module.exports = {
	"-KhIW2TmbtoEI7_7d1NL": {
		"author": "Barracuda Brigade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T01:49:27.168+03:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "money",
				"salience": 0.19120464,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.19120464,
				"type": "OTHER"
			},
			{
				"name": "Print",
				"salience": 0.17359065,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.09943038,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.049216818,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.03927192,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.03853309,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.033925317,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.033925317,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.027738104,
				"type": "PERSON"
			},
			{
				"name": "taxpayers",
				"salience": 0.02404071,
				"type": "PERSON"
			},
			{
				"name": "fraud",
				"salience": 0.017985161,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.017985161,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalis",
				"salience": 0.014829758,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.013113701,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.013113701,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.0110875415,
				"type": "OTHER"
			},
			{
				"name": "government benefits",
				"salience": 0.009803406,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://bb4sp.com/wp-content/uploads/2016/10/Fullscreen-capture-10262016-83501-AM.bmp.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T21:41:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Print They should pay all the back all the money plus interest. The entire family and everyone who came in with them need to be deported asap. Why did it take two years to bust them? \nHere we go again …another group stealing from the government and taxpayers! A group of Somalis stole over four million in government benefits over just 10 months! \nWe’ve reported on numerous cases like this one where the Muslim refugees/immigrants commit fraud by scamming our system…It’s way out of control! More Related",
		"thread_title": "Muslims BUSTED: They Stole Millions In Gov’t Benefits",
		"title": "Muslims BUSTED: They Stole Millions In Gov’t Benefits",
		"type": "bias",
		"uuid": "6a175f46bcd24d39b3e962ad0f29936721db70db"
	},
	"-KhIW2ebIRBqY2zummbx": {
		"author": "reasoning with facts",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T08:47:11.259+03:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.5767878,
				"type": "PERSON"
			},
			{
				"name": "Loretta Lynch Plead The Fifth",
				"salience": 0.07403544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.05988255,
				"type": "LOCATION"
			},
			{
				"name": "Barracuda Brigade",
				"salience": 0.051377296,
				"type": "PERSON"
			},
			{
				"name": "payments",
				"salience": 0.025458392,
				"type": "OTHER"
			},
			{
				"name": "cash payment",
				"salience": 0.021242784,
				"type": "OTHER"
			},
			{
				"name": "cash payments",
				"salience": 0.015798282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dpr5f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marco_Rubio"
				},
				"name": "Marco Rubio",
				"salience": 0.01251771,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.012380965,
				"type": "ORGANIZATION"
			},
			{
				"name": "corruption",
				"salience": 0.010984572,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.010733,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.010733,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0102798985,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cnxjk7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pompeo"
				},
				"name": "Mike Pompeo",
				"salience": 0.0064183725,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sjg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fifth_Amendment_to_the_United_States_Constitution"
				},
				"name": "Fifth",
				"salience": 0.005921022,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.00566972,
				"type": "OTHER"
			},
			{
				"name": "cash",
				"salience": 0.0045938552,
				"type": "OTHER"
			},
			{
				"name": "finest",
				"salience": 0.0044362224,
				"type": "OTHER"
			},
			{
				"name": "ass",
				"salience": 0.0037162204,
				"type": "OTHER"
			},
			{
				"name": "lawmakers",
				"salience": 0.0035938127,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0034599346,
				"type": "ORGANIZATION"
			},
			{
				"name": "communications",
				"salience": 0.0031128123,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.0031128123,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.002996814,
				"type": "EVENT"
			},
			{
				"name": "efforts",
				"salience": 0.002996814,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.002996814,
				"type": "PERSON"
			},
			{
				"name": "core",
				"salience": 0.002996814,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0028255915,
				"type": "OTHER"
			},
			{
				"name": "100percentfedUp.com",
				"salience": 0.002733254,
				"type": "OTHER"
			},
			{
				"name": "Corrupt",
				"salience": 0.0026522502,
				"type": "OTHER"
			},
			{
				"name": "Peter Kadzik",
				"salience": 0.00257993,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.0025419935,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "R.",
				"salience": 0.0023795557,
				"type": "PERSON"
			},
			{
				"name": "lawmakers",
				"salience": 0.0019691498,
				"type": "PERSON"
			},
			{
				"name": "Washington Free Beacon",
				"salience": 0.001917168,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ryt15"
				},
				"name": "Amendment",
				"salience": 0.001917168,
				"type": "OTHER"
			},
			{
				"name": "fifth",
				"salience": 0.001899544,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.001899544,
				"type": "ORGANIZATION"
			},
			{
				"name": "ransom deal",
				"salience": 0.001899544,
				"type": "OTHER"
			},
			{
				"name": "hostages",
				"salience": 0.001899544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0018456657,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0018456657,
				"type": "ORGANIZATION"
			},
			{
				"name": "cash",
				"salience": 0.0016684274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Fla",
				"salience": 0.0015653552,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0488g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas"
				},
				"name": "Kan",
				"salience": 0.0015653552,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0015509618,
				"type": "OTHER"
			},
			{
				"name": "inquiries",
				"salience": 0.001383773,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.001383773,
				"type": "OTHER"
			},
			{
				"name": "state sponsor",
				"salience": 0.001383773,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.001383773,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.001383773,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.001383773,
				"type": "WORK_OF_ART"
			},
			{
				"name": "response",
				"salience": 0.0011938544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0011695276,
				"type": "LOCATION"
			},
			{
				"name": "behalf",
				"salience": 0.0010338274,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.00091072696,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://bb4sp.com/wp-content/uploads/2016/10/Fullscreen-capture-10282016-102616-PM.bmp.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T08:47:11.259+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Why Did Attorney General Loretta Lynch Plead The Fifth? Barracuda Brigade 2016-10-28 Print The administration is blocking congressional probe into cash payments to Iran. Of course she needs to plead the 5th. She either can’t recall, refuses to answer, or just plain deflects the question. Straight up corruption at its finest! \n100percentfedUp.com ; Talk about covering your ass! Loretta Lynch did just that when she plead the Fifth to avoid incriminating herself over payments to Iran…Corrupt to the core! Attorney General Loretta Lynch is declining to comply with an investigation by leading members of Congress about the Obama administration’s secret efforts to send Iran $1.7 billion in cash earlier this year, prompting accusations that Lynch has “pleaded the Fifth” Amendment to avoid incriminating herself over these payments, according to lawmakers and communications exclusively obtained by the Washington Free Beacon. \nSen. Marco Rubio (R., Fla.) and Rep. Mike Pompeo (R., Kan.) initially presented Lynch in October with a series of questions about how the cash payment to Iran was approved and delivered. \nIn an Oct. 24 response, Assistant Attorney General Peter Kadzik responded on Lynch’s behalf, refusing to answer the questions and informing the lawmakers that they are barred from publicly disclosing any details about the cash payment, which was bound up in a ransom deal aimed at freeing several American hostages from Iran. \nThe response from the attorney general’s office is “unacceptable” and provides evidence that Lynch has chosen to “essentially plead the fifth and refuse to respond to inquiries regarding [her]role in providing cash to the world’s foremost state sponsor of terrorism,” Rubio and Pompeo wrote on Friday in a follow-up letter to Lynch. More Related",
		"thread_title": "Re: Why Did Attorney General Loretta Lynch Plead The Fifth?",
		"title": "Re: Why Did Attorney General Loretta Lynch Plead The Fifth?",
		"type": "bias",
		"uuid": "2bdc29d12605ef9cf3f09f9875040a7113be5d5b"
	},
	"-KhIW2qxNJJ6FOP4bmO_": {
		"author": "Barracuda Brigade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T01:41:49.479+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.2869582,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.17648919,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.060709268,
				"type": "EVENT"
			},
			{
				"name": "lefties",
				"salience": 0.047706697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.037703205,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/048xm2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Red_states_and_blue_states"
				},
				"name": "Red State",
				"salience": 0.029569555,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06rgxb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bret_Baier"
				},
				"name": "Bret Baier",
				"salience": 0.027059102,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048h73",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Wallace"
				},
				"name": "Chris Wallace",
				"salience": 0.020815488,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.019846939,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.017758181,
				"type": "PERSON"
			},
			{
				"name": "Targets",
				"salience": 0.017606195,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.014132545,
				"type": "PERSON"
			},
			{
				"name": "e-mail",
				"salience": 0.013258874,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.012995134,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.012995134,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.012249732,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.011738517,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.010170161,
				"type": "EVENT"
			},
			{
				"name": "panel segment",
				"salience": 0.010170161,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0091236085,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.008904756,
				"type": "PERSON"
			},
			{
				"name": "laptop",
				"salience": 0.008784056,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "warrant",
				"salience": 0.00824015,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.007839128,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "investigations",
				"salience": 0.0074523697,
				"type": "EVENT"
			},
			{
				"name": "laptop",
				"salience": 0.0074523697,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "consideration",
				"salience": 0.007353563,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.0068720393,
				"type": "OTHER"
			},
			{
				"name": "contents",
				"salience": 0.0063981223,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.0059343907,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0058556637,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.005829556,
				"type": "PERSON"
			},
			{
				"name": "sentencing",
				"salience": 0.005829556,
				"type": "EVENT"
			},
			{
				"name": "development",
				"salience": 0.005829556,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.005570433,
				"type": "OTHER"
			},
			{
				"name": "co-ownership",
				"salience": 0.005136357,
				"type": "OTHER"
			},
			{
				"name": "contents",
				"salience": 0.0051260004,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.005030356,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.0043567247,
				"type": "OTHER"
			},
			{
				"name": "consent form",
				"salience": 0.0040588267,
				"type": "OTHER"
			},
			{
				"name": "warrant",
				"salience": 0.0040049423,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0036650954,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.003174063,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "prosecutor",
				"salience": 0.0030946347,
				"type": "PERSON"
			},
			{
				"name": "penchant",
				"salience": 0.0023715147,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0023715147,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.0023715147,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0020368765,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://bb4sp.com/wp-content/uploads/2016/10/Fullscreen-capture-10302016-60437-PM.bmp.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T01:41:49.479+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Red State : \nFox News Sunday reported this morning that Anthony Weiner is cooperating with the FBI, which has re-opened (yes, lefties: “re-opened”) the investigation into Hillary Clinton’s classified emails. Watch as Chris Wallace reports the breaking news during the panel segment near the end of the show: \nAnd the news is breaking while we’re on the air. Our colleague Bret Baier has just sent us an e-mail saying he has two sources who say that Anthony Weiner, who also had co-ownership of that laptop with his estranged wife Huma Abedin, is cooperating with the FBI investigation, had given them the laptop, so therefore they didn’t need a warrant to get in to see the contents of said laptop. Pretty interesting development. \nTargets of federal investigations will often cooperate, hoping that they will get consideration from a judge at sentencing. Given Weiner’s well-known penchant for lying, it’s hard to believe that a prosecutor would give Weiner a deal based on an agreement to testify, unless his testimony were very strongly corroborated by hard evidence. But cooperation can take many forms — and, as Wallace indicated on this morning’s show, one of those forms could be signing a consent form to allow   the contents of devices that they could probably get a warrant for anyway. We’ll see if Weiner’s cooperation extends beyond that. More Related",
		"thread_title": "BREAKING: Weiner Cooperating With FBI On Hillary Email Investigation",
		"title": "BREAKING: Weiner Cooperating With FBI On Hillary Email Investigation",
		"type": "bias",
		"uuid": "c70e149fdd53de5e61c29281100b9de0ed268bc3"
	},
	"-KhIW2ve_ch6yz_mOKUh": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T15:46:26.304+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/012sp_3k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kayla_Mueller"
				},
				"name": "Kayla Mueller",
				"salience": 0.5427613,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.12595394,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chance",
				"salience": 0.054155573,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.054155573,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.042934395,
				"type": "PERSON"
			},
			{
				"name": "pin drop speech",
				"salience": 0.038725805,
				"type": "WORK_OF_ART"
			},
			{
				"name": "father",
				"salience": 0.03714779,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.036923632,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.033733685,
				"type": "ORGANIZATION"
			},
			{
				"name": "speech",
				"salience": 0.010199356,
				"type": "EVENT"
			},
			{
				"name": "shares",
				"salience": 0.008838219,
				"type": "OTHER"
			},
			{
				"name": "hug",
				"salience": 0.005679637,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06l3bl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Epic_film"
				},
				"name": "Epic",
				"salience": 0.005449489,
				"type": "OTHER"
			},
			{
				"name": "Carl Mueller",
				"salience": 0.0033415677,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/10/kayla.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-01T05:22:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.068",
		"text": "Email Kayla Mueller was a prisoner and tortured by ISIS while no chance of release…a horrific story. Her father gave a pin drop speech that was so heartfelt you want to give him a hug. Carl Mueller believes Donald Trump will be a great president…Epic speech! 9.0K shares ",
		"thread_title": "PIN DROP SPEECH BY FATHER OF DAUGHTER Kidnapped And Killed By ISIS: \"I have voted for Donald J. Trump!\" » 100percentfedUp.com",
		"title": "PIN DROP SPEECH BY FATHER OF DAUGHTER Kidnapped And Killed By ISIS: \"I have voted for Donald J. Trump!\" » 100percentfedUp.com",
		"type": "bias",
		"uuid": "7cf7c15731ac2a116dd7f629bd57ea468ed70284"
	},
	"-KhIW3AkKnmhDs1TJdGh": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T23:59:42.266+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Affordable Care Act",
				"salience": 0.33527675,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.12095036,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0531906,
				"type": "PERSON"
			},
			{
				"name": "HEALTHCARE REFORM",
				"salience": 0.043761276,
				"type": "OTHER"
			},
			{
				"name": "burden",
				"salience": 0.037969552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.01999086,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.019510407,
				"type": "OTHER"
			},
			{
				"name": "websites",
				"salience": 0.017525474,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.013277203,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0116899945,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.011460739,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.011460739,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_of_Representatives"
				},
				"name": "House",
				"salience": 0.01088828,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.01088828,
				"type": "ORGANIZATION"
			},
			{
				"name": "competition",
				"salience": 0.010302177,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.010302177,
				"type": "PERSON"
			},
			{
				"name": "insurance",
				"salience": 0.009359306,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.009304645,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.009304645,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.009304645,
				"type": "OTHER"
			},
			{
				"name": "premiums",
				"salience": 0.009304645,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.008146242,
				"type": "ORGANIZATION"
			},
			{
				"name": "choices",
				"salience": 0.008060043,
				"type": "OTHER"
			},
			{
				"name": "rationing",
				"salience": 0.008060043,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.008060043,
				"type": "OTHER"
			},
			{
				"name": "health insurance",
				"salience": 0.0075483867,
				"type": "OTHER"
			},
			{
				"name": "congress",
				"salience": 0.007229775,
				"type": "ORGANIZATION"
			},
			{
				"name": "healthcare coverage",
				"salience": 0.0068237116,
				"type": "OTHER"
			},
			{
				"name": "representatives",
				"salience": 0.006529049,
				"type": "PERSON"
			},
			{
				"name": "representatives",
				"salience": 0.006529049,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.006285758,
				"type": "PERSON"
			},
			{
				"name": "individuals",
				"salience": 0.0061708586,
				"type": "PERSON"
			},
			{
				"name": "healthcare industry",
				"salience": 0.005654973,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.0054441905,
				"type": "OTHER"
			},
			{
				"name": "collapse",
				"salience": 0.0054441905,
				"type": "EVENT"
			},
			{
				"name": "cracks",
				"salience": 0.0054089786,
				"type": "OTHER"
			},
			{
				"name": "uncertainty",
				"salience": 0.0053080437,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.0047607836,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.004676628,
				"type": "OTHER"
			},
			{
				"name": "mandate",
				"salience": 0.0046177665,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0046177665,
				"type": "OTHER"
			},
			{
				"name": "state lines",
				"salience": 0.0046177665,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.0046177665,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.004412378,
				"type": "PERSON"
			},
			{
				"name": "companies",
				"salience": 0.004412378,
				"type": "ORGANIZATION"
			},
			{
				"name": "individuals",
				"salience": 0.004412378,
				"type": "PERSON"
			},
			{
				"name": "free market reforms",
				"salience": 0.004244879,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.004110632,
				"type": "OTHER"
			},
			{
				"name": "deductions",
				"salience": 0.0036761991,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0034825373,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.0034793266,
				"type": "LOCATION"
			},
			{
				"name": "tax returns",
				"salience": 0.0034505187,
				"type": "OTHER"
			},
			{
				"name": "Businesses",
				"salience": 0.0034505187,
				"type": "ORGANIZATION"
			},
			{
				"name": "tax system",
				"salience": 0.0034505187,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0033526341,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.0033526341,
				"type": "ORGANIZATION"
			},
			{
				"name": "insurance coverage opportunities",
				"salience": 0.00281724,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0025995818,
				"type": "LOCATION"
			},
			{
				"name": "insurance",
				"salience": 0.0025720536,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.0025135167,
				"type": "PERSON"
			},
			{
				"name": "market",
				"salience": 0.0024016416,
				"type": "OTHER"
			},
			{
				"name": "exemptions",
				"salience": 0.0022425114,
				"type": "OTHER"
			},
			{
				"name": "options",
				"salience": 0.0020782643,
				"type": "OTHER"
			},
			{
				"name": "insurance costs",
				"salience": 0.0019103048,
				"type": "OTHER"
			},
			{
				"name": "vendor",
				"salience": 0.0018778144,
				"type": "PERSON"
			},
			{
				"name": "health insurance premium payments",
				"salience": 0.0018778144,
				"type": "OTHER"
			},
			{
				"name": "state requirements",
				"salience": 0.0018778144,
				"type": "OTHER"
			},
			{
				"name": "consumer satisfaction",
				"salience": 0.0016542018,
				"type": "OTHER"
			},
			{
				"name": "competition",
				"salience": 0.0015606383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fh83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Medicaid"
				},
				"name": "Medicaid",
				"salience": 0.0015472557,
				"type": "OTHER"
			},
			{
				"name": "Fed Up",
				"salience": 0.0015472557,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/obamacare-sites-404-970x0.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-01T21:56:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.865",
		"text": "Email HEALTHCARE REFORM TO MAKE AMERICA GREAT AGAIN \nSince March of 2010, the American people have had to suffer under the incredible economic burden of the Affordable Care Act—Obamacare. This legislation, passed by totally partisan votes in the House and Senate and signed into law by the most divisive and partisan President in American history, has tragically but predictably resulted in runaway costs, websites that don’t work, greater rationing of care, higher premiums, less competition and fewer choices. Obamacare has raised the economic uncertainty of every single person residing in this country. As it appears Obamacare is certain to collapse of its own weight, the damage done by the Democrats and President Obama, and abetted by the Supreme Court, will be difficult to repair unless the next President and a Republican congress lead the effort to bring much-needed free market reforms to the healthcare industry. \nCongress must act. Our elected representatives in the House and Senate must: \n1. Completely repeal Obamacare. Our elected representatives must eliminate the individual mandate. No person should be required to buy insurance unless he or she wants to. \n2. Modify existing law that inhibits the sale of health insurance across state lines. As long as the plan purchased complies with state requirements, any vendor ought to be able to offer insurance in any state. By allowing full competition in this market, insurance costs will go down and consumer satisfaction will go up. \n3. Allow individuals to fully deduct health insurance premium payments from their tax returns under the current tax system. Businesses are allowed to take these deductions so why wouldn’t Congress allow individuals the same exemptions? As we allow the free market to provide insurance coverage opportunities to companies and individuals, we must also make sure that no one slips through the cracks simply because they cannot afford insurance. We must review basic options for Medicaid and work with states to ensure that those who want healthcare coverage can have it. TRENDING ON 100% Fed Up ",
		"thread_title": "FANTASTIC! TRUMP'S 7 POINT PLAN To Reform Healthcare Begins With A Bombshell! » 100percentfedUp.com",
		"title": "FANTASTIC! TRUMP'S 7 POINT PLAN To Reform Healthcare Begins With A Bombshell! » 100percentfedUp.com",
		"type": "bias",
		"uuid": "0206b54719c7e241ffe0ad4315b808290dbe6c0f"
	},
	"-KhIW3KRrz28U6uN-QKk": {
		"author": "Barracuda Brigade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T16:31:28.550+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.38904598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.27310523,
				"type": "PERSON"
			},
			{
				"name": "enabler",
				"salience": 0.07070059,
				"type": "PERSON"
			},
			{
				"name": "Print",
				"salience": 0.03085105,
				"type": "OTHER"
			},
			{
				"name": "Alicia Machado",
				"salience": 0.030769112,
				"type": "PERSON"
			},
			{
				"name": "rapist",
				"salience": 0.021941857,
				"type": "PERSON"
			},
			{
				"name": "protester",
				"salience": 0.021941857,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.020292666,
				"type": "EVENT"
			},
			{
				"name": "irony",
				"salience": 0.01591131,
				"type": "OTHER"
			},
			{
				"name": "escapades",
				"salience": 0.01591131,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.010052266,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.008417276,
				"type": "EVENT"
			},
			{
				"name": "integrity",
				"salience": 0.006588335,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.006588335,
				"type": "OTHER"
			},
			{
				"name": "Protester",
				"salience": 0.0063158516,
				"type": "PERSON"
			},
			{
				"name": "protester",
				"salience": 0.0061582695,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0057179956,
				"type": "LOCATION"
			},
			{
				"name": "campaign rally",
				"salience": 0.0056907684,
				"type": "EVENT"
			},
			{
				"name": "behavior",
				"salience": 0.0046246503,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.0046246503,
				"type": "OTHER"
			},
			{
				"name": "pic.twitter.com/yncdkS90Bg",
				"salience": 0.0038335382,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0037772087,
				"type": "OTHER"
			},
			{
				"name": "pic.twitter.com/2GPjps1EQB",
				"salience": 0.0032920064,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rj0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fort_Lauderdale,_Florida"
				},
				"name": "Fort Lauderdale",
				"salience": 0.0028492727,
				"type": "LOCATION"
			},
			{
				"name": "protester",
				"salience": 0.0028466475,
				"type": "PERSON"
			},
			{
				"name": "distractions",
				"salience": 0.0028230944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0027430626,
				"type": "ORGANIZATION"
			},
			{
				"name": "TGP",
				"salience": 0.0027430626,
				"type": "ORGANIZATION"
			},
			{
				"name": "@jamieNBC6",
				"salience": 0.0024062556,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0023266457,
				"type": "PERSON"
			},
			{
				"name": "rails",
				"salience": 0.0020568597,
				"type": "OTHER"
			},
			{
				"name": "@JxhnBinder",
				"salience": 0.0017530236,
				"type": "OTHER"
			},
			{
				"name": "@nbc6",
				"salience": 0.0017385083,
				"type": "OTHER"
			},
			{
				"name": "Jamie Guirola",
				"salience": 0.0017385083,
				"type": "PERSON"
			},
			{
				"name": "pic.twitter.com/j11qI5JjtO",
				"salience": 0.0016195761,
				"type": "OTHER"
			},
			{
				"name": "Man",
				"salience": 0.0015368488,
				"type": "PERSON"
			},
			{
				"name": "@HillaryClinton",
				"salience": 0.0013097598,
				"type": "PERSON"
			},
			{
				"name": "John Binder 👽",
				"salience": 0.0012663959,
				"type": "PERSON"
			},
			{
				"name": "@joshbhaskell",
				"salience": 0.001144265,
				"type": "OTHER"
			},
			{
				"name": "Josh Haskell",
				"salience": 0.00094610034,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://bb4sp.com/wp-content/uploads/2016/11/Fullscreen-capture-1122016-74311-AM.bmp.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T16:31:28.550+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Print Hillary goes absolutely berserk! She explodes on Bill ‘rapist’ protester at rally… Oh the irony! She is an enabler to Bill’s “escapades”. She’s is just projecting again. She is so pathetic. Dragging integrity challenged Alicia Machado on stage with her yesterday at her sad little “rally” in Florida. \nTGP : Democratic Party presidential nominee Hillary Clinton angrily reacted to a protester shouting “Bill Clinton is a rapist” at a campaign rally in Fort Lauderdale, Florida Tuesday night, saying, “I am sick and tired of the negative, dark, divisive, dangerous vision and behavior of people who support Donald Trump,” according to reports. \nProtester interrupts Hillary Clinton shouting \"Bill Clinton is a rapist.\" Clinton fires right back \"I am sick and tired of the negative\" pic.twitter.com/yncdkS90Bg \n— Josh Haskell (@joshbhaskell) November 2, 2016 Man interrupts @HillaryClinton yelling \"Bill Clinton is a rapist\"- she responds she's tired of divisive distractions. @nbc6 pic.twitter.com/2GPjps1EQB \n— Jamie Guirola (@jamieNBC6) November 2, 2016 Here's Hillary absolutely going bezerk on a protester, starts screaming, shouting, yelling. Full off the rails. pic.twitter.com/j11qI5JjtO \n— John Binder 👽 (@JxhnBinder) November 2, 2016 Related",
		"thread_title": "Hillary Goes Absolutely Berserk On Protester At Rally! (Video)",
		"title": "Hillary Goes Absolutely Berserk On Protester At Rally! (Video)",
		"type": "bias",
		"uuid": "8f30f5ea14c9d5914a9fe4f55ab2581772af4c31"
	},
	"-KhIW3w_o5em1NCBxudr": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T02:13:46.065+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.42397752,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.050374284,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.050295517,
				"type": "PERSON"
			},
			{
				"name": "Pay-for-Play",
				"salience": 0.036789477,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.024784608,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.02290308,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.021088077,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.01890188,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.018199941,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.01618562,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027hn7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Erik_Prince"
				},
				"name": "Erik Prince",
				"salience": 0.013727826,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.011920647,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09gf_wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Preet_Bharara"
				},
				"name": "Preet Bharara",
				"salience": 0.009799355,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.008694856,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0076183276,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0067023863,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.006325447,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.006325447,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.006325447,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Handling Classified Information",
				"salience": 0.006325447,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0060332455,
				"type": "EVENT"
			},
			{
				"name": "Times",
				"salience": 0.005355275,
				"type": "OTHER"
			},
			{
				"name": "pushback",
				"salience": 0.005278775,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.004948121,
				"type": "OTHER"
			},
			{
				"name": "Underage Sex",
				"salience": 0.004948121,
				"type": "PERSON"
			},
			{
				"name": "guy",
				"salience": 0.0044684527,
				"type": "PERSON"
			},
			{
				"name": "laptop",
				"salience": 0.0044684527,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "warrant",
				"salience": 0.0044684527,
				"type": "OTHER"
			},
			{
				"name": "Prince",
				"salience": 0.0042274063,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fz196",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Epstein"
				},
				"name": "Jeffrey Epstein",
				"salience": 0.0039779595,
				"type": "PERSON"
			},
			{
				"name": "stuff",
				"salience": 0.0038701466,
				"type": "OTHER"
			},
			{
				"name": "subpoena",
				"salience": 0.0038701466,
				"type": "OTHER"
			},
			{
				"name": "Founder",
				"salience": 0.0038701466,
				"type": "PERSON"
			},
			{
				"name": "sexting scandal",
				"salience": 0.0038701466,
				"type": "OTHER"
			},
			{
				"name": "Pedophile Island",
				"salience": 0.0036364535,
				"type": "LOCATION"
			},
			{
				"name": "amount",
				"salience": 0.003609181,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0033033541,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gvrvrn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner_sexting_scandals"
				},
				"name": "Weinergate",
				"salience": 0.0032986726,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0032128426,
				"type": "OTHER"
			},
			{
				"name": "sexting",
				"salience": 0.0031940455,
				"type": "EVENT"
			},
			{
				"name": "insider knowledge",
				"salience": 0.0028920318,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0027804929,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0027313253,
				"type": "EVENT"
			},
			{
				"name": "level",
				"salience": 0.0026306554,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.002607178,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.002607178,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qwr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Academi"
				},
				"name": "Blackwater USA",
				"salience": 0.0023832354,
				"type": "ORGANIZATION"
			},
			{
				"name": "Least 6",
				"salience": 0.0023832354,
				"type": "OTHER"
			},
			{
				"name": "warrants",
				"salience": 0.0023420404,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0023164938,
				"type": "EVENT"
			},
			{
				"name": "offices",
				"salience": 0.002211864,
				"type": "LOCATION"
			},
			{
				"name": "times",
				"salience": 0.0022066997,
				"type": "EVENT"
			},
			{
				"name": "matters",
				"salience": 0.002116227,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0020325326,
				"type": "OTHER"
			},
			{
				"name": "Arrests In Weiner Case",
				"salience": 0.0020302848,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Weiner",
				"salience": 0.0019547055,
				"type": "PERSON"
			},
			{
				"name": "investigations",
				"salience": 0.001929803,
				"type": "EVENT"
			},
			{
				"name": "sex island",
				"salience": 0.001840818,
				"type": "LOCATION"
			},
			{
				"name": "email",
				"salience": 0.0017601124,
				"type": "WORK_OF_ART"
			},
			{
				"name": "copy",
				"salience": 0.0017498074,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0017237462,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0016423406,
				"type": "PERSON"
			},
			{
				"name": "level",
				"salience": 0.0016095297,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.0015940737,
				"type": "OTHER"
			},
			{
				"name": "garbage",
				"salience": 0.0015940737,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0015940737,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0015940737,
				"type": "OTHER"
			},
			{
				"name": "indictments",
				"salience": 0.0015940737,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0015940737,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0015474041,
				"type": "PERSON"
			},
			{
				"name": "Obama Justice Department",
				"salience": 0.0015442859,
				"type": "ORGANIZATION"
			},
			{
				"name": "evil",
				"salience": 0.0015314874,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0014926831,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reporting",
				"salience": 0.0014677495,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0014295601,
				"type": "OTHER"
			},
			{
				"name": "homebrew server",
				"salience": 0.0014295601,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0014235779,
				"type": "EVENT"
			},
			{
				"name": "point",
				"salience": 0.0013762075,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0013762075,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.0013579202,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.0012907697,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "kinds",
				"salience": 0.0012907697,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0012877658,
				"type": "OTHER"
			},
			{
				"name": "arrests",
				"salience": 0.0012425937,
				"type": "OTHER"
			},
			{
				"name": "matters",
				"salience": 0.0012425937,
				"type": "OTHER"
			},
			{
				"name": "downdrafts",
				"salience": 0.0012425937,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0012032614,
				"type": "OTHER"
			},
			{
				"name": "sex",
				"salience": 0.0011670759,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0011670759,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0011662608,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.001117715,
				"type": "OTHER"
			},
			{
				"name": "revelations",
				"salience": 0.001117715,
				"type": "OTHER"
			},
			{
				"name": "exposure",
				"salience": 0.001117715,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.001117715,
				"type": "ORGANIZATION"
			},
			{
				"name": "crimes",
				"salience": 0.001117715,
				"type": "EVENT"
			},
			{
				"name": "messages",
				"salience": 0.001117715,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.001117715,
				"type": "OTHER"
			},
			{
				"name": "commissioner",
				"salience": 0.0010767725,
				"type": "PERSON"
			},
			{
				"name": "mine",
				"salience": 0.0010759948,
				"type": "OTHER"
			},
			{
				"name": "heart attack death",
				"salience": 0.0010759948,
				"type": "EVENT"
			},
			{
				"name": "coercion",
				"salience": 0.0010759948,
				"type": "OTHER"
			},
			{
				"name": "press conference",
				"salience": 0.0010759948,
				"type": "EVENT"
			},
			{
				"name": "source",
				"salience": 0.0010759948,
				"type": "OTHER"
			},
			{
				"name": "pay-for-play",
				"salience": 0.0010537562,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0010537562,
				"type": "OTHER"
			},
			{
				"name": "handling",
				"salience": 0.0010537562,
				"type": "OTHER"
			},
			{
				"name": "copy",
				"salience": 0.0010537562,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0010016398,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0009867162,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0009826123,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.000981222,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.000981222,
				"type": "ORGANIZATION"
			},
			{
				"name": "pressure",
				"salience": 0.0009437227,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0009437227,
				"type": "OTHER"
			},
			{
				"name": "plenty",
				"salience": 0.0009124644,
				"type": "OTHER"
			},
			{
				"name": "culpability",
				"salience": 0.0009124644,
				"type": "OTHER"
			},
			{
				"name": "receiving",
				"salience": 0.0009124644,
				"type": "OTHER"
			},
			{
				"name": "computer",
				"salience": 0.0009124644,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "course",
				"salience": 0.0009124644,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0009124644,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0009124644,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0009124644,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chairs",
				"salience": 0.0009124644,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04_1kbb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/1_Police_Plaza"
				},
				"name": "One Police Plaza",
				"salience": 0.00087210623,
				"type": "LOCATION"
			},
			{
				"name": "prosecutor",
				"salience": 0.00087183365,
				"type": "PERSON"
			},
			{
				"name": "money laundering",
				"salience": 0.0008608471,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00079125527,
				"type": "OTHER"
			},
			{
				"name": "law enforcement officials",
				"salience": 0.00078717043,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.00078717043,
				"type": "OTHER"
			},
			{
				"name": "downdraft",
				"salience": 0.00078717043,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00076482166,
				"type": "LOCATION"
			},
			{
				"name": "reputation",
				"salience": 0.00071708264,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.0007156572,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0006816119,
				"type": "PERSON"
			},
			{
				"name": "due process",
				"salience": 0.0006816119,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.0006816119,
				"type": "OTHER"
			},
			{
				"name": "hunt",
				"salience": 0.0006816119,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.0006730217,
				"type": "OTHER"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Death_of_Eric_Garner"
				},
				"name": "Eric Garner",
				"salience": 0.0006622591,
				"type": "PERSON"
			},
			{
				"name": "prosecutors",
				"salience": 0.0006595699,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0006397298,
				"type": "OTHER"
			},
			{
				"name": "email content",
				"salience": 0.0006397298,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0006237064,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01pf4l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/SAP_SE"
				},
				"name": "SAP",
				"salience": 0.00056159176,
				"type": "ORGANIZATION"
			},
			{
				"name": "effort",
				"salience": 0.00049639714,
				"type": "OTHER"
			},
			{
				"name": "sunlight",
				"salience": 0.00049639714,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00049639714,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00049639714,
				"type": "OTHER"
			},
			{
				"name": "transparency",
				"salience": 0.00049639714,
				"type": "OTHER"
			},
			{
				"name": "mayor",
				"salience": 0.00049639714,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.00049639714,
				"type": "WORK_OF_ART"
			},
			{
				"name": "shares",
				"salience": 0.00049639714,
				"type": "OTHER"
			},
			{
				"name": "money laundering",
				"salience": 0.0004926845,
				"type": "OTHER"
			},
			{
				"name": "Marlow",
				"salience": 0.00048881077,
				"type": "PERSON"
			},
			{
				"name": "evil",
				"salience": 0.0004282233,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_lf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_Stalin"
				},
				"name": "Stalinist",
				"salience": 0.00041949196,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "Constitution",
				"salience": 0.00041949196,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.00041949196,
				"type": "ORGANIZATION"
			},
			{
				"name": "father",
				"salience": 0.00037079066,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.00037079066,
				"type": "OTHER"
			},
			{
				"name": "grand jury",
				"salience": 0.00037079066,
				"type": "PERSON"
			},
			{
				"name": "daughters",
				"salience": 0.00037079066,
				"type": "PERSON"
			},
			{
				"name": "parent",
				"salience": 0.00037079066,
				"type": "PERSON"
			},
			{
				"name": "chiefs",
				"salience": 0.00037079066,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00037079066,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00037079066,
				"type": "WORK_OF_ART"
			},
			{
				"name": "plot",
				"salience": 0.00037079066,
				"type": "OTHER"
			},
			{
				"name": "Special Access Programs",
				"salience": 0.00037079066,
				"type": "OTHER"
			},
			{
				"name": "clock",
				"salience": 0.00033928634,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.00030549287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gjsd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_de_Blasio"
				},
				"name": "de Blasio",
				"salience": 0.00030549287,
				"type": "PERSON"
			},
			{
				"name": "Breitbart News 14.7K",
				"salience": 0.00030549287,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.00022818685,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/hillary-looking-down.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-04T19:40:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.701",
		"text": "BREAKING! NYPD Ready To Make Arrests In Weiner Case…Hillary Visited Pedophile Island At Least 6 Times…Money Laundering, Underage Sex, Pay-for-Play,Proof of Inappropriate Handling Classified Information Blackwater USA Founder, Retired Navy Seal Erik Prince \nPrince claimed he had insider knowledge of the investigation that could help explain why FBI Director James Comey had to announce he was reopening the investigation into Clinton’s email server last week. \n“Because of Weinergate and the sexting scandal, the NYPD started investigating it. Through a subpoena, through a warrant, they searched his laptop, and sure enough, found those 650,000 emails. They found way more stuff than just more information pertaining to the inappropriate sexting the guy was doing,” Prince claimed. \n“They found State Department emails. They found a lot of other really damning criminal information, including money laundering, including the fact that Hillary went to this sex island with convicted pedophile Jeffrey Epstein. Bill Clinton went there more than 20 times. Hillary Clinton went there at least six times,” he said. \n“The amount of garbage that they found in these emails, of criminal activity by Hillary, by her immediate circle, and even by other Democratic members of Congress was so disgusting they gave it to the FBI, and they said, ‘We’re going to go public with this if you don’t reopen the investigation and you don’t do the right thing with timely indictments,’” Prince explained. \n“I believe – I know, and this is from a very well-placed source of mine at 1PP, One Police Plaza in New York – the NYPD wanted to do a press conference announcing the warrants and the additional arrests they were making in this investigation, and they’ve gotten huge pushback, to the point of coercion, from the Justice Department, with the Justice Department threatening to charge someone that had been unrelated in the accidental heart attack death of Eric Garner almost two years ago. That’s the level of pushback the Obama Justice Department is doing against actually seeking justice in the email and other related criminal matters,” Prince said. \n“There’s five different parts of the FBI conducting investigations into these things, with constant downdrafts from the Obama Justice Department. So in the, I hope, unlikely and very unfortunate event that Hillary Clinton is elected president, we will have a constitutional crisis that we have not seen since, I believe, 1860,” Prince declared. \nMarlow asked Prince to clarify these revelations. \n“NYPD was the first one to look at that laptop,” Prince elaborated. “Weiner and Huma Abedin, his wife – the closest adviser of Hillary Clinton for 20 years – have both flipped. They are cooperating with the government. They both have – they see potential jail time of many years for their crimes, for Huma Abedin sending and receiving and even storing hundreds of thousands of messages from the State Department server and from Hillary Clinton’s own homebrew server, which contained classified information. Weiner faces all kinds of exposure for the inappropriate sexting that was going on and for other information that they found.” \n“So NYPD first gets that computer. They see how disgusting it is. They keep a copy of everything, and they pass a copy on to the FBI, which finally pushes the FBI off their chairs, making Comey reopen that investigation, which was indicated in the letter last week. The point being, NYPD has all the information, and they will pursue justice within their rights if the FBI doesn’t,” Prince contended. \n“There is all kinds of criminal culpability through all the emails they’ve seen of that 650,000, including money laundering, underage sex, pay-for-play, and, of course, plenty of proof of inappropriate handling, sending/receiving of classified information, up to SAP level Special Access Programs,” he stated. \n“So the plot thickens. NYPD was pushing because, as an article quoted one of the chiefs – that’s the level just below commissioner – he said as a parent, as a father with daughters, he could not let that level of evil continue,” Prince said. \nHe noted that the FBI can investigate these matters, “but they can’t convene a grand jury. They can’t file charges.” \n“The prosecutors, the Justice Department has to do that,” he explained. “Now, as I understand it, Preet Bharara, the Manhattan prosecutor, has gotten ahold of some of this. From what I hear, he’s a stand-up guy, and hopefully he does the right thing.” \nMarlow agreed that Bharara’s “sterling reputation” as a determined prosecutor was “bad news for the Clintons.” \nPrince agreed, but said, “If people are willing to bend or break the law and don’t really care about the Constitution or due process – if you’re willing to use Stalinist tactics against someone – who knows what level of pressure” could be brought to bear against even the most tenacious law enforcement officials? \nListen to interview here: \n“The point being, fortunately, it’s not just the FBI; [there are] five different offices that are in the hunt for justice, but the NYPD has it as well,” Prince said, citing the Wall Street Journal reporting that has “exposed downdraft, back pressure from the Justice Department” against both the FBI and NYPD, in an effort to “keep the sunlight and the disinfecting effects of the truth and transparency from shining on this great evil that has gone on, and is slowly being exposed.” \n“The Justice Department is trying to run out the clock, to elect Hillary Clinton, to prevent any real justice from being done,” he warned. \nAs for the mayor of New York City, Prince said he has heard that “de Blasio wants to stay away from this.” \n“The evidence is so bad, the email content is so bad, that I think even he wants to stay away from it, which is really telling,” he said. \nFor entire story: Breitbart News 14.7K shares ",
		"thread_title": "BREAKING! NYPD Ready To Make Arrests In Weiner Case…Hillary Visited Pedophile Island At Least 6 Times…Money Laundering, Underage Sex, Pay-for-Play,Proof of Inappropriate Handling Classified Information » 100percentfedUp.com",
		"title": "BREAKING! NYPD Ready To Make Arrests In Weiner Case…Hillary Visited Pedophile Island At Least 6 Times…Money Laundering, Underage Sex, Pay-for-Play,Proof of Inappropriate Handling Classified Information » 100percentfedUp.com",
		"type": "bias",
		"uuid": "d3cc0fe38f41a59f7c48f8c3528ca5f74193148f"
	},
	"-KhIW4AOts0n09QQscEZ": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:59:07.458+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "residents",
				"salience": 0.19912288,
				"type": "PERSON"
			},
			{
				"name": "Anne Sallee",
				"salience": 0.066117585,
				"type": "PERSON"
			},
			{
				"name": "Florida State Attorney",
				"salience": 0.055464312,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mike Cernovich",
				"salience": 0.052966297,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jgk3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Broward_County,_Florida"
				},
				"name": "Broward County",
				"salience": 0.051894758,
				"type": "LOCATION"
			},
			{
				"name": "Pay-for-Play",
				"salience": 0.039381497,
				"type": "OTHER"
			},
			{
				"name": "Brenda Snipes",
				"salience": 0.031119471,
				"type": "PERSON"
			},
			{
				"name": "fraud case",
				"salience": 0.027793381,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.023346888,
				"type": "LOCATION"
			},
			{
				"name": "Times",
				"salience": 0.018328417,
				"type": "OTHER"
			},
			{
				"name": "Periscope",
				"salience": 0.01632316,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.015882175,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Classified Information",
				"salience": 0.015882175,
				"type": "OTHER"
			},
			{
				"name": "Proof",
				"salience": 0.015882175,
				"type": "OTHER"
			},
			{
				"name": "Underage Sex",
				"salience": 0.015882175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.015743816,
				"type": "PERSON"
			},
			{
				"name": "Sun Sentinal",
				"salience": 0.015141396,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pedophile Island",
				"salience": 0.012932032,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01mtmv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Constitutional_amendment"
				},
				"name": "Constitutional Amendment",
				"salience": 0.011460424,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.010477513,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.009832991,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.009792279,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/048kprv"
				},
				"name": "Danger",
				"salience": 0.009792279,
				"type": "OTHER"
			},
			{
				"name": "Least 6",
				"salience": 0.009792279,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.009673149,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chelsey Marie Smith",
				"salience": 0.009083138,
				"type": "PERSON"
			},
			{
				"name": "Voting fraud",
				"salience": 0.0090682525,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.00777419,
				"type": "LOCATION"
			},
			{
				"name": "Elections",
				"salience": 0.0072357133,
				"type": "EVENT"
			},
			{
				"name": "Arrests In Weiner Case",
				"salience": 0.007227721,
				"type": "EVENT"
			},
			{
				"name": "ballot",
				"salience": 0.007168355,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02l3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election"
				},
				"name": "Elections",
				"salience": 0.0065994333,
				"type": "EVENT"
			},
			{
				"name": "voter fraud scheme",
				"salience": 0.0065540397,
				"type": "OTHER"
			},
			{
				"name": "whistle",
				"salience": 0.0065540397,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.006491994,
				"type": "PERSON"
			},
			{
				"name": "photos",
				"salience": 0.0060352893,
				"type": "WORK_OF_ART"
			},
			{
				"name": "marijuana",
				"salience": 0.005878443,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "elections office",
				"salience": 0.0055424846,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.005308338,
				"type": "OTHER"
			},
			{
				"name": "Jack Posobiec",
				"salience": 0.005270338,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0051036687,
				"type": "ORGANIZATION"
			},
			{
				"name": "stranger",
				"salience": 0.004897912,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0047624423,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0047364044,
				"type": "PERSON"
			},
			{
				"name": "Voter Fraud Case",
				"salience": 0.0046800477,
				"type": "OTHER"
			},
			{
				"name": "Broward County Supervisor",
				"salience": 0.0046607503,
				"type": "LOCATION"
			},
			{
				"name": "controversy",
				"salience": 0.0045973035,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.004425856,
				"type": "OTHER"
			},
			{
				"name": "MAGA3X https://t.co/q7jeEz6Rgh",
				"salience": 0.004036347,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0037537203,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0037537203,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.0037537203,
				"type": "OTHER"
			},
			{
				"name": "complaint",
				"salience": 0.0037537203,
				"type": "OTHER"
			},
			{
				"name": "election snafu",
				"salience": 0.0037537203,
				"type": "OTHER"
			},
			{
				"name": "chapter director",
				"salience": 0.0037537203,
				"type": "PERSON"
			},
			{
				"name": "State Attorney investigators",
				"salience": 0.0037064536,
				"type": "PERSON"
			},
			{
				"name": "@Cernovich",
				"salience": 0.0034849378,
				"type": "OTHER"
			},
			{
				"name": "@JackPosobiec",
				"salience": 0.0034849378,
				"type": "PERSON"
			},
			{
				"name": "Secretary",
				"salience": 0.0032386188,
				"type": "PERSON"
			},
			{
				"name": "ballots",
				"salience": 0.003186679,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.003186679,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.003186679,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0030170325,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019x9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeb_Bush"
				},
				"name": "Jeb Bush",
				"salience": 0.0028306032,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rjcr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oakland_Park,_Florida"
				},
				"name": "Oakland Park",
				"salience": 0.0028306032,
				"type": "LOCATION"
			},
			{
				"name": "smoke",
				"salience": 0.0028045697,
				"type": "OTHER"
			},
			{
				"name": "employee",
				"salience": 0.0028045697,
				"type": "PERSON"
			},
			{
				"name": "@JackPosobiec",
				"salience": 0.0023901055,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "affidavit",
				"salience": 0.0023590378,
				"type": "WORK_OF_ART"
			},
			{
				"name": "affidavit",
				"salience": 0.0023590378,
				"type": "OTHER"
			},
			{
				"name": "Florida Restaurant and Lodging Association",
				"salience": 0.0023109633,
				"type": "ORGANIZATION"
			},
			{
				"name": "Supervisor of Elections",
				"salience": 0.0020569651,
				"type": "ORGANIZATION"
			},
			{
				"name": "headquarters",
				"salience": 0.0020427962,
				"type": "LOCATION"
			},
			{
				"name": "GP Page",
				"salience": 0.0020427962,
				"type": "OTHER"
			},
			{
				"name": "insiders",
				"salience": 0.0020427962,
				"type": "PERSON"
			},
			{
				"name": "transportation sales surtax question",
				"salience": 0.0017623438,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d18n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elections_Department"
				},
				"name": "Elections Department",
				"salience": 0.0017264226,
				"type": "ORGANIZATION"
			},
			{
				"name": "testimony",
				"salience": 0.0016677049,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0016540793,
				"type": "OTHER"
			},
			{
				"name": "yes",
				"salience": 0.0015260536,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0015260536,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0015260536,
				"type": "OTHER"
			},
			{
				"name": "printing ballots",
				"salience": 0.0015260536,
				"type": "OTHER"
			},
			{
				"name": "voter ID cards",
				"salience": 0.0015260536,
				"type": "OTHER"
			},
			{
				"name": "primary election results",
				"salience": 0.0015260536,
				"type": "OTHER"
			},
			{
				"name": "posting",
				"salience": 0.0015260536,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.0008998863,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/snipes-dem.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-05T01:19:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.188",
		"text": "BREAKING! NYPD Ready To Make Arrests In Weiner Case…Hillary Visited Pedophile Island At Least 6 Times…Money Laundering, Underage Sex, Pay-for-Play,Proof of Inappropriate Handling Classified Information \nThe amazing citizen journalist Mike Cernovich broke this story this morning at Danger and Play . Florida residents have been complaining that they’re not getting their absentee ballots. Chelsey Marie Smith, was working full-time at Broward County Supervisor of Elections main office blew the whistle on the voter fraud scheme: LIVE on #Periscope : Breaking news! Voting fraud uncovered in Florida #MAGA3X https://t.co/q7jeEz6Rgh \n— Mike Cernovich 🇺🇸 (@Cernovich) November 4, 2016 \nThe Florida State Attorney is actively investigating the fraud case that involves Secretary of Elections Brenda Snipes: Source: FL State Attorney investigators are actively reviewing Broward County Voter Fraud Case \n— Jack Posobiec 🇺🇸 (@JackPosobiec) November 4, 2016 \n\nDemocrat Dr. Brenda Snipes was appointed by Jeb Bush in 2003 and is no stranger to controversy. On October 20, the Sun Sentinal reported that former Oakland Park Commissioner Anne Sallee noticed something troubling about her vote-by-mail ballot. It is missing Constitutional Amendment 2, the medical marijuana question. \nSallee, now Broward chapter director of the Florida Restaurant and Lodging Association, knows her way around government. Yet she said she spent a week unsuccessfully trying to get someone at the Broward elections office to pay attention to her complaint. \nShe was cleared on Wednesday of another election snafu, the early posting of primary election results. Her office also was criticized for sending out inaccurate voter ID cards, and for printing ballots for November that include the word “no” in the “yes” line on the county’s transportation sales surtax question. \nThere were multiple reports that Hillary personally met with Brenda Snipes days ago: There were multiple reports Hillary personally met with Brenda Snipes days ago. No photos, but where there's smoke… \n— Jack Posobiec 🇺🇸 (@JackPosobiec) November 4, 2016 \nAccording to a former Secretary of Elections Department employee, there is a secret room where Democrat insiders fill out those absentee ballots. \nThe woman provided her sworn testimony via affidavit. \nThe affidavit by Chelsey Marie Smith accuses Broward County officials of filling out blank absentee ballots to officials who she saw filling the ballots out at the Supervisor of Elections headquarters. Via: GP Page 1: ",
		"thread_title": "WOW! WHISTLEBLOWER TELLS CHILLING STORY Of Massive Voter Fraud: Trump Campaign Readies Lawsuit Against FL Sec Of Elections In Critical District [VIDEO] » 100percentfedUp.com",
		"title": "WOW! WHISTLEBLOWER TELLS CHILLING STORY Of Massive Voter Fraud: Trump Campaign Readies Lawsuit Against FL Sec Of Elections In Critical District [VIDEO] » 100percentfedUp.com",
		"type": "bias",
		"uuid": "b4bbf8b5c19e8864f5257832a58b81ef4ed2d4e4"
	},
	"-KhIW4K5oLgo7g-N0845": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T10:20:06.409+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.15860507,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.15308148,
				"type": "PERSON"
			},
			{
				"name": "revelations",
				"salience": 0.061693814,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.053176224,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.052751176,
				"type": "EVENT"
			},
			{
				"name": "email server",
				"salience": 0.052751176,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.05240499,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.045811336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.044025924,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.036980085,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.031108873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.028401108,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01w6mk6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rush_Limbaugh"
				},
				"name": "Limbaugh",
				"salience": 0.024740195,
				"type": "PERSON"
			},
			{
				"name": "distraction",
				"salience": 0.023608375,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.013508198,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.013339063,
				"type": "PERSON"
			},
			{
				"name": "SWAMP",
				"salience": 0.009770618,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.009449232,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.009330575,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.007916616,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.007878974,
				"type": "PERSON"
			},
			{
				"name": "conclusion",
				"salience": 0.0076219146,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0076219146,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.007604274,
				"type": "PERSON"
			},
			{
				"name": "agency",
				"salience": 0.0066318875,
				"type": "ORGANIZATION"
			},
			{
				"name": "use",
				"salience": 0.0066023334,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00646618,
				"type": "WORK_OF_ART"
			},
			{
				"name": "case",
				"salience": 0.005792322,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.005672175,
				"type": "ORGANIZATION"
			},
			{
				"name": "clock",
				"salience": 0.005600836,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0055154175,
				"type": "ORGANIZATION"
			},
			{
				"name": "conclusion",
				"salience": 0.00483304,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.0045738644,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "secretary of state",
				"salience": 0.0041858666,
				"type": "PERSON"
			},
			{
				"name": "review",
				"salience": 0.0041858666,
				"type": "OTHER"
			},
			{
				"name": "female",
				"salience": 0.0030496297,
				"type": "PERSON"
			},
			{
				"name": "sexting",
				"salience": 0.0030496297,
				"type": "EVENT"
			},
			{
				"name": "wife",
				"salience": 0.0030496297,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0027812098,
				"type": "ORGANIZATION"
			},
			{
				"name": "letter",
				"salience": 0.0026311802,
				"type": "WORK_OF_ART"
			},
			{
				"name": "communications",
				"salience": 0.002505391,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.002175636,
				"type": "OTHER"
			},
			{
				"name": "volume",
				"salience": 0.0018840227,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0018775599,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/088cp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/York"
				},
				"name": "York",
				"salience": 0.0018775599,
				"type": "LOCATION"
			},
			{
				"name": "ex-New",
				"salience": 0.0018775599,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/05/hillary-comey.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-06T23:54:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.144",
		"text": "\nLimbaugh said that the revelations in the Wikileaks material were “starting to hurt” the Clintons and that the renewed interest in an FBI investigation into her private email server would be a fruitless distraction. \nIn any case… \nIT’S TIME TO DRAIN THE SWAMP! \nFBI Director James Comey said Sunday that the agency has reviewed all of the Hillary Clinton emails recently discovered in an unrelated case and that his conclusion in July not to prosecute Clinton after the FBI’s original investigation into her use of private email server still stands. \nComey informed Congress on Oct. 28 that the agency would, in the unrelated case, review additional emails related to Clinton’s time running the State Department from 2009 to 2013. \n“Since my letter, the FBI investigative team has been working around the clock to process and review a large volume of emails,” Comey said Sunday in a follow-up letter to Congress. “During that time we reviewed all of the communications that were to or from Hilary Clinton as secretary of state. Based on our review, we have not changed our conclusion.” \nThe new case is purportedly related to ex-New York Democratic Rep. Anthony Weiner using a laptop he shared with estranged wife and top Clinton aide Huma Abedin for “sexting” an apparently underage female. \n",
		"thread_title": "BREAKING: CLINTON CLEARED...Was This A Coordinated Last Minute Trick To Energize Hillary's Base? » 100percentfedUp.com",
		"title": "BREAKING: CLINTON CLEARED...Was This A Coordinated Last Minute Trick To Energize Hillary's Base? » 100percentfedUp.com",
		"type": "bias",
		"uuid": "a19aabaa5a61eb8bc22fadaaa003e5fbba5c4bf6"
	},
	"-KhIW4SUrNfOkj5FE67C": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T10:20:27.252+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "people",
				"salience": 0.25944877,
				"type": "PERSON"
			},
			{
				"name": "NOTHING",
				"salience": 0.17882441,
				"type": "OTHER"
			},
			{
				"name": "Laws",
				"salience": 0.15256438,
				"type": "OTHER"
			},
			{
				"name": "truck",
				"salience": 0.0708546,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Hao Lee",
				"salience": 0.061923236,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.036244415,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.03342349,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.027183082,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.016222049,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.012701579,
				"type": "OTHER"
			},
			{
				"name": "son fishing",
				"salience": 0.010965374,
				"type": "OTHER"
			},
			{
				"name": "bumper",
				"salience": 0.010294496,
				"type": "OTHER"
			},
			{
				"name": "sticker",
				"salience": 0.009911747,
				"type": "OTHER"
			},
			{
				"name": "truck",
				"salience": 0.009311541,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fire",
				"salience": 0.008587266,
				"type": "OTHER"
			},
			{
				"name": "expletives",
				"salience": 0.008587266,
				"type": "OTHER"
			},
			{
				"name": "stranger",
				"salience": 0.008587266,
				"type": "PERSON"
			},
			{
				"name": "stickers",
				"salience": 0.008410364,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.007833203,
				"type": "LOCATION"
			},
			{
				"name": "pair",
				"salience": 0.007285854,
				"type": "OTHER"
			},
			{
				"name": "pro-Donald Trump",
				"salience": 0.006765158,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.006287844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0057391776,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/03xvyz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dodge_Ram"
				},
				"name": "Ram",
				"salience": 0.0044890777,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bs_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dodge"
				},
				"name": "Dodge",
				"salience": 0.0044890777,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07bcn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sacramento,_California"
				},
				"name": "Sacramento",
				"salience": 0.0044890777,
				"type": "LOCATION"
			},
			{
				"name": "F' Trump",
				"salience": 0.004289486,
				"type": "OTHER"
			},
			{
				"name": "river",
				"salience": 0.003968747,
				"type": "LOCATION"
			},
			{
				"name": "edge",
				"salience": 0.003968747,
				"type": "LOCATION"
			},
			{
				"name": "bumper",
				"salience": 0.0034244137,
				"type": "OTHER"
			},
			{
				"name": "fishing",
				"salience": 0.0034244137,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0029656645,
				"type": "PERSON"
			},
			{
				"name": "Fed Up",
				"salience": 0.002443893,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0679_1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KTXL"
				},
				"name": "KTXL",
				"salience": 0.0022649465,
				"type": "ORGANIZATION"
			},
			{
				"name": "Garden Highway",
				"salience": 0.0018258953,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/TRUCK-TORCHED-HILLARY.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-07T02:43:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.995",
		"text": "Email \nThese people are sick and evil. They will stop at NOTHING to get their way. Laws mean nothing to them, because they mean nothing to their President and his regime… \nA California man says a stranger hurled expletives and set his truck on fire Thursday after seeing a pro-Donald Trump sticker on the bumper. \nHao Lee had taken his 2-year-old son fishing on a pleasant November afternoon in Sacramento. He parked his white Dodge Ram truck with a pair of Trump stickers on the bumper along Garden Highway. \n“About a couple hours into fishing I heard someone yelling out ‘F’ Trump,” Lee told KTXL. \nLee and his son were only about 50 yards from where his truck was parked, near the edge of the river. TRENDING ON 100% Fed Up ",
		"thread_title": "EVIL HILLARY SUPPORTERS Yell \"F*ck Trump\"…Burn Truck Of Daddy Fishing With 2 Yr Son Over Of Trump Bumper-Stickers [VIDEO] » 100percentfedUp.com",
		"title": "EVIL HILLARY SUPPORTERS Yell \"F*ck Trump\"…Burn Truck Of Daddy Fishing With 2 Yr Son Over Of Trump Bumper-Stickers [VIDEO] » 100percentfedUp.com",
		"type": "bias",
		"uuid": "f54d8e13010d0a79893995ee65360ad4b38b5a35"
	},
	"-KhIW4Vwx1Md18rbizW7": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T22:34:36.822+02:00",
		"domain_rank": "25689",
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2521919-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T22:34:36.822+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": " ",
		"thread_title": "YIKES! HILLARY GOES OFF THE RAILS…Pulls A Howard Dean [Video]",
		"title": "YIKES! HILLARY GOES OFF THE RAILS…Pulls A Howard Dean [Video]",
		"type": "bias",
		"uuid": "4d3faf17519cfa46ca754ab8068428818dbb2bf3"
	},
	"-KhIW4pQ5q5_JuKFJLhT": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T17:37:41.165+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.34047467,
				"type": "PERSON"
			},
			{
				"name": "actress",
				"salience": 0.036239497,
				"type": "PERSON"
			},
			{
				"name": "Comedian",
				"salience": 0.032184206,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.031356893,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.031356893,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.025475917,
				"type": "LOCATION"
			},
			{
				"name": "Founder",
				"salience": 0.023285868,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.022806648,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07x1_3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Lopez_(TV_series)"
				},
				"name": "George Lopez",
				"salience": 0.017714953,
				"type": "PERSON"
			},
			{
				"name": "Actress",
				"salience": 0.014977179,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.014330879,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.013162214,
				"type": "LOCATION"
			},
			{
				"name": "Actress",
				"salience": 0.013031623,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spain",
				"salience": 0.011888076,
				"type": "LOCATION"
			},
			{
				"name": "honesty",
				"salience": 0.011841999,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.010614341,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.010614341,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03f2h01",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malcolm_X"
				},
				"name": "Malcolm X",
				"salience": 0.010331107,
				"type": "PERSON"
			},
			{
				"name": "Creator",
				"salience": 0.009608309,
				"type": "PERSON"
			},
			{
				"name": "Comedian",
				"salience": 0.009327347,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0091932425,
				"type": "OTHER"
			},
			{
				"name": "charming",
				"salience": 0.0091932425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vtj38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cher"
				},
				"name": "Cher",
				"salience": 0.0084364815,
				"type": "PERSON"
			},
			{
				"name": "host",
				"salience": 0.0079492135,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hmrpgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Huffington_Post"
				},
				"name": "Huffington Post",
				"salience": 0.0065372568,
				"type": "ORGANIZATION"
			},
			{
				"name": "IAC Interactive",
				"salience": 0.0065372568,
				"type": "ORGANIZATION"
			},
			{
				"name": "Activist",
				"salience": 0.006488211,
				"type": "PERSON"
			},
			{
				"name": "Actress",
				"salience": 0.006412808,
				"type": "PERSON"
			},
			{
				"name": "Actor",
				"salience": 0.0063542244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0304nh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_View_(U.S._TV_series)"
				},
				"name": "The View",
				"salience": 0.0060366862,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0059067514,
				"type": "LOCATION"
			},
			{
				"name": "Pop star",
				"salience": 0.005691205,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0164bt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Live!_with_Kelly_and_Michael"
				},
				"name": "Live with Kelly and Michael",
				"salience": 0.005661371,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0h3rv9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Cards_(U.S._TV_series)"
				},
				"name": "House of Cards",
				"salience": 0.005661371,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/044khm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barry_Diller"
				},
				"name": "Barry Diller",
				"salience": 0.005661371,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0l8v5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neve_Campbell"
				},
				"name": "Neve Campbell",
				"salience": 0.005661371,
				"type": "PERSON"
			},
			{
				"name": "Singer",
				"salience": 0.005502834,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059t8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nova_Scotia"
				},
				"name": "Nova Scotia",
				"salience": 0.0054541137,
				"type": "LOCATION"
			},
			{
				"name": "guest star",
				"salience": 0.00524203,
				"type": "PERSON"
			},
			{
				"name": "Actor",
				"salience": 0.004747685,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0199pk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ruth_Bader_Ginsburg"
				},
				"name": "Ruth Bader Ginsburg",
				"salience": 0.004592378,
				"type": "PERSON"
			},
			{
				"name": "heart",
				"salience": 0.0044928356,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0043729087,
				"type": "PERSON"
			},
			{
				"name": "Comedian",
				"salience": 0.004145704,
				"type": "PERSON"
			},
			{
				"name": "UK. 4",
				"salience": 0.0038219353,
				"type": "PERSON"
			},
			{
				"name": "Girls",
				"salience": 0.0037867809,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.0037867809,
				"type": "OTHER"
			},
			{
				"name": "Spike Lee Who",
				"salience": 0.0037014124,
				"type": "PERSON"
			},
			{
				"name": "Actress",
				"salience": 0.0034901237,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0032938712,
				"type": "OTHER"
			},
			{
				"name": "Star of Key & Peele",
				"salience": 0.0032271168,
				"type": "ORGANIZATION"
			},
			{
				"name": "republic",
				"salience": 0.0030662904,
				"type": "LOCATION"
			},
			{
				"name": "Comedian",
				"salience": 0.0030010252,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.0030010252,
				"type": "PERSON"
			},
			{
				"name": "hospital",
				"salience": 0.0029518488,
				"type": "LOCATION"
			},
			{
				"name": "hospital",
				"salience": 0.0029518488,
				"type": "LOCATION"
			},
			{
				"name": "ticket",
				"salience": 0.0029518488,
				"type": "OTHER"
			},
			{
				"name": "press conference",
				"salience": 0.0029518488,
				"type": "EVENT"
			},
			{
				"name": "resistance",
				"salience": 0.0028289848,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.002752588,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b1dys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Keegan-Michael_Key"
				},
				"name": "Keegan-Michael Key",
				"salience": 0.0026918773,
				"type": "PERSON"
			},
			{
				"name": "Director",
				"salience": 0.0026551995,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.0026551995,
				"type": "PERSON"
			},
			{
				"name": "Model",
				"salience": 0.0026551995,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hr22w5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orange_Is_the_New_Black"
				},
				"name": "Orange Is the New Black",
				"salience": 0.002573824,
				"type": "WORK_OF_ART"
			},
			{
				"name": "question",
				"salience": 0.0025560928,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0025560928,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cr3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brooklyn"
				},
				"name": "Brooklyn",
				"salience": 0.0024853246,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.002388625,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01g25r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chlo%C3%AB_Sevigny"
				},
				"name": "Chloë Sevigny",
				"salience": 0.0023309588,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.0023309588,
				"type": "LOCATION"
			},
			{
				"name": "Matrix Awards",
				"salience": 0.0023309588,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dd8vm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portlandia_(TV_series)"
				},
				"name": "Portlandia",
				"salience": 0.0023309588,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/080h2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vancouver"
				},
				"name": "Vancouver",
				"salience": 0.0023309588,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b3w054",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lena_Dunham"
				},
				"name": "Lena Dunham",
				"salience": 0.0023309588,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.0022418783,
				"type": "OTHER"
			},
			{
				"name": "popularity",
				"salience": 0.0021676235,
				"type": "OTHER"
			},
			{
				"name": "IM",
				"salience": 0.0021676235,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0021676235,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0021424098,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09q84",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jupiter"
				},
				"name": "JUPITER",
				"salience": 0.0020289295,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0018873506,
				"type": "LOCATION"
			},
			{
				"name": "actress",
				"salience": 0.0018399747,
				"type": "PERSON"
			},
			{
				"name": "TMZ. 7",
				"salience": 0.0018168933,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.001706451,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amber_Rose"
				},
				"name": "Amber Rose",
				"salience": 0.0016342637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01q2nh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vanity_Fair_(magazine)"
				},
				"name": "Vanity Fair",
				"salience": 0.0016342637,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president",
				"salience": 0.0016327556,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0016192249,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.0016192249,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.0015732514,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03xxbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eddie_Griffin"
				},
				"name": "Eddie Griffin",
				"salience": 0.0015732514,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/032bfz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Natasha_Lyonne"
				},
				"name": "Natasha Lyonne",
				"salience": 0.0015732514,
				"type": "PERSON"
			},
			{
				"name": "Al Sharpton Who",
				"salience": 0.0015732514,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.0015156087,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02p_8n9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Usher"
				},
				"name": "Michael Usher",
				"salience": 0.0014848617,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0013744459,
				"type": "LOCATION"
			},
			{
				"name": "post",
				"salience": 0.0013618767,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03f2_rc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barbra_Streisand"
				},
				"name": "Barbra Streisand",
				"salience": 0.0013341106,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f5xn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Samuel_L._Jackson"
				},
				"name": "Samuel L. Jackson",
				"salience": 0.0013341106,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.0013341106,
				"type": "LOCATION"
			},
			{
				"name": "confession",
				"salience": 0.0013110307,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0012363505,
				"type": "LOCATION"
			},
			{
				"name": "somewhere",
				"salience": 0.0011792366,
				"type": "LOCATION"
			},
			{
				"name": "comprehension",
				"salience": 0.0011792366,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0011117393,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ctw_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Zealand"
				},
				"name": "New Zealand",
				"salience": 0.0011037694,
				"type": "LOCATION"
			},
			{
				"name": "DJ Vlad",
				"salience": 0.0011029736,
				"type": "PERSON"
			},
			{
				"name": "TMZ. 16",
				"salience": 0.0010398405,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0010172849,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0010172849,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/061ln",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Power_(physics)"
				},
				"name": "Power",
				"salience": 0.000996543,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02cl1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denver"
				},
				"name": "Denver",
				"salience": 0.000996543,
				"type": "LOCATION"
			},
			{
				"name": "Omari Hardwick Who",
				"salience": 0.000996543,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fb1q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whoopi_Goldberg"
				},
				"name": "Whoopi Goldberg",
				"salience": 0.000996543,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bdxs5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miley_Cyrus"
				},
				"name": "Miley Cyrus",
				"salience": 0.000996543,
				"type": "PERSON"
			},
			{
				"name": "leaving",
				"salience": 0.000926695,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/043hrw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Us_Weekly"
				},
				"name": "US Weekly",
				"salience": 0.0009003803,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.00088084926,
				"type": "PERSON"
			},
			{
				"name": "Note",
				"salience": 0.00088084926,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00088084926,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082447455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australia",
				"salience": 0.00082447455,
				"type": "LOCATION"
			},
			{
				"name": "Amy Schumer Who",
				"salience": 0.000725729,
				"type": "PERSON"
			},
			{
				"name": "Katie Hopkins",
				"salience": 0.000725729,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.000725729,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06nm1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spanish_language"
				},
				"name": "Spanish",
				"salience": 0.000725729,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associate_Justice_of_the_Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court Justice",
				"salience": 0.000725729,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0glpjll",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Instagram"
				},
				"name": "Instagram",
				"salience": 0.000725729,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0007099859,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_qfnmv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/TheWrap"
				},
				"name": "The Wrap",
				"salience": 0.00067254325,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.0006264898,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/035pvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raven-Symon%C3%A9"
				},
				"name": "Raven-Symoné",
				"salience": 0.00054208166,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australian",
				"salience": 0.00054208166,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01r6t9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Newsnight"
				},
				"name": "Newsnight",
				"salience": 0.00048976834,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/moving.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-09T17:28:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 31.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.998",
		"text": "\nWho? Comedian. \nWhere would she move? Spain. “I did buy a house in another country just in case, so all of these people that threaten to leave the country and then don’t, I will leave the country,” she said on Live with Kelly and Michael. \n(Weirdly, she called Trump charming in the same interview.) \n3. Neve Campbell \nWho? House of Cards actress. \nWhere would she move? Canada. \n“His honesty is terrifying,” she told Huffington Post UK. \n4. Barry Diller \nWho? Founder of IAC Interactive. \nWhere would he move? Unspecified. \n“If Donald Trump doesn’t fall, I’ll either move out of the country or join the resistance,” he told Bloomberg. \n5. Lena Dunham \nWho? Creator of Girls. \nWhere would she move? Vancouver. \n“I know a lot of people have been threatening to do this, but I really will,” she said at the Matrix Awards. \n6. Keegan-Michael Key \nWho? Star of Key & Peele. \nWhere would he move? Canada. \n“It’s easy. It’s like 10 minutes from Detroit and that’s where I’m from,” he told TMZ. \n7. Chloë Sevigny \nWho? Actress and guest star in Portlandia. \nWhere would she move? Nova Scotia. \nShe answered simply, “Nova Scotia” to a question of where she would move if Trump were elected. \n8. Al Sharpton \nWho? Activist. \nWhere would he move? Out of here. \n“If Donald Trump is the nominee, I’m open to support anyone, while I’m also reserving my ticket out of here if he wins,” he said at a press conference. \n9. Natasha Lyonne \nWho? Actress in Orange Is the New Black. \nWhere would she move? A mental hospital. \n“[I’ll move] to a mental hospital for a while because you’re like ‘why is this happening?’” she said. \n10. Eddie Griffin \nWho? Comedian. \nWhere would he move? Africa. \n“He’s good at making money, but he’s ignorant…If Trump wins, I’m moving to Africa,” he told DJ Vlad. \n11. Spike Lee \nWho? Director of Malcolm X. \nWhere would he move? …Brooklyn. \nIf Trump wins, he’ll be “moving back to the republic of Brooklyn, New York,” he reported to Vanity Fair. \n12. Amber Rose \nWho? Model. \nWhere would she move? Unspecified. \n“I can’t even think about it! I’m moving, I’m out! I can’t. And I am taking my son with me!” she told US Weekly. \n13. Samuel L. Jackson \nWho? Actor. \nWhere would he move? South Africa. \n“He’s just running for popularity. C’mon, just let it go,” he said on The View. \n14. Cher \nWhere would she move? Jupiter \n“IF HE WERE TO BE ELECTED, IM MOVING TO JUPITER >:|” she tweeted. \n15. George Lopez \nWho? Comedian and star of George Lopez. \nWhere would he move? Mexico. \n“If he wins, he won’t have to worry about immigration, we’ll all go back,” he told TMZ. \n16. Barbra Streisand \nWho? Singer. \nWhere would she move? Australia or Canada. \n“He has no facts. I don’t know, I can’t believe it. I’m either coming to your country [Australia], if you’ll let me in, or Canada,” she told Australian journalist Michael Usher. \n17. Raven-Symoné \nWho? Actress and host of The View. \nWhere would she move? Canada. \n“My confession for this election is if any Republican gets nominated, I’m going to move to Canada with my entire family. I already have my ticket,” she said on The View. \nNote: Her leaving was contingent on any Republican candidate winning the election–not just Trump. \n18. Whoopi Goldberg \nWho? Actress and host of The View. \nWhere would she move? Unspecified. \n“I don’t want it to be America. Maybe it’s time for me to move, you know,” she said. \n19. Omari Hardwick \nWho? Actor in Power. \nWhere would he move? Italy. \n“I’ll move from Denver to Italy… If Donald Trump wins the presidency, I’m out,” he told The Wrap. \n20. Miley Cyrus \nWho? Pop star. \nWhere would she move? Unspecified. \n“My heart is broken into a 1 pieces…I am moving if this is my president! I don’t say things I don’t mean!” she wrote in an Instagram post. \n21. Ruth Bader Ginsburg \nWho? Supreme Court Justice. \nWhere would she move? New Zealand. \n“I can’t imagine what the country would be with Donald Trump as our president… Now it’s time for us to move to New Zealand,” she told The New York Times. \n22. Amy Schumer \nWho? Comedian and actress. \nWhere would she move? Spain. \n“I will need to learn to speak Spanish because I will move to Spain or somewhere… It’s beyond my comprehension if Trump won. It’s too crazy,” she told BBC Newsnight. \n23. Katie Hopkins ",
		"thread_title": "SAY GOODBYE! These 23 Hollywood Celebs Threatened To Leave The U.S....Let's Hold Them To It! » 100percentfedUp.com",
		"title": "SAY GOODBYE! These 23 Hollywood Celebs Threatened To Leave The U.S....Let's Hold Them To It! » 100percentfedUp.com",
		"type": "bias",
		"uuid": "7f90d71cc69893f4c91e8a55f2c4da52d88cd7c1"
	},
	"-KhIW596kqMBsBFJijpH": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-10T02:37:06.677+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "university",
				"salience": 0.09097641,
				"type": "ORGANIZATION"
			},
			{
				"name": "presidency",
				"salience": 0.058269758,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.04724722,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07szy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Michigan"
				},
				"name": "University of Michigan",
				"salience": 0.046505213,
				"type": "ORGANIZATION"
			},
			{
				"name": "Students",
				"salience": 0.044620182,
				"type": "PERSON"
			},
			{
				"name": "honesty",
				"salience": 0.02934565,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.02667164,
				"type": "PERSON"
			},
			{
				"name": "each other",
				"salience": 0.02137387,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.019218922,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.018521978,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.018521978,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.018521978,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.018384688,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.014770877,
				"type": "EVENT"
			},
			{
				"name": "President",
				"salience": 0.0139869405,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0139869405,
				"type": "PERSON"
			},
			{
				"name": "responsibility",
				"salience": 0.01383481,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.012166475,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0121172285,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.011421122,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.011421122,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.01075811,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Office of Student Life",
				"salience": 0.010224455,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.00907763,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.007940575,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0075878403,
				"type": "PERSON"
			},
			{
				"name": "Paul Joseph Watson",
				"salience": 0.0066280314,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.006092595,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.006092595,
				"type": "EVENT"
			},
			{
				"name": "everyone",
				"salience": 0.005922421,
				"type": "PERSON"
			},
			{
				"name": "classroom environments",
				"salience": 0.0058959997,
				"type": "OTHER"
			},
			{
				"name": "NotMyPresident pic.twitter.com/8cKfQdF2Ce",
				"salience": 0.00583962,
				"type": "OTHER"
			},
			{
				"name": "@PrisonPlanet",
				"salience": 0.00583962,
				"type": "OTHER"
			},
			{
				"name": "Members",
				"salience": 0.005768476,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/052rj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan_Union"
				},
				"name": "Michigan Union",
				"salience": 0.0055919127,
				"type": "LOCATION"
			},
			{
				"name": "Ron Weiser",
				"salience": 0.0055822134,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0226cw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Dingell"
				},
				"name": "John Dingell",
				"salience": 0.0055822134,
				"type": "PERSON"
			},
			{
				"name": "staff",
				"salience": 0.0054072747,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0053226203,
				"type": "PERSON"
			},
			{
				"name": "Students",
				"salience": 0.0053226203,
				"type": "PERSON"
			},
			{
				"name": "election coverage",
				"salience": 0.005162549,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00499579,
				"type": "OTHER"
			},
			{
				"name": "discovery",
				"salience": 0.00499579,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.00499579,
				"type": "ORGANIZATION"
			},
			{
				"name": "university",
				"salience": 0.004668756,
				"type": "ORGANIZATION"
			},
			{
				"name": "post election event",
				"salience": 0.0046393117,
				"type": "EVENT"
			},
			{
				"name": "inclusion",
				"salience": 0.004511099,
				"type": "OTHER"
			},
			{
				"name": "equity",
				"salience": 0.004511099,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.004511099,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.004511099,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_frb_3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Schlissel"
				},
				"name": "Mark Schlissel",
				"salience": 0.004487038,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0043460014,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0043460014,
				"type": "PERSON"
			},
			{
				"name": "responsibility",
				"salience": 0.004345873,
				"type": "OTHER"
			},
			{
				"name": "faculty",
				"salience": 0.004273206,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.004273206,
				"type": "EVENT"
			},
			{
				"name": "faculty",
				"salience": 0.004273206,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0041138097,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.003906649,
				"type": "PERSON"
			},
			{
				"name": "ALL",
				"salience": 0.0038948418,
				"type": "OTHER"
			},
			{
				"name": "university community",
				"salience": 0.0038948418,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0037923148,
				"type": "PERSON"
			},
			{
				"name": "community discussion",
				"salience": 0.0035935463,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.0035642008,
				"type": "OTHER"
			},
			{
				"name": "University Community",
				"salience": 0.0035519772,
				"type": "OTHER"
			},
			{
				"name": "faculty",
				"salience": 0.0034889455,
				"type": "PERSON"
			},
			{
				"name": "faculty",
				"salience": 0.0034889455,
				"type": "PERSON"
			},
			{
				"name": "discovery",
				"salience": 0.0033728853,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.0033728853,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0033705307,
				"type": "OTHER"
			},
			{
				"name": "faculty members",
				"salience": 0.0033032063,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.003247137,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0031635514,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0031635514,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0031635514,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0030962338,
				"type": "PERSON"
			},
			{
				"name": "Ginsberg Center",
				"salience": 0.0030759282,
				"type": "ORGANIZATION"
			},
			{
				"name": "equity",
				"salience": 0.0030455105,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0030455105,
				"type": "OTHER"
			},
			{
				"name": "inclusion",
				"salience": 0.0030455105,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0030455105,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0030455105,
				"type": "OTHER"
			},
			{
				"name": "Center for Research on Teaching and Learning",
				"salience": 0.0029989285,
				"type": "ORGANIZATION"
			},
			{
				"name": "research university",
				"salience": 0.0029584228,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0029339187,
				"type": "OTHER"
			},
			{
				"name": "vigil",
				"salience": 0.0027395196,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0027395196,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0027395196,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0027395196,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0027395196,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0027395196,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.002682915,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0026372885,
				"type": "LOCATION"
			},
			{
				"name": "differences",
				"salience": 0.0026372885,
				"type": "OTHER"
			},
			{
				"name": "implications",
				"salience": 0.0026372885,
				"type": "OTHER"
			},
			{
				"name": "aftermath",
				"salience": 0.0026372885,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0026372885,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0026202113,
				"type": "PERSON"
			},
			{
				"name": "faculty",
				"salience": 0.002606621,
				"type": "PERSON"
			},
			{
				"name": "Elections",
				"salience": 0.002606621,
				"type": "EVENT"
			},
			{
				"name": "events",
				"salience": 0.002606621,
				"type": "EVENT"
			},
			{
				"name": "perspectives",
				"salience": 0.0025827945,
				"type": "OTHER"
			},
			{
				"name": "campus",
				"salience": 0.0025827945,
				"type": "LOCATION"
			},
			{
				"name": "Post-Election Analysis",
				"salience": 0.0025712613,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0025502578,
				"type": "OTHER"
			},
			{
				"name": "offices",
				"salience": 0.0024678202,
				"type": "LOCATION"
			},
			{
				"name": "Speakers",
				"salience": 0.002323263,
				"type": "PERSON"
			},
			{
				"name": "staff",
				"salience": 0.0023131566,
				"type": "PERSON"
			},
			{
				"name": "referrals",
				"salience": 0.0022365553,
				"type": "OTHER"
			},
			{
				"name": "location",
				"salience": 0.0022365553,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b9htp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gerald_R._Ford_School_of_Public_Policy"
				},
				"name": "Gerald R. Ford School of Public Policy",
				"salience": 0.0021568267,
				"type": "ORGANIZATION"
			},
			{
				"name": "schools",
				"salience": 0.0021369846,
				"type": "ORGANIZATION"
			},
			{
				"name": "resources",
				"salience": 0.002108587,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0019295007,
				"type": "PERSON"
			},
			{
				"name": "opportunities",
				"salience": 0.0019295007,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0019295007,
				"type": "OTHER"
			},
			{
				"name": "campus",
				"salience": 0.0019295007,
				"type": "LOCATION"
			},
			{
				"name": "event",
				"salience": 0.0018276769,
				"type": "EVENT"
			},
			{
				"name": "University of Michigan Events Calendar",
				"salience": 0.0018211032,
				"type": "ORGANIZATION"
			},
			{
				"name": "members",
				"salience": 0.001797426,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.001797426,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0017433694,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0017303338,
				"type": "OTHER"
			},
			{
				"name": "Diag",
				"salience": 0.0016863131,
				"type": "OTHER"
			},
			{
				"name": "colleges",
				"salience": 0.0016707976,
				"type": "ORGANIZATION"
			},
			{
				"name": "change",
				"salience": 0.0016707976,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0016707976,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0016707976,
				"type": "OTHER"
			},
			{
				"name": "1014 Tisch Hall",
				"salience": 0.0015898133,
				"type": "LOCATION"
			},
			{
				"name": "Weill Hall",
				"salience": 0.0015898133,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0015553362,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0014052844,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0014052844,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0014052844,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0014052844,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0014052844,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0014052844,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ch8xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marina_von_Neumann_Whitman"
				},
				"name": "Marina Whitman",
				"salience": 0.0013766367,
				"type": "PERSON"
			},
			{
				"name": "Mara Ostfeld",
				"salience": 0.0013766367,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0r8nct7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Betsey_Stevenson"
				},
				"name": "Betsey Stevenson",
				"salience": 0.0013766367,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0013766367,
				"type": "LOCATION"
			},
			{
				"name": "Annenberg Auditorium",
				"salience": 0.0013766367,
				"type": "LOCATION"
			},
			{
				"name": "Willis Ward Lounge",
				"salience": 0.0013766367,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07snqm2"
				},
				"name": "History Department",
				"salience": 0.0013766367,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.0013427073,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0013263256,
				"type": "LOCATION"
			},
			{
				"name": "art",
				"salience": 0.0012168424,
				"type": "WORK_OF_ART"
			},
			{
				"name": "work",
				"salience": 0.0012168424,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0012168424,
				"type": "PERSON"
			},
			{
				"name": "preeminence",
				"salience": 0.0012168424,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0012168424,
				"type": "LOCATION"
			},
			{
				"name": "mission",
				"salience": 0.0012168424,
				"type": "OTHER"
			},
			{
				"name": "Office of Multi-Ethnic Student Affairs",
				"salience": 0.0011937622,
				"type": "ORGANIZATION"
			},
			{
				"name": "Perspective",
				"salience": 0.001049741,
				"type": "OTHER"
			},
			{
				"name": "Impact",
				"salience": 0.001049741,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00096847437,
				"type": "OTHER"
			},
			{
				"name": "Dialogue",
				"salience": 0.00090896327,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.00076107413,
				"type": "LOCATION"
			},
			{
				"name": "Henderson Room",
				"salience": 0.0006460482,
				"type": "LOCATION"
			},
			{
				"name": "Room 2202",
				"salience": 0.0006460482,
				"type": "LOCATION"
			},
			{
				"name": "Michigan League",
				"salience": 0.00055939984,
				"type": "ORGANIZATION"
			},
			{
				"name": "Student Life Professional Development Conference",
				"salience": 0.00055939984,
				"type": "EVENT"
			},
			{
				"name": "Ginsberg Center and Counseling and Psychological Services",
				"salience": 0.00055939984,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0qpn9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mesa,_Arizona"
				},
				"name": "MESA",
				"salience": 0.00055939984,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2534062-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-10T02:37:06.677+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Students expressed their “fear” over a Trump presidency in messages to each other that were being shared on Twitter today: “Literally scared for their lives” is the new “literally Hitler”. #NotMyPresident pic.twitter.com/8cKfQdF2Ce \n— Paul Joseph Watson (@PrisonPlanet) November 9, 2016 \nAnd finally, this ridiculous and totally biased email was sent from University of Michigan President to the students offering them assistance to help them through the results of our Presidential election last night. The President wants to ensure the students that the university remains committed to their “most important responsibility” at their school which is apparently, “to remain committed to education, discovery and intellectual honesty – and to diversity, equity and inclusion.”: \nTo All Members of the University Community: \nAs I’m sure many of you did, I watched the election coverage late into the night, and had the opportunity to visit with students and staff at a results-watching event sponsored by the Ginsberg Center at the Michigan Union. It will take quite some time to completely absorb the results from yesterday’s election, understand the full implications, and discern the long-term impact on our university and our nation . More immediately, in the aftermath of a close and highly contentious election we continue to embrace our most important responsibility as a university community. Our responsibility is to remain committed to education, discovery and intellectual honesty – and to diversity, equity and inclusion. We are at our best when we come together to engage respectfully across our ideological differences; to support ALL who feel marginalized, threatened or unwelcome; and to pursue knowledge and understanding, as we always have, as the students, faculty and staff of the University of Michigan. There are reports of members of our community offering support to one another. Students are planning a vigil tonight on the Diag at 6 p.m. Our Center for Research on Teaching and Learning also has numerous resources available for faculty seeking help in cultivating classroom environments that are responsive to national issues. I also want to make everyone aware of some of the plans and events we have had in place for today and beyond. · Our Gerald R. Ford School of Public Policy is holding a Post-Election Analysis from 4 to 5:30 p.m. today in the Weill Hall’s Annenberg Auditorium. Speakers include former U.S. Congressman John Dingell, former Ambassador Ron Weiser, and faculty members Mara Ostfeld, Betsey Stevenson and Marina Whitman. · Our History Department has organized a community discussion led by faculty and students to include historical perspectives at 6 p.m. tonight in 1014 Tisch Hall. · The Office of Student Life will provide resources and referrals for support on campus to students, faculty and staff at a location in the Michigan Union’s Willis Ward Lounge. It will be open today from 11 a.m. to 4 p.m. · Our Office of Multi-Ethnic Student Affairs is offering an open space of support to help members of our community connect during open hours today. MESA’s office is in the Michigan Union, Room 2202. · Tomorrow, our Ginsberg Center and Counseling and Psychological Services office is facilitating a Post-election Dialogue: Impact, Perspective-taking, and Moving Forward. This event is part of the Student Life Professional Development Conference at 1 – 2 p.m. in the Michigan League’s Henderson Room. I know that other schools, colleges and offices across our campus are planning events as well. I thank everyone who is helping us come together and ask anyone scheduling a post election event post it on the University of Michigan Events Calendar. I hope all of us will continue to proudly embrace the opportunities before us as the students, faculty and staff of a great public research university governed by the people. Elections are often times of great change, but the values we stand for at U-M have been shaped over the course of nearly 200 years. Our mission remains as essential for society as ever: “…to serve the people of Michigan and the world through preeminence in creating, communicating, preserving and applying knowledge, art, and academic values, and in developing leaders and citizens who will challenge the present and enrich the future.” I look forward to working together with all of you to advance the work we do in service of the public – and to ensure that the University of Michigan will always be a welcoming place for all members of society. Sincerely, \nMark Schlissel President  ",
		"thread_title": "NOT KIDDING: Colleges Give Students “Safe Spaces” To Cry Over Trump Win…Threaten Students Over Pro-Trump “Chalkings”",
		"title": "NOT KIDDING: Colleges Give Students “Safe Spaces” To Cry Over Trump Win…Threaten Students Over Pro-Trump “Chalkings”",
		"type": "bias",
		"uuid": "fd2c048d7e03f7260a8d75725b0441c627578f1a"
	},
	"-KhIW5_aIX4AIXyjZ7GT": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-10T16:25:14.079+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.38073552,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.23943529,
				"type": "PERSON"
			},
			{
				"name": "Trumpers",
				"salience": 0.07388035,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02zzm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kasich"
				},
				"name": "John Kasich",
				"salience": 0.04876789,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.02738533,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.02725388,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.02725388,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013f39m8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump_presidential_campaign,_2016"
				},
				"name": "Trump 2016",
				"salience": 0.017869288,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.010301219,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.009427483,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.007957972,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0075711277,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.007329838,
				"type": "ORGANIZATION"
			},
			{
				"name": "media force",
				"salience": 0.006560504,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.006560504,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.0056750365,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0044240127,
				"type": "OTHER"
			},
			{
				"name": "precincts",
				"salience": 0.003125513,
				"type": "LOCATION"
			},
			{
				"name": "total",
				"salience": 0.0027296816,
				"type": "OTHER"
			},
			{
				"name": "glance",
				"salience": 0.0027070988,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0027070988,
				"type": "OTHER"
			},
			{
				"name": "totals",
				"salience": 0.0025299848,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0025299848,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0024280355,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.0023551055,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0023496312,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0023487252,
				"type": "ORGANIZATION"
			},
			{
				"name": "answer",
				"salience": 0.0023064902,
				"type": "OTHER"
			},
			{
				"name": "vote totals",
				"salience": 0.002145927,
				"type": "OTHER"
			},
			{
				"name": "battlegrounds",
				"salience": 0.0021107965,
				"type": "LOCATION"
			},
			{
				"name": "more",
				"salience": 0.0021107965,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.0021013787,
				"type": "WORK_OF_ART"
			},
			{
				"name": "same",
				"salience": 0.0020230205,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0019826335,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0019826335,
				"type": "EVENT"
			},
			{
				"name": "instance",
				"salience": 0.0018988536,
				"type": "OTHER"
			},
			{
				"name": "credit",
				"salience": 0.0018988536,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0018988536,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0018944382,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.001828037,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0016671508,
				"type": "LOCATION"
			},
			{
				"name": "exercise",
				"salience": 0.001651823,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0015504126,
				"type": "OTHER"
			},
			{
				"name": "Disclaimer",
				"salience": 0.0015504126,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0014814228,
				"type": "LOCATION"
			},
			{
				"name": "opponent",
				"salience": 0.0014737806,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0013376529,
				"type": "LOCATION"
			},
			{
				"name": "answer",
				"salience": 0.0013376529,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0012658502,
				"type": "OTHER"
			},
			{
				"name": "totals",
				"salience": 0.0011680473,
				"type": "OTHER"
			},
			{
				"name": "battleground states",
				"salience": 0.0011680473,
				"type": "LOCATION"
			},
			{
				"name": "roof",
				"salience": 0.0011583728,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0011583728,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0q76g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Midwestern_United_States"
				},
				"name": "Midwestern",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wisconsin",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.0011255009,
				"type": "LOCATION"
			},
			{
				"name": "math",
				"salience": 0.0009743511,
				"type": "OTHER"
			},
			{
				"name": "precincts",
				"salience": 0.0009743511,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00087262987,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.00084373204,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.00084373204,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00080616894,
				"type": "LOCATION"
			},
			{
				"name": "electorates",
				"salience": 0.00080616894,
				"type": "PERSON"
			},
			{
				"name": "math",
				"salience": 0.0007278957,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.0007130591,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.0006715577,
				"type": "OTHER"
			},
			{
				"name": "performances",
				"salience": 0.00063030026,
				"type": "EVENT"
			},
			{
				"name": "matchup",
				"salience": 0.00063030026,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt41",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Yankees"
				},
				"name": "Yankees",
				"salience": 0.0005895464,
				"type": "ORGANIZATION"
			},
			{
				"name": "comparison",
				"salience": 0.00052776793,
				"type": "OTHER"
			},
			{
				"name": "Fed Up",
				"salience": 0.00051932875,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01yjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago_Cubs"
				},
				"name": "Cubs",
				"salience": 0.00038793474,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/us-election-map.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-10T15:38:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.001",
		"text": "Email For Republican politicians like Ohio Governor John Kasich who refused to get behind Donald J. Trump…it turns out Trump was right…he didn’t need you. In spite of the massive media force who came out against him, and the ‘never Trumpers’ from his own party who worked very hard to defeat him, if Obama was running against Donald J. Trump today, Trump would have beaten him… \nIt’s easy to glance at Tuesday’s popular vote — which, with 92 percent of all precincts reporting, shows Hillary Clinton with six million fewer votes than Barack Obama won in 2012 – and reach the conclusion that Clinton lost the White House because she failed to turn out the Democratic base. But the truth is much more complicated. While she underperformed relative to Obama’s 2012 totals in several Midwestern states — Ohio, Michigan, Iowa, and Wisconsin — Clinton ran virtually even with Obama in the battlegrounds of Pennsylvania, North Carolina, Virginia, Nevada, and New Hampshire. What’s more, she far surpassed Obama’s 2012 vote total in Florida, the country’s biggest swing state. Yet somehow, while Obama carried Florida, Clinton lost it. Which brings us to an important question: Was Donald Trump just good enough to beat a bad Democratic opponent on Tuesday, or does he deserve far more credit? Could he, for instance, have competed with the vaunted Obama machine? The answer, somewhat shockingly, is yes. \nA review of vote totals in the past two elections reveals that Trump 2016 would have defeated Obama 2012 in the electoral college. (Disclaimer: This obviously is an apples-to-oranges exercise because no two elections are the same, nor are any two electorates. Still, unlike debating whether the 2016 Cubs would defeat the 1927 Yankees, this is not an entirely abstract argument; a comparison of their respective performances in the country’s most competitive states shows Trump edging Obama in a hypothetical head-to-head matchup.) The math might seem impossible. After all, Obama won nearly 66 million votes in 2012; Trump is currently at 59.5 million and should finish around 60 million, which will actually be one million fewer votes than Mitt Romney won. How, then, could Trump have topped Obama in the electoral college? The answer: Republican turnout lagged in certain parts of the country but shot through the roof in the nation’s most critical battleground states. Let’s look at them individually, in descending order by population, and do the electoral-vote math. The 2016 totals aren’t yet final because not all precincts have reported. \nFLORIDA — 29 EVs — 98 percent reporting \nObama 2012: 4,235,270 \nClinton 2016: 4,485,745 TRENDING ON 100% Fed Up ",
		"thread_title": "BOOM! MATH SHOWS Trump Would Have Beaten Obama In Romney-Obama Election » 100percentfedUp.com",
		"title": "BOOM! MATH SHOWS Trump Would Have Beaten Obama In Romney-Obama Election » 100percentfedUp.com",
		"type": "bias",
		"uuid": "c8d4c0a88af223f1b41e3e966ecd98ceb22ab5fb"
	},
	"-KhIW5hFRU4WoFCCJ7Mj": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-11T16:41:40.949+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "Copyright",
				"salience": 0.32185277,
				"type": "OTHER"
			},
			{
				"name": "100PercentFedUp.com",
				"salience": 0.20688634,
				"type": "OTHER"
			},
			{
				"name": "association",
				"salience": 0.14167665,
				"type": "OTHER"
			},
			{
				"name": "Liberty Alliance",
				"salience": 0.088852,
				"type": "ORGANIZATION"
			},
			{
				"name": "STAY",
				"salience": 0.05234081,
				"type": "EVENT"
			},
			{
				"name": "rights",
				"salience": 0.050420094,
				"type": "OTHER"
			},
			{
				"name": "WPDevelopers",
				"salience": 0.03243378,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gz469",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago_Loop"
				},
				"name": "THE LOOP",
				"salience": 0.026529748,
				"type": "WORK_OF_ART"
			},
			{
				"name": "insider",
				"salience": 0.02347414,
				"type": "PERSON"
			},
			{
				"name": "Subscribe",
				"salience": 0.02347414,
				"type": "OTHER"
			},
			{
				"name": "email newsletter",
				"salience": 0.017569268,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Fed Up",
				"salience": 0.014490256,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/reagan.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-11T15:13:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Copyright © 2016 100PercentFedUp.com, in association with Liberty Alliance | All rights reserved. Proudly built by WPDevelopers . STAY IN THE LOOP Sign up for our email newsletter to become a 100% Fed Up insider. Subscribe ",
		"thread_title": "BOOM! This Is How President Reagan Handled Protesters: \"Negotiate? What is there to negotiate?\" [Video] » 100percentfedUp.com",
		"title": "BOOM! This Is How President Reagan Handled Protesters: \"Negotiate? What is there to negotiate?\" [Video] » 100percentfedUp.com",
		"type": "bias",
		"uuid": "f0b221ac2a32d3f533ab5e097883b5bd19924033"
	},
	"-KhIW670tYkJNfkfZIVR": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-12T06:16:03.318+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.16226612,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.15426913,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.15426913,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reporter",
				"salience": 0.14689197,
				"type": "PERSON"
			},
			{
				"name": "t-shirt",
				"salience": 0.105366044,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "woman",
				"salience": 0.0575625,
				"type": "PERSON"
			},
			{
				"name": "reporting",
				"salience": 0.05402536,
				"type": "OTHER"
			},
			{
				"name": "demonizing",
				"salience": 0.046939652,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02q4dxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hunter_Pence"
				},
				"name": "Pence",
				"salience": 0.041317213,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.028060965,
				"type": "ORGANIZATION"
			},
			{
				"name": "protests",
				"salience": 0.014837014,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.014837014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New Yorkers",
				"salience": 0.0070208684,
				"type": "PERSON"
			},
			{
				"name": "pic.twitter.com/EMelMQamAU",
				"salience": 0.0066745663,
				"type": "OTHER"
			},
			{
				"name": "@calmsnbc",
				"salience": 0.005662448,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2543787-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T06:16:03.318+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article A Trump supporter wearing a Trump/Pence t-shirt let it fly on a reporter from MSNBC because of his one sided reporting and the demonizing of Trump. This is one brave woman! New Yorkers have had enough of the protests and violence! … @calmsnbc is having an interesting day. pic.twitter.com/EMelMQamAU",
		"thread_title": "TRUMP SUPPORTER GOT NUTS On MSNBC Reporter Covering Anti-Trump Rioters [Video]",
		"title": "TRUMP SUPPORTER GOT NUTS On MSNBC Reporter Covering Anti-Trump Rioters [Video]",
		"type": "bias",
		"uuid": "a9efba05a81e5b106ac2a4b12bd39615e402bfb9"
	},
	"-KhIW6Bbs8QYsml7ikQH": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-12T15:52:41.900+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "Copyright",
				"salience": 0.32185277,
				"type": "OTHER"
			},
			{
				"name": "100PercentFedUp.com",
				"salience": 0.20688634,
				"type": "OTHER"
			},
			{
				"name": "association",
				"salience": 0.14167665,
				"type": "OTHER"
			},
			{
				"name": "Liberty Alliance",
				"salience": 0.088852,
				"type": "ORGANIZATION"
			},
			{
				"name": "STAY",
				"salience": 0.05234081,
				"type": "EVENT"
			},
			{
				"name": "rights",
				"salience": 0.050420094,
				"type": "OTHER"
			},
			{
				"name": "WPDevelopers",
				"salience": 0.03243378,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gz469",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago_Loop"
				},
				"name": "THE LOOP",
				"salience": 0.026529748,
				"type": "WORK_OF_ART"
			},
			{
				"name": "insider",
				"salience": 0.02347414,
				"type": "PERSON"
			},
			{
				"name": "Subscribe",
				"salience": 0.02347414,
				"type": "OTHER"
			},
			{
				"name": "email newsletter",
				"salience": 0.017569268,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Fed Up",
				"salience": 0.014490256,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/Tomi.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-10T08:41:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.268",
		"text": "Copyright © 2016 100PercentFedUp.com, in association with Liberty Alliance | All rights reserved. Proudly built by WPDevelopers . STAY IN THE LOOP Sign up for our email newsletter to become a 100% Fed Up insider. Subscribe ",
		"thread_title": "TOMI LAHREN Has Special Message For Celebrities Who Said They'd Move To Canada If Trump Won [VIDEO] » 100percentfedUp.com",
		"title": "TOMI LAHREN Has Special Message For Celebrities Who Said They'd Move To Canada If Trump Won [VIDEO] » 100percentfedUp.com",
		"type": "bias",
		"uuid": "13e3e1983787c76876e9e5d095e73ef8cee1628a"
	},
	"-KhIW6SZ6tG0GROhVygR": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-12T19:55:23.883+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.54537743,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06cgy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_De_Niro"
				},
				"name": "Robert De Niro",
				"salience": 0.25493062,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.019984977,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.019773422,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.012352882,
				"type": "LOCATION"
			},
			{
				"name": "control",
				"salience": 0.008001315,
				"type": "OTHER"
			},
			{
				"name": "control government",
				"salience": 0.007513311,
				"type": "ORGANIZATION"
			},
			{
				"name": "Article",
				"salience": 0.0065121935,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.004487718,
				"type": "WORK_OF_ART"
			},
			{
				"name": "actor",
				"salience": 0.004371501,
				"type": "PERSON"
			},
			{
				"name": "The Comedian",
				"salience": 0.0041992133,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sacrifices",
				"salience": 0.0041346443,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.003849919,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0036701642,
				"type": "PERSON"
			},
			{
				"name": "hate",
				"salience": 0.0034572042,
				"type": "OTHER"
			},
			{
				"name": "rioters",
				"salience": 0.0034137727,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.0033352498,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.0033352498,
				"type": "OTHER"
			},
			{
				"name": "business man",
				"salience": 0.0033352498,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0033352498,
				"type": "LOCATION"
			},
			{
				"name": "kind",
				"salience": 0.0031643684,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.002559072,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0025520744,
				"type": "PERSON"
			},
			{
				"name": "baseball bats",
				"salience": 0.0020621638,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Women",
				"salience": 0.0019976015,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0019976015,
				"type": "PERSON"
			},
			{
				"name": "cities",
				"salience": 0.0019030077,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0019030077,
				"type": "EVENT"
			},
			{
				"name": "town",
				"salience": 0.0018281658,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.0018010351,
				"type": "LOCATION"
			},
			{
				"name": "face",
				"salience": 0.0017582456,
				"type": "OTHER"
			},
			{
				"name": "passion project",
				"salience": 0.001631229,
				"type": "OTHER"
			},
			{
				"name": "windows",
				"salience": 0.0015877179,
				"type": "OTHER"
			},
			{
				"name": "windshields",
				"salience": 0.0015877179,
				"type": "OTHER"
			},
			{
				"name": "rioters",
				"salience": 0.0015877179,
				"type": "PERSON"
			},
			{
				"name": "landslide",
				"salience": 0.0013750385,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0013708839,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0013708839,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0013708839,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0013348071,
				"type": "EVENT"
			},
			{
				"name": "cities",
				"salience": 0.0012850239,
				"type": "LOCATION"
			},
			{
				"name": "Yahoo Here",
				"salience": 0.001235007,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Comedian",
				"salience": 0.0012332135,
				"type": "PERSON"
			},
			{
				"name": "faces",
				"salience": 0.0011872146,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0011872146,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0011872146,
				"type": "OTHER"
			},
			{
				"name": "Demonstrators",
				"salience": 0.0011586706,
				"type": "PERSON"
			},
			{
				"name": "anti-Donald Trump",
				"salience": 0.0011212687,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.001089859,
				"type": "EVENT"
			},
			{
				"name": "protesters",
				"salience": 0.0010775676,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.0010144707,
				"type": "PERSON"
			},
			{
				"name": "win",
				"salience": 0.0009766228,
				"type": "EVENT"
			},
			{
				"name": "carpet",
				"salience": 0.0009643229,
				"type": "OTHER"
			},
			{
				"name": "world premiere",
				"salience": 0.0009643229,
				"type": "EVENT"
			},
			{
				"name": "pay",
				"salience": 0.0009643229,
				"type": "OTHER"
			},
			{
				"name": "Antonio Cerio",
				"salience": 0.0009303442,
				"type": "PERSON"
			},
			{
				"name": "images",
				"salience": 0.00092834415,
				"type": "WORK_OF_ART"
			},
			{
				"name": "flags",
				"salience": 0.00092834415,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.00092834415,
				"type": "OTHER"
			},
			{
				"name": "movie",
				"salience": 0.00091665174,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.00090916554,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.00081426697,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.00080092676,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0007873067,
				"type": "EVENT"
			},
			{
				"name": "outcome",
				"salience": 0.0007873067,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0007873067,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.0007873067,
				"type": "ORGANIZATION"
			},
			{
				"name": "response",
				"salience": 0.0007873067,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.00075226155,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00069716305,
				"type": "OTHER"
			},
			{
				"name": "grandparents",
				"salience": 0.00065926986,
				"type": "PERSON"
			},
			{
				"name": "Things",
				"salience": 0.00065388426,
				"type": "OTHER"
			},
			{
				"name": "refuge",
				"salience": 0.0006266692,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.00059387845,
				"type": "EVENT"
			},
			{
				"name": "idiot",
				"salience": 0.0005881747,
				"type": "OTHER"
			},
			{
				"name": "disappointment",
				"salience": 0.0005881747,
				"type": "EVENT"
			},
			{
				"name": "escape",
				"salience": 0.0005881747,
				"type": "OTHER"
			},
			{
				"name": "pig",
				"salience": 0.0005881747,
				"type": "OTHER"
			},
			{
				"name": "punk",
				"salience": 0.0005881747,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0005881747,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.0005714794,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.0004925056,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00048463113,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06cm5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raging_Bull"
				},
				"name": "Raging Bull",
				"salience": 0.00048463113,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00048463113,
				"type": "ORGANIZATION"
			},
			{
				"name": "cities",
				"salience": 0.00044305724,
				"type": "LOCATION"
			},
			{
				"name": "rant",
				"salience": 0.00042838225,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00042838225,
				"type": "OTHER"
			},
			{
				"name": "screen",
				"salience": 0.00042838225,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.00036202584,
				"type": "LOCATION"
			},
			{
				"name": "signs",
				"salience": 0.0003200025,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0003200025,
				"type": "LOCATION"
			},
			{
				"name": "streets",
				"salience": 0.0003200025,
				"type": "LOCATION"
			},
			{
				"name": "barrier",
				"salience": 0.0003200025,
				"type": "LOCATION"
			},
			{
				"name": "reference",
				"salience": 0.0003200025,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0002645638,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fft2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ferrazzano"
				},
				"name": "Ferrazzano",
				"salience": 0.0002636558,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kf0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Film_Institute"
				},
				"name": "AFI Fest",
				"salience": 0.0002636558,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kf0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Film_Institute"
				},
				"name": "American Film Institute",
				"salience": 0.0002636558,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wpbx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Megyn_Kelly"
				},
				"name": "Megyn Kelly",
				"salience": 0.0002636558,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00019694305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f2v0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami"
				},
				"name": "Miami",
				"salience": 0.00019694305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.00019694305,
				"type": "LOCATION"
			},
			{
				"name": "Your Wall Can't Stand in Our Way",
				"salience": 0.00019694305,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.00019694305,
				"type": "LOCATION"
			},
			{
				"name": "billionaire",
				"salience": 0.00012203755,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2544872-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T19:55:23.883+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article Donald Trump was willing to give up a very fulfilling life that took decades to build, so he could step up and take control of an out of control government. He and his family have already sacrificed so much because he chose to put his country first. Making sacrifices is certainly not something loudmouth liberals like Robert DeNiro are accustomed to. DeNiro was very vocal about his opposition to the wildly successful business man Donald J. Trump. He felt so strongly about his hate for Trump that made a video where he angrily stated he’d like to, “punch him in the face.” Now that Trump won the election in a landslide, DeNiro has chosen to get behind the Trump rioters who are terrorizing cities across America. Anti-Trump rioters are breaking windows, using baseball bats to smash the windshields of innocent citizens who get trapped in their hellish protests as they try to escape. Women who are taking part in the protests are being punched in the faces by men who are also taking part in the George Soros funded protests. American flags are being burned and families who are walking in major cities are being subjected to the most vile and disgusting, hateful language and images imaginable. If this is the kind of America that Robert DiNero is openly supporting? And if so, why would any American pay to see his movie,”Comedian”? \nRobert De Niro gave anti-Donald Trump protesters across the United States his backing Friday as he spoke about how “depressed” the tycoon’s win in the presidential election had made him. \nThe 73-year-old star was on the red carpet at the world premiere of his new film “The Comedian” in Los Angeles when he was asked how he was coping with Trump’s victory over Democratic rival Hillary Clinton. \n“How am I doing? I’m very depressed,” the famously laconic “Raging Bull” actor told reporters. \n“We have to just wait and see how things go and keep our eyes ever vigilant on the new government.” \nAsked if he thought the protests were an appropriate response to the outcome of Tuesday’s election, he replied: “Yes, absolutely. Things aren’t being done right.” \nDemonstrators took to the streets in Miami, Los Angeles, New York and other US cities for a third straight night on Friday. \nIn Manhattan, they held signs reading “Your Wall Can’t Stand in Our Way” — a reference to the anti-immigration barrier the billionaire has promised to build on the US border with Mexico. \nDe Niro hasn’t minced his words in his criticism of Trump, describing him as “a punk,” “a pig” and “an idiot.” \n“I’d like to punch him in the face,” he said before the election. \nEarlier in the day a town in southern Italy where De Niro’s grandparents came from offered the actor a means of escape. \n“If, after the disappointment of Trump, he wants to take refuge here, we are ready to welcome him,” said Antonio Cerio, the mayor of Ferrazzano. \n“The Comedian,” De Niro’s passion project which took him eight years to bring to the big screen, was part of this year’s program for the American Film Institute’s annual AFI Fest in Los Angeles. – Yahoo \nHere’s a clip of Trump-hater Megyn Kelly promoting DiNero’s hateful rant against Donald J. Trump:  ",
		"thread_title": "#BoycottComedian…ROBERT DENIRO Wanted “To Punch Trump In The Face”…Supports Anti-Trump Rioters…Now Wants Americans To Support His New Movie [VIDEO]",
		"title": "#BoycottComedian…ROBERT DENIRO Wanted “To Punch Trump In The Face”…Supports Anti-Trump Rioters…Now Wants Americans To Support His New Movie [VIDEO]",
		"type": "bias",
		"uuid": "162b39e6518af4e591acdd65d719b4f858596b3e"
	},
	"-KhIW6dQSvnRq5nht92P": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-13T06:02:46.689+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "John McNaughton",
				"salience": 0.22558548,
				"type": "PERSON"
			},
			{
				"name": "painting",
				"salience": 0.09247103,
				"type": "WORK_OF_ART"
			},
			{
				"name": "man",
				"salience": 0.09209511,
				"type": "PERSON"
			},
			{
				"name": "subject matter",
				"salience": 0.08612823,
				"type": "OTHER"
			},
			{
				"name": "painter",
				"salience": 0.07018699,
				"type": "PERSON"
			},
			{
				"name": "intensity",
				"salience": 0.040762488,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.040762488,
				"type": "ORGANIZATION"
			},
			{
				"name": "Presidents",
				"salience": 0.03545236,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.03177036,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.021363528,
				"type": "LOCATION"
			},
			{
				"name": "painting",
				"salience": 0.021198543,
				"type": "WORK_OF_ART"
			},
			{
				"name": "The Forgotten Man",
				"salience": 0.020155856,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.014254572,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.012999359,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01v054",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sean_Hannity"
				},
				"name": "Sean Hannity",
				"salience": 0.012172804,
				"type": "PERSON"
			},
			{
				"name": "painting",
				"salience": 0.011215038,
				"type": "WORK_OF_ART"
			},
			{
				"name": "painting",
				"salience": 0.009578384,
				"type": "WORK_OF_ART"
			},
			{
				"name": "man",
				"salience": 0.009136326,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.008827074,
				"type": "PERSON"
			},
			{
				"name": "sky",
				"salience": 0.008677386,
				"type": "LOCATION"
			},
			{
				"name": "symbolism",
				"salience": 0.008677386,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.008677386,
				"type": "OTHER"
			},
			{
				"name": "Presidents",
				"salience": 0.00842404,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0077516446,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "Presidents of the United States",
				"salience": 0.007397992,
				"type": "PERSON"
			},
			{
				"name": "direction",
				"salience": 0.0060894885,
				"type": "OTHER"
			},
			{
				"name": "hand corner",
				"salience": 0.0058626267,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0058626267,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0058626267,
				"type": "EVENT"
			},
			{
				"name": "each other",
				"salience": 0.005741687,
				"type": "PERSON"
			},
			{
				"name": "exception",
				"salience": 0.005644197,
				"type": "OTHER"
			},
			{
				"name": "painting",
				"salience": 0.005153584,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07q0tbb"
				},
				"name": "Constitution",
				"salience": 0.005047274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "accomplishments",
				"salience": 0.0049730735,
				"type": "OTHER"
			},
			{
				"name": "wind",
				"salience": 0.0049730735,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0049730735,
				"type": "OTHER"
			},
			{
				"name": "paper trash",
				"salience": 0.0049730735,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0049730735,
				"type": "OTHER"
			},
			{
				"name": "paintings",
				"salience": 0.003308246,
				"type": "WORK_OF_ART"
			},
			{
				"name": "MAN",
				"salience": 0.0031551844,
				"type": "PERSON"
			},
			{
				"name": "The Forgotten Man",
				"salience": 0.0030270861,
				"type": "WORK_OF_ART"
			},
			{
				"name": "original",
				"salience": 0.0027074541,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0023487527,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "facebook",
				"salience": 0.0022883117,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0020228243,
				"type": "OTHER"
			},
			{
				"name": "dollar bills",
				"salience": 0.0020228243,
				"type": "OTHER"
			},
			{
				"name": "foot",
				"salience": 0.0020228243,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.001245176,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2546115-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-13T06:02:46.689+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "John McNaughton is a special American painter because of his subject matter and the intensity in which he portrays our current government…troubled and corrupt. The Forgotten Man painting is amazing in its symbolism. \nHere’s how McNaughton describes the painting: \nAgainst the background of a darkening sky, all of the past Presidents of the United States gather before the White House, as if to commemorate some great event. In the left hand corner of the painting sits a man. That man, with his head bowed appears distraught and hopeless as he contemplates his future. Some of the past Presidents try to console him while looking in the direction of the modern Presidents as if to say, “What have you done?” Many of these modern Presidents, seemingly oblivious to anything other than themselves, appear to be congratulating each other on their great accomplishments. In front of the man, paper trash is blowing in the wind. Crumpled dollar bills, legislative documents, and, like a whisper—the U.S. Constitution beneath the foot of Barack Obama. \nTHE FORGOTTEN MAN… \nMcNaughton never sells his original paintings BUT he made an exception this time. He sold this painting to Sean Hannity so Hannity could give it to Donald Trump. Awesome, huh? \nNovember 9th McNaughton announced via facebook that he sold the original to Sean Hannity: \n“Sean Hannity just purchased my painting “The Forgotten Man” to give to Donald Trump to hang in the White House” \nTHE WHITE HOUSE!",
		"thread_title": "HE’S NEVER SOLD AN ORIGINAL PAINTING UNTIL NOW…And This One’s Going In The White House",
		"title": "HE’S NEVER SOLD AN ORIGINAL PAINTING UNTIL NOW…And This One’s Going In The White House",
		"type": "bias",
		"uuid": "59899b8db5916d23b121cc8cae00e623f681d474"
	},
	"-KhIW6uoA5yL7DAreQPC": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-13T06:02:47.949+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "woman",
				"salience": 0.5916173,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.09112835,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.014395147,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.012628647,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.012600434,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.012506913,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lq3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electoral_College_(United_States)"
				},
				"name": "Electoral College",
				"salience": 0.011312452,
				"type": "ORGANIZATION"
			},
			{
				"name": "activity",
				"salience": 0.011275647,
				"type": "OTHER"
			},
			{
				"name": "rapist",
				"salience": 0.011275647,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.011275647,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.008437175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.0069576562,
				"type": "LOCATION"
			},
			{
				"name": "Abby",
				"salience": 0.0069576562,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0060756216,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.005776086,
				"type": "PERSON"
			},
			{
				"name": "cockroaches",
				"salience": 0.005776086,
				"type": "OTHER"
			},
			{
				"name": "rooftops",
				"salience": 0.005776086,
				"type": "OTHER"
			},
			{
				"name": "gays",
				"salience": 0.005776086,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.005776086,
				"type": "LOCATION"
			},
			{
				"name": "server",
				"salience": 0.005776086,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.005776086,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.005776086,
				"type": "OTHER"
			},
			{
				"name": "States",
				"salience": 0.005600991,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0034292114,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.003413251,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.003413251,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.003413251,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.003413251,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0032860457,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.0029562435,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.0029562435,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0027872918,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0027518948,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.002749975,
				"type": "PERSON"
			},
			{
				"name": "Someone",
				"salience": 0.002749975,
				"type": "PERSON"
			},
			{
				"name": "term",
				"salience": 0.0026356364,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0026050154,
				"type": "LOCATION"
			},
			{
				"name": "absentee ballots",
				"salience": 0.0024139676,
				"type": "OTHER"
			},
			{
				"name": "absentee ballot",
				"salience": 0.0024139676,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.0023816414,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0023816414,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0023119648,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0022257445,
				"type": "OTHER"
			},
			{
				"name": "state margin",
				"salience": 0.0021360128,
				"type": "OTHER"
			},
			{
				"name": "headline",
				"salience": 0.0020430374,
				"type": "OTHER"
			},
			{
				"name": "breakout",
				"salience": 0.002029038,
				"type": "EVENT"
			},
			{
				"name": "chance",
				"salience": 0.0019201519,
				"type": "OTHER"
			},
			{
				"name": "vagina",
				"salience": 0.0019201519,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0018568145,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.0018037334,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0017148632,
				"type": "EVENT"
			},
			{
				"name": "difference",
				"salience": 0.0016703049,
				"type": "OTHER"
			},
			{
				"name": "election results",
				"salience": 0.0016703049,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0016079899,
				"type": "OTHER"
			},
			{
				"name": "brilliance",
				"salience": 0.0016079899,
				"type": "OTHER"
			},
			{
				"name": "Fathers",
				"salience": 0.0016079899,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.0016079899,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0015892963,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0015333861,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0015172535,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0288jd7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maine_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0014664244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0014664244,
				"type": "PERSON"
			},
			{
				"name": "importance",
				"salience": 0.0014410716,
				"type": "OTHER"
			},
			{
				"name": "Farmers",
				"salience": 0.0014346377,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.0013637108,
				"type": "ORGANIZATION"
			},
			{
				"name": "murder",
				"salience": 0.0013637108,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0013637108,
				"type": "OTHER"
			},
			{
				"name": "Students",
				"salience": 0.0013637108,
				"type": "PERSON"
			},
			{
				"name": "trips",
				"salience": 0.0013637108,
				"type": "EVENT"
			},
			{
				"name": "businesspeople",
				"salience": 0.0013637108,
				"type": "PERSON"
			},
			{
				"name": "absentee ballots",
				"salience": 0.0012331996,
				"type": "OTHER"
			},
			{
				"name": "shore",
				"salience": 0.0011765234,
				"type": "LOCATION"
			},
			{
				"name": "importers",
				"salience": 0.0011765234,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0011765234,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0011576494,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0011576494,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.0011335401,
				"type": "OTHER"
			},
			{
				"name": "say",
				"salience": 0.0011133543,
				"type": "OTHER"
			},
			{
				"name": "execs",
				"salience": 0.0010188035,
				"type": "PERSON"
			},
			{
				"name": "regions",
				"salience": 0.0010188035,
				"type": "LOCATION"
			},
			{
				"name": "voting proclivities",
				"salience": 0.0010188035,
				"type": "OTHER"
			},
			{
				"name": "variances",
				"salience": 0.0010188035,
				"type": "OTHER"
			},
			{
				"name": "Thank G-d",
				"salience": 0.0010188035,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.0010188035,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.0010188035,
				"type": "OTHER"
			},
			{
				"name": "exporters",
				"salience": 0.0010188035,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0009898859,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07pcbmd"
				},
				"name": "Founding",
				"salience": 0.0009898859,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.0009815787,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00095622113,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05fv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Gore"
				},
				"name": "Al Gore",
				"salience": 0.0009536276,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "N.Y.",
				"salience": 0.0009536276,
				"type": "LOCATION"
			},
			{
				"name": "Article",
				"salience": 0.00094907195,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Article",
				"salience": 0.00094907195,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Shortcomings",
				"salience": 0.00085692346,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.00085692346,
				"type": "LOCATION"
			},
			{
				"name": "Account Comment",
				"salience": 0.00085692346,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Account",
				"salience": 0.00085692346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.000834976,
				"type": "LOCATION"
			},
			{
				"name": "factory workers",
				"salience": 0.0007420277,
				"type": "PERSON"
			},
			{
				"name": "voting preferences",
				"salience": 0.0007420277,
				"type": "OTHER"
			},
			{
				"name": "vice versa",
				"salience": 0.0007420277,
				"type": "PERSON"
			},
			{
				"name": "margin",
				"salience": 0.00070898735,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0007053275,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0006945503,
				"type": "OTHER"
			},
			{
				"name": "Times",
				"salience": 0.0006734499,
				"type": "OTHER"
			},
			{
				"name": "breakout",
				"salience": 0.0006401401,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/015pgg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Madison_Avenue"
				},
				"name": "Madison Ave.",
				"salience": 0.00062709034,
				"type": "LOCATION"
			},
			{
				"name": "victory",
				"salience": 0.0005543003,
				"type": "EVENT"
			},
			{
				"name": "yields",
				"salience": 0.0005543003,
				"type": "OTHER"
			},
			{
				"name": "vote advantage",
				"salience": 0.0005543003,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "D",
				"salience": 0.00045669966,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07h34",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tennessee"
				},
				"name": "Tennessee",
				"salience": 0.00045669966,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01bncw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_Nightly_News"
				},
				"name": "NBC Nightly News",
				"salience": 0.0003411426,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "Bush",
				"salience": 0.0003411426,
				"type": "PERSON"
			},
			{
				"name": "American Thinker Comment",
				"salience": 0.00023421517,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2546106-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-13T06:02:47.949+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article Dear Abby, I supported a woman I knew had a history of criminal activity, who is married to a rapist and who left 4 men to die in Benghazi. She put our national security at grave risk by leaving top classified emails on her private server, and she took money from nations who throw gays off rooftops and treat women worse than cockroaches. She is likely very sick and would be unlikely to serve out her first term without someone there to prop her up, but nevertheless, I supported her anyhow, because she’s a Democrat and has a vagina. Someone told me she still has a chance of winning the presidency if I just signed a petition. They said that Trump really didn’t win, because Hillary won the popular vote. Is that true? \nOkay, let’s address this “Hillary might win the popular vote, isn’t that Electoral College situation just awful” thing head on. \nNo, it’s not awful. It’s great, and it protects the importance of your vote. It’s also uniquely American and demonstrates yet again the once-in-creation brilliance of the Founding Fathers. \nFirst of all, she’s probably not going to win the actual number of votes cast. She may win the number of votes counted, but not the votes cast. \nStates don’t count their absentee ballots unless the number of outstanding absentee ballots is larger than the state margin of difference. If there is a margin of 1,000 votes counted and there are 1,300 absentee ballots outstanding, then the state tabulates those. If the number of outstanding absentee ballots wouldn’t influence the election results, then the absentee ballots aren’t counted. \nWho votes by absentee ballot? Students overseas, the military, businesspeople on trips, etc. The historical breakout for absentee ballots is about 67-33% Republican. In 2000, when Al Gore “won” the popular vote nationally by 500,000 votes and the liberal media screamed bloody murder, there were 2 million absentee ballots in California alone. A 67-33 breakout of those yields a 1.33- to 0.667-million Republican vote advantage, so Bush would have gotten a 667,000-vote margin from California’s uncounted absentee ballots alone! So much for Gore’s 500,000 popular vote “victory.” (That was the headline on the N.Y. Times, and it was the lead story on NBC Nightly News, right? No? You’re kidding.) \nGetting back to the “win the popular vote/lose the Electoral College” scenario: Thank G-d we have that, or else California and N.Y. would determine every election. Every time. \nBut the Electoral College brilliantly smooths out the variances in the voting proclivities among states and regions. Farmers in the middle of the country and importers and exporters on the shore get roughly equal say, as do Madison Ave. execs and factory workers in Tennessee. \nShortcomings? Sure. The E.C. can make an R vote meaningless in a very few heavily D states or vice versa. But without the Electoral College, the country’s entire population is subject to the disproportionate voting preferences of the few most populous states. – American Thinker Comment on this Article Via Your Facebook Account Comment on this Article Via Your Disqus Account Follow Us on Facebook!",
		"thread_title": "SORRY LIBERALS…You Can Stop With The Petitions…Hillary Did NOT Win The Popular Vote",
		"title": "SORRY LIBERALS…You Can Stop With The Petitions…Hillary Did NOT Win The Popular Vote",
		"type": "bias",
		"uuid": "1fe4c0fa4ba9e410fe5c4e7fec13c6740062629b"
	},
	"-KhIW77aQ9Us6zhJZYLz": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-13T17:06:40.624+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/024t0y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Cuban"
				},
				"name": "Mark Cuban",
				"salience": 0.37051925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.16504376,
				"type": "PERSON"
			},
			{
				"name": "secret",
				"salience": 0.08252674,
				"type": "OTHER"
			},
			{
				"name": "dislike",
				"salience": 0.05498679,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.05498679,
				"type": "OTHER"
			},
			{
				"name": "Crooked Hillary",
				"salience": 0.034158293,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "FOX News",
				"salience": 0.017567784,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuban",
				"salience": 0.016826974,
				"type": "LOCATION"
			},
			{
				"name": "mark",
				"salience": 0.016274534,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03tcrq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neil_Cavuto"
				},
				"name": "Neil Cavuto",
				"salience": 0.014360959,
				"type": "PERSON"
			},
			{
				"name": "doubt",
				"salience": 0.012864097,
				"type": "OTHER"
			},
			{
				"name": "market tanks",
				"salience": 0.011776647,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0101733375,
				"type": "OTHER"
			},
			{
				"name": "stocks",
				"salience": 0.009544051,
				"type": "OTHER"
			},
			{
				"name": "industrials",
				"salience": 0.009189081,
				"type": "OTHER"
			},
			{
				"name": "stocks",
				"salience": 0.009189081,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.008632458,
				"type": "OTHER"
			},
			{
				"name": "surge",
				"salience": 0.008268502,
				"type": "EVENT"
			},
			{
				"name": "health-care",
				"salience": 0.008268502,
				"type": "OTHER"
			},
			{
				"name": "investors",
				"salience": 0.008268502,
				"type": "PERSON"
			},
			{
				"name": "infrastructure spending policy",
				"salience": 0.008268502,
				"type": "OTHER"
			},
			{
				"name": "index",
				"salience": 0.0075193397,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dow_Jones_Industrial_Average"
				},
				"name": "Dow",
				"salience": 0.0056635393,
				"type": "OTHER"
			},
			{
				"name": "Market Watch",
				"salience": 0.0049054776,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0049054776,
				"type": "LOCATION"
			},
			{
				"name": "Dow Jones Industrial Average DJIA",
				"salience": 0.0046632513,
				"type": "ORGANIZATION"
			},
			{
				"name": "loss",
				"salience": 0.004562283,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.004247459,
				"type": "PERSON"
			},
			{
				"name": "gains",
				"salience": 0.0038210952,
				"type": "OTHER"
			},
			{
				"name": "shares",
				"salience": 0.0036786282,
				"type": "OTHER"
			},
			{
				"name": "Cheers",
				"salience": 0.0036786282,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0036786282,
				"type": "PERSON"
			},
			{
				"name": "economics",
				"salience": 0.0036786282,
				"type": "OTHER"
			},
			{
				"name": "Caterpillar Inc CAT",
				"salience": 0.0031093855,
				"type": "ORGANIZATION"
			},
			{
				"name": "PFE",
				"salience": 0.0029185172,
				"type": "ORGANIZATION"
			},
			{
				"name": "points",
				"salience": 0.0028339443,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0027487765,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gvbw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pfizer"
				},
				"name": "Pfizer Inc.",
				"salience": 0.0016922952,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/Cuban-invester.png",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-10T09:10:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.19",
		"text": "Mark Cuban has made no secret of his dislike for Trump and his love for Crooked Hillary. Watch him tell FOX News’ Neil Cavuto (at 5:38 mark), “If Donald wins, I have no doubt the market tanks!” Well, that’s not exactly what happened now is it Cuban? So here’s what really happened: \nMarket Watch – U.S. stocks rallied Wednesday, with the Dow industrials jumping 257 points, led by a surge in financial, health-care and industrial stocks, as investors bet on the infrastructure spending policy promised by President-elect Donald Trump. \nThe Dow Jones Industrial Average DJIA, +1.40% gained as much as 316 points, briefly surpassing the all-time closing high set in August. The index closed 256.95 points, or 1.4%, higher at 18,589.69, its highest level since Aug. 18. Pfizer Inc. PFE, +7.07% and Caterpillar Inc CAT, +7.70% led the gains, rallying more than 7%. Way to go Cuban…you just reminded us of how little you know about economics or choosing the right candidate for President… Hope that loss didn’t cost you too much Cuban…Cheers! 46.4K shares ",
		"thread_title": "MARK CUBAN: \"In The Event Donald Wins, I Have No Doubt The Market Tanks\"…So Here's What Really Happened [VIDEO] » 100percentfedUp.com",
		"title": "MARK CUBAN: \"In The Event Donald Wins, I Have No Doubt The Market Tanks\"…So Here's What Really Happened [VIDEO] » 100percentfedUp.com",
		"type": "bias",
		"uuid": "124c5aa1e29aa1e27a2ad9284400243ee5a150e6"
	},
	"-KhIW7CG2u5FDAfBqJ3_": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-14T08:35:23.027+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "David Wilcox",
				"salience": 0.8367289,
				"type": "PERSON"
			},
			{
				"name": "mob",
				"salience": 0.0561672,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.0495537,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.028802432,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.016898377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.011849409,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2548928-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-14T08:35:23.027+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "David Wilcox, a 49 year old Chicago man who was brutally beaten by a mob of black Democrats asks, “What happened to America?” Here is his very sad story:  ",
		"thread_title": "TRUMP SUPPORTER Whose Brutal Beating By Black Mob Was Caught On Video Asks: “What Happened To America?” [VIDEO]",
		"title": "TRUMP SUPPORTER Whose Brutal Beating By Black Mob Was Caught On Video Asks: “What Happened To America?” [VIDEO]",
		"type": "bias",
		"uuid": "bb6352cab853dfeaf11d29a08cd5b1d0baf424a3"
	},
	"-KhIW7HW3JkovbP3fFaX": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-15T09:43:45.343+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0g7xct9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ami_Horowitz"
				},
				"name": "Ami Horowitz",
				"salience": 0.21114886,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.1396884,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.12413222,
				"type": "WORK_OF_ART"
			},
			{
				"name": "streets",
				"salience": 0.12413222,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "CA",
				"salience": 0.10588984,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01jr6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Berkeley,_California"
				},
				"name": "Berkeley",
				"salience": 0.07258759,
				"type": "LOCATION"
			},
			{
				"name": "voter ID laws",
				"salience": 0.04574381,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.026080362,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.025513677,
				"type": "OTHER"
			},
			{
				"name": "voter ID laws",
				"salience": 0.0244951,
				"type": "OTHER"
			},
			{
				"name": "voter ID laws",
				"salience": 0.023888014,
				"type": "OTHER"
			},
			{
				"name": "responses",
				"salience": 0.020699292,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0149994865,
				"type": "PERSON"
			},
			{
				"name": "generalizations",
				"salience": 0.01174313,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.008563768,
				"type": "PERSON"
			},
			{
				"name": "reply",
				"salience": 0.0064027156,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0064027156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f94t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harlem"
				},
				"name": "Harlem",
				"salience": 0.0039443946,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "NY",
				"salience": 0.0039443946,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2553918-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-15T09:43:45.343+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article Filmmaker Ami Horowitz takes to the streets in Berkeley, CA to ask white liberals how they feel about voter ID laws? Do voter ID laws suppress the black vote? Are voter ID laws racist? Watch the stunning (and very telling) responses these elitist liberals give to Horowitz. Next, watch how black citizens in Harlem, NY reply to the racist generalizations made by white liberals in Berkeley, CA. Tell us again who the real racists are? Wow!  ",
		"thread_title": "WOW! WHITE Liberals Suggest Blacks Are Too Stupid To Get ID’s…Can’t Figure Out How To Use Internet [VIDEO]",
		"title": "WOW! WHITE Liberals Suggest Blacks Are Too Stupid To Get ID’s…Can’t Figure Out How To Use Internet [VIDEO]",
		"type": "bias",
		"uuid": "ee8e9d4d80c9b05f5a049f6687be1cf8a90cdc34"
	},
	"-KhIW8XJcW6jzgliOWzl": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-20T03:53:12.132+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0105mnnv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amal_Clooney"
				},
				"name": "Amal Clooney",
				"salience": 0.45165268,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.30383947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.03178321,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014zcr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Clooney"
				},
				"name": "George Clooney",
				"salience": 0.010755655,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.009946414,
				"type": "WORK_OF_ART"
			},
			{
				"name": "immigration policies",
				"salience": 0.009946414,
				"type": "OTHER"
			},
			{
				"name": "activist",
				"salience": 0.009946414,
				"type": "PERSON"
			},
			{
				"name": "immigration stance",
				"salience": 0.0083813565,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.007842531,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.007084897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0056952145,
				"type": "PERSON"
			},
			{
				"name": "memo",
				"salience": 0.0055681905,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pack",
				"salience": 0.005096903,
				"type": "OTHER"
			},
			{
				"name": "contenders",
				"salience": 0.005096903,
				"type": "PERSON"
			},
			{
				"name": "heap",
				"salience": 0.005096903,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.005096903,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.004630584,
				"type": "EVENT"
			},
			{
				"name": "actor husband",
				"salience": 0.004408433,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0042850142,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0031030425,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0026876712,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0026876712,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0025235896,
				"type": "ORGANIZATION"
			},
			{
				"name": "property",
				"salience": 0.0024270725,
				"type": "OTHER"
			},
			{
				"name": "confidence",
				"salience": 0.0024270725,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0024270725,
				"type": "LOCATION"
			},
			{
				"name": "border towns",
				"salience": 0.0024270725,
				"type": "LOCATION"
			},
			{
				"name": "picture",
				"salience": 0.0022969032,
				"type": "OTHER"
			},
			{
				"name": "walls",
				"salience": 0.0021559643,
				"type": "OTHER"
			},
			{
				"name": "ranchers",
				"salience": 0.0021020367,
				"type": "PERSON"
			},
			{
				"name": "Aliens",
				"salience": 0.0021020367,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0020586404,
				"type": "OTHER"
			},
			{
				"name": "violations",
				"salience": 0.002032729,
				"type": "EVENT"
			},
			{
				"name": "husband",
				"salience": 0.0019079756,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0018852733,
				"type": "OTHER"
			},
			{
				"name": "test",
				"salience": 0.0018286275,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.0018286275,
				"type": "OTHER"
			},
			{
				"name": "violations",
				"salience": 0.0018137007,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0017939231,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.0017023716,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0016523674,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0016388776,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0016388776,
				"type": "PERSON"
			},
			{
				"name": "proposals",
				"salience": 0.0016388776,
				"type": "OTHER"
			},
			{
				"name": "border towns",
				"salience": 0.0016388776,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0016388776,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0015978676,
				"type": "OTHER"
			},
			{
				"name": "standing",
				"salience": 0.0015393408,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.001493077,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.001474276,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.001474276,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.001474276,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.001474276,
				"type": "EVENT"
			},
			{
				"name": "real estate mogul",
				"salience": 0.001474276,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.001474276,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.001474276,
				"type": "PERSON"
			},
			{
				"name": "reputation",
				"salience": 0.0014622383,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.0014192797,
				"type": "LOCATION"
			},
			{
				"name": "citizens",
				"salience": 0.0014192797,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0013899636,
				"type": "OTHER"
			},
			{
				"name": "human rights law",
				"salience": 0.0013899636,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0013899636,
				"type": "LOCATION"
			},
			{
				"name": "safety",
				"salience": 0.0013491261,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0013281093,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0013281093,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0012719637,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0012090849,
				"type": "PERSON"
			},
			{
				"name": "risk",
				"salience": 0.0012036869,
				"type": "OTHER"
			},
			{
				"name": "human rights record",
				"salience": 0.0012036869,
				"type": "OTHER"
			},
			{
				"name": "standing",
				"salience": 0.0010861757,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.001065886,
				"type": "OTHER"
			},
			{
				"name": "Texas Conference For Women",
				"salience": 0.0010090058,
				"type": "ORGANIZATION"
			},
			{
				"name": "US -Mexican",
				"salience": 0.0010090058,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.00089927163,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00089927163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b9c7n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austin_Convention_Center"
				},
				"name": "Austin Convention Center",
				"salience": 0.0008737484,
				"type": "LOCATION"
			},
			{
				"name": "shutdown",
				"salience": 0.00065498,
				"type": "EVENT"
			},
			{
				"name": "jihad",
				"salience": 0.00065498,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.00065498,
				"type": "WORK_OF_ART"
			},
			{
				"name": "way",
				"salience": 0.00065498,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00065498,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00065498,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0005650485,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0005650485,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0005650485,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005018495,
				"type": "PERSON"
			},
			{
				"name": "sovereignty",
				"salience": 0.00048928073,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00048928073,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexicans",
				"salience": 0.00046556295,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.0004031311,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.00034777002,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03cg25",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hollywood_Reporter"
				},
				"name": "Hollywood Reporter",
				"salience": 0.00030113044,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2574659-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-20T03:53:12.132+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article \nPolitical activist and Hillary supporter Amal Clooney traveled to Texas to warn Americans about our elected President Donald J. Trump and his tough immigration policies. Maybe she didn’t get the memo…Trump’s tough immigration stance is what catapulted him to the top of the heap in the crowded pack of GOP primary contenders. It wasn’t too long ago that her arrogant liberal husband announced with great confidence, “There will never be a President Trump”. \nPerhaps Amal should’ve traveled to some of the border towns if she wanted to get a clear picture of how illegal immigration is affecting our nation. Aliens crossing our borders illegally have destroyed the property of American ranchers, and threatened the safety and security of American citizens living in homes in or near the US -Mexican border towns… \nAmal Clooney has warned that many of president-elect Trump’s proposals would be ‘violations of international law.’ \nSpeaking at the Texas Conference For Women at the Austin Convention Center on Tuesday, the international human rights lawyer, and wife of George Clooney, said she had concerns about America’s reputation under the real estate mogul’s plans. \nShe noted that Trump’s comments during his campaign, ‘that there should be a religious test imposed on entering the U.S. or the fact that there should be state-sponsored torture or that families of suspected terrorists should all be killed — all of those things are violations of international human rights law and the values that underlie that.’ \nThe 38-year-old wife said America’s reputation as a country with a strong human rights record and high moral standing was at risk. \n‘I think there’s some concern from abroad as to, “Are these things actually going to happen?”, or is the U.S. going to lose some of the moral standing that it has internationally,’ according to the Hollywood Reporter. \nPerhaps its time to put our nation’s security and sovereignty before we worry about what people in other countries around the world think of us… \nBoth Amal and her Hollywood actor husband George, a staunch Hillary Clinton supporter, have spoken out against Trump in the past. \nEarlier this year, Amal Clooney called for Trump to be challenged on his extreme views. \nWatch George Clooney here whine about press giving Trump too much favorable press: \n‘When you listen to what the leading candidate on the Republican side has been saying about building walls, about excluding Mexicans and a complete shutdown of all Muslims entering in, and if you actually look at what he specifically said in that now infamous speech about Muslims, he kept saying, ‘They only want jihad. They don’t believe in our way of life. They don’t respect our system,” Clooney said. Via: Daily Mail  ",
		"thread_title": "LOL! BRITISH WIFE Of LIB ACTOR Who Said: “There Will Never Be A President Donald Trump”…Warns Americans About President-Elect Trump [VIDEO]",
		"title": "LOL! BRITISH WIFE Of LIB ACTOR Who Said: “There Will Never Be A President Donald Trump”…Warns Americans About President-Elect Trump [VIDEO]",
		"type": "bias",
		"uuid": "3836cd38353373b7d934a7e25e5888876958f94a"
	},
	"-KhIW8hudW5-Vzm1S2BV": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-20T06:44:12.111+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "interview",
				"salience": 0.2293758,
				"type": "EVENT"
			},
			{
				"name": "Article",
				"salience": 0.2293758,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Rafael Salamanca",
				"salience": 0.14661618,
				"type": "PERSON"
			},
			{
				"name": "throw",
				"salience": 0.08646772,
				"type": "EVENT"
			},
			{
				"name": "councilman",
				"salience": 0.076018296,
				"type": "PERSON"
			},
			{
				"name": "proportions",
				"salience": 0.068482496,
				"type": "OTHER"
			},
			{
				"name": "Tucker Carlson Tonight",
				"salience": 0.06260747,
				"type": "ORGANIZATION"
			},
			{
				"name": "Reality",
				"salience": 0.03681558,
				"type": "OTHER"
			},
			{
				"name": "talking points",
				"salience": 0.030138196,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.018007891,
				"type": "OTHER"
			},
			{
				"name": "Trucker Carlson",
				"salience": 0.016094577,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2574911-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-20T06:44:12.111+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article Rafael Salamanca’s interview on “Tucker Carlson Tonight” was a major throw down of epic proportions. Reality hit this councilman and he just kept repeating the same talking points. If you want to go up against the brilliant Trucker Carlson then you need to have your facts straight.",
		"thread_title": "EPIC! TUCKER CARLSON Demolishes NYC Councilman Over Sanctuary Cities [Video]",
		"title": "EPIC! TUCKER CARLSON Demolishes NYC Councilman Over Sanctuary Cities [Video]",
		"type": "bias",
		"uuid": "80da68b7ce6ee3c4e5d9a583abac77828606c2bb"
	},
	"-KhIW8vC5kv8DDSIjXci": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-21T03:35:20.047+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "Article",
				"salience": 0.31478325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.17198598,
				"type": "EVENT"
			},
			{
				"name": "The Bubble",
				"salience": 0.16155013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "life",
				"salience": 0.15638244,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.04695685,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.042328887,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Account",
				"salience": 0.02869658,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.023305282,
				"type": "OTHER"
			},
			{
				"name": "Comment",
				"salience": 0.020959703,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Article",
				"salience": 0.017363787,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Account Comment",
				"salience": 0.01568712,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2577115-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-21T03:35:20.047+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article In The Bubble, life continues for progressive Americans as if the election never happened… Comment on this Article Via Your Facebook Account Comment on this Article Via Your Disqus Account Follow Us on Facebook!",
		"thread_title": "FUNNY! SNL’S SOLUTION To Democrat Election Denial: “Safe Space For Everyone” [Video]",
		"title": "FUNNY! SNL’S SOLUTION To Democrat Election Denial: “Safe Space For Everyone” [Video]",
		"type": "bias",
		"uuid": "de3862589a93552123e525fac783021a5fe929e2"
	},
	"-KhIW9ASUxAHZENHXUqj": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-22T08:17:53.961+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "TV execs",
				"salience": 0.08180926,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.075185716,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0709037,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_ss2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeff_Zucker"
				},
				"name": "Jeff Zucker",
				"salience": 0.06821872,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.044970155,
				"type": "ORGANIZATION"
			},
			{
				"name": "source",
				"salience": 0.042208076,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0brnz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Martha_Raddatz"
				},
				"name": "Martha Raddatz",
				"salience": 0.03721875,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.033459544,
				"type": "ORGANIZATION"
			},
			{
				"name": "liars",
				"salience": 0.02882176,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.027028333,
				"type": "LOCATION"
			},
			{
				"name": "Article",
				"salience": 0.023584396,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sources",
				"salience": 0.019722475,
				"type": "PERSON"
			},
			{
				"name": "network",
				"salience": 0.018813746,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.01781637,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.017166238,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.013044159,
				"type": "EVENT"
			},
			{
				"name": "encounter",
				"salience": 0.012079586,
				"type": "EVENT"
			},
			{
				"name": "shots",
				"salience": 0.012079586,
				"type": "OTHER"
			},
			{
				"name": "sitdown",
				"salience": 0.012079586,
				"type": "EVENT"
			},
			{
				"name": "ing firing squad",
				"salience": 0.012079586,
				"type": "ORGANIZATION"
			},
			{
				"name": "correspondent",
				"salience": 0.009480111,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.008747849,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0nb8zk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Katy_Tur"
				},
				"name": "Katy Tur",
				"salience": 0.008712742,
				"type": "PERSON"
			},
			{
				"name": "network correspondent",
				"salience": 0.008676518,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0085647665,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.008168919,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.008150157,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.008141966,
				"type": "PERSON"
			},
			{
				"name": "Kellyanne Conway",
				"salience": 0.008125609,
				"type": "PERSON"
			},
			{
				"name": "liar",
				"salience": 0.007833123,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_0ds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gayle_King"
				},
				"name": "Gayle",
				"salience": 0.007115377,
				"type": "PERSON"
			},
			{
				"name": "network",
				"salience": 0.006929347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04qqj8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump_Tower_(New_York_City)"
				},
				"name": "Trump Tower",
				"salience": 0.006903813,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.0065608015,
				"type": "OTHER"
			},
			{
				"name": "liar",
				"salience": 0.0065608015,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.006335366,
				"type": "EVENT"
			},
			{
				"name": "anchors",
				"salience": 0.005750578,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.005750578,
				"type": "ORGANIZATION"
			},
			{
				"name": "networks",
				"salience": 0.0052442965,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00523916,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0050663934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/076vsnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Post_(Ohio_newspaper)"
				},
				"name": "The Post",
				"salience": 0.005026495,
				"type": "ORGANIZATION"
			},
			{
				"name": "fireworks",
				"salience": 0.0049802912,
				"type": "OTHER"
			},
			{
				"name": "dressing down",
				"salience": 0.0049802912,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.004968711,
				"type": "PERSON"
			},
			{
				"name": "liars",
				"salience": 0.004965244,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.004933114,
				"type": "EVENT"
			},
			{
				"name": "reporters",
				"salience": 0.0048194123,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0047834083,
				"type": "PERSON"
			},
			{
				"name": "room",
				"salience": 0.004654273,
				"type": "LOCATION"
			},
			{
				"name": "board room",
				"salience": 0.004654273,
				"type": "LOCATION"
			},
			{
				"name": "everyone",
				"salience": 0.004300022,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0042649144,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.004033215,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0038827613,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0036743653,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.003644361,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.003644361,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0034961621,
				"type": "EVENT"
			},
			{
				"name": "meetings",
				"salience": 0.003323333,
				"type": "EVENT"
			},
			{
				"name": "network",
				"salience": 0.003323333,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.003323333,
				"type": "EVENT"
			},
			{
				"name": "networks",
				"salience": 0.003323333,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.0032929617,
				"type": "ORGANIZATION"
			},
			{
				"name": "word",
				"salience": 0.0031161932,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0029009313,
				"type": "OTHER"
			},
			{
				"name": "living",
				"salience": 0.0028516003,
				"type": "OTHER"
			},
			{
				"name": "edgewise",
				"salience": 0.0028516003,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0027357736,
				"type": "PERSON"
			},
			{
				"name": "executives",
				"salience": 0.0027246699,
				"type": "PERSON"
			},
			{
				"name": "execs",
				"salience": 0.0027246699,
				"type": "PERSON"
			},
			{
				"name": "record",
				"salience": 0.0024601677,
				"type": "OTHER"
			},
			{
				"name": "session",
				"salience": 0.0022129514,
				"type": "EVENT"
			},
			{
				"name": "attendees",
				"salience": 0.0021303585,
				"type": "PERSON"
			},
			{
				"name": "lobby",
				"salience": 0.0021303585,
				"type": "LOCATION"
			},
			{
				"name": "cable news channels",
				"salience": 0.0021303585,
				"type": "OTHER"
			},
			{
				"name": "gaggle",
				"salience": 0.0021303585,
				"type": "EVENT"
			},
			{
				"name": "conversations",
				"salience": 0.0021303585,
				"type": "EVENT"
			},
			{
				"name": "substance",
				"salience": 0.0021303585,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0021303585,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cs0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/King_(chess)"
				},
				"name": "King",
				"salience": 0.0020271125,
				"type": "PERSON"
			},
			{
				"name": "CBS Good Morning",
				"salience": 0.0017553291,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "DC",
				"salience": 0.0017553291,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0017172643,
				"type": "PERSON"
			},
			{
				"name": "sampling",
				"salience": 0.0017172643,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0017120709,
				"type": "OTHER"
			},
			{
				"name": "news anchors",
				"salience": 0.0016396554,
				"type": "PERSON"
			},
			{
				"name": "gathering",
				"salience": 0.0015914531,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0013222137,
				"type": "ORGANIZATION"
			},
			{
				"name": "something",
				"salience": 0.0011590495,
				"type": "OTHER"
			},
			{
				"name": "news empire",
				"salience": 0.0011590495,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.0011590495,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.0011590495,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0011590495,
				"type": "EVENT"
			},
			{
				"name": "campaign trail",
				"salience": 0.0011590495,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04syw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monarch"
				},
				"name": "King",
				"salience": 0.0011028621,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09d5h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS"
				},
				"name": "CBS",
				"salience": 0.0011028621,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.0010340202,
				"type": "PERSON"
			},
			{
				"name": "reporters",
				"salience": 0.0010005813,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fg6cv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Muir"
				},
				"name": "David Muir",
				"salience": 0.0009556516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g12y5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chuck_Todd"
				},
				"name": "Chuck Todd",
				"salience": 0.0009556516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dkg24",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Erin_Burnett"
				},
				"name": "Erin Burnett",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.0009549626,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02x6ptd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phil_Griffin"
				},
				"name": "Phil Griffin",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"name": "Suzanne Scott",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"name": "Jay Wallace",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"name": "Jack Abernethy",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"name": "Bill Shine",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019rqj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania_Station_(New_York_City)"
				},
				"name": "NYP",
				"salience": 0.0009549626,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Isham",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02919h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charlie_Rose"
				},
				"name": "Charlie Rose",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"name": "Norah O'Donnell John Dickerson",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027j7l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Stephanopoulos"
				},
				"name": "George Stephanopoulos",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0009549626,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k2cjhd"
				},
				"name": "James Goldston",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06jvj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lester_Holt"
				},
				"name": "Lester Holt",
				"salience": 0.0009549626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "NYC",
				"salience": 0.0007133296,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jkzb24",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deborah_Turness"
				},
				"name": "Deborah Turness",
				"salience": 0.00048755456,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2582326-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-22T08:17:53.961+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article \nThey had to know they had it coming… \nDonald Trump scolded media big shots during an off-the-record Trump Tower sitdown on Monday, sources told The Post. \n“It was like a f–ing firing squad,” one source said of the encounter. \n“Trump started with [CNN chief] Jeff Zucker and said ‘I hate your network, everyone at CNN is a liar and you should be ashamed,’ ” the source said. \n“The meeting was a total disaster. The TV execs and anchors went in there thinking they would be discussing the access they would get to the Trump administration, but instead they got a Trump-style dressing down,” the source added. \nA second source confirmed the fireworks. \n“The meeting took place in a big board room and there were about 30 or 40 people, including the big news anchors from all the networks,” the other source said. \n“Trump kept saying, ‘We’re in a room of liars, the deceitful dishonest media who got it all wrong.’ He addressed everyone in the room calling the media dishonest, deceitful liars. He called out Jeff Zucker by name and said everyone at CNN was a liar, and CNN was [a] network of liars,” the source said. \n“Trump didn’t say [NBC reporter] Katy Tur by name, but talked about an NBC female correspondent who got it wrong, then he referred to a horrible network correspondent who cried when Hillary lost who hosted a debate – which was Martha Raddatz who was also in the room.” \nThe stunned reporters tried to get a word in edgewise to discuss access to a Trump Administration. \n“[CBS Good Morning co-host Gayle] King did not stand up, but asked some question, ‘How do you propose we the media work with you?’ Chuck Todd asked some pretty pointed questions. David Muir asked ‘How are you going to cope living in DC while your family is in NYC? It was a horrible meeting.” \nHere’s a sampling of Trump hitting back at the dishonest media while he was on the campaign trail. Trump did something no other presidential candidate has ever done before, he won the election in a landslide, in spite of the entire fake news empire working together to take him down: \nTrump spokeswoman Kellyanne Conway told reporters the gathering went well. \n“Excellent meetings with the top executives of the major networks,” she said during a gaggle in the lobby of Trump Tower. “Pretty unprecedented meeting we put together in two days.” \nThe meeting was off the record, meaning the participants agreed not to talk about the substance of the conversations. \nThe hour-long session included top execs from network and cable news channels. Among the attendees were NBC’s Deborah Turness, Lester Holt and Chuck Todd, ABC’s James Goldston, George Stephanopoulos, David Muir and Martha Raddatz, \nAlso, CBS’ Norah O’Donnell John Dickerson, Charlie Rose, Christopher Isham and King, Fox News’ Bill Shine, Jack Abernethy, Jay Wallace, Suzanne Scott, MSNBC’s Phil Griffin and CNN’s Jeff Zucker and Erin Burnett. -Via : NYP  ",
		"thread_title": "DONALD TRUMP Calls Meeting With Press…Dresses Down Real Fake News Networks: “Everyone at CNN is a liar and you should be ashamed”",
		"title": "DONALD TRUMP Calls Meeting With Press…Dresses Down Real Fake News Networks: “Everyone at CNN is a liar and you should be ashamed”",
		"type": "bias",
		"uuid": "c1a86b752a21196a06591d5a785fa29b14fab245"
	},
	"-KhIW9WIZ5F-yNn2LS4S": {
		"author": "Fed Up",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-22T21:34:52.034+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02q4dxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hunter_Pence"
				},
				"name": "Pence",
				"salience": 0.1380139,
				"type": "PERSON"
			},
			{
				"name": "Brandon Dixon",
				"salience": 0.09586305,
				"type": "PERSON"
			},
			{
				"name": "MEDIA",
				"salience": 0.05951826,
				"type": "OTHER"
			},
			{
				"name": "Audience members",
				"salience": 0.058530446,
				"type": "PERSON"
			},
			{
				"name": "cast",
				"salience": 0.058530446,
				"type": "PERSON"
			},
			{
				"name": "curtain call",
				"salience": 0.042483937,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.042483937,
				"type": "OTHER"
			},
			{
				"name": "theater",
				"salience": 0.042483937,
				"type": "LOCATION"
			},
			{
				"name": "Video",
				"salience": 0.042483937,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Delivers Transition Update Straight To The People",
				"salience": 0.026276784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "DONALD TRUMP",
				"salience": 0.026276784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.02610789,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02z5fcr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lin-Manuel_Miranda"
				},
				"name": "Lin-Manuel Miranda",
				"salience": 0.022433495,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012vzzgm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamilton_(musical)"
				},
				"name": "Hamilton",
				"salience": 0.02163868,
				"type": "PERSON"
			},
			{
				"name": "Seth Stewart",
				"salience": 0.015882071,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07s7zc5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Seller"
				},
				"name": "Jeffrey Seller",
				"salience": 0.01517327,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.01304857,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.012472918,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.012277733,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.011238034,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.010409744,
				"type": "PERSON"
			},
			{
				"name": "Onaodowan",
				"salience": 0.009626705,
				"type": "PERSON"
			},
			{
				"name": "director",
				"salience": 0.009017279,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.009017279,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.009017279,
				"type": "OTHER"
			},
			{
				"name": "performance",
				"salience": 0.009017279,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.0073044156,
				"type": "WORK_OF_ART"
			},
			{
				"name": "leads",
				"salience": 0.007271848,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0063265157,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0063265157,
				"type": "OTHER"
			},
			{
				"name": "behalf",
				"salience": 0.0063265157,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0063265157,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.0063265157,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0060906974,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.0060906974,
				"type": "LOCATION"
			},
			{
				"name": "administration",
				"salience": 0.0060906974,
				"type": "ORGANIZATION"
			},
			{
				"name": "sir",
				"salience": 0.0060906974,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqlqw9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_Kail"
				},
				"name": "Thomas Kail",
				"salience": 0.0055549117,
				"type": "PERSON"
			},
			{
				"name": "records",
				"salience": 0.005532387,
				"type": "OTHER"
			},
			{
				"name": "actors",
				"salience": 0.0051661176,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.0044574575,
				"type": "OTHER"
			},
			{
				"name": "input",
				"salience": 0.004437566,
				"type": "OTHER"
			},
			{
				"name": "Dixon",
				"salience": 0.0044031283,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0043310295,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0038960646,
				"type": "LOCATION"
			},
			{
				"name": "cast",
				"salience": 0.0038924725,
				"type": "PERSON"
			},
			{
				"name": "players",
				"salience": 0.0038602434,
				"type": "PERSON"
			},
			{
				"name": "Oak",
				"salience": 0.0038602434,
				"type": "OTHER"
			},
			{
				"name": "cast members",
				"salience": 0.0036534965,
				"type": "PERSON"
			},
			{
				"name": "booing",
				"salience": 0.0036232437,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0035961687,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.003488079,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0028119686,
				"type": "EVENT"
			},
			{
				"name": "clash",
				"salience": 0.0028119686,
				"type": "EVENT"
			},
			{
				"name": "record",
				"salience": 0.0026868086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08r6m9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Radar_Online"
				},
				"name": "RadarOnline",
				"salience": 0.0026302214,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0115b5j_"
				},
				"name": "James Madison",
				"salience": 0.0023765552,
				"type": "PERSON"
			},
			{
				"name": "Hercules Mulligan",
				"salience": 0.0023765552,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0021007787,
				"type": "EVENT"
			},
			{
				"name": "reelection bid",
				"salience": 0.0021007787,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.0017309685,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11c3p0scs0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Javier_Mu%C3%B1oz_(actor)"
				},
				"name": "Javier Munoz",
				"salience": 0.0012930698,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07cbs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_Jefferson"
				},
				"name": "Thomas Jefferson",
				"salience": 0.0012825038,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0011683154,
				"type": "ORGANIZATION"
			},
			{
				"name": "role",
				"salience": 0.0009816147,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://100percentfedup.com/wp-content/uploads/2016/11/HAMILTON.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-22T21:26:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0.256",
		"text": "DONALD TRUMP SKIPS MEDIA: Delivers Transition Update Straight To The People [Video] Audience members booed Pence as he entered the theater and after the cast’s curtain call, the statement was read. Cast member Brandon Dixon stopped Pence on his way out of the performance to publicly shame him in front of the audience and cast members of Hamilton. Dixon’s message was written by show creator Lin-Manuel Miranda, director, Thomas Kail and lead producer, Jeffrey Seller, according to the New York Times. ‘We, sir, we are the diverse America who are alarmed and anxious that your new administration will not protect us, our planet, our children, our parents, or defend us and uphold our inalienable rights. We truly hope that this show has inspired you to uphold our American values and to work on behalf of all of us,’ Dixon said, reading the message aloud. But cast members were able to give input. RadarOnline investigated whether or not the actors had voted and revealed many leads hadn’t in years. Dixon’s records show he didn’t vote during president Obama’s reelection bid in 2012. Javier Munoz, playing the titular role of Hamilton, registered to vote in 2006 and voted in the mid-term elections, but hasn’t been on record as voting since. \nSeth Stewart, who plays Thomas Jefferson, voted in 2008 when Obama ran for the first time. He did not vote in 2012. Okieriete “Oak” Onaodowan, who players James Madison and Hercules Mulligan, registered to vote in 2005 but hasn’t been on record voting since. Since the clash with the Hamilton cast, Pence told Fox News he wasn’t offended by the message and said the booing ‘is what freedom sounds like’. – Daily Mail \n",
		"thread_title": "OOPS! CRYBABY HAMILTON STARS Who Lectured Pence Haven't Voted In Years [VIDEO] » 100percentfedUp.com",
		"title": "OOPS! CRYBABY HAMILTON STARS Who Lectured Pence Haven't Voted In Years [VIDEO] » 100percentfedUp.com",
		"type": "bias",
		"uuid": "018d2edef81f8ac93622de17798556762119c736"
	},
	"-KhIW9ebJ2vJZmlf5Su4": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-23T01:48:30.528+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.36547023,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.21739732,
				"type": "ORGANIZATION"
			},
			{
				"name": "narrative",
				"salience": 0.13278896,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.07489549,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.05132843,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.05132843,
				"type": "WORK_OF_ART"
			},
			{
				"name": "press",
				"salience": 0.014753832,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0118424,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.009631121,
				"type": "ORGANIZATION"
			},
			{
				"name": "difference",
				"salience": 0.009461887,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.009037173,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.007832528,
				"type": "EVENT"
			},
			{
				"name": "news",
				"salience": 0.007832528,
				"type": "OTHER"
			},
			{
				"name": "celebration",
				"salience": 0.007832528,
				"type": "EVENT"
			},
			{
				"name": "supporters",
				"salience": 0.0064009773,
				"type": "PERSON"
			},
			{
				"name": "church",
				"salience": 0.0047872365,
				"type": "LOCATION"
			},
			{
				"name": "20years",
				"salience": 0.0047872365,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0047271135,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f69h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neo-Nazism"
				},
				"name": "neo-Nazi",
				"salience": 0.004651779,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0016064096,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01hk__",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Black_Panther_Party"
				},
				"name": "New Black Panthers",
				"salience": 0.0016064096,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2586035-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-23T01:48:30.528+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article The left is shameful in their latest effort to create a false narrative that Donald Trump is supportive of racist groups. A full-court-press has been going on all day after a neo-Nazi/alt-right group held a celebration of Trump’s victory. The left grabbed onto the news and attached it to Donald Trump and his supporters. There’s a big difference between a president like Obama who actually marched with the racist New Black Panthers and sat in a racist church for 20years and Trump who DOES NOT support racist groups and has said so! He can’t help who supports him. These people are sickening…  ",
		"thread_title": "WHITE TRUMP-BASHING LIB Reprimanded On LIVE CNN Interview For Using “N-Word” [VIDEO]",
		"title": "WHITE TRUMP-BASHING LIB Reprimanded On LIVE CNN Interview For Using “N-Word” [VIDEO]",
		"type": "bias",
		"uuid": "2459f5d2ecfe04bfe96d6d75e92f948004edf67a"
	},
	"-KhIW9lC0jjIeKdiaVQn": {
		"author": "Barracuda Brigade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-24T01:18:15.204+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "Kellyanne Conway",
				"salience": 0.6046508,
				"type": "PERSON"
			},
			{
				"name": "BOOM",
				"salience": 0.117896944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/074lfh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Cuomo"
				},
				"name": "Chris Cuomo",
				"salience": 0.07846692,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.03872401,
				"type": "ORGANIZATION"
			},
			{
				"name": "THIS",
				"salience": 0.03346661,
				"type": "OTHER"
			},
			{
				"name": "cookie",
				"salience": 0.019543272,
				"type": "OTHER"
			},
			{
				"name": "comebacks",
				"salience": 0.018353948,
				"type": "OTHER"
			},
			{
				"name": "WOMAN",
				"salience": 0.017675046,
				"type": "PERSON"
			},
			{
				"name": "twitter scrap",
				"salience": 0.017021025,
				"type": "OTHER"
			},
			{
				"name": "Cuomo Barracuda Brigade",
				"salience": 0.016131068,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03pzf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamilton,_Ontario"
				},
				"name": "Hamilton",
				"salience": 0.006929033,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.006929033,
				"type": "PERSON"
			},
			{
				"name": "concern",
				"salience": 0.0061271177,
				"type": "OTHER"
			},
			{
				"name": "tweeting",
				"salience": 0.0061271177,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0061271177,
				"type": "PERSON"
			},
			{
				"name": "https://t.co/11UIp8cKFi https://t.co/vnk4rOhY4m",
				"salience": 0.005830933,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://bb4sp.com/wp-content/uploads/2016/11/Fullscreen-capture-11232016-85104-AM.bmp.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-23T21:54:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "BOOM! Kellyanne Conway Shuts Down CNN’s Cuomo Barracuda Brigade 2016-11-23 THIS IS WHY WE LOVE THIS WOMAN! Kellyanne Conway is one smart cookie and is so quick with comebacks. Watch her shut down Chris Cuomo on his faux concern about “my president” tweeting: Kellyanne Conway defends Trump’s ‘Hamilton’ twitter scrap: ‘Why do you care’ https://t.co/11UIp8cKFi https://t.co/vnk4rOhY4m",
		"thread_title": "BOOM! Kellyanne Conway Shuts Down CNN’s Cuomo",
		"title": "BOOM! Kellyanne Conway Shuts Down CNN’s Cuomo",
		"type": "bias",
		"uuid": "5c96dddf3e19affb7386519985180b9e086bea93"
	},
	"-KhIW9uL_6KDPSg7zwH8": {
		"author": "Barracuda Brigade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-24T01:18:23.263+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "Assimilation",
				"salience": 0.31287974,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.15780623,
				"type": "PERSON"
			},
			{
				"name": "Muslims",
				"salience": 0.074631825,
				"type": "PERSON"
			},
			{
				"name": "SHARIA",
				"salience": 0.07305603,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.033750456,
				"type": "PERSON"
			},
			{
				"name": "Print",
				"salience": 0.02969839,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.026883427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fpzwf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minneapolis"
				},
				"name": "Minneapolis",
				"salience": 0.023930022,
				"type": "LOCATION"
			},
			{
				"name": "Terrorists Barracuda Brigade",
				"salience": 0.018362911,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.017694868,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.017576262,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somali",
				"salience": 0.014833102,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.012309059,
				"type": "OTHER"
			},
			{
				"name": "Isolation",
				"salience": 0.012309059,
				"type": "OTHER"
			},
			{
				"name": "100percentfedUp",
				"salience": 0.012309059,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.012309059,
				"type": "LOCATION"
			},
			{
				"name": "promise",
				"salience": 0.012309059,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.010849068,
				"type": "OTHER"
			},
			{
				"name": "Sharia law",
				"salience": 0.01063312,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.010057211,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0096043,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0096043,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.009022482,
				"type": "OTHER"
			},
			{
				"name": "Sharia law",
				"salience": 0.009022482,
				"type": "OTHER"
			},
			{
				"name": "recruitment",
				"salience": 0.008320435,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.008148969,
				"type": "LOCATION"
			},
			{
				"name": "Pete Hegseth",
				"salience": 0.0075895595,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.0067454954,
				"type": "OTHER"
			},
			{
				"name": "LOWDOWN",
				"salience": 0.0056928345,
				"type": "EVENT"
			},
			{
				"name": "Little Mogadishu",
				"salience": 0.0053254045,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0052764905,
				"type": "OTHER"
			},
			{
				"name": "HAPPENING",
				"salience": 0.004952845,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.004348831,
				"type": "OTHER"
			},
			{
				"name": "TOWN",
				"salience": 0.0038446712,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.0033172786,
				"type": "OTHER"
			},
			{
				"name": "REFUGEE RESETTLEMENT PROGRAM EVERY AMERICAN",
				"salience": 0.002733674,
				"type": "PERSON"
			},
			{
				"name": "REFUGEE RESETTLEMENT PROGRAM",
				"salience": 0.0022619774,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://bb4sp.com/wp-content/uploads/2016/11/Fullscreen-capture-11232016-80742-AM.bmp.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-23T21:06:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "SHARIA IN AMERICA? How Minneapolis Muslims Are Still Being Recruited By Terrorists Barracuda Brigade 2016-11-23 Print I truly hope that Trump keeps his promise to keep Muslims out of our country… 100percentfedUp : Isolation of the Somali Muslim community AND teaching Sharia law in Muslim schools in Minneapolis are the two main reasons why we should still fear their recruitment to terrorism. Assimilation hasn’t happened and that’s a HUGE problem! Pete Hegseth goes to “Little Mogadishu” and finds out that many Somali Muslims don’t speak English and that they actually teach Sharia law in school but not sure about American law. This all goes back to the REFUGEE RESETTLEMENT PROGRAM and the HUGE problem with bringing over 3 million MOSTLY Muslims to the U.S. in the past 30 years. We need to take a look at defunding this program because it’s ballooned way past what it was originally intended to be. \nIS THIS HAPPENING IN YOUR TOWN? HERE’S THE LOWDOWN ON THE REFUGEE RESETTLEMENT PROGRAM EVERY AMERICAN SHOULD HEAR: Related",
		"thread_title": "SHARIA IN AMERICA? How Minneapolis Muslims Are Still Being Recruited By Terrorists",
		"title": "SHARIA IN AMERICA? How Minneapolis Muslims Are Still Being Recruited By Terrorists",
		"type": "bias",
		"uuid": "dda26496a839264abf92217d94b681ddc98dae26"
	},
	"-KhIWA3_IDeDBZUUDIPg": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-25T09:24:40.752+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.5206394,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_yglzq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_A._Clarke,_Jr"
				},
				"name": "David Clarke",
				"salience": 0.15711112,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.14234802,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0dyl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Milwaukee"
				},
				"name": "Milwaukee",
				"salience": 0.046960805,
				"type": "LOCATION"
			},
			{
				"name": "tenant",
				"salience": 0.045673676,
				"type": "PERSON"
			},
			{
				"name": "property",
				"salience": 0.022283146,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.018225959,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.018225959,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.013644133,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.007443869,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.007443869,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2593516-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-25T09:24:40.752+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article Wow! Milwaukee’s Sheriff David Clarke nails it again! “[President] Obama is like a tenant who has been evicted from a property, and he’s going to trash the place on the way out the door just out of spite. So, nothing would surprise me from Obama in these waning days.” — Sheriff David Clarke  ",
		"thread_title": "SHERIFF CLARKE On Obama’s Final Days: “Obama’s Like A Tenant Who’s Been Evicted From A Property, And He’s Gonna Trash The Place On The Way Out The Door” [VIDEO]",
		"title": "SHERIFF CLARKE On Obama’s Final Days: “Obama’s Like A Tenant Who’s Been Evicted From A Property, And He’s Gonna Trash The Place On The Way Out The Door” [VIDEO]",
		"type": "bias",
		"uuid": "3de83a29b8c501996ba153a532ee28eaf037d8b6"
	},
	"-KhIWA7zxyZB5E_CeELw": {
		"author": "EdJenner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-25T15:21:54.424+02:00",
		"domain_rank": "25689",
		"entities": [
			{
				"name": "Article",
				"salience": 0.26837233,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.22340207,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austin,_Texas"
				},
				"name": "Austin",
				"salience": 0.17556836,
				"type": "LOCATION"
			},
			{
				"name": "scene",
				"salience": 0.10533911,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.08386378,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.07680005,
				"type": "LOCATION"
			},
			{
				"name": "police officers",
				"salience": 0.03436362,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.032290705,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://conservativeangle.com/wp-content/uploads/2016/11/2593868-thumb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-25T15:21:54.424+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "100percentfedup.com",
		"spam_score": "0",
		"text": "Go to Article Austin, Texas was the scene of protest against President-elect Donald Trump and police officers. The same weekend three police officers were ambushed:  ",
		"thread_title": "ANTI-TRUMP CROWD CHANTS: “What’s Better Than 11 Dead Cops, 12 Dead Cops!”…Three Police Officers Ambushed The Same Weekend [Video]",
		"title": "ANTI-TRUMP CROWD CHANTS: “What’s Better Than 11 Dead Cops, 12 Dead Cops!”…Three Police Officers Ambushed The Same Weekend [Video]",
		"type": "bias",
		"uuid": "f4cfaff903a1ab1dd704278422a76057bbc32da4"
	},
	"-KhIWBtq9KvihYV-3eSO": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T04:15:54.459+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "media outlets",
				"salience": 0.14608416,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.106943175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0633752,
				"type": "ORGANIZATION"
			},
			{
				"name": "images",
				"salience": 0.04256767,
				"type": "WORK_OF_ART"
			},
			{
				"name": "child victims",
				"salience": 0.04256767,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.041510753,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.034524027,
				"type": "PERSON"
			},
			{
				"name": "Vanessa Beeley",
				"salience": 0.03316737,
				"type": "PERSON"
			},
			{
				"name": "level",
				"salience": 0.031470023,
				"type": "OTHER"
			},
			{
				"name": "Mother Agnes-Mariam",
				"salience": 0.030752536,
				"type": "PERSON"
			},
			{
				"name": "mortars",
				"salience": 0.029922945,
				"type": "OTHER"
			},
			{
				"name": "hell cannon",
				"salience": 0.029922945,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "snipers",
				"salience": 0.029922945,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.029922945,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.026287952,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.026287952,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.026287952,
				"type": "ORGANIZATION"
			},
			{
				"name": "information fraud",
				"salience": 0.024454838,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.024454838,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.022710463,
				"type": "LOCATION"
			},
			{
				"name": "East Aleppo",
				"salience": 0.022710463,
				"type": "LOCATION"
			},
			{
				"name": "West Aleppo",
				"salience": 0.019271845,
				"type": "LOCATION"
			},
			{
				"name": "standards",
				"salience": 0.01829033,
				"type": "OTHER"
			},
			{
				"name": "RT International",
				"salience": 0.013628314,
				"type": "ORGANIZATION"
			},
			{
				"name": "researcher",
				"salience": 0.013333489,
				"type": "PERSON"
			},
			{
				"name": "Watch",
				"salience": 0.013333489,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mainstream media",
				"salience": 0.011506501,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.011272414,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.011272414,
				"type": "LOCATION"
			},
			{
				"name": "politicians",
				"salience": 0.00996633,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.0061380267,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vznt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Samantha_Power"
				},
				"name": "Samantha Power",
				"salience": 0.0061380267,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://21stcenturywire.com/wp-content/uploads/2016/10/1-Syria-No-Fly-Zone.png",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T02:24:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.015",
		"text": "\n21st Century Wire says… \nAs western media outlets like the New York Times, Washington Post, CNN and the BBC continue to hurl viral images of ‘child victims of Aleppo,’ western and gulf-backed terrorists in East Aleppo continue to fire mortars, ‘ hell cannon ‘ and use snipers to target civilians and children in government-protected West Aleppo. The level of information fraud and propaganda being perpetrated by the western mainstream media and politicians like John Kerry and Samantha Power is unprecedented – even by traditional low US standards. \nRT International interviews Syrian peace campaigner Mother Agnes-Mariam and independent researcher and journalist Vanessa Beeley . Watch: \n. ",
		"thread_title": "‘Intl Community Still Financing, Protecting Terrorists’ – Mother Agnes, Vanessa Beeley on Syria",
		"title": "‘Intl Community Still Financing, Protecting Terrorists’ – Mother Agnes, Vanessa Beeley on Syria",
		"type": "conspiracy",
		"uuid": "98b54c302a72804005e6e3b1ff5d7a5e556f21cd"
	},
	"-KhIWCD5DIpIDLMKTx5Q": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T01:12:10.534+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.5421942,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.17610037,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.043966018,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.039771568,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.018338585,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.013878957,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.013878957,
				"type": "PERSON"
			},
			{
				"name": "computer",
				"salience": 0.0126099195,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "smoke",
				"salience": 0.009106207,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0071655777,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.006474971,
				"type": "EVENT"
			},
			{
				"name": "announcement",
				"salience": 0.006474971,
				"type": "EVENT"
			},
			{
				"name": "husband",
				"salience": 0.005612351,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.005612351,
				"type": "OTHER"
			},
			{
				"name": "email case",
				"salience": 0.005612351,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0045050117,
				"type": "ORGANIZATION"
			},
			{
				"name": "21WIRE",
				"salience": 0.0044243173,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.003975181,
				"type": "EVENT"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.0035337766,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0033181696,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0030455627,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0029790378,
				"type": "EVENT"
			},
			{
				"name": "running-up",
				"salience": 0.0028746242,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.002362556,
				"type": "PERSON"
			},
			{
				"name": "Democratic Party Machine",
				"salience": 0.002073416,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.0020001766,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle",
				"salience": 0.001996172,
				"type": "PERSON"
			},
			{
				"name": "calls",
				"salience": 0.0017884241,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0016402465,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0015150362,
				"type": "ORGANIZATION"
			},
			{
				"name": "shock announcement",
				"salience": 0.0013685019,
				"type": "EVENT"
			},
			{
				"name": "moves",
				"salience": 0.0013685019,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.0013342705,
				"type": "WORK_OF_ART"
			},
			{
				"name": "damage control",
				"salience": 0.0011851935,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.0011851935,
				"type": "OTHER"
			},
			{
				"name": "nowhere",
				"salience": 0.0011851935,
				"type": "OTHER"
			},
			{
				"name": "CIRCLES",
				"salience": 0.0011851935,
				"type": "OTHER"
			},
			{
				"name": "mirrors",
				"salience": 0.0011851935,
				"type": "OTHER"
			},
			{
				"name": "tricksters",
				"salience": 0.0011851935,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.0011851935,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0010757558,
				"type": "EVENT"
			},
			{
				"name": "Hillary Clintons",
				"salience": 0.0010460931,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0010282153,
				"type": "PERSON"
			},
			{
				"name": "specifics",
				"salience": 0.0010114395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0010101268,
				"type": "PERSON"
			},
			{
				"name": "prelude",
				"salience": 0.000992553,
				"type": "EVENT"
			},
			{
				"name": "scandal",
				"salience": 0.00095981295,
				"type": "EVENT"
			},
			{
				"name": "explosion",
				"salience": 0.00093161565,
				"type": "EVENT"
			},
			{
				"name": "distraction",
				"salience": 0.00093161565,
				"type": "OTHER"
			},
			{
				"name": "scandal",
				"salience": 0.0009240087,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00085635314,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0008311922,
				"type": "OTHER"
			},
			{
				"name": "decks",
				"salience": 0.0008311922,
				"type": "OTHER"
			},
			{
				"name": "NOTE",
				"salience": 0.0008311922,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0008311922,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.0008311922,
				"type": "OTHER"
			},
			{
				"name": "scenarios",
				"salience": 0.00080018124,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.00080018124,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00080018124,
				"type": "EVENT"
			},
			{
				"name": "issue",
				"salience": 0.00080018124,
				"type": "OTHER"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.0007953563,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.0007836507,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0007297318,
				"type": "LOCATION"
			},
			{
				"name": "dump",
				"salience": 0.0006960418,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.0006786172,
				"type": "ORGANIZATION"
			},
			{
				"name": "outrage",
				"salience": 0.0006786172,
				"type": "OTHER"
			},
			{
				"name": "confidence",
				"salience": 0.000670069,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.00065329415,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00063979573,
				"type": "OTHER"
			},
			{
				"name": "information secret",
				"salience": 0.0005854654,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.00054950424,
				"type": "EVENT"
			},
			{
				"name": "recourse",
				"salience": 0.00053335313,
				"type": "OTHER"
			},
			{
				"name": "nothing material",
				"salience": 0.00051999866,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0005116857,
				"type": "ORGANIZATION"
			},
			{
				"name": "trust",
				"salience": 0.00050697837,
				"type": "OTHER"
			},
			{
				"name": "disclosure",
				"salience": 0.00050697837,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00050697837,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00050697837,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama White House",
				"salience": 0.00049258803,
				"type": "ORGANIZATION"
			},
			{
				"name": "space",
				"salience": 0.00048805634,
				"type": "LOCATION"
			},
			{
				"name": "highlight reel",
				"salience": 0.0004758354,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.00042642184,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.00042642184,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.00041772993,
				"type": "ORGANIZATION"
			},
			{
				"name": "Clinton Foundation & Drug Cartel",
				"salience": 0.00041772993,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.00041772993,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.0004086714,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00038189554,
				"type": "ORGANIZATION"
			},
			{
				"name": "democrats",
				"salience": 0.00038189554,
				"type": "PERSON"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0003692465,
				"type": "OTHER"
			},
			{
				"name": "occasions",
				"salience": 0.0003692465,
				"type": "EVENT"
			},
			{
				"name": "any",
				"salience": 0.00035280472,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.00031854457,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.00031854457,
				"type": "OTHER"
			},
			{
				"name": "Secretary of State",
				"salience": 0.00031854457,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.00031854457,
				"type": "EVENT"
			},
			{
				"name": "Demcorats",
				"salience": 0.00031205072,
				"type": "PERSON"
			},
			{
				"name": "ass",
				"salience": 0.00030917928,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00029168837,
				"type": "OTHER"
			},
			{
				"name": "tenure",
				"salience": 0.0002758287,
				"type": "OTHER"
			},
			{
				"name": "indictment",
				"salience": 0.0002758287,
				"type": "OTHER"
			},
			{
				"name": "committee",
				"salience": 0.0002758287,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.0002758287,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congressional",
				"salience": 0.00016975716,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00016975716,
				"type": "LOCATION"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.00016975716,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://21stcenturywire.com/wp-content/uploads/2016/10/1-FBI-Comey-Hillary-Clinton-e1477728962985.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T16:20:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "\n21st Century Wire says… \n21WIRE reported on Friday about the FBI’s surprising announcement that it would be reopening the Clinton email case due to new evidence of ‘classified information’ found on sex cheat Anthony Weiner’s (newly estranged husband of Clinton chief aid Huma Abedin) computer which was subject to a seperate investigation. Will this really yield anything significant in the 10 days running-up to the Nov 8th election, or is this just clever Democrat party smoke and mirrors? It seems that Washington’s political tricksters have already sprung into action… \nAfter Comey’s shock announcement, a “leaked” memo appeared out of nowhere, supplied to Fox News , in which Comey and the FBI seem to be going through a routine set of prescribed political moves designed to implement damage control. \nELITE CIRCLES: FBI head James Comey and friend Hillary Clinton. \nCertainly, a desperate Democratic Party, and an even more desperate Obama White House (over the last 3 weeks, Obama and his wife Michelle have been out campaigning more that Hillary Clinton herself), could be pressuring or nudging the FBI on this volatile issue which could easily tilt a close presidential race against Donald Trump. Aside from the obvious potential of another Clinton scandal, yesterday’s FBI move could also be a prelude to the following possible scenarios: Protect the President, who is already deeply tied to the Clinton email cover-up Democratic Party Machine has created a distraction to cover-up latest Wikileaks dump. FBI are trying to restore lost public confidence over allegations of favoring Hillary Clintons. Create a controlled explosion this weekend to clear the decks for another salacious Trump scandal next week. \nNOTE: Despite calls from the Clinton camp for FBI to disclose what they have (which they cannot by law anyway, you’d think Hillary would have already known that), it is highly unlikely that the FBI will release any real specifics before the election – if they have anything at all. It’s just too early to tell. \nSEE ALSO: FBI James Comey was board member of HSBC – Clinton Foundation & Drug Cartel ‘bank of choice’ \nThe FBI director stoked outrage last month when he announced that he would not recommend the Justice Department seek an indictment against Clinton or any of the other parties to the investigation – allowing Clinton to dodge any criminal probe before the election – despite the fact that Comey stated to a Congressional investigative committee that Clinton was “extremely careless,” and that Clinton openly lied about her handling classified information on her unsecured private server throughout her tenure as the US Secretary of State. \nZero Hedge adds: \n“Now, it is the democrats turn to rage at Comey and the FBI, although Comey likely did not have much choice: had he kept the information secret, it certainly would have leaked as we predicted; as such his best recourse was to come clean, although many have speculated about the cryptic nature of the disclosure. Needless to say, all Comey would need to do to regain the Demcorats’ trust and favor is to announce in just a few days that nothing material has been found and that the second probe is also over.” \nHere is “leaked” (aka ‘just covering my ass) memo from FBI director James Comey: \nWatch this space. Here is a highlight reel of Hillary Clinton lying on at least 5 occasions when asked direct questions about her illegal private email server: \n. READ MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV ",
		"thread_title": "FBI Director Comey’s ‘Leaked’ Memo Explains Why He’s Reopening the Clinton Email Case",
		"title": "FBI Director Comey’s ‘Leaked’ Memo Explains Why He’s Reopening the Clinton Email Case",
		"type": "conspiracy",
		"uuid": "aff3ede5c01b6823e3bb6f96035c4df02d470d98"
	},
	"-KhIWCzS8oBvZjF0hLup": {
		"author": "Shawn Helton",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T04:16:06.492+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "Federal Bureau of Investigation",
				"salience": 0.2573207,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.15322794,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James B. Comey",
				"salience": 0.13856009,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.030263772,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.026336906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony D. Weiner",
				"salience": 0.021382747,
				"type": "PERSON"
			},
			{
				"name": "email server",
				"salience": 0.020538878,
				"type": "OTHER"
			},
			{
				"name": "PROBE",
				"salience": 0.017890705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0127xng6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Creamer_(Lobbyist)"
				},
				"name": "Robert Creamer",
				"salience": 0.015717149,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.014182099,
				"type": "PERSON"
			},
			{
				"name": "investigators",
				"salience": 0.014009042,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.011443871,
				"type": "EVENT"
			},
			{
				"name": "testimony",
				"salience": 0.00985628,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02dgtb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terry_McAuliffe"
				},
				"name": "Terry McAuliffe",
				"salience": 0.009600528,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0256nw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jan_Schakowsky"
				},
				"name": "Jan Schakowsky",
				"salience": 0.009411414,
				"type": "PERSON"
			},
			{
				"name": "email server case",
				"salience": 0.00916554,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.008259813,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0071732346,
				"type": "EVENT"
			},
			{
				"name": "21WIRE",
				"salience": 0.007151666,
				"type": "WORK_OF_ART"
			},
			{
				"name": "events",
				"salience": 0.006478945,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.0061259917,
				"type": "WORK_OF_ART"
			},
			{
				"name": "turn",
				"salience": 0.00561261,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0051642335,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0046907486,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.0042361566,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0042361566,
				"type": "OTHER"
			},
			{
				"name": "law enforcement officials",
				"salience": 0.0041946094,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0036690913,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.0036690913,
				"type": "WORK_OF_ART"
			},
			{
				"name": "testimony",
				"salience": 0.0036690913,
				"type": "EVENT"
			},
			{
				"name": "Democracy Partners",
				"salience": 0.0036509833,
				"type": "ORGANIZATION"
			},
			{
				"name": "Andrew McCabe",
				"salience": 0.0035145977,
				"type": "PERSON"
			},
			{
				"name": "material",
				"salience": 0.0033133242,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.0033133242,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0031976388,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.002869591,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.002525665,
				"type": "WORK_OF_ART"
			},
			{
				"name": "look",
				"salience": 0.002464913,
				"type": "OTHER"
			},
			{
				"name": "official",
				"salience": 0.0024432675,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.002415979,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.002415979,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.002415979,
				"type": "EVENT"
			},
			{
				"name": "details",
				"salience": 0.00240324,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0288lcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_of_Virginia"
				},
				"name": "Virginia Democratic Party",
				"salience": 0.0023098772,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0022334324,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.0020885065,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.0020751955,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.001933006,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0017712752,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01gl9g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNBC"
				},
				"name": "CNBC",
				"salience": 0.0017669497,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bill Clinton, Inc.",
				"salience": 0.001706068,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.00170519,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00170519,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.0016943198,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0016311032,
				"type": "EVENT"
			},
			{
				"name": "material",
				"salience": 0.0015889786,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0014645829,
				"type": "WORK_OF_ART"
			},
			{
				"name": "camp",
				"salience": 0.0014133726,
				"type": "EVENT"
			},
			{
				"name": "Committees",
				"salience": 0.0013647565,
				"type": "ORGANIZATION"
			},
			{
				"name": "developments",
				"salience": 0.0013647565,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0013606303,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.0013049167,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.0012591487,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0012290078,
				"type": "ORGANIZATION"
			},
			{
				"name": "email server",
				"salience": 0.0012239113,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.0012121575,
				"type": "EVENT"
			},
			{
				"name": "light",
				"salience": 0.0011818078,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0011818078,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0011818078,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.0011818078,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0011818078,
				"type": "ORGANIZATION"
			},
			{
				"name": "existence",
				"salience": 0.0011818078,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.0011818078,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0011782343,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email server",
				"salience": 0.0011782343,
				"type": "OTHER"
			},
			{
				"name": "docu-dump",
				"salience": 0.0011233676,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0010926907,
				"type": "OTHER"
			},
			{
				"name": "following",
				"salience": 0.0010678153,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0010598318,
				"type": "OTHER"
			},
			{
				"name": "camera sting operation",
				"salience": 0.0010590918,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0010334139,
				"type": "EVENT"
			},
			{
				"name": "letter",
				"salience": 0.0010202748,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Husband",
				"salience": 0.0010202748,
				"type": "PERSON"
			},
			{
				"name": "memo",
				"salience": 0.00095692964,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.00095692964,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.00095692964,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dollar deal",
				"salience": 0.00095692964,
				"type": "OTHER"
			},
			{
				"name": "hook",
				"salience": 0.00095692964,
				"type": "OTHER"
			},
			{
				"name": "recommendation",
				"salience": 0.00095692964,
				"type": "OTHER"
			},
			{
				"name": "aide",
				"salience": 0.0009212113,
				"type": "PERSON"
			},
			{
				"name": "tweet",
				"salience": 0.0008828645,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dollar business arrangement",
				"salience": 0.00087174,
				"type": "OTHER"
			},
			{
				"name": "impetus",
				"salience": 0.00087174,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.0008652217,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0008652217,
				"type": "OTHER"
			},
			{
				"name": "election campaign",
				"salience": 0.0008620026,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0008620026,
				"type": "EVENT"
			},
			{
				"name": "move",
				"salience": 0.0008391999,
				"type": "OTHER"
			},
			{
				"name": "mishandling",
				"salience": 0.00082862534,
				"type": "OTHER"
			},
			{
				"name": "home brew",
				"salience": 0.00082862534,
				"type": "OTHER"
			},
			{
				"name": "U-turn",
				"salience": 0.00082862534,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.00082862534,
				"type": "PERSON"
			},
			{
				"name": "associate",
				"salience": 0.00082185486,
				"type": "PERSON"
			},
			{
				"name": "Sexting",
				"salience": 0.00079769397,
				"type": "EVENT"
			},
			{
				"name": "computer",
				"salience": 0.00079769397,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fire",
				"salience": 0.00079769397,
				"type": "OTHER"
			},
			{
				"name": "text messages",
				"salience": 0.00079769397,
				"type": "WORK_OF_ART"
			},
			{
				"name": "girl",
				"salience": 0.00079769397,
				"type": "PERSON"
			},
			{
				"name": "revelations",
				"salience": 0.0007911761,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0007868619,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.00078120636,
				"type": "EVENT"
			},
			{
				"name": "operations",
				"salience": 0.00078120636,
				"type": "OTHER"
			},
			{
				"name": "visits",
				"salience": 0.00078120636,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0007526574,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0007526574,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0007526574,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.00074642064,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.00074642064,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meetings",
				"salience": 0.00071165396,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.0006974312,
				"type": "OTHER"
			},
			{
				"name": "separation",
				"salience": 0.00067645387,
				"type": "OTHER"
			},
			{
				"name": "agitators",
				"salience": 0.00067645387,
				"type": "PERSON"
			},
			{
				"name": "type",
				"salience": 0.00067645387,
				"type": "OTHER"
			},
			{
				"name": "grassroots level",
				"salience": 0.00067645387,
				"type": "OTHER"
			},
			{
				"name": "buffering point",
				"salience": 0.00067645387,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.00067645387,
				"type": "PERSON"
			},
			{
				"name": "allegations",
				"salience": 0.00067645387,
				"type": "OTHER"
			},
			{
				"name": "fallout",
				"salience": 0.00067645387,
				"type": "EVENT"
			},
			{
				"name": "visitor records",
				"salience": 0.00065412273,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0006463309,
				"type": "LOCATION"
			},
			{
				"name": "husband",
				"salience": 0.0006463309,
				"type": "PERSON"
			},
			{
				"name": "wife",
				"salience": 0.0006463309,
				"type": "PERSON"
			},
			{
				"name": "wife",
				"salience": 0.0006463309,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0006331686,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.00062798057,
				"type": "ORGANIZATION"
			},
			{
				"name": "probe",
				"salience": 0.00061711745,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0006020817,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0006020817,
				"type": "PERSON"
			},
			{
				"name": "official",
				"salience": 0.0006020817,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.0005958811,
				"type": "OTHER"
			},
			{
				"name": "action committee",
				"salience": 0.0005835634,
				"type": "ORGANIZATION"
			},
			{
				"name": "interviewee",
				"salience": 0.0005762089,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.0005669946,
				"type": "LOCATION"
			},
			{
				"name": "doubt",
				"salience": 0.0005452594,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0005436101,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.0005238443,
				"type": "LOCATION"
			},
			{
				"name": "Brad Jaffy",
				"salience": 0.0005099987,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0005099987,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01bncw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_Nightly_News"
				},
				"name": "NBC Nightly News",
				"salience": 0.0005099987,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0005099987,
				"type": "ORGANIZATION"
			},
			{
				"name": "email system",
				"salience": 0.00050530536,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00050530536,
				"type": "PERSON"
			},
			{
				"name": "use",
				"salience": 0.00050530536,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00050530536,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00050530536,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0004909579,
				"type": "LOCATION"
			},
			{
				"name": "field office",
				"salience": 0.0004853073,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.00047296874,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.00047296874,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.00047070853,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00046895683,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00046895683,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0004497452,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0004497452,
				"type": "PERSON"
			},
			{
				"name": "dealings",
				"salience": 0.00042499223,
				"type": "OTHER"
			},
			{
				"name": "associates",
				"salience": 0.00042499223,
				"type": "PERSON"
			},
			{
				"name": "bureau",
				"salience": 0.00042499223,
				"type": "ORGANIZATION"
			},
			{
				"name": "interviews",
				"salience": 0.00042499223,
				"type": "WORK_OF_ART"
			},
			{
				"name": "revelations",
				"salience": 0.00042499223,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00042499223,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rwtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pay_to_play"
				},
				"name": "Pay-to-Play",
				"salience": 0.00041632706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.00041632706,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07s76_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_O'Keefe"
				},
				"name": "Project Veritas",
				"salience": 0.00041632706,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.00040606444,
				"type": "OTHER"
			},
			{
				"name": "backlash",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "notes",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "email practices",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "items",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00036799477,
				"type": "OTHER"
			},
			{
				"name": "Jill McCabe",
				"salience": 0.00035914985,
				"type": "PERSON"
			},
			{
				"name": "bank fraud",
				"salience": 0.00035160495,
				"type": "OTHER"
			},
			{
				"name": "tax violations",
				"salience": 0.00035160495,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.00035160495,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00035160495,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.00034538063,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0611v_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patrick_F._Kennedy"
				},
				"name": "Patrick Kennedy",
				"salience": 0.00034444348,
				"type": "PERSON"
			},
			{
				"name": "aa campaign contribution",
				"salience": 0.0003174542,
				"type": "OTHER"
			},
			{
				"name": "video sting",
				"salience": 0.0003174542,
				"type": "EVENT"
			},
			{
				"name": "Image",
				"salience": 0.0003174542,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Image Source",
				"salience": 0.0003174542,
				"type": "OTHER"
			},
			{
				"name": "controversy",
				"salience": 0.0003174542,
				"type": "OTHER"
			},
			{
				"name": "hook",
				"salience": 0.0003174542,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00031098124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "NY Post",
				"salience": 0.00031098124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.00031098124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.00031098124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cq0r_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Undersecretary"
				},
				"name": "Undersecretary of State",
				"salience": 0.000289687,
				"type": "ORGANIZATION"
			},
			{
				"name": "deniability",
				"salience": 0.00027487683,
				"type": "OTHER"
			},
			{
				"name": "upheaval",
				"salience": 0.00027487683,
				"type": "EVENT"
			},
			{
				"name": "campaign tactics",
				"salience": 0.00027487683,
				"type": "OTHER"
			},
			{
				"name": "republic",
				"salience": 0.00027487683,
				"type": "LOCATION"
			},
			{
				"name": "PAY",
				"salience": 0.00027487683,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.00027487683,
				"type": "EVENT"
			},
			{
				"name": "discussion",
				"salience": 0.00027487683,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.00027487683,
				"type": "OTHER"
			},
			{
				"name": "FILM",
				"salience": 0.00027487683,
				"type": "WORK_OF_ART"
			},
			{
				"name": "entity",
				"salience": 0.00027487683,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "Presidential",
				"salience": 0.00026154934,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00022646907,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.00022646907,
				"type": "ORGANIZATION"
			},
			{
				"name": "cobwebs",
				"salience": 0.00020531888,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://21stcenturywire.com/wp-content/uploads/2016/10/Clinton-New-FBI-Probe-21WIRE-SLIDER-New.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T04:22:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "\nIn a stunning turn of events 11 days before the 2016 presidential election, the FBI announced it is reopenning its investigation into Hillary Clinton’s email server case, by probing newly emerging emails linked to Hillary Clinton. \n‘NEW PROBE’– The FBI gives Hillary Clinton a second look. (Photo illustraion 21WIRE) \nFBI October Surprise? \nAccording to reports , in a letter written today, FBI Director James Comey , stated that the FBI has begun a new probe into Hillary Clinton related emails once again. Comey offered scant details about the new probe, but due to an unrelated case, additional classified material may have been mishandled on Clinton’s personal email server. \nCNBC reported the latest FBI developments, including a passage from Comey’s letter discussing the new investigation: \n“In previous congressional testimony, I referred to the fact that the Federal Bureau of Investigation (FBI) had completed its investigation of former Secretary Clinton’s personal email server. Due to recent developments, I am writing to supplement my previous testimony,” Comey wrote. \nIn connection with an unrelated case, the FBI has learned of the existence of emails that appear to be pertinent to the investigation. I am writing to inform you that the investigative team briefed me on this yesterday, and I agreed that the FBI should take appropriate investigative steps designed to allow investigators to review these emails to determine whether they contain classified information, as well as to assess their importance to our investigation,” he added. \nAlthough the FBI cannot yet assess whether or not this material may be significant, and I cannot predict how long it will take us to complete this additional work, I believe it is important to update your Committees about our efforts in light of my previous testimony,” Comey concluded.” \nHuma’s Estranged ‘Sexting’ Husband \nAccording to a new report released via The New York Times : \n“The presidential campaign was rocked on Friday after federal law enforcement officials said that emails pertinent to the now-closed investigation into Hillary Clinton ’s private email server were discovered on a computer belonging to Anthony D. Weiner, the estranged husband of a top Clinton aide.” “ In a letter to Congress , the F.B.I. director, James B. Comey, said the emails had surfaced in an unrelated case, which law enforcement officials said was an F.B.I. investigation into illicit text messages from Mr. Weiner to a 15-year-old girl in North Carolina. Mr. Weiner, a former Democratic congressman from New York, is married to Huma Abedin, the top aide.” Comey has come under fire recently for apparently letting Clinton off the hook for mishandling, and lying to Congress, about classified emails coming through her ‘home brew’ email server while she was Secretary of State. After previously closing the case, Comey has done a U-turn and is now saying the FBI will review the new emails to for classified information, and see whether it was mishandled. \nThis unprecedented investigative move comes just two days after a Wikileaks docu-dump revealed a memo containing detailed financial information between Clinton Foundation donors and former president Bill Clinton ‘s private financial activities. Among those included in the memo, was a $30 million dollar business arrangement under “Bill Clinton, Inc.,” with another $66 million dollar deal scheduled over nine years. \nThe following is a tweet from Brad Jaffy of NBC Nightly News containing the new FBI recommendation… \nThe new investigation into the Clinton camp will most certainly spark new ‘Pay-to-Play’ allegations , as the new FBI revelations also comes days after a Project Veritas hidden camera sting operation revealed that the Democratic consultant Robert Creamer of Democracy Partners, discussed ways to commit ‘large-scale’ voter fraud as well as paying political agitators to cause violence at Donald Trump rallies. Out of Creamer’s 342 visits to the White House, also included his wife, a 9-term Illinois Democratic congresswoman, Jan Schakowsky some 47 times. White House visitor records show that Schakowsky took 47 “private meetings with Obama or his senior staff,” also over the past year. The consultancy Democracy Partners appears to have applied Schakowsky as a political buffering point, possibly in the event of a fallout over their operations at a grassroots level. The impetus of this type of procedural separation is to keep certain high-ranking officials of the hook in case of a massive upheaval over various underhanded campaign tactics – thus giving a political campaign or political entity plausible deniability. ‘CAUGHT ON FILM’ – Robert Creamer resigns over a massive Democratic Party controversy. (Image Source: CNN ) Creamer, a convicted felon , (in 2005, Creamer plead guilty $2.3 million in bank fraud and tax violations) was promptly “shoved out of the Hillary Clinton campaign’s inner circle,” following a heavily publicized video sting revealing his discussion about voter fraud and violence at Trump rallies. ‘PAY TO PLAY?’– Virginia Governor Terry McAuliffe closely allied with the Clinton’s negotiated a a campaign contribution involving the FBI. (Image Source new republic ) It remains unclear what exactly reopened the new Clinton probe, but perhaps the FBI had its own cobwebs to clear out after it was revealed that a longtime Clinton associate , Virginia Gov. Terry McAuliffe , “helped steer $675,000 to the election campaign of the wife of an FBI official who went on to lead the probe into Hillary Clinton’s use of a private email system, according to a report.” The NY Post also reported on the matter this past week: \n“The political action committee of McAuliffe, the Clinton loyalist, gave $467,500 to the state Senate campaign of the wife of Andrew McCabe, who is now deputy director of the FBI, according to the Wall Street Journal . \nThe report states Jill McCabe received an additional $207,788 from the Virginia Democratic Party, which is heavily influenced by McAuliffe. \nThe money directed by McAuliffe began flowing two months after the FBI investigation into Clinton began in July 2015. Around that time, the candidate’s husband was promoted from running the Washington field office for the FBI to the No. 3 position at the bureau.” \nIn a CNN report from October 18th, a week before the McAuliffe revelations, “…According to notes from interviews conducted during an FBI investigation into Clinton’s email practices, Undersecretary of State Patrick Kennedy personally tried to convince FBI officials that the email should be declassified. One interviewee described feeling “pressured” by another FBI official at Kennedy’s request.” \nThe newly reopened FBI investigation into Clinton could be related to all or some of the items listed above, but there’s no doubt that due to public backlash the FBI received following the first Clinton investigation, in addition to concerns over dealings between the FBI and Clinton associates – the agency needed to save face. \nIt remains to be seen how new case will impact the US Presidential election. \nMore from RT below… ",
		"thread_title": "FBI REDUX: What’s Behind New Probe into Hillary Clinton Emails?",
		"title": "FBI REDUX: What’s Behind New Probe into Hillary Clinton Emails?",
		"type": "conspiracy",
		"uuid": "7759496d1762e34d0a33db572948fd77df481d1d"
	},
	"-KhIWE0gMV9MNK_sHhFO": {
		"author": "Mike Rivero",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T08:58:52.869+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "campaign",
				"salience": 0.18947078,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.1777345,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0127xng6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Creamer_(Lobbyist)"
				},
				"name": "Robert Creamer",
				"salience": 0.09968994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.038030207,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0y4zr4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robby_Mook"
				},
				"name": "Robby Mook",
				"salience": 0.03484478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.021702444,
				"type": "ORGANIZATION"
			},
			{
				"name": "Democracy Partners",
				"salience": 0.02040726,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.019727957,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.01871837,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03n1q0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donna_Brazile"
				},
				"name": "Donna Brazile",
				"salience": 0.017597258,
				"type": "PERSON"
			},
			{
				"name": "21WIRE",
				"salience": 0.017024217,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0256nw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jan_Schakowsky"
				},
				"name": "Jan Schakowsky",
				"salience": 0.014484957,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Weiner",
				"salience": 0.010829471,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.010753069,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bmck63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neera_Tanden"
				},
				"name": "Neera Tanden",
				"salience": 0.010693658,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04cvfql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_J._Manafort"
				},
				"name": "Paul Manafort",
				"salience": 0.009537624,
				"type": "PERSON"
			},
			{
				"name": "Andrew McCabe",
				"salience": 0.007577476,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.007559801,
				"type": "PERSON"
			},
			{
				"name": "revelations",
				"salience": 0.006888109,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.006888109,
				"type": "EVENT"
			},
			{
				"name": "congresswoman",
				"salience": 0.0061600106,
				"type": "PERSON"
			},
			{
				"name": "close",
				"salience": 0.005966809,
				"type": "EVENT"
			},
			{
				"name": "wave",
				"salience": 0.005966809,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0057967417,
				"type": "PERSON"
			},
			{
				"name": "video sting operation",
				"salience": 0.004221356,
				"type": "OTHER"
			},
			{
				"name": "Image Source",
				"salience": 0.003900268,
				"type": "OTHER"
			},
			{
				"name": "Dmytro Firtash",
				"salience": 0.0037515843,
				"type": "PERSON"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.0037514474,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0037069076,
				"type": "PERSON"
			},
			{
				"name": "details",
				"salience": 0.003522024,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.003522024,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.003522024,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d65rn"
				},
				"name": "Martin",
				"salience": 0.0034851849,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0034413615,
				"type": "EVENT"
			},
			{
				"name": "Bob Creamer",
				"salience": 0.0034164207,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0033140087,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07s76_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_O'Keefe"
				},
				"name": "Project Veritas",
				"salience": 0.0032822266,
				"type": "PERSON"
			},
			{
				"name": "email thread",
				"salience": 0.0032286937,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0030502742,
				"type": "OTHER"
			},
			{
				"name": "Lockerdome",
				"salience": 0.0030502742,
				"type": "ORGANIZATION"
			},
			{
				"name": "series",
				"salience": 0.0030502742,
				"type": "EVENT"
			},
			{
				"name": "email dump",
				"salience": 0.0030502742,
				"type": "OTHER"
			},
			{
				"name": "BOMBSHELL",
				"salience": 0.0030502742,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0029145866,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.002653473,
				"type": "OTHER"
			},
			{
				"name": "email exchange",
				"salience": 0.00263181,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.0024352348,
				"type": "PERSON"
			},
			{
				"name": "Jill McCabe",
				"salience": 0.002295919,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015l3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nuclear_meltdown"
				},
				"name": "MELTDOWN",
				"salience": 0.0021687597,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01ztxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Center_for_American_Progress"
				},
				"name": "Center for American Progress",
				"salience": 0.0021687597,
				"type": "ORGANIZATION"
			},
			{
				"name": "contractor",
				"salience": 0.0020480892,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0019585062,
				"type": "EVENT"
			},
			{
				"name": "Michael Lux of Progressive Strategies",
				"salience": 0.0018781039,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11b6r8f4g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sally_Yates"
				},
				"name": "Sally Yates",
				"salience": 0.001795258,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.001795258,
				"type": "PERSON"
			},
			{
				"name": "operations",
				"salience": 0.0017389574,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0017389574,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0017389574,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0017389574,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0017389574,
				"type": "PERSON"
			},
			{
				"name": "meetings",
				"salience": 0.0016901025,
				"type": "EVENT"
			},
			{
				"name": "Image Source",
				"salience": 0.0016688132,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0016286743,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0016186389,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0015299484,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.001501308,
				"type": "WORK_OF_ART"
			},
			{
				"name": "SCANDAL",
				"salience": 0.0014505812,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0014505812,
				"type": "EVENT"
			},
			{
				"name": "visits",
				"salience": 0.0014505812,
				"type": "EVENT"
			},
			{
				"name": "fallout",
				"salience": 0.0014505812,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.0014505812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0014466407,
				"type": "LOCATION"
			},
			{
				"name": "questions",
				"salience": 0.0014215993,
				"type": "OTHER"
			},
			{
				"name": "National Vanguard ) Creamer",
				"salience": 0.0014162159,
				"type": "PERSON"
			},
			{
				"name": "contributor",
				"salience": 0.0013740421,
				"type": "PERSON"
			},
			{
				"name": "visitor records",
				"salience": 0.0013452682,
				"type": "OTHER"
			},
			{
				"name": "controversy",
				"salience": 0.001322761,
				"type": "OTHER"
			},
			{
				"name": "town hall question",
				"salience": 0.0013008699,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0013008699,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0013008699,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.001273181,
				"type": "WORK_OF_ART"
			},
			{
				"name": "scenario",
				"salience": 0.0012721441,
				"type": "OTHER"
			},
			{
				"name": "fallout",
				"salience": 0.0012617513,
				"type": "EVENT"
			},
			{
				"name": "camera",
				"salience": 0.0012561163,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0012561163,
				"type": "PERSON"
			},
			{
				"name": "buffering point",
				"salience": 0.0012561163,
				"type": "OTHER"
			},
			{
				"name": "grassroots level",
				"salience": 0.0012561163,
				"type": "OTHER"
			},
			{
				"name": "campaign tactics",
				"salience": 0.0012561163,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.0012561163,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0012561163,
				"type": "OTHER"
			},
			{
				"name": "separation",
				"salience": 0.0012561163,
				"type": "OTHER"
			},
			{
				"name": "hook",
				"salience": 0.0012561163,
				"type": "OTHER"
			},
			{
				"name": "upheaval",
				"salience": 0.0012561163,
				"type": "EVENT"
			},
			{
				"name": "debate questions",
				"salience": 0.0012523179,
				"type": "OTHER"
			},
			{
				"name": "chair",
				"salience": 0.0012348946,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0012246637,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chair",
				"salience": 0.0011738252,
				"type": "PERSON"
			},
			{
				"name": "latest",
				"salience": 0.0011553962,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0011300123,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0010896238,
				"type": "ORGANIZATION"
			},
			{
				"name": "town hall",
				"salience": 0.0010844182,
				"type": "LOCATION"
			},
			{
				"name": "Roland) Martin",
				"salience": 0.0010226842,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.0010223646,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.0010170873,
				"type": "EVENT"
			},
			{
				"name": "campaign contribution scandal",
				"salience": 0.0010170873,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0010170873,
				"type": "OTHER"
			},
			{
				"name": "email server case developments",
				"salience": 0.0010170873,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Department of Justice",
				"salience": 0.0010029826,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.0010023413,
				"type": "ORGANIZATION"
			},
			{
				"name": "email server case",
				"salience": 0.0009954358,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0009954358,
				"type": "OTHER"
			},
			{
				"name": "revelations",
				"salience": 0.0009791218,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0009791218,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.0009791218,
				"type": "OTHER"
			},
			{
				"name": "town hall debates",
				"salience": 0.0009791218,
				"type": "EVENT"
			},
			{
				"name": "aides",
				"salience": 0.0009705074,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0009240249,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02dgtb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terry_McAuliffe"
				},
				"name": "Terry McAuliffe",
				"salience": 0.0009240249,
				"type": "PERSON"
			},
			{
				"name": "tarmac meeting",
				"salience": 0.00091961,
				"type": "EVENT"
			},
			{
				"name": "ties",
				"salience": 0.00091961,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.00091961,
				"type": "OTHER"
			},
			{
				"name": "Campaign Manager",
				"salience": 0.00091618835,
				"type": "PERSON"
			},
			{
				"name": "bureau",
				"salience": 0.0008807116,
				"type": "ORGANIZATION"
			},
			{
				"name": "advance",
				"salience": 0.0008807116,
				"type": "OTHER"
			},
			{
				"name": "second-in-command",
				"salience": 0.0008807116,
				"type": "OTHER"
			},
			{
				"name": "following",
				"salience": 0.0008807116,
				"type": "OTHER"
			},
			{
				"name": "host",
				"salience": 0.0008807116,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0008700123,
				"type": "EVENT"
			},
			{
				"name": "name",
				"salience": 0.00084783457,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.00084783457,
				"type": "WORK_OF_ART"
			},
			{
				"name": "deniability",
				"salience": 0.00084783457,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00084783457,
				"type": "OTHER"
			},
			{
				"name": "laundry list",
				"salience": 0.00084783457,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00083031,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.00083031,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00083031,
				"type": "PERSON"
			},
			{
				"name": "computer",
				"salience": 0.00083031,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "nothing",
				"salience": 0.0007957432,
				"type": "OTHER"
			},
			{
				"name": "Image Source",
				"salience": 0.00077983964,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.00077581377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.00077315135,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00075072685,
				"type": "OTHER"
			},
			{
				"name": "critics",
				"salience": 0.0007374392,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.00073490845,
				"type": "ORGANIZATION"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.0007297155,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.00071896944,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.00071896944,
				"type": "WORK_OF_ART"
			},
			{
				"name": "minor",
				"salience": 0.00071896944,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.00071896944,
				"type": "WORK_OF_ART"
			},
			{
				"name": "agencies",
				"salience": 0.00071896944,
				"type": "ORGANIZATION"
			},
			{
				"name": "confidant",
				"salience": 0.00071896944,
				"type": "OTHER"
			},
			{
				"name": "ruling",
				"salience": 0.00071896944,
				"type": "OTHER"
			},
			{
				"name": "feud",
				"salience": 0.00071896944,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.00071896944,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "space",
				"salience": 0.0007099087,
				"type": "LOCATION"
			},
			{
				"name": "emails",
				"salience": 0.0006926926,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0006926926,
				"type": "WORK_OF_ART"
			},
			{
				"name": "business",
				"salience": 0.0006869522,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.00067829486,
				"type": "EVENT"
			},
			{
				"name": "campaign manager",
				"salience": 0.00066725427,
				"type": "PERSON"
			},
			{
				"name": "House Oversight Commitee",
				"salience": 0.0006536508,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cpt28",
					"wikipedia_url": "http://en.wikipedia.org/wiki/TV_One_(U.S._TV_network)"
				},
				"name": "TV One",
				"salience": 0.0006259987,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign meltdown",
				"salience": 0.0006202379,
				"type": "OTHER"
			},
			{
				"name": "cable",
				"salience": 0.0006202379,
				"type": "OTHER"
			},
			{
				"name": "element",
				"salience": 0.0006202379,
				"type": "OTHER"
			},
			{
				"name": "element",
				"salience": 0.0006202379,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0006202379,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.0006202379,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00054635573,
				"type": "OTHER"
			},
			{
				"name": "News One Now",
				"salience": 0.0005420481,
				"type": "ORGANIZATION"
			},
			{
				"name": "Palmieri",
				"salience": 0.0005420481,
				"type": "PERSON"
			},
			{
				"name": "operative",
				"salience": 0.00054154784,
				"type": "ORGANIZATION"
			},
			{
				"name": "operation",
				"salience": 0.00054154784,
				"type": "EVENT"
			},
			{
				"name": "crime lord",
				"salience": 0.0005370597,
				"type": "PERSON"
			},
			{
				"name": "sweetheart natural gas deals",
				"salience": 0.0005370597,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0005370597,
				"type": "OTHER"
			},
			{
				"name": "meme",
				"salience": 0.0005370597,
				"type": "OTHER"
			},
			{
				"name": "fortune",
				"salience": 0.0005370597,
				"type": "OTHER"
			},
			{
				"name": "enterprise",
				"salience": 0.0005370597,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0005370597,
				"type": "OTHER"
			},
			{
				"name": "links",
				"salience": 0.0005370597,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "Daily Caller",
				"salience": 0.0005218102,
				"type": "PERSON"
			},
			{
				"name": "detail",
				"salience": 0.0005063198,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00050028786,
				"type": "OTHER"
			},
			{
				"name": "LifeZette",
				"salience": 0.00050028786,
				"type": "ORGANIZATION"
			},
			{
				"name": "account",
				"salience": 0.00050028786,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukrainian",
				"salience": 0.00047247607,
				"type": "LOCATION"
			},
			{
				"name": "controversy",
				"salience": 0.00045586686,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.00045169774,
				"type": "EVENT"
			},
			{
				"name": "videos",
				"salience": 0.00045169774,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.00045169774,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.00045169774,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0004424879,
				"type": "ORGANIZATION"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.0004424879,
				"type": "OTHER"
			},
			{
				"name": "Assistant Attorney General",
				"salience": 0.00043513643,
				"type": "PERSON"
			},
			{
				"name": "Clintion",
				"salience": 0.0004073265,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "US State Department",
				"salience": 0.00040546854,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.0003911176,
				"type": "OTHER"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0003911176,
				"type": "OTHER"
			},
			{
				"name": "tricks",
				"salience": 0.0003911176,
				"type": "OTHER"
			},
			{
				"name": "provocateurs",
				"salience": 0.0003911176,
				"type": "PERSON"
			},
			{
				"name": "grassroots/netroots",
				"salience": 0.0003911176,
				"type": "OTHER"
			},
			{
				"name": "LifeZette",
				"salience": 0.0003757547,
				"type": "OTHER"
			},
			{
				"name": "court records",
				"salience": 0.0003736976,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.0003736976,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0003736976,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.0003670821,
				"type": "PERSON"
			},
			{
				"name": "business connections",
				"salience": 0.00033740047,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.00033740047,
				"type": "ORGANIZATION"
			},
			{
				"name": "probe",
				"salience": 0.00033740047,
				"type": "EVENT"
			},
			{
				"name": "business connection",
				"salience": 0.00033740047,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.00033589295,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026s38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slate_(magazine)"
				},
				"name": "Slate",
				"salience": 0.0003305207,
				"type": "ORGANIZATION"
			},
			{
				"name": "Trump Rally Agitator",
				"salience": 0.0003305207,
				"type": "PERSON"
			},
			{
				"name": "OUT OF CONTROL",
				"salience": 0.0003305207,
				"type": "WORK_OF_ART"
			},
			{
				"name": "value",
				"salience": 0.00030735342,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.0002921473,
				"type": "ORGANIZATION"
			},
			{
				"name": "mountain",
				"salience": 0.0002921473,
				"type": "LOCATION"
			},
			{
				"name": "start",
				"salience": 0.0002921473,
				"type": "EVENT"
			},
			{
				"name": "ambassador",
				"salience": 0.0002921473,
				"type": "PERSON"
			},
			{
				"name": "friend",
				"salience": 0.0002921473,
				"type": "PERSON"
			},
			{
				"name": "oligarch",
				"salience": 0.0002921473,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0002921473,
				"type": "OTHER"
			},
			{
				"name": "hotel",
				"salience": 0.0002921473,
				"type": "LOCATION"
			},
			{
				"name": "charge",
				"salience": 0.0002921473,
				"type": "OTHER"
			},
			{
				"name": "Jim Stinson",
				"salience": 0.00027798227,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02q_bk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gmail"
				},
				"name": "Gmail",
				"salience": 0.0002406975,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0001797869,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05mt_q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drake_(rapper)"
				},
				"name": "Drake",
				"salience": 0.0001797869,
				"type": "PERSON"
			},
			{
				"name": "Peter Kadzik",
				"salience": 0.0001797869,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0001797869,
				"type": "LOCATION"
			},
			{
				"name": "cables",
				"salience": 0.0001576134,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.000094954645,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i1.wp.com/21stcenturywire.com/wp-content/uploads/2016/10/DNC-SCANDAL-PART2-21WIRE-SLIDER-SH-1.jpg?fit=620%2C415",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T01:43:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "A tidal wave of revelations is pouring out of the Clinton campaign as the 2016 presidential election draws to a close. \n‘MELTDOWN’– The Clinton campaign continues to unravel following a series of troubling details. (Photo illustration 21WIRE) \nOver the weekend, it was discovered through a Wikileaks email dump, that Neera Tanden of the Center for American Progress , John Podesta ‘s top aide, had an email exchange with Michael Lux of Progressive Strategies revealing that the Democratic consultant Robert Creamer of Democracy Partners, was closely allied with Clinton campaign manager Robby Mook . \n‘POLITICAL BOMBSHELL’– Clinton campaign manager Robby Mook had close ties to disgraced DNC consultant Robert Creamer. (Image Source: Lockerdome ) \nCreamer gained national attention when he became the subject of video sting operation captured by the investigative non-profit Project Veritas . Not only was it revealed that the Creamer discussed ways to commit voter fraud and violence at Donald Trump rallies on camera – he also met with White House officials some 342 times over the past year, including 47 private meetings with President Obama or other senior officials. \n‘DNC SCANDAL’– Robert Creamer of Democracy Partners and Democratic congresswoman Jan Schakowsky. (Image Source: National Vanguard ) \nCreamer’s visits to the White House also included his wife, a 9-term Illinois Democratic congresswoman Jan Schakowsky . \nWhite House visitor records have shown that Schakowsky took 47 “private meetings with Obama or his senior staff,” over the past year. The consultancy Democracy Partners appears to have applied Schakowsky as a political buffering point, in the event of a fallout over their operations at a grassroots level. The nature of this type of procedural separation is to keep certain high-ranking officials of the hook in case of a massive upheaval over various underhanded campaign tactics , potentially giving the Clinton campaign and the DNC plausible deniability. \nThe Mook fallout is the latest in a laundry list of problems for the Clinton campaign and comes at a time when interim DNC chair Donna Brazile , is embroiled in controversy of over leaked debate questions prior to at least two 2016 town hall debates. Brazile stepped down from her role at CNN earlier in October. Here’s a passage from the Daily Caller describing the scenario: \n“Donna Brazile, the interim chair of the Democratic National Committee, began providing town hall and debate questions to the Clinton campaign earlier than previously known, emails released by WikiLeaks on Monday show.” \nThe article continued by stating that the revelations expose that the interim DNC chair was more deeply involved than previously outlined: \n“In the March 12 exchange, Brazile mentions [Roland] Martin by name and offers to provide more than just the one town hall question that she is known to have shared with the campaign. \n“I’ll send a few more. Though some questions Roland submitted,” Brazile wrote to Palmieri in the March 12 email thread, which is entitled “From time to time I get the questions in advance.” \nMartin, is a commentator for TV One and the host of News One Now , as well as a CNN contributor. \nIn another matter, the Wall Street Journal revealed the following , while disclosing an apparently contentious relationship between the FBI and DOJ, while the FBI appears to be somewhat fractured over the latest email server case developments: \n“The latest development began in early October when New York-based FBI officials notified Andrew McCabe [of the Terry McAuliffe campaign contribution scandal], the bureau’s second-in-command, that while investigating Mr. Weiner for possibly sending sexually charged messages to a teenage minor, they had recovered a laptop. Many of the 650,000 emails on the computer, they said, were from the accounts of Ms. Abedin, according to people familiar with the matter.” \nSome critics have called for McCabe to recuse himself after it was revealed his wife received $675,000 from a well-known Clinton confidant, Terry McAuliffe . This was further underlined after the House Oversight Commitee wanted more information about the Senate campaign of Dr. Jill McCabe and its ties to the Clintons. \nThe alleged internal feud among agencies was compounded when Attorney General Loretta Lynch and Deputy Attorney General Sally Yates ‘objected’ to FBI Director James Comey reopening the Clinton email server case this past week – something that added to the Lynch/Clinton tarmac meeting before the first FBI ruling in the Clinton case. \nAccording to a report filed by Zero Hedge , a close friend of Podesta, Peter Kadzik , the Assistant Attorney General of the Department of Justice (DOJ), will be in charge of a probe into Huma Abedin , Clintion’s closest aide. \nInterestingly, as a mountain of controversy envelops the Clinton campaign, the FBI is now conducting an early inquiry into former Trump campaign manager Paul Manafort , over his alleged foreign business connections. \nBack in August, the following business connection was revealed by NBC news : \n“In 2008, according to court records, senior Trump aide Paul Manafort’s firm was involved with a Ukrainian oligarch named Dmytro Firtash in a plan to redevelop a famous New York hotel, the Drake. The total value of the project was $850 million. Firtash’s company planned to invest over $100 million, the records say. \nThat same year, Firtash acknowledged to the U.S. ambassador in Ukraine that he got his start in business with the permission of a notorious Russian crime lord, according to a classified State Department cable. Other cables say Firtash made part of his fortune through sweetheart natural gas deals between Russia and the Ukraine.” \nAlthough the US State Department has determined that Firtash may have ties to a criminal enterprise in Russia – so far, there’s nothing directly linking Manafort to any underground element at this time. \nWatch this space – as the Russia/Trump meme fostered by mainstream media or some other politically polarizing element will look to deflect from the Clinton campaign meltdown. \nMore from LifeZette below… \n‘OUT OF CONTROL?’– Wikileaks reveals Robby Mook’s links to DNC contractor who discussed ways to commit voter fraud and violence. (Image Source: Slate ) \nWikiLeaks: Trump Rally Agitator and Clinton Campaign Manager Are ‘Close’ \nTop Clinton aides discussed Bob Creamer and his ‘grassroots/netroots’ operation \nby Jim Stinson LifeZette \nRobert Creamer, the operative behind sending provocateurs to Donald Trump rallies, was close to Robby Mook, Hillary Clinton’s campaign manager, according to new emails released by WikiLeaks. \nCreamer, who allegedly spearheaded the dirty tricks for the Democrats, wasn’t just consulting for the Democratic National Committee, according to videos made by Project Veritas. He was sending people to provoke Trump at events. \nCreamer has thus become a red-hot issue in the campaign. And now it’s apparent he is close to Mook. That surprising detail came out Sunday morning when WikiLeaks posted hundreds more emails from John Podesta’s Gmail account. Podesta is Clinton’s campaign chairman whose account was hacked in March. \nMore from LifeZette here … \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV",
		"thread_title": "PARTY CORRUPTION: Clinton Campaign Directly Tied to Disgraced DNC Consultant",
		"title": "PARTY CORRUPTION: Clinton Campaign Directly Tied to Disgraced DNC Consultant",
		"type": "conspiracy",
		"uuid": "f51a0aa7d160a15707b18a4007bdfa4c506d17a6"
	},
	"-KhIWG-F0N7XznFPpNsK": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T10:39:07.600+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.31221312,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.13680205,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.07524256,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.07165593,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.04197432,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.031829514,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.02736104,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.023204437,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.014892307,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.013067267,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.011332712,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "Federal Bureau of Investigation",
				"salience": 0.006247691,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0062427553,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.0044679902,
				"type": "ORGANIZATION"
			},
			{
				"name": "prospect",
				"salience": 0.0040480224,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0038816466,
				"type": "EVENT"
			},
			{
				"name": "President",
				"salience": 0.0037754402,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0036385346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0031989142,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0031971864,
				"type": "OTHER"
			},
			{
				"name": "pill",
				"salience": 0.003143945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.0030103386,
				"type": "PERSON"
			},
			{
				"name": "persona",
				"salience": 0.0028775176,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.0028640714,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00274903,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0026640894,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04cmyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Debbie_Wasserman_Schultz"
				},
				"name": "Debbie Wasserman Schultz",
				"salience": 0.0022589217,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0020841367,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0288j83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.002035438,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.001812945,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.0017731703,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama Administration",
				"salience": 0.001717509,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0016757272,
				"type": "LOCATION"
			},
			{
				"name": "hack",
				"salience": 0.0016621255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.001555289,
				"type": "PERSON"
			},
			{
				"name": "Crowdstrike",
				"salience": 0.0014783973,
				"type": "ORGANIZATION"
			},
			{
				"name": "email server",
				"salience": 0.0014740675,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03n1q0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donna_Brazile"
				},
				"name": "Donna Brazile",
				"salience": 0.0014726593,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.0014693689,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/045vz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Russian_sentiment"
				},
				"name": "anti-Russian",
				"salience": 0.0014268666,
				"type": "ORGANIZATION"
			},
			{
				"name": "Comments",
				"salience": 0.0013866214,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "National Security Agency",
				"salience": 0.001359729,
				"type": "ORGANIZATION"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.0012198206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07j1vt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gloria_Borger"
				},
				"name": "Gloria Borger",
				"salience": 0.0012143366,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0012087241,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0011590745,
				"type": "LOCATION"
			},
			{
				"name": "soap opera",
				"salience": 0.0011093831,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.0010873763,
				"type": "PERSON"
			},
			{
				"name": "scope",
				"salience": 0.0010775487,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0009963122,
				"type": "ORGANIZATION"
			},
			{
				"name": "Patrick Henningsen",
				"salience": 0.00094047736,
				"type": "PERSON"
			},
			{
				"name": "surrogates",
				"salience": 0.0009271054,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0009228407,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.0009092403,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012gx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Biden"
				},
				"name": "Joe Biden",
				"salience": 0.000864815,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.00085836486,
				"type": "ORGANIZATION"
			},
			{
				"name": "hackers",
				"salience": 0.0008490693,
				"type": "PERSON"
			},
			{
				"name": "Hackers",
				"salience": 0.0008490693,
				"type": "PERSON"
			},
			{
				"name": "hack",
				"salience": 0.0008490693,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0008368542,
				"type": "EVENT"
			},
			{
				"name": "capacity",
				"salience": 0.00081497314,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00081140094,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0j5wk_6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ben_Sasse"
				},
				"name": "Ben Sasse",
				"salience": 0.00080316083,
				"type": "PERSON"
			},
			{
				"name": "opponents",
				"salience": 0.00079813245,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.000784407,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.000784407,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.000784407,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.00075560977,
				"type": "ORGANIZATION"
			},
			{
				"name": "hackers",
				"salience": 0.0007526045,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0006911141,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0006911141,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ky5x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Intelligence_agency"
				},
				"name": "Intelligence Community",
				"salience": 0.00067859114,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.0006771908,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.00067316776,
				"type": "PERSON"
			},
			{
				"name": "election process",
				"salience": 0.000669524,
				"type": "OTHER"
			},
			{
				"name": "talking point",
				"salience": 0.0006674096,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0006646664,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0006642022,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.00066039455,
				"type": "ORGANIZATION"
			},
			{
				"name": "bureau",
				"salience": 0.0006500638,
				"type": "ORGANIZATION"
			},
			{
				"name": "points",
				"salience": 0.0006344031,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0006344031,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0006344031,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0006271444,
				"type": "WORK_OF_ART"
			},
			{
				"name": "passing remark",
				"salience": 0.0006077882,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0006077882,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00060495303,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "Russia Today",
				"salience": 0.0006040878,
				"type": "ORGANIZATION"
			},
			{
				"name": "Peter J. Kadzik",
				"salience": 0.0005929334,
				"type": "PERSON"
			},
			{
				"name": "election system",
				"salience": 0.000590776,
				"type": "OTHER"
			},
			{
				"name": "voter registration systems",
				"salience": 0.000590776,
				"type": "OTHER"
			},
			{
				"name": "election system",
				"salience": 0.000590776,
				"type": "OTHER"
			},
			{
				"name": "election systems",
				"salience": 0.000590776,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00056662294,
				"type": "OTHER"
			},
			{
				"name": "intelligence agencies",
				"salience": 0.0005465157,
				"type": "ORGANIZATION"
			},
			{
				"name": "action",
				"salience": 0.00054034335,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00054034335,
				"type": "OTHER"
			},
			{
				"name": "coverage",
				"salience": 0.00053818093,
				"type": "OTHER"
			},
			{
				"name": "Michele Reagan",
				"salience": 0.00053491915,
				"type": "PERSON"
			},
			{
				"name": "Anyone",
				"salience": 0.0005323067,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0005206107,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.0005174263,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.00051156257,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.00051156257,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.00051156257,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.00051156257,
				"type": "EVENT"
			},
			{
				"name": "stance",
				"salience": 0.0005089218,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.00050219515,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02cmx6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir"
				},
				"name": "Vladimir",
				"salience": 0.00049287087,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.00047949367,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00047949367,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.00047949367,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attention",
				"salience": 0.00047949367,
				"type": "OTHER"
			},
			{
				"name": "headline",
				"salience": 0.00047949367,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00047949367,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00045657787,
				"type": "LOCATION"
			},
			{
				"name": "Election",
				"salience": 0.00045628237,
				"type": "EVENT"
			},
			{
				"name": "hawks",
				"salience": 0.00044296638,
				"type": "PERSON"
			},
			{
				"name": "genesis",
				"salience": 0.00044296638,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.00044296638,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00044296638,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00044296638,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.00044296638,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00044296638,
				"type": "OTHER"
			},
			{
				"name": "Ellen Nakashima",
				"salience": 0.00043997393,
				"type": "PERSON"
			},
			{
				"name": "paragraph",
				"salience": 0.0004296426,
				"type": "WORK_OF_ART"
			},
			{
				"name": "someone",
				"salience": 0.00042777305,
				"type": "PERSON"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.00042603954,
				"type": "OTHER"
			},
			{
				"name": "left-wing",
				"salience": 0.00042076153,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "speculation",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "news release",
				"salience": 0.00039994877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sanctions",
				"salience": 0.00039994877,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0003943863,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Andrew McCabe",
				"salience": 0.0003881686,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.00037287053,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Jill McCabe",
				"salience": 0.00037045754,
				"type": "PERSON"
			},
			{
				"name": "plank",
				"salience": 0.0003689875,
				"type": "OTHER"
			},
			{
				"name": "Clinton Campaign Chair",
				"salience": 0.00036370597,
				"type": "ORGANIZATION"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.00035890806,
				"type": "OTHER"
			},
			{
				"name": "Roland Martin",
				"salience": 0.00035818556,
				"type": "PERSON"
			},
			{
				"name": "hack",
				"salience": 0.00034949338,
				"type": "OTHER"
			},
			{
				"name": "hack",
				"salience": 0.00034949338,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.00034949338,
				"type": "OTHER"
			},
			{
				"name": "email hacks",
				"salience": 0.00034949338,
				"type": "OTHER"
			},
			{
				"name": "government hacks",
				"salience": 0.00034949338,
				"type": "OTHER"
			},
			{
				"name": "onset",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "uncertainty",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "zone",
				"salience": 0.00034631463,
				"type": "LOCATION"
			},
			{
				"name": "struggles",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "defense industry",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.00034631463,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "tools",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "innuendo",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.00034631463,
				"type": "EVENT"
			},
			{
				"name": "bromance",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.00034631463,
				"type": "EVENT"
			},
			{
				"name": "options",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.00034631463,
				"type": "PERSON"
			},
			{
				"name": "envoys",
				"salience": 0.00034631463,
				"type": "PERSON"
			},
			{
				"name": "hold-outs",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "vanguard",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.00034631463,
				"type": "OTHER"
			},
			{
				"name": "Election",
				"salience": 0.0003444633,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0204x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_Reid"
				},
				"name": "Harry Reid",
				"salience": 0.00034293442,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.00033578233,
				"type": "OTHER"
			},
			{
				"name": "scandals",
				"salience": 0.00033295408,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00033158975,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.00032286666,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00032286666,
				"type": "LOCATION"
			},
			{
				"name": "scandal",
				"salience": 0.00032217705,
				"type": "OTHER"
			},
			{
				"name": "voter registration system",
				"salience": 0.00032140306,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00031551404,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0003148502,
				"type": "EVENT"
			},
			{
				"name": "door",
				"salience": 0.00031289918,
				"type": "OTHER"
			},
			{
				"name": "Matt Roberts",
				"salience": 0.00030962168,
				"type": "PERSON"
			},
			{
				"name": "charity",
				"salience": 0.000308021,
				"type": "ORGANIZATION"
			},
			{
				"name": "bag",
				"salience": 0.00030695403,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00030695403,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.00030438686,
				"type": "WORK_OF_ART"
			},
			{
				"name": "elections",
				"salience": 0.00030343083,
				"type": "EVENT"
			},
			{
				"name": "conspiracy theories",
				"salience": 0.0003005156,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.00029635377,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.00029287505,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0002895871,
				"type": "OTHER"
			},
			{
				"name": "intelligence agency",
				"salience": 0.00028445342,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.00028082158,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0002803083,
				"type": "PERSON"
			},
			{
				"name": "Cyber security officials",
				"salience": 0.00027706445,
				"type": "PERSON"
			},
			{
				"name": "election official",
				"salience": 0.00027706445,
				"type": "PERSON"
			},
			{
				"name": "none",
				"salience": 0.0002752613,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0002746937,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0002746937,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0gzz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Howard_Dean"
				},
				"name": "Howard Dean",
				"salience": 0.00027398672,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Ronald Reagan",
				"salience": 0.00027262533,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.0002692992,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0002692992,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0002692992,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebuttal",
				"salience": 0.0002636157,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0002614109,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0002614109,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.00026110452,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.00025868832,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.00025660894,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.00025359666,
				"type": "LOCATION"
			},
			{
				"name": "emails",
				"salience": 0.0002516505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0002516505,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04zy7kd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_E._Donilon"
				},
				"name": "Tom Donilon",
				"salience": 0.00024956645,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0002485265,
				"type": "OTHER"
			},
			{
				"name": "intelligence agencies",
				"salience": 0.00024740963,
				"type": "ORGANIZATION"
			},
			{
				"name": "hack",
				"salience": 0.00024502026,
				"type": "OTHER"
			},
			{
				"name": "hack",
				"salience": 0.00024502026,
				"type": "OTHER"
			},
			{
				"name": "email hacks",
				"salience": 0.00024502026,
				"type": "OTHER"
			},
			{
				"name": "state system",
				"salience": 0.00024314335,
				"type": "OTHER"
			},
			{
				"name": "county system",
				"salience": 0.00024314335,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00024224489,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0002414935,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.0002414935,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j8sy9w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_Binney_(U.S._intelligence_official)"
				},
				"name": "William Binney",
				"salience": 0.0002402482,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.00023918028,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00023918028,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00023639669,
				"type": "OTHER"
			},
			{
				"name": "hacking",
				"salience": 0.0002358717,
				"type": "OTHER"
			},
			{
				"name": "hack",
				"salience": 0.0002358717,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.0002358717,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.0002358717,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00023414475,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00023414475,
				"type": "EVENT"
			},
			{
				"name": "media operatives",
				"salience": 0.00023318201,
				"type": "ORGANIZATION"
			},
			{
				"name": "procedure",
				"salience": 0.00023318201,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00023318201,
				"type": "ORGANIZATION"
			},
			{
				"name": "consequences",
				"salience": 0.00023318201,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.00023318201,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.00023318201,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0002324766,
				"type": "EVENT"
			},
			{
				"name": "press",
				"salience": 0.00022635145,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0002254022,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0002254022,
				"type": "EVENT"
			},
			{
				"name": "efforts",
				"salience": 0.00022238136,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00022238136,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.00022238136,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00022238136,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.00021789983,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.00021789983,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00021789983,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.00021789983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "Central Intelligence Agency",
				"salience": 0.00021491283,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f2v0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami"
				},
				"name": "Miami",
				"salience": 0.00021313388,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.00021313388,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.00021053344,
				"type": "OTHER"
			},
			{
				"name": "leak",
				"salience": 0.00021053344,
				"type": "OTHER"
			},
			{
				"name": "commentators",
				"salience": 0.00020961715,
				"type": "PERSON"
			},
			{
				"name": "investigators",
				"salience": 0.00020871527,
				"type": "PERSON"
			},
			{
				"name": "Josh Rogin",
				"salience": 0.00020779486,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.00020474929,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0120w9bh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jennifer_Palmieri"
				},
				"name": "Jennifer Palmieri",
				"salience": 0.00020372563,
				"type": "PERSON"
			},
			{
				"name": "culprit",
				"salience": 0.0001981949,
				"type": "OTHER"
			},
			{
				"name": "media surrogates",
				"salience": 0.00019733231,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.00019733231,
				"type": "WORK_OF_ART"
			},
			{
				"name": "debate",
				"salience": 0.00019733231,
				"type": "EVENT"
			},
			{
				"name": "remainder election",
				"salience": 0.00019713528,
				"type": "EVENT"
			},
			{
				"name": "activity",
				"salience": 0.00019341975,
				"type": "OTHER"
			},
			{
				"name": "intelligence agencies",
				"salience": 0.00019197303,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.00019197303,
				"type": "ORGANIZATION"
			},
			{
				"name": "laptop",
				"salience": 0.00018923503,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "security",
				"salience": 0.00018879445,
				"type": "OTHER"
			},
			{
				"name": "Office",
				"salience": 0.00018698596,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02dgtb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terry_McAuliffe"
				},
				"name": "Terry McAuliffe",
				"salience": 0.00018680934,
				"type": "PERSON"
			},
			{
				"name": "living",
				"salience": 0.00018601492,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00018538586,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00018477412,
				"type": "PERSON"
			},
			{
				"name": "aggression",
				"salience": 0.00018367024,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00018304911,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00018304911,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00018229643,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00018229643,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.00018229643,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00018229643,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00018229643,
				"type": "OTHER"
			},
			{
				"name": "cyber",
				"salience": 0.00018229643,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.00018229643,
				"type": "OTHER"
			},
			{
				"name": "press secretary",
				"salience": 0.00018229643,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00018174492,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05fp3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Committee_on_Homeland_Security"
				},
				"name": "Homeland Security Committee",
				"salience": 0.00017940161,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03j793",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Congressional_Campaign_Committee"
				},
				"name": "Democratic Congressional Campaign Committee",
				"salience": 0.00017940161,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.00017867303,
				"type": "WORK_OF_ART"
			},
			{
				"name": "more",
				"salience": 0.00017852744,
				"type": "OTHER"
			},
			{
				"name": "Party",
				"salience": 0.00017798734,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00017798734,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.00017695622,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00017621409,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00017621409,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.00017536689,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W Bush",
				"salience": 0.00017526421,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00017441036,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00017034866,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00016843408,
				"type": "ORGANIZATION"
			},
			{
				"name": "Andrew Lack",
				"salience": 0.00016557993,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.00016522367,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.00016470467,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00016470467,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.00016470467,
				"type": "OTHER"
			},
			{
				"name": "sensitivity",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "IMAGE",
				"salience": 0.0001645896,
				"type": "WORK_OF_ART"
			},
			{
				"name": "material",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "cellphone numbers",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "ambiguity",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "password",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "specifics",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "motivations",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "cyber security company",
				"salience": 0.0001645896,
				"type": "ORGANIZATION"
			},
			{
				"name": "conflict",
				"salience": 0.0001645896,
				"type": "EVENT"
			},
			{
				"name": "rants",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "ambitions",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"name": "make-up",
				"salience": 0.0001645896,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02bp17",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Director_of_National_Intelligence"
				},
				"name": "Office of the Director of National Intelligence",
				"salience": 0.00016449811,
				"type": "ORGANIZATION"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.0001637107,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0001634727,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.0001634727,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.0001634727,
				"type": "OTHER"
			},
			{
				"name": "operatives",
				"salience": 0.0001634727,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.00016278824,
				"type": "PERSON"
			},
			{
				"name": "field agents",
				"salience": 0.00016278824,
				"type": "PERSON"
			},
			{
				"name": "analysis",
				"salience": 0.00016262857,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.00016170662,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0001616285,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.00015736854,
				"type": "ORGANIZATION"
			},
			{
				"name": "democracy",
				"salience": 0.00015689245,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01j6k5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Geospatial-Intelligence_Agency"
				},
				"name": "National Geospatial Intelligence Agency",
				"salience": 0.00015558612,
				"type": "ORGANIZATION"
			},
			{
				"name": "tribe",
				"salience": 0.0001547384,
				"type": "OTHER"
			},
			{
				"name": "Washington Intelligence",
				"salience": 0.00015290415,
				"type": "ORGANIZATION"
			},
			{
				"name": "sort",
				"salience": 0.00015184584,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03j50",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hacker_(term)"
				},
				"name": "Hack",
				"salience": 0.00015078887,
				"type": "PERSON"
			},
			{
				"name": "Russian Hack",
				"salience": 0.00015078887,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00015007902,
				"type": "OTHER"
			},
			{
				"name": "flagging efforts",
				"salience": 0.00015007902,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00015007902,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.00015007902,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00015007902,
				"type": "EVENT"
			},
			{
				"name": "queue",
				"salience": 0.00014993182,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.00014759402,
				"type": "OTHER"
			},
			{
				"name": "Leaks",
				"salience": 0.00014759402,
				"type": "EVENT"
			},
			{
				"name": "claims",
				"salience": 0.00014759402,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.00014759402,
				"type": "PERSON"
			},
			{
				"name": "claim",
				"salience": 0.00014759402,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00014725038,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00014725038,
				"type": "EVENT"
			},
			{
				"name": "demonization",
				"salience": 0.00014725038,
				"type": "EVENT"
			},
			{
				"name": "Air Force Intelligence",
				"salience": 0.00014719459,
				"type": "ORGANIZATION"
			},
			{
				"name": "Marine Corps Intelligence",
				"salience": 0.00014719459,
				"type": "ORGANIZATION"
			},
			{
				"name": "Navy Intelligence",
				"salience": 0.00014719459,
				"type": "OTHER"
			},
			{
				"name": "challenges",
				"salience": 0.00014693454,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.00014683188,
				"type": "OTHER"
			},
			{
				"name": "dumps",
				"salience": 0.00014683188,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00014276913,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00014276913,
				"type": "EVENT"
			},
			{
				"name": "sites",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "lawmakers",
				"salience": 0.00014251388,
				"type": "PERSON"
			},
			{
				"name": "calculus",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "nonsense",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "bandwagon",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "email addresses",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "ride",
				"salience": 0.00014251388,
				"type": "EVENT"
			},
			{
				"name": "universe",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "guesswork",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "repetition",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "accusation",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "cul de sac",
				"salience": 0.00014251388,
				"type": "LOCATION"
			},
			{
				"name": "detail",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "climate",
				"salience": 0.00014251388,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00014208272,
				"type": "PERSON"
			},
			{
				"name": "leaks",
				"salience": 0.00014208272,
				"type": "EVENT"
			},
			{
				"name": "campaign machine",
				"salience": 0.0001395673,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.00013833893,
				"type": "OTHER"
			},
			{
				"name": "hacking unit",
				"salience": 0.00013833893,
				"type": "OTHER"
			},
			{
				"name": "RT",
				"salience": 0.00013833893,
				"type": "OTHER"
			},
			{
				"name": "mainstream media surrogates",
				"salience": 0.00013833893,
				"type": "OTHER"
			},
			{
				"name": "surrogates",
				"salience": 0.00013833893,
				"type": "OTHER"
			},
			{
				"name": "reporter",
				"salience": 0.00013833893,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.00013833893,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.00013801683,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00013691564,
				"type": "LOCATION"
			},
			{
				"name": "Some",
				"salience": 0.00013659513,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.00013559591,
				"type": "EVENT"
			},
			{
				"name": "braintrust",
				"salience": 0.0001354629,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS News",
				"salience": 0.00013537606,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.0001348733,
				"type": "PERSON"
			},
			{
				"name": "reputation",
				"salience": 0.00013444963,
				"type": "OTHER"
			},
			{
				"name": "mainstream media operatives",
				"salience": 0.00013344393,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.00013344393,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00013317319,
				"type": "OTHER"
			},
			{
				"name": "worker",
				"salience": 0.00013317319,
				"type": "PERSON"
			},
			{
				"name": "leverage",
				"salience": 0.00013317319,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "Homeland Security Department",
				"salience": 0.00013298883,
				"type": "ORGANIZATION"
			},
			{
				"name": "election cycle",
				"salience": 0.0001326621,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00013108143,
				"type": "OTHER"
			},
			{
				"name": "username",
				"salience": 0.00013040454,
				"type": "OTHER"
			},
			{
				"name": "scandals",
				"salience": 0.00013010092,
				"type": "EVENT"
			},
			{
				"name": "problem",
				"salience": 0.00012876074,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.00012802285,
				"type": "ORGANIZATION"
			},
			{
				"name": "outrage",
				"salience": 0.0001277976,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0001277976,
				"type": "PERSON"
			},
			{
				"name": "content",
				"salience": 0.0001277976,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.0001277976,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/012qj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drug_Enforcement_Administration"
				},
				"name": "Drug Enforcement Administration",
				"salience": 0.00012753991,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0001272625,
				"type": "EVENT"
			},
			{
				"name": "Chairwoman",
				"salience": 0.0001272625,
				"type": "PERSON"
			},
			{
				"name": "Deputy Director",
				"salience": 0.0001272625,
				"type": "PERSON"
			},
			{
				"name": "chair",
				"salience": 0.0001272625,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0465sdr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Holder"
				},
				"name": "Eric Holder",
				"salience": 0.0001263704,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.00012609849,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.00012515526,
				"type": "OTHER"
			},
			{
				"name": "espionage attacks",
				"salience": 0.00012459603,
				"type": "EVENT"
			},
			{
				"name": "cyberattacks",
				"salience": 0.00012459603,
				"type": "EVENT"
			},
			{
				"name": "bosses",
				"salience": 0.00012395263,
				"type": "PERSON"
			},
			{
				"name": "campaign operatives",
				"salience": 0.00012366402,
				"type": "ORGANIZATION"
			},
			{
				"name": "entities",
				"salience": 0.00012314948,
				"type": "ORGANIZATION"
			},
			{
				"name": "mainstream media",
				"salience": 0.00012314624,
				"type": "ORGANIZATION"
			},
			{
				"name": "announcement",
				"salience": 0.00012302544,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00012302544,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.00012302544,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.00012302544,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00012302544,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.00012239015,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.000121976234,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.00012195682,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00012147465,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.00012138978,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00012138978,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00012048175,
				"type": "OTHER"
			},
			{
				"name": "coverage",
				"salience": 0.00012048175,
				"type": "OTHER"
			},
			{
				"name": "messenger",
				"salience": 0.000119943405,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0pl7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Intelligence_Agency"
				},
				"name": "Defense Intelligence Agency",
				"salience": 0.00011814081,
				"type": "ORGANIZATION"
			},
			{
				"name": "thanks",
				"salience": 0.00011685687,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00011685687,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00011607734,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.00011607734,
				"type": "OTHER"
			},
			{
				"name": "Maria Cardona",
				"salience": 0.00011601903,
				"type": "PERSON"
			},
			{
				"name": "PodestaEmails13",
				"salience": 0.00011569811,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.00011538383,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00011538383,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.00011538383,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.00011538383,
				"type": "ORGANIZATION"
			},
			{
				"name": "release",
				"salience": 0.00011538383,
				"type": "EVENT"
			},
			{
				"name": "excuse",
				"salience": 0.00011538383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0213xr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Reconnaissance_Office"
				},
				"name": "National Reconnaissance Office",
				"salience": 0.00011507156,
				"type": "ORGANIZATION"
			},
			{
				"name": "fraud",
				"salience": 0.00011486826,
				"type": "OTHER"
			},
			{
				"name": "bottom",
				"salience": 0.00011486826,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00011292662,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00011292662,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00011292662,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00011292662,
				"type": "OTHER"
			},
			{
				"name": "Coast Guard Intelligence",
				"salience": 0.00011234822,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.00011231303,
				"type": "PERSON"
			},
			{
				"name": "Bureau 121",
				"salience": 0.00011211695,
				"type": "ORGANIZATION"
			},
			{
				"name": "talking point",
				"salience": 0.00011161181,
				"type": "OTHER"
			},
			{
				"name": "talking point",
				"salience": 0.00011161181,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00011161181,
				"type": "OTHER"
			},
			{
				"name": "war hawks",
				"salience": 0.00011115284,
				"type": "OTHER"
			},
			{
				"name": "motivations",
				"salience": 0.00011107518,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00011107518,
				"type": "OTHER"
			},
			{
				"name": "sensitivity",
				"salience": 0.00011107518,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.00011107518,
				"type": "OTHER"
			},
			{
				"name": "anthrax",
				"salience": 0.00011107518,
				"type": "OTHER"
			},
			{
				"name": "techniques",
				"salience": 0.00011107518,
				"type": "OTHER"
			},
			{
				"name": "dog whistles",
				"salience": 0.00011107518,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02n670",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sergey_Lavrov"
				},
				"name": "Sergei Lavrov",
				"salience": 0.0001108173,
				"type": "PERSON"
			},
			{
				"name": "laptop",
				"salience": 0.00011035546,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "interests",
				"salience": 0.00011032466,
				"type": "OTHER"
			},
			{
				"name": "blackmail scheme",
				"salience": 0.000109862354,
				"type": "OTHER"
			},
			{
				"name": "Hacking",
				"salience": 0.00010879837,
				"type": "OTHER"
			},
			{
				"name": "Hacking",
				"salience": 0.00010879837,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.000108601154,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.000107232176,
				"type": "EVENT"
			},
			{
				"name": "party insiders",
				"salience": 0.00010644962,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.00010565334,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.00010483237,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00010478975,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.000104321516,
				"type": "OTHER"
			},
			{
				"name": "town hall question",
				"salience": 0.000104321516,
				"type": "OTHER"
			},
			{
				"name": "debate questions",
				"salience": 0.000104321516,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.000104321516,
				"type": "PERSON"
			},
			{
				"name": "matters",
				"salience": 0.000104321516,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000104321516,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.000104321516,
				"type": "OTHER"
			},
			{
				"name": "convention",
				"salience": 0.000104321516,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03rwz3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sony_Pictures_Entertainment"
				},
				"name": "Sony Pictures",
				"salience": 0.000101506455,
				"type": "ORGANIZATION"
			},
			{
				"name": "NE-R",
				"salience": 0.000101288046,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0m25p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gila_County,_Arizona"
				},
				"name": "Gila County",
				"salience": 0.000101288046,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f1r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_the_Treasury"
				},
				"name": "Treasury Department",
				"salience": 0.000100981604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gy_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Energy"
				},
				"name": "Energy Department",
				"salience": 0.000100981604,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.00010042591,
				"type": "OTHER"
			},
			{
				"name": "oxymoron",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "cadre",
				"salience": 0.000099907316,
				"type": "PERSON"
			},
			{
				"name": "wolf",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "purposes",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "chips",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "media proxy",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "plot",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "affront",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "timing",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "establishment choice",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "millennials",
				"salience": 0.000099907316,
				"type": "PERSON"
			},
			{
				"name": "mode",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "resignation",
				"salience": 0.000099907316,
				"type": "EVENT"
			},
			{
				"name": "spin doctors",
				"salience": 0.000099907316,
				"type": "PERSON"
			},
			{
				"name": "refusal",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "authenticity",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "spotlight",
				"salience": 0.000099907316,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.000099907316,
				"type": "ORGANIZATION"
			},
			{
				"name": "video",
				"salience": 0.000099907316,
				"type": "WORK_OF_ART"
			},
			{
				"name": "party operative",
				"salience": 0.00009967469,
				"type": "ORGANIZATION"
			},
			{
				"name": "process",
				"salience": 0.00009967469,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00009967469,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.00009967469,
				"type": "PERSON"
			},
			{
				"name": "election coverage",
				"salience": 0.00009960505,
				"type": "OTHER"
			},
			{
				"name": "ground attack",
				"salience": 0.00009915997,
				"type": "EVENT"
			},
			{
				"name": "prosecutors",
				"salience": 0.00009660822,
				"type": "PERSON"
			},
			{
				"name": "staff",
				"salience": 0.00009617654,
				"type": "PERSON"
			},
			{
				"name": "team",
				"salience": 0.00009617654,
				"type": "ORGANIZATION"
			},
			{
				"name": "labs",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "muscle",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.00009617654,
				"type": "PERSON"
			},
			{
				"name": "disclosures",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "camper vans",
				"salience": 0.00009617654,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "intelligence briefings",
				"salience": 0.00009617654,
				"type": "WORK_OF_ART"
			},
			{
				"name": "outlets",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "ounce",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "decree",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "thefts",
				"salience": 0.00009617654,
				"type": "EVENT"
			},
			{
				"name": "tactics",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "rooftops",
				"salience": 0.00009617654,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.00009617654,
				"type": "ORGANIZATION"
			},
			{
				"name": "Answer",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "trove",
				"salience": 0.00009617654,
				"type": "EVENT"
			},
			{
				"name": "instances",
				"salience": 0.00009617654,
				"type": "OTHER"
			},
			{
				"name": "@wikileaks",
				"salience": 0.00009594049,
				"type": "ORGANIZATION"
			},
			{
				"name": "@JoshSchwerin",
				"salience": 0.00009594049,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.000095553354,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.000095553354,
				"type": "LOCATION"
			},
			{
				"name": "director",
				"salience": 0.00009505741,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00009487006,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00009487006,
				"type": "OTHER"
			},
			{
				"name": "leak",
				"salience": 0.00009467685,
				"type": "EVENT"
			},
			{
				"name": "debates",
				"salience": 0.00009455082,
				"type": "OTHER"
			},
			{
				"name": "town hall",
				"salience": 0.00009418794,
				"type": "LOCATION"
			},
			{
				"name": "existence",
				"salience": 0.00009418794,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.00009418794,
				"type": "ORGANIZATION"
			},
			{
				"name": "no one",
				"salience": 0.00009418794,
				"type": "PERSON"
			},
			{
				"name": "replacement",
				"salience": 0.00009418794,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00009418794,
				"type": "EVENT"
			},
			{
				"name": "meltdown",
				"salience": 0.00009418794,
				"type": "EVENT"
			},
			{
				"name": "batches",
				"salience": 0.00009418794,
				"type": "OTHER"
			},
			{
				"name": "Kim Jing-Un",
				"salience": 0.000093512615,
				"type": "PERSON"
			},
			{
				"name": "meal",
				"salience": 0.00009258507,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "FOX News",
				"salience": 0.000090455535,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.00008999246,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00008999246,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00008921521,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00008854785,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00008854785,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00008854785,
				"type": "OTHER"
			},
			{
				"name": "Guccifer 2.0",
				"salience": 0.00008770207,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00008770207,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0203v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colin_Powell"
				},
				"name": "Colin Powell",
				"salience": 0.000087436725,
				"type": "PERSON"
			},
			{
				"name": "outrage",
				"salience": 0.00008734586,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00008670256,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00008670256,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00008670256,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00008670256,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.00008670256,
				"type": "OTHER"
			},
			{
				"name": "government office",
				"salience": 0.00008624735,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.00008624735,
				"type": "LOCATION"
			},
			{
				"name": "chance",
				"salience": 0.00008618454,
				"type": "OTHER"
			},
			{
				"name": "Daily Caller ) Brazile",
				"salience": 0.000085628824,
				"type": "PERSON"
			},
			{
				"name": "machine",
				"salience": 0.00008509811,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00008434911,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00008382973,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00008382973,
				"type": "ORGANIZATION"
			},
			{
				"name": "same",
				"salience": 0.000083718136,
				"type": "OTHER"
			},
			{
				"name": "sex slaves",
				"salience": 0.00008310789,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.00008309189,
				"type": "PERSON"
			},
			{
				"name": "outrage",
				"salience": 0.00008302418,
				"type": "OTHER"
			},
			{
				"name": "Cassandra Butts",
				"salience": 0.00008277354,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0509p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monica_Lewinsky"
				},
				"name": "Monica Lewinsky",
				"salience": 0.00008277354,
				"type": "PERSON"
			},
			{
				"name": "intern",
				"salience": 0.00008240556,
				"type": "PERSON"
			},
			{
				"name": "strategy",
				"salience": 0.00008197758,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "supervisors",
				"salience": 0.000081554244,
				"type": "PERSON"
			},
			{
				"name": "sabotage",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "feud",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.000081554244,
				"type": "EVENT"
			},
			{
				"name": "collusion",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "shortlist",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "Others",
				"salience": 0.000081554244,
				"type": "PERSON"
			},
			{
				"name": "disagreements",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "occasion",
				"salience": 0.000081554244,
				"type": "EVENT"
			},
			{
				"name": "devil",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.000081554244,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.00008127843,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00008127843,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "North Korean",
				"salience": 0.000080969505,
				"type": "LOCATION"
			},
			{
				"name": "competitor",
				"salience": 0.00007986797,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Democratic Party Convention",
				"salience": 0.0000786454,
				"type": "EVENT"
			},
			{
				"name": "same",
				"salience": 0.0000785728,
				"type": "OTHER"
			},
			{
				"name": "Meltdown Wasserman Schultz",
				"salience": 0.00007831609,
				"type": "PERSON"
			},
			{
				"name": "trigger event",
				"salience": 0.00007792149,
				"type": "EVENT"
			},
			{
				"name": "ginning-up",
				"salience": 0.00007792149,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00007792149,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00007792149,
				"type": "OTHER"
			},
			{
				"name": "war hawks",
				"salience": 0.00007792149,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.00007792149,
				"type": "EVENT"
			},
			{
				"name": "lifetime",
				"salience": 0.00007792149,
				"type": "OTHER"
			},
			{
				"name": "defender",
				"salience": 0.00007792149,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.000076617056,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.00007660432,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0280k2k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dmitry_Peskov"
				},
				"name": "Dmitry Peskov",
				"salience": 0.00007627914,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.000075502125,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.000075072836,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.000075072836,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.000075072836,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04b6p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KGB"
				},
				"name": "KGB",
				"salience": 0.0000730385,
				"type": "ORGANIZATION"
			},
			{
				"name": "21WIRE",
				"salience": 0.00007293393,
				"type": "ORGANIZATION"
			},
			{
				"name": "politicians",
				"salience": 0.000072585324,
				"type": "PERSON"
			},
			{
				"name": "scandal",
				"salience": 0.000072585324,
				"type": "EVENT"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.000072585324,
				"type": "OTHER"
			},
			{
				"name": "operatives",
				"salience": 0.000072585324,
				"type": "ORGANIZATION"
			},
			{
				"name": "Administration",
				"salience": 0.000072585324,
				"type": "ORGANIZATION"
			},
			{
				"name": "Electoral Process",
				"salience": 0.000072585324,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theories",
				"salience": 0.000072585324,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.000072585324,
				"type": "OTHER"
			},
			{
				"name": "Josh Schwerin",
				"salience": 0.000071005794,
				"type": "PERSON"
			},
			{
				"name": "Josh Schwerin",
				"salience": 0.000071005794,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.000070861715,
				"type": "OTHER"
			},
			{
				"name": "point of view",
				"salience": 0.000070692106,
				"type": "OTHER"
			},
			{
				"name": "rant",
				"salience": 0.0000703522,
				"type": "EVENT"
			},
			{
				"name": "calls",
				"salience": 0.0000703522,
				"type": "OTHER"
			},
			{
				"name": "Tweeting",
				"salience": 0.0000703522,
				"type": "WORK_OF_ART"
			},
			{
				"name": "excuses",
				"salience": 0.0000703522,
				"type": "OTHER"
			},
			{
				"name": "email batches",
				"salience": 0.0000703522,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "anything",
				"salience": 0.0000703522,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.0000703522,
				"type": "OTHER"
			},
			{
				"name": "finish line",
				"salience": 0.0000703522,
				"type": "OTHER"
			},
			{
				"name": "scapegoat",
				"salience": 0.0000703522,
				"type": "OTHER"
			},
			{
				"name": "arms race",
				"salience": 0.0000703522,
				"type": "EVENT"
			},
			{
				"name": "sanctions",
				"salience": 0.0000703522,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0000703522,
				"type": "OTHER"
			},
			{
				"name": "airstrike",
				"salience": 0.00007003784,
				"type": "EVENT"
			},
			{
				"name": "claims",
				"salience": 0.00006982593,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00006922284,
				"type": "OTHER"
			},
			{
				"name": "email exchange",
				"salience": 0.000068283174,
				"type": "OTHER"
			},
			{
				"name": "action committee",
				"salience": 0.00006778025,
				"type": "ORGANIZATION"
			},
			{
				"name": "communications",
				"salience": 0.00006778025,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00006778025,
				"type": "OTHER"
			},
			{
				"name": "scam artists",
				"salience": 0.000066871275,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00006553437,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.00006553437,
				"type": "PERSON"
			},
			{
				"name": "business people",
				"salience": 0.00006553437,
				"type": "PERSON"
			},
			{
				"name": "assassination",
				"salience": 0.00006553437,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.000064421,
				"type": "PERSON"
			},
			{
				"name": "Official",
				"salience": 0.000064421,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Mich",
				"salience": 0.00006419795,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.00006419795,
				"type": "ORGANIZATION"
			},
			{
				"name": "raid",
				"salience": 0.000064086424,
				"type": "EVENT"
			},
			{
				"name": "nobody",
				"salience": 0.000063278545,
				"type": "PERSON"
			},
			{
				"name": "scandal",
				"salience": 0.0000631312,
				"type": "OTHER"
			},
			{
				"name": "announcements",
				"salience": 0.000062805186,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.000062480845,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.00006185097,
				"type": "ORGANIZATION"
			},
			{
				"name": "endorsement",
				"salience": 0.00006169321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.00006148143,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07s76_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_O'Keefe"
				},
				"name": "Project Veritas",
				"salience": 0.00006148143,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.00006148143,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.00006148143,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jumping the Shark",
				"salience": 0.00006148143,
				"type": "EVENT"
			},
			{
				"name": "Michael Fallon",
				"salience": 0.00006148143,
				"type": "PERSON"
			},
			{
				"name": "https://t.co/ALzpYm1Bb5",
				"salience": 0.00006148143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00006148143,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.000061424675,
				"type": "OTHER"
			},
			{
				"name": "History",
				"salience": 0.000061424675,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.000061424675,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.000061424675,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "delegations",
				"salience": 0.0000609155,
				"type": "PERSON"
			},
			{
				"name": "State Dept",
				"salience": 0.0000609155,
				"type": "ORGANIZATION"
			},
			{
				"name": "trio",
				"salience": 0.0000609155,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "double entendre",
				"salience": 0.0000609155,
				"type": "PERSON"
			},
			{
				"name": "sweep",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "coup d'etat",
				"salience": 0.0000609155,
				"type": "PERSON"
			},
			{
				"name": "whole",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "feet",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "stake geopolitically",
				"salience": 0.0000609155,
				"type": "EVENT"
			},
			{
				"name": "desperation",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "league",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "exposés",
				"salience": 0.0000609155,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media arm",
				"salience": 0.0000609155,
				"type": "ORGANIZATION"
			},
			{
				"name": "propaganda assets",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0000609155,
				"type": "OTHER"
			},
			{
				"name": "email issue",
				"salience": 0.000060459817,
				"type": "OTHER"
			},
			{
				"name": "Self-serving",
				"salience": 0.000060206654,
				"type": "OTHER"
			},
			{
				"name": "campaign manager",
				"salience": 0.000060147595,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01jgn3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Carville"
				},
				"name": "James Carville",
				"salience": 0.00005962101,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/079dy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saddam_Hussein"
				},
				"name": "Saddam",
				"salience": 0.000059185488,
				"type": "PERSON"
			},
			{
				"name": "Winnebagos of Death",
				"salience": 0.000059185488,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02qkt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurasia"
				},
				"name": "Eurasia",
				"salience": 0.000059185488,
				"type": "LOCATION"
			},
			{
				"name": "@GovHowardDean",
				"salience": 0.00005849677,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cpt28",
					"wikipedia_url": "http://en.wikipedia.org/wiki/TV_One_(U.S._TV_network)"
				},
				"name": "TV One",
				"salience": 0.0000579617,
				"type": "ORGANIZATION"
			},
			{
				"name": "ones",
				"salience": 0.000057901467,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "list",
				"salience": 0.00005717155,
				"type": "OTHER"
			},
			{
				"name": "plenty",
				"salience": 0.00005717155,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.000056743873,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.000056743873,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.000056743873,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.000056743873,
				"type": "OTHER"
			},
			{
				"name": "challenges",
				"salience": 0.000056743873,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000056743873,
				"type": "PERSON"
			},
			{
				"name": "text message",
				"salience": 0.000056743873,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000056743873,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.000056704223,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.000056704223,
				"type": "OTHER"
			},
			{
				"name": "government system",
				"salience": 0.00005653266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vznt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Samantha_Power"
				},
				"name": "Samantha Power",
				"salience": 0.000055379798,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War III",
				"salience": 0.000055379798,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.000055379798,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.00005462485,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.00005458668,
				"type": "WORK_OF_ART"
			},
			{
				"name": "scandals",
				"salience": 0.00005421622,
				"type": "OTHER"
			},
			{
				"name": "sexting' scandal",
				"salience": 0.00005421622,
				"type": "EVENT"
			},
			{
				"name": "Hillary Email",
				"salience": 0.00005335519,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Clinton Email",
				"salience": 0.00005335519,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00005170464,
				"type": "EVENT"
			},
			{
				"name": "server",
				"salience": 0.00005170464,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.00005170464,
				"type": "OTHER"
			},
			{
				"name": "mail server",
				"salience": 0.00005170464,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00005170464,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.00005142908,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.00005123169,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00005123169,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.00005123169,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00005123169,
				"type": "LOCATION"
			},
			{
				"name": "change",
				"salience": 0.00005123169,
				"type": "OTHER"
			},
			{
				"name": "circumstances",
				"salience": 0.00005123169,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00005123169,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.00005123169,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.00005123169,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00005100276,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.000050585855,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m2rv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flint,_Michigan"
				},
				"name": "Flint",
				"salience": 0.000050186925,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.000050186925,
				"type": "LOCATION"
			},
			{
				"name": "Hacker Owens",
				"salience": 0.000050186925,
				"type": "PERSON"
			},
			{
				"name": "@NubianAwakening",
				"salience": 0.000050186925,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06sf9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jake_Tapper"
				},
				"name": "Jake Tapper",
				"salience": 0.000050186925,
				"type": "PERSON"
			},
			{
				"name": "misdirection",
				"salience": 0.00004972496,
				"type": "OTHER"
			},
			{
				"name": "high stakes",
				"salience": 0.0000493185,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0000493185,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.000048949565,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.000048949565,
				"type": "OTHER"
			},
			{
				"name": "email case",
				"salience": 0.000048949565,
				"type": "OTHER"
			},
			{
				"name": "cover-up",
				"salience": 0.000048949565,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.000048949565,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.000048949565,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charge",
				"salience": 0.000048949565,
				"type": "OTHER"
			},
			{
				"name": "Party Scapegoat Former",
				"salience": 0.00004795134,
				"type": "ORGANIZATION"
			},
			{
				"name": "UN Aid Convoy",
				"salience": 0.00004795134,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Al Nusra Front",
				"salience": 0.00004795134,
				"type": "ORGANIZATION"
			},
			{
				"name": "pattern",
				"salience": 0.0000472646,
				"type": "OTHER"
			},
			{
				"name": "news reports",
				"salience": 0.00004587987,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00004587987,
				"type": "OTHER"
			},
			{
				"name": "Obama Justice Department",
				"salience": 0.000044836637,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lack",
				"salience": 0.000044558736,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "follies",
				"salience": 0.000044359622,
				"type": "PERSON"
			},
			{
				"name": "ability",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "table",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "beings",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "lying",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "CF",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "human trafficking",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "vacations",
				"salience": 0.000044359622,
				"type": "EVENT"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.000044359622,
				"type": "LOCATION"
			},
			{
				"name": "folder",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"name": "adult",
				"salience": 0.000044359622,
				"type": "PERSON"
			},
			{
				"name": "emergence",
				"salience": 0.000044359622,
				"type": "EVENT"
			},
			{
				"name": "pedophilia",
				"salience": 0.000044359622,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02fsq5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Broadcasting_Board_of_Governors"
				},
				"name": "Broadcasting Board of Governors",
				"salience": 0.000043293243,
				"type": "ORGANIZATION"
			},
			{
				"name": "top",
				"salience": 0.000042383603,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000042383603,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.000042383603,
				"type": "OTHER"
			},
			{
				"name": "None",
				"salience": 0.000042383603,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00004198119,
				"type": "OTHER"
			},
			{
				"name": "understatement",
				"salience": 0.000041108346,
				"type": "OTHER"
			},
			{
				"name": "COVER-UP",
				"salience": 0.000040286475,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.000038266353,
				"type": "OTHER"
			},
			{
				"name": "lawyer",
				"salience": 0.000038266353,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.000038266353,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.000038266353,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.000038266353,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.000038266353,
				"type": "OTHER"
			},
			{
				"name": "Image",
				"salience": 0.000038266353,
				"type": "WORK_OF_ART"
			},
			{
				"name": "TV",
				"salience": 0.000038266353,
				"type": "OTHER"
			},
			{
				"name": "foreign ministers",
				"salience": 0.000038266353,
				"type": "PERSON"
			},
			{
				"name": "campaign funds",
				"salience": 0.000038266353,
				"type": "OTHER"
			},
			{
				"name": "document dumps",
				"salience": 0.000038266353,
				"type": "OTHER"
			},
			{
				"name": "Nour al-Din al-Zenki",
				"salience": 0.00003748598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0q0r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voice_of_America"
				},
				"name": "Voice of America",
				"salience": 0.00003748598,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.00003748598,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02sn34",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kiev"
				},
				"name": "Kiev",
				"salience": 0.00003748598,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.00003748598,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.00003748598,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012dwfwl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kirby_(admiral)"
				},
				"name": "John Kirby",
				"salience": 0.00003748598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01v3sw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ABC_News"
				},
				"name": "ABC News",
				"salience": 0.000037359197,
				"type": "ORGANIZATION"
			},
			{
				"name": "Assad Regime Sarin Attack",
				"salience": 0.000034918812,
				"type": "EVENT"
			},
			{
				"name": "Boys Town",
				"salience": 0.000034918812,
				"type": "LOCATION"
			},
			{
				"name": "scrutiny",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "security protocols",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.00003313337,
				"type": "EVENT"
			},
			{
				"name": "job",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.00003313337,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.00003313337,
				"type": "PERSON"
			},
			{
				"name": "account",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "pseudonym",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.00003313337,
				"type": "LOCATION"
			},
			{
				"name": "grid",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "leg",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.00003313337,
				"type": "EVENT"
			},
			{
				"name": "campaign jet",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "liars club",
				"salience": 0.00003313337,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.000032039192,
				"type": "WORK_OF_ART"
			},
			{
				"name": "@ameritech.net",
				"salience": 0.000031817737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00003152669,
				"type": "LOCATION"
			},
			{
				"name": "WillDippel",
				"salience": 0.00003152669,
				"type": "OTHER"
			},
			{
				"name": "female",
				"salience": 0.000028817673,
				"type": "PERSON"
			},
			{
				"name": "dinner",
				"salience": 0.000028582108,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.000028454384,
				"type": "PERSON"
			},
			{
				"name": "Shootting Down MH17",
				"salience": 0.000027646254,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vnr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Security_Council"
				},
				"name": "UNSC",
				"salience": 0.000027297732,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03fkd7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Radio_Free_Asia"
				},
				"name": "Radio Free Asia",
				"salience": 0.000027297732,
				"type": "ORGANIZATION"
			},
			{
				"name": "WeAreYourGods Wanna",
				"salience": 0.000027297732,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05mg9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Osama_bin_Laden"
				},
				"name": "Bin Laden",
				"salience": 0.000027297732,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06zrg5s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boko_Haram"
				},
				"name": "Boko Haram",
				"salience": 0.000027297732,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/021wy4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Life_insurance"
				},
				"name": "Life Insurance",
				"salience": 0.000027297732,
				"type": "OTHER"
			},
			{
				"name": "Rebles",
				"salience": 0.000027297732,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.000027297732,
				"type": "LOCATION"
			},
			{
				"name": "Analyze_This_88 Barrak",
				"salience": 0.000027297732,
				"type": "OTHER"
			},
			{
				"name": "Media Cog",
				"salience": 0.000027297732,
				"type": "OTHER"
			},
			{
				"name": "Brad Dueringer",
				"salience": 0.000027297732,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02dkdx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alhurra"
				},
				"name": "Middle East Broadcasting Networks",
				"salience": 0.000027297732,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03qc9zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Screaming"
				},
				"name": "Shout",
				"salience": 0.000027297732,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Lawrence King",
				"salience": 0.000027297732,
				"type": "PERSON"
			},
			{
				"name": "Dinner With Top",
				"salience": 0.000026081727,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053fc5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Senate_of_Virginia"
				},
				"name": "Virginia State Senate",
				"salience": 0.000026081727,
				"type": "ORGANIZATION"
			},
			{
				"name": "Benghazi Hearing",
				"salience": 0.000026081727,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ds0x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Watergate_scandal"
				},
				"name": "Watergate",
				"salience": 0.00002354805,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00002354805,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0n4bfmd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2012_Benghazi_attack"
				},
				"name": "Benghazi",
				"salience": 0.00002354805,
				"type": "LOCATION"
			},
			{
				"name": "game",
				"salience": 0.000020720774,
				"type": "OTHER"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.00002038932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06c97",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_Nixon"
				},
				"name": "Richard Nixon",
				"salience": 0.00002038932,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02q_bk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gmail"
				},
				"name": "Gmail",
				"salience": 0.00002038932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.00002038932,
				"type": "PERSON"
			},
			{
				"name": "One Day",
				"salience": 0.000017588578,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0grkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ken_Starr"
				},
				"name": "Ken Starr",
				"salience": 0.000016856073,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0195yp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Radio_Free_Europe/Radio_Liberty"
				},
				"name": "Radio Free Europe/Radio Liberty",
				"salience": 0.00001152028,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i0.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/2-Clinton-Podesta-Email.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-01T16:48:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 91.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.293",
		"text": "November 1, 2016 By 21wire 4 Comments \nPatrick Henningsen 21st Century Wire \nThe longer this soap opera drags on, it’s becoming more and more evident that the Russian government did not ‘hack’ into the DNC, and Moscow is not feeding John Podesta’s emails to Wikileaks. For those who are deeply invested in this now official conspiracy theory, this might be a hard pill to swallow. \nThe White House and the Hillary Clinton campaign are now married to the idea that ‘Putin is hacking the US elections.’ In response, the President is weighing his options – tougher economic sanctions, revoking diplomatic status to Russian envoys in the US, or even deploying his newly developed ‘malicious cyber-activity’ tools. \nEven VP Joe Biden wants in on the action, threatening Moscow by saying,”We’re sending a message. We have the capacity to do it.” \nIt seems that where ever you turn nowadays, someone in Washington is issuing a threat against Russia. Are US-Russian relations really that bad, or does this trend have more to do with the defense industry and power struggles within the US? \nWhat was previously a stance reserved for right-wing neoconservative hawks and Cold War hold-outs has now infected America’s left-wing, and is a firm plank in the Democratic Party platform, as evidenced by Hillary Clinton’s constant anti-Russian rhetoric throughout this 2016 election cycle. Along with the White House, Clinton has now transformed the Democrats into the vanguard of Washington’s new anti-Russia movement. \nOn July 27th, Josh Rogin from the Washington Post wrote, “The Clinton campaign has decided to escalate its rhetoric on Russia. After Trump suggested Wednesday that if Russia had indeed hacked Clinton’s private email server it should release the emails, the Clinton campaign sent out its Democratic surrogates to bash Russia and Trump in a manner traditionally reserved for Republicans.” \nAnyone who was paying attention back then knew this ‘Russian hack’ talking point was purely political, but then again, who’s really paying attention these days? Certainly not the US media. \nYou can trace the genesis of the Democratic Party’s hardcore anti-Russian strategy back to when President Vladimir Putin made a mild passing remark about Donald Trump’s GOP primary success. From that point on, Trump’s political opponents saw this as an open target. In their words, ‘comparing one dictator to another.’ \nNever one to pass up an opportunity to score cheap political points, President Obama got in on the act, intensifying the Trump-Putin narrative to the level of bromance . “If you’ve made a career out of idealizing Ronald Reagan, then where were you when your own party’s nominee for president was kissing up to Vladimir Putin?” said Obama on Oct 20th at a Clinton rally in Miami. \nBacked by the Obama White House, Clinton and the media felt they had a green light to keep pressing ahead with blaming Russia – not only for the controversial DNC leaks, but also for hacking into US election systems in Arizona – a charge devoid of any evidence other than innuendo and speculation. The media’s coverage on this issue was deceptive from the onset. In a leading news release, entitled, “ Russian hackers targeted Arizona election system ,” we can see how after the cock-sure headline, the first paragraph would always sound definitive: \n“Hackers targeted voter registration systems in Illinois and Arizona, and the FBI alerted Arizona officials in June that Russians were behind the assault on the election system in that state.” \nBut then by the time you advanced down the story, the report would quickly retreat into a zone of uncertainty: \n“The bureau described the threat as “credible” and significant, “an eight on a scale of one to 10,” Matt Roberts, a spokesman for Arizona Secretary of State Michele Reagan (R), said Monday. As a result, Reagan shut down the state’s voter registration system for nearly a week.” \nAnd then, down to almost nothing… \n“It turned out that the hackers had not compromised the state system or even any county system. They had, however, stolen the username and password of a single election official in Gila County.” \nAt no point was any evidence ever given. Only ambiguous statements like, “Cyber security officials agree that this looks very much like a Russian government-directed hack.” \nAre American politicians so callous as to tempt geopolitical conflict in order to further their short-term political ambitions? Better yet, has American political life really arrived in such a dark cul de sac (translated in French: ‘bottom of the bag’) where politicians in power are so insecure as to make-up and propagate wild international conspiracy theories – in the middle a national election cycle? It’s a very depressing prospect, and yet, this is exactly what we are seeing in this 2016 Presidential Election. \nBehind Clinton’s wild hyperbolic rants about the Kremlin and Wikileaks, you will find the White House… \nOn October 7th, the Obama Administration formally accused the Russian government of stealing emails from the Democratic National Committee and other high-profile individuals including Hillary Clinton’s campaign manager John Podesta – giving them to Wikileaks. \nSoon, there was a queue of ‘national security’ politicians eager to hitch a ride on this bandwagon. Senator Ben Sasse (NE-R), a member of the Homeland Security Committee spouted out, “Russia must face serious consequences. Moscow orchestrated these hacks because [Russian President Vladimir] Putin believes Soviet-style aggression is worth it. The United States must upend Putin’s calculus with a strong diplomatic, political, ­cyber and economic response.” \nAccording to a Washington Post report by technology editor, Ellen Nakashima , the only ‘evidence’ that seems to be available on this story is a corporate analysis of the alleged ‘Russian government hacks’– provided by a US cyber security company called Crowdstrike . No actual specifics are given, so we are meant to take private firm Crowdstrike’s word for it. \nIMAGE: Crowdstrike cyber security. \nThe Post’s Nakashima then added: \n“The administration also blamed Moscow for the hack of the Democratic Congressional Campaign Committee and the subsequent leak of private email addresses and cellphone numbers of Democratic lawmakers.” \nAn online persona calling himself Guccifer 2.0 has claimed responsibility for posting the material. Those sites and that persona are “consistent with the methods and motivations of Russian-directed efforts,” the joint statement said. “… We believe, based on the scope and sensitivity of these efforts, that only Russia’s senior-most officials could have authorized these activities.” \nMoscow’s press secretary’s reply: “This is some sort of nonsense,” said Dmitry Peskov. \nDespite the constant repetition by Democrat media surrogates, and as CNN’s Maria Cardona said last night, no US national intelligence agency has really “confirmed” that Russia was behind the email hacks – and still no evidence , other than speculative guesswork, has been presented. \nLikewise, US intelligence agencies have never actually said definitively on record that “Russia did it,” thus, leaving the door open to walk-back the accusation at a later date. Standard Washington procedure of ambiguity. This little detail doesn’t seem to matter in this hyperbolic political climate though. It seems that the White House, Hillary Clinton and media operatives like Cardona – are quite happy living in what John Kerry recent dubbed as a ‘ parallel universe .’ \nStill, during the final Presidential debate, Hillary Clinton proudly crowed how “ 17 US intelligence agencies ” aka the “Intelligence Community”– all agreed that Russia did it. \nThe announcement, albeit vague, actually originated from the Office of the Director of National Intelligence. \n“We have 17 intelligence agencies, civilian and military, who have all concluded that these espionage attacks, these cyberattacks, come from the highest levels of the Kremlin, and they are designed to influence our election,” said Clinton. “I find that deeply disturbing.” \nWhat’s even more disturbing is the fact that Clinton is lying in front of a national audience. The highest levels of the Kremlin? Here are Clinton’s ’17 agencies’: \nAir Force Intelligence, Army Intelligence, Central Intelligence Agency, Coast Guard Intelligence, Defense Intelligence Agency, Energy Department, Homeland Security Department, State Department, Treasury Department, Drug Enforcement Administration, Federal Bureau of Investigation, Marine Corps Intelligence, National Geospatial Intelligence Agency, National Reconnaissance Office, National Security Agency, Navy Intelligence and the Office of the Director of National Intelligence. \nWhat does the Coast Guard Intelligence, National Geospatial Intelligence Agency or the Drug Enforcement Administration know about John Podesta’s emails? Answer: nothing. \nThe exact same thing happened following Wikileaks first trove of DNC emails back in July 2016 . The US government issued a vague accusatory statement, but would not actually name the culprit. Some might call that propaganda. \nIn both instances, the Obama Administration refused to present any evidence. Translated: there was no evidence. If there had been, the White House would have been shouting from the rooftops and using it as leverage to apply muscle in the UN over Washington’s flagging efforts in Syria. Both Obama Administration announcements were nothing more than dog whistles for Democrats and “journalists” working for hopelessly partisan outlets like New York Times and CNN – none of whom have bothered to press the White House for one ounce of evidence pertaining to the Party’s decree that “Russian is hacking the US election process.” If you actually look at the joint DNI-DHS statement issued on the matter, it contains no definitive statement: “… [the hacks] are consistent with the methods and motivations of Russian-directed efforts. These thefts and disclosures are intended to interfere with the US election process. Such activity is not new to Moscow — the Russians have used similar tactics and techniques across Europe and Eurasia, for example, to influence public opinion there. We believe, based on the scope and sensitivity of these efforts, that only Russia’s senior-most officials could have authorized these activities.” According to NSA intelligence worker-turned whistleblower William Binney , when asked about WikiLeaks and whether the Russians are ‘hacking’ US elections, he concluded that the cyber efforts against the DNC were more likely to be the work of a “ disgruntled U.S. intelligence worker. ” \nUnder partisan pressure from senior Democrat Senator Harry Reid , the FBI also initiated another investigation into “people linked to the Trump team with Russia.” Reid was unset about the DNC hacks and the Podesta emails and demanded the FBI do something about the Trump campaign. To date, the FBI haven’t come up with anything. \nTo be fair, Hillary would have every reason to believe that the Kremlin is behind the hack – because her staff read it to her from the campaign’s daily intelligence briefings, presumably, supplied from the US government’s much vaunted Intelligence Community . Of course, that’s the same Intelligence Community that briefed George W Bush about Saddam’s nonexistent nuclear weapons program, and who also briefed Colin Powell about Iraq’s imaginary “Winnebagos of Death” aka mobile anthrax labs disguised as senior double-wide camper vans. So, of course, they would know if Putin directed the DNC leaks and Podesta email hacks. \nFor those us who are skeptical of the great oxymoron known as ‘Washington Intelligence,’ I can almost hear the mainstream rebuttal now, “No, that was Iraq, that was Bush. We’re not like that. No, this time it’s different. This time we are sure the Russians did it!” \nIn 2014, Obama claimed that Kim’s notorious “Bureau 121” hacked into Sony Pictures. \nThis isn’t the first time that President Obama has cried wolf on a foreign ‘hack’ and then tried to sell it for political purposes. Back in December 2014, Obama claimed that North Korea had hacked Sony Pictures in Hollywood. Pentagon-CIA media proxy CNN quickly chimed in to support Washington’s conspiracy theory, floating a colorful story that Kim Jing-Un had deployed a secret underground hacking unit called ‘ Bureau 121 .’ Just like with today’s “Russian Hack” theory, no member of the mainstream press dared to question the White House’s ridiculous North Korean claim, and like the ‘Russian Hack’ claims, the only source cited for Sony hack was analysis provided by US firm Crowdstrike . \nJumping the Shark \nAfter their Democratic Party Convention on July 27th, the Clinton campaign machine put all of its chips on their Putin narrative. \nSoon after, a cadre of top Clinton national security surrogates then accused Trump of emboldening Russia in their evil plot to “destabilize and dominate the West.” Tom Donilon, a former national security adviser then accused Russia of ‘interfering’ with elections all over Europe and then accused Trump is helping Russia directly. At that point, they were in too deep to turn back. The biggest impact of @wikileaks ? Shining a spotlight on Russia’s attempt to undermine American democracy and Trump’s refusal to condemn it https://t.co/ALzpYm1Bb5 \n— Josh Schwerin (@JoshSchwerin) October 21, 2016 \nClinton spin doctors Josh Schwerin and Michael Fallon would stoop even lower by accusing RT of having possession of the Podesta emails even before Wikileaks did. Their only ‘evidence’ seemed to be Twitter posts by RT News which Clinton held up as ‘proof’ that the Kremlin was front-running Wikileaks email dumps. The Clinton braintrust failed to note that the Podesta emails were posted on Wikileaks own website well before RT News had tweeted about them. At that point it became obvious that the Clinton campaign was panicking and hysterically grabbing for any excuse they could get their hands on. We then watched, as one RT reporter after another dismantled the Clinton campaign’s desperate claims. It was embarrassing. \nThey could not face the uncomfortable fact that it was WikiLeaks head Julian Assange who chose the timing of the release of the DNC and Podesta emails. Rather than attack Assange himself, who happens to be popular with millennials (the very group Clinton struggles to connect with), her operatives opted to target Russia and Trump instead. \nEither way, the political strategy here is clear – to shoot the messenger . The Clinton campaign is stuck in permanent rear-guard mode, because based on the content of both the DNC Leaks, Wikileaks files, and Project Veritas video – their own Democratic Party has been discredited and exposed as a corrupt political organization. \nTheir other big problem is that despite all the outrage from Democrats and their mainstream media surrogates, none of the leaked content has been challenged on the basis of its authenticity. The results speak for themselves. The initial DNC leak of 20,000 emails resulted in the resignation of DNC Chairwoman Debbie Wasserman Schultz . They revealed the unthinkable: the Democratic National Committee actively worked to undermine the Presidential campaign of Bernie Sanders in favor of the establishment choice in Hillary Clinton. Sanders never had a chance. Honest commentators called this an affront to the democratic process, while party insiders and Clinton supporters pretended to be aloof as if it never happened. \nTo prove this point, both President Obama and Hillary Clinton then gave Wasserman-Schultz a glowing endorsement on the way out. “For the last eight years, Chairwoman Debbie Wasserman Schultz has had my back. This afternoon, I called her to let her know that I am grateful,” said Obama. Not surprisingly, Clinton thanked Wasserman Schultz, presumably for helping to knock her only competitor Sanders out of the Democrat primary race. “I am grateful to Debbie for getting the Democratic Party to this year’s historic convention in Philadelphia, and I know that this week’s events will be a success thanks to her hard work and leadership,” said Clinton. \nThe party had sold its soul to devil and no one seemed to care too much about it. \nParty Meltdown \nWasserman Schultz’s replacement didn’t fair much better. DNC Vice Chairwoman Donna Brazile was installed to serve as interim chair through the remainder election, but Brazile was soon skewered by subsequent Wikileaks batches – showing how, on more than one occasion, she fed debate questions obtained from corrupt mainstream media operatives – straight to Hillary Clinton. \n“ A March 12 email exchange shows Brazile stating that she received a town hall question from Roland Martin, a TV One host who co-moderated a March 13 town hall with CNN’s Jake Tapper.” \n“ A March 5 email shows that she shared a question with Clinton campaign chairman John Podesta and communications director Jennifer Palmieri that was to be asked in a March 6 debate hosted by CNN in Flint, Mich.” (Source: Daily Caller ) \nBrazile’s audacious fraud also helped contribute to her party’s planned sabotage of Democrat challenger Bernie Sanders. Watch Brazile go into full meltdown when confronted here: \n. Completely corrupt and still, Brazile even had to temerity to deny doing it when pressed on FOX News last week. Brazile’s reputation is so bad now that even CNN has severed ties with her – and that’s saying a lot. \nIn addition, it was also revealed how CNN’s head political commentator, Gloria Borger , was named by Podesta as one of a shortlist of ‘journalists’ the Clinton campaign would “work with” to gain favorable coverage. You’d think that CNN would have dropped Borger after this was revealed, but no. Amazingly, Borger is still leading CNN’s election coverage. \nClearly, CNN cannot be trusted to police itself when it comes to matters of outright collusion with Hillary Clinton and the Democratic Party. Ever-unbiased CNN's Gloria Borger refers to being in \"GOP hell\" and says she'll \"reach out soon\" to Podesta. Heart-warming #PodestaEmails13 pic.twitter.com/CQFdcJ12Q5 \n— 400-lb Hacker Owens (@NubianAwakening) October 21, 2016 \nWorse Than Watergate \nPerhaps a bigger scandal which the Obama White House and Clinton campaign operatives would like to bury – is the FBI’s investigation into the Clinton Foundation. Yesterday, the Wall Street Journal confirmed the existence of an internal feud between the FBI and the Justice Department, over whether or not to pursue an investigation into Clinton issue: \n“Some investigators grew frustrated, viewing FBI leadership as uninterested in probing the charity, these people said. Others involved disagreed sharply, defending FBI bosses and saying Mr. McCabe in particular was caught between an increasingly acrimonious fight for control between the Justice Department and FBI agents pursuing the Clinton Foundation case. It isn’t unusual for field agents to favor a more aggressive approach than supervisors and prosecutors think is merited. But the internal debates about the Clinton Foundation show the high stakes when such disagreements occur surrounding someone who is running for president.” \nThere’s more. It was also revealed last week how Jill McCabe, the wife of FBI Deputy Director, Andrew McCabe , received $467,500 in campaign funds in late 2015 for her Virginia State Senate run. This unusually large donation came via a political action committee run by Virginia Gov.Terry McAuliffe – a Clinton Foundation board member. After the funds were donated, Andrew McCabe was then put in charge of the Clinton Email case. In normal times, this one scandal would be bigger than Watergate, but these are not normal times . \nSo why is Washington going all out to deflect to Russia , and cover-up the Clinton scandals, and the Wikileaks document dumps? One reason is because the Clinton email issue goes all the way to the top – to the President himself. \nWhat 21WIRE reported on Oct 21st is how President Obama lied when first confronted about whether or not he knew about the existence of Hillary’s unauthorized private server. Obama told CBS News on March 7, 2015 that he only found out about Clinton’s server “the same time everybody else learned it through news reports.” The President’s lie was confirmed when newly released FBI documents showed that: \n“Obama used a pseudonym [bobama@ameritech.net] when communicating with then-Secretary of State Hillary Clinton by email, and at least one of those emails ended up on Clinton’s private email server.” \nSo, not only did Obama lie on national TV, but he also broke strict White House security protocols by carelessly exchanging private emails “off grid” with Hillary Clinton on a unsecured and unauthorized mail server – maybe to avoid the same scrutiny one would have on a government system. Who knows why he did it. \nSure, he’s not the first US President to lie, but like, Richard Nixon and Bill Clinton, Obama just joined that exclusive liars club – caught out lying to the American people. \nOn top of this, any communications made by the President of the United States are de facto labeled as “ born classified .” The same goes for any State Department communications with other foreign ministers. \nCOVER-UP: John Podesta and Huma Abedin on the Hillary campaign jet (Image: ABC News ) \nIt should be well known by now after watching both Attorney Generals Eric Holder and Loretta Lynch in action – that the Obama Justice Department (DOJ) is one of the most politicized in history. Bear that in mind when looking at the latest leg of the Hillary Email case. \nOn Friday, FBI Director James Comey set the election alight after announcing that the FBI would be reopening the Clinton email case – currently examining 650,000 emails found while investigating a laptop belonging to former US Congressman Anthony Weiner (estranged husband of top Clinton aid and long-time confidant Huma Abedin) who was snared in a ‘sexting’ scandal, allegedly involving a underaged female. So which DOJ person is in charge of this investigation? None other than Assistant Attorney General Peter J. Kadzik . Who is Kadzik? Zero Hedge reports: \n“Oh yes. Recall our post from last week, “ Clinton Campaign Chair Had Dinner With Top DOJ Official One Day After Hillary’s Benghazi Hearing ” in which we reported that John Podesta had dinner with one of the highest ranked DOJ officials the very day after Hillary Clinton’s Benghazi testimony? It was Peter Kadzik.” \nOh, and if that wasn’t good enough, Kadzik was also Podesta’s lawyer back in 1998 when Ken Starr was investigating Podesta over his role in helping Bill Clinton intern/mistress Monica Lewinsky land a job at the United Nations. The two were described as ‘best friends.’ FOX News confirms: \n“Fantastic lawyer. Kept me out of jail,” Podesta wrote on Sept. 8, 2008 to Obama aide Cassandra Butts, according to emails hacked from Podesta’s Gmail account and posted by WikiLeaks. \nTo call the Clinton circle incestuous would be an understatement, and on the whole, Americans are sick of it. \nRussia – The Party Scapegoat \nFormer Democratic Party leader Howard Dean was so incensed about the FBI reopening the case, he accused the FBI director of being in league with Russia, Tweeting: “Ironically Comey put himself on the same side as Putin.” Ironically Comey put himself on the same side as Putin. \n— Howard Dean (@GovHowardDean) October 29, 2016 \nAnother veteran party operative and lifetime Clinton defender, James Carville , was so upset by the FBI announcement that he accused “the KGB” working with Republicans to “hijack the election” during his wild rant on MSNBC . \n“I think this an outrage and I think the fact that the KGB is involved in this election is an outrage and I think the American people ought to take their democracy back regardless of what the press wants to do and the excuses they want to make for Comey. That’s what I think,” said Carville. \nMaybe someone can remind Carville that there is no KGB , and that the Soviet Union actually dissolved in 1991. \nThese are just a few scandals surrounding the Democratic Party and the Clinton campaign, along with the many exposés revealed through Wikileaks, and the Podesta email batches. Those are actual scandals with real tangible evidence – unlike the ‘Russians hacking the DNC and John Podesta and passing those to Wikileaks.’ \nSuffice to say, the Democratic Party machine has already demonstrated that it is prepared to say anything in order to deflect and divert attention away from the damning Wikileaks material, and also blame Donald Trump in the process. It should be obvious by now that in their desperation to push a highly comprised Hillary Clinton over the finish line on November 8th, the Washington establishment has concocted the story that ‘Putin is trying to influence our electoral process in the US.’ They’ve tried to lay this at the feet of Donald Trump, who Obama and Clinton claim has some secret special relationship with Vladimir Putin. The liberal mainstream media have made a meal out of this talking point, and anti-Russian war hawks on the Republican side love it too. For the White House and the Clinton campaign this seemed like the ultimate clean sweep – a perfect double entendre . \nThe geopolitical strategy behind this move was twofold. First, this non event would be used to advance immediate calls for sanctions against Russia. Secondly, the US could continue to lean on Russia in the UN over Syria. Previously, 21WIRE reported how Washington’s State Dept and UN delegations, led by the dynamic trio of John Kerry , Samantha Power , and John Kirby , already lied when levelling charges against Russia for war crimes in Aleppo, and again while accusing Russia and Syria of conducting an airstrike on a UN Aid Convoy in Syria. As we have already shown – that raid was most likely a ground attack carried out of US-backed ‘rebels’ Al Nusra Front, or Nour al-Din al-Zenki. \nWith so much at stake geopolitically, why would Washington lie about a potential World War III trigger event? If they are prepared to lie about this, what else are they prepared to lie about? \nThe demonization of all things Russian has definitely accelerated since late 2013 when the US engineered a coup d’etat in Kiev, Ukraine. Ever since that it’s been a go-to talking point for ginning-up and new transaltlantic arms race, as with Republican war hawks – and a convenient scapegoat for any politician requiring misdirection, like Clinton and the Democrats. When the new year rang in 2015, the newly appointed head of the U.S. Broadcasting Board of Governors, Andrew Lack, announced the new challenges facing America’s own state-run media arm that includes U.S. overseas propaganda assets including Voice of America, Radio Free Europe/Radio Liberty, the Middle East Broadcasting Networks and Radio Free Asia. Lack said , “We are facing a number of challenges from entities like Russia Today which is out there pushing a point of view, the Islamic State in the Middle East and groups like Boko Haram,” He was forced to resign shortly after that. \nWhat’s clear is that when it comes to all things Russian, there is an established pattern of compulsive lying by this US Administration. The list is too long to chronicle here, although ‘ Russian-backed Rebles Shootting Down MH17 ,’ and ‘ Assad Regime Sarin Attack in Damascus in 2013 ‘ certainly comes to mind. \nThat said, it’s hard to imagine a lie as egregious and potentially destructive than one which accuses the Russia government, a world nuclear power and member of the UNSC, of ‘Hacking Into the US Electoral Process.’ When you examine history however, what you will find is plenty of evidence documenting exactly how the US government and the CIA have altered and flipped 100 foreign elections throughout history, the attempted assassination of over 50 foreign leaders . Knowing all this, one might find it hard to take seriously Washington’s claims that Putin and Trump are trying manipulate the 2016 Election \nOn Oct 9, 2016, Russian Foreign Minister Sergei Lavrov laid it all on the table: \n“We have witnessed a fundamental change of circumstances when it comes to the aggressive Russophobia that now lies at the heart of U.S. policy towards Russia. It’s not just a rhetorical Russophobia, but aggressive steps that really hurt our national interests and pose a threat to our security.” \nSelf-serving, career political operatives in Washington are playing a dangerous game. History will mark this as one of the biggest political follies of the Obama-Clinton era. \nKnowing what we now know about the NSA and its ability to hack and grab any email or text message from anyone, anywhere – if Washington really wanted to know where the hacks came from, maybe they could start there. Far be it from anyone in Washington or the media to ever adopt that line of inquiry. \nStill, we’re waiting for the emergence of an adult in the room in Washington – before it’s too late. \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV \nFiled Under: Featured , Patrick Henningsen , Shout , US News Tagged With: CNN , Debbie Wasserman Schultz , Donna Brazile , Gloria Borger , Hillary Clinton , Media Cog , Russia , wikileaks WillDippel \nHere is an article that looks at the real story behind one of the more interesting conspiracy theories about the 2016 election: \nSometimes the real story is even more fascinating than any conspiracy theory. WeAreYourGods \nWanna bet money that the Weiner laptop, on which the over 600,000 emails were stored in a folder titled “Life Insurance”, holds information linking the CF to human trafficking and typical elite pedophilia “vacations”? Ever wonder why nobody ever really goes after the Clinton Foundation from a government office? Same old blackmail scheme involving underage sex slaves that was going on during the Boys Town scandal with Lawrence King and elite politicians and business people in the 80’s. Why would they stop? Brad Dueringer \nIt seems the most morally depraved beings are the ones we let run things. But they have help crafting “reality” with the tribe that owns the media Analyze_This_88 \nBarrak Obama and Hillary Clinton are both political scam artists. It’s amazing that a US President would invent a Russian Hacking conspiracy theory in order to drive a geopolitical agenda. But then again, Bush did the same with Bin Laden and 9/11. \nClinton on the other hand is pure corruption personified. She’s should never be allowed near public office. ",
		"thread_title": "Hillary’s ‘Russian Hack’ Hoax: The Biggest Lie of This Election Season",
		"title": "Hillary’s ‘Russian Hack’ Hoax: The Biggest Lie of This Election Season",
		"type": "conspiracy",
		"uuid": "236eaaea138082b5f4e8362de5e8e5584d8e7ef4"
	},
	"-KhIWHGxPqVeEPYQ_34p": {
		"author": "Shawn Helton",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T07:25:43.119+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Rodham Clinton",
				"salience": 0.2948921,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "William Jefferson Clinton",
				"salience": 0.25131577,
				"type": "LOCATION"
			},
			{
				"name": "Goldman Sachs Blankfein",
				"salience": 0.03767218,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.02688714,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.019655624,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0644gjz"
				},
				"name": "Marc Mezvinsky",
				"salience": 0.018728971,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015v0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gramm%E2%80%93Leach%E2%80%93Bliley_Act"
				},
				"name": "Financial Services Modernization Act of 1999",
				"salience": 0.017667115,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/015wqw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glass%E2%80%93Steagall_Legislation"
				},
				"name": "Glass-Steagall Act",
				"salience": 0.015381779,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.010625564,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea Clinton",
				"salience": 0.008259974,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dfb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citigroup"
				},
				"name": "Travelers Group",
				"salience": 0.008211338,
				"type": "ORGANIZATION"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.0073437635,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "Goldman, Sachs & Co.",
				"salience": 0.005454279,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09ggz5f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nomi_Prins"
				},
				"name": "Nomi Prins",
				"salience": 0.0049774707,
				"type": "PERSON"
			},
			{
				"name": "bankers",
				"salience": 0.004516759,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0041805455,
				"type": "ORGANIZATION"
			},
			{
				"name": "conglomeration",
				"salience": 0.0041072606,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congressional",
				"salience": 0.003935104,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0033695488,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington DC",
				"salience": 0.003194887,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hlwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JPMorgan_Chase"
				},
				"name": "JPMorgan Chase",
				"salience": 0.0031220857,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC Bank",
				"salience": 0.0030884875,
				"type": "ORGANIZATION"
			},
			{
				"name": "leak",
				"salience": 0.0030361193,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0028812354,
				"type": "PERSON"
			},
			{
				"name": "repeal",
				"salience": 0.002831843,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0026522316,
				"type": "PERSON"
			},
			{
				"name": "partner",
				"salience": 0.002644011,
				"type": "PERSON"
			},
			{
				"name": "co-chairs",
				"salience": 0.002411501,
				"type": "ORGANIZATION"
			},
			{
				"name": "banks",
				"salience": 0.0022784788,
				"type": "ORGANIZATION"
			},
			{
				"name": "banks",
				"salience": 0.0022784788,
				"type": "ORGANIZATION"
			},
			{
				"name": "Comment",
				"salience": 0.0022524178,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0jt5_vh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lehman_Brothers"
				},
				"name": "Lehman Brothers",
				"salience": 0.0022081058,
				"type": "ORGANIZATION"
			},
			{
				"name": "husband",
				"salience": 0.0021342204,
				"type": "PERSON"
			},
			{
				"name": "employees",
				"salience": 0.002096375,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04yh3vv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Avenue_Capital_Group"
				},
				"name": "Avenue Capital Group",
				"salience": 0.001983326,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.0019259334,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shawn Helton",
				"salience": 0.0018680119,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0018159794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0018008887,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.001776865,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jvs0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morgan_Stanley"
				},
				"name": "Morgan Stanley",
				"salience": 0.001745568,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.0016791571,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bz7v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edward_Mezvinsky"
				},
				"name": "Ed Mezvinsky",
				"salience": 0.0016438185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.0015991317,
				"type": "ORGANIZATION"
			},
			{
				"name": "ties",
				"salience": 0.0015879262,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0015879262,
				"type": "OTHER"
			},
			{
				"name": "removal",
				"salience": 0.0015551255,
				"type": "EVENT"
			},
			{
				"name": "Steagell",
				"salience": 0.0014733837,
				"type": "OTHER"
			},
			{
				"name": "heights",
				"salience": 0.0014441676,
				"type": "OTHER"
			},
			{
				"name": "family foundation",
				"salience": 0.0014334167,
				"type": "ORGANIZATION"
			},
			{
				"name": "firm",
				"salience": 0.0013932715,
				"type": "ORGANIZATION"
			},
			{
				"name": "presidency",
				"salience": 0.0013932715,
				"type": "OTHER"
			},
			{
				"name": "investment banking firm",
				"salience": 0.0013932715,
				"type": "ORGANIZATION"
			},
			{
				"name": "investment banking firms",
				"salience": 0.0013932715,
				"type": "ORGANIZATION"
			},
			{
				"name": "securities firms",
				"salience": 0.0013932715,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dlx_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marjorie_Margolies"
				},
				"name": "Marjorie Margolies-Mezvinsky",
				"salience": 0.0013848157,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0013397251,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/080t3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lloyd_Blankfein"
				},
				"name": "Lloyd Blankfein",
				"salience": 0.0013290787,
				"type": "PERSON"
			},
			{
				"name": "oversight",
				"salience": 0.0013022744,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0012401665,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0012065286,
				"type": "OTHER"
			},
			{
				"name": "merger",
				"salience": 0.0011506772,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0011506772,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0011506772,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0011506772,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0011506772,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0011506772,
				"type": "OTHER"
			},
			{
				"name": "investment banking",
				"salience": 0.00113486,
				"type": "OTHER"
			},
			{
				"name": "connections",
				"salience": 0.0010894065,
				"type": "OTHER"
			},
			{
				"name": "email server case",
				"salience": 0.0010894065,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02wr9k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Rubin"
				},
				"name": "Robert Rubin",
				"salience": 0.0010793632,
				"type": "PERSON"
			},
			{
				"name": "fund",
				"salience": 0.0010327948,
				"type": "OTHER"
			},
			{
				"name": "insider lobbyists",
				"salience": 0.0010211333,
				"type": "PERSON"
			},
			{
				"name": "campaign contributions",
				"salience": 0.0010211333,
				"type": "OTHER"
			},
			{
				"name": "lobbyists",
				"salience": 0.0010211333,
				"type": "PERSON"
			},
			{
				"name": "contributions",
				"salience": 0.0010211333,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.0010211333,
				"type": "EVENT"
			},
			{
				"name": "hold",
				"salience": 0.0010051035,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.00095047103,
				"type": "OTHER"
			},
			{
				"name": "banking elite",
				"salience": 0.0009485519,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.0009433877,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.00094336516,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00094336516,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00094336516,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00094336516,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.00094336516,
				"type": "ORGANIZATION"
			},
			{
				"name": "banking cartel",
				"salience": 0.00094336516,
				"type": "OTHER"
			},
			{
				"name": "consumer banking",
				"salience": 0.0009383239,
				"type": "OTHER"
			},
			{
				"name": "investment banking",
				"salience": 0.0009383239,
				"type": "OTHER"
			},
			{
				"name": "shadow banking",
				"salience": 0.0009383239,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00091499736,
				"type": "OTHER"
			},
			{
				"name": "subsidiary",
				"salience": 0.00090752234,
				"type": "ORGANIZATION"
			},
			{
				"name": "All",
				"salience": 0.000905117,
				"type": "OTHER"
			},
			{
				"name": "The Clinton Foundation",
				"salience": 0.0008824051,
				"type": "ORGANIZATION"
			},
			{
				"name": "activities",
				"salience": 0.0008790683,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01yx7f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_of_America"
				},
				"name": "Bank of America",
				"salience": 0.00086335733,
				"type": "ORGANIZATION"
			},
			{
				"name": "process",
				"salience": 0.0008517745,
				"type": "OTHER"
			},
			{
				"name": "hometown",
				"salience": 0.0008517745,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.0008517745,
				"type": "OTHER"
			},
			{
				"name": "Key",
				"salience": 0.0008517745,
				"type": "OTHER"
			},
			{
				"name": "family members",
				"salience": 0.0008517745,
				"type": "PERSON"
			},
			{
				"name": "examples",
				"salience": 0.0008517745,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0008517745,
				"type": "PERSON"
			},
			{
				"name": "amount",
				"salience": 0.0008517745,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0008517745,
				"type": "PERSON"
			},
			{
				"name": "fund",
				"salience": 0.0008431652,
				"type": "OTHER"
			},
			{
				"name": "watershed moment",
				"salience": 0.00082673674,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00080603454,
				"type": "PERSON"
			},
			{
				"name": "trip",
				"salience": 0.0007858505,
				"type": "EVENT"
			},
			{
				"name": "whistle",
				"salience": 0.00076120935,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0007585974,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0007583802,
				"type": "LOCATION"
			},
			{
				"name": "investors",
				"salience": 0.0007547794,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01p06z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_Times"
				},
				"name": "LA Times",
				"salience": 0.0007426896,
				"type": "ORGANIZATION"
			},
			{
				"name": "quality",
				"salience": 0.0007421472,
				"type": "OTHER"
			},
			{
				"name": "bombshell",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "BLANK CHECK",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "banking behemoth",
				"salience": 0.000737573,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawyers",
				"salience": 0.000737573,
				"type": "PERSON"
			},
			{
				"name": "share",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "collusion lane",
				"salience": 0.000737573,
				"type": "LOCATION"
			},
			{
				"name": "advisers",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.000737573,
				"type": "EVENT"
			},
			{
				"name": "pile",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "speaking fees",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "rulings",
				"salience": 0.000737573,
				"type": "OTHER"
			},
			{
				"name": "MONEY CHANGERS",
				"salience": 0.000737573,
				"type": "PERSON"
			},
			{
				"name": "sort",
				"salience": 0.0007144449,
				"type": "OTHER"
			},
			{
				"name": "Wall Street Selects 'Team Clinton",
				"salience": 0.0007069077,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02jw08",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sanford_I._Weill"
				},
				"name": "Sanford Weill",
				"salience": 0.00069425255,
				"type": "PERSON"
			},
			{
				"name": "high street",
				"salience": 0.00068764377,
				"type": "LOCATION"
			},
			{
				"name": "investment banker",
				"salience": 0.0006579004,
				"type": "ORGANIZATION"
			},
			{
				"name": "firewall",
				"salience": 0.00065375917,
				"type": "OTHER"
			},
			{
				"name": "pedigree",
				"salience": 0.0006501992,
				"type": "OTHER"
			},
			{
				"name": "skeleton key",
				"salience": 0.0006444206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k2gt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KPMG"
				},
				"name": "KPMG",
				"salience": 0.0006358114,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bankers",
				"salience": 0.00063334143,
				"type": "PERSON"
			},
			{
				"name": "banking",
				"salience": 0.00063334143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05rgkg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Henry_Paulson"
				},
				"name": "Henry Paulson",
				"salience": 0.00059994805,
				"type": "PERSON"
			},
			{
				"name": "founder",
				"salience": 0.0005976414,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0005832727,
				"type": "LOCATION"
			},
			{
				"name": "presidency",
				"salience": 0.0005735738,
				"type": "OTHER"
			},
			{
				"name": "firms",
				"salience": 0.0005735738,
				"type": "ORGANIZATION"
			},
			{
				"name": "repeal",
				"salience": 0.0005706128,
				"type": "OTHER"
			},
			{
				"name": "partnership",
				"salience": 0.00055612286,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.0005370793,
				"type": "ORGANIZATION"
			},
			{
				"name": "headquarters",
				"salience": 0.00053316087,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/049006",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alberto_Gonzales"
				},
				"name": "Alberto Gonzalez",
				"salience": 0.00053267315,
				"type": "PERSON"
			},
			{
				"name": "investors",
				"salience": 0.0005291894,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gpgk6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stephens_Inc."
				},
				"name": "Stephens Inc.",
				"salience": 0.0005242687,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Kingdom",
				"salience": 0.0005242687,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.0005120369,
				"type": "OTHER"
			},
			{
				"name": "Kenneth Guenther",
				"salience": 0.0005117077,
				"type": "PERSON"
			},
			{
				"name": "Roger Levy",
				"salience": 0.0005117077,
				"type": "PERSON"
			},
			{
				"name": "clients",
				"salience": 0.0004978609,
				"type": "PERSON"
			},
			{
				"name": "senior managing director",
				"salience": 0.0004966594,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05gh5c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phil_Angelides"
				},
				"name": "Phil Angelides",
				"salience": 0.00049565965,
				"type": "PERSON"
			},
			{
				"name": "merger",
				"salience": 0.0004797035,
				"type": "OTHER"
			},
			{
				"name": "loophole",
				"salience": 0.0004761286,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.00046628623,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0004602676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Ark",
				"salience": 0.00045396396,
				"type": "LOCATION"
			},
			{
				"name": "crash",
				"salience": 0.00044842585,
				"type": "EVENT"
			},
			{
				"name": "securities",
				"salience": 0.00044842585,
				"type": "OTHER"
			},
			{
				"name": "industry executives",
				"salience": 0.00044124064,
				"type": "PERSON"
			},
			{
				"name": "banking industry",
				"salience": 0.0004376348,
				"type": "OTHER"
			},
			{
				"name": "investors",
				"salience": 0.0004319987,
				"type": "PERSON"
			},
			{
				"name": "investors",
				"salience": 0.0004319987,
				"type": "PERSON"
			},
			{
				"name": "investors",
				"salience": 0.0004319987,
				"type": "PERSON"
			},
			{
				"name": "investors",
				"salience": 0.0004319987,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.0004203114,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.0004203114,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.0004203114,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.0004203114,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.0004203114,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0465sdr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Holder"
				},
				"name": "Eric Holder",
				"salience": 0.0004146026,
				"type": "PERSON"
			},
			{
				"name": "Vol.146",
				"salience": 0.0004146026,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ftvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Little_Rock,_Arkansas"
				},
				"name": "Little Rock",
				"salience": 0.00041045804,
				"type": "LOCATION"
			},
			{
				"name": "merger",
				"salience": 0.00040678648,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0004021281,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0004021281,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0004021281,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0004021281,
				"type": "PERSON"
			},
			{
				"name": "hedge fund",
				"salience": 0.0004015929,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.00040119197,
				"type": "ORGANIZATION"
			},
			{
				"name": "investment banking",
				"salience": 0.00040119197,
				"type": "OTHER"
			},
			{
				"name": "banking",
				"salience": 0.00040119197,
				"type": "OTHER"
			},
			{
				"name": "merger",
				"salience": 0.0003915989,
				"type": "OTHER"
			},
			{
				"name": "The Clintons",
				"salience": 0.00039095376,
				"type": "WORK_OF_ART"
			},
			{
				"name": "politics",
				"salience": 0.000389892,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.000389892,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.00038828896,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00038828896,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Alliances",
				"salience": 0.00038828896,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.00038828896,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.00038828896,
				"type": "LOCATION"
			},
			{
				"name": "globe",
				"salience": 0.00038828896,
				"type": "LOCATION"
			},
			{
				"name": "banking world",
				"salience": 0.00038828896,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0003871144,
				"type": "EVENT"
			},
			{
				"name": "hedge funds",
				"salience": 0.0003769156,
				"type": "OTHER"
			},
			{
				"name": "investor funds",
				"salience": 0.0003769156,
				"type": "OTHER"
			},
			{
				"name": "hedge funds",
				"salience": 0.0003769156,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.00037524945,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.0003738029,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01r2lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Forbes"
				},
				"name": "Forbes",
				"salience": 0.00037288445,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03qv4n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bear_Stearns"
				},
				"name": "Bear Stearns",
				"salience": 0.00036318894,
				"type": "ORGANIZATION"
			},
			{
				"name": "finance",
				"salience": 0.00036307273,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00035958443,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.00035346608,
				"type": "OTHER"
			},
			{
				"name": "Bank Act",
				"salience": 0.00035301,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ponzi schemes",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00035057735,
				"type": "PERSON"
			},
			{
				"name": "trading risk",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "removal",
				"salience": 0.00035057735,
				"type": "EVENT"
			},
			{
				"name": "nature",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "senior strategist",
				"salience": 0.00035057735,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "kingdom",
				"salience": 0.00035057735,
				"type": "LOCATION"
			},
			{
				"name": "investment banking system",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "fiat fraud",
				"salience": 0.00035057735,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00034819858,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00034100012,
				"type": "OTHER"
			},
			{
				"name": "managing director",
				"salience": 0.00033519792,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.00033207113,
				"type": "EVENT"
			},
			{
				"name": "firms",
				"salience": 0.00032826816,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05r6fc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Economic_policy_of_Bill_Clinton"
				},
				"name": "Clintonomics",
				"salience": 0.00032413288,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00032375308,
				"type": "OTHER"
			},
			{
				"name": "Pillage",
				"salience": 0.00032343552,
				"type": "OTHER"
			},
			{
				"name": "mergers",
				"salience": 0.0003196725,
				"type": "EVENT"
			},
			{
				"name": "partners",
				"salience": 0.00031827902,
				"type": "ORGANIZATION"
			},
			{
				"name": "politicians",
				"salience": 0.00031827902,
				"type": "PERSON"
			},
			{
				"name": "banking connections",
				"salience": 0.00031437984,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00031437984,
				"type": "OTHER"
			},
			{
				"name": "following",
				"salience": 0.00031437984,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00031437984,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00031437984,
				"type": "OTHER"
			},
			{
				"name": "Investment",
				"salience": 0.00031064358,
				"type": "OTHER"
			},
			{
				"name": "campaign funds",
				"salience": 0.00030768555,
				"type": "OTHER"
			},
			{
				"name": "slush fund",
				"salience": 0.00030768555,
				"type": "OTHER"
			},
			{
				"name": "Wall Street Racket To",
				"salience": 0.00030704724,
				"type": "OTHER"
			},
			{
				"name": "realm",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "retail",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0003035599,
				"type": "WORK_OF_ART"
			},
			{
				"name": "banking luminaries",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "speculating",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "stability",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "products",
				"salience": 0.0003035599,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "power",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "CEOs",
				"salience": 0.0003035599,
				"type": "PERSON"
			},
			{
				"name": "feet",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "bank regulations",
				"salience": 0.0003035599,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0003026416,
				"type": "ORGANIZATION"
			},
			{
				"name": "ground",
				"salience": 0.00029638477,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00029466784,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00029466784,
				"type": "OTHER"
			},
			{
				"name": "controversies",
				"salience": 0.00029466784,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.00029217187,
				"type": "ORGANIZATION"
			},
			{
				"name": "Swiss bank",
				"salience": 0.00029217187,
				"type": "ORGANIZATION"
			},
			{
				"name": "bank",
				"salience": 0.00029217187,
				"type": "ORGANIZATION"
			},
			{
				"name": "much",
				"salience": 0.0002872865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04qk7z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Center_for_Responsive_Politics"
				},
				"name": "Center for Responsive Politics",
				"salience": 0.00028560706,
				"type": "ORGANIZATION"
			},
			{
				"name": "lobbyists",
				"salience": 0.00028366546,
				"type": "PERSON"
			},
			{
				"name": "Secretary of State",
				"salience": 0.00028366546,
				"type": "PERSON"
			},
			{
				"name": "insurance companies",
				"salience": 0.00028366546,
				"type": "ORGANIZATION"
			},
			{
				"name": "contributions",
				"salience": 0.00028366546,
				"type": "OTHER"
			},
			{
				"name": "breaks",
				"salience": 0.0002825769,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0002806594,
				"type": "OTHER"
			},
			{
				"name": "media outlet",
				"salience": 0.0002777686,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00027363704,
				"type": "EVENT"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.0002726124,
				"type": "PERSON"
			},
			{
				"name": "most",
				"salience": 0.00027221607,
				"type": "OTHER"
			},
			{
				"name": "campaigns",
				"salience": 0.00027221607,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.00027221607,
				"type": "OTHER"
			},
			{
				"name": "revival",
				"salience": 0.00027221607,
				"type": "EVENT"
			},
			{
				"name": "alliance",
				"salience": 0.00027221607,
				"type": "ORGANIZATION"
			},
			{
				"name": "speeches",
				"salience": 0.00027221607,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Image Source",
				"salience": 0.00027107637,
				"type": "OTHER"
			},
			{
				"name": "Image Source",
				"salience": 0.00027107637,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.00027107637,
				"type": "EVENT"
			},
			{
				"name": "relationships",
				"salience": 0.00027107637,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00027107637,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.00027107637,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.00027107637,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.00026205185,
				"type": "WORK_OF_ART"
			},
			{
				"name": "events",
				"salience": 0.00026205185,
				"type": "EVENT"
			},
			{
				"name": "position",
				"salience": 0.00026205185,
				"type": "OTHER"
			},
			{
				"name": "banking deregulation",
				"salience": 0.00026205185,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.00026205185,
				"type": "WORK_OF_ART"
			},
			{
				"name": "influence",
				"salience": 0.00026205185,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.00026205185,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00026205185,
				"type": "EVENT"
			},
			{
				"name": "investment banking world",
				"salience": 0.00026205185,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00026205185,
				"type": "OTHER"
			},
			{
				"name": "oversimplification",
				"salience": 0.00026186876,
				"type": "OTHER"
			},
			{
				"name": "tenure",
				"salience": 0.00025856803,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.00025663403,
				"type": "PERSON"
			},
			{
				"name": "connection",
				"salience": 0.00025663403,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00025663403,
				"type": "OTHER"
			},
			{
				"name": "crash",
				"salience": 0.00025663403,
				"type": "EVENT"
			},
			{
				"name": "following",
				"salience": 0.00025663403,
				"type": "OTHER"
			},
			{
				"name": "securities",
				"salience": 0.00025663403,
				"type": "OTHER"
			},
			{
				"name": "equity investment",
				"salience": 0.00025358394,
				"type": "OTHER"
			},
			{
				"name": "bank stocks",
				"salience": 0.00024891333,
				"type": "OTHER"
			},
			{
				"name": "pardon",
				"salience": 0.00024577588,
				"type": "EVENT"
			},
			{
				"name": "excess",
				"salience": 0.00024577588,
				"type": "OTHER"
			},
			{
				"name": "prosecutors",
				"salience": 0.00024577588,
				"type": "PERSON"
			},
			{
				"name": "Ponzi schemes",
				"salience": 0.00024577588,
				"type": "OTHER"
			},
			{
				"name": "government debt",
				"salience": 0.00024577588,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00024577588,
				"type": "OTHER"
			},
			{
				"name": "bank stocks",
				"salience": 0.00024577588,
				"type": "OTHER"
			},
			{
				"name": "vice chairman",
				"salience": 0.00024577588,
				"type": "PERSON"
			},
			{
				"name": "wife",
				"salience": 0.00024577588,
				"type": "PERSON"
			},
			{
				"name": "loss",
				"salience": 0.00024577588,
				"type": "EVENT"
			},
			{
				"name": "state probes",
				"salience": 0.00024054218,
				"type": "OTHER"
			},
			{
				"name": "state probe",
				"salience": 0.00024054218,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.00024054218,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hmrpgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Huffington_Post"
				},
				"name": "Huffington Post",
				"salience": 0.00023896353,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cgc3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_Holding_Company_Act"
				},
				"name": "Bank Holding Company Act",
				"salience": 0.00023824061,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Citi-Travelers Act",
				"salience": 0.00023824061,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.00023774173,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00023774173,
				"type": "OTHER"
			},
			{
				"name": "Deals",
				"salience": 0.00023659875,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.00023659875,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.00023659875,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00023659875,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.00023659875,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02hszk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standard_Chartered"
				},
				"name": "Standard Chartered",
				"salience": 0.00023604948,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.00023500019,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.00023500019,
				"type": "EVENT"
			},
			{
				"name": "records",
				"salience": 0.00022792348,
				"type": "OTHER"
			},
			{
				"name": "Image Source",
				"salience": 0.00022696919,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00022388846,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00022221381,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.00022221381,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.00022221381,
				"type": "EVENT"
			},
			{
				"name": "INFLUENCE",
				"salience": 0.00022221381,
				"type": "OTHER"
			},
			{
				"name": "headquarters",
				"salience": 0.00022221381,
				"type": "LOCATION"
			},
			{
				"name": "bankruptcy",
				"salience": 0.00021823974,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034jx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Depression"
				},
				"name": "Great Depression",
				"salience": 0.00021575266,
				"type": "EVENT"
			},
			{
				"name": "combination",
				"salience": 0.00021552847,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.00021546047,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.00021281176,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tree",
				"salience": 0.00021281176,
				"type": "OTHER"
			},
			{
				"name": "apple",
				"salience": 0.00021281176,
				"type": "OTHER"
			},
			{
				"name": "pardon request",
				"salience": 0.00021281176,
				"type": "OTHER"
			},
			{
				"name": "iceberg",
				"salience": 0.00021281176,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.00021281176,
				"type": "EVENT"
			},
			{
				"name": "beginning",
				"salience": 0.00021281176,
				"type": "EVENT"
			},
			{
				"name": "infusion",
				"salience": 0.00021281176,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.00021281176,
				"type": "OTHER"
			},
			{
				"name": "net worth",
				"salience": 0.00021281176,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00021121994,
				"type": "PERSON"
			},
			{
				"name": "attendee",
				"salience": 0.00020578479,
				"type": "PERSON"
			},
			{
				"name": "losses",
				"salience": 0.00020578479,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "expectation",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "tune",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "reinstatement",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "halls",
				"salience": 0.00020486531,
				"type": "LOCATION"
			},
			{
				"name": "advocate",
				"salience": 0.00020486531,
				"type": "PERSON"
			},
			{
				"name": "disobedience",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.00020486531,
				"type": "PERSON"
			},
			{
				"name": "quote",
				"salience": 0.00020486531,
				"type": "OTHER"
			},
			{
				"name": "merger",
				"salience": 0.00020248159,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.00020140257,
				"type": "PERSON"
			},
			{
				"name": "INSIDERS",
				"salience": 0.00020062964,
				"type": "ORGANIZATION"
			},
			{
				"name": "employees",
				"salience": 0.00020062964,
				"type": "PERSON"
			},
			{
				"name": "debt",
				"salience": 0.00020062964,
				"type": "OTHER"
			},
			{
				"name": "excess",
				"salience": 0.00020062964,
				"type": "OTHER"
			},
			{
				"name": "tax breaks",
				"salience": 0.00020062964,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00020062964,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00020062964,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greek",
				"salience": 0.00019919123,
				"type": "LOCATION"
			},
			{
				"name": "speech",
				"salience": 0.00019823921,
				"type": "OTHER"
			},
			{
				"name": "fortune",
				"salience": 0.00019721556,
				"type": "OTHER"
			},
			{
				"name": "banking collapse",
				"salience": 0.00019169335,
				"type": "EVENT"
			},
			{
				"name": "crash",
				"salience": 0.00019169335,
				"type": "EVENT"
			},
			{
				"name": "securities",
				"salience": 0.00019169335,
				"type": "OTHER"
			},
			{
				"name": "collusion",
				"salience": 0.00019169335,
				"type": "OTHER"
			},
			{
				"name": "vetoes",
				"salience": 0.00018745831,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jwwgtt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Big_Six_Energy_Suppliers_(UK)"
				},
				"name": "Big Six",
				"salience": 0.00018681482,
				"type": "ORGANIZATION"
			},
			{
				"name": "Behind the Bonuses, Bailouts",
				"salience": 0.00018681482,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01kdws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wells_Fargo"
				},
				"name": "Wells Fargo",
				"salience": 0.00018681482,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.00018371629,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.00018045845,
				"type": "OTHER"
			},
			{
				"name": "settlement",
				"salience": 0.00018045845,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.000179673,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01d_ys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Warren_Buffett"
				},
				"name": "Warren Buffett",
				"salience": 0.00017631704,
				"type": "PERSON"
			},
			{
				"name": "Corporate Research Project",
				"salience": 0.00017631704,
				"type": "OTHER"
			},
			{
				"name": "investors",
				"salience": 0.00017553325,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00017553325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.00017457061,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.00017371995,
				"type": "EVENT"
			},
			{
				"name": "tax revenue",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "housing bubble",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "touch",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "loans",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "ceremony",
				"salience": 0.00017371995,
				"type": "EVENT"
			},
			{
				"name": "situation",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "sputniknews",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.00017371995,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.00017313244,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00016752405,
				"type": "ORGANIZATION"
			},
			{
				"name": "deregulation",
				"salience": 0.00016598211,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.00016598211,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media",
				"salience": 0.00016598211,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00016586613,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.0001617109,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01ljlg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Nation"
				},
				"name": "The Nation",
				"salience": 0.00016126847,
				"type": "ORGANIZATION"
			},
			{
				"name": "NEWS AT",
				"salience": 0.00016098833,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.00016098833,
				"type": "OTHER"
			},
			{
				"name": "total",
				"salience": 0.00015497678,
				"type": "OTHER"
			},
			{
				"name": "swarm",
				"salience": 0.00015497678,
				"type": "OTHER"
			},
			{
				"name": "Director",
				"salience": 0.00015461595,
				"type": "PERSON"
			},
			{
				"name": "Director",
				"salience": 0.00015461595,
				"type": "PERSON"
			},
			{
				"name": "Stuart Delery",
				"salience": 0.00015335319,
				"type": "PERSON"
			},
			{
				"name": "bailout",
				"salience": 0.0001527141,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.00015203172,
				"type": "OTHER"
			},
			{
				"name": "Authorities",
				"salience": 0.00015109431,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0001498593,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0001498593,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0001498593,
				"type": "OTHER"
			},
			{
				"name": "derivatives",
				"salience": 0.0001498593,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0001498593,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0001498593,
				"type": "OTHER"
			},
			{
				"name": "prosperity",
				"salience": 0.0001498593,
				"type": "OTHER"
			},
			{
				"name": "vice chairman",
				"salience": 0.0001498593,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0001498593,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09pfj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Bloomberg"
				},
				"name": "Michael Bloomberg",
				"salience": 0.00014803043,
				"type": "PERSON"
			},
			{
				"name": "files",
				"salience": 0.00014797026,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00014745373,
				"type": "PERSON"
			},
			{
				"name": "Rubinomics",
				"salience": 0.00014630693,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bw8r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secretary_of_the_Treasury"
				},
				"name": "Secretary of the Treasury",
				"salience": 0.00014561633,
				"type": "PERSON"
			},
			{
				"name": "connection",
				"salience": 0.00014137926,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.00014074754,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.00013959709,
				"type": "OTHER"
			},
			{
				"name": "connections",
				"salience": 0.00013959709,
				"type": "OTHER"
			},
			{
				"name": "collusion",
				"salience": 0.00013959709,
				"type": "EVENT"
			},
			{
				"name": "cases",
				"salience": 0.00013959709,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.00013959709,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.00013959709,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kt0d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bilderberg_Group"
				},
				"name": "Bilderberg Group",
				"salience": 0.00013624145,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00013337903,
				"type": "ORGANIZATION"
			},
			{
				"name": "firm",
				"salience": 0.00013337903,
				"type": "ORGANIZATION"
			},
			{
				"name": "firm",
				"salience": 0.00013337903,
				"type": "ORGANIZATION"
			},
			{
				"name": "firm",
				"salience": 0.00013337903,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.0001309641,
				"type": "ORGANIZATION"
			},
			{
				"name": "Eaglevale Hellenic Opportunity",
				"salience": 0.0001309641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.0001309641,
				"type": "LOCATION"
			},
			{
				"name": "ANOINTED",
				"salience": 0.0001309641,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pa",
				"salience": 0.0001309641,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04d_ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Presidential_Center"
				},
				"name": "Clinton Presidential Library",
				"salience": 0.0001309641,
				"type": "LOCATION"
			},
			{
				"name": "email probe",
				"salience": 0.00013084321,
				"type": "OTHER"
			},
			{
				"name": "derivatives",
				"salience": 0.00013034105,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.00012988604,
				"type": "OTHER"
			},
			{
				"name": "Microscope",
				"salience": 0.00012975864,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "range",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "separation",
				"salience": 0.00012975864,
				"type": "EVENT"
			},
			{
				"name": "CFR",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.00012975864,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.00012975864,
				"type": "EVENT"
			},
			{
				"name": "ledger",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "aftermath",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00012975864,
				"type": "PERSON"
			},
			{
				"name": "testimony",
				"salience": 0.00012975864,
				"type": "EVENT"
			},
			{
				"name": "legislation",
				"salience": 0.00012975864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tax hikes",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.00012975864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "spending cuts",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "deficits",
				"salience": 0.00012975864,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.0001293198,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.00012650788,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03wy1vs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_S._Reed"
				},
				"name": "John Reed",
				"salience": 0.0001260736,
				"type": "PERSON"
			},
			{
				"name": "Backroom",
				"salience": 0.0001260736,
				"type": "PERSON"
			},
			{
				"name": "Common Dreams",
				"salience": 0.0001260736,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07s4vw5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Financial_Crisis_Inquiry_Commission"
				},
				"name": "Financial Crisis Inquiry Commission",
				"salience": 0.0001246066,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05s0y9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Committee_on_Financial_Services"
				},
				"name": "House Banking Committee",
				"salience": 0.0001246066,
				"type": "ORGANIZATION"
			},
			{
				"name": "Commodities Futures Trading Commission",
				"salience": 0.0001246066,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.00012346685,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02bmd_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lower_Manhattan"
				},
				"name": "Lower Manhattan",
				"salience": 0.00012346685,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.000120872784,
				"type": "PERSON"
			},
			{
				"name": "Election",
				"salience": 0.000120872784,
				"type": "EVENT"
			},
			{
				"name": "banking cartel",
				"salience": 0.000120872784,
				"type": "OTHER"
			},
			{
				"name": "handling",
				"salience": 0.000120872784,
				"type": "OTHER"
			},
			{
				"name": "cartels",
				"salience": 0.000120872784,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.000120872784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025st0_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Bill_Clinton"
				},
				"name": "Clinton Administration",
				"salience": 0.0001179672,
				"type": "ORGANIZATION"
			},
			{
				"name": "understatement",
				"salience": 0.000117236064,
				"type": "OTHER"
			},
			{
				"name": "Chelsea Clinton Foundation",
				"salience": 0.00011305792,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00011056959,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.00011013881,
				"type": "OTHER"
			},
			{
				"name": "Image Source",
				"salience": 0.00011013881,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.00011013881,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.00010913139,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.00010913139,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.00010913139,
				"type": "PERSON"
			},
			{
				"name": "money laundering",
				"salience": 0.00010913139,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.00010913139,
				"type": "EVENT"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.00010913139,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00010913139,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.00010913139,
				"type": "OTHER"
			},
			{
				"name": "donations",
				"salience": 0.00010913139,
				"type": "OTHER"
			},
			{
				"name": "clients",
				"salience": 0.00010913139,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06jlt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Racketeer_Influenced_and_Corrupt_Organizations_Act"
				},
				"name": "RICO",
				"salience": 0.00010690595,
				"type": "PERSON"
			},
			{
				"name": "Bennett Grau",
				"salience": 0.00010690595,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.00010690595,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f94t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harlem"
				},
				"name": "Harlem",
				"salience": 0.00010690595,
				"type": "LOCATION"
			},
			{
				"name": "Mark Mallon",
				"salience": 0.00010690595,
				"type": "PERSON"
			},
			{
				"name": "ilovemyfreedom",
				"salience": 0.00010690595,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01gl9g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNBC"
				},
				"name": "CNBC",
				"salience": 0.00010690595,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.00010654439,
				"type": "PERSON"
			},
			{
				"name": "Data",
				"salience": 0.00010592192,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.00010458668,
				"type": "OTHER"
			},
			{
				"name": "crash",
				"salience": 0.00010427026,
				"type": "EVENT"
			},
			{
				"name": "crash",
				"salience": 0.00010427026,
				"type": "EVENT"
			},
			{
				"name": "securities",
				"salience": 0.00010427026,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Department of Justice",
				"salience": 0.00010359862,
				"type": "ORGANIZATION"
			},
			{
				"name": "syndicate",
				"salience": 0.000100681114,
				"type": "OTHER"
			},
			{
				"name": "mortgages",
				"salience": 0.00009928047,
				"type": "OTHER"
			},
			{
				"name": "payoff",
				"salience": 0.00009859935,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00009773151,
				"type": "WORK_OF_ART"
			},
			{
				"name": "All",
				"salience": 0.00009773151,
				"type": "PERSON"
			},
			{
				"name": "bank holding companies",
				"salience": 0.00009773151,
				"type": "ORGANIZATION"
			},
			{
				"name": "watch",
				"salience": 0.00009449322,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tax shelter violations",
				"salience": 0.00009449322,
				"type": "OTHER"
			},
			{
				"name": "update",
				"salience": 0.00009449322,
				"type": "OTHER"
			},
			{
				"name": "banking division",
				"salience": 0.00009449322,
				"type": "ORGANIZATION"
			},
			{
				"name": "choke-point",
				"salience": 0.00009449322,
				"type": "OTHER"
			},
			{
				"name": "narcotics",
				"salience": 0.00009449322,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.00009449322,
				"type": "OTHER"
			},
			{
				"name": "identities",
				"salience": 0.00009449322,
				"type": "OTHER"
			},
			{
				"name": "affairs",
				"salience": 0.00009449322,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.00009449322,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "board",
				"salience": 0.00009449322,
				"type": "ORGANIZATION"
			},
			{
				"name": "loyalty",
				"salience": 0.00009449322,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xmb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Reserve_System"
				},
				"name": "Federal Reserve",
				"salience": 0.000094236784,
				"type": "ORGANIZATION"
			},
			{
				"name": "investment giant",
				"salience": 0.00009330204,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.00009253939,
				"type": "OTHER"
			},
			{
				"name": "Deregulatory Steps to Financial Meltdown",
				"salience": 0.000092221715,
				"type": "WORK_OF_ART"
			},
			{
				"name": "James Donahue",
				"salience": 0.000092221715,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.000090284084,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.000090284084,
				"type": "OTHER"
			},
			{
				"name": "sound mortgages",
				"salience": 0.000090284084,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.000090284084,
				"type": "WORK_OF_ART"
			},
			{
				"name": "record profits",
				"salience": 0.000087567634,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.000081513856,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.000081513856,
				"type": "OTHER"
			},
			{
				"name": "tenure",
				"salience": 0.000081513856,
				"type": "OTHER"
			},
			{
				"name": "equity",
				"salience": 0.000081513856,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000081513856,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.000081513856,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.000081513856,
				"type": "OTHER"
			},
			{
				"name": "government agencies",
				"salience": 0.000081513856,
				"type": "ORGANIZATION"
			},
			{
				"name": "relief payouts",
				"salience": 0.000081513856,
				"type": "OTHER"
			},
			{
				"name": "homeowners",
				"salience": 0.000081513856,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01d_8r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_Foreign_Relations"
				},
				"name": "Council on Foreign Relations",
				"salience": 0.00007985157,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05kv8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oath_of_office"
				},
				"name": "SWORN",
				"salience": 0.00007985157,
				"type": "OTHER"
			},
			{
				"name": "thewhitehousespin",
				"salience": 0.00007985157,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01x7wr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brookings_Institution"
				},
				"name": "Brookings Institution",
				"salience": 0.00007985157,
				"type": "ORGANIZATION"
			},
			{
				"name": "Multinational Monitor",
				"salience": 0.00007985157,
				"type": "ORGANIZATION"
			},
			{
				"name": "Robert Weissman",
				"salience": 0.00007985157,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03902",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Geneva"
				},
				"name": "Geneva",
				"salience": 0.00007438318,
				"type": "LOCATION"
			},
			{
				"name": "Trump Analyze_This_88 So",
				"salience": 0.00007438318,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/084y_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitsubishi_UFJ_Financial_Group"
				},
				"name": "Mitsubishi UFJ Financial Group",
				"salience": 0.000074106305,
				"type": "ORGANIZATION"
			},
			{
				"name": "courts",
				"salience": 0.00007057994,
				"type": "ORGANIZATION"
			},
			{
				"name": "occasions",
				"salience": 0.00007057994,
				"type": "EVENT"
			},
			{
				"name": "interest",
				"salience": 0.00007057994,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00007057994,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.00007057994,
				"type": "OTHER"
			},
			{
				"name": "penalty",
				"salience": 0.00007057994,
				"type": "OTHER"
			},
			{
				"name": "Recession",
				"salience": 0.00007057994,
				"type": "EVENT"
			},
			{
				"name": "borrowers",
				"salience": 0.00007057994,
				"type": "PERSON"
			},
			{
				"name": "misconduct",
				"salience": 0.00007057994,
				"type": "OTHER"
			},
			{
				"name": "economic policy team",
				"salience": 0.00006743596,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06mzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Switzerland"
				},
				"name": "Swiss",
				"salience": 0.000067157496,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "Guardian",
				"salience": 0.00006601459,
				"type": "ORGANIZATION"
			},
			{
				"name": "mega-bank",
				"salience": 0.000061386905,
				"type": "ORGANIZATION"
			},
			{
				"name": "claims",
				"salience": 0.000058349517,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.000058149206,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01yqlp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Louis_Post-Dispatch"
				},
				"name": "St. Louis Post-Dispatch",
				"salience": 0.00005555893,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01rdhr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Review_of_Books"
				},
				"name": "New York Review",
				"salience": 0.00005555893,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gl4n5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Housing_Finance_Agency"
				},
				"name": "Federal Housing Finance Agency",
				"salience": 0.0000501618,
				"type": "ORGANIZATION"
			},
			{
				"name": "laundering",
				"salience": 0.000046057354,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01kb4x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Merrill_Lynch"
				},
				"name": "Merrill Lynch",
				"salience": 0.000043433192,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawsuits",
				"salience": 0.00002978681,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/10/Clinton-Gold-21WIRE-SLIDER-SH.jpg?fit=620%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-04T00:03:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 36.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.139",
		"text": "November 3, 2016 By Shawn Helton 1 Comment \nShawn Helton 21st Century Wire \nThe cozy relationship between Goldman Sachs and the Clintons has reached dizzying new heights in recent years, giving the Democratic Party nominee Hillary Clinton an immensely influential partner on Wall Street. \nAs the public and most of the mainstream media is still processing the political bombshell concerning the newly reopened FBI probe into the Hillary Clinton ’s email server case – the global investment banking firm Goldman Sachs quietly endorsed the Democratic presidential candidate this past week. \nThe financial ties that bind the Clintons and Wall Street banks like Goldman Sachs are nothing new, but never before have the connections been so exposed. Let’s take a trip down collusion lane to review some of the more questionable examples of their political and financial merger formed long ago… \n‘MONEY CHANGERS’– Wall Street’s Goldman Sachs are inextricably linked to the Clinton’s and The Clinton Foundation. (Photo illustration 21WIRE) \nThe Clintons & Goldman Sachs \nWhile campaigning for his first term in the White House, former president Bill Clinton received an enormous amount of support from Washington insider lobbyists and investment banking firms on Wall Street. \nAt the top of the pile sat Goldman Sachs… \nIn 1992, the LA Times reported that presidential nominee Bill Clinton,” received the largest share of his financial support–at least $2.6 million–from lawyers and lobbyists,” and that Clinton also received additional support from “…big securities firms such as Goldman, Sachs & Co. in New York and Stephens Inc. in his hometown of Little Rock, Ark. In fact, Goldman Sachs employees and their family members were responsible for the biggest contributions from a single firm: $98,700.” \nFor decades the Clintons have remained close allies to the banking behemoth Goldman Sachs and in the process, a mutually beneficial relationship has taken hold, something that even the NY Times admits: \n“Over 20-plus years, Goldman provided the Clintons with some of their most influential advisers, millions of dollars in campaign contributions and speaking fees, and financial support for the family foundation’s charitable programs.” \nBy now, there should be little doubt that the Clinton political machine is a wholly owned subsidiary of the Wall Street banking cartel. Their relationship was built over three decades. \nThe real watershed moment came here… \nBLANK CHECK: Bill Clinton laughs with Wall Street elites after signing the Financial Services Modernization Act in 1999. \n‘Key to the Kingdom’ \nIn one of the most significant financial rulings in the modern era, the Clinton presidency gave big banks like Goldman Sachs the skeleton key to the kingdom by deregulating the investment banking system almost entirely. \nThe Clinton/Goldman Sachs/Wall Street partnership was fully forged after the removal of the Glass-Steagall Act , which banking luminaries cynically named the “ Financial Services Modernization Act of 1999″ officially titled the Gramm- Leach-Bliley Act . The original Glass-Steagall was a depression-age four-part provision under the Bank Act of 1933 that strictly prohibited securities activities that could be harmful to investors – the same sort of rogue speculating and paper fiat fraud which triggered the Great Depression (1929-1941). In fact, the Gramm-Leach-Bliley Act which repealed Glass-Steagall, opened the door for the ‘shadow banking’ realm outside of regulatory oversight which led to a much higher trading risk, as banks became more interlinked. \nSimply put: Clinton’s repeal of Glass-Steagell removed the firewall between speculative investment banking and regular high street retail and consumer banking – which exposed everyone to toxic, subprime ponzi schemes and fake paper products being pushed around the globe by the banking elite – which ultimately causing the global economy to crash in 2008. All that can be laid at the feet of one William Jefferson Clinton. And Hillary still claims that, “My husband did so well with the economy.” Really? \nIn a cross-posted article featured at Huffington Post , Nomi Prins underscored the complicit nature of Wall Street and Washington after the removal of tighter bank regulations under the Clinton administration during the 1990’s: \n“To grasp the dangers that the Big Six banks (JPMorgan Chase, Citigroup, Bank of America, Wells Fargo, Goldman Sachs, and Morgan Stanley) presently pose to the financial stability of our nation and the world, you need to understand their history in Washington, starting with the Clinton years of the 1990s. Alliances established then (not exclusively with Democrats, since bankers are bipartisan by nature) enabled these firms to become as politically powerful as they are today and to exert that power over an unprecedented amount of capital. Rest assured of one thing: their past and present CEOs will prove as critical in backing a Hillary Clinton presidency as they were in enabling her husband’s years in office.” \nPrins herself was a former managing director at Goldman Sachs, senior managing director at Bear Stearns, as well as having worked as a senior strategist at the now defunct investment banking firm Lehman Brothers. Following the financial crash in 2007-2008, Prins blew the whistle on the banking world in a book entitled “ It Takes a Pillage : Behind the Bonuses, Bailouts, and Backroom Deals from Washington to Wall Street.” \nPrins has become an advocate for the reinstatement of the Glass-Steagall Act since departing from the investment banking world. \nThe media outlet Common Dreams described the merger between Citicorp and Travelers Group (becoming Citigroup), which was dubbed the ‘Citi-Travelers Act’ on Capitol Hill. It was a conglomeration that went hand in hand with the Clinton administration’s influence on banking deregulation marked by the repeal of Glass-Steagall: \n“Then, in 1998, in an act of corporate civil disobedience, Citicorp and Travelers Group announced they were merging. Such a combination of banking and insurance companies was illegal under the Bank Holding Company Act , but was excused due to a loophole that provided a two-year review period of proposed mergers. The merger was premised on the expectation that Glass-Steagall would be repealed. Citigroup’s co-chairs Sandy Weill and John Reed led a swarm of industry executives and lobbyists who trammeled the halls of Congress to make sure a deal was cut.” \nAt the time, it was the largest financial merger even though it was technically illegal , as stated by the former Bankers of America CEO Kenneth Guenther . In 1999 , after “12 attempts in 25 years,” Congress passed the Financial Services Modernization Act , which led to the repeal of Glass-Steagall. \nThe repeal of Glass-Steagall was pushed heavily by Citigroup’s co-CEO Sanford Weill and lobbyist Roger Levy and according to a report by The Nation : \n“They laid out more than $290 million for lobbying in 1998, according to the Center for Responsive Politics, and donated more than $150 million in the 1997–98 election cycle—a figure sure to be topped in 1999–2000.” \nHow much of those contributions made their way to the Clinton family and what kind of impact did this have after they left the White House? \nIn 2005, Bill Clinton was paid over half a million for speaking at three private Goldman events. \nIn 2013, after stepping down from her position as Secretary of State, Hillary Clinton gave a total of three paid speeches at Goldman Sachs events to the tune of $675,000 dollars, in which one attendee said “s he sounded more like a Goldman Sachs managing director,” according to a quote obtained by Politico . Indeed, Clinton gave a glowing speech to the Goldman gang and in the process, as Wikileaks released in early October , the Democratic nominee believes in “both a public and a private position” on Wall Street reform and that it is an “ oversimplification” to suggest that investment banking led to the most recent financial crisis. \nThat Clinton leak provided another window into the much protected alliance between finance and politics, but it’s only the tip of a much larger iceberg. \nIn 2015, the Washington Post reported that “Hillary Rodham Clinton and former president Bill Clinton earned in excess of $25 million for delivering 104 speeches since the beginning of 2014, a huge infusion to their net worth as she was readying for a presidential bid.” \n‘ANOINTED’: Chelsea Clinton with Goldman Sachs-backed hedge funder Marc Mezvinsky. \nThe Clinton family is chock-full of banking connections, as Chelsea Clinton ‘joined’ the Avenue Capital Group, which according to reports is a “…$12 billion hedge fund whose founder has contributed to many Democratic Party campaigns.” Chelsea is married to Marc Mezvinsky , a former investment banker for Goldman Sachs. Chelsea’s tenure at Avenue Capital Group was from 2006-2008 just prior to Hillary Clinton’s run for president in 2008. Since then Chelsea has risen to vice chairman inside the Clinton Foundation. \nMarc Mezvinsky was forced to close one of his hedge funds recently, Eaglevale Hellenic Opportunity , after had the fund lost most of its initial investor funds of $25 million – after blowing the money on secondhand junk Greek bank stocks and toxic government debt. \nThe apple doesn’t fall far from the tree… \nAs it turns out, Marc is the son of troubled former Congressman Ed Mezvinsky – another close friend of Team Clinton. \nPolitico reports on one of Ed Mezvinsky’s financial controversies in 1999: \n“In the waning days of Clinton’s presidency, federal prosecutors and the FBI were bearing down on former Rep. Ed Mezvinsky (D-Iowa), who had fallen for a series of Ponzi schemes and pulled in nearly $10 million money from other investors to cover his losses. “ \nContinuing, Politico outlined new information concerning a pardon request sent by from Ed Mezvinsky’s wife to then President Bill Clinton: \n“…records released last week by the Clinton Presidential Library in Little Rock and obtained by POLITICO show Mezvinsky and his then-wife — ex-Rep. Marjorie Margolies-Mezvinsky (D-Pa.) — pleaded with the former president for a presidential pardon to head off the looming federal case.” \nIn 2016, the Daily Mail reported the following: “Chelsea Clinton’s husband and his partners have suffered a huge loss after trying to bet on the revival of the Greek economy, and are now being forced to shut down one of their hedge funds. Marc Mezvinsky, 38, and his partners, former Goldman Sachs colleagues Bennett Grau and Mark Mallon, raised $25million from investors to buy up bank stocks and debt from the struggling nation. That fund however has lost 90 percent of its value, investors with direct knowledge of the situation told The New York Times , and will now be closed.” \n‘THE INSIDERS’– A ground-breaking ceremony at Goldman Sachs headquarters in Manhattan in 2005. Hillary Clinton is joined by Michael Bloomberg , Lloyd Blankfein (current Goldman Sachs CEO), Former Goldman Sachs CEO Henry Paulson. (Image Source: ilovemyfreedom ) \nThe NY Times further outlined the long-held Clinton/Goldman connection just two years before the 2007-2008 financial crisis: “The Clintons’ relationships with Wall Street deepened in the 2000s, when Mr. Clinton set up his foundation in Harlem and Mrs. Clinton was elected to the Senate from New York. That brought her in close touch with the big Wall Street firms, a source of jobs and tax revenue for New York — and a leading source of campaign funds for Mrs. Clinton. During her years in Congress, employees of Goldman donated in excess of $234,000 to Mrs. Clinton, more than those of any other company except Citigroup, according to the Center for Responsive Politics. Along with other New York politicians, Mrs. Clinton worked to obtain federal tax breaks to resuscitate Lower Manhattan after the Sept. 11, 2001, attacks, and those breaks helped Goldman build its new, roughly $2 billion headquarters. When it broke ground in 2005, Mrs. Clinton and other New York officials were on-site.” ‘HOW TO MONETIZE INFLUENCE’– Lloyd Blankfein at a Clinton Global Initiative event with Hillary Clinton. (Image Source: sputniknews ) The Wall Street Racket To understand who powers the Clinton Foundation’s billion dollar RICO influence-peddling slush fund, you need to understand how money is laundered between Wall Street and Washington DC. Goldman Sachs, JPMorgan Chase, Morgan Stanley, Bank of America and Citigroup and many others were all ordered to pay millions for misleading investors after the 2008 crash, then in April of 2016, Goldman was ordered to settle a federal and state probe for $5 Billion dollars. CNBC reported the following: \n“Goldman Sachs will pay $5 billion to settle federal and state probes into the bank’s sale of mortgage-backed securities before the financial crisis, the Justice Department announced Monday. \nAuthorities said Goldman misrepresented the quality of loans it securitized and then sold to investors ahead of the housing bubble and 2008 crisis. The settlement includes a $2.4 billion civil penalty, $1.8 billion in relief payouts to underwater homeowners and affected borrowers and $875 million to resolve various other claims. \nThis resolution holds Goldman Sachs accountable for its serious misconduct in falsely assuring investors that securities it sold were backed by sound mortgages, when it knew that they were full of mortgages that were likely to fail,” acting Associate Attorney General Stuart Delery said in a statement .” \nIn 2013, a Bloomberg article questioned how Goldman managed to survive and even thrive during the 2007-2008 economic crisis: \n“Whether Goldman could have gone the way of Lehman Brothers or Merrill Lynch remains the subject of much debate. Goldman maintains that it did not need, or want, the $10 billion bailout that Hank Paulson [ former Goldman alum] pushed on it and other firms in October 2008. But the fact remains that when the Federal Reserve allowed Goldman and Morgan Stanley—but not Lehman Brothers—to become bank holding companies on Sept. 21, 2008, Goldman was able, three days later, to raise $10 billion in equity, $5 billion from the public and another $5 billion from investor Warren Buffett. That would probably not have happened without the Fed’s expedited decision and support. (A week later, Morgan Stanley saved itself from bankruptcy when it negotiated a $9 billion equity investment from Mitsubishi UFJ Financial Group.)” \nAll told the Clinton friendly investment giant Goldman Sachs (after making record profits) became the fifth mega-bank ordered to pay billions to the Department of Justice after the financial crash of 2007-2008. In addition, the firm was ordered to pay $3 billion to the Federal Housing Finance Agency in 2014 – not including pending private lawsuits levied on the firm since the Great Recession. \nIn a New York Review article Goldman Sachs was already under investigation for committing fraud at least a year before the economic crash in 2007-2008: \n“Data gathered mostly from the Corporate Research Project , a public interest website, show that on thirteen occasions between 2009 and 2016, Goldman was penalized by US courts or government agencies for fraudulent or deceptive practices that were committed mostly between 2006 and 2009.” \n‘CASHING OUT’– Bill Clinton with his top economic strategist Robert Rubin. (Image Source: St. Louis Post-Dispatch ) \nWall Street Selects ‘Team Clinton’ \nThe Clinton connection to Goldman Sachs emerged in the early 1990’s as Robert Rubin , a former senior partner with Goldman (with a 26-year tenure with the firm), joined former President Clinton’s economic policy team, later becoming Secretary of the Treasury in 1995. Around that time, the Clinton presidency ushered in soaring tax hikes under the ‘Rubinomics’ banner (aka Clintonomics), the plan raised taxes on most Americans, specifically the middle class , in what was said to be the largest increase in American history at the time. \nAccording to Congressional record ( Vol.146 part 2 ), “In 1995, the economy grew at a sickly 1.5% – Clinton’s vetoes of spending cuts [insured] continued deficits well into the 21st Century.” \nIn a Multinational Monitor report entitled “Wall Street’s Best Investment: Ten Deregulatory Steps to Financial Meltdown,” by Robert Weissman and James Donahue , a clearer picture of the financial collusion spawned in the 1990’s under the Clinton administration was revealed: \n“During the Clinton Administration, Treasury Secretary Robert Rubin, who had run Goldman Sachs, enthusiastically promoted the legislation. In a 1995 testimony before the House Banking Committee, for example, Rubin argued that “the banking industry is fundamentally different from what it was two decades ago, let alone in 1933. … U.S. banks generally engage in a broader range of securities activities abroad than is permitted domestically. Even domestically, the separation of investment banking and commercial banking envisioned by Glass-Steagall has eroded significantly.” \nWith a pedigree that included Goldman Sachs, the Council on Foreign Relations (CFR), The Brookings Institution and the Bilderberg Group , Robert Rubin emerged in 1999 as the vice chairman at Citigroup (1999-2009) after overseeing its merger as well as helping to craft the repeal of Glass-Steagall while serving as Secretary of Treasury. Rubin made a fortune with Citigroup causing sharp criticism in media and from those within the financial sector following the 2007-2008 crash. Here’s a passage from Bloomberg regarding Rubin in the aftermath of the banking collapse: \n“When it collapsed, due in part to bank-friendly policies that Rubin advocated, he made more than $100 million while others lost everything. “You have to view people in a fair light,” says Phil Angelides, co-chair of the Financial Crisis Inquiry Commission, who credits Rubin for much of the Clinton-era prosperity. “But on the other side of the ledger are key acts, such as the deregulation of derivatives, or stopping the Commodities Futures Trading Commission from regulating derivatives, that in the end weakened our financial system and exposed us to the risk of financial disaster.” \n‘SWORN’– FBI director James Comey sworn in by former DOJ head Eric Holder. (Image Source: thewhitehousespin ) \nUnder the Microscope \nOver the summer 21WIRE observed some curious connections between the Clinton Foundation and FBI director James Comey , as well as his questionable handling of other cases related to the Clinton family. Here’s the following passage to consider in light of the new information related to the Clinton investigation: \n“Many will also be unaware that before Comey was installed by the Obama Administration as FBI Director, he was on the board of Director at HSBC Bank – a bank implicated in international money laundering , including the laundering of billions on behalf of international drugs and narcotics trafficking cartels. Forbes also points out where Comey was also at the key choke-point during the case involving dodgy auditor KPMG which followed on by the HSBC criminal case: \n“If Comey, and his boss Attorney General Alberto Gonzalez, had made a different decision about KPMG back in 2005, KPMG would not have been around to miss all the illegal acts HSBC and Standard Chartered SCBFF +% were committing on its watch. Bloomberg reported in 2007 that back in June of 2005, Comey was the man thrust into the position of deciding whether KPMG would live or die for its criminal tax shelter violations.” \nIn 2015, the Guardian discussed the financial relationship between HSBC and the Clinton Foundation receiving a startling $81 million in donations from clients of the large bank: \n“The charitable foundation run by Hillary Clinton and her family has received as much as $81m from wealthy international donors who were clients of HSBC’s controversial Swiss bank. \nLeaked files from HSBC’s Swiss banking division reveal the identities of seven donors to the Bill, Hillary and Chelsea Clinton Foundation with accounts in Geneva.” \nA new update on the FBI investigation into the Clinton Foundation was announced over the last 24 hours, in addition the recently reopened Clinton email probe from last week. It remains to be seen how in-depth this new investigation will be. \nTo call it collusion would be an understatement. When looking back at the financial affairs of the Clintons, Goldman Sachs and others on Wall Street – it’s clearer than ever that what we are looking at is a criminal syndicate. \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV Filed Under: Featured , Shawn Helton , US News Tagged With: 2016 Election , Clinton Foundation , Clinton Global Initiative , FBI , Goldman Sachs , Hillary Clinton , Trump Analyze_This_88 \nSo looks like Goldman Sachs Blankfein bankrolled Chelsea Clinton’s husband, no doubt another payoff for the Clintons loyalty to the Wall Street criminal banking cartel.. TRENDING ON 21WIRE ",
		"thread_title": "PARTNERS IN CRIME: Goldman Sachs, The Clintons & Wall Street",
		"title": "PARTNERS IN CRIME: Goldman Sachs, The Clintons & Wall Street",
		"type": "conspiracy",
		"uuid": "9705f82da90935a714b424d8fafa93fba75be998"
	},
	"-KhIWHXYgdwPjoNK27l6": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T04:46:01.202+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.21272364,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.12953733,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.10295982,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.05565877,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.05346382,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.034968153,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.027864391,
				"type": "LOCATION"
			},
			{
				"name": "email",
				"salience": 0.025518298,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/012ml0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Pilger"
				},
				"name": "John Pilger",
				"salience": 0.020348767,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.013188334,
				"type": "EVENT"
			},
			{
				"name": "email",
				"salience": 0.012689571,
				"type": "WORK_OF_ART"
			},
			{
				"name": "states",
				"salience": 0.011696269,
				"type": "LOCATION"
			},
			{
				"name": "revelation",
				"salience": 0.011556701,
				"type": "OTHER"
			},
			{
				"name": "princes",
				"salience": 0.010946455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.009773142,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0094363615,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.008301482,
				"type": "PERSON"
			},
			{
				"name": "revelation",
				"salience": 0.008266999,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.008076828,
				"type": "PERSON"
			},
			{
				"name": "email trove",
				"salience": 0.008076828,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.008076828,
				"type": "OTHER"
			},
			{
				"name": "dodge",
				"salience": 0.007923829,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0067874356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "story",
				"salience": 0.0067661125,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media",
				"salience": 0.005812899,
				"type": "OTHER"
			},
			{
				"name": "Conservative Post",
				"salience": 0.005608357,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.005535987,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.0054437425,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.0050246175,
				"type": "OTHER"
			},
			{
				"name": "RT Exclusive",
				"salience": 0.0049765883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Gulf",
				"salience": 0.0049031596,
				"type": "LOCATION"
			},
			{
				"name": "oil money",
				"salience": 0.004222959,
				"type": "OTHER"
			},
			{
				"name": "family foundation",
				"salience": 0.003981587,
				"type": "OTHER"
			},
			{
				"name": "Clinton's Foundation",
				"salience": 0.0039679403,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0039178887,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.0038447431,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.0034922129,
				"type": "OTHER"
			},
			{
				"name": "donations",
				"salience": 0.0033297115,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0033297115,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.0033297115,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0031393284,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0031180494,
				"type": "EVENT"
			},
			{
				"name": "21WIRE",
				"salience": 0.0029385542,
				"type": "ORGANIZATION"
			},
			{
				"name": "ramifications",
				"salience": 0.0029334552,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0028748752,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0028117532,
				"type": "ORGANIZATION"
			},
			{
				"name": "pressure",
				"salience": 0.0027676346,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0026964867,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0026964867,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0026391193,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0026391193,
				"type": "ORGANIZATION"
			},
			{
				"name": "gulf monarchies",
				"salience": 0.0025958933,
				"type": "PERSON"
			},
			{
				"name": "campaigning",
				"salience": 0.0023351237,
				"type": "EVENT"
			},
			{
				"name": "allegation",
				"salience": 0.0023351237,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0023351237,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0023351237,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0023351237,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0022479985,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0022479985,
				"type": "OTHER"
			},
			{
				"name": "indictments",
				"salience": 0.0022479985,
				"type": "OTHER"
			},
			{
				"name": "terrorist fighting organizations",
				"salience": 0.0022479985,
				"type": "ORGANIZATION"
			},
			{
				"name": "crisis",
				"salience": 0.0022479985,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0022334445,
				"type": "PERSON"
			},
			{
				"name": "consequence",
				"salience": 0.00211941,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0021035688,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0jt9h01",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam_in_Lebanon"
				},
				"name": "Sunni",
				"salience": 0.0020500722,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0019554212,
				"type": "PERSON"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.0019349499,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.0019307894,
				"type": "OTHER"
			},
			{
				"name": "monarchies",
				"salience": 0.0019268916,
				"type": "PERSON"
			},
			{
				"name": "funding",
				"salience": 0.0019064677,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0018216042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "FOX News",
				"salience": 0.0017699056,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.0016969383,
				"type": "EVENT"
			},
			{
				"name": "interview",
				"salience": 0.0016969383,
				"type": "EVENT"
			},
			{
				"name": "exports",
				"salience": 0.0016583103,
				"type": "OTHER"
			},
			{
				"name": "arms sales",
				"salience": 0.0016374185,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0015321925,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0015321925,
				"type": "OTHER"
			},
			{
				"name": "arms deal",
				"salience": 0.0014983587,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0014242615,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.0014242615,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0014242615,
				"type": "LOCATION"
			},
			{
				"name": "tenure",
				"salience": 0.0014242615,
				"type": "OTHER"
			},
			{
				"name": "dollar value",
				"salience": 0.0014242615,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0013838334,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Al Nusra Front",
				"salience": 0.0013838334,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al Qaeda",
				"salience": 0.0013838334,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0013838334,
				"type": "LOCATION"
			},
			{
				"name": "preview",
				"salience": 0.001371102,
				"type": "WORK_OF_ART"
			},
			{
				"name": "analysts",
				"salience": 0.0013538265,
				"type": "PERSON"
			},
			{
				"name": "NEWS",
				"salience": 0.0013267738,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0012677009,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0011828524,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.0011446076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0010738475,
				"type": "ORGANIZATION"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0010728567,
				"type": "PERSON"
			},
			{
				"name": "RT International",
				"salience": 0.0010445175,
				"type": "OTHER"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.001037321,
				"type": "OTHER"
			},
			{
				"name": "following",
				"salience": 0.0009985978,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.000894882,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "JP",
				"salience": 0.0008766386,
				"type": "ORGANIZATION"
			},
			{
				"name": "excerpt",
				"salience": 0.0008256083,
				"type": "WORK_OF_ART"
			},
			{
				"name": "21WIRE",
				"salience": 0.0008166218,
				"type": "OTHER"
			},
			{
				"name": "interview transcript",
				"salience": 0.0007748791,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0007044791,
				"type": "LOCATION"
			},
			{
				"name": "conflict",
				"salience": 0.0006825777,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "JA",
				"salience": 0.0006384359,
				"type": "LOCATION"
			},
			{
				"name": "Clinton Files",
				"salience": 0.0006384359,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qataris",
				"salience": 0.0006100026,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00047689187,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccans",
				"salience": 0.00047689187,
				"type": "PERSON"
			},
			{
				"name": "Ecuadorian Embassy",
				"salience": 0.00047689187,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0161c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bahrain"
				},
				"name": "Bahrainis",
				"salience": 0.00047689187,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/ISIS_Clinton-Foundation.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-04T15:33:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "\n21st Century Wire says… \nThis should be the biggest revelation yet from WikiLeaks already epic email trove. Will the US media cover this story? \nLast night, in an RT Exclusive interview conducted by award-winning filmmaker John Pilger, WikiLeaks editor and founder Julian Assange described what he believes is “the most significant email in the whole collection.” \nWikiLeaks reveals an early 2014 email where the outgoing Secretary of State Hillary Clinton was urging John Podesta , then advisor to President Barack Obama, to “bring pressure” on Gulf states Saudi Arabia and Qatar, “which are providing clandestine financial and logistic support to ISIL [Islamic State, IS, ISIS] and other radical Sunni groups.” \nThis constitutes proof that the Clinton Foundation knowingly accepting millions of dollars in ‘charitable’ donations from the same Gulf states which both Secretary Clinton and President Obama knew were funding ISIS, Al Nusra Front (al Qaeda in Syria) and known takfiri terrorist fighting organizations. \nIn addition, the Clinton’s Foundation took money from a number of other gulf monarchies: \n(Infographic: Conservative Post ) \nThis latest news validates what 21WIRE has been saying since the ‘ISIS crisis’ began in June 2014. \nAccording to FOX News , FBI sources have said that ‘indictments are likely’ for the Clinton Foundation investigation. One only wonders how this latest Assange revelation will factor into the wider investigation – as it goes right to the heart of the national security and foreign policy – two things which Clinton trades heavily on in her campaigning. \nAssange went on to explain the deep ramifications of this latest criminal allegation against Clinton and her family foundation: \n“All serious analysts know, and even the US government has agreed, that some Saudi figures have been supporting ISIS and funding ISIS, but the dodge has always been that it is some “rogue” princes using their oil money to do whatever they like, but actually the government disapproves. But that email says that it is the government of Saudi Arabia, and the government of Qatar that have been funding ISIS.” \nDuring their 25-minute interview filmed at the Ecuadorian Embassy in London, Assange and Pilger discussed the obvious conflict of interest between Clinton as Secretary of State, the Clinton Foundation and Gulf monarchies who financed them. The following is an excerpt from the interview transcript: \nJohn Pilger: The Saudis, the Qataris, the Moroccans, the Bahrainis, particularly the first two, are giving all this money to the Clinton Foundation, while Hillary Clinton is secretary of state, and the State Department is approving massive arms sales, particularly Saudi Arabia. \nJulian Assange: Under Hillary Clinton – and the Clinton emails reveal a significant discussion of it – the biggest-ever arms deal in the world was made with Saudi Arabia: more than $80 billion. During her tenure, the total arms exports from the US doubled in dollar value. \nJP: Of course, the consequence of that is that this notorious jihadist group, called ISIL or ISIS, is created largely with money from people who are giving money to the Clinton Foundation? \nJA: Yes. \nWatch a brief preview of the interview here: \nThe interview will air in full on RT International this Saturday Nov 5th. \nREAD MORE CLINTON NEWS AT: 21st Century Wire Clinton Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV ",
		"thread_title": "WikiLeaks: Hillary Clinton knew Saudi, Qatar were funding ISIS – but still took their money for Foundation",
		"title": "WikiLeaks: Hillary Clinton knew Saudi, Qatar were funding ISIS – but still took their money for Foundation",
		"type": "conspiracy",
		"uuid": "92841a56f9f241e8d06164ab78c68925ab0ac82b"
	},
	"-KhIWHl9sz79fSglM-OF": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T04:46:01.987+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.3641509,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.07236978,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026s38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slate_(magazine)"
				},
				"name": "Slate",
				"salience": 0.047714375,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.045015145,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.034340244,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.019254431,
				"type": "ORGANIZATION"
			},
			{
				"name": "work",
				"salience": 0.016737897,
				"type": "OTHER"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.014024489,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.013804211,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/066vhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Roberts"
				},
				"name": "John Roberts",
				"salience": 0.0131560825,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.012001326,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.011409874,
				"type": "ORGANIZATION"
			},
			{
				"name": "election process",
				"salience": 0.011409874,
				"type": "OTHER"
			},
			{
				"name": "fiction",
				"salience": 0.011409874,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.011409874,
				"type": "OTHER"
			},
			{
				"name": "fish tale",
				"salience": 0.011409874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "low",
				"salience": 0.011409874,
				"type": "OTHER"
			},
			{
				"name": "founder",
				"salience": 0.011409874,
				"type": "PERSON"
			},
			{
				"name": "claim",
				"salience": 0.011409874,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.008737963,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0070321187,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0070321187,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama White House",
				"salience": 0.0070321187,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012ml0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Pilger"
				},
				"name": "John Pilger",
				"salience": 0.0067223865,
				"type": "PERSON"
			},
			{
				"name": "conspiracy story",
				"salience": 0.0065118736,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.0054779933,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.005433299,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0050551347,
				"type": "OTHER"
			},
			{
				"name": "21WIRE",
				"salience": 0.0050220117,
				"type": "ORGANIZATION"
			},
			{
				"name": "term",
				"salience": 0.0047056745,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0047056745,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0047056745,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0047056745,
				"type": "OTHER"
			},
			{
				"name": "campaign staff",
				"salience": 0.0047056745,
				"type": "PERSON"
			},
			{
				"name": "shark",
				"salience": 0.0047056745,
				"type": "OTHER"
			},
			{
				"name": "news story",
				"salience": 0.0043976973,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0043976973,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bottom line",
				"salience": 0.0042521907,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0042521907,
				"type": "OTHER"
			},
			{
				"name": "Server",
				"salience": 0.0040420867,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0039831484,
				"type": "OTHER"
			},
			{
				"name": "election season",
				"salience": 0.0038109825,
				"type": "EVENT"
			},
			{
				"name": "works",
				"salience": 0.0038109825,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0037054718,
				"type": "ORGANIZATION"
			},
			{
				"name": "@HillaryClinton",
				"salience": 0.003345926,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0033003644,
				"type": "OTHER"
			},
			{
				"name": "headline",
				"salience": 0.0031772489,
				"type": "OTHER"
			},
			{
				"name": "clickbait blog",
				"salience": 0.0031772489,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.0031772489,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0031772489,
				"type": "PERSON"
			},
			{
				"name": "news outlet",
				"salience": 0.0031772489,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0031116214,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05_5d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Political_party"
				},
				"name": "Party",
				"salience": 0.0030512218,
				"type": "ORGANIZATION"
			},
			{
				"name": "https://t.co/D8oSmyVAR4 pic.twitter.com/07dRyEmPjX",
				"salience": 0.0028975552,
				"type": "OTHER"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.002734869,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.0026946187,
				"type": "OTHER"
			},
			{
				"name": "RETRACTION",
				"salience": 0.0026946187,
				"type": "OTHER"
			},
			{
				"name": "FEUD",
				"salience": 0.0026946187,
				"type": "OTHER"
			},
			{
				"name": "pale",
				"salience": 0.0026946187,
				"type": "OTHER"
			},
			{
				"name": "obsession",
				"salience": 0.0026946187,
				"type": "OTHER"
			},
			{
				"name": "lemon",
				"salience": 0.0026946187,
				"type": "OTHER"
			},
			{
				"name": "antics",
				"salience": 0.0026946187,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0026946187,
				"type": "EVENT"
			},
			{
				"name": "legitimacy",
				"salience": 0.0023738216,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0023584517,
				"type": "OTHER"
			},
			{
				"name": "Foer",
				"salience": 0.0023463566,
				"type": "OTHER"
			},
			{
				"name": "surrogates",
				"salience": 0.0023247753,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0023247753,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.0023247753,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0brrkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Franklin_Foer"
				},
				"name": "Franklin Foer",
				"salience": 0.0022588007,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0022418445,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.002031837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01r2lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Forbes"
				},
				"name": "Forbes",
				"salience": 0.002031837,
				"type": "ORGANIZATION"
			},
			{
				"name": "superpower",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "tabloid sting",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "mic",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "audio excerpt",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "high priestess",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "cult coven",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "party rank",
				"salience": 0.0020131466,
				"type": "OTHER"
			},
			{
				"name": "pro-Democratic",
				"salience": 0.0019560095,
				"type": "ORGANIZATION"
			},
			{
				"name": "spoils",
				"salience": 0.0019136005,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0017089144,
				"type": "ORGANIZATION"
			},
			{
				"name": "men",
				"salience": 0.0017072391,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0016932915,
				"type": "OTHER"
			},
			{
				"name": "surrogate",
				"salience": 0.0016932915,
				"type": "OTHER"
			},
			{
				"name": "election season",
				"salience": 0.0016932915,
				"type": "EVENT"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0014662673,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0014662673,
				"type": "PERSON"
			},
			{
				"name": "strategy",
				"salience": 0.0014662673,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0014115361,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0014009817,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0fx3jl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/TMZ"
				},
				"name": "TMZ",
				"salience": 0.0012391574,
				"type": "ORGANIZATION"
			},
			{
				"name": "anything",
				"salience": 0.0012023785,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.0010953265,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.0010953265,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0010953265,
				"type": "OTHER"
			},
			{
				"name": "deceit",
				"salience": 0.0010953265,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0010953265,
				"type": "PERSON"
			},
			{
				"name": "dishonesty",
				"salience": 0.0010953265,
				"type": "OTHER"
			},
			{
				"name": "ambitions",
				"salience": 0.0010953265,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00090246834,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i0.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Hillary-jump-the-shark.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-04T14:30:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.417",
		"text": "\n21st Century Wire says… \nYesterday, WikiLeaks editor and founder Julian Assange confirmed what 21WIRE already knew – that Hillary Clinton and the Obama White House’s claim of the US election process being “hacked by the Russian government” was a desperate work of fiction. Not content with that fish tale, Hillary Clinton took the narrative to an embarrassing new low (if that was even possible) with another, wilder made-up conspiracy story about the Russians. \nThe following statement made by Hillary Clinton yesterday epitomizes the term “ jumping the shark “: It's time for Trump to answer serious questions about his ties to Russia. https://t.co/D8oSmyVAR4 pic.twitter.com/07dRyEmPjX \n— Hillary Clinton (@HillaryClinton) October 31, 2016 \nApparently, Hillary Clinton’s campaign staff fed her a planted online news story (by the Clinton campaign?) which ran on a questionable pro-Democratic Party online news outlet. On Monday, the Slate ran the story by one of its alleged “journalists” named Franklin Foer , complete with a clickbait blog-like headline, “Was a Trump Server Communicating With Russia?” \nWhatever legitimacy the Slate had before last night, just evaporated. \nJohn Roberts from Forbes explains, “The bottom line is that Slate screwed up by publishing this in the first place, and by adding more kooky misinformation to an already addled election season. As for Foer, he says on Twitter a “follow up” piece is in the works.” \nRoberts rightly points out that the only follow-up story for this lemon should start with the word “RETRACTION.” \nCYBER FEUD: Assange believes Clinton has gone beyond the pale with her Russian conspiracy obsession. \nDuring his exclusive interview with award-winning filmmaker John Pilger, when asked what he thought of Hillary Clinton’s shrill antics, Julian Assange said, “ “I actually feel quite sorry for Hillary Clinton as a person, because I see someone who is eaten alive by their ambitions, tormented literally to the point where they become sick.” \nThe saddest thing about this and the other dishonest and destructive actions of the Clinton campaign and the Democratic Party – is that no one in the party seems to see anything wrong with this level of deceit and dishonesty. Like Hillary Clinton in her sociopathic path to power, the party rank and file are acting like a cult coven following their high priestess. \nStill, Clinton surrogates in the media are trying to equate Clinton simultaneously scapegoating and baiting another nuclear superpower – with a decade-old misogynist hot mic audio excerpt of Donald Trump in a TMZ-style tabloid sting. That pretty much sums up Democratic Party strategy for this election season. \nAssange was right. Clinton, the Democratic Party and their surrogate, are eating themselves. Such are the spoils of power in Washington that men and women will do and say anything to have it. \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV ",
		"thread_title": "Hillary Clinton Jumps the Shark with ‘Trump’s Secret Russian Server’ Conspiracy Theory",
		"title": "Hillary Clinton Jumps the Shark with ‘Trump’s Secret Russian Server’ Conspiracy Theory",
		"type": "conspiracy",
		"uuid": "86bf9b50cfecaeb861219f63245d4c71d345438e"
	},
	"-KhIWHvN4fXoG2G9EvqG": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T01:29:27.768+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.40529025,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04s2lr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michel_Chossudovsky"
				},
				"name": "Michel Chossudovsky",
				"salience": 0.0796055,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.059031695,
				"type": "ORGANIZATION"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.05425197,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0509926,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.044267,
				"type": "OTHER"
			},
			{
				"name": "fanfare",
				"salience": 0.044267,
				"type": "OTHER"
			},
			{
				"name": "Patrick Henningsen",
				"salience": 0.028988695,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.027417095,
				"type": "ORGANIZATION"
			},
			{
				"name": "claim",
				"salience": 0.018394865,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.018394865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.015004568,
				"type": "LOCATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.014358619,
				"type": "OTHER"
			},
			{
				"name": "guest",
				"salience": 0.012921899,
				"type": "OTHER"
			},
			{
				"name": "foreign policy record",
				"salience": 0.012441598,
				"type": "OTHER"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.01071467,
				"type": "PERSON"
			},
			{
				"name": "editor",
				"salience": 0.010557458,
				"type": "PERSON"
			},
			{
				"name": "hawks",
				"salience": 0.010557458,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.010557458,
				"type": "OTHER"
			},
			{
				"name": "SUNDAY WIRE",
				"salience": 0.010182324,
				"type": "OTHER"
			},
			{
				"name": "fetish",
				"salience": 0.007893553,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.007893553,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.007893553,
				"type": "OTHER"
			},
			{
				"name": "Episode #158",
				"salience": 0.007670015,
				"type": "OTHER"
			},
			{
				"name": "www.globalresearch.ca",
				"salience": 0.006506689,
				"type": "OTHER"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.005752802,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0042992476,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0042992476,
				"type": "OTHER"
			},
			{
				"name": "globe",
				"salience": 0.0042992476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0026472618,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0026472618,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i1.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-hillary-russia-hawk-nuke-.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-06T07:48:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.983",
		"text": "\n21st Century Wire says… \nAmid great mainstream media and Democratic Party fanfare, Hillary Clinton’s candidacy has been based on a claim she is “most experienced” candidate in history, and highlighting her foreign policy record in particular. What would a Clinton foreign policy really look like? \nOn Episode #158 of the SUNDAY WIRE, host Patrick Henningsen spoke with a special guest, Professor Michel Chossudovsky , founder & editor of www.globalresearch.ca about ‘Hillary’s hawks’ and what a Clinton presidency will look like in terms of US-backed wars around the globe, as well as Washington’s current fetish with ‘sustainable’ nuclear conflicts. \nListen to this excellent discussion: \n. \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV ",
		"thread_title": "Prof Michel Chossudovsky discusses Hillary Clinton’s foreign policy & emerging nuclear risks",
		"title": "Prof Michel Chossudovsky discusses Hillary Clinton’s foreign policy & emerging nuclear risks",
		"type": "conspiracy",
		"uuid": "e4c1a7542c447d908a878fd429fef0f5cf9130d4"
	},
	"-KhIWI5aBEp_vz9siTxM": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T22:24:56.764+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Patrick Henningsen",
				"salience": 0.35807914,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.1431496,
				"type": "LOCATION"
			},
			{
				"name": "Marcus Papadopoulos",
				"salience": 0.059810575,
				"type": "PERSON"
			},
			{
				"name": "Comment Episode #",
				"salience": 0.04151462,
				"type": "WORK_OF_ART"
			},
			{
				"name": "SUNDAY WIRE SHOW",
				"salience": 0.039848913,
				"type": "EVENT"
			},
			{
				"name": "broadcast",
				"salience": 0.03646532,
				"type": "OTHER"
			},
			{
				"name": "talk radio",
				"salience": 0.023196295,
				"type": "OTHER"
			},
			{
				"name": "TIMES",
				"salience": 0.015186974,
				"type": "OTHER"
			},
			{
				"name": "ACR",
				"salience": 0.014315724,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02l3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election"
				},
				"name": "Elections",
				"salience": 0.012906216,
				"type": "EVENT"
			},
			{
				"name": "PAGE",
				"salience": 0.011885134,
				"type": "OTHER"
			},
			{
				"name": "FOLLOWING",
				"salience": 0.011885134,
				"type": "OTHER"
			},
			{
				"name": "publication Politics",
				"salience": 0.009629453,
				"type": "ORGANIZATION"
			},
			{
				"name": "editor",
				"salience": 0.009629453,
				"type": "PERSON"
			},
			{
				"name": "SUNDAYS",
				"salience": 0.009363316,
				"type": "ORGANIZATION"
			},
			{
				"name": "UK Time",
				"salience": 0.009363316,
				"type": "OTHER"
			},
			{
				"name": "edition",
				"salience": 0.009270921,
				"type": "WORK_OF_ART"
			},
			{
				"name": "road",
				"salience": 0.008030549,
				"type": "LOCATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.007864917,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0069869035,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Basil Valentine",
				"salience": 0.0069138636,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.0068122377,
				"type": "OTHER"
			},
			{
				"name": "evaluation",
				"salience": 0.0068122377,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0068122377,
				"type": "OTHER"
			},
			{
				"name": "bigs",
				"salience": 0.0068122377,
				"type": "PERSON"
			},
			{
				"name": "perspective",
				"salience": 0.0068122377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04l3y6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.pt"
				},
				"name": "PT",
				"salience": 0.0063724923,
				"type": "LOCATION"
			},
			{
				"name": "EPISODE",
				"salience": 0.0061836536,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.005932771,
				"type": "LOCATION"
			},
			{
				"name": "THE SUNDAY WIRE",
				"salience": 0.0057116207,
				"type": "EVENT"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.005164896,
				"type": "OTHER"
			},
			{
				"name": "fun",
				"salience": 0.005091046,
				"type": "OTHER"
			},
			{
				"name": "voter fraud reports",
				"salience": 0.005091046,
				"type": "OTHER"
			},
			{
				"name": "odds",
				"salience": 0.005091046,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.005091046,
				"type": "OTHER"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.005091046,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vjl2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix_metropolitan_area"
				},
				"name": "Valley of the Sun",
				"salience": 0.004946685,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0041955854,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0041955854,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0041955854,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0041955854,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0041955854,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0039515854,
				"type": "LOCATION"
			},
			{
				"name": "NOTE",
				"salience": 0.0037089968,
				"type": "OTHER"
			},
			{
				"name": "LANGUAGE",
				"salience": 0.0037089968,
				"type": "OTHER"
			},
			{
				"name": "blast shield",
				"salience": 0.0037089968,
				"type": "OTHER"
			},
			{
				"name": "THEMES",
				"salience": 0.0037089968,
				"type": "OTHER"
			},
			{
				"name": "MEMBER",
				"salience": 0.0037089968,
				"type": "PERSON"
			},
			{
				"name": "HillaryBettingPool",
				"salience": 0.0031348458,
				"type": "OTHER"
			},
			{
				"name": "take",
				"salience": 0.0030282745,
				"type": "OTHER"
			},
			{
				"name": "overdrive",
				"salience": 0.0027711669,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0027711669,
				"type": "OTHER"
			},
			{
				"name": "@21WIRE.TV Strap",
				"salience": 0.0022834446,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034cm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Britain"
				},
				"name": "Great Britain",
				"salience": 0.0017058692,
				"type": "LOCATION"
			},
			{
				"name": "BREXIT",
				"salience": 0.0017058692,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Trump-Hillary.jpg?fit=610%2C413",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-06T22:52:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.002",
		"text": "November 6, 2016 By 21wire Leave a Comment \nEpisode #159 of SUNDAY WIRE SHOW resumes this November 6, 2016 as host Patrick Henningsen brings a 3 HOURS special broadcast of LIVE power-packed talk radio on ACR… \nLISTEN LIVE ON THIS PAGE AT THE FOLLOWING SCHEDULED SHOW TIMES: \nSUNDAYS – 5pm-8pm UK Time | 12pm-3pm ET (US) | 9am-12pm PT (US) \nThis week’s edition of THE SUNDAY WIRE is on the road broadcasting LIVE from the Valley of the Sun. This week host Patrick Henningsen covers this week’s top stories in the US and internationally. In the first hour we’re joined by a very special guest, Dr Marcus Papadopoulos , founder & editor of UK-based publication Politics First to discuss the US Elections and an evaluation of Trump vs Clinton from an international and foreign policy perspective looking at big bigs like US-NATO and Russian relations as well as the Syrian situation, as well as get his take on the spiralling BREXIT issue currently gripping Great Britain. In the final hour of overdrive, we’ll be rejoined by our esoteric bookmaker, Basil Valentine, for final thoughts on the US Elections, new odds, more voter fraud reports, and and time permitting, some more fun with the #HillaryBettingPool . \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV \nStrap yourselves in and lower the blast shield – this is your brave new world… \n*NOTE: THIS EPISODE MAY CONTAIN STRONG LANGUAGE AND MATURE THEMES* ",
		"thread_title": "Episode #159 – SUNDAY WIRE: ‘Tick-Tock USA’ with guests Dr Marcus Papadopoulos, Basil Valentine",
		"title": "Episode #159 – SUNDAY WIRE: ‘Tick-Tock USA’ with guests Dr Marcus Papadopoulos, Basil Valentine",
		"type": "conspiracy",
		"uuid": "095b7cc19392c3b309519cc1919657208fc25e6f"
	},
	"-KhIWIMp2b2jPnMZgsim": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T20:23:08.936+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.22179776,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.09318251,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.08110507,
				"type": "LOCATION"
			},
			{
				"name": "relations",
				"salience": 0.06794901,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.051499214,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.048693348,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.023612814,
				"type": "ORGANIZATION"
			},
			{
				"name": "interests",
				"salience": 0.017623356,
				"type": "OTHER"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.016289674,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.016066674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.016033953,
				"type": "ORGANIZATION"
			},
			{
				"name": "Leaks",
				"salience": 0.013254078,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.013254078,
				"type": "WORK_OF_ART"
			},
			{
				"name": "voting systems",
				"salience": 0.013254078,
				"type": "OTHER"
			},
			{
				"name": "hacking",
				"salience": 0.013254078,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.013254078,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.013254078,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.013254078,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02l3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election"
				},
				"name": "Election",
				"salience": 0.009431829,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.009396568,
				"type": "PERSON"
			},
			{
				"name": "dialogue",
				"salience": 0.008662301,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.008248895,
				"type": "OTHER"
			},
			{
				"name": "witch hunt",
				"salience": 0.008198168,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.008170101,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama White House",
				"salience": 0.008170101,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.008170101,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.007871453,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0077778697,
				"type": "OTHER"
			},
			{
				"name": "dialogue",
				"salience": 0.0060011926,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.005467662,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.005467662,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.005467662,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.005467662,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.005330918,
				"type": "EVENT"
			},
			{
				"name": "each other",
				"salience": 0.0044282437,
				"type": "PERSON"
			},
			{
				"name": "confidence",
				"salience": 0.0044282437,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0042631063,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0042631063,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0042631063,
				"type": "PERSON"
			},
			{
				"name": "tone",
				"salience": 0.0042440826,
				"type": "OTHER"
			},
			{
				"name": "crusade",
				"salience": 0.004137897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0038879316,
				"type": "ORGANIZATION"
			},
			{
				"name": "views",
				"salience": 0.0038349961,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0038349961,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0038349961,
				"type": "EVENT"
			},
			{
				"name": "play",
				"salience": 0.0036919545,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0036919545,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0036157044,
				"type": "OTHER"
			},
			{
				"name": "responses",
				"salience": 0.0036157044,
				"type": "OTHER"
			},
			{
				"name": "confidence",
				"salience": 0.0036157044,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045vz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Russian_sentiment"
				},
				"name": "anti-Russian",
				"salience": 0.003366987,
				"type": "LOCATION"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.003177964,
				"type": "PERSON"
			},
			{
				"name": "top",
				"salience": 0.003131197,
				"type": "OTHER"
			},
			{
				"name": "challenges",
				"salience": 0.003131197,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.003131197,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.003131197,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.003131197,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.003131197,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.002904763,
				"type": "OTHER"
			},
			{
				"name": "partner",
				"salience": 0.0027014704,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.0025036295,
				"type": "OTHER"
			},
			{
				"name": "deterioration",
				"salience": 0.0023393747,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0023393747,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0023393747,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0022729835,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0022729835,
				"type": "LOCATION"
			},
			{
				"name": "relations",
				"salience": 0.0019858652,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0019677114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6h97",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RIA_Novosti"
				},
				"name": "RIA Novosti",
				"salience": 0.0019276084,
				"type": "ORGANIZATION"
			},
			{
				"name": "choice",
				"salience": 0.0018704076,
				"type": "OTHER"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0017039097,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0017039097,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.0017039097,
				"type": "OTHER"
			},
			{
				"name": "forum",
				"salience": 0.0017039097,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.0014699677,
				"type": "LOCATION"
			},
			{
				"name": "each other",
				"salience": 0.0014699677,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.0014160862,
				"type": "OTHER"
			},
			{
				"name": "worsening",
				"salience": 0.0013390996,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0012728674,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.0012728674,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0012728674,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.0012728674,
				"type": "PERSON"
			},
			{
				"name": "positions",
				"salience": 0.0012728674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.00078340643,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i0.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Putin-Trump.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-09T17:06:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.124",
		"text": "\n21st Century Wire says… \nOver the past months, Hillary Clinton, the Obama White House and the mainstream media have been promoting the conspiracy theory that “ Russia is Hacking the US Election ”– blaming Moscow for the WikiLeaks emails, the DNC Leaks and for allegedly ‘hacking’ US voting systems. Despite the grand accusations, no evidence or proof has been offered by the US government. \nIt goes without saying how damaging the Democratic Party’s crazed witch hunt has been to US-Russian relations, where Clinton has led the anti-Russian crusade, and demonizing president Vladimir Putin at every opportunity. \nToday’s stunning presidential victory by Donald Trump means that all eyes are now on Putin to see how Moscow and Washington will be interfacing going forward. \nWith such sensitive geopolitical issues like Syria and the Ukraine currently in play, what happens between the two leaders over the coming months could set the tone going forward… \nIn a message to Donald Trump, Russian President Vladimir Putin has expressed confidence that the dialogue between Moscow and Washington, in keeping with each other’s views, meets the interests of both Russia and the US. \nPutin also expressed hope over the joint efforts on bringing Russian-American relations out of their current crisis. \nThe Russian leader noted in the message that he hopes to address some “burning issues that are currently on the international agenda, and search for effective responses to the challenges of the global security,” RIA Novosti reported. \nOn top of it, Putin has expressed confidence that “building a constructive dialogue between Moscow and Washington, based on principles of equality, mutual respect and each other’s positions, meets the interests of the peoples of our countries and of the entire international community.” \nAccording to many observers, US-Russia relations are now at their lowest point since the Cold War. Putin has repeatedly noted that the worsening of Russia’s relations with the US “was not our choice,” however. \nFor things to improve between Moscow and Washington, the US should first and foremost start acting like an equal partner and respect Russia’s interests rather than try to dictate terms, Putin said last month. \n“We are concerned with the deterioration of Russian-American relations, but that was not our choice, we never wanted that. On the contrary, we want to have friendly relations with the US, a great country and a leading economy,” Putin said at an economic forum in Moscow… \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV ",
		"thread_title": "KREMLIN: Putin Congratulates Trump, Hopes to Work Together Major Issues",
		"title": "KREMLIN: Putin Congratulates Trump, Hopes to Work Together Major Issues",
		"type": "conspiracy",
		"uuid": "d414680a6b1ef737053c20281c78f7753be24936"
	},
	"-KhIWIXFycE1Yk0OPvNq": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-10T12:04:04.874+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "grass-roots",
				"salience": 0.37407646,
				"type": "OTHER"
			},
			{
				"name": "Posts",
				"salience": 0.0978596,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North American",
				"salience": 0.06140346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.06140346,
				"type": "LOCATION"
			},
			{
				"name": "news",
				"salience": 0.05275805,
				"type": "OTHER"
			},
			{
				"name": "volunteer contributors",
				"salience": 0.05216184,
				"type": "PERSON"
			},
			{
				"name": "blog",
				"salience": 0.04148802,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.03728526,
				"type": "OTHER"
			},
			{
				"name": "media analysis",
				"salience": 0.034856983,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.029269544,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.029269544,
				"type": "LOCATION"
			},
			{
				"name": "array",
				"salience": 0.02819225,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.019721452,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.013956631,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0131721245,
				"type": "OTHER"
			},
			{
				"name": "mainstream",
				"salience": 0.01230417,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.006711665,
				"type": "PERSON"
			},
			{
				"name": "lady",
				"salience": 0.0065440712,
				"type": "PERSON"
			},
			{
				"name": "SundayWire RT",
				"salience": 0.0056746653,
				"type": "OTHER"
			},
			{
				"name": "@JeanetteJing",
				"salience": 0.0056746653,
				"type": "PERSON"
			},
			{
				"name": "career politicians",
				"salience": 0.005017438,
				"type": "PERSON"
			},
			{
				"name": "watchers",
				"salience": 0.005017438,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cjdk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_Broadcasting_Company"
				},
				"name": "FOX",
				"salience": 0.0030906089,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0030906089,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i1.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-david-icke-trump.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-10T12:04:04.874+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "Latest Posts 21wire We are a North American and European-based, grass-roots, independent blog offering geopolitical news and media analysis, working with an array of volunteer contributors who write and help to analyse news and opinion from around the world. We're covering news you won't necessarily find in the mainstream, and things which regularly confuse career politicians, FOX and CNN watchers... #SundayWire RT @JeanetteJing : Shocked that the finger-jabbing rich lady didn't appeal to voters. https://t.co/FbZxOQ6G8Q - 5 hours ago",
		"thread_title": "America’s Primal Scream: David Icke Explains Reason for Trump’s Election Result",
		"title": "America’s Primal Scream: David Icke Explains Reason for Trump’s Election Result",
		"type": "conspiracy",
		"uuid": "6ffb2f9c20a5ee09fb76d53bbbaa8dd39edf6916"
	},
	"-KhIWIdqUZee5MYqP2Fo": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-11T01:36:55.435+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02ygr1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Carlos_Slim"
				},
				"name": "Carlos Slim",
				"salience": 0.48712894,
				"type": "PERSON"
			},
			{
				"name": "chuck",
				"salience": 0.091074385,
				"type": "PERSON"
			},
			{
				"name": "wealth",
				"salience": 0.05248872,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.047738876,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.036758192,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.022821737,
				"type": "PERSON"
			},
			{
				"name": "stock markets",
				"salience": 0.021857379,
				"type": "OTHER"
			},
			{
				"name": "currency",
				"salience": 0.018946873,
				"type": "OTHER"
			},
			{
				"name": "election victory",
				"salience": 0.018946873,
				"type": "EVENT"
			},
			{
				"name": "news",
				"salience": 0.018946873,
				"type": "OTHER"
			},
			{
				"name": "haircut",
				"salience": 0.01400031,
				"type": "OTHER"
			},
			{
				"name": "free fall",
				"salience": 0.013311123,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.012816477,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.012816477,
				"type": "PERSON"
			},
			{
				"name": "loss",
				"salience": 0.011439643,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/012ts8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexican_peso"
				},
				"name": "Mexican Peso",
				"salience": 0.011257445,
				"type": "ORGANIZATION"
			},
			{
				"name": "upset",
				"salience": 0.010875975,
				"type": "EVENT"
			},
			{
				"name": "fortune",
				"salience": 0.010875975,
				"type": "OTHER"
			},
			{
				"name": "world markets",
				"salience": 0.00938742,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.009121743,
				"type": "ORGANIZATION"
			},
			{
				"name": "wealth increase",
				"salience": 0.008132133,
				"type": "OTHER"
			},
			{
				"name": "oligarchs",
				"salience": 0.007537816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0067035365,
				"type": "ORGANIZATION"
			},
			{
				"name": "total",
				"salience": 0.005926931,
				"type": "OTHER"
			},
			{
				"name": "slide",
				"salience": 0.005926931,
				"type": "EVENT"
			},
			{
				"name": "loser",
				"salience": 0.005926931,
				"type": "ORGANIZATION"
			},
			{
				"name": "billionaires",
				"salience": 0.005663482,
				"type": "PERSON"
			},
			{
				"name": "Bloomberg Billionaires Index",
				"salience": 0.0050102877,
				"type": "OTHER"
			},
			{
				"name": "odds",
				"salience": 0.004429508,
				"type": "OTHER"
			},
			{
				"name": "favorite",
				"salience": 0.004429508,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.003991813,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0037097002,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Carlos-Slim-Trump.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-10T14:42:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.002",
		"text": "\n21st Century Wire says… \nMexico’s billionaire tycoon Carlos Slim saw a large chuck of his wealth evaporate – literally overnight, after news of a Donald Trump election victory hit the currency and stock markets on Wednesday morning. \nAccording to Bloomberg financial analysts, Slim, Mexico’s wealthiest person and rated fifth on the global rich list, took a stinging $5.1 billion haircut after the Mexican Peso went into a 12% free fall after Trump’s stunning upset over Democratic Hillary Clinton. \nSlim’s loss amounted to a staggering 9.2 percent of his total fortune. \nIn the week before, polls showed Hillary Clinton as the odds on favorite, netting the billionaires a staggering $57 billion in total wealth increase across world markets. However, according to the Bloomberg Billionaires Index, oligarchs lost a total of $41 billion during Wednesday’s epic slide – with Slim being the biggest loser. ",
		"thread_title": "Mexico’s Richest Oligarch Loses Billions on News of Trump Victory",
		"title": "Mexico’s Richest Oligarch Loses Billions on News of Trump Victory",
		"type": "conspiracy",
		"uuid": "63c6bf1deea567e43a0c7aaad5b8020ca6082159"
	},
	"-KhIWIo_zyJQsrQAchHX": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-12T06:41:47.990+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "lie",
				"salience": 0.13660063,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.088389374,
				"type": "PERSON"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.06438484,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.063384436,
				"type": "ORGANIZATION"
			},
			{
				"name": "establishment media",
				"salience": 0.06049913,
				"type": "ORGANIZATION"
			},
			{
				"name": "myths",
				"salience": 0.052488223,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.045358453,
				"type": "OTHER"
			},
			{
				"name": "pundits",
				"salience": 0.04007471,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.027111707,
				"type": "LOCATION"
			},
			{
				"name": "blacks",
				"salience": 0.025111523,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.025111523,
				"type": "PERSON"
			},
			{
				"name": "latinos",
				"salience": 0.025111523,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.021761004,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.017635942,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.017635942,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.015279092,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.015279092,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.014710548,
				"type": "PERSON"
			},
			{
				"name": "mandate",
				"salience": 0.014710548,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.014710548,
				"type": "EVENT"
			},
			{
				"name": "demographics",
				"salience": 0.014407436,
				"type": "OTHER"
			},
			{
				"name": "celebrities",
				"salience": 0.013985149,
				"type": "PERSON"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.012666741,
				"type": "PERSON"
			},
			{
				"name": "impression",
				"salience": 0.012639569,
				"type": "OTHER"
			},
			{
				"name": "intenet",
				"salience": 0.012480713,
				"type": "OTHER"
			},
			{
				"name": "Psychologist",
				"salience": 0.012480713,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.011485804,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latinos",
				"salience": 0.010870634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.010870634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.010495534,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.009329318,
				"type": "EVENT"
			},
			{
				"name": "WARNING",
				"salience": 0.009329318,
				"type": "OTHER"
			},
			{
				"name": "LANGUAGE",
				"salience": 0.009329318,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00906494,
				"type": "ORGANIZATION"
			},
			{
				"name": "blacks",
				"salience": 0.008361992,
				"type": "PERSON"
			},
			{
				"name": "Kiki Green",
				"salience": 0.0074440567,
				"type": "PERSON"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0067978916,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.006380718,
				"type": "OTHER"
			},
			{
				"name": "partnership",
				"salience": 0.0058654426,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01mpq7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beyonc%C3%A9"
				},
				"name": "Beyonce",
				"salience": 0.0057459925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vw20h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jay_Z"
				},
				"name": "Jay Z",
				"salience": 0.0057459925,
				"type": "PERSON"
			},
			{
				"name": "Katie Perry",
				"salience": 0.0057459925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.003127318,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i1.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Kiki-Green-Trump.png?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-11T13:52:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.49",
		"text": "\n21st Century Wire says… \nOne of the great myths being spun by the establishment media was that Donald Trump had no support from women, latinos and blacks in the US. As it turned out, this was a lie propagated in a failed attempt to margnalize Republican voters and give a false impression of a liberal Democratic mandate in America. In the end Trump gathered 29% of Latinos, 9% of African Americans and 49% of college educated white women. For months, mainstream media pundits and polls insisted that all of these demographics were exclusively for Hillary Clinton. How could they have got it so wrong? \nPsychologist and intenet radio personality Kiki Green explains how blacks were conned into voting for Hillary Clinton by the partnership between the Democratic Party, Hollywood and the Clinton campaign – by cynically using celebrities like Beyonce, Jay Z and Katie Perry… \nWARNING: ADULT LANGUAGE please be advised: \n. READ MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV ",
		"thread_title": "‘Beyonce, Jay Z, Hillary Clinton – You Don’t Represent All Blacks, Women’",
		"title": "‘Beyonce, Jay Z, Hillary Clinton – You Don’t Represent All Blacks, Women’",
		"type": "conspiracy",
		"uuid": "4dc9f03b3aadbffd2c7cb6432b6247b3d742d55d"
	},
	"-KhIWIyeaWUaZ3Vg4LhG": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-12T06:41:50.441+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "university student",
				"salience": 0.15091243,
				"type": "PERSON"
			},
			{
				"name": "college students",
				"salience": 0.105664775,
				"type": "PERSON"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.06567899,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.064659834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0257nv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MoveOn.org"
				},
				"name": "MoveOn.org",
				"salience": 0.055029944,
				"type": "ORGANIZATION"
			},
			{
				"name": "victory",
				"salience": 0.05355662,
				"type": "EVENT"
			},
			{
				"name": "claim",
				"salience": 0.03745933,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.03313493,
				"type": "LOCATION"
			},
			{
				"name": "street protests",
				"salience": 0.028375527,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.026435481,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.025637405,
				"type": "OTHER"
			},
			{
				"name": "web portal",
				"salience": 0.025637405,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.022218285,
				"type": "OTHER"
			},
			{
				"name": "rapist",
				"salience": 0.016619645,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.016288774,
				"type": "EVENT"
			},
			{
				"name": "court case",
				"salience": 0.016073095,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05256f_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President-elect_of_the_United_States"
				},
				"name": "Elect",
				"salience": 0.015828056,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.015817042,
				"type": "ORGANIZATION"
			},
			{
				"name": "student protest",
				"salience": 0.01568295,
				"type": "EVENT"
			},
			{
				"name": "election result",
				"salience": 0.015602288,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.015602288,
				"type": "PERSON"
			},
			{
				"name": "number university campuses",
				"salience": 0.015021897,
				"type": "LOCATION"
			},
			{
				"name": "riots",
				"salience": 0.015021897,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.013360773,
				"type": "PERSON"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.012935389,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.012745465,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02frhbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland,_Oregon"
				},
				"name": "Portland",
				"salience": 0.010688169,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.009527851,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.009527851,
				"type": "OTHER"
			},
			{
				"name": "Los Angleses",
				"salience": 0.009257898,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.009257898,
				"type": "LOCATION"
			},
			{
				"name": "student",
				"salience": 0.007180428,
				"type": "PERSON"
			},
			{
				"name": "Watch",
				"salience": 0.0069429236,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0069429236,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0djd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Albuquerque,_New_Mexico"
				},
				"name": "Albuquerque",
				"salience": 0.005868712,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fjy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Mexico"
				},
				"name": "New Mexico",
				"salience": 0.005868712,
				"type": "LOCATION"
			},
			{
				"name": "court case",
				"salience": 0.005345177,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.005188181,
				"type": "OTHER"
			},
			{
				"name": "hoax",
				"salience": 0.005188181,
				"type": "OTHER"
			},
			{
				"name": "Stuart J Hooper",
				"salience": 0.004275407,
				"type": "PERSON"
			},
			{
				"name": "interviews",
				"salience": 0.004026707,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02zd460",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Berkeley"
				},
				"name": "Berkeley",
				"salience": 0.0039124587,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Trump-student-protesters.png?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-11T15:35:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.293",
		"text": "\n21st Century Wire says… \nUS college students continue to be emotionally traumatized and ‘threatened’ by Donald Trump’s surprise presidential victory this week, sparking a wave of nationally coordinated street protests, organized in part through the George Soros funded Democratic Party ‘community organizing’ web portal MoveOn.org . \nVarious protests and riots have been organized around a number university campuses including Berkeley, Portland, New York City and Los Angleses. \nWhen asked why she scared by the election result, one female university student claimed that the President Elect is a “rapist,” while another claim that, “He [Trump] is about to have a court case about a 13 years old girl soon, and I’m not down for that.” \nThe alleged court case the student is referring was actually dropped , and has since been exposed as a likely politically motivated hoax according to reports . \nHere is last night’s student protest, including multiple interviews from both sides of the debate, filmed last night in Albuquerque, New Mexico, by Stuart J Hooper . Watch: \n. READ MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV ",
		"thread_title": "(VIDEO) Female College Students Protesting Because ‘Trump is a Rapist’",
		"title": "(VIDEO) Female College Students Protesting Because ‘Trump is a Rapist’",
		"type": "conspiracy",
		"uuid": "8910588330147ab1149ff116ba4d1570643b29f0"
	},
	"-KhIWJjCGJ98bnGvKg8d": {
		"author": "Mike Rivero",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-12T23:13:29.272+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.36681655,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0257nv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MoveOn.org"
				},
				"name": "MoveOn.org",
				"salience": 0.16715384,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.05261039,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.015677819,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.014073016,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.008857893,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "Elect",
				"salience": 0.0082854545,
				"type": "PERSON"
			},
			{
				"name": "street protests",
				"salience": 0.008058561,
				"type": "EVENT"
			},
			{
				"name": "Comment",
				"salience": 0.0075517334,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.0065027988,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0061195325,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.005087298,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00481053,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.00440645,
				"type": "OTHER"
			},
			{
				"name": "VS",
				"salience": 0.004393177,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.004216944,
				"type": "ORGANIZATION"
			},
			{
				"name": "protests",
				"salience": 0.0041222367,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0041222367,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0041222367,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0041222367,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0041222367,
				"type": "EVENT"
			},
			{
				"name": "movement",
				"salience": 0.004054818,
				"type": "OTHER"
			},
			{
				"name": "Shawn Helton",
				"salience": 0.0038775094,
				"type": "PERSON"
			},
			{
				"name": "Duran Anti-Trump",
				"salience": 0.0037084366,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0035511705,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.0032407576,
				"type": "EVENT"
			},
			{
				"name": "presidency",
				"salience": 0.0032240492,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.0031881542,
				"type": "OTHER"
			},
			{
				"name": "organizing",
				"salience": 0.0031168938,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.003002572,
				"type": "OTHER"
			},
			{
				"name": "Susan Sandler",
				"salience": 0.0028622532,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.0027465026,
				"type": "LOCATION"
			},
			{
				"name": "streets",
				"salience": 0.0027465026,
				"type": "LOCATION"
			},
			{
				"name": "nonprofit group",
				"salience": 0.0027282774,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0026003486,
				"type": "OTHER"
			},
			{
				"name": "grassroots movement",
				"salience": 0.0024742703,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0024374789,
				"type": "LOCATION"
			},
			{
				"name": "unrest",
				"salience": 0.0024374789,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0024374789,
				"type": "LOCATION"
			},
			{
				"name": "analysis",
				"salience": 0.002312071,
				"type": "OTHER"
			},
			{
				"name": "media outlets",
				"salience": 0.0022978305,
				"type": "OTHER"
			},
			{
				"name": "Steve Phillips",
				"salience": 0.002262274,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.0021842606,
				"type": "OTHER"
			},
			{
				"name": "driving force",
				"salience": 0.0021842606,
				"type": "PERSON"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.0021659571,
				"type": "OTHER"
			},
			{
				"name": "Soros Agit-Prop Empire Last",
				"salience": 0.0020901004,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0020334094,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rioting",
				"salience": 0.0020334094,
				"type": "EVENT"
			},
			{
				"name": "developments",
				"salience": 0.0020334094,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.002017033,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, D.C.",
				"salience": 0.0019437431,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02frhbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland,_Oregon"
				},
				"name": "Portland",
				"salience": 0.0018948803,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03860h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Viktor_Orb%C3%A1n"
				},
				"name": "Victor Orban",
				"salience": 0.0018131424,
				"type": "PERSON"
			},
			{
				"name": "Photo Illustration",
				"salience": 0.0017608948,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.0017608948,
				"type": "EVENT"
			},
			{
				"name": "news stories",
				"salience": 0.0017608948,
				"type": "WORK_OF_ART"
			},
			{
				"name": "light",
				"salience": 0.0017608948,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0017561204,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01y17m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Illinois_at_Chicago"
				},
				"name": "University of Illinois Chicago",
				"salience": 0.0016158102,
				"type": "ORGANIZATION"
			},
			{
				"name": "flash mobs",
				"salience": 0.0015982207,
				"type": "OTHER"
			},
			{
				"name": "media coverage",
				"salience": 0.0015124178,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.0014960391,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.0014176511,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0014089572,
				"type": "OTHER"
			},
			{
				"name": "21WIRE",
				"salience": 0.001386394,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.001386394,
				"type": "LOCATION"
			},
			{
				"name": "protest groups",
				"salience": 0.0013761459,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0013703081,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0013694877,
				"type": "EVENT"
			},
			{
				"name": "organizations",
				"salience": 0.0012836597,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04f06y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Insider"
				},
				"name": "INSIDER",
				"salience": 0.0012518,
				"type": "WORK_OF_ART"
			},
			{
				"name": "The Free Thought Project",
				"salience": 0.0012518,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.0012092292,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.0011757872,
				"type": "EVENT"
			},
			{
				"name": "movement",
				"salience": 0.0011712853,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.0011601035,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0011513933,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.001146346,
				"type": "EVENT"
			},
			{
				"name": "gatherings",
				"salience": 0.0011249646,
				"type": "EVENT"
			},
			{
				"name": "organization",
				"salience": 0.0011165537,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-Trump",
				"salience": 0.0011042997,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.0010839761,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d9jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Seattle"
				},
				"name": "Seattle",
				"salience": 0.0010839761,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0010839761,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04ykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota"
				},
				"name": "Minn.",
				"salience": 0.0010839761,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b2lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saint_Paul,_Minnesota"
				},
				"name": "St. Paul",
				"salience": 0.0010839761,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA Today",
				"salience": 0.0010839761,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Ore.",
				"salience": 0.0010839761,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0010839761,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0279hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Billionaire"
				},
				"name": "Billionaire",
				"salience": 0.0010839761,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.0010839761,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0010707557,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.0010707557,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0010318282,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0010318282,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0010036398,
				"type": "PERSON"
			},
			{
				"name": "cities",
				"salience": 0.0010036398,
				"type": "LOCATION"
			},
			{
				"name": "gatherings",
				"salience": 0.0010036398,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0010036398,
				"type": "LOCATION"
			},
			{
				"name": "gatherings",
				"salience": 0.0010036398,
				"type": "EVENT"
			},
			{
				"name": "hundreds",
				"salience": 0.0010036398,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0009879111,
				"type": "PERSON"
			},
			{
				"name": "PROTEST",
				"salience": 0.00097213674,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.00095103553,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.00095103553,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.00095103553,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00095103553,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.00095103553,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.00092719187,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0009243878,
				"type": "EVENT"
			},
			{
				"name": "groups",
				"salience": 0.00090003933,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.00090003933,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.00090003933,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00087474403,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.0008741331,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.0008669907,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0008669907,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.00086644216,
				"type": "ORGANIZATION"
			},
			{
				"name": "thousands",
				"salience": 0.0008478424,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.0008371586,
				"type": "OTHER"
			},
			{
				"name": "xenophobia",
				"salience": 0.0008371586,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.0008371586,
				"type": "LOCATION"
			},
			{
				"name": "dynamic",
				"salience": 0.0008371586,
				"type": "OTHER"
			},
			{
				"name": "photo",
				"salience": 0.0008371586,
				"type": "WORK_OF_ART"
			},
			{
				"name": "misogyny",
				"salience": 0.0008371586,
				"type": "EVENT"
			},
			{
				"name": "role",
				"salience": 0.0008371586,
				"type": "OTHER"
			},
			{
				"name": "founder",
				"salience": 0.0008371586,
				"type": "PERSON"
			},
			{
				"name": "play",
				"salience": 0.0008371586,
				"type": "OTHER"
			},
			{
				"name": "xenophobia",
				"salience": 0.0008371586,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.0008371586,
				"type": "LOCATION"
			},
			{
				"name": "misogyny",
				"salience": 0.0008371586,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00083462667,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0008314793,
				"type": "EVENT"
			},
			{
				"name": "strength",
				"salience": 0.0008133446,
				"type": "OTHER"
			},
			{
				"name": "agitation activities",
				"salience": 0.0008064949,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0008004403,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00078389543,
				"type": "EVENT"
			},
			{
				"name": "campaigns",
				"salience": 0.00078039384,
				"type": "EVENT"
			},
			{
				"name": "stand",
				"salience": 0.0007723574,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.00077079755,
				"type": "PERSON"
			},
			{
				"name": "designer",
				"salience": 0.0007660462,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00075149606,
				"type": "LOCATION"
			},
			{
				"name": "alliances",
				"salience": 0.0007507364,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0007507364,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0007507364,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.0007507364,
				"type": "OTHER"
			},
			{
				"name": "transition meeting",
				"salience": 0.0007435246,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0242xw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Alliance_(South_Africa)"
				},
				"name": "Democratic Alliance",
				"salience": 0.0007403243,
				"type": "ORGANIZATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0007402893,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0007299323,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.000726201,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.000726201,
				"type": "EVENT"
			},
			{
				"name": "protest",
				"salience": 0.000726201,
				"type": "EVENT"
			},
			{
				"name": "participants",
				"salience": 0.00072595326,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00072490296,
				"type": "OTHER"
			},
			{
				"name": "resolve",
				"salience": 0.00072490296,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.00072490296,
				"type": "PERSON"
			},
			{
				"name": "circle",
				"salience": 0.00072490296,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.00072490296,
				"type": "OTHER"
			},
			{
				"name": "chair",
				"salience": 0.00072490296,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bigotry",
				"salience": 0.00072490296,
				"type": "OTHER"
			},
			{
				"name": "migrant crisis",
				"salience": 0.00072490296,
				"type": "EVENT"
			},
			{
				"name": "opposition groups",
				"salience": 0.00071635126,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.0007143033,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0007143033,
				"type": "OTHER"
			},
			{
				"name": "Defendant Black Lives Matter",
				"salience": 0.000708983,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.00070777157,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0007036722,
				"type": "LOCATION"
			},
			{
				"name": "NGO's",
				"salience": 0.0007036722,
				"type": "ORGANIZATION"
			},
			{
				"name": "call",
				"salience": 0.00070097233,
				"type": "OTHER"
			},
			{
				"name": "The Occupy Movement",
				"salience": 0.00069402327,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobia",
				"salience": 0.00067851733,
				"type": "OTHER"
			},
			{
				"name": "unrest",
				"salience": 0.00067740254,
				"type": "OTHER"
			},
			{
				"name": "contributor",
				"salience": 0.00065006525,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h63jfq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Occupy_Wall_Street"
				},
				"name": "Occupy Wall Street Movement",
				"salience": 0.0006325279,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04ych",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Missouri"
				},
				"name": "Missouri",
				"salience": 0.00062880095,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0w_s6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ferguson,_Missouri"
				},
				"name": "Ferguson",
				"salience": 0.00062880095,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0006257962,
				"type": "PERSON"
			},
			{
				"name": "campaign event",
				"salience": 0.0006257962,
				"type": "EVENT"
			},
			{
				"name": "events",
				"salience": 0.0006257962,
				"type": "EVENT"
			},
			{
				"name": "campaign events",
				"salience": 0.0006257962,
				"type": "EVENT"
			},
			{
				"name": "agitator",
				"salience": 0.0006257962,
				"type": "PERSON"
			},
			{
				"name": "Hundreds Peaceful Gatherings of Solidarity",
				"salience": 0.000617729,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.00061286,
				"type": "ORGANIZATION"
			},
			{
				"name": "intentions",
				"salience": 0.00061286,
				"type": "OTHER"
			},
			{
				"name": "color revolution",
				"salience": 0.00061012217,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026q3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy_Alliance"
				},
				"name": "Democracy Alliance",
				"salience": 0.0006084669,
				"type": "ORGANIZATION"
			},
			{
				"name": "activists",
				"salience": 0.0006024508,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.0006024508,
				"type": "PERSON"
			},
			{
				"name": "Action",
				"salience": 0.0006024508,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.00058693363,
				"type": "PERSON"
			},
			{
				"name": "insight",
				"salience": 0.00058693363,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.00058693363,
				"type": "OTHER"
			},
			{
				"name": "SOCIAL ENGINEERING",
				"salience": 0.00058693363,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00058693363,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.00058693363,
				"type": "PERSON"
			},
			{
				"name": "engineers",
				"salience": 0.00058693363,
				"type": "PERSON"
			},
			{
				"name": "president-elect",
				"salience": 0.0005855673,
				"type": "PERSON"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.000583023,
				"type": "PERSON"
			},
			{
				"name": "imagery",
				"salience": 0.0005744368,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0005744368,
				"type": "OTHER"
			},
			{
				"name": "abc news",
				"salience": 0.0005744368,
				"type": "OTHER"
			},
			{
				"name": "violation",
				"salience": 0.0005744368,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0005744368,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0005744368,
				"type": "LOCATION"
			},
			{
				"name": "color",
				"salience": 0.0005744368,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/011hwh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Agency_for_International_Development"
				},
				"name": "US Agency for International Development",
				"salience": 0.0005713163,
				"type": "ORGANIZATION"
			},
			{
				"name": "Resolve Following Election Results Hundreds of Americans",
				"salience": 0.0005706674,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0005650208,
				"type": "OTHER"
			},
			{
				"name": "clashes",
				"salience": 0.0005650208,
				"type": "OTHER"
			},
			{
				"name": "endorsement",
				"salience": 0.0005650208,
				"type": "OTHER"
			},
			{
				"name": "provocateurs",
				"salience": 0.0005650208,
				"type": "PERSON"
			},
			{
				"name": "rallies",
				"salience": 0.0005650208,
				"type": "EVENT"
			},
			{
				"name": "stage",
				"salience": 0.0005650208,
				"type": "OTHER"
			},
			{
				"name": "machinations",
				"salience": 0.0005650208,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0123hdtx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Organization_for_Black_Struggle"
				},
				"name": "Organization for Black Struggle",
				"salience": 0.00055395253,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.0005488547,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.0005488547,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.0005471309,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.00054149586,
				"type": "WORK_OF_ART"
			},
			{
				"name": "form",
				"salience": 0.00054149586,
				"type": "OTHER"
			},
			{
				"name": "globalist",
				"salience": 0.00053467124,
				"type": "PERSON"
			},
			{
				"name": "Image Source",
				"salience": 0.0005306725,
				"type": "OTHER"
			},
			{
				"name": "Image Source",
				"salience": 0.0005306725,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0005306725,
				"type": "OTHER"
			},
			{
				"name": "Color Revolutions",
				"salience": 0.0005306725,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.0005288781,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.0005288781,
				"type": "EVENT"
			},
			{
				"name": "movements",
				"salience": 0.00052685244,
				"type": "OTHER"
			},
			{
				"name": "protest movements",
				"salience": 0.00052021234,
				"type": "OTHER"
			},
			{
				"name": "Open Society Foundations (Open Society Institute",
				"salience": 0.00051524444,
				"type": "ORGANIZATION"
			},
			{
				"name": "disruption",
				"salience": 0.0005147091,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.0005117484,
				"type": "ORGANIZATION"
			},
			{
				"name": "pain",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "touch",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "uprisings",
				"salience": 0.00050822203,
				"type": "EVENT"
			},
			{
				"name": "nomination",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "memes",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.00050822203,
				"type": "EVENT"
			},
			{
				"name": "PAC money",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00050822203,
				"type": "WORK_OF_ART"
			},
			{
				"name": "discussions",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "teenager",
				"salience": 0.00050822203,
				"type": "PERSON"
			},
			{
				"name": "police killing",
				"salience": 0.00050822203,
				"type": "EVENT"
			},
			{
				"name": "oppression",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00050822203,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0005070389,
				"type": "ORGANIZATION"
			},
			{
				"name": "press release",
				"salience": 0.0005018167,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protests",
				"salience": 0.0004963794,
				"type": "EVENT"
			},
			{
				"name": "threshold",
				"salience": 0.0004892471,
				"type": "OTHER"
			},
			{
				"name": "venue",
				"salience": 0.0004892471,
				"type": "LOCATION"
			},
			{
				"name": "website",
				"salience": 0.0004892471,
				"type": "OTHER"
			},
			{
				"name": "human-smuggling network",
				"salience": 0.0004892471,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.00048308086,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0004791329,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.0004791329,
				"type": "EVENT"
			},
			{
				"name": "cause",
				"salience": 0.0004791329,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0004791329,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0004791329,
				"type": "WORK_OF_ART"
			},
			{
				"name": "agenda",
				"salience": 0.0004791329,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.0004791329,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0004791329,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0004730941,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07pg3rf"
				},
				"name": "Resistance",
				"salience": 0.00044614458,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hungary"
				},
				"name": "Hungarian",
				"salience": 0.00044614458,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00044614458,
				"type": "LOCATION"
			},
			{
				"name": "activists",
				"salience": 0.00043874554,
				"type": "PERSON"
			},
			{
				"name": "flash mobs",
				"salience": 0.000438426,
				"type": "OTHER"
			},
			{
				"name": "police officer",
				"salience": 0.0004290905,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.0004290905,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0004290905,
				"type": "PERSON"
			},
			{
				"name": "RT news",
				"salience": 0.0004290905,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0004290905,
				"type": "OTHER"
			},
			{
				"name": "police officers",
				"salience": 0.0004290905,
				"type": "PERSON"
			},
			{
				"name": "purpose",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "cast",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "fronts",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "destablization",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "awe",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "shock",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "dependency",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "upheavals",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "marxist",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "election bylaws",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "class warfare",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.00041487493,
				"type": "PERSON"
			},
			{
				"name": "criminal law",
				"salience": 0.00041487493,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.000413472,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.000413472,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s76_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_O'Keefe"
				},
				"name": "Project Veritas",
				"salience": 0.0004030943,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0003963973,
				"type": "WORK_OF_ART"
			},
			{
				"name": "deaths",
				"salience": 0.0003963973,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.0003963973,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.0003963973,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.00039505685,
				"type": "EVENT"
			},
			{
				"name": "reboot",
				"salience": 0.00038447228,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.00035789624,
				"type": "OTHER"
			},
			{
				"name": "injury",
				"salience": 0.00035789624,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.00035789624,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00035789624,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00035789624,
				"type": "OTHER"
			},
			{
				"name": "machinations",
				"salience": 0.00035789624,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.00035789624,
				"type": "EVENT"
			},
			{
				"name": "streets",
				"salience": 0.00035215166,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f2rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dallas"
				},
				"name": "Dallas",
				"salience": 0.00034872664,
				"type": "LOCATION"
			},
			{
				"name": "Soros Groups",
				"salience": 0.00033778299,
				"type": "ORGANIZATION"
			},
			{
				"name": "victory",
				"salience": 0.00033590224,
				"type": "EVENT"
			},
			{
				"name": "interests",
				"salience": 0.0003333898,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.00033018645,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latino",
				"salience": 0.00031277377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.00031277377,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06wxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Louis"
				},
				"name": "St. Louis",
				"salience": 0.00031277377,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/011l2bwd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shooting_of_Michael_Brown"
				},
				"name": "Michael Brown",
				"salience": 0.00031277377,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0003124851,
				"type": "LOCATION"
			},
			{
				"name": "masses",
				"salience": 0.00030989505,
				"type": "OTHER"
			},
			{
				"name": "damages",
				"salience": 0.00030989505,
				"type": "OTHER"
			},
			{
				"name": "gunman",
				"salience": 0.00030989505,
				"type": "PERSON"
			},
			{
				"name": "suit",
				"salience": 0.00030989505,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.00030989505,
				"type": "PERSON"
			},
			{
				"name": "races",
				"salience": 0.00030989505,
				"type": "EVENT"
			},
			{
				"name": "ethnicities",
				"salience": 0.00030989505,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.00030989505,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00030884705,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.00030884705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.00030109493,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06kx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reno,_Nevada"
				},
				"name": "Reno",
				"salience": 0.00030109493,
				"type": "LOCATION"
			},
			{
				"name": "labor union organizations",
				"salience": 0.00029856697,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizations",
				"salience": 0.00029856697,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizations",
				"salience": 0.00029856697,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00029265485,
				"type": "OTHER"
			},
			{
				"name": "color revolution",
				"salience": 0.00029236008,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.00029085047,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fvvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baton_Rouge,_Louisiana"
				},
				"name": "Baton Rouge",
				"salience": 0.00029006123,
				"type": "LOCATION"
			},
			{
				"name": "Image Source",
				"salience": 0.00028867496,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00028760053,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-Trump",
				"salience": 0.00028173614,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup",
				"salience": 0.00026613774,
				"type": "EVENT"
			},
			{
				"name": "world stage",
				"salience": 0.00026063525,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00026063525,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.00026063525,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00026063525,
				"type": "OTHER"
			},
			{
				"name": "bloc",
				"salience": 0.00026063525,
				"type": "ORGANIZATION"
			},
			{
				"name": "provocateurs",
				"salience": 0.00026063525,
				"type": "PERSON"
			},
			{
				"name": "sovereignty",
				"salience": 0.00025620003,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03y48",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Monetary_Fund"
				},
				"name": "IMF",
				"salience": 0.0002553206,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0002553206,
				"type": "ORGANIZATION"
			},
			{
				"name": "pro-US",
				"salience": 0.0002553206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "youtube",
				"salience": 0.0002553206,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.000250903,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0002497819,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00024902623,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.00024663337,
				"type": "OTHER"
			},
			{
				"name": "Duran",
				"salience": 0.00024394828,
				"type": "LOCATION"
			},
			{
				"name": "pill",
				"salience": 0.00024045486,
				"type": "OTHER"
			},
			{
				"name": "unrest",
				"salience": 0.00023341076,
				"type": "EVENT"
			},
			{
				"name": "unrest",
				"salience": 0.00023341076,
				"type": "OTHER"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"name": "charity",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"name": "leverage",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"name": "government insurrection",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"name": "sights",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"name": "thanks",
				"salience": 0.0002256772,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j75z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_district_court"
				},
				"name": "US District Court",
				"salience": 0.00022025248,
				"type": "ORGANIZATION"
			},
			{
				"name": "motivation",
				"salience": 0.00021725014,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00021725014,
				"type": "OTHER"
			},
			{
				"name": "party leaders",
				"salience": 0.00020650147,
				"type": "PERSON"
			},
			{
				"name": "George Soros NGO",
				"salience": 0.00020489689,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00020301096,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03zfw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Republican_Institute"
				},
				"name": "International Republican Institute",
				"salience": 0.00020182408,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05l5x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Democratic_Institute_for_International_Affairs"
				},
				"name": "National Democratic Institute",
				"salience": 0.00020182408,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00019468016,
				"type": "LOCATION"
			},
			{
				"name": "riots",
				"salience": 0.00019468016,
				"type": "EVENT"
			},
			{
				"name": "public",
				"salience": 0.00019468016,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.00019468016,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04yl1w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fort_Worth_Star-Telegram"
				},
				"name": "Fort Worth Star Telegram",
				"salience": 0.0001907103,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k0t_dz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caucasian_race"
				},
				"name": "Caucasians",
				"salience": 0.0001907103,
				"type": "PERSON"
			},
			{
				"name": "Patrick Zamarripa",
				"salience": 0.0001907103,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.0001907103,
				"type": "PERSON"
			},
			{
				"name": "Duran",
				"salience": 0.00017765063,
				"type": "PERSON"
			},
			{
				"name": "state actors",
				"salience": 0.0001707197,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.00016856767,
				"type": "LOCATION"
			},
			{
				"name": "authoritarianism",
				"salience": 0.00016856767,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00016856767,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.00016856767,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.00016856767,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00016856767,
				"type": "OTHER"
			},
			{
				"name": "silence",
				"salience": 0.00016856767,
				"type": "OTHER"
			},
			{
				"name": "financial",
				"salience": 0.00016856767,
				"type": "OTHER"
			},
			{
				"name": "NEO BLACK BLOC",
				"salience": 0.00016039408,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01ntzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Endowment_for_Democracy"
				},
				"name": "National Endowment for Democracy",
				"salience": 0.0001577783,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.00015766453,
				"type": "ORGANIZATION"
			},
			{
				"name": "Albert Einstein Institute",
				"salience": 0.00015324957,
				"type": "LOCATION"
			},
			{
				"name": "racism",
				"salience": 0.00014358104,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.00013888004,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0zdr2nc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Euromaidan"
				},
				"name": "Maidan",
				"salience": 0.00013888004,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.00013888004,
				"type": "PERSON"
			},
			{
				"name": "Alex Christoforou",
				"salience": 0.00013888004,
				"type": "PERSON"
			},
			{
				"name": "George Soros NGOs",
				"salience": 0.00013888004,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.00013888004,
				"type": "ORGANIZATION"
			},
			{
				"name": "relations",
				"salience": 0.00013586711,
				"type": "OTHER"
			},
			{
				"name": "International Center for Non-Violent Conflict",
				"salience": 0.00013269378,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0drpg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_House"
				},
				"name": "Freedom House",
				"salience": 0.00013269378,
				"type": "ORGANIZATION"
			},
			{
				"name": "woes",
				"salience": 0.000109509805,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qzyj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unite_the_Union"
				},
				"name": "UNITE",
				"salience": 0.00010373407,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018czw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AFL%E2%80%93CIO"
				},
				"name": "AFL-CIO",
				"salience": 0.00010373407,
				"type": "ORGANIZATION"
			},
			{
				"name": "ICNC",
				"salience": 0.00010373407,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "Department of State",
				"salience": 0.00010373407,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0p8q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Enterprise_Institute"
				},
				"name": "AEI",
				"salience": 0.00010373407,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i0.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/SICK-SOROS-PAID-PROTESTS-21WIRE-SLIDER-SH-4.jpg?fit=620%2C415",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T23:13:29.272+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 27.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "November 11, 2016 By Shawn Helton Leave a Comment \nShawn Helton 21st Century Wire \nAnti-Trump street protests linked to the Soros’ funded organization MoveOn.org have cascaded across the nation for the third day following the 2016 presidential election result. \nMainstream media outlets like CNN and MSNBC have given the protests around-the-clock media coverage, drowning out all other news stories, including a successful transition meeting between the President Elect and President Barack Obama. \n‘OUTSIDER VS. INSIDER’– Manufactured social unrest incited after announcement of Trump presidency. (Photo Illustration 21WIRE’s Shawn Helton) \nThe Free Thought Project weighed in on the new developments concerning a series of centrally coordinated anti-Trump protests organized in part by by the George Soros NGO MoveOn: \n“Washington, D.C. – Billionaire globalist financier George Soros’ MoveOn.org has been revealed to be a driving force behind the organizing of nationwide protests against the election of Donald Trump — exposing the protests to largely be an organized, top-down operation — and not an organic movement of concerned Americans taking to the streets as reported by the mainstream media. \nWednesday saw protests in the streets of at least 10 major U.S. cities. Chicago, New York, Los Angeles, Philadelphia, Boston, Washington, D.C., Portland, Ore., St. Paul, Minn., Seattle , and several other cities saw protests, according to USA Today. \nIn light of the protests and rioting that have transpired since the election of Trump, a closer analysis of the dynamic at play is warranted to gauge whether it’s an organic grassroots movement, or something much more organized, sophisticated and potentially dangerous.” \nSoros’ affiliated organization MoveOn.org released the following press release yesterday afternoon: \n“Americans to Come Together in Hundreds Peaceful Gatherings of Solidarity, Resistance, and Resolve Following Election Results \nHundreds of Americans, dozens of organizations to gather peacefully outside the White House and in cities and towns nationwide to take a continued stand against misogyny, racism, Islamophobia, and xenophobia. \nTonight, thousands of Americans will come together at hundreds of peaceful gatherings in cities and towns across the nation, including outside the White House, following the results of Tuesday’s presidential election. \nThe gatherings – organized by MoveOn.org and allies – will affirm a continued rejection of Donald Trump’s bigotry, xenophobia, Islamophobia, and misogyny and demonstrate our resolve to fight together for the America we still believe is possible. \nWithin two hours of the call-to-action, MoveOn members had created more than 200 gatherings nationwide, with the number continuing to grow on Wednesday afternoon.” \nSoros Agit-Prop Empire \nLast year during the ongoing European migrant crisis, startling claims were levied by Hungarian PM Victor Orban (left photo), concerning the role played by Soros. \nPM Orban contended that the founder and chair of Open Society Foundations (Open Society Institute), was entrenched in a “ circle of activists,” that “inadvertently become part of this international human-smuggling network.” \nThe stunning declaration by Orban recalled the misguided machinations of ‘The Occupy Movement’ ( aka OWS) in 2011, as well as the Soros funded protests in Ferguson, Missouri in 2014, along with other Black Lives Matter protests this past year – all of which were uniquely designed to push naive participants (along with paid provocateurs) into violent action and social unrest. \nBack in January, MoveOn publicly endorsed the Bernie Sanders campaign in what appeared to be a call to action for BLM associated groups seen backing Sanders. It’s worth mentioning, that MoveOn also supported the Obama campaign in 2008 and according to the website, Sanders was the only other candidate to reach the “threshold for an endorsement.” \nAs we said back in March, professional political agitator flash mobs, had been mobilized at future Trump campaign events, making it very difficult to run a normal campaign – as ‘activists’ attempted to take away Trump’s ‘strength in numbers’ at his rallies. This was confirmed at events in both Ohio, and at a Trump primary campaign event the University of Illinois Chicago earlier this year, where hundreds of BLM activists and Sanders supporters, triggered voilent clashes inside the venue and even stormed the stage , shortly after Trump started speaking, then again at Reno he was birddogged just prior to his election forcing secret service to escort Trump away. \nIn a Politico article in early 2016 entitled “ Major donors consider funding Black Lives Matter ,” we gained deeper insight into the political funding for BLM and the Soros linked Democratic Alliance: \n“Major donors are usually not as radical or confrontational as activists most in touch with the pain of oppression,” said Steve Phillips, a Democracy Alliance member and significant contributor to Democratic candidates and causes. He donated to a St. Louis nonprofit group called the Organization for Black Struggle that helped organize 2014 Black Lives Matter-related protests in Ferguson, Missouri, over the police killing of a black teenager named Michael Brown. And Phillips and his wife, Democracy Alliance board member Susan Sandler, are in discussions about funding other groups involved in the movement.” \nIt worth noting how Soros, a long time contributor to Hillary Clinton, donated $2 million in PAC money in 2015 and January of 2016, Soros reportedly gave $8 million to “boost” Clinton’s campaign . Soros also recently funded $15 million to Latino groups looking to stop Trump’s rise towards a potential GOP nomination and beyond. \nLook for these political engineers to pit choreographed conservative and liberal groups against each other across the country – as all of these hostile uprisings are designer engineered by party linked alliances. \n‘SOCIAL ENGINEERING’– Political memes and staged political flash mobs have been sparked by media, NGO’s and social media. (Image Source: abc news ) \nDuring the last month, it was revealed how investigative non-profit Project Veritas found evidence that the DNC paid participants to incite violence at Trump rallies during the course of the 2016 election. \nIf those reports are accurate – reports which have gone unchallenged so far – this would be in violation of both election bylaws and also US criminal law. \nPAID PROTEST?’– Social justice warriors incite anti-Trump violence across the US. (Image Source: youtube ) \nUSA Color Revolutions \nBoth the purpose of these types of agitation activities seems to be to first cause a public disruption, and also to foment are a form of modern class warfare. These political protests are designed in such a way as to disguise its true intentions. Ultimately, a radical globalist and cultural marxist “progressive” agenda is at play – eroding the legitimacy of a democratically elected government through a series of artificial ‘color’ upheavals, and where possible – weakening a country’s national sovereignty through forced dependency on multilateral globalist institutions like the UN or IMF, while presenting shock and awe imagery in order to manipulate the public’s political perspective. \nThis is how the US and its CIA conduct their destablization ‘color revolution’ campaigns overseas , and now astute observers will be able to see these exact same methods being deployed here inside the US. \nOverseas, Washington tends to use the same cast of NGO fronts to build-up pro-US political opposition groups, as well as plan and generate civil unrest. They include the Albert Einstein Institute (AEI), National Endowment for Democracy (NED), International Republican Institute (IRI), National Democratic Institute (NDI), Freedom House and later the International Center for Non-Violent Conflict (ICNC), and the US Agency for International Development (USAID), the financial and contractor arm of the Department of State. \nInside the US, deep state actors in Washington generally work through Democratic Party affiliated organizations like MoveOn.org , as well as through labor union organizations like AFL-CIO , and UNITE HERE . These, along with many other similar organizations have been involved in organizing this week’s protests. \nIt still remains to be seen if Trump’s stated dynamic political vision for America can unite an embattled nation by restoring international relations throughout the world, in addition to helping economic woes at home, or will it simply push the country further into authoritarianism. This remains to be seen. \nCertainly, judging by President Obama and Hillary Clinton’s total silence over their own party’s role in fomenting this week’s unrest – one can only conclude that both party leaders approve of the protests and riots. The political motivation is undeniable – to help delegitimize a new Trump presidency. \nBut one thing is for sure – there’s no doubt now that a systematic design is in place to unsettle the 45th president and the public should question why. \nLegal Action Against Soros Groups \nIn a recent report featured at RT news we learn that George Soros and BLM activists will be sued for the deaths of slain police officers in Dallas and Baton Rouge: “The father of the Dallas police officer who was killed by a lone gunman during a Black Lives Matter protest is suing the organization’s activists and George Soros for $550 million . In a separate suit a Baton Rouge police officer is suing for injuries sustained during a BLM protest. \nThe father of Patrick Zamarripa filed a lawsuit against Black Lives Matter and other groups for allegedly “inciting a war on police” that led to the death of his son. \nThe lawsuit filed in US District Court in Dallas on Monday seeks $550 million in damages. \n“While Defendant Black Lives Matter claims to combat anti-black racism,” the lawsuit said, according to the Fort Worth Star Telegram, “the movement has in fact incited and committed further violence, severe bodily injury and death against police officers of all races and ethnicities, Jews, and Caucasians. Defendant Black Lives Matter is in fact a violent and revolutionary criminal gang.” \nThe misguided machinations behind the anti-Trump protests have dominated any peaceful transition into power for the president-elect. Will these protest groups be a reboot of the OWS movement, occupying the masses with their own hateful rhetoric as we move into 2017 and beyond? \nMore from the Duran below… \n‘NEO BLACK BLOC?’– Black bloc provocateurs, have violently escalated protest movements since the 1980’s, all the way through 2011’s Occupy Wall Street Movement and beyond. The riotous scene above is from the anti-trump protests in Portland. (Image Source: willamette week ) \nGeorge Soros begins his color revolution in America, as MoveOn “activists” march against Trump \nBy Alex Christoforou The Duran \nAnti-Trump protesters march through the streets of New York shouting ‘Not my president’. \nMoveOn.org is a George Soros NGO…and George Soros NGOs have nothing to do with charity or justice, and everything to do with political leverage, and in extreme cases government insurrection. \nWe have seen Soros begin destructive movements to remove those he deems unsuitable to govern in a variety of countries, most recently in Ukraine, with the Soros sponsored Maidan coup. \nNow it looks like Soros may be setting his sights on sabotaging the forthcoming Trump presidency. \nWe do know, thanks to Wikileaks, that George Soros was a huge supporter of Hillary Clinton, as Hillary Clinton was always looking out of George Soros’ best interests. \nWe are certain Trump’s victory is a bitter pill for globalist Soros to swallow. Between Putin and Trump, Soros may finally be starting to feel his power on the world stage falter. \nMore from Duran here … \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV",
		"thread_title": "‘COLOR REV’ AGIT PROP: George Soros MoveOn Agitators March on America – as Billionaire Instigator Sued",
		"title": "‘COLOR REV’ AGIT PROP: George Soros MoveOn Agitators March on America – as Billionaire Instigator Sued",
		"type": "conspiracy",
		"uuid": "2a63aa7d67b72eb1233594b7814a35e7fde7813a"
	},
	"-KhIWK47JHArZIPFMXLh": {
		"author": "Mike Rivero",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-12T23:13:50.035+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.16396536,
				"type": "PERSON"
			},
			{
				"name": "Patrick Henningsen",
				"salience": 0.08155409,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.060918037,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.05772862,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0257nv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MoveOn.org"
				},
				"name": "MoveOn.org",
				"salience": 0.05088951,
				"type": "ORGANIZATION"
			},
			{
				"name": "protests",
				"salience": 0.025671016,
				"type": "EVENT"
			},
			{
				"name": "voters",
				"salience": 0.022950362,
				"type": "PERSON"
			},
			{
				"name": "Shawn Helton",
				"salience": 0.021789888,
				"type": "PERSON"
			},
			{
				"name": "Election",
				"salience": 0.021388771,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.019450394,
				"type": "PERSON"
			},
			{
				"name": "unrest",
				"salience": 0.018535735,
				"type": "EVENT"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.017831005,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.017551064,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.015335597,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.014507957,
				"type": "OTHER"
			},
			{
				"name": "eve",
				"salience": 0.014507957,
				"type": "EVENT"
			},
			{
				"name": "likes",
				"salience": 0.014507957,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.014507957,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.014507957,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04qwhs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_presidential_election,_2004"
				},
				"name": "US Presidential Election",
				"salience": 0.013194748,
				"type": "EVENT"
			},
			{
				"name": "flash mobs",
				"salience": 0.012865039,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.01170332,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGO",
				"salience": 0.011601213,
				"type": "OTHER"
			},
			{
				"name": "21WIRE",
				"salience": 0.010338537,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.009329774,
				"type": "OTHER"
			},
			{
				"name": "community organizing",
				"salience": 0.008833948,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition groups",
				"salience": 0.008212847,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.008087609,
				"type": "PERSON"
			},
			{
				"name": "wave",
				"salience": 0.0069099143,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0069099143,
				"type": "EVENT"
			},
			{
				"name": "front organizations",
				"salience": 0.0061976435,
				"type": "ORGANIZATION"
			},
			{
				"name": "Watch",
				"salience": 0.005984683,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "platform",
				"salience": 0.005984683,
				"type": "OTHER"
			},
			{
				"name": "news rotation",
				"salience": 0.005984683,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.005984683,
				"type": "OTHER"
			},
			{
				"name": "RT International",
				"salience": 0.0051009525,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.005060795,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.005060795,
				"type": "EVENT"
			},
			{
				"name": "overseas",
				"salience": 0.004846952,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.004846952,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.0047501842,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.004666196,
				"type": "PERSON"
			},
			{
				"name": "unrest",
				"salience": 0.00438283,
				"type": "OTHER"
			},
			{
				"name": "shores",
				"salience": 0.004197598,
				"type": "LOCATION"
			},
			{
				"name": "color revolutions",
				"salience": 0.004197598,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.004197598,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.004197598,
				"type": "OTHER"
			},
			{
				"name": "VIDEO",
				"salience": 0.004197598,
				"type": "WORK_OF_ART"
			},
			{
				"name": "College Students",
				"salience": 0.004197598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/011hwh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Agency_for_International_Development"
				},
				"name": "US Agency for International Development",
				"salience": 0.004086011,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.004041028,
				"type": "OTHER"
			},
			{
				"name": "totals",
				"salience": 0.004041028,
				"type": "OTHER"
			},
			{
				"name": "activist",
				"salience": 0.004041028,
				"type": "PERSON"
			},
			{
				"name": "fronts",
				"salience": 0.0039575673,
				"type": "OTHER"
			},
			{
				"name": "street protests",
				"salience": 0.0037814712,
				"type": "EVENT"
			},
			{
				"name": "organizations",
				"salience": 0.0037814712,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.003685329,
				"type": "ORGANIZATION"
			},
			{
				"name": "Occupy 2.0",
				"salience": 0.003685329,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "BlackLivesMatter",
				"salience": 0.003685329,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03zfw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Republican_Institute"
				},
				"name": "International Republican Institute",
				"salience": 0.0035528843,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06w_03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Max_Planck_Institute_for_Gravitational_Physics"
				},
				"name": "Albert Einstein Institute",
				"salience": 0.0035528843,
				"type": "LOCATION"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.003478431,
				"type": "PERSON"
			},
			{
				"name": "cast",
				"salience": 0.0034272415,
				"type": "OTHER"
			},
			{
				"name": "driving force",
				"salience": 0.0034272415,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.0034272415,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.002984326,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.0029094515,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0lq3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electoral_College_(United_States)"
				},
				"name": "Electoral College",
				"salience": 0.002872972,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01ntzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Endowment_for_Democracy"
				},
				"name": "National Endowment for Democracy",
				"salience": 0.0027780964,
				"type": "ORGANIZATION"
			},
			{
				"name": "protests",
				"salience": 0.0027545448,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05l5x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Democratic_Institute_for_International_Affairs"
				},
				"name": "National Democratic Institute",
				"salience": 0.0026544398,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0025843156,
				"type": "ORGANIZATION"
			},
			{
				"name": "presidency",
				"salience": 0.0025819319,
				"type": "OTHER"
			},
			{
				"name": "silence",
				"salience": 0.0025605445,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0025605445,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0024964397,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0024878758,
				"type": "LOCATION"
			},
			{
				"name": "motivation",
				"salience": 0.002403277,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0023967593,
				"type": "LOCATION"
			},
			{
				"name": "unrest",
				"salience": 0.002385311,
				"type": "EVENT"
			},
			{
				"name": "party leaders",
				"salience": 0.0022844416,
				"type": "PERSON"
			},
			{
				"name": "riots",
				"salience": 0.0021537393,
				"type": "EVENT"
			},
			{
				"name": "pro-US",
				"salience": 0.0021098445,
				"type": "OTHER"
			},
			{
				"name": "labor union organizations",
				"salience": 0.0020578564,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizations",
				"salience": 0.0020578564,
				"type": "ORGANIZATION"
			},
			{
				"name": "role",
				"salience": 0.0018649953,
				"type": "OTHER"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0018649953,
				"type": "OTHER"
			},
			{
				"name": "updates",
				"salience": 0.0018649953,
				"type": "OTHER"
			},
			{
				"name": "21WIRE",
				"salience": 0.0016955928,
				"type": "OTHER"
			},
			{
				"name": "financial",
				"salience": 0.0016089347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qzyj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unite_the_Union"
				},
				"name": "UNITE",
				"salience": 0.0015761381,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0015033426,
				"type": "OTHER"
			},
			{
				"name": "state actors",
				"salience": 0.0014109801,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gspln",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Center_on_Nonviolent_Conflict"
				},
				"name": "International Center for Non-Violent Conflict",
				"salience": 0.0010967825,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.0010503847,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0010503847,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0drpg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_House"
				},
				"name": "Freedom House",
				"salience": 0.0009902668,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018czw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AFL%E2%80%93CIO"
				},
				"name": "AFL-CIO",
				"salience": 0.00085746474,
				"type": "ORGANIZATION"
			},
			{
				"name": "ICNC",
				"salience": 0.00085746474,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "Department of State",
				"salience": 0.00085746474,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i0.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Patrick_henningsen-Trump-Riots.png?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T23:13:50.035+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "21st Century Wire says… \nOrganized efforts are underway by Democratic Party affiliated NGO’s to try and somehow delegitimize the results of this week’s US Presidential Election. \nOn the eve of the US Election before voters went to the polls, 21WIRE political affairs analyst Patrick Henningsen accurately predicted this week’s unrest when he said : \n“If Trump wins, expect the likes of Soros and MoveOn.org to unleash wave after wave of flash mobs, who will protest, riot, smash and burn their way on to CNN’s 24 hour news rotation. Expect Occupy 2.0, and #BlackLivesMatter to rage.” \nOn Friday, Henningsen talked to RT International about the post-elections protests that were coordinated in part by Democratic Party ‘community organizing’ online platform MoveOn.org . Watch: \n. Not surprisingly, MoveOn.org have also launched a national ‘activist’ campaign to “ Abolish the Electoral College ” after Democratic candidate Hillary Clinton came up short with 232 (including New Hampshire) to Donald Trump’s 306 (including Arizona and Michigan). Final totals are not yet in, but thus far 2016 would be the fifth time in U.S. history that a presidential candidate has won the White House while losing the total popular vote. \nSEE ALSO: (VIDEO) Female College Students Protesting Because ‘Trump is a Rapist’ \n21WIRE Associate Editor Shawn Helton recently revealed more details about how the near exact same methods used in CIA and Soros-funded ‘color revolutions’ overseas – are now being deployed on US domestic shores by similar NGO front organizations: has been the driving force behind nationwide protests against the election of Donald Trump. \n“Overseas, Washington tends to use the same cast of NGO fronts to build-up pro-US political opposition groups, as well as plan and generate civil unrest. They include the Albert Einstein Institute (AEI), National Endowment for Democracy (NED), International Republican Institute (IRI), National Democratic Institute (NDI), Freedom House and later the International Center for Non-Violent Conflict (ICNC), and the US Agency for International Development (USAID), the financial and contractor arm of the Department of State. Inside the US, deep state actors in Washington generally work through Democratic Party affiliated organizations like MoveOn.org, as well as through labor union organizations like AFL-CIO , and UNITE HERE . These, along with many other similar organizations have been involved in organizing this week’s protests,” says Helton. \nHelton also raised the question as to why President Obama has stayed silent in the face of street protests, opting instead to “lead from behind.” He explains: \n“Certainly, judging by President Obama and Hillary Clinton’s total silence over their own party’s role in fomenting this week’s unrest – one can only conclude that both party leaders approve of the protests and riots. The political motivation is undeniable – to help delegitimize a new Trump presidency.” \nStay tuned for more updates here at 21WIRE. \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV",
		"thread_title": "Henningsen: ‘US Anti-Trump Protests Similar to Soros Color Revolutions Abroad’",
		"title": "Henningsen: ‘US Anti-Trump Protests Similar to Soros Color Revolutions Abroad’",
		"type": "conspiracy",
		"uuid": "2c6a0f68ac6206d50c6993c4e727bc3b6a6354e7"
	},
	"-KhIWKH6vIwxVuUBJhN6": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-13T04:33:15.249+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.15191568,
				"type": "ORGANIZATION"
			},
			{
				"name": "Schools",
				"salience": 0.040877897,
				"type": "ORGANIZATION"
			},
			{
				"name": "universities",
				"salience": 0.039198127,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.039198127,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.03624042,
				"type": "LOCATION"
			},
			{
				"name": "staffers",
				"salience": 0.03323496,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.029756192,
				"type": "ORGANIZATION"
			},
			{
				"name": "trauma",
				"salience": 0.028391883,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.028391883,
				"type": "ORGANIZATION"
			},
			{
				"name": "nations",
				"salience": 0.028391883,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.027445314,
				"type": "LOCATION"
			},
			{
				"name": "therapy dogs",
				"salience": 0.022818973,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.022386063,
				"type": "LOCATION"
			},
			{
				"name": "poetry readings",
				"salience": 0.019820552,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.019659396,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.01752348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.01752348,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.016229829,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.016229829,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.016052386,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08815",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yale_University"
				},
				"name": "Yale University",
				"salience": 0.015472392,
				"type": "ORGANIZATION"
			},
			{
				"name": "group scream",
				"salience": 0.013657659,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.013546427,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.011504785,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.011392335,
				"type": "EVENT"
			},
			{
				"name": "Students",
				"salience": 0.011392335,
				"type": "PERSON"
			},
			{
				"name": "dogs",
				"salience": 0.010968154,
				"type": "OTHER"
			},
			{
				"name": "campuses",
				"salience": 0.010526642,
				"type": "PERSON"
			},
			{
				"name": "campus",
				"salience": 0.010526642,
				"type": "LOCATION"
			},
			{
				"name": "activities",
				"salience": 0.010340782,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.009830476,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cornell_University"
				},
				"name": "Cornell University",
				"salience": 0.0090072695,
				"type": "ORGANIZATION"
			},
			{
				"name": "cry-ins",
				"salience": 0.0089971395,
				"type": "OTHER"
			},
			{
				"name": "offices",
				"salience": 0.008234287,
				"type": "LOCATION"
			},
			{
				"name": "doodles",
				"salience": 0.007927438,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.007927438,
				"type": "OTHER"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.007927438,
				"type": "OTHER"
			},
			{
				"name": "beagle mix",
				"salience": 0.007927438,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.007230246,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/039vb8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Therapy_dog"
				},
				"name": "Therapy Dogs",
				"salience": 0.0067571774,
				"type": "ORGANIZATION"
			},
			{
				"name": "snacks",
				"salience": 0.0067243064,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0065967394,
				"type": "OTHER"
			},
			{
				"name": "campus",
				"salience": 0.0064252825,
				"type": "LOCATION"
			},
			{
				"name": "bosses",
				"salience": 0.0063921576,
				"type": "PERSON"
			},
			{
				"name": "Organizers",
				"salience": 0.0061582825,
				"type": "PERSON"
			},
			{
				"name": "press release",
				"salience": 0.0058498243,
				"type": "WORK_OF_ART"
			},
			{
				"name": "@SteveFeldman",
				"salience": 0.005637545,
				"type": "PERSON"
			},
			{
				"name": "dogs",
				"salience": 0.0053301677,
				"type": "OTHER"
			},
			{
				"name": "Pet Leadership Council",
				"salience": 0.0052952315,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pet Industry Joint Advisory Council",
				"salience": 0.0052952315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_of_Representatives"
				},
				"name": "House of Representatives",
				"salience": 0.0050714626,
				"type": "ORGANIZATION"
			},
			{
				"name": "Steve Feldman",
				"salience": 0.0050714626,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.005066788,
				"type": "EVENT"
			},
			{
				"name": "student",
				"salience": 0.005066788,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.0050248425,
				"type": "OTHER"
			},
			{
				"name": "re-election bids",
				"salience": 0.0050248425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017lw7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Eskimo_Dog"
				},
				"name": "American Eskimo",
				"salience": 0.0048823184,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02pkff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Capitol_Hill"
				},
				"name": "Capitol Hill",
				"salience": 0.0048823184,
				"type": "LOCATION"
			},
			{
				"name": "Pet Partners",
				"salience": 0.0047814925,
				"type": "ORGANIZATION"
			},
			{
				"name": "surprise victory",
				"salience": 0.004226922,
				"type": "EVENT"
			},
			{
				"name": "NGOs the Human Animal Bond Research Initiative",
				"salience": 0.004140816,
				"type": "ORGANIZATION"
			},
			{
				"name": "stress",
				"salience": 0.003660479,
				"type": "OTHER"
			},
			{
				"name": "student meltdown",
				"salience": 0.003660479,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0034795252,
				"type": "OTHER"
			},
			{
				"name": "Lionel Media",
				"salience": 0.0034263853,
				"type": "PERSON"
			},
			{
				"name": "reaction",
				"salience": 0.0032247133,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0031580892,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qv6f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ed_Schultz"
				},
				"name": "Ed Schultz",
				"salience": 0.0029782949,
				"type": "PERSON"
			},
			{
				"name": "RT America",
				"salience": 0.0028820282,
				"type": "LOCATION"
			},
			{
				"name": "steam",
				"salience": 0.0027347722,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0027347722,
				"type": "OTHER"
			},
			{
				"name": "best friend",
				"salience": 0.0027347722,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Hillary-Trump-DOGS.jpg?fit=610%2C419",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-13T03:51:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.5,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.288",
		"text": "\n21st Century Wire says… \nYou can imagine how nations like China and Russia are now laughing at US students as mass psychological trauma has apparently set-in across liberal America. Schools, universities and political institutions across the country are now offering various services following Republican Donald Trump’s insurgent victory in the US presidential election. \nAccording to NBC News , Democratic staffers were so distraught over this week’s election that “therapy dogs” had to be brought in to help workers on Capitol Hill cope with their vulnerabilities and hurt feelings. \n— Steve Feldman (@SteveFeldman) November 9, 2016 \nTherapy Dogs included two golden doodles, two American Eskimo dogs, and a beagle mix – walked around the offices of the House of Representatives. Students at Cornell University even staged a “cry-in” on campus the day after the election. \nOther US campuses were organizing various theraputic activities like poetry readings, where “healthy snacks will be served.” \nThe dogs were organized by NGOs the Human Animal Bond Research Initiative, Pet Partners, the Pet Leadership Council and the Pet Industry Joint Advisory Council. \nTheir press release says that Democratic Party staffers needed, “the help of a non-judgmental, furry, four-legged best friend that enjoys bipartisan support.” \n“Organizers say it was a great way for workers to blow off steam especially for those whose bosses may have lost re-election bids,” NBC added. \nAlso,“cry-ins” were staged on the campus of Cornell University, and Yale University even staged a “group scream” in order to help student vent their “internalized stress” the day after the election. \nWatch RT America’s Ed Schultz and Lionel, of Lionel Media, discuss the ridiculous liberal reaction and student meltdown to Trump’s surprise victory: \n. ",
		"thread_title": "Post-Trump Liberal Meltdown: Counseling, Cry-ins, Therapy Dogs and Poetry",
		"title": "Post-Trump Liberal Meltdown: Counseling, Cry-ins, Therapy Dogs and Poetry",
		"type": "conspiracy",
		"uuid": "65272a7457360257e5b5f2540411785b4f848d55"
	},
	"-KhIWKTA-k1N160K5buH": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-14T22:30:02.870+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Patrick Henningsen",
				"salience": 0.2323024,
				"type": "PERSON"
			},
			{
				"name": "Comment Episode",
				"salience": 0.1131589,
				"type": "WORK_OF_ART"
			},
			{
				"name": "SUNDAY WIRE SHOW",
				"salience": 0.070367865,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.061116844,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J Trump",
				"salience": 0.044334427,
				"type": "PERSON"
			},
			{
				"name": "talk radio",
				"salience": 0.041029286,
				"type": "OTHER"
			},
			{
				"name": "ACR",
				"salience": 0.029242653,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02l3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election"
				},
				"name": "Election",
				"salience": 0.028693747,
				"type": "EVENT"
			},
			{
				"name": "post-mortem",
				"salience": 0.027947817,
				"type": "EVENT"
			},
			{
				"name": "broadcast",
				"salience": 0.02674594,
				"type": "OTHER"
			},
			{
				"name": "TIMES",
				"salience": 0.024287434,
				"type": "OTHER"
			},
			{
				"name": "FOLLOWING",
				"salience": 0.021045897,
				"type": "OTHER"
			},
			{
				"name": "PAGE",
				"salience": 0.021045897,
				"type": "OTHER"
			},
			{
				"name": "SUNDAYS",
				"salience": 0.016584484,
				"type": "ORGANIZATION"
			},
			{
				"name": "edition",
				"salience": 0.014225746,
				"type": "WORK_OF_ART"
			},
			{
				"name": "road",
				"salience": 0.014225746,
				"type": "LOCATION"
			},
			{
				"name": "stories",
				"salience": 0.0123782605,
				"type": "WORK_OF_ART"
			},
			{
				"name": "aftermath",
				"salience": 0.012069026,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.012069026,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04l3y6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.pt"
				},
				"name": "PT",
				"salience": 0.011290437,
				"type": "LOCATION"
			},
			{
				"name": "EPISODE",
				"salience": 0.010956068,
				"type": "WORK_OF_ART"
			},
			{
				"name": "THE SUNDAY WIRE",
				"salience": 0.010120206,
				"type": "EVENT"
			},
			{
				"name": "UK Time",
				"salience": 0.010120206,
				"type": "OTHER"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.009151982,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vjl2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix_metropolitan_area"
				},
				"name": "Valley of the Sun",
				"salience": 0.009104821,
				"type": "LOCATION"
			},
			{
				"name": "ground",
				"salience": 0.009021189,
				"type": "LOCATION"
			},
			{
				"name": "MEMBER",
				"salience": 0.009021189,
				"type": "PERSON"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.009021189,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.009021189,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.007002891,
				"type": "LOCATION"
			},
			{
				"name": "blast shield",
				"salience": 0.006573141,
				"type": "OTHER"
			},
			{
				"name": "NOTE",
				"salience": 0.006573141,
				"type": "OTHER"
			},
			{
				"name": "LANGUAGE",
				"salience": 0.006573141,
				"type": "OTHER"
			},
			{
				"name": "THEMES",
				"salience": 0.006573141,
				"type": "OTHER"
			},
			{
				"name": "Randy J",
				"salience": 0.0064153634,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.005671447,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017l04",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Coast_of_the_United_States"
				},
				"name": "West Coast",
				"salience": 0.005555939,
				"type": "LOCATION"
			},
			{
				"name": "@21WIRE.TV Strap",
				"salience": 0.005555939,
				"type": "OTHER"
			},
			{
				"name": "contributor",
				"salience": 0.0049115624,
				"type": "PERSON"
			},
			{
				"name": "everyman",
				"salience": 0.0049115624,
				"type": "PERSON"
			},
			{
				"name": "street protests",
				"salience": 0.0049115624,
				"type": "EVENT"
			},
			{
				"name": "ACR Boiler Room",
				"salience": 0.00302377,
				"type": "LOCATION"
			},
			{
				"name": "Democratic Party Machine",
				"salience": 0.00302377,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.00302377,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i0.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-SW-deplorables-copy.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-13T23:22:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.959",
		"text": "November 13, 2016 By 21wire Leave a Comment \nEpisode #160 of SUNDAY WIRE SHOW resumes this November 13, 2016 as host Patrick Henningsen brings a 3 HOURS special broadcast of LIVE power-packed talk radio on ACR… \nLISTEN LIVE ON THIS PAGE AT THE FOLLOWING SCHEDULED SHOW TIMES: \nSUNDAYS – 5pm-8pm UK Time | 12pm-3pm ET (US) | 9am-12pm PT (US) \nThis week’s edition of THE SUNDAY WIRE is on the road broadcasting LIVE from the Valley of the Sun. This week host Patrick Henningsen covers this week’s top stories in the US and internationally. In the first hour we’ll conduct a post-mortem on the incredible US Election which has produced President Elect Donald J Trump , and the aftermath – a nation divided punctuated by numerous street protests in part fuelled by Soros and the Democratic Party Machine . Later, we’re joined by our roving everyman , ACR Boiler Room contributor, Randy J , for an on the ground take on Election events from the West Coast, and beyond… \nSUPPORT 21WIRE – SUBSCRIBE & BECOME A MEMBER @21WIRE.TV \nStrap yourselves in and lower the blast shield – this is your brave new world… \n*NOTE: THIS EPISODE MAY CONTAIN STRONG LANGUAGE AND MATURE THEMES* ",
		"thread_title": "Episode #160 – SUNDAY WIRE: ‘Hail to the Deplorables’ with special guest Randy J",
		"title": "Episode #160 – SUNDAY WIRE: ‘Hail to the Deplorables’ with special guest Randy J",
		"type": "conspiracy",
		"uuid": "78ea7e7d34d7da2ba484674ad024e0951f46bcfa"
	},
	"-KhIWL3T7stey1_U7Cez": {
		"author": "Mike Rivero",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-17T03:16:17.756+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.28819957,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS News",
				"salience": 0.08391188,
				"type": "ORGANIZATION"
			},
			{
				"name": "Affiliated Street Gangs What Leslie Stahl",
				"salience": 0.029748168,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.024490379,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.024279332,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.022739353,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.020795884,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.018455844,
				"type": "PERSON"
			},
			{
				"name": "Comment",
				"salience": 0.014167267,
				"type": "WORK_OF_ART"
			},
			{
				"name": "street gangs",
				"salience": 0.012008033,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.011439876,
				"type": "OTHER"
			},
			{
				"name": "supporter",
				"salience": 0.010360848,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.009092867,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.008333576,
				"type": "EVENT"
			},
			{
				"name": "mainstream media",
				"salience": 0.0075376746,
				"type": "OTHER"
			},
			{
				"name": "election campaign",
				"salience": 0.007531549,
				"type": "EVENT"
			},
			{
				"name": "woman",
				"salience": 0.00600167,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.005934515,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.005934515,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026q4th",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brian_Stelter"
				},
				"name": "Brian Stelter",
				"salience": 0.005870769,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.005535452,
				"type": "EVENT"
			},
			{
				"name": "story",
				"salience": 0.0054311086,
				"type": "WORK_OF_ART"
			},
			{
				"name": "supporter",
				"salience": 0.005189027,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0051570907,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0050925883,
				"type": "PERSON"
			},
			{
				"name": "swing",
				"salience": 0.005060993,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.004840819,
				"type": "OTHER"
			},
			{
				"name": "complainant",
				"salience": 0.0045346264,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0044288784,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.0044092364,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.004228846,
				"type": "OTHER"
			},
			{
				"name": "plea",
				"salience": 0.0039284797,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.003818623,
				"type": "OTHER"
			},
			{
				"name": "hate crime",
				"salience": 0.003818623,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.003818623,
				"type": "OTHER"
			},
			{
				"name": "camera",
				"salience": 0.0035794657,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0035051396,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0033070233,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0033070233,
				"type": "ORGANIZATION"
			},
			{
				"name": "credibility",
				"salience": 0.0033070233,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0032856197,
				"type": "OTHER"
			},
			{
				"name": "SUPPORT 21WIRE",
				"salience": 0.0031807593,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qbmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._R._Smith"
				},
				"name": "J.R. Smith",
				"salience": 0.0031166417,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0030674078,
				"type": "OTHER"
			},
			{
				"name": "mainstream media collusion",
				"salience": 0.0029861217,
				"type": "OTHER"
			},
			{
				"name": "Democratic National Party",
				"salience": 0.002915407,
				"type": "ORGANIZATION"
			},
			{
				"name": "hoaxes",
				"salience": 0.0028767325,
				"type": "OTHER"
			},
			{
				"name": "female",
				"salience": 0.002737289,
				"type": "PERSON"
			},
			{
				"name": "clip",
				"salience": 0.0026910624,
				"type": "WORK_OF_ART"
			},
			{
				"name": "slogans",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "election results",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "coverage",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "outbreaks",
				"salience": 0.0025859473,
				"type": "EVENT"
			},
			{
				"name": "pockets",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0025859473,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "polling",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "email dump",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0025859473,
				"type": "PERSON"
			},
			{
				"name": "mode",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "crumb",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "fronts",
				"salience": 0.0025859473,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0024109713,
				"type": "OTHER"
			},
			{
				"name": "mainstream media observers",
				"salience": 0.002292217,
				"type": "PERSON"
			},
			{
				"name": "supports",
				"salience": 0.002277316,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0021242849,
				"type": "PERSON"
			},
			{
				"name": "Clinton Campaign",
				"salience": 0.0020360006,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.002027737,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0020215267,
				"type": "PERSON"
			},
			{
				"name": "intimidation",
				"salience": 0.0019439488,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0018695184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.0018638783,
				"type": "PERSON"
			},
			{
				"name": "flavor",
				"salience": 0.0018478264,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.0018166106,
				"type": "PERSON"
			},
			{
				"name": "appeal",
				"salience": 0.0017904595,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0017828885,
				"type": "ORGANIZATION"
			},
			{
				"name": "mainstream media",
				"salience": 0.0016905748,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0016609359,
				"type": "EVENT"
			},
			{
				"name": "Podesta",
				"salience": 0.0015918968,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0015918968,
				"type": "ORGANIZATION"
			},
			{
				"name": "pro-Clinton",
				"salience": 0.0015918968,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "incidents",
				"salience": 0.0015787994,
				"type": "EVENT"
			},
			{
				"name": "gutter operatives",
				"salience": 0.001547293,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0015425633,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0014895019,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.0014895019,
				"type": "PERSON"
			},
			{
				"name": "media outlet",
				"salience": 0.0014773717,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05xy1t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lesley_Stahl"
				},
				"name": "Lesley Stahl",
				"salience": 0.0014745512,
				"type": "PERSON"
			},
			{
				"name": "cameras",
				"salience": 0.0014739205,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.0014447079,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.0014447079,
				"type": "EVENT"
			},
			{
				"name": "supporters",
				"salience": 0.0014339059,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0014043134,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0013966282,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0013801545,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0013719122,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0013672743,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.0013616543,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0013616543,
				"type": "OTHER"
			},
			{
				"name": "hoaxes",
				"salience": 0.0013616543,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0013616543,
				"type": "EVENT"
			},
			{
				"name": "abuses",
				"salience": 0.0013616543,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0013616543,
				"type": "OTHER"
			},
			{
				"name": "abuses",
				"salience": 0.0013616543,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.0013616543,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0013217797,
				"type": "OTHER"
			},
			{
				"name": "newsrooms",
				"salience": 0.0013217797,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0013108278,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.0012210964,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protests",
				"salience": 0.0012210964,
				"type": "EVENT"
			},
			{
				"name": "supporters",
				"salience": 0.0012159854,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0012159854,
				"type": "OTHER"
			},
			{
				"name": "hoax",
				"salience": 0.0012147931,
				"type": "OTHER"
			},
			{
				"name": "David Wilcox",
				"salience": 0.0012053784,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.0011755142,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.0011755142,
				"type": "WORK_OF_ART"
			},
			{
				"name": "President",
				"salience": 0.0011755142,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0011755142,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hat",
				"salience": 0.0011634092,
				"type": "OTHER"
			},
			{
				"name": "headlines",
				"salience": 0.0011342729,
				"type": "OTHER"
			},
			{
				"name": "Student Trump",
				"salience": 0.0011263797,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.0011210787,
				"type": "EVENT"
			},
			{
				"name": "parties",
				"salience": 0.0011161929,
				"type": "PERSON"
			},
			{
				"name": "clip",
				"salience": 0.0011151063,
				"type": "WORK_OF_ART"
			},
			{
				"name": "street violence",
				"salience": 0.0011025214,
				"type": "OTHER"
			},
			{
				"name": "hate crimes",
				"salience": 0.0011025214,
				"type": "OTHER"
			},
			{
				"name": "behalf",
				"salience": 0.0010645835,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.0010645835,
				"type": "OTHER"
			},
			{
				"name": "rumors",
				"salience": 0.0010645835,
				"type": "OTHER"
			},
			{
				"name": "egos",
				"salience": 0.0010645835,
				"type": "OTHER"
			},
			{
				"name": "apology",
				"salience": 0.0010645835,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.0010645835,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0010645835,
				"type": "OTHER"
			},
			{
				"name": "win",
				"salience": 0.0010645835,
				"type": "EVENT"
			},
			{
				"name": "hate crime",
				"salience": 0.0010613637,
				"type": "OTHER"
			},
			{
				"name": "hate crime",
				"salience": 0.0010613637,
				"type": "OTHER"
			},
			{
				"name": "intersection",
				"salience": 0.0010394251,
				"type": "LOCATION"
			},
			{
				"name": "gatekeepers",
				"salience": 0.0010334051,
				"type": "PERSON"
			},
			{
				"name": "gatekeeping media",
				"salience": 0.0010309996,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05256f_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President-elect_of_the_United_States"
				},
				"name": "Elect",
				"salience": 0.0010178714,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0010171777,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0009968485,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.0009968485,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.0009968485,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latinos",
				"salience": 0.0009964637,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.00095468,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.0009506837,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.0009468788,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0009301192,
				"type": "WORK_OF_ART"
			},
			{
				"name": "damage",
				"salience": 0.0009301192,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.00092596415,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00092596415,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0009190394,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0009190394,
				"type": "EVENT"
			},
			{
				"name": "minorities",
				"salience": 0.0009190394,
				"type": "PERSON"
			},
			{
				"name": "specifics",
				"salience": 0.0009142948,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.000913086,
				"type": "EVENT"
			},
			{
				"name": "supporters",
				"salience": 0.0009083481,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.00090682344,
				"type": "WORK_OF_ART"
			},
			{
				"name": "violence",
				"salience": 0.0009000418,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0008913952,
				"type": "OTHER"
			},
			{
				"name": "Presidency",
				"salience": 0.0008781125,
				"type": "PERSON"
			},
			{
				"name": "wallet",
				"salience": 0.0008729688,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0008664403,
				"type": "OTHER"
			},
			{
				"name": "wallet",
				"salience": 0.0008619671,
				"type": "OTHER"
			},
			{
				"name": "males",
				"salience": 0.0008619671,
				"type": "PERSON"
			},
			{
				"name": "car",
				"salience": 0.0008619671,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "network",
				"salience": 0.0008619671,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02frhbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland,_Oregon"
				},
				"name": "Portland",
				"salience": 0.00085578836,
				"type": "LOCATION"
			},
			{
				"name": "Kai Ryssdal",
				"salience": 0.00084912847,
				"type": "PERSON"
			},
			{
				"name": "gang",
				"salience": 0.0008436147,
				"type": "PERSON"
			},
			{
				"name": "clip",
				"salience": 0.0008436147,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03jt40",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democrat_Party_(Thailand)"
				},
				"name": "Democrat Party",
				"salience": 0.00084153883,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections",
				"salience": 0.00083379465,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.00082978664,
				"type": "OTHER"
			},
			{
				"name": "hijab",
				"salience": 0.00082978664,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00082978664,
				"type": "PERSON"
			},
			{
				"name": "hijab",
				"salience": 0.00082978664,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00082978664,
				"type": "EVENT"
			},
			{
				"name": "media outlets",
				"salience": 0.00082978664,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00082978664,
				"type": "PERSON"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.00082786055,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.00081376993,
				"type": "EVENT"
			},
			{
				"name": "news",
				"salience": 0.0008060456,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00079936563,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.0007793437,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0007764436,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.00075155235,
				"type": "PERSON"
			},
			{
				"name": "anarchy",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "high school kids",
				"salience": 0.00074637355,
				"type": "PERSON"
			},
			{
				"name": "silence",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "community organizer",
				"salience": 0.00074637355,
				"type": "PERSON"
			},
			{
				"name": "journalists",
				"salience": 0.00074637355,
				"type": "PERSON"
			},
			{
				"name": "examples",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "hordes",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "donor",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "NOTE",
				"salience": 0.00074637355,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.000744636,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0007407915,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.00072896626,
				"type": "PERSON"
			},
			{
				"name": "clip",
				"salience": 0.00072451186,
				"type": "WORK_OF_ART"
			},
			{
				"name": "problem",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "immaturity",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.00071850745,
				"type": "WORK_OF_ART"
			},
			{
				"name": "adults",
				"salience": 0.00071850745,
				"type": "PERSON"
			},
			{
				"name": "scarf",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "media cohorts",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00071850745,
				"type": "PERSON"
			},
			{
				"name": "removal",
				"salience": 0.00071850745,
				"type": "EVENT"
			},
			{
				"name": "much",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "hype",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "obscenities",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00071850745,
				"type": "OTHER"
			},
			{
				"name": "male",
				"salience": 0.0007036539,
				"type": "PERSON"
			},
			{
				"name": "car",
				"salience": 0.0007036539,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hundreds",
				"salience": 0.0007036539,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0007036539,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.0006723162,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00064099603,
				"type": "OTHER"
			},
			{
				"name": "@michellemalkin",
				"salience": 0.000636016,
				"type": "PERSON"
			},
			{
				"name": "@Mommysaurus75",
				"salience": 0.000636016,
				"type": "OTHER"
			},
			{
				"name": "establishment gatekeeper",
				"salience": 0.00063016266,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00062494,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-Americans",
				"salience": 0.0006135138,
				"type": "PERSON"
			},
			{
				"name": "Chief",
				"salience": 0.00060928595,
				"type": "PERSON"
			},
			{
				"name": "vehicle",
				"salience": 0.00060928595,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "insurance information",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00060928595,
				"type": "PERSON"
			},
			{
				"name": "middle",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "daylight",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "wounds",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "hospital",
				"salience": 0.00060928595,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "Agitator",
				"salience": 0.00060928595,
				"type": "PERSON"
			},
			{
				"name": "fascism",
				"salience": 0.00060928595,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.00060928595,
				"type": "PERSON"
			},
			{
				"name": "Woodside High School",
				"salience": 0.0005875575,
				"type": "ORGANIZATION"
			},
			{
				"name": "credibility",
				"salience": 0.00058215,
				"type": "OTHER"
			},
			{
				"name": "media establishment",
				"salience": 0.00058215,
				"type": "OTHER"
			},
			{
				"name": "protester",
				"salience": 0.00057051337,
				"type": "PERSON"
			},
			{
				"name": "Lafayette Police",
				"salience": 0.00056561956,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.00056545535,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.00054228934,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president",
				"salience": 0.00054228934,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.00054228934,
				"type": "PERSON"
			},
			{
				"name": "Protests",
				"salience": 0.00052870525,
				"type": "EVENT"
			},
			{
				"name": "hope",
				"salience": 0.00052560784,
				"type": "OTHER"
			},
			{
				"name": "comparison",
				"salience": 0.00052560784,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.00052560784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ly1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Louisiana"
				},
				"name": "Louisiana",
				"salience": 0.00051068264,
				"type": "LOCATION"
			},
			{
				"name": "Mama Angel",
				"salience": 0.00045934145,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0257nv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MoveOn.org"
				},
				"name": "MoveOn.org",
				"salience": 0.00045934145,
				"type": "ORGANIZATION"
			},
			{
				"name": "camera",
				"salience": 0.0004589175,
				"type": "OTHER"
			},
			{
				"name": "camera",
				"salience": 0.0004589175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08k9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/60_Minutes"
				},
				"name": "60 Minutes",
				"salience": 0.000458272,
				"type": "OTHER"
			},
			{
				"name": "facade",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "feeling",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "superiority",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0004551138,
				"type": "LOCATION"
			},
			{
				"name": "None",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "COSMETIC",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "scandal",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "manipulator",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.0004551138,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00045357473,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/076vlrm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BuzzFeed"
				},
				"name": "Buzzfeed",
				"salience": 0.00044218998,
				"type": "ORGANIZATION"
			},
			{
				"name": "Religion of Peace",
				"salience": 0.00044218998,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fb7fv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Advertiser_(Lafayette)"
				},
				"name": "The Advertiser",
				"salience": 0.00044218998,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02zccd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Louisiana_at_Lafayette"
				},
				"name": "University of Louisiana at Lafayette",
				"salience": 0.00044218998,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00043950626,
				"type": "PERSON"
			},
			{
				"name": "reasoning",
				"salience": 0.0004381202,
				"type": "OTHER"
			},
			{
				"name": "election victory",
				"salience": 0.00042395008,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.00042395008,
				"type": "EVENT"
			},
			{
				"name": "interest",
				"salience": 0.00042237222,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ttk_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hill_(newspaper)"
				},
				"name": "The Hill",
				"salience": 0.0004137598,
				"type": "ORGANIZATION"
			},
			{
				"name": "Joe Concha The Hill",
				"salience": 0.0004137598,
				"type": "ORGANIZATION"
			},
			{
				"name": "media gatekeeper-cum-commentators",
				"salience": 0.00040811993,
				"type": "PERSON"
			},
			{
				"name": "Hundreds",
				"salience": 0.0004026941,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.00037496604,
				"type": "LOCATION"
			},
			{
				"name": "irrelevance",
				"salience": 0.00034868295,
				"type": "OTHER"
			},
			{
				"name": "spokesperson",
				"salience": 0.0003314318,
				"type": "PERSON"
			},
			{
				"name": "cities",
				"salience": 0.0003314318,
				"type": "LOCATION"
			},
			{
				"name": "advance",
				"salience": 0.0003314318,
				"type": "OTHER"
			},
			{
				"name": "arrests",
				"salience": 0.0003314318,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0003314318,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0003314318,
				"type": "OTHER"
			},
			{
				"name": "traffic",
				"salience": 0.0003314318,
				"type": "OTHER"
			},
			{
				"name": "Marketplace",
				"salience": 0.0003314318,
				"type": "OTHER"
			},
			{
				"name": "roads",
				"salience": 0.0003314318,
				"type": "LOCATION"
			},
			{
				"name": "SUBSCRIBE",
				"salience": 0.0003314318,
				"type": "OTHER"
			},
			{
				"name": "wake",
				"salience": 0.0003314318,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00031666923,
				"type": "PERSON"
			},
			{
				"name": "news program",
				"salience": 0.00031666923,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00031666923,
				"type": "OTHER"
			},
			{
				"name": "mainstream",
				"salience": 0.00031666923,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.00031666923,
				"type": "OTHER"
			},
			{
				"name": "progressives",
				"salience": 0.00031666923,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "media watchdog person",
				"salience": 0.0003071419,
				"type": "PERSON"
			},
			{
				"name": "hope",
				"salience": 0.00030463145,
				"type": "OTHER"
			},
			{
				"name": "quotes",
				"salience": 0.00029346114,
				"type": "OTHER"
			},
			{
				"name": "quote",
				"salience": 0.00029346114,
				"type": "OTHER"
			},
			{
				"name": "quote",
				"salience": 0.00029346114,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Affordable Care Act",
				"salience": 0.00029157096,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.0002859095,
				"type": "ORGANIZATION"
			},
			{
				"name": "@brianstelter",
				"salience": 0.0002824203,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0002637716,
				"type": "PERSON"
			},
			{
				"name": "street thugs",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "offenders",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "segments",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "cast",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "ratings",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "photo",
				"salience": 0.0002475606,
				"type": "WORK_OF_ART"
			},
			{
				"name": "show",
				"salience": 0.0002475606,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Sources",
				"salience": 0.0002475606,
				"type": "PERSON"
			},
			{
				"name": "senior media analyst",
				"salience": 0.0002475606,
				"type": "PERSON"
			},
			{
				"name": "run",
				"salience": 0.0002475606,
				"type": "EVENT"
			},
			{
				"name": "leverage",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "angst",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "unrest",
				"salience": 0.0002475606,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.00021260286,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0002072766,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00020466371,
				"type": "OTHER"
			},
			{
				"name": "Impeach Trump",
				"salience": 0.00020396114,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s52",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Time_(magazine)"
				},
				"name": "Time Magazine",
				"salience": 0.00017594584,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z14n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anderson_Cooper"
				},
				"name": "Anderson Cooper",
				"salience": 0.00015234544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02jqxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/People_(magazine)"
				},
				"name": "People Magazine",
				"salience": 0.00014181339,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i0.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/2-Trump-Stahl-60-Minutes-copy.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-17T00:41:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 35,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "November 15, 2016 By 21wire Leave a Comment \nJ.R. Smith 21st Century Wire \nThe election campaign might be over, but the mainstream media’s campaign against President Elect Donald Trump is in full swing. \nBetween all of the fake polling, intentionally pro-Clinton partisan coverage, and mainstream media collusion with the Democratic National Party and the Clinton Campaign exposed through WikiLeaks’ Podesta email dump – nearly the entire US mainstream media is now in full damage-limitation mode desperately trying to preserve any crumb of credibility and perceived authority they might have left. \nIt’s now become clear that the media is guilty on multiple fronts, as more proof has emerged of how they are helping to stoke violence, while promoting unfounded fears – and all the while pushing fictional ‘hate crime’ hoaxes. \nCBS News flagship investigative program 60 Minutes conducted a recorded interview with Trump on Friday in which he made a direct plea on camera to any possible supporters to “Stop it,” in reference to anyone that may have written racist slogans or abusive language in public, or at schools. In light of the numerous pockets of protests and outbreaks of partisan violence which have racked America since the election results were announced last week, it would have been in the public interest to release this powerful appeal by Trump, but instead mainstream CBS buried it for 3 days until 60 Minutes was scheduled to air later on Sunday evening nationwide. If CBS had any credibility remaining, this certainly will have finished it off. \nWhen told about alleged reports of a ‘Trump supporter’ who were said to have been harassing Latinos and Muslims following his presidential win, Trump told interviewer Leslie Stahl , “I am so saddened to hear that.” He then added, “And I say, ‘Stop it.’ If it helps, I will say this – and I will say right to the cameras: ‘Stop it.'” \nOne big thing in this incident that many mainstream media observers did not pick up is that at no time did Stahl give any specifics on these alleged “abuses” by Trump supporters against Muslims and Latinos, and even though it’s obvious that Trump was not responsible for directing any alleged abuses – Stahl still demanded an apology on their behalf – without offering any evidence to support her claim. This was ‘drive-by’ media at its worst. In fact, not one of these said accusations of abuse have been properly investigated by the media, and some may end up actually being media-generated rumors, or even hoaxes. \nNow, it’s perfectly understandable that Trump’s victory over the establishment’s heavily inflated candidate Hillary Clinton has left many Democrats, especially millennial college-aged students upset, angry and feeling more than a little delicate due to their bruised collective egos (they are not upset that Trump won, as much as they are upset that ‘they’ lost). The real problem exists far beyond the learned immaturity of America’s politically correct-obsessed young adults. The real danger is that Democratic Party gutter operatives and their liberal media cohorts are actually staging, and fabricating “hate crime” incidents in order to propagate the idea that the President Elect and his supporters are somehow “causing many minorities fearful about the future”. In reality, much of this hype is being generated through these same liberal media outlets. \nIn fact, one Muslim female from Louisiana has since been forced to apologize for inventing her alleged ‘hate crime’ incident – one designed to discredit Trump, and to help stoke more nationwide protests. \nBuzzfeed reported, via Religion of Peace : \nA woman who claimed she was attacked and robbed by two men near the University of Louisiana at Lafayette, including one wearing a Donald Trump hat, made up the story, police said in a statement. \nThe woman had alleged the men yelled obscenities at her and took away her wallet and hijab, a scarf sometimes worn by Muslim women, The Advertiser reported. \nLafayette Police officials said in a statement the incident is no longer under investigation, the paper reported. \n“During the course of the investigation, the female complainant admitted that she fabricated the story about her physical attack as well as the removal of her hijab and wallet by two white males,” the statement reportedly read. \nNOTE: This story made national headlines and was not questioned or challenged by the hordes of self-described “journalists” who populate the news and editorial newsrooms of America’s corrupt liberal mainstream media. \nThat’s right – this was just another hoax: \nViolent Democratic-Affiliated Street Gangs \nWhat Leslie Stahl and the rest of the gatekeepers at CBS and 60 Minutes have obscured is the fact since Tuesday’s election, nearly all of the so-called ‘violent hate crimes’ have been carried out against Trump supporters – by street gangs who are most clearly Democrat Party supporters. \nHere are just a few examples: @michellemalkin Even high school kids are not spared. Student Trump supporter attacked at Woodside High School https://t.co/e7tVvDJ6O8 \n— Mama Angel (@Mommysaurus75) November 11, 2016 \nWatch this clip taken from the radical leftist Portland protests this weekend, where Democratic Party supports attack a single woman in her car because they believed that she was a ‘Trump supporter.’ These violent incidents reveal the flavor of anarchy which the Democratic Party and the sitting President of the United States, Barack Obama – are condoning through their deaf silence over the multiple reports of street violence unleashed with the help of the Democratic Party’s online ‘community organizer’ network MoveOn.org – a digital platform partly funded by leading Clinton donor and billionaire George Soros . Watch this stunning clip: \n. Here is a video of clip of a white male in Chicago, 49 yr old David Wilcox, who was driving and scraped another vehicle. When the two parties stopped at the intersection to exchange insurance information, Wilcox was greeted by a gang of African-Americans, presumably Democratic Party supporters, who began pointing and shouting, “You voted for Donald Trump!” before beating and robbing the man in the middle of the street. Wilcox was then dragged hundreds of yards as he tried to keep the gang from stealing his car in broad daylight. He was treated for multiple wounds at a local hospital. \nFrom reports we learned that at no time before the attack took place did Wilcox display any support for Donald Trump. It appears as if they attacked him because he was white. So could one call this a case of black on white racism? Regardless, it’s political intimidation done on the street – which could also be defined as pure political fascism. In this instance, the violence was partisan, and carried out by what could be classed as unofficial Democrat foot soldiers – enforcing a type of radical political regime on the streets of America. Watch this disturbing video: . Agitator and Chief: Where is Obama? \nThese incidents have been mostly blacked out by a national US media who are obviously still working to discredit the Trump Presidency. \nAmidst all this violence, however, where is the current President Obama, or the Democratic Party’s losing candidate Hillary Clinton – to help calm street thugs and violent ‘progressives’? It’s almost as if Obama and Clinton are enjoying the unrest. Most certainly though, Obama, Clinton and the Democratic Party are hoping to use this week’s media-generated liberal angst as future political leverage. \nWhat used to be regarded as a reputable investigative news program, 60 minutes, has gradually become a joke. It seems disinterested in covering anything of genuine interest, opting instead for running bland People Magazine and Time Magazine-style ‘safe’ segments. Judging by its plummeting ratings, and its predictable cast of ‘job for life’ government-approved media gatekeeper-cum-commentators like Anderson Cooper and Lesley Stahl, there is little hope for this institution. You might even say it’s irredeemable . \nOne of the corporate mainstream’s worst offenders during the election was CNN host Brian Stelter (photo, left), whose own show is ironically titled “Reliable Sources.” Stelter is meant to be CNN’s media watchdog person, laughably given the lofty title as “senior media analyst.” After leading CNN’s own exposed efforts to obscure and derail Trump’s Presidential run, while working to cover for a hugely unpopular (even among Democrats) Hillary Clinton candidacy, Stelter has now taken it upon himself to revamp his network’s horrible reputation as an establishment gatekeeper and manipulator of US elections. But it’s too late. The damage has already been done, and CNN will not regain the hanging facade of credibility it once struggled to retain. They are a dirty media outlet, and now everyone knows it. \nNow CBS News has been exposed in public view, but their crime is even worse than CNN’s which was just dirty politics in comparison. CBS News took it upon itself to compromise public safety, and put lives at risk – all for its own selfish institutional political position. Twenty years ago, this might have been considered shameful, but in today’s toxic liberal media establishment ruled by an unhealthy feeling of superiority over the unwashed masses – they are all way past shameless at this stage. \nNone of them can be trusted anymore – only tolerated, in the hope that they might actually report some useful news in the coming years. \nMore on the CBS 60 Minutes scandal from The Hill… \nCOSMETIC: CBS’s Stahl represents the shallow, bland irrelevance of the mainstream gatekeeping media. \nJoe Concha The Hill \nCBS News is under fire for holding a videotaped clip from a Friday interview with President-elect Donald Trump urging supporters not to attack minorities until a “60 Minutes” broadcast on Sunday night. \n“I am very surprised to hear that. I hate to hear it,” Trump told interviewer Lesley Stahl when told of some attacks on minorities that have reportedly occurred since his election victory Tuesday. \n“I am so sorry to hear it, and I say stop it,” Trump said before looking directly into the camera. “And I say right to the camera, stop it.” \n“60 Minutes” did release quotes from the Friday interview in advance, but only a statement by Trump on the Affordable Care Act. \n“We chose to release a quote on the issue that affects the most Americans & that was his statement on Obamacare,” a spokesperson for CBS told CNN Monday. \nKai Ryssdal, host of “Marketplace,” called that reasoning “completely underwhelming.” CBS's underwhelming answer: \"We chose to release a quote on the issue that affects the most Americans & that was his statement on Obamacare\" \n— Brian Stelter (@brianstelter) November 14, 2016 \nProtests have grown in the wake of Trump’s victory in major cities across the country. \nNot all protests have been peaceful. A protester was shot in Portland last Thursday and hospitalized. Hundreds of arrests have been made, property has been damaged and traffic has snarled due to roads being blocked by protesters chanting “Impeach Trump” and “Not my president.”… \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files \nSUPPORT 21WIRE – SUBSCRIBE NOW & BECOME A MEMBER @21WIRE.TV",
		"thread_title": "CBS 60 Minutes Withheld Trump’s Appeal to ‘Stop Attacking Minorities,’ and Ignored Reports of Attacks on Trump Supporters",
		"title": "CBS 60 Minutes Withheld Trump’s Appeal to ‘Stop Attacking Minorities,’ and Ignored Reports of Attacks on Trump Supporters",
		"type": "conspiracy",
		"uuid": "eca38219488f8785530cc20ad38c98dac4faa432"
	},
	"-KhIWLGKQka8SqoFZxla": {
		"author": "Mike Rivero",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-23T01:36:58.899+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.54911464,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.075685635,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.07194377,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.038537912,
				"type": "PERSON"
			},
			{
				"name": "Comment",
				"salience": 0.030777687,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.02645641,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.02300633,
				"type": "PERSON"
			},
			{
				"name": "straight",
				"salience": 0.015479229,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05hpy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Association_for_the_Advancement_of_Colored_People"
				},
				"name": "NAACP",
				"salience": 0.013358723,
				"type": "ORGANIZATION"
			},
			{
				"name": "bigot",
				"salience": 0.009596527,
				"type": "OTHER"
			},
			{
				"name": "sight",
				"salience": 0.0072708135,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.007160206,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "Ku Klux Klan",
				"salience": 0.0067772544,
				"type": "ORGANIZATION"
			},
			{
				"name": "reporters",
				"salience": 0.0067704325,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.0065036304,
				"type": "PERSON"
			},
			{
				"name": "William McGurn Wall Street Journal",
				"salience": 0.006071622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fdlv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Murder_of_James_Byrd,_Jr."
				},
				"name": "James Byrd",
				"salience": 0.005808782,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.005040272,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Small wonder",
				"salience": 0.0044415197,
				"type": "OTHER"
			},
			{
				"name": "vice",
				"salience": 0.0034639142,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0033773251,
				"type": "PERSON"
			},
			{
				"name": "ho-hum",
				"salience": 0.0030001982,
				"type": "PERSON"
			},
			{
				"name": "values",
				"salience": 0.0030001982,
				"type": "OTHER"
			},
			{
				"name": "drill",
				"salience": 0.0028883726,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0028883726,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/012gx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Biden"
				},
				"name": "Joe Biden",
				"salience": 0.0028222047,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0026909204,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bymv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_McCain"
				},
				"name": "John McCain",
				"salience": 0.0026536519,
				"type": "PERSON"
			},
			{
				"name": "hater",
				"salience": 0.0025906023,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.002544812,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0023971887,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.0021044435,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0021044435,
				"type": "OTHER"
			},
			{
				"name": "twist",
				"salience": 0.0021044435,
				"type": "OTHER"
			},
			{
				"name": "gays",
				"salience": 0.0020259595,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0020259595,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0020259595,
				"type": "PERSON"
			},
			{
				"name": "hate group",
				"salience": 0.0020259595,
				"type": "ORGANIZATION"
			},
			{
				"name": "chain",
				"salience": 0.0019841224,
				"type": "ORGANIZATION"
			},
			{
				"name": "men",
				"salience": 0.0019841224,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-Americans",
				"salience": 0.0018879771,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_lf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_Stalin"
				},
				"name": "Stalin",
				"salience": 0.0018476541,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.0018476541,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0177g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benito_Mussolini"
				},
				"name": "Mussolini",
				"salience": 0.0018476541,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0017182768,
				"type": "PERSON"
			},
			{
				"name": "footage",
				"salience": 0.0017182768,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pickup truck",
				"salience": 0.0017182768,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hate-crimes legislation",
				"salience": 0.0017182768,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.0017182768,
				"type": "EVENT"
			},
			{
				"name": "break",
				"salience": 0.001612779,
				"type": "EVENT"
			},
			{
				"name": "daughter",
				"salience": 0.0014946876,
				"type": "PERSON"
			},
			{
				"name": "dog whistles",
				"salience": 0.0014946876,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0014824815,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.0012837906,
				"type": "OTHER"
			},
			{
				"name": "bottom",
				"salience": 0.0012837906,
				"type": "OTHER"
			},
			{
				"name": "deck",
				"salience": 0.0012837906,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0012837906,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.0012049474,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.001180051,
				"type": "PERSON"
			},
			{
				"name": "chains",
				"salience": 0.0010798447,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "ObamaCare",
				"salience": 0.0010107468,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00093508343,
				"type": "OTHER"
			},
			{
				"name": "presidents",
				"salience": 0.0008934533,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00080670544,
				"type": "EVENT"
			},
			{
				"name": "audience",
				"salience": 0.0007633843,
				"type": "PERSON"
			},
			{
				"name": "dollar bills",
				"salience": 0.00069854327,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00069854327,
				"type": "PERSON"
			},
			{
				"name": "stories",
				"salience": 0.00065562676,
				"type": "WORK_OF_ART"
			},
			{
				"name": "race card",
				"salience": 0.00032637117,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Clinton-KKK-Democratic-Party.jpg?fit=610%2C415",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-23T00:49:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "November 21, 2016 By 21wire Leave a Comment \nWilliam McGurn Wall Street Journal \nLet’s get this straight. Calling Hillary Clinton a “bigot” has reporters asking every Republican in sight if Donald Trump has gone too far. But the Clinton campaign releases a video saying Mr. Trump is the candidate of the Ku Klux Klan, and it’s all okey-dokey? \nThen again, Mr. Trump has already been likened to Hitler, Mussolini and Stalin. Small wonder there’s a collective ho-hum when Democratic vice presidential nominee Tim Kaine says Mr. Trump is peddling “KKK values.” \nThis is what Democrats do. It didn’t start with Mr. Trump, either. For years Democrats have portrayed the GOP as one giant hate group. \nEach presidential election, the drill goes like this: \nAfter Republicans nominate someone, he immediately finds himself having to prove he’s not a hater – of African-Americans, of women, of gays, etc. \nThis year Democrats added a twist. Mr. Trump, they claim, represents a break with all those decent and lovable Republicans such as Mitt Romney , John McCain and George W. Bush . Of course, this isn’t what they were saying back when these men were running for president. \n• In 2000, for example, an NAACP ad recreated the gruesome murder of James Byrd to imply that then-Gov. Bush was sympathetic to lynching black men. Over footage of a chain being dragged by a pickup truck, Mr. Byrd’s daughter says, “So when Gov. George W. Bush refused to support hate-crimes legislation, it was like my father was killed all over again.” \n• When John McCain ran in 2008, Barack Obama warned that Republicans would scare people by saying, “You know, he doesn’t look like all those other presidents on those dollar bills.” The McCain campaign fired back, accusing Mr. Obama of playing the race card from the “bottom of the deck.” Funny thing: All those reporters always hearing “dog whistles” from Republicans somehow didn’t hear this one. \n• In 2012, when Mitt Romney went to the NAACP and told them face-to-face about his opposition to ObamaCare, the stories were all about how he was really just trolling for the racist vote. Vice President Joe Biden put it more explicitly, telling a largely African-American audience that if Mr. Romney were to win, he’d “put ya’ll back in chains.” \nThe only difference today is that Republicans now have a nominee giving as good as he gets…",
		"thread_title": "FLASHBACK - Hillary Clinton’s ‘KKK’ Smear Against Trump was Democrat Strategy",
		"title": "FLASHBACK - Hillary Clinton’s ‘KKK’ Smear Against Trump was Democrat Strategy",
		"type": "conspiracy",
		"uuid": "a36405a8d7d32c2192b9a9b482dcf0ebc83c62eb"
	},
	"-KhIWLWR5e9ojjTn-I9m": {
		"author": "Mike Rivero",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-24T06:43:29.107+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.119681016,
				"type": "PERSON"
			},
			{
				"name": "Comment",
				"salience": 0.069956295,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.05754806,
				"type": "ORGANIZATION"
			},
			{
				"name": "person",
				"salience": 0.050629027,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.042120367,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.038263302,
				"type": "LOCATION"
			},
			{
				"name": "votes",
				"salience": 0.03483194,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.029098684,
				"type": "OTHER"
			},
			{
				"name": "tampering",
				"salience": 0.025222898,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.024521394,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03q1mw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barbara_Simons"
				},
				"name": "Barbara Simons",
				"salience": 0.023084862,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.021989312,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.020302506,
				"type": "LOCATION"
			},
			{
				"name": "journalists",
				"salience": 0.019230835,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.017866304,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.01684102,
				"type": "ORGANIZATION"
			},
			{
				"name": "President",
				"salience": 0.016511053,
				"type": "PERSON"
			},
			{
				"name": "diligence",
				"salience": 0.012920448,
				"type": "OTHER"
			},
			{
				"name": "Alex Halderman",
				"salience": 0.012900925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.009857352,
				"type": "ORGANIZATION"
			},
			{
				"name": "thing",
				"salience": 0.008456172,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.008456172,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Clinton Campaign",
				"salience": 0.008424803,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.007997524,
				"type": "ORGANIZATION"
			},
			{
				"name": "stories",
				"salience": 0.007404865,
				"type": "WORK_OF_ART"
			},
			{
				"name": "shoe",
				"salience": 0.00686316,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Election",
				"salience": 0.006370216,
				"type": "EVENT"
			},
			{
				"name": "news",
				"salience": 0.0061513064,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.006132726,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.005488574,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.005327388,
				"type": "OTHER"
			},
			{
				"name": "foot",
				"salience": 0.005327388,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.005327388,
				"type": "OTHER"
			},
			{
				"name": "memories",
				"salience": 0.005327388,
				"type": "OTHER"
			},
			{
				"name": "media operatives",
				"salience": 0.005327388,
				"type": "OTHER"
			},
			{
				"name": "Clinton Campaign",
				"salience": 0.0048438953,
				"type": "ORGANIZATION"
			},
			{
				"name": "authorities",
				"salience": 0.0047779474,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.004634368,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0046218066,
				"type": "ORGANIZATION"
			},
			{
				"name": "result",
				"salience": 0.0045997426,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.004504748,
				"type": "EVENT"
			},
			{
				"name": "election vote",
				"salience": 0.0042225723,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060c4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President"
				},
				"name": "Presidency",
				"salience": 0.0041948883,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.0041534174,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qry6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wolf_Blitzer"
				},
				"name": "Wolf Blitzer",
				"salience": 0.0040025227,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.003901132,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.003901132,
				"type": "LOCATION"
			},
			{
				"name": "results",
				"salience": 0.003901132,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.003901132,
				"type": "PERSON"
			},
			{
				"name": "battleground states",
				"salience": 0.003901132,
				"type": "LOCATION"
			},
			{
				"name": "talking points",
				"salience": 0.0038321326,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0038321326,
				"type": "OTHER"
			},
			{
				"name": "academics",
				"salience": 0.0037362205,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.0037362205,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0037362205,
				"type": "OTHER"
			},
			{
				"name": "feature",
				"salience": 0.0035968302,
				"type": "OTHER"
			},
			{
				"name": "run-up",
				"salience": 0.0035968302,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.0035968302,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.0035968302,
				"type": "EVENT"
			},
			{
				"name": "election victory",
				"salience": 0.0035968302,
				"type": "OTHER"
			},
			{
				"name": "lock",
				"salience": 0.0035968302,
				"type": "OTHER"
			},
			{
				"name": "hackers",
				"salience": 0.0035225276,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0035225276,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0035225276,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0035225276,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.003280168,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.003280168,
				"type": "ORGANIZATION"
			},
			{
				"name": "pages",
				"salience": 0.0032500005,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/068jhv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Bonifaz"
				},
				"name": "John Bonifaz",
				"salience": 0.0030959814,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.003050412,
				"type": "WORK_OF_ART"
			},
			{
				"name": "committee chairs",
				"salience": 0.003050412,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003050412,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.002914636,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.002914636,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0028310998,
				"type": "EVENT"
			},
			{
				"name": "NEWS AT",
				"salience": 0.0028270052,
				"type": "OTHER"
			},
			{
				"name": "deadlines",
				"salience": 0.0027913938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cmmlx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guardian_Life_Insurance_Company_of_America"
				},
				"name": "Guardian",
				"salience": 0.002656133,
				"type": "ORGANIZATION"
			},
			{
				"name": "paper ballots",
				"salience": 0.0026317004,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.0026199485,
				"type": "PERSON"
			},
			{
				"name": "assessments",
				"salience": 0.0024742733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.002362483,
				"type": "LOCATION"
			},
			{
				"name": "Move On",
				"salience": 0.0023000631,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Guardian A",
				"salience": 0.0023000631,
				"type": "ORGANIZATION"
			},
			{
				"name": "vote",
				"salience": 0.0022979411,
				"type": "EVENT"
			},
			{
				"name": "blogpost",
				"salience": 0.0022789037,
				"type": "OTHER"
			},
			{
				"name": "contact",
				"salience": 0.0022789037,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.0022789037,
				"type": "OTHER"
			},
			{
				"name": "voting equipment",
				"salience": 0.0022789037,
				"type": "OTHER"
			},
			{
				"name": "push",
				"salience": 0.0022789037,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.0022789037,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.0022789037,
				"type": "EVENT"
			},
			{
				"name": "computer security",
				"salience": 0.0022789037,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0022789037,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0021331152,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wisconsin",
				"salience": 0.0021331152,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0021229247,
				"type": "LOCATION"
			},
			{
				"name": "intelligence authorities",
				"salience": 0.0018465453,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07szy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Michigan"
				},
				"name": "University of Michigan",
				"salience": 0.0017941267,
				"type": "ORGANIZATION"
			},
			{
				"name": "vote",
				"salience": 0.0017166559,
				"type": "OTHER"
			},
			{
				"name": "intrusions",
				"salience": 0.001659798,
				"type": "OTHER"
			},
			{
				"name": "computer systems",
				"salience": 0.001659798,
				"type": "OTHER"
			},
			{
				"name": "theft",
				"salience": 0.001659798,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.001659798,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.001659798,
				"type": "PERSON"
			},
			{
				"name": "Files",
				"salience": 0.001659798,
				"type": "OTHER"
			},
			{
				"name": "recounts",
				"salience": 0.001659798,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.001659798,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.0015858918,
				"type": "OTHER"
			},
			{
				"name": "election assistance commission",
				"salience": 0.0015858918,
				"type": "ORGANIZATION"
			},
			{
				"name": "analysts",
				"salience": 0.001431891,
				"type": "PERSON"
			},
			{
				"name": "analysis",
				"salience": 0.001431891,
				"type": "OTHER"
			},
			{
				"name": "ballot audits",
				"salience": 0.0013549861,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0012398808,
				"type": "ORGANIZATION"
			},
			{
				"name": "involvement",
				"salience": 0.0012398808,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0012398808,
				"type": "OTHER"
			},
			{
				"name": "expert",
				"salience": 0.0012398808,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.0011636972,
				"type": "OTHER"
			},
			{
				"name": "surprise defeat",
				"salience": 0.0011061337,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0010215634,
				"type": "LOCATION"
			},
			{
				"name": "hackers",
				"salience": 0.0009787455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025w87t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Voting_Rights_Institute"
				},
				"name": "National Voting Rights Institute",
				"salience": 0.0007630805,
				"type": "ORGANIZATION"
			},
			{
				"name": "developments",
				"salience": 0.0007371188,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-Hillary-Clinton-e1479932220348.jpg?fit=740%2C411",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-24T03:37:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0",
		"text": "November 23, 2016 By 21wire Leave a Comment \n“The person who received the most votes free from interference or tampering needs to be in the White House. It may well be Donald J. Trump, but further due diligence is required to ensure that American democracy is not threatened.” \n21st Century Wire says… \nAlthough the election was called on Nov 8th, the Democratic Party’s ongoing campaign to delegitimize the new incoming President is still ongoing. \nFor those of us with long enough memories, the Democratic Party, their media operatives and the Clinton Campaign were claiming that Trump and the GOP would be engaged in this very same behavior after Hillary Clinton won the Presidency (as expected). \nNotice how the shoe is now on the other foot. \nIt’s interesting reading past stories by ‘news’ sources linked to the Clinton Campaign and John Podesta as Politico has, who ran a feature on Aug 16th entitled, “Why the GOP Will Never Accept President Hillary Clinton” which lays out the case of Hillary’s lock on the White House and how the evil Republicans will not accept her eventual election victory. \n“Will Donald Trump respect the peaceful transition of power?” howled CNN’s Wolf Blitzer in the run-up to the election. The question now is: will the Democrats respect the result, and simply “Move On,” as they say? \nOf course, we now know that ‘journalists’ like Wolf at CNN were getting their talking points directly the Clinton Campaign . \nAs it turns out, the only thing illegitimate about the 2016 Election… was the mainstream corporate media. \nMore form the Guardian… \nThe Guardian \nA growing number of academics and activists are calling for US authorities to fully audit or recount the 2016 presidential election vote in key battleground states, in case the results could have been skewed by foreign hackers. \nThe loose coalition, which is urging Hillary Clinton’s campaign to join its fight, is preparing to deliver a report detailing its concerns to congressional committee chairs and federal authorities early next week, according to two people involved. \nThe document, which is currently 18 pages long, focuses on concerns about the results in the states of Michigan, Pennsylvania and Wisconsin. \n“I’m interested in verifying the vote,” said Dr Barbara Simons, an adviser to the US election assistance commission and expert on electronic voting. “We need to have post-election ballot audits.” Simons is understood to have contributed analysis to the effort but declined to characterise the precise nature of her involvement. \nA second group of analysts, led by the National Voting Rights Institute founder John Bonifaz and Professor Alex Halderman, the director of the University of Michigan’s center for computer security and society, is also taking part in the push for a review, and has been in contact with Simons. \nIn a blogpost early on Wednesday, Halderman said paper ballots and voting equipment should be examined in Wisconsin, Michigan, and Pennsylvania, warning that deadlines were rapidly approaching. \n“Unfortunately, nobody is ever going to examine that evidence unless candidates in those states act now, in the next several days, to petition for recounts,” he said. \nThe developments follow Clinton’s surprise defeat to Donald Trump in the 8 November vote, and come after US intelligence authorities released public assessments that Russian hackers were behind intrusions into regional electoral computer systems and the theft of emails from Democratic officials before the election… \nREAD MORE ELECTION NEWS AT: 21st Century Wire 2016 Files",
		"thread_title": "Hillary Clinton Supporters Now Calling for a Recount of Votes in Battleground States",
		"title": "Hillary Clinton Supporters Now Calling for a Recount of Votes in Battleground States",
		"type": "conspiracy",
		"uuid": "561b309ed5c260bb67b4a63756e20f056b7983a0"
	},
	"-KhIWMOubfrQbIFJW7aW": {
		"author": "Branko Mali",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-25T14:33:14.332+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.37040904,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cmd7rf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_B._Spencer"
				},
				"name": "Richard Spencer",
				"salience": 0.033246126,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.024340974,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01h83w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chaos_magic"
				},
				"name": "Chaos",
				"salience": 0.01774342,
				"type": "OTHER"
			},
			{
				"name": "Kek",
				"salience": 0.016914165,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03qykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleksandr_Dugin"
				},
				"name": "Alexander Dugin",
				"salience": 0.013889461,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.011328259,
				"type": "OTHER"
			},
			{
				"name": "contender",
				"salience": 0.009282914,
				"type": "PERSON"
			},
			{
				"name": "Meme",
				"salience": 0.008734851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/050z_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pep%C3%A9_Le_Pew"
				},
				"name": "Pepe",
				"salience": 0.0053831437,
				"type": "PERSON"
			},
			{
				"name": "eye",
				"salience": 0.004808959,
				"type": "OTHER"
			},
			{
				"name": "adherents",
				"salience": 0.004773458,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0046921973,
				"type": "PERSON"
			},
			{
				"name": "analogy",
				"salience": 0.0046677655,
				"type": "OTHER"
			},
			{
				"name": "weirdness",
				"salience": 0.00457645,
				"type": "OTHER"
			},
			{
				"name": "Kek",
				"salience": 0.004516004,
				"type": "OTHER"
			},
			{
				"name": "opposite",
				"salience": 0.0043672207,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.0040876484,
				"type": "OTHER"
			},
			{
				"name": "speech point",
				"salience": 0.0037765945,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0034101994,
				"type": "OTHER"
			},
			{
				"name": "chaos magick",
				"salience": 0.0033665134,
				"type": "OTHER"
			},
			{
				"name": "chaos magick",
				"salience": 0.0033049993,
				"type": "OTHER"
			},
			{
				"name": "envy",
				"salience": 0.0032472007,
				"type": "OTHER"
			},
			{
				"name": "intent",
				"salience": 0.0032240078,
				"type": "OTHER"
			},
			{
				"name": "peculiarity",
				"salience": 0.0029899916,
				"type": "OTHER"
			},
			{
				"name": "salute",
				"salience": 0.0029532714,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0029532714,
				"type": "OTHER"
			},
			{
				"name": "dust",
				"salience": 0.0029532714,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00293129,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00293129,
				"type": "LOCATION"
			},
			{
				"name": "conservative",
				"salience": 0.002909369,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0028492068,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0028076489,
				"type": "LOCATION"
			},
			{
				"name": "reality",
				"salience": 0.0027625798,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0027397221,
				"type": "WORK_OF_ART"
			},
			{
				"name": "movement",
				"salience": 0.0026707072,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0026707072,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0026505038,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0025726946,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0024673736,
				"type": "OTHER"
			},
			{
				"name": "alternative right",
				"salience": 0.0024673736,
				"type": "OTHER"
			},
			{
				"name": "God Emperor",
				"salience": 0.0024622637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07djv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tradition"
				},
				"name": "Tradition",
				"salience": 0.0024466938,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.002418676,
				"type": "EVENT"
			},
			{
				"name": "beings",
				"salience": 0.0023760463,
				"type": "PERSON"
			},
			{
				"name": "will",
				"salience": 0.0023531711,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0023531711,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dialectics",
				"salience": 0.0022446637,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0022415502,
				"type": "OTHER"
			},
			{
				"name": "deity",
				"salience": 0.0022278859,
				"type": "PERSON"
			},
			{
				"name": "recipients",
				"salience": 0.0022034913,
				"type": "PERSON"
			},
			{
				"name": "accordance",
				"salience": 0.0021946188,
				"type": "OTHER"
			},
			{
				"name": "in-joke",
				"salience": 0.0021134063,
				"type": "OTHER"
			},
			{
				"name": "NPI",
				"salience": 0.0020995825,
				"type": "ORGANIZATION"
			},
			{
				"name": "leader",
				"salience": 0.0020882797,
				"type": "PERSON"
			},
			{
				"name": "leadership",
				"salience": 0.0020882797,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0020858664,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06g4_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_Dawkins"
				},
				"name": "Richard Dawkins",
				"salience": 0.0020505143,
				"type": "PERSON"
			},
			{
				"name": "faithful",
				"salience": 0.0020422526,
				"type": "PERSON"
			},
			{
				"name": "adolescent commissars",
				"salience": 0.0019937002,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.0019437864,
				"type": "ORGANIZATION"
			},
			{
				"name": "installment",
				"salience": 0.0019437864,
				"type": "OTHER"
			},
			{
				"name": "joy",
				"salience": 0.0019292559,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0019292559,
				"type": "OTHER"
			},
			{
				"name": "relief",
				"salience": 0.0019292559,
				"type": "OTHER"
			},
			{
				"name": "relief",
				"salience": 0.0019292559,
				"type": "OTHER"
			},
			{
				"name": "correctness",
				"salience": 0.0019292559,
				"type": "OTHER"
			},
			{
				"name": "joy",
				"salience": 0.0019292559,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0019292559,
				"type": "WORK_OF_ART"
			},
			{
				"name": "age",
				"salience": 0.0019292559,
				"type": "OTHER"
			},
			{
				"name": "sigh",
				"salience": 0.0019192998,
				"type": "EVENT"
			},
			{
				"name": "paper tiger",
				"salience": 0.0018712474,
				"type": "OTHER"
			},
			{
				"name": "Branko Malić",
				"salience": 0.0018670656,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptian",
				"salience": 0.0018196527,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "R",
				"salience": 0.0018181385,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0017702134,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0017419634,
				"type": "EVENT"
			},
			{
				"name": "sake",
				"salience": 0.0017419634,
				"type": "OTHER"
			},
			{
				"name": "brand",
				"salience": 0.0017419634,
				"type": "ORGANIZATION"
			},
			{
				"name": "sun",
				"salience": 0.0017419634,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.0017419634,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0017419634,
				"type": "OTHER"
			},
			{
				"name": "occultists",
				"salience": 0.0017419634,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.0017419634,
				"type": "OTHER"
			},
			{
				"name": "directions",
				"salience": 0.0017419634,
				"type": "OTHER"
			},
			{
				"name": "construct",
				"salience": 0.0017177443,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.001569182,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0015451254,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.0015435698,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "v",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "PC gaming",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "nominalism",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "tabletop",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0015084293,
				"type": "PERSON"
			},
			{
				"name": "transcript",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "xenophobia",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "SJW",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "homophobia",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "tears",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "shitlib",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "übermenschen",
				"salience": 0.0015084293,
				"type": "ORGANIZATION"
			},
			{
				"name": "references",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "overabundance",
				"salience": 0.0015084293,
				"type": "EVENT"
			},
			{
				"name": "manifestation",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "vengeance",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "metaphor",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "gleam",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "spotlight",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "minions",
				"salience": 0.0015084293,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0013809464,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0013809464,
				"type": "OTHER"
			},
			{
				"name": "practitioner",
				"salience": 0.0013329885,
				"type": "PERSON"
			},
			{
				"name": "identities",
				"salience": 0.0013329885,
				"type": "OTHER"
			},
			{
				"name": "meme magic",
				"salience": 0.0012498373,
				"type": "OTHER"
			},
			{
				"name": "eristic",
				"salience": 0.0012473133,
				"type": "OTHER"
			},
			{
				"name": "memes",
				"salience": 0.001239047,
				"type": "OTHER"
			},
			{
				"name": "memes",
				"salience": 0.001239047,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meme magic",
				"salience": 0.0012340884,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0012185379,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0012185379,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.001137364,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.001137364,
				"type": "OTHER"
			},
			{
				"name": "deity",
				"salience": 0.001130401,
				"type": "PERSON"
			},
			{
				"name": "association",
				"salience": 0.0011195425,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0010995166,
				"type": "OTHER"
			},
			{
				"name": "alt right movement",
				"salience": 0.0010995166,
				"type": "OTHER"
			},
			{
				"name": "Internet movement",
				"salience": 0.0010995166,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0010995166,
				"type": "OTHER"
			},
			{
				"name": "Matt Furie",
				"salience": 0.001087115,
				"type": "PERSON"
			},
			{
				"name": "chaos principle",
				"salience": 0.0010591416,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0010591416,
				"type": "OTHER"
			},
			{
				"name": "Images",
				"salience": 0.0010586474,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.0010519149,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.0010418509,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.0010364725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02wh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Friedrich_Nietzsche"
				},
				"name": "Nietzsche",
				"salience": 0.0010351423,
				"type": "PERSON"
			},
			{
				"name": "discussions",
				"salience": 0.0010297587,
				"type": "EVENT"
			},
			{
				"name": "nothing",
				"salience": 0.0010203158,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.000999766,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00097211095,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00096871844,
				"type": "EVENT"
			},
			{
				"name": "will",
				"salience": 0.00096871844,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00096871844,
				"type": "EVENT"
			},
			{
				"name": "will",
				"salience": 0.00096871844,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0009682125,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0009682125,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0009682125,
				"type": "OTHER"
			},
			{
				"name": "consciousness",
				"salience": 0.00096484134,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qbld",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LOL"
				},
				"name": "LOL",
				"salience": 0.0009576325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.00095695717,
				"type": "OTHER"
			},
			{
				"name": "interpretation",
				"salience": 0.00093071687,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00093071687,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00093071687,
				"type": "OTHER"
			},
			{
				"name": "interpretation",
				"salience": 0.00093071687,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00093071687,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00093071687,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00093071687,
				"type": "OTHER"
			},
			{
				"name": "whateverphobia",
				"salience": 0.0009284425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cg3x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Swastika"
				},
				"name": "Swastika",
				"salience": 0.0009284425,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0009284425,
				"type": "LOCATION"
			},
			{
				"name": "symbol",
				"salience": 0.00092402677,
				"type": "OTHER"
			},
			{
				"name": "control system",
				"salience": 0.0009123819,
				"type": "OTHER"
			},
			{
				"name": "digits",
				"salience": 0.0009074692,
				"type": "OTHER"
			},
			{
				"name": "talent",
				"salience": 0.00090242224,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.0008959709,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00088068383,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00087688817,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00087525486,
				"type": "OTHER"
			},
			{
				"name": "meme",
				"salience": 0.00086870935,
				"type": "OTHER"
			},
			{
				"name": "meme",
				"salience": 0.00086870935,
				"type": "OTHER"
			},
			{
				"name": "Internet memes",
				"salience": 0.00086870935,
				"type": "OTHER"
			},
			{
				"name": "chaos logic",
				"salience": 0.00085961993,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00084614585,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00084614585,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00084614585,
				"type": "LOCATION"
			},
			{
				"name": "expression",
				"salience": 0.00084612076,
				"type": "OTHER"
			},
			{
				"name": "posthumanist",
				"salience": 0.00083627756,
				"type": "PERSON"
			},
			{
				"name": "memes",
				"salience": 0.00083627756,
				"type": "WORK_OF_ART"
			},
			{
				"name": "postmodern",
				"salience": 0.00083627756,
				"type": "OTHER"
			},
			{
				"name": "chaos magick",
				"salience": 0.0008224331,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0008145561,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0008145561,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0008145561,
				"type": "LOCATION"
			},
			{
				"name": "constructs",
				"salience": 0.00080787565,
				"type": "OTHER"
			},
			{
				"name": "meme magick",
				"salience": 0.0008018338,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00080069277,
				"type": "PERSON"
			},
			{
				"name": "deity",
				"salience": 0.0007976941,
				"type": "PERSON"
			},
			{
				"name": "reality",
				"salience": 0.00079740887,
				"type": "OTHER"
			},
			{
				"name": "virtual reality",
				"salience": 0.00079740887,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00079740887,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00079740887,
				"type": "OTHER"
			},
			{
				"name": "viruses",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "viruses",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0007941305,
				"type": "LOCATION"
			},
			{
				"name": "starting point",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "channeling",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "human thoughts",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "theology",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "subsistence",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "self-subsistence",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "viruses",
				"salience": 0.0007941305,
				"type": "OTHER"
			},
			{
				"name": "nothingness",
				"salience": 0.0007917284,
				"type": "OTHER"
			},
			{
				"name": "magic",
				"salience": 0.0007917284,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0007908061,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.00079039304,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.00079039304,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.00079039304,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.00079039304,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.00079039304,
				"type": "OTHER"
			},
			{
				"name": "existent",
				"salience": 0.00078357436,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.0007639481,
				"type": "PERSON"
			},
			{
				"name": "kek",
				"salience": 0.00075978175,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0007476822,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00074256025,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00074256025,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00074256025,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0007422137,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.00071821123,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sun",
				"salience": 0.0007170056,
				"type": "OTHER"
			},
			{
				"name": "hierarchy",
				"salience": 0.0007170056,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0007170056,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0007170056,
				"type": "EVENT"
			},
			{
				"name": "office",
				"salience": 0.0007170056,
				"type": "LOCATION"
			},
			{
				"name": "phrase",
				"salience": 0.0007170056,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.0007170056,
				"type": "OTHER"
			},
			{
				"name": "phrases",
				"salience": 0.0007170056,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0007148367,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.0007148367,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0007148367,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0007148367,
				"type": "OTHER"
			},
			{
				"name": "dreams",
				"salience": 0.00071214064,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.00071214064,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00071214064,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.00071214064,
				"type": "OTHER"
			},
			{
				"name": "meme",
				"salience": 0.00070915936,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.00070915936,
				"type": "WORK_OF_ART"
			},
			{
				"name": "post",
				"salience": 0.00070915936,
				"type": "WORK_OF_ART"
			},
			{
				"name": "life",
				"salience": 0.00069592317,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.00069071836,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0006815365,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0006791578,
				"type": "EVENT"
			},
			{
				"name": "will",
				"salience": 0.0006791578,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0006791578,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0006784917,
				"type": "OTHER"
			},
			{
				"name": "analogy",
				"salience": 0.00066214614,
				"type": "OTHER"
			},
			{
				"name": "plethora",
				"salience": 0.00066016056,
				"type": "OTHER"
			},
			{
				"name": "analogy",
				"salience": 0.00065380073,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.00065380073,
				"type": "OTHER"
			},
			{
				"name": "mass culture",
				"salience": 0.00065380073,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0006429765,
				"type": "OTHER"
			},
			{
				"name": "remark",
				"salience": 0.00063402764,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00062928564,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "Triumph",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "introduction",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "encomium",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "unreality",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "uninitiated",
				"salience": 0.0006208481,
				"type": "PERSON"
			},
			{
				"name": "mysteries",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0006208481,
				"type": "PERSON"
			},
			{
				"name": "circulation",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0006208481,
				"type": "PERSON"
			},
			{
				"name": "ability",
				"salience": 0.0006208481,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.00062063587,
				"type": "OTHER"
			},
			{
				"name": "poster",
				"salience": 0.00062063587,
				"type": "WORK_OF_ART"
			},
			{
				"name": "practitioner",
				"salience": 0.00061896996,
				"type": "PERSON"
			},
			{
				"name": "practice",
				"salience": 0.00061896996,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0006061738,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0006061738,
				"type": "OTHER"
			},
			{
				"name": "frog",
				"salience": 0.0006026624,
				"type": "OTHER"
			},
			{
				"name": "dream logic",
				"salience": 0.0006026624,
				"type": "OTHER"
			},
			{
				"name": "chaos logic",
				"salience": 0.0006026624,
				"type": "OTHER"
			},
			{
				"name": "chaos logic",
				"salience": 0.0006026624,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0005931975,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0005904055,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0005904055,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0005904055,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00058016076,
				"type": "PERSON"
			},
			{
				"name": "interpretation",
				"salience": 0.00056753785,
				"type": "OTHER"
			},
			{
				"name": "reality tunnel",
				"salience": 0.0005609403,
				"type": "LOCATION"
			},
			{
				"name": "hell",
				"salience": 0.0005609403,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0005609403,
				"type": "OTHER"
			},
			{
				"name": "weirdness",
				"salience": 0.00055674487,
				"type": "OTHER"
			},
			{
				"name": "Internet forums",
				"salience": 0.00055674487,
				"type": "OTHER"
			},
			{
				"name": "accomplishment",
				"salience": 0.00055674487,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00055674487,
				"type": "ORGANIZATION"
			},
			{
				"name": "Internet observers",
				"salience": 0.00055674487,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.00055674487,
				"type": "OTHER"
			},
			{
				"name": "pop culture",
				"salience": 0.000554414,
				"type": "OTHER"
			},
			{
				"name": "imageboard culture",
				"salience": 0.000554414,
				"type": "OTHER"
			},
			{
				"name": "Someone",
				"salience": 0.000554414,
				"type": "PERSON"
			},
			{
				"name": "imageboard",
				"salience": 0.000554414,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.000554414,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.00053999614,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.00053999614,
				"type": "OTHER"
			},
			{
				"name": "object",
				"salience": 0.00053999614,
				"type": "OTHER"
			},
			{
				"name": "alt righters",
				"salience": 0.00053873897,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.0005359573,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0005359573,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0005359573,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0005359573,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00053433597,
				"type": "OTHER"
			},
			{
				"name": "posthumanism",
				"salience": 0.00052972155,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.0005248769,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.0005248769,
				"type": "OTHER"
			},
			{
				"name": "deity",
				"salience": 0.0005248769,
				"type": "PERSON"
			},
			{
				"name": "deity",
				"salience": 0.0005248769,
				"type": "PERSON"
			},
			{
				"name": "identification",
				"salience": 0.0005248769,
				"type": "OTHER"
			},
			{
				"name": "couple digits",
				"salience": 0.0005248769,
				"type": "OTHER"
			},
			{
				"name": "remark",
				"salience": 0.00052417826,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00051596103,
				"type": "LOCATION"
			},
			{
				"name": "plethora",
				"salience": 0.00050267,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00050267,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00050267,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00050267,
				"type": "LOCATION"
			},
			{
				"name": "sense",
				"salience": 0.00050267,
				"type": "OTHER"
			},
			{
				"name": "laughter",
				"salience": 0.00050267,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00050267,
				"type": "OTHER"
			},
			{
				"name": "magic",
				"salience": 0.00050149974,
				"type": "OTHER"
			},
			{
				"name": "nothingness",
				"salience": 0.00050149974,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.0005004241,
				"type": "OTHER"
			},
			{
				"name": "in-joke",
				"salience": 0.00049196614,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00049196614,
				"type": "PERSON"
			},
			{
				"name": "Chaos Magick",
				"salience": 0.000487259,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.00048520352,
				"type": "OTHER"
			},
			{
				"name": "assumption",
				"salience": 0.0004839011,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.0004839011,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0004839011,
				"type": "OTHER"
			},
			{
				"name": "assumption",
				"salience": 0.0004839011,
				"type": "OTHER"
			},
			{
				"name": "evolution",
				"salience": 0.0004839011,
				"type": "OTHER"
			},
			{
				"name": "medium",
				"salience": 0.0004839011,
				"type": "OTHER"
			},
			{
				"name": "evolution",
				"salience": 0.0004839011,
				"type": "OTHER"
			},
			{
				"name": "meaning",
				"salience": 0.0004839011,
				"type": "OTHER"
			},
			{
				"name": "alt right movement",
				"salience": 0.0004700545,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0004579062,
				"type": "OTHER"
			},
			{
				"name": "Kek/Pepe/Trump",
				"salience": 0.000457635,
				"type": "OTHER"
			},
			{
				"name": "synchronicities",
				"salience": 0.0004544812,
				"type": "OTHER"
			},
			{
				"name": "synchronicities",
				"salience": 0.0004544812,
				"type": "OTHER"
			},
			{
				"name": "lineage",
				"salience": 0.0004544812,
				"type": "OTHER"
			},
			{
				"name": "darkness",
				"salience": 0.0004544812,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.0004544812,
				"type": "PERSON"
			},
			{
				"name": "breeding ground",
				"salience": 0.0004544812,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0004544812,
				"type": "EVENT"
			},
			{
				"name": "forums",
				"salience": 0.0004544812,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theorists",
				"salience": 0.0004544812,
				"type": "PERSON"
			},
			{
				"name": "principles",
				"salience": 0.00045278974,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00045278974,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00045278974,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00045278974,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00045278974,
				"type": "OTHER"
			},
			{
				"name": "theology",
				"salience": 0.00044875266,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00043751128,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0004372056,
				"type": "OTHER"
			},
			{
				"name": "motives",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "depths",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "inspection",
				"salience": 0.00043525218,
				"type": "EVENT"
			},
			{
				"name": "extreme",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "computer nodes",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00043525218,
				"type": "EVENT"
			},
			{
				"name": "embodiment",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "creation",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "reader",
				"salience": 0.00043525218,
				"type": "PERSON"
			},
			{
				"name": "judgment",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.00043525218,
				"type": "PERSON"
			},
			{
				"name": "takedown",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "avatar",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.00043525218,
				"type": "OTHER"
			},
			{
				"name": "traditionalists",
				"salience": 0.0004342388,
				"type": "PERSON"
			},
			{
				"name": "traditionalism",
				"salience": 0.0004342388,
				"type": "OTHER"
			},
			{
				"name": "traditionalism",
				"salience": 0.0004342388,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00043055008,
				"type": "PERSON"
			},
			{
				"name": "alt",
				"salience": 0.0004299632,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0004299632,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021dvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_of_Warcraft"
				},
				"name": "World of Warcraft",
				"salience": 0.0004250999,
				"type": "WORK_OF_ART"
			},
			{
				"name": "implications",
				"salience": 0.00041900013,
				"type": "OTHER"
			},
			{
				"name": "vein",
				"salience": 0.00041900013,
				"type": "OTHER"
			},
			{
				"name": "sustenance",
				"salience": 0.00041900013,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.00041900013,
				"type": "OTHER"
			},
			{
				"name": "domain",
				"salience": 0.00041900013,
				"type": "OTHER"
			},
			{
				"name": "imitation",
				"salience": 0.00041900013,
				"type": "OTHER"
			},
			{
				"name": "cry",
				"salience": 0.00041900013,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00041412492,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.00041412492,
				"type": "OTHER"
			},
			{
				"name": "aficionados",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "dubs",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "cartoon character",
				"salience": 0.00041033732,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.00041033732,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00039940572,
				"type": "OTHER"
			},
			{
				"name": "adherence",
				"salience": 0.00039206079,
				"type": "OTHER"
			},
			{
				"name": "adherents",
				"salience": 0.00039206079,
				"type": "PERSON"
			},
			{
				"name": "identity",
				"salience": 0.00039206079,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.00039206079,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.00039206079,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.00039030903,
				"type": "OTHER"
			},
			{
				"name": "memes",
				"salience": 0.00038576763,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cyh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Babylon"
				},
				"name": "Babylon",
				"salience": 0.00038208318,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington D.C.",
				"salience": 0.00038208318,
				"type": "LOCATION"
			},
			{
				"name": "NPI Conference",
				"salience": 0.00038208318,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.00038208318,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.00037573487,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00036747666,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00036747666,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.00036632235,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0003652141,
				"type": "OTHER"
			},
			{
				"name": "Kek/Pepe",
				"salience": 0.00035776704,
				"type": "OTHER"
			},
			{
				"name": "cuck",
				"salience": 0.0003553014,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0003553014,
				"type": "EVENT"
			},
			{
				"name": "front",
				"salience": 0.0003553014,
				"type": "OTHER"
			},
			{
				"name": "traffic",
				"salience": 0.0003553014,
				"type": "OTHER"
			},
			{
				"name": "run-down",
				"salience": 0.0003553014,
				"type": "EVENT"
			},
			{
				"name": "amount",
				"salience": 0.0003553014,
				"type": "OTHER"
			},
			{
				"name": "stamp",
				"salience": 0.0003553014,
				"type": "OTHER"
			},
			{
				"name": "cameras",
				"salience": 0.0003553014,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "action",
				"salience": 0.0003553014,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0003553014,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0003553014,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0003553014,
				"type": "WORK_OF_ART"
			},
			{
				"name": "venues",
				"salience": 0.0003553014,
				"type": "LOCATION"
			},
			{
				"name": "players",
				"salience": 0.0003553014,
				"type": "PERSON"
			},
			{
				"name": "One",
				"salience": 0.00035409982,
				"type": "OTHER"
			},
			{
				"name": "posthumanist movement",
				"salience": 0.0003423132,
				"type": "OTHER"
			},
			{
				"name": "religions",
				"salience": 0.00033947584,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.00033947584,
				"type": "EVENT"
			},
			{
				"name": "act",
				"salience": 0.00033947584,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.00033947584,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.00033947584,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.00033947584,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.00032973968,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00032973968,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.00032973968,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00032973968,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0003211613,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0003211613,
				"type": "OTHER"
			},
			{
				"name": "allure",
				"salience": 0.00031696752,
				"type": "OTHER"
			},
			{
				"name": "monkey ancestry",
				"salience": 0.0003129721,
				"type": "OTHER"
			},
			{
				"name": "God Emperor of USA",
				"salience": 0.00030934846,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00030650114,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.00030650114,
				"type": "OTHER"
			},
			{
				"name": "hierarchy",
				"salience": 0.00030650114,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00030650114,
				"type": "OTHER"
			},
			{
				"name": "information technology",
				"salience": 0.00030650114,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.00030650114,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00030214406,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00030158117,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00030158117,
				"type": "OTHER"
			},
			{
				"name": "analogies",
				"salience": 0.00030158117,
				"type": "OTHER"
			},
			{
				"name": "bringer",
				"salience": 0.00028637899,
				"type": "OTHER"
			},
			{
				"name": "adherents",
				"salience": 0.0002855126,
				"type": "PERSON"
			},
			{
				"name": "light",
				"salience": 0.0002855126,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00028066224,
				"type": "LOCATION"
			},
			{
				"name": "humor",
				"salience": 0.0002756852,
				"type": "OTHER"
			},
			{
				"name": "denominator",
				"salience": 0.0002756852,
				"type": "OTHER"
			},
			{
				"name": "entry position",
				"salience": 0.00027221005,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.00026785608,
				"type": "ORGANIZATION"
			},
			{
				"name": "remark",
				"salience": 0.00026760885,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "subtlety",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "vanguard",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "leadership advocates",
				"salience": 0.00026539064,
				"type": "PERSON"
			},
			{
				"name": "lunatics",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "wand",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "magus",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "ilk offer",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "myths",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "exotic",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "mentality",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "ether",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "persona",
				"salience": 0.00026539064,
				"type": "PERSON"
			},
			{
				"name": "insight",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "disintegration",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "essence",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "nihilism",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "simulacrum",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "reattachment",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "affiliates",
				"salience": 0.00026539064,
				"type": "ORGANIZATION"
			},
			{
				"name": "lack",
				"salience": 0.00026539064,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0002644931,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0002644931,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/089zd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/1970s"
				},
				"name": "Seventies",
				"salience": 0.00025785388,
				"type": "ORGANIZATION"
			},
			{
				"name": "god",
				"salience": 0.00025568885,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "opposites",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "Darkness",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "correspondent",
				"salience": 0.000247217,
				"type": "PERSON"
			},
			{
				"name": "substance",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "correctness",
				"salience": 0.000247217,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.00024629684,
				"type": "OTHER"
			},
			{
				"name": "meanings",
				"salience": 0.00024393013,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0002362052,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.0002362052,
				"type": "OTHER"
			},
			{
				"name": "dreams",
				"salience": 0.0002362052,
				"type": "OTHER"
			},
			{
				"name": "obsession",
				"salience": 0.00023498546,
				"type": "OTHER"
			},
			{
				"name": "post number",
				"salience": 0.00022526341,
				"type": "OTHER"
			},
			{
				"name": "imageboard culture",
				"salience": 0.00022526341,
				"type": "OTHER"
			},
			{
				"name": "digit post numbers",
				"salience": 0.00022526341,
				"type": "OTHER"
			},
			{
				"name": "PC brigade",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "irreverence",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "irony",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "pinch",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "grin",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "brightness",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "pinch",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "irony",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "discordian dialectic",
				"salience": 0.000223203,
				"type": "OTHER"
			},
			{
				"name": "Kekists",
				"salience": 0.00021865143,
				"type": "PERSON"
			},
			{
				"name": "cuckservative",
				"salience": 0.00021865143,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.00021761122,
				"type": "OTHER"
			},
			{
				"name": "mascot",
				"salience": 0.00021390796,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.00021326078,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.00021326078,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.00021326078,
				"type": "OTHER"
			},
			{
				"name": "practitioner",
				"salience": 0.00021326078,
				"type": "PERSON"
			},
			{
				"name": "practice",
				"salience": 0.00021326078,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00021065812,
				"type": "PERSON"
			},
			{
				"name": "bloggers",
				"salience": 0.00019326432,
				"type": "PERSON"
			},
			{
				"name": "salt",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "liar",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "division",
				"salience": 0.00019326432,
				"type": "ORGANIZATION"
			},
			{
				"name": "cheat",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "mine",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "sarcasm",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "neologism",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "globalization",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "techno loonies",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "rampart destruction",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "owner",
				"salience": 0.00019326432,
				"type": "PERSON"
			},
			{
				"name": "hail",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "worshipers",
				"salience": 0.00019326432,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "genes",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.00019326432,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Gutter",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "humankind",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "beta males",
				"salience": 0.00019326432,
				"type": "PERSON"
			},
			{
				"name": "alpha",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "counter-signaling",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "GMO",
				"salience": 0.00019326432,
				"type": "OTHER"
			},
			{
				"name": "KEK",
				"salience": 0.00018998455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.00018861852,
				"type": "LOCATION"
			},
			{
				"name": "roll",
				"salience": 0.00018842252,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00018465558,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.00018465558,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00018465558,
				"type": "OTHER"
			},
			{
				"name": "contents",
				"salience": 0.00018465558,
				"type": "OTHER"
			},
			{
				"name": "Internet forums",
				"salience": 0.00018465558,
				"type": "OTHER"
			},
			{
				"name": "Synchronicities",
				"salience": 0.00018465558,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0001776358,
				"type": "OTHER"
			},
			{
				"name": "Light from Light",
				"salience": 0.00017570177,
				"type": "OTHER"
			},
			{
				"name": "Light from Darkness",
				"salience": 0.00017570177,
				"type": "OTHER"
			},
			{
				"name": "poster",
				"salience": 0.00016699864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "message",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "occurrence",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "irreverence",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "laughter",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "sake",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "dubs",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "grin",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"name": "aficionados",
				"salience": 0.00016671824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09ld4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Frog"
				},
				"name": "Frog",
				"salience": 0.00016468356,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09q915",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan_State_Spartans"
				},
				"name": "Spartans",
				"salience": 0.00016331844,
				"type": "OTHER"
			},
			{
				"name": "Ray Kurzweill",
				"salience": 0.00016331844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bl_5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aryan_race"
				},
				"name": "Aryan",
				"salience": 0.00016331844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00016331844,
				"type": "LOCATION"
			},
			{
				"name": "human relations",
				"salience": 0.00015647164,
				"type": "OTHER"
			},
			{
				"name": "endeavor",
				"salience": 0.00015577245,
				"type": "OTHER"
			},
			{
				"name": "Pepe the Frog",
				"salience": 0.00015292387,
				"type": "WORK_OF_ART"
			},
			{
				"name": "GET",
				"salience": 0.00015186987,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00014435555,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "phenomenon",
				"salience": 0.00014435555,
				"type": "EVENT"
			},
			{
				"name": "luck",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "stroke",
				"salience": 0.00014435555,
				"type": "EVENT"
			},
			{
				"name": "forms",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "bowels",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "merging",
				"salience": 0.00014435555,
				"type": "EVENT"
			},
			{
				"name": "emergence",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "quads",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "trips",
				"salience": 0.00014435555,
				"type": "EVENT"
			},
			{
				"name": "reaction",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "trolling",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "delight",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "conviction",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "brevity",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.00014435555,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00014435555,
				"type": "PERSON"
			},
			{
				"name": "discussion threads",
				"salience": 0.00012397063,
				"type": "OTHER"
			},
			{
				"name": "Chateau Heartiste",
				"salience": 0.00011893142,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01pj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Croatia"
				},
				"name": "Croatian",
				"salience": 0.00011893142,
				"type": "LOCATION"
			},
			{
				"name": "Kali Tribune",
				"salience": 0.00011893142,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02l840",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kanye_West"
				},
				"name": "West",
				"salience": 0.00011893142,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.00011893142,
				"type": "PERSON"
			},
			{
				"name": "leadership",
				"salience": 0.0000843598,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i2.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/trump-pepe.png?fit=610%2C420",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-25T14:33:14.332+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 39.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.121",
		"text": "\nWhile Richard Spencer’s half-joke of hailing Donald Trump with R oman salute rose a lot of dust, some remarks in his NPI speech point into rather sinister direction. A posthuman one. \ntranscript with references and additional a/v material: \nUndoubtedly, there was a sigh of relief throughout the world when Hillary Clinton lost Presidential elections to Donald Trump. If for nothing else, then for the sake of quiet joy of watching adolescent commissars melt in tears “because: racism, homophobia, xenophobia and whateverphobia”; it was a joy, and a relief, because it showed monolithic control system of moral nominalism , dubbed “political correctness”, to be a paper tiger. \nHowever, party is over and dialectics is back with the vengeance. As SJW s are, hopefully, moving out from the spotlight of post-historical stage, the new contender asserts his right to fashion the reality of our day and age into his own image. If we are to judge the day by the first gleam of dawn, this image will be just as ugly – and just as unreal – as hermaphrodite ideal of politically correct “ shitlib ”. \nIn the words of more or less universally acclaimed leader of the “alternative right” movement, Richard Spencer, in the future we are to deal with the leadership of “children of the sun”. \nThis is an interesting, and to my mind quite worrisome, statement of intent – a manifestation of will, as Spencer would doubtless rectify me – pointing out in many directions while seemingly focusing on the eternal – and quite unidirectional – circular movement of the pagan deity, revered by all self-respecting übermenschen – from Nietzsche to postmodern occultists. \nHowever, there’s a deeper astro-theological metaphor at work here. The “pure eye that can gaze upon overabundance of joy without envy” (Nietzsche) in it’s virtual, postmodern, installment is not to be strictly represented by Swastika – as Spencer apparently assumes, but by other, only seemingly ancient, symbol taken in fact from the world of tabletop and PC gaming and turned into ideological brand by Russian philosopher Alexander Dugin (or his minions): an individual widely promoted by core members of alt right movement. \nThe symbol in question is an eight pointed star signifying the movement, not of sun, but of presumably primordial origin of everything: Chaos. \nIn the lines to follow, we’ll provide some preliminary analysis of the emerging situation: the channeling of chaos principle – and adjacent chaos logic – through loosely knit alt right movement, taking as a starting point some statements from Spencer’s speech held at NPI Conference in Washington D.C. on November 21 st . \n\nTriumph of the will or hipster Babylon working \n\nIn introduction to his triumphal encomium to the ideological victory of alt right, embodied in the election of Donald Trump, Spencer makes one interesting remark: \n“But even though we always took Trump seriously, there was still a moment of unreality – or perhaps too painfully intense reality – when the state of Pennsylvania was called for Donald Trump, the moment when we knew Kek had smiled upon us, that meme magic was real. And though these terms are used half-jokingly, they represent something truly important–the victory of will . We willed Donald Trump into office, made this dream into reality. ” \nIt is all delivered in a manner of an in-joke, not to be taken too seriously. Moreover, to the uninitiated into mysteries of this Internet movement it is probably unclear who is “Kek” and what exactly is “meme magic”. \nWe’ll start our explanation with lesser weirdness. \n“Meme” is an expression denoting “inexistent existent”, coined apparently by Richard Dawkins to explain how human thoughts fit in his evolutionary theology: memes are thoughts expressed in image and/or phrase which, by circulation in public, acquire the life and subsistence of their own and are able to “infect” the consciousness with their messages, like viruses. Meme is inexistent because there’s no such thing as thoughts having a biologically based self-subsistence and ability to procreate like viruses. Images and/or phrases are not living beings save by bad analogy that omits to tell us on what exactly it is based: what is that one principle making memes and viruses congenial. Yet they, quite paradoxically, exist because analogy apparently works . However no one seems to pose the question, why it works. \nWell, it works because it is magical. \n\nChaos Magick \n\nHere we have an example of magical thinking in the postmodern – in fact posthumanist – vein, resting on assumption that what has not evolved in nature can – and should – be created in analogy to imagined process of evolution. If artificial construct is in line with “principle of evolution” it is real or, to be more precise, it is in accordance with imaginary nature of this principle; it is imagined into existence . \nTherefore “meme magick” works only insofar it relies upon artificial, preferably technological medium for sustenance and on assumption that its recipients identify themselves with their artificial, preferably online identities that can indeed be imbibed with “memes” as they are in themselves artificial and arbitrary constructs. \nThe goal of practitioner of such magic – a far cry from what was traditionally considered to be magic – is to change the world according to his will. This is, more or less, what is known from the Seventies of the last century as chaos magick , a postmodern imitation of ancient practice of acting in sub-human and sub-natural “domain” of the world, in the past mostly confined to people born with dubious talent to practice it. The peculiarity of chaos magick is, on the one hand, that it is entirely syncretic, i.e. that it uses everything that it’s practitioner can imbibe with intended, subjective, meaning, and that it relies on virtual, i.e. artificial world of mass culture, now embodied above all in Internet. \nThe idea behind it all is that nothing is true and everything is possible . \nThere are many interesting implications to this. \nThe first is that everything is interrelated, i.e. that everything is connected with everything else. So any which way you take, you’ll get where you want to get if you will it hard enough. The second is that there’s no hierarchy of higher and lower – there’s only an infinite surface dissolving into ever more complex elements, dissolving in turn into nothingness, if concentrated upon. As there’s nothing higher, there’s nothing to be revered and everything can – and indeed: should – be an object of ironical laughter. And, most importantly, this is the world of dreams, ruled by what is usually called “dream logic” but in actual fact: chaos logic or un-logic . \nIn this sense, Richard Spencer quite accurately proclaimed Trump’s victory an accomplishment of meme- or chaos magick. \nTrump is willed into office by Internet memes binding the will of alt right adherents and turning their dream into reality – virtual reality, one may add, yet reality nonetheless. The fact that Trump was elected for a plethora of motives – from the appeal of his politics, to public takedown of Hillary Clinton by Wikileaks – is immaterial, because in the world of chaos every subjective “reality tunnel”, or interpretation of the world, is as real as any other. \nIn this sense we can observe new “God Emperor of USA” as a magical creation of Internet, by the Internet and for the Internet – today still the Internet of interconnected computer nodes, but soon probably the Internet of things. If one is to push Spencer’s remark to it’s logical extreme, we can assert that illustrious Donald is the world’s first president of posthuman race; an embodiment of ultra progressive dream invoked to reality by professed ultra anti-progressive group. \nSo that was lesser weirdness. Let us proceed now to high weirdness. \n\n\nWe owe the reader an answer to a question: who the hell is Kek? \nWell, the reason why Spencer mentions him is again a magickal “half-joke”: Kek is interpreted to be an ancient Egyptian deity by a number of Internet observers and identified with alt right memetic avatar – Pepe the frog. While I habitually suspend judgment on all things Egyptian, because ancient Egyptian culture is a slippery ground even for experts, I consider this interpretation, upon closer inspection, to be quite valid in the virtual light of chaos logic. \nNamely, Pepe, the cartoon character, conceived in 2005. by cartoonist Matt Furie, emerged as a meme from the depths of Internet forums, more precisely: 4chan sub-forum /pol/, devoted to political discussions with no holds barred, which was, in view of some observers, a breeding ground for many alt right aficionados; a place of absolute freedom, therefore: absolute chaos. \nThe expression “kek” was also appropriated from the forums and stems from the in-joke among the players of World of Warcraft , replacing the standard Internet abbreviation “LOL” (“laughing out loud”). Someone eventually noticed that Kek is in fact the name of frog-headed Egyptian deity, signifying Chaos and darkness, and Pepe was rebranded as Kek the deity – ironic one, no doubt, half joking one, as surprisingly many alt righters like to put it, but deity nonetheless. \nIt is important to point out that in view of the most “esoteric Kekists”, that is: (half grinning) faithful of Kek/Pepe, the association was originally entirely haphazard and accidental, yet it developed into an ever growing system of synchronicities – causally unrelated meaningful relations among events. So it came to pass that Kek sounds very similar to ‘cuck’(originally: cuckservative), a term denoting old fashioned conservative who was still not “red pilled” (another meme taken from pop culture, shared by both alt right and conspiracy theorists) by alt right or, should we assume: Kek himself; furthermore, Hillary Clinton addressed Pepe as nothing less than public enemy, identifying presumably the whole alt right movement with cartoon character. Then it happened that after this act Hillary fainted in front of the cameras, and that was immediately interpreted as an action of Kek. \nA good run-down of Kek/Pepe/Trump identification \nHowever, it all began with people noticing the numerical synchronicities in the random series of numbers in posts on /pol/ sub-forum: \n„One last thing you need to understand about imageboard culture: dubs. \nEvery post on 4chan and similar venues comes with an 8-digit numerical stamp. This number represents that post’s entry position in the entire posting lineage of the imageboard. \nWith the amount of traffic these sites get, the last couple digits of this number are essentially a random roll. When a poster gets repeated digits, its called “dubs”, “trips”, “quads”, and so on. \nSince a poster can’t know their post number until after they’ve submitted the post, its common for people to “bet” the contents of their message on the occurrence of repeating digits (…) When that endeavor proves a successful, a “GET” has been made and the stroke of luck is celebrated. \nOut of this practice, a strange phenomenon began to take place on /pol/: discussion threads associated with Trump displayed noticeably frequent GETs. It wasn’t long before all of these seemingly random elements discussed so far became irreparably tied together within imageboard culture: Pepe the Frog (now /pol/’s unofficial mascot) Donald Trump (/pol/’s overwhelming candidate of choice) Repeating digit post numbers (“GETS”) “KEK” (used as an expression of delight, particular in response to Trump’s “trolling” of the establishment, as well as in reaction to unlikely GETs in general) \n…and a god was born.“ ( source ) \n\nSynchronicities related to emergence of Kek the God and his merging with Trump in the bowels of Internet forums early on in the presidential campaign, are so numerous and, frankly, mind boggling that we cannot list them here, for the sake of brevity. For our purpose it is sufficient to point out that for many alt right aficionados, including core leadership, Kek is the God and Trump is his prophet, all declared with smug grin and ironical stance, yet with all the necessary power of conviction. \nNamely, chaos magick relies on laughter, or irreverence of its own principles because it is essentially un-principled. Fairly in accordance with its postmodern nature it seeks to deconstruct any kind of order to enable its “practitioner” to impose his own will and change the world – as Spencer would put it: make his dreams a reality. \nI would go further and add: make all reality a dream ; because, chaos magick and alt right are nothing more but novel forms in the development of virtual, i.e. posthuman , world. The idea of adherence and reattachment to tradition that the alt right movement professes is nothing more but simulacrum appealing to people tired of liberal nihilism – in its essence, however, it is a complete opposite: a disintegration of all substantial traditional principles – above all an idea of preexistent hierarchy of Being – into nothingness of primordial Chaos. \n\nPosthuman traditionalism \n\nI already developed this insight regarding the subversive work of Alexander Dugin, who is probably the most consequent subverter of Tradition with recognizable public persona acting in our age, but now we can see how his affiliates in USA and Europe are doing the same thing – with less philosophical subtlety, but fueled by much greater raw power. Namely, alt right, if we are to judge by what it’s leadership advocates, is ideologically nothing more but project of building the simulated tradition – something Richard Spencer likes to call “political theology” – founded on New Age filtered Aryan myths , racial interpretation of Nietzsche and generally crossbred with “do your own thing” mentality, all done in the virtual ether of information technology. After all, if we are to agree with Spencer – half jokingly of course – that God Emperor was inaugurated by the act of Kek the God, then the victory of alt right “traditionalists” is in fact the victory of technological magic; the act of pseudo magus waving the same wand Ray Kurzweill and his ilk offer to progressive lunatics . \nIn the end, therefore, we are talking about another victory of posthumanism, branded, spontaneously or otherwise, as traditionalism. The obsession of alt right adherents with “identity” in general and “white identity” in particular points to a fact that they are unable to realize the simple truth of Tradition they supposedly defend: they understand identity as something that can be created and not something that must be accepted . Observing the plethora of various, rather eccentric individuals in it’s vanguard, from macho gay postmodern Spartans to adherents to all kinds of exotic – and to a large extent made up – pagan religions one is at the lack to find a common denominator, save maybe for quite unchallenged neo-darwinist stance, especially to be found among “game” bloggers as Chateau Heartiste . If someone thinks that he can reattach himself to pre-modern spiritual history of humankind – actually the only one there is – while at the same time musing about “alpha and beta males”, “sexual market”, “signaling and counter-signaling”, professing therefore his proud monkey ancestry and reducing human relations to mental GMO of memes, genes and biological analogies, he is doing nothing else than unconsciously subverting the very thing he seemingly defends. \nThe allure of alt right lies in it’s dialectical opposition to political correctness and rampart destruction of moral substance of the West, induced by process of globalization. Yet this is an eristic or, to use an excellent neologism invented by one correspondent of mine: discordian dialectic; the process of infinite division into ever multiplying opposites founded on the principle of Chaos. It is all done with the crooked half grin, a pinch of salt to every smug remark – with irony of the man who knows he’s a liar and a cheat. But smug humor goes just a short way. In the end it morphs into sarcasm and irreverence of what should in fact be revered and subverts the very principles it professes to defend, far more effectively than dead serious PC brigade or techno loonies of posthumanist movement could ever hope for. \nWe’ll end with the word of warning to Christian adherents of alt right. The words have a definite meanings and power. There’s only one Chaos and there’s only one bringer of light from Chaos – as some Kek worshipers already defined the poor Frog’s main job . And it’s not the One to be defined as “God from God, Light from Light”, but “God from Gutter, Light from Darkness”. A real Darkness shining in virtual brightness. Hope you guess His name. \nSo, without a pinch of irony, I declare: be careful who your “hail”. \n*** \nAuthor Branko Malić is a Croatian author and owner of Kali Tribune , with the background in classical philosophy. He’s focused on philosophy, media, culture and deep politics analysis. ",
		"thread_title": "Hell Comes to Frogtown: Alt Right and Triumph of Transhumanism",
		"title": "Hell Comes to Frogtown: Alt Right and Triumph of Transhumanism",
		"type": "conspiracy",
		"uuid": "f06f10470a770c390f1ade24760e2ea34825014b"
	},
	"-KhIWMipY2xtqL1JHg5j": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-25T23:06:47.899+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.2266101,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.086240396,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.033989936,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.029560221,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.026394818,
				"type": "EVENT"
			},
			{
				"name": "media organizations",
				"salience": 0.022243787,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/045vz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Russian_sentiment"
				},
				"name": "anti-Russian",
				"salience": 0.02007709,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.01757194,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.015556768,
				"type": "ORGANIZATION"
			},
			{
				"name": "programs",
				"salience": 0.011673477,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.01151118,
				"type": "WORK_OF_ART"
			},
			{
				"name": "technocrats",
				"salience": 0.010112619,
				"type": "OTHER"
			},
			{
				"name": "ideologues",
				"salience": 0.009483627,
				"type": "PERSON"
			},
			{
				"name": "legislation",
				"salience": 0.009434572,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.009429274,
				"type": "ORGANIZATION"
			},
			{
				"name": "social media",
				"salience": 0.008875305,
				"type": "OTHER"
			},
			{
				"name": "star chamber",
				"salience": 0.008844292,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.008664955,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.008181191,
				"type": "WORK_OF_ART"
			},
			{
				"name": "member states",
				"salience": 0.007786178,
				"type": "LOCATION"
			},
			{
				"name": "doubts",
				"salience": 0.0076480648,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.007083815,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0063253916,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0060130027,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0060130027,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.005429876,
				"type": "OTHER"
			},
			{
				"name": "internet trolls",
				"salience": 0.005429876,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.005429876,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.005429876,
				"type": "OTHER"
			},
			{
				"name": "Parliamentarians",
				"salience": 0.0052940627,
				"type": "PERSON"
			},
			{
				"name": "RT MEPs",
				"salience": 0.0052258065,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.005010072,
				"type": "OTHER"
			},
			{
				"name": "EU Resolution",
				"salience": 0.004937189,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wire"
				},
				"name": "Wire",
				"salience": 0.0049300543,
				"type": "ORGANIZATION"
			},
			{
				"name": "millions",
				"salience": 0.0049100607,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0129g54z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sputnik_(news_agency)"
				},
				"name": "Sputnik",
				"salience": 0.0048291474,
				"type": "ORGANIZATION"
			},
			{
				"name": "plot",
				"salience": 0.004702593,
				"type": "OTHER"
			},
			{
				"name": "bankruptcy",
				"salience": 0.004702593,
				"type": "EVENT"
			},
			{
				"name": "decline",
				"salience": 0.004702593,
				"type": "OTHER"
			},
			{
				"name": "brainwashing",
				"salience": 0.004702593,
				"type": "EVENT"
			},
			{
				"name": "class",
				"salience": 0.004702593,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.004702593,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.0045398907,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.0041747224,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0033712783,
				"type": "OTHER"
			},
			{
				"name": "bureaucrats",
				"salience": 0.0033401079,
				"type": "PERSON"
			},
			{
				"name": "propaganda",
				"salience": 0.0033028196,
				"type": "OTHER"
			},
			{
				"name": "intelligence agency operatives",
				"salience": 0.003249937,
				"type": "ORGANIZATION"
			},
			{
				"name": "audiences",
				"salience": 0.003052507,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.0030467876,
				"type": "PERSON"
			},
			{
				"name": "businesses",
				"salience": 0.0029234546,
				"type": "ORGANIZATION"
			},
			{
				"name": "Euro Red Scare",
				"salience": 0.0028954782,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0028601764,
				"type": "OTHER"
			},
			{
				"name": "presenters",
				"salience": 0.0026809573,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.0026809573,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.002495463,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.002495463,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.002495463,
				"type": "OTHER"
			},
			{
				"name": "fools",
				"salience": 0.002495463,
				"type": "OTHER"
			},
			{
				"name": "audiences",
				"salience": 0.0024768093,
				"type": "PERSON"
			},
			{
				"name": "wonder millions",
				"salience": 0.0024768093,
				"type": "PERSON"
			},
			{
				"name": "media moguls",
				"salience": 0.0024480731,
				"type": "PERSON"
			},
			{
				"name": "resolution",
				"salience": 0.002286863,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0022363693,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0022363693,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0022363693,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0022363693,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0022363693,
				"type": "OTHER"
			},
			{
				"name": "westerners",
				"salience": 0.0022363693,
				"type": "PERSON"
			},
			{
				"name": "resolution",
				"salience": 0.0022296074,
				"type": "OTHER"
			},
			{
				"name": "news network",
				"salience": 0.002198335,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0021833885,
				"type": "PERSON"
			},
			{
				"name": "level",
				"salience": 0.0020633047,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europeans",
				"salience": 0.0020332613,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0020304236,
				"type": "WORK_OF_ART"
			},
			{
				"name": "effort",
				"salience": 0.0019452508,
				"type": "OTHER"
			},
			{
				"name": "budgets",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "contributors",
				"salience": 0.0019365633,
				"type": "PERSON"
			},
			{
				"name": "pundits",
				"salience": 0.0019365633,
				"type": "PERSON"
			},
			{
				"name": "analysis",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "media monoliths",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0019365633,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "propaganda pieces",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "plethora",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "establishment outlets",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0019365633,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0019307074,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.0018997808,
				"type": "EVENT"
			},
			{
				"name": "propaganda",
				"salience": 0.0018908078,
				"type": "OTHER"
			},
			{
				"name": "audience ratings",
				"salience": 0.0018880727,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0018257567,
				"type": "EVENT"
			},
			{
				"name": "journalists",
				"salience": 0.0018096952,
				"type": "PERSON"
			},
			{
				"name": "journalism",
				"salience": 0.0018096952,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0017366786,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0017366786,
				"type": "OTHER"
			},
			{
				"name": "media environment",
				"salience": 0.0017277147,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0017125963,
				"type": "LOCATION"
			},
			{
				"name": "committees",
				"salience": 0.0016718562,
				"type": "ORGANIZATION"
			},
			{
				"name": "news agency",
				"salience": 0.0016373033,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0016045847,
				"type": "OTHER"
			},
			{
				"name": "debacle",
				"salience": 0.0015680521,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0015680521,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0015680521,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0015680521,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0015644026,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0015644026,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0015168107,
				"type": "WORK_OF_ART"
			},
			{
				"name": "truth",
				"salience": 0.0015095207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h95w7m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Margarita_Simonyan"
				},
				"name": "Margarita Simonyan",
				"salience": 0.0015060174,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0014997434,
				"type": "EVENT"
			},
			{
				"name": "resolution",
				"salience": 0.0014859919,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0014651443,
				"type": "PERSON"
			},
			{
				"name": "approach",
				"salience": 0.0014284526,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0014284526,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0014177712,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0014177712,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0014177712,
				"type": "OTHER"
			},
			{
				"name": "restrictions",
				"salience": 0.0014177712,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.001412496,
				"type": "OTHER"
			},
			{
				"name": "shape",
				"salience": 0.0013751298,
				"type": "OTHER"
			},
			{
				"name": "escape",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "axis",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "chapters",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "disservice",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "coup d'etat",
				"salience": 0.0013578014,
				"type": "PERSON"
			},
			{
				"name": "tens",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0013578014,
				"type": "EVENT"
			},
			{
				"name": "door",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "hubris",
				"salience": 0.0013578014,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.0013431367,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0013431367,
				"type": "PERSON"
			},
			{
				"name": "minds",
				"salience": 0.0013406912,
				"type": "OTHER"
			},
			{
				"name": "layers",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "management",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "subterfuge",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "propaganda regime",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "payroll",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0013071147,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0012800969,
				"type": "OTHER"
			},
			{
				"name": "tools",
				"salience": 0.0012800969,
				"type": "OTHER"
			},
			{
				"name": "information warfare",
				"salience": 0.0012800969,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0012230946,
				"type": "ORGANIZATION"
			},
			{
				"name": "agency",
				"salience": 0.0012230946,
				"type": "ORGANIZATION"
			},
			{
				"name": "news agency",
				"salience": 0.0012230946,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0011919752,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.0011919752,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britons",
				"salience": 0.0011919752,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0011810069,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0011393608,
				"type": "OTHER"
			},
			{
				"name": "Deep State",
				"salience": 0.0011138692,
				"type": "ORGANIZATION"
			},
			{
				"name": "regard",
				"salience": 0.0011084428,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0011084428,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0011084428,
				"type": "OTHER"
			},
			{
				"name": "degradation",
				"salience": 0.0011084428,
				"type": "OTHER"
			},
			{
				"name": "mainstream",
				"salience": 0.0011084428,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.0011084428,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.0011084428,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "interference",
				"salience": 0.00110509,
				"type": "OTHER"
			},
			{
				"name": "White Helmets",
				"salience": 0.0011046388,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.001077749,
				"type": "ORGANIZATION"
			},
			{
				"name": "communication",
				"salience": 0.0010590815,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0010536138,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resolution",
				"salience": 0.0010287132,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.0010287132,
				"type": "OTHER"
			},
			{
				"name": "RT International",
				"salience": 0.0010077405,
				"type": "ORGANIZATION"
			},
			{
				"name": "measures",
				"salience": 0.0009562277,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0009562277,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0009562277,
				"type": "OTHER"
			},
			{
				"name": "internet trolls",
				"salience": 0.0009562277,
				"type": "OTHER"
			},
			{
				"name": "propaganda threat",
				"salience": 0.0009562277,
				"type": "OTHER"
			},
			{
				"name": "tools",
				"salience": 0.0009562277,
				"type": "OTHER"
			},
			{
				"name": "information warfare",
				"salience": 0.0009562277,
				"type": "OTHER"
			},
			{
				"name": "fund",
				"salience": 0.0009562277,
				"type": "OTHER"
			},
			{
				"name": "adventure",
				"salience": 0.0009281121,
				"type": "OTHER"
			},
			{
				"name": "decision-making process",
				"salience": 0.00090486533,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0008907586,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0008907586,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.000842323,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0008356818,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0008356818,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0008356818,
				"type": "PERSON"
			},
			{
				"name": "NeoMcCarthyites",
				"salience": 0.0008356818,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01522",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Sea"
				},
				"name": "Baltic",
				"salience": 0.0008356818,
				"type": "LOCATION"
			},
			{
				"name": "US-UK",
				"salience": 0.0008356818,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGO",
				"salience": 0.0008356818,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0008349106,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.0008349106,
				"type": "PERSON"
			},
			{
				"name": "TV channel",
				"salience": 0.00082799117,
				"type": "OTHER"
			},
			{
				"name": "entities",
				"salience": 0.00082799117,
				"type": "OTHER"
			},
			{
				"name": "bloc",
				"salience": 0.00082799117,
				"type": "ORGANIZATION"
			},
			{
				"name": "means",
				"salience": 0.00082799117,
				"type": "OTHER"
			},
			{
				"name": "awareness raising",
				"salience": 0.00082799117,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.00082799117,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0008251914,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.0008251914,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Sunset for Goebbels",
				"salience": 0.0008044809,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0008044809,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.0008044809,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0008044809,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02m0v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Parliament"
				},
				"name": "EU Parliament",
				"salience": 0.0007878499,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0007878499,
				"type": "LOCATION"
			},
			{
				"name": "propaganda",
				"salience": 0.0007684293,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.0007684293,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.0007684293,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.0007419833,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0006997519,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.0006963879,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0006963879,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0006963879,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.0006963879,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.0006963879,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Strasbourg"
				},
				"name": "Strasbourg",
				"salience": 0.000682189,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05q11",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Organization_for_Security_and_Co-operation_in_Europe"
				},
				"name": "Organization for Security and Co-operation in Europe",
				"salience": 0.00066903495,
				"type": "ORGANIZATION"
			},
			{
				"name": "disintegration",
				"salience": 0.0006673914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.0006651007,
				"type": "ORGANIZATION"
			},
			{
				"name": "vote",
				"salience": 0.0006623997,
				"type": "OTHER"
			},
			{
				"name": "lawmakers",
				"salience": 0.0006343746,
				"type": "PERSON"
			},
			{
				"name": "catch-up",
				"salience": 0.00061068824,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0006029909,
				"type": "OTHER"
			},
			{
				"name": "jet fighter",
				"salience": 0.0006029909,
				"type": "PERSON"
			},
			{
				"name": "collision course",
				"salience": 0.0006029909,
				"type": "OTHER"
			},
			{
				"name": "norms",
				"salience": 0.0006029909,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0006029909,
				"type": "WORK_OF_ART"
			},
			{
				"name": "activity",
				"salience": 0.0006029909,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0006029909,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.0006029909,
				"type": "LOCATION"
			},
			{
				"name": "NGOs",
				"salience": 0.0006029909,
				"type": "ORGANIZATION"
			},
			{
				"name": "MEPs",
				"salience": 0.0005834889,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.00057613436,
				"type": "PERSON"
			},
			{
				"name": "partners",
				"salience": 0.00057613436,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.00057613436,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.00057613436,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition parties",
				"salience": 0.00057613436,
				"type": "OTHER"
			},
			{
				"name": "restrictions",
				"salience": 0.00057613436,
				"type": "OTHER"
			},
			{
				"name": "communication",
				"salience": 0.00057613436,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00057613436,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0005201747,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0005201747,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c3y1b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rossotrudnichestvo"
				},
				"name": "Rossotrudnichestvo",
				"salience": 0.0005095681,
				"type": "ORGANIZATION"
			},
			{
				"name": "Russkiy Mir",
				"salience": 0.0005095681,
				"type": "PERSON"
			},
			{
				"name": "Russian World",
				"salience": 0.0005095681,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0005095681,
				"type": "ORGANIZATION"
			},
			{
				"name": "document",
				"salience": 0.00048602614,
				"type": "WORK_OF_ART"
			},
			{
				"name": "aim",
				"salience": 0.00048602614,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00047030646,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.00045040736,
				"type": "EVENT"
			},
			{
				"name": "fear",
				"salience": 0.00045040736,
				"type": "OTHER"
			},
			{
				"name": "uncertainty",
				"salience": 0.00045040736,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.00045040736,
				"type": "PERSON"
			},
			{
				"name": "point of view",
				"salience": 0.00045040736,
				"type": "OTHER"
			},
			{
				"name": "arguments",
				"salience": 0.00043358904,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00043252495,
				"type": "LOCATION"
			},
			{
				"name": "institutions",
				"salience": 0.00039674775,
				"type": "ORGANIZATION"
			},
			{
				"name": "agency",
				"salience": 0.00037597757,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.00036767105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/065y85t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Conservatives_and_Reformists"
				},
				"name": "European Conservatives and Reformists",
				"salience": 0.00036503497,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Polish",
				"salience": 0.00032011743,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ln61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reporters_Without_Borders"
				},
				"name": "Reporters Without Borders",
				"salience": 0.0002869582,
				"type": "ORGANIZATION"
			},
			{
				"name": "Anna Fotyga",
				"salience": 0.00027718,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North American",
				"salience": 0.00027718,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://i1.wp.com/21stcenturywire.com/wp-content/uploads/2016/11/1-RU-REd-SCARE-RT.jpg?fit=610%2C413",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-25T02:49:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "21stcenturywire.com",
		"spam_score": "0.301",
		"text": "\n21st Century Wire says… \nIf there was any doubt as to the intellectual bankruptcy and democratic decline of the EU’s super bureaucratic class, those doubts can finally be put to rest this week. It seems that Europe’s technocrats have truly surrendered to their own program of ‘Euro Red Scare’ brainwashing. \nThe new EU Resolution compares Russian media organizations to terrorist groups like ISIS (see full report below). The report also claims that Russian “ social media and internet trolls ” are somehow “ challenging democratic values .” The new anti-Russia legislation will now require many millions in funding to implement all of the ‘anti-Russia’ programs that bureaucrats believe are needed to counter this ‘grave threat to democracy.’ A touch oxymoronic, isn’t it? \nEU Parliamentarians appear to have lost the plot. Claiming that Europe is currently ‘at war with Russia’ is one thing, but the hysterical notion that “Russian propaganda” is somehow damaging the minds of Europeans is a whole new level of crazy. \nNo wonder millions of Britons voted to leave the EU this past summer. \nThe cold reality is that most of the ‘dangerous views and information’ aired on RT are by presenters, contributors and pundits — westerners , not Russians. The reason RT’s audience ratings are growing is because the version of news and analysis being presented is resonating with international audiences who see RT’s reports as more accurate, and truthful than media monoliths like the BBC, CNN and other establishment outlets. By spending most of their time, effort and budgets crafting propaganda pieces to cover for the plethora of lies and clandestine operations globally, the western media are killing off their own relationship with domestic audiences. The age of talking down to the public and assuming them as fools is over. RT understood this in 2005 when their news network took shape. 11 years later, western media moguls are playing catch-up, albeit in vain.Sunset for Goebbels. Hamstrung with layers of management and editorial committees infested with intelligence agency operatives and journalists on the payroll of a Deep State star chamber that is so tangled in its own web of subterfuge – obsessed with controlling real information, rather than disseminating it – that their media environment has become too dysfunctional for its own good. They are simply unable to do authentic journalism, or speak truth to power . Incredibly, instead of working to help western media to phase out its own propaganda regime, ideologues in Brussels want to attack RT. \nThe faceless force behind this latest xenophobic EU resolution are those in Washington, Paris and London who are still hell-bent on keeping anti-Russian economic sanctions in place – much to the disservice of many European businesses and their workers who are losing out on trade with Russia. When Donald Trump is sworn in this January, the US-UK-EU anti-Russian axis could disintegrate within a year – so this latest move by Brussels could be a last-ditch effort to do some damage as Europe’s NeoMcCarthyites plot their escape out the back door. From their disastrous coup d’etat in the Ukraine , to NATO’s hubris in the Baltic and beyond, and the EU’s ‘migrant crisis’ debacle, and the tens of millions of Euros being laundered by EU member states through a pseudo NGO called the ‘ White Helmets’ in Syria – these last 3 years will certainly go down as one of the worst chapters in modern diplomatic history – an abject failure of incompetent foreign policy, underpinned by a backward and confused ideology. \nWe tried to find a coherent western reporting on this subject, but it seems even the western mainstream are too embarrassed to cover this bizarre Brussels adventure. See the following video and written report by RT International… \n. RT MEPs in Strasbourg have voted on a non-legislative resolution which calls for the EU to “respond to information warfare by Russia.” RT and Sputnik news agency are alleged to be among the most dangerous “tools” of “hostile propaganda.” \nThe EU Parliament’s resolution demonstrates “ political degradation ” in regard to the “ idea of democracy ” in the West, Russian President Vladimir Putin said on Wednesday, commenting on the vote. \nPutin pointed out that while “ everyone tries to lecture ” Russia on democracy, European lawmakers themselves resort to a policy of restrictions, “ which is not the best way ” to deal with any issues. \n“ The best approach is an open discussion, in which bright and solid arguments to support one’s point of view should be presented ,” Putin said. \nAdding that he hopes the Western move to “ counter Russian propaganda ” won’t lead to serious restrictions, the president congratulated RT and Sputnik journalists on their work. \nIn the Wednesday vote, 304 MEPs supported the resolution based on the report ‘ EU strategic communication to counteract propaganda against it by third parties ’, with 179 voting against it and 208 abstaining. \nWritten by a Polish member of the European Conservatives and Reformists (ECR) group, Anna Fotyga, the report alleged that Moscow aims to “ distort the truth, provoke doubt, divide the EU and its North American partners, paralyze the decision-making process, discredit the EU institutions and incite fear and uncertainty among EU citizens .” \nThe report suggests that Moscow provides financial support to opposition parties and organizations in EU member states, causing disintegration within the bloc. \nAt the same time, Russia is accused of “ information warfare ,” with such entities as RT TV channel, Sputnik news agency, Rossotrudnichestvo federal agency and the Russkiy Mir (Russian World) fund alleged to be among its most threatening propaganda “tools. ” \nThe document places Russian media organizations alongside terrorist groups such as Islamic State (IS, formerly ISIS/ISIL). \nThe report also mentions some “ social media and internet trolls ” from Russia who are thought to “ challenge democratic values .” \nIt called for the establishment of measures to tackle the perceived Russian propaganda threat, by means of “ investing in awareness raising, education, online and local media .” It also suggests stronger cooperation between the EU and NATO “ on strategic communication .” \nSputnik has already appealed to the UN, the Organization for Security and Co-operation in Europe (OSCE) and a number of international journalists’ organizations and NGOs, including Reporters Without Borders, to take measures to stop what it considers to be interference into freedom of speech in the EU. \n“ The resolution hits straight at a number of respected media, including Sputnik agency, and has an aim to stop their activity in the EU. Moreover, the resolution bluntly contradicts the EU’s own human rights and freedom of press norms,” reads the letter signed by Sputnik Editor-in-Chief Margarita Simonyan. \nDuring the parliamentary debate that preceded the vote, MEPs campaigning for the resolution said the EU was “ at war with Russia, on a collision course with each other traveling faster than a jet fighter ,” and that with an alleged “ aim to split Europe, the Kremlin forces its information into our countries .” ",
		"thread_title": "EU Red Scare: Brussels Passes New Resolution to ‘Counter Russian Media Propaganda’",
		"title": "EU Red Scare: Brussels Passes New Resolution to ‘Counter Russian Media Propaganda’",
		"type": "conspiracy",
		"uuid": "d1056f290f1cfffa9907ac34ab6dc0ffbc3339ca"
	},
	"-KhIWN2eCift89Q_oIaJ": {
		"author": "Jimmy Rustling",
		"comments": "0",
		"country": "CO",
		"crawled": "2016-10-27T15:50:22.818+03:00",
		"domain_rank": "65078",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.4548278,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8ym",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amish"
				},
				"name": "Amish",
				"salience": 0.21808499,
				"type": "ORGANIZATION"
			},
			{
				"name": "American Amish Brotherhood",
				"salience": 0.12418992,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.033817936,
				"type": "PERSON"
			},
			{
				"name": "SHARE",
				"salience": 0.010669459,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.00737489,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.0073342454,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.0071232948,
				"type": "OTHER"
			},
			{
				"name": "Presidency",
				"salience": 0.0060678115,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.006029485,
				"type": "ORGANIZATION"
			},
			{
				"name": "men",
				"salience": 0.0056804176,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0053886096,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0048205825,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0039508245,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.0036041725,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0035084928,
				"type": "OTHER"
			},
			{
				"name": "portion",
				"salience": 0.0032866832,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0031085005,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0029434387,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0027658953,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.002759452,
				"type": "OTHER"
			},
			{
				"name": "challenges",
				"salience": 0.002426434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gl0hx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nate_Silver"
				},
				"name": "Nate Silver",
				"salience": 0.0024184387,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0023027777,
				"type": "PERSON"
			},
			{
				"name": "History",
				"salience": 0.002098187,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0019946129,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0019946129,
				"type": "LOCATION"
			},
			{
				"name": "governing body",
				"salience": 0.0019946129,
				"type": "ORGANIZATION"
			},
			{
				"name": "Photo",
				"salience": 0.0019946129,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01smm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Columbus,_Ohio"
				},
				"name": "COLUMBUS",
				"salience": 0.001867219,
				"type": "LOCATION"
			},
			{
				"name": "assault",
				"salience": 0.0018570177,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.0013662127,
				"type": "LOCATION"
			},
			{
				"name": "presidency",
				"salience": 0.0012817701,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0012817701,
				"type": "PERSON"
			},
			{
				"name": "scenarios",
				"salience": 0.0012404012,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "Associated Press",
				"salience": 0.0012367013,
				"type": "ORGANIZATION"
			},
			{
				"name": "Dennis System",
				"salience": 0.0012285374,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0012135671,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0012135671,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01rytd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Menno_Simons"
				},
				"name": "Menno Simons",
				"salience": 0.0012045095,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqj4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Census_Bureau"
				},
				"name": "United States Census Bureau",
				"salience": 0.0010687177,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0009827911,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.00094899785,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00094899785,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.00087177916,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.000821822,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.000821822,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.000821822,
				"type": "EVENT"
			},
			{
				"name": "urban sprawl",
				"salience": 0.000821822,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.000821822,
				"type": "PERSON"
			},
			{
				"name": "voting age",
				"salience": 0.000821822,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0008201632,
				"type": "EVENT"
			},
			{
				"name": "swing states",
				"salience": 0.0008024116,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0008024116,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0008024116,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.0008024116,
				"type": "WORK_OF_ART"
			},
			{
				"name": "vote",
				"salience": 0.0007977667,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0007370243,
				"type": "OTHER"
			},
			{
				"name": "descendants",
				"salience": 0.0007239857,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.0007117573,
				"type": "OTHER"
			},
			{
				"name": "Amish",
				"salience": 0.00069798005,
				"type": "ORGANIZATION"
			},
			{
				"name": "assault",
				"salience": 0.0006654823,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0006548071,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.00065131986,
				"type": "OTHER"
			},
			{
				"name": "stand",
				"salience": 0.0006139868,
				"type": "OTHER"
			},
			{
				"name": "Amish",
				"salience": 0.0005994817,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.00057627447,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.00057627447,
				"type": "OTHER"
			},
			{
				"name": "Lord",
				"salience": 0.00057627447,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.00057627447,
				"type": "OTHER"
			},
			{
				"name": "violation",
				"salience": 0.00057627447,
				"type": "OTHER"
			},
			{
				"name": "leadership role",
				"salience": 0.00057627447,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00057627447,
				"type": "PERSON"
			},
			{
				"name": "marriage",
				"salience": 0.00057627447,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00057627447,
				"type": "ORGANIZATION"
			},
			{
				"name": "Paul Horner",
				"salience": 0.000555963,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.00055476744,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00055476744,
				"type": "ORGANIZATION"
			},
			{
				"name": "patriotism",
				"salience": 0.00055476744,
				"type": "OTHER"
			},
			{
				"name": "reformation sect",
				"salience": 0.00055476744,
				"type": "PERSON"
			},
			{
				"name": "virtues",
				"salience": 0.00055476744,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.00055476744,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00055476744,
				"type": "OTHER"
			},
			{
				"name": "displays",
				"salience": 0.00055476744,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00055476744,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.00054831576,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00054831576,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00050591066,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00049542665,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.000491394,
				"type": "ORGANIZATION"
			},
			{
				"name": "freefall",
				"salience": 0.00047046432,
				"type": "OTHER"
			},
			{
				"name": "models",
				"salience": 0.00047046432,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "country",
				"salience": 0.00046453657,
				"type": "LOCATION"
			},
			{
				"name": "mood",
				"salience": 0.0004529041,
				"type": "OTHER"
			},
			{
				"name": "campaign workers",
				"salience": 0.00044951774,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.00044951774,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.00044951774,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00044036502,
				"type": "LOCATION"
			},
			{
				"name": "price",
				"salience": 0.00040587015,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00040587015,
				"type": "EVENT"
			},
			{
				"name": "community",
				"salience": 0.00037808646,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05t38r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Second_Epistle_to_Timothy"
				},
				"name": "Timothy 2",
				"salience": 0.00035471254,
				"type": "WORK_OF_ART"
			},
			{
				"name": "support",
				"salience": 0.0003514487,
				"type": "OTHER"
			},
			{
				"name": "government buildings",
				"salience": 0.0003514487,
				"type": "LOCATION"
			},
			{
				"name": "taxpayers",
				"salience": 0.0003514487,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0003514487,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0003514487,
				"type": "EVENT"
			},
			{
				"name": "staff",
				"salience": 0.0003514487,
				"type": "PERSON"
			},
			{
				"name": "hopelessness",
				"salience": 0.0003514487,
				"type": "OTHER"
			},
			{
				"name": "despair",
				"salience": 0.0003514487,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01274",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anabaptists"
				},
				"name": "Anabaptists",
				"salience": 0.00034147105,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.00033441285,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.00032738893,
				"type": "OTHER"
			},
			{
				"name": "losses",
				"salience": 0.00031754168,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00029559573,
				"type": "EVENT"
			},
			{
				"name": "price",
				"salience": 0.00029559573,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0q76g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Midwestern_United_States"
				},
				"name": "Midwest",
				"salience": 0.0002895695,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.0002895695,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v1s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indiana"
				},
				"name": "Indiana",
				"salience": 0.0002895695,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.0002895695,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0002895695,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.0002895695,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.0002895695,
				"type": "LOCATION"
			},
			{
				"name": "Cleary",
				"salience": 0.00026496995,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.00026472544,
				"type": "OTHER"
			},
			{
				"name": "TAGS",
				"salience": 0.000255956,
				"type": "OTHER"
			},
			{
				"name": "sleeping giant",
				"salience": 0.000255956,
				"type": "ORGANIZATION"
			},
			{
				"name": "plea",
				"salience": 0.0002464,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00024455722,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0002208058,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.00021630389,
				"type": "LOCATION"
			},
			{
				"name": "concerns",
				"salience": 0.00019119319,
				"type": "OTHER"
			},
			{
				"name": "press conference",
				"salience": 0.00019119319,
				"type": "EVENT"
			},
			{
				"name": "opponent",
				"salience": 0.00019119319,
				"type": "PERSON"
			},
			{
				"name": "facts",
				"salience": 0.00019119319,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00019119319,
				"type": "PERSON"
			},
			{
				"name": "lady",
				"salience": 0.00019119319,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.00019119319,
				"type": "OTHER"
			},
			{
				"name": "career real estate developer",
				"salience": 0.00019119319,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.00019119319,
				"type": "OTHER"
			},
			{
				"name": "Pennsylvania Amish Heritage Museum",
				"salience": 0.0001575247,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00015050871,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00014648355,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00014648355,
				"type": "OTHER"
			},
			{
				"name": "pundits",
				"salience": 0.0001357486,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Arkansas",
				"salience": 0.00011766381,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://abcnews.com.co/wp-content/uploads/2016/10/The-Amish-vote-for-donald-Trump.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T13:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12,
			"score": 0
		},
		"shares": "0",
		"site_url": "abcnews.com.co",
		"spam_score": "0",
		"text": "18 SHARE The Amish in America have committed their vote to Donald Trump guaranteeing him the Presidency. (AP Photo / Dennis System) \nCOLUMBUS, OH (AP) — History was made today in Columbus, Ohio when more than 3 million Amish poured into the city to see the American Amish Brotherhood (AAB), an organization which acts as an informal governing body for the Amish community, endorse Donald Trump for president. That number represents a significant portion of the total Amish population, which the United States Census Bureau says numbers more than 20 million men and women nationwide all pledging their vote to Trump for President. With the full force of the Amish community behind him, Donald Trump is now mathematically guaranteed to win the presidency in November. \nThe organization typically meets once a year and the meetings usually consist of about 300 Amish leaders who meet to discuss the challenges, such as urban sprawl, that face the community. This year, however, the organization wanted as many people in attendance as possible so they can effectively instruct all Amish men and women of legal voting age to cast their vote for the flamboyant Republican nominee. \nThe Amish, who are direct descendants of the protestant reformation sect known as the Anabaptists, have typically stayed out of politics in the past. As a general rule, they don’t vote, serve in the military, or engage in any other displays of patriotism. This year, however, the AAB has said that it is imperative that they get involved in the democratic process. \n“Over the past eight years, the Democratic Party has launched a systematic assault on biblical virtues,” said AAB chairman Menno Simons. “We have seen more and more Christians being persecuted for their faith; we have seen the state defile the institution of marriage. Now, they want to put a woman in the nation’s highest leadership role in direct violation of 1 Timothy 2:12. We need to stop this assault and take a stand for biblical principles. Donald Trump has shown in both action and deed that he is committed to restoring this country to the Lord’s way.” \nAccording to statistician Nate Silver of the website fivethirtyeight.com, there are no possible scenarios in which Hillary Clinton can win with Donald Trump carrying the Amish vote. \n“The Amish have their highest numbers in perennial swing states like Pennsylvania, Virginia, Ohio, Indiana, and Iowa,” Silver noted. “They also have strong numbers in reliably Democratic states like Michigan, Illinois, and New York, meaning that Hillary will lose those states as well. There is also a sizeable community in Florida which, while not as large as it is in the Midwest, is still large enough to turn Florida for Trump. Over the next two weeks, you can expect Hillary to enter into a state of freefall in all of my predictive models.” \nThe Clinton campaign issued a written statement to the AAB asking them to reconsider their decision. \n“I don’t believe that Donald Trump is the person who best represents your interests,” Clinton wrote to the AAB. “As a career real estate developer, he represents a clear threat to your simple way of life. As former first lady of Arkansas, I understand the concerns of rural Americans more than any candidate in this election. I implore you to consider all of the facts before voting for my opponent.” \nMost pundits believe that Mrs. Clinton’s plea is too little too late. \nDuring a press conference in Manhattan, Trump thanked the AAB for their support and promised to put the Amish to work maintaining government buildings, which he said would save taxpayers millions because “the Amish do great work for a very low price.” \nThough Clinton has pledged to stay in the race until the very end, many of her campaign workers have already resigned. According to the Associated Press, it is expected that the Clinton campaign will lose 50% of its staff over the next two weeks. There is a general mood of hopelessness and despair in the Clinton camp, and many simply want to cut their losses. \n“It looked like she was going to win this election easily,” said Paul Horner, a campaign worker in Ohio, “But this is what happens when you wake a sleeping giant. Cleary, Mrs. Clinton took far too much for granted in this race, and we are all now paying the price. It’s really sad to see the campaign end this way.” \nIf you are interested in learning more about the Amish community and the AAB, you can contact the Pennsylvania Amish Heritage Museum at (785) 273-0325. TAGS ",
		"thread_title": "The Amish In America Commit Their Vote To Donald Trump; Mathematically Guaranteeing Him A Presidential Victory - ABC News",
		"title": "The Amish In America Commit Their Vote To Donald Trump; Mathematically Guaranteeing Him A Presidential Victory - ABC News",
		"type": "fake",
		"uuid": "8a35883f9c9f0b15a9e20ab8711d403d91d57405"
	},
	"-KhIWNM7DuIeDz8ef1P4": {
		"author": "Jimmy Rustling",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-11T16:33:32.484+02:00",
		"domain_rank": "65078",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.21945202,
				"type": "PERSON"
			},
			{
				"name": "college",
				"salience": 0.078717686,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.044193164,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.02230639,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.021109749,
				"type": "ORGANIZATION"
			},
			{
				"name": "electors",
				"salience": 0.018450905,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Department of Justice",
				"salience": 0.018411122,
				"type": "ORGANIZATION"
			},
			{
				"name": "Many",
				"salience": 0.017649135,
				"type": "PERSON"
			},
			{
				"name": "Executive Order",
				"salience": 0.017471302,
				"type": "OTHER"
			},
			{
				"name": "Executive Order",
				"salience": 0.01589792,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.01508718,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.014221814,
				"type": "PERSON"
			},
			{
				"name": "election results",
				"salience": 0.013776885,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.012925411,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.012445066,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.012008126,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.012008126,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.012008126,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.011742031,
				"type": "PERSON"
			},
			{
				"name": "revote",
				"salience": 0.010782733,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.010782733,
				"type": "EVENT"
			},
			{
				"name": "votes",
				"salience": 0.010403916,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.009074627,
				"type": "OTHER"
			},
			{
				"name": "recount",
				"salience": 0.008742983,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.008140459,
				"type": "OTHER"
			},
			{
				"name": "electors",
				"salience": 0.007962144,
				"type": "PERSON"
			},
			{
				"name": "calls",
				"salience": 0.0076314704,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.0072322036,
				"type": "OTHER"
			},
			{
				"name": "poll workers",
				"salience": 0.0070951376,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.007051506,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.007051506,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03jzl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Share_(finance)"
				},
				"name": "SHARE",
				"salience": 0.0066461433,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.006368197,
				"type": "LOCATION"
			},
			{
				"name": "concerns",
				"salience": 0.006368197,
				"type": "OTHER"
			},
			{
				"name": "equipment failures",
				"salience": 0.005802288,
				"type": "OTHER"
			},
			{
				"name": "Photo",
				"salience": 0.0055158054,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thousands",
				"salience": 0.0055158054,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0055158054,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "AP",
				"salience": 0.0051634475,
				"type": "ORGANIZATION"
			},
			{
				"name": "electoral college",
				"salience": 0.0051550227,
				"type": "ORGANIZATION"
			},
			{
				"name": "Dennis System",
				"salience": 0.0050155204,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0048899446,
				"type": "LOCATION"
			},
			{
				"name": "President",
				"salience": 0.004414501,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.004290957,
				"type": "PERSON"
			},
			{
				"name": "electoral college",
				"salience": 0.004290957,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.004277827,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004135128,
				"type": "PERSON"
			},
			{
				"name": "precincts",
				"salience": 0.0040109,
				"type": "LOCATION"
			},
			{
				"name": "elections",
				"salience": 0.003994761,
				"type": "EVENT"
			},
			{
				"name": "recount",
				"salience": 0.0038483343,
				"type": "OTHER"
			},
			{
				"name": "shirt",
				"salience": 0.00367797,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "nothing",
				"salience": 0.0036081686,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0169dl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Matt_Damon"
				},
				"name": "Matt Daemon",
				"salience": 0.0035962672,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0034751324,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.0034701093,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "WASHINGTON, D.C.",
				"salience": 0.003397063,
				"type": "LOCATION"
			},
			{
				"name": "People",
				"salience": 0.0033556628,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0033455226,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0033455226,
				"type": "EVENT"
			},
			{
				"name": "college",
				"salience": 0.003009522,
				"type": "OTHER"
			},
			{
				"name": "collusion",
				"salience": 0.003009522,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0029807226,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0029807226,
				"type": "PERSON"
			},
			{
				"name": "margin",
				"salience": 0.0029279198,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0029279198,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0029089681,
				"type": "OTHER"
			},
			{
				"name": "ballots",
				"salience": 0.002906041,
				"type": "OTHER"
			},
			{
				"name": "poll workers",
				"salience": 0.002906041,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0028374149,
				"type": "EVENT"
			},
			{
				"name": "entry",
				"salience": 0.0027135431,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0026933446,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.002659347,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0026240228,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0026240228,
				"type": "LOCATION"
			},
			{
				"name": "concerns",
				"salience": 0.0026240228,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0025279643,
				"type": "PERSON"
			},
			{
				"name": "swing states",
				"salience": 0.0024856103,
				"type": "LOCATION"
			},
			{
				"name": "votes",
				"salience": 0.0024571656,
				"type": "OTHER"
			},
			{
				"name": "electoral college",
				"salience": 0.0024571656,
				"type": "ORGANIZATION"
			},
			{
				"name": "constitution",
				"salience": 0.0024360262,
				"type": "WORK_OF_ART"
			},
			{
				"name": "states",
				"salience": 0.0023928713,
				"type": "LOCATION"
			},
			{
				"name": "system",
				"salience": 0.002353282,
				"type": "OTHER"
			},
			{
				"name": "Paul Horner",
				"salience": 0.00230629,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0022723451,
				"type": "OTHER"
			},
			{
				"name": "voting booths",
				"salience": 0.0022723451,
				"type": "LOCATION"
			},
			{
				"name": "horror stories",
				"salience": 0.0022723451,
				"type": "WORK_OF_ART"
			},
			{
				"name": "calls",
				"salience": 0.0022723451,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0022723451,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.0022723451,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0022654757,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0022485428,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0021989678,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0020378605,
				"type": "PERSON"
			},
			{
				"name": "poll workers",
				"salience": 0.0020378605,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0020378605,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.0020293337,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0020293337,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0020096085,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.0020061065,
				"type": "OTHER"
			},
			{
				"name": "challenges",
				"salience": 0.0019765897,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0019212782,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0018788576,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0018551885,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.0018400343,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.001833615,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African American",
				"salience": 0.0017890603,
				"type": "PERSON"
			},
			{
				"name": "precincts",
				"salience": 0.0017713652,
				"type": "LOCATION"
			},
			{
				"name": "voter suppression",
				"salience": 0.0017713652,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.0017713652,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0016136934,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0015933628,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.0015933628,
				"type": "OTHER"
			},
			{
				"name": "election fair",
				"salience": 0.0015933628,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0015440852,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0015440852,
				"type": "EVENT"
			},
			{
				"name": "reporters",
				"salience": 0.0015338938,
				"type": "PERSON"
			},
			{
				"name": "background checks",
				"salience": 0.0015338938,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0015021943,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.001476643,
				"type": "OTHER"
			},
			{
				"name": "press conference",
				"salience": 0.001458038,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0014303434,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0014099141,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.001398801,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.001398801,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latino",
				"salience": 0.001398801,
				"type": "OTHER"
			},
			{
				"name": "nightmare",
				"salience": 0.0013921494,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0013859316,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0013746084,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0013370672,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0013007898,
				"type": "PERSON"
			},
			{
				"name": "college run",
				"salience": 0.0013007898,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0013007898,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0013007898,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.0012364562,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0011577918,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0011577918,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.001153484,
				"type": "EVENT"
			},
			{
				"name": "President",
				"salience": 0.0010276099,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.00097171054,
				"type": "OTHER"
			},
			{
				"name": "depression",
				"salience": 0.00097171054,
				"type": "EVENT"
			},
			{
				"name": "recession",
				"salience": 0.00097171054,
				"type": "EVENT"
			},
			{
				"name": "compromise",
				"salience": 0.00097171054,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00097171054,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.00097171054,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0009572317,
				"type": "OTHER"
			},
			{
				"name": "election hotline",
				"salience": 0.0009354349,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.0009354349,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.00093260553,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00089315436,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0008598104,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00082482205,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.0008172794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09f2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Los_Angeles"
				},
				"name": "UCLA",
				"salience": 0.0008006172,
				"type": "ORGANIZATION"
			},
			{
				"name": "Executive Order",
				"salience": 0.0007808832,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0007351242,
				"type": "EVENT"
			},
			{
				"name": "deadline",
				"salience": 0.0007076783,
				"type": "OTHER"
			},
			{
				"name": "TAGS",
				"salience": 0.0007076783,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0007076783,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.0007076783,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.0007076783,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charges",
				"salience": 0.0007076783,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00061049126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00059804396,
				"type": "LOCATION"
			},
			{
				"name": "king joke",
				"salience": 0.0005632269,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.00052861567,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.00052861567,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.0004524196,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0004492222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01v3sw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ABC_News"
				},
				"name": "ABC News",
				"salience": 0.00025355237,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://abcnews.com.co/wp-content/uploads/2016/11/Obama-signs-Executive-Order.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-11T12:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abcnews.com.co",
		"spam_score": "0.009",
		"text": "64 SHARE President Obama has signed an Executive Order declaring an investigation into the election results and plans for a revote on December 19th. (AP Photo / Dennis System) \nWASHINGTON, D.C. (AP) — Following the results of Tuesday night’s election, President Obama has signed Executive Order 13805 , which orders a full recount of all votes cast in the election and calls for a special election to be held on December 19 th . Obama signed the order in response to the concerns of thousands of voters across the country who said that they were prevented from casting a ballot on election day , too many absentee ballots have not been found or counted , equipment failures, as well as concerns that some members of the electoral college may have acted unethically. \n“People all over the country have been flooding my office with calls, telling my staff of horror stories about being harassed and intimidated by poll workers,” Obama told reporters. “Many have even said that they were flat out denied entry into the voting booths to cast their ballots if they were wearing a Hillary Clinton shirt or other signs showing support for her as President. This was especially bad in areas of Florida and North Carolina where there are high numbers of Latino and African American voters. We must investigate these claims. The margin of victory is too close to call, and the outcome of this election is too important. There is just too many legal challenges in too many states to just call this a victory for Trump.” \nUnder the President’s order, the votes cast in all precincts nationwide will be recounted, and all poll workers who took part in Tuesday’s election will be subjected to strict background checks. This process is expected to take 30 days. In precincts where the Department of Justice has cause to believe that voter suppression has occurred, new elections will be held on Dec. 19 th, with those results being used to help determine who will represent the individual states in the electoral college. \nNot surprisingly, Donald Trump is not happy with the president’s decision. \n“Crooked Hillary lost this election fair and square. They tried to rig this election against me, but the American people didn’t allow that to happen. President Obama doesn’t care about what the American people want. I said the system was rigged all along, and this proves I was right.” \nThe president also said that the DOJ will be taking a close look at the members of the electoral college. \n“We have received information from a very reliable source that suggests there may have been some collusion between the members of the electoral college and poll workers in certain swing states. We still need to investigate these claims, but if they are true, we will take all the appropriate actions necessary.” \nPaul Horner, a professor of political science at UCLA, believes that the issues with the electoral college run much deeper that this election. \n“Most people feel that it is their right as citizens to pick the president of the United States, but there is nothing in the constitution that says that. Hillary Clinton won the popular vote by more than 200,000 votes , but because of the electoral college, she still lost. That decision is reserved solely for the 538 electors who meet in their respective states on December 19 th . What the people are actually voting for are their states’ electors, not for the President. Though the system is odd and unfair, it has persisted because many insist that it works just fine as it is, with the winner of the popular and electoral vote usually matching. That does not mean, however, that it will continue to work just fine in the future. The way the system is set up could cause it to malfunction in some potentially terrifying ways, this recent election being one of them.” \nPolitical Analyst Matt Daemon told ABC News that he agrees with the President’s Executive Order and said that he would like to see the electoral college done away with altogether. \n“[The electoral college] is a f—king joke; we should be using the popular vote instead. It may have made sense in 1788, but so did the three fifths compromise . Everyone should have an equal vote, and that’s just not the case with the electoral college. You know what the electoral college gave us? It gave us George W. Bush. It gave us a war in Iraq, and the worst recession since the great depression. It’s time to bring our system into the 21 st century. I hope Obama fixes this, because president Trump is going to be a nightmare.” \nObama finished up the press conference explaining his plans for moving forward. \n“We’re going to investigate the FBI into their role in all of this,” Obama said. “Why did FBI director James Comey on Sunday say that the agency is not recommending charges against Clinton after reviewing all of her emails; declaring Hillary Clinton a free women conveniently just one day before the election? Why wasn’t this news released earlier? How many votes were lost because of this?” Obama said. “If all of these questions cannot be answered by our deadline set in December, a recount will be ordered.” \nIf you have any questions about the recount or the special December 19 th election , you can call the Obama administration’s special election hotline at (785) 273-0325. TAGS ",
		"thread_title": "Obama Signs Executive Order Declaring Investigation Into Election Results; Revote Planned For Dec. 19th - ABC News",
		"title": "Obama Signs Executive Order Declaring Investigation Into Election Results; Revote Planned For Dec. 19th - ABC News",
		"type": "fake",
		"uuid": "c6fb8dae30e3d378935e910540a0cb99b5351ac0"
	},
	"-KhIWOp3_rekgT05oLYr": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:37:58.775+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.10912948,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "BILL CLINTON",
				"salience": 0.084278576,
				"type": "PERSON"
			},
			{
				"name": "Taylor",
				"salience": 0.07812532,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wp7w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Malloch_Brown,_Baron_Malloch-Brown"
				},
				"name": "Mark Malloch-Brown",
				"salience": 0.023448097,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0412gcn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Smartmatic"
				},
				"name": "Smartmatic",
				"salience": 0.022984417,
				"type": "ORGANIZATION"
			},
			{
				"name": "Digital Fires Instructor Serco",
				"salience": 0.021195747,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/028z3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Pickton"
				},
				"name": "Robert ``Willie'' Pickton",
				"salience": 0.017607052,
				"type": "PERSON"
			},
			{
				"name": "Mar 2013 Serco Inc.",
				"salience": 0.014446917,
				"type": "ORGANIZATION"
			},
			{
				"name": "AbelDanger.net",
				"salience": 0.01420192,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.013371723,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.008969496,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gillenwater",
				"salience": 0.0078041037,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.007701518,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fz196",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Epstein"
				},
				"name": "Jeffrey Epstein",
				"salience": 0.007339526,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fzds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Patent_and_Trademark_Office"
				},
				"name": "U.S. Patent and Trademark Office",
				"salience": 0.0066662123,
				"type": "ORGANIZATION"
			},
			{
				"name": "DOJ Pride 8",
				"salience": 0.0065268744,
				"type": "OTHER"
			},
			{
				"name": "jet",
				"salience": 0.00637254,
				"type": "OTHER"
			},
			{
				"name": "Christopher Rajendran Hyman CBE",
				"salience": 0.0056794602,
				"type": "PERSON"
			},
			{
				"name": "Platte River Networks",
				"salience": 0.005265694,
				"type": "ORGANIZATION"
			},
			{
				"name": "passengers",
				"salience": 0.0051403344,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0046689934,
				"type": "PERSON"
			},
			{
				"name": "companies",
				"salience": 0.0045861686,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.004121765,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0040852632,
				"type": "OTHER"
			},
			{
				"name": "Virginia Roberts",
				"salience": 0.0039452184,
				"type": "PERSON"
			},
			{
				"name": "7537159 B2",
				"salience": 0.0038817383,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.00388073,
				"type": "PERSON"
			},
			{
				"name": "basement",
				"salience": 0.0037992399,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0037744963,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.003494888,
				"type": "LOCATION"
			},
			{
				"name": "Business",
				"salience": 0.0034397985,
				"type": "ORGANIZATION"
			},
			{
				"name": "loan",
				"salience": 0.0031686623,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0029606537,
				"type": "PERSON"
			},
			{
				"name": "addicts",
				"salience": 0.0029102755,
				"type": "PERSON"
			},
			{
				"name": "server",
				"salience": 0.0028268425,
				"type": "OTHER"
			},
			{
				"name": "Field",
				"salience": 0.002701834,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Columbia"
				},
				"name": "B.C.",
				"salience": 0.0026388254,
				"type": "OTHER"
			},
			{
				"name": "e-mail server company",
				"salience": 0.0026259723,
				"type": "ORGANIZATION"
			},
			{
				"name": "Paul Combetta",
				"salience": 0.0026145484,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0025770972,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0206rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Sachs"
				},
				"name": "Sachs",
				"salience": 0.002488569,
				"type": "PERSON"
			},
			{
				"name": "Lynne Cheney",
				"salience": 0.002488569,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0024843568,
				"type": "LOCATION"
			},
			{
				"name": "pig farm friends",
				"salience": 0.002478205,
				"type": "PERSON"
			},
			{
				"name": "Base One",
				"salience": 0.0023095477,
				"type": "ORGANIZATION"
			},
			{
				"name": "Battleground States",
				"salience": 0.0022164744,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0022164744,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0022164744,
				"type": "LOCATION"
			},
			{
				"name": "Some",
				"salience": 0.002184035,
				"type": "PERSON"
			},
			{
				"name": "Pat Casanova",
				"salience": 0.002175974,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.002132105,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.0021306656,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0021306656,
				"type": "ORGANIZATION"
			},
			{
				"name": "Daniel Greenfield",
				"salience": 0.0021259666,
				"type": "PERSON"
			},
			{
				"name": "Command",
				"salience": 0.002107805,
				"type": "ORGANIZATION"
			},
			{
				"name": "management services",
				"salience": 0.0020853006,
				"type": "OTHER"
			},
			{
				"name": "balloting equipment",
				"salience": 0.002070332,
				"type": "OTHER"
			},
			{
				"name": "command",
				"salience": 0.0020380674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "United States Marine",
				"salience": 0.002023228,
				"type": "ORGANIZATION"
			},
			{
				"name": "status",
				"salience": 0.0019646527,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.001937116,
				"type": "OTHER"
			},
			{
				"name": "patent office",
				"salience": 0.001937116,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0019370586,
				"type": "OTHER"
			},
			{
				"name": "Maria Contreras-Sweet",
				"salience": 0.0019187074,
				"type": "PERSON"
			},
			{
				"name": "companies",
				"salience": 0.0019008975,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0018828451,
				"type": "ORGANIZATION"
			},
			{
				"name": "billionaire",
				"salience": 0.0018828451,
				"type": "PERSON"
			},
			{
				"name": "Governments",
				"salience": 0.0018828451,
				"type": "ORGANIZATION"
			},
			{
				"name": "procurer",
				"salience": 0.0018255714,
				"type": "OTHER"
			},
			{
				"name": "farm",
				"salience": 0.0017648315,
				"type": "LOCATION"
			},
			{
				"name": "pig farm",
				"salience": 0.0017648315,
				"type": "LOCATION"
			},
			{
				"name": "technology",
				"salience": 0.0017648315,
				"type": "OTHER"
			},
			{
				"name": "sex-trade workers",
				"salience": 0.0017648315,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.0017492245,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01l4l4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Physical_Laboratory_(United_Kingdom)"
				},
				"name": "National Physical Laboratory",
				"salience": 0.0017438857,
				"type": "ORGANIZATION"
			},
			{
				"name": "patent application",
				"salience": 0.0017000345,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0017000345,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0017000345,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0017000345,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0017000345,
				"type": "ORGANIZATION"
			},
			{
				"name": "application",
				"salience": 0.0017000345,
				"type": "OTHER"
			},
			{
				"name": "McConnell Plum City",
				"salience": 0.0016631669,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0016304082,
				"type": "OTHER"
			},
			{
				"name": "Voting Machines",
				"salience": 0.0016292696,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.0015549135,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Director",
				"salience": 0.0015549135,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.0015549135,
				"type": "OTHER"
			},
			{
				"name": "Types of Exercise Workshop",
				"salience": 0.0015535934,
				"type": "EVENT"
			},
			{
				"name": "Serco 8",
				"salience": 0.0015456129,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025smhq"
				},
				"name": "Brian",
				"salience": 0.0015091748,
				"type": "PERSON"
			},
			{
				"name": "defence counsel",
				"salience": 0.0014908821,
				"type": "PERSON"
			},
			{
				"name": "Voting Machines",
				"salience": 0.0014720958,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "voting machines",
				"salience": 0.0014720958,
				"type": "OTHER"
			},
			{
				"name": "nationless",
				"salience": 0.0014720958,
				"type": "OTHER"
			},
			{
				"name": "pig-farm network",
				"salience": 0.0014720958,
				"type": "OTHER"
			},
			{
				"name": "flow-chart",
				"salience": 0.0014720958,
				"type": "OTHER"
			},
			{
				"name": "exercises",
				"salience": 0.0014536706,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0014451407,
				"type": "OTHER"
			},
			{
				"name": "combat service support",
				"salience": 0.001379816,
				"type": "OTHER"
			},
			{
				"name": "military disciplines",
				"salience": 0.001379816,
				"type": "OTHER"
			},
			{
				"name": "mentors",
				"salience": 0.001379816,
				"type": "PERSON"
			},
			{
				"name": "Field",
				"salience": 0.001379816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01bkk6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_key_infrastructure"
				},
				"name": "PKI",
				"salience": 0.0013757002,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0013668063,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.001366633,
				"type": "ORGANIZATION"
			},
			{
				"name": "Concern",
				"salience": 0.0013452602,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.0013388642,
				"type": "PERSON"
			},
			{
				"name": "mass snuff film",
				"salience": 0.0013173013,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0013138745,
				"type": "LOCATION"
			},
			{
				"name": "PGPubs) Classification Services",
				"salience": 0.00128355,
				"type": "ORGANIZATION"
			},
			{
				"name": "action",
				"salience": 0.0012747066,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0012747066,
				"type": "LOCATION"
			},
			{
				"name": "administration",
				"salience": 0.0012747066,
				"type": "ORGANIZATION"
			},
			{
				"name": "quest",
				"salience": 0.0012747066,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0012747066,
				"type": "OTHER"
			},
			{
				"name": "ground combat",
				"salience": 0.0012747066,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0012747066,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0012747066,
				"type": "LOCATION"
			},
			{
				"name": "courses",
				"salience": 0.0012747066,
				"type": "OTHER"
			},
			{
				"name": "maniac",
				"salience": 0.0012747066,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.0012017558,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0011509199,
				"type": "LOCATION"
			},
			{
				"name": "finger",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "Shareholders",
				"salience": 0.0011509199,
				"type": "PERSON"
			},
			{
				"name": "website",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "Media Coverage",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "Gold",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "killer",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "List",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "enemy capabilities",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "street walkers",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "prostitutes",
				"salience": 0.0011509199,
				"type": "PERSON"
			},
			{
				"name": "drug",
				"salience": 0.0011509199,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "dispute",
				"salience": 0.0011509199,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0011213943,
				"type": "OTHER"
			},
			{
				"name": "Defense Ammunition Center",
				"salience": 0.001086251,
				"type": "ORGANIZATION"
			},
			{
				"name": "changes",
				"salience": 0.0010753784,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0010329009,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0010201201,
				"type": "PERSON"
			},
			{
				"name": "McConnell -- Global Operations",
				"salience": 0.001003497,
				"type": "ORGANIZATION"
			},
			{
				"name": "Concern Grows Over Soros",
				"salience": 0.001003497,
				"type": "OTHER"
			},
			{
				"name": "Gina Houston",
				"salience": 0.0010032125,
				"type": "PERSON"
			},
			{
				"name": "ransom",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "keys",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "bonus",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0009965824,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "Subsidiaries",
				"salience": 0.0009965824,
				"type": "ORGANIZATION"
			},
			{
				"name": "actors",
				"salience": 0.0009965824,
				"type": "PERSON"
			},
			{
				"name": "general",
				"salience": 0.0009965824,
				"type": "PERSON"
			},
			{
				"name": "human history",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "Teachers",
				"salience": 0.0009965824,
				"type": "PERSON"
			},
			{
				"name": "revelations",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "child pornography",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "aviation",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0009965824,
				"type": "OTHER"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0009482703,
				"type": "PERSON"
			},
			{
				"name": "farm",
				"salience": 0.00094191585,
				"type": "LOCATION"
			},
			{
				"name": "battleground states",
				"salience": 0.0009357757,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hkqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_Martin"
				},
				"name": "Lockheed Martin",
				"salience": 0.00093280885,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fee status",
				"salience": 0.0009123371,
				"type": "OTHER"
			},
			{
				"name": "voting station",
				"salience": 0.0009123371,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0009123371,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0009098176,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/068bb9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Star_(magazine)"
				},
				"name": "Star",
				"salience": 0.0008876425,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0008770026,
				"type": "ORGANIZATION"
			},
			{
				"name": "E-Mail Server Company",
				"salience": 0.0008770026,
				"type": "ORGANIZATION"
			},
			{
				"name": "Willie",
				"salience": 0.0008626911,
				"type": "PERSON"
			},
			{
				"name": "Source",
				"salience": 0.000857445,
				"type": "ORGANIZATION"
			},
			{
				"name": "Starnet",
				"salience": 0.00084923423,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0712bf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_patent_law"
				},
				"name": "Pre-Grant Publication",
				"salience": 0.00084923423,
				"type": "ORGANIZATION"
			},
			{
				"name": "progress",
				"salience": 0.00084397924,
				"type": "OTHER"
			},
			{
				"name": "COMMENTS",
				"salience": 0.0008388737,
				"type": "WORK_OF_ART"
			},
			{
				"name": "team",
				"salience": 0.000830241,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00082430674,
				"type": "OTHER"
			},
			{
				"name": "coat-check girl",
				"salience": 0.00082283927,
				"type": "PERSON"
			},
			{
				"name": "loan",
				"salience": 0.0008142077,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0007973066,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.0007973066,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0007845986,
				"type": "PERSON"
			},
			{
				"name": "Federal Bridge Certification Authority",
				"salience": 0.0007845324,
				"type": "ORGANIZATION"
			},
			{
				"name": "Serco Processes 2 Millionth Patent Application",
				"salience": 0.0007845324,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021psw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Citizenship_and_Immigration_Services"
				},
				"name": "USCIS",
				"salience": 0.00078414386,
				"type": "ORGANIZATION"
			},
			{
				"name": "invention",
				"salience": 0.0007808007,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.000774961,
				"type": "ORGANIZATION"
			},
			{
				"name": "host processor",
				"salience": 0.00075137964,
				"type": "OTHER"
			},
			{
				"name": "vendors",
				"salience": 0.0007434424,
				"type": "ORGANIZATION"
			},
			{
				"name": "pass",
				"salience": 0.0007421748,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.0007361754,
				"type": "LOCATION"
			},
			{
				"name": "dollar loan",
				"salience": 0.0007263716,
				"type": "OTHER"
			},
			{
				"name": "consulting firms",
				"salience": 0.0007263716,
				"type": "ORGANIZATION"
			},
			{
				"name": "work",
				"salience": 0.0007263716,
				"type": "OTHER"
			},
			{
				"name": "Loans",
				"salience": 0.0007263716,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.0007263716,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.0007263716,
				"type": "OTHER"
			},
			{
				"name": "government loans",
				"salience": 0.0007263716,
				"type": "OTHER"
			},
			{
				"name": "Sereena Abotsway",
				"salience": 0.00071817724,
				"type": "PERSON"
			},
			{
				"name": "Information Security Planning",
				"salience": 0.0007165053,
				"type": "OTHER"
			},
			{
				"name": "items",
				"salience": 0.0007151846,
				"type": "OTHER"
			},
			{
				"name": "PKIs",
				"salience": 0.00070954557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0178g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing"
				},
				"name": "Boeing",
				"salience": 0.0007083358,
				"type": "ORGANIZATION"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0007083358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0007083358,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ftvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Little_Rock,_Arkansas"
				},
				"name": "Little Rock",
				"salience": 0.0007083358,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.0006996938,
				"type": "OTHER"
			},
			{
				"name": "Names",
				"salience": 0.0006996938,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.0006996938,
				"type": "OTHER"
			},
			{
				"name": "contest",
				"salience": 0.0006996938,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0xnh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Prince_Andrew,_Duke_of_York"
				},
				"name": "Andrew",
				"salience": 0.00069136254,
				"type": "PERSON"
			},
			{
				"name": "bed",
				"salience": 0.0006884816,
				"type": "OTHER"
			},
			{
				"name": "data entry device",
				"salience": 0.0006818487,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/05d2y1g"
				},
				"name": "Robert",
				"salience": 0.0006770695,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03clxlz"
				},
				"name": "Dave",
				"salience": 0.0006770695,
				"type": "PERSON"
			},
			{
				"name": "election systems",
				"salience": 0.00067102845,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00067102845,
				"type": "OTHER"
			},
			{
				"name": "Publication number",
				"salience": 0.00067102845,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.00067102845,
				"type": "OTHER"
			},
			{
				"name": "Grant Application number",
				"salience": 0.00067102845,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00067102845,
				"type": "OTHER"
			},
			{
				"name": "firms",
				"salience": 0.0006687817,
				"type": "ORGANIZATION"
			},
			{
				"name": "units",
				"salience": 0.00066122663,
				"type": "OTHER"
			},
			{
				"name": "directors",
				"salience": 0.0006563901,
				"type": "PERSON"
			},
			{
				"name": "women engineer",
				"salience": 0.00065244205,
				"type": "PERSON"
			},
			{
				"name": "device",
				"salience": 0.0006399479,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "e-mails",
				"salience": 0.0006399479,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protocol",
				"salience": 0.0006399479,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.0006399479,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "voting pad input device",
				"salience": 0.0006399479,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "E-Mails",
				"salience": 0.0006399479,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00063961366,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.00063653785,
				"type": "OTHER"
			},
			{
				"name": "conservatives",
				"salience": 0.0006318819,
				"type": "PERSON"
			},
			{
				"name": "BREAKING",
				"salience": 0.00061821134,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0006157317,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04mn99",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AXA"
				},
				"name": "AXA",
				"salience": 0.0006133368,
				"type": "ORGANIZATION"
			},
			{
				"name": "Edmund Kozak",
				"salience": 0.0006133368,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01frpd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northrop_Grumman"
				},
				"name": "Northrop Grumman",
				"salience": 0.0006133368,
				"type": "ORGANIZATION"
			},
			{
				"name": "Starnet Raid",
				"salience": 0.0006133368,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0yb_v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chappaqua,_New_York"
				},
				"name": "Chappaqua",
				"salience": 0.0006133368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0006133368,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ky8y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raytheon"
				},
				"name": "Raytheon",
				"salience": 0.0006133368,
				"type": "ORGANIZATION"
			},
			{
				"name": "Scandal Supercut Copy",
				"salience": 0.0006133368,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "CA",
				"salience": 0.0006133368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Arkansas",
				"salience": 0.0006133368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.0006133368,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "U.N.",
				"salience": 0.0006133368,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0006133368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016mgj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Murder_of_JonBen%C3%A9t_Ramsey"
				},
				"name": "JonBenet",
				"salience": 0.0006133368,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.00061041926,
				"type": "OTHER"
			},
			{
				"name": "premises",
				"salience": 0.000607692,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0006058536,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0006058536,
				"type": "EVENT"
			},
			{
				"name": "flow-chart",
				"salience": 0.0006058536,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0006058536,
				"type": "OTHER"
			},
			{
				"name": "engineering",
				"salience": 0.000600902,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.00059554446,
				"type": "PERSON"
			},
			{
				"name": "Sex crimes",
				"salience": 0.00059554446,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0005918824,
				"type": "ORGANIZATION"
			},
			{
				"name": "e-mail server company",
				"salience": 0.0005918824,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04570",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joule"
				},
				"name": "K.J.",
				"salience": 0.00059086183,
				"type": "OTHER"
			},
			{
				"name": "considerations",
				"salience": 0.00058920874,
				"type": "OTHER"
			},
			{
				"name": "South City Slam",
				"salience": 0.000586263,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.0005836397,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.00057628326,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.00057290716,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00056786515,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mainstream media",
				"salience": 0.00056786515,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00056786515,
				"type": "WORK_OF_ART"
			},
			{
				"name": "voting equipment",
				"salience": 0.00056786515,
				"type": "OTHER"
			},
			{
				"name": "HeiTech Services, Inc.",
				"salience": 0.00056745345,
				"type": "ORGANIZATION"
			},
			{
				"name": "reputation",
				"salience": 0.0005631585,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0005589463,
				"type": "OTHER"
			},
			{
				"name": "minority professionals",
				"salience": 0.00055781717,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0005483415,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0005380917,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0005360732,
				"type": "OTHER"
			},
			{
				"name": "pig farm",
				"salience": 0.00053573394,
				"type": "LOCATION"
			},
			{
				"name": "procurer",
				"salience": 0.0005267628,
				"type": "OTHER"
			},
			{
				"name": "voter input",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0005245968,
				"type": "EVENT"
			},
			{
				"name": "accuracy",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "options",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "paper template",
				"salience": 0.0005245968,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "options",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "voting options",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "Assignee",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0005245968,
				"type": "PERSON"
			},
			{
				"name": "Events",
				"salience": 0.0005245968,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "Assignment",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0005245968,
				"type": "EVENT"
			},
			{
				"name": "mission",
				"salience": 0.0005245968,
				"type": "OTHER"
			},
			{
				"name": "research team",
				"salience": 0.0005226444,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0005221275,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.0005160566,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0005114554,
				"type": "OTHER"
			},
			{
				"name": "workshop",
				"salience": 0.00050922943,
				"type": "EVENT"
			},
			{
				"name": "farm",
				"salience": 0.00050922943,
				"type": "LOCATION"
			},
			{
				"name": "farm",
				"salience": 0.00050922943,
				"type": "LOCATION"
			},
			{
				"name": "sex-trade workers",
				"salience": 0.00050922943,
				"type": "PERSON"
			},
			{
				"name": "complexity",
				"salience": 0.00050190324,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.0004945676,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00049052545,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00049052545,
				"type": "OTHER"
			},
			{
				"name": "government loans",
				"salience": 0.00049021497,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00049021497,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gndv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zulu_language"
				},
				"name": "Zulu",
				"salience": 0.00048848643,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00048848643,
				"type": "LOCATION"
			},
			{
				"name": "stuff",
				"salience": 0.0004775453,
				"type": "OTHER"
			},
			{
				"name": "@HillaryClinton",
				"salience": 0.00047692907,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03m3svm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Mail_on_Sunday"
				},
				"name": "Mail on Sunday",
				"salience": 0.00047548622,
				"type": "ORGANIZATION"
			},
			{
				"name": "capacity",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "preparation",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "Classifications",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "Citation",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "codes",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0004736422,
				"type": "PERSON"
			},
			{
				"name": "condo",
				"salience": 0.0004736422,
				"type": "LOCATION"
			},
			{
				"name": "providers",
				"salience": 0.0004736422,
				"type": "ORGANIZATION"
			},
			{
				"name": "cover",
				"salience": 0.0004736422,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0004736422,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.0004722093,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0004722093,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00047042812,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00047042812,
				"type": "OTHER"
			},
			{
				"name": "plane",
				"salience": 0.00047042812,
				"type": "OTHER"
			},
			{
				"name": "outreach worker",
				"salience": 0.0004571077,
				"type": "PERSON"
			},
			{
				"name": "visas",
				"salience": 0.00045428931,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0004525459,
				"type": "OTHER"
			},
			{
				"name": "police interview",
				"salience": 0.00044863758,
				"type": "EVENT"
			},
			{
				"name": "Consumer groups",
				"salience": 0.0004466818,
				"type": "ORGANIZATION"
			},
			{
				"name": "billions",
				"salience": 0.00044349927,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.00044254801,
				"type": "EVENT"
			},
			{
				"name": "participants",
				"salience": 0.0004383505,
				"type": "PERSON"
			},
			{
				"name": "e-mails",
				"salience": 0.00043188533,
				"type": "OTHER"
			},
			{
				"name": "TSymmetry, Inc.",
				"salience": 0.00043088812,
				"type": "ORGANIZATION"
			},
			{
				"name": "Serco , Inc.",
				"salience": 0.00043088812,
				"type": "ORGANIZATION"
			},
			{
				"name": "defence counsel",
				"salience": 0.0004301564,
				"type": "PERSON"
			},
			{
				"name": "procedures",
				"salience": 0.00043000258,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.00043000258,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0004282344,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08_ykc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Small_Business_Administration"
				},
				"name": "Small Business Administration",
				"salience": 0.00042516415,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.00042473426,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.00042473426,
				"type": "PERSON"
			},
			{
				"name": "participants",
				"salience": 0.00042473426,
				"type": "PERSON"
			},
			{
				"name": "shooting investigation",
				"salience": 0.00042473426,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.00042473426,
				"type": "OTHER"
			},
			{
				"name": "pass",
				"salience": 0.00041938046,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0004192305,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0155qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_Corps_Base_Camp_Pendleton"
				},
				"name": "Camp Pendleton",
				"salience": 0.00041920916,
				"type": "LOCATION"
			},
			{
				"name": "work",
				"salience": 0.00041568946,
				"type": "OTHER"
			},
			{
				"name": "pig farm",
				"salience": 0.00041568946,
				"type": "LOCATION"
			},
			{
				"name": "talent pool",
				"salience": 0.00041354293,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.0004101152,
				"type": "ORGANIZATION"
			},
			{
				"name": "office space",
				"salience": 0.0004101152,
				"type": "LOCATION"
			},
			{
				"name": "tips",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "spokesperson",
				"salience": 0.0004101152,
				"type": "PERSON"
			},
			{
				"name": "Links",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "geometry",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "pictures",
				"salience": 0.0004101152,
				"type": "WORK_OF_ART"
			},
			{
				"name": "symbols",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "selection",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "reusability",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "durability",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "reliability",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "deployment",
				"salience": 0.0004101152,
				"type": "EVENT"
			},
			{
				"name": "simplicity",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "functions",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "photo",
				"salience": 0.0004101152,
				"type": "WORK_OF_ART"
			},
			{
				"name": "use",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "embodiment",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.0004101152,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.0004101152,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00040887445,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00040887445,
				"type": "LOCATION"
			},
			{
				"name": "victims",
				"salience": 0.00040887445,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.00040887445,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0n5zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Component_Object_Model"
				},
				"name": "COM",
				"salience": 0.00040792522,
				"type": "OTHER"
			},
			{
				"name": "contracts",
				"salience": 0.00040042074,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00040042074,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00039810096,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.00039810096,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00039810096,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00039810096,
				"type": "OTHER"
			},
			{
				"name": "trailer",
				"salience": 0.00039810096,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stand",
				"salience": 0.00039810096,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.00039810096,
				"type": "ORGANIZATION"
			},
			{
				"name": "source",
				"salience": 0.00039810096,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.00039810096,
				"type": "PERSON"
			},
			{
				"name": "trailer",
				"salience": 0.00039810096,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.00039810096,
				"type": "PERSON"
			},
			{
				"name": "NVC",
				"salience": 0.00039313087,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.00039038964,
				"type": "ORGANIZATION"
			},
			{
				"name": "status",
				"salience": 0.00039000355,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00039000355,
				"type": "LOCATION"
			},
			{
				"name": "plans",
				"salience": 0.00038401465,
				"type": "OTHER"
			},
			{
				"name": "high frequency trading",
				"salience": 0.00038401465,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00038401465,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00038323554,
				"type": "WORK_OF_ART"
			},
			{
				"name": "presence",
				"salience": 0.00038323554,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.00038323554,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00038323554,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.00038176478,
				"type": "OTHER"
			},
			{
				"name": "information security policies",
				"salience": 0.00038075243,
				"type": "OTHER"
			},
			{
				"name": "biker club colours",
				"salience": 0.00038005898,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0003748964,
				"type": "ORGANIZATION"
			},
			{
				"name": "US20070007340 Inventors",
				"salience": 0.00037284865,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0003724612,
				"type": "OTHER"
			},
			{
				"name": "limit",
				"salience": 0.0003705379,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.00037004787,
				"type": "PERSON"
			},
			{
				"name": "box",
				"salience": 0.00036776622,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.00036776622,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.00036776622,
				"type": "OTHER"
			},
			{
				"name": "trips",
				"salience": 0.00036776622,
				"type": "EVENT"
			},
			{
				"name": "Court",
				"salience": 0.00036776622,
				"type": "ORGANIZATION"
			},
			{
				"name": "maniac",
				"salience": 0.00036776622,
				"type": "OTHER"
			},
			{
				"name": "willingness",
				"salience": 0.00036776622,
				"type": "OTHER"
			},
			{
				"name": "criminals",
				"salience": 0.00036776622,
				"type": "PERSON"
			},
			{
				"name": "exchange",
				"salience": 0.00036776622,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00036776622,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.0003662264,
				"type": "OTHER"
			},
			{
				"name": "buzz",
				"salience": 0.00036586716,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.00036476026,
				"type": "OTHER"
			},
			{
				"name": "Super Serco",
				"salience": 0.00036403502,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03cn2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_Communications_Headquarters"
				},
				"name": "GCHQ",
				"salience": 0.00035797877,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00035784257,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fynw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secret_Service"
				},
				"name": "Secret Service",
				"salience": 0.00035649032,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.0003540334,
				"type": "OTHER"
			},
			{
				"name": "accusers",
				"salience": 0.0003540334,
				"type": "PERSON"
			},
			{
				"name": "jet",
				"salience": 0.0003540334,
				"type": "OTHER"
			},
			{
				"name": "child rape",
				"salience": 0.0003540334,
				"type": "EVENT"
			},
			{
				"name": "trips",
				"salience": 0.0003540334,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.0003540334,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0003540334,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.0003540334,
				"type": "EVENT"
			},
			{
				"name": "TRIPS",
				"salience": 0.0003540334,
				"type": "EVENT"
			},
			{
				"name": "flights",
				"salience": 0.0003540334,
				"type": "EVENT"
			},
			{
				"name": "request",
				"salience": 0.0003540334,
				"type": "OTHER"
			},
			{
				"name": "manifests",
				"salience": 0.0003540334,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0003540334,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.00035378605,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.00035378605,
				"type": "OTHER"
			},
			{
				"name": "group sex",
				"salience": 0.0003527157,
				"type": "OTHER"
			},
			{
				"name": "flyer",
				"salience": 0.00035220524,
				"type": "OTHER"
			},
			{
				"name": "Steve Remian",
				"salience": 0.00035022205,
				"type": "PERSON"
			},
			{
				"name": "US7537159 B2 Publication",
				"salience": 0.00034946852,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Profit growth",
				"salience": 0.00034932644,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.00034671344,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00034671344,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.00034671344,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.00034671344,
				"type": "OTHER"
			},
			{
				"name": "cocktail-gown kind",
				"salience": 0.00034492306,
				"type": "OTHER"
			},
			{
				"name": "DNA",
				"salience": 0.00034057518,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0003401248,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.00033651723,
				"type": "PERSON"
			},
			{
				"name": "SSL protocol",
				"salience": 0.00033293688,
				"type": "OTHER"
			},
			{
				"name": "jurors",
				"salience": 0.00033204313,
				"type": "PERSON"
			},
			{
				"name": "suitcase",
				"salience": 0.00033204313,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "jurors",
				"salience": 0.00033204313,
				"type": "PERSON"
			},
			{
				"name": "murder trial",
				"salience": 0.00033204313,
				"type": "EVENT"
			},
			{
				"name": "DNA testing",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "favors",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "murder trial",
				"salience": 0.00033204313,
				"type": "EVENT"
			},
			{
				"name": "thing",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "arrest",
				"salience": 0.00033204313,
				"type": "EVENT"
			},
			{
				"name": "drug",
				"salience": 0.00033204313,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "woman",
				"salience": 0.00033204313,
				"type": "PERSON"
			},
			{
				"name": "fellatio",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "street walkers",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "prostitutes",
				"salience": 0.00033204313,
				"type": "PERSON"
			},
			{
				"name": "dispute",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "items",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "code",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "bed",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "killer",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.00033204313,
				"type": "OTHER"
			},
			{
				"name": "condoms",
				"salience": 0.00033204313,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Government",
				"salience": 0.00033127,
				"type": "ORGANIZATION"
			},
			{
				"name": "rigour",
				"salience": 0.00033055947,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.00032497197,
				"type": "ORGANIZATION"
			},
			{
				"name": "City",
				"salience": 0.00032497197,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.00032497197,
				"type": "ORGANIZATION"
			},
			{
				"name": "economy",
				"salience": 0.00032497197,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00032497197,
				"type": "OTHER"
			},
			{
				"name": "Base One",
				"salience": 0.0003242012,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02631vg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monkey_Business_(TV_series)"
				},
				"name": "Monkey Business",
				"salience": 0.00032417214,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contacteditor@gotnews.com",
				"salience": 0.0003228391,
				"type": "OTHER"
			},
			{
				"name": "@gotnews.com",
				"salience": 0.0003228391,
				"type": "PERSON"
			},
			{
				"name": "GotNews.com/donate",
				"salience": 0.0003228391,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x6r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angel"
				},
				"name": "Angel",
				"salience": 0.000322642,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.00032118836,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00032050448,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "favors",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "massage",
				"salience": 0.0003196441,
				"type": "WORK_OF_ART"
			},
			{
				"name": "island",
				"salience": 0.0003196441,
				"type": "LOCATION"
			},
			{
				"name": "prison",
				"salience": 0.0003196441,
				"type": "LOCATION"
			},
			{
				"name": "friends",
				"salience": 0.0003196441,
				"type": "PERSON"
			},
			{
				"name": "flight logs",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.0003196441,
				"type": "LOCATION"
			},
			{
				"name": "kind",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "suits",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "house arrest",
				"salience": 0.0003196441,
				"type": "EVENT"
			},
			{
				"name": "most",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.0003196441,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.0003196441,
				"type": "LOCATION"
			},
			{
				"name": "allegations",
				"salience": 0.0003196441,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00031852827,
				"type": "OTHER"
			},
			{
				"name": "cryptographic engineering",
				"salience": 0.00031465996,
				"type": "OTHER"
			},
			{
				"name": "rap",
				"salience": 0.00031420458,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vywh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Freedom_Center"
				},
				"name": "Freedom Center",
				"salience": 0.00031338137,
				"type": "LOCATION"
			},
			{
				"name": "firms",
				"salience": 0.0003104969,
				"type": "ORGANIZATION"
			},
			{
				"name": "firm",
				"salience": 0.0003104969,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.0003104969,
				"type": "ORGANIZATION"
			},
			{
				"name": "veteran firms",
				"salience": 0.0003104969,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.0003104969,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.0003104969,
				"type": "ORGANIZATION"
			},
			{
				"name": "cutting edge solutions",
				"salience": 0.00030663385,
				"type": "OTHER"
			},
			{
				"name": "invention",
				"salience": 0.0003034274,
				"type": "OTHER"
			},
			{
				"name": "caesium fountain atomic clock",
				"salience": 0.0003024716,
				"type": "OTHER"
			},
			{
				"name": "order book",
				"salience": 0.0003024716,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01wlmc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Port_Coquitlam"
				},
				"name": "Port Coquitlam",
				"salience": 0.0003016508,
				"type": "LOCATION"
			},
			{
				"name": "another",
				"salience": 0.00030020904,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.00030020904,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00030020904,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00030020904,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00030020904,
				"type": "ORGANIZATION"
			},
			{
				"name": "sign",
				"salience": 0.00030020904,
				"type": "OTHER"
			},
			{
				"name": "exercise tempo",
				"salience": 0.00030020904,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.00030020904,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.00030020904,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03l2n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houston"
				},
				"name": "Houston",
				"salience": 0.0002991785,
				"type": "LOCATION"
			},
			{
				"name": "diversity",
				"salience": 0.00029909165,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.00029909165,
				"type": "PERSON"
			},
			{
				"name": "engineers",
				"salience": 0.00029909165,
				"type": "PERSON"
			},
			{
				"name": "diversity",
				"salience": 0.00029909165,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.00029909165,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.00029909165,
				"type": "EVENT"
			},
			{
				"name": "access",
				"salience": 0.000298952,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.000298952,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.00029735884,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.000294894,
				"type": "OTHER"
			},
			{
				"name": "Soros' Open Society Foundations",
				"salience": 0.0002914796,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03b_pxn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Association_of_Secretaries_of_State"
				},
				"name": "National Association of Secretaries of State",
				"salience": 0.0002914796,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ref Man Patent Citations",
				"salience": 0.0002914796,
				"type": "OTHER"
			},
			{
				"name": "GotNews",
				"salience": 0.0002914796,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.00029029578,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.00028899862,
				"type": "OTHER"
			},
			{
				"name": "applicant",
				"salience": 0.00028792297,
				"type": "PERSON"
			},
			{
				"name": "trace",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "syringes",
				"salience": 0.00028750626,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hairs",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "blanket",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "motorhome",
				"salience": 0.00028750626,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "rosary",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "sexual assault",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "label",
				"salience": 0.00028750626,
				"type": "ORGANIZATION"
			},
			{
				"name": "hive",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "suicide-by-cop",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "lipstick",
				"salience": 0.00028750626,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vehicles",
				"salience": 0.00028750626,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "clothing",
				"salience": 0.00028750626,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "anyone",
				"salience": 0.00028750626,
				"type": "PERSON"
			},
			{
				"name": "child rapist",
				"salience": 0.00028750626,
				"type": "PERSON"
			},
			{
				"name": "conversation",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.00028750626,
				"type": "OTHER"
			},
			{
				"name": "Lolita Express",
				"salience": 0.00028692654,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00028683685,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00028683685,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00028683685,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00028683685,
				"type": "PERSON"
			},
			{
				"name": "Women",
				"salience": 0.00028683685,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.00028683685,
				"type": "OTHER"
			},
			{
				"name": "nightclub",
				"salience": 0.00028515625,
				"type": "LOCATION"
			},
			{
				"name": "team",
				"salience": 0.00028429352,
				"type": "ORGANIZATION"
			},
			{
				"name": "Office of Partner Relations",
				"salience": 0.00028331808,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0002815617,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ryjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cabinet_Office"
				},
				"name": "UK Cabinet Office",
				"salience": 0.00028079966,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.0002782068,
				"type": "OTHER"
			},
			{
				"name": "vendors",
				"salience": 0.0002782068,
				"type": "ORGANIZATION"
			},
			{
				"name": "prince",
				"salience": 0.00027801242,
				"type": "PERSON"
			},
			{
				"name": "junkets",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "occasions",
				"salience": 0.00027677018,
				"type": "EVENT"
			},
			{
				"name": "government bureaucrats",
				"salience": 0.00027677018,
				"type": "PERSON"
			},
			{
				"name": "term",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "anonymity",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "sex toy",
				"salience": 0.00027677018,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cash payment",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "sex slave",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "sex offender",
				"salience": 0.00027677018,
				"type": "PERSON"
			},
			{
				"name": "sex acts",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "pretense",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "co-accused",
				"salience": 0.00027677018,
				"type": "PERSON"
			},
			{
				"name": "feds",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.00027677018,
				"type": "EVENT"
			},
			{
				"name": "friendly",
				"salience": 0.00027677018,
				"type": "EVENT"
			},
			{
				"name": "example",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "CHILD RAPE JET MATTER",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "nickname",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "initials",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "jets",
				"salience": 0.00027677018,
				"type": "OTHER"
			},
			{
				"name": "rape accusations",
				"salience": 0.00027469985,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00027354964,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00027209183,
				"type": "PERSON"
			},
			{
				"name": "prisons",
				"salience": 0.00027104755,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00027104755,
				"type": "EVENT"
			},
			{
				"name": "property",
				"salience": 0.00027104755,
				"type": "LOCATION"
			},
			{
				"name": "goodwill",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"name": "innovation",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"name": "goodbye",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00027104755,
				"type": "EVENT"
			},
			{
				"name": "innovation",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"name": "management",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00027104755,
				"type": "LOCATION"
			},
			{
				"name": "decision making",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"name": "Table Top",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"name": "breadth",
				"salience": 0.00027104755,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018ldw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oakville,_Ontario"
				},
				"name": "Oakville",
				"salience": 0.00026910417,
				"type": "LOCATION"
			},
			{
				"name": "flight logs",
				"salience": 0.00026763082,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.00026719435,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.0002669211,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00026643494,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013r60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hells_Angels"
				},
				"name": "Hells Angels",
				"salience": 0.00026337325,
				"type": "ORGANIZATION"
			},
			{
				"name": "ways",
				"salience": 0.00026272846,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00026272846,
				"type": "OTHER"
			},
			{
				"name": "implementation",
				"salience": 0.000260926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02t27n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_of_Information_Act_(United_States)"
				},
				"name": "Freedom of Information Act",
				"salience": 0.00025905517,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jrxx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palm_Beach_County,_Florida"
				},
				"name": "Palm Beach",
				"salience": 0.00025905517,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00025897418,
				"type": "LOCATION"
			},
			{
				"name": "community organizations",
				"salience": 0.00025897418,
				"type": "ORGANIZATION"
			},
			{
				"name": "IT professionals",
				"salience": 0.00025897418,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.00025897418,
				"type": "ORGANIZATION"
			},
			{
				"name": "professionals",
				"salience": 0.00025897418,
				"type": "PERSON"
			},
			{
				"name": "Centre of Carbon Measurement",
				"salience": 0.00025581362,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0002523831,
				"type": "PERSON"
			},
			{
				"name": "Antonio Mugica",
				"salience": 0.0002523831,
				"type": "PERSON"
			},
			{
				"name": "Smartmatic International Corporation Export",
				"salience": 0.0002523831,
				"type": "ORGANIZATION"
			},
			{
				"name": "BiBTeX",
				"salience": 0.0002523831,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "EndNote",
				"salience": 0.0002523831,
				"type": "OTHER"
			},
			{
				"name": "Espacenet",
				"salience": 0.0002523831,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.0002523831,
				"type": "PERSON"
			},
			{
				"name": "CHARLES C. JOHNSON",
				"salience": 0.0002523831,
				"type": "PERSON"
			},
			{
				"name": "USAspending.gov",
				"salience": 0.0002523831,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0002523831,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.0002523831,
				"type": "LOCATION"
			},
			{
				"name": "nationals",
				"salience": 0.00025085022,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.00024819683,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.00024819683,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.00024818946,
				"type": "ORGANIZATION"
			},
			{
				"name": "rise",
				"salience": 0.00024690782,
				"type": "OTHER"
			},
			{
				"name": "Kabul for COM approval",
				"salience": 0.00024646174,
				"type": "OTHER"
			},
			{
				"name": "Remian",
				"salience": 0.00024498923,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.0002448896,
				"type": "OTHER"
			},
			{
				"name": "Jeff Wells",
				"salience": 0.00024404896,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05zp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palace"
				},
				"name": "Palace",
				"salience": 0.00024330377,
				"type": "LOCATION"
			},
			{
				"name": "Piggy",
				"salience": 0.00024330377,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0002427342,
				"type": "PERSON"
			},
			{
				"name": "market",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "staffing",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "pools",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "technology research",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "pool",
				"salience": 0.0002427342,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0002427342,
				"type": "PERSON"
			},
			{
				"name": "pool",
				"salience": 0.0002427342,
				"type": "LOCATION"
			},
			{
				"name": "staff",
				"salience": 0.0002427342,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0002418026,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00024123958,
				"type": "ORGANIZATION"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.00023757608,
				"type": "WORK_OF_ART"
			},
			{
				"name": "access",
				"salience": 0.00023492184,
				"type": "OTHER"
			},
			{
				"name": "knives",
				"salience": 0.0002346914,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "achievements",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "accomplishments",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0002346914,
				"type": "PERSON"
			},
			{
				"name": "variety",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "dividends",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "defence budgets",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "farewell",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "forest bulldozers",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "denim",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.0002346914,
				"type": "LOCATION"
			},
			{
				"name": "airport radar",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "opportunities",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "leather",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "carbon emissions reductions",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "footprint",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "running banks",
				"salience": 0.0002346914,
				"type": "ORGANIZATION"
			},
			{
				"name": "environment",
				"salience": 0.0002346914,
				"type": "OTHER"
			},
			{
				"name": "information systems",
				"salience": 0.00023414493,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00023389765,
				"type": "OTHER"
			},
			{
				"name": "processes",
				"salience": 0.00023389765,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00023389765,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.00023389765,
				"type": "ORGANIZATION"
			},
			{
				"name": "Table-top exercises",
				"salience": 0.00022914338,
				"type": "OTHER"
			},
			{
				"name": "group finance director",
				"salience": 0.0002261492,
				"type": "PERSON"
			},
			{
				"name": "visas",
				"salience": 0.00022611163,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.00022611163,
				"type": "LOCATION"
			},
			{
				"name": "firm",
				"salience": 0.00022611163,
				"type": "ORGANIZATION"
			},
			{
				"name": "center",
				"salience": 0.00022611163,
				"type": "LOCATION"
			},
			{
				"name": "signature",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.00022423734,
				"type": "ORGANIZATION"
			},
			{
				"name": "technology project",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "schemes",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.00022423734,
				"type": "ORGANIZATION"
			},
			{
				"name": "diversity mix",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.00022423734,
				"type": "ORGANIZATION"
			},
			{
				"name": "IT projects",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "diversity mix",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "diversity recruiting",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.00022423734,
				"type": "OTHER"
			},
			{
				"name": "cutting edge solutions",
				"salience": 0.00022329841,
				"type": "OTHER"
			},
			{
				"name": "contractor",
				"salience": 0.00022058652,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.00021861956,
				"type": "OTHER"
			},
			{
				"name": "LOLITA EXPRESS",
				"salience": 0.00021786908,
				"type": "ORGANIZATION"
			},
			{
				"name": "applicants",
				"salience": 0.00021780583,
				"type": "PERSON"
			},
			{
				"name": "teams",
				"salience": 0.00021780583,
				"type": "ORGANIZATION"
			},
			{
				"name": "application",
				"salience": 0.00021780583,
				"type": "OTHER"
			},
			{
				"name": "visa applications",
				"salience": 0.00021780583,
				"type": "OTHER"
			},
			{
				"name": "business operations",
				"salience": 0.00020888136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.00020433591,
				"type": "OTHER"
			},
			{
				"name": "Shillman Journalism Fellow",
				"salience": 0.00020433591,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01d26y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Burnaby"
				},
				"name": "Burnaby",
				"salience": 0.00020433591,
				"type": "LOCATION"
			},
			{
				"name": "scenario",
				"salience": 0.00020412357,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0002039213,
				"type": "ORGANIZATION"
			},
			{
				"name": "components",
				"salience": 0.0002039213,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "spectrum",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "relationships",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "government implementations",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "recognition",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00020245506,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "diversity talent",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "Strategy",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00020245506,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00020245506,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0002010811,
				"type": "OTHER"
			},
			{
				"name": "discoveries",
				"salience": 0.00020067311,
				"type": "EVENT"
			},
			{
				"name": "director",
				"salience": 0.00019920507,
				"type": "PERSON"
			},
			{
				"name": "deputy director",
				"salience": 0.00019920507,
				"type": "PERSON"
			},
			{
				"name": "solutions",
				"salience": 0.00019920507,
				"type": "OTHER"
			},
			{
				"name": "risk analysis",
				"salience": 0.00019920507,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mlk2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing_727"
				},
				"name": "Boeing 727",
				"salience": 0.00019670537,
				"type": "OTHER"
			},
			{
				"name": "GotNews",
				"salience": 0.00019670537,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.00019604342,
				"type": "PERSON"
			},
			{
				"name": "communications",
				"salience": 0.00019505371,
				"type": "OTHER"
			},
			{
				"name": "communication",
				"salience": 0.00019505371,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00019505371,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00019505371,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00019505371,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.00019402387,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dth9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Information_Systems_Agency"
				},
				"name": "Defense Information Systems Agency",
				"salience": 0.00019363264,
				"type": "ORGANIZATION"
			},
			{
				"name": "file",
				"salience": 0.00018859067,
				"type": "OTHER"
			},
			{
				"name": "Information Security Counter",
				"salience": 0.00018859067,
				"type": "ORGANIZATION"
			},
			{
				"name": "files",
				"salience": 0.00018859067,
				"type": "OTHER"
			},
			{
				"name": "visa files",
				"salience": 0.00018859067,
				"type": "OTHER"
			},
			{
				"name": "hub zone location",
				"salience": 0.00018774795,
				"type": "LOCATION"
			},
			{
				"name": "Piggy Palace",
				"salience": 0.00018474481,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.00018474481,
				"type": "ORGANIZATION"
			},
			{
				"name": "surplus",
				"salience": 0.00018442387,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00018075784,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00018018999,
				"type": "ORGANIZATION"
			},
			{
				"name": "role",
				"salience": 0.00017902085,
				"type": "OTHER"
			},
			{
				"name": "Brenda Wolfe",
				"salience": 0.00017692741,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vqq1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Westminster"
				},
				"name": "New Westminster",
				"salience": 0.00017692741,
				"type": "LOCATION"
			},
			{
				"name": "Hudson's Bay",
				"salience": 0.00017692741,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tanya Carr",
				"salience": 0.00017692741,
				"type": "PERSON"
			},
			{
				"name": "Mona Wilson",
				"salience": 0.00017692741,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cg_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gary_Hart"
				},
				"name": "Gary Hart",
				"salience": 0.00017692741,
				"type": "PERSON"
			},
			{
				"name": "petitions",
				"salience": 0.0001767641,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.0001767641,
				"type": "OTHER"
			},
			{
				"name": "employers",
				"salience": 0.0001767641,
				"type": "ORGANIZATION"
			},
			{
				"name": "posts",
				"salience": 0.0001767641,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contract employees",
				"salience": 0.0001767641,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0001767641,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.0001767641,
				"type": "PERSON"
			},
			{
				"name": "visa petitions",
				"salience": 0.0001767641,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0001767641,
				"type": "OTHER"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.0001767641,
				"type": "PERSON"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.0001767641,
				"type": "PERSON"
			},
			{
				"name": "infrastructure",
				"salience": 0.00017529883,
				"type": "OTHER"
			},
			{
				"name": "pioneers",
				"salience": 0.00017529883,
				"type": "PERSON"
			},
			{
				"name": "IT positions",
				"salience": 0.00017529883,
				"type": "OTHER"
			},
			{
				"name": "privacy",
				"salience": 0.00017529883,
				"type": "OTHER"
			},
			{
				"name": "scope",
				"salience": 0.00017529883,
				"type": "OTHER"
			},
			{
				"name": "IT skills",
				"salience": 0.00017529883,
				"type": "OTHER"
			},
			{
				"name": "points of view",
				"salience": 0.00017529883,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.00017470596,
				"type": "OTHER"
			},
			{
				"name": "grouping",
				"salience": 0.00017470596,
				"type": "ORGANIZATION"
			},
			{
				"name": "advantage",
				"salience": 0.00017386593,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanic",
				"salience": 0.00017032035,
				"type": "LOCATION"
			},
			{
				"name": "Nabakov",
				"salience": 0.00017032035,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01jjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balkans"
				},
				"name": "Balkan",
				"salience": 0.00017032035,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.00017032035,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "FoxNews.com",
				"salience": 0.00017032035,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00017032035,
				"type": "LOCATION"
			},
			{
				"name": "penetration testing",
				"salience": 0.00016951004,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.00016889021,
				"type": "OTHER"
			},
			{
				"name": "file number",
				"salience": 0.00016835963,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v06q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Emergency_Planning_College"
				},
				"name": "Emergency Planning College",
				"salience": 0.0001667986,
				"type": "ORGANIZATION"
			},
			{
				"name": "guidelines",
				"salience": 0.00016662526,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0158jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_service"
				},
				"name": "Civil Service",
				"salience": 0.00016442733,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02dqk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Foreign_Service"
				},
				"name": "Foreign Service",
				"salience": 0.00016442733,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02c3wh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Bar_Association"
				},
				"name": "American Bar Association",
				"salience": 0.0001640783,
				"type": "ORGANIZATION"
			},
			{
				"name": "Operating procedures",
				"salience": 0.00016396833,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.00016380864,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.00016329404,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.00016329404,
				"type": "OTHER"
			},
			{
				"name": "mail",
				"salience": 0.00016329404,
				"type": "OTHER"
			},
			{
				"name": "information technology risk",
				"salience": 0.00016329404,
				"type": "OTHER"
			},
			{
				"name": "diversity recruitment",
				"salience": 0.00016329404,
				"type": "OTHER"
			},
			{
				"name": "appointment scheduling",
				"salience": 0.00016329404,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.00016268622,
				"type": "OTHER"
			},
			{
				"name": "teamwork",
				"salience": 0.00016268622,
				"type": "OTHER"
			},
			{
				"name": "Exercises",
				"salience": 0.00016268622,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00016268622,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00016207251,
				"type": "OTHER"
			},
			{
				"name": "DKW Communications, Inc.",
				"salience": 0.00016070071,
				"type": "ORGANIZATION"
			},
			{
				"name": "BUSINESS CORPORATION",
				"salience": 0.00015708622,
				"type": "ORGANIZATION"
			},
			{
				"name": "time line",
				"salience": 0.00015638427,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.00015602013,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.00015602013,
				"type": "PERSON"
			},
			{
				"name": "planning",
				"salience": 0.00015602013,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00015602013,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.00015591111,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.00015180267,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00015122004,
				"type": "OTHER"
			},
			{
				"name": "package",
				"salience": 0.00015122004,
				"type": "OTHER"
			},
			{
				"name": "Simulation",
				"salience": 0.00014931374,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.00014879249,
				"type": "OTHER"
			},
			{
				"name": "cryptographic protocols",
				"salience": 0.00014879249,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00014879249,
				"type": "OTHER"
			},
			{
				"name": "intensity",
				"salience": 0.00014879249,
				"type": "OTHER"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.00014770107,
				"type": "ORGANIZATION"
			},
			{
				"name": "Citizenship",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "filing",
				"salience": 0.00014743148,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.00014743148,
				"type": "LOCATION"
			},
			{
				"name": "preprocessing",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "assessments",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "Information Security Expertise",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "incident documentation",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "paperwork",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "visa pre-processing",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "strategies",
				"salience": 0.00014743148,
				"type": "OTHER"
			},
			{
				"name": "designs",
				"salience": 0.00014743148,
				"type": "WORK_OF_ART"
			},
			{
				"name": "successor",
				"salience": 0.00014743148,
				"type": "PERSON"
			},
			{
				"name": "data",
				"salience": 0.00014632859,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00014557294,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00014557294,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02fvf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Docklands_Light_Railway"
				},
				"name": "Docklands Light Railway",
				"salience": 0.00014442492,
				"type": "LOCATION"
			},
			{
				"name": "Burns Rd.",
				"salience": 0.00014442492,
				"type": "LOCATION"
			},
			{
				"name": "Dominion Road",
				"salience": 0.00014442492,
				"type": "LOCATION"
			},
			{
				"name": "concurrence",
				"salience": 0.00014429161,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00014086414,
				"type": "OTHER"
			},
			{
				"name": "organisations",
				"salience": 0.00014086414,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisation",
				"salience": 0.00014086414,
				"type": "ORGANIZATION"
			},
			{
				"name": "databases",
				"salience": 0.00014086414,
				"type": "OTHER"
			},
			{
				"name": "handcuffs",
				"salience": 0.00014013669,
				"type": "OTHER"
			},
			{
				"name": "Transitional Immigrant Visa Processing Center",
				"salience": 0.00013914495,
				"type": "ORGANIZATION"
			},
			{
				"name": "Special Immigrant Visa",
				"salience": 0.00013914495,
				"type": "OTHER"
			},
			{
				"name": "Diversity Recruitment and Staffing",
				"salience": 0.0001379915,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.00013329597,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00013203039,
				"type": "PERSON"
			},
			{
				"name": "roles",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.00013203039,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "simulation support",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "Command Post",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00013203039,
				"type": "PERSON"
			},
			{
				"name": "training",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "disclosure",
				"salience": 0.00013203039,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00013093592,
				"type": "OTHER"
			},
			{
				"name": "finance director",
				"salience": 0.00012941226,
				"type": "PERSON"
			},
			{
				"name": "primitives",
				"salience": 0.00012928531,
				"type": "OTHER"
			},
			{
				"name": "military pilot",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "shelves",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "airline",
				"salience": 0.00012765551,
				"type": "ORGANIZATION"
			},
			{
				"name": "efforts",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "logging",
				"salience": 0.00012765551,
				"type": "EVENT"
			},
			{
				"name": "honey-pots",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "implements",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "Yours",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "utilization",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "Agreements",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "mentoring goals",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "fees",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "adjudication",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "fiancé",
				"salience": 0.00012765551,
				"type": "PERSON"
			},
			{
				"name": "inception",
				"salience": 0.00012765551,
				"type": "EVENT"
			},
			{
				"name": "pieces",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "file rooms",
				"salience": 0.00012765551,
				"type": "LOCATION"
			},
			{
				"name": "belief",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00012765551,
				"type": "PERSON"
			},
			{
				"name": "dreams",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "data theft",
				"salience": 0.00012765551,
				"type": "OTHER"
			},
			{
				"name": "computer hackers",
				"salience": 0.00012765551,
				"type": "PERSON"
			},
			{
				"name": "Clients",
				"salience": 0.00012765551,
				"type": "PERSON"
			},
			{
				"name": "embassies",
				"salience": 0.00012765551,
				"type": "LOCATION"
			},
			{
				"name": "advantage",
				"salience": 0.00012661204,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/028j0m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minority_group"
				},
				"name": "Minority",
				"salience": 0.00012458676,
				"type": "ORGANIZATION"
			},
			{
				"name": "Disabled Veteran",
				"salience": 0.00012458676,
				"type": "PERSON"
			},
			{
				"name": "Mentor Protégé",
				"salience": 0.00012258673,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "server authentication",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "Developments",
				"salience": 0.00012196906,
				"type": "EVENT"
			},
			{
				"name": "Web users",
				"salience": 0.00012196906,
				"type": "PERSON"
			},
			{
				"name": "projects",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "tempo",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.00012196906,
				"type": "LOCATION"
			},
			{
				"name": "developments",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "mix",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.00012196906,
				"type": "LOCATION"
			},
			{
				"name": "leadership",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.00012196906,
				"type": "ORGANIZATION"
			},
			{
				"name": "web browsers",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "authentication",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "information flow",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "training benefit",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.00012196906,
				"type": "OTHER"
			},
			{
				"name": "handling.",
				"salience": 0.00012034734,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "DHS",
				"salience": 0.000119484415,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03b9f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_jury"
				},
				"name": "Grand Juries",
				"salience": 0.00011850507,
				"type": "ORGANIZATION"
			},
			{
				"name": "problems",
				"salience": 0.00011447259,
				"type": "OTHER"
			},
			{
				"name": "Vendors",
				"salience": 0.00011302951,
				"type": "ORGANIZATION"
			},
			{
				"name": "aspects",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "algorithms",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "exercising package",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "decision making",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "entrepreneurs",
				"salience": 0.00011012071,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.00011012071,
				"type": "EVENT"
			},
			{
				"name": "allegations",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "media play",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "encryption algorithms",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "floor",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"name": "Head",
				"salience": 0.00011012071,
				"type": "PERSON"
			},
			{
				"name": "shareholder",
				"salience": 0.00011012071,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07srw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Utah"
				},
				"name": "Utah",
				"salience": 0.00010787501,
				"type": "LOCATION"
			},
			{
				"name": "Common Access Cards",
				"salience": 0.00010787501,
				"type": "OTHER"
			},
			{
				"name": "MWBD",
				"salience": 0.00010787501,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.00010787501,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.00010787501,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.00010688202,
				"type": "OTHER"
			},
			{
				"name": "chief executive",
				"salience": 0.000106082465,
				"type": "PERSON"
			},
			{
				"name": "Mentor Protégé Team Award",
				"salience": 0.00010517234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Trade_Center_(1973%E2%80%932001)"
				},
				"name": "World Trade Center",
				"salience": 0.0001039312,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0262dl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Private_company_limited_by_shares"
				},
				"name": "Ltd.",
				"salience": 0.00010124476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0619_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portsmouth"
				},
				"name": "Portsmouth",
				"salience": 0.00010048737,
				"type": "LOCATION"
			},
			{
				"name": "COM",
				"salience": 0.00010048737,
				"type": "ORGANIZATION"
			},
			{
				"name": "Field McConnell",
				"salience": 0.00010048737,
				"type": "PERSON"
			},
			{
				"name": "CSI Crime and Safety Investigation",
				"salience": 0.00010048737,
				"type": "OTHER"
			},
			{
				"name": "Pentagon Renovation Program",
				"salience": 0.00010048737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y07",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secretary_of_State"
				},
				"name": "Secretary of State",
				"salience": 0.00010048737,
				"type": "PERSON"
			},
			{
				"name": "government customers",
				"salience": 0.000095349336,
				"type": "PERSON"
			},
			{
				"name": "Punk",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "graduation",
				"salience": 0.000095349336,
				"type": "EVENT"
			},
			{
				"name": "possibility",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "Web URLs",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "readiness",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "coordination",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "e-commerce",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "spread",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.000095349336,
				"type": "OTHER"
			},
			{
				"name": "rehearsal",
				"salience": 0.000095349336,
				"type": "EVENT"
			},
			{
				"name": "predecessors",
				"salience": 0.000095349336,
				"type": "PERSON"
			},
			{
				"name": "structure",
				"salience": 0.000094147326,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07cx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Telephone"
				},
				"name": "Tel",
				"salience": 0.00009072574,
				"type": "LOCATION"
			},
			{
				"name": "David Hawkins Tel",
				"salience": 0.00009072574,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02q26r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_of_Professional_Responsibility"
				},
				"name": "OPR",
				"salience": 0.00009072574,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01dfb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citigroup"
				},
				"name": "Citigroup",
				"salience": 0.00009072574,
				"type": "ORGANIZATION"
			},
			{
				"name": "Taher Elgamal",
				"salience": 0.00008160334,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0828v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Wide_Web"
				},
				"name": "World Wide Web",
				"salience": 0.00008124813,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09bbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gold_standard"
				},
				"name": "Gold Standard",
				"salience": 0.00008124813,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.0000785559,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g8fs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Naval_Academy"
				},
				"name": "United States Naval Academy",
				"salience": 0.0000785559,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026vq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Services_Administration"
				},
				"name": "GSA",
				"salience": 0.0000785559,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_hj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Aviation_Administration"
				},
				"name": "FAA",
				"salience": 0.0000785559,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02rf6d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rosslyn,_Arlington,_Virginia"
				},
				"name": "Rosslyn",
				"salience": 0.0000785559,
				"type": "LOCATION"
			},
			{
				"name": "MCI",
				"salience": 0.0000785559,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0000785559,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09lhr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Departments_of_France"
				},
				"name": "Department",
				"salience": 0.0000785559,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/022t9j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Simian_immunodeficiency_virus"
				},
				"name": "SIV",
				"salience": 0.0000785559,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0000785559,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Va.",
				"salience": 0.0000785559,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0htyj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ron_Rivest"
				},
				"name": "Rivest",
				"salience": 0.00007505655,
				"type": "PERSON"
			},
			{
				"name": "Hellman",
				"salience": 0.00007505655,
				"type": "PERSON"
			},
			{
				"name": "Tatiana",
				"salience": 0.00007188046,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00006776529,
				"type": "LOCATION"
			},
			{
				"name": "Clifford Cocks",
				"salience": 0.00006776529,
				"type": "PERSON"
			},
			{
				"name": "James Ellis",
				"salience": 0.00005942442,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.000058675283,
				"type": "LOCATION"
			},
			{
				"name": "Adleman",
				"salience": 0.000058675283,
				"type": "PERSON"
			},
			{
				"name": "Shamir",
				"salience": 0.000058675283,
				"type": "PERSON"
			},
			{
				"name": "Diffie",
				"salience": 0.000058675283,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05j3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netscape"
				},
				"name": "Netscape",
				"salience": 0.000058675283,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01tjvv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Durban"
				},
				"name": "Durban",
				"salience": 0.000058675283,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.000058675283,
				"type": "LOCATION"
			},
			{
				"name": "North Tower",
				"salience": 0.000058675283,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09p6s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arthur_Andersen"
				},
				"name": "Arthur Andersen",
				"salience": 0.000058675283,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g9jc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ernst_%26_Young"
				},
				"name": "Ernst & Young",
				"salience": 0.000058675283,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.000058675283,
				"type": "LOCATION"
			},
			{
				"name": "reasons",
				"salience": 0.000048674607,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00002859851,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:14:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 86.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "United States Marine Field McConnell  Plum City Online - ( AbelDanger.net )  October 26, 2016 \n1. Abel Danger ( AD ) claims that Hillary Clinton used DOJ Pride 8(a) actors to blackmail mentors of the Federal Bridge Certification Authority – including erstwhile directors of Boeing, Lockheed Martin, Raytheon and Northrop Grumman – with child pornography originating from a B.C. pig farm. \n\n2. AD claims that in early 2001, Clinton's 8(a) companies used their pig-farm network (cf. Starnet) to set up a server to the federal bridge in the basement of her Chappaqua home where she allegedly used Serco Zulu timing signals to synchronize and watch 'the first live-broadcast mass snuff film in human history' on 9/11. \n\n3. AD claims that Serco 8(a) companies at the US Patent and Trademark Office have issued phony keys for an electronic voting pad input device (US 7537159 B2) so the George Soros-tied company Smartmatic can switch votes from Donald Trump to Hillary Clinton – a former patent lawyer in Little Rock, Arkansas. \n\n4. United States Marine Field McConnell – Global Operations Director of Abel Danger – has offered to serve as a five-star general in a Trump administration and destroy Clinton's pig farm friends at DOJ Pride and the federal bridge with which they can activate weaponized devices through the Serco patent office. \n\n\nSoros Linked Voting Machines To Be Used In Key Battleground States   \nNote the ransom equals the bonus paid by Lockheed Martin Sister Lynne Cheney to JonBenet's father \n\nMedia Coverage of Starnet Raid - August 20, 1999   \n\nHillary Clinton vs. James Comey: Email Scandal Supercut  \nCopy of SERCO GROUP PLC: List of Subsidiaries AND Shareholders! [Note British and Saudi Governments, AXA, HSBC , Teachers' and Gold man Sachs]    \nDefense Ammunition Center [Outsourced to Serco ]   \nSerco ... Would you like to know more?  \n\n\"Digital Fires Instructor Serco - Camp Pendleton, CA Uses information derived from all military disciplines (e.g., aviation, ground combat, command and control, combat service support, intelligence, and opposing forces) to determine changes in enemy capabilities, vulnerabilities, and probable courses of action.\" \n\n\" Serco Processes 2 Millionth Patent Application for U.S. Patent and Trademark Office   \nDate: 18 Mar 2013  \nSerco Inc., a leading provider of professional, technology, and management services to the federal government, announced today that their Pre-Grant Publication (PGPubs) Classification Services team recently processed their 2 millionth patent application for the U.S. Patent & Trademark Office (USPTO). Each application was also processed within the contractually required 28-day window.\" \n\nFor sure, defence counsel have made much of Taylor's involvement with the missing and murdered women, all but pointing the finger at her as homicidal maniac, the real killer. What's not in dispute is that Taylor is one scary character ? street-hardened, menacing, a procurer of prostitutes lured to the Pickton farm, contemptuous of both sex-trade workers (especially street walkers) and drug addicts. \n\n\"Concern Grows Over Soros-Linked Voting Machines   \nSixteen states may be using balloting equipment from a company tied to the leftist billionaire  \nby Edmund Kozak | Updated 24 Oct 2016 at 5:21 PM  \nConcern is growing over revelations that voting machines in a significant number of states could be linked to a company tied directly to billionaire leftist George Soros and his personal quest to create a nationless, borderless global state. \n\nThe U.K.-based Smartmatic company posted a flow-chart on its website that it had provided voting machines for 16 states, including important battleground states like Florida and Arizona. Smartmatic Chairman Mark Malloch-Brown is a former U.N. official and sits on the board of Soros’ Open Society Foundations. Since the story first broke, the flow-chart has disappeared from Smartmatic’s website, raising further questions about the real status of the Soros-tied voting equipment and whether it is truly being deployed in U.S. elections. \n\nIf Malloch-Brown's Soros ties weren't troubling enough, he also has ties to the Clintons through his work at two consulting firms. \n\nAccording to a spokesperson for the National Association of Secretaries of State, Smartmatic is not on a list of federally certified providers for election systems and officials in several states’ have contested that their equipment came from Smartmatic. Why, then, had Smartmatic bragged about providing over 50,000 voting machines for U.S. elections?\" \n\n\"Check http://www.gmanetwork.com/news/story/309533/opinion/why-have-all-the-digital-signatures-from-the-election-returns-been-stripped \" \n\n\"Electronic voting pad input device, system and method  \nUS 7537159  \nB2 ABSTRACT  \nIn the preferred embodiment, the invention is a data entry device intended for use by voters during an election to enter selected choices. Its basic functions are to display available options and accept voter input. Its design achieves simplicity in its preparation, deployment, and operation at any given electoral event. It also furnishes accuracy, reliability, durability, and reusability. It connects in a standard protocol to a voting station's host processor. It accepts up to 300 key codes, each one potentially a unique selection. Names, symbols, or pictures identifying candidates are printed on a paper template compliant with the device's geometry, inserted prior to an election, and visible through the device's transparent cover. When the number of candidates or valid options in a contest exceeds its capacity, additional identical units can be chain-connected, until a sufficient number of voting options are available. \n\nPublication number: US7537159 B2  \nPublication type: Grant  \nApplication number: US 11/160,782  \nPublication date: May 26, 2009  \nFiling date: Jul 8, 2005  \nPriority date: Jul 8, 2005  \nFee status: Paid  \nAlso published as: US20070007340   \nInventors: Antonio Mugica , 4 More »  \nOriginal Assignee: Smartmatic International Corporation   \nExport Citation: BiBTeX, EndNote, Ref Man Patent Citations (12), Referenced by (4), Classifications (7), Legal Events (7)  \nExternal Links: USPTO , USPTO Assignment , Espacenet \" \n\n\"BREAKING: @HillaryClinton's E-Mail Server Company Got Almost $1 Million In Gov't Loans After Wiping E-Mails   \nOCTOBER 26, 2016  \nBY CHARLES C. JOHNSON 6 COMMENTS  \nGive it up already. It's over. K. J. Gillenwater was the primary researcher behind this story. \n\nHillary Clinton's e-mail server company got almost $1 million in government loans starting immediately after they were secretly asked to wipe Hillary Clinton's name from her e-mails. \n\nPlatte River Networks (PRN) got a $493,000 loan from the Small Business Administration in August 2014 and another $350,000 loan in September 2015: \n\nPublic government data available as USAspending.gov \n\nThe first half-million dollar loan arrived not one month after PRN employee Paul Combetta was caught accidentally revealing his company was deleting evidence at Hillary's request in July 2014 . \n\nThe second $350,000 loan came about one year later. \n\nYou won't hear this stuff from the lying mainstream media. Keep the GotNews mission alive: donate at GotNews.com/donate or send tips to editor@gotnews.com. If you'd like to join our research team, contacteditor@gotnews.com. \n\nAfter getting the first loan, PRN moved to a large office space after previously working out of the owner’s condo. The head of the Small Business Administration is Maria Contreras-Sweet , a Mexican immigrant who was appointed to the office by Barack Obama two months before Hillary's PRN got the first loan. \n\nWikiLeaks leaks have proven Hillary's corrupt pay-to-play scheme. GotNews has shined a light on how Hillary gets favors from Hispanic and Democratic government bureaucrats before . \n\nDid Hillary Clinton pay her e-mail server company Platte River Networks (PRN) with almost $1 million in favorable government loans — given out by a political friendly — in order to alter her illegal e-mails and get her name off them? \n\nIt sure looks like it. \n\nA Freedom of Information Act (FOIA) request has been lodged for more information. \n\nStay tuned for more. \n\nK. J. Gillenwater was the primary researcher behind this story.\" \n\n\"WHY BILL CLINTON'S 26 TRIPS ON THE LOLITA EXPRESS CHILD RAPE JET MATTER May 15, 2016  \nDaniel Greenfield   \nWe don't know what Bill Clinton did or didn't do in company with Jeffrey Epstein. But we certainly know what Epstein did and, almost as outrageously, what he got away with doing . \n\nSome of the most shocking allegations against Epstein surfaced only after the conclusion of an FBI probe, in civil suits brought by his victims: for example, the claim that three 12-year-old French girls were delivered to him as a birthday present. But the feds did identify roughly 40 young women, most of them underage at the time, who described being lured to Epstein's Palm Beach home on the pretense of giving a \"massage\" for money, then pressured into various sex acts, as well as the \"Balkan sex slave\" Epstein allegedly boasted of purchasing from her family when she was just 14. More recently, a big cash payment from Mail on Sunday coaxed one of Epstein's main accusers out of anonymity to describe what she claims were her years as a teenage sex toy. This victim, Virginia Roberts, produced a photo of herself with Prince Andrew in 2001 and reported that Epstein paid her $15,000 to meet the prince. Then 17 years old, she claims that she was abused by Epstein and \"loaned\" to his friends from the age of 15. \n\nSex crimes of the kind Roberts alleges took place typically carry a term of 10 to 20 years in federal prison. Yet when all was said and done, Epstein served his scant year-plus-one-month in a private wing of the Palm Beach jail and was granted a 16-hour-per-day free pass to leave the premises for work. \n\nIn short, Epstein was never actually in jail. During his \"house arrest,\" he flew around the country on his jets from his New York City place to his private island. At least one of Epstein's victims claimed to have met Bill Clinton. And it turns out that Bill Clinton was a much more regular passenger on the Lolita Express. \n\nFormer President Bill Clinton was a much more frequent flyer on a registered sex offender's infamous jet than previously reported, with flight logs showing the former president taking at least 26 trips aboard the \"Lolita Express\" -- even apparently ditching his Secret Service detail for at least five of the flights, according to records obtained by FoxNews.com. \n\nClinton's presence aboard Jeffrey Epstein's Boeing 727 on 11 occasions has been reported, but flight logs show the number is more than double that, and trips between 2001 and 2003 included extended junkets around the world with Epstein and fellow passengers identified on manifests by their initials or first names, including \"Tatiana.\" The tricked-out jet earned its Nabakov-inspired nickname because it was reportedly outfitted with a bed where passengers had group sex with young girls. \n\nIt doesn't help that the Democratic establishment seems to have played a role in getting Epstein a pass on child rape, that Bill Clinton already had rape accusations in his past or that the Clintons had become notorious for their willingness to do favors for criminals in exchange for money. \n\nEither way we've come a long way from Gary Hart being bounced for \"Monkey Business\" to Bill Clinton flying around on a child rapist's plane without anyone in the media seeming to care much about it. \n\nSocial conservatives often get a bad rap. But there really is no limit to how low standards can fall when any trace of a moral code vanishes out the window. What did Bill Clinton actually do? Who knows. More importantly these days, who cares \n\nABOUT DANIEL GREENFIELD \n\nDaniel Greenfield, a Shillman Journalism Fellow at the Freedom Center, is a New York writer focusing on radical Islam.\" \n\n\"For sure, defence counsel have made much of Taylor's involvement with the missing and murdered women, all but pointing the finger at her as homicidal maniac, the real killer. What's not in dispute is that Taylor is one scary character ? street-hardened, menacing, a procurer of prostitutes lured to the Pickton farm, contemptuous of both sex-trade workers (especially street walkers) and drug addicts. \n\n\"She's pure evil,'' says one outreach worker, who asked that her name not be used in any story about Taylor. \n\n... \n\nCourt has heard that Taylor's DNA was found on 113 items retrieved from the Pickton property ? including handcuffs, condoms, clothing, syringes ? and also on items that belonged to some victims ? Brenda Wolfe's lipstick, Mona Wilson's rosary. \n\nOne witness, Pickton pal Pat Casanova, told the court he once received fellatio from a woman he knew as \"Angel,\" who'd been brought to the farm by Taylor. He said he gave the money to Taylor, who shared some of it with \"Angel.\" \n\nAnother witness, Gina Houston, put Taylor on the same bed with victim Sereena Abotsway, in Pickton's trailer. \n\nIn his lengthy police interview, Pickton repeatedly tells police he wants to speak with Taylor. \n\nOn the stand, Houston recounted a conversation she'd had with Pickton about Taylor, shortly before his arrest. \n\n\"Willie told me that he believed she (Taylor) would do the right thing when she came back. That she would take responsibility for what she said she would take responsibility for.\" \n\nSource \n\nJeff Wells points to other odd things. \n\nA week or so ago a man called Steve Remian committed suicide-by-cop but: The name \"Steve Remian\" surfaced at the Robert \"Willie\" Pickton murder trial in New Westminster, B.C., last March, when jurors were told that Remian's name ? with a Burnaby, B.C., address ? was on the label of a suitcase packed into a box found in Pickton's workshop. \n\nIn April, jurors heard further evidence that DNA testing on two hairs found on a Hudson's Bay blanket removed from Pickton's motorhome linked one to Pickton, and the other to a \"Steve Remian.\" \n\nA source involved in the Oakville shooting investigation told the Star that the man shot by police had been charged with sexual assault earlier in life while living in Oakville, but had been acquitted, although a co-accused was convicted. \n\nSource \n\nIt does seem like a regular hive of activity: Robert Pickton's pig farm was a constant buzz of activity, with people and vehicles coming and going all the time, a woman who lived in Pickton's trailer for a time testified on Wednesday. \n\nTanya Carr, 35, told the jury in Pickton's murder trial that people were coming and going all day long at the Port Coquitlam, B.C., farm and it wasn't unusual for people to show up late at night looking for Pickton or his brother Dave. \n\nSource \n\nAlso there are those Hells Angels and the \"Piggy Palace\": \n\n\"It was a rough crowd\" at Piggy's Palace, said Brian, a musician who played there a few years ago with the hard-rock band South City Slam. \n\nThe nightclub, he said, was inside an old building on a property Dave Pickton and his brother Robert own at 2552 Burns Rd., near their pig farm on Dominion Road in Port Coquitlam.... \n\n\"Even the women were tough- looking -- a lot of leather and denim. It wasn't a cocktail-gown kind of place ,\" he recalled. \n\nBrian, who didn't want his last name used, recalled that there was a coat-check girl and a sign saying, \"Check your knives and other weapons at the door.\" ... \n\nThe crowd at Piggy's Palace often included men wearing Hells Angels biker club colours. \n\n\"They were there a lot,\" said Brian. \"The people who came all seemed to know one another.\"  \n\n\"Super Serco bulldozes ahead  \nBy DAILY MAIL REPORTER UPDATED: 23:00 GMT, 1 September 2004 \nSERCO has come a long way since the 1960s when it ran the 'four-minute warning' system to alert the nation to a ballistic missile attack. \n\nToday its £10.3bn order book is bigger than many countries' defence budgets. It is bidding for a further £8bn worth of contracts and sees £16bn of 'opportunities'. \n\nProfit growth is less ballistic. The first-half pre-tax surplus rose 4% to £28.1m, net profits just 1% to £18m. Stripping out goodwill, the rise was 17%, with dividends up 12.5% to 0.81p. \n\nSerco runs the Docklands Light Railway, five UK prisons, airport radar and forest bulldozers in Florida.\"  \n\n\" Serco farewell to NPL after 19 years of innovation 8 January 2015 Serco said goodbye to the National Physical Laboratory (NPL) at the end of December 2014 after 19 years of extraordinary innovation and science that has seen the establishment build a world-leading reputation and deliver billions of pounds of benefit for the UK economy. During that period under Serco 's management and leadership, NPL has delivered an extraordinary variety and breadth of accomplishments for the UK's economy and industry. Some of the key achievements during that time have been:… It has been estimated that work carried out by the Centre of Carbon Measurement at NPL will save eight million tonnes of carbon emissions reductions (2% of UK footprint) and over half a billion pounds in economic benefit over the next decade…. NPL's caesium fountain atomic clock is accurate to 1 second in 158 million years and NPL is playing a key role in introducing rigour to high frequency trading [for Serco 's front running banks] in the City through NPL [Zulu] Time.\" \n\n\"UK Cabinet Office – Emergency Planning College – Serco …..Types of Exercise Workshop Exercises These are structured discussion events where participants can explore issues in a less pressurised environment. They are an ideal way of developing solutions, procedures and plans rather than the focus being on decision making. Table Top Exercises These involve a realistic scenario and will follow a time line, either in real-time or with time jumps to concentrate on the more important areas. The participants would be expected to be familiar with the plans and procedures that are being used although the exercise tempo and complexity can be adjusted to suit the current state of training and readiness. Simulation and media play can be used to support the exercise. Table-top exercises help develop teamwork and allow participants to gain a better understanding of their roles and that of other agencies and organisations. Command/Control Post Exercises These are designed primarily to exercise the senior leadership and support staff in collective planning and decision making within a strategic grouping. Ideally such exercises would be run from the real command and control locations and using their communications and information systems [Feeling lucky, Punk?] . This could include a mix of locations and varying levels of technical simulation support. The Gold Standard system is flexible to allow the tempo and intensity to be adjusted to ensure maximum training benefit, or to fully test and evaluate the most important aspects of a plan. Such exercises also test information flow, communications, equipment, procedures, decision making and coordination. Live Exercises These can range from testing individual components of a system or organisation through to a full-scale rehearsal. They are particularly useful where there are regulatory requirements or with high-risk situations. They are more complex and costly to organise and deliver but can be integrated with Command Post Exercises as part of a wider exercising package.\"  \n\n\"Christopher Rajendran Hyman CBE (born 5 July 1963 in Durban, South Africa)[1] was Chief Executive of Serco Group plc from 2002 to October 2013.[2] … On graduation, he worked for Arthur Andersen. In 1989, he won an 18-month exchange with Ernst & Young in London, who employed him after four months.[1] Head hunted in 1994 by Serco , Hyman became European finance director, and in 1999 was made group finance director. In 2002, Hyman became chief executive. .. Hyman resigned from his role of Chief Executive of Serco on 25 October 2013 following allegations that Serco had overcharged government customers. .. He was [making a presentation to Serco shareholder, including British and Saudi governments] on the 47th floor of the World Trade Center [North Tower] at the time of the September 11 attacks in 2001.\" \n\n\"July 7, 2016 Developments in PKI occurred in the early 1970s at the British intelligence agency GCHQ , where James Ellis , Clifford Cocks and others made important discoveries related to encryption algorithms and key distribution.[ 19 ] However, as developments at GCHQ are highly classified, the results of this work were kept secret and not publicly acknowledged until the mid-1990s. \n\nThe public disclosure of both secure key exchange and asymmetric key algorithms in 1976 by Diffie, Hellman , Rivest, Shamir , and Adleman changed secure communications entirely. With the further development of high-speed digital electronic communications (the Internet and its predecessors), a need became evident for ways in which users could securely communicate with each other, and as a further consequence of that, for ways in which users could be sure with whom they were actually interacting. \n\nAssorted cryptographic protocols were invented and analyzed within which the new cryptographic primitives could be effectively used. With the invention of the World Wide Web and its rapid spread, the need for authentication and secure communication became still more acute. Commercial reasons alone (e.g., e-commerce, online access to proprietary databases from web browsers) were sufficient. Taher Elgamal and others at Netscape developed the SSL protocol ('https' in Web URLs); it included key establishment, server authentication (prior to v3, one-way only), and so on. A PKI structure was thus created for Web users/sites wishing secure communications. \n\nVendors and entrepreneurs saw the possibility of a large market, started companies (or new projects at existing companies), and began to agitate for legal recognition and protection from liability. An American Bar Association technology project published an extensive analysis of some of the foreseeable legal aspects of PKI operations (see ABA digital signature guidelines), and shortly thereafter, several U.S. states (Utah being the first in 1995) and other jurisdictions throughout the world began to enact laws and adopt regulations. Consumer groups raised questions about privacy, access, and liability considerations, which were more taken into consideration in some jurisdictions than in others. \n\nThe enacted laws and regulations differed, there were technical and operational problems in converting PKI schemes into successful commercial operation, and progress has been much slower than pioneers had imagined it would be. \n\nBy the first few years of the 21st century, the underlying cryptographic engineering was clearly not easy to deploy correctly. Operating procedures (manual or automatic) were not easy to correctly design (nor even if so designed, to execute perfectly, which the engineering required). The standards that existed were insufficient. \n\nPKI vendors have found a market, but it is not quite the market envisioned in the mid-1990s, and it has grown both more slowly and in somewhat different ways than were anticipated.[20] PKIs have not solved some of the problems they were expected to, and several major vendors have gone out of business or been acquired by others. PKI has had the most success in government implementations; the largest PKI implementation to date is the Defense Information Systems Agency (DISA) PKI infrastructure for the Common Access Cards program.\"  \n\nBase One Technologies – Corporate Strategy – We are a Government Certified Women-Owned Business   \nWe practice Diversity Recruitment and Staffing for IT positions Base One was founded in 1994 by a women engineer who had made a career in technology research for many years. Base One has been very successful in focusing on diversity recruiting and staffing for IT projects. It has been our experience that the greater the diversity mix, the more creative the solution. As in any field the more diverse the viewpoint the more thorough your analysis. Our engineers can think out of the box. \n\nBecause of our affiliations we have access to pools of resources among more diverse groups & individuals. We work with a large pool of minority professionals who specialize in IT skills. We are able to have access to these resources through our status as a D/MWBD firm and our affiliations. These affiliations assist us in working with resources among more diverse groups & individuals. We are also partnered with firms that are 8A certified as Minority firms, Disabled Veteran firms, Native American firms, Vietnam veteran firms, women owned firms. \n\nOur hub zone location keeps us close to the professional organizations of great diversity. We are active in recruiting from and networking with these community organizations of local IT professionals. This has given us access to a large pool of diversity talent. \n\nBase One's staff of engineers are a diverse group of professionals. This diverse network of engineers helps us to branch out to other engineers and creates an even larger network of resources for us to work with. \n\nThe greater the diversity the more complete & thorough the analysis. The broader the spectrum of points of view the broader the scope of the analysis. We feel that a diverse team gives us a greater advantage in creating cutting edge solutions. To that end we will continue to nurture these relationships to further extend our talent pool. \n\nThe greater the diversity mix, the more creative the solution. \n\nThe more diverse the viewpoint, the more thorough the analysis. \n\nThe more diverse our team, the more our engineers can think out of the box. \n\nThis is why Base One Technologies concentrates on diversity recruitment in the belief that a diverse team gives us a greater advantage in creating cutting edge solutions.\" \n\nInformation Security Planning is the process whereby an organization seeks to protect its operations and assets from data theft or computer hackers that seek to obtain unauthorized information or sabotage business operations. \n\nKey Clients Benefiting From Our Information Security Expertise: Pentagon Renovation Program, FAA, Citigroup, MCI. \n\nBase One Technologies \n\nExpertly researches, designs, and develops information security policies that protect your data and manage your firm's information technology risk at levels acceptable to your business. \n\nPerforms architectural assessments and conducts both internal and external penetration testing. The results of these efforts culminate in an extensive risk analysis and vulnerabilities report. \n\nDevelops, implements and supports Information Security Counter measures such as honey-pots and evidence logging and incident documentation processes and solutions.\" \n\n\"Base One Technologies, Ltd. is a DOMESTIC BUSINESS CORPORATION, located in New York, NY and was formed on Feb 15, 1994. This file was obtained from the Secretary of State and has a file number of 1795583. \" \n\n\"Serco's Office of Partner Relations (OPR) helps facilitate our aggressive small business utilization and growth strategies. Through the OPR, Serco mentors four local small businesses under formal Mentor Protégé Agreements: Three sponsored by DHS (Base One Technologies, TSymmetry, Inc., and HeiTech Services, Inc.,) and the fourth sponsored by GSA (DKW Communications, Inc.). Serco and HeiTech Services were awarded the 2007 DHS Mentor Protégé Team Award for exceeding our mentoring goals.\" http://www.dtic.mil/whs/directives/corres/pdf/100515p.pdf \n\n\"Opened in 1994 as the successor to the Transitional Immigrant Visa Processing Center in Rosslyn, Va., the NVC centralizes all immigrant visa pre-processing and appointment scheduling for overseas posts. The NVC collects paperwork and fees before forwarding a case, ready for adjudication, to the responsible post. \n\nThe center also handles immigrant and fiancé visa petitions, and while it does not adjudicate visa applications, it provides technical assistance and support to visa-adjudicating consular officials overseas. \n\nOnly two Foreign Service officers, the director and deputy director, work at the center, along with just five Civil Service employees. They work with almost 500 contract employees doing preprocessing of visas, making the center one of the largest employers in the Portsmouth area. \n\nThe contractor, Serco , Inc., has worked with the NVC since its inception and with the Department for almost 18 years. \n\nThe NVC houses more than 2.6 million immigrant visa files, receives almost two million pieces of mail per year and received more than half a million petitions from the U.S. Citizenship and Immigration Service (USCIS) in 2011. Its file rooms' high-density shelves are stacked floor-to-ceiling with files, each a collection of someone’s hopes and dreams and each requiring proper handling. …. \n\nThe NVC also preprocesses the chief of mission (COM) application required for the filing of a petition for a Special Immigrant Visa (SIV). Such visas, for foreign nationals who have performed services for the U.S. government in Iraq and Afghanistan, require COM concurrence before the applicant can file a petition with USCIS. The NVC collects the requisite documents from such applicants and, when complete, forwards the package to the U.S. embassies in Baghdad or Kabul for COM approval\" \n\nYours sincerely, \n\nField McConnell, United States Naval Academy, 1971; Forensic Economist; 30 year airline and 22 year military pilot; 23,000 hours of safety; Tel: 715 307 8222 \n\nDavid Hawkins Tel: 604 542-0891 Forensic Economist; former leader of oil-well blow-out teams; now sponsors Grand Juries in CSI Crime and Safety Investigation \n",
		"thread_title": "#2816: Clinton Pride’s 8(a) Pig Farm Bridge – Serco Zulu Server Snuff –Soros's Patented Voter Key",
		"title": "#2816: Clinton Pride’s 8(a) Pig Farm Bridge – Serco Zulu Server Snuff –Soros's Patented Voter Key",
		"type": "bs",
		"uuid": "b9af57aaf67e5894ea9cee78d8f646aecaa0ebd9"
	},
	"-KhIWOwAtx_FPMekunRV": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:37:58.893+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/024656",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walter_Rothschild,_2nd_Baron_Rothschild"
				},
				"name": "Rothschild",
				"salience": 0.69035244,
				"type": "PERSON"
			},
			{
				"name": "banksters",
				"salience": 0.07626235,
				"type": "ORGANIZATION"
			},
			{
				"name": "voting machines",
				"salience": 0.061276115,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.038506646,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.030127142,
				"type": "LOCATION"
			},
			{
				"name": "central bank",
				"salience": 0.022670142,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.01960403,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.010908483,
				"type": "LOCATION"
			},
			{
				"name": "t",
				"salience": 0.009339141,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00910703,
				"type": "EVENT"
			},
			{
				"name": "independence",
				"salience": 0.00910703,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.008920193,
				"type": "LOCATION"
			},
			{
				"name": "credit",
				"salience": 0.0049716015,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.004218496,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.0031538415,
				"type": "PERSON"
			},
			{
				"name": "sides",
				"salience": 0.0014753421,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-26T23:12:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "So ,you have Rothschild banksters and British voting machines running USA . Somehow i don&#39;t think USA won any war for independence . Rothschild owns a central bank in almost every country which means hecontrols every country , so he plays all sides against each other , no doubt Soros is a Rothschild agent . You have to give them credit He even owns all the media as well . ",
		"thread_title": "#2816: Clinton Pride’s 8(a) Pig Farm Bridge – Serco Zulu Server Snuff –Soros's Patented Voter Key",
		"title": "",
		"type": "bs",
		"uuid": "03905a0f06cb711190aad3934af253a0e1c00a83"
	},
	"-KhIWPEmMWL23dZxpF4P": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:37:58.902+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "problem",
				"salience": 0.12764314,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.067044504,
				"type": "WORK_OF_ART"
			},
			{
				"name": "war",
				"salience": 0.065726504,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.065726504,
				"type": "EVENT"
			},
			{
				"name": "bankster elite",
				"salience": 0.06337433,
				"type": "OTHER"
			},
			{
				"name": "Sanctions",
				"salience": 0.059438176,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.051569797,
				"type": "WORK_OF_ART"
			},
			{
				"name": "banksters",
				"salience": 0.03277697,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.032368407,
				"type": "LOCATION"
			},
			{
				"name": "issue",
				"salience": 0.026997097,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.024675474,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.024482086,
				"type": "ORGANIZATION"
			},
			{
				"name": "defence",
				"salience": 0.021383492,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.021383492,
				"type": "OTHER"
			},
			{
				"name": "banksters",
				"salience": 0.018353663,
				"type": "ORGANIZATION"
			},
			{
				"name": "sanctions",
				"salience": 0.017330345,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.016685886,
				"type": "OTHER"
			},
			{
				"name": "&quot",
				"salience": 0.015014511,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.015014511,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.014455852,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.01436252,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.01415801,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.01415801,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.01226476,
				"type": "LOCATION"
			},
			{
				"name": "regimes",
				"salience": 0.01226476,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.01226476,
				"type": "PERSON"
			},
			{
				"name": "narcotics traffickers",
				"salience": 0.01226476,
				"type": "OTHER"
			},
			{
				"name": "goals",
				"salience": 0.01226476,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.010584554,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.010584554,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f1r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_the_Treasury"
				},
				"name": "Department of the Treasury",
				"salience": 0.009253014,
				"type": "ORGANIZATION"
			},
			{
				"name": "OFAC&quot",
				"salience": 0.009253014,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.009168036,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.009168036,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hm3m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_of_Foreign_Assets_Control"
				},
				"name": "Office of Foreign Assets Control",
				"salience": 0.008908241,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.008541525,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0077133845,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.005764142,
				"type": "OTHER"
			},
			{
				"name": "United​ States",
				"salience": 0.0056467582,
				"type": "LOCATION"
			},
			{
				"name": "weapons of mass destruction",
				"salience": 0.0049919114,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0049919114,
				"type": "OTHER"
			},
			{
				"name": "proliferation",
				"salience": 0.0049919114,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0049919114,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-26T22:48:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 2.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Here is the problem . The USA constitution states only Congress can declare war yet Sanctions are a declaration of war made by non other than the bankster elite that has everrything to do with profit and nothing to do with defence . Far too much power for banksters to have and the profits they make are huge , The Office of Foreign Assets Control (&quot;OFAC&quot;) of the US Department of the Treasury administers and enforces economic and trade sanctions based on US foreign policy and national security goals against targeted foreign countries and regimes, terrorists, international narcotics traffickers, those engaged in activities related to the proliferation of weapons of mass destruction, and other threats to the national security, foreign policy or economy of the United​ States.  It is an issue no one has ever adressed anywhere . So no matter who you vote for its the banksters who go to war and no one ever elects them .",
		"thread_title": "#2816: Clinton Pride’s 8(a) Pig Farm Bridge – Serco Zulu Server Snuff –Soros's Patented Voter Key",
		"title": "",
		"type": "bs",
		"uuid": "42c16d3818e64ff4632409cafd309c22df530ac1"
	},
	"-KhIWPMZw4PTm3cJlB0p": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:37:58.915+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "plenty",
				"salience": 0.15208575,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.1369693,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "polls",
				"salience": 0.1369693,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.11928987,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.07186965,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.05466916,
				"type": "OTHER"
			},
			{
				"name": "eletion results",
				"salience": 0.05466916,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.045131743,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.03543196,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.03258167,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.01908729,
				"type": "OTHER"
			},
			{
				"name": "think",
				"salience": 0.01814825,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.01814825,
				"type": "OTHER"
			},
			{
				"name": "&quot",
				"salience": 0.01647904,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.014829823,
				"type": "PERSON"
			},
			{
				"name": "con",
				"salience": 0.014829823,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.009332021,
				"type": "OTHER"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.008083408,
				"type": "OTHER"
			},
			{
				"name": "gig",
				"salience": 0.008083408,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.006975481,
				"type": "OTHER"
			},
			{
				"name": "Victory&quot",
				"salience": 0.0068335324,
				"type": "OTHER"
			},
			{
				"name": "For Trump",
				"salience": 0.0068335324,
				"type": "OTHER"
			},
			{
				"name": "scam",
				"salience": 0.0064364183,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/098pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Landslide"
				},
				"name": "Landslide",
				"salience": 0.0037205017,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.0025116708,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-26T22:35:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "There is plenty of proof the machines are rigged whic also means trhe polls are rigged to match the machines so they must all know about it . Ask yourself how can a poll of a few thousand asked questions where they have no option possible tell you what hundreds of millions people who havent been polled think ?? Its impossible and has been the greatest con of the elite . And using past eletion results which were rigged to ppredict future results is also a scam .Soros Expects &quot;Landslide Popular Vote Victory&quot; For Trump But President Clinton Is A &quot;Done Deal&quot; Zero Hedge Done deal alright , they have been rinning this gig forever . ",
		"thread_title": "#2816: Clinton Pride’s 8(a) Pig Farm Bridge – Serco Zulu Server Snuff –Soros's Patented Voter Key",
		"title": "",
		"type": "bs",
		"uuid": "336f5dfbea5f263dbdd6ec9be9d1d94d255caa1f"
	},
	"-KhIWPRZ6hy7Yl8llIm0": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:37:58.925+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.55977523,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.13327993,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.08665487,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.045443684,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.02827417,
				"type": "ORGANIZATION"
			},
			{
				"name": "polling booths",
				"salience": 0.02112863,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.020349635,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.01728907,
				"type": "PERSON"
			},
			{
				"name": "booth",
				"salience": 0.01728907,
				"type": "LOCATION"
			},
			{
				"name": "photo",
				"salience": 0.016986208,
				"type": "WORK_OF_ART"
			},
			{
				"name": "phones",
				"salience": 0.016565045,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bus loads",
				"salience": 0.013547658,
				"type": "OTHER"
			},
			{
				"name": "booth",
				"salience": 0.0070692906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.0062555782,
				"type": "PERSON"
			},
			{
				"name": "scam",
				"salience": 0.0055317213,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.004560205,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-10-26T22:19:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Trump has an excuse now to audit any vote with these machines , trust the UN to be involved .  He neds them to take a photo of their vote with phones , and be onto the polling booths for the bus loads of illegal voters going from booth to booth , he can bust this whole scam wide open if he is smart . Soros gave 10 million to Clinton , this must be ilegal surely ...",
		"thread_title": "#2816: Clinton Pride’s 8(a) Pig Farm Bridge – Serco Zulu Server Snuff –Soros's Patented Voter Key",
		"title": "",
		"type": "bs",
		"uuid": "ea086a28e0bbafcd9fbaabd728920337371d4876"
	},
	"-KhIWPXrFqHJDV7RYXxg": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:37:58.936+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "one",
				"salience": 0.42808172,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.2724855,
				"type": "PERSON"
			},
			{
				"name": "trouble",
				"salience": 0.04701081,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.025864419,
				"type": "OTHER"
			},
			{
				"name": "worl",
				"salience": 0.024295207,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.024295207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.02347945,
				"type": "PERSON"
			},
			{
				"name": "Human Rights&quot",
				"salience": 0.015368078,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0114973765,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.0102461185,
				"type": "OTHER"
			},
			{
				"name": "Conflict",
				"salience": 0.0084408345,
				"type": "EVENT"
			},
			{
				"name": "state dept",
				"salience": 0.0084408345,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0084408345,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.008230278,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.007824726,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.007162321,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.007072367,
				"type": "OTHER"
			},
			{
				"name": "&quot",
				"salience": 0.0061816997,
				"type": "OTHER"
			},
			{
				"name": "riot",
				"salience": 0.0060004676,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.005404441,
				"type": "LOCATION"
			},
			{
				"name": "Scam",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "Voting machines",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "Conviction",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "human rights&quot",
				"salience": 0.0045055705,
				"type": "OTHER"
			},
			{
				"name": "gain",
				"salience": 0.0039024374,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0039024374,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.0033673376,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.002916336,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.002916336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGO",
				"salience": 0.0024033387,
				"type": "OTHER"
			},
			{
				"name": "http://landdestroyer.blogspot.com.au/2012/03/surpise-soros-is-convicted-criminal.html",
				"salience": 0.0024033387,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.0017956801,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-10-26T22:07:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "He has got to go after him , he is the one causing al the trouble around the worl and is 100% proof that what Trump says about crooked and corruption is true . Conflict of interest ?? You bet it is funded by the state dept to run riot causing huge cost to USA with as Trump says ,wars they dont need amd shouldnt be involved in and making profit along the way . Have a look at his funding to all these non profits on the Gov site , its an outrage he is involved with the Voting machines . Soros Criminal Conviction Exposes &quot;Human Rights&quot; Scam Soros leverages &quot;human rights&quot; for personal gain - as does his global NGO empire. http://landdestroyer.blogspot.com.au/2012/03/surpise-soros-is-convicted-criminal.html ",
		"thread_title": "#2816: Clinton Pride’s 8(a) Pig Farm Bridge – Serco Zulu Server Snuff –Soros's Patented Voter Key",
		"title": "",
		"type": "bs",
		"uuid": "6fad6edc4156d92153a9a7a0d66f7ae59b98760c"
	},
	"-KhIWPgpzUbWk3URL7kp": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:39:59.892+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "one",
				"salience": 0.42808172,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.2724855,
				"type": "PERSON"
			},
			{
				"name": "trouble",
				"salience": 0.04701081,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.025864419,
				"type": "OTHER"
			},
			{
				"name": "worl",
				"salience": 0.024295207,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.024295207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.02347945,
				"type": "PERSON"
			},
			{
				"name": "Human Rights&quot",
				"salience": 0.015368078,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0114973765,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.0102461185,
				"type": "OTHER"
			},
			{
				"name": "Conflict",
				"salience": 0.0084408345,
				"type": "EVENT"
			},
			{
				"name": "state dept",
				"salience": 0.0084408345,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0084408345,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.008230278,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.007824726,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.007162321,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.007072367,
				"type": "OTHER"
			},
			{
				"name": "&quot",
				"salience": 0.0061816997,
				"type": "OTHER"
			},
			{
				"name": "riot",
				"salience": 0.0060004676,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.005404441,
				"type": "LOCATION"
			},
			{
				"name": "Scam",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "Voting machines",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "Conviction",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "human rights&quot",
				"salience": 0.0045055705,
				"type": "OTHER"
			},
			{
				"name": "gain",
				"salience": 0.0039024374,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0039024374,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.0033673376,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.002916336,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.002916336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGO",
				"salience": 0.0024033387,
				"type": "OTHER"
			},
			{
				"name": "http://landdestroyer.blogspot.com.au/2012/03/surpise-soros-is-convicted-criminal.html",
				"salience": 0.0024033387,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.0017956801,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "6",
		"participants_count": "1",
		"published": "2016-10-26T22:07:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "He has got to go after him , he is the one causing al the trouble around the worl and is 100% proof that what Trump says about crooked and corruption is true . Conflict of interest ?? You bet it is funded by the state dept to run riot causing huge cost to USA with as Trump says ,wars they dont need amd shouldnt be involved in and making profit along the way . Have a look at his funding to all these non profits on the Gov site , its an outrage he is involved with the Voting machines . Soros Criminal Conviction Exposes &quot;Human Rights&quot; Scam Soros leverages &quot;human rights&quot; for personal gain - as does his global NGO empire. http://landdestroyer.blogspot.com.au/2012/03/surpise-soros-is-convicted-criminal.html ",
		"thread_title": "#2816: Clinton Pride’s 8(a) Pig Farm Bridge – Serco Zulu Server Snuff –Soros's Patented Voter Key",
		"title": "",
		"type": "bs",
		"uuid": "30026d6f4721bb93578dffe88ee680e1dcbf20c8"
	},
	"-KhIWPniEVLw0UjjrncG": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:40:03.654+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "plenty",
				"salience": 0.15208575,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.1369693,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "polls",
				"salience": 0.1369693,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.11928987,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.07186965,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.05466916,
				"type": "OTHER"
			},
			{
				"name": "eletion results",
				"salience": 0.05466916,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.045131743,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.03543196,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.03258167,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.01908729,
				"type": "OTHER"
			},
			{
				"name": "think",
				"salience": 0.01814825,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.01814825,
				"type": "OTHER"
			},
			{
				"name": "&quot",
				"salience": 0.01647904,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.014829823,
				"type": "PERSON"
			},
			{
				"name": "con",
				"salience": 0.014829823,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.009332021,
				"type": "OTHER"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.008083408,
				"type": "OTHER"
			},
			{
				"name": "gig",
				"salience": 0.008083408,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.006975481,
				"type": "OTHER"
			},
			{
				"name": "Victory&quot",
				"salience": 0.0068335324,
				"type": "OTHER"
			},
			{
				"name": "For Trump",
				"salience": 0.0068335324,
				"type": "OTHER"
			},
			{
				"name": "scam",
				"salience": 0.0064364183,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/098pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Landslide"
				},
				"name": "Landslide",
				"salience": 0.0037205017,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.0025116708,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-10-26T22:35:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 1.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "There is plenty of proof the machines are rigged whic also means trhe polls are rigged to match the machines so they must all know about it . Ask yourself how can a poll of a few thousand asked questions where they have no option possible tell you what hundreds of millions people who havent been polled think ?? Its impossible and has been the greatest con of the elite . And using past eletion results which were rigged to ppredict future results is also a scam .Soros Expects &quot;Landslide Popular Vote Victory&quot; For Trump But President Clinton Is A &quot;Done Deal&quot; Zero Hedge Done deal alright , they have been rinning this gig forever . ",
		"thread_title": "Did Google Kill Julian Assange?",
		"title": "",
		"type": "bs",
		"uuid": "4b9eb00294cc3efea62d55aa972b8218b588b55e"
	},
	"-KhIWPuT54po6vs-LREy": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:40:03.667+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.55977523,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.13327993,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.08665487,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.045443684,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.02827417,
				"type": "ORGANIZATION"
			},
			{
				"name": "polling booths",
				"salience": 0.02112863,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.020349635,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.01728907,
				"type": "PERSON"
			},
			{
				"name": "booth",
				"salience": 0.01728907,
				"type": "LOCATION"
			},
			{
				"name": "photo",
				"salience": 0.016986208,
				"type": "WORK_OF_ART"
			},
			{
				"name": "phones",
				"salience": 0.016565045,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bus loads",
				"salience": 0.013547658,
				"type": "OTHER"
			},
			{
				"name": "booth",
				"salience": 0.0070692906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.0062555782,
				"type": "PERSON"
			},
			{
				"name": "scam",
				"salience": 0.0055317213,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.004560205,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-10-26T22:19:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 1.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Trump has an excuse now to audit any vote with these machines , trust the UN to be involved .  He neds them to take a photo of their vote with phones , and be onto the polling booths for the bus loads of illegal voters going from booth to booth , he can bust this whole scam wide open if he is smart . Soros gave 10 million to Clinton , this must be ilegal surely ...",
		"thread_title": "Did Google Kill Julian Assange?",
		"title": "",
		"type": "bs",
		"uuid": "11ecd71be0955967a9058366b7bee2499dbc3e95"
	},
	"-KhIWQ13JS7WjeFrr6Kg": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:40:03.678+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "one",
				"salience": 0.42808172,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.2724855,
				"type": "PERSON"
			},
			{
				"name": "trouble",
				"salience": 0.04701081,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.025864419,
				"type": "OTHER"
			},
			{
				"name": "worl",
				"salience": 0.024295207,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.024295207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.02347945,
				"type": "PERSON"
			},
			{
				"name": "Human Rights&quot",
				"salience": 0.015368078,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0114973765,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.0102461185,
				"type": "OTHER"
			},
			{
				"name": "Conflict",
				"salience": 0.0084408345,
				"type": "EVENT"
			},
			{
				"name": "state dept",
				"salience": 0.0084408345,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0084408345,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.008230278,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.007824726,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.007162321,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.007072367,
				"type": "OTHER"
			},
			{
				"name": "&quot",
				"salience": 0.0061816997,
				"type": "OTHER"
			},
			{
				"name": "riot",
				"salience": 0.0060004676,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.005404441,
				"type": "LOCATION"
			},
			{
				"name": "Scam",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "Voting machines",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "Conviction",
				"salience": 0.0053548333,
				"type": "OTHER"
			},
			{
				"name": "human rights&quot",
				"salience": 0.0045055705,
				"type": "OTHER"
			},
			{
				"name": "gain",
				"salience": 0.0039024374,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0039024374,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.0033673376,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.002916336,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.002916336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGO",
				"salience": 0.0024033387,
				"type": "OTHER"
			},
			{
				"name": "http://landdestroyer.blogspot.com.au/2012/03/surpise-soros-is-convicted-criminal.html",
				"salience": 0.0024033387,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.0017956801,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "6",
		"participants_count": "1",
		"published": "2016-10-26T22:07:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "He has got to go after him , he is the one causing al the trouble around the worl and is 100% proof that what Trump says about crooked and corruption is true . Conflict of interest ?? You bet it is funded by the state dept to run riot causing huge cost to USA with as Trump says ,wars they dont need amd shouldnt be involved in and making profit along the way . Have a look at his funding to all these non profits on the Gov site , its an outrage he is involved with the Voting machines . Soros Criminal Conviction Exposes &quot;Human Rights&quot; Scam Soros leverages &quot;human rights&quot; for personal gain - as does his global NGO empire. http://landdestroyer.blogspot.com.au/2012/03/surpise-soros-is-convicted-criminal.html ",
		"thread_title": "Did Google Kill Julian Assange?",
		"title": "",
		"type": "bs",
		"uuid": "269e89072d73ae89a8645199b121aaa497460f40"
	},
	"-KhIWRjKzKt3BYGrsmRq": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T03:19:50.476+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Starnet Communications",
				"salience": 0.101495884,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0412gcn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Smartmatic"
				},
				"name": "Smartmatic",
				"salience": 0.035306666,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wp7w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Malloch_Brown,_Baron_Malloch-Brown"
				},
				"name": "Mark Malloch-Brown",
				"salience": 0.027777364,
				"type": "PERSON"
			},
			{
				"name": "Digital Fires Instructor Serco",
				"salience": 0.02431225,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.020560462,
				"type": "ORGANIZATION"
			},
			{
				"name": "AbelDanger.net",
				"salience": 0.019331044,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.01662013,
				"type": "PERSON"
			},
			{
				"name": "Christopher Rajendran Hyman CBE",
				"salience": 0.014194218,
				"type": "PERSON"
			},
			{
				"name": "Redlight.com",
				"salience": 0.011269882,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00979159,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.009124048,
				"type": "PERSON"
			},
			{
				"name": "7537159 B2",
				"salience": 0.008792054,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Command",
				"salience": 0.0075298566,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.0070580025,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.007049022,
				"type": "LOCATION"
			},
			{
				"name": "status",
				"salience": 0.006731628,
				"type": "OTHER"
			},
			{
				"name": "snuff films",
				"salience": 0.006663194,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Gillenwater",
				"salience": 0.0064045335,
				"type": "PERSON"
			},
			{
				"name": "pornography company",
				"salience": 0.006343309,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/080h2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vancouver"
				},
				"name": "Vancouver",
				"salience": 0.0059729717,
				"type": "LOCATION"
			},
			{
				"name": "Mark Dohlen",
				"salience": 0.0056408304,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.005326281,
				"type": "LOCATION"
			},
			{
				"name": "exercises",
				"salience": 0.004869905,
				"type": "OTHER"
			},
			{
				"name": "Platte River Networks",
				"salience": 0.004320304,
				"type": "ORGANIZATION"
			},
			{
				"name": "Business",
				"salience": 0.004268356,
				"type": "ORGANIZATION"
			},
			{
				"name": "loan",
				"salience": 0.003999587,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0039490312,
				"type": "PERSON"
			},
			{
				"name": "general",
				"salience": 0.0038629465,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028z2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Georgia_Straight"
				},
				"name": "The Georgia Straight",
				"salience": 0.0037257753,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Field",
				"salience": 0.0036798487,
				"type": "LOCATION"
			},
			{
				"name": "RECORDS",
				"salience": 0.0035099823,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0035060341,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0206rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Sachs"
				},
				"name": "Sachs",
				"salience": 0.0033894235,
				"type": "PERSON"
			},
			{
				"name": "Lynne Cheney",
				"salience": 0.0033894235,
				"type": "PERSON"
			},
			{
				"name": "blackmailers",
				"salience": 0.0033674277,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.0032798585,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0032798585,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.003128042,
				"type": "LOCATION"
			},
			{
				"name": "Battleground States",
				"salience": 0.003128042,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.003128042,
				"type": "LOCATION"
			},
			{
				"name": "Base One",
				"salience": 0.0030301658,
				"type": "ORGANIZATION"
			},
			{
				"name": "command",
				"salience": 0.002961493,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fzds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Patent_and_Trademark_Office"
				},
				"name": "US Patent and Trademark Office",
				"salience": 0.0029352666,
				"type": "ORGANIZATION"
			},
			{
				"name": "offices",
				"salience": 0.0029020149,
				"type": "LOCATION"
			},
			{
				"name": "patent office",
				"salience": 0.0029020149,
				"type": "LOCATION"
			},
			{
				"name": "servers",
				"salience": 0.002840234,
				"type": "OTHER"
			},
			{
				"name": "servers",
				"salience": 0.002840234,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0028369944,
				"type": "PERSON"
			},
			{
				"name": "balloting equipment",
				"salience": 0.002819848,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "United States Marine",
				"salience": 0.002755698,
				"type": "ORGANIZATION"
			},
			{
				"name": "e-mail server company",
				"salience": 0.0027287235,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0027087512,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0024865097,
				"type": "OTHER"
			},
			{
				"name": "Governments",
				"salience": 0.0024865097,
				"type": "ORGANIZATION"
			},
			{
				"name": "more",
				"salience": 0.0024865097,
				"type": "OTHER"
			},
			{
				"name": "Paul Combetta",
				"salience": 0.0024038241,
				"type": "PERSON"
			},
			{
				"name": "consulting firms",
				"salience": 0.002403787,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01l4l4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Physical_Laboratory_(United_Kingdom)"
				},
				"name": "National Physical Laboratory",
				"salience": 0.0023752605,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0023155382,
				"type": "OTHER"
			},
			{
				"name": "CEO",
				"salience": 0.002270768,
				"type": "PERSON"
			},
			{
				"name": "Director",
				"salience": 0.0022207117,
				"type": "PERSON"
			},
			{
				"name": "courses",
				"salience": 0.0022207117,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0021178918,
				"type": "OTHER"
			},
			{
				"name": "Types of Exercise Workshop",
				"salience": 0.0021160939,
				"type": "EVENT"
			},
			{
				"name": "Serco 8",
				"salience": 0.002077205,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0020618986,
				"type": "LOCATION"
			},
			{
				"name": "companies",
				"salience": 0.0020385215,
				"type": "ORGANIZATION"
			},
			{
				"name": "military disciplines",
				"salience": 0.0020050977,
				"type": "OTHER"
			},
			{
				"name": "Voting Machines",
				"salience": 0.0020050977,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0020050977,
				"type": "OTHER"
			},
			{
				"name": "Voting Machines",
				"salience": 0.0020050977,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "flow-chart",
				"salience": 0.0020050977,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.0020050977,
				"type": "OTHER"
			},
			{
				"name": "flow-chart",
				"salience": 0.0020050977,
				"type": "OTHER"
			},
			{
				"name": "nationless",
				"salience": 0.0020050977,
				"type": "OTHER"
			},
			{
				"name": "McConnell Plum City",
				"salience": 0.0018895905,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0018794151,
				"type": "OTHER"
			},
			{
				"name": "voting equipment",
				"salience": 0.0018794151,
				"type": "OTHER"
			},
			{
				"name": "combat service support",
				"salience": 0.0018794151,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0018794151,
				"type": "LOCATION"
			},
			{
				"name": "blackmailers",
				"salience": 0.0018794151,
				"type": "PERSON"
			},
			{
				"name": "blackmailers",
				"salience": 0.0018794151,
				"type": "OTHER"
			},
			{
				"name": "pig-farm bridge",
				"salience": 0.0018794151,
				"type": "LOCATION"
			},
			{
				"name": "Field",
				"salience": 0.0018794151,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0018772426,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bkk6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_key_infrastructure"
				},
				"name": "PKI",
				"salience": 0.0018738096,
				"type": "OTHER"
			},
			{
				"name": "court action",
				"salience": 0.0018722052,
				"type": "EVENT"
			},
			{
				"name": "groups",
				"salience": 0.0018614602,
				"type": "ORGANIZATION"
			},
			{
				"name": "Maria Contreras-Sweet",
				"salience": 0.0018323791,
				"type": "PERSON"
			},
			{
				"name": "engineers",
				"salience": 0.0018236396,
				"type": "PERSON"
			},
			{
				"name": "ground combat",
				"salience": 0.0017362576,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0017362576,
				"type": "WORK_OF_ART"
			},
			{
				"name": "votes",
				"salience": 0.0017362576,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0017362576,
				"type": "ORGANIZATION"
			},
			{
				"name": "adults",
				"salience": 0.0017362576,
				"type": "PERSON"
			},
			{
				"name": "quest",
				"salience": 0.0017362576,
				"type": "OTHER"
			},
			{
				"name": "revelations",
				"salience": 0.0017362576,
				"type": "OTHER"
			},
			{
				"name": "billionaire",
				"salience": 0.0017362576,
				"type": "PERSON"
			},
			{
				"name": "Shareholders",
				"salience": 0.0017362576,
				"type": "PERSON"
			},
			{
				"name": "Media Coverage",
				"salience": 0.0017350449,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0017016007,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.0016927766,
				"type": "OTHER"
			},
			{
				"name": "Concern",
				"salience": 0.0016927766,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.001636899,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0016206212,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ian Donaldson",
				"salience": 0.0016113947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j05f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_Canadian_Mounted_Police"
				},
				"name": "RCMP",
				"salience": 0.0015867375,
				"type": "ORGANIZATION"
			},
			{
				"name": "website",
				"salience": 0.0015676601,
				"type": "OTHER"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.0015676601,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0015676601,
				"type": "OTHER"
			},
			{
				"name": "pig farm",
				"salience": 0.0015676601,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0015676601,
				"type": "PERSON"
			},
			{
				"name": "enemy capabilities",
				"salience": 0.0015676601,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0015676601,
				"type": "OTHER"
			},
			{
				"name": "Gold",
				"salience": 0.0015676601,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0015676601,
				"type": "OTHER"
			},
			{
				"name": "List",
				"salience": 0.0015676601,
				"type": "OTHER"
			},
			{
				"name": "court hearing",
				"salience": 0.0015606576,
				"type": "EVENT"
			},
			{
				"name": "Police",
				"salience": 0.0015210523,
				"type": "PERSON"
			},
			{
				"name": "McConnell -- Global Operations",
				"salience": 0.0014795801,
				"type": "ORGANIZATION"
			},
			{
				"name": "Defense Ammunition Center",
				"salience": 0.0014795801,
				"type": "ORGANIZATION"
			},
			{
				"name": "changes",
				"salience": 0.0014647713,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0014567117,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0014354971,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.0014252478,
				"type": "ORGANIZATION"
			},
			{
				"name": "site",
				"salience": 0.0013936867,
				"type": "OTHER"
			},
			{
				"name": "Concern Grows Over Soros",
				"salience": 0.001366867,
				"type": "OTHER"
			},
			{
				"name": "Starnet Raid",
				"salience": 0.001366867,
				"type": "ORGANIZATION"
			},
			{
				"name": "invention",
				"salience": 0.0013603662,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0013574491,
				"type": "EVENT"
			},
			{
				"name": "blackmail victims",
				"salience": 0.0013574491,
				"type": "PERSON"
			},
			{
				"name": "keys",
				"salience": 0.0013574491,
				"type": "OTHER"
			},
			{
				"name": "bets",
				"salience": 0.0013574491,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.0013574491,
				"type": "OTHER"
			},
			{
				"name": "Subsidiaries",
				"salience": 0.0013574491,
				"type": "ORGANIZATION"
			},
			{
				"name": "spokesperson",
				"salience": 0.0013574491,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0013574491,
				"type": "PERSON"
			},
			{
				"name": "board",
				"salience": 0.0013574491,
				"type": "ORGANIZATION"
			},
			{
				"name": "ransom",
				"salience": 0.0013574491,
				"type": "OTHER"
			},
			{
				"name": "bonus",
				"salience": 0.0013574491,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0013574491,
				"type": "OTHER"
			},
			{
				"name": "aviation",
				"salience": 0.0013574491,
				"type": "OTHER"
			},
			{
				"name": "Teachers",
				"salience": 0.0013574491,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.001350193,
				"type": "ORGANIZATION"
			},
			{
				"name": "battleground states",
				"salience": 0.0013207434,
				"type": "LOCATION"
			},
			{
				"name": "participants",
				"salience": 0.0013167833,
				"type": "PERSON"
			},
			{
				"name": "Peter Thiessen",
				"salience": 0.0013011064,
				"type": "PERSON"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0012916463,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.0012876644,
				"type": "LOCATION"
			},
			{
				"name": "voting station",
				"salience": 0.0012876644,
				"type": "LOCATION"
			},
			{
				"name": "Fee status",
				"salience": 0.0012876644,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0012797605,
				"type": "OTHER"
			},
			{
				"name": "Information Security Planning",
				"salience": 0.0012780434,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0012636324,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0011945764,
				"type": "PERSON"
			},
			{
				"name": "team",
				"salience": 0.001173999,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.0011654128,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0010690634,
				"type": "EVENT"
			},
			{
				"name": "Federal Bridge Certification Authority",
				"salience": 0.0010686268,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/021psw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Citizenship_and_Immigration_Services"
				},
				"name": "USCIS",
				"salience": 0.0010680975,
				"type": "ORGANIZATION"
			},
			{
				"name": "More",
				"salience": 0.0010234705,
				"type": "OTHER"
			},
			{
				"name": "units",
				"salience": 0.0010149956,
				"type": "OTHER"
			},
			{
				"name": "vendors",
				"salience": 0.0010126595,
				"type": "ORGANIZATION"
			},
			{
				"name": "center",
				"salience": 0.0010027613,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.0009894079,
				"type": "OTHER"
			},
			{
				"name": "PKIs",
				"salience": 0.0009664896,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00096484175,
				"type": "LOCATION"
			},
			{
				"name": "Abel Danger",
				"salience": 0.00096484175,
				"type": "OTHER"
			},
			{
				"name": "Soros' Open Society Foundations",
				"salience": 0.00096484175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03b_pxn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Association_of_Secretaries_of_State"
				},
				"name": "National Association of Secretaries of State",
				"salience": 0.00096484175,
				"type": "ORGANIZATION"
			},
			{
				"name": "contest",
				"salience": 0.0009530707,
				"type": "EVENT"
			},
			{
				"name": "police access",
				"salience": 0.0009530707,
				"type": "OTHER"
			},
			{
				"name": "host processor",
				"salience": 0.0009530707,
				"type": "OTHER"
			},
			{
				"name": "ACCESS",
				"salience": 0.0009530707,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.0009530707,
				"type": "WORK_OF_ART"
			},
			{
				"name": "e-mail server company",
				"salience": 0.00094660395,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.00094660395,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.00094660395,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.00094660395,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.00094660395,
				"type": "ORGANIZATION"
			},
			{
				"name": "hiring",
				"salience": 0.00093201734,
				"type": "OTHER"
			},
			{
				"name": "police raid",
				"salience": 0.00091402634,
				"type": "EVENT"
			},
			{
				"name": "court",
				"salience": 0.00091402634,
				"type": "LOCATION"
			},
			{
				"name": "court",
				"salience": 0.00091402634,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.00091402634,
				"type": "OTHER"
			},
			{
				"name": "election systems",
				"salience": 0.00091402634,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0009112614,
				"type": "ORGANIZATION"
			},
			{
				"name": "E-Mail Server Company",
				"salience": 0.0009112614,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.000910966,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0009102238,
				"type": "PERSON"
			},
			{
				"name": "Police investigation",
				"salience": 0.0009065565,
				"type": "EVENT"
			},
			{
				"name": "statements",
				"salience": 0.00090276124,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.0009025063,
				"type": "EVENT"
			},
			{
				"name": "women engineer",
				"salience": 0.0008887101,
				"type": "PERSON"
			},
			{
				"name": "data entry device",
				"salience": 0.00087928516,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "files",
				"salience": 0.0008716921,
				"type": "OTHER"
			},
			{
				"name": "searches",
				"salience": 0.0008716921,
				"type": "EVENT"
			},
			{
				"name": "resolution",
				"salience": 0.0008716921,
				"type": "OTHER"
			},
			{
				"name": "protocol",
				"salience": 0.0008716921,
				"type": "OTHER"
			},
			{
				"name": "Grant Application number",
				"salience": 0.0008716921,
				"type": "OTHER"
			},
			{
				"name": "Publication number",
				"salience": 0.0008716921,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0008716921,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.00086704735,
				"type": "OTHER"
			},
			{
				"name": "Police",
				"salience": 0.0008651726,
				"type": "PERSON"
			},
			{
				"name": "design",
				"salience": 0.000864324,
				"type": "OTHER"
			},
			{
				"name": "offices",
				"salience": 0.0008374923,
				"type": "LOCATION"
			},
			{
				"name": "company offices",
				"salience": 0.0008374923,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.0008374923,
				"type": "ORGANIZATION"
			},
			{
				"name": "offices",
				"salience": 0.0008374923,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.0008354455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/028z3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Pickton"
				},
				"name": "Pickton",
				"salience": 0.0008354455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Columbia"
				},
				"name": "B.C.",
				"salience": 0.0008354455,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hkqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_Martin"
				},
				"name": "Lockheed Martin",
				"salience": 0.0008354455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016mgj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Murder_of_JonBen%C3%A9t_Ramsey"
				},
				"name": "JonBenet",
				"salience": 0.0008354455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04mn99",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AXA"
				},
				"name": "AXA",
				"salience": 0.0008354455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0008354455,
				"type": "PERSON"
			},
			{
				"name": "Scandal Supercut Copy",
				"salience": 0.0008354455,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0008354455,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01r9k0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Certificate_authority"
				},
				"name": "CA",
				"salience": 0.0008354455,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "U.N.",
				"salience": 0.0008354455,
				"type": "ORGANIZATION"
			},
			{
				"name": "Edmund Kozak",
				"salience": 0.0008354455,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0008328697,
				"type": "PERSON"
			},
			{
				"name": "OTHERS",
				"salience": 0.0008252527,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0008252527,
				"type": "EVENT"
			},
			{
				"name": "staff",
				"salience": 0.0008252527,
				"type": "PERSON"
			},
			{
				"name": "Assignee",
				"salience": 0.0008252527,
				"type": "OTHER"
			},
			{
				"name": "voting pad input device",
				"salience": 0.0008252527,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "porn-peddler posting",
				"salience": 0.0008252527,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.0008252527,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Assignment",
				"salience": 0.0008252527,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0008252527,
				"type": "EVENT"
			},
			{
				"name": "device",
				"salience": 0.0008252527,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "documents",
				"salience": 0.0008252527,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0008252527,
				"type": "OTHER"
			},
			{
				"name": "COMMENTS",
				"salience": 0.00082275626,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officers",
				"salience": 0.00082157913,
				"type": "PERSON"
			},
			{
				"name": "revenues",
				"salience": 0.0008215657,
				"type": "OTHER"
			},
			{
				"name": "engineering",
				"salience": 0.00081850815,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.00080622267,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.0008010793,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0008010793,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0008010793,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.00080042664,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088zs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zulu_people"
				},
				"name": "Zulu",
				"salience": 0.000799958,
				"type": "PERSON"
			},
			{
				"name": "information systems",
				"salience": 0.00078497524,
				"type": "OTHER"
			},
			{
				"name": "Police",
				"salience": 0.0007816889,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0007816889,
				"type": "OTHER"
			},
			{
				"name": "defence",
				"salience": 0.000773509,
				"type": "OTHER"
			},
			{
				"name": "entertainment division",
				"salience": 0.000773509,
				"type": "ORGANIZATION"
			},
			{
				"name": "complexity",
				"salience": 0.0007727367,
				"type": "OTHER"
			},
			{
				"name": "components",
				"salience": 0.0007727367,
				"type": "OTHER"
			},
			{
				"name": "porn business",
				"salience": 0.000771169,
				"type": "OTHER"
			},
			{
				"name": "Table-top exercises",
				"salience": 0.0007682097,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.00076709804,
				"type": "OTHER"
			},
			{
				"name": "minority professionals",
				"salience": 0.00075982267,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.00075250235,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.00074849254,
				"type": "OTHER"
			},
			{
				"name": "information security policies",
				"salience": 0.00074762705,
				"type": "OTHER"
			},
			{
				"name": "investors",
				"salience": 0.0007400434,
				"type": "PERSON"
			},
			{
				"name": "investigators",
				"salience": 0.0007400434,
				"type": "PERSON"
			},
			{
				"name": "police investigation",
				"salience": 0.0007400434,
				"type": "EVENT"
			},
			{
				"name": "HeiTech Services, Inc.",
				"salience": 0.0007385412,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.00073694513,
				"type": "LOCATION"
			},
			{
				"name": "site",
				"salience": 0.0007298644,
				"type": "OTHER"
			},
			{
				"name": "recruitment ad",
				"salience": 0.00072100153,
				"type": "PERSON"
			},
			{
				"name": "grounds",
				"salience": 0.0007175235,
				"type": "LOCATION"
			},
			{
				"name": "more",
				"salience": 0.0007175235,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.00071682484,
				"type": "PERSON"
			},
			{
				"name": "HIRING SPREE",
				"salience": 0.00071457325,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.00071457325,
				"type": "EVENT"
			},
			{
				"name": "voter input",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "hiring spree",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "options",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00071457325,
				"type": "PERSON"
			},
			{
				"name": "Events",
				"salience": 0.00071457325,
				"type": "EVENT"
			},
			{
				"name": "headquarters",
				"salience": 0.00071457325,
				"type": "LOCATION"
			},
			{
				"name": "solicitor-client privilege",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "options",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "implementation",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "paper template",
				"salience": 0.00071457325,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "voting options",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "Names",
				"salience": 0.00071457325,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00071241154,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.0007087331,
				"type": "OTHER"
			},
			{
				"name": "porn division",
				"salience": 0.000703204,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00069768296,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00069768296,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0006936413,
				"type": "OTHER"
			},
			{
				"name": "centre",
				"salience": 0.0006936413,
				"type": "LOCATION"
			},
			{
				"name": "child pornography",
				"salience": 0.0006936413,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0006936413,
				"type": "OTHER"
			},
			{
				"name": "pornography",
				"salience": 0.0006936413,
				"type": "OTHER"
			},
			{
				"name": "government loans",
				"salience": 0.0006936413,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0006907324,
				"type": "ORGANIZATION"
			},
			{
				"name": "marketer",
				"salience": 0.0006907324,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.00068958366,
				"type": "PERSON"
			},
			{
				"name": "progress",
				"salience": 0.0006769475,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00067414145,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.00067367044,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0006681645,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0006681645,
				"type": "PERSON"
			},
			{
				"name": "contracts",
				"salience": 0.0006681645,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.0006677417,
				"type": "OTHER"
			},
			{
				"name": "dollar loan",
				"salience": 0.0006677417,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.0006677417,
				"type": "OTHER"
			},
			{
				"name": "adult pornography",
				"salience": 0.0006677417,
				"type": "OTHER"
			},
			{
				"name": "Loans",
				"salience": 0.0006677417,
				"type": "OTHER"
			},
			{
				"name": "government loans",
				"salience": 0.0006677417,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00066538726,
				"type": "LOCATION"
			},
			{
				"name": "US20070007340 Inventors",
				"salience": 0.0006496448,
				"type": "PERSON"
			},
			{
				"name": "Citation",
				"salience": 0.0006451678,
				"type": "OTHER"
			},
			{
				"name": "capacity",
				"salience": 0.0006451678,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0006451678,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0006451678,
				"type": "PERSON"
			},
			{
				"name": "challenge",
				"salience": 0.0006451678,
				"type": "OTHER"
			},
			{
				"name": "cover",
				"salience": 0.0006451678,
				"type": "OTHER"
			},
			{
				"name": "search warrant challenge",
				"salience": 0.0006451678,
				"type": "OTHER"
			},
			{
				"name": "PORN-PEDDLER",
				"salience": 0.0006451678,
				"type": "ORGANIZATION"
			},
			{
				"name": "Internet gambling",
				"salience": 0.0006451678,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0006451678,
				"type": "PERSON"
			},
			{
				"name": "pictures",
				"salience": 0.0006451678,
				"type": "WORK_OF_ART"
			},
			{
				"name": "preparation",
				"salience": 0.0006451678,
				"type": "OTHER"
			},
			{
				"name": "providers",
				"salience": 0.0006451678,
				"type": "ORGANIZATION"
			},
			{
				"name": "body parts",
				"salience": 0.000643216,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.000643216,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ad",
				"salience": 0.000643216,
				"type": "WORK_OF_ART"
			},
			{
				"name": "participation",
				"salience": 0.000643216,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00064078986,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.00064078986,
				"type": "EVENT"
			},
			{
				"name": "directors",
				"salience": 0.00064078986,
				"type": "PERSON"
			},
			{
				"name": "raid",
				"salience": 0.00064078986,
				"type": "EVENT"
			},
			{
				"name": "raid",
				"salience": 0.00064078986,
				"type": "EVENT"
			},
			{
				"name": "Starnet Communications International",
				"salience": 0.00062987534,
				"type": "ORGANIZATION"
			},
			{
				"name": "home page",
				"salience": 0.0006290062,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.000621512,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.00061880704,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.0006168633,
				"type": "EVENT"
			},
			{
				"name": "directors",
				"salience": 0.0006168633,
				"type": "PERSON"
			},
			{
				"name": "analysts",
				"salience": 0.0006168633,
				"type": "PERSON"
			},
			{
				"name": "document",
				"salience": 0.00061643234,
				"type": "WORK_OF_ART"
			},
			{
				"name": "search",
				"salience": 0.0006111087,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.0006111087,
				"type": "OTHER"
			},
			{
				"name": "company sites",
				"salience": 0.0006111087,
				"type": "LOCATION"
			},
			{
				"name": "resources",
				"salience": 0.0006111087,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.00061050936,
				"type": "OTHER"
			},
			{
				"name": "Super Serco",
				"salience": 0.00059936405,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.0005882903,
				"type": "PERSON"
			},
			{
				"name": "sites",
				"salience": 0.0005882903,
				"type": "LOCATION"
			},
			{
				"name": "e-mails",
				"salience": 0.0005882903,
				"type": "WORK_OF_ART"
			},
			{
				"name": "E-Mails",
				"salience": 0.0005882903,
				"type": "OTHER"
			},
			{
				"name": "porn sites",
				"salience": 0.0005882903,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0005882903,
				"type": "PERSON"
			},
			{
				"name": "intensity",
				"salience": 0.00058572576,
				"type": "OTHER"
			},
			{
				"name": "grouping",
				"salience": 0.00058572576,
				"type": "ORGANIZATION"
			},
			{
				"name": "Profit growth",
				"salience": 0.0005829098,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00057854975,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00057854975,
				"type": "LOCATION"
			},
			{
				"name": "network",
				"salience": 0.00057854975,
				"type": "OTHER"
			},
			{
				"name": "counts",
				"salience": 0.00057777966,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00057105295,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0155qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_Corps_Base_Camp_Pendleton"
				},
				"name": "Camp Pendleton",
				"salience": 0.0005710239,
				"type": "LOCATION"
			},
			{
				"name": "BREAKING",
				"salience": 0.0005683075,
				"type": "EVENT"
			},
			{
				"name": "teamwork",
				"salience": 0.00056622963,
				"type": "OTHER"
			},
			{
				"name": "talent pool",
				"salience": 0.00056330586,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sbhb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_British_Columbia"
				},
				"name": "Supreme Court of British Columbia",
				"salience": 0.00056251354,
				"type": "ORGANIZATION"
			},
			{
				"name": "TSymmetry, Inc.",
				"salience": 0.00056080404,
				"type": "ORGANIZATION"
			},
			{
				"name": "Serco , Inc.",
				"salience": 0.00056080404,
				"type": "ORGANIZATION"
			},
			{
				"name": "privilege claim",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00055863685,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "motion",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "residence",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "curve",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "deals",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "Links",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "Classifications",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "embodiment",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "selection",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "reliability",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "functions",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "simplicity",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "durability",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "deployment",
				"salience": 0.00055863685,
				"type": "EVENT"
			},
			{
				"name": "reusability",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "symbols",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "geometry",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "codes",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "accuracy",
				"salience": 0.00055863685,
				"type": "OTHER"
			},
			{
				"name": "assistant",
				"salience": 0.00055694685,
				"type": "PERSON"
			},
			{
				"name": "assistant",
				"salience": 0.00055694685,
				"type": "PERSON"
			},
			{
				"name": "data",
				"salience": 0.00055694685,
				"type": "OTHER"
			},
			{
				"name": "straps",
				"salience": 0.00055694685,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.00055694685,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.00055694685,
				"type": "OTHER"
			},
			{
				"name": "market research",
				"salience": 0.00055694685,
				"type": "OTHER"
			},
			{
				"name": "disclosure",
				"salience": 0.00055694685,
				"type": "EVENT"
			},
			{
				"name": "documentation",
				"salience": 0.00055694685,
				"type": "OTHER"
			},
			{
				"name": "search warrant",
				"salience": 0.0005562055,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n5zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Component_Object_Model"
				},
				"name": "COM",
				"salience": 0.0005556539,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0005520452,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.0005520452,
				"type": "ORGANIZATION"
			},
			{
				"name": "status",
				"salience": 0.00055046653,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0005474695,
				"type": "OTHER"
			},
			{
				"name": "Exercises",
				"salience": 0.0005454319,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0005454319,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.0005454319,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.0005454319,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.0005454319,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.0005454319,
				"type": "OTHER"
			},
			{
				"name": "recruitment ad",
				"salience": 0.0005454319,
				"type": "WORK_OF_ART"
			},
			{
				"name": "control",
				"salience": 0.0005454319,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00054227206,
				"type": "LOCATION"
			},
			{
				"name": "trading",
				"salience": 0.00054227206,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.00054227206,
				"type": "LOCATION"
			},
			{
				"name": "entertainment",
				"salience": 0.00054227206,
				"type": "OTHER"
			},
			{
				"name": "warrant",
				"salience": 0.00054227206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08_ykc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Small_Business_Administration"
				},
				"name": "Small Business Administration",
				"salience": 0.00053669314,
				"type": "ORGANIZATION"
			},
			{
				"name": "Co-ordinated Law Enforcement Unit",
				"salience": 0.00053645764,
				"type": "ORGANIZATION"
			},
			{
				"name": "NVC",
				"salience": 0.0005355022,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0005337549,
				"type": "OTHER"
			},
			{
				"name": "invention",
				"salience": 0.00052869227,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00052308483,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.0005220236,
				"type": "OTHER"
			},
			{
				"name": "count",
				"salience": 0.0005220236,
				"type": "OTHER"
			},
			{
				"name": "HTML programmers",
				"salience": 0.0005220236,
				"type": "OTHER"
			},
			{
				"name": "search warrant",
				"salience": 0.0005220236,
				"type": "OTHER"
			},
			{
				"name": "horse bridles",
				"salience": 0.0005220236,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00051260303,
				"type": "OTHER"
			},
			{
				"name": "order book",
				"salience": 0.0005047278,
				"type": "WORK_OF_ART"
			},
			{
				"name": "users",
				"salience": 0.0005040604,
				"type": "PERSON"
			},
			{
				"name": "gaming",
				"salience": 0.00050095253,
				"type": "OTHER"
			},
			{
				"name": "cutting edge",
				"salience": 0.00050095253,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.00050095253,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00050095253,
				"type": "OTHER"
			},
			{
				"name": "Internet gaming",
				"salience": 0.00050095253,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00050095253,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.00050095253,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00050095253,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.00050095253,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.00050095253,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Simulation",
				"salience": 0.0005006025,
				"type": "OTHER"
			},
			{
				"name": "planning",
				"salience": 0.000498855,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.000498855,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.000498855,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.000498855,
				"type": "OTHER"
			},
			{
				"name": "research team",
				"salience": 0.00049877213,
				"type": "ORGANIZATION"
			},
			{
				"name": "network",
				"salience": 0.00049685803,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00048845983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cn2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_Communications_Headquarters"
				},
				"name": "GCHQ",
				"salience": 0.00048762077,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z7yn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Customs_Service"
				},
				"name": "United States Customs Service",
				"salience": 0.0004855933,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03z19",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Internal_Revenue_Service"
				},
				"name": "U.S. Internal Revenue Service",
				"salience": 0.0004855933,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04570",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joule"
				},
				"name": "K.J.",
				"salience": 0.00048456262,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0004822467,
				"type": "EVENT"
			},
			{
				"name": "name",
				"salience": 0.0004822467,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0004822467,
				"type": "OTHER"
			},
			{
				"name": "manager",
				"salience": 0.0004822467,
				"type": "PERSON"
			},
			{
				"name": "Internet marketing manager",
				"salience": 0.0004822467,
				"type": "PERSON"
			},
			{
				"name": "adult entertainment division assets",
				"salience": 0.0004822467,
				"type": "OTHER"
			},
			{
				"name": "designers",
				"salience": 0.0004822467,
				"type": "PERSON"
			},
			{
				"name": "investor relations",
				"salience": 0.0004822467,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0004822467,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mainstream media",
				"salience": 0.0004822467,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0004822467,
				"type": "OTHER"
			},
			{
				"name": "AM ET Police",
				"salience": 0.0004810632,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.00047663544,
				"type": "OTHER"
			},
			{
				"name": "US7537159 B2 Publication",
				"salience": 0.00047602874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "profits",
				"salience": 0.00047227598,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.00047227598,
				"type": "PERSON"
			},
			{
				"name": "organisations",
				"salience": 0.00047227598,
				"type": "ORGANIZATION"
			},
			{
				"name": "Command Post",
				"salience": 0.00047227598,
				"type": "OTHER"
			},
			{
				"name": "organisation",
				"salience": 0.00047227598,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020zkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ontario_Provincial_Police"
				},
				"name": "Ontario Provincial Police",
				"salience": 0.00046309995,
				"type": "ORGANIZATION"
			},
			{
				"name": "users",
				"salience": 0.00045838745,
				"type": "PERSON"
			},
			{
				"name": "thinking",
				"salience": 0.00045602044,
				"type": "OTHER"
			},
			{
				"name": "SSL protocol",
				"salience": 0.00045351055,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00045229317,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00045229317,
				"type": "EVENT"
			},
			{
				"name": "light",
				"salience": 0.00045229317,
				"type": "OTHER"
			},
			{
				"name": "licensing agreements",
				"salience": 0.00045229317,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00045229317,
				"type": "OTHER"
			},
			{
				"name": "gambling",
				"salience": 0.00045229317,
				"type": "OTHER"
			},
			{
				"name": "marketing representative",
				"salience": 0.00045027223,
				"type": "PERSON"
			},
			{
				"name": "rigour",
				"salience": 0.00045027223,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0004452408,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0004452408,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "mix",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "dividends",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "high frequency trading",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "simulation support",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00044266135,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0004389922,
				"type": "OTHER"
			},
			{
				"name": "@HillaryClinton",
				"salience": 0.00043842566,
				"type": "PERSON"
			},
			{
				"name": "Government",
				"salience": 0.00043750758,
				"type": "ORGANIZATION"
			},
			{
				"name": "market",
				"salience": 0.00043750758,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00043750758,
				"type": "OTHER"
			},
			{
				"name": "mix",
				"salience": 0.0004370815,
				"type": "OTHER"
			},
			{
				"name": "considerations",
				"salience": 0.00043657603,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.00043540407,
				"type": "OTHER"
			},
			{
				"name": "distribution",
				"salience": 0.00043540407,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.00043540407,
				"type": "OTHER"
			},
			{
				"name": "team effort",
				"salience": 0.00043540407,
				"type": "OTHER"
			},
			{
				"name": "pictures",
				"salience": 0.00043540407,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Office of Partner Relations",
				"salience": 0.00042450512,
				"type": "OTHER"
			},
			{
				"name": "business operations",
				"salience": 0.00042294437,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.00042294437,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00042294437,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00042294437,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00042294437,
				"type": "ORGANIZATION"
			},
			{
				"name": "veteran firms",
				"salience": 0.00042294437,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00042294437,
				"type": "ORGANIZATION"
			},
			{
				"name": "leaks",
				"salience": 0.00042259975,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01ryjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cabinet_Office"
				},
				"name": "UK Cabinet Office",
				"salience": 0.0004207318,
				"type": "ORGANIZATION"
			},
			{
				"name": "cutting edge solutions",
				"salience": 0.00041768243,
				"type": "OTHER"
			},
			{
				"name": "cutting edge solutions",
				"salience": 0.00041768243,
				"type": "OTHER"
			},
			{
				"name": "grey",
				"salience": 0.00041727273,
				"type": "OTHER"
			},
			{
				"name": "caesium fountain atomic clock",
				"salience": 0.0004120129,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.00040893097,
				"type": "ORGANIZATION"
			},
			{
				"name": "locations",
				"salience": 0.00040893097,
				"type": "LOCATION"
			},
			{
				"name": "roles",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.00040893097,
				"type": "LOCATION"
			},
			{
				"name": "tempo",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "training benefit",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "information flow",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "management",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "exercise tempo",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.00040893097,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.00040740895,
				"type": "PERSON"
			},
			{
				"name": "diversity",
				"salience": 0.00040740895,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.00040740895,
				"type": "PERSON"
			},
			{
				"name": "engineers",
				"salience": 0.00040740895,
				"type": "PERSON"
			},
			{
				"name": "diversity",
				"salience": 0.00040740895,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.00040504863,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0004016912,
				"type": "OTHER"
			},
			{
				"name": "pass",
				"salience": 0.0004016912,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/069pbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antigua"
				},
				"name": "Antigua",
				"salience": 0.00039704033,
				"type": "LOCATION"
			},
			{
				"name": "Ref Man Patent Citations",
				"salience": 0.00039704033,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.00039542778,
				"type": "OTHER"
			},
			{
				"name": "implementation",
				"salience": 0.0003936609,
				"type": "OTHER"
			},
			{
				"name": "opportunities",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "friendly",
				"salience": 0.0003916281,
				"type": "EVENT"
			},
			{
				"name": "sex side",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "Share prices",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "gaming software",
				"salience": 0.0003916281,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "government bureaucrats",
				"salience": 0.0003916281,
				"type": "PERSON"
			},
			{
				"name": "favors",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "materials",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "seizure",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "defence budgets",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "sex shows",
				"salience": 0.0003916281,
				"type": "WORK_OF_ART"
			},
			{
				"name": "money laundering",
				"salience": 0.0003916281,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00039071625,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00039071625,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00039071625,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00039071625,
				"type": "OTHER"
			},
			{
				"name": "vendors",
				"salience": 0.000378961,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigations",
				"salience": 0.0003778145,
				"type": "EVENT"
			},
			{
				"name": "purpose",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "sports odds",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "web-surfers",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "sections",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "bondage",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "teaser",
				"salience": 0.0003770041,
				"type": "WORK_OF_ART"
			},
			{
				"name": "editor",
				"salience": 0.0003770041,
				"type": "PERSON"
			},
			{
				"name": "team atmosphere",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "tips",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "advertising",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "clamps",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "bits",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "belts",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "demographics",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "mouths",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "circulation",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "office space",
				"salience": 0.0003770041,
				"type": "LOCATION"
			},
			{
				"name": "condo",
				"salience": 0.0003770041,
				"type": "LOCATION"
			},
			{
				"name": "shots",
				"salience": 0.0003770041,
				"type": "OTHER"
			},
			{
				"name": "Base One",
				"salience": 0.00037510562,
				"type": "ORGANIZATION"
			},
			{
				"name": "resources",
				"salience": 0.00037261727,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.00037261727,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.00037261727,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.00037261727,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.00037261727,
				"type": "OTHER"
			},
			{
				"name": "Women",
				"salience": 0.00037261727,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.00037261727,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00037261727,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.00037188292,
				"type": "PERSON"
			},
			{
				"name": "exercising package",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "breadth",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "Table Top",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0003692091,
				"type": "EVENT"
			},
			{
				"name": "innovation",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "goodbye",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "media play",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "innovation",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0003692091,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.0003692091,
				"type": "LOCATION"
			},
			{
				"name": "decision making",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "City",
				"salience": 0.0003692091,
				"type": "LOCATION"
			},
			{
				"name": "levels",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "decision making",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "goodwill",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.0003692091,
				"type": "OTHER"
			},
			{
				"name": "home page",
				"salience": 0.00036455505,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.00036396054,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0003629261,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00035787735,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00035787735,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00035571202,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.00035571202,
				"type": "ORGANIZATION"
			},
			{
				"name": "business",
				"salience": 0.00035571202,
				"type": "OTHER"
			},
			{
				"name": "diversity recruitment",
				"salience": 0.0003527635,
				"type": "OTHER"
			},
			{
				"name": "staffing",
				"salience": 0.0003527635,
				"type": "OTHER"
			},
			{
				"name": "Strategy",
				"salience": 0.0003527635,
				"type": "OTHER"
			},
			{
				"name": "professionals",
				"salience": 0.0003527635,
				"type": "PERSON"
			},
			{
				"name": "diversity recruiting",
				"salience": 0.0003527635,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0003527635,
				"type": "PERSON"
			},
			{
				"name": "technology research",
				"salience": 0.0003527635,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0003527635,
				"type": "PERSON"
			},
			{
				"name": "IT professionals",
				"salience": 0.0003527635,
				"type": "PERSON"
			},
			{
				"name": "community organizations",
				"salience": 0.0003527635,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.0003527635,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0003527635,
				"type": "ORGANIZATION"
			},
			{
				"name": "access",
				"salience": 0.00034988014,
				"type": "OTHER"
			},
			{
				"name": "Centre of Carbon Measurement",
				"salience": 0.00034845842,
				"type": "ORGANIZATION"
			},
			{
				"name": "Antonio Mugica",
				"salience": 0.00034378553,
				"type": "PERSON"
			},
			{
				"name": "Adultv.com",
				"salience": 0.00034378553,
				"type": "OTHER"
			},
			{
				"name": "Espacenet",
				"salience": 0.00034378553,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02l0wnp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BibTeX"
				},
				"name": "BiBTeX",
				"salience": 0.00034378553,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Smartmatic International Corporation Export",
				"salience": 0.00034378553,
				"type": "ORGANIZATION"
			},
			{
				"name": "Brent Mudry",
				"salience": 0.00034378553,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ggl4x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/EndNote"
				},
				"name": "EndNote",
				"salience": 0.00034378553,
				"type": "OTHER"
			},
			{
				"name": "WorldBroadcasts.com",
				"salience": 0.00034274542,
				"type": "ORGANIZATION"
			},
			{
				"name": "Redlight.com",
				"salience": 0.00034274542,
				"type": "OTHER"
			},
			{
				"name": "Redlight.com",
				"salience": 0.00034274542,
				"type": "ORGANIZATION"
			},
			{
				"name": "nationals",
				"salience": 0.00034169754,
				"type": "PERSON"
			},
			{
				"name": "applicant",
				"salience": 0.00033959065,
				"type": "PERSON"
			},
			{
				"name": "rise",
				"salience": 0.00033632744,
				"type": "OTHER"
			},
			{
				"name": "Consumer groups",
				"salience": 0.0003309647,
				"type": "ORGANIZATION"
			},
			{
				"name": "pools",
				"salience": 0.0003306424,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0003306424,
				"type": "OTHER"
			},
			{
				"name": "diversity mix",
				"salience": 0.0003306424,
				"type": "OTHER"
			},
			{
				"name": "diversity mix",
				"salience": 0.0003306424,
				"type": "OTHER"
			},
			{
				"name": "pool",
				"salience": 0.0003306424,
				"type": "LOCATION"
			},
			{
				"name": "field",
				"salience": 0.0003306424,
				"type": "OTHER"
			},
			{
				"name": "pool",
				"salience": 0.0003306424,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0003281691,
				"type": "OTHER"
			},
			{
				"name": "group finance director",
				"salience": 0.0003230144,
				"type": "PERSON"
			},
			{
				"name": "accomplishments",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "environment",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "farewell",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "forest bulldozers",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "airport radar",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "readiness",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "Punk",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "prisons",
				"salience": 0.00031968695,
				"type": "LOCATION"
			},
			{
				"name": "coordination",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "running banks",
				"salience": 0.00031968695,
				"type": "ORGANIZATION"
			},
			{
				"name": "footprint",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "carbon emissions reductions",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "rehearsal",
				"salience": 0.00031968695,
				"type": "EVENT"
			},
			{
				"name": "achievements",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.00031968695,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00031860577,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02t27n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_of_Information_Act_(United_States)"
				},
				"name": "Freedom of Information Act",
				"salience": 0.00031739485,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.00031396933,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.00031396933,
				"type": "ORGANIZATION"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.00031172903,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00030944333,
				"type": "ORGANIZATION"
			},
			{
				"name": "teams",
				"salience": 0.0003080001,
				"type": "ORGANIZATION"
			},
			{
				"name": "visas",
				"salience": 0.0003080001,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.0003080001,
				"type": "LOCATION"
			},
			{
				"name": "center",
				"salience": 0.0003080001,
				"type": "LOCATION"
			},
			{
				"name": "firm",
				"salience": 0.0003080001,
				"type": "ORGANIZATION"
			},
			{
				"name": "Stocks",
				"salience": 0.0003077491,
				"type": "OTHER"
			},
			{
				"name": "surplus",
				"salience": 0.0003077491,
				"type": "OTHER"
			},
			{
				"name": "Kabul for COM approval",
				"salience": 0.00030736104,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "government implementations",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.00030544703,
				"type": "ORGANIZATION"
			},
			{
				"name": "IT positions",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "IT projects",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.00030544703,
				"type": "ORGANIZATION"
			},
			{
				"name": "affiliations",
				"salience": 0.00030544703,
				"type": "ORGANIZATION"
			},
			{
				"name": "viewpoint",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "relationships",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.00030544703,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00030325583,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0003006842,
				"type": "OTHER"
			},
			{
				"name": "contractor",
				"salience": 0.0003004741,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.00029942518,
				"type": "LOCATION"
			},
			{
				"name": "GotNews.com/donate",
				"salience": 0.00029677257,
				"type": "OTHER"
			},
			{
				"name": "@gotnews.com",
				"salience": 0.00029677257,
				"type": "PERSON"
			},
			{
				"name": "processes",
				"salience": 0.0002966864,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.00029252248,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.00029252248,
				"type": "OTHER"
			},
			{
				"name": "discoveries",
				"salience": 0.00029163747,
				"type": "EVENT"
			},
			{
				"name": "deputy director",
				"salience": 0.00028453,
				"type": "PERSON"
			},
			{
				"name": "risk analysis",
				"salience": 0.00028453,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.00028453,
				"type": "PERSON"
			},
			{
				"name": "communications",
				"salience": 0.00028347093,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00028347093,
				"type": "OTHER"
			},
			{
				"name": "communication",
				"salience": 0.00028347093,
				"type": "OTHER"
			},
			{
				"name": "GotNews",
				"salience": 0.0002783384,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.0002783384,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02vk77f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBC_News"
				},
				"name": "CBC News",
				"salience": 0.0002783384,
				"type": "ORGANIZATION"
			},
			{
				"name": "scenario",
				"salience": 0.00027804918,
				"type": "OTHER"
			},
			{
				"name": "spectrum",
				"salience": 0.00027577643,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.00027577643,
				"type": "OTHER"
			},
			{
				"name": "Clients",
				"salience": 0.00027577643,
				"type": "PERSON"
			},
			{
				"name": "Information Security Expertise",
				"salience": 0.00027577643,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00027577643,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00027577643,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.00027577643,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00027577643,
				"type": "PERSON"
			},
			{
				"name": "individuals",
				"salience": 0.00027577643,
				"type": "PERSON"
			},
			{
				"name": "diversity talent",
				"salience": 0.00027577643,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.00027134945,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.00027134945,
				"type": "OTHER"
			},
			{
				"name": "visa files",
				"salience": 0.00027134945,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.00027134945,
				"type": "OTHER"
			},
			{
				"name": "contacteditor@gotnews.com",
				"salience": 0.0002679445,
				"type": "OTHER"
			},
			{
				"name": "GotNews",
				"salience": 0.0002679445,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dth9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Information_Systems_Agency"
				},
				"name": "Defense Information Systems Agency",
				"salience": 0.000263759,
				"type": "ORGANIZATION"
			},
			{
				"name": "communications",
				"salience": 0.00026269507,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.00025689107,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.00025689107,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.00025689107,
				"type": "WORK_OF_ART"
			},
			{
				"name": "applicants",
				"salience": 0.00025689107,
				"type": "PERSON"
			},
			{
				"name": "contract employees",
				"salience": 0.00025689107,
				"type": "PERSON"
			},
			{
				"name": "visa applications",
				"salience": 0.00025689107,
				"type": "OTHER"
			},
			{
				"name": "incident documentation",
				"salience": 0.00025689107,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.00025689107,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.00025689107,
				"type": "OTHER"
			},
			{
				"name": "employers",
				"salience": 0.00025689107,
				"type": "ORGANIZATION"
			},
			{
				"name": "strategies",
				"salience": 0.00025689107,
				"type": "OTHER"
			},
			{
				"name": "hub zone location",
				"salience": 0.00025574316,
				"type": "LOCATION"
			},
			{
				"name": "analysis",
				"salience": 0.00024747092,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.00024719696,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.00024100397,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.00024100397,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0261m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caribbean"
				},
				"name": "Caribbean",
				"salience": 0.00024100397,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.00024100397,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanic",
				"salience": 0.00024100397,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.00024100397,
				"type": "PERSON"
			},
			{
				"name": "petition",
				"salience": 0.00024078152,
				"type": "OTHER"
			},
			{
				"name": "Information Security Counter",
				"salience": 0.00024078152,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.00024078152,
				"type": "OTHER"
			},
			{
				"name": "visa petitions",
				"salience": 0.00024078152,
				"type": "OTHER"
			},
			{
				"name": "petitions",
				"salience": 0.00024078152,
				"type": "OTHER"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.00024078152,
				"type": "PERSON"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.00024078152,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.00024078152,
				"type": "PERSON"
			},
			{
				"name": "scope",
				"salience": 0.00023878561,
				"type": "OTHER"
			},
			{
				"name": "computer hackers",
				"salience": 0.00023878561,
				"type": "PERSON"
			},
			{
				"name": "data theft",
				"salience": 0.00023878561,
				"type": "OTHER"
			},
			{
				"name": "IT skills",
				"salience": 0.00023878561,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.00023878561,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.00023878561,
				"type": "OTHER"
			},
			{
				"name": "points of view",
				"salience": 0.00023878561,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.000237978,
				"type": "ORGANIZATION"
			},
			{
				"name": "market",
				"salience": 0.000237978,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00023683377,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00023683377,
				"type": "OTHER"
			},
			{
				"name": "DKW Communications, Inc.",
				"salience": 0.00023354647,
				"type": "ORGANIZATION"
			},
			{
				"name": "cryptographic engineering",
				"salience": 0.00023314074,
				"type": "OTHER"
			},
			{
				"name": "USAspending.gov",
				"salience": 0.00023200414,
				"type": "OTHER"
			},
			{
				"name": "Sizzler.com",
				"salience": 0.00023200414,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.00023200414,
				"type": "PERSON"
			},
			{
				"name": "CLEU",
				"salience": 0.00023200414,
				"type": "ORGANIZATION"
			},
			{
				"name": "CHARLES C. JOHNSON",
				"salience": 0.00023200414,
				"type": "PERSON"
			},
			{
				"name": "Chisel.com",
				"salience": 0.00023200414,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00023005609,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.00023005609,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v06q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Emergency_Planning_College"
				},
				"name": "Emergency Planning College",
				"salience": 0.00022720701,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09bbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gold_standard"
				},
				"name": "Gold Standard",
				"salience": 0.00022720701,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.00022719376,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0158jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_service"
				},
				"name": "Civil Service",
				"salience": 0.00022397697,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02dqk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Foreign_Service"
				},
				"name": "Foreign Service",
				"salience": 0.00022397697,
				"type": "ORGANIZATION"
			},
			{
				"name": "results",
				"salience": 0.00022243326,
				"type": "OTHER"
			},
			{
				"name": "appointment scheduling",
				"salience": 0.00022243326,
				"type": "OTHER"
			},
			{
				"name": "designs",
				"salience": 0.00022243326,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information technology risk",
				"salience": 0.00022243326,
				"type": "OTHER"
			},
			{
				"name": "assessments",
				"salience": 0.00022243326,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00022243326,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00022160531,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00022160531,
				"type": "OTHER"
			},
			{
				"name": "file number",
				"salience": 0.00021870961,
				"type": "OTHER"
			},
			{
				"name": "Diversity Recruitment and Staffing",
				"salience": 0.00021708621,
				"type": "OTHER"
			},
			{
				"name": "BUSINESS CORPORATION",
				"salience": 0.00021397726,
				"type": "ORGANIZATION"
			},
			{
				"name": "time line",
				"salience": 0.00021302109,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00021281002,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.00021252509,
				"type": "EVENT"
			},
			{
				"name": "immigrant",
				"salience": 0.00021237659,
				"type": "PERSON"
			},
			{
				"name": "assistance",
				"salience": 0.00020969937,
				"type": "OTHER"
			},
			{
				"name": "package",
				"salience": 0.00020598662,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00020598662,
				"type": "OTHER"
			},
			{
				"name": "Pentagon Renovation Program",
				"salience": 0.00020347268,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00020267992,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00020267992,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.00020267992,
				"type": "OTHER"
			},
			{
				"name": "cryptographic protocols",
				"salience": 0.00020267992,
				"type": "OTHER"
			},
			{
				"name": "mail",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "successor",
				"salience": 0.000200826,
				"type": "PERSON"
			},
			{
				"name": "filing",
				"salience": 0.000200826,
				"type": "EVENT"
			},
			{
				"name": "Citizenship",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "Agreements",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.000200826,
				"type": "LOCATION"
			},
			{
				"name": "safety",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "preprocessing",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "paperwork",
				"salience": 0.000200826,
				"type": "OTHER"
			},
			{
				"name": "penetration testing",
				"salience": 0.00019992862,
				"type": "EVENT"
			},
			{
				"name": "data",
				"salience": 0.00019932371,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00019829438,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00019829438,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.0001974083,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01tjvv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Durban"
				},
				"name": "Durban",
				"salience": 0.00019673063,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02fvf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Docklands_Light_Railway"
				},
				"name": "Docklands Light Railway",
				"salience": 0.00019673063,
				"type": "LOCATION"
			},
			{
				"name": "Fetish",
				"salience": 0.00019425062,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00019188027,
				"type": "PERSON"
			},
			{
				"name": "recognition",
				"salience": 0.00019188027,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00019188027,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.00019188027,
				"type": "PERSON"
			},
			{
				"name": "disclosure",
				"salience": 0.00019188027,
				"type": "OTHER"
			},
			{
				"name": "databases",
				"salience": 0.00019188027,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00019188027,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.00019188027,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00019188027,
				"type": "LOCATION"
			},
			{
				"name": "role",
				"salience": 0.00019102286,
				"type": "OTHER"
			},
			{
				"name": "Special Immigrant Visa",
				"salience": 0.00018953848,
				"type": "OTHER"
			},
			{
				"name": "Transitional Immigrant Visa Processing Center",
				"salience": 0.00018953848,
				"type": "ORGANIZATION"
			},
			{
				"name": "presentation",
				"salience": 0.00018610698,
				"type": "OTHER"
			},
			{
				"name": "finance director",
				"salience": 0.00018484394,
				"type": "PERSON"
			},
			{
				"name": "concurrence",
				"salience": 0.00018157125,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00017984732,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00017984732,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00017984732,
				"type": "OTHER"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.00017959836,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.0001783565,
				"type": "OTHER"
			},
			{
				"name": "primitives",
				"salience": 0.00017610811,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03b9f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_jury"
				},
				"name": "Grand Juries",
				"salience": 0.00017473962,
				"type": "ORGANIZATION"
			},
			{
				"name": "embassies",
				"salience": 0.00017388807,
				"type": "LOCATION"
			},
			{
				"name": "logging",
				"salience": 0.00017388807,
				"type": "EVENT"
			},
			{
				"name": "utilization",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "fiancé",
				"salience": 0.00017388807,
				"type": "PERSON"
			},
			{
				"name": "hopes",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "military pilot",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "fees",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "airline",
				"salience": 0.00017388807,
				"type": "ORGANIZATION"
			},
			{
				"name": "honey-pots",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "visa pre-processing",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "implements",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00017388807,
				"type": "PERSON"
			},
			{
				"name": "dreams",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "adjudication",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "inception",
				"salience": 0.00017388807,
				"type": "EVENT"
			},
			{
				"name": "mentoring goals",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "file rooms",
				"salience": 0.00017388807,
				"type": "LOCATION"
			},
			{
				"name": "shelves",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"name": "Yours",
				"salience": 0.00017388807,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/028j0m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minority_group"
				},
				"name": "Minority",
				"salience": 0.00016970794,
				"type": "ORGANIZATION"
			},
			{
				"name": "Disabled Veteran",
				"salience": 0.00016970794,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dfb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citigroup"
				},
				"name": "Citigroup",
				"salience": 0.00016970794,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.00016970794,
				"type": "PERSON"
			},
			{
				"name": "Mentor Protégé",
				"salience": 0.00016698359,
				"type": "OTHER"
			},
			{
				"name": "projects",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "Head",
				"salience": 0.00016614221,
				"type": "PERSON"
			},
			{
				"name": "Web users",
				"salience": 0.00016614221,
				"type": "PERSON"
			},
			{
				"name": "server authentication",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "technology project",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "web browsers",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "spread",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "authentication",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "shareholder",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "schemes",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"name": "Developments",
				"salience": 0.00016614221,
				"type": "EVENT"
			},
			{
				"name": "privacy",
				"salience": 0.00016614221,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "DHS",
				"salience": 0.00016275774,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.00016197978,
				"type": "OTHER"
			},
			{
				"name": "video clip",
				"salience": 0.00015911189,
				"type": "WORK_OF_ART"
			},
			{
				"name": "COM",
				"salience": 0.00015808591,
				"type": "ORGANIZATION"
			},
			{
				"name": "chief executive",
				"salience": 0.00015642223,
				"type": "PERSON"
			},
			{
				"name": "Vendors",
				"salience": 0.00015396514,
				"type": "ORGANIZATION"
			},
			{
				"name": "laws",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "entrepreneurs",
				"salience": 0.00015000289,
				"type": "PERSON"
			},
			{
				"name": "liability",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "signature",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "algorithms",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "encryption algorithms",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.00015000289,
				"type": "EVENT"
			},
			{
				"name": "liability",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "floor",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "government customers",
				"salience": 0.00015000289,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.00015000289,
				"type": "OTHER"
			},
			{
				"name": "Common Access Cards",
				"salience": 0.00014694387,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_hj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Aviation_Administration"
				},
				"name": "FAA",
				"salience": 0.00014694387,
				"type": "ORGANIZATION"
			},
			{
				"name": "MCI",
				"salience": 0.00014694387,
				"type": "ORGANIZATION"
			},
			{
				"name": "MWBD",
				"salience": 0.00014694387,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.00014694387,
				"type": "LOCATION"
			},
			{
				"name": "Mentor Protégé Team Award",
				"salience": 0.00014326241,
				"type": "OTHER"
			},
			{
				"name": "handling.",
				"salience": 0.00014194369,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Trade_Center_(1973%E2%80%932001)"
				},
				"name": "World Trade Center",
				"salience": 0.00014157177,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00014092591,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0262dl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Private_company_limited_by_shares"
				},
				"name": "Ltd.",
				"salience": 0.00013791242,
				"type": "LOCATION"
			},
			{
				"name": "Field McConnell",
				"salience": 0.00013688073,
				"type": "PERSON"
			},
			{
				"name": "pioneers",
				"salience": 0.0001298819,
				"type": "PERSON"
			},
			{
				"name": "allegations",
				"salience": 0.0001298819,
				"type": "OTHER"
			},
			{
				"name": "predecessors",
				"salience": 0.0001298819,
				"type": "PERSON"
			},
			{
				"name": "e-commerce",
				"salience": 0.0001298819,
				"type": "OTHER"
			},
			{
				"name": "Web URLs",
				"salience": 0.0001298819,
				"type": "OTHER"
			},
			{
				"name": "graduation",
				"salience": 0.0001298819,
				"type": "EVENT"
			},
			{
				"name": "structure",
				"salience": 0.00012824456,
				"type": "OTHER"
			},
			{
				"name": "David Hawkins Tel",
				"salience": 0.0001235838,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09n5b9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Secretary_of_state_(U.S._state_government)"
				},
				"name": "Secretary of State",
				"salience": 0.0001235838,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02q26r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_of_Professional_Responsibility"
				},
				"name": "OPR",
				"salience": 0.0001235838,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07cx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Telephone"
				},
				"name": "Tel",
				"salience": 0.0001235838,
				"type": "LOCATION"
			},
			{
				"name": "guidelines",
				"salience": 0.00012345538,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02c3wh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Bar_Association"
				},
				"name": "American Bar Association",
				"salience": 0.00012156825,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0828v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Wide_Web"
				},
				"name": "World Wide Web",
				"salience": 0.00011807869,
				"type": "OTHER"
			},
			{
				"name": "Operating procedures",
				"salience": 0.00011312833,
				"type": "OTHER"
			},
			{
				"name": "Taher Elgamal",
				"salience": 0.000111157606,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.0001070065,
				"type": "LOCATION"
			},
			{
				"name": "CSI Crime and Safety Investigation",
				"salience": 0.0001070065,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g8fs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Naval_Academy"
				},
				"name": "United States Naval Academy",
				"salience": 0.0001070065,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09lhr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Departments_of_France"
				},
				"name": "Department",
				"salience": 0.0001070065,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026vq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Services_Administration"
				},
				"name": "GSA",
				"salience": 0.0001070065,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0001070065,
				"type": "LOCATION"
			},
			{
				"name": "SIV",
				"salience": 0.0001070065,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0mn8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portsmouth,_Virginia"
				},
				"name": "Portsmouth",
				"salience": 0.0001070065,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Va.",
				"salience": 0.0001070065,
				"type": "LOCATION"
			},
			{
				"name": "Rosslyn",
				"salience": 0.0001070065,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0001070065,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0htyj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ron_Rivest"
				},
				"name": "Rivest",
				"salience": 0.00010223981,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.000092307906,
				"type": "LOCATION"
			},
			{
				"name": "James Ellis",
				"salience": 0.00008094624,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07srw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Utah"
				},
				"name": "Utah",
				"salience": 0.0000799258,
				"type": "LOCATION"
			},
			{
				"name": "Shamir",
				"salience": 0.0000799258,
				"type": "PERSON"
			},
			{
				"name": "Hellman",
				"salience": 0.0000799258,
				"type": "PERSON"
			},
			{
				"name": "Diffie",
				"salience": 0.0000799258,
				"type": "PERSON"
			},
			{
				"name": "Clifford Cocks",
				"salience": 0.0000799258,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05j3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netscape"
				},
				"name": "Netscape",
				"salience": 0.0000799258,
				"type": "ORGANIZATION"
			},
			{
				"name": "North Tower",
				"salience": 0.0000799258,
				"type": "LOCATION"
			},
			{
				"name": "Adleman",
				"salience": 0.0000799258,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0000799258,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0000799258,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g9jc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ernst_%26_Young"
				},
				"name": "Ernst & Young",
				"salience": 0.0000799258,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09p6s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arthur_Andersen"
				},
				"name": "Arthur Andersen",
				"salience": 0.0000799258,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.0000799258,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.000076574936,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0000663032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.000043147706,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:19:50.476+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 80.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "United States Marine Field McConnell  Plum City Online - ( AbelDanger.net )  October 27, 2016 \n1. Abel Danger ( AD ) claims that Serco began providing Zulu-timing signals through servers in the Vancouver B.C. offices of Starnet Communications in 1996 to record bets by prospective blackmail victims on the time of death of adults and children in live-broadcast snuff films. \n\n2. AD claims that Hillary Clinton deployed Serco 8(a) companies to Vancouver in August 1999 to confiscate the Starnet servers – together with all the betting records of snuff films produced at the Pickton pig farm – and transfer them to blackmailers embedded in the Federal Bridge Certification Authority. \n\n3. AD claims that Serco 's blackmailers on the federal bridge have forced the US Patent and Trademark Office to issue Zulu time lapse keys to a voting pad input device (US 7537159 B2) with which the George Soros-tied company Smartmatic can allegedly switch votes from Donald Trump to Hillary Clinton. \n\n4. United States Marine Field McConnell – Global Operations Director of Abel Danger – has offered to serve as a five-star general in a future Trump administration so he can first recognize and then destroy Clinton's pig-farm bridge to Serco 's 8(a) blackmailers in the patent office. \n\n\nMedia Coverage of Starnet Raid - August 20, 1999 \nSoros Linked Voting Machines To Be Used In Key Battleground States   \nNote the ransom equals the bonus paid by Lockheed Martin Sister Lynne Cheney to JonBenet's father \n\n\nHillary Clinton vs. James Comey: Email Scandal Supercut  \nCopy of SERCO GROUP PLC: List of Subsidiaries AND Shareholders! [Note British and Saudi Governments, AXA, HSBC , Teachers' and Gold man Sachs]    \nDefense Ammunition Center [Outsourced to Serco ]   \nSerco ... Would you like to know more?  \n\n\"Digital Fires Instructor Serco - Camp Pendleton, CA Uses information derived from all military disciplines (e.g., aviation, ground combat, command and control, combat service support, intelligence, and opposing forces) to determine changes in enemy capabilities, vulnerabilities, and probable courses of action.\" \n\n\"Concern Grows Over Soros-Linked Voting Machines   \nSixteen states may be using balloting equipment from a company tied to the leftist billionaire  \nby Edmund Kozak | Updated 24 Oct 2016 at 5:21 PM  \nConcern is growing over revelations that voting machines in a significant number of states could be linked to a company tied directly to billionaire leftist George Soros and his personal quest to create a nationless, borderless global state. \n\nThe U.K.-based Smartmatic company posted a flow-chart on its website that it had provided voting machines for 16 states, including important battleground states like Florida and Arizona. Smartmatic Chairman Mark Malloch-Brown is a former U.N. official and sits on the board of Soros’ Open Society Foundations. Since the story first broke, the flow-chart has disappeared from Smartmatic’s website, raising further questions about the real status of the Soros-tied voting equipment and whether it is truly being deployed in U.S. elections. \n\nIf Malloch-Brown's Soros ties weren't troubling enough, he also has ties to the Clintons through his work at two consulting firms. \n\nAccording to a spokesperson for the National Association of Secretaries of State, Smartmatic is not on a list of federally certified providers for election systems and officials in several states’ have contested that their equipment came from Smartmatic. Why, then, had Smartmatic bragged about providing over 50,000 voting machines for U.S. elections?\" \n\n\"Check http://www.gmanetwork.com/news/story/309533/opinion/why-have-all-the-digital-signatures-from-the-election-returns-been-stripped \" \n\n\"Electronic voting pad input device, system and method  \nUS 7537159  \nB2 ABSTRACT  \nIn the preferred embodiment, the invention is a data entry device intended for use by voters during an election to enter selected choices. Its basic functions are to display available options and accept voter input. Its design achieves simplicity in its preparation, deployment, and operation at any given electoral event. It also furnishes accuracy, reliability, durability, and reusability. It connects in a standard protocol to a voting station's host processor. It accepts up to 300 key codes, each one potentially a unique selection. Names, symbols, or pictures identifying candidates are printed on a paper template compliant with the device's geometry, inserted prior to an election, and visible through the device's transparent cover. When the number of candidates or valid options in a contest exceeds its capacity, additional identical units can be chain-connected, until a sufficient number of voting options are available. \n\nPublication number: US7537159 B2  \nPublication type: Grant  \nApplication number: US 11/160,782  \nPublication date: May 26, 2009  \nFiling date: Jul 8, 2005  \nPriority date: Jul 8, 2005  \nFee status: Paid  \nAlso published as: US20070007340   \nInventors: Antonio Mugica , 4 More »  \nOriginal Assignee: Smartmatic International Corporation   \nExport Citation: BiBTeX, EndNote, Ref Man Patent Citations (12), Referenced by (4), Classifications (7), Legal Events (7)  \nExternal Links: USPTO , USPTO Assignment , Espacenet \"  \n\nStarnet CEO heads to court; hiring continues; sweet deals in Antigua   \nFriday Aug 27 1999  \nby Brent Mudry  \nCEO SEEKS TO BLOCK ACCESS TO SENSITIVE RECORDS \n\nIn the first legal challenge to the Starnet Communications International police raid, Starnet chief executive Mark Dohlen has launched a court action seeking to assert solicitor-client privilege over certain documents and records seized during searches of Starnet's corporate headquarters and his personal residence a week ago. In a motion filed Thursday in the Supreme Court of British Columbia, prominent Vancouver criminal defence lawyer Ian Donaldson seeks to block police access to sensitive records seized by members of the RCMP and the Co-ordinated Law Enforcement Unit on Aug. 20. \n\nCertain disputed files have been sealed in court pending resolution of the privilege claim. An initial court hearing has been scheduled for Tuesday morning on the search warrant challenge. \n\nHIRING SPREE SEEKS PORN-PEDDLER, OTHERS \n\nIn an unrelated Starnet matter, the Vancouver-based Internet gambling and pornography company appears eager to mount a new hiring spree, recruiting staff in numerous positions, including its porn division, which it hopes to quickly sell off. \n\nIn a large ad on Thursday in The Georgia Straight, a Vancouver weekly entertainment newspaper, Starnet is soliciting a marketing representative for its entertainment division, amongst numerous other posted jobs. \"Do you have the ability to 'think outside the curve'?,\" Starnet asks in its porn-peddler posting. The company states that this position requires strategic thinking and implementation, directly relating to Redlight.com and Adultv.com. \n\nQueasy web-surfers may want to take a pass on these sites, at least Redlight.com, which offers a much harder-core home page than Starnet's main porn sites, Sizzler.com and Chisel.com. Redlight.com's home page offers an extremely explicit mix of \"teaser\" shots, including a graphic live-sex video clip. While Starnet wants to dump its porn business, its latest ad seeks a marketer to maintain continual market research of new forms of advertising and demographics, with \"overall participation in the team effort.\" The Thursday recruitment ad came three days after Starnet's Monday disclosure that it hopes to quickly auction off its adult entertainment division assets, with documentation to be complete in 30 days. \n\nThis Redlight.com site happens to be the same Starnet site targeted by the police in their proposed single criminal count of adult pornography. While no charges have yet been laid against Starnet or any directors or employees, the \"information to obtain,\" a court-filed document supporting the search warrant, notes eight proposed counts, including one of possession, for the purpose of publication, distribution or circulation, computerized pictures depicting obscene acts. The police note that \"Fetish,\" one of Redlight.com's seven sections, shows 84 images of nude bondage, women with clamps on body parts, women with horse bridles and bits in their mouths, and women hanging by their arms from straps or belts. \n\nThe latest Starnet recruitment ad also suggests it is \"business as usual\" at Starnet, despite the week-ago raid by more than 100 officers from the RCMP, CLEU, the Ontario Provincial Police, the United States Customs Service and the U.S. Internal Revenue Service. \n\nThe Georgia Straight ad seeks a WorldBroadcasts.com manager, an Internet marketing manager, HTML programmers, graphic designers, an investor relations administrative assistant, an adminstrative assistant of production and sports odds analysts. Starnet seeks \"open-minded, innovative people who enjoy working in a dynamic, fun, team atmosphere and are able to work creatively under pressure.\" \n\n\"BREAKING: @HillaryClinton's E-Mail Server Company Got Almost $1 Million In Gov't Loans After Wiping E-Mails   \nOCTOBER 26, 2016  \nBY CHARLES C. JOHNSON 6 COMMENTS  \nGive it up already. It's over. K. J. Gillenwater was the primary researcher behind this story. \n\nHillary Clinton's e-mail server company got almost $1 million in government loans starting immediately after they were secretly asked to wipe Hillary Clinton's name from her e-mails. \n\nPlatte River Networks (PRN) got a $493,000 loan from the Small Business Administration in August 2014 and another $350,000 loan in September 2015: \n\nPublic government data available as USAspending.gov \n\nThe first half-million dollar loan arrived not one month after PRN employee Paul Combetta was caught accidentally revealing his company was deleting evidence at Hillary's request in July 2014 . \n\nThe second $350,000 loan came about one year later. \n\nYou won't hear this stuff from the lying mainstream media. Keep the GotNews mission alive: donate at GotNews.com/donate or send tips to editor@gotnews.com. If you'd like to join our research team, contacteditor@gotnews.com. \n\nAfter getting the first loan, PRN moved to a large office space after previously working out of the owner’s condo. The head of the Small Business Administration is Maria Contreras-Sweet , a Mexican immigrant who was appointed to the office by Barack Obama two months before Hillary's PRN got the first loan. \n\nWikiLeaks leaks have proven Hillary's corrupt pay-to-play scheme. GotNews has shined a light on how Hillary gets favors from Hispanic and Democratic government bureaucrats before . \n\nDid Hillary Clinton pay her e-mail server company Platte River Networks (PRN) with almost $1 million in favorable government loans — given out by a political friendly — in order to alter her illegal e-mails and get her name off them? \n\nIt sure looks like it. \n\nA Freedom of Information Act (FOIA) request has been lodged for more information. \n\nStay tuned for more. \n\nK. J. Gillenwater was the primary researcher behind this story.\"  \n\n\"Police conclude search of Starnet   \nCBC News Posted: Aug 24, 1999 11:26 AM ET Last Updated: Aug 24, 1999 11:26 AM ET  \nPolice have wrapped up several days of searching the offices of Starnet Communications in Vancouver. They entered the company offices and homes of some directors on Friday. \n\nPolice were looking for evidence of illegal gambling, distributing child pornography, and money laundering. Since the raid, Starnet officials say police just don't understand their business. \n\nThe search warrant details 18 months of police investigation. It traces a network of companies registered in American and Caribbean jurisdictions. \n\nThe warrant also identifies Vancouver as the centre of Starnet's operations, even though this is a grey under Canadian law. \n\nPolice note that Starnet's revenues grew dramatically in the past two years, from betting and sex shows and from lucrative licensing agreements for its gaming software. The investigations and pornography from company sites were grounds for Friday's raid and seizure of company materials. \n\nRCMP Constable Peter Thiessen says investigators left Starnet offices yesterday morning. He says, \"They spent the better part of three days going through the business. And as a result of that search the investigation is continuing, but no charges have been laid.\" Starnet's many investors were spooked by the raid. Share prices dropped almost 70-percent on Friday. However, the company insists the raid had minimal effect on its operation. Stocks rose slightly yesterday after a day of very heavy trading. \n\nIn written statements, company CEO Mark Dohlen said the Wall Street Journal calls Starnet the leader in Internet gaming and entertainment. He says companies like his, those on the cutting edge, are often misunderstood. Yesterday, Starnet announced it will sell off the sex side of its business. It plans to focus more resources on gaming. \n\nThe Police investigation is expected to last for several more months.\" \n\n\"Super Serco bulldozes ahead  \nBy DAILY MAIL REPORTER UPDATED: 23:00 GMT, 1 September 2004 \nSERCO has come a long way since the 1960s when it ran the 'four-minute warning' system to alert the nation to a ballistic missile attack. \n\nToday its £10.3bn order book is bigger than many countries' defence budgets. It is bidding for a further £8bn worth of contracts and sees £16bn of 'opportunities'. \n\nProfit growth is less ballistic. The first-half pre-tax surplus rose 4% to £28.1m, net profits just 1% to £18m. Stripping out goodwill, the rise was 17%, with dividends up 12.5% to 0.81p. \n\nSerco runs the Docklands Light Railway, five UK prisons, airport radar and forest bulldozers in Florida.\"  \n\n\" Serco farewell to NPL after 19 years of innovation 8 January 2015 Serco said goodbye to the National Physical Laboratory (NPL) at the end of December 2014 after 19 years of extraordinary innovation and science that has seen the establishment build a world-leading reputation and deliver billions of pounds of benefit for the UK economy. During that period under Serco 's management and leadership, NPL has delivered an extraordinary variety and breadth of accomplishments for the UK's economy and industry. Some of the key achievements during that time have been:… It has been estimated that work carried out by the Centre of Carbon Measurement at NPL will save eight million tonnes of carbon emissions reductions (2% of UK footprint) and over half a billion pounds in economic benefit over the next decade…. NPL's caesium fountain atomic clock is accurate to 1 second in 158 million years and NPL is playing a key role in introducing rigour to high frequency trading [for Serco 's front running banks] in the City through NPL [Zulu] Time.\" \n\n\"UK Cabinet Office – Emergency Planning College – Serco …..Types of Exercise Workshop Exercises These are structured discussion events where participants can explore issues in a less pressurised environment. They are an ideal way of developing solutions, procedures and plans rather than the focus being on decision making. Table Top Exercises These involve a realistic scenario and will follow a time line, either in real-time or with time jumps to concentrate on the more important areas. The participants would be expected to be familiar with the plans and procedures that are being used although the exercise tempo and complexity can be adjusted to suit the current state of training and readiness. Simulation and media play can be used to support the exercise. Table-top exercises help develop teamwork and allow participants to gain a better understanding of their roles and that of other agencies and organisations. Command/Control Post Exercises These are designed primarily to exercise the senior leadership and support staff in collective planning and decision making within a strategic grouping. Ideally such exercises would be run from the real command and control locations and using their communications and information systems [Feeling lucky, Punk?] . This could include a mix of locations and varying levels of technical simulation support. The Gold Standard system is flexible to allow the tempo and intensity to be adjusted to ensure maximum training benefit, or to fully test and evaluate the most important aspects of a plan. Such exercises also test information flow, communications, equipment, procedures, decision making and coordination. Live Exercises These can range from testing individual components of a system or organisation through to a full-scale rehearsal. They are particularly useful where there are regulatory requirements or with high-risk situations. They are more complex and costly to organise and deliver but can be integrated with Command Post Exercises as part of a wider exercising package.\"  \n\n\"Christopher Rajendran Hyman CBE (born 5 July 1963 in Durban, South Africa)[1] was Chief Executive of Serco Group plc from 2002 to October 2013.[2] … On graduation, he worked for Arthur Andersen. In 1989, he won an 18-month exchange with Ernst & Young in London, who employed him after four months.[1] Head hunted in 1994 by Serco , Hyman became European finance director, and in 1999 was made group finance director. In 2002, Hyman became chief executive. .. Hyman resigned from his role of Chief Executive of Serco on 25 October 2013 following allegations that Serco had overcharged government customers. .. He was [making a presentation to Serco shareholder, including British and Saudi governments] on the 47th floor of the World Trade Center [North Tower] at the time of the September 11 attacks in 2001.\" \n\n\"July 7, 2016 Developments in PKI occurred in the early 1970s at the British intelligence agency GCHQ , where James Ellis , Clifford Cocks and others made important discoveries related to encryption algorithms and key distribution.[ 19 ] However, as developments at GCHQ are highly classified, the results of this work were kept secret and not publicly acknowledged until the mid-1990s. \n\nThe public disclosure of both secure key exchange and asymmetric key algorithms in 1976 by Diffie, Hellman , Rivest, Shamir , and Adleman changed secure communications entirely. With the further development of high-speed digital electronic communications (the Internet and its predecessors), a need became evident for ways in which users could securely communicate with each other, and as a further consequence of that, for ways in which users could be sure with whom they were actually interacting. \n\nAssorted cryptographic protocols were invented and analyzed within which the new cryptographic primitives could be effectively used. With the invention of the World Wide Web and its rapid spread, the need for authentication and secure communication became still more acute. Commercial reasons alone (e.g., e-commerce, online access to proprietary databases from web browsers) were sufficient. Taher Elgamal and others at Netscape developed the SSL protocol ('https' in Web URLs); it included key establishment, server authentication (prior to v3, one-way only), and so on. A PKI structure was thus created for Web users/sites wishing secure communications. \n\nVendors and entrepreneurs saw the possibility of a large market, started companies (or new projects at existing companies), and began to agitate for legal recognition and protection from liability. An American Bar Association technology project published an extensive analysis of some of the foreseeable legal aspects of PKI operations (see ABA digital signature guidelines), and shortly thereafter, several U.S. states (Utah being the first in 1995) and other jurisdictions throughout the world began to enact laws and adopt regulations. Consumer groups raised questions about privacy, access, and liability considerations, which were more taken into consideration in some jurisdictions than in others. \n\nThe enacted laws and regulations differed, there were technical and operational problems in converting PKI schemes into successful commercial operation, and progress has been much slower than pioneers had imagined it would be. \n\nBy the first few years of the 21st century, the underlying cryptographic engineering was clearly not easy to deploy correctly. Operating procedures (manual or automatic) were not easy to correctly design (nor even if so designed, to execute perfectly, which the engineering required). The standards that existed were insufficient. \n\nPKI vendors have found a market, but it is not quite the market envisioned in the mid-1990s, and it has grown both more slowly and in somewhat different ways than were anticipated.[20] PKIs have not solved some of the problems they were expected to, and several major vendors have gone out of business or been acquired by others. PKI has had the most success in government implementations; the largest PKI implementation to date is the Defense Information Systems Agency (DISA) PKI infrastructure for the Common Access Cards program.\"  \n\nBase One Technologies – Corporate Strategy – We are a Government Certified Women-Owned Business   \nWe practice Diversity Recruitment and Staffing for IT positions Base One was founded in 1994 by a women engineer who had made a career in technology research for many years. Base One has been very successful in focusing on diversity recruiting and staffing for IT projects. It has been our experience that the greater the diversity mix, the more creative the solution. As in any field the more diverse the viewpoint the more thorough your analysis. Our engineers can think out of the box. \n\nBecause of our affiliations we have access to pools of resources among more diverse groups & individuals. We work with a large pool of minority professionals who specialize in IT skills. We are able to have access to these resources through our status as a D/MWBD firm and our affiliations. These affiliations assist us in working with resources among more diverse groups & individuals. We are also partnered with firms that are 8A certified as Minority firms, Disabled Veteran firms, Native American firms, Vietnam veteran firms, women owned firms. \n\nOur hub zone location keeps us close to the professional organizations of great diversity. We are active in recruiting from and networking with these community organizations of local IT professionals. This has given us access to a large pool of diversity talent. \n\nBase One's staff of engineers are a diverse group of professionals. This diverse network of engineers helps us to branch out to other engineers and creates an even larger network of resources for us to work with. \n\nThe greater the diversity the more complete & thorough the analysis. The broader the spectrum of points of view the broader the scope of the analysis. We feel that a diverse team gives us a greater advantage in creating cutting edge solutions. To that end we will continue to nurture these relationships to further extend our talent pool. \n\nThe greater the diversity mix, the more creative the solution. \n\nThe more diverse the viewpoint, the more thorough the analysis. \n\nThe more diverse our team, the more our engineers can think out of the box. \n\nThis is why Base One Technologies concentrates on diversity recruitment in the belief that a diverse team gives us a greater advantage in creating cutting edge solutions.\" \n\nInformation Security Planning is the process whereby an organization seeks to protect its operations and assets from data theft or computer hackers that seek to obtain unauthorized information or sabotage business operations. \n\nKey Clients Benefiting From Our Information Security Expertise: Pentagon Renovation Program, FAA, Citigroup, MCI. \n\nBase One Technologies \n\nExpertly researches, designs, and develops information security policies that protect your data and manage your firm's information technology risk at levels acceptable to your business. \n\nPerforms architectural assessments and conducts both internal and external penetration testing. The results of these efforts culminate in an extensive risk analysis and vulnerabilities report. \n\nDevelops, implements and supports Information Security Counter measures such as honey-pots and evidence logging and incident documentation processes and solutions.\" \n\n\"Base One Technologies, Ltd. is a DOMESTIC BUSINESS CORPORATION, located in New York, NY and was formed on Feb 15, 1994. This file was obtained from the Secretary of State and has a file number of 1795583. \" \n\n\"Serco's Office of Partner Relations (OPR) helps facilitate our aggressive small business utilization and growth strategies. Through the OPR, Serco mentors four local small businesses under formal Mentor Protégé Agreements: Three sponsored by DHS (Base One Technologies, TSymmetry, Inc., and HeiTech Services, Inc.,) and the fourth sponsored by GSA (DKW Communications, Inc.). Serco and HeiTech Services were awarded the 2007 DHS Mentor Protégé Team Award for exceeding our mentoring goals.\" http://www.dtic.mil/whs/directives/corres/pdf/100515p.pdf \n\n\"Opened in 1994 as the successor to the Transitional Immigrant Visa Processing Center in Rosslyn, Va., the NVC centralizes all immigrant visa pre-processing and appointment scheduling for overseas posts. The NVC collects paperwork and fees before forwarding a case, ready for adjudication, to the responsible post. \n\nThe center also handles immigrant and fiancé visa petitions, and while it does not adjudicate visa applications, it provides technical assistance and support to visa-adjudicating consular officials overseas. \n\nOnly two Foreign Service officers, the director and deputy director, work at the center, along with just five Civil Service employees. They work with almost 500 contract employees doing preprocessing of visas, making the center one of the largest employers in the Portsmouth area. \n\nThe contractor, Serco , Inc., has worked with the NVC since its inception and with the Department for almost 18 years. \n\nThe NVC houses more than 2.6 million immigrant visa files, receives almost two million pieces of mail per year and received more than half a million petitions from the U.S. Citizenship and Immigration Service (USCIS) in 2011. Its file rooms' high-density shelves are stacked floor-to-ceiling with files, each a collection of someone’s hopes and dreams and each requiring proper handling. …. \n\nThe NVC also preprocesses the chief of mission (COM) application required for the filing of a petition for a Special Immigrant Visa (SIV). Such visas, for foreign nationals who have performed services for the U.S. government in Iraq and Afghanistan, require COM concurrence before the applicant can file a petition with USCIS. The NVC collects the requisite documents from such applicants and, when complete, forwards the package to the U.S. embassies in Baghdad or Kabul for COM approval\" \n\nYours sincerely, \n\nField McConnell, United States Naval Academy, 1971; Forensic Economist; 30 year airline and 22 year military pilot; 23,000 hours of safety; Tel: 715 307 8222 \n\nDavid Hawkins Tel: 604 542-0891 Forensic Economist; former leader of oil-well blow-out teams; now sponsors Grand Juries in CSI Crime and Safety Investigation \n",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"type": "bs",
		"uuid": "a3c854d3f9deceb87d031300016128124040c9a7"
	},
	"-KhIWRtEaDqIsOdgJxNS": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T03:19:50.504+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Field",
				"salience": 0.21428202,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.16906565,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.1357268,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.13488826,
				"type": "LOCATION"
			},
			{
				"name": "http://planet.infowars.com/politics/whats-the-truth-about-american-vote-fraud-anything-to-suspect",
				"salience": 0.11987427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.04475803,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.026197566,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.025227733,
				"type": "OTHER"
			},
			{
				"name": "Curtis",
				"salience": 0.023022344,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.01986108,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "Nasa",
				"salience": 0.016177375,
				"type": "ORGANIZATION"
			},
			{
				"name": "No one",
				"salience": 0.016029283,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.013218944,
				"type": "LOCATION"
			},
			{
				"name": "testimony",
				"salience": 0.011690209,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.011690209,
				"type": "WORK_OF_ART"
			},
			{
				"name": "industry",
				"salience": 0.009549643,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.008740576,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-27T21:50:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 1.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Field is correct about the 8a companies and Trump is correct about China . http://planet.infowars.com/politics/whats-the-truth-about-american-vote-fraud-anything-to-suspect  As Curtis testifies they were downloading a lot of secret stuff from Nasa as well . Chinese controlling the vote in USA you couldnt make that up , no wonder they have all your industry . No one can deny this didnt happen they are all there at the testimony on video .",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "3ab296a353b298c9cae5042219c8c03c8233ca0b"
	},
	"-KhIWSD92uo7tKJelzPl": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T03:19:50.512+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05qdsg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clint_Curtis"
				},
				"name": "Clinton Eugene ``Clint'' Curtis",
				"salience": 0.2723765,
				"type": "PERSON"
			},
			{
				"name": "http://mailstar.net/soros.html",
				"salience": 0.091231726,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "democrats",
				"salience": 0.082895346,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ft8nd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Feeney"
				},
				"name": "Tom Feeney",
				"salience": 0.055708993,
				"type": "PERSON"
			},
			{
				"name": "oil",
				"salience": 0.035190202,
				"type": "OTHER"
			},
			{
				"name": "prototype software package",
				"salience": 0.026859133,
				"type": "OTHER"
			},
			{
				"name": "Georg Soros",
				"salience": 0.025093539,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.020845782,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "wind",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "raddicals",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.013542579,
				"type": "PERSON"
			},
			{
				"name": "wonder",
				"salience": 0.013354171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.012861617,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.011910258,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.010950521,
				"type": "OTHER"
			},
			{
				"name": "Award.YEI",
				"salience": 0.01017947,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.009249221,
				"type": "WORK_OF_ART"
			},
			{
				"name": "liars",
				"salience": 0.009139553,
				"type": "PERSON"
			},
			{
				"name": "whistleblower allegations",
				"salience": 0.008611571,
				"type": "OTHER"
			},
			{
				"name": "employer",
				"salience": 0.007459226,
				"type": "PERSON"
			},
			{
				"name": "computer programmer",
				"salience": 0.007459226,
				"type": "OTHER"
			},
			{
				"name": "ex-employee",
				"salience": 0.007459226,
				"type": "PERSON"
			},
			{
				"name": "election hacking",
				"salience": 0.007459226,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0066905795,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.006447727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "enterprises",
				"salience": 0.006436754,
				"type": "ORGANIZATION"
			},
			{
				"name": "bias",
				"salience": 0.006436754,
				"type": "OTHER"
			},
			{
				"name": "Congressman",
				"salience": 0.006041908,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.0058167013,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0054636337,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.005256275,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0052328263,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.0050377273,
				"type": "EVENT"
			},
			{
				"name": "scheme",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "code",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "touch screen voting systems",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.004933725,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.004933725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.0045944713,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02s6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ExxonMobil"
				},
				"name": "ExxonMobil",
				"salience": 0.0045944713,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0045944713,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.004494937,
				"type": "OTHER"
			},
			{
				"name": "http://www.yangenterprises.com/ YEI",
				"salience": 0.00433483,
				"type": "OTHER"
			},
			{
				"name": "Name",
				"salience": 0.0042728335,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0041659256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0041516433,
				"type": "PERSON"
			},
			{
				"name": "assistance",
				"salience": 0.004113478,
				"type": "OTHER"
			},
			{
				"name": "Services",
				"salience": 0.0040827463,
				"type": "OTHER"
			},
			{
				"name": "Field",
				"salience": 0.003960058,
				"type": "OTHER"
			},
			{
				"name": "Yang Enterprises",
				"salience": 0.0035820229,
				"type": "ORGANIZATION"
			},
			{
				"name": "solutions",
				"salience": 0.0035783045,
				"type": "OTHER"
			},
			{
				"name": "Lee) Yang Title",
				"salience": 0.0033096338,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0031925947,
				"type": "OTHER"
			},
			{
				"name": "Small Business Subcontractor",
				"salience": 0.0031925947,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0031020122,
				"type": "PERSON"
			},
			{
				"name": "nottrue",
				"salience": 0.0029965572,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ytc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Information_technology"
				},
				"name": "Information Technology",
				"salience": 0.0026307695,
				"type": "OTHER"
			},
			{
				"name": "GSA Advantage",
				"salience": 0.0026307695,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0024777013,
				"type": "OTHER"
			},
			{
				"name": "smoking gun",
				"salience": 0.0024777013,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "allegation",
				"salience": 0.0024574636,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0023255274,
				"type": "LOCATION"
			},
			{
				"name": "Management Services",
				"salience": 0.0022220076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "GS",
				"salience": 0.0021160692,
				"type": "ORGANIZATION"
			},
			{
				"name": "Li-Woan",
				"salience": 0.002094027,
				"type": "PERSON"
			},
			{
				"name": "cultures",
				"salience": 0.0019973316,
				"type": "OTHER"
			},
			{
				"name": "State of Florida IT Consulting",
				"salience": 0.001965402,
				"type": "ORGANIZATION"
			},
			{
				"name": "Facilities Maintenance",
				"salience": 0.0017373167,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.0017373167,
				"type": "OTHER"
			},
			{
				"name": "YEI",
				"salience": 0.0013677285,
				"type": "LOCATION"
			},
			{
				"name": "Professional Engineering Services",
				"salience": 0.0013677285,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0svpj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marshall_Space_Flight_Center"
				},
				"name": "Marshall Space Flight Center",
				"salience": 0.0010693177,
				"type": "ORGANIZATION"
			},
			{
				"name": "Logistics Worldwide",
				"salience": 0.0010693177,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-27T21:30:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 6.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Georg Soros the good oil . http://mailstar.net/soros.html   Sometimes for truth you have to sacrifice something in order to show non bias , it certainly puts the wind up the mad left raddicals paid by Soros . So the democrats dont think voting is rigged eh???? How do they explain this then ?? Clinton Eugene “Clint” Curtis is an American attorney, computer programmer and ex-employee of NASA and ExxonMobil, who also exposed election hacking.  He is notable chiefly for making a series of whistleblower allegations about his former employer and about Republican Congressman Tom Feeney, including an allegation that in 2000, Feeney and Yang Enterprises requested Curtis’s assistance in a scheme to steal votes by inserting fraudulent code into touch screen voting systems. Remember this is the Democrats at the hearing . He tells the members how he was hired by Congressman Tom Feeney in 2000 to build a prototype software package that would secretly rig an election to sway the result 51/49 to a specified side. Now this shows Donald Trump is not only not bias but just wants an honest election and no vote rigging http://www.activistpost.com/2016/03/watch-computer-programmer-testifies-under-oath-he-coded-computers-to-rig-elections.html  One might ask who are Yang enterprises ??? Field will like this . There was a reason they did not want to know who they were . http://www.yangenterprises.com/   YEI is a GSA Advantage member, offering Information Technology solutions (GS-35F-0896N), Professional Engineering Services (GS-10F-0107Y), Logistics Worldwide (GS-10F-0135Y), and Facilities Maintenance and Management Services (GS-21F-090AA).YEI receives the Marshall Space Flight Center Small Business Subcontractor Excellence Award.YEI awarded State of Florida IT Consulting Services contract.http://www.dms.myflorida.com/business_operations/state_purchasing/vendor_information/state_contracts_and_agreements/state_term_contracts/information_technology_it_consulting_services/contractors/t_z/contractors_yang_enterprises_inc  Name: Li-Woan (Lee) Yang  Title: President/CEO  Looks like they are all in on it , no wonder its always 50/50 no matter how many people in every western country which is impossible given the differnt cultures . The video is the ultimate smoking gun against the liars who know full well its all rigged . And for the Democrats to be claiming its nottrue is an outrageous lie , they had the inquiry .    ",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "7dfe3b0a85d4f96a3d024615267629ee56d9846f"
	},
	"-KhIWSP8b5H2ZkFpU-Fw": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:05:41.413+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Yang",
				"salience": 0.29355067,
				"type": "PERSON"
			},
			{
				"name": "mob",
				"salience": 0.124000855,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.124000855,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.108382255,
				"type": "OTHER"
			},
			{
				"name": "contracts",
				"salience": 0.091883115,
				"type": "OTHER"
			},
			{
				"name": "Gregory A. Presenell",
				"salience": 0.028649207,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.028230792,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rht0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida_Department_of_Transportation"
				},
				"name": "Florida Department of Transportation",
				"salience": 0.021918438,
				"type": "ORGANIZATION"
			},
			{
				"name": "contracts",
				"salience": 0.019693542,
				"type": "OTHER"
			},
			{
				"name": "defrauding",
				"salience": 0.01886496,
				"type": "EVENT"
			},
			{
				"name": "over-billing",
				"salience": 0.016419986,
				"type": "EVENT"
			},
			{
				"name": "activities",
				"salience": 0.016010595,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "State of Florida",
				"salience": 0.011634539,
				"type": "LOCATION"
			},
			{
				"name": "guy",
				"salience": 0.011527816,
				"type": "PERSON"
			},
			{
				"name": "espionage",
				"salience": 0.011527816,
				"type": "OTHER"
			},
			{
				"name": "Nee",
				"salience": 0.010784573,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.009503301,
				"type": "LOCATION"
			},
			{
				"name": "connection",
				"salience": 0.008727744,
				"type": "OTHER"
			},
			{
				"name": "slap",
				"salience": 0.008402636,
				"type": "OTHER"
			},
			{
				"name": "wrist",
				"salience": 0.008402636,
				"type": "OTHER"
			},
			{
				"name": "fine",
				"salience": 0.0062801577,
				"type": "OTHER"
			},
			{
				"name": "alien",
				"salience": 0.0062801577,
				"type": "OTHER"
			},
			{
				"name": "probation",
				"salience": 0.0062801577,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/091msx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serco"
				},
				"name": "Serco",
				"salience": 0.005175779,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.0038674315,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-27T23:03:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 1.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "There is a lot more than meets the eye to this mob , wait till you read this . &quot;Soon thereafter I resigned from Yang and took another job at the Florida Department of Transportation (FDOT). While there, I discovered some other illegal activities of Yang, who had contracts with FDOT, involving over-billing and defrauding of the State of Florida regarding contracts Nee was sentenced on October 7, 2004 by U.S. District Judge Gregory A. Presenell to three years of supervised probation and $100 fine. An illegal Chinese alien admitting to what is paramount to corporate if not treasonable espionage, and the guy gets a slap on the wrist. http://www.bradblog.com/?page_id=3526  now finding the connection to Serco via contracts ....",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "4384d62eb60d6da437e335573ff4c61bda9ed4fa"
	},
	"-KhIWSYe0VRMA4n6Meor": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:05:41.502+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Yang Enterprises",
				"salience": 0.19805408,
				"type": "ORGANIZATION"
			},
			{
				"name": "radar",
				"salience": 0.100437105,
				"type": "OTHER"
			},
			{
				"name": "boxes",
				"salience": 0.100437105,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.058721486,
				"type": "PERSON"
			},
			{
				"name": "customers",
				"salience": 0.027402854,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.021448648,
				"type": "OTHER"
			},
			{
				"name": "ethics",
				"salience": 0.021448648,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.021448648,
				"type": "OTHER"
			},
			{
				"name": "quest",
				"salience": 0.021448648,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.020822952,
				"type": "LOCATION"
			},
			{
				"name": "customers",
				"salience": 0.019242426,
				"type": "PERSON"
			},
			{
				"name": "customers",
				"salience": 0.019242426,
				"type": "PERSON"
			},
			{
				"name": "services",
				"salience": 0.017011005,
				"type": "OTHER"
			},
			{
				"name": "quality",
				"salience": 0.016733052,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.015637957,
				"type": "OTHER"
			},
			{
				"name": "products",
				"salience": 0.015055776,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "agencies",
				"salience": 0.015055776,
				"type": "ORGANIZATION"
			},
			{
				"name": "manner",
				"salience": 0.014495203,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.014495203,
				"type": "PERSON"
			},
			{
				"name": "RUN BY WOMEN",
				"salience": 0.013221391,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.01261207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "U.S. Air Force",
				"salience": 0.011859337,
				"type": "ORGANIZATION"
			},
			{
				"name": "level",
				"salience": 0.0118387835,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "State of Florida",
				"salience": 0.010482214,
				"type": "LOCATION"
			},
			{
				"name": "services",
				"salience": 0.010385931,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0178g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing"
				},
				"name": "The Boeing Company",
				"salience": 0.009684997,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.009275946,
				"type": "ORGANIZATION"
			},
			{
				"name": "government sites",
				"salience": 0.009190721,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.009190721,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.009190721,
				"type": "OTHER"
			},
			{
				"name": "contracts",
				"salience": 0.008665486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02s6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ExxonMobil"
				},
				"name": "ExxonMobil",
				"salience": 0.008603462,
				"type": "ORGANIZATION"
			},
			{
				"name": "contracts",
				"salience": 0.0077319443,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03s0d3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Computer_Sciences_Corporation"
				},
				"name": "CSC",
				"salience": 0.007574509,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "U.S. Army",
				"salience": 0.007574509,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01frpd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northrop_Grumman"
				},
				"name": "Northrop Grumman",
				"salience": 0.007574509,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/032b0q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/URS_Corporation"
				},
				"name": "URS",
				"salience": 0.007574509,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09ml88",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Space_Alliance"
				},
				"name": "United Space Alliance",
				"salience": 0.007574509,
				"type": "ORGANIZATION"
			},
			{
				"name": "services",
				"salience": 0.0069253724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kennedy_Space_Center"
				},
				"name": "Kennedy Space Center",
				"salience": 0.006535447,
				"type": "LOCATION"
			},
			{
				"name": "Logistics Operations",
				"salience": 0.0057774857,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.005707054,
				"type": "LOCATION"
			},
			{
				"name": "Global Engineering Services",
				"salience": 0.005707054,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01smkl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cape_Canaveral_Air_Force_Station"
				},
				"name": "Cape Canaveral Air Force Station",
				"salience": 0.005707054,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/073shf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patrick_Air_Force_Base"
				},
				"name": "Patrick Air Force Base",
				"salience": 0.005659799,
				"type": "LOCATION"
			},
			{
				"name": "Systems Engineering disciplines",
				"salience": 0.0050032865,
				"type": "OTHER"
			},
			{
				"name": "Maintenance",
				"salience": 0.0050032865,
				"type": "OTHER"
			},
			{
				"name": "core competencies",
				"salience": 0.0049033556,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0svpj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marshall_Space_Flight_Center"
				},
				"name": "Marshall Space Flight Center",
				"salience": 0.0047609047,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06n3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_America"
				},
				"name": "South America",
				"salience": 0.0041228137,
				"type": "LOCATION"
			},
			{
				"name": "http://www.yangenterprises.com/about.aspx",
				"salience": 0.0041228137,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0261m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caribbean"
				},
				"name": "Caribbean",
				"salience": 0.0041228137,
				"type": "LOCATION"
			},
			{
				"name": "Applied Engineering and Information Technology",
				"salience": 0.003939305,
				"type": "OTHER"
			},
			{
				"name": "Facility Operations",
				"salience": 0.003556901,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-10-27T22:57:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 3.6,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "They tick all the boxes , flying under the radar and might be far more dangerous than anyone knows , just look who they do work for . Yang Enterprises is a high-technology woman-owned, small disadvantaged company RUN BY WOMEN .built on a strong culture of ethics, integrity, and a quest for providing our customers the highest level of quality in a safe, timely, and cost-effective manner. We are financially secure and debt-free. Our employees excel at providing top quality services and products to federal, state, and local agencies as well as commercial customers. Our enviable list of customers includes NASA, the U.S. Air Force, the U.S. Army, United Space Alliance, URS, Northrop Grumman, CSC, The Boeing Company, ExxonMobil, and the State of Florida.  While our business was founded on Applied Engineering and Information Technology services, we have successfully expanded these core competencies to include Facility Operations and Maintenance; Logistics Operations; and Systems Engineering disciplines. We currently provide these services in support of some of the nation&#39;s most complex contracts at government sites such as the Kennedy Space Center, Patrick Air Force Base, Marshall Space Flight Center, and Cape Canaveral Air Force Station and for commercial contracts such as Global Engineering Services for ExxonMobil in the United States, Caribbean and South America.  http://www.yangenterprises.com/about.aspx    ",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "3144033585889c0fd7f8edc294354ead60fd9f10"
	},
	"-KhIWSeHNlsKupF2u204": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:05:41.506+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Field",
				"salience": 0.21428202,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.16906565,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.1357268,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.13488826,
				"type": "LOCATION"
			},
			{
				"name": "http://planet.infowars.com/politics/whats-the-truth-about-american-vote-fraud-anything-to-suspect",
				"salience": 0.11987427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.04475803,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.026197566,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.025227733,
				"type": "OTHER"
			},
			{
				"name": "Curtis",
				"salience": 0.023022344,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.01986108,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "Nasa",
				"salience": 0.016177375,
				"type": "ORGANIZATION"
			},
			{
				"name": "No one",
				"salience": 0.016029283,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.013218944,
				"type": "LOCATION"
			},
			{
				"name": "testimony",
				"salience": 0.011690209,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.011690209,
				"type": "WORK_OF_ART"
			},
			{
				"name": "industry",
				"salience": 0.009549643,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.008740576,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-10-27T21:50:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 1.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Field is correct about the 8a companies and Trump is correct about China . http://planet.infowars.com/politics/whats-the-truth-about-american-vote-fraud-anything-to-suspect  As Curtis testifies they were downloading a lot of secret stuff from Nasa as well . Chinese controlling the vote in USA you couldnt make that up , no wonder they have all your industry . No one can deny this didnt happen they are all there at the testimony on video .",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "c40caf3e677c5fdfd7bd47f68d029e0eaa75e1ac"
	},
	"-KhIWSrENmEvTHzqfjla": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:05:41.509+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05qdsg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clint_Curtis"
				},
				"name": "Clinton Eugene ``Clint'' Curtis",
				"salience": 0.2723765,
				"type": "PERSON"
			},
			{
				"name": "http://mailstar.net/soros.html",
				"salience": 0.091231726,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "democrats",
				"salience": 0.082895346,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ft8nd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Feeney"
				},
				"name": "Tom Feeney",
				"salience": 0.055708993,
				"type": "PERSON"
			},
			{
				"name": "oil",
				"salience": 0.035190202,
				"type": "OTHER"
			},
			{
				"name": "prototype software package",
				"salience": 0.026859133,
				"type": "OTHER"
			},
			{
				"name": "Georg Soros",
				"salience": 0.025093539,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.020845782,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "wind",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "raddicals",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.013542579,
				"type": "PERSON"
			},
			{
				"name": "wonder",
				"salience": 0.013354171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.012861617,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.011910258,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.010950521,
				"type": "OTHER"
			},
			{
				"name": "Award.YEI",
				"salience": 0.01017947,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.009249221,
				"type": "WORK_OF_ART"
			},
			{
				"name": "liars",
				"salience": 0.009139553,
				"type": "PERSON"
			},
			{
				"name": "whistleblower allegations",
				"salience": 0.008611571,
				"type": "OTHER"
			},
			{
				"name": "employer",
				"salience": 0.007459226,
				"type": "PERSON"
			},
			{
				"name": "computer programmer",
				"salience": 0.007459226,
				"type": "OTHER"
			},
			{
				"name": "ex-employee",
				"salience": 0.007459226,
				"type": "PERSON"
			},
			{
				"name": "election hacking",
				"salience": 0.007459226,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0066905795,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.006447727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "enterprises",
				"salience": 0.006436754,
				"type": "ORGANIZATION"
			},
			{
				"name": "bias",
				"salience": 0.006436754,
				"type": "OTHER"
			},
			{
				"name": "Congressman",
				"salience": 0.006041908,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.0058167013,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0054636337,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.005256275,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0052328263,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.0050377273,
				"type": "EVENT"
			},
			{
				"name": "scheme",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "code",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "touch screen voting systems",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.004933725,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.004933725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.0045944713,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02s6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ExxonMobil"
				},
				"name": "ExxonMobil",
				"salience": 0.0045944713,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0045944713,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.004494937,
				"type": "OTHER"
			},
			{
				"name": "http://www.yangenterprises.com/ YEI",
				"salience": 0.00433483,
				"type": "OTHER"
			},
			{
				"name": "Name",
				"salience": 0.0042728335,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0041659256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0041516433,
				"type": "PERSON"
			},
			{
				"name": "assistance",
				"salience": 0.004113478,
				"type": "OTHER"
			},
			{
				"name": "Services",
				"salience": 0.0040827463,
				"type": "OTHER"
			},
			{
				"name": "Field",
				"salience": 0.003960058,
				"type": "OTHER"
			},
			{
				"name": "Yang Enterprises",
				"salience": 0.0035820229,
				"type": "ORGANIZATION"
			},
			{
				"name": "solutions",
				"salience": 0.0035783045,
				"type": "OTHER"
			},
			{
				"name": "Lee) Yang Title",
				"salience": 0.0033096338,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0031925947,
				"type": "OTHER"
			},
			{
				"name": "Small Business Subcontractor",
				"salience": 0.0031925947,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0031020122,
				"type": "PERSON"
			},
			{
				"name": "nottrue",
				"salience": 0.0029965572,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ytc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Information_technology"
				},
				"name": "Information Technology",
				"salience": 0.0026307695,
				"type": "OTHER"
			},
			{
				"name": "GSA Advantage",
				"salience": 0.0026307695,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0024777013,
				"type": "OTHER"
			},
			{
				"name": "smoking gun",
				"salience": 0.0024777013,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "allegation",
				"salience": 0.0024574636,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0023255274,
				"type": "LOCATION"
			},
			{
				"name": "Management Services",
				"salience": 0.0022220076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "GS",
				"salience": 0.0021160692,
				"type": "ORGANIZATION"
			},
			{
				"name": "Li-Woan",
				"salience": 0.002094027,
				"type": "PERSON"
			},
			{
				"name": "cultures",
				"salience": 0.0019973316,
				"type": "OTHER"
			},
			{
				"name": "State of Florida IT Consulting",
				"salience": 0.001965402,
				"type": "ORGANIZATION"
			},
			{
				"name": "Facilities Maintenance",
				"salience": 0.0017373167,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.0017373167,
				"type": "OTHER"
			},
			{
				"name": "YEI",
				"salience": 0.0013677285,
				"type": "LOCATION"
			},
			{
				"name": "Professional Engineering Services",
				"salience": 0.0013677285,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0svpj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marshall_Space_Flight_Center"
				},
				"name": "Marshall Space Flight Center",
				"salience": 0.0010693177,
				"type": "ORGANIZATION"
			},
			{
				"name": "Logistics Worldwide",
				"salience": 0.0010693177,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "6",
		"participants_count": "1",
		"published": "2016-10-27T21:30:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 6.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Georg Soros the good oil . http://mailstar.net/soros.html   Sometimes for truth you have to sacrifice something in order to show non bias , it certainly puts the wind up the mad left raddicals paid by Soros . So the democrats dont think voting is rigged eh???? How do they explain this then ?? Clinton Eugene “Clint” Curtis is an American attorney, computer programmer and ex-employee of NASA and ExxonMobil, who also exposed election hacking.  He is notable chiefly for making a series of whistleblower allegations about his former employer and about Republican Congressman Tom Feeney, including an allegation that in 2000, Feeney and Yang Enterprises requested Curtis’s assistance in a scheme to steal votes by inserting fraudulent code into touch screen voting systems. Remember this is the Democrats at the hearing . He tells the members how he was hired by Congressman Tom Feeney in 2000 to build a prototype software package that would secretly rig an election to sway the result 51/49 to a specified side. Now this shows Donald Trump is not only not bias but just wants an honest election and no vote rigging http://www.activistpost.com/2016/03/watch-computer-programmer-testifies-under-oath-he-coded-computers-to-rig-elections.html  One might ask who are Yang enterprises ??? Field will like this . There was a reason they did not want to know who they were . http://www.yangenterprises.com/   YEI is a GSA Advantage member, offering Information Technology solutions (GS-35F-0896N), Professional Engineering Services (GS-10F-0107Y), Logistics Worldwide (GS-10F-0135Y), and Facilities Maintenance and Management Services (GS-21F-090AA).YEI receives the Marshall Space Flight Center Small Business Subcontractor Excellence Award.YEI awarded State of Florida IT Consulting Services contract.http://www.dms.myflorida.com/business_operations/state_purchasing/vendor_information/state_contracts_and_agreements/state_term_contracts/information_technology_it_consulting_services/contractors/t_z/contractors_yang_enterprises_inc  Name: Li-Woan (Lee) Yang  Title: President/CEO  Looks like they are all in on it , no wonder its always 50/50 no matter how many people in every western country which is impossible given the differnt cultures . The video is the ultimate smoking gun against the liars who know full well its all rigged . And for the Democrats to be claiming its nottrue is an outrageous lie , they had the inquiry .    ",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "5be68a7c4c09f180b8f15d8d176fb097520f5a02"
	},
	"-KhIWSxeRFwbeeXSF-zk": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:57:33.983+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Field",
				"salience": 0.21428202,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.16906565,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.1357268,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.13488826,
				"type": "LOCATION"
			},
			{
				"name": "http://planet.infowars.com/politics/whats-the-truth-about-american-vote-fraud-anything-to-suspect",
				"salience": 0.11987427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.04475803,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.026197566,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.025227733,
				"type": "OTHER"
			},
			{
				"name": "Curtis",
				"salience": 0.023022344,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.01986108,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "Nasa",
				"salience": 0.016177375,
				"type": "ORGANIZATION"
			},
			{
				"name": "No one",
				"salience": 0.016029283,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.013218944,
				"type": "LOCATION"
			},
			{
				"name": "testimony",
				"salience": 0.011690209,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.011690209,
				"type": "WORK_OF_ART"
			},
			{
				"name": "industry",
				"salience": 0.009549643,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.008740576,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "7",
		"participants_count": "1",
		"published": "2016-10-27T21:50:00.000+03:00",
		"replies_count": "8",
		"sentiment": {
			"magnitude": 1.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Field is correct about the 8a companies and Trump is correct about China . http://planet.infowars.com/politics/whats-the-truth-about-american-vote-fraud-anything-to-suspect  As Curtis testifies they were downloading a lot of secret stuff from Nasa as well . Chinese controlling the vote in USA you couldnt make that up , no wonder they have all your industry . No one can deny this didnt happen they are all there at the testimony on video .",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "25de41d2c7889142bdc6e7c2a47d577ae74db71c"
	},
	"-KhIWTBVlU5QT57jSZwy": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:57:33.991+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05qdsg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clint_Curtis"
				},
				"name": "Clinton Eugene ``Clint'' Curtis",
				"salience": 0.2723765,
				"type": "PERSON"
			},
			{
				"name": "http://mailstar.net/soros.html",
				"salience": 0.091231726,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "democrats",
				"salience": 0.082895346,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ft8nd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Feeney"
				},
				"name": "Tom Feeney",
				"salience": 0.055708993,
				"type": "PERSON"
			},
			{
				"name": "oil",
				"salience": 0.035190202,
				"type": "OTHER"
			},
			{
				"name": "prototype software package",
				"salience": 0.026859133,
				"type": "OTHER"
			},
			{
				"name": "Georg Soros",
				"salience": 0.025093539,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.020845782,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "wind",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "raddicals",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.013542579,
				"type": "PERSON"
			},
			{
				"name": "wonder",
				"salience": 0.013354171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.012861617,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.011910258,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.010950521,
				"type": "OTHER"
			},
			{
				"name": "Award.YEI",
				"salience": 0.01017947,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.009249221,
				"type": "WORK_OF_ART"
			},
			{
				"name": "liars",
				"salience": 0.009139553,
				"type": "PERSON"
			},
			{
				"name": "whistleblower allegations",
				"salience": 0.008611571,
				"type": "OTHER"
			},
			{
				"name": "employer",
				"salience": 0.007459226,
				"type": "PERSON"
			},
			{
				"name": "computer programmer",
				"salience": 0.007459226,
				"type": "OTHER"
			},
			{
				"name": "ex-employee",
				"salience": 0.007459226,
				"type": "PERSON"
			},
			{
				"name": "election hacking",
				"salience": 0.007459226,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0066905795,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.006447727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "enterprises",
				"salience": 0.006436754,
				"type": "ORGANIZATION"
			},
			{
				"name": "bias",
				"salience": 0.006436754,
				"type": "OTHER"
			},
			{
				"name": "Congressman",
				"salience": 0.006041908,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.0058167013,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0054636337,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.005256275,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0052328263,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.0050377273,
				"type": "EVENT"
			},
			{
				"name": "scheme",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "code",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "touch screen voting systems",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.004933725,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.004933725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.0045944713,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02s6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ExxonMobil"
				},
				"name": "ExxonMobil",
				"salience": 0.0045944713,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0045944713,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.004494937,
				"type": "OTHER"
			},
			{
				"name": "http://www.yangenterprises.com/ YEI",
				"salience": 0.00433483,
				"type": "OTHER"
			},
			{
				"name": "Name",
				"salience": 0.0042728335,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0041659256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0041516433,
				"type": "PERSON"
			},
			{
				"name": "assistance",
				"salience": 0.004113478,
				"type": "OTHER"
			},
			{
				"name": "Services",
				"salience": 0.0040827463,
				"type": "OTHER"
			},
			{
				"name": "Field",
				"salience": 0.003960058,
				"type": "OTHER"
			},
			{
				"name": "Yang Enterprises",
				"salience": 0.0035820229,
				"type": "ORGANIZATION"
			},
			{
				"name": "solutions",
				"salience": 0.0035783045,
				"type": "OTHER"
			},
			{
				"name": "Lee) Yang Title",
				"salience": 0.0033096338,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0031925947,
				"type": "OTHER"
			},
			{
				"name": "Small Business Subcontractor",
				"salience": 0.0031925947,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0031020122,
				"type": "PERSON"
			},
			{
				"name": "nottrue",
				"salience": 0.0029965572,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ytc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Information_technology"
				},
				"name": "Information Technology",
				"salience": 0.0026307695,
				"type": "OTHER"
			},
			{
				"name": "GSA Advantage",
				"salience": 0.0026307695,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0024777013,
				"type": "OTHER"
			},
			{
				"name": "smoking gun",
				"salience": 0.0024777013,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "allegation",
				"salience": 0.0024574636,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0023255274,
				"type": "LOCATION"
			},
			{
				"name": "Management Services",
				"salience": 0.0022220076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "GS",
				"salience": 0.0021160692,
				"type": "ORGANIZATION"
			},
			{
				"name": "Li-Woan",
				"salience": 0.002094027,
				"type": "PERSON"
			},
			{
				"name": "cultures",
				"salience": 0.0019973316,
				"type": "OTHER"
			},
			{
				"name": "State of Florida IT Consulting",
				"salience": 0.001965402,
				"type": "ORGANIZATION"
			},
			{
				"name": "Facilities Maintenance",
				"salience": 0.0017373167,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.0017373167,
				"type": "OTHER"
			},
			{
				"name": "YEI",
				"salience": 0.0013677285,
				"type": "LOCATION"
			},
			{
				"name": "Professional Engineering Services",
				"salience": 0.0013677285,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0svpj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marshall_Space_Flight_Center"
				},
				"name": "Marshall Space Flight Center",
				"salience": 0.0010693177,
				"type": "ORGANIZATION"
			},
			{
				"name": "Logistics Worldwide",
				"salience": 0.0010693177,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "8",
		"participants_count": "1",
		"published": "2016-10-27T21:30:00.000+03:00",
		"replies_count": "8",
		"sentiment": {
			"magnitude": 6.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Georg Soros the good oil . http://mailstar.net/soros.html   Sometimes for truth you have to sacrifice something in order to show non bias , it certainly puts the wind up the mad left raddicals paid by Soros . So the democrats dont think voting is rigged eh???? How do they explain this then ?? Clinton Eugene “Clint” Curtis is an American attorney, computer programmer and ex-employee of NASA and ExxonMobil, who also exposed election hacking.  He is notable chiefly for making a series of whistleblower allegations about his former employer and about Republican Congressman Tom Feeney, including an allegation that in 2000, Feeney and Yang Enterprises requested Curtis’s assistance in a scheme to steal votes by inserting fraudulent code into touch screen voting systems. Remember this is the Democrats at the hearing . He tells the members how he was hired by Congressman Tom Feeney in 2000 to build a prototype software package that would secretly rig an election to sway the result 51/49 to a specified side. Now this shows Donald Trump is not only not bias but just wants an honest election and no vote rigging http://www.activistpost.com/2016/03/watch-computer-programmer-testifies-under-oath-he-coded-computers-to-rig-elections.html  One might ask who are Yang enterprises ??? Field will like this . There was a reason they did not want to know who they were . http://www.yangenterprises.com/   YEI is a GSA Advantage member, offering Information Technology solutions (GS-35F-0896N), Professional Engineering Services (GS-10F-0107Y), Logistics Worldwide (GS-10F-0135Y), and Facilities Maintenance and Management Services (GS-21F-090AA).YEI receives the Marshall Space Flight Center Small Business Subcontractor Excellence Award.YEI awarded State of Florida IT Consulting Services contract.http://www.dms.myflorida.com/business_operations/state_purchasing/vendor_information/state_contracts_and_agreements/state_term_contracts/information_technology_it_consulting_services/contractors/t_z/contractors_yang_enterprises_inc  Name: Li-Woan (Lee) Yang  Title: President/CEO  Looks like they are all in on it , no wonder its always 50/50 no matter how many people in every western country which is impossible given the differnt cultures . The video is the ultimate smoking gun against the liars who know full well its all rigged . And for the Democrats to be claiming its nottrue is an outrageous lie , they had the inquiry .    ",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "30f5b9ea505d2f0c80348428504139a8d8fa6436"
	},
	"-KhIWTpOZ5tyuVW6p4Ye": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:04.288+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05qdsg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clint_Curtis"
				},
				"name": "Clinton Eugene ``Clint'' Curtis",
				"salience": 0.2723765,
				"type": "PERSON"
			},
			{
				"name": "http://mailstar.net/soros.html",
				"salience": 0.091231726,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "democrats",
				"salience": 0.082895346,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ft8nd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Feeney"
				},
				"name": "Tom Feeney",
				"salience": 0.055708993,
				"type": "PERSON"
			},
			{
				"name": "oil",
				"salience": 0.035190202,
				"type": "OTHER"
			},
			{
				"name": "prototype software package",
				"salience": 0.026859133,
				"type": "OTHER"
			},
			{
				"name": "Georg Soros",
				"salience": 0.025093539,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.020845782,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "wind",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "raddicals",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.018066073,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.013542579,
				"type": "PERSON"
			},
			{
				"name": "wonder",
				"salience": 0.013354171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.012861617,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.011910258,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.010950521,
				"type": "OTHER"
			},
			{
				"name": "Award.YEI",
				"salience": 0.01017947,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.009249221,
				"type": "WORK_OF_ART"
			},
			{
				"name": "liars",
				"salience": 0.009139553,
				"type": "PERSON"
			},
			{
				"name": "whistleblower allegations",
				"salience": 0.008611571,
				"type": "OTHER"
			},
			{
				"name": "employer",
				"salience": 0.007459226,
				"type": "PERSON"
			},
			{
				"name": "computer programmer",
				"salience": 0.007459226,
				"type": "OTHER"
			},
			{
				"name": "ex-employee",
				"salience": 0.007459226,
				"type": "PERSON"
			},
			{
				"name": "election hacking",
				"salience": 0.007459226,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0066905795,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.006447727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "enterprises",
				"salience": 0.006436754,
				"type": "ORGANIZATION"
			},
			{
				"name": "bias",
				"salience": 0.006436754,
				"type": "OTHER"
			},
			{
				"name": "Congressman",
				"salience": 0.006041908,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.0058167013,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0054636337,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.005256275,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0052328263,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.0050377273,
				"type": "EVENT"
			},
			{
				"name": "scheme",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "code",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "touch screen voting systems",
				"salience": 0.0050377273,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.004933725,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.004933725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.0045944713,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02s6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ExxonMobil"
				},
				"name": "ExxonMobil",
				"salience": 0.0045944713,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0045944713,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.004494937,
				"type": "OTHER"
			},
			{
				"name": "http://www.yangenterprises.com/ YEI",
				"salience": 0.00433483,
				"type": "OTHER"
			},
			{
				"name": "Name",
				"salience": 0.0042728335,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0041659256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0041516433,
				"type": "PERSON"
			},
			{
				"name": "assistance",
				"salience": 0.004113478,
				"type": "OTHER"
			},
			{
				"name": "Services",
				"salience": 0.0040827463,
				"type": "OTHER"
			},
			{
				"name": "Field",
				"salience": 0.003960058,
				"type": "OTHER"
			},
			{
				"name": "Yang Enterprises",
				"salience": 0.0035820229,
				"type": "ORGANIZATION"
			},
			{
				"name": "solutions",
				"salience": 0.0035783045,
				"type": "OTHER"
			},
			{
				"name": "Lee) Yang Title",
				"salience": 0.0033096338,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0031925947,
				"type": "OTHER"
			},
			{
				"name": "Small Business Subcontractor",
				"salience": 0.0031925947,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0031020122,
				"type": "PERSON"
			},
			{
				"name": "nottrue",
				"salience": 0.0029965572,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ytc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Information_technology"
				},
				"name": "Information Technology",
				"salience": 0.0026307695,
				"type": "OTHER"
			},
			{
				"name": "GSA Advantage",
				"salience": 0.0026307695,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0024777013,
				"type": "OTHER"
			},
			{
				"name": "smoking gun",
				"salience": 0.0024777013,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "allegation",
				"salience": 0.0024574636,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0023255274,
				"type": "LOCATION"
			},
			{
				"name": "Management Services",
				"salience": 0.0022220076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "GS",
				"salience": 0.0021160692,
				"type": "ORGANIZATION"
			},
			{
				"name": "Li-Woan",
				"salience": 0.002094027,
				"type": "PERSON"
			},
			{
				"name": "cultures",
				"salience": 0.0019973316,
				"type": "OTHER"
			},
			{
				"name": "State of Florida IT Consulting",
				"salience": 0.001965402,
				"type": "ORGANIZATION"
			},
			{
				"name": "Facilities Maintenance",
				"salience": 0.0017373167,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.0017373167,
				"type": "OTHER"
			},
			{
				"name": "YEI",
				"salience": 0.0013677285,
				"type": "LOCATION"
			},
			{
				"name": "Professional Engineering Services",
				"salience": 0.0013677285,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0svpj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marshall_Space_Flight_Center"
				},
				"name": "Marshall Space Flight Center",
				"salience": 0.0010693177,
				"type": "ORGANIZATION"
			},
			{
				"name": "Logistics Worldwide",
				"salience": 0.0010693177,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "9",
		"participants_count": "1",
		"published": "2016-10-27T21:30:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 6.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Georg Soros the good oil . http://mailstar.net/soros.html   Sometimes for truth you have to sacrifice something in order to show non bias , it certainly puts the wind up the mad left raddicals paid by Soros . So the democrats dont think voting is rigged eh???? How do they explain this then ?? Clinton Eugene “Clint” Curtis is an American attorney, computer programmer and ex-employee of NASA and ExxonMobil, who also exposed election hacking.  He is notable chiefly for making a series of whistleblower allegations about his former employer and about Republican Congressman Tom Feeney, including an allegation that in 2000, Feeney and Yang Enterprises requested Curtis’s assistance in a scheme to steal votes by inserting fraudulent code into touch screen voting systems. Remember this is the Democrats at the hearing . He tells the members how he was hired by Congressman Tom Feeney in 2000 to build a prototype software package that would secretly rig an election to sway the result 51/49 to a specified side. Now this shows Donald Trump is not only not bias but just wants an honest election and no vote rigging http://www.activistpost.com/2016/03/watch-computer-programmer-testifies-under-oath-he-coded-computers-to-rig-elections.html  One might ask who are Yang enterprises ??? Field will like this . There was a reason they did not want to know who they were . http://www.yangenterprises.com/   YEI is a GSA Advantage member, offering Information Technology solutions (GS-35F-0896N), Professional Engineering Services (GS-10F-0107Y), Logistics Worldwide (GS-10F-0135Y), and Facilities Maintenance and Management Services (GS-21F-090AA).YEI receives the Marshall Space Flight Center Small Business Subcontractor Excellence Award.YEI awarded State of Florida IT Consulting Services contract.http://www.dms.myflorida.com/business_operations/state_purchasing/vendor_information/state_contracts_and_agreements/state_term_contracts/information_technology_it_consulting_services/contractors/t_z/contractors_yang_enterprises_inc  Name: Li-Woan (Lee) Yang  Title: President/CEO  Looks like they are all in on it , no wonder its always 50/50 no matter how many people in every western country which is impossible given the differnt cultures . The video is the ultimate smoking gun against the liars who know full well its all rigged . And for the Democrats to be claiming its nottrue is an outrageous lie , they had the inquiry .    ",
		"thread_title": "#2817: Serco's Zulu Starnet Blackmail – Clinton 8(a) Pig Farm Bridge – Soros Patent Vote",
		"title": "",
		"type": "bs",
		"uuid": "1403af5606fe2460829e56a0c9adb6178936fbdb"
	},
	"-KhIWTuXb1vWO7fglsk6": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T14:03:12.156+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Roger Stone",
				"salience": 0.4433034,
				"type": "PERSON"
			},
			{
				"name": "Election Special Report",
				"salience": 0.24005544,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Hillary Plans",
				"salience": 0.21262276,
				"type": "OTHER"
			},
			{
				"name": "James O'Keefe",
				"salience": 0.052009206,
				"type": "PERSON"
			},
			{
				"name": "Alex Jones",
				"salience": 0.052009206,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T14:03:12.156+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "\nRoger Stone: Hillary Plans to Steal Election   \nSpecial Report: James O'Keefe and Roger Stone Join Alex Jones   ",
		"thread_title": "Roger Stone update on Stop the Steal exit poll program - Globalist establishment creating false expectation of a close race using fake polls, then rigging voting machines to meet that expectation - Nationalistic, constitutional, free-market awakening - Rothschild, Soros, Hillary's chances of stealing the US election are shrinking by the day - The whole system is rigged and exposed, and the American people are fed up - The elitist deviants are panicking",
		"title": "Roger Stone update on Stop the Steal exit poll program - Globalist establishment creating false expectation of a close race using fake polls, then rigging voting machines to meet that expectation - Nationalistic, constitutional, free-market awakening - Rothschild, Soros, Hillary's chances of stealing the US election are shrinking by the day - The whole system is rigged and exposed, and the American people are fed up - The elitist deviants are panicking",
		"type": "bs",
		"uuid": "13fc2d922a6669ef992eeb7a701646bc04839e18"
	},
	"-KhIZuNrb1xBOv2nF9RR": {
		"author": "pak alresky",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T18:07:55.028+03:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-28T11:58:00.000+03:00",
		"replies_count": "1",
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "ASS..WR.WB.SAYA pak alresky TKI BRUNAY DARUSALAM INGIN BERTERIMA KASIH BANYAK KEPADA EYANG WORO MANGGOLO,YANG SUDAH MEMBANTU ORANG TUA SAYA KARNA SELAMA INI ORANG TUA SAYA SEDANG TERLILIT HUTANG YANG BANYAK,BERKAT BANTUAN AKI SEKARAN ORANG TUA SAYA SUDAH BISA MELUNASI SEMUA HUTAN2NYA,DAN SAWAH YANG DULUNYA SEMPAT DI GADAIKAN SEKARAN ALHAMDULILLAH SUDAH BISA DI TEBUS KEMBALI,ITU SEMUA ATAS BANTUAN EYANG  WORO MANGGOLO MEMBERIKAN ANGKA RITUALNYA KEPADA KAMI DAN TIDAK DI SANGKA SANGKA TERNYATA BERHASIL,BAGI ANDA YANG INGIN DIBANTU SAMA SEPERTI KAMI SILAHKAN HUBUNGI NO HP EYANG WORO MANGGOLO (0823-9177-2208) JANGAN ANDA RAGU ANGKA RITUAL EYANG WORO MANGGOLO SELALU TEPAT DAN TERBUKTI INI BUKAN REKAYASA SAYA SUDAH MEMBUKTIKAN NYA TERIMAH KASIH   NO HP EYANG WORO MANGGOLO (0823-9177-2208)    BUTUH ANGKA GHOIB HASIL RTUAL  EYANG WORO MANGGOLO angka;GHOIB: singapura  angka;GHOIB: hongkong  angka;GHOIB; malaysia  angka;GHOIB; toto magnum  angka”GHOIB; laos…  angka”GHOIB; macau  angka”GHOIB; sidney  angka”GHOIB: vietnam  angka”GHOIB: korea  angka”GHOIB: brunei  angka”GHOIB: china  angka”GHOIB: thailand  ANGKA TOGEL JITU 2D 3D 4D 5D 6D 0823-9177-2208 saya pak alresky posisi sekarang di malaysia  bekerja sebagai BURU BANGUNAN gaji tidak seberapa ",
		"thread_title": "Roger Stone update on Stop the Steal exit poll program - Globalist establishment creating false expectation of a close race using fake polls, then rigging voting machines to meet that expectation - Nationalistic, constitutional, free-market awakening - Rothschild, Soros, Hillary's chances of stealing the US election are shrinking by the day - The whole system is rigged and exposed, and the American people are fed up - The elitist deviants are panicking",
		"title": "",
		"type": "bs",
		"uuid": "a1a02e00f91bc9152c467c9cf3588fd1074e6a7e"
	},
	"-KhI_eN1gwt8cpzGZeYU": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T23:31:03.391+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04gd7t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernardine_Dohrn"
				},
				"name": "Bernardine Dohrn",
				"salience": 0.21214911,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.033177454,
				"type": "PERSON"
			},
			{
				"name": "Digital Fires Instructor Serco",
				"salience": 0.025459789,
				"type": "ORGANIZATION"
			},
			{
				"name": "AbelDanger.net",
				"salience": 0.01608751,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.016034516,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09mfkl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sidley_Austin"
				},
				"name": "Sidley Austin",
				"salience": 0.012841894,
				"type": "ORGANIZATION"
			},
			{
				"name": "2008 Mumbai",
				"salience": 0.010936997,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.009083366,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.008776455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicagoan",
				"salience": 0.008482913,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03srt_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Guard"
				},
				"name": "National Security Guards",
				"salience": 0.008025596,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0076955715,
				"type": "LOCATION"
			},
			{
				"name": "I-Team",
				"salience": 0.0075159436,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0066451086,
				"type": "PERSON"
			},
			{
				"name": "Christopher Rajendran Hyman CBE",
				"salience": 0.006434968,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan.",
				"salience": 0.006342416,
				"type": "LOCATION"
			},
			{
				"name": "Command",
				"salience": 0.006139313,
				"type": "ORGANIZATION"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.005568613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0055177547,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01fzds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Patent_and_Trademark_Office"
				},
				"name": "U.S. Patent and Trademark Office",
				"salience": 0.005463224,
				"type": "ORGANIZATION"
			},
			{
				"name": "attackers",
				"salience": 0.00545213,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.00540547,
				"type": "EVENT"
			},
			{
				"name": "mentor",
				"salience": 0.0053611156,
				"type": "PERSON"
			},
			{
				"name": "consulate",
				"salience": 0.0049673854,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06_wd0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nirupama_Rao"
				},
				"name": "Nirupama Rao",
				"salience": 0.0047893953,
				"type": "PERSON"
			},
			{
				"name": "Mar 2013 Serco Inc.",
				"salience": 0.004619528,
				"type": "ORGANIZATION"
			},
			{
				"name": "warrant",
				"salience": 0.0046128826,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.004485813,
				"type": "OTHER"
			},
			{
				"name": "general",
				"salience": 0.0044485587,
				"type": "PERSON"
			},
			{
				"name": "Starnet Raid",
				"salience": 0.004438328,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09gndg4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Headley"
				},
				"name": "David Coleman Headley",
				"salience": 0.0042807017,
				"type": "PERSON"
			},
			{
				"name": "Gillenwater",
				"salience": 0.0040324465,
				"type": "PERSON"
			},
			{
				"name": "Business",
				"salience": 0.0038976069,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_j43",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lashkar-e-Taiba"
				},
				"name": "Lashkar-e-Taiba",
				"salience": 0.0038250869,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle",
				"salience": 0.0030709708,
				"type": "PERSON"
			},
			{
				"name": "Field",
				"salience": 0.0030614852,
				"type": "LOCATION"
			},
			{
				"name": "exercises",
				"salience": 0.0030272105,
				"type": "OTHER"
			},
			{
				"name": "attacks.",
				"salience": 0.0028509856,
				"type": "PERSON"
			},
			{
				"name": "Platte River Networks",
				"salience": 0.0027197048,
				"type": "ORGANIZATION"
			},
			{
				"name": "Base One",
				"salience": 0.0026170071,
				"type": "ORGANIZATION"
			},
			{
				"name": "protégé company",
				"salience": 0.0026023765,
				"type": "ORGANIZATION"
			},
			{
				"name": "loan",
				"salience": 0.002517742,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0025115495,
				"type": "EVENT"
			},
			{
				"name": "attackers",
				"salience": 0.0025115495,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0025115495,
				"type": "EVENT"
			},
			{
				"name": "attackers",
				"salience": 0.0025115495,
				"type": "PERSON"
			},
			{
				"name": "attackers",
				"salience": 0.0025115495,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0025115495,
				"type": "EVENT"
			},
			{
				"name": "attackers",
				"salience": 0.0024952868,
				"type": "PERSON"
			},
			{
				"name": "visas",
				"salience": 0.0024540098,
				"type": "OTHER"
			},
			{
				"name": "command",
				"salience": 0.0024143227,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0023986495,
				"type": "PERSON"
			},
			{
				"name": "Governments",
				"salience": 0.0023629211,
				"type": "ORGANIZATION"
			},
			{
				"name": "webcast servers",
				"salience": 0.0023629211,
				"type": "OTHER"
			},
			{
				"name": "visa service",
				"salience": 0.0023629211,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0023067335,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "United States Marine",
				"salience": 0.0022925881,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09g9q16",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tahawwur_Hussain_Rana"
				},
				"name": "Tahawwur Rana",
				"salience": 0.0022782972,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0022535292,
				"type": "OTHER"
			},
			{
				"name": "e-mail server company",
				"salience": 0.0022489792,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gndv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zulu_language"
				},
				"name": "Zulu",
				"salience": 0.0022057334,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.002195017,
				"type": "OTHER"
			},
			{
				"name": "Jewish community centre",
				"salience": 0.002195017,
				"type": "ORGANIZATION"
			},
			{
				"name": "operation",
				"salience": 0.0021335236,
				"type": "OTHER"
			},
			{
				"name": "operatives",
				"salience": 0.0021335236,
				"type": "ORGANIZATION"
			},
			{
				"name": "Paul Combetta",
				"salience": 0.0020773679,
				"type": "PERSON"
			},
			{
				"name": "Mark Dohlen",
				"salience": 0.0020294988,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.001999804,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01l4l4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Physical_Laboratory_(United_Kingdom)"
				},
				"name": "National Physical Laboratory",
				"salience": 0.0019760707,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0019263831,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico.com",
				"salience": 0.001887569,
				"type": "ORGANIZATION"
			},
			{
				"name": "webcast",
				"salience": 0.0018474901,
				"type": "OTHER"
			},
			{
				"name": "mentors",
				"salience": 0.0018474901,
				"type": "PERSON"
			},
			{
				"name": "protégée",
				"salience": 0.0018474901,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.0017619471,
				"type": "OTHER"
			},
			{
				"name": "patents",
				"salience": 0.0017619471,
				"type": "OTHER"
			},
			{
				"name": "Director",
				"salience": 0.0017619471,
				"type": "PERSON"
			},
			{
				"name": "McConnell Plum City",
				"salience": 0.0017410639,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0016767724,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.0016681061,
				"type": "PERSON"
			},
			{
				"name": "combat service support",
				"salience": 0.0016681061,
				"type": "OTHER"
			},
			{
				"name": "military disciplines",
				"salience": 0.0016681061,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.0016681061,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0016681061,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0016279723,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.0016173854,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.0015971949,
				"type": "ORGANIZATION"
			},
			{
				"name": "mission",
				"salience": 0.0015635429,
				"type": "OTHER"
			},
			{
				"name": "Field",
				"salience": 0.0015635429,
				"type": "LOCATION"
			},
			{
				"name": "records",
				"salience": 0.0015617354,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bkk6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_key_infrastructure"
				},
				"name": "PKI",
				"salience": 0.0015588793,
				"type": "OTHER"
			},
			{
				"name": "Maria Contreras-Sweet",
				"salience": 0.0015244108,
				"type": "PERSON"
			},
			{
				"name": "Types of Exercise Workshop",
				"salience": 0.0015244108,
				"type": "EVENT"
			},
			{
				"name": "engineers",
				"salience": 0.00151714,
				"type": "PERSON"
			},
			{
				"name": "ground combat",
				"salience": 0.0014444417,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0014444417,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0014444417,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shareholders",
				"salience": 0.0014444417,
				"type": "PERSON"
			},
			{
				"name": "port area",
				"salience": 0.0014444417,
				"type": "LOCATION"
			},
			{
				"name": "militant",
				"salience": 0.0014444417,
				"type": "PERSON"
			},
			{
				"name": "sites",
				"salience": 0.0014444417,
				"type": "LOCATION"
			},
			{
				"name": "courses",
				"salience": 0.0014444417,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0014444417,
				"type": "LOCATION"
			},
			{
				"name": "company",
				"salience": 0.0014429396,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01h1wl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times_of_India"
				},
				"name": "Times of India",
				"salience": 0.0014215109,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.0013720398,
				"type": "OTHER"
			},
			{
				"name": "Defense Ammunition Center",
				"salience": 0.0013510848,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03js9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Mumbai"
				},
				"name": "South Mumbai",
				"salience": 0.0013510848,
				"type": "LOCATION"
			},
			{
				"name": "National Visa Center",
				"salience": 0.0013510848,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05zl0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Princeton_University"
				},
				"name": "Princeton University",
				"salience": 0.0013210002,
				"type": "LOCATION"
			},
			{
				"name": "companies",
				"salience": 0.0013203698,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/028r15",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mumbai_Police"
				},
				"name": "Mumbai Police",
				"salience": 0.0013132246,
				"type": "ORGANIZATION"
			},
			{
				"name": "McConnell -- Global Operations",
				"salience": 0.0013132246,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0013132216,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0013076859,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.0013041765,
				"type": "EVENT"
			},
			{
				"name": "Gold",
				"salience": 0.0013041765,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0013041765,
				"type": "EVENT"
			},
			{
				"name": "intellectual property",
				"salience": 0.0013041765,
				"type": "OTHER"
			},
			{
				"name": "pig farm",
				"salience": 0.0013041765,
				"type": "LOCATION"
			},
			{
				"name": "security forces",
				"salience": 0.0013041765,
				"type": "PERSON"
			},
			{
				"name": "snuff-film crews",
				"salience": 0.0013041765,
				"type": "PERSON"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.0013041765,
				"type": "OTHER"
			},
			{
				"name": "Eight",
				"salience": 0.0013041765,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.0013041765,
				"type": "WORK_OF_ART"
			},
			{
				"name": "series",
				"salience": 0.0013041765,
				"type": "WORK_OF_ART"
			},
			{
				"name": "List",
				"salience": 0.0013041765,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.0013041765,
				"type": "EVENT"
			},
			{
				"name": "forces",
				"salience": 0.0013041765,
				"type": "OTHER"
			},
			{
				"name": "condemnation",
				"salience": 0.0013041765,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0013041765,
				"type": "OTHER"
			},
			{
				"name": "snuff-film crews",
				"salience": 0.0013041765,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0013041765,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0012825774,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/014zws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_Law_School"
				},
				"name": "Harvard Law School",
				"salience": 0.0012482915,
				"type": "ORGANIZATION"
			},
			{
				"name": "participants",
				"salience": 0.0012482664,
				"type": "PERSON"
			},
			{
				"name": "visas",
				"salience": 0.0012454578,
				"type": "OTHER"
			},
			{
				"name": "call center",
				"salience": 0.0012249381,
				"type": "LOCATION"
			},
			{
				"name": "changes",
				"salience": 0.0012185783,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.001211873,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0012066502,
				"type": "PERSON"
			},
			{
				"name": "Police",
				"salience": 0.0011979964,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.001195396,
				"type": "OTHER"
			},
			{
				"name": "explosion",
				"salience": 0.0011880584,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0521fxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zakiur_Rehman_Lakhvi"
				},
				"name": "Zakiur Rehman Lakhvi",
				"salience": 0.0011607998,
				"type": "PERSON"
			},
			{
				"name": "visa",
				"salience": 0.0011396571,
				"type": "OTHER"
			},
			{
				"name": "visa",
				"salience": 0.0011396571,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.0011396571,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.0011396571,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0011371272,
				"type": "LOCATION"
			},
			{
				"name": "lane",
				"salience": 0.001129292,
				"type": "LOCATION"
			},
			{
				"name": "action",
				"salience": 0.001129292,
				"type": "OTHER"
			},
			{
				"name": "enemy capabilities",
				"salience": 0.001129292,
				"type": "OTHER"
			},
			{
				"name": "shooting",
				"salience": 0.001129292,
				"type": "EVENT"
			},
			{
				"name": "aviation",
				"salience": 0.001129292,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.001129292,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.001129292,
				"type": "LOCATION"
			},
			{
				"name": "Subsidiaries",
				"salience": 0.001129292,
				"type": "ORGANIZATION"
			},
			{
				"name": "torture killings",
				"salience": 0.001129292,
				"type": "EVENT"
			},
			{
				"name": "taxi",
				"salience": 0.001129292,
				"type": "OTHER"
			},
			{
				"name": "pig farm raves",
				"salience": 0.001129292,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.001129292,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.001129292,
				"type": "PERSON"
			},
			{
				"name": "lawyer",
				"salience": 0.001129292,
				"type": "PERSON"
			},
			{
				"name": "IP",
				"salience": 0.001129292,
				"type": "OTHER"
			},
			{
				"name": "Teachers",
				"salience": 0.001129292,
				"type": "PERSON"
			},
			{
				"name": "consul general",
				"salience": 0.001110208,
				"type": "PERSON"
			},
			{
				"name": "Peter Thiessen",
				"salience": 0.0010824181,
				"type": "PERSON"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0010745478,
				"type": "PERSON"
			},
			{
				"name": "Information Security Planning",
				"salience": 0.001063231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cdmk3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taj_Hotels_Resorts_and_Palaces"
				},
				"name": "Taj Hotel",
				"salience": 0.0010570278,
				"type": "LOCATION"
			},
			{
				"name": "team",
				"salience": 0.0010420006,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack",
				"salience": 0.0010338305,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0010338305,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0010338305,
				"type": "EVENT"
			},
			{
				"name": "Federal Bridge Certification Authority",
				"salience": 0.0010266949,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ashok Kumar Attri",
				"salience": 0.001009646,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.0010091921,
				"type": "ORGANIZATION"
			},
			{
				"name": "record",
				"salience": 0.000983204,
				"type": "OTHER"
			},
			{
				"name": "consulate office",
				"salience": 0.00097262446,
				"type": "ORGANIZATION"
			},
			{
				"name": "progress",
				"salience": 0.00095637125,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00091788033,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.00091567816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Columbia"
				},
				"name": "B.C.",
				"salience": 0.0009152756,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0009034844,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0009034844,
				"type": "OTHER"
			},
			{
				"name": "government statements",
				"salience": 0.0009034844,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0009034844,
				"type": "WORK_OF_ART"
			},
			{
				"name": "disclaimers",
				"salience": 0.00089607434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ggh4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Xavier's_College,_Mumbai"
				},
				"name": "St. Xavier's College",
				"salience": 0.0008890094,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/021psw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Citizenship_and_Immigration_Services"
				},
				"name": "USCIS",
				"salience": 0.00088856905,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.00088360324,
				"type": "OTHER"
			},
			{
				"name": "visa processing",
				"salience": 0.0008659417,
				"type": "OTHER"
			},
			{
				"name": "bail",
				"salience": 0.00084356364,
				"type": "OTHER"
			},
			{
				"name": "vendors",
				"salience": 0.00084244827,
				"type": "ORGANIZATION"
			},
			{
				"name": "thesis",
				"salience": 0.0008337495,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00083361095,
				"type": "EVENT"
			},
			{
				"name": "considerations",
				"salience": 0.0008318551,
				"type": "OTHER"
			},
			{
				"name": "investigators",
				"salience": 0.00082310446,
				"type": "PERSON"
			},
			{
				"name": "visa application process",
				"salience": 0.00082310446,
				"type": "OTHER"
			},
			{
				"name": "PKIs",
				"salience": 0.0008040381,
				"type": "PERSON"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0008026672,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04vmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mumbai"
				},
				"name": "Bombay",
				"salience": 0.0008026672,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0008026672,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04zy_sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2008_Mumbai_attacks"
				},
				"name": "Operation Black Tornado",
				"salience": 0.0007990811,
				"type": "EVENT"
			},
			{
				"name": "firms",
				"salience": 0.000783938,
				"type": "ORGANIZATION"
			},
			{
				"name": "advantages",
				"salience": 0.0007661223,
				"type": "OTHER"
			},
			{
				"name": "FILES",
				"salience": 0.0007603923,
				"type": "OTHER"
			},
			{
				"name": "citizen.",
				"salience": 0.00075646624,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.0007510205,
				"type": "ORGANIZATION"
			},
			{
				"name": "e-mail server company",
				"salience": 0.0007510205,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.0007510205,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0007510205,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0007510205,
				"type": "ORGANIZATION"
			},
			{
				"name": "head",
				"salience": 0.00074368116,
				"type": "OTHER"
			},
			{
				"name": "women engineer",
				"salience": 0.00073933095,
				"type": "PERSON"
			},
			{
				"name": "entrepreneurs",
				"salience": 0.0007322275,
				"type": "PERSON"
			},
			{
				"name": "law firm",
				"salience": 0.0007312285,
				"type": "ORGANIZATION"
			},
			{
				"name": "visa records",
				"salience": 0.00072517316,
				"type": "OTHER"
			},
			{
				"name": "visa records",
				"salience": 0.00072517316,
				"type": "OTHER"
			},
			{
				"name": "E-Mail Server Company",
				"salience": 0.0007229795,
				"type": "ORGANIZATION"
			},
			{
				"name": "visas",
				"salience": 0.00071279844,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wtrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Visa_(document)"
				},
				"name": "VISA",
				"salience": 0.0007013986,
				"type": "ORGANIZATION"
			},
			{
				"name": "COMMENTS",
				"salience": 0.0006967214,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04zww53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leopold_Cafe"
				},
				"name": "Leopold Cafe",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bx1c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Taj_Mahal_Palace_Hotel"
				},
				"name": "Taj Mahal Palace & Tower",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04zz57g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oberoi_Trident"
				},
				"name": "Oberoi Trident",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01q6xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chhatrapati_Shivaji_Terminus"
				},
				"name": "Chhatrapati Shivaji Terminus",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0206rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Sachs"
				},
				"name": "Sachs",
				"salience": 0.0006950186,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mumbai Terror Attack Watch",
				"salience": 0.0006950186,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03nl1k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mazagaon"
				},
				"name": "Mazagaon",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"name": "Scandal Supercut Copy",
				"salience": 0.0006950186,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0006950186,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d8qb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Journalist"
				},
				"name": "Media Coverage",
				"salience": 0.0006950186,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04zw2ry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ajmal_Kasab"
				},
				"name": "Ajmal Kasab",
				"salience": 0.0006950186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04zyzd7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cama_Hospital"
				},
				"name": "Cama Hospital",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02y3w4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vile_Parle"
				},
				"name": "Vile Parle",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06w988",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Metro_Big_Cinemas"
				},
				"name": "Metro Cinema",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04mn99",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AXA"
				},
				"name": "AXA",
				"salience": 0.0006950186,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01r9k0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Certificate_authority"
				},
				"name": "CA",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.0006950186,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0006950186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04zz_tz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nariman_House"
				},
				"name": "Nariman House",
				"salience": 0.0006950186,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.000686539,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.000686539,
				"type": "PERSON"
			},
			{
				"name": "others.",
				"salience": 0.000686539,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.000686539,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02pbmw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_India"
				},
				"name": "Government of India",
				"salience": 0.00068563386,
				"type": "ORGANIZATION"
			},
			{
				"name": "offices",
				"salience": 0.00068188045,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.00068188045,
				"type": "ORGANIZATION"
			},
			{
				"name": "company offices",
				"salience": 0.00068188045,
				"type": "ORGANIZATION"
			},
			{
				"name": "offices",
				"salience": 0.00068188045,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00068188045,
				"type": "ORGANIZATION"
			},
			{
				"name": "Police",
				"salience": 0.000681404,
				"type": "PERSON"
			},
			{
				"name": "engineering",
				"salience": 0.000680928,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.0006778857,
				"type": "EVENT"
			},
			{
				"name": "birth name",
				"salience": 0.00067698344,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00067553745,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0006695509,
				"type": "ORGANIZATION"
			},
			{
				"name": "officers",
				"salience": 0.00066892384,
				"type": "PERSON"
			},
			{
				"name": "minority professionals",
				"salience": 0.00066767767,
				"type": "PERSON"
			},
			{
				"name": "Webcasting",
				"salience": 0.0006613671,
				"type": "OTHER"
			},
			{
				"name": "management services",
				"salience": 0.0006564204,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0006564204,
				"type": "ORGANIZATION"
			},
			{
				"name": "participants",
				"salience": 0.0006537088,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0006502971,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.0006468318,
				"type": "OTHER"
			},
			{
				"name": "CASE",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "terrorism case",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "visa documents",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "counterpart",
				"salience": 0.000643492,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "Foreign Secretary",
				"salience": 0.000643492,
				"type": "PERSON"
			},
			{
				"name": "outsourcing",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "roles",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "consul general",
				"salience": 0.000643492,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "visa requests",
				"salience": 0.000643492,
				"type": "OTHER"
			},
			{
				"name": "bond",
				"salience": 0.0006410226,
				"type": "OTHER"
			},
			{
				"name": "Table-top exercises",
				"salience": 0.0006390834,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.0006381586,
				"type": "OTHER"
			},
			{
				"name": "mentor",
				"salience": 0.0006366729,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apple_Inc."
				},
				"name": "Apple Computer",
				"salience": 0.00063603517,
				"type": "ORGANIZATION"
			},
			{
				"name": "participants",
				"salience": 0.00063340424,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.00063340424,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00063340424,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00063340424,
				"type": "OTHER"
			},
			{
				"name": "centre",
				"salience": 0.00063340424,
				"type": "LOCATION"
			},
			{
				"name": "more",
				"salience": 0.00063340424,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.00063340424,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0006156512,
				"type": "OTHER"
			},
			{
				"name": "Police",
				"salience": 0.0006156512,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.0006156512,
				"type": "OTHER"
			},
			{
				"name": "grounds",
				"salience": 0.0006156512,
				"type": "LOCATION"
			},
			{
				"name": "complexity",
				"salience": 0.00061307364,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0006097539,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0006097539,
				"type": "OTHER"
			},
			{
				"name": "partnership",
				"salience": 0.0006097539,
				"type": "OTHER"
			},
			{
				"name": "HeiTech Services, Inc.",
				"salience": 0.0006039475,
				"type": "ORGANIZATION"
			},
			{
				"name": "family members",
				"salience": 0.0005944619,
				"type": "PERSON"
			},
			{
				"name": "court",
				"salience": 0.0005944619,
				"type": "LOCATION"
			},
			{
				"name": "paperwork",
				"salience": 0.0005944619,
				"type": "OTHER"
			},
			{
				"name": "travel",
				"salience": 0.0005944619,
				"type": "OTHER"
			},
			{
				"name": "issuance",
				"salience": 0.0005944619,
				"type": "OTHER"
			},
			{
				"name": "issuance",
				"salience": 0.0005944619,
				"type": "EVENT"
			},
			{
				"name": "probe",
				"salience": 0.0005944619,
				"type": "EVENT"
			},
			{
				"name": "papers",
				"salience": 0.0005944619,
				"type": "WORK_OF_ART"
			},
			{
				"name": "team",
				"salience": 0.0005926636,
				"type": "ORGANIZATION"
			},
			{
				"name": "patent application",
				"salience": 0.0005926636,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.0005926636,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0005916638,
				"type": "EVENT"
			},
			{
				"name": "subject",
				"salience": 0.00059139245,
				"type": "OTHER"
			},
			{
				"name": "information systems",
				"salience": 0.0005896034,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0005896034,
				"type": "OTHER"
			},
			{
				"name": "information security policies",
				"salience": 0.0005888237,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0005795706,
				"type": "OTHER"
			},
			{
				"name": "dollar loan",
				"salience": 0.00057704817,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.00057704817,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.00057704817,
				"type": "OTHER"
			},
			{
				"name": "government loans",
				"salience": 0.00057704817,
				"type": "OTHER"
			},
			{
				"name": "police investigation",
				"salience": 0.00057704817,
				"type": "EVENT"
			},
			{
				"name": "government loans",
				"salience": 0.00057704817,
				"type": "OTHER"
			},
			{
				"name": "Loans",
				"salience": 0.00057704817,
				"type": "OTHER"
			},
			{
				"name": "investigators",
				"salience": 0.00057704817,
				"type": "PERSON"
			},
			{
				"name": "Police investigation",
				"salience": 0.00057704817,
				"type": "EVENT"
			},
			{
				"name": "investors",
				"salience": 0.00057704817,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.0005746282,
				"type": "OTHER"
			},
			{
				"name": "law firm",
				"salience": 0.0005746282,
				"type": "ORGANIZATION"
			},
			{
				"name": "communications",
				"salience": 0.0005687464,
				"type": "OTHER"
			},
			{
				"name": "New York Music Festival",
				"salience": 0.0005602051,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.0005558535,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.000536722,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.000536722,
				"type": "EVENT"
			},
			{
				"name": "calls",
				"salience": 0.000536722,
				"type": "OTHER"
			},
			{
				"name": "government court filings",
				"salience": 0.000536722,
				"type": "WORK_OF_ART"
			},
			{
				"name": "property",
				"salience": 0.000536722,
				"type": "OTHER"
			},
			{
				"name": "surety bonds",
				"salience": 0.000536722,
				"type": "OTHER"
			},
			{
				"name": "persons",
				"salience": 0.000536722,
				"type": "PERSON"
			},
			{
				"name": "assault",
				"salience": 0.000536722,
				"type": "EVENT"
			},
			{
				"name": "revenues",
				"salience": 0.0005343239,
				"type": "OTHER"
			},
			{
				"name": "outsourcing",
				"salience": 0.0005319984,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0005170576,
				"type": "LOCATION"
			},
			{
				"name": "business",
				"salience": 0.0005170576,
				"type": "OTHER"
			},
			{
				"name": "thesis",
				"salience": 0.0005148775,
				"type": "OTHER"
			},
			{
				"name": "audio/video webcasts",
				"salience": 0.0005131749,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media files",
				"salience": 0.0005131749,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.0005083876,
				"type": "WORK_OF_ART"
			},
			{
				"name": "E-Mails",
				"salience": 0.0005083876,
				"type": "OTHER"
			},
			{
				"name": "trading",
				"salience": 0.0005083876,
				"type": "EVENT"
			},
			{
				"name": "directors",
				"salience": 0.0005083876,
				"type": "PERSON"
			},
			{
				"name": "e-mails",
				"salience": 0.0005083876,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00050635246,
				"type": "OTHER"
			},
			{
				"name": "grouping",
				"salience": 0.000502565,
				"type": "ORGANIZATION"
			},
			{
				"name": "teamwork",
				"salience": 0.000502565,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n5zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Component_Object_Model"
				},
				"name": "COM",
				"salience": 0.00050038105,
				"type": "OTHER"
			},
			{
				"name": "heroin dealer",
				"salience": 0.00049516594,
				"type": "ORGANIZATION"
			},
			{
				"name": "name",
				"salience": 0.0004930108,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0004899754,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0004899754,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.0004899754,
				"type": "ORGANIZATION"
			},
			{
				"name": "thesis",
				"salience": 0.0004894045,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thesis",
				"salience": 0.0004894045,
				"type": "OTHER"
			},
			{
				"name": "internet",
				"salience": 0.0004894045,
				"type": "OTHER"
			},
			{
				"name": "perpetrator",
				"salience": 0.00048892444,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0004867965,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.00048428707,
				"type": "PERSON"
			},
			{
				"name": "network",
				"salience": 0.0004813011,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.0004813011,
				"type": "EVENT"
			},
			{
				"name": "raid",
				"salience": 0.0004813011,
				"type": "EVENT"
			},
			{
				"name": "raid",
				"salience": 0.0004813011,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.00048066047,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0155qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_Corps_Base_Camp_Pendleton"
				},
				"name": "Camp Pendleton",
				"salience": 0.00047504023,
				"type": "LOCATION"
			},
			{
				"name": "BREAKING",
				"salience": 0.0004727804,
				"type": "EVENT"
			},
			{
				"name": "procedures",
				"salience": 0.0004710518,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.0004710518,
				"type": "OTHER"
			},
			{
				"name": "talent pool",
				"salience": 0.00046861946,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rdm1x"
				},
				"name": "Mentor",
				"salience": 0.0004679603,
				"type": "PERSON"
			},
			{
				"name": "background check",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "camera",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "massacre",
				"salience": 0.00046473523,
				"type": "EVENT"
			},
			{
				"name": "suspects",
				"salience": 0.00046473523,
				"type": "PERSON"
			},
			{
				"name": "answers",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "district judge",
				"salience": 0.00046473523,
				"type": "PERSON"
			},
			{
				"name": "prosecutors",
				"salience": 0.00046473523,
				"type": "PERSON"
			},
			{
				"name": "targets",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.00046473523,
				"type": "PERSON"
			},
			{
				"name": "passage",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "cash",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "news conference",
				"salience": 0.00046473523,
				"type": "EVENT"
			},
			{
				"name": "website claims",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.00046473523,
				"type": "OTHER"
			},
			{
				"name": "concert",
				"salience": 0.00046332926,
				"type": "EVENT"
			},
			{
				"name": "concert",
				"salience": 0.00046332926,
				"type": "EVENT"
			},
			{
				"name": "concert",
				"salience": 0.00046332926,
				"type": "EVENT"
			},
			{
				"name": "author",
				"salience": 0.00046332926,
				"type": "PERSON"
			},
			{
				"name": "research team",
				"salience": 0.0004598636,
				"type": "ORGANIZATION"
			},
			{
				"name": "Serco , Inc.",
				"salience": 0.0004585997,
				"type": "ORGANIZATION"
			},
			{
				"name": "TSymmetry, Inc.",
				"salience": 0.0004585997,
				"type": "ORGANIZATION"
			},
			{
				"name": "contracts",
				"salience": 0.00045374976,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.00045374976,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00045374976,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00045112107,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00045112107,
				"type": "LOCATION"
			},
			{
				"name": "data",
				"salience": 0.00045112107,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00045112107,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.00045112107,
				"type": "EVENT"
			},
			{
				"name": "request",
				"salience": 0.00045112107,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00045112107,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.00045112107,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.00045112107,
				"type": "OTHER"
			},
			{
				"name": "NVC",
				"salience": 0.0004454891,
				"type": "ORGANIZATION"
			},
			{
				"name": "users",
				"salience": 0.00044040618,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00043925532,
				"type": "LOCATION"
			},
			{
				"name": "Starnet Communications",
				"salience": 0.0004287728,
				"type": "ORGANIZATION"
			},
			{
				"name": "issues",
				"salience": 0.00042745494,
				"type": "OTHER"
			},
			{
				"name": "speculation",
				"salience": 0.00042745494,
				"type": "OTHER"
			},
			{
				"name": "distribution",
				"salience": 0.00042745494,
				"type": "OTHER"
			},
			{
				"name": "webcast equivalent",
				"salience": 0.0004220668,
				"type": "OTHER"
			},
			{
				"name": "Super Serco",
				"salience": 0.0004178817,
				"type": "ORGANIZATION"
			},
			{
				"name": "company sites",
				"salience": 0.0004167466,
				"type": "LOCATION"
			},
			{
				"name": "search",
				"salience": 0.0004167466,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0004167466,
				"type": "OTHER"
			},
			{
				"name": "Simulation",
				"salience": 0.00041645544,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.0004157763,
				"type": "ORGANIZATION"
			},
			{
				"name": "profits",
				"salience": 0.0004150017,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0004150017,
				"type": "OTHER"
			},
			{
				"name": "planning",
				"salience": 0.0004150017,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.0004150017,
				"type": "OTHER"
			},
			{
				"name": "organisations",
				"salience": 0.0004150017,
				"type": "ORGANIZATION"
			},
			{
				"name": "high frequency trading",
				"salience": 0.0004150017,
				"type": "OTHER"
			},
			{
				"name": "diplomats",
				"salience": 0.00041459463,
				"type": "PERSON"
			},
			{
				"name": "network",
				"salience": 0.00041334034,
				"type": "OTHER"
			},
			{
				"name": "invention",
				"salience": 0.00041224426,
				"type": "OTHER"
			},
			{
				"name": "thesis",
				"salience": 0.00040977052,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00040635373,
				"type": "PERSON"
			},
			{
				"name": "individuals",
				"salience": 0.00040635373,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03cn2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_Communications_Headquarters"
				},
				"name": "GCHQ",
				"salience": 0.0004056557,
				"type": "ORGANIZATION"
			},
			{
				"name": "controllers",
				"salience": 0.00040479426,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00040420843,
				"type": "PERSON"
			},
			{
				"name": "above",
				"salience": 0.00040420843,
				"type": "OTHER"
			},
			{
				"name": "PGPubs) Classification Services",
				"salience": 0.00040396902,
				"type": "ORGANIZATION"
			},
			{
				"name": "equivalent",
				"salience": 0.00040118492,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00040118492,
				"type": "OTHER"
			},
			{
				"name": "Travisa Outsourcing",
				"salience": 0.00039601212,
				"type": "ORGANIZATION"
			},
			{
				"name": "Profit growth",
				"salience": 0.00039585112,
				"type": "OTHER"
			},
			{
				"name": "SSL protocol",
				"salience": 0.00039560406,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00039289013,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00039289013,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.00039289013,
				"type": "OTHER"
			},
			{
				"name": "simulation support",
				"salience": 0.00039289013,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00039289013,
				"type": "LOCATION"
			},
			{
				"name": "status",
				"salience": 0.00038621572,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00038621572,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00038621572,
				"type": "OTHER"
			},
			{
				"name": "search warrant",
				"salience": 0.00038593443,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.00037936692,
				"type": "OTHER"
			},
			{
				"name": "AM ET Police",
				"salience": 0.00037887733,
				"type": "ORGANIZATION"
			},
			{
				"name": "condo",
				"salience": 0.00037626614,
				"type": "LOCATION"
			},
			{
				"name": "charges",
				"salience": 0.00037626614,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00037626614,
				"type": "WORK_OF_ART"
			},
			{
				"name": "licensing agreements",
				"salience": 0.00037626614,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00037626614,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.00037626614,
				"type": "OTHER"
			},
			{
				"name": "child pornography",
				"salience": 0.00037626614,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00037626614,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pornography",
				"salience": 0.00037626614,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.00037539005,
				"type": "OTHER"
			},
			{
				"name": "rigour",
				"salience": 0.00037458487,
				"type": "OTHER"
			},
			{
				"name": "roles",
				"salience": 0.0003682533,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0003682533,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0003682533,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.0003682533,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0003682533,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0003682533,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0003682533,
				"type": "LOCATION"
			},
			{
				"name": "leadership",
				"salience": 0.0003682533,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0003682533,
				"type": "OTHER"
			},
			{
				"name": "Travisa",
				"salience": 0.00036583637,
				"type": "ORGANIZATION"
			},
			{
				"name": "Webcasting Group",
				"salience": 0.00036472955,
				"type": "ORGANIZATION"
			},
			{
				"name": "@HillaryClinton",
				"salience": 0.00036472955,
				"type": "PERSON"
			},
			{
				"name": "firms",
				"salience": 0.00036396578,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00036396578,
				"type": "ORGANIZATION"
			},
			{
				"name": "veteran firms",
				"salience": 0.00036396578,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00036396578,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00036396578,
				"type": "ORGANIZATION"
			},
			{
				"name": "firm",
				"salience": 0.00036396578,
				"type": "ORGANIZATION"
			},
			{
				"name": "Daood Giliani",
				"salience": 0.00036394724,
				"type": "PERSON"
			},
			{
				"name": "Internet",
				"salience": 0.00036319083,
				"type": "OTHER"
			},
			{
				"name": "globe",
				"salience": 0.00036221585,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.00036221585,
				"type": "EVENT"
			},
			{
				"name": "periphery",
				"salience": 0.00036221585,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00036221585,
				"type": "OTHER"
			},
			{
				"name": "bar",
				"salience": 0.00036221585,
				"type": "LOCATION"
			},
			{
				"name": "reporters",
				"salience": 0.00036221585,
				"type": "PERSON"
			},
			{
				"name": "event audio webcast concerts",
				"salience": 0.00036221585,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "list",
				"salience": 0.00036221585,
				"type": "OTHER"
			},
			{
				"name": "applicant",
				"salience": 0.00036137248,
				"type": "PERSON"
			},
			{
				"name": "cryptographic engineering",
				"salience": 0.00035656797,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.0003547913,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.00035156374,
				"type": "EVENT"
			},
			{
				"name": "cutting edge solutions",
				"salience": 0.000347473,
				"type": "OTHER"
			},
			{
				"name": "cutting edge solutions",
				"salience": 0.000347473,
				"type": "OTHER"
			},
			{
				"name": "Office of Partner Relations",
				"salience": 0.0003456256,
				"type": "OTHER"
			},
			{
				"name": "order book",
				"salience": 0.0003427564,
				"type": "WORK_OF_ART"
			},
			{
				"name": "caesium fountain atomic clock",
				"salience": 0.0003427564,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01ryjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cabinet_Office"
				},
				"name": "UK Cabinet Office",
				"salience": 0.0003425534,
				"type": "ORGANIZATION"
			},
			{
				"name": "locations",
				"salience": 0.00034019252,
				"type": "LOCATION"
			},
			{
				"name": "benefit",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00034019252,
				"type": "LOCATION"
			},
			{
				"name": "agencies",
				"salience": 0.00034019252,
				"type": "ORGANIZATION"
			},
			{
				"name": "work",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "mix",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.00034019252,
				"type": "LOCATION"
			},
			{
				"name": "Internet gaming",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "cutting edge",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "City",
				"salience": 0.00034019252,
				"type": "LOCATION"
			},
			{
				"name": "benefit",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "gaming",
				"salience": 0.00034019252,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0003389263,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.0003389263,
				"type": "PERSON"
			},
			{
				"name": "engineers",
				"salience": 0.0003389263,
				"type": "PERSON"
			},
			{
				"name": "diversity",
				"salience": 0.0003389263,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.0003389263,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.0003387681,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0003387681,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08_ykc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Small_Business_Administration"
				},
				"name": "Small Business Administration",
				"salience": 0.00033775342,
				"type": "ORGANIZATION"
			},
			{
				"name": "petition",
				"salience": 0.00033696275,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.00032895902,
				"type": "OTHER"
			},
			{
				"name": "government bureaucrats",
				"salience": 0.00032579803,
				"type": "PERSON"
			},
			{
				"name": "favors",
				"salience": 0.00032579803,
				"type": "OTHER"
			},
			{
				"name": "friendly",
				"salience": 0.00032579803,
				"type": "EVENT"
			},
			{
				"name": "office space",
				"salience": 0.00032579803,
				"type": "LOCATION"
			},
			{
				"name": "Share prices",
				"salience": 0.00032579803,
				"type": "OTHER"
			},
			{
				"name": "money laundering",
				"salience": 0.00032579803,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.00032579803,
				"type": "PERSON"
			},
			{
				"name": "sex shows",
				"salience": 0.00032579803,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tips",
				"salience": 0.00032579803,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.00032579803,
				"type": "LOCATION"
			},
			{
				"name": "gambling",
				"salience": 0.00032579803,
				"type": "OTHER"
			},
			{
				"name": "materials",
				"salience": 0.00032579803,
				"type": "OTHER"
			},
			{
				"name": "seizure",
				"salience": 0.00032579803,
				"type": "OTHER"
			},
			{
				"name": "gaming software",
				"salience": 0.00032579803,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Base One",
				"salience": 0.00032105207,
				"type": "ORGANIZATION"
			},
			{
				"name": "Centre of Carbon Measurement",
				"salience": 0.00031819826,
				"type": "ORGANIZATION"
			},
			{
				"name": "vendors",
				"salience": 0.00031526008,
				"type": "ORGANIZATION"
			},
			{
				"name": "excerpts",
				"salience": 0.00031363213,
				"type": "WORK_OF_ART"
			},
			{
				"name": "links",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "J.D.",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00031363213,
				"type": "PERSON"
			},
			{
				"name": "window",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "alumnus",
				"salience": 0.00031363213,
				"type": "PERSON"
			},
			{
				"name": "mirrors",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "audio",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "video multicast",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "rock band",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "history.",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "clubs",
				"salience": 0.00031363213,
				"type": "LOCATION"
			},
			{
				"name": "examples",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "hypotheses",
				"salience": 0.00031363213,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0003099827,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.0003099827,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0003099827,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.0003099827,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0003099827,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0003099827,
				"type": "OTHER"
			},
			{
				"name": "professionals",
				"salience": 0.0003099827,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0003099827,
				"type": "ORGANIZATION"
			},
			{
				"name": "IT professionals",
				"salience": 0.0003099827,
				"type": "PERSON"
			},
			{
				"name": "community organizations",
				"salience": 0.0003099827,
				"type": "ORGANIZATION"
			},
			{
				"name": "exercise tempo",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "goodwill",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "dividends",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "innovation",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "goodbye",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0003071474,
				"type": "EVENT"
			},
			{
				"name": "innovation",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "media play",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0003071474,
				"type": "ORGANIZATION"
			},
			{
				"name": "management",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "breadth",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "decision making",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"name": "Table Top",
				"salience": 0.0003071474,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/080h2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vancouver"
				},
				"name": "Vancouver",
				"salience": 0.0003049452,
				"type": "LOCATION"
			},
			{
				"name": "K.J.",
				"salience": 0.0003049452,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00030278103,
				"type": "PERSON"
			},
			{
				"name": "services",
				"salience": 0.00030278103,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00030278103,
				"type": "ORGANIZATION"
			},
			{
				"name": "career",
				"salience": 0.0003019205,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00029772034,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00029772034,
				"type": "OTHER"
			},
			{
				"name": "implementation",
				"salience": 0.00029567786,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.00029459674,
				"type": "EVENT"
			},
			{
				"name": "resources",
				"salience": 0.00029346612,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00029346612,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00029346612,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.00029346612,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.00029346612,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.00029346612,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.00029346612,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00029127087,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00028875525,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03wd63k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chuck_Goudie"
				},
				"name": "Chuck Goudie",
				"salience": 0.0002859972,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0002859972,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j49t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan_Avenue_(Chicago)"
				},
				"name": "Michigan Avenue",
				"salience": 0.0002859972,
				"type": "LOCATION"
			},
			{
				"name": "Rani",
				"salience": 0.0002859972,
				"type": "PERSON"
			},
			{
				"name": "Tahawwur Rana Hussain",
				"salience": 0.0002859972,
				"type": "PERSON"
			},
			{
				"name": "Serco Processes 2 Millionth Patent Application",
				"salience": 0.00028513192,
				"type": "OTHER"
			},
			{
				"name": "nationals",
				"salience": 0.0002842602,
				"type": "PERSON"
			},
			{
				"name": "Consumer groups",
				"salience": 0.00028397384,
				"type": "ORGANIZATION"
			},
			{
				"name": "center",
				"salience": 0.00028125342,
				"type": "LOCATION"
			},
			{
				"name": "center",
				"salience": 0.00028125342,
				"type": "LOCATION"
			},
			{
				"name": "businesses",
				"salience": 0.00028125342,
				"type": "ORGANIZATION"
			},
			{
				"name": "business",
				"salience": 0.00028125342,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00028125342,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.00027979273,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00027942273,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00027506327,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00027506327,
				"type": "OTHER"
			},
			{
				"name": "pool",
				"salience": 0.00027506327,
				"type": "OTHER"
			},
			{
				"name": "pool",
				"salience": 0.00027506327,
				"type": "LOCATION"
			},
			{
				"name": "technology research",
				"salience": 0.00027506327,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.00027506327,
				"type": "PERSON"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00027506327,
				"type": "OTHER"
			},
			{
				"name": "staffing",
				"salience": 0.00027506327,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.00027506327,
				"type": "OTHER"
			},
			{
				"name": "pools",
				"salience": 0.00027506327,
				"type": "OTHER"
			},
			{
				"name": "visa applications",
				"salience": 0.0002733696,
				"type": "OTHER"
			},
			{
				"name": "teams",
				"salience": 0.0002733696,
				"type": "ORGANIZATION"
			},
			{
				"name": "applicants",
				"salience": 0.0002733696,
				"type": "PERSON"
			},
			{
				"name": "business operations",
				"salience": 0.0002733696,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.0002733696,
				"type": "OTHER"
			},
			{
				"name": "http://en.wikipedia.org/wiki/Bernardine_Dohrn",
				"salience": 0.0002672517,
				"type": "OTHER"
			},
			{
				"name": "http://en.wikipedia.org/wiki/Barack_Obama",
				"salience": 0.0002672517,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00026621047,
				"type": "OTHER"
			},
			{
				"name": "defence budgets",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "Punk",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "entertainment",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "sex side",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "opportunities",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "prisons",
				"salience": 0.00026594935,
				"type": "LOCATION"
			},
			{
				"name": "airport radar",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "forest bulldozers",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "farewell",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "accomplishments",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "achievements",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "carbon emissions reductions",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "footprint",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "running banks",
				"salience": 0.00026594935,
				"type": "ORGANIZATION"
			},
			{
				"name": "environment",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "readiness",
				"salience": 0.00026594935,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.0002650499,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02t27n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_of_Information_Act_(United_States)"
				},
				"name": "Freedom of Information Act",
				"salience": 0.0002640425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00025742754,
				"type": "ORGANIZATION"
			},
			{
				"name": "GotNews.com/donate",
				"salience": 0.00025646365,
				"type": "OTHER"
			},
			{
				"name": "@gotnews.com",
				"salience": 0.00025646365,
				"type": "PERSON"
			},
			{
				"name": "group finance director",
				"salience": 0.0002562695,
				"type": "PERSON"
			},
			{
				"name": "thesis",
				"salience": 0.0002562695,
				"type": "OTHER"
			},
			{
				"name": "processes",
				"salience": 0.00025622692,
				"type": "OTHER"
			},
			{
				"name": "Stocks",
				"salience": 0.00025601813,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.000254103,
				"type": "PERSON"
			},
			{
				"name": "affiliations",
				"salience": 0.000254103,
				"type": "ORGANIZATION"
			},
			{
				"name": "IT projects",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "spectrum",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "Women",
				"salience": 0.000254103,
				"type": "PERSON"
			},
			{
				"name": "schemes",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "diversity mix",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.000254103,
				"type": "ORGANIZATION"
			},
			{
				"name": "viewpoint",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "diversity mix",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.000254103,
				"type": "ORGANIZATION"
			},
			{
				"name": "diversity recruiting",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "diversity recruitment",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.000254103,
				"type": "OTHER"
			},
			{
				"name": "Kabul for COM approval",
				"salience": 0.00025095837,
				"type": "OTHER"
			},
			{
				"name": "contractor",
				"salience": 0.00024996596,
				"type": "PERSON"
			},
			{
				"name": "companies",
				"salience": 0.00024909337,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.00024909337,
				"type": "ORGANIZATION"
			},
			{
				"name": "components",
				"salience": 0.00024909337,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.00024688663,
				"type": "LOCATION"
			},
			{
				"name": "effect",
				"salience": 0.00024335094,
				"type": "OTHER"
			},
			{
				"name": "discoveries",
				"salience": 0.00024261467,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.00024039357,
				"type": "EVENT"
			},
			{
				"name": "visa files",
				"salience": 0.00023670189,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.00023670189,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.00023670189,
				"type": "OTHER"
			},
			{
				"name": "Benford E. Standley",
				"salience": 0.00023171297,
				"type": "PERSON"
			},
			{
				"name": "GotNews",
				"salience": 0.00023155106,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02vk77f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBC_News"
				},
				"name": "CBC News",
				"salience": 0.00023155106,
				"type": "ORGANIZATION"
			},
			{
				"name": "GotNews",
				"salience": 0.00023155106,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.00023131045,
				"type": "OTHER"
			},
			{
				"name": "communication",
				"salience": 0.00023108124,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00023108124,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00023108124,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00023108124,
				"type": "OTHER"
			},
			{
				"name": "Strategy",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "relationships",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "government implementations",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "diversity talent",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00022941972,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.00022740045,
				"type": "WORK_OF_ART"
			},
			{
				"name": "governments",
				"salience": 0.00022615826,
				"type": "ORGANIZATION"
			},
			{
				"name": "director",
				"salience": 0.00022573689,
				"type": "PERSON"
			},
			{
				"name": "solutions",
				"salience": 0.00022573689,
				"type": "OTHER"
			},
			{
				"name": "deputy director",
				"salience": 0.00022573689,
				"type": "PERSON"
			},
			{
				"name": "risk analysis",
				"salience": 0.00022573689,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017j69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northwestern_University"
				},
				"name": "Northwestern",
				"salience": 0.00022290427,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02bf58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Chicago_Law_School"
				},
				"name": "University of Chicago Law School",
				"salience": 0.00022290427,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dth9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Information_Systems_Agency"
				},
				"name": "Defense Information Systems Agency",
				"salience": 0.00021942232,
				"type": "ORGANIZATION"
			},
			{
				"name": "Special Immigrant Visa",
				"salience": 0.00021833509,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00021822096,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00021822096,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00021414497,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00021370883,
				"type": "OTHER"
			},
			{
				"name": "hub zone location",
				"salience": 0.00021275388,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.00021007814,
				"type": "LOCATION"
			},
			{
				"name": "consequence",
				"salience": 0.00021007814,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00021007814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v06q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Emergency_Planning_College"
				},
				"name": "Emergency Planning College",
				"salience": 0.00020935078,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09bbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gold_standard"
				},
				"name": "Gold Standard",
				"salience": 0.00020935078,
				"type": "OTHER"
			},
			{
				"name": "surplus",
				"salience": 0.0002089871,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.00020564423,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.00020545442,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00020418933,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.00020049223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fk1z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic"
				},
				"name": "Hispanic",
				"salience": 0.00020049223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0261m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caribbean"
				},
				"name": "Caribbean",
				"salience": 0.00020049223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.00020049223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j05f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_Canadian_Mounted_Police"
				},
				"name": "RCMP",
				"salience": 0.00020049223,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.00020049223,
				"type": "ORGANIZATION"
			},
			{
				"name": "contacteditor@gotnews.com",
				"salience": 0.00020049223,
				"type": "OTHER"
			},
			{
				"name": "USAspending.gov",
				"salience": 0.00020049223,
				"type": "OTHER"
			},
			{
				"name": "CHARLES C. JOHNSON",
				"salience": 0.00020049223,
				"type": "PERSON"
			},
			{
				"name": "incident documentation",
				"salience": 0.00020030716,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.00020030716,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00020030716,
				"type": "OTHER"
			},
			{
				"name": "Information Security Counter",
				"salience": 0.00020030716,
				"type": "ORGANIZATION"
			},
			{
				"name": "posts",
				"salience": 0.00020030716,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.00020030716,
				"type": "PERSON"
			},
			{
				"name": "petitions",
				"salience": 0.00020030716,
				"type": "OTHER"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.00020030716,
				"type": "PERSON"
			},
			{
				"name": "employers",
				"salience": 0.00020030716,
				"type": "ORGANIZATION"
			},
			{
				"name": "contract employees",
				"salience": 0.00020030716,
				"type": "PERSON"
			},
			{
				"name": "employees",
				"salience": 0.00020030716,
				"type": "PERSON"
			},
			{
				"name": "petition",
				"salience": 0.00020030716,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.00020030716,
				"type": "PERSON"
			},
			{
				"name": "visa petitions",
				"salience": 0.00020030716,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.00020030716,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.00019864675,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.00019864675,
				"type": "OTHER"
			},
			{
				"name": "scope",
				"salience": 0.00019864675,
				"type": "OTHER"
			},
			{
				"name": "points of view",
				"salience": 0.00019864675,
				"type": "OTHER"
			},
			{
				"name": "IT skills",
				"salience": 0.00019864675,
				"type": "OTHER"
			},
			{
				"name": "pioneers",
				"salience": 0.00019864675,
				"type": "PERSON"
			},
			{
				"name": "IT positions",
				"salience": 0.00019864675,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0001963352,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021_9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Union_territory"
				},
				"name": "UT",
				"salience": 0.0001930052,
				"type": "LOCATION"
			},
			{
				"name": "Slim",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco.",
				"salience": 0.0001930052,
				"type": "LOCATION"
			},
			{
				"name": "James Fulford",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"name": "David B. Pakman",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.0001930052,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j5g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wales"
				},
				"name": "Wales",
				"salience": 0.0001930052,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rcr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Metallica"
				},
				"name": "Metallica",
				"salience": 0.0001930052,
				"type": "ORGANIZATION"
			},
			{
				"name": "Celtica",
				"salience": 0.0001930052,
				"type": "ORGANIZATION"
			},
			{
				"name": "Caduseus",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"name": "Jeffrey Ressner",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"name": "Machynlleth",
				"salience": 0.0001930052,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0712bf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_patent_law"
				},
				"name": "Pre-Grant Publication",
				"salience": 0.0001930052,
				"type": "ORGANIZATION"
			},
			{
				"name": "Michael Dorf",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"name": "Andrew Rasiej",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"name": "Steve Sailer",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0zd6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Macintosh"
				},
				"name": "Macintosh",
				"salience": 0.0001930052,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.0001930052,
				"type": "PERSON"
			},
			{
				"name": "procedures",
				"salience": 0.00019138459,
				"type": "OTHER"
			},
			{
				"name": "Head",
				"salience": 0.00019138459,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.00019138459,
				"type": "EVENT"
			},
			{
				"name": "DKW Communications, Inc.",
				"salience": 0.00019038333,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.00018901442,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bxwmd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indian_Foreign_Service"
				},
				"name": "Foreign Service",
				"salience": 0.00018632734,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0158jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_service"
				},
				"name": "Civil Service",
				"salience": 0.00018632734,
				"type": "ORGANIZATION"
			},
			{
				"name": "paperwork",
				"salience": 0.0001850431,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0001850431,
				"type": "LOCATION"
			},
			{
				"name": "Citizenship",
				"salience": 0.0001850431,
				"type": "OTHER"
			},
			{
				"name": "visa pre-processing",
				"salience": 0.0001850431,
				"type": "OTHER"
			},
			{
				"name": "information technology risk",
				"salience": 0.0001850431,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.0001850431,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0001850431,
				"type": "OTHER"
			},
			{
				"name": "appointment scheduling",
				"salience": 0.0001850431,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0001849138,
				"type": "PERSON"
			},
			{
				"name": "Exercises",
				"salience": 0.00018435433,
				"type": "OTHER"
			},
			{
				"name": "Operating procedures",
				"salience": 0.00017962191,
				"type": "OTHER"
			},
			{
				"name": "time line",
				"salience": 0.00017721306,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00017680041,
				"type": "OTHER"
			},
			{
				"name": "cryptographic protocols",
				"salience": 0.00017680041,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.00017667688,
				"type": "PERSON"
			},
			{
				"name": "concurrence",
				"salience": 0.00017444968,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00017326577,
				"type": "PERSON"
			},
			{
				"name": "Transitional Immigrant Visa Processing Center",
				"salience": 0.0001730791,
				"type": "ORGANIZATION"
			},
			{
				"name": "role",
				"salience": 0.00017202126,
				"type": "OTHER"
			},
			{
				"name": "package",
				"salience": 0.00017136103,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00017136103,
				"type": "OTHER"
			},
			{
				"name": "recognition",
				"salience": 0.00016861016,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00016861016,
				"type": "OTHER"
			},
			{
				"name": "organisation",
				"salience": 0.00016861016,
				"type": "ORGANIZATION"
			},
			{
				"name": "intensity",
				"salience": 0.00016861016,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.00016861016,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00016861016,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "mail",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "Agreements",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "Information Security Expertise",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "assessments",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "successor",
				"salience": 0.00016706788,
				"type": "PERSON"
			},
			{
				"name": "growth",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "strategies",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "filing",
				"salience": 0.00016706788,
				"type": "EVENT"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.00016706788,
				"type": "OTHER"
			},
			{
				"name": "penetration testing",
				"salience": 0.00016632133,
				"type": "EVENT"
			},
			{
				"name": "need",
				"salience": 0.0001649618,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0001649618,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02fvf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Docklands_Light_Railway"
				},
				"name": "Docklands Light Railway",
				"salience": 0.0001636609,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0001636609,
				"type": "LOCATION"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.00016044726,
				"type": "ORGANIZATION"
			},
			{
				"name": "each other",
				"salience": 0.00015962587,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.00015962587,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.00015962587,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00015962587,
				"type": "OTHER"
			},
			{
				"name": "disclosure",
				"salience": 0.00015962587,
				"type": "OTHER"
			},
			{
				"name": "authentication",
				"salience": 0.00015962587,
				"type": "OTHER"
			},
			{
				"name": "Web users",
				"salience": 0.00015962587,
				"type": "PERSON"
			},
			{
				"name": "server authentication",
				"salience": 0.00015962587,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00015962587,
				"type": "PERSON"
			},
			{
				"name": "Diversity Recruitment and Staffing",
				"salience": 0.00015637065,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.00015541952,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.00015493127,
				"type": "OTHER"
			},
			{
				"name": "BUSINESS CORPORATION",
				"salience": 0.00015413118,
				"type": "ORGANIZATION"
			},
			{
				"name": "role",
				"salience": 0.00014961557,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00014961557,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00014961557,
				"type": "LOCATION"
			},
			{
				"name": "requirements",
				"salience": 0.00014961557,
				"type": "OTHER"
			},
			{
				"name": "Command Post",
				"salience": 0.00014961557,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00014961557,
				"type": "OTHER"
			},
			{
				"name": "databases",
				"salience": 0.00014961557,
				"type": "OTHER"
			},
			{
				"name": "finance director",
				"salience": 0.00014664876,
				"type": "PERSON"
			},
			{
				"name": "primitives",
				"salience": 0.0001465049,
				"type": "OTHER"
			},
			{
				"name": "Mentor Protégé",
				"salience": 0.000145662,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03b9f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_jury"
				},
				"name": "Grand Juries",
				"salience": 0.00014536644,
				"type": "ORGANIZATION"
			},
			{
				"name": "Yours",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "honey-pots",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "mentoring goals",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "fiancé",
				"salience": 0.00014465803,
				"type": "PERSON"
			},
			{
				"name": "logging",
				"salience": 0.00014465803,
				"type": "EVENT"
			},
			{
				"name": "preprocessing",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "embassies",
				"salience": 0.00014465803,
				"type": "LOCATION"
			},
			{
				"name": "adjudication",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "fees",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "utilization",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "implements",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "Clients",
				"salience": 0.00014465803,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "inception",
				"salience": 0.00014465803,
				"type": "EVENT"
			},
			{
				"name": "pieces",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "shelves",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "file rooms",
				"salience": 0.00014465803,
				"type": "LOCATION"
			},
			{
				"name": "airline",
				"salience": 0.00014465803,
				"type": "ORGANIZATION"
			},
			{
				"name": "military pilot",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "dreams",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "designs",
				"salience": 0.00014465803,
				"type": "WORK_OF_ART"
			},
			{
				"name": "data theft",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "computer hackers",
				"salience": 0.00014465803,
				"type": "PERSON"
			},
			{
				"name": "hopes",
				"salience": 0.00014465803,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00014465803,
				"type": "PERSON"
			},
			{
				"name": "Disabled Veteran",
				"salience": 0.00014118056,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028j0m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minority_group"
				},
				"name": "Minority",
				"salience": 0.00014118056,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.00014118056,
				"type": "PERSON"
			},
			{
				"name": "shareholder",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "training benefit",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "technology project",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "projects",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.00013821422,
				"type": "OTHER"
			},
			{
				"name": "Developments",
				"salience": 0.00013821422,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "DHS",
				"salience": 0.00013539864,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.00013475146,
				"type": "OTHER"
			},
			{
				"name": "file number",
				"salience": 0.00013465731,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.00013405558,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00012971931,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Trade_Center_(1973%E2%80%932001)"
				},
				"name": "World Trade Center",
				"salience": 0.00012927783,
				"type": "LOCATION"
			},
			{
				"name": "Vendors",
				"salience": 0.00012808404,
				"type": "ORGANIZATION"
			},
			{
				"name": "liability",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "algorithms",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "encryption algorithms",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "entrepreneurs",
				"salience": 0.00012478781,
				"type": "PERSON"
			},
			{
				"name": "tempo",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "floor",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "signature",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "decision making",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "exercising package",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00012478781,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y07",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secretary_of_State"
				},
				"name": "Secretary of State",
				"salience": 0.00012326482,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.00012224301,
				"type": "LOCATION"
			},
			{
				"name": "Common Access Cards",
				"salience": 0.00012224301,
				"type": "OTHER"
			},
			{
				"name": "MWBD",
				"salience": 0.00012224301,
				"type": "ORGANIZATION"
			},
			{
				"name": "chief executive",
				"salience": 0.00012021173,
				"type": "PERSON"
			},
			{
				"name": "Mentor Protégé Team Award",
				"salience": 0.000119180375,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.00011808333,
				"type": "OTHER"
			},
			{
				"name": "handling.",
				"salience": 0.00011808333,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0262dl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Private_company_limited_by_shares"
				},
				"name": "Ltd.",
				"salience": 0.000114729686,
				"type": "LOCATION"
			},
			{
				"name": "COM",
				"salience": 0.00011387143,
				"type": "ORGANIZATION"
			},
			{
				"name": "Field McConnell",
				"salience": 0.00011387143,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dfb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citigroup"
				},
				"name": "Citigroup",
				"salience": 0.00011387143,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pentagon Renovation Program",
				"salience": 0.00011387143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02c3wh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Bar_Association"
				},
				"name": "American Bar Association",
				"salience": 0.00011201428,
				"type": "ORGANIZATION"
			},
			{
				"name": "web browsers",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "privacy",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "predecessors",
				"salience": 0.00010804906,
				"type": "PERSON"
			},
			{
				"name": "coordination",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "government customers",
				"salience": 0.00010804906,
				"type": "PERSON"
			},
			{
				"name": "allegations",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "spread",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "e-commerce",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "graduation",
				"salience": 0.00010804906,
				"type": "EVENT"
			},
			{
				"name": "Web URLs",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "rehearsal",
				"salience": 0.00010804906,
				"type": "EVENT"
			},
			{
				"name": "information flow",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.00010804906,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.000106686966,
				"type": "OTHER"
			},
			{
				"name": "David Hawkins Tel",
				"salience": 0.00010280966,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07cx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Telephone"
				},
				"name": "Tel",
				"salience": 0.00010280966,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0nbzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portsmouth,_New_Hampshire"
				},
				"name": "Portsmouth",
				"salience": 0.00010280966,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02q26r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_of_Professional_Responsibility"
				},
				"name": "OPR",
				"salience": 0.00010280966,
				"type": "ORGANIZATION"
			},
			{
				"name": "guidelines",
				"salience": 0.00010270282,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Taher Elgamal",
				"salience": 0.000092472255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0828v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Wide_Web"
				},
				"name": "World Wide Web",
				"salience": 0.000092069735,
				"type": "OTHER"
			},
			{
				"name": "CSI Crime and Safety Investigation",
				"salience": 0.000089018926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g8fs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Naval_Academy"
				},
				"name": "United States Naval Academy",
				"salience": 0.000089018926,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.000089018926,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.000089018926,
				"type": "LOCATION"
			},
			{
				"name": "SIV",
				"salience": 0.000089018926,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09lhr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Departments_of_France"
				},
				"name": "Department",
				"salience": 0.000089018926,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Va.",
				"salience": 0.000089018926,
				"type": "LOCATION"
			},
			{
				"name": "Rosslyn",
				"salience": 0.000089018926,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/026vq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Services_Administration"
				},
				"name": "GSA",
				"salience": 0.000089018926,
				"type": "ORGANIZATION"
			},
			{
				"name": "MCI",
				"salience": 0.000089018926,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_hj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Aviation_Administration"
				},
				"name": "FAA",
				"salience": 0.000089018926,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.000089018926,
				"type": "LOCATION"
			},
			{
				"name": "Rivest",
				"salience": 0.0000850535,
				"type": "PERSON"
			},
			{
				"name": "North Tower",
				"salience": 0.00007679111,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00007679111,
				"type": "LOCATION"
			},
			{
				"name": "James Ellis",
				"salience": 0.000067339315,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g9jc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ernst_%26_Young"
				},
				"name": "Ernst & Young",
				"salience": 0.0000664904,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0000664904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0000664904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07srw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Utah"
				},
				"name": "Utah",
				"salience": 0.0000664904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05j3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netscape"
				},
				"name": "Netscape",
				"salience": 0.0000664904,
				"type": "ORGANIZATION"
			},
			{
				"name": "Adleman",
				"salience": 0.0000664904,
				"type": "PERSON"
			},
			{
				"name": "Shamir",
				"salience": 0.0000664904,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09p6s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arthur_Andersen"
				},
				"name": "Arthur Andersen",
				"salience": 0.0000664904,
				"type": "PERSON"
			},
			{
				"name": "Hellman",
				"salience": 0.0000664904,
				"type": "PERSON"
			},
			{
				"name": "Diffie",
				"salience": 0.0000664904,
				"type": "PERSON"
			},
			{
				"name": "Clifford Cocks",
				"salience": 0.0000664904,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.0000664904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tjvv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Durban"
				},
				"name": "Durban",
				"salience": 0.0000664904,
				"type": "LOCATION"
			},
			{
				"name": "reasons",
				"salience": 0.000055157725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.000032407646,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T23:31:03.391+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 83.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "United States Marine Field McConnell  Plum City Online - ( AbelDanger.net )  October 28, 2016 \n1. Abel Danger ( AD ) claims that Serco relayed Zulu timing signals to mentors of the Federal Bridge Certification Authority in support of live webcast of torture killings in the Mumbai attacks of November 2008 and B.C. pig farm raves (1996-2001). \n\n2. AD claims that Serco used an 8(a) protégé company – Base One Technologies – to blackmail Hillary Clinton into outsourcing the operation of the U.S. Patent and Trademark Office to users of the federal bridge and equipping selected users with patented webcast servers for Zulu betting on the times of victims’ deaths. \n\n3. AD claims that in 1994, Serco operatives at the National Visa Center began equipping Hillary Clinton and Michelle Obama – a former Sidley Austin intellectual property (IP) lawyer and a protégée of terrorist Bernardine Dohrn – with a long-range visa service for the BC pig farm and Mumbai snuff-film crews. \n\n4. United States Marine Field McConnell – Global Operations Director of Abel Danger – has offered to serve as a five-star general in a future Trump administration so he can first recognize and then destroy Serco's Zulu bridge to Clinton patents and Obama snuff-film crews. \n\nMumbai Terror Attack Watch NSG successful in mission against Mumbai attackers   \nMedia Coverage of Starnet Raid - August 20, 1999     \n\nHillary Clinton vs. James Comey: Email Scandal Supercut  \nCopy of SERCO GROUP PLC: List of Subsidiaries AND Shareholders! [Note British and Saudi Governments, AXA, HSBC , Teachers' and Gold man Sachs]    \nDefense Ammunition Center [Outsourced to Serco ]   \nSerco ... Would you like to know more?  \n\n\"Digital Fires Instructor Serco - Camp Pendleton, CA Uses information derived from all military disciplines (e.g., aviation, ground combat, command and control, combat service support, intelligence, and opposing forces) to determine changes in enemy capabilities, vulnerabilities, and probable courses of action.\" \n\n\"The 2008 Mumbai (Bombay) attacks were a series of attacks that took place in November 2008, when 10 members of Lashkar-e-Taiba , an Islamic militant organisation based in Pakistan , carried out a series of 12 coordinated shooting and bombing attacks lasting four days across Mumbai . The attacks, which drew widespread global condemnation, began on Wednesday, 26 November and lasted until Saturday, 29 November 2008, killing 164 people and wounding at least 308.[2][ 14 ] \n\nEight of the attacks occurred in South Mumbai: at Chhatrapati Shivaji Terminus , the Oberoi Trident,[15] the Taj Mahal Palace & Tower ,[15] Leopold Cafe, Cama Hospital,[15] the Nariman House Jewish community centre,[16] the Metro Cinema,[17] and in a lane behind the Times of India building and St. Xavier's College .[15] There was also an explosion at Mazagaon, in Mumbai's port area, and in a taxi at Vile Parle .[18] By the early morning of 28 November, all sites except for the Taj Hotel had been secured by Mumbai Police and security forces. On 29 November, India's National Security Guards (NSG) conducted 'Operation Black Tornado' to flush out the remaining attackers; it culminated in the death of the last remaining attackers at the Taj Hotel and ending the attacks.[19] Ajmal Kasab[20] disclosed that the attackers were members of Lashkar-e-Taiba,[21] among others.[22] The Government of India said that the attackers came from Pakistan, and their controllers were in Pakistan.[23] On 7 January 2009, Pakistan confirmed the sole surviving perpetrator of the attacks was a Pakistani citizen.[24] On 9 April 2015, the foremost ringleader of the attacks, Zakiur Rehman Lakhvi ,[3][4] was granted bail against surety bonds of ₨200,000 (US$2,000) in Pakistan.[25][26]\" \n\n\"THE CASE OF THE VANISHING VISA FILES  \nDecember 25, 2009 10:00:00 PM PST  \nBy Chuck Goudie   \nDecember 16, 2009 (CHICAGO) -- Potentially important evidence has disappeared in a terrorism case involving two Chicago men. Their visa records vanished from Chicago's Indian consulate. It comes one week after the ABC 7 I-Team raised questions about how David Coleman Headley and Tahawwur Rana obtained their foreign visas in the first place. \n\nThe case of the vanishing visa records has churned up diplomats from Mumbai to Michigan Avenue. India's foreign secretary Nirupama Rao told reporters overseas Wednesday that she wants answers from Chicago's Indian consulate about the records and visa documents that have disappeared, records that might show how two accused Chicago terrorists obtained permission to scout targets in India. \n\nTop officials of Chicago's India consulate wouldn't talk to the I-Team on camera last week when asked how terror suspects David Coleman Headley and Tahawwur Rana obtained five-year, unlimited passage visas to India. \n\nAnd the consul general did not return calls Wednesday regarding the paperwork they used to process Headley and Rana's visas, which Indian Foreign Secretary Nirupama Rao announced Wednesday have disappeared. \n\nWednesday evening, the Chicago consul general emailed a statement to the I-Team that conflicted with government statements made in India. The brief statement read: \"We have not reported loss of any papers regarding issuance of visa to David Coleman Headley and Tahawwur Rana Hussain. Relevant information concerning the issuance of visa to these persons is available with the Government of India\". \n\nIndia's counterpart to the FBI is looking into the visa application process as part of its probe into the 2008 Mumbai massacre. \n\nThe two Chicago suspects are accused of having roles in the assault. Rana was denied bond by a Chicago district judge Tuesday, despite family members and friends offering $1 million in cash and property. Rana has not been directly charged with the Mumbai attack that left 175 dead, but was linked to the assault in government court filings. \n\nHeadley, a Pakistan-born Chicagoan, is a convicted heroin dealer whose birth name was Daood Giliani. He changed his name to ease travel to India, according to federal prosecutors in Chicago and to avoid the required pre-visa background check by Indian authorities. \n\nSince the time Headley and Rani were processed, India's Chicago consulate office began contracting out visa requests to a private company called Travisa Outsourcing that on its website claims, \"We have revolutionized the way people get their visas.\" \n\nAnd the new visa processing was subject of a news conference last year. \n\n\"The advantages of outsourcing is the Travisa company, which is handling the outsourcing, has set up a call center,\" said Ashok Kumar Attri, consul general. \n\nForeign Secretary Rao said she is impressed with the cooperation the US has given to Indian investigators. Headley and Rana are not due back in court until January.\" \n\n\"Was Bernardine Dohrn the Mentor of Michelle Obama at Sidley Austin?  \nApril 22, 2008  \nBernardine Dohrn was at Sidley Austin a law firm in Chicago from From 1984 to 1988, Dohrn was employed by the law firm Sidley Austin, although her criminal record has prevented her from being admitted to either the New York or Illinois bar. http://en.wikipedia.org/wiki/Bernardine_Dohrn \n\nMichelle Obama graduated from Harvard Law School in 1988. But she likely also was a summer associate in 1987 and likely 1986. Barack Obama was assigned to her in 1989 when he was a summer associate from Harvard Law School. http://en.wikipedia.org/wiki/Barack_Obama \n\nHe entered Harvard Law School in 1988.[9] More links and excerpts: \n\nhttps://oldatlanticlighthouse.wordpress.com/2008/04/18/northwestern-law-prof-bernardine-dohrn-weather-underground/   \n\nSteve Sailer on Michelle Obama \nhttp://www.vdare.com/sailer/080225_michelle_obama.htm   \n\nMichelle's Princeton thesis: \nhttp://blog.vdare.com/archives/2008/02/22/michelle-obama-thesis-found-download-it-here/   \n\nJames Fulford quotes Politico \n\nMichelle Obama's senior year thesis at Princeton University, obtained exclusively from the campaign by Politico , shows a document written by a young woman grappling with a society in which a black Princeton alumnus might only be allowed to remain \"on the periphery.\" Read the full thesis here: Part 1 , Part 2 , Part 3 , Part 4 . Michelle Obama thesis was on racial divide – Jeffrey Ressner – Politico.com \n\nSidley Austin likely recognized this in Michelle even if she didn't show them her Princeton thesis. Who better at Sidley Austin to be mentor to the author of this Princeton thesis than Bernardine Dohrn who had been number 2 on the FBI most wanted list? \n\nBarack Obama was assigned to Michelle Obama in summer 1989. This may have reflected how few blacks there were at Sidley Austin, especially from Harvard Law School or the equivalent. Dohrn got her J.D. from University of Chicago Law School. Since she is a prof at Northwestern despite her background, we might infer she was very smart and understanding. So she was the perfect person to be the mentor for Michelle Obama at Sidley Austin. \n\nThe above is speculation, hypotheses or opinion. All statements should be restated as questions. All other disclaimers apply.\" \n\n\"Webcasting is the distribution of media files through the internet. The earliest webcast equivalent of an online concert and one of the earliest examples of webcasting itself was by Apple Computer 's Webcasting Group in partnership with the entrepreneurs Michael Dorf and Andrew Rasiej . Together with David B. Pakman from Apple, they launched the Macintosh New York Music Festival from July 17–22, 1995. This event audio webcast concerts from more than 15 clubs in New York City. Apple later webcast a concert by Metallica on June 10, 1996 live from Slim's in San Francisco.[ 3 ] \n\nIn 1995, Benford E. Standley produced one of the first audio/video webcasts in history.[4] On October 31, 1996, UK rock band Caduseus broadcast their one-hour concert from 11pm to 12am (UT) at Celtica in Machynlleth, Wales, UK – the first live streamed audio and simultaneous live streamed video multicast – around the globe to more than twenty direct \"mirrors\" in more than twenty countries.[5][ 6 ]\" \n\n\"Serco Processes 2 Millionth Patent Application for U.S. Patent and Trademark Office Date: 18 Mar 2013 Serco Inc., a leading provider of professional, technology, and management services to the federal government, announced today that their Pre-Grant Publication (PGPubs) Classification Services team recently processed their 2 millionth patent application for the U.S. Patent & Trademark Office (USPTO). Each application was also processed within the contractually required 28-day window.\" \n\n\"BREAKING: @HillaryClinton's E-Mail Server Company Got Almost $1 Million In Gov't Loans After Wiping E-Mails   \nOCTOBER 26, 2016  \nBY CHARLES C. JOHNSON 6 COMMENTS  \nGive it up already. It's over. K. J. Gillenwater was the primary researcher behind this story. \n\nHillary Clinton's e-mail server company got almost $1 million in government loans starting immediately after they were secretly asked to wipe Hillary Clinton's name from her e-mails. \n\nPlatte River Networks (PRN) got a $493,000 loan from the Small Business Administration in August 2014 and another $350,000 loan in September 2015: \n\nPublic government data available as USAspending.gov \n\nThe first half-million dollar loan arrived not one month after PRN employee Paul Combetta was caught accidentally revealing his company was deleting evidence at Hillary's request in July 2014 . \n\nThe second $350,000 loan came about one year later. \n\nYou won't hear this stuff from the lying mainstream media. Keep the GotNews mission alive: donate at GotNews.com/donate or send tips to editor@gotnews.com. If you'd like to join our research team, contacteditor@gotnews.com. \n\nAfter getting the first loan, PRN moved to a large office space after previously working out of the owner’s condo. The head of the Small Business Administration is Maria Contreras-Sweet , a Mexican immigrant who was appointed to the office by Barack Obama two months before Hillary's PRN got the first loan. \n\nWikiLeaks leaks have proven Hillary's corrupt pay-to-play scheme. GotNews has shined a light on how Hillary gets favors from Hispanic and Democratic government bureaucrats before . \n\nDid Hillary Clinton pay her e-mail server company Platte River Networks (PRN) with almost $1 million in favorable government loans — given out by a political friendly — in order to alter her illegal e-mails and get her name off them? \n\nIt sure looks like it. \n\nA Freedom of Information Act (FOIA) request has been lodged for more information. \n\nStay tuned for more. \n\nK. J. Gillenwater was the primary researcher behind this story.\"  \n\n\"Police conclude search of Starnet   \nCBC News Posted: Aug 24, 1999 11:26 AM ET Last Updated: Aug 24, 1999 11:26 AM ET  \nPolice have wrapped up several days of searching the offices of Starnet Communications in Vancouver. They entered the company offices and homes of some directors on Friday. \n\nPolice were looking for evidence of illegal gambling, distributing child pornography, and money laundering. Since the raid, Starnet officials say police just don't understand their business. \n\nThe search warrant details 18 months of police investigation. It traces a network of companies registered in American and Caribbean jurisdictions. \n\nThe warrant also identifies Vancouver as the centre of Starnet's operations, even though this is a grey under Canadian law. \n\nPolice note that Starnet's revenues grew dramatically in the past two years, from betting and sex shows and from lucrative licensing agreements for its gaming software. The investigations and pornography from company sites were grounds for Friday's raid and seizure of company materials. \n\nRCMP Constable Peter Thiessen says investigators left Starnet offices yesterday morning. He says, \"They spent the better part of three days going through the business. And as a result of that search the investigation is continuing, but no charges have been laid.\" Starnet's many investors were spooked by the raid. Share prices dropped almost 70-percent on Friday. However, the company insists the raid had minimal effect on its operation. Stocks rose slightly yesterday after a day of very heavy trading. \n\nIn written statements, company CEO Mark Dohlen said the Wall Street Journal calls Starnet the leader in Internet gaming and entertainment. He says companies like his, those on the cutting edge, are often misunderstood. Yesterday, Starnet announced it will sell off the sex side of its business. It plans to focus more resources on gaming. \n\nThe Police investigation is expected to last for several more months.\" \n\n\"Super Serco bulldozes ahead  \nBy DAILY MAIL REPORTER UPDATED: 23:00 GMT, 1 September 2004 \nSERCO has come a long way since the 1960s when it ran the 'four-minute warning' system to alert the nation to a ballistic missile attack. \n\nToday its £10.3bn order book is bigger than many countries' defence budgets. It is bidding for a further £8bn worth of contracts and sees £16bn of 'opportunities'. \n\nProfit growth is less ballistic. The first-half pre-tax surplus rose 4% to £28.1m, net profits just 1% to £18m. Stripping out goodwill, the rise was 17%, with dividends up 12.5% to 0.81p. \n\nSerco runs the Docklands Light Railway, five UK prisons, airport radar and forest bulldozers in Florida.\"  \n\n\" Serco farewell to NPL after 19 years of innovation 8 January 2015 Serco said goodbye to the National Physical Laboratory (NPL) at the end of December 2014 after 19 years of extraordinary innovation and science that has seen the establishment build a world-leading reputation and deliver billions of pounds of benefit for the UK economy. During that period under Serco 's management and leadership, NPL has delivered an extraordinary variety and breadth of accomplishments for the UK's economy and industry. Some of the key achievements during that time have been:… It has been estimated that work carried out by the Centre of Carbon Measurement at NPL will save eight million tonnes of carbon emissions reductions (2% of UK footprint) and over half a billion pounds in economic benefit over the next decade…. NPL's caesium fountain atomic clock is accurate to 1 second in 158 million years and NPL is playing a key role in introducing rigour to high frequency trading [for Serco 's front running banks] in the City through NPL [Zulu] Time.\" \n\n\"UK Cabinet Office – Emergency Planning College – Serco …..Types of Exercise Workshop Exercises These are structured discussion events where participants can explore issues in a less pressurised environment. They are an ideal way of developing solutions, procedures and plans rather than the focus being on decision making. Table Top Exercises These involve a realistic scenario and will follow a time line, either in real-time or with time jumps to concentrate on the more important areas. The participants would be expected to be familiar with the plans and procedures that are being used although the exercise tempo and complexity can be adjusted to suit the current state of training and readiness. Simulation and media play can be used to support the exercise. Table-top exercises help develop teamwork and allow participants to gain a better understanding of their roles and that of other agencies and organisations. Command/Control Post Exercises These are designed primarily to exercise the senior leadership and support staff in collective planning and decision making within a strategic grouping. Ideally such exercises would be run from the real command and control locations and using their communications and information systems [Feeling lucky, Punk?] . This could include a mix of locations and varying levels of technical simulation support. The Gold Standard system is flexible to allow the tempo and intensity to be adjusted to ensure maximum training benefit, or to fully test and evaluate the most important aspects of a plan. Such exercises also test information flow, communications, equipment, procedures, decision making and coordination. Live Exercises These can range from testing individual components of a system or organisation through to a full-scale rehearsal. They are particularly useful where there are regulatory requirements or with high-risk situations. They are more complex and costly to organise and deliver but can be integrated with Command Post Exercises as part of a wider exercising package.\"  \n\n\"Christopher Rajendran Hyman CBE (born 5 July 1963 in Durban, South Africa)[1] was Chief Executive of Serco Group plc from 2002 to October 2013.[2] … On graduation, he worked for Arthur Andersen. In 1989, he won an 18-month exchange with Ernst & Young in London, who employed him after four months.[1] Head hunted in 1994 by Serco , Hyman became European finance director, and in 1999 was made group finance director. In 2002, Hyman became chief executive. .. Hyman resigned from his role of Chief Executive of Serco on 25 October 2013 following allegations that Serco had overcharged government customers. .. He was [making a presentation to Serco shareholder, including British and Saudi governments] on the 47th floor of the World Trade Center [North Tower] at the time of the September 11 attacks in 2001.\" \n\n\"July 7, 2016 Developments in PKI occurred in the early 1970s at the British intelligence agency GCHQ , where James Ellis , Clifford Cocks and others made important discoveries related to encryption algorithms and key distribution.[ 19 ] However, as developments at GCHQ are highly classified, the results of this work were kept secret and not publicly acknowledged until the mid-1990s. \n\nThe public disclosure of both secure key exchange and asymmetric key algorithms in 1976 by Diffie, Hellman , Rivest, Shamir , and Adleman changed secure communications entirely. With the further development of high-speed digital electronic communications (the Internet and its predecessors), a need became evident for ways in which users could securely communicate with each other, and as a further consequence of that, for ways in which users could be sure with whom they were actually interacting. \n\nAssorted cryptographic protocols were invented and analyzed within which the new cryptographic primitives could be effectively used. With the invention of the World Wide Web and its rapid spread, the need for authentication and secure communication became still more acute. Commercial reasons alone (e.g., e-commerce, online access to proprietary databases from web browsers) were sufficient. Taher Elgamal and others at Netscape developed the SSL protocol ('https' in Web URLs); it included key establishment, server authentication (prior to v3, one-way only), and so on. A PKI structure was thus created for Web users/sites wishing secure communications. \n\nVendors and entrepreneurs saw the possibility of a large market, started companies (or new projects at existing companies), and began to agitate for legal recognition and protection from liability. An American Bar Association technology project published an extensive analysis of some of the foreseeable legal aspects of PKI operations (see ABA digital signature guidelines), and shortly thereafter, several U.S. states (Utah being the first in 1995) and other jurisdictions throughout the world began to enact laws and adopt regulations. Consumer groups raised questions about privacy, access, and liability considerations, which were more taken into consideration in some jurisdictions than in others. \n\nThe enacted laws and regulations differed, there were technical and operational problems in converting PKI schemes into successful commercial operation, and progress has been much slower than pioneers had imagined it would be. \n\nBy the first few years of the 21st century, the underlying cryptographic engineering was clearly not easy to deploy correctly. Operating procedures (manual or automatic) were not easy to correctly design (nor even if so designed, to execute perfectly, which the engineering required). The standards that existed were insufficient. \n\nPKI vendors have found a market, but it is not quite the market envisioned in the mid-1990s, and it has grown both more slowly and in somewhat different ways than were anticipated.[20] PKIs have not solved some of the problems they were expected to, and several major vendors have gone out of business or been acquired by others. PKI has had the most success in government implementations; the largest PKI implementation to date is the Defense Information Systems Agency (DISA) PKI infrastructure for the Common Access Cards program.\"  \n\nBase One Technologies – Corporate Strategy – We are a Government Certified Women-Owned Business   \nWe practice Diversity Recruitment and Staffing for IT positions Base One was founded in 1994 by a women engineer who had made a career in technology research for many years. Base One has been very successful in focusing on diversity recruiting and staffing for IT projects. It has been our experience that the greater the diversity mix, the more creative the solution. As in any field the more diverse the viewpoint the more thorough your analysis. Our engineers can think out of the box. \n\nBecause of our affiliations we have access to pools of resources among more diverse groups & individuals. We work with a large pool of minority professionals who specialize in IT skills. We are able to have access to these resources through our status as a D/MWBD firm and our affiliations. These affiliations assist us in working with resources among more diverse groups & individuals. We are also partnered with firms that are 8A certified as Minority firms, Disabled Veteran firms, Native American firms, Vietnam veteran firms, women owned firms. \n\nOur hub zone location keeps us close to the professional organizations of great diversity. We are active in recruiting from and networking with these community organizations of local IT professionals. This has given us access to a large pool of diversity talent. \n\nBase One's staff of engineers are a diverse group of professionals. This diverse network of engineers helps us to branch out to other engineers and creates an even larger network of resources for us to work with. \n\nThe greater the diversity the more complete & thorough the analysis. The broader the spectrum of points of view the broader the scope of the analysis. We feel that a diverse team gives us a greater advantage in creating cutting edge solutions. To that end we will continue to nurture these relationships to further extend our talent pool. \n\nThe greater the diversity mix, the more creative the solution. \n\nThe more diverse the viewpoint, the more thorough the analysis. \n\nThe more diverse our team, the more our engineers can think out of the box. \n\nThis is why Base One Technologies concentrates on diversity recruitment in the belief that a diverse team gives us a greater advantage in creating cutting edge solutions.\" \n\nInformation Security Planning is the process whereby an organization seeks to protect its operations and assets from data theft or computer hackers that seek to obtain unauthorized information or sabotage business operations. \n\nKey Clients Benefiting From Our Information Security Expertise: Pentagon Renovation Program, FAA, Citigroup, MCI. \n\nBase One Technologies \n\nExpertly researches, designs, and develops information security policies that protect your data and manage your firm's information technology risk at levels acceptable to your business. \n\nPerforms architectural assessments and conducts both internal and external penetration testing. The results of these efforts culminate in an extensive risk analysis and vulnerabilities report. \n\nDevelops, implements and supports Information Security Counter measures such as honey-pots and evidence logging and incident documentation processes and solutions.\" \n\n\"Base One Technologies, Ltd. is a DOMESTIC BUSINESS CORPORATION, located in New York, NY and was formed on Feb 15, 1994. This file was obtained from the Secretary of State and has a file number of 1795583. \" \n\n\"Serco's Office of Partner Relations (OPR) helps facilitate our aggressive small business utilization and growth strategies. Through the OPR, Serco mentors four local small businesses under formal Mentor Protégé Agreements: Three sponsored by DHS (Base One Technologies, TSymmetry, Inc., and HeiTech Services, Inc.,) and the fourth sponsored by GSA (DKW Communications, Inc.). Serco and HeiTech Services were awarded the 2007 DHS Mentor Protégé Team Award for exceeding our mentoring goals.\" http://www.dtic.mil/whs/directives/corres/pdf/100515p.pdf \n\n\"Opened in 1994 as the successor to the Transitional Immigrant Visa Processing Center in Rosslyn, Va., the NVC centralizes all immigrant visa pre-processing and appointment scheduling for overseas posts. The NVC collects paperwork and fees before forwarding a case, ready for adjudication, to the responsible post. \n\nThe center also handles immigrant and fiancé visa petitions, and while it does not adjudicate visa applications, it provides technical assistance and support to visa-adjudicating consular officials overseas. \n\nOnly two Foreign Service officers, the director and deputy director, work at the center, along with just five Civil Service employees. They work with almost 500 contract employees doing preprocessing of visas, making the center one of the largest employers in the Portsmouth area. \n\nThe contractor, Serco , Inc., has worked with the NVC since its inception and with the Department for almost 18 years. \n\nThe NVC houses more than 2.6 million immigrant visa files, receives almost two million pieces of mail per year and received more than half a million petitions from the U.S. Citizenship and Immigration Service (USCIS) in 2011. Its file rooms' high-density shelves are stacked floor-to-ceiling with files, each a collection of someone’s hopes and dreams and each requiring proper handling. …. \n\nThe NVC also preprocesses the chief of mission (COM) application required for the filing of a petition for a Special Immigrant Visa (SIV). Such visas, for foreign nationals who have performed services for the U.S. government in Iraq and Afghanistan, require COM concurrence before the applicant can file a petition with USCIS. The NVC collects the requisite documents from such applicants and, when complete, forwards the package to the U.S. embassies in Baghdad or Kabul for COM approval\" \n\nYours sincerely, \n\nField McConnell, United States Naval Academy, 1971; Forensic Economist; 30 year airline and 22 year military pilot; 23,000 hours of safety; Tel: 715 307 8222 \n\nDavid Hawkins Tel: 604 542-0891 Forensic Economist; former leader of oil-well blow-out teams; now sponsors Grand Juries in CSI Crime and Safety Investigation \n",
		"thread_title": "#2818: Serco's Zulu Bridge To Mumbai Pig Farm – Clinton 8(a) Patent – Obama Visa 9/11 Snuff",
		"title": "#2818: Serco's Zulu Bridge To Mumbai Pig Farm – Clinton 8(a) Patent – Obama Visa 9/11 Snuff",
		"type": "bs",
		"uuid": "da9eac98db2b8bd73f0bc060b74c41e167b1dc30"
	},
	"-KhI_eX3WModFM7Nos6p": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T03:14:27.928+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "attack",
				"salience": 0.15037864,
				"type": "EVENT"
			},
			{
				"name": "Lets",
				"salience": 0.10225235,
				"type": "PERSON"
			},
			{
				"name": "guys",
				"salience": 0.08212485,
				"type": "PERSON"
			},
			{
				"name": "Rothschild",
				"salience": 0.078011945,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.06784833,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.047221217,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.038871136,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.023721848,
				"type": "PERSON"
			},
			{
				"name": "central bank",
				"salience": 0.020711806,
				"type": "ORGANIZATION"
			},
			{
				"name": "spooks",
				"salience": 0.018722627,
				"type": "OTHER"
			},
			{
				"name": "armies",
				"salience": 0.017547315,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.017547315,
				"type": "LOCATION"
			},
			{
				"name": "exuse",
				"salience": 0.016608618,
				"type": "OTHER"
			},
			{
				"name": "polulation",
				"salience": 0.0152028585,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.0152028585,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.013063259,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.012056267,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0118592,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0118592,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0118592,
				"type": "PERSON"
			},
			{
				"name": "armies",
				"salience": 0.0118592,
				"type": "ORGANIZATION"
			},
			{
				"name": "nations",
				"salience": 0.01067007,
				"type": "LOCATION"
			},
			{
				"name": "flags",
				"salience": 0.01067007,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.01067007,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.01067007,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.010272664,
				"type": "OTHER"
			},
			{
				"name": "crooks",
				"salience": 0.010272664,
				"type": "PERSON"
			},
			{
				"name": "paper",
				"salience": 0.010272664,
				"type": "WORK_OF_ART"
			},
			{
				"name": "green c02 fraud",
				"salience": 0.010206274,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.010015963,
				"type": "PERSON"
			},
			{
				"name": "immunity",
				"salience": 0.009521595,
				"type": "OTHER"
			},
			{
				"name": "&quot",
				"salience": 0.009369656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.009369656,
				"type": "PERSON"
			},
			{
				"name": "everycountry",
				"salience": 0.008714308,
				"type": "LOCATION"
			},
			{
				"name": "war game",
				"salience": 0.008714308,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.007775912,
				"type": "PERSON"
			},
			{
				"name": "west",
				"salience": 0.007519624,
				"type": "OTHER"
			},
			{
				"name": "human rights clatter",
				"salience": 0.006851069,
				"type": "OTHER"
			},
			{
				"name": "front line",
				"salience": 0.0065126475,
				"type": "LOCATION"
			},
			{
				"name": "profits",
				"salience": 0.0065126475,
				"type": "OTHER"
			},
			{
				"name": "chemtrails",
				"salience": 0.0061909156,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.005548615,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0054787653,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.0047447463,
				"type": "OTHER"
			},
			{
				"name": "vaccines",
				"salience": 0.0047447463,
				"type": "OTHER"
			},
			{
				"name": "dreaming",
				"salience": 0.0035450573,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0035450573,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0035450573,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0035450573,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-28T20:39:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 5.5,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "I dont know guys , i must say that attack looks mighty fake , i didnt see anyone firing back , it looked very staged . I think the idea of fake terror is to give reason for the Gov around the world to have an exuse to change laws and terrorise the polulation so they need&quot;&quot; the armies to protect them . They mentioned that in the white paper of a world without war , because without armies the people might overthrow the crooks in power . No one appeared to be really stressed in that video . Lets face it not one country has ever exposed all the false flags of other nations . Rothschild has a central bank in everycountry except 2 or three =he controls all of them . They do all war game together and have immunity for all their spooks  which only leaves the public as an enemy . There are no good guys in the elites and if you think they would let anyonecontrol them in any way your dreaming . You wont see them on the front line they are far too busy counting the profits and partying on . The human rights clatter is only directed against the west , so are the chemtrails , and green c02 fraud , its not hard to work out . And only the west has made it law to force the deadly vaccines on people .",
		"thread_title": "#2818: Serco's Zulu Bridge To Mumbai Pig Farm – Clinton 8(a) Patent – Obama Visa 9/11 Snuff",
		"title": "",
		"type": "bs",
		"uuid": "160453f5b7386ad17e4c7c7882f15b1346dfb497"
	},
	"-KhI_emisJq-x901ZxJE": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T03:14:27.938+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0kscy0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rodrigo_Duterte"
				},
				"name": "Rodrigo Duterte",
				"salience": 0.39529037,
				"type": "PERSON"
			},
			{
				"name": "POPE",
				"salience": 0.08026818,
				"type": "PERSON"
			},
			{
				"name": "EVERYTHING",
				"salience": 0.06980422,
				"type": "OTHER"
			},
			{
				"name": "THING",
				"salience": 0.06980422,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.044119045,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippine",
				"salience": 0.043425664,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "CATHOLICS",
				"salience": 0.043425664,
				"type": "ORGANIZATION"
			},
			{
				"name": "swearing",
				"salience": 0.029204853,
				"type": "EVENT"
			},
			{
				"name": "Thats",
				"salience": 0.02779582,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.027488166,
				"type": "PERSON"
			},
			{
				"name": "slang term",
				"salience": 0.021738403,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3k14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy"
				},
				"name": "JFK",
				"salience": 0.014296293,
				"type": "PERSON"
			},
			{
				"name": "speeches",
				"salience": 0.013812514,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pope",
				"salience": 0.011702409,
				"type": "PERSON"
			},
			{
				"name": "sky",
				"salience": 0.010530712,
				"type": "LOCATION"
			},
			{
				"name": "expanse",
				"salience": 0.010530712,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.010139048,
				"type": "PERSON"
			},
			{
				"name": "whore&quot",
				"salience": 0.010139048,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.010073612,
				"type": "EVENT"
			},
			{
				"name": "epithets",
				"salience": 0.008602794,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.008602794,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.007424611,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.007424611,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.0064908387,
				"type": "LOCATION"
			},
			{
				"name": "example",
				"salience": 0.004992876,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.004686573,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.003718388,
				"type": "LOCATION"
			},
			{
				"name": "plane",
				"salience": 0.002276237,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.002191305,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-28T20:00:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Its true you know the CATHOLICS ARE BEHIND EVERYTHING , HE CURSED THE POPE NEXT THING YOU KNOW ..Philippine President Rodrigo Duterte has made a solemn promise: no more swearing.  Duterte, who famously cursed the pope and used a slang term that translates as “son of a whore&quot; while denouncing President Obama, said he was flying back from Japan late Thursday, looking at a vast expanse of sky, listening to his colleagues snore, when he heard a voice say, “If you don’t stop epithets, I will bring this plane down now.”  https://www.washingtonpost.com/news/worldviews/wp/2016/10/28/philippines-duterte-god-told-me-to-quit-the-cussing/   Thats who JFK was talking about in his speeches  , andthink about it they have been roaming into countries for ever unscathed undermining every country they enter . Mexico is a typical example . And just look at the crimes they have committed in their history .",
		"thread_title": "#2818: Serco's Zulu Bridge To Mumbai Pig Farm – Clinton 8(a) Patent – Obama Visa 9/11 Snuff",
		"title": "",
		"type": "bs",
		"uuid": "ca38d319bedd06eff9bf77b062ca8ee2e5e522b0"
	},
	"-KhI_ewkbFNQJLWdYH3K": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T11:56:37.068+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Mindblowing Reason Elites Fear Donald Trump",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T11:56:37.068+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0.9
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "\n\nMindblowing Reason Elites Fear Donald Trump   ",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "Trump Advocates the American People's Control Over U.S. Government",
		"type": "bs",
		"uuid": "56c77ca93df34d1ac4cd240afad84a8dd41029a6"
	},
	"-KhI_f0J-DAPOTNQDXrs": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:49:48.196+03:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-29T09:34:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.8
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Brilliant!",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "",
		"type": "bs",
		"uuid": "864b26ceeacbcc5ed38177f11285b464f7927a64"
	},
	"-KhI_fEm3fdf41eVnbOJ": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T15:58:39.811+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.36559084,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.19641753,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.07120005,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.070179984,
				"type": "LOCATION"
			},
			{
				"name": "Investigation",
				"salience": 0.025493188,
				"type": "EVENT"
			},
			{
				"name": "Situation",
				"salience": 0.022250159,
				"type": "OTHER"
			},
			{
				"name": "Favors",
				"salience": 0.022114601,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.018998982,
				"type": "OTHER"
			},
			{
				"name": "The Name of Jeffrey Epstein",
				"salience": 0.01790233,
				"type": "PERSON"
			},
			{
				"name": "Hillary Caught Selling",
				"salience": 0.013671779,
				"type": "PERSON"
			},
			{
				"name": "pay",
				"salience": 0.013102666,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.00811845,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/058l5z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kim_Dotcom"
				},
				"name": "Kim Dotcom",
				"salience": 0.007004655,
				"type": "PERSON"
			},
			{
				"name": "Victurus Libertas",
				"salience": 0.007004655,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0066446736,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0063399007,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.0061435755,
				"type": "WORK_OF_ART"
			},
			{
				"name": "deal",
				"salience": 0.0054864553,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.0054137185,
				"type": "OTHER"
			},
			{
				"name": "Kingpin",
				"salience": 0.004762109,
				"type": "ORGANIZATION"
			},
			{
				"name": "computer",
				"salience": 0.0046893624,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "election",
				"salience": 0.0046893624,
				"type": "EVENT"
			},
			{
				"name": "EMAILS",
				"salience": 0.0037984154,
				"type": "WORK_OF_ART"
			},
			{
				"name": "INVESTIGATION",
				"salience": 0.0037984154,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "CLINTON",
				"salience": 0.0037085474,
				"type": "LOCATION"
			},
			{
				"name": "Paid in Money & Children - Hammer HRC",
				"salience": 0.0035849926,
				"type": "ORGANIZATION"
			},
			{
				"name": "FACE",
				"salience": 0.0032897994,
				"type": "OTHER"
			},
			{
				"name": "PROBE",
				"salience": 0.0032897994,
				"type": "OTHER"
			},
			{
				"name": "LED",
				"salience": 0.0032897994,
				"type": "OTHER"
			},
			{
				"name": "Scumbag",
				"salience": 0.0032897994,
				"type": "PERSON"
			},
			{
				"name": "REPORT",
				"salience": 0.0032897994,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Rothschild Globalist Cartel",
				"salience": 0.0032785255,
				"type": "ORGANIZATION"
			},
			{
				"name": "aid",
				"salience": 0.0031671522,
				"type": "OTHER"
			},
			{
				"name": "Jeb - Clinton",
				"salience": 0.0030283586,
				"type": "PERSON"
			},
			{
				"name": "Politicians",
				"salience": 0.002686301,
				"type": "PERSON"
			},
			{
				"name": "Insider",
				"salience": 0.002317762,
				"type": "OTHER"
			},
			{
				"name": "Insider",
				"salience": 0.002317762,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.0020071918,
				"type": "OTHER"
			},
			{
				"name": "EXPLOSIVE",
				"salience": 0.0020071918,
				"type": "OTHER"
			},
			{
				"name": "SCHLONGED",
				"salience": 0.0019502448,
				"type": "OTHER"
			},
			{
				"name": "Human Trafficking in Unpaid Interns",
				"salience": 0.0019099591,
				"type": "OTHER"
			},
			{
				"name": "Donald Trump Unloads",
				"salience": 0.0017846759,
				"type": "PERSON"
			},
			{
				"name": "Government",
				"salience": 0.0017459923,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bill",
				"salience": 0.0016883851,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Pedophilia Coverup",
				"salience": 0.0016539836,
				"type": "OTHER"
			},
			{
				"name": "Healthless",
				"salience": 0.0016539836,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d2y1g"
				},
				"name": "Robert",
				"salience": 0.0016539836,
				"type": "PERSON"
			},
			{
				"name": "Huma Abedin Has Run",
				"salience": 0.0016539836,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "Bush",
				"salience": 0.0016539836,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03prx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mossad"
				},
				"name": "Mossad",
				"salience": 0.0016539836,
				"type": "ORGANIZATION"
			},
			{
				"name": "Blackmail Influence",
				"salience": 0.0016539836,
				"type": "OTHER"
			},
			{
				"name": "Underage Sex Slave Scandal",
				"salience": 0.0016539836,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.0015922684,
				"type": "PERSON"
			},
			{
				"name": "Everywhere",
				"salience": 0.0014620817,
				"type": "LOCATION"
			},
			{
				"name": "CF",
				"salience": 0.0014620817,
				"type": "OTHER"
			},
			{
				"name": "E-mails",
				"salience": 0.0014620817,
				"type": "OTHER"
			},
			{
				"name": "Currency",
				"salience": 0.0014620817,
				"type": "OTHER"
			},
			{
				"name": "Child Sex Trafficking Network",
				"salience": 0.0014620817,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0014620817,
				"type": "PERSON"
			},
			{
				"name": "Ask Me Anything About the Clinton Case",
				"salience": 0.0012356733,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02szg2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/4chan"
				},
				"name": "4chan",
				"salience": 0.0012356733,
				"type": "OTHER"
			},
			{
				"name": "Q & A",
				"salience": 0.0012356733,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0012356733,
				"type": "LOCATION"
			},
			{
				"name": "Lawyers",
				"salience": 0.0010922767,
				"type": "PERSON"
			},
			{
				"name": "Ghislaine Maxwell - Jane Doe 102 - Epstein",
				"salience": 0.00093081745,
				"type": "PERSON"
			},
			{
				"name": "Rothschild Thread - Clinton Foundation",
				"salience": 0.0008517542,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ymwd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roy_Black_(attorney)"
				},
				"name": "Roy Black",
				"salience": 0.0007764135,
				"type": "PERSON"
			},
			{
				"name": "Little St. James",
				"salience": 0.0006723018,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Egg-Shaped Penis",
				"salience": 0.0006723018,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0grkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ken_Starr"
				},
				"name": "Kenneth Starr",
				"salience": 0.0006723018,
				"type": "PERSON"
			},
			{
				"name": "Sweetheart Deal: Celebrity",
				"salience": 0.0006723018,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/097qj4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alan_Dershowitz"
				},
				"name": "Alan Dershowitz",
				"salience": 0.0006723018,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T15:58:39.811+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 5.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "\nEXCLUSIVE #Breaking FBI Reopens Investigation! \"Hillary Caught Selling Political Favors to Israel\"?   \nVicturus Libertas Published on Oct 28, 2016 \n\nThe FBI was investigating Anthony Weiner and Kim Dotcom when they found the Israeli pay to play emails on Weiner's computer. It's very serious. The FBI will be charging Hillary Clinton with planning to engage in pay to play after she had won the election. It's technically treason. Weiner was bragging that he had set up the Israeli deal. HRC was to get $100 million for the Clinton Foundation, for increasing Israeli aid by double! That's $38 billion more than today! Huma Abedin helped set the deal up. \n\n\nHILLARY GOT SCHLONGED! LOOK WHAT ANTHONY WEINER JUST SHOVED RIGHT BACK IN HER FACE…   \nREPORT: INVESTIGATION INTO ANTHONY WEINER LED FBI TO NEW PROBE OF CLINTON'S EMAILS   \nDonald Trump Unloads on Hillary, Huma Abedin & Anthony Weiner   \n\"You're a Real Scumbag, Anthony\"  \n\n\nRelated: \n\nRothschild Globalist Cartel Owns Healthless Hillary Clinton   \n\nClinton Foundation's Huma Abedin Has Run \"Human Trafficking in Unpaid Interns\"   \n\nBillionaire Degenerate Jeffrey Epstein's Underage Sex Slave Scandal Taints Hillary and Jeb - Clinton–Bush Pedophilia Coverup - Mossad Blackmail Influence Over Leading Politicians - Robert & Ghislaine Maxwell - Jane Doe 102 - Epstein's Sweetheart Deal: Celebrity Lawyers Alan Dershowitz, Kenneth Starr, Roy Black - \"Little St. James\": The Name of Jeffrey Epstein's \"Egg-Shaped Penis\"?   \n\nThe Situation Is So Intense, It Involves the Entire US Government | FBI Insider   \n\n*EXPLOSIVE* Q & A on the Clinton Foundation - FBI Insider on 4chan /pol/ : \"Ask Me Anything About the Clinton Case\" - George Soros Is the Kingpin - Follow the Rothschild Thread - Clinton Foundation Uses People as Currency - Jeffrey Epstein's Child Sex Trafficking Network - Bill & Hillary Clinton Get Paid in Money & Children - Hammer HRC's E-mails, Dig Into the CF: Post Everywhere You Can   ",
		"thread_title": "FBI Weiner Probe Reopens Hillary Clinton Investigation - Clinton Foundation Pay to Play for Israeli Pork Is Not Kosher - President Trump Will Make America Great Again #MAGA",
		"title": "FBI Weiner Probe Reopens Hillary Clinton Investigation - Clinton Foundation Pay to Play for Israeli Pork Is Not Kosher - President Trump Will Make America Great Again #MAGA",
		"type": "bs",
		"uuid": "32b8a10c927682a608bd3b88147c357b8807eaeb"
	},
	"-KhI_fLhsuXLcaRmXEby": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T15:58:39.820+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "AD",
				"salience": 0.31443995,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ATTACK",
				"salience": 0.137202,
				"type": "OTHER"
			},
			{
				"name": "hit VP pick",
				"salience": 0.097411886,
				"type": "PERSON"
			},
			{
				"name": "OBAMA Crime Cartel First",
				"salience": 0.06064428,
				"type": "ORGANIZATION"
			},
			{
				"name": "crash",
				"salience": 0.060096376,
				"type": "EVENT"
			},
			{
				"name": "engine",
				"salience": 0.060096376,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "CLINTON",
				"salience": 0.058420278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "BUSH",
				"salience": 0.058420278,
				"type": "PERSON"
			},
			{
				"name": "Mike Pences Plane",
				"salience": 0.04989325,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fires",
				"salience": 0.0329656,
				"type": "EVENT"
			},
			{
				"name": "Cause",
				"salience": 0.0329656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05czz6l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Airplane"
				},
				"name": "Plane",
				"salience": 0.023497706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04tgw2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toyota_ZZ_engine"
				},
				"name": "ZZ",
				"salience": 0.013946427,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-29T10:38:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Good Day AD I would have to say that we are under ATTACK by the BUSH/CLINTON/OBAMA Crime Cartel First  hit VP pick Mike Pences Plane and the other Plane fires etc Cause ? computer induced crash and engine failure&#39;s etc. ZZ",
		"thread_title": "FBI Weiner Probe Reopens Hillary Clinton Investigation - Clinton Foundation Pay to Play for Israeli Pork Is Not Kosher - President Trump Will Make America Great Again #MAGA",
		"title": "",
		"type": "bs",
		"uuid": "2ee23dfd1bc388c251fec378231fe3bbd8ef0883"
	},
	"-KhI_gklfab7_Cks_m4z": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T23:54:43.950+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.17854884,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/091msx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serco"
				},
				"name": "SERCO GROUP PLC",
				"salience": 0.03605591,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "Federal Bureau of Investigations",
				"salience": 0.022457203,
				"type": "ORGANIZATION"
			},
			{
				"name": "AbelDanger.net",
				"salience": 0.020518327,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Rajendran Hyman CBE",
				"salience": 0.020144587,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.018016977,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0132447,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.010719966,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02pkl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Expert"
				},
				"name": "Experts",
				"salience": 0.010372717,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.009171778,
				"type": "ORGANIZATION"
			},
			{
				"name": "Command",
				"salience": 0.007995952,
				"type": "ORGANIZATION"
			},
			{
				"name": "assault",
				"salience": 0.007967631,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0074400418,
				"type": "PERSON"
			},
			{
				"name": "annex",
				"salience": 0.0070758783,
				"type": "OTHER"
			},
			{
				"name": "Gillenwater",
				"salience": 0.0068012658,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0062191007,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libyan",
				"salience": 0.0060393917,
				"type": "LOCATION"
			},
			{
				"name": "Mar 2013 Serco Inc.",
				"salience": 0.00574358,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.005660538,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.005369823,
				"type": "EVENT"
			},
			{
				"name": "exercises",
				"salience": 0.0051718783,
				"type": "OTHER"
			},
			{
				"name": "Platte River Networks",
				"salience": 0.0050812503,
				"type": "ORGANIZATION"
			},
			{
				"name": "Business",
				"salience": 0.004836014,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.004533674,
				"type": "LOCATION"
			},
			{
				"name": "Field",
				"salience": 0.003908208,
				"type": "LOCATION"
			},
			{
				"name": "tactics",
				"salience": 0.0035848122,
				"type": "OTHER"
			},
			{
				"name": "extremists",
				"salience": 0.0035848122,
				"type": "PERSON"
			},
			{
				"name": "mortar barrel",
				"salience": 0.003565303,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0033254034,
				"type": "PERSON"
			},
			{
				"name": "Base One",
				"salience": 0.0032182883,
				"type": "ORGANIZATION"
			},
			{
				"name": "loan",
				"salience": 0.003214202,
				"type": "OTHER"
			},
			{
				"name": "command",
				"salience": 0.0031453602,
				"type": "OTHER"
			},
			{
				"name": "commander-in-chief",
				"salience": 0.0031453602,
				"type": "PERSON"
			},
			{
				"name": "fallback building",
				"salience": 0.0031043768,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01l4l4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Physical_Laboratory_(United_Kingdom)"
				},
				"name": "National Physical Laboratory",
				"salience": 0.003090051,
				"type": "ORGANIZATION"
			},
			{
				"name": "compound",
				"salience": 0.002948274,
				"type": "OTHER"
			},
			{
				"name": "Officials",
				"salience": 0.002944867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "United States Marine",
				"salience": 0.0029268113,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0028769546,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0028769546,
				"type": "OTHER"
			},
			{
				"name": "mortars",
				"salience": 0.002802267,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.002802267,
				"type": "ORGANIZATION"
			},
			{
				"name": "training",
				"salience": 0.002802267,
				"type": "OTHER"
			},
			{
				"name": "Governments",
				"salience": 0.002723773,
				"type": "ORGANIZATION"
			},
			{
				"name": "operatives",
				"salience": 0.0026409354,
				"type": "OTHER"
			},
			{
				"name": "mortar attack",
				"salience": 0.0026409354,
				"type": "EVENT"
			},
			{
				"name": "attackers",
				"salience": 0.0026409354,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0026409354,
				"type": "EVENT"
			},
			{
				"name": "consulate attackers",
				"salience": 0.0026409354,
				"type": "PERSON"
			},
			{
				"name": "Paul Combetta",
				"salience": 0.0025531226,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0025530832,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.002464548,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0024593617,
				"type": "OTHER"
			},
			{
				"name": "Director",
				"salience": 0.0024593617,
				"type": "PERSON"
			},
			{
				"name": "e-mail server company",
				"salience": 0.0024528438,
				"type": "ORGANIZATION"
			},
			{
				"name": "operatives",
				"salience": 0.0024475043,
				"type": "PERSON"
			},
			{
				"name": "Mortar training device",
				"salience": 0.0024316553,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "network",
				"salience": 0.0023586538,
				"type": "OTHER"
			},
			{
				"name": "command network",
				"salience": 0.0023586538,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0023586538,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0023586538,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0023586538,
				"type": "OTHER"
			},
			{
				"name": "perimeter",
				"salience": 0.0022573317,
				"type": "OTHER"
			},
			{
				"name": "Consulate",
				"salience": 0.002249456,
				"type": "PERSON"
			},
			{
				"name": "Digital Fires Instructor Serco",
				"salience": 0.0022062454,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0021739441,
				"type": "LOCATION"
			},
			{
				"name": "Defense Ammunition Center",
				"salience": 0.0021406168,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0021296644,
				"type": "EVENT"
			},
			{
				"name": "groups",
				"salience": 0.002097919,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.0020231162,
				"type": "PERSON"
			},
			{
				"name": "compound",
				"salience": 0.0020155415,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n46_gt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Christopher_Stevens"
				},
				"name": "Chris Stevens",
				"salience": 0.0020106758,
				"type": "PERSON"
			},
			{
				"name": "McConnell Plum City",
				"salience": 0.0020069901,
				"type": "OTHER"
			},
			{
				"name": "Field",
				"salience": 0.0019961835,
				"type": "LOCATION"
			},
			{
				"name": "military disciplines",
				"salience": 0.0019961835,
				"type": "OTHER"
			},
			{
				"name": "diplomatic mission",
				"salience": 0.0019961835,
				"type": "OTHER"
			},
			{
				"name": "combat service support",
				"salience": 0.0019961835,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bkk6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_key_infrastructure"
				},
				"name": "PKI",
				"salience": 0.00199023,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.0019854465,
				"type": "LOCATION"
			},
			{
				"name": "Maria Contreras-Sweet",
				"salience": 0.0019462287,
				"type": "PERSON"
			},
			{
				"name": "Types of Exercise Workshop",
				"salience": 0.0019462287,
				"type": "EVENT"
			},
			{
				"name": "engineers",
				"salience": 0.0019369468,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0n47tsv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ansar_al-Sharia_(Libya)"
				},
				"name": "Ansar al-Shariah",
				"salience": 0.0018955836,
				"type": "PERSON"
			},
			{
				"name": "cartridge projectile",
				"salience": 0.0018876872,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.0018441416,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0018441416,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.0018441416,
				"type": "WORK_OF_ART"
			},
			{
				"name": "responders",
				"salience": 0.0018441416,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0018441416,
				"type": "PERSON"
			},
			{
				"name": "assault",
				"salience": 0.0018441416,
				"type": "EVENT"
			},
			{
				"name": "ground combat",
				"salience": 0.0018441416,
				"type": "OTHER"
			},
			{
				"name": "Shareholders",
				"salience": 0.0018441416,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.0018073338,
				"type": "ORGANIZATION"
			},
			{
				"name": "James Convey",
				"salience": 0.0017063525,
				"type": "PERSON"
			},
			{
				"name": "details",
				"salience": 0.0016650789,
				"type": "OTHER"
			},
			{
				"name": "Gold",
				"salience": 0.0016650789,
				"type": "OTHER"
			},
			{
				"name": "extremists",
				"salience": 0.0016650789,
				"type": "PERSON"
			},
			{
				"name": "equipment",
				"salience": 0.0016650789,
				"type": "OTHER"
			},
			{
				"name": "spies",
				"salience": 0.0016650789,
				"type": "OTHER"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.0016650789,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.0016650789,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0016650789,
				"type": "OTHER"
			},
			{
				"name": "spies",
				"salience": 0.0016650789,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.0016345907,
				"type": "EVENT"
			},
			{
				"name": "McConnell -- Global Operations",
				"salience": 0.0016256236,
				"type": "ORGANIZATION"
			},
			{
				"name": "plans",
				"salience": 0.0016223682,
				"type": "OTHER"
			},
			{
				"name": "Michael Bay Movie HD Trump",
				"salience": 0.0016179533,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0015854295,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.0015558025,
				"type": "OTHER"
			},
			{
				"name": "Gun trucks",
				"salience": 0.0015558025,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "WASHINGTON",
				"salience": 0.0015515822,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0015515822,
				"type": "LOCATION"
			},
			{
				"name": "device",
				"salience": 0.0015505428,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "firepower",
				"salience": 0.0015054976,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0014943548,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Moammar Gadhafi",
				"salience": 0.0014820405,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0m52nw7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sean_Smith_(diplomat)"
				},
				"name": "Sean Smith",
				"salience": 0.0014820405,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01srj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Comet"
				},
				"name": "Comet",
				"salience": 0.0014764662,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "terrorists",
				"salience": 0.0014758662,
				"type": "PERSON"
			},
			{
				"name": "movie",
				"salience": 0.0014758662,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0r4xkxr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Red_Switch_Network"
				},
				"name": "Defense Red Switch Network",
				"salience": 0.0014518192,
				"type": "ORGANIZATION"
			},
			{
				"name": "propaganda snuff film",
				"salience": 0.0014418165,
				"type": "WORK_OF_ART"
			},
			{
				"name": "images",
				"salience": 0.0014418165,
				"type": "WORK_OF_ART"
			},
			{
				"name": "torture killings",
				"salience": 0.0014418165,
				"type": "EVENT"
			},
			{
				"name": "RPGs",
				"salience": 0.0014418165,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Teachers",
				"salience": 0.0014418165,
				"type": "PERSON"
			},
			{
				"name": "aviation",
				"salience": 0.0014418165,
				"type": "OTHER"
			},
			{
				"name": "Subsidiaries",
				"salience": 0.0014418165,
				"type": "ORGANIZATION"
			},
			{
				"name": "List",
				"salience": 0.0014418165,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0014418165,
				"type": "OTHER"
			},
			{
				"name": "enemy capabilities",
				"salience": 0.0014418165,
				"type": "OTHER"
			},
			{
				"name": "courses",
				"salience": 0.0014418165,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0014418165,
				"type": "OTHER"
			},
			{
				"name": "general",
				"salience": 0.0014418165,
				"type": "PERSON"
			},
			{
				"name": "siege",
				"salience": 0.0014418165,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.0014418165,
				"type": "PERSON"
			},
			{
				"name": "production",
				"salience": 0.0014418165,
				"type": "OTHER"
			},
			{
				"name": "ambush",
				"salience": 0.0014418165,
				"type": "EVENT"
			},
			{
				"name": "expansion",
				"salience": 0.0014418165,
				"type": "EVENT"
			},
			{
				"name": "ammo",
				"salience": 0.0014418165,
				"type": "OTHER"
			},
			{
				"name": "Information Security Planning",
				"salience": 0.0014233955,
				"type": "OTHER"
			},
			{
				"name": "terrorist attack",
				"salience": 0.0013833005,
				"type": "EVENT"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0013719274,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0013676983,
				"type": "PERSON"
			},
			{
				"name": "security officers",
				"salience": 0.0013676983,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0013676983,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0013495605,
				"type": "PERSON"
			},
			{
				"name": "planning",
				"salience": 0.0013330681,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0013262256,
				"type": "ORGANIZATION"
			},
			{
				"name": "powers",
				"salience": 0.0012779648,
				"type": "OTHER"
			},
			{
				"name": "Federal Bridge Certification Authority",
				"salience": 0.0012286579,
				"type": "ORGANIZATION"
			},
			{
				"name": "compound",
				"salience": 0.0012136698,
				"type": "OTHER"
			},
			{
				"name": "compound",
				"salience": 0.0012136698,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0012110777,
				"type": "PERSON"
			},
			{
				"name": "team",
				"salience": 0.0012011812,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.0011896105,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0011896105,
				"type": "PERSON"
			},
			{
				"name": "device",
				"salience": 0.001173047,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stage",
				"salience": 0.0011621934,
				"type": "OTHER"
			},
			{
				"name": "mortar",
				"salience": 0.0011535361,
				"type": "OTHER"
			},
			{
				"name": "13 Hours The Secret Soldiers of Benghazi Official Trailer #1",
				"salience": 0.0011350561,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0134tnny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/13_Hours:_The_Secret_Soldiers_of_Benghazi"
				},
				"name": "13 Hours",
				"salience": 0.0011350561,
				"type": "WORK_OF_ART"
			},
			{
				"name": "device",
				"salience": 0.0011292537,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/021psw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Citizenship_and_Immigration_Services"
				},
				"name": "USCIS",
				"salience": 0.0011087887,
				"type": "ORGANIZATION"
			},
			{
				"name": "operation",
				"salience": 0.0010870947,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0010870947,
				"type": "EVENT"
			},
			{
				"name": "mortar training device",
				"salience": 0.0010870947,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "attack",
				"salience": 0.0010870947,
				"type": "EVENT"
			},
			{
				"name": "center",
				"salience": 0.0010870947,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.0010870947,
				"type": "OTHER"
			},
			{
				"name": "mortar training devices",
				"salience": 0.0010870947,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "charges",
				"salience": 0.0010588345,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0010509158,
				"type": "OTHER"
			},
			{
				"name": "contacts",
				"salience": 0.0010509158,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cn2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_Communications_Headquarters"
				},
				"name": "GCHQ",
				"salience": 0.0010306607,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.0010248235,
				"type": "PERSON"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0010248235,
				"type": "OTHER"
			},
			{
				"name": "Red Switch",
				"salience": 0.0010248235,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0010248235,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0010248235,
				"type": "ORGANIZATION"
			},
			{
				"name": "Antony Wiener",
				"salience": 0.0010248235,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.0010036101,
				"type": "PERSON"
			},
			{
				"name": "reputation",
				"salience": 0.0009981164,
				"type": "OTHER"
			},
			{
				"name": "Weaponry",
				"salience": 0.0009781665,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0009588859,
				"type": "ORGANIZATION"
			},
			{
				"name": "women engineer",
				"salience": 0.0009439617,
				"type": "PERSON"
			},
			{
				"name": "training",
				"salience": 0.00094167446,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0009406671,
				"type": "PERSON"
			},
			{
				"name": "wave",
				"salience": 0.00093678484,
				"type": "EVENT"
			},
			{
				"name": "device",
				"salience": 0.0009336172,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0tm59dw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Matt_Apuzzo"
				},
				"name": "MATT APUZZO",
				"salience": 0.0009335697,
				"type": "PERSON"
			},
			{
				"name": "firms",
				"salience": 0.00093206466,
				"type": "ORGANIZATION"
			},
			{
				"name": "computer system",
				"salience": 0.00092588627,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.00092588627,
				"type": "EVENT"
			},
			{
				"name": "career officials",
				"salience": 0.0009230856,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "The Associated Press",
				"salience": 0.0009067732,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00088738743,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "CA",
				"salience": 0.00088738743,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0206rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Sachs"
				},
				"name": "Sachs",
				"salience": 0.00088738743,
				"type": "ORGANIZATION"
			},
			{
				"name": "Scandal Supercut Copy",
				"salience": 0.00088738743,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.00088738743,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04mn99",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AXA"
				},
				"name": "AXA",
				"salience": 0.00088738743,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0blhyc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kimberly_Dozier"
				},
				"name": "KIMBERLY DOZIER",
				"salience": 0.00088738743,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00088738743,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0840w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Health_Organization"
				},
				"name": "WHO",
				"salience": 0.00088738743,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00088203285,
				"type": "LOCATION"
			},
			{
				"name": "group finance director",
				"salience": 0.00088049495,
				"type": "PERSON"
			},
			{
				"name": "mortar projectile",
				"salience": 0.0008765613,
				"type": "OTHER"
			},
			{
				"name": "COMMENTS",
				"salience": 0.0008739097,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Some",
				"salience": 0.00086436153,
				"type": "OTHER"
			},
			{
				"name": "e-mail server company",
				"salience": 0.00085088576,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0008302903,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00082160207,
				"type": "LOCATION"
			},
			{
				"name": "authorities",
				"salience": 0.00082160207,
				"type": "PERSON"
			},
			{
				"name": "Secretary of State",
				"salience": 0.00082160207,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.00082160207,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00082160207,
				"type": "LOCATION"
			},
			{
				"name": "mortar firing",
				"salience": 0.00082160207,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00082160207,
				"type": "OTHER"
			},
			{
				"name": "E-Mail Server Company",
				"salience": 0.0008191167,
				"type": "ORGANIZATION"
			},
			{
				"name": "management services",
				"salience": 0.0008191167,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0008191167,
				"type": "ORGANIZATION"
			},
			{
				"name": "level",
				"salience": 0.0008190215,
				"type": "OTHER"
			},
			{
				"name": "Table-top exercises",
				"salience": 0.0008159735,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fzds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Patent_and_Trademark_Office"
				},
				"name": "U.S. Patent and Trademark Office",
				"salience": 0.00081208174,
				"type": "ORGANIZATION"
			},
			{
				"name": "minority professionals",
				"salience": 0.0008070652,
				"type": "PERSON"
			},
			{
				"name": "Zulu",
				"salience": 0.00080234045,
				"type": "PERSON"
			},
			{
				"name": "information systems",
				"salience": 0.0007951631,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.000795031,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00079253386,
				"type": "OTHER"
			},
			{
				"name": "Statement",
				"salience": 0.0007785275,
				"type": "WORK_OF_ART"
			},
			{
				"name": "trainee",
				"salience": 0.0007785275,
				"type": "PERSON"
			},
			{
				"name": "trainee firing errors",
				"salience": 0.0007785275,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0007785275,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00076213735,
				"type": "EVENT"
			},
			{
				"name": "device",
				"salience": 0.00076213735,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "device",
				"salience": 0.00076213735,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "advance",
				"salience": 0.00075900374,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00075900374,
				"type": "LOCATION"
			},
			{
				"name": "aspects",
				"salience": 0.00075900374,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.00075900374,
				"type": "EVENT"
			},
			{
				"name": "weapons",
				"salience": 0.00075900374,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00075900374,
				"type": "EVENT"
			},
			{
				"name": "mortar fire",
				"salience": 0.00075900374,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.00075900374,
				"type": "EVENT"
			},
			{
				"name": "mortar service ammunition",
				"salience": 0.00075900374,
				"type": "OTHER"
			},
			{
				"name": "Intelligence reports",
				"salience": 0.00075900374,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00075900374,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0007567077,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0007567077,
				"type": "ORGANIZATION"
			},
			{
				"name": "training",
				"salience": 0.0007494595,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0007489137,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00074106373,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00074106373,
				"type": "OTHER"
			},
			{
				"name": "government loans",
				"salience": 0.00073677086,
				"type": "OTHER"
			},
			{
				"name": "contracts",
				"salience": 0.00073677086,
				"type": "OTHER"
			},
			{
				"name": "blast attenuator device",
				"salience": 0.00073368114,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "HeiTech Services, Inc.",
				"salience": 0.0007328042,
				"type": "ORGANIZATION"
			},
			{
				"name": "data",
				"salience": 0.0007155588,
				"type": "OTHER"
			},
			{
				"name": "discoveries",
				"salience": 0.00071460643,
				"type": "EVENT"
			},
			{
				"name": "more",
				"salience": 0.0007097107,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.00070926157,
				"type": "OTHER"
			},
			{
				"name": "Loans",
				"salience": 0.00070926157,
				"type": "OTHER"
			},
			{
				"name": "dollar loan",
				"salience": 0.00070926157,
				"type": "OTHER"
			},
			{
				"name": "government loans",
				"salience": 0.00070926157,
				"type": "OTHER"
			},
			{
				"name": "loan",
				"salience": 0.00070926157,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.00070926157,
				"type": "OTHER"
			},
			{
				"name": "components",
				"salience": 0.0006945983,
				"type": "OTHER"
			},
			{
				"name": "complexity",
				"salience": 0.0006945983,
				"type": "OTHER"
			},
			{
				"name": "zone",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "mortar barrel",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "detainee",
				"salience": 0.0006852847,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0006852847,
				"type": "LOCATION"
			},
			{
				"name": "firing distance",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0006852847,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0006852847,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "recoil",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "positioning",
				"salience": 0.0006852847,
				"type": "OTHER"
			},
			{
				"name": "rebellion",
				"salience": 0.0006852847,
				"type": "EVENT"
			},
			{
				"name": "team",
				"salience": 0.00068321155,
				"type": "ORGANIZATION"
			},
			{
				"name": "Director",
				"salience": 0.00068321155,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0006828927,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.0006746002,
				"type": "OTHER"
			},
			{
				"name": "intelligence reports",
				"salience": 0.0006685856,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.00066425395,
				"type": "OTHER"
			},
			{
				"name": "grouping",
				"salience": 0.00066017814,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.00066017814,
				"type": "LOCATION"
			},
			{
				"name": "training",
				"salience": 0.00066017814,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.00065728545,
				"type": "OTHER"
			},
			{
				"name": "patent application",
				"salience": 0.0006552209,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.0006552209,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.00064910867,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00064910867,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.00064564974,
				"type": "EVENT"
			},
			{
				"name": "group",
				"salience": 0.0006436408,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0006416746,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0n5zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Component_Object_Model"
				},
				"name": "COM",
				"salience": 0.00063888624,
				"type": "OTHER"
			},
			{
				"name": "Simulation",
				"salience": 0.0006375117,
				"type": "OTHER"
			},
			{
				"name": "Super Serco",
				"salience": 0.0006366339,
				"type": "ORGANIZATION"
			},
			{
				"name": "participants",
				"salience": 0.0006342255,
				"type": "PERSON"
			},
			{
				"name": "E-Mails",
				"salience": 0.0006248719,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.0006248719,
				"type": "WORK_OF_ART"
			},
			{
				"name": "origin",
				"salience": 0.00062425894,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0006221479,
				"type": "EVENT"
			},
			{
				"name": "head",
				"salience": 0.00061915687,
				"type": "OTHER"
			},
			{
				"name": "Profit growth",
				"salience": 0.00061915687,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0006145258,
				"type": "PERSON"
			},
			{
				"name": "profits",
				"salience": 0.0006145258,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0155qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_Corps_Base_Camp_Pendleton"
				},
				"name": "Camp Pendleton",
				"salience": 0.00060653215,
				"type": "LOCATION"
			},
			{
				"name": "BREAKING",
				"salience": 0.0006036469,
				"type": "EVENT"
			},
			{
				"name": "control",
				"salience": 0.0006014399,
				"type": "OTHER"
			},
			{
				"name": "talent pool",
				"salience": 0.0005983344,
				"type": "OTHER"
			},
			{
				"name": "pad",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "anonymity",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "opening",
				"salience": 0.0005933752,
				"type": "EVENT"
			},
			{
				"name": "sight reacquisition",
				"salience": 0.0005933752,
				"type": "EVENT"
			},
			{
				"name": "round",
				"salience": 0.0005933752,
				"type": "EVENT"
			},
			{
				"name": "fuse",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "explosion",
				"salience": 0.0005933752,
				"type": "EVENT"
			},
			{
				"name": "militias",
				"salience": 0.0005933752,
				"type": "PERSON"
			},
			{
				"name": "regime",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "weapons depots",
				"salience": 0.0005933752,
				"type": "LOCATION"
			},
			{
				"name": "object",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "target sight acquisition",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "elevation",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "azimuth",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "battlefield savvy",
				"salience": 0.0005933752,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00059158006,
				"type": "EVENT"
			},
			{
				"name": "data",
				"salience": 0.00059158006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01ryjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cabinet_Office"
				},
				"name": "UK Cabinet Office",
				"salience": 0.00059012836,
				"type": "ORGANIZATION"
			},
			{
				"name": "rigour",
				"salience": 0.0005858959,
				"type": "OTHER"
			},
			{
				"name": "vendors",
				"salience": 0.00058512116,
				"type": "ORGANIZATION"
			},
			{
				"name": "network",
				"salience": 0.00058453187,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.00057934935,
				"type": "OTHER"
			},
			{
				"name": "Exercises",
				"salience": 0.00057934935,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.00057934935,
				"type": "OTHER"
			},
			{
				"name": "teamwork",
				"salience": 0.00057934935,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0005759931,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.0005759931,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0005759931,
				"type": "OTHER"
			},
			{
				"name": "high frequency trading",
				"salience": 0.0005759931,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0005759931,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08_ykc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Small_Business_Administration"
				},
				"name": "Small Business Administration",
				"salience": 0.0005700673,
				"type": "ORGANIZATION"
			},
			{
				"name": "NVC",
				"salience": 0.0005688024,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.00056694646,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.00056483643,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.00056483643,
				"type": "ORGANIZATION"
			},
			{
				"name": "PKIs",
				"salience": 0.0005584412,
				"type": "PERSON"
			},
			{
				"name": "TSymmetry, Inc.",
				"salience": 0.00055644946,
				"type": "ORGANIZATION"
			},
			{
				"name": "Serco , Inc.",
				"salience": 0.00055644946,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.00055561314,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.00055561314,
				"type": "OTHER"
			},
			{
				"name": "planning",
				"salience": 0.00055561314,
				"type": "OTHER"
			},
			{
				"name": "intensity",
				"salience": 0.00055561314,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0005544859,
				"type": "OTHER"
			},
			{
				"name": "simulation",
				"salience": 0.0005544859,
				"type": "OTHER"
			},
			{
				"name": "committee chairman",
				"salience": 0.0005544859,
				"type": "PERSON"
			},
			{
				"name": "simulation",
				"salience": 0.0005544859,
				"type": "OTHER"
			},
			{
				"name": "campaign chair",
				"salience": 0.0005544859,
				"type": "OTHER"
			},
			{
				"name": "Probe",
				"salience": 0.0005544859,
				"type": "EVENT"
			},
			{
				"name": "Congressional Chairmen",
				"salience": 0.0005544859,
				"type": "PERSON"
			},
			{
				"name": "information security policies",
				"salience": 0.00054632727,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0005389136,
				"type": "WORK_OF_ART"
			},
			{
				"name": "order book",
				"salience": 0.00053611497,
				"type": "WORK_OF_ART"
			},
			{
				"name": "caesium fountain atomic clock",
				"salience": 0.00053611497,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.000535406,
				"type": "PERSON"
			},
			{
				"name": "benefit",
				"salience": 0.0005321049,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0005321049,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0005321049,
				"type": "LOCATION"
			},
			{
				"name": "leadership",
				"salience": 0.0005321049,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.0005321049,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0005321049,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0005321049,
				"type": "OTHER"
			},
			{
				"name": "research team",
				"salience": 0.0005301245,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.0005298771,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.0005298771,
				"type": "OTHER"
			},
			{
				"name": "@HillaryClinton",
				"salience": 0.00052701763,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0005250308,
				"type": "OTHER"
			},
			{
				"name": "K.J.",
				"salience": 0.0005146961,
				"type": "OTHER"
			},
			{
				"name": "trainees",
				"salience": 0.0005122514,
				"type": "PERSON"
			},
			{
				"name": "request",
				"salience": 0.0005122362,
				"type": "EVENT"
			},
			{
				"name": "letter",
				"salience": 0.0005122362,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Response",
				"salience": 0.0005122362,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0005122362,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0005122362,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Letter",
				"salience": 0.0005122362,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.0005122362,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.0005122362,
				"type": "EVENT"
			},
			{
				"name": "response",
				"salience": 0.0005122362,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0005122362,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.00050959125,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00050627615,
				"type": "OTHER"
			},
			{
				"name": "PGPubs) Classification Services",
				"salience": 0.00050410203,
				"type": "ORGANIZATION"
			},
			{
				"name": "finance director",
				"salience": 0.00050389714,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00050164567,
				"type": "OTHER"
			},
			{
				"name": "organisation",
				"salience": 0.00050164567,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisations",
				"salience": 0.00050164567,
				"type": "ORGANIZATION"
			},
			{
				"name": "status",
				"salience": 0.00049312395,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0004927648,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.0004868937,
				"type": "PERSON"
			},
			{
				"name": "presentation",
				"salience": 0.00048655353,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00048624983,
				"type": "OTHER"
			},
			{
				"name": "firing sound",
				"salience": 0.00048437953,
				"type": "OTHER"
			},
			{
				"name": "SSL protocol",
				"salience": 0.00048171362,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00048042054,
				"type": "OTHER"
			},
			{
				"name": "government bureaucrats",
				"salience": 0.00048042054,
				"type": "PERSON"
			},
			{
				"name": "light",
				"salience": 0.00048042054,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00048042054,
				"type": "ORGANIZATION"
			},
			{
				"name": "City",
				"salience": 0.00048042054,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.00048042054,
				"type": "WORK_OF_ART"
			},
			{
				"name": "condo",
				"salience": 0.00048042054,
				"type": "LOCATION"
			},
			{
				"name": "innovation",
				"salience": 0.00048042054,
				"type": "OTHER"
			},
			{
				"name": "office space",
				"salience": 0.00048042054,
				"type": "LOCATION"
			},
			{
				"name": "goodwill",
				"salience": 0.00048042054,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00048042054,
				"type": "EVENT"
			},
			{
				"name": "prisons",
				"salience": 0.00048042054,
				"type": "LOCATION"
			},
			{
				"name": "breadth",
				"salience": 0.00048042054,
				"type": "OTHER"
			},
			{
				"name": "innovation",
				"salience": 0.00048042054,
				"type": "OTHER"
			},
			{
				"name": "goodbye",
				"salience": 0.00048042054,
				"type": "OTHER"
			},
			{
				"name": "management",
				"salience": 0.00048042054,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.000479302,
				"type": "ORGANIZATION"
			},
			{
				"name": "engineering",
				"salience": 0.00047292974,
				"type": "OTHER"
			},
			{
				"name": "prosecutor",
				"salience": 0.0004722453,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0004701899,
				"type": "PERSON"
			},
			{
				"name": "Command Post",
				"salience": 0.0004701899,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.0004701899,
				"type": "ORGANIZATION"
			},
			{
				"name": "staff",
				"salience": 0.0004701899,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0004701899,
				"type": "OTHER"
			},
			{
				"name": "simulation support",
				"salience": 0.0004701899,
				"type": "OTHER"
			},
			{
				"name": "Centre of Carbon Measurement",
				"salience": 0.0004690327,
				"type": "ORGANIZATION"
			},
			{
				"name": "stuff",
				"salience": 0.00046629267,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.000465207,
				"type": "OTHER"
			},
			{
				"name": "business operations",
				"salience": 0.0004647157,
				"type": "OTHER"
			},
			{
				"name": "considerations",
				"salience": 0.00046372626,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00046248146,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00046248146,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.00046248146,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00046248146,
				"type": "OTHER"
			},
			{
				"name": "Issues",
				"salience": 0.00046248146,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00046248146,
				"type": "WORK_OF_ART"
			},
			{
				"name": "access",
				"salience": 0.000453553,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.000453553,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0004492471,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.00044888104,
				"type": "EVENT"
			},
			{
				"name": "career",
				"salience": 0.00044521215,
				"type": "OTHER"
			},
			{
				"name": "cutting edge solutions",
				"salience": 0.00044365803,
				"type": "OTHER"
			},
			{
				"name": "cutting edge solutions",
				"salience": 0.00044365803,
				"type": "OTHER"
			},
			{
				"name": "invention",
				"salience": 0.00043901886,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.000437636,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "mix",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.00043436245,
				"type": "LOCATION"
			},
			{
				"name": "levels",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "training benefit",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "shareholder",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "Developments",
				"salience": 0.00043436245,
				"type": "EVENT"
			},
			{
				"name": "locations",
				"salience": 0.00043436245,
				"type": "LOCATION"
			},
			{
				"name": "scheme",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00043436245,
				"type": "LOCATION"
			},
			{
				"name": "roles",
				"salience": 0.00043436245,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.0004327458,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.0004327458,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.0004327458,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.0004327458,
				"type": "ORGANIZATION"
			},
			{
				"name": "veteran firms",
				"salience": 0.0004327458,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.0004327458,
				"type": "ORGANIZATION"
			},
			{
				"name": "diversity",
				"salience": 0.0004327458,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.0004327458,
				"type": "PERSON"
			},
			{
				"name": "firm",
				"salience": 0.0004327458,
				"type": "ORGANIZATION"
			},
			{
				"name": "engineers",
				"salience": 0.0004327458,
				"type": "PERSON"
			},
			{
				"name": "engineers",
				"salience": 0.0004327458,
				"type": "PERSON"
			},
			{
				"name": "diversity",
				"salience": 0.0004327458,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.00043023872,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0004257994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0btt37",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guant%C3%A1namo_Bay"
				},
				"name": "Guantanamo Bay",
				"salience": 0.00042173252,
				"type": "LOCATION"
			},
			{
				"name": "ABSTRACT A",
				"salience": 0.00042173252,
				"type": "OTHER"
			},
			{
				"name": "American Space",
				"salience": 0.00042173252,
				"type": "LOCATION"
			},
			{
				"name": "airport radar",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "defence budgets",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "running banks",
				"salience": 0.00041598378,
				"type": "ORGANIZATION"
			},
			{
				"name": "opportunities",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "dividends",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "footprint",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "carbon emissions reductions",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "friendly",
				"salience": 0.00041598378,
				"type": "EVENT"
			},
			{
				"name": "forest bulldozers",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "accomplishments",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "favors",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "achievements",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "farewell",
				"salience": 0.00041598378,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00041501524,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00041501524,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00041501524,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00041501524,
				"type": "OTHER"
			},
			{
				"name": "risk analysis",
				"salience": 0.00041501524,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.00040045052,
				"type": "OTHER"
			},
			{
				"name": "realism",
				"salience": 0.00040045052,
				"type": "OTHER"
			},
			{
				"name": "firing option",
				"salience": 0.00040045052,
				"type": "OTHER"
			},
			{
				"name": "purposes",
				"salience": 0.00040045052,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.00040045052,
				"type": "PERSON"
			},
			{
				"name": "tips",
				"salience": 0.00040045052,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.00040045052,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.00040045052,
				"type": "ORGANIZATION"
			},
			{
				"name": "applicant",
				"salience": 0.00039951815,
				"type": "PERSON"
			},
			{
				"name": "solution",
				"salience": 0.00039579096,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.00039579096,
				"type": "OTHER"
			},
			{
				"name": "tempo",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "floor",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "Table Top",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "decision making",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "exercising package",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "exercise tempo",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "media play",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "encryption algorithms",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "Head",
				"salience": 0.00039217088,
				"type": "PERSON"
			},
			{
				"name": "decision making",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00039217088,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Trade_Center_(1973%E2%80%932001)"
				},
				"name": "World Trade Center",
				"salience": 0.00038287468,
				"type": "LOCATION"
			},
			{
				"name": "conclusion",
				"salience": 0.0003823463,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00038013453,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00038013453,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.0003778346,
				"type": "OTHER"
			},
			{
				"name": "chief executive",
				"salience": 0.00037779065,
				"type": "PERSON"
			},
			{
				"name": "professionals",
				"salience": 0.00037470274,
				"type": "PERSON"
			},
			{
				"name": "IT professionals",
				"salience": 0.00037470274,
				"type": "PERSON"
			},
			{
				"name": "IT projects",
				"salience": 0.00037470274,
				"type": "OTHER"
			},
			{
				"name": "community organizations",
				"salience": 0.00037470274,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizations",
				"salience": 0.00037470274,
				"type": "ORGANIZATION"
			},
			{
				"name": "Base One",
				"salience": 0.00037344947,
				"type": "ORGANIZATION"
			},
			{
				"name": "Consumer groups",
				"salience": 0.00037303954,
				"type": "ORGANIZATION"
			},
			{
				"name": "Office of Partner Relations",
				"salience": 0.0003690715,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.00036516652,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07p7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tripoli"
				},
				"name": "Tripoli",
				"salience": 0.00036516652,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Islam",
				"salience": 0.00036516652,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09j2x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy_SEALs"
				},
				"name": "Navy SEALs",
				"salience": 0.00036516652,
				"type": "PERSON"
			},
			{
				"name": "operations",
				"salience": 0.0003605818,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0003564129,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00035228863,
				"type": "ORGANIZATION"
			},
			{
				"name": "field",
				"salience": 0.00035120614,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.00035120614,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.00035120614,
				"type": "OTHER"
			},
			{
				"name": "pool",
				"salience": 0.00035120614,
				"type": "LOCATION"
			},
			{
				"name": "resources",
				"salience": 0.00035120614,
				"type": "OTHER"
			},
			{
				"name": "pool",
				"salience": 0.00035120614,
				"type": "OTHER"
			},
			{
				"name": "pools",
				"salience": 0.00035120614,
				"type": "OTHER"
			},
			{
				"name": "staffing",
				"salience": 0.00035120614,
				"type": "OTHER"
			},
			{
				"name": "technology research",
				"salience": 0.00035120614,
				"type": "OTHER"
			},
			{
				"name": "Information Security Counter",
				"salience": 0.00035120614,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00034904366,
				"type": "ORGANIZATION"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.0003437432,
				"type": "WORK_OF_ART"
			},
			{
				"name": "CHARLES C. JOHNSON",
				"salience": 0.00034123234,
				"type": "PERSON"
			},
			{
				"name": "information flow",
				"salience": 0.0003395695,
				"type": "OTHER"
			},
			{
				"name": "rehearsal",
				"salience": 0.0003395695,
				"type": "EVENT"
			},
			{
				"name": "situations",
				"salience": 0.0003395695,
				"type": "OTHER"
			},
			{
				"name": "coordination",
				"salience": 0.0003395695,
				"type": "OTHER"
			},
			{
				"name": "readiness",
				"salience": 0.0003395695,
				"type": "OTHER"
			},
			{
				"name": "graduation",
				"salience": 0.0003395695,
				"type": "EVENT"
			},
			{
				"name": "allegations",
				"salience": 0.0003395695,
				"type": "OTHER"
			},
			{
				"name": "government customers",
				"salience": 0.0003395695,
				"type": "PERSON"
			},
			{
				"name": "focus",
				"salience": 0.0003395695,
				"type": "OTHER"
			},
			{
				"name": "Punk",
				"salience": 0.0003395695,
				"type": "OTHER"
			},
			{
				"name": "environment",
				"salience": 0.0003395695,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02t27n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_of_Information_Act_(United_States)"
				},
				"name": "Freedom of Information Act",
				"salience": 0.00033713484,
				"type": "OTHER"
			},
			{
				"name": "contractor",
				"salience": 0.00033133256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0003286889,
				"type": "ORGANIZATION"
			},
			{
				"name": "visas",
				"salience": 0.00032715593,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.00032715593,
				"type": "ORGANIZATION"
			},
			{
				"name": "business",
				"salience": 0.00032715593,
				"type": "OTHER"
			},
			{
				"name": "surplus",
				"salience": 0.00032688933,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.00032444412,
				"type": "ORGANIZATION"
			},
			{
				"name": "Women",
				"salience": 0.00032444412,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "diversity recruiting",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "information technology risk",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "diversity mix",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.00032444412,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.00032444412,
				"type": "PERSON"
			},
			{
				"name": "Information Security Expertise",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "diversity mix",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "affiliations",
				"salience": 0.00032444412,
				"type": "ORGANIZATION"
			},
			{
				"name": "diversity recruitment",
				"salience": 0.00032444412,
				"type": "OTHER"
			},
			{
				"name": "Serco Processes 2 Millionth Patent Application",
				"salience": 0.00031523025,
				"type": "OTHER"
			},
			{
				"name": "GotNews.com/donate",
				"salience": 0.00031523025,
				"type": "OTHER"
			},
			{
				"name": "@gotnews.com",
				"salience": 0.00031523025,
				"type": "PERSON"
			},
			{
				"name": "processes",
				"salience": 0.00031513872,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.00031513872,
				"type": "PERSON"
			},
			{
				"name": "teams",
				"salience": 0.00031513872,
				"type": "ORGANIZATION"
			},
			{
				"name": "deputy director",
				"salience": 0.00031513872,
				"type": "PERSON"
			},
			{
				"name": "nationals",
				"salience": 0.00031426648,
				"type": "PERSON"
			},
			{
				"name": "Kabul for COM approval",
				"salience": 0.00031416636,
				"type": "OTHER"
			},
			{
				"name": "hallmarks",
				"salience": 0.00031071587,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.00030222637,
				"type": "OTHER"
			},
			{
				"name": "visa applications",
				"salience": 0.00030222637,
				"type": "OTHER"
			},
			{
				"name": "applicants",
				"salience": 0.00030222637,
				"type": "PERSON"
			},
			{
				"name": "communications",
				"salience": 0.00030110148,
				"type": "OTHER"
			},
			{
				"name": "communication",
				"salience": 0.00030110148,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00030110148,
				"type": "OTHER"
			},
			{
				"name": "GotNews",
				"salience": 0.0002956498,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09v06q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Emergency_Planning_College"
				},
				"name": "Emergency Planning College",
				"salience": 0.0002956498,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0002956498,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.0002956498,
				"type": "ORGANIZATION"
			},
			{
				"name": "scenario",
				"salience": 0.00029534256,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00029292848,
				"type": "PERSON"
			},
			{
				"name": "box",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "Strategy",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "assessments",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "IT positions",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "relationships",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00029292848,
				"type": "PERSON"
			},
			{
				"name": "diversity talent",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "points of view",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "spectrum",
				"salience": 0.00029292848,
				"type": "OTHER"
			},
			{
				"name": "penetration testing",
				"salience": 0.00029161957,
				"type": "EVENT"
			},
			{
				"name": "data",
				"salience": 0.00029073728,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.00028822623,
				"type": "OTHER"
			},
			{
				"name": "GotNews",
				"salience": 0.00028460956,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.00028460956,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.00028221984,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.00028221984,
				"type": "ORGANIZATION"
			},
			{
				"name": "communications",
				"salience": 0.0002790337,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00027862986,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00027862986,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.00027286875,
				"type": "OTHER"
			},
			{
				"name": "visa files",
				"salience": 0.00027286875,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.00027286875,
				"type": "OTHER"
			},
			{
				"name": "hub zone location",
				"salience": 0.00027164945,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.00026823307,
				"type": "LOCATION"
			},
			{
				"name": "analysis",
				"salience": 0.0002628628,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02fvf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Docklands_Light_Railway"
				},
				"name": "Docklands Light Railway",
				"salience": 0.00025599368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.00025599368,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanic",
				"salience": 0.00025599368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.00025599368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00025599368,
				"type": "LOCATION"
			},
			{
				"name": "contacteditor@gotnews.com",
				"salience": 0.00025599368,
				"type": "OTHER"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.0002557574,
				"type": "PERSON"
			},
			{
				"name": "petition",
				"salience": 0.0002557574,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0002557574,
				"type": "OTHER"
			},
			{
				"name": "visa petitions",
				"salience": 0.0002557574,
				"type": "OTHER"
			},
			{
				"name": "petitions",
				"salience": 0.0002557574,
				"type": "OTHER"
			},
			{
				"name": "employers",
				"salience": 0.0002557574,
				"type": "ORGANIZATION"
			},
			{
				"name": "post",
				"salience": 0.0002557574,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0002557574,
				"type": "WORK_OF_ART"
			},
			{
				"name": "employees",
				"salience": 0.0002557574,
				"type": "PERSON"
			},
			{
				"name": "contract employees",
				"salience": 0.0002557574,
				"type": "PERSON"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.0002557574,
				"type": "PERSON"
			},
			{
				"name": "data theft",
				"salience": 0.00025363738,
				"type": "OTHER"
			},
			{
				"name": "implements",
				"salience": 0.00025363738,
				"type": "OTHER"
			},
			{
				"name": "scope",
				"salience": 0.00025363738,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00025363738,
				"type": "OTHER"
			},
			{
				"name": "designs",
				"salience": 0.00025363738,
				"type": "WORK_OF_ART"
			},
			{
				"name": "IT skills",
				"salience": 0.00025363738,
				"type": "OTHER"
			},
			{
				"name": "Clients",
				"salience": 0.00025363738,
				"type": "PERSON"
			},
			{
				"name": "belief",
				"salience": 0.00025363738,
				"type": "OTHER"
			},
			{
				"name": "computer hackers",
				"salience": 0.00025363738,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.00025277954,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00025277954,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00024856668,
				"type": "OTHER"
			},
			{
				"name": "DKW Communications, Inc.",
				"salience": 0.0002480724,
				"type": "ORGANIZATION"
			},
			{
				"name": "cryptographic engineering",
				"salience": 0.00024764147,
				"type": "OTHER"
			},
			{
				"name": "Pre-Grant Publication",
				"salience": 0.00024643418,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tyler Durden",
				"salience": 0.00024643418,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "NYT",
				"salience": 0.00024643418,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.00024643418,
				"type": "PERSON"
			},
			{
				"name": "USAspending.gov",
				"salience": 0.00024643418,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.000244365,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00024133873,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09bbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gold_standard"
				},
				"name": "Gold Standard",
				"salience": 0.00024133873,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0002362681,
				"type": "LOCATION"
			},
			{
				"name": "leader",
				"salience": 0.0002362681,
				"type": "PERSON"
			},
			{
				"name": "appointment scheduling",
				"salience": 0.0002362681,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.00023538868,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02dqk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Foreign_Service"
				},
				"name": "Foreign Service",
				"salience": 0.00023251591,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0158jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_service"
				},
				"name": "Civil Service",
				"salience": 0.00023251591,
				"type": "ORGANIZATION"
			},
			{
				"name": "time line",
				"salience": 0.00022627061,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00022574376,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00022574376,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.00022558602,
				"type": "PERSON"
			},
			{
				"name": "vendors",
				"salience": 0.00021895165,
				"type": "ORGANIZATION"
			},
			{
				"name": "package",
				"salience": 0.00021879867,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00021879867,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00021528632,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00021528632,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.00021528632,
				"type": "OTHER"
			},
			{
				"name": "cryptographic protocols",
				"salience": 0.00021528632,
				"type": "OTHER"
			},
			{
				"name": "visa pre-processing",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "Citizenship",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "incident documentation",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "strategies",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "successor",
				"salience": 0.00021331711,
				"type": "PERSON"
			},
			{
				"name": "collection",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "mail",
				"salience": 0.00021331711,
				"type": "OTHER"
			},
			{
				"name": "James Ellis",
				"salience": 0.00021163489,
				"type": "PERSON"
			},
			{
				"name": "need",
				"salience": 0.00021062804,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00021062804,
				"type": "OTHER"
			},
			{
				"name": "Clifford Cocks",
				"salience": 0.00020896703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09p6s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arthur_Andersen"
				},
				"name": "Arthur Andersen",
				"salience": 0.00020896703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g9jc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ernst_%26_Young"
				},
				"name": "Ernst & Young",
				"salience": 0.00020896703,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.00020896703,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00020896703,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tjvv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Durban"
				},
				"name": "Durban",
				"salience": 0.00020896703,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00020896703,
				"type": "LOCATION"
			},
			{
				"name": "North Tower",
				"salience": 0.00020896703,
				"type": "LOCATION"
			},
			{
				"name": "Transitional Immigrant Visa Processing Center",
				"salience": 0.00020826029,
				"type": "ORGANIZATION"
			},
			{
				"name": "implementation",
				"salience": 0.00020535117,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.00020381503,
				"type": "PERSON"
			},
			{
				"name": "databases",
				"salience": 0.00020381503,
				"type": "OTHER"
			},
			{
				"name": "technology project",
				"salience": 0.00020381503,
				"type": "OTHER"
			},
			{
				"name": "projects",
				"salience": 0.00020381503,
				"type": "OTHER"
			},
			{
				"name": "Special Immigrant Visa",
				"salience": 0.0002013276,
				"type": "OTHER"
			},
			{
				"name": "Diversity Recruitment and Staffing",
				"salience": 0.00019965872,
				"type": "OTHER"
			},
			{
				"name": "Pentagon Renovation Program",
				"salience": 0.00019965872,
				"type": "OTHER"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.00019804417,
				"type": "ORGANIZATION"
			},
			{
				"name": "BUSINESS CORPORATION",
				"salience": 0.00019679934,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.00019103375,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00019103375,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.00019103375,
				"type": "PERSON"
			},
			{
				"name": "authentication",
				"salience": 0.00019103375,
				"type": "OTHER"
			},
			{
				"name": "server authentication",
				"salience": 0.00019103375,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.00019103375,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00019103375,
				"type": "PERSON"
			},
			{
				"name": "disclosure",
				"salience": 0.00019103375,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00019103375,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.00019103375,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00019103375,
				"type": "OTHER"
			},
			{
				"name": "primitives",
				"salience": 0.00018706197,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "adjudication",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "shelves",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00018470385,
				"type": "PERSON"
			},
			{
				"name": "fees",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "paperwork",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "Agreements",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "fiancé",
				"salience": 0.00018470385,
				"type": "PERSON"
			},
			{
				"name": "file rooms",
				"salience": 0.00018470385,
				"type": "LOCATION"
			},
			{
				"name": "Yours",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "mentoring goals",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "filing",
				"salience": 0.00018470385,
				"type": "EVENT"
			},
			{
				"name": "inception",
				"salience": 0.00018470385,
				"type": "EVENT"
			},
			{
				"name": "utilization",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "embassies",
				"salience": 0.00018470385,
				"type": "LOCATION"
			},
			{
				"name": "preprocessing",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "airline",
				"salience": 0.00018470385,
				"type": "ORGANIZATION"
			},
			{
				"name": "honey-pots",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "military pilot",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "dreams",
				"salience": 0.00018470385,
				"type": "OTHER"
			},
			{
				"name": "logging",
				"salience": 0.00018470385,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/028j0m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minority_group"
				},
				"name": "Minority",
				"salience": 0.00018026376,
				"type": "ORGANIZATION"
			},
			{
				"name": "Disabled Veteran",
				"salience": 0.00018026376,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dfb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citigroup"
				},
				"name": "Citigroup",
				"salience": 0.00018026376,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mentor Protégé",
				"salience": 0.00017736998,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "jurisdictions",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "Web users",
				"salience": 0.00017647627,
				"type": "PERSON"
			},
			{
				"name": "aspects",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "schemes",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00017647627,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00017521023,
				"type": "OTHER"
			},
			{
				"name": "handling.",
				"salience": 0.00017412983,
				"type": "OTHER"
			},
			{
				"name": "concurrence",
				"salience": 0.00017412983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02q26r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_of_Professional_Responsibility"
				},
				"name": "OPR",
				"salience": 0.00017288131,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "DHS",
				"salience": 0.00017288131,
				"type": "ORGANIZATION"
			},
			{
				"name": "file number",
				"salience": 0.00017193473,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03b9f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_jury"
				},
				"name": "Grand Juries",
				"salience": 0.00017146431,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dth9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Information_Systems_Agency"
				},
				"name": "Defense Information Systems Agency",
				"salience": 0.00016496044,
				"type": "ORGANIZATION"
			},
			{
				"name": "Vendors",
				"salience": 0.00016354186,
				"type": "ORGANIZATION"
			},
			{
				"name": "exchange",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "recognition",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "government implementations",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "algorithms",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00015933317,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y07",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secretary_of_State"
				},
				"name": "Secretary of State",
				"salience": 0.00015738857,
				"type": "PERSON"
			},
			{
				"name": "MWBD",
				"salience": 0.0001560839,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.0001560839,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.0001560839,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_hj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Aviation_Administration"
				},
				"name": "FAA",
				"salience": 0.0001560839,
				"type": "ORGANIZATION"
			},
			{
				"name": "MCI",
				"salience": 0.0001560839,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.00015534133,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.00015464718,
				"type": "OTHER"
			},
			{
				"name": "Mentor Protégé Team Award",
				"salience": 0.00015217347,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.00015077273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0262dl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Private_company_limited_by_shares"
				},
				"name": "Ltd.",
				"salience": 0.00014649073,
				"type": "LOCATION"
			},
			{
				"name": "COM",
				"salience": 0.00014539488,
				"type": "ORGANIZATION"
			},
			{
				"name": "Field McConnell",
				"salience": 0.00014539488,
				"type": "PERSON"
			},
			{
				"name": "pioneers",
				"salience": 0.00013796074,
				"type": "PERSON"
			},
			{
				"name": "privacy",
				"salience": 0.00013796074,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.00013796074,
				"type": "OTHER"
			},
			{
				"name": "signature",
				"salience": 0.00013796074,
				"type": "OTHER"
			},
			{
				"name": "entrepreneurs",
				"salience": 0.00013796074,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.00013796074,
				"type": "OTHER"
			},
			{
				"name": "Web URLs",
				"salience": 0.00013796074,
				"type": "OTHER"
			},
			{
				"name": "web browsers",
				"salience": 0.00013796074,
				"type": "OTHER"
			},
			{
				"name": "e-commerce",
				"salience": 0.00013796074,
				"type": "OTHER"
			},
			{
				"name": "predecessors",
				"salience": 0.00013796074,
				"type": "PERSON"
			},
			{
				"name": "spread",
				"salience": 0.00013796074,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.00013622158,
				"type": "OTHER"
			},
			{
				"name": "David Hawkins Tel",
				"salience": 0.00013127094,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07cx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Telephone"
				},
				"name": "Tel",
				"salience": 0.00013127094,
				"type": "LOCATION"
			},
			{
				"name": "guidelines",
				"salience": 0.00013113453,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02c3wh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Bar_Association"
				},
				"name": "American Bar Association",
				"salience": 0.00012913001,
				"type": "ORGANIZATION"
			},
			{
				"name": "Operating procedures",
				"salience": 0.00012016516,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00011901041,
				"type": "OTHER"
			},
			{
				"name": "Taher Elgamal",
				"salience": 0.00011807187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0828v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Wide_Web"
				},
				"name": "World Wide Web",
				"salience": 0.00011755792,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.000113662565,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g8fs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Naval_Academy"
				},
				"name": "United States Naval Academy",
				"salience": 0.000113662565,
				"type": "ORGANIZATION"
			},
			{
				"name": "CSI Crime and Safety Investigation",
				"salience": 0.000113662565,
				"type": "OTHER"
			},
			{
				"name": "SIV",
				"salience": 0.000113662565,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09lhr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Departments_of_France"
				},
				"name": "Department",
				"salience": 0.000113662565,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0mn8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portsmouth,_Virginia"
				},
				"name": "Portsmouth",
				"salience": 0.000113662565,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Va.",
				"salience": 0.000113662565,
				"type": "LOCATION"
			},
			{
				"name": "Rosslyn",
				"salience": 0.000113662565,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/026vq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Services_Administration"
				},
				"name": "GSA",
				"salience": 0.000113662565,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.000113662565,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0htyj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ron_Rivest"
				},
				"name": "Rivest",
				"salience": 0.00010859939,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00010185339,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.000097521486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07srw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Utah"
				},
				"name": "Utah",
				"salience": 0.00008489747,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05j3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netscape"
				},
				"name": "Netscape",
				"salience": 0.00008489747,
				"type": "ORGANIZATION"
			},
			{
				"name": "Adleman",
				"salience": 0.00008489747,
				"type": "PERSON"
			},
			{
				"name": "Shamir",
				"salience": 0.00008489747,
				"type": "PERSON"
			},
			{
				"name": "Hellman",
				"salience": 0.00008489747,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02786t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whitfield_Diffie"
				},
				"name": "Diffie",
				"salience": 0.00008489747,
				"type": "PERSON"
			},
			{
				"name": "Common Access Cards",
				"salience": 0.00008489747,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.00007042753,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T23:54:43.950+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 72.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "United States Marine Field McConnell  Plum City Online - ( AbelDanger.net )  October 29, 2016 \n1. Abel Danger ( AD ) claims that Antony Wiener, Huma Abedin and Michelle Obama ('WHO') have been leaking classified information and pornographic images of torture killings to spies allegedly embedded by the Clinton Foundation in the Federal Bridge Certification Authority network. \n\n2. AD claims that former Secretary of State Hillary Clinton authorized Serco operatives at the Defense Ammunition Center to ship ammo, RPGs, mortars and training equipment to an annex in Benghazi and prepare for the expansion of the ISIS command network into Iraq and Syria. \n\n3. AD claims that on 9/11-12/2012, Serco 8(a) operatives of the Defense Red Switch Network stood down first responders to a Zulu-timed mortar attack on the annex and prepared the stage for the production of a phony propaganda snuff film \"13 Hours\". \n\n4. United States Marine Field McConnell – Global Operations Director of Abel Danger – has offered to serve as a five-star general in a Trump administration to help Trump destroy the Clinton bridge of spies and return the Red Switch to a legitimate commander-in-chief.\n\n13 Hours The Secret Soldiers of Benghazi Official Trailer #1 (2016) Michael Bay Movie HD    \nTrump on Huma Abedin, Anthony Weiner, Hillary Clinton; 8-28-2015  \n    \nFBI reopens Clinton investigation as new emails found ‒ Comey \n\nHillary Clinton vs. James Comey: Email Scandal Supercut  \nCopy of SERCO GROUP PLC: List of Subsidiaries AND Shareholders! [Note British and Saudi Governments, AXA, HSBC , Teachers' and Gold man Sachs]    \nDefense Ammunition Center [Outsourced to Serco ]   \nSerco ... Would you like to know more?  \n\n\"Digital Fires Instructor Serco - Camp Pendleton, CA Uses information derived from all military disciplines (e.g., aviation, ground combat, command and control, combat service support, intelligence, and opposing forces) to determine changes in enemy capabilities, vulnerabilities, and probable courses of action.\" \n\n\"Benghazi consulate attackers used military-style tactics, say US officials  \nExperts still unsure whether assault that killed 4 Americans in Libya could have been prevented  \nBY MATT APUZZO AND KIMBERLY DOZIER   \nSeptember 22, 2012, 1:44 am 1 WASHINGTON (AP) — The heavily armed extremists who laid siege to the US Consulate in Libya used military-style tactics that may have steered Americans toward a waiting ambush, US officials said Friday as they pieced together details about how the compound was overrun. \n\nUS intelligence indicates that 50 or more people, many of them masked, were responsible for the Sept. 11 assault on the US diplomatic mission in Benghazi. Gun trucks provided added firepower. The attackers set up a perimeter, controlling access in and out of the compound. A first wave of attacks sent the Americans fleeing to a fallback building, where a second group of extremists beset them with precise mortar fire. \n\nIntelligence reports were still coming in, but officials told The Associated Press that what may have initially seemed like a protest over an anti-Islam movie that had spun out of control now showed the hallmarks of a more sophisticated operation. \n\nIn a country coming off a civil war, a level of battlefield savvy does not prove the attack on the compound was planned well in advance. How much planning went into the operation and whether it could have been detected or prevented remain unanswered questions, officials said. \n\nThe attacks killed Ambassador Chris Stevens, diplomat Sean Smith and two former Navy SEALs, who US officials said were security officers guarding diplomatic officials. Stevens was visiting Benghazi from Tripoli to preside over the opening of an “American Space” cultural center. \n\nThe officials spoke on condition of anonymity because they were not authorized to discuss intelligence reports. They stressed that even now authorities do not have a clear understanding of exactly what happened in Benghazi. FBI agents from New York and Washington were in Libya investigating the attack. \n\n\"What happened in Benghazi was a terrorist attack,\" Secretary of State Hillary Clinton said Friday. \"And we will not rest until we have tracked down and brought to justice the terrorists who murdered four Americans.\" \n\nOfficials have not singled out one responsible group, but have focused their attention on Ansar al-Shariah, a Libyan militant group led by a former detainee at the US military-run prison in Guantanamo Bay, Cuba. \n\nSince the civil war that ousted Libyan dictator Moammar Gadhafi last year, the country has been awash with rebels, militias and terrorists. Weaponry is easy to come by, both from the former regime, from weapons depots looted during the war, and from foreign powers that armed the rebellion. The origin of the weapons used in the assault on the US compound was unclear, officials said.\" \n\n\"Mortar training device with functional simulated propelling charges  \nUS 6059573 A  \nABSTRACT  \nA full-size mortar training device which includes full-size, simulated, propelling charges is disclosed. Both 81 mm and 60 mm mortar training devices are disclosed. The device provides realistic training on virtually all aspects of mortar firing. The device allows training in target sight acquisition and mortar positioning (elevation and azimuth), sight reacquisition due to recoil, dropping a round, adjusting the number of charges, as required, to achieve a desired zone of firing distance, adjusting the projectile fuse setting to control time of explosion, provides realistic firing sound, and allows trainees to follow procedures similar to those used with standard mortar service ammunition. The device includes a cartridge projectile which contacts a pad within and at the lowermost point of the mortar barrel which is not propelled from the mortar barrel and which provides data to a computer system to determine if an area or object would have been impacted by the mortar projectile, provides analysis of trainee firing errors and provides for the simulation to be replayed for trainee instructional and other purposes. The 60 mm device includes a hand-held firing option and the 81 mm device includes a blast attenuator device to further enhance the realism of the simulation.\" \n\n\"Serco Processes 2 Millionth Patent Application for U.S. Patent and Trademark Office Date: 18 Mar 2013 Serco Inc., a leading provider of professional, technology, and management services to the federal government, announced today that their Pre-Grant Publication (PGPubs) Classification Services team recently processed their 2 millionth patent application for the U.S. Patent & Trademark Office (USPTO). Each application was also processed within the contractually required 28-day window.\" \n\n\"An Angry John Podesta Issues A Statement On \"Reopening\" Of FBI Probe   \nby Tyler Durden   \nOct 28, 2016 3:57 PM While Hillary has yet to address today's stunning letter by FBI director Comey, who reported that the Federal Bureau of Investigations has \"opened\" a probe into Hillary Clinton's email as a result of \"findings\" on what the NYT reported was an electronic device belonging to Anthony Wiener, a clearly angry John Podesta, Clinton's recently hacked campaign chair, issued the following statement in Response to FBI Letter to GOP Congressional Chairmen. \n\nIn response to the letter sent by FBI Director James Convey to eight Republican committee chairman in Congress, Hillary for America Chair John Podesta released the following statement Friday: \n\nUpon completing this investigation more than three months ago, FBI Director Comet' declared no reasonable prosecutor would move forward with a case like this and added that it was not even a close call. In the months since, Donald Trump and his Republican allies have been baselessly second-guessing the FBI and, in both public and private, browbeating the career officials there to revisit their conclusion in a desperate attempt to harm Hillary Clinton's presidential campaign.\" \n\n\"BREAKING: @HillaryClinton's E-Mail Server Company Got Almost $1 Million In Gov't Loans After Wiping E-Mails   \nOCTOBER 26, 2016  \nBY CHARLES C. JOHNSON 6 COMMENTS  \nGive it up already. It's over. K. J. Gillenwater was the primary researcher behind this story. \n\nHillary Clinton's e-mail server company got almost $1 million in government loans starting immediately after they were secretly asked to wipe Hillary Clinton's name from her e-mails. \n\nPlatte River Networks (PRN) got a $493,000 loan from the Small Business Administration in August 2014 and another $350,000 loan in September 2015: \n\nPublic government data available as USAspending.gov \n\nThe first half-million dollar loan arrived not one month after PRN employee Paul Combetta was caught accidentally revealing his company was deleting evidence at Hillary's request in July 2014 . \n\nThe second $350,000 loan came about one year later. \n\nYou won't hear this stuff from the lying mainstream media. Keep the GotNews mission alive: donate at GotNews.com/donate or send tips to editor@gotnews.com. If you'd like to join our research team, contacteditor@gotnews.com. \n\nAfter getting the first loan, PRN moved to a large office space after previously working out of the owner’s condo. The head of the Small Business Administration is Maria Contreras-Sweet , a Mexican immigrant who was appointed to the office by Barack Obama two months before Hillary's PRN got the first loan. \n\nWikiLeaks leaks have proven Hillary's corrupt pay-to-play scheme. GotNews has shined a light on how Hillary gets favors from Hispanic and Democratic government bureaucrats before . \n\nDid Hillary Clinton pay her e-mail server company Platte River Networks (PRN) with almost $1 million in favorable government loans — given out by a political friendly — in order to alter her illegal e-mails and get her name off them? \n\nIt sure looks like it. \n\nA Freedom of Information Act (FOIA) request has been lodged for more information. \n\nStay tuned for more. \n\nK. J. Gillenwater was the primary researcher behind this story.\"  \n\n\"Super Serco bulldozes ahead  \nBy DAILY MAIL REPORTER UPDATED: 23:00 GMT, 1 September 2004 \nSERCO has come a long way since the 1960s when it ran the 'four-minute warning' system to alert the nation to a ballistic missile attack. \n\nToday its £10.3bn order book is bigger than many countries' defence budgets. It is bidding for a further £8bn worth of contracts and sees £16bn of 'opportunities'. \n\nProfit growth is less ballistic. The first-half pre-tax surplus rose 4% to £28.1m, net profits just 1% to £18m. Stripping out goodwill, the rise was 17%, with dividends up 12.5% to 0.81p. \n\nSerco runs the Docklands Light Railway, five UK prisons, airport radar and forest bulldozers in Florida.\"  \n\n\" Serco farewell to NPL after 19 years of innovation 8 January 2015 Serco said goodbye to the National Physical Laboratory (NPL) at the end of December 2014 after 19 years of extraordinary innovation and science that has seen the establishment build a world-leading reputation and deliver billions of pounds of benefit for the UK economy. During that period under Serco 's management and leadership, NPL has delivered an extraordinary variety and breadth of accomplishments for the UK's economy and industry. Some of the key achievements during that time have been:… It has been estimated that work carried out by the Centre of Carbon Measurement at NPL will save eight million tonnes of carbon emissions reductions (2% of UK footprint) and over half a billion pounds in economic benefit over the next decade…. NPL's caesium fountain atomic clock is accurate to 1 second in 158 million years and NPL is playing a key role in introducing rigour to high frequency trading [for Serco 's front running banks] in the City through NPL [Zulu] Time.\" \n\n\"UK Cabinet Office – Emergency Planning College – Serco …..Types of Exercise Workshop Exercises These are structured discussion events where participants can explore issues in a less pressurised environment. They are an ideal way of developing solutions, procedures and plans rather than the focus being on decision making. Table Top Exercises These involve a realistic scenario and will follow a time line, either in real-time or with time jumps to concentrate on the more important areas. The participants would be expected to be familiar with the plans and procedures that are being used although the exercise tempo and complexity can be adjusted to suit the current state of training and readiness. Simulation and media play can be used to support the exercise. Table-top exercises help develop teamwork and allow participants to gain a better understanding of their roles and that of other agencies and organisations. Command/Control Post Exercises These are designed primarily to exercise the senior leadership and support staff in collective planning and decision making within a strategic grouping. Ideally such exercises would be run from the real command and control locations and using their communications and information systems [Feeling lucky, Punk?] . This could include a mix of locations and varying levels of technical simulation support. The Gold Standard system is flexible to allow the tempo and intensity to be adjusted to ensure maximum training benefit, or to fully test and evaluate the most important aspects of a plan. Such exercises also test information flow, communications, equipment, procedures, decision making and coordination. Live Exercises These can range from testing individual components of a system or organisation through to a full-scale rehearsal. They are particularly useful where there are regulatory requirements or with high-risk situations. They are more complex and costly to organise and deliver but can be integrated with Command Post Exercises as part of a wider exercising package.\"  \n\n\"Christopher Rajendran Hyman CBE (born 5 July 1963 in Durban, South Africa)[1] was Chief Executive of Serco Group plc from 2002 to October 2013.[2] … On graduation, he worked for Arthur Andersen. In 1989, he won an 18-month exchange with Ernst & Young in London, who employed him after four months.[1] Head hunted in 1994 by Serco , Hyman became European finance director, and in 1999 was made group finance director. In 2002, Hyman became chief executive. .. Hyman resigned from his role of Chief Executive of Serco on 25 October 2013 following allegations that Serco had overcharged government customers. .. He was [making a presentation to Serco shareholder, including British and Saudi governments] on the 47th floor of the World Trade Center [North Tower] at the time of the September 11 attacks in 2001.\" \n\n\"July 7, 2016 Developments in PKI occurred in the early 1970s at the British intelligence agency GCHQ , where James Ellis , Clifford Cocks and others made important discoveries related to encryption algorithms and key distribution.[ 19 ] However, as developments at GCHQ are highly classified, the results of this work were kept secret and not publicly acknowledged until the mid-1990s. \n\nThe public disclosure of both secure key exchange and asymmetric key algorithms in 1976 by Diffie, Hellman , Rivest, Shamir , and Adleman changed secure communications entirely. With the further development of high-speed digital electronic communications (the Internet and its predecessors), a need became evident for ways in which users could securely communicate with each other, and as a further consequence of that, for ways in which users could be sure with whom they were actually interacting. \n\nAssorted cryptographic protocols were invented and analyzed within which the new cryptographic primitives could be effectively used. With the invention of the World Wide Web and its rapid spread, the need for authentication and secure communication became still more acute. Commercial reasons alone (e.g., e-commerce, online access to proprietary databases from web browsers) were sufficient. Taher Elgamal and others at Netscape developed the SSL protocol ('https' in Web URLs); it included key establishment, server authentication (prior to v3, one-way only), and so on. A PKI structure was thus created for Web users/sites wishing secure communications. \n\nVendors and entrepreneurs saw the possibility of a large market, started companies (or new projects at existing companies), and began to agitate for legal recognition and protection from liability. An American Bar Association technology project published an extensive analysis of some of the foreseeable legal aspects of PKI operations (see ABA digital signature guidelines), and shortly thereafter, several U.S. states (Utah being the first in 1995) and other jurisdictions throughout the world began to enact laws and adopt regulations. Consumer groups raised questions about privacy, access, and liability considerations, which were more taken into consideration in some jurisdictions than in others. \n\nThe enacted laws and regulations differed, there were technical and operational problems in converting PKI schemes into successful commercial operation, and progress has been much slower than pioneers had imagined it would be. \n\nBy the first few years of the 21st century, the underlying cryptographic engineering was clearly not easy to deploy correctly. Operating procedures (manual or automatic) were not easy to correctly design (nor even if so designed, to execute perfectly, which the engineering required). The standards that existed were insufficient. \n\nPKI vendors have found a market, but it is not quite the market envisioned in the mid-1990s, and it has grown both more slowly and in somewhat different ways than were anticipated.[20] PKIs have not solved some of the problems they were expected to, and several major vendors have gone out of business or been acquired by others. PKI has had the most success in government implementations; the largest PKI implementation to date is the Defense Information Systems Agency (DISA) PKI infrastructure for the Common Access Cards program.\"  \n\nBase One Technologies – Corporate Strategy – We are a Government Certified Women-Owned Business   \nWe practice Diversity Recruitment and Staffing for IT positions Base One was founded in 1994 by a women engineer who had made a career in technology research for many years. Base One has been very successful in focusing on diversity recruiting and staffing for IT projects. It has been our experience that the greater the diversity mix, the more creative the solution. As in any field the more diverse the viewpoint the more thorough your analysis. Our engineers can think out of the box. \n\nBecause of our affiliations we have access to pools of resources among more diverse groups & individuals. We work with a large pool of minority professionals who specialize in IT skills. We are able to have access to these resources through our status as a D/MWBD firm and our affiliations. These affiliations assist us in working with resources among more diverse groups & individuals. We are also partnered with firms that are 8A certified as Minority firms, Disabled Veteran firms, Native American firms, Vietnam veteran firms, women owned firms. \n\nOur hub zone location keeps us close to the professional organizations of great diversity. We are active in recruiting from and networking with these community organizations of local IT professionals. This has given us access to a large pool of diversity talent. \n\nBase One's staff of engineers are a diverse group of professionals. This diverse network of engineers helps us to branch out to other engineers and creates an even larger network of resources for us to work with. \n\nThe greater the diversity the more complete & thorough the analysis. The broader the spectrum of points of view the broader the scope of the analysis. We feel that a diverse team gives us a greater advantage in creating cutting edge solutions. To that end we will continue to nurture these relationships to further extend our talent pool. \n\nThe greater the diversity mix, the more creative the solution. \n\nThe more diverse the viewpoint, the more thorough the analysis. \n\nThe more diverse our team, the more our engineers can think out of the box. \n\nThis is why Base One Technologies concentrates on diversity recruitment in the belief that a diverse team gives us a greater advantage in creating cutting edge solutions.\" \n\nInformation Security Planning is the process whereby an organization seeks to protect its operations and assets from data theft or computer hackers that seek to obtain unauthorized information or sabotage business operations. \n\nKey Clients Benefiting From Our Information Security Expertise: Pentagon Renovation Program, FAA, Citigroup, MCI. \n\nBase One Technologies \n\nExpertly researches, designs, and develops information security policies that protect your data and manage your firm's information technology risk at levels acceptable to your business. \n\nPerforms architectural assessments and conducts both internal and external penetration testing. The results of these efforts culminate in an extensive risk analysis and vulnerabilities report. \n\nDevelops, implements and supports Information Security Counter measures such as honey-pots and evidence logging and incident documentation processes and solutions.\" \n\n\"Base One Technologies, Ltd. is a DOMESTIC BUSINESS CORPORATION, located in New York, NY and was formed on Feb 15, 1994. This file was obtained from the Secretary of State and has a file number of 1795583. \" \n\n\"Serco's Office of Partner Relations (OPR) helps facilitate our aggressive small business utilization and growth strategies. Through the OPR, Serco mentors four local small businesses under formal Mentor Protégé Agreements: Three sponsored by DHS (Base One Technologies, TSymmetry, Inc., and HeiTech Services, Inc.,) and the fourth sponsored by GSA (DKW Communications, Inc.). Serco and HeiTech Services were awarded the 2007 DHS Mentor Protégé Team Award for exceeding our mentoring goals.\" http://www.dtic.mil/whs/directives/corres/pdf/100515p.pdf \n\n\"Opened in 1994 as the successor to the Transitional Immigrant Visa Processing Center in Rosslyn, Va., the NVC centralizes all immigrant visa pre-processing and appointment scheduling for overseas posts. The NVC collects paperwork and fees before forwarding a case, ready for adjudication, to the responsible post. \n\nThe center also handles immigrant and fiancé visa petitions, and while it does not adjudicate visa applications, it provides technical assistance and support to visa-adjudicating consular officials overseas. \n\nOnly two Foreign Service officers, the director and deputy director, work at the center, along with just five Civil Service employees. They work with almost 500 contract employees doing preprocessing of visas, making the center one of the largest employers in the Portsmouth area. \n\nThe contractor, Serco , Inc., has worked with the NVC since its inception and with the Department for almost 18 years. \n\nThe NVC houses more than 2.6 million immigrant visa files, receives almost two million pieces of mail per year and received more than half a million petitions from the U.S. Citizenship and Immigration Service (USCIS) in 2011. Its file rooms' high-density shelves are stacked floor-to-ceiling with files, each a collection of someone’s hopes and dreams and each requiring proper handling. …. \n\nThe NVC also preprocesses the chief of mission (COM) application required for the filing of a petition for a Special Immigrant Visa (SIV). Such visas, for foreign nationals who have performed services for the U.S. government in Iraq and Afghanistan, require COM concurrence before the applicant can file a petition with USCIS. The NVC collects the requisite documents from such applicants and, when complete, forwards the package to the U.S. embassies in Baghdad or Kabul for COM approval\" \n\nYours sincerely, \n\nField McConnell, United States Naval Academy, 1971; Forensic Economist; 30 year airline and 22 year military pilot; 23,000 hours of safety; Tel: 715 307 8222 \n\nDavid Hawkins Tel: 604 542-0891 Forensic Economist; former leader of oil-well blow-out teams; now sponsors Grand Juries in CSI Crime and Safety Investigation \n",
		"thread_title": "",
		"title": "",
		"type": "bs",
		"uuid": "c0934278c651e872ae8aef084b8f23f128bb2ad3"
	},
	"-KhI_gvj-OOr7aAlkERR": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T01:08:16.887+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.26169875,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07kf3pg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zero_Hedge"
				},
				"name": "Zero Hedge",
				"salience": 0.12378567,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.079981714,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.045989767,
				"type": "ORGANIZATION"
			},
			{
				"name": "Source",
				"salience": 0.038523614,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.02755973,
				"type": "PERSON"
			},
			{
				"name": "tens of thousands",
				"salience": 0.024524884,
				"type": "PERSON"
			},
			{
				"name": "reasons",
				"salience": 0.022843394,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.019801177,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email probe",
				"salience": 0.019801177,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/042h9p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fight_Club_(novel)"
				},
				"name": "Tyler Durden",
				"salience": 0.01221875,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.01221875,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/043g3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Janet_Reno"
				},
				"name": "Janet Reno",
				"salience": 0.010895657,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.010457313,
				"type": "WORK_OF_ART"
			},
			{
				"name": "evidence",
				"salience": 0.010336348,
				"type": "OTHER"
			},
			{
				"name": "core reasons",
				"salience": 0.009444916,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.009444916,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.009209069,
				"type": "OTHER"
			},
			{
				"name": "obligation",
				"salience": 0.008181721,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.008181721,
				"type": "OTHER"
			},
			{
				"name": "email discovery",
				"salience": 0.008181721,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.008181721,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.008181721,
				"type": "OTHER"
			},
			{
				"name": "lawmakers",
				"salience": 0.008181721,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.008181721,
				"type": "OTHER"
			},
			{
				"name": "notebook",
				"salience": 0.008181721,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "anything",
				"salience": 0.0077277604,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New Yorker",
				"salience": 0.0070994934,
				"type": "LOCATION"
			},
			{
				"name": "preference",
				"salience": 0.0066277827,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.006380839,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0060387547,
				"type": "OTHER"
			},
			{
				"name": "official",
				"salience": 0.0059936773,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0057405718,
				"type": "EVENT"
			},
			{
				"name": "revelations",
				"salience": 0.0057405718,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0057405718,
				"type": "OTHER"
			},
			{
				"name": "tarmac",
				"salience": 0.0057405718,
				"type": "LOCATION"
			},
			{
				"name": "contravention",
				"salience": 0.005526618,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.005526618,
				"type": "WORK_OF_ART"
			},
			{
				"name": "coverup",
				"salience": 0.005526618,
				"type": "OTHER"
			},
			{
				"name": "Attorney General",
				"salience": 0.0054125623,
				"type": "PERSON"
			},
			{
				"name": "preference",
				"salience": 0.0054125623,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.0053444603,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.005277213,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.005040503,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.005040503,
				"type": "PERSON"
			},
			{
				"name": "official",
				"salience": 0.0049568936,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0048481235,
				"type": "EVENT"
			},
			{
				"name": "action",
				"salience": 0.004737919,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0046877465,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.004344695,
				"type": "WORK_OF_ART"
			},
			{
				"name": "outcome",
				"salience": 0.0040447596,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0036088843,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0syvm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix_Sky_Harbor_International_Airport"
				},
				"name": "Phoenix",
				"salience": 0.0035353801,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0035321207,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0035321207,
				"type": "EVENT"
			},
			{
				"name": "appearance",
				"salience": 0.0035028772,
				"type": "OTHER"
			},
			{
				"name": "meddling",
				"salience": 0.0035028772,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0035028772,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/058_1w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jane_Mayer"
				},
				"name": "Jane Mayer",
				"salience": 0.003403513,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027l24_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Administration_(law)"
				},
				"name": "Administration",
				"salience": 0.0028865633,
				"type": "ORGANIZATION"
			},
			{
				"name": "official",
				"salience": 0.0028386456,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0026390657,
				"type": "EVENT"
			},
			{
				"name": "target",
				"salience": 0.0025516967,
				"type": "OTHER"
			},
			{
				"name": "prosecutors",
				"salience": 0.0022014629,
				"type": "PERSON"
			},
			{
				"name": "outcome",
				"salience": 0.0022014629,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.0019063585,
				"type": "EVENT"
			},
			{
				"name": "law enforcement",
				"salience": 0.0019063585,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T01:08:16.887+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Source: Zero Hedge \n\nby Tyler Durden\nOct 29, 2016 \n\nLast night a leaked memo was revealed, indicating FBI director James Comey's stated reasons for reopening the Clinton email probe upon discovering what now appear to be tens of thousands of Huma Abedin emails located on Anthony Weiner's notebook. Comey revealed two core reasons for the action: a sense of obligation to lawmakers and a concern that word of the new email discovery would leak to the media and raise questions of a coverup. What he did not reveal, and as has emerged overnight from a report by the New Yorker's Jane Mayer, is that Comey also acted in contravention to DOJ practices, and more importantly, acted contrary to the \"preference\" of DOJ head Loretta Lynch, whose infamous meeting with Bill Clinton on the Phoenix tarmac at the end of June will likely be reassessed in light of these latest revelations. \n\n\nAccording to the New Yorker, \"Comey's decision to make public new evidence that may raise additional legal questions about Clinton was contrary to the views of the Attorney General, according to a well-informed Administration official. Lynch expressed her preference that Comey follow the department's longstanding practice of not commenting on ongoing investigations, and not taking any action that could influence the outcome of an election, but he said that he felt compelled to do otherwise. \" \nTraditionally, the Justice Department has advised prosecutors and law enforcement to avoid any appearance of meddling in the outcome of elections, even if it means holding off on pressing cases . One former senior official recalled that Janet Reno, the Attorney General under Bill Clinton, \"completely shut down the prosecution of a politically sensitive criminal target prior to an election . \"She was adamant—anything that could influence the election had to go dark,\" the former official said. Please go to Zero Hedge to read the entire article. ",
		"thread_title": "DOJ's Loretta Lynch Tried To Squash Comey's Letter To Congress",
		"title": "DOJ's Loretta Lynch Tried To Squash Comey's Letter To Congress",
		"type": "bs",
		"uuid": "eb054fba367975664dc134e494c96fafd31de3ef"
	},
	"-KhI_h4dk9brHlG1ET1H": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T01:47:42.720+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "idea",
				"salience": 0.39500305,
				"type": "OTHER"
			},
			{
				"name": "faces",
				"salience": 0.27349466,
				"type": "OTHER"
			},
			{
				"name": "clip",
				"salience": 0.23383021,
				"type": "WORK_OF_ART"
			},
			{
				"name": "movie",
				"salience": 0.09767206,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-29T21:04:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Its not a bad idea paiting their faces same as that on the clip  , its very polular movie and could catch on quick .",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "",
		"type": "bs",
		"uuid": "274d5ad06a90ac9358ef21375b00e09f1f05726d"
	},
	"-KhI_h9HyYqTJ9r2ZA6Y": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T01:47:43.275+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07qb5ct"
				},
				"name": "Hell",
				"salience": 0.47726858,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.37270054,
				"type": "EVENT"
			},
			{
				"name": "UGLY UN",
				"salience": 0.056193843,
				"type": "PERSON"
			},
			{
				"name": "guy",
				"salience": 0.02318448,
				"type": "PERSON"
			},
			{
				"name": "net",
				"salience": 0.016559629,
				"type": "OTHER"
			},
			{
				"name": "clips",
				"salience": 0.015947098,
				"type": "WORK_OF_ART"
			},
			{
				"name": "TV",
				"salience": 0.015947098,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.015947098,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016lh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ron_Paul"
				},
				"name": "Ron Paul",
				"salience": 0.006251637,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-29T20:55:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Hell thats a good speech , maybe there is more to him than we know . he only needs to puts clips of that speech on TV everywhere on the net and he will succeed . Now he just has to watch out for the UGLY  UN who is behind it all . What are those who were behind Ron Paul etc waiting for , this is the guy you have to vote for this time .",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "",
		"type": "bs",
		"uuid": "c47fb48f708e4fd39e4e23d03ccb710c62ce3d14"
	},
	"-KhI_hDBvBPH2D8t6jxh": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T01:47:44.166+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "o1takU08aOI",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-10-29T10:02:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Draining the swamp - youtube.com/watch?v=o1takU08aOI",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "",
		"type": "bs",
		"uuid": "c2b527f6f19a09e9d9ee814f69b4388aaa64d32c"
	},
	"-KhI_hGnluSYohgXUdGU": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T01:47:44.808+02:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-10-29T09:34:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.8
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Brilliant!",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "",
		"type": "bs",
		"uuid": "13b2a3aa1853d50f8f4353986fa702ce50ab0a0d"
	},
	"-KhI_hPR1P9s3IuubeYv": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T02:45:32.694+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "DARK",
				"salience": 0.21281576,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.19354743,
				"type": "PERSON"
			},
			{
				"name": "twist",
				"salience": 0.1113715,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.1113715,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.083443336,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.046541885,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.044629052,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.043522358,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.032733653,
				"type": "LOCATION"
			},
			{
				"name": "corruption",
				"salience": 0.032733653,
				"type": "OTHER"
			},
			{
				"name": "reptutation",
				"salience": 0.031520277,
				"type": "OTHER"
			},
			{
				"name": "voting booths",
				"salience": 0.02675794,
				"type": "LOCATION"
			},
			{
				"name": "slaves",
				"salience": 0.020017955,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "KKK",
				"salience": 0.008993689,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-29T22:36:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "iTS DARK ALRIGHT . In a sad twist of fate these black people in power are doing more to damage black people &#39;s reptutation than any white people ever could . Whats wrong with them ?? Where are they in the streets complaing about corruption ???? Where are they at the voting booths voting against it ?? Thats what you get when you back the very people who fought  hard to keep them slaves and i might add where the KKK  . They need to wake up  fast .",
		"thread_title": "DOJ's Loretta Lynch Tried To Squash Comey's Letter To Congress",
		"title": "",
		"type": "bs",
		"uuid": "ba61d877c7b6ba8bb9bbf0de7b540f8ceb8a23ba"
	},
	"-KhI_hTa1Gahykxgg48v": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T02:45:32.702+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.5304225,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.20596017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "corruption",
				"salience": 0.073762685,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.05991357,
				"type": "PERSON"
			},
			{
				"name": "arguments",
				"salience": 0.049197897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.035964232,
				"type": "LOCATION"
			},
			{
				"name": "infrmants",
				"salience": 0.019070756,
				"type": "PERSON"
			},
			{
				"name": "provications",
				"salience": 0.013926255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.011781951,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-29T22:25:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "The second video (bottom one ) proves what Trump is sayng is true , corruption with the Clinton gang is rife , he could use this in his arguments . http://www.opb.org/news/series/burns-oregon-standoff-bundy-militia-news-updates/ammon-bundy-verdict-oregon-standoff-malheur-court/   And lets not forget there were 15 undercover FBI infrmants doing the provications = set up . ",
		"thread_title": "DOJ's Loretta Lynch Tried To Squash Comey's Letter To Congress",
		"title": "",
		"type": "bs",
		"uuid": "51885985bf02be49ebfd1c78485babfd09c25f90"
	},
	"-KhI_hmQW0QBapt0SOHq": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T02:45:38.655+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "DARK",
				"salience": 0.21281576,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.19354743,
				"type": "PERSON"
			},
			{
				"name": "twist",
				"salience": 0.1113715,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.1113715,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.083443336,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.046541885,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.044629052,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.043522358,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.032733653,
				"type": "LOCATION"
			},
			{
				"name": "corruption",
				"salience": 0.032733653,
				"type": "OTHER"
			},
			{
				"name": "reptutation",
				"salience": 0.031520277,
				"type": "OTHER"
			},
			{
				"name": "voting booths",
				"salience": 0.02675794,
				"type": "LOCATION"
			},
			{
				"name": "slaves",
				"salience": 0.020017955,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "KKK",
				"salience": 0.008993689,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-29T22:36:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "iTS DARK ALRIGHT . In a sad twist of fate these black people in power are doing more to damage black people &#39;s reptutation than any white people ever could . Whats wrong with them ?? Where are they in the streets complaing about corruption ???? Where are they at the voting booths voting against it ?? Thats what you get when you back the very people who fought  hard to keep them slaves and i might add where the KKK  . They need to wake up  fast .",
		"thread_title": "",
		"title": "",
		"type": "bs",
		"uuid": "926b9b1371903ad912ce189712d5ba5cfa1bf665"
	},
	"-KhI_hrVl1orgtShZ7H1": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T02:45:38.673+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.5304225,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.20596017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "corruption",
				"salience": 0.073762685,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.05991357,
				"type": "PERSON"
			},
			{
				"name": "arguments",
				"salience": 0.049197897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.035964232,
				"type": "LOCATION"
			},
			{
				"name": "infrmants",
				"salience": 0.019070756,
				"type": "PERSON"
			},
			{
				"name": "provications",
				"salience": 0.013926255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.011781951,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-29T22:25:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "The second video (bottom one ) proves what Trump is sayng is true , corruption with the Clinton gang is rife , he could use this in his arguments . http://www.opb.org/news/series/burns-oregon-standoff-bundy-militia-news-updates/ammon-bundy-verdict-oregon-standoff-malheur-court/   And lets not forget there were 15 undercover FBI infrmants doing the provications = set up . ",
		"thread_title": "",
		"title": "",
		"type": "bs",
		"uuid": "3ad02a79678325091fca526f388553b72a977561"
	},
	"-KhI_hw3I-_YEuAbwC-V": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T03:42:21.211+02:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "6",
		"participants_count": "1",
		"published": "2016-10-29T09:34:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.8
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Brilliant!",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "",
		"type": "bs",
		"uuid": "5876d2342903b7d1aa341d851073a7a9d3cbe253"
	},
	"-KhI_i8IUYj8JpKpDyJF": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T07:28:30.846+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.5304225,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.20596017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "corruption",
				"salience": 0.073762685,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.05991357,
				"type": "PERSON"
			},
			{
				"name": "arguments",
				"salience": 0.049197897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.035964232,
				"type": "LOCATION"
			},
			{
				"name": "infrmants",
				"salience": 0.019070756,
				"type": "PERSON"
			},
			{
				"name": "provications",
				"salience": 0.013926255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.011781951,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-29T22:25:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "The second video (bottom one ) proves what Trump is sayng is true , corruption with the Clinton gang is rife , he could use this in his arguments . http://www.opb.org/news/series/burns-oregon-standoff-bundy-militia-news-updates/ammon-bundy-verdict-oregon-standoff-malheur-court/   And lets not forget there were 15 undercover FBI infrmants doing the provications = set up . ",
		"thread_title": "DOJ's Loretta Lynch Tried To Squash Comey's Letter To Congress",
		"title": "",
		"type": "bs",
		"uuid": "74d341d65f684cebcc49eacab22d8fa2cd743c61"
	},
	"-KhI_igjGlE3p6pZ6Q6g": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T07:28:38.439+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.5304225,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.20596017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "corruption",
				"salience": 0.073762685,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.05991357,
				"type": "PERSON"
			},
			{
				"name": "arguments",
				"salience": 0.049197897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.035964232,
				"type": "LOCATION"
			},
			{
				"name": "infrmants",
				"salience": 0.019070756,
				"type": "PERSON"
			},
			{
				"name": "provications",
				"salience": 0.013926255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.011781951,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-29T22:25:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "The second video (bottom one ) proves what Trump is sayng is true , corruption with the Clinton gang is rife , he could use this in his arguments . http://www.opb.org/news/series/burns-oregon-standoff-bundy-militia-news-updates/ammon-bundy-verdict-oregon-standoff-malheur-court/   And lets not forget there were 15 undercover FBI infrmants doing the provications = set up . ",
		"thread_title": "",
		"title": "",
		"type": "bs",
		"uuid": "167eaade2362bfe3815ee8bef9bf67b9496dde70"
	},
	"-KhI_imv1ZunVwloaen9": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T07:28:42.279+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.25868928,
				"type": "PERSON"
			},
			{
				"name": "aLEX JONES",
				"salience": 0.19407563,
				"type": "PERSON"
			},
			{
				"name": "Gangster Statue",
				"salience": 0.15757048,
				"type": "WORK_OF_ART"
			},
			{
				"name": "PART",
				"salience": 0.10729831,
				"type": "OTHER"
			},
			{
				"name": "LAWS",
				"salience": 0.07329539,
				"type": "OTHER"
			},
			{
				"name": "NYC LOL https://youtu.be/HSSPQxR0d2g NOTE",
				"salience": 0.06698668,
				"type": "OTHER"
			},
			{
				"name": "HAIG -RACKET",
				"salience": 0.04728692,
				"type": "OTHER"
			},
			{
				"name": "READERS",
				"salience": 0.02892879,
				"type": "PERSON"
			},
			{
				"name": "EVERYWHERE",
				"salience": 0.024112292,
				"type": "LOCATION"
			},
			{
				"name": "AFFECT",
				"salience": 0.019222226,
				"type": "OTHER"
			},
			{
				"name": "CONTEST",
				"salience": 0.01316516,
				"type": "EVENT"
			},
			{
				"name": "HILARY FOR PRISON",
				"salience": 0.009368848,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-30T01:37:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Hillary Clinton Life Sized Gangster Statue Visits NYC  LOL https://youtu.be/HSSPQxR0d2g   NOTE CLINTON WROTE PART OF THE LAWS FOR THE HAIG -RACKET . https://youtu.be/Jljuppo7Qxk  aLEX JONES SHOULD GET ALL HIS READERS OUT THERE IN A CONTEST WITH PLASTIC GUMMIES HILARY FOR PRISON , IF THEY WERE EVERYWHERE IT WOULD HAVE A PROFOUND AFFECT .",
		"thread_title": "Prominent Democrat Connected To Clintons Donated $675,000 To Campaign Of Deputy FBI Director's Wife",
		"title": "",
		"type": "bs",
		"uuid": "cf089ce65b0ccb5a77e593f27d226097c30f36b9"
	},
	"-KhI_itGyyfwMmNveomj": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T07:28:42.433+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "DARK",
				"salience": 0.21281576,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.19354743,
				"type": "PERSON"
			},
			{
				"name": "twist",
				"salience": 0.1113715,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.1113715,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.083443336,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.046541885,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.044629052,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.043522358,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.032733653,
				"type": "LOCATION"
			},
			{
				"name": "corruption",
				"salience": 0.032733653,
				"type": "OTHER"
			},
			{
				"name": "reptutation",
				"salience": 0.031520277,
				"type": "OTHER"
			},
			{
				"name": "voting booths",
				"salience": 0.02675794,
				"type": "LOCATION"
			},
			{
				"name": "slaves",
				"salience": 0.020017955,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "KKK",
				"salience": 0.008993689,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-29T22:36:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "iTS DARK ALRIGHT . In a sad twist of fate these black people in power are doing more to damage black people &#39;s reptutation than any white people ever could . Whats wrong with them ?? Where are they in the streets complaing about corruption ???? Where are they at the voting booths voting against it ?? Thats what you get when you back the very people who fought  hard to keep them slaves and i might add where the KKK  . They need to wake up  fast .",
		"thread_title": "Prominent Democrat Connected To Clintons Donated $675,000 To Campaign Of Deputy FBI Director's Wife",
		"title": "",
		"type": "bs",
		"uuid": "9bd95ab408508d7f55bcf412c540f279912e3aa7"
	},
	"-KhI_ixJe3_A-tIrh0n1": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T07:28:42.518+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.5304225,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.20596017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "corruption",
				"salience": 0.073762685,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.05991357,
				"type": "PERSON"
			},
			{
				"name": "arguments",
				"salience": 0.049197897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.035964232,
				"type": "LOCATION"
			},
			{
				"name": "infrmants",
				"salience": 0.019070756,
				"type": "PERSON"
			},
			{
				"name": "provications",
				"salience": 0.013926255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.011781951,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-29T22:25:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "The second video (bottom one ) proves what Trump is sayng is true , corruption with the Clinton gang is rife , he could use this in his arguments . http://www.opb.org/news/series/burns-oregon-standoff-bundy-militia-news-updates/ammon-bundy-verdict-oregon-standoff-malheur-court/   And lets not forget there were 15 undercover FBI infrmants doing the provications = set up . ",
		"thread_title": "Prominent Democrat Connected To Clintons Donated $675,000 To Campaign Of Deputy FBI Director's Wife",
		"title": "",
		"type": "bs",
		"uuid": "f0336a240d3df34e121bfc27879f31325cb07912"
	},
	"-KhI_j-fRFnD5UxLc11s": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T07:39:13.677+02:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "7",
		"participants_count": "1",
		"published": "2016-10-29T09:34:00.000+03:00",
		"replies_count": "7",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.8
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Brilliant!",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "",
		"type": "bs",
		"uuid": "c34c0bcecdccaaf463450e9a9e3e168e7e619465"
	},
	"-KhI_j2iHlx07ei6qN9y": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T08:06:40.841+02:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "8",
		"participants_count": "1",
		"published": "2016-10-29T09:34:00.000+03:00",
		"replies_count": "8",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.8
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Brilliant!",
		"thread_title": "Trump Advocates the American People's Control Over U.S. Government",
		"title": "",
		"type": "bs",
		"uuid": "ded9595ce287ba01bc8670c804a928d42f224f19"
	},
	"-KhI_jBXPKOlRw_KqFFb": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T13:11:38.177+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "Central Intelligence Agency",
				"salience": 0.17724529,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.12465547,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.087189026,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02bfkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shell_game"
				},
				"name": "Shell Game",
				"salience": 0.0635996,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "I.S.I.S.",
				"salience": 0.040874172,
				"type": "OTHER"
			},
			{
				"name": "Scott Bennett",
				"salience": 0.03260704,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05jlg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Booz_Allen_Hamilton"
				},
				"name": "Booz Allen Hamilton",
				"salience": 0.026343212,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05s_vxq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Hastings_(journalist)"
				},
				"name": "Michael Hastings",
				"salience": 0.025758576,
				"type": "PERSON"
			},
			{
				"name": "intelligence officer",
				"salience": 0.025064837,
				"type": "PERSON"
			},
			{
				"name": "contractor",
				"salience": 0.025064837,
				"type": "ORGANIZATION"
			},
			{
				"name": "financier",
				"salience": 0.025064837,
				"type": "PERSON"
			},
			{
				"name": "Lie",
				"salience": 0.02172622,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.02172622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03kq8l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dov_S._Zakheim"
				},
				"name": "Dov Zakheim",
				"salience": 0.01939912,
				"type": "PERSON"
			},
			{
				"name": "Swiss bank accounts",
				"salience": 0.01927167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "Army",
				"salience": 0.015472272,
				"type": "ORGANIZATION"
			},
			{
				"name": "Roger Zakheim",
				"salience": 0.009582856,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "U.S. Congress",
				"salience": 0.009536427,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.009295316,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Shell Game",
				"salience": 0.007751732,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.007591834,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Army Officer",
				"salience": 0.007271326,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.007170674,
				"type": "LOCATION"
			},
			{
				"name": "military intelligence",
				"salience": 0.0071168174,
				"type": "OTHER"
			},
			{
				"name": "PROJECT CAMELOT",
				"salience": 0.006984173,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.006794952,
				"type": "OTHER"
			},
			{
				"name": "military whistleblowing",
				"salience": 0.0062979227,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0062979227,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Synopsis",
				"salience": 0.0062979227,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Scandal",
				"salience": 0.0062979227,
				"type": "OTHER"
			},
			{
				"name": "formation",
				"salience": 0.006063185,
				"type": "LOCATION"
			},
			{
				"name": "auto accident",
				"salience": 0.006063185,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0059380503,
				"type": "ORGANIZATION"
			},
			{
				"name": "contractor",
				"salience": 0.0059380503,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0056740134,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06c1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rolling_Stone"
				},
				"name": "Rolling Stone",
				"salience": 0.0055298517,
				"type": "ORGANIZATION"
			},
			{
				"name": "counterterrorism",
				"salience": 0.005142833,
				"type": "OTHER"
			},
			{
				"name": "cover-up",
				"salience": 0.005142833,
				"type": "OTHER"
			},
			{
				"name": "betrayal",
				"salience": 0.005142833,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.005142833,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.005142833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lhw0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Classified_information"
				},
				"name": "TOP SECRET",
				"salience": 0.004959682,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "National Security Agency",
				"salience": 0.0047323382,
				"type": "ORGANIZATION"
			},
			{
				"name": "U.S. Civil Affairs - Psychological Operations Command",
				"salience": 0.004478568,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03lkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hastings"
				},
				"name": "Hastings",
				"salience": 0.0043115476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gx047j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sensitive_Compartmented_Information"
				},
				"name": "SCI",
				"salience": 0.0038785576,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacks",
				"salience": 0.0038428989,
				"type": "EVENT"
			},
			{
				"name": "links",
				"salience": 0.0038428989,
				"type": "OTHER"
			},
			{
				"name": "Buzzsaw",
				"salience": 0.0038428989,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/031rxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UBS"
				},
				"name": "UBS",
				"salience": 0.0037338862,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0035971957,
				"type": "ORGANIZATION"
			},
			{
				"name": "Secrets",
				"salience": 0.0035800207,
				"type": "OTHER"
			},
			{
				"name": "SHELL GAME",
				"salience": 0.0035800207,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Whistleblowers",
				"salience": 0.0032326009,
				"type": "PERSON"
			},
			{
				"name": "Government",
				"salience": 0.0032326009,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0031667436,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence",
				"salience": 0.0028952167,
				"type": "OTHER"
			},
			{
				"name": "Lies",
				"salience": 0.0027993657,
				"type": "OTHER"
			},
			{
				"name": "Money Trails",
				"salience": 0.0027993657,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xsrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Central_Command"
				},
				"name": "U.S. Central Command",
				"salience": 0.0027321277,
				"type": "ORGANIZATION"
			},
			{
				"name": "WTC 9-11",
				"salience": 0.0023659149,
				"type": "ORGANIZATION"
			},
			{
				"name": "http://www.lulu.com/spotlight/shellgame",
				"salience": 0.0023659149,
				"type": "OTHER"
			},
			{
				"name": "terrorist threat finance connection",
				"salience": 0.0020913794,
				"type": "OTHER"
			},
			{
				"name": "SWISS BANKS FUND ISIS",
				"salience": 0.0017232306,
				"type": "ORGANIZATION"
			},
			{
				"name": "Michael Jay",
				"salience": 0.0017232306,
				"type": "PERSON"
			},
			{
				"name": "Union Bank of Switzerland",
				"salience": 0.0016465066,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vzv0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edward_Snowden"
				},
				"name": "Edward Snowden",
				"salience": 0.0012872955,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/080k26z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bradley_Birkenfeld"
				},
				"name": "Brad Birkenfeld",
				"salience": 0.0012872955,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T13:11:38.177+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Exposing the I.S.I.S. Lie: How President Obama & Hillary Clinton Created I.S.I.S. \nScott Bennett, former Army intelligence officer, once private contractor to CIA financier Booz Allen Hamilton, and author of the book Shell Game, a military whistleblowing report to the U.S. Congress, stated he gave Rolling Stone reporter Michael Hastings information about Swiss bank accounts which directly implicated former Secretary of State Hillary Clinton and President Obama in the formation of I.S.I.S., just prior to Hastings being killed in a suspicious auto accident. \n\n\nShell Game: NSA - CIA - UBS - Booz Allen Hamilton Scandal \n\nSynopsis: A true story, originally submitted as a TOP SECRET/SCI military whistleblowing report to U.S. Civil Affairs - Psychological Operations Command in 2012, by an American Army Officer and State Department contractor working at the highest levels of American military intelligence, counterterrorism, and psychological warfare. This report to Congress exposed the betrayal and cover-up by the U.S. government of the Union Bank of Switzerland - Brad Birkenfeld - terrorist threat finance connection to Edward Snowden's intelligence on the National Security Agency, Central Intelligence Agency, Booz Allen Hamilton, and U.S. Central Command. This report exposed new links to Pentagon Comptroller Dov Zakheim, his son Roger Zakheim, and the Pentagon and WTC 9-11 attacks. http://www.lulu.com/spotlight/shellgame \n\n\nBuzzsaw: Money Trails, Whistleblowers & Government Secrets + Lies with Scott Bennett   \nPROJECT CAMELOT: SCOTT BENNETT : CIA, SWISS BANKS FUND ISIS   \nSHELL GAME: An affidavit by Scott Bennett and Michael Jay   ",
		"thread_title": "Scott Bennett, Whistleblower, U.S. Army Terrorist Threat Finance Analyst Under Dov Zakheim - A Gross Perversion of Justice - UBS Whistleblower Brad Birkenfeld Worked With the CIA's Edward Snowden - Terrorist Financing Banks UBS & HSBC Are Represented by Covington & Burling, Employer of Eric Holder, Lanny Breuer, Michael Chertoff, Roger Zakheim - Demand Accountability From Your Representatives!",
		"title": "Scott Bennett, Whistleblower, U.S. Army Terrorist Threat Finance Analyst Under Dov Zakheim - A Gross Perversion of Justice - UBS Whistleblower Brad Birkenfeld Worked With the CIA's Edward Snowden - Terrorist Financing Banks UBS & HSBC Are Represented by Covington & Burling, Employer of Eric Holder, Lanny Breuer, Michael Chertoff, Roger Zakheim - Demand Accountability From Your Representatives!",
		"type": "bs",
		"uuid": "ea4c5f878b9dda1adfa4b52b39087ec210000d2d"
	},
	"-KhI_jFoC7apW-CpaP86": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T15:18:50.150+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "infowars",
				"salience": 0.56205535,
				"type": "OTHER"
			},
			{
				"name": "Everybody",
				"salience": 0.33023196,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dgg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drudge_Report"
				},
				"name": "Drudge",
				"salience": 0.107712686,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-30T10:17:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Everybody send it to Drudge, infowars lets see if they expose it. Time to call them out i say . ",
		"thread_title": "Scott Bennett, Whistleblower, U.S. Army Terrorist Threat Finance Analyst Under Dov Zakheim - A Gross Perversion of Justice - UBS Whistleblower Brad Birkenfeld Worked With the CIA's Edward Snowden - Terrorist Financing Banks UBS & HSBC Are Represented by Covington & Burling, Employer of Eric Holder, Lanny Breuer, Michael Chertoff, Roger Zakheim - Demand Accountability From Your Representatives!",
		"title": "",
		"type": "bs",
		"uuid": "90a69009908b1bda26a937cd2e8769ffcf23f9e8"
	},
	"-KhI_jOmpgUh0iLEsfeO": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T15:18:50.307+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.29880774,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.1770827,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.14706248,
				"type": "PERSON"
			},
			{
				"name": "Everything",
				"salience": 0.08911505,
				"type": "OTHER"
			},
			{
				"name": "whitehouse",
				"salience": 0.05567915,
				"type": "PERSON"
			},
			{
				"name": "shock",
				"salience": 0.05567915,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.024519056,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.014729697,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.011966711,
				"type": "OTHER"
			},
			{
				"name": "fund",
				"salience": 0.011966711,
				"type": "OTHER"
			},
			{
				"name": "justice dept",
				"salience": 0.010818213,
				"type": "OTHER"
			},
			{
				"name": "theu",
				"salience": 0.008404338,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.008404338,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.008091788,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.008091788,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Switzerland"
				},
				"name": "Swiss",
				"salience": 0.007381459,
				"type": "LOCATION"
			},
			{
				"name": "looks",
				"salience": 0.0068658283,
				"type": "OTHER"
			},
			{
				"name": "Truth",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "complicity",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.004818131,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rj_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberty"
				},
				"name": "Liberty",
				"salience": 0.0042307647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0042307647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0042307647,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0036010253,
				"type": "ORGANIZATION"
			},
			{
				"name": "oath",
				"salience": 0.0031327321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.0031219947,
				"type": "PERSON"
			},
			{
				"name": "Notice Drudge",
				"salience": 0.0023034564,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-30T10:01:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "There is the guy who can leaf Trump to the whitehouse , imagine the shock . Everything he says is true and isnt it strnge how the Swiss fund all the wars and get away with it including Hitler . If Trump was ever after someone to trust he would be 1st choice and he knows his way around . Imagine how much money theu have ripped off . That justice dept is as crooked as can be . Trump was right about Hillary and ISIS  . So much for the Liberty party who has been higjacked by the looks of it . And where is the army ?? I think its what oath ?? All these people who did nothing are guilty of complicity in terror by their own laws . Truth should be rewarded not punished or you end up like the world is now as corrupt as can be , Notice Drudge wont even show this . ",
		"thread_title": "Scott Bennett, Whistleblower, U.S. Army Terrorist Threat Finance Analyst Under Dov Zakheim - A Gross Perversion of Justice - UBS Whistleblower Brad Birkenfeld Worked With the CIA's Edward Snowden - Terrorist Financing Banks UBS & HSBC Are Represented by Covington & Burling, Employer of Eric Holder, Lanny Breuer, Michael Chertoff, Roger Zakheim - Demand Accountability From Your Representatives!",
		"title": "",
		"type": "bs",
		"uuid": "a0785e99cf9a112ad97688b2ee80a6524068c8c8"
	},
	"-KhI_jubqT8hK_r1RmWw": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T02:03:09.291+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.16413072,
				"type": "ORGANIZATION"
			},
			{
				"name": "job",
				"salience": 0.12588349,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.07375769,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "JULIAN ASSANGE",
				"salience": 0.06631563,
				"type": "PERSON"
			},
			{
				"name": "IDIOTS",
				"salience": 0.037383117,
				"type": "PERSON"
			},
			{
				"name": "lowest",
				"salience": 0.03446963,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.022934403,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.022047225,
				"type": "ORGANIZATION"
			},
			{
				"name": "filth",
				"salience": 0.02062971,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.016497951,
				"type": "PERSON"
			},
			{
				"name": "type",
				"salience": 0.014969822,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6gkfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream_media"
				},
				"name": "MSM",
				"salience": 0.013750368,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.012096039,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.010609323,
				"type": "OTHER"
			},
			{
				"name": "trap",
				"salience": 0.0086895805,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.008303793,
				"type": "OTHER"
			},
			{
				"name": "WORTH",
				"salience": 0.007701746,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.007360631,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05r5w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pamela_Anderson"
				},
				"name": "Pamela Anderson",
				"salience": 0.00647358,
				"type": "PERSON"
			},
			{
				"name": "ROLL",
				"salience": 0.0063195745,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0061905473,
				"type": "ORGANIZATION"
			},
			{
				"name": "something",
				"salience": 0.005857674,
				"type": "OTHER"
			},
			{
				"name": "GIG",
				"salience": 0.005646611,
				"type": "EVENT"
			},
			{
				"name": "lunch",
				"salience": 0.0056219054,
				"type": "OTHER"
			},
			{
				"name": "VOTES",
				"salience": 0.0054196957,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0054196957,
				"type": "OTHER"
			},
			{
				"name": "trash",
				"salience": 0.005412494,
				"type": "OTHER"
			},
			{
				"name": "EMBASSY",
				"salience": 0.005112512,
				"type": "LOCATION"
			},
			{
				"name": "trash scum",
				"salience": 0.0047894223,
				"type": "OTHER"
			},
			{
				"name": "garbage",
				"salience": 0.0047894223,
				"type": "OTHER"
			},
			{
				"name": "Jimstone.is",
				"salience": 0.004423674,
				"type": "ORGANIZATION"
			},
			{
				"name": "matter",
				"salience": 0.0042384686,
				"type": "OTHER"
			},
			{
				"name": "THEM",
				"salience": 0.0042384686,
				"type": "OTHER"
			},
			{
				"name": "fragment",
				"salience": 0.004192249,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021vtm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crown_Prosecution_Service"
				},
				"name": "CPS",
				"salience": 0.004102836,
				"type": "ORGANIZATION"
			},
			{
				"name": "vote scam machines",
				"salience": 0.004011042,
				"type": "OTHER"
			},
			{
				"name": "CBS-FOX",
				"salience": 0.0039498075,
				"type": "ORGANIZATION"
			},
			{
				"name": "everywhere",
				"salience": 0.0036870576,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02c3wh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Bar_Association"
				},
				"name": "American Bar Association",
				"salience": 0.0036806848,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.0036706012,
				"type": "OTHER"
			},
			{
				"name": "disease",
				"salience": 0.0036706012,
				"type": "OTHER"
			},
			{
				"name": "AVERAGE",
				"salience": 0.0036706012,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0036706012,
				"type": "OTHER"
			},
			{
				"name": "ALL",
				"salience": 0.0035977184,
				"type": "OTHER"
			},
			{
				"name": "CANNOT",
				"salience": 0.0034987698,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gavin McFadyen",
				"salience": 0.0032866707,
				"type": "PERSON"
			},
			{
				"name": "All",
				"salience": 0.0031295805,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.002900414,
				"type": "OTHER"
			},
			{
				"name": "VEHICLE",
				"salience": 0.0023727028,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "IT",
				"salience": 0.0023258193,
				"type": "OTHER"
			},
			{
				"name": "DON'T",
				"salience": 0.0022598119,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04zk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monopoly_(game)"
				},
				"name": "GO TO JAIL",
				"salience": 0.0022598119,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0022322552,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0022322552,
				"type": "OTHER"
			},
			{
				"name": "EVERYONE",
				"salience": 0.0022322552,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.0022322552,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0021669003,
				"type": "OTHER"
			},
			{
				"name": "darkness",
				"salience": 0.0021283128,
				"type": "OTHER"
			},
			{
				"name": "trash",
				"salience": 0.002092359,
				"type": "OTHER"
			},
			{
				"name": "EVERYONE ELSE",
				"salience": 0.0020488838,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.0020309573,
				"type": "ORGANIZATION"
			},
			{
				"name": "manner",
				"salience": 0.001959644,
				"type": "OTHER"
			},
			{
				"name": "staffs",
				"salience": 0.0018627377,
				"type": "PERSON"
			},
			{
				"name": "arts",
				"salience": 0.0018627377,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0018075178,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0017690437,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0017483119,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence",
				"salience": 0.001745332,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.001745332,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.001745332,
				"type": "EVENT"
			},
			{
				"name": "bulldozer",
				"salience": 0.001745332,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "treason",
				"salience": 0.001745332,
				"type": "OTHER"
			},
			{
				"name": "Ditto",
				"salience": 0.001745332,
				"type": "OTHER"
			},
			{
				"name": "DITTO",
				"salience": 0.001745332,
				"type": "OTHER"
			},
			{
				"name": "alt-media",
				"salience": 0.0017334933,
				"type": "OTHER"
			},
			{
				"name": "alt-media",
				"salience": 0.0017334933,
				"type": "OTHER"
			},
			{
				"name": "alt-media",
				"salience": 0.0017334933,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0016726837,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0016726837,
				"type": "OTHER"
			},
			{
				"name": "alt-media",
				"salience": 0.0016687909,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0016058822,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.001565179,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.001565179,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.001565179,
				"type": "OTHER"
			},
			{
				"name": "rats",
				"salience": 0.0015113264,
				"type": "OTHER"
			},
			{
				"name": "sewer",
				"salience": 0.0015113264,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0015113264,
				"type": "OTHER"
			},
			{
				"name": "cover",
				"salience": 0.0015113264,
				"type": "OTHER"
			},
			{
				"name": "echelons",
				"salience": 0.0015113264,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0014877699,
				"type": "PERSON"
			},
			{
				"name": "God Trump",
				"salience": 0.0014283176,
				"type": "OTHER"
			},
			{
				"name": "fungus roots",
				"salience": 0.0014184773,
				"type": "OTHER"
			},
			{
				"name": "brain",
				"salience": 0.0013915312,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.0013915312,
				"type": "PERSON"
			},
			{
				"name": "agency",
				"salience": 0.0013553166,
				"type": "ORGANIZATION"
			},
			{
				"name": "websites",
				"salience": 0.0013553166,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0013553166,
				"type": "OTHER"
			},
			{
				"name": "ads",
				"salience": 0.0013553166,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rot",
				"salience": 0.0013145534,
				"type": "OTHER"
			},
			{
				"name": "vaccines",
				"salience": 0.0012816318,
				"type": "OTHER"
			},
			{
				"name": "criminal",
				"salience": 0.0012237066,
				"type": "PERSON"
			},
			{
				"name": "heads",
				"salience": 0.0012237066,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0012237066,
				"type": "EVENT"
			},
			{
				"name": "bleach",
				"salience": 0.0012237066,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "country",
				"salience": 0.0012237066,
				"type": "LOCATION"
			},
			{
				"name": "bottle",
				"salience": 0.0012182404,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "scam",
				"salience": 0.0011780246,
				"type": "OTHER"
			},
			{
				"name": "bullshit",
				"salience": 0.0011780246,
				"type": "OTHER"
			},
			{
				"name": "gates",
				"salience": 0.0011780246,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0011780246,
				"type": "LOCATION"
			},
			{
				"name": "gates",
				"salience": 0.0011780246,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011780246,
				"type": "LOCATION"
			},
			{
				"name": "evil",
				"salience": 0.0011727622,
				"type": "OTHER"
			},
			{
				"name": "journals",
				"salience": 0.0011433903,
				"type": "WORK_OF_ART"
			},
			{
				"name": "violation",
				"salience": 0.0011289814,
				"type": "OTHER"
			},
			{
				"name": "toast",
				"salience": 0.0011289814,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.0011064174,
				"type": "ORGANIZATION"
			},
			{
				"name": "bombing",
				"salience": 0.0010596135,
				"type": "EVENT"
			},
			{
				"name": "flag",
				"salience": 0.0010596135,
				"type": "OTHER"
			},
			{
				"name": "psyops",
				"salience": 0.0010596135,
				"type": "OTHER"
			},
			{
				"name": "cold",
				"salience": 0.0010596135,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.0010596135,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0010596135,
				"type": "EVENT"
			},
			{
				"name": "self-fund",
				"salience": 0.0010596135,
				"type": "OTHER"
			},
			{
				"name": "bait tactics",
				"salience": 0.0010596135,
				"type": "OTHER"
			},
			{
				"name": "Denial",
				"salience": 0.0010596135,
				"type": "EVENT"
			},
			{
				"name": "control",
				"salience": 0.0010596135,
				"type": "OTHER"
			},
			{
				"name": "ad firms",
				"salience": 0.0010596135,
				"type": "ORGANIZATION"
			},
			{
				"name": "antitrust laws",
				"salience": 0.0010596135,
				"type": "OTHER"
			},
			{
				"name": "fakest",
				"salience": 0.0010200551,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0010200551,
				"type": "EVENT"
			},
			{
				"name": "justice",
				"salience": 0.0010200551,
				"type": "OTHER"
			},
			{
				"name": "jarhead",
				"salience": 0.0010200551,
				"type": "OTHER"
			},
			{
				"name": "bags",
				"salience": 0.0010200551,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0010200551,
				"type": "OTHER"
			},
			{
				"name": "intent",
				"salience": 0.0009989692,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.0009989692,
				"type": "OTHER"
			},
			{
				"name": "feed",
				"salience": 0.0009989692,
				"type": "OTHER"
			},
			{
				"name": "slave trade",
				"salience": 0.0009989692,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.000981973,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0009587652,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0009551493,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.00095448206,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.0009511759,
				"type": "OTHER"
			},
			{
				"name": "YOUNAMEIT",
				"salience": 0.0009301952,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0009301952,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02dkt6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Snopes.com"
				},
				"name": "Snopes",
				"salience": 0.0009301952,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "NSA",
				"salience": 0.0009301952,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0179dd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Transportation_Security_Administration"
				},
				"name": "TSA",
				"salience": 0.0009301952,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "DHS",
				"salience": 0.0009301952,
				"type": "ORGANIZATION"
			},
			{
				"name": "ads",
				"salience": 0.00088059093,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ads",
				"salience": 0.00088059093,
				"type": "WORK_OF_ART"
			},
			{
				"name": "support",
				"salience": 0.0008799758,
				"type": "OTHER"
			},
			{
				"name": "home front",
				"salience": 0.0008650036,
				"type": "OTHER"
			},
			{
				"name": "hive",
				"salience": 0.0008650036,
				"type": "OTHER"
			},
			{
				"name": "towers",
				"salience": 0.0008650036,
				"type": "LOCATION"
			},
			{
				"name": "executives",
				"salience": 0.0008650036,
				"type": "PERSON"
			},
			{
				"name": "necks",
				"salience": 0.0008650036,
				"type": "OTHER"
			},
			{
				"name": "domain",
				"salience": 0.0008650036,
				"type": "OTHER"
			},
			{
				"name": "women's studies department",
				"salience": 0.0008650036,
				"type": "ORGANIZATION"
			},
			{
				"name": "libraries",
				"salience": 0.0008650036,
				"type": "LOCATION"
			},
			{
				"name": "belief",
				"salience": 0.0008650036,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.0008650036,
				"type": "ORGANIZATION"
			},
			{
				"name": "monopoly",
				"salience": 0.00085410185,
				"type": "OTHER"
			},
			{
				"name": "ASSANGE",
				"salience": 0.00083338754,
				"type": "PERSON"
			},
			{
				"name": "tweets",
				"salience": 0.0008264808,
				"type": "WORK_OF_ART"
			},
			{
				"name": "website",
				"salience": 0.0008264808,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00082221365,
				"type": "OTHER"
			},
			{
				"name": "memory",
				"salience": 0.00082221365,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.00074621156,
				"type": "OTHER"
			},
			{
				"name": "Body double",
				"salience": 0.00074621156,
				"type": "OTHER"
			},
			{
				"name": "Themes",
				"salience": 0.00074621156,
				"type": "OTHER"
			},
			{
				"name": "deadman switch",
				"salience": 0.00074621156,
				"type": "OTHER"
			},
			{
				"name": "alt-media",
				"salience": 0.0007411483,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0007342348,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0007342348,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00073129585,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0006951186,
				"type": "PERSON"
			},
			{
				"name": "GO TO HELL",
				"salience": 0.0006809457,
				"type": "WORK_OF_ART"
			},
			{
				"name": "moderators",
				"salience": 0.0006797629,
				"type": "PERSON"
			},
			{
				"name": "DNS server",
				"salience": 0.00065502484,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0vp3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/September_11_attacks"
				},
				"name": "World Trade Center",
				"salience": 0.00065213634,
				"type": "LOCATION"
			},
			{
				"name": "communications",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"name": "disinformation",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"name": "Streams",
				"salience": 0.0006461345,
				"type": "LOCATION"
			},
			{
				"name": "mystery problems",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"name": "timing",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"name": "forums",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0006461345,
				"type": "EVENT"
			},
			{
				"name": "blogs",
				"salience": 0.0006461345,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rumors",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0006461345,
				"type": "EVENT"
			},
			{
				"name": "data",
				"salience": 0.0006461345,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "OH",
				"salience": 0.0006277871,
				"type": "LOCATION"
			},
			{
				"name": "torture",
				"salience": 0.00059878465,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0005484477,
				"type": "OTHER"
			},
			{
				"name": "DNS server",
				"salience": 0.0005484477,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0005484477,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0005434317,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.000532351,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0005192276,
				"type": "OTHER"
			},
			{
				"name": "deadman switches",
				"salience": 0.00051654654,
				"type": "OTHER"
			},
			{
				"name": "IP address change",
				"salience": 0.00050775683,
				"type": "OTHER"
			},
			{
				"name": "hats",
				"salience": 0.0005013567,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "food",
				"salience": 0.0004950373,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0004909912,
				"type": "PERSON"
			},
			{
				"name": "embassy",
				"salience": 0.0004866701,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.00047054596,
				"type": "PERSON"
			},
			{
				"name": "re-direct",
				"salience": 0.00047054596,
				"type": "OTHER"
			},
			{
				"name": "wikileak releases",
				"salience": 0.00047054596,
				"type": "WORK_OF_ART"
			},
			{
				"name": "care",
				"salience": 0.00047054596,
				"type": "OTHER"
			},
			{
				"name": "TAKE",
				"salience": 0.00047054596,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00047054596,
				"type": "OTHER"
			},
			{
				"name": "circles",
				"salience": 0.00047054596,
				"type": "OTHER"
			},
			{
				"name": "laugh",
				"salience": 0.00047054596,
				"type": "OTHER"
			},
			{
				"name": "Kill",
				"salience": 0.00047054596,
				"type": "OTHER"
			},
			{
				"name": "tweets",
				"salience": 0.00044958765,
				"type": "WORK_OF_ART"
			},
			{
				"name": "IP address",
				"salience": 0.00044958765,
				"type": "OTHER"
			},
			{
				"name": "IP address",
				"salience": 0.00044958765,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.00044958765,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "McFayden",
				"salience": 0.00044239685,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.000405918,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ctr7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pin_(chess)"
				},
				"name": "PINs",
				"salience": 0.00039764086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hmrpgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Huffington_Post"
				},
				"name": "The Huffington Post",
				"salience": 0.00039262857,
				"type": "WORK_OF_ART"
			},
			{
				"name": "transfer",
				"salience": 0.00036976812,
				"type": "EVENT"
			},
			{
				"name": "task",
				"salience": 0.00035147363,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00035147363,
				"type": "LOCATION"
			},
			{
				"name": "quality",
				"salience": 0.00035147363,
				"type": "OTHER"
			},
			{
				"name": "odds",
				"salience": 0.00035147363,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.00035147363,
				"type": "OTHER"
			},
			{
				"name": "THING",
				"salience": 0.00035147363,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0003426686,
				"type": "ORGANIZATION"
			},
			{
				"name": "Much",
				"salience": 0.00032987288,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0002942816,
				"type": "PERSON"
			},
			{
				"name": "tweets",
				"salience": 0.00022952196,
				"type": "WORK_OF_ART"
			},
			{
				"name": "jobs",
				"salience": 0.0002283367,
				"type": "OTHER"
			},
			{
				"name": "alt-media needs",
				"salience": 0.00022545834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cbzq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rock_(geology)"
				},
				"name": "STONE",
				"salience": 0.00021629404,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T02:03:09.291+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 35.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Jimstone.is \nOctober 29 2016 \n\nDO NOT FORGIVE THE MSM \n\nThe MSM turned on Hillary. The FBI turned on Hillary. WANT TO KNOW WHY? Because in Florida, where they flipped a HUGE number of votes, Trump still had 68 percent of the vote. Nationwide they did not have the vote scam machines everywhere, and when that got averaged in, Trump took 82 percent of the votes nationwide EVEN WITH THE STOLEN VOTES SUBTRACTED FROM THE AVERAGE. THE FBI, FOX, CNN, EVERYONE ELSE KNEW THE GIG WAS UP, AND IS NOW ONLY MOVING TO SAY \"SORRY\" SO THEY DON'T GO TO JAIL. \n\nWell, I've got news for you: they are still the same lying despicable malfunctioning trash scum they always were; THEY SHOWED THEIR WORTH, and we would be IDIOTS to forgive them, no matter how badly they burn Hillary. \n\nCNN is despicable trash; we all witnessed it. NEVER FORGIVE THEM , because they have proven their worth already. No matter what they do, they can't recover from what they have done: they are garbage, a disease, bleach-worthy filth, and I hope Trump ERASES THEM. DITTO FOR ALL of the rest of the MSM, including The Huffington Post, Snopes, ABC-CBS-FOX-YOUNAMEIT – ALL of them are the lowest of filth that is now heading for the darkness of the nearest sewer to get away from the coming bulldozer. \n\nTHE FBI is a trash agency, along with the rest of American intelligence, which only works to serve the enemy for as long as it thinks its head will not be cut off. ALL of the FBI MUST BE DISBANDED and EVERYONE in the FBI should be blackballed and never allowed to work again, with the top echelons jailed for life for treason. THEY LIED ABOUT 9-11 AND THEY KNEW IT , and have proven they serve one purpose: to protect evil. Ditto for the CIA, the NSA, the DHS, the TSA, and all the rest of the trash. All of it needs to go; there is not one fragment of it that should be salvaged. \n\nSo they are all running like rats for cover: they know they blew it, they know they are going to be bagged for heinous crimes against America. Now they are putting on the biggest fakest show the world will ever witness. As if they cared! They never did care, and I hope to God Trump has a memory longer than the average jarhead and bags every last one of them when he has his day. They had BETTER run for the gates and ditch the country just like they said they would if he got elected – because if not, they are heading straight to the gates of justice. \n\nI would like to thank everyone in the alt-media who made this happen. And I would also like to say that I said it all along as it was and NEVER backed off: Hillary never had more than 8 percent national support. This is something I said repeatedly: that Trump was always 80+ percent supported, and I never wavered and never once posted bullshit like OH, LET'S REJOICE, TRUMP IS AT 51 PERCENT! That was always a trap – a scam, to justify stealing the election – and I called it as it was. \n\nOur job is not over \n\nThe rot is there. It is deeply rooted, with fungus roots running all the way through the country. One bottle of bleach is not going to do more than spot-clean the surface. We won this battle, and it is NOT time to sit down. The alt-media cannot rest until CNN and all of the rest of the MSM is either bankrupted or jailed. The alt-media CANNOT rest for as long as Google is allowed to wage war on websites like this one by refusing to allow it ads. If this website were allowed ads, it would easily self-fund with $12,000 plus per month (and would probably have more than $24,000 per month). Denial of ads just because someone disagrees and has a monopoly established via full control of various ad firms is a flagrant violation of antitrust laws, and has to be stopped dead cold. \n\nThe alt-media cannot stop until every last criminal in the FBI is jailed BY THE FBI. I am sick of the bait tactics and false flag psyops fronted by that agency: heads have GOT TO ROLL, PILES OF THEM, especially since it has been proven that it was the FBI itself that did the first World Trade Center bombing, with the full intent to bring one of the towers down. That's the type of agency that has got to be shuttered – or we are all toast, Trump or not. Yeah, I know YOU, at the FBI, are reading this. GO TO HELL. \n\nOur job will not be over until the CIA is cleaned out. Our job is not over until the American Bar Association is disbanded as the criminal bloodsucking hive it is. Our job is not over until the top executives at the medical companies that produced the tainted autism-inflicting vaccines hang with stretched necks. Our job will not be over until every last liberal arts and women's studies department of all universities have their staffs jailed for treason. They gutted the home front in a manner which was horrific beyond belief. Our job is not over until all of America's great libraries are fully restored after being totally wiped out by the Jews, and ALL scientific journals and works once again become fully free and public domain. Our job will not be over until the child-snatching CPS is shut down and their feed for their slave trade is cut off. Our job will not be over until American corporations begin to fight for America, and bring our jobs and American quality back. \n\nThe list of what the alt-media needs to accomplish now that it appears the first huge battle has been won is practically endless. But I believe the alt-media is up to the task, and will succeed as long as ONE THING IS CEMENTED IN STONE: \n\n\n\nJULIAN ASSANGE IS OBVIOUSLY DEAD. \n\nConsider these facts, and then figure the odds of him being alive: \n\n1. Wikileaks' DNS server was suddenly pointed elsewhere. That's right: that night, in the wee hours of the morning after Pamela was there (to poison him), police in an armored vehicle showed up at the embassy; and THAT NIGHT, the DNS server pointed to a different IP address for Wikileaks, and GOOGLE updated everything instantly, so the transfer was completely seamless from the real Wikileaks server to the fake Wikileaks server that was at a completely different IP address. \n\n2. Mr. Assange's subsequent tweets were noticeably more hostile and attacked his most loyal supporters. I reported this repeatedly. \n\n3. Mr. Assange's tweets regularly misspelled the names of some of his closest friends whom he has known for decades (Gavin McFadyen became McFayden, for example). McFadyen, 76, the director of Wikileaks, was found dead three days after Assange started having mystery problems. This is something I made a huge issue of here. \n\n4. Streams of disinformation were spewed. \n\n5. Themes supported by Mr. Assange for years were then knocked down or discredited by his subsequent tweets and communications. Very bad timing with that. Everyone with a brain noticed this, and it lit up the forums and blogs. \n\n6. \"Body double\" rumors have been circulated and documented. \n\n7. New, strange, hitherto unknown moderators of Wikileaks have suddenly been installed. \n\n8. His \"deadman switch\" WAS ACTIVATED BEFORE THE ARMORED VEHICLE EVEN SHOWED UP AT THE EMBASSY, which means Assange probably manually triggered it after he figured out he was poisoned. Much of his stored data and secret website PINs were to be released in the event of his untimely death (I released both deadman switches here, one encrypted and one unencrypted). \n\nAll of this happened right after Pamela Anderson showed up with a lunch that was no doubt poisoned, and the media talked all about how Assange was \"pale\" and \"not feeling well\" when she left, and that he said the food Pamela brought him was \"torture\". Good for a laugh in the inside circles to have this go out on the MSM, no doubt. \n\nMY TAKE: ASSANGE WAS POISONED, AND THEN REMOVED FROM THE EMBASSY IN AN ARMORED VEHICLE. This was clearly visible in a live feed someone set up that night because something was amiss, and I saw that and stayed up the entire night for it. That is why I so strongly stated that he can't possibly still be at the embassy. Perhaps he got medical care to save him and is now being waterboarded. \n\nIf the new \"wikileak releases\" are real, they are NOT coming from the Wikileaks server – only a re-direct to a different server in the name of Wikileaks. The IP address change proves it, and we can only hope it is white hats doing it. It seems so, but one can only guess. \n\nRelated: \n\nDid Google Kill Julian Assange? ",
		"thread_title": "Do Not Forgive the MSM; Alt-Media, Our Job Is Not Over",
		"title": "Do Not Forgive the MSM; Alt-Media, Our Job Is Not Over",
		"type": "bs",
		"uuid": "e7aacfabf3903ed68a5aa056c098f2face98cee8"
	},
	"-KhI_k9Hs9zLzgJkGjpu": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T02:40:07.541+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.17409293,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.17314488,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048z7l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Jews"
				},
				"name": "American Jews",
				"salience": 0.09304184,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06dpy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gilad_Atzmon"
				},
				"name": "Gilad Atzmon",
				"salience": 0.05547803,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.053188026,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.053188026,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0j6jl2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Sussman"
				},
				"name": "Donald Sussman",
				"salience": 0.047419224,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03r1p1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/S._Daniel_Abraham"
				},
				"name": "Daniel Abraham",
				"salience": 0.032143958,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gqq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Jewish_Chronicle"
				},
				"name": "Jewish Chronicle",
				"salience": 0.028545639,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.022084774,
				"type": "EVENT"
			},
			{
				"name": "donors",
				"salience": 0.022084774,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.01839087,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.01730087,
				"type": "OTHER"
			},
			{
				"name": "dots",
				"salience": 0.015511413,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.013438804,
				"type": "PERSON"
			},
			{
				"name": "media tycoon",
				"salience": 0.012938812,
				"type": "OTHER"
			},
			{
				"name": "speculator",
				"salience": 0.012938812,
				"type": "OTHER"
			},
			{
				"name": "venture Capitalist",
				"salience": 0.012938812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.01180255,
				"type": "ORGANIZATION"
			},
			{
				"name": "land",
				"salience": 0.010977786,
				"type": "LOCATION"
			},
			{
				"name": "rise",
				"salience": 0.010977786,
				"type": "OTHER"
			},
			{
				"name": "antisemitism",
				"salience": 0.010977786,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/055p6n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slim_Fast"
				},
				"name": "SlimFast",
				"salience": 0.008282201,
				"type": "ORGANIZATION"
			},
			{
				"name": "oligarchs",
				"salience": 0.008206143,
				"type": "OTHER"
			},
			{
				"name": "expense",
				"salience": 0.008206143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.007973615,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09g8tdm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J.B._Pritzker"
				},
				"name": "Jay Robert Pritzker",
				"salience": 0.007973615,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f1vrl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haim_Saban"
				},
				"name": "Haim Saban",
				"salience": 0.007973615,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.007973615,
				"type": "PERSON"
			},
			{
				"name": "conclusion",
				"salience": 0.0072304285,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0059796325,
				"type": "OTHER"
			},
			{
				"name": "mistakes",
				"salience": 0.0059796325,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0059796325,
				"type": "OTHER"
			},
			{
				"name": "dots",
				"salience": 0.0051594707,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.003886908,
				"type": "PERSON"
			},
			{
				"name": "game",
				"salience": 0.0038379615,
				"type": "EVENT"
			},
			{
				"name": "manyAmerican",
				"salience": 0.0027509865,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T02:40:07.541+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Gilad Atzmon \nOctober 29, 2016\n\nTop five donors to Clinton campaign are Jewish \n\n\nThe Jewish Chronicle reports this weekend that the \"five biggest donors to Democratic candidate Hillary Clinton's presidential campaign are all Jewish.\" \n\nDonald Sussman, hedge fund Manager; \n\nJay Robert Pritzker venture Capitalist \n\nHaim Saban, Israeli-American media tycoon \n\nGeorge Soros, speculator \n\nDaniel Abraham, founder of SlimFast \n\nThe only open question is whether the American people are ready to connect the dots? In the last few months we have been reading that American Jews are concerned by the sharp rise in antisemitism in the land of the free. I guess that manyAmerican Jews have connected the dots already. They grasp that once again, Jewish elite is playing a very dangerous game on their expense. \n\nOne would expect Jews in general and Jewish oligarchs in particular to draw the necessary conclusion from Jewish history. Somehow this never happens. The same disastrous mistakes are repeated. As we know, the consequences are grave ",
		"thread_title": "Is it coming into clearer focus for Americans or not?",
		"title": "Is it coming into clearer focus for Americans or not?",
		"type": "bs",
		"uuid": "ced44bbf8bc01f507735744020f17c120ce3047a"
	},
	"-KhI_kQLmCFF3U1desW4": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T06:10:04.338+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.70143104,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.13333125,
				"type": "PERSON"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.019492794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.017082453,
				"type": "ORGANIZATION"
			},
			{
				"name": "Source",
				"salience": 0.009730637,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d4r_q"
				},
				"name": "Jim",
				"salience": 0.006713665,
				"type": "PERSON"
			},
			{
				"name": "pressure",
				"salience": 0.0061664316,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.005097393,
				"type": "PERSON"
			},
			{
				"name": "email investigation",
				"salience": 0.0045132767,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0040026587,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.0039107096,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0033859033,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0030603204,
				"type": "OTHER"
			},
			{
				"name": "praise",
				"salience": 0.0030603204,
				"type": "OTHER"
			},
			{
				"name": "Conspiracy theories",
				"salience": 0.0030603204,
				"type": "OTHER"
			},
			{
				"name": "negligence",
				"salience": 0.0030603204,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0csqs5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Process_analytical_technology"
				},
				"name": "Pat",
				"salience": 0.0029488772,
				"type": "PERSON"
			},
			{
				"name": "prosecutor",
				"salience": 0.0025316107,
				"type": "PERSON"
			},
			{
				"name": "immunity agreements",
				"salience": 0.0022879478,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0019906452,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0018923699,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.001885888,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.001862926,
				"type": "EVENT"
			},
			{
				"name": "hand",
				"salience": 0.0014570443,
				"type": "OTHER"
			},
			{
				"name": "Clinton Email",
				"salience": 0.0014492765,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0014471727,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0014471727,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0013932182,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.001327476,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0012753991,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0012750059,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.0012618906,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0012618906,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0012618906,
				"type": "OTHER"
			},
			{
				"name": "staffers",
				"salience": 0.0012618906,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0012618906,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.001221131,
				"type": "OTHER"
			},
			{
				"name": "disgrace",
				"salience": 0.0011747716,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.0011317487,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.0011317487,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.0010895386,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.0010895386,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0010895386,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0010403371,
				"type": "EVENT"
			},
			{
				"name": "source",
				"salience": 0.0010279556,
				"type": "PERSON"
			},
			{
				"name": "handling",
				"salience": 0.0010219397,
				"type": "OTHER"
			},
			{
				"name": "disgrace",
				"salience": 0.0009963661,
				"type": "OTHER"
			},
			{
				"name": "wrist",
				"salience": 0.0009838201,
				"type": "OTHER"
			},
			{
				"name": "slap",
				"salience": 0.0009838201,
				"type": "OTHER"
			},
			{
				"name": "bureau",
				"salience": 0.0009838201,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0009838201,
				"type": "OTHER"
			},
			{
				"name": "Patrice",
				"salience": 0.00093786325,
				"type": "PERSON"
			},
			{
				"name": "indictment",
				"salience": 0.0008850007,
				"type": "OTHER"
			},
			{
				"name": "deputies",
				"salience": 0.0008850007,
				"type": "PERSON"
			},
			{
				"name": "material",
				"salience": 0.0008850007,
				"type": "OTHER"
			},
			{
				"name": "bureau",
				"salience": 0.0008343841,
				"type": "ORGANIZATION"
			},
			{
				"name": "slap",
				"salience": 0.0008343841,
				"type": "OTHER"
			},
			{
				"name": "wrist",
				"salience": 0.0008343841,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.00077697716,
				"type": "PERSON"
			},
			{
				"name": "Catholic mass",
				"salience": 0.00072255556,
				"type": "OTHER"
			},
			{
				"name": "family outings",
				"salience": 0.00072255556,
				"type": "EVENT"
			},
			{
				"name": "greetings",
				"salience": 0.00072255556,
				"type": "OTHER"
			},
			{
				"name": "hall",
				"salience": 0.00072255556,
				"type": "LOCATION"
			},
			{
				"name": "article",
				"salience": 0.0006696377,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letters",
				"salience": 0.0005422311,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.0005398095,
				"type": "OTHER"
			},
			{
				"name": "decision making process",
				"salience": 0.0005398095,
				"type": "OTHER"
			},
			{
				"name": "facets",
				"salience": 0.0005398095,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.0005398095,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.0005398095,
				"type": "OTHER"
			},
			{
				"name": "angriest",
				"salience": 0.0005398095,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.00052448775,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00050892367,
				"type": "PERSON"
			},
			{
				"name": "servant",
				"salience": 0.00050286285,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.00048047476,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0004540386,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.00043158382,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00039316175,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00039316175,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.00039316175,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00039316175,
				"type": "PERSON"
			},
			{
				"name": "desire",
				"salience": 0.00039316175,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00039316175,
				"type": "OTHER"
			},
			{
				"name": "Flashback",
				"salience": 0.00039316175,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0003756555,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.0003680061,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.00036138,
				"type": "PERSON"
			},
			{
				"name": "resignation letters",
				"salience": 0.00033917712,
				"type": "WORK_OF_ART"
			},
			{
				"name": "department heads",
				"salience": 0.00030508477,
				"type": "OTHER"
			},
			{
				"name": "length",
				"salience": 0.00029369528,
				"type": "OTHER"
			},
			{
				"name": "morale",
				"salience": 0.00029369528,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00029369528,
				"type": "OTHER"
			},
			{
				"name": "stack",
				"salience": 0.00029369528,
				"type": "OTHER"
			},
			{
				"name": "desk",
				"salience": 0.00029369528,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.00029369528,
				"type": "OTHER"
			},
			{
				"name": "rock bottom",
				"salience": 0.00029369528,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0002535412,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00024198189,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T06:10:04.338+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Source: Zero Hedge \n\nOctober 30, 2016\n\nConspiracy theories have swirled in recent days as to why FBI Director James Comey reopened Hillary's email investigation after just closing it back in July concluding that, although Hillary had demonstrated gross negligence in her establishment of a private email server, that \"no reasonable prosecutor\" would bring a case against her. Democrats, after lavishing Comey with praise for months on concluding his investigation in an \"impartial\" way, have since lashed out at him for seeking to influence the 2016 election cycle with Hillary herself describing his recent actions as \"deeply troubling\". Republicans, on the other hand, have praised Comey's recent efforts as an attempt to correct a corrupt investigation that seemingly ignored critical evidence while granting numerous immunity agreements to Clinton staffers. \n\nAccording to the Daily Mail , and a source close to James Comey, the decision, at least in part, came after he \"could no longer resist mounting pressure by mutinous agents in the FBI\" who \"felt that he betrayed them and brought disgrace on the bureau by letting Hillary off with a slap on the wrist.\" \nJames Comey's decision to revive the investigation of Hillary Clinton's email server and her handling of classified material came after he could no longer resist mounting pressure by mutinous agents in the FBI , including some of his top deputies, according to a source close to the embattled FBI director. \n\n'The atmosphere at the FBI has been toxic ever since Jim announced last July that he wouldn't recommend an indictment against Hillary,' said the source, a close friend who has known Comey for nearly two decades, shares family outings with him, and accompanies him to Catholic mass every week. \n\n'Some people, including department heads, stopped talking to Jim, and even ignored his greetings when they passed him in the hall,' said the source. 'They felt that he betrayed them and brought disgrace on the bureau by letting Hillary off with a slap on the wrist.' \n\nAccording to the source, Comey fretted over the problem for months and discussed it at great length with his wife, Patrice. \n\nHe told his wife that he was depressed by the stack of resignation letters piling up on his desk from disaffected agents. The letters reminded him every day that morale in the FBI had hit rock bottom. \n\n'The people he trusts the most have been the angriest at him,' the source continued. 'And that includes his wife, Pat. She kept urging him to admit that he had been wrong when he refused to press charges against the former secretary of state. Though we're sure there are many facets behind Comey's decision making process, we can all be quite certain, at this point, that he's not motivated by a desire to make friends having now alienated just about everyone in Washington, both in law enforcement and in both political parties. In fact, after Tim Kaine just last week praised Comey as a \"wonderful\" career public servant with the \"highest standards of integrity\".... \n\nFlashback: Kaine Praises FBI Director Comey On Clinton Email Investigation   \nPlease go to to Zero Hedge read the entire article.",
		"thread_title": "Is This Why Comey Broke: A Stack Of Resignation Letters From Furious FBI Agents",
		"title": "Is This Why Comey Broke: A Stack Of Resignation Letters From Furious FBI Agents",
		"type": "bs",
		"uuid": "ef88bc367c52cbf7e5f5936818b11b47718c36a9"
	},
	"-KhI_kYjpgn6ey76oq2T": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T07:05:35.473+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.48016256,
				"type": "ORGANIZATION"
			},
			{
				"name": "stand",
				"salience": 0.09086009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0431h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Edgar_Hoover"
				},
				"name": "Hoover",
				"salience": 0.060117453,
				"type": "PERSON"
			},
			{
				"name": "thats",
				"salience": 0.058849897,
				"type": "OTHER"
			},
			{
				"name": "disgrace",
				"salience": 0.058849897,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.052240137,
				"type": "OTHER"
			},
			{
				"name": "Alcapone",
				"salience": 0.034854274,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.021310005,
				"type": "PERSON"
			},
			{
				"name": "Sibel Edmons",
				"salience": 0.014021473,
				"type": "PERSON"
			},
			{
				"name": "help",
				"salience": 0.011428408,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.009456929,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.00933824,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.008878135,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.008878135,
				"type": "PERSON"
			},
			{
				"name": "honesty",
				"salience": 0.008547935,
				"type": "OTHER"
			},
			{
				"name": "mess",
				"salience": 0.008547935,
				"type": "OTHER"
			},
			{
				"name": "syatem",
				"salience": 0.008386131,
				"type": "OTHER"
			},
			{
				"name": "Looks",
				"salience": 0.007872626,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0072852066,
				"type": "OTHER"
			},
			{
				"name": "thm",
				"salience": 0.0071153934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0068714786,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0054219933,
				"type": "OTHER"
			},
			{
				"name": "credit",
				"salience": 0.0046580066,
				"type": "OTHER"
			},
			{
				"name": "crooks",
				"salience": 0.004399377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0043573254,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.0039511127,
				"type": "OTHER"
			},
			{
				"name": "Dirty dozen",
				"salience": 0.0033398368,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-31T01:50:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Its a disgrace , they have wrecked the FBI , its worse than Hoover and thats saying something , they have to make a stand sometime ,its getting like Alcapone arresting Alcapone . What a mess . Trump should make something out of this stopping honesty in the FBI is an outrage of the highest order. Your brave guys/girls  but where is the help you deserve ///???? No one is against the FBI They just hate crooks in their undermining the whole legal syatem if you could call it that . You have to give Sibel Edmons some credit she named Hillary as part of the Dirty dozen . Looks like they are trying to destroy thm going on who they keep putting in charge.",
		"thread_title": "Is This Why Comey Broke: A Stack Of Resignation Letters From Furious FBI Agents",
		"title": "",
		"type": "bs",
		"uuid": "7ef8f3d0a3103faf5171c5e020f61c5b7b126ed7"
	},
	"-KhI_kcGoe_XCkanZkFC": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T07:05:35.482+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "people",
				"salience": 0.7412198,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.25878018,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-31T01:40:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Same people all the time , i dont know how you can fix this corruption http://www.fromthewilderness.com/free/ww3/10_09_01_krongard.html",
		"thread_title": "Is This Why Comey Broke: A Stack Of Resignation Letters From Furious FBI Agents",
		"title": "",
		"type": "bs",
		"uuid": "ddc4431d0e58f108b7ea0f795af1682aa1d5eb29"
	},
	"-KhI_kkkMzVk-srFxs9U": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T07:14:47.404+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.48016256,
				"type": "ORGANIZATION"
			},
			{
				"name": "stand",
				"salience": 0.09086009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0431h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Edgar_Hoover"
				},
				"name": "Hoover",
				"salience": 0.060117453,
				"type": "PERSON"
			},
			{
				"name": "thats",
				"salience": 0.058849897,
				"type": "OTHER"
			},
			{
				"name": "disgrace",
				"salience": 0.058849897,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.052240137,
				"type": "OTHER"
			},
			{
				"name": "Alcapone",
				"salience": 0.034854274,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.021310005,
				"type": "PERSON"
			},
			{
				"name": "Sibel Edmons",
				"salience": 0.014021473,
				"type": "PERSON"
			},
			{
				"name": "help",
				"salience": 0.011428408,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.009456929,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.00933824,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.008878135,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.008878135,
				"type": "PERSON"
			},
			{
				"name": "honesty",
				"salience": 0.008547935,
				"type": "OTHER"
			},
			{
				"name": "mess",
				"salience": 0.008547935,
				"type": "OTHER"
			},
			{
				"name": "syatem",
				"salience": 0.008386131,
				"type": "OTHER"
			},
			{
				"name": "Looks",
				"salience": 0.007872626,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0072852066,
				"type": "OTHER"
			},
			{
				"name": "thm",
				"salience": 0.0071153934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0068714786,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0054219933,
				"type": "OTHER"
			},
			{
				"name": "credit",
				"salience": 0.0046580066,
				"type": "OTHER"
			},
			{
				"name": "crooks",
				"salience": 0.004399377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0043573254,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.0039511127,
				"type": "OTHER"
			},
			{
				"name": "Dirty dozen",
				"salience": 0.0033398368,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-31T01:50:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Its a disgrace , they have wrecked the FBI , its worse than Hoover and thats saying something , they have to make a stand sometime ,its getting like Alcapone arresting Alcapone . What a mess . Trump should make something out of this stopping honesty in the FBI is an outrage of the highest order. Your brave guys/girls  but where is the help you deserve ///???? No one is against the FBI They just hate crooks in their undermining the whole legal syatem if you could call it that . You have to give Sibel Edmons some credit she named Hillary as part of the Dirty dozen . Looks like they are trying to destroy thm going on who they keep putting in charge.",
		"thread_title": "Do Not Forgive the MSM; Alt-Media, Our Job Is Not Over",
		"title": "",
		"type": "bs",
		"uuid": "c2f4379c6bafd431f0deee6931ee9efbc4066bf5"
	},
	"-KhI_kpB0DEnyiX9Kbjv": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T07:14:47.438+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "people",
				"salience": 0.7412198,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.25878018,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-31T01:40:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Same people all the time , i dont know how you can fix this corruption http://www.fromthewilderness.com/free/ww3/10_09_01_krongard.html",
		"thread_title": "Do Not Forgive the MSM; Alt-Media, Our Job Is Not Over",
		"title": "",
		"type": "bs",
		"uuid": "2400342916f14231ba162d50627b115e7144a37d"
	},
	"-KhI_lBQbvZfRo7muUGd": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T12:26:19.531+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "people",
				"salience": 0.7412198,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.25878018,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-31T01:40:00.000+02:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Same people all the time , i dont know how you can fix this corruption http://www.fromthewilderness.com/free/ww3/10_09_01_krongard.html",
		"thread_title": "Is This Why Comey Broke: A Stack Of Resignation Letters From Furious FBI Agents",
		"title": "",
		"type": "bs",
		"uuid": "99ecf2b3a3a7acf4a8f83bc46104cea2acaf1848"
	},
	"-KhI_lJKyYxrMjZVIBLS": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:29:33.486+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.48016256,
				"type": "ORGANIZATION"
			},
			{
				"name": "stand",
				"salience": 0.09086009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0431h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Edgar_Hoover"
				},
				"name": "Hoover",
				"salience": 0.060117453,
				"type": "PERSON"
			},
			{
				"name": "thats",
				"salience": 0.058849897,
				"type": "OTHER"
			},
			{
				"name": "disgrace",
				"salience": 0.058849897,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.052240137,
				"type": "OTHER"
			},
			{
				"name": "Alcapone",
				"salience": 0.034854274,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.021310005,
				"type": "PERSON"
			},
			{
				"name": "Sibel Edmons",
				"salience": 0.014021473,
				"type": "PERSON"
			},
			{
				"name": "help",
				"salience": 0.011428408,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.009456929,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.00933824,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.008878135,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.008878135,
				"type": "PERSON"
			},
			{
				"name": "honesty",
				"salience": 0.008547935,
				"type": "OTHER"
			},
			{
				"name": "mess",
				"salience": 0.008547935,
				"type": "OTHER"
			},
			{
				"name": "syatem",
				"salience": 0.008386131,
				"type": "OTHER"
			},
			{
				"name": "Looks",
				"salience": 0.007872626,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0072852066,
				"type": "OTHER"
			},
			{
				"name": "thm",
				"salience": 0.0071153934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0068714786,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0054219933,
				"type": "OTHER"
			},
			{
				"name": "credit",
				"salience": 0.0046580066,
				"type": "OTHER"
			},
			{
				"name": "crooks",
				"salience": 0.004399377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0043573254,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.0039511127,
				"type": "OTHER"
			},
			{
				"name": "Dirty dozen",
				"salience": 0.0033398368,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-10-31T01:50:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Its a disgrace , they have wrecked the FBI , its worse than Hoover and thats saying something , they have to make a stand sometime ,its getting like Alcapone arresting Alcapone . What a mess . Trump should make something out of this stopping honesty in the FBI is an outrage of the highest order. Your brave guys/girls  but where is the help you deserve ///???? No one is against the FBI They just hate crooks in their undermining the whole legal syatem if you could call it that . You have to give Sibel Edmons some credit she named Hillary as part of the Dirty dozen . Looks like they are trying to destroy thm going on who they keep putting in charge.",
		"thread_title": "Is This Why Comey Broke: A Stack Of Resignation Letters From Furious FBI Agents",
		"title": "",
		"type": "bs",
		"uuid": "14d8cbfde7c9847bffe74fb59b99887e8c51776e"
	},
	"-KhI_lNDZXYI0hyJyDit": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:29:33.820+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "people",
				"salience": 0.7412198,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.25878018,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-10-31T01:40:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Same people all the time , i dont know how you can fix this corruption http://www.fromthewilderness.com/free/ww3/10_09_01_krongard.html",
		"thread_title": "Is This Why Comey Broke: A Stack Of Resignation Letters From Furious FBI Agents",
		"title": "",
		"type": "bs",
		"uuid": "4b275ff5fc13126b4e373b462d3f4a55aea06b81"
	},
	"-KhI_lS-2ak9kLIuKqEa": {
		"author": "IBU SUMIATUNG",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:29:40.101+02:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-31T12:28:00.000+02:00",
		"replies_count": "5",
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "SAYA IBU SUMIATUNG DARI PAPUA SALAH SATU MEMBER MBAH SERO SAYA SEKELUARGA MENGUCAPAKAN BANYAK TERIMA KASIH KEPADA MBAH SERO ANGKA TOGEL YANG DI BERIKAN KEMARIN 4D 4970 TGL 20-OKTOBER-2016 SGP TEMBUS 100% DAN WAKTU TGL 08-OKTOBER-2016 SAYA JUGA MENANG 4D 9996 DAN PEMASANGAN PERTAMA SAYA CUMA MENANG 2D 81 TGL 01-OKTOBER-2016 KARNA SAYA COBA-COBA PASANG ANGKA DARI MBAH SERO WALAUPUN CUMA 2D NYA SYUKUR ALHAMDULILLAH SAYA MENDAPATKAN KEMENANGAN RP.700.JUTA DALAM 3X PUTARAN SAYA SUDAH BISA MELUNASI HUTANG2 SAYA YANG ADA DI BANK DAN RENCANA MAU BUKA USAHA INI SEMUA BERKAT BANTUAN MBAH SERO SAYA TIDAK AKAN MELUPAKAN BUDI BAIK MBAH BAGI SAUDARAH2 BUTUH ANGK JITU HASIL RITUA 2D 3D 4D 5D 6D KALAU MAU MENANG SEPERTI SAYA LANSUNG HUBUNGI MBAH SERO DI NOMOR HP: 082-370-357-999 ANGKA YANG DI BERIKAN MBAH SERO TIDAK PERLU DI RAGUKAN LAGI SAYA JAMIN 100% TEMBUS SOALNYA SAYA SUDAH PERNAH MEMBUKTIKANNYA 3X PUTARAN MENANG..",
		"thread_title": "Is it coming into clearer focus for Americans, or not?",
		"title": "",
		"type": "bs",
		"uuid": "8e945ed1e1c570bda327ccc11fb74679175982d7"
	},
	"-KhI_lWUumCGL-EFwdAy": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:29:40.117+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "YAH Almighty",
				"salience": 0.56493115,
				"type": "ORGANIZATION"
			},
			{
				"name": "Praise the LORD",
				"salience": 0.26913968,
				"type": "ORGANIZATION"
			},
			{
				"name": "thing",
				"salience": 0.071110055,
				"type": "OTHER"
			},
			{
				"name": "Job Comey",
				"salience": 0.056915946,
				"type": "PERSON"
			},
			{
				"name": "Gregory William Gieseke",
				"salience": 0.03790316,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-10-31T12:26:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0.6
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Praise the LORD YAH Almighty. Good Job Comey for doing the right thing thus says  Gregory William Gieseke 593-40-8126 DOB July 28, 1968 (nineteen sixty eight).",
		"thread_title": "Is it coming into clearer focus for Americans, or not?",
		"title": "",
		"type": "bs",
		"uuid": "e1f1503a6198d76e855309bc9c77157f6af59db2"
	},
	"-KhI_lbjsI2oVyfSCSR0": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:29:40.125+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.42257312,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.40729558,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.14499354,
				"type": "ORGANIZATION"
			},
			{
				"name": "kiddie stuff",
				"salience": 0.00790975,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.00790975,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Wieners",
				"salience": 0.0048860367,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "choice",
				"salience": 0.0044322102,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-31T06:46:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.9,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "http://82.221.129.208/basepages2.html  The NYPD TRUMPED the FBI! That is why they had to investigate Hillary!  Well well, the  NYPD is what busted the Hillary mails open while they were looking for kiddie stuff on Wieners laptop, and THAT is why the FBI was forced to investigate Hillary. They had no choice. NYPD TRUMPS FBI!!!",
		"thread_title": "Is it coming into clearer focus for Americans, or not?",
		"title": "",
		"type": "bs",
		"uuid": "330f5c5c2d68bb521796bb2d88ba9c4eef433362"
	},
	"-KhI_lhx1Ya7ACFaC-fe": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:29:40.152+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.48016256,
				"type": "ORGANIZATION"
			},
			{
				"name": "stand",
				"salience": 0.09086009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0431h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Edgar_Hoover"
				},
				"name": "Hoover",
				"salience": 0.060117453,
				"type": "PERSON"
			},
			{
				"name": "thats",
				"salience": 0.058849897,
				"type": "OTHER"
			},
			{
				"name": "disgrace",
				"salience": 0.058849897,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.052240137,
				"type": "OTHER"
			},
			{
				"name": "Alcapone",
				"salience": 0.034854274,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.021310005,
				"type": "PERSON"
			},
			{
				"name": "Sibel Edmons",
				"salience": 0.014021473,
				"type": "PERSON"
			},
			{
				"name": "help",
				"salience": 0.011428408,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.009456929,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.00933824,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.008878135,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.008878135,
				"type": "PERSON"
			},
			{
				"name": "honesty",
				"salience": 0.008547935,
				"type": "OTHER"
			},
			{
				"name": "mess",
				"salience": 0.008547935,
				"type": "OTHER"
			},
			{
				"name": "syatem",
				"salience": 0.008386131,
				"type": "OTHER"
			},
			{
				"name": "Looks",
				"salience": 0.007872626,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0072852066,
				"type": "OTHER"
			},
			{
				"name": "thm",
				"salience": 0.0071153934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0068714786,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0054219933,
				"type": "OTHER"
			},
			{
				"name": "credit",
				"salience": 0.0046580066,
				"type": "OTHER"
			},
			{
				"name": "crooks",
				"salience": 0.004399377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0043573254,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.0039511127,
				"type": "OTHER"
			},
			{
				"name": "Dirty dozen",
				"salience": 0.0033398368,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-10-31T01:50:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Its a disgrace , they have wrecked the FBI , its worse than Hoover and thats saying something , they have to make a stand sometime ,its getting like Alcapone arresting Alcapone . What a mess . Trump should make something out of this stopping honesty in the FBI is an outrage of the highest order. Your brave guys/girls  but where is the help you deserve ///???? No one is against the FBI They just hate crooks in their undermining the whole legal syatem if you could call it that . You have to give Sibel Edmons some credit she named Hillary as part of the Dirty dozen . Looks like they are trying to destroy thm going on who they keep putting in charge.",
		"thread_title": "Is it coming into clearer focus for Americans, or not?",
		"title": "",
		"type": "bs",
		"uuid": "4a71af71d5a61e6ff7d6ec1631f0fb75e63d1dde"
	},
	"-KhI_llk17VhUfWCAVmZ": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:29:40.164+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "people",
				"salience": 0.7412198,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.25878018,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-10-31T01:40:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Same people all the time , i dont know how you can fix this corruption http://www.fromthewilderness.com/free/ww3/10_09_01_krongard.html",
		"thread_title": "Is it coming into clearer focus for Americans, or not?",
		"title": "",
		"type": "bs",
		"uuid": "db6838a2265f20af6b97f531fe5cda3885a35f9f"
	},
	"-KhI_lp9z8cRaBpccxxH": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:35:24.348+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "fraud",
				"salience": 0.5652084,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.33094114,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.103850454,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-30T21:24:00.000+02:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "The green fraud has a lot to do with it all as exposed in the emails . http://www.dailytelegraph.com.au/rendezview/miranda-devine-foreignfunded-green-groups-could-take-whole-swathes-of-australia-out-of-the-productive-economy/news-story/016e5d9ff252f2444790d05269f4ed90",
		"thread_title": "Do Not Forgive the MSM; Alt-Media, Our Job Is Not Over",
		"title": "",
		"type": "bs",
		"uuid": "3290f8bcdb89ddaaafe22f151221b2bd324ed7e4"
	},
	"-KhI_luo4A6lxP1e3z-V": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:35:32.911+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "fraud",
				"salience": 0.5652084,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.33094114,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.103850454,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-30T21:24:00.000+02:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "The green fraud has a lot to do with it all as exposed in the emails . http://www.dailytelegraph.com.au/rendezview/miranda-devine-foreignfunded-green-groups-could-take-whole-swathes-of-australia-out-of-the-productive-economy/news-story/016e5d9ff252f2444790d05269f4ed90",
		"thread_title": "Scott Bennett, Whistleblower, U.S. Army Terrorist Threat Finance Analyst Under Dov Zakheim - A Gross Perversion of Justice - UBS Whistleblower Brad Birkenfeld Worked With the CIA's Edward Snowden - Terrorist Financing Banks UBS & HSBC Are Represented by Covington & Burling, Employer of Eric Holder, Lanny Breuer, Michael Chertoff, Roger Zakheim - Demand Accountability From Your Representatives!",
		"title": "",
		"type": "bs",
		"uuid": "3ee7c64e68b0a5992cb4efdd20ecbfbf0dad89d4"
	},
	"-KhI_lzDKIe07_YYJb8L": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T18:41:32.894+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "infowars",
				"salience": 0.56205535,
				"type": "OTHER"
			},
			{
				"name": "Everybody",
				"salience": 0.33023196,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dgg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drudge_Report"
				},
				"name": "Drudge",
				"salience": 0.107712686,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-10-30T10:17:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Everybody send it to Drudge, infowars lets see if they expose it. Time to call them out i say . ",
		"thread_title": "Scott Bennett, Whistleblower, U.S. Army Terrorist Threat Finance Analyst Under Dov Zakheim - A Gross Perversion of Justice - UBS Whistleblower Brad Birkenfeld Worked With the CIA's Edward Snowden - Terrorist Financing Banks UBS & HSBC Are Represented by Covington & Burling, Employer of Eric Holder, Lanny Breuer, Michael Chertoff, Roger Zakheim - Demand Accountability From Your Representatives!",
		"title": "",
		"type": "bs",
		"uuid": "4e891021d3443e93022df946e782deda1b7ff7fc"
	},
	"-KhI_m4lssQUJYXlhVEQ": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T18:41:33.046+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.29880774,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.1770827,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.14706248,
				"type": "PERSON"
			},
			{
				"name": "Everything",
				"salience": 0.08911505,
				"type": "OTHER"
			},
			{
				"name": "whitehouse",
				"salience": 0.05567915,
				"type": "PERSON"
			},
			{
				"name": "shock",
				"salience": 0.05567915,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.024519056,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.014729697,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.011966711,
				"type": "OTHER"
			},
			{
				"name": "fund",
				"salience": 0.011966711,
				"type": "OTHER"
			},
			{
				"name": "justice dept",
				"salience": 0.010818213,
				"type": "OTHER"
			},
			{
				"name": "theu",
				"salience": 0.008404338,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.008404338,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.008091788,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.008091788,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Switzerland"
				},
				"name": "Swiss",
				"salience": 0.007381459,
				"type": "LOCATION"
			},
			{
				"name": "looks",
				"salience": 0.0068658283,
				"type": "OTHER"
			},
			{
				"name": "Truth",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "complicity",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.004818131,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rj_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberty"
				},
				"name": "Liberty",
				"salience": 0.0042307647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0042307647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0042307647,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0036010253,
				"type": "ORGANIZATION"
			},
			{
				"name": "oath",
				"salience": 0.0031327321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.0031219947,
				"type": "PERSON"
			},
			{
				"name": "Notice Drudge",
				"salience": 0.0023034564,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-10-30T10:01:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "There is the guy who can leaf Trump to the whitehouse , imagine the shock . Everything he says is true and isnt it strnge how the Swiss fund all the wars and get away with it including Hitler . If Trump was ever after someone to trust he would be 1st choice and he knows his way around . Imagine how much money theu have ripped off . That justice dept is as crooked as can be . Trump was right about Hillary and ISIS  . So much for the Liberty party who has been higjacked by the looks of it . And where is the army ?? I think its what oath ?? All these people who did nothing are guilty of complicity in terror by their own laws . Truth should be rewarded not punished or you end up like the world is now as corrupt as can be , Notice Drudge wont even show this . ",
		"thread_title": "Scott Bennett, Whistleblower, U.S. Army Terrorist Threat Finance Analyst Under Dov Zakheim - A Gross Perversion of Justice - UBS Whistleblower Brad Birkenfeld Worked With the CIA's Edward Snowden - Terrorist Financing Banks UBS & HSBC Are Represented by Covington & Burling, Employer of Eric Holder, Lanny Breuer, Michael Chertoff, Roger Zakheim - Demand Accountability From Your Representatives!",
		"title": "",
		"type": "bs",
		"uuid": "96eb09546bd1d06a58c7b06fd36d5290277c6ead"
	},
	"-KhI_m8uRFzpIhz4nkWk": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T18:41:33.643+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "infowars",
				"salience": 0.56205535,
				"type": "OTHER"
			},
			{
				"name": "Everybody",
				"salience": 0.33023196,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dgg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drudge_Report"
				},
				"name": "Drudge",
				"salience": 0.107712686,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-10-30T10:17:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Everybody send it to Drudge, infowars lets see if they expose it. Time to call them out i say . ",
		"thread_title": "DOJ's Loretta Lynch Tried To Squash Comey's Letter To Congress",
		"title": "",
		"type": "bs",
		"uuid": "ab91dd6c34d2fa54fdc3666a5dbe76c01a729a8b"
	},
	"-KhI_mKdHkHDdHd4mswO": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T18:41:33.878+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.29880774,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.1770827,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.14706248,
				"type": "PERSON"
			},
			{
				"name": "Everything",
				"salience": 0.08911505,
				"type": "OTHER"
			},
			{
				"name": "whitehouse",
				"salience": 0.05567915,
				"type": "PERSON"
			},
			{
				"name": "shock",
				"salience": 0.05567915,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.024519056,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.014729697,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.011966711,
				"type": "OTHER"
			},
			{
				"name": "fund",
				"salience": 0.011966711,
				"type": "OTHER"
			},
			{
				"name": "justice dept",
				"salience": 0.010818213,
				"type": "OTHER"
			},
			{
				"name": "theu",
				"salience": 0.008404338,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.008404338,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.008091788,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.008091788,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Switzerland"
				},
				"name": "Swiss",
				"salience": 0.007381459,
				"type": "LOCATION"
			},
			{
				"name": "looks",
				"salience": 0.0068658283,
				"type": "OTHER"
			},
			{
				"name": "Truth",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "complicity",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.005132831,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.004818131,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rj_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberty"
				},
				"name": "Liberty",
				"salience": 0.0042307647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0042307647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0042307647,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0036010253,
				"type": "ORGANIZATION"
			},
			{
				"name": "oath",
				"salience": 0.0031327321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.0031219947,
				"type": "PERSON"
			},
			{
				"name": "Notice Drudge",
				"salience": 0.0023034564,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-10-30T10:01:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "There is the guy who can leaf Trump to the whitehouse , imagine the shock . Everything he says is true and isnt it strnge how the Swiss fund all the wars and get away with it including Hitler . If Trump was ever after someone to trust he would be 1st choice and he knows his way around . Imagine how much money theu have ripped off . That justice dept is as crooked as can be . Trump was right about Hillary and ISIS  . So much for the Liberty party who has been higjacked by the looks of it . And where is the army ?? I think its what oath ?? All these people who did nothing are guilty of complicity in terror by their own laws . Truth should be rewarded not punished or you end up like the world is now as corrupt as can be , Notice Drudge wont even show this . ",
		"thread_title": "DOJ's Loretta Lynch Tried To Squash Comey's Letter To Congress",
		"title": "",
		"type": "bs",
		"uuid": "16382ab91afeb72dc5c7860da8c9a4eeaf12a496"
	},
	"-KhI_mPdtJ6pW1I7dahs": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T23:27:47.769+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "people",
				"salience": 0.7412198,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.25878018,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "6",
		"participants_count": "1",
		"published": "2016-10-31T01:40:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Same people all the time , i dont know how you can fix this corruption http://www.fromthewilderness.com/free/ww3/10_09_01_krongard.html",
		"thread_title": "Is This Why Comey Broke: A Stack Of Resignation Letters From Furious FBI Agents",
		"title": "",
		"type": "bs",
		"uuid": "362379cf974b85de90a836c751ac56742e77cccc"
	},
	"-KhI_mThiEPjYTdAxTpI": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T23:27:59.068+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "people",
				"salience": 0.7412198,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.25878018,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "6",
		"participants_count": "1",
		"published": "2016-10-31T01:40:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Same people all the time , i dont know how you can fix this corruption http://www.fromthewilderness.com/free/ww3/10_09_01_krongard.html",
		"thread_title": "Is it coming into clearer focus for Americans, or not?",
		"title": "",
		"type": "bs",
		"uuid": "80c6cd661e21919d9b57f41a68a977505fa0eeff"
	},
	"-KhI_mkIGuDcn40xD3fX": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T00:49:25.485+02:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T00:49:25.485+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "\n",
		"thread_title": "Why Hillary Clinton's Campaign Is Collapsing | True News",
		"title": "Why Hillary Clinton's Campaign Is Collapsing | True News",
		"type": "bs",
		"uuid": "98d6586f006a7d9ffeaf9f8d70962201a9b08df1"
	},
	"-KhI_mpwp5H-GaQED0SE": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T03:34:38.100+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Election fraud",
				"salience": 0.34378362,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02241w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bev_Harris"
				},
				"name": "Bev Harris",
				"salience": 0.32223555,
				"type": "PERSON"
			},
			{
				"name": "Fraction Magic&quot",
				"salience": 0.14658584,
				"type": "OTHER"
			},
			{
				"name": "Alex Jones Show",
				"salience": 0.08722015,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election computer fraud",
				"salience": 0.05190181,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.033880793,
				"type": "OTHER"
			},
			{
				"name": "http://www.infowars.com/watch-alex-jones-show/",
				"salience": 0.01439227,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-10-31T22:31:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Election fraud exposed on Alex Jones Show Oct. 31 2016, by Bev Harris with her &quot;Fraction Magic&quot; presentation on election computer fraud. http://www.infowars.com/watch-alex-jones-show/",
		"thread_title": "Why Hillary Clinton's Campaign Is Collapsing | True News",
		"title": "",
		"type": "bs",
		"uuid": "e398eb35bbc84a82b449c8fb2db103cdca728080"
	},
	"-KhI_oVWDpl2lrsOF8V0": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T03:43:08.657+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.12596418,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028z3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Pickton"
				},
				"name": "Robert William ``Willie'' Pickton",
				"salience": 0.12532264,
				"type": "PERSON"
			},
			{
				"name": "Andrew McCabe",
				"salience": 0.08716099,
				"type": "PERSON"
			},
			{
				"name": "AbelDanger.net",
				"salience": 0.06644189,
				"type": "OTHER"
			},
			{
				"name": "email probe",
				"salience": 0.029179012,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "Federal Bureau of Investigation",
				"salience": 0.026768632,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.017706623,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02dgtb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terry_McAuliffe"
				},
				"name": "Terry McAuliffe",
				"salience": 0.016184282,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.014128896,
				"type": "PERSON"
			},
			{
				"name": "Digital Fires Instructor Serco",
				"salience": 0.013874416,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.012632085,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.012321709,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.010278558,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04r3xz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crown_attorney"
				},
				"name": "Crown",
				"salience": 0.008076204,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Rajendran Hyman CBE",
				"salience": 0.0077765333,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0072415825,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.006441002,
				"type": "ORGANIZATION"
			},
			{
				"name": "email server",
				"salience": 0.0061468063,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.005806542,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0049977945,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.0049586473,
				"type": "PERSON"
			},
			{
				"name": "computer",
				"salience": 0.0047414196,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "snuff films",
				"salience": 0.0047344137,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Federal PKI Steering Committee",
				"salience": 0.0045494447,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.004240283,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "Comey",
				"salience": 0.004075527,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.0036565948,
				"type": "PERSON"
			},
			{
				"name": "Command",
				"salience": 0.0030827539,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0029481445,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.002944223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0178g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing"
				},
				"name": "Boeing",
				"salience": 0.0027722004,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.0027427138,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.0027318918,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0026107829,
				"type": "PERSON"
			},
			{
				"name": "Mar 2013 Serco Inc.",
				"salience": 0.0025798916,
				"type": "ORGANIZATION"
			},
			{
				"name": "wife",
				"salience": 0.002463124,
				"type": "PERSON"
			},
			{
				"name": "Field",
				"salience": 0.002381819,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.002216609,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.0021558488,
				"type": "PERSON"
			},
			{
				"name": "agencies",
				"salience": 0.0021558488,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.0021558488,
				"type": "ORGANIZATION"
			},
			{
				"name": "serial killer",
				"salience": 0.002098962,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.002052119,
				"type": "PERSON"
			},
			{
				"name": "farm",
				"salience": 0.0020309987,
				"type": "LOCATION"
			},
			{
				"name": "exercises",
				"salience": 0.0019933665,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0019885397,
				"type": "OTHER"
			},
			{
				"name": "headquarters office",
				"salience": 0.001897845,
				"type": "OTHER"
			},
			{
				"name": "defense agencies",
				"salience": 0.001897845,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigators",
				"salience": 0.0018806086,
				"type": "PERSON"
			},
			{
				"name": "Emails",
				"salience": 0.0018230256,
				"type": "WORK_OF_ART"
			},
			{
				"name": "laptop",
				"salience": 0.0018117384,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0017392846,
				"type": "LOCATION"
			},
			{
				"name": "FPKIPA",
				"salience": 0.0016909189,
				"type": "ORGANIZATION"
			},
			{
				"name": "servers",
				"salience": 0.001653826,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.001653826,
				"type": "OTHER"
			},
			{
				"name": "servers",
				"salience": 0.001653826,
				"type": "OTHER"
			},
			{
				"name": "Communications",
				"salience": 0.00162239,
				"type": "OTHER"
			},
			{
				"name": "command",
				"salience": 0.00162239,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0015843692,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0015789459,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.0015590558,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0015008749,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0014839286,
				"type": "OTHER"
			},
			{
				"name": "Governments",
				"salience": 0.0014839286,
				"type": "ORGANIZATION"
			},
			{
				"name": "server",
				"salience": 0.0014659452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "United States Marine",
				"salience": 0.0013630898,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0013621767,
				"type": "OTHER"
			},
			{
				"name": "Control",
				"salience": 0.0013621767,
				"type": "OTHER"
			},
			{
				"name": "murder-for-hire service",
				"salience": 0.0013501961,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0013360927,
				"type": "WORK_OF_ART"
			},
			{
				"name": "directors",
				"salience": 0.0012685126,
				"type": "PERSON"
			},
			{
				"name": "Director",
				"salience": 0.0012685126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0012288502,
				"type": "LOCATION"
			},
			{
				"name": "murders",
				"salience": 0.0012165634,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.0012165634,
				"type": "OTHER"
			},
			{
				"name": "Field",
				"salience": 0.0012165634,
				"type": "LOCATION"
			},
			{
				"name": "deaths",
				"salience": 0.0012165634,
				"type": "EVENT"
			},
			{
				"name": "plane",
				"salience": 0.0012165634,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0012165634,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.0012165634,
				"type": "EVENT"
			},
			{
				"name": "deaths",
				"salience": 0.0012165634,
				"type": "EVENT"
			},
			{
				"name": "team",
				"salience": 0.0011852722,
				"type": "ORGANIZATION"
			},
			{
				"name": "Emails",
				"salience": 0.0011846601,
				"type": "WORK_OF_ART"
			},
			{
				"name": "requirements",
				"salience": 0.0011602353,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.0011602353,
				"type": "OTHER"
			},
			{
				"name": "business units",
				"salience": 0.0011602353,
				"type": "ORGANIZATION"
			},
			{
				"name": "requirements",
				"salience": 0.0011602353,
				"type": "OTHER"
			},
			{
				"name": "system developer",
				"salience": 0.0011602353,
				"type": "ORGANIZATION"
			},
			{
				"name": "development",
				"salience": 0.0011602353,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0011602353,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0011602353,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.0011602353,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.0011118025,
				"type": "ORGANIZATION"
			},
			{
				"name": "many",
				"salience": 0.001103371,
				"type": "PERSON"
			},
			{
				"name": "combat service support",
				"salience": 0.0010984429,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0010984429,
				"type": "LOCATION"
			},
			{
				"name": "enterprise operations",
				"salience": 0.0010984429,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0010984429,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0010984429,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0010984429,
				"type": "OTHER"
			},
			{
				"name": "Andrew Mcabe",
				"salience": 0.0010849433,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.0010625845,
				"type": "OTHER"
			},
			{
				"name": "Business",
				"salience": 0.0010613562,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup d'etat",
				"salience": 0.00106065,
				"type": "ORGANIZATION"
			},
			{
				"name": "McConnell Plum City",
				"salience": 0.0010351646,
				"type": "OTHER"
			},
			{
				"name": "military disciplines",
				"salience": 0.0010295901,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.0010295901,
				"type": "PERSON"
			},
			{
				"name": "mentor",
				"salience": 0.0010295901,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.0010295901,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081yw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington_(state)"
				},
				"name": "Washington State",
				"salience": 0.0009986659,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01l4l4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Physical_Laboratory_(United_Kingdom)"
				},
				"name": "National Physical Laboratory",
				"salience": 0.0009720705,
				"type": "ORGANIZATION"
			},
			{
				"name": "law-enforcement officials",
				"salience": 0.00096297334,
				"type": "PERSON"
			},
			{
				"name": "pimps",
				"salience": 0.00095116405,
				"type": "OTHER"
			},
			{
				"name": "pimps",
				"salience": 0.00095116405,
				"type": "OTHER"
			},
			{
				"name": "Shareholders",
				"salience": 0.00095116405,
				"type": "PERSON"
			},
			{
				"name": "needs",
				"salience": 0.00095116405,
				"type": "OTHER"
			},
			{
				"name": "pedophile pimps",
				"salience": 0.00095116405,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.00095116405,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026789x"
				},
				"name": "David",
				"salience": 0.0008827605,
				"type": "PERSON"
			},
			{
				"name": "mishandling",
				"salience": 0.00086587656,
				"type": "EVENT"
			},
			{
				"name": "charges",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "pig farm raves",
				"salience": 0.00085880136,
				"type": "EVENT"
			},
			{
				"name": "child pornography",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "killings",
				"salience": 0.00085880136,
				"type": "EVENT"
			},
			{
				"name": "life",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.00085880136,
				"type": "LOCATION"
			},
			{
				"name": "Subsidiaries",
				"salience": 0.00085880136,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "ground combat",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "Gold",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "courses",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.00085880136,
				"type": "PERSON"
			},
			{
				"name": "loved ones",
				"salience": 0.00085880136,
				"type": "PERSON"
			},
			{
				"name": "whistle-blowers",
				"salience": 0.00085880136,
				"type": "PERSON"
			},
			{
				"name": "architecture",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00085880136,
				"type": "OTHER"
			},
			{
				"name": "Agents",
				"salience": 0.0008482819,
				"type": "PERSON"
			},
			{
				"name": "Comey Bureau Re Opening Investigation",
				"salience": 0.00083845,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01bkk6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_key_infrastructure"
				},
				"name": "PKI",
				"salience": 0.0008379724,
				"type": "OTHER"
			},
			{
				"name": "C4I",
				"salience": 0.00083680317,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00081661507,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.0008060365,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.00080243597,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/080h2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vancouver"
				},
				"name": "Vancouver",
				"salience": 0.0008002591,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01wlmc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Port_Coquitlam"
				},
				"name": "Port Coquitlam",
				"salience": 0.0008002591,
				"type": "LOCATION"
			},
			{
				"name": "agents",
				"salience": 0.00079125544,
				"type": "PERSON"
			},
			{
				"name": "laptop",
				"salience": 0.0007878332,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Bill Hiscox",
				"salience": 0.00078402547,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.0007812841,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0007812841,
				"type": "PERSON"
			},
			{
				"name": "Defense Ammunition Center",
				"salience": 0.0007807838,
				"type": "ORGANIZATION"
			},
			{
				"name": "Enterprise Architecture Center of Excellence",
				"salience": 0.0007807838,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.00076916354,
				"type": "LOCATION"
			},
			{
				"name": "brothers",
				"salience": 0.00076120463,
				"type": "PERSON"
			},
			{
				"name": "windows",
				"salience": 0.00076120463,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0007504671,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0007504671,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0007504671,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Types of Exercise Workshop",
				"salience": 0.00074986735,
				"type": "EVENT"
			},
			{
				"name": "fear",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "general",
				"salience": 0.00074364187,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.00074364187,
				"type": "ORGANIZATION"
			},
			{
				"name": "research",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "parole",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "enemy capabilities",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "fulfillment",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00074364187,
				"type": "PERSON"
			},
			{
				"name": "Copy",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "List",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "Teachers",
				"salience": 0.00074364187,
				"type": "PERSON"
			},
			{
				"name": "vulnerabilities",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "sentence",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "aviation",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "assassination",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.00074364187,
				"type": "OTHER"
			},
			{
				"name": "Computers and Intelligence",
				"salience": 0.0007141234,
				"type": "OTHER"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0007075932,
				"type": "PERSON"
			},
			{
				"name": "variety",
				"salience": 0.0007010819,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0006994185,
				"type": "ORGANIZATION"
			},
			{
				"name": "probe",
				"salience": 0.0006932952,
				"type": "EVENT"
			},
			{
				"name": "probe",
				"salience": 0.0006932952,
				"type": "EVENT"
			},
			{
				"name": "Command",
				"salience": 0.00068499136,
				"type": "ORGANIZATION"
			},
			{
				"name": "methods",
				"salience": 0.0006849644,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0006789012,
				"type": "ORGANIZATION"
			},
			{
				"name": "McConnell -- Global Operations",
				"salience": 0.0006760825,
				"type": "ORGANIZATION"
			},
			{
				"name": "Federal Bridge Certification Authority",
				"salience": 0.0006760825,
				"type": "ORGANIZATION"
			},
			{
				"name": "laptops",
				"salience": 0.00066808506,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.0006678348,
				"type": "PERSON"
			},
			{
				"name": "investigations",
				"salience": 0.00064862054,
				"type": "EVENT"
			},
			{
				"name": "relationships",
				"salience": 0.00063343835,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.0006264028,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0006250649,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021psw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Citizenship_and_Immigration_Services"
				},
				"name": "USCIS",
				"salience": 0.00062194915,
				"type": "ORGANIZATION"
			},
			{
				"name": "participants",
				"salience": 0.000614019,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07x3g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unified_Modeling_Language"
				},
				"name": "Unified Modeling Language",
				"salience": 0.0006027135,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Columbia"
				},
				"name": "British Columbia",
				"salience": 0.0006027135,
				"type": "LOCATION"
			},
			{
				"name": "parties",
				"salience": 0.00059494906,
				"type": "ORGANIZATION"
			},
			{
				"name": "official",
				"salience": 0.0005618232,
				"type": "PERSON"
			},
			{
				"name": "Women",
				"salience": 0.00056131533,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.00056067953,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.00054775074,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.00054775074,
				"type": "PERSON"
			},
			{
				"name": "field office",
				"salience": 0.00054775074,
				"type": "OTHER"
			},
			{
				"name": "agent",
				"salience": 0.00054775074,
				"type": "PERSON"
			},
			{
				"name": "field office",
				"salience": 0.00054775074,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.00054775074,
				"type": "PERSON"
			},
			{
				"name": "Others",
				"salience": 0.0005425656,
				"type": "PERSON"
			},
			{
				"name": "Laptop",
				"salience": 0.00054201914,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "laptop",
				"salience": 0.00054201914,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "officers",
				"salience": 0.0005373434,
				"type": "PERSON"
			},
			{
				"name": "Information Security Planning",
				"salience": 0.0005346571,
				"type": "OTHER"
			},
			{
				"name": "field offices",
				"salience": 0.00053403067,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.00053242466,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.0005307681,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.0005291595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00052856124,
				"type": "LOCATION"
			},
			{
				"name": "Abel Danger",
				"salience": 0.00052856124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01x1d8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Downtown_Eastside"
				},
				"name": "Downtown Eastside",
				"salience": 0.00052856124,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01gx66",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Honeywell"
				},
				"name": "Honeywell",
				"salience": 0.00052856124,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.0005273,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.0005273,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.00052571425,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.00052211276,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.00052211276,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.00051951164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00050649873,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00050649873,
				"type": "WORK_OF_ART"
			},
			{
				"name": "murders",
				"salience": 0.0005007233,
				"type": "PERSON"
			},
			{
				"name": "jury evidence",
				"salience": 0.0005007233,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0005007233,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0005007233,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.0005007233,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.0004922607,
				"type": "OTHER"
			},
			{
				"name": "field office",
				"salience": 0.0004886602,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.00048605635,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.00048605635,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.00048605635,
				"type": "OTHER"
			},
			{
				"name": "probes",
				"salience": 0.00048605635,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.00048605635,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.00048362708,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00048144237,
				"type": "WORK_OF_ART"
			},
			{
				"name": "events",
				"salience": 0.0004810501,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.00047753155,
				"type": "PERSON"
			},
			{
				"name": "farm",
				"salience": 0.00047753155,
				"type": "LOCATION"
			},
			{
				"name": "server",
				"salience": 0.00047728213,
				"type": "OTHER"
			},
			{
				"name": "command",
				"salience": 0.0004682048,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.0004682048,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0004682048,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.0004679085,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0206rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Sachs"
				},
				"name": "Sachs",
				"salience": 0.0004576748,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado_Springs,_Colorado"
				},
				"name": "Colorado Springs",
				"salience": 0.0004576748,
				"type": "LOCATION"
			},
			{
				"name": "Libranos",
				"salience": 0.0004576748,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.0004576748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "CA",
				"salience": 0.0004576748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.0004576748,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "CO",
				"salience": 0.0004576748,
				"type": "LOCATION"
			},
			{
				"name": "Uninterruptible Autopilot Extortion",
				"salience": 0.0004576748,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04mn99",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AXA"
				},
				"name": "AXA",
				"salience": 0.0004576748,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hkqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_Martin"
				},
				"name": "Lockheed Martin",
				"salience": 0.0004576748,
				"type": "ORGANIZATION"
			},
			{
				"name": "members",
				"salience": 0.0004524178,
				"type": "PERSON"
			},
			{
				"name": "sports organizations",
				"salience": 0.00045209093,
				"type": "ORGANIZATION"
			},
			{
				"name": "prostitutes",
				"salience": 0.00045209093,
				"type": "PERSON"
			},
			{
				"name": "service organizations",
				"salience": 0.00045209093,
				"type": "ORGANIZATION"
			},
			{
				"name": "farming operations",
				"salience": 0.00045209093,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00045072334,
				"type": "LOCATION"
			},
			{
				"name": "action committee",
				"salience": 0.00045072334,
				"type": "ORGANIZATION"
			},
			{
				"name": "statements",
				"salience": 0.00045072334,
				"type": "OTHER"
			},
			{
				"name": "government agencies",
				"salience": 0.00044714342,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.00044714342,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.00044714342,
				"type": "ORGANIZATION"
			},
			{
				"name": "official",
				"salience": 0.00044714342,
				"type": "PERSON"
			},
			{
				"name": "agencies",
				"salience": 0.00044714342,
				"type": "ORGANIZATION"
			},
			{
				"name": "contents",
				"salience": 0.00044060883,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00044017978,
				"type": "EVENT"
			},
			{
				"name": "TSymmetry, Inc.",
				"salience": 0.00043955626,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.00043823392,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.00043564977,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00042972557,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.00042950353,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00042950353,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/088zs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zulu_people"
				},
				"name": "Zulu",
				"salience": 0.00042444194,
				"type": "PERSON"
			},
			{
				"name": "tens of thousands",
				"salience": 0.00042374447,
				"type": "PERSON"
			},
			{
				"name": "court order",
				"salience": 0.00042374447,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.00042374447,
				"type": "OTHER"
			},
			{
				"name": "boar",
				"salience": 0.00042374447,
				"type": "OTHER"
			},
			{
				"name": "HeiTech Services, Inc.",
				"salience": 0.00042155763,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.0004196657,
				"type": "PERSON"
			},
			{
				"name": "participant",
				"salience": 0.0004171017,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0004171017,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0004171017,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0004171017,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0004171017,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.00041708932,
				"type": "OTHER"
			},
			{
				"name": "governor",
				"salience": 0.00041223658,
				"type": "PERSON"
			},
			{
				"name": "review",
				"salience": 0.00041154452,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00040825535,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.00040723072,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00040723072,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.00040399618,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.00040152788,
				"type": "OTHER"
			},
			{
				"name": "probes",
				"salience": 0.00039677846,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.00039677846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fzds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Patent_and_Trademark_Office"
				},
				"name": "U.S. Patent and Trademark Office",
				"salience": 0.00039337057,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.00039307436,
				"type": "EVENT"
			},
			{
				"name": "department",
				"salience": 0.00039307436,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00039202542,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00039202542,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00039202542,
				"type": "PERSON"
			},
			{
				"name": "pig",
				"salience": 0.0003914581,
				"type": "OTHER"
			},
			{
				"name": "email use",
				"salience": 0.0003914581,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0003914581,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0003914581,
				"type": "EVENT"
			},
			{
				"name": "management services",
				"salience": 0.00038961557,
				"type": "OTHER"
			},
			{
				"name": "bus",
				"salience": 0.00038943684,
				"type": "OTHER"
			},
			{
				"name": "Office of Partner Relations",
				"salience": 0.00038125663,
				"type": "OTHER"
			},
			{
				"name": "matters",
				"salience": 0.00037839753,
				"type": "OTHER"
			},
			{
				"name": "computer",
				"salience": 0.00037839753,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "matter",
				"salience": 0.00037839753,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00037839753,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00037839753,
				"type": "OTHER"
			},
			{
				"name": "computer",
				"salience": 0.00037839753,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "email investigators",
				"salience": 0.00037839753,
				"type": "PERSON"
			},
			{
				"name": "department",
				"salience": 0.00037839753,
				"type": "ORGANIZATION"
			},
			{
				"name": "content",
				"salience": 0.00037839753,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00037802904,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00037722156,
				"type": "PERSON"
			},
			{
				"name": "light",
				"salience": 0.00037657836,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00036930863,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.0003661715,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.0003658027,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "laptop",
				"salience": 0.0003658027,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "laptop",
				"salience": 0.0003658027,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "finding",
				"salience": 0.0003563487,
				"type": "OTHER"
			},
			{
				"name": "aide",
				"salience": 0.00035343622,
				"type": "PERSON"
			},
			{
				"name": "behalf",
				"salience": 0.00035343622,
				"type": "OTHER"
			},
			{
				"name": "raves",
				"salience": 0.00035343622,
				"type": "OTHER"
			},
			{
				"name": "charity",
				"salience": 0.00035343622,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00035343622,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.00035127983,
				"type": "ORGANIZATION"
			},
			{
				"name": "work",
				"salience": 0.00035103786,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00035103786,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00035103786,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00034956817,
				"type": "ORGANIZATION"
			},
			{
				"name": "governance",
				"salience": 0.00034956817,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0003445825,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.0003415499,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00034048714,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.00034048714,
				"type": "OTHER"
			},
			{
				"name": "email case",
				"salience": 0.00034048714,
				"type": "OTHER"
			},
			{
				"name": "foundation case",
				"salience": 0.00034048714,
				"type": "OTHER"
			},
			{
				"name": "group finance director",
				"salience": 0.00033920986,
				"type": "PERSON"
			},
			{
				"name": "visas",
				"salience": 0.00033899522,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00033595058,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0003347779,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.0003347779,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.00033399847,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00033343775,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00033242902,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00033242902,
				"type": "PERSON"
			},
			{
				"name": "metadata",
				"salience": 0.00033194793,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.00032340633,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00032227745,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.00032227745,
				"type": "EVENT"
			},
			{
				"name": "vehicle",
				"salience": 0.00032196133,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "participants",
				"salience": 0.0003215451,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.00032087252,
				"type": "EVENT"
			},
			{
				"name": "firms",
				"salience": 0.00032018937,
				"type": "ORGANIZATION"
			},
			{
				"name": "Serco , Inc.",
				"salience": 0.00032010596,
				"type": "ORGANIZATION"
			},
			{
				"name": "deputy director",
				"salience": 0.0003183638,
				"type": "PERSON"
			},
			{
				"name": "authority",
				"salience": 0.00031694132,
				"type": "ORGANIZATION"
			},
			{
				"name": "Table-top exercises",
				"salience": 0.00031435088,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0155qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_Corps_Base_Camp_Pendleton"
				},
				"name": "Camp Pendleton",
				"salience": 0.0003128185,
				"type": "LOCATION"
			},
			{
				"name": "participants",
				"salience": 0.00031155732,
				"type": "PERSON"
			},
			{
				"name": "warrant",
				"salience": 0.00031133043,
				"type": "OTHER"
			},
			{
				"name": "information systems",
				"salience": 0.0003063331,
				"type": "OTHER"
			},
			{
				"name": "minimum",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.00030603263,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "reasons",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00030603263,
				"type": "LOCATION"
			},
			{
				"name": "slaughterhouse",
				"salience": 0.00030603263,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.00030603263,
				"type": "PERSON"
			},
			{
				"name": "shows",
				"salience": 0.00030603263,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dances",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "functions",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "cellmate",
				"salience": 0.00030603263,
				"type": "PERSON"
			},
			{
				"name": "gatherings",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "dogs",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.00030603263,
				"type": "PERSON"
			},
			{
				"name": "duplicates",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "pigs",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.00030603263,
				"type": "EVENT"
			},
			{
				"name": "substance abuse",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "Background",
				"salience": 0.00030603263,
				"type": "OTHER"
			},
			{
				"name": "exhibitions",
				"salience": 0.00030603263,
				"type": "EVENT"
			},
			{
				"name": "board member",
				"salience": 0.00030510678,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0n5zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Component_Object_Model"
				},
				"name": "COM",
				"salience": 0.00030439848,
				"type": "OTHER"
			},
			{
				"name": "deputy director",
				"salience": 0.00029879864,
				"type": "PERSON"
			},
			{
				"name": "instruction",
				"salience": 0.00029706763,
				"type": "OTHER"
			},
			{
				"name": "NVC",
				"salience": 0.00029335896,
				"type": "ORGANIZATION"
			},
			{
				"name": "Some",
				"salience": 0.00029117748,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.00028655643,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00028655643,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.00028655643,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00028655643,
				"type": "OTHER"
			},
			{
				"name": "patent application",
				"salience": 0.00028655643,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.00028655643,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00028655643,
				"type": "OTHER"
			},
			{
				"name": "bureau",
				"salience": 0.00028597505,
				"type": "ORGANIZATION"
			},
			{
				"name": "messages",
				"salience": 0.00028597505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thousands",
				"salience": 0.00028597505,
				"type": "PERSON"
			},
			{
				"name": "tens of thousands",
				"salience": 0.00028597505,
				"type": "PERSON"
			},
			{
				"name": "messages",
				"salience": 0.00028597505,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00028548992,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00028548992,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00028548992,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0002796522,
				"type": "PERSON"
			},
			{
				"name": "board member",
				"salience": 0.00027566357,
				"type": "PERSON"
			},
			{
				"name": "wife",
				"salience": 0.00027443186,
				"type": "PERSON"
			},
			{
				"name": "accounts",
				"salience": 0.00027443186,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00027443186,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00027443186,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00027443186,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.00027443186,
				"type": "EVENT"
			},
			{
				"name": "requirements",
				"salience": 0.00027328284,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00027328284,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.00027328284,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.00027328284,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00027328284,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00026957341,
				"type": "OTHER"
			},
			{
				"name": "metadata",
				"salience": 0.0002641844,
				"type": "OTHER"
			},
			{
				"name": "second-in-command",
				"salience": 0.0002641844,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.0002641844,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0002641844,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0002641844,
				"type": "EVENT"
			},
			{
				"name": "update",
				"salience": 0.0002641844,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0002641844,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0002641844,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0002641844,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0002641844,
				"type": "EVENT"
			},
			{
				"name": "handful",
				"salience": 0.0002641844,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00026307828,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00026111046,
				"type": "ORGANIZATION"
			},
			{
				"name": "conflict",
				"salience": 0.00026067207,
				"type": "OTHER"
			},
			{
				"name": "prosecutors",
				"salience": 0.00025872223,
				"type": "PERSON"
			},
			{
				"name": "team",
				"salience": 0.00025872223,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00025872223,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00025872223,
				"type": "EVENT"
			},
			{
				"name": "prosecutors",
				"salience": 0.00025872223,
				"type": "PERSON"
			},
			{
				"name": "Others",
				"salience": 0.00025837784,
				"type": "PERSON"
			},
			{
				"name": "defenders",
				"salience": 0.00025837784,
				"type": "PERSON"
			},
			{
				"name": "wrongdoing",
				"salience": 0.0002562362,
				"type": "OTHER"
			},
			{
				"name": "instruction",
				"salience": 0.00025512095,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00025432708,
				"type": "OTHER"
			},
			{
				"name": "Offense The",
				"salience": 0.0002497307,
				"type": "WORK_OF_ART"
			},
			{
				"name": "needs",
				"salience": 0.00024794845,
				"type": "OTHER"
			},
			{
				"name": "needs",
				"salience": 0.00024794845,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.00024777523,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.00024777523,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.00024777523,
				"type": "LOCATION"
			},
			{
				"name": "start",
				"salience": 0.00024777523,
				"type": "EVENT"
			},
			{
				"name": "person",
				"salience": 0.00024777523,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00024777523,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00024777523,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00024777523,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00024559448,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0002432303,
				"type": "PERSON"
			},
			{
				"name": "Others",
				"salience": 0.0002424987,
				"type": "PERSON"
			},
			{
				"name": "disclosure",
				"salience": 0.0002424987,
				"type": "OTHER"
			},
			{
				"name": "bureau",
				"salience": 0.0002424987,
				"type": "ORGANIZATION"
			},
			{
				"name": "discussion",
				"salience": 0.0002424987,
				"type": "EVENT"
			},
			{
				"name": "trail",
				"salience": 0.00024173695,
				"type": "LOCATION"
			},
			{
				"name": "meeting",
				"salience": 0.00024173695,
				"type": "EVENT"
			},
			{
				"name": "Hell's Angel",
				"salience": 0.00024090715,
				"type": "ORGANIZATION"
			},
			{
				"name": "PGPubs) Classification Services",
				"salience": 0.00023977314,
				"type": "ORGANIZATION"
			},
			{
				"name": "complexity",
				"salience": 0.00023967536,
				"type": "OTHER"
			},
			{
				"name": "components",
				"salience": 0.00023967536,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00023967536,
				"type": "OTHER"
			},
			{
				"name": "warrant",
				"salience": 0.00023852302,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00023852302,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.00023852302,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.00023852302,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.00023852302,
				"type": "OTHER"
			},
			{
				"name": "press conference",
				"salience": 0.00023852302,
				"type": "EVENT"
			},
			{
				"name": "child pornography",
				"salience": 0.00023852302,
				"type": "OTHER"
			},
			{
				"name": "persona ones",
				"salience": 0.00023852302,
				"type": "OTHER"
			},
			{
				"name": "minor",
				"salience": 0.00023852302,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.00023852302,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.00023852302,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.00023673884,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.00023568104,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.00022828198,
				"type": "PERSON"
			},
			{
				"name": "update",
				"salience": 0.0002268804,
				"type": "OTHER"
			},
			{
				"name": "punchline",
				"salience": 0.00022570883,
				"type": "OTHER"
			},
			{
				"name": "prosecutors",
				"salience": 0.00022502597,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.00022402049,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00022402049,
				"type": "EVENT"
			},
			{
				"name": "agreements",
				"salience": 0.00022402049,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00022402049,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00022402049,
				"type": "OTHER"
			},
			{
				"name": "handling",
				"salience": 0.00022402049,
				"type": "OTHER"
			},
			{
				"name": "Exercises",
				"salience": 0.00022318668,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.00022318668,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00022286369,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.00022241432,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00022241432,
				"type": "LOCATION"
			},
			{
				"name": "petition",
				"salience": 0.00022189367,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00022189367,
				"type": "OTHER"
			},
			{
				"name": "metadata",
				"salience": 0.00022119662,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.00022091265,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.00021840836,
				"type": "OTHER"
			},
			{
				"name": "chain",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.00021454161,
				"type": "EVENT"
			},
			{
				"name": "refusal",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "displeasure",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "pursuit",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "entity",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "nowhere",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "bank records",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "state capitol",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "influence-peddling",
				"salience": 0.00021454161,
				"type": "EVENT"
			},
			{
				"name": "sway",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "subpoenas",
				"salience": 0.00021454161,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00021454161,
				"type": "EVENT"
			},
			{
				"name": "agents",
				"salience": 0.00021425226,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.00021404208,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.00021404208,
				"type": "OTHER"
			},
			{
				"name": "grouping",
				"salience": 0.00021404208,
				"type": "ORGANIZATION"
			},
			{
				"name": "planning",
				"salience": 0.00021404208,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.00021193444,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.00020937229,
				"type": "PERSON"
			},
			{
				"name": "presentation",
				"salience": 0.00020760231,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00020653027,
				"type": "LOCATION"
			},
			{
				"name": "email arrangement",
				"salience": 0.00020653027,
				"type": "OTHER"
			},
			{
				"name": "teenager",
				"salience": 0.00020653027,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00020653027,
				"type": "PERSON"
			},
			{
				"name": "examination",
				"salience": 0.00020653027,
				"type": "EVENT"
			},
			{
				"name": "dots",
				"salience": 0.00020653027,
				"type": "OTHER"
			},
			{
				"name": "vocal",
				"salience": 0.00020653027,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.00020653027,
				"type": "OTHER"
			},
			{
				"name": "campaign funds",
				"salience": 0.00020653027,
				"type": "OTHER"
			},
			{
				"name": "applicant",
				"salience": 0.00020604939,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ryjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cabinet_Office"
				},
				"name": "UK Cabinet Office",
				"salience": 0.0002055437,
				"type": "ORGANIZATION"
			},
			{
				"name": "Simulation",
				"salience": 0.00020484216,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.00020412708,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.00020412708,
				"type": "ORGANIZATION"
			},
			{
				"name": "procedures",
				"salience": 0.00020412708,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00020412708,
				"type": "OTHER"
			},
			{
				"name": "intensity",
				"salience": 0.00020412708,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.00020412708,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00020412708,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.00020412708,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00020412708,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.00020226001,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.00020226001,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.00020226001,
				"type": "OTHER"
			},
			{
				"name": "conduct",
				"salience": 0.00020226001,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.00020226001,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.00020226001,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.00020155396,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ftvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Little_Rock,_Arkansas"
				},
				"name": "Little Rock",
				"salience": 0.00020080985,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.00020047984,
				"type": "PERSON"
			},
			{
				"name": "finance director",
				"salience": 0.00019411817,
				"type": "PERSON"
			},
			{
				"name": "organisations",
				"salience": 0.00019325079,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisation",
				"salience": 0.00019325079,
				"type": "ORGANIZATION"
			},
			{
				"name": "simulation support",
				"salience": 0.00019325079,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00019325079,
				"type": "OTHER"
			},
			{
				"name": "teamwork",
				"salience": 0.00019325079,
				"type": "OTHER"
			},
			{
				"name": "high frequency trading",
				"salience": 0.00019325079,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00019244745,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.00019225285,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00019014865,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.00019014865,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00019014865,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.00018996776,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0001898294,
				"type": "OTHER"
			},
			{
				"name": "Huma Adein",
				"salience": 0.00018833244,
				"type": "PERSON"
			},
			{
				"name": "Midyear",
				"salience": 0.00018833244,
				"type": "OTHER"
			},
			{
				"name": "Tyler Durden",
				"salience": 0.00018833244,
				"type": "PERSON"
			},
			{
				"name": "DOJ Blocked Foundation Probe",
				"salience": 0.00018833244,
				"type": "OTHER"
			},
			{
				"name": "Piggy Palace Good Times Society",
				"salience": 0.00018833244,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawyer",
				"salience": 0.00018659895,
				"type": "PERSON"
			},
			{
				"name": "steps",
				"salience": 0.00018659895,
				"type": "OTHER"
			},
			{
				"name": "rigour",
				"salience": 0.00018424676,
				"type": "OTHER"
			},
			{
				"name": "Murder-for-Hire",
				"salience": 0.00018381776,
				"type": "OTHER"
			},
			{
				"name": "stand-down instruction",
				"salience": 0.0001834448,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.00018167884,
				"type": "ORGANIZATION"
			},
			{
				"name": "Command Post",
				"salience": 0.00018113237,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.00018113237,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00018113237,
				"type": "OTHER"
			},
			{
				"name": "roles",
				"salience": 0.00018113237,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.00017989129,
				"type": "PERSON"
			},
			{
				"name": "Participation",
				"salience": 0.00017829252,
				"type": "OTHER"
			},
			{
				"name": "Kabul for COM approval",
				"salience": 0.00017715828,
				"type": "OTHER"
			},
			{
				"name": "contractor",
				"salience": 0.00017676671,
				"type": "PERSON"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.00017672642,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nationals",
				"salience": 0.0001754503,
				"type": "PERSON"
			},
			{
				"name": "permission",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "bottom",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "obligations",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "Things",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "grants",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "remainder",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "setting",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "furor",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "immunity",
				"salience": 0.00017513076,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.0001707433,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.00016872845,
				"type": "OTHER"
			},
			{
				"name": "caesium fountain atomic clock",
				"salience": 0.00016859095,
				"type": "OTHER"
			},
			{
				"name": "prosecutor-shopping",
				"salience": 0.00016859095,
				"type": "OTHER"
			},
			{
				"name": "Federal PKI",
				"salience": 0.00016817718,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.00016732984,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.00016732984,
				"type": "OTHER"
			},
			{
				"name": "Head",
				"salience": 0.00016732984,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.00016732984,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.00016732984,
				"type": "OTHER"
			},
			{
				"name": "Agreements",
				"salience": 0.00016732984,
				"type": "OTHER"
			},
			{
				"name": "shareholder",
				"salience": 0.00016732984,
				"type": "OTHER"
			},
			{
				"name": "training benefit",
				"salience": 0.00016732984,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.00016732984,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.0001666292,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.00016253057,
				"type": "LOCATION"
			},
			{
				"name": "deputy director",
				"salience": 0.00016253057,
				"type": "PERSON"
			},
			{
				"name": "director",
				"salience": 0.00016253057,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.00016253057,
				"type": "LOCATION"
			},
			{
				"name": "Public Key Infrastructure Policy Authority",
				"salience": 0.00015921622,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hilllary",
				"salience": 0.00015921622,
				"type": "PERSON"
			},
			{
				"name": "application",
				"salience": 0.00015587104,
				"type": "OTHER"
			},
			{
				"name": "applicants",
				"salience": 0.00015587104,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.00015587104,
				"type": "OTHER"
			},
			{
				"name": "visa applications",
				"salience": 0.00015587104,
				"type": "OTHER"
			},
			{
				"name": "commerce",
				"salience": 0.00015529087,
				"type": "OTHER"
			},
			{
				"name": "State",
				"salience": 0.00015529087,
				"type": "LOCATION"
			},
			{
				"name": "statute",
				"salience": 0.00015529087,
				"type": "WORK_OF_ART"
			},
			{
				"name": "commerce",
				"salience": 0.00015529087,
				"type": "OTHER"
			},
			{
				"name": "statute",
				"salience": 0.00015529087,
				"type": "WORK_OF_ART"
			},
			{
				"name": "City",
				"salience": 0.00015107566,
				"type": "LOCATION"
			},
			{
				"name": "strategies",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.00015107566,
				"type": "EVENT"
			},
			{
				"name": "floor",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "decision making",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "Table Top",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "running banks",
				"salience": 0.00015107566,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.00015107566,
				"type": "LOCATION"
			},
			{
				"name": "exercise tempo",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "exercising package",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.00015107566,
				"type": "LOCATION"
			},
			{
				"name": "locations",
				"salience": 0.00015107566,
				"type": "LOCATION"
			},
			{
				"name": "tempo",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "decision making",
				"salience": 0.00015107566,
				"type": "OTHER"
			},
			{
				"name": "Serco Processes 2 Millionth Patent Application",
				"salience": 0.0001492319,
				"type": "OTHER"
			},
			{
				"name": "firms",
				"salience": 0.00014865048,
				"type": "ORGANIZATION"
			},
			{
				"name": "leader",
				"salience": 0.00014865048,
				"type": "PERSON"
			},
			{
				"name": "processes",
				"salience": 0.00014865048,
				"type": "OTHER"
			},
			{
				"name": "firms",
				"salience": 0.00014865048,
				"type": "ORGANIZATION"
			},
			{
				"name": "veteran firms",
				"salience": 0.00014865048,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00014865048,
				"type": "ORGANIZATION"
			},
			{
				"name": "firms",
				"salience": 0.00014865048,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.000146189,
				"type": "PERSON"
			},
			{
				"name": "chief executive",
				"salience": 0.00014553577,
				"type": "PERSON"
			},
			{
				"name": "cooperation",
				"salience": 0.00014295908,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.000142029,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.00014072988,
				"type": "OTHER"
			},
			{
				"name": "teams",
				"salience": 0.00014072988,
				"type": "ORGANIZATION"
			},
			{
				"name": "business operations",
				"salience": 0.00014072988,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00014072988,
				"type": "OTHER"
			},
			{
				"name": "visa files",
				"salience": 0.00014072988,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.00014072988,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.00013918956,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.00013833905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Trade_Center_(1973%E2%80%932001)"
				},
				"name": "World Trade Center",
				"salience": 0.00013734693,
				"type": "LOCATION"
			},
			{
				"name": "National Partnership for Reinventing Government",
				"salience": 0.0001323258,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Ark.",
				"salience": 0.00013202662,
				"type": "LOCATION"
			},
			{
				"name": "visa petitions",
				"salience": 0.00013190474,
				"type": "OTHER"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.00013190474,
				"type": "PERSON"
			},
			{
				"name": "Forensic Economist",
				"salience": 0.00013190474,
				"type": "PERSON"
			},
			{
				"name": "petition",
				"salience": 0.00013190474,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.00013190474,
				"type": "WORK_OF_ART"
			},
			{
				"name": "post",
				"salience": 0.00013190474,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.00013190474,
				"type": "OTHER"
			},
			{
				"name": "petitions",
				"salience": 0.00013190474,
				"type": "OTHER"
			},
			{
				"name": "Base One Technologies",
				"salience": 0.00013171919,
				"type": "ORGANIZATION"
			},
			{
				"name": "equipment",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "Punk",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "information flow",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "mix",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "rehearsal",
				"salience": 0.00013081134,
				"type": "EVENT"
			},
			{
				"name": "aspects",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "coordination",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "media play",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "government customers",
				"salience": 0.00013081134,
				"type": "PERSON"
			},
			{
				"name": "allegations",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "graduation",
				"salience": 0.00013081134,
				"type": "EVENT"
			},
			{
				"name": "readiness",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "environment",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"name": "utilization",
				"salience": 0.00013081134,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0158jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_service"
				},
				"name": "Civil Service",
				"salience": 0.00013042212,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02dqk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Foreign_Service"
				},
				"name": "Foreign Service",
				"salience": 0.00013042212,
				"type": "ORGANIZATION"
			},
			{
				"name": "contracts",
				"salience": 0.00013036894,
				"type": "OTHER"
			},
			{
				"name": "DKW Communications, Inc.",
				"salience": 0.00012794124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.00012709633,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.00012709633,
				"type": "PERSON"
			},
			{
				"name": "Pre-Grant Publication",
				"salience": 0.00012446837,
				"type": "ORGANIZATION"
			},
			{
				"name": "mail",
				"salience": 0.000121853205,
				"type": "OTHER"
			},
			{
				"name": "Staffing",
				"salience": 0.000121853205,
				"type": "OTHER"
			},
			{
				"name": "employers",
				"salience": 0.000121853205,
				"type": "ORGANIZATION"
			},
			{
				"name": "employees",
				"salience": 0.000121853205,
				"type": "PERSON"
			},
			{
				"name": "contract employees",
				"salience": 0.000121853205,
				"type": "PERSON"
			},
			{
				"name": "domains",
				"salience": 0.00011969579,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00011642531,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.00011642531,
				"type": "EVENT"
			},
			{
				"name": "murder-for-hire",
				"salience": 0.00011642531,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00011642531,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.00011377341,
				"type": "OTHER"
			},
			{
				"name": "package",
				"salience": 0.000112843416,
				"type": "OTHER"
			},
			{
				"name": "Super Serco",
				"salience": 0.000111802525,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0294qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Attorney"
				},
				"name": "United States Attorney's Office",
				"salience": 0.000111802525,
				"type": "ORGANIZATION"
			},
			{
				"name": "development",
				"salience": 0.000111031935,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.000111031935,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.000111031935,
				"type": "OTHER"
			},
			{
				"name": "intent",
				"salience": 0.000111031935,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.000110440196,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00011001633,
				"type": "PERSON"
			},
			{
				"name": "safety",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "Citizenship",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "Strategy",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00011001633,
				"type": "LOCATION"
			},
			{
				"name": "file rooms",
				"salience": 0.00011001633,
				"type": "LOCATION"
			},
			{
				"name": "measures",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "visa pre-processing",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "Information Security Counter",
				"salience": 0.00011001633,
				"type": "ORGANIZATION"
			},
			{
				"name": "documents",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "incident documentation",
				"salience": 0.00011001633,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00010919334,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.00010904798,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lgh_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_District_Court_for_the_Eastern_District_of_New_York"
				},
				"name": "Eastern District of New York",
				"salience": 0.000107772794,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.000107772794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cr3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brooklyn"
				},
				"name": "Brooklyn",
				"salience": 0.000107772794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.000107772794,
				"type": "LOCATION"
			},
			{
				"name": "Profit growth",
				"salience": 0.00010590793,
				"type": "OTHER"
			},
			{
				"name": "Special Immigrant Visa",
				"salience": 0.00010383279,
				"type": "OTHER"
			},
			{
				"name": "BUSINESS CORPORATION",
				"salience": 0.00010149737,
				"type": "ORGANIZATION"
			},
			{
				"name": "Transitional Immigrant Visa Processing Center",
				"salience": 0.0001000186,
				"type": "ORGANIZATION"
			},
			{
				"name": "handling.",
				"salience": 0.00009946819,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00009852379,
				"type": "LOCATION"
			},
			{
				"name": "economy",
				"salience": 0.00009852379,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00009852379,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.00009852379,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.00009852379,
				"type": "OTHER"
			},
			{
				"name": "death penalty",
				"salience": 0.00009568677,
				"type": "EVENT"
			},
			{
				"name": "mentoring goals",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "implements",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "adjudication",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "Yours",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "preprocessing",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "fiancé",
				"salience": 0.00009525919,
				"type": "PERSON"
			},
			{
				"name": "airline",
				"salience": 0.00009525919,
				"type": "ORGANIZATION"
			},
			{
				"name": "shelves",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "IT positions",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "military pilot",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "honey-pots",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "Information Security Expertise",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "computer hackers",
				"salience": 0.00009525919,
				"type": "PERSON"
			},
			{
				"name": "data theft",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "appointment scheduling",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "successor",
				"salience": 0.00009525919,
				"type": "PERSON"
			},
			{
				"name": "Clients",
				"salience": 0.00009525919,
				"type": "PERSON"
			},
			{
				"name": "filing",
				"salience": 0.00009525919,
				"type": "EVENT"
			},
			{
				"name": "inception",
				"salience": 0.00009525919,
				"type": "EVENT"
			},
			{
				"name": "pieces",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "paperwork",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "fees",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "logging",
				"salience": 0.00009525919,
				"type": "EVENT"
			},
			{
				"name": "dreams",
				"salience": 0.00009525919,
				"type": "OTHER"
			},
			{
				"name": "embassies",
				"salience": 0.00009525919,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09bbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gold_standard"
				},
				"name": "Gold Standard",
				"salience": 0.00009296924,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02q26r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_of_Professional_Responsibility"
				},
				"name": "OPR",
				"salience": 0.00009296924,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00009296924,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09v06q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Emergency_Planning_College"
				},
				"name": "Emergency Planning College",
				"salience": 0.00009296924,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mentor Protégé",
				"salience": 0.00009296924,
				"type": "OTHER"
			},
			{
				"name": "order book",
				"salience": 0.000091701855,
				"type": "WORK_OF_ART"
			},
			{
				"name": "goodbye",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "goodwill",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "death results",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "sharing",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "accomplishments",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "mail",
				"salience": 0.00009101586,
				"type": "OTHER"
			},
			{
				"name": "concurrence",
				"salience": 0.000089805704,
				"type": "OTHER"
			},
			{
				"name": "time line",
				"salience": 0.00008716451,
				"type": "OTHER"
			},
			{
				"name": "Federal Bridge",
				"salience": 0.000086602464,
				"type": "LOCATION"
			},
			{
				"name": "role",
				"salience": 0.00008461083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "DHS",
				"salience": 0.00008262682,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.00008217442,
				"type": "LOCATION"
			},
			{
				"name": "innovation",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "guidelines",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00008217442,
				"type": "EVENT"
			},
			{
				"name": "management",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "innovation",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "guidance",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "prisons",
				"salience": 0.00008217442,
				"type": "LOCATION"
			},
			{
				"name": "violation",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "conduct",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "penalty",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "violation",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00008217442,
				"type": "OTHER"
			},
			{
				"name": "North Tower",
				"salience": 0.000080498634,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tjvv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Durban"
				},
				"name": "Durban",
				"salience": 0.000080498634,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.000080498634,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09p6s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arthur_Andersen"
				},
				"name": "Arthur Andersen",
				"salience": 0.000080498634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g9jc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ernst_%26_Young"
				},
				"name": "Ernst & Young",
				"salience": 0.000080498634,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.000080498634,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.000080498634,
				"type": "LOCATION"
			},
			{
				"name": "Mentor Protégé Team Award",
				"salience": 0.000078481855,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.00007775944,
				"type": "OTHER"
			},
			{
				"name": "file number",
				"salience": 0.00007677918,
				"type": "OTHER"
			},
			{
				"name": "Section",
				"salience": 0.00007677918,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0262dl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Private_company_limited_by_shares"
				},
				"name": "Ltd.",
				"salience": 0.00007555103,
				"type": "LOCATION"
			},
			{
				"name": "Field McConnell",
				"salience": 0.00007498585,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0619_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portsmouth"
				},
				"name": "Portsmouth",
				"salience": 0.00007498585,
				"type": "LOCATION"
			},
			{
				"name": "CSI Crime and Safety Investigation",
				"salience": 0.00007498585,
				"type": "OTHER"
			},
			{
				"name": "COM",
				"salience": 0.00007498585,
				"type": "ORGANIZATION"
			},
			{
				"name": "rise",
				"salience": 0.00007485558,
				"type": "OTHER"
			},
			{
				"name": "Centre of Carbon Measurement",
				"salience": 0.00007470673,
				"type": "ORGANIZATION"
			},
			{
				"name": "another",
				"salience": 0.00007335902,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00007335902,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "farewell",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00007115175,
				"type": "EVENT"
			},
			{
				"name": "forest bulldozers",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "airport radar",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "dividends",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "opportunities",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "defence budgets",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "uses",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "life imprisonment",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "fine",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "injury",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "severity",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "receipt",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "facility",
				"salience": 0.00007115175,
				"type": "LOCATION"
			},
			{
				"name": "breadth",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00007115175,
				"type": "ORGANIZATION"
			},
			{
				"name": "achievements",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "carbon emissions reductions",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"name": "footprint",
				"salience": 0.00007115175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03b9f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_jury"
				},
				"name": "Grand Juries",
				"salience": 0.000069131,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/028j0m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minority_group"
				},
				"name": "Minority",
				"salience": 0.00006770154,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01t_55",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_minister"
				},
				"name": "Secretary of State",
				"salience": 0.00006770154,
				"type": "PERSON"
			},
			{
				"name": "Disabled Veteran",
				"salience": 0.00006770154,
				"type": "PERSON"
			},
			{
				"name": "David Hawkins Tel",
				"salience": 0.00006770154,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01dfb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citigroup"
				},
				"name": "Citigroup",
				"salience": 0.00006770154,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07cx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Telephone"
				},
				"name": "Tel",
				"salience": 0.00006770154,
				"type": "LOCATION"
			},
			{
				"name": "promotion",
				"salience": 0.00006623274,
				"type": "OTHER"
			},
			{
				"name": "Government Information Technology Services Board",
				"salience": 0.000060629165,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_hj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Aviation_Administration"
				},
				"name": "FAA",
				"salience": 0.00005862017,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pentagon Renovation Program",
				"salience": 0.00005862017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.00005862017,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.00005862017,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.00005862017,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g7w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MCI_Inc."
				},
				"name": "MCI",
				"salience": 0.00005862017,
				"type": "ORGANIZATION"
			},
			{
				"name": "We practice Diversity (Pride) Recruitment",
				"salience": 0.00005862017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.00005862017,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00005862017,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/026vq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Services_Administration"
				},
				"name": "GSA",
				"salience": 0.00005862017,
				"type": "ORGANIZATION"
			},
			{
				"name": "SIV",
				"salience": 0.00005862017,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02rf6d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rosslyn,_Arlington,_Virginia"
				},
				"name": "Rosslyn",
				"salience": 0.00005862017,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g8fs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Naval_Academy"
				},
				"name": "United States Naval Academy",
				"salience": 0.00005862017,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.00005600889,
				"type": "ORGANIZATION"
			},
			{
				"name": "surplus",
				"salience": 0.000055911587,
				"type": "OTHER"
			},
			{
				"name": "USAM 9",
				"salience": 0.000043784847,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02fvf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Docklands_Light_Railway"
				},
				"name": "Docklands Light Railway",
				"salience": 0.000043784847,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.000043784847,
				"type": "LOCATION"
			},
			{
				"name": "Part A",
				"salience": 0.000043784847,
				"type": "OTHER"
			},
			{
				"name": "X",
				"salience": 0.000043784847,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c0sl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NPR"
				},
				"name": "NPR",
				"salience": 0.000043784847,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0c0d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_of_Management_and_Budget"
				},
				"name": "OMB",
				"salience": 0.000043784847,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ch",
				"salience": 0.000043784847,
				"type": "LOCATION"
			},
			{
				"name": "Pub.L. 98",
				"salience": 0.000043784847,
				"type": "LOCATION"
			},
			{
				"name": "Comprehensive Crime Control Act of 1984",
				"salience": 0.000043784847,
				"type": "WORK_OF_ART"
			},
			{
				"name": "http://gits-sec.treas.gov",
				"salience": 0.000043784847,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0000434573,
				"type": "LOCATION"
			},
			{
				"name": "victim",
				"salience": 0.000041579937,
				"type": "PERSON"
			},
			{
				"name": "victim",
				"salience": 0.000041579937,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T03:43:08.657+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 74.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "United States Marine Field McConnell  Plum City Online - ( AbelDanger.net )  October 31, 2016 \n1. Abel Danger ( AD ) claims that Clinton Foundation donors use 8(a) servers for online assassination betting and the trade in child pornography and torture killings as first staged in 1996 at pig farm raves in B.C. allegedly sponsored by so-called 'Libranos' in the Canadian government. \n\n2. AD claims that Hillary Clinton or her aide Huma Abedin hired pedophile pimps to entrap and extort the directors of Boeing into mentoring the Federal Bridge Certification Authority, outsourcing C4I developments to Serco , moving the Boeing headquarters office from Washington State to Chicago in 2001 and attempting a bridge-based coup d'etat on 9/11. \n\n3. AD claims that Serco has been providing a murder-for-hire service to Clinton donors by synchronizing Zulu death betting on 8(a) servers with in-flight snuff films which victims watch as they are flown to their deaths and with which loved ones and potential whistle-blowers are silenced by fear. \n\n4. United States Marine Field McConnell – Global Operations Director of Abel Danger – has offered to serve as a five-star general in a Trump administration to help Trump destroy the Clinton bridge of pimps and obtain justice for victims of 'death by plane'. \n\nFBI's Comey Bureau Re Opening Investigation into Hillary Clinton's Emails!! October 28, 2016    \nBoeing Honeywell Uninterruptible Autopilot Extortion of Lockheed Martin – a mentor of Clinton’s bridge of pimps.  \n\nCopy of SERCO GROUP PLC: List of Subsidiaries AND Shareholders! [Note British and Saudi Governments, AXA, HSBC , Teachers' and Gold man Sachs]    \nDefense Ammunition Center [Outsourced to Serco ]   \nSerco ... Would you like to know more?  \n\n\"Digital Fires Instructor Serco - Camp Pendleton, CA Uses information derived from all military disciplines (e.g., aviation, ground combat, command and control, combat service support, intelligence, and opposing forces) to determine changes in enemy capabilities, vulnerabilities, and probable courses of action.\" \n\n\" Serco 's Enterprise Architecture Center of Excellence is based in Colorado Springs, CO. The team provides a variety of services in support of Boeing’s business units as well as research and development efforts. Serco 's architecture employs object-oriented (OO)/Unified Modeling Language (UML) to define, design and satisfy defense agencies' mission-critical requirements, including Command, Control, Communications, Computers and Intelligence (C4I). This approach improves system developer's understanding of operational requirements and how best to integrate enterprise operations and systems for the optimal fulfillment of C4I and other operational needs.\" \n\n\" Robert William \"Willie\" Pickton (born October 24, 1949)[ 2 ] of Port Coquitlam , British Columbia , Canada, is a former multi-millionaire pig farmer[ 3 ] and serial killer convicted in 2007 of the second-degree murders of six women.[4][ 5 ] He was also charged in the deaths of an additional twenty women,[6] many of them from Vancouver's Downtown Eastside; however, these charges were stayed by the Crown in 2010.[7] In December 2007, he was sentenced to life in prison, with no possibility of parole for 25 years – the longest sentence then available under Canadian law for murder.[8] \n\nDuring the trial's first day of jury evidence, January 22, 2007, the Crown stated he confessed to 49 murders to an undercover police officer posing as a cellmate . The Crown reported that Pickton told the officer that he wanted to kill another woman to make it an even 50, and that he was caught because he was \"sloppy\".[9] Background[edit] \n\nBy 1992, Robert William Pickton and his brother David owned a Port Coquitlam farm. Worker Bill Hiscox called it a \"creepy-looking place\", noting that it was patrolled by a 600-lb. (270 kg) boar , one of the few actual pigs on the farm. \"I never saw a pig like that, who would chase you and bite at you,\" he said. \"It was running out with the dogs around the property.\" He later described Pickton as a \"pretty quiet guy, hard to strike up a conversation with,\" whose occasionally bizarre behavior, despite no evidence of substance abuse , would draw attention. \n\nPickton's only vehicle was a converted bus, with deeply tinted windows, to which he was emotionally attached. The Pickton brothers gradually neglected the site's farming operations. They registered a non-profit charity, the Piggy Palace Good Times Society, with the Canadian government in 1996 as aiming to \"organize, co-ordinate, manage and operate special events, functions, dances, shows and exhibitions on behalf of service organizations, sports organizations and other worthy groups.\" Its events included raves and wild parties featuring Vancouver prostitutes and gatherings in a converted slaughterhouse. These events attracted as many as 2,000 people. Hell's Angel members were known to often frequent the farm.\" \n\n\"650,000 Emails Found On Anthony Weiner's Laptop; DOJ Blocked Foundation Probe   \nby Tyler Durden   \nOct 30, 2016 10:34 PM  \nYesterday, we reported that the FBI has found \" tens of thousands of emails \" belonging to Huma Adein on Anthony Weiner's computer, raising questions how practical it is that any conclusive finding will be available or made by the FBI in the few days left before the elections Now, according to the WSJ , it appears that Federal agents are preparing to scour roughly 650,000 emails that, as we reported moments ago were discovered weeks ago on the laptop of Anthony Weiner , to see how many relate to a prior probe of Hillary Clinton's email use, as metadata on the device suggests there may be thousands sent to or from the private server that the Democratic nominee used while she was secretary of state, according to people familiar with the matter. \n\nAs the WSJ adds, the review will take weeks at a minimum to determine whether those messages are work-related emails between Huma Abedin, a close Clinton aide and the estranged wife of Mr. Weiner, and State Department officials; how many are duplicates of emails already reviewed by the Federal Bureau of Investigation; and whether they include either classified information or important new evidence in the Clinton email probe, which FBI officials call \"Midyear.\" \n\nAnd, as we further reported earlier today , the FBI has had to await a court order to begin reviewing the emails, because they were uncovered in an unrelated probe of Mr. Weiner, and that order was delayed for reasons that remain unclear. \n\nMore stunning is just how many emails were found on Weiner's computer. And while one can only imagine the content of some of the more persona ones, the WSJ writes that the latest development began in early October when New York-based FBI officials notified Andrew McCabe, the bureau's second-in-command, that while investigating Mr. Weiner for possibly sending sexually charged messages to a minor, they had recovered a laptop with 650,000 emails. Many, they said, were from the accounts of Ms. Abedin, according to people familiar with the matter. \n\nThose emails stretched back years , these people said, and were on a laptop that both Mr. Weiner and Ms. Abedin used and that hadn't previously come up in the Clinton email probe. Ms. Abedin said in late August that the couple were separating. \n\nThe FBI had searched the computer while looking for child pornography, people familiar with the matter said, but the warrant they used didn't give them authority to search for matters related to Mrs. Clinton's email arrangement at the State Department. Mr. Weiner has denied sending explicit or indecent messages to the teenager. \n\nAs reported yesterday, it appears that there are potentially tens of thousands of Abedin linked emails on Weiner's computer: \n\nIn their initial review of the laptop, the metadata showed many messages, apparently in the thousands, that were either sent to or from the private email server at Mrs. Clinton's home that had been the focus of so much investigative effort for the FBI. Senior FBI officials decided to let the Weiner investigators proceed with a closer examination of the metadata on the computer, and report back to them. \n\nThe WSJ then connects the dots between how the Weiner emails were linked to the Clinton reopening of the Clinton probe, despite Loretta Lynch's and the DOJ's vocal urges not to do so : \n\nAt a meeting early last week of senior Justice Department and FBI officials, a member of the department’s senior national-security staff asked for an update on the Weiner laptop, the people familiar with the matter said. At that point, officials realized that no one had acted to obtain a warrant, these people said. \n\nMr. McCabe then instructed the email investigators to talk to the Weiner investigators and see whether the laptop’s contents could be relevant to the Clinton email probe, these people said. After the investigators spoke, the agents agreed it was potentially relevant. \n\nMr. Comey was given an update, decided to go forward with the case and notified Congress on Friday, with explosive results. Senior Justice Department officials had warned Mr. Comey that telling Congress would violate well-established policies against overt actions that could affect an election, and some within the FBI have been unhappy at Mr. Comey's repeated public statements on the probe, going back to his first press conference on the subject in July. \n\nBut wait it gets better. \n\nRecall that this is the same Andrew Mcabe whose wife the Wall Street Journal reported last week received $467,500 in campaign funds in late 2015 from the political action committee of Virginia Gov. Terry McAuliffe, a longtime ally of the Clintons and, until he was elected governor in November 2013, a Clinton Foundation board member. \n\nMr. McAuliffe had supported Dr. McCabe in the hopes she and a handful of other Democrats might help win a majority in the state Senate, giving Mr. McAuliffe more sway in the state capitol. Dr. McCabe lost her race last November, and Democrats failed to win their majority. \n\nFBI officials have said Mr. McCabe had no role in the Clinton email probe until he became deputy director, and there was no conflict of interest because by then his wife's campaign was over. Which brings us to the second big topic: the Clinton Foundation, and how the DOJ made sure that particular probe never made the light of day. At the same time as the Clinton server was being investigated, other Clinton-related investigations were under way within the FBI, and they have been the subject of internal debate for months. \n\nEarly this year, four FBI field offices—New York, Los Angeles, Washington and Little Rock, Ark.—were collecting information about the Clinton Foundation to see if there was evidence of financial crimes or influence-peddling, according to people familiar with the matter. \n\nThe WSJ touches on something fascinating: Los Angeles agents had picked up information about the Clinton Foundation from an unrelated public corruption case and had issued some subpoenas for bank records related to the foundation, these people said. So where did that trail go? Apparently nowhere. \n\nThe Washington field office was probing financial relationships involving Mr. McAuliffe before he became a Clinton Foundation board member, these people said. Mr. McAuliffe has denied any wrongdoing, and his lawyer has said the probe is focused on whether he failed to register as an agent of a foreign entity. The FBI field office in New York had done the most work on the Clinton Foundation case and received help from the FBI field office in Little Rock, the people familiar with the matter said. \n\nIn February, FBI officials made a presentation to the Justice Department, according to these people. By all accounts, the meeting didn't go well. \n\nSome said that is because the FBI didn’t present compelling evidence to justify more aggressive pursuit of the Clinton Foundation, and that the career public integrity prosecutors in the room simply believed it wasn't a very strong case. Others said that from the start, the Justice Department officials were stern, icy and dismissive of the case. \n\n\"That was one of the weirdest meetings I've ever been to,\" one participant told others afterward, according to people familiar with the matter. \n\nNeedless to say, the probe into the Foundation faded. \n\nBut back to the Clinton probe, according to a person familiar with the probes, on Aug. 12, a senior Justice Department official called Mr. McCabe to voice his displeasure at finding that New York FBI agents were still openly pursuing the Clinton Foundation probe, despite the department's refusal to allow more aggressive investigative methods in the case. Mr. McCabe said agents still had the authority to pursue the issue as long as they didn’t use those methods. \n\nAt this point a question emerges: did McCabe seek to defend or press on with a Clinton probe: Mr. McCabe’s defenders in the agency said that following the call, he repeated the instruction that he had given earlier in the Clinton Foundation investigation: Agents were to keep pursuing the work within the authority they had. \n\nOthers further down the FBI chain of command, however, said agents were given a much starker instruction on the case: “Stand down.” When agents questioned why they weren’t allowed to take more aggressive steps, they said they were told the order had come from the deputy director—Mr. McCabe. Others familiar with the matter deny Mr. McCabe or any other senior FBI official gave such a stand-down instruction. \n\nAt this point the two probes, into Hillary's email and the Clinton Foundation converged: \n\nFor agents who already felt uneasy about FBI leadership’s handling of the Clinton Foundation case, the moment only deepened their concerns, these people said. For those who felt the probe hadn’t yet found significant evidence of criminal conduct, the leadership’s approach was the right response to the facts on the ground. \n\nThings accelerated over the past two months, when in September, agents on the foundation case asked to see the emails contained on nongovernment laptops that had been searched as part of the Clinton email case, but that request was rejected by prosecutors at the Eastern District of New York, in Brooklyn. Those emails were given to the FBI based on grants of partial immunity and limited-use agreements, meaning agents could only use them for the purpose of investigating possible mishandling of classified information. \n\nSome FBI agents were dissatisfied with that answer, and asked for permission to make a similar request to federal prosecutors in Manhattan, according to people familiar with the matter. Mr. McCabe, these people said, told them no and added that they could not “go prosecutor-shopping.\" \n\nNot long after that discussion, FBI agents informed the bureau’s leaders about the Weiner laptop, prompting Mr. Comey's disclosure to Congress and setting of the furor that promises to consume the final days of a tumultuous campaign \n\nWhile much of the latest developments are known, or could have been inferred assuming more corruption within government agencies, the punchline is that the weeks if not months of upcoming work means that if Clinton wins the White House, she will likely do so amid at least one ongoing investigation into her inner circle being handled by law-enforcement officials who are deeply divided over how to manage such cases. It also means that Trump will be hounding Hilllary for the remainder of the campaign as being the only presidential candidate to seek election with a recently reopened criminal probe hanging over her head.\" \n\n\" Serco Processes 2 Millionth Patent Application for U.S. Patent and Trademark  \nOffice Date: 18 Mar 2013 Serco Inc., a leading provider of professional, technology, and management services to the federal government, announced today that their Pre-Grant Publication (PGPubs) Classification Services team recently processed their 2 millionth patent application for the U.S. Patent & Trademark Office (USPTO). Each application was also processed within the contractually required 28-day window.\" \n\n\"3.4.1 Federal Public Key Infrastructure Policy Authority (FPKIPA)  \nAny infrastructure which cuts across multiple agencies requires the cooperation of the affected agencies to make it work. The Federal PKI is no different. While agencies may run their own agency-specific PKI domains to serve their own agency-specific needs, interoperating with other agencies imposes unique requirements and obligations. The model of governance reflects the fact that the Federal PKI has evolved from the bottom up, from agencies adopting this technology to serve their specific needs rather than having its use prescribed for them. In 1996, the Federal PKI Steering Committee was formed under the Government Information Technology Services Board, co-chaired by OMB and the National Partnership for Reinventing Government (NPR). The Steering Committee, comprising over 50 members representing over two dozen agencies, has as its focus the promotion of interoperable PKI solutions, the development of common guidance, and the sharing of information so that agencies considering or deploying PKI solutions can benefit from those who have already done so. Participation in the Steering Committee is voluntary. Its activities are published at http://gits-sec.treas.gov .\" \n\n\"1107. Murder-for-Hire—The Offense  \nThe \"murder-for-hire\" statute, 18 U.S.C. § 1958, was enacted as part of the Comprehensive Crime Control Act of 1984, Pub.L. 98-473, Ch. X, Part A (Oct. 12, 1984). Section 1958(a) provides: \n\nWhoever travels in or causes another (including the intended victim) to travel in interstate or foreign commerce, or uses or causes another (including the intended victim) to use the mail or any facility of interstate or foreign commerce, with intent that a murder be committed in violation of the laws of any State or the United States as consideration for the receipt of, or as consideration for a promise or agreement to pay anything of pecuniary value, or who conspires to do so [violates this statute]. \n\n… The maximum penalty for violating § 1958 varies with the severity of the conduct: a fine and/or ten years for any violation; a fine and/or twenty years if personal injury results; and a fine of not more than $250,000 and/or death or life imprisonment if death results. If the death penalty might be applicable, the United States Attorney's Office must comply with the guidelines at USAM 9-10.000 .\" \n\n\"Super Serco bulldozes ahead  \nBy DAILY MAIL REPORTER UPDATED: 23:00 GMT, 1 September 2004 \nSERCO has come a long way since the 1960s when it ran the 'four-minute warning' system to alert the nation to a ballistic missile attack. \n\nToday its £10.3bn order book is bigger than many countries' defence budgets. It is bidding for a further £8bn worth of contracts and sees £16bn of 'opportunities'. \n\nProfit growth is less ballistic. The first-half pre-tax surplus rose 4% to £28.1m, net profits just 1% to £18m. Stripping out goodwill, the rise was 17%, with dividends up 12.5% to 0.81p. \n\nSerco runs the Docklands Light Railway, five UK prisons, airport radar and forest bulldozers in Florida.\"  \n\n\" Serco farewell to NPL after 19 years of innovation 8 January 2015 Serco said goodbye to the National Physical Laboratory (NPL) at the end of December 2014 after 19 years of extraordinary innovation and science that has seen the establishment build a world-leading reputation and deliver billions of pounds of benefit for the UK economy. During that period under Serco 's management and leadership, NPL has delivered an extraordinary variety and breadth of accomplishments for the UK's economy and industry. Some of the key achievements during that time have been:… It has been estimated that work carried out by the Centre of Carbon Measurement at NPL will save eight million tonnes of carbon emissions reductions (2% of UK footprint) and over half a billion pounds in economic benefit over the next decade…. NPL's caesium fountain atomic clock is accurate to 1 second in 158 million years and NPL is playing a key role in introducing rigour to high frequency trading [for Serco 's front running banks] in the City through NPL [Zulu] Time.\" \n\n\"UK Cabinet Office – Emergency Planning College – Serco …..Types of Exercise Workshop Exercises These are structured discussion events where participants can explore issues in a less pressurised environment. They are an ideal way of developing solutions, procedures and plans rather than the focus being on decision making. Table Top Exercises These involve a realistic scenario and will follow a time line, either in real-time or with time jumps to concentrate on the more important areas. The participants would be expected to be familiar with the plans and procedures that are being used although the exercise tempo and complexity can be adjusted to suit the current state of training and readiness. Simulation and media play can be used to support the exercise. Table-top exercises help develop teamwork and allow participants to gain a better understanding of their roles and that of other agencies and organisations. Command/Control Post Exercises These are designed primarily to exercise the senior leadership and support staff in collective planning and decision making within a strategic grouping. Ideally such exercises would be run from the real command and control locations and using their communications and information systems [Feeling lucky, Punk?] . This could include a mix of locations and varying levels of technical simulation support. The Gold Standard system is flexible to allow the tempo and intensity to be adjusted to ensure maximum training benefit, or to fully test and evaluate the most important aspects of a plan. Such exercises also test information flow, communications, equipment, procedures, decision making and coordination. Live Exercises These can range from testing individual components of a system or organisation through to a full-scale rehearsal. They are particularly useful where there are regulatory requirements or with high-risk situations. They are more complex and costly to organise and deliver but can be integrated with Command Post Exercises as part of a wider exercising package.\"  \n\n\"Christopher Rajendran Hyman CBE (born 5 July 1963 in Durban, South Africa)[1] was Chief Executive of Serco Group plc from 2002 to October 2013.[2] … On graduation, he worked for Arthur Andersen. In 1989, he won an 18-month exchange with Ernst & Young in London, who employed him after four months.[1] Head hunted in 1994 by Serco , Hyman became European finance director, and in 1999 was made group finance director. In 2002, Hyman became chief executive. .. Hyman resigned from his role of Chief Executive of Serco on 25 October 2013 following allegations that Serco had overcharged government customers. .. He was [making a presentation to Serco shareholder, including British and Saudi governments] on the 47th floor of the World Trade Center [North Tower] at the time of the September 11 attacks in 2001.\"  \n\n\"Serco's Office of Partner Relations (OPR) helps facilitate our aggressive small business utilization and growth strategies. Through the OPR, Serco mentors four local small businesses under formal Mentor Protégé Agreements: Three sponsored by DHS (Base One Technologies, TSymmetry, Inc., and HeiTech Services, Inc.,) and the fourth sponsored by GSA (DKW Communications, Inc.). Serco and HeiTech Services were awarded the 2007 DHS Mentor Protégé Team Award for exceeding our mentoring goals.\" \n\n\"Base One Technologies, Ltd. is a DOMESTIC BUSINESS CORPORATION, located in New York, NY and was formed on Feb 15, 1994. This file was obtained from the Secretary of State and has a file number of 1795583. \" \n\n\"Base One Technologies – Corporate Strategy – We are a Government Certified Women-Owned Business   \nWe practice Diversity [Pride] Recruitment and Staffing for IT positions .. We are also partnered with firms that are 8A certified as Minority firms, Disabled Veteran firms, Native American firms, Vietnam veteran firms, women owned firms. .. Information Security Planning is the process whereby an organization seeks to protect its operations and assets from data theft or computer hackers that seek to obtain unauthorized information or sabotage business operations. Key Clients Benefiting From Our Information Security Expertise: Pentagon Renovation Program, FAA, Citigroup [Federal Bridge] , MCI. .. Base One Technologies … Develops, implements and supports Information Security Counter measures such as honey-pots and evidence logging and incident documentation processes and solutions.\"  \n\n\"Opened in 1994 as the successor to the Transitional Immigrant Visa Processing Center in Rosslyn, Va., the NVC centralizes all immigrant visa pre-processing and appointment scheduling for overseas posts. The NVC collects paperwork and fees before forwarding a case, ready for adjudication, to the responsible post. \n\nThe center also handles immigrant and fiancé visa petitions, and while it does not adjudicate visa applications, it provides technical assistance and support to visa-adjudicating consular officials overseas. \n\nOnly two Foreign Service officers, the director and deputy director, work at the center, along with just five Civil Service employees. They work with almost 500 contract employees doing preprocessing of visas, making the center one of the largest employers in the Portsmouth area. \n\nThe contractor, Serco , Inc., has worked with the NVC since its inception and with the Department for almost 18 years. \n\nThe NVC houses more than 2.6 million immigrant visa files, receives almost two million pieces of mail per year and received more than half a million petitions from the U.S. Citizenship and Immigration Service (USCIS) in 2011. Its file rooms' high-density shelves are stacked floor-to-ceiling with files, each a collection of someone’s hopes and dreams and each requiring proper handling. …. \n\nThe NVC also preprocesses the chief of mission (COM) application required for the filing of a petition for a Special Immigrant Visa (SIV). Such visas, for foreign nationals who have performed services for the U.S. government in Iraq and Afghanistan, require COM concurrence before the applicant can file a petition with USCIS. The NVC collects the requisite documents from such applicants and, when complete, forwards the package to the U.S. embassies in Baghdad or Kabul for COM approval\" \n\nYours sincerely, \n\nField McConnell, United States Naval Academy, 1971; Forensic Economist; 30 year airline and 22 year military pilot; 23,000 hours of safety; Tel: 715 307 8222 \n\nDavid Hawkins Tel: 604 542-0891 Forensic Economist; former leader of oil-well blow-out teams; now sponsors Grand Juries in CSI Crime and Safety Investigation",
		"thread_title": "#2820: Clinton 8(a) Pig Farm Servers – Boeing Bridge Of Pimps – Serco In-Flight Zulu Snuff",
		"title": "#2820: Clinton 8(a) Pig Farm Servers – Boeing Bridge Of Pimps – Serco In-Flight Zulu Snuff",
		"type": "bs",
		"uuid": "0d6d76e138b4c0bf2b5ef3a985fd05d6477daf46"
	},
	"-KhI_och9V7_eTlSxCk5": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T08:32:30.307+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "soldier",
				"salience": 0.60302764,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.2793764,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.06965631,
				"type": "OTHER"
			},
			{
				"name": "insult",
				"salience": 0.04793968,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-11-01T02:52:00.000+02:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Every soldier that ever went to war for these turkey&#39;s should be out there screaming the place down . What an insult . ",
		"thread_title": "Why Hillary Clinton's Campaign Is Collapsing | True News",
		"title": "",
		"type": "bs",
		"uuid": "12a52a11a8a9a430f1386316782c57b2e8d9f41b"
	},
	"-KhI_owDI9ydAmdOm3Uy": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T08:32:30.316+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Election fraud",
				"salience": 0.34378362,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02241w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bev_Harris"
				},
				"name": "Bev Harris",
				"salience": 0.32223555,
				"type": "PERSON"
			},
			{
				"name": "Fraction Magic&quot",
				"salience": 0.14658584,
				"type": "OTHER"
			},
			{
				"name": "Alex Jones Show",
				"salience": 0.08722015,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election computer fraud",
				"salience": 0.05190181,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.033880793,
				"type": "OTHER"
			},
			{
				"name": "http://www.infowars.com/watch-alex-jones-show/",
				"salience": 0.01439227,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-10-31T22:31:00.000+02:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Election fraud exposed on Alex Jones Show Oct. 31 2016, by Bev Harris with her &quot;Fraction Magic&quot; presentation on election computer fraud. http://www.infowars.com/watch-alex-jones-show/",
		"thread_title": "Why Hillary Clinton's Campaign Is Collapsing | True News",
		"title": "",
		"type": "bs",
		"uuid": "a7213108eabfa8b3d788bd23c5b2dd8a354ae3bb"
	},
	"-KhI_qNt3BYhqZVBerDs": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T09:56:04.637+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.12672698,
				"type": "ORGANIZATION"
			},
			{
				"name": "insiders",
				"salience": 0.09340735,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.036241326,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.030883944,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0xnh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Prince_Andrew,_Duke_of_York"
				},
				"name": "Andrew",
				"salience": 0.025375085,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.023006683,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.02028107,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fz196",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Epstein"
				},
				"name": "Jeffrey Epstein",
				"salience": 0.019503461,
				"type": "PERSON"
			},
			{
				"name": "Creatives",
				"salience": 0.01780867,
				"type": "PERSON"
			},
			{
				"name": "senior analyst",
				"salience": 0.017601367,
				"type": "PERSON"
			},
			{
				"name": "file",
				"salience": 0.017555423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048lv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kevin_Spacey"
				},
				"name": "Kevin Spacey",
				"salience": 0.016791085,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.016497914,
				"type": "OTHER"
			},
			{
				"name": "insider",
				"salience": 0.014158055,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.012710178,
				"type": "ORGANIZATION"
			},
			{
				"name": "Victurus Libertas",
				"salience": 0.012679058,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.011010465,
				"type": "LOCATION"
			},
			{
				"name": "detectives",
				"salience": 0.010595727,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.010191414,
				"type": "PERSON"
			},
			{
				"name": "BOMBSHELL",
				"salience": 0.009949412,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.008998884,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.008998884,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.008998884,
				"type": "OTHER"
			},
			{
				"name": "Jim Comey",
				"salience": 0.007894836,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.007508659,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.007508659,
				"type": "OTHER"
			},
			{
				"name": "Situation",
				"salience": 0.007295604,
				"type": "OTHER"
			},
			{
				"name": "Scandal",
				"salience": 0.0070386906,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.0070386906,
				"type": "OTHER"
			},
			{
				"name": "email scandal",
				"salience": 0.0070386906,
				"type": "OTHER"
			},
			{
				"name": "computer",
				"salience": 0.0065032654,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Source",
				"salience": 0.0065032654,
				"type": "ORGANIZATION"
			},
			{
				"name": "computer",
				"salience": 0.0065032654,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "farce",
				"salience": 0.006469741,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0064333733,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.00611535,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nations",
				"salience": 0.006099972,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016lb3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eliot_Ness"
				},
				"name": "Eliot Ness",
				"salience": 0.0059952694,
				"type": "PERSON"
			},
			{
				"name": "government officials",
				"salience": 0.0055618607,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.0055575054,
				"type": "OTHER"
			},
			{
				"name": "SICK",
				"salience": 0.0054184757,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.005170611,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.005085907,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.005085907,
				"type": "PERSON"
			},
			{
				"name": "deals",
				"salience": 0.005085907,
				"type": "OTHER"
			},
			{
				"name": "avenues",
				"salience": 0.005085907,
				"type": "LOCATION"
			},
			{
				"name": "order",
				"salience": 0.005085907,
				"type": "OTHER"
			},
			{
				"name": "games",
				"salience": 0.005085907,
				"type": "EVENT"
			},
			{
				"name": "entities",
				"salience": 0.005085907,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/097qj4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alan_Dershowitz"
				},
				"name": "Alan Dershowitz",
				"salience": 0.0049143876,
				"type": "PERSON"
			},
			{
				"name": "file",
				"salience": 0.004467137,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.004092077,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israelis",
				"salience": 0.004004684,
				"type": "PERSON"
			},
			{
				"name": "players",
				"salience": 0.0039099865,
				"type": "PERSON"
			},
			{
				"name": "insider",
				"salience": 0.0038355945,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.003708038,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.003708038,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0034704953,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0034257285,
				"type": "PERSON"
			},
			{
				"name": "field agents",
				"salience": 0.003256373,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.003131402,
				"type": "ORGANIZATION"
			},
			{
				"name": "TWISTED Turn",
				"salience": 0.003131402,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gw_xk8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ghislaine_Maxwell"
				},
				"name": "Ghislaine Maxwell",
				"salience": 0.0030957635,
				"type": "PERSON"
			},
			{
				"name": "file",
				"salience": 0.003093222,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.003093222,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.003093222,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0029432534,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/015tvw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Secret_Intelligence_Service"
				},
				"name": "Secret Intelligence Service",
				"salience": 0.0028675785,
				"type": "ORGANIZATION"
			},
			{
				"name": "plea bargain",
				"salience": 0.0027852387,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0027332068,
				"type": "WORK_OF_ART"
			},
			{
				"name": "scandal",
				"salience": 0.0027213183,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0026669507,
				"type": "WORK_OF_ART"
			},
			{
				"name": "some",
				"salience": 0.0026647788,
				"type": "PERSON"
			},
			{
				"name": "breadcrumbs",
				"salience": 0.0026430115,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0025812387,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012m5s7l"
				},
				"name": "Virginia Roberts",
				"salience": 0.002540582,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.0024806734,
				"type": "LOCATION"
			},
			{
				"name": "agents",
				"salience": 0.0024021599,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.002370981,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.0023125082,
				"type": "PERSON"
			},
			{
				"name": "Kingpin",
				"salience": 0.0022949905,
				"type": "ORGANIZATION"
			},
			{
				"name": "content",
				"salience": 0.0021755206,
				"type": "WORK_OF_ART"
			},
			{
				"name": "players",
				"salience": 0.002168942,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0021146324,
				"type": "OTHER"
			},
			{
				"name": "photos",
				"salience": 0.0020943223,
				"type": "WORK_OF_ART"
			},
			{
				"name": "TEENAGER",
				"salience": 0.0020943223,
				"type": "PERSON"
			},
			{
				"name": "help",
				"salience": 0.0020943223,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0020879894,
				"type": "OTHER"
			},
			{
				"name": "creatives",
				"salience": 0.0020266136,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0019269902,
				"type": "LOCATION"
			},
			{
				"name": "computer",
				"salience": 0.0018781485,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "investigation",
				"salience": 0.0018781485,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0018080438,
				"type": "OTHER"
			},
			{
				"name": "investigators",
				"salience": 0.0018080438,
				"type": "PERSON"
			},
			{
				"name": "actor",
				"salience": 0.0018080438,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0017706752,
				"type": "ORGANIZATION"
			},
			{
				"name": "congressmen",
				"salience": 0.0016957811,
				"type": "PERSON"
			},
			{
				"name": "targets",
				"salience": 0.0016957811,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.0016957811,
				"type": "OTHER"
			},
			{
				"name": "senators",
				"salience": 0.0016882067,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0016836273,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01lhw0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Classified_information"
				},
				"name": "TOP SECRET",
				"salience": 0.0016487921,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Department of Justice",
				"salience": 0.0016477858,
				"type": "ORGANIZATION"
			},
			{
				"name": "MORE",
				"salience": 0.0016324804,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.0015906659,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0015602777,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_n44",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Untouchables_(1959_TV_series)"
				},
				"name": "The Untouchables",
				"salience": 0.0015406162,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0015332551,
				"type": "PERSON"
			},
			{
				"name": "actors",
				"salience": 0.0015332551,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0015332551,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0015269263,
				"type": "LOCATION"
			},
			{
				"name": "kid gloves",
				"salience": 0.0015061187,
				"type": "OTHER"
			},
			{
				"name": "geniuses",
				"salience": 0.0014871393,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.001468399,
				"type": "OTHER"
			},
			{
				"name": "lobbyists",
				"salience": 0.001468399,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.001468399,
				"type": "EVENT"
			},
			{
				"name": "team",
				"salience": 0.001468399,
				"type": "ORGANIZATION"
			},
			{
				"name": "home",
				"salience": 0.001468399,
				"type": "LOCATION"
			},
			{
				"name": "probe",
				"salience": 0.001468399,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0014649811,
				"type": "OTHER"
			},
			{
				"name": "players",
				"salience": 0.0014272936,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.0014135827,
				"type": "OTHER"
			},
			{
				"name": "panic",
				"salience": 0.0014135827,
				"type": "EVENT"
			},
			{
				"name": "prison",
				"salience": 0.0014135827,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.0013843636,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.0013326833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0013231308,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0013227172,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jw5r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Lieberman"
				},
				"name": "Joe Lieberman",
				"salience": 0.0012890624,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0012890624,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07p9j68"
				},
				"name": "Intimate",
				"salience": 0.0012890624,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bymv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_McCain"
				},
				"name": "John McCain",
				"salience": 0.0012890624,
				"type": "PERSON"
			},
			{
				"name": "DNC Nuclear Arsenal",
				"salience": 0.0012890624,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01_pdg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lindsey_Graham"
				},
				"name": "Lindsey Graham",
				"salience": 0.0012890624,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/047lj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kazakhstan"
				},
				"name": "Kazakhstan",
				"salience": 0.0012890624,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/021wy4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Life_insurance"
				},
				"name": "Life Insurance",
				"salience": 0.0012890624,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0012890624,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0012890624,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.0012772004,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0012728173,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016hk4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ehud_Barak"
				},
				"name": "Ehud Barak",
				"salience": 0.0012166414,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.0011987245,
				"type": "LOCATION"
			},
			{
				"name": "superiors",
				"salience": 0.0011987245,
				"type": "PERSON"
			},
			{
				"name": "several",
				"salience": 0.0011987245,
				"type": "PERSON"
			},
			{
				"name": "touch",
				"salience": 0.0011987245,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0011987245,
				"type": "OTHER"
			},
			{
				"name": "brilliance",
				"salience": 0.0011987245,
				"type": "OTHER"
			},
			{
				"name": "hackers",
				"salience": 0.0011987245,
				"type": "PERSON"
			},
			{
				"name": "malcontents",
				"salience": 0.0011987245,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0011987245,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0011987245,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0011987245,
				"type": "PERSON"
			},
			{
				"name": "magnitude",
				"salience": 0.0011987245,
				"type": "OTHER"
			},
			{
				"name": "Insider",
				"salience": 0.0011946714,
				"type": "OTHER"
			},
			{
				"name": "Insider",
				"salience": 0.0011946714,
				"type": "OTHER"
			},
			{
				"name": "INSIDER",
				"salience": 0.0011946714,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0011747659,
				"type": "PERSON"
			},
			{
				"name": "Administration",
				"salience": 0.0011394289,
				"type": "ORGANIZATION"
			},
			{
				"name": "friends",
				"salience": 0.0011018116,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.0010614177,
				"type": "PERSON"
			},
			{
				"name": "sex",
				"salience": 0.0010527438,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0010437141,
				"type": "ORGANIZATION"
			},
			{
				"name": "friend",
				"salience": 0.0010341092,
				"type": "PERSON"
			},
			{
				"name": "pedophiles",
				"salience": 0.0010341092,
				"type": "OTHER"
			},
			{
				"name": "sex slave",
				"salience": 0.0010341092,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0010047471,
				"type": "ORGANIZATION"
			},
			{
				"name": "sex",
				"salience": 0.0009633068,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.0009633068,
				"type": "OTHER"
			},
			{
				"name": "Bill",
				"salience": 0.0009633068,
				"type": "WORK_OF_ART"
			},
			{
				"name": "girls",
				"salience": 0.00094989996,
				"type": "PERSON"
			},
			{
				"name": "creature",
				"salience": 0.00094691647,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0009037435,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0009037435,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0009037435,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0009037435,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026swz9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cheryl_Mills"
				},
				"name": "Cheryl Mills",
				"salience": 0.0009037435,
				"type": "PERSON"
			},
			{
				"name": "mansion",
				"salience": 0.0008954264,
				"type": "LOCATION"
			},
			{
				"name": "day pass",
				"salience": 0.0008954264,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0008954264,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0008954264,
				"type": "OTHER"
			},
			{
				"name": "defense lawyers",
				"salience": 0.0008954264,
				"type": "PERSON"
			},
			{
				"name": "insiders",
				"salience": 0.00089239853,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "NYC",
				"salience": 0.00087000104,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.00084040256,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.0008378603,
				"type": "ORGANIZATION"
			},
			{
				"name": "Everywhere",
				"salience": 0.000834117,
				"type": "LOCATION"
			},
			{
				"name": "People",
				"salience": 0.000834117,
				"type": "PERSON"
			},
			{
				"name": "vagina",
				"salience": 0.00081935147,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0007969678,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.0007869229,
				"type": "PERSON"
			},
			{
				"name": "More",
				"salience": 0.0007531032,
				"type": "OTHER"
			},
			{
				"name": "Scandal",
				"salience": 0.00074647553,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02vnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Espionage"
				},
				"name": "ESPIONAGE",
				"salience": 0.00073774776,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00073774776,
				"type": "LOCATION"
			},
			{
				"name": "Cicada 3301",
				"salience": 0.00073774776,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0007217448,
				"type": "PERSON"
			},
			{
				"name": "victim girls",
				"salience": 0.0006786275,
				"type": "PERSON"
			},
			{
				"name": "sentence",
				"salience": 0.00067739165,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00067444355,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.00067444355,
				"type": "PERSON"
			},
			{
				"name": "EXPLOSIVE",
				"salience": 0.0006520988,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.0006520988,
				"type": "OTHER"
			},
			{
				"name": "Child Sex Trafficking Network",
				"salience": 0.0006520988,
				"type": "OTHER"
			},
			{
				"name": "Currency",
				"salience": 0.0006520988,
				"type": "OTHER"
			},
			{
				"name": "E-mails",
				"salience": 0.0006520988,
				"type": "OTHER"
			},
			{
				"name": "CF",
				"salience": 0.0006520988,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0006520988,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h3rv9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Cards_(U.S._TV_series)"
				},
				"name": "House of Cards",
				"salience": 0.0006364249,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Government",
				"salience": 0.00062585104,
				"type": "ORGANIZATION"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0006230548,
				"type": "PERSON"
			},
			{
				"name": "Minister of Defense",
				"salience": 0.0006230548,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0006230548,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0005671729,
				"type": "LOCATION"
			},
			{
				"name": "corruption",
				"salience": 0.0005625372,
				"type": "OTHER"
			},
			{
				"name": "whistleblowers",
				"salience": 0.0005625372,
				"type": "PERSON"
			},
			{
				"name": "pedophile",
				"salience": 0.0005625372,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.0005510667,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.0005172007,
				"type": "PERSON"
			},
			{
				"name": "Vistors",
				"salience": 0.0005059811,
				"type": "PERSON"
			},
			{
				"name": "DEAD BOX whistleblower encryption method",
				"salience": 0.0004870876,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0004870876,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0004870876,
				"type": "PERSON"
			},
			{
				"name": "darkness",
				"salience": 0.0004870876,
				"type": "OTHER"
			},
			{
				"name": "Israeli Secret Intelligence Service",
				"salience": 0.00046347055,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rothschild Thread - Clinton Foundation",
				"salience": 0.00040520018,
				"type": "ORGANIZATION"
			},
			{
				"name": "Abel Danger",
				"salience": 0.0004013066,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02szg2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/4chan"
				},
				"name": "4chan",
				"salience": 0.0004013066,
				"type": "OTHER"
			},
			{
				"name": "Q & A",
				"salience": 0.0004013066,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Paid in Money & Children - Hammer HRC",
				"salience": 0.0004013066,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0004013066,
				"type": "LOCATION"
			},
			{
				"name": "Ask Me Anything About the Clinton Case",
				"salience": 0.0004013066,
				"type": "WORK_OF_ART"
			},
			{
				"name": "http://victuruslibertas.com/2016/10/insiders-reveal-sex-ring/",
				"salience": 0.0004013066,
				"type": "OTHER"
			},
			{
				"name": "Little St. James Island",
				"salience": 0.0002997521,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_nk8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chamber_of_Deputies"
				},
				"name": "Deputy",
				"salience": 0.0002997521,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Binyamin Netanyahu",
				"salience": 0.0002997521,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0002997521,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T09:56:04.637+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 24.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "BREAKING BOMBSHELL! FBI NYPD INSIDERS LEAK - Email Scandal About to Take a SICK and TWISTED Turn    \nSource: Victurus Libertas  \n\n\nAll of the following information was given to us by our insiders who have specific first-hand knowledge of the Hillary Clinton email scandal. It seems that things are about to heat up. We are told that of the 662,871 emails lifted from Anthony Weiner's computer, 11,112 emails are Huma Abedin's… and pay to play – including Saudis and Israelis. Meaning Huma was the one Hillary USED to communicate with foreign leaders via email for inside information and deals via Huma's computer. \n\nIt has been established through many avenues, but mainly through Wikileaks, that the Clinton Foundation was just a farce set up in order to perform pay-to-play games with multiple entities, including foreign nations. Pay-to-play nations include: Israel, Saudi Arabia, Turkey, Qatar, Kazakhstan, and the Ukraine. \nFurthermore, we are told by one of our insiders that one email unequivocally confirms ISIS was created by CIA and Israeli Secret Intelligence Service , with help from Joe Lieberman, John McCain, and Lindsey Graham! An NYPD insider said the content they viewed did include State Department TOP SECRET emails. One file was called \"Life Insurance\". A second file was titled \" DNC Nuclear Arsenal \". \n\nA third file I'm sure Hillary definitely DOES NOT want released was a file labeled \"Intimate\" … according to this NYPD insider, this file contained X-rated photos of Huma and Hillary with a TEENAGER . \n\nNYPD detectives were sickened by what they saw, according to our insider, and they had threatened FBI field agents that they would leak this information, if the FBI did not \"step up and take off the kid gloves\" . At that point, 13 of the FBI agents in NYC were also threatening to leak the information. \n\nAs you can imagine, the scandal has the entire Obama Administration in full panic. We are told there are emails that could send Loretta Lynch to prison , as well as Bill and Hillary. The Twitter post below, our sources sent us, verifying it is all true: \n\n\n\n\nEven MORE! \n\nThe following information comes straight from an FBI Anonymous source, who is the senior analyst who posted on 4chan in early July of this year: \n\nJim Comey learned that some of his own investigators were tipping off both Loretta Lynch and Bill Clinton, thus making his job impossible. \n\nComey sent a letter to Congress, knowing that ultimately it would expose Loretta Lynch as a dirty actor and the breadcrumbs would lead directly to Obama . The State Department is terrified now. Comey has assembled a small team of 40 agents, whom he has declared \"The Untouchables\" after the famous federal agent Eliot Ness. \n\nComey has clamped down on all FBI agents and he expects a full-scale war between the FBI and the Department of Justice (DOJ), the White House, and the State Department. He has confirmed and understands that many sitting senators, congressmen, lobbyists, and power players are going to be indicted and prosecuted . One of the main targets of the probe is the Clinton Foundation and Clinton Global Initiative. Among the targets under investigation are John Podesta, Huma, Cheryl Mills, CNN, ABC, NBC, etc. \n\nAs it turns out, Weiner, Huma's husband, had been forwarding Huma's emails each time she came home and left her computer open. Huma appears to have been in touch with Saudi actors, and therefore, ESPIONAGE is strongly suspected. \nComey and his 40 \" Untouchables \" are now preparing to take down the largest corruption ever witnessed in American history… which is what I think MUST happen if Comey is planning to stay part of the FBI. He lost so much respect and so much credibility with the first Hillary investigation, it would take something of this magnitude to allow him to face the public again. The Pentagon has internal players and outside players they call \" creatives \". Creatives are civilians who tend to be geniuses, malcontents, extreme hackers, or otherwise demonstrate brilliance in other useful areas. A Pentagon program called Cicada 3301 , which we have reported on previously, was created by several of these talented civilians. The program is now used to allow thousands of honest government people to report on their corrupt superiors, using what is called a DEAD BOX whistleblower encryption method so the non-corrupted government officials can report corruption and still remain safe. \n\nI've heard it said \"A vagina almost took down Bill, now will a Weiner take down Hillary?\" LOL! \n\nAgain, thank you to all of the insiders, the whistleblowers, the good FBI agents, the good CIA agents, the good NYPD officers, and the non-corrupted government officials who want to see the truth exposed! Without these brave, wonderful, and morally erect individuals, our country would still be in the corrupted darkness. \n\n\n\nVistors to Epstein's Little St. James Island include: \n\n• Ehud Barak , the former Prime Minister of Israel (1999-2001) – pedophile being procured underage girls by Epstein. Former Israeli Minister of Defense and also Deputy Israeli Prime Minister under Binyamin Netanyahu from 2009 to 2013. \n\n• Prince Andrew – British royalty – Jeffrey Epstein and his girlfriend Ghislaine Maxwell pimped Epstein sex slave Virginia Roberts to Prince Andrew multiple times. The victim girls say Prince Andrew was very sexually sadistic; they despised this sick, twisted creature. \n\n• Kevin Spacey – actor in House of Cards. People tell me Spacey is gay, and my response is \"Have you ever heard of the word bisexual?\" Spacey is very good friends with 2 big-time pedophiles: Jeffrey Epstein and Bill Clinton. Spacey, big Hollywood star, has 3.78 million Twitter followers. \n\n• Alan Dershowitz – longtime friend of Epstein, as well as one of his defense lawyers. Dershowitz was the one who negotiated that absurd plea bargain for Epstein that gave him a 13-month (served) sentence and a 16 hour/day day pass so he could spend most of his time in his mansion. Epstein sex slave Virginia Roberts has said that Epstein made her have sex with Dershowitz numerous times. The real question is how many other underage girls was Dershowitz having sex with? Virginia Roberts says Dershowitz also witnessed Epstein's pedophilic activities. \n\nhttp://victuruslibertas.com/2016/10/insiders-reveal-sex-ring/ \n\nRelated: \n\nAbel Danger - \"FBI INSIDER\" - Clinton Foundation Scandal Would Bring Down the Government and More   \n\nThe Situation Is So Intense, It Involves the Entire US Government | FBI Insider   \n\n*EXPLOSIVE* Q & A on the Clinton Foundation - FBI Insider on 4chan /pol/ : \"Ask Me Anything About the Clinton Case\" - George Soros Is the Kingpin - Follow the Rothschild Thread - Clinton Foundation Uses People as Currency - Jeffrey Epstein's Child Sex Trafficking Network - Bill & Hillary Clinton Get Paid in Money & Children - Hammer HRC's E-mails, Dig Into the CF: Post Everywhere You Can   \n\nI SIS stands for \"Israeli Secret Intelligence Service\"   ",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"type": "bs",
		"uuid": "999af667dd0fec633e0a98865fb8d973a39fcb0a"
	},
	"-KhI_qV1cxg4FWA8fWMk": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T10:10:41.864+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02241w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bev_Harris"
				},
				"name": "Bev Harris",
				"salience": 0.46011487,
				"type": "PERSON"
			},
			{
				"name": "Infowars",
				"salience": 0.20644511,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.03920009,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.025787855,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.01907924,
				"type": "OTHER"
			},
			{
				"name": "Election Fraud",
				"salience": 0.018044781,
				"type": "OTHER"
			},
			{
				"name": "black box",
				"salience": 0.014632895,
				"type": "OTHER"
			},
			{
				"name": "smoking gun",
				"salience": 0.014375553,
				"type": "OTHER"
			},
			{
				"name": "black box",
				"salience": 0.01426873,
				"type": "OTHER"
			},
			{
				"name": "voting fraud LIVE",
				"salience": 0.0141325155,
				"type": "OTHER"
			},
			{
				"name": "Investigators",
				"salience": 0.0141325155,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.013211877,
				"type": "EVENT"
			},
			{
				"name": "Elections",
				"salience": 0.013046338,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02qlz8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_box_voting"
				},
				"name": "Black Box Voting",
				"salience": 0.011008589,
				"type": "EVENT"
			},
			{
				"name": "Smoking Gun",
				"salience": 0.010097782,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vote rigging",
				"salience": 0.009926727,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.009926727,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.009557672,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.009557672,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.008109993,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.008109993,
				"type": "OTHER"
			},
			{
				"name": "Infowars.com/show",
				"salience": 0.0076837777,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.007517659,
				"type": "WORK_OF_ART"
			},
			{
				"name": "transparency",
				"salience": 0.0060633505,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0060633505,
				"type": "OTHER"
			},
			{
				"name": "functions",
				"salience": 0.005479655,
				"type": "OTHER"
			},
			{
				"name": "black box systems",
				"salience": 0.004728612,
				"type": "OTHER"
			},
			{
				"name": "vote count",
				"salience": 0.004418783,
				"type": "OTHER"
			},
			{
				"name": "video clips",
				"salience": 0.004418783,
				"type": "WORK_OF_ART"
			},
			{
				"name": "link",
				"salience": 0.004254091,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.003302207,
				"type": "WORK_OF_ART"
			},
			{
				"name": "copy",
				"salience": 0.003302207,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T10:10:41.864+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Source: Infowars \n\nVote fraud expert Bev Harris exposes electronic voting machines \n\nOctober 31, 2016 \n\n\nWatch elections expert Bev Harris discuss the smoking gun behind voting fraud LIVE: Infowars.com/show \n\nSmoking Gun In Massive Election Fraud Discovered By Investigators    \nBlack Box Voting, founded in 2003, performs nonpartisan investigative reporting on elections in an attempt to stop vote rigging. \n\nYou may be wondering what the term \"black box\" means. A \"black box\" system is non-transparent; its functions are hidden from the public. Elections, of course, should not be black box systems. \n\nHere is a link to a free copy of the book, Black Box Voting HERE. \n\nAuthor Bev Harris became known for groundbreaking work on electronic voting machines, which can remove transparency of the vote count. \n\nPlease go to Infowars to read the entire article and view the video clips.",
		"thread_title": "How America’s Elections Are Hacked, Missing Link Discovered",
		"title": "How America’s Elections Are Hacked, Missing Link Discovered",
		"type": "bs",
		"uuid": "2cc80e75892986518cf3a4e9d60cb07e3617fcd0"
	},
	"-KhI_qYFqDf1LT8TaX2x": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T10:20:35.392+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Cloud Centric",
				"salience": 0.8099109,
				"type": "OTHER"
			},
			{
				"name": "C2) Crime Scene Investigation",
				"salience": 0.19008912,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T10:20:35.392+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0.6
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Cloud Centric (C2) Crime Scene Investigation \n\n",
		"thread_title": "Weiner Sings Like a Bird as Dickileak Provides Exit As Huma Sequestered by FBI at MOUNT WEATHER - After Huma's 65,000 Emails Found...No Longer Together",
		"title": "Weiner Sings Like a Bird as Dickileak Provides Exit As Huma Sequestered by FBI at MOUNT WEATHER - After Huma's 65,000 Emails Found...No Longer Together",
		"type": "bs",
		"uuid": "6515694a1764fd4635a69f867b8e57739bb181f9"
	},
	"-KhI_qiM5NEK5R4zgPFu": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T10:54:31.899+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.13264005,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/043tfg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Key"
				},
				"name": "John Key",
				"salience": 0.122701265,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.09600521,
				"type": "PERSON"
			},
			{
				"name": "Seemorerocks",
				"salience": 0.054629702,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ctw_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Zealand"
				},
				"name": "New Zealand",
				"salience": 0.048907343,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/043tfg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Key"
				},
				"name": "Key",
				"salience": 0.04715845,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.03839672,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.03686173,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.03322747,
				"type": "ORGANIZATION"
			},
			{
				"name": "NZ taxpeyers",
				"salience": 0.028197348,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.024352023,
				"type": "PERSON"
			},
			{
				"name": "Julian Crawford",
				"salience": 0.02396941,
				"type": "PERSON"
			},
			{
				"name": "virus",
				"salience": 0.022894254,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.018681515,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.015709965,
				"type": "OTHER"
			},
			{
				"name": "harbour",
				"salience": 0.011365639,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.011365639,
				"type": "PERSON"
			},
			{
				"name": "lockstep",
				"salience": 0.011365639,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.011365639,
				"type": "OTHER"
			},
			{
				"name": "warships",
				"salience": 0.011365639,
				"type": "OTHER"
			},
			{
				"name": "taxpayer",
				"salience": 0.009129204,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bm8zlf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Duncan_Garner"
				},
				"name": "Duncan Garner",
				"salience": 0.0082064085,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.007895253,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.007006603,
				"type": "LOCATION"
			},
			{
				"name": "Thomas Fuentes",
				"salience": 0.0066981125,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0064884378,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0064884378,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0064173746,
				"type": "LOCATION"
			},
			{
				"name": "foundation",
				"salience": 0.0061490475,
				"type": "ORGANIZATION"
			},
			{
				"name": "style",
				"salience": 0.0046892217,
				"type": "OTHER"
			},
			{
				"name": "tax-payer",
				"salience": 0.0046892217,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0046892217,
				"type": "PERSON"
			},
			{
				"name": "cannabis",
				"salience": 0.004552092,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "HIV virus",
				"salience": 0.0042057876,
				"type": "OTHER"
			},
			{
				"name": "Cannabis Party",
				"salience": 0.0040993947,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.0036863207,
				"type": "WORK_OF_ART"
			},
			{
				"name": "concerns",
				"salience": 0.0035647613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.003494683,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill",
				"salience": 0.0034072478,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.0032890886,
				"type": "PERSON"
			},
			{
				"name": "humans",
				"salience": 0.0032890886,
				"type": "PERSON"
			},
			{
				"name": "monkeys",
				"salience": 0.0032890886,
				"type": "OTHER"
			},
			{
				"name": "Hundreds",
				"salience": 0.0032890886,
				"type": "PERSON"
			},
			{
				"name": "goals",
				"salience": 0.0032890886,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0032890886,
				"type": "OTHER"
			},
			{
				"name": "HIV prevention",
				"salience": 0.0032890886,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.003166416,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.003166416,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0031459236,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.0031459236,
				"type": "PERSON"
			},
			{
				"name": "taxpayers",
				"salience": 0.0029218507,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haiti",
				"salience": 0.0028877219,
				"type": "LOCATION"
			},
			{
				"name": "foundation",
				"salience": 0.0028398756,
				"type": "OTHER"
			},
			{
				"name": "Legalise Cannibis Party",
				"salience": 0.0026986422,
				"type": "ORGANIZATION"
			},
			{
				"name": "revelations",
				"salience": 0.002685505,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.002685505,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.002685505,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0025000295,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.002385593,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.002258965,
				"type": "OTHER"
			},
			{
				"name": "handout",
				"salience": 0.0021925855,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0gjwh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tetrahydrocannabinol"
				},
				"name": "THC",
				"salience": 0.002130367,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0021217843,
				"type": "OTHER"
			},
			{
				"name": "RIV",
				"salience": 0.0020250415,
				"type": "ORGANIZATION"
			},
			{
				"name": "payments",
				"salience": 0.0020064157,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06nx8f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Business_Review"
				},
				"name": "National Business Review",
				"salience": 0.00162632,
				"type": "ORGANIZATION"
			},
			{
				"name": "article",
				"salience": 0.0015374394,
				"type": "WORK_OF_ART"
			},
			{
				"name": "taxpayer",
				"salience": 0.0015114653,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0015114653,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0014614104,
				"type": "PERSON"
			},
			{
				"name": "trough",
				"salience": 0.0014614104,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0014614104,
				"type": "OTHER"
			},
			{
				"name": "paywall",
				"salience": 0.0014614104,
				"type": "OTHER"
			},
			{
				"name": "flagship",
				"salience": 0.0014614104,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0012607676,
				"type": "EVENT"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0010917215,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0010917215,
				"type": "OTHER"
			},
			{
				"name": "occasions",
				"salience": 0.0010917215,
				"type": "EVENT"
			},
			{
				"name": "lots",
				"salience": 0.0010917215,
				"type": "OTHER"
			},
			{
				"name": "dinner",
				"salience": 0.0008155203,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06j8fb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Premier_House"
				},
				"name": "Premier House",
				"salience": 0.0006719226,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T10:54:31.899+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Source: Seemorerocks \n\nNovember 1, 2016 \n\nJohn Key channels NZ taxpeyers' money to Clinton Foundation \n\n\nThis is information that every taxpayer (or those that care) should know about but our journalists are not doing their job.  \n\nWhat with warships in our harbour and troops in Iraq this government of John Key is in lockstep with the most corrupt and warmongering part of the US government. \n\nNo doubt Key would approve of the Clinton's defrauding the people of Haiti. It's his style. \n\nThe Cannabis Party is calling on John Key to explain why he gave over $7 million of New Zealand tax-payer's money to the Clinton Foundation.  \n\nLegalise Cannibis Party \n\n31 October, 2016 \n\nWikileaks raised serious ethical concerns about the Clinton Foundation when it published a hacked email, send to Clinton campaign chairman John Podesta, revealing blurred lines between the foundation and the personal financial interests of Bill and Hillary Clinton. \n\nCannabis Party leader Julian Crawford said if John Key was serious about HIV prevention, one of the Clinton Foundation's supposed goals, he should legalise medical cannabis in New Zealand. \n\n\"Hundreds of researchers have reported that THC was able to destroy the RIV virus in monkeys. That virus is nearly identical to the HIV virus found in humans,\" he said. \n\n\"John Key has a lot of explaining to do if the Wikileaks revelations about the Clinton Foundation are true.\" \n\nFormer Assistant Director of the FBI Thomas Fuentes confirmed that \"the FBI has an intensive investigation ongoing into the Clinton Foundation\". \n\nNew Zealand's National Business Review has reported that John Key will continue giving millions of dollars of taxpayer's money to the foundation in the future, despite the criminal investigation of Hillary Clinton. \n\n\"I've met her on lots of occasions, had dinner with her at Premier House a few times,\" John Key said. \n\n\"As Secretary of State she was great, very engaged with New Zealand.\" Broadcaster Duncan Garner yesterday raised serious concerns about the ongoing payments to the Clinton Foundation, known as \"pay-to-play\". \n\n\"We also give money to the Clinton Foundation? Yes, we did. Gosh, who didn't get a handout?\" Garner said. \n\n\"We've been feeding all these guys at the trough for years\" \n\n\"pay-to-play\" refers to operations where Bill and Hillary Clinton rewarded big donors to their foundation with preferential access to the US government. \n\nThe original article was in the neo-liberal NBR, behind a paywall \n\nNZ taxpayers will continue funding Clinton Foundation's flagship \n\n\n",
		"thread_title": "Prime Minster John Key caught channeling millions of dollars of taxpayer's money to 'ethically compromised' Clinton Foundation",
		"title": "Prime Minster John Key caught channeling millions of dollars of taxpayer's money to 'ethically compromised' Clinton Foundation",
		"type": "bs",
		"uuid": "cf91054424959b027f81f6bf13753ce2b12e5c8a"
	},
	"-KhI_qu8tnqsNvhZcopA": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T10:55:27.725+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.13574442,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/043tfg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Key"
				},
				"name": "John Key",
				"salience": 0.12556894,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0982404,
				"type": "PERSON"
			},
			{
				"name": "Seemorerocks",
				"salience": 0.055894032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/043tfg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Key"
				},
				"name": "Key",
				"salience": 0.04824869,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.039283276,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.037712652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.033994094,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ctw_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Zealand"
				},
				"name": "New Zealand",
				"salience": 0.02803227,
				"type": "LOCATION"
			},
			{
				"name": "journalists",
				"salience": 0.024913153,
				"type": "PERSON"
			},
			{
				"name": "Julian Crawford",
				"salience": 0.02452169,
				"type": "PERSON"
			},
			{
				"name": "virus",
				"salience": 0.02342168,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.019111628,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.016071504,
				"type": "OTHER"
			},
			{
				"name": "taxpayers",
				"salience": 0.016071504,
				"type": "PERSON"
			},
			{
				"name": "harbour",
				"salience": 0.011627037,
				"type": "OTHER"
			},
			{
				"name": "lockstep",
				"salience": 0.011627037,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.011627037,
				"type": "PERSON"
			},
			{
				"name": "warships",
				"salience": 0.011627037,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.011627037,
				"type": "OTHER"
			},
			{
				"name": "channels",
				"salience": 0.011627037,
				"type": "OTHER"
			},
			{
				"name": "taxpayer",
				"salience": 0.009339098,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bm8zlf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Duncan_Garner"
				},
				"name": "Duncan Garner",
				"salience": 0.00839506,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.008076743,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0071676453,
				"type": "LOCATION"
			},
			{
				"name": "Thomas Fuentes",
				"salience": 0.0068520578,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0066375593,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0066375593,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.006564861,
				"type": "LOCATION"
			},
			{
				"name": "foundation",
				"salience": 0.0062903618,
				"type": "ORGANIZATION"
			},
			{
				"name": "tax-payer",
				"salience": 0.0047969646,
				"type": "OTHER"
			},
			{
				"name": "style",
				"salience": 0.0047969646,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0047969646,
				"type": "PERSON"
			},
			{
				"name": "cannabis",
				"salience": 0.004656682,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "HIV virus",
				"salience": 0.004302416,
				"type": "OTHER"
			},
			{
				"name": "Cannabis Party",
				"salience": 0.004193577,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.0037710078,
				"type": "WORK_OF_ART"
			},
			{
				"name": "concerns",
				"salience": 0.003646654,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.003574965,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill",
				"salience": 0.0034855204,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.0033646454,
				"type": "PERSON"
			},
			{
				"name": "humans",
				"salience": 0.0033646454,
				"type": "PERSON"
			},
			{
				"name": "monkeys",
				"salience": 0.0033646454,
				"type": "OTHER"
			},
			{
				"name": "Hundreds",
				"salience": 0.0033646454,
				"type": "PERSON"
			},
			{
				"name": "goals",
				"salience": 0.0033646454,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0033646454,
				"type": "OTHER"
			},
			{
				"name": "HIV prevention",
				"salience": 0.0033646454,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0032391534,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0032391534,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0032181903,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.0032181903,
				"type": "PERSON"
			},
			{
				"name": "taxpayers",
				"salience": 0.0029889678,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haiti",
				"salience": 0.0029540546,
				"type": "LOCATION"
			},
			{
				"name": "foundation",
				"salience": 0.0029051087,
				"type": "OTHER"
			},
			{
				"name": "Legalise Cannibis Party",
				"salience": 0.00276063,
				"type": "ORGANIZATION"
			},
			{
				"name": "revelations",
				"salience": 0.0027471909,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0027471909,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0027471909,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0025574537,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0024403876,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.00231085,
				"type": "OTHER"
			},
			{
				"name": "handout",
				"salience": 0.0022429456,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0gjwh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tetrahydrocannabinol"
				},
				"name": "THC",
				"salience": 0.0021792976,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0021705176,
				"type": "OTHER"
			},
			{
				"name": "RIV",
				"salience": 0.002071552,
				"type": "ORGANIZATION"
			},
			{
				"name": "payments",
				"salience": 0.0020524985,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06nx8f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Business_Review"
				},
				"name": "National Business Review",
				"salience": 0.0016636708,
				"type": "ORGANIZATION"
			},
			{
				"name": "article",
				"salience": 0.0015727484,
				"type": "WORK_OF_ART"
			},
			{
				"name": "taxpayer",
				"salience": 0.0015461777,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0015461777,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.001494973,
				"type": "PERSON"
			},
			{
				"name": "trough",
				"salience": 0.001494973,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.001494973,
				"type": "OTHER"
			},
			{
				"name": "paywall",
				"salience": 0.001494973,
				"type": "OTHER"
			},
			{
				"name": "flagship",
				"salience": 0.001494973,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0012897213,
				"type": "EVENT"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0011167924,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0011167924,
				"type": "OTHER"
			},
			{
				"name": "occasions",
				"salience": 0.0011167924,
				"type": "EVENT"
			},
			{
				"name": "lots",
				"salience": 0.0011167924,
				"type": "OTHER"
			},
			{
				"name": "dinner",
				"salience": 0.0008342477,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06j8fb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Premier_House"
				},
				"name": "Premier House",
				"salience": 0.0006873521,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T10:55:27.725+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Source: Seemorerocks \n\nNovember 1, 2016 \n\nJohn Key channels NZ taxpayers' money to Clinton Foundation \n\n\nThis is information that every taxpayer (or those that care) should know about but our journalists are not doing their job.  \n\nWhat with warships in our harbour and troops in Iraq this government of John Key is in lockstep with the most corrupt and warmongering part of the US government. \n\nNo doubt Key would approve of the Clinton's defrauding the people of Haiti. It's his style. \n\nThe Cannabis Party is calling on John Key to explain why he gave over $7 million of New Zealand tax-payer's money to the Clinton Foundation.  \n\nLegalise Cannibis Party \n\n31 October, 2016 \n\nWikileaks raised serious ethical concerns about the Clinton Foundation when it published a hacked email, send to Clinton campaign chairman John Podesta, revealing blurred lines between the foundation and the personal financial interests of Bill and Hillary Clinton. \n\nCannabis Party leader Julian Crawford said if John Key was serious about HIV prevention, one of the Clinton Foundation's supposed goals, he should legalise medical cannabis in New Zealand. \n\n\"Hundreds of researchers have reported that THC was able to destroy the RIV virus in monkeys. That virus is nearly identical to the HIV virus found in humans,\" he said. \n\n\"John Key has a lot of explaining to do if the Wikileaks revelations about the Clinton Foundation are true.\" \n\nFormer Assistant Director of the FBI Thomas Fuentes confirmed that \"the FBI has an intensive investigation ongoing into the Clinton Foundation\". \n\nNew Zealand's National Business Review has reported that John Key will continue giving millions of dollars of taxpayer's money to the foundation in the future, despite the criminal investigation of Hillary Clinton. \n\n\"I've met her on lots of occasions, had dinner with her at Premier House a few times,\" John Key said. \n\n\"As Secretary of State she was great, very engaged with New Zealand.\" Broadcaster Duncan Garner yesterday raised serious concerns about the ongoing payments to the Clinton Foundation, known as \"pay-to-play\". \n\n\"We also give money to the Clinton Foundation? Yes, we did. Gosh, who didn't get a handout?\" Garner said. \n\n\"We've been feeding all these guys at the trough for years\" \n\n\"pay-to-play\" refers to operations where Bill and Hillary Clinton rewarded big donors to their foundation with preferential access to the US government. \n\nThe original article was in the neo-liberal NBR, behind a paywall \n\nNZ taxpayers will continue funding Clinton Foundation's flagship \n\n",
		"thread_title": "Prime Minster John Key caught channeling millions of dollars of taxpayer's money to 'ethically compromised' Clinton Foundation",
		"title": "Prime Minster John Key caught channeling millions of dollars of taxpayer's money to 'ethically compromised' Clinton Foundation",
		"type": "bs",
		"uuid": "505c9bca0c6f2c0c10f98b8450c264b7e6776598"
	},
	"-KhI_r0phwRC4UH4VIQ_": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T13:32:25.253+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Greg Hallet",
				"salience": 0.18082066,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02kx9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julia_Gillard"
				},
				"name": "Gillard",
				"salience": 0.11727298,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.081557356,
				"type": "PERSON"
			},
			{
				"name": "homosexual",
				"salience": 0.040453058,
				"type": "OTHER"
			},
			{
				"name": "derivatives",
				"salience": 0.038001437,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.038001437,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.038001437,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.038001437,
				"type": "OTHER"
			},
			{
				"name": "Cathy Obrien",
				"salience": 0.033078864,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.030712383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.02894386,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australia",
				"salience": 0.023511304,
				"type": "LOCATION"
			},
			{
				"name": "sex collectors",
				"salience": 0.0228577,
				"type": "PERSON"
			},
			{
				"name": "pedo ring",
				"salience": 0.020668397,
				"type": "OTHER"
			},
			{
				"name": "Clintns",
				"salience": 0.01944064,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.018191399,
				"type": "OTHER"
			},
			{
				"name": "ufrtd",
				"salience": 0.015765335,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.015765335,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.015765335,
				"type": "OTHER"
			},
			{
				"name": "hospitals",
				"salience": 0.015765335,
				"type": "LOCATION"
			},
			{
				"name": "BOOK",
				"salience": 0.011996035,
				"type": "WORK_OF_ART"
			},
			{
				"name": "court action",
				"salience": 0.010724934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bk7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Project_MKUltra"
				},
				"name": "MK ULTRA",
				"salience": 0.009723142,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/017_4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelmsford"
				},
				"name": "Chelmsford",
				"salience": 0.009723142,
				"type": "LOCATION"
			},
			{
				"name": "girls",
				"salience": 0.0070657292,
				"type": "PERSON"
			},
			{
				"name": "truth teller",
				"salience": 0.0070222705,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0062943487,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00566276,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.0054517067,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.005339197,
				"type": "WORK_OF_ART"
			},
			{
				"name": "some",
				"salience": 0.005339197,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.005339197,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.005214558,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xfbl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Undercover_operation"
				},
				"name": "UNDERCOVER",
				"salience": 0.005099718,
				"type": "ORGANIZATION"
			},
			{
				"name": "melt",
				"salience": 0.005052861,
				"type": "OTHER"
			},
			{
				"name": "x agents",
				"salience": 0.004624205,
				"type": "PERSON"
			},
			{
				"name": "sound",
				"salience": 0.004624205,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.00445953,
				"type": "ORGANIZATION"
			},
			{
				"name": "names",
				"salience": 0.004312354,
				"type": "OTHER"
			},
			{
				"name": "class mates",
				"salience": 0.0041515534,
				"type": "PERSON"
			},
			{
				"name": "Stew wev",
				"salience": 0.0040600887,
				"type": "OTHER"
			},
			{
				"name": "commo",
				"salience": 0.0036813826,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.0033573795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ctw_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Zealand"
				},
				"name": "NZ",
				"salience": 0.0033573795,
				"type": "LOCATION"
			},
			{
				"name": "charge",
				"salience": 0.0029066524,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0028474368,
				"type": "PERSON"
			},
			{
				"name": "Communist party",
				"salience": 0.0025171093,
				"type": "ORGANIZATION"
			},
			{
				"name": "everything",
				"salience": 0.0021716228,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0021716228,
				"type": "PERSON"
			},
			{
				"name": "scam",
				"salience": 0.002003582,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0019817823,
				"type": "PERSON"
			},
			{
				"name": "detail",
				"salience": 0.0018805184,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0018805184,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mistake",
				"salience": 0.0018568274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0015494922,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rx9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damien_Duff"
				},
				"name": "Duff",
				"salience": 0.0014916575,
				"type": "PERSON"
			},
			{
				"name": "Tredeau",
				"salience": 0.0004886112,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-11-01T07:12:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 2.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "He has quite a history , he sold the derivatives in Australia and is another homosexual as are most of the media and those in power , the woman who works with him in charge of police and law was ran the MK ULTRA ,ufrtd in Chelmsford hospitals . tHERE IS A GREAT BOOK ABOUT IT ALL FROM UNDERCOVER called sex collectors by Greg Hallet , they chased him out of NZ tried to kill him lots of times . He sats there is a huge pedo ring there in Gov . I am beginning to think Cathy Obrien would shakethe life out of Clintons she must have been telling the truth , it all fits http://www.stewwebb.com/2016/05/25/hillary-clinton-lesbian-demon-pedophile-child-rapist/      I think Stew wev might be a truth teller too he was onto this a long time ago and he has taken court action and some of the x agents that come on sound vey credible . If Trump apeared with Cathy i think Clintns would have a melt down her book is very detailed , names everyone and where in great detail including Tredeau .Duff is a UN  scam , the UN is very involved in everything , The foundation that Gillard is noww running for girls /is very suspect , she transfered 300 million into it and she is also another gay commo and i haver talked to her class mates who knew her well  , they sure had some stories much like Clinton . She was in charge of the Communist party claimed she was trained by the CIA. make no mistake she will be involved .",
		"thread_title": "Prime Minster John Key caught channeling millions of dollars of taxpayer's money to 'ethically compromised' Clinton Foundation",
		"title": "",
		"type": "bs",
		"uuid": "53b787d6125553668af9e4c9ad84ce65c0c87b5b"
	},
	"-KhI_r60fPi73zSk4nrr": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T13:37:48.513+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.6473283,
				"type": "ORGANIZATION"
			},
			{
				"name": "privatization",
				"salience": 0.12470063,
				"type": "OTHER"
			},
			{
				"name": "TAXPAYERS",
				"salience": 0.054703366,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.054039404,
				"type": "OTHER"
			},
			{
				"name": "SYSTEMS",
				"salience": 0.030787086,
				"type": "OTHER"
			},
			{
				"name": "E SYSTEMS TO RIP OGG",
				"salience": 0.022940103,
				"type": "OTHER"
			},
			{
				"name": "ELECTIONS",
				"salience": 0.016212625,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "BUSH",
				"salience": 0.01518569,
				"type": "PERSON"
			},
			{
				"name": "CHIPS BACKDOOR",
				"salience": 0.0074970126,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kwyc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Intelligence_assessment"
				},
				"name": "INTEL",
				"salience": 0.0074970126,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gtxjrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Smart_Response_Technology"
				},
				"name": "SRT",
				"salience": 0.005467039,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "ISRAEL",
				"salience": 0.005467039,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01ky8y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raytheon"
				},
				"name": "RAYTHEON",
				"salience": 0.0040873317,
				"type": "ORGANIZATION"
			},
			{
				"name": "INSLAW SOFTWARE",
				"salience": 0.0040873317,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-11-01T08:12:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "So privatization is really moving the CIA into private business , using E SYSTEMS TO RIP OGG  TAXPAYERS TO FEED THE CIA . APPARENTLY E SYSTEMS ARE USED TO RIG THE ELECTIONS , AND ITS RUN BY BUSH AND RAYTHEON . INSLAW SOFTWARE USED THEN INTEL CHIPS BACKDOOR OWNED BY ISRAEL SRT UP BY BUSH .http://www.stewwebb.com/2016/05/25/hillary-clinton-lesbian-demon-pedophile-child-rapist/",
		"thread_title": "Weiner Sings Like a Bird as Dickileak Provides Exit as Huma Sequestered by FBI at MOUNT WEATHER - After Huma's 65,000 Emails Found...No Longer Together",
		"title": "",
		"type": "bs",
		"uuid": "157ad08082720efc711dd7edf802e4adfdc3722f"
	},
	"-KhI_rF_XzWttQru6QD_": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T17:30:52.527+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Greg Hallet",
				"salience": 0.18082066,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02kx9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julia_Gillard"
				},
				"name": "Gillard",
				"salience": 0.11727298,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.081557356,
				"type": "PERSON"
			},
			{
				"name": "homosexual",
				"salience": 0.040453058,
				"type": "OTHER"
			},
			{
				"name": "derivatives",
				"salience": 0.038001437,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.038001437,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.038001437,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.038001437,
				"type": "OTHER"
			},
			{
				"name": "Cathy Obrien",
				"salience": 0.033078864,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.030712383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.02894386,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australia",
				"salience": 0.023511304,
				"type": "LOCATION"
			},
			{
				"name": "sex collectors",
				"salience": 0.0228577,
				"type": "PERSON"
			},
			{
				"name": "pedo ring",
				"salience": 0.020668397,
				"type": "OTHER"
			},
			{
				"name": "Clintns",
				"salience": 0.01944064,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.018191399,
				"type": "OTHER"
			},
			{
				"name": "ufrtd",
				"salience": 0.015765335,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.015765335,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.015765335,
				"type": "OTHER"
			},
			{
				"name": "hospitals",
				"salience": 0.015765335,
				"type": "LOCATION"
			},
			{
				"name": "BOOK",
				"salience": 0.011996035,
				"type": "WORK_OF_ART"
			},
			{
				"name": "court action",
				"salience": 0.010724934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bk7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Project_MKUltra"
				},
				"name": "MK ULTRA",
				"salience": 0.009723142,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/017_4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelmsford"
				},
				"name": "Chelmsford",
				"salience": 0.009723142,
				"type": "LOCATION"
			},
			{
				"name": "girls",
				"salience": 0.0070657292,
				"type": "PERSON"
			},
			{
				"name": "truth teller",
				"salience": 0.0070222705,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0062943487,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00566276,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.0054517067,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.005339197,
				"type": "WORK_OF_ART"
			},
			{
				"name": "some",
				"salience": 0.005339197,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.005339197,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.005214558,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xfbl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Undercover_operation"
				},
				"name": "UNDERCOVER",
				"salience": 0.005099718,
				"type": "ORGANIZATION"
			},
			{
				"name": "melt",
				"salience": 0.005052861,
				"type": "OTHER"
			},
			{
				"name": "x agents",
				"salience": 0.004624205,
				"type": "PERSON"
			},
			{
				"name": "sound",
				"salience": 0.004624205,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.00445953,
				"type": "ORGANIZATION"
			},
			{
				"name": "names",
				"salience": 0.004312354,
				"type": "OTHER"
			},
			{
				"name": "class mates",
				"salience": 0.0041515534,
				"type": "PERSON"
			},
			{
				"name": "Stew wev",
				"salience": 0.0040600887,
				"type": "OTHER"
			},
			{
				"name": "commo",
				"salience": 0.0036813826,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.0033573795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ctw_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Zealand"
				},
				"name": "NZ",
				"salience": 0.0033573795,
				"type": "LOCATION"
			},
			{
				"name": "charge",
				"salience": 0.0029066524,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0028474368,
				"type": "PERSON"
			},
			{
				"name": "Communist party",
				"salience": 0.0025171093,
				"type": "ORGANIZATION"
			},
			{
				"name": "everything",
				"salience": 0.0021716228,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0021716228,
				"type": "PERSON"
			},
			{
				"name": "scam",
				"salience": 0.002003582,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0019817823,
				"type": "PERSON"
			},
			{
				"name": "detail",
				"salience": 0.0018805184,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0018805184,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mistake",
				"salience": 0.0018568274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0015494922,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rx9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damien_Duff"
				},
				"name": "Duff",
				"salience": 0.0014916575,
				"type": "PERSON"
			},
			{
				"name": "Tredeau",
				"salience": 0.0004886112,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-11-01T07:12:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 2.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "He has quite a history , he sold the derivatives in Australia and is another homosexual as are most of the media and those in power , the woman who works with him in charge of police and law was ran the MK ULTRA ,ufrtd in Chelmsford hospitals . tHERE IS A GREAT BOOK ABOUT IT ALL FROM UNDERCOVER called sex collectors by Greg Hallet , they chased him out of NZ tried to kill him lots of times . He sats there is a huge pedo ring there in Gov . I am beginning to think Cathy Obrien would shakethe life out of Clintons she must have been telling the truth , it all fits http://www.stewwebb.com/2016/05/25/hillary-clinton-lesbian-demon-pedophile-child-rapist/      I think Stew wev might be a truth teller too he was onto this a long time ago and he has taken court action and some of the x agents that come on sound vey credible . If Trump apeared with Cathy i think Clintns would have a melt down her book is very detailed , names everyone and where in great detail including Tredeau .Duff is a UN  scam , the UN is very involved in everything , The foundation that Gillard is noww running for girls /is very suspect , she transfered 300 million into it and she is also another gay commo and i haver talked to her class mates who knew her well  , they sure had some stories much like Clinton . She was in charge of the Communist party claimed she was trained by the CIA. make no mistake she will be involved .",
		"thread_title": "Prime Minster John Key caught channeling millions of dollars of taxpayer's money to 'ethically compromised' Clinton Foundation",
		"title": "",
		"type": "bs",
		"uuid": "49e3bf1bc40b989aea881125f83f732b6fc67707"
	},
	"-KhI_rZVB--wLNlnQhEy": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T01:17:20.300+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.54858774,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.14825486,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.109313,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.03476499,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.014052374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09gf_wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Preet_Bharara"
				},
				"name": "Preet Bharara",
				"salience": 0.0069477283,
				"type": "PERSON"
			},
			{
				"name": "DIRECTOR",
				"salience": 0.0065010255,
				"type": "PERSON"
			},
			{
				"name": "Jimstone.is",
				"salience": 0.0061868196,
				"type": "ORGANIZATION"
			},
			{
				"name": "e-mails",
				"salience": 0.0059286733,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.005471597,
				"type": "OTHER"
			},
			{
				"name": "gutter",
				"salience": 0.0051366817,
				"type": "OTHER"
			},
			{
				"name": "meme",
				"salience": 0.0051366817,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma",
				"salience": 0.00480915,
				"type": "PERSON"
			},
			{
				"name": "target",
				"salience": 0.0035177912,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.0031659738,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0031659738,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0031659738,
				"type": "OTHER"
			},
			{
				"name": "felonies",
				"salience": 0.0030774341,
				"type": "PERSON"
			},
			{
				"name": "laptop",
				"salience": 0.0030069256,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "laptop",
				"salience": 0.0029317664,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "laptop",
				"salience": 0.0029317664,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "child sex investigation",
				"salience": 0.0027088313,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.0027088313,
				"type": "OTHER"
			},
			{
				"name": "child sex",
				"salience": 0.0027088313,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.002553025,
				"type": "LOCATION"
			},
			{
				"name": "establishment",
				"salience": 0.002118621,
				"type": "OTHER"
			},
			{
				"name": "life insurance",
				"salience": 0.002118621,
				"type": "OTHER"
			},
			{
				"name": "kiddie porn",
				"salience": 0.002118621,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.002118621,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0019508757,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.0019001592,
				"type": "EVENT"
			},
			{
				"name": "prison",
				"salience": 0.0017158223,
				"type": "LOCATION"
			},
			{
				"name": "portions",
				"salience": 0.0016866601,
				"type": "OTHER"
			},
			{
				"name": "CASE",
				"salience": 0.0016654254,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.0016518295,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0015515105,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0015240732,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0014936384,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0014859339,
				"type": "WORK_OF_ART"
			},
			{
				"name": "outcome",
				"salience": 0.0014859339,
				"type": "OTHER"
			},
			{
				"name": "credibility points",
				"salience": 0.0014859339,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0014859339,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0014859339,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0014305051,
				"type": "LOCATION"
			},
			{
				"name": "FORM",
				"salience": 0.0014305051,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0014305051,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.0014305051,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0014305051,
				"type": "OTHER"
			},
			{
				"name": "suicide",
				"salience": 0.0014009582,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.0013597993,
				"type": "OTHER"
			},
			{
				"name": "Prosecuting Attorney",
				"salience": 0.0012132145,
				"type": "PERSON"
			},
			{
				"name": "swamp",
				"salience": 0.0012132145,
				"type": "LOCATION"
			},
			{
				"name": "chance",
				"salience": 0.001167949,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00096571085,
				"type": "OTHER"
			},
			{
				"name": "BANG ON",
				"salience": 0.0009502747,
				"type": "ORGANIZATION"
			},
			{
				"name": "laptop",
				"salience": 0.0009139686,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "part",
				"salience": 0.0009063975,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.0009063975,
				"type": "WORK_OF_ART"
			},
			{
				"name": "monster",
				"salience": 0.0009063975,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0009063975,
				"type": "PERSON"
			},
			{
				"name": "zombie",
				"salience": 0.0009063975,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0009063975,
				"type": "OTHER"
			},
			{
				"name": "FULL UNADULTERATED",
				"salience": 0.0008806726,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/037ycj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_District_Court_for_the_Southern_District_of_New_York"
				},
				"name": "Southern District of New York",
				"salience": 0.00074685004,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.00074685004,
				"type": "LOCATION"
			},
			{
				"name": "COMMIT SUICIDE",
				"salience": 0.0006631365,
				"type": "EVENT"
			},
			{
				"name": "kiddie stuff",
				"salience": 0.00066017464,
				"type": "OTHER"
			},
			{
				"name": "Insiders",
				"salience": 0.00066017464,
				"type": "PERSON"
			},
			{
				"name": "Pedophile Sex Ring",
				"salience": 0.00066017464,
				"type": "EVENT"
			},
			{
				"name": "circle",
				"salience": 0.0006355328,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.00063078076,
				"type": "OTHER"
			},
			{
				"name": "INVESTIGATIONS",
				"salience": 0.00063078076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington DC",
				"salience": 0.0005579216,
				"type": "LOCATION"
			},
			{
				"name": "death machine",
				"salience": 0.00049316353,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00049316353,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.00049316353,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.0004200816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.00030352172,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.00030352172,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01klyk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Prediction"
				},
				"name": "PREDICTION",
				"salience": 0.00028980128,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00017591837,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T01:17:20.300+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Jimstone.is \nOctober 31 2016 \n\nHuma's husband, Anthony Weiner (which blows the whole Huma/Islam meme into the gutter; all we are seeing with this is the fact the \"Muslims\" running Saudi Arabia are crypto Jews) – ANYWAY , Hillary was so sure she'd never be called to account with her e-mails that she was careless enough to have them end up on Weiner's personal laptop in a file he titled \"life insurance\". \n\nWell, you know how the entire establishment is wrapped up in child sex and other similar crimes, and Weiner ended up getting his laptop seized by the NYPD in a kiddie porn/child sex investigation. When the NYPD went through the laptop, they found Hillary's e-mails in FULL UNADULTERATED PRISTINE FORM. They proved crimes of the highest order – at least 15 felonies found so far, with a majority of them related to treason and selling out the country. \n\nSO THE NYPD OPENED UP A CASE ON HILLARY. The FBI said, NO, WE'LL TAKE THAT – and that is the ONLY reason why these investigations got re-opened: because if the NYPD handled it, huge portions of the FBI would be sent to prison. Now the FBI is under pressure to actually do its job, because they know the NYPD knows. No matter what the outcome, the FBI gains zero (0) ZERO credibility points from this. \n\nSo read my report DO NOT FORGIVE : it was BANG ON, they did this because they HAD TO, not because they had any intention at all of being good, and it really is time to drain the swamp. \n\nNow let's all sit and wait for the suicide of Preet Bharara , the U.S. Prosecuting Attorney for the Southern District of New York, and the NYPD who pushed this into the light. He's now a target of the FBI, the DNC, the Clinton death machine and God knows what else. PREDICTION (and I do not make predictions): THE DIRECTOR OF INVESTIGATIONS FOR THE NYPD WILL \"COMMIT SUICIDE\" WITHIN 5 DAYS. He's a walking dead man. \n\nThe circle of crime in Washington DC is so entrenched and so intertwined that if you poke one part of it, there is a good chance the whole show will fall apart. Poking that monster in a way that hurts is something I do not believe anyone will survive; Preet might as well call himself a zombie. \n\nThe NYPD TRUMPED the FBI! That is why they had to investigate Hillary! \n\nWell well, the NYPD is what busted the Hillary mails open while they were looking for kiddie stuff on Weiner's laptop, and THAT is why the FBI was forced to investigate Hillary. They had no choice. NYPD TRUMPS FBI!!! \n\nRelated: \n\nInsiders Threaten to Expose Hillary's Pedophile Sex Ring!!!   ",
		"thread_title": "An explanation for why the FBI re-opened Hillary's e-mails",
		"title": "An explanation for why the FBI re-opened Hillary's e-mails",
		"type": "bs",
		"uuid": "30f81e37ff684f0b67b973379fe7b29fab41d7df"
	},
	"-KhI_rpN99_L7ciDaNEJ": {
		"author": "tokyowashi (noreply@blogger.com)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:41:31.968+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Peter J. Kadzik",
				"salience": 0.4563186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.12952194,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01rhh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marc_Rich"
				},
				"name": "Marc Rich",
				"salience": 0.1238973,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.04270609,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.01744796,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.01410167,
				"type": "PERSON"
			},
			{
				"name": "affairs",
				"salience": 0.009130784,
				"type": "OTHER"
			},
			{
				"name": "contact",
				"salience": 0.009130784,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.009130784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.00855621,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.007346509,
				"type": "EVENT"
			},
			{
				"name": "70News",
				"salience": 0.0061344574,
				"type": "PERSON"
			},
			{
				"name": "Source",
				"salience": 0.0061344574,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.005346164,
				"type": "EVENT"
			},
			{
				"name": "classmates",
				"salience": 0.0052342857,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.0046491744,
				"type": "WORK_OF_ART"
			},
			{
				"name": "another",
				"salience": 0.004631389,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.004380274,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.004373279,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.0043002767,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.0036231722,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.0036231722,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/026dx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Lynch"
				},
				"name": "Lynch",
				"salience": 0.0035520294,
				"type": "PERSON"
			},
			{
				"name": "Clintons",
				"salience": 0.0032743677,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.0032256285,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.003192452,
				"type": "OTHER"
			},
			{
				"name": "tax dodger",
				"salience": 0.003138241,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0024936239,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.002288538,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.002027903,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.001960249,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018lqb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kilowatt_hour"
				},
				"name": "WH",
				"salience": 0.001932827,
				"type": "ORGANIZATION"
			},
			{
				"name": "Vincent Roberti",
				"salience": 0.0018476051,
				"type": "PERSON"
			},
			{
				"name": "pardon",
				"salience": 0.0017896878,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05492pc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denise_Eisenberg_Rich"
				},
				"name": "Denise Rich",
				"salience": 0.0017671814,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rff2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgetown_University_Law_Center"
				},
				"name": "Georgetown Law School",
				"salience": 0.0017477728,
				"type": "ORGANIZATION"
			},
			{
				"name": "agency",
				"salience": 0.001653461,
				"type": "ORGANIZATION"
			},
			{
				"name": "sex scandal",
				"salience": 0.001653461,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.001653461,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.001631501,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0016050725,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0016050725,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thanks",
				"salience": 0.0015052975,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0013441193,
				"type": "WORK_OF_ART"
			},
			{
				"name": "another",
				"salience": 0.0013389653,
				"type": "OTHER"
			},
			{
				"name": "pardon",
				"salience": 0.001303713,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.0012929154,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0012929154,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0012929154,
				"type": "OTHER"
			},
			{
				"name": "deed",
				"salience": 0.0012929154,
				"type": "OTHER"
			},
			{
				"name": "mud",
				"salience": 0.0012929154,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0012929154,
				"type": "OTHER"
			},
			{
				"name": "mutiny",
				"salience": 0.0012929154,
				"type": "OTHER"
			},
			{
				"name": "crap",
				"salience": 0.0012929154,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0012929154,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.0012662044,
				"type": "EVENT"
			},
			{
				"name": "assistant attorney general",
				"salience": 0.0012550689,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "HRC",
				"salience": 0.0012247808,
				"type": "ORGANIZATION"
			},
			{
				"name": "dinner",
				"salience": 0.0012082382,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0011904725,
				"type": "ORGANIZATION"
			},
			{
				"name": "dinner arrangement",
				"salience": 0.0011682345,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.0011595022,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.0011469842,
				"type": "WORK_OF_ART"
			},
			{
				"name": "friends",
				"salience": 0.0011162346,
				"type": "PERSON"
			},
			{
				"name": "dinner",
				"salience": 0.0010246641,
				"type": "EVENT"
			},
			{
				"name": "letter",
				"salience": 0.0010078752,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.0010078752,
				"type": "EVENT"
			},
			{
				"name": "letters",
				"salience": 0.0010078752,
				"type": "WORK_OF_ART"
			},
			{
				"name": "example",
				"salience": 0.0009659289,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00094662973,
				"type": "OTHER"
			},
			{
				"name": "email scandal",
				"salience": 0.00094662973,
				"type": "EVENT"
			},
			{
				"name": "lobbying campaign",
				"salience": 0.00094310835,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.00093919015,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.0009298798,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.0009298798,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.00092228345,
				"type": "OTHER"
			},
			{
				"name": "email practices",
				"salience": 0.0009065971,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0009065971,
				"type": "EVENT"
			},
			{
				"name": "interest",
				"salience": 0.0009065971,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.0009065971,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.00087276095,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00087276095,
				"type": "WORK_OF_ART"
			},
			{
				"name": "front",
				"salience": 0.00087276095,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00087276095,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawmakers",
				"salience": 0.00087276095,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.0008547248,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0008547248,
				"type": "EVENT"
			},
			{
				"name": "tax bill",
				"salience": 0.0008166715,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0007958967,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_of_Representatives"
				},
				"name": "House",
				"salience": 0.00079348986,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.00076548295,
				"type": "OTHER"
			},
			{
				"name": "fixtures",
				"salience": 0.0007401308,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.0007401308,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.0007401308,
				"type": "PERSON"
			},
			{
				"name": "trenches",
				"salience": 0.0007401308,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0007401308,
				"type": "ORGANIZATION"
			},
			{
				"name": "behalf",
				"salience": 0.0007401308,
				"type": "OTHER"
			},
			{
				"name": "Chief of Staff",
				"salience": 0.0007071768,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0006871017,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00068690226,
				"type": "EVENT"
			},
			{
				"name": "terrorism",
				"salience": 0.00065198465,
				"type": "OTHER"
			},
			{
				"name": "House Select Committee",
				"salience": 0.00062038226,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.00055802654,
				"type": "ORGANIZATION"
			},
			{
				"name": "Assistant Attorney General",
				"salience": 0.00055751164,
				"type": "PERSON"
			},
			{
				"name": "dinner",
				"salience": 0.00055751164,
				"type": "OTHER"
			},
			{
				"name": "pardon",
				"salience": 0.00055751164,
				"type": "OTHER"
			},
			{
				"name": "pardon",
				"salience": 0.00055751164,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00055289175,
				"type": "ORGANIZATION"
			},
			{
				"name": "trading activity",
				"salience": 0.00055289175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "DAILY CALLER",
				"salience": 0.0005371948,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0n4bfmd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2012_Benghazi_attack"
				},
				"name": "Benghazi",
				"salience": 0.0005371948,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0005371948,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.00053268555,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lobbying effort",
				"salience": 0.00051504065,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00051312416,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0c0cs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Executive_Office_of_the_President_of_the_United_States"
				},
				"name": "White House",
				"salience": 0.0005026633,
				"type": "ORGANIZATION"
			},
			{
				"name": "post-Benghazi",
				"salience": 0.00045554273,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0509p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monica_Lewinsky"
				},
				"name": "Monica Lewinsky",
				"salience": 0.00045554273,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vzrj7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Inside_the_Beltway"
				},
				"name": "Beltway",
				"salience": 0.00045554273,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00041645806,
				"type": "LOCATION"
			},
			{
				"name": "campaign official",
				"salience": 0.00041645806,
				"type": "PERSON"
			},
			{
				"name": "top",
				"salience": 0.00040266197,
				"type": "OTHER"
			},
			{
				"name": "SOMETHING",
				"salience": 0.00040266197,
				"type": "OTHER"
			},
			{
				"name": "library",
				"salience": 0.00040266197,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05rw4y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Committee_on_Oversight_and_Government_Reform"
				},
				"name": "House Oversight Committee",
				"salience": 0.00039298457,
				"type": "ORGANIZATION"
			},
			{
				"name": "scandal",
				"salience": 0.0003847295,
				"type": "EVENT"
			},
			{
				"name": "chief of staff",
				"salience": 0.0003847295,
				"type": "PERSON"
			},
			{
				"name": "transition effort",
				"salience": 0.0003847295,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.00034736394,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.00034736394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0003402816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Switzerland"
				},
				"name": "Switzerland",
				"salience": 0.0003402816,
				"type": "LOCATION"
			},
			{
				"name": "role",
				"salience": 0.0003007778,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0003007778,
				"type": "OTHER"
			},
			{
				"name": "@RealVinnieJames",
				"salience": 0.0002861953,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama White House",
				"salience": 0.00027344865,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.00024781126,
				"type": "LOCATION"
			},
			{
				"name": "VJ pic.twitter.com/xVjiRwQMCz -- RealVinnieJames",
				"salience": 0.00024781126,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00021377581,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02q_bk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gmail"
				},
				"name": "Gmail",
				"salience": 0.00018510327,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j9pbdl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Free_Beacon"
				},
				"name": "Washington Free Beacon",
				"salience": 0.00018510327,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:41:31.968+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Source: 70News \n\nOctober 31, 2016 Updated on November 1, 2016 \n\n• John Podesta: Kadzik was a \"fantastic lawyer\" who \"kept me out of jail.\" \n\n• Podesta and Kadzik, the assistant attorney general for legislative affairs, were in frequent contact, other emails show. \n\n• Both were classmates at Georgetown Law School in the 1970s, discussed plans to celebrate Podesta's birthday. And in another sent last May, Kadzik's son emailed Podesta asking for a job on the Clinton campaign. \n\n• Kadzik lobbied Podesta ( then WH Chief of Staff ) to pardon his billionaire, tax dodger fugitive client Marc Rich, whose wife gave $1 million to the Clintons and other Democrats prior to the pardon. FBI Director James Comey is now trying to do the right thing and correct the deed cleaning up the mud he and Hillary Clinton put all over the face of FBI agency. By reopening Hillary Clinton's case, thanks to 650k-emails linked to sex scandal of Huma Abedin's husband Anthony Weiner and the mutiny of FBI agents who won't put up with Comey's crap, we are suppose to finally get justice. \n\nBut guess what? DOJ assigned a Clinton ally and John Podesta's very close friend Peter Kadzik to take charge of the new investigation. \n\nIn a letter to Congress, the DOJ writes that it \"will continue to work closely with the FBI and together, dedicate all necessary resources and take appropriate steps as expeditiously as possible,\" assistant attorney General Peter J. Kadzik writes in letters to House and Senate lawmakers. \n\nWHO IS PETER KADZIK? \n\nAccording to an excellent article published by DAILY CALLER: \n\nThe day after Hillary Clinton testified in front of the House Select Committee on Benghazi last October, John Podesta, the Democrat's campaign chairman, met for dinner with a small group of well-connected friends, including Peter Kadzik, a top official at the Justice Department. \n\nThe dinner arrangement, revealed in hacked Podesta emails released by WikiLeaks, is just the latest example of an apparent conflict of interest between the Clinton campaign and the federal agency charged with investigating the former secretary of state's email practices. \n\n\nPodesta and Kadzik, the assistant attorney general for legislative affairs, were in frequent contact, other emails show. In one email from January, Kadzik and Podesta, who were classmates at Georgetown Law School in the 1970s, discussed plans to celebrate Podesta's birthday. And in another sent last May, Kadzik's son emailed Podesta asking for a job on the Clinton campaign. \n\nThe post-Benghazi dinner was attended by Podesta, Kadzik, superlobbyist Vincent Roberti and other well-placed Beltway fixtures. \n\nKadzik, who started at the DOJ in 2013, helped spearhead the effort to nominate Lynch, who was heavily criticized for her secret meeting with the former president. \n\nIn the trenches \n\nPodesta and Kadzik have a long history — one which has largely gone unnoticed during the ongoing Clinton email scandal. \n\nKadzik represented Podesta during the Monica Lewinsky investigation. And in the waning days of the Bill Clinton administration, Kadzik lobbied Podesta on behalf of Marc Rich, the fugitive who Bill Clinton controversially pardoned on his last day in office. \n\nThat history is cited by Podesta in another email hacked from his Gmail account. \n\nIn a Sept. 2008 email , which the Washington Free Beacon flagged last week, Podesta emailed an Obama campaign official to recommend Kadzik for a supportive role in the campaign. \n\nPodesta, who would later head up the Obama White House transition effort, wrote that Kadzik was a \"fantastic lawyer\" who \"kept me out of jail.\" \n\nPodesta had been promoted to Clinton’s chief of staff when he and Kadzik became embroiled in another scandal. \n\nKadzik was then representing Marc Rich, a billionaire financier who was wanted by the U.S. government for evading a $48 million tax bill. The fugitive, who was also implicated in illegal trading activity with nations that sponsored terrorism, had been living in Switzerland for 17 years when he sought the pardon. \n\nTo help Rich, Kadzik lobbied Podesta heavily in the weeks before Clinton left office on Jan. 20, 2001. \n\nA House Oversight Committee report released in May 2002 stated that \"Kadzik was recruited into Marc Rich's lobbying campaign because he was a long-time friend of White House Chief of Staff John Podesta.\" \n\nThe report noted that Kadzik contacted Podesta at least seven times regarding Rich’s pardon. \n\nOn top of the all-hands-on-deck lobbying effort, Rich's ex-wife, Denise Rich, had doled out more than $1 million to the Clintons and other Democrats prior to the pardon. She gave $100,000 to Hillary Clinton's New York Senate campaign and another $450,000 to the Clinton presidential library.\n\nSOMETHING STINKS (again)! Peter J. Kadzik a Assistant Attorney General having dinner with Podesta WHILE FBI is investigating HRC? Nice! -VJ pic.twitter.com/xVjiRwQMCz — RealVinnieJames (@RealVinnieJames) October 30, 2016 \n\n",
		"thread_title": "Who Is Peter Kadzik? The Clinton Ally and John Podesta's Very Close Friend Peter Kadzik Who Will Take Charge of DoJ's Hillary Clinton and Huma Abedin Email Probe",
		"title": "Who Is Peter Kadzik? The Clinton Ally and John Podesta's Very Close Friend Peter Kadzik Who Will Take Charge of DoJ's Hillary Clinton and Huma Abedin Email Probe",
		"type": "bs",
		"uuid": "00a1b3f0820914870a8b3a52c6080892c05c5d9b"
	},
	"-KhI_rtpd3DED3VgWEZw": {
		"author": "Steve smith",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:48:46.543+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.6754767,
				"type": "ORGANIZATION"
			},
			{
				"name": "David Howard",
				"salience": 0.20952894,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k0fz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Windows_ME"
				},
				"name": "Me",
				"salience": 0.04644174,
				"type": "LOCATION"
			},
			{
				"name": "internet",
				"salience": 0.03240196,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.023072759,
				"type": "PERSON"
			},
			{
				"name": "crap",
				"salience": 0.013077918,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-11-01T22:22:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 1.2,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Google David Howard......Uh oh! Google Me.....Uh oh!   Google this....Google that.....I can make up crap and put it on the internet and people will believe it. ",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "e479b6959d80b6f3b934de0a24c71ab7a9e0f440"
	},
	"-KhI_rxM7fv2utn6agZN": {
		"author": "David Howard",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:48:46.547+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "&quot",
				"salience": 0.40784535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.40784535,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.13683312,
				"type": "PERSON"
			},
			{
				"name": "pedophile&quot",
				"salience": 0.047476206,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "2",
		"participants_count": "1",
		"published": "2016-11-01T19:53:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Google &quot;Donald Trump, pedophile&quot;",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "517503ed877aec015dedcff2dc864bedf0647b8f"
	},
	"-KhI_s3EJwIkkUb6EEFM": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:48:46.562+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.3372759,
				"type": "ORGANIZATION"
			},
			{
				"name": "truths",
				"salience": 0.12459141,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.10841854,
				"type": "OTHER"
			},
			{
				"name": "Lets",
				"salience": 0.052495986,
				"type": "PERSON"
			},
			{
				"name": "flags",
				"salience": 0.04547304,
				"type": "OTHER"
			},
			{
				"name": "believer",
				"salience": 0.04547304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.041027833,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.033862963,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.024887111,
				"type": "EVENT"
			},
			{
				"name": "truth",
				"salience": 0.018944247,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.01641546,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.015805304,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.015805304,
				"type": "OTHER"
			},
			{
				"name": "crooks",
				"salience": 0.0154799875,
				"type": "PERSON"
			},
			{
				"name": "crooks",
				"salience": 0.0154799875,
				"type": "PERSON"
			},
			{
				"name": "top",
				"salience": 0.01341177,
				"type": "OTHER"
			},
			{
				"name": "loot",
				"salience": 0.01095589,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.010818217,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.010682269,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p1l2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy_International_Airport"
				},
				"name": "JFK",
				"salience": 0.010120536,
				"type": "ORGANIZATION"
			},
			{
				"name": "world peace",
				"salience": 0.007308128,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.007308128,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0070357746,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0054615913,
				"type": "OTHER"
			},
			{
				"name": "theftfest",
				"salience": 0.0054615913,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "3",
		"participants_count": "1",
		"published": "2016-11-01T19:47:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "There are lots of diiferent truths , when i hear the FBI come out and admit they ran the false flags and helped cover them up , i&#39;m a believer . At the moment its one side much the same as the other . Lets face it if they cant even arrest or solve the JFK murder and expose the truth then there wont be any . One thing we can be certain of the crooks at the very top running the rest of the crooks will never be mentioned and while that exists nothing much will change i dont think . Its like a theftfest and when they crash it they will still have all the loot . Soros is a bigger threat to world peace and they dont stop him in fact they fund him , go figure .",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "007c2b623b39d89ab0964f86fe0a8bd56855c0ca"
	},
	"-KhI_s7nR9AGyKflzBcs": {
		"author": "Joseph Olson",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:48:46.572+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Roberts Affidavit&quot",
				"salience": 0.4649054,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.12223102,
				"type": "LOCATION"
			},
			{
				"name": "&quot",
				"salience": 0.12223102,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z8cms"
				},
				"name": "Andy",
				"salience": 0.052194614,
				"type": "PERSON"
			},
			{
				"name": "Randy Prince",
				"salience": 0.052194614,
				"type": "PERSON"
			},
			{
				"name": "AD report",
				"salience": 0.039380465,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Alan Dirtbag0witz",
				"salience": 0.035528187,
				"type": "PERSON"
			},
			{
				"name": "Orgy Island",
				"salience": 0.035528187,
				"type": "LOCATION"
			},
			{
				"name": "lawyer",
				"salience": 0.024198804,
				"type": "PERSON"
			},
			{
				"name": "Veterans Today",
				"salience": 0.01553753,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fz196",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Epstein"
				},
				"name": "Jeffrey Epstein",
				"salience": 0.011628458,
				"type": "PERSON"
			},
			{
				"name": "ring",
				"salience": 0.009065379,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0grkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ken_Starr"
				},
				"name": "Ken Starr",
				"salience": 0.0090344,
				"type": "PERSON"
			},
			{
				"name": "Demonic Warlords",
				"salience": 0.006341891,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "4",
		"participants_count": "1",
		"published": "2016-11-01T18:35:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "&quot;Virginia Roberts Affidavit&quot; a teen diary of Randy Prince Andy and Alan Dirtbag0witz at Orgy Island.  This AD report is consistent with Veterans Today on the ruling Demonic Warlords kiddy diddling ring.  BTW....lawyer for Jeffrey Epstein is Ken Starr....",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "25c5521c96107186076ff57ec1e95d41d92815e4"
	},
	"-KhI_sBmmbN1BbDp4Gtj": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:48:46.582+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "NYPAD",
				"salience": 0.20796476,
				"type": "ORGANIZATION"
			},
			{
				"name": "SOMEWHERE",
				"salience": 0.15020767,
				"type": "LOCATION"
			},
			{
				"name": "CHILD SEXUAL ABUSE",
				"salience": 0.14139976,
				"type": "OTHER"
			},
			{
				"name": "LINE",
				"salience": 0.13308482,
				"type": "OTHER"
			},
			{
				"name": "IT",
				"salience": 0.10685761,
				"type": "OTHER"
			},
			{
				"name": "INSIDERS",
				"salience": 0.087786786,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.05462058,
				"type": "ORGANIZATION"
			},
			{
				"name": "GO HARD",
				"salience": 0.05462058,
				"type": "OTHER"
			},
			{
				"name": "TIME",
				"salience": 0.036278892,
				"type": "OTHER"
			},
			{
				"name": "scum",
				"salience": 0.027178543,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "5",
		"participants_count": "1",
		"published": "2016-11-01T05:15:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 1.4,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "yOU HAVE TO DRAW THE LINE SOMEWHERE AND CHILD SEXUAL ABUSE HAS TO BE IT , GO HARD FBI NYPAD INSIDERS ITS YOUR TIME !!!!  Get Those rotten scum . ",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "a8afd31101d4daef3eec6246ce9a7e82129b4f2a"
	},
	"-KhI_sGjDapsqJnhbqGi": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:48:46.592+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "attack",
				"salience": 0.31119895,
				"type": "EVENT"
			},
			{
				"name": "lead",
				"salience": 0.12964094,
				"type": "OTHER"
			},
			{
				"name": "GUNS",
				"salience": 0.1050365,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.08873261,
				"type": "PERSON"
			},
			{
				"name": "guns",
				"salience": 0.065811515,
				"type": "OTHER"
			},
			{
				"name": "SHOT",
				"salience": 0.051753044,
				"type": "OTHER"
			},
			{
				"name": "OPEATION",
				"salience": 0.04964802,
				"type": "ORGANIZATION"
			},
			{
				"name": "GUN LAWS",
				"salience": 0.035167616,
				"type": "OTHER"
			},
			{
				"name": "COUNTRY",
				"salience": 0.035167616,
				"type": "LOCATION"
			},
			{
				"name": "NOTHING",
				"salience": 0.02460096,
				"type": "OTHER"
			},
			{
				"name": "GUN RUNNING CAMP",
				"salience": 0.018776182,
				"type": "LOCATION"
			},
			{
				"name": "GANGS",
				"salience": 0.015348485,
				"type": "ORGANIZATION"
			},
			{
				"name": "ASK CROOKED HILLARY",
				"salience": 0.012352515,
				"type": "PERSON"
			},
			{
				"name": "RED",
				"salience": 0.011776049,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "MEXICO",
				"salience": 0.009467869,
				"type": "LOCATION"
			},
			{
				"name": "HYPOCRISY",
				"salience": 0.008372275,
				"type": "OTHER"
			},
			{
				"name": "ORDER",
				"salience": 0.008372275,
				"type": "OTHER"
			},
			{
				"name": "FACT",
				"salience": 0.0062588593,
				"type": "OTHER"
			},
			{
				"name": "THANKS",
				"salience": 0.0062588593,
				"type": "OTHER"
			},
			{
				"name": "IRONY",
				"salience": 0.0062588593,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "6",
		"participants_count": "1",
		"published": "2016-11-01T05:06:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 2.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Trump should take the lead aand prempt the attack that is sure to come on guns , 17 SHOT IN CHACAGO THE TIGHTEST GUN LAWS IN THE COUNTRY . HOW COULDTHIS HAPPEN ?? ASK CROOKED HILLARY AND THE GUN RUNNING CAMP , CAUGHT RED HANDED SUPPLYING GUNS TO GANGS IN MEXICO . 20 YRS NOTHING HAS CHANGED IN FACT ITS WORSE THANKS TO CROOKED HILLARY . THINK OF THE IRONY HERE ISTHE OPEATION GUN RUNNER CREW TELLING YOU YOU CAN HAVE GUNS . I MEAN TO SAY HYPOCRISY OF THE HIGHEST ORDER.",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "032d5612f4777d59ddd538980305106f90306b19"
	},
	"-KhI_sLeV6NaMtO5XAI8": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T04:57:24.197+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "NYPAD",
				"salience": 0.20796476,
				"type": "ORGANIZATION"
			},
			{
				"name": "SOMEWHERE",
				"salience": 0.15020767,
				"type": "LOCATION"
			},
			{
				"name": "CHILD SEXUAL ABUSE",
				"salience": 0.14139976,
				"type": "OTHER"
			},
			{
				"name": "LINE",
				"salience": 0.13308482,
				"type": "OTHER"
			},
			{
				"name": "IT",
				"salience": 0.10685761,
				"type": "OTHER"
			},
			{
				"name": "INSIDERS",
				"salience": 0.087786786,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.05462058,
				"type": "ORGANIZATION"
			},
			{
				"name": "GO HARD",
				"salience": 0.05462058,
				"type": "OTHER"
			},
			{
				"name": "TIME",
				"salience": 0.036278892,
				"type": "OTHER"
			},
			{
				"name": "scum",
				"salience": 0.027178543,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "7",
		"participants_count": "1",
		"published": "2016-11-01T05:15:00.000+02:00",
		"replies_count": "8",
		"sentiment": {
			"magnitude": 1.4,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "yOU HAVE TO DRAW THE LINE SOMEWHERE AND CHILD SEXUAL ABUSE HAS TO BE IT , GO HARD FBI NYPAD INSIDERS ITS YOUR TIME !!!!  Get Those rotten scum . ",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "f3a09186cc1b6603809d2f45f7dcf1c4d6158de5"
	},
	"-KhI_sUASF6vvRFz6XOi": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T04:57:24.202+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "attack",
				"salience": 0.31119895,
				"type": "EVENT"
			},
			{
				"name": "lead",
				"salience": 0.12964094,
				"type": "OTHER"
			},
			{
				"name": "GUNS",
				"salience": 0.1050365,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.08873261,
				"type": "PERSON"
			},
			{
				"name": "guns",
				"salience": 0.065811515,
				"type": "OTHER"
			},
			{
				"name": "SHOT",
				"salience": 0.051753044,
				"type": "OTHER"
			},
			{
				"name": "OPEATION",
				"salience": 0.04964802,
				"type": "ORGANIZATION"
			},
			{
				"name": "GUN LAWS",
				"salience": 0.035167616,
				"type": "OTHER"
			},
			{
				"name": "COUNTRY",
				"salience": 0.035167616,
				"type": "LOCATION"
			},
			{
				"name": "NOTHING",
				"salience": 0.02460096,
				"type": "OTHER"
			},
			{
				"name": "GUN RUNNING CAMP",
				"salience": 0.018776182,
				"type": "LOCATION"
			},
			{
				"name": "GANGS",
				"salience": 0.015348485,
				"type": "ORGANIZATION"
			},
			{
				"name": "ASK CROOKED HILLARY",
				"salience": 0.012352515,
				"type": "PERSON"
			},
			{
				"name": "RED",
				"salience": 0.011776049,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "MEXICO",
				"salience": 0.009467869,
				"type": "LOCATION"
			},
			{
				"name": "HYPOCRISY",
				"salience": 0.008372275,
				"type": "OTHER"
			},
			{
				"name": "ORDER",
				"salience": 0.008372275,
				"type": "OTHER"
			},
			{
				"name": "FACT",
				"salience": 0.0062588593,
				"type": "OTHER"
			},
			{
				"name": "THANKS",
				"salience": 0.0062588593,
				"type": "OTHER"
			},
			{
				"name": "IRONY",
				"salience": 0.0062588593,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "8",
		"participants_count": "1",
		"published": "2016-11-01T05:06:00.000+02:00",
		"replies_count": "8",
		"sentiment": {
			"magnitude": 2.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Trump should take the lead aand prempt the attack that is sure to come on guns , 17 SHOT IN CHACAGO THE TIGHTEST GUN LAWS IN THE COUNTRY . HOW COULDTHIS HAPPEN ?? ASK CROOKED HILLARY AND THE GUN RUNNING CAMP , CAUGHT RED HANDED SUPPLYING GUNS TO GANGS IN MEXICO . 20 YRS NOTHING HAS CHANGED IN FACT ITS WORSE THANKS TO CROOKED HILLARY . THINK OF THE IRONY HERE ISTHE OPEATION GUN RUNNER CREW TELLING YOU YOU CAN HAVE GUNS . I MEAN TO SAY HYPOCRISY OF THE HIGHEST ORDER.",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "6dae303eece8a53524cfecfaa610905358a6397e"
	},
	"-KhI_sYPOJseVu0nXaP8": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T05:23:51.322+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Jamie Gorelick",
				"salience": 0.63981164,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.36018834,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "1",
		"published": "2016-11-02T00:14:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Jamie Gorelick, call your office....",
		"thread_title": "Who Is Peter Kadzik? The Clinton Ally and John Podesta's Very Close Friend Peter Kadzik Who Will Take Charge of DoJ's Hillary Clinton and Huma Abedin Email Probe",
		"title": "",
		"type": "bs",
		"uuid": "d15057675f1eebaa2101853d2ac9ed568fc69f1a"
	},
	"-KhI_sboXNFzAxx0qNmg": {
		"author": "David Howard",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T05:55:11.262+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "&quot",
				"salience": 0.40784535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.40784535,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.13683312,
				"type": "PERSON"
			},
			{
				"name": "pedophile&quot",
				"salience": 0.047476206,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "9",
		"participants_count": "1",
		"published": "2016-11-01T19:53:00.000+02:00",
		"replies_count": "13",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "Google &quot;Donald Trump, pedophile&quot;",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "057c1dbca3935587019a9ad2a9725b5c6bb12a97"
	},
	"-KhI_slahS2KvEAXck0H": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T05:55:11.432+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.3372759,
				"type": "ORGANIZATION"
			},
			{
				"name": "truths",
				"salience": 0.12459141,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.10841854,
				"type": "OTHER"
			},
			{
				"name": "Lets",
				"salience": 0.052495986,
				"type": "PERSON"
			},
			{
				"name": "flags",
				"salience": 0.04547304,
				"type": "OTHER"
			},
			{
				"name": "believer",
				"salience": 0.04547304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.041027833,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.033862963,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.024887111,
				"type": "EVENT"
			},
			{
				"name": "truth",
				"salience": 0.018944247,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.01641546,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.015805304,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.015805304,
				"type": "OTHER"
			},
			{
				"name": "crooks",
				"salience": 0.0154799875,
				"type": "PERSON"
			},
			{
				"name": "crooks",
				"salience": 0.0154799875,
				"type": "PERSON"
			},
			{
				"name": "top",
				"salience": 0.01341177,
				"type": "OTHER"
			},
			{
				"name": "loot",
				"salience": 0.01095589,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.010818217,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.010682269,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p1l2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy_International_Airport"
				},
				"name": "JFK",
				"salience": 0.010120536,
				"type": "ORGANIZATION"
			},
			{
				"name": "world peace",
				"salience": 0.007308128,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.007308128,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0070357746,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0054615913,
				"type": "OTHER"
			},
			{
				"name": "theftfest",
				"salience": 0.0054615913,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "10",
		"participants_count": "1",
		"published": "2016-11-01T19:47:00.000+02:00",
		"replies_count": "13",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "There are lots of diiferent truths , when i hear the FBI come out and admit they ran the false flags and helped cover them up , i&#39;m a believer . At the moment its one side much the same as the other . Lets face it if they cant even arrest or solve the JFK murder and expose the truth then there wont be any . One thing we can be certain of the crooks at the very top running the rest of the crooks will never be mentioned and while that exists nothing much will change i dont think . Its like a theftfest and when they crash it they will still have all the loot . Soros is a bigger threat to world peace and they dont stop him in fact they fund him , go figure .",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "5ca52be3387f8d79dee27e15e605bd0e62c70754"
	},
	"-KhI_ssHyZNEL9htqZwr": {
		"author": "Joseph Olson",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T05:55:11.669+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Roberts Affidavit&quot",
				"salience": 0.4649054,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.12223102,
				"type": "LOCATION"
			},
			{
				"name": "&quot",
				"salience": 0.12223102,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z8cms"
				},
				"name": "Andy",
				"salience": 0.052194614,
				"type": "PERSON"
			},
			{
				"name": "Randy Prince",
				"salience": 0.052194614,
				"type": "PERSON"
			},
			{
				"name": "AD report",
				"salience": 0.039380465,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Alan Dirtbag0witz",
				"salience": 0.035528187,
				"type": "PERSON"
			},
			{
				"name": "Orgy Island",
				"salience": 0.035528187,
				"type": "LOCATION"
			},
			{
				"name": "lawyer",
				"salience": 0.024198804,
				"type": "PERSON"
			},
			{
				"name": "Veterans Today",
				"salience": 0.01553753,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fz196",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Epstein"
				},
				"name": "Jeffrey Epstein",
				"salience": 0.011628458,
				"type": "PERSON"
			},
			{
				"name": "ring",
				"salience": 0.009065379,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0grkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ken_Starr"
				},
				"name": "Ken Starr",
				"salience": 0.0090344,
				"type": "PERSON"
			},
			{
				"name": "Demonic Warlords",
				"salience": 0.006341891,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "11",
		"participants_count": "1",
		"published": "2016-11-01T18:35:00.000+02:00",
		"replies_count": "13",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "abeldanger.net",
		"spam_score": "0",
		"text": "&quot;Virginia Roberts Affidavit&quot; a teen diary of Randy Prince Andy and Alan Dirtbag0witz at Orgy Island.  This AD report is consistent with Veterans Today on the ruling Demonic Warlords kiddy diddling ring.  BTW....lawyer for Jeffrey Epstein is Ken Starr....",
		"thread_title": "Insiders Threaten to Expose Hillary's Pedophile Sex Ring!!!",
		"title": "",
		"type": "bs",
		"uuid": "cd0262c68cec7911fa355e48feb7713b812f0605"
	},
	"-KhI_tAcioSrj2GdvFjC": {
		"author": "neoholographic",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T01:20:37.820+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "science",
				"salience": 0.17397325,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.12707132,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.08693783,
				"type": "WORK_OF_ART"
			},
			{
				"name": "end",
				"salience": 0.08113752,
				"type": "EVENT"
			},
			{
				"name": "claims",
				"salience": 0.047619984,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02m2p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Extraterrestrial_life"
				},
				"name": "Extraterrestrials",
				"salience": 0.020104721,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.019743865,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article",
				"salience": 0.019743865,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Claims",
				"salience": 0.019574951,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.017117444,
				"type": "EVENT"
			},
			{
				"name": "Extraordinary",
				"salience": 0.01644318,
				"type": "WORK_OF_ART"
			},
			{
				"name": "link",
				"salience": 0.015015491,
				"type": "OTHER"
			},
			{
				"name": "explanations",
				"salience": 0.014500708,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.014425587,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.013416279,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.013405824,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.013405824,
				"type": "OTHER"
			},
			{
				"name": "Extraterrestrials page",
				"salience": 0.013405824,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.013405824,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.013405824,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.012544579,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.0110345045,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0072441986,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01tdnyh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stephen_Hawking"
				},
				"name": "Hawking",
				"salience": 0.0072053634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ppt0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Extraterrestrials_in_fiction"
				},
				"name": "Extraterrestrial",
				"salience": 0.00546039,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.005340466,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.005180006,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.005180006,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.005120382,
				"type": "PERSON"
			},
			{
				"name": "tactic",
				"salience": 0.0050348816,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.004395657,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conclusions",
				"salience": 0.004263668,
				"type": "OTHER"
			},
			{
				"name": "Scientist",
				"salience": 0.004178596,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.004178596,
				"type": "WORK_OF_ART"
			},
			{
				"name": "evidence",
				"salience": 0.0036339762,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.003513206,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0034984949,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.003487639,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.003487639,
				"type": "WORK_OF_ART"
			},
			{
				"name": "extremophiles",
				"salience": 0.0033822197,
				"type": "OTHER"
			},
			{
				"name": "Extraterrestrials",
				"salience": 0.0033822197,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0033822197,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.003268041,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0031751818,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0030957488,
				"type": "OTHER"
			},
			{
				"name": "telescopes",
				"salience": 0.002977385,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.002967329,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.002967329,
				"type": "OTHER"
			},
			{
				"name": "prediction",
				"salience": 0.0028302628,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.0028302628,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0026449785,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0025383332,
				"type": "OTHER"
			},
			{
				"name": "blanket sstatement",
				"salience": 0.0024620474,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0024436507,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0024436507,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0024436507,
				"type": "OTHER"
			},
			{
				"name": "searches",
				"salience": 0.00229202,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0022287369,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0022065155,
				"type": "PERSON"
			},
			{
				"name": "Extraterrestrials",
				"salience": 0.0021434315,
				"type": "EVENT"
			},
			{
				"name": "explanation",
				"salience": 0.0021434315,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.002072477,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0019848607,
				"type": "ORGANIZATION"
			},
			{
				"name": "activities",
				"salience": 0.0019848607,
				"type": "OTHER"
			},
			{
				"name": "protocols",
				"salience": 0.0019848607,
				"type": "OTHER"
			},
			{
				"name": "civilizations",
				"salience": 0.0019848607,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0019848607,
				"type": "WORK_OF_ART"
			},
			{
				"name": "signal",
				"salience": 0.0019617844,
				"type": "OTHER"
			},
			{
				"name": "planets",
				"salience": 0.0019108041,
				"type": "LOCATION"
			},
			{
				"name": "water",
				"salience": 0.0019108041,
				"type": "OTHER"
			},
			{
				"name": "exoplanets",
				"salience": 0.0019108041,
				"type": "OTHER"
			},
			{
				"name": "zones",
				"salience": 0.0019108041,
				"type": "LOCATION"
			},
			{
				"name": "places",
				"salience": 0.0019108041,
				"type": "LOCATION"
			},
			{
				"name": "building blocks",
				"salience": 0.0019108041,
				"type": "OTHER"
			},
			{
				"name": "comets",
				"salience": 0.0019108041,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.0019108041,
				"type": "OTHER"
			},
			{
				"name": "spectra",
				"salience": 0.0019108041,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0019108041,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.001726539,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.001726539,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0016759953,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.0016205021,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0016205021,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0016150253,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0015613011,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0015613011,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0015209727,
				"type": "OTHER"
			},
			{
				"name": "search",
				"salience": 0.001398053,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.00138044,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0013756237,
				"type": "OTHER"
			},
			{
				"name": "Extraterrestrials",
				"salience": 0.0013580675,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0013075994,
				"type": "OTHER"
			},
			{
				"name": "Science",
				"salience": 0.0013023673,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06_10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Search_for_extraterrestrial_intelligence"
				},
				"name": "SETI",
				"salience": 0.0012218667,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0012218667,
				"type": "LOCATION"
			},
			{
				"name": "cases",
				"salience": 0.0012106256,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0012106256,
				"type": "OTHER"
			},
			{
				"name": "probability",
				"salience": 0.0012106256,
				"type": "OTHER"
			},
			{
				"name": "cherry pick",
				"salience": 0.0012106256,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0012106256,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0012065334,
				"type": "OTHER"
			},
			{
				"name": "Trottier",
				"salience": 0.0011762617,
				"type": "PERSON"
			},
			{
				"name": "Borra",
				"salience": 0.0011762617,
				"type": "PERSON"
			},
			{
				"name": "explanations",
				"salience": 0.00116639,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0011507558,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011328204,
				"type": "PERSON"
			},
			{
				"name": "explanations",
				"salience": 0.0010947367,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0010276538,
				"type": "OTHER"
			},
			{
				"name": "hypothesis",
				"salience": 0.001018258,
				"type": "OTHER"
			},
			{
				"name": "standard",
				"salience": 0.0010009366,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00097291917,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.0008929781,
				"type": "OTHER"
			},
			{
				"name": "sentence",
				"salience": 0.00088172534,
				"type": "OTHER"
			},
			{
				"name": "neoholographic",
				"salience": 0.00088172534,
				"type": "PERSON"
			},
			{
				"name": "existence",
				"salience": 0.0008275525,
				"type": "OTHER"
			},
			{
				"name": "hypothesis",
				"salience": 0.00076065183,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.0006586491,
				"type": "OTHER"
			},
			{
				"name": "NOBODY",
				"salience": 0.0005728804,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats10.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T01:01:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "The words Extraordinary Claims needs to be banished when talking Extraterrestrials page: 1 link I was reading an article that talked about Extraterrestrials the other day and of course at the end of the article the tired line about Extraordinary measures....blah, blah, blah came out towards the end of the article. This needs to stop when talking about Extraterrestrials. It may have been an extraordinary claim 60 years ago but it's not today. With the scientific evidence we have today, many people including one of the top Scientist of our time has reached the conclusion that Extraterrestrials exist based on the evidence. Hawking said,\"Aliens almost certainly exist.\" These are conclusions reached based on the evidence not extraordinary claims. The article was on a possible signal that could be of Extraterrestrial origin. This signal matches a prediction made in 2012 and it's just science. This is what was said at the end of the article and it's this type of thinking that needs to stop. With things like water found on other planets, exoplanets in habitable zones, extremophiles in places we thought life couldn't exist, building blocks of life found on comets and more, saying Extraterrestrials exist isn't an extraordinary claim but a possible explanation based on the evidence. Here's what was said. “The one in 10,000 objects with unusual spectra seen by Borra and Trottier are certainly worthy of additional study,” the team said in a statement. “However, extraordinary claims require extraordinary evidence. “It is too early to unequivocally attribute these purported signals to the activities of extraterrestrial civilizations. Internationally agreed-upon protocols for searches for evidence of advanced life beyond Earth (SETI) require candidates to be confirmed by independent groups using their own telescopes, and for all natural explanations to be exhausted before invoking extraterrestrial agents as an explanation. www.independent.co.uk... First, the Scientist who are behind this study never said UNEQUIVOCALLY. This is an old tactic that's used by some people on this board from time to time. They can't debate the evidence presented so they try to make it seem as you made a blanket sstatement. The Scientist say \"PROBABLY\" right there on the updated comments on their published paper. Here's what they said: But they make clear that further work will need to be done to confirm or deny that hypothesis. That will need to be done by watching for the same signals on different equipment so that all other explanations can be discarded. Again, NOBODY SAID UNEQUIVOCALLY. I hate it when people do that. This is why I always ask people to quote me where I said this or that because when people can't debate the evidence they try to debate against things that were never said. They also said this: ALL natural explanations need to be exhausted BEFORE Extraterrestrials are invoked as a possible explanation. WHAT!!! That makes no sense. This standard would make it almost impossible to find an Extraterrestrial signal. In most cases ALL natural explanations will never be exhausted so we will have to talk about these things in terms of probability and what's most likely and least likely at least at first. Look, it's easy to cherry pick after the fact. Like I said, an earlier study about the search for Extraterrestrials PREDICTED that we would see these signals and that would be evidence to support the hypothesis. That's just Science. If you look at the sentence, it says BEFORE you can even invoke Extraterrestrials as a possible explanation. Again, that's absurd. Extraterrestrial existence needs to be looked at as a possible explanation based on the observed evidence not an extraordinary claim. edit on 26-10-2016 by neoholographic because: (no reason given)",
		"thread_title": "The words Extraordinary Claims needs to be banished when talking Extraterrestrials",
		"title": "The words Extraordinary Claims needs to be banished when talking Extraterrestrials",
		"type": "bs",
		"uuid": "354559f2e2e842e569db09888649087bc243567b"
	},
	"-KhI_tcS9diX-9Pzq1nx": {
		"author": "Peeple",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T01:20:38.942+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "illness",
				"salience": 0.20238738,
				"type": "OTHER"
			},
			{
				"name": "threads",
				"salience": 0.07474882,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.04185044,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.03538929,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.024968391,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01l4vj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dennis_Kucinich"
				},
				"name": "Dennis J. Kucinich",
				"salience": 0.021300416,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.018939039,
				"type": "PERSON"
			},
			{
				"name": "Vinod",
				"salience": 0.015493237,
				"type": "PERSON"
			},
			{
				"name": "stress reaction",
				"salience": 0.014698295,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.014225116,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.014036398,
				"type": "OTHER"
			},
			{
				"name": "pattern",
				"salience": 0.012160109,
				"type": "OTHER"
			},
			{
				"name": "belief issue",
				"salience": 0.012160109,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.008604436,
				"type": "OTHER"
			},
			{
				"name": "persons",
				"salience": 0.0073590013,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0071794773,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0071794773,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0071794773,
				"type": "LOCATION"
			},
			{
				"name": "messages",
				"salience": 0.0071794773,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ultrasound waves",
				"salience": 0.0071700015,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0070847357,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "American Congress",
				"salience": 0.0063044713,
				"type": "ORGANIZATION"
			},
			{
				"name": "Attorney",
				"salience": 0.006231228,
				"type": "PERSON"
			},
			{
				"name": "guide",
				"salience": 0.006218129,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.006218129,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.006218129,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.006218129,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.006218129,
				"type": "OTHER"
			},
			{
				"name": "beam",
				"salience": 0.0053510848,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0048203627,
				"type": "LOCATION"
			},
			{
				"name": "beam",
				"salience": 0.0046263426,
				"type": "OTHER"
			},
			{
				"name": "judgement",
				"salience": 0.0045880415,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.004220395,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0041888603,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0041888603,
				"type": "OTHER"
			},
			{
				"name": "skull tech",
				"salience": 0.0041888603,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.0041277325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017d5m"
				},
				"name": "Nine",
				"salience": 0.003829049,
				"type": "ORGANIZATION"
			},
			{
				"name": "Dictionary.com",
				"salience": 0.003829049,
				"type": "OTHER"
			},
			{
				"name": "hallucinations",
				"salience": 0.003715474,
				"type": "OTHER"
			},
			{
				"name": "radiation",
				"salience": 0.003590628,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.0035454081,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0035454081,
				"type": "OTHER"
			},
			{
				"name": "manipulation",
				"salience": 0.0032754755,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.0032754755,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0032754755,
				"type": "PERSON"
			},
			{
				"name": "lawsuits",
				"salience": 0.0032754755,
				"type": "OTHER"
			},
			{
				"name": "diagnosis",
				"salience": 0.0032374791,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.0029575478,
				"type": "EVENT"
			},
			{
				"name": "knowledge",
				"salience": 0.0029575478,
				"type": "OTHER"
			},
			{
				"name": "human experimentation",
				"salience": 0.0029536395,
				"type": "OTHER"
			},
			{
				"name": "technologies",
				"salience": 0.002937492,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.002863955,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0028278793,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0028278793,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0028278793,
				"type": "PERSON"
			},
			{
				"name": "persons",
				"salience": 0.0028278793,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0028278793,
				"type": "PERSON"
			},
			{
				"name": "persons",
				"salience": 0.0028278793,
				"type": "PERSON"
			},
			{
				"name": "sound",
				"salience": 0.0028015154,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.0028015154,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.0026969728,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.002694329,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.0026629989,
				"type": "OTHER"
			},
			{
				"name": "sound waves",
				"salience": 0.0026523448,
				"type": "OTHER"
			},
			{
				"name": "experiments",
				"salience": 0.0026523448,
				"type": "OTHER"
			},
			{
				"name": "sound waves",
				"salience": 0.0026523448,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0025611082,
				"type": "PERSON"
			},
			{
				"name": "search",
				"salience": 0.0025611082,
				"type": "EVENT"
			},
			{
				"name": "disservice",
				"salience": 0.0025611082,
				"type": "OTHER"
			},
			{
				"name": "beam",
				"salience": 0.002486125,
				"type": "OTHER"
			},
			{
				"name": "human psychic",
				"salience": 0.002486125,
				"type": "OTHER"
			},
			{
				"name": "beam",
				"salience": 0.002486125,
				"type": "OTHER"
			},
			{
				"name": "brain",
				"salience": 0.002486125,
				"type": "OTHER"
			},
			{
				"name": "flashing",
				"salience": 0.0024344698,
				"type": "OTHER"
			},
			{
				"name": "experiments",
				"salience": 0.0024271088,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0023982066,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.0023933437,
				"type": "LOCATION"
			},
			{
				"name": "human brain",
				"salience": 0.0023933437,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.0023260938,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0022967886,
				"type": "OTHER"
			},
			{
				"name": "manipulation",
				"salience": 0.0022967886,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0022967886,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0022967886,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0022392806,
				"type": "WORK_OF_ART"
			},
			{
				"name": "structure",
				"salience": 0.0022277236,
				"type": "OTHER"
			},
			{
				"name": "energies",
				"salience": 0.0022110685,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0022110685,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0022110685,
				"type": "OTHER"
			},
			{
				"name": "radio waves",
				"salience": 0.0021653762,
				"type": "OTHER"
			},
			{
				"name": "technologies",
				"salience": 0.0020989499,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.0020737986,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "light",
				"salience": 0.0020737986,
				"type": "OTHER"
			},
			{
				"name": "consent",
				"salience": 0.0020737986,
				"type": "OTHER"
			},
			{
				"name": "stimulation",
				"salience": 0.0020737986,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0020737986,
				"type": "OTHER"
			},
			{
				"name": "human brain",
				"salience": 0.0020296564,
				"type": "OTHER"
			},
			{
				"name": "weapon system",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "well-being",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "laser",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "populations",
				"salience": 0.001996396,
				"type": "PERSON"
			},
			{
				"name": "populations",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.001996396,
				"type": "EVENT"
			},
			{
				"name": "article",
				"salience": 0.001996396,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stimulation",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "military research",
				"salience": 0.001996396,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.0019712423,
				"type": "WORK_OF_ART"
			},
			{
				"name": "manipulation",
				"salience": 0.0018750646,
				"type": "OTHER"
			},
			{
				"name": "PSYCHOTRONIC WEAPONS-SPACE PRESERVATION ACT",
				"salience": 0.0018205653,
				"type": "OTHER"
			},
			{
				"name": "House Resolution",
				"salience": 0.0018205653,
				"type": "OTHER"
			},
			{
				"name": "sphere",
				"salience": 0.0017957585,
				"type": "OTHER"
			},
			{
				"name": "science fiction",
				"salience": 0.0017957585,
				"type": "OTHER"
			},
			{
				"name": "replication",
				"salience": 0.0017957585,
				"type": "OTHER"
			},
			{
				"name": "world newspapers",
				"salience": 0.0017957585,
				"type": "WORK_OF_ART"
			},
			{
				"name": "frequencies",
				"salience": 0.0017957585,
				"type": "OTHER"
			},
			{
				"name": "combination",
				"salience": 0.0017957585,
				"type": "OTHER"
			},
			{
				"name": "human behavior",
				"salience": 0.0017957585,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.0017957585,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.0017957585,
				"type": "PERSON"
			},
			{
				"name": "most",
				"salience": 0.0017957585,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0017957585,
				"type": "LOCATION"
			},
			{
				"name": "harassment techniques",
				"salience": 0.0017915791,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0017394494,
				"type": "OTHER"
			},
			{
				"name": "Devices",
				"salience": 0.0017364845,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.0017304252,
				"type": "PERSON"
			},
			{
				"name": "information war",
				"salience": 0.0017287284,
				"type": "EVENT"
			},
			{
				"name": "none",
				"salience": 0.0017287284,
				"type": "OTHER"
			},
			{
				"name": "mind control",
				"salience": 0.0017287284,
				"type": "OTHER"
			},
			{
				"name": "mood management",
				"salience": 0.0017287284,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0017287284,
				"type": "OTHER"
			},
			{
				"name": "injury",
				"salience": 0.0017287284,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0017287284,
				"type": "EVENT"
			},
			{
				"name": "ban",
				"salience": 0.0017287284,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.0017287284,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0017175316,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0017086208,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0016929988,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0016929988,
				"type": "OTHER"
			},
			{
				"name": "military unit",
				"salience": 0.0016929988,
				"type": "ORGANIZATION"
			},
			{
				"name": "human being",
				"salience": 0.0016929988,
				"type": "OTHER"
			},
			{
				"name": "installation",
				"salience": 0.0016929988,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0016929988,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0016929988,
				"type": "WORK_OF_ART"
			},
			{
				"name": "human mind",
				"salience": 0.0016929988,
				"type": "OTHER"
			},
			{
				"name": "military chemical experimentation",
				"salience": 0.0016176158,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02cd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Diagnostic_and_Statistical_Manual_of_Mental_Disorders"
				},
				"name": "DSM",
				"salience": 0.0015764615,
				"type": "ORGANIZATION"
			},
			{
				"name": "Letter",
				"salience": 0.0015228392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "testing",
				"salience": 0.0014659921,
				"type": "EVENT"
			},
			{
				"name": "perception",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "functioning",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "sleep",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "induction",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "Discoveries",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "assumption",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "literature",
				"salience": 0.0014659921,
				"type": "WORK_OF_ART"
			},
			{
				"name": "development",
				"salience": 0.0014659921,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.0014356906,
				"type": "OTHER"
			},
			{
				"name": "denominators",
				"salience": 0.0014112662,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0014112662,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0014007128,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.0014007128,
				"type": "OTHER"
			},
			{
				"name": "lifetime",
				"salience": 0.0014007128,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "USSR",
				"salience": 0.0013721889,
				"type": "LOCATION"
			},
			{
				"name": "rabbit hole",
				"salience": 0.0013137332,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.0013048203,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0012830176,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.001264689,
				"type": "OTHER"
			},
			{
				"name": "symptoms",
				"salience": 0.001264689,
				"type": "OTHER"
			},
			{
				"name": "symptoms",
				"salience": 0.001264689,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.001264689,
				"type": "OTHER"
			},
			{
				"name": "Radioson",
				"salience": 0.0012492589,
				"type": "ORGANIZATION"
			},
			{
				"name": "Radiosleep",
				"salience": 0.0012492589,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons",
				"salience": 0.0012092151,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0011042455,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "achievements",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "similarities",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "lysergic acid diethylamide",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "paranoia",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0010950944,
				"type": "ORGANIZATION"
			},
			{
				"name": "more",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0010950944,
				"type": "ORGANIZATION"
			},
			{
				"name": "details",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "reading",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "surveillance scenarios",
				"salience": 0.0010950944,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0010861453,
				"type": "OTHER"
			},
			{
				"name": "Government Committee on the Matters of Inventions",
				"salience": 0.0010420064,
				"type": "ORGANIZATION"
			},
			{
				"name": "human experimentation",
				"salience": 0.0009990302,
				"type": "OTHER"
			},
			{
				"name": "aliens",
				"salience": 0.0009894321,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0009746878,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.00092104444,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00092104444,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00092104444,
				"type": "WORK_OF_ART"
			},
			{
				"name": "another",
				"salience": 0.00092104444,
				"type": "OTHER"
			},
			{
				"name": "gopher level",
				"salience": 0.00092104444,
				"type": "OTHER"
			},
			{
				"name": "hallucinations",
				"salience": 0.00092104444,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00092104444,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gzyb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Novosibirsk"
				},
				"name": "Novosibirsk",
				"salience": 0.0009022657,
				"type": "LOCATION"
			},
			{
				"name": "rabbit hole",
				"salience": 0.0008866564,
				"type": "OTHER"
			},
			{
				"name": "waves",
				"salience": 0.00088002504,
				"type": "OTHER"
			},
			{
				"name": "Congressional Committee Report",
				"salience": 0.0008620824,
				"type": "WORK_OF_ART"
			},
			{
				"name": "seizure",
				"salience": 0.0007975219,
				"type": "OTHER"
			},
			{
				"name": "lobe",
				"salience": 0.0007975219,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0007975219,
				"type": "OTHER"
			},
			{
				"name": "abduction",
				"salience": 0.0007975219,
				"type": "EVENT"
			},
			{
				"name": "memory",
				"salience": 0.0007975219,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.0007975219,
				"type": "EVENT"
			},
			{
				"name": "least",
				"salience": 0.0007975219,
				"type": "OTHER"
			},
			{
				"name": "v. Stanley",
				"salience": 0.00077835354,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.0007620025,
				"type": "ORGANIZATION"
			},
			{
				"name": "government agencies",
				"salience": 0.0007620025,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.0007620025,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.0007620025,
				"type": "PERSON"
			},
			{
				"name": "government agencies",
				"salience": 0.0007620025,
				"type": "ORGANIZATION"
			},
			{
				"name": "energy",
				"salience": 0.0007620025,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0007620025,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00072127295,
				"type": "PERSON"
			},
			{
				"name": "Evidence",
				"salience": 0.00069677416,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00068799185,
				"type": "ORGANIZATION"
			},
			{
				"name": "level",
				"salience": 0.00068799185,
				"type": "OTHER"
			},
			{
				"name": "hearings",
				"salience": 0.00068799185,
				"type": "EVENT"
			},
			{
				"name": "lasers",
				"salience": 0.00068799185,
				"type": "OTHER"
			},
			{
				"name": "D.D.C. 1988",
				"salience": 0.0006739638,
				"type": "ORGANIZATION"
			},
			{
				"name": "S. Prt. 103",
				"salience": 0.0006739638,
				"type": "LOCATION"
			},
			{
				"name": "2d Session",
				"salience": 0.0006739638,
				"type": "EVENT"
			},
			{
				"name": "MILABS",
				"salience": 0.000608928,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "targeting",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.000595719,
				"type": "PERSON"
			},
			{
				"name": "filings",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "releases",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "sophistication",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "electromagnetism",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "microwaves",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"name": "draft",
				"salience": 0.000595719,
				"type": "EVENT"
			},
			{
				"name": "types",
				"salience": 0.000595719,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fzds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Patent_and_Trademark_Office"
				},
				"name": "U.S. Patent and Trademark Office",
				"salience": 0.00042339796,
				"type": "ORGANIZATION"
			},
			{
				"name": "Space Preservation Act",
				"salience": 0.00042339796,
				"type": "WORK_OF_ART"
			},
			{
				"name": "House Resolution 2977",
				"salience": 0.00042339796,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00036660844,
				"type": "ORGANIZATION"
			},
			{
				"name": "Orlikow",
				"salience": 0.00036660844,
				"type": "PERSON"
			},
			{
				"name": "F.Supp",
				"salience": 0.00036660844,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats10.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T00:53:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Hey People: I always enjoy your threads, though I think you focus too much on a singular belief issue or pattern, and then it becomes self affirming for you in your research. First, this: But voices actual voices in your head is always mental illness. Sorry, maybe a stress reaction, not to be judgmental, happens to the best and such, just really not what I am trying to convey here. Though I believe you are quite intelligent, I don't think you are qualified, exactly, to make that wholesale, definitive judgement. You even contradict that by referencing Dr. Vinod's \"channeling\" of the Nine in 1952. Channeling, by definition, (from Dictionary.com) means in one sense: the practice of professedly entering a meditative or trancelike state in order to convey messages from a spiritual guide. Surely this process would involve the sensory structure of hearing. I don't wish to debate voice to skull tech with you because I don't sense this is really what your thread is about. But there have been lawsuits waged and won over such technology being used to harass people, who don't test as schizophrenic or any other DSM related diagnosis that would explain auditory hallucinations, indicating mental illness. Now, that's not to say that anyone hearing voices is being technologically harassed. But saying definitively it's always mental illness does a disservice to the search for knowledge, and stopping such technology being used on people. link to lawsuit PSYCHOTRONIC WEAPONS-SPACE PRESERVATION ACT-House Resolution bill 2977-Brain manipulation from a distance-2001-2002 Last year, in October, the Congressman Dennis J. Kucinich introduced in the American Congress a bill, obliging the American president to get engaged in the negotiations aimed at the ban of space based weapons. In this bill the definition of a weapon system includes: any other unacknowledged or as yet undeveloped means inflicting death or injury on, or damaging or destroying, a person (or the biological life, bodily health, mental health, or physical and economic well-being of a person) through the use of land-based, sea-based, or space-based systems using radiation, electromagnetic, psychotronic, sonic, laser, or other energies directed at individual persons or targeted populations or the purpose of information war, mood management, or mind control of such persons or populations\" (12). As in all legislative acts quoted in this article the bill counts with sound, light or electromagnetic stimulation of human brain. Psychotronic weapons remain, at least for a layman uninformed of secret military research, in the sphere of science fiction, since so far none of the published scientific experiments was presented in the way which would allow for its replication. That it is feasible to manipulate human behavior with the use of subliminal, either sound or visual, messages is now generally known. This is why in most of the countries the use of such technologies, without consent of the user, is banned. Devices using light for the stimulation of the brain show another way how the light flashing in certain frequencies could be used for the manipulation of human psychic life. As for the sound, a report on the device transmitting a beam of sound waves, which can hear only persons at whom the beam of sound waves is targeted, appeared last year in the world newspapers. The beam is formed by a combination of sound and ultrasound waves which causes that a person targeted by this beam hears the sound inside of his head. Such a perception could easily convince the human being that it is mentally ill. The acts presented in this article suggest that with the development of technology and knowledge of the functioning of human brain new ways of manipulation of human mind keep emerging. One of them seems to be the electromagnetic energy. Though in the open scientific literature only some 30 experiments were published, supporting this assumption (1),(2), already in 1974, in the USSR, after successful testing with military unit in Novosibirsk, the installation Radioson (Radiosleep) was registered with the Government Committee on the Matters of Inventions and Discoveries of the USSR, described as a method of induction of sleep by means of radio waves (3), (4), (5)… 22. Dear Senator-Attorney Letter included: We seek your office’s assistance in initiating hearings and a fact-finding congressional inquiry into the government agencies and/or private companies that are targeting citizens. Many citizens are desperate to be freed from the disturbing, intrusive and oppressive targeting. Evidence supports the conclusion that weapons exist that could be used against individuals, based on U.S. Patent and Trademark Office filings, public releases by agencies, and other technologies that indicate the level of technological sophistication. The weapons are believed to be based on electromagnetism, microwaves, sonic waves, lasers and other types of directed energy, and were characterized as “psychotronic” in Rep. Dennis Kucinich’s draft of House Resolution 2977, the Space Preservation Act of 2001. Furthermore, it is undeniable that government agencies have tested citizens without permission in the past; for example, the CIA’s human experimentation discussed in Orlikow v. U.S., 682 F.Supp. 77 (D.D.C. 1988), secretly administered lysergic acid diethylamide discussed in United States v. Stanley, 483 U.S. 669 (1987), and military chemical experimentation as discussed in Congressional Committee Report 103-97, 103d Congress, 2d Session, S. Prt. 103-97 (Dec. 8, 1994). Lastly, the sheer numbers of people complaining of being targeted, including people with post-graduate degrees and a lifetime of achievements, and the similarities in symptoms tend to outweigh a dismissive response based on charges of anecdotal evidence or group paranoia. there is a certain risk of sounding too conspiratorial, however, common denominators such as physical symptoms and medical reports, surveillance scenarios, harassment techniques, and more can be readily established. I highly recommend reading in full the details of this lawsuit, containing a great deal of verifiable information. The military has admitted for some time to having, at the least, a non lethal (lol) weapon called active denial. But this rabbit hole goes much, much deeper. Having said all that, as I've said before in one of your threads, I think it wise to consider that it's not just one thing or another. It's many things. There could be aliens, for instance. And then there could be MILABS, leaving the person with the memory of an alien abduction, rather than their being used for human experimentation, which is supposed to be against our constitution, and most certainly against our human rights. And then people can also suffer from temporal lobe, seizure like hallucinations, but one must also remember that these can most certainly be induced, artificially, as well. In short, I think your rabbit hole is only making it to the gopher level regards,",
		"thread_title": "We Know The Truth",
		"title": "We Know The Truth",
		"type": "bs",
		"uuid": "9465e8b596e6171df4742b8414f8906fd7629d6c"
	},
	"-KhI_tlu3gMK16PYoNmw": {
		"author": "PraetorianAZ",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T01:20:40.384+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFO",
				"salience": 0.30083707,
				"type": "ORGANIZATION"
			},
			{
				"name": "lights",
				"salience": 0.11784638,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jt2mz8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_Valley_(Phoenix_metropolitan_area)"
				},
				"name": "East Valley",
				"salience": 0.06060994,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "AZ",
				"salience": 0.06060994,
				"type": "LOCATION"
			},
			{
				"name": "pictures",
				"salience": 0.053689007,
				"type": "WORK_OF_ART"
			},
			{
				"name": "page",
				"salience": 0.05044053,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.05044053,
				"type": "OTHER"
			},
			{
				"name": "balcony",
				"salience": 0.030359466,
				"type": "LOCATION"
			},
			{
				"name": "friends",
				"salience": 0.029605787,
				"type": "PERSON"
			},
			{
				"name": "Lots",
				"salience": 0.028335629,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.026384339,
				"type": "PERSON"
			},
			{
				"name": "flares",
				"salience": 0.024489747,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.020945799,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.01854675,
				"type": "PERSON"
			},
			{
				"name": "flare",
				"salience": 0.015358694,
				"type": "OTHER"
			},
			{
				"name": "flares",
				"salience": 0.015358694,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.014711717,
				"type": "WORK_OF_ART"
			},
			{
				"name": "family",
				"salience": 0.014164709,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z7g9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Queen_Creek,_Arizona"
				},
				"name": "Queen Creek",
				"salience": 0.0129215,
				"type": "LOCATION"
			},
			{
				"name": "West Mesa",
				"salience": 0.0129215,
				"type": "LOCATION"
			},
			{
				"name": "plane",
				"salience": 0.0120190205,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0085422415,
				"type": "OTHER"
			},
			{
				"name": "lights",
				"salience": 0.0062572295,
				"type": "OTHER"
			},
			{
				"name": "ATS",
				"salience": 0.0056773936,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kinda nuts",
				"salience": 0.004893616,
				"type": "OTHER"
			},
			{
				"name": "PraetorianAZ",
				"salience": 0.0040327795,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T23:51:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "UFO over the East Valley here in AZ last night. page: 1 link I couldn't take any pictures I live in West Mesa and the lights were way East. Over Queen Creek area. Lots of my friends and family started calling me right when the lights started happening so I went out to my balcony and there they were. Some people got some pretty good videos. I know some people will say they are flares from a plane but if they are flares why do they dispensary right away. Typically if its a flare it will stay ignited for a short period of time. Kinda nuts. I only witnessed the later 3 lights when it was dark out. It was pretty cool to see and stopped soon after it started. What does ATS think??? edit on 26-10-2016 by PraetorianAZ because: (no reason given)",
		"thread_title": "UFO over the East Valley here in AZ last night.",
		"title": "UFO over the East Valley here in AZ last night.",
		"type": "bs",
		"uuid": "9ef3b49b0b27e00a687ed032c58132e961537a71"
	},
	"-KhI_u-t_aPzMVkNBGlL": {
		"author": "seentoomuch",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T01:20:44.272+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03q0zv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Support_Program"
				},
				"name": "DSP",
				"salience": 0.16644801,
				"type": "OTHER"
			},
			{
				"name": "Podesta",
				"salience": 0.075955294,
				"type": "PERSON"
			},
			{
				"name": "Podesta",
				"salience": 0.03682565,
				"type": "LOCATION"
			},
			{
				"name": "Program page",
				"salience": 0.035532694,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.035532694,
				"type": "OTHER"
			},
			{
				"name": "nugget",
				"salience": 0.035532694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cs175p"
				},
				"name": "Fastwalkers",
				"salience": 0.03512765,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "USAF",
				"salience": 0.023679744,
				"type": "ORGANIZATION"
			},
			{
				"name": "ID #",
				"salience": 0.021934709,
				"type": "OTHER"
			},
			{
				"name": "government programs",
				"salience": 0.021773266,
				"type": "OTHER"
			},
			{
				"name": "UFO files",
				"salience": 0.021019543,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.020272635,
				"type": "PERSON"
			},
			{
				"name": "course correction",
				"salience": 0.019360106,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.018677779,
				"type": "WORK_OF_ART"
			},
			{
				"name": "case",
				"salience": 0.018211782,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.015816366,
				"type": "OTHER"
			},
			{
				"name": "dates",
				"salience": 0.015532914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03q0zv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Support_Program"
				},
				"name": "DSP",
				"salience": 0.0128230285,
				"type": "ORGANIZATION"
			},
			{
				"name": "Leslie Kean",
				"salience": 0.0112250205,
				"type": "PERSON"
			},
			{
				"name": "satellite program",
				"salience": 0.011073666,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.010447531,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.009604265,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.008673118,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.008250532,
				"type": "PERSON"
			},
			{
				"name": "web",
				"salience": 0.007511704,
				"type": "OTHER"
			},
			{
				"name": "rumors",
				"salience": 0.007511704,
				"type": "OTHER"
			},
			{
				"name": "occasion",
				"salience": 0.007511704,
				"type": "EVENT"
			},
			{
				"name": "reference",
				"salience": 0.007511704,
				"type": "OTHER"
			},
			{
				"name": "insight",
				"salience": 0.007511704,
				"type": "OTHER"
			},
			{
				"name": "flying objects",
				"salience": 0.007511704,
				"type": "OTHER"
			},
			{
				"name": "factoid",
				"salience": 0.0073090475,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.0071406267,
				"type": "PERSON"
			},
			{
				"name": "satellite",
				"salience": 0.006737151,
				"type": "OTHER"
			},
			{
				"name": "satellite",
				"salience": 0.006737151,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0064859255,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fastwalker",
				"salience": 0.00629814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018w0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gulf_War"
				},
				"name": "Operation Desert Shield",
				"salience": 0.006089734,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "earth",
				"salience": 0.0060835844,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0060835844,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0060835844,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0059541934,
				"type": "OTHER"
			},
			{
				"name": "cafeteria",
				"salience": 0.005856697,
				"type": "OTHER"
			},
			{
				"name": "cafeteria",
				"salience": 0.005856697,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.0052685114,
				"type": "OTHER"
			},
			{
				"name": "backside",
				"salience": 0.0052685114,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.0052685114,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.0052685114,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0050719865,
				"type": "ORGANIZATION"
			},
			{
				"name": "gossipers",
				"salience": 0.0050719865,
				"type": "PERSON"
			},
			{
				"name": "clearances",
				"salience": 0.0050719865,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0050719865,
				"type": "PERSON"
			},
			{
				"name": "reentry trajectory",
				"salience": 0.0047006323,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.004684512,
				"type": "LOCATION"
			},
			{
				"name": "patterns",
				"salience": 0.0043564397,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0043015736,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0043015736,
				"type": "OTHER"
			},
			{
				"name": "meteorite",
				"salience": 0.0043015736,
				"type": "OTHER"
			},
			{
				"name": "Somewhere",
				"salience": 0.004141083,
				"type": "LOCATION"
			},
			{
				"name": "ground",
				"salience": 0.0041101333,
				"type": "OTHER"
			},
			{
				"name": "lunch",
				"salience": 0.003789486,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0037649507,
				"type": "PERSON"
			},
			{
				"name": "hazard support system",
				"salience": 0.0037649507,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.003711193,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.003632218,
				"type": "OTHER"
			},
			{
				"name": "worth",
				"salience": 0.003424035,
				"type": "OTHER"
			},
			{
				"name": "correlation",
				"salience": 0.0033532868,
				"type": "OTHER"
			},
			{
				"name": "substantiation",
				"salience": 0.0032137348,
				"type": "OTHER"
			},
			{
				"name": "program office",
				"salience": 0.0032137348,
				"type": "OTHER"
			},
			{
				"name": "craft",
				"salience": 0.0032137348,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0032137348,
				"type": "OTHER"
			},
			{
				"name": "destinations",
				"salience": 0.0032137348,
				"type": "LOCATION"
			},
			{
				"name": "eyewitness claims",
				"salience": 0.0032137348,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "CA",
				"salience": 0.0031225253,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0r099",
					"wikipedia_url": "http://en.wikipedia.org/wiki/El_Segundo,_California"
				},
				"name": "El Segundo",
				"salience": 0.0031225253,
				"type": "LOCATION"
			},
			{
				"name": "TS/SCI",
				"salience": 0.0031225253,
				"type": "OTHER"
			},
			{
				"name": "resource mining operation",
				"salience": 0.0029937928,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00270314,
				"type": "EVENT"
			},
			{
				"name": "earth",
				"salience": 0.00270314,
				"type": "LOCATION"
			},
			{
				"name": "event",
				"salience": 0.00270314,
				"type": "EVENT"
			},
			{
				"name": "info",
				"salience": 0.0026456034,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0024209083,
				"type": "OTHER"
			},
			{
				"name": "appearances",
				"salience": 0.0023407307,
				"type": "EVENT"
			},
			{
				"name": "detonation",
				"salience": 0.0023407307,
				"type": "OTHER"
			},
			{
				"name": "atomic bomb",
				"salience": 0.0023407307,
				"type": "OTHER"
			},
			{
				"name": "Regards",
				"salience": 0.0023407307,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFO",
				"salience": 0.0022844886,
				"type": "ORGANIZATION"
			},
			{
				"name": "much",
				"salience": 0.0022533606,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0022533606,
				"type": "OTHER"
			},
			{
				"name": "ufodigest.com",
				"salience": 0.0019781822,
				"type": "OTHER"
			},
			{
				"name": "DSP Fact Sheet",
				"salience": 0.0018332504,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0017485756,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0017485756,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0017485756,
				"type": "OTHER"
			},
			{
				"name": "portions",
				"salience": 0.0017485756,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0017485756,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.0017485756,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0017485756,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0016411413,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ws_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_Sands_National_Monument"
				},
				"name": "White Sands",
				"salience": 0.0014407018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07c5f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Aerospace_Corporation"
				},
				"name": "Aerospace Corporation",
				"salience": 0.0010761783,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats12.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T21:13:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Found this nugget in Podesta files Fastwalkers and DSP Program page: 1 Found this in the Podesta files, ID # 30433. It's probably well known already, just thought I'd post it just in case. Podesta had forwarded this letter he received onto Leslie Kean. Date: 2015-03-06 John – Just tuck this in your UFO files for future reference. One of the government programs that collects hard data on unidentified flying objects is the USAF DSP satellite program. I can add a little insight to rumors published on the web. While I was never fully briefed into the DSP operation directly, I was introduced to them as the US prepared for Operation Desert Shield and Desert Storm. On occasion, I had lunch with a few of them in the cafeteria of a highly classified organization in El Segundo, CA. No one could get into the cafeteria without TS/SCI clearances, so this was not “lightweight group of gossipers.” One of these times, a member of that group was really excited – said they’d just picked up Fastwalker (I assumed that same day). He described how it entered our atmosphere from “deep space” (origin actually unknown, of course, but from the backside of the satellite) and zipped by the DSP satellite pretty closely on its way to earth. Not only was it going very fast but it made a 30 degree course correction (turn) which means it did not have a ballistic (free fall) reentry trajectory that a meteorite might have. So, it was under some sort of control – although whether it was “manned” or just “robotic” there’s no way to tell. Although its now 24 years later, one factoid makes me think the USAF is still collecting information on these Fastwalkers. Reading the current official USAF “DSP Fact Sheet” there is this line near the end: In addition, researchers at The Aerospace Corporation have used DSP to develop portions of a hazard support system that will aid public safety in the future. www.losangeles.af.mil... Also, much of the information on this site is accurate although I do not know the author or his sources: ufodigest.com... Somewhere within that USAF program office is many year’s worth of Fastwalker data. If someone were to collect and analyze it, patterns will emerge that provide information about the various types of craft and their destinations, which would add substantiation to eyewitness claims on the ground about UFO activity. Furthermore, it would be interesting to understand the dates of these appearances – is there a certain time of the every year they swarm in (which might indicate a resource mining operation) or might there be a correlation with major events on earth, (such as the detonation of the first atomic bomb at White Sands in 1945 although no DSP’s existed to provide any info on that particular event)? Regards,",
		"thread_title": "Found this nugget in Podesta files Fastwalkers and DSP Program",
		"title": "Found this nugget in Podesta files Fastwalkers and DSP Program",
		"type": "bs",
		"uuid": "0293466db9711d1b8e4022fa8b41e989384455d4"
	},
	"-KhI_u886m6wsIxtgkXN": {
		"author": "vlawde",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:39.811+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "work bunker",
				"salience": 0.15106076,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.09795228,
				"type": "LOCATION"
			},
			{
				"name": "Man",
				"salience": 0.07261169,
				"type": "PERSON"
			},
			{
				"name": "crap",
				"salience": 0.071709365,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.03799869,
				"type": "OTHER"
			},
			{
				"name": "loot",
				"salience": 0.029754346,
				"type": "OTHER"
			},
			{
				"name": "lol",
				"salience": 0.029754346,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.029754346,
				"type": "OTHER"
			},
			{
				"name": "mine site",
				"salience": 0.027935684,
				"type": "OTHER"
			},
			{
				"name": "employer",
				"salience": 0.024936263,
				"type": "PERSON"
			},
			{
				"name": "vegetables",
				"salience": 0.024775468,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.023961179,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0208951,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0208951,
				"type": "LOCATION"
			},
			{
				"name": "item",
				"salience": 0.020117888,
				"type": "OTHER"
			},
			{
				"name": "truck",
				"salience": 0.020117888,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stock",
				"salience": 0.020117888,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.017069425,
				"type": "OTHER"
			},
			{
				"name": "genny",
				"salience": 0.017069425,
				"type": "OTHER"
			},
			{
				"name": "door boiler",
				"salience": 0.017069425,
				"type": "OTHER"
			},
			{
				"name": "propane tank",
				"salience": 0.017069425,
				"type": "OTHER"
			},
			{
				"name": "heat",
				"salience": 0.017069425,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.016854957,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.016729286,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.016643176,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.015311982,
				"type": "OTHER"
			},
			{
				"name": "Im On",
				"salience": 0.014868018,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.012760453,
				"type": "OTHER"
			},
			{
				"name": "buck",
				"salience": 0.012760453,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.012760453,
				"type": "PERSON"
			},
			{
				"name": "yard",
				"salience": 0.012760453,
				"type": "LOCATION"
			},
			{
				"name": "Lots",
				"salience": 0.012760453,
				"type": "OTHER"
			},
			{
				"name": "partridge",
				"salience": 0.012760453,
				"type": "OTHER"
			},
			{
				"name": "bears",
				"salience": 0.012760453,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.008023378,
				"type": "LOCATION"
			},
			{
				"name": "gas storage container",
				"salience": 0.006948594,
				"type": "OTHER"
			},
			{
				"name": "panels",
				"salience": 0.0056020394,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:39.811+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.1,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "You have a work bunker? What is it exactly that you do? Man if the world went to crap, the last thing i would be concerned about is ensuring my employer keeps the loot rolling in lol. In fact if that does go down, im jumping in my truck with a motivational \"item\" and coming to work to stock up. The mine site has enough food for 500 people a for 2 weeks at a time. I live out in the country. Im On well water, 1000 liter propane tank for heat and out door boiler. The genny is hooked up to a 400 liter gas storage container. My house that im building up the road from my current house already has the solar panels hooked up on a 24 volt system. Everyday, theres a buck or a couple does in the yard. Lots of partridge and bears around if things get rough. Only thing we would be lacking is fresh vegetables over the winter...which could be problematic.",
		"thread_title": "EMP event forthcoming?",
		"title": "EMP event forthcoming?",
		"type": "bs",
		"uuid": "39aeeae86034a00eb042a4cf133b5213d4cdda82"
	},
	"-KhI_uOod7alAQwwMFxi": {
		"author": "apoc36",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:41.397+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "kids",
				"salience": 0.70511925,
				"type": "PERSON"
			},
			{
				"name": "Kids",
				"salience": 0.018313792,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.01648956,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.01631122,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.014357741,
				"type": "PERSON"
			},
			{
				"name": "home address",
				"salience": 0.012783746,
				"type": "OTHER"
			},
			{
				"name": "achievements",
				"salience": 0.01215669,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.011249288,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.010179705,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.010179705,
				"type": "ORGANIZATION"
			},
			{
				"name": "School page",
				"salience": 0.00975081,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.008667548,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.008351972,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.007366368,
				"type": "PERSON"
			},
			{
				"name": "accomplishments",
				"salience": 0.006555185,
				"type": "OTHER"
			},
			{
				"name": "check mark",
				"salience": 0.005765241,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.005765241,
				"type": "OTHER"
			},
			{
				"name": "signature",
				"salience": 0.005765241,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.005765241,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081mh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Virginia"
				},
				"name": "West Virginia",
				"salience": 0.0054419385,
				"type": "LOCATION"
			},
			{
				"name": "high school",
				"salience": 0.0042064087,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0042064087,
				"type": "ORGANIZATION"
			},
			{
				"name": "grade school",
				"salience": 0.0042064087,
				"type": "OTHER"
			},
			{
				"name": "Children",
				"salience": 0.00404521,
				"type": "PERSON"
			},
			{
				"name": "buildings",
				"salience": 0.0038468083,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.0030402786,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.002951391,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.002951391,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.0028413942,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.002704557,
				"type": "OTHER"
			},
			{
				"name": "nominees",
				"salience": 0.0023778467,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.0023778467,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.002261956,
				"type": "OTHER"
			},
			{
				"name": "pic",
				"salience": 0.0020685776,
				"type": "WORK_OF_ART"
			},
			{
				"name": "something",
				"salience": 0.002050396,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.0019416105,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.0019245433,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Picture",
				"salience": 0.0019245433,
				"type": "WORK_OF_ART"
			},
			{
				"name": "paper",
				"salience": 0.0019245433,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0018845821,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0018009468,
				"type": "LOCATION"
			},
			{
				"name": "Document",
				"salience": 0.0017780651,
				"type": "WORK_OF_ART"
			},
			{
				"name": "President",
				"salience": 0.0017413436,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0016677432,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0016677432,
				"type": "LOCATION"
			},
			{
				"name": "tv show",
				"salience": 0.0016055321,
				"type": "WORK_OF_ART"
			},
			{
				"name": "speaking",
				"salience": 0.0016055321,
				"type": "OTHER"
			},
			{
				"name": "camera",
				"salience": 0.0016055321,
				"type": "OTHER"
			},
			{
				"name": "phone",
				"salience": 0.0016055321,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "back",
				"salience": 0.0016055321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g8309",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump"
				},
				"name": "Trumps",
				"salience": 0.0013692966,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.0013616544,
				"type": "OTHER"
			},
			{
				"name": "check mark",
				"salience": 0.0013616544,
				"type": "OTHER"
			},
			{
				"name": "signature",
				"salience": 0.0013616544,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.0013275711,
				"type": "LOCATION"
			},
			{
				"name": "pic",
				"salience": 0.0013108504,
				"type": "WORK_OF_ART"
			},
			{
				"name": "picture",
				"salience": 0.0012195304,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Picture",
				"salience": 0.0012195304,
				"type": "WORK_OF_ART"
			},
			{
				"name": "apoc36",
				"salience": 0.0011707052,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0010172965,
				"type": "PERSON"
			},
			{
				"name": "tv show",
				"salience": 0.0010172965,
				"type": "WORK_OF_ART"
			},
			{
				"name": "camera",
				"salience": 0.0010172965,
				"type": "OTHER"
			},
			{
				"name": "phone",
				"salience": 0.0010172965,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "url",
				"salience": 0.0010172965,
				"type": "OTHER"
			},
			{
				"name": "url",
				"salience": 0.0010172965,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0009801299,
				"type": "ORGANIZATION"
			},
			{
				"name": "high school",
				"salience": 0.0009801299,
				"type": "OTHER"
			},
			{
				"name": "grade school",
				"salience": 0.0009801299,
				"type": "OTHER"
			},
			{
				"name": "polling grade school children",
				"salience": 0.00095481175,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0007409474,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.0007409474,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.0007409474,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0007079571,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.00066357944,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00064160075,
				"type": "EVENT"
			},
			{
				"name": "opinions",
				"salience": 0.00064160075,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.00064160075,
				"type": "OTHER"
			},
			{
				"name": "filters",
				"salience": 0.00064160075,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00064160075,
				"type": "OTHER"
			},
			{
				"name": "speaking",
				"salience": 0.000553502,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.000553502,
				"type": "OTHER"
			},
			{
				"name": "nominees",
				"salience": 0.000553502,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.000553502,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.000526492,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:41.397+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Kids being made to vote for President in School page: 1 link I live in West Virginia. My kids came home today from school and was talking about voting at school for the next President. They explained something similar to a ballot. Where they had to put a check mark beside who they wanted as President along with their home address and signature. I have never heard of this , as my kids have never had to do this before or was I notified that my kids would be voting. My kids are age 11 and 9, 1 in grade school and another in middle / jr high school. I asked them if they were given any documentation from school about the nominees. They showed me 1 paper that spoke about all of Hillary's achievements and on the back it shows Trumps. However the paper seemed biased speaking of Hillary's accomplishments and barely spoke of Trump other than he built a few buildings and was on a tv show. I do not own a actual camera other than my phone. So the pic is bit blurry. Picture of Document Again sorry for the blurry picture. My kids have been going to school here all their lives. I have never seen this before, might be something new. Has anyone else seen this before? edit on pmp20162016-10-26T18:08:54-05:0036 by apoc36 because: (no reason given) link originally posted by: apoc36 I live in West Virginia. My kids came home today from school and was talking about voting at school for the next President. They explained something similar to a ballot. Where they had to put a check mark beside who they wanted as President along with their home address and signature. I have never heard of this , as my kids have never had to do this before or was I notified that my kids would be voting. My kids are age 11 and 9, 1 in grade school and another in middle / jr high school. I asked them if they were given any documentation from school about the nominees. They showed me 1 paper that spoke about all of Hillary's achievements and on the back it shows Trumps. However the paper seemed biased speaking of Hillary's accomplishments and barely spoke of Trump other than he built a few buildings and was on a tv show. I do not own a actual camera other than my phone. So the pic is bit blurry. [url=http://postimg.org/image/v35tvwykv/]Blurry Picture of _/url] Again sorry for the blurry picture. My kids have been going to school here all their lives. I have never seen this before, might be something new. Has anyone else seen this before? This has been done for years. I remember it happening when I was in 2nd grade more than 40 years ago. I have heard that polling grade school children on Presidential elections is actually more accurate than 'scientific polls'. Children tend to hear what their parents opinions are on the subject without all the filters. They subconsciously 'vote' the way their parents will vote (supposedly).",
		"thread_title": "Kids being made to vote for President in School",
		"title": "Kids being made to vote for President in School",
		"type": "bs",
		"uuid": "088ddf580942133f16728aa4773e94bcc26bcfc0"
	},
	"-KhI_uZXahG5itTXbFqp": {
		"author": "theantediluvian",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:46.091+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "guy",
				"salience": 0.4533868,
				"type": "PERSON"
			},
			{
				"name": "re-election",
				"salience": 0.0700157,
				"type": "EVENT"
			},
			{
				"name": "mandate",
				"salience": 0.0700157,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0700157,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.03375921,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.03117709,
				"type": "OTHER"
			},
			{
				"name": "asshole",
				"salience": 0.027178986,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.019849649,
				"type": "OTHER"
			},
			{
				"name": "Tweet",
				"salience": 0.015033221,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Link",
				"salience": 0.015033221,
				"type": "OTHER"
			},
			{
				"name": "fantasies",
				"salience": 0.013937392,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.011731892,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g8309",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump"
				},
				"name": "Trump",
				"salience": 0.011704777,
				"type": "PERSON"
			},
			{
				"name": "sheep",
				"salience": 0.010557135,
				"type": "OTHER"
			},
			{
				"name": "revolutionaries",
				"salience": 0.010557135,
				"type": "PERSON"
			},
			{
				"name": "colonists",
				"salience": 0.010557135,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.010164453,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.010164453,
				"type": "OTHER"
			},
			{
				"name": "self-aggrandizing",
				"salience": 0.010164453,
				"type": "OTHER"
			},
			{
				"name": "Wreckless",
				"salience": 0.009272031,
				"type": "OTHER"
			},
			{
				"name": "muskets",
				"salience": 0.008624234,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.008624234,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.008348776,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.007443038,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.006447149,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.006447149,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0061289053,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d4whv"
				},
				"name": "Joe",
				"salience": 0.005313991,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_6j_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alex_Jones_(radio_host)"
				},
				"name": "Alex Jones",
				"salience": 0.005313991,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.005198935,
				"type": "OTHER"
			},
			{
				"name": "theantediluvian",
				"salience": 0.0046980917,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0039523607,
				"type": "PERSON"
			},
			{
				"name": "pick",
				"salience": 0.0035107392,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0035107392,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01sb5r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Walsh"
				},
				"name": "Walsh",
				"salience": 0.002161534,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats15.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:46.091+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link This guy didn't even win re-election but he think's he's got a mandate of some sort to take up arms if the candidate he supports doesn't win in November? Link to Tweet : Wreckless, self-serving, self-aggrandizing, illiberal, undemocratic, moronic and contrary to the very rule of law his candidate purports to stand for when he's not ginning up cancerous fantasies among the froathy-mouthed sheep who fancy themselves as revolutionaries akin to the American colonists (muskets? lol. Okay Alex Jones). No Joe. You're just an asshole blathering about civil war if your pick of leader doesn't win the day. There's nothing laudable about that. Unbelievable how carelessly people like Walsh are yapping about something that could result in millions of dead people and the end to America as we know it. Make Trump President Or Else? \" edit on 2016-10-26 by theantediluvian because: (no reason given)",
		"thread_title": "Congressmen Turned Radio Host, Joe Walsh, Recklessly Talks Muskets If Trump Loses",
		"title": "Congressmen Turned Radio Host, Joe Walsh, Recklessly Talks Muskets If Trump Loses",
		"type": "bs",
		"uuid": "692d34b417af7a01051d4793c9acd201529078b2"
	},
	"-KhI_ukKqr_8TVptt4FI": {
		"author": "reldra",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:48.091+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "quake",
				"salience": 0.13673368,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gl7f0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Visso"
				},
				"name": "Visso",
				"salience": 0.13601501,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rzr6nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agenzia_Nazionale_Stampa_Associata"
				},
				"name": "ANSA",
				"salience": 0.12570193,
				"type": "ORGANIZATION"
			},
			{
				"name": "quake",
				"salience": 0.06539048,
				"type": "EVENT"
			},
			{
				"name": "page",
				"salience": 0.037284713,
				"type": "OTHER"
			},
			{
				"name": "location",
				"salience": 0.037284713,
				"type": "LOCATION"
			},
			{
				"name": "south-southwest",
				"salience": 0.028064366,
				"type": "LOCATION"
			},
			{
				"name": "Powerful Quakes Hit Italy Within Hours",
				"salience": 0.023058457,
				"type": "EVENT"
			},
			{
				"name": "epicenter",
				"salience": 0.02014457,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.019154416,
				"type": "LOCATION"
			},
			{
				"name": "info",
				"salience": 0.019154416,
				"type": "OTHER"
			},
			{
				"name": "ATS",
				"salience": 0.01821262,
				"type": "OTHER"
			},
			{
				"name": "Barbie Nadeau",
				"salience": 0.016719483,
				"type": "PERSON"
			},
			{
				"name": "quake",
				"salience": 0.014709241,
				"type": "EVENT"
			},
			{
				"name": "Mauro Falcucci",
				"salience": 0.011586641,
				"type": "PERSON"
			},
			{
				"name": "vilages",
				"salience": 0.010382501,
				"type": "OTHER"
			},
			{
				"name": "quakes",
				"salience": 0.00969448,
				"type": "OTHER"
			},
			{
				"name": "magnitude",
				"salience": 0.0091337925,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06w3g7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Matteo_Renzi"
				},
				"name": "Renzi",
				"salience": 0.008446687,
				"type": "PERSON"
			},
			{
				"name": "aftershock",
				"salience": 0.008151004,
				"type": "EVENT"
			},
			{
				"name": "quakes",
				"salience": 0.008019184,
				"type": "EVENT"
			},
			{
				"name": "depth",
				"salience": 0.007947348,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dly0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Perugia"
				},
				"name": "Perugia",
				"salience": 0.0074067786,
				"type": "LOCATION"
			},
			{
				"name": "Much",
				"salience": 0.0071502104,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.006448634,
				"type": "ORGANIZATION"
			},
			{
				"name": "town",
				"salience": 0.0064089564,
				"type": "LOCATION"
			},
			{
				"name": "earthquake",
				"salience": 0.0064089564,
				"type": "EVENT"
			},
			{
				"name": "aftershocks",
				"salience": 0.006170124,
				"type": "OTHER"
			},
			{
				"name": "depth",
				"salience": 0.006170124,
				"type": "OTHER"
			},
			{
				"name": "quake",
				"salience": 0.005993904,
				"type": "EVENT"
			},
			{
				"name": "victims",
				"salience": 0.005839281,
				"type": "PERSON"
			},
			{
				"name": "are",
				"salience": 0.005550902,
				"type": "OTHER"
			},
			{
				"name": "downpour",
				"salience": 0.0053439853,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.005300381,
				"type": "OTHER"
			},
			{
				"name": "injury",
				"salience": 0.005233682,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.005233682,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06c62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rome"
				},
				"name": "Rome",
				"salience": 0.0051962216,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01b69s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Geological_Survey"
				},
				"name": "USGS",
				"salience": 0.0048738685,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04vy66",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Macerata"
				},
				"name": "Macerata",
				"salience": 0.0048738685,
				"type": "LOCATION"
			},
			{
				"name": "tweets",
				"salience": 0.0048589916,
				"type": "WORK_OF_ART"
			},
			{
				"name": "person",
				"salience": 0.004708286,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.004687824,
				"type": "OTHER"
			},
			{
				"name": "reldra",
				"salience": 0.004687824,
				"type": "PERSON"
			},
			{
				"name": "reldra",
				"salience": 0.004687824,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.004687824,
				"type": "OTHER"
			},
			{
				"name": "Video",
				"salience": 0.0046490254,
				"type": "WORK_OF_ART"
			},
			{
				"name": "damage",
				"salience": 0.0045327293,
				"type": "OTHER"
			},
			{
				"name": "rubble",
				"salience": 0.0045327293,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0045327293,
				"type": "PERSON"
			},
			{
				"name": "churches",
				"salience": 0.0045327293,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.0044562225,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0044562225,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.004439145,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gl6cg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Castelsantangelo_sul_Nera"
				},
				"name": "Castelsantangelo sul Nera",
				"salience": 0.003947221,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0039109355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0034183608,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07zmlr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Testaccio"
				},
				"name": "Testaccio",
				"salience": 0.0034183608,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0034183608,
				"type": "ORGANIZATION"
			},
			{
				"name": "reldra",
				"salience": 0.003415209,
				"type": "PERSON"
			},
			{
				"name": "reldra",
				"salience": 0.003415209,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/010f9ftj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/News.com.au"
				},
				"name": "News.com.au",
				"salience": 0.0032228737,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.002909111,
				"type": "OTHER"
			},
			{
				"name": "rain",
				"salience": 0.0028490154,
				"type": "OTHER"
			},
			{
				"name": "earthquake areas",
				"salience": 0.0028490154,
				"type": "LOCATION"
			},
			{
				"name": "topics",
				"salience": 0.0024671697,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.0021285168,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0021285168,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0021285168,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0021285168,
				"type": "LOCATION"
			},
			{
				"name": "injuries",
				"salience": 0.0021285168,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0021285168,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italian",
				"salience": 0.001853317,
				"type": "LOCATION"
			},
			{
				"name": "mayor",
				"salience": 0.001851444,
				"type": "PERSON"
			},
			{
				"name": "emergency crews",
				"salience": 0.0018431757,
				"type": "PERSON"
			},
			{
				"name": "deaths",
				"salience": 0.0018431757,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.0015901272,
				"type": "OTHER"
			},
			{
				"name": "@matteorenzi",
				"salience": 0.0015187088,
				"type": "OTHER"
			},
			{
				"name": "Castel Santangelo Sul Nera",
				"salience": 0.0013101859,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020ly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_defense"
				},
				"name": "Civil Protection",
				"salience": 0.001134504,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:48.091+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Two Powerful Quakes Hit Italy Within Hours page: 1 Near the location of the deadly August quake. (see ATS for the August Quake info). The first quake: a magnitude-5.5 quake struck the same region. The epicenter was about 9 kilometers away, south-southwest of Visso. (It) hit at 7 p.m. (1 p.m. ET) between Perugia and Macerata, according to ANSA. The second quake -- with a magnitude of 6.1 -- was 3.2 kilometers (2 miles) north of Visso and 58 km (36 miles) from Perugia, the USGS reported. The depth of both is 10 km. There have been 2 aftershocks, 4.1 and 4.9, also at a depth of 10 KM. \"We don't have any reported victims, but we're in the dark and under a downpour,\" said Mauro Falcucci, the mayor of the small town of Castelsantangelo sul Nera, according to state news agency ANSA. CNN's Barbie Nadeau was in Rome when the quakes struck. \"Incredible aftershock or earthquake felt in Testaccio in Rome. Wow,\" she said on Twitter. Video showed a blocked road. Much of the are is small vilages that can't be reached by night. Some reports of damage and an injury has come in: News.com.au The quakes crumbled churches and buildings, knocking out power and sending panicked residents into the rain-drenched streets.One person was injured in Visso, where the rubble of collapsed buildings tumbled into the streets. But the Civil Protection agency, which initially reported two injured, had no other immediate reports of injuries or deaths. “We’re without power, waiting for emergency crews,” said the mayor of Castel Santangelo Sul Nera, a tiny town just north of some of the hard-hit areas of the August 24 quake. edit on 26-10-2016 by reldra because: (no reason given) edit on 26-10-2016 by reldra because: (no reason given) Italian Prime Minister Renzi tweets: 'I want to thank those who are working in the rain in the earthquake areas. All Italy hugs those affected' - @matteorenzi edit on 26-10-2016 by reldra because: (no reason given) edit on 26-10-2016 by reldra because: (no reason given) new topics",
		"thread_title": "Two Powerful Quakes Hit Italy Within Hours",
		"title": "Two Powerful Quakes Hit Italy Within Hours",
		"type": "bs",
		"uuid": "d98247222c1fac88012164585b780428cadad659"
	},
	"-KhI_uvb3q9IlkECiHmS": {
		"author": "Kali74",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:49.093+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.15438828,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.09407544,
				"type": "PERSON"
			},
			{
				"name": "Gov.",
				"salience": 0.08856778,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.06595098,
				"type": "PERSON"
			},
			{
				"name": "Supporters",
				"salience": 0.037557073,
				"type": "PERSON"
			},
			{
				"name": "party candidates",
				"salience": 0.032101512,
				"type": "PERSON"
			},
			{
				"name": "Statement",
				"salience": 0.02921993,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Gov.",
				"salience": 0.02921993,
				"type": "PERSON"
			},
			{
				"name": "endorsement",
				"salience": 0.026976964,
				"type": "OTHER"
			},
			{
				"name": "Stop Trump",
				"salience": 0.025506804,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.025332432,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.017999081,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.017626846,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.01612651,
				"type": "PERSON"
			},
			{
				"name": "Bill Weld Encourges",
				"salience": 0.015637979,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bill Weld This",
				"salience": 0.015637979,
				"type": "PERSON"
			},
			{
				"name": "electorate",
				"salience": 0.014985527,
				"type": "PERSON"
			},
			{
				"name": "backdrop",
				"salience": 0.012983781,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.011636189,
				"type": "PERSON"
			},
			{
				"name": "establishment",
				"salience": 0.00932787,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.009276984,
				"type": "PERSON"
			},
			{
				"name": "standards",
				"salience": 0.008998657,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.008753466,
				"type": "PERSON"
			},
			{
				"name": "pressure",
				"salience": 0.008753466,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.007112219,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0061414703,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.0053924466,
				"type": "PERSON"
			},
			{
				"name": "criticism",
				"salience": 0.0053553423,
				"type": "OTHER"
			},
			{
				"name": "decency",
				"salience": 0.0053553423,
				"type": "OTHER"
			},
			{
				"name": "reflection",
				"salience": 0.0053553423,
				"type": "OTHER"
			},
			{
				"name": "observation",
				"salience": 0.0053553423,
				"type": "EVENT"
			},
			{
				"name": "discipline",
				"salience": 0.0053553423,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0052213934,
				"type": "OTHER"
			},
			{
				"name": "trump",
				"salience": 0.005015029,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.004931334,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004624031,
				"type": "PERSON"
			},
			{
				"name": "libertarian",
				"salience": 0.0043371883,
				"type": "OTHER"
			},
			{
				"name": "veritas",
				"salience": 0.004052789,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.0039513777,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.0039513777,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.003919118,
				"type": "PERSON"
			},
			{
				"name": "look",
				"salience": 0.0038525013,
				"type": "OTHER"
			},
			{
				"name": "fear play",
				"salience": 0.0038039936,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.003756096,
				"type": "OTHER"
			},
			{
				"name": "lulz",
				"salience": 0.003756096,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0037088005,
				"type": "PERSON"
			},
			{
				"name": "mirror",
				"salience": 0.0036159868,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0036159868,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0036159868,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0036159868,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0036159868,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0035413003,
				"type": "PERSON"
			},
			{
				"name": "establisment",
				"salience": 0.0035413003,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.003351236,
				"type": "OTHER"
			},
			{
				"name": "trump",
				"salience": 0.003301336,
				"type": "OTHER"
			},
			{
				"name": "doo doo feces",
				"salience": 0.0030667342,
				"type": "OTHER"
			},
			{
				"name": "point im",
				"salience": 0.0030667342,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.0030667342,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0030667342,
				"type": "OTHER"
			},
			{
				"name": "wikileaks",
				"salience": 0.0030667342,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07w42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libertarian_Party_(United_States)"
				},
				"name": "Libertarian Party",
				"salience": 0.0028471027,
				"type": "ORGANIZATION"
			},
			{
				"name": "politics",
				"salience": 0.0026458323,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0026458323,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0026458323,
				"type": "PERSON"
			},
			{
				"name": "mentality",
				"salience": 0.0025037895,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "america",
				"salience": 0.0023751983,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0023124488,
				"type": "PERSON"
			},
			{
				"name": "Kali74",
				"salience": 0.0023124488,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.0022911779,
				"type": "PERSON"
			},
			{
				"name": "increase",
				"salience": 0.0022911779,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0022911779,
				"type": "OTHER"
			},
			{
				"name": "islamic",
				"salience": 0.0022911779,
				"type": "OTHER"
			},
			{
				"name": "trump",
				"salience": 0.0022570505,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0021343739,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.0020393564,
				"type": "OTHER"
			},
			{
				"name": "hijab",
				"salience": 0.0020183604,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "life",
				"salience": 0.0019929318,
				"type": "OTHER"
			},
			{
				"name": "thats",
				"salience": 0.0019271579,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0019271579,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.0019271579,
				"type": "LOCATION"
			},
			{
				"name": "jobs",
				"salience": 0.0016687844,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.0016687844,
				"type": "OTHER"
			},
			{
				"name": "tax plans",
				"salience": 0.0016687844,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0016687844,
				"type": "LOCATION"
			},
			{
				"name": "lots",
				"salience": 0.0016687844,
				"type": "LOCATION"
			},
			{
				"name": "amnesty",
				"salience": 0.0016687844,
				"type": "OTHER"
			},
			{
				"name": "drug lords",
				"salience": 0.0016687844,
				"type": "PERSON"
			},
			{
				"name": "thats",
				"salience": 0.0016137027,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0015145662,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0014396582,
				"type": "EVENT"
			},
			{
				"name": "politician.",
				"salience": 0.0014396582,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0014396582,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "europe",
				"salience": 0.0014103116,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0012466174,
				"type": "EVENT"
			},
			{
				"name": "russia",
				"salience": 0.0012466174,
				"type": "OTHER"
			},
			{
				"name": "china",
				"salience": 0.0012466174,
				"type": "OTHER"
			},
			{
				"name": "draft",
				"salience": 0.001030661,
				"type": "EVENT"
			},
			{
				"name": "return",
				"salience": 0.00091948133,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:49.093+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Gov. Bill Weld Encourges Supporters to Stop Trump page: 1 Statement by Gov. Bill Weld This is basically a backwards endorsement of Hillary. “Against that backdrop, I would like to address myself to all those in the electorate who remain torn between two so-called major party candidates whom they cannot enthusiastically support. I’m speaking particularly to those Republicans who feel that our President should exhibit commonly accepted standards of decency and discipline. *snip “After careful observation and reflection, I have come to believe that Donald Trump, if elected President of the United States, would not be able to stand up to this pressure and this criticism without becoming unhinged and unable to perform competently the duties of his office. I wonder what effect this will have on Libertarian Party members if any. I think it's unfortunate that people are feeling forced to support Hillary in order to stop Trump. Trump supporters need to take a long hard look in the mirror and realize that such a repulsive person, a man some voted for just for the lulz has ensured a Clinton presidency. You didn't stand up to the establishment you sent people fleeing to it. a reply to: Kali74 Check out the pretend libertarian! If I were libertarian, I'd be ticked off. Here's part of my supposed ticket endorsing one of the least libertarian candidates ever by making a fear play. what a bunch of doo doo feces this thread is. so voting for trump isnt standing up to the establisment? have you not watched veritas? have you not read anything from wikileaks? at this point im completely convinced if hillary wins this election, every women in america will be wearing a hijab within her presidency. the draft will make a return because we will be at war with russia and china. ok trump isnt a politician. and at this point, i dont think thats what we need. being president doesnt mean you have to be involved in politics your whole life. president of the us should be someone who has the values of america instilled in their heart. they should have america first mentality. hillary wants a 550% increase in muslim refugees. the same ones murdering and raping women throughout europe. the same ones who think because a woman isnt islamic, they can do whatever they want to them. hillary wants amnesty and open borders... great, so lots more columbian drug lords sending people over our border i want to feel safe in my own country. thats all i want. not fancy tax plans, free college, more jobs. trump makes me feel safe.",
		"thread_title": "Gov. Bill Weld Encourges Supporters to Stop Trump",
		"title": "Gov. Bill Weld Encourges Supporters to Stop Trump",
		"type": "bs",
		"uuid": "ef71041f2a66c89960f3181f02c72ce4593b594b"
	},
	"-KhI_vS695yL7NP4Xv3H": {
		"author": "recrisp",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:50.332+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "one",
				"salience": 0.12193259,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.034852337,
				"type": "OTHER"
			},
			{
				"name": "below",
				"salience": 0.031194229,
				"type": "OTHER"
			},
			{
				"name": "LOT",
				"salience": 0.024880217,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.019981293,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.019040342,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.019040342,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d2y1g"
				},
				"name": "Robert",
				"salience": 0.0178242,
				"type": "PERSON"
			},
			{
				"name": "satellite",
				"salience": 0.01647824,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.01631624,
				"type": "OTHER"
			},
			{
				"name": "Nothing major",
				"salience": 0.016081857,
				"type": "PERSON"
			},
			{
				"name": "amount",
				"salience": 0.01489543,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.01489543,
				"type": "OTHER"
			},
			{
				"name": "feeling",
				"salience": 0.01384532,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.013260984,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.012383524,
				"type": "OTHER"
			},
			{
				"name": "peanut butter",
				"salience": 0.012099627,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.011872195,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.011084613,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07q3j97"
				},
				"name": "South",
				"salience": 0.010659723,
				"type": "LOCATION"
			},
			{
				"name": "friends",
				"salience": 0.010537136,
				"type": "PERSON"
			},
			{
				"name": "trip",
				"salience": 0.010537136,
				"type": "EVENT"
			},
			{
				"name": "camping trip",
				"salience": 0.010537136,
				"type": "EVENT"
			},
			{
				"name": "few",
				"salience": 0.010537136,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.009808741,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0097354865,
				"type": "OTHER"
			},
			{
				"name": "binoculars",
				"salience": 0.009341165,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFOs",
				"salience": 0.0091752615,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00907893,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02wzq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Texas"
				},
				"name": "West Texas",
				"salience": 0.009072631,
				"type": "LOCATION"
			},
			{
				"name": "brother",
				"salience": 0.008900436,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.008897692,
				"type": "PERSON"
			},
			{
				"name": "tent",
				"salience": 0.008791172,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "canoeing",
				"salience": 0.008791172,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.008791172,
				"type": "PERSON"
			},
			{
				"name": "believer",
				"salience": 0.0082207145,
				"type": "PERSON"
			},
			{
				"name": "sleeping bags",
				"salience": 0.007613467,
				"type": "OTHER"
			},
			{
				"name": "snorkeling",
				"salience": 0.007613467,
				"type": "OTHER"
			},
			{
				"name": "cliff diving",
				"salience": 0.007613467,
				"type": "OTHER"
			},
			{
				"name": "stars",
				"salience": 0.007613467,
				"type": "PERSON"
			},
			{
				"name": "swimming",
				"salience": 0.007613467,
				"type": "EVENT"
			},
			{
				"name": "posting",
				"salience": 0.007613467,
				"type": "OTHER"
			},
			{
				"name": "CGI videos",
				"salience": 0.007613467,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0072651296,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0070998413,
				"type": "OTHER"
			},
			{
				"name": "spot",
				"salience": 0.0065688365,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.006551435,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0065442394,
				"type": "OTHER"
			},
			{
				"name": "flashlight",
				"salience": 0.0060526915,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "heat",
				"salience": 0.005271984,
				"type": "OTHER"
			},
			{
				"name": "footsteps",
				"salience": 0.0051950733,
				"type": "OTHER"
			},
			{
				"name": "night sky",
				"salience": 0.0048906896,
				"type": "OTHER"
			},
			{
				"name": "binoculars",
				"salience": 0.0048646457,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0h6114",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Possum_Kingdom_Lake"
				},
				"name": "Possum Kingdom Lake",
				"salience": 0.004814632,
				"type": "LOCATION"
			},
			{
				"name": "friend",
				"salience": 0.0045658806,
				"type": "PERSON"
			},
			{
				"name": "sphere",
				"salience": 0.0044286395,
				"type": "OTHER"
			},
			{
				"name": "cliffs",
				"salience": 0.0040096054,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0040096054,
				"type": "OTHER"
			},
			{
				"name": "cliffs",
				"salience": 0.0040096054,
				"type": "LOCATION"
			},
			{
				"name": "peninsula",
				"salience": 0.0039889123,
				"type": "LOCATION"
			},
			{
				"name": "sphere",
				"salience": 0.0039768512,
				"type": "OTHER"
			},
			{
				"name": "sphere",
				"salience": 0.0037084036,
				"type": "OTHER"
			},
			{
				"name": "sleep",
				"salience": 0.0036203347,
				"type": "OTHER"
			},
			{
				"name": "rental canoe",
				"salience": 0.0036203347,
				"type": "OTHER"
			},
			{
				"name": "campsite",
				"salience": 0.0036203347,
				"type": "LOCATION"
			},
			{
				"name": "spot",
				"salience": 0.0036203347,
				"type": "OTHER"
			},
			{
				"name": "beers",
				"salience": 0.0036203347,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "beer",
				"salience": 0.0036203347,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "distractions",
				"salience": 0.0036203347,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0036203347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.0035387294,
				"type": "LOCATION"
			},
			{
				"name": "brother",
				"salience": 0.0035068255,
				"type": "PERSON"
			},
			{
				"name": "following",
				"salience": 0.0034437077,
				"type": "PERSON"
			},
			{
				"name": "satellite",
				"salience": 0.0033680527,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0032466617,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.00313496,
				"type": "OTHER"
			},
			{
				"name": "herb",
				"salience": 0.00313496,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.00313496,
				"type": "OTHER"
			},
			{
				"name": "boat",
				"salience": 0.00313496,
				"type": "OTHER"
			},
			{
				"name": "high",
				"salience": 0.00313496,
				"type": "OTHER"
			},
			{
				"name": "sphere",
				"salience": 0.0031254797,
				"type": "LOCATION"
			},
			{
				"name": "satellite",
				"salience": 0.0030819925,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0029730538,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0029555715,
				"type": "OTHER"
			},
			{
				"name": "binoculars",
				"salience": 0.002929569,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "flash",
				"salience": 0.0028472375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gkh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West"
				},
				"name": "Westward",
				"salience": 0.0028464056,
				"type": "LOCATION"
			},
			{
				"name": "rest",
				"salience": 0.0028325405,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0028113606,
				"type": "OTHER"
			},
			{
				"name": "directions",
				"salience": 0.0028113606,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0028113606,
				"type": "OTHER"
			},
			{
				"name": "degrees",
				"salience": 0.0028113606,
				"type": "OTHER"
			},
			{
				"name": "beam",
				"salience": 0.0028113606,
				"type": "OTHER"
			},
			{
				"name": "beam",
				"salience": 0.0027409568,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0027064185,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0026504805,
				"type": "OTHER"
			},
			{
				"name": "boss",
				"salience": 0.0026214472,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.002551541,
				"type": "OTHER"
			},
			{
				"name": "speed",
				"salience": 0.0025383697,
				"type": "OTHER"
			},
			{
				"name": "plane",
				"salience": 0.0025383697,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.0025383697,
				"type": "OTHER"
			},
			{
				"name": "degree turn",
				"salience": 0.0024843307,
				"type": "OTHER"
			},
			{
				"name": "plane/jet traffic",
				"salience": 0.0024637447,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.0024436135,
				"type": "OTHER"
			},
			{
				"name": "speed",
				"salience": 0.0024436135,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.002341885,
				"type": "OTHER"
			},
			{
				"name": "degree turn",
				"salience": 0.0022446506,
				"type": "OTHER"
			},
			{
				"name": "destination",
				"salience": 0.0021979976,
				"type": "LOCATION"
			},
			{
				"name": "path",
				"salience": 0.0021979976,
				"type": "OTHER"
			},
			{
				"name": "curving",
				"salience": 0.0021979976,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0021979976,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.0021979976,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0021979976,
				"type": "OTHER"
			},
			{
				"name": "bubble",
				"salience": 0.0021159425,
				"type": "OTHER"
			},
			{
				"name": "estimation",
				"salience": 0.0021159425,
				"type": "OTHER"
			},
			{
				"name": "altitude",
				"salience": 0.0021159425,
				"type": "OTHER"
			},
			{
				"name": "comfort",
				"salience": 0.0021159425,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0021159425,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.002091328,
				"type": "LOCATION"
			},
			{
				"name": "sky",
				"salience": 0.002091328,
				"type": "LOCATION"
			},
			{
				"name": "sky",
				"salience": 0.002091328,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.0018730334,
				"type": "LOCATION"
			},
			{
				"name": "satellites",
				"salience": 0.0018557971,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.0017943213,
				"type": "OTHER"
			},
			{
				"name": "tabloids",
				"salience": 0.0017943213,
				"type": "OTHER"
			},
			{
				"name": "gravel rocks",
				"salience": 0.0017943213,
				"type": "OTHER"
			},
			{
				"name": "branches",
				"salience": 0.0017943213,
				"type": "OTHER"
			},
			{
				"name": "heyday",
				"salience": 0.0017055621,
				"type": "PERSON"
			},
			{
				"name": "other",
				"salience": 0.001691624,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.0015479104,
				"type": "OTHER"
			},
			{
				"name": "backyard",
				"salience": 0.0015479104,
				"type": "LOCATION"
			},
			{
				"name": "front",
				"salience": 0.0015479104,
				"type": "OTHER"
			},
			{
				"name": "trees",
				"salience": 0.0015479104,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0014419275,
				"type": "OTHER"
			},
			{
				"name": "sphere",
				"salience": 0.0014419275,
				"type": "OTHER"
			},
			{
				"name": "break",
				"salience": 0.0014419275,
				"type": "EVENT"
			},
			{
				"name": "binoculars",
				"salience": 0.0013862436,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "thing",
				"salience": 0.001370596,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.0013515201,
				"type": "EVENT"
			},
			{
				"name": "mind",
				"salience": 0.0013403188,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0013403188,
				"type": "OTHER"
			},
			{
				"name": "ol",
				"salience": 0.0013403188,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0013403188,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.0013403188,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fifties",
				"salience": 0.0013403188,
				"type": "OTHER"
			},
			{
				"name": "pick-up",
				"salience": 0.0013403188,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0012485463,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0012485463,
				"type": "OTHER"
			},
			{
				"name": "beam",
				"salience": 0.0012485463,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0012485463,
				"type": "PERSON"
			},
			{
				"name": "sky",
				"salience": 0.0011376841,
				"type": "LOCATION"
			},
			{
				"name": "sky",
				"salience": 0.0011376841,
				"type": "LOCATION"
			},
			{
				"name": "guy",
				"salience": 0.0011272792,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.0011272792,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0011272792,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0011272792,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0011272792,
				"type": "OTHER"
			},
			{
				"name": "fun",
				"salience": 0.0011080976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05mph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma"
				},
				"name": "O.K.",
				"salience": 0.0011042941,
				"type": "ORGANIZATION"
			},
			{
				"name": "bread",
				"salience": 0.0010770716,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bread",
				"salience": 0.0010770716,
				"type": "OTHER"
			},
			{
				"name": "bread",
				"salience": 0.0010770716,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bread",
				"salience": 0.0010770716,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "thing",
				"salience": 0.0010770716,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0009760893,
				"type": "LOCATION"
			},
			{
				"name": "bunch",
				"salience": 0.0009760893,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009760893,
				"type": "PERSON"
			},
			{
				"name": "piece",
				"salience": 0.0009760893,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Typo",
				"salience": 0.0009760893,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00093261444,
				"type": "PERSON"
			},
			{
				"name": "harm",
				"salience": 0.0009277988,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0009277988,
				"type": "OTHER"
			},
			{
				"name": "peanut butter",
				"salience": 0.00084202824,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tent",
				"salience": 0.00084202824,
				"type": "OTHER"
			},
			{
				"name": "trees",
				"salience": 0.00084202824,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00079679315,
				"type": "PERSON"
			},
			{
				"name": "claims",
				"salience": 0.00076704053,
				"type": "OTHER"
			},
			{
				"name": "wrapper",
				"salience": 0.00076704053,
				"type": "OTHER"
			},
			{
				"name": "flying saucers",
				"salience": 0.0007290911,
				"type": "OTHER"
			},
			{
				"name": "vacation",
				"salience": 0.0007290911,
				"type": "EVENT"
			},
			{
				"name": "much",
				"salience": 0.0007290911,
				"type": "OTHER"
			},
			{
				"name": "forum",
				"salience": 0.0007290911,
				"type": "EVENT"
			},
			{
				"name": "sort",
				"salience": 0.0007290911,
				"type": "OTHER"
			},
			{
				"name": "river",
				"salience": 0.0007290911,
				"type": "LOCATION"
			},
			{
				"name": "patch",
				"salience": 0.0007290911,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007145159,
				"type": "PERSON"
			},
			{
				"name": "Ask Robert",
				"salience": 0.0006006899,
				"type": "WORK_OF_ART"
			},
			{
				"name": "recrisp",
				"salience": 0.0006006899,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025t0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caddo_Lake"
				},
				"name": "Caddo Lake",
				"salience": 0.0005739336,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02590c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_Texas"
				},
				"name": "East Texas",
				"salience": 0.0005739336,
				"type": "LOCATION"
			},
			{
				"name": "CREEPY",
				"salience": 0.00044867865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01ty0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spring_(hydrology)"
				},
				"name": "Spring",
				"salience": 0.00044867865,
				"type": "LOCATION"
			},
			{
				"name": "kids",
				"salience": 0.00037220915,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:50.332+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 19.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Years ago I came here for the UFOs and after a small amount of time I stopped believing, mostly due to nothing being 'real' anymore, most stuff is faked, at least in my opinion... The below is true, even if it's not as exciting as CGI videos... My main reason for posting is about one of the (very few) times I saw 'stuff'. Back in Summer of July,1974 I went on a camping trip to Possum Kingdom Lake in West Texas with a friend Robert, (my last trip as a single guy before I got married the following month). The trip was a lot of canoeing, swimming, cliff diving, snorkeling, and camping out at night beneath the stars, no tent, just star gazing while we eventually drifted off to sleep nightly. (Robert and I were best friends and also worked together too) Anyway, one really, REALLY dark chilly and moonless night about 9:30pm or so, we had tucked ourselves in our sleeping bags and had a really good spot (elevated with no distractions) to look at the night sky, I had excellent vision then and could see pretty danged good, (I was 21) my friend was 20. He partook of the herb and drank beer daily and I consumed a few beers daily, by nightfall we were tuckered out and wanted nothing more than to just go to sleep, the heat of the West Texas day really took it out of us. The campsite was only accessed by boat, we used a rental canoe, so we paddled our way to this place that was a fairly large and very rugged rocky peninsula with some cliffs being 20-30 foot high. (They seemed a LOT taller to me!) We camped on the top of the cliffs at night and played down on the water by day. So this one night I was looking at a particular spot up there above us and he was looking at another, I then saw, it, and said, \"Look right there!\", he having binoculars he looked at where I had pointed, saw \"it\" and got pretty excited. He finally let me look at it through his binoculars and what I saw was the following... Slightly larger than what we normally see a satellite was a transparent, or semi-transparent and faint bluish looking sphere, a clear 'bubble really, moving at a speed I remember as being slightly faster than what a satellite would be going, but not so much faster or slower than any plane/jet traffic would be, in my estimation. It was going South and we watched it by passing the binoculars back and forth. We both assumed it was a satellite. Exciting stuff, but then one of us (I really can't remember who) noticed another one, this time coming from the East, they appeared to be on a course that appeared to us that would be really a close call if they were at the same altitude. When they were getting a little too close for comfort (at least for us!) the one that came from the East shot a light bluish light at the Southbound sphere, it wasn't laser-like at all (I don't think) but it appeared more like a v-shaped beam from a flashlight shot at it. It lasted all of a second, and I am positive that it happened due to we both saw it at the same time. The light flash made the Southbound one turn Westward, now going almost the same direction as the one from the East, making them both going in the same direction, actually the one that got flashed didn't make a 90 degree turn, it was really going more of a path more like West-southwest more like 87 degrees or so, just guessing now. When I say that it turned, it turned abruptly, not at all anything like any plane would do, that struck us both as being odd, no curving involved at all. We watched them until they both grew dim from the distance, both staying in a straight line to their (intended?) destination. Of course we kept thinking that the one that flashed the beam would turn and follow the other, but nope. I could be wrong on the speed and the directions, but the rest is completely accurate. The really sharp turn back then was unheard of, we hear it all of the time now, years ago though it wasn't talked about at all, not even in the tabloids. This is why this really stood out out to me all of these years, that almost 90 degree turn. To be honest I just didn't understand what we had just seen. We finally got to sleep that night, I don't know how long it took us, but we did, but after a few hours (around 3-ish am) Robert woke me up and said, \"Listen!\", and I heard footsteps, that scared us pretty good 'cause we had gotten so worked up earlier, I guess. heheh We listened to the small branches and small gravel rocks moving beneath whatever it was that was about to kill us, well, we did until we finally scared ourselves to sleep. (I have to admit, O.K., yeah, I did partake myself, but only a little bit, I wasn't into it like him but I was on vacation, that made us both VERY paranoid, I guess) Anyway, the next morning we found our bread and peanut butter missing, the bread's plastic wrapper was there but no bread. CREEPY. A few years later my boss (who I had told all of this to and he made fun of me) told me that the same thing happened to him, his peanut butter and bread went missing while camped on a river, they determined that it was a raccoon, which, they do this sort of thing, I know now. Now to regular people that might not seem like much, especially now days, here on this forum more spectacular claims are made daily. Still, for back then it was REALLY something. My older brother (by 3-1/2 years) and I were camping with no tent underneath the starry sky of Caddo Lake in East Texas around 1981 in the Spring, May I think, and we were looking at a patch of sky surrounded by silhouetted trees actually talking about when we were kids looking for flying saucers. (That's all they were known as back then) Our entire family would look out at the sky in our backyard, it was a common thing for us to do back in the fifties, after all, that was its heyday. As we stared at the sky in the back of my pick-up I mentioned the bluish sphere that I had seen years before at Possum Kingdom Lake, he being quiet through the entire story, he wasn't that talkative really, and within 5 minutes of me mentioning this to him we saw one. (I had my own binoculars this time!) I was really amazed, it was exactly as what I had seen before, I mean exactly! Nothing major happened though, it just quietly slid across the sky in front of us and disappeared behind the trees to our right, and that was that. My brother was never a believer anyway, maybe had it landed it would change his mind. We saw several regular ol' satellites afterwards too. Why I even bring this up is that when I first started coming here around 2008 (lurking) I read a thread of a guy here that saw the exact thing I did, with the slightly v-shaped flashlight looking beam and the other blue sphere turning away, I'd REALLY love to read that again, it was a good feeling to be somewhat confirmed. I say, \"confirmed\" because that friend, Robert that witnessed the sphere denied it in front of a LOT of people at work. We hardly talked about anything else on that trip, and especially on the way home too. Assuming he felt as I did I brought it up when a bunch of guys were taking a break at work, maybe 10-12 people, I didn't see the harm in telling what we saw. After I said my piece I said, \"Ask Robert\". Robert said I was crazy and he didn't see a thing, I thought he was kidding but he was being serious, you'd think that on the way back he'd say that he wasn't wanting to tell anyone, but, Nooo... edit on 26-10-2016 by recrisp because: Typo",
		"thread_title": "Little Blue Balls...",
		"title": "Little Blue Balls...",
		"type": "bs",
		"uuid": "2bf87d92513207ee0cd3db2bd1e24a5fcd18db6d"
	},
	"-KhI_vX_JTopMWl3XseJ": {
		"author": "recrisp",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:51.149+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "thread",
				"salience": 0.20506558,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.15297413,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.116913676,
				"type": "OTHER"
			},
			{
				"name": "forum",
				"salience": 0.115606844,
				"type": "EVENT"
			},
			{
				"name": "brain",
				"salience": 0.093373224,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.093373224,
				"type": "LOCATION"
			},
			{
				"name": "right",
				"salience": 0.07634099,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.054310847,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.035223454,
				"type": "LOCATION"
			},
			{
				"name": "Howdy",
				"salience": 0.031145275,
				"type": "PERSON"
			},
			{
				"name": "recrisp",
				"salience": 0.025672752,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats6.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:51.149+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.3,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Well, that didn't go as planned... Anyway, my first thread so I can indulge. I have to admit, getting to 'here' was not easy, this forum (or my brain) is really different than other places, so hopefully I do this right. I have a thread or two that I have wanted to do, this is my beginning to that. Howdy from Texas too, I have to mention that. edit on 26-10-2016 by recrisp because: (no reason given)",
		"thread_title": "Finally, my first thread! :)",
		"title": "Finally, my first thread! :)",
		"type": "bs",
		"uuid": "648db5ad9913a13960fa04f161d1ab67e283a160"
	},
	"-KhI_vetp3sDDR8GN2HN": {
		"author": "Profusion",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:51.356+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.22135107,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05b4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norway"
				},
				"name": "Norwegian",
				"salience": 0.21345554,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "US Marines",
				"salience": 0.12925693,
				"type": "ORGANIZATION"
			},
			{
				"name": "decision",
				"salience": 0.0380723,
				"type": "OTHER"
			},
			{
				"name": "soil",
				"salience": 0.0380723,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0365144,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0365144,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.03623474,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.03304598,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.019379009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.015809309,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.009772452,
				"type": "LOCATION"
			},
			{
				"name": "move",
				"salience": 0.008982489,
				"type": "OTHER"
			},
			{
				"name": "military base",
				"salience": 0.007028598,
				"type": "LOCATION"
			},
			{
				"name": "buildup",
				"salience": 0.007028598,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.007028598,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.0063523,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norway"
				},
				"name": "Norway",
				"salience": 0.0059920936,
				"type": "LOCATION"
			},
			{
				"name": "decision",
				"salience": 0.0059896642,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.005694095,
				"type": "OTHER"
			},
			{
				"name": "home soil",
				"salience": 0.005694095,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.005694095,
				"type": "OTHER"
			},
			{
				"name": "deployment",
				"salience": 0.0054820045,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.0054820045,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reaction",
				"salience": 0.005254268,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.005149476,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.005149476,
				"type": "OTHER"
			},
			{
				"name": "forum",
				"salience": 0.0049320804,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.004748308,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.004748308,
				"type": "OTHER"
			},
			{
				"name": "SOURCE",
				"salience": 0.004748308,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01s5gq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trondheim_Airport,_V%C3%A6rnes"
				},
				"name": "Vaernes",
				"salience": 0.0043307533,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.0040277364,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0040277364,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.003927013,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.003475386,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.003303691,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.003009862,
				"type": "OTHER"
			},
			{
				"name": "military presence",
				"salience": 0.003009862,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.003009862,
				"type": "LOCATION"
			},
			{
				"name": "battalions",
				"salience": 0.003009862,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xp_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defence_minister"
				},
				"name": "Defense Ministry",
				"salience": 0.002544029,
				"type": "ORGANIZATION"
			},
			{
				"name": "point of view",
				"salience": 0.0021926563,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.0021926563,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.002095078,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.002095078,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.001853189,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01522",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Sea"
				},
				"name": "Baltic",
				"salience": 0.001853189,
				"type": "LOCATION"
			},
			{
				"name": "deployment",
				"salience": 0.0018443797,
				"type": "EVENT"
			},
			{
				"name": "article",
				"salience": 0.0016381722,
				"type": "WORK_OF_ART"
			},
			{
				"name": "egos",
				"salience": 0.0016381722,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.0016381722,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0016381722,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0016381722,
				"type": "OTHER"
			},
			{
				"name": "Profusion",
				"salience": 0.0013498277,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats17.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:51.356+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Russia 'puzzled' by Norway's decision to host US Marines page: 1 link Norway is to break a decades-old commitment not to host foreign troops on its soil by accommodating 330 US Marines next year. Russia, the apparent target of the buildup, said it was puzzled by the move. The Marines will be stationed at the Vaernes military base in central Norway from January, the Norwegian Defense Ministry said in a statement on Monday. The agreement for the deployment will be reviewed in the course of the year, it added. SOURCE I was one of the few posters on this forum who expressed that Norway's decision to have Marines deployed on its home soil was significant. Part of the reason I believe it is significant is Russia's reaction to the move. Our opinions mean nothing in this matter. If Russia considers the move to be significant then it's significant. I wonder if posters will be able to put aside their egos for this thread and not focus on their view of this issue but focus on Russia's view. Quoting from the article linked above: \"The deployment appears to be in line with NATO's strategy to boost its military presence close to Russia’s borders. The alliance decided to send four 1,000-strong battalions each to Poland and the Baltic states, claiming it was needed to deter Russia.\" Please put it all in context from Russia's point of view. edit on 26-10-2016 by Profusion because: (no reason given)",
		"thread_title": "Russia puzzled by Norways decision to host US Marines",
		"title": "Russia puzzled by Norways decision to host US Marines",
		"type": "bs",
		"uuid": "8c3f2f666330a71bc4cf26c97ae85359232fc758"
	},
	"-KhI_vpI8USFCHEhbzED": {
		"author": "sanitizedinfo",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:53.333+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "TM",
				"salience": 0.13361414,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012gh4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wave_function"
				},
				"name": "Quantum Wave Function",
				"salience": 0.058314044,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.05727238,
				"type": "OTHER"
			},
			{
				"name": "crystals",
				"salience": 0.056867804,
				"type": "OTHER"
			},
			{
				"name": "magnus",
				"salience": 0.05178653,
				"type": "PERSON"
			},
			{
				"name": "machine",
				"salience": 0.044924174,
				"type": "OTHER"
			},
			{
				"name": "Tim Rifat",
				"salience": 0.044535585,
				"type": "PERSON"
			},
			{
				"name": "electron microscope",
				"salience": 0.0345151,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "blood",
				"salience": 0.02945973,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.02945973,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.025216106,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.023532512,
				"type": "OTHER"
			},
			{
				"name": "Remote Influencing Psychotronic",
				"salience": 0.023388961,
				"type": "ORGANIZATION"
			},
			{
				"name": "page",
				"salience": 0.023070067,
				"type": "OTHER"
			},
			{
				"name": "Generators",
				"salience": 0.0174192,
				"type": "PERSON"
			},
			{
				"name": "generators",
				"salience": 0.0174192,
				"type": "PERSON"
			},
			{
				"name": "Bone Generators",
				"salience": 0.0174192,
				"type": "PERSON"
			},
			{
				"name": "Bone Generators",
				"salience": 0.016043827,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06669",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Psychokinesis"
				},
				"name": "Remote Influencing",
				"salience": 0.013238756,
				"type": "EVENT"
			},
			{
				"name": "hyperinfinity",
				"salience": 0.011569368,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.010998602,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.010924176,
				"type": "EVENT"
			},
			{
				"name": "Psychotronic Generator",
				"salience": 0.010738614,
				"type": "PERSON"
			},
			{
				"name": "bones",
				"salience": 0.010517368,
				"type": "OTHER"
			},
			{
				"name": "skull",
				"salience": 0.009648348,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.009527028,
				"type": "OTHER"
			},
			{
				"name": "Bone Generators",
				"salience": 0.009191375,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.008982916,
				"type": "OTHER"
			},
			{
				"name": "circuits",
				"salience": 0.008942871,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.008922097,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.008922097,
				"type": "EVENT"
			},
			{
				"name": "process",
				"salience": 0.008609673,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.00742938,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.00742938,
				"type": "OTHER"
			},
			{
				"name": "Psychotronic Crystal Generators",
				"salience": 0.007253596,
				"type": "ORGANIZATION"
			},
			{
				"name": "quantum vacuum grand state",
				"salience": 0.006683693,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.006668157,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.006668157,
				"type": "EVENT"
			},
			{
				"name": "quantum mechanics",
				"salience": 0.0064345216,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0064345216,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.006301694,
				"type": "OTHER"
			},
			{
				"name": "Pavlita",
				"salience": 0.0058684098,
				"type": "PERSON"
			},
			{
				"name": "quantum",
				"salience": 0.005644379,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.0054576187,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0054576187,
				"type": "OTHER"
			},
			{
				"name": "Services",
				"salience": 0.0051879473,
				"type": "OTHER"
			},
			{
				"name": "hyperinfinity",
				"salience": 0.0047088866,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0046769683,
				"type": "EVENT"
			},
			{
				"name": "Bone Psychotronic Generators",
				"salience": 0.0045973915,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "energy",
				"salience": 0.004479293,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0041728723,
				"type": "EVENT"
			},
			{
				"name": "Batteries",
				"salience": 0.0040779235,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "skeleton",
				"salience": 0.0040779235,
				"type": "OTHER"
			},
			{
				"name": "Psychotronic Bone Generators",
				"salience": 0.0040641455,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "effects",
				"salience": 0.003430224,
				"type": "OTHER"
			},
			{
				"name": "magnus",
				"salience": 0.003430224,
				"type": "PERSON"
			},
			{
				"name": "Psychotronic Amplifiers",
				"salience": 0.0033603325,
				"type": "ORGANIZATION"
			},
			{
				"name": "dount im",
				"salience": 0.0032460834,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0029704561,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0029704561,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0029704561,
				"type": "OTHER"
			},
			{
				"name": "Psychotronic Fuel",
				"salience": 0.002510474,
				"type": "OTHER"
			},
			{
				"name": "operator",
				"salience": 0.0022191417,
				"type": "ORGANIZATION"
			},
			{
				"name": "ive",
				"salience": 0.0020050788,
				"type": "PERSON"
			},
			{
				"name": "www.psychicpowergambling.com",
				"salience": 0.0013658963,
				"type": "OTHER"
			},
			{
				"name": "thats",
				"salience": 0.00075512764,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats6.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:53.333+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.3,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "the influencing machine and magnus olsens blood. page: 1 First off i just heard of this about 2 months ago. His blood is clumping up and they found crystals that seem engineered in the blood using an electron microscope. then today i read this.. remote influencing.. As we all know all electronic circuits need power, in the case of Remote Influencing Psychotronic Generators provide this power. Tim Rifat has developed the Psychotronic Generator from simple Pavlita generators to the far future Bone Generators(TM) using your own skull and bones as Psychotronic Crystal Generators. These Bone Generators(TM) change the Quantum Wave Function of reality, Remote Influencing. The science of Remote Influencing is based on quantum mechanics only Tim Rifat has developed science to explain Remote Influencing. The process is to decohere the Quantum Wave Function, decollapse it and return it to it's quantum vacuum grand state, modify the Quantum Wave Function to the remote influenced event, collapse it using hyperinfinity so it manifests as your remote influenced event. (see www.supernaturalspirit.com Services for full explanation). In effect we zap the thing to be changed make it vanish and remanifest it as the event we went in laymans language; this takes energy supplied by Psychotronic Amplifiers in your Psychotronic Bone Generators(TM) as well as hyperinfinity the operator that holds the new event in being supplied by your Bone Generators(TM). Only one event can be carried out at a time (explained on www.psychicpowergambling.com) so Tim Rifat has arranged to quantum mechanically change your skeleton into Bone Psychotronic Generators(TM) for one specific event and give you the energy and Psychotronic Fuel with the hyperinfinity to manifest 12 of these singular events after which your Bone Generators which are acting as Psychotronic Batteries run out of energy. ive experienced temporal effects both physical and mental in being attacked by some kind of possibly similar technology. i have no dount im on a similar program as magnus. i get tortured bad. thats all ill say.",
		"thread_title": "the influencing machine and magnus olsens blood.",
		"title": "the influencing machine and magnus olsens blood.",
		"type": "bs",
		"uuid": "6669d4d107a664aafd5f3c5f25bfc9378fbef0aa"
	},
	"-KhI_w6vtcp4Egg6krqJ": {
		"author": "neoholographic",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:54.209+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "U.F.O.'s",
				"salience": 0.15869398,
				"type": "OTHER"
			},
			{
				"name": "comet",
				"salience": 0.054503065,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.049205843,
				"type": "OTHER"
			},
			{
				"name": "eyewitness accounts",
				"salience": 0.044549633,
				"type": "OTHER"
			},
			{
				"name": "observer evidence",
				"salience": 0.038931075,
				"type": "OTHER"
			},
			{
				"name": "boy",
				"salience": 0.03616963,
				"type": "PERSON"
			},
			{
				"name": "Eyewitness accounts",
				"salience": 0.030963972,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.030286046,
				"type": "OTHER"
			},
			{
				"name": "meteors",
				"salience": 0.029626496,
				"type": "PERSON"
			},
			{
				"name": "comets",
				"salience": 0.024731085,
				"type": "OTHER"
			},
			{
				"name": "eyewtiness accounts",
				"salience": 0.022892077,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03s9v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Isaac_Newton"
				},
				"name": "Newton",
				"salience": 0.021401023,
				"type": "LOCATION"
			},
			{
				"name": "comets",
				"salience": 0.019839639,
				"type": "OTHER"
			},
			{
				"name": "comets",
				"salience": 0.019839639,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.017192092,
				"type": "OTHER"
			},
			{
				"name": "sighting",
				"salience": 0.017192092,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.015529768,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01t16r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Silliman"
				},
				"name": "Benjamin Silliman",
				"salience": 0.01437347,
				"type": "PERSON"
			},
			{
				"name": "meteorite",
				"salience": 0.013557705,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.013455017,
				"type": "LOCATION"
			},
			{
				"name": "eyewitness accounts",
				"salience": 0.009457199,
				"type": "OTHER"
			},
			{
				"name": "eyewitness accounts",
				"salience": 0.009457199,
				"type": "OTHER"
			},
			{
				"name": "meteorites",
				"salience": 0.009457199,
				"type": "OTHER"
			},
			{
				"name": "meteor",
				"salience": 0.00933831,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0nb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philosophi%C3%A6_Naturalis_Principia_Mathematica"
				},
				"name": "Principia",
				"salience": 0.0082926685,
				"type": "ORGANIZATION"
			},
			{
				"name": "meteors",
				"salience": 0.007530747,
				"type": "PERSON"
			},
			{
				"name": "theory",
				"salience": 0.0070952154,
				"type": "OTHER"
			},
			{
				"name": "theories",
				"salience": 0.0070952154,
				"type": "OTHER"
			},
			{
				"name": "meteors",
				"salience": 0.006635246,
				"type": "PERSON"
			},
			{
				"name": "phenomenon",
				"salience": 0.0059426324,
				"type": "OTHER"
			},
			{
				"name": "internet",
				"salience": 0.005837597,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0057467213,
				"type": "LOCATION"
			},
			{
				"name": "equations",
				"salience": 0.0055492274,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0055492274,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.005532465,
				"type": "LOCATION"
			},
			{
				"name": "list",
				"salience": 0.005434667,
				"type": "OTHER"
			},
			{
				"name": "eyewitness accounts",
				"salience": 0.0054182503,
				"type": "OTHER"
			},
			{
				"name": "meteors",
				"salience": 0.0054182503,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06mq7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Science"
				},
				"name": "Science",
				"salience": 0.005416517,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0052987216,
				"type": "OTHER"
			},
			{
				"name": "phenomena",
				"salience": 0.005201805,
				"type": "EVENT"
			},
			{
				"name": "observers",
				"salience": 0.0049769995,
				"type": "PERSON"
			},
			{
				"name": "phenomenon",
				"salience": 0.0047913995,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0046924623,
				"type": "LOCATION"
			},
			{
				"name": "astronomers",
				"salience": 0.00449416,
				"type": "ORGANIZATION"
			},
			{
				"name": "eyewitness accounts",
				"salience": 0.004368469,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0043265424,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meteor storm",
				"salience": 0.0041651684,
				"type": "EVENT"
			},
			{
				"name": "point",
				"salience": 0.0040637758,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0038920108,
				"type": "PERSON"
			},
			{
				"name": "attention",
				"salience": 0.0038920108,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0038920108,
				"type": "PERSON"
			},
			{
				"name": "stars",
				"salience": 0.0038920108,
				"type": "PERSON"
			},
			{
				"name": "OBSERVERS",
				"salience": 0.0037662545,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.003746826,
				"type": "EVENT"
			},
			{
				"name": "lightning",
				"salience": 0.003746826,
				"type": "OTHER"
			},
			{
				"name": "rocks",
				"salience": 0.003746826,
				"type": "OTHER"
			},
			{
				"name": "papers",
				"salience": 0.003669434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "papers",
				"salience": 0.003669434,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09lw1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gravity"
				},
				"name": "Gravity",
				"salience": 0.0034169946,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081gf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wiki"
				},
				"name": "Wiki",
				"salience": 0.0034169946,
				"type": "LOCATION"
			},
			{
				"name": "radient",
				"salience": 0.0031776796,
				"type": "ORGANIZATION"
			},
			{
				"name": "constellation",
				"salience": 0.0031776796,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.0031776796,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.0031776796,
				"type": "WORK_OF_ART"
			},
			{
				"name": "monographs",
				"salience": 0.0031776796,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0030728362,
				"type": "OTHER"
			},
			{
				"name": "eyewitness accounts",
				"salience": 0.0029492392,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.0029078803,
				"type": "OTHER"
			},
			{
				"name": "wind",
				"salience": 0.0027415375,
				"type": "OTHER"
			},
			{
				"name": "wind",
				"salience": 0.0027415375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.002663736,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rd8m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Weston,_Connecticut"
				},
				"name": "Weston",
				"salience": 0.002663736,
				"type": "LOCATION"
			},
			{
				"name": "comets",
				"salience": 0.0025539265,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0025539265,
				"type": "LOCATION"
			},
			{
				"name": "sky",
				"salience": 0.0025539265,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0023960858,
				"type": "LOCATION"
			},
			{
				"name": "front",
				"salience": 0.0023740449,
				"type": "OTHER"
			},
			{
				"name": "orb",
				"salience": 0.0023740449,
				"type": "OTHER"
			},
			{
				"name": "probes",
				"salience": 0.0023740449,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0023740449,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.0023740449,
				"type": "OTHER"
			},
			{
				"name": "visitation",
				"salience": 0.0023740449,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/08815",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yale_University"
				},
				"name": "Yale University",
				"salience": 0.002306665,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01x73",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Connecticut"
				},
				"name": "Connecticut.",
				"salience": 0.002306665,
				"type": "LOCATION"
			},
			{
				"name": "sightings",
				"salience": 0.0022683605,
				"type": "OTHER"
			},
			{
				"name": "sightings",
				"salience": 0.0022115656,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0021724333,
				"type": "OTHER"
			},
			{
				"name": "UAPs",
				"salience": 0.0019561513,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04h2q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leo_(constellation)"
				},
				"name": "Leo.",
				"salience": 0.0019561513,
				"type": "LOCATION"
			},
			{
				"name": "Scientist",
				"salience": 0.0019297232,
				"type": "PERSON"
			},
			{
				"name": "explanations",
				"salience": 0.0019223207,
				"type": "OTHER"
			},
			{
				"name": "metorites",
				"salience": 0.0017291285,
				"type": "OTHER"
			},
			{
				"name": "malfunction",
				"salience": 0.0017291285,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.0017291285,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.0017291285,
				"type": "OTHER"
			},
			{
				"name": "radar",
				"salience": 0.0017291285,
				"type": "OTHER"
			},
			{
				"name": "U.F.O.'s",
				"salience": 0.0016521394,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.001592072,
				"type": "OTHER"
			},
			{
				"name": "specialty publications",
				"salience": 0.0014917132,
				"type": "WORK_OF_ART"
			},
			{
				"name": "astronomers",
				"salience": 0.0014917132,
				"type": "ORGANIZATION"
			},
			{
				"name": "explanations",
				"salience": 0.0014917132,
				"type": "OTHER"
			},
			{
				"name": "publications",
				"salience": 0.0014917132,
				"type": "WORK_OF_ART"
			},
			{
				"name": "literature",
				"salience": 0.0014478591,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Scientist",
				"salience": 0.0014054569,
				"type": "PERSON"
			},
			{
				"name": "facilities",
				"salience": 0.0013938108,
				"type": "LOCATION"
			},
			{
				"name": "journals",
				"salience": 0.0012916895,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dissertations",
				"salience": 0.0012916895,
				"type": "OTHER"
			},
			{
				"name": "academics",
				"salience": 0.0012916895,
				"type": "PERSON"
			},
			{
				"name": "UFOs. www.hyper.net",
				"salience": 0.0007949788,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:54.209+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Why isn't observer evidence like eyewitness accounts counted as evidence for UFO's? page: 1 link Eyewitness accounts have been used by Science for years. Newton used eyewtiness accounts in the Principia when talking about comets. He came up with a theory on comets based on recorded sighting throughout the world like a boy saw a comet and this is what he described. There wasn't any internet to even verify the credibility of these eyewitness accounts yet Newton used them to come up with a theory about comets which helped lead to his equations of Gravity. So if eyewitness accounts are so unreliable, how did Newton use them to come up with his theories? We also saw this with meteorites. This is from Wiki: Although meteors have been known since ancient times, they were not known to be an astronomical phenomenon until early in the 19th century. Prior to that, they were seen in the West as an atmospheric phenomenon, like lightning, and were not connected with strange stories of rocks falling from the sky. In 1807, Yale University chemistry professor Benjamin Silliman investigated a meteorite that fell in Weston, Connecticut.[27] Silliman believed the meteor had a cosmic origin, but meteors did not attract much attention from astronomers until the spectacular meteor storm of November 1833.[28] People all across the eastern United States saw thousands of meteors, radiating from a single point in the sky. Astute observers noticed that the radiant, as the point is now called, moved with the stars, staying in the constellation Leo.[29] ASTUTE OBSERVERS saw meteors radiating from a single point in the sky and to this day this is still called the radient. I thought Science never uses eyewitness accounts? Also, here's a list of published papers and studies on U.F.O.'s. This page offers a list of 100+ articles, papers and monographs about UFOs / UAPs published in professional journals and specialty publications. Two polls of professional & amateur astronomers respectively, on whether they see UFOs or not. Finally 60+ PhD dissertations and academic publications about UFOs. Very little peer-reviewed literature has been published in which academics have proposed, studied or supported non-prosaic explanations for UFOs. www.hyper.net... Why aren't there more non-prosaic explanations of U.F.O.'s? That alone lends support to the notion that extraterrestrial visitation has occurred. I have had 3 sightings myself. Two looked like probes. It was real windy one day and the wind was almost knocking me over, then this round orb passed in front of me going against the wind. It slowed down and then it sped back up. Where are all the Scientist explaining U.F.O.'s? Why are there still these unidentified objects in the sky? We have aeriel phenomena in the sky that can avoid radar, outrun our best planes and cause nuclear facilities to malfunction. After 60 or more years of these sightings why can't Scientist explain these things like Newton did with comets based on eyewitness accounts or what happened with metorites? Here's 565 eyewitness accounts",
		"thread_title": "Why isnt observer evidence like eyewitness accounts counted as evidence for UFOs?",
		"title": "Why isnt observer evidence like eyewitness accounts counted as evidence for UFOs?",
		"type": "bs",
		"uuid": "b6675e35ddf7156b02c354c66094a03b97e604ba"
	},
	"-KhI_wLteJSdCHNW7N7L": {
		"author": "The angel of light",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:55.783+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.25967047,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.06180292,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.0333691,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.028484862,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.028004052,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f_dc8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bucking"
				},
				"name": "Buck",
				"salience": 0.024589049,
				"type": "PERSON"
			},
			{
				"name": "voter registration",
				"salience": 0.022955824,
				"type": "EVENT"
			},
			{
				"name": "attempt",
				"salience": 0.02001715,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.019894434,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.018678773,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.017971953,
				"type": "OTHER"
			},
			{
				"name": "Election",
				"salience": 0.017644424,
				"type": "EVENT"
			},
			{
				"name": "measures",
				"salience": 0.015867457,
				"type": "OTHER"
			},
			{
				"name": "Readers",
				"salience": 0.015572159,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.015572159,
				"type": "OTHER"
			},
			{
				"name": "Peace",
				"salience": 0.015572159,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.014475877,
				"type": "PERSON"
			},
			{
				"name": "Trump Win",
				"salience": 0.013003068,
				"type": "ORGANIZATION"
			},
			{
				"name": "voters",
				"salience": 0.012216117,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0106581375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v1s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indiana"
				},
				"name": "Indiana",
				"salience": 0.009792951,
				"type": "LOCATION"
			},
			{
				"name": "narrative",
				"salience": 0.009691975,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African American",
				"salience": 0.009599403,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04k84",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Light"
				},
				"name": "Light",
				"salience": 0.009599403,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.009599403,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dy8r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mission:_Impossible"
				},
				"name": "Mission Impossible",
				"salience": 0.009599403,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Governor",
				"salience": 0.008889445,
				"type": "PERSON"
			},
			{
				"name": "voter fraud",
				"salience": 0.007417448,
				"type": "OTHER"
			},
			{
				"name": "moves",
				"salience": 0.007417448,
				"type": "OTHER"
			},
			{
				"name": "State",
				"salience": 0.007417448,
				"type": "LOCATION"
			},
			{
				"name": "attempt",
				"salience": 0.00692227,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.006735286,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h1c4mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ThinkProgress"
				},
				"name": "thinkprogress.org",
				"salience": 0.006734944,
				"type": "ORGANIZATION"
			},
			{
				"name": "instructions",
				"salience": 0.006424329,
				"type": "OTHER"
			},
			{
				"name": "campaign trail",
				"salience": 0.006424329,
				"type": "LOCATION"
			},
			{
				"name": "Nominee",
				"salience": 0.006424329,
				"type": "PERSON"
			},
			{
				"name": "raid",
				"salience": 0.006424329,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.005965118,
				"type": "EVENT"
			},
			{
				"name": "kind",
				"salience": 0.0059157535,
				"type": "OTHER"
			},
			{
				"name": "voter registration drive",
				"salience": 0.005835429,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.005761987,
				"type": "EVENT"
			},
			{
				"name": "conspiracy",
				"salience": 0.0055888956,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0054735127,
				"type": "OTHER"
			},
			{
				"name": "Red Alert",
				"salience": 0.005260312,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.0050125597,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.004704891,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0045917896,
				"type": "PERSON"
			},
			{
				"name": "Patriot Majority",
				"salience": 0.004568253,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0045436732,
				"type": "EVENT"
			},
			{
				"name": "nothing",
				"salience": 0.0045060567,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0045060567,
				"type": "OTHER"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0045060567,
				"type": "LOCATION"
			},
			{
				"name": "President",
				"salience": 0.0043604807,
				"type": "PERSON"
			},
			{
				"name": "staff",
				"salience": 0.00433799,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.00433799,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.00433799,
				"type": "PERSON"
			},
			{
				"name": "activity",
				"salience": 0.00433799,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0042483998,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.0042483998,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027z3rz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ty_Lawson"
				},
				"name": "Lawson",
				"salience": 0.00400662,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012dpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vice"
				},
				"name": "Vice",
				"salience": 0.0039561684,
				"type": "PERSON"
			},
			{
				"name": "boycott",
				"salience": 0.0039197924,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003773568,
				"type": "PERSON"
			},
			{
				"name": "excuse",
				"salience": 0.0036791249,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.0036791249,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0036791249,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.003571445,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.0035418689,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0130xz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_officer"
				},
				"name": "General",
				"salience": 0.0032036747,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0031742114,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.0027717175,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.0027487588,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0027487588,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0027487588,
				"type": "OTHER"
			},
			{
				"name": "irregularities",
				"salience": 0.0027487588,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0027067736,
				"type": "PERSON"
			},
			{
				"name": "attention",
				"salience": 0.00256065,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0022158336,
				"type": "OTHER"
			},
			{
				"name": "governors",
				"salience": 0.0020706744,
				"type": "PERSON"
			},
			{
				"name": "voter registration drive",
				"salience": 0.0020124866,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.0020020995,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.0020020995,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0020020995,
				"type": "LOCATION"
			},
			{
				"name": "voter registration groups",
				"salience": 0.0020020995,
				"type": "ORGANIZATION"
			},
			{
				"name": "regulations",
				"salience": 0.0020020995,
				"type": "OTHER"
			},
			{
				"name": "violations",
				"salience": 0.0020020995,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0019768742,
				"type": "OTHER"
			},
			{
				"name": "decisions",
				"salience": 0.0017272199,
				"type": "OTHER"
			},
			{
				"name": "www.dailykos.com",
				"salience": 0.0016920128,
				"type": "OTHER"
			},
			{
				"name": "ATS",
				"salience": 0.0016920128,
				"type": "ORGANIZATION"
			},
			{
				"name": "Candidate",
				"salience": 0.0014956285,
				"type": "PERSON"
			},
			{
				"name": "protocol",
				"salience": 0.0013343067,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hmrpgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Huffington_Post"
				},
				"name": "Huffington Post",
				"salience": 0.0012322989,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025rssf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_election"
				},
				"name": "General Election",
				"salience": 0.0011774226,
				"type": "EVENT"
			},
			{
				"name": "Voter registration drives",
				"salience": 0.0011373692,
				"type": "EVENT"
			},
			{
				"name": "theintercept.com",
				"salience": 0.0009205118,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:55.783+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Watch up! Mission Impossible against voter registration to make Trump Win starts from Indiana! page: 1 The Peace of God to all that belong to the Light, Dear Readers, A so serious and suspicious move in Indiana today is practically leaving 45000 voters, the major part of which are African American, possibly out of any possibility to vote this November 8th Presidential Election, this following instructions of the Vice Presidential Republican Nominee and Governor of the State Mike Pence. Please Read: thinkprogress.org... Patriot Majority alleges the investigation and raid were political moves, and that Lawson worked closely with Gov. Mike Pence (R), who has pushed the “voter fraud” conspiracy on the campaign trail alongside Donald Trump. “We’ve seen nothing but partisan activity from the secretary of state, and even from the police,” Buck said. “They saw that there was a very successful voter registration drive happening, and this was an attempt to shut it down.” “It’s clear that the governor or the governor’s staff are very aware and involved in what’s happening,” he continued. “It fits into the Trump/Pence narrative that in certain neighborhoods, you have to watch how many times people show up to vote and how things happen.” If this situation is Not fully clarified in the following hours we could see in the General election how Trump will probably take Indiana with a really small margin of votes by blocking these voters to be able to express their decision freely. All this operation of today is part of carefully designed Republican strategy to use the excuse of a possible fraud to justify arbitrary measures that will prevent many Americans to elect the next President, is a political boycott of the General Election. Please check: theintercept.com... This is an Red Alert to all voters that oppose Donald Trump to watch carefully the behavior and decisions taken by the Republican governors to try to favor their Candidate. “They saw that there was a very successful voter registration drive happening, and this was an attempt to shut it down.” Please check: www.dailykos.com... The thread is open not only to discuss this so dark operation but also to invite other members of ATS community to report irregularities of any kind that are right now taking place to assure that on November who become elected will be President not because it has really the support of the majority but because thousands of Americans are going to be deprived of their right to vote. Voter registration drives across the country follow similar protocol, without being subject to investigations. A Huffington Post investigation reported that “it seems the extraordinary investigation is likely to find no more than potential technical violations of obscure regulations for third-party voter registration groups.” Thanks for your attention,",
		"thread_title": "Watch up! Mission Impossible against voter registration to make Trump Win starts from Indiana!",
		"title": "Watch up! Mission Impossible against voter registration to make Trump Win starts from Indiana!",
		"type": "bs",
		"uuid": "b712ee19f141c4c8ab3d7005ff59da2eb410faf2"
	},
	"-KhI_wXPgVP7nivTVnWs": {
		"author": "darkbake",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:57.851+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.5916315,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.20096135,
				"type": "PERSON"
			},
			{
				"name": "disability",
				"salience": 0.04031797,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.01952589,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.015216672,
				"type": "OTHER"
			},
			{
				"name": "trouble",
				"salience": 0.014179572,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.010715826,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.009864594,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09cds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asperger_syndrome"
				},
				"name": "Aspergers",
				"salience": 0.0076162755,
				"type": "PERSON"
			},
			{
				"name": "IQ",
				"salience": 0.007393899,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.006942595,
				"type": "PERSON"
			},
			{
				"name": "disability",
				"salience": 0.0059421915,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0058754957,
				"type": "PERSON"
			},
			{
				"name": "level",
				"salience": 0.005129538,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0045074965,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.0039845677,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.003317782,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0032349254,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0032349254,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0027937472,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0027361359,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.002523032,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0023877958,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0022699127,
				"type": "OTHER"
			},
			{
				"name": "mental health diagnosis",
				"salience": 0.0022699127,
				"type": "OTHER"
			},
			{
				"name": "medicines",
				"salience": 0.0022699127,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "work",
				"salience": 0.0021853272,
				"type": "OTHER"
			},
			{
				"name": "business deals",
				"salience": 0.0021853272,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0021853272,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0021853272,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0021402352,
				"type": "OTHER"
			},
			{
				"name": "speaker",
				"salience": 0.0017180385,
				"type": "PERSON"
			},
			{
				"name": "mistakes",
				"salience": 0.001675066,
				"type": "OTHER"
			},
			{
				"name": "Aspergers",
				"salience": 0.0012904502,
				"type": "OTHER"
			},
			{
				"name": "gaffes",
				"salience": 0.001021956,
				"type": "OTHER"
			},
			{
				"name": "relationships",
				"salience": 0.0010090854,
				"type": "OTHER"
			},
			{
				"name": "weaknesses",
				"salience": 0.0010090854,
				"type": "OTHER"
			},
			{
				"name": "blunders",
				"salience": 0.00093519257,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.000870593,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.00075389794,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00075389794,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fear",
				"salience": 0.00070181274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.0005359116,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:57.851+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Donald Trump could have a disability that used to be known as Aspergers, and this can cause people trouble when they try to socialize because their theory of mind is not complete. Basically, they have trouble thinking of how others perceive their actions. These people tend to be highly intelligent. Trump's IQ is 156, which makes sense considering he has built more businesses than most of us have, and although he could have invested his father's money and made the same amount back as he did in the end through business deals, he put a lot of work and thought into his business. I would like to know what kind of medicines Trump is on and what his mental health diagnosis are. If he has Aspergers, then that would explain why he makes so many social mistakes. Being super rich from a young age might also account for it since he would not be trained to interact with people on an equal level (which is a lot more complicated than interacting with people when you are rich and they are poor). However, an article in The New York Times recently focused on Trump's fears of making social blunders. He has a fear of losing social status or being embarrassed publicly. However, he doesn't seem to do well publicly, which must be a disability because he would *want* to be a good public speaker and not make social gaffes yet he still does it. It must be accidental. Donald even stated he is a difficult man to be married to, which means he knows himself and his weaknesses. Many people with Aspergers don't get married because they have a hard time in relationships.",
		"thread_title": "Is Donald Trump Autistic?",
		"title": "Is Donald Trump Autistic?",
		"type": "bs",
		"uuid": "6b47a615b958c59fc0f3b0a8c5da69edf34cacd9"
	},
	"-KhI_wgBWWG9ZWsKfHby": {
		"author": "willz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:59.244+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "lad",
				"salience": 0.5266956,
				"type": "PERSON"
			},
			{
				"name": "COMPUTING",
				"salience": 0.04926038,
				"type": "OTHER"
			},
			{
				"name": "nanobots",
				"salience": 0.041427605,
				"type": "OTHER"
			},
			{
				"name": "Nanobots",
				"salience": 0.040885396,
				"type": "OTHER"
			},
			{
				"name": "depression",
				"salience": 0.03306526,
				"type": "OTHER"
			},
			{
				"name": "bots",
				"salience": 0.022885442,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.019787569,
				"type": "OTHER"
			},
			{
				"name": "expert",
				"salience": 0.019022364,
				"type": "PERSON"
			},
			{
				"name": "experiment",
				"salience": 0.019022364,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.0164886,
				"type": "OTHER"
			},
			{
				"name": "biology",
				"salience": 0.0164886,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0164886,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0164886,
				"type": "OTHER"
			},
			{
				"name": "brain",
				"salience": 0.008817962,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.008772593,
				"type": "WORK_OF_ART"
			},
			{
				"name": "brain",
				"salience": 0.008707209,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.00839162,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.0068123234,
				"type": "OTHER"
			},
			{
				"name": "d",
				"salience": 0.0068123234,
				"type": "OTHER"
			},
			{
				"name": "radio",
				"salience": 0.0062349583,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06qmk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Schutzstaffel"
				},
				"name": "Nazi SS",
				"salience": 0.006026061,
				"type": "ORGANIZATION"
			},
			{
				"name": "ALL",
				"salience": 0.0058829933,
				"type": "OTHER"
			},
			{
				"name": "depression",
				"salience": 0.0058829933,
				"type": "OTHER"
			},
			{
				"name": "Maths",
				"salience": 0.005245953,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0047796587,
				"type": "OTHER"
			},
			{
				"name": "depression",
				"salience": 0.0047439747,
				"type": "OTHER"
			},
			{
				"name": "chase",
				"salience": 0.0046015107,
				"type": "OTHER"
			},
			{
				"name": "brain chemicals",
				"salience": 0.0046015107,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0046015107,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0046015107,
				"type": "OTHER"
			},
			{
				"name": "nerves",
				"salience": 0.0046015107,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.0045436127,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0039030311,
				"type": "OTHER"
			},
			{
				"name": "pain",
				"salience": 0.0038539076,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.0031072227,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.0029435393,
				"type": "OTHER"
			},
			{
				"name": "monkey",
				"salience": 0.002916477,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.0028337443,
				"type": "LOCATION"
			},
			{
				"name": "nanobots",
				"salience": 0.0027169718,
				"type": "OTHER"
			},
			{
				"name": "anti-depressants",
				"salience": 0.002381224,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "death",
				"salience": 0.0021245123,
				"type": "EVENT"
			},
			{
				"name": "drugs",
				"salience": 0.0021245123,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "computer",
				"salience": 0.0020299535,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "action",
				"salience": 0.0019689242,
				"type": "OTHER"
			},
			{
				"name": "Math",
				"salience": 0.0018329063,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0016910731,
				"type": "OTHER"
			},
			{
				"name": "professor",
				"salience": 0.0015872027,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0015872027,
				"type": "LOCATION"
			},
			{
				"name": "ambition",
				"salience": 0.0015872027,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0015872027,
				"type": "OTHER"
			},
			{
				"name": "standard",
				"salience": 0.0015872027,
				"type": "OTHER"
			},
			{
				"name": "computer programming",
				"salience": 0.0015872027,
				"type": "OTHER"
			},
			{
				"name": "tutor",
				"salience": 0.0013805826,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:59.244+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.1,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Nanobots causing overwhelming depression. Not far off the end now... page: 1 Hello ATS I'm subject to a fierce experiment, or, how it feels to me : torture. I'm not an expert on biology or how the brain works in detail, so forgive me if this post is a little simplistic. Basically I've nanobots (which supposedly don't exist) in my brain, an,d (I assume) they act on my brain chemicals in such a way as to cause chronic depression...suicidal depression in fact. To cut to the chase, as you say in the USA, they also electrocute my nerves (ALL AT ONCE), causing agonising pain! The 'bots are remote/radio controlled by the English SS (and they ARE very similar to the Nazi SS in their treatment of me, I think). So basically, I hear voices (The SS again), and am suffering from feelings that I want to die. About my quite happy 'previous life' before this happened : I was just a young lad who e naonwanted career in computer programming and studied Math/Maths to a high standard (my tutor said I was doing the work of a professor), and still lived at home bashing away at my computer to try and achieve my ambition. As a lot of you will know though COMPUTING is a conspiracy theory too (ie it's not all it states it is). So I suppose I'm doubly unlucky. Why they can't just use a monkey, instead of driving me to my death I don't know, I really dont. Anyways, oh I forgot...the nanobots block the action of nearly ALL the psycho-active drugs I've tried liked anti-depressants etc.",
		"thread_title": "Nanobots causing overwhelming depression. Not far off the end now...",
		"title": "Nanobots causing overwhelming depression. Not far off the end now...",
		"type": "bs",
		"uuid": "1e956fb8691f0534fc21f70e769b5d9b44e983e7"
	},
	"-KhI_wsuQ6AIthbwwk6i": {
		"author": "jedi_hamster",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:54:59.580+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "link",
				"salience": 0.29274595,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.11112636,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.080776595,
				"type": "OTHER"
			},
			{
				"name": "mods",
				"salience": 0.05045309,
				"type": "OTHER"
			},
			{
				"name": "calibration - touchscreen devices",
				"salience": 0.038286004,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "purpose",
				"salience": 0.036850218,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.036850218,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.036850218,
				"type": "OTHER"
			},
			{
				"name": "touchscreen calibration'' page",
				"salience": 0.031965315,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.031965315,
				"type": "OTHER"
			},
			{
				"name": "coincidence",
				"salience": 0.018937238,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.016685026,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "youtube",
				"salience": 0.016269498,
				"type": "OTHER"
			},
			{
				"name": "Hi JH",
				"salience": 0.012786451,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.008208058,
				"type": "WORK_OF_ART"
			},
			{
				"name": "screen",
				"salience": 0.00782377,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00782377,
				"type": "PERSON"
			},
			{
				"name": "names",
				"salience": 0.00782377,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.00782377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02szg2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/4chan"
				},
				"name": "4chan",
				"salience": 0.00767018,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.006578824,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.0063337088,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hoax",
				"salience": 0.0054892777,
				"type": "OTHER"
			},
			{
				"name": "bandwagon",
				"salience": 0.0054892777,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0052846777,
				"type": "OTHER"
			},
			{
				"name": "hoax",
				"salience": 0.0052846777,
				"type": "OTHER"
			},
			{
				"name": "bandwagon",
				"salience": 0.0052846777,
				"type": "OTHER"
			},
			{
				"name": "garbage",
				"salience": 0.0047542253,
				"type": "OTHER"
			},
			{
				"name": "calibration - touchscreen devices",
				"salience": 0.004659335,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "reply",
				"salience": 0.004576976,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0045473664,
				"type": "OTHER"
			},
			{
				"name": "neck",
				"salience": 0.003882059,
				"type": "OTHER"
			},
			{
				"name": "woods",
				"salience": 0.003882059,
				"type": "LOCATION"
			},
			{
				"name": "link",
				"salience": 0.0037093612,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.003523595,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0033494579,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0033494579,
				"type": "EVENT"
			},
			{
				"name": "screen",
				"salience": 0.0033494579,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0033494579,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.0033494579,
				"type": "OTHER"
			},
			{
				"name": "GIF",
				"salience": 0.003169705,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.003065146,
				"type": "OTHER"
			},
			{
				"name": "EartOccupant",
				"salience": 0.0029275552,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0029248556,
				"type": "WORK_OF_ART"
			},
			{
				"name": "EDIT",
				"salience": 0.002900635,
				"type": "OTHER"
			},
			{
				"name": "touchscreen devices",
				"salience": 0.0027021815,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "calibration error",
				"salience": 0.0026882403,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0024399124,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07q2hky"
				},
				"name": "Thanks",
				"salience": 0.002390197,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0021128722,
				"type": "OTHER"
			},
			{
				"name": "kelbtalfenek",
				"salience": 0.0021128722,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0021128722,
				"type": "OTHER"
			},
			{
				"name": "quote",
				"salience": 0.0021128722,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0021128722,
				"type": "OTHER"
			},
			{
				"name": "realms",
				"salience": 0.0021128722,
				"type": "OTHER"
			},
			{
				"name": "ATS",
				"salience": 0.0019514011,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.0018228323,
				"type": "PERSON"
			},
			{
				"name": "coincidence",
				"salience": 0.0018228323,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.0018228323,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0018228323,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0018228323,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0013005763,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:59.580+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "yet another proof of \"wrong touchscreen calibration\" page: 1 now, i don't agree with their claim about such equipment not needing a calibration - touchscreen devices need it, but this really had to be done on purpose to favor one side and not the other. \"coincidence\", you say. if someone can grab it and upload it to youtube, that would be great - it may disappear from 4chan. i don't have the link for that thread there, but judging by the names on the screen, it's from Virginia. yet another place. Somehow ATS will not let me upload a GIF. But here: damn, i've jumped the bandwagon. mods, 404 or hoax it, that video isn't from 2016. a reply to: jedi_hamster Aah... Then so am I . Damn.. And I promised myself to stay out of this political garbage... I now know why.. edit on 26-10-2016 by EartOccupant because: (no reason given) damn, i've jumped the bandwagon. mods, 404 or hoax it, that video isn't from 2016. Hi JH, how do you know its not from 2016? just curious as i am not in that neck of the woods Thanks now, i don't agree with their claim about such equipment not needing a calibration - touchscreen devices need it, but this really had to be done on purpose to favor one side and not the other. \"coincidence\", you say. if someone can grab it and upload it to youtube, that would be great - it may disappear from 4chan. i don't have the link for that thread there, but judging by the names on the screen, it's from Virginia. yet another place. Direct link EDIT: This video was actually taken back in 2014 in Virginia, during the 2014 congressional elections (see it on YouTube here.) The reason listed for the issues that arose in the video was a calibration error; not entirely out of the realms of possibility given the number of touchscreen devices used during the elections across the United States that year. edit on 26-10-2016 by kelbtalfenek because: more information and a quote",
		"thread_title": "yet another proof of wrong touchscreen calibration",
		"title": "yet another proof of wrong touchscreen calibration",
		"type": "bs",
		"uuid": "2b977a7e92cb2834c52e6d1466416955d0d696b0"
	},
	"-KhI_xC9QtlocTmr-_7f": {
		"author": "PrairieShepherd",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:55:00.542+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Jonathan Rockport",
				"salience": 0.16214274,
				"type": "PERSON"
			},
			{
				"name": "host",
				"salience": 0.07354514,
				"type": "PERSON"
			},
			{
				"name": "Eleanor Harrington",
				"salience": 0.065509014,
				"type": "PERSON"
			},
			{
				"name": "grand",
				"salience": 0.0552337,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.03584691,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Mister Walker",
				"salience": 0.030186923,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06fgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Borden"
				},
				"name": "Borden",
				"salience": 0.023048189,
				"type": "PERSON"
			},
			{
				"name": "writing contest",
				"salience": 0.02071595,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "Good Lord",
				"salience": 0.015633088,
				"type": "PERSON"
			},
			{
				"name": "lanterns",
				"salience": 0.013379101,
				"type": "OTHER"
			},
			{
				"name": "Master",
				"salience": 0.0127097815,
				"type": "PERSON"
			},
			{
				"name": "coach",
				"salience": 0.012614965,
				"type": "PERSON"
			},
			{
				"name": "coach",
				"salience": 0.012614965,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.012614965,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03lq2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halloween"
				},
				"name": "Halloween",
				"salience": 0.011889794,
				"type": "EVENT"
			},
			{
				"name": "fog",
				"salience": 0.011825902,
				"type": "OTHER"
			},
			{
				"name": "Estate",
				"salience": 0.010926858,
				"type": "LOCATION"
			},
			{
				"name": "window",
				"salience": 0.010926858,
				"type": "OTHER"
			},
			{
				"name": "mist",
				"salience": 0.010320266,
				"type": "OTHER"
			},
			{
				"name": "bumps",
				"salience": 0.009867677,
				"type": "OTHER"
			},
			{
				"name": "Sturbridge Village",
				"salience": 0.009861912,
				"type": "LOCATION"
			},
			{
				"name": "railway",
				"salience": 0.009641233,
				"type": "LOCATION"
			},
			{
				"name": "stars",
				"salience": 0.008546509,
				"type": "PERSON"
			},
			{
				"name": "leather seat",
				"salience": 0.008546509,
				"type": "OTHER"
			},
			{
				"name": "curtain",
				"salience": 0.008546509,
				"type": "OTHER"
			},
			{
				"name": "moon",
				"salience": 0.008124376,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.007699729,
				"type": "LOCATION"
			},
			{
				"name": "Herr von Graeff",
				"salience": 0.0076147374,
				"type": "PERSON"
			},
			{
				"name": "trip",
				"salience": 0.0074351104,
				"type": "EVENT"
			},
			{
				"name": "window",
				"salience": 0.0059497925,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0059239273,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0052380334,
				"type": "OTHER"
			},
			{
				"name": "fog",
				"salience": 0.004873202,
				"type": "OTHER"
			},
			{
				"name": "Driver",
				"salience": 0.004617778,
				"type": "PERSON"
			},
			{
				"name": "sir",
				"salience": 0.0045021973,
				"type": "OTHER"
			},
			{
				"name": "sir",
				"salience": 0.0045021973,
				"type": "PERSON"
			},
			{
				"name": "window",
				"salience": 0.0045021973,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.004370417,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.004370417,
				"type": "PERSON"
			},
			{
				"name": "steps",
				"salience": 0.0042766454,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0041695945,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.004065221,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.004065221,
				"type": "OTHER"
			},
			{
				"name": "bump",
				"salience": 0.004065221,
				"type": "OTHER"
			},
			{
				"name": "fiancée",
				"salience": 0.0037776378,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0037537387,
				"type": "PERSON"
			},
			{
				"name": "meaning",
				"salience": 0.003750682,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.003750682,
				"type": "OTHER"
			},
			{
				"name": "coach",
				"salience": 0.003645731,
				"type": "PERSON"
			},
			{
				"name": "coach",
				"salience": 0.003645731,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.003645731,
				"type": "LOCATION"
			},
			{
				"name": "hand",
				"salience": 0.003645731,
				"type": "OTHER"
			},
			{
				"name": "hm",
				"salience": 0.0036107232,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0035681452,
				"type": "PERSON"
			},
			{
				"name": "fork",
				"salience": 0.0035203286,
				"type": "OTHER"
			},
			{
				"name": "trees",
				"salience": 0.0035203286,
				"type": "OTHER"
			},
			{
				"name": "pardon",
				"salience": 0.0035203286,
				"type": "OTHER"
			},
			{
				"name": "brow",
				"salience": 0.0035203286,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0035096852,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.0035096852,
				"type": "LOCATION"
			},
			{
				"name": "coach",
				"salience": 0.0035096852,
				"type": "PERSON"
			},
			{
				"name": "tops",
				"salience": 0.0033462667,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0033189328,
				"type": "OTHER"
			},
			{
				"name": "fog",
				"salience": 0.0032897398,
				"type": "OTHER"
			},
			{
				"name": "estate",
				"salience": 0.0031570264,
				"type": "LOCATION"
			},
			{
				"name": "driver",
				"salience": 0.0031570264,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.0030528384,
				"type": "OTHER"
			},
			{
				"name": "cobblestone drive",
				"salience": 0.0030392052,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0029764012,
				"type": "LOCATION"
			},
			{
				"name": "hands",
				"salience": 0.0029764012,
				"type": "OTHER"
			},
			{
				"name": "sir",
				"salience": 0.0028889172,
				"type": "PERSON"
			},
			{
				"name": "butler",
				"salience": 0.0028525202,
				"type": "PERSON"
			},
			{
				"name": "footman",
				"salience": 0.0028505283,
				"type": "PERSON"
			},
			{
				"name": "oak door",
				"salience": 0.0028505283,
				"type": "OTHER"
			},
			{
				"name": "footman",
				"salience": 0.0028505283,
				"type": "PERSON"
			},
			{
				"name": "accent",
				"salience": 0.0028505283,
				"type": "OTHER"
			},
			{
				"name": "Oil lanterns",
				"salience": 0.0027441387,
				"type": "OTHER"
			},
			{
				"name": "gables",
				"salience": 0.0027441387,
				"type": "LOCATION"
			},
			{
				"name": "gables",
				"salience": 0.0027441387,
				"type": "OTHER"
			},
			{
				"name": "master",
				"salience": 0.0027095648,
				"type": "PERSON"
			},
			{
				"name": "shape",
				"salience": 0.0026634773,
				"type": "OTHER"
			},
			{
				"name": "dinner",
				"salience": 0.0025773682,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0025640652,
				"type": "OTHER"
			},
			{
				"name": "stairs",
				"salience": 0.0024683613,
				"type": "OTHER"
			},
			{
				"name": "evening meal",
				"salience": 0.0024683613,
				"type": "EVENT"
			},
			{
				"name": "service",
				"salience": 0.0024683613,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0024683613,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0024683613,
				"type": "OTHER"
			},
			{
				"name": "smile",
				"salience": 0.0024683613,
				"type": "OTHER"
			},
			{
				"name": "soup",
				"salience": 0.0023762276,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0023762276,
				"type": "OTHER"
			},
			{
				"name": "legs",
				"salience": 0.0023762276,
				"type": "OTHER"
			},
			{
				"name": "gate",
				"salience": 0.0023762276,
				"type": "OTHER"
			},
			{
				"name": "hooks",
				"salience": 0.0023762276,
				"type": "OTHER"
			},
			{
				"name": "pools",
				"salience": 0.0023762276,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0023762276,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0023762276,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.0023271167,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.0023271167,
				"type": "OTHER"
			},
			{
				"name": "breath",
				"salience": 0.0022587073,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053v04",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belgrade_Nikola_Tesla_Airport"
				},
				"name": "Beg",
				"salience": 0.002166934,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0021199426,
				"type": "OTHER"
			},
			{
				"name": "fog",
				"salience": 0.0020841216,
				"type": "OTHER"
			},
			{
				"name": "arrival",
				"salience": 0.0020150915,
				"type": "EVENT"
			},
			{
				"name": "squeal",
				"salience": 0.0020150915,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0020150915,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.0020150915,
				"type": "OTHER"
			},
			{
				"name": "creases",
				"salience": 0.0020150915,
				"type": "OTHER"
			},
			{
				"name": "hair",
				"salience": 0.0020150915,
				"type": "OTHER"
			},
			{
				"name": "seventies",
				"salience": 0.0020150915,
				"type": "OTHER"
			},
			{
				"name": "hesitation",
				"salience": 0.0020150915,
				"type": "OTHER"
			},
			{
				"name": "foyer",
				"salience": 0.0020150915,
				"type": "LOCATION"
			},
			{
				"name": "Anne Union Keyes Estate",
				"salience": 0.0019432439,
				"type": "LOCATION"
			},
			{
				"name": "dinner",
				"salience": 0.0019253634,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0017383945,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.0017383945,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0017383945,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0typ5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fall_River,_Massachusetts"
				},
				"name": "Fall River",
				"salience": 0.001693864,
				"type": "LOCATION"
			},
			{
				"name": "business meetings",
				"salience": 0.0016450263,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0015192608,
				"type": "LOCATION"
			},
			{
				"name": "sound",
				"salience": 0.0015052803,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.0015052803,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0015052803,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0014502645,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0014502645,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0014502645,
				"type": "PERSON"
			},
			{
				"name": "businessman",
				"salience": 0.0014022224,
				"type": "PERSON"
			},
			{
				"name": "dinner",
				"salience": 0.0014022224,
				"type": "OTHER"
			},
			{
				"name": "butler",
				"salience": 0.0014022224,
				"type": "PERSON"
			},
			{
				"name": "branch line",
				"salience": 0.0012764722,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0012660407,
				"type": "OTHER"
			},
			{
				"name": "dining hall",
				"salience": 0.0012660407,
				"type": "LOCATION"
			},
			{
				"name": "accent",
				"salience": 0.0012034118,
				"type": "OTHER"
			},
			{
				"name": "business proposition",
				"salience": 0.0011980355,
				"type": "OTHER"
			},
			{
				"name": "appointment",
				"salience": 0.0011980355,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0011353253,
				"type": "OTHER"
			},
			{
				"name": "v",
				"salience": 0.0010962525,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.0010962525,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0010962525,
				"type": "OTHER"
			},
			{
				"name": "entrepreneur",
				"salience": 0.0010962525,
				"type": "PERSON"
			},
			{
				"name": "success",
				"salience": 0.0010962525,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0010962525,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0009823766,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.0009456971,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "Massachusetts",
				"salience": 0.0009264147,
				"type": "LOCATION"
			},
			{
				"name": "grip",
				"salience": 0.0008614818,
				"type": "OTHER"
			},
			{
				"name": "stiffness",
				"salience": 0.0008614818,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00081886223,
				"type": "LOCATION"
			},
			{
				"name": "cane",
				"salience": 0.00081886223,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.00081886223,
				"type": "OTHER"
			},
			{
				"name": "highway",
				"salience": 0.00081886223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00067465776,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0005039338,
				"type": "LOCATION"
			},
			{
				"name": "Gottfried Hansjürgen",
				"salience": 0.0005039338,
				"type": "PERSON"
			},
			{
				"name": "eyes",
				"salience": 0.00041804943,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats6.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:55:00.542+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 29.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "It seems there isn't going to be a Halloween writing contest, so I thought I would post the story I pre-emptively wrote for it. I hope you enjoy it! Master of the Estate \"This coach really is quite wonderful, Jonathan. I can barely feel the bumps and I don't feel like I'm about to be thrown out the window!\" Eleanor exclaimed. \"It is grand, isn't it?\" \"It's all grand. The trip, our coach...and you,\" she said, smiling and snuggling in closer to Jonathan on the wide leather seat. \"I could do without this fog, though. I would like to see the moon and stars later tonight.\" He pulled the curtain aside slightly with a gloved hand and peered mournfully through the window at the white mist that nearly obscured everything. He could hardly see the tops of the trees it was so thick. Just then a particularly large bump jostled them roughly, followed closely by another. \"Oh!\" squealed Eleanor. Jonathan's brow drew down. \"Driver!\" he called out the window. \"Is everything alright?\" \"Beg pardon, sir. I fear I may have taken a wrong turn at that fork back a ways. There's a house up ahead...I'll check in with them and make sure. Sturbridge Village can't be far now, and we're better safe than sorry with this fog rolling in, if you take my meaning, sir. Don't want to be out past dark in this soup.\" Jonathan looked at Eleanor. \"Well, it would be nice to stretch our legs for a moment,\" she said. She was not quite as cheerful as she had been just minutes ago. The October afternoon was cooling off as evening approached, and Jonathan could see his breath. The coach trundled past well-maintained stone gables and a heavy wrought-iron gate, standing open on one side. Oil lanterns hung from black hooks in the gables glowed dimly in the fog, and additional lanterns spilled pools of yellow-orange light on a cobblestone drive as they made their way up toward the house. Eleanor gasped as the massive shape of the house came into view. \"It's beautiful!\" Jonathan made a surprised \"hm\", but otherwise said nothing. A well-dressed footman dashed out to lower the stairs of their coach and open the door, then offered a white-gloved hand to Eleanor as she peered out. With a flashed smile at Jonathan, she accepted the young man's hand and descended. The driver was speaking quietly with another footman, and an older man emerged from the heavy oak door of the house as Jonathan descended the steps of the coach. The older man - clearly the butler - bowed to Eleanor and Jonathan. \"Welcome to the Anne Union Keyes Estate. I am Mister Walker, and I am at your service. The master of the estate has invited you in for the evening meal.\" The butler spoke with some kind of British accent, but beyond that Jonathan not say from where exactly. \"Good Lord man, we just arrived unannounced!\" \"Yes, sir, but Herr von Graeff enjoys entertaining and was notified of your arrival as you drove up. I would be honored if you would follow me...\" he gestured toward the polished steps. Eleanor was the type of woman who, once her mind was made, up, proceeded without hesitation. She must have decided they were staying for dinner, for with a delighted squeal she headed for the house. They were greeted in the foyer by an elderly man. Jonathan estimated he was in his seventies, hair fully white with deep creases in his face on age showing on his hands. However, the man was tall and straight-backed, and he carried himself proudly. There was a stiffness to his movements, and he used a cane to walk, but when Jonathan shook his large hands the man's grip was as firm as a man half his age. “Welcome,” he said warmly and with what Jonathan thought was a German accent. “I am Gottfried Hansjürgen von Graeff. Please, be welcome in my home. How may I call you?” The man’s eyes were unusual, but Jonathan could not place what it was about them that seemed so. He shrugged it off. “Thank you, Herr von Graeff. I am Jonathan Rockport, this is my fiancée Eleanor Harrington. We really have only stopped to find our way back to the highway. We are trying to get to Sturbridge Village to stay for the night before continuing on to Fall River in the morning.” “Ah, yes, well, you will not make it to Sturbridge Village in this fog.” Herr von Graeff pronounced the name of the town with a “sh” sound. “At least, not before dark, even if you left now. It is fifteen miles yet. Why don’t you join me for dinner, stay here tonight, and then resume your journey first thing tomorrow?” “You are a generous host, Herr von Graeff, but I really would like to press on if possible. I have business meetings in Massachusetts and must be in Fall River by Tuesday. ” “Ah, a wonderful town, Fall River, yes? Tell me, how is the new railway doing? I understand the esteemed Mr. Borden opened the branch line just last year, yes?” “Indeed,” said Jonathan slowly, “The railway has been a smashing success. In fact, it is Mr. Borden I have an appointment to see. I have a business proposition for him that I think he will be quite excited about.” “An entrepreneur!” Exclaimed Herr von Graeff. “Excellent! I always enjoy conversing with a businessman, especially you Americans. Always such big ideas, yes? Please, let us carry on our conversation over dinner. Mister Walker,” he continued, pronouncing the butler’s name with a “v”, “would you lead us to the dining hall?” “Yes, Herr von Graeff.”",
		"thread_title": "Master of the Estate",
		"title": "Master of the Estate",
		"type": "bs",
		"uuid": "e70d073d92d8d932580e52147f09b73c62824608"
	},
	"-KhI_xIYFbXRJPqGENii": {
		"author": "SyxPak",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:55:02.683+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "page",
				"salience": 0.3063803,
				"type": "OTHER"
			},
			{
				"name": "End",
				"salience": 0.13524958,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.12950772,
				"type": "OTHER"
			},
			{
				"name": "tale",
				"salience": 0.066735946,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Someone",
				"salience": 0.066735946,
				"type": "PERSON"
			},
			{
				"name": "woe",
				"salience": 0.066735946,
				"type": "OTHER"
			},
			{
				"name": "Life",
				"salience": 0.052125897,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.04518028,
				"type": "OTHER"
			},
			{
				"name": "Nothing",
				"salience": 0.04322373,
				"type": "OTHER"
			},
			{
				"name": "Breath",
				"salience": 0.028685236,
				"type": "OTHER"
			},
			{
				"name": "Life Forces",
				"salience": 0.023650562,
				"type": "ORGANIZATION"
			},
			{
				"name": "Death",
				"salience": 0.020912828,
				"type": "EVENT"
			},
			{
				"name": "I Will Live Forever More",
				"salience": 0.014876023,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:55:02.683+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "It Will Come for You All... page: 1 (For A little Halloween atmosphere, I present this...) Someone's tale of woe has induced, a poetic response for You to see. End of Life will come for You all, but it will Never come for Me. For I will live on Eternally with, the Life Forces I will get from You. It Will happen to You all one day or night, there is Nothing to avoid it You can do. I will be Empowered evermore, even from Your Last Breath. I Will Live Forever More, for I am Known as Death...",
		"thread_title": "It Will Come for You All...",
		"title": "It Will Come for You All...",
		"type": "bs",
		"uuid": "3130cacdf1253a22cf0f2e03b762f452ee0173ba"
	},
	"-KhI_xWIHMCb5KkgKAeT": {
		"author": "matafuchs",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:55:03.186+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Loretta",
				"salience": 0.31905448,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01qh39",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elizabeth_Warren"
				},
				"name": "Elizabeth Warren",
				"salience": 0.045978457,
				"type": "PERSON"
			},
			{
				"name": "whoppers",
				"salience": 0.040713977,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.040713977,
				"type": "OTHER"
			},
			{
				"name": "low",
				"salience": 0.03508477,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.032612458,
				"type": "PERSON"
			},
			{
				"name": "excuse",
				"salience": 0.031630293,
				"type": "OTHER"
			},
			{
				"name": "Hispanics Hillary",
				"salience": 0.029032448,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.029032448,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02p10m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Univision"
				},
				"name": "Univision",
				"salience": 0.02516579,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.020901889,
				"type": "EVENT"
			},
			{
				"name": "hot sauce",
				"salience": 0.020901889,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.020901889,
				"type": "LOCATION"
			},
			{
				"name": "accent",
				"salience": 0.020901889,
				"type": "OTHER"
			},
			{
				"name": "grandchild",
				"salience": 0.017887367,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Native Americans",
				"salience": 0.012891696,
				"type": "PERSON"
			},
			{
				"name": "grandchild",
				"salience": 0.011938995,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07r_cc9"
				},
				"name": "Blacks",
				"salience": 0.010530394,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.0091938,
				"type": "OTHER"
			},
			{
				"name": "Link",
				"salience": 0.0086687375,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0075083724,
				"type": "OTHER"
			},
			{
				"name": "y/o granddaughter",
				"salience": 0.007197143,
				"type": "PERSON"
			},
			{
				"name": "gelato ice cream",
				"salience": 0.0067297434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.0061377496,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.0061377496,
				"type": "LOCATION"
			},
			{
				"name": "meat",
				"salience": 0.0060542184,
				"type": "OTHER"
			},
			{
				"name": "hosts",
				"salience": 0.0060542184,
				"type": "PERSON"
			},
			{
				"name": "establishment",
				"salience": 0.0060542184,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0060542184,
				"type": "PERSON"
			},
			{
				"name": "sandwiches",
				"salience": 0.0060542184,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0058284947,
				"type": "LOCATION"
			},
			{
				"name": "restaurants",
				"salience": 0.0058284947,
				"type": "LOCATION"
			},
			{
				"name": "article",
				"salience": 0.0058284947,
				"type": "WORK_OF_ART"
			},
			{
				"name": "deal",
				"salience": 0.005266802,
				"type": "OTHER"
			},
			{
				"name": "massagers",
				"salience": 0.005266802,
				"type": "PERSON"
			},
			{
				"name": "goodness sake",
				"salience": 0.0049435357,
				"type": "OTHER"
			},
			{
				"name": "pack",
				"salience": 0.0049435357,
				"type": "OTHER"
			},
			{
				"name": "sombrero",
				"salience": 0.0049435357,
				"type": "OTHER"
			},
			{
				"name": "t-shirt",
				"salience": 0.0049435357,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stage",
				"salience": 0.0049435357,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.0043048677,
				"type": "LOCATION"
			},
			{
				"name": "Bills",
				"salience": 0.0042652884,
				"type": "OTHER"
			},
			{
				"name": "grandchild",
				"salience": 0.0041745533,
				"type": "PERSON"
			},
			{
				"name": "Northern Lights Creamery",
				"salience": 0.0041442895,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0038858068,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06nm1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spanish_language"
				},
				"name": "Spanish",
				"salience": 0.0037280146,
				"type": "OTHER"
			},
			{
				"name": "Charlie The Butcher",
				"salience": 0.0037280146,
				"type": "PERSON"
			},
			{
				"name": "Little Store",
				"salience": 0.0037280146,
				"type": "LOCATION"
			},
			{
				"name": "bottle",
				"salience": 0.0036937334,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "birthday",
				"salience": 0.0036937334,
				"type": "EVENT"
			},
			{
				"name": "library",
				"salience": 0.0036937334,
				"type": "LOCATION"
			},
			{
				"name": "Someone",
				"salience": 0.0036662167,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.003588932,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020m8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raja"
				},
				"name": "Rao",
				"salience": 0.003588932,
				"type": "PERSON"
			},
			{
				"name": "Lange",
				"salience": 0.003588932,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italian",
				"salience": 0.003588932,
				"type": "LOCATION"
			},
			{
				"name": "Thrillist",
				"salience": 0.003588932,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.003588932,
				"type": "LOCATION"
			},
			{
				"name": "matafuchs",
				"salience": 0.0031070283,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0031070283,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0031070283,
				"type": "OTHER"
			},
			{
				"name": "matafuchs",
				"salience": 0.0031070283,
				"type": "PERSON"
			},
			{
				"name": "Sol",
				"salience": 0.003043719,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bn8n2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joaqu%C3%ADn_Guzm%C3%A1n"
				},
				"name": "El Chapo",
				"salience": 0.003043719,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09sy4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tequila"
				},
				"name": "Tequila",
				"salience": 0.0022739093,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ANYBODY",
				"salience": 0.0020100218,
				"type": "PERSON"
			},
			{
				"name": "voting block",
				"salience": 0.0020100218,
				"type": "OTHER"
			},
			{
				"name": "ANYTHING",
				"salience": 0.0020100218,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0020100218,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0012371674,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0012371674,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats15.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:55:03.186+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "To pander to Hispanics Hillary states some whoppers on Univision page: 1 link Ah, Hillary. You change your accent depending on who you talk to. You tell Blacks in an interview you carry hot sauce everywhere. You try to appeal to Native Americans with Elizabeth Warren (hahahaha) but for her this is a low. USing her own grandchild....it isn't the first time she has used the grandchild either. It was the excuse for Bill and Loretta also... Link First, when asked, she says her favorite food is Mexican. In an article this year for “Thrillist,” detailing her favorite restaurants in the state of the New York, Clinton listed Rao’s (Italian), Northern Lights Creamery (gelato ice cream), Lange’s Little Store (sandwiches), Charlie The Butcher’s (meat) and others. But she didn’t list a single Mexican establishment. Second, she went on to tell the hosts her 2 y/o granddaughter is learning Spanish. Really? I mean she should have walked on stage with an El Chapo t-shirt, a sombrero and a six pack of Sol for goodness sake. Now, i know, this is not a big deal but stop and think. She is pathological. Is that who we really want in the White House? Someone who will say ANYTHING to ANYBODY in order to get them to agree. Using your grandchild to pander to a voting block. She is Nasty. If I was HIspanic this may not drive me to vote Trump, even though they should and will, I certainly would not vote for someone as fake as she is. Only good thing was she got a bottle of Tequila for her birthday. I am sure Bills foot massagers in his library will love it.... edit on 10pm31pmf 2016-10-26T14:56:02-05:000202 by matafuchs because: (no reason given) edit on 10pm31pmf 2016-10-26T14:57:05-05:000205 by matafuchs because: (no reason given)",
		"thread_title": "To pander to Hispanics Hillary states some whoppers on Univision",
		"title": "To pander to Hispanics Hillary states some whoppers on Univision",
		"type": "bs",
		"uuid": "fcabf23cf87c727c47464356d5fd6537f19e5226"
	},
	"-KhI_xe2tC7_3eipW1qA": {
		"author": "Bloodydagger",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:55:03.783+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "reply",
				"salience": 0.16357324,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.15410663,
				"type": "WORK_OF_ART"
			},
			{
				"name": "vote",
				"salience": 0.14782229,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.09324115,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.08802203,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.06566388,
				"type": "EVENT"
			},
			{
				"name": "mayhem",
				"salience": 0.06566388,
				"type": "OTHER"
			},
			{
				"name": "f*g ree-tards",
				"salience": 0.025749873,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.02387959,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.022995569,
				"type": "PERSON"
			},
			{
				"name": "idiocy",
				"salience": 0.022995569,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.022995569,
				"type": "WORK_OF_ART"
			},
			{
				"name": "record",
				"salience": 0.019525051,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.019525051,
				"type": "OTHER"
			},
			{
				"name": "b*d'",
				"salience": 0.01866142,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.013891837,
				"type": "OTHER"
			},
			{
				"name": "hypocrisy",
				"salience": 0.012244296,
				"type": "OTHER"
			},
			{
				"name": "k*e",
				"salience": 0.007967204,
				"type": "OTHER"
			},
			{
				"name": "thesungod",
				"salience": 0.006567436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jew",
				"salience": 0.0049084364,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats10.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:55:03.783+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "a reply to: windword Shall I post videos of Hillary laughing at death and mayhem? They are both terrible people. Period end of story. A vote for either one is a vote for idiocy. Hillary was heard calling mentally challenged children 'f*g ree-tards' and caught on record blurting out the terms 'stupid k*e and 'f*ing Jew b*d'. Your hypocrisy is showing again. edit on 26-10-2016 by thesungod because: (no reason given)",
		"thread_title": "Donald Trump and the Disabled Reporter: The whole truth and not the spin put on by the media.",
		"title": "Donald Trump and the Disabled Reporter: The whole truth and not the spin put on by the media.",
		"type": "bs",
		"uuid": "d581178752d1e6792f565e960aef629b273dc6c8"
	},
	"-KhI_xiw3IdSJhn4UJhf": {
		"author": "Xcathdra",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:55:04.507+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "The Above Top Secret",
				"salience": 0.6604545,
				"type": "OTHER"
			},
			{
				"name": "topics",
				"salience": 0.107863545,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.07227189,
				"type": "PERSON"
			},
			{
				"name": "The Above Network, LLC",
				"salience": 0.033263147,
				"type": "ORGANIZATION"
			},
			{
				"name": "content",
				"salience": 0.024887815,
				"type": "OTHER"
			},
			{
				"name": "member contributors",
				"salience": 0.024887815,
				"type": "PERSON"
			},
			{
				"name": "content community",
				"salience": 0.018807884,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.013855878,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.010373902,
				"type": "OTHER"
			},
			{
				"name": "venue",
				"salience": 0.008479037,
				"type": "LOCATION"
			},
			{
				"name": "content copyright",
				"salience": 0.0075688106,
				"type": "OTHER"
			},
			{
				"name": "The Above Network, LLC",
				"salience": 0.005964454,
				"type": "ORGANIZATION"
			},
			{
				"name": "site ownership",
				"salience": 0.005660646,
				"type": "OTHER"
			},
			{
				"name": "agnosticism",
				"salience": 0.005660646,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:37:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.4,
			"score": 0.6
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "new topics The Above Top Secret Web site is a wholly owned social content community of The Above Network, LLC . \nThis content community relies on user-generated content from our member contributors. The opinions of our members are not those of site ownership who maintains strict editorial agnosticism and simply provides a collaborative venue for free expression. \nAll content copyright 2016, The Above Network, LLC.",
		"thread_title": "Rigging the Election - Video IV: $20K Wire Transfer From Belize Returned",
		"title": "Rigging the Election - Video IV: $20K Wire Transfer From Belize Returned",
		"type": "bs",
		"uuid": "d1158e06920f83baa03e7362eebce3722cec4c8e"
	},
	"-KhI_y5RERWMWFLZEoyJ": {
		"author": "gortex",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T02:55:07.358+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.25798035,
				"type": "PERSON"
			},
			{
				"name": "piece",
				"salience": 0.21928999,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.044835854,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.035037365,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.026167259,
				"type": "PERSON"
			},
			{
				"name": "bloke",
				"salience": 0.019696416,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.017784627,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.017154954,
				"type": "PERSON"
			},
			{
				"name": "jacket",
				"salience": 0.016296484,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sign",
				"salience": 0.015416707,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.015416707,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.015416707,
				"type": "OTHER"
			},
			{
				"name": "vandalism",
				"salience": 0.015416707,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.015416707,
				"type": "OTHER"
			},
			{
				"name": "Sledgehammer",
				"salience": 0.015416707,
				"type": "OTHER"
			},
			{
				"name": "Pick page",
				"salience": 0.015416707,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.012525497,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0qjfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood_Walk_of_Fame"
				},
				"name": "Hollywood Walk of Fame",
				"salience": 0.009514119,
				"type": "ORGANIZATION"
			},
			{
				"name": "losers",
				"salience": 0.008154193,
				"type": "PERSON"
			},
			{
				"name": "onlookers",
				"salience": 0.007898678,
				"type": "PERSON"
			},
			{
				"name": "News report",
				"salience": 0.007898678,
				"type": "WORK_OF_ART"
			},
			{
				"name": "group",
				"salience": 0.007898678,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.007898678,
				"type": "OTHER"
			},
			{
				"name": "frustration",
				"salience": 0.007898678,
				"type": "OTHER"
			},
			{
				"name": "helmet",
				"salience": 0.007898678,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "supporter",
				"salience": 0.007864186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d3t7x"
				},
				"name": "Donald",
				"salience": 0.007249614,
				"type": "PERSON"
			},
			{
				"name": "artists",
				"salience": 0.006831583,
				"type": "PERSON"
			},
			{
				"name": "psyop",
				"salience": 0.005954644,
				"type": "PERSON"
			},
			{
				"name": "jacket",
				"salience": 0.003860031,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "jacket",
				"salience": 0.003860031,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "prison",
				"salience": 0.0037608703,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.0037608703,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.0037495114,
				"type": "PERSON"
			},
			{
				"name": "gortex",
				"salience": 0.0032571722,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0032571722,
				"type": "EVENT"
			},
			{
				"name": "link",
				"salience": 0.0030709708,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.0029212674,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.0028844909,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.0028807926,
				"type": "ORGANIZATION"
			},
			{
				"name": "guy",
				"salience": 0.002833488,
				"type": "PERSON"
			},
			{
				"name": "followers",
				"salience": 0.00263784,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.00263784,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.00263784,
				"type": "EVENT"
			},
			{
				"name": "star",
				"salience": 0.0025967562,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0025603534,
				"type": "OTHER"
			},
			{
				"name": "mouth breather",
				"salience": 0.0024031654,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.0023852082,
				"type": "LOCATION"
			},
			{
				"name": "probation",
				"salience": 0.0022843846,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.0022843846,
				"type": "OTHER"
			},
			{
				"name": "IQs",
				"salience": 0.0022843846,
				"type": "OTHER"
			},
			{
				"name": "sumbeyotch",
				"salience": 0.0022843846,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0022843846,
				"type": "OTHER"
			},
			{
				"name": "morons",
				"salience": 0.0022843846,
				"type": "PERSON"
			},
			{
				"name": "sides",
				"salience": 0.0022843846,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.002199164,
				"type": "OTHER"
			},
			{
				"name": "custody",
				"salience": 0.002199164,
				"type": "OTHER"
			},
			{
				"name": "filth",
				"salience": 0.002199164,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.002199164,
				"type": "OTHER"
			},
			{
				"name": "redneck",
				"salience": 0.002199164,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0021537363,
				"type": "EVENT"
			},
			{
				"name": "landslide",
				"salience": 0.0021537363,
				"type": "EVENT"
			},
			{
				"name": "ass clowns",
				"salience": 0.0018650896,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.001821035,
				"type": "PERSON"
			},
			{
				"name": "retard",
				"salience": 0.0017954974,
				"type": "PERSON"
			},
			{
				"name": "thinkig",
				"salience": 0.0017820768,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.0017310029,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0016939692,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0016430388,
				"type": "PERSON"
			},
			{
				"name": "actors",
				"salience": 0.0016090901,
				"type": "PERSON"
			},
			{
				"name": "everybody",
				"salience": 0.0016090901,
				"type": "PERSON"
			},
			{
				"name": "TV show",
				"salience": 0.0016090901,
				"type": "WORK_OF_ART"
			},
			{
				"name": "star",
				"salience": 0.0014132109,
				"type": "PERSON"
			},
			{
				"name": "producer",
				"salience": 0.0013933885,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0013933885,
				"type": "OTHER"
			},
			{
				"name": "narcissists",
				"salience": 0.0013933885,
				"type": "PERSON"
			},
			{
				"name": "ColdWisdom",
				"salience": 0.0013538399,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.0013042518,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05f3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Peace_Prize"
				},
				"name": "Nobel Peace Prize",
				"salience": 0.0013042518,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0012980214,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0012980214,
				"type": "PERSON"
			},
			{
				"name": "stars",
				"salience": 0.001213754,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.0011719955,
				"type": "PERSON"
			},
			{
				"name": "Nobody",
				"salience": 0.0011667612,
				"type": "PERSON"
			},
			{
				"name": "somebody",
				"salience": 0.0010148586,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0010148586,
				"type": "PERSON"
			},
			{
				"name": "thinkig",
				"salience": 0.0009696708,
				"type": "OTHER"
			},
			{
				"name": "TV show",
				"salience": 0.0008755112,
				"type": "WORK_OF_ART"
			},
			{
				"name": "actors",
				"salience": 0.0008755112,
				"type": "PERSON"
			},
			{
				"name": "everybody",
				"salience": 0.0008755112,
				"type": "PERSON"
			},
			{
				"name": "network dude followers",
				"salience": 0.0008755112,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.0008755112,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02pgkkk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Apprentice_(U.S._TV_series)"
				},
				"name": "The Apprentice",
				"salience": 0.0008576636,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.0007213613,
				"type": "LOCATION"
			},
			{
				"name": "stars",
				"salience": 0.00066035,
				"type": "PERSON"
			},
			{
				"name": "AdmireTheDistance",
				"salience": 0.00062462554,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats12.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:18:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Trump's Hollywood Walk of Fame star Destroyed with a Sledgehammer and Pick page: 1 link I guess you could say it a sign of the strength of feeling this election has generated but in the real world it's just a mindless piece of vandalism that achieves nothing. A man wearing high visibility jacket and helmet was filmed taking out his frustration in front of a group of onlookers. News report on the incident. I suppose it made him feel better but it will return before he goes to prison. edit on 26-10-2016 by gortex because: (no reason given) I suppose it made him feel better but it will return before he goes to prison. So he was charged then? You didn't provide a link. edit on 10/26/2016 by ColdWisdom because: (no reason given) You don't think he will be arrested and charged ? He may not be in custody yet but he will be , he will be caught. link pure filth that guy is. I get it...Donald sucks, whatever..cast your vote against him on the 8th. Consider if Obama gets a star, will some dumbass redneck be smashing that up also because he didn't like the politics? morons. followers of the DNC in action. Such peaceful folks. link a reply to: gortex Poor sumbeyotch. The low IQs are always on display on both sides. I hope he just gets probation. This is how sore losers everywhere will react when Trump wins by a landslide. I like how safety-conscious he was by wearing a high visibility jacket, though. This is how sore losers everywhere will react when Trump wins by a landslide. I like how safety-conscious he was by wearing a high visibility jacket, though. If a mouth breather like this is so upset before the election, damn, if Trump does win, how many of these ass clowns will go full retard after the 8th? Thought these stars were for artists like actors. What did Trump get the star for? For this \"not-scripted\" TV show? Is it like with the Nobel Peace Prize, everybody nowadays gets one(thinkig of Obama and the EU...) originally posted by: network dude followers of the DNC in action. Such peaceful folks. No one said he was a DNC supporter He may just be a bloke who hates racist, homophobic, misogynistic narcissists. Thought these stars were for artists like actors. What did Trump get the star for? For this \"not-scripted\" TV show? Is it like with the Nobel Peace Prize, everybody nowadays gets one(thinkig of Obama and the EU...) He got it for his role as producer on The Apprentice. originally posted by: roadgravel It could be a psyop by a Trump supporter. Make people feel for Trump's lost star and therefore vote for him. That's one of the dumbest things I've ever heard. Nobody is going to vote for him just because somebody vandalized his star in Hollywood. edit on 10/26/2016 by AdmireTheDistance because: (no reason given)",
		"thread_title": "Trumps Hollywood Walk of Fame star Destroyed with a Sledgehammer and Pick",
		"title": "Trumps Hollywood Walk of Fame star Destroyed with a Sledgehammer and Pick",
		"type": "bs",
		"uuid": "62647429fb29cd89628638c8c2283cfc8474340d"
	},
	"-KhI_yJqdvpm7DtrQwRA": {
		"author": "ssenerawa",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T03:12:44.568+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03n6jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peter_Griffin"
				},
				"name": "Peter",
				"salience": 0.0919294,
				"type": "PERSON"
			},
			{
				"name": "family guy",
				"salience": 0.09142351,
				"type": "PERSON"
			},
			{
				"name": "nuts",
				"salience": 0.058015157,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.047258347,
				"type": "OTHER"
			},
			{
				"name": "stations",
				"salience": 0.038564704,
				"type": "LOCATION"
			},
			{
				"name": "human heads",
				"salience": 0.03437511,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.03357676,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.029792726,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.029792726,
				"type": "OTHER"
			},
			{
				"name": "chant",
				"salience": 0.029792726,
				"type": "OTHER"
			},
			{
				"name": "weirdness",
				"salience": 0.029792726,
				"type": "OTHER"
			},
			{
				"name": "recorder",
				"salience": 0.029792726,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.022525782,
				"type": "WORK_OF_ART"
			},
			{
				"name": "quagmire",
				"salience": 0.020661395,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.019114524,
				"type": "WORK_OF_ART"
			},
			{
				"name": "time travel",
				"salience": 0.018554525,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.017019622,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.014203615,
				"type": "OTHER"
			},
			{
				"name": "plane",
				"salience": 0.013080334,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.012303221,
				"type": "LOCATION"
			},
			{
				"name": "counsel",
				"salience": 0.0113298735,
				"type": "PERSON"
			},
			{
				"name": "family guy",
				"salience": 0.0110355625,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0110355625,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.010624351,
				"type": "OTHER"
			},
			{
				"name": "family guy",
				"salience": 0.010624351,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.009965742,
				"type": "OTHER"
			},
			{
				"name": "references",
				"salience": 0.009965742,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.008852733,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.008631333,
				"type": "WORK_OF_ART"
			},
			{
				"name": "programming",
				"salience": 0.008631333,
				"type": "OTHER"
			},
			{
				"name": "ramifications",
				"salience": 0.008631333,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.008309552,
				"type": "OTHER"
			},
			{
				"name": "ssenerawa",
				"salience": 0.008309552,
				"type": "PERSON"
			},
			{
				"name": "Lord",
				"salience": 0.008309552,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.008309552,
				"type": "OTHER"
			},
			{
				"name": "headphones",
				"salience": 0.008138019,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "plane",
				"salience": 0.008138019,
				"type": "OTHER"
			},
			{
				"name": "innver voice",
				"salience": 0.007934463,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.007834599,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crap",
				"salience": 0.007047979,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.007047979,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.006785143,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0064016716,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.006158606,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0060810647,
				"type": "PERSON"
			},
			{
				"name": "timelines",
				"salience": 0.005983562,
				"type": "OTHER"
			},
			{
				"name": "timelines",
				"salience": 0.00568784,
				"type": "OTHER"
			},
			{
				"name": "dad",
				"salience": 0.0054703034,
				"type": "PERSON"
			},
			{
				"name": "references",
				"salience": 0.0054592635,
				"type": "OTHER"
			},
			{
				"name": "GoShredAK",
				"salience": 0.0053151106,
				"type": "PERSON"
			},
			{
				"name": "seth macfalane",
				"salience": 0.0052662375,
				"type": "PERSON"
			},
			{
				"name": "tower",
				"salience": 0.0052662375,
				"type": "LOCATION"
			},
			{
				"name": "op",
				"salience": 0.0052662375,
				"type": "OTHER"
			},
			{
				"name": "tv",
				"salience": 0.0052662375,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.003967414,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.003967414,
				"type": "OTHER"
			},
			{
				"name": "Addendum",
				"salience": 0.0038360525,
				"type": "OTHER"
			},
			{
				"name": "experiences",
				"salience": 0.0038360525,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0038360525,
				"type": "OTHER"
			},
			{
				"name": "ALOT",
				"salience": 0.0038360525,
				"type": "OTHER"
			},
			{
				"name": "splitting",
				"salience": 0.0038360525,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.00357104,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0033094776,
				"type": "PERSON"
			},
			{
				"name": "favorites",
				"salience": 0.0028658037,
				"type": "OTHER"
			},
			{
				"name": "spirits",
				"salience": 0.0028658037,
				"type": "OTHER"
			},
			{
				"name": "t.v.",
				"salience": 0.0028658037,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Ghosts",
				"salience": 0.0028658037,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0028658037,
				"type": "OTHER"
			},
			{
				"name": "blood shed",
				"salience": 0.0028658037,
				"type": "OTHER"
			},
			{
				"name": "OneGoal",
				"salience": 0.0023613,
				"type": "OTHER"
			},
			{
				"name": "telelvisions",
				"salience": 0.001763921,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:12:44.568+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Has family guy gone nuts? page: 1 link I was watching and they were singing a weird chant something about patriotic weirdness and barbecued human heads. I just brushed it off then 5 mins later some more weird popped in outta nowhere wtf so I recorder it I have no idea why quagmire took Peter back in time so far or what it's supposed to mean. Why would going back in time cause home to that? Or am I missing something Peter: [demonic voice] I see the six stations of the Lord's order, and they will all burn ! edit on 26-10-2016 by ssenerawa because: (no reason given) link That was kind of weird and random. Were they referencing anything? Probably just typical family guy but they have taken part in predictive programming and subliminal messages I am pretty sure edit on 26-10-2016 by GoShredAK because: (no reason given) Oh family guy... There are a lot of references to: a) time travel and its ramifications including multiple timelines. They even have an episode where time flows backward. b) occultic crap. There is another episode where Peter puts on noise cancelling headphones to \"be alone with my thoughts\". This is all while on a plane, and his \"innver voice\" begins babbling about blood shed and something about the dark counsel or something along those lines. c) Paranormal in general. Ghosts and spirits speaking through telelvisions etc. One of my personal favorites is when Peter talks to the t.v. as if the people on it can \"hear\" him. Ironically enough,the people on tv respond to him. To me, the show is some type of op. With american dad included. Afterall, seth macfalane was set to be on the plane that hit the north tower...talk about a splitting of timelines. Addendum: this show has a lot, and i do mean ALOT of references that resonate with my life and experiences to a very close T. edit on 26-10-2016 by OneGoal because: (no reason given)",
		"thread_title": "Has family guy gone nuts?",
		"title": "Has family guy gone nuts?",
		"type": "bs",
		"uuid": "5057916cc03a32b4122be784780bb6737eaede85"
	},
	"-KhI_yUnBOornCmgtFjY": {
		"author": "Encryptor",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T03:28:37.789+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Human Right",
				"salience": 0.09985193,
				"type": "OTHER"
			},
			{
				"name": "Use",
				"salience": 0.07872191,
				"type": "OTHER"
			},
			{
				"name": "Marijuana",
				"salience": 0.07872191,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "page",
				"salience": 0.06844142,
				"type": "OTHER"
			},
			{
				"name": "consumption",
				"salience": 0.06844142,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.062246576,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.0490165,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Mexican Supreme Court",
				"salience": 0.042207345,
				"type": "ORGANIZATION"
			},
			{
				"name": "human right",
				"salience": 0.042038694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.033600774,
				"type": "LOCATION"
			},
			{
				"name": "cannabis",
				"salience": 0.03298047,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.03298047,
				"type": "OTHER"
			},
			{
				"name": "cannabis",
				"salience": 0.028908594,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "development",
				"salience": 0.02860533,
				"type": "OTHER"
			},
			{
				"name": "cultivation",
				"salience": 0.02860533,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.02860533,
				"type": "PERSON"
			},
			{
				"name": "effects",
				"salience": 0.018073972,
				"type": "OTHER"
			},
			{
				"name": "Freedom",
				"salience": 0.014681921,
				"type": "OTHER"
			},
			{
				"name": "human right",
				"salience": 0.01463775,
				"type": "OTHER"
			},
			{
				"name": "Smoke a Human Right",
				"salience": 0.010451593,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.010309676,
				"type": "OTHER"
			},
			{
				"name": "human body",
				"salience": 0.010309676,
				"type": "OTHER"
			},
			{
				"name": "substances",
				"salience": 0.009556808,
				"type": "OTHER"
			},
			{
				"name": "alcohol",
				"salience": 0.008421814,
				"type": "OTHER"
			},
			{
				"name": "comparison",
				"salience": 0.008421814,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.008421814,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.008421814,
				"type": "OTHER"
			},
			{
				"name": "human right",
				"salience": 0.008396414,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0067922357,
				"type": "OTHER"
			},
			{
				"name": "pain",
				"salience": 0.0062956023,
				"type": "OTHER"
			},
			{
				"name": "neighbors",
				"salience": 0.0062956023,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.005984808,
				"type": "OTHER"
			},
			{
				"name": "marijuana",
				"salience": 0.0052967886,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "miracle plant",
				"salience": 0.0051413127,
				"type": "OTHER"
			},
			{
				"name": "topics",
				"salience": 0.004529794,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0039583244,
				"type": "PERSON"
			},
			{
				"name": "Norther",
				"salience": 0.0038777203,
				"type": "ORGANIZATION"
			},
			{
				"name": "parts",
				"salience": 0.0034280503,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0034280503,
				"type": "LOCATION"
			},
			{
				"name": "cigarettes",
				"salience": 0.0034280503,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Encryptor",
				"salience": 0.0028249281,
				"type": "OTHER"
			},
			{
				"name": "disease",
				"salience": 0.002529077,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0021105763,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:28:37.789+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Mexico Declares Marijuana Use “Human Right” In Supreme Court page: 1 The Mexican Supreme Court ruled by 4 to 1 that banning the consumption and cultivation of cannabis for personal use violates the human right to free development of one’s personality. … … Freedom To Smoke a Human Right. It's about damn time! For a long time now, people have been fighting for the basic human right of being able to consume whatever substances they wish, and do with their personal property (the human body) as they see fit. This is especially true of cannabis, which has a long list of medicinal benefits. In spite of its minor adverse effects (which pale in comparison to alcohol and cigarettes) people in the United States, and other parts of the world, are still being locked up for simply using the “miracle plant” to help combat disease and pain. Mexico, however, often demonized as being backwards by their Norther neighbors, has ruled that smoking marijuana should be a basic human right! edit on 26-10-2016 by Encryptor because: (no reason given) new topics",
		"thread_title": "Mexico Declares Marijuana Use \"Human Right\" In Supreme Court",
		"title": "Mexico Declares Marijuana Use \"Human Right\" In Supreme Court",
		"type": "bs",
		"uuid": "9d16c3ff4e461b9291a64562b289ae0c05b42fbd"
	},
	"-KhI_ye2aWh-U1LtfvGk": {
		"author": "bryan2006",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:41.254+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Craig McCaa",
				"salience": 0.4883471,
				"type": "PERSON"
			},
			{
				"name": "phone interview",
				"salience": 0.0551447,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0qf5p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fairbanks,_Alaska"
				},
				"name": "Fairbanks",
				"salience": 0.053388305,
				"type": "LOCATION"
			},
			{
				"name": "photos",
				"salience": 0.049705844,
				"type": "WORK_OF_ART"
			},
			{
				"name": "link",
				"salience": 0.04614859,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nvbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chena_River"
				},
				"name": "Chena River",
				"salience": 0.042514518,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f4r5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bureau_of_Land_Management"
				},
				"name": "Bureau of Land Management",
				"salience": 0.027970523,
				"type": "ORGANIZATION"
			},
			{
				"name": "bridge",
				"salience": 0.022806678,
				"type": "LOCATION"
			},
			{
				"name": "weather",
				"salience": 0.020761851,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.016871655,
				"type": "WORK_OF_ART"
			},
			{
				"name": "river",
				"salience": 0.01472176,
				"type": "LOCATION"
			},
			{
				"name": "ice",
				"salience": 0.012294046,
				"type": "OTHER"
			},
			{
				"name": "pictures",
				"salience": 0.010653883,
				"type": "WORK_OF_ART"
			},
			{
				"name": "camera",
				"salience": 0.010653883,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "river",
				"salience": 0.010343391,
				"type": "LOCATION"
			},
			{
				"name": "water",
				"salience": 0.008313399,
				"type": "OTHER"
			},
			{
				"name": "ice",
				"salience": 0.008313399,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.007868526,
				"type": "OTHER"
			},
			{
				"name": "snow",
				"salience": 0.0074806698,
				"type": "OTHER"
			},
			{
				"name": "current",
				"salience": 0.00720233,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.00720233,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00720233,
				"type": "OTHER"
			},
			{
				"name": "object",
				"salience": 0.0071118623,
				"type": "OTHER"
			},
			{
				"name": "Speculation",
				"salience": 0.007053936,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gmlg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_Avenue_(Toronto)"
				},
				"name": "University Avenue",
				"salience": 0.0065697916,
				"type": "LOCATION"
			},
			{
				"name": "page",
				"salience": 0.006427722,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0045677847,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ideas",
				"salience": 0.0045677847,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hjy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alaska"
				},
				"name": "Alaska",
				"salience": 0.004276034,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0037648112,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0033283993,
				"type": "OTHER"
			},
			{
				"name": "internet-observers",
				"salience": 0.0033283993,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.0028718647,
				"type": "OTHER"
			},
			{
				"name": "creature",
				"salience": 0.0028718647,
				"type": "OTHER"
			},
			{
				"name": "www.adn.com",
				"salience": 0.0028133807,
				"type": "OTHER"
			},
			{
				"name": "style",
				"salience": 0.0024871167,
				"type": "OTHER"
			},
			{
				"name": "bryan2006",
				"salience": 0.0020495208,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats15.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:41.254+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link At various times of year, Bureau of Land Management Fairbanks District Office Public Affairs Specialist Craig McCaa likes to go down to the Chena River to share photos of changing Fairbanks weather. On Oct. 18, he decided to walk his camera down to the University Avenue bridge that crosses the river to snap a few pictures of ice forming on the water's surface. But instead of finding just snow and ice, McCaa saw a \"strange thing\" moving back and forth in the current of the murky river. \"It never fully revealed itself,\" he said in a phone interview Tuesday. McCaa took a video and posted it to the \"Bureau of Land Management – Alaska\" Facebook page Tuesday afternoon. By evening it had been watched about 20,900 times. Speculation has run rampant on what the creepy object — or creature — swaying in the water might be. This is really wild. What could be this big and swim in this style in Alaska? I'm looking for ideas and don't suggest any bias from this post. www.adn.com... aska-life/2016/10/26/string-sturgeon-or-sea-monster-chena-river-creature-baffles-internet-observers/ edit on 27-10-2016 by bryan2006 because: (no reason given)",
		"thread_title": "Chena River, Fairbanks Alaska. A swimming beast is caught on tape. What is it?",
		"title": "Chena River, Fairbanks Alaska. A swimming beast is caught on tape. What is it?",
		"type": "bs",
		"uuid": "f5991f5fd80bbe10cd342dda7f46f66c01adc1bf"
	},
	"-KhI_ym1f4jurMKOqHG4": {
		"author": "carewemust",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:42.294+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.26220807,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Hussein Obama",
				"salience": 0.16635525,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.11442697,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.08356848,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.039467398,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African American",
				"salience": 0.033386458,
				"type": "PERSON"
			},
			{
				"name": "shame",
				"salience": 0.026593005,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "DEMOCRAT",
				"salience": 0.022972114,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014wm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Don_King_(boxing_promoter)"
				},
				"name": "DON KING",
				"salience": 0.022229053,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.014442256,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.0140540525,
				"type": "OTHER"
			},
			{
				"name": "minions",
				"salience": 0.0140540525,
				"type": "OTHER"
			},
			{
				"name": "NEW DEAL FOR BLACK AMERICA",
				"salience": 0.012527135,
				"type": "WORK_OF_ART"
			},
			{
				"name": "community",
				"salience": 0.012374985,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.00968403,
				"type": "OTHER"
			},
			{
				"name": "community leaders",
				"salience": 0.008918683,
				"type": "PERSON"
			},
			{
				"name": "footsteps",
				"salience": 0.008389146,
				"type": "OTHER"
			},
			{
				"name": "Story",
				"salience": 0.008389146,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.008363844,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.007095589,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.006796102,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cycle",
				"salience": 0.0067658103,
				"type": "OTHER"
			},
			{
				"name": "www.nbcnews.com",
				"salience": 0.0059676776,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.005667144,
				"type": "OTHER"
			},
			{
				"name": "ministers",
				"salience": 0.0055502052,
				"type": "PERSON"
			},
			{
				"name": "community leaders",
				"salience": 0.0055502052,
				"type": "PERSON"
			},
			{
				"name": "church",
				"salience": 0.0055502052,
				"type": "LOCATION"
			},
			{
				"name": "try",
				"salience": 0.0050568124,
				"type": "OTHER"
			},
			{
				"name": "segments",
				"salience": 0.0048070527,
				"type": "OTHER"
			},
			{
				"name": "crowds",
				"salience": 0.004455312,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "DEMOCRATS",
				"salience": 0.0037854398,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.003592145,
				"type": "PERSON"
			},
			{
				"name": "rallies",
				"salience": 0.003592145,
				"type": "EVENT"
			},
			{
				"name": "corner",
				"salience": 0.003592145,
				"type": "OTHER"
			},
			{
				"name": "arm",
				"salience": 0.0035022653,
				"type": "OTHER"
			},
			{
				"name": "churches",
				"salience": 0.0030217299,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.0029601748,
				"type": "LOCATION"
			},
			{
				"name": "ways",
				"salience": 0.002616793,
				"type": "OTHER"
			},
			{
				"name": "youuu",
				"salience": 0.002616793,
				"type": "OTHER"
			},
			{
				"name": "NOTHING",
				"salience": 0.002616793,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.002616793,
				"type": "PERSON"
			},
			{
				"name": "women abusers",
				"salience": 0.002616793,
				"type": "OTHER"
			},
			{
				"name": "Video",
				"salience": 0.0022576458,
				"type": "WORK_OF_ART"
			},
			{
				"name": "guard",
				"salience": 0.001955026,
				"type": "PERSON"
			},
			{
				"name": "reasons",
				"salience": 0.001955026,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/023fb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_F.C."
				},
				"name": "Chelsea",
				"salience": 0.0016108991,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabian",
				"salience": 0.0016108991,
				"type": "LOCATION"
			},
			{
				"name": "CareWeMust",
				"salience": 0.0016108991,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "www.youtube.com",
				"salience": 0.0013897348,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0167xk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Sharpton"
				},
				"name": "Al Sharpton",
				"salience": 0.0012033983,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/040cf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesse_Jackson"
				},
				"name": "Jesse Jackson",
				"salience": 0.0012033983,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05hpy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Association_for_the_Advancement_of_Colored_People"
				},
				"name": "NAACP",
				"salience": 0.0012033983,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kc7r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/C-SPAN"
				},
				"name": "C-Span",
				"salience": 0.0012033983,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:42.294+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Wednesday, October 26, 2016 Today, the amazingly energetic Donald J. Trump promised something that NO DEMOCRAT has cared enough to attempt, in decades. Our next President proposed and detailed a critically important \"NEW DEAL FOR BLACK AMERICA\". Story: www.nbcnews.com... It's a damn shame that Barack Hussein Obama completely ignored the/his Black community after receiving their votes. Now, Hillary Clinton is following in his footsteps.. She's blindly assuming that because she's a Democrat, and was endorsed by Barack Obama, the African American community will \"fall in line\" like good little mindless minions, and cast their 16 million votes for her, like they did for Obama in 2012. This cycle, open-minded Black Americans who refuse to be FOOLED AGAIN, are indeed going to give Donald Trump a try. As you can see from this video of boxing promoter DON KING introducing Donald Trump to a church filled with Black ministers and community leaders in Ohio last month, important segments of the community are tired of being lied to, screwed by, and ignored by, DEMOCRATS that they voted for! Don King Introduces Donald Trump (C-Span Video): www.youtube.com... For obvious reasons, the \"old guard\" community leaders like Jesse Jackson, Al Sharpton, along with the NAACP, are not in Donald Trump's corner. But what's most telling, is that they are not out there at rallies raising Hillary's arm to roaring crowds of supporters either. Probably because they know Hillary is lying when she exclaims, \"I ain't in no ways ever tired of fightin for youuu!\" in Black churches. In 30 years, she's done NOTHING for no one except herself, Chelsea, and Saudi Arabian women abusers. -CareWeMust",
		"thread_title": "DONALD J. TRUMP - Officially Lays Out His NEW DEAL FOR BLACK AMERICA.",
		"title": "DONALD J. TRUMP - Officially Lays Out His NEW DEAL FOR BLACK AMERICA.",
		"type": "bs",
		"uuid": "4223ad1d0f49142d3d3801b6424877086f8e6c05"
	},
	"-KhI_yuOdQlmHVWAA-5E": {
		"author": "Teotihuacan",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:46.815+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "newb",
				"salience": 0.83496916,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.041248504,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01x5g2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jack_Sparrow"
				},
				"name": "Captain Jack",
				"salience": 0.026810188,
				"type": "PERSON"
			},
			{
				"name": "colleagues",
				"salience": 0.021777846,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.018492386,
				"type": "OTHER"
			},
			{
				"name": "weather balloon",
				"salience": 0.015699271,
				"type": "OTHER"
			},
			{
				"name": "lantern",
				"salience": 0.012993605,
				"type": "LOCATION"
			},
			{
				"name": "Captain Jack Spearow",
				"salience": 0.00886542,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.007521733,
				"type": "LOCATION"
			},
			{
				"name": "best",
				"salience": 0.0066507827,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.0049711205,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:46.815+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.3,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "I didn't know which one to do first or rather if I would but I did and not in chronological order either. Hello, My colleagues call me Captain Jack. My name is Jack Fearow and no not Captain Jack Spearow or was that Jack Sparrow? Anyways I'm new here but I'm no newb so don't expect me to believe a weather balloon is a Chinese lantern you know what I mean. Hopefully I reach out and touch a soul or 2 but if not I know I gave it me best. And that's the best I can do till we meet have a helluva bloody day!",
		"thread_title": "Im no bloody wankah",
		"title": "Im no bloody wankah",
		"type": "bs",
		"uuid": "80573537c11a77fee4b9498744ecda241ed5699b"
	},
	"-KhI_z2zFfcQFomrD07u": {
		"author": "Teotihuacan",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:47.272+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0k_f9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Teotihuacan"
				},
				"name": "Teotihuacan",
				"salience": 0.07227657,
				"type": "LOCATION"
			},
			{
				"name": "stones",
				"salience": 0.06275592,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Streaks",
				"salience": 0.06034121,
				"type": "OTHER"
			},
			{
				"name": "Gold",
				"salience": 0.06034121,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.057489377,
				"type": "LOCATION"
			},
			{
				"name": "structures",
				"salience": 0.056773532,
				"type": "LOCATION"
			},
			{
				"name": "king",
				"salience": 0.038637523,
				"type": "PERSON"
			},
			{
				"name": "moon",
				"salience": 0.030561928,
				"type": "LOCATION"
			},
			{
				"name": "shapes",
				"salience": 0.029346162,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.01859239,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03chltv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pumapunku"
				},
				"name": "Puma Punku",
				"salience": 0.016569994,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01xyy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crete"
				},
				"name": "Crete",
				"salience": 0.016569994,
				"type": "LOCATION"
			},
			{
				"name": "kind",
				"salience": 0.015775139,
				"type": "OTHER"
			},
			{
				"name": "Ancient Man",
				"salience": 0.015359516,
				"type": "PERSON"
			},
			{
				"name": "heaven",
				"salience": 0.014286086,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.013261111,
				"type": "OTHER"
			},
			{
				"name": "crescent moon",
				"salience": 0.013112035,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.012805879,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.012805879,
				"type": "OTHER"
			},
			{
				"name": "streaks",
				"salience": 0.012805879,
				"type": "OTHER"
			},
			{
				"name": "plantations",
				"salience": 0.012805879,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.012767239,
				"type": "OTHER"
			},
			{
				"name": "moon",
				"salience": 0.012232562,
				"type": "LOCATION"
			},
			{
				"name": "dependency",
				"salience": 0.011816762,
				"type": "OTHER"
			},
			{
				"name": "Sun and the Moon",
				"salience": 0.011645024,
				"type": "OTHER"
			},
			{
				"name": "moon",
				"salience": 0.011628802,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06m_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sun"
				},
				"name": "Sun",
				"salience": 0.011235309,
				"type": "PERSON"
			},
			{
				"name": "circuitry board",
				"salience": 0.011092197,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wv_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moon"
				},
				"name": "Moon",
				"salience": 0.010878349,
				"type": "LOCATION"
			},
			{
				"name": "absence",
				"salience": 0.010458591,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.009578353,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0089845015,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0089845015,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.008814075,
				"type": "PERSON"
			},
			{
				"name": "moon",
				"salience": 0.008691314,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.008290014,
				"type": "LOCATION"
			},
			{
				"name": "sun",
				"salience": 0.00809437,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.008082675,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.007980955,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.007980955,
				"type": "OTHER"
			},
			{
				"name": "Teotihuacan People",
				"salience": 0.007888697,
				"type": "PERSON"
			},
			{
				"name": "detail",
				"salience": 0.0077813324,
				"type": "OTHER"
			},
			{
				"name": "ocean",
				"salience": 0.0077813324,
				"type": "LOCATION"
			},
			{
				"name": "queen",
				"salience": 0.0077813324,
				"type": "PERSON"
			},
			{
				"name": "both",
				"salience": 0.0077813324,
				"type": "PERSON"
			},
			{
				"name": "life giver",
				"salience": 0.0074912063,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.0073365476,
				"type": "OTHER"
			},
			{
				"name": "species",
				"salience": 0.006353762,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.006353762,
				"type": "EVENT"
			},
			{
				"name": "heart",
				"salience": 0.006353762,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.006353762,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.006353762,
				"type": "OTHER"
			},
			{
				"name": "mother nature",
				"salience": 0.005741295,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0054820124,
				"type": "LOCATION"
			},
			{
				"name": "dots",
				"salience": 0.0053209644,
				"type": "OTHER"
			},
			{
				"name": "crescent moon",
				"salience": 0.0047313585,
				"type": "OTHER"
			},
			{
				"name": "moon",
				"salience": 0.0047313585,
				"type": "LOCATION"
			},
			{
				"name": "advancement",
				"salience": 0.0044558854,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0044225827,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0039933193,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0039933193,
				"type": "OTHER"
			},
			{
				"name": "kingdoms",
				"salience": 0.0039933193,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02vwwj1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sun_and_Moon_(Middle-earth)"
				},
				"name": "Sun and Moon",
				"salience": 0.0036306945,
				"type": "OTHER"
			},
			{
				"name": "bottom",
				"salience": 0.0034580482,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.0034580482,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0034580482,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.003328999,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0033041127,
				"type": "OTHER"
			},
			{
				"name": "god",
				"salience": 0.0031245227,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.0029833396,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0029325979,
				"type": "PERSON"
			},
			{
				"name": "snitch",
				"salience": 0.0027524552,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.002583372,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:47.272+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.3,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Hello, Welcome to Teotihuacan Presenting: Streaks of Gold As you can clearly see this is not Teotihuacan but we are very close to it. With places like Puma Punku that have Quick Crete stones that have these shapes in them... And you can clearly see that Ancient Man were telling us in the future that one day would have our green plantations marked by streaks of gold. Obviously being a circuitry board. Our heaven is dependency on technology! This is Teotihuacan People were inspired to build such large and grandiose structures and attribute them to the Sun and the Moon. But why obviously the sun being a life giver is something to honor. But the Moon is a great question. Night is the absence of the Sun and everything depending on the Sun surely would not want to celebrate it's absence. It must be because the Sun was attributed to a great king who sailed across a mighty ocean much like the sun does the sky. And the moon was attributed to a great queen that did the same. And both of them must have proven with great detail. That not only made you believe past all the great technology they brought with them but also believing in them with your heart and soul. That kind of belief transcends time and it also transcends race and species. Those people knew that the moon was not real proof of this is that they symbolize the moon with the crescent moon. If you pay attention at all the moon like god and everything else on the planet snitches what the truth is no matter how good it is at hiding it. And the crescent moon is a snitch that it can cloak and uncloak. Otherwise why would anyone attribute the night with the moon. You would just mark tiny dots in a sky and point to the day and say absent of the sun. It means that while we are very technologically dependent we are being told to believe through what is natural and what mother nature has intended you to see. Why advancement is necessary it's also good to stay rooted and see that everything from top to bottom no matter how primitive still believes in the same Sun and Moon that all life depend on. And that kind of love builds cities,nations, and galactic kingdoms.",
		"thread_title": "Teotihuacan",
		"title": "Teotihuacan",
		"type": "bs",
		"uuid": "602c315d2b346264b4c47438e509dea5eb5e0d53"
	},
	"-KhI_zFGklwD9m3t7o5K": {
		"author": "Doctor Smith",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:48.384+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.3391346,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.083349,
				"type": "PERSON"
			},
			{
				"name": "computer voting machines",
				"salience": 0.052636843,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "election fraud",
				"salience": 0.047938544,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.038305774,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.033426803,
				"type": "ORGANIZATION"
			},
			{
				"name": "talk",
				"salience": 0.02977256,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.02688804,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.024653124,
				"type": "OTHER"
			},
			{
				"name": "Rumors",
				"salience": 0.024653124,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.022572963,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.015872944,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.015872944,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0b6gkfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream_media"
				},
				"name": "MSM",
				"salience": 0.0152159175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0152159175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0152159175,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0152159175,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.014836464,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010728922,
				"type": "EVENT"
			},
			{
				"name": "stuff",
				"salience": 0.008967224,
				"type": "OTHER"
			},
			{
				"name": "fix",
				"salience": 0.008683346,
				"type": "OTHER"
			},
			{
				"name": "write",
				"salience": 0.008359914,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.007521292,
				"type": "ORGANIZATION"
			},
			{
				"name": "state election laws",
				"salience": 0.0068835206,
				"type": "OTHER"
			},
			{
				"name": "cronies",
				"salience": 0.0068835206,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.0068835206,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0068835206,
				"type": "WORK_OF_ART"
			},
			{
				"name": "criminals",
				"salience": 0.0068390104,
				"type": "PERSON"
			},
			{
				"name": "reply",
				"salience": 0.0068273717,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0067414828,
				"type": "EVENT"
			},
			{
				"name": "movement",
				"salience": 0.0067414828,
				"type": "OTHER"
			},
			{
				"name": "fix",
				"salience": 0.006490232,
				"type": "OTHER"
			},
			{
				"name": "Doctor Smith Intuitively",
				"salience": 0.0062781377,
				"type": "ORGANIZATION"
			},
			{
				"name": "write",
				"salience": 0.006248326,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0050380393,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qh39",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elizabeth_Warren"
				},
				"name": "Elizabeth Warren",
				"salience": 0.004403632,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.004403632,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0042393953,
				"type": "ORGANIZATION"
			},
			{
				"name": "Stein",
				"salience": 0.0041518463,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0038334853,
				"type": "PERSON"
			},
			{
				"name": "topics",
				"salience": 0.0031784524,
				"type": "OTHER"
			},
			{
				"name": "dollar question",
				"salience": 0.0030598657,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0027422193,
				"type": "EVENT"
			},
			{
				"name": "reply",
				"salience": 0.0027422193,
				"type": "OTHER"
			},
			{
				"name": "Stein Vote",
				"salience": 0.0026863422,
				"type": "OTHER"
			},
			{
				"name": "Pee Wee Herman",
				"salience": 0.0026863422,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0023746463,
				"type": "PERSON"
			},
			{
				"name": "Doctor Smith",
				"salience": 0.002175248,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abraham_Lincoln"
				},
				"name": "Abraham Lincoln",
				"salience": 0.002084714,
				"type": "PERSON"
			},
			{
				"name": "SaturnFX",
				"salience": 0.0014616917,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:48.384+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Hillary Clinton's election fraud finally exposed. California stolen from Bernie Sanders! page: 1 link With all the talk from MSM of Russians interfering with US elections. Rumors of Soros owning new computer voting machines that can easily be programed to steal election. If you don't think that the DNC won't steal an election if they can. Think again. a reply to: Doctor Smith Intuitively, we all know that Hillary is capable of attempting to steal an election. Your video, combined with the many e-mails provided by WikiLeaks, confirms that she does indeed have an army of cronies out there breaking federal and state election laws, to not only cheat Bernie Sanders, but to get her into the White House again too. Hillary is indeed a Nasty Woman, just as Elizabeth Warren confirmed this past Monday. link This is the stuff that needs a independent investigation launched pronto. If it is found out 100% it is a fix, what then? I guess there could be a sweeping write in movement for Bernie..or just vote for Stein a reply to: Doctor Smith Now the million dollar question is what are \"we\" the people going to do about it ? originally posted by: SaturnFX This is the stuff that needs a independent investigation launched pronto. If it is found out 100% it is a fix, what then? I guess there could be a sweeping write in movement for Bernie..or just vote for Stein Vote for Pee Wee Herman if you want. Just don't vote those Clinton criminals in again. But if you really want to stop her, you have to vote for Trump. Compared to Hillary, Trump is Honest Abraham Lincoln. new topics",
		"thread_title": "Hillary Clintons election fraud finally exposed. California stolen from Bernie Sanders!",
		"title": "Hillary Clintons election fraud finally exposed. California stolen from Bernie Sanders!",
		"type": "bs",
		"uuid": "69851ee9245122d59905e6075036999ba0cd82ee"
	},
	"-KhI_zRcHYiNB05jiAhn": {
		"author": "Kashai",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:48.830+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "transportation system",
				"salience": 0.13641629,
				"type": "OTHER"
			},
			{
				"name": "investors",
				"salience": 0.054469217,
				"type": "PERSON"
			},
			{
				"name": "investors",
				"salience": 0.054469217,
				"type": "PERSON"
			},
			{
				"name": "investment",
				"salience": 0.052463543,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.049647875,
				"type": "OTHER"
			},
			{
				"name": "Kashai Hyperloop",
				"salience": 0.038874842,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.03704319,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.03704319,
				"type": "OTHER"
			},
			{
				"name": "tract",
				"salience": 0.03704319,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.02197442,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.016537663,
				"type": "OTHER"
			},
			{
				"name": "Hyperloop One",
				"salience": 0.016203731,
				"type": "PERSON"
			},
			{
				"name": "chamber",
				"salience": 0.015231538,
				"type": "ORGANIZATION"
			},
			{
				"name": "cutting edge levitation systems",
				"salience": 0.015118051,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.010069944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m09kzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hyperloop"
				},
				"name": "Hyperloop",
				"salience": 0.009245729,
				"type": "OTHER"
			},
			{
				"name": "company document",
				"salience": 0.009053527,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cost",
				"salience": 0.009053527,
				"type": "OTHER"
			},
			{
				"name": "investment document",
				"salience": 0.009053527,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Levitation Rig",
				"salience": 0.007876737,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.007841612,
				"type": "OTHER"
			},
			{
				"name": "projects",
				"salience": 0.007841612,
				"type": "OTHER"
			},
			{
				"name": "funding round",
				"salience": 0.007841612,
				"type": "EVENT"
			},
			{
				"name": "predictions",
				"salience": 0.007841612,
				"type": "OTHER"
			},
			{
				"name": "architect",
				"salience": 0.007841612,
				"type": "PERSON"
			},
			{
				"name": "concept",
				"salience": 0.007841612,
				"type": "OTHER"
			},
			{
				"name": "billionaire tech industrialist",
				"salience": 0.007841612,
				"type": "PERSON"
			},
			{
				"name": "financing",
				"salience": 0.007841612,
				"type": "OTHER"
			},
			{
				"name": "tens",
				"salience": 0.007841612,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.007841612,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.007817935,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.006736211,
				"type": "OTHER"
			},
			{
				"name": "Hyperloop One",
				"salience": 0.006683957,
				"type": "OTHER"
			},
			{
				"name": "rotor",
				"salience": 0.00665144,
				"type": "OTHER"
			},
			{
				"name": "test stand",
				"salience": 0.00651414,
				"type": "LOCATION"
			},
			{
				"name": "use",
				"salience": 0.006351208,
				"type": "OTHER"
			},
			{
				"name": "speeds",
				"salience": 0.006351208,
				"type": "OTHER"
			},
			{
				"name": "surface speeds",
				"salience": 0.006351208,
				"type": "OTHER"
			},
			{
				"name": "test stand",
				"salience": 0.0061144065,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "link",
				"salience": 0.0061144065,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.005786393,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Hyperpod",
				"salience": 0.0057749045,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0057431716,
				"type": "OTHER"
			},
			{
				"name": "excess",
				"salience": 0.005500495,
				"type": "OTHER"
			},
			{
				"name": "pressures",
				"salience": 0.005500495,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.005500495,
				"type": "OTHER"
			},
			{
				"name": "plastic",
				"salience": 0.005328177,
				"type": "OTHER"
			},
			{
				"name": "passengers",
				"salience": 0.005295367,
				"type": "PERSON"
			},
			{
				"name": "spartandhp",
				"salience": 0.005295367,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.005295367,
				"type": "ORGANIZATION"
			},
			{
				"name": "freight",
				"salience": 0.005295367,
				"type": "OTHER"
			},
			{
				"name": "Feedback",
				"salience": 0.005228703,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00518602,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0050270488,
				"type": "ORGANIZATION"
			},
			{
				"name": "tech",
				"salience": 0.004955304,
				"type": "OTHER"
			},
			{
				"name": "Elon Musk. www.msn.com",
				"salience": 0.0048293397,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01r2lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Forbes"
				},
				"name": "Forbes",
				"salience": 0.0048293397,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0046449234,
				"type": "PERSON"
			},
			{
				"name": "analogies",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "doubt errors",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "optimizations",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "advance",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "jargon",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "formulas",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "minimum",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.004491191,
				"type": "OTHER"
			},
			{
				"name": "herring",
				"salience": 0.0041623693,
				"type": "OTHER"
			},
			{
				"name": "Hyperloop Levitation Rig",
				"salience": 0.0037649535,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.0037610445,
				"type": "OTHER"
			},
			{
				"name": "pencil eraser",
				"salience": 0.0037136772,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02hzl8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Introduction_(music)"
				},
				"name": "Intro",
				"salience": 0.0033867229,
				"type": "ORGANIZATION"
			},
			{
				"name": "mishap",
				"salience": 0.003355575,
				"type": "EVENT"
			},
			{
				"name": "ethenol",
				"salience": 0.003355575,
				"type": "OTHER"
			},
			{
				"name": "sorts",
				"salience": 0.003355575,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.003189678,
				"type": "OTHER"
			},
			{
				"name": "Money",
				"salience": 0.0031495003,
				"type": "OTHER"
			},
			{
				"name": "mistake",
				"salience": 0.002774513,
				"type": "OTHER"
			},
			{
				"name": "transportation technology",
				"salience": 0.0026968701,
				"type": "OTHER"
			},
			{
				"name": "BS",
				"salience": 0.002604098,
				"type": "OTHER"
			},
			{
				"name": "invention wins",
				"salience": 0.0024441434,
				"type": "EVENT"
			},
			{
				"name": "materials",
				"salience": 0.0024441434,
				"type": "OTHER"
			},
			{
				"name": "Labor",
				"salience": 0.0024441434,
				"type": "ORGANIZATION"
			},
			{
				"name": "space",
				"salience": 0.0024441434,
				"type": "OTHER"
			},
			{
				"name": "polymer",
				"salience": 0.0024441434,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0024441434,
				"type": "OTHER"
			},
			{
				"name": "compadres",
				"salience": 0.002305909,
				"type": "OTHER"
			},
			{
				"name": "vids",
				"salience": 0.0018966768,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0018258792,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0018258792,
				"type": "OTHER"
			},
			{
				"name": "Engineer",
				"salience": 0.0018258792,
				"type": "PERSON"
			},
			{
				"name": "PDF",
				"salience": 0.0018258792,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.0016028982,
				"type": "ORGANIZATION"
			},
			{
				"name": "@spacex.com",
				"salience": 0.0012978339,
				"type": "PERSON"
			},
			{
				"name": "@teslamotors.com",
				"salience": 0.0011237919,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.0011237919,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:48.830+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link originally posted by: Kashai Hyperloop one is a about a transportation system that is really fast and technologically feasible to the extent that in relation to investors, easily Is on the fast tract to half a billion from investors in the not to distant future. Despite announcing a $50 million investment in mid-October, Hyperloop One plans to raise as much as $250 million in its next funding round early next year and is already seeking tens of millions in new financing, according to an investment document obtained by Forbes. Meanwhile, according to another company document, internal estimates of the cost of Hyperloop One projects could greatly exceed predictions from the concept’s architect, billionaire tech industrialist Elon Musk. www.msn.com... li=BBmkt5R&ocid=spartandhp As offered in this link by 2021 we will be carrying freight and passengers with this technology. In so far as what this technology is.... Levitation Rig The Hyperloop Levitation Rig is another unique test stand designed, fabricated and built by the Hyperloop team. This test stand is housed in an 18 cubic meter environmental chamber that is capable of achieving pressures down to 1/1000 of atmospheric. The rotor achieves surface speeds in excess of 300 m/s. These speeds are necessary to simulate Hyperloop’s cutting edge levitation systems that will be adapted for use on the Hyperpod. hyperloop-one.com... Intro The first several pages will attempt to describe the design in everyday language, keeping numbers to a minimum and avoiding formulas and jargon. I apologize in advance for my loose use of language and imperfect analogies. The second section is for those with a technical background. There are no doubt errors of various kinds and superior optimizations for elements of the system. Feedback would be most welcome – please send to hyperloop@spacex.com or hyperloop@teslamotors.com. I would like to thank my excellent compadres at both companies for their help in putting this together.PDF Now I am not an Engineer but clearly this seems a step forward in transportation technology. I have seen a couple YouTube vids debunking this.. Or at least pointing out how hard it will be to actually pull it off..and it not kill every one at the slightest mishap... Kinda like ethenol, it might be a red herring of sorts.. That said ANY time you try and create new tech some good comes out of it. Every mistake could invent something you weren't even trying for... Take NASA for example..EVERY single day we use some plastic or polymer that didn't work for space, but made a really good pencil eraser.. Money is fake...just some BS we tell ourselves. Labor, materials and KNOW how are all that matter. So IMHO reguardless or cost invention wins.",
		"thread_title": "Hyperloop One",
		"title": "Hyperloop One",
		"type": "bs",
		"uuid": "e7f055d70484312e94bcd39bf6640c75c9a7ac47"
	},
	"-KhI_zYgkQbZna3w1gDc": {
		"author": "Jdennis10",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:49.020+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "earth",
				"salience": 0.5394347,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.06952913,
				"type": "LOCATION"
			},
			{
				"name": "thoughts",
				"salience": 0.054609057,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.054609057,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.054609057,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.053194333,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.029331675,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.0287013,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.01624151,
				"type": "PERSON"
			},
			{
				"name": "human race",
				"salience": 0.015642341,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.01532274,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.013288557,
				"type": "OTHER"
			},
			{
				"name": "Life",
				"salience": 0.012702438,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.009951505,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.009274887,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.007262015,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0054319017,
				"type": "OTHER"
			},
			{
				"name": "beer Seeping",
				"salience": 0.0054319017,
				"type": "OTHER"
			},
			{
				"name": "rowing",
				"salience": 0.0054319017,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats10.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:49.020+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "All this time of thoughts and reason Now this country is full of treason This earth goes up It also goes down Mostly this life feels hellbound Do we question this crazy human race On this long crazy day please engulf me with mace Time was this and that was now Come on humans show us how All we want is to deal with time One of you can not even blow my mind This way that way which is clear Double the facts and I will drink beer Seeping peeping on the line Throwing rowing in due time Life is full of different ways To you all please have a great day This is about the struggle in life and we can all overcome this by being happy.",
		"thread_title": "Time does nothing",
		"title": "Time does nothing",
		"type": "bs",
		"uuid": "9e574b11f39f12d13054afb7f7074defa568eaee"
	},
	"-KhI_zio2VoeP8RgWhU0": {
		"author": "JinMI",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:49.337+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "link",
				"salience": 0.12193198,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.12095317,
				"type": "OTHER"
			},
			{
				"name": "Lots",
				"salience": 0.104981616,
				"type": "OTHER"
			},
			{
				"name": "JinMI",
				"salience": 0.06499232,
				"type": "OTHER"
			},
			{
				"name": "platitudes",
				"salience": 0.05400377,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.05400377,
				"type": "OTHER"
			},
			{
				"name": "Joe Blow",
				"salience": 0.026900114,
				"type": "PERSON"
			},
			{
				"name": "discussions",
				"salience": 0.025770519,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.024517074,
				"type": "OTHER"
			},
			{
				"name": "arguments",
				"salience": 0.022325087,
				"type": "OTHER"
			},
			{
				"name": "debates",
				"salience": 0.022325087,
				"type": "OTHER"
			},
			{
				"name": "third party vote",
				"salience": 0.020281289,
				"type": "OTHER"
			},
			{
				"name": "standing",
				"salience": 0.019425524,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.018086128,
				"type": "OTHER"
			},
			{
				"name": "party system",
				"salience": 0.018086128,
				"type": "OTHER"
			},
			{
				"name": "charade",
				"salience": 0.01755558,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.016356202,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.015665669,
				"type": "OTHER"
			},
			{
				"name": "rebel",
				"salience": 0.015665669,
				"type": "OTHER"
			},
			{
				"name": "disapproval",
				"salience": 0.015665669,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.015665669,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.015665669,
				"type": "OTHER"
			},
			{
				"name": "apathy",
				"salience": 0.015564389,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.01508194,
				"type": "PERSON"
			},
			{
				"name": "conversation",
				"salience": 0.01508194,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.013629267,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.012793147,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.008906193,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.007878215,
				"type": "PERSON"
			},
			{
				"name": "Anything",
				"salience": 0.0069643725,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0069643725,
				"type": "OTHER"
			},
			{
				"name": "Drumf",
				"salience": 0.005886135,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.005886135,
				"type": "PERSON"
			},
			{
				"name": "Shillary",
				"salience": 0.005886135,
				"type": "OTHER"
			},
			{
				"name": "Stein",
				"salience": 0.005886135,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Johnson",
				"salience": 0.005886135,
				"type": "PERSON"
			},
			{
				"name": "contribution",
				"salience": 0.0055436613,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0052031875,
				"type": "OTHER"
			},
			{
				"name": "stake",
				"salience": 0.0052031875,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.0042873356,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/054yc0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cannabis_(drug)"
				},
				"name": "Cannabis",
				"salience": 0.0042873356,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.0042873356,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/060c4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President"
				},
				"name": "Presidency",
				"salience": 0.004096464,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.003973276,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats18.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:49.337+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link originally posted by: JinMI Lots of discussion over the past months. Who we're for or who we're against and platitudes of statements...some not so much. Whomever you decide to give your vote to honestly does not concern me nor should mine concern you. The debates, arguments and discussions are fun and generally informative. Vote for who you would, even if it takes a few hours. I've seen quite a bit of conversation of folks not wanting to vote at all. What does this prove? What is this standing (sitting) against? Your disapproval of the two party system or maybe you think the whole thing a charade? My opinion would leave me to believe that if your going to attempt to rebel against the system it would be a secure third party vote or a vote for the future so to speak. We as Americans need to take back our power over Government. There is more than just the Presidency at stake and to me I would think that not voting at all is a contribution to the apathy that has us in the situation we are in. Whether it be Trump or Drumf or Hillary or Shillary or Stein or Johnson or Joe Blow, I would urge you to vote! If you are not voting at all, would you please elaborate as to why? I'm trying to imagine the next president of the USA being Joe Blow. Well now President Blow, what do you think of the Cannabis trade with Mexico? Anything to declare?",
		"thread_title": "Vote Vote Vote",
		"title": "Vote Vote Vote",
		"type": "bs",
		"uuid": "9838e9c4403efdde00da32169f2d71221c736492"
	},
	"-KhI_zqJPYoRxz54FagG": {
		"author": "theantediluvian",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:49.682+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Reporter",
				"salience": 0.16750912,
				"type": "PERSON"
			},
			{
				"name": "Jesse Benton",
				"salience": 0.14806926,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.13677025,
				"type": "PERSON"
			},
			{
				"name": "pieces",
				"salience": 0.07834358,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.07834358,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.06833766,
				"type": "PERSON"
			},
			{
				"name": "suprises",
				"salience": 0.0546026,
				"type": "EVENT"
			},
			{
				"name": "funds",
				"salience": 0.035884935,
				"type": "OTHER"
			},
			{
				"name": "moms",
				"salience": 0.025232868,
				"type": "PERSON"
			},
			{
				"name": "transcript",
				"salience": 0.024764456,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0179qd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Telegraph"
				},
				"name": "Telegraph",
				"salience": 0.020687375,
				"type": "ORGANIZATION"
			},
			{
				"name": "voter suppression",
				"salience": 0.019330978,
				"type": "EVENT"
			},
			{
				"name": "anywhere",
				"salience": 0.01675026,
				"type": "LOCATION"
			},
			{
				"name": "camera",
				"salience": 0.01675026,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.015539141,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.013175855,
				"type": "PERSON"
			},
			{
				"name": "taste",
				"salience": 0.012526223,
				"type": "OTHER"
			},
			{
				"name": "voter suppression campaign",
				"salience": 0.012368865,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.011758888,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.009604532,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.0069752987,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.005230537,
				"type": "EVENT"
			},
			{
				"name": "bit",
				"salience": 0.005230537,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.005230537,
				"type": "EVENT"
			},
			{
				"name": "cloaer",
				"salience": 0.005230537,
				"type": "OTHER"
			},
			{
				"name": "negative",
				"salience": 0.003908263,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "wI",
				"salience": 0.0018435938,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:42:49.682+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link originally posted by: theantediluvian It looks like everyone is releasing their October suprises in pieces, including the Telegraph . Now we have Jesse Benton admitting to voter suppression on a hidden camera. Here's the transcript: Benton: We're doing pretty well ahhh but we don't have anywhere near the funds that Hillary's groups do so we really have to be surgical Benton: So we have a voter suppression campaign — quite frankly — targeting African Americans , and uh, and sort of, suburban moms , just bad stuff about Hillary, just trying to take their taste for her away. Female Reporter: I see, so that they don't turn out. Benton: Yeah just keep them — just try to drop her turn out two or three points Basically if they put out enough negative adds about how she hasn't supported blacks and there causes they will make it less likely they will vote for her. Realistically speaking they aren't going to votell republican and they know that. So the best they can hope for is make them mad enough at her not to vote. But looking at early voting they may have switched more than they thought and instead of bit voting they are voting trump wI'll see as election. Gets cloaer.",
		"thread_title": "BUSTED! Pro-Trump PAC Rep Admits To Voter Suppression Campaign Targeting Blacks, Suburban Mothers",
		"title": "BUSTED! Pro-Trump PAC Rep Admits To Voter Suppression Campaign Targeting Blacks, Suburban Mothers",
		"type": "bs",
		"uuid": "0d526c456ad18365ca4929c2045447b59cfa109a"
	},
	"-KhI_zxSTh3rRJNPv4st": {
		"author": "Violater1",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:49.940+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "vote",
				"salience": 0.1728017,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.1728017,
				"type": "OTHER"
			},
			{
				"name": "Violater1",
				"salience": 0.108047985,
				"type": "OTHER"
			},
			{
				"name": "ROFL Damm",
				"salience": 0.10468241,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.087261505,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.08098905,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.03751499,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.03367179,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.03367179,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.032424018,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.030424442,
				"type": "LOCATION"
			},
			{
				"name": "changes",
				"salience": 0.0253901,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.021549456,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.018602436,
				"type": "OTHER"
			},
			{
				"name": "representative",
				"salience": 0.017607141,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.015322092,
				"type": "OTHER"
			},
			{
				"name": "Isurrender73",
				"salience": 0.0072374074,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:14:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "a reply to: Violater1 She wants your vote. And she will say anything to get it. She changes her mind as fast as public opinion changes. ROFL Damm - If we could get someone in office who would change their opinion to public opinion AND FOLLOW THROUGH, they would be my hero. They spend all their money finding out what we want, then they lie. Why can't we just get a representative in office? edit on 26-10-2016 by Isurrender73 because: (no reason given)",
		"thread_title": "Hillary Clinton Wants a Strong Russia. Wait, what did she say?",
		"title": "Hillary Clinton Wants a Strong Russia. Wait, what did she say?",
		"type": "bs",
		"uuid": "4886706731d0990f4b9ecf8a5038e7678c943f24"
	},
	"-KhIa-AlAZPWPSa0_h-N": {
		"author": "carewemust",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:50.126+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05d5nvn"
				},
				"name": "Max",
				"salience": 0.25330496,
				"type": "PERSON"
			},
			{
				"name": "eye",
				"salience": 0.23546027,
				"type": "OTHER"
			},
			{
				"name": "vomit",
				"salience": 0.09241354,
				"type": "OTHER"
			},
			{
				"name": "charcoal",
				"salience": 0.05469285,
				"type": "OTHER"
			},
			{
				"name": "liquid",
				"salience": 0.052928664,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.045987234,
				"type": "OTHER"
			},
			{
				"name": "coffee grounds",
				"salience": 0.023734972,
				"type": "OTHER"
			},
			{
				"name": "internally",
				"salience": 0.023734972,
				"type": "OTHER"
			},
			{
				"name": "Vanessa",
				"salience": 0.022797104,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.015366847,
				"type": "PERSON"
			},
			{
				"name": "Spiers",
				"salience": 0.013859892,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.011347174,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.009832307,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cemetery",
				"salience": 0.009832307,
				"type": "LOCATION"
			},
			{
				"name": "mother",
				"salience": 0.009832307,
				"type": "PERSON"
			},
			{
				"name": "inquest",
				"salience": 0.008556916,
				"type": "OTHER"
			},
			{
				"name": "examination",
				"salience": 0.008556916,
				"type": "EVENT"
			},
			{
				"name": "result",
				"salience": 0.007967611,
				"type": "OTHER"
			},
			{
				"name": "bolding",
				"salience": 0.0076370114,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.0075259055,
				"type": "OTHER"
			},
			{
				"name": "pathologist",
				"salience": 0.0066454588,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.0066454588,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.0066454588,
				"type": "LOCATION"
			},
			{
				"name": "body",
				"salience": 0.0066454588,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.006508477,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cy07",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canterbury"
				},
				"name": "Canterbury",
				"salience": 0.006061583,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox news",
				"salience": 0.006061583,
				"type": "ORGANIZATION"
			},
			{
				"name": "HeatStreet",
				"salience": 0.006061583,
				"type": "LOCATION"
			},
			{
				"name": "injuries",
				"salience": 0.005637806,
				"type": "OTHER"
			},
			{
				"name": "toxicology tests",
				"salience": 0.005637806,
				"type": "OTHER"
			},
			{
				"name": "post-mortem",
				"salience": 0.005637806,
				"type": "EVENT"
			},
			{
				"name": "self-treat",
				"salience": 0.0042139045,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048kw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kent"
				},
				"name": "Kent",
				"salience": 0.004094461,
				"type": "LOCATION"
			},
			{
				"name": "liquid",
				"salience": 0.003545139,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.002294128,
				"type": "PERSON"
			},
			{
				"name": "poisoning",
				"salience": 0.002294128,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T08:37:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link a reply to: carewemust \"Vomiting black liquid\" caught my eye. I know bleeding internally can cause black vomit, sometimes it looks like coffee grounds. But something in the HeatStreet article that Fox news linked too also caught my eye: Max was buried in Canterbury cemetery after his mother arranged to have his body flown home a week after his death. A post-mortem examination was carried out by a pathologist in east Kent, but Vanessa says that more than two months later she still does not know the result, or whether there will be an inquest. She added: “Apparently, he had not suffered any obvious physical injuries but he could have been slowly poisoned, which is why the results of toxicology tests from his post-mortem are so important. [bolding by me] Activated charcoal -- which is black and readily available to anyone -- is used to treat poisoning, and could cause black vomit also. Could Spiers have suspected he was being poisoned and tried to self-treat with activated charcoal? I can't find much more about the black vomit... as in if someone was with him before/during/after he vomited the black liquid... or if it was found at the same time as he was found dead.",
		"thread_title": "UFO Investigator - MAX SPIERS - Found Dead After Vomiting Black Liquid.",
		"title": "UFO Investigator - MAX SPIERS - Found Dead After Vomiting Black Liquid.",
		"type": "bs",
		"uuid": "5d643d8795edb9197cd7aea4187b8a4d84e794e9"
	},
	"-KhIa-Im04Z1ph-r4nPK": {
		"author": "Profusion",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:50.367+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Nutinbutayahoo",
				"salience": 0.22745515,
				"type": "PERSON"
			},
			{
				"name": "TM OverLords",
				"salience": 0.13173768,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.12792443,
				"type": "PERSON"
			},
			{
				"name": "Russkies",
				"salience": 0.070814624,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.06954367,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03hm3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Head_of_state"
				},
				"name": "Head of State",
				"salience": 0.054761905,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghans",
				"salience": 0.048647,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.043217327,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.022233518,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.014905895,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.014056898,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.011290632,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.010870654,
				"type": "OTHER"
			},
			{
				"name": "script",
				"salience": 0.0104662385,
				"type": "WORK_OF_ART"
			},
			{
				"name": "show",
				"salience": 0.0104662385,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tickets",
				"salience": 0.0104662385,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0100768125,
				"type": "OTHER"
			},
			{
				"name": "ALL",
				"salience": 0.009501904,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.009191825,
				"type": "LOCATION"
			},
			{
				"name": "bunch",
				"salience": 0.0085494565,
				"type": "OTHER"
			},
			{
				"name": "uranium",
				"salience": 0.0085494565,
				"type": "OTHER"
			},
			{
				"name": "Russkies",
				"salience": 0.0083503695,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0067343493,
				"type": "PERSON"
			},
			{
				"name": "CatsTM Good",
				"salience": 0.006450044,
				"type": "OTHER"
			},
			{
				"name": "dots",
				"salience": 0.006390808,
				"type": "OTHER"
			},
			{
				"name": "et al",
				"salience": 0.0061316025,
				"type": "PERSON"
			},
			{
				"name": "definition",
				"salience": 0.0060752844,
				"type": "OTHER"
			},
			{
				"name": "evils",
				"salience": 0.0053768065,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.0053768065,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.005352826,
				"type": "OTHER"
			},
			{
				"name": "lesser",
				"salience": 0.004656778,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.004656778,
				"type": "OTHER"
			},
			{
				"name": "hacking",
				"salience": 0.0034797362,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.0034797362,
				"type": "OTHER"
			},
			{
				"name": "BALL OF WAX",
				"salience": 0.002760514,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T08:06:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link She and Nutinbutayahoo have been wanting Syria and their resources since She was the Head of State. Their Zionist™ OverLords really want that entire area and all they can extract from it, per usual.. You mean the Afghans who the US et al trained and then armed to fight 'The Russkies'? That is par for the course. Why change the script if the show still sells tickets? See: Cats™ Good thing these heinous Russkies weren't this volatile when Hillary sold them a bunch of uranium, I don't watch the news, did She apologize to the Russians for accusing them of the hacking of Her measly secured e-mails? If You can't see that the WHOLE BALL OF WAX is crooked, You are not \"looking\" Sure You might be reading the words but You're not connecting the dots. ALL of it is bent, there is NO 'lesser of 2 evils' when both choices are the definition of evil.",
		"thread_title": "Trump: Hillary Clintons policy for Syria would lead to world war three",
		"title": "Trump: Hillary Clintons policy for Syria would lead to world war three",
		"type": "bs",
		"uuid": "59c25f1c37896d41b27d00f4a223e6a5d0856190"
	},
	"-KhIa-RxCeCAe0g6yXWo": {
		"author": "ghostrager",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:42:51.628+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "YouTubers",
				"salience": 0.47504756,
				"type": "PERSON"
			},
			{
				"name": "reply",
				"salience": 0.20346923,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.08579633,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.060071077,
				"type": "PERSON"
			},
			{
				"name": "internet",
				"salience": 0.03104865,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.03104865,
				"type": "PERSON"
			},
			{
				"name": "perception",
				"salience": 0.02537389,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.018976916,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.013833538,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.013833538,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.013833538,
				"type": "OTHER"
			},
			{
				"name": "secrets",
				"salience": 0.013833538,
				"type": "OTHER"
			},
			{
				"name": "deceptions",
				"salience": 0.013833538,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T07:31:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link a reply to: ghostrager Two YouTubers I know of, I'm not mentioning who they are, have been promoting the notion he's dead. It didn't ring true for me because if he was I believe it would be known by all very quickly via the internet. He has close friends and family who I doubt would want it to be kept secret. That's my perception anyway. He really is isolated as I've mentioned before. I hope he makes it through. He's brilliant and has done a great service for regular people in a frightful world based upon lies, ugly secrets and deceptions.",
		"thread_title": "Julian Assange Surfaces - Speaks at Argentina Conference Via Telephone",
		"title": "Julian Assange Surfaces - Speaks at Argentina Conference Via Telephone",
		"type": "bs",
		"uuid": "e93b4a5fb9de606d8ca0c5f7e4a9856665b946e3"
	},
	"-KhIa-gKx0ca8P9EGboJ": {
		"author": "frenchfries",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:15:29.892+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027g4yj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mr_Smith_(The_Sarah_Jane_Adventures)"
				},
				"name": "Smith",
				"salience": 0.7559499,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027dvv2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Main_Street_(Vancouver)"
				},
				"name": "Main",
				"salience": 0.06037894,
				"type": "PERSON"
			},
			{
				"name": "The Main",
				"salience": 0.032437038,
				"type": "LOCATION"
			},
			{
				"name": "Mr",
				"salience": 0.025667405,
				"type": "PERSON"
			},
			{
				"name": "Mr",
				"salience": 0.0120000765,
				"type": "PERSON"
			},
			{
				"name": "Mistakes",
				"salience": 0.0112082,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.010579441,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.009119706,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.006620847,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01hw2r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hyperborea"
				},
				"name": "Hyperborea",
				"salience": 0.0052666147,
				"type": "OTHER"
			},
			{
				"name": "controller",
				"salience": 0.004912728,
				"type": "OTHER"
			},
			{
				"name": "strings",
				"salience": 0.004799565,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0044956175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027dvv2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Main_Street_(Vancouver)"
				},
				"name": "Main",
				"salience": 0.0033599914,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0032054263,
				"type": "PERSON"
			},
			{
				"name": "Eons",
				"salience": 0.0026260398,
				"type": "PERSON"
			},
			{
				"name": "Hyperboreans",
				"salience": 0.0025058356,
				"type": "OTHER"
			},
			{
				"name": "pill",
				"salience": 0.0024565686,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "voice",
				"salience": 0.0019453813,
				"type": "OTHER"
			},
			{
				"name": "controllers",
				"salience": 0.0014012563,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0013378389,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.0012622351,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0012189852,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0012189852,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0012189852,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0012189852,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0011690233,
				"type": "PERSON"
			},
			{
				"name": "rules",
				"salience": 0.0011690233,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0010123866,
				"type": "WORK_OF_ART"
			},
			{
				"name": "boss",
				"salience": 0.0010123866,
				"type": "PERSON"
			},
			{
				"name": "sex",
				"salience": 0.0010123866,
				"type": "OTHER"
			},
			{
				"name": "boredom",
				"salience": 0.0010123866,
				"type": "OTHER"
			},
			{
				"name": "Die",
				"salience": 0.0010123866,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0010123866,
				"type": "OTHER"
			},
			{
				"name": "Truth",
				"salience": 0.0009079408,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0009079408,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0009041426,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0009041426,
				"type": "OTHER"
			},
			{
				"name": "controllers",
				"salience": 0.00080237474,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Genocide",
				"salience": 0.00078923017,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0007792893,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00070828316,
				"type": "PERSON"
			},
			{
				"name": "Sir",
				"salience": 0.0006952663,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.0006834425,
				"type": "EVENT"
			},
			{
				"name": "species",
				"salience": 0.0006834425,
				"type": "OTHER"
			},
			{
				"name": "voice calm",
				"salience": 0.0006834425,
				"type": "OTHER"
			},
			{
				"name": "Sir",
				"salience": 0.0006693208,
				"type": "PERSON"
			},
			{
				"name": "mistake",
				"salience": 0.00063997286,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.0005994459,
				"type": "OTHER"
			},
			{
				"name": "finger pointing",
				"salience": 0.0005795952,
				"type": "OTHER"
			},
			{
				"name": "Soul",
				"salience": 0.00055093376,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.00051709067,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0005000238,
				"type": "LOCATION"
			},
			{
				"name": "source",
				"salience": 0.0005000238,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0005000238,
				"type": "OTHER"
			},
			{
				"name": "sol",
				"salience": 0.00043298217,
				"type": "OTHER"
			},
			{
				"name": "incarnations",
				"salience": 0.00043298217,
				"type": "OTHER"
			},
			{
				"name": "demise",
				"salience": 0.00043298217,
				"type": "OTHER"
			},
			{
				"name": "myriad",
				"salience": 0.00043298217,
				"type": "OTHER"
			},
			{
				"name": "aether",
				"salience": 0.00043298217,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028ght",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Applause"
				},
				"name": "Applause",
				"salience": 0.0004206906,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0004115675,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ld5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Heaven"
				},
				"name": "Heaven",
				"salience": 0.0003998836,
				"type": "LOCATION"
			},
			{
				"name": "crescendo voice",
				"salience": 0.00036753633,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.00036417565,
				"type": "LOCATION"
			},
			{
				"name": "Controller",
				"salience": 0.00036097137,
				"type": "PERSON"
			},
			{
				"name": "love",
				"salience": 0.000347496,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.00032614524,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.00032614524,
				"type": "OTHER"
			},
			{
				"name": "frenchfries",
				"salience": 0.0003153417,
				"type": "PERSON"
			},
			{
				"name": "simulation",
				"salience": 0.0003153417,
				"type": "OTHER"
			},
			{
				"name": "extinction",
				"salience": 0.0003153417,
				"type": "EVENT"
			},
			{
				"name": "hearth",
				"salience": 0.0003153417,
				"type": "OTHER"
			},
			{
				"name": "opposite",
				"salience": 0.00030356913,
				"type": "OTHER"
			},
			{
				"name": "Genocide",
				"salience": 0.00027203796,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s82",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Transient_ischemic_attack"
				},
				"name": "Tia",
				"salience": 0.00026649173,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028v0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silence"
				},
				"name": "Silence",
				"salience": 0.00026649173,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.00023555588,
				"type": "OTHER"
			},
			{
				"name": "Hubris",
				"salience": 0.00023555588,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.00019407654,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d2l53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hell"
				},
				"name": "Hell",
				"salience": 0.00014496749,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats8.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T11:15:29.892+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "(Mr Smith): You know Mr Main I don't respond very well if people start to pull on my strings... (The Main): ... and still... here you are Mr Smith. (Mr Smith): Indeed ! (The Main): Poor Mr Smith , doesn't know which pill swallow... doesn't he ? (Mr Smith): You weren't completely honest with me Mr Main. I don't like dishonest people dear Mr Main and I certainly want a dishonest person to become my boss. (The Main): So just follow the rules dear Mr Smith. Forget about the letter have some fun some sex and Die of boredom like the rest of the controllers. (Mr Smith): People that talk about rules are very dangerous people my father used to say. (The Main): your father was a wise man. (The Main): Tell me do you like dangerous Mr Smith ? (Mr Smith): Hyperborea... (The Main): I consider that a yes , Applause for you. You've been investigating haven't you? (The Main): Oh I really start to like you Dear young Mr Smith. (Mr Smith,agitated): 58 Billion death , Genocide !, an entire sentient species !!. Sir You're a monster nothing more !!! (The Main,voice calm): ...And yet here you are (Mr Smith): Just the Truth nothing more.... Convince me that you're worth it. (The Main): Oh dear Mr smith I'm worth it. But the truth has to be deserved.... I admit Hyperborea was an mistake that shouldn't be made. (Mr Smith): The truth...Just tell me why... (The Main): Mistakes dear Mr Smith... We have made a lot of mistakes. (Mr Smith,loud voice): don't you mean You made a lot of mistakes... Sir ! (finger pointing). (Mr Smith,loud voice ): Don't blame it on the minor controllers , YOU were the main controller and YOU made a lot of mistakes. (The Main,soft voice): OK OK , Indeed I made a lot of mistakes. I tried to create Heaven and ended up with Hell , it was Hubris at it's finest ! (Mr Smith): .... (The Main): You know what the opposite of love is dear Mr Smith ? (Mr Smith): .... (The Main,crescendo voice): It's isn't hate it is Too much love. I loved too much ! If you want to condemn me condemn me for too much love and not for Genocide. Yes yes I killed 58biljon beautiful people but the source of my demise the one and only real source Mr Smith was ... too much love!! (Silence) (The Main,emotional):It was a beautiful Soul pure as our precious aether. I was obsessed with it. I started it to follow into it's myriad of incarnations. As the Eons went by I saw how the Hyperboreans those beautiful people that I had created started colonize the 5 th planet of sol ,Tia-mat Eons later they even colonized the 3th planet now known as Earth. Their empire grew. Beautiful people that had no hate in their hearth. Yes I was responsible for they extinction by making the greatest mistake a Controller could make... Do you know what that is Mr Smith ? (Mr Smith): .... (The Main,soft-voice): I Entered The simulation. edit on 10272016 by frenchfries because: (no reason given)",
		"thread_title": "Letter for Mr Smith - part 2 The Main -",
		"title": "Letter for Mr Smith - part 2 The Main -",
		"type": "bs",
		"uuid": "cebd77a807adabf4fe1f0ff7677ea339550de46f"
	},
	"-KhIa-v4ahBsu8IsdJqs": {
		"author": "Paradoxroutine",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:15:32.457+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "guide",
				"salience": 0.11700818,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nothing",
				"salience": 0.06460682,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.056024633,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0423532,
				"type": "OTHER"
			},
			{
				"name": "Paradoxroutine",
				"salience": 0.03992903,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.028736265,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.028736265,
				"type": "OTHER"
			},
			{
				"name": "dance",
				"salience": 0.028736265,
				"type": "OTHER"
			},
			{
				"name": "intrigue",
				"salience": 0.028736265,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.021715332,
				"type": "OTHER"
			},
			{
				"name": "guise",
				"salience": 0.018816255,
				"type": "OTHER"
			},
			{
				"name": "void",
				"salience": 0.01516019,
				"type": "OTHER"
			},
			{
				"name": "musing",
				"salience": 0.013690944,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.011858193,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.011858193,
				"type": "OTHER"
			},
			{
				"name": "self dissolution",
				"salience": 0.011858193,
				"type": "OTHER"
			},
			{
				"name": "devils mask",
				"salience": 0.011858193,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "angel",
				"salience": 0.011858193,
				"type": "PERSON"
			},
			{
				"name": "gasp",
				"salience": 0.011858193,
				"type": "OTHER"
			},
			{
				"name": "ends",
				"salience": 0.011858193,
				"type": "OTHER"
			},
			{
				"name": "motion",
				"salience": 0.011858193,
				"type": "OTHER"
			},
			{
				"name": "void",
				"salience": 0.010635819,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.010239326,
				"type": "OTHER"
			},
			{
				"name": "Hope",
				"salience": 0.010027964,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.009246217,
				"type": "OTHER"
			},
			{
				"name": "guidance",
				"salience": 0.009136211,
				"type": "OTHER"
			},
			{
				"name": "void",
				"salience": 0.0086848205,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.008317836,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.008317836,
				"type": "OTHER"
			},
			{
				"name": "clarity",
				"salience": 0.008317836,
				"type": "OTHER"
			},
			{
				"name": "caste",
				"salience": 0.008317836,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.008317836,
				"type": "LOCATION"
			},
			{
				"name": "living",
				"salience": 0.008317836,
				"type": "OTHER"
			},
			{
				"name": "vice",
				"salience": 0.008317836,
				"type": "OTHER"
			},
			{
				"name": "disregard",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "being",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "regard",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "remorse",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "happenstance",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.008007634,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.007842276,
				"type": "OTHER"
			},
			{
				"name": "herald",
				"salience": 0.007842276,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.007454732,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.007144647,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0070240153,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0070240153,
				"type": "OTHER"
			},
			{
				"name": "kingship",
				"salience": 0.006791537,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.006791537,
				"type": "PERSON"
			},
			{
				"name": "preponderance",
				"salience": 0.006791537,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.006791537,
				"type": "OTHER"
			},
			{
				"name": "veil",
				"salience": 0.006791537,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.006791537,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0065381923,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.0062942873,
				"type": "WORK_OF_ART"
			},
			{
				"name": "death",
				"salience": 0.006086643,
				"type": "EVENT"
			},
			{
				"name": "call",
				"salience": 0.0058595655,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.0058595655,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0052709146,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0050742435,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0050328,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0050328,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cy5n2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maya_religion"
				},
				"name": "Maya",
				"salience": 0.0044547785,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0042681475,
				"type": "OTHER"
			},
			{
				"name": "musings",
				"salience": 0.0042681475,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.004078149,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.004078149,
				"type": "OTHER"
			},
			{
				"name": "bull",
				"salience": 0.0036959767,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0036959767,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0036959767,
				"type": "OTHER"
			},
			{
				"name": "guidance",
				"salience": 0.003531433,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0035025827,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0031885593,
				"type": "EVENT"
			},
			{
				"name": "stones",
				"salience": 0.0027610443,
				"type": "OTHER"
			},
			{
				"name": "wells shortcomings",
				"salience": 0.0027610443,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0027610443,
				"type": "OTHER"
			},
			{
				"name": "realm",
				"salience": 0.0027610443,
				"type": "OTHER"
			},
			{
				"name": "darkness",
				"salience": 0.0027610443,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0027610443,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.0027610443,
				"type": "OTHER"
			},
			{
				"name": "Paradoxroutine",
				"salience": 0.0026272153,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0023712898,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c1d0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Providence,_Rhode_Island"
				},
				"name": "Providence",
				"salience": 0.0016993618,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T11:15:32.457+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "A guide to the Paradoxroutine page: 1 Hah I'm here randomly post, and be good at nothing. If I were to sum up myself in one form or another it would be this: What is it that I wish to create? In a seamless dance of hope and intrigue, I jitter and pounce on that which does define. But in an ends' motion what is it that I have made? More musing of a solid soul, a gasp of an angel brought forth upon the devils mask. Shattered within a hopeless contextual void of self dissolution. To dissolve in ones own thoughts of regard of high and mighty being? In the beginning what is it that we seek? In hell and high water, in times of disregard. What is it that seeks us. From times of happenstance to those of remorse. Again we beckon the call to purpose and resolve. Every time, even without a moments clarity we call too and forth of the void, to give us direction. Show me ways beyond vice, ways not wanted of founded living, shallower within such a world. Should they be down caste or sought without voice? Give me guidance before the light. Hope before the void. I shall know of the kingship of a heralds' life, before the life of a herald be know to his people. To this preponderance I shadow skirt my minds eye, to a veil beyond the guise that which is a worded Maya. I find such things a mere hope of sound falling. Give me hope or the hope of death. Give me light or knowledge of only darkness. Give not guidance, but a misadventured fall into the abysmal realm of chance and near do wells shortcomings. Shall be you chance or stones carved Providence? I beckon the call to truth, yet I hope and pray tell that none does exist. The only way to continue searching, is to never find the answer we seek. To find is to know, to know is to be content. To be content is to stagnant in truth. To find death in one truth, one truth among many. To live is to know nothing, but to know what you understand has already become false by nature is to understand that my musings are bull****. edit on 10|27|2016 by Paradoxroutine because: Because I'm a dumbass.",
		"thread_title": "A guide to the Paradoxroutine",
		"title": "A guide to the Paradoxroutine",
		"type": "bs",
		"uuid": "8c399d142898a0d596ce483c80cc37a95a3fcdd0"
	},
	"-KhIa0RYNFgn6YtlM-T5": {
		"author": "SoulOfCeres",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:15:47.153+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "fan",
				"salience": 0.4834939,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.097286806,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.08413142,
				"type": "OTHER"
			},
			{
				"name": "ERB Trump",
				"salience": 0.077338085,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.047707353,
				"type": "LOCATION"
			},
			{
				"name": "Internet",
				"salience": 0.03550277,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jwymmq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Epic_Rap_Battles_of_History"
				},
				"name": "ERB",
				"salience": 0.025363287,
				"type": "PERSON"
			},
			{
				"name": "rap battle",
				"salience": 0.025021879,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dms7zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peter_Shukoff"
				},
				"name": "Nice Peter",
				"salience": 0.023717912,
				"type": "PERSON"
			},
			{
				"name": "guess",
				"salience": 0.02248949,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.01718748,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jt05w8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lloyd_Ahlquist"
				},
				"name": "Epic Lloyd",
				"salience": 0.014899254,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.010503939,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.007856135,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Formatting",
				"salience": 0.005727053,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Romney",
				"salience": 0.004841772,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.004841772,
				"type": "PERSON"
			},
			{
				"name": "glory",
				"salience": 0.0042807776,
				"type": "OTHER"
			},
			{
				"name": "LANGUAGE",
				"salience": 0.0042807776,
				"type": "OTHER"
			},
			{
				"name": "SoulOfCeres",
				"salience": 0.0035281482,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats5.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T11:15:47.153+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "ERB Trump vs Clinton is finally here! page: 1 link If you're an avid ERB fan like me and 75% of the Internet, then you'll be very happy to know that Nice Peter and Epic Lloyd have finally delivered the highly anticipated Trump vs Clinton rap battle! We all knew it had to happen sooner or later. My guess that it would drop shortly after the final debate turned out to be true! Here it is in all its glory: ** CONTAINS STRONG LANGUAGE ** While you're at it, may as well check out the Romney vs Obama video from 2012: edit on 27-10-2016 by SoulOfCeres because: Formatting",
		"thread_title": "ERB Trump vs Clinton is finally here!",
		"title": "ERB Trump vs Clinton is finally here!",
		"type": "bs",
		"uuid": "9249b82b3a40dfa0fc7849909fa2bad90a636f95"
	},
	"-KhIa0axDLlMGVObGzsG": {
		"author": "gariac",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:15:48.078+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "gravel pits",
				"salience": 0.085099906,
				"type": "OTHER"
			},
			{
				"name": "imagery",
				"salience": 0.07962373,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.07922303,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.06259626,
				"type": "LOCATION"
			},
			{
				"name": "cars",
				"salience": 0.06259626,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "page",
				"salience": 0.06259626,
				"type": "OTHER"
			},
			{
				"name": "hunting",
				"salience": 0.06182286,
				"type": "OTHER"
			},
			{
				"name": "imagery",
				"salience": 0.04520611,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06ny5h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google_Earth"
				},
				"name": "Google Earth",
				"salience": 0.038821038,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0272fh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tonopah_Test_Range"
				},
				"name": "Tonopah Test Range",
				"salience": 0.038821038,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0338b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_F-117_Nighthawk"
				},
				"name": "F-117",
				"salience": 0.026336864,
				"type": "OTHER"
			},
			{
				"name": "radar berm",
				"salience": 0.02606464,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.018469837,
				"type": "PERSON"
			},
			{
				"name": "Rumors",
				"salience": 0.01574395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dm1q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muck,_Scotland"
				},
				"name": "Muck",
				"salience": 0.015268246,
				"type": "LOCATION"
			},
			{
				"name": "gravel pits",
				"salience": 0.014115605,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.014115605,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.013590762,
				"type": "OTHER"
			},
			{
				"name": "edge",
				"salience": 0.013360456,
				"type": "LOCATION"
			},
			{
				"name": "runway",
				"salience": 0.013360456,
				"type": "LOCATION"
			},
			{
				"name": "cost",
				"salience": 0.012305158,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09gl__",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tonopah_Test_Range_Airport"
				},
				"name": "Tonopah",
				"salience": 0.01224225,
				"type": "LOCATION"
			},
			{
				"name": "tunnels",
				"salience": 0.012150639,
				"type": "OTHER"
			},
			{
				"name": "mining tailings",
				"salience": 0.011986012,
				"type": "OTHER"
			},
			{
				"name": "thesungod",
				"salience": 0.011595275,
				"type": "PERSON"
			},
			{
				"name": "site",
				"salience": 0.011102895,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.01059591,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.01033132,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.009908674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.009507119,
				"type": "ORGANIZATION"
			},
			{
				"name": "targets",
				"salience": 0.009028699,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.007659309,
				"type": "OTHER"
			},
			{
				"name": "hangar",
				"salience": 0.007659309,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.00660943,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0yjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Area_51"
				},
				"name": "Area 51",
				"salience": 0.0064221006,
				"type": "LOCATION"
			},
			{
				"name": "system",
				"salience": 0.005724464,
				"type": "OTHER"
			},
			{
				"name": "trucking",
				"salience": 0.005724464,
				"type": "OTHER"
			},
			{
				"name": "White Sand",
				"salience": 0.005562172,
				"type": "OTHER"
			},
			{
				"name": "topics",
				"salience": 0.005172893,
				"type": "OTHER"
			},
			{
				"name": "pile",
				"salience": 0.004855443,
				"type": "OTHER"
			},
			{
				"name": "muck",
				"salience": 0.0048158136,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.004170679,
				"type": "OTHER"
			},
			{
				"name": "mining tailings",
				"salience": 0.0039851265,
				"type": "OTHER"
			},
			{
				"name": "Tailings",
				"salience": 0.0039851265,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lp7f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Motocross"
				},
				"name": "MX",
				"salience": 0.0035251358,
				"type": "LOCATION"
			},
			{
				"name": "imagery",
				"salience": 0.0033372995,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0033200828,
				"type": "OTHER"
			},
			{
				"name": "rock",
				"salience": 0.0031162212,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015m86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada_Test_Site"
				},
				"name": "NTS",
				"salience": 0.0025678168,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01csh3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nellis_Air_Force_Base"
				},
				"name": "Nellis",
				"salience": 0.0025678168,
				"type": "LOCATION"
			},
			{
				"name": "amounts",
				"salience": 0.001632429,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats15.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T11:15:48.078+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Tonopah Test Range Google Earth imagery 7/22/2016 page: 1 37.785314° -116.765487° lots of cars 37.788909° -116.756991° buildings removed 37.761840° -116.760566° new building 37.723731° -116.730658° new radar berm Happy hunting. Note they cut this really close to the north edge of the runway, as if someone ordered this imagery and Google poached it. Tonopah is the Area 51 site. These look like the White Sand targets I've fired at. (above) edit on 26-10-2016 by thesungod because: (no reason given) edit on 26-10-2016 by thesungod because: (no reason given) The only things missing are the \"commercial gravel pits.\" That is how the mining tailings are covered up. Posted a thread on this here Looks like something (maybe F-117 or something else) being moved into a hangar 37.798244, -116.774809 The only things missing are the \"commercial gravel pits.\" That is how the mining tailings are covered up. I would presume since available imagery would show large amounts of \"Muck\" which is the technical term for the rock left over (Tailings are actually something else) they would eat the cost associated with trucking it elsewhere or using previously excavated areas on site. Rumors persist that the proposed underground, mobile, MX system was mocked up and extensive tunnels were dug in and around the NTS and Nellis etc. which could also be used for storing the muck. Otherwise a giant pile of the stuff would be a dead giveaway new topics",
		"thread_title": "Tonopah Test Range Google Earth imagery 7/22/2016",
		"title": "Tonopah Test Range Google Earth imagery 7/22/2016",
		"type": "bs",
		"uuid": "bb71d1d812a31aebd848575a6ac28705a9085895"
	},
	"-KhIa0jI35RzqrwPHzxS": {
		"author": "xuenchen",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:15:51.857+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.30618602,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.270914,
				"type": "PERSON"
			},
			{
				"name": "wiki files",
				"salience": 0.07216136,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.07216136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cjjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Podest%C3%A0"
				},
				"name": "Podesta",
				"salience": 0.061752126,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0120w9bh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jennifer_Palmieri"
				},
				"name": "Jennifer Palmieri",
				"salience": 0.039138187,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.03736356,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WIKILEAKS",
				"salience": 0.018233202,
				"type": "ORGANIZATION"
			},
			{
				"name": "Boy",
				"salience": 0.015509112,
				"type": "PERSON"
			},
			{
				"name": "Someone",
				"salience": 0.015509112,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.013916329,
				"type": "OTHER"
			},
			{
				"name": "campaign aides",
				"salience": 0.01210399,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.010892201,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Sober Her Up",
				"salience": 0.009537693,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.00889826,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.008186694,
				"type": "OTHER"
			},
			{
				"name": "email exchange",
				"salience": 0.007841342,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0066522583,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.004847708,
				"type": "OTHER"
			},
			{
				"name": "Cheryl",
				"salience": 0.004097747,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/045m16",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mill_(grinding)"
				},
				"name": "Mills",
				"salience": 0.004097747,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats17.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T10:31:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Well here's a good from the Podesta wiki files. This time it has Podesta himself and some others trying to decide who should sober Hillary up !! Oh Boy it's from Aug 2015. WIKILEAKS: Hillary Clinton Needed Someone to ‘Sober Her Up’ at 4:30 in the Afternoon Hillary Clinton campaign aides had a frantic email exchange in August 2015 over who should call the candidate to “sober her up some” at around 4:30 in the afternoon. According to documents published by WikiLeaks, Clinton campaign chairman John Podesta emailed communications aide Jennifer Palmieri with a question at around 2:00 p.m. “Should I call her and talk this through or better to leave with you?” Podesta wrote. “I’m worried she’ll get on with Cheryl [Mills] and we’ll end up in a bad place.” Palmieri wrote back more than two hours later with a response: “I think you should call her and sober her up some.”",
		"thread_title": "WIKILEAKS: Hillary Clinton Needed Someone to 'Sober Her Up' at 4:30 in the Afternoon",
		"title": "WIKILEAKS: Hillary Clinton Needed Someone to 'Sober Her Up' at 4:30 in the Afternoon",
		"type": "bs",
		"uuid": "42643932576614c74e544e56cc7b0e15603f09b4"
	},
	"-KhIa1C5eVfA1uYa6rUn": {
		"author": "Hefficide",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:15:52.581+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.75087285,
				"type": "PERSON"
			},
			{
				"name": "season",
				"salience": 0.013291681,
				"type": "EVENT"
			},
			{
				"name": "clouds",
				"salience": 0.012447437,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.011479112,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0061754305,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.005945799,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.0059031434,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.004790059,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.004617619,
				"type": "EVENT"
			},
			{
				"name": "ATS",
				"salience": 0.0043552876,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.0042293,
				"type": "PERSON"
			},
			{
				"name": "powder keg",
				"salience": 0.004177325,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.004046537,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0037084487,
				"type": "LOCATION"
			},
			{
				"name": "spokesperson",
				"salience": 0.003250118,
				"type": "PERSON"
			},
			{
				"name": "opinion",
				"salience": 0.0029499838,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0029259184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/047yrg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hello_(magazine)"
				},
				"name": "Hello",
				"salience": 0.0028663676,
				"type": "PERSON"
			},
			{
				"name": "base",
				"salience": 0.0027464242,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0027118663,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0027017193,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0025920887,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0024657694,
				"type": "EVENT"
			},
			{
				"name": "writing",
				"salience": 0.0023786256,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lead",
				"salience": 0.0023786256,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0023786256,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0023786256,
				"type": "OTHER"
			},
			{
				"name": "revelation",
				"salience": 0.0023786256,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0023786256,
				"type": "EVENT"
			},
			{
				"name": "landscape",
				"salience": 0.0023786256,
				"type": "OTHER"
			},
			{
				"name": "About Trump",
				"salience": 0.0022763382,
				"type": "OTHER"
			},
			{
				"name": "Money",
				"salience": 0.002056679,
				"type": "OTHER"
			},
			{
				"name": "meta-analysis",
				"salience": 0.0019920757,
				"type": "OTHER"
			},
			{
				"name": "fringe support",
				"salience": 0.0018911343,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0017216953,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019t77",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_O'Reilly_(political_commentator)"
				},
				"name": "O'Reilly",
				"salience": 0.0016529793,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02pgkkk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Apprentice_(U.S._TV_series)"
				},
				"name": "The Apprentice",
				"salience": 0.0015692165,
				"type": "WORK_OF_ART"
			},
			{
				"name": "network",
				"salience": 0.0014538349,
				"type": "OTHER"
			},
			{
				"name": "lock",
				"salience": 0.0014024369,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "thoughts",
				"salience": 0.0013942273,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0013509543,
				"type": "EVENT"
			},
			{
				"name": "Election",
				"salience": 0.0013349104,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0013349104,
				"type": "EVENT"
			},
			{
				"name": "eighth",
				"salience": 0.0013171379,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0012851025,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0012834158,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.001262331,
				"type": "OTHER"
			},
			{
				"name": "proportions",
				"salience": 0.0012528958,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.0012362509,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0011771355,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.0011457109,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0011312786,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.0011312786,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011312786,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0011312786,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0011312786,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0010890627,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0010715921,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0010405835,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0010228863,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.0010176074,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.0009847124,
				"type": "PERSON"
			},
			{
				"name": "reaction",
				"salience": 0.0009840248,
				"type": "OTHER"
			},
			{
				"name": "storm",
				"salience": 0.0009796304,
				"type": "EVENT"
			},
			{
				"name": "bar",
				"salience": 0.0009796304,
				"type": "LOCATION"
			},
			{
				"name": "worst",
				"salience": 0.0009796304,
				"type": "OTHER"
			},
			{
				"name": "taboos",
				"salience": 0.0009796304,
				"type": "OTHER"
			},
			{
				"name": "hyperbole",
				"salience": 0.0009796304,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0009796304,
				"type": "PERSON"
			},
			{
				"name": "horizon",
				"salience": 0.0009796304,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.0009796304,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0009796304,
				"type": "OTHER"
			},
			{
				"name": "tension",
				"salience": 0.0009796304,
				"type": "OTHER"
			},
			{
				"name": "crystal ball",
				"salience": 0.0009796304,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.0009766683,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0009242268,
				"type": "OTHER"
			},
			{
				"name": "fringe",
				"salience": 0.0008785229,
				"type": "EVENT"
			},
			{
				"name": "outcome",
				"salience": 0.0008785229,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0008668485,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00084573345,
				"type": "LOCATION"
			},
			{
				"name": "outcome",
				"salience": 0.00084573345,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00084573345,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0007932255,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0007932255,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0007932255,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0007932255,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.0007932255,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.0007932255,
				"type": "OTHER"
			},
			{
				"name": "news network",
				"salience": 0.0007763405,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0007636179,
				"type": "OTHER"
			},
			{
				"name": "degree",
				"salience": 0.0007636179,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0007636179,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0007636179,
				"type": "EVENT"
			},
			{
				"name": "reactions",
				"salience": 0.0007636179,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.00075062865,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00072635955,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.0007226102,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0007172071,
				"type": "LOCATION"
			},
			{
				"name": "breath",
				"salience": 0.00070451444,
				"type": "OTHER"
			},
			{
				"name": "celebrity",
				"salience": 0.00069563714,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0006899534,
				"type": "OTHER"
			},
			{
				"name": "revolution",
				"salience": 0.00068687164,
				"type": "EVENT"
			},
			{
				"name": "rage",
				"salience": 0.00068687164,
				"type": "OTHER"
			},
			{
				"name": "chemistry",
				"salience": 0.00068687164,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.00068687164,
				"type": "OTHER"
			},
			{
				"name": "extremes",
				"salience": 0.00068687164,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00068687164,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.00068125944,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.000661232,
				"type": "EVENT"
			},
			{
				"name": "fame",
				"salience": 0.000661232,
				"type": "OTHER"
			},
			{
				"name": "Passions",
				"salience": 0.000661232,
				"type": "OTHER"
			},
			{
				"name": "spasm",
				"salience": 0.000661232,
				"type": "OTHER"
			},
			{
				"name": "phones",
				"salience": 0.000661232,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "emotion",
				"salience": 0.000661232,
				"type": "OTHER"
			},
			{
				"name": "computers",
				"salience": 0.000661232,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "spark",
				"salience": 0.000661232,
				"type": "OTHER"
			},
			{
				"name": "televisions",
				"salience": 0.000661232,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mass",
				"salience": 0.000661232,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.000661232,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.000661232,
				"type": "OTHER"
			},
			{
				"name": "rant",
				"salience": 0.000661232,
				"type": "OTHER"
			},
			{
				"name": "groundwork",
				"salience": 0.00064756506,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00063654897,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00063654897,
				"type": "OTHER"
			},
			{
				"name": "Election results",
				"salience": 0.00062852766,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0006206074,
				"type": "PERSON"
			},
			{
				"name": "Election Night Blues",
				"salience": 0.0006029886,
				"type": "ORGANIZATION"
			},
			{
				"name": "face",
				"salience": 0.0006001209,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0005607334,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0005607334,
				"type": "OTHER"
			},
			{
				"name": "media operation",
				"salience": 0.0005607334,
				"type": "OTHER"
			},
			{
				"name": "wonks",
				"salience": 0.0005607334,
				"type": "PERSON"
			},
			{
				"name": "pundits",
				"salience": 0.0005607334,
				"type": "PERSON"
			},
			{
				"name": "shame",
				"salience": 0.0005607334,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0005607334,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0005357637,
				"type": "OTHER"
			},
			{
				"name": "brand",
				"salience": 0.0005154023,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00048373415,
				"type": "LOCATION"
			},
			{
				"name": "messaging",
				"salience": 0.00048373415,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00048373415,
				"type": "OTHER"
			},
			{
				"name": "branding",
				"salience": 0.00048373415,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.00048373415,
				"type": "OTHER"
			},
			{
				"name": "angers",
				"salience": 0.00048373415,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.00047343498,
				"type": "OTHER"
			},
			{
				"name": "speaker",
				"salience": 0.00041886405,
				"type": "PERSON"
			},
			{
				"name": "feed",
				"salience": 0.00041886405,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.00041886405,
				"type": "LOCATION"
			},
			{
				"name": "ideas",
				"salience": 0.00041886405,
				"type": "OTHER"
			},
			{
				"name": "guest",
				"salience": 0.00041886405,
				"type": "PERSON"
			},
			{
				"name": "platform",
				"salience": 0.00041886405,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.00041886405,
				"type": "OTHER"
			},
			{
				"name": "frustrations",
				"salience": 0.00041886405,
				"type": "OTHER"
			},
			{
				"name": "insecurities",
				"salience": 0.00041886405,
				"type": "OTHER"
			},
			{
				"name": "Blunty",
				"salience": 0.00041742646,
				"type": "PERSON"
			},
			{
				"name": "faces",
				"salience": 0.00041020516,
				"type": "OTHER"
			},
			{
				"name": "propaganda arm",
				"salience": 0.00037844834,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00036134123,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00035519304,
				"type": "PERSON"
			},
			{
				"name": "degree",
				"salience": 0.00035229023,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.00035229023,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00035229023,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.00035229023,
				"type": "OTHER"
			},
			{
				"name": "Trump TV",
				"salience": 0.00033927482,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0003391369,
				"type": "OTHER"
			},
			{
				"name": "propaganda value",
				"salience": 0.00033762175,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00033660044,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00030893722,
				"type": "PERSON"
			},
			{
				"name": "subjects",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "isolationism",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "curtain",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "camera talents",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "media enterprise",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "news heap",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "power war",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "camera positions",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "identity politics",
				"salience": 0.00030504333,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0002951778,
				"type": "ORGANIZATION"
			},
			{
				"name": "prediction",
				"salience": 0.0002936537,
				"type": "OTHER"
			},
			{
				"name": "nationalism",
				"salience": 0.00029145734,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00029145734,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00029145734,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Mercers",
				"salience": 0.0002689835,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.00026314872,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.00026314872,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00026314872,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.00026314872,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00026314872,
				"type": "ORGANIZATION"
			},
			{
				"name": "news venue",
				"salience": 0.00025541053,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05b6sny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hannity"
				},
				"name": "Hannity",
				"salience": 0.00023290736,
				"type": "PERSON"
			},
			{
				"name": "entity",
				"salience": 0.00022785501,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.00022785501,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "figurehead",
				"salience": 0.00022785501,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.00022785501,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00022785501,
				"type": "OTHER"
			},
			{
				"name": "conservatism",
				"salience": 0.00022785501,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.00022785501,
				"type": "OTHER"
			},
			{
				"name": "jump",
				"salience": 0.00022498296,
				"type": "OTHER"
			},
			{
				"name": "Mercers",
				"salience": 0.00021680743,
				"type": "ORGANIZATION"
			},
			{
				"name": "Trump's MAGA Network",
				"salience": 0.00019416126,
				"type": "OTHER"
			},
			{
				"name": "Lahren",
				"salience": 0.00018772823,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d2y1g"
				},
				"name": "Robert",
				"salience": 0.00018772823,
				"type": "PERSON"
			},
			{
				"name": "Rebekah",
				"salience": 0.00018772823,
				"type": "PERSON"
			},
			{
				"name": "Steve Bannon",
				"salience": 0.00018772823,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0134dc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roger_Ailes"
				},
				"name": "Roger Ailes",
				"salience": 0.00018772823,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04w2dc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_Television_Stations"
				},
				"name": "Fox",
				"salience": 0.00018772823,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09v571r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tea_Party_movement"
				},
				"name": "Tea Party",
				"salience": 0.00017936654,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08f3b1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sarah_Palin"
				},
				"name": "Sarah Palin",
				"salience": 0.00014022247,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0264n4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Beck"
				},
				"name": "Glenn Beck",
				"salience": 0.00014022247,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04bbb8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patriot_(American_Revolution)"
				},
				"name": "Patriot",
				"salience": 0.00014022247,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/071ycn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservatism_in_the_United_States"
				},
				"name": "Conservative",
				"salience": 0.00014022247,
				"type": "ORGANIZATION"
			},
			{
				"name": "Big Daddy Bill",
				"salience": 0.00007158413,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats6.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:52:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 20.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Hello again ATS! Though we are two weeks out from Election Day as I sit to write these words – I find myself already looking beyond Tuesday, November the eighth and at some of the things that I think will happen between now and 2020 as well as what I think the landscape will look like in the year leading up to that year's election. It won't be a popular opinion here on ATS, I am sure... But as of today I feel confident in saying that, short of some unprecedented and wholly unforseeable revelation or event – this years election is very likely a done deal. Hillary Clinton will almost certainly be the next President of the United States. With just two weeks remaining before Election Day ( as of this writing ), the meta-analysis of polls shows Clinton possessing nearly an insurmountable lead. While it is true that Trump enjoys a very passionate and enthusiastic base, he has done little to successfully expand that base. The potential for him to find a means of connecting with undecided and uncommitted voters is minimal and shrinks with each passing day. Having come to this view, I find myself free to look beyond the coming weeks and to try and get a handle on what a post 2016 world will look like. Frankly, gazing into my allegorical crystal ball, I see dark and threatening clouds gathering on our horizon. Clouds that could very well bring a storm of epic proportions our way. Election Night Blues The night of Tuesday, November the eighth could well be historic – in the worst of ways. This election cycle has broken several taboos and lowered the bar of political discourse in unprecedented ways. It has been a season of highly divisive hyperbole and rhetoric that has built-up a great deal of social tension. We currently sit atop a very, very dry powder keg of anger that is seething and highly volatile. Passions will be flaring among many as we watch the Election results stream in on our televisions, computers and phones. Many of those watching will be deeply, deeply emotionally invested in the outcome of this race. In this climactic moment we, as a nation, will be perilously close to critical mass. One spark away from potential disaster... Four years ago a man with some degree of fame was emotionally invested in that years election and he took to social media, Twitter, to vent his reactions in a paroxysmal spasm of emotion... That minor celebrity was one Donald J. Trump: Source Imagine for a moment what could happen if history repeats itself and this same man goes on a similar rant this Election night. Imagine the violence such a display could potentially trigger. Then stop imagining and take a deep breath... Such a reaction is not just possible – given the evidence, it is more than likely the probable outcome. Trump is currently heavily invested in telling his followers that the election is rigged, that they have no voice and that he is \"the only one\" who can save them. This is a very, very dangerous and unstable bit of social chemistry. Most Trump supporters, obviously, will not lash out in violence if their candidate loses the race – even if they personally feel that the outcome of the Election was not legitimate. However some Trump supporters, those in the extremes of what the media is currently calling \"the alt right\" very well could take to the streets in rage. Given some of the fringe support that Trump enjoys, I would honestly be surprised if such things were not already being planned by a handful of those on the fringe. The rhetoric of revolution has been abused of late – and there are always the few who take such statements far too literally... Across the line. Blunty put – if Election night comes and Trump loses – and if he takes to Twitter as he did four years ago – it could well result in a very long and bloody night. A catastrophic night that we will look back upon with shame. A night that could well poison our nation for years to come. Much Ado About Trump TV Many pundits and wonks have mused over the fact that it truly does appear that Trump has been laying the groundwork for a future media operation... Presumably a news network or service of some kind. I count myself among those who have been suggesting so for a fairly long time. However where I differ is that I don't see it as being quite so cut and dry any longer. While I do think that Trump's original thoughts ( or more the thoughts of those who influence Trump ) was to create a new media Conservative news venue... I think that it's now grown into something more. I think that Trump TV ( Or whatever they end up calling it - \"Trump TV\" is too generic. There's no inherent propaganda value in the name. I think something more like \"Trump's MAGA Network\" is probably more on point. ) will be used as a device to begin a new political party. More accurately to succeed where others have previously failed ( I’m looking at you Sarah Palin and Glenn Beck ) by congealing the various \"Patriot\", \"Tea Party\" and fringe right wing groups into one collective and singular entity – a party firmly rooted in extreme nationalism with enough religion and conservatism thrown in to gain wider appeal. My prediction is that Donald Trump will remain the focal point and figurehead of this coming movement – using this new network much as he currently utilizes his Twitter feed... A platform for him to vent his late night frustrations, angers and insecurities. His name will be predominantly used in the branding and messaging and Trump will be the face of it all. The most frequent speaker and guest. Imagine if The Apprentice had been a 24/7/365 live streaming show – and Trump had the power to walk in at any moment to say whatever happened to be on his mind... That is how I see Trump TV. However I don't see Trump being the driving force behind the actual message. Trump is a brand, after all. He has made his place in this world by putting his name on buildings he didn't build, shows that he didn't create and ideas he didn't originate. Trump works as a spokesperson – the guy who says \"I’m not only the President of... But I'm also a member\". The real people behind the curtain will be The Mercers ( Robert and Rebekah ), Steve Bannon and, to a lesser degree, Roger Ailes. As for on camera talents? I think the current obvious potential faces of this new media enterprise will be Hannity, O'Reilly and Lahren – though I'm honestly not personally sure if O'Reilly will make the jump. Money is money, after all, and Big Daddy Bill is sitting pretty comfortably atop the Fox news heap as his career winds down. Regardless, however, of who wins the backstage power war ( Other than the Mercers who are a lock ) and the on camera positions... The network itself will be the propaganda arm of the extreme right wing and I think it very well could end up pulling the national discourse much further to the right in the coming 4-8 years. Particularly with the subjects of national isolationism and national identity politics.",
		"thread_title": "Looking Beyond November 8th - A Song of Oligarchy and Doom",
		"title": "Looking Beyond November 8th - A Song of Oligarchy and Doom",
		"type": "bs",
		"uuid": "e5ebcf2cf86adff339c789032997a8bb534833b9"
	},
	"-KhIa1OjQLas05n3RkhC": {
		"author": "childoffather",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T11:15:53.339+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "page",
				"salience": 0.07330265,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.07330265,
				"type": "PERSON"
			},
			{
				"name": "HOAX",
				"salience": 0.062143806,
				"type": "OTHER"
			},
			{
				"name": "feedback",
				"salience": 0.04745349,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.045338497,
				"type": "PERSON"
			},
			{
				"name": "Footage Of Operation High Jump",
				"salience": 0.045338497,
				"type": "WORK_OF_ART"
			},
			{
				"name": "experiences",
				"salience": 0.03766335,
				"type": "OTHER"
			},
			{
				"name": "spaceship research",
				"salience": 0.03766335,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.035135463,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.029549867,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "youtube",
				"salience": 0.023237428,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.022836972,
				"type": "PERSON"
			},
			{
				"name": "coverup",
				"salience": 0.0208484,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.020641085,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.020549187,
				"type": "WORK_OF_ART"
			},
			{
				"name": "man",
				"salience": 0.017961184,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.016999107,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.01694783,
				"type": "OTHER"
			},
			{
				"name": "coverup",
				"salience": 0.015586909,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.015511652,
				"type": "OTHER"
			},
			{
				"name": "lol. link",
				"salience": 0.0146702025,
				"type": "OTHER"
			},
			{
				"name": "moon landing",
				"salience": 0.013955855,
				"type": "EVENT"
			},
			{
				"name": "Moon landing",
				"salience": 0.013955855,
				"type": "EVENT"
			},
			{
				"name": "moonlanding",
				"salience": 0.013842057,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.013257705,
				"type": "OTHER"
			},
			{
				"name": "hoax",
				"salience": 0.012976002,
				"type": "OTHER"
			},
			{
				"name": "us.",
				"salience": 0.012706823,
				"type": "OTHER"
			},
			{
				"name": "carewemust",
				"salience": 0.012603187,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.012335361,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.012335361,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.011397245,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.011246007,
				"type": "OTHER"
			},
			{
				"name": "baby",
				"salience": 0.010915899,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.010509012,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.010345437,
				"type": "OTHER"
			},
			{
				"name": "dynamics",
				"salience": 0.010292108,
				"type": "OTHER"
			},
			{
				"name": "Moon landing",
				"salience": 0.008517254,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.0080907745,
				"type": "OTHER"
			},
			{
				"name": "carewemust",
				"salience": 0.0076909875,
				"type": "OTHER"
			},
			{
				"name": "dynamics",
				"salience": 0.0076909875,
				"type": "OTHER"
			},
			{
				"name": "moonlanding",
				"salience": 0.0075374274,
				"type": "EVENT"
			},
			{
				"name": "hoax",
				"salience": 0.0070653297,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.006716151,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.006716151,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.006204902,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.0061224885,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.005602732,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.005602732,
				"type": "OTHER"
			},
			{
				"name": "tech",
				"salience": 0.005353388,
				"type": "OTHER"
			},
			{
				"name": "h",
				"salience": 0.0048518274,
				"type": "OTHER"
			},
			{
				"name": "distraction",
				"salience": 0.0048518274,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0041858586,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0041858586,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0041858586,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.003624726,
				"type": "OTHER"
			},
			{
				"name": "'s.",
				"salience": 0.003624726,
				"type": "PERSON"
			},
			{
				"name": "equation",
				"salience": 0.003624726,
				"type": "OTHER"
			},
			{
				"name": "Darkmadness",
				"salience": 0.0025978032,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats10.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:50:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "More Footage Of Operation High Jump With Hitler! page: 1 link Hi everyone. This was on my youtube feed today and thought I would share it and maybe get some feedback. Thru all my years of paranormal and alien spaceship research and experiences, I came to the conclusion that it was all man made. After watching this video, I am even more convinced of them being man made. There is so much technology they aren't telling us.Well, I hope you get a chance to view this and let me know what you think. Are they man made? a reply to: childoffather They knew about the technology were using right now in the 50's and 60's. I have heard the public are ten years behind what they know technologically. 40 to 60 years ago...we have come a long way baby. Not sure about the moon landing though. lol. link originally posted by: carewemust I guess there was no reason to HOAX a fake Moon landing, since the technology was available, even before the 1960's. Was probably even more refined by 1967. That's not true. We don't understand the dynamics of space so what we can do outside of the atmosphere and inside of the atmosphere we have no idea. How the moonlanding was a hoax we also do not understand. It could be a coverup of some sort or another. link a reply to: childoffather factor the exponential growth of tech into the equation and start from the early 1930's instead of the 90's. originally posted by: Darkmadness originally posted by: carewemust I guess there was no reason to HOAX a fake Moon landing, since the technology was available, even before the 1960's. Was probably even more refined by 1967. That's not true. We don't understand the dynamics of space so what we can do outside of the atmosphere and inside of the atmosphere we have no idea. How the moonlanding was a hoax we also do not understand. It could be a coverup of some sort or another. Or a distraction...h .",
		"thread_title": "More Footage Of Operation High Jump With Hitler!",
		"title": "More Footage Of Operation High Jump With Hitler!",
		"type": "bs",
		"uuid": "f8b2cee6c8961fc74ada040808b09baa7dacdea4"
	},
	"-KhIa1exnGSJ_s9pVQ4b": {
		"author": "Gandalf77",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:27:23.032+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "individual",
				"salience": 0.5733729,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.06056141,
				"type": "PERSON"
			},
			{
				"name": "satellite",
				"salience": 0.04174575,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.022573253,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.020677647,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.020677647,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.017279107,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.014980527,
				"type": "PERSON"
			},
			{
				"name": "pilot",
				"salience": 0.012466338,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.011696956,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.01132096,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Dad",
				"salience": 0.0099320635,
				"type": "PERSON"
			},
			{
				"name": "Greetings ATS",
				"salience": 0.009248066,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.008862243,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.008487102,
				"type": "WORK_OF_ART"
			},
			{
				"name": "civilian",
				"salience": 0.0076785106,
				"type": "OTHER"
			},
			{
				"name": "Background",
				"salience": 0.0076785106,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.0076785106,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0076785106,
				"type": "ORGANIZATION"
			},
			{
				"name": "story",
				"salience": 0.005362501,
				"type": "WORK_OF_ART"
			},
			{
				"name": "story",
				"salience": 0.004675237,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pilots",
				"salience": 0.0040495005,
				"type": "PERSON"
			},
			{
				"name": "aircraft",
				"salience": 0.0040495005,
				"type": "OTHER"
			},
			{
				"name": "mountains",
				"salience": 0.003952237,
				"type": "LOCATION"
			},
			{
				"name": "experience",
				"salience": 0.0036569075,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.0034503515,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0031672248,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.0031672248,
				"type": "OTHER"
			},
			{
				"name": "tales",
				"salience": 0.0031672248,
				"type": "OTHER"
			},
			{
				"name": "exageration",
				"salience": 0.0031672248,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.002959955,
				"type": "OTHER"
			},
			{
				"name": "aerodynamics",
				"salience": 0.002916466,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.0028406507,
				"type": "OTHER"
			},
			{
				"name": "pilot",
				"salience": 0.0027347265,
				"type": "PERSON"
			},
			{
				"name": "eyebrow",
				"salience": 0.0024694237,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.0024694237,
				"type": "EVENT"
			},
			{
				"name": "trip",
				"salience": 0.0024694237,
				"type": "EVENT"
			},
			{
				"name": "aircraft",
				"salience": 0.002363588,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0022214248,
				"type": "OTHER"
			},
			{
				"name": "ordinary",
				"salience": 0.0022214248,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0022214248,
				"type": "OTHER"
			},
			{
				"name": "stop",
				"salience": 0.0022214248,
				"type": "LOCATION"
			},
			{
				"name": "distance",
				"salience": 0.0022214248,
				"type": "OTHER"
			},
			{
				"name": "speed",
				"salience": 0.0022214248,
				"type": "OTHER"
			},
			{
				"name": "vector",
				"salience": 0.0022214248,
				"type": "OTHER"
			},
			{
				"name": "elevation",
				"salience": 0.0022214248,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0022214248,
				"type": "OTHER"
			},
			{
				"name": "beach",
				"salience": 0.0022214248,
				"type": "LOCATION"
			},
			{
				"name": "beer",
				"salience": 0.0021385632,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "attention",
				"salience": 0.0021385632,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.0021385632,
				"type": "OTHER"
			},
			{
				"name": "layover",
				"salience": 0.0021385632,
				"type": "EVENT"
			},
			{
				"name": "dinner",
				"salience": 0.0021385632,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0020979668,
				"type": "OTHER"
			},
			{
				"name": "eyebrow",
				"salience": 0.0020943931,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0018137295,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0018137295,
				"type": "OTHER"
			},
			{
				"name": "sight",
				"salience": 0.0018137295,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0016563925,
				"type": "PERSON"
			},
			{
				"name": "couch",
				"salience": 0.0013550547,
				"type": "OTHER"
			},
			{
				"name": "landing zone",
				"salience": 0.0013550547,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0013550547,
				"type": "ORGANIZATION"
			},
			{
				"name": "installation",
				"salience": 0.0013550547,
				"type": "EVENT"
			},
			{
				"name": "aliens",
				"salience": 0.0013550547,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.0013165971,
				"type": "LOCATION"
			},
			{
				"name": "UFO's",
				"salience": 0.0012623181,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.0011397669,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFO",
				"salience": 0.0010668281,
				"type": "ORGANIZATION"
			},
			{
				"name": "buzz kill",
				"salience": 0.0009869599,
				"type": "EVENT"
			},
			{
				"name": "Thanks",
				"salience": 0.0009869599,
				"type": "OTHER"
			},
			{
				"name": "reading",
				"salience": 0.0009869599,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.00083409384,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00083409384,
				"type": "LOCATION"
			},
			{
				"name": "abilities",
				"salience": 0.0007372815,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0007372815,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cjdk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_Broadcasting_Company"
				},
				"name": "Fox",
				"salience": 0.0004537683,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T00:17:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Greetings ATS community, I wanted to pass on something my dad experienced several years ago in the hopes that perhaps others have experienced something similiar or know someone who has. I found the story quite interesting, and I hope you will too. Background: My dad was a pilot with 30+ years of experience flying all manner of civilian, military, and commercial aircraft. He was a naturally humble and quiet individual--never given to boasting or exageration. Like many pilots, he was wired to be logical, mathematical, and mechanical; he was also a supreme skeptic where all things supernatural and speculative are concerned. He preferred direct experience and scientific inquiry to wild tales. His story: One day he came back from a trip he flew (commercial flight) to Mexico. Over a beer, I casually asked him about his trip. He looked at me, cocked one eyebrow and replied, \"I saw something I can't explain.\" This got my attention. On the layover, he and another pilot went out for dinner. Walking back along the beach at night, they both noticed a distant light moving along a fixed vector at a constant speed. They kept watching it, and were wondering about distance and elevation, thinking perhaps it was either a satellite or a high-flying aircraft--nothing out of the ordinary. Then it came to a complete stop, reversed direction 180 degrees, and whizzed off so fast it was out of sight in less than a second or two. So my first response was, \"Do you think it was a UFO?\" Again with the cocked eyebrow he said, \"I don't want to use that word. All I will say is that what we witnessed completely and utterly defies all laws of aerodynamics that I'm familiar with. I'm not aware of any aircraft--military or otherwise--that can do that. It's beyond my abilities to explain; that's all I'm willing to say.\" To contrast this story, I will also say that one time we were watching a campy, early 80's Fox program that was reporting on the US government harboring aliens. At one point in the story, they started talking about a particular installation in the mountains of Nevada (not area 51) that's being used as a landing zone for UFO's. Dad started laughing so hard I thought he was going to fall off the couch. He looked at me and said, \"I know what they do there.\" I said, \"And???\" He replied, \"I can't tell you that, but I CAN tell you they're NOT landing UFO's.\" Total buzz kill. Anyway, that's the story I wanted to relate in the hopes that others can add their own. Thanks for reading.",
		"thread_title": "A Pilots Experience",
		"title": "A Pilots Experience",
		"type": "bs",
		"uuid": "2cc24dacadc4fa950e9a4a2ff8070044ca1fdf04"
	},
	"-KhIa1yLtPerbxE170Oj": {
		"author": "Kantzveldt",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:29.874+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/025sf8x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silver"
				},
				"name": "Silver",
				"salience": 0.31127357,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wv_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moon"
				},
				"name": "The Moon",
				"salience": 0.11832699,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03ld5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Heaven"
				},
				"name": "Heavens",
				"salience": 0.045077987,
				"type": "LOCATION"
			},
			{
				"name": "Hapantali",
				"salience": 0.03579565,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0410_fc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Weather_god"
				},
				"name": "Storm God",
				"salience": 0.0355785,
				"type": "PERSON"
			},
			{
				"name": "Kamrusepa",
				"salience": 0.035152175,
				"type": "PERSON"
			},
			{
				"name": "trade",
				"salience": 0.01544697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k80",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anatolia"
				},
				"name": "Anatolia",
				"salience": 0.0149688665,
				"type": "LOCATION"
			},
			{
				"name": "text",
				"salience": 0.012774414,
				"type": "WORK_OF_ART"
			},
			{
				"name": "luminaries",
				"salience": 0.0116866585,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ttpb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taurus_Mountains"
				},
				"name": "Taurus",
				"salience": 0.0114844665,
				"type": "ORGANIZATION"
			},
			{
				"name": "myth",
				"salience": 0.010391256,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.010391256,
				"type": "LOCATION"
			},
			{
				"name": "gate complex",
				"salience": 0.010391256,
				"type": "LOCATION"
			},
			{
				"name": "regards",
				"salience": 0.009385704,
				"type": "OTHER"
			},
			{
				"name": "rain",
				"salience": 0.009267834,
				"type": "OTHER"
			},
			{
				"name": "rains",
				"salience": 0.009267834,
				"type": "OTHER"
			},
			{
				"name": "silver",
				"salience": 0.009019947,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.00870024,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.008130915,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.008130915,
				"type": "OTHER"
			},
			{
				"name": "text",
				"salience": 0.007903957,
				"type": "OTHER"
			},
			{
				"name": "gate complex",
				"salience": 0.006466763,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.005353985,
				"type": "OTHER"
			},
			{
				"name": "identification",
				"salience": 0.0053322464,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0053156936,
				"type": "LOCATION"
			},
			{
				"name": "words",
				"salience": 0.0053156936,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0pxkt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anatolian_languages"
				},
				"name": "Anatolian",
				"salience": 0.005009949,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0048003206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0755b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scorpion"
				},
				"name": "Scorpion",
				"salience": 0.0046340795,
				"type": "ORGANIZATION"
			},
			{
				"name": "anxiety",
				"salience": 0.0041575017,
				"type": "OTHER"
			},
			{
				"name": "Fear",
				"salience": 0.0041575017,
				"type": "OTHER"
			},
			{
				"name": "spell",
				"salience": 0.0041575017,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0041575017,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f78w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/K%C3%BCltepe"
				},
				"name": "Kultepe",
				"salience": 0.0038169094,
				"type": "LOCATION"
			},
			{
				"name": "bull",
				"salience": 0.0036855745,
				"type": "OTHER"
			},
			{
				"name": "myth",
				"salience": 0.003521632,
				"type": "OTHER"
			},
			{
				"name": "Kanes",
				"salience": 0.0029646382,
				"type": "LOCATION"
			},
			{
				"name": "allegory",
				"salience": 0.0029340198,
				"type": "OTHER"
			},
			{
				"name": "Goddess",
				"salience": 0.0028734214,
				"type": "PERSON"
			},
			{
				"name": "silver",
				"salience": 0.0028329217,
				"type": "OTHER"
			},
			{
				"name": "gate complex",
				"salience": 0.0027862014,
				"type": "OTHER"
			},
			{
				"name": "centre",
				"salience": 0.0027862014,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.0026348243,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.0025479025,
				"type": "OTHER"
			},
			{
				"name": "textiles",
				"salience": 0.0025288616,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02wkmf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Assur"
				},
				"name": "Assur",
				"salience": 0.0024663373,
				"type": "LOCATION"
			},
			{
				"name": "Silver Mountains",
				"salience": 0.0024577356,
				"type": "LOCATION"
			},
			{
				"name": "Father",
				"salience": 0.0024369676,
				"type": "PERSON"
			},
			{
				"name": "trade",
				"salience": 0.0023704225,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0021899417,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0021418452,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0019787536,
				"type": "OTHER"
			},
			{
				"name": "tin",
				"salience": 0.0019773722,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.0019773722,
				"type": "OTHER"
			},
			{
				"name": "essence",
				"salience": 0.0018013828,
				"type": "OTHER"
			},
			{
				"name": "wisdom",
				"salience": 0.0017866682,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0017123108,
				"type": "OTHER"
			},
			{
				"name": "lapis lazuli",
				"salience": 0.0017123108,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0017123108,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0017123108,
				"type": "PERSON"
			},
			{
				"name": "gates",
				"salience": 0.0017071335,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0016621772,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ttpb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taurus_Mountains"
				},
				"name": "Taurus Mountains",
				"salience": 0.0016443642,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ttsp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cilician_Gates"
				},
				"name": "Cilician Gates",
				"salience": 0.0015567972,
				"type": "LOCATION"
			},
			{
				"name": "accounts",
				"salience": 0.0015567476,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.001535587,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.001535587,
				"type": "OTHER"
			},
			{
				"name": "inter-section point",
				"salience": 0.001535587,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.001535587,
				"type": "EVENT"
			},
			{
				"name": "Kubbabar-Anzu",
				"salience": 0.0015193464,
				"type": "ORGANIZATION"
			},
			{
				"name": "tablets",
				"salience": 0.0015084149,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07fgx8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ishara"
				},
				"name": "Ishara",
				"salience": 0.0014952163,
				"type": "PERSON"
			},
			{
				"name": "field",
				"salience": 0.0014797646,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.0014782748,
				"type": "LOCATION"
			},
			{
				"name": "ideogram",
				"salience": 0.0014706451,
				"type": "OTHER"
			},
			{
				"name": "Silver Mountain",
				"salience": 0.0014615391,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0013864968,
				"type": "OTHER"
			},
			{
				"name": "underworld",
				"salience": 0.0013864968,
				"type": "OTHER"
			},
			{
				"name": "symbolism",
				"salience": 0.0013864968,
				"type": "OTHER"
			},
			{
				"name": "Anatoian",
				"salience": 0.0013480815,
				"type": "PERSON"
			},
			{
				"name": "symbol",
				"salience": 0.001334746,
				"type": "OTHER"
			},
			{
				"name": "concept idea",
				"salience": 0.001334746,
				"type": "OTHER"
			},
			{
				"name": "Tessub",
				"salience": 0.0013171571,
				"type": "OTHER"
			},
			{
				"name": "silver",
				"salience": 0.0013073988,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dmdx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hurrians"
				},
				"name": "Hurrians",
				"salience": 0.0012862257,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05vny2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kumarbi"
				},
				"name": "Kumarbi",
				"salience": 0.0012596428,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.0012536248,
				"type": "LOCATION"
			},
			{
				"name": "conflict",
				"salience": 0.0012536248,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025sk5n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tin"
				},
				"name": "Tin",
				"salience": 0.001217187,
				"type": "OTHER"
			},
			{
				"name": "Song",
				"salience": 0.001206831,
				"type": "WORK_OF_ART"
			},
			{
				"name": "same",
				"salience": 0.001205988,
				"type": "OTHER"
			},
			{
				"name": "Queen",
				"salience": 0.0012006015,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0012006015,
				"type": "OTHER"
			},
			{
				"name": "gods",
				"salience": 0.0012006015,
				"type": "PERSON"
			},
			{
				"name": "terms",
				"salience": 0.0012006015,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.0012006015,
				"type": "OTHER"
			},
			{
				"name": "emergence",
				"salience": 0.0012006015,
				"type": "OTHER"
			},
			{
				"name": "entrance",
				"salience": 0.0012006015,
				"type": "OTHER"
			},
			{
				"name": "wannumiyas DUMU",
				"salience": 0.0011578939,
				"type": "PERSON"
			},
			{
				"name": "trade colony",
				"salience": 0.0011557859,
				"type": "OTHER"
			},
			{
				"name": "purity",
				"salience": 0.0011557859,
				"type": "OTHER"
			},
			{
				"name": "refinement",
				"salience": 0.0011557859,
				"type": "OTHER"
			},
			{
				"name": "caravans",
				"salience": 0.0011557859,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "example",
				"salience": 0.0011557859,
				"type": "OTHER"
			},
			{
				"name": "bronze",
				"salience": 0.0011557859,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vsg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Solar_deity"
				},
				"name": "Sun God",
				"salience": 0.0011529503,
				"type": "PERSON"
			},
			{
				"name": "specialists",
				"salience": 0.0011482998,
				"type": "PERSON"
			},
			{
				"name": "heaven",
				"salience": 0.0011423421,
				"type": "LOCATION"
			},
			{
				"name": "boy",
				"salience": 0.0011318974,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.0011318974,
				"type": "WORK_OF_ART"
			},
			{
				"name": "men",
				"salience": 0.0011318974,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0011318974,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0011318974,
				"type": "OTHER"
			},
			{
				"name": "wisdom",
				"salience": 0.0011318974,
				"type": "OTHER"
			},
			{
				"name": "regards",
				"salience": 0.0011318974,
				"type": "OTHER"
			},
			{
				"name": "The Songs",
				"salience": 0.0011145779,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Fine",
				"salience": 0.0010442841,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0010137009,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0010098116,
				"type": "OTHER"
			},
			{
				"name": "disputes",
				"salience": 0.0009801238,
				"type": "EVENT"
			},
			{
				"name": "cycle",
				"salience": 0.0009801238,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0009801238,
				"type": "EVENT"
			},
			{
				"name": "hunger",
				"salience": 0.0009801238,
				"type": "OTHER"
			},
			{
				"name": "Abundance",
				"salience": 0.0009801238,
				"type": "PERSON"
			},
			{
				"name": "sp1endor",
				"salience": 0.0009801238,
				"type": "PERSON"
			},
			{
				"name": "g1ory",
				"salience": 0.0009801238,
				"type": "OTHER"
			},
			{
				"name": "grain",
				"salience": 0.00095557695,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bqvp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sky"
				},
				"name": "Sky",
				"salience": 0.00094517635,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Song of Silver",
				"salience": 0.00094517635,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.0009364791,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00089296215,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06pgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scorpius"
				},
				"name": "Scorpio",
				"salience": 0.00085338886,
				"type": "OTHER"
			},
			{
				"name": "boy",
				"salience": 0.00084553595,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.00084553595,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.00084553595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0lh4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Underworld"
				},
				"name": "Underworld",
				"salience": 0.00082152954,
				"type": "WORK_OF_ART"
			},
			{
				"name": "texts",
				"salience": 0.00078764785,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02d9wb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Destiny"
				},
				"name": "Destiny",
				"salience": 0.00073894847,
				"type": "ORGANIZATION"
			},
			{
				"name": "Sauska Nineveh",
				"salience": 0.00073894847,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02jkq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ecliptic"
				},
				"name": "Ecliptic",
				"salience": 0.00073894847,
				"type": "ORGANIZATION"
			},
			{
				"name": "Galactic",
				"salience": 0.00073894847,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/077r8d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gemini_(constellation)"
				},
				"name": "Gemini",
				"salience": 0.00073894847,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06242s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cosmology"
				},
				"name": "Cosmological",
				"salience": 0.00073894847,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.00073214824,
				"type": "OTHER"
			},
			{
				"name": "spear",
				"salience": 0.00073214824,
				"type": "OTHER"
			},
			{
				"name": "reverence",
				"salience": 0.00073214824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gf0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Susa"
				},
				"name": "Susa",
				"salience": 0.0007113602,
				"type": "LOCATION"
			},
			{
				"name": "Nesi",
				"salience": 0.0007113602,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cx45",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Temple"
				},
				"name": "Temple",
				"salience": 0.0007113602,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k0gz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cilicia"
				},
				"name": "Cilician",
				"salience": 0.0007113602,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0wmn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Assyria"
				},
				"name": "Assyrian",
				"salience": 0.0007113602,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z5y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Asia"
				},
				"name": "Central Asia",
				"salience": 0.0007113602,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02hdtz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elamite_language"
				},
				"name": "Elamite",
				"salience": 0.0007113602,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0007079767,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00069593097,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vwwj1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sun_and_Moon_(Middle-earth)"
				},
				"name": "Sun and Moon",
				"salience": 0.0006656294,
				"type": "ORGANIZATION"
			},
			{
				"name": "pity",
				"salience": 0.0006560987,
				"type": "OTHER"
			},
			{
				"name": "centre",
				"salience": 0.0006482826,
				"type": "LOCATION"
			},
			{
				"name": "The Sun and the Moon",
				"salience": 0.0006421592,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cults",
				"salience": 0.00061578234,
				"type": "OTHER"
			},
			{
				"name": "Gold",
				"salience": 0.00061578234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01slhg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ebla"
				},
				"name": "Ebla",
				"salience": 0.0006032273,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/017ygw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Byblos"
				},
				"name": "Byblos",
				"salience": 0.0006032273,
				"type": "LOCATION"
			},
			{
				"name": "father",
				"salience": 0.0005927913,
				"type": "PERSON"
			},
			{
				"name": "text",
				"salience": 0.0005883577,
				"type": "WORK_OF_ART"
			},
			{
				"name": "person-ally",
				"salience": 0.0005331982,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0005331982,
				"type": "OTHER"
			},
			{
				"name": "qualities",
				"salience": 0.0005331982,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0005331982,
				"type": "OTHER"
			},
			{
				"name": "love.",
				"salience": 0.0005331982,
				"type": "OTHER"
			},
			{
				"name": "lands",
				"salience": 0.0005331982,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09d_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mountain"
				},
				"name": "Mountains",
				"salience": 0.00051203027,
				"type": "LOCATION"
			},
			{
				"name": "conflict",
				"salience": 0.0005094508,
				"type": "OTHER"
			},
			{
				"name": "mythos",
				"salience": 0.0005094508,
				"type": "OTHER"
			},
			{
				"name": "cult",
				"salience": 0.00045996922,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.00045996922,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.00045996922,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.00045996922,
				"type": "OTHER"
			},
			{
				"name": "pity",
				"salience": 0.00045996922,
				"type": "OTHER"
			},
			{
				"name": "orphan",
				"salience": 0.00045996922,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0642tj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sumerian_religion"
				},
				"name": "Sumerian",
				"salience": 0.00044818447,
				"type": "OTHER"
			},
			{
				"name": "consternation",
				"salience": 0.00043170256,
				"type": "OTHER"
			},
			{
				"name": "Hittitologists",
				"salience": 0.00039827812,
				"type": "PERSON"
			},
			{
				"name": "association",
				"salience": 0.00039827812,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.00039827812,
				"type": "OTHER"
			},
			{
				"name": "metallurgy industry",
				"salience": 0.00039827812,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.00039827812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.00037896764,
				"type": "LOCATION"
			},
			{
				"name": "DUMU",
				"salience": 0.00033938355,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03m72yx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dumuzid,_the_Fisherman"
				},
				"name": "Dumuzid",
				"salience": 0.00033938355,
				"type": "PERSON"
			},
			{
				"name": "Allani",
				"salience": 0.00032813902,
				"type": "PERSON"
			},
			{
				"name": "ChicagoThursday2731",
				"salience": 0.00032813902,
				"type": "LOCATION"
			},
			{
				"name": "Kam1031300vAmerica",
				"salience": 0.00032813902,
				"type": "OTHER"
			},
			{
				"name": "Kantzveldt",
				"salience": 0.00032813902,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03091h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anz%C3%BB_(mythology)"
				},
				"name": "Anzu",
				"salience": 0.0002830694,
				"type": "PERSON"
			},
			{
				"name": "City of Dumuzid",
				"salience": 0.00025785968,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bad-Tivira",
				"salience": 0.00024510172,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01l05y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ninurta"
				},
				"name": "Ninurta",
				"salience": 0.00024510172,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02bqhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Divine_retribution"
				},
				"name": "Divine",
				"salience": 0.00024510172,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d7mh7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damu"
				},
				"name": "Damu",
				"salience": 0.00024510172,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats8.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:29.874+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "The Moon that Fell from Heaven page: 1 link There is an intriguing text from Anatolian myth with regards to the Moon falling from Heaven; The Moon God fell from the sky and fell upon the gate complex, but no one saw him. The Storm God sent rain after him; he sent rains after him. Fear seized him; anxiety seized him. The god Hapantali went there. He stood beside him and uttered over him the words of a spell. The goddess Kamrusepa looked down from the sky and said: \"What in the world has happened here? A good question from Kamrusepa there then, but the text is fragmentary and partial and the matter isn't really explained, so anyway the first question then is were was this gate complex and why couldn't he, the Moon, be seen having landed. My consideration is that the gate complex is that of the Cilician Gates , and that the Moon can no longer be seen as he has infused the Taurus Mountains with Silver. That region did relate to the Silver Mountains as several sources mention and was a major centre for the trade in Silver at Kultepe/Kanes; The essence of the trade was to ship tin, woolen textiles and lapis lazuli to Anatolia to sell it there in order to acquire, directly or indirectly, silver and gold, which was shipped back to Assur. Tin, essential for the Anatoian production of bronze was imported in Assur from Susa, perhaps by Elamite caravans, and ultimately originated from Central Asia. Assyrian trade colony at Kanes There are a great many tablets related to this trade recovered from Kultepe, on these sometimes can be seen the Taurus bull that bears upon it's back the Silver Mountain. Also seen beneath on that example is the Scorpion which was likely also an ideogram based upon the Cilician gates and greater region, also the symbol of Ishara the Goddess of the Silver Mountain and related to concept idea of the Moon within the Underworld, her symbolic metal silver and purity through refinement, the Temple of Ishara being at Kanes or Nesi to the Hurrians. There were a great many ideas bound up within this symbolism then, including in Cosmological terms the entrance into the underworld being above Taurus in Gemini, and it's opposite point of emergence in Scorpio, according to the inter-section point of the Galactic and Ecliptic planes. Were this gets interesting is that there is a Hurrian myth that relates to a conflict in the primeval period named The Song of Silver involving their tutelary God Tessub and his ongoing issues with Kumarbi, God of Destiny; Among Tessub, the Sun God of the Sky, Sauska Nineveh's Queen, and all the gods, no one worships him, although his power is greater than their power. His word is greater than their words, his wisdom is greater than their wisdom, his battle and his g1ory are greater than theirs. It is Silver the Fine of whom I sing. Wise men to1d me the story of the fatherless boy. It did not exist. Long ago Silver's Father had disappeared. And they do not know his sp1endor. Heroic men ran to battle. Abundance did not exist. And grain did not grow only hunger The Songs of the Kumarbi cycle can contain veiled allegory regarding ethnic disputes such as i outlined here with regards to Byblos and Ebla, it is likely the same in this case, conflict with the region of Nesa and the Silver Mountains, this however relating to a much earlier period, potentially also this relates to conflict from the Heavens as Silver could be named Kubbabar-Anzu as noted here the association with Anzu in conflict with Tessub relating to the same with Ninurta in the Sumerian mythos, and that seemingly from Anatolia. The identification of Silver as DUMU also correlates with the Sumerian notion of the Divine child as Damu, often seen as the basis for the cult of Dumuzid, were it was also the case that the City of Dumuzid, Bad-Tivira, was the centre of the Sumerian metallurgy industry. Silver is described in this text as a wannumiyas DUMU, which means a child whose father is dead or missing. Hittitologists generally translate this as \"orphan,\" Silver's consternation at being told by the orphan boy that he too was an orphan need not mean that he was discovering this for the first time. The Song of Silver again is fragmentary but does seem to involve Silver at some point establishing his power; Silver seized power with his hands. Silver seized the spear. He dragged the Sun and Moon down from heaven. The Sun and the Moon did reverence. They bowed to Silver. The Sun and the Moon began to speak to Silver: O Silver, our lord, do not strike/kill us! We are the luminaries of heaven and earth. We are the torches of what lands you govern. If you strike/kill us, you will proceed to govern the dark lands person-ally.\" His soul within him was filled with love.He had pity on them In dragging the Sun and the Moon down from Heaven again it could be considered that is what had infused the Mountains with Gold and Silver, but also it could relate to the establishment of the cults of Allani and Ishara at the time of silver, the spiritual qualities brought down to Earth. Hopefully in the future more complete accounts of these texts will emerge as they are most intriguing and almost completely overlooked apart from specialists in the field, which is a pity as they are more interesting than most. edit on Kam1031300vAmerica/ChicagoThursday2731 by Kantzveldt because: (no reason given)",
		"thread_title": "The Moon that Fell from Heaven",
		"title": "The Moon that Fell from Heaven",
		"type": "bs",
		"uuid": "1fd78022dd7187cabb8850950af33bb349375dc5"
	},
	"-KhIa2FBRpL3Z5aJACaO": {
		"author": "greg302",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:30.872+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "government agencies",
				"salience": 0.07568966,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0371d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Confabulation"
				},
				"name": "Mandela Effect",
				"salience": 0.06619453,
				"type": "OTHER"
			},
			{
				"name": "d computers",
				"salience": 0.0620214,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.058466125,
				"type": "OTHER"
			},
			{
				"name": "jokes",
				"salience": 0.054686397,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.049548525,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.035879634,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.035879634,
				"type": "OTHER"
			},
			{
				"name": "mankind",
				"salience": 0.035879634,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.035879634,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.035879634,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.032953482,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.023145625,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.022753472,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.02121488,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.017659746,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.017659746,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.015231573,
				"type": "PERSON"
			},
			{
				"name": "ones",
				"salience": 0.009887269,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "job",
				"salience": 0.009762863,
				"type": "OTHER"
			},
			{
				"name": "collider",
				"salience": 0.009689966,
				"type": "OTHER"
			},
			{
				"name": "Power",
				"salience": 0.009689966,
				"type": "OTHER"
			},
			{
				"name": "bully",
				"salience": 0.009124058,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.008667383,
				"type": "OTHER"
			},
			{
				"name": "bully",
				"salience": 0.007837546,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0075782235,
				"type": "OTHER"
			},
			{
				"name": "bullies",
				"salience": 0.007356514,
				"type": "OTHER"
			},
			{
				"name": "lunch money",
				"salience": 0.0071499585,
				"type": "OTHER"
			},
			{
				"name": "lunch money",
				"salience": 0.0071499585,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007082165,
				"type": "PERSON"
			},
			{
				"name": "bullies",
				"salience": 0.007082165,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.006935113,
				"type": "PERSON"
			},
			{
				"name": "collider",
				"salience": 0.0065431455,
				"type": "OTHER"
			},
			{
				"name": "d computers",
				"salience": 0.0065431455,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "2nd grade",
				"salience": 0.0061371755,
				"type": "EVENT"
			},
			{
				"name": "2nd grade",
				"salience": 0.0061371755,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.005870004,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.0057346732,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00554937,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0054440163,
				"type": "LOCATION"
			},
			{
				"name": "water bottles",
				"salience": 0.005314783,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0053077615,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.0051165,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.005010804,
				"type": "PERSON"
			},
			{
				"name": "liberation",
				"salience": 0.0045353486,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0044878027,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0043392186,
				"type": "OTHER"
			},
			{
				"name": "Shift",
				"salience": 0.0042845616,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.004146077,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.004146077,
				"type": "LOCATION"
			},
			{
				"name": "continuum",
				"salience": 0.004146077,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0038424153,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0037436003,
				"type": "OTHER"
			},
			{
				"name": "page book",
				"salience": 0.0035136617,
				"type": "WORK_OF_ART"
			},
			{
				"name": "all",
				"salience": 0.0034873942,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "Nasa",
				"salience": 0.0032718454,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/099rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CERN"
				},
				"name": "Cern",
				"salience": 0.0032718454,
				"type": "ORGANIZATION"
			},
			{
				"name": "fabric",
				"salience": 0.0032417465,
				"type": "OTHER"
			},
			{
				"name": "code",
				"salience": 0.0032417465,
				"type": "OTHER"
			},
			{
				"name": "self-journey",
				"salience": 0.0032417465,
				"type": "EVENT"
			},
			{
				"name": "any",
				"salience": 0.0032417465,
				"type": "OTHER"
			},
			{
				"name": "gain",
				"salience": 0.0032417465,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0028921468,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0027266564,
				"type": "OTHER"
			},
			{
				"name": "page book",
				"salience": 0.0027266564,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Real Light",
				"salience": 0.0026710785,
				"type": "OTHER"
			},
			{
				"name": "Pyron",
				"salience": 0.0026710785,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/073wh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spacetime"
				},
				"name": "Space Time",
				"salience": 0.0025521498,
				"type": "OTHER"
			},
			{
				"name": "pacman",
				"salience": 0.002391198,
				"type": "PERSON"
			},
			{
				"name": "existence",
				"salience": 0.0023610669,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.0023610669,
				"type": "OTHER"
			},
			{
				"name": "Revolution",
				"salience": 0.0023610669,
				"type": "EVENT"
			},
			{
				"name": "computers",
				"salience": 0.002255935,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "colliders",
				"salience": 0.002255935,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0020368686,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.0020368686,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.0020368686,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.0020368686,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.0017637336,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0017637336,
				"type": "OTHER"
			},
			{
				"name": "writing",
				"salience": 0.0017637336,
				"type": "OTHER"
			},
			{
				"name": "sciences",
				"salience": 0.0017637336,
				"type": "OTHER"
			},
			{
				"name": "row",
				"salience": 0.0017637336,
				"type": "OTHER"
			},
			{
				"name": "break",
				"salience": 0.0017637336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03p3bj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jumpgate"
				},
				"name": "Stargate",
				"salience": 0.0016920611,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "www.youtube.com",
				"salience": 0.0016023321,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:30.872+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link There is simply no more denying, for millions of people across whatever planet we are actually on now, that the Mandela Effect is the greatest and most important single event in the history of all mankind on every possible level. That's not in question anymore, the only remaining question left is \"Who done it?\". Will the real one responsible for this, please stand up? Now, because this is the biggest display of sheer Power, there are a lot of government agencies whose only job is to make you think that they have power who are sitting down and yelling \"we did it, we are the ones and we did it with our collider!\" And there's others sitting down and yelling \"we did it, with our d computers!\" These collider and d computers are jokes, they can't do anything, you can barely play pacman on them - they are just impressive looking things to you which make you scared of the people who want to control you. That's all they are. You people need to stop being scared of your bullies. Your bully who took you lunch money every day in the 2nd grade - is not the same person who caused a universal-earth-ending-space-time-continuum-Shift. This is real power. Whoever can do this, isn't the same bully who took your lunch money in the 2nd grade. Your government and Nasa and Cern are all a bunch of bullies, who throw water bottles at your head then when you turn around they point to the person next to them and call them a terrorist. That's all they have done throughout the years. But whoever did the Mandela Effect is entirely different from them, whoever did that has True and Real Light. I'll just go ahead and flatly state it for the whole world to hear - I, Pyron, created the Mandela Effect through metaphysical sciences through writing. No computers no colliders, only my mind and heart. It was my true desire to create a new world where those who control you will lose control. I wrote from age 12 to age 32, obsessively for 20 years in a row without break, I've been rejected by everyone the whole time, no one out there has been continuously rejected like I have, so I just kept on continuously going into my own space and writing more and more. Not caring about money or controlling people for selfish gain or any of that, I was just going on a self-journey. And in doing that, I cracked the code for the fabric of the Space Time continuum and opened up the Stargate. And I recorded every last thing that I did, and tell the whole world exactly how I did it and how everything occurred in a 50 page book - that I've put up for free on Youtube. This 50 page book is the liberation and the Revolution for every soul in all of existence, and I offer it for free here www.youtube.com...",
		"thread_title": "The Mandela Effect was made by one overlooked 33 year old man, an ascended master (video and proof)",
		"title": "The Mandela Effect was made by one overlooked 33 year old man, an ascended master (video and proof)",
		"type": "bs",
		"uuid": "5038ea5e8169278054669d45c9344f7d50b1243a"
	},
	"-KhIa2QFvrsQ_ovc39TF": {
		"author": "WindCharger",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:32.835+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "member",
				"salience": 0.17310429,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0760zn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Park_Geun-hye"
				},
				"name": "Park",
				"salience": 0.12282224,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0760689,
				"type": "PERSON"
			},
			{
				"name": "Shadow Government",
				"salience": 0.058681477,
				"type": "ORGANIZATION"
			},
			{
				"name": "Choi Sun-sil",
				"salience": 0.03985806,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.03435924,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.026764657,
				"type": "PERSON"
			},
			{
				"name": "rumor",
				"salience": 0.026628682,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.02511188,
				"type": "OTHER"
			},
			{
				"name": "treasury",
				"salience": 0.022113556,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.018212592,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.018212592,
				"type": "OTHER"
			},
			{
				"name": "The 8 Goddess",
				"salience": 0.017559303,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0760zn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Park_Geun-hye"
				},
				"name": "Park",
				"salience": 0.016943945,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.016075334,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06qd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Korea"
				},
				"name": "South Korea",
				"salience": 0.014370401,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.013110024,
				"type": "PERSON"
			},
			{
				"name": "Ancient Aliens",
				"salience": 0.011255521,
				"type": "PERSON"
			},
			{
				"name": "#",
				"salience": 0.0109653445,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.010426219,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.009636336,
				"type": "PERSON"
			},
			{
				"name": "joke rumor",
				"salience": 0.008705183,
				"type": "OTHER"
			},
			{
				"name": "whistleblower",
				"salience": 0.008705183,
				"type": "PERSON"
			},
			{
				"name": "whistleblower",
				"salience": 0.008705183,
				"type": "PERSON"
			},
			{
				"name": "President Park",
				"salience": 0.008247865,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/048fz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korea"
				},
				"name": "Korea",
				"salience": 0.007818325,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0078104567,
				"type": "PERSON"
			},
			{
				"name": "decisions",
				"salience": 0.007735752,
				"type": "OTHER"
			},
			{
				"name": "news conference",
				"salience": 0.0075765303,
				"type": "EVENT"
			},
			{
				"name": "billionaire",
				"salience": 0.0075428286,
				"type": "PERSON"
			},
			{
				"name": "tablets",
				"salience": 0.0075428286,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "veil",
				"salience": 0.0075428286,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0070143314,
				"type": "PERSON"
			},
			{
				"name": "PC",
				"salience": 0.006904549,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "LEAK",
				"salience": 0.006429067,
				"type": "OTHER"
			},
			{
				"name": "leak",
				"salience": 0.006112135,
				"type": "OTHER"
			},
			{
				"name": "toe toe",
				"salience": 0.005884695,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.005884695,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.0055280654,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0052948906,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.005097766,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.005097766,
				"type": "OTHER"
			},
			{
				"name": "text",
				"salience": 0.005097766,
				"type": "OTHER"
			},
			{
				"name": "ministers",
				"salience": 0.005097766,
				"type": "PERSON"
			},
			{
				"name": "secretaries",
				"salience": 0.005097766,
				"type": "PERSON"
			},
			{
				"name": "moves",
				"salience": 0.005097766,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.005097766,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0048101195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xhh5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Koreans"
				},
				"name": "Korean",
				"salience": 0.004649825,
				"type": "LOCATION"
			},
			{
				"name": "FORGIVENESS",
				"salience": 0.004324715,
				"type": "OTHER"
			},
			{
				"name": "anime plot tier ba",
				"salience": 0.004324715,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0030279462,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.0030093084,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0030093084,
				"type": "PERSON"
			},
			{
				"name": "Goddess",
				"salience": 0.00228619,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0022105356,
				"type": "LOCATION"
			},
			{
				"name": "jail",
				"salience": 0.0021121895,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0017597055,
				"type": "OTHER"
			},
			{
				"name": "diggings",
				"salience": 0.0016516554,
				"type": "OTHER"
			},
			{
				"name": "photos",
				"salience": 0.0016516554,
				"type": "WORK_OF_ART"
			},
			{
				"name": "father",
				"salience": 0.0016516554,
				"type": "PERSON"
			},
			{
				"name": "ambassador report documents",
				"salience": 0.0016516554,
				"type": "OTHER"
			},
			{
				"name": "whereabouts",
				"salience": 0.0015502336,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.001389301,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.001389301,
				"type": "OTHER"
			},
			{
				"name": "mystery",
				"salience": 0.0012818014,
				"type": "OTHER"
			},
			{
				"name": "Goddess",
				"salience": 0.001244275,
				"type": "OTHER"
			},
			{
				"name": "somewhere",
				"salience": 0.0012030741,
				"type": "LOCATION"
			},
			{
				"name": "body",
				"salience": 0.0012030741,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.0012030741,
				"type": "OTHER"
			},
			{
				"name": "Choi Tae-Min (Choi Sun Sil",
				"salience": 0.0011558428,
				"type": "PERSON"
			},
			{
				"name": "jail",
				"salience": 0.0011495184,
				"type": "LOCATION"
			},
			{
				"name": "jail",
				"salience": 0.0011495184,
				"type": "LOCATION"
			},
			{
				"name": "news conference",
				"salience": 0.0010379184,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0010167644,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.0008987662,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0008987662,
				"type": "PERSON"
			},
			{
				"name": "# loads",
				"salience": 0.0008987662,
				"type": "OTHER"
			},
			{
				"name": "informations",
				"salience": 0.0008987662,
				"type": "OTHER"
			},
			{
				"name": "EVERYONE PANIC",
				"salience": 0.0008987662,
				"type": "OTHER"
			},
			{
				"name": "WindCharger",
				"salience": 0.0008552055,
				"type": "PERSON"
			},
			{
				"name": "WindCharger",
				"salience": 0.0008552055,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0007405383,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats5.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:32.835+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Shadow Government in South Korea page: 1 archive.is... >being a ... >since 2~3 years ago there was Ancient Aliens tier rumor that president Park is indoctrinated and being controled by handful of secret society called \"8선녀 (The 8 Goddess)\", and they're ruling Korea from behind >everyone laughed at this crude joke rumor >suddenly a week ago whistleblower confirmed this # was real >the 8 powerful Korean billionaire women formed secret society and ruled Korea from behind the veil >whistleblower stole PC and tablets from them, opened to media, confirming they did it all >they made decisions, from Park's text of speeches, reforming taxes by their own, maintaining national treasury, deciding every diplomatic moves from toe toe, assigning secretaries and ministers by their own >only 1 members of The 8 Goddess identity confirmed, it's former psychic woman named 'Choi Sun-sil' >according to the leak she indoctrinated President Park since age of 23 >yes, a psychic woman who's member of secret society indoctrinated the president >I ain't joking >tfw everyone didn't believed this anime plot tier ba# insane absurd news >seriously who's gonna believe this >then suddenly president Park made news conference yesterday >SHE CONFIRMED THIS LEAK IS REAL AND ASKED FORGIVENESS >tfw a country's president confirming that she's indoctrinated by the secret society at the news conference >EVERYONE PANIC >people started to get #s together >gathering informations about them >after digging it's confirmed that # loads of men are in jail right now for leaking the truth about The 8 Goddess >politicians who's in jail right now mentioned Choi and 8 Goddess right before they went jail >people found photos that Choi escorting Park since her age of early 20's >diggings found US ambassador report documents >it saying \"Choi Tae-Min (Choi Sun Sil's father) is fully control of Park's body and soul\" >Choi Sun Sil's whereabouts is mystery, she's somewhere in Germany edit on 27-10-2016 by WindCharger because: (no reason given) edit on 27-10-2016 by WindCharger because: (no reason given)",
		"thread_title": "Shadow Government in South Korea",
		"title": "Shadow Government in South Korea",
		"type": "bs",
		"uuid": "95d9b99598f9eea4ac370e7bbec3ef64c83e15ed"
	},
	"-KhIa2YtDfwZ3-AL-BI8": {
		"author": "ConnectDots",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:34.830+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Mary Rodwell",
				"salience": 0.39372832,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.2680453,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.080491185,
				"type": "PERSON"
			},
			{
				"name": "kids",
				"salience": 0.028859427,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.024951223,
				"type": "OTHER"
			},
			{
				"name": "New Book The New Human",
				"salience": 0.020113906,
				"type": "PERSON"
			},
			{
				"name": "Project Camelot",
				"salience": 0.016442714,
				"type": "ORGANIZATION"
			},
			{
				"name": "liar",
				"salience": 0.012829247,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0114312535,
				"type": "WORK_OF_ART"
			},
			{
				"name": "words",
				"salience": 0.009342715,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.008445488,
				"type": "OTHER"
			},
			{
				"name": "resource",
				"salience": 0.007696671,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.006120525,
				"type": "EVENT"
			},
			{
				"name": "seat belt",
				"salience": 0.005302065,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.005302065,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.005302065,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.004613316,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.0045258724,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.0042951736,
				"type": "EVENT"
			},
			{
				"name": "chance",
				"salience": 0.0040649497,
				"type": "OTHER"
			},
			{
				"name": "Encounters",
				"salience": 0.0037202705,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0037202705,
				"type": "OTHER"
			},
			{
				"name": "offense",
				"salience": 0.0037202705,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.003581628,
				"type": "OTHER"
			},
			{
				"name": "experiencers",
				"salience": 0.003581628,
				"type": "PERSON"
			},
			{
				"name": "contents",
				"salience": 0.003581628,
				"type": "OTHER"
			},
			{
				"name": "regressionist",
				"salience": 0.003581628,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0035077191,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0035077191,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0033517687,
				"type": "PERSON"
			},
			{
				"name": "space kids",
				"salience": 0.0033517687,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0030705403,
				"type": "OTHER"
			},
			{
				"name": "sh*t",
				"salience": 0.003038027,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0026213513,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0024420845,
				"type": "PERSON"
			},
			{
				"name": "ConnectDots",
				"salience": 0.0022912505,
				"type": "OTHER"
			},
			{
				"name": "Foundation for Research",
				"salience": 0.0022912505,
				"type": "ORGANIZATION"
			},
			{
				"name": "phrases",
				"salience": 0.002270187,
				"type": "OTHER"
			},
			{
				"name": "jargon",
				"salience": 0.002270187,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.002086819,
				"type": "OTHER"
			},
			{
				"name": "crazies",
				"salience": 0.0019096824,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0019096824,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0019096824,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0018618886,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.001824703,
				"type": "PERSON"
			},
			{
				"name": "telepathy",
				"salience": 0.0016537628,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.0016537628,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0016537628,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crazies",
				"salience": 0.001426784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b2pbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gee_(Girls'_Generation_song)"
				},
				"name": "Gee",
				"salience": 0.00070479483,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:34.830+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Mary Rodwell's New Book The New Human page: 1 link Go ahead and spout this is Project Camelot it's BS. You'll be wrong. Go ahead and call Mary Rodwell a liar she's just doing this for the money. You'll be wrong. This is what I have to say to open-minded individuals reading this: Put your seat belt on! In this interview, hypnotherapist and regressionist Mary Rodwell talks about the contents of her new book, The New Human , which apparently is soon to be released: For experiencers looking for a resource where you'll be treated with respect and have a chance to communicate, the organization Mary talked about in the interview is FREE, for Foundation for Research into Extra-terrestrial Encounters. link a reply to: ConnectDots No offense but these people just sound completely full of sh*t. They present no evidence of anything but talk wildly about stuff that I don't even think they understand and use words that just sound interesting but are totally made up BS. They just talk to other crazies and kids and believe anything they hear and then repeat it. Gee, some little kids tell you they don't like school or don't get along with other kids so that makes them multidimensional space kids with mental powers???? Come on They love to drop cool sounding phrases built from psudo scientific jargon but I don't think they even understand what the words mean. They talk about telepathy and mental powers and stuff but do they have any evidence of it or just a bunch of stories made up from kids and crazies???",
		"thread_title": "Mary Rodwells New Book The New Human",
		"title": "Mary Rodwells New Book The New Human",
		"type": "bs",
		"uuid": "1b7bd11157445d9e322bcf0717763b714cdcf37b"
	},
	"-KhIa2h-9h8BdXxIflEs": {
		"author": "Vasa Croe",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:37.543+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02ys79",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reed_Hastings"
				},
				"name": "Reed Hastings",
				"salience": 0.45926094,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.14926375,
				"type": "ORGANIZATION"
			},
			{
				"name": "CEO",
				"salience": 0.076945044,
				"type": "PERSON"
			},
			{
				"name": "Everyone",
				"salience": 0.034490634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03d556z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_chill"
				},
				"name": "Chill",
				"salience": 0.02296328,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.02173675,
				"type": "OTHER"
			},
			{
				"name": "Chill Pill",
				"salience": 0.020807015,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.02055025,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "concept",
				"salience": 0.017233495,
				"type": "OTHER"
			},
			{
				"name": "movies",
				"salience": 0.014701184,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pill",
				"salience": 0.014467208,
				"type": "OTHER"
			},
			{
				"name": "brand",
				"salience": 0.013832739,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.013344363,
				"type": "OTHER"
			},
			{
				"name": "entertainment pills",
				"salience": 0.007278464,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.0068943566,
				"type": "ORGANIZATION"
			},
			{
				"name": "thing",
				"salience": 0.0068830717,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0058401674,
				"type": "OTHER"
			},
			{
				"name": "product name",
				"salience": 0.0057191523,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0057191523,
				"type": "OTHER"
			},
			{
				"name": "tech conference",
				"salience": 0.0057191523,
				"type": "EVENT"
			},
			{
				"name": "pill",
				"salience": 0.0054423995,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0262yfc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hastings_Entertainment"
				},
				"name": "Hastings",
				"salience": 0.005158481,
				"type": "LOCATION"
			},
			{
				"name": "rage",
				"salience": 0.0047910954,
				"type": "OTHER"
			},
			{
				"name": "entertainment",
				"salience": 0.004534896,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.004013275,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article",
				"salience": 0.0039628,
				"type": "WORK_OF_ART"
			},
			{
				"name": "TV shows",
				"salience": 0.0038637423,
				"type": "WORK_OF_ART"
			},
			{
				"name": "substitutes",
				"salience": 0.0038637423,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0032774215,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.0032774215,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0032774215,
				"type": "ORGANIZATION"
			},
			{
				"name": "pill",
				"salience": 0.0029645646,
				"type": "OTHER"
			},
			{
				"name": "Netflix and Chill",
				"salience": 0.0025070377,
				"type": "ORGANIZATION"
			},
			{
				"name": "thing",
				"salience": 0.0024696225,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0024491798,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.0024491798,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02qc9_6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pharmaceutical_lobby"
				},
				"name": "BIG PHARMA",
				"salience": 0.0023305777,
				"type": "OTHER"
			},
			{
				"name": "movie",
				"salience": 0.0020602918,
				"type": "WORK_OF_ART"
			},
			{
				"name": "entertainment purposes",
				"salience": 0.0020602918,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.0020343498,
				"type": "OTHER"
			},
			{
				"name": "youth",
				"salience": 0.0017842138,
				"type": "PERSON"
			},
			{
				"name": "pharmacy",
				"salience": 0.0015393498,
				"type": "OTHER"
			},
			{
				"name": "entertainment purposes",
				"salience": 0.0015393498,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0013330223,
				"type": "OTHER"
			},
			{
				"name": "legalization",
				"salience": 0.0013330223,
				"type": "OTHER"
			},
			{
				"name": "Anywho",
				"salience": 0.0010983911,
				"type": "PERSON"
			},
			{
				"name": "phrase",
				"salience": 0.0009346843,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:37.543+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Everyone is familiar with the saying 'Netflix and Chill,' but Netflix CEO Reed Hastings has an even better idea, 'Netflix and Chill Pill.' That's not the actual brand or product name, but more of a concept that Hastings introduced at a recent tech conference for the Wall Street Journal. When speaking about the future of Netflix, Hastings said that, while movies and TV shows may be all the rage now, he anticipates they'll eventually become obsolete and will be rivaled by pharmaceutical substitutes, \"like a pill that entertains you.\" This according to a tweet from the Wall Street Journal. Netflix's CEO says entertainment pills could be the next big thing This article struck me as funny....so Netflix own CEO is saying the next big thing in entertainment at home is a pill? I wonder how close his ties are with BIG PHARMA? This is a really crazy thing for a CEO of a major company to be suggesting....drugs for entertainment purposes...sounds like he is trying to progress towards legalization of something to actually entertain us while we watch TV. Coming soon to a pharmacy near you...The Netflix and Chill Pill....knowing what \"Netflix and Chill\" actually means I think the phrase he used kinda promotes rape in the form he said it though....\"here baby...take this pill before we start the movie....don't worry....it is for entertainment purposes\" Anywho....just the next big thing in drugs for our mindless youth to get caught up in!",
		"thread_title": "Netflixs CEO says entertainment pills could be the next big thing",
		"title": "Netflixs CEO says entertainment pills could be the next big thing",
		"type": "bs",
		"uuid": "4e6d02982140f6a190eaf2b3e290eebfe48e697d"
	},
	"-KhIa2otjeKIzvDcJKrn": {
		"author": "IAMTAT",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:39.991+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "election",
				"salience": 0.1764401,
				"type": "EVENT"
			},
			{
				"name": "powers",
				"salience": 0.13717462,
				"type": "OTHER"
			},
			{
				"name": "IAMTAT",
				"salience": 0.13552107,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.13552107,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.05723546,
				"type": "OTHER"
			},
			{
				"name": "conspiracies",
				"salience": 0.037616387,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.029484637,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.023319917,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.02163762,
				"type": "EVENT"
			},
			{
				"name": "elite",
				"salience": 0.021526651,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.020834997,
				"type": "EVENT"
			},
			{
				"name": "beast system",
				"salience": 0.020728117,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.019959012,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.019959012,
				"type": "PERSON"
			},
			{
				"name": "bit",
				"salience": 0.019959012,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.016940938,
				"type": "OTHER"
			},
			{
				"name": "consolidation",
				"salience": 0.01619022,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.01619022,
				"type": "EVENT"
			},
			{
				"name": "interest corruption",
				"salience": 0.014624847,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.012671077,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.012046536,
				"type": "OTHER"
			},
			{
				"name": "cement",
				"salience": 0.009237433,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.009237433,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.007971802,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.007971802,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:39.991+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "a reply to: IAMTAT I like knowing that the powers of good are working quite effectively in the background. This election has opened up so much in the way of \"conspiracies\" that the average person paying even the slightest bit of attention have been exposed to how it actually works. I think we will continue to see this corrupt beast system brought into the light, regardless of the election, the elite have lost control. I really hope you're right. MY eyes have been REALLY opened to the corruption and the control. THIS election is about consolidation of a long construction of establishment/outside interest corruption spanning decades and both parties. It needs to be brought down before the cement hardens.",
		"thread_title": "RELEASE: The Podesta Emails Part 20",
		"title": "RELEASE: The Podesta Emails Part 20",
		"type": "bs",
		"uuid": "3c3baf87a65e8ccd772129b63bf70b3edb563d72"
	},
	"-KhIa3-PfoPcQZ6nsZN9": {
		"author": "crazyewok",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:45.095+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "tensions",
				"salience": 0.12630035,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.113593064,
				"type": "LOCATION"
			},
			{
				"name": "decision",
				"salience": 0.086358786,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.07604722,
				"type": "EVENT"
			},
			{
				"name": "objector",
				"salience": 0.06879594,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.05971539,
				"type": "OTHER"
			},
			{
				"name": "horizon",
				"salience": 0.05971539,
				"type": "OTHER"
			},
			{
				"name": "objector page",
				"salience": 0.05971539,
				"type": "OTHER"
			},
			{
				"name": "None",
				"salience": 0.017643552,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.016234197,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.015313352,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.01494162,
				"type": "LOCATION"
			},
			{
				"name": "War",
				"salience": 0.012768774,
				"type": "EVENT"
			},
			{
				"name": "fight",
				"salience": 0.0127030555,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.0127030555,
				"type": "OTHER"
			},
			{
				"name": "saftey",
				"salience": 0.0127030555,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.011827599,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.0115954755,
				"type": "LOCATION"
			},
			{
				"name": "ground",
				"salience": 0.011480805,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.010291245,
				"type": "PERSON"
			},
			{
				"name": "reliavance",
				"salience": 0.010245383,
				"type": "OTHER"
			},
			{
				"name": "self defence",
				"salience": 0.009907936,
				"type": "OTHER"
			},
			{
				"name": "defence",
				"salience": 0.009907936,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0089539755,
				"type": "OTHER"
			},
			{
				"name": "opinion violence",
				"salience": 0.008581925,
				"type": "OTHER"
			},
			{
				"name": "disgrafully",
				"salience": 0.008581925,
				"type": "OTHER"
			},
			{
				"name": "curmstances",
				"salience": 0.008581925,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.008404866,
				"type": "OTHER"
			},
			{
				"name": "fingers",
				"salience": 0.0072796224,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.0072796224,
				"type": "OTHER"
			},
			{
				"name": "Russias",
				"salience": 0.00675874,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.006281341,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.006281341,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.006281341,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.005869568,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ndwhc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimea"
				},
				"name": "Crimea",
				"salience": 0.005490446,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.005490446,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.005490446,
				"type": "LOCATION"
			},
			{
				"name": "services",
				"salience": 0.005473683,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.0054399786,
				"type": "OTHER"
			},
			{
				"name": "coward",
				"salience": 0.0054399786,
				"type": "OTHER"
			},
			{
				"name": "crazyewok",
				"salience": 0.004576203,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.004576203,
				"type": "OTHER"
			},
			{
				"name": "crazyewok",
				"salience": 0.004576203,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.004576203,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0039629946,
				"type": "EVENT"
			},
			{
				"name": "sides",
				"salience": 0.0034191164,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0029608333,
				"type": "EVENT"
			},
			{
				"name": "call",
				"salience": 0.0029608333,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.0029608333,
				"type": "OTHER"
			},
			{
				"name": "exception",
				"salience": 0.0029608333,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:45.095+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "I declare myself a conscientious objector page: 1 link With tensions as they are and a war on the horizon I have decided to declare myself a conscientious objector. The UK does not need to start a war in Syria, it does not need to start fight with Russia. None of that has any reliavance to the UK or its saftey! In fact it would make us more unsafe! War in these curmstances would not be for my defence. And in my opinion violence is only nessary or justified in self defence. Russias leaders have acted disgrafully. But our leaders in the USA and UK are equally as bad. For every Crimea there's a Iraq, for every Syria a Libya. There is no moral high ground, the USA or UK has no right to point fingers, nor does Russia. I will therefore refuse to support (directly or indirectly), take part in or contribute (beyond taxes) anything. My only exception being unarmed medical services that I will give neutrally to BOTH sides equally. In the unlikely event of a call up I will choose prison. I will not actively support or aid the other side beyond medical and humanitarian aid. Call me a traitor, a coward or anything you like, this is my decision . I want NO part in any looming conflict. edit on 27-10-2016 by crazyewok because: (no reason given) edit on 27-10-2016 by crazyewok because: (no reason given)",
		"thread_title": "I declare myself a conscientious objector",
		"title": "I declare myself a conscientious objector",
		"type": "bs",
		"uuid": "b6cc7380db7ec6eb1dca0ef30a80a81a9ec551b4"
	},
	"-KhIa3J6y2X-phjZ5hXO": {
		"author": "BlueShaman",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:47.441+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.4224941,
				"type": "PERSON"
			},
			{
				"name": "Molly Forbes",
				"salience": 0.2532889,
				"type": "PERSON"
			},
			{
				"name": "widow",
				"salience": 0.049668342,
				"type": "PERSON"
			},
			{
				"name": "property",
				"salience": 0.04070982,
				"type": "OTHER"
			},
			{
				"name": "stream water",
				"salience": 0.020328524,
				"type": "OTHER"
			},
			{
				"name": "granny",
				"salience": 0.019077133,
				"type": "PERSON"
			},
			{
				"name": "grandmother",
				"salience": 0.016129956,
				"type": "PERSON"
			},
			{
				"name": "Heartless Trump",
				"salience": 0.0139426105,
				"type": "PERSON"
			},
			{
				"name": "water supply page",
				"salience": 0.0138477925,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0138477925,
				"type": "OTHER"
			},
			{
				"name": "wheelbarrow",
				"salience": 0.0138477925,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "builders",
				"salience": 0.0138477925,
				"type": "PERSON"
			},
			{
				"name": "property developer",
				"salience": 0.01276318,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.011397928,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04mwpn9"
				},
				"name": "Michael",
				"salience": 0.009995771,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06q1r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scotland"
				},
				"name": "Scottish",
				"salience": 0.008565501,
				"type": "LOCATION"
			},
			{
				"name": "cottage",
				"salience": 0.0064331074,
				"type": "LOCATION"
			},
			{
				"name": "golf course",
				"salience": 0.0057427967,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.004267714,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0037610594,
				"type": "EVENT"
			},
			{
				"name": "coast",
				"salience": 0.0029395607,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.0029395607,
				"type": "LOCATION"
			},
			{
				"name": "golf resort",
				"salience": 0.0029395607,
				"type": "LOCATION"
			},
			{
				"name": "edge",
				"salience": 0.0029395607,
				"type": "OTHER"
			},
			{
				"name": "monster",
				"salience": 0.0023113175,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.002062413,
				"type": "OTHER"
			},
			{
				"name": "eyesore",
				"salience": 0.0019855388,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0019855388,
				"type": "OTHER"
			},
			{
				"name": "water supply",
				"salience": 0.0019445586,
				"type": "OTHER"
			},
			{
				"name": "water daily",
				"salience": 0.0019115249,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k9g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aberdeenshire"
				},
				"name": "Aberdeenshire",
				"salience": 0.0018108786,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cbjz3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balmedie"
				},
				"name": "Balmedie",
				"salience": 0.0018108786,
				"type": "LOCATION"
			},
			{
				"name": "granny",
				"salience": 0.0017417578,
				"type": "OTHER"
			},
			{
				"name": "sleep",
				"salience": 0.0016841356,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.0016841356,
				"type": "OTHER"
			},
			{
				"name": "bedroom window",
				"salience": 0.0016841356,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0016420073,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0016213394,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.0014531186,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.0013537313,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.0012584311,
				"type": "ORGANIZATION"
			},
			{
				"name": "battle",
				"salience": 0.0012584311,
				"type": "EVENT"
			},
			{
				"name": "next",
				"salience": 0.0012584311,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00091669924,
				"type": "OTHER"
			},
			{
				"name": "security guards",
				"salience": 0.0009051527,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:47.441+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Heartless Trump cuts sweet old granny's water supply page: 1 link A 92-year-old Scottish widow is forced to drink stream water she collects in a wheelbarrow because Donald Trump refuses to fix the damage caused by builders working on his £1billion golf course. Grandmother Molly Forbes, 92, has refused to leave her cottage on the edge of Trump's golf resort in the tiny village of Balmedie, on the Aberdeenshire coast. The property developer and presidential hopeful, 70, has consistently tried to move Mrs Forbes and her son Michael from their home, which he has branded an 'eyesore'. Only a cold-blooded monster like Trump would be capable of something like this. He's been systematically bullying this innocent silver-haired grandmother to force her out of her property. Not only has he forced her to collect water daily at her frail old age, he is also keeping her from having a good night's sleep: Mrs Forbes says she has been subjected to an appalling campaign of intimidation, which allegedly includes cutting off the water supply to her property, floodlighting her bedroom window at night so she cannot sleep and building a massive wall against her property. She also claims security guards have tried to intimidate her by appearing at all hours of the day and night. Despite all this, she is determined not to be driven out. Source What is this vile man going to do to her next? Grope her? We must do all we can to support this sweet old granny and her son on their battle against ruthless Trump, and Trump must be forced to repair her water and leave them alone. This has gone too far! If this isn't proof that Trump is pure evil, I don't know what is. (Did I do this right?)",
		"thread_title": "Heartless Trump cuts sweet old grannys water supply",
		"title": "Heartless Trump cuts sweet old grannys water supply",
		"type": "bs",
		"uuid": "63b5a1a96856dc4c6ef6b6bf5e12ded989ad4596"
	},
	"-KhIa3XkfNPtuZOjKjqT": {
		"author": "2012newstart",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:48.169+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "mercy",
				"salience": 0.142764,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.1380901,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03blm4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mercy"
				},
				"name": "Mercy",
				"salience": 0.04594302,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01h9ym",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jubilee_(Christianity)"
				},
				"name": "Jubilee Year",
				"salience": 0.042367168,
				"type": "EVENT"
			},
			{
				"name": "justice",
				"salience": 0.032711785,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.025266442,
				"type": "PERSON"
			},
			{
				"name": "mercy",
				"salience": 0.023334434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09wpt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope_Benedict_XVI"
				},
				"name": "Benedict",
				"salience": 0.021313824,
				"type": "PERSON"
			},
			{
				"name": "Diary",
				"salience": 0.01875211,
				"type": "WORK_OF_ART"
			},
			{
				"name": "world",
				"salience": 0.016649276,
				"type": "LOCATION"
			},
			{
				"name": "Day of Justice",
				"salience": 0.016552376,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01kzr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Our_Lady_of_F%C3%A1tima"
				},
				"name": "Fatima",
				"salience": 0.01451471,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.014458506,
				"type": "OTHER"
			},
			{
				"name": "sinners",
				"salience": 0.014097672,
				"type": "PERSON"
			},
			{
				"name": "Judgment",
				"salience": 0.013896984,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.013431283,
				"type": "LOCATION"
			},
			{
				"name": "recourse",
				"salience": 0.013153038,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ngt2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope_Francis"
				},
				"name": "Francis",
				"salience": 0.012373901,
				"type": "PERSON"
			},
			{
				"name": "fountain",
				"salience": 0.012039041,
				"type": "LOCATION"
			},
			{
				"name": "page",
				"salience": 0.012039041,
				"type": "OTHER"
			},
			{
				"name": "coming",
				"salience": 0.012039041,
				"type": "EVENT"
			},
			{
				"name": "Diary 848",
				"salience": 0.010717557,
				"type": "WORK_OF_ART"
			},
			{
				"name": "souls",
				"salience": 0.00983334,
				"type": "PERSON"
			},
			{
				"name": "mercy",
				"salience": 0.009637549,
				"type": "OTHER"
			},
			{
				"name": "Much",
				"salience": 0.009509458,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.008718139,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04sy0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Feast_of_Christ_the_King"
				},
				"name": "Christ the King",
				"salience": 0.008359623,
				"type": "EVENT"
			},
			{
				"name": "Nothing",
				"salience": 0.008236755,
				"type": "OTHER"
			},
			{
				"name": "St Faustina: You",
				"salience": 0.0075124432,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05jy2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Naval_mine"
				},
				"name": "Mine",
				"salience": 0.0074179308,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Jesus",
				"salience": 0.0074179308,
				"type": "PERSON"
			},
			{
				"name": "door",
				"salience": 0.0073275925,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0073275925,
				"type": "OTHER"
			},
			{
				"name": "once",
				"salience": 0.0072103813,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.007091073,
				"type": "PERSON"
			},
			{
				"name": "prophecy",
				"salience": 0.006427269,
				"type": "OTHER"
			},
			{
				"name": "climate chaos",
				"salience": 0.0061159288,
				"type": "EVENT"
			},
			{
				"name": "mercy",
				"salience": 0.005521164,
				"type": "OTHER"
			},
			{
				"name": "combination",
				"salience": 0.0050264327,
				"type": "OTHER"
			},
			{
				"name": "visitation",
				"salience": 0.004963153,
				"type": "EVENT"
			},
			{
				"name": "woe",
				"salience": 0.004963153,
				"type": "OTHER"
			},
			{
				"name": "sake",
				"salience": 0.004963153,
				"type": "OTHER"
			},
			{
				"name": "doors",
				"salience": 0.004916135,
				"type": "OTHER"
			},
			{
				"name": "Diary 1146",
				"salience": 0.0047663357,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Diary 965",
				"salience": 0.0047663357,
				"type": "WORK_OF_ART"
			},
			{
				"name": "end",
				"salience": 0.0046382383,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.0045700674,
				"type": "OTHER"
			},
			{
				"name": "rabbis predictions",
				"salience": 0.004451225,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.004451225,
				"type": "OTHER"
			},
			{
				"name": "pope",
				"salience": 0.004451225,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.00428519,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0040192897,
				"type": "OTHER"
			},
			{
				"name": "anniversary",
				"salience": 0.003869349,
				"type": "EVENT"
			},
			{
				"name": "wishes",
				"salience": 0.0038035654,
				"type": "OTHER"
			},
			{
				"name": "sequence",
				"salience": 0.0036616637,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.0036342987,
				"type": "OTHER"
			},
			{
				"name": "wordings",
				"salience": 0.003546902,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0034806547,
				"type": "EVENT"
			},
			{
				"name": "retaking",
				"salience": 0.0034806547,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.0034806547,
				"type": "PERSON"
			},
			{
				"name": "secrets",
				"salience": 0.0034806547,
				"type": "OTHER"
			},
			{
				"name": "codes",
				"salience": 0.0034806547,
				"type": "OTHER"
			},
			{
				"name": "pontificate",
				"salience": 0.003350789,
				"type": "OTHER"
			},
			{
				"name": "decade.",
				"salience": 0.003350789,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.003350789,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.003350789,
				"type": "EVENT"
			},
			{
				"name": "justification",
				"salience": 0.003311831,
				"type": "OTHER"
			},
			{
				"name": "mercy",
				"salience": 0.0030822803,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0029390277,
				"type": "LOCATION"
			},
			{
				"name": "kill shot",
				"salience": 0.002841715,
				"type": "OTHER"
			},
			{
				"name": "queen",
				"salience": 0.002841715,
				"type": "PERSON"
			},
			{
				"name": "frames",
				"salience": 0.002841715,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.002841715,
				"type": "OTHER"
			},
			{
				"name": "orders",
				"salience": 0.002841715,
				"type": "OTHER"
			},
			{
				"name": "scenarios",
				"salience": 0.0028233146,
				"type": "OTHER"
			},
			{
				"name": "Warning",
				"salience": 0.0026120676,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.0026004033,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0025033576,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0024871465,
				"type": "PERSON"
			},
			{
				"name": "foreign minister",
				"salience": 0.00247182,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015j7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bible"
				},
				"name": "Bible",
				"salience": 0.0021426673,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0430_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jerusalem"
				},
				"name": "Jerusalem",
				"salience": 0.0021426673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.0021426673,
				"type": "OTHER"
			},
			{
				"name": "component",
				"salience": 0.002122955,
				"type": "OTHER"
			},
			{
				"name": "seers",
				"salience": 0.002122955,
				"type": "PERSON"
			},
			{
				"name": "reality",
				"salience": 0.002122955,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.002122955,
				"type": "OTHER"
			},
			{
				"name": "shape",
				"salience": 0.002122955,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0019925411,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04q006h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Sebasti%C3%A1n_de_Garabandal"
				},
				"name": "Garabandal",
				"salience": 0.0019871367,
				"type": "LOCATION"
			},
			{
				"name": "prophecy",
				"salience": 0.0019776432,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0019181684,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0017856188,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0017856188,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06m_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sun"
				},
				"name": "Solar",
				"salience": 0.001749221,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.001749221,
				"type": "LOCATION"
			},
			{
				"name": "mercy",
				"salience": 0.0016560055,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0015991632,
				"type": "LOCATION"
			},
			{
				"name": "apparitions",
				"salience": 0.0015461949,
				"type": "OTHER"
			},
			{
				"name": "take",
				"salience": 0.0015461949,
				"type": "OTHER"
			},
			{
				"name": "Door of Mercy",
				"salience": 0.0014977552,
				"type": "OTHER"
			},
			{
				"name": "prophecies",
				"salience": 0.0014773448,
				"type": "OTHER"
			},
			{
				"name": "2012newstart",
				"salience": 0.0014472605,
				"type": "PERSON"
			},
			{
				"name": "Door of Justice",
				"salience": 0.0014057325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Catholics",
				"salience": 0.0013922285,
				"type": "PERSON"
			},
			{
				"name": "Chastisement",
				"salience": 0.0013338802,
				"type": "OTHER"
			},
			{
				"name": "anniversary",
				"salience": 0.0013338802,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0013066871,
				"type": "EVENT"
			},
			{
				"name": "call",
				"salience": 0.001155008,
				"type": "OTHER"
			},
			{
				"name": "nonsense",
				"salience": 0.001155008,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04n7gc6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mary_(mother_of_Jesus)"
				},
				"name": "Virgin Mary",
				"salience": 0.00095163047,
				"type": "OTHER"
			},
			{
				"name": "Anguera",
				"salience": 0.00095163047,
				"type": "PERSON"
			},
			{
				"name": "distinction",
				"salience": 0.0008518935,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dpq1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miracle"
				},
				"name": "Miracle",
				"salience": 0.0008209394,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Great Warning- Miracle - Chastisement",
				"salience": 0.0008209394,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats11.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:48.169+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Jubilee Year of Mercy ends on November 20. Following Judgment? page: 1 Jesus to St Faustina: You will prepare the world for My final coming. (Diary 429) Speak to the world about My mercy ... It is a sign for the end times. After it will come the Day of Justice. While there is still time, let them have recourse to the fountain of My mercy. (Diary 848) Tell souls about this great mercy of Mine, because the awful day, the day of My justice, is near. (Diary 965). I am prolonging the time of mercy for the sake of sinners. But woe to them if they do not recognize this time of My visitation. (Diary 1160) Before the Day of Justice, I am sending the Day of Mercy. (Diary 1588) He who refuses to pass through the door of My mercy must pass through the door of My justice. (Diary 1146). The Jubilee Year of Mercy proclaimed by pope Francis, ends on November 20th the feast of Christ the King the end of the liturgical year. Every jubilee year is destined to end of course, that's why it is a year and not a decade.But...isn't it too much prophecy gathered in that last year? First of all, the Catholics expect earnestly the 100th anniversary of Fatima. The 100th year started on October 13 and would end on October 13, 2017. As pope Benedict said during his pontificate on his trip to Fatima, the 100th year will see the Fatima secrets fulfilled. Then, we had all kinds of predictions recently. Let only remember the once at the time Jewish rabbis predictions of the year 5776, encoded in Bible codes according to some of them, that also appeared to be the 49th jubilee year since the retaking of Jerusalem. \"Nothing happened, again\" would say many. Much happened in terms that might be the last quiet year before the events. Then we have the enigmatic wishes on the last Christmas of both pope and queen as if that would be our last Christmas? The wordings were vague enough to draw firm conclusion, anyway they were said and stirred public interest. There are more predictions, such as of major Solar kill shot, that even president Obama signed orders in case it happens. The French foreign minister said of 500 days before climate chaos, days that expired last Fall. How much more mercy is envisioned by God, in what time frames? If the sequence given in Garabandal of Great Warning- Miracle - Chastisement is to be accomplished before the 100th anniversary of Fatima, it seems God's mercy towards the entire world would end in less than a year time. The only possible date for the Miracle in 2017 would fall on April 13, Holy Thursday. Let make a distinction, mercy to individuals who accepted God's loving call, NEVER ENDS! But God is a just judge at the same time. The Chastisement is predicted by too many prophecies and cannot be disregarded as nonsense. Moreover,t he world today is in a worse shape than during the end of the Cold War. I don't know what exactly will follow, there are variety of scenarios each of them having its own justification and logic to exist. May be a combination of them will happen in reality. What is exactly Great Warning, is it only what is said to be by numerous seers, far not only those in Garabandal? For me it should include ET-angelic component. Time will tell. Time that runs out, according to Anguera and other apparitions of Virgin Mary. That doesn't mean it has all to happen on December 1st. Every next week draws us closer to the two doors, one of which is the Door of Mercy and the other the Door of Justice. Your take on recent catholic prophecy? Or may be protestant or orthodox one? edit on 27-10-2016 by 2012newstart because: (no reason given) edit on 27-10-2016 by 2012newstart because: (no reason given)",
		"thread_title": "Jubilee Year of Mercy ends on November 20. Following Judgment?",
		"title": "Jubilee Year of Mercy ends on November 20. Following Judgment?",
		"type": "bs",
		"uuid": "f3f806e5d087f32681562c8170a06b16e73fe086"
	},
	"-KhIa3gZ8xPvtlc9Q3OT": {
		"author": "Cavrecon22",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:49.204+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "fantasy",
				"salience": 0.10315027,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.08197618,
				"type": "LOCATION"
			},
			{
				"name": "breakingdefense.com",
				"salience": 0.080352545,
				"type": "OTHER"
			},
			{
				"name": "Username",
				"salience": 0.07293206,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.063334405,
				"type": "OTHER"
			},
			{
				"name": "lurker",
				"salience": 0.063334405,
				"type": "PERSON"
			},
			{
				"name": "The Above Top Secret",
				"salience": 0.051037144,
				"type": "OTHER"
			},
			{
				"name": "Sixth Gen Fighter Concept",
				"salience": 0.039260235,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01frmh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northrop_Corporation"
				},
				"name": "Northrop",
				"salience": 0.039260235,
				"type": "ORGANIZATION"
			},
			{
				"name": "A-XX",
				"salience": 0.033535663,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.030420119,
				"type": "PERSON"
			},
			{
				"name": "demonstrators",
				"salience": 0.019595778,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.019192902,
				"type": "OTHER"
			},
			{
				"name": "testing systems",
				"salience": 0.017273007,
				"type": "EVENT"
			},
			{
				"name": "shape",
				"salience": 0.013504764,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.013504764,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.013504764,
				"type": "OTHER"
			},
			{
				"name": "fools game",
				"salience": 0.012361393,
				"type": "EVENT"
			},
			{
				"name": "Artist",
				"salience": 0.012115144,
				"type": "PERSON"
			},
			{
				"name": "impressions",
				"salience": 0.012115144,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.010942067,
				"type": "OTHER"
			},
			{
				"name": "impression",
				"salience": 0.010542064,
				"type": "OTHER"
			},
			{
				"name": "artist",
				"salience": 0.009896023,
				"type": "PERSON"
			},
			{
				"name": "artist",
				"salience": 0.009896023,
				"type": "PERSON"
			},
			{
				"name": "impressions",
				"salience": 0.009896023,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.009125434,
				"type": "OTHER"
			},
			{
				"name": "Looks",
				"salience": 0.009125434,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.009125434,
				"type": "OTHER"
			},
			{
				"name": "member contributors",
				"salience": 0.008540132,
				"type": "PERSON"
			},
			{
				"name": "content",
				"salience": 0.008540132,
				"type": "OTHER"
			},
			{
				"name": "F-XX",
				"salience": 0.008323303,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0488g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas"
				},
				"name": "Kansas",
				"salience": 0.008323303,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.008323303,
				"type": "LOCATION"
			},
			{
				"name": "instance",
				"salience": 0.0077411607,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0077411607,
				"type": "LOCATION"
			},
			{
				"name": "content community",
				"salience": 0.0066799223,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.0057854163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.005621378,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026wy8d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Call_of_Duty"
				},
				"name": "Call of Duty",
				"salience": 0.005621378,
				"type": "OTHER"
			},
			{
				"name": "The Above Network, LLC",
				"salience": 0.0045938124,
				"type": "ORGANIZATION"
			},
			{
				"name": "site ownership",
				"salience": 0.004214957,
				"type": "OTHER"
			},
			{
				"name": "agnosticism",
				"salience": 0.004214957,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.004214957,
				"type": "OTHER"
			},
			{
				"name": "content copyright",
				"salience": 0.004214957,
				"type": "OTHER"
			},
			{
				"name": "The Above Network, LLC",
				"salience": 0.004113753,
				"type": "ORGANIZATION"
			},
			{
				"name": "topics",
				"salience": 0.0040274197,
				"type": "OTHER"
			},
			{
				"name": "topics",
				"salience": 0.0040274197,
				"type": "OTHER"
			},
			{
				"name": "venue",
				"salience": 0.00344141,
				"type": "LOCATION"
			},
			{
				"name": "Elections",
				"salience": 0.0031492384,
				"type": "EVENT"
			},
			{
				"name": "UFOs",
				"salience": 0.0031492384,
				"type": "OTHER"
			},
			{
				"name": "Aliens",
				"salience": 0.0031492384,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0019386328,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats8.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:49.204+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.4,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Northrop Unveils Sixth Gen Fighter Concept page: 1 Long time lurker, lost my original Username so...had to make a new one. Saw this on the news, breakingdefense.com... The shape looks familiar to the aircraft spotted over Kansas and Texas link a reply to: Cavrecon22 The F-XX and F/A-XX aren't even close to flying their demonstrators yet. They're testing systems, but they're nowhere close to flying. The Pentagon hasn't settled on the requirements yet. Looks like something out of Call of Duty! Awesome looking thing. Ah. Artist's impressions are a fools game. It's a fantasy until it actually starts getting prototyped, build and delivered. Russia seems to generate quite a few artist's impressions of things that would never get built. For instance, this is an artist's impression of my new house... .. but this is what got built. Aliens and UFOs : 1 hours ago top topics 2016 US Elections : 15 hours ago, 22 flags active topics new topics The Above Top Secret Web site is a wholly owned social content community of The Above Network, LLC . \nThis content community relies on user-generated content from our member contributors. The opinions of our members are not those of site ownership who maintains strict editorial agnosticism and simply provides a collaborative venue for free expression. \nAll content copyright 2016, The Above Network, LLC.",
		"thread_title": "Northrop Unveils Sixth Gen Fighter Concept",
		"title": "Northrop Unveils Sixth Gen Fighter Concept",
		"type": "bs",
		"uuid": "b9d528f7b51117bc70f457a1728e092b6a7bafc3"
	},
	"-KhIa4GbvWyG4b3QFJ8y": {
		"author": "Profusion",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T17:58:50.060+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.70628405,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "Nato",
				"salience": 0.023498688,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.01055113,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.007812123,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.00736974,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0071616927,
				"type": "LOCATION"
			},
			{
				"name": "pressure",
				"salience": 0.006716795,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0060971873,
				"type": "LOCATION"
			},
			{
				"name": "Government",
				"salience": 0.0058114924,
				"type": "ORGANIZATION"
			},
			{
				"name": "crisis",
				"salience": 0.0056109303,
				"type": "EVENT"
			},
			{
				"name": "territory",
				"salience": 0.005473901,
				"type": "LOCATION"
			},
			{
				"name": "word",
				"salience": 0.005316887,
				"type": "OTHER"
			},
			{
				"name": "fleet",
				"salience": 0.005251251,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.0052465983,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.005155414,
				"type": "LOCATION"
			},
			{
				"name": "assistance",
				"salience": 0.005000226,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "WW3",
				"salience": 0.004494073,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.004152525,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0038680902,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0038671456,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.0038436842,
				"type": "OTHER"
			},
			{
				"name": "Brits",
				"salience": 0.0037900957,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.0037485547,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012l22",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guy_Verhofstadt"
				},
				"name": "Guy Verhofstadt",
				"salience": 0.0037429973,
				"type": "PERSON"
			},
			{
				"name": "harassment",
				"salience": 0.0035984076,
				"type": "OTHER"
			},
			{
				"name": "goons",
				"salience": 0.0032087003,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0032087003,
				"type": "PERSON"
			},
			{
				"name": "harassment",
				"salience": 0.0031715652,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.003042159,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.003015031,
				"type": "LOCATION"
			},
			{
				"name": "vehicles",
				"salience": 0.0028753616,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "war",
				"salience": 0.0025382268,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/078y9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_World"
				},
				"name": "New World",
				"salience": 0.0025084037,
				"type": "LOCATION"
			},
			{
				"name": "fleet",
				"salience": 0.002495343,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0023804088,
				"type": "OTHER"
			},
			{
				"name": "russia",
				"salience": 0.0021661716,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.0021498608,
				"type": "OTHER"
			},
			{
				"name": "talks",
				"salience": 0.0021498608,
				"type": "EVENT"
			},
			{
				"name": "annihilation",
				"salience": 0.0021498608,
				"type": "OTHER"
			},
			{
				"name": "representative",
				"salience": 0.0021498608,
				"type": "PERSON"
			},
			{
				"name": "kinds",
				"salience": 0.0021498608,
				"type": "OTHER"
			},
			{
				"name": "critiques",
				"salience": 0.0021498608,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0019258789,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.0019016647,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0018214852,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0017874469,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0017285611,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.0017285611,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.0016331552,
				"type": "LOCATION"
			},
			{
				"name": "essence",
				"salience": 0.0015939154,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.0015867869,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0015580879,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0015580879,
				"type": "PERSON"
			},
			{
				"name": "pick",
				"salience": 0.001508437,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.001475234,
				"type": "LOCATION"
			},
			{
				"name": "Angelic Powers",
				"salience": 0.0014574084,
				"type": "OTHER"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0014183638,
				"type": "PERSON"
			},
			{
				"name": "purpose",
				"salience": 0.0013980914,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.0013290411,
				"type": "OTHER"
			},
			{
				"name": "fleet",
				"salience": 0.0012521977,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0012270507,
				"type": "EVENT"
			},
			{
				"name": "Government",
				"salience": 0.001203071,
				"type": "ORGANIZATION"
			},
			{
				"name": "ground",
				"salience": 0.0011973582,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0011826857,
				"type": "LOCATION"
			},
			{
				"name": "tension",
				"salience": 0.0011537767,
				"type": "OTHER"
			},
			{
				"name": "essence",
				"salience": 0.0010764069,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0010369761,
				"type": "PERSON"
			},
			{
				"name": "goon",
				"salience": 0.0010369761,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0009992239,
				"type": "OTHER"
			},
			{
				"name": "Rapha",
				"salience": 0.00097367656,
				"type": "ORGANIZATION"
			},
			{
				"name": "saber rattling",
				"salience": 0.00097127934,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0009347201,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stance",
				"salience": 0.00089804945,
				"type": "OTHER"
			},
			{
				"name": "harassment",
				"salience": 0.0008704869,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.00084114383,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0008147854,
				"type": "OTHER"
			},
			{
				"name": "EGO",
				"salience": 0.0008109072,
				"type": "OTHER"
			},
			{
				"name": "ground alot",
				"salience": 0.0008109072,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.00079622515,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0007630231,
				"type": "LOCATION"
			},
			{
				"name": "fearmongering",
				"salience": 0.00075951754,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.0007066123,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06wzv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Satan"
				},
				"name": "Satan",
				"salience": 0.00069383596,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07806",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_aircraft_carrier_Admiral_Kuznetsov"
				},
				"name": "Kuznetsov",
				"salience": 0.0006602916,
				"type": "PERSON"
			},
			{
				"name": "threads",
				"salience": 0.0006528125,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0006528125,
				"type": "OTHER"
			},
			{
				"name": "refuelling",
				"salience": 0.0006528125,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0005894471,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.0005894471,
				"type": "OTHER"
			},
			{
				"name": "drones",
				"salience": 0.0005894471,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.0005894471,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "quote",
				"salience": 0.0005894471,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0005894471,
				"type": "PERSON"
			},
			{
				"name": "warships",
				"salience": 0.0005894471,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0005713685,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonia",
				"salience": 0.00054928125,
				"type": "LOCATION"
			},
			{
				"name": "Government",
				"salience": 0.00054482836,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/019tjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_states"
				},
				"name": "Baltic",
				"salience": 0.0005248305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02m1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Council"
				},
				"name": "European Council",
				"salience": 0.00049193914,
				"type": "ORGANIZATION"
			},
			{
				"name": "ones",
				"salience": 0.00046646906,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0004605285,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h42m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Match"
				},
				"name": "Lucifers",
				"salience": 0.0004457195,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.00042366143,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.00041928835,
				"type": "EVENT"
			},
			{
				"name": "west",
				"salience": 0.0004110858,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0154j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belgium"
				},
				"name": "Belgium",
				"salience": 0.00041034885,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07p8wl2"
				},
				"name": "SOURCE",
				"salience": 0.00041034885,
				"type": "ORGANIZATION"
			},
			{
				"name": "Brexit",
				"salience": 0.00041034885,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08wdkk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dmitry_Medvedev"
				},
				"name": "Dmitry Medvedev",
				"salience": 0.00039438988,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.00038488267,
				"type": "LOCATION"
			},
			{
				"name": "russia",
				"salience": 0.00035963036,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0003584148,
				"type": "OTHER"
			},
			{
				"name": "harassment",
				"salience": 0.0003584148,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0003584148,
				"type": "OTHER"
			},
			{
				"name": "fleet",
				"salience": 0.00034812163,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00034373507,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0003278181,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0003278181,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0003278181,
				"type": "OTHER"
			},
			{
				"name": "Distraction",
				"salience": 0.0003172269,
				"type": "OTHER"
			},
			{
				"name": "saber rattling",
				"salience": 0.00031035725,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0003092742,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03860h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Viktor_Orb%C3%A1n"
				},
				"name": "Orban",
				"salience": 0.0003027131,
				"type": "PERSON"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0002983741,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00029259615,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.00029090152,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.00029090152,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.00029090152,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00028300288,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.0002744451,
				"type": "OTHER"
			},
			{
				"name": "saber rattling",
				"salience": 0.00026994685,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.00026994685,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.000268741,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0002678413,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.000267741,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00025977634,
				"type": "WORK_OF_ART"
			},
			{
				"name": "war",
				"salience": 0.00025569883,
				"type": "EVENT"
			},
			{
				"name": "ground",
				"salience": 0.0002512903,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0002512903,
				"type": "OTHER"
			},
			{
				"name": "harassment",
				"salience": 0.0002512903,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0002512903,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.00024743687,
				"type": "ORGANIZATION"
			},
			{
				"name": "context",
				"salience": 0.00024264285,
				"type": "OTHER"
			},
			{
				"name": "posturing",
				"salience": 0.00024264285,
				"type": "OTHER"
			},
			{
				"name": "trouble",
				"salience": 0.00024264285,
				"type": "OTHER"
			},
			{
				"name": "peasants",
				"salience": 0.00024264285,
				"type": "PERSON"
			},
			{
				"name": "overseas",
				"salience": 0.00024264285,
				"type": "LOCATION"
			},
			{
				"name": "drones",
				"salience": 0.00024264285,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.00024264285,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "harassment",
				"salience": 0.00024190893,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00024099661,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00024099661,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00024099661,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00023998778,
				"type": "EVENT"
			},
			{
				"name": "powers",
				"salience": 0.00023779323,
				"type": "OTHER"
			},
			{
				"name": "Profusion Britain",
				"salience": 0.0002368924,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0002337475,
				"type": "OTHER"
			},
			{
				"name": "fleet",
				"salience": 0.00023199942,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0002298355,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0002298355,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.00022891558,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Jesus",
				"salience": 0.00022325179,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00022325179,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.00022310221,
				"type": "LOCATION"
			},
			{
				"name": "word",
				"salience": 0.00022125486,
				"type": "OTHER"
			},
			{
				"name": "rocket shield",
				"salience": 0.00021550154,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0002118596,
				"type": "OTHER"
			},
			{
				"name": "fearmongering",
				"salience": 0.00021104667,
				"type": "OTHER"
			},
			{
				"name": "warhead",
				"salience": 0.00021010384,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00021010384,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00020961474,
				"type": "OTHER"
			},
			{
				"name": "saber rattling",
				"salience": 0.0002094683,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.00020682836,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00020513813,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00020513813,
				"type": "LOCATION"
			},
			{
				"name": "member",
				"salience": 0.00020394988,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.00020316729,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.00020316729,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.00020316729,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00019673447,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.00019633539,
				"type": "PERSON"
			},
			{
				"name": "promises",
				"salience": 0.00018900509,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00018827984,
				"type": "OTHER"
			},
			{
				"name": "dialoge",
				"salience": 0.00018590687,
				"type": "OTHER"
			},
			{
				"name": "Hung",
				"salience": 0.00018528514,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0001835638,
				"type": "OTHER"
			},
			{
				"name": "threads",
				"salience": 0.00018137695,
				"type": "OTHER"
			},
			{
				"name": "refuelling",
				"salience": 0.00018137695,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.00018137695,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sytr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hung_(TV_series)"
				},
				"name": "Hung.",
				"salience": 0.00017903862,
				"type": "PERSON"
			},
			{
				"name": "becasue",
				"salience": 0.00017011247,
				"type": "OTHER"
			},
			{
				"name": "interesets",
				"salience": 0.00017011247,
				"type": "OTHER"
			},
			{
				"name": "swanne",
				"salience": 0.00017011247,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.00017011247,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00016649025,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00016649025,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.00016649025,
				"type": "PERSON"
			},
			{
				"name": "Profusion",
				"salience": 0.00016539768,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00016455207,
				"type": "LOCATION"
			},
			{
				"name": "quote",
				"salience": 0.00016376101,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.00016376101,
				"type": "OTHER"
			},
			{
				"name": "warships",
				"salience": 0.00016376101,
				"type": "OTHER"
			},
			{
				"name": "posturing",
				"salience": 0.00016376101,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.00016376101,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.00016376101,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00016376101,
				"type": "PERSON"
			},
			{
				"name": "few",
				"salience": 0.0001547593,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d5kpb"
				},
				"name": "Lucy",
				"salience": 0.00015454374,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.00015380517,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00015380517,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.00015380517,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.00015323277,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00015323277,
				"type": "OTHER"
			},
			{
				"name": "axis",
				"salience": 0.00015186661,
				"type": "OTHER"
			},
			{
				"name": "dialoge",
				"salience": 0.00015176051,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0001512308,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00014806245,
				"type": "OTHER"
			},
			{
				"name": "wins",
				"salience": 0.000147959,
				"type": "EVENT"
			},
			{
				"name": "annex",
				"salience": 0.00014729795,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00014729795,
				"type": "OTHER"
			},
			{
				"name": "finest",
				"salience": 0.00014729795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "russian",
				"salience": 0.00014691048,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.00014014833,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00013886658,
				"type": "PERSON"
			},
			{
				"name": "natives",
				"salience": 0.00013886658,
				"type": "PERSON"
			},
			{
				"name": "bit",
				"salience": 0.00013886658,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.00013886658,
				"type": "OTHER"
			},
			{
				"name": "peasants",
				"salience": 0.00013886658,
				"type": "PERSON"
			},
			{
				"name": "overseas",
				"salience": 0.00013886658,
				"type": "LOCATION"
			},
			{
				"name": "partners",
				"salience": 0.00013590955,
				"type": "ORGANIZATION"
			},
			{
				"name": "west",
				"salience": 0.00013268164,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.00013268164,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.00013268164,
				"type": "LOCATION"
			},
			{
				"name": "Profusion Hm",
				"salience": 0.00012930512,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00012436212,
				"type": "PERSON"
			},
			{
				"name": "promises",
				"salience": 0.00012436212,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.00012436212,
				"type": "OTHER"
			},
			{
				"name": "collaboration id",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "inability",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "penis",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00012024187,
				"type": "EVENT"
			},
			{
				"name": "anyone",
				"salience": 0.00012024187,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.00012024187,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "enclave",
				"salience": 0.00012024187,
				"type": "LOCATION"
			},
			{
				"name": "gesture",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "squaddies",
				"salience": 0.00012024187,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.00012024187,
				"type": "OTHER"
			},
			{
				"name": "eavesdrop stations",
				"salience": 0.00011983524,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/049hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kaliningrad"
				},
				"name": "Kaliningrad",
				"salience": 0.00011840411,
				"type": "LOCATION"
			},
			{
				"name": "brtian",
				"salience": 0.000117755895,
				"type": "PERSON"
			},
			{
				"name": "unity",
				"salience": 0.00011575211,
				"type": "OTHER"
			},
			{
				"name": "axis",
				"salience": 0.000114886316,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.000111591464,
				"type": "LOCATION"
			},
			{
				"name": "reasons",
				"salience": 0.000111591464,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.000111591464,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.000111539375,
				"type": "OTHER"
			},
			{
				"name": "military troops",
				"salience": 0.000107374515,
				"type": "PERSON"
			},
			{
				"name": "wall",
				"salience": 0.0001072692,
				"type": "OTHER"
			},
			{
				"name": "t break",
				"salience": 0.00010505139,
				"type": "EVENT"
			},
			{
				"name": "expansion",
				"salience": 0.00010372723,
				"type": "EVENT"
			},
			{
				"name": "families",
				"salience": 0.00010372723,
				"type": "PERSON"
			},
			{
				"name": "elsewhere",
				"salience": 0.00010372723,
				"type": "LOCATION"
			},
			{
				"name": "trouble",
				"salience": 0.00010372723,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00010372723,
				"type": "PERSON"
			},
			{
				"name": "commitments",
				"salience": 0.00010372723,
				"type": "OTHER"
			},
			{
				"name": "east",
				"salience": 0.00010372723,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.00010206224,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.00010206224,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00010206224,
				"type": "OTHER"
			},
			{
				"name": "world war",
				"salience": 0.0000975163,
				"type": "EVENT"
			},
			{
				"name": "brtian",
				"salience": 0.00009612544,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.000092691684,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.000092122595,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.00009096138,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lSkrewloosel",
				"salience": 0.00009064914,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ohanka",
				"salience": 0.00009064914,
				"type": "OTHER"
			},
			{
				"name": "Chicago4Thursday2016201646",
				"salience": 0.00009064914,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippine",
				"salience": 0.00009064914,
				"type": "LOCATION"
			},
			{
				"name": "ThursdaythkThu",
				"salience": 0.00009064914,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "enlargement",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.00008981479,
				"type": "EVENT"
			},
			{
				"name": "say",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "reunification",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "Globalists",
				"salience": 0.00008981479,
				"type": "PERSON"
			},
			{
				"name": "taxmoney",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"name": "archives",
				"salience": 0.00008981479,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "europe",
				"salience": 0.00008624884,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern Europe",
				"salience": 0.00008624884,
				"type": "LOCATION"
			},
			{
				"name": "link",
				"salience": 0.00008404002,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.000083664505,
				"type": "PERSON"
			},
			{
				"name": "axis",
				"salience": 0.000083664505,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00008335311,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.00008165342,
				"type": "LOCATION"
			},
			{
				"name": "reply",
				"salience": 0.00007993792,
				"type": "OTHER"
			},
			{
				"name": "puppets",
				"salience": 0.00007811721,
				"type": "OTHER"
			},
			{
				"name": "West Break Its Promise",
				"salience": 0.00007653318,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00007582874,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.000075537726,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.000075537726,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.000075537726,
				"type": "OTHER"
			},
			{
				"name": "communism",
				"salience": 0.000075537726,
				"type": "OTHER"
			},
			{
				"name": "andy06shake",
				"salience": 0.000073997384,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "WW2",
				"salience": 0.000073997384,
				"type": "EVENT"
			},
			{
				"name": "saber rattling",
				"salience": 0.00007217308,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Erdogan",
				"salience": 0.000070701346,
				"type": "PERSON"
			},
			{
				"name": "Erdolf",
				"salience": 0.000070701346,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.00006764726,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00006764726,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00006764726,
				"type": "PERSON"
			},
			{
				"name": "stance",
				"salience": 0.00006658471,
				"type": "OTHER"
			},
			{
				"name": "Erdolfistan",
				"salience": 0.00006635614,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "germans",
				"salience": 0.00006585978,
				"type": "PERSON"
			},
			{
				"name": "anti-refugee",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"name": "mass surveillance pioneers",
				"salience": 0.00006540587,
				"type": "PERSON"
			},
			{
				"name": "idiot",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00006540587,
				"type": "ORGANIZATION"
			},
			{
				"name": "aircraft",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"name": "revenge",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"name": "nuke",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"name": "store",
				"salience": 0.00006540587,
				"type": "LOCATION"
			},
			{
				"name": "bankster crash",
				"salience": 0.00006540587,
				"type": "EVENT"
			},
			{
				"name": "robber baron capitalism",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"name": "feeds",
				"salience": 0.00006540587,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00006383363,
				"type": "LOCATION"
			},
			{
				"name": "Eastward Expansion",
				"salience": 0.00006383363,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.000063489744,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04vd0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anglo_American_plc"
				},
				"name": "anglo-american",
				"salience": 0.000062836516,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "europe",
				"salience": 0.00006280894,
				"type": "LOCATION"
			},
			{
				"name": "traitor",
				"salience": 0.00006249248,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00006249248,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.00006249248,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.000056422086,
				"type": "ORGANIZATION"
			},
			{
				"name": "fallout",
				"salience": 0.000056422086,
				"type": "EVENT"
			},
			{
				"name": "each other",
				"salience": 0.000056422086,
				"type": "PERSON"
			},
			{
				"name": "WINS",
				"salience": 0.000056422086,
				"type": "EVENT"
			},
			{
				"name": "interesets",
				"salience": 0.000056422086,
				"type": "OTHER"
			},
			{
				"name": "becasue",
				"salience": 0.000056422086,
				"type": "OTHER"
			},
			{
				"name": "suicides",
				"salience": 0.000056422086,
				"type": "EVENT"
			},
			{
				"name": "suicide",
				"salience": 0.000056422086,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.000056422086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hungary"
				},
				"name": "hungaria",
				"salience": 0.0000557335,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03xz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iron_Curtain"
				},
				"name": "Iron Curtain",
				"salience": 0.000055271517,
				"type": "OTHER"
			},
			{
				"name": "Bceause",
				"salience": 0.000055271517,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.000055271517,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.000055271517,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b97y1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/N%C3%A9pszabads%C3%A1g"
				},
				"name": "Népszabadság",
				"salience": 0.000055271517,
				"type": "OTHER"
			},
			{
				"name": "water supply",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.000048854028,
				"type": "LOCATION"
			},
			{
				"name": "atmosphere",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "food stuffs",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "dumbarses",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.000048854028,
				"type": "PERSON"
			},
			{
				"name": "lap dog",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "no brainer",
				"salience": 0.000048854028,
				"type": "PERSON"
			},
			{
				"name": "crazyewok",
				"salience": 0.000048854028,
				"type": "PERSON"
			},
			{
				"name": "atomics",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "repair",
				"salience": 0.000048854028,
				"type": "OTHER"
			},
			{
				"name": "traitor",
				"salience": 0.00004608945,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.000042490905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05jj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_American_Free_Trade_Agreement"
				},
				"name": "NAFTA",
				"salience": 0.000040249866,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cp5q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/DuPont"
				},
				"name": "Dupont",
				"salience": 0.000040249866,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0n8m6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monsanto"
				},
				"name": "Monsanto",
				"salience": 0.000040249866,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi",
				"salience": 0.000040249866,
				"type": "ORGANIZATION"
			},
			{
				"name": "TISA",
				"salience": 0.000040249866,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09rw5rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Comprehensive_Economic_and_Trade_Agreement"
				},
				"name": "CETA",
				"salience": 0.000040249866,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0r4t_pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Transatlantic_Trade_and_Investment_Partnership"
				},
				"name": "TTIP",
				"salience": 0.000040249866,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "NSA",
				"salience": 0.000040249866,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hobby Hitlers",
				"salience": 0.000040249866,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.000038711034,
				"type": "PERSON"
			},
			{
				"name": "foul",
				"salience": 0.000035285626,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.000031599604,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07c5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Americas"
				},
				"name": "Americas",
				"salience": 0.000030063828,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats6.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T17:58:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 44.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Britain to send hundreds more troops to Russia border as Cold War tension escalates page: 1 link Britain will send hundreds more troops close to Russia’s border, the Government has said, as the Prime Minister also called for “pressure” on Moscow over the Syria crisis. Around 800 soldiers along with tanks, armoured vehicles and drones will now head to Estonia in the spring in a Nato effort to reassure the Baltic states over Russian aggression. Is it starting to look like WW3 yet? Let's see if the main critiques of these kinds of threads are answered. 1. Is this \"saber rattling\"? No. 2. Is this move unequivocally directly related to countering Russia? Yes. 3. Is this \"fearmongering\"? No. There was something in the news yesterday that seemed to slip by everyone: Guy Verhofstadt, former prime minister of Belgium and now the EU’s representative on Brexit talks with the UK, called Spain’s decision to allow the refuelling “scandalous”. \"It is scandalous that Spain, a member of NATO and the EU, is today allowing the Russian #Kuznetsov fleet to refuel and receive technical assistance on Spanish territory. Only last week – this Spanish Government signed up to a statement from the European Council accusing Russia of war crimes against civilians in #Aleppo, yet today it provides assistance to a fleet which has one purpose; the annihilation of Aleppo and the harassment of EU & NATO forces .\" SOURCE Did Guy Verhofstadt just state that Russia is using a fleet of warships to terrorize EU & NATO forces? I realize that the word \"harassment\" is used in the quote above, but how does that word fit in this context? It seems like it could be a coded message. Either way, \"the harassment of EU & NATO forces\" sounds like it could be an act of war to me. That's the essence of my argument for why WW3 has already started. It's well past the point of \"saber rattling\" and \"posturing\", actual harassment/terrorism/warfare (take your pick of words) is involved. edit on 27-10-2016 by Profusion because: (no reason given) link a reply to: Profusion Hm. On its side, Russia has just unveiled her new, Satan 2 nuclear warhead, capable of \"destroying UK two times over\". I agree with you, this isn't just saber rattling anymore. Good thread. We should really kick those baltic states out of NATO. They've been nothing but trouble since we let them in. Turkey can go too. Ever wondered if it is a spiritual war where the peasants in the soldiers native country are soon to be tested by Jesus. 1) remove all military personal overseas. 2) create war between imported terrorists (ISIS) and local Brits. 3) the Brits that cower, die fast. The ones that stand their ground get angelic powers and become the New World leaders after all of Lucifers goons are Judged and Hung. link originally posted by: Profusion Britain will send hundreds more troops close to Russia’s border, the Government has said, as the Prime Minister also called for “pressure” on Moscow over the Syria crisis. Around 800 soldiers along with tanks, armoured vehicles and drones will now head to Estonia in the spring in a Nato effort to reassure the Baltic states over Russian aggression. Is it starting to look like WW3 yet? Let's see if the main critiques of these kinds of threads are answered. 1. Is this \"saber rattling\"? No. 2. Is this move unequivocally directly related to countering Russia? Yes. 3. Is this \"fearmongering\"? No. There was something in the news yesterday that seemed to slip by everyone: Guy Verhofstadt, former prime minister of Belgium and now the EU’s representative on Brexit talks with the UK, called Spain’s decision to allow the refuelling “scandalous”. \"It is scandalous that Spain, a member of NATO and the EU, is today allowing the Russian #Kuznetsov fleet to refuel and receive technical assistance on Spanish territory. Only last week – this Spanish Government signed up to a statement from the European Council accusing Russia of war crimes against civilians in #Aleppo, yet today it provides assistance to a fleet which has one purpose; the annihilation of Aleppo and the harassment of EU & NATO forces .\" SOURCE Did Guy Verhofstadt just state that Russia is using a fleet of warships to terrorize EU & NATO forces? I realize that the word \"harassment\" is used in the quote above, but how does that word fit in this context? It seems like it could be a coded message. Either way, \"the harassment of EU & NATO forces\" sounds like it could be an act of war to me. That's the essence of my argument for why WW3 has already started. It's well past the point of \"saber rattling\" and \"posturing\", actual harassment/terrorism/warfare (take your pick of words) is involved. It's American election time. Just look at the Philippine situation also. Distraction at its finest. link a reply to: Rapha the Brits that cower, die fast. The ones that stand their ground get angelic powers and become the New World leaders after all of Lucifers goons are Judged and Hung. Oh? I've stood my ground alot of times, yet this didn't make me gain any Level Up Angelic Powers, nor did I become leader of the New World and made Lucy's goon magically hang in the process? Maybe I did it wrong? Perhaps I didn't do my stance right when I stood my ground? edit on 27-10-2016 by swanne because: (no reason given) link a reply to: Profusion It is scandalous that Spain, a member of NATO and the EU, is today allowing the Russian #Kuznetsov fleet to refuel and receive technical assistance on Spanish territory. spain cancelled this, yesterday . a reply to: Profusion i wish brtian will just let USA destroy it self and stop licking their a$$es. Russia should be left alone or at least have dialoge on similar interesets. All becasue of USA big EGO they stepped into syria edit on ThursdaythkThu, 27 Oct 2016 05:36:46 -0500America/Chicago4Thursday2016201646 by lSkrewloosel because: (no reason given) originally posted by: Ohanka We should really kick those baltic states out of NATO. Why? So that we could leave Russia free to invade and occupy them again? Did I say occupy? Sorry, I meant annex. Moving troops around NATO members for training and inter-service collaboration id not new. It's just reported a bit more because to the current tensions. Note that a couple of weeks ago Russia was putting massive forces into their enclave of Kaliningrad which makes the movement of a few hundred British squaddies seem a little bit of a token gesture. Kaliningrad was a part of Germany annexed by Russia after WW2 and the place was ethnically cleansed of the natives. link a reply to: Rapha Don't really see how anyone or anything for that matter could stand there ground against a nuclear attack. This has nothing to do with spiritual war, this is about humanity's inability to communicate without resorting to waving there nuclear penis at one another. If there is a third world war of the nuclear variety nobody wins and all it will serve to achieve is to set back humanity for the next 10,000 years or so. edit on 27-10-2016 by andy06shake because: (no reason given) link originally posted by: Rapha Ever wondered if it is a spiritual war where the peasants in the soldiers native country are soon to be tested by Jesus. 1) remove all military personal overseas. 2) create war between imported terrorists (ISIS) and local Brits. 3) the Brits that cower, die fast. The ones that stand their ground get angelic powers and become the New World leaders after all of Lucifers goons are Judged and Hung. I guess a link is out of the question ? a reply to: Profusion i wish brtian will just let USA destroy it self and stop licking their a$$es. Russia should be left alone or at least have dialoge on similar interesets. All becasue of USA big EGO they stepped into syria Exactly. The dumbarses destroy each other. Britain can survive and pick up the pieces. In WW3 NO ONE WINS. So no point getting involved! As a UK citizen i refuse to support any actions of aggression and will remain neutral. I do not care if that makes me a traitor. edit on 27-10-2016 by crazyewok because: (no reason given) link a reply to: crazyewok If the USA and Russia do decide to start lobbing atomics at one another whether or not Britain chooses to play the part of Americas lap dog is nether here nor there considering it will ultimately lead to full blown world war. Even if we were not targeted and they kept there exchange to there own nations we would still be blanketed by the fallout contaminating our water supply's, food stuffs, land and atmosphere beyond repair for the next few thousand years. So your no traitor for not supporting there crazy nonsensical saber rattling, point of fact i imagine most people can see Nuclear war for the no brainer it actually is. link originally posted by: swanne I've stood my ground alot of times, yet this didn't make me gain any Level Up Angelic Powers, nor did I become leader of the New World and made Lucy's goon magically hang in the process? Maybe I did it wrong? Perhaps I didn't do my stance right when I stood my ground? By not committing suicide is already a stance. A lot of people are losing it now with suicides on the rise. It will be at least a week or two before something big happens. Just hang-in-there. We should really kick those baltic states out of NATO. They've been nothing but trouble since we let them in. Turkey can go too. This is right, and not only for warmongerers reasons! But we also should not forget that these miniature states are only used too, like the rest of dumb europe. By the anglo-american axis, some call it meanwhile the new axis of evil. Bceause, for the simple reason that russia didn´t break made promises, after the Globalists \"reunited\" Germany, let´s better say brought down the wall(To be honest, there is no unity between german people, often not even in the own families, less than ever between the east and west of germany). The broken promises were about the eastward enlargement of the NATO. NATO's Eastward Expansion Did the West Break Its Promise to Moscow? \"Russian President Dmitry Medvedev has accused the West of breaking promises made after the fall of the Iron Curtain, saying that NATO's expansion into Eastern Europe violated commitments made during the negotiations over German reunification. Newly discovered documents from Western archives support the Russian position.\" Russia didn´t expand his military troops to the borders of the USA or UK, didn´t build a rocket shield in Mexico, Canada or elsewhere at the borders of the USA. I read right now that Orban acts the same like Erdolf aka Erdogan. The last hungarian newspaper that reported about the criminal acts of the Orban family, the \"Népszabadság\" was closed down, freedom of the press is almost terminated now. And those EU puppets send taxmoney to such states and get nothing but problems back, but don´t even try to stop such Hobby Hitlers. Good that Erdolfistan is not in the EU like hungaria and the other \"want revenge from russia\" liliputh states. And the people that elected Orban, just for anti-refugee and othe Nazi reasons, for nothing else? Another year under Orban and they will end as refugees in western europe! That will become embarrassing for the anti-refugee masses... To come to an end. It´s obvisiously the \"west\" who is playing foul, playing foul and nothing else than that, at least since 9/11. The anglo-american axis(the modern mass surveillance pioneers) is surrounding russia, not russia the \"west\"(and is using it´s idiot european \"partners\" for this). It´s not russia that covers every part of the world with his military and his eavesdrop stations. It´s not russia that \"owns\" almost unsinkable aircraft carries like Germany(38.500 US troops in germany), for example. It´s not russia that stores nuke in germany, that we germans aren´t even allowed to own or store on our territory. The NSA isn´t russian. TTIP, CETA, NAFTA, TISA and all that, isn´t russian. The bankster crash 2008 was not based in russia. The robber baron capitalism that \"feeds\" a few but exploits 99,9% is not coming from communism(though they learned fast how it works). Monsanto, Dupont etc, not russian. I could go on and on, but i have to come to an end.",
		"thread_title": "Britain to send hundreds more troops to Russia border as Cold War tension escalates",
		"title": "Britain to send hundreds more troops to Russia border as Cold War tension escalates",
		"type": "bs",
		"uuid": "1532b208b9cdc26d04a9a701f90b8eb5ddf6f5c7"
	},
	"-KhIa4NLBR9S9-aPmrOC": {
		"author": "BlackProject",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T18:30:26.289+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.58185065,
				"type": "ORGANIZATION"
			},
			{
				"name": "page",
				"salience": 0.069010094,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.066816814,
				"type": "WORK_OF_ART"
			},
			{
				"name": "link",
				"salience": 0.058147248,
				"type": "OTHER"
			},
			{
				"name": "UFO Flying Past",
				"salience": 0.0496029,
				"type": "OTHER"
			},
			{
				"name": "Footage Films",
				"salience": 0.043110542,
				"type": "WORK_OF_ART"
			},
			{
				"name": "idea",
				"salience": 0.020085575,
				"type": "OTHER"
			},
			{
				"name": "craft",
				"salience": 0.015334317,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.014953357,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.01077733,
				"type": "PERSON"
			},
			{
				"name": "path",
				"salience": 0.010508906,
				"type": "OTHER"
			},
			{
				"name": "debris",
				"salience": 0.010118682,
				"type": "OTHER"
			},
			{
				"name": "footage",
				"salience": 0.009910612,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hardware",
				"salience": 0.008587609,
				"type": "OTHER"
			},
			{
				"name": "visitors",
				"salience": 0.006422107,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.006422107,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0061054244,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.005312538,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0040396396,
				"type": "WORK_OF_ART"
			},
			{
				"name": "BlackProject",
				"salience": 0.002883575,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats6.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T18:30:26.289+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "New NASA Footage Films UFO Flying Past page: 1 link Here the video shows a very odd craft zooming past. It looks to be very direct on its movement and shows no sign of being as NASA love to use ''debris'' flying by. It is on its own and on its own path. Be nice to see what others think about this footage I have no idea whether this is coming from NASA hardware or not. It states on the video also 2016, I presume this is new. It would seem we are being visited all the time, by our visitors. Star people, ET's. edit on 27-10-2016 by BlackProject because: (no reason given)",
		"thread_title": "New NASA Footage Films UFO Flying Past",
		"title": "New NASA Footage Films UFO Flying Past",
		"type": "bs",
		"uuid": "f65df374fd32c1466fe443eddd6afe1d85873cfd"
	},
	"-KhIa4kIoasS-E0CMDtM": {
		"author": "Profusion",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T19:02:22.117+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.30906567,
				"type": "LOCATION"
			},
			{
				"name": "leaders",
				"salience": 0.16321069,
				"type": "PERSON"
			},
			{
				"name": "regime",
				"salience": 0.06654114,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.018008247,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.017522436,
				"type": "OTHER"
			},
			{
				"name": "Profusion",
				"salience": 0.0137150055,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0137150055,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0122125605,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.011988812,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.010935455,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.009707343,
				"type": "ORGANIZATION"
			},
			{
				"name": "proxy war",
				"salience": 0.009707343,
				"type": "EVENT"
			},
			{
				"name": "terrorism",
				"salience": 0.009707343,
				"type": "OTHER"
			},
			{
				"name": "gun",
				"salience": 0.008969928,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "region",
				"salience": 0.008969715,
				"type": "LOCATION"
			},
			{
				"name": "door",
				"salience": 0.008100627,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00706681,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0070164567,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0070164567,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0070164567,
				"type": "LOCATION"
			},
			{
				"name": "most",
				"salience": 0.0070164567,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0070164567,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0067672958,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0059355604,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0052602794,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.0050364896,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0049898643,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.004937476,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.004803525,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.004767771,
				"type": "PERSON"
			},
			{
				"name": "problems",
				"salience": 0.004727398,
				"type": "OTHER"
			},
			{
				"name": "lets",
				"salience": 0.004504293,
				"type": "PERSON"
			},
			{
				"name": "choices",
				"salience": 0.0043827402,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.004326231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Assad",
				"salience": 0.004321448,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.0041648834,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0041648834,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0041648834,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.00400142,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00400142,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00400142,
				"type": "ORGANIZATION"
			},
			{
				"name": "positions",
				"salience": 0.003562529,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.0034733717,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.0033381009,
				"type": "OTHER"
			},
			{
				"name": "war effort",
				"salience": 0.0033381009,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0033381009,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.0032545542,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0031895516,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.00316203,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.0030144758,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0029936978,
				"type": "PERSON"
			},
			{
				"name": "cause",
				"salience": 0.0028907394,
				"type": "OTHER"
			},
			{
				"name": "regard",
				"salience": 0.0028907394,
				"type": "OTHER"
			},
			{
				"name": "witlessness",
				"salience": 0.0028907394,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0027014175,
				"type": "PERSON"
			},
			{
				"name": "terrorist",
				"salience": 0.0027014175,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.0027014175,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.0026452974,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0025924533,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0025924533,
				"type": "OTHER"
			},
			{
				"name": "mob",
				"salience": 0.002579076,
				"type": "OTHER"
			},
			{
				"name": "assemblage",
				"salience": 0.002579076,
				"type": "OTHER"
			},
			{
				"name": "bastard",
				"salience": 0.002579076,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.002556514,
				"type": "LOCATION"
			},
			{
				"name": "representatives",
				"salience": 0.0025145109,
				"type": "PERSON"
			},
			{
				"name": "blood",
				"salience": 0.0024957152,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.002444149,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002444149,
				"type": "PERSON"
			},
			{
				"name": "game players",
				"salience": 0.0023407983,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0022909807,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0022759538,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0022759538,
				"type": "LOCATION"
			},
			{
				"name": "door",
				"salience": 0.0022534437,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.00211651,
				"type": "OTHER"
			},
			{
				"name": "bloodshed",
				"salience": 0.00211651,
				"type": "OTHER"
			},
			{
				"name": "backstabbing",
				"salience": 0.0020528673,
				"type": "OTHER"
			},
			{
				"name": "schemers",
				"salience": 0.0020270043,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0020270043,
				"type": "PERSON"
			},
			{
				"name": "determination",
				"salience": 0.0020270043,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0019513527,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0019513527,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0019513527,
				"type": "ORGANIZATION"
			},
			{
				"name": "hunger",
				"salience": 0.0019513527,
				"type": "OTHER"
			},
			{
				"name": "meddling",
				"salience": 0.0019513527,
				"type": "OTHER"
			},
			{
				"name": "proxy",
				"salience": 0.0019513527,
				"type": "OTHER"
			},
			{
				"name": "greed",
				"salience": 0.0019513527,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0019110271,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.00188695,
				"type": "OTHER"
			},
			{
				"name": "gall",
				"salience": 0.0018084095,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0017631265,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0017409116,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.001711498,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.001711498,
				"type": "EVENT"
			},
			{
				"name": "fold",
				"salience": 0.001654815,
				"type": "OTHER"
			},
			{
				"name": "sweat",
				"salience": 0.001654815,
				"type": "OTHER"
			},
			{
				"name": "labour",
				"salience": 0.001654815,
				"type": "EVENT"
			},
			{
				"name": "tithe",
				"salience": 0.001654815,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.001654815,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0015811356,
				"type": "LOCATION"
			},
			{
				"name": "same",
				"salience": 0.0014393666,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0014393666,
				"type": "OTHER"
			},
			{
				"name": "favours",
				"salience": 0.0013005055,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0012361804,
				"type": "OTHER"
			},
			{
				"name": "charade",
				"salience": 0.0012361804,
				"type": "OTHER"
			},
			{
				"name": "tragedy",
				"salience": 0.0012361804,
				"type": "EVENT"
			},
			{
				"name": "enemies",
				"salience": 0.0012361804,
				"type": "OTHER"
			},
			{
				"name": "pantomime",
				"salience": 0.0012361804,
				"type": "WORK_OF_ART"
			},
			{
				"name": "obfuscations",
				"salience": 0.0012361804,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0012361804,
				"type": "LOCATION"
			},
			{
				"name": "meantime",
				"salience": 0.0012361804,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0012361804,
				"type": "EVENT"
			},
			{
				"name": "infrastructure",
				"salience": 0.0012361804,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.0012361804,
				"type": "LOCATION"
			},
			{
				"name": "sound",
				"salience": 0.0011602279,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0011602279,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0010493161,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0010493161,
				"type": "OTHER"
			},
			{
				"name": "programming",
				"salience": 0.0010397208,
				"type": "OTHER"
			},
			{
				"name": "bolt gun",
				"salience": 0.0010397208,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "proxy war",
				"salience": 0.00093113683,
				"type": "EVENT"
			},
			{
				"name": "governments",
				"salience": 0.00093113683,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.000900291,
				"type": "ORGANIZATION"
			},
			{
				"name": "much",
				"salience": 0.000900291,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.000900291,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.000900291,
				"type": "OTHER"
			},
			{
				"name": "cattle",
				"salience": 0.000900291,
				"type": "OTHER"
			},
			{
				"name": "error correction",
				"salience": 0.000900291,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0008601969,
				"type": "OTHER"
			},
			{
				"name": "programming",
				"salience": 0.00077665347,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.0007165253,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0007165253,
				"type": "OTHER"
			},
			{
				"name": "destabilisation",
				"salience": 0.0006724942,
				"type": "OTHER"
			},
			{
				"name": "concepts",
				"salience": 0.0006724942,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0006724942,
				"type": "WORK_OF_ART"
			},
			{
				"name": "OP",
				"salience": 0.0006724942,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0006724942,
				"type": "LOCATION"
			},
			{
				"name": "right",
				"salience": 0.0006724942,
				"type": "OTHER"
			},
			{
				"name": "TrueBrit",
				"salience": 0.0005540691,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats11.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T19:02:22.117+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 16.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link a reply to: Profusion I must point out to you, that his statements are accurate. What is more, they are entirely appropriate to the situation. As we speak, proxy war is being fought by the destabilising forces of IS, sponsored by Western nations and interests by the back door, against the Assad regime. That regime is an ally of Russia. I am tired of pointing these things out, but to suggest that Russia is the problem, when for most of the last two decades, there has been western sponsored terrorism all over the most volatile region of the planet, smacks to me of the most unutterable witlessness. Russia is not the problem. I would not go as far as to say that it never was, and lets face it, the Russian government are not clean handed. But here is the thing... Russia cannot dishonour the British. It cannot dishonour the Americans. It can only make choices that make its nation look bad, and many of the choices it has made, with specific regard to its ACTUAL war effort against terror in Syria, have been absolutely legitimate, especially since they were not the cause of the problems there in the least. No... only OUR nations governments can dishonour us, and dishonour us they do. Every gun that makes its way from America and Britain, into the hands of a terrorist, dishonours us. Every time those weapons we sell the terrorists by the back door, are used to kill an innocent, we are dishonoured, stained with blood we would not wish to be shed. Our leaders, those of America and Britain not to mention other allies, THEY are the problem here. Their meddling, proxy warring, greed and hunger for power are the problem. They are the problem because we pay the taxes that make it possible. They are the problem because we did not give them permission to do these things in our name, because we would not want these things done in our name, and because they are supposed to be our representatives. No backstabbing, soft handed, work shy bastard represents me. No assemblage of schemers and game players represents me. No such mob represents my people on their best day, because on our best day the British people are not cold, evil, calculating and prepared to screw anyone to succeed. On our best day, even the least of us has more fair play and determination to do right than our government have. The same can be said a thousand fold for the leadership of the United States. We are not evil people, and yet we have allowed evil people to usurp the purpose of the tithe taken from our labour, to turn our effort, sweat and blood, into bloodshed overseas. We have had enemies made for us, by people we have mindlessly elected to positions with which they cannot be trusted. And we have the gall to be concerned about RUSSIA? I despair, I absolutely despair! This is not a game, this is not politics, this is real life. We should be doing better with it, and we are not. We should not be sliding ever further to the right, and yet we are. We should not be accepting the programming, and yet that is precisely what is happening all over the world, and in the OP of this very post. We MUST take back control of our governments. We MUST prevent our leaders from continuing these outmoded concepts of proxy war and destabilisation. We MUST mend the things our leaders broke in our name, we MUST take responsibility for those things, and we must NEVER allow them to happen again. In the meantime, we must leave Russia to deal with the crisis in Syria, so that the nation can be rebuilt, its infrastructure repaired, its homes and cities bought back to a livable state, and so that we are not distracted by a war that could turn from a pantomime into an even greater tragedy than it already is. I tire of this bizarre and ridiculous charade that we are apparently too stupid to stop, too uncaring to prevent. It needs to end, and end today, yesterday, TEN DAMNED YEARS AGO OR MORE! Can we stop accepting the lies, the obfuscations, the programming we have been fed? Can we PLEASE start doing that as a group? Would that be too damned much to ask? Because to be quite frank, if we cannot even do that, then we deserve to burn in nuclear fire for a hundred years, because we are not going to do ourselves any favours continuing such a pathetic existence as our leaders have created for us, cattle like and willing to believe whatever we are told, except that the sound of the bolt gun ahead is anything to worry about. edit on 27-10-2016 by TrueBrit because: grammatical error correction.",
		"thread_title": "Putin: stupid and unrealistic claims of impending war",
		"title": "Putin: stupid and unrealistic claims of impending war",
		"type": "bs",
		"uuid": "773ad305847d2f69613ceb27d59d01b6f89297d2"
	},
	"-KhIa4vBR_0CZrSKMq1V": {
		"author": "Cymru",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T19:02:33.676+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "DVD",
				"salience": 0.20342644,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "girlfriend",
				"salience": 0.17879775,
				"type": "PERSON"
			},
			{
				"name": "episode",
				"salience": 0.08854382,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bridge",
				"salience": 0.07056935,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.04675909,
				"type": "LOCATION"
			},
			{
				"name": "conspiracy theories",
				"salience": 0.04675909,
				"type": "OTHER"
			},
			{
				"name": "vacation",
				"salience": 0.040589932,
				"type": "EVENT"
			},
			{
				"name": "introduction",
				"salience": 0.040589932,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.030005043,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.028029423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0z0y2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kent,_Ohio"
				},
				"name": "Kent",
				"salience": 0.025136687,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.025136687,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.020888574,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07cfdjg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conspiracy_Theory_with_Jesse_Ventura"
				},
				"name": "Conspiracy Theory",
				"salience": 0.014228699,
				"type": "WORK_OF_ART"
			},
			{
				"name": "trail",
				"salience": 0.009970281,
				"type": "LOCATION"
			},
			{
				"name": "path",
				"salience": 0.009201088,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.008637529,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.006737106,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.006061342,
				"type": "LOCATION"
			},
			{
				"name": "outside",
				"salience": 0.005835514,
				"type": "OTHER"
			},
			{
				"name": "handrail",
				"salience": 0.005835514,
				"type": "OTHER"
			},
			{
				"name": "sleeve",
				"salience": 0.005835514,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0057151257,
				"type": "OTHER"
			},
			{
				"name": "clip",
				"salience": 0.0057151257,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01pzk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuyahoga_River"
				},
				"name": "Cuyahoga river",
				"salience": 0.0053223968,
				"type": "LOCATION"
			},
			{
				"name": "camps",
				"salience": 0.004950025,
				"type": "LOCATION"
			},
			{
				"name": "conspiracy",
				"salience": 0.0047299387,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.004306383,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.004271241,
				"type": "LOCATION"
			},
			{
				"name": "most",
				"salience": 0.0041458295,
				"type": "OTHER"
			},
			{
				"name": "Jesse Ventura 9/11",
				"salience": 0.003733463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_6j_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alex_Jones_(radio_host)"
				},
				"name": "infowars.com",
				"salience": 0.003733463,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.003699147,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.003699147,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hd1l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesse_Ventura"
				},
				"name": "Jesse Ventura",
				"salience": 0.003520022,
				"type": "PERSON"
			},
			{
				"name": "park trail",
				"salience": 0.0031118053,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_6j_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alex_Jones_(radio_host)"
				},
				"name": "Alex Jones",
				"salience": 0.0030484223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0js8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Emergency_Management_Agency"
				},
				"name": "FEMA",
				"salience": 0.0030484223,
				"type": "ORGANIZATION"
			},
			{
				"name": "door",
				"salience": 0.002694837,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.002694837,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.002694837,
				"type": "LOCATION"
			},
			{
				"name": "audio clip",
				"salience": 0.0023250093,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.002013382,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.002013382,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Jesus",
				"salience": 0.0012393529,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats15.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T19:02:33.676+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link My first introduction to the world of conspiracy theories was a DVD I found while on vacation visiting my girlfriend in Kent, Ohio. There was a little bridge over a muddy area on a trail by the Cuyahoga river, and for some reason my girlfriend and I decided to take the muddy path instead of the bridge. Well, she slipped and fell, so I helped her up and we made our way back to the bridge to go across the sane way, when we saw a sleeve stapled to the outside of the wooden handrail with a DVD in it labeled simply with \"infowars.com Jesse Ventura 9/11\", and I grabbed it because... well, why not? Popped it in at her house and watched it, it was an episode or two from Jesse Ventura's show Conspiracy Theory, one about FEMA camps, one about 9/11, and then some reletively short clip of Alex Jones yelling at me, and ending with an audio clip of some guy preaching about the end times coming soon and needing to get right with Jesus or something. I dunno, I didn't listen much to him because I don't care a thing for religion. Anyhow, that's at least what opened my mind, so to speak, to this world of conspiracy. True or not, most of them are entertaining at least. So, I can't say they were delivered to my door. Far from it in fact, they were instead hidden on a park trail 600 miles away from home.",
		"thread_title": "Conspiracy Theories deliverd to your door, anonymously.",
		"title": "Conspiracy Theories deliverd to your door, anonymously.",
		"type": "bs",
		"uuid": "7e3c2389dcb53dd0827843cbe063f336d2b370a2"
	},
	"-KhIa56fgVr5xQTlgTHH": {
		"author": "jadedANDcynical",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T19:02:47.938+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "SPAM",
				"salience": 0.1560147,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.07778098,
				"type": "PERSON"
			},
			{
				"name": "executive director",
				"salience": 0.07205336,
				"type": "PERSON"
			},
			{
				"name": "waixalle.com",
				"salience": 0.06832473,
				"type": "OTHER"
			},
			{
				"name": "Emails",
				"salience": 0.046919774,
				"type": "WORK_OF_ART"
			},
			{
				"name": "messages",
				"salience": 0.040688127,
				"type": "WORK_OF_ART"
			},
			{
				"name": "EMAILS",
				"salience": 0.027286643,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tabs",
				"salience": 0.024283446,
				"type": "OTHER"
			},
			{
				"name": "leak",
				"salience": 0.02087154,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.02087154,
				"type": "OTHER"
			},
			{
				"name": "ATS",
				"salience": 0.02087154,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.02087154,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.018197918,
				"type": "OTHER"
			},
			{
				"name": "Christopher Barrios",
				"salience": 0.012154815,
				"type": "PERSON"
			},
			{
				"name": "thread",
				"salience": 0.011917254,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.011767628,
				"type": "PERSON"
			},
			{
				"name": "embassy workers",
				"salience": 0.010824845,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.010714697,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03cjjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Podest%C3%A0"
				},
				"name": "Podesta",
				"salience": 0.010644455,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.009944367,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.009944367,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.009060594,
				"type": "OTHER"
			},
			{
				"name": "hedge-fund managers",
				"salience": 0.009060594,
				"type": "PERSON"
			},
			{
				"name": "body",
				"salience": 0.008651785,
				"type": "OTHER"
			},
			{
				"name": "comment",
				"salience": 0.008613203,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anon",
				"salience": 0.008613203,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.008613203,
				"type": "EVENT"
			},
			{
				"name": "ears",
				"salience": 0.008613203,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.008613203,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.008587196,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/070sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spamming"
				},
				"name": "Spam",
				"salience": 0.0079317335,
				"type": "OTHER"
			},
			{
				"name": "hedge fund",
				"salience": 0.0077253594,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.007283855,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.007283855,
				"type": "WORK_OF_ART"
			},
			{
				"name": "way",
				"salience": 0.0067160456,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0063557564,
				"type": "OTHER"
			},
			{
				"name": "contention",
				"salience": 0.006041727,
				"type": "OTHER"
			},
			{
				"name": "investment firm",
				"salience": 0.006041727,
				"type": "ORGANIZATION"
			},
			{
				"name": "gold prices",
				"salience": 0.006041727,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.006041727,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.006041727,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.0059965947,
				"type": "OTHER"
			},
			{
				"name": "hedge-fund phenomenon",
				"salience": 0.005816415,
				"type": "OTHER"
			},
			{
				"name": "following",
				"salience": 0.005816415,
				"type": "OTHER"
			},
			{
				"name": "plebbit",
				"salience": 0.005816415,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0056963083,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0056963083,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0056963083,
				"type": "OTHER"
			},
			{
				"name": "search",
				"salience": 0.005553783,
				"type": "EVENT"
			},
			{
				"name": "surprise",
				"salience": 0.0049331104,
				"type": "OTHER"
			},
			{
				"name": "thread lead",
				"salience": 0.0049331104,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.0045346017,
				"type": "OTHER"
			},
			{
				"name": "Check",
				"salience": 0.0043459474,
				"type": "OTHER"
			},
			{
				"name": "gf",
				"salience": 0.0042912164,
				"type": "OTHER"
			},
			{
				"name": "search results",
				"salience": 0.004256174,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.004256174,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.004256174,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/056zy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Midas"
				},
				"name": "Midas.",
				"salience": 0.0037199662,
				"type": "PERSON"
			},
			{
				"name": "Elsewhere",
				"salience": 0.0036857536,
				"type": "LOCATION"
			},
			{
				"name": "love gun",
				"salience": 0.0035035326,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "following",
				"salience": 0.0031656516,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0029712175,
				"type": "OTHER"
			},
			{
				"name": "spam",
				"salience": 0.002962234,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.0027765865,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0026846395,
				"type": "OTHER"
			},
			{
				"name": "households",
				"salience": 0.0026846395,
				"type": "PERSON"
			},
			{
				"name": "views",
				"salience": 0.0026846395,
				"type": "OTHER"
			},
			{
				"name": "dimension gi= ves",
				"salience": 0.0026846395,
				"type": "OTHER"
			},
			{
				"name": "references",
				"salience": 0.0025651215,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0023351493,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.0022688638,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0022688638,
				"type": "LOCATION"
			},
			{
				"name": "poster",
				"salience": 0.0020145383,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ashidome domain",
				"salience": 0.00200554,
				"type": "OTHER"
			},
			{
				"name": "crap",
				"salience": 0.00200554,
				"type": "OTHER"
			},
			{
				"name": "treatment facility",
				"salience": 0.00200554,
				"type": "LOCATION"
			},
			{
				"name": "wastewater",
				"salience": 0.00200554,
				"type": "OTHER"
			},
			{
				"name": "SupremeHolmes",
				"salience": 0.0016524467,
				"type": "ORGANIZATION"
			},
			{
				"name": "ofHuge",
				"salience": 0.0016524467,
				"type": "OTHER"
			},
			{
				"name": "https://__._/podesta-emails/emailid/26434#efmACcADo Well",
				"salience": 0.0015788634,
				"type": "OTHER"
			},
			{
				"name": "inLouisville",
				"salience": 0.0014372818,
				"type": "PERSON"
			},
			{
				"name": "Pakistan Javaid Iqbal",
				"salience": 0.0014372818,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b2334",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reddit"
				},
				"name": "Reddit",
				"salience": 0.0012343697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0xs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._state"
				},
				"name": "States",
				"salience": 0.0012343697,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T19:02:47.938+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Secret messages hidden within the SPAM of the Podesta Emails ? page: 1 link Good morning ATS! So, after I get to work and do all my morning routine stuff I sat down at my pc, opened up my usual tabs and began searching through the most recent leak when lo and behold, I ran across a comment on the 4chan thread about today's release: REMEMBER: CHECK EMAILS THAT LOOK LIKE SPAM WE FOUND SPOOKY SOROS # HIDDEN IN FAKE SPAM EMAILS Wow, so my ears perked up at this and I asked for an example. A bit lower down an anon posted this: They are using Spam as a way to communicate. There was thread on plebbit about it, look -- here's an example: https://__._/podesta-emails/emailid/31971 Well, I pulled up the referenced email and read the following: George Soros and the whole hedge-fund phenomenon. They had no Check out our tried-and-true method of male enhancement! waixalle.com... The answer was clear. George Soros seemed to be a modern Midas.body. And all hedge-fund managers have been subject to antifraud legislation. A hedge fund can avoid registering as an investment firm,her contention that the late rise in gold prices had been the result of could cost as much as $1.5 billion.Perfect way to get more manly You can imagine my surprise when I see a reference to George Soros within an email about male enhancement. Well, clicking on that thread lead to the following post: There have been a few interesting emails disguised as spam. Here's a good one: https://__._/podesta-emails/emailid/26434#efmACcADo Well, the email that post references has this: would shunt the wastewater to a treatment facility indifferent image.States. In the above-reference Reddit thread, one poster says this: Holy crap. The woman who owns the ashidome domain is the executive director of at&t Elsewhere, I don't recall where, a Google search for waixalle.com... gives the following as one of the search results: link: the body of Christopher Barrios about 3 miles from his Just imagine how your gf will be happy to see this large love gun! Five British embassy workers who were kidnapped inLouisville would have e= xpected to be soundly booed, they Pakistan Javaid Iqbal said, \"the advice of the SupremeHolmes says that lo= w-income single-parent households are Mr=2E Putin confirmed once again his views on any use ofHuge dimension gi= ves increased force",
		"thread_title": "Secret messages hidden within the SPAM of the Podesta Emails ?",
		"title": "Secret messages hidden within the SPAM of the Podesta Emails ?",
		"type": "bs",
		"uuid": "70be13277ab7b1d154e5e76f81f1833436d935e8"
	},
	"-KhIa5Epp8QIKhL3cuK3": {
		"author": "JinMI",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T19:03:05.849+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "thoughts",
				"salience": 0.12208082,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.12208082,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.10614698,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.10614698,
				"type": "EVENT"
			},
			{
				"name": "hand page",
				"salience": 0.10614698,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.04437907,
				"type": "PERSON"
			},
			{
				"name": "plenty",
				"salience": 0.028224468,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.022780538,
				"type": "OTHER"
			},
			{
				"name": "baggage",
				"salience": 0.022780538,
				"type": "OTHER"
			},
			{
				"name": "tapes",
				"salience": 0.022780538,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fever pitch",
				"salience": 0.015997117,
				"type": "OTHER"
			},
			{
				"name": "mudpit",
				"salience": 0.015997117,
				"type": "OTHER"
			},
			{
				"name": "ends",
				"salience": 0.015997117,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.0154020395,
				"type": "EVENT"
			},
			{
				"name": "drips",
				"salience": 0.0154020395,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0154020395,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.0154020395,
				"type": "OTHER"
			},
			{
				"name": "recordings",
				"salience": 0.0154020395,
				"type": "WORK_OF_ART"
			},
			{
				"name": "immoralities",
				"salience": 0.0154020395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.01404966,
				"type": "ORGANIZATION"
			},
			{
				"name": "more",
				"salience": 0.013068001,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.013068001,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.013068001,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.013068001,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.009768961,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.009768961,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s76_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_O'Keefe"
				},
				"name": "Project Veritas",
				"salience": 0.0094921775,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0094921775,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.009286722,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.008115755,
				"type": "OTHER"
			},
			{
				"name": "roles",
				"salience": 0.007301218,
				"type": "OTHER"
			},
			{
				"name": "tad",
				"salience": 0.0053194724,
				"type": "OTHER"
			},
			{
				"name": "VP",
				"salience": 0.0053194724,
				"type": "PERSON"
			},
			{
				"name": "POTUS",
				"salience": 0.0053194724,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0039924006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Kaine",
				"salience": 0.0032751197,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02q4dxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hunter_Pence"
				},
				"name": "Pence",
				"salience": 0.0032751197,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats5.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T16:28:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Must be impeach of a hand page: 1 link Mingling through some thoughts tonight on thoughts of current events and the next president. No matter who wins, there will be plenty of baggage being brought into the White House. Between tapes and recordings being uncovered to Wikileaks and Project Veritas, corruption and ethical immoralities run deep in both candidates. The drips and leaks from both ends of the mudpit seem to be coming to a fever pitch. Will it end on Nov.9 or will there still be more. Could each side be holding on to a real key piece of damning material to have our future POTUS impeached? This brings up the choices of VP. Kaine and Pence. Now I could just be a tad ignorant here, but I've never heard of either one of them. I understand that they've had minor roles in government however the choices struck me as odd. Were these two possibly chosen for them? Are they the backup plan?",
		"thread_title": "Must be impeach of a hand",
		"title": "Must be impeach of a hand",
		"type": "bs",
		"uuid": "0ad982405c9508a9bc2383a1c04aaeeab7a1a3cf"
	},
	"-KhIa5QCNa-6ahwgFfRa": {
		"author": "Biigs",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:03.492+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "math",
				"salience": 0.15626873,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.15374464,
				"type": "OTHER"
			},
			{
				"name": "universe",
				"salience": 0.10411359,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.08200753,
				"type": "OTHER"
			},
			{
				"name": "simulation",
				"salience": 0.073695,
				"type": "OTHER"
			},
			{
				"name": "math",
				"salience": 0.073695,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.06401907,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0391065,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.02667325,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.023714937,
				"type": "LOCATION"
			},
			{
				"name": "simulation",
				"salience": 0.011954257,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.010756519,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.010487955,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.010097588,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.009599535,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.009599535,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.009242133,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.009242133,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.009242133,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.008108542,
				"type": "LOCATION"
			},
			{
				"name": "plans",
				"salience": 0.00800659,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.00784055,
				"type": "PERSON"
			},
			{
				"name": "planet weather",
				"salience": 0.00784055,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00784055,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.00784055,
				"type": "OTHER"
			},
			{
				"name": "universe",
				"salience": 0.006944261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06p5g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Solar_System"
				},
				"name": "SOLAR SYSTEM",
				"salience": 0.0066579524,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.005812298,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.005713565,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0056939865,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.0050339242,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.0049705673,
				"type": "OTHER"
			},
			{
				"name": "SYSTEMS",
				"salience": 0.0049300017,
				"type": "OTHER"
			},
			{
				"name": "programming powers",
				"salience": 0.0047852336,
				"type": "OTHER"
			},
			{
				"name": "universe",
				"salience": 0.004079675,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0038753597,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0035756172,
				"type": "OTHER"
			},
			{
				"name": "computing",
				"salience": 0.0031902003,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats17.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:03.492+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link Okay, we are all familiar with the theory that our universe is some sort of simulation, math that works so specifically, so well, so many predictions from math and science that are proved right more and more often etc and so on. (not going to get into \"proof\" google it!) So you have to ask yourself WHY would a thing, being, God, whatever want to create such a virtual simulation? We know that we as humans have the right to live and have family's, often with as many kids as sustainable (at the time). This means that however well we create food, we WILL use up all resources on this planet weather we make the best plans or not. But we cant crack viable ways to leave this planet and populate others beyond our own slowly decaying star. So what about this. What if the answer was to create a sped up reality, using all our computing and programming powers to emulate the universe (or observable universe), wait for life to grow on a planet and then give them the same problem we have so that we can reap the answer for ourselves? LEAVING THE SOLAR SYSTEM TO COLONISE OTHER SYSTEMS, INDEFINITELY. Could it be as simple as that? Love to hear your thoughts, been thinking about this for some time now.",
		"thread_title": "Universe is a hologram/virtual reality - But why? Could it be this?",
		"title": "Universe is a hologram/virtual reality - But why? Could it be this?",
		"type": "bs",
		"uuid": "f7725a64593bf05c0b17a910227b2a611ffa0150"
	},
	"-KhIa5Ylu_fURaboghnu": {
		"author": "sanitizedinfo",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:04.584+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09xrxq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peter_Capaldi"
				},
				"name": "Peter Capaldi",
				"salience": 0.34028342,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.12079754,
				"type": "PERSON"
			},
			{
				"name": "reply",
				"salience": 0.1057144,
				"type": "OTHER"
			},
			{
				"name": "avatar",
				"salience": 0.07201953,
				"type": "OTHER"
			},
			{
				"name": "celebration",
				"salience": 0.07201953,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0wp920q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doctor_Who"
				},
				"name": "Doctor Who",
				"salience": 0.04481461,
				"type": "WORK_OF_ART"
			},
			{
				"name": "favourite",
				"salience": 0.022683613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088pn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zeus"
				},
				"name": "Zeus",
				"salience": 0.021252217,
				"type": "PERSON"
			},
			{
				"name": "favourite",
				"salience": 0.019020235,
				"type": "OTHER"
			},
			{
				"name": "oldies",
				"salience": 0.015478631,
				"type": "PERSON"
			},
			{
				"name": "reboot",
				"salience": 0.015478631,
				"type": "EVENT"
			},
			{
				"name": "reply",
				"salience": 0.012546491,
				"type": "OTHER"
			},
			{
				"name": "coherence",
				"salience": 0.011290614,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.011008978,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thread",
				"salience": 0.010870793,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07c_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Time"
				},
				"name": "Time",
				"salience": 0.010625583,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/063zdxb"
				},
				"name": "Tom",
				"salience": 0.010042759,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.008880771,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.008880771,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.008880771,
				"type": "OTHER"
			},
			{
				"name": "Hm",
				"salience": 0.006700702,
				"type": "ORGANIZATION"
			},
			{
				"name": "Proposition",
				"salience": 0.006639184,
				"type": "OTHER"
			},
			{
				"name": "Heavensent",
				"salience": 0.0064511066,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0063114967,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fv2k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omega_Point"
				},
				"name": "Omega Point",
				"salience": 0.0054723844,
				"type": "OTHER"
			},
			{
				"name": "substance",
				"salience": 0.0048381803,
				"type": "OTHER"
			},
			{
				"name": "latter",
				"salience": 0.0048381803,
				"type": "ORGANIZATION"
			},
			{
				"name": "swanne",
				"salience": 0.0048381803,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kp19",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chronos"
				},
				"name": "Chronos",
				"salience": 0.0040896935,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0036154995,
				"type": "OTHER"
			},
			{
				"name": "entropy",
				"salience": 0.0036154995,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:04.584+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "a reply to: corblimeyguvnor My current avatar is in celebration of Doctor Who Day, the 23rd of November. I have to agree, Tom was also my favourite of the oldies, and Peter Capaldi is my favourite of the reboot. He is old, he can be childish but also so deep, he can be dark but also joyful. His Heavensent episode was absolutely... Awesome. a reply to: sanitizedinfo Sorry to derail the thread! God is Time, eh? Hm, that's actually pretty thought provoking. I often picture God as the result of Time, a bit like the concept of the Omega Point. But God being Time is as interesting of an idea. If entropy increases with passing time, however, doesn't that mean that God is doomed to lose coherence in the future? Proposition: What if Time (Chronos) is actually the emeny of God (Zeus), forever attempting to swallow the latter's substance? edit on 27-10-2016 by swanne because: (no reason given)",
		"thread_title": "Time:God",
		"title": "Time:God",
		"type": "bs",
		"uuid": "f396260099688929312821ce82b34f0d70e49009"
	},
	"-KhIa5jyUhYzD7Ap7vuc": {
		"author": "Jonjonj",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:04.623+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04_jsg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_DeLonge"
				},
				"name": "Tom DeLonge",
				"salience": 0.23882434,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07s661",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_M._Greer"
				},
				"name": "Steven Greer",
				"salience": 0.1035877,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.04670497,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Podesta",
				"salience": 0.038301546,
				"type": "PERSON"
			},
			{
				"name": "IMO",
				"salience": 0.03548501,
				"type": "ORGANIZATION"
			},
			{
				"name": "guys",
				"salience": 0.022898505,
				"type": "PERSON"
			},
			{
				"name": "op",
				"salience": 0.022898505,
				"type": "OTHER"
			},
			{
				"name": "conclusions",
				"salience": 0.022898505,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.022898505,
				"type": "OTHER"
			},
			{
				"name": "face value",
				"salience": 0.022898505,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.022898505,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.022898505,
				"type": "OTHER"
			},
			{
				"name": "patterns",
				"salience": 0.02177045,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.012078374,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.01195158,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.011329784,
				"type": "OTHER"
			},
			{
				"name": "franchise",
				"salience": 0.011264386,
				"type": "WORK_OF_ART"
			},
			{
				"name": "doors",
				"salience": 0.010997302,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.0109076025,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.009626867,
				"type": "OTHER"
			},
			{
				"name": "players",
				"salience": 0.009447232,
				"type": "PERSON"
			},
			{
				"name": "individual",
				"salience": 0.009447232,
				"type": "PERSON"
			},
			{
				"name": "keys",
				"salience": 0.009370152,
				"type": "OTHER"
			},
			{
				"name": "franchise",
				"salience": 0.008473258,
				"type": "OTHER"
			},
			{
				"name": "franchise",
				"salience": 0.008157344,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.006970861,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.006626396,
				"type": "OTHER"
			},
			{
				"name": "BIG",
				"salience": 0.006626396,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.006626396,
				"type": "OTHER"
			},
			{
				"name": "packs",
				"salience": 0.006626396,
				"type": "OTHER"
			},
			{
				"name": "t-shirts",
				"salience": 0.006626396,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "coffee cups",
				"salience": 0.006626396,
				"type": "OTHER"
			},
			{
				"name": "merchandise",
				"salience": 0.006626396,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "movie tie-ins",
				"salience": 0.006626396,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.006626396,
				"type": "OTHER"
			},
			{
				"name": "novels",
				"salience": 0.006626396,
				"type": "WORK_OF_ART"
			},
			{
				"name": "schtick",
				"salience": 0.0063792495,
				"type": "OTHER"
			},
			{
				"name": "keys",
				"salience": 0.006327169,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.006247505,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0060144733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gcvy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Billy_Meier"
				},
				"name": "Billy Meier",
				"salience": 0.0058177705,
				"type": "PERSON"
			},
			{
				"name": "David Fry",
				"salience": 0.0058177705,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01l3mw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Adamski"
				},
				"name": "George Adamski",
				"salience": 0.0058177705,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09020s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Moore_(ufologist)"
				},
				"name": "William Moore",
				"salience": 0.0058177705,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.005764279,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00564522,
				"type": "OTHER"
			},
			{
				"name": "representative",
				"salience": 0.0054103695,
				"type": "PERSON"
			},
			{
				"name": "go-between",
				"salience": 0.0054103695,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0054103695,
				"type": "ORGANIZATION"
			},
			{
				"name": "George Lucas Star Wars",
				"salience": 0.0047112023,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0046678754,
				"type": "PERSON"
			},
			{
				"name": "Disclosure",
				"salience": 0.0046678754,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0046678754,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0043616607,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.004306722,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.004042229,
				"type": "OTHER"
			},
			{
				"name": "Sekret Machines",
				"salience": 0.0039275144,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0038423694,
				"type": "OTHER"
			},
			{
				"name": "dupe",
				"salience": 0.0036523843,
				"type": "OTHER"
			},
			{
				"name": "handlers",
				"salience": 0.0035609414,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFOs",
				"salience": 0.0033307523,
				"type": "OTHER"
			},
			{
				"name": "dinner",
				"salience": 0.0030198437,
				"type": "OTHER"
			},
			{
				"name": "multi-millionaire",
				"salience": 0.002944228,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.002944228,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.002944228,
				"type": "OTHER"
			},
			{
				"name": "Disclosure",
				"salience": 0.0025400014,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0025400014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0024882273,
				"type": "ORGANIZATION"
			},
			{
				"name": "potential",
				"salience": 0.002373309,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0021994319,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0021994319,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Star_Wars"
				},
				"name": "Star-Wars",
				"salience": 0.002092821,
				"type": "ORGANIZATION"
			},
			{
				"name": "schuyler",
				"salience": 0.0018121887,
				"type": "PERSON"
			},
			{
				"name": "Stephen Bassett",
				"salience": 0.0016794073,
				"type": "PERSON"
			},
			{
				"name": "Paradigm Research Group",
				"salience": 0.0013536841,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:04.623+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link IMO, here is what is happening. you guys are jumping to conclusions by not having any context and taking this at face value. I've been into this a very long time, and with that perspective I see some repeating patterns. To the point of the op, this is the same old same old--with a new generation of players. We've seen the same exact thing over the last 70 years with people like George Adamski, David Fry, Billy Meier, William Moore, and Steven Greer. It's the same story: A privileged individual is given the keys to open a few doors about what \"really is happening.\" Tom DeLonge believes (and that's all it takes) he has been given these keys, and he's running with it, as his handlers knew he would. Tom sees this whole \"Sekret Machines\" schtick as a \"franchise.\" That's how he talks about it. when he says \"franchise\" he's talking in George Lucas Star Wars terms with movie tie-ins, merchandise, graphic novels, coffee cups, t-shirts, and back packs. That's his vision for this. He sees opportunity to make this thing BIG. Now, he's been writing to Podesta and who knows who else, but he and we know Podesta has an interest in UFOs. So Podesta is seen by Tom as an \"in\" for what he perceives as the new administration and he is offering himself as a legitimate representative of his generation. His statement to Podesta is one of POSITIONING HIMSELF as a natural go-between for these issues--especially with \"young people.\" It has nothing really to do with young people being disenfranchised and cynical and everything to do with Tom DeLonge taking an important position vis-a-vis \"Disclosure.\" If DeLonge pulls this off it won't be Stephen Bassett of the Paradigm Research Group or Steven Greer, who \"once had dinner with the head of the CIA\" whose name is forever associated with \"Disclosure.\" The name everyone will remember is Tom DeLonge. THAT'S what is happening here. DeLonge is attempting to position himself to take major advantage of what he now thinks is reality, and which also includes a major Star-Wars-sized \"franchise\" that has the potential of turning him from a mere multi-millionaire into something much larger. Of course, he may also be a dupe and or delusional, but he may not know that yet. edit on 10/27/2016 by schuyler because: (no reason given)",
		"thread_title": "Tom deLonge: Changing the cynical views of youth towards government",
		"title": "Tom deLonge: Changing the cynical views of youth towards government",
		"type": "bs",
		"uuid": "f400365115128506e8899d6a524d875f36d22312"
	},
	"-KhIa62DyoaunNIIyPyX": {
		"author": "BlackProject",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:06.368+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0h1ht5z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tommy_Robinson_(activist)"
				},
				"name": "Tommy Robinson",
				"salience": 0.25991815,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.065768465,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k9qb3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_Defence_League"
				},
				"name": "English Defence League",
				"salience": 0.06329794,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "islam",
				"salience": 0.0497896,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.03921566,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.028438237,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.026290504,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.023355845,
				"type": "OTHER"
			},
			{
				"name": "ears",
				"salience": 0.018422514,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.018422514,
				"type": "WORK_OF_ART"
			},
			{
				"name": "side",
				"salience": 0.018285468,
				"type": "OTHER"
			},
			{
				"name": "islamists",
				"salience": 0.014240243,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.013496066,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.011265138,
				"type": "OTHER"
			},
			{
				"name": "muslim",
				"salience": 0.010886511,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.010886511,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.01087555,
				"type": "LOCATION"
			},
			{
				"name": "reside",
				"salience": 0.0105673615,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0094303945,
				"type": "PERSON"
			},
			{
				"name": "impact",
				"salience": 0.0094303945,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0094303945,
				"type": "OTHER"
			},
			{
				"name": "sleeper cells",
				"salience": 0.008813982,
				"type": "OTHER"
			},
			{
				"name": "creation",
				"salience": 0.008361046,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0071808575,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.006960227,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0066230083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0064192023,
				"type": "LOCATION"
			},
			{
				"name": "Stephen Christopher Yaxley-Lennon",
				"salience": 0.0058095916,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.005738821,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0057311947,
				"type": "OTHER"
			},
			{
				"name": "faiths",
				"salience": 0.0055516995,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.005530427,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0049701766,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.004904189,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.004904189,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.00448801,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.00448801,
				"type": "OTHER"
			},
			{
				"name": "islamist movement",
				"salience": 0.00448801,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0043236427,
				"type": "WORK_OF_ART"
			},
			{
				"name": "members",
				"salience": 0.0038866964,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0038866964,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0038866964,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0038866964,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00387495,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.0034857334,
				"type": "WORK_OF_ART"
			},
			{
				"name": "town",
				"salience": 0.0034857334,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0034857334,
				"type": "PERSON"
			},
			{
				"name": "home towns",
				"salience": 0.0034857334,
				"type": "LOCATION"
			},
			{
				"name": "home town",
				"salience": 0.0034857334,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.0034857334,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0034857334,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0032863712,
				"type": "LOCATION"
			},
			{
				"name": "fear",
				"salience": 0.0031474363,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.0031474363,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.003107795,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.003030003,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0029039239,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.0028459153,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0028459153,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0028459153,
				"type": "PERSON"
			},
			{
				"name": "generation",
				"salience": 0.0028459153,
				"type": "PERSON"
			},
			{
				"name": "generation",
				"salience": 0.0028459153,
				"type": "OTHER"
			},
			{
				"name": "root cause",
				"salience": 0.0027378097,
				"type": "OTHER"
			},
			{
				"name": "extremism",
				"salience": 0.0027255854,
				"type": "OTHER"
			},
			{
				"name": "scaremonger",
				"salience": 0.0027255854,
				"type": "OTHER"
			},
			{
				"name": "scape goat",
				"salience": 0.0027255854,
				"type": "OTHER"
			},
			{
				"name": "behaviour",
				"salience": 0.0027255854,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0027255854,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0026238791,
				"type": "OTHER"
			},
			{
				"name": "multiculturalism",
				"salience": 0.0026238791,
				"type": "OTHER"
			},
			{
				"name": "nose",
				"salience": 0.0026238791,
				"type": "OTHER"
			},
			{
				"name": "cultures",
				"salience": 0.0026238791,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.0026238791,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "some",
				"salience": 0.0026024473,
				"type": "PERSON"
			},
			{
				"name": "statements",
				"salience": 0.0025696647,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0025696647,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0025696647,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.002518328,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00245528,
				"type": "LOCATION"
			},
			{
				"name": "cause",
				"salience": 0.0023814556,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0023432514,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.0022251997,
				"type": "EVENT"
			},
			{
				"name": "debates",
				"salience": 0.0022251997,
				"type": "EVENT"
			},
			{
				"name": "other",
				"salience": 0.0021261382,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0016697893,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0016623313,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0016623313,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0016623313,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0016623313,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0016136516,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0015801167,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0015034406,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0014110726,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0014110726,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0013981703,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0013459766,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.001329944,
				"type": "WORK_OF_ART"
			},
			{
				"name": "faith",
				"salience": 0.0012521636,
				"type": "OTHER"
			},
			{
				"name": "watch",
				"salience": 0.0012106864,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mans",
				"salience": 0.0012106864,
				"type": "PERSON"
			},
			{
				"name": "everywhere",
				"salience": 0.0012106864,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0012106864,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.0012106864,
				"type": "OTHER"
			},
			{
				"name": "Desensitisation",
				"salience": 0.001165489,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0010530389,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.0010444334,
				"type": "LOCATION"
			},
			{
				"name": "pages",
				"salience": 0.0010444334,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.0010444334,
				"type": "OTHER"
			},
			{
				"name": "muslims",
				"salience": 0.0010444334,
				"type": "PERSON"
			},
			{
				"name": "worry",
				"salience": 0.00096357916,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.0009043698,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0009043698,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.0009043698,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.0009043698,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.0007572301,
				"type": "OTHER"
			},
			{
				"name": "BlackProject",
				"salience": 0.0007451198,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0005565764,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:06.368+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link I am sure that this post will fall on deaf ears. I am also sure that this may not be the best place to make any form of impact as let's be honest. I do not think many muslim's reside on this website and if they do, then I am sure they will defend their side just as usual. Tommy Robinson (also known as Stephen Christopher Yaxley-Lennon) is the co-founder and leader of the English Defence League. Some of you who know this man may already, may have opinions about him because of his creation of the EDL and what some of its members have been known to behave like. However, Tommy Robinson in my eyes is one of the very few, if not the only person to stand up to the islamist movement in this country. It is a good thing he is around whether you respect him or not as islamists have one thing in common, they have a lot to loose and also a lot to gain either way. Just like anyone that stands up to a movement like islam, its always a difficult one. Considering England has been asleep for to long to even notice what is going on under its nose. Everyone thinks England is promoting multiculturalism by allowing Islam to move freely within this country but islam and its ways are not to get along peacefully, they want western cultures out completely. If left to their own devices, England will be taken over within 10 - 20 years or sooner. Here is a short video of Tommy Robinson travelling through his local town and regardless of him being the main man of the EDL he is not being abusive to anyone yet this is the kind of treatment a born and raised English man gets in his own home town. As you can tell in the video above. Disgusting behaviour by disgusting people who are using their faith as a scape goat to instil fear, scaremonger and literally drive out English people from there home towns. How? Because people of England are sitting back and not sharing their fears about such extremism in their own country. Also a big shame is that the younger generation are being taught to accept anyone and everyone and although this is a beautiful message to portray this is the root cause of Islam continuing to grow. You will see in many debates get side tracked by blank statements made by younger generations about such political points only to end up with a nonsensical opinion that gets us nowhere. The older generation are tired of fighting, so we have only this moment in time to get those capable, those noticing changes in the UK and America and many other places to realise what is occurring before there is no one of the right age to know how things have changed. Desensitisation is the worry here. There is so much to cover a topic like this could last pages and pages, however I just want to point out a few things. The rest should be up to conversation. The current state of moderate muslims is not a thing. A muslim lives by the faith of Islam and if they had to side with one or the other, they would side with Islam. This should be cause of concern because even though they deem themselves not the same or as severe, they are in fact, just as severe. Basically they are sleeper cells being created within our very own country. They are not here to live peacefully along side us either. They are here to promote their faith and grow, growing means pushing more and more on other faiths that for many years have lived together, peacefully. Only until now, has this country had problems like this. I am not here to promote Tommy Robinson but I am here to state that this mans points should be heard. If you have the time now or again, give this video below a watch. He explains very well where things have gone, are going and will end up. Not just in the UK but everywhere in the world that does nothing about this. edit on 27-10-2016 by BlackProject because: (no reason given)",
		"thread_title": "War On Islam, As Islam Only Wants War. No Peace.",
		"title": "War On Islam, As Islam Only Wants War. No Peace.",
		"type": "bs",
		"uuid": "2ba7c32520da5896d6a1d30ce3089e73312c6897"
	},
	"-KhIa6JuNplr0fCwxvXU": {
		"author": "lostbook",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:07.960+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.63061506,
				"type": "ORGANIZATION"
			},
			{
				"name": "space",
				"salience": 0.08443238,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d_23",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Natural_satellite"
				},
				"name": "Moon",
				"salience": 0.040118065,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.025421781,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09cws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mars"
				},
				"name": "Mars",
				"salience": 0.015656525,
				"type": "LOCATION"
			},
			{
				"name": "space",
				"salience": 0.013855937,
				"type": "LOCATION"
			},
			{
				"name": "habitats",
				"salience": 0.013543545,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00943535,
				"type": "PERSON"
			},
			{
				"name": "Space",
				"salience": 0.008858843,
				"type": "LOCATION"
			},
			{
				"name": "space",
				"salience": 0.008858843,
				"type": "OTHER"
			},
			{
				"name": "gateway",
				"salience": 0.0088455565,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b3_3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NeXTSTEP"
				},
				"name": "NextSTEP",
				"salience": 0.0087747825,
				"type": "ORGANIZATION"
			},
			{
				"name": "space page",
				"salience": 0.007668062,
				"type": "OTHER"
			},
			{
				"name": "www.abovetopsecret.com",
				"salience": 0.0054617603,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.005432493,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.005020567,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.005020567,
				"type": "OTHER"
			},
			{
				"name": "gateway",
				"salience": 0.004535045,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0039290865,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.0039290865,
				"type": "OTHER"
			},
			{
				"name": "distances",
				"salience": 0.0039290865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jwy_3r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deep_Space_Habitat"
				},
				"name": "Deep-Space Habitat",
				"salience": 0.0034864969,
				"type": "LOCATION"
			},
			{
				"name": "program",
				"salience": 0.0032563265,
				"type": "OTHER"
			},
			{
				"name": "space habitats",
				"salience": 0.0026486828,
				"type": "OTHER"
			},
			{
				"name": "habitat",
				"salience": 0.0026486828,
				"type": "OTHER"
			},
			{
				"name": "www.nasa.gov",
				"salience": 0.0023564328,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.0020717843,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.0020717843,
				"type": "ORGANIZATION"
			},
			{
				"name": "astronauts",
				"salience": 0.0020717843,
				"type": "PERSON"
			},
			{
				"name": "astronauts",
				"salience": 0.0020717843,
				"type": "PERSON"
			},
			{
				"name": "systems",
				"salience": 0.0020500273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/038hvr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bigelow_Aerospace"
				},
				"name": "Bigelow Aerospace",
				"salience": 0.001997465,
				"type": "ORGANIZATION"
			},
			{
				"name": "space habitat",
				"salience": 0.0018582204,
				"type": "OTHER"
			},
			{
				"name": "habitat",
				"salience": 0.001766435,
				"type": "OTHER"
			},
			{
				"name": "location",
				"salience": 0.0016203341,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0016203341,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0016203341,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.0016203341,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.0015729351,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0015729351,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0015482644,
				"type": "OTHER"
			},
			{
				"name": "habitat program",
				"salience": 0.0015142818,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.0013918278,
				"type": "EVENT"
			},
			{
				"name": "awards",
				"salience": 0.0013570033,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0012843353,
				"type": "LOCATION"
			},
			{
				"name": "step",
				"salience": 0.0012641853,
				"type": "OTHER"
			},
			{
				"name": "missions",
				"salience": 0.0012633031,
				"type": "EVENT"
			},
			{
				"name": "landings",
				"salience": 0.0011364195,
				"type": "OTHER"
			},
			{
				"name": "stone",
				"salience": 0.0011364195,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0011364195,
				"type": "EVENT"
			},
			{
				"name": "destination",
				"salience": 0.0011364195,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0011364195,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0011364195,
				"type": "PERSON"
			},
			{
				"name": "ambitions",
				"salience": 0.0011079785,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.0010940257,
				"type": "PERSON"
			},
			{
				"name": "mention",
				"salience": 0.0010940257,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0010940257,
				"type": "OTHER"
			},
			{
				"name": "significance",
				"salience": 0.0010940257,
				"type": "OTHER"
			},
			{
				"name": "contract",
				"salience": 0.0010940257,
				"type": "OTHER"
			},
			{
				"name": "moon",
				"salience": 0.00095960544,
				"type": "LOCATION"
			},
			{
				"name": "elsewhere",
				"salience": 0.0009278367,
				"type": "LOCATION"
			},
			{
				"name": "surface",
				"salience": 0.0009278367,
				"type": "OTHER"
			},
			{
				"name": "expedition",
				"salience": 0.0009278367,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0009278367,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.0009278367,
				"type": "OTHER"
			},
			{
				"name": "human space flight missions",
				"salience": 0.0008004859,
				"type": "OTHER"
			},
			{
				"name": "space exploration capabilities",
				"salience": 0.0008004859,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0008004859,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.000744713,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0007186024,
				"type": "LOCATION"
			},
			{
				"name": "Journey to Mars",
				"salience": 0.00069961697,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0q3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apollo_program"
				},
				"name": "Apollo",
				"salience": 0.00069961697,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.00069318124,
				"type": "OTHER"
			},
			{
				"name": "ATS",
				"salience": 0.0006212043,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0005830446,
				"type": "OTHER"
			},
			{
				"name": "step program",
				"salience": 0.0005221673,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0005048731,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0005048731,
				"type": "OTHER"
			},
			{
				"name": "morbidity",
				"salience": 0.0005048731,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0005048731,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05d8t2h"
				},
				"name": "Simon",
				"salience": 0.00049680093,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fgvhh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Proving_ground"
				},
				"name": "Proving Ground",
				"salience": 0.0004927418,
				"type": "LOCATION"
			},
			{
				"name": "venture",
				"salience": 0.00048602754,
				"type": "OTHER"
			},
			{
				"name": "astronauts",
				"salience": 0.00048239334,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.00043555125,
				"type": "LOCATION"
			},
			{
				"name": "capabilities",
				"salience": 0.00043555125,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0178g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing"
				},
				"name": "Boeing",
				"salience": 0.00042667246,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hkqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_Martin"
				},
				"name": "Lockheed Martin",
				"salience": 0.00042667246,
				"type": "ORGANIZATION"
			},
			{
				"name": "aerospace companies",
				"salience": 0.0004192922,
				"type": "ORGANIZATION"
			},
			{
				"name": "others",
				"salience": 0.00037714743,
				"type": "PERSON"
			},
			{
				"name": "space station",
				"salience": 0.00037714743,
				"type": "LOCATION"
			},
			{
				"name": "Some",
				"salience": 0.00037714743,
				"type": "PERSON"
			},
			{
				"name": "periods",
				"salience": 0.00037714743,
				"type": "OTHER"
			},
			{
				"name": "technologies",
				"salience": 0.00037714743,
				"type": "OTHER"
			},
			{
				"name": "prototype",
				"salience": 0.00037714743,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.00037714743,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ATS",
				"salience": 0.00036808403,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012w3z5g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orbital_ATK"
				},
				"name": "Orbital ATK",
				"salience": 0.00031074113,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b1_d3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sierra_Nevada_Corporation"
				},
				"name": "Sierra Nevada Corporation",
				"salience": 0.00031074113,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/080h7k_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NanoRacks"
				},
				"name": "NanoRacks",
				"salience": 0.00031074113,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00031074113,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:07.960+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "NASA’s gateway to deep space page: 1 www.abovetopsecret.com... Now, it sems that NASA is making good on his promise and is moving forward with the plan by establishing a Deep-Space Habitat near the Moon to test out systems for people who would live in orbit or travel long distances in Space; a gateway to deep space NASA plans to address its problem by parking a “deep space” habitat in a location near the Moon, which astronauts could visit and use to become acclimated to life beyond low-Earth orbit. President Obama mentioned deep space habitats earlier this month, when he reiterated his call for NASA to send humans to Mars. “I'm excited to announce that we are working with our commercial partners to build new habitats that can sustain and transport astronauts on long-duration missions in deep space,” Obama said. This wasn’t really a new announcement, as NASA has been working on the habitat program for a couple of years. Nevertheless, before the president's mention, this NextSTEP program had received surprisingly little attention given its significance—it might be the most important contract NASA awards for next decade. As Obama said, NASA has embarked upon a \"Journey to Mars.\" While the plan may change to include lunar landings as a stepping stone to Mars, the space agency does intend to try and venture back into deep space for the first time since the Apollo program. Whatever destination it chooses, NASA's ambitions will begin with the deep space habitat, because it is an affordable first step, costing hundreds of millions or a few billion dollars initially, instead of multiple billions needed for a full-blown expedition to the Moon's surface, Mars or elsewhere in deep space. \"This is the right next step,\" Simon said. \"We need to understand how to live in deep space, how to live off of our planet.\" The first habitat launched in the 2020s won’t be exactly the same as the vehicle NASA eventually sends to Mars. Rather, it will serve as a prototype to help the space agency understand the capabilities, technologies, and systems needed for astronauts to survive for long periods in deep space. Some of those systems can be tested on the ground or the existing space station, but others can only be tested further from Earth. This venture is part of the Next step program initiated by NASA: www.nasa.gov... NextSTEP is a public-private partnership model that seeks commercial development of deep space exploration capabilities to support more extensive human space flight missions in the Proving Ground around and beyond cislunar space—the space near Earth that extends just beyond the moon. So far, NASA has partnered with 6 companies in this effort: Bigelow Aerospace, Boeing, Lockheed Martin, Orbital ATK, Sierra Nevada Corporation, and NanoRacks. This is great, ATS! I am very excited at this news, even with all of the morbidity we have in the world today; I'm still excited for the future..! This is an ambitious plan..can US aerospace companies pull this off alone, or should this be more of a global effort? What does ATS think?",
		"thread_title": "NASA's gateway to deep space",
		"title": "NASA's gateway to deep space",
		"type": "bs",
		"uuid": "ba8e59cdfd38086852ef55230633ab4b07123f99"
	},
	"-KhIa6yRcnvJ-PYTSKMG": {
		"author": "mobiusmale",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:08.579+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Obamacare",
				"salience": 0.36515695,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.054150216,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.035536364,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.035178907,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.02185197,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.020549994,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.02006843,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.016995478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.016934255,
				"type": "ORGANIZATION"
			},
			{
				"name": "argument",
				"salience": 0.012032777,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.011656904,
				"type": "PERSON"
			},
			{
				"name": "poor",
				"salience": 0.011276757,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.011216657,
				"type": "OTHER"
			},
			{
				"name": "Headshot",
				"salience": 0.011142643,
				"type": "PERSON"
			},
			{
				"name": "October Surprise",
				"salience": 0.01054047,
				"type": "OTHER"
			},
			{
				"name": "premiums",
				"salience": 0.010034577,
				"type": "OTHER"
			},
			{
				"name": "brunt",
				"salience": 0.00894002,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.008398781,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.0076892115,
				"type": "OTHER"
			},
			{
				"name": "poor",
				"salience": 0.0067708264,
				"type": "PERSON"
			},
			{
				"name": "treatment",
				"salience": 0.006511909,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0064930944,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.006253339,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0058812895,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.0056268726,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0052076536,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.004972486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.004843691,
				"type": "PERSON"
			},
			{
				"name": "segment",
				"salience": 0.0045434623,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.004456818,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6gkfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream_media"
				},
				"name": "MSM",
				"salience": 0.004409953,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.004253603,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.0042185267,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0038635146,
				"type": "OTHER"
			},
			{
				"name": "turns",
				"salience": 0.0038635146,
				"type": "OTHER"
			},
			{
				"name": "stream",
				"salience": 0.003414509,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0033846498,
				"type": "PERSON"
			},
			{
				"name": "peoples",
				"salience": 0.0033215096,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0033215096,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0033215096,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.0029446313,
				"type": "PERSON"
			},
			{
				"name": "Premiums",
				"salience": 0.0028570564,
				"type": "OTHER"
			},
			{
				"name": "poor",
				"salience": 0.0027873015,
				"type": "PERSON"
			},
			{
				"name": "reply",
				"salience": 0.0026669784,
				"type": "OTHER"
			},
			{
				"name": "revelations",
				"salience": 0.002617272,
				"type": "OTHER"
			},
			{
				"name": "supreme leader",
				"salience": 0.002617272,
				"type": "PERSON"
			},
			{
				"name": "intrigue",
				"salience": 0.002617272,
				"type": "OTHER"
			},
			{
				"name": "twists",
				"salience": 0.002617272,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.002558814,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0xs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._state"
				},
				"name": "State",
				"salience": 0.00252765,
				"type": "ORGANIZATION"
			},
			{
				"name": "minority",
				"salience": 0.0024124093,
				"type": "ORGANIZATION"
			},
			{
				"name": "course",
				"salience": 0.0023719724,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002285714,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.0021292423,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0020856885,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0020654083,
				"type": "PERSON"
			},
			{
				"name": "poor",
				"salience": 0.0020307363,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.0019895567,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.001883227,
				"type": "OTHER"
			},
			{
				"name": "Obamacare Premiums",
				"salience": 0.001759398,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.0017166245,
				"type": "OTHER"
			},
			{
				"name": "Red",
				"salience": 0.0017100995,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0016919234,
				"type": "ORGANIZATION"
			},
			{
				"name": "minority",
				"salience": 0.0016919234,
				"type": "ORGANIZATION"
			},
			{
				"name": "mobiusmale",
				"salience": 0.0015441389,
				"type": "PERSON"
			},
			{
				"name": "hardest",
				"salience": 0.0015441389,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0015441389,
				"type": "PERSON"
			},
			{
				"name": "mobiusmale",
				"salience": 0.0015441389,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0015441389,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0015441389,
				"type": "PERSON"
			},
			{
				"name": "business owners",
				"salience": 0.0015189816,
				"type": "PERSON"
			},
			{
				"name": "poor",
				"salience": 0.0015173068,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0015031518,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.0014534469,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.0014534469,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0014484585,
				"type": "PERSON"
			},
			{
				"name": "bill",
				"salience": 0.0014260741,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0fzh9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Medicare_(United_States)"
				},
				"name": "Medicare",
				"salience": 0.0014242447,
				"type": "ORGANIZATION"
			},
			{
				"name": "businesses",
				"salience": 0.0013858891,
				"type": "ORGANIZATION"
			},
			{
				"name": "minority",
				"salience": 0.0013813752,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0013683686,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0013683686,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0013371863,
				"type": "WORK_OF_ART"
			},
			{
				"name": "typo",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0013371863,
				"type": "PERSON"
			},
			{
				"name": "husband",
				"salience": 0.0013371863,
				"type": "PERSON"
			},
			{
				"name": "pocketbooks",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "pain",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "impacts",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "Polls",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "bank accounts",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "increases",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "attention span",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "paycheque",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0013371863,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0013371863,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.0013371863,
				"type": "OTHER"
			},
			{
				"name": "tens of thousands",
				"salience": 0.0013371863,
				"type": "PERSON"
			},
			{
				"name": "health insurance",
				"salience": 0.0013300421,
				"type": "OTHER"
			},
			{
				"name": "abortion",
				"salience": 0.0012469382,
				"type": "OTHER"
			},
			{
				"name": "premiums",
				"salience": 0.0011768161,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.0011604368,
				"type": "OTHER"
			},
			{
				"name": "hike",
				"salience": 0.0011256763,
				"type": "EVENT"
			},
			{
				"name": "premium hikes",
				"salience": 0.0011256763,
				"type": "EVENT"
			},
			{
				"name": "hikes",
				"salience": 0.0011256763,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0010984426,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0010948965,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0010550476,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Fl",
				"salience": 0.0010405726,
				"type": "LOCATION"
			},
			{
				"name": "insurance",
				"salience": 0.0010191714,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0010083182,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.0009811345,
				"type": "OTHER"
			},
			{
				"name": "segment",
				"salience": 0.0009790312,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.00096265104,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0009594977,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0009594977,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0009594977,
				"type": "PERSON"
			},
			{
				"name": "premiums",
				"salience": 0.0009248968,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.00090053095,
				"type": "OTHER"
			},
			{
				"name": "blue states",
				"salience": 0.00090053095,
				"type": "OTHER"
			},
			{
				"name": "exchanges",
				"salience": 0.00090053095,
				"type": "OTHER"
			},
			{
				"name": "brunt",
				"salience": 0.0008663139,
				"type": "OTHER"
			},
			{
				"name": "penalty",
				"salience": 0.0008579932,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0008232109,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0008231344,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0008231344,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01g5v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Blue"
				},
				"name": "Blue",
				"salience": 0.0008231344,
				"type": "ORGANIZATION"
			},
			{
				"name": "course",
				"salience": 0.0008179476,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00081309484,
				"type": "EVENT"
			},
			{
				"name": "left",
				"salience": 0.00081309484,
				"type": "OTHER"
			},
			{
				"name": "premium hikes",
				"salience": 0.0007892847,
				"type": "EVENT"
			},
			{
				"name": "hike",
				"salience": 0.0007892847,
				"type": "EVENT"
			},
			{
				"name": "premium hikes",
				"salience": 0.0007892847,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0007881731,
				"type": "PERSON"
			},
			{
				"name": "minority",
				"salience": 0.0007858899,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00078331534,
				"type": "PERSON"
			},
			{
				"name": "reply",
				"salience": 0.00077018526,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00077018526,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00076212804,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.0007613673,
				"type": "OTHER"
			},
			{
				"name": "hikes",
				"salience": 0.0007598232,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fh83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Medicaid"
				},
				"name": "Medicaid",
				"salience": 0.00074606336,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0007414363,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0007414363,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0007040749,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0007040749,
				"type": "OTHER"
			},
			{
				"name": "Kinda",
				"salience": 0.0006664503,
				"type": "OTHER"
			},
			{
				"name": "hike",
				"salience": 0.0006443435,
				"type": "EVENT"
			},
			{
				"name": "premium hikes",
				"salience": 0.0006443435,
				"type": "EVENT"
			},
			{
				"name": "price hikes",
				"salience": 0.0006443435,
				"type": "EVENT"
			},
			{
				"name": "subsidies",
				"salience": 0.00063570554,
				"type": "OTHER"
			},
			{
				"name": "wallets",
				"salience": 0.00063570554,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0006313928,
				"type": "LOCATION"
			},
			{
				"name": "blue states",
				"salience": 0.0006313928,
				"type": "OTHER"
			},
			{
				"name": "exchanges",
				"salience": 0.0006313928,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00062874996,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00062874996,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0006119744,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.0006098387,
				"type": "WORK_OF_ART"
			},
			{
				"name": "exchanges",
				"salience": 0.00060782256,
				"type": "OTHER"
			},
			{
				"name": "alot",
				"salience": 0.0005864971,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005851492,
				"type": "PERSON"
			},
			{
				"name": "Work",
				"salience": 0.00057714805,
				"type": "OTHER"
			},
			{
				"name": "service providers",
				"salience": 0.00057180814,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0005700787,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0005700787,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0005700787,
				"type": "EVENT"
			},
			{
				"name": "Kinda",
				"salience": 0.0005651564,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0005579415,
				"type": "OTHER"
			},
			{
				"name": "irs",
				"salience": 0.0005504614,
				"type": "OTHER"
			},
			{
				"name": "Looks",
				"salience": 0.0005504614,
				"type": "OTHER"
			},
			{
				"name": "income",
				"salience": 0.0005504614,
				"type": "OTHER"
			},
			{
				"name": "health coverage",
				"salience": 0.0005504614,
				"type": "OTHER"
			},
			{
				"name": "hardest",
				"salience": 0.0005504614,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00054879644,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.00054879644,
				"type": "OTHER"
			},
			{
				"name": "insurance companies",
				"salience": 0.0005394597,
				"type": "ORGANIZATION"
			},
			{
				"name": "business",
				"salience": 0.0005343394,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0005343394,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0005343394,
				"type": "OTHER"
			},
			{
				"name": "blue states",
				"salience": 0.0005154365,
				"type": "OTHER"
			},
			{
				"name": "exchanges",
				"salience": 0.0005154365,
				"type": "OTHER"
			},
			{
				"name": "risk pool",
				"salience": 0.00051439094,
				"type": "OTHER"
			},
			{
				"name": "Health insurance Premiums",
				"salience": 0.0005032003,
				"type": "OTHER"
			},
			{
				"name": "insurance industry",
				"salience": 0.00050150737,
				"type": "OTHER"
			},
			{
				"name": "red",
				"salience": 0.0004936318,
				"type": "OTHER"
			},
			{
				"name": "blue state red",
				"salience": 0.0004936318,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0004936318,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.0004915654,
				"type": "WORK_OF_ART"
			},
			{
				"name": "kind",
				"salience": 0.0004915654,
				"type": "OTHER"
			},
			{
				"name": "hikes",
				"salience": 0.00048132395,
				"type": "OTHER"
			},
			{
				"name": "price hikes",
				"salience": 0.00048132395,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00047520266,
				"type": "PERSON"
			},
			{
				"name": "slap",
				"salience": 0.00047487073,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00047321338,
				"type": "OTHER"
			},
			{
				"name": "Funding",
				"salience": 0.00047321338,
				"type": "OTHER"
			},
			{
				"name": "redistribution",
				"salience": 0.0004727493,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.000468886,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00046537933,
				"type": "EVENT"
			},
			{
				"name": "reply",
				"salience": 0.0004521394,
				"type": "OTHER"
			},
			{
				"name": "can",
				"salience": 0.0004464528,
				"type": "OTHER"
			},
			{
				"name": "basket",
				"salience": 0.00044569164,
				"type": "OTHER"
			},
			{
				"name": "basket",
				"salience": 0.00044569164,
				"type": "OTHER"
			},
			{
				"name": "football",
				"salience": 0.00044569164,
				"type": "OTHER"
			},
			{
				"name": "purple one",
				"salience": 0.00044569164,
				"type": "PERSON"
			},
			{
				"name": "bill",
				"salience": 0.0004441361,
				"type": "WORK_OF_ART"
			},
			{
				"name": "employees",
				"salience": 0.00043620195,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.00043620195,
				"type": "OTHER"
			},
			{
				"name": "mess",
				"salience": 0.00042905175,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.00042713498,
				"type": "OTHER"
			},
			{
				"name": "Kinda",
				"salience": 0.0004221657,
				"type": "OTHER"
			},
			{
				"name": "OP",
				"salience": 0.00040600536,
				"type": "ORGANIZATION"
			},
			{
				"name": "blood pressure",
				"salience": 0.00040600536,
				"type": "OTHER"
			},
			{
				"name": "Shows",
				"salience": 0.00040600536,
				"type": "EVENT"
			},
			{
				"name": "kruphix",
				"salience": 0.00040490378,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00040296884,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.00040296884,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00038592072,
				"type": "OTHER"
			},
			{
				"name": "deplorables",
				"salience": 0.00038592072,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00038592072,
				"type": "OTHER"
			},
			{
				"name": "monkey",
				"salience": 0.00038592072,
				"type": "OTHER"
			},
			{
				"name": "exchanges",
				"salience": 0.0003850223,
				"type": "OTHER"
			},
			{
				"name": "health care",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "shape",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "nonsense",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "foot crap",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "dive",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00037151185,
				"type": "OTHER"
			},
			{
				"name": "golf course",
				"salience": 0.00037151185,
				"type": "LOCATION"
			},
			{
				"name": "yearts",
				"salience": 0.00036718955,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00036608844,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.0003638315,
				"type": "OTHER"
			},
			{
				"name": "slap",
				"salience": 0.00035471798,
				"type": "OTHER"
			},
			{
				"name": "hikes",
				"salience": 0.00035053276,
				"type": "OTHER"
			},
			{
				"name": "healthcare costs",
				"salience": 0.00034787058,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00034762756,
				"type": "PERSON"
			},
			{
				"name": "Healthcare",
				"salience": 0.0003446256,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.0003381308,
				"type": "OTHER"
			},
			{
				"name": "insurance",
				"salience": 0.0003381308,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.00033740563,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.00033175817,
				"type": "WORK_OF_ART"
			},
			{
				"name": "employees",
				"salience": 0.00032583118,
				"type": "PERSON"
			},
			{
				"name": "risk pool",
				"salience": 0.00032583118,
				"type": "OTHER"
			},
			{
				"name": "dems",
				"salience": 0.00031905787,
				"type": "OTHER"
			},
			{
				"name": "insurance industry",
				"salience": 0.00031766933,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.00031503642,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.00031503642,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.00031503642,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.00031503642,
				"type": "OTHER"
			},
			{
				"name": "rates",
				"salience": 0.00031503642,
				"type": "OTHER"
			},
			{
				"name": "touch",
				"salience": 0.00031503642,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.00030327358,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00029974504,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0002972113,
				"type": "ORGANIZATION"
			},
			{
				"name": "exchanges",
				"salience": 0.00028039457,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0002740086,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime",
				"salience": 0.0002740086,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.000273655,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.0002717691,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00027082048,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00026206835,
				"type": "PERSON"
			},
			{
				"name": "hikes",
				"salience": 0.00026183485,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00025716968,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00025315996,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00025315996,
				"type": "PERSON"
			},
			{
				"name": "code",
				"salience": 0.00025072746,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00024160239,
				"type": "OTHER"
			},
			{
				"name": "competition",
				"salience": 0.00023956005,
				"type": "OTHER"
			},
			{
				"name": "Hilary",
				"salience": 0.00023750501,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00023750501,
				"type": "LOCATION"
			},
			{
				"name": "employer",
				"salience": 0.0002372858,
				"type": "PERSON"
			},
			{
				"name": "risk pool",
				"salience": 0.0002372858,
				"type": "OTHER"
			},
			{
				"name": "semblance",
				"salience": 0.00023531904,
				"type": "OTHER"
			},
			{
				"name": "little",
				"salience": 0.00023531904,
				"type": "OTHER"
			},
			{
				"name": "Debt",
				"salience": 0.00023531904,
				"type": "OTHER"
			},
			{
				"name": "bubble",
				"salience": 0.00023531904,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.00023531904,
				"type": "OTHER"
			},
			{
				"name": "taxpayer",
				"salience": 0.00023531904,
				"type": "PERSON"
			},
			{
				"name": "insurance industry",
				"salience": 0.0002313416,
				"type": "OTHER"
			},
			{
				"name": "Kinda",
				"salience": 0.00022964936,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00022367683,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.00021920541,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00021828762,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.00021261054,
				"type": "OTHER"
			},
			{
				"name": "exchanges",
				"salience": 0.0002094418,
				"type": "OTHER"
			},
			{
				"name": "wallet",
				"salience": 0.00019791331,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.00019791331,
				"type": "PERSON"
			},
			{
				"name": "Greggers",
				"salience": 0.00019635267,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "HRC",
				"salience": 0.00019387763,
				"type": "ORGANIZATION"
			},
			{
				"name": "left",
				"salience": 0.00018909795,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00018909795,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00018909795,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00018909795,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00018909795,
				"type": "PERSON"
			},
			{
				"name": "improvement",
				"salience": 0.0001881215,
				"type": "OTHER"
			},
			{
				"name": "improvement",
				"salience": 0.0001881215,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00018258925,
				"type": "OTHER"
			},
			{
				"name": "risk pool",
				"salience": 0.00017724028,
				"type": "OTHER"
			},
			{
				"name": "insurance industry",
				"salience": 0.00017280011,
				"type": "OTHER"
			},
			{
				"name": "horse",
				"salience": 0.00017136778,
				"type": "OTHER"
			},
			{
				"name": "cronies",
				"salience": 0.00017136778,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00017136778,
				"type": "OTHER"
			},
			{
				"name": "lunch",
				"salience": 0.00017136778,
				"type": "EVENT"
			},
			{
				"name": "tort reform",
				"salience": 0.00017136778,
				"type": "OTHER"
			},
			{
				"name": "dimes",
				"salience": 0.00017136778,
				"type": "OTHER"
			},
			{
				"name": "cynicalheathen",
				"salience": 0.00017136778,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.00016724851,
				"type": "LOCATION"
			},
			{
				"name": "funding",
				"salience": 0.0001630491,
				"type": "OTHER"
			},
			{
				"name": "minimum wage",
				"salience": 0.00015880849,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0001478301,
				"type": "OTHER"
			},
			{
				"name": "subsidies",
				"salience": 0.0001478301,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0001478301,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0001478301,
				"type": "OTHER"
			},
			{
				"name": "Vasa Croe",
				"salience": 0.00014481557,
				"type": "PERSON"
			},
			{
				"name": "conditions",
				"salience": 0.00012800151,
				"type": "OTHER"
			},
			{
				"name": "broomstick",
				"salience": 0.00012800151,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00012800151,
				"type": "PERSON"
			},
			{
				"name": "slice",
				"salience": 0.00012800151,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.000109027904,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats5.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:08.579+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 40.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Forget Wikileaks...this is the real October Surprise that is going to stop Hillary page: 1 link People have a hard time wading through all of the twists and turns, and convoluted political intrigue, that are the devastating stream of revelations about just how corrupt the Democratic Party...and its supreme leader Hillary Clinton...is. Most people don't have the time, or the attention span, to pour over the tens of thousands of documents being released by Wikileaks - and the MSM is trying their hardest to ignore the subject. Having said that, my father once told me that, \"There are two things you don't mess with. A man's wife, or a man's paycheque...and not necessarily in that order.\" Substitute \"woman\" and \"husband\" if you like, but the message is very clear. And now...even CNN cannot ignore it...we have the issue that directly affects people's pocketbooks. Plain and simple. The pain and the impacts are very real and very personal. Obamacare Premiums... Just watch the Polls swing on this issue leading up to November 8...and watch as State after State goes from Blue to Red - just like the American peoples' bank accounts, due to the astonishing increases in Obamacare Premiums! edit on 27-10-2016 by mobiusmale because: link not working edit on 27-10-2016 by mobiusmale because: typo link a reply to: mobiusmale Most people get their insurance through their work, the next largest segment has Medicare/Medicaid. Those that get their insurance through the exchanges, not all of them are experiencing a large premium hike. The people you are talking about that are effected by these premium hikes are a small minority that won't tilt the election one way or another. But go ahead and think this will change blue states to red. link a reply to: kruphix Kinda going to spin off that, but isn't it funny that that is the argument being made by the left now? The poor and disaffected who don't get the insurance through their work (basically the people who were invoked to pass the bill) are going to, now, take the brunt of the hikes. People will vote with their wallets. Looks like the people least likely to afford it get hit the hardest. time.com... Yet it’s also true that for Americans who don’t get insurance through work, and who make too much money to qualify for federal subsidies, the cost of health coverage is about to soar dramatically, with premiums sometimes rising $1,000, even over $2,000 for the year. If one were making 45k per year and the cost of a service increased 1k-2k for THAT year one would find other service providers or not use the service at all. But if you did not pay for health insurance you would owe the irs a penalty of 2k. Damned if you do Damned if you do not. 5% of someones income is alot, enough to make them think about who to vote for. a reply to: kruphix I am 27, never get ill, have low blood pressure, and am in good shape. My premiums doubled since this mess. So I ditched it. This was a redistribution of health care. link I don't understand why Trump hasn't been all over this opportunity. He should stop with the nonsense shooting himself in the foot crap and focus on this news to sway more voters to his side. Instead he has been babbling about his awesome golf course. It is times like these that make me think he must be taking a dive on purpose. originally posted by: Mr Headshot a reply to: kruphix Kinda going to spin off that, but isn't it funny that that is the argument being made by the left now? The poor and disaffected who don't get the insurance through their work (basically the people who were invoked to pass the bill) are going to, now, take the brunt of the hikes. Of course they will because they're the ones on the exchanges. One thing Hillary would like to do is provide more federal funding to get younger people signed up, to lower the risk pool and in turn lower premiums. Of course, the Republicans won't work with her on it because \"OBAMACARE,\" so who knows. I guess everyone is holding out for single payer, which is the inevitable result once the insurance industry collapses under the high cost of medical treatment. link a reply to: kruphix The people you are talking about that are effected by these premium hikes are a small minority that won't tilt the election one way or another. Yeah the people in the \"basket of deplorables\" are a small minority as well. Perhaps in your opinion they are all in the same basket. Nice to be told \"you're a amall minority\" your fate won't effect an election. originally posted by: kruphix a reply to: mobiusmale Most people get their insurance through their work, the next largest segment has Medicare/Medicaid. Those that get their insurance through the exchanges, not all of them are experiencing a large premium hike. The people you are talking about that are effected by these premium hikes are a small minority that won't tilt the election one way or another. But go ahead and think this will change blue states to red. cool, then abolishing the abortion that is \"Obamacare\" should be quick and easy. Then we can get insurance companies back to competing for our business and maybe get insurance back to where most people can afford it and not just those making less than $23k a year. You do realize that Obamacare is the single biggest failure in the history of the US last 8 years right? Much like a monkey #ing a football. link a reply to: mobiusmale It's going to cost Hilary some votes but is NOT going turn a blue state red. Might sway a poorer purple one toward red, but I'm unsure of what state fits that bill exactly. Fl maybe? a reply to: Greggers Of course, the Republicans won't work with her on it because \"OBAMACARE,\" so who knows. \"Work with her\"? really kind of like the dems worked with the gop to pass the ACA to begin with? Pass it before you read it? Like your plan keep your plan? That kind of cooperation? originally posted by: kruphix a reply to: mobiusmale Most people get their insurance through their work, the next largest segment has Medicare/Medicaid. Those that get their insurance through the exchanges, not all of them are experiencing a large premium hike. The people you are talking about that are effected by these premium hikes are a small minority that won't tilt the election one way or another. But go ahead and think this will change blue states to red. Considering you're talking about small and medium business owners who the current administration (and HRC) says they want to support, I am fairly certain the OP is accurate. The price hikes are a direct slap in the face to those of us that own our own small businesses and pay for insurance on our own. Shows how out of touch the top is with the middle. Employer sponsored rates are high too. It's cutting into employees' pay. Wake up voters !!! originally posted by: Mr Headshot a reply to: kruphix Kinda going to spin off that, but isn't it funny that that is the argument being made by the left now? The poor and disaffected who don't get the insurance through their work (basically the people who were invoked to pass the bill) are going to, now, take the brunt of the hikes. Of course they will because they're the ones on the exchanges. One thing Hillary would like to do is provide more federal funding to get younger people signed up, to lower the risk pool and in turn lower premiums. Of course, the Republicans won't work with her on it because \"OBAMACARE,\" so who knows. I guess everyone is holding out for single payer, which is the inevitable result once the insurance industry collapses under the high cost of medical treatment. yes, the young ones who are also making minimum wage or close. If they make any money at all, they will miss the subsidies and be paying the $500 to $800 a month the rest of us have to pay. The way it was before Obamacare was much much better for everyone except the one's with pre-existing conditions. It's a shame we couldn't have someone who was smart enough to grasp that. Then they could have just tried to fix that tiny slice of the population instead of jamming a broomstick up the rest of us. originally posted by: Mr Headshot a reply to: kruphix Kinda going to spin off that, but isn't it funny that that is the argument being made by the left now? The poor and disaffected who don't get the insurance through their work (basically the people who were invoked to pass the bill) are going to, now, take the brunt of the hikes. Of course they will because they're the ones on the exchanges. One thing Hillary would like to do is provide more federal funding to get younger people signed up, to lower the risk pool and in turn lower premiums. Of course, the Republicans won't work with her on it because \"OBAMACARE,\" so who knows. I guess everyone is holding out for single payer, which is the inevitable result once the insurance industry collapses under the high cost of medical treatment. \"More Federal Funding\" is just code for, \"we are going to increase taxes\"...so Hillary's solution for high Health insurance Premiums, is to move the taxpayer drain a little farther to left and call it something else. I mean what choice would she have, if she wants to keep some semblance of this disaster intact? The Obama/Clinton regime doubled the National Debt to over $20 trillion dollars in 8 yearts...how much deeper can that go before the whole bubble bursts? a reply to: Vasa Croe The price hikes are a direct slap in the face to those of us that own our own small businesses and pay for insurance on our own. That's right they forgot if you have less than 50 people employed you do not have to provide insurance to your employees. originally posted by: Mr Headshot a reply to: kruphix Kinda going to spin off that, but isn't it funny that that is the argument being made by the left now? The poor and disaffected who don't get the insurance through their work (basically the people who were invoked to pass the bill) are going to, now, take the brunt of the hikes. Of course they will because they're the ones on the exchanges. One thing Hillary would like to do is provide more federal funding to get younger people signed up, to lower the risk pool and in turn lower premiums. Of course, the Republicans won't work with her on it because \"OBAMACARE,\" so who knows. I guess everyone is holding out for single payer, which is the inevitable result once the insurance industry collapses under the high cost of medical treatment. And where exactly does federal funding come from? *looks at wallet* No such thing as a free lunch. My healthcare costs have gone up almost 50% while benefits have gone down, and I'm on an employer provided plan. I'm 33yo and healthy as a horse. Healthcare is not a right, quit treating it as such. Get some actual competition in the system as well as some tort reform and maybe you'll see some improvement. Start jailing cronies and letting unprofitable companies fail you'll see some improvement. I feel sorry for anyone who believes that Democrats/Republicans are one dimes worth of different from each other... edit on 10-27-2016 by cynicalheathen because: (no reason given)",
		"thread_title": "Forget Wikileaks...this is the real October Surprise that is going to stop Hillary",
		"title": "Forget Wikileaks...this is the real October Surprise that is going to stop Hillary",
		"type": "bs",
		"uuid": "50336fcfa54025e51c1bcf5798841f06e7332642"
	},
	"-KhIa77Yu-ubqW3LD6Ji": {
		"author": "makaira1985",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:09.871+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "anyone",
				"salience": 0.19054718,
				"type": "PERSON"
			},
			{
				"name": "playing card",
				"salience": 0.13733333,
				"type": "OTHER"
			},
			{
				"name": "meaning",
				"salience": 0.119506456,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.09692935,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.05504412,
				"type": "PERSON"
			},
			{
				"name": "design",
				"salience": 0.03271707,
				"type": "OTHER"
			},
			{
				"name": "playing card",
				"salience": 0.029716397,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.027089005,
				"type": "OTHER"
			},
			{
				"name": "college campus",
				"salience": 0.02575794,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.023287583,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.022523211,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.022423172,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.018094262,
				"type": "OTHER"
			},
			{
				"name": "logo",
				"salience": 0.017421708,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.017421708,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.017063119,
				"type": "PERSON"
			},
			{
				"name": "symbols",
				"salience": 0.014783386,
				"type": "OTHER"
			},
			{
				"name": "The Path of Light",
				"salience": 0.013718039,
				"type": "WORK_OF_ART"
			},
			{
				"name": "scribblings",
				"salience": 0.01294401,
				"type": "OTHER"
			},
			{
				"name": "reference path",
				"salience": 0.01275967,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.01275967,
				"type": "OTHER"
			},
			{
				"name": "diamonds",
				"salience": 0.01275967,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Diamond"
				},
				"name": "Diamonds",
				"salience": 0.01239849,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.01074016,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.009300383,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.008055527,
				"type": "OTHER"
			},
			{
				"name": "pics",
				"salience": 0.008055527,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07g9f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_X-Files"
				},
				"name": "X-Files",
				"salience": 0.0068095606,
				"type": "WORK_OF_ART"
			},
			{
				"name": "someone",
				"salience": 0.006020146,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.006020146,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:09.871+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Can anyone help with the meaning behind a mystery playing card? page: 1 link Trying this again My son found a playing card on his college campus. The back was a fairly normal design except it looks like the Facebook logo right in the middle. The front is the 8 of Diamonds with the words \"The truth is out there\" and \"The Path of Light\" written on it...also a couple of symbols drawn on it. We were wondering if this has some known meaning that anyone recognizes or maybe its just the rambling scribblings of someone with too much time on their hands. I tried to cross reference path of light and 8 of diamonds with the X-Files, but didn't come up with anything. I'll post a couple of pics as soon as I figure out how.",
		"thread_title": "Can anyone help with the meaning behind a mystery playing card?",
		"title": "Can anyone help with the meaning behind a mystery playing card?",
		"type": "bs",
		"uuid": "85d9b602de2ea0b8a826f2eb8101b1c0ac849762"
	},
	"-KhIa7Lt8XeisMUrM0W7": {
		"author": "raymundoko",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:10.209+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "planet",
				"salience": 0.12815267,
				"type": "LOCATION"
			},
			{
				"name": "researchers",
				"salience": 0.06594694,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.0472991,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05yvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Planets_beyond_Neptune"
				},
				"name": "Planet X",
				"salience": 0.04247533,
				"type": "ORGANIZATION"
			},
			{
				"name": "planet",
				"salience": 0.033267763,
				"type": "LOCATION"
			},
			{
				"name": "planet",
				"salience": 0.0328523,
				"type": "LOCATION"
			},
			{
				"name": "planet",
				"salience": 0.031241225,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.030663067,
				"type": "PERSON"
			},
			{
				"name": "views",
				"salience": 0.030663067,
				"type": "OTHER"
			},
			{
				"name": "board hold",
				"salience": 0.026581079,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.023539606,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03w38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Maritime_Organization"
				},
				"name": "IMO",
				"salience": 0.021114677,
				"type": "ORGANIZATION"
			},
			{
				"name": "objects",
				"salience": 0.017403316,
				"type": "OTHER"
			},
			{
				"name": "perturbations",
				"salience": 0.017096676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.016418554,
				"type": "LOCATION"
			},
			{
				"name": "plane",
				"salience": 0.015914628,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.013619701,
				"type": "OTHER"
			},
			{
				"name": "planets",
				"salience": 0.012921868,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0270fhr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Homer_Bailey"
				},
				"name": "Bailey",
				"salience": 0.011450013,
				"type": "PERSON"
			},
			{
				"name": "mass",
				"salience": 0.011395459,
				"type": "OTHER"
			},
			{
				"name": "object",
				"salience": 0.010429969,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.009068366,
				"type": "LOCATION"
			},
			{
				"name": "planet",
				"salience": 0.009068366,
				"type": "LOCATION"
			},
			{
				"name": "figure",
				"salience": 0.008914658,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.008730548,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.008474615,
				"type": "LOCATION"
			},
			{
				"name": "stuff",
				"salience": 0.008454929,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09q84",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jupiter"
				},
				"name": "Jupiter",
				"salience": 0.008393636,
				"type": "LOCATION"
			},
			{
				"name": "Batygin",
				"salience": 0.007963169,
				"type": "PERSON"
			},
			{
				"name": "planets",
				"salience": 0.0074059065,
				"type": "LOCATION"
			},
			{
				"name": "proof",
				"salience": 0.0067362403,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.0067158975,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0064961966,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.0064655524,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.006143325,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.005914287,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.005914287,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.0056166034,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0056166034,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0056166034,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0056166034,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0056166034,
				"type": "OTHER"
			},
			{
				"name": "orbit stars",
				"salience": 0.0056166034,
				"type": "PERSON"
			},
			{
				"name": "table",
				"salience": 0.0056166034,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0056166034,
				"type": "LOCATION"
			},
			{
				"name": "Link",
				"salience": 0.0056166034,
				"type": "OTHER"
			},
			{
				"name": "Overview",
				"salience": 0.0056166034,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "solar system",
				"salience": 0.005599636,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.005484027,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.005484027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.005324642,
				"type": "ORGANIZATION"
			},
			{
				"name": "One AU",
				"salience": 0.005174167,
				"type": "OTHER"
			},
			{
				"name": "mass",
				"salience": 0.0050373925,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0048495294,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.0047706757,
				"type": "OTHER"
			},
			{
				"name": "solar system",
				"salience": 0.0047493856,
				"type": "OTHER"
			},
			{
				"name": "Planet Nine",
				"salience": 0.0045192465,
				"type": "ORGANIZATION"
			},
			{
				"name": "average",
				"salience": 0.0043790075,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0041130413,
				"type": "OTHER"
			},
			{
				"name": "object",
				"salience": 0.0041130413,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.004097749,
				"type": "OTHER"
			},
			{
				"name": "planets",
				"salience": 0.00403204,
				"type": "LOCATION"
			},
			{
				"name": "planets",
				"salience": 0.00403204,
				"type": "OTHER"
			},
			{
				"name": "observations",
				"salience": 0.0039391858,
				"type": "OTHER"
			},
			{
				"name": "news feed",
				"salience": 0.0039391858,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.0039391858,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0039391858,
				"type": "OTHER"
			},
			{
				"name": "computer simulations",
				"salience": 0.0036898595,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brown_University"
				},
				"name": "Brown",
				"salience": 0.0035950094,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c31h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neptune"
				},
				"name": "Neptune",
				"salience": 0.003549734,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02sjgpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Institute_of_Technology"
				},
				"name": "Caltech",
				"salience": 0.0034583916,
				"type": "ORGANIZATION"
			},
			{
				"name": "calculations",
				"salience": 0.0033408175,
				"type": "OTHER"
			},
			{
				"name": "mass",
				"salience": 0.0033158485,
				"type": "OTHER"
			},
			{
				"name": "zone",
				"salience": 0.003216168,
				"type": "LOCATION"
			},
			{
				"name": "size",
				"salience": 0.003216168,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0031292483,
				"type": "LOCATION"
			},
			{
				"name": "Batygin",
				"salience": 0.0028004872,
				"type": "PERSON"
			},
			{
				"name": "computer simulations",
				"salience": 0.0027747285,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0027747285,
				"type": "LOCATION"
			},
			{
				"name": "proof",
				"salience": 0.0027747285,
				"type": "OTHER"
			},
			{
				"name": "solar system",
				"salience": 0.00258484,
				"type": "OTHER"
			},
			{
				"name": "solar system",
				"salience": 0.00258484,
				"type": "OTHER"
			},
			{
				"name": "tilt",
				"salience": 0.002507119,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0024027757,
				"type": "WORK_OF_ART"
			},
			{
				"name": "patch",
				"salience": 0.0024027757,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.0024027757,
				"type": "OTHER"
			},
			{
				"name": "location",
				"salience": 0.0024027757,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c3qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pluto"
				},
				"name": "Pluto",
				"salience": 0.0023345787,
				"type": "OTHER"
			},
			{
				"name": "orbit",
				"salience": 0.002229999,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.0020396544,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.0020396544,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.0020396544,
				"type": "OTHER"
			},
			{
				"name": "solar system",
				"salience": 0.0019310272,
				"type": "OTHER"
			},
			{
				"name": "Planet Nine",
				"salience": 0.0018916675,
				"type": "ORGANIZATION"
			},
			{
				"name": "lifetime",
				"salience": 0.0017500407,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.0017500407,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0017500407,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0017500407,
				"type": "PERSON"
			},
			{
				"name": "sky",
				"salience": 0.0015097497,
				"type": "LOCATION"
			},
			{
				"name": "astronomical units",
				"salience": 0.0013073043,
				"type": "OTHER"
			},
			{
				"name": "hemisphere",
				"salience": 0.0013073043,
				"type": "LOCATION"
			},
			{
				"name": "virge",
				"salience": 0.0013073043,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0013073043,
				"type": "OTHER"
			},
			{
				"name": "tilt",
				"salience": 0.0012802815,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n0_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Astronomical_unit"
				},
				"name": "AU",
				"salience": 0.0009292004,
				"type": "LOCATION"
			},
			{
				"name": "model",
				"salience": 0.0009049845,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09mn7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Space.com"
				},
				"name": "Space.com",
				"salience": 0.00072694634,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats11.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:10.209+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link I want to preface this by saying there is no \"Planet X\" IMO as pertains to the views of such a planet that many on this board hold. However, I have always felt there was a massive missing planet as we could never satisfactorily explain perturbations of a planet like Jupiter and the movement of outer objects. The view that there is a missing massive planet has always been on the table and NASA has always supported the idea and never stood in the way of people trying to find proof of it. We know planets, often many, orbit stars in this outer region, why should we be different? Link: Planet X Overview, Source: NASA Caltech researchers have found evidence suggesting there may be a \"Planet X\" deep in the solar system. This hypothetical Neptune-sized planet orbits our sun in a highly elongated orbit far beyond Pluto. The object, which the researchers have nicknamed \"Planet Nine,\" could have a mass about 10 times that of Earth and orbit about 20 times farther from the sun on average than Neptune. It may take between 10,000 and 20,000 Earth years to make one full orbit around the sun. But this is all from January you might say, quite old and possibly already discussed. Fast forward to my news feed for today and what do I find? Narrowing the field for the 9th planet Batygin and Brown's work narrowed down the planet’s possible mass and orbit to areas where previous observations might have missed it. Their calculations suggest that it has a mass between five to 20 times that of Earth—a figure that is key to knowing the approximate size of the object they are looking for. They also suggest that its orbit is likely tilted about 30 degrees compared to the plane of the solar system—the relatively thin, flat zone in which the eight major planets orbit. They also propose that the planet is now likely near its farthest point from the sun, in the sky's northern hemisphere, and that it likely has an elongated orbit averaging between 380 and 980 astronomical units (AU) from the sun. (One AU is the average distance between Earth and the sun.) We are on the virge of finding a very real planet in our outer solar system. They previsouly released this model for what the orbit could look like: And they've created 100+ more of those which have not yet been published. n an as-yet unpublished set of about 100 new high-resolution computer simulations, Batygin says he and Brown have narrowed down Planet Nine's location to a roughly 600- to 800-square degree patch of sky. The biggest piece of proof has turned out to be the very tilt of our solar system from the perspective of the inner planets. Bailey and her colleagues ran computer simulations that suggest that the tilt of the eight official planets can be explained by the gravitational influence of Planet Nine \"over the 4.5-billion-years-ish lifetime of the solar system,\" Bailey told Space.com. This is fascinating stuff!",
		"thread_title": "Planet Nine",
		"title": "Planet Nine",
		"type": "bs",
		"uuid": "2391f7be920188f35f1b930cfff731085473bbdd"
	},
	"-KhIa7Y7frn0Yz-flINV": {
		"author": "gortex",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:12.021+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0fwssh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Schiaparelli_(Martian_crater)"
				},
				"name": "Schiaparelli",
				"salience": 0.17659256,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.14869253,
				"type": "OTHER"
			},
			{
				"name": "lander",
				"salience": 0.10022256,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02t63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Space_Agency"
				},
				"name": "ESA",
				"salience": 0.09840551,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09cws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mars"
				},
				"name": "Mars",
				"salience": 0.09431635,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.039110538,
				"type": "ORGANIZATION"
			},
			{
				"name": "mars",
				"salience": 0.03528709,
				"type": "OTHER"
			},
			{
				"name": "Images",
				"salience": 0.028172798,
				"type": "OTHER"
			},
			{
				"name": "Schiaparelli Mars",
				"salience": 0.021904882,
				"type": "ORGANIZATION"
			},
			{
				"name": "mission",
				"salience": 0.020876424,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.020876424,
				"type": "OTHER"
			},
			{
				"name": "lander page",
				"salience": 0.020876424,
				"type": "OTHER"
			},
			{
				"name": "working lab",
				"salience": 0.020876424,
				"type": "LOCATION"
			},
			{
				"name": "proof",
				"salience": 0.0196963,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.00999032,
				"type": "EVENT"
			},
			{
				"name": "conditions",
				"salience": 0.008973499,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.00865763,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0075490545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0164bb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shame"
				},
				"name": "Shame",
				"salience": 0.0072116787,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.0061297854,
				"type": "OTHER"
			},
			{
				"name": "landing",
				"salience": 0.005717258,
				"type": "EVENT"
			},
			{
				"name": "Looks",
				"salience": 0.005115881,
				"type": "OTHER"
			},
			{
				"name": "impact crater",
				"salience": 0.005115881,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0047602607,
				"type": "OTHER"
			},
			{
				"name": "success rate",
				"salience": 0.00470043,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.003975076,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0039223535,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.003873028,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0036580344,
				"type": "OTHER"
			},
			{
				"name": "Looks",
				"salience": 0.0035898027,
				"type": "OTHER"
			},
			{
				"name": "impact crater",
				"salience": 0.0035898027,
				"type": "OTHER"
			},
			{
				"name": "comparison",
				"salience": 0.003109218,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0030756893,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0029933255,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0029933255,
				"type": "OTHER"
			},
			{
				"name": "secrets",
				"salience": 0.0029933255,
				"type": "OTHER"
			},
			{
				"name": "conspiracy site",
				"salience": 0.0029933255,
				"type": "OTHER"
			},
			{
				"name": "Mars R.I.P Schiaparelli",
				"salience": 0.0028746848,
				"type": "OTHER"
			},
			{
				"name": "success rate",
				"salience": 0.0028692237,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0028222632,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0027049272,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.002538941,
				"type": "OTHER"
			},
			{
				"name": "ducks",
				"salience": 0.002538941,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.0021906684,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0021906684,
				"type": "EVENT"
			},
			{
				"name": "life",
				"salience": 0.0019373982,
				"type": "OTHER"
			},
			{
				"name": "chute",
				"salience": 0.0018971646,
				"type": "OTHER"
			},
			{
				"name": "cream",
				"salience": 0.0018971646,
				"type": "OTHER"
			},
			{
				"name": "cake",
				"salience": 0.0018971646,
				"type": "OTHER"
			},
			{
				"name": "rockets",
				"salience": 0.0015958654,
				"type": "OTHER"
			},
			{
				"name": "success rate",
				"salience": 0.0015619105,
				"type": "OTHER"
			},
			{
				"name": "smurfy",
				"salience": 0.0013819821,
				"type": "OTHER"
			},
			{
				"name": "fashion",
				"salience": 0.0013819821,
				"type": "OTHER"
			},
			{
				"name": "Text",
				"salience": 0.0013819821,
				"type": "OTHER"
			},
			{
				"name": "sequence",
				"salience": 0.0013819821,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.0011922909,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0knf0q2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Curiosity_(rover)"
				},
				"name": "Curiosity",
				"salience": 0.0011679938,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:39:12.021+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Images reveal crashed Schiaparelli Mars lander page: 1 link We knew as time passed that Schiaparelli had failed in its mission to become ESA's first working lab on mars , now the efforts of ESA to locate their missing lander have provided the proof that Schiaparelli crashed on Mars , as suggested by the data returned before the event. If at first you don't succeed Looks like an impact crater to me. Mars succès rate is all told about 50%? originally posted by: gortex the efforts of ESA to locate their missing lander have provided the proof that Schiaparelli crashed on Mars R.I.P Schiaparelli, you never even got a chance to reveal some of the secrets of Mars. Okay, we're on a conspiracy site, i'll say it... Looks like an impact crater to me. Schiaparelli's impact. NASA have a good success rate landing on Mars probably due to them being well funded , in comparison ESA don't seem to have all of their ducks in a line to be able to take the next step. Shame really as we are going looking for life where NASA seems content to look for the conditions that would have allowed life to start. originally posted by: gortex NASA have a good success rate landing on Mars probably due to them being well funded , Shame really as we are going looking for life where NASA seems content to look for the conditions that would have allowed life to start. Nasa does have a good success rate, Curiosity's wacky landing putting the cream on the cake, since it obviously worked. Ihave to say though it's kind of weird that there were two failed events. The chute, then the rocket in the next sequence one aiding the other sort of, (I'm assuming that the rockets would have fired in a controlled fashion but then cut off prematurely) edit on 27-10-2016 by smurfy because: Text.",
		"thread_title": "Images reveal crashed Schiaparelli Mars lander",
		"title": "Images reveal crashed Schiaparelli Mars lander",
		"type": "bs",
		"uuid": "b271a10f24190a80c177b705e1c39253b2a02008"
	},
	"-KhIa7fNq1itRjY0Vou-": {
		"author": "grayeagle",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:13.403+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "images",
				"salience": 0.3224074,
				"type": "OTHER"
			},
			{
				"name": "emotions",
				"salience": 0.13213047,
				"type": "OTHER"
			},
			{
				"name": "residue",
				"salience": 0.11731574,
				"type": "OTHER"
			},
			{
				"name": "depth",
				"salience": 0.054757986,
				"type": "OTHER"
			},
			{
				"name": "intensity",
				"salience": 0.054757986,
				"type": "OTHER"
			},
			{
				"name": "deja vu",
				"salience": 0.054757986,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.029107634,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.026308293,
				"type": "OTHER"
			},
			{
				"name": "memories",
				"salience": 0.01957343,
				"type": "OTHER"
			},
			{
				"name": "mercy",
				"salience": 0.012455917,
				"type": "OTHER"
			},
			{
				"name": "ruminations",
				"salience": 0.010704065,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.010490909,
				"type": "OTHER"
			},
			{
				"name": "memories",
				"salience": 0.010093599,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.009475442,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.009475442,
				"type": "WORK_OF_ART"
			},
			{
				"name": "loop",
				"salience": 0.0082083605,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.0082083605,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.0082083605,
				"type": "OTHER"
			},
			{
				"name": "recollections",
				"salience": 0.0082083605,
				"type": "OTHER"
			},
			{
				"name": "load",
				"salience": 0.007902739,
				"type": "OTHER"
			},
			{
				"name": "crushing",
				"salience": 0.007902739,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0070522893,
				"type": "OTHER"
			},
			{
				"name": "album",
				"salience": 0.0067042233,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pictures",
				"salience": 0.0067042233,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pages",
				"salience": 0.0067042233,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0064018336,
				"type": "OTHER"
			},
			{
				"name": "emotions",
				"salience": 0.0057853265,
				"type": "OTHER"
			},
			{
				"name": "ending",
				"salience": 0.005010752,
				"type": "EVENT"
			},
			{
				"name": "chest",
				"salience": 0.005010752,
				"type": "OTHER"
			},
			{
				"name": "black",
				"salience": 0.005010752,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.004668198,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0036507507,
				"type": "PERSON"
			},
			{
				"name": "sadness",
				"salience": 0.00360479,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0030573325,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0027277758,
				"type": "OTHER"
			},
			{
				"name": "regret",
				"salience": 0.0027277758,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.0027277758,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats14.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:02:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "I feel emotions with such depth and intensity they seem so familiar as if lived before, like deja vu they leave their residue, images form and bounce back and forth between heart and mind. It is mercy that I have forgotten so much more than remembered, time has allowed me to change and redefine them, such a crushing and heavy load to carry otherwise. If I am defined by those lost memories what am I? A loop between my heart and mind, thoughts and feelings rise and fall. Thoughtful ruminations give way to painful images and recollections. Oh there are good, even wonderful memories. I hang on to them like an album of pictures, I turn the pages and revisit those good times. They chronicle by not so much as what they show but what they don't. some are filled with regret, others live in denial, always hoping for a happy ending. My emotions sometimes rip through my chest and a sadness as black as night covers me, but I have determined not to cower, but to meet them with head and heart! I will not give up, I will not give up!",
		"thread_title": "Best Forgotten",
		"title": "Best Forgotten",
		"type": "bs",
		"uuid": "c64810cd3121f620bf4d9396857901b7c03a6bd6"
	},
	"-KhIa7s_Opg1ucG1CAKA": {
		"author": "searcherfortruth",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:13.503+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.5559031,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "Central Intelligence Agency",
				"salience": 0.08711795,
				"type": "ORGANIZATION"
			},
			{
				"name": "Theocracy",
				"salience": 0.0278803,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03h2c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Honduras"
				},
				"name": "Honduras",
				"salience": 0.020674923,
				"type": "LOCATION"
			},
			{
				"name": "reply",
				"salience": 0.020214327,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.011968421,
				"type": "EVENT"
			},
			{
				"name": "guy",
				"salience": 0.010894016,
				"type": "PERSON"
			},
			{
				"name": "missionaries",
				"salience": 0.010371463,
				"type": "PERSON"
			},
			{
				"name": "military dictatorship",
				"salience": 0.010371463,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.010371463,
				"type": "OTHER"
			},
			{
				"name": "Advertisement",
				"salience": 0.009797276,
				"type": "WORK_OF_ART"
			},
			{
				"name": "locals",
				"salience": 0.009197925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03h2c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Honduras"
				},
				"name": "Honduras",
				"salience": 0.008844524,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_America"
				},
				"name": "Central America",
				"salience": 0.00817332,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00817332,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0081487475,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c8wxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholicism"
				},
				"name": "Catholic",
				"salience": 0.007033418,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/014zws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_Law_School"
				},
				"name": "Harvard Law School",
				"salience": 0.0063952724,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ps4ry"
				},
				"name": "Jesuit",
				"salience": 0.0063952724,
				"type": "ORGANIZATION"
			},
			{
				"name": "story",
				"salience": 0.0058998247,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05yfx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope_John_Paul_II"
				},
				"name": "John Paul II",
				"salience": 0.004570131,
				"type": "PERSON"
			},
			{
				"name": "staging ground",
				"salience": 0.0042806366,
				"type": "LOCATION"
			},
			{
				"name": "clergy",
				"salience": 0.0042806366,
				"type": "PERSON"
			},
			{
				"name": "midst",
				"salience": 0.0042806366,
				"type": "OTHER"
			},
			{
				"name": "farmers",
				"salience": 0.0042806366,
				"type": "PERSON"
			},
			{
				"name": "empowerment",
				"salience": 0.0042806366,
				"type": "OTHER"
			},
			{
				"name": "Marxists",
				"salience": 0.0042806366,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.0038394285,
				"type": "EVENT"
			},
			{
				"name": "story",
				"salience": 0.0034671056,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04pnx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latin_America"
				},
				"name": "Latin American",
				"salience": 0.0034446912,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.003337846,
				"type": "EVENT"
			},
			{
				"name": "operations",
				"salience": 0.003337846,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.003337846,
				"type": "WORK_OF_ART"
			},
			{
				"name": "volunteer",
				"salience": 0.0030027346,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.0030027346,
				"type": "PERSON"
			},
			{
				"name": "vice president",
				"salience": 0.0030027346,
				"type": "PERSON"
			},
			{
				"name": "mentors",
				"salience": 0.0030027346,
				"type": "PERSON"
			},
			{
				"name": "priesthood",
				"salience": 0.0030027346,
				"type": "OTHER"
			},
			{
				"name": "faces",
				"salience": 0.0030027346,
				"type": "OTHER"
			},
			{
				"name": "communism",
				"salience": 0.002890762,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002890762,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.002890762,
				"type": "OTHER"
			},
			{
				"name": "career path",
				"salience": 0.0028720568,
				"type": "OTHER"
			},
			{
				"name": "operative",
				"salience": 0.0028310725,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0q76g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Midwestern_United_States"
				},
				"name": "Midwesterner",
				"salience": 0.0026363705,
				"type": "PERSON"
			},
			{
				"name": "liberation theology",
				"salience": 0.002535702,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.0024517826,
				"type": "OTHER"
			},
			{
				"name": "poor",
				"salience": 0.0024517826,
				"type": "PERSON"
			},
			{
				"name": "shift",
				"salience": 0.0024517826,
				"type": "OTHER"
			},
			{
				"name": "suspicion",
				"salience": 0.0024517826,
				"type": "OTHER"
			},
			{
				"name": "crossroads",
				"salience": 0.0024517826,
				"type": "OTHER"
			},
			{
				"name": "intrigue",
				"salience": 0.0024517826,
				"type": "OTHER"
			},
			{
				"name": "Lord",
				"salience": 0.0023904294,
				"type": "PERSON"
			},
			{
				"name": "bread",
				"salience": 0.0023115803,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "gospel",
				"salience": 0.0021459917,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0021153572,
				"type": "OTHER"
			},
			{
				"name": "hunger",
				"salience": 0.0021153572,
				"type": "OTHER"
			},
			{
				"name": "hunger",
				"salience": 0.0021153572,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0018788952,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0018488679,
				"type": "ORGANIZATION"
			},
			{
				"name": "liberation theology",
				"salience": 0.0018471627,
				"type": "OTHER"
			},
			{
				"name": "teaching",
				"salience": 0.0018318644,
				"type": "OTHER"
			},
			{
				"name": "beliefs",
				"salience": 0.0018318644,
				"type": "OTHER"
			},
			{
				"name": "military leaders",
				"salience": 0.0018318644,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0018318644,
				"type": "PERSON"
			},
			{
				"name": "bread",
				"salience": 0.0018169037,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/El_Salvador"
				},
				"name": "El Salvador",
				"salience": 0.0017798839,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05c74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicaragua"
				},
				"name": "Nicaragua",
				"salience": 0.0017798839,
				"type": "LOCATION"
			},
			{
				"name": "liberation theology",
				"salience": 0.001380011,
				"type": "OTHER"
			},
			{
				"name": "lawyer",
				"salience": 0.0013343132,
				"type": "PERSON"
			},
			{
				"name": "housing discrimination",
				"salience": 0.0013343132,
				"type": "OTHER"
			},
			{
				"name": "governor",
				"salience": 0.0013343132,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.0013343132,
				"type": "PERSON"
			},
			{
				"name": "focus",
				"salience": 0.0013343132,
				"type": "OTHER"
			},
			{
				"name": "interpretation",
				"salience": 0.0012749123,
				"type": "OTHER"
			},
			{
				"name": "mayor",
				"salience": 0.0011606148,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07pncwk"
				},
				"name": "Marxist",
				"salience": 0.0011276704,
				"type": "ORGANIZATION"
			},
			{
				"name": "mealtime",
				"salience": 0.0009967962,
				"type": "OTHER"
			},
			{
				"name": "blessing",
				"salience": 0.0009967962,
				"type": "OTHER"
			},
			{
				"name": "recitation",
				"salience": 0.0009967962,
				"type": "WORK_OF_ART"
			},
			{
				"name": "downtrodden",
				"salience": 0.0009967962,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0009967962,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0009967962,
				"type": "OTHER"
			},
			{
				"name": "pueblos",
				"salience": 0.0009967962,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0009967962,
				"type": "LOCATION"
			},
			{
				"name": "banana plantation company towns",
				"salience": 0.0009967962,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.00082130445,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats17.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T23:09:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "a reply to: kruphix Theocracy? Tim Kaine? In September 1980, as violence and civil war erupted throughout Central America, a quiet American left Harvard Law School to volunteer with Jesuit missionaries in northern Honduras. Around him, the United States-backed military dictatorship hunted Marxists and cracked down on the Catholic clergy for preaching empowerment to peasant farmers. But some locals also looked warily on the bearded and mop-haired Midwesterner in their midst. Just a few hours south, the Central Intelligence Agency was using Honduras as a staging ground in its covert war against Latin American communism, with right-wing forces training for operations in El Salvador and Nicaragua. “Some of the people were wondering what’s going on, who is this guy?” Tim Kaine, then a 22-year-old volunteer and now the Democratic nominee for vice president, said in an interview. He understood why. His mentors in the priesthood had also urged him to be wary of friendly American faces. Continue reading the main story Advertisement Continue reading the main story “It was a time of such intrigue and suspicion,” Mr. Kaine said. Far from being a C.I.A. operative, Mr. Kaine was a young Catholic at a crossroads, undergoing a spiritual shift as he awakened to the plight of the deeply poor in Honduras. In its far-flung pueblos, banana plantation company towns and dusty cities, Mr. Kaine embraced an interpretation of the gospel, known as liberation theology, that championed social change to improve the lives of the downtrodden. In Honduras, his recitation of the traditional Catholic mealtime blessing changed to “Lord give bread to those who hunger, and hunger for justice to those who have bread.” Honduran military leaders, American officials and even Pope John Paul II viewed liberation theology suspiciously, as dangerously injecting Marxist beliefs into religious teaching. But the strong social-justice message of liberation theology helped set Mr. Kaine on a left-veering career path in which he fought as a lawyer against housing discrimination, became a liberal mayor, and rose as a Spanish-speaking governor and senator with an enduring focus on Latin America.",
		"thread_title": "What is one more election thread, ehhh?",
		"title": "What is one more election thread, ehhh?",
		"type": "bs",
		"uuid": "64e53a2fbe37698782eee5174e53365b86002fba"
	},
	"-KhIa85yqZsT-6trbj8a": {
		"author": "ghostrager",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:39:15.467+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.2961838,
				"type": "PERSON"
			},
			{
				"name": "Steps",
				"salience": 0.042661756,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.042661756,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.037913658,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.03599734,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.03505666,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.03147499,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.027472373,
				"type": "OTHER"
			},
			{
				"name": "Help page",
				"salience": 0.027472373,
				"type": "OTHER"
			},
			{
				"name": "stairs",
				"salience": 0.027472373,
				"type": "OTHER"
			},
			{
				"name": "leg strength",
				"salience": 0.02629553,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.023349114,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.023056922,
				"type": "OTHER"
			},
			{
				"name": "gentleman",
				"salience": 0.016289346,
				"type": "PERSON"
			},
			{
				"name": "lending hand",
				"salience": 0.01625522,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.01625522,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ease",
				"salience": 0.014084508,
				"type": "OTHER"
			},
			{
				"name": "helper rushes",
				"salience": 0.014084508,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.010662342,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.006708591,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.006708591,
				"type": "LOCATION"
			},
			{
				"name": "step",
				"salience": 0.0066852197,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0066786758,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0058103544,
				"type": "OTHER"
			},
			{
				"name": "paradoxious",
				"salience": 0.0058103544,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0058103544,
				"type": "OTHER"
			},
			{
				"name": "pole dance",
				"salience": 0.0058103544,
				"type": "OTHER"
			},
			{
				"name": "spot",
				"salience": 0.0058103544,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.005772772,
				"type": "PERSON"
			},
			{
				"name": "ghostrager",
				"salience": 0.0054782843,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0054301466,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.0052112974,
				"type": "OTHER"
			},
			{
				"name": "campaign trail",
				"salience": 0.0052112974,
				"type": "LOCATION"
			},
			{
				"name": "link",
				"salience": 0.0050169905,
				"type": "OTHER"
			},
			{
				"name": "campaign trail",
				"salience": 0.0050169905,
				"type": "LOCATION"
			},
			{
				"name": "trainer",
				"salience": 0.0050169905,
				"type": "PERSON"
			},
			{
				"name": "boost",
				"salience": 0.004991122,
				"type": "OTHER"
			},
			{
				"name": "naps",
				"salience": 0.004705802,
				"type": "OTHER"
			},
			{
				"name": "sleep",
				"salience": 0.004705802,
				"type": "OTHER"
			},
			{
				"name": "gym",
				"salience": 0.004705802,
				"type": "LOCATION"
			},
			{
				"name": "pockets",
				"salience": 0.004605725,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.004605725,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0045880727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reply",
				"salience": 0.0045303158,
				"type": "OTHER"
			},
			{
				"name": "gym",
				"salience": 0.0045303158,
				"type": "LOCATION"
			},
			{
				"name": "speech money",
				"salience": 0.0045303158,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02yy8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Franklin_D._Roosevelt"
				},
				"name": "Franklin D. Roosevelt",
				"salience": 0.004497878,
				"type": "PERSON"
			},
			{
				"name": "violation",
				"salience": 0.00392337,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.00392337,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0038423415,
				"type": "OTHER"
			},
			{
				"name": "sleep",
				"salience": 0.0038423415,
				"type": "OTHER"
			},
			{
				"name": "naps",
				"salience": 0.0038423415,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ynx29_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_(corporate_title)"
				},
				"name": "Presidents",
				"salience": 0.0035780366,
				"type": "PERSON"
			},
			{
				"name": "Mudpit",
				"salience": 0.0035780366,
				"type": "WORK_OF_ART"
			},
			{
				"name": "heels",
				"salience": 0.002931369,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.002870809,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.002486018,
				"type": "PERSON"
			},
			{
				"name": "cahoots",
				"salience": 0.002486018,
				"type": "OTHER"
			},
			{
				"name": "grim reaper",
				"salience": 0.002486018,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.002486018,
				"type": "PERSON"
			},
			{
				"name": "game",
				"salience": 0.002486018,
				"type": "EVENT"
			},
			{
				"name": "anything",
				"salience": 0.002486018,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.002486018,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.0024154654,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0023270026,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0022462534,
				"type": "WORK_OF_ART"
			},
			{
				"name": "steps",
				"salience": 0.0021103506,
				"type": "OTHER"
			},
			{
				"name": "pocket",
				"salience": 0.0018727428,
				"type": "OTHER"
			},
			{
				"name": "pocket",
				"salience": 0.0018727428,
				"type": "OTHER"
			},
			{
				"name": "pockets",
				"salience": 0.0018727428,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.001810722,
				"type": "OTHER"
			},
			{
				"name": "lala land",
				"salience": 0.001810722,
				"type": "OTHER"
			},
			{
				"name": "joker smile",
				"salience": 0.001810722,
				"type": "OTHER"
			},
			{
				"name": "acid",
				"salience": 0.001810722,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.001810722,
				"type": "PERSON"
			},
			{
				"name": "note",
				"salience": 0.001810722,
				"type": "OTHER"
			},
			{
				"name": "hand assist",
				"salience": 0.001810722,
				"type": "OTHER"
			},
			{
				"name": "health issues",
				"salience": 0.0015950829,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0015621159,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0015621159,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0015621159,
				"type": "OTHER"
			},
			{
				"name": "disability",
				"salience": 0.0015551386,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0013526607,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T22:45:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Hillary Conquers 2 Steps with Little Help page: 1 link She has again conquered a flight of stairs, well 2 steps, with little help. As you can see in the video she takes the first step with ease as her helper rushes to her side just in time. The next step was larger and she glances back knowing a lending hand is there. He gives her a boost and she proudly, albeit ironically, holds up her \"Stronger Together\" sign. Political Mudpit seems like a good spot for this. With how Presidents age in office, how much is she going to deteriorate over the next 4 years? Ghost I though she was about to perform a pole dance. (post by paradoxious removed for a serious terms and conditions violation) link What with all of the time she spends off of the campaign trail, you would think she could spend a little time in the gym, working on her leg strength. And I know, given all of the \"speech money\" she and Bill have socked away, she can afford to hire a personal trainer... link a reply to: mobiusmale What with all of the time she spends off of the campaign trail, you would think she could spend a little time in the gym, working on her leg strength. And cut into her 16 hours of sleep and naps per day? Not likely. link originally posted by: ghostrager Could it just be that the second step was a little higher up and she needed some help? Or maybe theven gentleman that is supposed to be by her side was just being a gentleman. Good thing Franklin D. Roosevelt isn't running in the US today. don't fool yourself, ol frank was in some deep pockets to. And cut into her 16 hours of sleep and naps per day? Not likely. I had heard it was 18 hours. Good thing Franklin D. Roosevelt isn't running in the US today. don't fool yourself, ol frank was in some deep pockets to. In this case it was about steps, not which pocket. There all in some pocket even if it isn't about money. link a reply to: roadgravel frank also tried to hide the extant his disability from the public as best he could. sounds very familiar to me. link Her, age in office? We're talking about the grim reaper here. Who's already been in cahoots with other elites and has been in the game completely giving zero f***s about anything except power. Anyway, the video didn't really deliver. She is wearing heels, so that's enough to valid needing a hand assist. Enough to be a non story, and discredit her real concerning health issues as far reach. On another note, she's horrendous. Her greeting the crowd wooing looking like someone who's high as hell in lala land tripping on acid etc. Let's not talk further about her joker smile.",
		"thread_title": "Hillary Conquers 2 Steps with Little Help",
		"title": "Hillary Conquers 2 Steps with Little Help",
		"type": "bs",
		"uuid": "7facacd9a551b14017784d720f1eaf9647946ec9"
	},
	"-KhIa8EXDypQUpaDbaNQ": {
		"author": "Stevemagegod",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T02:09:13.534+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04zxmr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/SoundCloud"
				},
				"name": "soundcloud.com",
				"salience": 0.64026386,
				"type": "ORGANIZATION"
			},
			{
				"name": "EVP",
				"salience": 0.103285715,
				"type": "OTHER"
			},
			{
				"name": "Opinion page",
				"salience": 0.103285715,
				"type": "OTHER"
			},
			{
				"name": "clip",
				"salience": 0.058981385,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Audio",
				"salience": 0.026383493,
				"type": "OTHER"
			},
			{
				"name": "audio",
				"salience": 0.017903302,
				"type": "OTHER"
			},
			{
				"name": "sleep noises",
				"salience": 0.013185138,
				"type": "OTHER"
			},
			{
				"name": "San-ta Claus",
				"salience": 0.009960547,
				"type": "OTHER"
			},
			{
				"name": "Hey Satan",
				"salience": 0.009960547,
				"type": "PERSON"
			},
			{
				"name": "Hey Sleepy",
				"salience": 0.009590863,
				"type": "WORK_OF_ART"
			},
			{
				"name": "topics",
				"salience": 0.007199416,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats18.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T02:09:13.534+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "New EVP I want a 2nd Opinion page: 1 Original: soundcloud.com... Audio Slowed down: soundcloud.com... On the slowed down audio it sounds like to me \"Hey Sleepy\" or \"Hey Satan\" then goes on to say \"San-ta Claus\" As you can tell by my sleep noises that i am fast asleep. This was recorded at 9-01-2016 at 3-54-23am. It's a month old clip but i just got around to looking at it. new topics",
		"thread_title": "New EVP I want a 2nd Opinion",
		"title": "New EVP I want a 2nd Opinion",
		"type": "bs",
		"uuid": "6a15227d25ac0066be187c3d3e50e0b57280cdd7"
	},
	"-KhIa8Y8GcmwlhsFF06W": {
		"author": "eisegesis",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T02:09:13.668+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Obamacare",
				"salience": 0.73418033,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.060880363,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0204x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_Reid"
				},
				"name": "Harry Reid",
				"salience": 0.015025204,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.011891814,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.010132362,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.007971928,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0062144795,
				"type": "OTHER"
			},
			{
				"name": "oligarchy",
				"salience": 0.0062144795,
				"type": "OTHER"
			},
			{
				"name": "Solution",
				"salience": 0.0062144795,
				"type": "OTHER"
			},
			{
				"name": "Reaction",
				"salience": 0.0062144795,
				"type": "OTHER"
			},
			{
				"name": "Problem",
				"salience": 0.0062144795,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0060414327,
				"type": "OTHER"
			},
			{
				"name": "construct",
				"salience": 0.004728701,
				"type": "OTHER"
			},
			{
				"name": "health care system",
				"salience": 0.0046934816,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00406629,
				"type": "ORGANIZATION"
			},
			{
				"name": "doubt",
				"salience": 0.0036726287,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0036726287,
				"type": "OTHER"
			},
			{
				"name": "Link",
				"salience": 0.0036726287,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.0034322662,
				"type": "EVENT"
			},
			{
				"name": "illusion",
				"salience": 0.003389134,
				"type": "OTHER"
			},
			{
				"name": "sham",
				"salience": 0.003389134,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012v1t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nancy_Pelosi"
				},
				"name": "Nancy Pelosi",
				"salience": 0.0032699679,
				"type": "PERSON"
			},
			{
				"name": "e-mail",
				"salience": 0.0031814452,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0031814452,
				"type": "OTHER"
			},
			{
				"name": "shadow",
				"salience": 0.0031814452,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.0025127872,
				"type": "OTHER"
			},
			{
				"name": "Ann O'Leary",
				"salience": 0.0022088785,
				"type": "PERSON"
			},
			{
				"name": "bill",
				"salience": 0.002176405,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.0021601561,
				"type": "ORGANIZATION"
			},
			{
				"name": "goose",
				"salience": 0.0018658212,
				"type": "OTHER"
			},
			{
				"name": "version passes",
				"salience": 0.0018574978,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "asset",
				"salience": 0.0013112909,
				"type": "OTHER"
			},
			{
				"name": "health scores",
				"salience": 0.0013112909,
				"type": "OTHER"
			},
			{
				"name": "health insurance companies",
				"salience": 0.0013112909,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.0013112909,
				"type": "OTHER"
			},
			{
				"name": "health data",
				"salience": 0.0013112909,
				"type": "OTHER"
			},
			{
				"name": "doctor visits",
				"salience": 0.0013112909,
				"type": "EVENT"
			},
			{
				"name": "will",
				"salience": 0.0013112909,
				"type": "OTHER"
			},
			{
				"name": "quote",
				"salience": 0.0012947798,
				"type": "OTHER"
			},
			{
				"name": "Picture",
				"salience": 0.0012784764,
				"type": "WORK_OF_ART"
			},
			{
				"name": "health care",
				"salience": 0.001272918,
				"type": "OTHER"
			},
			{
				"name": "health tracking apparel",
				"salience": 0.0012464823,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.001176019,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0011675955,
				"type": "ORGANIZATION"
			},
			{
				"name": "doubts",
				"salience": 0.0011603988,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0011321467,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0010706307,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0010618876,
				"type": "OTHER"
			},
			{
				"name": "doctors",
				"salience": 0.0010618876,
				"type": "PERSON"
			},
			{
				"name": "coverage",
				"salience": 0.0010618876,
				"type": "OTHER"
			},
			{
				"name": "Link",
				"salience": 0.001022269,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0009851224,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.0009601628,
				"type": "OTHER"
			},
			{
				"name": "opposite",
				"salience": 0.00095520855,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0009243362,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.00091956666,
				"type": "OTHER"
			},
			{
				"name": "rates",
				"salience": 0.00091956666,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00091956666,
				"type": "PERSON"
			},
			{
				"name": "penalties",
				"salience": 0.00091956666,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.00091956666,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.00091956666,
				"type": "WORK_OF_ART"
			},
			{
				"name": "unraveling",
				"salience": 0.0008965467,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00088525354,
				"type": "OTHER"
			},
			{
				"name": "options",
				"salience": 0.00088525354,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.00088525354,
				"type": "OTHER"
			},
			{
				"name": "revenues",
				"salience": 0.00088525354,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00088525354,
				"type": "OTHER"
			},
			{
				"name": "email thread",
				"salience": 0.00088525354,
				"type": "OTHER"
			},
			{
				"name": "goose",
				"salience": 0.000866963,
				"type": "OTHER"
			},
			{
				"name": "gander",
				"salience": 0.000866963,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.000866963,
				"type": "OTHER"
			},
			{
				"name": "ganders",
				"salience": 0.000866963,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00086075143,
				"type": "LOCATION"
			},
			{
				"name": "system",
				"salience": 0.0008283724,
				"type": "OTHER"
			},
			{
				"name": "health care",
				"salience": 0.0007764598,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0007507487,
				"type": "OTHER"
			},
			{
				"name": "subsidiaries",
				"salience": 0.0007507487,
				"type": "ORGANIZATION"
			},
			{
				"name": "rest",
				"salience": 0.0007507487,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0007173275,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0006536984,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.0006476846,
				"type": "EVENT"
			},
			{
				"name": "marketplace",
				"salience": 0.00061290513,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0005900286,
				"type": "OTHER"
			},
			{
				"name": "progressives",
				"salience": 0.0005608485,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "outcome",
				"salience": 0.0005608485,
				"type": "OTHER"
			},
			{
				"name": "sufficiency",
				"salience": 0.0005608485,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0005608485,
				"type": "OTHER"
			},
			{
				"name": "Memo on Cadillac Tax for HRC",
				"salience": 0.00054492767,
				"type": "WORK_OF_ART"
			},
			{
				"name": "folks",
				"salience": 0.0005026039,
				"type": "PERSON"
			},
			{
				"name": "coverage",
				"salience": 0.00047172533,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00047172533,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00047172533,
				"type": "OTHER"
			},
			{
				"name": "medicine system",
				"salience": 0.00045072025,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00044522146,
				"type": "PERSON"
			},
			{
				"name": "decisions",
				"salience": 0.00042972667,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00040847136,
				"type": "OTHER"
			},
			{
				"name": "well-being",
				"salience": 0.00040847136,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00040847136,
				"type": "OTHER"
			},
			{
				"name": "premium",
				"salience": 0.00040847136,
				"type": "OTHER"
			},
			{
				"name": "employer",
				"salience": 0.00040847136,
				"type": "PERSON"
			},
			{
				"name": "health care policy",
				"salience": 0.00039028184,
				"type": "OTHER"
			},
			{
				"name": "conservatives",
				"salience": 0.00035238016,
				"type": "PERSON"
			},
			{
				"name": "purpose",
				"salience": 0.00035238016,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.00035238016,
				"type": "PERSON"
			},
			{
				"name": "damn",
				"salience": 0.000350806,
				"type": "OTHER"
			},
			{
				"name": "PBS' Nevada Week In Review",
				"salience": 0.00034519614,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "D.",
				"salience": 0.00034519614,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.00033770912,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w74d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chuck_Schumer"
				},
				"name": "Schumer",
				"salience": 0.00023003708,
				"type": "PERSON"
			},
			{
				"name": "Obamacare 'Absolutely' A Step Toward A Single-Payer System",
				"salience": 0.00021686981,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T02:09:13.668+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link The oligarchy runs our society with Problem – Reaction – Solution. If anything, these leaks have proven beyond a shadow of a doubt that the two-party system is an illusion and the whole construct is one huge pay-for-play corporate sham. Obamacare was always meant to destroy the private health care system and usher in single-payer, government run socialist medicine. It was designed that way… and it’s “working”. Related: Link In this particular e-mail, we get to see just how fake and fraudulent our government is. Your health determines how valuable of an asset you are and it’s the main reason why we see “health tracking apparel” and “health scores,” designed by and for prominent health insurance companies in order to track your health data in-between doctor visits. Remember this quote by demon spawn Nancy Pelosi? “We have to pass the bill so that you can find out what’s in it.” If that wasn’t telling you something at the time, maybe this will… Picture: Link In an email thread dated September 26, 2015 between Hillary and her senior policy adviser, Ann O’Leary, titled “Memo on Cadillac Tax for HRC,” Hillary wrote, “Given the politics now w bipartisan support including Schumer, I’ll support repeal w ‘sense of the Senate’ that revenues would have to be found. I’d be open to a range of options to do that. But we have to be careful that the R version passes which begins the unraveling of the ACA.” Do you still have any doubts? Sadly, there are those who have benefited from the ACA, but to a greater extent, many have seen the exact opposite of what was promised. Higher rates, less coverage, new doctors, etc… A Democrat supporting Republican legislation to destroy Obamacare on purpose. How many millions have they raked in on this deal and bilked the American people for in Obamacare penalties because they can’t afford the “affordable” health care? And the American people will look at this like a “victory” when it does unravel, even though it has been the plan all along. Which reminds me, when was the last time that the people had a victory? This just goes to show you that what is good for the goose isn’t always good for the gander. They knew that going in and only after the fact, can we realize this. They wanted the ganders’ money while the goose that benefits (through subsidiaries), cries to defend the ACA, making the rest of us look insensitive and unfair. Good plan… They’re all working together, folks. Obamacare was always meant to fail — on purpose — to bring in a single-payer, government-controlled socialist medicine system. Don’t believe me yet? Back in 2013, Senator Harry Reid had this to say about the ACA… Sen. Harry Reid: Obamacare 'Absolutely' A Step Toward A Single-Payer System When I speak to conservatives about health care policy, I’m often asked the question: “Do you think that Obamacare is secretly a step toward single-payer health care?” I always explain that, while progressives may want single-payer, I don’t think that Obamacare is deliberately designed to bring about that outcome. Well, yesterday on PBS’ Nevada Week In Review , Senate Majority Leader Harry Reid (D., Nev.) was asked whether his goal was to move Obamacare to a single-payer system. His answer? “Yes, yes. Absolutely, yes.” The plan to undermine your health and sufficiency is so diabolical and disgusting, that many would simply refuse to believe such a thing. Well, there it is folks. They don’t give a damn about you or your well-being and will do anything in their power to see that decisions about your health are made by them in the future. For me personally, the ACA has increased my premium by 300%, causing me to drop what was offered by my employer and settle with less coverage for more money using the \"marketplace.\" Is this where I get to say... Thanks Obama?",
		"thread_title": "Obamacare is Meant to Fail in Order to Usher in Government-Run Socialist Health Care",
		"title": "Obamacare is Meant to Fail in Order to Usher in Government-Run Socialist Health Care",
		"type": "bs",
		"uuid": "7029376cd414f30d053fb15ddba32bf2f2b84634"
	},
	"-KhIa8jrs1BatTn4pRCb": {
		"author": "CaptainBeno",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T02:09:14.091+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "WTFrick",
				"salience": 0.16618796,
				"type": "PERSON"
			},
			{
				"name": "ahole",
				"salience": 0.14320345,
				"type": "OTHER"
			},
			{
				"name": "Ahmad Rahimi",
				"salience": 0.09936887,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.083400816,
				"type": "PERSON"
			},
			{
				"name": "Duuhhh",
				"salience": 0.036814053,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.031529818,
				"type": "PERSON"
			},
			{
				"name": "Ahman Khan",
				"salience": 0.028961034,
				"type": "PERSON"
			},
			{
				"name": "conversation",
				"salience": 0.028489204,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.026227057,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.024691794,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fist",
				"salience": 0.024691794,
				"type": "OTHER"
			},
			{
				"name": "bail",
				"salience": 0.024691794,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.01927116,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.01927116,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.01759435,
				"type": "PERSON"
			},
			{
				"name": "steps",
				"salience": 0.017342025,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.016697152,
				"type": "OTHER"
			},
			{
				"name": "shelter",
				"salience": 0.016697152,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.016353333,
				"type": "EVENT"
			},
			{
				"name": "Peter Hammer",
				"salience": 0.01437868,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.01416763,
				"type": "PERSON"
			},
			{
				"name": "bombs",
				"salience": 0.01416763,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.011001553,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01nz0l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tavern"
				},
				"name": "Tavern",
				"salience": 0.010689948,
				"type": "LOCATION"
			},
			{
				"name": "Merdie",
				"salience": 0.010689948,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.010680107,
				"type": "PERSON"
			},
			{
				"name": "No one",
				"salience": 0.0105918115,
				"type": "PERSON"
			},
			{
				"name": "shoot-out",
				"salience": 0.010131381,
				"type": "EVENT"
			},
			{
				"name": "fugitive",
				"salience": 0.010069067,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.008730453,
				"type": "LOCATION"
			},
			{
				"name": "identification",
				"salience": 0.008434006,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.007758701,
				"type": "PERSON"
			},
			{
				"name": "fire",
				"salience": 0.0067150383,
				"type": "OTHER"
			},
			{
				"name": "backup",
				"salience": 0.005768142,
				"type": "PERSON"
			},
			{
				"name": "Linden Police",
				"salience": 0.004541934,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T02:09:14.091+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "I cannot believe this ahole has been released?? Duuhhh?? WTFrick? however he has since been released on a $5.2 million bail. The video at fist seems to capture the seemingly standard conversation between New Jersey police and a homeless man seeking shelter on a rainy day. The officers were responding to reports that a man was sleeping on the steps of Merdie's Tavern, unaware they were talking to Ahmad Rahimi. Rahimi is alleged to have injured 31 people when he detonated two bombs in New York and New Jersey last month. Moments after the conversation began Rahimi opened fire at Linden Police officer Peter Hammer and four other officers who had been called as backup. No one was killed in the shoot-out which followed, but everyone was injured, including Rahimi. The fugitive had given police the alias Ahman Khan and said he did not have any identification when pressed by officers.",
		"thread_title": "WATCH: The moment police realised homeless man was bombing suspect",
		"title": "WATCH: The moment police realised homeless man was bombing suspect",
		"type": "bs",
		"uuid": "fa8132e42ddfbbd3b5edad22c803815f17e76d69"
	},
	"-KhIa8vrUIvm5u9l0FWe": {
		"author": "PraetorianAZ",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T02:09:14.728+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "students",
				"salience": 0.34875533,
				"type": "PERSON"
			},
			{
				"name": "entry",
				"salience": 0.092984326,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.07615305,
				"type": "PERSON"
			},
			{
				"name": "color",
				"salience": 0.059895266,
				"type": "OTHER"
			},
			{
				"name": "PraetorianAZ SJWs",
				"salience": 0.03716976,
				"type": "PERSON"
			},
			{
				"name": "Anyone",
				"salience": 0.03134877,
				"type": "PERSON"
			},
			{
				"name": "bridge",
				"salience": 0.02680058,
				"type": "OTHER"
			},
			{
				"name": "stream",
				"salience": 0.02680058,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.021142345,
				"type": "PERSON"
			},
			{
				"name": "whiteness",
				"salience": 0.015333701,
				"type": "OTHER"
			},
			{
				"name": "toddlers",
				"salience": 0.013658291,
				"type": "PERSON"
			},
			{
				"name": "next",
				"salience": 0.012800953,
				"type": "OTHER"
			},
			{
				"name": "hostility",
				"salience": 0.011090753,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.011090753,
				"type": "OTHER"
			},
			{
				"name": "human barrier",
				"salience": 0.011090753,
				"type": "OTHER"
			},
			{
				"name": "stone",
				"salience": 0.011090753,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.008986144,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.008986144,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.008986144,
				"type": "WORK_OF_ART"
			},
			{
				"name": "whitie",
				"salience": 0.008795371,
				"type": "OTHER"
			},
			{
				"name": "jaw",
				"salience": 0.008292385,
				"type": "OTHER"
			},
			{
				"name": "nuts",
				"salience": 0.007784147,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.007784147,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007784147,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.007494239,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.007494239,
				"type": "PERSON"
			},
			{
				"name": "BLock White",
				"salience": 0.0063884705,
				"type": "OTHER"
			},
			{
				"name": "education system",
				"salience": 0.0063574086,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0063574086,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0063574086,
				"type": "PERSON"
			},
			{
				"name": "joke",
				"salience": 0.0063574086,
				"type": "OTHER"
			},
			{
				"name": "Students",
				"salience": 0.0060625854,
				"type": "PERSON"
			},
			{
				"name": "Campus Nice Video",
				"salience": 0.0053303647,
				"type": "WORK_OF_ART"
			},
			{
				"name": "SJWS Build Human Wall",
				"salience": 0.0053303647,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.0051580975,
				"type": "PERSON"
			},
			{
				"name": "nose",
				"salience": 0.0047512585,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0047512585,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0047512585,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02zd460",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Berkeley"
				},
				"name": "UC Berkeley",
				"salience": 0.0046165423,
				"type": "ORGANIZATION"
			},
			{
				"name": "dolts",
				"salience": 0.004516547,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0034615225,
				"type": "OTHER"
			},
			{
				"name": "rainbow kerchief",
				"salience": 0.0034615225,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.0034615225,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.0034615225,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0032490145,
				"type": "OTHER"
			},
			{
				"name": "human punch",
				"salience": 0.002586304,
				"type": "OTHER"
			},
			{
				"name": "straw",
				"salience": 0.002586304,
				"type": "OTHER"
			},
			{
				"name": "meals",
				"salience": 0.002586304,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.002586304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dbxy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cherokee"
				},
				"name": "Cherokee",
				"salience": 0.0021311329,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0896tb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shawnee_language"
				},
				"name": "SJW",
				"salience": 0.0021311329,
				"type": "ORGANIZATION"
			},
			{
				"name": "role",
				"salience": 0.001617964,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T02:09:14.728+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "originally posted by: PraetorianAZ SJWs blocked white students from passing but granted entry to students of color. White students had to bypass the bridge by crossing a rocky stream, hopping from one stone to the next. Anyone who tried to push past the human barrier was immediately met with violence and hostility. “This is bigger than you! This is about whiteness,” the protesters cried. UC Berkeley SJWS Build Human Wall to BLock White Students from Campus Nice Video in the link. They never actually say that whites were not allowed to cross the wall but you can clearly see in the video they let people of color through while making white students walk around. Pretty nuts. One more reason I don't believe in the education system. So many self entitled 20 year old toddlers who piss and moan when life gets rough. Then take it out on whitie and the police. What a joke. If they blocked me anybody who stood in my way would be eating blended meals through a straw for the next couple of months. The average human punch can generate 178 pounds of pressure or force. It takes 10 to 13 pounds to break a nose and 40 pounds to dislocate someones jaw. I have done both and im very good at it. Then to get to class, one may need to keep a rainbow kerchief or Cherokee flag handy and play a role. SJW racists are basically dolts and can be readily outwitted.",
		"thread_title": "UC Berkeley SJWS Build Human Wall to BLock White Students from Campus",
		"title": "UC Berkeley SJWS Build Human Wall to BLock White Students from Campus",
		"type": "bs",
		"uuid": "ba836dbba7bac7bb460834687df8d80b4f7d8b80"
	},
	"-KhIa96-kuUUrvI5VeQr": {
		"author": "xuenchen",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T02:09:15.029+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.57920825,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "Goldman Sachs",
				"salience": 0.26502416,
				"type": "ORGANIZATION"
			},
			{
				"name": "President",
				"salience": 0.021198908,
				"type": "PERSON"
			},
			{
				"name": "Business",
				"salience": 0.018410021,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.016459094,
				"type": "PERSON"
			},
			{
				"name": "endorsement",
				"salience": 0.014815077,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.010940406,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.009487405,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/080t3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lloyd_Blankfein"
				},
				"name": "Lloyd Blankfein",
				"salience": 0.0068554105,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0065738363,
				"type": "PERSON"
			},
			{
				"name": "talents",
				"salience": 0.0060308254,
				"type": "OTHER"
			},
			{
				"name": "activism",
				"salience": 0.0039264797,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0039264797,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0039264797,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0028342516,
				"type": "ORGANIZATION"
			},
			{
				"name": "positions",
				"salience": 0.0028265005,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.0025985385,
				"type": "OTHER"
			},
			{
				"name": "regulation",
				"salience": 0.0025985385,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0025985385,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.002250786,
				"type": "EVENT"
			},
			{
				"name": "regulations",
				"salience": 0.0019422347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0016977587,
				"type": "ORGANIZATION"
			},
			{
				"name": "crisis",
				"salience": 0.0016821579,
				"type": "EVENT"
			},
			{
				"name": "key",
				"salience": 0.0016821579,
				"type": "OTHER"
			},
			{
				"name": "works",
				"salience": 0.0015671434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "industry",
				"salience": 0.0014151275,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.0014151275,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0013863096,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.0012255427,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00091567857,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.00091567857,
				"type": "OTHER"
			},
			{
				"name": "anti-Bernie anti-Thesis",
				"salience": 0.0008713155,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09ggjpz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dodd%E2%80%93Frank_Wall_Street_Reform_and_Consumer_Protection_Act"
				},
				"name": "Dodd-Frank",
				"salience": 0.0007937737,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats11.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T02:09:15.029+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Well finally we have the big global Business/Bank Goldman Sachs officially endorsing Hillary Clinton for President !! They have been giving her money and paying for speeches for some time now. Get ready for Hillary's *actual* policies to kick in if and when she gets elected. Ironic. GS has been a target of political activism for years. Now they can bank on Hillary protecting them. Goldman Sachs Endorses Hillary Clinton For President He’s with her. On Sunday, former Secretary of State Hillary Clinton earned the endorsement of Goldman Sachs CEO Lloyd Blankfein—an endorsement she had been working toward for years. As was revealed by Wikileaks, Hillary Clinton spent the run up to her presidential campaign giving speeches to Goldman Sachs and other Wall Street banks, where she praised their talents and explained her positions on financial regulation. On October 24, 2013, Clinton told Goldman Sachs that Dodd-Frank had to be done mostly for “political reasons” because Congress needed to look like it was doing something about the crisis. She said, “There’s nothing magic about regulations, too much is bad, too little is bad. How do you get to the golden key, how do we figure out what works? And the people that know the industry better than anybody are the people who work in the industry.” The anti-Bernie anti-Thesis",
		"thread_title": "Goldman Sachs Endorses Hillary Clinton For President",
		"title": "Goldman Sachs Endorses Hillary Clinton For President",
		"type": "bs",
		"uuid": "5728857f1236aa78f8ddac7e5175bf3c99461154"
	},
	"-KhIa9HRwLavRG2clWAT": {
		"author": "xuenchen",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T02:09:15.267+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "world problems",
				"salience": 0.11263317,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.112350024,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.097523466,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.051843558,
				"type": "OTHER"
			},
			{
				"name": "Hillary Campaign",
				"salience": 0.047644936,
				"type": "ORGANIZATION"
			},
			{
				"name": "bullying",
				"salience": 0.045983203,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.042072836,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.041031826,
				"type": "LOCATION"
			},
			{
				"name": "bullying",
				"salience": 0.04006635,
				"type": "OTHER"
			},
			{
				"name": "bullies",
				"salience": 0.02329002,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07pbvp7"
				},
				"name": "Humanity",
				"salience": 0.021230198,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.021093503,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.020298647,
				"type": "PERSON"
			},
			{
				"name": "States",
				"salience": 0.016793434,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.015889559,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.01422523,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.01422523,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.01422523,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.01422523,
				"type": "EVENT"
			},
			{
				"name": "plan",
				"salience": 0.014182373,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.014182373,
				"type": "OTHER"
			},
			{
				"name": "greatness",
				"salience": 0.012379265,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.012033855,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.011097386,
				"type": "ORGANIZATION"
			},
			{
				"name": "nominee",
				"salience": 0.009984899,
				"type": "PERSON"
			},
			{
				"name": "funding",
				"salience": 0.009984899,
				"type": "OTHER"
			},
			{
				"name": "heel",
				"salience": 0.009613095,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.009613095,
				"type": "OTHER"
			},
			{
				"name": "Latest",
				"salience": 0.009613095,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.008155068,
				"type": "OTHER"
			},
			{
				"name": "appearance",
				"salience": 0.008155068,
				"type": "EVENT"
			},
			{
				"name": "bully",
				"salience": 0.006837382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00615151,
				"type": "ORGANIZATION"
			},
			{
				"name": "color",
				"salience": 0.006094988,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.006094988,
				"type": "OTHER"
			},
			{
				"name": "gender identity",
				"salience": 0.006094988,
				"type": "OTHER"
			},
			{
				"name": "sexual orientation",
				"salience": 0.006094988,
				"type": "OTHER"
			},
			{
				"name": "disability",
				"salience": 0.006094988,
				"type": "OTHER"
			},
			{
				"name": "sex",
				"salience": 0.006094988,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.006094988,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.006094988,
				"type": "EVENT"
			},
			{
				"name": "basis",
				"salience": 0.006094988,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0051275236,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.005023113,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.0045926115,
				"type": "ORGANIZATION"
			},
			{
				"name": "tax increases",
				"salience": 0.004440632,
				"type": "OTHER"
			},
			{
				"name": "wealthy",
				"salience": 0.004440632,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0033328016,
				"type": "EVENT"
			},
			{
				"name": "incidents",
				"salience": 0.003317923,
				"type": "EVENT"
			},
			{
				"name": "comments",
				"salience": 0.003317923,
				"type": "WORK_OF_ART"
			},
			{
				"name": "process",
				"salience": 0.00292294,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats12.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:05:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "A major new plan will be announced soon by the Hillary Campaign. This will certainly solve the world problems that face Humanity. She will tax the rich and pay hundreds of millions of dollars to states that fight bullies !!!! It's the anti-bully agenda to keep everybody's free speech and free thought on heel of the government. The greatness is astounding !!! The Latest: Clinton to unveil anti-bullying plan Hillary Clinton is unveiling a plan to reduce bullying. Called \"Better than Bullying,\" the plan released Thursday by the Democratic presidential nominee would provide $500 million in new funding to states that develop comprehensive anti-bullying efforts. Clinton is expected to talk about the plan during an appearance with first lady Michelle Obama Thursday. She has called Republican Donald Trump a bully for his derogatory comments. The campaign said states must address verbal and cyber bullying and establish a process for addressing incidents. They must also ban bullying on the \"basis of race, color, national origin, sex, disability, sexual orientation, gender identity, and religion.\" States could get $4 dollars from the federal government for every $1 they spend. It would be paid for through Clinton's proposed tax increases on the wealthy.",
		"thread_title": "The Latest: Clinton to unveil anti-bullying plan",
		"title": "The Latest: Clinton to unveil anti-bullying plan",
		"type": "bs",
		"uuid": "e9dd13e098360cb39af77415904b1d933cc568b8"
	},
	"-KhIa9NclQFqCtNtLAC5": {
		"author": "TrueBrit",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T02:09:15.885+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "place",
				"salience": 0.37968454,
				"type": "OTHER"
			},
			{
				"name": "rope",
				"salience": 0.17953129,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.13735828,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.06833625,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.06581362,
				"type": "OTHER"
			},
			{
				"name": "gates",
				"salience": 0.059264645,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.04347175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n1p1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paradise"
				},
				"name": "Heavens",
				"salience": 0.036615573,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d2l53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hell"
				},
				"name": "Hell",
				"salience": 0.029924052,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T00:29:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "I hope this is in the right place. If it is not, then neither am I. Here goes nothing, No matter how hard he climbed, Still some how he fell, No matter how close to Heavens gates, He still wound up in Hell, He fell so deep the rope ran out, After a while, That he had ever left, Or ever been, So long was it since he was seen, Here goes nothing,",
		"thread_title": "Here Goes Nothing: Futilitys Song",
		"title": "Here Goes Nothing: Futilitys Song",
		"type": "bs",
		"uuid": "c3b944bf5cbefba1775f5aca4c4cf31a08c8b273"
	},
	"-KhIa9Wz1tgrxjuD6J2w": {
		"author": "beeeyotch",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:08.471+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Red Necks page",
				"salience": 0.43226218,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.1537982,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.11784275,
				"type": "PERSON"
			},
			{
				"name": "Supporters",
				"salience": 0.049528793,
				"type": "PERSON"
			},
			{
				"name": "Calling Black Trump",
				"salience": 0.030807037,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.024821615,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.022708856,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.015009305,
				"type": "PERSON"
			},
			{
				"name": "folks",
				"salience": 0.014517665,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.012554866,
				"type": "OTHER"
			},
			{
				"name": "fine",
				"salience": 0.011162298,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.009797036,
				"type": "PERSON"
			},
			{
				"name": "folks",
				"salience": 0.008879605,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.007925711,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0062339655,
				"type": "PERSON"
			},
			{
				"name": "trump",
				"salience": 0.0061016483,
				"type": "OTHER"
			},
			{
				"name": "brothers",
				"salience": 0.005400258,
				"type": "PERSON"
			},
			{
				"name": "sisters",
				"salience": 0.005400258,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.005387721,
				"type": "OTHER"
			},
			{
				"name": "school zones",
				"salience": 0.0051991707,
				"type": "LOCATION"
			},
			{
				"name": "opportunities",
				"salience": 0.0051991707,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.00480262,
				"type": "ORGANIZATION"
			},
			{
				"name": "minority members",
				"salience": 0.0045236666,
				"type": "PERSON"
			},
			{
				"name": "liberal",
				"salience": 0.0044667805,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.004410608,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0043362286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.0033269983,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0032964288,
				"type": "OTHER"
			},
			{
				"name": "upbringings",
				"salience": 0.0032964288,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fj7z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Instant_messaging"
				},
				"name": "Im",
				"salience": 0.002751346,
				"type": "LOCATION"
			},
			{
				"name": "colors",
				"salience": 0.0024016828,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0024016828,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.0020721583,
				"type": "PERSON"
			},
			{
				"name": "minorities",
				"salience": 0.0020721583,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "AMERICANS",
				"salience": 0.002029947,
				"type": "PERSON"
			},
			{
				"name": "lots",
				"salience": 0.001794474,
				"type": "OTHER"
			},
			{
				"name": "Ameicans",
				"salience": 0.0014786755,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:08.471+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Democrats are Racist for Calling Black Trump Supporters Uneducated Red Necks page: 1 link Its ok to call us white Trump supporters all that but when You mess with our black friends then that's another issue. Democrats need to realize that some black folks and white folks all grew up with different opportunities and school zones, that is SO RACIST to call them uneducated, its fine to call us whites that but not our black brothers and sisters, the Hispanics and all other non whites. How dare the Clintons offend our black and other minority members , Im sure some liberal will come along and say something totally ignorant like trump doesn't have and black supporters, well he does, over 20% of them. True, the democrats didn't single out the blacks and minorities, they referred to all of us as lots of things, all of us AMERICANS that weren't equal in our financial upbringings. You see, I see all of us Trump supporters as 3 colors, red white and blue. I see us all as Ameicans and not trying to DIVIDE people like the democrats.",
		"thread_title": "Democrats are Racist for Calling Black Trump Supporters Uneducated Red Necks",
		"title": "Democrats are Racist for Calling Black Trump Supporters Uneducated Red Necks",
		"type": "bs",
		"uuid": "c33f353c72d404633c01a9a17853f10951c5ed83"
	},
	"-KhIa9lK4oeLWQh6LEvo": {
		"author": "Zaphod58",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:10.809+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.2728265,
				"type": "ORGANIZATION"
			},
			{
				"name": "wing design",
				"salience": 0.0774043,
				"type": "OTHER"
			},
			{
				"name": "Spanwise Adaptive Wing",
				"salience": 0.06642846,
				"type": "WORK_OF_ART"
			},
			{
				"name": "flight",
				"salience": 0.050366174,
				"type": "OTHER"
			},
			{
				"name": "wingtips",
				"salience": 0.047481097,
				"type": "OTHER"
			},
			{
				"name": "drag",
				"salience": 0.04660622,
				"type": "OTHER"
			},
			{
				"name": "shape",
				"salience": 0.04216221,
				"type": "OTHER"
			},
			{
				"name": "yaw stability",
				"salience": 0.04216221,
				"type": "OTHER"
			},
			{
				"name": "flight folding wing page",
				"salience": 0.03659711,
				"type": "OTHER"
			},
			{
				"name": "rudder size",
				"salience": 0.032872006,
				"type": "OTHER"
			},
			{
				"name": "PTERA UAV",
				"salience": 0.018244267,
				"type": "OTHER"
			},
			{
				"name": "wingspan",
				"salience": 0.015869884,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0118k7fm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing_777X"
				},
				"name": "Boeing 777X",
				"salience": 0.015453447,
				"type": "OTHER"
			},
			{
				"name": "wingtip area",
				"salience": 0.013040375,
				"type": "LOCATION"
			},
			{
				"name": "wings",
				"salience": 0.012808324,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.0099492725,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0099492725,
				"type": "LOCATION"
			},
			{
				"name": "wingtips",
				"salience": 0.00910822,
				"type": "OTHER"
			},
			{
				"name": "wingspan",
				"salience": 0.008993847,
				"type": "OTHER"
			},
			{
				"name": "gates",
				"salience": 0.008986547,
				"type": "LOCATION"
			},
			{
				"name": "wing",
				"salience": 0.0068099773,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.006774127,
				"type": "OTHER"
			},
			{
				"name": "actuators",
				"salience": 0.006723599,
				"type": "PERSON"
			},
			{
				"name": "actuators",
				"salience": 0.006723599,
				"type": "OTHER"
			},
			{
				"name": "shape-memory alloy actuators",
				"salience": 0.006723599,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tips",
				"salience": 0.006072167,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.005746736,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.005259509,
				"type": "OTHER"
			},
			{
				"name": "airliner",
				"salience": 0.0049998313,
				"type": "ORGANIZATION"
			},
			{
				"name": "flight",
				"salience": 0.0046139746,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0044613816,
				"type": "OTHER"
			},
			{
				"name": "aviation",
				"salience": 0.0044613816,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0042630113,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0042630113,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.0042630113,
				"type": "OTHER"
			},
			{
				"name": "rudder authority",
				"salience": 0.0042410363,
				"type": "OTHER"
			},
			{
				"name": "Spanwise Adaptive Wing",
				"salience": 0.00419543,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0n0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Area"
				},
				"name": "Area",
				"salience": 0.0038852808,
				"type": "LOCATION"
			},
			{
				"name": "fuel",
				"salience": 0.003849576,
				"type": "OTHER"
			},
			{
				"name": "wingspans",
				"salience": 0.003709063,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.0033617674,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.0033339395,
				"type": "OTHER"
			},
			{
				"name": "taxiway",
				"salience": 0.0033339395,
				"type": "OTHER"
			},
			{
				"name": "gate size restrictions",
				"salience": 0.0033339395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03128q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shape-memory_alloy"
				},
				"name": "SMA",
				"salience": 0.0032393846,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0178g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing"
				},
				"name": "Boeing",
				"salience": 0.003172493,
				"type": "ORGANIZATION"
			},
			{
				"name": "goal",
				"salience": 0.003129302,
				"type": "OTHER"
			},
			{
				"name": "tail drag",
				"salience": 0.0031059235,
				"type": "OTHER"
			},
			{
				"name": "yaw stability",
				"salience": 0.0028045669,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01f10d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_American_XB-70_Valkyrie"
				},
				"name": "XB-70",
				"salience": 0.00274744,
				"type": "OTHER"
			},
			{
				"name": "feasibility assessment",
				"salience": 0.0024287566,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.0024287566,
				"type": "OTHER"
			},
			{
				"name": "wing sections",
				"salience": 0.0024287566,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0024287566,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.0023981698,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "aircraft",
				"salience": 0.0023206726,
				"type": "OTHER"
			},
			{
				"name": "rudder size",
				"salience": 0.00217817,
				"type": "OTHER"
			},
			{
				"name": "tips",
				"salience": 0.002095436,
				"type": "OTHER"
			},
			{
				"name": "cruise efficiency",
				"salience": 0.0018145731,
				"type": "OTHER"
			},
			{
				"name": "lift distribution",
				"salience": 0.0018145731,
				"type": "OTHER"
			},
			{
				"name": "fuel burn",
				"salience": 0.0018145731,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0018145731,
				"type": "OTHER"
			},
			{
				"name": "drag",
				"salience": 0.0016273097,
				"type": "OTHER"
			},
			{
				"name": "Convergent Aeronautics Solutions",
				"salience": 0.001495182,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats8.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:10.809+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "NASA to test in flight folding wing page: 1 link NASA is set to begin testing a new wing design that would change shape in flight, bending up or down, to increase yaw stability, reduce required rudder size, and decrease drag. The Boeing 777X is set to introduce wingtips that fold on the ground, to allow the aircraft to fit in existing gates with a longer wingspan. NASA is set to begin testing the Spanwise Adaptive Wing, which would add shape-memory alloy actuators to the wingtip area that would bend the tips up or down. The SMA actuators would activate when heated electrically, so there is no need for complex hydraulic lines or actuators. Beginning in Spring of 2017, NASA will start flying the Area-I PTERA UAV. It has a 176 inch wingspan, with the outer 15 inches moving as far as 75 degrees up or down. PTERA is not set up for SAW, but it appears that it could see a 40% rudder authority. The idea behind SAW is similar to what was done with the XB-70, with the wingtips angled down. Boeing will introduce folding wings to commercial aviation when the 777X airliner enters service at the end of 2019. But the devices could become commonplace on future aircraft as wingspans increase in an effort to reduce drag and fuel burn. The 777X has almost 24 ft. more wingspan than today’s 777 to optimize lift distribution and maximize cruise efficiency. Folding the tips on the ground keeps the larger aircraft compatible with existing taxiway and gate size restrictions. But NASA is investigating whether also folding the wing in flight could save still more fuel. The Spanwise Adaptive Wing (SAW) concept will be tested on the ground and in flight in a rapid feasibility assessment under NASA’s new Convergent Aeronautics Solutions project. The goal is to show that angling the outboard wing sections up or down can increase yaw stability and control, and reduce rudder size and tail drag.",
		"thread_title": "NASA to test in flight folding wing",
		"title": "NASA to test in flight folding wing",
		"type": "bs",
		"uuid": "47bc2e858c57a93d3dea97499ff795da6e640c12"
	},
	"-KhIa9sKR6pgiD8P-l5h": {
		"author": "CriticalStinker",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:12.283+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Assange",
				"salience": 0.43470922,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.12930998,
				"type": "EVENT"
			},
			{
				"name": "conference",
				"salience": 0.042100135,
				"type": "EVENT"
			},
			{
				"name": "telephone",
				"salience": 0.042100135,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0366104,
				"type": "PERSON"
			},
			{
				"name": "servers",
				"salience": 0.030183017,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.028409926,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0jgd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Argentina"
				},
				"name": "Argentinian",
				"salience": 0.026091708,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.02168672,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.021387823,
				"type": "EVENT"
			},
			{
				"name": "pro-Hillary",
				"salience": 0.0133941,
				"type": "LOCATION"
			},
			{
				"name": "servers",
				"salience": 0.012515864,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.010441763,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.009355848,
				"type": "ORGANIZATION"
			},
			{
				"name": "nest atmosphere",
				"salience": 0.008972963,
				"type": "OTHER"
			},
			{
				"name": "hornet",
				"salience": 0.008972963,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.008972963,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state documents",
				"salience": 0.0077100736,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chance",
				"salience": 0.0076131984,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0068806265,
				"type": "OTHER"
			},
			{
				"name": "Podesta",
				"salience": 0.0066064848,
				"type": "PERSON"
			},
			{
				"name": "pedophile",
				"salience": 0.0062975287,
				"type": "OTHER"
			},
			{
				"name": "spy",
				"salience": 0.0062975287,
				"type": "PERSON"
			},
			{
				"name": "hacking attacks",
				"salience": 0.006062968,
				"type": "EVENT"
			},
			{
				"name": "courts",
				"salience": 0.006062968,
				"type": "LOCATION"
			},
			{
				"name": "election result",
				"salience": 0.0051431884,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0049515297,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0049145673,
				"type": "EVENT"
			},
			{
				"name": "bombshell",
				"salience": 0.0042000497,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6gkfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream_media"
				},
				"name": "MSM",
				"salience": 0.0038793848,
				"type": "ORGANIZATION"
			},
			{
				"name": "difference",
				"salience": 0.0037953577,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0037347442,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0037347442,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0037347442,
				"type": "LOCATION"
			},
			{
				"name": "pressure",
				"salience": 0.0028003075,
				"type": "OTHER"
			},
			{
				"name": "talks",
				"salience": 0.0028003075,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0027650474,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.002675708,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.0025216595,
				"type": "ORGANIZATION"
			},
			{
				"name": "most",
				"salience": 0.0024052637,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.0020922518,
				"type": "OTHER"
			},
			{
				"name": "media organizations",
				"salience": 0.0020922518,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02k1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ecuador"
				},
				"name": "Ecuador",
				"salience": 0.0017240219,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0012879507,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:12.283+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link So this is from an Argentinian conference Assange spoke with via telephone. He states Hillary campaign (or pro-Hillary government) attempted to attack Wikileaks servers. Assange claimed the release “whipped up a crazed hornet’s nest atmosphere in the Hillary Clinton campaign” leading them to attack WikiLeaks. “They attacked our servers and attempted hacking attacks and there is an amazing ongoing campaign where state documents were put in the UN and British courts to accuse me of being both a Russian spy and a pedophile,” he added. He also added that he does not think the Podesta emails will have an impact, adding the influence of MSM pushing Hillary. The Podesta emails will make no difference to the election result, according to Assange. “I don’t think there’s any chance of Donald Trump winning the election, even with the amazing material we are publishing, because most of the media organizations are strongly aligned with Hillary Clinton,” he said. sorry this is RT, but many won't cover this Interesting considering he implied he would have a bombshell before the election. This whole situation is so hard to read, with talks of Wikileaks being compromised, or pressure on to Ecuador trickling down to Assange. Just thought I'd share.",
		"thread_title": "Assange - Hillary will win and tried to hack Wikileaks",
		"title": "Assange - Hillary will win and tried to hack Wikileaks",
		"type": "bs",
		"uuid": "2fc939186376c9fc90cda08707b212bada66fb9f"
	},
	"-KhIaA2eY98LfcbzYxqk": {
		"author": "Violater1",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:18.062+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "google",
				"salience": 0.21183136,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.16412559,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.13041264,
				"type": "OTHER"
			},
			{
				"name": "www.abovetopsecret.com",
				"salience": 0.10764398,
				"type": "OTHER"
			},
			{
				"name": "purse",
				"salience": 0.031457957,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.021433553,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.020772351,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.018754812,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.018627673,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.016731542,
				"type": "WORK_OF_ART"
			},
			{
				"name": "page",
				"salience": 0.016142529,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.015347911,
				"type": "OTHER"
			},
			{
				"name": "gun control",
				"salience": 0.010178219,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.009954396,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.0099071935,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hillary",
				"salience": 0.0073508713,
				"type": "PERSON"
			},
			{
				"name": "news story",
				"salience": 0.0069519933,
				"type": "WORK_OF_ART"
			},
			{
				"name": "site",
				"salience": 0.0066631124,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0066631124,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.0057852142,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.0056772637,
				"type": "OTHER"
			},
			{
				"name": "trump",
				"salience": 0.0053968565,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0051992885,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.005195662,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.005195662,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.005195662,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.0049169674,
				"type": "OTHER"
			},
			{
				"name": "drudge",
				"salience": 0.004674053,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.004674053,
				"type": "EVENT"
			},
			{
				"name": "doubt",
				"salience": 0.004674053,
				"type": "OTHER"
			},
			{
				"name": "bush",
				"salience": 0.0044997633,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0044997633,
				"type": "PERSON"
			},
			{
				"name": "kinda",
				"salience": 0.0044997633,
				"type": "OTHER"
			},
			{
				"name": "magazines",
				"salience": 0.0044997633,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reply",
				"salience": 0.0044068545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "POTUS",
				"salience": 0.004103792,
				"type": "ORGANIZATION"
			},
			{
				"name": "goal",
				"salience": 0.0040148767,
				"type": "OTHER"
			},
			{
				"name": "feeling",
				"salience": 0.0039144186,
				"type": "OTHER"
			},
			{
				"name": "vid",
				"salience": 0.003816471,
				"type": "WORK_OF_ART"
			},
			{
				"name": "errors",
				"salience": 0.003816471,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.003816471,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.003816471,
				"type": "PERSON"
			},
			{
				"name": "demolition",
				"salience": 0.003627858,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02cxcd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google_News"
				},
				"name": "google news",
				"salience": 0.0033233617,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0032928032,
				"type": "OTHER"
			},
			{
				"name": "ChicagoThu",
				"salience": 0.0028779919,
				"type": "OTHER"
			},
			{
				"name": "511031America",
				"salience": 0.0028779919,
				"type": "OTHER"
			},
			{
				"name": "stake",
				"salience": 0.0028515246,
				"type": "OTHER"
			},
			{
				"name": "ball",
				"salience": 0.0028515246,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.0027706125,
				"type": "ORGANIZATION"
			},
			{
				"name": "Violater1",
				"salience": 0.0027706125,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "hollywood",
				"salience": 0.0027706125,
				"type": "LOCATION"
			},
			{
				"name": "class",
				"salience": 0.0026211215,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0023985617,
				"type": "OTHER"
			},
			{
				"name": "storys",
				"salience": 0.0023985617,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.002077039,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.002077039,
				"type": "ORGANIZATION"
			},
			{
				"name": "identity",
				"salience": 0.002077039,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0020508724,
				"type": "OTHER"
			},
			{
				"name": "freedom fighters",
				"salience": 0.0018767018,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0017918986,
				"type": "PERSON"
			},
			{
				"name": "socialism",
				"salience": 0.0017614202,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0016956768,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0015871923,
				"type": "ORGANIZATION"
			},
			{
				"name": "crowd",
				"salience": 0.0015516555,
				"type": "PERSON"
			},
			{
				"name": "bunch",
				"salience": 0.0015516555,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.0012040635,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0011591148,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "american",
				"salience": 0.00095502596,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/023k2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Corporation"
				},
				"name": "Corporations",
				"salience": 0.00095502596,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Obamacare",
				"salience": 0.00095502596,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats6.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:18.062+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Is google and YouTube in the Hillary’s purse? page: 1 link After I posted my opening post (OP) on “Hillary Clinton Wants a Strong Russia. Wait, what did she say?” , mysteriously, my YouTube account gets wiped out. The next thing I notice, is that the youtube video that I used in my OP, www.abovetopsecret.com... suddenly won’t work. Has anyone else experienced this bizarre behavior before? Is this what we are to expect if Hillary becomes POTUS? I went to the Youtube site and the video is available. www.youtube.com... I frankly, don't know what to think about this. link a reply to: Violater1 yes, so is almost all the major media, magazines (that are left), most of hollywood, GOP kinda, most of the bush's. Who else? Google is pro clinton like drudge is pro trump without a doubt Just about every news story under google news is pro hillary and negative towards trump. If I recall correctly they even advice her campaign edit on 511031America/ChicagoThu, 27 Oct 2016 21:51:09 -05 p3142 by interupt42 because: (no reason given) Is the dead link the same as the good one in the following reply? Same vid#? No errors? link I'm getting the feeling that the gun control,Hillary as dictator,is not unlike Obamacare,forced on us,this is socialism and being the Corporations own the candidates,they want this we have no choice,they have the UN,plus a bunch of immigrants to join the UN forces to attack the american freedom fighters,you may think I'm crazy but they said I was crazy when I said 9/11 was a controlled demolition,look at the past,put common sense to it,the big ball is rolling,too much money at stake here thats the goal rich get richer,no more middle class,upper middle class,those making like 1 or 2 million a year,will be joining the crowd,unless your a member of the party,Known many an immigrant who lived under communist rule,all storys kind of same,all bad,no sense of identity",
		"thread_title": "Is google and YouTube in the Hillary's purse?",
		"title": "Is google and YouTube in the Hillary's purse?",
		"type": "bs",
		"uuid": "95326a4ff163ca27f2185f6450b56e1e5c0abb4f"
	},
	"-KhIaAC64e6PWugOVWkF": {
		"author": "carewemust",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:18.127+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.3268314,
				"type": "PERSON"
			},
			{
				"name": "disgrace",
				"salience": 0.19159469,
				"type": "OTHER"
			},
			{
				"name": "media people",
				"salience": 0.09494662,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qry6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wolf_Blitzer"
				},
				"name": "Wolf Blitzer",
				"salience": 0.03445286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027j7l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Stephanopoulos"
				},
				"name": "George Stephanopoulos",
				"salience": 0.03445286,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.031440984,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.024108667,
				"type": "ORGANIZATION"
			},
			{
				"name": "al.",
				"salience": 0.023154696,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.023154696,
				"type": "PERSON"
			},
			{
				"name": "viewers",
				"salience": 0.023154696,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.021473931,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/075dqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_King_(journalist)"
				},
				"name": "John King",
				"salience": 0.014305867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02s2l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonian_language"
				},
				"name": "Et",
				"salience": 0.014305867,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00834171,
				"type": "OTHER"
			},
			{
				"name": "List",
				"salience": 0.0080313105,
				"type": "OTHER"
			},
			{
				"name": "Journalists",
				"salience": 0.0080313105,
				"type": "PERSON"
			},
			{
				"name": "news channels",
				"salience": 0.0076352744,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.006813919,
				"type": "PERSON"
			},
			{
				"name": "curtain",
				"salience": 0.006813919,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.006813919,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Newspapers",
				"salience": 0.0058803987,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02kh4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Injury"
				},
				"name": "HURT",
				"salience": 0.0051406086,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0051406086,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0051406086,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0049490575,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.0049490575,
				"type": "ORGANIZATION"
			},
			{
				"name": "Story w",
				"salience": 0.0049490575,
				"type": "OTHER"
			},
			{
				"name": "thefreethoughtproject.com",
				"salience": 0.0049490575,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0048419167,
				"type": "OTHER"
			},
			{
				"name": "thanks",
				"salience": 0.004781007,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0044312757,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.004197991,
				"type": "ORGANIZATION"
			},
			{
				"name": "Podesta",
				"salience": 0.004197991,
				"type": "PERSON"
			},
			{
				"name": "slant",
				"salience": 0.0037113489,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "reldra",
				"salience": 0.0037113489,
				"type": "PERSON"
			},
			{
				"name": "CareWeMust Those",
				"salience": 0.0031370586,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0031370586,
				"type": "PERSON"
			},
			{
				"name": "companies",
				"salience": 0.0027732488,
				"type": "ORGANIZATION"
			},
			{
				"name": "knees",
				"salience": 0.0027732488,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0027732488,
				"type": "ORGANIZATION"
			},
			{
				"name": "leverage",
				"salience": 0.0027732488,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00180237,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats17.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:18.127+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "originally posted by: carewemust October 27, 2016 It's a disgrace that such prominent media people, like Wolf Blitzer, George Stephanopoulos, John King, Et al., are willing to go before millions of viewers, and shamelessly report what Hillary's campaign tells them to report. Story w/List of 65 Corrupt Journalists: thefreethoughtproject.com... It's always been obvious that CNN-MSNBC-NBC-ABC in particular, go out of their way to HELP Hillary Clinton and HURT Donald Trump. Now, thanks to the Podesta e-mails provided by WikiLeaks, we can see \"behind the curtain\". If mentally imbalanced Hillary becomes President, imagine the leverage she will have, to bring groups, organizations, companies, and people to their knees, if she doesn't like them! -CareWeMust Those news channels have always been Democrat. Newspapers over 100 years have picked a side and given a slant. You just notice this now? edit on 27-10-2016 by reldra because: (no reason given)",
		"thread_title": "MEDIA SHAME - These 65 Journalists are Now Presstitutes. Their Madam is Hillary Clinton.",
		"title": "MEDIA SHAME - These 65 Journalists are Now Presstitutes. Their Madam is Hillary Clinton.",
		"type": "bs",
		"uuid": "b7e15736ee03db55ed797b6f3d72e899615187b9"
	},
	"-KhIaAKEoVSJgsaNep3S": {
		"author": "reldra",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:18.183+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.55456656,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01kyln",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LaGuardia_Airport"
				},
				"name": "LaGuardia",
				"salience": 0.088869736,
				"type": "LOCATION"
			},
			{
				"name": "page",
				"salience": 0.075393796,
				"type": "OTHER"
			},
			{
				"name": "Plane Slides off Runway",
				"salience": 0.054503404,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign plane",
				"salience": 0.04081022,
				"type": "OTHER"
			},
			{
				"name": "runway",
				"salience": 0.04081022,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.037642814,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Campaign plane",
				"salience": 0.030157492,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.016601345,
				"type": "OTHER"
			},
			{
				"name": "runway",
				"salience": 0.014906671,
				"type": "OTHER"
			},
			{
				"name": "reldra",
				"salience": 0.0110195065,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.007842837,
				"type": "OTHER"
			},
			{
				"name": "reldra",
				"salience": 0.006017057,
				"type": "PERSON"
			},
			{
				"name": "LaGuardia Airport Watch",
				"salience": 0.0058949073,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "facebook",
				"salience": 0.0058949073,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0051707323,
				"type": "OTHER"
			},
			{
				"name": "fundraiser",
				"salience": 0.0038978062,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:18.183+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Mike Pence's Plane Slides off Runway at LaGuardia page: 1 Mike Pence's campaign plane has slid off a runway at LaGuardia. No injuries have been reported at this time. This is a developing story. Campaign plane carrying Gov Mike Pence skids off runway while landing at LaGuardia Airport Watch on facebook edit on 27-10-2016 by reldra because: (no reason given) he was going to a fundraiser and it appears he is not going anymore. edit on 27-10-2016 by reldra because: (no reason given)",
		"thread_title": "Mike Pences Plane Slides off Runway at LaGuardia",
		"title": "Mike Pences Plane Slides off Runway at LaGuardia",
		"type": "bs",
		"uuid": "efd145a647477cec66123e7f3ee38a2a8b91836e"
	},
	"-KhIaAbERAHZXhacJ0cp": {
		"author": "queenofswords",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:20.683+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.3159384,
				"type": "PERSON"
			},
			{
				"name": "Everyone",
				"salience": 0.079014726,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.05406779,
				"type": "PERSON"
			},
			{
				"name": "witness",
				"salience": 0.0382104,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.02930989,
				"type": "ORGANIZATION"
			},
			{
				"name": "link",
				"salience": 0.023580732,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mzbj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Air_Lines"
				},
				"name": "Eastern Air Lines",
				"salience": 0.022221128,
				"type": "ORGANIZATION"
			},
			{
				"name": "plane",
				"salience": 0.021936959,
				"type": "OTHER"
			},
			{
				"name": "runway",
				"salience": 0.021936959,
				"type": "LOCATION"
			},
			{
				"name": "runway",
				"salience": 0.021936959,
				"type": "LOCATION"
			},
			{
				"name": "plane",
				"salience": 0.021936959,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01kyln",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LaGuardia_Airport"
				},
				"name": "La Guardia Airport",
				"salience": 0.021107139,
				"type": "LOCATION"
			},
			{
				"name": "Vice",
				"salience": 0.018009128,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.01409952,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.009982162,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.009224105,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ccvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Queens"
				},
				"name": "Queens",
				"salience": 0.00869421,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hcxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WABC-TV"
				},
				"name": "WABC",
				"salience": 0.00869421,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01sn04",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jamaica,_Queens"
				},
				"name": "JAMAICA",
				"salience": 0.00869421,
				"type": "LOCATION"
			},
			{
				"name": "emergency landing",
				"salience": 0.0072163893,
				"type": "EVENT"
			},
			{
				"name": "mishap",
				"salience": 0.0072163893,
				"type": "EVENT"
			},
			{
				"name": "producer",
				"salience": 0.0064266305,
				"type": "PERSON"
			},
			{
				"name": "producer",
				"salience": 0.0064266305,
				"type": "PERSON"
			},
			{
				"name": "runway",
				"salience": 0.0063648513,
				"type": "LOCATION"
			},
			{
				"name": "runway",
				"salience": 0.0063648513,
				"type": "LOCATION"
			},
			{
				"name": "cars",
				"salience": 0.006240559,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "witness",
				"salience": 0.006055715,
				"type": "PERSON"
			},
			{
				"name": "witness",
				"salience": 0.006055715,
				"type": "PERSON"
			},
			{
				"name": "Details",
				"salience": 0.0053027943,
				"type": "OTHER"
			},
			{
				"name": "@ABC7NY pic.twitter.com/e4PtrsQDeo",
				"salience": 0.005132742,
				"type": "PERSON"
			},
			{
				"name": "@itsmeJilani",
				"salience": 0.005132742,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01l4zv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bob_Hope_Airport"
				},
				"name": "Burbank airport",
				"salience": 0.004665624,
				"type": "LOCATION"
			},
			{
				"name": "Details",
				"salience": 0.004116267,
				"type": "OTHER"
			},
			{
				"name": "Details",
				"salience": 0.004116267,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cjdk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_Broadcasting_Company"
				},
				"name": "Fox",
				"salience": 0.0038699848,
				"type": "ORGANIZATION"
			},
			{
				"name": "everybody",
				"salience": 0.0037195478,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0035808282,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0035808282,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.0033610153,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.003346173,
				"type": "ORGANIZATION"
			},
			{
				"name": "Eastern 737",
				"salience": 0.0032587068,
				"type": "OTHER"
			},
			{
				"name": "plane",
				"salience": 0.0032529668,
				"type": "OTHER"
			},
			{
				"name": "flights",
				"salience": 0.0031030145,
				"type": "EVENT"
			},
			{
				"name": "In4ormant",
				"salience": 0.003082942,
				"type": "ORGANIZATION"
			},
			{
				"name": "everybody",
				"salience": 0.0030370024,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0029935592,
				"type": "PERSON"
			},
			{
				"name": "airport",
				"salience": 0.0029036975,
				"type": "LOCATION"
			},
			{
				"name": "airport",
				"salience": 0.0029036975,
				"type": "LOCATION"
			},
			{
				"name": "no one",
				"salience": 0.0028868916,
				"type": "PERSON"
			},
			{
				"name": "no one",
				"salience": 0.002779193,
				"type": "PERSON"
			},
			{
				"name": "plane",
				"salience": 0.0026559536,
				"type": "OTHER"
			},
			{
				"name": "runway",
				"salience": 0.0026559536,
				"type": "OTHER"
			},
			{
				"name": "Sounds",
				"salience": 0.002408249,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.002408249,
				"type": "OTHER"
			},
			{
				"name": "In4ormant",
				"salience": 0.0023714155,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.0023570037,
				"type": "OTHER"
			},
			{
				"name": "plane",
				"salience": 0.0023397752,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0023183909,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0023183909,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0023183909,
				"type": "OTHER"
			},
			{
				"name": "Nicholas Loudon",
				"salience": 0.0023130125,
				"type": "PERSON"
			},
			{
				"name": "revenue flight",
				"salience": 0.0022318827,
				"type": "OTHER"
			},
			{
				"name": "teh tremors",
				"salience": 0.0021939296,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0021775304,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.0021775304,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01jg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Board_of_directors"
				},
				"name": "Board",
				"salience": 0.0021619292,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0020983862,
				"type": "ORGANIZATION"
			},
			{
				"name": "fundraiser",
				"salience": 0.0020076337,
				"type": "EVENT"
			},
			{
				"name": "action",
				"salience": 0.0020076337,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0020076337,
				"type": "OTHER"
			},
			{
				"name": "beer",
				"salience": 0.0020076337,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "layout",
				"salience": 0.0019946336,
				"type": "OTHER"
			},
			{
				"name": "traffic",
				"salience": 0.0019661502,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.0019661502,
				"type": "OTHER"
			},
			{
				"name": "fence",
				"salience": 0.0019661502,
				"type": "OTHER"
			},
			{
				"name": "blvd",
				"salience": 0.0019661502,
				"type": "LOCATION"
			},
			{
				"name": "Sounds",
				"salience": 0.0019661502,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0019661502,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.0018843239,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0017608893,
				"type": "PERSON"
			},
			{
				"name": "blvd",
				"salience": 0.0017208192,
				"type": "LOCATION"
			},
			{
				"name": "Aviation enthusiasts",
				"salience": 0.0016811265,
				"type": "PERSON"
			},
			{
				"name": "vice",
				"salience": 0.0016267789,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04lyk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_International_Airport"
				},
				"name": "los angeles",
				"salience": 0.0015936584,
				"type": "LOCATION"
			},
			{
				"name": "airports",
				"salience": 0.0015801447,
				"type": "LOCATION"
			},
			{
				"name": "aircraft",
				"salience": 0.0014688323,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0012825218,
				"type": "PERSON"
			},
			{
				"name": "start-up carrier",
				"salience": 0.0012718949,
				"type": "ORGANIZATION"
			},
			{
				"name": "logo",
				"salience": 0.0012718949,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0012718949,
				"type": "OTHER"
			},
			{
				"name": "campaign stops",
				"salience": 0.0012718949,
				"type": "LOCATION"
			},
			{
				"name": "shuttle",
				"salience": 0.0012718949,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.0012718949,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0012718949,
				"type": "OTHER"
			},
			{
				"name": "jet",
				"salience": 0.0012718949,
				"type": "OTHER"
			},
			{
				"name": "comfort",
				"salience": 0.0012718949,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0011905159,
				"type": "LOCATION"
			},
			{
				"name": "runway",
				"salience": 0.0010796455,
				"type": "OTHER"
			},
			{
				"name": "charter",
				"salience": 0.0010697735,
				"type": "OTHER"
			},
			{
				"name": "vice president",
				"salience": 0.0010697735,
				"type": "PERSON"
			},
			{
				"name": "aircraft",
				"salience": 0.0010697735,
				"type": "OTHER"
			},
			{
				"name": "BASSPLYR",
				"salience": 0.0010479654,
				"type": "OTHER"
			},
			{
				"name": "plane",
				"salience": 0.00095105125,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0009263221,
				"type": "OTHER"
			},
			{
				"name": "passengers",
				"salience": 0.0009263221,
				"type": "PERSON"
			},
			{
				"name": "incarnation",
				"salience": 0.0009263221,
				"type": "OTHER"
			},
			{
				"name": "destinations",
				"salience": 0.0009263221,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.0009263221,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.0008670464,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0yt9j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami_International_Airport"
				},
				"name": "Miami",
				"salience": 0.00080351456,
				"type": "LOCATION"
			},
			{
				"name": "traffic",
				"salience": 0.0007991163,
				"type": "OTHER"
			},
			{
				"name": "fence",
				"salience": 0.0007991163,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.0007991163,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0007991163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0137k8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing_737"
				},
				"name": "Boeing 737",
				"salience": 0.00078282406,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00075619284,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0006919492,
				"type": "LOCATION"
			},
			{
				"name": "stone",
				"salience": 0.0006919492,
				"type": "OTHER"
			},
			{
				"name": "strip",
				"salience": 0.0006919492,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0006919492,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0006919492,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0005942541,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01bqvp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sky"
				},
				"name": "Sky",
				"salience": 0.0005701027,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6hn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Havana"
				},
				"name": "Havana",
				"salience": 0.0005701027,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0261m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caribbean"
				},
				"name": "Caribbean",
				"salience": 0.0005701027,
				"type": "LOCATION"
			},
			{
				"name": "god",
				"salience": 0.0005301444,
				"type": "PERSON"
			},
			{
				"name": "Evil Hillary",
				"salience": 0.0004258439,
				"type": "OTHER"
			},
			{
				"name": "charter services",
				"salience": 0.00029956366,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:20.683+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "GOP VP candidate Mike Pence's plane skids off runway at LaGuardia airport page: 1 JAMAICA, Queens (WABC) -- Republican Vice Presidential Candidate Mike Pence's plane skidded off the runway at LaGuardia Airport on Thursday night. It happened just before 8 p.m. Everyone on board is reportedly ok. Just witnessed an emergency landing at La Guardia Airport. Hope everyone's safe. @ABC7NY pic.twitter.com/e4PtrsQDeo — Xpl0iter (@itsmeJilani) October 27, 2016 It's not yet known what led to the mishap. Scary! No details as to what happened yet. CNN reporting that a witness from 27 years ago has come forward stating Trump told her he was going to kill Pence one day. Details forthcoming link originally posted by: In4ormant CNN reporting that a witness from 27 years ago has come forward stating Trump told her he was going to kill Pence one day. Details forthcoming link originally posted by: In4ormant CNN reporting that a witness from 27 years ago has come forward stating Trump told her he was going to kill Pence one day. Details forthcoming The witness wishes to stay anonymous and does not seek legal action. They just thought this is a good time to bring it up. link a reply to: xuenchen The onl thing to add is that he was on his to a fundraiser that he will no longer attend. link a reply to: In4ormant yea it definitely has been eyes are re, and i need a beer so i dont get teh tremors... anyway glad everyones ok I'm sure that there are those that are disappointed that no one was hurt. hate to be the one to say it, but it's true. I'm sure that there are those that are disappointed that no one was hurt. hate to be the one to say it, but it's true. Good god, why would you say that? Fox had a producer on Board, and he is saying everybody is ok (were about 45 people on the plane). Sounds like a real close call! link originally posted by: mobiusmale Fox had a producer on Board, and he is saying everybody is ok (were about 45 people on the plane). Sounds like a real close call! Good link This happens several times a year at that airport. They built the runway too short. Burbank airport in los angeles had a plane go off the runway. Through a fence and hit a bunch of cars in traffic on a major blvd several years ago originally posted by: BASSPLYR This happens several times a year at that airport. They built the runway too short. Burbank airport in los angeles had a plane go off the runway. Through a fence and hit a bunch of cars in traffic on a major blvd several years ago I could never stand landing there. They make you fly so high above the city and then drop you like a stone on to a short strip. I would rather parachute In. link I worry about this sort of thing happening to Donald Trump as we get closer to the election, and he keeps gaining on Evil Hillary. I have no doubt that the U.S. government would sabotage some part of Trump's jet, if he gets too close for comfort. link There’s a retro look to the aircraft flying Republican vice presidential candidate Mike Pence. Aviation enthusiasts may recognize the Eastern Air Lines paint scheme on the Boeing 737-700 picked to shuttle Pence, Donald Trump's running mate, between campaign stops. ... That’s because the old Eastern name and logo has been resurrected by a new Miami-based start-up carrier. The “new\" Eastern made its first revenue flight in 2015 on a charter from Miami to Havana, Cuba. Eastern spokesman Nicholas Loudon confirmed to Today in the Sky it is an Eastern 737 that's flying the Republican candidate for vice president. The aircraft is configured in an all-business class layout that can seat 62 passengers. As for the current incarnation of Eastern, the company has said it intends to eventually launch regularly scheduled flights from U.S. airports. For now, however, the airline is focused on operating charter services to Cuba and destinations in the Caribbean region.",
		"thread_title": "GOP VP candidate Mike Pences plane skids off runway at LaGuardia airport",
		"title": "GOP VP candidate Mike Pences plane skids off runway at LaGuardia airport",
		"type": "bs",
		"uuid": "8ccd3168d4f816d6c885567750a827625877a57c"
	},
	"-KhIaAisCP-CwaBrhkD8": {
		"author": "JinMI",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:21.454+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "Ammon Bundy",
				"salience": 0.3277743,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.07167486,
				"type": "OTHER"
			},
			{
				"name": "court jury",
				"salience": 0.07167486,
				"type": "PERSON"
			},
			{
				"name": "followers",
				"salience": 0.063749805,
				"type": "PERSON"
			},
			{
				"name": "Oregon Standoff Leaders Acquitted For Malheur Wildlife Refuge Takeover",
				"salience": 0.05139745,
				"type": "ORGANIZATION"
			},
			{
				"name": "news",
				"salience": 0.038206335,
				"type": "OTHER"
			},
			{
				"name": "militant leader",
				"salience": 0.03461879,
				"type": "ORGANIZATION"
			},
			{
				"name": "takeover",
				"salience": 0.03461879,
				"type": "EVENT"
			},
			{
				"name": "Ryan Bundy",
				"salience": 0.03302281,
				"type": "PERSON"
			},
			{
				"name": "conspiracy charges",
				"salience": 0.030034918,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.030034918,
				"type": "OTHER"
			},
			{
				"name": "wildlife center",
				"salience": 0.020353947,
				"type": "LOCATION"
			},
			{
				"name": "event",
				"salience": 0.018286712,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.014502246,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.012567394,
				"type": "LOCATION"
			},
			{
				"name": "guys",
				"salience": 0.010904834,
				"type": "PERSON"
			},
			{
				"name": "act",
				"salience": 0.010837901,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.010837901,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.010434971,
				"type": "PERSON"
			},
			{
				"name": "Prosecutors",
				"salience": 0.009081066,
				"type": "PERSON"
			},
			{
				"name": "precedent",
				"salience": 0.008967024,
				"type": "OTHER"
			},
			{
				"name": "civil disobedience",
				"salience": 0.00885441,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.00885441,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00885441,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00885441,
				"type": "OTHER"
			},
			{
				"name": "Malheur National Wildlife Refuge",
				"salience": 0.0077128843,
				"type": "LOCATION"
			},
			{
				"name": "likelihood",
				"salience": 0.006619906,
				"type": "OTHER"
			},
			{
				"name": "Justice",
				"salience": 0.005982633,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.004824383,
				"type": "WORK_OF_ART"
			},
			{
				"name": "climate",
				"salience": 0.004824383,
				"type": "OTHER"
			},
			{
				"name": "fashion",
				"salience": 0.004824383,
				"type": "OTHER"
			},
			{
				"name": "Someone",
				"salience": 0.004586137,
				"type": "PERSON"
			},
			{
				"name": "brother",
				"salience": 0.0044151903,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0036053166,
				"type": "OTHER"
			},
			{
				"name": "gal",
				"salience": 0.0036053166,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats15.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:21.454+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Oregon Standoff Leaders Acquitted For Malheur Wildlife Refuge Takeover page: 1 link A federal court jury on Wednesday acquitted anti-government militant leader Ammon Bundy and six followers of conspiracy charges stemming from their role in the armed takeover of a U.S. wildlife center in Oregon earlier this year. Bundy and others, including his brother and co-defendant Ryan Bundy, cast the 41-day occupation of the Malheur National Wildlife Refuge as a legitimate and patriotic act of civil disobedience. Prosecutors called it a lawless scheme to seize federal property by force. This is news! I surely did not expect these guys n gal to get off. Someone lost their life during this event which is sad. Justice has spoken. Does this set a precedent going forward? The likelihood of this happening again in a similar fashion seems high given the current political climate. A more detailed article.",
		"thread_title": "Oregon Standoff Leaders Acquitted For Malheur Wildlife Refuge Takeover",
		"title": "Oregon Standoff Leaders Acquitted For Malheur Wildlife Refuge Takeover",
		"type": "bs",
		"uuid": "5fccb20a0257e0d9fd1e1df51d43352f73288fdd"
	},
	"-KhIaAtzw1YsYCVosbtU": {
		"author": "burdman30ott6",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:23.266+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.63707334,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.04395987,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.02472925,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.020994505,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.019420953,
				"type": "OTHER"
			},
			{
				"name": "offshoot thread",
				"salience": 0.017562432,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.017562432,
				"type": "OTHER"
			},
			{
				"name": "threads",
				"salience": 0.017562432,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.015237056,
				"type": "PERSON"
			},
			{
				"name": "defense page",
				"salience": 0.015237056,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.015237056,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0052816053,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0052816053,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0052816053,
				"type": "PERSON"
			},
			{
				"name": "official",
				"salience": 0.004897599,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0266lb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Cameron"
				},
				"name": "David Cameron",
				"salience": 0.004828395,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.004472553,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.004472553,
				"type": "LOCATION"
			},
			{
				"name": "response",
				"salience": 0.004472553,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.004472553,
				"type": "LOCATION"
			},
			{
				"name": "response",
				"salience": 0.004472553,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0042331475,
				"type": "PERSON"
			},
			{
				"name": "concerns",
				"salience": 0.004132907,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0037326855,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.0037074315,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0036594288,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0033768648,
				"type": "LOCATION"
			},
			{
				"name": "narrative",
				"salience": 0.0032500888,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.0032333499,
				"type": "OTHER"
			},
			{
				"name": "contingents",
				"salience": 0.0032333499,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0032333499,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0031388702,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.003066638,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0030219485,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0029755253,
				"type": "LOCATION"
			},
			{
				"name": "incursions",
				"salience": 0.0028131949,
				"type": "EVENT"
			},
			{
				"name": "narrative",
				"salience": 0.0027921991,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0026191333,
				"type": "LOCATION"
			},
			{
				"name": "military actions",
				"salience": 0.0026191333,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukrainian",
				"salience": 0.0024300087,
				"type": "LOCATION"
			},
			{
				"name": "invasion",
				"salience": 0.0023863253,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.002268474,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.002268474,
				"type": "PERSON"
			},
			{
				"name": "army officer",
				"salience": 0.002193699,
				"type": "PERSON"
			},
			{
				"name": "passage",
				"salience": 0.002183914,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "Marines",
				"salience": 0.0019917923,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighbor",
				"salience": 0.0018523799,
				"type": "PERSON"
			},
			{
				"name": "sovereignty",
				"salience": 0.0018523799,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0018523799,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.0015982727,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0014586248,
				"type": "LOCATION"
			},
			{
				"name": "South Eastern Ukraine",
				"salience": 0.0014586248,
				"type": "LOCATION"
			},
			{
				"name": "scorpion",
				"salience": 0.0014017802,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0014017802,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07lz5p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russophilia"
				},
				"name": "pro-Russian",
				"salience": 0.0013969735,
				"type": "LOCATION"
			},
			{
				"name": "cause",
				"salience": 0.001384129,
				"type": "OTHER"
			},
			{
				"name": "exercises",
				"salience": 0.001384129,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.001384129,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.001384129,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.001315717,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0012894401,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0011300896,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0010127744,
				"type": "OTHER"
			},
			{
				"name": "snake coils",
				"salience": 0.0010082524,
				"type": "OTHER"
			},
			{
				"name": "tail",
				"salience": 0.0010082524,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0009633745,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.000869856,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ndwhc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimea"
				},
				"name": "Crimea",
				"salience": 0.00085212913,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00085212913,
				"type": "LOCATION"
			},
			{
				"name": "evil",
				"salience": 0.0007532463,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0007532463,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0006892737,
				"type": "PERSON"
			},
			{
				"name": "burdman30ott6",
				"salience": 0.00062064716,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats14.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:23.266+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "To anyone relying on the \"not enough troops to indicate concern\" defense page: 1 link This is something of an offshoot thread, but it is in response to something I have seen posted in multiple threads of late. In response to concerns over the US sending 300+ Marines to the Russian border, in response to the UK sending 800 troops to the Russian border, in response to all the NATO countries sending small contingents of troops and equipment to the Russian borders we've heard one narrative consistently: \"Oh, that's not enough troops to indicate there's anything serious happening.\" My how 2 year's passage of time has changed the narrative. A top Ukrainian army officer said a \"full-scale invasion\" of his country was under way Thursday, as a U.S. official said up to 1,000 Russian troops had crossed Ukraine's southern border to fight alongside pro-Russian rebels. Russia's military actions in eastern Ukraine \"must cease immediately,\" British Prime Minister David Cameron said Thursday. \"I'm extremely concerned by mounting evidence that Russian troops have made large-scale incursions into South Eastern Ukraine, completely disregarding the sovereignty of a neighbor,\" Cameron said. \"The international community has already warned Russia that such provocative actions would be completely unacceptable and illegal.\" Yet another example of the west's never ending \"NATO good, Russia evil\" narrative. When Russia involves 1,000 troops in assisting a region which requested their help (Crimea, or more recently Syria) the western leaders come unglued... but when the west does the same, it's \"exercises\" and \"no cause for any concern.\" When a snake coils, it intends to strike and when a scorpion raises it's tail it is preparing to sting. edit on 27-10-2016 by burdman30ott6 because: (no reason given)",
		"thread_title": "To anyone relying on the not enough troops to indicate concern defense",
		"title": "To anyone relying on the not enough troops to indicate concern defense",
		"type": "bs",
		"uuid": "1272ae8f77556a0b90d0ca088db19ee7ff2d13f5"
	},
	"-KhIaB20DBEha5KguiTf": {
		"author": "whyamIhere",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:24.865+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.55457515,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.08450643,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.05546878,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.048161138,
				"type": "PERSON"
			},
			{
				"name": "answer",
				"salience": 0.024802392,
				"type": "OTHER"
			},
			{
				"name": "finder",
				"salience": 0.024802392,
				"type": "OTHER"
			},
			{
				"name": "billionaire",
				"salience": 0.016176127,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.014583501,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.012937596,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.011766599,
				"type": "OTHER"
			},
			{
				"name": "Citizen",
				"salience": 0.010260413,
				"type": "PERSON"
			},
			{
				"name": "displeasure",
				"salience": 0.010260413,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.008525955,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.008069236,
				"type": "ORGANIZATION"
			},
			{
				"name": "job",
				"salience": 0.0075746602,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "DC",
				"salience": 0.0073001133,
				"type": "LOCATION"
			},
			{
				"name": "friends",
				"salience": 0.0072008576,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0072008576,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0069326307,
				"type": "OTHER"
			},
			{
				"name": "Bernie",
				"salience": 0.0067410744,
				"type": "PERSON"
			},
			{
				"name": "DC Establishment",
				"salience": 0.00632316,
				"type": "OTHER"
			},
			{
				"name": "Primary",
				"salience": 0.0058808504,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.0058808504,
				"type": "OTHER"
			},
			{
				"name": "crap",
				"salience": 0.0048635886,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.004435714,
				"type": "ORGANIZATION"
			},
			{
				"name": "slave masters",
				"salience": 0.0043949485,
				"type": "PERSON"
			},
			{
				"name": "future",
				"salience": 0.0043949485,
				"type": "OTHER"
			},
			{
				"name": "Country",
				"salience": 0.0043949485,
				"type": "LOCATION"
			},
			{
				"name": "handful",
				"salience": 0.0043949485,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0043949485,
				"type": "PERSON"
			},
			{
				"name": "tool",
				"salience": 0.003697207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.0036219084,
				"type": "ORGANIZATION"
			},
			{
				"name": "ways",
				"salience": 0.0032018453,
				"type": "OTHER"
			},
			{
				"name": "restraints",
				"salience": 0.0032018453,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.0032018453,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.0023922394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04q7gbh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Americans"
				},
				"name": "American People",
				"salience": 0.002005307,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0014726022,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:24.865+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Does anyone like Trump as a person ? The answer in No. It's not about that, it never was. This is about a giant middle finder to the DC Establishment. As a Citizen we only have one way to express our displeasure with DC. We are as divided as I've ever seen. This is not acceptable. If young people can't open businesses we have failed them. They can't. Trump is a tool we need for real change. He blew up the GOP. Our friends on the other side wanted Bernie. But, it was rigged against Bernie. Now you are going to support the very person who rigged your Primary. You almost blew up the DNC, but the job is not complete. We can not hand this crap to our younger generation. We will not. Only a billionaire can get this far on his own. He will be checked by Congress. Join us in giving the middle finger to the slave masters controlling our future. This Country belongs to us. Not a handful of wealthy families. This isn't about Trump. He's a tool in more ways than one. This is about cutting restraints and letting the American People go. At least, that's the way I see it.",
		"thread_title": "This Election is Not About Trump, Its about a Giant Middle Finger to Washington DC.",
		"title": "This Election is Not About Trump, Its about a Giant Middle Finger to Washington DC.",
		"type": "bs",
		"uuid": "c5bf2532e22d222444e63658cd6fed941648ced7"
	},
	"-KhIaB7etBiXzDE7v6Gp": {
		"author": "Profusion",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:25.182+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.45829913,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.18588589,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.043381806,
				"type": "LOCATION"
			},
			{
				"name": "Mark II",
				"salience": 0.041029964,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.038556475,
				"type": "EVENT"
			},
			{
				"name": "leadership",
				"salience": 0.036573358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.02322673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gkh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West"
				},
				"name": "West",
				"salience": 0.014888377,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.014195122,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.013328416,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.012178156,
				"type": "OTHER"
			},
			{
				"name": "world order",
				"salience": 0.011749611,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.009013868,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.009013868,
				"type": "OTHER"
			},
			{
				"name": "encirclement",
				"salience": 0.009013868,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.008828296,
				"type": "WORK_OF_ART"
			},
			{
				"name": "piece",
				"salience": 0.008147428,
				"type": "WORK_OF_ART"
			},
			{
				"name": "approach",
				"salience": 0.007648558,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0073639657,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0072714663,
				"type": "OTHER"
			},
			{
				"name": "counter-arguments",
				"salience": 0.0066013644,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0060917214,
				"type": "OTHER"
			},
			{
				"name": "threads",
				"salience": 0.0057183634,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0054361764,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.004611522,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.004348077,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tensions",
				"salience": 0.0031143208,
				"type": "OTHER"
			},
			{
				"name": "Profusion",
				"salience": 0.002566497,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.0019175856,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:25.182+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.1,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link The simple fact is that this is not a Cold War Mark II - far from it. Russia with its declining economy is nothing like the Soviet Union, which aspired to establish a different world order to that pursued by the capitalist West. Russia is in many ways a weak country. Its leadership has a strong sense of encirclement - a view that the West is only eager to do it down - and, rightly or wrongly, this is driving Mr Putin's more assertive approach. SOURCE The article linked above is the most chilling piece I've read yet concerning the current tensions with Russia. The fact it was published by the BBC doesn't help. The article should put to rest a lot of the counter-arguments in recent WW3 threads. That is not good news. The situation is clearly worse than we're being told. edit on 27-10-2016 by Profusion because: (no reason given)",
		"thread_title": "BBC: Nato sends a message to Russia",
		"title": "BBC: Nato sends a message to Russia",
		"type": "bs",
		"uuid": "4fe5a5d5dd622be6dadb30017a39f758b0871e7c"
	},
	"-KhIaBTjV0zSXKGFIMdE": {
		"author": "thesungod",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:26.896+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0swlncz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laser_Weapon_System"
				},
				"name": "Laser Weapon System",
				"salience": 0.1275853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "United States Navy",
				"salience": 0.1025682,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0lg0r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ponce,_Puerto_Rico"
				},
				"name": "Ponce",
				"salience": 0.0977785,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "U.S. Army",
				"salience": 0.08404264,
				"type": "ORGANIZATION"
			},
			{
				"name": "laser defense systems",
				"salience": 0.05209083,
				"type": "OTHER"
			},
			{
				"name": "LaWS",
				"salience": 0.025094638,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.02486178,
				"type": "OTHER"
			},
			{
				"name": "prototype weapon system",
				"salience": 0.024550831,
				"type": "OTHER"
			},
			{
				"name": "pod",
				"salience": 0.020437686,
				"type": "OTHER"
			},
			{
				"name": "field testing",
				"salience": 0.020153472,
				"type": "EVENT"
			},
			{
				"name": "testbed platform",
				"salience": 0.01584763,
				"type": "OTHER"
			},
			{
				"name": "installation",
				"salience": 0.01577717,
				"type": "OTHER"
			},
			{
				"name": "commander",
				"salience": 0.01577717,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_Martin_F-22_Raptor"
				},
				"name": "Lockheed Martin F-22 Raptor",
				"salience": 0.011107124,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "lasers",
				"salience": 0.010924467,
				"type": "OTHER"
			},
			{
				"name": "weapon.",
				"salience": 0.010639771,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.010148468,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0083863605,
				"type": "OTHER"
			},
			{
				"name": "drones",
				"salience": 0.00832379,
				"type": "OTHER"
			},
			{
				"name": "contract",
				"salience": 0.007722962,
				"type": "OTHER"
			},
			{
				"name": "laser",
				"salience": 0.00761906,
				"type": "OTHER"
			},
			{
				"name": "laser",
				"salience": 0.00761906,
				"type": "OTHER"
			},
			{
				"name": "laser",
				"salience": 0.00761906,
				"type": "OTHER"
			},
			{
				"name": "state laser",
				"salience": 0.00761906,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.007466229,
				"type": "OTHER"
			},
			{
				"name": "laser weapon",
				"salience": 0.007466229,
				"type": "OTHER"
			},
			{
				"name": "laser weapons",
				"salience": 0.007466229,
				"type": "OTHER"
			},
			{
				"name": "laser weapon",
				"salience": 0.007188044,
				"type": "OTHER"
			},
			{
				"name": "Concept vehicles",
				"salience": 0.00674249,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "power",
				"salience": 0.006510874,
				"type": "OTHER"
			},
			{
				"name": "boats.",
				"salience": 0.006510874,
				"type": "OTHER"
			},
			{
				"name": "operation.",
				"salience": 0.006510874,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.006510874,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.0064912145,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ground targets",
				"salience": 0.0063205026,
				"type": "OTHER"
			},
			{
				"name": "enemy drone targets",
				"salience": 0.0063205026,
				"type": "OTHER"
			},
			{
				"name": "enemy drones",
				"salience": 0.005839737,
				"type": "OTHER"
			},
			{
				"name": "test",
				"salience": 0.005839737,
				"type": "EVENT"
			},
			{
				"name": "target",
				"salience": 0.005784393,
				"type": "OTHER"
			},
			{
				"name": "combat vehicle",
				"salience": 0.0055059963,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vehicles",
				"salience": 0.0055059963,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01j5_t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USS_Ponce_(LPD-15)"
				},
				"name": "USS Ponce",
				"salience": 0.0052627786,
				"type": "OTHER"
			},
			{
				"name": "High Energy Laser Mobile Demonstrator",
				"salience": 0.0051612677,
				"type": "PERSON"
			},
			{
				"name": "targets",
				"salience": 0.0051612677,
				"type": "OTHER"
			},
			{
				"name": "demonstrations",
				"salience": 0.0051612677,
				"type": "EVENT"
			},
			{
				"name": "integration",
				"salience": 0.005118552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w3tz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stryker"
				},
				"name": "Stryker",
				"salience": 0.004791411,
				"type": "ORGANIZATION"
			},
			{
				"name": "service",
				"salience": 0.0045670494,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0045670494,
				"type": "OTHER"
			},
			{
				"name": "Sill artillery headquarters",
				"salience": 0.0045670494,
				"type": "LOCATION"
			},
			{
				"name": "effort",
				"salience": 0.0045670494,
				"type": "OTHER"
			},
			{
				"name": "video footage",
				"salience": 0.004509557,
				"type": "WORK_OF_ART"
			},
			{
				"name": "use",
				"salience": 0.004396732,
				"type": "OTHER"
			},
			{
				"name": "sea",
				"salience": 0.004396732,
				"type": "LOCATION"
			},
			{
				"name": "HEL MD",
				"salience": 0.0043059415,
				"type": "ORGANIZATION"
			},
			{
				"name": "mortars",
				"salience": 0.0043059415,
				"type": "OTHER"
			},
			{
				"name": "HEL MD",
				"salience": 0.0043059415,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05pd98l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Dynamics_Land_Systems"
				},
				"name": "General Dynamics Land Systems",
				"salience": 0.004222383,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lasers",
				"salience": 0.004148725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Persian Gulf",
				"salience": 0.0040097907,
				"type": "LOCATION"
			},
			{
				"name": "High Energy Laser Demonstrator",
				"salience": 0.00385667,
				"type": "PERSON"
			},
			{
				"name": "precision",
				"salience": 0.003729026,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.003729026,
				"type": "ORGANIZATION"
			},
			{
				"name": "UAVs",
				"salience": 0.003729026,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "acquisition",
				"salience": 0.003729026,
				"type": "EVENT"
			},
			{
				"name": "laser",
				"salience": 0.0033025988,
				"type": "OTHER"
			},
			{
				"name": "fighter fleet",
				"salience": 0.002786127,
				"type": "OTHER"
			},
			{
				"name": "programme",
				"salience": 0.002786127,
				"type": "OTHER"
			},
			{
				"name": "STRAFE",
				"salience": 0.002786127,
				"type": "OTHER"
			},
			{
				"name": "demonstrator",
				"salience": 0.0027045687,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0178g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing"
				},
				"name": "Boeing",
				"salience": 0.0026079325,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bg7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shield"
				},
				"name": "SHiELD",
				"salience": 0.0026079325,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "Air Force",
				"salience": 0.0026079325,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/039h7m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Air_Force_Research_Laboratory"
				},
				"name": "Air Force Research Laboratory",
				"salience": 0.0022583532,
				"type": "ORGANIZATION"
			},
			{
				"name": "military vehicle",
				"salience": 0.0022392056,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stealth characteristics",
				"salience": 0.002029367,
				"type": "OTHER"
			},
			{
				"name": "airspace",
				"salience": 0.002029367,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.002029367,
				"type": "ORGANIZATION"
			},
			{
				"name": "Turret Research",
				"salience": 0.0019806116,
				"type": "OTHER"
			},
			{
				"name": "aspect",
				"salience": 0.0018807121,
				"type": "OTHER"
			},
			{
				"name": "Source w/video",
				"salience": 0.0017957254,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mortar",
				"salience": 0.0017507597,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.0017507597,
				"type": "OTHER"
			},
			{
				"name": "artillery",
				"salience": 0.0017507597,
				"type": "OTHER"
			},
			{
				"name": "Aero-Effects",
				"salience": 0.0017150748,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.0015160235,
				"type": "EVENT"
			},
			{
				"name": "mobile",
				"salience": 0.0015160235,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.0015160235,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.0015160235,
				"type": "OTHER"
			},
			{
				"name": "C-RAM",
				"salience": 0.0015160235,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0337b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McDonnell_Douglas_F-15_Eagle"
				},
				"name": "F-15 Eagle",
				"salience": 0.001249114,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.001249114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/033yz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_Martin_F-35_Lightning_II"
				},
				"name": "F-35 Lightning II",
				"salience": 0.001249114,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/033zf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Dynamics_F-16_Fighting_Falcon"
				},
				"name": "Lockheed Martin F-16 Fighting Falcon",
				"salience": 0.001249114,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/04x90j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oshkosh_Corporation"
				},
				"name": "Oshkosh",
				"salience": 0.0009330821,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.00051583286,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats15.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:26.896+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link So we have laser defense systems being used by the US Navy... Ponce became the testbed platform for the Laser Weapon System (LaWS), with installation of a prototype weapon system for field testing in August 2014.[29][30][31] In December 2014 the United States Navy reported the LaWS system works perfectly, and that the commander of Ponce is authorized to use the system as a defensive weapon.[32] On 9 December 2014, the U.S. Navy released video footage of the LaWS in operation.[33] The exact level of power the LaWS will use is unknown but estimated between 15–50 kW for engaging drones, small aircraft and high-speed boats.[34] Ponce was deployed to the Persian Gulf in late August 2014.[35][36] The LaWS will remain in use on Ponce as long as it is at sea, potentially into 2017.[37] USS Ponce (LPD-15) The US Army has them and they will be fielded... The Army and General Dynamics Land Systems are developing a Stryker-mounted laser weapon aimed at better arming the vehicle to incinerate enemy drones or threatening ground targets. Concept vehicles are now being engineered and tested at the Army’s Ft. Sill artillery headquarters as a way to quickly develop the weapon for operational service. During a test this past April, the laser weapons successful shot down 21 out of 23 enemy drone targets. The effort marks the first-ever integration of an Army laser weapon onto a combat vehicle. Stryker mounted laser Boeing’s High Energy Laser Mobile Demonstrator (HEL MD) team has used a solid state laser to destroy mortars and unmanned aerial vehicles (UAVs). A laser destroys targets with pinpoint precision within seconds of acquisition, then acquires the next target and keeps firing. In recent demonstrations, HEL MD used a 10-kilowatt, high energy laser installed on an Oshkosh tactical military vehicle. The demonstrator is the first mobile, high-energy laser, counter rocket, artillery and mortar (C-RAM) platform to be built and demonstrated by the U.S. Army. Source w/video And now after the Air Force originally called lasers off, they've gone and called the game back on. After the success of the Navy and the Army. The contract, which was awarded by the Air Force Research Laboratory (AFRL) on 23 August, is for the Self-Protect High Energy Laser Demonstrator (SHiELD) Turret Research in Aero-Effects (STRAFE) programme. It is intended that the SHiELD pod would better enable the USAF's fourth-generation fighter fleet, such as the Boeing F-15 Eagle and Lockheed Martin F-16 Fighting Falcon, to survive in contested airspace. The fifth-generation Lockheed Martin F-22 Raptor and F-35 Lightning II would probably not carry the pod, as it would negate their stealth characteristics. Lasers are upon on the USA. They have permeated every aspect of our military. Can anyone else say that?",
		"thread_title": "Lasers, they are truly upon US.",
		"title": "Lasers, they are truly upon US.",
		"type": "bs",
		"uuid": "f6258e969d0b1f57ea4705c6f5aa2bf482fc3827"
	},
	"-KhIaBa_zReP8OMir_i2": {
		"author": "seasonal",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:28.318+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01vw26l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ice_Cube"
				},
				"name": "Ice-Cube",
				"salience": 0.3179471,
				"type": "PERSON"
			},
			{
				"name": "debate commentator",
				"salience": 0.14907011,
				"type": "WORK_OF_ART"
			},
			{
				"name": "enjoyment",
				"salience": 0.12406386,
				"type": "OTHER"
			},
			{
				"name": "vid",
				"salience": 0.12406386,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.05286284,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.05286284,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.032844365,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "POTUS",
				"salience": 0.032844365,
				"type": "ORGANIZATION"
			},
			{
				"name": "story",
				"salience": 0.021214865,
				"type": "WORK_OF_ART"
			},
			{
				"name": "everything",
				"salience": 0.01851263,
				"type": "OTHER"
			},
			{
				"name": "boss thing",
				"salience": 0.01851263,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.015718682,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.014211755,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.011183652,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0072537498,
				"type": "OTHER"
			},
			{
				"name": "endorsement",
				"salience": 0.006832714,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats12.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:28.318+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "link For your enjoyment a very short vid with Ice-Cube talking about the only 3 people in the US capable of taking on the POTUS role. I agree with him. Well, everything except the boss thing. And he makes a some good points in a very short time. In my opinion he should be the next debate commentator. But a month ago it was a different story. While it isn't a ringing endorsement of Trump, he fared much better than the other 2. edit on 27-10-2016 by seasonal because: (no reason given)",
		"thread_title": "Ice Cube: Trump America loves -Hill called us superpreditors -The Bern whatve you done",
		"title": "Ice Cube: Trump America loves -Hill called us superpreditors -The Bern whatve you done",
		"type": "bs",
		"uuid": "a6e81c1ff34b0eea83548f598b26dfd54df5632a"
	},
	"-KhIaBlyjJYBflUBgY6F": {
		"author": "xuenchen",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:57:29.029+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0115nnlq"
				},
				"name": "Eric Garner",
				"salience": 0.38205498,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0115nwkf"
				},
				"name": "Erica Garner",
				"salience": 0.18558896,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.10878251,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.06955848,
				"type": "PERSON"
			},
			{
				"name": "Daughter Erica",
				"salience": 0.06641487,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.023032347,
				"type": "WORK_OF_ART"
			},
			{
				"name": "discussions staffers",
				"salience": 0.020263491,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.012783857,
				"type": "EVENT"
			},
			{
				"name": "Clinton Campaign",
				"salience": 0.011924369,
				"type": "ORGANIZATION"
			},
			{
				"name": "ways",
				"salience": 0.011364342,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.011364342,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.010588229,
				"type": "PERSON"
			},
			{
				"name": "Podesta",
				"salience": 0.008107311,
				"type": "PERSON"
			},
			{
				"name": "newspaper story",
				"salience": 0.0051788413,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Campaign",
				"salience": 0.004107114,
				"type": "ORGANIZATION"
			},
			{
				"name": "Campaign",
				"salience": 0.004107114,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.003602212,
				"type": "OTHER"
			},
			{
				"name": "discussions staffers",
				"salience": 0.0029307657,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0025641269,
				"type": "PERSON"
			},
			{
				"name": "staffers",
				"salience": 0.0024551712,
				"type": "PERSON"
			},
			{
				"name": "exposure",
				"salience": 0.0024118207,
				"type": "EVENT"
			},
			{
				"name": "liability",
				"salience": 0.0024118207,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0024118207,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.0024118207,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0024045433,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.0023549565,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0021334223,
				"type": "ORGANIZATION"
			},
			{
				"name": "piece",
				"salience": 0.0021078233,
				"type": "OTHER"
			},
			{
				"name": "campaign emails",
				"salience": 0.0020920928,
				"type": "WORK_OF_ART"
			},
			{
				"name": "death",
				"salience": 0.002082766,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.0020397992,
				"type": "WORK_OF_ART"
			},
			{
				"name": "father",
				"salience": 0.0019536752,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.0019061632,
				"type": "EVENT"
			},
			{
				"name": "father",
				"salience": 0.0018808724,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dsdp74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicholas_Merrill"
				},
				"name": "Nick Merrill",
				"salience": 0.0017062587,
				"type": "PERSON"
			},
			{
				"name": "revelation",
				"salience": 0.0016921156,
				"type": "OTHER"
			},
			{
				"name": "tweets",
				"salience": 0.0016921156,
				"type": "WORK_OF_ART"
			},
			{
				"name": "series",
				"salience": 0.0016921156,
				"type": "WORK_OF_ART"
			},
			{
				"name": "losses",
				"salience": 0.0016290413,
				"type": "OTHER"
			},
			{
				"name": "Human dignity",
				"salience": 0.0016290413,
				"type": "OTHER"
			},
			{
				"name": "dad",
				"salience": 0.0013817452,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.0013817452,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0011282293,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0011282293,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0011106578,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0010420486,
				"type": "ORGANIZATION"
			},
			{
				"name": "piece",
				"salience": 0.00086849194,
				"type": "OTHER"
			},
			{
				"name": "Police violence",
				"salience": 0.0008360889,
				"type": "OTHER"
			},
			{
				"name": "PodestaEmails19",
				"salience": 0.00073402625,
				"type": "LOCATION"
			},
			{
				"name": "gun violence",
				"salience": 0.00064885744,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0005618746,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0004887286,
				"type": "OTHER"
			},
			{
				"name": "xuenchen",
				"salience": 0.00046296453,
				"type": "PERSON"
			},
			{
				"name": "politicalmoneyisntgreen",
				"salience": 0.00046296453,
				"type": "OTHER"
			},
			{
				"name": "@CoreyCiorciari",
				"salience": 0.00034584373,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:57:29.029+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Erica Garner blasts Clinton campaign over discussions staffers had about Eric Garner page: 1 One Podesta email has Clinton Campaign people discussing the death of Eric Garner in ways his Daughter Erica dislikes. She went on Twitter and gave them a piece of her mind. Seems they saw a newspaper story that may have been interpreted as a liability. This exposure could hurt the Campaign. The whole Campaign is based on political profits and losses, not Human dignity. Erica Garner blasts Clinton campaign over discussions staffers had about her father’s death in WikiLeaks emails Erica Garner, the daughter of police chokehold victim Eric Garner, ripped the Hillary Clinton campaign in a series of tweets Thursday after new campaign emails released by WikiLeaks showed how the Democratic nominee's staffers discussed the death of her father. “I’m troubled by the revelation that you and this campaign actually discussed ‘using’ Eric Garner … Why would you want to ‘use my dad?” Garner tweeted along with a link to emails released by WikiLeaks. “These people will co opt anything to push their agenda. Police violence is not the same as gun violence. “I'm vey (sic) interested to know exactly what @CoreyCiorciari meant when he said ‘I know we have an Erica Garner problem’ in the #PodestaEmails19,” added Garner. “I know we have Erica Garner issues but we don't want to mention Eric at all? I can see her coming after us for leaving him out of the piece,” Clinton’s traveling press secretary Nick Merrill wrote in a March 17 email. edit on Oct-27-2016 by xuenchen because: politicalmoneyisntgreen",
		"thread_title": "Erica Garner blasts Clinton campaign over discussions staffers had about Eric Garner",
		"title": "Erica Garner blasts Clinton campaign over discussions staffers had about Eric Garner",
		"type": "bs",
		"uuid": "90df00b42898431d3bc846627e3fc569ff0af129"
	},
	"-KhIaBtpZQUPAy-mGrh0": {
		"author": "seasonal",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T07:09:44.027+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.37367108,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.11576263,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.06542809,
				"type": "PERSON"
			},
			{
				"name": "Homeless TRUMP Supporter",
				"salience": 0.048859492,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.04245172,
				"type": "OTHER"
			},
			{
				"name": "leftist",
				"salience": 0.04245172,
				"type": "PERSON"
			},
			{
				"name": "Star on Hollywood Blvd",
				"salience": 0.030366562,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.027274638,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.026719308,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0qjfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood_Walk_of_Fame"
				},
				"name": "Hollywood Walk of Fame",
				"salience": 0.026349582,
				"type": "LOCATION"
			},
			{
				"name": "plant",
				"salience": 0.022704624,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g8309",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump"
				},
				"name": "Trumps",
				"salience": 0.018436689,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.0141261425,
				"type": "PERSON"
			},
			{
				"name": "homeless man",
				"salience": 0.010297492,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.009555843,
				"type": "PERSON"
			},
			{
				"name": "sledgehammer",
				"salience": 0.009076395,
				"type": "OTHER"
			},
			{
				"name": "culprits",
				"salience": 0.009076395,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.007834753,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.006732246,
				"type": "OTHER"
			},
			{
				"name": "watch",
				"salience": 0.006452818,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Everybody",
				"salience": 0.006371741,
				"type": "PERSON"
			},
			{
				"name": "gimmick",
				"salience": 0.006371741,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.006134554,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fame",
				"salience": 0.006008103,
				"type": "OTHER"
			},
			{
				"name": "homeless vote",
				"salience": 0.0056147855,
				"type": "OTHER"
			},
			{
				"name": "stinkin",
				"salience": 0.0052043693,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0052043693,
				"type": "LOCATION"
			},
			{
				"name": "signs",
				"salience": 0.004491159,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035zpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood_Boulevard"
				},
				"name": "Hollywood BLVD",
				"salience": 0.004363896,
				"type": "LOCATION"
			},
			{
				"name": "sidewalk",
				"salience": 0.004092002,
				"type": "LOCATION"
			},
			{
				"name": "spray painting buildings",
				"salience": 0.0038899381,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.0032725874,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0032725874,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0032725874,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Ill",
				"salience": 0.0032059597,
				"type": "LOCATION"
			},
			{
				"name": "entourage",
				"salience": 0.0028342502,
				"type": "PERSON"
			},
			{
				"name": "low",
				"salience": 0.0028342502,
				"type": "OTHER"
			},
			{
				"name": "lows",
				"salience": 0.0028342502,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0028342502,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0024454235,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0018189714,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats14.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T07:09:44.027+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Homeless TRUMP Supporter Guards Donald Trump’s Star on Hollywood Blvd page: 1 On Wednesday a violent leftist smashed Donald Trump’s star on the Hollywood Walk of Fame. The culprits used a sledgehammer to destroy Donald’s star. The person who was watching Trumps star had an anti-immigration sign and is pro-trump. Later another homeless man took up the watch to keep Trumps star on Hollywood BLVD safe. From the video it looks like the star had already been replaced. Could this be a plant? And has Trump secured the homeless vote? Everybody's looking for a gimmick, and their 15 minutes of fame. Sad, really. Really sad. Maybe he wants a home. Another stinkin' deplorable. link Ill bet Hillary laughs at him because he is homeless and like Trump. I would give him money if I lived there. The violent destructive liberals just cant stop stealing signs, spray painting buildings and now vandalizing a sidewalk, wow but not surprised, the liberals have been so dirty not only Hillary and her supporters but her whole entourage that it makes this years election a new low in lows and sets a really bad example for the next election.",
		"thread_title": "Homeless TRUMP Supporter Guards Donald Trump's Star on Hollywood Blvd",
		"title": "Homeless TRUMP Supporter Guards Donald Trump's Star on Hollywood Blvd",
		"type": "bs",
		"uuid": "24d373a8a32ac2d4b9ce4bb8e73aa8618a83ae62"
	},
	"-KhIaC122a0xzSQ7czuO": {
		"author": "Xcathdra",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T07:09:44.249+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "aliens",
				"salience": 0.07540747,
				"type": "OTHER"
			},
			{
				"name": "aliens",
				"salience": 0.07540747,
				"type": "OTHER"
			},
			{
				"name": "stars",
				"salience": 0.07061248,
				"type": "PERSON"
			},
			{
				"name": "signals",
				"salience": 0.06285299,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.06285299,
				"type": "OTHER"
			},
			{
				"name": "astronomers",
				"salience": 0.052637365,
				"type": "ORGANIZATION"
			},
			{
				"name": "space",
				"salience": 0.045702744,
				"type": "LOCATION"
			},
			{
				"name": "cluster",
				"salience": 0.045702744,
				"type": "OTHER"
			},
			{
				"name": "universe",
				"salience": 0.043130353,
				"type": "OTHER"
			},
			{
				"name": "hypothesis",
				"salience": 0.039873306,
				"type": "OTHER"
			},
			{
				"name": "stars",
				"salience": 0.035663113,
				"type": "PERSON"
			},
			{
				"name": "team",
				"salience": 0.032616317,
				"type": "ORGANIZATION"
			},
			{
				"name": "duplicate",
				"salience": 0.027590731,
				"type": "OTHER"
			},
			{
				"name": "Scientists",
				"salience": 0.025216592,
				"type": "PERSON"
			},
			{
				"name": "fraction",
				"salience": 0.02408718,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.020363443,
				"type": "OTHER"
			},
			{
				"name": "stars",
				"salience": 0.015161939,
				"type": "PERSON"
			},
			{
				"name": "beacons",
				"salience": 0.013077108,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.009736668,
				"type": "OTHER"
			},
			{
				"name": "beams",
				"salience": 0.009736668,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.009452454,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.009452454,
				"type": "OTHER"
			},
			{
				"name": "hypothesis",
				"salience": 0.008734567,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.008734567,
				"type": "OTHER"
			},
			{
				"name": "stars",
				"salience": 0.008698115,
				"type": "PERSON"
			},
			{
				"name": "Eric Trottier",
				"salience": 0.008449702,
				"type": "PERSON"
			},
			{
				"name": "aliens",
				"salience": 0.008409444,
				"type": "OTHER"
			},
			{
				"name": "Ermanno F. Borra",
				"salience": 0.008238681,
				"type": "PERSON"
			},
			{
				"name": "publication",
				"salience": 0.007888661,
				"type": "EVENT"
			},
			{
				"name": "shape",
				"salience": 0.007466049,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/073gh_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Publications_of_the_Astronomical_Society_of_the_Pacific"
				},
				"name": "Publications of the Astronomical Society of the Pacific",
				"salience": 0.0069274777,
				"type": "WORK_OF_ART"
			},
			{
				"name": "agreement",
				"salience": 0.0068332884,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0065787532,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stars",
				"salience": 0.00650239,
				"type": "PERSON"
			},
			{
				"name": "fraction",
				"salience": 0.006443059,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.005580661,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.005580661,
				"type": "EVENT"
			},
			{
				"name": "parameters",
				"salience": 0.0053325775,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0053325775,
				"type": "OTHER"
			},
			{
				"name": "parameters",
				"salience": 0.0053325775,
				"type": "OTHER"
			},
			{
				"name": "authors",
				"salience": 0.0049796565,
				"type": "PERSON"
			},
			{
				"name": "stars",
				"salience": 0.0047383523,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zh3_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laval_University"
				},
				"name": "Laval University",
				"salience": 0.0046789986,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11b80c8nvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Extraterrestrial_intelligence"
				},
				"name": "Extraterrestrial Intelligence",
				"salience": 0.0045246254,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.0041706073,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0694j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quebec"
				},
				"name": "Quebec",
				"salience": 0.0040523433,
				"type": "LOCATION"
			},
			{
				"name": "parameters",
				"salience": 0.0038854154,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0035084821,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.0030384064,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0030384064,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.0030384064,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0030384064,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0030384064,
				"type": "OTHER"
			},
			{
				"name": "Thoughts",
				"salience": 0.0030384064,
				"type": "OTHER"
			},
			{
				"name": "beacon",
				"salience": 0.0026214633,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.002270127,
				"type": "WORK_OF_ART"
			},
			{
				"name": "link",
				"salience": 0.002270127,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.002270127,
				"type": "OTHER"
			},
			{
				"name": "radio waves",
				"salience": 0.002270127,
				"type": "OTHER"
			},
			{
				"name": "life force",
				"salience": 0.0021307115,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats14.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T07:09:44.249+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Scientists say weird signals from space are ‘probably’ aliens A team of astronomers believes that strange signals emanating from a cluster of stars are actually aliens trying to tell the universe they exist. The study, which appeared in the Publications of the Astronomical Society of the Pacific, analyzed the odd beams of light from 234 stars — a fraction of the 2.5 million that were observed. The bizarre beacons led the paper’s authors, Ermanno F. Borra and Eric Trottier from Laval University in Quebec, to conclude that it’s “probably” aliens. “We find that the detected signals have exactly the shape of an [extraterrestrial intelligence] signal predicted in the previous publication and are therefore in agreement with this hypothesis,” wrote Borra and Trottier. They also note that their findings align with the Extraterrestrial Intelligence (ETI) hypothesis, since the mysterious activity only occurred in a tiny fraction of stars. The hypothesis also suggests that an intelligent life force would use a more sophisticated optical beacon than, say, radio waves to reveal its existence. Click link for article... **MODS - If this is a duplicate please delete / and or lock ** So apparently signals detected from 230+ stars are fitting the hypothesized parameters established for extraterrestrial intelligence. The stars in question also fit the hypothesized parameters for supporting life. Since only a small amount of stars in the area being looked at are fitting the parameters they are using that as further evidence in support of their claims. Thoughts?",
		"thread_title": "Scientists say weird signals from space are 'probably' aliens",
		"title": "Scientists say weird signals from space are 'probably' aliens",
		"type": "bs",
		"uuid": "4e7fffe9585979bf197a1039c500ea3e7f7d5eda"
	},
	"-KhIaCGDWCUjlv_ryCfa": {
		"author": "DaRAGE",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T07:09:44.972+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"name": "idiot",
				"salience": 0.1409714,
				"type": "PERSON"
			},
			{
				"name": "transistor",
				"salience": 0.049360447,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.049158085,
				"type": "OTHER"
			},
			{
				"name": "transistors",
				"salience": 0.0386742,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.035722475,
				"type": "OTHER"
			},
			{
				"name": "qubit",
				"salience": 0.0349567,
				"type": "PERSON"
			},
			{
				"name": "transistor",
				"salience": 0.03143381,
				"type": "OTHER"
			},
			{
				"name": "transistor",
				"salience": 0.022661945,
				"type": "OTHER"
			},
			{
				"name": "quantum computing",
				"salience": 0.02096608,
				"type": "OTHER"
			},
			{
				"name": "computing",
				"salience": 0.02096608,
				"type": "OTHER"
			},
			{
				"name": "Transistors",
				"salience": 0.019855535,
				"type": "OTHER"
			},
			{
				"name": "qubits",
				"salience": 0.01793707,
				"type": "OTHER"
			},
			{
				"name": "qubits",
				"salience": 0.01793707,
				"type": "OTHER"
			},
			{
				"name": "quantum computers",
				"salience": 0.015488203,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "quantum computer",
				"salience": 0.013291665,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "question",
				"salience": 0.01328746,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.012907467,
				"type": "OTHER"
			},
			{
				"name": "quantum",
				"salience": 0.01216244,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.010536118,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.010536118,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.008957612,
				"type": "OTHER"
			},
			{
				"name": "transistor",
				"salience": 0.008198283,
				"type": "OTHER"
			},
			{
				"name": "transistor",
				"salience": 0.008198283,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.007685327,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.007685327,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.007685327,
				"type": "LOCATION"
			},
			{
				"name": "both",
				"salience": 0.0070066787,
				"type": "OTHER"
			},
			{
				"name": "quantum computer",
				"salience": 0.006894428,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "transistors",
				"salience": 0.006866881,
				"type": "OTHER"
			},
			{
				"name": "voltage",
				"salience": 0.0067726034,
				"type": "OTHER"
			},
			{
				"name": "voltage",
				"salience": 0.0067726034,
				"type": "OTHER"
			},
			{
				"name": "voltage",
				"salience": 0.0067726034,
				"type": "OTHER"
			},
			{
				"name": "voltage",
				"salience": 0.0067726034,
				"type": "OTHER"
			},
			{
				"name": "voltage",
				"salience": 0.0067726034,
				"type": "OTHER"
			},
			{
				"name": "waves",
				"salience": 0.0065388954,
				"type": "OTHER"
			},
			{
				"name": "computing",
				"salience": 0.0060744532,
				"type": "OTHER"
			},
			{
				"name": "quantum computing",
				"salience": 0.0060744532,
				"type": "OTHER"
			},
			{
				"name": "computer",
				"salience": 0.0060744532,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bits",
				"salience": 0.0060482183,
				"type": "OTHER"
			},
			{
				"name": "circuitry",
				"salience": 0.006010989,
				"type": "OTHER"
			},
			{
				"name": "transistors",
				"salience": 0.005536896,
				"type": "OTHER"
			},
			{
				"name": "proceeding transistor",
				"salience": 0.005536896,
				"type": "OTHER"
			},
			{
				"name": "transistor",
				"salience": 0.005536896,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.005190199,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.005190199,
				"type": "LOCATION"
			},
			{
				"name": "numbers",
				"salience": 0.005113936,
				"type": "OTHER"
			},
			{
				"name": "Quantum",
				"salience": 0.005078903,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0050118454,
				"type": "OTHER"
			},
			{
				"name": "quantum computer",
				"salience": 0.0049601593,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "reading",
				"salience": 0.0047459067,
				"type": "OTHER"
			},
			{
				"name": "voltage",
				"salience": 0.0045733927,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0044020927,
				"type": "LOCATION"
			},
			{
				"name": "wave",
				"salience": 0.004388281,
				"type": "OTHER"
			},
			{
				"name": "layer",
				"salience": 0.0043431316,
				"type": "OTHER"
			},
			{
				"name": "collapse",
				"salience": 0.0043150242,
				"type": "EVENT"
			},
			{
				"name": "qubit",
				"salience": 0.004240585,
				"type": "PERSON"
			},
			{
				"name": "qubits",
				"salience": 0.004240585,
				"type": "OTHER"
			},
			{
				"name": "circuit",
				"salience": 0.004216046,
				"type": "LOCATION"
			},
			{
				"name": "bits",
				"salience": 0.004216046,
				"type": "OTHER"
			},
			{
				"name": "circuitry",
				"salience": 0.004216046,
				"type": "OTHER"
			},
			{
				"name": "bits",
				"salience": 0.004216046,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0040670307,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.003895128,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0035171336,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0035171336,
				"type": "OTHER"
			},
			{
				"name": "features",
				"salience": 0.0035171336,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0035171336,
				"type": "OTHER"
			},
			{
				"name": "bits",
				"salience": 0.003442303,
				"type": "OTHER"
			},
			{
				"name": "qubit scenario",
				"salience": 0.0032864327,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0031802244,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0031802244,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0031802244,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0031802244,
				"type": "OTHER"
			},
			{
				"name": "quantum computer",
				"salience": 0.003143251,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "features",
				"salience": 0.003137978,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0030457703,
				"type": "OTHER"
			},
			{
				"name": "registers",
				"salience": 0.0030457703,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0030457703,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0030457703,
				"type": "OTHER"
			},
			{
				"name": "qbit",
				"salience": 0.0030457703,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0030457703,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.0030208954,
				"type": "OTHER"
			},
			{
				"name": "Qubits",
				"salience": 0.0029738287,
				"type": "OTHER"
			},
			{
				"name": "circuit",
				"salience": 0.0029566134,
				"type": "OTHER"
			},
			{
				"name": "laymen terms",
				"salience": 0.0029321252,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.0029321252,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.0029321252,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0028715464,
				"type": "OTHER"
			},
			{
				"name": "computer",
				"salience": 0.0026997214,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "quantum computer",
				"salience": 0.0026997214,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "computer",
				"salience": 0.0026997214,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.0026777408,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0025204166,
				"type": "LOCATION"
			},
			{
				"name": "logic gates",
				"salience": 0.0024866394,
				"type": "PERSON"
			},
			{
				"name": "algorithms",
				"salience": 0.0024866394,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0024866394,
				"type": "OTHER"
			},
			{
				"name": "particle",
				"salience": 0.0024866394,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0023957929,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0023957929,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.0023759461,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0023759461,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0023759461,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0023759461,
				"type": "OTHER"
			},
			{
				"name": "physics concept",
				"salience": 0.002176364,
				"type": "OTHER"
			},
			{
				"name": "superposition",
				"salience": 0.0021452822,
				"type": "OTHER"
			},
			{
				"name": "pipe",
				"salience": 0.0021452822,
				"type": "OTHER"
			},
			{
				"name": "DaRAGE",
				"salience": 0.0018749201,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0018731903,
				"type": "OTHER"
			},
			{
				"name": "sequence",
				"salience": 0.0018576705,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0018576705,
				"type": "WORK_OF_ART"
			},
			{
				"name": "version",
				"salience": 0.0016784692,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "way",
				"salience": 0.001665919,
				"type": "OTHER"
			},
			{
				"name": "standing wave",
				"salience": 0.0016534624,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0016534624,
				"type": "OTHER"
			},
			{
				"name": "parallel",
				"salience": 0.0015624805,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.0014929079,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0013529714,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0013529714,
				"type": "OTHER"
			},
			{
				"name": "superposition",
				"salience": 0.0011671855,
				"type": "OTHER"
			},
			{
				"name": "frequency",
				"salience": 0.0011671855,
				"type": "OTHER"
			},
			{
				"name": "pipe",
				"salience": 0.0011671855,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0011619715,
				"type": "OTHER"
			},
			{
				"name": "Estimates",
				"salience": 0.0011473278,
				"type": "OTHER"
			},
			{
				"name": "waves",
				"salience": 0.0011159879,
				"type": "OTHER"
			},
			{
				"name": "originals",
				"salience": 0.0010106644,
				"type": "WORK_OF_ART"
			},
			{
				"name": "something",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "cat",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "flute",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "multiples",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0010106644,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "note",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "overtones",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "bicycle",
				"salience": 0.0010106644,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bus",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "harmonics",
				"salience": 0.0010106644,
				"type": "OTHER"
			},
			{
				"name": "qubits store",
				"salience": 0.0010106644,
				"type": "LOCATION"
			},
			{
				"name": "explainthatstuff.com",
				"salience": 0.0008327009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02p_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Erwin_Schr%C3%B6dinger"
				},
				"name": "Schrödinger",
				"salience": 0.00062199973,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats13.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T07:09:44.972+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "Can normal transistors act like a qubit? page: 1 link Hi. I guess I have a question relating to quantum computing. Since qubits are what makes up quantum computers... That being a qubits can act like a transistor that can be either on, off, or both on and off at the same time. In usual computing... Transistors are either on or off. In quantum they can be both on and off at the same time... The question I have is simply this. Is it possible to make a transistor that can act as on, off, and on and off at the same time... Even if you had to add an extra layer of circuitry to get that same reading from that single transistor? I mean. A normal transistor operate that if it gets no voltage or low voltage then the transistor is in an off state. If it gets a certain voltage it is in an on state. Couldn't you make the voltage extra high to get a both on/off at the same time state? Or half voltage to get the same on/off state at the same time to essentially create a fake qubit scenario? There might have to be additional transistors to help make sure of that determination of a transistor appearing in an on/off state but couldn't it be possible? Perhaps a circuit of transistors could determine whether the proceeding transistor should act as both on/off by checking the voltage some how? Idk... Please answer me like I'm a drunk stupid idiot. Perhaps laymen terms? I can be quite the idiot sometimes. Thanks for hearing me out. I'm currently drunk and just pondering things link a reply to: DaRAGE I'm sure we could do weird stuff with circuitry to store more than one bit of data in the circuit, but that doesn't really give an advantage over just storing more bits with our conventional technology (which has been highly refined). The advantage of the qbit isn't really that it stores more information, it's that it can be used to process more information at the same time. Quantum + computing = quantum computing The key features of an ordinary computer—bits, registers, logic gates, algorithms, and so on—have analogous features in a quantum computer. Instead of bits, a quantum computer has quantum bits or qubits, which work in a particularly intriguing way. Where a bit can store either a zero or a 1, a qubit can store a zero, a one, both zero and one, or an infinite number of values in between—and be in multiple states (store multiple values) at the same time! If that sounds confusing, think back to light being a particle and a wave at the same time, Schrödinger's cat being alive and dead, or a car being a bicycle and a bus. A gentler way to think of the numbers qubits store is through the physics concept of superposition (where two waves add to make a third one that contains both of the originals). If you blow on something like a flute, the pipe fills up with a standing wave: a wave made up of a fundamental frequency (the basic note you're playing) and lots of overtones or harmonics (higher-frequency multiples of the fundamental). The wave inside the pipe contains all these waves simultaneously: they're added together to make a combined wave that includes them all. Qubits use superposition to represent multiple states (multiple numeric values) simultaneously in a similar way. Just as a quantum computer can store multiple numbers at once, so it can process them simultaneously. Instead of working in serial (doing a series of things one at a time in a sequence), it can work in parallel (doing multiple things at the same time). Only when you try to find out what state it's actually in at any given moment (by measuring it, in other words) does it \"collapse\" into one of its possible states—and that gives you the answer to your problem. Estimates suggest a quantum computer's ability to work in parallel would make it millions of times faster than any conventional computer... if only we could build it! So how would we do that? explainthatstuff.com If I understand correctly, a quantum computer will just be a smaller, more energy efficient version of a massive parallel computer.",
		"thread_title": "Can normal transistors act like a qubit?",
		"title": "Can normal transistors act like a qubit?",
		"type": "bs",
		"uuid": "ad7cd6224912c388b038ca5cfa8639c4c057319f"
	},
	"-KhIaCQJhMPS9_GvZWwz": {
		"author": "mobiusmale",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T15:46:49.823+03:00",
		"domain_rank": "18533",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Secretary Clinton",
				"salience": 0.46132335,
				"type": "PERSON"
			},
			{
				"name": "Ratheon 14",
				"salience": 0.17846501,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.048223637,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.017665181,
				"type": "PERSON"
			},
			{
				"name": "Mainstream Mafia",
				"salience": 0.015447278,
				"type": "PERSON"
			},
			{
				"name": "missile defence systems",
				"salience": 0.014925267,
				"type": "OTHER"
			},
			{
				"name": "Clinton Cabal",
				"salience": 0.014504224,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.012045916,
				"type": "OTHER"
			},
			{
				"name": "attack helicopters",
				"salience": 0.012045916,
				"type": "PERSON"
			},
			{
				"name": "military materiel",
				"salience": 0.012045916,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07kdq4q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Heather_Podesta"
				},
				"name": "Heather Podesta",
				"salience": 0.011434792,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.009493491,
				"type": "LOCATION"
			},
			{
				"name": "pay-for-play",
				"salience": 0.008690733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09dxm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing_AH-64_Apache"
				},
				"name": "Apache",
				"salience": 0.007428631,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0071777445,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.006890837,
				"type": "ORGANIZATION"
			},
			{
				"name": "State Department 5",
				"salience": 0.0066389143,
				"type": "ORGANIZATION"
			},
			{
				"name": "John Merrigan",
				"salience": 0.006511343,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07xg1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Armed_Forces"
				},
				"name": "U.S. Military",
				"salience": 0.0058940067,
				"type": "ORGANIZATION"
			},
			{
				"name": "military sales",
				"salience": 0.0057409336,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.0049726134,
				"type": "OTHER"
			},
			{
				"name": "spouse",
				"salience": 0.0049726134,
				"type": "PERSON"
			},
			{
				"name": "goods",
				"salience": 0.0049726134,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00480046,
				"type": "PERSON"
			},
			{
				"name": "Qatar 4",
				"salience": 0.0047755977,
				"type": "LOCATION"
			},
			{
				"name": "bundlers",
				"salience": 0.0038775238,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.0034882643,
				"type": "PERSON"
			},
			{
				"name": "senior advisor",
				"salience": 0.0034882643,
				"type": "PERSON"
			},
			{
				"name": "foreign policy",
				"salience": 0.0034882643,
				"type": "OTHER"
			},
			{
				"name": "advisory board",
				"salience": 0.0034882643,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.0034882643,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0033732476,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0033581967,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0033581967,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.0033581967,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0033581967,
				"type": "OTHER"
			},
			{
				"name": "beck",
				"salience": 0.0033581967,
				"type": "OTHER"
			},
			{
				"name": "fundraisers",
				"salience": 0.0033581967,
				"type": "EVENT"
			},
			{
				"name": "confidants",
				"salience": 0.0033581967,
				"type": "OTHER"
			},
			{
				"name": "aides",
				"salience": 0.0033581967,
				"type": "OTHER"
			},
			{
				"name": "titles",
				"salience": 0.0033581967,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bundlers",
				"salience": 0.0032888614,
				"type": "OTHER"
			},
			{
				"name": "Matt Bernstein",
				"salience": 0.0031836245,
				"type": "PERSON"
			},
			{
				"name": "Charitable Foundation'' 7",
				"salience": 0.003062693,
				"type": "OTHER"
			},
			{
				"name": "campaigns",
				"salience": 0.0028482708,
				"type": "EVENT"
			},
			{
				"name": "millions",
				"salience": 0.0028482708,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.0027942092,
				"type": "OTHER"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0027215495,
				"type": "PERSON"
			},
			{
				"name": "network",
				"salience": 0.002707512,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.002538017,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "POTUS",
				"salience": 0.0024691992,
				"type": "ORGANIZATION"
			},
			{
				"name": "Clinton Organized Crime Family",
				"salience": 0.0023877462,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0021281412,
				"type": "LOCATION"
			},
			{
				"name": "folks",
				"salience": 0.0021281412,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0020250396,
				"type": "ORGANIZATION"
			},
			{
				"name": "access",
				"salience": 0.0018360583,
				"type": "OTHER"
			},
			{
				"name": "Slick Willy",
				"salience": 0.0017536179,
				"type": "PERSON"
			},
			{
				"name": "State Department 15",
				"salience": 0.0016755603,
				"type": "ORGANIZATION"
			},
			{
				"name": "Podestas",
				"salience": 0.001560892,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.0015501409,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0015501409,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0015501409,
				"type": "PERSON"
			},
			{
				"name": "gear",
				"salience": 0.0015501409,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sale",
				"salience": 0.0014069105,
				"type": "EVENT"
			},
			{
				"name": "birthday gift",
				"salience": 0.0011580412,
				"type": "OTHER"
			},
			{
				"name": "Lobbying Fees",
				"salience": 0.0011580412,
				"type": "OTHER"
			},
			{
				"name": "aaahhh",
				"salience": 0.0011580412,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0011434498,
				"type": "OTHER"
			},
			{
				"name": "Clinton Crime Family",
				"salience": 0.0011019136,
				"type": "ORGANIZATION"
			},
			{
				"name": "Matt Berstein",
				"salience": 0.000712765,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://files.abovetopsecret.com/images/ats12.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T15:46:49.823+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "abovetopsecret.com",
		"spam_score": "0",
		"text": "This is how it works in the Clinton Cabal...or is it the Mainstream Mafia. 1) Qatar supports ISIS (just by the way) 2) Qatar wants to buy advanced U.S. missile defence systems, Apache attack helicopters and other military materiel 3) Ratheon (a big defence contractor) wants to sell said U.S. Military goods to Qatar 4) These kinds of foreign military sales have to be approved by the State Department 5) Hillary becomes Secretary of State 6) Hillary has a \"Charitable Foundation\" 7) Hillary has a former POTUS as her spouse 8) Hillary has a network of aides, confidants, bundlers and fundraisers at her beck and call (all part of the Clinton Organized Crime Family) 9) John Podesta (at that time)...yeah the same John Podesta who is having all of his emails released right now... held dual titles at the State Department: as a \"senior advisor\", and as a member of a foreign policy advisory board Secretary Clinton created. 10) Ratheon hires John Podesta's sister-in-law (Heather Podesta), along with John Merrigan and Matt Bernstein (both major donors or bundlers to Hillary Clinton’s 2008 and 2016 campaigns). This guaranteed them access to Hillary Clinton. 11) Qatar, meanwhile, donated millions to the Clinton Foundation. They hired Bill Clinton to make 2 speeches that paid him between $500,000 and $1 million dollars. They gave Slick Willy another $1 million as a birthday gift...aaahhh, isn't that sweet? 12) The $19 billion dollar sale from Ratheon to Qatar was...wait for it - approved by Hillary Clinton! Yeah!! 13) Heather Podesta, John Merrigan and Matt Berstein were paid $460,000 in Lobbying Fees by Ratheon 14) Hillary Clinton left the State Department 15) Ratheon released Podesta, Merrigan and Bernstein...as they no longer had direct and personal access to the Secretary of State. This is how it is done folks. This is pay-for-play. The ISIS supporting nation of Qatar gets advanced U.S. Military gear, the Clintons, the Podestas, and assorted others in the Clinton Crime Family get rich(er). There are still a lot of Americans who need to wake up, pay attention, and then make the right decision on November 8th.",
		"thread_title": "Podesta relative earned six-figure fees lobbying Clintons State Dept. during his tenure there",
		"title": "Podesta relative earned six-figure fees lobbying Clintons State Dept. during his tenure there",
		"type": "bs",
		"uuid": "38c469c205239cb94bcbe2ce0f14c72c449c7f02"
	},
	"-KhIaCUBz5nX1DLon51m": {
		"author": "Brandon Turbeville",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T23:40:33.528+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Brandon Turbeville",
				"salience": 0.29997444,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.1495201,
				"type": "OTHER"
			},
			{
				"name": "overdrive",
				"salience": 0.123319134,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.123319134,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.09319816,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01mxf7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Province,_Sri_Lanka"
				},
				"name": "Western",
				"salience": 0.090640984,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.06851704,
				"type": "EVENT"
			},
			{
				"name": "hospital bombings",
				"salience": 0.051511023,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T23:40:33.528+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Brandon Turbeville Over the past few days, the Western corporate press has kicked into overdrive with reports of hospital bombings, dead civilians, and war... ",
		"thread_title": "A Tale Of Two Cities: Mosul And Aleppo",
		"title": "A Tale Of Two Cities: Mosul And Aleppo",
		"type": "conspiracy",
		"uuid": "ffb4d6aafe739e06833f2567512023d7c4a454c3"
	},
	"-KhIaC_5pwMB-WgITZsz": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T03:50:22.157+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "parents",
				"salience": 0.2785423,
				"type": "PERSON"
			},
			{
				"name": "Mike Maharrey Today",
				"salience": 0.21573924,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.206735,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.10685014,
				"type": "PERSON"
			},
			{
				"name": "testing",
				"salience": 0.08802895,
				"type": "OTHER"
			},
			{
				"name": "statute",
				"salience": 0.044736817,
				"type": "WORK_OF_ART"
			},
			{
				"name": "effect",
				"salience": 0.036659043,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hjy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alaska"
				},
				"name": "Alaska",
				"salience": 0.022708517,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:50:22.157+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Mike Maharrey Today, a new law allowing parents to opt their children out of standardized testing in Alaska goes into effect. The new statute gives... ",
		"thread_title": "New Alaska Law Taking First Step Against Common Core",
		"title": "New Alaska Law Taking First Step Against Common Core",
		"type": "conspiracy",
		"uuid": "49139d100e5c90887f09316f35f10500ba726390"
	},
	"-KhIaCcozkzELcFk3XRR": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T04:30:27.564+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Everett Numbers",
				"salience": 0.25980178,
				"type": "PERSON"
			},
			{
				"name": "fixes",
				"salience": 0.16619064,
				"type": "OTHER"
			},
			{
				"name": "scandal",
				"salience": 0.12949632,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09w3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pentagon"
				},
				"name": "The Pentagon",
				"salience": 0.11445775,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.11445775,
				"type": "ORGANIZATION"
			},
			{
				"name": "soldiers",
				"salience": 0.08071703,
				"type": "PERSON"
			},
			{
				"name": "bonus payments",
				"salience": 0.06796727,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09gs3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Guard_of_the_United_States"
				},
				"name": "National Guard",
				"salience": 0.066911474,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T04:30:27.564+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Everett Numbers The Pentagon and Congress are both promising quick fixes to the scandal surrounding excessive National Guard bonus payments to soldiers. However, the... ",
		"thread_title": "Military Veteran Bonus Scandal Might Be Much Worse Than Initially Reported",
		"title": "Military Veteran Bonus Scandal Might Be Much Worse Than Initially Reported",
		"type": "conspiracy",
		"uuid": "893f398aceeccb501ca72e0f6acfcff25f0a15f7"
	},
	"-KhIaCr4hE-riXBhi6HW": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T04:44:47.307+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.36045793,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.27323854,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.045299288,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.034633335,
				"type": "ORGANIZATION"
			},
			{
				"name": "provocation",
				"salience": 0.028245455,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.012102927,
				"type": "LOCATION"
			},
			{
				"name": "cold war",
				"salience": 0.011463568,
				"type": "EVENT"
			},
			{
				"name": "borders",
				"salience": 0.010830223,
				"type": "LOCATION"
			},
			{
				"name": "tension",
				"salience": 0.009937333,
				"type": "OTHER"
			},
			{
				"name": "military buildup",
				"salience": 0.0089784935,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.008669515,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.008181162,
				"type": "PERSON"
			},
			{
				"name": "midst",
				"salience": 0.00778116,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0058767614,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0058767614,
				"type": "PERSON"
			},
			{
				"name": "John Vibes",
				"salience": 0.0057319417,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.005509737,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.0050914637,
				"type": "ORGANIZATION"
			},
			{
				"name": "thousands",
				"salience": 0.0048768,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0043081585,
				"type": "EVENT"
			},
			{
				"name": "equipment",
				"salience": 0.003983554,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.003983554,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.003702514,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.0034450055,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0032492217,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.0030052564,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.002776946,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/024gm7"
				},
				"name": "John",
				"salience": 0.0027470796,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0027215392,
				"type": "OTHER"
			},
			{
				"name": "military divisions",
				"salience": 0.002639812,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.002560467,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01b8g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jens_Stoltenberg"
				},
				"name": "Jens Stoltenberg",
				"salience": 0.0024993601,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0024541705,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Denmark",
				"salience": 0.0024541705,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0024541705,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0024541705,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.0024242764,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0024242764,
				"type": "PERSON"
			},
			{
				"name": "military deployment",
				"salience": 0.0020995934,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0020995934,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0020995934,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0017959495,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02r4y2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Douglas_Lute"
				},
				"name": "Douglas Lute",
				"salience": 0.0017913198,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.0017887686,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0017220529,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.0017003713,
				"type": "PERSON"
			},
			{
				"name": "TheFreeThoughtProject.com",
				"salience": 0.0016886774,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0016767299,
				"type": "WORK_OF_ART"
			},
			{
				"name": "drones",
				"salience": 0.0016419103,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.0016419103,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "total",
				"salience": 0.0016419103,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0016419103,
				"type": "PERSON"
			},
			{
				"name": "military build-up",
				"salience": 0.0016419103,
				"type": "EVENT"
			},
			{
				"name": "hardware",
				"salience": 0.0016419103,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0016419103,
				"type": "PERSON"
			},
			{
				"name": "addition",
				"salience": 0.0016419103,
				"type": "OTHER"
			},
			{
				"name": "third world war",
				"salience": 0.0016369484,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0015344078,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0014663734,
				"type": "LOCATION"
			},
			{
				"name": "tensions",
				"salience": 0.0014175993,
				"type": "OTHER"
			},
			{
				"name": "deployment",
				"salience": 0.0013997467,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0013365214,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0013013353,
				"type": "ORGANIZATION"
			},
			{
				"name": "deterrent",
				"salience": 0.0012800184,
				"type": "OTHER"
			},
			{
				"name": "publishing company",
				"salience": 0.001218816,
				"type": "ORGANIZATION"
			},
			{
				"name": "proxy war",
				"salience": 0.0012151316,
				"type": "EVENT"
			},
			{
				"name": "deployment",
				"salience": 0.0012022534,
				"type": "EVENT"
			},
			{
				"name": "cruise missiles",
				"salience": 0.0011514218,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.0011514218,
				"type": "OTHER"
			},
			{
				"name": "warheads",
				"salience": 0.0011514218,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0011084573,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0011084573,
				"type": "OTHER"
			},
			{
				"name": "Free Your Mind",
				"salience": 0.0010935371,
				"type": "EVENT"
			},
			{
				"name": "threat",
				"salience": 0.0010855552,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0010855552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonia",
				"salience": 0.0010108543,
				"type": "LOCATION"
			},
			{
				"name": "type",
				"salience": 0.00097648095,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00094003964,
				"type": "LOCATION"
			},
			{
				"name": "lands",
				"salience": 0.00094003964,
				"type": "LOCATION"
			},
			{
				"name": "someone",
				"salience": 0.00094003964,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.00094003964,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.00094003964,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0008935565,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.00088229915,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00088229915,
				"type": "PERSON"
			},
			{
				"name": "CONFIDENTIAL",
				"salience": 0.00075548043,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0007327609,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.0007087806,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dv_mb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/9K720_Iskander"
				},
				"name": "Iskander-M",
				"salience": 0.0007087806,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.0007087806,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/019tjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_states"
				},
				"name": "Baltics",
				"salience": 0.0007087806,
				"type": "LOCATION"
			},
			{
				"name": "superpowers",
				"salience": 0.0007022595,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0007022595,
				"type": "OTHER"
			},
			{
				"name": "odds",
				"salience": 0.0007022595,
				"type": "OTHER"
			},
			{
				"name": "researcher",
				"salience": 0.0007022595,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.0007022595,
				"type": "EVENT"
			},
			{
				"name": "fiction",
				"salience": 0.0007022595,
				"type": "OTHER"
			},
			{
				"name": "writers",
				"salience": 0.0007022595,
				"type": "PERSON"
			},
			{
				"name": "non-fiction",
				"salience": 0.0007022595,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0006632047,
				"type": "OTHER"
			},
			{
				"name": "subscription",
				"salience": 0.00059066527,
				"type": "OTHER"
			},
			{
				"name": "Report",
				"salience": 0.00059066527,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.0005880269,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/049hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kaliningrad"
				},
				"name": "Kaliningrad",
				"salience": 0.0005786246,
				"type": "LOCATION"
			},
			{
				"name": "change",
				"salience": 0.0005473896,
				"type": "EVENT"
			},
			{
				"name": "Collapse",
				"salience": 0.00051146274,
				"type": "EVENT"
			},
			{
				"name": "Ways",
				"salience": 0.00051146274,
				"type": "OTHER"
			},
			{
				"name": "treatments",
				"salience": 0.00051146274,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00051146274,
				"type": "OTHER"
			},
			{
				"name": "radiation",
				"salience": 0.00051146274,
				"type": "OTHER"
			},
			{
				"name": "chemo",
				"salience": 0.00051146274,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.00051146274,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.00051146274,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00051146274,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00049865304,
				"type": "WORK_OF_ART"
			},
			{
				"name": "result",
				"salience": 0.00049865304,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000492369,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00048868696,
				"type": "ORGANIZATION"
			},
			{
				"name": "military tensions",
				"salience": 0.00048868696,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00048868696,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.00047011458,
				"type": "OTHER"
			},
			{
				"name": "Activist Post Daily Newsletter Subscription",
				"salience": 0.0004685012,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.0004412289,
				"type": "EVENT"
			},
			{
				"name": "security posture",
				"salience": 0.0004412289,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0004412289,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.00038205856,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.00038205856,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00038205856,
				"type": "LOCATION"
			},
			{
				"name": "rebel groups",
				"salience": 0.00038205856,
				"type": "ORGANIZATION"
			},
			{
				"name": "others",
				"salience": 0.00033230582,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00031478264,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0003096498,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0002351313,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/10/2_11-1024x597.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T04:44:47.307+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By John Vibes \nIn the midst of deepening tension between US allies NATO and Russia, NATO is planning the largest military buildup along the Russian border since the cold war. \nNATO called on allied governments this week to contribute whatever troops and equipment they can to the effort. According to Reuters , thousands of troops are expected to arrive in the coming days and weeks. \nIt was reported that Italy, France, Denmark and other European states are expected to join the NATO military divisions that will be led by the United States along Russia’s border. \nOn Wednesday, Britain announced it is sending hundreds of soldiers and hardware to Russia’s borders as part of a huge military deployment. \nA total of 800 troops, drones and tanks are moving to Estonia as part of the biggest military build-up of NATO troops on Russia’s borders since the Cold War. \nIn addition to the forces allocated for his specific operation, NATO has an army of over 40,000 ready to be called up to fight at any time. \nThe US military claims that this threatening move is meant to act as a “deterrent” to the Russian military, but this is obvious a move that will escalate tensions and push towards a possible third world war. \n“This is a credible deterrence, not to provoke a conflict but to prevent conflict,” NATO Secretary-General Jens Stoltenberg said on Tuesday — ironically ignoring the fact that it is a de facto provocation. \nJust imagine what would happen if Russian troops amassed along the Mexican border and told the US that this move was to ‘prevent conflict.’ \nThe so-called Iskander-M cruise missiles can hit targets across Poland and the Baltics, although NATO officials declined to say if Russia had moved nuclear warheads to Kaliningrad. \nThe United States’ envoy to NATO, Douglas Lute, told reporters that NATO and the US military may consider Russia a threat if they had nuclear weapons within range of NATO’s deployment. This statement is insane considering the fact that the US military is the one that is many miles from home on the border of someone else’s lands. \n“This deployment, if it becomes permanent if the presence of nuclear weapons were confirmed, would be a change in (Russia’s) security posture,” Lute said. \nIf anyone is a threat, it is NATO and the US government. \nThese military tensions are the result of an ongoing proxy war in Syria, in which Western powers are attempting to institute a regime change in the country by funding violent rebel groups. Meanwhile, Russia has interests in keeping their allies in the Syrian government in control, putting the two superpowers at odds. \nUntil now, Russia and the US have been fighting through third parties, just as they had during the previous Cold War, and the same type of situation is developing today. \nJohn Vibes is an author and researcher who organizes a number of large events including the Free Your Mind Conference. He also has a publishing company where he offers a censorship free platform for both fiction and non-fiction writers. John writes for TheFreeThoughtProject.com , where this article first appeared . You can contact him and stay connected to his work at his Facebook page. John is currently battling cancer naturally , without any chemo or radiation, and will be working to help others through his experience, if you wish to contribute to his treatments please donate here . Activist Post Daily Newsletter Subscription is FREE and CONFIDENTIAL Free Report: 10 Ways to Survive the Economic Collapse with subscription",
		"thread_title": "NATO, US, And UK Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"title": "NATO, US, And UK Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"type": "conspiracy",
		"uuid": "d10f978329e58cce0c9dd1639b3e3c9595ee95ef"
	},
	"-KhIaD2KoXJtBRtW5-P2": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T04:44:47.443+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05pd98l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Dynamics_Land_Systems"
				},
				"name": "General Dynamics Land Systems",
				"salience": 0.07141292,
				"type": "ORGANIZATION"
			},
			{
				"name": "army",
				"salience": 0.053916797,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.05301723,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0268g3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raymond_T._Odierno"
				},
				"name": "Raymond Odierno",
				"salience": 0.04626343,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.04509856,
				"type": "EVENT"
			},
			{
				"name": "hit",
				"salience": 0.04165284,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.039124765,
				"type": "WORK_OF_ART"
			},
			{
				"name": "folk hero",
				"salience": 0.039124765,
				"type": "OTHER"
			},
			{
				"name": "tank",
				"salience": 0.035420008,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Iraqi Counter-Terror Services",
				"salience": 0.03088018,
				"type": "ORGANIZATION"
			},
			{
				"name": "destruction",
				"salience": 0.025851918,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.024692278,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.02419261,
				"type": "LOCATION"
			},
			{
				"name": "Blacklisted News",
				"salience": 0.02419261,
				"type": "OTHER"
			},
			{
				"name": "Kurt Nimmo",
				"salience": 0.02419261,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.022182513,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09dwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/M1_Abrams"
				},
				"name": "Abrams",
				"salience": 0.021615665,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.020095678,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.016317379,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.015863352,
				"type": "LOCATION"
			},
			{
				"name": "tank",
				"salience": 0.014671329,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.01239686,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tb56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/9M133_Kornet"
				},
				"name": "Kornet",
				"salience": 0.01239686,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c1r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-tank_missile"
				},
				"name": "ATGM",
				"salience": 0.01239686,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "Army",
				"salience": 0.011039606,
				"type": "ORGANIZATION"
			},
			{
				"name": "battle tank",
				"salience": 0.010833514,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03dnvd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mac_Thornberry"
				},
				"name": "Mac Thornberry",
				"salience": 0.010312978,
				"type": "PERSON"
			},
			{
				"name": "stockholder",
				"salience": 0.00958157,
				"type": "PERSON"
			},
			{
				"name": "crew",
				"salience": 0.00958157,
				"type": "PERSON"
			},
			{
				"name": "commodity",
				"salience": 0.008443005,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.008412215,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.008412215,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tanks",
				"salience": 0.007997033,
				"type": "OTHER"
			},
			{
				"name": "Maj. Gen. Thomas A. Horlander",
				"salience": 0.0077094063,
				"type": "PERSON"
			},
			{
				"name": "tank fleet",
				"salience": 0.0075005796,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.007201563,
				"type": "ORGANIZATION"
			},
			{
				"name": "problem",
				"salience": 0.00695204,
				"type": "OTHER"
			},
			{
				"name": "tank crew",
				"salience": 0.006722948,
				"type": "PERSON"
			},
			{
				"name": "Military readiness",
				"salience": 0.006125324,
				"type": "OTHER"
			},
			{
				"name": "contract",
				"salience": 0.00607959,
				"type": "OTHER"
			},
			{
				"name": "average",
				"salience": 0.0058227996,
				"type": "OTHER"
			},
			{
				"name": "shape",
				"salience": 0.0058227996,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0058227996,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0056057354,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0056057354,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Defense",
				"salience": 0.0051125656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_bp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chrysler"
				},
				"name": "Chrysler",
				"salience": 0.0051125656,
				"type": "ORGANIZATION"
			},
			{
				"name": "consumable",
				"salience": 0.005065579,
				"type": "OTHER"
			},
			{
				"name": "weapon systems",
				"salience": 0.004917399,
				"type": "OTHER"
			},
			{
				"name": "chairman",
				"salience": 0.004754701,
				"type": "PERSON"
			},
			{
				"name": "services",
				"salience": 0.0045432015,
				"type": "OTHER"
			},
			{
				"name": "controls",
				"salience": 0.0045432015,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.0044860085,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.004102429,
				"type": "OTHER"
			},
			{
				"name": "stock",
				"salience": 0.0038996886,
				"type": "OTHER"
			},
			{
				"name": "production decision-making",
				"salience": 0.0035527467,
				"type": "OTHER"
			},
			{
				"name": "support systems requirements",
				"salience": 0.0035527467,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.0035527467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/046lmc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Committee_on_Armed_Services"
				},
				"name": "House Armed Services Committee",
				"salience": 0.0033806516,
				"type": "ORGANIZATION"
			},
			{
				"name": "contract",
				"salience": 0.003309693,
				"type": "OTHER"
			},
			{
				"name": "Budgets",
				"salience": 0.003309693,
				"type": "OTHER"
			},
			{
				"name": "producer",
				"salience": 0.003183993,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0029884784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.002927589,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.002927589,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.002927589,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.002927589,
				"type": "PERSON"
			},
			{
				"name": "engineering",
				"salience": 0.002900665,
				"type": "OTHER"
			},
			{
				"name": "rocket system",
				"salience": 0.0026765482,
				"type": "OTHER"
			},
			{
				"name": "exporter",
				"salience": 0.0025879298,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0025879298,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0025879298,
				"type": "ORGANIZATION"
			},
			{
				"name": "Military hardware",
				"salience": 0.0024913596,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c1wvb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MarketWatch"
				},
				"name": "MarketWatch",
				"salience": 0.0021871915,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07xg1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Armed_Forces"
				},
				"name": "U.S. Military",
				"salience": 0.0020374984,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporation",
				"salience": 0.00193338,
				"type": "ORGANIZATION"
			},
			{
				"name": "Obama FY2010",
				"salience": 0.0015930281,
				"type": "PERSON"
			},
			{
				"name": "Bush Jr FY2002",
				"salience": 0.0015930281,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0011900169,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/10/us-tank.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T04:44:47.443+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Kurt Nimmo, Blacklisted News \nIn the video below the “folk hero” of the Iraqi Counter-Terror Services and regular Iraqi army takes a direct hit in the battle for Mosul. \nThe destruction of an Abrams tank by a Russian ATGM Kornet missile is good news if you’re a stockholder in General Dynamics Land Systems, formerly Chrysler Defense. \nGeneral Dynamics makes the Abrams battle tank. \nEach one costs $9 million. \nThe US will simply ship another tank to replace the one destroyed along with its presumed Iraqi crew. Iraqi lives are a cheap commodity, so it will not be a problem to find another expendable tank crew. \nBack in 2012 former Army Chief of Staff Gen. Raymond Odierno testified to Congress that the Army has more than enough tanks. He suggested the line at General Dynamics be shut down temporarily. “Our tank fleet is two and a half years old on average now. We’re in good shape and these are additional tanks that we don’t need,” he said. \nCongress budgeted more money for new tanks anyway. Rep. Mac Thornberry, a Texas Republican and chairman of the House Armed Services Committee, said more tanks were needed in Europe to confront Vladimir Putin. \nMilitary readiness is a “consumable,” said Maj. Gen. Thomas A. Horlander, the Army’s budget director. Military hardware is “cumulative,” according to the Pentagon. \nOn Tuesday General Dynamics stock opened at $151.21 and closed at $152.59. Last week the corporation was awarded a $170 million contract for an air-to-ground rocket system. Earlier this month General Dynamics was awarded a $900 million contract over five years to provide engineering and technical services for major weapon systems, program technical assistance, support systems requirements and assist with production decision-making and program controls, according to MarketWatch . \nThe United States is the largest producer and exporter of weapons in the world. The US armed forces budget topped out over $600 billion in 2015. \nU.S. Military Budgets 1948-2015 \nObama FY2010-15 $663.4 billion per year Bush Jr FY2002-09* $634.9",
		"thread_title": "Destruction of US Abrams Tank: Mosul Offensive Good for General Dynamics",
		"title": "Destruction of US Abrams Tank: Mosul Offensive Good for General Dynamics",
		"type": "conspiracy",
		"uuid": "26464c21f1efb9715156e153ad0c9a5845776a20"
	},
	"-KhIaD6HupPp3PgZuihE": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T18:00:33.040+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04f6_3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Op-ed"
				},
				"name": "Op-Ed",
				"salience": 0.34781864,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.13647954,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.13160446,
				"type": "OTHER"
			},
			{
				"name": "Laraine C. Abbey",
				"salience": 0.12046943,
				"type": "PERSON"
			},
			{
				"name": "destruction",
				"salience": 0.090085536,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.070130736,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.070130736,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.033280935,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T18:00:33.040+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "Op-Ed by Laraine C. Abbey The political story of our time is less about Hillary or Trump than what many believe is the destruction of... ",
		"thread_title": "A Conundrum of the Current Political Season",
		"title": "A Conundrum of the Current Political Season",
		"type": "conspiracy",
		"uuid": "16e0c4cf5d39e240ac5c71cbc9748f20dfc9928c"
	},
	"-KhIaDAnVLBEhg2FqZow": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T18:35:43.561+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04f6_3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Op-ed"
				},
				"name": "Op-Ed",
				"salience": 0.40864557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.22397844,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.06946675,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.06946675,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.066975236,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Laraine C. Abbey",
				"salience": 0.061287265,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.05713597,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.043044038,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T18:35:43.561+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "Op-Ed by Laraine C. Abbey President Obama’s statement “giving up some freedom in exchange for security” [1] was a lance through my heart. Give up... ",
		"thread_title": "Liberty or State Control? You Decide",
		"title": "Liberty or State Control? You Decide",
		"type": "conspiracy",
		"uuid": "1c00b306dfea15a2d321e1f6909ab78cffe251b9"
	},
	"-KhIaDEqKBLwhv5S2kjr": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T19:20:39.827+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0vzv0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edward_Snowden"
				},
				"name": "Edward Snowden",
				"salience": 0.5152855,
				"type": "PERSON"
			},
			{
				"name": "Nika Knight",
				"salience": 0.16048442,
				"type": "PERSON"
			},
			{
				"name": "reporters",
				"salience": 0.079483844,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.07665863,
				"type": "ORGANIZATION"
			},
			{
				"name": "era",
				"salience": 0.06548311,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.048064552,
				"type": "LOCATION"
			},
			{
				"name": "journalists",
				"salience": 0.027269986,
				"type": "PERSON"
			},
			{
				"name": "mass surveillance",
				"salience": 0.027269986,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T19:20:39.827+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.5,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Nika Knight Whistleblower Edward Snowden warned a group of European reporters Wednesday that in the era of mass surveillance, journalists are increasingly a threatened... ",
		"thread_title": "Snowden: “Journalists Are a Threatened Class” in Era of Mass Surveillance",
		"title": "Snowden: “Journalists Are a Threatened Class” in Era of Mass Surveillance",
		"type": "conspiracy",
		"uuid": "37a8ada3fb420069c88f99eb24de7754f07cd32d"
	},
	"-KhIaDIWHRSwTwKFIJPN": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T19:50:29.983+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Melissa Dykes",
				"salience": 0.23244333,
				"type": "PERSON"
			},
			{
				"name": "oligarchy",
				"salience": 0.16028133,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.16028133,
				"type": "OTHER"
			},
			{
				"name": "Reaction",
				"salience": 0.114521645,
				"type": "OTHER"
			},
			{
				"name": "Solution",
				"salience": 0.114521645,
				"type": "OTHER"
			},
			{
				"name": "Problem",
				"salience": 0.11043091,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.049011093,
				"type": "OTHER"
			},
			{
				"name": "shadow",
				"salience": 0.036787145,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.021721568,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T19:50:29.983+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Melissa Dykes The oligarchy runs our society with Problem – Reaction – Solution. If anything, these leaks have proven beyond a shadow of a... ",
		"thread_title": "We Now Have Proof Obamacare Was Designed to Fail… and Here’s Why",
		"title": "We Now Have Proof Obamacare Was Designed to Fail… and Here’s Why",
		"type": "conspiracy",
		"uuid": "adb1d66e3b41ce73354e158ebfb43df88fc7bea5"
	},
	"-KhIaDNDg1yA3Vv2wAIn": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T21:10:29.195+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "opponents",
				"salience": 0.41100776,
				"type": "PERSON"
			},
			{
				"name": "Jay Syrmopoulos Pipeline",
				"salience": 0.23919624,
				"type": "PERSON"
			},
			{
				"name": "oil pipeline",
				"salience": 0.09933346,
				"type": "OTHER"
			},
			{
				"name": "water supply",
				"salience": 0.07957466,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access",
				"salience": 0.0660525,
				"type": "OTHER"
			},
			{
				"name": "DAPL",
				"salience": 0.05426866,
				"type": "ORGANIZATION"
			},
			{
				"name": "destruction",
				"salience": 0.05056673,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T21:10:29.195+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jay Syrmopoulos Pipeline opponents attempting to protect their water supply from the Dakota Access oil pipeline (DAPL), as well as prevent the continued destruction... ",
		"thread_title": "No-Fly Zone Declared as Militarized Police Prep for Assault on “Front-Line Camp” at Standing Rock",
		"title": "No-Fly Zone Declared as Militarized Police Prep for Assault on “Front-Line Camp” at Standing Rock",
		"type": "conspiracy",
		"uuid": "819e8ccd8da0c4308b215d3f898fe90f16ce0995"
	},
	"-KhIaDRK0-po-MlxGR9Y": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:00:41.110+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Anonymity",
				"salience": 0.58055717,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rj_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberty"
				},
				"name": "Liberty",
				"salience": 0.10987514,
				"type": "ORGANIZATION"
			},
			{
				"name": "Paul Stevens",
				"salience": 0.10545061,
				"type": "PERSON"
			},
			{
				"name": "shield",
				"salience": 0.08039364,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.054133978,
				"type": "OTHER"
			},
			{
				"name": "tyranny",
				"salience": 0.0522003,
				"type": "PERSON"
			},
			{
				"name": "internet",
				"salience": 0.017389152,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T01:00:41.110+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Learn Liberty “Anonymity is a shield from the tyranny of the majority” – Justice Paul Stevens. When we think of anonymity on the internet,... ",
		"thread_title": "Anonymity: The Greatest Weapon Against Oppression",
		"title": "Anonymity: The Greatest Weapon Against Oppression",
		"type": "conspiracy",
		"uuid": "1c05d3fb8fb2ae6efdb65f47881c28c59801f831"
	},
	"-KhIaDVtf1fQbx9X75lG": {
		"author": "Brandon Turbeville",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T07:35:29.388+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.5193515,
				"type": "LOCATION"
			},
			{
				"name": "Brandon Turbeville",
				"salience": 0.19386534,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.09663078,
				"type": "EVENT"
			},
			{
				"name": "terror",
				"salience": 0.09663078,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.06023144,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.033290178,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T07:35:29.388+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.8
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Brandon Turbeville As the United States marches forward with its war of terror abroad it is, as predicted by researchers and informed observers many... ",
		"thread_title": "U.S. Takes A Stab At A No Fly Zone In Two Places – Syria And Standing Rock",
		"title": "U.S. Takes A Stab At A No Fly Zone In Two Places – Syria And Standing Rock",
		"type": "conspiracy",
		"uuid": "07517581586f16e842364402f43ed60f3a472858"
	},
	"-KhIaD_C-wBHGT3kqjwr": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T18:20:46.917+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Nick Bernabe",
				"salience": 0.351656,
				"type": "PERSON"
			},
			{
				"name": "site",
				"salience": 0.17226577,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock Sioux",
				"salience": 0.15806703,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.112990625,
				"type": "LOCATION"
			},
			{
				"name": "news narrative",
				"salience": 0.111998156,
				"type": "OTHER"
			},
			{
				"name": "Sacred Stone Camp",
				"salience": 0.09302244,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T18:20:46.917+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Nick Bernabe A small Standing Rock Sioux site in North Dakota called the Sacred Stone Camp has been propelled into the national news narrative following... ",
		"thread_title": "5 Things You Need to Know About the Dakota Access Pipeline Protests",
		"title": "5 Things You Need to Know About the Dakota Access Pipeline Protests",
		"type": "conspiracy",
		"uuid": "b60aad27d903c253a16dec459bac8dccb5aae020"
	},
	"-KhIaDcpqMCkd_3WWXzX": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T19:31:11.746+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Vic Bishop",
				"salience": 0.25689495,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.20424865,
				"type": "EVENT"
			},
			{
				"name": "concerns",
				"salience": 0.12906505,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.12906505,
				"type": "OTHER"
			},
			{
				"name": "corner",
				"salience": 0.12454003,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.11418129,
				"type": "LOCATION"
			},
			{
				"name": "schools",
				"salience": 0.042004988,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T19:31:11.746+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Vic Bishop With the U.S. presidential elections just around the corner, concerns about violence on Election Day seem to be escalating. Several schools have announced... ",
		"thread_title": "Americans Preparing for Strong Possibility of Violence on Election Day",
		"title": "Americans Preparing for Strong Possibility of Violence on Election Day",
		"type": "conspiracy",
		"uuid": "ae80fc789ca5160c2c060ca8e5cb109c6b1bd260"
	},
	"-KhIaE3DHCQR9XG3RipA": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T19:38:59.262+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/011p3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aung_San_Suu_Kyi"
				},
				"name": "Aung San Suu Kyi",
				"salience": 0.6311462,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04xn_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Myanmar"
				},
				"name": "Myanmar",
				"salience": 0.07110532,
				"type": "LOCATION"
			},
			{
				"name": "leader",
				"salience": 0.043896973,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.027960492,
				"type": "OTHER"
			},
			{
				"name": "Tony Cartalucci",
				"salience": 0.01228078,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/057xrpg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norddeutscher_Lloyd"
				},
				"name": "NDL",
				"salience": 0.012136164,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0075351787,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0l8pdhc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eleven_Media_Group"
				},
				"name": "Eleven Media Group",
				"salience": 0.00696438,
				"type": "ORGANIZATION"
			},
			{
				"name": "rule",
				"salience": 0.0050716195,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.0047221025,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0046884045,
				"type": "ORGANIZATION"
			},
			{
				"name": "post",
				"salience": 0.0045028776,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hypocrisy",
				"salience": 0.004395587,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.003762591,
				"type": "WORK_OF_ART"
			},
			{
				"name": "irony",
				"salience": 0.0036686447,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0036686447,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.003605616,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0034617009,
				"type": "ORGANIZATION"
			},
			{
				"name": "Inhumane Humanitarian Another",
				"salience": 0.0031677182,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0028744286,
				"type": "OTHER"
			},
			{
				"name": "foreign minister",
				"salience": 0.0028419497,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.00265592,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00265592,
				"type": "LOCATION"
			},
			{
				"name": "Nay Myo Kyaw",
				"salience": 0.0026516463,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.0025331704,
				"type": "PERSON"
			},
			{
				"name": "State Counsellor",
				"salience": 0.0023984883,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0023984883,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0022656042,
				"type": "LOCATION"
			},
			{
				"name": "principles",
				"salience": 0.0021468652,
				"type": "OTHER"
			},
			{
				"name": "opponents",
				"salience": 0.0020773758,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0020294525,
				"type": "PERSON"
			},
			{
				"name": "foreign",
				"salience": 0.0018759222,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.0018759222,
				"type": "WORK_OF_ART"
			},
			{
				"name": "office",
				"salience": 0.0018675538,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0016699277,
				"type": "ORGANIZATION"
			},
			{
				"name": "contravention",
				"salience": 0.0016246649,
				"type": "OTHER"
			},
			{
				"name": "purge",
				"salience": 0.0016246649,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0016246649,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.0016246649,
				"type": "PERSON"
			},
			{
				"name": "citizenship",
				"salience": 0.0016246649,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.0016246649,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0250jt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_League_for_Democracy"
				},
				"name": "National League for Democracy",
				"salience": 0.0015598413,
				"type": "ORGANIZATION"
			},
			{
				"name": "somebody",
				"salience": 0.0015539591,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/073q1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southeast_Asia"
				},
				"name": "Southeast Asian",
				"salience": 0.0015140293,
				"type": "LOCATION"
			},
			{
				"name": "Mike Tee",
				"salience": 0.0015023882,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0014402134,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.0012946347,
				"type": "PERSON"
			},
			{
				"name": "military government",
				"salience": 0.0012798227,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0012637074,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0011688655,
				"type": "ORGANIZATION"
			},
			{
				"name": "Off The West",
				"salience": 0.0011356794,
				"type": "LOCATION"
			},
			{
				"name": "Aung Myint Tun",
				"salience": 0.0011042088,
				"type": "PERSON"
			},
			{
				"name": "Htin Kyaw",
				"salience": 0.0011042088,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0010947024,
				"type": "PERSON"
			},
			{
				"name": "military rule",
				"salience": 0.0010943647,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0010943647,
				"type": "LOCATION"
			},
			{
				"name": "leader",
				"salience": 0.0010437153,
				"type": "PERSON"
			},
			{
				"name": "facades",
				"salience": 0.0010045144,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0009881502,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0009881502,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0009817566,
				"type": "LOCATION"
			},
			{
				"name": "Nay Myo Wai",
				"salience": 0.0009562205,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.00091670733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0008861853,
				"type": "ORGANIZATION"
			},
			{
				"name": "sons",
				"salience": 0.00087314704,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.00085570384,
				"type": "WORK_OF_ART"
			},
			{
				"name": "governments",
				"salience": 0.00084759283,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.00083065254,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00077263603,
				"type": "PERSON"
			},
			{
				"name": "de facto",
				"salience": 0.00077263603,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0007702999,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0007702999,
				"type": "OTHER"
			},
			{
				"name": "Telecommunications Law",
				"salience": 0.00075466826,
				"type": "OTHER"
			},
			{
				"name": "rule of law",
				"salience": 0.0007387571,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0007387571,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.00073186896,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.00072349125,
				"type": "ORGANIZATION"
			},
			{
				"name": "husband",
				"salience": 0.0007038643,
				"type": "PERSON"
			},
			{
				"name": "advocates",
				"salience": 0.0006999924,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.0006781472,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00066905795,
				"type": "OTHER"
			},
			{
				"name": "essence",
				"salience": 0.00066905795,
				"type": "OTHER"
			},
			{
				"name": "house arrest",
				"salience": 0.00066905795,
				"type": "EVENT"
			},
			{
				"name": "side-stepping",
				"salience": 0.00066905795,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0006670348,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0006670348,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.00065523153,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/033829",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St%C3%A9phane_Dion"
				},
				"name": "Stéphane Dion",
				"salience": 0.0006423398,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.0006262557,
				"type": "LOCATION"
			},
			{
				"name": "shirts",
				"salience": 0.000620047,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "organizations",
				"salience": 0.0006000009,
				"type": "ORGANIZATION"
			},
			{
				"name": "article",
				"salience": 0.0006000009,
				"type": "WORK_OF_ART"
			},
			{
				"name": "jail",
				"salience": 0.0006000009,
				"type": "LOCATION"
			},
			{
				"name": "court",
				"salience": 0.0006000009,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.0006000009,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0005974898,
				"type": "ORGANIZATION"
			},
			{
				"name": "posts",
				"salience": 0.0005974898,
				"type": "WORK_OF_ART"
			},
			{
				"name": "both",
				"salience": 0.00057760574,
				"type": "OTHER"
			},
			{
				"name": "opponents",
				"salience": 0.00057760574,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.00057760574,
				"type": "LOCATION"
			},
			{
				"name": "opponents",
				"salience": 0.00057760574,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00057462434,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.000541743,
				"type": "PERSON"
			},
			{
				"name": "censorship",
				"salience": 0.000541743,
				"type": "OTHER"
			},
			{
				"name": "writing",
				"salience": 0.000541743,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0005404821,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0005404821,
				"type": "ORGANIZATION"
			},
			{
				"name": "champion",
				"salience": 0.00052152126,
				"type": "PERSON"
			},
			{
				"name": "account",
				"salience": 0.00049572764,
				"type": "OTHER"
			},
			{
				"name": "Section 66",
				"salience": 0.00049217464,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0004920208,
				"type": "LOCATION"
			},
			{
				"name": "jail",
				"salience": 0.0004898231,
				"type": "LOCATION"
			},
			{
				"name": "article",
				"salience": 0.0004898231,
				"type": "WORK_OF_ART"
			},
			{
				"name": "human rights",
				"salience": 0.0004880006,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0004880006,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.00046910436,
				"type": "OTHER"
			},
			{
				"name": "media fronts",
				"salience": 0.00046910436,
				"type": "OTHER"
			},
			{
				"name": "photos",
				"salience": 0.00046910436,
				"type": "WORK_OF_ART"
			},
			{
				"name": "offender",
				"salience": 0.00046910436,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00046801247,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00046801247,
				"type": "OTHER"
			},
			{
				"name": "rule of law",
				"salience": 0.00046801247,
				"type": "OTHER"
			},
			{
				"name": "rule of law",
				"salience": 0.00046801247,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00046801247,
				"type": "OTHER"
			},
			{
				"name": "Aung Win Hlaing",
				"salience": 0.00045578674,
				"type": "PERSON"
			},
			{
				"name": "myth",
				"salience": 0.00045159284,
				"type": "OTHER"
			},
			{
				"name": "laureate",
				"salience": 0.00045159284,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.00045159284,
				"type": "EVENT"
			},
			{
				"name": "protection",
				"salience": 0.00045159284,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00045159284,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.00045159284,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00045159284,
				"type": "OTHER"
			},
			{
				"name": "crush",
				"salience": 0.00045159284,
				"type": "OTHER"
			},
			{
				"name": "backers",
				"salience": 0.00045159284,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00045159284,
				"type": "ORGANIZATION"
			},
			{
				"name": "action",
				"salience": 0.00044225858,
				"type": "OTHER"
			},
			{
				"name": "advocates",
				"salience": 0.00042967772,
				"type": "PERSON"
			},
			{
				"name": "State Counsellor",
				"salience": 0.00042648948,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00042256506,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00041181373,
				"type": "LOCATION"
			},
			{
				"name": "hypocrisy",
				"salience": 0.00039607423,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00039363615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jqvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rule_of_law"
				},
				"name": "Rule of Law",
				"salience": 0.00038561132,
				"type": "ORGANIZATION"
			},
			{
				"name": "name",
				"salience": 0.00038295434,
				"type": "OTHER"
			},
			{
				"name": "resignation letter",
				"salience": 0.00038295434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wording",
				"salience": 0.00038295434,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.00038295434,
				"type": "EVENT"
			},
			{
				"name": "person",
				"salience": 0.00038295434,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03h3yl3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dagon_Township"
				},
				"name": "North Dagon Township",
				"salience": 0.00036929906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07l4fs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Okkalapa_Township"
				},
				"name": "North Okkalapa Township",
				"salience": 0.00036929906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j9q9bt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zaw_Zaw"
				},
				"name": "Zaw Zaw",
				"salience": 0.00036929906,
				"type": "PERSON"
			},
			{
				"name": "silence",
				"salience": 0.0003686577,
				"type": "OTHER"
			},
			{
				"name": "human rights advocacy organizations",
				"salience": 0.00036590072,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00036019666,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01j1gk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Globe_and_Mail"
				},
				"name": "The Globe and Mail",
				"salience": 0.00035819074,
				"type": "ORGANIZATION"
			},
			{
				"name": "rights",
				"salience": 0.00035540882,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.00035540882,
				"type": "OTHER"
			},
			{
				"name": "Hla Phone",
				"salience": 0.00034921936,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Peace and Diversity Party",
				"salience": 0.00034816304,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00034084983,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00034084983,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.00033885322,
				"type": "PERSON"
			},
			{
				"name": "complaints",
				"salience": 0.0003348166,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00033036602,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00033036602,
				"type": "OTHER"
			},
			{
				"name": "champions",
				"salience": 0.00033036602,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00033036602,
				"type": "PERSON"
			},
			{
				"name": "rhetoric",
				"salience": 0.00031262098,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.00029404182,
				"type": "OTHER"
			},
			{
				"name": "Nga Pha",
				"salience": 0.00028871893,
				"type": "OTHER"
			},
			{
				"name": "hypocrites",
				"salience": 0.0002884525,
				"type": "OTHER"
			},
			{
				"name": "hypocrisy",
				"salience": 0.0002884525,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.0002860619,
				"type": "OTHER"
			},
			{
				"name": "track",
				"salience": 0.0002860619,
				"type": "OTHER"
			},
			{
				"name": "Dictators",
				"salience": 0.0002860619,
				"type": "PERSON"
			},
			{
				"name": "breaches",
				"salience": 0.0002860619,
				"type": "EVENT"
			},
			{
				"name": "sanctions",
				"salience": 0.0002860619,
				"type": "OTHER"
			},
			{
				"name": "condemnation",
				"salience": 0.0002860619,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0002860619,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.0002860619,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0002860619,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05f3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Peace_Prize"
				},
				"name": "Nobel Peace Prize",
				"salience": 0.0002779394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "United Kingdom",
				"salience": 0.0002779394,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06613z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rohingya_people"
				},
				"name": "Rohingya",
				"salience": 0.0002779394,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ln61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reporters_Without_Borders"
				},
				"name": "Reporters without Borders",
				"salience": 0.00026775527,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizations",
				"salience": 0.0002664757,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime",
				"salience": 0.0002664757,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.0002664757,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.0002664757,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.00026293332,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.00024281521,
				"type": "WORK_OF_ART"
			},
			{
				"name": "group",
				"salience": 0.00024281521,
				"type": "ORGANIZATION"
			},
			{
				"name": "posts",
				"salience": 0.00024281521,
				"type": "WORK_OF_ART"
			},
			{
				"name": "posts",
				"salience": 0.00024281521,
				"type": "WORK_OF_ART"
			},
			{
				"name": "group",
				"salience": 0.00024281521,
				"type": "ORGANIZATION"
			},
			{
				"name": "proxies",
				"salience": 0.00024059456,
				"type": "OTHER"
			},
			{
				"name": "writer",
				"salience": 0.00024059456,
				"type": "PERSON"
			},
			{
				"name": "proxies",
				"salience": 0.00024059456,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.00024059456,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.00024059456,
				"type": "OTHER"
			},
			{
				"name": "Ko Pho Htaung",
				"salience": 0.000235689,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nyar Thar",
				"salience": 0.000235689,
				"type": "LOCATION"
			},
			{
				"name": "Yar Pyay",
				"salience": 0.000235689,
				"type": "ORGANIZATION"
			},
			{
				"name": "Network of Supporters",
				"salience": 0.000235689,
				"type": "ORGANIZATION"
			},
			{
				"name": "process",
				"salience": 0.00021640724,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0002154654,
				"type": "OTHER"
			},
			{
				"name": "pretexts",
				"salience": 0.000208327,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.000208327,
				"type": "OTHER"
			},
			{
				"name": "magazine",
				"salience": 0.000208327,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mind",
				"salience": 0.000208327,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.000208327,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.00020331971,
				"type": "ORGANIZATION"
			},
			{
				"name": "complaints",
				"salience": 0.00019904837,
				"type": "OTHER"
			},
			{
				"name": "complaints",
				"salience": 0.00019904837,
				"type": "OTHER"
			},
			{
				"name": "The Myawady Township Court",
				"salience": 0.00019586488,
				"type": "ORGANIZATION"
			},
			{
				"name": "abuse",
				"salience": 0.00017971493,
				"type": "OTHER"
			},
			{
				"name": "censorship",
				"salience": 0.00017971493,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.00017971493,
				"type": "PERSON"
			},
			{
				"name": "account",
				"salience": 0.00017971493,
				"type": "OTHER"
			},
			{
				"name": "audiences",
				"salience": 0.00017443014,
				"type": "PERSON"
			},
			{
				"name": "advantage",
				"salience": 0.00016580043,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00015561111,
				"type": "LOCATION"
			},
			{
				"name": "regards",
				"salience": 0.00015561111,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.00015561111,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.00015561111,
				"type": "PERSON"
			},
			{
				"name": "Commander-in-Chief",
				"salience": 0.00015561111,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.00015561111,
				"type": "OTHER"
			},
			{
				"name": "critics",
				"salience": 0.00015561111,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.00015561111,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00014420693,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05f9k82",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Institute_of_Oriental_Studies_of_the_Russian_Academy_of_Sciences"
				},
				"name": "New Eastern Outlook",
				"salience": 0.00012820665,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fn2g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bangkok"
				},
				"name": "Bangkok",
				"salience": 0.00012820665,
				"type": "LOCATION"
			},
			{
				"name": "Than Tun Zaw",
				"salience": 0.00012249607,
				"type": "PERSON"
			},
			{
				"name": "Myat Maw",
				"salience": 0.00009576291,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ckxt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Watch"
				},
				"name": "Human Rights Watch",
				"salience": 0.00007430348,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/10/suu-kyi.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T19:38:59.262+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 16,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Tony Cartalucci \nMyanmar’s defacto leader, Aung San Suu Kyi of the National League for Democracy (NDL) political party, has paved her time since coming to power earlier this year with both irony and hypocrisy. She has not only illegally declared herself “leader” of the Southeast Asian state in contravention of its constitution, she has also embarked on an iron-fisted purge of her political opponents identical to the one she fought against as she struggled to seize power to begin with. \nDuring elections earlier this year, Myanmar’s constitution prevented Suu Kyi from holding the nation’s highest office due to her inordinate amount of time overseas, her status of having been married to a foreign, and her children’s dual citizenship. Instead of adhering to the law, her party once in power, simply contrived an entirely new post for her, State Counsellor of Myanmar, which makes her the “defacto leader” of Myanmar. \nCanada’s The Globe and Mail in an article titled, “Stéphane Dion says Aung San Suu Kyi is the ‘de facto’ leader of Myanmar,” would note that Canada’s government recognized this legal side-stepping, stating: \nDion called Suu Kyi, now Myanmar’s foreign minister, “the de facto national leader” of her country “because they have a strange rule that if you have married somebody who’s not of the country, you cannot be the leader of the government and of the state.” \nSuu Kyi, the internationally recognized democracy advocate, is barred from becoming president because her late husband was British, as are her two sons. The rule was crafted during Myanmar’s decades of military rule, which Suu Kyi fought against during years of house arrest before finally prevailing last fall. \nIn essence, she is unelected, and illegally holding power. For a woman who’s Western backers – particularly in the United States and United Kingdom – have held her up as a champion for democracy and the rule of law, she and her party’s first act upon taking power was trampling both. The Inhumane Humanitarian \nAnother myth built up around Nobel Peace Prize laureate Suu Kyi by the West has been her advocacy for “human rights.” Her advocacy for human rights, however, appears only to extend out to protect only as far as her immediate political allies are concerned. For groups beyond this self-serving political protection, and particularly regarding her political opponents, she and her NDL are just as eager to jail, crush, or kill political opponents as they claimed the ruling military government had been. \nIn addition to escalating violence targeting the nation’s Rohingya’s population, several activists online have been sent to jail for “insulting” the ruling government and Western-backed media fronts and organizations. \nMyanmar’s Eleven Media Group (EMG) in its article, “Facebook offender brought to court for insulting Suu Kyi,” attempted to distance what Suu Kyi and her political supporters had once called draconian censorship as now, a simple matter of enforcing the law. It would state: \nA Facebook user named Zaw Zaw (aka Nga Pha) was brought to the North Dagon Township court on October 24 to face prosecution for his defamatory posts about State Counsellor Aung San Suu Kyi. \nHe has been charged under Section 66(d) of the Telecommunications Law. \n“He’s being sued for defamatory writing and photos about the State Counsellor [posted on Facebook],” said plaintiff Nay Myo Kyaw, a 34-year-old resident of North Okkalapa Township. \nAround 50 people showed up at the hearing wearing shirts affiliated with a group called the Network of Supporters of the Rule of Law. They shouted: “You deserved it for insulting a good person.” \nThe article also admits: \nThe Myawady Township Court sentenced Aung Win Hlaing (aka A Nyar Thar), the first man to be prosecuted under the current government, for defamatory posts on Facebook about President Htin Kyaw, to nine months in jail after he was convicted under Section 66(d) of the Telecommunications Law. \nAung Myint Tun (aka Ko Pho Htaung), a member of the National League for Democracy, is still facing legal action under the same law for the wording of a resignation letter. \nAnother man named Yar Pyay was arrested and is being prosecuted for creating a fake Facebook account under the name of Nay Myo Wai, the chairman of Peace and Diversity Party. \nHla Phone was also arrested and is being prosecuted for defamatory posts on Facebook about the Commander-in-Chief. \nEMG – ironically awarded for its work in opposing the previous military-led government by Reporters without Borders – would also admit that it itself had taken advantage of Myanmar’s laws to silence its own critics, claiming: \nEleven Media Group (EMG) also filed complaints about repeated defamatory posts on Facebook against the group. Though EMG lodged complaints against film director Mike Tee, who is the owner of a Facebook account named Than Tun Zaw, and another Facebook user named Myat Maw for offensive posts about the group and its staff, the legal process has yet to begin. EMG lodged the complaints on January 27 and March 31 this year. \nOne would expect such a tidal wave of abuse – as defined by the West in regards to media, governance, and censorship around the world – to be met with sweeping condemnation from the West’s various human rights advocacy organizations including Human Rights Watch, Amnesty International, and a no doubt embarrassed Reporters Without Borders – yet the silence is as deafening as it is telling. Taking Over Where Accused Dictators Left Off \nThe West’s champions of democracy, rule of law, and human rights in Myanmar appears to have simply taken over right where Suu Kyi and her NDL party had claimed the military-led government left off. And despite the overt nature of Suu Kyi’s breaches of Western standards of “democracy” and “human rights,” the US is on track to lift all sanctions from Myanmar as Suu Kyi and her government open the nation, its people, and its resources to exploitation by Western corporations. \nThe overt nature of both the West’s and Suu Kyi’s hypocrisy illustrates that “democracy,” “rule of law,” and “human rights” are merely facades behind which the West and its proxies wield their power – hiding behind such principles rather than truly upholding them. And in reality, such behavior undermines these principles more than any overt abuse by an openly tyrannical regime ever could – because genuine advocates thus become associated with hypocrites like the Western governments supporting the current regime in Myanmar, their faux-nongovernmental organizations aiding and abetting the regime, and proxies like Suu Kyi and her NDL themselves. \nInternational audiences must keep this example of hypocrisy in mind as the West attempts to overturn other governments in Southeast Asia and beyond under similar pretexts and using similar rhetoric – supporting supposed “pro-democracy” and “pro-human rights” advocates who have every intention of trampling both upon seizing power. \nTony Cartalucci, Bangkok-based geopolitical researcher and writer, especially for the online magazine “New Eastern Outlook” .",
		"thread_title": "Irony Redefined: “Human Rights Champion” Suu Kyi Jails Dissidents",
		"title": "Irony Redefined: “Human Rights Champion” Suu Kyi Jails Dissidents",
		"type": "conspiracy",
		"uuid": "2e0b576aaf47e069ade1af1e2308945e6e04772a"
	},
	"-KhIaE9BOVp2oif2-Dc0": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T21:05:33.657+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Vin Armani",
				"salience": 0.31631622,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.27644056,
				"type": "LOCATION"
			},
			{
				"name": "trouble",
				"salience": 0.15109484,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.12906778,
				"type": "PERSON"
			},
			{
				"name": "Internet connection",
				"salience": 0.05374938,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.05049896,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.022832274,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T21:05:33.657+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Vin Armani You know the state is in trouble when they’re afraid of one man with an Internet connection. The case of Julian Assange... ",
		"thread_title": "We Live In A Time Where Each Individual Has Immense Power",
		"title": "We Live In A Time Where Each Individual Has Immense Power",
		"type": "conspiracy",
		"uuid": "e630b4191b92efbbb2a9d69b0a694b1adfacaf41"
	},
	"-KhIaECr38Bbtk5-3_jH": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:20:19.157+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03y0d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ICANN"
				},
				"name": "Internet Corporation for Assigned Names and Numbers",
				"salience": 0.7032561,
				"type": "ORGANIZATION"
			},
			{
				"name": "Patrick Wood",
				"salience": 0.15666889,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.10932508,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04sx9m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Technocracy"
				},
				"name": "Technocrats",
				"salience": 0.03074994,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T01:20:19.157+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Patrick Wood By its very nature, the Internet Corporation for Assigned Names and Numbers (ICANN) is a non-profit organization exclusively run by Technocrats. As... ",
		"thread_title": "Technocracy: The Real Reason Why The UN Wants Control Over The Internet",
		"title": "Technocracy: The Real Reason Why The UN Wants Control Over The Internet",
		"type": "conspiracy",
		"uuid": "30a703b51c007da96e927ca53b74392e3ae209c4"
	},
	"-KhIaEH0n1HoSQov8j3H": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T03:45:28.365+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "people",
				"salience": 0.2648099,
				"type": "PERSON"
			},
			{
				"name": "Isaac Davis",
				"salience": 0.22530013,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.2029056,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.17709452,
				"type": "ORGANIZATION"
			},
			{
				"name": "taxes",
				"salience": 0.11319169,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d35zk"
				},
				"name": "Catherine",
				"salience": 0.016698165,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:45:28.365+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Isaac Davis How is the government going to get people to pay their taxes if the government is not viewed as legitimate? ~ Catherine... ",
		"thread_title": "Financial Whistleblower Explains What’s About to Happen to the Economy",
		"title": "Financial Whistleblower Explains What’s About to Happen to the Economy",
		"type": "conspiracy",
		"uuid": "8000a6ee0e054bc95dd260528f622a75623868dc"
	},
	"-KhIaELnU8GF4v2p4Q3h": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:20:38.885+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.30864313,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nathaniel Mauka",
				"salience": 0.30864313,
				"type": "PERSON"
			},
			{
				"name": "civil liberties",
				"salience": 0.18878303,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.098299086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07x98",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patriot_Act"
				},
				"name": "Patriot Act",
				"salience": 0.095631644,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:20:38.885+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Nathaniel Mauka Congress overwhelmingly voted for the Patriot Act nearly 16 years ago, and our civil liberties have never been the same since. As... ",
		"thread_title": "Distracted By Election 2016, No One Resisted The Deep State’s Patriot Act 2",
		"title": "Distracted By Election 2016, No One Resisted The Deep State’s Patriot Act 2",
		"type": "conspiracy",
		"uuid": "0d599ada25a336c0df13ee689cd612154a5e9a51"
	},
	"-KhIaEQEsmVwelNp-kLP": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T17:55:48.250+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "John Anthony",
				"salience": 0.32775217,
				"type": "PERSON"
			},
			{
				"name": "programs",
				"salience": 0.22761014,
				"type": "OTHER"
			},
			{
				"name": "marketing campaigns",
				"salience": 0.16630079,
				"type": "EVENT"
			},
			{
				"name": "Affirmatively Furthering Fair Housing",
				"salience": 0.1027411,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.09118384,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0c409dj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Common_Core_State_Standards_Initiative"
				},
				"name": "Common Core",
				"salience": 0.08441197,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T17:55:48.250+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By John Anthony When federal agencies promote programs, like Affirmatively Furthering Fair Housing, or Common Core they conduct sophisticated and often deceptive marketing campaigns that... ",
		"thread_title": "How HUD Makes Lousy Programs Look Great",
		"title": "How HUD Makes Lousy Programs Look Great",
		"type": "conspiracy",
		"uuid": "ec1f300f9f28b6f9f64fda261b5fa45b9a44f5d6"
	},
	"-KhIaETzitqPV3Jkx0Cy": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T18:20:14.527+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Julian Rose",
				"salience": 0.25931495,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.2586219,
				"type": "OTHER"
			},
			{
				"name": "wisdom",
				"salience": 0.18095252,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.13028087,
				"type": "OTHER"
			},
			{
				"name": "economics",
				"salience": 0.12571323,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.045116503,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T18:20:14.527+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Julian Rose Virtually everything that conventional wisdom teaches about ‘economics’ is undergoing changes of an almost seismic nature at this time. Albeit mostly beneath... ",
		"thread_title": "On The Fault Lines of Change: Globalization-v-Localization",
		"title": "On The Fault Lines of Change: Globalization-v-Localization",
		"type": "conspiracy",
		"uuid": "7779bea33bfdfd07e2801da97a9b1b2d9ff8110b"
	},
	"-KhIaEY0V_JaJHe-CvnH": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T19:10:18.488+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Luke Rudkowski",
				"salience": 0.35990655,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.2653489,
				"type": "WORK_OF_ART"
			},
			{
				"name": "moves",
				"salience": 0.16162226,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.10832318,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.063740425,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.041058674,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T19:10:18.488+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Luke Rudkowski In this video Luke Rudkowski covers more geopolitical moves and how the recent presidential election with Hillary Clinton is making the situation... ",
		"thread_title": "Blaming Russia For Everything Wrong in the US is Getting Dangerous",
		"title": "Blaming Russia For Everything Wrong in the US is Getting Dangerous",
		"type": "conspiracy",
		"uuid": "27ef5900e6f9b6975672d629cc03809592fa1196"
	},
	"-KhIaEbyyRivgyr7n7Qv": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T22:20:10.208+03:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "File",
				"salience": 0.4509705,
				"type": "OTHER"
			},
			{
				"name": "Jon Rappoport",
				"salience": 0.2994081,
				"type": "PERSON"
			},
			{
				"name": "elephant",
				"salience": 0.10879627,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.06508913,
				"type": "LOCATION"
			},
			{
				"name": "emails",
				"salience": 0.035851393,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.022190692,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.017693918,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T22:20:10.208+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jon Rappoport File this one under: “Come on. Really?” The elephant in the room: HOW LONG HAS THE FBI KNOWN that new Hillary emails... ",
		"thread_title": "FBI Reopens Hillary Email Probe: Why Did It Take So Long?",
		"title": "FBI Reopens Hillary Email Probe: Why Did It Take So Long?",
		"type": "conspiracy",
		"uuid": "157eba53c234d2695ec95783e1f5547a853d0d8c"
	},
	"-KhIaEfvVKntiw3dO3X4": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T02:06:06.807+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Dan Dicks",
				"salience": 0.44716772,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018l04",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Hortons"
				},
				"name": "Tim Hortons",
				"salience": 0.24106984,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Truth",
				"salience": 0.10564647,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Press",
				"salience": 0.080509216,
				"type": "OTHER"
			},
			{
				"name": "Truth",
				"salience": 0.07601382,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.049592927,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T02:06:06.807+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Dan Dicks Tim Hortons Doesn’t Want You To See The Truth. Press For Truth has been banned from Tim Hortons! In this video Dan... ",
		"thread_title": "Restaurant Chain Tim Hortons Blocks Independent Journalist’s Website on WiFi",
		"title": "Restaurant Chain Tim Hortons Blocks Independent Journalist’s Website on WiFi",
		"type": "conspiracy",
		"uuid": "a53dc58ceb402fbc08e7c8cce45ca723a73ad148"
	},
	"-KhIaEkolla__C7ys6vj": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T02:10:31.417+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.30282345,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jay Syrmopoulos",
				"salience": 0.24524224,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.17031045,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02z4f6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Human_Rights_Council"
				},
				"name": "UN Human Rights Council",
				"salience": 0.114825875,
				"type": "ORGANIZATION"
			},
			{
				"name": "inception",
				"salience": 0.07619357,
				"type": "EVENT"
			},
			{
				"name": "council",
				"salience": 0.048491906,
				"type": "ORGANIZATION"
			},
			{
				"name": "time",
				"salience": 0.042112514,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T02:10:31.417+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jay Syrmopoulos Russia lost an election to the UN Human Rights Council (UNHRC) for the first time since the council’s inception in 2006 –... ",
		"thread_title": "Russia Kicked Off UN Human Rights Council, While Terrorist Saudi Arabia Re-Elected",
		"title": "Russia Kicked Off UN Human Rights Council, While Terrorist Saudi Arabia Re-Elected",
		"type": "conspiracy",
		"uuid": "5affd87dfa79dfe68d81b9b6a15aee1d17edf062"
	},
	"-KhIaEokXk9Z2gRCDCNb": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T02:35:25.843+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Claire Bernish",
				"salience": 0.31418985,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.22058655,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.15944731,
				"type": "LOCATION"
			},
			{
				"name": "riot gear",
				"salience": 0.13192363,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "weaponry",
				"salience": 0.10006565,
				"type": "OTHER"
			},
			{
				"name": "pepper",
				"salience": 0.07378699,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T02:35:25.843+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.5
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Claire Bernish On Thursday, police from no less than five states sporting full riot gear and armed with heavy lethal and nonlethal weaponry, pepper... ",
		"thread_title": "Like a “Concentration Camp” Police Mark DAPL Protesters with Numbers and Lock Them in Dog Kennels",
		"title": "Like a “Concentration Camp” Police Mark DAPL Protesters with Numbers and Lock Them in Dog Kennels",
		"type": "conspiracy",
		"uuid": "02ae76c658c0a52244fddeaf9c14b5d0dde4e9d7"
	},
	"-KhIaEsHnX0VvTDy6Qro": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T14:20:27.043+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Jay Syrmopoulos",
				"salience": 0.21126817,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/035rnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Ruffalo"
				},
				"name": "Mark Ruffalo",
				"salience": 0.15489204,
				"type": "PERSON"
			},
			{
				"name": "Wahleah Johns",
				"salience": 0.15489204,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.14568,
				"type": "EVENT"
			},
			{
				"name": "kindness",
				"salience": 0.14568,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.10037086,
				"type": "OTHER"
			},
			{
				"name": "Standing Rock Sioux",
				"salience": 0.06518417,
				"type": "LOCATION"
			},
			{
				"name": "Native Renewables",
				"salience": 0.022032717,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T14:20:27.043+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.7
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jay Syrmopoulos In a show of kindness and solidarity with the Standing Rock Sioux, actor Mark Ruffalo and Native Renewables founder Wahleah Johns presented... ",
		"thread_title": "Mark Ruffalo Delivers Mobile Solar Trailers to Standing Rock Camps in Preparation for Harsh Winter",
		"title": "Mark Ruffalo Delivers Mobile Solar Trailers to Standing Rock Camps in Preparation for Harsh Winter",
		"type": "conspiracy",
		"uuid": "f4b5177cf9e6d9abaa4369bed6d1e413149609b3"
	},
	"-KhIaExtW22WWRZ5xc1A": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T16:47:16.022+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Janet Phelan",
				"salience": 0.3387374,
				"type": "PERSON"
			},
			{
				"name": "cancer symposium",
				"salience": 0.23782092,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.16593733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.10883976,
				"type": "LOCATION"
			},
			{
				"name": "evolution",
				"salience": 0.107883744,
				"type": "OTHER"
			},
			{
				"name": "oncology",
				"salience": 0.04078084,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T16:47:16.022+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Janet Phelan A recent cancer symposium, with a surgical focus, met in Boston to discuss how surgical oncology is experiencing “an exciting evolution and... ",
		"thread_title": "Cancer, Cancer Everywhere … But Not In The Presidential Suite",
		"title": "Cancer, Cancer Everywhere … But Not In The Presidential Suite",
		"type": "conspiracy",
		"uuid": "7640ebe6da35bd243e0eca656fee4e99b792c14e"
	},
	"-KhIaFimZxGfpzLX9qwa": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:05:11.328+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "fan",
				"salience": 0.12595528,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.05246262,
				"type": "OTHER"
			},
			{
				"name": "Jon Rappoport",
				"salience": 0.04273509,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.02456144,
				"type": "PERSON"
			},
			{
				"name": "news business",
				"salience": 0.023942104,
				"type": "ORGANIZATION"
			},
			{
				"name": "problem",
				"salience": 0.021557964,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.01700164,
				"type": "PERSON"
			},
			{
				"name": "directors",
				"salience": 0.014095339,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.013670317,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.011973781,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gw_lh4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Newsstand_(application)"
				},
				"name": "Apple News",
				"salience": 0.011429784,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "consumer",
				"salience": 0.01087816,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.010643462,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.010374672,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.008892418,
				"type": "OTHER"
			},
			{
				"name": "technocrats",
				"salience": 0.008678803,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.008429265,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.008218553,
				"type": "OTHER"
			},
			{
				"name": "media metaphysics",
				"salience": 0.008176206,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.008054841,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.007894522,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00785384,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.007659254,
				"type": "PERSON"
			},
			{
				"name": "look",
				"salience": 0.007209873,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.0069285682,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.006781228,
				"type": "OTHER"
			},
			{
				"name": "work-in-progress",
				"salience": 0.0063470975,
				"type": "OTHER"
			},
			{
				"name": "quotes",
				"salience": 0.0063470975,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.0061422307,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apple_Inc."
				},
				"name": "Apple",
				"salience": 0.006024702,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0057935026,
				"type": "LOCATION"
			},
			{
				"name": "audio",
				"salience": 0.005740154,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.005740154,
				"type": "PERSON"
			},
			{
				"name": "misnomer",
				"salience": 0.0050988337,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.005008827,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0048248847,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.0046196217,
				"type": "PERSON"
			},
			{
				"name": "twist",
				"salience": 0.004531861,
				"type": "OTHER"
			},
			{
				"name": "app",
				"salience": 0.0042934753,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "non-sequiturs",
				"salience": 0.004285664,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.004275823,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.004275823,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.00414719,
				"type": "EVENT"
			},
			{
				"name": "principle",
				"salience": 0.00414719,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00414719,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00414719,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.00414719,
				"type": "OTHER"
			},
			{
				"name": "theater",
				"salience": 0.0039896956,
				"type": "LOCATION"
			},
			{
				"name": "theater",
				"salience": 0.0039896956,
				"type": "LOCATION"
			},
			{
				"name": "bubbles",
				"salience": 0.0039791265,
				"type": "OTHER"
			},
			{
				"name": "The Underground",
				"salience": 0.0039582653,
				"type": "LOCATION"
			},
			{
				"name": "tree",
				"salience": 0.0037447258,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0037447258,
				"type": "OTHER"
			},
			{
				"name": "liars",
				"salience": 0.0037447258,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0037447258,
				"type": "OTHER"
			},
			{
				"name": "producers",
				"salience": 0.0037447258,
				"type": "PERSON"
			},
			{
				"name": "eyes",
				"salience": 0.0037447258,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0037447258,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xf2l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whole_Foods_Market"
				},
				"name": "Whole Foods",
				"salience": 0.0035693948,
				"type": "ORGANIZATION"
			},
			{
				"name": "quality",
				"salience": 0.0035437227,
				"type": "OTHER"
			},
			{
				"name": "push",
				"salience": 0.003455021,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/011z69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeff_Bezos"
				},
				"name": "Jeff Bezos",
				"salience": 0.0033332766,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.0033184707,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0033184707,
				"type": "OTHER"
			},
			{
				"name": "forest",
				"salience": 0.003242851,
				"type": "LOCATION"
			},
			{
				"name": "souls",
				"salience": 0.003242851,
				"type": "PERSON"
			},
			{
				"name": "farce",
				"salience": 0.003242851,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.003242851,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.003242851,
				"type": "WORK_OF_ART"
			},
			{
				"name": "gibberish",
				"salience": 0.003242851,
				"type": "OTHER"
			},
			{
				"name": "obfuscations",
				"salience": 0.003242851,
				"type": "OTHER"
			},
			{
				"name": "first-rate job",
				"salience": 0.003242851,
				"type": "OTHER"
			},
			{
				"name": "Gaps",
				"salience": 0.003161674,
				"type": "OTHER"
			},
			{
				"name": "tree",
				"salience": 0.003096352,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.0030595365,
				"type": "PERSON"
			},
			{
				"name": "bubble",
				"salience": 0.0030304613,
				"type": "OTHER"
			},
			{
				"name": "war footage",
				"salience": 0.0028744799,
				"type": "WORK_OF_ART"
			},
			{
				"name": "users",
				"salience": 0.0028539395,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0027931815,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0027931815,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.0026639467,
				"type": "PERSON"
			},
			{
				"name": "Search engines",
				"salience": 0.002581246,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0025778345,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0025670475,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0024792056,
				"type": "OTHER"
			},
			{
				"name": "MATRIX",
				"salience": 0.0024480876,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.0023670192,
				"type": "PERSON"
			},
			{
				"name": "audience",
				"salience": 0.002363963,
				"type": "PERSON"
			},
			{
				"name": "media giant",
				"salience": 0.0023275702,
				"type": "ORGANIZATION"
			},
			{
				"name": "news",
				"salience": 0.0022686576,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0022400748,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0022400748,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0022400748,
				"type": "OTHER"
			},
			{
				"name": "transaction",
				"salience": 0.002226891,
				"type": "OTHER"
			},
			{
				"name": "drill",
				"salience": 0.002163215,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0021402817,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.0020828033,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0020483313,
				"type": "LOCATION"
			},
			{
				"name": "boy",
				"salience": 0.0020155192,
				"type": "PERSON"
			},
			{
				"name": "fringe users",
				"salience": 0.0020011133,
				"type": "PERSON"
			},
			{
				"name": "user",
				"salience": 0.0020011133,
				"type": "PERSON"
			},
			{
				"name": "News stories",
				"salience": 0.0019718774,
				"type": "WORK_OF_ART"
			},
			{
				"name": "users",
				"salience": 0.0019264207,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.0019264207,
				"type": "PERSON"
			},
			{
				"name": "piece",
				"salience": 0.0017736987,
				"type": "OTHER"
			},
			{
				"name": "media tongue",
				"salience": 0.0017531142,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0017513491,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.001728073,
				"type": "PERSON"
			},
			{
				"name": "princes",
				"salience": 0.0017074905,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0017074905,
				"type": "PERSON"
			},
			{
				"name": "profiling",
				"salience": 0.0017074905,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0017074905,
				"type": "OTHER"
			},
			{
				"name": "profiling",
				"salience": 0.0017074905,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.0017074905,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "print",
				"salience": 0.0017074905,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0016574865,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.001601468,
				"type": "OTHER"
			},
			{
				"name": "audiences",
				"salience": 0.0015956142,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.0015906508,
				"type": "OTHER"
			},
			{
				"name": "shelf life",
				"salience": 0.0015416859,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0015416859,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.0015416859,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0015416859,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.0015416859,
				"type": "PERSON"
			},
			{
				"name": "app",
				"salience": 0.0014525381,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "media",
				"salience": 0.0014264015,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.00141908,
				"type": "OTHER"
			},
			{
				"name": "distribution",
				"salience": 0.0014107262,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0013825318,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congressional",
				"salience": 0.001365536,
				"type": "ORGANIZATION"
			},
			{
				"name": "audiences",
				"salience": 0.0013530975,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.0013461122,
				"type": "OTHER"
			},
			{
				"name": "inquiries",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "buyer",
				"salience": 0.0013349573,
				"type": "PERSON"
			},
			{
				"name": "Ads",
				"salience": 0.0013349573,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cottage roofs",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "platforms",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "guarantees",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "information rise",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "go",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "civilizations",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "Tech blather",
				"salience": 0.0013349573,
				"type": "OTHER"
			},
			{
				"name": "fire sale",
				"salience": 0.0013349573,
				"type": "EVENT"
			},
			{
				"name": "stories",
				"salience": 0.0013309196,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stories",
				"salience": 0.0013309196,
				"type": "WORK_OF_ART"
			},
			{
				"name": "power",
				"salience": 0.0013309196,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019rl6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yahoo!"
				},
				"name": "Yahoo",
				"salience": 0.0013136104,
				"type": "ORGANIZATION"
			},
			{
				"name": "layer",
				"salience": 0.0012689249,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0012474813,
				"type": "OTHER"
			},
			{
				"name": "bubbles",
				"salience": 0.0012474813,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.001244817,
				"type": "PERSON"
			},
			{
				"name": "corner",
				"salience": 0.0012291293,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.0012203422,
				"type": "PERSON"
			},
			{
				"name": "lies",
				"salience": 0.0011971375,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.0011971375,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.0011921261,
				"type": "PERSON"
			},
			{
				"name": "consumer",
				"salience": 0.0011921261,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0011921261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0011885562,
				"type": "PERSON"
			},
			{
				"name": "bubble",
				"salience": 0.0011708306,
				"type": "OTHER"
			},
			{
				"name": "government gridlock",
				"salience": 0.0011611277,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.001152444,
				"type": "OTHER"
			},
			{
				"name": "twist",
				"salience": 0.001152444,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.001152444,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "press",
				"salience": 0.0011449785,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0011371252,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.001128621,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.001128621,
				"type": "LOCATION"
			},
			{
				"name": "goals",
				"salience": 0.0011227942,
				"type": "OTHER"
			},
			{
				"name": "news source",
				"salience": 0.0011177782,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0011094188,
				"type": "OTHER"
			},
			{
				"name": "demographic",
				"salience": 0.0010808755,
				"type": "PERSON"
			},
			{
				"name": "Nothing",
				"salience": 0.0010808755,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.0010738776,
				"type": "ORGANIZATION"
			},
			{
				"name": "X",
				"salience": 0.0010647759,
				"type": "PERSON"
			},
			{
				"name": "frontier",
				"salience": 0.0010412487,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.0010405213,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0010405213,
				"type": "OTHER"
			},
			{
				"name": "Prophet",
				"salience": 0.0010405213,
				"type": "PERSON"
			},
			{
				"name": "mind control",
				"salience": 0.0010405213,
				"type": "OTHER"
			},
			{
				"name": "Translation",
				"salience": 0.0010405213,
				"type": "OTHER"
			},
			{
				"name": "Power Outside The Matrix",
				"salience": 0.001038106,
				"type": "OTHER"
			},
			{
				"name": "newspapers",
				"salience": 0.001033492,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0010257323,
				"type": "OTHER"
			},
			{
				"name": "viewers",
				"salience": 0.0010016734,
				"type": "PERSON"
			},
			{
				"name": "answer",
				"salience": 0.0009971984,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0009897404,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.0009772663,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0009772663,
				"type": "EVENT"
			},
			{
				"name": "profilers",
				"salience": 0.0009772663,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0009772663,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0009772663,
				"type": "EVENT"
			},
			{
				"name": "unity",
				"salience": 0.0009772663,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0009772663,
				"type": "PERSON"
			},
			{
				"name": "unity",
				"salience": 0.0009772663,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.00095996744,
				"type": "OTHER"
			},
			{
				"name": "storm",
				"salience": 0.0009450013,
				"type": "EVENT"
			},
			{
				"name": "social-construct-bundle",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "preferences",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "experiments",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "celeb gossip",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "host",
				"salience": 0.00093592214,
				"type": "PERSON"
			},
			{
				"name": "fluff",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "psyops",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "produce section",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "ban",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "car crash",
				"salience": 0.00093592214,
				"type": "EVENT"
			},
			{
				"name": "I5",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "science fiction",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "ratings",
				"salience": 0.00093592214,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00092827337,
				"type": "OTHER"
			},
			{
				"name": "league",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "news outlets",
				"salience": 0.0009009784,
				"type": "WORK_OF_ART"
			},
			{
				"name": "moon",
				"salience": 0.0009009784,
				"type": "LOCATION"
			},
			{
				"name": "headlines",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "toenails",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "default",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "operating system",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "neo-con",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "paradigms",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "debut",
				"salience": 0.0009009784,
				"type": "EVENT"
			},
			{
				"name": "territory",
				"salience": 0.0009009784,
				"type": "LOCATION"
			},
			{
				"name": "rocks",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0009009784,
				"type": "OTHER"
			},
			{
				"name": "consulting practice",
				"salience": 0.0008951414,
				"type": "OTHER"
			},
			{
				"name": "variations",
				"salience": 0.00088235235,
				"type": "OTHER"
			},
			{
				"name": "viewers",
				"salience": 0.00088235235,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.00088235235,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00088235235,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.0008698108,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0008430553,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mgkg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amazon.com"
				},
				"name": "Amazon",
				"salience": 0.000821602,
				"type": "ORGANIZATION"
			},
			{
				"name": "interest",
				"salience": 0.0007901957,
				"type": "OTHER"
			},
			{
				"name": "alt",
				"salience": 0.0007901957,
				"type": "OTHER"
			},
			{
				"name": "collapse",
				"salience": 0.0007901957,
				"type": "EVENT"
			},
			{
				"name": "MATRIX",
				"salience": 0.00078023603,
				"type": "ORGANIZATION"
			},
			{
				"name": "news",
				"salience": 0.00077199086,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00076401676,
				"type": "PERSON"
			},
			{
				"name": "brand",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "bottom",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "glands",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "punch",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "robot media editors",
				"salience": 0.00076401676,
				"type": "PERSON"
			},
			{
				"name": "bits",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "error",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "dozen",
				"salience": 0.00076401676,
				"type": "PERSON"
			},
			{
				"name": "realities",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "skulls",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.00076401676,
				"type": "LOCATION"
			},
			{
				"name": "voice",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.00076401676,
				"type": "OTHER"
			},
			{
				"name": "audiences",
				"salience": 0.0007360898,
				"type": "PERSON"
			},
			{
				"name": "fronts",
				"salience": 0.0007299889,
				"type": "OTHER"
			},
			{
				"name": "media twist",
				"salience": 0.0007299889,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0007170663,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.000711703,
				"type": "OTHER"
			},
			{
				"name": "dud",
				"salience": 0.0007080282,
				"type": "OTHER"
			},
			{
				"name": "Jeff Genius",
				"salience": 0.000679252,
				"type": "PERSON"
			},
			{
				"name": "cops",
				"salience": 0.00066864013,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.00065908657,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.00065908657,
				"type": "PERSON"
			},
			{
				"name": "whatever",
				"salience": 0.00065908657,
				"type": "OTHER"
			},
			{
				"name": "alt news sites",
				"salience": 0.00065908657,
				"type": "OTHER"
			},
			{
				"name": "liars",
				"salience": 0.00065908657,
				"type": "OTHER"
			},
			{
				"name": "EVERYONE",
				"salience": 0.00065908657,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.00065908657,
				"type": "OTHER"
			},
			{
				"name": "news sites",
				"salience": 0.00065908657,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00065908657,
				"type": "OTHER"
			},
			{
				"name": "lying",
				"salience": 0.00061581936,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00061395636,
				"type": "LOCATION"
			},
			{
				"name": "POWER",
				"salience": 0.00061395636,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00061395636,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00061395636,
				"type": "OTHER"
			},
			{
				"name": "topics",
				"salience": 0.0006003929,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0005798232,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0005759906,
				"type": "LOCATION"
			},
			{
				"name": "Decentralized Centralization",
				"salience": 0.0005759906,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/037mm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Genetically_modified_organism"
				},
				"name": "GMOs",
				"salience": 0.0005759906,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jbs5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maui"
				},
				"name": "Maui",
				"salience": 0.0005759906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0005759906,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dow_Jones_Industrial_Average"
				},
				"name": "Dow",
				"salience": 0.0005759906,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01q_vm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glyphosate"
				},
				"name": "Roundup",
				"salience": 0.0005759906,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0n8m6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monsanto"
				},
				"name": "Monsanto",
				"salience": 0.0005759906,
				"type": "ORGANIZATION"
			},
			{
				"name": "collections",
				"salience": 0.000575459,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Collapse",
				"salience": 0.000575459,
				"type": "EVENT"
			},
			{
				"name": "collusion",
				"salience": 0.000575459,
				"type": "OTHER"
			},
			{
				"name": "priority",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "awareness",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.00057068927,
				"type": "PERSON"
			},
			{
				"name": "scandal",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00057068927,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.00057068927,
				"type": "EVENT"
			},
			{
				"name": "support",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "GMO hustle",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "note",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "pesticide damage",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.00057068927,
				"type": "PERSON"
			},
			{
				"name": "need",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00057068927,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06b7km",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nieman_Foundation_for_Journalism"
				},
				"name": "Nieman Journalism Lab",
				"salience": 0.00055448327,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027lnzs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/IPhone"
				},
				"name": "iPhone",
				"salience": 0.00055448327,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/g/11bymj34t6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/IOS_9"
				},
				"name": "iOS 9",
				"salience": 0.00055448327,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00055448327,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09rvlp4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/IPad"
				},
				"name": "iPad",
				"salience": 0.00055448327,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "news app",
				"salience": 0.0005539715,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "border war",
				"salience": 0.0005469888,
				"type": "EVENT"
			},
			{
				"name": "purpose",
				"salience": 0.00053561747,
				"type": "OTHER"
			},
			{
				"name": "Project Veritas",
				"salience": 0.000534164,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.000534164,
				"type": "ORGANIZATION"
			},
			{
				"name": "health",
				"salience": 0.0005316111,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0005316111,
				"type": "OTHER"
			},
			{
				"name": "Ways",
				"salience": 0.0005316111,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lcxb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alanine_transaminase"
				},
				"name": "alt",
				"salience": 0.00048629925,
				"type": "ORGANIZATION"
			},
			{
				"name": "Alt",
				"salience": 0.00048629925,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dsbsw1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joshua_Benton"
				},
				"name": "Joshua Benton",
				"salience": 0.00048226846,
				"type": "PERSON"
			},
			{
				"name": "Report",
				"salience": 0.0004799742,
				"type": "OTHER"
			},
			{
				"name": "reporter",
				"salience": 0.0004799742,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0004799742,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0004799742,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0004799742,
				"type": "EVENT"
			},
			{
				"name": "outcome",
				"salience": 0.0004799742,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0004799742,
				"type": "OTHER"
			},
			{
				"name": "magazines",
				"salience": 0.0004799742,
				"type": "WORK_OF_ART"
			},
			{
				"name": "subscription",
				"salience": 0.0004799742,
				"type": "OTHER"
			},
			{
				"name": "drills",
				"salience": 0.0004739241,
				"type": "OTHER"
			},
			{
				"name": "lemon pie",
				"salience": 0.00047180653,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034bs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Orwell"
				},
				"name": "Orwell",
				"salience": 0.000470187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Obamacare",
				"salience": 0.00044924417,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.0004428108,
				"type": "OTHER"
			},
			{
				"name": "War",
				"salience": 0.00042983866,
				"type": "EVENT"
			},
			{
				"name": "border war",
				"salience": 0.00042983866,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01cm3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Big_Brother_(Nineteen_Eighty-Four)"
				},
				"name": "Big Brother",
				"salience": 0.00041945765,
				"type": "PERSON"
			},
			{
				"name": "station",
				"salience": 0.00041559685,
				"type": "LOCATION"
			},
			{
				"name": "sense",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "entitlement",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "desperation",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "roots",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "brain cells",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "train",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "writing articles",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "EXIT",
				"salience": 0.00041559685,
				"type": "LOCATION"
			},
			{
				"name": "CONFIDENTIAL",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00041559685,
				"type": "WORK_OF_ART"
			},
			{
				"name": "clients",
				"salience": 0.00041559685,
				"type": "PERSON"
			},
			{
				"name": "logic",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "seminars",
				"salience": 0.00041559685,
				"type": "EVENT"
			},
			{
				"name": "lectures",
				"salience": 0.00041559685,
				"type": "OTHER"
			},
			{
				"name": "movie",
				"salience": 0.00041035813,
				"type": "WORK_OF_ART"
			},
			{
				"name": "weather channels",
				"salience": 0.00041035813,
				"type": "OTHER"
			},
			{
				"name": "communication devices",
				"salience": 0.00039708527,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "outcome",
				"salience": 0.00039680785,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.00038686706,
				"type": "OTHER"
			},
			{
				"name": "Activist Post Daily Newsletter Subscription",
				"salience": 0.00038067918,
				"type": "OTHER"
			},
			{
				"name": "androids",
				"salience": 0.000358514,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "androids",
				"salience": 0.000358514,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "propaganda",
				"salience": 0.000358514,
				"type": "OTHER"
			},
			{
				"name": "varieties",
				"salience": 0.000358514,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.000358514,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.00035726247,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00035120323,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.00035120323,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dgg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drudge_Report"
				},
				"name": "Drudge",
				"salience": 0.00035120323,
				"type": "OTHER"
			},
			{
				"name": "Globalism",
				"salience": 0.00035120323,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0r4xf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chula_Vista,_California"
				},
				"name": "Chula Vista",
				"salience": 0.00034932778,
				"type": "LOCATION"
			},
			{
				"name": "CBS Healthwatch",
				"salience": 0.00032715307,
				"type": "ORGANIZATION"
			},
			{
				"name": "thing",
				"salience": 0.00032658476,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00031438938,
				"type": "PERSON"
			},
			{
				"name": "tunes",
				"salience": 0.00031438938,
				"type": "WORK_OF_ART"
			},
			{
				"name": "auto rifles",
				"salience": 0.0003104263,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "gear",
				"salience": 0.0003104263,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Vests",
				"salience": 0.0003104263,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "User D:",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "ring",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "shields",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "User C",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "combat",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "flash-bangs",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "silencers",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "drones",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "sophistication",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "User A",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "User E",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "batons",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "User B",
				"salience": 0.0003104263,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0003104263,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02wmv9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spin_(magazine)"
				},
				"name": "Spin Magazine",
				"salience": 0.00029537416,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04bbtx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LA_Weekly"
				},
				"name": "LA Weekly",
				"salience": 0.00029537416,
				"type": "ORGANIZATION"
			},
			{
				"name": "District of California",
				"salience": 0.00029537416,
				"type": "ORGANIZATION"
			},
			{
				"name": "coverage",
				"salience": 0.00029506724,
				"type": "OTHER"
			},
			{
				"name": "demonstration",
				"salience": 0.00027120646,
				"type": "EVENT"
			},
			{
				"name": "defense",
				"salience": 0.0002665911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0423bn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stern_(magazine)"
				},
				"name": "Stern",
				"salience": 0.00025575486,
				"type": "ORGANIZATION"
			},
			{
				"name": "OutsideTheRealityMachine",
				"salience": 0.00025575486,
				"type": "OTHER"
			},
			{
				"name": "NoMoreFakeNews.com",
				"salience": 0.00025575486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/061jp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pulitzer_Prize"
				},
				"name": "Pulitzer Prize",
				"salience": 0.00025575486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00025575486,
				"type": "LOCATION"
			},
			{
				"name": "exhibit",
				"salience": 0.00023186838,
				"type": "EVENT"
			},
			{
				"name": "food show",
				"salience": 0.00023186838,
				"type": "EVENT"
			},
			{
				"name": "Big One",
				"salience": 0.00019347052,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/062zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_relations"
				},
				"name": "PR",
				"salience": 0.00019103162,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/10/o-MEDIA-facebook-1024x512.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T17:05:11.328+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 54.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jon Rappoport \nI begin this piece with three quotes from my work-in-progress, The Underground: \n“There is a media metaphysics. Its basic principle states that nothing exists until it becomes information. Now we have a new twist: information only becomes real when it reaches a mind already attuned to it. In other words, the tree falling in the forest makes a sound only if a user/consumer who wants a tree to fall receives video and audio of the event…” \n“Information can be dressed up a thousand different ways. But it tends to have an ‘elastic’ quality. By that I mean you eventually get to see the person who dressed it up. That’s a problem for chronic liars who inhabit the press. They expose themselves, even though they don’t want to. It takes a surprisingly small push to expose the whole operation. This is happening now, right in front of our eyes.” \n“The basis of big media is theater. News is theater. Its directors and producers think they’re doing a first-rate job. But they’re sadly mistaken. Gaps and obfuscations are growing larger. The outright non-sequiturs and gibberish are becoming more apparent. The audience is wising up to the farce. Who are these fools who direct the news? They’re simply people who want to sell their souls and have found an elite buyer. But that transaction doesn’t contain any guarantees about shelf life. Mainstream news is decaying, and the expiration date is approaching. Like civilizations, the petty princes of information rise and fall…” \nGlobalized media. It’s nice plan. Let’s examine it. \nThe new technocratic media is based on profiling users. There is no impactful news unless each member of the audience is surveilled and analyzed on the basis of what he already likes and wants. \nShocking? It’s to be expected. How else would technocrats parlay the untold hours they’ve spent sizing up their consumers/users? \nSeveral years ago, I wrote: “Tech blather has already begun, since Jeff Bezos, CEO of Amazon, bought the Washington Post at a fire sale. Jeff Genius will invent new ways to transmit the news to ‘people on the go’ and make the Post a smashing success. Mobile devices. Multiple platforms. Digital taking over from print. Ads customized to fit readers’ interests (profiling). News stories customized to fit readers’ interests (more profiling).” \nIn other words, non-news. If you thought media were irrelevant and deceptive before, you haven’t seen anything. The “new news” will create millions of virtual bubbles in which profiled users can float contentedly, under the cozy cottage roofs of their favorite little separate paradigms. \nThe tech giant Apple has waded into this territory with an app that will deliver news to users. Yahoo: “Apple News, part of the upcoming iOS 9 operating system, aims to be the primary news source for users of the iPhone and iPad… Apple says its news app ‘follows over a million topics and pulls relevant stories based on your specific interests’… Joshua Benton of the Nieman Journalism Lab said the app will be important because ‘through the awesome power of default, Apple distribution puts it in an entirely other league. This [news] app will be on hundreds of millions of devices within 24 hours of its debut’.” \nTranslation: Profiling their users down to their toenails, Apple will present them with virtual bubbles of news they want to see and read. \nNot just one overall presentation for all; no, different “news outlets” for Apple’s audiences. \nThis introduces a whole new layer of mind control. \n“You’re an Obama fan? Here are stories confirming your belief in the Prophet.” \n“You want neo-con on the rocks with a conservative Republican twist? Here’s some war footage that’ll warm your heart.” \n“Do you believe ‘government gridlock’ is our biggest concern? Congress can’t get anything done? We’ve got headlines for that from here to the moon.” \n“Tuned into celeb gossip? Here’s your world in three minutes.” \nThe idea: convince users, one day at a time, that what they already believe is important IS the news of the day. \nIt’s Decentralized Centralization. One media giant carving its global audience up into little pieces and delivering them a whole host of different algorithmically appropriate lies and fluff and no-context psyops. \nAnd for “fringe users?” “You’re doubtful about GMOs? Well, look at what Whole Foods is planning for their healthier produce section. Cheer up.” Nothing about Maui voters declaring a temporary ban on devastatingly toxic Monsanto/Dow experiments or the dangers of Roundup. “You’re anti-vaccine? Sorry, you don’t count. You’re not a recognized demographic. But here’s a piece about a little unvaccinated boy who was involved in car crash on the I5.” \nDoes this sound like science fiction? It isn’t. It’s the mainstream look of the near-future. Search engines are already “personalizing” your inquiries. US ABC national news is climbing in the ratings because it’s giving viewers “lighter stories,” and spending less time on thorny issues like the Middle East. \nThe mainstream news business is desperately looking for audience; and treating every “user” as a profiled social-construct-bundle of superficial preferences is their answer. \n“Mr. X, we’ve studied the little virtual bubble you live in, and now we can sell you your own special brand of truth.” \n“Hello, audience. We’re going to pitch you on becoming full-fledged obsessed consumers, as if there is no other worthy goal in life—and then we’re going to profile you from top to bottom, to find out exactly what kind of obsessed consumer you are, so we can hit you and trigger you with information that uniquely stimulates your adrenal glands…” \nThe one-two punch. \nAny actual event occurring in the world will be pre-digested by robot media editors and profilers, and then split up into variously programmed bits of information for different audiences. \nWho cares what really happened? In the new world, there is no ‘what really happened’. That’s a gross misnomer. A faulty idea. A metaphysical error. No, there is only a multi-forked media tongue that simultaneously spits out a dozen or a hundred variations of the same event…because different viewers want and expect different realities. \nIn 1984 , Orwell’s Big Brother was issuing a single voice into the homes of the population. That was old-school. That was primitive technology. That was achieving unity by hammering unity into people’s skulls. This, now, is the frontier of unity through diversity. \n“We want to make all of you into androids, through basic PR and propaganda and a pathetic excuse for education. However, we recognize you’ll become different varieties of androids, and we’ll serve that outcome with technological sophistication. Trust us. We care about what you prefer.” \nUser A: “Wow, did you see the coverage of the border war in Chula Vista?” \nUser B: “War? They had a fantastic exhibit of drones down there. At least a hundred different types. And then I watched an old WW2 movie about aerial combat.” \nUser C: “Chula Vista? They had a great food show. This woman made a lemon pie. I could practically taste it.” \nUser D: “That wasn’t a border war. It was a drill. And then afterwards, these cops gave a demonstration of all their gear. Vests, shields, communication devices, flash-bangs, auto rifles with silencers, batons. I watch drills all over the country. Love them.” \nUser E: “Chula Vista? The only thing I saw on the news was ‘sunny and mild’ this week. I watch all the weather channels. I love them.” \nBUT when a Big One comes along, like the 2016 national election in the US, the separate tunes come together and ring as one. Then the overriding need to extend Globalism’s goals (in the person of Hillary Clinton) blot out every other priority. Then the major media twist whatever they need to twist. Then it’s the same bubble for everyone. \nOne problem, though. Major media have been lanced thousands of times by alt news sites, and by WikiLeaks and Project Veritas. This attack has exposed the truth and the Clinton crimes. \nAnd alt news reflects the growing interest of the public in what’s actually happening on many fronts. \nThe technocratic plan for the news is failing. \nIt was a nice plan, but… \nIt’s turning out to be a dud. \nAlt media are forcing public awareness of one giant scandal after another: Hillary/Obama support for ISIS; pro-vaccine liars; the collapse of Obamacare; the GMO hustle; pesticide damage…on and on and on. \nThe result? Major media are being backed into a corner, where they must defend lies and build monolithic lies for EVERYONE all the time. The idea of creating separate news for each profiled user is collapsing. \nMajor media are playing defense against the rest of the world. \nIt’s quite a party. \nAnd it has no expiration date. \nA final note: Trump, WikiLeaks, Project Veritas, Drudge, and many alt news sites created a perfect storm in 2016, raining down on major media. It was and is unprecedented. The mainstream press has been exposed down to its roots, as never before. The lying, the collusion, the arrogant sense of entitlement, the desperation, the corruption—it’s all there to see, for anyone who has eyes and a few working brain cells. Expect more to come, regardless of the outcome of the election. The train has really left the station… \n(To read about Jon’s mega-collection, Power Outside The Matrix , click here .) \nThe author of three explosive collections, THE MATRIX REVEALED , EXIT FROM THE MATRIX , and POWER OUTSIDE THE MATRIX , Jon was a candidate for a US Congressional seat in the 29 th District of California. He maintains a consulting practice for private clients, the purpose of which is the expansion of personal creative power. Nominated for a Pulitzer Prize, he has worked as an investigative reporter for 30 years, writing articles on politics, medicine, and health for CBS Healthwatch, LA Weekly, Spin Magazine, Stern, and other newspapers and magazines in the US and Europe. Jon has delivered lectures and seminars on global politics, health, logic, and creative power to audiences around the world. You can sign up for his free emails at NoMoreFakeNews.com or OutsideTheRealityMachine . Activist Post Daily Newsletter Subscription is FREE and CONFIDENTIAL Free Report: 10 Ways to Survive the Economic Collapse with subscription",
		"thread_title": "The Globalization Of Media: A Failing Strike Force",
		"title": "The Globalization Of Media: A Failing Strike Force",
		"type": "conspiracy",
		"uuid": "59af19dddc087cd7c169e73b3269ba6a34997ea9"
	},
	"-KhIaFrBhZ0CNMSSzImI": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T22:56:25.733+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Carey Wedler",
				"salience": 0.315505,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.1572612,
				"type": "ORGANIZATION"
			},
			{
				"name": "security",
				"salience": 0.1572612,
				"type": "OTHER"
			},
			{
				"name": "brute force",
				"salience": 0.15170528,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.098023295,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock",
				"salience": 0.06114042,
				"type": "LOCATION"
			},
			{
				"name": "hand",
				"salience": 0.059103623,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T22:56:25.733+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Carey Wedler When it comes to brute force, law enforcement and private security currently have the upper hand on the ground in Standing Rock,... ",
		"thread_title": "Here’s Why Everyone On Facebook Is Checking Into Standing Rock, North Dakota",
		"title": "Here’s Why Everyone On Facebook Is Checking Into Standing Rock, North Dakota",
		"type": "conspiracy",
		"uuid": "e72d8371199928ffb8cbe5e2a65c3b2a3dbce2de"
	},
	"-KhIaFvovS6j5s-QqMXW": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:46:02.654+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "debate",
				"salience": 0.27776763,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.18765569,
				"type": "OTHER"
			},
			{
				"name": "Nicholas West",
				"salience": 0.1829244,
				"type": "PERSON"
			},
			{
				"name": "replacement",
				"salience": 0.10645802,
				"type": "OTHER"
			},
			{
				"name": "killer robots",
				"salience": 0.10074003,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.0752,
				"type": "PERSON"
			},
			{
				"name": "robotics industry",
				"salience": 0.03784282,
				"type": "OTHER"
			},
			{
				"name": "workforce",
				"salience": 0.03141142,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:46:02.654+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Nicholas West While debate surrounds the threat of autonomous “killer robots,” the mechanized replacement of humans continues across the workforce. The industrial robotics industry is... ",
		"thread_title": "China’s Airport Security Robot Can Deliver Electroshocks",
		"title": "China’s Airport Security Robot Can Deliver Electroshocks",
		"type": "conspiracy",
		"uuid": "0548a4a7a5d414eab993531b26f053fd92e6b76f"
	},
	"-KhIaG1dt2d4juU7zyAh": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T05:00:32.254+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "James Holbrooks",
				"salience": 0.3807009,
				"type": "PERSON"
			},
			{
				"name": "demand",
				"salience": 0.15796807,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.13847302,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015tck",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Japan_Times"
				},
				"name": "Japan Times",
				"salience": 0.11630939,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.09920669,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.06623564,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.041106313,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T05:00:32.254+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By James Holbrooks Over the weekend, The Japan Times reported Japan might agree to Russia’s demand that U.S. troops be forbidden from being stationed on... ",
		"thread_title": "Russia, Japan May Finally Sign Peace Treaty to Officially End WWII Conflict",
		"title": "Russia, Japan May Finally Sign Peace Treaty to Officially End WWII Conflict",
		"type": "conspiracy",
		"uuid": "ed92dab837c22c5cee95cbee4b5629fcaa8642f6"
	},
	"-KhIaG5nbtLhtQo90DWB": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T17:05:20.744+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02241w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bev_Harris"
				},
				"name": "Bev Harris",
				"salience": 0.35258022,
				"type": "PERSON"
			},
			{
				"name": "Jon Rappoport",
				"salience": 0.2188528,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.1519841,
				"type": "WORK_OF_ART"
			},
			{
				"name": "software",
				"salience": 0.1519841,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "elections",
				"salience": 0.10523169,
				"type": "EVENT"
			},
			{
				"name": "voting machines",
				"salience": 0.019367108,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T17:05:20.744+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jon Rappoport Shocking video reveals secret software designed to rig elections. Vote fraud expert Bev Harris exposes electronic voting machines. Okay. She finally did... ",
		"thread_title": "Biggest Election Fraud In History Discovered In The United States",
		"title": "Biggest Election Fraud In History Discovered In The United States",
		"type": "conspiracy",
		"uuid": "cb0c4b8cc95cfd07b07bbcae59ffaeafc7d11bcc"
	},
	"-KhIaGCkFkqkMWaO0ppE": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T18:26:34.819+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Claire Bernish",
				"salience": 0.27848426,
				"type": "PERSON"
			},
			{
				"name": "explosion",
				"salience": 0.19339564,
				"type": "EVENT"
			},
			{
				"name": "gas pipeline",
				"salience": 0.1533667,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.100770906,
				"type": "LOCATION"
			},
			{
				"name": "pipeline",
				"salience": 0.09938853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kzpc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shelby_County,_Alabama"
				},
				"name": "Shelby County",
				"salience": 0.08729699,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alabama"
				},
				"name": "Alabama",
				"salience": 0.08729699,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T18:26:34.819+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Claire Bernish A massive explosion of a gas pipeline in Shelby County, Alabama — near the site where the same pipeline leaked some 336,000... ",
		"thread_title": "DAPL Protesters Proven Right as Largest Gas Pipeline in U.S. Experiences Massive and Deadly Explosion",
		"title": "DAPL Protesters Proven Right as Largest Gas Pipeline in U.S. Experiences Massive and Deadly Explosion",
		"type": "conspiracy",
		"uuid": "3cfb0fed2f7a36b29fffaf29cbdd110ca260e0c6"
	},
	"-KhIaGH1mbve-8d6tHKk": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T18:26:34.857+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.58862776,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.1610188,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jack Burns",
				"salience": 0.118594974,
				"type": "PERSON"
			},
			{
				"name": "campaign promise",
				"salience": 0.05843012,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.036263607,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.024696732,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.012368022,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T18:26:34.857+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.8
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jack Burns WikiLeaks is helping President Obama keep his 2008 campaign promise — to be the most transparent administration in U.S. history — whether he likes... ",
		"thread_title": "Not Just Hillary, Entire Obama Administration Exposed for Using Private Email to Avoid FOIA Requests",
		"title": "Not Just Hillary, Entire Obama Administration Exposed for Using Private Email to Avoid FOIA Requests",
		"type": "conspiracy",
		"uuid": "3bd561303ff1ea6176476fb1be4596520c054b0a"
	},
	"-KhIaGOdRgOSDoEREuWJ": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T18:26:34.928+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Brandon Turbeville Anti-fluoridation",
				"salience": 0.23897178,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.16478303,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.117738135,
				"type": "OTHER"
			},
			{
				"name": "boost",
				"salience": 0.1135325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.10392654,
				"type": "LOCATION"
			},
			{
				"name": "Ambassador",
				"salience": 0.096911535,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.06050037,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/042kg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmy_Carter"
				},
				"name": "Jimmy Carter",
				"salience": 0.045455668,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0glttb"
				},
				"name": "Andrew",
				"salience": 0.03325857,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.02492187,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T18:26:34.928+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Brandon Turbeville Anti-fluoridation activists in Georgia received a major boost of support when former U.S. Ambassador to the United Nations under Jimmy Carter, Andrew... ",
		"thread_title": "Former Ambassador Andrew Young Calls for End to Water Fluoridation, “Civil Rights Issue”",
		"title": "Former Ambassador Andrew Young Calls for End to Water Fluoridation, “Civil Rights Issue”",
		"type": "conspiracy",
		"uuid": "636d2c77b341dda55acce49eb5ae3d6e8a54cdd7"
	},
	"-KhIaGXZE-zWX1YhPchx": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T18:26:34.980+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Brandon Turbeville",
				"salience": 0.2921318,
				"type": "PERSON"
			},
			{
				"name": "development",
				"salience": 0.2028733,
				"type": "OTHER"
			},
			{
				"name": "talcum powder saga",
				"salience": 0.145611,
				"type": "WORK_OF_ART"
			},
			{
				"name": "woman",
				"salience": 0.120095044,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0168nq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Johnson_%26_Johnson"
				},
				"name": "Johnson & Johnson",
				"salience": 0.101413526,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.05661103,
				"type": "LOCATION"
			},
			{
				"name": "jury",
				"salience": 0.050164305,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06wxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Louis"
				},
				"name": "St. Louis",
				"salience": 0.03109997,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T18:26:34.980+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Brandon Turbeville In the latest development in the Johnson & Johnson talcum powder saga, a St. Louis jury has awarded a California woman over... ",
		"thread_title": "Johnson & Johnson Loses Yet Another Multimillion Dollar Case Over Baby Powder",
		"title": "Johnson & Johnson Loses Yet Another Multimillion Dollar Case Over Baby Powder",
		"type": "conspiracy",
		"uuid": "bd54c5dd4f8188cd940bdceb16b221e3e0999553"
	},
	"-KhIaGdRSvIiu3CsF5nC": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T19:21:58.828+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Jabhat Al Nusra",
				"salience": 0.52680373,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ulson Gunnar Militants",
				"salience": 0.25117734,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.10546562,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01mxf7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Province,_Sri_Lanka"
				},
				"name": "Western",
				"salience": 0.066443145,
				"type": "LOCATION"
			},
			{
				"name": "Jabhat Fateh al-Sham",
				"salience": 0.050110146,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T19:21:58.828+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Ulson Gunnar Militants led by designated terrorist organisation, Jabhat Al Nusra, now obliquely referred to by the Western media as “Jabhat Fateh al-Sham,” has... ",
		"thread_title": "Latest Assault on Aleppo: West Covers Up Terror-Ties",
		"title": "Latest Assault on Aleppo: West Covers Up Terror-Ties",
		"type": "conspiracy",
		"uuid": "7ff889eb215c0fe778a7a3bfe3bdf4af44faf6d9"
	},
	"-KhIaGiKD1e9EYTr8vbd": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T19:45:36.456+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.5086318,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/034bs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Orwell"
				},
				"name": "Eric Blair",
				"salience": 0.35447505,
				"type": "PERSON"
			},
			{
				"name": "kids",
				"salience": 0.13689315,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T19:45:36.456+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Eric Blair We recently moved back to the mainland United States after ten years of traveling and living abroad. Our homeschooled kids are getting... ",
		"thread_title": "Obamacare forces companies to drop workers from private insurance",
		"title": "Obamacare forces companies to drop workers from private insurance",
		"type": "conspiracy",
		"uuid": "a4249896270b791e3197cedd422c5f1158fff123"
	},
	"-KhIaGmeaPfA1TwzyaGp": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T00:12:19.459+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "government",
				"salience": 0.4221505,
				"type": "ORGANIZATION"
			},
			{
				"name": "Michael Maharrey",
				"salience": 0.18537292,
				"type": "PERSON"
			},
			{
				"name": "chicken",
				"salience": 0.092397794,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.092397794,
				"type": "LOCATION"
			},
			{
				"name": "game",
				"salience": 0.08913345,
				"type": "EVENT"
			},
			{
				"name": "REAL ID",
				"salience": 0.07620659,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.042340953,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T00:12:19.459+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Michael Maharrey The federal government ratcheted up its game of chicken with states over REAL ID last month, threatening once again to ban residents... ",
		"thread_title": "Feds Ramp Up REAL ID Bullying Tactics",
		"title": "Feds Ramp Up REAL ID Bullying Tactics",
		"type": "conspiracy",
		"uuid": "702a321430e05c787cd43bf9133a7fb3f481b9da"
	},
	"-KhIaGqYkPsv15esEgHZ": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T00:26:51.454+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08z129",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AT%26T"
				},
				"name": "AT&T",
				"salience": 0.39374074,
				"type": "ORGANIZATION"
			},
			{
				"name": "Michael Maharrey Communications",
				"salience": 0.25345853,
				"type": "ORGANIZATION"
			},
			{
				"name": "behest",
				"salience": 0.12633456,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.1041965,
				"type": "ORGANIZATION"
			},
			{
				"name": "taxpayer dollars",
				"salience": 0.07874627,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0435234,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T00:26:51.454+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Michael Maharrey Communications company AT&T spies on you at the behest of the federal government and rakes in millions of taxpayer dollars in the... ",
		"thread_title": "AT&T Helping Feds Spy On Everyone",
		"title": "AT&T Helping Feds Spy On Everyone",
		"type": "conspiracy",
		"uuid": "f2c6375b4ac3265c0830bbfddcaa64c377a7122f"
	},
	"-KhIayHj95MyMW7WgUPu": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T00:50:26.092+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.17350763,
				"type": "LOCATION"
			},
			{
				"name": "Nadia Prupis",
				"salience": 0.17350763,
				"type": "PERSON"
			},
			{
				"name": "advocates",
				"salience": 0.11932194,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.11932194,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.08511153,
				"type": "PERSON"
			},
			{
				"name": "journalist",
				"salience": 0.08511153,
				"type": "PERSON"
			},
			{
				"name": "revelations",
				"salience": 0.08205889,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.052738093,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/052p7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montreal"
				},
				"name": "Montreal",
				"salience": 0.051277317,
				"type": "LOCATION"
			},
			{
				"name": "cell phone calls",
				"salience": 0.029021747,
				"type": "OTHER"
			},
			{
				"name": "text messages",
				"salience": 0.029021747,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T00:50:26.092+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Nadia Prupis Canadian free speech advocates slammed recent revelations that Montreal police tracked a journalist’s cell phone calls, text messages, and locations in an... ",
		"thread_title": "Critics Decry Surveillance of Canadian Journalist as Part of “Horrifying” Culture Shift",
		"title": "Critics Decry Surveillance of Canadian Journalist as Part of “Horrifying” Culture Shift",
		"type": "conspiracy",
		"uuid": "b3227dd405c784b0564d538cf9e9397700c350af"
	},
	"-KhIayNvTYneOHgzS8xb": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T01:00:30.756+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Recep Tayyip Erdoğan",
				"salience": 0.42093602,
				"type": "PERSON"
			},
			{
				"name": "James Holbrooks",
				"salience": 0.2933582,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.14370741,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.09009592,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.051902458,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T01:00:30.756+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By James Holbrooks A day after the administration of President Recep Tayyip Erdoğan dismissed an additional 10,000 civil employees and shut down another 15 media... ",
		"thread_title": "Turkey’s Crackdown on Criticism Continues as Journalists, 10K Civil Servants Arrested",
		"title": "Turkey’s Crackdown on Criticism Continues as Journalists, 10K Civil Servants Arrested",
		"type": "conspiracy",
		"uuid": "6b0b639ba79f18e9f6fc93397f2605940c437406"
	},
	"-KhIayS3Qek7a9k3mUtE": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:25:38.471+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "military forces",
				"salience": 0.4109882,
				"type": "PERSON"
			},
			{
				"name": "James Holbrooks",
				"salience": 0.2124309,
				"type": "PERSON"
			},
			{
				"name": "push",
				"salience": 0.10648693,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.09292508,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.06601309,
				"type": "LOCATION"
			},
			{
				"name": "defense officials",
				"salience": 0.0480484,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.04074712,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.022360284,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:25:38.471+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By James Holbrooks As Iraqi military forces were beginning their initial push into Mosul on Tuesday, the Washington Post was reporting that U.S. defense officials... ",
		"thread_title": "Anti-ISIS Coalition Too Busy Defeating Themselves to Defeat ISIS",
		"title": "Anti-ISIS Coalition Too Busy Defeating Themselves to Defeat ISIS",
		"type": "conspiracy",
		"uuid": "54f41ceb7541a581a43f2ce1537596799f2c1317"
	},
	"-KhIayko7c4p8-tIBZg-": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T04:38:47.251+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Tamara Francis-Fourkiller",
				"salience": 0.3972111,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02jrlv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caddo"
				},
				"name": "Caddo Nation",
				"salience": 0.06612722,
				"type": "ORGANIZATION"
			},
			{
				"name": "everyone",
				"salience": 0.056381002,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock",
				"salience": 0.054657415,
				"type": "LOCATION"
			},
			{
				"name": "donor",
				"salience": 0.047806673,
				"type": "OTHER"
			},
			{
				"name": "construction site",
				"salience": 0.043286122,
				"type": "LOCATION"
			},
			{
				"name": "mass arrests",
				"salience": 0.03761398,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.03761398,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.029755099,
				"type": "LOCATION"
			},
			{
				"name": "Nick Bernabe",
				"salience": 0.023354152,
				"type": "PERSON"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.021680621,
				"type": "OTHER"
			},
			{
				"name": "tribe",
				"salience": 0.018604597,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.018093375,
				"type": "EVENT"
			},
			{
				"name": "Francis-Fourkiller",
				"salience": 0.01438428,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.013983254,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donor",
				"salience": 0.01153856,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.011514433,
				"type": "OTHER"
			},
			{
				"name": "tribe",
				"salience": 0.010279832,
				"type": "OTHER"
			},
			{
				"name": "water protectors",
				"salience": 0.006521348,
				"type": "OTHER"
			},
			{
				"name": "clashes",
				"salience": 0.0056496006,
				"type": "EVENT"
			},
			{
				"name": "activists",
				"salience": 0.0056496006,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.0056496006,
				"type": "ORGANIZATION"
			},
			{
				"name": "Family members",
				"salience": 0.005613117,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0054636537,
				"type": "PERSON"
			},
			{
				"name": "jail",
				"salience": 0.0054393196,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.005327213,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0my9m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caddo_County,_Oklahoma"
				},
				"name": "Caddo County",
				"salience": 0.0049614683,
				"type": "LOCATION"
			},
			{
				"name": "confirmation",
				"salience": 0.0046146377,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0039823,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.003582755,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.003481217,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05mph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma"
				},
				"name": "Oklahoma",
				"salience": 0.0033514774,
				"type": "LOCATION"
			},
			{
				"name": "Red Owl Legal Collective",
				"salience": 0.0028427881,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03_cg_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Lawyers_Guild"
				},
				"name": "National Lawyers Guild",
				"salience": 0.0028427881,
				"type": "ORGANIZATION"
			},
			{
				"name": "everyone",
				"salience": 0.00275852,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0025132042,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0025132042,
				"type": "OTHER"
			},
			{
				"name": "news affiliate",
				"salience": 0.0018778951,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03nk0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/News_program"
				},
				"name": "News",
				"salience": 0.0014785848,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/11/dapl-arrests.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T04:38:47.251+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Nick Bernabe \nFollowing the recent mass arrests of 141 people at the Dakota Access Pipeline construction site located near Standing Rock, North Dakota, an anonymous donor just donated $2.5 million to bail out everyone who was arrested at the protests. \nThe news came after Tamara Francis-Fourkiller, a tribal leader from the Caddo Nation tribe in Caddo County, Oklahoma, was arrested at Standing Rock. Francis-Fourkiller was released after spending two days in jail, but her family says she was just an innocent observer in the clashes between militarized law enforcement and Native American activists, or “water protectors.” \n[ UPDATE 11/1 4:35 pm EST: A statement from Red Owl Legal Collective/National Lawyers Guild that is advising Standing Rock has issued a statement saying the $2.5 million has not been received yet. We are waiting on confirmation from the Caddo Nation tribe.] \nAccording to local news affiliate News On 6 : \nFamily members of Caddo Nation chairwoman Tamara Francis-Fourkiller said an anonymous donor paid $2.5 million late Saturday afternoon to release everyone arrested on Thursday at the Dakota Access Pipeline site. They said, however, that Francis-Fourkiller should not have been arrested in the first place. \nThough the donor who sent the $2.5 million remains anonymous, it appears the person is connected to the Caddo Nation tribe in some way .",
		"thread_title": "Someone Just Donated $2.5 Million to Bail Out Everyone Arrested at Standing Rock",
		"title": "Someone Just Donated $2.5 Million to Bail Out Everyone Arrested at Standing Rock",
		"type": "conspiracy",
		"uuid": "3f9475b17cff16ea2aee6247c3addbc002585f4b"
	},
	"-KhIaz24RbQOZrRiuN0m": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:10:34.257+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.3928842,
				"type": "LOCATION"
			},
			{
				"name": "Vin Armani",
				"salience": 0.2449906,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.15257645,
				"type": "PERSON"
			},
			{
				"name": "email leak",
				"salience": 0.122113794,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.087434955,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:10:34.257+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Vin Armani Hillary Clinton continues to blame Russia for the email leak even though it doesn’t matter who leaked the damning emails if they... ",
		"thread_title": "If Russia Can Rig the US Presidential Election, So Can An Insider",
		"title": "If Russia Can Rig the US Presidential Election, So Can An Insider",
		"type": "conspiracy",
		"uuid": "3fe5e76edbc1ddb69635795777c340301e5f05ca"
	},
	"-KhIaz6ocq2wLAnRUZJa": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:25:27.675+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Derrick Broze",
				"salience": 0.4108236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jm64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atlanta_Hawks"
				},
				"name": "Hawks",
				"salience": 0.19931969,
				"type": "ORGANIZATION"
			},
			{
				"name": "RT",
				"salience": 0.13744092,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h1qg3g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tyrel_Ventura"
				},
				"name": "Tyrel Ventura",
				"salience": 0.113138884,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.04472267,
				"type": "EVENT"
			},
			{
				"name": "DAPL",
				"salience": 0.037913304,
				"type": "OTHER"
			},
			{
				"name": "experiences",
				"salience": 0.033578884,
				"type": "OTHER"
			},
			{
				"name": "Subscribe",
				"salience": 0.02306204,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:25:27.675+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Watching The Hawks RT Tyrel Ventura is joined by independent journalist Derrick Broze to talk about his horrific experiences at the #DAPL protest. Subscribe ",
		"thread_title": "Violent Escalation At The #DAPL Protests w/Derrick Broze",
		"title": "Violent Escalation At The #DAPL Protests w/Derrick Broze",
		"type": "conspiracy",
		"uuid": "61a86ada6b63c199c905c6ab3c744c19b2152185"
	},
	"-KhIazCldNIiuGfVWDys": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:25:27.690+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Derrick Broze",
				"salience": 0.63892233,
				"type": "PERSON"
			},
			{
				"name": "MintPressNews Mint Press",
				"salience": 0.18727069,
				"type": "ORGANIZATION"
			},
			{
				"name": "fight",
				"salience": 0.07770613,
				"type": "EVENT"
			},
			{
				"name": "Standing Rock Sioux Reservation",
				"salience": 0.059344564,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.03675626,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:25:27.690+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By MintPressNews Mint Press News reporter Derrick Broze reports from the Standing Rock Sioux Reservation during the fight against the Dakota Access Pipeline. Broze was... ",
		"thread_title": "Water Protectors Face Off With Police #NoDAPL",
		"title": "Water Protectors Face Off With Police #NoDAPL",
		"type": "conspiracy",
		"uuid": "f76aedcf2bdd0ecf0110491bb22b2e494f77cb56"
	},
	"-KhIazHtftO6B2zQYUJ8": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:35:42.682+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02241w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bev_Harris"
				},
				"name": "Bev Harris",
				"salience": 0.32497382,
				"type": "PERSON"
			},
			{
				"name": "demo",
				"salience": 0.2583759,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election theft mechanism",
				"salience": 0.16326813,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.13484468,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.056540053,
				"type": "OTHER"
			},
			{
				"name": "voting system",
				"salience": 0.038912654,
				"type": "OTHER"
			},
			{
				"name": "Demonstration",
				"salience": 0.023084756,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:35:42.682+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Bev Harris A real-time demo of the most devastating election theft mechanism yet found, with context and explanation. Demonstration uses a real voting system... ",
		"thread_title": "See Real Voting System Rigged For Election Theft – Bev Harris",
		"title": "See Real Voting System Rigged For Election Theft – Bev Harris",
		"type": "conspiracy",
		"uuid": "cbfb2f08b69dd57a3a01ec4a0fcdbef611ace640"
	},
	"-KhIb-IMHSgjetQbE7mo": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T20:03:33.288+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Catherine J. Frompovich",
				"salience": 0.4647603,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05mzm6p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PECO_Energy_Company"
				},
				"name": "PECO Energy Company",
				"salience": 0.11119177,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b5npj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Smart_meter"
				},
				"name": "Smart Meters",
				"salience": 0.09781939,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.07570426,
				"type": "LOCATION"
			},
			{
				"name": "breast cancer survivor",
				"salience": 0.03881335,
				"type": "PERSON"
			},
			{
				"name": "testimony",
				"salience": 0.013186995,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07jwhk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_utilities_commission"
				},
				"name": "PUC",
				"salience": 0.006695637,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.004960262,
				"type": "LOCATION"
			},
			{
				"name": "RF",
				"salience": 0.003914686,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.0037604258,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hg9q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electromotive_force"
				},
				"name": "EMF",
				"salience": 0.0027853637,
				"type": "ORGANIZATION"
			},
			{
				"name": "SM RFR",
				"salience": 0.0027144076,
				"type": "ORGANIZATION"
			},
			{
				"name": "customer acceptance",
				"salience": 0.002712411,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0024451206,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.0023693508,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.0022240656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_27",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voltage"
				},
				"name": "EMFs",
				"salience": 0.002187228,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.002133137,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.002133137,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.0018162656,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.0017660055,
				"type": "PERSON"
			},
			{
				"name": "following",
				"salience": 0.001680947,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08xhxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pell_Grant"
				},
				"name": "Pell",
				"salience": 0.0016633663,
				"type": "PERSON"
			},
			{
				"name": "Heep",
				"salience": 0.0016633663,
				"type": "PERSON"
			},
			{
				"name": "Pennsylvania Public Utility Commission's Administrative Law Court",
				"salience": 0.0015617759,
				"type": "ORGANIZATION"
			},
			{
				"name": "utilities",
				"salience": 0.001470086,
				"type": "ORGANIZATION"
			},
			{
				"name": "health",
				"salience": 0.0013940415,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.0013624908,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.0013624908,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.0013624908,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.0013624908,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvanians",
				"salience": 0.0013282096,
				"type": "PERSON"
			},
			{
				"name": "lawyer",
				"salience": 0.0013047631,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.0013047631,
				"type": "OTHER"
			},
			{
				"name": "customers",
				"salience": 0.0013044723,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0523pkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ADA_Amendments_Act_of_2008"
				},
				"name": "ADAAA",
				"salience": 0.0013013722,
				"type": "ORGANIZATION"
			},
			{
				"name": "research",
				"salience": 0.001295054,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.0012587981,
				"type": "PERSON"
			},
			{
				"name": "RFs",
				"salience": 0.0011986784,
				"type": "ORGANIZATION"
			},
			{
				"name": "testimony",
				"salience": 0.0011366595,
				"type": "EVENT"
			},
			{
				"name": "testimony",
				"salience": 0.0011366595,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0011366595,
				"type": "LOCATION"
			},
			{
				"name": "parts",
				"salience": 0.0011366595,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0011366595,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.0011366595,
				"type": "OTHER"
			},
			{
				"name": "MD",
				"salience": 0.0010902203,
				"type": "PERSON"
			},
			{
				"name": "utility customers",
				"salience": 0.0010901366,
				"type": "PERSON"
			},
			{
				"name": "service",
				"salience": 0.0010901366,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.0010819378,
				"type": "OTHER"
			},
			{
				"name": "RFR exposure",
				"salience": 0.0010466215,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0010461943,
				"type": "LOCATION"
			},
			{
				"name": "Exhibit A-2",
				"salience": 0.0010117894,
				"type": "OTHER"
			},
			{
				"name": "EMF",
				"salience": 0.0009843457,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0009843457,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00092461956,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.0009226743,
				"type": "WORK_OF_ART"
			},
			{
				"name": "case",
				"salience": 0.0009226743,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.0009226743,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04mxw8y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Godshall"
				},
				"name": "Robert Godshall",
				"salience": 0.00086764735,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.0008524234,
				"type": "OTHER"
			},
			{
				"name": "staff member",
				"salience": 0.00084170693,
				"type": "PERSON"
			},
			{
				"name": "AMI SMs",
				"salience": 0.0007896384,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.0007825088,
				"type": "PERSON"
			},
			{
				"name": "dichotomy",
				"salience": 0.000782478,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0007721126,
				"type": "OTHER"
			},
			{
				"name": "human health studies",
				"salience": 0.0007702325,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.00076968217,
				"type": "EVENT"
			},
			{
				"name": "excess",
				"salience": 0.00076968217,
				"type": "OTHER"
			},
			{
				"name": "Members",
				"salience": 0.00076968217,
				"type": "PERSON"
			},
			{
				"name": "court rules",
				"salience": 0.00076968217,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.00076968217,
				"type": "EVENT"
			},
			{
				"name": "Meters",
				"salience": 0.0007501943,
				"type": "OTHER"
			},
			{
				"name": "Meters",
				"salience": 0.0007501943,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00072666525,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00070632383,
				"type": "LOCATION"
			},
			{
				"name": "PA Public Utility Commission",
				"salience": 0.0006997861,
				"type": "ORGANIZATION"
			},
			{
				"name": "cell phone research",
				"salience": 0.0006959584,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.00066650874,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00066650874,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.00066650874,
				"type": "OTHER"
			},
			{
				"name": "backup",
				"salience": 0.00066650874,
				"type": "PERSON"
			},
			{
				"name": "advance",
				"salience": 0.00066650874,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.00066650874,
				"type": "ORGANIZATION"
			},
			{
				"name": "researchers",
				"salience": 0.0006572618,
				"type": "PERSON"
			},
			{
				"name": "AMI",
				"salience": 0.0006427833,
				"type": "OTHER"
			},
			{
				"name": "public service commission",
				"salience": 0.0006198876,
				"type": "ORGANIZATION"
			},
			{
				"name": "studies",
				"salience": 0.0005865619,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.00058039336,
				"type": "OTHER"
			},
			{
				"name": "EHS",
				"salience": 0.0005762225,
				"type": "OTHER"
			},
			{
				"name": "Cancer",
				"salience": 0.00056106877,
				"type": "OTHER"
			},
			{
				"name": "Cancers",
				"salience": 0.00056106877,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.00056106877,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.00056106877,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.00056106877,
				"type": "OTHER"
			},
			{
				"name": "utilities",
				"salience": 0.00056106877,
				"type": "ORGANIZATION"
			},
			{
				"name": "Exhibits",
				"salience": 0.0005474929,
				"type": "OTHER"
			},
			{
				"name": "Exhibits",
				"salience": 0.0005474929,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00054060895,
				"type": "PERSON"
			},
			{
				"name": "Meter",
				"salience": 0.0005260197,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.0005183347,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.0005183347,
				"type": "OTHER"
			},
			{
				"name": "Exhibits A-1 thru W",
				"salience": 0.0004737846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.0004737846,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c5lg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Judge"
				},
				"name": "Your Honor",
				"salience": 0.0004737846,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.00046800583,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.00046800583,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00046800583,
				"type": "ORGANIZATION"
			},
			{
				"name": "Magda Havas",
				"salience": 0.00046243478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0wq41j8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Martha_Herbert"
				},
				"name": "Martha Herbert",
				"salience": 0.00046243478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0127x486",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lennart_Hardell"
				},
				"name": "Lennart Hardell",
				"salience": 0.00046243478,
				"type": "PERSON"
			},
			{
				"name": "Sam Milham",
				"salience": 0.00046243478,
				"type": "PERSON"
			},
			{
				"name": "readers",
				"salience": 0.00046144018,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.00044883744,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00044883744,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00044883744,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00043251863,
				"type": "LOCATION"
			},
			{
				"name": "cell phone",
				"salience": 0.00043208312,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Meters",
				"salience": 0.00042942693,
				"type": "OTHER"
			},
			{
				"name": "Meters",
				"salience": 0.00042942693,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00042805352,
				"type": "WORK_OF_ART"
			},
			{
				"name": "all",
				"salience": 0.00042805352,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00042486392,
				"type": "PERSON"
			},
			{
				"name": "exposure",
				"salience": 0.00042285692,
				"type": "OTHER"
			},
			{
				"name": "meter",
				"salience": 0.00041071916,
				"type": "OTHER"
			},
			{
				"name": "meter",
				"salience": 0.00041071916,
				"type": "OTHER"
			},
			{
				"name": "Exhibit A-4",
				"salience": 0.0004055868,
				"type": "WORK_OF_ART"
			},
			{
				"name": "disability",
				"salience": 0.00040525367,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00040525367,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00040525367,
				"type": "OTHER"
			},
			{
				"name": "disability",
				"salience": 0.00040525367,
				"type": "OTHER"
			},
			{
				"name": "ADA Amendments Act",
				"salience": 0.00040263025,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cancer",
				"salience": 0.00039338533,
				"type": "OTHER"
			},
			{
				"name": "pulses",
				"salience": 0.0003852094,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00037984896,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.00037984896,
				"type": "WORK_OF_ART"
			},
			{
				"name": "radiation",
				"salience": 0.00037984896,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.00037984896,
				"type": "OTHER"
			},
			{
				"name": "RF",
				"salience": 0.00037984896,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.00037389545,
				"type": "PERSON"
			},
			{
				"name": "studies",
				"salience": 0.0003715858,
				"type": "OTHER"
			},
			{
				"name": "exposure",
				"salience": 0.0003677991,
				"type": "EVENT"
			},
			{
				"name": "state constitution",
				"salience": 0.000363418,
				"type": "ORGANIZATION"
			},
			{
				"name": "consumers",
				"salience": 0.000363418,
				"type": "PERSON"
			},
			{
				"name": "consent",
				"salience": 0.000363418,
				"type": "OTHER"
			},
			{
				"name": "RF Cancer Studies",
				"salience": 0.00036103622,
				"type": "OTHER"
			},
			{
				"name": "KEY dispute",
				"salience": 0.00036028965,
				"type": "EVENT"
			},
			{
				"name": "researchers",
				"salience": 0.00035993752,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.00035993752,
				"type": "LOCATION"
			},
			{
				"name": "health effects",
				"salience": 0.00035236098,
				"type": "OTHER"
			},
			{
				"name": "sections",
				"salience": 0.00035091242,
				"type": "OTHER"
			},
			{
				"name": "BREAST",
				"salience": 0.00035091242,
				"type": "OTHER"
			},
			{
				"name": "microwave technology",
				"salience": 0.00035091242,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00033815266,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0003375762,
				"type": "OTHER"
			},
			{
				"name": "North Carolina Utilities Commission Exhibit",
				"salience": 0.00033698333,
				"type": "EVENT"
			},
			{
				"name": "Health",
				"salience": 0.00032858475,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00032812584,
				"type": "OTHER"
			},
			{
				"name": "paragraph",
				"salience": 0.00032812584,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.00032812584,
				"type": "OTHER"
			},
			{
				"name": "exposure",
				"salience": 0.00032812584,
				"type": "OTHER"
			},
			{
				"name": "exposures",
				"salience": 0.00032812584,
				"type": "OTHER"
			},
			{
				"name": "harm",
				"salience": 0.00032142614,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.00032113979,
				"type": "OTHER"
			},
			{
				"name": "prongs",
				"salience": 0.0003168343,
				"type": "OTHER"
			},
			{
				"name": "printout",
				"salience": 0.0003168343,
				"type": "OTHER"
			},
			{
				"name": "printout",
				"salience": 0.0003168343,
				"type": "OTHER"
			},
			{
				"name": "physicians",
				"salience": 0.0003168343,
				"type": "PERSON"
			},
			{
				"name": "RFR",
				"salience": 0.00031587598,
				"type": "OTHER"
			},
			{
				"name": "paragraph",
				"salience": 0.00031587598,
				"type": "WORK_OF_ART"
			},
			{
				"name": "paragraph",
				"salience": 0.00031587598,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cell phone",
				"salience": 0.0003146847,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cell phones",
				"salience": 0.0003146847,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cell phones",
				"salience": 0.0003146847,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Exhibit",
				"salience": 0.0003133674,
				"type": "OTHER"
			},
			{
				"name": "utility customers",
				"salience": 0.00030293645,
				"type": "PERSON"
			},
			{
				"name": "cell phones",
				"salience": 0.00030293645,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "customers",
				"salience": 0.000300974,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.00030011087,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Pertinent Published Literature Regarding Electromagnetic Radiation",
				"salience": 0.00028804946,
				"type": "OTHER"
			},
			{
				"name": "microwave",
				"salience": 0.0002841237,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "microwave industry",
				"salience": 0.00027720083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dcms",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Postal_Service"
				},
				"name": "U.S. Postal Service",
				"salience": 0.00027624948,
				"type": "ORGANIZATION"
			},
			{
				"name": "dozens",
				"salience": 0.00027434592,
				"type": "PERSON"
			},
			{
				"name": "Bibliography",
				"salience": 0.00027434592,
				"type": "WORK_OF_ART"
			},
			{
				"name": "view",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "Q",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "Schedule",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "WORLD",
				"salience": 0.00027434592,
				"type": "LOCATION"
			},
			{
				"name": "academics",
				"salience": 0.00027434592,
				"type": "PERSON"
			},
			{
				"name": "importance",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "dossier",
				"salience": 0.00027434592,
				"type": "OTHER"
			},
			{
				"name": "pulses",
				"salience": 0.00027351605,
				"type": "OTHER"
			},
			{
				"name": "pulses",
				"salience": 0.00027351605,
				"type": "OTHER"
			},
			{
				"name": "meter",
				"salience": 0.00027202436,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00026786185,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.00026786185,
				"type": "OTHER"
			},
			{
				"name": "exposures",
				"salience": 0.00026786185,
				"type": "OTHER"
			},
			{
				"name": "exposure",
				"salience": 0.00026786185,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00026786185,
				"type": "OTHER"
			},
			{
				"name": "Electricity",
				"salience": 0.00026786185,
				"type": "OTHER"
			},
			{
				"name": "radiation",
				"salience": 0.00026631026,
				"type": "OTHER"
			},
			{
				"name": "utility regulations",
				"salience": 0.00026631026,
				"type": "OTHER"
			},
			{
				"name": "conclusions",
				"salience": 0.00026631026,
				"type": "OTHER"
			},
			{
				"name": "Conclusion",
				"salience": 0.00026631026,
				"type": "OTHER"
			},
			{
				"name": "regulatory agency",
				"salience": 0.00026631026,
				"type": "ORGANIZATION"
			},
			{
				"name": "RFRs",
				"salience": 0.0002635708,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00026212804,
				"type": "OTHER"
			},
			{
				"name": "MD",
				"salience": 0.00025636752,
				"type": "PERSON"
			},
			{
				"name": "regulations",
				"salience": 0.00025636752,
				"type": "OTHER"
			},
			{
				"name": "outs",
				"salience": 0.00025636752,
				"type": "OTHER"
			},
			{
				"name": "meter",
				"salience": 0.00025530913,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.00025078983,
				"type": "OTHER"
			},
			{
				"name": "Disabilities Act Amendments",
				"salience": 0.00024942015,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ADA Amendments",
				"salience": 0.00024942015,
				"type": "WORK_OF_ART"
			},
			{
				"name": "frequency microwave bands",
				"salience": 0.00024602073,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00024602073,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00024499078,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0002442571,
				"type": "LOCATION"
			},
			{
				"name": "Environmental & Resources Studies",
				"salience": 0.00024366885,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0002406141,
				"type": "OTHER"
			},
			{
				"name": "Assistant Professor of Neurology",
				"salience": 0.0002368353,
				"type": "PERSON"
			},
			{
				"name": "PhD",
				"salience": 0.0002368353,
				"type": "OTHER"
			},
			{
				"name": "frequency bands",
				"salience": 0.0002368353,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0002368353,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.0002368353,
				"type": "PERSON"
			},
			{
				"name": "PhD",
				"salience": 0.0002368353,
				"type": "OTHER"
			},
			{
				"name": "Neuroscientist",
				"salience": 0.0002368353,
				"type": "PERSON"
			},
			{
				"name": "PhD",
				"salience": 0.0002368353,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00023368695,
				"type": "OTHER"
			},
			{
				"name": "meter",
				"salience": 0.00023361864,
				"type": "OTHER"
			},
			{
				"name": "meter",
				"salience": 0.00023361864,
				"type": "OTHER"
			},
			{
				"name": "Meters",
				"salience": 0.00023361864,
				"type": "OTHER"
			},
			{
				"name": "pulses",
				"salience": 0.00023193918,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00023193918,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00023193918,
				"type": "OTHER"
			},
			{
				"name": "proponents",
				"salience": 0.00022901589,
				"type": "PERSON"
			},
			{
				"name": "North Carolina Utilities Commission",
				"salience": 0.00022636465,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cwx2n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania_Constitution"
				},
				"name": "Pennsylvania Constitution",
				"salience": 0.00022366786,
				"type": "WORK_OF_ART"
			},
			{
				"name": "use",
				"salience": 0.00022212653,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.00022212653,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00022046521,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.00021739677,
				"type": "OTHER"
			},
			{
				"name": "PA PUC Regulations",
				"salience": 0.00021583828,
				"type": "OTHER"
			},
			{
				"name": "health effects",
				"salience": 0.00021486596,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00021486596,
				"type": "OTHER"
			},
			{
				"name": "electromagnetic spectrum",
				"salience": 0.00021383302,
				"type": "OTHER"
			},
			{
				"name": "smart meter installation",
				"salience": 0.00021383302,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00020970522,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0002092798,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.000207277,
				"type": "OTHER"
			},
			{
				"name": "Inherent Rights of Mankind",
				"salience": 0.00020194416,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j7v_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Commonwealth_of_Nations"
				},
				"name": "Commonwealth",
				"salience": 0.00020194416,
				"type": "LOCATION"
			},
			{
				"name": "Risk",
				"salience": 0.00020083303,
				"type": "OTHER"
			},
			{
				"name": "Risk",
				"salience": 0.00020083303,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00020083303,
				"type": "LOCATION"
			},
			{
				"name": "life processes",
				"salience": 0.00020083303,
				"type": "OTHER"
			},
			{
				"name": "frequency bands",
				"salience": 0.00020083303,
				"type": "OTHER"
			},
			{
				"name": "rulemaking process",
				"salience": 0.00020083303,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.00020083303,
				"type": "OTHER"
			},
			{
				"name": "agency powers",
				"salience": 0.00020083303,
				"type": "OTHER"
			},
			{
				"name": "exposures",
				"salience": 0.0002000856,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0002000856,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0002000856,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fv1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Section_One_of_the_Canadian_Charter_of_Rights_and_Freedoms"
				},
				"name": "Section 1",
				"salience": 0.00019939325,
				"type": "OTHER"
			},
			{
				"name": "meter",
				"salience": 0.0001956083,
				"type": "OTHER"
			},
			{
				"name": "Americans with Disability Act Amendments Act",
				"salience": 0.00019499392,
				"type": "PERSON"
			},
			{
				"name": "Exhibit A-1",
				"salience": 0.00019499392,
				"type": "OTHER"
			},
			{
				"name": "HB2200/Act 129",
				"salience": 0.00019367077,
				"type": "OTHER"
			},
			{
				"name": "Act 129",
				"salience": 0.00019367077,
				"type": "WORK_OF_ART"
			},
			{
				"name": "exercise",
				"salience": 0.0001931993,
				"type": "OTHER"
			},
			{
				"name": "Why Are Electromagnetic Fields",
				"salience": 0.00019285995,
				"type": "WORK_OF_ART"
			},
			{
				"name": "proof",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "nonfulfillment",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "experiment",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "happiness.",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "produce",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "individual",
				"salience": 0.00019233613,
				"type": "PERSON"
			},
			{
				"name": "essence",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00019233613,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.00019045312,
				"type": "OTHER"
			},
			{
				"name": "pulses",
				"salience": 0.00018695093,
				"type": "OTHER"
			},
			{
				"name": "penalty",
				"salience": 0.00018515467,
				"type": "OTHER"
			},
			{
				"name": "Director",
				"salience": 0.00018515467,
				"type": "PERSON"
			},
			{
				"name": "cell phone study findings",
				"salience": 0.00018515467,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00018515467,
				"type": "OTHER"
			},
			{
				"name": "sentence",
				"salience": 0.00018515467,
				"type": "OTHER"
			},
			{
				"name": "chief epidemiologist",
				"salience": 0.00018515467,
				"type": "PERSON"
			},
			{
				"name": "SM",
				"salience": 0.00018478137,
				"type": "ORGANIZATION"
			},
			{
				"name": "Privacy",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "prongs",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.00018132674,
				"type": "PERSON"
			},
			{
				"name": "spectrum",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "excess",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "breast cancer survivor",
				"salience": 0.00018132674,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.00018132674,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Ranking",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "Table",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "Privacy",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "Ranking",
				"salience": 0.00018132674,
				"type": "OTHER"
			},
			{
				"name": "Table",
				"salience": 0.00018132674,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "report",
				"salience": 0.00018132674,
				"type": "WORK_OF_ART"
			},
			{
				"name": "property",
				"salience": 0.00017997049,
				"type": "OTHER"
			},
			{
				"name": "Radiofrequency Research: Does Funding Matter",
				"salience": 0.00017647864,
				"type": "OTHER"
			},
			{
				"name": "utilities",
				"salience": 0.00017469861,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01mvt4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trent_University"
				},
				"name": "Trent University",
				"salience": 0.00017407874,
				"type": "ORGANIZATION"
			},
			{
				"name": "Exhibit T Electrosensitivity",
				"salience": 0.00017343086,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00017325066,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00017325066,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00017325066,
				"type": "OTHER"
			},
			{
				"name": "health issues",
				"salience": 0.00017325066,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.00017325066,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.00017325066,
				"type": "ORGANIZATION"
			},
			{
				"name": "usage",
				"salience": 0.00017158601,
				"type": "OTHER"
			},
			{
				"name": "districts",
				"salience": 0.00017158601,
				"type": "LOCATION"
			},
			{
				"name": "influence",
				"salience": 0.00016942326,
				"type": "OTHER"
			},
			{
				"name": "Exhibit S",
				"salience": 0.00016884173,
				"type": "OTHER"
			},
			{
				"name": "Exhibits A",
				"salience": 0.00016884173,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01__ql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Extremely_low_frequency"
				},
				"name": "ELF",
				"salience": 0.00016884173,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.00016604144,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.00016604144,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.00016604144,
				"type": "LOCATION"
			},
			{
				"name": "NCUC Exhibit A-4",
				"salience": 0.00016389578,
				"type": "LOCATION"
			},
			{
				"name": "health impacts",
				"salience": 0.00016309717,
				"type": "OTHER"
			},
			{
				"name": "charities",
				"salience": 0.00016238734,
				"type": "ORGANIZATION"
			},
			{
				"name": "science",
				"salience": 0.00016238734,
				"type": "OTHER"
			},
			{
				"name": "utilities",
				"salience": 0.00016189608,
				"type": "OTHER"
			},
			{
				"name": "utilities",
				"salience": 0.00016189608,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maryland"
				},
				"name": "MD",
				"salience": 0.00015777606,
				"type": "LOCATION"
			},
			{
				"name": "vires",
				"salience": 0.00015700726,
				"type": "OTHER"
			},
			{
				"name": "actuality",
				"salience": 0.00015700726,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00015700726,
				"type": "OTHER"
			},
			{
				"name": "grant monies",
				"salience": 0.00015700726,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.00015700726,
				"type": "OTHER"
			},
			{
				"name": "cancer patient",
				"salience": 0.00015700726,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00015700726,
				"type": "OTHER"
			},
			{
				"name": "animal",
				"salience": 0.00015700726,
				"type": "OTHER"
			},
			{
				"name": "RFRs",
				"salience": 0.00015197671,
				"type": "PERSON"
			},
			{
				"name": "Nuremberg Code",
				"salience": 0.00015197671,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.00015001417,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00015001417,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.00015001417,
				"type": "OTHER"
			},
			{
				"name": "industry representatives",
				"salience": 0.00015001417,
				"type": "PERSON"
			},
			{
				"name": "microwave technology industry representative assistance",
				"salience": 0.00015001417,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.00014812767,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.00014812767,
				"type": "LOCATION"
			},
			{
				"name": "researchers",
				"salience": 0.00014812767,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/022x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Computer_security"
				},
				"name": "Cyber Security",
				"salience": 0.00014695857,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dq8f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_at_Albany,_SUNY"
				},
				"name": "University of Albany",
				"salience": 0.00014575418,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pediatric Neurologist",
				"salience": 0.00014575418,
				"type": "PERSON"
			},
			{
				"name": "Part",
				"salience": 0.00014571188,
				"type": "OTHER"
			},
			{
				"name": "Dirty Electricity Making You Sick?",
				"salience": 0.00014274071,
				"type": "OTHER"
			},
			{
				"name": "effects studies",
				"salience": 0.00014171554,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0001397419,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.00013903649,
				"type": "OTHER"
			},
			{
				"name": "industry research studies",
				"salience": 0.00013642389,
				"type": "OTHER"
			},
			{
				"name": "industry studies",
				"salience": 0.00013642389,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.00013642389,
				"type": "OTHER"
			},
			{
				"name": "industry studies",
				"salience": 0.00013642389,
				"type": "OTHER"
			},
			{
				"name": "bills",
				"salience": 0.00013544304,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00013544304,
				"type": "ORGANIZATION"
			},
			{
				"name": "exercise",
				"salience": 0.00013544304,
				"type": "OTHER"
			},
			{
				"name": "bills",
				"salience": 0.00013544304,
				"type": "OTHER"
			},
			{
				"name": "Honors",
				"salience": 0.00013544304,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00013452393,
				"type": "OTHER"
			},
			{
				"name": "Institute for Health and the Environment",
				"salience": 0.00013159678,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Department of Oncology",
				"salience": 0.00013159678,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04bl11",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts_General_Hospital"
				},
				"name": "Massachusetts General Hospital",
				"salience": 0.00013159678,
				"type": "LOCATION"
			},
			{
				"name": "HB2200",
				"salience": 0.00013159678,
				"type": "OTHER"
			},
			{
				"name": "Washington State Department of Health",
				"salience": 0.00013159678,
				"type": "ORGANIZATION"
			},
			{
				"name": "page",
				"salience": 0.0001304919,
				"type": "OTHER"
			},
			{
				"name": "health issues",
				"salience": 0.00012616841,
				"type": "OTHER"
			},
			{
				"name": "utility",
				"salience": 0.00012561926,
				"type": "ORGANIZATION"
			},
			{
				"name": "offence",
				"salience": 0.00012495607,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.00012402509,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/043hzk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electromagnetic_interference"
				},
				"name": "Dirty Power",
				"salience": 0.00012359569,
				"type": "OTHER"
			},
			{
				"name": "NCUC",
				"salience": 0.00012359569,
				"type": "ORGANIZATION"
			},
			{
				"name": "PA House Consumer Affairs Committee",
				"salience": 0.00012313567,
				"type": "ORGANIZATION"
			},
			{
				"name": "opt-outs",
				"salience": 0.0001182569,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00011727669,
				"type": "OTHER"
			},
			{
				"name": "floor",
				"salience": 0.00011727669,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00011727669,
				"type": "PERSON"
			},
			{
				"name": "sessions",
				"salience": 0.00011727669,
				"type": "EVENT"
			},
			{
				"name": "legislature",
				"salience": 0.00011727669,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chair",
				"salience": 0.00011727669,
				"type": "PERSON"
			},
			{
				"name": "campaign coffers",
				"salience": 0.00011727669,
				"type": "OTHER"
			},
			{
				"name": "Hyper-sensitivity",
				"salience": 0.00011727669,
				"type": "OTHER"
			},
			{
				"name": "CRUX",
				"salience": 0.00011727669,
				"type": "OTHER"
			},
			{
				"name": "redress",
				"salience": 0.00011727669,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00011688008,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00011688008,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00011688008,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00011688008,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00011688008,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wqg8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_Medical_School"
				},
				"name": "Harvard Medical School",
				"salience": 0.000113946255,
				"type": "ORGANIZATION"
			},
			{
				"name": "University Hospital Orebro",
				"salience": 0.000113946255,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02h4rq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bachelor_of_Science"
				},
				"name": "BSC",
				"salience": 0.000113946255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b6df",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Former"
				},
				"name": "Former",
				"salience": 0.000113946255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ch34z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Professional_degrees_of_public_health"
				},
				"name": "MPH",
				"salience": 0.000113946255,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Sweden",
				"salience": 0.000113946255,
				"type": "LOCATION"
			},
			{
				"name": "David Carpenter",
				"salience": 0.000113946255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.000113946255,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.000113946255,
				"type": "LOCATION"
			},
			{
				"name": "literature",
				"salience": 0.0001119747,
				"type": "OTHER"
			},
			{
				"name": "https://www.scribd.com/doc/289782183/Ranking-Electricity-Meters-for-Risk-to-Health-Privacy-and-Cyber-Security",
				"salience": 0.00011159033,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fyyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Health_and_Human_Services"
				},
				"name": "DHHS",
				"salience": 0.00010977053,
				"type": "ORGANIZATION"
			},
			{
				"name": "home",
				"salience": 0.00010924588,
				"type": "LOCATION"
			},
			{
				"name": "healthcare professionals",
				"salience": 0.00010924588,
				"type": "PERSON"
			},
			{
				"name": "utility companies",
				"salience": 0.00010924588,
				"type": "ORGANIZATION"
			},
			{
				"name": "electrohypersensitivity",
				"salience": 0.00010883927,
				"type": "OTHER"
			},
			{
				"name": "Paragraph",
				"salience": 0.00010883927,
				"type": "WORK_OF_ART"
			},
			{
				"name": "right",
				"salience": 0.00010883927,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0001051665,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.00010437984,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00010437984,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.000103599064,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00009954472,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.00009954472,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Nutrition",
				"salience": 0.00009863423,
				"type": "OTHER"
			},
			{
				"name": "physicians",
				"salience": 0.00009863423,
				"type": "PERSON"
			},
			{
				"name": "Ranking Electricity Meters",
				"salience": 0.00009662291,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.00009610694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, DC",
				"salience": 0.0000958416,
				"type": "LOCATION"
			},
			{
				"name": "work",
				"salience": 0.00009573356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "property",
				"salience": 0.00009424081,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00009424081,
				"type": "OTHER"
			},
			{
				"name": "charts",
				"salience": 0.000091757574,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.000088717316,
				"type": "PERSON"
			},
			{
				"name": "other",
				"salience": 0.000088331166,
				"type": "OTHER"
			},
			{
				"name": "wash",
				"salience": 0.000088331166,
				"type": "LOCATION"
			},
			{
				"name": "chart",
				"salience": 0.000088331166,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.000088331166,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "monographs",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "papers",
				"salience": 0.00008540443,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nurses",
				"salience": 0.00008540443,
				"type": "PERSON"
			},
			{
				"name": "counting",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.00008540443,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Certification",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "government agency oppressions",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "magazines",
				"salience": 0.00008540443,
				"type": "WORK_OF_ART"
			},
			{
				"name": "website",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "degrees",
				"salience": 0.00008540443,
				"type": "OTHER"
			},
			{
				"name": "airline",
				"salience": 0.00008540443,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.00008160024,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.00008160024,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.000079938036,
				"type": "LOCATION"
			},
			{
				"name": "flag",
				"salience": 0.00007914514,
				"type": "OTHER"
			},
			{
				"name": "NCUC Exhibit",
				"salience": 0.00007836032,
				"type": "EVENT"
			},
			{
				"name": "reputation",
				"salience": 0.000076531636,
				"type": "OTHER"
			},
			{
				"name": "human",
				"salience": 0.00007367376,
				"type": "PERSON"
			},
			{
				"name": "poster",
				"salience": 0.00007367376,
				"type": "WORK_OF_ART"
			},
			{
				"name": "collusion",
				"salience": 0.00007367376,
				"type": "OTHER"
			},
			{
				"name": "collusion",
				"salience": 0.00007367376,
				"type": "OTHER"
			},
			{
				"name": "Holistic Health Sciences",
				"salience": 0.00007277463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d35zk"
				},
				"name": "Catherine",
				"salience": 0.00007277463,
				"type": "PERSON"
			},
			{
				"name": "ES",
				"salience": 0.00007217138,
				"type": "LOCATION"
			},
			{
				"name": "crime",
				"salience": 0.000067969064,
				"type": "OTHER"
			},
			{
				"name": "rollout",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "omission",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000063791675,
				"type": "PERSON"
			},
			{
				"name": "none",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "edge",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "variances",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "hazards",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "refusal",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "grant money",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.000063791675,
				"type": "OTHER"
			},
			{
				"name": "proclamations",
				"salience": 0.00006331448,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088k6p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Consumers_Energy"
				},
				"name": "Consumers Energy",
				"salience": 0.000060698454,
				"type": "ORGANIZATION"
			},
			{
				"name": "Central Hudson Valley",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/028653",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Automatic_meter_reading"
				},
				"name": "AMR",
				"salience": 0.000052556694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/010pxn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Port_Angeles,_Washington"
				},
				"name": "Port Angeles",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colorado",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0220r2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fountain"
				},
				"name": "Fountain",
				"salience": 0.000052556694,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maryland"
				},
				"name": "Maryland",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"name": "Orthomolecular Theory and Practice plus Paralegal Studies",
				"salience": 0.000052556694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gh4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hawaii"
				},
				"name": "Hawaii",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07vfmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/DTE_Energy"
				},
				"name": "DTE",
				"salience": 0.000052556694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/050ks",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maine"
				},
				"name": "Maine",
				"salience": 0.000052556694,
				"type": "LOCATION"
			},
			{
				"name": "pie charts",
				"salience": 0.0000462521,
				"type": "OTHER"
			},
			{
				"name": "state regulatory agencies",
				"salience": 0.000037279344,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/06/smart_meter_radiation.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T20:03:33.288+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 24,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Catherine J. Frompovich \nPart 1 of 4 \nThe following is the testimony I will present pro se [without a lawyer representing me] to the Pennsylvania Public Utility Commission’s Administrative Law Court, November 2 and 3, 2016 as a result of my not permitting an AMI Smart Meter to be retrofitted on to my electric service by PECO, an Exelon Company that provides electricity and service to the suburban Philadelphia where I live. \nThis testimony addresses most of the health, legal, and constitutional issues, plus the politics involved regarding the unsafe and RF/EMF cancer-causing technology forced on consumers, along with threats of no electric service if utility customers refuse an AMI Smart Meter. \nThere are four parts to the entire testimony that was 18 pages long plus 195 pages of Exhibits A-1 thru W, and other documentation I had in my brief case (not presented but as backup, if needed) that totaled in excess of three to four hundred pages of scientific documentation, published research, etc. \nPersonally, I think after reading the entire testimony, which will appear in four parts, readers can understand what’s involved with unsafe, fire-prone, and RF/EMF/dirty electricity-producing AMI Smart Meters when for decades utilities provided safe, non-plastic parts analog meters. Before the Administrative Law Court at the PA Public Utility Commission Philadelphia, PA – November 2 & 3, 2016 \nYour Honor, Judge Heep and Judge Pell, Members of the PA PUC, PECO Energy Company, the Exelon legal team, and all interested parties: \nSince today is the rescheduled postponed June 27, 2016 hearing and for which I, Catherine J Frompovich, submitted written testimony five days in advance of that previous hearing as per court rules, I have decided to revise and include additional testimony interspersed into the previous 75 pages (10 pages of testimony and 65 pages of Exhibits A thru Q) that I submitted via the U.S. Postal Service and which all parties received, I presume. \nHowever, in view of the paramount importance, plus dire consequences, of EMFs/RFs being forced onto Pennsylvania consumers with no opt-out for personal safety and protection from 24/7/365 non-ionizing radiation emitted by AMI Smart Meters microwave technology, and my being a five-year breast cancer survivor, I submit into testimony and evidence that the PA PUC and all participating Pennsylvania utilities, not just PECO as in my case, must factor in the American with Disabilities Act Amendments, which redefine cancer as a disability, especially since there are cancer-causing effects from EMFs/RFs about which I submit into the record hundreds of documented scientific evidence as dozens of Exhibits per the Schedule of Exhibits I now introduce, plus printed documents I have with me in support of the four-page Bibliography of Pertinent Published Literature Regarding Electromagnetic Radiation, Cancer & AMI Smart Meters that I also submit into the record as Exhibit S . \nSince the ADA Amendments Act provides for three “prongs” of what constitutes a disability, I am submitting into evidence a printout titled “Americans with Disability Act Amendments Act (ADAAA)” pointing out appropriate and applicable sections Exhibit A-1 ; a two-page printout titled “ADA Amendments redefine cancer as a disability” Exhibit A-2 ; along with a 43-page dossier containing about 240 published studies regarding BREAST and Other Cancers and EMF/ELF/RF Cancer Studies Exhibit A-3 ; and topping off those documents with a two-page letter dated 2 August 2016 from the foremost EMF/RF researchers, physicians and academics in the WORLD written to the North Carolina Utilities Commission Exhibit A-4 wherein in the third paragraph they state: \nSmart meters and cell phones occupy similar frequency bands of the electromagnetic spectrum, meaning that cell phone research can apply to smart meter RFR. Smart meter RFR consists of frequent, very intense but very brief pulses throughout the day. Because smart meter exposure over a 24 hour period can be very prolonged ( pulses can average 9,600 times a day ), and because there is building evidence that the sharp, high intensity pulses are particularly harmful , the cell phone study findings are applicable when discussing adverse health impacts from smart meters. \nThose five researchers, David Carpenter, MD, Director, Institute for Health and the Environment, University of Albany Dr Lennart Hardell, MD, PhD, Professor, Department of Oncology, University Hospital Orebro, Sweden Dr Magda Havas, BSC, PhD, Environmental & Resources Studies. Trent University, Canada Dr Martha Herbert, MD, PhD, Assistant Professor of Neurology, Harvard Medical School, Pediatric Neurologist and Neuroscientist at the Massachusetts General Hospital, Boston Dr Sam Milham, MD, MPH, Former chief epidemiologist, Washington State Department of Health \npoint out in the last sentence of the first paragraph, “… it is imperative that the North Carolina Utilities Commission be fully aware of the harm that RFR can cause and allow utility customers to opt out of smart meter installation with no penalty.” \nFrompovich respectfully points out, and also cautions the PA PUC, that in not permitting opt outs from AMI Smart Meters in Pennsylvania during formulating its AMI SM regulations, since HB2200 stated AMI SMs were NOT to be mandated , it has breached ethical and legal standards regarding unsafe AMI SMs regarding the RFRs they emit. Various states have permitted safe electric power usage by granting and implementing AMI SMs opt outs, which the PA PUC deliberately refused in formulating its utility regulations regarding AMI SMs thereby subjecting consumers to unknown adverse health effects which, in essence, violate the Nuremberg Code since consumers’ consent was not required nor asked, and their use apparently amounts to an experiment on PECO’s customers. \nAgain, Frompovich points to the letter addressed to the NCUC Exhibit A-4 at the end of the second paragraph wherein those researchers cite the U.S. NTP June 2016 study Conclusion in part stating “…adds proof to the conclusions from the human health studies that radiofrequency radiation increases risk of cancer .” \nFrompovich further elaborates that cell phone RFR exposure is elective , i.e., depending upon personal choice, use, and an individual’s ability to turn off cell phones, thereby reducing and/or avoiding similar frequency microwave bands and RFRs exposures both cell phones and AMI SMs produce. \nHowever, harmful personal bodily RFR exposure has been mandated by PA PUC Regulations—not HB2200/Act 129 (2008) and, therefore, is absolutely illegal, since Act 129 does not defy nor negate the Pennsylvania state constitution’s “Inherent Rights of Mankind, Section 1”, but it’s the Commonwealth’s regulatory agency—the PA PUC—that is guilty of nonfulfillment, I allege: \nAll men [and women] are born equally free and independent, and have certain inherent and indefeasible rights, among which are those of enjoying and defending life and liberty, of acquiring, possessing and protecting property and reputation , and of pursuing their own happiness. … Pennsylvania Constitution, Section 1. \nHowever, contrary to that Pennsylvania constitutional right is the fact that mandated AMI Smart Meter RFR exposure, because of no opt outs in Pennsylvania specifically via PA PUC Regulations not Act 129, literally provides no way to escape and/or avoid AMI SMs microwave RFRs. That is illegal and should be prosecuted criminally, Frompovich contends. Furthermore, the PA PUC overstepped its agency powers and, Frompovich contends, is guilty of committing ultra vires during its rulemaking process. \nThe above five researchers Exhibit A-4 delineate cell phone and Smart Meters as basically the same “animal” because both occupy similar frequency bands on the electromagnetic spectrum! See paragraph 3 of their letter to the NCUC for more detail, including that Smart Meters over a 24-hour period can average 9,600 pulses a day causing high intensity pulses known as “dirty electricity .” \nI submit into the record Exhibit A-5 Dirty Electricity or Dirty Power and the 10-page report “Why Are Electromagnetic Fields Dangerous? – Is Dirty Electricity Making You Sick?” including 2 charts [ Table 1 Ranking Electric Meters and Table 2 Ranking Electric Meters for Risk of Privacy and Cyber Security] from the 20-page report “Ranking Electricity Meters for Risk to Health, Privacy, and Cyber Security,” available online at https://www.scribd.com/doc/289782183/Ranking-Electricity-Meters-for-Risk-to-Health-Privacy-and-Cyber-Security . \nThe KEY dispute and multi-faceted issue of concern in Frompovich’s case – being a breast cancer survivor in excess of five years – is her free and legal exercise of legal and constitutional rights to be free of the fear, exposure to cancer-causing EMFs, and/or actuality of contracting cancer due to AMI SM RFR exposures 24/7/365 in her home—something that the ADA Amendments Act indisputably encompass, since once a cancer patient that makes Frompovich covered within one of the ADAAA prongs for all time, and also includes Frompovich’s indefeasible right to protect property— both her home and her personal body and its life processes —including her reputation. \nThat federal ADAAA must be factored into Frompovich’s case since PECO has obtained federal grant monies to implement its AMI Smart Meters rollout, and the law states that any business that accepts federal grant money is mandated to abide by the ADAAA, including state regulatory agencies like the PA PUC. \nFrompovich’s refusal of an AMI SM, plus her human and innate right to protect her health, body and property, are more than confirmed when those five researchers point out “… the strongest evidence for hazards coming from RFR is cancer , there is a growing body of evidence that some people develop a condition called electrohypersensitivity (EHS).” See paragraph 4 of the letter to NCUC Exhibit A-4 . \nOn page 2, paragraph 1 of that same letter, the researchers further point out a dichotomy in science, which is the very fact that independent research versus industry research studies are at coincidental, if not predictable , variances, as per the chart I raise up and submit into the record , a double-sided poster “Radiofrequency Research: Does Funding Matter,” which shows two pie charts depicting those conflicting statistics. \nNon-industry studies indicate 70% harmful effects with 30% no effects, while industry studies indicate 32 % harmful effects with 68% no effects! Statistically, that’s almost a wash, as each just about cancels the other, however, there’s a slight edge of 2% from non-industry studies indicating harmful effects. More interestingly, though, is that industry studies DID find 32% harmful effects studies—almost one-third of the studies and, yet, the industry concludes differently stating there are none! That alone should be a red flag for them, or anyone of scientific mind, to investigate further and they did not, which indicates some sort of collusion of not wanting to know or find out. Is that a crime of omission or collusion? \nParagraph 2 on page 2 of that letter Exhibit A-4 cites the obvious CRUX of scientific and ethical issues regarding AMI Smart Meters in Pennsylvania, in particular, stating “With a leading [NC] DHHS staff member admitting that he is not qualified to review the literature, and the fact that he relied on industry representatives for assistance, the DHHS conclusion is not surprising.” \nFrompovich feels compelled to question how much of that microwave technology industry representative assistance occurred, and still occurs, with and from PECO and the PA PUC, thereby illegally depriving Frompovich and all Pennsylvanians of their rights to protect their health and property, along with the exercise of redress against what amounts to experimental AMI Smart Meter science whose proponents wantonly do not recognize non-thermal adverse health effects from RFRs, which have been known since 1932! I introduce Exhibit T Electrosensitivity (ES) and Electromagnetic Hyper-sensitivity (EHS) into the record to document that in 1962, 1979, 2009 and 2015 various health issues have been identified with EMF non-thermal exposures. \nYour Honors, I respectfully ask the court to instruct PECO to produce the experimental studies, rather than epidemiological studies, indicating no non-thermal effects from EMFs/RFs. Where’s the science? \nAren’t PECO’s customers entitled to have that evidence? \nFrompovich also feels compelled to ask this court the following: How much influence did the microwave industry contribute to PA State Representative Robert Godshall’s campaign coffers and/or his preferred charities that apparently has enabled Godshall, as Chair of the PA House Consumer Affairs Committee, to sit on opt out bills in the PA legislature for several legislative sessions, including Godshall’s verbal proclamations to others that he will never bring opt out bills to the floor for a vote, which obviously is an impeachable offence for depriving Pennsylvanians of their right to redress government and government agency oppressions that enable utility companies to harass and bully customers about cutting off electric service if they refuse fire-prone AMI SMs in Pennsylvania. \nHere’s what other U.S. states have done regarding AMI Smart Meters: \nAnalog meters are definitively offered as the opt-out meter in four states: Arizona, California, Maine, and Texas. The Nevada public service commission urges the utilities to provide the meter that will have the “greatest customer acceptance,” which, clearly, is the analog. \nThree states offer the “existing meter” as the opt-out meter. An existing meter might or might not be analog. Georgia, Hawaii, and Consumers Energy in Michigan. \nThree states let the utility decide: Florida, Maryland, and Nevada. The Nevada public service commission urges the utilities to provide the meter that will have the “greatest customer acceptance,” which, clearly, is the analog. \nFour states or utilities definitively forbid analog opt-outs: Fountain in Colorado, DTE in Michigan, Central Hudson Valley in New York (AMR), and Port Angeles in Washington (touted as the first place to ban smart meters—not much help you are required to have a digital meter on your home!). \nTwo states/districts require smart meters: Pennsylvania and Washington, DC. \nSource: http://www.smartmetereducationnetwork.com/optout-status-other-states.php \nContinued in Part 2. \nCatherine J Frompovich ( website ) is a retired natural nutritionist who earned advanced degrees in Nutrition and Holistic Health Sciences, Certification in Orthomolecular Theory and Practice plus Paralegal Studies. Her work has been published in national and airline magazines since the early 1980s. Catherine authored numerous books on health issues along with co-authoring papers and monographs with physicians, nurses, and holistic healthcare professionals. She has been a consumer healthcare researcher 35 years and counting.",
		"thread_title": "Smart Meter Case Testimony Before the Pennsylvania Public Utility Commission: What No One Wants to Acknowledge About EMF Damage",
		"title": "Smart Meter Case Testimony Before the Pennsylvania Public Utility Commission: What No One Wants to Acknowledge About EMF Damage",
		"type": "conspiracy",
		"uuid": "e74d0a70f5fab73a2766fa15c81ac1820704085c"
	},
	"-KhIb-R9vsmkzJRbB_HQ": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T00:00:56.085+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Clint Siegner",
				"salience": 0.32383338,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.13213503,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.11565959,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.10063151,
				"type": "PERSON"
			},
			{
				"name": "terms",
				"salience": 0.09973398,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.09973398,
				"type": "OTHER"
			},
			{
				"name": "silver",
				"salience": 0.07324582,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.055026717,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T00:00:56.085+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Clint Siegner It just doesn’t matter much whether Hillary Clinton or Donald Trump wins the election, at least in terms of gold and silver... ",
		"thread_title": "Regardless of Who Wins the Election, Confidence in Washington DC Is ALREADY Shattered",
		"title": "Regardless of Who Wins the Election, Confidence in Washington DC Is ALREADY Shattered",
		"type": "conspiracy",
		"uuid": "f8105c872d7a99b8c39a559e8005d368910e98d8"
	},
	"-KhIb-VrpXwhUa7YO5XF": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:40:30.832+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Kurt Nimmo",
				"salience": 0.27913904,
				"type": "PERSON"
			},
			{
				"name": "Blacklisted News The Iraqis",
				"salience": 0.18798646,
				"type": "PERSON"
			},
			{
				"name": "base",
				"salience": 0.13825044,
				"type": "LOCATION"
			},
			{
				"name": "missiles",
				"salience": 0.13333641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.086742714,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.07121736,
				"type": "LOCATION"
			},
			{
				"name": "discovery",
				"salience": 0.044563733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.029381923,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "DOD",
				"salience": 0.029381923,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:40:30.832+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Kurt Nimmo, Blacklisted News The Iraqis found missiles at an Islamic State base in Mosul stamped with USA and DOD. The discovery did not... ",
		"thread_title": "Iraqis in Mosul Find US Missiles at Captured Islamic State Base",
		"title": "Iraqis in Mosul Find US Missiles at Captured Islamic State Base",
		"type": "conspiracy",
		"uuid": "8b3c1f190fdb0f55ee0ea46def67823074f9eb12"
	},
	"-KhIb-_GTrAPXdPpyXI8": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:45:30.745+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Tom Luongo",
				"salience": 0.47807235,
				"type": "PERSON"
			},
			{
				"name": "interest rates",
				"salience": 0.19912985,
				"type": "OTHER"
			},
			{
				"name": "Federal Reserve's Open Market Committee",
				"salience": 0.15090048,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.08647755,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.085419804,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:45:30.745+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Tom Luongo The Federal Reserve’s Open Market Committee chose not to raise interest rates six days out from an election. The statement was also... ",
		"thread_title": "Fed Holds on Raising Rates, Fears Rising Dollar",
		"title": "Fed Holds on Raising Rates, Fears Rising Dollar",
		"type": "conspiracy",
		"uuid": "7840aac829f6c1b3a4992779694bb322bebd42dd"
	},
	"-KhIb-gBbI2LDxE_744K": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T03:00:37.361+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "catastrophe",
				"salience": 0.4405234,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.23197494,
				"type": "OTHER"
			},
			{
				"name": "Chris ``Kikila'' Perrin",
				"salience": 0.20578755,
				"type": "PERSON"
			},
			{
				"name": "Flint Water Crisis",
				"salience": 0.12171411,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T03:00:37.361+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Chris “Kikila” Perrin Like any moment of catastrophe that flitters through the mainstream media, the Flint Water Crisis cannot be boiled down to a moment. With... ",
		"thread_title": "In Rush to Lay Blame, Media Ignores Positive Community Movement in Flint, Michigan",
		"title": "In Rush to Lay Blame, Media Ignores Positive Community Movement in Flint, Michigan",
		"type": "conspiracy",
		"uuid": "aeb693cd5d9ccd50f516f9136cd34c22278e5aa7"
	},
	"-KhIb-kxvEeC6WWLXVV6": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T18:15:58.346+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "James Corbett",
				"salience": 0.35135993,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.24668296,
				"type": "LOCATION"
			},
			{
				"name": "hatred",
				"salience": 0.17212074,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.17212074,
				"type": "OTHER"
			},
			{
				"name": "election candidates",
				"salience": 0.057715658,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T18:15:58.346+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.5,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By James Corbett With the world spinning into hatred and violence as the two most hated (s)election candidates of all time tell us to hate... ",
		"thread_title": "You Are Being Programmed to Hate",
		"title": "You Are Being Programmed to Hate",
		"type": "conspiracy",
		"uuid": "5df5d7bff8a58596682df230036855799831c1e1"
	},
	"-KhIb-qAUBUK1ZA9DH1a": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T18:25:27.805+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "The US",
				"salience": 0.47254562,
				"type": "LOCATION"
			},
			{
				"name": "Whitney Webb",
				"salience": 0.21441558,
				"type": "PERSON"
			},
			{
				"name": "mystery",
				"salience": 0.10563962,
				"type": "OTHER"
			},
			{
				"name": "drone war",
				"salience": 0.10186615,
				"type": "EVENT"
			},
			{
				"name": "inception",
				"salience": 0.08695312,
				"type": "EVENT"
			},
			{
				"name": "secrecy",
				"salience": 0.018579923,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T18:25:27.805+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Whitney Webb The US’ secret drone war has largely been shrouded in mystery since its inception. Despite its secrecy there is no denying that... ",
		"thread_title": "UK Involvement In US’ Secret Drone War Revealed",
		"title": "UK Involvement In US’ Secret Drone War Revealed",
		"type": "conspiracy",
		"uuid": "cfe6ed1b575e40398f1f7eab1d3bd70db8317724"
	},
	"-KhIb-uVG-qDTk7E6JlX": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T19:17:10.165+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.52339244,
				"type": "LOCATION"
			},
			{
				"name": "Ulson Gunnar",
				"salience": 0.18772383,
				"type": "PERSON"
			},
			{
				"name": "reconstruction",
				"salience": 0.09297483,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.09019948,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.057815056,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dbpy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Republic_of_Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.047894396,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T19:17:10.165+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Ulson Gunnar Despite the United States being engaged in what it calls “reconstruction” in Afghanistan, quarterly reports on their progress doing so reveals expanding... ",
		"thread_title": "US War In Afghanistan Silently Slips Into The Abyss",
		"title": "US War In Afghanistan Silently Slips Into The Abyss",
		"type": "conspiracy",
		"uuid": "676a4e98a0601c74a22c27a077ddd692770d2ad3"
	},
	"-KhIb-zcXy7lnra0lGbe": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T19:17:10.178+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "landgrab protesters",
				"salience": 0.5538711,
				"type": "PERSON"
			},
			{
				"name": "Vin Armani",
				"salience": 0.21910094,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Bundys",
				"salience": 0.06943131,
				"type": "WORK_OF_ART"
			},
			{
				"name": "occupation",
				"salience": 0.06881752,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.05065922,
				"type": "LOCATION"
			},
			{
				"name": "charges",
				"salience": 0.03811993,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T19:17:10.178+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Vin Armani The federal landgrab protesters known as “The Bundys” were recently found not guilty of all charges in their occupation of a building... ",
		"thread_title": "Some Want Injustice To Be Distributed Evenly, Rather Than Not At All",
		"title": "Some Want Injustice To Be Distributed Evenly, Rather Than Not At All",
		"type": "conspiracy",
		"uuid": "063726c998dfdbe9e917b618f205b7aa7bbffcef"
	},
	"-KhIb0npkd_Ry5bTNcYI": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T20:33:06.135+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "drug addict",
				"salience": 0.41587955,
				"type": "OTHER"
			},
			{
				"name": "AMI",
				"salience": 0.13866574,
				"type": "OTHER"
			},
			{
				"name": "Catherine J. Frompovich This",
				"salience": 0.10566954,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b5npj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Smart_meter"
				},
				"name": "Smart Meters",
				"salience": 0.033909738,
				"type": "OTHER"
			},
			{
				"name": "Meters",
				"salience": 0.014734463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hg9q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electromotive_force"
				},
				"name": "EMF",
				"salience": 0.014658337,
				"type": "ORGANIZATION"
			},
			{
				"name": "prevention",
				"salience": 0.012390029,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.009309696,
				"type": "LOCATION"
			},
			{
				"name": "Godshall",
				"salience": 0.008144769,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05mzm6p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PECO_Energy_Company"
				},
				"name": "PECO",
				"salience": 0.0073189093,
				"type": "ORGANIZATION"
			},
			{
				"name": "safety",
				"salience": 0.0070579015,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bqhl7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electromagnetic_hypersensitivity"
				},
				"name": "Electrohypersensitivity",
				"salience": 0.006105974,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.0045263423,
				"type": "ORGANIZATION"
			},
			{
				"name": "consumers",
				"salience": 0.004366398,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.004309702,
				"type": "LOCATION"
			},
			{
				"name": "health effects",
				"salience": 0.004013512,
				"type": "OTHER"
			},
			{
				"name": "EUROPAEM EMF Guideline 2016",
				"salience": 0.0035149672,
				"type": "WORK_OF_ART"
			},
			{
				"name": "RFR",
				"salience": 0.0032768068,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07jwhk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_utilities_commission"
				},
				"name": "PUC",
				"salience": 0.0029272872,
				"type": "ORGANIZATION"
			},
			{
				"name": "testimony",
				"salience": 0.0027576804,
				"type": "OTHER"
			},
			{
				"name": "continuation",
				"salience": 0.0027144481,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.0024474293,
				"type": "OTHER"
			},
			{
				"name": "session",
				"salience": 0.0023047505,
				"type": "EVENT"
			},
			{
				"name": "science",
				"salience": 0.0022365004,
				"type": "OTHER"
			},
			{
				"name": "references",
				"salience": 0.002190894,
				"type": "OTHER"
			},
			{
				"name": "Pennsylvania Public Utility Commission's Administrative Law Court",
				"salience": 0.0018118,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fjdq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Communications_Commission"
				},
				"name": "Federal Communications Commission",
				"salience": 0.0017370717,
				"type": "ORGANIZATION"
			},
			{
				"name": "science",
				"salience": 0.0017359373,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0017359373,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.0017359373,
				"type": "OTHER"
			},
			{
				"name": "microwave technology science",
				"salience": 0.0017359373,
				"type": "OTHER"
			},
			{
				"name": "THERMAL science",
				"salience": 0.0017359373,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0016648916,
				"type": "OTHER"
			},
			{
				"name": "intelligence gathering technology",
				"salience": 0.0016648916,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0016648916,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0016615175,
				"type": "OTHER"
			},
			{
				"name": "controversy",
				"salience": 0.0016354489,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0015878528,
				"type": "ORGANIZATION"
			},
			{
				"name": "technology world",
				"salience": 0.0015878528,
				"type": "OTHER"
			},
			{
				"name": "health problems",
				"salience": 0.0015033354,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0014091545,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0014091545,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rights",
				"salience": 0.0014091545,
				"type": "OTHER"
			},
			{
				"name": "Things",
				"salience": 0.0013018702,
				"type": "OTHER"
			},
			{
				"name": "credibility factor",
				"salience": 0.0013018702,
				"type": "OTHER"
			},
			{
				"name": "energies",
				"salience": 0.0013018702,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.0013018702,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_27",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voltage"
				},
				"name": "EMFs",
				"salience": 0.0012830414,
				"type": "OTHER"
			},
			{
				"name": "Pennsylvania Constitution",
				"salience": 0.0012502233,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cell phones",
				"salience": 0.0011755096,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "microwave industry",
				"salience": 0.0011755096,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0011755096,
				"type": "OTHER"
			},
			{
				"name": "diagnosis",
				"salience": 0.0011755096,
				"type": "OTHER"
			},
			{
				"name": "bills",
				"salience": 0.0011755096,
				"type": "OTHER"
			},
			{
				"name": "ECOPSYCHOLOGY",
				"salience": 0.0010463328,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Pamela Reed Gibson",
				"salience": 0.0010463328,
				"type": "PERSON"
			},
			{
				"name": "health professionals",
				"salience": 0.0010419751,
				"type": "PERSON"
			},
			{
				"name": "sine",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "offense",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "redress",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "conundrum",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "illnesses",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "criterion",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "standard",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0010179437,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.000948575,
				"type": "LOCATION"
			},
			{
				"name": "certainty",
				"salience": 0.0009022962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0840w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Health_Organization"
				},
				"name": "World Health Organization",
				"salience": 0.0008773185,
				"type": "ORGANIZATION"
			},
			{
				"name": "Connie Kirkland",
				"salience": 0.0008595262,
				"type": "PERSON"
			},
			{
				"name": "CAM",
				"salience": 0.0008512656,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0008468721,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.00084318797,
				"type": "OTHER"
			},
			{
				"name": "disability rights",
				"salience": 0.00084318797,
				"type": "OTHER"
			},
			{
				"name": "human health",
				"salience": 0.0008357438,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0008357438,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00080916914,
				"type": "LOCATION"
			},
			{
				"name": "Commissioner",
				"salience": 0.0007675678,
				"type": "PERSON"
			},
			{
				"name": "science",
				"salience": 0.00074249884,
				"type": "OTHER"
			},
			{
				"name": "electromagnetics",
				"salience": 0.00074202917,
				"type": "OTHER"
			},
			{
				"name": "utilities",
				"salience": 0.00074202917,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.0007369183,
				"type": "OTHER"
			},
			{
				"name": "appliances",
				"salience": 0.0007306046,
				"type": "OTHER"
			},
			{
				"name": "sensitivity",
				"salience": 0.000690674,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0006855097,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0006855097,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0006855097,
				"type": "PERSON"
			},
			{
				"name": "statistics",
				"salience": 0.0006855097,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0006855097,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0006855097,
				"type": "PERSON"
			},
			{
				"name": "pain",
				"salience": 0.0006826586,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0006822841,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0006822841,
				"type": "OTHER"
			},
			{
				"name": "state legislators",
				"salience": 0.00066058675,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.0006594607,
				"type": "OTHER"
			},
			{
				"name": "radar",
				"salience": 0.0006560567,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0006537674,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.00062658894,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.00062658894,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.00062082364,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Children",
				"salience": 0.00061894604,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00061894604,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/032mx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Food_and_Drug_Administration"
				},
				"name": "U.S. Food and Drug Administration",
				"salience": 0.0006173292,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0006161814,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.000615751,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.00060903013,
				"type": "OTHER"
			},
			{
				"name": "diagnostics",
				"salience": 0.00060799194,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.0005857052,
				"type": "OTHER"
			},
			{
				"name": "radiation",
				"salience": 0.0005801464,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0005801464,
				"type": "PERSON"
			},
			{
				"name": "microwave radiation",
				"salience": 0.0005801464,
				"type": "OTHER"
			},
			{
				"name": "proclivities",
				"salience": 0.0005801464,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0005643944,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00056093023,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0005381648,
				"type": "OTHER"
			},
			{
				"name": "health issues",
				"salience": 0.0005381648,
				"type": "OTHER"
			},
			{
				"name": "consumer health issues",
				"salience": 0.0005381648,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00053595245,
				"type": "OTHER"
			},
			{
				"name": "sensitivities",
				"salience": 0.00053595245,
				"type": "OTHER"
			},
			{
				"name": "Multiple Chemical Sensitivity",
				"salience": 0.00053595245,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00053595245,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.00052025594,
				"type": "OTHER"
			},
			{
				"name": "commissions",
				"salience": 0.00051807455,
				"type": "OTHER"
			},
			{
				"name": "The Consequences",
				"salience": 0.0005146789,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0005096765,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0005094428,
				"type": "OTHER"
			},
			{
				"name": "Internet of Things",
				"salience": 0.000501151,
				"type": "OTHER"
			},
			{
				"name": "Internet of Things",
				"salience": 0.000501151,
				"type": "OTHER"
			},
			{
				"name": "interventions",
				"salience": 0.000501151,
				"type": "OTHER"
			},
			{
				"name": "utility",
				"salience": 0.00050083396,
				"type": "ORGANIZATION"
			},
			{
				"name": "microwave electromagnetics",
				"salience": 0.00050083396,
				"type": "OTHER"
			},
			{
				"name": "utilities",
				"salience": 0.00050083396,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.000489776,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00048624293,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0004839057,
				"type": "PERSON"
			},
			{
				"name": "modalities",
				"salience": 0.0004839057,
				"type": "OTHER"
			},
			{
				"name": "adults",
				"salience": 0.0004839057,
				"type": "PERSON"
			},
			{
				"name": "science",
				"salience": 0.00048244206,
				"type": "OTHER"
			},
			{
				"name": "surveillance technology",
				"salience": 0.00048062264,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00048062264,
				"type": "LOCATION"
			},
			{
				"name": "lifestyle",
				"salience": 0.00048062264,
				"type": "OTHER"
			},
			{
				"name": "health consequences",
				"salience": 0.00047861075,
				"type": "OTHER"
			},
			{
				"name": "persons",
				"salience": 0.0004700179,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.00046267975,
				"type": "PERSON"
			},
			{
				"name": "safety",
				"salience": 0.00046267975,
				"type": "OTHER"
			},
			{
				"name": "utility technology",
				"salience": 0.00046267975,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.00046074294,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.00045730936,
				"type": "OTHER"
			},
			{
				"name": "lights",
				"salience": 0.00044844908,
				"type": "OTHER"
			},
			{
				"name": "Ward Smith",
				"salience": 0.00044740818,
				"type": "PERSON"
			},
			{
				"name": "nutrition",
				"salience": 0.00043394728,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.00043394728,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04zkhyh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Academy_of_Pediatrics"
				},
				"name": "American Academy of Pediatrics",
				"salience": 0.00043377007,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.00042832518,
				"type": "OTHER"
			},
			{
				"name": "testing",
				"salience": 0.0004225153,
				"type": "EVENT"
			},
			{
				"name": "following",
				"salience": 0.0004190138,
				"type": "OTHER"
			},
			{
				"name": "RF exposures",
				"salience": 0.0004190138,
				"type": "OTHER"
			},
			{
				"name": "doctors",
				"salience": 0.0004190138,
				"type": "PERSON"
			},
			{
				"name": "sick building syndrome",
				"salience": 0.0004190138,
				"type": "OTHER"
			},
			{
				"name": "MCS",
				"salience": 0.0004190138,
				"type": "ORGANIZATION"
			},
			{
				"name": "peer",
				"salience": 0.0004190138,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0004190138,
				"type": "PERSON"
			},
			{
				"name": "occurrences",
				"salience": 0.0004190138,
				"type": "OTHER"
			},
			{
				"name": "Absorption Rates",
				"salience": 0.0004190138,
				"type": "OTHER"
			},
			{
				"name": "SARs",
				"salience": 0.0004190138,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.0004190138,
				"type": "OTHER"
			},
			{
				"name": "RF",
				"salience": 0.00041774637,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00041774637,
				"type": "OTHER"
			},
			{
				"name": "healthcare modalities",
				"salience": 0.00041558963,
				"type": "OTHER"
			},
			{
				"name": "radio transmitter system",
				"salience": 0.00040674105,
				"type": "OTHER"
			},
			{
				"name": "processes",
				"salience": 0.00040674105,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.00040674105,
				"type": "PERSON"
			},
			{
				"name": "government agencies",
				"salience": 0.00040674105,
				"type": "ORGANIZATION"
			},
			{
				"name": "agenda",
				"salience": 0.00040674105,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00040035354,
				"type": "OTHER"
			},
			{
				"name": "lifestyle",
				"salience": 0.00039235145,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.00039235145,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00039235145,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00039235145,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00039235145,
				"type": "OTHER"
			},
			{
				"name": "technologies",
				"salience": 0.00039235145,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.00039155554,
				"type": "OTHER"
			},
			{
				"name": "proclivity",
				"salience": 0.00039155554,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00038341663,
				"type": "ORGANIZATION"
			},
			{
				"name": "monitoring",
				"salience": 0.00037858434,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00037693683,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.00037575295,
				"type": "OTHER"
			},
			{
				"name": "legislature",
				"salience": 0.00037575295,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.00037575295,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00037575295,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00037575295,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00037575295,
				"type": "LOCATION"
			},
			{
				"name": "third parties",
				"salience": 0.00037575295,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00037575295,
				"type": "OTHER"
			},
			{
				"name": "pulses",
				"salience": 0.00037575295,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00037417992,
				"type": "LOCATION"
			},
			{
				"name": "health",
				"salience": 0.0003711875,
				"type": "OTHER"
			},
			{
				"name": "Exhibit U-1",
				"salience": 0.00036319892,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.00036172406,
				"type": "EVENT"
			},
			{
				"name": "no one",
				"salience": 0.00036172406,
				"type": "PERSON"
			},
			{
				"name": "electricity pulses",
				"salience": 0.00036172406,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00036172406,
				"type": "OTHER"
			},
			{
				"name": "fires",
				"salience": 0.00036172406,
				"type": "EVENT"
			},
			{
				"name": "construct",
				"salience": 0.00035751576,
				"type": "OTHER"
			},
			{
				"name": "consumer",
				"salience": 0.00035751576,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00035424624,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.00035424624,
				"type": "OTHER"
			},
			{
				"name": "obligation",
				"salience": 0.00035084278,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.00035084278,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0003482188,
				"type": "OTHER"
			},
			{
				"name": "hearings",
				"salience": 0.0003392594,
				"type": "EVENT"
			},
			{
				"name": "residence",
				"salience": 0.0003392594,
				"type": "LOCATION"
			},
			{
				"name": "paradigm",
				"salience": 0.0003392594,
				"type": "OTHER"
			},
			{
				"name": "witness",
				"salience": 0.0003392594,
				"type": "PERSON"
			},
			{
				"name": "disease",
				"salience": 0.0003392594,
				"type": "OTHER"
			},
			{
				"name": "breast cancer survivor",
				"salience": 0.0003320356,
				"type": "PERSON"
			},
			{
				"name": "testimony",
				"salience": 0.0003320356,
				"type": "OTHER"
			},
			{
				"name": "healthcare system",
				"salience": 0.0003320356,
				"type": "OTHER"
			},
			{
				"name": "consumer health researcher",
				"salience": 0.0003320356,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.0003320356,
				"type": "PERSON"
			},
			{
				"name": "appliances",
				"salience": 0.00032659268,
				"type": "OTHER"
			},
			{
				"name": "explosions",
				"salience": 0.00032659268,
				"type": "EVENT"
			},
			{
				"name": "residences",
				"salience": 0.00032659268,
				"type": "LOCATION"
			},
			{
				"name": "buildings",
				"salience": 0.00032659268,
				"type": "LOCATION"
			},
			{
				"name": "light",
				"salience": 0.00032659268,
				"type": "OTHER"
			},
			{
				"name": "microwave industry",
				"salience": 0.00032659268,
				"type": "OTHER"
			},
			{
				"name": "utility companies",
				"salience": 0.00032659268,
				"type": "ORGANIZATION"
			},
			{
				"name": "allopathy",
				"salience": 0.00032513356,
				"type": "OTHER"
			},
			{
				"name": "PA Public Utility Commission",
				"salience": 0.00031885193,
				"type": "ORGANIZATION"
			},
			{
				"name": "microwave energy",
				"salience": 0.00030673773,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00030673773,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00030673773,
				"type": "PERSON"
			},
			{
				"name": "care",
				"salience": 0.00030673773,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00030673773,
				"type": "OTHER"
			},
			{
				"name": "interrogatory",
				"salience": 0.0003055962,
				"type": "PERSON"
			},
			{
				"name": "science",
				"salience": 0.0003055962,
				"type": "OTHER"
			},
			{
				"name": "customer data marketing agendas",
				"salience": 0.00030382595,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00029905426,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.00029681754,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "curve",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "salt",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "wound",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "assurances",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "parcel",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "surveillance device",
				"salience": 0.00029376036,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "reasons",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "warrants",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "epigenetics",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "privacy",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "diet",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "physiology",
				"salience": 0.00029376036,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.00029307645,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00029307645,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00029307645,
				"type": "LOCATION"
			},
			{
				"name": "record",
				"salience": 0.00029307645,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.00029307645,
				"type": "OTHER"
			},
			{
				"name": "Meters",
				"salience": 0.0002901909,
				"type": "OTHER"
			},
			{
				"name": "Meters",
				"salience": 0.0002901909,
				"type": "OTHER"
			},
			{
				"name": "AMI",
				"salience": 0.00028467173,
				"type": "OTHER"
			},
			{
				"name": "Frompovich",
				"salience": 0.00028356223,
				"type": "OTHER"
			},
			{
				"name": "home wiring",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "environment",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00028279205,
				"type": "PERSON"
			},
			{
				"name": "Electromagnetic fields",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "emissions",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "sockets",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "protections",
				"salience": 0.00028279205,
				"type": "OTHER"
			},
			{
				"name": "fetuses",
				"salience": 0.0002809599,
				"type": "PERSON"
			},
			{
				"name": "breast cancer",
				"salience": 0.00027950184,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0002772664,
				"type": "OTHER"
			},
			{
				"name": "cell phones",
				"salience": 0.00027694562,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "water utility customers",
				"salience": 0.00027694562,
				"type": "PERSON"
			},
			{
				"name": "health principles",
				"salience": 0.00027694562,
				"type": "OTHER"
			},
			{
				"name": "adults",
				"salience": 0.00027694562,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00027694562,
				"type": "PERSON"
			},
			{
				"name": "paradigm",
				"salience": 0.00027694562,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.00026660503,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.00026660503,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.00026541387,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00026461095,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.00026461095,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.00026425874,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.00026036374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00025787714,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedish",
				"salience": 0.00025787714,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Danish",
				"salience": 0.00025787714,
				"type": "LOCATION"
			},
			{
				"name": "permission",
				"salience": 0.00025228327,
				"type": "OTHER"
			},
			{
				"name": "CAM",
				"salience": 0.00024860117,
				"type": "PERSON"
			},
			{
				"name": "proceedings",
				"salience": 0.00024801926,
				"type": "EVENT"
			},
			{
				"name": "researcher",
				"salience": 0.00024801926,
				"type": "PERSON"
			},
			{
				"name": "surveillance",
				"salience": 0.00024801926,
				"type": "OTHER"
			},
			{
				"name": "Exhibit V",
				"salience": 0.00024511933,
				"type": "OTHER"
			},
			{
				"name": "Eat to Beat Disease",
				"salience": 0.000243387,
				"type": "OTHER"
			},
			{
				"name": "natural gas",
				"salience": 0.00023980218,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00023980218,
				"type": "PERSON"
			},
			{
				"name": "butt",
				"salience": 0.00023980218,
				"type": "OTHER"
			},
			{
				"name": "gadgets",
				"salience": 0.00023980218,
				"type": "OTHER"
			},
			{
				"name": "Wi-Fi",
				"salience": 0.00023980218,
				"type": "OTHER"
			},
			{
				"name": "towers",
				"salience": 0.00023980218,
				"type": "LOCATION"
			},
			{
				"name": "mistakes",
				"salience": 0.00023980218,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.00023980218,
				"type": "LOCATION"
			},
			{
				"name": "damage",
				"salience": 0.00023980218,
				"type": "OTHER"
			},
			{
				"name": "frequencies",
				"salience": 0.00023980218,
				"type": "OTHER"
			},
			{
				"name": "cancer health records",
				"salience": 0.00023924388,
				"type": "OTHER"
			},
			{
				"name": "health issues",
				"salience": 0.00023899124,
				"type": "OTHER"
			},
			{
				"name": "health issues",
				"salience": 0.00023899124,
				"type": "OTHER"
			},
			{
				"name": "electromagnetics",
				"salience": 0.00023103645,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.00023103645,
				"type": "OTHER"
			},
			{
				"name": "innovations",
				"salience": 0.00023084819,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00022912152,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00022912152,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.00022912152,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.0002222285,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0tnw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alternative_medicine"
				},
				"name": "Alternative Medicine",
				"salience": 0.00021801265,
				"type": "OTHER"
			},
			{
				"name": "tea",
				"salience": 0.00021666156,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00021343252,
				"type": "OTHER"
			},
			{
				"name": "PA population",
				"salience": 0.00021343252,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00021218209,
				"type": "OTHER"
			},
			{
				"name": "expertise input",
				"salience": 0.00020986544,
				"type": "OTHER"
			},
			{
				"name": "AMI SMs",
				"salience": 0.00020878843,
				"type": "OTHER"
			},
			{
				"name": "termination",
				"salience": 0.00020686678,
				"type": "OTHER"
			},
			{
				"name": "bills",
				"salience": 0.00020686678,
				"type": "OTHER"
			},
			{
				"name": "utility companies",
				"salience": 0.00020686678,
				"type": "ORGANIZATION"
			},
			{
				"name": "cancer",
				"salience": 0.00020354625,
				"type": "OTHER"
			},
			{
				"name": "governor",
				"salience": 0.00020354625,
				"type": "PERSON"
			},
			{
				"name": "technologies",
				"salience": 0.00020287317,
				"type": "OTHER"
			},
			{
				"name": "Printout",
				"salience": 0.0002009923,
				"type": "OTHER"
			},
			{
				"name": "AMI SMs",
				"salience": 0.0002009923,
				"type": "ORGANIZATION"
			},
			{
				"name": "consortium",
				"salience": 0.00019448019,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0chvn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Institutes_of_Health"
				},
				"name": "National Institutes of Health",
				"salience": 0.0001943502,
				"type": "ORGANIZATION"
			},
			{
				"name": "problem",
				"salience": 0.00019270144,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.00019270144,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00019270144,
				"type": "PERSON"
			},
			{
				"name": "EHS",
				"salience": 0.00019270144,
				"type": "OTHER"
			},
			{
				"name": "disregard",
				"salience": 0.00019084982,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0523pkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ADA_Amendments_Act_of_2008"
				},
				"name": "ADAAA",
				"salience": 0.00018779731,
				"type": "ORGANIZATION"
			},
			{
				"name": "odds",
				"salience": 0.00018606882,
				"type": "OTHER"
			},
			{
				"name": "National Center for Complementary and Integrative Health",
				"salience": 0.00018159628,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01brgt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ZigBee"
				},
				"name": "ZigBee",
				"salience": 0.00018078487,
				"type": "OTHER"
			},
			{
				"name": "health effects",
				"salience": 0.00018061802,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.00018061802,
				"type": "OTHER"
			},
			{
				"name": "radiation",
				"salience": 0.00018061802,
				"type": "OTHER"
			},
			{
				"name": "health effects",
				"salience": 0.00018061802,
				"type": "OTHER"
			},
			{
				"name": "radar safety research",
				"salience": 0.00018061802,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.00018061802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j7v_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Commonwealth_of_Nations"
				},
				"name": "Commonwealth",
				"salience": 0.00017949787,
				"type": "LOCATION"
			},
			{
				"name": "liberty",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "pursuit",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "happiness",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "options",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "snooping",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "subsidies",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "health hazards",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "stake",
				"salience": 0.00017912092,
				"type": "OTHER"
			},
			{
				"name": "statistic",
				"salience": 0.00017870388,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00017851517,
				"type": "OTHER"
			},
			{
				"name": "ADA Amendments Act",
				"salience": 0.00017403427,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Exhibit XI",
				"salience": 0.00017403427,
				"type": "PERSON"
			},
			{
				"name": "Exhibit W",
				"salience": 0.00017403427,
				"type": "OTHER"
			},
			{
				"name": "Coalition for Alternatives in Nutrition And Healthcare",
				"salience": 0.00017063344,
				"type": "ORGANIZATION"
			},
			{
				"name": "costs",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "healthcare services",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "continuum",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.00016685526,
				"type": "PERSON"
			},
			{
				"name": "pulses",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "legislature",
				"salience": 0.00016685526,
				"type": "ORGANIZATION"
			},
			{
				"name": "operating budget",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "energies",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "caregiving",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "state budget",
				"salience": 0.00016685526,
				"type": "OTHER"
			},
			{
				"name": "TV shows",
				"salience": 0.00016673868,
				"type": "WORK_OF_ART"
			},
			{
				"name": "PUC Administrative Law Court",
				"salience": 0.0001628445,
				"type": "ORGANIZATION"
			},
			{
				"name": "lifestyle",
				"salience": 0.00015942323,
				"type": "OTHER"
			},
			{
				"name": "consumer health issues",
				"salience": 0.00015724743,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.00015709428,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvanians",
				"salience": 0.0001528754,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.00015064781,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.00015064781,
				"type": "OTHER"
			},
			{
				"name": "impacts",
				"salience": 0.00015064781,
				"type": "OTHER"
			},
			{
				"name": "disabilities",
				"salience": 0.00015064781,
				"type": "OTHER"
			},
			{
				"name": "RFs",
				"salience": 0.0001467878,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00014571562,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bs3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Radio_frequency"
				},
				"name": "RF",
				"salience": 0.00014473,
				"type": "ORGANIZATION"
			},
			{
				"name": "nutritionist",
				"salience": 0.0001439376,
				"type": "OTHER"
			},
			{
				"name": "healthcare issues",
				"salience": 0.00013676718,
				"type": "OTHER"
			},
			{
				"name": "Foods",
				"salience": 0.00013491165,
				"type": "OTHER"
			},
			{
				"name": "government relations department",
				"salience": 0.00013210683,
				"type": "ORGANIZATION"
			},
			{
				"name": "harmonics",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "annotations",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "health cost line items",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "forewarning",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "reams",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "electromagnetic hypersensitivity",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "wellbeing",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "budget shortfall",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00013044155,
				"type": "PERSON"
			},
			{
				"name": "human tissue",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "responsibilities",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00013044155,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.0001246313,
				"type": "PERSON"
			},
			{
				"name": "journalist",
				"salience": 0.0001246313,
				"type": "PERSON"
			},
			{
				"name": "books",
				"salience": 0.0001246313,
				"type": "WORK_OF_ART"
			},
			{
				"name": "books",
				"salience": 0.0001246313,
				"type": "WORK_OF_ART"
			},
			{
				"name": "book",
				"salience": 0.0001246313,
				"type": "WORK_OF_ART"
			},
			{
				"name": "time",
				"salience": 0.0001246313,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.0001246313,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.0001246313,
				"type": "OTHER"
			},
			{
				"name": "food irradiation",
				"salience": 0.000119357755,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.00011838215,
				"type": "EVENT"
			},
			{
				"name": "government relations specialist",
				"salience": 0.000112524925,
				"type": "PERSON"
			},
			{
				"name": "nutrition witness",
				"salience": 0.000112524925,
				"type": "PERSON"
			},
			{
				"name": "Government Relations specialist",
				"salience": 0.000112524925,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.000112524925,
				"type": "PERSON"
			},
			{
				"name": "qualifications",
				"salience": 0.000112524925,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.000112524925,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.000112524925,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.000112524925,
				"type": "PERSON"
			},
			{
				"name": "crisis center",
				"salience": 0.000112524925,
				"type": "LOCATION"
			},
			{
				"name": "rape",
				"salience": 0.000112524925,
				"type": "EVENT"
			},
			{
				"name": "rape",
				"salience": 0.000112524925,
				"type": "EVENT"
			},
			{
				"name": "campaigns",
				"salience": 0.000112524925,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021zj6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Health_Insurance_Portability_and_Accountability_Act"
				},
				"name": "HIPPA",
				"salience": 0.00011023031,
				"type": "ORGANIZATION"
			},
			{
				"name": "half",
				"salience": 0.00010381196,
				"type": "OTHER"
			},
			{
				"name": "recipient",
				"salience": 0.00010250333,
				"type": "PERSON"
			},
			{
				"name": "non-violence",
				"salience": 0.000097431686,
				"type": "OTHER"
			},
			{
				"name": "subcommittee",
				"salience": 0.000097431686,
				"type": "ORGANIZATION"
			},
			{
				"name": "advocate-activist",
				"salience": 0.000097431686,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.000097431686,
				"type": "PERSON"
			},
			{
				"name": "good",
				"salience": 0.000097431686,
				"type": "OTHER"
			},
			{
				"name": "necks",
				"salience": 0.000097431686,
				"type": "OTHER"
			},
			{
				"name": "lobbyist",
				"salience": 0.000097431686,
				"type": "PERSON"
			},
			{
				"name": "executive director",
				"salience": 0.000097431686,
				"type": "PERSON"
			},
			{
				"name": "holistic health practices",
				"salience": 0.000097431686,
				"type": "OTHER"
			},
			{
				"name": "nutrition supplement makers",
				"salience": 0.000097431686,
				"type": "PERSON"
			},
			{
				"name": "Life Extension Foundation",
				"salience": 0.00007896295,
				"type": "ORGANIZATION"
			},
			{
				"name": "Unconventional Cancer Treatments",
				"salience": 0.000069246074,
				"type": "OTHER"
			},
			{
				"name": "Telly Award",
				"salience": 0.000069246074,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03dpl4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Over-the-air_programming"
				},
				"name": "OTA",
				"salience": 0.000069246074,
				"type": "ORGANIZATION"
			},
			{
				"name": "Giraffe Award",
				"salience": 0.00006099572,
				"type": "OTHER"
			},
			{
				"name": "CANAH",
				"salience": 0.00005995767,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "U.S. Congress",
				"salience": 0.00005995767,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0mgkg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amazon.com"
				},
				"name": "Amazon.com",
				"salience": 0.00005995767,
				"type": "OTHER"
			},
			{
				"name": "Turn Off the Violence",
				"salience": 0.00005995767,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/039d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Mason_University"
				},
				"name": "George Mason University",
				"salience": 0.00005995767,
				"type": "ORGANIZATION"
			},
			{
				"name": "OTA-H-405",
				"salience": 0.00005995767,
				"type": "OTHER"
			},
			{
				"name": "NTIS",
				"salience": 0.00005995767,
				"type": "ORGANIZATION"
			},
			{
				"name": "PB91-104893",
				"salience": 0.00005995767,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/06/smart_meter_radiation.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T20:33:06.135+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 26.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Catherine J. Frompovich \nThis is the continuation of the testimony I will present before the Pennsylvania Public Utility Commission’s Administrative Law Court November 2 and 3, 2016. \nCurrently, Chairman Representative Godshall is allowing three more opt out bills to become sine die this session, which should amount to an impeachable offense for denying consumers their inherent and indefeasible rights, especially of redress to government, and also according to the Pennsylvania Constitution, I contend. \nProbably nothing encapsulates and explains the EMF/RFR controversy or conundrum, if you may, from a scientific viewpoint than the 35-page report “ EUROPAEM EMF Guideline 2016 for the prevention, diagnosis and treatment of EMF-related health problems and illnesses ,” which is a Spanish language document and found online at https://listas.um.es/sympa/arc/anuncios/2016-07/msg00069.html This report cites 308 published scientific references, which leaves Frompovich to question why the PA PUC—and PECO in particular—are so daft in proffering that there is no updated science other than the 1940s era ‘safety’ THERMAL science regarding microwave electromagnetic energies based in ‘ancient’ radar studies the microwave industry always trots out as proof of ‘safety’. \nThose ‘safety’ studies originated in Germany during World War II; are totally outmoded; but remain the present Federal Communications Commission’s rules regarding safety of cell phones and AMI Smart Meters. It is now 2016! How come 1940s microwave technology science is being applied as the ‘gold standard’ or ‘scientific criterion’ to meters that will become the key intelligence gathering technology for the Internet of Things? Frompovich has to question the credibility factor of both PECO and the PA PUC for depending upon 1940 science in today’s technology world of 2016. Where’s the science later than the 1940s? Please, may I have those studies PECO supplied to the PA PUC? \nFrompovich, therefore, respectfully suggests that the PA PUC study the above-aforementioned European reports with medical and EHS health professionals, who are qualified to explain the diagnostics and varied modalities discussed, in order to issue updated regulations affecting AMI Smart Meters and their continuous RFR/EMF health-damaging electromagnetics, plus their fire-and-explosion-prone proclivities and occurrences, which definitely was not the case for all the decades utilities used safe and efficient analog meters. \nChildren are the most vulnerable to EMF radiation and, therefore, I introduce Exhibit U-1 “Why children absorb more microwave radiation than adults: The Consequences,” and Exhibit U-2 “American Academy of Pediatrics August 29, 2013 letter urging the Food and Drug Administration Commissioner, the Federal Communications Commission and others to advise the public about Specific Absorption Rates (SARs) regarding EMF/RF exposures.” \nAlso, I want to apprise every one of the fact that electromagnetic sensitivity (EHS) is a growing problem and according to recently reported statistics in the peer reviewed journal ECOPSYCHOLOGY, Professor Pamela Reed Gibson states the following: 26% of the USA population; 19% of the Swedish population; 27% of the Danish population; and 32 % of the German population are EHS compromised. See Exhibit V . However, other sources claim that as much as 5% of the entire world’s population is affected. \nJust as chemical sensitivities were discredited and denied by medical doctors for years—now referred to as “sick building syndrome” or “Multiple Chemical Sensitivity (MCS)—so, too, is EHS now being recognized by many, including the World Health Organization. I introduce Exhibit W “Electrohypersensitivity: a functional impairment due to an inaccessible environment.” Printout available here https://docs.google.com/viewer?a=v&pid=forums&srcid=MDgxODkwOTk5NjU5OTU4ODQwNTYBMTU3NTIzMDA1MTQxNTY1NzI0NTcBTVRzdGFEOUNBUUFKATAuMQEBdjI \nAs Exhibit X I introduce a study no one can refute, “A review on Electromagnetic fields (EMFs) and the reproductive system,” which outlines science the microwave industry, PECO and all utilities utilizing AMI Smart Meters, plus public utility commissions across the USA need to factor into the inevitable legal liability that they are assuming by committing crimes against humanity by exposing the population to unsafe microwave electromagnetics 24/7/365 from dirty electricity pulsed by AMI SMs onto home wiring and into private residences and all buildings retrofitted with AMI Smart Meters. \nBefore I include my previously submitted testimony, I find it necessary to impress upon the court that it should not be Frompovich’s obligation to prove the medical consequences beyond a reasonable doubt, especially in light of the ADA Amendments Act as it applies to those receiving federal funding or even that the consequences of medical problems are more probable than not, since the ADAAA provides Frompovich with disability rights and protections, which PECO and the PA PUC must abide by. \nFurthermore, it should be the indisputable duty of PECO and all Pennsylvania utility companies – but more specifically that of the PA Public Utility Commission’s stated mission for being – to provide safe and non-radiating innovations in utility technology and appliances with 100% certainty, which AMI Smart Meters fail on numerous levels, especially with their proclivity for “hot sockets,” fires and explosions, EMF/RF constant emissions and dirty electricity pulses as frequent as 9600 times a day! \nNo medical-scientific testing has proved AMI Smart Meters EMFs safety regarding non-thermal adverse health effects that I know of. Where’s the science? \nTherefore, Frompovich should not be forced to allow a proven-fire-prone AMI Smart Meter electric service on her property that would radiate dirty electricity into her residence with high RFR pulses every fifteen seconds. \nJust to add more “salt to the wound,” as they would say, there are no assurances that monitoring is not part and parcel of the AMI Smart Meter agenda and an integral surveillance device of the Internet of Things, or that information will be shared with unknown third parties—for whatever reasons—and for which Frompovich does not approve nor give her permission to PECO, the PA PUC or any government agencies or agents. \nTherefore, Frompovich feels her privacy, as well as her home and personal physiology, will be subjected to unlawful, unconstitutional and unnecessary interventions at various levels and, specifically, without proper legal processes, e.g., court-issued warrants, in order to surveil her home that automatically will occur from the two-way ZigBee radio transmitter system of AMI SMs and all “smart” appliances which are built to interact with the coming surveillance technology of the Internet of Things. The times Frompovich makes tea in the morning and shuts off her lights for the night are no one’s business but her own. \nI’ve been researching consumer health issues and whatsoever affects human health negatively , including technologies, since the late 1970s. During my career, I was considered an expert witness providing testimony before several states’ legislature/legislative hearings on health issues. For numerous years I was ahead of both the popular curve and the allopathic paradigm of medicine regarding the role of diet, nutrition, epigenetics, and lifestyle issues in maintaining optimum health, avoiding disease and regaining health utilizing holistic health principles. \nI am in my 78 th year, thank God. Since the early 1970s, when I almost lost my life due to unfortunate medical mistakes and had to remove myself from mainstream allopathic care in order to save my life, I’ve been immersed in what’s called the “holistic lifestyle.” I’ve beaten the odds, including being a breast cancer survivor, using holistic healthcare modalities. For the record, 38.3% of U.S. adults and 11.8% of U.S. children used what’s referred to as CAM in 2007 per NIH statistics[1]. Complementary and Alternative Medicine—CAM as it’s called, is popular throughout the world, while in the U.S. there is the National Center for Complementary and Integrative Health at the National Institutes of Health. \nHowever, the allopathic paradigm considers it, quite frankly, a pain in its professional butt since CAM has become the “go to” healthcare system when allopathy fails one. \nTherefore, I expect that I probably will educate misinformed individuals on the negative health consequences of electromagnetic frequencies from microwave energy producing technologies like cell phones and towers, Wi-Fi, ‘smart’ gadgets, and, in particular, AMI Smart Meters, which are being bully-forced onto electric, natural gas, and municipal water utility customers. Most state legislators, the media and the public are undeniably ignorant of the damage being done to their health. Fortunately, I am not one of those people, thus my refusing an AMI Smart Meter on my house. But, first I think you ought to know some of my background: I’m a well-informed, plus over 40 years published consumer health researcher, advocate-activist, journalist, and author. \nThat I should be taken seriously, I offer some of my professional background: retired practicing natural nutritionist; former registered lobbyist with the U.S. Congress for five years representing holistic healthcare issues; executive director for the national Coalition for Alternatives in Nutrition And Healthcare (CANAH) for five years and, as such, presented FDA-solicited expertise input regarding holistic health practices for its 1990 OTA report OTA-H-405 NTIS #PB91-104893[2] “Unconventional Cancer Treatments” [3]; expert nutrition witness before a congressional subcommittee opposing food irradiation; government relations specialist for a consortium of natural nutrition supplement makers before the U.S. Food and Drug Administration; the first Government Relations specialist for the Life Extension Foundation, who set up LEF’s government relations department; a published journalist; author of numerous books regarding health and lifestyle issues with several books available on Amazon.com and my 2016 book, Eat to Beat Disease, Foods Medicinal Qualities. \nAdditionally, I wrote and produced two TV shows. One called, “ Turn Off the Violence ” was nominated for a Telly Award. That hour-long show was instrumental in securing the Giraffe Award given to persons, who stick out their necks for the common good. The recipient was George Mason University staff member Connie Kirkland[4], who founded a 24-hour crisis center for rape victims and promoted on-campus non-violence educational campaigns specifically relating to rape and domestic violence. What I’ve shared is much less than half of my background. More would take too much of your time. However, I feel compelled to ask, “How many people can match my qualifications to discuss consumer health issues?” \nFurthermore, I want to underscore upfront that IF I were a habitual drug addict, rather than an informed, concerned health-conscious researcher and consumer being harassed for trying to protect and preserve my health, I probably would be welcomed with open arms, plus there would be all types of programs and subsidies available for help. Because I am opposing faulty and health-damaging RF/EMF ‘science’, plus vested-interest snooping, surveillance, and customer data marketing agendas using AMI smart meters, I am harassed and even threatened with termination of electric service even though all my bills are paid in full. That leaves me with no options but to dutifully invoke and defend my state and federal constitutional rights to life, liberty, and the pursuit of happiness. Isn’t there something radically wrong with such a construct, especially in the USA, if I have to do that? \nAttorney Ward Smith’s interrogatory requesting Frompovich’s cancer health records, quite frankly, leaves everyone with whom I’ve shared that fact, totally aghast and amazed! Why? Because Frompovich’s medical records are her personal information protected under HIPPA and I must protect them. Furthermore, since the PUC Administrative Law Court hearing is of public record, Frompovich does not want her personal medical records made public information during any level in these proceedings, as that is her fundamental right. \nI respectfully bring to this court’s attention that my breast cancer and medical records are NOT the issue. What’s the issue, problem, and at stake not only for me, but for all Pennsylvanians, is the total callous disregard by utility companies—PECO included, the PA PUC, and the Commonwealth for health hazards, safety, and the wellbeing of all Pennsylvanians, especially those with health issues, compromised immune systems, disabilities, and especially young, growing children—fetuses in particular—whom RF/EMF and dirty electricity produced by AMI Smart Meters affect and impact negatively. \nBefore presenting into the record additional reams of recent research with documentation and annotations—not 1940s vintage radar safety research—for RFs/EMFs and microwave electromagnetic energies impacts upon cancer and health, I feel it necessary to introduce something no one probably has thought about nor factored into the AMI Smart Meter hidden costs continuum , and that is, healthcare services and ancillary costs stemming from non-ionizing radiation RFs/EMFs Smart Meters impact upon human tissue. \nThere are mounting underlying, long-term adverse health effects accruing as we speak from PA PUC-PECO forced AMI Smart Meter 24/7/365 RF/EMF electromagnetics, pulses, harmonics and dirty electricity, specifically adverse Non-thermal health effects, impacting children and an ageing PA population, which will generate dire fiscal consequences, plus responsibilities, upon Penna. Medicaid health cost line items in each year’s operating budget for the Commonwealth. \nTo cement that forewarning, I offer the World Health Organization’s statistic, “Approximately 10% of reported cases of EHS [electromagnetic hypersensitivity] were considered severe,” which means specialized caregiving. That, however, does not include cancer-induced health issues from RFs/EMFs! What kind of budget shortfall will AMI Smart Meters adverse health effects eventually generate for PA’s legislature and governor to haggle about, when we’ve seen what’s been going on recently to get a state budget passed? Has anyone thought about that very real problem? \nContinued in Part 3",
		"thread_title": "Smart Meter Case Testimony Before the Pennsylvania Public Utility Commission: What No One Wants to Acknowledge About EMF Damage (Part 2 of 4)",
		"title": "Smart Meter Case Testimony Before the Pennsylvania Public Utility Commission: What No One Wants to Acknowledge About EMF Damage (Part 2 of 4)",
		"type": "conspiracy",
		"uuid": "096858c81b7e65acb92a0070dc7c37ac70c49a44"
	},
	"-KhIb0tUeYx1XZ27Betv": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T02:47:08.638+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Justin Gardner",
				"salience": 0.27656844,
				"type": "PERSON"
			},
			{
				"name": "cannabis industry",
				"salience": 0.23519467,
				"type": "OTHER"
			},
			{
				"name": "flower",
				"salience": 0.14035493,
				"type": "OTHER"
			},
			{
				"name": "bud",
				"salience": 0.13548261,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colorado",
				"salience": 0.12431567,
				"type": "LOCATION"
			},
			{
				"name": "data analysis",
				"salience": 0.088083684,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:47:08.638+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Justin Gardner The Colorado cannabis industry has quickly gone from bud to full flower, as indicated by a new in-depth data analysis by the... ",
		"thread_title": "Colorado Cannabis Industry Contributes More to Economy Than All Other Industries: Report",
		"title": "Colorado Cannabis Industry Contributes More to Economy Than All Other Industries: Report",
		"type": "conspiracy",
		"uuid": "d7c1d94bce58f1f6e5de9f91c84b8c2fa496694a"
	},
	"-KhIb0yJsHL7ykcTVOtI": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T16:52:06.225+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Claire Bernish Disinformation",
				"salience": 0.33468083,
				"type": "OTHER"
			},
			{
				"name": "Misinformation",
				"salience": 0.121566914,
				"type": "OTHER"
			},
			{
				"name": "Propaganda",
				"salience": 0.121566914,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.08607596,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.08293438,
				"type": "OTHER"
			},
			{
				"name": "distractions",
				"salience": 0.08293438,
				"type": "OTHER"
			},
			{
				"name": "tools",
				"salience": 0.059270356,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.05296754,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.029001363,
				"type": "ORGANIZATION"
			},
			{
				"name": "ally",
				"salience": 0.029001363,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T16:52:06.225+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Claire Bernish Disinformation. Misinformation. Propaganda. Outright lies. Purposeful distractions. Misleading bias. All tools of the government and close ally, corporate media, to keep the... ",
		"thread_title": "When Good People Share Bad Info — Here’s Why You Need to Fact Check Before You Click Share",
		"title": "When Good People Share Bad Info — Here’s Why You Need to Fact Check Before You Click Share",
		"type": "conspiracy",
		"uuid": "cf55e005e68dfa99fa8d74b4188d18f7ac7310bf"
	},
	"-KhIb11Af8YBAJTzR1s1": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T17:11:49.532+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Amanda Froelich",
				"salience": 0.42381388,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.17422937,
				"type": "EVENT"
			},
			{
				"name": "news",
				"salience": 0.1434374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock",
				"salience": 0.109152496,
				"type": "LOCATION"
			},
			{
				"name": "tension",
				"salience": 0.10424819,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.045118667,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T17:11:49.532+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Amanda Froelich It should be evident if you’re following news concerning the Standing Rock protests in North Dakota that tension continues to escalate between... ",
		"thread_title": "Police Turn In Badges Rather Than Incite Violence Against Standing Rock Protesters: Report",
		"title": "Police Turn In Badges Rather Than Incite Violence Against Standing Rock Protesters: Report",
		"type": "conspiracy",
		"uuid": "de2c7318f12c7284b373d82c67592d4c3e660c90"
	},
	"-KhIb14m5ru7eaN7CZp6": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T17:27:28.247+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "continuation",
				"salience": 0.39280927,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.26070356,
				"type": "OTHER"
			},
			{
				"name": "Catherine J. Frompovich This",
				"salience": 0.2394764,
				"type": "PERSON"
			},
			{
				"name": "Pennsylvania Public Utility Commission's Administrative Law Court",
				"salience": 0.107010745,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T17:27:28.247+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.5
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Catherine J. Frompovich This is the continuation of the testimony I will present before the Pennsylvania Public Utility Commission’s Administrative Law Court November 2... ",
		"thread_title": "Smart Meter Case Testimony Before the Pennsylvania Public Utility Commission: What No One Wants to Acknowledge About EMF Damage (Part 3 of 4)",
		"title": "Smart Meter Case Testimony Before the Pennsylvania Public Utility Commission: What No One Wants to Acknowledge About EMF Damage (Part 3 of 4)",
		"type": "conspiracy",
		"uuid": "eb220c23463f9df324cf0f92b88506c41f4f9644"
	},
	"-KhIb18qU1U1KqDMNrfy": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T17:36:57.750+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "world",
				"salience": 0.55945027,
				"type": "LOCATION"
			},
			{
				"name": "Shane Trejo",
				"salience": 0.39022657,
				"type": "PERSON"
			},
			{
				"name": "Tenth Amendment",
				"salience": 0.050323177,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T17:36:57.750+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Shane Trejo This brave new world we are living in is getting very wild and crazy during this election season. Although the Tenth Amendment... ",
		"thread_title": "WikiLeaks Revelations Leave The Federal Emperor Wearing No Clothes",
		"title": "WikiLeaks Revelations Leave The Federal Emperor Wearing No Clothes",
		"type": "conspiracy",
		"uuid": "69e93a8afe51828bffce8c5d1c30a3bb7dec5e04"
	},
	"-KhIb1DYdOt_aAL6UFeV": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T18:00:50.740+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Bernie Suarez",
				"salience": 0.35455802,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.2088054,
				"type": "WORK_OF_ART"
			},
			{
				"name": "source",
				"salience": 0.17048326,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02pfqn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LiveLeak"
				},
				"name": "LiveLeak",
				"salience": 0.10713408,
				"type": "ORGANIZATION"
			},
			{
				"name": "crisis",
				"salience": 0.08098445,
				"type": "EVENT"
			},
			{
				"name": "car bomb explosion",
				"salience": 0.07803479,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T18:00:50.740+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Bernie Suarez A recent video released by a LiveLeak source shows a staged car bomb explosion followed by what I call must-watch jaw-dropping crisis... ",
		"thread_title": "Iraqi Car Bomb Jaw-Dropping Crisis Actor Fakery Caught On Video",
		"title": "Iraqi Car Bomb Jaw-Dropping Crisis Actor Fakery Caught On Video",
		"type": "conspiracy",
		"uuid": "09a6989efa0ae4b702bf7e35b00a9902ec959485"
	},
	"-KhIb1Hn3XjsPJVUWr27": {
		"author": "Brandon Turbeville",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T18:10:50.613+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Brandon Turbeville",
				"salience": 0.2569564,
				"type": "PERSON"
			},
			{
				"name": "floodwaters",
				"salience": 0.17775275,
				"type": "OTHER"
			},
			{
				"name": "journey",
				"salience": 0.11836981,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.106129795,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.104846954,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06yxd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Carolina"
				},
				"name": "South Carolina",
				"salience": 0.07984944,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.07913726,
				"type": "LOCATION"
			},
			{
				"name": "Nichols",
				"salience": 0.07695759,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T18:10:50.613+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Brandon Turbeville As the floodwaters receded from Nichols, South Carolina and the surrounding areas, many residents made the emotional journey home to assess what... ",
		"thread_title": "FEMA Opens Loan Window As Red Cross Tries To Shut Down Shelters",
		"title": "FEMA Opens Loan Window As Red Cross Tries To Shut Down Shelters",
		"type": "conspiracy",
		"uuid": "6885d2e6ef484cb89e670a14c9c90e1f72f10510"
	},
	"-KhIb1LmKA4JiaWeM4qF": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T19:15:47.388+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Students",
				"salience": 0.29688808,
				"type": "PERSON"
			},
			{
				"name": "Matt Agorist",
				"salience": 0.27523124,
				"type": "PERSON"
			},
			{
				"name": "dose",
				"salience": 0.11314724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.09398272,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01p9s3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_Valley_State_University"
				},
				"name": "Grand Valley State University",
				"salience": 0.08316452,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vn7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allendale,_Michigan"
				},
				"name": "Allendale",
				"salience": 0.08316452,
				"type": "LOCATION"
			},
			{
				"name": "police state",
				"salience": 0.054421652,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T19:15:47.388+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Matt Agorist Students at Grand Valley State University in Allendale, Michigan got a hefty dose of the police state this week as they were... ",
		"thread_title": "Cops Threaten To Arrest Students If They Don’t Stop Handing Out Constitutions",
		"title": "Cops Threaten To Arrest Students If They Don’t Stop Handing Out Constitutions",
		"type": "conspiracy",
		"uuid": "7491e70acab05cfa77d4ddb6dd4645d267202a8e"
	},
	"-KhIb1SG_9akhyrVKeWU": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T19:56:01.728+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.23152822,
				"type": "ORGANIZATION"
			},
			{
				"name": "GRTV",
				"salience": 0.23152822,
				"type": "PERSON"
			},
			{
				"name": "surprise",
				"salience": 0.1645888,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.11540357,
				"type": "EVENT"
			},
			{
				"name": "chaos",
				"salience": 0.11540357,
				"type": "OTHER"
			},
			{
				"name": "examination",
				"salience": 0.06683128,
				"type": "EVENT"
			},
			{
				"name": "trigger mechanism",
				"salience": 0.037358172,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.037358172,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T19:56:01.728+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By GRTV The FBI’s October surprise has thrown the 2016 election into November chaos. But an examination of the trigger mechanism behind this event reveals... ",
		"thread_title": "U.S. Elections “November Chaos”: What You’re Not Being Told",
		"title": "U.S. Elections “November Chaos”: What You’re Not Being Told",
		"type": "conspiracy",
		"uuid": "175c7828a1a86c7ff20bf993539e82e6ed5c2fdd"
	},
	"-KhIb1Wb1yQLhJEUBQ5z": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T16:25:20.291+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Tony Cartalucci",
				"salience": 0.29613099,
				"type": "PERSON"
			},
			{
				"name": "reality",
				"salience": 0.2066431,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.14356126,
				"type": "EVENT"
			},
			{
				"name": "division",
				"salience": 0.09301192,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.09301192,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.09047212,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.077168666,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T16:25:20.291+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Tony Cartalucci In reality, since even before Syria’s conflict began unfolding in 2011, the United States had been planning for the nation’s division and... ",
		"thread_title": "US Plan “C” in Syria: Make “Al Qaeda Central” The New Capital",
		"title": "US Plan “C” in Syria: Make “Al Qaeda Central” The New Capital",
		"type": "conspiracy",
		"uuid": "689fa27bc92400b6a9c18d09b3315738d8b919a1"
	},
	"-KhIb1a1Y251ccGJYZkT": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T16:35:21.682+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Shane Trejo",
				"salience": 0.25209743,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.18636161,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.17796193,
				"type": "EVENT"
			},
			{
				"name": "millions",
				"salience": 0.12665474,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.11204894,
				"type": "OTHER"
			},
			{
				"name": "property rights violations",
				"salience": 0.079181395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.06569397,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T16:35:21.682+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Shane Trejo The Dakota Access Pipeline protests have made national news, as millions of Americans are concerned with potential property rights violations and environmental... ",
		"thread_title": "Drone Restrictions Can Help Peaceful Protesters Combat Injustice",
		"title": "Drone Restrictions Can Help Peaceful Protesters Combat Injustice",
		"type": "conspiracy",
		"uuid": "17359768953b61269780878e26d074a37f679b7c"
	},
	"-KhIb1eyn-0rMQmpsxWL": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T16:50:46.736+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Leshu Torchin",
				"salience": 0.3149066,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018sg9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_St_Andrews"
				},
				"name": "University of St Andrews",
				"salience": 0.3149066,
				"type": "ORGANIZATION"
			},
			{
				"name": "users",
				"salience": 0.13222459,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.10118268,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.07395532,
				"type": "LOCATION"
			},
			{
				"name": "Standing Rock Reservation",
				"salience": 0.062824205,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T16:50:46.736+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Leshu Torchin, University of St Andrews On Oct. 31, more than a million Facebook users “checked in” at Standing Rock Reservation, on the border... ",
		"thread_title": "What Can The Mass “Check-in” At Standing Rock Tell Us About Online Advocacy?",
		"title": "What Can The Mass “Check-in” At Standing Rock Tell Us About Online Advocacy?",
		"type": "conspiracy",
		"uuid": "65fe15aaf6aec33c37c37678b8550a58be618ea2"
	},
	"-KhIb1pdcQq1W18AT1sZ": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T17:30:36.699+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "continuation",
				"salience": 0.39280927,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.26070356,
				"type": "OTHER"
			},
			{
				"name": "Catherine J. Frompovich This",
				"salience": 0.2394764,
				"type": "PERSON"
			},
			{
				"name": "Pennsylvania Public Utility Commission's Administrative Law Court",
				"salience": 0.107010745,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T17:30:36.699+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.5
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Catherine J. Frompovich This is the continuation of the testimony I will present before the Pennsylvania Public Utility Commission’s Administrative Law Court November 2... ",
		"thread_title": "Smart Meter Case Testimony Before the Pennsylvania Public Utility Commission: What No One Wants to Acknowledge About EMF Damage (Part 4 of 4)",
		"title": "Smart Meter Case Testimony Before the Pennsylvania Public Utility Commission: What No One Wants to Acknowledge About EMF Damage (Part 4 of 4)",
		"type": "conspiracy",
		"uuid": "4f34dd134c678cd33a0906d509b407e4cf6ef9d9"
	},
	"-KhIb2AucAs8hwmtvZ6l": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T18:11:59.518+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.26273027,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.1955841,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.051510464,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al Qaeda",
				"salience": 0.049101565,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.03798413,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.03037404,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pat Milton",
				"salience": 0.02452062,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS News",
				"salience": 0.020161724,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist attack",
				"salience": 0.019424334,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.016230274,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.0127132265,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.01101841,
				"type": "PERSON"
			},
			{
				"name": "suspension",
				"salience": 0.01101841,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.01101841,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.010324615,
				"type": "PERSON"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.009969009,
				"type": "EVENT"
			},
			{
				"name": "sources",
				"salience": 0.009393664,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.008788514,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.008399497,
				"type": "LOCATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.007988539,
				"type": "ORGANIZATION"
			},
			{
				"name": "credence",
				"salience": 0.00711504,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.006825395,
				"type": "EVENT"
			},
			{
				"name": "Whitney Webb",
				"salience": 0.00679653,
				"type": "PERSON"
			},
			{
				"name": "theories",
				"salience": 0.0063500367,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.004115264,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.0039644237,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0039644237,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.00380232,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00380232,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0037325327,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0034336539,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02hx8_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Intelligence_Community"
				},
				"name": "US intelligence community",
				"salience": 0.0033371628,
				"type": "ORGANIZATION"
			},
			{
				"name": "authorities",
				"salience": 0.0030479901,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0029086075,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0027809546,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.0027791972,
				"type": "EVENT"
			},
			{
				"name": "attackers",
				"salience": 0.0027791972,
				"type": "PERSON"
			},
			{
				"name": "counter-terrorism officials",
				"salience": 0.0026853678,
				"type": "PERSON"
			},
			{
				"name": "terror threat",
				"salience": 0.0026671698,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0026671698,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0025677069,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0025526828,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0025437837,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0025437837,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0023552713,
				"type": "OTHER"
			},
			{
				"name": "terrorism task forces",
				"salience": 0.002325618,
				"type": "ORGANIZATION"
			},
			{
				"name": "locations",
				"salience": 0.002325618,
				"type": "LOCATION"
			},
			{
				"name": "terror attack",
				"salience": 0.0022982077,
				"type": "EVENT"
			},
			{
				"name": "counterparts",
				"salience": 0.002085725,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.0020770014,
				"type": "OTHER"
			},
			{
				"name": "homeland security communities",
				"salience": 0.0020079208,
				"type": "OTHER"
			},
			{
				"name": "counter-terrorism",
				"salience": 0.0020079208,
				"type": "OTHER"
			},
			{
				"name": "State",
				"salience": 0.0019258278,
				"type": "LOCATION"
			},
			{
				"name": "official",
				"salience": 0.0018130587,
				"type": "PERSON"
			},
			{
				"name": "terrorist attack",
				"salience": 0.0017836851,
				"type": "EVENT"
			},
			{
				"name": "terrorist attack",
				"salience": 0.0016741552,
				"type": "EVENT"
			},
			{
				"name": "shares",
				"salience": 0.0016309195,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0016309195,
				"type": "OTHER"
			},
			{
				"name": "community partners",
				"salience": 0.0016309195,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.0016309195,
				"type": "EVENT"
			},
			{
				"name": "safety",
				"salience": 0.0016309195,
				"type": "OTHER"
			},
			{
				"name": "abundance",
				"salience": 0.0015700659,
				"type": "OTHER"
			},
			{
				"name": "lone wolf",
				"salience": 0.0015700659,
				"type": "OTHER"
			},
			{
				"name": "caution",
				"salience": 0.0015700659,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.0015700659,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0015700659,
				"type": "PERSON"
			},
			{
				"name": "ideologies",
				"salience": 0.0015700659,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0015700659,
				"type": "PERSON"
			},
			{
				"name": "extremist activity",
				"salience": 0.0015700659,
				"type": "OTHER"
			},
			{
				"name": "scenarios",
				"salience": 0.0015700659,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.0015700659,
				"type": "LOCATION"
			},
			{
				"name": "justification",
				"salience": 0.0015376278,
				"type": "OTHER"
			},
			{
				"name": "product",
				"salience": 0.0015376278,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0014318225,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0014318225,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.0014318225,
				"type": "LOCATION"
			},
			{
				"name": "announcement",
				"salience": 0.0013315214,
				"type": "EVENT"
			},
			{
				"name": "rebels",
				"salience": 0.0013315214,
				"type": "OTHER"
			},
			{
				"name": "inception",
				"salience": 0.0013315214,
				"type": "EVENT"
			},
			{
				"name": "ability",
				"salience": 0.0013315214,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0012339937,
				"type": "OTHER"
			},
			{
				"name": "revelations",
				"salience": 0.0011653781,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0011487349,
				"type": "WORK_OF_ART"
			},
			{
				"name": "threat",
				"salience": 0.0011409435,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.0010781714,
				"type": "OTHER"
			},
			{
				"name": "branch",
				"salience": 0.0010733563,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0010701105,
				"type": "EVENT"
			},
			{
				"name": "ground",
				"salience": 0.0009947274,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.0009947274,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0009947274,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.0009947274,
				"type": "OTHER"
			},
			{
				"name": "mutiny",
				"salience": 0.0009947274,
				"type": "OTHER"
			},
			{
				"name": "campaign chair",
				"salience": 0.0009947274,
				"type": "PERSON"
			},
			{
				"name": "releases",
				"salience": 0.0009947274,
				"type": "OTHER"
			},
			{
				"name": "siege",
				"salience": 0.0009947274,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0009310867,
				"type": "ORGANIZATION"
			},
			{
				"name": "news",
				"salience": 0.00092663843,
				"type": "OTHER"
			},
			{
				"name": "State",
				"salience": 0.0009231909,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.00088537997,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviets",
				"salience": 0.0008622528,
				"type": "LOCATION"
			},
			{
				"name": "opportunity",
				"salience": 0.0008543193,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.00083666184,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.00081960694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al Nusra Front",
				"salience": 0.00081960694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0008104289,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.00080543046,
				"type": "OTHER"
			},
			{
				"name": "warnings",
				"salience": 0.0008018328,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.0007994078,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.00072447595,
				"type": "OTHER"
			},
			{
				"name": "meantime",
				"salience": 0.00072447595,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00072447595,
				"type": "OTHER"
			},
			{
				"name": "circumstances",
				"salience": 0.00072447595,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.00072447595,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00072447595,
				"type": "WORK_OF_ART"
			},
			{
				"name": "soil",
				"salience": 0.00072447595,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00072447595,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.0007185561,
				"type": "OTHER"
			},
			{
				"name": "justification",
				"salience": 0.00066590833,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0006249931,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0006122515,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00060730195,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0005480882,
				"type": "OTHER"
			},
			{
				"name": "liberties",
				"salience": 0.0005411807,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.0005411807,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0005411807,
				"type": "OTHER"
			},
			{
				"name": "elimination",
				"salience": 0.0005411807,
				"type": "OTHER"
			},
			{
				"name": "entities",
				"salience": 0.0005411807,
				"type": "OTHER"
			},
			{
				"name": "bogeyman",
				"salience": 0.0005411807,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0005411807,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0004458866,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/11/freda-false-flag-1024x543-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T18:11:59.518+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Whitney Webb \nOver the course of this year’s US presidential election, which has been nothing if not bizarre, some have repeatedly speculated that the election may not actually happen at all if an opportunely timed terrorist attack or other major event occurred at just the right moment, leading to a suspension of the November election. Now, these theories appear to have more credence as sources within US intelligence have contacted Pat Milton, a CBS News senior investigative producer, warning him that terrorist attacks in three US states are highly likely come this Monday, the day before the US election. US Intelligence has allegedly alerted joint terrorism task forces that al Qaeda, not ISIS, could be planning attacks in New York, Texas, and Virginia. No specific locations within those three states were mentioned. \nUS authorities are said to be taking the threat seriously, though CBS News ’ sources stress that the threat is still being assessed and its credibility has yet to be confirmed. According to CBS , counter-terrorism officials were alerted to the threat out of an “abundance of caution.” \nEarlier this week, there were also warnings that “polling places” could be seen as “attractive targets” for “lone wolf” attackers by individuals motivated by “violent extremist ideologies, sovereign citizen or other extremist activity.” This has led federal law enforcement to plan for several worst-case scenarios. One FBI official told CBS : \nThe counter-terrorism and homeland security communities remain vigilant and well-postured to defend against attacks here in the United States. The FBI, working with our federal, state and local counterparts, shares and assesses intelligence on a daily basis and will continue to work closely with law enforcement and intelligence community partners to identify and disrupt any potential threat to public safety. \nHowever, what’s interesting here is that the terror threat is coming from al Qaeda as opposed to the Islamic State. In the Syrian “civil” war, the US has been actively helping al Qaeda there, grouping their Syrian branch – the al Nusra Front – in with the “moderate rebels” they support. Therefore, al Qaeda’s ability to launch attacks within the US has been directly aided by US intelligence, making this announcement incredibly suspect. \nIt’s also worth pointing out that al Qaeda, since its inception, has been a product of the US intelligence community. In the 1980s they were essentially created by the US to fight the Soviets in Afghanistan. Ever since, they have conveniently been used as the justification for an expansion of US wars abroad and the elimination of civil liberties domestically. \nIt is also interesting that the threat is al Qaeda and NOT the Islamic State. The Islamic State has been the terrorist “bogeyman” of recent years and their involvement in any threat, real or imagined, is useful justification for escalating US involvement in Syria. It seems highly likely that the Islamic State was left out due to recent revelations from WikiLeaks showing that their funding comes from the very same entities that donate millions to the Clinton Foundation. \nIt is also worth noting that if a terrorist attack does come to pass, it will be a big help for Hillary. Hillary has been under siege in recent weeks due to WikiLeaks’ near constant releases of her campaign chair’s emails, but also due to the FBI’s “mutiny” which led them to re-open a probe into Clinton’s use of a private email server. Any terror attack would give Clinton the opportunity to gain political ground by promoting her aggressive foreign policy aims in Syria and the rest of the Middle East. \nHowever, as mentioned at the beginning of this article, it is also possible that a terrorist attack on US soil would give President Obama the authority to either postpone or outright cancel the election, something he could not normally do except in the event of extraordinary circumstances. Unfortunately, only time will tell which theory is correct, compelling us to stay vigilant in the meantime. \nWhat are your thoughts? Please comment below and share this news!",
		"thread_title": "False Flag? US Intelligence Warns Of Likely Al Qaeda Terror Attack Day Before Election",
		"title": "False Flag? US Intelligence Warns Of Likely Al Qaeda Terror Attack Day Before Election",
		"type": "conspiracy",
		"uuid": "4729f48f5301dd29fa27cfc59c3c50f8b298d848"
	},
	"-KhIb2VpJ_TsR1mS1Ca1": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T19:08:49.013+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "State of California",
				"salience": 0.4190888,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States of America",
				"salience": 0.15029053,
				"type": "LOCATION"
			},
			{
				"name": "Joseph Jankowski",
				"salience": 0.056473263,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.034734223,
				"type": "ORGANIZATION"
			},
			{
				"name": "Yes California Independence Campaign",
				"salience": 0.03069323,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.023284463,
				"type": "LOCATION"
			},
			{
				"name": "meeting",
				"salience": 0.0134806745,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07bcn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sacramento,_California"
				},
				"name": "Sacramento",
				"salience": 0.012623442,
				"type": "LOCATION"
			},
			{
				"name": "state capitol",
				"salience": 0.011735498,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.011735498,
				"type": "EVENT"
			},
			{
				"name": "aim",
				"salience": 0.009470012,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trade_union"
				},
				"name": "Union",
				"salience": 0.007238661,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0070364666,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.006936275,
				"type": "EVENT"
			},
			{
				"name": "means",
				"salience": 0.006008746,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0049379272,
				"type": "LOCATION"
			},
			{
				"name": "statehood",
				"salience": 0.0048145205,
				"type": "OTHER"
			},
			{
				"name": "State",
				"salience": 0.0045472723,
				"type": "LOCATION"
			},
			{
				"name": "self-determination",
				"salience": 0.003737767,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/071vr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Diego"
				},
				"name": "San Diego",
				"salience": 0.0037020342,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.003464207,
				"type": "LOCATION"
			},
			{
				"name": "referendum",
				"salience": 0.0034608147,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0033350599,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.003180262,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.0031672046,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0030616834,
				"type": "LOCATION"
			},
			{
				"name": "independence referendum",
				"salience": 0.0028619803,
				"type": "OTHER"
			},
			{
				"name": "secession",
				"salience": 0.0028599834,
				"type": "OTHER"
			},
			{
				"name": "exit",
				"salience": 0.0028599834,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0028287242,
				"type": "LOCATION"
			},
			{
				"name": "Calexit",
				"salience": 0.0028037617,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.002596796,
				"type": "LOCATION"
			},
			{
				"name": "income inequality",
				"salience": 0.0025084172,
				"type": "OTHER"
			},
			{
				"name": "charity",
				"salience": 0.0024879386,
				"type": "ORGANIZATION"
			},
			{
				"name": "values",
				"salience": 0.0024768352,
				"type": "OTHER"
			},
			{
				"name": "initiative",
				"salience": 0.0024768352,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0024768352,
				"type": "PERSON"
			},
			{
				"name": "ballot",
				"salience": 0.0024768352,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.0024768352,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0024768352,
				"type": "OTHER"
			},
			{
				"name": "Brexit",
				"salience": 0.0022892912,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Yes California",
				"salience": 0.0022886875,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.0021384764,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.002113618,
				"type": "LOCATION"
			},
			{
				"name": "schools",
				"salience": 0.0020742002,
				"type": "ORGANIZATION"
			},
			{
				"name": "both",
				"salience": 0.0020222869,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.002005773,
				"type": "LOCATION"
			},
			{
				"name": "right",
				"salience": 0.002005773,
				"type": "OTHER"
			},
			{
				"name": "charity",
				"salience": 0.002005773,
				"type": "OTHER"
			},
			{
				"name": "counties",
				"salience": 0.0019402622,
				"type": "LOCATION"
			},
			{
				"name": "counties",
				"salience": 0.0019402622,
				"type": "LOCATION"
			},
			{
				"name": "detriment",
				"salience": 0.0019309418,
				"type": "OTHER"
			},
			{
				"name": "detriment",
				"salience": 0.0019309418,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0019309418,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0019309418,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k3d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jefferson_(proposed_Pacific_state)"
				},
				"name": "Gilbert Gable",
				"salience": 0.001919856,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.0018981114,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0018272932,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0017815537,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.0017369582,
				"type": "OTHER"
			},
			{
				"name": "association",
				"salience": 0.0017369582,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0017369582,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0017369582,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0017150803,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0016721473,
				"type": "PERSON"
			},
			{
				"name": "infrastructure",
				"salience": 0.0016721473,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0016721473,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.0016721473,
				"type": "OTHER"
			},
			{
				"name": "persons",
				"salience": 0.0016721473,
				"type": "PERSON"
			},
			{
				"name": "shelter",
				"salience": 0.0016721473,
				"type": "OTHER"
			},
			{
				"name": "necessities",
				"salience": 0.0016721473,
				"type": "OTHER"
			},
			{
				"name": "poverty rates",
				"salience": 0.0016721473,
				"type": "OTHER"
			},
			{
				"name": "exit",
				"salience": 0.0016375998,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0016375998,
				"type": "LOCATION"
			},
			{
				"name": "nations",
				"salience": 0.0016375998,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0016375998,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "Californian",
				"salience": 0.0015249145,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01v9vx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco_Chronicle"
				},
				"name": "SF Gate",
				"salience": 0.0015249145,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012x2r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northern_California"
				},
				"name": "Northern California",
				"salience": 0.0014501815,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0014501815,
				"type": "LOCATION"
			},
			{
				"name": "truths",
				"salience": 0.0014180912,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.0014180912,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0014180912,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0014180912,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0014180912,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0014180912,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0014180912,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0012879637,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0012411447,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.0012234193,
				"type": "OTHER"
			},
			{
				"name": "push",
				"salience": 0.0012234193,
				"type": "EVENT"
			},
			{
				"name": "topics",
				"salience": 0.0011874592,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0010558168,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0l2kp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Modoc_County,_California"
				},
				"name": "Modoc County",
				"salience": 0.0009916195,
				"type": "LOCATION"
			},
			{
				"name": "newsletter",
				"salience": 0.0009868819,
				"type": "WORK_OF_ART"
			},
			{
				"name": "subscription",
				"salience": 0.0009868819,
				"type": "OTHER"
			},
			{
				"name": "counties",
				"salience": 0.00091835676,
				"type": "LOCATION"
			},
			{
				"name": "works",
				"salience": 0.0008648599,
				"type": "WORK_OF_ART"
			},
			{
				"name": "push",
				"salience": 0.00085779326,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0mx6r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Josephine_County,_Oregon"
				},
				"name": "Josephine",
				"salience": 0.0008340237,
				"type": "PERSON"
			},
			{
				"name": "Activist Post Daily Newsletter Subscription",
				"salience": 0.0007827819,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.00077874097,
				"type": "ORGANIZATION"
			},
			{
				"name": "Collapse",
				"salience": 0.0007715753,
				"type": "EVENT"
			},
			{
				"name": "alternative news sites",
				"salience": 0.0007715753,
				"type": "OTHER"
			},
			{
				"name": "Photo Credit",
				"salience": 0.0007715753,
				"type": "OTHER"
			},
			{
				"name": "Report",
				"salience": 0.0007715753,
				"type": "OTHER"
			},
			{
				"name": "CONFIDENTIAL",
				"salience": 0.0007715753,
				"type": "OTHER"
			},
			{
				"name": "Ways",
				"salience": 0.0007715753,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kq20",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Del_Norte_County,_California"
				},
				"name": "Del Norte",
				"salience": 0.0007530337,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.00074277166,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0l339",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Siskiyou_County,_California"
				},
				"name": "Siskiyou County",
				"salience": 0.00074075663,
				"type": "LOCATION"
			},
			{
				"name": "referendum",
				"salience": 0.00073721714,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0006656245,
				"type": "OTHER"
			},
			{
				"name": "blog post",
				"salience": 0.0006656245,
				"type": "WORK_OF_ART"
			},
			{
				"name": "secession",
				"salience": 0.0006656245,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mx6c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Klamath_County,_Oregon"
				},
				"name": "Klamath",
				"salience": 0.00065205456,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0mx7f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jackson_County,_Oregon"
				},
				"name": "Jackson",
				"salience": 0.00065205456,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.0005987157,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.0005763631,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.0005763631,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0005763631,
				"type": "OTHER"
			},
			{
				"name": "Will.com",
				"salience": 0.0005484218,
				"type": "OTHER"
			},
			{
				"name": "ActivistPost.com",
				"salience": 0.0005484218,
				"type": "OTHER"
			},
			{
				"name": "California State Flag",
				"salience": 0.0005484218,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05gv9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_flag"
				},
				"name": "National Flag",
				"salience": 0.0005484218,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0005484218,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Planet"
				},
				"name": "Planet",
				"salience": 0.0005484218,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.00053947966,
				"type": "LOCATION"
			},
			{
				"name": "parallels",
				"salience": 0.0005077072,
				"type": "OTHER"
			},
			{
				"name": "The Information Leak",
				"salience": 0.00047487358,
				"type": "EVENT"
			},
			{
				"name": "@ twitter.com/PlanetFreeWill Subscribe",
				"salience": 0.00047487358,
				"type": "PERSON"
			},
			{
				"name": "ZeroHedge.com",
				"salience": 0.00047487358,
				"type": "OTHER"
			},
			{
				"name": "Mintpressnews.com",
				"salience": 0.00047487358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03674n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/City_Hall_(IRT_Lexington_Avenue_Line)"
				},
				"name": "City Hall",
				"salience": 0.00047487358,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06_kh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Santa_Monica,_California"
				},
				"name": "Santa Monica",
				"salience": 0.00047487358,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04dtx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flickr"
				},
				"name": "Flickr",
				"salience": 0.00047487358,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ed Uthman",
				"salience": 0.00047487358,
				"type": "PERSON"
			},
			{
				"name": "GlobalResearch.ca",
				"salience": 0.00047487358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00046713036,
				"type": "LOCATION"
			},
			{
				"name": "mayor",
				"salience": 0.00040923076,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0mxf9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Curry_County,_Oregon"
				},
				"name": "Curry",
				"salience": 0.00035471443,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0zch5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Port_Orford,_Oregon"
				},
				"name": "Port Orford",
				"salience": 0.00035471443,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/11/california-secession.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-05T18:01:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0.029",
		"text": "\nBy Joseph Jankowski \nAn organization which has the aim to separate the state of California from the Union of the United States is set to hold a meeting at the state capitol in Sacramento on Wednesday, November 9, 2016, the day after the presidential election. \nThe Yes California Independence Campaign , which is based in San Diego, describes itself as a “nonviolent campaign to establish the country of California using any and all legal and constitutional means to do so.” \nThe group is currently trying to qualify a citizen’s initiative in 2018 to get a referendum for secession on the ballot in 2019, reports SF Gate . They will be in Sacramento in hopes to gather support for the state’s exit, or the “Calexit,” as they call it. \n“In our view, the United States of America represents so many things that conflict with Californian values, and our continued statehood means California will continue subsidizing the other states to our own detriment, and to the detriment of our children,” reads Yes California ’s official website. \nThe group’s page reads on: \nAlthough charity is part of our culture, when you consider that California’s infrastructure is falling apart, our public schools are ranked among the worst in the entire country, we have the highest number of homeless persons living without shelter and other basic necessities, poverty rates remain high, income inequality continues to expand, and we must often borrow money from the future to provide services for today, now is not the time for charity. However, this independence referendum is about more than California subsidizing other states of this country. It is about the right to self-determination and the concept of voluntary association, both of which are supported by constitutional and international law.\nIt is about California taking its place in the world, standing as an equal among nations. We believe in two fundamental truths: (1) California exerts a positive influence on the rest of the world, and (2) California could do more good as an independent country than it is able to do as a just a U.S. state. \nYes California ’s website lays out 9 different points covering topics the group believes will benefit from a California exit from the US, including education, peace and security, debt and taxes and immigration. \nOne blog post on their page draws parallels with a “Calexit” and the recent referendum known as “Brexit” that passed in the UK in June which showed that most British people are ready for their country to leave the EU. \nThe push for secession is nothing new to California. In 1941 the mayor of Port Orford, Oregon, Gilbert Gable, proposed the idea to push the Oregon counties of Curry, Josephine, Jackson, and Klamath to join with the California counties of Del Norte, Siskiyou, and Modoc to form a new state, later named Jefferson. \nModoc County of Northern California voted in 2013 to join neighboring Siskiyou County in a push to secede from the State of California . \nIn 2014, two counties in northern California petitioned for the right to form a 51st State of America, which they also wanted to name Jefferson. \nJoseph Jankowski is a contributor for Planet Free Will.com . His works have been published by recognizable alternative news sites like GlobalResearch.ca, ActivistPost.com, Mintpressnews.com and ZeroHedge.com. \nFollow Planet Free Will on Twitter @ twitter.com/PlanetFreeWill \nSubscribe to our newsletter – The Information Leak \nPhoto Credit: US National Flag and California State Flag, City Hall, Santa Monica (Ed Uthman/ Flickr ) Activist Post Daily Newsletter Subscription is FREE and CONFIDENTIAL Free Report: 10 Ways to Survive the Economic Collapse with subscription ",
		"thread_title": "California Secessionists to Meet at Capitol Day After Presidential Election",
		"title": "California Secessionists to Meet at Capitol Day After Presidential Election",
		"type": "conspiracy",
		"uuid": "2ca77a341a3e26e3f842f2804aef1ecf62ba90f6"
	},
	"-KhIb2cWTeLVY9Y9Ieaq": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T15:00:37.543+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Amanda Froelich",
				"salience": 0.34011754,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.23878989,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.16661341,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.16340622,
				"type": "PERSON"
			},
			{
				"name": "bed",
				"salience": 0.05943582,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.03163711,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T15:00:37.543+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Amanda Froelich By 2050, the world’s population is estimated to reach 9.7 billion people. Already, 795 million people go to bed hungry each evening.... ",
		"thread_title": "Tree-Shaped Vertical Farm Can Grow 24 Acres Of Crops",
		"title": "Tree-Shaped Vertical Farm Can Grow 24 Acres Of Crops",
		"type": "conspiracy",
		"uuid": "790dc20b22d056c6599d5855d37d7f06622a9700"
	},
	"-KhIb2gPTOQvqkGq9gCx": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T15:15:19.742+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Austyn Crites",
				"salience": 0.5215816,
				"type": "PERSON"
			},
			{
				"name": "Daisy Luther",
				"salience": 0.3783379,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.10008052,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T15:15:19.742+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Daisy Luther UPDATED: Although it doesn’t appear that Austyn Crites was trying to assassinate Donald Trump, it’s very interesting that he does appear in... ",
		"thread_title": "No One Tried to Assassinate Donald Trump … But Austyn Crites Shows Up in WikiLeaks 7 Times",
		"title": "No One Tried to Assassinate Donald Trump … But Austyn Crites Shows Up in WikiLeaks 7 Times",
		"type": "conspiracy",
		"uuid": "d9b870559567f88c3adb074139df79177465237e"
	},
	"-KhIb2kIRwaUVc4X1xRB": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T17:20:52.990+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Kash Jackson",
				"salience": 0.4343173,
				"type": "PERSON"
			},
			{
				"name": "Claire Bernish",
				"salience": 0.22785223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "U.S. Navy",
				"salience": 0.10038212,
				"type": "ORGANIZATION"
			},
			{
				"name": "mind",
				"salience": 0.07079072,
				"type": "OTHER"
			},
			{
				"name": "Petty Officer 1st Class",
				"salience": 0.068848364,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.05868293,
				"type": "LOCATION"
			},
			{
				"name": "imperative",
				"salience": 0.039126337,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T17:20:52.990+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Claire Bernish U.S. Navy veteran, Petty Officer 1st Class Kash Jackson, came to North Dakota with one imperative in mind — to uphold the... ",
		"thread_title": "Navy Petty Officer Joins DAPL Protest With Upside Down Flag – “Our Greatest Enemies Are Right Here”",
		"title": "Navy Petty Officer Joins DAPL Protest With Upside Down Flag – “Our Greatest Enemies Are Right Here”",
		"type": "conspiracy",
		"uuid": "d655b4f5840049a825a19860292c7c71883ede00"
	},
	"-KhIb31_0Y-5YHoyzyiw": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T17:57:39.233+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.45524862,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kumiki Gibson",
				"salience": 0.13050583,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.05540369,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0902k5"
				},
				"name": "Jon Rappoport",
				"salience": 0.048277542,
				"type": "PERSON"
			},
			{
				"name": "Bruce Lindsay",
				"salience": 0.029806372,
				"type": "PERSON"
			},
			{
				"name": "memo",
				"salience": 0.01391841,
				"type": "WORK_OF_ART"
			},
			{
				"name": "status",
				"salience": 0.00854759,
				"type": "OTHER"
			},
			{
				"name": "compliance",
				"salience": 0.007899415,
				"type": "OTHER"
			},
			{
				"name": "Foundation's practices",
				"salience": 0.007135442,
				"type": "ORGANIZATION"
			},
			{
				"name": "laws",
				"salience": 0.007135442,
				"type": "OTHER"
			},
			{
				"name": "non-profits",
				"salience": 0.007135442,
				"type": "ORGANIZATION"
			},
			{
				"name": "laws",
				"salience": 0.007135442,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.006948146,
				"type": "PERSON"
			},
			{
				"name": "responsibilities",
				"salience": 0.0065024854,
				"type": "OTHER"
			},
			{
				"name": "MATRIX",
				"salience": 0.006406438,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.0061949715,
				"type": "PERSON"
			},
			{
				"name": "assessment",
				"salience": 0.0061819763,
				"type": "OTHER"
			},
			{
				"name": "non-profit entity",
				"salience": 0.0061819763,
				"type": "ORGANIZATION"
			},
			{
				"name": "existence",
				"salience": 0.0061819763,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0061819763,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.0061819763,
				"type": "OTHER"
			},
			{
				"name": "quotes",
				"salience": 0.0061819763,
				"type": "OTHER"
			},
			{
				"name": "Foundation",
				"salience": 0.005442516,
				"type": "ORGANIZATION"
			},
			{
				"name": "CFO",
				"salience": 0.005344704,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f94t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harlem"
				},
				"name": "Harlem",
				"salience": 0.0044593955,
				"type": "LOCATION"
			},
			{
				"name": "Foundation",
				"salience": 0.0044454285,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.00438954,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0042754575,
				"type": "OTHER"
			},
			{
				"name": "foundation executive",
				"salience": 0.003846586,
				"type": "PERSON"
			},
			{
				"name": "foundation",
				"salience": 0.0038191432,
				"type": "OTHER"
			},
			{
				"name": "compliance",
				"salience": 0.0032596383,
				"type": "OTHER"
			},
			{
				"name": "filings",
				"salience": 0.002943561,
				"type": "EVENT"
			},
			{
				"name": "department",
				"salience": 0.002943561,
				"type": "ORGANIZATION"
			},
			{
				"name": "Power Outside The Matrix",
				"salience": 0.002721853,
				"type": "OTHER"
			},
			{
				"name": "consulting practice",
				"salience": 0.0027105277,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0025493344,
				"type": "ORGANIZATION"
			},
			{
				"name": "drain",
				"salience": 0.0025493344,
				"type": "OTHER"
			},
			{
				"name": "filings rules",
				"salience": 0.0025493344,
				"type": "OTHER"
			},
			{
				"name": "oversight",
				"salience": 0.0025493344,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0025493344,
				"type": "OTHER"
			},
			{
				"name": "record retention policy",
				"salience": 0.0024984442,
				"type": "OTHER"
			},
			{
				"name": "Foundation",
				"salience": 0.0023905078,
				"type": "ORGANIZATION"
			},
			{
				"name": "State",
				"salience": 0.002382475,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.0022460055,
				"type": "OTHER"
			},
			{
				"name": "HR offices",
				"salience": 0.002227671,
				"type": "ORGANIZATION"
			},
			{
				"name": "compliance",
				"salience": 0.0022011618,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.0021350184,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0020646018,
				"type": "OTHER"
			},
			{
				"name": "MATRIX",
				"salience": 0.002046452,
				"type": "ORGANIZATION"
			},
			{
				"name": "tax exempt status",
				"salience": 0.0020206852,
				"type": "OTHER"
			},
			{
				"name": "non-profit",
				"salience": 0.0019875942,
				"type": "ORGANIZATION"
			},
			{
				"name": "lapses",
				"salience": 0.0018107635,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01chbr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gibson_Guitar_Corporation"
				},
				"name": "Gibson",
				"salience": 0.0018003567,
				"type": "ORGANIZATION"
			},
			{
				"name": "memo",
				"salience": 0.0017959779,
				"type": "WORK_OF_ART"
			},
			{
				"name": "procedures",
				"salience": 0.0017879612,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0017879612,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0017723243,
				"type": "LOCATION"
			},
			{
				"name": "profits",
				"salience": 0.0017212608,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.0017212608,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0017212608,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0017212608,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0017212608,
				"type": "OTHER"
			},
			{
				"name": "department",
				"salience": 0.0016857057,
				"type": "ORGANIZATION"
			},
			{
				"name": "POWER",
				"salience": 0.001509771,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.001509771,
				"type": "OTHER"
			},
			{
				"name": "regard",
				"salience": 0.0014597878,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0014597878,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0014597878,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0014597878,
				"type": "OTHER"
			},
			{
				"name": "pre-approval",
				"salience": 0.0014597878,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0014597878,
				"type": "EVENT"
			},
			{
				"name": "purpose",
				"salience": 0.0014053193,
				"type": "OTHER"
			},
			{
				"name": "Foundation",
				"salience": 0.0012685361,
				"type": "ORGANIZATION"
			},
			{
				"name": "leadership",
				"salience": 0.0012380038,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.001161966,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0010997055,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.0010905953,
				"type": "OTHER"
			},
			{
				"name": "EXIT",
				"salience": 0.0010905953,
				"type": "LOCATION"
			},
			{
				"name": "collections",
				"salience": 0.0010905953,
				"type": "WORK_OF_ART"
			},
			{
				"name": "clients",
				"salience": 0.0010905953,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0010299527,
				"type": "OTHER"
			},
			{
				"name": "writing articles",
				"salience": 0.0010159527,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0010159527,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0010159527,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0010159527,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0010159527,
				"type": "OTHER"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.0009574317,
				"type": "PERSON"
			},
			{
				"name": "magazines",
				"salience": 0.00091731385,
				"type": "WORK_OF_ART"
			},
			{
				"name": "newspapers",
				"salience": 0.0007943245,
				"type": "ORGANIZATION"
			},
			{
				"name": "lectures",
				"salience": 0.0007943245,
				"type": "OTHER"
			},
			{
				"name": "seminars",
				"salience": 0.0007943245,
				"type": "EVENT"
			},
			{
				"name": "medicine",
				"salience": 0.0007943245,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.0007943245,
				"type": "OTHER"
			},
			{
				"name": "audiences",
				"salience": 0.0007943245,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0007943245,
				"type": "LOCATION"
			},
			{
				"name": "emails",
				"salience": 0.0007943245,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reporter",
				"salience": 0.0007943245,
				"type": "PERSON"
			},
			{
				"name": "Dept.",
				"salience": 0.0006852587,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0006852587,
				"type": "PERSON"
			},
			{
				"name": "District of California",
				"salience": 0.0006712895,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congressional",
				"salience": 0.0006712895,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/061jp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pulitzer_Prize"
				},
				"name": "Pulitzer Prize",
				"salience": 0.0006712895,
				"type": "OTHER"
			},
			{
				"name": "CBS Healthwatch",
				"salience": 0.0006253339,
				"type": "ORGANIZATION"
			},
			{
				"name": "corruption",
				"salience": 0.0005933707,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0005933707,
				"type": "EVENT"
			},
			{
				"name": "particulars",
				"salience": 0.0005933707,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0005933707,
				"type": "OTHER"
			},
			{
				"name": "wildfire",
				"salience": 0.0005933707,
				"type": "OTHER"
			},
			{
				"name": "fires",
				"salience": 0.0005933707,
				"type": "EVENT"
			},
			{
				"name": "Dept. of Justice",
				"salience": 0.0005865023,
				"type": "ORGANIZATION"
			},
			{
				"name": "Clintons",
				"salience": 0.0005698174,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02wmv9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spin_(magazine)"
				},
				"name": "Spin Magazine",
				"salience": 0.00056460686,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York State",
				"salience": 0.0005056426,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00048889243,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0423bn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stern_(magazine)"
				},
				"name": "Stern",
				"salience": 0.00048889243,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04bbtx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LA_Weekly"
				},
				"name": "LA Weekly",
				"salience": 0.00048889243,
				"type": "ORGANIZATION"
			},
			{
				"name": "NoMoreFakeNews.com",
				"salience": 0.00048889243,
				"type": "OTHER"
			},
			{
				"name": "OutsideTheRealityMachine",
				"salience": 0.00048889243,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c5lg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Judge"
				},
				"name": "Justice",
				"salience": 0.00042175333,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.activistpost.com/wp-content/uploads/2016/11/hillary-clinton-foundation-money-cash-1024x435.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T17:57:39.233+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jon Rappoport \nBreaking: leaked 2008 memo from attorney Kumiki Gibson to Clinton Foundation chairman Bruce Lindsay. Gibson had been hired to do an independent assessment of the Foundation’s practices. \nBelow are key quotes from Gibson’s findings. Keep in mind that the Clinton Foundation’s very existence depends on it being legally certified as a non-profit entity, in compliance with laws governing non-profits. Break those laws and its non-profit status would be revoked, and the whole operation would go down the drain. \nGibson: “Important responsibilities regarding corporate filings are delegated to the [Foundation] CFO, who appears to delegate them to an outside organization, with very little oversight by the legal department. As a result, the Foundation is not in compliance with the filings rules, including in New York, which requires the Foundation to be certified to do business in the State.” [Apparently, the Clinton Foundation was not legally registered as a non-profit in New York.] \nGibson: “No matter what the leadership decides about the larger, over-arching question, it must act immediately to bring the Foundation into compliance with the law and standards that govern not-for-profits, and must create strong legal and HR offices so to prevent any lapses in the future.” \nGibson: “The Foundation does not have a record retention policy[!], and the procedures currently utilized in Harlem [headquarters] may violate the law.” \nZero Hedge writes: “Furthermore, and more troubling, the [Gibson] review pointed to a high-ranking but unnamed foundation executive who was ‘being paid by [President Clinton], the government and the foundation’ who ‘allowed the foundation to host what may have been (or may have been viewed as) a political event, apparently without official pre-approval from the foundation’s legal department and without regard, before the fact, to the impact of that decision on the foundation’s tax exempt status.’” \nThis memo was written in 2008. It would have taken then, and it would now take, about a month of investigation by New York State and US Dept. of Justice officials to nail down the particulars and sink the Clinton Foundation. \nThat didn’t happen then. Will it happen now? Not if the Dept. of Justice has anything to say about it. The Clintons are protected. \nBut evidence of the Foundation corruption is spreading like wildfire. Some fires are impossible to contain. \n(To read about Jon’s mega-collection, Power Outside The Matrix , click here .) \nThe author of three explosive collections, THE MATRIX REVEALED , EXIT FROM THE MATRIX , and POWER OUTSIDE THE MATRIX , Jon was a candidate for a US Congressional seat in the 29 th District of California. He maintains a consulting practice for private clients, the purpose of which is the expansion of personal creative power. Nominated for a Pulitzer Prize, he has worked as an investigative reporter for 30 years, writing articles on politics, medicine, and health for CBS Healthwatch, LA Weekly, Spin Magazine, Stern, and other newspapers and magazines in the US and Europe. Jon has delivered lectures and seminars on global politics, health, logic, and creative power to audiences around the world. You can sign up for his free emails at NoMoreFakeNews.com or OutsideTheRealityMachine .",
		"thread_title": "Leaked Memo: Clinton Foundation Broke The Law",
		"title": "Leaked Memo: Clinton Foundation Broke The Law",
		"type": "conspiracy",
		"uuid": "cd54e63fd137f22219c6c4beba24de524fc6d56c"
	},
	"-KhIb361HJUk0nNTpIyr": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T19:30:31.360+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "corporatocracy",
				"salience": 0.38842982,
				"type": "ORGANIZATION"
			},
			{
				"name": "Justin Gardner",
				"salience": 0.19672325,
				"type": "PERSON"
			},
			{
				"name": "masses",
				"salience": 0.09743201,
				"type": "OTHER"
			},
			{
				"name": "grip",
				"salience": 0.09396884,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.08325074,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.06058669,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.04618085,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.033427794,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T19:30:31.360+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0.6
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Justin Gardner As the corporatocracy tightens its grip on the masses – finding ever more ways to funnel wealth to the top – humanity... ",
		"thread_title": "Tiny Homes Banned In U.S. At Increasing Rate As Govt Criminalizes Sustainable Living",
		"title": "Tiny Homes Banned In U.S. At Increasing Rate As Govt Criminalizes Sustainable Living",
		"type": "conspiracy",
		"uuid": "b9add48225ead4ab014dd4561466989d555cbbb8"
	},
	"-KhIb3CM26GLgVkvuMZw": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T21:05:30.789+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.46307713,
				"type": "PERSON"
			},
			{
				"name": "Abby Martin",
				"salience": 0.15408096,
				"type": "PERSON"
			},
			{
				"name": "release",
				"salience": 0.106246546,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.07320193,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.07320193,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.06700833,
				"type": "ORGANIZATION"
			},
			{
				"name": "society",
				"salience": 0.047114402,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.016068783,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T21:05:30.789+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Abby Martin With the Wikileaks release of thousands of emails belonging to John Podesta, very little is known in US society about Podesta himself.... ",
		"thread_title": "The Empire Files: Abby Martin Exposes John Podesta",
		"title": "The Empire Files: Abby Martin Exposes John Podesta",
		"type": "conspiracy",
		"uuid": "ebb7a92b07607a02a379305f814720d7741d4c06"
	},
	"-KhIb3HFEUe8eTn0DMt9": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T03:55:20.620+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Most",
				"salience": 0.36857286,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.26771855,
				"type": "EVENT"
			},
			{
				"name": "Clint Siegner",
				"salience": 0.24272437,
				"type": "PERSON"
			},
			{
				"name": "wildest",
				"salience": 0.12098421,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T03:55:20.620+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Clint Siegner Most of us consider this year’s presidential election as the wildest and most unpredictable we’ve ever seen, but you wouldn’t know it... ",
		"thread_title": "Election Uncertainty Now Influencing Gold and Silver Prices",
		"title": "Election Uncertainty Now Influencing Gold and Silver Prices",
		"type": "conspiracy",
		"uuid": "bc9ad0b9ebac59588f3c51f8bb7a987481131888"
	},
	"-KhIb3LPV0Y5KVoDQXXL": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T17:55:36.561+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Kurt Nimmo",
				"salience": 0.32804847,
				"type": "PERSON"
			},
			{
				"name": "Blacklisted News",
				"salience": 0.14452438,
				"type": "OTHER"
			},
			{
				"name": "heat",
				"salience": 0.13486034,
				"type": "OTHER"
			},
			{
				"name": "brinkmanship",
				"salience": 0.13486034,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.12207134,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.10283399,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.03280115,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T17:55:36.561+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Kurt Nimmo, Blacklisted News If elected this week Hillary Clinton will turn up the heat on brinkmanship with Russia. Democrats insist Russia is behind... ",
		"thread_title": "DNC Hack: A Cold War 2.0 False Flag",
		"title": "DNC Hack: A Cold War 2.0 False Flag",
		"type": "conspiracy",
		"uuid": "ac291921661ecf4d0562121c31415f4f726c60f5"
	},
	"-KhIb3QKRHCkPCvP6ehD": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T18:06:13.864+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Bernie Suarez",
				"salience": 0.41528508,
				"type": "PERSON"
			},
			{
				"name": "perspective",
				"salience": 0.20699586,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.20699586,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.1707232,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T18:06:13.864+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Bernie Suarez It’s always important to keep a strong perspective on reality and the objective truth about what is happening even though we ourselves... ",
		"thread_title": "Here’s a Summary Of the Engineered US Election Chaos With a Positive Perspective",
		"title": "Here’s a Summary Of the Engineered US Election Chaos With a Positive Perspective",
		"type": "conspiracy",
		"uuid": "525633ff8631f5b245a6d09141722d7c264c5a5b"
	},
	"-KhIb3UTqATMZxP4c8sa": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T18:25:56.671+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.25211236,
				"type": "ORGANIZATION"
			},
			{
				"name": "Claire Bernish",
				"salience": 0.17408441,
				"type": "PERSON"
			},
			{
				"name": "surprise",
				"salience": 0.1197186,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.1197186,
				"type": "PERSON"
			},
			{
				"name": "attention",
				"salience": 0.08539446,
				"type": "OTHER"
			},
			{
				"name": "clearing",
				"salience": 0.070236415,
				"type": "EVENT"
			},
			{
				"name": "briefly",
				"salience": 0.05291341,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.05291341,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.043790113,
				"type": "PERSON"
			},
			{
				"name": "wrongdoing",
				"salience": 0.029118223,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T18:25:56.671+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Claire Bernish In no surprise to anyone paying even marginal attention, the FBI’s clearing Hillary Clinton of wrongdoing in its briefly reopened investigation —... ",
		"thread_title": "FBI Wants you to Believe It Examined 650,000 Emails in 691,000 Seconds",
		"title": "FBI Wants you to Believe It Examined 650,000 Emails in 691,000 Seconds",
		"type": "conspiracy",
		"uuid": "10b7f0b943835bccb69d5ca90c4ee2c1e2570954"
	},
	"-KhIb3Y6DlMZGa66kblq": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T21:05:34.067+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Kurt Nimmo",
				"salience": 0.31535584,
				"type": "PERSON"
			},
			{
				"name": "anybody",
				"salience": 0.26460713,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.1561877,
				"type": "OTHER"
			},
			{
				"name": "smokestack",
				"salience": 0.1561877,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09w3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pentagon"
				},
				"name": "Pentagon",
				"salience": 0.05407543,
				"type": "ORGANIZATION"
			},
			{
				"name": "elite",
				"salience": 0.053586192,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T21:05:34.067+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Kurt Nimmo Remember when the Pentagon promised to put a missile down the smokestack of anybody who hacks the elite? It hasn’t done that... ",
		"thread_title": "WikiLeaks Fends Off Cyber Attack",
		"title": "WikiLeaks Fends Off Cyber Attack",
		"type": "conspiracy",
		"uuid": "cb7be234128a36706486923b85361645cd6aef82"
	},
	"-KhIb3fbuf8TfhJ2oXEN": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T23:05:53.804+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "case",
				"salience": 0.397637,
				"type": "OTHER"
			},
			{
				"name": "Chris ``Kikila'' Perrin",
				"salience": 0.1736926,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.16207813,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.12249018,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vk9xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CTV_News"
				},
				"name": "CTV News",
				"salience": 0.07640124,
				"type": "ORGANIZATION"
			},
			{
				"name": "freedom",
				"salience": 0.067700855,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T23:05:53.804+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Chris “Kikila” Perrin In what can only be described as a case that defies the idea of freedom of the press, CTV News reported... ",
		"thread_title": "Police Caught Spying on Journalists to Uncover Source of Leaks",
		"title": "Police Caught Spying on Journalists to Uncover Source of Leaks",
		"type": "conspiracy",
		"uuid": "48ed7ee6e668ecfecfbe59144d8b4192d9bd7474"
	},
	"-KhIb3kVpcEIjjht7C9l": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T23:50:53.204+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Melissa Dykes This",
				"salience": 0.3295866,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.1655856,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.15978019,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.1367587,
				"type": "LOCATION"
			},
			{
				"name": "fraud",
				"salience": 0.103520006,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.057342596,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.04742632,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T23:50:53.204+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Melissa Dykes This has already been the craziest election in the history of the country, with the most overt corruption and fraud the American... ",
		"thread_title": "Just Weeks After Obama’s Executive Order on Catastrophic Space Weather Events, a Coronal Mass Ejection Is Set to Hit on Election Day?",
		"title": "Just Weeks After Obama’s Executive Order on Catastrophic Space Weather Events, a Coronal Mass Ejection Is Set to Hit on Election Day?",
		"type": "conspiracy",
		"uuid": "94960e7cebddda9dffc6c459c89268181f1f1b5d"
	},
	"-KhIb3oqCjw-jWEWSNmY": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T01:20:32.516+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07jfgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Miller_(journalist)"
				},
				"name": "John Miller",
				"salience": 0.24552247,
				"type": "PERSON"
			},
			{
				"name": "Kurt Nimmo",
				"salience": 0.213293,
				"type": "PERSON"
			},
			{
				"name": "Deputy Commissioner",
				"salience": 0.14754806,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.1108493,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.0933022,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorism",
				"salience": 0.087030806,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kwyc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Intelligence_assessment"
				},
				"name": "Intelligence",
				"salience": 0.06388055,
				"type": "ORGANIZATION"
			},
			{
				"name": "constant",
				"salience": 0.0385736,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T01:20:32.516+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Kurt Nimmo According to NYPD Deputy Commissioner of Intelligence and Counterterrorism John Miller, the threat of terrorism is a constant. Following yet another empty... ",
		"thread_title": "Police State Elections, 2016",
		"title": "Police State Elections, 2016",
		"type": "conspiracy",
		"uuid": "b3bb60a6802baff47de6702f8456bc8172729bf1"
	},
	"-KhIb3uaxLilAioclwjA": {
		"author": "ActivistPost",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T17:20:22.420+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Chris Duane",
				"salience": 0.8312682,
				"type": "PERSON"
			},
			{
				"name": "paradigm",
				"salience": 0.08248841,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.043457843,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.042785536,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T17:20:22.420+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Chris Duane Chris Duane explains why he’s not voting and destroys the left-right paradigm surrounding the 2016 US presidential (s)election. Vote for yourself. These... ",
		"thread_title": "9 Reasons Why I Am NOT Voting",
		"title": "9 Reasons Why I Am NOT Voting",
		"type": "conspiracy",
		"uuid": "27d1cf9b1c84474e17b0166fb5985151e8e95a31"
	},
	"-KhIb3z36qYk7QVFNulF": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T17:45:20.893+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "ball",
				"salience": 0.26998684,
				"type": "OTHER"
			},
			{
				"name": "Jon Rappoport",
				"salience": 0.26910397,
				"type": "PERSON"
			},
			{
				"name": "money bundlers",
				"salience": 0.14826785,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.09216635,
				"type": "PERSON"
			},
			{
				"name": "Fredrick D. Schaufeld",
				"salience": 0.08697069,
				"type": "PERSON"
			},
			{
				"name": "Sonjia Smith",
				"salience": 0.056552827,
				"type": "PERSON"
			},
			{
				"name": "Michael Bills",
				"salience": 0.041294087,
				"type": "OTHER"
			},
			{
				"name": "Karen Schaufeld",
				"salience": 0.035657413,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T17:45:20.893+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jon Rappoport Follow the bouncing ball. It turns out that several money bundlers for Hillary Clinton—Fredrick D. Schaufeld, Karen Schaufeld, Sonjia Smith, Michael Bills—... ",
		"thread_title": "No Matter Who Wins: The Case Against Hillary Clinton Is Alive",
		"title": "No Matter Who Wins: The Case Against Hillary Clinton Is Alive",
		"type": "conspiracy",
		"uuid": "9e39d77d6c7452b27e250ff9e9bb82bea9398a63"
	},
	"-KhIb44k-q0U7KzbSgkH": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T18:00:23.026+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.33814308,
				"type": "OTHER"
			},
			{
				"name": "Justin Gardner",
				"salience": 0.23928595,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.15394817,
				"type": "PERSON"
			},
			{
				"name": "crossing",
				"salience": 0.119270355,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04ykz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Missouri_River"
				},
				"name": "Missouri River",
				"salience": 0.07500943,
				"type": "LOCATION"
			},
			{
				"name": "fight",
				"salience": 0.07434303,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T18:00:23.026+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.7
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Justin Gardner As the controversial Dakota Access Pipeline nears its planned Missouri River crossing, protesters are remaining strong in their fight to protect the... ",
		"thread_title": "Cops Fire Tear Gas on Water Protectors as They Attempt to Reclaim Sacred Land",
		"title": "Cops Fire Tear Gas on Water Protectors as They Attempt to Reclaim Sacred Land",
		"type": "conspiracy",
		"uuid": "2f836e2554e5b1b7533ea25b3461b06e38c5355b"
	},
	"-KhIb49XcXaOz401eEKn": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T22:56:55.077+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "attorneys",
				"salience": 0.5001674,
				"type": "PERSON"
			},
			{
				"name": "Catherine J. Frompovich One",
				"salience": 0.25331363,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.12545978,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.07801536,
				"type": "EVENT"
			},
			{
				"name": "news",
				"salience": 0.043043796,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T22:56:55.077+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0.6
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Catherine J. Frompovich One of the attorneys with whom I network on various issues was so incensed about a recent news ‘event’ that I... ",
		"thread_title": "What Is “Fake” News?",
		"title": "What Is “Fake” News?",
		"type": "conspiracy",
		"uuid": "47d021d9d6d842cafaba334e0930c5b49f9ea154"
	},
	"-KhIb4Els4wSwvoIESs-": {
		"author": "Brandon Turbeville",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T01:16:24.080+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Brandon Turbeville",
				"salience": 0.3017539,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1951078,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.17266674,
				"type": "OTHER"
			},
			{
				"name": "close",
				"salience": 0.15160236,
				"type": "EVENT"
			},
			{
				"name": "selection circus",
				"salience": 0.14628719,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.03258199,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T01:16:24.080+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Brandon Turbeville As the U.S. Presidential selection circus draws to a close, the United States and Turkey have announced a new plan to defeat... ",
		"thread_title": "The U.S./Turkey Plan For “Seizing, Holding, And Occupying” Syrian Territory In Raqqa",
		"title": "The U.S./Turkey Plan For “Seizing, Holding, And Occupying” Syrian Territory In Raqqa",
		"type": "conspiracy",
		"uuid": "3a7ac4cdd4a98abe359e36b2c62650cc6bfda11c"
	},
	"-KhIb4JRxMxJtbvz4RfH": {
		"author": "Brandon Turbeville",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T01:19:03.532+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Brandon Turbeville",
				"salience": 0.3017539,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1951078,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.17266674,
				"type": "OTHER"
			},
			{
				"name": "close",
				"salience": 0.15160236,
				"type": "EVENT"
			},
			{
				"name": "selection circus",
				"salience": 0.14628719,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.03258199,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T01:19:03.532+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Brandon Turbeville As the U.S. Presidential selection circus draws to a close, the United States and Turkey have announced a new plan to defeat... ",
		"thread_title": "The U.S./Turkey Plan For “Seizing, Holding, And Occupying” Syrian Territory In Raqqa",
		"title": "The U.S./Turkey Plan For “Seizing, Holding, And Occupying” Syrian Territory In Raqqa",
		"type": "conspiracy",
		"uuid": "f8a861274edf89c2fcb3bbf3bf8df1312fd90a08"
	},
	"-KhIb4OQpBXMCcrjVYsP": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T02:00:47.984+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04f6_3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Op-ed"
				},
				"name": "Op-Ed",
				"salience": 0.27003574,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.1420354,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.13374181,
				"type": "OTHER"
			},
			{
				"name": "Carey Wedler",
				"salience": 0.11812356,
				"type": "PERSON"
			},
			{
				"name": "voices",
				"salience": 0.110183775,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.08316542,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.08087481,
				"type": "PERSON"
			},
			{
				"name": "difference",
				"salience": 0.061839473,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T02:00:47.984+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "Op-Ed by Carey Wedler As millions of Americans head to the polls today to “have their voices heard” and “make a difference,” many will likely... ",
		"thread_title": "Proof That 100 Years of Voting for the “Lesser Evil” Gave Us Trump and Hillary",
		"title": "Proof That 100 Years of Voting for the “Lesser Evil” Gave Us Trump and Hillary",
		"type": "conspiracy",
		"uuid": "f728265dae1b66efae24134da7a5fce4a5d839c3"
	},
	"-KhIb4T9yVp-o1aKgqpW": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T16:36:02.223+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Jon Rappoport",
				"salience": 0.37088618,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.26039195,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.20756793,
				"type": "LOCATION"
			},
			{
				"name": "networks",
				"salience": 0.07515999,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.05207423,
				"type": "LOCATION"
			},
			{
				"name": "viewers",
				"salience": 0.03391973,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T16:36:02.223+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jon Rappoport Before the polls are closed in the states. And already… The networks are tuning up viewers to expect a few key states... ",
		"thread_title": "Trump Declared The Winner",
		"title": "Trump Declared The Winner",
		"type": "conspiracy",
		"uuid": "a6050b55110503dbb5a3bac8af941e23354801dc"
	},
	"-KhIb4XkOc9LFmv26Y2x": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T16:50:47.187+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Elect Trump",
				"salience": 0.50473577,
				"type": "PERSON"
			},
			{
				"name": "Makia Freeman",
				"salience": 0.12805453,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.10716188,
				"type": "PERSON"
			},
			{
				"name": "title",
				"salience": 0.0643615,
				"type": "OTHER"
			},
			{
				"name": "businessman",
				"salience": 0.0628152,
				"type": "PERSON"
			},
			{
				"name": "millionaire",
				"salience": 0.0628152,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0378444,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.032211512,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T16:50:47.187+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Makia Freeman President Elect Trump is new title for New York businessman, millionaire and Republican candidate Donald J. Trump, who yesterday on November 8th,... ",
		"thread_title": "President Elect Trump: A New Era of Unpredictability Awaits",
		"title": "President Elect Trump: A New Era of Unpredictability Awaits",
		"type": "conspiracy",
		"uuid": "adc3a8a777233c71bda45a4a22fee4cd0350bbaf"
	},
	"-KhIb4akTpBiusIfXVoj": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T17:47:25.240+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Jon Rappoport",
				"salience": 0.4477764,
				"type": "PERSON"
			},
			{
				"name": "media narrative",
				"salience": 0.16270903,
				"type": "OTHER"
			},
			{
				"name": "Riots",
				"salience": 0.11851941,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.114235796,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.104465775,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.052293595,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T17:47:25.240+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Jon Rappoport But… After Trump’s stunning victory, the media narrative will continue: Riots are okay. Now we are a nation “deeply divided.” This horrible... ",
		"thread_title": "Election: Media’s Movie of Reality Failed",
		"title": "Election: Media’s Movie of Reality Failed",
		"type": "conspiracy",
		"uuid": "7f3663c2b01b54651776352c84a9200ba5285393"
	},
	"-KhIb4fE9EB8IPwzJPdt": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T18:00:25.921+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Mike Maharrey Voters",
				"salience": 0.3018714,
				"type": "PERSON"
			},
			{
				"name": "ballot measures",
				"salience": 0.17273396,
				"type": "OTHER"
			},
			{
				"name": "marijuana",
				"salience": 0.15166138,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.13417183,
				"type": "LOCATION"
			},
			{
				"name": "prohibition",
				"salience": 0.09481493,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Arkansas",
				"salience": 0.09222589,
				"type": "LOCATION"
			},
			{
				"name": "step",
				"salience": 0.052520614,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T18:00:25.921+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Mike Maharrey Voters in North Dakota and Arkansas have approved ballot measures legalizing medical marijuana, taking a first step toward nullifying the unconstitutional federal prohibition of... ",
		"thread_title": "Voters in Arkansas, North Dakota Legalize Medical Marijuana Despite Federal Prohibition",
		"title": "Voters in Arkansas, North Dakota Legalize Medical Marijuana Despite Federal Prohibition",
		"type": "conspiracy",
		"uuid": "7b7f801a6bae9b26c2e07d9525f87118b4818aea"
	},
	"-KhIb4jPe_UmBP6vBtik": {
		"author": "Activist Post",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T18:20:20.110+02:00",
		"domain_rank": "37161",
		"entities": [
			{
				"name": "Mike Maharrey Voters",
				"salience": 0.33225384,
				"type": "PERSON"
			},
			{
				"name": "ballot measure",
				"salience": 0.18518284,
				"type": "OTHER"
			},
			{
				"name": "marijuana",
				"salience": 0.16861455,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.14934589,
				"type": "LOCATION"
			},
			{
				"name": "prohibition",
				"salience": 0.10581881,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.05878408,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T18:20:20.110+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "activistpost.com",
		"spam_score": "0",
		"text": "By Mike Maharrey Voters in Florida have approved a ballot measure legalizing medical marijuana, taking a big step toward nullifying the unconstitutional federal prohibition of... ",
		"thread_title": "Florida Voters Approve Medical Marijuana, Reject Federal Prohibition",
		"title": "Florida Voters Approve Medical Marijuana, Reject Federal Prohibition",
		"type": "conspiracy",
		"uuid": "82d9a352ae393f35f9b215c78e7eadd412f0ef70"
	},
	"-KhIb51NdxR8ZEf_yF3F": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T19:50:02.054+03:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.1952838,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.11939526,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0750499,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05r8b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roger_Stone"
				},
				"name": "Roger Stone",
				"salience": 0.052474752,
				"type": "PERSON"
			},
			{
				"name": "deplorables",
				"salience": 0.04708886,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07pcq79"
				},
				"name": "Conservatives",
				"salience": 0.039794963,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.030152213,
				"type": "ORGANIZATION"
			},
			{
				"name": "voters",
				"salience": 0.024847602,
				"type": "PERSON"
			},
			{
				"name": "voter ID",
				"salience": 0.023780614,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.016106071,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.014285047,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.014073025,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.012481432,
				"type": "PERSON"
			},
			{
				"name": "badge",
				"salience": 0.010351795,
				"type": "OTHER"
			},
			{
				"name": "Voters",
				"salience": 0.010142822,
				"type": "PERSON"
			},
			{
				"name": "badges",
				"salience": 0.009658413,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0090487525,
				"type": "ORGANIZATION"
			},
			{
				"name": "Danielle Lang",
				"salience": 0.0087571675,
				"type": "PERSON"
			},
			{
				"name": "polling places",
				"salience": 0.008619963,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00847346,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hmrpgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Huffington_Post"
				},
				"name": "The Huffington Post",
				"salience": 0.008257757,
				"type": "ORGANIZATION"
			},
			{
				"name": "polling locations",
				"salience": 0.007785281,
				"type": "LOCATION"
			},
			{
				"name": "polling places",
				"salience": 0.0076431143,
				"type": "LOCATION"
			},
			{
				"name": "IDs",
				"salience": 0.007557025,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0573vv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Wisconsin%E2%80%93Green_Bay"
				},
				"name": "University of Wisconsin-Green Bay",
				"salience": 0.007549415,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.007455194,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.007455194,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0067438753,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.0067438753,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0067438753,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0067438753,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.005979102,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.005961056,
				"type": "ORGANIZATION"
			},
			{
				"name": "voters",
				"salience": 0.0058102747,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.0058102747,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04704d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.id"
				},
				"name": "ID",
				"salience": 0.0053117415,
				"type": "ORGANIZATION"
			},
			{
				"name": "democrat",
				"salience": 0.00518627,
				"type": "PERSON"
			},
			{
				"name": "Vote Protectors",
				"salience": 0.004718677,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0041038115,
				"type": "ORGANIZATION"
			},
			{
				"name": "efforts",
				"salience": 0.004038146,
				"type": "OTHER"
			},
			{
				"name": "ID badge",
				"salience": 0.0039833128,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0039547817,
				"type": "OTHER"
			},
			{
				"name": "conservatives",
				"salience": 0.0039547817,
				"type": "PERSON"
			},
			{
				"name": "videotape voters",
				"salience": 0.0039240345,
				"type": "PERSON"
			},
			{
				"name": "exit polls",
				"salience": 0.0035275815,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0028170522,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0028170522,
				"type": "EVENT"
			},
			{
				"name": "ability",
				"salience": 0.0027793152,
				"type": "OTHER"
			},
			{
				"name": "droves",
				"salience": 0.0027793152,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0027793152,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0027709154,
				"type": "ORGANIZATION"
			},
			{
				"name": "tactics",
				"salience": 0.0027709154,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0026026038,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0025591461,
				"type": "PERSON"
			},
			{
				"name": "volunteers",
				"salience": 0.002279375,
				"type": "PERSON"
			},
			{
				"name": "videotaping",
				"salience": 0.0022506665,
				"type": "OTHER"
			},
			{
				"name": "privacy",
				"salience": 0.0022506665,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0022506665,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0022027756,
				"type": "PERSON"
			},
			{
				"name": "websites",
				"salience": 0.00216669,
				"type": "OTHER"
			},
			{
				"name": "volunteers",
				"salience": 0.00216669,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.0020370996,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0020080125,
				"type": "OTHER"
			},
			{
				"name": "internet",
				"salience": 0.0019490019,
				"type": "OTHER"
			},
			{
				"name": "voter intimidation scheme",
				"salience": 0.0019490019,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.0019490019,
				"type": "OTHER"
			},
			{
				"name": "election law",
				"salience": 0.0019490019,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0019490019,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.0019490019,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.0019490019,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0019490019,
				"type": "OTHER"
			},
			{
				"name": "voter suppression tactics",
				"salience": 0.0019186328,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.0018846879,
				"type": "PERSON"
			},
			{
				"name": "risks",
				"salience": 0.0018762724,
				"type": "OTHER"
			},
			{
				"name": "confines",
				"salience": 0.0018762724,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0018762724,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.001837504,
				"type": "PERSON"
			},
			{
				"name": "privacy",
				"salience": 0.001837504,
				"type": "OTHER"
			},
			{
				"name": "city clerk",
				"salience": 0.0018256058,
				"type": "PERSON"
			},
			{
				"name": "site",
				"salience": 0.0017029173,
				"type": "OTHER"
			},
			{
				"name": "democrats",
				"salience": 0.0016456767,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.0015911805,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0015911805,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.0015911805,
				"type": "OTHER"
			},
			{
				"name": "aspect",
				"salience": 0.0015911805,
				"type": "OTHER"
			},
			{
				"name": "Kris Teske",
				"salience": 0.0015745199,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0015330435,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.0015203429,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k0b7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota_Democratic%E2%80%93Farmer%E2%80%93Labor_Party"
				},
				"name": "Democrat",
				"salience": 0.0015198987,
				"type": "PERSON"
			},
			{
				"name": "polling location",
				"salience": 0.0014625774,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.0014560454,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.0012990166,
				"type": "OTHER"
			},
			{
				"name": "voter intimidation tactics",
				"salience": 0.0012787702,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h3tkvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Campaign_Legal_Center"
				},
				"name": "Campaign Legal Center",
				"salience": 0.0011997204,
				"type": "ORGANIZATION"
			},
			{
				"name": "democrats",
				"salience": 0.0011986136,
				"type": "PERSON"
			},
			{
				"name": "thoughts",
				"salience": 0.0011886822,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0011886822,
				"type": "PERSON"
			},
			{
				"name": "Chief of Staff",
				"salience": 0.0011886822,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.0011886822,
				"type": "EVENT"
			},
			{
				"name": "budget",
				"salience": 0.0011886822,
				"type": "OTHER"
			},
			{
				"name": "whole",
				"salience": 0.0011886822,
				"type": "LOCATION"
			},
			{
				"name": "statutes",
				"salience": 0.0011015962,
				"type": "OTHER"
			},
			{
				"name": "college students",
				"salience": 0.0010049742,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.0009997863,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0009997863,
				"type": "OTHER"
			},
			{
				"name": "Image",
				"salience": 0.0009997863,
				"type": "WORK_OF_ART"
			},
			{
				"name": "proposals",
				"salience": 0.00095816446,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.00090332876,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.0008657211,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0008657211,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0008657211,
				"type": "WORK_OF_ART"
			},
			{
				"name": "polling place",
				"salience": 0.00082716905,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.00073772564,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/021yby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Seat_of_local_government"
				},
				"name": "City Hall",
				"salience": 0.00073161186,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.0006978161,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0006466826,
				"type": "ORGANIZATION"
			},
			{
				"name": "advantage",
				"salience": 0.0006466826,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0006466826,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.00061533134,
				"type": "ORGANIZATION"
			},
			{
				"name": "Drew Angerer",
				"salience": 0.0005328078,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wisconsin",
				"salience": 0.0005090778,
				"type": "LOCATION"
			},
			{
				"name": "election experts",
				"salience": 0.00047696396,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fscv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Bay,_Wisconsin"
				},
				"name": "Green Bay",
				"salience": 0.00045963252,
				"type": "LOCATION"
			},
			{
				"name": "Wisconsin Ethics Commission",
				"salience": 0.00039798665,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T14:53:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0.096",
		"text": "on October 27, 2016 2:53 am · \nConservatives claim that voter ID is necessary to catch illegal voters, but it turns out they’re the only ones creating fake IDs to use on Election Day. \nTrump supporters are taking Trump’s call to monitor polling places so seriously that they are creating fake ID badges in order to infiltrate polling locations across the country and intimidate voters by interrogating them, confusing them, and filming them — all of which are illegal. \nBut, Trump’s deplorables are doing this in droves with the help of a right-wing group known as “Vote Protectors.” \nThe group, which is affiliated with top Trump ally Roger Stone, is giving people the ability to intimidate voters on Election Day. They are literally teaching them to create their own fake badge, which is designed to give them access to voters both inside and outside the polling places where citizens cast their votes. \nAccording to the Huffington Post , \nStone’s group created an official-looking ID badge for its volunteers to wear, and its volunteers planned to videotape voters and conduct fake “exit polls,” efforts that election experts say risks intimidating and confusing voters. Or at least that’s what the group was planning to do before The Huffington Post asked Stone about it on Tuesday. The controversial Trump ally, long known for his bare-knuckled political tactics, said that key proposals on his group’s websites were there without his knowledge, and assured HuffPost that he would operate within the confines of election law. \nIn fact, after HuffPo confronted Stone with evidence that these kinds of tactics were being pursued by the website, he acknowledged that Vote Protectors had a “bad idea” and “ordered them taken down.” \nCampaign Legal Center deputy director Danielle Lang called the tactics a clear voter intimidation scheme. \n“It’s inherently intimidating and an invasion of privacy,” she told HuffPo in reference to the videotaping. “When that’s being live streamed to the internet, it amplifies the potentially intimidating aspect of it, and violates a sense of security and privacy people have a right to enjoy at the polls. Objectively, intimidating voters is unlawful, no matter where you do it.” \nIndeed, but that’s exactly what Donald Trump has been calling upon his supporters to do because he has repeatedly claimed that the election is rigged against him. \nAs it turns out, he’s right about the election being rigged, only it’s conservatives who are trying to rig it in favor of Trump. \nEarlier this week, a Wisconsin city clerk in Green Bay got caught trying to intentionally prevent college students from voting by arguing in an email to the Wisconsin Ethics Commission that an extra polling place should not be opened near the University of Wisconsin-Green Bay because she has merely heard that students lean Democrat. \n“I was reading the statutes and read: No site may be designated that affords an advantage to any political party,” Republican appointed clerk Kris Teske wrote. \n“UWGB is a polling location for students and residents on Election Day but I feel by asking for this to be the site for early voting is encouraging the students to vote more than benefiting the city as a whole. I have heard it said that students lean more toward the democrats and he is a democrat. I have spoken with our Chief of Staff and others at City Hall and they agree that budget wise this isn’t going to happen. I would like to know your thoughts on this. Do I have an argument about it being more of a benefit to the democrats.” \nSo not only are Trump supporters trying to rig the election with voter intimidation tactics using hypocritical methods, they are using voter suppression tactics as well. \nAnd that is likely going to cause a lot of Election Day chaos. Voters should be prepared to stand up for their right to vote no matter what Trump’s deplorables try to do to keep them from exercising it. \nFeatured Image: Drew Angerer/Getty Images Share this Article! ",
		"thread_title": "BUSTED: Trump Supporters Get Caught Creating Fake Badges To Intimidate Voters At Polling Places | Addicting Info | The Knowledge You Crave",
		"title": "BUSTED: Trump Supporters Get Caught Creating Fake Badges To Intimidate Voters At Polling Places | Addicting Info | The Knowledge You Crave",
		"type": "bias",
		"uuid": "cdd25a3803eb434911f1df9222ed083f66eaa1d2"
	},
	"-KhIb5MQZMZe2o2gIla3": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-10-31T02:43:21.942+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.67817336,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.04731029,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06sf9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jake_Tapper"
				},
				"name": "Jake Tapper",
				"salience": 0.030387545,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_m1t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conway,_South_Carolina"
				},
				"name": "Conway",
				"salience": 0.023674536,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.022685468,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dq819",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kellyanne_Conway"
				},
				"name": "Kellyanne Conway",
				"salience": 0.020978143,
				"type": "PERSON"
			},
			{
				"name": "Shannon Barber Shannon Barber",
				"salience": 0.012299623,
				"type": "PERSON"
			},
			{
				"name": "travesty",
				"salience": 0.0100312615,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0077078086,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.006973631,
				"type": "PERSON"
			},
			{
				"name": "president campaign",
				"salience": 0.005415532,
				"type": "EVENT"
			},
			{
				"name": "experts",
				"salience": 0.005256596,
				"type": "PERSON"
			},
			{
				"name": "comfort level",
				"salience": 0.004832505,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.004476524,
				"type": "OTHER"
			},
			{
				"name": "bigots",
				"salience": 0.004443171,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.004443171,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.004443171,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0042749085,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.004013116,
				"type": "PERSON"
			},
			{
				"name": "misogynists",
				"salience": 0.004013116,
				"type": "PERSON"
			},
			{
				"name": "anti-semites",
				"salience": 0.004013116,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003824834,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.003824834,
				"type": "PERSON"
			},
			{
				"name": "anti-Semites",
				"salience": 0.0036036477,
				"type": "PERSON"
			},
			{
				"name": "folks",
				"salience": 0.0034764956,
				"type": "PERSON"
			},
			{
				"name": "real estate mogul",
				"salience": 0.0034764956,
				"type": "OTHER"
			},
			{
				"name": "xenophobes",
				"salience": 0.0034764956,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0030823804,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0028593666,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0025358489,
				"type": "PERSON"
			},
			{
				"name": "racists",
				"salience": 0.0018324885,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0017125569,
				"type": "PERSON"
			},
			{
				"name": "candidacy",
				"salience": 0.0016547388,
				"type": "OTHER"
			},
			{
				"name": "misogynists",
				"salience": 0.0016547388,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.001606142,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0015674938,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0014525136,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.0014330589,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.0014330589,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0014330589,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0014330589,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.0012852356,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0012852356,
				"type": "PERSON"
			},
			{
				"name": "rallies",
				"salience": 0.001117217,
				"type": "EVENT"
			},
			{
				"name": "rally",
				"salience": 0.001117217,
				"type": "EVENT"
			},
			{
				"name": "support",
				"salience": 0.0010493462,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0010049818,
				"type": "OTHER"
			},
			{
				"name": "hate groups",
				"salience": 0.0010049818,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.0010049818,
				"type": "OTHER"
			},
			{
				"name": "excess",
				"salience": 0.0010049818,
				"type": "OTHER"
			},
			{
				"name": "tens of thousands",
				"salience": 0.0010049818,
				"type": "PERSON"
			},
			{
				"name": "press pen",
				"salience": 0.0009674834,
				"type": "OTHER"
			},
			{
				"name": "JEW-S-A",
				"salience": 0.0009674834,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0009674834,
				"type": "OTHER"
			},
			{
				"name": "adjectives",
				"salience": 0.0009674834,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0009474949,
				"type": "OTHER"
			},
			{
				"name": "fans",
				"salience": 0.0009432644,
				"type": "PERSON"
			},
			{
				"name": "exchange",
				"salience": 0.0009355602,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0009323511,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.00089662854,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0008822971,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0008485894,
				"type": "OTHER"
			},
			{
				"name": "bigot",
				"salience": 0.0008352693,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00082049106,
				"type": "OTHER"
			},
			{
				"name": "open",
				"salience": 0.00082049106,
				"type": "OTHER"
			},
			{
				"name": "bigots",
				"salience": 0.00078396674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antisemitism"
				},
				"name": "anti-Semitic",
				"salience": 0.00064596825,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.0006129566,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0006129566,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0006129566,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fiasco",
				"salience": 0.0006129566,
				"type": "OTHER"
			},
			{
				"name": "Dog whistles",
				"salience": 0.0006129566,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fog horns",
				"salience": 0.0006129566,
				"type": "LOCATION"
			},
			{
				"name": "election cycle",
				"salience": 0.0006129566,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00057530135,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0005709998,
				"type": "OTHER"
			},
			{
				"name": "women's rights",
				"salience": 0.0005709998,
				"type": "OTHER"
			},
			{
				"name": "LGBT rights",
				"salience": 0.0005709998,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00052031304,
				"type": "EVENT"
			},
			{
				"name": "exchange",
				"salience": 0.00049631076,
				"type": "OTHER"
			},
			{
				"name": "cloud",
				"salience": 0.00046661377,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "activist",
				"salience": 0.00044642616,
				"type": "PERSON"
			},
			{
				"name": "Search",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "computer science",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "websites",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "humor blog",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "lesbians",
				"salience": 0.00044642616,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00044642616,
				"type": "LOCATION"
			},
			{
				"name": "mind",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "Author",
				"salience": 0.00044642616,
				"type": "PERSON"
			},
			{
				"name": "Share",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.00044642616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video screen capture",
				"salience": 0.00044642616,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0003851243,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0003851243,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0003553109,
				"type": "OTHER"
			},
			{
				"name": "stain",
				"salience": 0.00033347862,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.00033347862,
				"type": "OTHER"
			},
			{
				"name": "pattern",
				"salience": 0.00033347862,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00033347862,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.00031731208,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00027475783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hhz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oval_Office"
				},
				"name": "Oval Office",
				"salience": 0.0002052349,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00016967492,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "3",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/10/tapper-and-conway.png",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-31T01:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.4,
			"score": -0.1
		},
		"shares": "3",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on October 30, 2016 2:24 pm · \nOne thing that has continuously dogged the Donald Trump for president campaign is the fact that racists, anti-semites, xenophobes, misogynists, and various other bigots have stuck with the bombastic real estate mogul since he first launched his travesty of a campaign. No matter how much Trump’s people try to say he doesn’t want the support of such folks, the candidate himself refuses to take the fact that there is anything about the campaign he has been running that attracts these people seriously. So, naturally, when Trump’s campaign manager Kellyanne Conway sat down with an interview with CNN’s Jake Tapper on Sunday , that particular issue came up again. Of course, Conway was not happy. Tapper began: \n“There are a lot of anti-Semites and racists and misogynists who support the Trump candidacy.” \nConway immediately went on defense, saying, “wow.” Tapper went on to reference a man who was shouting ‘JEW-S-A’ at the press pen at a recent Trump rally, and directly asked Conway if she would refer to such people as ‘deplorable.’ She responded: \n“Yes, I would. Wow, I have to push back on some of the adjectives you just used to describe — I hope you’ve been to Trump rallies and I hope that you’ve seen the tens of thousands. I mean, he’s had over half a million people easily, I think in excess of that. These are U.S.A.-loving Americans.” \nTapper went on to say that no, he isn’t putting all Trump supporters into that camp, but went on to force Conway’s hand on this one: \n“But without question, people who are experts on hate groups say that there has been a comfort level that has been offered to people who are anti-Semitic that has been offered to people who are anti-Semitic and racists and on and on. And these people are comfortable coming out in the open and supporting Mr. Trump. \nMr. Trump has refused to condemn in a very serious way his racist and anti-Semitic fans,” Tapper continued. “He just has. He says things like, “Oh, sure, I disavow, I disavow.’ But he has never serious said, ‘I don’t want the support of those people, they are reprehensible, they have nothing to do with me.’ He has never seriously done it.” \nConway used the pushing to pivot back to the idea that the Trump campaign is winning, saying: \n“I think this exchange is frankly the best piece of evidence I have that we’re actually going to win in nine days because the idea that we’re going to shift away from the pattern of corruption the cloud of ethical stain that Hillary Clinton would bring to the Oval Office in such an important week.” \nNo, Kellyanne, it’s not a sign that Trump is winning. It’s pointing something out that has been true since this whole fiasco began: That Donald Trump is a raging bigot, and he has been so openly. Dog whistles have turned into fog horns this election cycle, and it’s all because of Donald Trump. He embraces these bigots because he’s one of them. The quicker you learn that, the better. \nWatch the exchange below: \nFeatured image via video screen capture Share this Article! Share on Facebook Author: Shannon Barber Shannon Barber is a self- described queer feminist and activist for racial equality, LGBT rights, women’s rights, and secular rights in America. She is a lifelong lover of words, though her educational background is in computer science. She currently writes for 2 liberal websites, and keeps her own humor blog for lesbians. She hopes to change the world, one mind at a time. Search",
		"thread_title": "Kellyanne Conway LOSES IT On Jake Tapper When He Calls Out Trump’s Bigoted Fans (VIDEO)",
		"title": "Kellyanne Conway LOSES IT On Jake Tapper When He Calls Out Trump’s Bigoted Fans (VIDEO)",
		"type": "bias",
		"uuid": "266257d3076cd0a1b76446eef8577d1899485d93"
	},
	"-KhIb5Vq4Vw-h0Ukyhwp": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-10-31T02:43:35.030+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08f3b1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sarah_Palin"
				},
				"name": "Sarah Palin",
				"salience": 0.48223168,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.05437639,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.05437639,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0380042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.029160349,
				"type": "OTHER"
			},
			{
				"name": "links",
				"salience": 0.02255568,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.02255568,
				"type": "WORK_OF_ART"
			},
			{
				"name": "problem",
				"salience": 0.01954499,
				"type": "OTHER"
			},
			{
				"name": "glance",
				"salience": 0.01954499,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.01858243,
				"type": "OTHER"
			},
			{
				"name": "timeline",
				"salience": 0.015249593,
				"type": "OTHER"
			},
			{
				"name": "Wolfcastle",
				"salience": 0.015214322,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.014762741,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.013721548,
				"type": "OTHER"
			},
			{
				"name": "hillbilly brawl",
				"salience": 0.013721548,
				"type": "EVENT"
			},
			{
				"name": "bar",
				"salience": 0.013210826,
				"type": "LOCATION"
			},
			{
				"name": "half-wit",
				"salience": 0.013210826,
				"type": "OTHER"
			},
			{
				"name": "Governor",
				"salience": 0.013210826,
				"type": "PERSON"
			},
			{
				"name": "campaign stop",
				"salience": 0.013210826,
				"type": "LOCATION"
			},
			{
				"name": "Sam Adams",
				"salience": 0.011757676,
				"type": "PERSON"
			},
			{
				"name": "@SarahPalinUSA",
				"salience": 0.0111018885,
				"type": "ORGANIZATION"
			},
			{
				"name": "camera",
				"salience": 0.011066969,
				"type": "OTHER"
			},
			{
				"name": "@JohnYuma",
				"salience": 0.008934044,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.008377389,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hjy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alaska"
				},
				"name": "Alaska",
				"salience": 0.008139948,
				"type": "LOCATION"
			},
			{
				"name": "drinking",
				"salience": 0.006288652,
				"type": "OTHER"
			},
			{
				"name": "@tew156",
				"salience": 0.0061462796,
				"type": "OTHER"
			},
			{
				"name": "@SarahPalinUSA",
				"salience": 0.0061462796,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rsxrn"
				},
				"name": "Lush",
				"salience": 0.005159358,
				"type": "ORGANIZATION"
			},
			{
				"name": "John Yuma",
				"salience": 0.005159358,
				"type": "PERSON"
			},
			{
				"name": "internet",
				"salience": 0.0048894063,
				"type": "OTHER"
			},
			{
				"name": "@Clodagh831",
				"salience": 0.004592583,
				"type": "OTHER"
			},
			{
				"name": "@SarahPalinUSA",
				"salience": 0.004592583,
				"type": "OTHER"
			},
			{
				"name": "Box O' Wine",
				"salience": 0.004375765,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.004018075,
				"type": "LOCATION"
			},
			{
				"name": "Clodagh Smith",
				"salience": 0.0028079029,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "1",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/10/Untitled-2-Recovered.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-31T02:43:35.030+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.5,
			"score": -0.1
		},
		"shares": "1",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on October 30, 2016 4:07 pm · \nFor like the eleventy-billionth time, Sarah Palin posted a broken link to a Facebook post on Twitter Sunday. Now, at first glance her months of posting dead links and not figuring out how to fix the problem might seem moderately stupid — until you see the content of the actual post on the half-term, half-wit former Governor of Alaska’s Facebook timeline. \nReferencing Clinton’s recent, mundane campaign stop at a bar, Palin — who regularly appears to be heavily intoxicated whenever she has a camera in front of her and was involved in a drunken hillbilly brawl in 2014 — quipped, “she’s gonna drive us all to drink.” \nThinking she is clever, she then adds that Clinton should have been “thinking Sam Adams” rather than “drinking Sam Adams.” \nNaturally, as Palin brought up drinking, the internet decided it couldn’t let this one go: @SarahPalinUSA I see you've already started \n— Clodagh Smith (@Clodagh831) October 30, 2016 @SarahPalinUSA Any excuse to drink, eh Sarah? #Lush \n— John Yuma (@JohnYuma) October 30, 2016 @SarahPalinUSA Have you been day drinking again? \n— Mr. Wolfcastle (@tew156) October 30, 2016 @SarahPalinUSA oh Sarah, remember when you mattered?Me neither. Open another Box O' Wine.",
		"thread_title": "Internet Erupts In Mockery After Sarah Palin Posts Something Monumentally Stupid Again (TWEETS)",
		"title": "Internet Erupts In Mockery After Sarah Palin Posts Something Monumentally Stupid Again (TWEETS)",
		"type": "bias",
		"uuid": "5ce9574f216dc7a933c782146e8ef08ab76012c9"
	},
	"-KhIb5g7RVlWpaI-bI4H": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T15:40:51.830+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.2541993,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.064241365,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.046703078,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.03178326,
				"type": "EVENT"
			},
			{
				"name": "election results",
				"salience": 0.02764749,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.024811482,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.023575261,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.020430373,
				"type": "OTHER"
			},
			{
				"name": "supporter",
				"salience": 0.018412838,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.017428217,
				"type": "OTHER"
			},
			{
				"name": "election code",
				"salience": 0.014683282,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.014070106,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.012599015,
				"type": "PERSON"
			},
			{
				"name": "polling places",
				"salience": 0.012445787,
				"type": "LOCATION"
			},
			{
				"name": "polling place",
				"salience": 0.012445787,
				"type": "LOCATION"
			},
			{
				"name": "polling place",
				"salience": 0.012445787,
				"type": "LOCATION"
			},
			{
				"name": "Election code",
				"salience": 0.011049694,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.011000464,
				"type": "OTHER"
			},
			{
				"name": "electioneering",
				"salience": 0.010781171,
				"type": "EVENT"
			},
			{
				"name": "politics",
				"salience": 0.010390115,
				"type": "OTHER"
			},
			{
				"name": "somebody",
				"salience": 0.010390115,
				"type": "PERSON"
			},
			{
				"name": "volunteer",
				"salience": 0.010379679,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0101688085,
				"type": "LOCATION"
			},
			{
				"name": "box cutter blades",
				"salience": 0.009921595,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "voters",
				"salience": 0.009736596,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.009736596,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.009460221,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.009223794,
				"type": "OTHER"
			},
			{
				"name": "polling location sign",
				"salience": 0.009223794,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.009223794,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.008880157,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.00873345,
				"type": "LOCATION"
			},
			{
				"name": "Deplorables",
				"salience": 0.0084335,
				"type": "WORK_OF_ART"
			},
			{
				"name": "T-shirt",
				"salience": 0.0084335,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hats",
				"salience": 0.0084335,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "polling place",
				"salience": 0.008408041,
				"type": "LOCATION"
			},
			{
				"name": "Steve Spainhouer",
				"salience": 0.0076849232,
				"type": "PERSON"
			},
			{
				"name": "violation",
				"salience": 0.0075643337,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.007532723,
				"type": "OTHER"
			},
			{
				"name": "volunteer",
				"salience": 0.007282399,
				"type": "PERSON"
			},
			{
				"name": "official",
				"salience": 0.007282399,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.006610286,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.006504524,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0061769933,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0061769933,
				"type": "PERSON"
			},
			{
				"name": "volunteer",
				"salience": 0.0061769933,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.0059160213,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.0059160213,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.005695427,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.005577834,
				"type": "OTHER"
			},
			{
				"name": "blades",
				"salience": 0.005577834,
				"type": "OTHER"
			},
			{
				"name": "temper tantrum",
				"salience": 0.0054140235,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0053458693,
				"type": "WORK_OF_ART"
			},
			{
				"name": "supporters",
				"salience": 0.0053297174,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0048305932,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0041677887,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.004100954,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02k0lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Collin_College"
				},
				"name": "Collin College",
				"salience": 0.004049547,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.0039440976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013m4v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Plano,_Texas"
				},
				"name": "Plano",
				"salience": 0.0036427607,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0036092608,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0036092608,
				"type": "ORGANIZATION"
			},
			{
				"name": "act",
				"salience": 0.0034901807,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0033623045,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0033623045,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0033623045,
				"type": "PERSON"
			},
			{
				"name": "Image",
				"salience": 0.0030359405,
				"type": "WORK_OF_ART"
			},
			{
				"name": "voters",
				"salience": 0.0030359405,
				"type": "PERSON"
			},
			{
				"name": "minds",
				"salience": 0.002984313,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0029096017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0027215292,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0026289837,
				"type": "EVENT"
			},
			{
				"name": "safety",
				"salience": 0.0026289837,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0026289837,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0026289837,
				"type": "WORK_OF_ART"
			},
			{
				"name": "persuasion",
				"salience": 0.0022680752,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0022680752,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05yrln",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KTVT"
				},
				"name": "KTVT",
				"salience": 0.0022218486,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0019639933,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.0019639933,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.0018688026,
				"type": "ORGANIZATION"
			},
			{
				"name": "Darren McCollester",
				"salience": 0.0016182276,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0013960238,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-03T11:22:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.6,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0.033",
		"text": "on November 3, 2016 12:22 am · \nDonald Trump’s deplorable supporters aren’t waiting for the election results to start spilling blood. \nThey’ve been threatening bloody violence ever since Trump began claiming that the election is “rigged” in favor of Hillary Clinton. And Trump has called for them to intimidate voters at polling places. \nIn Texas last week, a Trump supporter was arrested for electioneering at a polling place because he was wearing one of Trump’s stupid hats and a “Deplorables” T-shirt to vote. \nElection code prohibits any person from electioneering within 100 feet of a polling place. \nOf course, Trump supporters threw a temper tantrum because they think the rules don’t apply to them. \nWell, now it looks like they have retaliated by setting up a booby trapped Trump sign at a polling place knowing that an official or volunteer would have to take the sign down. \nAt Collin College in Plano, Texas a Trump sign was discovered zip-tied to an official polling location sign in direct violation of the election code that forbids electioneering at polling places. \nBut when a volunteer went out to remove the sign they got a nasty surprise in the form of box cutter blades that were strategically hidden inside. The blades sliced into the volunteer’s hands and drew blood, requiring medical attention and prompting officials to order that signs be checked thoroughly before removal. \n“It just shows how far we have come in politics where people want to be so mean and so hateful to try and injure somebody who’s probably not got any political party persuasion one way or the other,” local Democratic Party campaign chair Steve Spainhouer said in response . “I think most people have already made their minds up at this point how they’re going to vote and so there’s nothing to gain by being mean spirited or hateful.” \nHere’s the video via KTVT . \nFrankly, this should be considered an act of domestic terrorism. Trump’s supporters have gone too far and it could get worse as Election Day approaches. And if Trump loses, his supporters have already threatened to try to overthrow the federal government in a bloody coup. \nClearly, these people are deranged and the safety of voters and election officials are in danger. But you won’t hear Donald Trump condemning this act of violence. After all, he is the one inciting it. \nFeatured Image: Darren McCollester/Getty Images Share this Article! ",
		"thread_title": "Trump Supporters Booby Trap Polling Place And Spill Blood Of Election Volunteer (VIDEO) | Addicting Info | The Knowledge You Crave",
		"title": "Trump Supporters Booby Trap Polling Place And Spill Blood Of Election Volunteer (VIDEO) | Addicting Info | The Knowledge You Crave",
		"type": "bias",
		"uuid": "5ac146c54a890412d8f4c1e49253c026d4c359b7"
	},
	"-KhIb5tZ0W_FS8Bbc0nV": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T03:06:01.150+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04g__c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fred_Trump"
				},
				"name": "Fred Trump",
				"salience": 0.23338939,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.16394128,
				"type": "PERSON"
			},
			{
				"name": "real estate business",
				"salience": 0.04724196,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.04262163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ncdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Trump_Organization"
				},
				"name": "Trump Organization",
				"salience": 0.042006955,
				"type": "ORGANIZATION"
			},
			{
				"name": "Stanley Leibowitz",
				"salience": 0.029307349,
				"type": "PERSON"
			},
			{
				"name": "applicants",
				"salience": 0.027580958,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.025224565,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.024779925,
				"type": "OTHER"
			},
			{
				"name": "minority applicants",
				"salience": 0.022506865,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.019508377,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.01762492,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.01762492,
				"type": "EVENT"
			},
			{
				"name": "mountain",
				"salience": 0.015273324,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.015273324,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0131501835,
				"type": "OTHER"
			},
			{
				"name": "properties",
				"salience": 0.0131501835,
				"type": "LOCATION"
			},
			{
				"name": "investigators",
				"salience": 0.012454566,
				"type": "PERSON"
			},
			{
				"name": "news network",
				"salience": 0.009154847,
				"type": "ORGANIZATION"
			},
			{
				"name": "apartment properties",
				"salience": 0.008721811,
				"type": "LOCATION"
			},
			{
				"name": "property managers",
				"salience": 0.007766671,
				"type": "PERSON"
			},
			{
				"name": "Oliver Willis",
				"salience": 0.006562054,
				"type": "PERSON"
			},
			{
				"name": "applicants",
				"salience": 0.0065281987,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0064656045,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0063039693,
				"type": "EVENT"
			},
			{
				"name": "rental agent",
				"salience": 0.0063039693,
				"type": "PERSON"
			},
			{
				"name": "properties",
				"salience": 0.0061196685,
				"type": "OTHER"
			},
			{
				"name": "housing",
				"salience": 0.00609623,
				"type": "OTHER"
			},
			{
				"name": "entanglements",
				"salience": 0.005879037,
				"type": "OTHER"
			},
			{
				"name": "applications",
				"salience": 0.0053311186,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0051059253,
				"type": "ORGANIZATION"
			},
			{
				"name": "discrimination",
				"salience": 0.0051059253,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0049973694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0049041766,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g8309",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump"
				},
				"name": "Trumps",
				"salience": 0.0048474525,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.004501649,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.0044830893,
				"type": "ORGANIZATION"
			},
			{
				"name": "run-in",
				"salience": 0.0044220663,
				"type": "EVENT"
			},
			{
				"name": "backgrounds",
				"salience": 0.0044220663,
				"type": "OTHER"
			},
			{
				"name": "revelation",
				"salience": 0.004311441,
				"type": "OTHER"
			},
			{
				"name": "allegation",
				"salience": 0.004311441,
				"type": "OTHER"
			},
			{
				"name": "n-word",
				"salience": 0.0042571686,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0042571686,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0041692667,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.0037033686,
				"type": "ORGANIZATION"
			},
			{
				"name": "testimony",
				"salience": 0.0036106997,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0036106997,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0036106997,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.0034042285,
				"type": "WORK_OF_ART"
			},
			{
				"name": "story",
				"salience": 0.0031152563,
				"type": "WORK_OF_ART"
			},
			{
				"name": "discrimination",
				"salience": 0.0031152563,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0026977642,
				"type": "WORK_OF_ART"
			},
			{
				"name": "screen capture",
				"salience": 0.0026977642,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0026977642,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0026977642,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0026212137,
				"type": "PERSON"
			},
			{
				"name": "bloggers",
				"salience": 0.0022692196,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0022692196,
				"type": "LOCATION"
			},
			{
				"name": "bloggers",
				"salience": 0.0022692196,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.0019650313,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Author",
				"salience": 0.0019650313,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.0018916948,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0018775524,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0018775524,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0018775524,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.0018775524,
				"type": "OTHER"
			},
			{
				"name": "real estate world",
				"salience": 0.0016952646,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0016952646,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media",
				"salience": 0.0014679751,
				"type": "OTHER"
			},
			{
				"name": "prominence",
				"salience": 0.0014679751,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0014679751,
				"type": "OTHER"
			},
			{
				"name": "wrongdoing",
				"salience": 0.0014679751,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0013968241,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0012095305,
				"type": "OTHER"
			},
			{
				"name": "@owillis",
				"salience": 0.0012095305,
				"type": "PERSON"
			},
			{
				"name": "OliverWillis.com Search",
				"salience": 0.0012095305,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T10:41:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0.001",
		"text": "on October 25, 2016 10:41 pm · \nNew video has surfaced adding to the mountain of evidence that while working alongside his father, Fred Trump, young Donald Trump was part of a real estate business that discriminated against minority applicants. \nAs part of an investigation by NBC News, Stanley Leibowitz, who worked as a rental agent for the Trump Organization, told the news network that he personally witnessed the elder Trump explicitly lay out a racist policy for their apartment properties. \nIn the interview, Leibowitz said that Trump told him “I don’t rent to the n-word,” and indicates that Trump made this statement with Donald Trump in the room and that the younger Trump affirmed the policy. \nThe revelation comes at the same time that the Clinton campaign has released a video highlighting Trump’s run-in with the federal government over discrimination. \nUndercover investigators were sent to Trump properties, and there they repeatedly ran into a policy where black applicants with identical financial backgrounds to white applicants were systematically denied housing. The white applicants were allowed into the Trump properties. \nOne bit of testimony determined that Trump property managers indicated applications from blacks by putting a “C” on the documents for “colored,” and that was a sign that they should be denied. \nThe Trumps denied the allegation, but later settled with the government over the policy without admitting wrongdoing. \nDonald Trump’s involvement with his father’s business is key to the entire story of his rise to prominence in the real estate world and the media, as is his father’s $14 million dollars that he gave to Trump to start his business. But if you accept that, the Trump Organization’s history of racial discrimination and the legal entanglements that come with that are also part of the story, and no matter how Trump may try to wave it away – it’s still there. \nFeatured image via screen capture Share this Article! Author: Oliver Willis I was one of the first political bloggers in the world (since 2000), and was among the first bloggers to interview President Obama at the White House. I am on Twitter @owillis and write at OliverWillis.com Search ",
		"thread_title": "‘I Don’t Rent To N s’: Smoking Gun Proves Trump Family Racism (VIDEO) | Addicting Info | The Knowledge You Crave",
		"title": "‘I Don’t Rent To N s’: Smoking Gun Proves Trump Family Racism (VIDEO) | Addicting Info | The Knowledge You Crave",
		"type": "bias",
		"uuid": "512b10f6c4f4a9fb564eb08862192bbe1959550c"
	},
	"-KhIb68OkUSHglJQd7tc": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T03:57:05.546+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0dzqp5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump,_Jr."
				},
				"name": "Donald Trump Jr",
				"salience": 0.20926851,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.14786166,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.09045385,
				"type": "PERSON"
			},
			{
				"name": "Conover Kennard Conover",
				"salience": 0.06936453,
				"type": "PERSON"
			},
			{
				"name": "Mekler",
				"salience": 0.06202156,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.047511507,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.03974941,
				"type": "OTHER"
			},
			{
				"name": "Scott Melker",
				"salience": 0.028419089,
				"type": "PERSON"
			},
			{
				"name": "pictures",
				"salience": 0.01801711,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Donald Jr.",
				"salience": 0.014036225,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.010332023,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.009332137,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g8309",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump"
				},
				"name": "Trumps",
				"salience": 0.009111722,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0081965225,
				"type": "OTHER"
			},
			{
				"name": "bills",
				"salience": 0.008084438,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.008084438,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.008084438,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.008084438,
				"type": "OTHER"
			},
			{
				"name": "camera",
				"salience": 0.008084438,
				"type": "OTHER"
			},
			{
				"name": "toys",
				"salience": 0.008084438,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "decor",
				"salience": 0.008084438,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.008084438,
				"type": "LOCATION"
			},
			{
				"name": "Diaper Don",
				"salience": 0.005446702,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.005196909,
				"type": "PERSON"
			},
			{
				"name": "Barron",
				"salience": 0.004981202,
				"type": "LOCATION"
			},
			{
				"name": "father",
				"salience": 0.0046125334,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0046125334,
				"type": "PERSON"
			},
			{
				"name": "temperament",
				"salience": 0.0042616352,
				"type": "OTHER"
			},
			{
				"name": "jersey",
				"salience": 0.0037828928,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0037664513,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.0036454,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.003509456,
				"type": "PERSON"
			},
			{
				"name": "animosity",
				"salience": 0.0033327716,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0033327716,
				"type": "OTHER"
			},
			{
				"name": "reality show star",
				"salience": 0.0033327716,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.0032352556,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0032352556,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0031145872,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0031145872,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0029890055,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0029890055,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.0026989565,
				"type": "OTHER"
			},
			{
				"name": "classmates",
				"salience": 0.0026989565,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0026989565,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0026082704,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0025982698,
				"type": "LOCATION"
			},
			{
				"name": "room",
				"salience": 0.0025982698,
				"type": "LOCATION"
			},
			{
				"name": "memory",
				"salience": 0.0024588075,
				"type": "OTHER"
			},
			{
				"name": "drunk",
				"salience": 0.0024278406,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.0023372583,
				"type": "PERSON"
			},
			{
				"name": "floor",
				"salience": 0.0023372583,
				"type": "LOCATION"
			},
			{
				"name": "real estate magnate",
				"salience": 0.0022500525,
				"type": "PERSON"
			},
			{
				"name": "glimpse",
				"salience": 0.0022500525,
				"type": "OTHER"
			},
			{
				"name": "baseball game",
				"salience": 0.0022500525,
				"type": "EVENT"
			},
			{
				"name": "friends",
				"salience": 0.0022500525,
				"type": "PERSON"
			},
			{
				"name": "freshman dorm",
				"salience": 0.0022500525,
				"type": "OTHER"
			},
			{
				"name": "drinking",
				"salience": 0.0022035674,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.0022035674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07tds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Pennsylvania"
				},
				"name": "University of Pennsylvania",
				"salience": 0.0020519437,
				"type": "ORGANIZATION"
			},
			{
				"name": "nickname",
				"salience": 0.0020074612,
				"type": "PERSON"
			},
			{
				"name": "arm",
				"salience": 0.0019082066,
				"type": "OTHER"
			},
			{
				"name": "sling",
				"salience": 0.0019082066,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0019082066,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0019082066,
				"type": "OTHER"
			},
			{
				"name": "campus",
				"salience": 0.0019082066,
				"type": "LOCATION"
			},
			{
				"name": "tendency",
				"salience": 0.0019082066,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0018369972,
				"type": "OTHER"
			},
			{
				"name": "temper",
				"salience": 0.001823265,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0017910057,
				"type": "OTHER"
			},
			{
				"name": "tea partiers",
				"salience": 0.0016462617,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt41",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Yankees"
				},
				"name": "Yankee",
				"salience": 0.0014387941,
				"type": "ORGANIZATION"
			},
			{
				"name": "Author",
				"salience": 0.0014255572,
				"type": "PERSON"
			},
			{
				"name": "Share",
				"salience": 0.0014255572,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0014255572,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hobby",
				"salience": 0.0014255572,
				"type": "OTHER"
			},
			{
				"name": "takeover",
				"salience": 0.0014255572,
				"type": "EVENT"
			},
			{
				"name": "Photo",
				"salience": 0.0014255572,
				"type": "WORK_OF_ART"
			},
			{
				"name": "drinking problem",
				"salience": 0.0014255572,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0011990358,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.0011990358,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0011542784,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0011491226,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0010382629,
				"type": "OTHER"
			},
			{
				"name": "arseholes",
				"salience": 0.0010382629,
				"type": "OTHER"
			},
			{
				"name": "tears",
				"salience": 0.0010382629,
				"type": "OTHER"
			},
			{
				"name": "wings",
				"salience": 0.0010382629,
				"type": "OTHER"
			},
			{
				"name": "flies",
				"salience": 0.0010382629,
				"type": "OTHER"
			},
			{
				"name": "Search",
				"salience": 0.0010382629,
				"type": "OTHER"
			},
			{
				"name": "temperament",
				"salience": 0.00099203,
				"type": "OTHER"
			},
			{
				"name": "Jade Helm15",
				"salience": 0.00087743375,
				"type": "PERSON"
			},
			{
				"name": "Saul Loeb-Pool",
				"salience": 0.00087743375,
				"type": "PERSON"
			},
			{
				"name": "Getty",
				"salience": 0.00087743375,
				"type": "ORGANIZATION"
			},
			{
				"name": "beds",
				"salience": 0.00077558163,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00077558163,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00077558163,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.00077558163,
				"type": "OTHER"
			},
			{
				"name": "decency",
				"salience": 0.00077558163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0148d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-communism"
				},
				"name": "Commie",
				"salience": 0.00073798303,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservative_Party_(UK)"
				},
				"name": "Conservative",
				"salience": 0.0006390143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0006390143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07pncwk"
				},
				"name": "Marxist",
				"salience": 0.0006390143,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/043njm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Communist_Party_of_India_(Maoist)"
				},
				"name": "Maoist",
				"salience": 0.0006390143,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07pghgr"
				},
				"name": "Socialist",
				"salience": 0.0006390143,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07q3j97"
				},
				"name": "South",
				"salience": 0.0006390143,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0005301219,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0004773235,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-04T23:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0.02",
		"text": "on November 4, 2016 12:25 pm · \nWe’ve all seen pictures of the Trumps in their home surrounded by tacky gold decor, complete with their young son Barron in a suit with toys in front of him while he stares at the camera off to the side of his parents. It’s a life most of us can never imagine while we’re paying our monthly bills. So what’s it like growing up with Donald Trump as a father? According to Scott Melker, a former classmate of Donald Trump Jr.’s, at the University of Pennsylvania, being the former reality show star’s son wasn’t what one might imagine. Or, given Trump’s temperament, it might be exactly what you’d imagine. \nOn Facebook , Mekler told of the animosity Trump’s son had for this father. \n“I was hanging out in a freshman dorm with some friends, next door to Donald Jr.’s room. I walked out of the room to find Donald Trump at his son’s door, there to pick him up for a baseball game,” he recalls. “There were quite a few students standing around watching, trying to catch a glimpse of the famed real estate magnate. Don Jr. opened the door, wearing a Yankee jersey.” \nThen Mekler told of the moment Trump slapped his son in the face in front of others. \n“Without saying a word, his father slapped him across the face, knocking him to the floor in front of all of his classmates. He simply said “put on a suit and meet me outside,” and closed the door,” Melker wrote. \n“Donald Jr. was a drunk in college. Every memory I have of him is of him stumbling around campus falling over or passing out in public, with his arm in a sling from injuring himself while drinking,” he continued. “He absolutely despised his father, and hated the attention that his last name afforded him. His nickname was “Diaper Don,” because of his tendency to fall asleep drunk in other people’s beds and urinate.” “I always felt terrible for him,” he continued. \nMekler said part of his reason for voting for Hillary Clinton is because “in light of what I saw that day, it is clear to me that Donald Trump lacks the temperament and basic social decency to run our country.” \nTo be clear, we are not demonizing Trump’s son for having an alleged drinking problem during his college days. Whether Melker’s story is accurate or not, we’re not sure, but given Trump’s awful temper, it’s difficult to discount it. \nPhoto by Saul Loeb-Pool via Getty. Share this Article! Share on Facebook Author: Conover Kennard Conover makes tea partiers cry as a hobby. She was Commander of Jade Helm15 during the failed takeover of the South. She's also one of the biggest arseholes on Twitter. At night, she can be found drinking Conservative tears while pulling off the wings of flies just because she can. She is the founder of a Marxist, Commie, Maoist, Socialist site and has contributed to several other sites, blah blah blah. She is an awful person but she doesn't like to brag about that. Search ",
		"thread_title": "Former Classmate: Trump Smacked His Son So Hard It Knocked ‘Him To The Floor’ | Addicting Info | The Knowledge You Crave",
		"title": "Former Classmate: Trump Smacked His Son So Hard It Knocked ‘Him To The Floor’ | Addicting Info | The Knowledge You Crave",
		"type": "bias",
		"uuid": "1fd7c9a718708972572b7246e6f445e0ad835049"
	},
	"-KhIb6SbdVeGbJCuWI_E": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:26:15.936+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04hfnv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Melania_Trump"
				},
				"name": "Melania Trump",
				"salience": 0.70484835,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.034561295,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.021149691,
				"type": "LOCATION"
			},
			{
				"name": "Shannon Barber Shannon Barber",
				"salience": 0.018711753,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.017351665,
				"type": "LOCATION"
			},
			{
				"name": "wall",
				"salience": 0.012639055,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.009348598,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.009288375,
				"type": "OTHER"
			},
			{
				"name": "hypocrite",
				"salience": 0.006506389,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.006213921,
				"type": "PERSON"
			},
			{
				"name": "stance",
				"salience": 0.005636733,
				"type": "OTHER"
			},
			{
				"name": "deportation forces",
				"salience": 0.0052914396,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.0052914396,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0052914396,
				"type": "PERSON"
			},
			{
				"name": "hardline",
				"salience": 0.0052914396,
				"type": "OTHER"
			},
			{
				"name": "ledgers",
				"salience": 0.005125975,
				"type": "OTHER"
			},
			{
				"name": "entry",
				"salience": 0.004566688,
				"type": "OTHER"
			},
			{
				"name": "work visa",
				"salience": 0.0035191115,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.003291844,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.0032715867,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.0032603785,
				"type": "ORGANIZATION"
			},
			{
				"name": "visa",
				"salience": 0.003220673,
				"type": "OTHER"
			},
			{
				"name": "visa",
				"salience": 0.003220673,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "Associated Press",
				"salience": 0.0031221309,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0027894105,
				"type": "LOCATION"
			},
			{
				"name": "agency",
				"salience": 0.0025994931,
				"type": "ORGANIZATION"
			},
			{
				"name": "visitor",
				"salience": 0.0025188648,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0022374273,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0022110594,
				"type": "OTHER"
			},
			{
				"name": "B1",
				"salience": 0.002181447,
				"type": "OTHER"
			},
			{
				"name": "immigration laws",
				"salience": 0.002181447,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0019813897,
				"type": "WORK_OF_ART"
			},
			{
				"name": "blessing",
				"salience": 0.0019463504,
				"type": "OTHER"
			},
			{
				"name": "immigration story",
				"salience": 0.001883465,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001883465,
				"type": "LOCATION"
			},
			{
				"name": "work visa",
				"salience": 0.0018445639,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0017733942,
				"type": "PERSON"
			},
			{
				"name": "entrepreneur",
				"salience": 0.0017665952,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0017006921,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0016520699,
				"type": "PERSON"
			},
			{
				"name": "contract",
				"salience": 0.0016299362,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0015691262,
				"type": "OTHER"
			},
			{
				"name": "abundance",
				"salience": 0.0015298505,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0015298505,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0015298505,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0015298505,
				"type": "OTHER"
			},
			{
				"name": "stump speech",
				"salience": 0.0015298505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.0015298505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0014941505,
				"type": "LOCATION"
			},
			{
				"name": "bid",
				"salience": 0.001472771,
				"type": "OTHER"
			},
			{
				"name": "green card",
				"salience": 0.001472771,
				"type": "OTHER"
			},
			{
				"name": "modeling assignments",
				"salience": 0.001472771,
				"type": "OTHER"
			},
			{
				"name": "modeling agency",
				"salience": 0.0014423447,
				"type": "ORGANIZATION"
			},
			{
				"name": "visitor",
				"salience": 0.0014423447,
				"type": "PERSON"
			},
			{
				"name": "visa",
				"salience": 0.0013781488,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06t8v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slovenia"
				},
				"name": "Slovenia",
				"salience": 0.0013431008,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0012974339,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.001249019,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.001249019,
				"type": "OTHER"
			},
			{
				"name": "work practices",
				"salience": 0.001249019,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0011934211,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0011934211,
				"type": "WORK_OF_ART"
			},
			{
				"name": "image",
				"salience": 0.0010775647,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wife",
				"salience": 0.0010775647,
				"type": "PERSON"
			},
			{
				"name": "hypocrisy",
				"salience": 0.0010775647,
				"type": "OTHER"
			},
			{
				"name": "wrongdoing",
				"salience": 0.0010458932,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.0010197057,
				"type": "OTHER"
			},
			{
				"name": "height",
				"salience": 0.0009941736,
				"type": "OTHER"
			},
			{
				"name": "immigration law",
				"salience": 0.00093310355,
				"type": "OTHER"
			},
			{
				"name": "con",
				"salience": 0.00093310355,
				"type": "PERSON"
			},
			{
				"name": "demagogue",
				"salience": 0.00093310355,
				"type": "OTHER"
			},
			{
				"name": "hypnotism",
				"salience": 0.00093310355,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00093310355,
				"type": "OTHER"
			},
			{
				"name": "dealings",
				"salience": 0.00093310355,
				"type": "OTHER"
			},
			{
				"name": "cover-ups",
				"salience": 0.00093310355,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00093310355,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.00090578076,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.00089900853,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00087578286,
				"type": "OTHER"
			},
			{
				"name": "women's rights",
				"salience": 0.0008692348,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0008692348,
				"type": "OTHER"
			},
			{
				"name": "LGBT rights",
				"salience": 0.0008692348,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00078483444,
				"type": "OTHER"
			},
			{
				"name": "Share",
				"salience": 0.00078483444,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.000781329,
				"type": "OTHER"
			},
			{
				"name": "Metropolitan International Management",
				"salience": 0.00076883653,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizenship",
				"salience": 0.00070288166,
				"type": "OTHER"
			},
			{
				"name": "Search",
				"salience": 0.0006796006,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0006796006,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mind",
				"salience": 0.0006796006,
				"type": "OTHER"
			},
			{
				"name": "Author",
				"salience": 0.0006796006,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0006796006,
				"type": "LOCATION"
			},
			{
				"name": "activist",
				"salience": 0.0006796006,
				"type": "PERSON"
			},
			{
				"name": "equality",
				"salience": 0.0006796006,
				"type": "OTHER"
			},
			{
				"name": "lesbians",
				"salience": 0.0006796006,
				"type": "PERSON"
			},
			{
				"name": "humor blog",
				"salience": 0.0006796006,
				"type": "OTHER"
			},
			{
				"name": "websites",
				"salience": 0.0006796006,
				"type": "OTHER"
			},
			{
				"name": "computer science",
				"salience": 0.0006796006,
				"type": "OTHER"
			},
			{
				"name": "``other",
				"salience": 0.0006493388,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.0006493388,
				"type": "OTHER"
			},
			{
				"name": "Alex Wong",
				"salience": 0.0005743297,
				"type": "PERSON"
			},
			{
				"name": "path",
				"salience": 0.00050766213,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00050766213,
				"type": "OTHER"
			},
			{
				"name": "immigration fraud",
				"salience": 0.00050766213,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.00050766213,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.00048305187,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0004182715,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0003514248,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "4",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/07/GettyImages-577294844-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-05T05:26:15.936+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.8,
			"score": 0
		},
		"shares": "4",
		"site_url": "addictinginfo.org",
		"spam_score": "0.039",
		"text": "on November 4, 2016 10:58 pm · \nGOP presidential nominee Donald Trump has taken a ridiculously hardline – and even bigoted – stance on immigration. He has promised to build a wall and force Mexico to pay for it, and he has said that he will erect “deportation forces” to root out and get rid of all people in the United States without proper documentation. Well, as we already knew, it turns out that The Donald is the ultimate hypocrite on this one. \nAccording to the Associated Press , it turns out that Donald Trump’s wife Melania violated immigration laws by working illegally in the United States when she first arrived from her native Slovenia. Melania often modeled using just her first name, and was first granted entry into the country on a visitor’s visa, known as a B1/B2 visa. This occurred on August 27, 1996. Melania did not get a legal work visa until October 18, 1996. During the time when she was prohibited from working in the country, Melania made money on ten different modeling assignments, totaling upwards of $20,000. She got a green card in 2000, and became a naturalized citizen in 2006. \nSo, in other words, Melania Trump lied about her immigration story, as recently as Thursday, when she once again touted how a million percent legal immigration is the only way to go, and that this is how she did it. Melania said, in part, in her stump speech: \n“As a young entrepreneur, I wanted to follow my dream to a place where freedom and opportunity were in abundance. So of course, I came here. Living and working in America was a true blessing, but I wanted something more. I wanted to be an American.” \nWell, it appears that, as has long been suspected, that Melania Trump wasn’t as kosher in her immigration and work practices as she claims. The information obtained by the AP include, but are not limited to, her contract from Metropolitan International Management – a modeling agency. Also, there’s the ledgers from the agency, which is no longer in business, that shows Melania working during the time when she had the visitor’s visa, but no work visa. It seems to be a complicated story full of many attempts to cover up Melania’s wrongdoing, but it is certainly quite interesting. This would be why Melania Trump never released actual records regarding her initial immigration to the United States and her eventual path to citizenship. While it is unlikely that her citizenship is at risk, it certainly means that she committed immigration fraud. You can read more here at the Associated Press . \nThe long and short of it is this: Donald Trump launched his crazy bid for the presidency preying on the fears of the “other.” Namely, immigrants. That is the height of hypocrisy, seeing as how his own wife didn’t completely comply with immigration law. Hopefully this story, and the many other lies and cover-ups and shady dealings surrounding the Trump campaign break through the hypnotism that the demagogue has spun onto so many desperate citizens of this great country, and they figure out that they are falling for the biggest con of all time. \nFeatured image via Alex Wong/Getty Images Share this Article! Share on Facebook Author: Shannon Barber Shannon Barber is a self- described queer feminist and activist for racial equality, LGBT rights, women’s rights, and secular rights in America. She is a lifelong lover of words, though her educational background is in computer science. She currently writes for 2 liberal websites, and keeps her own humor blog for lesbians. She hopes to change the world, one mind at a time. Search ",
		"thread_title": "BREAKING: Melania Trump’s Immigration Records Made Public, Show Trump’s ULTIMATE Hypocrisy | Addicting Info | The Knowledge You Crave",
		"title": "BREAKING: Melania Trump’s Immigration Records Made Public, Show Trump’s ULTIMATE Hypocrisy | Addicting Info | The Knowledge You Crave",
		"type": "bias",
		"uuid": "787d6b67fbb3365bfcab0eb53be5f311381c8ca6"
	},
	"-KhIb6hAfartdIy8rUL6": {
		"author": "",
		"comments": "1",
		"country": "FR",
		"crawled": "2016-11-05T09:26:32.575+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"name": "Michael Robert Kubek",
				"salience": 0.2033312,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.15397264,
				"type": "PERSON"
			},
			{
				"name": "kids",
				"salience": 0.10441551,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.0769358,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.07094664,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.062573634,
				"type": "PERSON"
			},
			{
				"name": "teenagers",
				"salience": 0.03267273,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.021532906,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.017238393,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.017172705,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.012487697,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.010258355,
				"type": "OTHER"
			},
			{
				"name": "felonies",
				"salience": 0.010258355,
				"type": "OTHER"
			},
			{
				"name": "gun",
				"salience": 0.009143613,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "benefit",
				"salience": 0.008815015,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.008250131,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vrkz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allen_Park,_Michigan"
				},
				"name": "Allen Park",
				"salience": 0.0080824485,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.007299673,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.006384059,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.006146257,
				"type": "LOCATION"
			},
			{
				"name": "sign",
				"salience": 0.0054101422,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0052137794,
				"type": "PERSON"
			},
			{
				"name": "hearing",
				"salience": 0.0050521474,
				"type": "EVENT"
			},
			{
				"name": "supporters",
				"salience": 0.004885645,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.004382014,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.004382014,
				"type": "PERSON"
			},
			{
				"name": "whatever",
				"salience": 0.004285364,
				"type": "OTHER"
			},
			{
				"name": "lawn",
				"salience": 0.0042314352,
				"type": "LOCATION"
			},
			{
				"name": "gunpoint",
				"salience": 0.0042314352,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.0042186547,
				"type": "PERSON"
			},
			{
				"name": "scene",
				"salience": 0.004196906,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.003909949,
				"type": "PERSON"
			},
			{
				"name": "park",
				"salience": 0.003795135,
				"type": "LOCATION"
			},
			{
				"name": "involvement",
				"salience": 0.0035438482,
				"type": "OTHER"
			},
			{
				"name": "grass",
				"salience": 0.0032991774,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.0032991774,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.0029678512,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0029678512,
				"type": "OTHER"
			},
			{
				"name": "birthday celebration",
				"salience": 0.0029678512,
				"type": "EVENT"
			},
			{
				"name": "corner",
				"salience": 0.0028571482,
				"type": "LOCATION"
			},
			{
				"name": "any",
				"salience": 0.0027981366,
				"type": "OTHER"
			},
			{
				"name": "grass",
				"salience": 0.0027981366,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0025061301,
				"type": "PERSON"
			},
			{
				"name": "social media",
				"salience": 0.0024231693,
				"type": "OTHER"
			},
			{
				"name": "shock",
				"salience": 0.0024231693,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0024231693,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.0023926517,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.002268206,
				"type": "ORGANIZATION"
			},
			{
				"name": "pistol",
				"salience": 0.002120884,
				"type": "PERSON"
			},
			{
				"name": "type",
				"salience": 0.0019288415,
				"type": "OTHER"
			},
			{
				"name": "screams",
				"salience": 0.0019045445,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0018748677,
				"type": "PERSON"
			},
			{
				"name": "gun owner",
				"salience": 0.0018103764,
				"type": "PERSON"
			},
			{
				"name": "firearms",
				"salience": 0.0018103764,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "person",
				"salience": 0.0018103764,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0018103764,
				"type": "ORGANIZATION"
			},
			{
				"name": "officer",
				"salience": 0.0017156579,
				"type": "PERSON"
			},
			{
				"name": "image",
				"salience": 0.0015227497,
				"type": "WORK_OF_ART"
			},
			{
				"name": "issues",
				"salience": 0.0015227497,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0015227497,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0015227497,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0015227497,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0015227497,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0014968499,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rj9cy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_News-Herald_(Southgate,_Michigan)"
				},
				"name": "The News-Herald",
				"salience": 0.0014917144,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.001454957,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.001454957,
				"type": "PERSON"
			},
			{
				"name": "human rights",
				"salience": 0.0013185975,
				"type": "OTHER"
			},
			{
				"name": "Search",
				"salience": 0.0013185975,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.0013185975,
				"type": "OTHER"
			},
			{
				"name": "magazine",
				"salience": 0.0013185975,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Author",
				"salience": 0.0013185975,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.0013185975,
				"type": "WORK_OF_ART"
			},
			{
				"name": "gun",
				"salience": 0.0012598889,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "man",
				"salience": 0.0012598889,
				"type": "PERSON"
			},
			{
				"name": "passion",
				"salience": 0.0010901999,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0009850233,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009850233,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.0009372758,
				"type": "ORGANIZATION"
			},
			{
				"name": "website",
				"salience": 0.0009013487,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0008567647,
				"type": "OTHER"
			},
			{
				"name": "Vera My",
				"salience": 0.00081159035,
				"type": "PERSON"
			},
			{
				"name": "Addicting Info",
				"salience": 0.00081159035,
				"type": "OTHER"
			},
			{
				"name": "Joe Raedle",
				"salience": 0.00081159035,
				"type": "PERSON"
			},
			{
				"name": "Allen Park Police Department",
				"salience": 0.00081159035,
				"type": "ORGANIZATION"
			},
			{
				"name": "officer",
				"salience": 0.00069729576,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "4",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/11/Trump-2.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-05T03:45:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7,
			"score": -0.1
		},
		"shares": "4",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 4, 2016 4:45 pm · \nIf you had wanted to give Trump supporters the benefit of the doubt, this most recent incident proves that it’s far too much to give them. \nA 56-year-old man in Allen Park, Michigan has just been charged with six felonies after he held six children at gunpoint because he thought they’d damaged the Donald Trump sign on his lawn. Yes, this is the kind of deranged, emotionally unstable supporters Trump has attracted. \nThe man, Michael Robert Kubek, had called police on October 29th to report that his Trump sign had been hit by teenagers, who had fled the scene. When the police arrived at the scene, they didn’t find Kubek at his home – however, when the officers followed the screams coming from around the corner, there he was. \nThe police saw Kubek standing over six children ages 12-14, who were sitting on the grass. Kubek accused the children of destroying his sign despite the fact that he never actually witnessed them doing it. The children denied any involvement, and the officers told Kubek to return to his house so they could speak to the children. \nAccording to the kids, they were simply on their way to the park for a birthday celebration when Kubek had pulled out a gun and pointed it at them, instructing them to sit down on the grass. Those witnessing the act took to social media to vent their shock: Twitter Twitter \nThe News-Herald reported: \n“The officer asked him again if he could identify any of the kids as the one who damaged his sign, but Kubek repeated that he could not. The officer then asked Kubek if he pulled out a pistol and pointed it at the kids. According to police, Kubek said “yes.” \nIn response to another question from the officer, Kubek said he felt threatened because he was outnumbered.” \nYes, a grown man used a gun because he felt “outnumbered” by a small group of innocent kids. This is EXACTLY the type of unhinged person who shouldn’t be trusted with firearms! Kubek’s hearing is scheduled for December 5th – let’s hope that whatever happens to Kubek, that he is no longer considered a responsible gun owner. You can watch a report below: \nFeatured image via Allen Park Police Department and Joe Raedle / Getty Images Share this Article! Author: Vera My passion is bringing attention to human rights and equality issues. In addition to writing for Addicting Info, I also run a website and digital magazine dedicated to social issues and promoting equality in all forms. Search",
		"thread_title": "Unhinged Trump Supporter Holds Children AT GUNPOINT Over Damaged Trump Sign (VIDEO)",
		"title": "Unhinged Trump Supporter Holds Children AT GUNPOINT Over Damaged Trump Sign (VIDEO)",
		"type": "bias",
		"uuid": "6e728a65950c4f686a534dffea96efdc52ce4d72"
	},
	"-KhIb6rEsdjVra38FAUz": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-06T03:50:10.374+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.20439857,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01mpq7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beyonc%C3%A9"
				},
				"name": "Beyoncé",
				"salience": 0.1444523,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.07049899,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vw20h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jay_Z"
				},
				"name": "Jay Z",
				"salience": 0.067507416,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.04550746,
				"type": "PERSON"
			},
			{
				"name": "possibilities",
				"salience": 0.043254092,
				"type": "OTHER"
			},
			{
				"name": "Sarah Sarah",
				"salience": 0.03560823,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.03511329,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.033676557,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.029679738,
				"type": "LOCATION"
			},
			{
				"name": "concert",
				"salience": 0.027342439,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03f771p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Big_Sean"
				},
				"name": "Big Sean",
				"salience": 0.016877048,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rfdsvp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chance_the_Rapper"
				},
				"name": "Chance the Rapper",
				"salience": 0.016877048,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.016877048,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.01630545,
				"type": "EVENT"
			},
			{
				"name": "nephew",
				"salience": 0.012348573,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.011724155,
				"type": "PERSON"
			},
			{
				"name": "gender",
				"salience": 0.010881875,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.009761249,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.009761249,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.009761249,
				"type": "PERSON"
			},
			{
				"name": "Free Wood Post",
				"salience": 0.008794994,
				"type": "WORK_OF_ART"
			},
			{
				"name": "something",
				"salience": 0.008134378,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.007931043,
				"type": "PERSON"
			},
			{
				"name": "mold",
				"salience": 0.007931043,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.007635511,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.007635511,
				"type": "EVENT"
			},
			{
				"name": "path",
				"salience": 0.007635511,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.007635511,
				"type": "OTHER"
			},
			{
				"name": "inception",
				"salience": 0.0064767394,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.0064767394,
				"type": "OTHER"
			},
			{
				"name": "Photo",
				"salience": 0.0063147647,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.0051003294,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.004839902,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Author",
				"salience": 0.004839902,
				"type": "PERSON"
			},
			{
				"name": "@Beyonce",
				"salience": 0.004124967,
				"type": "OTHER"
			},
			{
				"name": "Search",
				"salience": 0.003525788,
				"type": "OTHER"
			},
			{
				"name": "Editor-in-Chief",
				"salience": 0.003525788,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.003525788,
				"type": "OTHER"
			},
			{
				"name": "@kharyp",
				"salience": 0.0034411117,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.0029799126,
				"type": "ORGANIZATION"
			},
			{
				"name": "Justin Sullivan",
				"salience": 0.0029799126,
				"type": "PERSON"
			},
			{
				"name": "Khary Penebaker",
				"salience": 0.0029799126,
				"type": "PERSON"
			},
			{
				"name": "ImWithHer",
				"salience": 0.0029799126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0021704983,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0021704983,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/11/GettyImages-621177134.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-06T03:50:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 5, 2016 4:50 pm · \nAppearing at a concert for Hillary Clinton in Ohio alongside Chance the Rapper, Big Sean and her husband Jay Z, Beyoncé let us all know why she’s “with her.” \nAfter explaining that she was so happy her nephew got to have Barack Obama to look up to and know he could one day be president, Beyoncé then explained that this election is continuing on that path of progress. She explained that gender goes beyond that of any religion or race, and electing the first woman president is something she wants for her daughter. She said: \n“I want my daughter to grow up seeing a woman lead our country and know that her possibilities are limitless.” \nElecting Hillary Clinton would break the mold of the United States being led by only men since its inception. However, that’s clearly not the only reason to elect Hillary. She is, by far, the most qualified person to run for President of the United States in more than a century. \nWatch Beyoncé explain why she’s “with her” here: “I want my daughter to grow up seeing a woman lead our country & know that her possibilities are limitless”– @Beyonce #ImWithHer pic.twitter.com/eXRJn04QiJ \n— Khary Penebaker (@kharyp) November 5, 2016 \nFeatured Photo by Justin Sullivan/Getty Images Share this Article! Author: Sarah Sarah is a liberal writer who's been writing and commenting on politics for over 5 years as the Opinionated Democrat on Facebook. She is also the founder and Editor-in-Chief of the online satirical publication Free Wood Post. Search",
		"thread_title": "Watch Beyoncé Tell The Entire World Why She Supports Hillary; Grab Your Tissues (VIDEO)",
		"title": "Watch Beyoncé Tell The Entire World Why She Supports Hillary; Grab Your Tissues (VIDEO)",
		"type": "bias",
		"uuid": "7f1e8efb04daa87139bc0884c71f48591079d4b5"
	},
	"-KhIb7L_69SctY2uroZx": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T00:26:58.297+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"name": "Har de har har -- Trump",
				"salience": 0.31441408,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.10028325,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.04376011,
				"type": "PERSON"
			},
			{
				"name": "liar",
				"salience": 0.03749673,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.02186888,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.021803198,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.013471354,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.010811539,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.010149295,
				"type": "OTHER"
			},
			{
				"name": "liars",
				"salience": 0.008350663,
				"type": "OTHER"
			},
			{
				"name": "liars",
				"salience": 0.008350663,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00804473,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00804473,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00804473,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0062161065,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/011m14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toronto_Star"
				},
				"name": "Toronto Star",
				"salience": 0.0061415173,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.00608072,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0060353233,
				"type": "EVENT"
			},
			{
				"name": "Falsely",
				"salience": 0.005984393,
				"type": "PERSON"
			},
			{
				"name": "lies",
				"salience": 0.0057279905,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0054500983,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thing",
				"salience": 0.0054500983,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0054500983,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0054500983,
				"type": "OTHER"
			},
			{
				"name": "Rika Christensen Rika Christensen",
				"salience": 0.0053235553,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0047201775,
				"type": "PERSON"
			},
			{
				"name": "bullying",
				"salience": 0.0047201775,
				"type": "OTHER"
			},
			{
				"name": "spread",
				"salience": 0.0047201775,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.0047201775,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hundreds",
				"salience": 0.0047201775,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0047201775,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0040618964,
				"type": "PERSON"
			},
			{
				"name": "Polls",
				"salience": 0.003974015,
				"type": "OTHER"
			},
			{
				"name": "master liar",
				"salience": 0.003666659,
				"type": "OTHER"
			},
			{
				"name": "Nobody",
				"salience": 0.003617544,
				"type": "PERSON"
			},
			{
				"name": "reporters",
				"salience": 0.0035745737,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.0034576615,
				"type": "ORGANIZATION"
			},
			{
				"name": "master liar",
				"salience": 0.0034415524,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0033152662,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0033152662,
				"type": "OTHER"
			},
			{
				"name": "Terri Lynn Rote",
				"salience": 0.0032758263,
				"type": "PERSON"
			},
			{
				"name": "cities",
				"salience": 0.003262188,
				"type": "LOCATION"
			},
			{
				"name": "few",
				"salience": 0.0031264701,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.002987683,
				"type": "OTHER"
			},
			{
				"name": "Daniel Dale",
				"salience": 0.0029064142,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0028250092,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.002799993,
				"type": "ORGANIZATION"
			},
			{
				"name": "polls",
				"salience": 0.002786945,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.002786945,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.002786945,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002691095,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.002691095,
				"type": "PERSON"
			},
			{
				"name": "Refugees",
				"salience": 0.002691095,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.002691095,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.00268296,
				"type": "OTHER"
			},
			{
				"name": "Tons",
				"salience": 0.0026019996,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0025503177,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0024861856,
				"type": "EVENT"
			},
			{
				"name": "list",
				"salience": 0.0024861856,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.0024861856,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0024861856,
				"type": "EVENT"
			},
			{
				"name": "record",
				"salience": 0.0024861856,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.0024861856,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0023958245,
				"type": "OTHER"
			},
			{
				"name": "polling",
				"salience": 0.002275339,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0022448467,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0022448467,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0022448467,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0022448467,
				"type": "OTHER"
			},
			{
				"name": "assault allegations",
				"salience": 0.0022448467,
				"type": "OTHER"
			},
			{
				"name": "Taxes",
				"salience": 0.0022448467,
				"type": "OTHER"
			},
			{
				"name": "Immigration",
				"salience": 0.0022448467,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0022448467,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0022448467,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0022006857,
				"type": "LOCATION"
			},
			{
				"name": "The Clintons",
				"salience": 0.0021916672,
				"type": "ORGANIZATION"
			},
			{
				"name": "voter suppression",
				"salience": 0.0021264043,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0wbktl"
				},
				"name": "Liar",
				"salience": 0.0021187577,
				"type": "WORK_OF_ART"
			},
			{
				"name": "many",
				"salience": 0.0020860203,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.0020283354,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.001993838,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "shape",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.0019439162,
				"type": "ORGANIZATION"
			},
			{
				"name": "categories",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "endorsements",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "Trade",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "Health care",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "Economy",
				"salience": 0.0019439162,
				"type": "OTHER"
			},
			{
				"name": "Trumpsters",
				"salience": 0.0019332846,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.001905297,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.001905297,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0018979888,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0018165712,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.0017788237,
				"type": "PERSON"
			},
			{
				"name": "Another",
				"salience": 0.0017564117,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0017432799,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0017359841,
				"type": "PERSON"
			},
			{
				"name": "problems",
				"salience": 0.0017013408,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0016984409,
				"type": "OTHER"
			},
			{
				"name": "debates",
				"salience": 0.0016782132,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0016782132,
				"type": "EVENT"
			},
			{
				"name": "voter fraud",
				"salience": 0.0015941036,
				"type": "OTHER"
			},
			{
				"name": "``other",
				"salience": 0.0015740179,
				"type": "PERSON"
			},
			{
				"name": "fraud",
				"salience": 0.0015740179,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0015740179,
				"type": "PERSON"
			},
			{
				"name": "campaign workers",
				"salience": 0.001534602,
				"type": "PERSON"
			},
			{
				"name": "claims",
				"salience": 0.0015163246,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0015152656,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0014707218,
				"type": "OTHER"
			},
			{
				"name": "poll denialism",
				"salience": 0.0014521899,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0014231696,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0014231696,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0014231696,
				"type": "EVENT"
			},
			{
				"name": "debates",
				"salience": 0.0014231696,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.0013629731,
				"type": "PERSON"
			},
			{
				"name": "fears",
				"salience": 0.0013629731,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0013629731,
				"type": "OTHER"
			},
			{
				"name": "assertions",
				"salience": 0.0013629731,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0013361525,
				"type": "LOCATION"
			},
			{
				"name": "suspicion",
				"salience": 0.0013120949,
				"type": "OTHER"
			},
			{
				"name": "mail",
				"salience": 0.0013120949,
				"type": "OTHER"
			},
			{
				"name": "fairness",
				"salience": 0.0013120949,
				"type": "OTHER"
			},
			{
				"name": "ballots",
				"salience": 0.0013120949,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0013120949,
				"type": "PERSON"
			},
			{
				"name": "populations",
				"salience": 0.0013120949,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0013120949,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rallies",
				"salience": 0.0013120949,
				"type": "EVENT"
			},
			{
				"name": "thugs",
				"salience": 0.0013120949,
				"type": "WORK_OF_ART"
			},
			{
				"name": "course",
				"salience": 0.0012849749,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0012849749,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0012757649,
				"type": "LOCATION"
			},
			{
				"name": "Inner",
				"salience": 0.0011965195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dtc1p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fuck"
				},
				"name": "WTF",
				"salience": 0.0011965195,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0011965195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0011965195,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06ng1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sex"
				},
				"name": "Sex",
				"salience": 0.0011965195,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.0011965195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021r13",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electoral_fraud"
				},
				"name": "Rigged",
				"salience": 0.0011965195,
				"type": "OTHER"
			},
			{
				"name": "lady",
				"salience": 0.0011558188,
				"type": "PERSON"
			},
			{
				"name": "catchword",
				"salience": 0.0011412533,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06jvj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lester_Holt"
				},
				"name": "Lester Holt",
				"salience": 0.0011293004,
				"type": "PERSON"
			},
			{
				"name": "legitimacy",
				"salience": 0.0011126705,
				"type": "OTHER"
			},
			{
				"name": "favour",
				"salience": 0.0011126705,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0011126705,
				"type": "OTHER"
			},
			{
				"name": "polling data",
				"salience": 0.0011126705,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0011126705,
				"type": "OTHER"
			},
			{
				"name": "liars",
				"salience": 0.0010720057,
				"type": "OTHER"
			},
			{
				"name": "liar",
				"salience": 0.0010720057,
				"type": "OTHER"
			},
			{
				"name": "Climate change",
				"salience": 0.0010711324,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0010576337,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07df1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trojan_horse_(computing)"
				},
				"name": "Trojan Horse",
				"salience": 0.0010407212,
				"type": "PERSON"
			},
			{
				"name": "lying",
				"salience": 0.0009926488,
				"type": "OTHER"
			},
			{
				"name": "apartment",
				"salience": 0.0009737895,
				"type": "LOCATION"
			},
			{
				"name": "tape",
				"salience": 0.0009737895,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sexual assault allegations",
				"salience": 0.0009598779,
				"type": "OTHER"
			},
			{
				"name": "licence",
				"salience": 0.0009555899,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.00093262445,
				"type": "PERSON"
			},
			{
				"name": "position",
				"salience": 0.0009316555,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.0008901655,
				"type": "OTHER"
			},
			{
				"name": "hoax",
				"salience": 0.0008855697,
				"type": "OTHER"
			},
			{
				"name": "nonsense",
				"salience": 0.0008855697,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00087440887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.00083887397,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0008380998,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.00083115406,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.00083115406,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.00083115406,
				"type": "OTHER"
			},
			{
				"name": "EKG",
				"salience": 0.00083115406,
				"type": "OTHER"
			},
			{
				"name": "sexual assault accuser",
				"salience": 0.00083115406,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.00083115406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06wxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Louis"
				},
				"name": "St. Louis",
				"salience": 0.0008075544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.0008075544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rczx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greeley,_Colorado"
				},
				"name": "Greeley",
				"salience": 0.0008075544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.0008075544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.0008075544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colo.",
				"salience": 0.0008075544,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.00079358375,
				"type": "OTHER"
			},
			{
				"name": "repeats",
				"salience": 0.0007900384,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0007779647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0007779647,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.00074768806,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.0007359457,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00070550205,
				"type": "PERSON"
			},
			{
				"name": "analysis",
				"salience": 0.00069904997,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.00069904997,
				"type": "OTHER"
			},
			{
				"name": "highest",
				"salience": 0.00069904997,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00069904997,
				"type": "WORK_OF_ART"
			},
			{
				"name": "image",
				"salience": 0.00069904997,
				"type": "WORK_OF_ART"
			},
			{
				"name": "paper",
				"salience": 0.00069904997,
				"type": "WORK_OF_ART"
			},
			{
				"name": "more",
				"salience": 0.00069904997,
				"type": "OTHER"
			},
			{
				"name": "family members",
				"salience": 0.00066994305,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.0006644678,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0006260377,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0006260377,
				"type": "PERSON"
			},
			{
				"name": "myth",
				"salience": 0.00060529716,
				"type": "OTHER"
			},
			{
				"name": "squillion",
				"salience": 0.00060529716,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00060529716,
				"type": "LOCATION"
			},
			{
				"name": "Search",
				"salience": 0.00060529716,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.00060529716,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Author",
				"salience": 0.00060529716,
				"type": "PERSON"
			},
			{
				"name": "fit",
				"salience": 0.00060529716,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.00058069645,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00058016053,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0005783382,
				"type": "OTHER"
			},
			{
				"name": "cholesterol",
				"salience": 0.000575352,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00056093954,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.00054241833,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0005221651,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0005221651,
				"type": "LOCATION"
			},
			{
				"name": "immigration",
				"salience": 0.0005221651,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0005221651,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.000511518,
				"type": "LOCATION"
			},
			{
				"name": "Summer Zervos",
				"salience": 0.000511518,
				"type": "PERSON"
			},
			{
				"name": "anchor",
				"salience": 0.00045213144,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00045213144,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.00045213144,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.00045213144,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.00045213144,
				"type": "OTHER"
			},
			{
				"name": "Crooked Hillary",
				"salience": 0.00043418072,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.00043020965,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chip Somodevilla",
				"salience": 0.0003725077,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq_War"
				},
				"name": "Iraq",
				"salience": 0.0003725077,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0003725077,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0003423859,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0288j83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.00032134366,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.000278242,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.000278242,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0r4qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Bernardino,_California"
				},
				"name": "San Bernardino",
				"salience": 0.000278242,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-07T00:26:58.297+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 33.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0.435",
		"text": "on November 6, 2016 3:40 pm · \nTrying to catch the liar of liars in a lie isn’t hard. Getting him and his campaign to acknowledge that Trump is the liar of liars is. Same thing with bullying, but The New York Times put together a spread of all the bullyish things Trump has said and tweeted, and to whom. Now, the Toronto Star ‘s Daniel Dale has been tracking Trump’s lies for just six weeks, and the paper has compiled a complete list of those lies, which you can find here . \nThere are literally hundreds of lies in Trump’s speeches. They’re not all 100% unique, but this is probably the final and ultimate proof that Trump will say anything to smear anyone, including his enemies, while keeping his supporters happy. \nIs there any presidential candidate in history that has lied this much? Tons of people claim Hillary is a master liar, but first, she’s actually more honest than most politicians. Second, even if she could be considered anything like a master liar, she still could not compete with Trump the Liar in any way, shape or form. \nThe Star put the lies into a whopping 20 categories: Clinton’s policies, WTF, Daesh/Middle East, Clinton’s record, African Americans/Inner cities, The Clintons’ corruption, Rigged election, Trade/Economy, Health care, Trump’s endorsements, Refugees/Immigration, Polls, Obama’s record, The campaign, Russia, Trump’s record, Taxes, Sex assault allegations, Clinton’s health and Government corruption. \nThey also compiled a list of the top 10 types of lies Trump has told and gave more detailed analysis, beginning with, “The electoral system is rigged.” Of course, it’s rigged against him: \n“After plummeting in the polls after the first two debates, Trump began to repeatedly question the fairness of the election. ‘Rigged’ became his catchword. \nHe claimed Hillary Clinton campaign workers hired ‘thugs’ to cause violence at his rallies, twisting the evidence from an undercover video to unfairly disparage Clinton. He claimed there was widespread voter fraud in Philadelphia, Chicago and St. Louis — cities with large black populations that heavily favour Democrats. \nIn Greeley, Colo., Trump told his supporters if they don’t trust mail-in ballots, they should vote again in person. So, one did. Trump supporter Terri Lynn Rote, a 55-year-old from Iowa, was charged by police for suspicion of voting twice.” \nNobody’s committing voter suppression and fraud quite like Trumpsters and Republicans. \nAnother is, “Muslims are risky.” This touches on his assertions that we know nothing about refugees coming from Syria, who could be the great Trojan Horse of our time: \n“His claims that Syrian refugees — 99 per cent are Muslim — are terrorists plays to the fears of the “other,” even though they are extensively vetted and are predominantly women and children. And their numbers is nowhere near Trump’s claims — about 13,000 have been admitted to the United States in 2016.” \n“The polls favour Trump.” Har de har har – Trump only looks at the polls he likes, and they’re usually unscientific online polls or other dubious polls. Very few of the established, scientific polls favor him. Nevertheless: \n“It seems clear Trump manipulates, exaggerates or makes up polls that make it sound as if he is doing better than he actually is. This ‘poll denialism’ gives his supporters licence to dismiss negative polling data, suggests CNN. \nHis false claims cast doubt on the legitimacy of mainstream polling — and perhaps even the vote itself. If supporters feel Trump should be doing better, then the idea of a rigged election seems more credible. \nOn Oct. 24, he said ‘I won the last two debates, and every poll showed it.’ In fact, every scientific poll showed that he lost. \nOf course, when unscientific online polls came out in his favour, Trump was quick to promote — and exaggerate — those numbers.” \nBut these are just a few of his biggest, most repeated lies. He has also: Falsely said on Twitter, “The failing NYTimes reporters don’t even call us anymore, they just write whatever they want to write, making up sources along the way!” Falsely said, “By ‘open borders,’ [Hillary] means totally unlimited immigration.” Falsely said, “Hillary’s plan includes an open border with the Middle East.” Falsely called NBC anchor Lester Holt, the moderator of the first debate, “a Democrat.” Falsely said, “Wow, just came out on secret tape that Crooked Hillary wants to take in as many Syrians as possible.” Falsely said the U.S. provided Iran “$150 billion” as part of the nuclear deal. Falsely said, “In San Bernardino, many people saw the bombs all over the apartment of the two people that killed 14 and wounded many, many people…Muslims have to report the problems when they see them.” Falsely asserted that Clinton has “been fighting ISIS (her) entire adult life.” Falsely said, “All together, the Hillary Clinton plan would bring in 620,000 refugees in her first term.” Falsely claimed he had been acknowledged to be correct in declaring NATO “obsolete because it doesn’t cover terror;” falsely suggested NATO created an anti-terror position because of his comments. Falsely claimed Clinton didn’t release cholesterol or EKG information Falsely said sexual assault allegations against him “have been largely debunked.” Falsely said, apparently of sexual assault accuser Summer Zervos, “The one young lady has five family members saying what she said is absolute nonsense.” Falsely said “I did not. I did not” to Clinton’s charge that he thinks Climate change is a “hoax perpetrated by the Chinese.” Falsely said, “I was against going into Iraq. And it’s so well-documented.” Falsely said, “Our taxes are so high. Just about the highest in the world.” \nAnd so many more, just in the last six weeks! Yes, many of them are repeats, but lies are lies. If Trump sees this, he’ll likely throw a livid fit about it and claim that the paper’s lying, and continue to sell the myth that he’s not the liar of liars being caught in a squillion lies. \nTo see the full list and detailed analysis, click here . \nFeatured image by Chip Somodevilla via Getty Images Share this Article! Author: Rika Christensen Rika Christensen is an experienced writer and loves debating politics. Engage with her and see more of her work by following her on Facebook and Twitter . Search ",
		"thread_title": "The Toronto Star Published An ‘Unauthorized Database’ Of Things That Will INFURIATE Trump | Addicting Info | The Knowledge You Crave",
		"title": "The Toronto Star Published An ‘Unauthorized Database’ Of Things That Will INFURIATE Trump | Addicting Info | The Knowledge You Crave",
		"type": "bias",
		"uuid": "7d61ba17f451b3e3634eb3cf4d09bce0d7e562a4"
	},
	"-KhIb7YjB09zmt5Uh1ni": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-07T20:54:32.813+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03qcvwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kate_McKinnon"
				},
				"name": "Kate McKinnon",
				"salience": 0.14345555,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.13520534,
				"type": "PERSON"
			},
			{
				"name": "site",
				"salience": 0.094651,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018ygt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alec_Baldwin"
				},
				"name": "Alec Baldwin",
				"salience": 0.08930263,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/039cq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saturday_Night_Live"
				},
				"name": "Saturday Night Live",
				"salience": 0.040914666,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.03458331,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.03458331,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.027086575,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.027086575,
				"type": "WORK_OF_ART"
			},
			{
				"name": "levity",
				"salience": 0.027086575,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.023878522,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.019387353,
				"type": "PERSON"
			},
			{
				"name": "bit",
				"salience": 0.017638218,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.017494667,
				"type": "OTHER"
			},
			{
				"name": "cast",
				"salience": 0.015742494,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.013490297,
				"type": "LOCATION"
			},
			{
				"name": "two",
				"salience": 0.0115470905,
				"type": "PERSON"
			},
			{
				"name": "portrayal",
				"salience": 0.011189369,
				"type": "OTHER"
			},
			{
				"name": "character",
				"salience": 0.011189369,
				"type": "PERSON"
			},
			{
				"name": "act",
				"salience": 0.011189369,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0087261535,
				"type": "WORK_OF_ART"
			},
			{
				"name": "whatever",
				"salience": 0.0087261535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.008235912,
				"type": "PERSON"
			},
			{
				"name": "lady",
				"salience": 0.007850451,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.007850451,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.007850451,
				"type": "OTHER"
			},
			{
				"name": "caffeine",
				"salience": 0.0075578284,
				"type": "OTHER"
			},
			{
				"name": "cold opener",
				"salience": 0.0075578284,
				"type": "EVENT"
			},
			{
				"name": "sugar",
				"salience": 0.0075578284,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mixture",
				"salience": 0.0075578284,
				"type": "OTHER"
			},
			{
				"name": "tweets",
				"salience": 0.0074627274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0074018366,
				"type": "WORK_OF_ART"
			},
			{
				"name": "something",
				"salience": 0.0074018366,
				"type": "OTHER"
			},
			{
				"name": "rebuke",
				"salience": 0.0064105354,
				"type": "EVENT"
			},
			{
				"name": "decision",
				"salience": 0.0064105354,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0064105354,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0064105354,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0048345514,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0047901017,
				"type": "PERSON"
			},
			{
				"name": "friendship montage",
				"salience": 0.0047901017,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0047901017,
				"type": "LOCATION"
			},
			{
				"name": "stage",
				"salience": 0.0047901017,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0047901017,
				"type": "OTHER"
			},
			{
				"name": "None",
				"salience": 0.0047901017,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0044960133,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0039472575,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "KKK",
				"salience": 0.0039472575,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.0039472575,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.003813064,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0034893176,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0034893176,
				"type": "LOCATION"
			},
			{
				"name": "facade",
				"salience": 0.0026068157,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0026068157,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/11/Untitled-2-Recovered-Recovered-2.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-06T20:03:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 6, 2016 8:03 am · \nSaturday Night Live has helped bring quite a bit of levity to this otherwise horrific election year but in the final episode before the election, before we as a nation go to the polls and decide if we want to be extraordinary or “deplorable,” the cast of Saturday Night Live could not help but drop the act and get real with America. \nIt began as it normally does, with Alec Baldwin’s masterful Donald Trump character and Kate McKinnon’s excellent portrayal of Hillary Clinton (if she spent all day every day mainlining a dangerous mixture of sugar and caffeine). \n“I never use emails,” Trump says in the cold opener. “I use a very private, very secure site where one can write whatever they want to and no one can read it It’s called Twitter.” \nAfter he is informed that everyone can see his tweets, “Trump” replies: \n“Really? And I’m still in this thing? America you must really hate this lady.” \nAfter a scathing rebuke of the media’s decision to ignore Trump’s cozy relationship with Putin, the KKK, and the FBI and instead focus on something as meaningless as Hillary Clinton’s emails, something magical happened: McKinnon and Baldwin dropped the facade and got serious. \n“I’m sorry, Kate. I just hate yelling all this stuff at you like this,” Baldwin says. “I just feel gross all the time about this. Don’t you all feel gross?” he added, addressing the audience. \nMcKinnon agrees and the two embark on a “friendship montage” through the city before returning to the stage. Then they dropped perhaps the most important message you will hear this election year. “None of this would have mattered if you don’t vote,” Baldwin says. \n“We can’t tell you who to vote for, but on Tuesday we all get a chance to choose what kind of country we want to live in,” McKinnon finishes. \nThey’re right.",
		"thread_title": "SNL Gets Real And Delivers The Most Important Message Of The Election Year (VIDEO)",
		"title": "SNL Gets Real And Delivers The Most Important Message Of The Election Year (VIDEO)",
		"type": "bias",
		"uuid": "1b9104850bec39ed6a90d185913108c87f267767"
	},
	"-KhIb8-gj77xkV9_VvM1": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-12T13:47:45.113+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.15457366,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.15252185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_pdg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lindsey_Graham"
				},
				"name": "Lindsey Graham",
				"salience": 0.11230222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07j6ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ted_Cruz"
				},
				"name": "Ted Cruz",
				"salience": 0.07168826,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.06785916,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.056956172,
				"type": "PERSON"
			},
			{
				"name": "extremist",
				"salience": 0.046531543,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.029589878,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.020818701,
				"type": "EVENT"
			},
			{
				"name": "nomination",
				"salience": 0.019568326,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07qln4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WYFF"
				},
				"name": "WYFF-TV",
				"salience": 0.019441556,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.016685687,
				"type": "ORGANIZATION"
			},
			{
				"name": "pick",
				"salience": 0.01325808,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/046w5d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Merrick_B._Garland"
				},
				"name": "Merrick Garland",
				"salience": 0.013003966,
				"type": "PERSON"
			},
			{
				"name": "extremist",
				"salience": 0.012371003,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.010748769,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.010718874,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0099636605,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.008089736,
				"type": "PERSON"
			},
			{
				"name": "puppet president",
				"salience": 0.007896024,
				"type": "PERSON"
			},
			{
				"name": "bench",
				"salience": 0.0075705335,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0066554914,
				"type": "PERSON"
			},
			{
				"name": "Senator",
				"salience": 0.0061185574,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.005977737,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.0056766565,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.0054651373,
				"type": "PERSON"
			},
			{
				"name": "nominees",
				"salience": 0.0054651373,
				"type": "PERSON"
			},
			{
				"name": "nominees",
				"salience": 0.0054651373,
				"type": "PERSON"
			},
			{
				"name": "hearing",
				"salience": 0.0043887147,
				"type": "EVENT"
			},
			{
				"name": "nominees",
				"salience": 0.0042965906,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.004292413,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0041323844,
				"type": "EVENT"
			},
			{
				"name": "mistake",
				"salience": 0.0038466936,
				"type": "OTHER"
			},
			{
				"name": "pick",
				"salience": 0.0037672746,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.003464225,
				"type": "PERSON"
			},
			{
				"name": "shake",
				"salience": 0.0032795188,
				"type": "OTHER"
			},
			{
				"name": "confirmation hearing",
				"salience": 0.00323823,
				"type": "EVENT"
			},
			{
				"name": "list",
				"salience": 0.0031013733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0027228897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06yxd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Carolina"
				},
				"name": "South Carolina",
				"salience": 0.0027228897,
				"type": "LOCATION"
			},
			{
				"name": "conservative",
				"salience": 0.0026978527,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.0026638787,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0026638787,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.002618895,
				"type": "EVENT"
			},
			{
				"name": "vacancy",
				"salience": 0.0025322041,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.002437733,
				"type": "PERSON"
			},
			{
				"name": "shakes",
				"salience": 0.0024195146,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0024195146,
				"type": "OTHER"
			},
			{
				"name": "assholes",
				"salience": 0.0018918524,
				"type": "PERSON"
			},
			{
				"name": "step",
				"salience": 0.0018918524,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0018918524,
				"type": "OTHER"
			},
			{
				"name": "Turnabout",
				"salience": 0.0017756561,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0016122453,
				"type": "ORGANIZATION"
			},
			{
				"name": "Image",
				"salience": 0.0015912867,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0166zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antonin_Scalia"
				},
				"name": "Antonin Scalia",
				"salience": 0.0015588553,
				"type": "PERSON"
			},
			{
				"name": "hearing",
				"salience": 0.0015136539,
				"type": "EVENT"
			},
			{
				"name": "play",
				"salience": 0.0014681363,
				"type": "WORK_OF_ART"
			},
			{
				"name": "LGBT rights",
				"salience": 0.0014251474,
				"type": "OTHER"
			},
			{
				"name": "women's rights",
				"salience": 0.0014251474,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0013779496,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.0013779496,
				"type": "OTHER"
			},
			{
				"name": "disrespect",
				"salience": 0.0013779496,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0013779496,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fair shake",
				"salience": 0.0013165994,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0010293651,
				"type": "OTHER"
			},
			{
				"name": "peril",
				"salience": 0.0010293651,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0010293651,
				"type": "OTHER"
			},
			{
				"name": "rulings",
				"salience": 0.0010293651,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0010293651,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.0009794688,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ethan Miller",
				"salience": 0.0008481268,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019twb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_Rights_Act_of_1964"
				},
				"name": "Civil Rights Act",
				"salience": 0.0007316589,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0fh70",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voting_Rights_Act_of_1965"
				},
				"name": "Voting Rights Act",
				"salience": 0.0007316589,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "7",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/03/GettyImages-501528656.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-12T05:06:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.5,
			"score": -0.1
		},
		"shares": "7",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 11, 2016 3:30 pm · \nAs if the election of Donald Trump couldn’t get even more disastrous and hypocritical, Senator Lindsey Graham just called on Trump to nominate a right-wing extremist to nation’s highest court. \nAll year long, Republicans have been blocking President Obama’s nomination of Merrick Garland to the Supreme Court because they want the next president to make the pick. And because they now have the conservative puppet president they have always wanted, they want to make sure that nominee is a conservative extremist. \nSouth Carolina Senator Lindsey Graham told WYFF-TV that Trump should pick Texas Senator Ted Cruz as the nominee and warned Democrats not to block him, which is hypocritical considering how Republicans have treated President Obama’s nominee and threatened to block any nominees Hillary Clinton would have made had she won the election. \n“I’m here to tell my Democratic colleagues that I voted for Obama’s nominees. I expect them to give Trump’s nominees a fair shake. He won this election. He will pick a conservative. I would put Ted Cruz on that list. If they try to block this pick, they will regret it. If you don’t honor Trump’s nominee, you’re making a huge mistake.” \nDemocrats should stand up and give Graham a collective middle finger. \nSince Antonin Scalia died in February, there has been a vacancy on the Supreme Court bench that has yet to be filled. The body wasn’t even cold yet before Republicans vowed to block any nominee President Obama picked to replace him, going so far as to even deny Garland a confirmation hearing. That’s far from the “fair shake” Graham is asking Democrats to give to a man as dangerous as Ted Cruz. \nPutting Cruz on the Supreme Court would guarantee rulings against women’s rights and LGBT rights as well as putting laws like the Voting Rights Act and the Civil Rights Act in further peril. In no uncertain terms should Democrats grant Cruz a hearing, nor should they respect any of Trump’s conservative choices for the court. Republicans should have thought about “fair shakes” before taking the totally unprecedented step of being complete assholes toward the Supreme Court nominee of a sitting president who also won an election and s far more popular than Trump. Again, Senate Republicans didn’t even give Garland a hearing or a vote. They refused to do their jobs entirely out of disrespect towards President Obama. And so that’s exactly what Democrats should do to Trump. Turnabout is fair play and Republicans only have themselves to blame. \nFeatured Image: Ethan Miller/Getty Images Share this Article!",
		"thread_title": "Lindsey Graham Wants Trump To Put Ted Cruz On The Supreme Court Bench",
		"title": "Lindsey Graham Wants Trump To Put Ted Cruz On The Supreme Court Bench",
		"type": "bias",
		"uuid": "3582348c3ebcd3c5dee39c3b1afb23dcec3d954e"
	},
	"-KhIb8O8OhLm8YdtB9PU": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-13T02:55:48.945+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"name": "Trump fans",
				"salience": 0.13647127,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.12651815,
				"type": "PERSON"
			},
			{
				"name": "John Prager John Prager",
				"salience": 0.10685963,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.033360157,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.028994275,
				"type": "EVENT"
			},
			{
				"name": "gift",
				"salience": 0.025717307,
				"type": "OTHER"
			},
			{
				"name": "cover",
				"salience": 0.02512712,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.02512712,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.02512712,
				"type": "OTHER"
			},
			{
				"name": "break",
				"salience": 0.02512712,
				"type": "EVENT"
			},
			{
				"name": "Trump fans",
				"salience": 0.019481717,
				"type": "PERSON"
			},
			{
				"name": "lady",
				"salience": 0.019250581,
				"type": "PERSON"
			},
			{
				"name": "veterans",
				"salience": 0.015645688,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xy5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Lady_of_the_United_States"
				},
				"name": "First Lady",
				"salience": 0.015518304,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d3t7x"
				},
				"name": "Donald",
				"salience": 0.015496355,
				"type": "PERSON"
			},
			{
				"name": "authority",
				"salience": 0.011975946,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01y5zy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vogue_(magazine)"
				},
				"name": "Vogue",
				"salience": 0.011740806,
				"type": "WORK_OF_ART"
			},
			{
				"name": "clothes",
				"salience": 0.011100368,
				"type": "OTHER"
			},
			{
				"name": "decor",
				"salience": 0.0103732515,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0103732515,
				"type": "OTHER"
			},
			{
				"name": "flowers",
				"salience": 0.0103732515,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.009304236,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.008957472,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.008957472,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.008402094,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.007973304,
				"type": "LOCATION"
			},
			{
				"name": "Deplorables",
				"salience": 0.007924224,
				"type": "PERSON"
			},
			{
				"name": "reaction",
				"salience": 0.007655038,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0072768824,
				"type": "OTHER"
			},
			{
				"name": "eating",
				"salience": 0.0072768824,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.0072768824,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0072768824,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.0072768824,
				"type": "OTHER"
			},
			{
				"name": "magazine",
				"salience": 0.0070055565,
				"type": "ORGANIZATION"
			},
			{
				"name": "entertainment",
				"salience": 0.0070055565,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0070055565,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0070055565,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0068609198,
				"type": "EVENT"
			},
			{
				"name": "education",
				"salience": 0.006330392,
				"type": "OTHER"
			},
			{
				"name": "Readers",
				"salience": 0.0060943076,
				"type": "PERSON"
			},
			{
				"name": "behavior",
				"salience": 0.0059418236,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0059418236,
				"type": "OTHER"
			},
			{
				"name": "monkey",
				"salience": 0.0059418236,
				"type": "OTHER"
			},
			{
				"name": "ape",
				"salience": 0.0059418236,
				"type": "OTHER"
			},
			{
				"name": "aspiration",
				"salience": 0.0057202117,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.005506855,
				"type": "EVENT"
			},
			{
				"name": "soul",
				"salience": 0.0047300123,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05bd08",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yahoo!_News"
				},
				"name": "Yahoo News",
				"salience": 0.0044807834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fmhy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Right-wing_politics"
				},
				"name": "Right",
				"salience": 0.0044807834,
				"type": "OTHER"
			},
			{
				"name": "re-education camps",
				"salience": 0.0044395784,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0044395784,
				"type": "LOCATION"
			},
			{
				"name": "counselor",
				"salience": 0.0044395784,
				"type": "PERSON"
			},
			{
				"name": "weather control coordinator",
				"salience": 0.0044395784,
				"type": "PERSON"
			},
			{
				"name": "hellscape",
				"salience": 0.0044395784,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.0044395784,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0044395784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.004155663,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0035338975,
				"type": "OTHER"
			},
			{
				"name": "sock",
				"salience": 0.0033591688,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "world",
				"salience": 0.0032338111,
				"type": "LOCATION"
			},
			{
				"name": "iron fist",
				"salience": 0.0032338111,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0032338111,
				"type": "WORK_OF_ART"
			},
			{
				"name": "comments",
				"salience": 0.0032338111,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0032338111,
				"type": "OTHER"
			},
			{
				"name": "Search",
				"salience": 0.0032338111,
				"type": "OTHER"
			},
			{
				"name": "Author",
				"salience": 0.0027898797,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0js8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Emergency_Management_Agency"
				},
				"name": "FEMA",
				"salience": 0.0027330187,
				"type": "ORGANIZATION"
			},
			{
				"name": "Barry Soetoro",
				"salience": 0.0027330187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0027330187,
				"type": "PERSON"
			},
			{
				"name": "HAARP",
				"salience": 0.0027330187,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservative_Party_(UK)"
				},
				"name": "Conservative",
				"salience": 0.0027330187,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0136kr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberal_Party_of_Canada"
				},
				"name": "Liberal",
				"salience": 0.0027330187,
				"type": "ORGANIZATION"
			},
			{
				"name": "Share",
				"salience": 0.0024158447,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0024158447,
				"type": "WORK_OF_ART"
			},
			{
				"name": "screengrabs",
				"salience": 0.0024158447,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0024158447,
				"type": "WORK_OF_ART"
			},
			{
				"name": "candidate",
				"salience": 0.0024158447,
				"type": "PERSON"
			},
			{
				"name": "shot",
				"salience": 0.0024158447,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0019905348,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "KKK",
				"salience": 0.0014869388,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "8",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/11/Untitled-2-Recovered-Recovered-Recovered.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-13T02:55:48.945+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.6,
			"score": 0
		},
		"shares": "8",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 12, 2016 3:54 pm · \nTrump fans may have won the election, but they aren’t taking a break from expressing their racist hatred of Michelle Obama. The Donald’s Deplorables were out in force after the First Lady posed for the cover of Vogue. \n“I could have spent eight years doing anything , and at some level, it would have been fine,” Obama told the magazine . “I could have focused on flowers. I could have focused on decor. I could have focused on entertainment. Because any first lady, rightfully, gets to define her role. There’s no legislative authority; you’re not elected. And that’s a wonderful gift of freedom.” \nIn exercising her freedom, Michelle Obama has done quite a bit to push education, healthy eating, and support for our veterans — and in exercising their freedom, the Right has responded with nothing but hate. The reaction to the First Lady appearing in elegant clothing was typical. Readers of Yahoo News showered Obama with racist remarks, calling her an “ape” and a “monkey” and even wishing death upon her for the horrific crime of wearing pretty clothes. \nIf you thought this behavior would stop after the election, you were wrong. Trump fans are not done by a long shot — and now they have been emboldened by America electing its first official KKK candidate. \nIt will get worse before it gets better. \nFeatured image via Vogue /screengrabs Share this Article! Share on Facebook Author: John Prager John Prager is an unfortunate Liberal soul who lives uncomfortably in the middle of a Conservative hellscape. John is the managing editor of Winning Democrats . He moonlights as a counselor at one of Barry Soetoro's FEMA re-education camps and as a HAARP weather control coordinator. John's life's aspiration is to rule the world with an iron fist, or find that sock he's been looking for. Feel free to email him at [email protected] if you have any questions or comments -- or drop him a line on Twitter or Facebook . Search",
		"thread_title": "Michelle Obama Poses In A Pretty Dress, So Racist Conservatives Call Her A ‘Monkey’ (SCREENSHOTS)",
		"title": "Michelle Obama Poses In A Pretty Dress, So Racist Conservatives Call Her A ‘Monkey’ (SCREENSHOTS)",
		"type": "bias",
		"uuid": "88a8a4973bcb0a53f3a1f59ee176ecd8c1f46a31"
	},
	"-KhIb8bsYp26DU8oJcin": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-14T01:53:53.917+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.17928882,
				"type": "LOCATION"
			},
			{
				"name": "sign",
				"salience": 0.11467986,
				"type": "OTHER"
			},
			{
				"name": "James Thompson",
				"salience": 0.11001739,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04hfnv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Melania_Trump"
				},
				"name": "Melania Trump",
				"salience": 0.06513673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.05208926,
				"type": "PERSON"
			},
			{
				"name": "image",
				"salience": 0.031783894,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sign",
				"salience": 0.025718529,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.022487752,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.021477368,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.018612042,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.018612042,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.018612042,
				"type": "LOCATION"
			},
			{
				"name": "conservatives",
				"salience": 0.018612042,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.011477238,
				"type": "EVENT"
			},
			{
				"name": "husband",
				"salience": 0.010484385,
				"type": "PERSON"
			},
			{
				"name": "lawsuit",
				"salience": 0.009056335,
				"type": "OTHER"
			},
			{
				"name": "sister",
				"salience": 0.008869553,
				"type": "PERSON"
			},
			{
				"name": "photo",
				"salience": 0.0076824473,
				"type": "WORK_OF_ART"
			},
			{
				"name": "picture",
				"salience": 0.0076824473,
				"type": "WORK_OF_ART"
			},
			{
				"name": "social media platform",
				"salience": 0.0076824473,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0076824473,
				"type": "LOCATION"
			},
			{
				"name": "building",
				"salience": 0.0076824473,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.007120527,
				"type": "ORGANIZATION"
			},
			{
				"name": "incidents",
				"salience": 0.0063260132,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.006222477,
				"type": "EVENT"
			},
			{
				"name": "effort",
				"salience": 0.006222477,
				"type": "OTHER"
			},
			{
				"name": "Equal rights",
				"salience": 0.006222477,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.006144173,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.0060901865,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.005951752,
				"type": "PERSON"
			},
			{
				"name": "sister",
				"salience": 0.005767163,
				"type": "PERSON"
			},
			{
				"name": "bullying",
				"salience": 0.005556012,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/068p2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pittsburgh"
				},
				"name": "Pittsburgh",
				"salience": 0.005463463,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0qyvr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pittsburg,_California"
				},
				"name": "Pittsburg",
				"salience": 0.005463463,
				"type": "LOCATION"
			},
			{
				"name": "owners",
				"salience": 0.0053890976,
				"type": "PERSON"
			},
			{
				"name": "wake",
				"salience": 0.0053890976,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0053890976,
				"type": "EVENT"
			},
			{
				"name": "incidents",
				"salience": 0.0053309593,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.0051881447,
				"type": "OTHER"
			},
			{
				"name": "lynching",
				"salience": 0.0051881447,
				"type": "OTHER"
			},
			{
				"name": "tree",
				"salience": 0.0051881447,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.005081023,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.005081023,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.005081023,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.005081023,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0047315974,
				"type": "OTHER"
			},
			{
				"name": "water fountains",
				"salience": 0.0044003217,
				"type": "OTHER"
			},
			{
				"name": "teacher",
				"salience": 0.0044003217,
				"type": "PERSON"
			},
			{
				"name": "harassment",
				"salience": 0.0044003217,
				"type": "OTHER"
			},
			{
				"name": "election night results",
				"salience": 0.0044003217,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0044003217,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.0044003217,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0044003217,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0044003217,
				"type": "OTHER"
			},
			{
				"name": "bullying",
				"salience": 0.0042045414,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-Americans",
				"salience": 0.003880643,
				"type": "PERSON"
			},
			{
				"name": "focus",
				"salience": 0.0038277977,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0033182723,
				"type": "ORGANIZATION"
			},
			{
				"name": "incidents",
				"salience": 0.0033152122,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.0032877561,
				"type": "OTHER"
			},
			{
				"name": "pic.twitter.com/gDLKw54Lox",
				"salience": 0.0031944658,
				"type": "OTHER"
			},
			{
				"name": "@JETBallin",
				"salience": 0.0031944658,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.003099698,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.0030627942,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.002765498,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.002765498,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.0027091436,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0027091436,
				"type": "OTHER"
			},
			{
				"name": "tally",
				"salience": 0.0018583968,
				"type": "OTHER"
			},
			{
				"name": "high school",
				"salience": 0.0017890305,
				"type": "LOCATION"
			},
			{
				"name": "bullying",
				"salience": 0.0017756537,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07p6zym"
				},
				"name": "First Lady",
				"salience": 0.0015705564,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0012716551,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0011011276,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "2",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/11/CxGrYz8UAAAkiYB1-800x430.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-14T01:53:53.917+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.7,
			"score": -0.2
		},
		"shares": "2",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 13, 2016 3:09 pm · \nAs predicted, Donald Trump’s victory on Election Day has emboldened racist conservatives to start harassing and attacking minorities. \nAnd it’s even happening in the deep blue state of California, where a woman spotted a sign hanging on the side of a building in the town of Pittsburg and snapped a photo of it. \nTwitter user James Thompson posted the image of the sign on the social media platform after his sister sent it to him. This picture was taken in Pittsburgh California. My sister texted this to me 10 minutes ago.Our democracy is being tested even in California pic.twitter.com/gDLKw54Lox \n— James Thompson (@JETBallin) November 13, 2016 \nThe sign clearly promotes lynching to prevent African-Americans from getting equal rights. \n“You can hang a n****r from a tree / Equal rights he will never see!” it says. \nThe FBI has been notified and local police have filed a lawsuit in an effort to force the owners of the sign to remove it. \nIn the wake of Trump’s surprising and depressing victory there has been a rise in the number of racist incidents in this country. In fact, there have been 139 reports of people being bullied by Trump supporters since the election night results. \nThese incidents include the harassment of a Muslim teacher by a student in Georgia, and students designating water fountains “white” or “colored” at a Florida high school. \nFrankly, there are so many incidents that it’s difficult to list them all. You can find a somewhat comprehensive tally here . \nThis is what Trump’s America looks like and it’s scary. And this has all happend in the course of a few days as Melania Trump continues to tell the media that her focus will be on ending bullying. What exactly does she mean by that? Is she going to call out all bullying, including the racist bullying being perpetrated by her husband’s own supporters? Or is she going to ignore those incidents and merely whine about people who criticize her husband. Because right now, she isn’t even First Lady yet and her “effort” has failed miserably. And she only has her husband to blame.",
		"thread_title": "Racist Sign Calls For Lynching Black People To Prevent Them From Getting Equal Rights",
		"title": "Racist Sign Calls For Lynching Black People To Prevent Them From Getting Equal Rights",
		"type": "bias",
		"uuid": "f495aee210336752f140bab451f664e4a975149d"
	},
	"-KhIb8rEKpYvYrUl8HZL": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-14T01:54:00.054+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.29968747,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.08954896,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.07144985,
				"type": "PERSON"
			},
			{
				"name": "American National Elections Study",
				"salience": 0.043865927,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.04216415,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.041389216,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.021276856,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.014653955,
				"type": "OTHER"
			},
			{
				"name": "Post election",
				"salience": 0.014163454,
				"type": "EVENT"
			},
			{
				"name": "whites",
				"salience": 0.01398576,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.013187166,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.013088958,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.011822602,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.010242289,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.010242289,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.010242289,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.010242289,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.010242289,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.009391773,
				"type": "PERSON"
			},
			{
				"name": "Author: Wendy Gittleson Wendy",
				"salience": 0.0069463896,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0062647206,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0062261717,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0058442545,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0058442545,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0058442545,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0058442545,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.005337125,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0051381607,
				"type": "PERSON"
			},
			{
				"name": "Post election",
				"salience": 0.005084342,
				"type": "EVENT"
			},
			{
				"name": "job",
				"salience": 0.0050648614,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.004876029,
				"type": "OTHER"
			},
			{
				"name": "employers",
				"salience": 0.004876029,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.004638378,
				"type": "PERSON"
			},
			{
				"name": "Jason McDaniel",
				"salience": 0.0045087147,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004446752,
				"type": "PERSON"
			},
			{
				"name": "answer",
				"salience": 0.0042229,
				"type": "OTHER"
			},
			{
				"name": "minority communities",
				"salience": 0.0042229,
				"type": "LOCATION"
			},
			{
				"name": "jobs",
				"salience": 0.004210141,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00409935,
				"type": "PERSON"
			},
			{
				"name": "minorities",
				"salience": 0.0039464664,
				"type": "PERSON"
			},
			{
				"name": "Sean McElwee",
				"salience": 0.0038477797,
				"type": "PERSON"
			},
			{
				"name": "trade",
				"salience": 0.003835648,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.0037873562,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.0037873562,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0037715172,
				"type": "PERSON"
			},
			{
				"name": "trade",
				"salience": 0.0036460932,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0036460932,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.003552373,
				"type": "OTHER"
			},
			{
				"name": "employers",
				"salience": 0.0034198642,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0033549443,
				"type": "OTHER"
			},
			{
				"name": "Graph courtesy",
				"salience": 0.0032922928,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0032922928,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0032922928,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0032922928,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.003092308,
				"type": "OTHER"
			},
			{
				"name": "Salon",
				"salience": 0.0028510913,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.0028510913,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0027921926,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0027721904,
				"type": "PERSON"
			},
			{
				"name": "electorate",
				"salience": 0.0025007518,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0024800384,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.0023720379,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.002327727,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.002310327,
				"type": "OTHER"
			},
			{
				"name": "bigots",
				"salience": 0.00208605,
				"type": "PERSON"
			},
			{
				"name": "facts",
				"salience": 0.00208605,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.00208605,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nation",
				"salience": 0.00208605,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.00208605,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00208605,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0020525844,
				"type": "PERSON"
			},
			{
				"name": "ANES",
				"salience": 0.0020268443,
				"type": "LOCATION"
			},
			{
				"name": "claims",
				"salience": 0.0018376529,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.001806397,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.001806397,
				"type": "OTHER"
			},
			{
				"name": "gender inequality",
				"salience": 0.001806397,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0017928918,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0015843583,
				"type": "OTHER"
			},
			{
				"name": "Share",
				"salience": 0.0015193697,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0015193697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0014883999,
				"type": "PERSON"
			},
			{
				"name": "opinions",
				"salience": 0.0014561238,
				"type": "OTHER"
			},
			{
				"name": "writing",
				"salience": 0.0013156506,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0013156506,
				"type": "LOCATION"
			},
			{
				"name": "two",
				"salience": 0.0013156506,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0013156506,
				"type": "WORK_OF_ART"
			},
			{
				"name": "passions",
				"salience": 0.0013156506,
				"type": "OTHER"
			},
			{
				"name": "dogs",
				"salience": 0.0013156506,
				"type": "OTHER"
			},
			{
				"name": "bike",
				"salience": 0.0013156506,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "meal",
				"salience": 0.0013156506,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.0013156506,
				"type": "PERSON"
			},
			{
				"name": "loved one",
				"salience": 0.0013156506,
				"type": "PERSON"
			},
			{
				"name": "Search",
				"salience": 0.0013156506,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.001284036,
				"type": "ORGANIZATION"
			},
			{
				"name": "coalition",
				"salience": 0.0012665385,
				"type": "ORGANIZATION"
			},
			{
				"name": "racism",
				"salience": 0.0012570677,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0012314697,
				"type": "OTHER"
			},
			{
				"name": "bigots",
				"salience": 0.0011349967,
				"type": "PERSON"
			},
			{
				"name": "gender",
				"salience": 0.0011349967,
				"type": "OTHER"
			},
			{
				"name": "Ralph Freso",
				"salience": 0.0011118586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0011118586,
				"type": "LOCATION"
			},
			{
				"name": "path",
				"salience": 0.0010471372,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0009827974,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0009827974,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0009827974,
				"type": "OTHER"
			},
			{
				"name": "reductions",
				"salience": 0.0009827974,
				"type": "OTHER"
			},
			{
				"name": "living",
				"salience": 0.00097041164,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0008097458,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gh6xtp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google%2B"
				},
				"name": "Google Plus",
				"salience": 0.0008097458,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0006717617,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/11/GettyImages-612445408.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-14T01:54:00.054+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 13, 2016 4:03 pm · \nPost election, the media and Donald Trump voters everywhere have been rewriting recent history. They are making the claim that Trump wasn’t elected because of racism; he was elected because of the economy. The problem with that argument, though, is that it’s simply not true. Trump voters are racist and there’s proof. \nThe American National Elections Study (ANES) began the study in January. Initially, they asked “How likely is it that many whites are unable to find a job because employers are hiring minorities instead.” Now, of course, anyone who spends more than five minutes listening to those in minority communities know the answer to that. It’s VERY unlikely that whites aren’t getting jobs because minorities are, but that’s not what Trump voters think. The vast majority said that it’s “extremely likely” that minorities are taking jobs from white people. Graph courtesy of ANES and Salon . \nThen, they asked the same Trump voters about a non-racial issue, trade. Despite the fact that trade was one of Trump’s signature issues, their opinions on trade were mixed. \nPost election, this is what the study found: \nThe question about white jobs is powerfully linked to support for Trump over Clinton. Eighty-four percent of whites who believe it is “extremely likely” that whites can’t find a job because employers are hiring people of color instead support Trump, compared with 23 percent of those who think it is “not at all” likely. Among white Democrats, 58 percent who believe people of color are taking jobs support Trump over Clinton, compared with less than 1 percent of those who believe it is not at all likely. Eighty-one percent of white women who think it is “extremely likely” people of color are taking jobs supported Trump, compared with 26 percent who don’t think that. \nMore than that, 78 percent of white Trump supporters say black people are “violent.” 84 percent think that of Muslims. \nUnfortunately, Democrats might not be able to just ride out this wave of racism, hoping that eventually, the aging bigots will die off. It turns out their children are just as bad. Sean McElwee, the man who was responsible for publishing the study, suggested this: \nDemocrats must create a narrative that weaves economic, racial and gender justice together. A multiracial coalition is the path to sustained political power and reductions in economic, racial and gender inequality. As I’ve shown with political scientist Jason McDaniel, racism often diminishes support for progressive policies. The solution is not to abandon either the white working class or the diverse and rising American electorate that still stands poised to transform the nation. \nGreat idea, if we had a media that reported facts instead of letting bigots’ claims go unchallenged. \nFeatured image via Ralph Freso/Getty Images Share this Article! Share on Facebook Author: Wendy Gittleson Wendy is one of the luckiest people on the planet. She actually gets to make a living out of two of her greatest passions, writing and politics. When she's not writing, she's hiking with her dogs, riding her bike or cooking a great meal with her friends or loved one. Follow Wendy on Facebook , Twitter or Google Plus . Search",
		"thread_title": "Trump Supporters Didn’t Vote Because Of The Economy; It Was Racism, And Here’s PROOF",
		"title": "Trump Supporters Didn’t Vote Because Of The Economy; It Was Racism, And Here’s PROOF",
		"type": "bias",
		"uuid": "e5f023c08a1aa9ff62d008a74278afb5159cc786"
	},
	"-KhIb96Ft9lqmvWKASZe": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-14T01:54:00.165+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.21683532,
				"type": "PERSON"
			},
			{
				"name": "accusation",
				"salience": 0.15910634,
				"type": "OTHER"
			},
			{
				"name": "portion",
				"salience": 0.028309625,
				"type": "OTHER"
			},
			{
				"name": "coverage",
				"salience": 0.023886263,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.020080509,
				"type": "OTHER"
			},
			{
				"name": "propensity",
				"salience": 0.018424924,
				"type": "OTHER"
			},
			{
				"name": "tape",
				"salience": 0.016654337,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "question",
				"salience": 0.016085424,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.015715674,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.015715674,
				"type": "PERSON"
			},
			{
				"name": "media coverage",
				"salience": 0.015715674,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.01548712,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.015244666,
				"type": "OTHER"
			},
			{
				"name": "memoire",
				"salience": 0.013689624,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07wpbx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Megyn_Kelly"
				},
				"name": "Megyn Kelly",
				"salience": 0.013010263,
				"type": "PERSON"
			},
			{
				"name": "competitors",
				"salience": 0.012296566,
				"type": "ORGANIZATION"
			},
			{
				"name": "faults",
				"salience": 0.012296566,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.012296566,
				"type": "OTHER"
			},
			{
				"name": "pussy",
				"salience": 0.012296566,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.012296566,
				"type": "EVENT"
			},
			{
				"name": "example",
				"salience": 0.012296566,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.012150788,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.011231994,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.008563843,
				"type": "PERSON"
			},
			{
				"name": "Author: Wendy Gittleson Wendy",
				"salience": 0.008338701,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.008287414,
				"type": "OTHER"
			},
			{
				"name": "Billy Bush",
				"salience": 0.007576164,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0074838903,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0072121746,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.007015401,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0069385017,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0061154426,
				"type": "OTHER"
			},
			{
				"name": "dogs",
				"salience": 0.0058529624,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0057379073,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0055965134,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0055965134,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0052027064,
				"type": "PERSON"
			},
			{
				"name": "tirades",
				"salience": 0.0050688656,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.0050688656,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.0050688656,
				"type": "OTHER"
			},
			{
				"name": "slobs",
				"salience": 0.0050688656,
				"type": "OTHER"
			},
			{
				"name": "pigs",
				"salience": 0.0050688656,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0050688656,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0045460043,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.004244885,
				"type": "OTHER"
			},
			{
				"name": "loyalty",
				"salience": 0.0039842455,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0039517097,
				"type": "EVENT"
			},
			{
				"name": "Bill Sammon",
				"salience": 0.003895196,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.003711645,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.0036000675,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0035547244,
				"type": "EVENT"
			},
			{
				"name": "stories",
				"salience": 0.0035547244,
				"type": "WORK_OF_ART"
			},
			{
				"name": "perks",
				"salience": 0.0035547244,
				"type": "OTHER"
			},
			{
				"name": "hotels",
				"salience": 0.0035547244,
				"type": "LOCATION"
			},
			{
				"name": "bribery",
				"salience": 0.0034220894,
				"type": "OTHER"
			},
			{
				"name": "ass",
				"salience": 0.0034220894,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0034220894,
				"type": "PERSON"
			},
			{
				"name": "behavior",
				"salience": 0.0034220894,
				"type": "OTHER"
			},
			{
				"name": "refs",
				"salience": 0.0033513883,
				"type": "PERSON"
			},
			{
				"name": "refs",
				"salience": 0.0033513883,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.003248604,
				"type": "EVENT"
			},
			{
				"name": "journalists",
				"salience": 0.0032263338,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0032022176,
				"type": "OTHER"
			},
			{
				"name": "town hall debate question",
				"salience": 0.0032022176,
				"type": "OTHER"
			},
			{
				"name": "stays",
				"salience": 0.0029766876,
				"type": "OTHER"
			},
			{
				"name": "gifts",
				"salience": 0.0029766876,
				"type": "OTHER"
			},
			{
				"name": "TV hosts",
				"salience": 0.00293919,
				"type": "PERSON"
			},
			{
				"name": "tank",
				"salience": 0.0029021644,
				"type": "OTHER"
			},
			{
				"name": "chapter",
				"salience": 0.0029021644,
				"type": "OTHER"
			},
			{
				"name": "praise",
				"salience": 0.0029021644,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0027938602,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0027729743,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0027729743,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0027729743,
				"type": "OTHER"
			},
			{
				"name": "egos",
				"salience": 0.0027239106,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.002503767,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0023292957,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0021680952,
				"type": "PERSON"
			},
			{
				"name": "underbelly",
				"salience": 0.0021680952,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0021680952,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m2rv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flint,_Michigan"
				},
				"name": "Flint",
				"salience": 0.0020293854,
				"type": "LOCATION"
			},
			{
				"name": "politics",
				"salience": 0.00201969,
				"type": "OTHER"
			},
			{
				"name": "insider knowledge",
				"salience": 0.001885827,
				"type": "OTHER"
			},
			{
				"name": "Share",
				"salience": 0.0018235785,
				"type": "OTHER"
			},
			{
				"name": "dogs",
				"salience": 0.0018235785,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0018235785,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0017423802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0016980511,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.00157906,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Search",
				"salience": 0.00157906,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.00157906,
				"type": "LOCATION"
			},
			{
				"name": "two",
				"salience": 0.00157906,
				"type": "OTHER"
			},
			{
				"name": "passions",
				"salience": 0.00157906,
				"type": "OTHER"
			},
			{
				"name": "writing",
				"salience": 0.00157906,
				"type": "OTHER"
			},
			{
				"name": "bike",
				"salience": 0.00157906,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "meal",
				"salience": 0.00157906,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.00157906,
				"type": "PERSON"
			},
			{
				"name": "loved one",
				"salience": 0.00157906,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.0015475019,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.001508745,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.001508745,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0014780209,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0013622288,
				"type": "EVENT"
			},
			{
				"name": "Chip Somodevilla",
				"salience": 0.0013344573,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0013344573,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/024c08",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fourth_Estate"
				},
				"name": "Fourth Estate",
				"salience": 0.0013344573,
				"type": "ORGANIZATION"
			},
			{
				"name": "Yahoo Kelly",
				"salience": 0.0011877366,
				"type": "PERSON"
			},
			{
				"name": "media outlet",
				"salience": 0.0011795524,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0011795524,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0011795524,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.0011795524,
				"type": "OTHER"
			},
			{
				"name": "advance",
				"salience": 0.0011795524,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0011795524,
				"type": "OTHER"
			},
			{
				"name": "exec",
				"salience": 0.0011795524,
				"type": "PERSON"
			},
			{
				"name": "living",
				"salience": 0.0011646866,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.0011223695,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gh6xtp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google%2B"
				},
				"name": "Google Plus",
				"salience": 0.00097185053,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/11/GettyImages-483377088.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-14T00:43:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 13, 2016 12:43 pm · \nBefore the leaked tape of Donald Trump describing his propensity to grab women “by the pussy” to Billy Bush, it seemed that the media was ignoring Donald Trump’s glaring faults as a presidential candidate. During the primaries , for example, he received far more positive media coverage than any of his competitors. It turns out there might be a reason for that – Trump was bribing the media – at least that’s the accusation being made by Megyn Kelly of Fox News. \nIn her memoire “Settle for More,” which will be released this week, Kelly said that Trump likely received the infamous question, in which she asked about the fact that he has called women “fat pigs, dogs, slobs and disgusting animals.” That question set Trump off on one of his Twitter tirades. These are only a portion: \nThe worst and most controversial of which was this: \nAs the election progressed, it became more and more apparent that Trump expected that no matter how egregious his behavior, he expected, no, demanded that the media kiss his orange ass. If they didn’t, he would cut off access, but before that, he tried bribery. \nWhile Kelly couldn’t speak for other members of the media, she alleges that Trump attempted to buy positive coverage by offering free stays at his hotels, with full perks. While the attempt clearly didn’t work on Kelly, she says that with some, their loyalty came cheap, or perhaps not so cheap. \n“This is actually one of the untold stories of the 2016 campaign: I was not the only journalist to whom Trump offered gifts clearly meant to shape coverage,” Kelly said. He also attempted to woo them with praise, she said, adding, “This is smart, because the media is full of people whose egos need stroking.” \n“Trump tried to work the refs, and some of the refs responded,” she said. \nWhen it became obvious that some reporters were “in the tank” for Trump, she alleges in one chapter, “certain TV hosts” would work with the candidate in advance on occasional Trump criticism so they would appear unbiased. She didn’t identify them by name or media outlet. \nSource: Yahoo \nKelly also asserts that the day before the debate in which Kelly asked about Trump’s treatment of women, the candidate called Fox News exec. Bill Sammon, who told him about the first question. All we heard about, though, during the election, was that it was Hillary Clinton who was fed a town hall debate question and it was hardly earth shattering. The insider knowledge said that a woman, in the Flint, Michigan debate, would ask a question about the Flint water . \nWhile bribing journalists isn’t illegal, per say, it is highly unethical. Without the Fourth Estate exposing the underbelly of politicians and of politics, democracy is impossible. \nFeatured image via Chip Somodevilla/Getty Images Share this Article! Share on Facebook Author: Wendy Gittleson Wendy is one of the luckiest people on the planet. She actually gets to make a living out of two of her greatest passions, writing and politics. When she's not writing, she's hiking with her dogs, riding her bike or cooking a great meal with her friends or loved one. Follow Wendy on Facebook , Twitter or Google Plus . Search",
		"thread_title": "Megyn Kelly Makes BOMBSHELL Admission About Trump And The Media",
		"title": "Megyn Kelly Makes BOMBSHELL Admission About Trump And The Media",
		"type": "bias",
		"uuid": "b850f0cc65e665dee17bc9d3054872e1ca5a32d7"
	},
	"-KhIb9MwgsH5C_NziSet": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-14T01:54:13.190+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"name": "stereotype",
				"salience": 0.21174806,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jbhs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Agriculture"
				},
				"name": "United States Department of Agriculture",
				"salience": 0.06858212,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0x_w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brushton,_New_York"
				},
				"name": "Brushton",
				"salience": 0.06678925,
				"type": "LOCATION"
			},
			{
				"name": "store",
				"salience": 0.031110123,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanic",
				"salience": 0.028253194,
				"type": "PERSON"
			},
			{
				"name": "Courtesy",
				"salience": 0.02819285,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.022236915,
				"type": "LOCATION"
			},
			{
				"name": "food stamp recipients",
				"salience": 0.022009011,
				"type": "OTHER"
			},
			{
				"name": "recipients",
				"salience": 0.022009011,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.021770054,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.019071532,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.019071532,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media",
				"salience": 0.019071532,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.018654527,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.018264314,
				"type": "EVENT"
			},
			{
				"name": "Dennis Sauve",
				"salience": 0.015294098,
				"type": "PERSON"
			},
			{
				"name": "bust",
				"salience": 0.01506969,
				"type": "OTHER"
			},
			{
				"name": "food stamp capital",
				"salience": 0.012488056,
				"type": "OTHER"
			},
			{
				"name": "Travissonno.com",
				"salience": 0.011758703,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.011615649,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.010889281,
				"type": "WORK_OF_ART"
			},
			{
				"name": "SNAP program",
				"salience": 0.0100616375,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.00989824,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.009335353,
				"type": "OTHER"
			},
			{
				"name": "food stamps",
				"salience": 0.008688742,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0081501575,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.00787018,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.00787018,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00787018,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007846416,
				"type": "PERSON"
			},
			{
				"name": "food stamp fraud",
				"salience": 0.007846416,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007846416,
				"type": "PERSON"
			},
			{
				"name": "arrests",
				"salience": 0.0078059775,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.0075616036,
				"type": "LOCATION"
			},
			{
				"name": "time",
				"salience": 0.0067957686,
				"type": "OTHER"
			},
			{
				"name": "WCAX News",
				"salience": 0.006197903,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fox ``News",
				"salience": 0.006197903,
				"type": "OTHER"
			},
			{
				"name": "blue",
				"salience": 0.0061471243,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.006020215,
				"type": "OTHER"
			},
			{
				"name": "food stamp program",
				"salience": 0.0059873266,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.005881479,
				"type": "OTHER"
			},
			{
				"name": "demographics",
				"salience": 0.0055205044,
				"type": "OTHER"
			},
			{
				"name": "kicker",
				"salience": 0.0055205044,
				"type": "PERSON"
			},
			{
				"name": "alcohol",
				"salience": 0.0053146277,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fraud",
				"salience": 0.00529857,
				"type": "OTHER"
			},
			{
				"name": "Denis Sauve",
				"salience": 0.0052825953,
				"type": "PERSON"
			},
			{
				"name": "arrests",
				"salience": 0.005204882,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.005139354,
				"type": "PERSON"
			},
			{
				"name": "fraud",
				"salience": 0.004973324,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004973324,
				"type": "PERSON"
			},
			{
				"name": "affiliations",
				"salience": 0.004925592,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/082rfx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Country_(New_York)"
				},
				"name": "North Country",
				"salience": 0.004832254,
				"type": "LOCATION"
			},
			{
				"name": "welfare program",
				"salience": 0.0043069497,
				"type": "OTHER"
			},
			{
				"name": "Owsley Country",
				"salience": 0.004098321,
				"type": "LOCATION"
			},
			{
				"name": "food stamp",
				"salience": 0.0040122983,
				"type": "OTHER"
			},
			{
				"name": "government assistance",
				"salience": 0.0038889775,
				"type": "OTHER"
			},
			{
				"name": "Investigators",
				"salience": 0.0037222467,
				"type": "PERSON"
			},
			{
				"name": "bust",
				"salience": 0.0036501742,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0035881102,
				"type": "PERSON"
			},
			{
				"name": "Police",
				"salience": 0.0034062185,
				"type": "PERSON"
			},
			{
				"name": "woes",
				"salience": 0.0033677653,
				"type": "OTHER"
			},
			{
				"name": "rates",
				"salience": 0.0033677653,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.0033677653,
				"type": "OTHER"
			},
			{
				"name": "misconception",
				"salience": 0.0033677653,
				"type": "OTHER"
			},
			{
				"name": "Old Time Butcher Block",
				"salience": 0.0032721981,
				"type": "LOCATION"
			},
			{
				"name": "Franklin County Department of Social Services Fraud Unit",
				"salience": 0.003204592,
				"type": "ORGANIZATION"
			},
			{
				"name": "red state",
				"salience": 0.0031373133,
				"type": "LOCATION"
			},
			{
				"name": "food stamps",
				"salience": 0.0029976657,
				"type": "OTHER"
			},
			{
				"name": "stereotypes",
				"salience": 0.0028327645,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0498y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kentucky"
				},
				"name": "Kentucky",
				"salience": 0.002775036,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.002775036,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0027148721,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0026252775,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0024530175,
				"type": "WORK_OF_ART"
			},
			{
				"name": "criminal",
				"salience": 0.0024530175,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.0024530175,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Author",
				"salience": 0.0024530175,
				"type": "PERSON"
			},
			{
				"name": "Search",
				"salience": 0.0024530175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021sj1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office"
				},
				"name": "Office",
				"salience": 0.0018344114,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "misuse",
				"salience": 0.0018325059,
				"type": "OTHER"
			},
			{
				"name": "grand larceny",
				"salience": 0.0018325059,
				"type": "OTHER"
			},
			{
				"name": "District Attorney",
				"salience": 0.0018325059,
				"type": "PERSON"
			},
			{
				"name": "Police",
				"salience": 0.0017288476,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f612",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Franklin_County,_New_York"
				},
				"name": "Franklin County",
				"salience": 0.0016660421,
				"type": "LOCATION"
			},
			{
				"name": "Ryan Denson Living",
				"salience": 0.0015098756,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bs2wqq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_State_Department_of_Family_Assistance"
				},
				"name": "New York State Office of Temporary and Disability Assistance",
				"salience": 0.0013025426,
				"type": "ORGANIZATION"
			},
			{
				"name": "WPTZ News: Police",
				"salience": 0.0009023103,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2015/02/Food-Stamp-Fraud.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-14T01:54:13.190+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on February 15, 2015 11:17 am · \nIt’s a common stereotype that food stamp recipients, and those who abuse it, are black, Hispanic, or any other race but white. According to the USDA in their report for fiscal year 2013, 40% of recipients are white and 26% are black. Courtesy of Travissonno.com \nWhile the media and America’s culture will have you believe that black people (or anyone who isn’t white) account for copious amounts of fraud, there’s a story breaking that you won’t hear on Fox “News” anytime soon (or you might, because any chance to crush the SNAP program, they will take). \nAccording to WCAX News in New York: \nMore than 30 people have been nabbed for food stamp fraud in the North Country. \nInvestigators say over the past couple month’s people used their food stamps to get food or alcohol at the Old Time Butcher Block store in Brushton. \nPolice also say it’s not the first time the owner of that store, Dennis Sauve, has been charged with allowing such fraud. \nPolice say more arrests are expected. \nNow here’s the kicker: they’re all white. Brushton, New York, where this bust happened, has a population of roughly 480 people. Approximately 99.83% of the population is white, and 0.42% are black. These demographics are eerily similar to the food stamp capital of the country , Owsley Country, Kentucky, which is 99.22% white and 95% Republican. Maybe we should investigate them. \nI just wish we could get the political affiliations of those arrested in Brushton. \nAccording to WPTZ News: \nPolice say the arrests are the result of a year-long investigation, initiated by the Franklin County Department of Social Services Fraud Unit. Franklin County District Attorney’s Office, the United States Department of Agriculture, and the New York State Office of Temporary and Disability Assistance helped with the investigation. \nThe store owner, Denis Sauve (also white), has been charged with third-degree grand larceny and misuse of food stamps. \nThis really isn’t a racial issue so much as it is an, “I told you so,” issue. While the food stamp program has one of the lowest rates of abuse than any other welfare program, a lot of people buy into this misconception that it is the “lazy blacks” who account for all the fraud and woes of government assistance. Well, here we are, a major food stamp “bust” and every criminal involved is white. \nIt might be time to rethink today’ stereotypes. Share this Article! Author: Ryan Denson Living blue in a red state (hopefully it will be purple in the next 10 years). You can reach me at [email protected] Search",
		"thread_title": "30 People Arrested For Food Stamp Fraud; Guess How Many Were Black",
		"title": "30 People Arrested For Food Stamp Fraud; Guess How Many Were Black",
		"type": "bias",
		"uuid": "3cf0dbc6c8884b53a531f9303e6ad300e5c5eb67"
	},
	"-KhIb9Z3zBan3hAuivcP": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-16T01:56:09.897+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.45825708,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07c72",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Simpsons"
				},
				"name": "The Simpsons",
				"salience": 0.16380887,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0h684",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lisa_Simpson"
				},
				"name": "Lisa Simpson",
				"salience": 0.077249974,
				"type": "PERSON"
			},
			{
				"name": "future",
				"salience": 0.029415382,
				"type": "OTHER"
			},
			{
				"name": "Sarah Sarah",
				"salience": 0.026923062,
				"type": "PERSON"
			},
			{
				"name": "opening",
				"salience": 0.020895287,
				"type": "EVENT"
			},
			{
				"name": "presidency",
				"salience": 0.020282801,
				"type": "OTHER"
			},
			{
				"name": "prediction",
				"salience": 0.015251261,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.011945709,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.011945709,
				"type": "EVENT"
			},
			{
				"name": "businessman",
				"salience": 0.011720226,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.010013032,
				"type": "EVENT"
			},
			{
				"name": "reality",
				"salience": 0.0068262913,
				"type": "OTHER"
			},
			{
				"name": "story line",
				"salience": 0.006518058,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0063645327,
				"type": "OTHER"
			},
			{
				"name": "glimpse",
				"salience": 0.006275527,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h6cb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bart_Simpson"
				},
				"name": "Bart Simpson",
				"salience": 0.0057366327,
				"type": "PERSON"
			},
			{
				"name": "Presidency",
				"salience": 0.0056800414,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0056800414,
				"type": "PERSON"
			},
			{
				"name": "clip",
				"salience": 0.005126065,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mess",
				"salience": 0.0049351794,
				"type": "OTHER"
			},
			{
				"name": "chalkboard",
				"salience": 0.0049351794,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.004612548,
				"type": "OTHER"
			},
			{
				"name": "despair",
				"salience": 0.0044040163,
				"type": "OTHER"
			},
			{
				"name": "prediction",
				"salience": 0.004261908,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0039977734,
				"type": "OTHER"
			},
			{
				"name": "Free Wood Post",
				"salience": 0.0038398926,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0h545",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Homer_Simpson"
				},
				"name": "Homer Simpson",
				"salience": 0.0032873384,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0032647226,
				"type": "EVENT"
			},
			{
				"name": "president-elect",
				"salience": 0.0032647226,
				"type": "PERSON"
			},
			{
				"name": "hair",
				"salience": 0.0028275063,
				"type": "OTHER"
			},
			{
				"name": "campaign rollout",
				"salience": 0.0028275063,
				"type": "EVENT"
			},
			{
				"name": "economy",
				"salience": 0.0028275063,
				"type": "OTHER"
			},
			{
				"name": "fallout",
				"salience": 0.0028275063,
				"type": "EVENT"
			},
			{
				"name": "reality TV host",
				"salience": 0.0028275063,
				"type": "PERSON"
			},
			{
				"name": "TheSimpsons pic.twitter.com/Myf5rYb9Dj",
				"salience": 0.0027127487,
				"type": "OTHER"
			},
			{
				"name": "prediction",
				"salience": 0.0027017472,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.002687816,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0021127982,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video screen capture",
				"salience": 0.0021127982,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0021127982,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Author",
				"salience": 0.0021127982,
				"type": "PERSON"
			},
			{
				"name": "league",
				"salience": 0.0021127982,
				"type": "ORGANIZATION"
			},
			{
				"name": "words",
				"salience": 0.0021127982,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0021127982,
				"type": "EVENT"
			},
			{
				"name": "@TheSimpsons",
				"salience": 0.0020528631,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0015917639,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0015390653,
				"type": "OTHER"
			},
			{
				"name": "Editor-in-Chief",
				"salience": 0.0015390653,
				"type": "PERSON"
			},
			{
				"name": "Search",
				"salience": 0.0015390653,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0013007559,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.001149818,
				"type": "OTHER"
			},
			{
				"name": "comedy",
				"salience": 0.001149818,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Most",
				"salience": 0.0010791895,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0009474124,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0009474124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lq3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electoral_College_(United_States)"
				},
				"name": "Electoral College",
				"salience": 0.0007077392,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0007077392,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://addictinginfo.addictinginfoent.netdna-cdn.com/wp-content/uploads/2016/11/simpsonstrump.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-15T11:36:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 14, 2016 11:36 pm · \nIn reaction to Donald Trump’s victory, The Simpsons decided to update their 2000 prediction of a Trump presidency. \nIn 2000, the show showed a glimpse into the future where President Lisa Simpson inherited an economic mess from “President Trump.” Well, now that fictional story line has become a horrifying reality. \nHere is The Simpsons new opening with Bart Simpson writing on the chalkboard, “BEING RIGHT SUCKS”: The Simpsons updates its 2000 prediction of a Trump Presidency… #TheSimpsons pic.twitter.com/Myf5rYb9Dj \n— The Simpsons (@TheSimpsons) November 14, 2016 \nHopefully, the financial despair the fictional President Trump never becomes a reality, but seeing as he has no experience, is a businessman who’s not as good as he says he is, and The Simpsons have been right thus far, the future’s looking pretty bleak. \nHere’s the original clip of President Lisa Simpson calling out a Donald Trump presidency for his fiscal fallout and bad economy: \nEarly on into Trump’s campaign, The Simpsons satirized the reality TV host turned president-elect by having Homer Simpson somehow at the campaign rollout and falling into Trump’s hair. If we could only go back to that moment and enjoy the comedy over reality. \nNow we have to reap what we’ve sown, or rather what the less than half of voting Americans have sown considering Trump only won with the Electoral College and lost the popular vote to Hillary Clinton in his own words, big league. \nMost of us with The Simpsons were very wrong with the prediction as well. \nFeatured image via video screen capture Share this Article! Author: Sarah Sarah is a liberal writer who's been writing and commenting on politics for over 5 years as the Opinionated Democrat on Facebook. She is also the founder and Editor-in-Chief of the online satirical publication Free Wood Post. Search",
		"thread_title": "‘The Simpsons’ React To Their Trump Election Prediction, And They’re NOT Happy (VIDEO)",
		"title": "‘The Simpsons’ React To Their Trump Election Prediction, And They’re NOT Happy (VIDEO)",
		"type": "bias",
		"uuid": "3e090ff222967720007c6e7c63d562d740f10ce2"
	},
	"-KhIb9mmisjFKHOPpRpT": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-18T01:28:17.798+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.7804619,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.037346512,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.032580983,
				"type": "PERSON"
			},
			{
				"name": "budget",
				"salience": 0.022704653,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.00921794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0067082583,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.0054258867,
				"type": "PERSON"
			},
			{
				"name": "nightmare",
				"salience": 0.005004247,
				"type": "EVENT"
			},
			{
				"name": "election win",
				"salience": 0.0046599014,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0046599014,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0040373644,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0040373644,
				"type": "PERSON"
			},
			{
				"name": "chair",
				"salience": 0.0034256233,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.002872744,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0027924327,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xh64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Debbie_Stabenow"
				},
				"name": "Debbie Stabenow",
				"salience": 0.0026657106,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0024883577,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.0024883577,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0021956346,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0021290467,
				"type": "OTHER"
			},
			{
				"name": "outreach",
				"salience": 0.001922621,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0016651509,
				"type": "OTHER"
			},
			{
				"name": "caucus meeting",
				"salience": 0.0016651509,
				"type": "EVENT"
			},
			{
				"name": "Vermont Senator",
				"salience": 0.0015906283,
				"type": "PERSON"
			},
			{
				"name": "outreach",
				"salience": 0.0015899827,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "United States Congress",
				"salience": 0.0015774632,
				"type": "ORGANIZATION"
			},
			{
				"name": "wreck",
				"salience": 0.0014485735,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0014192389,
				"type": "ORGANIZATION"
			},
			{
				"name": "families",
				"salience": 0.0013485609,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0013485609,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0013485609,
				"type": "EVENT"
			},
			{
				"name": "position",
				"salience": 0.0013485609,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0013425427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0013112255,
				"type": "PERSON"
			},
			{
				"name": "Senator",
				"salience": 0.0013032601,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0012194169,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0012194169,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0011880718,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0011739313,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.0011678757,
				"type": "EVENT"
			},
			{
				"name": "billionaires",
				"salience": 0.0011678757,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0011243104,
				"type": "ORGANIZATION"
			},
			{
				"name": "priorities",
				"salience": 0.0011243104,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0011010877,
				"type": "OTHER"
			},
			{
				"name": "grassroots message",
				"salience": 0.0011010877,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.001046662,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ttk_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hill_(newspaper)"
				},
				"name": "The Hill",
				"salience": 0.0010253387,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.0009780078,
				"type": "PERSON"
			},
			{
				"name": "vision",
				"salience": 0.0009535278,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.0009535278,
				"type": "EVENT"
			},
			{
				"name": "popularity",
				"salience": 0.0009535278,
				"type": "OTHER"
			},
			{
				"name": "needs",
				"salience": 0.0008949729,
				"type": "OTHER"
			},
			{
				"name": "win",
				"salience": 0.0008226552,
				"type": "EVENT"
			},
			{
				"name": "caucus",
				"salience": 0.0008226552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0007993094,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.000712382,
				"type": "LOCATION"
			},
			{
				"name": "politicians",
				"salience": 0.000712382,
				"type": "PERSON"
			},
			{
				"name": "promotion",
				"salience": 0.000712382,
				"type": "OTHER"
			},
			{
				"name": "talent",
				"salience": 0.000712382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041t_8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate_Committee_on_the_Budget"
				},
				"name": "Senate Budget Committee",
				"salience": 0.00069216336,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.00067786046,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07_f2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vermont"
				},
				"name": "Vermont",
				"salience": 0.00067786046,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.00063037017,
				"type": "EVENT"
			},
			{
				"name": "issues",
				"salience": 0.00059919746,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00059919746,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00059919746,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00059919746,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00059919746,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.00059919746,
				"type": "WORK_OF_ART"
			},
			{
				"name": "human rights",
				"salience": 0.00051886204,
				"type": "OTHER"
			},
			{
				"name": "magazine",
				"salience": 0.00051886204,
				"type": "WORK_OF_ART"
			},
			{
				"name": "forms",
				"salience": 0.00051886204,
				"type": "OTHER"
			},
			{
				"name": "Search",
				"salience": 0.00051886204,
				"type": "OTHER"
			},
			{
				"name": "Author",
				"salience": 0.00051886204,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.00051886204,
				"type": "WORK_OF_ART"
			},
			{
				"name": "workers",
				"salience": 0.0004476207,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0004476207,
				"type": "PERSON"
			},
			{
				"name": "responsibility",
				"salience": 0.0004476207,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.0004456213,
				"type": "OTHER"
			},
			{
				"name": "passion",
				"salience": 0.0004289866,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.0004235808,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0004129726,
				"type": "OTHER"
			},
			{
				"name": "nerve",
				"salience": 0.00038759943,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00038759943,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00038759943,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.00036881078,
				"type": "ORGANIZATION"
			},
			{
				"name": "website",
				"salience": 0.00035467348,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00033712972,
				"type": "OTHER"
			},
			{
				"name": "Addicting Info",
				"salience": 0.00031935368,
				"type": "OTHER"
			},
			{
				"name": "Vera My",
				"salience": 0.00031935368,
				"type": "PERSON"
			},
			{
				"name": "Zach Gibson",
				"salience": 0.00031935368,
				"type": "PERSON"
			},
			{
				"name": "Alex Wong",
				"salience": 0.00031935368,
				"type": "PERSON"
			},
			{
				"name": "D-Mich",
				"salience": 0.00023855089,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-17T04:56:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 16, 2016 4:56 pm · \nIt was just a few days ago that Bernie Sanders responded to Trump’s election win with the perfect message from Democrats. He said : \n“If Donald Trump takes people’s anger and turns it against Muslims, Hispanics, African Americans and women, we will be his worst nightmare.” \nAnd from what was just announced, it seems that Sanders has every intention of making good on that warning. Earlier today, the Vermont Senator was named chair of outreach during a closed-door Senate Democrat caucus meeting, according to The Hill . In his new role, Sanders will lead outreach to blue-collar voters — the very voters who became Trump supporters this year. Sanders will also be the ranking member on the Senate Budget Committee. Acknowledging that he has a “heavy responsibility to help shape the priorities of the United States government,” Sanders said: “I’m going to do everything that I can to make sure that the budget that leaves the United States Congress is a budget that represents the needs of working families and a shrinking middle class and not billionaires.” With the announcement of Sanders’ new position, Trump is definitely going to be a nervous wreck. He’s spent his entire presidential campaign claiming that he would help the working class, and now Sanders is in the position to challenge him and hold him to it for the next four years. By elevating Sanders to this new role, Democrats are moving to a more grassroots message, fully aware that Sanders’ presidential campaign and vision for America resonated with many voters. As we saw with Sanders’ popularity in the primaries, the Vermont Senator struck a nerve with workers and families, making him the perfect candidate to go up against Trump as he takes office. Sen. Debbie Stabenow (D-Mich.) commented on Sanders’ new responsibility: “We want to expand on that, and he will be reaching out to all our allies. We have a tremendous amount of talent in our caucus and we want to make sure everyone is contributing.” Sanders hardly needed this promotion to upset Trump, as he’s been one of the most outspoken politicians on Twitter since Trump’s win: Twitter Twitter Twitter \nHowever, Sanders’ new role is great news for our country, and we know he’s going to give Trump hell. \nFeatured image via Zach Gibson and Alex Wong / Getty Images Share this Article! Author: Vera My passion is bringing attention to human rights and equality issues. In addition to writing for Addicting Info, I also run a website and digital magazine dedicated to social issues and promoting equality in all forms. Search ",
		"thread_title": "Bernie Sanders Rises In The Senate, Prepares To Become Trump’s WORST Nightmare (TWEETS) | Addicting Info | The Knowledge You Crave",
		"title": "Bernie Sanders Rises In The Senate, Prepares To Become Trump’s WORST Nightmare (TWEETS) | Addicting Info | The Knowledge You Crave",
		"type": "bias",
		"uuid": "4e23cd2cece886f25c82aa54c0e34451a6e2e591"
	},
	"-KhIbA2VgebecmOw-on0": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-22T16:26:47.977+02:00",
		"domain_rank": "5772",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.66960776,
				"type": "PERSON"
			},
			{
				"name": "press access",
				"salience": 0.040848028,
				"type": "OTHER"
			},
			{
				"name": "TV execs",
				"salience": 0.026613351,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.025573602,
				"type": "ORGANIZATION"
			},
			{
				"name": "meeting",
				"salience": 0.011029444,
				"type": "EVENT"
			},
			{
				"name": "press",
				"salience": 0.010487303,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.010487303,
				"type": "EVENT"
			},
			{
				"name": "television networks",
				"salience": 0.008521668,
				"type": "ORGANIZATION"
			},
			{
				"name": "liars",
				"salience": 0.0063870675,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0061632902,
				"type": "EVENT"
			},
			{
				"name": "truth",
				"salience": 0.0061632902,
				"type": "OTHER"
			},
			{
				"name": "President-elect",
				"salience": 0.0061632902,
				"type": "PERSON"
			},
			{
				"name": "record",
				"salience": 0.0061632902,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.004608015,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0043480564,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0041704644,
				"type": "EVENT"
			},
			{
				"name": "Kellyanne Conway",
				"salience": 0.0041464274,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.003989158,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.003883841,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0034621905,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.0032498257,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.003197018,
				"type": "EVENT"
			},
			{
				"name": "press",
				"salience": 0.003197018,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.003185963,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0031458782,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0029258404,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.002545346,
				"type": "EVENT"
			},
			{
				"name": "protocol press pools",
				"salience": 0.0025416678,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.002489193,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0024673168,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.002267803,
				"type": "EVENT"
			},
			{
				"name": "temper tantrum",
				"salience": 0.0021832278,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.0021737372,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0021286013,
				"type": "OTHER"
			},
			{
				"name": "anchors",
				"salience": 0.0020583973,
				"type": "OTHER"
			},
			{
				"name": "disrespect",
				"salience": 0.0020492107,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_ss2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeff_Zucker"
				},
				"name": "Jeff Zucker",
				"salience": 0.0020436565,
				"type": "PERSON"
			},
			{
				"name": "networks",
				"salience": 0.002014613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0019555262,
				"type": "ORGANIZATION"
			},
			{
				"name": "board room",
				"salience": 0.0018612646,
				"type": "LOCATION"
			},
			{
				"name": "room",
				"salience": 0.0018612646,
				"type": "LOCATION"
			},
			{
				"name": "meetings",
				"salience": 0.0018543443,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0018071997,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.00178259,
				"type": "ORGANIZATION"
			},
			{
				"name": "firing squad",
				"salience": 0.00178259,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.001722777,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0017160905,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.0017160905,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0017160905,
				"type": "OTHER"
			},
			{
				"name": "proportions",
				"salience": 0.0017160905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g12y5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chuck_Todd"
				},
				"name": "Chuck Todd",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k2cjhd"
				},
				"name": "James Goldston",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06jvj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lester_Holt"
				},
				"name": "Lester Holt",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0015650175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jkzb24",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deborah_Turness"
				},
				"name": "Deborah Turness",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0015650175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027j7l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Stephanopoulos"
				},
				"name": "George Stephanopoulos",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fg6cv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Muir"
				},
				"name": "David Muir",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0brnz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Martha_Raddatz"
				},
				"name": "Martha Raddatz",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07hm8x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norah_O'Donnell"
				},
				"name": "Norah O'Donnell",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02919h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charlie_Rose"
				},
				"name": "Charlie Rose",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"name": "Bill Shine",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"name": "Jack Abernethy",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"name": "Jay Wallace",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"name": "Suzanne Scott",
				"salience": 0.0015650175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09d5h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS"
				},
				"name": "CBS",
				"salience": 0.0015650175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.0015650175,
				"type": "ORGANIZATION"
			},
			{
				"name": "source",
				"salience": 0.0015506252,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0015310957,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.0015052373,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0014994653,
				"type": "PERSON"
			},
			{
				"name": "claim",
				"salience": 0.0014554046,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0013507731,
				"type": "EVENT"
			},
			{
				"name": "executives",
				"salience": 0.001255641,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "The New York Post",
				"salience": 0.0010974173,
				"type": "WORK_OF_ART"
			},
			{
				"name": "networks",
				"salience": 0.0010964051,
				"type": "OTHER"
			},
			{
				"name": "mistakes",
				"salience": 0.0010873222,
				"type": "OTHER"
			},
			{
				"name": "shortcomings",
				"salience": 0.0010873222,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0010873222,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0010825924,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dkg24",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Erin_Burnett"
				},
				"name": "Erin Burnett",
				"salience": 0.0010564611,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x6ptd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phil_Griffin"
				},
				"name": "Phil Griffin",
				"salience": 0.0010564611,
				"type": "PERSON"
			},
			{
				"name": "network",
				"salience": 0.0010421891,
				"type": "OTHER"
			},
			{
				"name": "liar",
				"salience": 0.0010421891,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00091456156,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00091456156,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00091456156,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.00091456156,
				"type": "WORK_OF_ART"
			},
			{
				"name": "issues",
				"salience": 0.00091456156,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00091456156,
				"type": "OTHER"
			},
			{
				"name": "liars",
				"salience": 0.00081906933,
				"type": "PERSON"
			},
			{
				"name": "nerve",
				"salience": 0.00081228284,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.00079194165,
				"type": "WORK_OF_ART"
			},
			{
				"name": "human rights",
				"salience": 0.00079194165,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.00079194165,
				"type": "OTHER"
			},
			{
				"name": "Search",
				"salience": 0.00079194165,
				"type": "OTHER"
			},
			{
				"name": "magazine",
				"salience": 0.00079194165,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Author",
				"salience": 0.00079194165,
				"type": "PERSON"
			},
			{
				"name": "room",
				"salience": 0.00075667986,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0007432883,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0007187529,
				"type": "PERSON"
			},
			{
				"name": "news anchors",
				"salience": 0.0007096958,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.00068320334,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0006692761,
				"type": "PERSON"
			},
			{
				"name": "attention",
				"salience": 0.0006581591,
				"type": "OTHER"
			},
			{
				"name": "passion",
				"salience": 0.0006547615,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00059159123,
				"type": "EVENT"
			},
			{
				"name": "name",
				"salience": 0.00059159123,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.00059159123,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.00056291366,
				"type": "ORGANIZATION"
			},
			{
				"name": "website",
				"salience": 0.0005413356,
				"type": "OTHER"
			},
			{
				"name": "press access",
				"salience": 0.00053218746,
				"type": "OTHER"
			},
			{
				"name": "Addicting Info",
				"salience": 0.00048742644,
				"type": "OTHER"
			},
			{
				"name": "Vera My",
				"salience": 0.00048742644,
				"type": "PERSON"
			},
			{
				"name": "Christopher Furlong",
				"salience": 0.00048742644,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-22T07:58:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "addictinginfo.org",
		"spam_score": "0",
		"text": "on November 21, 2016 7:58 pm · \nDonald Trump has had a rocky relationship with the press ever since his presidential campaign, and he’s only punished them further for trying to report the truth since becoming the President-elect. \nOn Monday, Trump was set to have an off the record meeting with television networks to try and hash out presidential press access. This meeting was particularly important because Trump has previously limited press access, and has ditched two protocol press pools since getting elected. \nSome reporters in attendance were NBC’s Deborah Turness, Lester Holt and Chuck Todd; ABC’s James Goldston, George Stephanopoulos, David Muir and Martha Raddatz; CBS’ Norah O’Donnell and Charlie Rose; Fox News’ Bill Shine, Jack Abernethy, Jay Wallace, Suzanne Scott; MSNBC’s Phil Griffin; and CNN’s Jeff Zucker and Erin Burnett. It was a good group, and it could have been a very effective meeting if only things had gone according to plan. \nUnfortunately, instead of having a respectful conversation and coming up with an amicable way to move forward, what the press got was a baby Trump temper tantrum of epic proportions. Or, as one person put it , “It was like a f*cking firing squad.” \nTrump made zero attempt to hide his disrespect for the media. According to The New York Post , one anonymous source said: \n“The meeting was a total disaster. The TV execs and anchors went in there thinking they would be discussing the access they would get to the Trump administration, but instead they got a Trump-style dressing down.” \nThis claim was backed up by another person, who said: \n“The meeting took place in a big board room and there were about 30 or 40 people, including the big news anchors from all the networks. \n“Trump kept saying, ‘We’re in a room of liars, the deceitful dishonest media who got it all wrong. He addressed everyone in the room calling the media dishonest, deceitful liars. He called out Jeff Zucker by name and said everyone at CNN was a liar, and CNN was network of liars.” \nThis attack left reporters stunned, and even as they tried to keep bringing up press access to stay on topic, Trump barely let them speak. While this is certainly shocking, this behavior is completely typical of Trump. He has always hated the free press because it has held him accountable and reported on his mistakes and shortcomings. \nAmericans on social media are already coming to terms with how terrifying this is: Twitter Twitter Twitter \nInterestingly enough, Trump spokeswoman Kellyanne Conway had the nerve to say the meeting went well. She said: \n“Excellent meetings with the top executives of the major networks. Pretty unprecedented meeting we put together in two days.” \nDisgraceful. \nFeatured image by Christopher Furlong via Getty Images Share this Article! Author: Vera My passion is bringing attention to human rights and equality issues. In addition to writing for Addicting Info, I also run a website and digital magazine dedicated to social issues and promoting equality in all forms. Search ",
		"thread_title": "Trump ERUPTS At Secret Meeting With The Press, Transition In Chaos (TWEETS) | Addicting Info | The Knowledge You Crave",
		"title": "Trump ERUPTS At Secret Meeting With The Press, Transition In Chaos (TWEETS) | Addicting Info | The Knowledge You Crave",
		"type": "bias",
		"uuid": "1dc6ff5a17dbaae65f902edc49ea475a4ceb892a"
	},
	"-KhIbAAGeVp0eQO08x4Q": {
		"author": "Day of the Dead 2015: History, food and reflections – Andrea Lawson Gray",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:25:28.782+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "adobochron",
				"salience": 0.27382895,
				"type": "OTHER"
			},
			{
				"name": "Comments",
				"salience": 0.059629854,
				"type": "WORK_OF_ART"
			},
			{
				"name": "city hall officials",
				"salience": 0.059629854,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco",
				"salience": 0.055664524,
				"type": "LOCATION"
			},
			{
				"name": "making",
				"salience": 0.051816057,
				"type": "OTHER"
			},
			{
				"name": "matches",
				"salience": 0.051816057,
				"type": "EVENT"
			},
			{
				"name": "representatives",
				"salience": 0.051816057,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lq2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halloween"
				},
				"name": "Halloween",
				"salience": 0.032677688,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.032172084,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.021984296,
				"type": "ORGANIZATION"
			},
			{
				"name": "merchants",
				"salience": 0.021613752,
				"type": "PERSON"
			},
			{
				"name": "homeowners",
				"salience": 0.021613752,
				"type": "PERSON"
			},
			{
				"name": "Registrants",
				"salience": 0.019971557,
				"type": "PERSON"
			},
			{
				"name": "registry",
				"salience": 0.018780077,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.017359987,
				"type": "EVENT"
			},
			{
				"name": "Castro Halloween",
				"salience": 0.013700687,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.013649262,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/036qbx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sisters_of_Perpetual_Indulgence"
				},
				"name": "Sisters of Perpetual Indulgence",
				"salience": 0.0133498935,
				"type": "ORGANIZATION"
			},
			{
				"name": "district",
				"salience": 0.011085752,
				"type": "LOCATION"
			},
			{
				"name": "event",
				"salience": 0.009945975,
				"type": "EVENT"
			},
			{
				"name": "city hall",
				"salience": 0.00990451,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.008983642,
				"type": "OTHER"
			},
			{
				"name": "city officials",
				"salience": 0.008983642,
				"type": "PERSON"
			},
			{
				"name": "bash",
				"salience": 0.008502793,
				"type": "OTHER"
			},
			{
				"name": "revelers",
				"salience": 0.007782745,
				"type": "PERSON"
			},
			{
				"name": "Stabbing",
				"salience": 0.007782745,
				"type": "EVENT"
			},
			{
				"name": "shooting",
				"salience": 0.007782745,
				"type": "EVENT"
			},
			{
				"name": "parade",
				"salience": 0.0074930675,
				"type": "OTHER"
			},
			{
				"name": "tourist attraction",
				"salience": 0.0074930675,
				"type": "LOCATION"
			},
			{
				"name": "agreement",
				"salience": 0.0073386324,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0073386324,
				"type": "PERSON"
			},
			{
				"name": "IDs",
				"salience": 0.005531017,
				"type": "OTHER"
			},
			{
				"name": "entry",
				"salience": 0.0054859146,
				"type": "OTHER"
			},
			{
				"name": "identification cards",
				"salience": 0.004751584,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fy9k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pride_parade"
				},
				"name": "Pride",
				"salience": 0.0046169097,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03fwj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Folsom_Street_Fair"
				},
				"name": "Folsom Street Fair",
				"salience": 0.0046169097,
				"type": "EVENT"
			},
			{
				"name": "entrances",
				"salience": 0.0039975345,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hn10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LGBT"
				},
				"name": "LGBTQ",
				"salience": 0.0039161523,
				"type": "ORGANIZATION"
			},
			{
				"name": "gay registry",
				"salience": 0.0035805912,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0034621258,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.0029738534,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_v7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Identity_document"
				},
				"name": "ID",
				"salience": 0.002926344,
				"type": "ORGANIZATION"
			},
			{
				"name": "oath",
				"salience": 0.0027561493,
				"type": "OTHER"
			},
			{
				"name": "transgender",
				"salience": 0.00258694,
				"type": "OTHER"
			},
			{
				"name": "questioning",
				"salience": 0.00258694,
				"type": "OTHER"
			},
			{
				"name": "lesbian",
				"salience": 0.00258694,
				"type": "PERSON"
			},
			{
				"name": "Boo!",
				"salience": 0.0021317368,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2013/10/image16.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T05:18:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 10 Comments \nSan Francisco, California – It was an agreement four years in the making, oftentimes marred by shouting matches among city hall officials, representatives of the Sisters of Perpetual Indulgence, merchants and homeowners. But the Halloween party in San Francisco’s gay Castro district finally returns in 2014. \nIt will be recalled that the Halloween bash attracted as many as 500,000 each year and has become a major tourist attraction, second and third only to the Pride parade and Folsom Street Fair. Stabbing and shooting incidents, believed to be perpetrated by straight revelers, prompted city officials to permanently ban the event beginning in 2010. \nAs part of the agreement, the “new” Castro Halloween will be open only to members of the LGBTQ community who will have to register with city hall and be included in a “gay registry.” Registrants, who will take an oath admitting that they are gay, lesbian, bisexual, transgender or questioning, will be issued special identification cards linked to the official registry. The IDs will be the only accepted pass to gain entry to the Halloween event. ID’s will be scanned at entrances to the event to confirm that individuals are listed in the official registry. \nGet ready to say “Boo!” Again. Rate this:",
		"thread_title": "Comment on HALLOWEEN IN THE CASTRO RETURNS IN 2014! by Day of the Dead 2015: History, food and reflections – Andrea Lawson Gray",
		"title": "Comment on HALLOWEEN IN THE CASTRO RETURNS IN 2014! by Day of the Dead 2015: History, food and reflections – Andrea Lawson Gray",
		"type": "fake",
		"uuid": "504e8fa4469d75f8d22984220568e3313c74a1b7"
	},
	"-KhIbAPQGJYvcYryhnJm": {
		"author": "Ivan Jose",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T09:18:46.193+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "jeepney",
				"salience": 0.33464402,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0195pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manila"
				},
				"name": "MANILA",
				"salience": 0.08155186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.07456431,
				"type": "LOCATION"
			},
			{
				"name": "Many",
				"salience": 0.055652708,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07pbjfg"
				},
				"name": "Driver",
				"salience": 0.045945086,
				"type": "PERSON"
			},
			{
				"name": "nationals",
				"salience": 0.032255113,
				"type": "PERSON"
			},
			{
				"name": "adobochron",
				"salience": 0.019755276,
				"type": "OTHER"
			},
			{
				"name": "tutorial",
				"salience": 0.018239226,
				"type": "WORK_OF_ART"
			},
			{
				"name": "towns",
				"salience": 0.017127626,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.017127626,
				"type": "LOCATION"
			},
			{
				"name": "mass transportation",
				"salience": 0.017127626,
				"type": "OTHER"
			},
			{
				"name": "Comment",
				"salience": 0.017127626,
				"type": "WORK_OF_ART"
			},
			{
				"name": "room",
				"salience": 0.01539371,
				"type": "LOCATION"
			},
			{
				"name": "Manila Bureau",
				"salience": 0.010574059,
				"type": "ORGANIZATION"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.010574059,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.010132949,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.008779574,
				"type": "OTHER"
			},
			{
				"name": "etiquette",
				"salience": 0.008779574,
				"type": "OTHER"
			},
			{
				"name": "tricks",
				"salience": 0.008779574,
				"type": "OTHER"
			},
			{
				"name": "fare",
				"salience": 0.00873001,
				"type": "OTHER"
			},
			{
				"name": "driver",
				"salience": 0.0074782334,
				"type": "PERSON"
			},
			{
				"name": "jeepneys",
				"salience": 0.0068332506,
				"type": "OTHER"
			},
			{
				"name": "mask",
				"salience": 0.005858492,
				"type": "OTHER"
			},
			{
				"name": "ride",
				"salience": 0.0054691895,
				"type": "EVENT"
			},
			{
				"name": "jeepney",
				"salience": 0.0046163416,
				"type": "OTHER"
			},
			{
				"name": "jeepney",
				"salience": 0.0046163416,
				"type": "OTHER"
			},
			{
				"name": "jeepney",
				"salience": 0.0046163416,
				"type": "OTHER"
			},
			{
				"name": "Para po",
				"salience": 0.0045846254,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.004181431,
				"type": "OTHER"
			},
			{
				"name": "passengers",
				"salience": 0.004062673,
				"type": "PERSON"
			},
			{
				"name": "Bayad po",
				"salience": 0.003974231,
				"type": "OTHER"
			},
			{
				"name": "jeepney",
				"salience": 0.0039157975,
				"type": "OTHER"
			},
			{
				"name": "fare",
				"salience": 0.0038613884,
				"type": "OTHER"
			},
			{
				"name": "passsenger",
				"salience": 0.0038134328,
				"type": "PERSON"
			},
			{
				"name": "bus stops",
				"salience": 0.0036841147,
				"type": "LOCATION"
			},
			{
				"name": "fare",
				"salience": 0.003670667,
				"type": "OTHER"
			},
			{
				"name": "smell",
				"salience": 0.003621526,
				"type": "OTHER"
			},
			{
				"name": "smoke",
				"salience": 0.003621526,
				"type": "OTHER"
			},
			{
				"name": "balikbayan",
				"salience": 0.003621526,
				"type": "OTHER"
			},
			{
				"name": "gasoline",
				"salience": 0.003621526,
				"type": "OTHER"
			},
			{
				"name": "driver",
				"salience": 0.0033914018,
				"type": "PERSON"
			},
			{
				"name": "driver",
				"salience": 0.0033914018,
				"type": "PERSON"
			},
			{
				"name": "driver",
				"salience": 0.0033914018,
				"type": "PERSON"
			},
			{
				"name": "passenger",
				"salience": 0.0032345378,
				"type": "PERSON"
			},
			{
				"name": "passengers",
				"salience": 0.0032345378,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Filipinos",
				"salience": 0.0031994588,
				"type": "PERSON"
			},
			{
				"name": "capacity",
				"salience": 0.003150535,
				"type": "OTHER"
			},
			{
				"name": "premium spot",
				"salience": 0.0030854866,
				"type": "OTHER"
			},
			{
				"name": "jeepney",
				"salience": 0.002926213,
				"type": "OTHER"
			},
			{
				"name": "fare",
				"salience": 0.0027429473,
				"type": "OTHER"
			},
			{
				"name": "fares",
				"salience": 0.0027429473,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.002672138,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.0025400822,
				"type": "OTHER"
			},
			{
				"name": "butt",
				"salience": 0.0025400822,
				"type": "OTHER"
			},
			{
				"name": "cash payment",
				"salience": 0.0025400822,
				"type": "OTHER"
			},
			{
				"name": "peso bills",
				"salience": 0.0025400822,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.002445336,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.002445336,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0023948306,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0023948306,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.002209583,
				"type": "LOCATION"
			},
			{
				"name": "another",
				"salience": 0.0020739113,
				"type": "OTHER"
			},
			{
				"name": "fare",
				"salience": 0.001998163,
				"type": "OTHER"
			},
			{
				"name": "fare",
				"salience": 0.001998163,
				"type": "OTHER"
			},
			{
				"name": "driver",
				"salience": 0.0018460264,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0017892792,
				"type": "PERSON"
			},
			{
				"name": "seniors",
				"salience": 0.0017892792,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.0017892792,
				"type": "OTHER"
			},
			{
				"name": "jeepney driver",
				"salience": 0.0016892836,
				"type": "PERSON"
			},
			{
				"name": "body odor",
				"salience": 0.0015892319,
				"type": "OTHER"
			},
			{
				"name": "Barya lang po sa umaga",
				"salience": 0.0015638293,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lp63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeepney"
				},
				"name": "Jeepney",
				"salience": 0.0015638293,
				"type": "ORGANIZATION"
			},
			{
				"name": "worries",
				"salience": 0.0015494447,
				"type": "OTHER"
			},
			{
				"name": "roof",
				"salience": 0.0015494447,
				"type": "OTHER"
			},
			{
				"name": "senior",
				"salience": 0.0015494447,
				"type": "PERSON"
			},
			{
				"name": "fare",
				"salience": 0.0014928383,
				"type": "OTHER"
			},
			{
				"name": "fare",
				"salience": 0.0014928383,
				"type": "OTHER"
			},
			{
				"name": "student",
				"salience": 0.0013032751,
				"type": "PERSON"
			},
			{
				"name": "seniors",
				"salience": 0.0013032751,
				"type": "PERSON"
			},
			{
				"name": "hand rails",
				"salience": 0.0011285483,
				"type": "OTHER"
			},
			{
				"name": "jeepney entrance",
				"salience": 0.0011285483,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011285483,
				"type": "PERSON"
			},
			{
				"name": "disabilities",
				"salience": 0.0011285483,
				"type": "OTHER"
			},
			{
				"name": "stop",
				"salience": 0.0010373275,
				"type": "LOCATION"
			},
			{
				"name": "mobile phone",
				"salience": 0.0008430529,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "phrases",
				"salience": 0.0008430529,
				"type": "OTHER"
			},
			{
				"name": "jeepney sign",
				"salience": 0.0007332804,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0003007323,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/10/img_6705.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T09:18:46.193+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 1 Comment \nMANILA, Philippines (The Adobo Chronicles, Manila Bureau) – This is a tutorial on how to ride the jeepney which is an important mode of mass transportation in many cities and towns in the Philippines. \nMany of you may already be familiar with these rules, etiquette and tricks but for those who are visiting the country for the first time or are returning nationals (balikbayan) who have been away for a long time, you might want to keep this tutorial handy. First of all, not all jeepneys you encounter are as colorful, shiny and clean as the one pictured here. If you are bothered by smoke or the smell of gasoline, remember to always carry and wear a disposable surgical mask. It also helps with, you know, body odor. In most cases, there are no jeepney stops like there are bus stops. Wherever you are, be rest assured that so long as there is room for one more passsenger, the jeepney will stop for you. Speaking of room, when the driver says the capacity of his jeepney is 10 passengers on either side, you can’t argue. Ten means ten, even if only half your butt sits comfortably on the padded seat. Only cash payment is accepted, but you probably already know that. Exact fare is appreciated but Mr. Driver is happy to provide change except very early in the day. “Barya lang po sa umaga!” No five hundred peso bills in the morning, please. Jeepney fare is passed on from one passenger to another until it reaches the driver. The same is true for any change back due the passenger. It takes a village to ride the jeepney you know. If you don’t want to be bothered by other passengers asking you to pass on the fare to the driver, sit as far as possible from the driver, assuming that premium spot is vacant. The jeepney driver would appreciate it so much if you pay your fare before you start texting on your mobile phone. “God knows who doesn’t pay,” says one jeepney sign. There are two phrases you need to learn when riding the jeepney: “Bayad po” (here’s my fare) and “Para po” (this is my stop). If you don’t speak the language, no worries. Just pass on your fare to the passenger next to you and he or she will know what to do. And if you need to disembark, just knock on the jeepney’s roof. It also means “please stop.” There are discounted fares for students and seniors. Be sure to say “one senior” or “one student” when paying your fare. Otherwise, you pay full fare. Filipinos have learned to respect seniors and people with disabilities. The spot closest to the jeepney entrance (farthest from the driver) is reserved for them. Isn’t that nice? As always, hold on to the hand rails. It can be a very bumpy ride. Rate this:",
		"thread_title": "Comment on Tutorial: Riding The Philippine Jeepney by Ivan Jose",
		"title": "Comment on Tutorial: Riding The Philippine Jeepney by Ivan Jose",
		"type": "fake",
		"uuid": "20e1a45f760f8db5f26207bbfe827bf8cd6d65bb"
	},
	"-KhIbAXjV2CkSPs035SA": {
		"author": "Tony Rabon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T19:56:09.149+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Comerford WASHINGTON, D.C.",
				"salience": 0.28465253,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07fx7n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cristeta_Comerford"
				},
				"name": "Cristeta Comerford",
				"salience": 0.11311632,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.09906117,
				"type": "PERSON"
			},
			{
				"name": "adobochron",
				"salience": 0.08879788,
				"type": "OTHER"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.044917144,
				"type": "OTHER"
			},
			{
				"name": "Washington Bureau",
				"salience": 0.033230655,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.033230655,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.023784867,
				"type": "PERSON"
			},
			{
				"name": "pancit",
				"salience": 0.022469014,
				"type": "OTHER"
			},
			{
				"name": "meal",
				"salience": 0.022283852,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.018441172,
				"type": "OTHER"
			},
			{
				"name": "pancit",
				"salience": 0.017678801,
				"type": "OTHER"
			},
			{
				"name": "noodle dish",
				"salience": 0.015648918,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.015468456,
				"type": "ORGANIZATION"
			},
			{
				"name": "residence",
				"salience": 0.015066843,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.015066843,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03295l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Filipino_Americans"
				},
				"name": "Filipino-American",
				"salience": 0.0137439985,
				"type": "PERSON"
			},
			{
				"name": "Filipino pancit",
				"salience": 0.013220355,
				"type": "OTHER"
			},
			{
				"name": "The Adobo",
				"salience": 0.010898601,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.009801607,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.009645217,
				"type": "LOCATION"
			},
			{
				"name": "pork adobo",
				"salience": 0.009636337,
				"type": "OTHER"
			},
			{
				"name": "pancit",
				"salience": 0.009636337,
				"type": "OTHER"
			},
			{
				"name": "predecessor",
				"salience": 0.009556656,
				"type": "PERSON"
			},
			{
				"name": "boss",
				"salience": 0.009556656,
				"type": "PERSON"
			},
			{
				"name": "Photo",
				"salience": 0.009556656,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chicken",
				"salience": 0.006964016,
				"type": "OTHER"
			},
			{
				"name": "rationale",
				"salience": 0.006964016,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.00600893,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.00600893,
				"type": "OTHER"
			},
			{
				"name": "MyBayKitchen.com",
				"salience": 0.005886577,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/10/img_6726.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T19:56:09.149+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 1 Comment Comerford \nWASHINGTON, D.C. ( The Adobo Chronicles, Washington Bureau) – White House executive chef, Filipino-American Cristeta Comerford, has revealed what she would cook for President Hillary Clinton’s first meal when she moves (back) to the presidential residence. That is, of course, assuming the Clintons will continue to retain her services. \nIt would be pancit, that signature noodle dish closely identified with the Philippines. \nWhen asked by The Adobo Chronicles why she chose pancit, Comerford said that pancit represents long life and a ‘long term,’ meaning she was hoping Hillary would be elected to a second four-year term like her predecessor and current boss, President Barack Obama. Filipino pancit (Photo: MyBayKitchen.com) \nWe were hoping she’d say “chicken or pork adobo” but we agree with her rationale for choosing pancit. Rate this:",
		"thread_title": "Comment on What White House Executive Chef Comerford Would Cook For President Hillary’s First Meal by Tony Rabon",
		"title": "Comment on What White House Executive Chef Comerford Would Cook For President Hillary’s First Meal by Tony Rabon",
		"type": "fake",
		"uuid": "9874fcff14d4af3c13954116c55590b28a5b98b8"
	},
	"-KhIbAjG0CW3pWngffE_": {
		"author": "Shirley Barnett",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:38:32.268+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0hhty1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump_Tower_Manila"
				},
				"name": "Trump Tower",
				"salience": 0.1982236,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/026r8jg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Trump"
				},
				"name": "Eric Trump",
				"salience": 0.18315782,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.11366079,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.0966129,
				"type": "LOCATION"
			},
			{
				"name": "adobochron",
				"salience": 0.038454697,
				"type": "OTHER"
			},
			{
				"name": "Comments",
				"salience": 0.034779243,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.034779243,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.03301336,
				"type": "PERSON"
			},
			{
				"name": "rendering",
				"salience": 0.030179176,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0kscy0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rodrigo_Duterte"
				},
				"name": "Rodrigo Roa Duterte",
				"salience": 0.020943133,
				"type": "PERSON"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.018671708,
				"type": "WORK_OF_ART"
			},
			{
				"name": "buildings",
				"salience": 0.018445803,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01dvzy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Makati"
				},
				"name": "Makati City",
				"salience": 0.01788499,
				"type": "LOCATION"
			},
			{
				"name": "Broadway Malyan",
				"salience": 0.010783993,
				"type": "ORGANIZATION"
			},
			{
				"name": "everything",
				"salience": 0.009664256,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.009664256,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.0094558,
				"type": "LOCATION"
			},
			{
				"name": "building",
				"salience": 0.0077248635,
				"type": "LOCATION"
			},
			{
				"name": "joint venture",
				"salience": 0.0068279402,
				"type": "ORGANIZATION"
			},
			{
				"name": "name",
				"salience": 0.006409513,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.0063901767,
				"type": "LOCATION"
			},
			{
				"name": "Century Properties Management Inc.",
				"salience": 0.005315935,
				"type": "ORGANIZATION"
			},
			{
				"name": "executive vice president of development",
				"salience": 0.0051921667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ncdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Trump_Organization"
				},
				"name": "Trump Organization",
				"salience": 0.004559156,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gywrh9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Century_Properties"
				},
				"name": "Century Properties",
				"salience": 0.004559156,
				"type": "ORGANIZATION"
			},
			{
				"name": "acquisition",
				"salience": 0.004497131,
				"type": "EVENT"
			},
			{
				"name": "corner",
				"salience": 0.004497131,
				"type": "LOCATION"
			},
			{
				"name": "project",
				"salience": 0.0043846862,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0043295207,
				"type": "OTHER"
			},
			{
				"name": "drug users",
				"salience": 0.004301521,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.00424017,
				"type": "ORGANIZATION"
			},
			{
				"name": "building permit",
				"salience": 0.0036723535,
				"type": "OTHER"
			},
			{
				"name": "persona non grata",
				"salience": 0.0036723535,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0036723535,
				"type": "OTHER"
			},
			{
				"name": "Salamanca Street",
				"salience": 0.0027695964,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0y7t1cv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kalayaan_Avenue"
				},
				"name": "Kalayaan Avenue",
				"salience": 0.0027695964,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0027441338,
				"type": "ORGANIZATION"
			},
			{
				"name": "fist fight",
				"salience": 0.0027441338,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Filipinos",
				"salience": 0.0025686873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0025686873,
				"type": "LOCATION"
			},
			{
				"name": "rehabilitation center",
				"salience": 0.0025564232,
				"type": "LOCATION"
			},
			{
				"name": "drugs",
				"salience": 0.0023083435,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.002261317,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Adobo",
				"salience": 0.002160683,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0019989845,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0019989845,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.0017246132,
				"type": "LOCATION"
			},
			{
				"name": "comments",
				"salience": 0.0017246132,
				"type": "WORK_OF_ART"
			},
			{
				"name": "terrorism links",
				"salience": 0.0014934302,
				"type": "OTHER"
			},
			{
				"name": "campaign speeches",
				"salience": 0.0014934302,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0014934302,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/08/image24.jpeg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T22:41:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.3,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 7 Comments A rendering of the Trump Tower in Makati City, Philippines \nMAKATI CITY, Philippines ( The Adobo Chronicles) – When completed by the end of 2016, the Trump Tower in the Philippines will be among the country’s tallest buildings . But the Trump name may disappear from this upscale residential building. \nLaunched in 2012, Trump Tower is a joint venture between Century Properties and the Trump Organization. It will be managed by Century Properties Management Inc. To rise at 250 meters above ground, the 56-story building is designed by award-winning international architectural firm Broadway Malyan. \n“It’s really just an iconic, modern building, very tall, very chic, something that really symbolizes everything that a Trump project means,” said Eric Trump, son of Donald, and executive vice president of development and acquisition. \nIt is located at the corner of Kalayaan Avenue and Salamanca Street in Makati City. \nBut today, Philippine President Rodrigo Roa Duterte issued an executive order canceling the building permit of the Trump Tower. \nDuterte called Donald Trump and his organization “persona non grata” for the Republican presidential candidate’s recent comments about the Philippines. \nIt will be recalled that in one of his campaign speeches, Trump lumped the Philippines with other countries with terrorism links, calling for the banning Filipinos from immigrating to the United States. Duterte even challenged Trump to a fist fight. \n“If we, Filipinos, are not welcome in the United States, why would we welcome Trump in the Philippines,” Duterte said. \nAsked by The Adobo Chronicles what the Philippine government plans to do with the Trump Tower, Duterte replied, “I will make it a rehabilitation center for the more than half a million Filipino drug users who surrendered as part of my war on drugs.” \nTouché!",
		"thread_title": "Comment on Philippines Voids Building Permit Of Trump Tower In Makati City by Shirley Barnett",
		"title": "Comment on Philippines Voids Building Permit Of Trump Tower In Makati City by Shirley Barnett",
		"type": "fake",
		"uuid": "3b136392b55de72123d5b03a3d07e575119e944d"
	},
	"-KhIbArIx7DnUvVS46bB": {
		"author": "برنامه ریزی ضمیر ناخوداگاه",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T20:52:38.316+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.26445073,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.181886,
				"type": "LOCATION"
			},
			{
				"name": "Comment",
				"salience": 0.058143064,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "SAN FRANCISCO",
				"salience": 0.041616727,
				"type": "LOCATION"
			},
			{
				"name": "The Adobo Chronicles",
				"salience": 0.036119,
				"type": "WORK_OF_ART"
			},
			{
				"name": "San Francisco Bureau",
				"salience": 0.036119,
				"type": "ORGANIZATION"
			},
			{
				"name": "bid",
				"salience": 0.03579152,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.027988104,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.025042087,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.023799002,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.021268593,
				"type": "PERSON"
			},
			{
				"name": "rightist",
				"salience": 0.019089755,
				"type": "OTHER"
			},
			{
				"name": "campaign logo",
				"salience": 0.017208701,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.015338012,
				"type": "PERSON"
			},
			{
				"name": "arrow",
				"salience": 0.012836865,
				"type": "OTHER"
			},
			{
				"name": "logo",
				"salience": 0.0120896455,
				"type": "OTHER"
			},
			{
				"name": "logo",
				"salience": 0.011640363,
				"type": "WORK_OF_ART"
			},
			{
				"name": "right",
				"salience": 0.010757294,
				"type": "OTHER"
			},
			{
				"name": "logo",
				"salience": 0.010389807,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.009313459,
				"type": "ORGANIZATION"
			},
			{
				"name": "arrow",
				"salience": 0.009127965,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.0087431185,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0087431185,
				"type": "OTHER"
			},
			{
				"name": "symbolism",
				"salience": 0.0087431185,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.008417759,
				"type": "OTHER"
			},
			{
				"name": "quest",
				"salience": 0.008417759,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.007992091,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.007845612,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.0061632344,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.0058590206,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0049735075,
				"type": "PERSON"
			},
			{
				"name": "arrow",
				"salience": 0.0049735075,
				"type": "OTHER"
			},
			{
				"name": "edge",
				"salience": 0.0045859152,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.004491266,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0043282113,
				"type": "ORGANIZATION"
			},
			{
				"name": "placement",
				"salience": 0.0038897838,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0038897838,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0038897838,
				"type": "EVENT"
			},
			{
				"name": "rightist",
				"salience": 0.0037167764,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0037167764,
				"type": "PERSON"
			},
			{
				"name": "concept",
				"salience": 0.0036976112,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0029065576,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/06/image8.jpeg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T22:17:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 1 Comment \nSAN FRANCISCO, California ( The Adobo Chronicles, San Francisco Bureau) – Now it can be told — now that Hillary Clinton is all but assured of the Democratic presidential nomination. \nFor months since the former secretary of state launched her presidential bid, her campaign logo has always symbolized America’s quest to move forward, with the arrow in the logo pointing to the right. Left-handed people, of course, dispute that symbolism because for them, moving forward should be pointing to the left. \nBut there is another school of thought about Hillary’s logo. Many believe that the arrow pointing right actually symbolizes moving to the (conservative) right as opposed to the (liberal) left. \nThe logo was a brilliant concept designed to help the Democrats win over Republican voters in the general elections — voters who will definitely choose a rightist over a leftist candidate. \nThe GOP’s presumptive nominee, Donald Trump, is perceived by many as more leftist than rightist, which would give Clinton the edge among conservative voters. \nWho knew the placement or direction of an arrow could spell victory or defeat for an American presidential candidate? Rate this:",
		"thread_title": "Comment on Hillary Clinton Campaign Logo Has A Subliminal Message by برنامه ریزی ضمیر ناخوداگاه",
		"title": "Comment on Hillary Clinton Campaign Logo Has A Subliminal Message by برنامه ریزی ضمیر ناخوداگاه",
		"type": "fake",
		"uuid": "6cc3f4a496a8124a3832867e74a1a26a9ae43232"
	},
	"-KhIbAzhVKPO2_3lk4M4": {
		"author": "adobochron",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T23:48:58.529+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0by2n5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maria_Ressa"
				},
				"name": "Maria Ressa",
				"salience": 0.46389085,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0nd3xkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rappler"
				},
				"name": "Rappler",
				"salience": 0.19752178,
				"type": "ORGANIZATION"
			},
			{
				"name": "adobochron",
				"salience": 0.038015977,
				"type": "OTHER"
			},
			{
				"name": "Comments",
				"salience": 0.033043582,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.033043582,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Mocha Uson",
				"salience": 0.029799527,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0195pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manila"
				},
				"name": "MANILA",
				"salience": 0.023654675,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.021942753,
				"type": "ORGANIZATION"
			},
			{
				"name": "Manila Bureau",
				"salience": 0.020530744,
				"type": "ORGANIZATION"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.020530744,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Internet",
				"salience": 0.0187355,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.012101216,
				"type": "LOCATION"
			},
			{
				"name": "news sites",
				"salience": 0.010266831,
				"type": "OTHER"
			},
			{
				"name": "XVI",
				"salience": 0.010097911,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03v78v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omidyar_Network"
				},
				"name": "Omidyar Network",
				"salience": 0.0075568953,
				"type": "ORGANIZATION"
			},
			{
				"name": "proliferation",
				"salience": 0.007079717,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.0055622915,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.0055281343,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0055242875,
				"type": "PERSON"
			},
			{
				"name": "reader engagements",
				"salience": 0.004785924,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.004785924,
				"type": "OTHER"
			},
			{
				"name": "news organization",
				"salience": 0.004785924,
				"type": "ORGANIZATION"
			},
			{
				"name": "trolls",
				"salience": 0.004785924,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0046284245,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lq2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halloween"
				},
				"name": "Halloween",
				"salience": 0.0043655764,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f7lr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Constitution_of_the_Philippines"
				},
				"name": "Philippine Constitution",
				"salience": 0.002841326,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mass media",
				"salience": 0.0019239656,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0016526019,
				"type": "PERSON"
			},
			{
				"name": "Section 11",
				"salience": 0.0010174405,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/11/img_6773.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T23:48:58.529+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": 0
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 2 Comments \nMANILA, Philippines ( The Adobo Chronicles, Manila Bureau) – Rappler CEO Maria Ressa’s widely-quoted statement, “Time to take back the Internet” might just come back to haunt her. Just in time for Halloween. \nRessa has been very vocal about the proliferation of “fake” news sites and trolls that have left her online news organization lagging behind in terms of followers and reader engagements. She was particularly critical of entertainer-turned-political blogger, Mocha Uson, who has more than 4 million followers, twice that of Rappler. \nNow, the Philippine government may soon ‘take back the Internet’ from Rappler because it appears it has violated the Philippine Constitution. \nArticle XVI, Section 11 of the 1987 Philippine Constitution specifically states that the mass media must be wholly-owned and managed by citizens of the Philippines. \nBut Rappler is partly-owned by a foreign company, Omidyar Network. How do we know? Rappler itself told us so way back on November 5, 2015: \nSo, before Rappler can take back the Internet, it may first have to give it up! Rate this:",
		"thread_title": "Comment on Philippine Government To ‘Take Back The Internet’ From Maria Ressa And Rappler? by adobochron",
		"title": "Comment on Philippine Government To ‘Take Back The Internet’ From Maria Ressa And Rappler? by adobochron",
		"type": "fake",
		"uuid": "d6cf2ee2ebc9b55ec8385b0a20f9417cbd9f63a9"
	},
	"-KhIbBAZboVCiUDAjF-c": {
		"author": "Rebecca Bennett",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-12T01:24:50.353+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.71090853,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.07263683,
				"type": "PERSON"
			},
			{
				"name": "bid",
				"salience": 0.03064774,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.013360099,
				"type": "PERSON"
			},
			{
				"name": "Comments",
				"salience": 0.012449235,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hotels",
				"salience": 0.012449235,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.011611247,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.011611247,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.009070602,
				"type": "LOCATION"
			},
			{
				"name": "adobochron",
				"salience": 0.00852273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gn1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Davao_City"
				},
				"name": "Davao City",
				"salience": 0.007130516,
				"type": "LOCATION"
			},
			{
				"name": "promises",
				"salience": 0.006784134,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0066764182,
				"type": "ORGANIZATION"
			},
			{
				"name": "Doral DES MOINES",
				"salience": 0.0066764182,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cv3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas"
				},
				"name": "Las Vegas",
				"salience": 0.0060407063,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.0051643015,
				"type": "OTHER"
			},
			{
				"name": "electorate",
				"salience": 0.0051643015,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0051643015,
				"type": "EVENT"
			},
			{
				"name": "nothing",
				"salience": 0.004475003,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.004475003,
				"type": "OTHER"
			},
			{
				"name": "caucus",
				"salience": 0.004475003,
				"type": "EVENT"
			},
			{
				"name": "The Adobo Chronicles",
				"salience": 0.0025592349,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president",
				"salience": 0.0023714083,
				"type": "PERSON"
			},
			{
				"name": "jet",
				"salience": 0.0022713111,
				"type": "OTHER"
			},
			{
				"name": "hotels",
				"salience": 0.001854902,
				"type": "LOCATION"
			},
			{
				"name": "billionaire candidate",
				"salience": 0.0017857677,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0016065267,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0015466335,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0015466335,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0015466335,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.001514706,
				"type": "OTHER"
			},
			{
				"name": "bed",
				"salience": 0.0014582304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0130v6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Air_Force_One"
				},
				"name": "Airforce One",
				"salience": 0.0013990452,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.0013118169,
				"type": "OTHER"
			},
			{
				"name": "taxpayers",
				"salience": 0.0013118169,
				"type": "PERSON"
			},
			{
				"name": "press corps",
				"salience": 0.0013118169,
				"type": "ORGANIZATION"
			},
			{
				"name": "jet",
				"salience": 0.0012368169,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rnbt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doral,_Florida"
				},
				"name": "Doral",
				"salience": 0.0011423484,
				"type": "LOCATION"
			},
			{
				"name": "bed",
				"salience": 0.001131846,
				"type": "OTHER"
			},
			{
				"name": "counterpart",
				"salience": 0.001131846,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, D.C.",
				"salience": 0.00095237425,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00095237425,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.00095237425,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/028vxn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_One"
				},
				"name": "Marine One",
				"salience": 0.0009327013,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "commute",
				"salience": 0.00087844214,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.00079453754,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0007878021,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0195pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manila"
				},
				"name": "Manila",
				"salience": 0.0007401681,
				"type": "LOCATION"
			},
			{
				"name": "plane",
				"salience": 0.00071398675,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.00071398675,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00071398675,
				"type": "OTHER"
			},
			{
				"name": "traffic",
				"salience": 0.00071398675,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.00071398675,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.0006159771,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0006159771,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01prx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malaca%C3%B1ang_Palace"
				},
				"name": "Malacañang",
				"salience": 0.00060342345,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jhwd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Metro_Manila"
				},
				"name": "Metro Manila",
				"salience": 0.00056212355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kscy0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rodrigo_Duterte"
				},
				"name": "Rodrigo Duterte",
				"salience": 0.0005248702,
				"type": "PERSON"
			},
			{
				"name": "flights",
				"salience": 0.0005200414,
				"type": "EVENT"
			},
			{
				"name": "Thousands",
				"salience": 0.00046395566,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/02/image.jpeg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T00:27:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 2 Comments The Trump hotels in Las Vegas, left, and Doral \nDES MOINES, Iowa ( The Adobo Chronicles) – Since he launched his bid to be the Republican nominee for president of the United States, Donald Trump has made many promises, but nothing has caught the attention of the media and electorate more than what he said today in Iowa, on the eve of the first caucus of the 2016 presidential elections season. \nIf elected president of the United States, Trump says he will not live in the White House. \nInstead, the billionaire candidate will establish his own White House outside of Washington, D.C. — as a matter of fact two of them : one in Florida and another in Nevada. Trump’s White House (s) will be headquartered in the Trump hotels in Doral and Las Vegas. \n“This will bring the White House — and the president — closer to the people,” Trump declared. He also indicated that he will not be using Airforce One or Marine One. Rather, he said he will be using his own private jet at no cost to the taxpayers. \nThe Adobo Chronicles asked Trump what will happen to the media and the White House press corps when he travels across the country or abroad. \n“Well, they just have to book their own commercial flights and follow me around,” he said. \nThousands of miles away in the Philippines, a leading presidential candidate said that if elected president, he will not live in Malacañang — the Filipino counterpart of the White House — because he likes to sleep in his own bed. His bed is in Davao City of which he is currently the mayor. \nRodrigo Duterte said he will commute daily from Manila to Davao using a private jet of his friend. Davao is about a hour and forty-five minutes by plane from Manila, which is a far way shorter commute than being stuck in daily traffic on Metro Manila’s streets.",
		"thread_title": "Comment on If Elected President, Donald Trump Will Not Live In The White House by Rebecca Bennett",
		"title": "Comment on If Elected President, Donald Trump Will Not Live In The White House by Rebecca Bennett",
		"type": "fake",
		"uuid": "a0ec7a8f22b44b92bea5c01a45c70e30b17384b4"
	},
	"-KhIbBJy5XdFHn3HAj4t": {
		"author": "Eligio Abellera",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-15T18:56:14.861+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07fx7n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cristeta_Comerford"
				},
				"name": "Cristeta Comerford",
				"salience": 0.596248,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.07111735,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Ronald Reagan",
				"salience": 0.05171976,
				"type": "PERSON"
			},
			{
				"name": "Comments",
				"salience": 0.021935953,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Filipino",
				"salience": 0.019408492,
				"type": "LOCATION"
			},
			{
				"name": "adobochron",
				"salience": 0.01565633,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.014170574,
				"type": "OTHER"
			},
			{
				"name": "Comerford Washington, D.C.",
				"salience": 0.01357523,
				"type": "ORGANIZATION"
			},
			{
				"name": "knowledge",
				"salience": 0.01201159,
				"type": "OTHER"
			},
			{
				"name": "mac n'cheese",
				"salience": 0.011278876,
				"type": "OTHER"
			},
			{
				"name": "heart bypass",
				"salience": 0.011278876,
				"type": "EVENT"
			},
			{
				"name": "jalapeño cheeseburgers",
				"salience": 0.011278876,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.0100166155,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.009079494,
				"type": "PERSON"
			},
			{
				"name": "foods",
				"salience": 0.007597008,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0075192014,
				"type": "PERSON"
			},
			{
				"name": "food",
				"salience": 0.0070427996,
				"type": "OTHER"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.0069608213,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0056195017,
				"type": "ORGANIZATION"
			},
			{
				"name": "halo-halo",
				"salience": 0.0054303757,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/079pwk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kare-kare"
				},
				"name": "Kare-Kare",
				"salience": 0.004842211,
				"type": "OTHER"
			},
			{
				"name": "Filipino cuisine",
				"salience": 0.0046613286,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0046613286,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06lgcb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halo-halo"
				},
				"name": "Halo-Halo",
				"salience": 0.004632538,
				"type": "PERSON"
			},
			{
				"name": "executive chef",
				"salience": 0.004181284,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.0037761165,
				"type": "OTHER"
			},
			{
				"name": "Presidents",
				"salience": 0.0036354386,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.0036354386,
				"type": "OTHER"
			},
			{
				"name": "descent",
				"salience": 0.0032706885,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.0032706885,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.0030838232,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ice",
				"salience": 0.0030838232,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03lcgp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balut_(food)"
				},
				"name": "Balut",
				"salience": 0.0027107538,
				"type": "OTHER"
			},
			{
				"name": "Kinilaw na Kambing",
				"salience": 0.0027107538,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.002333948,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.0023045698,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian",
				"salience": 0.0020143609,
				"type": "LOCATION"
			},
			{
				"name": "food",
				"salience": 0.0020125038,
				"type": "OTHER"
			},
			{
				"name": "taro leaves",
				"salience": 0.0019958427,
				"type": "OTHER"
			},
			{
				"name": "Pinakbet",
				"salience": 0.0019958427,
				"type": "OTHER"
			},
			{
				"name": "ratatouille",
				"salience": 0.0019958427,
				"type": "OTHER"
			},
			{
				"name": "pork knuckles",
				"salience": 0.0019958427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03295l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Filipino_Americans"
				},
				"name": "Filipino American",
				"salience": 0.0019392312,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0019392312,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/053n10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuisine_of_Hawaii"
				},
				"name": "Hawaiian",
				"salience": 0.0016447023,
				"type": "LOCATION"
			},
			{
				"name": "eye",
				"salience": 0.0014539112,
				"type": "OTHER"
			},
			{
				"name": "wink",
				"salience": 0.0014539112,
				"type": "OTHER"
			},
			{
				"name": "peanut sauce",
				"salience": 0.0014539112,
				"type": "OTHER"
			},
			{
				"name": "vegetables",
				"salience": 0.0014539112,
				"type": "OTHER"
			},
			{
				"name": "pork",
				"salience": 0.001389204,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06_wyyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Family_of_Barack_Obama"
				},
				"name": "Obamas",
				"salience": 0.0013218975,
				"type": "PERSON"
			},
			{
				"name": "ice",
				"salience": 0.0012543619,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cmbtjb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crispy_pata"
				},
				"name": "Crispy Pata",
				"salience": 0.0012288018,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06whg9"
				},
				"name": "Laing",
				"salience": 0.0012288018,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018dxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tripe"
				},
				"name": "Tripe",
				"salience": 0.0012288018,
				"type": "OTHER"
			},
			{
				"name": "Tocino",
				"salience": 0.0010862214,
				"type": "OTHER"
			},
			{
				"name": "pork blood stew",
				"salience": 0.0010862214,
				"type": "OTHER"
			},
			{
				"name": "Dinuguan",
				"salience": 0.0010862214,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2014/09/filfoods.jpg?w=474",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-15T18:56:14.861+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.7,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 3 Comments Comerford \nWashington, D.C. (The Adobo Chronicles) – It is common knowledge that Ronald Reagan loved mac n’cheese. Bill Clinton, before his heart bypass, indulged in jalapeño cheeseburgers. How about Barack Obama? \nIn an exclusive interview with White House executive chef Cristeta Comerford, she indicated that Obama does not have one particular favorite food. “But he loves Filipino cuisine,” she said. \nComerford, a Filipino American, has so far served as executive chef under three U.S. Presidents – George W. Bush, Clinton and Obama. She is the first woman and the first of Asian descent who has served as White House executive chef. Halo-Halo \n“There are so many Filipino foods that the president likes, but on top of his list is halo-halo, the Filipino version of the Hawaiian shaved ice,” Comerford said. Asked to name the top ten Filipino foods fancied by Obama, Comerford gave us the following list: \n1. Halo-Halo (shaved ice) \n2. Dinuguan (pork blood stew) \n3. Balut (duck embryo) \n5. Kinilaw na Kambing (ceviche-style goat meat) \n6. Tocino (sweet cured pork) \n7. Laing (spicy taro leaves) \n8. Pinakbet (Filipino version of ratatouille) \n9. Crispy Pata (Deep-fried pork knuckles) \n10. Kare-Kare (Tripe and vegetables in peanut sauce) \nAsked how often Filipino food is served to the Obamas, Comerford, with a wink in her eye, said, “That’s classified information!” Rate this:",
		"thread_title": "Comment on WHITE HOUSE EXECUTIVE CHEF REVEALS OBAMA’S FAVORITE FILIPINO FOODS by Eligio Abellera",
		"title": "Comment on WHITE HOUSE EXECUTIVE CHEF REVEALS OBAMA’S FAVORITE FILIPINO FOODS by Eligio Abellera",
		"type": "fake",
		"uuid": "c545a56e757eeb80748da7f585752084b8d73c3f"
	},
	"-KhIbBV7oyNpsrKH241T": {
		"author": "Sue Penn (@SuePennonTwitte)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-15T18:56:27.364+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05x0zf5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Moyers"
				},
				"name": "Billy Don ``Bill'' Moyers",
				"salience": 0.6180862,
				"type": "PERSON"
			},
			{
				"name": "Moyers WASHINGTON, D.C.",
				"salience": 0.13078268,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.066846214,
				"type": "LOCATION"
			},
			{
				"name": "adobochron",
				"salience": 0.03481512,
				"type": "OTHER"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.015618397,
				"type": "OTHER"
			},
			{
				"name": "Washington Bureau",
				"salience": 0.015618397,
				"type": "ORGANIZATION"
			},
			{
				"name": "commentator",
				"salience": 0.013381212,
				"type": "PERSON"
			},
			{
				"name": "documentaries",
				"salience": 0.010887246,
				"type": "WORK_OF_ART"
			},
			{
				"name": "network TV news commentator",
				"salience": 0.009059939,
				"type": "WORK_OF_ART"
			},
			{
				"name": "journalism",
				"salience": 0.007690438,
				"type": "OTHER"
			},
			{
				"name": "news journal programs",
				"salience": 0.0073668193,
				"type": "OTHER"
			},
			{
				"name": "broadcasting",
				"salience": 0.0073668193,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0070931814,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01pt0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House_Press_Secretary"
				},
				"name": "White House Press Secretary",
				"salience": 0.006471195,
				"type": "PERSON"
			},
			{
				"name": "awards",
				"salience": 0.0060196095,
				"type": "OTHER"
			},
			{
				"name": "degrees",
				"salience": 0.0060196095,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0060196095,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0045013605,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0045013605,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Johnson",
				"salience": 0.004373939,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0037877976,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0034114479,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0027736179,
				"type": "PERSON"
			},
			{
				"name": "Farewell to America.",
				"salience": 0.002603476,
				"type": "WORK_OF_ART"
			},
			{
				"name": "critic",
				"salience": 0.0024521542,
				"type": "PERSON"
			},
			{
				"name": "news media",
				"salience": 0.0024521542,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/11/img_6937.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-13T07:32:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 1 Comment Moyers \nWASHINGTON, D.C. ( The Adobo Chronicles, Washington Bureau) – Billy Don “Bill” Moyers is an American journalist and political commentator who served as White House Press Secretary in the Johnson administration from 1965 to 1967. He also worked as a network TV news commentator for ten years. Moyers has been extensively involved with public broadcasting, producing documentaries and news journal programs. He has won numerous awards and honorary degrees for his investigative journalism and civic activities and has become well known as a trenchant critic of the corporately structured U.S. news media. \nWell, he is the first high-profile American to flee the U.S. as a result of the election of Donald Trump as the 45th president of the United States. \nHere is Moyers’“ Farewell to America. ”",
		"thread_title": "Comment on Respected Journalist Bill Moyers Is First High-Profile American To Flee U.S. After Trump’s Election by Sue Penn (@SuePennonTwitte)",
		"title": "Comment on Respected Journalist Bill Moyers Is First High-Profile American To Flee U.S. After Trump’s Election by Sue Penn (@SuePennonTwitte)",
		"type": "fake",
		"uuid": "5f51e089375c7d5452ca475b563a468a60f07968"
	},
	"-KhIbBbD8xwkhQ82RsBY": {
		"author": "Mitch Jalandoni",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-20T02:34:46.400+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05dpch",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paula_Deen"
				},
				"name": "Paula Deen",
				"salience": 0.3252944,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07fx7n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cristeta_Comerford"
				},
				"name": "Cristeta Comerford",
				"salience": 0.18157837,
				"type": "PERSON"
			},
			{
				"name": "Comment",
				"salience": 0.069447935,
				"type": "WORK_OF_ART"
			},
			{
				"name": "adobochron",
				"salience": 0.0594358,
				"type": "OTHER"
			},
			{
				"name": "Deen WASHINGTON, D.C.",
				"salience": 0.04978057,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04hfnv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Melania_Trump"
				},
				"name": "Melania Trump",
				"salience": 0.030874167,
				"type": "PERSON"
			},
			{
				"name": "president-elect",
				"salience": 0.029624805,
				"type": "PERSON"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.022265323,
				"type": "OTHER"
			},
			{
				"name": "Washington Bureau",
				"salience": 0.022265323,
				"type": "ORGANIZATION"
			},
			{
				"name": "chicken adobo",
				"salience": 0.02062875,
				"type": "OTHER"
			},
			{
				"name": "pancit",
				"salience": 0.0185001,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.017991548,
				"type": "ORGANIZATION"
			},
			{
				"name": "Adobo",
				"salience": 0.013960611,
				"type": "OTHER"
			},
			{
				"name": "headlines",
				"salience": 0.01299924,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d3t7x"
				},
				"name": "Donald",
				"salience": 0.010856333,
				"type": "PERSON"
			},
			{
				"name": "family menu",
				"salience": 0.010098521,
				"type": "OTHER"
			},
			{
				"name": "pumpkin pie",
				"salience": 0.010098521,
				"type": "OTHER"
			},
			{
				"name": "potato tot casserole",
				"salience": 0.010098521,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.009600866,
				"type": "OTHER"
			},
			{
				"name": "TV cooking show host",
				"salience": 0.008568653,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.008568653,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Filipina",
				"salience": 0.006465334,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.006465334,
				"type": "LOCATION"
			},
			{
				"name": "waiters",
				"salience": 0.0064059803,
				"type": "PERSON"
			},
			{
				"name": "slaves",
				"salience": 0.0064059803,
				"type": "PERSON"
			},
			{
				"name": "N-word",
				"salience": 0.0052317237,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.004668315,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.004668315,
				"type": "EVENT"
			},
			{
				"name": "Birds",
				"salience": 0.004668315,
				"type": "OTHER"
			},
			{
				"name": "feather",
				"salience": 0.004668315,
				"type": "OTHER"
			},
			{
				"name": "jokes",
				"salience": 0.004326773,
				"type": "OTHER"
			},
			{
				"name": "deposition",
				"salience": 0.0034886012,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/11/img_6994.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-19T10:09:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 1 Comment Comerford, left, and Deen \nWASHINGTON, D.C. ( The Adobo Chronicles, Washington Bureau) – When Donald and Melania Trump officially move into the White House, there will be no pancit or chicken adobo on the family menu, just potato tot casserole and pumpkin pie. \nThe president-elect has informed The Adobo Chronicles that he is firing Filipina White House Executive Chef Cristeta Comerford. She will be replaced by Paula Deen, American celebrity chef and former TV cooking show host. \nPaula Deen made headlines when a video surfaced in which Deen, in a deposition, admits to using the N-word and making racist and anti-semitic jokes. She also allegedly described her interest in hiring black waiters dressed to look like “slaves” at a wedding.Jun 19, 2013. \nTrump himself has been criticized for racist remarks during his presidential campaign. \nBirds of the same feather… Rate this:",
		"thread_title": "Comment on Donald Trump To Replace Filipina White House Chef With Paula Deen by Mitch Jalandoni",
		"title": "Comment on Donald Trump To Replace Filipina White House Chef With Paula Deen by Mitch Jalandoni",
		"type": "fake",
		"uuid": "f7f8a37ccb53effb82fc140d0038e096f42dfa03"
	},
	"-KhIbBiut5NeFJjIJjZr": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-23T01:52:55.837+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apple_Inc."
				},
				"name": "Apple",
				"salience": 0.5095574,
				"type": "ORGANIZATION"
			},
			{
				"name": "Alternative Right",
				"salience": 0.063493475,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0r679",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cupertino,_California"
				},
				"name": "CUPERTINO",
				"salience": 0.03448579,
				"type": "LOCATION"
			},
			{
				"name": "adobochron",
				"salience": 0.029557534,
				"type": "PERSON"
			},
			{
				"name": "comment",
				"salience": 0.025649432,
				"type": "WORK_OF_ART"
			},
			{
				"name": "innovation",
				"salience": 0.025649432,
				"type": "OTHER"
			},
			{
				"name": "products",
				"salience": 0.025649432,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "The Adobo Chronicles",
				"salience": 0.015871214,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.015871214,
				"type": "LOCATION"
			},
			{
				"name": "San Jose Bureau",
				"salience": 0.015871214,
				"type": "ORGANIZATION"
			},
			{
				"name": "key",
				"salience": 0.013663018,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.013185991,
				"type": "OTHER"
			},
			{
				"name": "Alt-Right",
				"salience": 0.009502268,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.008098704,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00791012,
				"type": "PERSON"
			},
			{
				"name": "term",
				"salience": 0.007196175,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.005804612,
				"type": "PERSON"
			},
			{
				"name": "correctness",
				"salience": 0.005731669,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.005448921,
				"type": "OTHER"
			},
			{
				"name": "globe",
				"salience": 0.005448921,
				"type": "LOCATION"
			},
			{
				"name": "politics",
				"salience": 0.005448921,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.005448921,
				"type": "EVENT"
			},
			{
				"name": "success",
				"salience": 0.005448921,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.005448921,
				"type": "PERSON"
			},
			{
				"name": "addition",
				"salience": 0.0051800814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05r65m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Cook"
				},
				"name": "Tim Cook",
				"salience": 0.0050615235,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/033830",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alt_key"
				},
				"name": "Alt",
				"salience": 0.0049550976,
				"type": "PERSON"
			},
			{
				"name": "belief",
				"salience": 0.0049244687,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0049244687,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.0048877294,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.004705675,
				"type": "OTHER"
			},
			{
				"name": "ideologies",
				"salience": 0.004249624,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.003823229,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.003823229,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003823229,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.003823229,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.003823229,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.003823229,
				"type": "EVENT"
			},
			{
				"name": "groups",
				"salience": 0.0036807423,
				"type": "ORGANIZATION"
			},
			{
				"name": "phrase",
				"salience": 0.0036807423,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.0036047844,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0033570027,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0033570027,
				"type": "PERSON"
			},
			{
				"name": "Alt-Righters",
				"salience": 0.0032777837,
				"type": "PERSON"
			},
			{
				"name": "key",
				"salience": 0.0032288823,
				"type": "OTHER"
			},
			{
				"name": "ethno-nationalism",
				"salience": 0.0031220743,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.0031220743,
				"type": "OTHER"
			},
			{
				"name": "memes",
				"salience": 0.0031220743,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0031220743,
				"type": "OTHER"
			},
			{
				"name": "conservatism",
				"salience": 0.0031220743,
				"type": "OTHER"
			},
			{
				"name": "keyboard",
				"salience": 0.002983227,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ideologies",
				"salience": 0.0026938554,
				"type": "OTHER"
			},
			{
				"name": "texts",
				"salience": 0.0023329668,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0023329668,
				"type": "WORK_OF_ART"
			},
			{
				"name": "idiosyncrasies",
				"salience": 0.0023329668,
				"type": "OTHER"
			},
			{
				"name": "key",
				"salience": 0.0021802275,
				"type": "OTHER"
			},
			{
				"name": "keyboard",
				"salience": 0.0021733865,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "social media",
				"salience": 0.0021733865,
				"type": "OTHER"
			},
			{
				"name": "keyboards",
				"salience": 0.0017521526,
				"type": "OTHER"
			},
			{
				"name": "hashtag",
				"salience": 0.001699481,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.001699481,
				"type": "PERSON"
			},
			{
				"name": "AlternativeRight",
				"salience": 0.0014483418,
				"type": "OTHER"
			},
			{
				"name": "corner",
				"salience": 0.00126968,
				"type": "LOCATION"
			},
			{
				"name": "design",
				"salience": 0.00126968,
				"type": "OTHER"
			},
			{
				"name": "iPhones",
				"salience": 0.00126968,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "laptops",
				"salience": 0.00126968,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "desktops",
				"salience": 0.00126968,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09rvlp4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/IPad"
				},
				"name": "iPads",
				"salience": 0.0007815292,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/11/img_7188.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-23T01:52:55.837+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0.643",
		"text": "adobochron Leave a comment \nCUPERTINO, California ( The Adobo Chronicles, San Jose Bureau) – Technology giant Apple is known for its innovation and for constantly reinventing itself and its products. This strategy has spelled the company’s tremendous success across the globe. \nOccasionally, Apple immerses itself in politics and the current political atmosphere following the election of Donald Trump as the 45th U.S. president is one of those times. \nBy now, the term Alt-Right (Alternative Right) has become a familiar phrase especially on social media. \nThe Alternative Right, commonly known as the Alt-Right, is a set of far-right ideologies, groups and individuals whose core belief is that “white identity” is under attack by multicultural forces using “political correctness” and “social justice” to undermine white people and “their” civilization. Characterized by heavy use of social media and online memes, Alt-Righters eschew “establishment” conservatism, skew young, and embrace white ethno-nationalism as a fundamental value. \nIn keeping up with this new political atmosphere, Apple has just announced that it will be replacing all keyboards on its desktops, laptops, iPhones and iPads with a new design that adds the “Alt-Right” key. The key will be located in the lowermost right corner of the keyboard. How appropriate \nApple CEO Tim Cook said that the addition of this all-important key will enable those who subscribe to the Alternative Right ideologies (and idiosyncrasies) to identify themselves when sending emails, texts or posting on social media. Hitting the “Alt-Right” key will automatically add the hashtag #AlternativeRight to whatever a person is typing on the keyboard. \nWelcome to the 22nd century! Rate this: ",
		"thread_title": "Apple Adds ‘Alt-Right’ Key To Its Computer Keyboards |",
		"title": "Apple Adds ‘Alt-Right’ Key To Its Computer Keyboards |",
		"type": "fake",
		"uuid": "b27b6f7b47cce095d8e2b6b06e5e65d164b35cc9"
	},
	"-KhIbBsnQtnuELK1LnyH": {
		"author": "adobochronicles.com - Real or Satire?",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-24T10:09:31.879+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01d08",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Books_of_Chronicles"
				},
				"name": "CHRONICLES",
				"salience": 0.13737026,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.12330982,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.11962103,
				"type": "OTHER"
			},
			{
				"name": "adobo",
				"salience": 0.059473373,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.04897206,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.04089446,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.034103762,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.029053202,
				"type": "OTHER"
			},
			{
				"name": "mouthful",
				"salience": 0.022696948,
				"type": "PERSON"
			},
			{
				"name": "credit",
				"salience": 0.02195871,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.01972288,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.01972288,
				"type": "OTHER"
			},
			{
				"name": "Everything",
				"salience": 0.01972288,
				"type": "OTHER"
			},
			{
				"name": "domain",
				"salience": 0.017063687,
				"type": "OTHER"
			},
			{
				"name": "reposts",
				"salience": 0.013649861,
				"type": "OTHER"
			},
			{
				"name": "comment",
				"salience": 0.0134785,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Use",
				"salience": 0.011292734,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.010410614,
				"type": "OTHER"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.009746229,
				"type": "OTHER"
			},
			{
				"name": "Statements",
				"salience": 0.009538124,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.009402215,
				"type": "WORK_OF_ART"
			},
			{
				"name": "creative writing",
				"salience": 0.008144165,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.008144165,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.008144165,
				"type": "OTHER"
			},
			{
				"name": "The Adobo Chronicles",
				"salience": 0.007663562,
				"type": "WORK_OF_ART"
			},
			{
				"name": "intent",
				"salience": 0.0065967967,
				"type": "OTHER"
			},
			{
				"name": "reposts",
				"salience": 0.0063509215,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0063509215,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dish",
				"salience": 0.006086922,
				"type": "OTHER"
			},
			{
				"name": "fiction",
				"salience": 0.005816256,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0057134554,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.0057134554,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.0057134554,
				"type": "OTHER"
			},
			{
				"name": "mixture",
				"salience": 0.0053868983,
				"type": "OTHER"
			},
			{
				"name": "news sizzle",
				"salience": 0.0046653333,
				"type": "OTHER"
			},
			{
				"name": "spices",
				"salience": 0.0046653333,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.0046653333,
				"type": "OTHER"
			},
			{
				"name": "soy sauce",
				"salience": 0.0046653333,
				"type": "OTHER"
			},
			{
				"name": "writing stories",
				"salience": 0.0046653333,
				"type": "OTHER"
			},
			{
				"name": "home country",
				"salience": 0.0046653333,
				"type": "LOCATION"
			},
			{
				"name": "pork",
				"salience": 0.0046653333,
				"type": "OTHER"
			},
			{
				"name": "chicken",
				"salience": 0.0046653333,
				"type": "OTHER"
			},
			{
				"name": "vinegar",
				"salience": 0.0046653333,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "images",
				"salience": 0.0044577937,
				"type": "WORK_OF_ART"
			},
			{
				"name": "images",
				"salience": 0.0044577937,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.0039952025,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0039448976,
				"type": "OTHER"
			},
			{
				"name": "paragraphs",
				"salience": 0.0034859022,
				"type": "OTHER"
			},
			{
				"name": "italics",
				"salience": 0.0034859022,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0034859022,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0034859022,
				"type": "OTHER"
			},
			{
				"name": "accordance",
				"salience": 0.0034859022,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.003247409,
				"type": "OTHER"
			},
			{
				"name": "trademark",
				"salience": 0.003124068,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.0029322237,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0028017152,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0028017152,
				"type": "OTHER"
			},
			{
				"name": "Registration",
				"salience": 0.0025391986,
				"type": "OTHER"
			},
			{
				"name": "copyright infringement",
				"salience": 0.0025391986,
				"type": "OTHER"
			},
			{
				"name": "parody",
				"salience": 0.0025391986,
				"type": "OTHER"
			},
			{
				"name": "doctrine",
				"salience": 0.0025391986,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0024261698,
				"type": "OTHER"
			},
			{
				"name": "fiction",
				"salience": 0.0024261698,
				"type": "OTHER"
			},
			{
				"name": "imagination",
				"salience": 0.0024261698,
				"type": "OTHER"
			},
			{
				"name": "fiction",
				"salience": 0.0024261698,
				"type": "OTHER"
			},
			{
				"name": "mixture",
				"salience": 0.0021906379,
				"type": "OTHER"
			},
			{
				"name": "FORMAT",
				"salience": 0.0021906379,
				"type": "OTHER"
			},
			{
				"name": "format",
				"salience": 0.0021906379,
				"type": "OTHER"
			},
			{
				"name": "figments",
				"salience": 0.0018969539,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.0018969539,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fzds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Patent_and_Trademark_Office"
				},
				"name": "U.S. Patent and Trademark Office",
				"salience": 0.0015630057,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2013/06/image1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-24T07:31:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "Search for: About Us \nTHE ADOBO CHRONICLES is your source of up-to-date, unbelievable news. Everything you read on this site is based on fact, except for the lies. \nWe abide by the highest standards of creative writing and intend to make this site as respectable as possible to the extent allowed by our fertile mind. We welcome comments, but please bear in mind that this is a family-oriented site. We reserve the right to edit or censor any comment that we deem inappropriate or funnier than our posts . \nWe also welcome reposts of our stories but request appropriate credit to The Adobo Chronicles. We cannot be responsible for reposts without credit as they may be taken in a context outside of the original intent of this website. (Yeah we know, that was quite a mouthful!) \nWhy the title, “ The Adobo Chronicles ,” you might ask? Well, adobo is the national dish of our home country. You see, adobo is usually made with pork or chicken, boiled and simmered in a mixture of vinegar, soy sauce and other spices. When writing stories for this blog, we let the news sizzle and simmer in our mind in a mixture of fact and fiction, then we spice it up with figments of our imagination. \nNEW FORMAT: The Adobo Chronicles has recently adopted a new format to help readers distinguish between fact and fiction. Statements and paragraphs in our posts that are in italics represent the facts. The rest are fiction. \nUnless indicated otherwise, all images are by us or from public domain. Use of images and information from public domain are in accordance with the fair use doctrine as it applies to news, parody and the Internet. No copyright infringement is intended. \nThe Adobo Chronicles is a registered trademark with the U.S. Patent and Trademark Office | Registration # 4711386. And THAT is a fact!",
		"thread_title": "Comment on About Us by adobochronicles.com - Real or Satire?",
		"title": "Comment on About Us by adobochronicles.com - Real or Satire?",
		"type": "fake",
		"uuid": "d9483f7585dc9cedb50cd111741b55535cbe7350"
	},
	"-KhIbC8Fow3e40Ua_N6z": {
		"author": "Koel@WritingSouls",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-25T08:08:35.160+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.22758104,
				"type": "LOCATION"
			},
			{
				"name": "McCann Worldgroup Philippines",
				"salience": 0.16448638,
				"type": "ORGANIZATION"
			},
			{
				"name": "spokesperson",
				"salience": 0.06175699,
				"type": "PERSON"
			},
			{
				"name": "adobochron",
				"salience": 0.049076244,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.04440832,
				"type": "LOCATION"
			},
			{
				"name": "Comment",
				"salience": 0.038559377,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charge",
				"salience": 0.038559377,
				"type": "OTHER"
			},
			{
				"name": "tourism campaign",
				"salience": 0.038559377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0195pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manila"
				},
				"name": "MANILA",
				"salience": 0.02754872,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kscy0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rodrigo_Duterte"
				},
				"name": "Rodrigo Roa Duterte",
				"salience": 0.027479269,
				"type": "PERSON"
			},
			{
				"name": "Manila Bureau",
				"salience": 0.023894826,
				"type": "ORGANIZATION"
			},
			{
				"name": "McCann",
				"salience": 0.021564895,
				"type": "PERSON"
			},
			{
				"name": "Adobo Chronicles",
				"salience": 0.019559367,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dnlmv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Department_of_Tourism_(Philippines)"
				},
				"name": "Department of Tourism",
				"salience": 0.018862154,
				"type": "ORGANIZATION"
			},
			{
				"name": "contract",
				"salience": 0.018298786,
				"type": "OTHER"
			},
			{
				"name": "Katherine de Castro",
				"salience": 0.017772974,
				"type": "PERSON"
			},
			{
				"name": "slogan",
				"salience": 0.009490401,
				"type": "OTHER"
			},
			{
				"name": "public affairs",
				"salience": 0.00821654,
				"type": "PERSON"
			},
			{
				"name": "advocacy",
				"salience": 0.00821654,
				"type": "OTHER"
			},
			{
				"name": "slogan",
				"salience": 0.0077532446,
				"type": "OTHER"
			},
			{
				"name": "Son",
				"salience": 0.0075672776,
				"type": "PERSON"
			},
			{
				"name": "tourism slogan",
				"salience": 0.007370934,
				"type": "OTHER"
			},
			{
				"name": "partner",
				"salience": 0.006883741,
				"type": "PERSON"
			},
			{
				"name": "advertising",
				"salience": 0.006409259,
				"type": "OTHER"
			},
			{
				"name": "take-off",
				"salience": 0.006143102,
				"type": "EVENT"
			},
			{
				"name": "formulation",
				"salience": 0.0055517536,
				"type": "OTHER"
			},
			{
				"name": "positioning",
				"salience": 0.0055517536,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0055517536,
				"type": "OTHER"
			},
			{
				"name": "promotions",
				"salience": 0.0055517536,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.0055517536,
				"type": "OTHER"
			},
			{
				"name": "marketing materials",
				"salience": 0.0055517536,
				"type": "OTHER"
			},
			{
				"name": "wheel",
				"salience": 0.0055158706,
				"type": "OTHER"
			},
			{
				"name": "Fun",
				"salience": 0.005437247,
				"type": "OTHER"
			},
			{
				"name": "P.I.",
				"salience": 0.005437247,
				"type": "PERSON"
			},
			{
				"name": "Ina",
				"salience": 0.004779756,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0047094994,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.004255875,
				"type": "OTHER"
			},
			{
				"name": "cussing",
				"salience": 0.004063815,
				"type": "OTHER"
			},
			{
				"name": "More Fun in P.I.",
				"salience": 0.003568153,
				"type": "WORK_OF_ART"
			},
			{
				"name": "world map",
				"salience": 0.003519589,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.003519589,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interviews",
				"salience": 0.003519589,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippine Islands",
				"salience": 0.0028532872,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.002564138,
				"type": "OTHER"
			},
			{
				"name": "cuss words",
				"salience": 0.0019157887,
				"type": "OTHER"
			},
			{
				"name": "PH",
				"salience": 0.0019157887,
				"type": "OTHER"
			},
			{
				"name": "acronym",
				"salience": 0.0019157887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ps0fx"
				},
				"name": "Whore",
				"salience": 0.0011793172,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://adobochroniclesdotcom.files.wordpress.com/2016/11/img_7221.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-25T08:08:35.160+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "adobochronicles.com",
		"spam_score": "0",
		"text": "adobochron 1 Comment \nMANILA, Philippines ( The Adobo Chronicles, Manila Bureau) – Advertising company McCann Worldgroup Philippines will be in charge of crafting the new tourism campaign of the country, the Department of Tourism (DOT) said over the weekend. \nTourism undersecretary for advocacy and public affairs Katherine de Castro said the P650-million contract with McCann, which won the bid to be the advertising and promotions partner of the DOT for one year, includes the production and positioning of marketing materials, as well as the formulation of a new tourism slogan. \nThe Adobo Chronicles spoke with a McCann spokesperson who informed us that the slogan selected for the 2017 tourism year is a take-off from the previous “It’s More Fun in the Philippines.” \nThe new slogan is “More Fun in P.I.” \nP.I. of course stands for Philippine Islands (although the country is now known by the acronym of ‘PH.’) \nBut it also stands for ‘P*tang Ina’ (Son of a Whore), the cuss words often heard from President Rodrigo Roa Duterte in his speeches and interviews. \n“President Duterte’s rhetoric and cussing have put the Philippines on the world map and we would like to capitalize on that,” the McCann spokesperson said. \nHe added: “Why reinvent the wheel when we can just tweak it to reflect the current situation in the Philippines?”",
		"thread_title": "Comment on Philippines’ Department Of Tourism Unveils New Promo Slogan, A Double Entendre by Koel@WritingSouls",
		"title": "Comment on Philippines’ Department Of Tourism Unveils New Promo Slogan, A Double Entendre by Koel@WritingSouls",
		"type": "fake",
		"uuid": "af9615acde9b8fb236be519ad33606c0731dd060"
	},
	"-KhIbCFpLw66mgIKPxl4": {
		"author": "Ron Smith",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T01:19:47.632+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "senator",
				"salience": 0.2680552,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_f2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vermont"
				},
				"name": "Vermont",
				"salience": 0.16998658,
				"type": "LOCATION"
			},
			{
				"name": "statists",
				"salience": 0.13850713,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.07200965,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.07200965,
				"type": "LOCATION"
			},
			{
				"name": "PLENTY",
				"salience": 0.052913226,
				"type": "OTHER"
			},
			{
				"name": "freebies",
				"salience": 0.04408414,
				"type": "OTHER"
			},
			{
				"name": "father types",
				"salience": 0.04224127,
				"type": "OTHER"
			},
			{
				"name": "statists",
				"salience": 0.039850585,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.025877059,
				"type": "ORGANIZATION"
			},
			{
				"name": "freebies",
				"salience": 0.024117135,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.018180493,
				"type": "OTHER"
			},
			{
				"name": "freebies",
				"salience": 0.01804519,
				"type": "OTHER"
			},
			{
				"name": "Both",
				"salience": 0.01412269,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Clinton_11_e78c6.jpg",
		"ord_in_thread": "29",
		"participants_count": "19",
		"published": "2016-10-26T17:18:00.000+03:00",
		"replies_count": "29",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "The \"74 year old senator from Vermont\" would fit in 1917 Russia, but not America 1776. BTW there are PLENTY of founding father types around now. It is just that the statists who want freebies, and the statists that promise freebies have carried the day. Both of these groups then wonder why there aren't enough freebies to go around. Go figure.",
		"thread_title": "Installing a President by Force: Hillary Clinton and Our Moribund Democracy",
		"title": "",
		"type": "bs",
		"uuid": "24023c2826c573c6f9c2d119f344a7285a5bda64"
	},
	"-KhIbCbjA7QUpD4ECRmX": {
		"author": "Jim",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T22:38:13.628+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/043zsw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Curiosity"
				},
				"name": "Curious",
				"salience": 0.18253358,
				"type": "OTHER"
			},
			{
				"name": "Letita",
				"salience": 0.18253358,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.10232867,
				"type": "LOCATION"
			},
			{
				"name": "angst",
				"salience": 0.10063401,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.07459812,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.06865573,
				"type": "PERSON"
			},
			{
				"name": "problems",
				"salience": 0.05999322,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.054970033,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.045359172,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.043536782,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.03757783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.027003592,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.020275677,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Clinton_11_e78c6.jpg",
		"ord_in_thread": "30",
		"participants_count": "19",
		"published": "2016-10-27T19:17:00.000+03:00",
		"replies_count": "30",
		"sentiment": {
			"magnitude": 0.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Curious, Letita, what specifically causes you such angst? The country has problems but must can be administered away and Hillary, Obama, or any body really can lead an effort to do that. The real problem is that, at the end of the day, we have a country where 40% of the population believes Trump is a viable leader.",
		"thread_title": "Installing a President by Force: Hillary Clinton and Our Moribund Democracy",
		"title": "",
		"type": "bs",
		"uuid": "ce68229099c4d64f33d8840816313cdee340d37f"
	},
	"-KhIbDBGECFEjkBGuuH6": {
		"author": "Daniel Haiphong",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T22:38:13.643+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.5281151,
				"type": "PERSON"
			},
			{
				"name": "Bankers - Hillary Clinton",
				"salience": 0.08365619,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.02652775,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.014325593,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.010671283,
				"type": "PERSON"
			},
			{
				"name": "trade agreement",
				"salience": 0.010181467,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.008040056,
				"type": "WORK_OF_ART"
			},
			{
				"name": "administration",
				"salience": 0.007079133,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kq5b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_England_and_Wales"
				},
				"name": "Green Party",
				"salience": 0.0068173236,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections",
				"salience": 0.006704367,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.005681852,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.005680103,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025st0_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Bill_Clinton"
				},
				"name": "Clinton Administration",
				"salience": 0.005450486,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0051922128,
				"type": "PERSON"
			},
			{
				"name": "readers",
				"salience": 0.005168375,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0050478177,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.004476736,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0042021936,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00413856,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.0040600346,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0040488923,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fear",
				"salience": 0.0039648856,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.0038948292,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0037409524,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0035007058,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0033781903,
				"type": "EVENT"
			},
			{
				"name": "banks",
				"salience": 0.0031733608,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement activist",
				"salience": 0.0030233888,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.0029257408,
				"type": "OTHER"
			},
			{
				"name": "distaste",
				"salience": 0.002874017,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Report",
				"salience": 0.0027573593,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0027144707,
				"type": "LOCATION"
			},
			{
				"name": "migration",
				"salience": 0.0026419186,
				"type": "EVENT"
			},
			{
				"name": "sexism",
				"salience": 0.0026419186,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0026419186,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0026419186,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0026419186,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0026419186,
				"type": "PERSON"
			},
			{
				"name": "sexism",
				"salience": 0.0026419186,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0024376016,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0023038192,
				"type": "ORGANIZATION"
			},
			{
				"name": "supremacy",
				"salience": 0.002287959,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.002287959,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.002287959,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.002287959,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.002287959,
				"type": "EVENT"
			},
			{
				"name": "analysis",
				"salience": 0.002287959,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.002287959,
				"type": "EVENT"
			},
			{
				"name": "tent",
				"salience": 0.002287959,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "left",
				"salience": 0.002287959,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.002283342,
				"type": "PERSON"
			},
			{
				"name": "border",
				"salience": 0.002244528,
				"type": "LOCATION"
			},
			{
				"name": "media outlets",
				"salience": 0.0022307034,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0019195387,
				"type": "LOCATION"
			},
			{
				"name": "Presidency",
				"salience": 0.0017941691,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0017183148,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.00166278,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0016334035,
				"type": "OTHER"
			},
			{
				"name": "character",
				"salience": 0.0016333645,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0pgkc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voting"
				},
				"name": "Voting",
				"salience": 0.0015876724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hndy2n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Defense_Authorization_Act_for_Fiscal_Year_2012"
				},
				"name": "National Defense Authorization Act of 2012",
				"salience": 0.0015548693,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Presidency",
				"salience": 0.0015410049,
				"type": "PERSON"
			},
			{
				"name": "Presidency",
				"salience": 0.0015410049,
				"type": "OTHER"
			},
			{
				"name": "Presidency",
				"salience": 0.0015024266,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0014222028,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.0014134393,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0014085906,
				"type": "PERSON"
			},
			{
				"name": "ruling class",
				"salience": 0.0013914141,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0013570021,
				"type": "LOCATION"
			},
			{
				"name": "support system",
				"salience": 0.0013495772,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.0013408379,
				"type": "EVENT"
			},
			{
				"name": "nothing",
				"salience": 0.0012907983,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0012666824,
				"type": "OTHER"
			},
			{
				"name": "characterization",
				"salience": 0.0012048869,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0711yt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Temporary_Assistance_for_Needy_Families"
				},
				"name": "Temporary Assistance to Needy Families",
				"salience": 0.0011816719,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.001168655,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.0011259543,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0011078496,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidacy",
				"salience": 0.0010879054,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0010879054,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0010879054,
				"type": "PERSON"
			},
			{
				"name": "readers",
				"salience": 0.0010879054,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0010879054,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0010879054,
				"type": "OTHER"
			},
			{
				"name": "fascist",
				"salience": 0.0010879054,
				"type": "PERSON"
			},
			{
				"name": "pressure",
				"salience": 0.001080526,
				"type": "OTHER"
			},
			{
				"name": "surveillance state",
				"salience": 0.001080526,
				"type": "OTHER"
			},
			{
				"name": "Surveillance State",
				"salience": 0.001080526,
				"type": "ORGANIZATION"
			},
			{
				"name": "position",
				"salience": 0.0010480316,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0010348267,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama Administration",
				"salience": 0.001003235,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0009920318,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.000982962,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00097561226,
				"type": "EVENT"
			},
			{
				"name": "commission",
				"salience": 0.0009722336,
				"type": "ORGANIZATION"
			},
			{
				"name": "cuts",
				"salience": 0.00094627135,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "overdrive",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "validity",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "hegemony",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "sphere",
				"salience": 0.0009420448,
				"type": "OTHER"
			},
			{
				"name": "bills",
				"salience": 0.0009144578,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0009109496,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09h5x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trans-Pacific_Partnership"
				},
				"name": "Transpacific Partnership",
				"salience": 0.0008982855,
				"type": "ORGANIZATION"
			},
			{
				"name": "AFDC",
				"salience": 0.00086737395,
				"type": "ORGANIZATION"
			},
			{
				"name": "incarceration state",
				"salience": 0.0008600213,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.0008448006,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.0008448006,
				"type": "EVENT"
			},
			{
				"name": "immigration policy",
				"salience": 0.00084126455,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00084126455,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.0008335725,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0008201963,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00081716926,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00081326487,
				"type": "LOCATION"
			},
			{
				"name": "no-fly zone",
				"salience": 0.0007888044,
				"type": "OTHER"
			},
			{
				"name": "Expansion",
				"salience": 0.0007627653,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0007627653,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.0007627653,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0007627653,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0007627653,
				"type": "EVENT"
			},
			{
				"name": "agreement",
				"salience": 0.0007627653,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0007627653,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0007627653,
				"type": "EVENT"
			},
			{
				"name": "confrontation",
				"salience": 0.00073429063,
				"type": "EVENT"
			},
			{
				"name": "Maintenance",
				"salience": 0.0007159003,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0007037209,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0007037209,
				"type": "OTHER"
			},
			{
				"name": "hold",
				"salience": 0.00069485256,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0006896563,
				"type": "PERSON"
			},
			{
				"name": "trip",
				"salience": 0.0006860959,
				"type": "EVENT"
			},
			{
				"name": "likes",
				"salience": 0.0006604824,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.0006604824,
				"type": "OTHER"
			},
			{
				"name": "drone",
				"salience": 0.0006604824,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0006604824,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.0006604824,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0006604824,
				"type": "OTHER"
			},
			{
				"name": "steroids",
				"salience": 0.0006604824,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0006604824,
				"type": "LOCATION"
			},
			{
				"name": "benefits",
				"salience": 0.0006604824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Security_(United_States)"
				},
				"name": "Social Security",
				"salience": 0.000659151,
				"type": "ORGANIZATION"
			},
			{
				"name": "deficit reduction",
				"salience": 0.00063582475,
				"type": "OTHER"
			},
			{
				"name": "conversations",
				"salience": 0.00063582475,
				"type": "EVENT"
			},
			{
				"name": "friends",
				"salience": 0.00063582475,
				"type": "PERSON"
			},
			{
				"name": "earnings",
				"salience": 0.00063582475,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00063582475,
				"type": "OTHER"
			},
			{
				"name": "entitlements",
				"salience": 0.00063582475,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.00063582475,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00063582475,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.00063582475,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.00063582475,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.00063582475,
				"type": "EVENT"
			},
			{
				"name": "suffering",
				"salience": 0.0006317059,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00062842807,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0006226814,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.0006226814,
				"type": "OTHER"
			},
			{
				"name": "Servitude",
				"salience": 0.0006226814,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.0006226814,
				"type": "EVENT"
			},
			{
				"name": "great migration",
				"salience": 0.0006226814,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.000618218,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.00059513765,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0005770553,
				"type": "OTHER"
			},
			{
				"name": "Austerity",
				"salience": 0.00057331705,
				"type": "OTHER"
			},
			{
				"name": "deregulation",
				"salience": 0.00056723726,
				"type": "OTHER"
			},
			{
				"name": "wall rhetoric",
				"salience": 0.00056723726,
				"type": "OTHER"
			},
			{
				"name": "Bankers",
				"salience": 0.00055765104,
				"type": "ORGANIZATION"
			},
			{
				"name": "school privatizers",
				"salience": 0.00055765104,
				"type": "OTHER"
			},
			{
				"name": "privatization",
				"salience": 0.00055765104,
				"type": "OTHER"
			},
			{
				"name": "Hedge funds",
				"salience": 0.0005391777,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0005391777,
				"type": "OTHER"
			},
			{
				"name": "suspects",
				"salience": 0.0005391777,
				"type": "PERSON"
			},
			{
				"name": "dollar speeches",
				"salience": 0.0005391777,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0005391777,
				"type": "ORGANIZATION"
			},
			{
				"name": "thousands",
				"salience": 0.0005391777,
				"type": "OTHER"
			},
			{
				"name": "detention",
				"salience": 0.0005391777,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0005391777,
				"type": "OTHER"
			},
			{
				"name": "deportation",
				"salience": 0.0005391777,
				"type": "EVENT"
			},
			{
				"name": "terror",
				"salience": 0.0005391777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05jj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_American_Free_Trade_Agreement"
				},
				"name": "NAFTA",
				"salience": 0.0005373272,
				"type": "ORGANIZATION"
			},
			{
				"name": "intention",
				"salience": 0.00053238234,
				"type": "OTHER"
			},
			{
				"name": "secrets",
				"salience": 0.0005280316,
				"type": "OTHER"
			},
			{
				"name": "track record",
				"salience": 0.0005151655,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0005151655,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0005151655,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0005151655,
				"type": "PERSON"
			},
			{
				"name": "economists",
				"salience": 0.0005151655,
				"type": "PERSON"
			},
			{
				"name": "rise",
				"salience": 0.0005060464,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05dp3g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Security_debate_in_the_United_States"
				},
				"name": "Privatization of Social Security",
				"salience": 0.00050053786,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fzh9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Medicare_(United_States)"
				},
				"name": "Medicare",
				"salience": 0.00050053786,
				"type": "ORGANIZATION"
			},
			{
				"name": "record",
				"salience": 0.00047741545,
				"type": "OTHER"
			},
			{
				"name": "Boost",
				"salience": 0.00046513183,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00046513183,
				"type": "EVENT"
			},
			{
				"name": "programs",
				"salience": 0.00046513183,
				"type": "OTHER"
			},
			{
				"name": "poor",
				"salience": 0.00046513183,
				"type": "PERSON"
			},
			{
				"name": "Crisis",
				"salience": 0.00046513183,
				"type": "EVENT"
			},
			{
				"name": "cuts",
				"salience": 0.00046513183,
				"type": "OTHER"
			},
			{
				"name": "teachers unions",
				"salience": 0.00046513183,
				"type": "ORGANIZATION"
			},
			{
				"name": "teachers",
				"salience": 0.00046513183,
				"type": "PERSON"
			},
			{
				"name": "boos",
				"salience": 0.00046513183,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09qqq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall"
				},
				"name": "Wall",
				"salience": 0.0004594562,
				"type": "LOCATION"
			},
			{
				"name": "Lesser Evil",
				"salience": 0.0004519245,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War III",
				"salience": 0.0004519245,
				"type": "EVENT"
			},
			{
				"name": "millions",
				"salience": 0.00044212188,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00044014663,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0004332844,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.00043104726,
				"type": "OTHER"
			},
			{
				"name": "unions",
				"salience": 0.00043104726,
				"type": "ORGANIZATION"
			},
			{
				"name": "aggression",
				"salience": 0.00041309927,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00040789257,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00040649256,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vzv0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edward_Snowden"
				},
				"name": "Ed Snowden",
				"salience": 0.00040649256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/055yrc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia-Pacific"
				},
				"name": "Asia Pacific",
				"salience": 0.00040649256,
				"type": "LOCATION"
			},
			{
				"name": "everywhere",
				"salience": 0.0004061174,
				"type": "LOCATION"
			},
			{
				"name": "capitalists",
				"salience": 0.0004061174,
				"type": "PERSON"
			},
			{
				"name": "crash",
				"salience": 0.00040275147,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.00040275147,
				"type": "PERSON"
			},
			{
				"name": "poverty",
				"salience": 0.00040275147,
				"type": "OTHER"
			},
			{
				"name": "SNAP",
				"salience": 0.00040275147,
				"type": "OTHER"
			},
			{
				"name": "foodstamps",
				"salience": 0.00040275147,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00040275147,
				"type": "OTHER"
			},
			{
				"name": "protections",
				"salience": 0.00040275147,
				"type": "OTHER"
			},
			{
				"name": "charter operators",
				"salience": 0.00040275147,
				"type": "ORGANIZATION"
			},
			{
				"name": "good",
				"salience": 0.00040275147,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.00040275147,
				"type": "PERSON"
			},
			{
				"name": "shock and awe",
				"salience": 0.00040275147,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012ml0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Pilger"
				},
				"name": "John Pilger",
				"salience": 0.0003913151,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.00038771366,
				"type": "PERSON"
			},
			{
				"name": "method",
				"salience": 0.00037800163,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00037800163,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00037517436,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00037517436,
				"type": "LOCATION"
			},
			{
				"name": "expression",
				"salience": 0.00036388772,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00034186098,
				"type": "OTHER"
			},
			{
				"name": "policing",
				"salience": 0.00034186098,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0003387344,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0003387344,
				"type": "PERSON"
			},
			{
				"name": "sentiment",
				"salience": 0.0003387344,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0003387344,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0003387344,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.0003387344,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "Goldman Sachs",
				"salience": 0.00033182753,
				"type": "ORGANIZATION"
			},
			{
				"name": "US-Mexico",
				"salience": 0.00033182753,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03h2c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Honduras"
				},
				"name": "Honduras",
				"salience": 0.00033182753,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_America"
				},
				"name": "Central American",
				"salience": 0.00033182753,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.0003287735,
				"type": "PERSON"
			},
			{
				"name": "Maintenance",
				"salience": 0.0003260864,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.00032364737,
				"type": "OTHER"
			},
			{
				"name": "finance capitalist class",
				"salience": 0.00032364737,
				"type": "OTHER"
			},
			{
				"name": "Privatization of Education",
				"salience": 0.0003170481,
				"type": "OTHER"
			},
			{
				"name": "crime bill",
				"salience": 0.0003033535,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.00029330296,
				"type": "OTHER"
			},
			{
				"name": "contradictions",
				"salience": 0.00029330296,
				"type": "OTHER"
			},
			{
				"name": "election season",
				"salience": 0.00029330296,
				"type": "EVENT"
			},
			{
				"name": "collapse",
				"salience": 0.00029330296,
				"type": "EVENT"
			},
			{
				"name": "stimulus cash",
				"salience": 0.00029330296,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00029330296,
				"type": "OTHER"
			},
			{
				"name": "alternative",
				"salience": 0.00029330296,
				"type": "OTHER"
			},
			{
				"name": "duopoly",
				"salience": 0.00029330296,
				"type": "OTHER"
			},
			{
				"name": "trillions",
				"salience": 0.00029330296,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.00029330296,
				"type": "OTHER"
			},
			{
				"name": "Children",
				"salience": 0.00028023912,
				"type": "PERSON"
			},
			{
				"name": "record",
				"salience": 0.00028023912,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.00028023912,
				"type": "EVENT"
			},
			{
				"name": "project",
				"salience": 0.00027879208,
				"type": "OTHER"
			},
			{
				"name": "material threat",
				"salience": 0.00025952005,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "Families",
				"salience": 0.00025301878,
				"type": "PERSON"
			},
			{
				"name": "drug sentence",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "militarization",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "realm",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "prisons",
				"salience": 0.00025301878,
				"type": "PERSON"
			},
			{
				"name": "Austerity",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.00025301878,
				"type": "OTHER"
			},
			{
				"name": "rein",
				"salience": 0.00025188824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07phv8n"
				},
				"name": "Capitalists",
				"salience": 0.00024993106,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0841v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walmart"
				},
				"name": "Wal-Mart",
				"salience": 0.00024785945,
				"type": "ORGANIZATION"
			},
			{
				"name": "enemy",
				"salience": 0.0002334281,
				"type": "PERSON"
			},
			{
				"name": "Mass Black Incarceration State",
				"salience": 0.00022060265,
				"type": "ORGANIZATION"
			},
			{
				"name": "More",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "welfare",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "evisceration",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.00021908227,
				"type": "EVENT"
			},
			{
				"name": "police departments",
				"salience": 0.00021908227,
				"type": "ORGANIZATION"
			},
			{
				"name": "Aid",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "architect",
				"salience": 0.00021908227,
				"type": "PERSON"
			},
			{
				"name": "super predator",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.00021908227,
				"type": "PERSON"
			},
			{
				"name": "use",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "dynasty",
				"salience": 0.00021908227,
				"type": "OTHER"
			},
			{
				"name": "prison population",
				"salience": 0.00019882835,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black America",
				"salience": 0.00019273338,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.0001866846,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0001836132,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00018112082,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0knw7x0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jill_Stein_presidential_campaign,_2012"
				},
				"name": "Jill Stein",
				"salience": 0.00018049909,
				"type": "PERSON"
			},
			{
				"name": "Ajamu Baraka",
				"salience": 0.00018049909,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015wqw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glass%E2%80%93Steagall_Legislation"
				},
				"name": "Glass-Steagall Act",
				"salience": 0.00015570686,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Clinton_12_e693f.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 24.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "20 Shares\n17 2 0 1\nIn last issue of Black Agenda Report, I argued that readers should vote for the Green Party this November. This week, I will outline what to expect from a Hillary Clinton Presidency. The great migration of Republicans into the Democratic Party tent of Hillary Clinton has guaranteed her victory in the highly undemocratic US Presidential elections. Corporate media outlets have collaborated with Clinton to instill deep popular fear of a Trump administration. Fear of Trump has been used to distract the many millions of people in the US who are fed up with both corporate parties. This has led to a lack of investigation and analysis of what can be expected once Hillary Clinton actually takes office.\nThe corporate media has exploited the general population's distaste for sexism and white supremacy in the process. Trump has made heinous statement after heinous statement, all of which should be taken seriously by anyone who calls themselves a movement activist. It is critical that the left in the US extend solidarity to those who experience the consequences of racism and sexism every day. However, Trump's vile character has been used as a means to legitimize the candidacy of Hillary Clinton. His characterization as a fascist has convinced many that his rule would be a greater danger to humanity than a Clinton Presidency.\nOne could endlessly debate Clinton supporters on the validity of such a claim. Trump's vulgar and putrid presentation has provided Clinton supporters with a convenient weapon of defense against all criticism of their own vile choice. Yet the lesser evil argument has never been weaker than in the 2016 elections. It is reasonable to assume that a Hillary Clinton Presidency will be far less effective than Obama in effecting capitalist and imperialist hegemony. This is why her support system, the entire ruling class, has gone into overdrive to spread fear of a Russia-Trump collaborative threat in every sphere of US political life.\nHere are ten things to expect from a Clinton Presidency. I will leave it to readers to judge as to whether Clinton represents a \"lesser evil\" than Trump or just plain evil.\n1.) The Privatization of Social Security - Hillary Clinton has stated publicly and privately to her Wall Street friends that she will reignite conversations to downsize the program. Wikileaks exposed Clinton's support for the Obama's Administration's \"deficit reduction\" commission that originally proposed cuts to entitlements such as Social Security and Medicare in 2012. Clinton donors on Wall Street have made it clear that they would love to get a hold of Social Security earnings and turn them into a financial market to be traded for profit.\nMORE... Hillary Clinton must be indicted How Hillary Clinton ushered in a one party dictatorship of monopoly capital Voting for the “Lesser Evil” John Pilger: Clinton policies will bring great aggression to the US and the world 2.) World War III - Hillary Clinton has stated in nearly every debate that her administration would consider placing a no-fly zone in Syria. That means US airstrikes would rain down on Syrian and Russian assets in Syria. Such a move would place the US military in direct confrontation with the Russia. Clinton has been caught stating that the Syrian and Russian lives that will die in such a conflict are well worth the benefits.\n3.) The Transpacific Partnership - Often called \"NAFTA on steroids,\" the massive corporate trade agreement that captures much of Asia Pacific region has been a major talking point in the 2016 elections. Clinton has supported the agreement in the past, only to switch her position due to pressure from the Bernie Sanders campaign. With Sanders firmly in the Clinton camp, there is currently nothing in the way to stop Clinton from moving forward with the TPP's passage and making her private position on the deal a public reality.\n4.) Maintenance and Expansion of the Surveillance State - Not much needs to be said here. The Obama Administration's vast expansion of the surveillance state has been exposed by the likes of Ed Snowden and Julian Assange. Wikileaks additionally revealed Clinton's desire to drone Julian Assange for releasing Washington’s secrets to the public. A Clinton Presidency has every intention of following up on the Obama Administration's passage of bills such as the National Defense Authorization Act of 2012. This bill gave the US government the right to militarily detain \"terror\" suspects indefinitely.\n5.) Trump's Wall - Hillary Clinton was Obama's Secretary of State from 2009-2013. Over this time, she helped facilitate the largest deportation of undocumented people in US history. Furthermore, she oversaw the detention of thousands of Central American children during the great migration from the 2009 fascist coup in Honduras, a coup that was drawn up by Clinton herself. The US-Mexico border is more militarized than it has ever been. Trump's wall rhetoric was indeed a racist trip, but too few recognize that something just as dangerous actually exists under current US immigration policy.\n6.) Servitude to the Bankers - Hillary Clinton has received over forty million in support from Hedge funds in the 2016 elections. Before selling out, Bernie Sanders made it a point to request public access into Clinton's private, quarter million dollar speeches to banks like Goldman Sachs. The deregulation of the banks with the passage of the Glass-Steagall Act was a Clinton project. Both her current list of donors and past connection to her husband’s policies make her the obvious choice for the finance capitalist class.\n7.) Maintenance of the Mass Black Incarceration State - Hillary Clinton is the enemy of Black America. From her callous use of the term \"super predator\" to describe working class Black men to being the architect of the 1994 crime bill, the Clinton dynasty virtually built the mass Black incarceration state. Under Bill and Hillary Clinton's two terms, the prison population rose by 673,000. This was facilitated by draconian \"three strikes\" laws, mandatory drug sentence, and the deep militarization of local police departments. With her record, it isn't too difficult to assume what another four years of Clinton rule will bring in the realm of policing and prisons.\n8.) Austerity and More Austerity - It was the first Clinton Administration that eliminated \"welfare as we know it.\" The evisceration of Aid to Families and Dependent Children (AFDC) and its replacement, Temporary Assistance to Needy Families (TANF), threw millions of women and children into poverty. Obama has followed up with draconian cuts to SNAP (foodstamps). There is nothing on Clinton's track record that indicates her administration would do anything but roll back whatever social programs and protections still exist for the poor in the US.\n9.) A Boost to the Privatization of Education - Hillary Clinton received boos in July when she urged teachers' unions and charter operators to \"work together\" for the greater good of students. Ever since, Clinton has attempted to exploit the rise of Sanders by courting teachers unions to endorse her. Her position has slightly softened on the privatization of education, but that hardly matters. Clinton receives broad support from school privatizers (like Wal-Mart) and should not be expected to roll back the \"shock and awe\" war on public education waged by the Obama Administration.\n10.) An Economic Crisis - Bankers and economists have been predicting an economic crash for much of 2016. Capitalists everywhere were given free rein to \"recover\" with trillions in stimulus cash after sending the entire global capitalist economy into collapse in 2008. The internal contradictions of the system are only sharpening as workers become poorer and global production stagnates. Whether Clinton can manage a crisis in service of the capitalists as well Obama has remains to be seen.\nClinton may very well be the highest expression of ruling class consensus that has ever presented itself in an election season. Her political record represents a greater material threat to humanity than Donald Trump for the sheer fact that she is the preferred candidate of the ruling class. The question now is whether mass sentiment exists to organize around an alternative to the two-party corporate duopoly. Jill Stein and Ajamu Baraka are attempting to build the base of the Green party ticket. Whatever method is chosen, it must be wielded to combat lesser evil politics and build an organized force ready to struggle against the intensified suffering that will surely be imposed on the world by a Clinton Administration.",
		"thread_title": "10 Things to Expect with a Hillary Clinton Presidency",
		"title": "10 Things to Expect with a Hillary Clinton Presidency",
		"type": "bs",
		"uuid": "332dce74fd5213b4076b1d5d6be088205f00117c"
	},
	"-KhIbDMdbjLntrtgbjN3": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T09:35:05.241+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.17916438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.12355103,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.11290017,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.05266921,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.040596023,
				"type": "PERSON"
			},
			{
				"name": "atrocities",
				"salience": 0.032349084,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.029452814,
				"type": "EVENT"
			},
			{
				"name": "momentum",
				"salience": 0.029452814,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.025702942,
				"type": "PERSON"
			},
			{
				"name": "Abdel Rakhim Shamri",
				"salience": 0.02491294,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.023601718,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.021790322,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.019313317,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/052dhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takfiri"
				},
				"name": "Takfiris",
				"salience": 0.018208439,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.015479155,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.01512409,
				"type": "LOCATION"
			},
			{
				"name": "human rights office",
				"salience": 0.013305062,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rupert Colville",
				"salience": 0.012230759,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ck32l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nouri_al-Maliki"
				},
				"name": "Nouri al-Maliki",
				"salience": 0.011700245,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028t63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haider_al-Abadi"
				},
				"name": "Haider al-Abadi",
				"salience": 0.010510943,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.010467321,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nineveh_Governorate"
				},
				"name": "Nineveh",
				"salience": 0.009328986,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.007983404,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.007983404,
				"type": "LOCATION"
			},
			{
				"name": "human rights committee",
				"salience": 0.007210134,
				"type": "ORGANIZATION"
			},
			{
				"name": "hostage",
				"salience": 0.006245418,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0055243596,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.005393163,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.005393163,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.004951305,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sf4r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Nicholson_(East_India_Company_officer)"
				},
				"name": "John Nicholson",
				"salience": 0.0048589963,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.004696742,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.004574683,
				"type": "LOCATION"
			},
			{
				"name": "human shields",
				"salience": 0.0043814424,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.0043814424,
				"type": "OTHER"
			},
			{
				"name": "killings",
				"salience": 0.0043814424,
				"type": "EVENT"
			},
			{
				"name": "airlifting",
				"salience": 0.0042180973,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.004131022,
				"type": "LOCATION"
			},
			{
				"name": "police officers",
				"salience": 0.004131022,
				"type": "PERSON"
			},
			{
				"name": "Hammam al-Alil",
				"salience": 0.0038469816,
				"type": "PERSON"
			},
			{
				"name": "security forces",
				"salience": 0.0035776873,
				"type": "PERSON"
			},
			{
				"name": "bullet wounds",
				"salience": 0.0035776873,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.0035776873,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0032740657,
				"type": "OTHER"
			},
			{
				"name": "Prime Minister",
				"salience": 0.003086857,
				"type": "PERSON"
			},
			{
				"name": "Shamri",
				"salience": 0.003076273,
				"type": "OTHER"
			},
			{
				"name": "Civilians",
				"salience": 0.0026955528,
				"type": "PERSON"
			},
			{
				"name": "coalition",
				"salience": 0.0026732315,
				"type": "ORGANIZATION"
			},
			{
				"name": "head",
				"salience": 0.0026732315,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0026732315,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0026732315,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0026732315,
				"type": "OTHER"
			},
			{
				"name": "Arij",
				"salience": 0.0025973879,
				"type": "ORGANIZATION"
			},
			{
				"name": "Staff",
				"salience": 0.00249034,
				"type": "PERSON"
			},
			{
				"name": "Staff",
				"salience": 0.00249034,
				"type": "PERSON"
			},
			{
				"name": "briefing",
				"salience": 0.0024154806,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03902",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Geneva"
				},
				"name": "Geneva",
				"salience": 0.0022028193,
				"type": "LOCATION"
			},
			{
				"name": "Tuloul Naser",
				"salience": 0.0022028193,
				"type": "PERSON"
			},
			{
				"name": "AHT",
				"salience": 0.0020306017,
				"type": "ORGANIZATION"
			},
			{
				"name": "Breathing Problems",
				"salience": 0.0019472393,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0019472393,
				"type": "EVENT"
			},
			{
				"name": "comple",
				"salience": 0.0019472393,
				"type": "OTHER"
			},
			{
				"name": "al-Qanoon",
				"salience": 0.0016457025,
				"type": "PERSON"
			},
			{
				"name": "Mosul Iraqi",
				"salience": 0.0014648136,
				"type": "LOCATION"
			},
			{
				"name": "army",
				"salience": 0.0014547231,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.0014547231,
				"type": "PERSON"
			},
			{
				"name": "Torches Sulphur Plant",
				"salience": 0.0011986285,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0011986285,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0011986285,
				"type": "LOCATION"
			},
			{
				"name": "Karamless Village",
				"salience": 0.0011452581,
				"type": "LOCATION"
			},
			{
				"name": "Khorasan Caliphate",
				"salience": 0.0010558724,
				"type": "OTHER"
			},
			{
				"name": "Muslim Iraqi Soldiers Erect Cross",
				"salience": 0.0008953894,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01wb7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Church_(building)"
				},
				"name": "Church",
				"salience": 0.0008953894,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.0008953894,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0008953894,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/ISIS_Hammam_c0a76.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "ISIS executes over 230 civilians in Mosul as the battle to liberate the Iraqi city from the Takfiris gains momentum. 14 Shares\n11 3 0 0\n\"ISIS terrorists continued to commit atrocities in the province of Nineveh, they executed 190 people in the area of Hammam al-Alil after taking them hostage in different areas of Mosul,\" said the chairman of the Iraqi parliamentary human rights committee, Abdel Rakhim Shamri, on Wednesday.\nHe added that another 42 people were taken from the village of Arij and executed after they refused to cooperate with the terrorists.\nShamri also called on Iraqi Prime Minister Haider al-Abadi to facilitate the airlifting of civilians from Daesh-held areas in Mosul as the terrorists are using them as human shields.\nOn Tuesday, the UN human rights office said it had preliminary reports about scores of mass killings by ISIS around Mosul in the past week.\nUN human rights spokesman Rupert Colville told a regular UN briefing in Geneva that the bodies of 70 civilians with bullet wounds had been discovered by Iraqi security forces in Tuloul Naser village on October 20, and 50 police officers being held outside the city had also reportedly been killed, Press TV reported.\nRecommended For You Muslim Iraqi Soldiers Erect Cross on Top of the Church in Newly Liberated Karamless Village Near Mosul\nIraqi army troops on Saturday stormed into a Christian region that has been under ISIS control since 2014 as part of operations to clear t...\nBy AHT Staff Nouri al-Maliki, the former Prime Minister of Iraq, and the head of the al-Qanoon parliamentary coalition, stated in his speech during the...\nBy AHT Staff U.S. Commander John Nicholson: ISIS Attempting to Establish Khorasan Caliphate in Afghanistan comple...\nBy AHT Staff Thousand of Iraqi Civilians Treated for Breathing Problems after ISIS Torches Sulphur Plant near Mosul",
		"thread_title": "Executes 190 Iraqi Civilians in Hammam al-Alil, 42 in Arij Village: Official",
		"title": "Executes 190 Iraqi Civilians in Hammam al-Alil, 42 in Arij Village: Official",
		"type": "bs",
		"uuid": "11df9bd055c59241dbb7a38b9b90a3091154cc47"
	},
	"-KhIbDzZMbvhD8-qkW_U": {
		"author": "Tim King",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T09:49:06.505+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.14616923,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.09326263,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.065812916,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.062538326,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.04213369,
				"type": "PERSON"
			},
			{
				"name": "pilots",
				"salience": 0.028309053,
				"type": "PERSON"
			},
			{
				"name": "conditioning system",
				"salience": 0.021027265,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.019034153,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.015617941,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_83h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_American_F-86_Sabre"
				},
				"name": "F-86 Sabre",
				"salience": 0.014545029,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.011234177,
				"type": "OTHER"
			},
			{
				"name": "responses",
				"salience": 0.009511982,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048n7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korean_War"
				},
				"name": "Korean War",
				"salience": 0.008422775,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladmir Putin",
				"salience": 0.007774552,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet",
				"salience": 0.0074816546,
				"type": "LOCATION"
			},
			{
				"name": "politicians",
				"salience": 0.0072373506,
				"type": "PERSON"
			},
			{
				"name": "wave",
				"salience": 0.0068750633,
				"type": "OTHER"
			},
			{
				"name": "denials",
				"salience": 0.0068750633,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0068750633,
				"type": "OTHER"
			},
			{
				"name": "deflections",
				"salience": 0.0068750633,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0064448463,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.006381391,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0063776616,
				"type": "EVENT"
			},
			{
				"name": "President",
				"salience": 0.005744915,
				"type": "PERSON"
			},
			{
				"name": "blow",
				"salience": 0.0056123706,
				"type": "OTHER"
			},
			{
				"name": "Peace",
				"salience": 0.005580204,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.004918586,
				"type": "ORGANIZATION"
			},
			{
				"name": "wing firebrands",
				"salience": 0.0048629087,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "democrats",
				"salience": 0.0048629087,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019cpb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mikoyan_MiG-29"
				},
				"name": "MiG-29",
				"salience": 0.00452915,
				"type": "ORGANIZATION"
			},
			{
				"name": "state election systems",
				"salience": 0.0044928505,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0044928505,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0044928505,
				"type": "OTHER"
			},
			{
				"name": "candor",
				"salience": 0.0044928505,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0044928505,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0044928505,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.00421413,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.004056955,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.004056955,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.004056955,
				"type": "OTHER"
			},
			{
				"name": "military conflict",
				"salience": 0.004056955,
				"type": "OTHER"
			},
			{
				"name": "wolf in sheep's clothing",
				"salience": 0.003743171,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "jet fighters",
				"salience": 0.0037243278,
				"type": "PERSON"
			},
			{
				"name": "G-suits",
				"salience": 0.003580217,
				"type": "OTHER"
			},
			{
				"name": "proclamations",
				"salience": 0.0035133578,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.0035133578,
				"type": "OTHER"
			},
			{
				"name": "world devastation",
				"salience": 0.0035133578,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0035133578,
				"type": "OTHER"
			},
			{
				"name": "military action",
				"salience": 0.0035133578,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.0035133578,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.0032350319,
				"type": "EVENT"
			},
			{
				"name": "Things",
				"salience": 0.0031910758,
				"type": "OTHER"
			},
			{
				"name": "Kemp Freund",
				"salience": 0.0030046029,
				"type": "PERSON"
			},
			{
				"name": "rules",
				"salience": 0.0029818257,
				"type": "OTHER"
			},
			{
				"name": "bursts",
				"salience": 0.0028140303,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0027325407,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0027325407,
				"type": "EVENT"
			},
			{
				"name": "Nikolay V. Stroykov",
				"salience": 0.0025324349,
				"type": "PERSON"
			},
			{
				"name": "pilots",
				"salience": 0.0025160208,
				"type": "PERSON"
			},
			{
				"name": "gun sight",
				"salience": 0.002479002,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0pgkc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voting"
				},
				"name": "Voting",
				"salience": 0.0024379338,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.002436215,
				"type": "OTHER"
			},
			{
				"name": "settlements",
				"salience": 0.002326745,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.002259669,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0022567254,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018js4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Top_Gun"
				},
				"name": "Top Gun",
				"salience": 0.002189417,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0264n4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Beck"
				},
				"name": "Glenn Beck",
				"salience": 0.0021629299,
				"type": "PERSON"
			},
			{
				"name": "jet fighter",
				"salience": 0.0021461372,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.002076095,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0020450025,
				"type": "PERSON"
			},
			{
				"name": "responses",
				"salience": 0.0020026476,
				"type": "OTHER"
			},
			{
				"name": "Military response",
				"salience": 0.0020026476,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0020026476,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.0020026476,
				"type": "OTHER"
			},
			{
				"name": "Military responses",
				"salience": 0.0020026476,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0020026476,
				"type": "EVENT"
			},
			{
				"name": "attachments",
				"salience": 0.0020026476,
				"type": "OTHER"
			},
			{
				"name": "pilots",
				"salience": 0.0019160394,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0019147014,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.001850121,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.001850121,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.001850121,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0018405719,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.0018200144,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0018200144,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01kvt3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mikoyan-Gurevich_MiG-25"
				},
				"name": "MiG-25",
				"salience": 0.0017910751,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Camp Joyce: Remote Fire Base Near Afghanistan-Pakistan Border",
				"salience": 0.0017836589,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sources",
				"salience": 0.0017828617,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/065ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_American_P-51_Mustang"
				},
				"name": "P-51 Mustangs",
				"salience": 0.0017342907,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fighter",
				"salience": 0.0017300074,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018z5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mikoyan-Gurevich_MiG-15"
				},
				"name": "MiG-15",
				"salience": 0.001681047,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hacking",
				"salience": 0.0016704856,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0016704856,
				"type": "PERSON"
			},
			{
				"name": "hackers",
				"salience": 0.0016704856,
				"type": "PERSON"
			},
			{
				"name": "jet fighter",
				"salience": 0.0016654339,
				"type": "PERSON"
			},
			{
				"name": "advantages",
				"salience": 0.0016092566,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.0015823289,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.0015380789,
				"type": "OTHER"
			},
			{
				"name": "theft",
				"salience": 0.0015217713,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0014995674,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.0014918267,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.0014465067,
				"type": "EVENT"
			},
			{
				"name": "files",
				"salience": 0.0014465067,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0014465067,
				"type": "WORK_OF_ART"
			},
			{
				"name": "consequences",
				"salience": 0.0014465067,
				"type": "OTHER"
			},
			{
				"name": "mindset",
				"salience": 0.0014465067,
				"type": "OTHER"
			},
			{
				"name": "media outlets",
				"salience": 0.0014465067,
				"type": "OTHER"
			},
			{
				"name": "blame",
				"salience": 0.0014465067,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0014465067,
				"type": "WORK_OF_ART"
			},
			{
				"name": "verge",
				"salience": 0.0014465067,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0014465067,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.001442132,
				"type": "LOCATION"
			},
			{
				"name": "air force",
				"salience": 0.0014175993,
				"type": "ORGANIZATION"
			},
			{
				"name": "air",
				"salience": 0.0014123247,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.0014123247,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.0014123247,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.0014123247,
				"type": "OTHER"
			},
			{
				"name": "interceptor",
				"salience": 0.0013646815,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0013429739,
				"type": "EVENT"
			},
			{
				"name": "speed",
				"salience": 0.0012971831,
				"type": "OTHER"
			},
			{
				"name": "interceptors",
				"salience": 0.0012971831,
				"type": "PERSON"
			},
			{
				"name": "advantages",
				"salience": 0.0012971831,
				"type": "OTHER"
			},
			{
				"name": "speed",
				"salience": 0.0012971831,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.0012917534,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet",
				"salience": 0.0012824946,
				"type": "ORGANIZATION"
			},
			{
				"name": "truth",
				"salience": 0.0012581672,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0012487586,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0012487586,
				"type": "OTHER"
			},
			{
				"name": "warmongering",
				"salience": 0.0012321607,
				"type": "OTHER"
			},
			{
				"name": "priority",
				"salience": 0.0012111985,
				"type": "OTHER"
			},
			{
				"name": "moves",
				"salience": 0.0012111985,
				"type": "OTHER"
			},
			{
				"name": "skies",
				"salience": 0.0011712145,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0011684883,
				"type": "EVENT"
			},
			{
				"name": "pilots",
				"salience": 0.0011684883,
				"type": "PERSON"
			},
			{
				"name": "pilot",
				"salience": 0.0011684883,
				"type": "OTHER"
			},
			{
				"name": "pilot",
				"salience": 0.0011684883,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.001146279,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.001141881,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA Today",
				"salience": 0.0011387577,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam War",
				"salience": 0.0011353134,
				"type": "EVENT"
			},
			{
				"name": "security",
				"salience": 0.0011274908,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0011274908,
				"type": "OTHER"
			},
			{
				"name": "designs",
				"salience": 0.0011274908,
				"type": "WORK_OF_ART"
			},
			{
				"name": "design",
				"salience": 0.0011274908,
				"type": "OTHER"
			},
			{
				"name": "rivalry",
				"salience": 0.0011274908,
				"type": "OTHER"
			},
			{
				"name": "blow",
				"salience": 0.0011274908,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0011274908,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.0011248739,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Benjamin Netanyahu",
				"salience": 0.0011248739,
				"type": "PERSON"
			},
			{
				"name": "gunners",
				"salience": 0.0011083087,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "U.S. Air Force",
				"salience": 0.0011060745,
				"type": "ORGANIZATION"
			},
			{
				"name": "road block",
				"salience": 0.0010943414,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviets",
				"salience": 0.0010643146,
				"type": "LOCATION"
			},
			{
				"name": "air",
				"salience": 0.0010550129,
				"type": "OTHER"
			},
			{
				"name": "military planes",
				"salience": 0.0010550129,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gry7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mikoyan-Gurevich_MiG-21"
				},
				"name": "MiG-21",
				"salience": 0.0010421406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gt74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mikoyan-Gurevich_MiG-17"
				},
				"name": "MiG-17",
				"salience": 0.0010421406,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "history",
				"salience": 0.0010402098,
				"type": "OTHER"
			},
			{
				"name": "fullest",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "ace",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "controls",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0010141563,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "prop",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "Everything",
				"salience": 0.0010141563,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0009783921,
				"type": "EVENT"
			},
			{
				"name": "nature",
				"salience": 0.000976294,
				"type": "OTHER"
			},
			{
				"name": "highway",
				"salience": 0.000976294,
				"type": "LOCATION"
			},
			{
				"name": "scales",
				"salience": 0.000976294,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.000976294,
				"type": "PERSON"
			},
			{
				"name": "balance",
				"salience": 0.000976294,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.000976294,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.000976294,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.000976294,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00096996943,
				"type": "LOCATION"
			},
			{
				"name": "aircraft",
				"salience": 0.00096493616,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0009561121,
				"type": "OTHER"
			},
			{
				"name": "air combat",
				"salience": 0.0009561121,
				"type": "OTHER"
			},
			{
				"name": "kills",
				"salience": 0.0009561121,
				"type": "OTHER"
			},
			{
				"name": "competitors",
				"salience": 0.0009561121,
				"type": "ORGANIZATION"
			},
			{
				"name": "kill",
				"salience": 0.0009561121,
				"type": "OTHER"
			},
			{
				"name": "air combat",
				"salience": 0.0009561121,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0009561121,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "WWII",
				"salience": 0.0009492584,
				"type": "EVENT"
			},
			{
				"name": "Lt. Col.",
				"salience": 0.0009337563,
				"type": "PERSON"
			},
			{
				"name": "war president",
				"salience": 0.0009141712,
				"type": "PERSON"
			},
			{
				"name": "commander",
				"salience": 0.00090081873,
				"type": "PERSON"
			},
			{
				"name": "Harrier",
				"salience": 0.00089889474,
				"type": "LOCATION"
			},
			{
				"name": "World Rivals",
				"salience": 0.00089428236,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0008883239,
				"type": "LOCATION"
			},
			{
				"name": "ways",
				"salience": 0.00087637966,
				"type": "OTHER"
			},
			{
				"name": "d",
				"salience": 0.0008709769,
				"type": "PERSON"
			},
			{
				"name": "pilot blackout",
				"salience": 0.0008709769,
				"type": "EVENT"
			},
			{
				"name": "Elizabith Weise",
				"salience": 0.00086798763,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0008499945,
				"type": "LOCATION"
			},
			{
				"name": "nobody",
				"salience": 0.0008384586,
				"type": "PERSON"
			},
			{
				"name": "turning maneuvers",
				"salience": 0.00082789117,
				"type": "OTHER"
			},
			{
				"name": "ratios",
				"salience": 0.00082789117,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.00082789117,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.00082789117,
				"type": "PERSON"
			},
			{
				"name": "MiGs",
				"salience": 0.00082789117,
				"type": "PERSON"
			},
			{
				"name": "target",
				"salience": 0.00082789117,
				"type": "OTHER"
			},
			{
				"name": "machine guns",
				"salience": 0.00082789117,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "types",
				"salience": 0.00082789117,
				"type": "OTHER"
			},
			{
				"name": "demands",
				"salience": 0.00081745686,
				"type": "OTHER"
			},
			{
				"name": "thrust vectoring",
				"salience": 0.0008158057,
				"type": "OTHER"
			},
			{
				"name": "Mach III",
				"salience": 0.0007983677,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.0007950254,
				"type": "ORGANIZATION"
			},
			{
				"name": "Quote",
				"salience": 0.00078693626,
				"type": "OTHER"
			},
			{
				"name": "Air There",
				"salience": 0.00076855964,
				"type": "LOCATION"
			},
			{
				"name": "job",
				"salience": 0.0007575549,
				"type": "OTHER"
			},
			{
				"name": "stars",
				"salience": 0.00075136375,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kdx6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_P-80_Shooting_Star"
				},
				"name": "F-80 Shooting Star",
				"salience": 0.0007208276,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.0007208276,
				"type": "LOCATION"
			},
			{
				"name": "method",
				"salience": 0.0007141937,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00071100285,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hg0x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_American_F-100_Super_Sabre"
				},
				"name": "F-100 Super Sabre",
				"salience": 0.00070547883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012m0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Ballistic_Missile_Treaty"
				},
				"name": "ABM Treaty",
				"salience": 0.00069391396,
				"type": "OTHER"
			},
			{
				"name": "jet",
				"salience": 0.0006764926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ffvqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_People's_Air_Force"
				},
				"name": "North Vietnamese Air Force",
				"salience": 0.0006517272,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.0006517272,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0006505952,
				"type": "ORGANIZATION"
			},
			{
				"name": "pilot",
				"salience": 0.0006356614,
				"type": "OTHER"
			},
			{
				"name": "pilots",
				"salience": 0.0006356614,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/023w12",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic_F-84_Thunderjet"
				},
				"name": "F-84 Thunderjet",
				"salience": 0.0006241536,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0006235775,
				"type": "OTHER"
			},
			{
				"name": "dark",
				"salience": 0.0006184092,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0006184092,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.0006184092,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0006184092,
				"type": "OTHER"
			},
			{
				"name": "echelons",
				"salience": 0.0006184092,
				"type": "OTHER"
			},
			{
				"name": "Warfare",
				"salience": 0.0006184092,
				"type": "OTHER"
			},
			{
				"name": "Approach",
				"salience": 0.0006184092,
				"type": "OTHER"
			},
			{
				"name": "helm",
				"salience": 0.0006184092,
				"type": "OTHER"
			},
			{
				"name": "soldier",
				"salience": 0.0006184092,
				"type": "PERSON"
			},
			{
				"name": "F-5 Tigers",
				"salience": 0.00060354534,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b73sgc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Petersburg_International_Economic_Forum"
				},
				"name": "St. Petersburg International Economic Forum",
				"salience": 0.00060084875,
				"type": "EVENT"
			},
			{
				"name": "Lesser Evil",
				"salience": 0.00060084875,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northrop_F-5"
				},
				"name": "F-5 Tiger",
				"salience": 0.0005884266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dyx3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing_B-29_Superfortress"
				},
				"name": "B-29",
				"salience": 0.0005884266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h7t2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MiG_Alley"
				},
				"name": "MiG Alley",
				"salience": 0.0005884266,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.00057392096,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.00057392096,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0005269657,
				"type": "LOCATION"
			},
			{
				"name": "aircraft",
				"salience": 0.00052491284,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.00052491284,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.00052491284,
				"type": "OTHER"
			},
			{
				"name": "jet",
				"salience": 0.00052491284,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.000520112,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.000520112,
				"type": "OTHER"
			},
			{
				"name": "reserves",
				"salience": 0.000520112,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.000520112,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.000520112,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.000520112,
				"type": "OTHER"
			},
			{
				"name": "Conflicts",
				"salience": 0.000520112,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.000520112,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0005177881,
				"type": "OTHER"
			},
			{
				"name": "792 MiG-15s",
				"salience": 0.0005095067,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/033j1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McDonnell_Douglas_F-4_Phantom_II"
				},
				"name": "F-4 Phantom",
				"salience": 0.0005095067,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0004969462,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0004969462,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.0004737937,
				"type": "OTHER"
			},
			{
				"name": "advantages",
				"salience": 0.0004702498,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d07ph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wikipedia"
				},
				"name": "Wikipedia",
				"salience": 0.00046863564,
				"type": "WORK_OF_ART"
			},
			{
				"name": "each other",
				"salience": 0.00046578547,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0004503531,
				"type": "PERSON"
			},
			{
				"name": "human rights",
				"salience": 0.0004503531,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0004503531,
				"type": "OTHER"
			},
			{
				"name": "military hardware",
				"salience": 0.0004503531,
				"type": "OTHER"
			},
			{
				"name": "taxpayer money",
				"salience": 0.0004503531,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0004503531,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0004503531,
				"type": "ORGANIZATION"
			},
			{
				"name": "hospitals",
				"salience": 0.0004503531,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.0004503531,
				"type": "OTHER"
			},
			{
				"name": "warmongering spirit",
				"salience": 0.0004503531,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.00043952803,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0004354826,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.00043029396,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.00042807206,
				"type": "OTHER"
			},
			{
				"name": "Computer security researchers",
				"salience": 0.00042457326,
				"type": "PERSON"
			},
			{
				"name": "MiG-28",
				"salience": 0.00042346094,
				"type": "WORK_OF_ART"
			},
			{
				"name": "skies",
				"salience": 0.00038849795,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.00038849795,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.00038849795,
				"type": "OTHER"
			},
			{
				"name": "thrust vectoring",
				"salience": 0.00038849795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "US Army",
				"salience": 0.00038057598,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.00038057598,
				"type": "LOCATION"
			},
			{
				"name": "speculation",
				"salience": 0.00035389917,
				"type": "OTHER"
			},
			{
				"name": "aces",
				"salience": 0.0003363896,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0003363896,
				"type": "EVENT"
			},
			{
				"name": "knowledge",
				"salience": 0.0003363896,
				"type": "OTHER"
			},
			{
				"name": "close",
				"salience": 0.0003363896,
				"type": "EVENT"
			},
			{
				"name": "no one",
				"salience": 0.0003363896,
				"type": "PERSON"
			},
			{
				"name": "tails",
				"salience": 0.0003363896,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.0003363896,
				"type": "OTHER"
			},
			{
				"name": "helicopter",
				"salience": 0.0003363896,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0003363896,
				"type": "OTHER"
			},
			{
				"name": "jet blast",
				"salience": 0.0003363896,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.0003363896,
				"type": "OTHER"
			},
			{
				"name": "650 Sabres",
				"salience": 0.00029776333,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.00029300118,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0002816517,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jt7v76",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestinians"
				},
				"name": "Palestinians",
				"salience": 0.00027714664,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0357_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gaza_Strip"
				},
				"name": "Gaza",
				"salience": 0.00027714664,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00027714664,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018wvh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gentile"
				},
				"name": "non-Jews",
				"salience": 0.00027714664,
				"type": "PERSON"
			},
			{
				"name": "plenty",
				"salience": 0.00025126268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranians",
				"salience": 0.0002224105,
				"type": "PERSON"
			},
			{
				"name": "AV8",
				"salience": 0.00020701079,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02p7py",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sukhoi_Su-30"
				},
				"name": "SU-30",
				"salience": 0.00020701079,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_Martin_F-22_Raptor"
				},
				"name": "F-22 Raptor",
				"salience": 0.00020701079,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "MiG-28",
				"salience": 0.00020701079,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Clinton_13_4f87e.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 26,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.038",
		"text": "22 Shares\n8 13 0 1\nAs Donald Trump gains more bad press, Hilary Clinton rides the political wave with quick responses, deflections and denials. Without question, and largely due to Trump's obnoxious candor and grandiose proclamations, she is working her way back into the favor of disgruntled democrats and even right wing firebrands like the notorious Glenn Beck. She is, without question, a wolf in sheep's clothing. While Trump is unbelievably hard to take, constantly, we need to focus on one simple question, which of these candidates will lead to world devastation first?\nI suspect it would be Hillary Clinton who would be most inclined toward involving Americans in another military conflict, and she doesn't go small, as she constantly demonizes Russia with threats of military action. In Clinton's own words, \"You've seen reports, Russia has hacked into a lot of things, China has hacked into a lot of things, Russia even hacked into the Democratic National Committee, maybe even some state election systems. So we've got to step up our game, make sure we are well defended and can take the fight to those who go after us. As President, I will make it clear that the United States will treat cyber attacks just like any other attack. We will be ready with serious political, economic and military responses.\"\nMilitary responses to a nation the US stood on the verge of war with for more than four decades? Military response against Russia? Over suspected hacking? Hillary Clinton betrayed her real mindset once and for all during the recent debate with Donald Trump when she spoke those words of war that would surely lead to only disastrous consequences.\nIt all stems from the Wikileaks release that included 19,252 emails and 8,034 attachments from leaders at the Democratic National Committee. Clinton says the Russians did it, the national mainstream media parroted those words. It's the American media's political conditioning system at its finest, convincingly reaching tens of millions of Americans, and yet nobody knows if the blame is properly attributed to the Russians. In a USA Today article from July 2016, Elizabith Weise wrote, \"Computer security researchers say it’s difficult to definitively say the cyber theft of files from the Democratic National Committee subsequently posted online by Wikileaks was the work of Russian hackers, as some media outlets have reported.\"\nRussia's leader, Vladmir Putin, says the US long ago tipped the scales in the wrong direction, well before the Cold War even ended. Peace with Russia should be a top priority for any US Presidential candidate. The truth is that American politicians, perpetually convinced they are making the right political moves, created a road block on the highway to peace during the Vietnam War. Putin said during the St. Petersburg International Economic Forum 2016, \"It is not in my nature to scold someone -- but when the United States unilaterally withdrew from the ABM Treaty (in) 1972 they delivered a colossal blow to the entire system of international security. That was the first blow when it comes to assessing the strategic balance of power in the world\".\nMORE... 10 Things to Expect with a Hillary Clinton Presidency Hillary Clinton must be indicted How Hillary Clinton ushered in a one party dictatorship of monopoly capital Voting for the “Lesser Evil” Now we have Clinton warmongering over unfounded allegations.\nWorld Rivals in the Air\nThere is a decades-old history of rivalry between eastern and western jet fighter design and technology. While American designs are more expensive and generally considered to be better, the fastest jet fighter ever made is the Russian MiG-25; it can break Mach III, more than three times the speed of sound. Such demands lessen the life of an aircraft. The MiG-25 is typically not flown at anything close to that speed. As an interceptor however, it was supreme, no allied fighter in the sky could outrun it.\nThe Korean War was the first test. Soviet MiG-15's initially dominated the skies. With Russian and Chinese pilots often at the controls, the MiG's were deadly.\nOn 1 November 1950, at least sixteen American F-51 fighters (P-51 Mustangs) were shot at by six Soviet MiG-15 interceptors led by Soviet WWII ace Mayor Nikolay V. Stroykov. The WWII \"prop\" planes like the Mustang, along with the U.S. F-80 Shooting Star and F-84 Thunderjet jet fighters, had a job on their hands fighting the robust and highly maneuverable MiG fighters.\nEverything changed when the U.S. Air Force launched the F-86 Sabre. Wikipedia explains that the F-86 Sabre pilots enjoyed advantages they learned to exploit to the fullest. Foremost among those was a radar ranging gun sight on their six .50 caliber machine guns, which ensured that even short bursts of fire generally found their target. F-86 pilots were also equipped with G-suits, which prevented pilot blackout in high-speed turning maneuvers.\nIt is unlikely that anybody will ever fully agree on the casualties and \"kill\" ratios over \"MiG Alley\" during the Korean War.\nThe Soviets claimed 1,106 United Nations planes of all types shot down, including about 650 Sabres. (The USAF only admits to losing less than 200 aircraft in air combat.)\nThe F-86 pilots claimed 792 MiG-15s shot down, while B-29 gunners claimed a further 16. These numbers were later reduced to 379 MiGs. The Chinese air force claimed only 85 kills.\nIn Vietnam, the competitors varied. The MiG-17 and MiG-21 fighters were widely used by the North Vietnamese Air Force. They fought planes like the F-100 Super Sabre, F-5 Tiger and the F-4 Phantom. Once again, if you believe western sources which are fairly reliable for the most part, the U.S. planes dominated in most air to air combat, though the other side had plenty of talented pilots and more aces overall than the Americans. During the end of the Cold War in the 1980's, the Soviet MiG-29 was the terror of the skies. There was more speculation about it than real knowledge at first. While MiG aircraft were only built in odd numbers, the movie Top Gun references the aircraft by calling them MiG-28's - \"MiG-28's, no one's been this close before!\" The planes used in the movie were actually American F-5 Tigers painted black with red stars applied to the tails. Today the United States spends obscene amounts on planes like the F-22 Raptor and these aircraft do not have any clear advantages over modern Russian planes like the SU-30. Both in this case, are capable of \"thrust vectoring\" which means the pilot can change the direction of the jet blast and create an entirely separate way to control the jet in flight. The ultimate western jet in the world of thrust vectoring is the AV8/b Harrier which can actually take off and land like a helicopter. Hopefully the world will not have to put these machines against each other in a future war, but with Clinton at the helm it is entirely possible and the advantages the US used to hold over the Russian military have evaporated into thin air.\nRussia's Modern Approach to Warfare\nDuring the decades-long Cold War, the Soviet Union operated under archaic rules that essentially prevented a commander, or a pilot, from knowing their mission until they were dispatched to carry out the order. Kemp Freund, a US Army sergeant major that I met while I was covering the war in Afghanistan, was Quote: d in my 2007 video report \"Camp Joyce: Remote Fire Base Near Afghanistan-Pakistan Border\" saying, \"We're trying to break the old Soviet methods that they use and the Soviet method had that Lt. Col. completely in the dark until he needed to move.” He added, “We're still working with the higher echelons to get that to move downhill.\" The Soviet ways were detrimental and offered little freedom to a trained soldier or pilot but all that is over now. Today's Russian pilots not only fly superior aircraft that cost far less than US taxpayer funded military planes, they also utilize tactics of Western pilots. Hillary Clinton surely knows these facts but she wants to play with fire and be another \"war president\" which was so important to former President George W. Bush, and Obama too for that matter.\nOther Looming Conflicts\nLest we forget, Hillary Clinton's unwavering support of Israel, the apartheid religious nuclear state that has long been protected by US taxpayer money and military hardware. The government of right wing Israeli Prime Minister Benjamin Netanyahu continues to violate the human rights of Palestinians constantly, while building settlements which are completely illegal under international law. Then there are the attacks in Gaza that target schools and hospitals, leaving hundreds and hundreds dead and thousands severely injured. Never does Clinton speak out against the barbaric treatment Israel reserves for non-Jews, never does she refer to the fact that the country we now call Iran hasn't attacked a nation outside of its borders for more than three hundred years. Yet Iran has been savagely attacked by the United States both directly and indirectly. Maintaining her warmongering spirit, Clinton said, \"I want the Iranians to know that if I'm president we will attack Iran.\" She added that, \"We would be able to totally obliterate them.\"",
		"thread_title": "Clinton's Policies Look Like a Death Sentence for Americans",
		"title": "Clinton's Policies Look Like a Death Sentence for Americans",
		"type": "bs",
		"uuid": "32d1b3ccf955d0e875513a04627930d3c76dfa16"
	},
	"-KhIbED4Q6d51S6f9mXZ": {
		"author": "Catherine Shakdam",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T22:11:47.477+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.17440896,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.15665345,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.09630672,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01pk8b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeddah"
				},
				"name": "Jeddah",
				"salience": 0.04678382,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05gmxm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/King_Abdulaziz_International_Airport"
				},
				"name": "King Abdulaziz International Airport",
				"salience": 0.03471053,
				"type": "LOCATION"
			},
			{
				"name": "army forces",
				"salience": 0.024187295,
				"type": "ORGANIZATION"
			},
			{
				"name": "area",
				"salience": 0.023277968,
				"type": "LOCATION"
			},
			{
				"name": "regime",
				"salience": 0.023277968,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighters",
				"salience": 0.023277968,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.022175748,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.020185534,
				"type": "OTHER"
			},
			{
				"name": "bombardments",
				"salience": 0.020185534,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.020185534,
				"type": "LOCATION"
			},
			{
				"name": "crisis",
				"salience": 0.020185534,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.01438599,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.013225449,
				"type": "PERSON"
			},
			{
				"name": "Popular Committees",
				"salience": 0.012804227,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.012467721,
				"type": "LOCATION"
			},
			{
				"name": "Yemen Burns",
				"salience": 0.011477674,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.010564657,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.010353191,
				"type": "ORGANIZATION"
			},
			{
				"name": "media outlets",
				"salience": 0.007790555,
				"type": "ORGANIZATION"
			},
			{
				"name": "missile",
				"salience": 0.0072789444,
				"type": "OTHER"
			},
			{
				"name": "Borkan-1",
				"salience": 0.006383133,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.005107927,
				"type": "OTHER"
			},
			{
				"name": "port city",
				"salience": 0.004932507,
				"type": "LOCATION"
			},
			{
				"name": "source",
				"salience": 0.004932507,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.004917618,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0046300045,
				"type": "ORGANIZATION"
			},
			{
				"name": "Houthi Ansarullah",
				"salience": 0.004340447,
				"type": "PERSON"
			},
			{
				"name": "anonymity",
				"salience": 0.004272201,
				"type": "OTHER"
			},
			{
				"name": "television network",
				"salience": 0.004272201,
				"type": "ORGANIZATION"
			},
			{
				"name": "condition",
				"salience": 0.004272201,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.004272201,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.0041714017,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.0041714017,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.004010116,
				"type": "OTHER"
			},
			{
				"name": "kingdom",
				"salience": 0.0039926935,
				"type": "LOCATION"
			},
			{
				"name": "claim",
				"salience": 0.0035331144,
				"type": "OTHER"
			},
			{
				"name": "missile systems",
				"salience": 0.0034886478,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0034601768,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0034601768,
				"type": "LOCATION"
			},
			{
				"name": "movement",
				"salience": 0.0034601768,
				"type": "OTHER"
			},
			{
				"name": "news agency",
				"salience": 0.0033311606,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.003038044,
				"type": "OTHER"
			},
			{
				"name": "propellant",
				"salience": 0.0028849277,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "projectile",
				"salience": 0.0028849277,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0028849277,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0028849277,
				"type": "OTHER"
			},
			{
				"name": "news agency",
				"salience": 0.002825353,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.002825353,
				"type": "EVENT"
			},
			{
				"name": "source",
				"salience": 0.002825353,
				"type": "OTHER"
			},
			{
				"name": "Volcano-1",
				"salience": 0.0026310268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09rt9v4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saba_News_Agency"
				},
				"name": "Saba",
				"salience": 0.0026310268,
				"type": "ORGANIZATION"
			},
			{
				"name": "al-Masirah",
				"salience": 0.0026310268,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ds4g09",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abd_Rabbuh_Mansur_Hadi"
				},
				"name": "Abd Rabbuh Mansur Hadi",
				"salience": 0.002483338,
				"type": "PERSON"
			},
			{
				"name": "Nightmare",
				"salience": 0.0024467974,
				"type": "OTHER"
			},
			{
				"name": "height",
				"salience": 0.0024467974,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0023379216,
				"type": "PERSON"
			},
			{
				"name": "damage",
				"salience": 0.002325861,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0023084807,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighters",
				"salience": 0.0021110317,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.0019725554,
				"type": "EVENT"
			},
			{
				"name": "battle tank",
				"salience": 0.0019231794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09pcf8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saada_Governorate"
				},
				"name": "Sa'ada",
				"salience": 0.0018450705,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/058wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mecca"
				},
				"name": "Mecca",
				"salience": 0.0018450705,
				"type": "LOCATION"
			},
			{
				"name": "World Yawns",
				"salience": 0.0018450705,
				"type": "ORGANIZATION"
			},
			{
				"name": "province",
				"salience": 0.0018281009,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.0018281009,
				"type": "PERSON"
			},
			{
				"name": "vehicle",
				"salience": 0.0018281009,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mercenaries",
				"salience": 0.0018281009,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0018281009,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.0018281009,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0018281009,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0017555711,
				"type": "LOCATION"
			},
			{
				"name": "border region",
				"salience": 0.0015376864,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0015376864,
				"type": "EVENT"
			},
			{
				"name": "movement",
				"salience": 0.0015376864,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/069dd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quotation"
				},
				"name": "Quote",
				"salience": 0.0015063498,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fyc5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sana'a"
				},
				"name": "Sana'a",
				"salience": 0.0015063498,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/029mv1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fars_Province"
				},
				"name": "Fars",
				"salience": 0.0015063498,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0014080866,
				"type": "ORGANIZATION"
			},
			{
				"name": "kingdom",
				"salience": 0.0013771545,
				"type": "LOCATION"
			},
			{
				"name": "military aggression",
				"salience": 0.0013315491,
				"type": "OTHER"
			},
			{
				"name": "death toll",
				"salience": 0.0013315491,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0013315491,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0013315491,
				"type": "OTHER"
			},
			{
				"name": "army soldiers",
				"salience": 0.0012722687,
				"type": "PERSON"
			},
			{
				"name": "operations command",
				"salience": 0.0012722687,
				"type": "OTHER"
			},
			{
				"name": "militiamen",
				"salience": 0.0011487411,
				"type": "PERSON"
			},
			{
				"name": "Jawf",
				"salience": 0.0011253265,
				"type": "OTHER"
			},
			{
				"name": "al-Kars",
				"salience": 0.0011253265,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.0011111473,
				"type": "ORGANIZATION"
			},
			{
				"name": "navy",
				"salience": 0.0009947198,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0009947198,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.0009947198,
				"type": "PERSON"
			},
			{
				"name": "gathering",
				"salience": 0.0009947198,
				"type": "EVENT"
			},
			{
				"name": "district",
				"salience": 0.0009947198,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00086520566,
				"type": "ORGANIZATION"
			},
			{
				"name": "media bureau",
				"salience": 0.00086520566,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0659tm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jizan"
				},
				"name": "Jizan",
				"salience": 0.00081958866,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00061222713,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01wh27",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aqaba"
				},
				"name": "Aqaba",
				"salience": 0.00061222713,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Borkan_79326.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Yemeni army forces and allied fighters from Popular Committees have reportedly launched a locally designed and manufactured ballistic missile towards an area deep inside Saudi Arabia in response to the Riyadh regime’s atrocious aerial bombardments against the crisis-hit Arab country. 3 Shares\n3 0 0 0\nYemeni soldiers and their allies fired a Borkan-1 (Volcano-1) missile towards King Abdulaziz International Airport, located 19 kilometers north of the western Saudi port city of Jeddah, Arabic-language al-Masirah television network reported.\nA military source, speaking on condition of anonymity, later told the official Saba news agency that the 12.5-meter-long missile had targeted its target accurately and left massive destruction at the airport.\nSaudi media outlets, however, reported that the kingdom’s missile systems intercepted and destroyed the solid propellant and Scud-type missile before it could cause any damage.\nThey said the projectile was launched at 9 p.m. local time (1800 GMT) on Thursday from Yemen’s mountainous northwestern area of Sa’ada.\nThe Saudi military also claimed that the Yemeni missile was fired toward the holy city of Mecca, but the Houthi Ansarullah movement has rejected the claim.\nMORE... Yemen Burns as the World Yawns and a Nightmare is Born Decapitation in Sana’a… Wanton murder – Saudi Arabia’s genocidal campaign in Yemen reaches new height Yemen's long-range ballistic missile hits deep inside Saudi Arabia's airbase Fars news agency Quote: d an informed Houthi source as saying that the missile was aimed at King Abdulaziz International Airport close to Jeddah, which hosts the kingdom’s royal navy forces as well as a group of American troops.\nAlso on Thursday, the media bureau of the operations command in Yemen said army soldiers had targeted a gathering of militiamen loyal to resigned president Abd Rabbuh Mansur Hadi in the Aqaba district of the northern province of Jawf, leaving scores of the Saudi-backed armed men dead.\nAn armored vehicle and battle tank belonging to the mercenaries were also destroyed in the attack.\nSeparately, a number of Saudi soldiers were killed and injured when Yemeni forces and Popular Committees fighters struck al-Kars base in Saudi Arabia’s southwestern border region of Jizan.\nSaudi Arabia has been engaged in the deadly campaign against Yemen since March 2015 in an attempt to bring back the former Yemeni government to power and undermine the Houthi Ansarullah movement.\nThe United Nations puts the death toll from the military aggression at about 10,000.",
		"thread_title": "Yemeni forces fire ballistic missile deep inside Saudi Arabia at Jeddah airport",
		"title": "Yemeni forces fire ballistic missile deep inside Saudi Arabia at Jeddah airport",
		"type": "bs",
		"uuid": "32f1b9492897e3d30acabd600be289e6f9500deb"
	},
	"-KhIbEH1Cp-EaFfX9xVd": {
		"author": "Vic Pittman",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T09:25:24.079+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "article",
				"salience": 1,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Clinton_13_4f87e.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-29T00:45:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.7
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.061",
		"text": "Great article !",
		"thread_title": "Clinton's Policies Look Like a Death Sentence for Americans - American Herald Tribune",
		"title": "",
		"type": "bs",
		"uuid": "863111ac46336780dcef67196fcddc2e7621ce5a"
	},
	"-KhIbEQvQ77mTdXLUYlT": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T19:46:34.596+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.21398693,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.1719163,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.065587744,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Hamam al-Alil",
				"salience": 0.060677525,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.04238502,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.03480204,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.027603842,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.027603842,
				"type": "ORGANIZATION"
			},
			{
				"name": "electrocution",
				"salience": 0.027603842,
				"type": "OTHER"
			},
			{
				"name": "media outlets",
				"salience": 0.027603842,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.024835015,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.019579979,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/028t63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haider_al-Abadi"
				},
				"name": "Haider al-Abadi",
				"salience": 0.013003063,
				"type": "PERSON"
			},
			{
				"name": "human rights office",
				"salience": 0.012468149,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rupert Colville",
				"salience": 0.0102299955,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.009119778,
				"type": "PERSON"
			},
			{
				"name": "al-Magmoa al-Thaqafiya",
				"salience": 0.008741889,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.008078667,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ck32l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nouri_al-Maliki"
				},
				"name": "Nouri al-Maliki",
				"salience": 0.007410214,
				"type": "PERSON"
			},
			{
				"name": "security forces",
				"salience": 0.0067562643,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0062219067,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.006162109,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0058522294,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.0058522294,
				"type": "PERSON"
			},
			{
				"name": "Al Sumaria News",
				"salience": 0.00576299,
				"type": "ORGANIZATION"
			},
			{
				"name": "Parliamentary Human Rights Committee",
				"salience": 0.0056400485,
				"type": "ORGANIZATION"
			},
			{
				"name": "village",
				"salience": 0.005469513,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.005469513,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.005227273,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.005053594,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.00463954,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0046190666,
				"type": "ORGANIZATION"
			},
			{
				"name": "coalition",
				"salience": 0.0045636157,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05sf4r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Nicholson_(East_India_Company_officer)"
				},
				"name": "John Nicholson",
				"salience": 0.00455304,
				"type": "PERSON"
			},
			{
				"name": "killings",
				"salience": 0.00410554,
				"type": "EVENT"
			},
			{
				"name": "bodies",
				"salience": 0.00410554,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.00410554,
				"type": "OTHER"
			},
			{
				"name": "AHT",
				"salience": 0.0040696575,
				"type": "ORGANIZATION"
			},
			{
				"name": "security forces",
				"salience": 0.0038708807,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.0037885718,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.0036047187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03m_n0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peshmerga"
				},
				"name": "Peshmerga",
				"salience": 0.0036047187,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0034024268,
				"type": "PERSON"
			},
			{
				"name": "bullet wounds",
				"salience": 0.0033523757,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0030678676,
				"type": "OTHER"
			},
			{
				"name": "You ISIS Executes 190 Iraqi Civilians",
				"salience": 0.0028571852,
				"type": "ORGANIZATION"
			},
			{
				"name": "al-Arij",
				"salience": 0.0028103932,
				"type": "LOCATION"
			},
			{
				"name": "briefing",
				"salience": 0.0027721247,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03902",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Geneva"
				},
				"name": "Geneva",
				"salience": 0.0025281082,
				"type": "LOCATION"
			},
			{
				"name": "operations",
				"salience": 0.0025048612,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0025048612,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0025048612,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0025048612,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0025048612,
				"type": "ORGANIZATION"
			},
			{
				"name": "Staff",
				"salience": 0.0023334853,
				"type": "PERSON"
			},
			{
				"name": "Karamless Village",
				"salience": 0.0021347455,
				"type": "LOCATION"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0021070011,
				"type": "PERSON"
			},
			{
				"name": "coalition",
				"salience": 0.0021070011,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.0020640693,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tuloul Naser",
				"salience": 0.0020640693,
				"type": "PERSON"
			},
			{
				"name": "Mosul Iraqi",
				"salience": 0.0019721987,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0019687752,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0018870663,
				"type": "LOCATION"
			},
			{
				"name": "head",
				"salience": 0.0018245839,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0018245839,
				"type": "EVENT"
			},
			{
				"name": "t",
				"salience": 0.001574118,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wb7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Church_(building)"
				},
				"name": "Church",
				"salience": 0.0015420369,
				"type": "ORGANIZATION"
			},
			{
				"name": "Iraqi Soldiers Erect Cross",
				"salience": 0.0015420369,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0015420369,
				"type": "OTHER"
			},
			{
				"name": "Hammam al-Alil",
				"salience": 0.0014130797,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.0013630854,
				"type": "LOCATION"
			},
			{
				"name": "atrocities",
				"salience": 0.0013630854,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0013630854,
				"type": "PERSON"
			},
			{
				"name": "Arij Village",
				"salience": 0.0011615935,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0011231207,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0011231207,
				"type": "LOCATION"
			},
			{
				"name": "al-Qanoon",
				"salience": 0.0011231207,
				"type": "PERSON"
			},
			{
				"name": "Khorasan Caliphate",
				"salience": 0.0009893564,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01chdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nineveh_Governorate"
				},
				"name": "Nineveh",
				"salience": 0.0008389821,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/ISIS_Electrocution_6072b.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.018",
		"text": "2 Shares\n1 0 0 1\nIraqi media outlets reported on Thursday, that the ISIS group executed 22 civilians by electrocution in central Mosul.\n“ISIS militants electrocuted 22 civilians in al-Magmoa al-Thaqafiya area in central Mosul, for collaborating with security forces and Kurdish Peshmerga fighters,” Al Sumaria News stated.\nAl Sumaria News added, “The ISIS militants were keeping these civilians inside a prison in Mosul for nearly four months.”\nYesterday, Parliamentary Human Rights Committee revealed, that the ISIS executed 190 civilians in Hamam al-Alil area and 42 in al-Arij village, south of the city of Mosul, while called Prime Minister Haider al-Abadi and the International coalition to continue liberating the ISIS-held areas in the city.\nOn Tuesday, the UN human rights office said it had preliminary reports about scores of mass killings by ISIS around Mosul in the past week.\nUN human rights spokesman Rupert Colville told a regular UN briefing in Geneva that the bodies of 70 civilians with bullet wounds had been discovered by Iraqi security forces in Tuloul Naser village on October 20, and 50 police officers being held outside the city had also reportedly been killed, Press TV reported.\nRecommended For You ISIS Executes 190 Iraqi Civilians in Hammam al-Alil, 42 in Arij Village: Official\n\"ISIS terrorists continued to commit atrocities in the province of Nineveh, they executed 190 people in the area of Hammam al-Alil after t...\nBy AHT Staff Muslim Iraqi Soldiers Erect Cross on Top of the Church in Newly Liberated Karamless Village Near Mosul Iraqi army troops on Saturday stormed into a Christian region that has been under ISIS control since 2014 as part of operations to clear t...\nBy AHT Staff Nouri al-Maliki, the former Prime Minister of Iraq, and the head of the al-Qanoon parliamentary coalition, stated in his speech during the...\nBy AHT Staff U.S. Commander John Nicholson: ISIS Attempting to Establish Khorasan Caliphate in Afghanistan",
		"thread_title": "ISIS Executes 22 Civilians by Electrocution in Central Mosul",
		"title": "ISIS Executes 22 Civilians by Electrocution in Central Mosul",
		"type": "bs",
		"uuid": "29c39970b840a4c4ddcc4350866951f33f4749b4"
	},
	"-KhIbFFzIuNjEjJiYoNI": {
		"author": "Kim Petersen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-30T16:44:59.431+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b78hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Noam_Chomsky"
				},
				"name": "Noam Chomsky",
				"salience": 0.31699312,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1437208,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.032349832,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.025759429,
				"type": "PERSON"
			},
			{
				"name": "Question",
				"salience": 0.018830655,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.016543662,
				"type": "PERSON"
			},
			{
				"name": "party candidates",
				"salience": 0.012320018,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.012058316,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.011370954,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.010019934,
				"type": "PERSON"
			},
			{
				"name": "foreign policy",
				"salience": 0.009069098,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.007043366,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.006495108,
				"type": "LOCATION"
			},
			{
				"name": "Disinfo",
				"salience": 0.006495108,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.006495108,
				"type": "OTHER"
			},
			{
				"name": "given",
				"salience": 0.006163655,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0054708966,
				"type": "OTHER"
			},
			{
				"name": "swing states",
				"salience": 0.0054365634,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.004681975,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0288j83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0044080955,
				"type": "PERSON"
			},
			{
				"name": "challenges",
				"salience": 0.004242617,
				"type": "OTHER"
			},
			{
				"name": "slide",
				"salience": 0.004102301,
				"type": "OTHER"
			},
			{
				"name": "evilism",
				"salience": 0.003996154,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0037983288,
				"type": "EVENT"
			},
			{
				"name": "challenges",
				"salience": 0.0036296905,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.0035799546,
				"type": "OTHER"
			},
			{
				"name": "consciousness",
				"salience": 0.0034241772,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.003396263,
				"type": "EVENT"
			},
			{
				"name": "evil",
				"salience": 0.003304724,
				"type": "OTHER"
			},
			{
				"name": "political parties",
				"salience": 0.0031737254,
				"type": "ORGANIZATION"
			},
			{
				"name": "Part",
				"salience": 0.0031737254,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.0031735706,
				"type": "OTHER"
			},
			{
				"name": "evilism",
				"salience": 0.003101896,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.003101896,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0030607693,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.0029704708,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.0029704708,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0028624898,
				"type": "EVENT"
			},
			{
				"name": "LEV",
				"salience": 0.0028078016,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.0027787127,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0027787127,
				"type": "OTHER"
			},
			{
				"name": "Grassroots organizing",
				"salience": 0.0025306486,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0024818433,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.00247595,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.0023802838,
				"type": "OTHER"
			},
			{
				"name": "activism",
				"salience": 0.0023669936,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0023669936,
				"type": "OTHER"
			},
			{
				"name": "progressives",
				"salience": 0.0022409956,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "change",
				"salience": 0.0022409956,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0022409956,
				"type": "OTHER"
			},
			{
				"name": "Agent",
				"salience": 0.0022380154,
				"type": "PERSON"
			},
			{
				"name": "desire",
				"salience": 0.002233239,
				"type": "OTHER"
			},
			{
				"name": "election cycles",
				"salience": 0.0021005925,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0020151834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.0019541136,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.0019406566,
				"type": "OTHER"
			},
			{
				"name": "duopoly",
				"salience": 0.0019406566,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0019406566,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0019406566,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0018823144,
				"type": "EVENT"
			},
			{
				"name": "poverty",
				"salience": 0.0018586052,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0018586052,
				"type": "EVENT"
			},
			{
				"name": "chicanery",
				"salience": 0.0017892529,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0017827579,
				"type": "PERSON"
			},
			{
				"name": "principle",
				"salience": 0.0017522846,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0017522846,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0017522846,
				"type": "OTHER"
			},
			{
				"name": "Voting",
				"salience": 0.0016810118,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0016778172,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0015173963,
				"type": "OTHER"
			},
			{
				"name": "be-all",
				"salience": 0.0015173963,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0015173963,
				"type": "EVENT"
			},
			{
				"name": "awareness",
				"salience": 0.0015173963,
				"type": "OTHER"
			},
			{
				"name": "impoverishment",
				"salience": 0.0015173963,
				"type": "OTHER"
			},
			{
				"name": "accounting",
				"salience": 0.0015173963,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.0015173963,
				"type": "OTHER"
			},
			{
				"name": "periods",
				"salience": 0.0015173963,
				"type": "EVENT"
			},
			{
				"name": "platform",
				"salience": 0.0015173963,
				"type": "OTHER"
			},
			{
				"name": "progressivism",
				"salience": 0.0014563502,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0014529042,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0014101871,
				"type": "OTHER"
			},
			{
				"name": "An Eight Point Brief",
				"salience": 0.0013899769,
				"type": "WORK_OF_ART"
			},
			{
				"name": "consequence",
				"salience": 0.001332192,
				"type": "OTHER"
			},
			{
				"name": "demolition",
				"salience": 0.001332192,
				"type": "EVENT"
			},
			{
				"name": "hegemony",
				"salience": 0.0013118474,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.0013069527,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.0013069527,
				"type": "OTHER"
			},
			{
				"name": "Bernie Saunders",
				"salience": 0.0012833301,
				"type": "PERSON"
			},
			{
				"name": "suffering",
				"salience": 0.0012362899,
				"type": "OTHER"
			},
			{
				"name": "individual",
				"salience": 0.001202517,
				"type": "PERSON"
			},
			{
				"name": "Lesser Evil Voting",
				"salience": 0.0011702364,
				"type": "OTHER"
			},
			{
				"name": "conservatives",
				"salience": 0.0011587607,
				"type": "PERSON"
			},
			{
				"name": "consciousness",
				"salience": 0.0011441604,
				"type": "OTHER"
			},
			{
				"name": "swing state",
				"salience": 0.0011441604,
				"type": "OTHER"
			},
			{
				"name": "writing",
				"salience": 0.0010961596,
				"type": "OTHER"
			},
			{
				"name": "combination",
				"salience": 0.0010841957,
				"type": "OTHER"
			},
			{
				"name": "John Halle",
				"salience": 0.0010786337,
				"type": "PERSON"
			},
			{
				"name": "track record",
				"salience": 0.001052446,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0010505299,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0010484084,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0010484084,
				"type": "PERSON"
			},
			{
				"name": "candidacy",
				"salience": 0.0010218382,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0010218382,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0010197656,
				"type": "PERSON"
			},
			{
				"name": "potentials",
				"salience": 0.0009779333,
				"type": "OTHER"
			},
			{
				"name": "Clintonomics",
				"salience": 0.0009753083,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0009745207,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0009745207,
				"type": "OTHER"
			},
			{
				"name": "polling results",
				"salience": 0.0009745207,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0009745207,
				"type": "EVENT"
			},
			{
				"name": "voting",
				"salience": 0.0009745207,
				"type": "EVENT"
			},
			{
				"name": "result",
				"salience": 0.0009745207,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0009740118,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0009740118,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0009740118,
				"type": "OTHER"
			},
			{
				"name": "objection",
				"salience": 0.0009491837,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00093765283,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.00093765283,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Sanders",
				"salience": 0.0009340067,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.0009315793,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0009315793,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0009258372,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0009226138,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0009226138,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0009226138,
				"type": "EVENT"
			},
			{
				"name": "change",
				"salience": 0.0009226138,
				"type": "OTHER"
			},
			{
				"name": "Agent",
				"salience": 0.00092138606,
				"type": "PERSON"
			},
			{
				"name": "Agent",
				"salience": 0.00092138606,
				"type": "PERSON"
			},
			{
				"name": "Agent",
				"salience": 0.00092138606,
				"type": "PERSON"
			},
			{
				"name": "claim",
				"salience": 0.00090783247,
				"type": "OTHER"
			},
			{
				"name": "Brian Mulroney Tories",
				"salience": 0.00089978904,
				"type": "ORGANIZATION"
			},
			{
				"name": "expression",
				"salience": 0.0008948643,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00086477655,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.00086477655,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00085471105,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.0008506028,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0008398837,
				"type": "OTHER"
			},
			{
				"name": "judgement",
				"salience": 0.0008398837,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.00079889863,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00079889863,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.00079889863,
				"type": "EVENT"
			},
			{
				"name": "foreign policy",
				"salience": 0.000795139,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.000795139,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007755006,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007755006,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007755006,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007755006,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007755006,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007465493,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007398455,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00072181947,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.0007213153,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.0007213153,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0007213153,
				"type": "ORGANIZATION"
			},
			{
				"name": "self-expression",
				"salience": 0.0007213153,
				"type": "OTHER"
			},
			{
				"name": "judgement",
				"salience": 0.0007213153,
				"type": "OTHER"
			},
			{
				"name": "seats",
				"salience": 0.0007213153,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.00071642135,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.00071642135,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.00071642135,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0006896749,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0006832421,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0006716909,
				"type": "WORK_OF_ART"
			},
			{
				"name": "supporters",
				"salience": 0.0006641317,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.00065486715,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0006491054,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0006423923,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0006325569,
				"type": "OTHER"
			},
			{
				"name": "suggestion",
				"salience": 0.0006273876,
				"type": "OTHER"
			},
			{
				"name": "solitude",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "retaliation",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "multitude",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "margins",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "voter disgust",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "voting tsunami",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.0006245848,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0006245848,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0006098229,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0006062906,
				"type": "ORGANIZATION"
			},
			{
				"name": "record",
				"salience": 0.0006062906,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00059396046,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.00058484095,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.00058484095,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00058484095,
				"type": "PERSON"
			},
			{
				"name": "logic",
				"salience": 0.00058484095,
				"type": "OTHER"
			},
			{
				"name": "tipping point",
				"salience": 0.00058365456,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.00056009874,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00056009874,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.00056009874,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.00056009874,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.00056009874,
				"type": "OTHER"
			},
			{
				"name": "military spending",
				"salience": 0.00056009874,
				"type": "OTHER"
			},
			{
				"name": "military spending",
				"salience": 0.00056009874,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0005577539,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0005577539,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.00055232964,
				"type": "LOCATION"
			},
			{
				"name": "evil",
				"salience": 0.00054613274,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.00054613274,
				"type": "OTHER"
			},
			{
				"name": "Much",
				"salience": 0.0005432499,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0005432499,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.00054177595,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0005391869,
				"type": "OTHER"
			},
			{
				"name": "military spending",
				"salience": 0.0005391869,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0005391869,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0005369296,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00052804017,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00052804017,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00052804017,
				"type": "OTHER"
			},
			{
				"name": "populations",
				"salience": 0.00052804017,
				"type": "OTHER"
			},
			{
				"name": "populations",
				"salience": 0.00052804017,
				"type": "OTHER"
			},
			{
				"name": "evilism",
				"salience": 0.0005125731,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.00050611276,
				"type": "OTHER"
			},
			{
				"name": "military bases",
				"salience": 0.0005057004,
				"type": "LOCATION"
			},
			{
				"name": "bit",
				"salience": 0.0005057004,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0005057004,
				"type": "OTHER"
			},
			{
				"name": "utterances",
				"salience": 0.0005057004,
				"type": "OTHER"
			},
			{
				"name": "military confrontation",
				"salience": 0.0005057004,
				"type": "EVENT"
			},
			{
				"name": "ramifications",
				"salience": 0.0005034411,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.0005034411,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00049493246,
				"type": "LOCATION"
			},
			{
				"name": "nation states",
				"salience": 0.0004891707,
				"type": "LOCATION"
			},
			{
				"name": "enemy states",
				"salience": 0.0004891707,
				"type": "LOCATION"
			},
			{
				"name": "actions",
				"salience": 0.0004881293,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0004868191,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0004868191,
				"type": "LOCATION"
			},
			{
				"name": "agreement",
				"salience": 0.0004868191,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0004868191,
				"type": "LOCATION"
			},
			{
				"name": "welfare",
				"salience": 0.0004868191,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0004868191,
				"type": "PERSON"
			},
			{
				"name": "warming",
				"salience": 0.0004868191,
				"type": "EVENT"
			},
			{
				"name": "remains",
				"salience": 0.0004868191,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0004868191,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.0004691169,
				"type": "LOCATION"
			},
			{
				"name": "plenty",
				"salience": 0.0004665488,
				"type": "OTHER"
			},
			{
				"name": "likelihood",
				"salience": 0.0004665488,
				"type": "OTHER"
			},
			{
				"name": "criticisms",
				"salience": 0.00045722292,
				"type": "OTHER"
			},
			{
				"name": "poor",
				"salience": 0.00045722292,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.00045722292,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00045722292,
				"type": "ORGANIZATION"
			},
			{
				"name": "poor",
				"salience": 0.00045722292,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.00045722292,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0004480834,
				"type": "PERSON"
			},
			{
				"name": "Halle",
				"salience": 0.0004439294,
				"type": "LOCATION"
			},
			{
				"name": "Eight Point Brief",
				"salience": 0.0004439294,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reversal",
				"salience": 0.00044346813,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.00043984372,
				"type": "OTHER"
			},
			{
				"name": "detractors",
				"salience": 0.00043787857,
				"type": "PERSON"
			},
			{
				"name": "border",
				"salience": 0.00043787857,
				"type": "LOCATION"
			},
			{
				"name": "pronouncements",
				"salience": 0.00043787857,
				"type": "OTHER"
			},
			{
				"name": "token",
				"salience": 0.00043787857,
				"type": "OTHER"
			},
			{
				"name": "military attack",
				"salience": 0.00043787857,
				"type": "EVENT"
			},
			{
				"name": "resort",
				"salience": 0.00043787857,
				"type": "LOCATION"
			},
			{
				"name": "substantiation",
				"salience": 0.00043787857,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00043787857,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.00043685915,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00043685915,
				"type": "PERSON"
			},
			{
				"name": "logic",
				"salience": 0.00043685915,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.00043685915,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.00043255786,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0004275286,
				"type": "OTHER"
			},
			{
				"name": "demand",
				"salience": 0.00042690992,
				"type": "OTHER"
			},
			{
				"name": "evilist",
				"salience": 0.0004237661,
				"type": "OTHER"
			},
			{
				"name": "saber",
				"salience": 0.00042152902,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "dissolution",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "free trade deals",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "no-fly zone",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "advocacy",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "menace",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "pretenses",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "safety net",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "openness",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "law and order",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "ban",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.00042152902,
				"type": "EVENT"
			},
			{
				"name": "protestors",
				"salience": 0.00042152902,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.00042152902,
				"type": "PERSON"
			},
			{
				"name": "assistance",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "dismantling",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "fossil fuels",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00042152902,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.00042025384,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0004166246,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00041281426,
				"type": "PERSON"
			},
			{
				"name": "suffering",
				"salience": 0.00041281426,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.00041281426,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.00041281426,
				"type": "PERSON"
			},
			{
				"name": "warmongering",
				"salience": 0.00041281426,
				"type": "OTHER"
			},
			{
				"name": "utterances",
				"salience": 0.00041281426,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.00041281426,
				"type": "OTHER"
			},
			{
				"name": "suggestion",
				"salience": 0.00041281426,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.00041281426,
				"type": "OTHER"
			},
			{
				"name": "terrorist organizations",
				"salience": 0.00041281426,
				"type": "ORGANIZATION"
			},
			{
				"name": "principle",
				"salience": 0.00041281426,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.00041281426,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.00041281426,
				"type": "PERSON"
			},
			{
				"name": "third party",
				"salience": 0.00040694632,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00040694632,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00040694632,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African American",
				"salience": 0.00040479403,
				"type": "PERSON"
			},
			{
				"name": "evil",
				"salience": 0.00039772445,
				"type": "OTHER"
			},
			{
				"name": "evilism",
				"salience": 0.00039772445,
				"type": "OTHER"
			},
			{
				"name": "evilism",
				"salience": 0.00039772445,
				"type": "OTHER"
			},
			{
				"name": "progressives",
				"salience": 0.00039442797,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mainstream media channels",
				"salience": 0.00039442797,
				"type": "OTHER"
			},
			{
				"name": "popularity",
				"salience": 0.00039442797,
				"type": "OTHER"
			},
			{
				"name": "progressives",
				"salience": 0.00038454754,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "LEV. 1",
				"salience": 0.00038439047,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.00038439047,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservative_Party_(UK)"
				},
				"name": "Tory",
				"salience": 0.00038439047,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hhz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oval_Office"
				},
				"name": "Oval Office",
				"salience": 0.00037313037,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.00037018894,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.00036969618,
				"type": "OTHER"
			},
			{
				"name": "challenge",
				"salience": 0.00036969618,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.00036969618,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00036969618,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.000359303,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.000359198,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.00035744772,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.00035744772,
				"type": "PERSON"
			},
			{
				"name": "attitudes",
				"salience": 0.00035744772,
				"type": "OTHER"
			},
			{
				"name": "neoliberalization",
				"salience": 0.00035744772,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00035744772,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.00035744772,
				"type": "PERSON"
			},
			{
				"name": "offshoring",
				"salience": 0.00035744772,
				"type": "OTHER"
			},
			{
				"name": "continuation",
				"salience": 0.00035744772,
				"type": "OTHER"
			},
			{
				"name": "casting",
				"salience": 0.00035744772,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00035661552,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00035477412,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.00035005755,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.00034697674,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.00034410084,
				"type": "OTHER"
			},
			{
				"name": "election cycles",
				"salience": 0.0003426032,
				"type": "OTHER"
			},
			{
				"name": "justification",
				"salience": 0.00034152702,
				"type": "OTHER"
			},
			{
				"name": "poor",
				"salience": 0.00034152702,
				"type": "PERSON"
			},
			{
				"name": "Conclusion",
				"salience": 0.00034152702,
				"type": "OTHER"
			},
			{
				"name": "justification",
				"salience": 0.00034152702,
				"type": "OTHER"
			},
			{
				"name": "Conclusion",
				"salience": 0.00034152702,
				"type": "OTHER"
			},
			{
				"name": "social security",
				"salience": 0.00034152702,
				"type": "OTHER"
			},
			{
				"name": "social security",
				"salience": 0.00034152702,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00034152702,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00033402076,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0003317323,
				"type": "OTHER"
			},
			{
				"name": "welfare policies",
				"salience": 0.00032310231,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.0003203145,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00031934545,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00031814087,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00031814087,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00030835395,
				"type": "ORGANIZATION"
			},
			{
				"name": "faith",
				"salience": 0.00030835395,
				"type": "OTHER"
			},
			{
				"name": "establishment operatives",
				"salience": 0.00030835395,
				"type": "ORGANIZATION"
			},
			{
				"name": "faith",
				"salience": 0.00030835395,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.00030835395,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.00030835395,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.00030835395,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.00030835395,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.00030835395,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00030697617,
				"type": "OTHER"
			},
			{
				"name": "business party factions",
				"salience": 0.00030340435,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.00030340435,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.00030340435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05st_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jill_Stein"
				},
				"name": "Jill Stein",
				"salience": 0.00030045334,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.00029178863,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00028960608,
				"type": "OTHER"
			},
			{
				"name": "Comments",
				"salience": 0.00028940372,
				"type": "WORK_OF_ART"
			},
			{
				"name": "establishment operatives",
				"salience": 0.00028940372,
				"type": "ORGANIZATION"
			},
			{
				"name": "probability",
				"salience": 0.00028811063,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.000287239,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Assad",
				"salience": 0.00026947615,
				"type": "PERSON"
			},
			{
				"name": "Chomskyian",
				"salience": 0.00026947615,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.00026947615,
				"type": "PERSON"
			},
			{
				"name": "reputation",
				"salience": 0.00026922743,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.00026699586,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.00026699586,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.00026699586,
				"type": "OTHER"
			},
			{
				"name": "premise",
				"salience": 0.00026699586,
				"type": "OTHER"
			},
			{
				"name": "measure",
				"salience": 0.00026699586,
				"type": "OTHER"
			},
			{
				"name": "about-face",
				"salience": 0.00026699586,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0002660929,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0002660929,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.00025941365,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09v0gf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sevens_(card_game)"
				},
				"name": "Parliament",
				"salience": 0.00025941365,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09h5x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trans-Pacific_Partnership"
				},
				"name": "TPP",
				"salience": 0.00024990705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.00024990705,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.00024990705,
				"type": "LOCATION"
			},
			{
				"name": "system",
				"salience": 0.00024871263,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00024871263,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.00024871263,
				"type": "OTHER"
			},
			{
				"name": "duopoly",
				"salience": 0.00024871263,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00024778693,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.00024324606,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0002394254,
				"type": "OTHER"
			},
			{
				"name": "social security",
				"salience": 0.0002304849,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00022662665,
				"type": "OTHER"
			},
			{
				"name": "factories",
				"salience": 0.00022662665,
				"type": "LOCATION"
			},
			{
				"name": "propeace",
				"salience": 0.0002245538,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.0002245538,
				"type": "OTHER"
			},
			{
				"name": "futility",
				"salience": 0.0002245538,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0002245538,
				"type": "LOCATION"
			},
			{
				"name": "finance",
				"salience": 0.0002245538,
				"type": "OTHER"
			},
			{
				"name": "revolution",
				"salience": 0.0002245538,
				"type": "EVENT"
			},
			{
				"name": "revolution",
				"salience": 0.0002245538,
				"type": "EVENT"
			},
			{
				"name": "propeace",
				"salience": 0.0002245538,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0002245538,
				"type": "PERSON"
			},
			{
				"name": "Morality",
				"salience": 0.0002245538,
				"type": "OTHER"
			},
			{
				"name": "bases",
				"salience": 0.00022172321,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00022172321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0002194896,
				"type": "PERSON"
			},
			{
				"name": "accusation",
				"salience": 0.00021892828,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00021892828,
				"type": "OTHER"
			},
			{
				"name": "succor",
				"salience": 0.00021795006,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0002161686,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0002145516,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00021344368,
				"type": "OTHER"
			},
			{
				"name": "commentators",
				"salience": 0.00021075312,
				"type": "PERSON"
			},
			{
				"name": "direction",
				"salience": 0.00020716662,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00020109753,
				"type": "OTHER"
			},
			{
				"name": "birth",
				"salience": 0.00019443443,
				"type": "EVENT"
			},
			{
				"name": "degree",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "fronts",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.00019443443,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "horizon",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "killing",
				"salience": 0.00019443443,
				"type": "EVENT"
			},
			{
				"name": "path",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "enrichment",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "tragedy",
				"salience": 0.00019443443,
				"type": "EVENT"
			},
			{
				"name": "cross-hairs",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "goals",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "domination",
				"salience": 0.00019443443,
				"type": "OTHER"
			},
			{
				"name": "cycles",
				"salience": 0.00018635913,
				"type": "OTHER"
			},
			{
				"name": "worker",
				"salience": 0.0001857737,
				"type": "PERSON"
			},
			{
				"name": "trade",
				"salience": 0.0001857737,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0001857737,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0001857737,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0001857737,
				"type": "ORGANIZATION"
			},
			{
				"name": "trade",
				"salience": 0.0001857737,
				"type": "OTHER"
			},
			{
				"name": "duopoly",
				"salience": 0.0001857737,
				"type": "OTHER"
			},
			{
				"name": "administrations",
				"salience": 0.0001857737,
				"type": "ORGANIZATION"
			},
			{
				"name": "swing",
				"salience": 0.0001857737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06drz0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Progressivism"
				},
				"name": "Progressivism",
				"salience": 0.00017676581,
				"type": "OTHER"
			},
			{
				"name": "accusation",
				"salience": 0.000167728,
				"type": "OTHER"
			},
			{
				"name": "militarism",
				"salience": 0.000167728,
				"type": "OTHER"
			},
			{
				"name": "futility",
				"salience": 0.000167728,
				"type": "OTHER"
			},
			{
				"name": "agreements",
				"salience": 0.000167728,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.000167728,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.000167728,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00016430765,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George Bush",
				"salience": 0.00016430765,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/022td4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cynthia_McKinney"
				},
				"name": "Cynthia McKinney",
				"salience": 0.00016430765,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06dnh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ralph_Nader"
				},
				"name": "Ralph Nader",
				"salience": 0.00016430765,
				"type": "PERSON"
			},
			{
				"name": "influence",
				"salience": 0.00015871681,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.00014523014,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempts",
				"salience": 0.00014523014,
				"type": "OTHER"
			},
			{
				"name": "vagaries",
				"salience": 0.00014523014,
				"type": "ORGANIZATION"
			},
			{
				"name": "finance sector",
				"salience": 0.00014523014,
				"type": "OTHER"
			},
			{
				"name": "rationale",
				"salience": 0.00014523014,
				"type": "OTHER"
			},
			{
				"name": "drone strikes",
				"salience": 0.00014523014,
				"type": "EVENT"
			},
			{
				"name": "incarceration",
				"salience": 0.00014523014,
				"type": "OTHER"
			},
			{
				"name": "perpetuation",
				"salience": 0.00014523014,
				"type": "OTHER"
			},
			{
				"name": "credence",
				"salience": 0.00014523014,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00014523014,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.00014523014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.00013593434,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.00013519009,
				"type": "ORGANIZATION"
			},
			{
				"name": "veneer",
				"salience": 0.00012472192,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.00011965222,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0161c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bahrain"
				},
				"name": "Bahrain",
				"salience": 0.00011965222,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0357_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gaza_Strip"
				},
				"name": "Gaza",
				"salience": 0.00011965222,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0000893718,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0btt37",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guant%C3%A1namo_Bay"
				},
				"name": "Guantanamo Bay",
				"salience": 0.0000893718,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0000893718,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Clinton_Trump_0ceea.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 41.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.007",
		"text": "22 Shares\n1 20 0 1\nThe anarchist political observer Noam Chomsky has over the years espoused a strategy of voting for the Democrat in swing states. Recently Chomsky, with John Halle, propounded \" An Eight Point Brief for LEV (Lesser Evil Voting) .\"\nChomsky questions the ethical/moral principle rejecting LEV since lesser evil voting is designed to minimize evil. As futile as lesser evilism is, it is also futile to discuss there being a lesser evilism between the two utterly dominant rightist political parties in the United States. LEV, in fact, is an equally contemptible or greater evil.\nChomsky, though, sensibly cautions that challenges to the political-business duopoly needs to be contemplated with a full awareness of their possible consequences. What are the possible consequences? Chomsky suggests, \"A Trump presidency, should it materialize, will undermine the burgeoning movement centered around the Sanders campaign, particularly if it is perceived as having minimized the dangers posed by the far right.\" However, another consequence is equally possible: a horrendous slide to the right would spur progressives to coalesce among a leftist Democrat, and/or it might finally cause former or potential Democrats to reject the chicanery of the business-dominated Democrats and embrace the progressivist platform of the Green Party.\nThis cost/benefit strategic accounting seriously pushes for progressivist change.\nFocusing on the electoral system, however, must not be the end-all and be-all for bringing about progressivism in the US. Grassroots organizing and activism must continue to inform, oppose poverty and impoverishment, oppose war and violence, and push for human rights and equal opportunity for all people — during electoral periods and between election cycles.\nMORE... 9/11 and the Zionist Question: Is Noam Chomsky a Disinfo Agent for Israel? - Part 9 9/11 and the Zionist Question: Is Noam Chomsky a Disinfo Agent for Israel? - Part 7 9/11 and the Zionist Question: Is Noam Chomsky a Disinfo Agent for Israel? - Part 3 9/11 and the Zionist Question: Is Noam Chomsky a Disinfo Agent for Israel? - Part 2 I examine Halle and Chomsky's Eight Point Brief for LEV.\n1) Voting should not be viewed as a form of personal self-expression or moral judgement directed in retaliation towards major party candidates who fail to reflect our values, or of a corrupt system designed to limit choices to those acceptable to corporate elites.\nNo argument with this.\n2) The exclusive consequence of the act of voting in 2016 will be (if in a contested \"swing state\") to marginally increase or decrease the chance of one of the major party candidates winning.\nThis is true of the individual act of voting. The individual in solitude has little sway over the electoral result; that is an obvious given. However, when a consciousness sweeps across a multitude of like-minded individuals then enormous potentials emerge. This desire for a change from the effete status quo is, arguably, what occurred with the almost breakthrough candidacy of Bernie Saunders, and it is also what happened, in a dissimilar manner, with the candidacy of Donald Trump. Chomsky has framed the exclusive consequence of the act of voting as the result of an individualistic action, and it is. But individuals can and do, at times, form a wider consciousness, measurable by statistically rigorous polling results, that has potential ramifications on a much greater scale that mere margins. An example of this would be the expression of voter disgust in the Canadian federal election of 1993. Following two successive majority governments led by the Brian Mulroney Tories, a voting tsunami washed away all but two Tory seats in the 295-seat Parliament. The conservatives had been around since 1867, but the electoral demolition led to the eventual dissolution of the Tories.\n3) One of these candidates, Trump, denies the existence of global warming, calls for increasing use of fossil fuels, dismantling of environmental regulations and refuses assistance to India and other developing nations as called for in the Paris agreement, the combination of which could, in four years, take us to a catastrophic tipping point. Trump has also pledged to deport 11 million Mexican immigrants, offered to provide for the defense of supporters who have assaulted African American protestors at his rallies, stated his \"openness to using nuclear weapons\", supports a ban on Muslims entering the U.S. and regards \"the police in this country as absolutely mistreated and misunderstood\" while having \"done an unbelievable job of keeping law and order.\" Trump has also pledged to increase military spending while cutting taxes on the rich, hence shredding what remains of the social welfare \"safety net\" despite pretenses.\nMuch of what Trump stands for is anathema. True. There is no need to defend this man. However, Trump stakes out important positions diametrical to Hillary Clinton; for example, Clinton's advocacy of a no-fly zone over Syria, her saber rattling with Russia, her corporate-friendly policy toward so-called free trade deals.\nChomsky cleverly anticipated such an objection, writing:\n... with respect to point 3) which some will challenge by citing the claim that Clinton's foreign policy could pose a more serious menace than that of Trump.\nIn any case, while conceding as an outside possibility that Trump's foreign policy is preferable, most of us not already convinced that that is so will need more evidence than can be aired in a discussion involving this statement. Furthermore, insofar as this is the fact of the matter, following the logic through seems to require a vote for Trump, though it's a bit hard to know whether those making this suggestion are intending it seriously.\nFirst, Chomsky concedes \"an outside possibility that Trump's foreign policy is preferable...\" In other words, Chomsky posits an inside possibility (one assumes that Chomsky is saying that there is the strongest likelihood) that Clinton's foreign policy is preferable without any substantiation of why this would be so. Second, he raises an unreasonable demand for \"evidence\" that Trump will follow a less menacing foreign policy than Clinton. Given that Trump has never held political office no such evidence exists. What does exist is plenty of evidence that Clinton will pursue a menacing foreign policy. There is no reason to assume Clinton would reduce the number of American military bases overseas or curtail military spending. In fact, it is likelier that she would increase military spending. She will also likeliest resort to a US military attack to bring about \"regime change\" in Syria, pushing the US closer to military confrontation with Russia. Trump's detractors compare his bombastic rhetoric unfavorably to Clinton's rhetoric. But toward Putin or Assad, Clinton's undiplomatic utterances are on record.\nMoreover, following Chomsky's logic, while the more preferable policies of Trump lack evidence, by the same token, the more objectionable policies of Trump also lack evidence for the same reason: Trump has no political track record upon which to judge what he would do if in the Oval Office. Thus, following this Chomskyian logic one could not pass judgement on hardly of Trump's pronouncements. Would he really build a wall on the Mexico-US border? Where is the evidence for this? Would Trump really ban Muslims from entering the US? Where is the evidence for this?\nBy effectively undermining Trump's peacemongering vis-à-vis Clinton's warmongering, Chomsky, by the same logic, undermines criticisms of the regressivist political utterances by Trump. Thus, following Chomsky's logic through it seems a bit hard to know whether his suggestion is intended seriously.\n4) The suffering which these and other similarly extremist policies and attitudes will impose on marginalized and already oppressed populations has a high probability of being significantly greater than that which will result from a Clinton presidency.\nOne assumes that Chomsky refers to the domestic population here. Trump's policies — if he is true to his word to protect jobs for American workers and punish offshoring of American jobs along with his opposition to the TPP — would be a political reversal for neoliberalization. Clintonomics would be decidedly worse for marginalized and oppressed peoples at home and abroad. The economic plight of students, the poor, and ill, however, would be much better under a Jill Stein presidency .\nThe economic plight of students, the poor, and ill would be much better under a Jill Stein presidency.\nIf Chomsky is referring to the preponderant violence of US foreign policy and its oppressive and genocidal on populations, then I agree with his \"basic moral principle\": \"not only must we take responsibility for our actions, but the consequences of our actions for others are a far more important consideration than feeling good about ourselves.\" Under the Democratic administration hundreds of thousands have died, millions of people have been displaced, and terrorist organizations have proliferated. This is the evidence from Clinton's time in political office. Thus a vote for Clinton is predictably a vote that will lead to a continuation, perhaps even a ramping up, of the suffering of others. Basic morality suggests to this writer to steer clear of casting such an oppression-enabling vote.\n5) Should constitute sufficient basis to voting for Clinton where a vote is potentially consequential-namely, in a contested, \"swing\" state.\nI contend that Chomsky's basis for 5) is false or questionable. First, Chomsky has staunchly argued that \"we\" should concentrate foremost on the wrongful actions and crimes of our own state because they are something we can have an influence over. But it seems that Chomsky believes that Trump will supersede Clinton's record of killing in Iraq, Libya, and Syria. Clinton is not going to close US military abroad. Trump has called these bases into question. And if one concentrates on the domestic population, at least the rhetoric of Trump against so-called free trade agreements and offshoring US factories abroad bodes well for the American worker.\n6) However, the left should also recognize that, should Trump win based on its failure to support Clinton, it will repeatedly face the accusation (based in fact), that it lacks concern for those sure to be most victimized by a Trump administration.\nThis criticism is anti-democratic; furthermore, the criticism applies conversely. Chomsky's citing the accusation gives it a veneer of credence. Effectively it leads to the perpetuation of the business-party duopoly. The records of the Bill Clinton and Barack Obama administrations demonstrate the futility of such a proffered rationale. Clinton deregulated the finance sector, exposed American workers to the vagaries of \"free trade,\" implemented regressive welfare policies, and continued aggressive US militarism abroad. Obama? Bailing out the banks; attempts to cut back social security; warring in Afghanistan, Libya, Yemen, and Syria; drone strikes; confrontation with Russia and China; TPP; and the lingering incarceration at Guantanamo Bay. It is important to note that Democrats, arguably, have a freer hand to implement rightist policy than Republicans have since many supporters of Democrats will mute their opposition to avoid providing succor to the Republicans. George Bush was stymied from tinkering with social security. Notably, Obama has done an about-face on social security and proposed an expansion, picking up on the popularity for such a measure from the Bernie Saunders candidacy.\n7) Often this charge will emanate from establishment operatives who will use it as a bad faith justification for defeating challenges to corporate hegemony either in the Democratic Party or outside of it. They will ensure that it will be widely circulated in mainstream media channels with the result that many of those who would otherwise be sympathetic to a left challenge will find it a convincing reason to maintain their ties with the political establishment rather than breaking with it, as they must.\nIt is true that establishment operatives will use LEV as a bad faith justification for defeating challenges to corporate hegemony either in the Democratic Party or outside of it. That was the case when Ralph Nader ran. It is the case when Cynthia McKinney ran and it is when Jill Stein runs. The corporate media and even many so-called progressives will trot out this time-worn argument with each election cycle. As long as enough people buy into the premise, then the status quo will persist. The result is that a right-wing government always assumes office in Washington. This bodes ill for the poor and working class. It bodes poorly for nation states designated as enemy states by the US.\n8) Conclusion: by dismissing a \"lesser evil\" electoral logic and thereby increasing the potential for Clinton's defeat the left will undermine what should be at the core of what it claims to be attempting to achieve.\nConclusion: by buying into a \"lesser evil\" electoral logic the corporate-political duopoly will remain in power to continue policies that primarily benefit the 1% and their goals for further enrichment; to unfetter finance, to pursue a belligerent foreign policy — a policy that seeks to placate the military-industrial establishment; and to further entrench corporate domination of the electoral system. All of this is at cross-hairs with what should be at the core of what progressives claim to be attempting to achieve.\nFinal Comments\nThe tragedy of opting for lesser evilism is that the people get evil.\nSome leftist commentators argue that there is no evilism . I found that to be preposterous. Barack Obama was the so-called lesser evil the previous two election cycles. Obama is not a lesser evilist; he is the man who enables evil. ... The cycles of US-backed violence and killing in places such as Gaza, Syria, Bahrain, Afghanistan, Yemen, and Somalia underscore the utter futility of pandering to a perceived lesser evilism. If one votes for a degree of evil, then one should not be surprised when evil results.\nProgressivism demands that social justice activists repudiate evil. Morality dictates that people should not live in fear of being killed. A genuine peacemongering US president is needed to stop the killing and save lives. Consequently, both Democrats and Republicans are anathema. Given the present candidates, if people vote, then the only conscionable vote is for someone not of the business party factions.\nOnly a propeace \"third\" party will set the US on a new path . Outside of a revolution, the election of a propeace \"third\" party is the only moral direction on the horizon for Americans truly interested in steering their country toward peace and rehabilitating the ensanguined US reputation. Such a \"third party\" vote, however, may well augur the birth of a revolution on many promising fronts.",
		"thread_title": "An Eight Point Brief for Voting to Avoid Corporate Evil",
		"title": "An Eight Point Brief for Voting to Avoid Corporate Evil",
		"type": "bs",
		"uuid": "0f06e348dee64d1e9aecdb381937c99e3b445b53"
	},
	"-KhIbFU-hYVp35TE9diH": {
		"author": "Paul Craig Roberts",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-30T17:34:29.423+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Northern Syria",
				"salience": 0.13193172,
				"type": "LOCATION"
			},
			{
				"name": "army",
				"salience": 0.12202503,
				"type": "ORGANIZATION"
			},
			{
				"name": "Muhammad al-Muhaysini",
				"salience": 0.11549411,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.045912422,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.041759852,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.03708266,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.027737677,
				"type": "LOCATION"
			},
			{
				"name": "preacher",
				"salience": 0.02463954,
				"type": "PERSON"
			},
			{
				"name": "missiles",
				"salience": 0.022954462,
				"type": "OTHER"
			},
			{
				"name": "Muhaysini",
				"salience": 0.022768954,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.021441137,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01311nj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Army_of_Conquest"
				},
				"name": "Jaish al-Fatah",
				"salience": 0.019860666,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.019602707,
				"type": "LOCATION"
			},
			{
				"name": "military aid",
				"salience": 0.019377228,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.019377228,
				"type": "PERSON"
			},
			{
				"name": "terrorist group",
				"salience": 0.019377228,
				"type": "ORGANIZATION"
			},
			{
				"name": "leader",
				"salience": 0.019377228,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.019175163,
				"type": "OTHER"
			},
			{
				"name": "Jeish al-Fatah",
				"salience": 0.014330859,
				"type": "PERSON"
			},
			{
				"name": "Persian Gulf Arab",
				"salience": 0.0119660525,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al Qaeda",
				"salience": 0.010368738,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shares",
				"salience": 0.008608616,
				"type": "OTHER"
			},
			{
				"name": "dissidents",
				"salience": 0.008608616,
				"type": "PERSON"
			},
			{
				"name": "news website",
				"salience": 0.008608616,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0077368496,
				"type": "PERSON"
			},
			{
				"name": "siege",
				"salience": 0.0076334607,
				"type": "EVENT"
			},
			{
				"name": "terrorists",
				"salience": 0.0062808585,
				"type": "PERSON"
			},
			{
				"name": "Enab",
				"salience": 0.005305709,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.005289526,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cargoes",
				"salience": 0.004631981,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0045395694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.004394398,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.004099421,
				"type": "PERSON"
			},
			{
				"name": "missiles",
				"salience": 0.004099421,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.004099421,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0039290073,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0038479096,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0035986174,
				"type": "PERSON"
			},
			{
				"name": "comrades",
				"salience": 0.0035504354,
				"type": "OTHER"
			},
			{
				"name": "Front",
				"salience": 0.003065572,
				"type": "OTHER"
			},
			{
				"name": "Turki Hassan",
				"salience": 0.0029440897,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0028753958,
				"type": "EVENT"
			},
			{
				"name": "allies",
				"salience": 0.0028753958,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist groups",
				"salience": 0.0027681529,
				"type": "ORGANIZATION"
			},
			{
				"name": "aid",
				"salience": 0.0027681529,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0027502382,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0026890293,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0026667658,
				"type": "PERSON"
			},
			{
				"name": "fronts",
				"salience": 0.002600033,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.0025796103,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0025245126,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.0024901363,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0024901363,
				"type": "EVENT"
			},
			{
				"name": "Option",
				"salience": 0.0024901363,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.0024901363,
				"type": "LOCATION"
			},
			{
				"name": "body",
				"salience": 0.0023972462,
				"type": "OTHER"
			},
			{
				"name": "hospitals",
				"salience": 0.0023972462,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.0023972462,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.0023972462,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.00234773,
				"type": "EVENT"
			},
			{
				"name": "regions",
				"salience": 0.00234773,
				"type": "LOCATION"
			},
			{
				"name": "source",
				"salience": 0.0022617253,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0020946497,
				"type": "LOCATION"
			},
			{
				"name": "Northern Aleppo",
				"salience": 0.0020471995,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.002033102,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.002033102,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.002033102,
				"type": "EVENT"
			},
			{
				"name": "equipment",
				"salience": 0.002033102,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0019822111,
				"type": "LOCATION"
			},
			{
				"name": "cause",
				"salience": 0.001957245,
				"type": "OTHER"
			},
			{
				"name": "Fatah Al-Sham",
				"salience": 0.0018874919,
				"type": "PERSON"
			},
			{
				"name": "orders",
				"salience": 0.0018688267,
				"type": "OTHER"
			},
			{
				"name": "Oded Yinon",
				"salience": 0.0015330329,
				"type": "PERSON"
			},
			{
				"name": "Maintaining Assad",
				"salience": 0.0015330329,
				"type": "OTHER"
			},
			{
				"name": "Criminal West's State Sponsorship of Terrorism Israel",
				"salience": 0.0015330329,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime",
				"salience": 0.0015257442,
				"type": "ORGANIZATION"
			},
			{
				"name": "stay",
				"salience": 0.001518931,
				"type": "EVENT"
			},
			{
				"name": "sides",
				"salience": 0.001518931,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.001518931,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.001518931,
				"type": "OTHER"
			},
			{
				"name": "decision-making",
				"salience": 0.001518931,
				"type": "OTHER"
			},
			{
				"name": "punishment",
				"salience": 0.0012775995,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0011120489,
				"type": "OTHER"
			},
			{
				"name": "masters",
				"salience": 0.0011063088,
				"type": "PERSON"
			},
			{
				"name": "defiance",
				"salience": 0.0011063088,
				"type": "OTHER"
			},
			{
				"name": "lords",
				"salience": 0.0011063088,
				"type": "OTHER"
			},
			{
				"name": "properties",
				"salience": 0.0011063088,
				"type": "OTHER"
			},
			{
				"name": "Violation",
				"salience": 0.0010650139,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.001035527,
				"type": "LOCATION"
			},
			{
				"name": "orders",
				"salience": 0.0010168827,
				"type": "OTHER"
			},
			{
				"name": "punishment",
				"salience": 0.0009544088,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00094276527,
				"type": "LOCATION"
			},
			{
				"name": "Fatah al-Sham",
				"salience": 0.0008709489,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0n49m9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ahrar_ash-Sham"
				},
				"name": "Ahrar al-Sham",
				"salience": 0.0008709489,
				"type": "ORGANIZATION"
			},
			{
				"name": "drones",
				"salience": 0.00085848005,
				"type": "OTHER"
			},
			{
				"name": "anticipation",
				"salience": 0.0008264322,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0008264322,
				"type": "ORGANIZATION"
			},
			{
				"name": "evacuation",
				"salience": 0.0008264322,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.0008264322,
				"type": "EVENT"
			},
			{
				"name": "opposition",
				"salience": 0.0008264322,
				"type": "OTHER"
			},
			{
				"name": "military analyst",
				"salience": 0.00071882136,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatari",
				"salience": 0.00068091956,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatari",
				"salience": 0.00068091956,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06gdww",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fine-needle_aspiration"
				},
				"name": "FNA",
				"salience": 0.0006310256,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Abdullah_Muhammad_al-Muhaysini_fad61.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Abdullah Muhammad al-Muhaysini, a senior al Qaeda-linked cleric and the religious leader of Jeish al-Fatah terrorist group, admitted that the militants in Syria have received financial and military aid from Saudi Arabia and certain other Persian Gulf Arab states. 36 Shares\n2 34 0 0\nAccording to the Syrian dissidents' news website, Enab, Muhaysini has released a video recently in which he appreciated Riyadh and other Arab states for equipping his comrades with missiles.\nThe Saudi preacher said that the missiles that they have sent would be used to break the Syrian army and its allies' siege of Aleppo.\nHe also thanked Turkey for supporting the terrorists and treating the wounded militants in its hospitals.\nJaish al-Fatah is a conglomerate of terrorist groups with Al-Nusra (Fatah Al-Sham) Front comprising its main body.\nIn relevant remarks in June, a source said that Saudi Arabia has sent new cargoes of weapons and financial aid to the terrorists in Aleppo in Northern Syria to strengthen them against the Syrian army and its allies' fresh attacks.\nMORE... Why do we only hear of the “humanitarian crisis in Aleppo” and not everywhere else in Syria? Is Maintaining Assad the Least Worst Option? The Criminal West’s State Sponsorship of Terrorism Israel wants Syria destroyed as presaged by the Oded Yinon plan \"The Saudi regime has recently sent small arms and new equipment, including 5 drones, to the terrorists in Syria,\" the source said.\nTo this end, Riyadh has sent one of its ranking officers to the regions controlled by terrorists in Northern Aleppo to supply them with money and arms to intensify attacks and open new fronts against the Syrian army and popular forces, the source added.\nAlso, a prominent Syrian military analyst said earlier this month that the terrorists in Aleppo take orders from outside and don’t dare to leave the city in anticipation of punishment by Saudi Arabia and Turkey.\n\"Violation of the ceasefire by the terrorists and their opposition to the evacuation of Aleppo is of no surprise as they are not the ones in charge of the decision-making for remaining or leaving the city, rather they take orders from the regional and international sides for whom they are working,\" Turki Hassan told FNA last Saturday.\nNoting that the main cause of the terrorists' stubborn stay in Aleppo is that leaders of Fatah al-Sham (formerly known as al-Nusra Front and Ahrar al-Sham) are afraid of punishment by their Qatari, Saudi and Turkish masters, he said, \"If they move in defiance of their Qatari, Saudi and Turkish lords, they might be killed and their properties be seized.\"",
		"thread_title": "Jaish Al-Fatah Leader Admits Receiving Financial, Military Aid from Saudi Arabia",
		"title": "Jaish Al-Fatah Leader Admits Receiving Financial, Military Aid from Saudi Arabia",
		"type": "bs",
		"uuid": "6008d2edfc0041dd4c882b663c8fdff385906d84"
	},
	"-KhIbFi-USAu5v3WY18x": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-10-30T21:49:39.974+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0j40h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan_Workers'_Party"
				},
				"name": "Kurdistan Workers Party",
				"salience": 0.3250663,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.1558259,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.05303568,
				"type": "PERSON"
			},
			{
				"name": "Al-Masdar News",
				"salience": 0.028135538,
				"type": "ORGANIZATION"
			},
			{
				"name": "footage",
				"salience": 0.026636504,
				"type": "WORK_OF_ART"
			},
			{
				"name": "soldiers",
				"salience": 0.026387058,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_g_33y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peoples'_Democratic_Party_(Turkey)"
				},
				"name": "Peoples' Democratic Party",
				"salience": 0.022424422,
				"type": "ORGANIZATION"
			},
			{
				"name": "Soldiers",
				"salience": 0.021324543,
				"type": "PERSON"
			},
			{
				"name": "ceasefire",
				"salience": 0.020717075,
				"type": "EVENT"
			},
			{
				"name": "Fighters",
				"salience": 0.01971609,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Tayyip Erdogan",
				"salience": 0.016598899,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012spzsx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Figen_Y%C3%BCksekda%C4%9F"
				},
				"name": "Figen Yuksekdag",
				"salience": 0.015449465,
				"type": "PERSON"
			},
			{
				"name": "Shooting",
				"salience": 0.015447446,
				"type": "EVENT"
			},
			{
				"name": "range",
				"salience": 0.015447446,
				"type": "OTHER"
			},
			{
				"name": "insurgents",
				"salience": 0.015447446,
				"type": "PERSON"
			},
			{
				"name": "Video",
				"salience": 0.012950491,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Their Heads 2 Shares 1 Amateur",
				"salience": 0.009535232,
				"type": "ORGANIZATION"
			},
			{
				"name": "footage",
				"salience": 0.007012917,
				"type": "WORK_OF_ART"
			},
			{
				"name": "court case",
				"salience": 0.006062922,
				"type": "OTHER"
			},
			{
				"name": "prosecutor",
				"salience": 0.00530597,
				"type": "PERSON"
			},
			{
				"name": "tension",
				"salience": 0.004896134,
				"type": "OTHER"
			},
			{
				"name": "co-leader",
				"salience": 0.004742909,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02zt1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Diyarbak%C4%B1r"
				},
				"name": "Diyarbakir",
				"salience": 0.0046644653,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0046262145,
				"type": "PERSON"
			},
			{
				"name": "clashes",
				"salience": 0.0043690186,
				"type": "EVENT"
			},
			{
				"name": "fighters",
				"salience": 0.0041748136,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0041748136,
				"type": "PERSON"
			},
			{
				"name": "mountanious terrain",
				"salience": 0.0037700424,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0037700424,
				"type": "ORGANIZATION"
			},
			{
				"name": "Soldiers",
				"salience": 0.003666036,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0034382183,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0034348515,
				"type": "OTHER"
			},
			{
				"name": "coup plotters",
				"salience": 0.0032651785,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0032651785,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0032651785,
				"type": "OTHER"
			},
			{
				"name": "government troops",
				"salience": 0.0032651785,
				"type": "PERSON"
			},
			{
				"name": "sides",
				"salience": 0.0032651785,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0029688987,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0029284854,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0029284854,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0029284854,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.002916241,
				"type": "OTHER"
			},
			{
				"name": "footage",
				"salience": 0.0028916223,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cases",
				"salience": 0.00281928,
				"type": "OTHER"
			},
			{
				"name": "border town",
				"salience": 0.0026443864,
				"type": "LOCATION"
			},
			{
				"name": "court",
				"salience": 0.0025800215,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.0025457612,
				"type": "PERSON"
			},
			{
				"name": "terrorist group",
				"salience": 0.0025457612,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0023911507,
				"type": "LOCATION"
			},
			{
				"name": "travel",
				"salience": 0.0022900847,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0022900847,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0022046585,
				"type": "OTHER"
			},
			{
				"name": "daily",
				"salience": 0.0022046585,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0022046585,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0021790315,
				"type": "ORGANIZATION"
			},
			{
				"name": "southeast",
				"salience": 0.0021591212,
				"type": "LOCATION"
			},
			{
				"name": "ceasefire",
				"salience": 0.0021591212,
				"type": "EVENT"
			},
			{
				"name": "southeast",
				"salience": 0.0021591212,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.0020432367,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.0019337905,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.0018936225,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0018697733,
				"type": "OTHER"
			},
			{
				"name": "ban",
				"salience": 0.0018697733,
				"type": "OTHER"
			},
			{
				"name": "collapse",
				"salience": 0.0018697733,
				"type": "EVENT"
			},
			{
				"name": "security crackdown",
				"salience": 0.0018697733,
				"type": "EVENT"
			},
			{
				"name": "co-mayors",
				"salience": 0.0018697733,
				"type": "PERSON"
			},
			{
				"name": "Yuksekdag",
				"salience": 0.0016281215,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "town",
				"salience": 0.0016131466,
				"type": "LOCATION"
			},
			{
				"name": "mortar fire",
				"salience": 0.0016131466,
				"type": "EVENT"
			},
			{
				"name": "operation",
				"salience": 0.0016131466,
				"type": "OTHER"
			},
			{
				"name": "immunity",
				"salience": 0.0016131466,
				"type": "OTHER"
			},
			{
				"name": "immunity",
				"salience": 0.0016131466,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0015087919,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.001451064,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bnmrm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Suru%C3%A7"
				},
				"name": "Suruc",
				"salience": 0.0014098817,
				"type": "LOCATION"
			},
			{
				"name": "security sources",
				"salience": 0.0014031787,
				"type": "PERSON"
			},
			{
				"name": "terrorism charges",
				"salience": 0.0013969127,
				"type": "OTHER"
			},
			{
				"name": "deputies",
				"salience": 0.0013969127,
				"type": "PERSON"
			},
			{
				"name": "parliament",
				"salience": 0.0013969127,
				"type": "ORGANIZATION"
			},
			{
				"name": "appeal",
				"salience": 0.0013793148,
				"type": "OTHER"
			},
			{
				"name": "pro-Kurdish",
				"salience": 0.0013572661,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bl5bn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/H%C3%BCrriyet"
				},
				"name": "Hurriyet",
				"salience": 0.0013572661,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0013572661,
				"type": "ORGANIZATION"
			},
			{
				"name": "fire",
				"salience": 0.0011749697,
				"type": "OTHER"
			},
			{
				"name": "terrorist group",
				"salience": 0.0011749697,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0011749697,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.0010703758,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0010220048,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.00101744,
				"type": "EVENT"
			},
			{
				"name": "province",
				"salience": 0.00101744,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.00101744,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bj5tf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C3%87ukurca"
				},
				"name": "Cukurca",
				"salience": 0.00088257325,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.0008777429,
				"type": "PERSON"
			},
			{
				"name": "prosecution",
				"salience": 0.0008777429,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0p5vf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Member_of_parliament"
				},
				"name": "MPs",
				"salience": 0.0008598504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09glf2z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Selahattin_Demirta%C5%9F"
				},
				"name": "Selahattin Demirtas",
				"salience": 0.00080132025,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0008009876,
				"type": "LOCATION"
			},
			{
				"name": "removal",
				"salience": 0.0007995966,
				"type": "EVENT"
			},
			{
				"name": "lawmakers",
				"salience": 0.0007600471,
				"type": "PERSON"
			},
			{
				"name": "extension",
				"salience": 0.0007600471,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0007600471,
				"type": "PERSON"
			},
			{
				"name": "servants",
				"salience": 0.0007600471,
				"type": "PERSON"
			},
			{
				"name": "links",
				"salience": 0.0007600471,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0007600471,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00072320434,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04xkvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hakk%C3%A2ri_Province"
				},
				"name": "Hakkari",
				"salience": 0.00062622374,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.00062622374,
				"type": "ORGANIZATION"
			},
			{
				"name": "Operations",
				"salience": 0.0005999771,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00044663151,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Turkey_PKK_e0749.JPG",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T21:49:39.974+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Gruesome Video Shows Turkish Soldiers Execute Female Kurdish PKK Fighters by Shooting in Their Heads 2 Shares 1 \nAmateur footage emerged on Saturday showing what appears to be Turkish soldiers executing two female PKK insurgents at point-blank range. \nAl-Masdar News that released the footage says they are not able to independently verify it. \nA ceasefire between Turkey and the PKK ended last year and clashes have since claimed hundreds of lives on both sides. \nThe PKK operates primarily in the mountanious terrain of southeastern Turkey and often uploads footage of its Kurdish fighters ambushing Turkish government troops. MORE... Erdogan vows heavy price for coup plotters \nThe tension between Kurdish fighters and Turkish government have always been high in past years. In yet one of the most recent cases, a Turkish court banned the co-leader of Turkey's pro-Kurdish opposition from traveling abroad as part of a court case in which she has been accused of being a member of an armed terrorist group, Hurriyet daily reported on Saturday, Reuters reported. \nFigen Yuksekdag, co-chair of Peoples' Democratic Party (HDP), is facing jail time up to 15 years over comments she made last year in the southeastern border town of Suruc. The prosecutor of the case requested the ban. \nHDP described the court's decision to bar Yuksekdag from foreign travel as 'political and arbitrary', saying in a statement that it will make a formal appeal for its overturn. \nThe move comes days after the co-mayors of Diyarbakir, the largest city in the southeast, were detained as part of a security crackdown. Turkey's largely Kurdish southeast has been rocked by violence following the collapse of a ceasefire between the state and the Kurdistan Workers Party (PKK) last year. \nPresident Tayyip Erdogan has accused the HDP of being a political extension of the outlawed PKK and repeatedly called for the prosecution of its members. He has also said the removal of elected officials and civil servants accused of links to the PKK was a vital part of the battle against it. \nSeveral other HDP lawmakers including co-chair Selahattin Demirtas are also being prosecuted, largely over terrorism charges, after the parliament earlier this year lifted the immunity of HDP deputies, along with the immunity of MPs from other parties. \nMeanwhile three Turkish soldiers were killed and five others were wounded by mortar fire from PKK militants near the southeastern town of Cukurca, security sources said. \nSoldiers who were on an operation in Cukurca in Hakkari province bordering Iraq and Iraq returned the fire, sources said. Operations were under way to hunt down the militants. \nThe autonomy-seeking PKK took up arms in 1984, and more than 40,000 people have died in the conflict. It is considered a terrorist group by Turkey, the United States and the European Union.",
		"thread_title": "Gruesome Video Shows Turkish Soldiers Execute Female Kurdish PKK Fighters by Shooting in Their Heads",
		"title": "Gruesome Video Shows Turkish Soldiers Execute Female Kurdish PKK Fighters by Shooting in Their Heads",
		"type": "bs",
		"uuid": "27ba406c357eeab7a152ff5225d579d1f312dc6f"
	},
	"-KhIbFyM_6F062-oWXzT": {
		"author": "Harun Yahya",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-31T02:53:06.651+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0j40h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan_Workers'_Party"
				},
				"name": "Kurdistan Workers Party",
				"salience": 0.26110527,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.18296498,
				"type": "LOCATION"
			},
			{
				"name": "Al-Masdar News",
				"salience": 0.033593155,
				"type": "ORGANIZATION"
			},
			{
				"name": "footage",
				"salience": 0.031802326,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0_g_33y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peoples'_Democratic_Party_(Turkey)"
				},
				"name": "Peoples' Democratic Party",
				"salience": 0.030315248,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.029183246,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.029132651,
				"type": "PERSON"
			},
			{
				"name": "ceasefire",
				"salience": 0.02473176,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Tayyip Erdogan",
				"salience": 0.018841086,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.01843887,
				"type": "OTHER"
			},
			{
				"name": "insurgents",
				"salience": 0.01843887,
				"type": "PERSON"
			},
			{
				"name": "range",
				"salience": 0.01843887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012spzsx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Figen_Y%C3%BCksekda%C4%9F"
				},
				"name": "Figen Yuksekdag",
				"salience": 0.013976203,
				"type": "PERSON"
			},
			{
				"name": "clashes",
				"salience": 0.012632755,
				"type": "EVENT"
			},
			{
				"name": "lives",
				"salience": 0.009448252,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.009448252,
				"type": "OTHER"
			},
			{
				"name": "bombers",
				"salience": 0.008377879,
				"type": "PERSON"
			},
			{
				"name": "footage",
				"salience": 0.008369469,
				"type": "WORK_OF_ART"
			},
			{
				"name": "court case",
				"salience": 0.0072355634,
				"type": "OTHER"
			},
			{
				"name": "prosecutor",
				"salience": 0.006332105,
				"type": "PERSON"
			},
			{
				"name": "band",
				"salience": 0.005917376,
				"type": "OTHER"
			},
			{
				"name": "co-leader",
				"salience": 0.0056600845,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02zt1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Diyarbak%C4%B1r"
				},
				"name": "Diyarbakir",
				"salience": 0.005566462,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0055208094,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0046190494,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.0044989926,
				"type": "PERSON"
			},
			{
				"name": "mountanious terrain",
				"salience": 0.0044989926,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0041029803,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.004098962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.004090825,
				"type": "LOCATION"
			},
			{
				"name": "Soldiers",
				"salience": 0.004042031,
				"type": "PERSON"
			},
			{
				"name": "coup d'état",
				"salience": 0.0039461367,
				"type": "OTHER"
			},
			{
				"name": "tension",
				"salience": 0.0039461367,
				"type": "OTHER"
			},
			{
				"name": "government troops",
				"salience": 0.0038964695,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0038964695,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempt",
				"salience": 0.0038964695,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0038964695,
				"type": "OTHER"
			},
			{
				"name": "coup plotters",
				"salience": 0.0038964695,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.0037039649,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.003494655,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.003494655,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0034800423,
				"type": "OTHER"
			},
			{
				"name": "footage",
				"salience": 0.0034506621,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cases",
				"salience": 0.0033643288,
				"type": "OTHER"
			},
			{
				"name": "border town",
				"salience": 0.0031556115,
				"type": "LOCATION"
			},
			{
				"name": "court",
				"salience": 0.003078799,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025k7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Coup_d'%C3%A9tat"
				},
				"name": "Coup",
				"salience": 0.003068243,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist group",
				"salience": 0.003037913,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.003037913,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.003037913,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.003037913,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0028534033,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state",
				"salience": 0.0028534033,
				"type": "LOCATION"
			},
			{
				"name": "comments",
				"salience": 0.0027327936,
				"type": "OTHER"
			},
			{
				"name": "travel",
				"salience": 0.0027327936,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0026308482,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0026308482,
				"type": "OTHER"
			},
			{
				"name": "daily",
				"salience": 0.0026308482,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.002600266,
				"type": "ORGANIZATION"
			},
			{
				"name": "southeast",
				"salience": 0.0025765055,
				"type": "LOCATION"
			},
			{
				"name": "ceasefire",
				"salience": 0.0025765055,
				"type": "EVENT"
			},
			{
				"name": "southeast",
				"salience": 0.0025765055,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.0024382132,
				"type": "PERSON"
			},
			{
				"name": "Turkey Dispute",
				"salience": 0.0023992495,
				"type": "EVENT"
			},
			{
				"name": "move",
				"salience": 0.00225967,
				"type": "OTHER"
			},
			{
				"name": "co-mayors",
				"salience": 0.0022312095,
				"type": "PERSON"
			},
			{
				"name": "security crackdown",
				"salience": 0.0022312095,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.0022312095,
				"type": "OTHER"
			},
			{
				"name": "collapse",
				"salience": 0.0022312095,
				"type": "EVENT"
			},
			{
				"name": "ban",
				"salience": 0.0022312095,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.002131904,
				"type": "PERSON"
			},
			{
				"name": "Yuksekdag",
				"salience": 0.001942835,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "town",
				"salience": 0.0019249651,
				"type": "LOCATION"
			},
			{
				"name": "mortar fire",
				"salience": 0.0019249651,
				"type": "EVENT"
			},
			{
				"name": "immunity",
				"salience": 0.0019249651,
				"type": "OTHER"
			},
			{
				"name": "immunity",
				"salience": 0.0019249651,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0018004347,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.0017315462,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0016824021,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bnmrm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Suru%C3%A7"
				},
				"name": "Suruc",
				"salience": 0.0016824021,
				"type": "LOCATION"
			},
			{
				"name": "security sources",
				"salience": 0.0016744031,
				"type": "PERSON"
			},
			{
				"name": "terrorism charges",
				"salience": 0.0016669258,
				"type": "OTHER"
			},
			{
				"name": "parliament",
				"salience": 0.0016669258,
				"type": "ORGANIZATION"
			},
			{
				"name": "deputies",
				"salience": 0.0016669258,
				"type": "PERSON"
			},
			{
				"name": "appeal",
				"salience": 0.0016459258,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bl5bn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/H%C3%BCrriyet"
				},
				"name": "Hurriyet",
				"salience": 0.0016196144,
				"type": "ORGANIZATION"
			},
			{
				"name": "pro-Kurdish",
				"salience": 0.0016196144,
				"type": "OTHER"
			},
			{
				"name": "terrorist group",
				"salience": 0.0014020761,
				"type": "ORGANIZATION"
			},
			{
				"name": "fire",
				"salience": 0.0014020761,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0014020761,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0014020761,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.0012772627,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0012195411,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.001214094,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.001214094,
				"type": "EVENT"
			},
			{
				"name": "province",
				"salience": 0.001214094,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bj5tf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C3%87ukurca"
				},
				"name": "Cukurca",
				"salience": 0.0010531567,
				"type": "LOCATION"
			},
			{
				"name": "prosecution",
				"salience": 0.0010473926,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.0010473926,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0p5vf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Member_of_parliament"
				},
				"name": "MPs",
				"salience": 0.0010260415,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09glf2z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Selahattin_Demirta%C5%9F"
				},
				"name": "Selahattin Demirtas",
				"salience": 0.00095619744,
				"type": "PERSON"
			},
			{
				"name": "removal",
				"salience": 0.0009541406,
				"type": "EVENT"
			},
			{
				"name": "links",
				"salience": 0.0009069463,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.0009069463,
				"type": "OTHER"
			},
			{
				"name": "lawmakers",
				"salience": 0.0009069463,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.0009069463,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.0009069463,
				"type": "PERSON"
			},
			{
				"name": "servants",
				"salience": 0.0009069463,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.000862982,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04xkvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hakk%C3%A2ri_Province"
				},
				"name": "Hakkari",
				"salience": 0.00074725586,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.00074725586,
				"type": "ORGANIZATION"
			},
			{
				"name": "Operations",
				"salience": 0.0007159361,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0005329513,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Turkey_PKK_e0749.JPG",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.6,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.002",
		"text": "4 Shares\n3 0 0 1\nAmateur footage emerged on Saturday showing what appears to be Turkish soldiers executing two female PKK insurgents at point-blank range.\nAl-Masdar News that released the footage says they are not able to independently verify it.\nA ceasefire between Turkey and the PKK ended last year and clashes have since claimed hundreds of lives on both sides.\nThe PKK operates primarily in the mountanious terrain of southeastern Turkey and often uploads footage of its Kurdish fighters ambushing Turkish government troops.\nMORE... 2 bombers, stopped by police, blew themselves up in Turkey Dispute over Kurds and Coup attempt threatens U.S.-Turkey alliance The attempted coup d’état made Turkey band together Erdogan vows heavy price for coup plotters The tension between Kurdish fighters and Turkish government have always been high in past years. In yet one of the most recent cases, a Turkish court banned the co-leader of Turkey's pro-Kurdish opposition from traveling abroad as part of a court case in which she has been accused of being a member of an armed terrorist group, Hurriyet daily reported on Saturday, Reuters reported.\nFigen Yuksekdag, co-chair of Peoples' Democratic Party (HDP), is facing jail time up to 15 years over comments she made last year in the southeastern border town of Suruc. The prosecutor of the case requested the ban.\nHDP described the court's decision to bar Yuksekdag from foreign travel as 'political and arbitrary', saying in a statement that it will make a formal appeal for its overturn.\nThe move comes days after the co-mayors of Diyarbakir, the largest city in the southeast, were detained as part of a security crackdown. Turkey's largely Kurdish southeast has been rocked by violence following the collapse of a ceasefire between the state and the Kurdistan Workers Party (PKK) last year.\nPresident Tayyip Erdogan has accused the HDP of being a political extension of the outlawed PKK and repeatedly called for the prosecution of its members. He has also said the removal of elected officials and civil servants accused of links to the PKK was a vital part of the battle against it.\nSeveral other HDP lawmakers including co-chair Selahattin Demirtas are also being prosecuted, largely over terrorism charges, after the parliament earlier this year lifted the immunity of HDP deputies, along with the immunity of MPs from other parties.\nMeanwhile three Turkish soldiers were killed and five others were wounded by mortar fire from PKK militants near the southeastern town of Cukurca, security sources said.\nSoldiers who were on an operation in Cukurca in Hakkari province bordering Iraq and Iraq returned the fire, sources said. Operations were under way to hunt down the militants.\nThe autonomy-seeking PKK took up arms in 1984, and more than 40,000 people have died in the conflict. It is considered a terrorist group by Turkey, the United States and the European Union.",
		"thread_title": "Gruesome Video Shows Turkish Soldiers Execute Female Kurdish PKK Fighters by Shooting in Their Heads",
		"title": "Gruesome Video Shows Turkish Soldiers Execute Female Kurdish PKK Fighters by Shooting in Their Heads",
		"type": "bs",
		"uuid": "90f750be0100d187716486b4b98d1b7c5285ba4a"
	},
	"-KhIbGBi7sDbjaEK0bLH": {
		"author": "Catherine Shakdam",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-31T13:38:08.146+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.16975906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.12723263,
				"type": "ORGANIZATION"
			},
			{
				"name": "match",
				"salience": 0.118660495,
				"type": "EVENT"
			},
			{
				"name": "Bassam Attiyah",
				"salience": 0.06551065,
				"type": "PERSON"
			},
			{
				"name": "football stadium",
				"salience": 0.046315823,
				"type": "LOCATION"
			},
			{
				"name": "police officers",
				"salience": 0.0402043,
				"type": "PERSON"
			},
			{
				"name": "terrorism plots",
				"salience": 0.036356255,
				"type": "OTHER"
			},
			{
				"name": "bomb attack",
				"salience": 0.036356255,
				"type": "EVENT"
			},
			{
				"name": "men",
				"salience": 0.023934584,
				"type": "PERSON"
			},
			{
				"name": "Mansour al-Turki",
				"salience": 0.02201153,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.016202975,
				"type": "OTHER"
			},
			{
				"name": "suspects",
				"salience": 0.013693586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sf4r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Nicholson_(East_India_Company_officer)"
				},
				"name": "John Nicholson",
				"salience": 0.013185132,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zqgj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Interior_ministry"
				},
				"name": "Interior Ministry",
				"salience": 0.01277236,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shares",
				"salience": 0.012750286,
				"type": "OTHER"
			},
			{
				"name": "blast radius",
				"salience": 0.010266304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.009141449,
				"type": "LOCATION"
			},
			{
				"name": "match",
				"salience": 0.008581401,
				"type": "EVENT"
			},
			{
				"name": "bomb",
				"salience": 0.007726104,
				"type": "OTHER"
			},
			{
				"name": "fans",
				"salience": 0.007726104,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.007726104,
				"type": "LOCATION"
			},
			{
				"name": "stadium",
				"salience": 0.006930448,
				"type": "LOCATION"
			},
			{
				"name": "stadium",
				"salience": 0.006930448,
				"type": "LOCATION"
			},
			{
				"name": "qualifier",
				"salience": 0.006692523,
				"type": "EVENT"
			},
			{
				"name": "suspects",
				"salience": 0.0064969594,
				"type": "PERSON"
			},
			{
				"name": "King Abdullah Sports City Stadium",
				"salience": 0.0060858135,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0060030483,
				"type": "PERSON"
			},
			{
				"name": "ministry",
				"salience": 0.0057793874,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0057420237,
				"type": "PERSON"
			},
			{
				"name": "stadium",
				"salience": 0.005660155,
				"type": "LOCATION"
			},
			{
				"name": "fans",
				"salience": 0.005421161,
				"type": "PERSON"
			},
			{
				"name": "parking lot",
				"salience": 0.004695341,
				"type": "LOCATION"
			},
			{
				"name": "scenario",
				"salience": 0.004695341,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.0046362593,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "explosives",
				"salience": 0.004520313,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.004520313,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.004520313,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.004520313,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01pk8b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeddah"
				},
				"name": "Jeddah",
				"salience": 0.0041226484,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/030791",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2014_FIFA_World_Cup"
				},
				"name": "World Cup",
				"salience": 0.0041226484,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0412q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates_national_football_team"
				},
				"name": "United Arab Emirates",
				"salience": 0.0041226484,
				"type": "LOCATION"
			},
			{
				"name": "suspects",
				"salience": 0.0039652763,
				"type": "PERSON"
			},
			{
				"name": "suspect",
				"salience": 0.0039652763,
				"type": "PERSON"
			},
			{
				"name": "spectators",
				"salience": 0.0038340846,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.0038340846,
				"type": "OTHER"
			},
			{
				"name": "arrest",
				"salience": 0.003308122,
				"type": "EVENT"
			},
			{
				"name": "activity",
				"salience": 0.003308122,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.003308122,
				"type": "OTHER"
			},
			{
				"name": "arrests",
				"salience": 0.003308122,
				"type": "EVENT"
			},
			{
				"name": "police officers",
				"salience": 0.0032275994,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0032109525,
				"type": "LOCATION"
			},
			{
				"name": "match",
				"salience": 0.0028887994,
				"type": "EVENT"
			},
			{
				"name": "identification",
				"salience": 0.0028648796,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0028648796,
				"type": "PERSON"
			},
			{
				"name": "security measures",
				"salience": 0.0028648796,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.0027580091,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "plot",
				"salience": 0.002409872,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0023607726,
				"type": "LOCATION"
			},
			{
				"name": "ministry",
				"salience": 0.0020977044,
				"type": "ORGANIZATION"
			},
			{
				"name": "links",
				"salience": 0.0020868804,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0020868804,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0019939912,
				"type": "PERSON"
			},
			{
				"name": "securities",
				"salience": 0.0019939912,
				"type": "OTHER"
			},
			{
				"name": "field work",
				"salience": 0.0018384124,
				"type": "OTHER"
			},
			{
				"name": "spokesman",
				"salience": 0.0018004251,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0018004251,
				"type": "EVENT"
			},
			{
				"name": "radio",
				"salience": 0.0018004251,
				"type": "OTHER"
			},
			{
				"name": "ISIS poppy fields",
				"salience": 0.0018004251,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0015590651,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.0015590651,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0015590651,
				"type": "OTHER"
			},
			{
				"name": "opium revenue",
				"salience": 0.0015590651,
				"type": "OTHER"
			},
			{
				"name": "heroin",
				"salience": 0.0015590651,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0014593262,
				"type": "LOCATION"
			},
			{
				"name": "Kirkuk A Saudi",
				"salience": 0.0011082292,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0009596268,
				"type": "LOCATION"
			},
			{
				"name": "'t",
				"salience": 0.0009596268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "gov",
				"salience": 0.0009596268,
				"type": "PERSON"
			},
			{
				"name": "Khorasan Caliphate",
				"salience": 0.00084532576,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/King_Abdullah_Sports_City_Stadium_aa588.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.007",
		"text": "Saudi Arabia says it has thwarted two ISIS terrorism plots concerning a bomb attack on a football stadium and killing police officers. 2 Shares\n1 0 0 1\nThe Saudi Interior Ministry on Sunday announced that four men were arrested over plans to detonate a bomb at the King Abdullah Sports City Stadium during or after an October 11 World Cup qualifier match against United Arab Emirates in the city of Jeddah. The suspects were arrested one day before the match which gathered over 60,000 fans.\n“ISIS wants any operation that could result in the highest number of victims,” said interior ministry spokesman Major General Mansour al-Turki.\nA security official, General Bassam Attiyah, said a vehicle carrying around 400 kilograms of explosives was found near the stadium. He added that the suspects had planned to either target people in the stadium’s parking lot or fans watching the match.\n“Another equally horrifying scenario would have occurred,” he added, “had the device exploded whilst the spectators were exiting the stadium.”\nHe noted that the blast radius would have been something around 1,100 meters which would have covered an area of almost 800,000 square meters.\nMORE... U.S. Commander John Nicholson: ISIS Attempting to Establish Khorasan Caliphate in Afghanistan ISIL executes Iraqi citizens listening to gov't radio Iraqi forces burn 16k m² ISIS poppy fields to curtail heroin and opium revenue ISIS executes 45 people southwest of Kirkuk A Saudi spokesman noted that securities had received information of the attack two days prior to the arrests.\n“Tighter security measures were taken and more troops were deployed to ensure prompt and decisive action against any suspect or suspicious activity. Greater field work resulted in the identification and arrest of the suspects one day before the match,” he added.\nThe ministry also announced that a separate plot had been foiled in the capital Riyadh in which four people with links to ISIS were detained after evidence surfaced that they had been plotting to attack police officers.",
		"thread_title": "Saudis Foil ISIS Terror Attacks on Packed Stadium",
		"title": "Saudis Foil ISIS Terror Attacks on Packed Stadium",
		"type": "bs",
		"uuid": "8766d7fcfc4d2e45d0d7101c98016f85163d1e12"
	},
	"-KhIbGXohVlQBK21oy1J": {
		"author": "Saurav Dutt",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-31T13:53:26.303+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.6218758,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.15683927,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.039744247,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0_5vr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Madeleine_Albright"
				},
				"name": "Madeleine Albright",
				"salience": 0.021109879,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012gx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Biden"
				},
				"name": "Joe Biden",
				"salience": 0.019998431,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.016592866,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.007246734,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.00624118,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.004413157,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0039864373,
				"type": "OTHER"
			},
			{
				"name": "cabinet members",
				"salience": 0.0034538496,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0030098902,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0030098902,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03k_f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Henry_Kissinger"
				},
				"name": "Henry Kissinger",
				"salience": 0.002999581,
				"type": "PERSON"
			},
			{
				"name": "space programme",
				"salience": 0.0023196763,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dwqgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Indian_sentiment"
				},
				"name": "Anti-India",
				"salience": 0.0022998536,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0022585355,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.0022585355,
				"type": "PERSON"
			},
			{
				"name": "establishment",
				"salience": 0.0022585355,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0022585355,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.002039652,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0017666144,
				"type": "OTHER"
			},
			{
				"name": "climate",
				"salience": 0.0017666144,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0017666144,
				"type": "OTHER"
			},
			{
				"name": "fabric",
				"salience": 0.0017666144,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.001524376,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0014318369,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0013827878,
				"type": "OTHER"
			},
			{
				"name": "Things",
				"salience": 0.0012290656,
				"type": "OTHER"
			},
			{
				"name": "supercomputers",
				"salience": 0.0011615828,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0010481506,
				"type": "LOCATION"
			},
			{
				"name": "amendment",
				"salience": 0.0010246986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "things",
				"salience": 0.0009908979,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0009791036,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.00093070895,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sanctions",
				"salience": 0.00093070895,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00093070895,
				"type": "OTHER"
			},
			{
				"name": "icing",
				"salience": 0.0008968902,
				"type": "OTHER"
			},
			{
				"name": "Narendra Modi. Trump",
				"salience": 0.0008579584,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.0008403835,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0008403835,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00077592564,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.0007655993,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.00075266836,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.000749782,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0007277487,
				"type": "EVENT"
			},
			{
				"name": "husband",
				"salience": 0.0007277487,
				"type": "PERSON"
			},
			{
				"name": "down-slide",
				"salience": 0.0007277487,
				"type": "OTHER"
			},
			{
				"name": "ambassador",
				"salience": 0.0007277487,
				"type": "PERSON"
			},
			{
				"name": "anger",
				"salience": 0.0007277487,
				"type": "OTHER"
			},
			{
				"name": "fronts",
				"salience": 0.0007277487,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0007064444,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0006948705,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00065264903,
				"type": "LOCATION"
			},
			{
				"name": "sanctions",
				"salience": 0.0006444275,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0006282935,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.0006282935,
				"type": "LOCATION"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0006144923,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0005968094,
				"type": "ORGANIZATION"
			},
			{
				"name": "takeover",
				"salience": 0.0005941442,
				"type": "EVENT"
			},
			{
				"name": "industries",
				"salience": 0.0005941442,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0005892907,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0005892907,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0005892907,
				"type": "EVENT"
			},
			{
				"name": "actions",
				"salience": 0.0005892907,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005892907,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.0005712831,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.000567298,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.000567298,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.000567298,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.000567298,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.000567298,
				"type": "ORGANIZATION"
			},
			{
				"name": "turn",
				"salience": 0.0005368368,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0005328232,
				"type": "LOCATION"
			},
			{
				"name": "deaths",
				"salience": 0.0005328232,
				"type": "EVENT"
			},
			{
				"name": "television outbursts",
				"salience": 0.0005102892,
				"type": "OTHER"
			},
			{
				"name": "patent laws",
				"salience": 0.0005102892,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0005102892,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0005102892,
				"type": "ORGANIZATION"
			},
			{
				"name": "plebiscite",
				"salience": 0.0005102892,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.0005102892,
				"type": "EVENT"
			},
			{
				"name": "Super 301",
				"salience": 0.0005092608,
				"type": "PERSON"
			},
			{
				"name": "engines",
				"salience": 0.0004912432,
				"type": "OTHER"
			},
			{
				"name": "clause",
				"salience": 0.0004912432,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.0004912432,
				"type": "OTHER"
			},
			{
				"name": "trade law",
				"salience": 0.0004912432,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0004912432,
				"type": "OTHER"
			},
			{
				"name": "textile",
				"salience": 0.0004912432,
				"type": "OTHER"
			},
			{
				"name": "carpet",
				"salience": 0.0004912432,
				"type": "OTHER"
			},
			{
				"name": "sectors",
				"salience": 0.0004912432,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0004875703,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0004810909,
				"type": "OTHER"
			},
			{
				"name": "lady",
				"salience": 0.00046984482,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.00046313406,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.00045967122,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00045017106,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.00044797742,
				"type": "PERSON"
			},
			{
				"name": "synonyms",
				"salience": 0.0004438558,
				"type": "OTHER"
			},
			{
				"name": "Secretary of State",
				"salience": 0.00043085805,
				"type": "PERSON"
			},
			{
				"name": "monopoly capital",
				"salience": 0.00041658778,
				"type": "OTHER"
			},
			{
				"name": "mines",
				"salience": 0.00041658778,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.00041658778,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00041658778,
				"type": "PERSON"
			},
			{
				"name": "cake",
				"salience": 0.00041658778,
				"type": "OTHER"
			},
			{
				"name": "investment firm",
				"salience": 0.00041658778,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.00041658778,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.00039803868,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.00039803868,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.00034292703,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0003226122,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04f30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmir"
				},
				"name": "Kashmir",
				"salience": 0.00031408598,
				"type": "LOCATION"
			},
			{
				"name": "oeuvre",
				"salience": 0.0003111958,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0003111958,
				"type": "PERSON"
			},
			{
				"name": "tape",
				"salience": 0.0003111958,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0003111958,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0003111958,
				"type": "OTHER"
			},
			{
				"name": "setting",
				"salience": 0.0003111958,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0003111958,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.0003111958,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/085h1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Trade_Organization"
				},
				"name": "WTO",
				"salience": 0.00030236045,
				"type": "ORGANIZATION"
			},
			{
				"name": "Dunkel Draft",
				"salience": 0.00030236045,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Ronald Reagan",
				"salience": 0.00030236045,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ftc9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cray"
				},
				"name": "Cray",
				"salience": 0.00030236045,
				"type": "ORGANIZATION"
			},
			{
				"name": "risk",
				"salience": 0.0002920749,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00028989062,
				"type": "LOCATION"
			},
			{
				"name": "intentions",
				"salience": 0.00028603734,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0002811708,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.00027207835,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.00026173762,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.00026056834,
				"type": "OTHER"
			},
			{
				"name": "Policies Look Like a Death Sentence",
				"salience": 0.0002564014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rhrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Federal_Republic_of_Yugoslavia"
				},
				"name": "Yugoslavia",
				"salience": 0.0002564014,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0002564014,
				"type": "LOCATION"
			},
			{
				"name": "intent",
				"salience": 0.00024879025,
				"type": "OTHER"
			},
			{
				"name": "anti-Modi",
				"salience": 0.00024498274,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00023542668,
				"type": "PERSON"
			},
			{
				"name": "Secretary of State",
				"salience": 0.00023440215,
				"type": "PERSON"
			},
			{
				"name": "foreign policy",
				"salience": 0.00023366594,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.0002266369,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0002266369,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0002266369,
				"type": "OTHER"
			},
			{
				"name": "confidante",
				"salience": 0.00021817519,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.00021817519,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.00021758325,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.00021542542,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.000195512,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0001850096,
				"type": "PERSON"
			},
			{
				"name": "corridors",
				"salience": 0.00018267773,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0001692908,
				"type": "OTHER"
			},
			{
				"name": "descent",
				"salience": 0.0001692908,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0001692908,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0001692908,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.0001692908,
				"type": "OTHER"
			},
			{
				"name": "advancements",
				"salience": 0.0001692908,
				"type": "OTHER"
			},
			{
				"name": "frame",
				"salience": 0.0001692908,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.000167157,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03kbr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hindu"
				},
				"name": "Hindus",
				"salience": 0.00013947852,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.00013720401,
				"type": "LOCATION"
			},
			{
				"name": "links",
				"salience": 0.00013645287,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.000104183484,
				"type": "LOCATION"
			},
			{
				"name": "role",
				"salience": 0.00007908399,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Clinton_India_4cf5c.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Bill Clinton and his cabinet members pursued Anti-India activities and as Secretary of State Hillary did the same. As President, she will no doubt continue to bully India. 7 Shares\n7 0 0 0\nThere are only weeks left until we find out if we have a President Trump or a President Clinton. Donald Trump is perceived as the candidate who is against the corrupt establishment, while Hillary Clinton is seen as part and fabric of the establishment and as the most corrupt candidate to run for President in the history of the country.\nA President Clinton in a few weeks would return us to the hostile climate towards India that we saw in the 1990s overseen by her husband. After he took office in 1993 the US relationship with India went on a considerable down-slide. For nearly a year, Clinton did not bother appointing an ambassador to India even as he went about opposing India on multiple fronts, leading to anger in the Indian establishment. Initially he was intent on disarming and weakening India by preventing access to technology and also mounted a sustained attack on the Indian economy by imposing several economic sanctions.\nIn 1991, Senator Joe Biden, who is now the Vice President under Barack Obama, introduced an amendment in the bill granting aid to Russia, making the aid conditional on the fact that Russia could not sell cryogenic engines for India's space programme. The Clinton administration was hellbent on hurting the development of India's space and technology sectors and blocked the sale of Cray supercomputers that had been approved under the Ronald Reagan administration. India was also targeted for several economic sanctions and was threatened under what was called the Super 301 clause of the American trade law.\nThese economic sanctions were specifically borne out in the way Mr Clinton attacked the Indian textile and carpet industries. Throughout the 1990s, the terms \"Dunkel Draft\", \"Super 301\", \"WTO\" and \"patent laws\" became synonyms for the US attempts to retard the Indian economy and led to many protests in India.\nBy 1996, India was justified in believing that Indo-US relations had hit the lowest point, but things took a dramatic turn for the worse during Bill Clinton's second term in office. Madeleine Albright became the new Secretary of State and she was increasingly hostile to India especially through her pseudo-racist television outbursts. In fact she loved attacking India so much she went at it after leaving office and called for a plebiscite in Kashmir, justifying the actions of violent groups in the process.\nMORE... Clinton's Policies Look Like a Death Sentence for Americans 10 Things to Expect with a Hillary Clinton Presidency Hillary Clinton must be indicted How Hillary Clinton ushered in a one party dictatorship of monopoly capital Remember this is the same blood-soaked Albright who advocated bombing Yugoslavia and then got her investment firm to attempt a takeover of mines in that country. Like the Clintons, she also knows how to abuse her power. Lest we forget, Albright also justified the deaths of half a million Iraqi children and claimed that the deaths were \"worth it\". And the icing on the cake for this particularly nasty woman? Albright has already threatened women in America and claimed that there was a special place in hell reserved for them if they did not vote for Hillary Clinton.\nThere is already talk of Joe Biden in the frame as Secretary of State under Hillary Clinton. Biden would continue his anti-India agenda and try to thwart the development of India's space programme and other technological advancements. Then of course there is Hillary's closest confidante, a duplicitous lady called Huma Abedin who is of Pakistani descent and whose family has links to radical elements in Pakistan and Saudi Arabia. Abedin could end up playing an important role in determining American foreign policy and would be certainly anti-Modi.\nAnother point against Hillary Clinton is that the hawkish Henry Kissinger has supports her and her oeuvre as Secretary of State. This is the same Kissinger who is so hostile against India, many of his racist statements are even on tape to that end.\nIt is in the light of this setting that many Indian-Americans have opposed the candidacy of Hillary Clinton and have come out in support of Donald Trump. In contrast to the policies of the Clintons, Trump has promised to make India the best friend of the US and has stated that he looks forward to working with Prime Minister Narendra Modi. Trump has also reached out to Hindus in US. While there is always a risk of the unknown and it is not clear if Trump can make the change he wants to, a Hillary presidency will certainly be a major step back for India.\nIn order for India to build a constructive relationship with US, it requires people in both countries to have good intentions. It is clear that India cannot have a strong and forward looking relationship with the US if Hillary Clinton is running the corridors of power. On the other hand, Donald Trump has articulated the right intent and his stance holds promise for India.",
		"thread_title": "What will Hillary Clinton do for India? Not Much and Here's Why",
		"title": "What will Hillary Clinton do for India? Not Much and Here's Why",
		"type": "bs",
		"uuid": "8d0a8e76694c1f8477f79c1b5a6dea7a14ed88a4"
	},
	"-KhIbGaUlnbJiVlAFTgt": {
		"author": "obbop",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-01T10:31:07.774+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.8166554,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.18334463,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Turkey_PKK_e0749.JPG",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-31T23:37:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.002",
		"text": "Does Hillary Clinton care or does she only care about obtaining votes?",
		"thread_title": "Gruesome Video Shows Turkish Soldiers Execute Female Kurdish PKK Fighters by Shooting in Their Heads",
		"title": "",
		"type": "bs",
		"uuid": "c96f410d37cd190da3d3277f32ec4a9d6a916116"
	},
	"-KhIbGhqFrV028xLsc_l": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-11-02T11:42:14.471+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.28420255,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hossam al-Din al-Abbar",
				"salience": 0.21951203,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.075179465,
				"type": "OTHER"
			},
			{
				"name": "ISIS Executes 300 Iraqi Civilians",
				"salience": 0.059700966,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mosul 7",
				"salience": 0.056071613,
				"type": "ORGANIZATION"
			},
			{
				"name": "Firing Squad North",
				"salience": 0.04084084,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nineveh Provincial Council",
				"salience": 0.04084084,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01chdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nineveh_Governorate"
				},
				"name": "Mosul",
				"salience": 0.038778987,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.031698603,
				"type": "PERSON"
			},
			{
				"name": "security members",
				"salience": 0.023796957,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.012225683,
				"type": "PERSON"
			},
			{
				"name": "Abbar",
				"salience": 0.011541754,
				"type": "PERSON"
			},
			{
				"name": "security forces",
				"salience": 0.011470983,
				"type": "PERSON"
			},
			{
				"name": "persons",
				"salience": 0.009940599,
				"type": "PERSON"
			},
			{
				"name": "press statement",
				"salience": 0.009571305,
				"type": "WORK_OF_ART"
			},
			{
				"name": "firing squad",
				"salience": 0.0093744015,
				"type": "EVENT"
			},
			{
				"name": "village",
				"salience": 0.0081224805,
				"type": "LOCATION"
			},
			{
				"name": "prisons",
				"salience": 0.0081224805,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.006073659,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.006073659,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.006073659,
				"type": "LOCATION"
			},
			{
				"name": "security forces",
				"salience": 0.005110777,
				"type": "ORGANIZATION"
			},
			{
				"name": "Moshairefa",
				"salience": 0.005006834,
				"type": "LOCATION"
			},
			{
				"name": "charges",
				"salience": 0.004426865,
				"type": "OTHER"
			},
			{
				"name": "Wilayet Nineveh",
				"salience": 0.004320693,
				"type": "LOCATION"
			},
			{
				"name": "For You",
				"salience": 0.003486487,
				"type": "WORK_OF_ART"
			},
			{
				"name": "execution",
				"salience": 0.0033085358,
				"type": "OTHER"
			},
			{
				"name": "death sentence",
				"salience": 0.0033085358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/074hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sharia"
				},
				"name": "Sharia Court",
				"salience": 0.0018177491,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/isis-shooting-Mosul_ac52a.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-02T11:42:14.471+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "ISIS Executes 300 Iraqi Civilians by Firing Squad North of Mosul 7 Shares 0 1 \nMember of Nineveh Provincial Council, Hossam al-Din al-Abbar, announced, that the ISIS executed 300 civilians and former security members, north of Mosul. \nAbbar said in a press statement, “Today, ISIS members executed 300 persons for collaborating with security forces,” pointing out that, “The ISIS was detaining them in its prisons, and then executed them by firing squad in Moshairefa village, north of Mosul.” \n“ISIS filmed the execution after the so-called Sharia Court issued the death sentence in Wilayet Nineveh,” Abbar added. \nThe ISIS executed thousands of Mosul residents after capturing the city in June 2014, on different charges, especially for collaborating with the security forces. Recommended For You",
		"thread_title": "ISIS Executes 300 Iraqi Civilians by Firing Squad North of Mosul",
		"title": "ISIS Executes 300 Iraqi Civilians by Firing Squad North of Mosul",
		"type": "bs",
		"uuid": "4d95572ff4dd1581095b8a75e53cfe6a8ce0ec69"
	},
	"-KhIbGlsj1hVqqBC9WJA": {
		"author": "Tim Wobble",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-02T18:13:49.729+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.579574,
				"type": "LOCATION"
			},
			{
				"name": "activist",
				"salience": 0.12770341,
				"type": "PERSON"
			},
			{
				"name": "spoils",
				"salience": 0.08787073,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022bh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colonialism"
				},
				"name": "Colonialism",
				"salience": 0.05519517,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.051445574,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0390805,
				"type": "LOCATION"
			},
			{
				"name": "learning",
				"salience": 0.028382566,
				"type": "OTHER"
			},
			{
				"name": "Daniel",
				"salience": 0.017581126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03kxzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greater_Boston"
				},
				"name": "Boston Area",
				"salience": 0.013166936,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/Brexit_UK_4c93f.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-02T14:17:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "\" Europe developed from the spoils of Colonialism \" - it did if you're a simple minded American activist and radical journalist in the Boston Area I guess....a little more learning please Daniel",
		"thread_title": "is bed the EU made, now it must lie in it -",
		"title": "",
		"type": "bs",
		"uuid": "f183ee3a424fa975f68df7a11819af8e7455e26f"
	},
	"-KhIbI6RGxKW5LCFVqgK": {
		"author": "Jan Oberg",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-02T18:19:06.479+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.63808966,
				"type": "LOCATION"
			},
			{
				"name": "White Helmets",
				"salience": 0.09270894,
				"type": "ORGANIZATION"
			},
			{
				"name": "White Helmets",
				"salience": 0.0711904,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "governments",
				"salience": 0.009372357,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGOs",
				"salience": 0.0039064996,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0036812846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0035396046,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Denmark",
				"salience": 0.0030540305,
				"type": "LOCATION"
			},
			{
				"name": "Syria Civil Defence",
				"salience": 0.0028479842,
				"type": "OTHER"
			},
			{
				"name": "Avaaz Avaaz",
				"salience": 0.0028456142,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.0027778714,
				"type": "LOCATION"
			},
			{
				"name": "Jeremy Heimans",
				"salience": 0.0024254431,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0021376254,
				"type": "PERSON"
			},
			{
				"name": "somebody",
				"salience": 0.001963788,
				"type": "PERSON"
			},
			{
				"name": "executioners",
				"salience": 0.0018427917,
				"type": "PERSON"
			},
			{
				"name": "James Le Mesurier",
				"salience": 0.0017960833,
				"type": "PERSON"
			},
			{
				"name": "organisations",
				"salience": 0.0017705418,
				"type": "ORGANIZATION"
			},
			{
				"name": "Raed Saleh",
				"salience": 0.0017605479,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027np7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doctor_of_Science"
				},
				"name": "SCD",
				"salience": 0.0017497152,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0017451012,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0016109069,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.0014414948,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b74gj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Arab_Red_Crescent"
				},
				"name": "Syrian Arab Red Crescent",
				"salience": 0.0014069319,
				"type": "ORGANIZATION"
			},
			{
				"name": "war zones",
				"salience": 0.0014066166,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02bkhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scott_Ritter"
				},
				"name": "Scott Ritter",
				"salience": 0.0013344279,
				"type": "PERSON"
			},
			{
				"name": "Civil Defence",
				"salience": 0.0012793278,
				"type": "LOCATION"
			},
			{
				"name": "helmets",
				"salience": 0.0012487008,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "rescue workers",
				"salience": 0.0012394531,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0012207329,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0011819612,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0011272725,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0011272725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "United Kingdom",
				"salience": 0.0010835514,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0010652161,
				"type": "LOCATION"
			},
			{
				"name": "organisation",
				"salience": 0.00096387963,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025szt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/No-fly_zone"
				},
				"name": "No-Fly Zone",
				"salience": 0.00095137785,
				"type": "OTHER"
			},
			{
				"name": "relief organisation",
				"salience": 0.00090469484,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisations",
				"salience": 0.00090469484,
				"type": "ORGANIZATION"
			},
			{
				"name": "civil society organisations",
				"salience": 0.00090469484,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0008916831,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0008916831,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.00088590285,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00087403314,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0008345506,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h3rt8x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_National_Council"
				},
				"name": "Syrian National Council",
				"salience": 0.00078859756,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gytvry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_peacekeeping"
				},
				"name": "Blue Helmet",
				"salience": 0.0007688156,
				"type": "ORGANIZATION"
			},
			{
				"name": "society",
				"salience": 0.00076663145,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0007364298,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.00073244044,
				"type": "PERSON"
			},
			{
				"name": "organisation",
				"salience": 0.000729322,
				"type": "ORGANIZATION"
			},
			{
				"name": "thing",
				"salience": 0.0007269655,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00072373863,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00072269194,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.00072269194,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.00072269194,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.00072269194,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0007135883,
				"type": "PERSON"
			},
			{
				"name": "links",
				"salience": 0.000711928,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ctzb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_people"
				},
				"name": "White",
				"salience": 0.0007072104,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.000697218,
				"type": "LOCATION"
			},
			{
				"name": "Syria Campaign",
				"salience": 0.00066499127,
				"type": "ORGANIZATION"
			},
			{
				"name": "funds",
				"salience": 0.0006535245,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0006535245,
				"type": "OTHER"
			},
			{
				"name": "John Tye",
				"salience": 0.00064267754,
				"type": "PERSON"
			},
			{
				"name": "military officer",
				"salience": 0.00063780433,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.00062953355,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0006037543,
				"type": "LOCATION"
			},
			{
				"name": "no one",
				"salience": 0.0005926571,
				"type": "PERSON"
			},
			{
				"name": "spectrum",
				"salience": 0.000580025,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0005758019,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0005758019,
				"type": "OTHER"
			},
			{
				"name": "relief work",
				"salience": 0.0005758019,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.0005758019,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.0005758019,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05f3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Peace_Prize"
				},
				"name": "Nobel Peace Prize",
				"salience": 0.00056945183,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00056138437,
				"type": "OTHER"
			},
			{
				"name": "International Civil Defence Organisation",
				"salience": 0.000556932,
				"type": "ORGANIZATION"
			},
			{
				"name": "account",
				"salience": 0.00054924405,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0005451376,
				"type": "EVENT"
			},
			{
				"name": "bombs",
				"salience": 0.0005451376,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nny0r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_Signals_Motorcycle_Display_Team"
				},
				"name": "The White Helmets",
				"salience": 0.0005439175,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00054200663,
				"type": "OTHER"
			},
			{
				"name": "volunteers",
				"salience": 0.00052531995,
				"type": "PERSON"
			},
			{
				"name": "website",
				"salience": 0.0005120471,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0005109694,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0005109694,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0005109694,
				"type": "LOCATION"
			},
			{
				"name": "everything",
				"salience": 0.0005109694,
				"type": "OTHER"
			},
			{
				"name": "little",
				"salience": 0.0005109694,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0005109694,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0005109694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.00050230173,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.00050084223,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.00049626327,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.00047205001,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00047205001,
				"type": "OTHER"
			},
			{
				"name": "briefing page",
				"salience": 0.00047205001,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.00046577654,
				"type": "OTHER"
			},
			{
				"name": "Asfari Foundation",
				"salience": 0.0004648897,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.0004541126,
				"type": "OTHER"
			},
			{
				"name": "colour",
				"salience": 0.0004541126,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00042621404,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00042621404,
				"type": "OTHER"
			},
			{
				"name": "harm",
				"salience": 0.00042621404,
				"type": "OTHER"
			},
			{
				"name": "aid budgets",
				"salience": 0.00042621404,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.00042621404,
				"type": "LOCATION"
			},
			{
				"name": "colour",
				"salience": 0.00042621404,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00042246416,
				"type": "OTHER"
			},
			{
				"name": "John Hanrahan",
				"salience": 0.00042175053,
				"type": "PERSON"
			},
			{
				"name": "clients",
				"salience": 0.00041926646,
				"type": "PERSON"
			},
			{
				"name": "illusions",
				"salience": 0.00040656587,
				"type": "OTHER"
			},
			{
				"name": "Right Livelihood Award Foundation",
				"salience": 0.0003798948,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizations",
				"salience": 0.00037245138,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons inspector",
				"salience": 0.0003690642,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0003690642,
				"type": "ORGANIZATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0003690642,
				"type": "PERSON"
			},
			{
				"name": "innocence",
				"salience": 0.0003690642,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0003690642,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0003690642,
				"type": "PERSON"
			},
			{
				"name": "underpinnings",
				"salience": 0.0003690642,
				"type": "OTHER"
			},
			{
				"name": "Helmets",
				"salience": 0.0003470554,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "media appearance",
				"salience": 0.00034355815,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06ztth6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Committee"
				},
				"name": "Nobel Committee",
				"salience": 0.00033864178,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020ly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_defense"
				},
				"name": "Civil Defence",
				"salience": 0.00033556597,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi-Arabia",
				"salience": 0.00033553637,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.00033394055,
				"type": "ORGANIZATION"
			},
			{
				"name": "media reports",
				"salience": 0.0003309637,
				"type": "WORK_OF_ART"
			},
			{
				"name": "uprising",
				"salience": 0.00032299978,
				"type": "EVENT"
			},
			{
				"name": "explanation",
				"salience": 0.0003186157,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.000316581,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00031066436,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00030932794,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0003031455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Holland"
				},
				"name": "Holland",
				"salience": 0.00029668066,
				"type": "LOCATION"
			},
			{
				"name": "Helmets",
				"salience": 0.00029430407,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "US Marine Corps",
				"salience": 0.0002905413,
				"type": "ORGANIZATION"
			},
			{
				"name": "member states",
				"salience": 0.00028699692,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.00028603605,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.00028239837,
				"type": "OTHER"
			},
			{
				"name": "zones",
				"salience": 0.00027591447,
				"type": "LOCATION"
			},
			{
				"name": "time",
				"salience": 0.00026900362,
				"type": "OTHER"
			},
			{
				"name": "Vanessa Beeley",
				"salience": 0.0002645491,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.00026322808,
				"type": "PERSON"
			},
			{
				"name": "James Harf",
				"salience": 0.0002615301,
				"type": "PERSON"
			},
			{
				"name": "news organisations",
				"salience": 0.00026112449,
				"type": "ORGANIZATION"
			},
			{
				"name": "Organisations",
				"salience": 0.00026112449,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0002591244,
				"type": "PERSON"
			},
			{
				"name": "purpose",
				"salience": 0.0002591244,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0002591244,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0002591244,
				"type": "LOCATION"
			},
			{
				"name": "confluence",
				"salience": 0.0002591244,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.0002591244,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0002591244,
				"type": "ORGANIZATION"
			},
			{
				"name": "opinion",
				"salience": 0.00025735612,
				"type": "OTHER"
			},
			{
				"name": "Nagieb Khaja",
				"salience": 0.0002560392,
				"type": "PERSON"
			},
			{
				"name": "contra Find",
				"salience": 0.0002560392,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.00025548838,
				"type": "OTHER"
			},
			{
				"name": "mainstream media articles",
				"salience": 0.00025497234,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.00025251607,
				"type": "OTHER"
			},
			{
				"name": "organisations",
				"salience": 0.0002513754,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisations",
				"salience": 0.0002513754,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisations",
				"salience": 0.0002513754,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00024850914,
				"type": "LOCATION"
			},
			{
				"name": "links",
				"salience": 0.00024850914,
				"type": "OTHER"
			},
			{
				"name": "organisation",
				"salience": 0.00024820725,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00024775742,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.00024775742,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.00023998677,
				"type": "ORGANIZATION"
			},
			{
				"name": "Many",
				"salience": 0.00023858092,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.00023699942,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00023699942,
				"type": "OTHER"
			},
			{
				"name": "security companies",
				"salience": 0.00023699942,
				"type": "ORGANIZATION"
			},
			{
				"name": "prize",
				"salience": 0.00023397352,
				"type": "OTHER"
			},
			{
				"name": "White Helmets A",
				"salience": 0.00023279269,
				"type": "ORGANIZATION"
			},
			{
				"name": "pair",
				"salience": 0.0002308364,
				"type": "OTHER"
			},
			{
				"name": "creation",
				"salience": 0.00022934093,
				"type": "OTHER"
			},
			{
				"name": "bakers",
				"salience": 0.00022894991,
				"type": "PERSON"
			},
			{
				"name": "volunteers",
				"salience": 0.00022894991,
				"type": "PERSON"
			},
			{
				"name": "ICDO",
				"salience": 0.00022714476,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.00022714476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Arab Army",
				"salience": 0.00022714476,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jgd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Argentina"
				},
				"name": "Argentinian",
				"salience": 0.00022714476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00022714476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Gulf",
				"salience": 0.00022714476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01lfy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Copenhagen"
				},
				"name": "Copenhagen",
				"salience": 0.00022714476,
				"type": "LOCATION"
			},
			{
				"name": "human face",
				"salience": 0.00022437357,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00022269544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00022161492,
				"type": "ORGANIZATION"
			},
			{
				"name": "makers",
				"salience": 0.0002207782,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00021780134,
				"type": "EVENT"
			},
			{
				"name": "Christina Lin",
				"salience": 0.00021711871,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.00021614724,
				"type": "OTHER"
			},
			{
				"name": "links",
				"salience": 0.00021614724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_hzr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernard_Kouchner"
				},
				"name": "Bernard Kouchner",
				"salience": 0.00021450923,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02gyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Diplomatic_mission"
				},
				"name": "US Embassy",
				"salience": 0.00021450923,
				"type": "LOCATION"
			},
			{
				"name": "White Helmets The White Helmet Homepage",
				"salience": 0.00021359719,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "White Helmets The Atlantic",
				"salience": 0.00021359719,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "White Helmets The White Helmets",
				"salience": 0.00021359719,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Aleppo Time The White Helmets",
				"salience": 0.00021359719,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "organisation",
				"salience": 0.00021316369,
				"type": "ORGANIZATION"
			},
			{
				"name": "picture",
				"salience": 0.00021122477,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/087vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yugoslavia"
				},
				"name": "Yugoslavia",
				"salience": 0.00021065166,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.00021030553,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.00021030553,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.00021030553,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00021030553,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00021009555,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.00021009555,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00020966935,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.00020459427,
				"type": "OTHER"
			},
			{
				"name": "advocacy",
				"salience": 0.00020333826,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00020120693,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00020120693,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.00020120693,
				"type": "LOCATION"
			},
			{
				"name": "White Helmets Syria",
				"salience": 0.00019928337,
				"type": "LOCATION"
			},
			{
				"name": "some",
				"salience": 0.00019927965,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00019843946,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00019636464,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.00019574615,
				"type": "OTHER"
			},
			{
				"name": "seed money",
				"salience": 0.0001942821,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0001942821,
				"type": "EVENT"
			},
			{
				"name": "league",
				"salience": 0.0001942821,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.0001942821,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0001942821,
				"type": "EVENT"
			},
			{
				"name": "rebels",
				"salience": 0.0001942821,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0001942821,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0001942821,
				"type": "EVENT"
			},
			{
				"name": "agenda",
				"salience": 0.00019414637,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00019346872,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.00019346872,
				"type": "ORGANIZATION"
			},
			{
				"name": "no-fly zone",
				"salience": 0.00018859112,
				"type": "OTHER"
			},
			{
				"name": "peace prize",
				"salience": 0.00018859112,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00018689739,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.000186332,
				"type": "EVENT"
			},
			{
				"name": "Purpose.com",
				"salience": 0.00018499618,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.00018386701,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.000182735,
				"type": "ORGANIZATION"
			},
			{
				"name": "lives",
				"salience": 0.00018166448,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00018166448,
				"type": "PERSON"
			},
			{
				"name": "foundations",
				"salience": 0.00018154952,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00018154952,
				"type": "OTHER"
			},
			{
				"name": "government funds",
				"salience": 0.00018154952,
				"type": "OTHER"
			},
			{
				"name": "White Helmets: War by Way of Deception",
				"salience": 0.000181127,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stereotyping",
				"salience": 0.00017887831,
				"type": "OTHER"
			},
			{
				"name": "Campaign",
				"salience": 0.00017779614,
				"type": "EVENT"
			},
			{
				"name": "campaigner",
				"salience": 0.00017779614,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00017778407,
				"type": "LOCATION"
			},
			{
				"name": "hypothesis",
				"salience": 0.00017685755,
				"type": "OTHER"
			},
			{
				"name": "violation",
				"salience": 0.00017608784,
				"type": "EVENT"
			},
			{
				"name": "security",
				"salience": 0.0001754121,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0001754121,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0001754121,
				"type": "PERSON"
			},
			{
				"name": "tailors",
				"salience": 0.0001754121,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0001754121,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.0001754121,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0001754121,
				"type": "OTHER"
			},
			{
				"name": "rescue team",
				"salience": 0.0001754121,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0001754121,
				"type": "OTHER"
			},
			{
				"name": "murderers",
				"salience": 0.0001754121,
				"type": "OTHER"
			},
			{
				"name": "purposes",
				"salience": 0.00017488145,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.00017462838,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.00017422182,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00017422182,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00017422182,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00017422182,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00016898871,
				"type": "LOCATION"
			},
			{
				"name": "Vanessa Beeley Syria",
				"salience": 0.00016898871,
				"type": "LOCATION"
			},
			{
				"name": "member",
				"salience": 0.00016827307,
				"type": "PERSON"
			},
			{
				"name": "links",
				"salience": 0.00016771664,
				"type": "OTHER"
			},
			{
				"name": "channels government funds",
				"salience": 0.00016771664,
				"type": "OTHER"
			},
			{
				"name": "links",
				"salience": 0.00016771664,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.00016615208,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.00016615208,
				"type": "WORK_OF_ART"
			},
			{
				"name": "company",
				"salience": 0.00016615208,
				"type": "ORGANIZATION"
			},
			{
				"name": "terror",
				"salience": 0.00016615208,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.00016548697,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00016424918,
				"type": "OTHER"
			},
			{
				"name": "world war",
				"salience": 0.00016424918,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/075jp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slobodan_Milo%C5%A1evi%C4%87"
				},
				"name": "Milosevic",
				"salience": 0.00016218,
				"type": "PERSON"
			},
			{
				"name": "guys",
				"salience": 0.00016183108,
				"type": "PERSON"
			},
			{
				"name": "organisations",
				"salience": 0.00015922557,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisation",
				"salience": 0.00015922557,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisations",
				"salience": 0.00015922557,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dv0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_League"
				},
				"name": "Arab League",
				"salience": 0.00015745907,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00015693365,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.00015693365,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.00015693365,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00015693365,
				"type": "ORGANIZATION"
			},
			{
				"name": "conclusion",
				"salience": 0.00015451519,
				"type": "OTHER"
			},
			{
				"name": "entry",
				"salience": 0.00015451519,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00015451519,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.00015415545,
				"type": "WORK_OF_ART"
			},
			{
				"name": "seed funding",
				"salience": 0.00015395026,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.00015395026,
				"type": "OTHER"
			},
			{
				"name": "co-founder",
				"salience": 0.00015256759,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qataris",
				"salience": 0.0001520439,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "pharmacists",
				"salience": 0.00015188592,
				"type": "PERSON"
			},
			{
				"name": "duty",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "walks",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "carpenters",
				"salience": 0.00015188592,
				"type": "PERSON"
			},
			{
				"name": "engineers",
				"salience": 0.00015188592,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.00015188592,
				"type": "PERSON"
			},
			{
				"name": "painters",
				"salience": 0.00015188592,
				"type": "PERSON"
			},
			{
				"name": "representatives",
				"salience": 0.00015188592,
				"type": "PERSON"
			},
			{
				"name": "author mention",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "caution",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "face value",
				"salience": 0.00015188592,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.00015064453,
				"type": "OTHER"
			},
			{
				"name": "extremist groups",
				"salience": 0.00014829572,
				"type": "ORGANIZATION"
			},
			{
				"name": "conflict",
				"salience": 0.00014829572,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.00014829572,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00014829572,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.00014829572,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00014743661,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00014743661,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00014743661,
				"type": "OTHER"
			},
			{
				"name": "militaries",
				"salience": 0.00014743661,
				"type": "ORGANIZATION"
			},
			{
				"name": "violation",
				"salience": 0.00014743661,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00014743661,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.00014743661,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00014743661,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0692b3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Hedges"
				},
				"name": "Chris Hedges",
				"salience": 0.00014652986,
				"type": "PERSON"
			},
			{
				"name": "web movement",
				"salience": 0.00014512094,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00014512094,
				"type": "OTHER"
			},
			{
				"name": "Syria Campaign",
				"salience": 0.00014409726,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0001429029,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00014221993,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00014221993,
				"type": "ORGANIZATION"
			},
			{
				"name": "background",
				"salience": 0.00014193139,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.00014193139,
				"type": "OTHER"
			},
			{
				"name": "film",
				"salience": 0.00014193139,
				"type": "WORK_OF_ART"
			},
			{
				"name": "film",
				"salience": 0.00014193139,
				"type": "WORK_OF_ART"
			},
			{
				"name": "network",
				"salience": 0.00014193139,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.00013984302,
				"type": "PERSON"
			},
			{
				"name": "circles",
				"salience": 0.00013984302,
				"type": "OTHER"
			},
			{
				"name": "arms trade",
				"salience": 0.00013984302,
				"type": "OTHER"
			},
			{
				"name": "MIMAC",
				"salience": 0.00013640083,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00013620252,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.00013620252,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.00013620252,
				"type": "OTHER"
			},
			{
				"name": "strategy consultants",
				"salience": 0.00013620252,
				"type": "PERSON"
			},
			{
				"name": "experiences",
				"salience": 0.00013620252,
				"type": "OTHER"
			},
			{
				"name": "reporter",
				"salience": 0.00013620252,
				"type": "PERSON"
			},
			{
				"name": "Part",
				"salience": 0.00013563226,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.00013563226,
				"type": "ORGANIZATION"
			},
			{
				"name": "team members",
				"salience": 0.00013563226,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.00013431306,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/062zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_relations"
				},
				"name": "PR",
				"salience": 0.00013431306,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00013392263,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01t_55",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_minister"
				},
				"name": "Foreign Ministry",
				"salience": 0.00013333203,
				"type": "ORGANIZATION"
			},
			{
				"name": "oil interests",
				"salience": 0.00013280597,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00013280597,
				"type": "OTHER"
			},
			{
				"name": "intervention",
				"salience": 0.00013280597,
				"type": "EVENT"
			},
			{
				"name": "interests",
				"salience": 0.00013280597,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.00013111671,
				"type": "EVENT"
			},
			{
				"name": "development corporation",
				"salience": 0.00013111671,
				"type": "ORGANIZATION"
			},
			{
				"name": "page",
				"salience": 0.00013111671,
				"type": "OTHER"
			},
			{
				"name": "NGOs",
				"salience": 0.00013111671,
				"type": "ORGANIZATION"
			},
			{
				"name": "opinions",
				"salience": 0.00013111671,
				"type": "OTHER"
			},
			{
				"name": "marketing firms",
				"salience": 0.00013111671,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighting",
				"salience": 0.00013102511,
				"type": "EVENT"
			},
			{
				"name": "NGO",
				"salience": 0.00013102511,
				"type": "ORGANIZATION"
			},
			{
				"name": "Illusions",
				"salience": 0.00013026719,
				"type": "OTHER"
			},
			{
				"name": "Qatari Red Crescent Society",
				"salience": 0.00012942616,
				"type": "ORGANIZATION"
			},
			{
				"name": "No one",
				"salience": 0.00012937354,
				"type": "PERSON"
			},
			{
				"name": "facelift",
				"salience": 0.00012840584,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00012823493,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00012622454,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00012531536,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00012446496,
				"type": "LOCATION"
			},
			{
				"name": "leaders",
				"salience": 0.00012297284,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.00012297284,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00012297284,
				"type": "OTHER"
			},
			{
				"name": "airspace",
				"salience": 0.00012297284,
				"type": "LOCATION"
			},
			{
				"name": "murder",
				"salience": 0.00012297284,
				"type": "EVENT"
			},
			{
				"name": "everywhere",
				"salience": 0.00012297284,
				"type": "LOCATION"
			},
			{
				"name": "causes",
				"salience": 0.00012297284,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00012297284,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.00012297284,
				"type": "OTHER"
			},
			{
				"name": "petition text",
				"salience": 0.00012297284,
				"type": "OTHER"
			},
			{
				"name": "war-agenda",
				"salience": 0.00012297284,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00012297284,
				"type": "OTHER"
			},
			{
				"name": "Mayday Rescue",
				"salience": 0.00012272489,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00012268653,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.00012268653,
				"type": "OTHER"
			},
			{
				"name": "Research",
				"salience": 0.0001203541,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0001203541,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0001203541,
				"type": "WORK_OF_ART"
			},
			{
				"name": "words",
				"salience": 0.0001203541,
				"type": "OTHER"
			},
			{
				"name": "Knowledge",
				"salience": 0.0001203541,
				"type": "OTHER"
			},
			{
				"name": "militarist",
				"salience": 0.0001203541,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0001203541,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.00011989222,
				"type": "OTHER"
			},
			{
				"name": "Helmets",
				"salience": 0.00011958633,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Helmets",
				"salience": 0.00011958633,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "side",
				"salience": 0.00011846373,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.000118380965,
				"type": "OTHER"
			},
			{
				"name": "transparency",
				"salience": 0.000118380965,
				"type": "OTHER"
			},
			{
				"name": "link collection",
				"salience": 0.000118380965,
				"type": "OTHER"
			},
			{
				"name": "favour",
				"salience": 0.000118380965,
				"type": "OTHER"
			},
			{
				"name": "degrees",
				"salience": 0.000118380965,
				"type": "OTHER"
			},
			{
				"name": "favour",
				"salience": 0.000118380965,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.000118380965,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.000118380965,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00011761394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000116820316,
				"type": "LOCATION"
			},
			{
				"name": "The Fund for Investigative Journalism",
				"salience": 0.00011606161,
				"type": "ORGANIZATION"
			},
			{
				"name": "Oscar The Nobel Peace Prize",
				"salience": 0.00011606161,
				"type": "OTHER"
			},
			{
				"name": "organisation",
				"salience": 0.000115954484,
				"type": "ORGANIZATION"
			},
			{
				"name": "defence",
				"salience": 0.00011499337,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00011499337,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.000114285336,
				"type": "ORGANIZATION"
			},
			{
				"name": "goodness",
				"salience": 0.00011187312,
				"type": "OTHER"
			},
			{
				"name": "The Right Livelihood",
				"salience": 0.00011179853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Prize"
				},
				"name": "Nobel",
				"salience": 0.00011179853,
				"type": "ORGANIZATION"
			},
			{
				"name": "White Helmets Purpose",
				"salience": 0.00011179853,
				"type": "OTHER"
			},
			{
				"name": "Syria Civil Defence",
				"salience": 0.00011172777,
				"type": "ORGANIZATION"
			},
			{
				"name": "FAQs Syria Civil Defence",
				"salience": 0.00011172777,
				"type": "EVENT"
			},
			{
				"name": "wars",
				"salience": 0.000111682355,
				"type": "OTHER"
			},
			{
				"name": "consultancy",
				"salience": 0.00011118333,
				"type": "OTHER"
			},
			{
				"name": "Contradiction",
				"salience": 0.00011118333,
				"type": "OTHER"
			},
			{
				"name": "Impact page",
				"salience": 0.00011118333,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00011118333,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.00011118333,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.00011118333,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00011076952,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00011076952,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00011076952,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.00011076952,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.000109214954,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.00010795045,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.00010794416,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alfred_Nobel"
				},
				"name": "Alfred Nobel",
				"salience": 0.00010762386,
				"type": "PERSON"
			},
			{
				"name": "resistance",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "soil",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "petition platform",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.00010647895,
				"type": "PERSON"
			},
			{
				"name": "copy",
				"salience": 0.00010647895,
				"type": "WORK_OF_ART"
			},
			{
				"name": "least",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "song",
				"salience": 0.00010647895,
				"type": "WORK_OF_ART"
			},
			{
				"name": "languages",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00010647895,
				"type": "PERSON"
			},
			{
				"name": "motivation",
				"salience": 0.00010647895,
				"type": "OTHER"
			},
			{
				"name": "shadow world",
				"salience": 0.00010623103,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00010623103,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.00010457462,
				"type": "ORGANIZATION"
			},
			{
				"name": "matters",
				"salience": 0.00010427741,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000103359635,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Isis",
				"salience": 0.000102902675,
				"type": "ORGANIZATION"
			},
			{
				"name": "least",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "criteria",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "movie",
				"salience": 0.0001025029,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stuff",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "networking structure",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "actors",
				"salience": 0.0001025029,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0001025029,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.00010131019,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.00010131019,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00010131019,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00010131019,
				"type": "LOCATION"
			},
			{
				"name": "concrete stories",
				"salience": 0.00010131019,
				"type": "WORK_OF_ART"
			},
			{
				"name": "terrorist",
				"salience": 0.00010131019,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.00010131019,
				"type": "LOCATION"
			},
			{
				"name": "public relations",
				"salience": 0.00010131019,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00010038356,
				"type": "PERSON"
			},
			{
				"name": "all-stars",
				"salience": 0.00010038356,
				"type": "PERSON"
			},
			{
				"name": "Sources",
				"salience": 0.00010038356,
				"type": "OTHER"
			},
			{
				"name": "oil industry",
				"salience": 0.00010038356,
				"type": "OTHER"
			},
			{
				"name": "Analysis",
				"salience": 0.00010038356,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00010038356,
				"type": "OTHER"
			},
			{
				"name": "forefront",
				"salience": 0.00010038356,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00010038356,
				"type": "OTHER"
			},
			{
				"name": "Ark",
				"salience": 0.00010038356,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00010038356,
				"type": "OTHER"
			},
			{
				"name": "conflict transformation",
				"salience": 0.00010038356,
				"type": "EVENT"
			},
			{
				"name": "questions",
				"salience": 0.00009786876,
				"type": "OTHER"
			},
			{
				"name": "Sources",
				"salience": 0.000097234624,
				"type": "OTHER"
			},
			{
				"name": "intensity",
				"salience": 0.0000967139,
				"type": "OTHER"
			},
			{
				"name": "Chemonics",
				"salience": 0.00009594224,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.00009594224,
				"type": "ORGANIZATION"
			},
			{
				"name": "bombing",
				"salience": 0.00009591224,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.00009591224,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00009591224,
				"type": "EVENT"
			},
			{
				"name": "politics",
				"salience": 0.00009578457,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00009508388,
				"type": "OTHER"
			},
			{
				"name": "Asia Times",
				"salience": 0.00009474174,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rockefeller Brothers Foundation",
				"salience": 0.00009474174,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.00009437264,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00009437264,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00009437264,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00009437264,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00009437264,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.00009421419,
				"type": "OTHER"
			},
			{
				"name": "Farouq Habib",
				"salience": 0.00009347125,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09949m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Istanbul"
				},
				"name": "Istanbul",
				"salience": 0.00009347125,
				"type": "LOCATION"
			},
			{
				"name": "leader",
				"salience": 0.00009302658,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Ark",
				"salience": 0.00009270725,
				"type": "LOCATION"
			},
			{
				"name": "displacement",
				"salience": 0.00009261091,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00009220782,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00009192885,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0000908486,
				"type": "OTHER"
			},
			{
				"name": "moderates",
				"salience": 0.000090290814,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.000090017646,
				"type": "OTHER"
			},
			{
				"name": "military operations",
				"salience": 0.00008989782,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00008989782,
				"type": "OTHER"
			},
			{
				"name": "operatives",
				"salience": 0.00008989782,
				"type": "ORGANIZATION"
			},
			{
				"name": "entry",
				"salience": 0.00008955281,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00008934429,
				"type": "LOCATION"
			},
			{
				"name": "bombing state",
				"salience": 0.00008934429,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.00008934429,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.00008934429,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00008934429,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.00008700453,
				"type": "PERSON"
			},
			{
				"name": "bonds",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "marketing jargon",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "stabilisation",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "finance",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "trustees",
				"salience": 0.00008691919,
				"type": "PERSON"
			},
			{
				"name": "emergence",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.00008691919,
				"type": "PERSON"
			},
			{
				"name": "whatever",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.00008691919,
				"type": "EVENT"
			},
			{
				"name": "people power",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "autonomy",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00008691919,
				"type": "LOCATION"
			},
			{
				"name": "pro-freedom",
				"salience": 0.00008691919,
				"type": "OTHER"
			},
			{
				"name": "organisation",
				"salience": 0.00008661145,
				"type": "ORGANIZATION"
			},
			{
				"name": "human rights organisation",
				"salience": 0.00008661145,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisations",
				"salience": 0.00008661145,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisation",
				"salience": 0.00008661145,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00008536465,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00008536465,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.00008536465,
				"type": "ORGANIZATION"
			},
			{
				"name": "Non",
				"salience": 0.000084741674,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.000084110274,
				"type": "OTHER"
			},
			{
				"name": "White Helmets The Guardian",
				"salience": 0.00008381906,
				"type": "ORGANIZATION"
			},
			{
				"name": "conflict zones",
				"salience": 0.000083741696,
				"type": "LOCATION"
			},
			{
				"name": "vision",
				"salience": 0.000083673454,
				"type": "OTHER"
			},
			{
				"name": "rebel",
				"salience": 0.000083047555,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.000083047555,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.000083047555,
				"type": "OTHER"
			},
			{
				"name": "co-optation",
				"salience": 0.000083047555,
				"type": "OTHER"
			},
			{
				"name": "peace guarantee",
				"salience": 0.000083047555,
				"type": "OTHER"
			},
			{
				"name": "co-ordination",
				"salience": 0.000083047555,
				"type": "OTHER"
			},
			{
				"name": "public relations firm",
				"salience": 0.000083047555,
				"type": "ORGANIZATION"
			},
			{
				"name": "co-operation",
				"salience": 0.000083047555,
				"type": "OTHER"
			},
			{
				"name": "Right Livelihood Award",
				"salience": 0.000082704646,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.00008066565,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.00008066565,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.000077943536,
				"type": "OTHER"
			},
			{
				"name": "Washington Star",
				"salience": 0.00007664323,
				"type": "ORGANIZATION"
			},
			{
				"name": "job",
				"salience": 0.00007498051,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00007498051,
				"type": "OTHER"
			},
			{
				"name": "human heart",
				"salience": 0.00007498051,
				"type": "OTHER"
			},
			{
				"name": "harm",
				"salience": 0.00007498051,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.00007498051,
				"type": "OTHER"
			},
			{
				"name": "demonisation",
				"salience": 0.00007498051,
				"type": "OTHER"
			},
			{
				"name": "narratives",
				"salience": 0.00007498051,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.00007498051,
				"type": "PERSON"
			},
			{
				"name": "places",
				"salience": 0.00007498051,
				"type": "LOCATION"
			},
			{
				"name": "most",
				"salience": 0.00007498051,
				"type": "OTHER"
			},
			{
				"name": "TruthDig The",
				"salience": 0.00007406544,
				"type": "ORGANIZATION"
			},
			{
				"name": "arms",
				"salience": 0.00007403533,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00007377688,
				"type": "WORK_OF_ART"
			},
			{
				"name": "The White Helmets Syria Solidarity Movement",
				"salience": 0.000073592935,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Military Intervention",
				"salience": 0.000072239425,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.000071545255,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00007037225,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00006984583,
				"type": "EVENT"
			},
			{
				"name": "wars",
				"salience": 0.00006984583,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00006865924,
				"type": "OTHER"
			},
			{
				"name": "Rick Sterling",
				"salience": 0.00006842152,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00006673464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00006673464,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.00006673464,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.00006630164,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.000065526336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02zt92",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McKinsey_%26_Company"
				},
				"name": "McKinsey & Company",
				"salience": 0.000065526336,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01r2lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Forbes"
				},
				"name": "Forbes",
				"salience": 0.000065526336,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.000065526336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bm97",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Press_International"
				},
				"name": "UPI",
				"salience": 0.000065526336,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.000065526336,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hanrahan Quote",
				"salience": 0.000065526336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.000065526336,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025svyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Arab_Air_Force"
				},
				"name": "Syrian Airforce",
				"salience": 0.000065526336,
				"type": "ORGANIZATION"
			},
			{
				"name": "peace researcher",
				"salience": 0.00006546586,
				"type": "PERSON"
			},
			{
				"name": "sociologist",
				"salience": 0.00006546586,
				"type": "PERSON"
			},
			{
				"name": "few",
				"salience": 0.00006546586,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00006546586,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.00006546586,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.00006546586,
				"type": "WORK_OF_ART"
			},
			{
				"name": "films",
				"salience": 0.00006546586,
				"type": "WORK_OF_ART"
			},
			{
				"name": "humanity",
				"salience": 0.000064923195,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.000064923195,
				"type": "LOCATION"
			},
			{
				"name": "sort",
				"salience": 0.000064923195,
				"type": "OTHER"
			},
			{
				"name": "dissolution",
				"salience": 0.000064923195,
				"type": "EVENT"
			},
			{
				"name": "video debate",
				"salience": 0.000064923195,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.000064923195,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.000064923195,
				"type": "EVENT"
			},
			{
				"name": "incubators",
				"salience": 0.000064923195,
				"type": "LOCATION"
			},
			{
				"name": "babies",
				"salience": 0.000064923195,
				"type": "PERSON"
			},
			{
				"name": "ingredients",
				"salience": 0.000064923195,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.000064923195,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.000064923195,
				"type": "OTHER"
			},
			{
				"name": "fear-mongering",
				"salience": 0.000064923195,
				"type": "OTHER"
			},
			{
				"name": "occasion",
				"salience": 0.000064923195,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03hdbf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trailer_(promotion)"
				},
				"name": "Official Trailer",
				"salience": 0.0000630794,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/027glbp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Jazeera"
				},
				"name": "Al-Jazeera",
				"salience": 0.0000630794,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dblm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Economist"
				},
				"name": "The Economist",
				"salience": 0.0000630794,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0000630794,
				"type": "LOCATION"
			},
			{
				"name": "Mayday Rescue Dutch",
				"salience": 0.0000630794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d07ph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wikipedia"
				},
				"name": "Wikipedia",
				"salience": 0.0000630794,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00006254975,
				"type": "OTHER"
			},
			{
				"name": "no-fly zone",
				"salience": 0.00006254975,
				"type": "OTHER"
			},
			{
				"name": "professionals",
				"salience": 0.000061710925,
				"type": "PERSON"
			},
			{
				"name": "anti-intellectual's",
				"salience": 0.000060933,
				"type": "PERSON"
			},
			{
				"name": "hunch",
				"salience": 0.000060933,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/047yc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kuwait"
				},
				"name": "Kuwaiti",
				"salience": 0.00006076765,
				"type": "LOCATION"
			},
			{
				"name": "narcissism",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "goodness",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "narcissism",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "guard",
				"salience": 0.000060477192,
				"type": "PERSON"
			},
			{
				"name": "experience",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "narcissism",
				"salience": 0.000060477192,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00006025209,
				"type": "EVENT"
			},
			{
				"name": "lives",
				"salience": 0.00006025209,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00006025209,
				"type": "ORGANIZATION"
			},
			{
				"name": "purposes",
				"salience": 0.00006025209,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.000058920865,
				"type": "WORK_OF_ART"
			},
			{
				"name": "regime change",
				"salience": 0.000057783287,
				"type": "EVENT"
			},
			{
				"name": "regime change",
				"salience": 0.000057783287,
				"type": "EVENT"
			},
			{
				"name": "kind",
				"salience": 0.000057188034,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.00005604472,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.000055106506,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.000055106506,
				"type": "WORK_OF_ART"
			},
			{
				"name": "relation",
				"salience": 0.000055106506,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.000055106506,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.000055106506,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.000055106506,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.000055106506,
				"type": "OTHER"
			},
			{
				"name": "texts",
				"salience": 0.00005460245,
				"type": "WORK_OF_ART"
			},
			{
				"name": "freedom",
				"salience": 0.00005460245,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00005460245,
				"type": "OTHER"
			},
			{
				"name": "manufacturing",
				"salience": 0.00005460245,
				"type": "OTHER"
			},
			{
				"name": "manufacturing",
				"salience": 0.00005460245,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.00005460245,
				"type": "OTHER"
			},
			{
				"name": "propagandist",
				"salience": 0.00005460245,
				"type": "PERSON"
			},
			{
				"name": "media coverage",
				"salience": 0.00005460245,
				"type": "OTHER"
			},
			{
				"name": "media coverage",
				"salience": 0.00005460245,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.00005460245,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/054p6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/M%C3%A9decins_Sans_Fronti%C3%A8res"
				},
				"name": "Doctors Without Borders",
				"salience": 0.000054171855,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.000053488966,
				"type": "ORGANIZATION"
			},
			{
				"name": "Syria Policy Hands",
				"salience": 0.000053488966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01f08r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dubai"
				},
				"name": "Dubai",
				"salience": 0.000053488966,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.000053488966,
				"type": "LOCATION"
			},
			{
				"name": "Alistair Harris",
				"salience": 0.000053488966,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.000052170213,
				"type": "OTHER"
			},
			{
				"name": "reality show politics",
				"salience": 0.00005144398,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.0000488986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wordings",
				"salience": 0.0000488986,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.0000488986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "operations",
				"salience": 0.0000488986,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.0000488986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "websites",
				"salience": 0.0000488986,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0000488986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "network",
				"salience": 0.0000488986,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.0000488986,
				"type": "PERSON"
			},
			{
				"name": "images",
				"salience": 0.0000488986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "affairs",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "pockets",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "balance",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "replacement",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.000047278347,
				"type": "LOCATION"
			},
			{
				"name": "phone",
				"salience": 0.000047278347,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "depth",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "attitude",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "pro-bombing",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "B",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "Zeitgeist",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "blamegamer",
				"salience": 0.000047278347,
				"type": "PERSON"
			},
			{
				"name": "summary",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.000047278347,
				"type": "OTHER"
			},
			{
				"name": "Citizens for a Free Kuwait",
				"salience": 0.00004614182,
				"type": "ORGANIZATION"
			},
			{
				"name": "films",
				"salience": 0.000045893234,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Military-Industrial-Media-Academic Complex",
				"salience": 0.0000454011,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.000045172343,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.000045172343,
				"type": "PERSON"
			},
			{
				"name": "marketing",
				"salience": 0.000045172343,
				"type": "OTHER"
			},
			{
				"name": "executive director",
				"salience": 0.000045172343,
				"type": "PERSON"
			},
			{
				"name": "consciousness",
				"salience": 0.000045172343,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.000045172343,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.00004425214,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Denmark",
				"salience": 0.000042981923,
				"type": "LOCATION"
			},
			{
				"name": "CrossTalk",
				"salience": 0.000041120365,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/04fh3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kosovo"
				},
				"name": "Kosovo",
				"salience": 0.000041008774,
				"type": "LOCATION"
			},
			{
				"name": "bakers",
				"salience": 0.00004078424,
				"type": "PERSON"
			},
			{
				"name": "terms",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "tailors",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "I",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "human rights issues",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "weaponization",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "degree",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.00004078424,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00004078424,
				"type": "PERSON"
			},
			{
				"name": "exploitation",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "Substance",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "airstrike",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "homepage",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.00004078424,
				"type": "OTHER"
			},
			{
				"name": "reality check",
				"salience": 0.000040601994,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00003995253,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mehdi Hasan",
				"salience": 0.00003995253,
				"type": "PERSON"
			},
			{
				"name": "American Hill & Knowlton",
				"salience": 0.00003995253,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07tgn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Oxford"
				},
				"name": "Oxford",
				"salience": 0.00003995253,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fhzy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zagreb"
				},
				"name": "Zagreb",
				"salience": 0.00003995253,
				"type": "LOCATION"
			},
			{
				"name": "pro-Assad",
				"salience": 0.000037216476,
				"type": "PERSON"
			},
			{
				"name": "pro-Russia",
				"salience": 0.000037216476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.000035878835,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0143vk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Regime_change"
				},
				"name": "Regime Change",
				"salience": 0.000035558656,
				"type": "OTHER"
			},
			{
				"name": "cats",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "association",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "lobbying",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "manipulators",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "diagram",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "quality",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "priority",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "emotions",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "formulations",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "midst",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.00003531357,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.00003531357,
				"type": "ORGANIZATION"
			},
			{
				"name": "chart secretary-general",
				"salience": 0.00003531357,
				"type": "PERSON"
			},
			{
				"name": "dollars",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "photos",
				"salience": 0.00003531357,
				"type": "WORK_OF_ART"
			},
			{
				"name": "playing",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "Guilt",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "Instrument",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "vain",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "massacres",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.00003531357,
				"type": "OTHER"
			},
			{
				"name": "bombing raids",
				"salience": 0.00003531357,
				"type": "EVENT"
			},
			{
				"name": "Multi-million",
				"salience": 0.00003442884,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0404lvv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marcellus_Formation"
				},
				"name": "Marcellus",
				"salience": 0.00003360119,
				"type": "PERSON"
			},
			{
				"name": "Max Blumenthal",
				"salience": 0.00003305318,
				"type": "PERSON"
			},
			{
				"name": "steps",
				"salience": 0.00003071394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jdx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Albania"
				},
				"name": "Albanians",
				"salience": 0.000029094,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/061jp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pulitzer_Prize"
				},
				"name": "Pulitzer",
				"salience": 0.000029094,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03j9w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamlet"
				},
				"name": "Shakespeare's Hamlet",
				"salience": 0.000029094,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09q7p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kronborg"
				},
				"name": "Kronborg Castle",
				"salience": 0.000029094,
				"type": "LOCATION"
			},
			{
				"name": "Ruder",
				"salience": 0.000029094,
				"type": "PERSON"
			},
			{
				"name": "Finn",
				"salience": 0.000029094,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01pj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Croatia"
				},
				"name": "Croatian",
				"salience": 0.000029094,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0166b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bosnia_and_Herzegovina"
				},
				"name": "Bosnian",
				"salience": 0.000029094,
				"type": "LOCATION"
			},
			{
				"name": "anti-Serb",
				"salience": 0.000029094,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbs",
				"salience": 0.000029094,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazis",
				"salience": 0.000029094,
				"type": "PERSON"
			},
			{
				"name": "Jonathan Gornell Newsmaker",
				"salience": 0.00002509761,
				"type": "PERSON"
			},
			{
				"name": "narratives",
				"salience": 0.000023044006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "II",
				"salience": 0.000021731044,
				"type": "LOCATION"
			},
			{
				"name": "Rick Sterling Seven",
				"salience": 0.000021731044,
				"type": "PERSON"
			},
			{
				"name": "White Helmets Became International Heroes",
				"salience": 0.000021731044,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "The Hamilton Coalition",
				"salience": 0.000021731044,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03vc7n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Open_letter"
				},
				"name": "Open Letter",
				"salience": 0.000021731044,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Patrick Henningsen",
				"salience": 0.000021731044,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.000021731044,
				"type": "ORGANIZATION"
			},
			{
				"name": "Omram",
				"salience": 0.000021731044,
				"type": "PERSON"
			},
			{
				"name": "Eva Bartlett",
				"salience": 0.000021731044,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/white-helmets_566c9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 50.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "15 Shares\n5 8 0 2\nWhile thousands of humanitarian organisations around the world are struggling fiercely with diminishing support from governments and the public, one has achieved a surprising amount of support from Western governments in a surprisingly short period of time and gained a surprising attention from mainstream media and ditto political elites: The Syrian Civil Defence or White Helmets.\nTheir name of course makes you think of the UN’s Blue Helmet and white is the colour of those who should be protected in harm’s way – and the colour of innocence. However, for many years there has been an Argentinian relief organisation with the same name.\nThe SCD or White Helmets counts nearly 3.000 rescue workers who operate in very dangerous areas in rebel-held territories in Syria and claims that it has, in three years, rescued about 70.000 lives according to its Twitter account (or 65 per day).\nContrary to what you might think, it isn’t a Syrian organisation because Syria has its own organisation, incidentally also called Syria Civil Defence, which was established in 1953 and is registered with ICDO, the International Civil Defence Organisation , since 1972.\nThe White Helmets seems to have an annual budget of US$ 30 million and has raised a total support of well over US$ 100 million. And it seems that they operate exclusively in war zones in which the fighting against the Syrian government and the Syrian Arab Army takes place, i.e. in ‘liberated’ areas where hundreds of groups and some 80 countries, mainly NATO members, Gulf states and Saudi-Arabia, operate.\nOn the White Helmets’ briefing page it is stated that “funding for their humanitarian relief work is received from the aid budgets of Japan, Denmark, the Netherlands, the United Kingdom and the United States.”\nHere is how the Foreign Ministry in Copenhagen explains the roughly US$ 9 million to the White helmets from Denmark, a country that bombs in both Iraq and Syria.\nOther civil society and humanitarian organisations inside Syria have not been so fortunate. You’ve probably not heard that much about the Syrian Arab Red Crescent and its work ? How much/little support have they received from Western humanitarian-concerned governments? And in general, civil society organisations in Syria – women, peace, human rights, culture, etc. – have received nothing like US$ 100 million in a few years and no one has such a flashy media appearance as the White Helmets.\nThe White Helmets was started in 2013 by James Le Mesurier who seems to have tried a little of everything everywhere, including the grey zones of special forces and intelligence in virtually all NATO wars, Yugoslavia in particular. He later set up a foundation in Holland to gather the funds. Here is a recent account by Scott Ritter , former US Marine Corps intelligence officer and weapons inspector in Iraq with tremendous knowledge of things Middle East:\n“The organizational underpinnings of the White Helmets can be sourced to a March 2013 meeting in Istanbul between a retired British military officer, James Le Mesurier—who had experience in the murky world of private security companies and the shadowy confluence between national security and intelligence operations and international organizations—and representatives of the Syrian National Council (SNC) and the Qatari Red Crescent Society. Earlier that month, the SNC was given Syria’s seat in the Arab League at a meeting of the league held in Qatar.\nAt that meeting, the SNC assumed Syria’s seat, and the Arab League authorized member states to actively provide support, including arms and ammunition, to the Syrian rebels. The Qataris, working through the SNC, helped assemble for Le Mesurier $300,000 in seed money from Japan, the United States and the United Kingdom for a seven-day course designed to train and equip a 25-person rescue team, recruited by the SNC, for duty in so-called “liberated areas” of Syria. The SNC made available a pair of Syrian activists—Raed Saleh and Farouq Habib—to assist Le Mesurier in this work.\nThe group is – as will be seen below – treated as uncontroversial in virtually all Western mainstream media. However, there is enough material with documentation to merit caution.\nIf you read media reports about the White Helmets and do not see the author mention that this group’s real identity is disputed and functions controversial you can be sure that you are wasting your time with somebody who is politically incredibly naive, or gullible; someone who has not done his or her research or is knowingly part of a deceptive effort serving a one-sided political agenda.\nThe White Helmets definitely is an controversial NGO – at the same time as it is (made) difficult to understand clearly what it really is.\nAnd until the whole picture has been developed, anyone ought to be cautious with taking information about them at face value. So much must be clear given the links below.\nDual purpose?\nThat said, this author has not been on the ground but has studied both the pro- et contra links provided below.\nSome observers draw the conclusion that the White Helmets – Syrian Civil Defence – is purely good guys rescuing lots of people, children in particular. The opposite advocacy claims that, all told, they are part of the terrorist groups, serve Western governments with intelligence and that their backers run political propaganda in their name and that they are simply executioners – murderers with a human face.\nBut does it have to be either/or?\nAn alternative hypothesis could be that the White Helmets is a dual-purposeorganisation. They claim to be ordinary Syrian volunteers who came together around the idea of saving lives and are truly altruistic “bakers, tailors, engineers, pharmacists, painters, carpenters, students and many more, the White Helmets are volunteers from all walks of life.” It could well be that some of them actually are, even a majority.\nThat doesn’t preclude that other elements – not the least those operating outside Syria such as foundations, PR and marketing firms, change organisations, NATO government and NGOs are in it with less noble, war-promoting purposes.\nLink collection pro et contra\nFind below a link collection – long but fascinating in its wealth of information. We bring it as a help to those seriously interested in Syria’s fate and in studying how opinions are being built by means of connected actors in a rather opaque networking structure, in how NGOs have increasingly become Near-governmental organisations and for those who do not want to sound foolish when they discuss these matters.\nFirst some links to how the the White Helmets presents themselves. Second, some mainstream media articles in their favour of and praising it – including some that argue that the White Helmets ought to receive the Nobel Peace Prize (which happens to be nonsense, since they don’t even remotely qualify according to the criteria in Alfred Nobel’s very clear will and the prize is not a general do-good-prize. In addition, it must be doubted that the Nobel Committee will get more persuaded by the White Helmets’ – quite immodest – campaign in favour of their own candidacy).\nThird some links to the comprehensive network of organisations, including governments, that the White Helmets seem to be part of – and it is quite a confusing lot with absolutely no transparency – but quite a few investigations have been carried out.\nAnd fourth and final – the main links to investigative reports and other stuff that are sceptical in various degrees to the first three.\n1. The White Helmets present themselves\nThe Syrian Civil Defence – The White Helmets\nThe White Helmet Homepage\nOn the front page you are asked to sign an appeal for establishing a No-Fly Zone (which would be a violation of international law).\nWikipedia’s entry about the White Helmets\nThe White Helmets’ media FAQs\nSyria Civil Defence on Facebook\nThe White Helmets on Twitter\nNetflix\nOfficial Trailer about White Helmets\nThe Atlantic\nThe makers of the Netflix movie give their background\nMayday Rescue\nDutch foundation supporting the White Helmets\nAccording to its website it channels government funds to the White Helmets: “Syria Civil Defence receives funding (through Mayday Rescue and Chemonics) from the governments of the UK, Holland, Denmark, Germany, Japan, and the USA.”\nChemonics\nA US global development corporation through which government funds for the White Helmets are channelled (according to Mayday Rescue).\nWhite Helmets themselves campaigning for the 2016 or 2017 Nobel Peace Prize\n2. Sources that promote the White Helmets without questioning\nTime\nHow the White Helmets are being hunted in a devastated Aleppo\nTime\nThe White Helmets of Syria\nThe Economist\nThe rise of Syria’s White Helmets\nSyria’s White Helmets\nA film by Danish journalist Nagieb Khaja shown on Al-Jazeera (30 secs into the film one learns that they have saved more than 56.000 lives “since the war began in 2011″ although the White Helmets were formed in 2013).\nNominated for an Oscar\nThe Nobel Peace Prize must go to the White Helmets\nThe Guardian view on the Nobel peace prize: give it to Syria’s White Helmets – Editorial\nSyria’s White Helmets nominated for Nobel Peace Prize\nThe White Helmets get the Right Livelihood Award\nThe Right Livelihood’s motivation – almost a copy of the White Helmets’ own story\n3. Organisations in the network around the White Helmets\nPurpose\nA social movement creation and PR company that allegedly wants to change the world, co-founded by Jeremy Heimans – whose mainstream, politically correct background you see here . Jeremy – of course – began his career with the strategy consultants McKinsey & Company. He also happens to be a co-founder of\nAvaaz\nAvaaz means voice or song in several languages and the organisation is known by millions as a petition platform for many good/progressive causes. Avaaz has some 43 million members around the world and is thus easily the largest NGO in the world.\nAvaaz has also created Purpose.com. Here Jeremy Heimans, co-founder of Avaaz too, speaks to Forbes about his background and what the two companies do.\nAvaaz is very active in promoting a No-Fly Zone in Syria which it explains in a petition text with these words: “Let’s build a resounding global call to Obama and other leaders to stand up to Putin and Assad’s terror. This might be our last, best chance to help end this mass murder of defenceless children. Add your name.”\nThe sad thing is that it has learnt nothing from its own campaign for a No-Fly Zone in Libya. John Hanrahan is a former executive director of The Fund for Investigative Journalism and reporter for The Washington Post, The Washington Star, UPI and other news organisations has made this extremely interesting analysis about how odd it is that Avaaz maintains an interventionist war-agenda in spite of earlier experiences and resistance even by high-ranking militaries.\nHanrahan Quote: s Avaaz’s campaign director, former State Department official John Tye, “that Avaaz shows 54,000 members in Syria in a population of 23 million – which means that even if every Avaaz member supported a no-fly zone, this would still mean that only one of every 426 Syrians had “voted” for one.\nAvaaz spearheads – at least in this matter – an extreme militarist policy while “Avaaz is a global web movement to bring people-powered politics to decision-making everywhere”. Which people want a No-Fly Zone in Syria? Do they know it’s a violation of a sovereign state’s airspace, of international law? That it would embolden every terrorist on Syrian soil because they would get rid of the Syrian Airforce as their enemy? That it continued into regime change in both Iraq and Libya?\nMany questions unanswered by this peculiar “people power” organisation, more militarist than governments!\nBut back to Purpose.com and one of its important clients:\nThe Syria Campaign – home\nThey maintain on their website that “The Syria Campaign is fiercely independent and has accepted no money from governments, corporations or anyone directly involved in the Syrian conflict. This allows us full autonomy to advocate for whatever is needed to save lives.” But they also say that they have accepted funds from the Asfari Foundation and the Rockefeller Brothers Foundation and other anonymous donors.\nThe Syria Campaign also states that it is only pro-human rights and pro-freedom and takes no side. But they explain the conflict in these words:\n“The regime of Bashar al-Assad is responsible for crushing a peaceful uprising that has led to the deaths of over 450,000 people, the displacement of over 12 million – half the country – and the emergence of violent, extremist groups like Isis.\nToday the fighting in Syria has given way to a world war with more than eighty countries involved on all sides.\nThe majority of Syrians want neither Assad nor Isis. They want an end to the violence and a democratic Syria.\nWhat is happening in Syria could be happening to any of us. No one is free until we’re all free.”\nI would characterise such a presentation as side-taking wrapped in substance-free marketing jargon; a very politicised statement wearing only black-and-white.\nAbout the Syria Campaign\nWhat the Syria Campaign is proud of: Impact page\nThe Syria Campaign seeks all-stars senior campaigner and “You don’t need to know anything about Syria”\nThe Syria Campaign on Facebook\nThe Syria Campaign on Twitter\nAnalysis, Research and Knowledge (Ark)\nA private company, headquartered in Dubai, that describes itself as “a research, conflict transformation and stabilisation consultancy”.\nIn Syria “Ark has been at the forefront of the response to the conflict … for the past five years”. One of its two team members, Alistair Harris is described here advocating two years ago that “moderates” should be armed to fight ISIS and not only in Iraq but also in Syria.\nThe British-based Asfari Foundation for change\nWhite Helmets, according to their website, received seed funding came from the Asfari Foundation – trustees of which are heavily related to the oil industry and corporate finance. The Asfari Foundation’s bonds with the Syria Campaign is dealt with here .\n4. Sources raising investigation-based questions about the White Helmets\nVanessa Beeley\nSyria’s White Helmets: War by Way of Deception – Part I\nScott Ritter at TruthDig\nThe ‘White Helmets’ and the Inherent Contradiction of America’s Syria Policy\nHands off Syria\nThe White Helmets – al-Qaeda with a facelift (video)\nRick Sterling\nThe “White Helmets” Controversy\nVanessa Beeley\nWho are Syria’s White Helmets?\nVanessa Beeley\nThe real Syrian Civil Defence\nChristina Lin, Asia Times\nWhite Helmets: Instrument of regime change in Syria?\nJonathan Gornell\nNewsmaker: The White Helmets\nSyria Solidarity Movement\nIts list of humanitarian/human rights organisation that are pushing for war on Syria and its government\nOpen Letter from The Hamilton Coalition To Stop War\nWhite Helmets should NOT be Nominated for Nobel Peace Prize\nMax Blumenthal\nInside the shadowy public relation firm that is lobbying for regime change in Syria (I)\nMax Blumenthal\nHow the White Helmets Became International Heroes While Pushing U.S. Military Intervention and Regime Change in Syria (II)\nRick Sterling\nSeven steps of highly effective manipulators\nThe article contains this diagram:\n21st Century Wire\nCrossTalk: ‘White Helmets, Really?’ with Vanessa Beeley, Eva Bartlett & Patrick Henningsen (video)\nRussia Today\nMulti-million funded – can’t be independent\nGeneral reasons for concern about the real identity of the White Helmets\nHere are some of the reasons – numbers not indicative of priority:\n1. Huge funding by NATO/EU countries which are militarily involved.\n2. A degree of political lobbying – a very specific explanation of the conflict and how it started which points to a no-fly zone, weaponization of human rights issues and speaks strongly against the Syrian government and Russia and very critically of the UN – that is extremely unusual for a purely humanitarian organisation.\n3. Incredibly advanced public relation in terms of very professional websites, videos and PR strategy dropping the right stories and images at the right time – quite unique for a group of “bakers, tailors and students” etc..\n“Omram rescued from a Russian airstrike” – From the White Helmets’ homepage.\n4. Too professional wordings and images, too much playing to (exploitation of) emotions, too catchy smart formulations again and again; in short, lacking every sense of genuine local quality. Too many children – and cats – in the images speaking to an audience with little politically consciousness but surely a good heart. In short, populist marketing also in the sense of conveying the message: Look how good we are and how evil everybody else are.\n5. Guilt by association: If the White Helmets is a 100% humanitarian first responder organisation it must be extremely naive in ignoring that its integrity, credibility and noble purposes is put at risk with the specific network of organisations and governments that it has chosen to seek support from.\n6. Substance versus public relation: how does a humanitarian organisation justify that millions of dollars are spent on self-promoting public relation rather than on saving more lives in such a horrific war? And taking so many photos and shoot films of its own work in the midst of massacres and bombing raids?\n7. It’s very difficult to discern who actually manages the White Helmets in general and in terms of day-to-day operations. One looks in vain for something like an organisational chart secretary-general, board, executive director (although one is mentioned, Raed Saleh, whom the US has on one occasion actually denied entry into the US).\n8. How come that such an innovative organisation seems to have been started in circles that have to do with oil interests, British intelligence, mercenary/military operations and interventionist/bombing countries?\n9. How come it works only in rebel/terrorist/liberated areas? Could it do that without co-operation or co-ordination with some of these groups? It has been stated – naively – by the Right Livelihood Award Foundation that their vision is to operate also on government-controlled territory and later be a leader in re-building a new democratic post-war Syria. However, why should the sovereign state of Syria’s legitimate government accept a foreign-based and -financed civil defence territory there when it has had its own since 1953?\nPerhaps we should not be that surprised?\nShould we be surprised that humanitarian workers are involved in “something else” and are not exclusively devoted to doing no harm and doing good for humanity?\nNot really. I’ve met that sort of people and organisations during the dissolution of Yugoslavia in the 1990s, among other places at the US Embassy in Zagreb where the humanitarian section people, most likely CIA operatives, after some talk with me about helping the people switched to talk about how good it would be if president Milosevic was killed.\nAre humanitarian organisations – like most other NGOs today – highly or completely dependent on governments? Yes, most are. And they should therefore always be checked for possible moral corruption and co-optation. Many are no longer Non- but Near-governmental and behave, at minimum, politically correct or serve/promote the interests of their governments one way or the other.\nWasn’t Doctors Without Borders started by Bernard Kouchner who advocated military humanitarian intervention as an idea, did the dirty job for NATO in Kosovo and morally advocated the bombing of Libya as a “peace guarantee”? Here an interesting video debate with him at Oxford by Mehdi Hasan.\nShould it be so surprising that – even liberal, democratic – governments propagandise, construct concrete stories to appeal to the human heart in us all (for a good cause) and that they regularly lie, do fear-mongering, use stereotyping and demonisation, present black-and-white narratives – all of which serve their elites’ interests and may not always be that noble in reality?\nThink of the ugly shadow world of the global arms trade in which virtually all governments take part in?\nOf course not. No wars would be possible without one of more of these ingredients.\nThink of the – invented – story about the Iraqi soldiers who kicked out babies of incubators in Kuwait city – all invented as part of the Citizens for a Free Kuwait public relations campaign which was run by American Hill & Knowlton for the Kuwaiti government.\nOr, remember James Harf of the US public relations firm, Ruder and Finn , who in 1991 was hired by the Croatian and Bosnian governments as well as by the Kosovo-Albanians to create and promote an anti-Serb attitude in the Western media?\nSays Harf “We were able to equate Serbs to Nazis in public opinion…” Some kind of balance or truth didn’t interest him: “We are professionals. We have got a job to do and we do it.”\nIf there is anything new in this field since the early 1990s it is the spectrum, the depth, the money and the intensity with which public opinion is being deceived about war and peace – that war today is peace and peace is preserved by violence. And the de facto replacement of knowledge and texts by purpose-driven, mediatized and emotionalised “narratives” and images and films – right down on you phone and into your mind.\nIn summary: Illusions about our goodness that feed social narcissism and the MIMAC\nI do not believe that I know exactly what the whole story and the truth is about the White Helmets. But I know that quite a few things don’t feel right.\nAs a sociologist and peace researcher with four decades of academic and practical experience of global affairs and work in conflict zones, the word spoken by the guard Marcellus in Shakespeare’s Hamlet at Kronborg Castle in my native Denmark come to mind: “There is something rotten in the state…” not only in the bombing state of Denmark (that supports the White Helmets) but also in the state of the – free – media coverage of conflicts and wars.\nIf, thus, you are generally sceptical of Western media coverage of wars fought by the West and specifically of the story of the White Helmets as a purely brave humanitarian organisation – are you then automatically pro-Assad, pro-Russia or pro-bombing? If you are critical to A, must you automatically endorse everything B or C does?\nGiven the “Zeitgeist” of these times, my hunch is that the anti-intellectual’s, the propagandist’s and the blamegamer’s answer is a roaring “Yes!” Personally, I couldn’t care less but there is reason to worry about the fact that our media are not free to take up the issues dealt with here.\nPulitzer prize winner, Chris Hedges, talks about “the incessant manufacturing of illusions that feed social narcissism.” The – unwinnable – wars the West fights with the illusory ideology of spreading goodness, democracy, freedom and peace as well as the alleged good role of the White Helmets in it is little else but an expression of such an incessant manufacturing of illusions that feed social narcissism of the many while filling the pockets of the few in the Military-Industrial-Media-Academic Complex (MIMAC).\nIt’s time to give reality show politics and media a reality check. But who can and who will? And who dares now everything will get worse after November 8?",
		"thread_title": "How Grey are the White Helmets and Their Backers?",
		"title": "How Grey are the White Helmets and Their Backers?",
		"type": "bs",
		"uuid": "f0e56581ec0f538b1a9ab0e28347905d412ce709"
	},
	"-KhIbIJAVhmC6nLMKp4J": {
		"author": "Kim Petersen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-02T18:25:52.607+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.34407464,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "Federal Bureau of Investigation",
				"salience": 0.23472366,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.08817328,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.057193045,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.026608454,
				"type": "PERSON"
			},
			{
				"name": "inquiry",
				"salience": 0.017546782,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.015096266,
				"type": "ORGANIZATION"
			},
			{
				"name": "associates",
				"salience": 0.012800471,
				"type": "PERSON"
			},
			{
				"name": "email practices",
				"salience": 0.012614222,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.012614222,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.010935698,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.010935698,
				"type": "OTHER"
			},
			{
				"name": "aide",
				"salience": 0.010935698,
				"type": "PERSON"
			},
			{
				"name": "inquiry",
				"salience": 0.009014071,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.006829848,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.006750269,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b_8h7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FireEye"
				},
				"name": "FireEye",
				"salience": 0.005916108,
				"type": "ORGANIZATION"
			},
			{
				"name": "server",
				"salience": 0.0055268016,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0y4zr4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robby_Mook"
				},
				"name": "Robby Mook",
				"salience": 0.0053435094,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.004644988,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Much",
				"salience": 0.00413777,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0041040475,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0034402516,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0031987098,
				"type": "EVENT"
			},
			{
				"name": "businesses",
				"salience": 0.002668923,
				"type": "ORGANIZATION"
			},
			{
				"name": "allegations",
				"salience": 0.002668923,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.002668923,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0023115152,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0023115152,
				"type": "OTHER"
			},
			{
				"name": "inquiries",
				"salience": 0.0022439025,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.0021602358,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hope Hicks",
				"salience": 0.0021469689,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.0020365077,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0019958506,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0018720382,
				"type": "OTHER"
			},
			{
				"name": "dealings",
				"salience": 0.0017272561,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.0016927653,
				"type": "EVENT"
			},
			{
				"name": "Things",
				"salience": 0.0016212177,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0016212177,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.0015677398,
				"type": "PERSON"
			},
			{
				"name": "announcement",
				"salience": 0.0015607419,
				"type": "EVENT"
			},
			{
				"name": "confidence",
				"salience": 0.0015607419,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0015607419,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0015607419,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.0015343875,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0015285048,
				"type": "PERSON"
			},
			{
				"name": "connections",
				"salience": 0.0015285048,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0014604874,
				"type": "ORGANIZATION"
			},
			{
				"name": "computers",
				"salience": 0.0014604874,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "information",
				"salience": 0.0014356573,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0014356573,
				"type": "OTHER"
			},
			{
				"name": "contacts",
				"salience": 0.001323667,
				"type": "OTHER"
			},
			{
				"name": "commerce",
				"salience": 0.001323667,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0013069959,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0012711555,
				"type": "PERSON"
			},
			{
				"name": "email server",
				"salience": 0.0012647563,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0012638733,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0011721342,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026s38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slate_(magazine)"
				},
				"name": "Slate",
				"salience": 0.0011685984,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0011127533,
				"type": "LOCATION"
			},
			{
				"name": "company",
				"salience": 0.0010638447,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0009980963,
				"type": "PERSON"
			},
			{
				"name": "Why Clinton's Policies Look Like a Death Sentence",
				"salience": 0.0009980963,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.0009980963,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.0009971757,
				"type": "OTHER"
			},
			{
				"name": "hotel marketing material",
				"salience": 0.0009889152,
				"type": "OTHER"
			},
			{
				"name": "connection attempts",
				"salience": 0.0009889152,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.00092123466,
				"type": "ORGANIZATION"
			},
			{
				"name": "everything",
				"salience": 0.00091648026,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0008317953,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.000814842,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0435ld",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_Corrupt_Practices_Act"
				},
				"name": "Foreign Corrupt Practices Act",
				"salience": 0.000814842,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0007764274,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.0007449475,
				"type": "EVENT"
			},
			{
				"name": "link",
				"salience": 0.00072027545,
				"type": "OTHER"
			},
			{
				"name": "infection",
				"salience": 0.00072027545,
				"type": "OTHER"
			},
			{
				"name": "hacking",
				"salience": 0.00072027545,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.00072027545,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.00072027545,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.00072027545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ncdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Trump_Organization"
				},
				"name": "Trump Organization",
				"salience": 0.0007029688,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/037ppp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alfa-Bank"
				},
				"name": "Alfa Bank",
				"salience": 0.00069199264,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.00062479934,
				"type": "LOCATION"
			},
			{
				"name": "organizations",
				"salience": 0.0006213798,
				"type": "ORGANIZATION"
			},
			{
				"name": "records",
				"salience": 0.0006213798,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0006031123,
				"type": "OTHER"
			},
			{
				"name": "foreign policy stance",
				"salience": 0.00057328196,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0005380595,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0005380595,
				"type": "ORGANIZATION"
			},
			{
				"name": "focus",
				"salience": 0.0005380595,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0005380595,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0005380595,
				"type": "PERSON"
			},
			{
				"name": "computer scientists",
				"salience": 0.0005380595,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.00051797304,
				"type": "PERSON"
			},
			{
				"name": "pro-Russia",
				"salience": 0.00033115296,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary-FBI_4ccfb.jpg",
		"ord_in_thread": "0",
		"participants_count": "2",
		"published": "2016-11-02T02:00:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 7.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "23 Shares\n4 18 0 1\nA top aide to Hillary Clinton urged the FBI on Tuesday to disclose what it knows about any ties between Donald Trump and Russia, accusing the agency of unfairly publicizing its inquiry into Clinton's email practices while staying quiet about the Republican presidential candidate.\nThe Federal Bureau of Investigation opened a preliminary inquiry in recent months into allegations that Trump or his associates might have had questionable dealings with Russian people or businesses, but found no evidence to warrant opening a full investigation, according to sources familiar with the matter. The agency has not publicly discussed the probe.\nA week before Election Day, the Clinton campaign was trying to contain damage from the announcement by FBI Director James Comey on Friday that his agency was looking into newly discovered emails that might relate to Clinton's use of a private server while she was secretary of state.\nClinton has voiced confidence the FBI will not find anything problematic.\nClinton campaign manager Robby Mook questioned why the FBI director had not released any information about the agency's Russia inquiries.\nMORE... What will Hillary Clinton do for India? Not Much and Here's Why Clinton's Policies Look Like a Death Sentence for Americans 10 Things to Expect with a Hillary Clinton Presidency Hillary Clinton must be indicted \"If you're in the business of releasing information about investigations on presidential candidates, release everything you have on Donald Trump. Release the information on his connections to the Russians,\" Mook said on CNN.\nThe FBI inquiry reviewed allegations that Trump or his associates might have violated the Foreign Corrupt Practices Act or engaged in contacts or commerce with people in Russia who are subject to U.S. or international financial sanctions.\nThe U.S. government has blamed Russia for cyber attacks on Democratic Party organizations. Democrats criticize Trump for taking what they say is a pro-Russia foreign policy stance.\nRussia's possible role in the campaign again came into focus when online magazine Slate said a group of computer scientists had been alarmed by records showing thousands of apparent connection attempts between an email server operated on behalf of the Trump Organization and computers inside a Russian company, Alfa Bank in Moscow.\nTrump campaign spokeswoman Hope Hicks said the server, which had been used to send out hotel marketing material, had been dormant for years.\nProminent U.S. cyber security company FireEye said it had been hired by Alfa Bank to investigate the records and had been granted access to the bank’s systems in Moscow to look for evidence of any relationship with Trump’s company or any signs of hacking or infection. FireEye said so far it had found no emails being sent back and forth or any other link.",
		"thread_title": "Top Aide to Hillary Clinton Urges the FBI to Disclose what it Knows about Trump's Russia Ties",
		"title": "Top Aide to Hillary Clinton Urges the FBI to Disclose what it Knows about Trump's Russia Ties",
		"type": "bs",
		"uuid": "6adb24b68e6aed2a8714ec173fd505cba931e14e"
	},
	"-KhIbIRl-6zoUZY9KSB_": {
		"author": "Orang kiyani",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-02T18:25:52.615+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.5762774,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.19776006,
				"type": "OTHER"
			},
			{
				"name": "misdeeds",
				"salience": 0.050562635,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.04874914,
				"type": "EVENT"
			},
			{
				"name": "lies",
				"salience": 0.04261918,
				"type": "OTHER"
			},
			{
				"name": "clan",
				"salience": 0.041587457,
				"type": "PERSON"
			},
			{
				"name": "card",
				"salience": 0.022973906,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.01947024,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary-FBI_4ccfb.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-02T12:49:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "It seems the only way left for Hillary Clinton camp to cover her lies and misdeeds of Clinton's clan, is to use the misleading and false Russian's card!",
		"thread_title": "Top Aide to Hillary Clinton Urges the FBI to Disclose what it Knows about Trump's Russia Ties",
		"title": "",
		"type": "bs",
		"uuid": "3b2e6ca67ea2c0ea8d8338d368437f9aa5ae732c"
	},
	"-KhIbIlYBT9B23NdYPGb": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-02T18:38:55.076+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.18689609,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranians",
				"salience": 0.13795848,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.09440759,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.038140934,
				"type": "PERSON"
			},
			{
				"name": "beauty products",
				"salience": 0.03045992,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.022393646,
				"type": "OTHER"
			},
			{
				"name": "earnings",
				"salience": 0.020701637,
				"type": "OTHER"
			},
			{
				"name": "counterparts",
				"salience": 0.020701637,
				"type": "PERSON"
			},
			{
				"name": "Perfumery Importers",
				"salience": 0.020472376,
				"type": "ORGANIZATION"
			},
			{
				"name": "Toiletries",
				"salience": 0.02044334,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.018706067,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.015114778,
				"type": "LOCATION"
			},
			{
				"name": "cosmetics",
				"salience": 0.014134278,
				"type": "OTHER"
			},
			{
				"name": "income",
				"salience": 0.012933558,
				"type": "OTHER"
			},
			{
				"name": "beauty products market",
				"salience": 0.011483371,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.010703728,
				"type": "LOCATION"
			},
			{
				"name": "products",
				"salience": 0.010120913,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "data",
				"salience": 0.0095852325,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0095852325,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.008231393,
				"type": "LOCATION"
			},
			{
				"name": "Iranian Association of Cosmetics",
				"salience": 0.007395666,
				"type": "ORGANIZATION"
			},
			{
				"name": "products",
				"salience": 0.006461687,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Toiletries",
				"salience": 0.0061570643,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06sx5v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hassan_Rouhani"
				},
				"name": "Rouhani",
				"salience": 0.005989279,
				"type": "PERSON"
			},
			{
				"name": "cosmetics",
				"salience": 0.005835471,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.005377692,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0051166285,
				"type": "LOCATION"
			},
			{
				"name": "index",
				"salience": 0.0050923354,
				"type": "OTHER"
			},
			{
				"name": "spending",
				"salience": 0.0050923354,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.004762071,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.0047379625,
				"type": "OTHER"
			},
			{
				"name": "contraband products",
				"salience": 0.0045333183,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "consumers",
				"salience": 0.0043775453,
				"type": "PERSON"
			},
			{
				"name": "average",
				"salience": 0.0043775453,
				"type": "OTHER"
			},
			{
				"name": "products",
				"salience": 0.004364324,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "products",
				"salience": 0.004364324,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "consumer",
				"salience": 0.004268061,
				"type": "PERSON"
			},
			{
				"name": "turnover",
				"salience": 0.003952978,
				"type": "OTHER"
			},
			{
				"name": "cosmetics",
				"salience": 0.003941037,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "beauty products",
				"salience": 0.0037017558,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "portal",
				"salience": 0.0034234656,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0034234656,
				"type": "OTHER"
			},
			{
				"name": "Oral and Maxillofacial Surgeons' Association",
				"salience": 0.0034072232,
				"type": "ORGANIZATION"
			},
			{
				"name": "figure",
				"salience": 0.003229982,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.003199354,
				"type": "OTHER"
			},
			{
				"name": "spending",
				"salience": 0.0031469637,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.0030703603,
				"type": "OTHER"
			},
			{
				"name": "income",
				"salience": 0.0030575192,
				"type": "OTHER"
			},
			{
				"name": "income",
				"salience": 0.0030575192,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europeans",
				"salience": 0.0029720897,
				"type": "PERSON"
			},
			{
				"name": "household average",
				"salience": 0.002955836,
				"type": "OTHER"
			},
			{
				"name": "earnings",
				"salience": 0.002955836,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.002955836,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.002955836,
				"type": "LOCATION"
			},
			{
				"name": "price",
				"salience": 0.002955836,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.002955836,
				"type": "OTHER"
			},
			{
				"name": "Statista",
				"salience": 0.0029177652,
				"type": "ORGANIZATION"
			},
			{
				"name": "surgeons",
				"salience": 0.002804076,
				"type": "PERSON"
			},
			{
				"name": "port",
				"salience": 0.0027724288,
				"type": "OTHER"
			},
			{
				"name": "indebtedness",
				"salience": 0.0027724288,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.0026956564,
				"type": "LOCATION"
			},
			{
				"name": "earnings",
				"salience": 0.0025068757,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0025019126,
				"type": "LOCATION"
			},
			{
				"name": "deindustrialization",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "dependence",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "Nowruz",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "Recipe",
				"salience": 0.0024008972,
				"type": "WORK_OF_ART"
			},
			{
				"name": "drills",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "warships berth",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "tax",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0024008972,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00231132,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00231132,
				"type": "OTHER"
			},
			{
				"name": "parameters",
				"salience": 0.00231132,
				"type": "OTHER"
			},
			{
				"name": "income",
				"salience": 0.0022844481,
				"type": "OTHER"
			},
			{
				"name": "beauty surgeries",
				"salience": 0.002162825,
				"type": "EVENT"
			},
			{
				"name": "figure",
				"salience": 0.0021260479,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nshxq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shahrvand"
				},
				"name": "Shahrvand",
				"salience": 0.0021078228,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0021078228,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/032f6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_language"
				},
				"name": "Persian",
				"salience": 0.0021078228,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.0020473565,
				"type": "LOCATION"
			},
			{
				"name": "beauty products",
				"salience": 0.002014826,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "products",
				"salience": 0.002014826,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "opinion polls",
				"salience": 0.0019601758,
				"type": "OTHER"
			},
			{
				"name": "Gallup Incorporation",
				"salience": 0.001882401,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0017836316,
				"type": "LOCATION"
			},
			{
				"name": "share",
				"salience": 0.0017578886,
				"type": "OTHER"
			},
			{
				"name": "household expenditure",
				"salience": 0.0016911036,
				"type": "OTHER"
			},
			{
				"name": "portion",
				"salience": 0.0016911036,
				"type": "OTHER"
			},
			{
				"name": "body contouring",
				"salience": 0.0016911036,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italians",
				"salience": 0.001518101,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.0014779893,
				"type": "LOCATION"
			},
			{
				"name": "cosmetics market",
				"salience": 0.0014766258,
				"type": "OTHER"
			},
			{
				"name": "world book market",
				"salience": 0.0014766258,
				"type": "OTHER"
			},
			{
				"name": "registration system",
				"salience": 0.0014643922,
				"type": "OTHER"
			},
			{
				"name": "pursuits",
				"salience": 0.0014643922,
				"type": "OTHER"
			},
			{
				"name": "rejuvenation",
				"salience": 0.0014643922,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0014643922,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0014643922,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.0014643922,
				"type": "OTHER"
			},
			{
				"name": "recreation",
				"salience": 0.0014643922,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0014643922,
				"type": "OTHER"
			},
			{
				"name": "share",
				"salience": 0.0014534437,
				"type": "OTHER"
			},
			{
				"name": "Data",
				"salience": 0.0014341291,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0014277241,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spain",
				"salience": 0.0014228255,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0013641589,
				"type": "LOCATION"
			},
			{
				"name": "cosmetics",
				"salience": 0.0013590838,
				"type": "OTHER"
			},
			{
				"name": "surgeries",
				"salience": 0.0013191331,
				"type": "EVENT"
			},
			{
				"name": "cinema turnover",
				"salience": 0.001231704,
				"type": "OTHER"
			},
			{
				"name": "cinema",
				"salience": 0.001231704,
				"type": "WORK_OF_ART"
			},
			{
				"name": "books",
				"salience": 0.001231704,
				"type": "WORK_OF_ART"
			},
			{
				"name": "businesses",
				"salience": 0.001231704,
				"type": "ORGANIZATION"
			},
			{
				"name": "business",
				"salience": 0.001231704,
				"type": "OTHER"
			},
			{
				"name": "expenses",
				"salience": 0.001231704,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.001210752,
				"type": "OTHER"
			},
			{
				"name": "beauty product dealers",
				"salience": 0.0010665533,
				"type": "ORGANIZATION"
			},
			{
				"name": "Culture",
				"salience": 0.0010665533,
				"type": "OTHER"
			},
			{
				"name": "film industry",
				"salience": 0.0010665533,
				"type": "OTHER"
			},
			{
				"name": "Statistics Center",
				"salience": 0.001040924,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0010190614,
				"type": "LOCATION"
			},
			{
				"name": "consumers",
				"salience": 0.0010190614,
				"type": "PERSON"
			},
			{
				"name": "Surgery",
				"salience": 0.00092487613,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.00092010153,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01q82",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_bank"
				},
				"name": "Central Bank",
				"salience": 0.0009013442,
				"type": "ORGANIZATION"
			},
			{
				"name": "percentage",
				"salience": 0.0008488762,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0007967177,
				"type": "OTHER"
			},
			{
				"name": "world population",
				"salience": 0.0007967177,
				"type": "PERSON"
			},
			{
				"name": "fortunes",
				"salience": 0.00078667694,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00077676267,
				"type": "PERSON"
			},
			{
				"name": "calculations",
				"salience": 0.0006670983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01chg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bollywood"
				},
				"name": "Bollywood",
				"salience": 0.00065642997,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.00065642997,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Beauty_Products_7acf7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "11 Shares\n1 9 0 1\nIranians spend 4.5% of their annual earnings on beauty products, three times more than their European counterparts, as per official statistics. The Germans spend 1.5% and the French and British 1.7% of their income every year on cosmetics.\nAccording to data from the Iranian Association of Cosmetics, Toiletries and Perfumery Importers, Iran accounts for $2.1 billion of the Middle East’s $7.2 billion beauty products market–second in the region after Saudi Arabia, the Persian daily Shahrvand reported.\nIt is said that there are 15 million consumers for cosmetic products in Iran. Dividing the annual turnover by this number shows that each consumer spends $140 on cosmetics per year. Germany’s online statistics portal (Statista) states that the per capita cosmetic spending in Europe is €90 ($99) on average. The index is $173.5 in Germany, $176 in France, $177 in Britain, $169 in Italy and $150 in Spain.\nIf the raw figures alone are taken, Iranians spend less than Europeans on make-up products. But the results change as other parameters such as the price of products and household average earnings are taken into account as well.\nAs confirmed by the Iranian Association of Cosmetics, Toiletries and Perfumery Importers, 70% of the cosmetics in the market are smuggled into the country and often sold at a lower price than they would be if they were legally imported, not to mention the health risks contraband products are likely to pose. Europeans on the other hand pay the real price of the products which includes tax and are thus more expensive.\nMORE... Pakistani warships berth in Iran’s port as part of amicable relations, joint drills President Rouhani’s “open-door” economic policy: Recipe for indebtedness, deindustrialization and dependence Iranian Nowruz: A new day has come! Moreover, the spending has to be measured as compared to the average earnings. Based on Gallup Incorporation’s opinion polls, Iranians’ median per capita income has been estimated as $3,100 while that of the Germans, French and British $14,000, $12,500 and $12,300 respectively. The Spanish and Italians earn $6,800 and $7,200.\nThis means that Iranians spend 4.5% of their income on beauty products while the figure is 1.5% for Germans, 1.7% for the French and British, 3% for Italians and 2.5% for the Spanish.\nThese calculations show that people in Iran spend three times as much on cosmetics as German, French and British consumers.\n Cosmetic Surgery\nAdditionally, Iran’s Oral and Maxillofacial Surgeons’ Association has announced that 80,000 cosmetic surgeries are performed each year constituting 0.3% of the operations in the world. This is a rather large percentage given that only 1.08% of the world population lives in Iran. Besides, the figure is said to be approximate due to the absence of an official registration system and the fact that other types of beauty surgeries such as body contouring and facial rejuvenation, among many others, are not included.\nData from the Central Bank and the Statistics Center of Iran suggest that cultural pursuits constitute a small portion of Iranian household expenditure. The reports indicate that each family spent only 2% of their income on recreation and cultural activities in 2015, less than half their expenses on cosmetic products.\nIran’s share of the world book market is 0.1% which is one-third the country’s share of the cosmetics market. The $2.1 billion incurred on beauty products is said to equal Japan’s cinema turnover and exceeds that of Bollywood and the UK’s film industry.\nCulture, cinema and books don’t comprise high-income businesses in Iran while cosmetic surgeons and beauty product dealers make fortunes on their business.",
		"thread_title": "Iranians Spend $2.1b on Beauty Products Annually, 3 Times more than Their European Counterparts",
		"title": "Iranians Spend $2.1b on Beauty Products Annually, 3 Times more than Their European Counterparts",
		"type": "bs",
		"uuid": "17c06cb24ac5d32042fab31d8cb9b8b80d31404c"
	},
	"-KhIbJ9UCxfSAEMavR7j": {
		"author": "Daniel Haiphong",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-03T17:33:26.977+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.24528219,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.1687782,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.048511676,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.045300186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.027687656,
				"type": "LOCATION"
			},
			{
				"name": "imperialism",
				"salience": 0.02188707,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.016928654,
				"type": "ORGANIZATION"
			},
			{
				"name": "crisis",
				"salience": 0.011429423,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.011429423,
				"type": "EVENT"
			},
			{
				"name": "competition",
				"salience": 0.009085129,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.009085129,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.008929565,
				"type": "OTHER"
			},
			{
				"name": "intelligence agencies",
				"salience": 0.008655315,
				"type": "ORGANIZATION"
			},
			{
				"name": "duopoly",
				"salience": 0.008264569,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.008264569,
				"type": "OTHER"
			},
			{
				"name": "nationalist",
				"salience": 0.0068225674,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.006721088,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.006336546,
				"type": "OTHER"
			},
			{
				"name": "coverage",
				"salience": 0.006289263,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.005847697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3k14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy"
				},
				"name": "John F. Kennedy",
				"salience": 0.0054593156,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.00540303,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.00540303,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.005188935,
				"type": "ORGANIZATION"
			},
			{
				"name": "rich",
				"salience": 0.004879183,
				"type": "PERSON"
			},
			{
				"name": "sections",
				"salience": 0.004879183,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.004879183,
				"type": "EVENT"
			},
			{
				"name": "profits",
				"salience": 0.004879183,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.004874264,
				"type": "ORGANIZATION"
			},
			{
				"name": "individuals",
				"salience": 0.0047997665,
				"type": "PERSON"
			},
			{
				"name": "destruction",
				"salience": 0.004225796,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.004225796,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.004225796,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.004225796,
				"type": "OTHER"
			},
			{
				"name": "monopoly outlets",
				"salience": 0.004225796,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.004225796,
				"type": "OTHER"
			},
			{
				"name": "hijacking",
				"salience": 0.004225796,
				"type": "EVENT"
			},
			{
				"name": "thanks",
				"salience": 0.004120097,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.0037347942,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.0035610157,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0034579486,
				"type": "WORK_OF_ART"
			},
			{
				"name": "speeches",
				"salience": 0.0033597634,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0031871535,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0031871535,
				"type": "EVENT"
			},
			{
				"name": "development",
				"salience": 0.0030337768,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.003008079,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0029009257,
				"type": "ORGANIZATION"
			},
			{
				"name": "email scandal",
				"salience": 0.0026110671,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0023945272,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0023051857,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election campaign",
				"salience": 0.0022350873,
				"type": "EVENT"
			},
			{
				"name": "media coverage",
				"salience": 0.0022259036,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0022191748,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0022191748,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0022191748,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.0021516895,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.0020098423,
				"type": "OTHER"
			},
			{
				"name": "sexual assault allegations",
				"salience": 0.0020098423,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0020098423,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0020098423,
				"type": "EVENT"
			},
			{
				"name": "record",
				"salience": 0.0020098423,
				"type": "OTHER"
			},
			{
				"name": "debauchery",
				"salience": 0.0020098423,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.0020098423,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00198786,
				"type": "ORGANIZATION"
			},
			{
				"name": "headlines",
				"salience": 0.0018543217,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0018247737,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.0018247737,
				"type": "EVENT"
			},
			{
				"name": "President",
				"salience": 0.0018024301,
				"type": "PERSON"
			},
			{
				"name": "Democracy",
				"salience": 0.0017640692,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.0017482341,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "privacy",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "breach",
				"salience": 0.0017404272,
				"type": "EVENT"
			},
			{
				"name": "issue",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "framework",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "limitations",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "campaign rhetoric",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "traps",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "tax evasion",
				"salience": 0.0017404272,
				"type": "EVENT"
			},
			{
				"name": "media inquiries",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "momentum",
				"salience": 0.0017404272,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0016264175,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.0016264175,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0016264175,
				"type": "OTHER"
			},
			{
				"name": "environment",
				"salience": 0.0016024982,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.001600885,
				"type": "WORK_OF_ART"
			},
			{
				"name": "common market",
				"salience": 0.001579612,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.0015608007,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contents",
				"salience": 0.0015608007,
				"type": "OTHER"
			},
			{
				"name": "continent",
				"salience": 0.0015025473,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0015025473,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0015025473,
				"type": "EVENT"
			},
			{
				"name": "Presidency",
				"salience": 0.0014714958,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0014272446,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.001409262,
				"type": "ORGANIZATION"
			},
			{
				"name": "rich",
				"salience": 0.001409262,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0013632126,
				"type": "EVENT"
			},
			{
				"name": "batch",
				"salience": 0.0013566613,
				"type": "OTHER"
			},
			{
				"name": "monopoly corporations",
				"salience": 0.0013566613,
				"type": "ORGANIZATION"
			},
			{
				"name": "profits",
				"salience": 0.0013566613,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.0013566613,
				"type": "OTHER"
			},
			{
				"name": "batch",
				"salience": 0.0013566613,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0013566613,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0013566613,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.0013566613,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.0013566613,
				"type": "LOCATION"
			},
			{
				"name": "stench",
				"salience": 0.0013167813,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0013001896,
				"type": "OTHER"
			},
			{
				"name": "masters",
				"salience": 0.0013001896,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.001283807,
				"type": "EVENT"
			},
			{
				"name": "anything",
				"salience": 0.001283807,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0012742078,
				"type": "PERSON"
			},
			{
				"name": "servant",
				"salience": 0.0012742078,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0012203137,
				"type": "OTHER"
			},
			{
				"name": "exchanges",
				"salience": 0.0012203137,
				"type": "OTHER"
			},
			{
				"name": "premiums",
				"salience": 0.0012203137,
				"type": "OTHER"
			},
			{
				"name": "desires",
				"salience": 0.0012203137,
				"type": "OTHER"
			},
			{
				"name": "ears",
				"salience": 0.0012203137,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0012203137,
				"type": "ORGANIZATION"
			},
			{
				"name": "conditions",
				"salience": 0.001204937,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0011747621,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0011747621,
				"type": "OTHER"
			},
			{
				"name": "worth",
				"salience": 0.0011747621,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0011747621,
				"type": "ORGANIZATION"
			},
			{
				"name": "currency",
				"salience": 0.0011747621,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0011747621,
				"type": "OTHER"
			},
			{
				"name": "demise",
				"salience": 0.0011599592,
				"type": "EVENT"
			},
			{
				"name": "banana republic",
				"salience": 0.0011504815,
				"type": "PERSON"
			},
			{
				"name": "statesmanship",
				"salience": 0.0011504815,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0011504815,
				"type": "OTHER"
			},
			{
				"name": "nose",
				"salience": 0.0011453426,
				"type": "OTHER"
			},
			{
				"name": "Presidents",
				"salience": 0.0010992537,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0010816142,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0010712866,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign emails",
				"salience": 0.0010240019,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Superdelegates",
				"salience": 0.0009962155,
				"type": "PERSON"
			},
			{
				"name": "reliance",
				"salience": 0.0009962155,
				"type": "OTHER"
			},
			{
				"name": "Anointment",
				"salience": 0.0009962155,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0009962155,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.0009962155,
				"type": "OTHER"
			},
			{
				"name": "Putin-Trump",
				"salience": 0.000958458,
				"type": "ORGANIZATION"
			},
			{
				"name": "billions",
				"salience": 0.00095185416,
				"type": "OTHER"
			},
			{
				"name": "campaign speech",
				"salience": 0.00095185416,
				"type": "WORK_OF_ART"
			},
			{
				"name": "alliance",
				"salience": 0.00095185416,
				"type": "ORGANIZATION"
			},
			{
				"name": "remarks",
				"salience": 0.00093500694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.000928305,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.00092736655,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.0009097518,
				"type": "PERSON"
			},
			{
				"name": "deals",
				"salience": 0.0009001014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Security_(United_States)"
				},
				"name": "Social Security",
				"salience": 0.0008673996,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0008594177,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0008594177,
				"type": "OTHER"
			},
			{
				"name": "cache",
				"salience": 0.00084479613,
				"type": "OTHER"
			},
			{
				"name": "partnership",
				"salience": 0.0008079676,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0008066114,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0008005791,
				"type": "PERSON"
			},
			{
				"name": "imperialism",
				"salience": 0.0008005791,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0007632863,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.000756077,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.00075108005,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Affordable Care Act",
				"salience": 0.00075108005,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crisis",
				"salience": 0.000750387,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.000750387,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.000750387,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/011_9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_war"
				},
				"name": "World War",
				"salience": 0.00074546295,
				"type": "EVENT"
			},
			{
				"name": "involvement",
				"salience": 0.00074416824,
				"type": "OTHER"
			},
			{
				"name": "cover-up",
				"salience": 0.00074416824,
				"type": "EVENT"
			},
			{
				"name": "pieces",
				"salience": 0.00074416824,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00074416824,
				"type": "EVENT"
			},
			{
				"name": "objectives",
				"salience": 0.00074416824,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.00074416824,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.00074416824,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00074416824,
				"type": "OTHER"
			},
			{
				"name": "blame game",
				"salience": 0.00074416824,
				"type": "EVENT"
			},
			{
				"name": "truth",
				"salience": 0.00074416824,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.00074416824,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0007287847,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Sanders",
				"salience": 0.00072303886,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.00072303886,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Gaddafi",
				"salience": 0.00072303886,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.00072303886,
				"type": "LOCATION"
			},
			{
				"name": "anti-Putin Russophobia",
				"salience": 0.00070809195,
				"type": "OTHER"
			},
			{
				"name": "task",
				"salience": 0.00069844135,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0006932178,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0006932178,
				"type": "PERSON"
			},
			{
				"name": "service",
				"salience": 0.0006932178,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0006932178,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0006896387,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00063104887,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.00062589167,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00062589167,
				"type": "OTHER"
			},
			{
				"name": "policy record",
				"salience": 0.00060252316,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0005998313,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0005949291,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama Administration",
				"salience": 0.0005902384,
				"type": "ORGANIZATION"
			},
			{
				"name": "crowd",
				"salience": 0.00057743554,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0005605214,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.0005517182,
				"type": "ORGANIZATION"
			},
			{
				"name": "email investigation",
				"salience": 0.0005443838,
				"type": "OTHER"
			},
			{
				"name": "policy work",
				"salience": 0.0005419516,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.0005419516,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0005419516,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0005419516,
				"type": "EVENT"
			},
			{
				"name": "principles",
				"salience": 0.0005419516,
				"type": "OTHER"
			},
			{
				"name": "depth",
				"salience": 0.0005419516,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0005419516,
				"type": "OTHER"
			},
			{
				"name": "disposal",
				"salience": 0.0005419516,
				"type": "OTHER"
			},
			{
				"name": "Speculation",
				"salience": 0.0005419516,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0005178143,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0005178143,
				"type": "PERSON"
			},
			{
				"name": "alliance",
				"salience": 0.0005178143,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0005069019,
				"type": "OTHER"
			},
			{
				"name": "nail",
				"salience": 0.00050223665,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00046752038,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.00046752038,
				"type": "OTHER"
			},
			{
				"name": "capitalist",
				"salience": 0.00046752038,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.00046752038,
				"type": "OTHER"
			},
			{
				"name": "surveillance apparatus",
				"salience": 0.00046543154,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.00043492796,
				"type": "EVENT"
			},
			{
				"name": "coffin",
				"salience": 0.00040481647,
				"type": "OTHER"
			},
			{
				"name": "machinations",
				"salience": 0.00040481647,
				"type": "OTHER"
			},
			{
				"name": "psyche",
				"salience": 0.00040481647,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00040481647,
				"type": "PERSON"
			},
			{
				"name": "lies",
				"salience": 0.00040481647,
				"type": "OTHER"
			},
			{
				"name": "suspicions",
				"salience": 0.00040481647,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.00040481647,
				"type": "OTHER"
			},
			{
				"name": "myths",
				"salience": 0.00040481647,
				"type": "OTHER"
			},
			{
				"name": "advocacy",
				"salience": 0.00040481647,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.00028771634,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/DNC_RNC_62753.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 23.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "20 Shares\n1 18 0 1\nThe two-party corporate duopoly remains mired in crisis in the closing days of the 2016 Presidential elections. Donald Trump's virtual hijacking of the Republican Party has stripped the competition between the two dominant sections of the ruling class down to its most naked form. The corporate media's non-stop coverage of Trump was supposed to legitimize the candidacy of Hillary Clinton and rake in enormous profits for the monopoly outlets. The eyes of the rich have been on Hillary Clinton to rescue the two-party system from the danger of Donald Trump. However, thanks to WikiLeaks, Hillary Clinton appears poised to take the Democratic Party down its own path of destruction.\nThe FBI announcement that it will reopen the investigation of Clinton's private email server has significantly eroded the momentum of the Democratic Party campaign. Trump appeared finished by the end of the third Presidential debate. His campaign was mired in sexual assault allegations and media inquiries into possible tax evasion. The billionaire white nationalist has suddenly found himself within one point of Hillary Clinton in recent polls. No matter how many traps Trump falls into or how vile his campaign rhetoric, Clinton has proven that no amount of Trump debauchery can save her from her political record.\nUnfortunately, the email scandal has been subject to the limitations of corporate media coverage. The threat to \"national security\" has been cited as the number one issue with Clinton's breach of State Department privacy. Indeed, Clinton did break the law and from this framework it is no doubt appropriate that she face the consequences. But under imperialism, where billions of people are exploited for the profits of monopoly corporations, the legitimacy of ruling class law is of little worth to the vast majority of humanity. What matters is the content of the emails themselves. The emails reveal that the current conditions of the imperialist system have thrown the two-party system into a permanent crisis of legitimacy.\nThe first batch of emails dumped by WikiLeaks exposed how US imperialism serves the masters of war and capital. The initial emails proved that Clinton destabilized Libya in 2011 in order to stop the Gaddafi-led government from instituting an independent gold currency across the African continent . The emails also exposed that the Democratic National Committee (DNC) spent copious amounts of time deriding the Sanders campaign . Another batch of emails further damaged the Clinton cache with contents from her speeches to the big banks. It was in these speeches where she told Wall Street that she takes a different position in public than she does in private. In private, Clinton serenaded the ears of the rich with her desires to privatize Social Security and create a \"hemispheric common market.\"\nThe emails have not been the only development that has soured Clinton's election campaign. The Obama Administration announced in late October that premiums for the Affordable Care Act market-based exchanges are set to increase by 25 percent next year . Bill Clinton also made negative headlines through a leaked memo that revealed the former President utilized the Clinton Foundation to make profitable deals with private corporations . In other words, the Democratic Party has been unable to avoid looking like the corporate servant and imperialist party it always has been. With less than a month left until voting day, a Clinton victory is anything but secure.\nMORE... The banana republic of America: Democracy be damned To the Superdelegates: Stand tall in statesmanship! Anointment of Hillary Clinton exposes a democracy that never was Democratic Party ignored its 2012 platform There are some in the US who believe that the demise of the Democratic Party will be a bad thing. Clinton has fewer staunch supporters among working people than she does individuals who are willing to hold their nose for Clinton in order to avoid a Trump Presidency. However, the stench emanating from the Clinton camp is becoming unbearable. Her campaign's reliance on anti-Putin Russophobia threatens World War. Her policy record is equally, if not more deplorable, than Donald Trump's capitalist, racist, and misogynistic machinations. The new email investigation could be the first nail of many to come in the Democratic Party coffin.\nHowever, the fear of Trump is deeply embedded into the psyche of a large section of American voters. The corporate media has constantly fed many of her lies and suspicions to the masses. One of these myths is the alleged WikiLeaks-Russia-Trump alliance. No such alliance exists. Neither Putin nor WikiLeaks has announced any sort of allegiance to Trump. Putin has simply commented on Trump's advocacy of a US-Russian partnership was a \"smart\" thing to say. Furthermore, Julian Assange has denied publicly that Trump would somehow present a better option than Hillary Clinton. But the truth matters little in a political environment that equates opposition to Clinton with support for Trump.\nClinton has turned the Russian blame game toward the FBI. In a campaign speech, Clinton insinuated that the FBI is hiding information regarding the Putin-Trump alliance. Her claims were promptly proved false . Such remarks may cause more damage to an already unpopular campaign. US intelligence agencies are powerful institutions that current and future Presidents must curry the favor of to achieve the objectives of US imperialism. When President John F. Kennedy signaled that he wanted to break the CIA into a \"thousand pieces,\" he was assassinated shortly thereafter. It was revealed last year that the CIA was heavily involved in the cover-up of its involvement in his murder. US intelligence is thus the wrong crowd for a future US President to anger, especially given the vast surveillance apparatus now at its disposal.\nSpeculation aside, the Clinton campaign emails present useful information on the depth of US imperialism’s crisis. US imperialism has been mired in a period of stagnant economic growth and endless war for decades. It was only a matter of time before this crisis would express itself through its electoral system. Never has it been clearer that the two corporate parties in front of US imperial policy work solely for the ruling class. The task now is to utilize the developments of this election cycle in service of the people. That means shedding all fear of what the results of the election will be and basing our action on principles instead.",
		"thread_title": "A New Email Investigation on Clinton Could Hasten the Democratic Party's Demise",
		"title": "A New Email Investigation on Clinton Could Hasten the Democratic Party's Demise",
		"type": "bs",
		"uuid": "ef0d1fd0d6be89d3cb4bc84a5c73dd6b0ada723a"
	},
	"-KhIbJZSN53aL6iRin-Z": {
		"author": "Ramzy Baroud",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-03T17:36:35.291+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.24806803,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/047876",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine_(region)"
				},
				"name": "Palestine",
				"salience": 0.10104982,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arabs",
				"salience": 0.07254467,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01jf9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balfour_Declaration"
				},
				"name": "Balfour Declaration",
				"salience": 0.047841907,
				"type": "WORK_OF_ART"
			},
			{
				"name": "agent",
				"salience": 0.034230895,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012l1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arthur_Balfour"
				},
				"name": "Arthur James Balfour",
				"salience": 0.027177833,
				"type": "PERSON"
			},
			{
				"name": "Zionist Jewish",
				"salience": 0.018490227,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.016227897,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shares",
				"salience": 0.014161483,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0139149595,
				"type": "LOCATION"
			},
			{
				"name": "map",
				"salience": 0.013138636,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.011504508,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.010069114,
				"type": "PERSON"
			},
			{
				"name": "government view",
				"salience": 0.010003887,
				"type": "OTHER"
			},
			{
				"name": "backing",
				"salience": 0.008435274,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.008435274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0077975825,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.007590276,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.007415616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "war",
				"salience": 0.0063663293,
				"type": "EVENT"
			},
			{
				"name": "latter",
				"salience": 0.005993962,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.005967926,
				"type": "OTHER"
			},
			{
				"name": "homeland",
				"salience": 0.005967926,
				"type": "LOCATION"
			},
			{
				"name": "proclamations",
				"salience": 0.0053484254,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cm2xh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_I"
				},
				"name": "World War I",
				"salience": 0.005303886,
				"type": "EVENT"
			},
			{
				"name": "homeland",
				"salience": 0.005258181,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.004437012,
				"type": "PERSON"
			},
			{
				"name": "call",
				"salience": 0.0043124096,
				"type": "OTHER"
			},
			{
				"name": "anniversary",
				"salience": 0.0043124096,
				"type": "EVENT"
			},
			{
				"name": "tug",
				"salience": 0.0043124096,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0043124096,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0038112719,
				"type": "PERSON"
			},
			{
				"name": "habit",
				"salience": 0.0034768244,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053wf0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Sykes"
				},
				"name": "Mark Sykes",
				"salience": 0.0034558654,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dv0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_League"
				},
				"name": "Arab League",
				"salience": 0.0030661952,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0604m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestinian_National_Authority"
				},
				"name": "Palestinian Authority",
				"salience": 0.0030410727,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.002889849,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0026809352,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.0026809352,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g7jk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Secretary_of_State_for_Foreign_and_Commonwealth_Affairs"
				},
				"name": "Foreign Secretary",
				"salience": 0.0026552803,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0026552803,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.002622908,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.002622908,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.002622908,
				"type": "WORK_OF_ART"
			},
			{
				"name": "promise",
				"salience": 0.0025864276,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.0025440576,
				"type": "PERSON"
			},
			{
				"name": "commemoration",
				"salience": 0.0024585603,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0024585603,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0024585603,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0024585603,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.0024585603,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0022713516,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0021575415,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0021208497,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0021144375,
				"type": "ORGANIZATION"
			},
			{
				"name": "leader",
				"salience": 0.0020508617,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0020508617,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.0020508617,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.0020508617,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0020508617,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0020508617,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0020508617,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/024656",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walter_Rothschild,_2nd_Baron_Rothschild"
				},
				"name": "Walter Rothschild",
				"salience": 0.0020105157,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.0018392018,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0018392018,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0018392018,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.0017759296,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0017759296,
				"type": "OTHER"
			},
			{
				"name": "goals",
				"salience": 0.0017759296,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0017759296,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0017759296,
				"type": "OTHER"
			},
			{
				"name": "heroes",
				"salience": 0.0017759296,
				"type": "OTHER"
			},
			{
				"name": "Majesty",
				"salience": 0.0017759296,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0017759296,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0017705596,
				"type": "LOCATION"
			},
			{
				"name": "colors",
				"salience": 0.0017239297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01nf_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sykes%E2%80%93Picot_Agreement"
				},
				"name": "Sykes-Picot Agreement",
				"salience": 0.0016709418,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rights",
				"salience": 0.001659587,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.001659587,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.001659587,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0016590724,
				"type": "LOCATION"
			},
			{
				"name": "Zionists",
				"salience": 0.001648839,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0016302336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02c7c_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Faisal%E2%80%93Weizmann_Agreement"
				},
				"name": "Faisal-Weizmann Agreement",
				"salience": 0.0016146275,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lines",
				"salience": 0.0015926281,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0015926281,
				"type": "OTHER"
			},
			{
				"name": "map",
				"salience": 0.0015926281,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0015926281,
				"type": "OTHER"
			},
			{
				"name": "victorious parties",
				"salience": 0.0015926281,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0015926281,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0015516633,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0015331833,
				"type": "OTHER"
			},
			{
				"name": "centerpiece",
				"salience": 0.001512808,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0015014969,
				"type": "EVENT"
			},
			{
				"name": "assumptions",
				"salience": 0.0014379908,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0014379908,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0014379908,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0014073798,
				"type": "ORGANIZATION"
			},
			{
				"name": "promise",
				"salience": 0.0014073798,
				"type": "OTHER"
			},
			{
				"name": "landscape",
				"salience": 0.001384315,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.001384315,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.001384315,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.001384315,
				"type": "WORK_OF_ART"
			},
			{
				"name": "behalf",
				"salience": 0.001384315,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0013001766,
				"type": "LOCATION"
			},
			{
				"name": "hypocrisy",
				"salience": 0.0012934651,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.0012741935,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0012451817,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0012451817,
				"type": "LOCATION"
			},
			{
				"name": "accordance",
				"salience": 0.0012451817,
				"type": "OTHER"
			},
			{
				"name": "graph pencil",
				"salience": 0.0012451817,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.0012451817,
				"type": "LOCATION"
			},
			{
				"name": "nature",
				"salience": 0.0012451817,
				"type": "OTHER"
			},
			{
				"name": "cake",
				"salience": 0.0012451817,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0012367135,
				"type": "LOCATION"
			},
			{
				"name": "knowledge",
				"salience": 0.0011986997,
				"type": "OTHER"
			},
			{
				"name": "designs",
				"salience": 0.0011986997,
				"type": "WORK_OF_ART"
			},
			{
				"name": "name",
				"salience": 0.0011986997,
				"type": "OTHER"
			},
			{
				"name": "object",
				"salience": 0.0011986997,
				"type": "OTHER"
			},
			{
				"name": "achievement",
				"salience": 0.0011986997,
				"type": "OTHER"
			},
			{
				"name": "endeavours",
				"salience": 0.0011986997,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0011800147,
				"type": "WORK_OF_ART"
			},
			{
				"name": "aspiration",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "disregard",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "Zionist movement",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "mandates",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0011739231,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0011739231,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.00115913,
				"type": "OTHER"
			},
			{
				"name": "rebellion",
				"salience": 0.0011516217,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/089g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionism"
				},
				"name": "Zionists",
				"salience": 0.0011406961,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottomans",
				"salience": 0.0011320661,
				"type": "PERSON"
			},
			{
				"name": "Asia Minor Agreement",
				"salience": 0.0011320661,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0cwzl_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nakba_Day"
				},
				"name": "Al Nakba",
				"salience": 0.0010931114,
				"type": "PERSON"
			},
			{
				"name": "FIFA World Cups Let There Be Water",
				"salience": 0.0010931114,
				"type": "EVENT"
			},
			{
				"name": "stage",
				"salience": 0.0010294816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.0010214844,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.001016508,
				"type": "EVENT"
			},
			{
				"name": "display",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "migration",
				"salience": 0.001016508,
				"type": "EVENT"
			},
			{
				"name": "settlers",
				"salience": 0.001016508,
				"type": "PERSON"
			},
			{
				"name": "turmoil",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "repercussions",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "civilizations",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "co-operation",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.001016508,
				"type": "EVENT"
			},
			{
				"name": "official",
				"salience": 0.001016508,
				"type": "PERSON"
			},
			{
				"name": "division",
				"salience": 0.001016508,
				"type": "ORGANIZATION"
			},
			{
				"name": "earnest",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "entities",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.001016508,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0009712413,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0009712413,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0009712413,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0009712413,
				"type": "LOCATION"
			},
			{
				"name": "aberration",
				"salience": 0.0009662271,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04_qj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Georges-Picot"
				},
				"name": "François Georges-Picot",
				"salience": 0.0009436658,
				"type": "PERSON"
			},
			{
				"name": "contrary",
				"salience": 0.00087691896,
				"type": "OTHER"
			},
			{
				"name": "assurances",
				"salience": 0.00087691896,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00087691896,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.00087691896,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0008520207,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.0008168803,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0008168803,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0008168803,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0008168803,
				"type": "LOCATION"
			},
			{
				"name": "injustice",
				"salience": 0.00079883594,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.00076901127,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00076637196,
				"type": "ORGANIZATION"
			},
			{
				"name": "colonialism",
				"salience": 0.0007656647,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0007656647,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0007656647,
				"type": "ORGANIZATION"
			},
			{
				"name": "promise",
				"salience": 0.0007656647,
				"type": "OTHER"
			},
			{
				"name": "obstacles",
				"salience": 0.00075931917,
				"type": "OTHER"
			},
			{
				"name": "lip-service",
				"salience": 0.00075931917,
				"type": "OTHER"
			},
			{
				"name": "replay",
				"salience": 0.00075931917,
				"type": "OTHER"
			},
			{
				"name": "refugee camps",
				"salience": 0.00075931917,
				"type": "LOCATION"
			},
			{
				"name": "cleansing",
				"salience": 0.00075931917,
				"type": "OTHER"
			},
			{
				"name": "diaspora",
				"salience": 0.00075931917,
				"type": "OTHER"
			},
			{
				"name": "concoctions",
				"salience": 0.00075931917,
				"type": "OTHER"
			},
			{
				"name": "troublemakers",
				"salience": 0.00075931917,
				"type": "PERSON"
			},
			{
				"name": "rioters",
				"salience": 0.00075931917,
				"type": "PERSON"
			},
			{
				"name": "radar",
				"salience": 0.00075931917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.000737759,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018wvh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gentile"
				},
				"name": "non-Jewish",
				"salience": 0.000737759,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0268zzq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionist_Federation_of_Great_Britain_and_Ireland"
				},
				"name": "Zionist Federation",
				"salience": 0.000737759,
				"type": "ORGANIZATION"
			},
			{
				"name": "peace",
				"salience": 0.00068605196,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.00063863164,
				"type": "OTHER"
			},
			{
				"name": "disregard",
				"salience": 0.00063863164,
				"type": "OTHER"
			},
			{
				"name": "aspirations",
				"salience": 0.00063863164,
				"type": "OTHER"
			},
			{
				"name": "rebellion",
				"salience": 0.00063863164,
				"type": "EVENT"
			},
			{
				"name": "generation",
				"salience": 0.00063863164,
				"type": "OTHER"
			},
			{
				"name": "diplomats",
				"salience": 0.00063863164,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00063863164,
				"type": "OTHER"
			},
			{
				"name": "intentions",
				"salience": 0.0006305824,
				"type": "OTHER"
			},
			{
				"name": "Belfour",
				"salience": 0.00062561047,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00062561047,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00062561047,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00062561047,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0006101887,
				"type": "EVENT"
			},
			{
				"name": "Arabs",
				"salience": 0.0006101887,
				"type": "PERSON"
			},
			{
				"name": "promises",
				"salience": 0.00060169597,
				"type": "OTHER"
			},
			{
				"name": "colonies",
				"salience": 0.0005719293,
				"type": "OTHER"
			},
			{
				"name": "homeland",
				"salience": 0.0005719293,
				"type": "LOCATION"
			},
			{
				"name": "colonialism",
				"salience": 0.0005719293,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0005719293,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00055585126,
				"type": "OTHER"
			},
			{
				"name": "misfortunates",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "peril",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "perpetuation",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "ancestors",
				"salience": 0.0005529812,
				"type": "PERSON"
			},
			{
				"name": "brief",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.0005529812,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0005529812,
				"type": "PERSON"
			},
			{
				"name": "terms",
				"salience": 0.00054846174,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0004770338,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.000434552,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.00041305294,
				"type": "OTHER"
			},
			{
				"name": "rapport",
				"salience": 0.00041305294,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.00041305294,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.00041305294,
				"type": "OTHER"
			},
			{
				"name": "avail",
				"salience": 0.00041305294,
				"type": "OTHER"
			},
			{
				"name": "takeover",
				"salience": 0.00041305294,
				"type": "EVENT"
			},
			{
				"name": "League of Nations Council",
				"salience": 0.00035963117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00034031091,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j3g2_g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Mandate_for_Palestine_(legal_instrument)"
				},
				"name": "British Mandate",
				"salience": 0.00029356894,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.00024353633,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Balfour_Declaration_a9ceb.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.009",
		"text": "9 Shares\n8 0 0 1\nLast July, the Palestinian Authority took the unexpected, although belated step of seeking Arab backing in suing Britain over the Balfour Declaration. That ‘declaration’ was the first ever explicit commitment made by Britain, and the West in general, to establish a Jewish homeland atop an existing Palestinian homeland.\nIt is too early to tell whether the Arab League would heed the Palestinian call , or if the PA would even follow through, especially considering that the latter has the habit of making too many proclamations backed by little or no action.\nHowever, it seems that the next year will witness a significant tug of war regarding the Balfour Declaration, the 100th anniversary of which will be commemorated on November 02, 2017 .\nBut who is Balfour, what is the Balfour Declaration and why does all of this matters today?\nBritain's Foreign Secretary from late 1916, Arthur James Balfour, had pledged Palestine to another people. That promise was made on November 02, 1917 on behalf of the British government in the form of a letter sent to the leader of the Jewish community in Britain, Walter Rothschild.\nMORE... Palestine’s reality: Al Nakba commemoration and the right of return or the return of the Faisal-Weizmann Agreement? To be a child in Palestine, where Israel has killed more children than the total number of goals scored in all FIFA World Cups Let There Be Water: Israel's policy of stolen water No hope and no heroes for Palestine At the time, Britain was not even in control of Palestine, which was still part of the Ottoman Empire. Either way, Palestine was never Balfour’s to so casually transfer to anyone else. His letter read:\n“His Majesty's government view with favour the establishment in Palestine of a national home for the Jewish people, and will use their best endeavours to facilitate the achievement of this object, it being clearly understood that nothing shall be done which may prejudice the civil and religious rights of existing non-Jewish communities in Palestine, or the rights and political status enjoyed by Jews in any other country.”\nHe concluded, “I should be grateful if you would bring this declaration to the knowledge of the Zionist Federation.”\nBalfour was hardly acting on his own. True, the Declaration bears his name, yet, in reality, he was a loyal agent of an Empire with massive geopolitical designs, not only concerning Palestine alone, but with Palestine as part of a larger Arab landscape.\nOnly a year earlier, another sinister document was introduced, albeit secretly. It was endorsed by another top British diplomat, Mark Sykes and, on behalf of France, by François Georges-Picot. The Russians were informed of the agreement, as they too had received a piece of the Ottoman cake.\nThe document indicated that, once the Ottomans were soundly defeated, their territories, including Palestine, would be split among the prospective victorious parties.\nThe Sykes-Picot Agreement , also known as the ‘Asia Minor Agreement’, was signed in secret one hundred years ago, two years into World War I. It signified the brutal nature of colonial powers that rarely associated land and resources with people who lived upon or owned them.\nThe centerpiece of the agreement was a map that was marked with straight lines by a China graph pencil. The map largely determined the fate of the Arabs, dividing them in accordance with various haphazard assumptions of tribal and sectarian lines.\nThe improvised map consisted not only of lines but also colors , along with language that attested to the fact that the two countries viewed the Arab region purely on materialistic terms, without paying the slightest attention to the possible repercussions of slicing up entire civilizations with a multifarious history of co-operation and conflict.\nThe Sykes-Picot negotiations were completed in March 1916 and, although official, was secretly signed on May 19, 1916.\nWWI concluded on November 11, 1918, after which the division of the Ottoman Empire began in earnest.\nBritish and French mandates were extended over divided Arab entities, while Palestine was granted to the Zionist movement a year later, when Belfour conveyed the British government’s promise, sealing the fate of Palestinians to a life of perpetual war and turmoil.\nRarely was British-Western hypocrisy and complete disregard for the national aspiration of any other nation on full display as in the case of Palestine. Beginning with the first wave of Zionist Jewish migration to Palestine in 1882, European countries helped facilitate the movement of illegal settlers and resources, where the establishment of many colonies, large and small, was afoot.\nSo when Balfour sent his letter to Rothschild, the idea of a Jewish homeland in Palestine was very much plausible.\nStill, many supercilious promises were being made to the Arabs during the Great War years, as the Arab leadership sided with the British in their war against the Ottoman Empire. Arabs were promised instant independence, including that of the Palestinians.\nWhen the intentions of the British and their rapport with the Zionists became too apparent, Palestinians rebelled , marking a rebellion that has never ceased 99 years later, and highlighting the horrific consequences of British colonialism and the eventual complete Zionist takeover of Palestine which is still felt after all of these years.\nPaltry attempts to pacify Palestinian anger were to no avail, especially after the League of Nations Council in July 1922 approved the terms of the British Mandate over Palestine – which was originally granted to Britain in April 1920 – without consulting the Palestinians at all. In fact, Palestinians would disappear from the British and international radar, only to reappear as negligible rioters, troublemakers, and obstacles to the joint British-Zionist colonial concoctions.\nDespite occasional assurances to the contrary, the British intention of ensuring the establishment of an exclusively Jewish state in Palestine was becoming clearer with time. The Balfour Declaration was not merely an aberration, but had, indeed, set the stage for the full-scale ethnic cleansing that followed, three decades later.\nIn fact, that history remains in constant replay: the Zionists claimed Palestine and renamed it ‘Israel’; the British continue to support them, although never ceasing to pay lip-service to the Arabs; and the Palestinian people remain a nation that is geographically fragmented between refugee camps, in the diaspora, militarily occupied, or treated as second class citizens in a country upon which their ancestors dwelt since time immemorial.\nWhile Balfour cannot be blamed for all the misfortunates that have befallen Palestinians since he communicated his brief, but infamous letter, the notion that his ‘promise’ embodied - that of complete disregard of the aspirations and rights of the Palestinian Arab people – that very letter is handed from one generation of British diplomats to the next, in the same way that Palestinian resistance to colonialism has and continues to spread across generations.\nThat injustice continues, thus the perpetuation of the conflict. What the British, the early Zionists, the Americans and subsequent Israeli governments failed to understand, and continue to ignore at their own peril, is that there can be no peace without justice and equality in Palestine; and that Palestinians will continue to resist, as long as the reasons that inspired their rebellion nearly a century ago, remain in place.",
		"thread_title": "Why Palestinians Want to Sue Britain: 99 Years since the Balfour Declaration",
		"title": "Why Palestinians Want to Sue Britain: 99 Years since the Balfour Declaration",
		"type": "bs",
		"uuid": "7289579d336c6c5ada78422b463aaf845154753f"
	},
	"-KhIbJjaGDw6oA0pZ9r2": {
		"author": "Prof. Tony Hall",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-03T17:45:41.453+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0bw62g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tony_Hall,_Baron_Hall_of_Birkenhead"
				},
				"name": "Tony Hall",
				"salience": 0.8011274,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hftcy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/B'nai_Brith_Canada"
				},
				"name": "B'nai Brith Canada",
				"salience": 0.0228945,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.01484995,
				"type": "LOCATION"
			},
			{
				"name": "Mike Mahon",
				"salience": 0.008156486,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.0076839817,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00624391,
				"type": "EVENT"
			},
			{
				"name": "mission",
				"salience": 0.005069787,
				"type": "OTHER"
			},
			{
				"name": "WRITER",
				"salience": 0.004819156,
				"type": "PERSON"
			},
			{
				"name": "Brantford Ontario",
				"salience": 0.0047435123,
				"type": "LOCATION"
			},
			{
				"name": "Mohawk Village",
				"salience": 0.0047435123,
				"type": "LOCATION"
			},
			{
				"name": "Haldimand Deed Recognition Dinner",
				"salience": 0.0047435123,
				"type": "EVENT"
			},
			{
				"name": "Kanata",
				"salience": 0.0047435123,
				"type": "LOCATION"
			},
			{
				"name": "branch",
				"salience": 0.0045456095,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.0042370367,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.0040520695,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01sq7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohawk_people"
				},
				"name": "Mohawk Territory",
				"salience": 0.004010366,
				"type": "LOCATION"
			},
			{
				"name": "witch hunt",
				"salience": 0.003938432,
				"type": "EVENT"
			},
			{
				"name": "target",
				"salience": 0.003938432,
				"type": "OTHER"
			},
			{
				"name": "tenure",
				"salience": 0.0034065521,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0029228828,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00236856,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.0021833705,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03p5zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Lethbridge"
				},
				"name": "University of Lethbridge",
				"salience": 0.0020929852,
				"type": "ORGANIZATION"
			},
			{
				"name": "Prof. Hall",
				"salience": 0.0020441082,
				"type": "LOCATION"
			},
			{
				"name": "smear",
				"salience": 0.0018756561,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0018756561,
				"type": "WORK_OF_ART"
			},
			{
				"name": "professor",
				"salience": 0.0018629517,
				"type": "PERSON"
			},
			{
				"name": "consent",
				"salience": 0.0016244908,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0016244908,
				"type": "OTHER"
			},
			{
				"name": "disinformation",
				"salience": 0.0016244908,
				"type": "OTHER"
			},
			{
				"name": "FB page",
				"salience": 0.0016244908,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0016244908,
				"type": "OTHER"
			},
			{
				"name": "university teacher",
				"salience": 0.0015769763,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0014569869,
				"type": "EVENT"
			},
			{
				"name": "object",
				"salience": 0.0014132133,
				"type": "OTHER"
			},
			{
				"name": "misrepresentation",
				"salience": 0.0013778583,
				"type": "OTHER"
			},
			{
				"name": "advocacy",
				"salience": 0.001326475,
				"type": "OTHER"
			},
			{
				"name": "critic",
				"salience": 0.0013156469,
				"type": "PERSON"
			},
			{
				"name": "teaching post",
				"salience": 0.0012665804,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.0011896605,
				"type": "EVENT"
			},
			{
				"name": "freedom",
				"salience": 0.0011896605,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0011896605,
				"type": "OTHER"
			},
			{
				"name": "holocaust",
				"salience": 0.0011835245,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.0011393793,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0011393793,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0011393793,
				"type": "ORGANIZATION"
			},
			{
				"name": "treatment",
				"salience": 0.0011393793,
				"type": "OTHER"
			},
			{
				"name": "U",
				"salience": 0.0011393793,
				"type": "OTHER"
			},
			{
				"name": "petition signatures",
				"salience": 0.0010968788,
				"type": "OTHER"
			},
			{
				"name": "letters",
				"salience": 0.0010968788,
				"type": "WORK_OF_ART"
			},
			{
				"name": "offices",
				"salience": 0.0010968788,
				"type": "LOCATION"
			},
			{
				"name": "membership",
				"salience": 0.0010968788,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0010968788,
				"type": "OTHER"
			},
			{
				"name": "Mahon",
				"salience": 0.0010902663,
				"type": "PERSON"
			},
			{
				"name": "principles",
				"salience": 0.0010742235,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.0010742235,
				"type": "ORGANIZATION"
			},
			{
				"name": "institutions",
				"salience": 0.0010742235,
				"type": "OTHER"
			},
			{
				"name": "smear item",
				"salience": 0.0010295345,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0q442",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Defamation_League"
				},
				"name": "Anti-Defamation League",
				"salience": 0.0010003254,
				"type": "ORGANIZATION"
			},
			{
				"name": "University of Lethbridge Faculty Association",
				"salience": 0.0009767013,
				"type": "ORGANIZATION"
			},
			{
				"name": "protection",
				"salience": 0.0009302689,
				"type": "OTHER"
			},
			{
				"name": "learning",
				"salience": 0.0009302689,
				"type": "OTHER"
			},
			{
				"name": "mainstay",
				"salience": 0.0009302689,
				"type": "OTHER"
			},
			{
				"name": "arbitration",
				"salience": 0.0009302689,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0009302689,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.0009302689,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.00088886777,
				"type": "EVENT"
			},
			{
				"name": "techniques",
				"salience": 0.00080259255,
				"type": "OTHER"
			},
			{
				"name": "techniques",
				"salience": 0.00080259255,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.00080259255,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00080259255,
				"type": "PERSON"
			},
			{
				"name": "publishing project",
				"salience": 0.00075950526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lwd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Carl_Linnaeus"
				},
				"name": "L",
				"salience": 0.00070146384,
				"type": "ORGANIZATION"
			},
			{
				"name": "Aboriginal Palestinians",
				"salience": 0.00070146384,
				"type": "PERSON"
			},
			{
				"name": "chief",
				"salience": 0.00069501146,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00069501146,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00069501146,
				"type": "OTHER"
			},
			{
				"name": "presence draw",
				"salience": 0.00069501146,
				"type": "OTHER"
			},
			{
				"name": "Kill All Jews",
				"salience": 0.00067528634,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0006505539,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Native Americans",
				"salience": 0.0005471787,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07c5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Americas"
				},
				"name": "Americas",
				"salience": 0.0005471787,
				"type": "LOCATION"
			},
			{
				"name": "university system",
				"salience": 0.00050621387,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00048367525,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.00048367525,
				"type": "EVENT"
			},
			{
				"name": "freedom",
				"salience": 0.00048367525,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.00043671034,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.00043671034,
				"type": "OTHER"
			},
			{
				"name": "critics",
				"salience": 0.00043671034,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00042780826,
				"type": "LOCATION"
			},
			{
				"name": "Alberta Canada",
				"salience": 0.00039852213,
				"type": "LOCATION"
			},
			{
				"name": "McGill-Queen's University Press",
				"salience": 0.00039852213,
				"type": "ORGANIZATION"
			},
			{
				"name": "nature",
				"salience": 0.00037815288,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.00037815288,
				"type": "OTHER"
			},
			{
				"name": "American Herald Tribune",
				"salience": 0.0003115712,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/079fm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Global_studies"
				},
				"name": "Globalization Studies",
				"salience": 0.0003115712,
				"type": "OTHER"
			},
			{
				"name": "The Bowl with One Spoon",
				"salience": 0.0002999392,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04cvhjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canadian_Association_of_University_Teachers"
				},
				"name": "Canadian Association of University Teachers",
				"salience": 0.00026878453,
				"type": "ORGANIZATION"
			},
			{
				"name": "Grand River",
				"salience": 0.00023273822,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Tony_Hall_on_Mohawk_Territory_cba6f.JPG",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.141",
		"text": "Prof. Tony Hall Speaks Out on Mohawk Territory 2 Shares\n1 0 0 1\nProf. Hall speaks at the Haldimand Deed Recognition Dinner at Kanata in the Mohawk Village near Brantford Ontario. Prof. Hall has been the target of a witch hunt mounted by Facebook and by B'nai Brith Canada. The mission of the Canadian branch of the Anti-Defamation League is to provide Zionist advocacy for \"the security of Israel.\"\nIn late August of 2016 a maliciously engineered smear item was placed on Prof. Hall's FB page without his knowledge or consent. The B'nai Brith immediately publicized the offensive content of the post to introduce a concerted smear and disinformation campaign implying falsely that Dr. Hall seeks to \"Kill All Jews.\" The B'nai Brith exploited its grotesque misrepresentation of Dr. Hall's academic work to call on its membership to flood the administrative offices of the University of Lethbridge with letters and petition signatures. The object is to remove Dr. Hall from his teaching post. Dr. Hall remains a tenured full professor whose career as a university teacher began in 1982.\nThe University of Lethbridge's administration soon surrendered to this Zionist campaign aimed at disabling an outspoken critic of Israel's genocidal treatment of the Aboriginal Palestinians. On Oct. 4 the U of L president, Dr. Mike Mahon, suspended Dr. Hall without pay. He undertook this assault on the principles of academic freedom in the complete absence of any due process of third-party arbitration whatsoever.\nThe attack on Dr. Hall is an attack on the institution of academic tenure, a mainstay of protection for academic freedom in institutions of higher learning. The University of Lethbridge Faculty Association and the Canadian Association of University Teachers have identified the illegal nature of Dr. Mahon's unprecedented assault on the core principles of tenure and academic freedom.\nIn his talk sponsored by the Mohawks of the Grand River, Dr. Hall put the Zionist/Facebook campaign directed at disabling critics of Israel in a broader historical context. The assault on the Palestinian people extends the genocidal holocaust directed at the Indigenous peoples of the Americas since 1492. Israeli techniques directed at terminating the Palestinian presence draw on the genocidal techniques directed at Native Americans in the expansionary course of US history.\nWRITER\nProf. Tony Hall Dr. Hall is editor in chief of American Herald Tribune. He is currently Professor of Globalization Studies at University of Lethbridge in Alberta Canada. He has been a teacher in the Canadian university system since 1982. Dr. Hall, has recently finished a big two-volume publishing project at McGill-Queen's University Press entitled \"The Bowl with One Spoon\".",
		"thread_title": "The Genocide of Indigenous Peoples in North America and Palestine-Israel - American Herald Tribune",
		"title": "The Genocide of Indigenous Peoples in North America and Palestine-Israel - American Herald Tribune",
		"type": "bs",
		"uuid": "6429c8ae7b59578a051770263f0d6ee7547f4e31"
	},
	"-KhIbK5YHkvG-1YAQMvq": {
		"author": "Stephen Yearwood",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-03T17:57:38.200+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "warming",
				"salience": 0.10770843,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01bc6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cain_and_Abel"
				},
				"name": "Cain",
				"salience": 0.07129215,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.043447968,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.03899742,
				"type": "OTHER"
			},
			{
				"name": "indifference",
				"salience": 0.02161808,
				"type": "OTHER"
			},
			{
				"name": "farm",
				"salience": 0.020313993,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.017967014,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.017347226,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.017347226,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.015342028,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.015282919,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.015282919,
				"type": "OTHER"
			},
			{
				"name": "farming",
				"salience": 0.013825313,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.013739996,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015j7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bible"
				},
				"name": "Bible",
				"salience": 0.012610516,
				"type": "WORK_OF_ART"
			},
			{
				"name": "feudalism",
				"salience": 0.011436783,
				"type": "OTHER"
			},
			{
				"name": "scythe",
				"salience": 0.010861212,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Civilization",
				"salience": 0.010799678,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.010626947,
				"type": "PERSON"
			},
			{
				"name": "Worst",
				"salience": 0.009995884,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.009027493,
				"type": "OTHER"
			},
			{
				"name": "survivalists",
				"salience": 0.009027493,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.008543715,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.00851525,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.00831341,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.007819406,
				"type": "PERSON"
			},
			{
				"name": "Fundamentalists",
				"salience": 0.007819406,
				"type": "PERSON"
			},
			{
				"name": "brother",
				"salience": 0.007819406,
				"type": "PERSON"
			},
			{
				"name": "stripes",
				"salience": 0.007819406,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.007819406,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.007819406,
				"type": "OTHER"
			},
			{
				"name": "ideologues",
				"salience": 0.007819406,
				"type": "PERSON"
			},
			{
				"name": "demise",
				"salience": 0.007819406,
				"type": "EVENT"
			},
			{
				"name": "mind",
				"salience": 0.007819406,
				"type": "OTHER"
			},
			{
				"name": "collapse",
				"salience": 0.007819406,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.0077210595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0_j65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serfdom"
				},
				"name": "Serfdom",
				"salience": 0.007544252,
				"type": "OTHER"
			},
			{
				"name": "agriculture",
				"salience": 0.007487598,
				"type": "OTHER"
			},
			{
				"name": "FIRE",
				"salience": 0.007487598,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0071596443,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.006980643,
				"type": "OTHER"
			},
			{
				"name": "farmers",
				"salience": 0.006679395,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.0065930127,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0063885883,
				"type": "OTHER"
			},
			{
				"name": "fortresses",
				"salience": 0.006020744,
				"type": "LOCATION"
			},
			{
				"name": "irony",
				"salience": 0.005916441,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0059005846,
				"type": "OTHER"
			},
			{
				"name": "farming",
				"salience": 0.0057751345,
				"type": "OTHER"
			},
			{
				"name": "tyrants",
				"salience": 0.0056147603,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0051348046,
				"type": "LOCATION"
			},
			{
				"name": "Civilization",
				"salience": 0.0050222534,
				"type": "OTHER"
			},
			{
				"name": "surpluses",
				"salience": 0.0048943674,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.004834971,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.004757501,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.004757501,
				"type": "OTHER"
			},
			{
				"name": "protection racket",
				"salience": 0.0046813567,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.004459545,
				"type": "LOCATION"
			},
			{
				"name": "slaves",
				"salience": 0.004459545,
				"type": "PERSON"
			},
			{
				"name": "calculations",
				"salience": 0.004366945,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.00412012,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.004100747,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.004100747,
				"type": "OTHER"
			},
			{
				"name": "seed crystals",
				"salience": 0.0040723397,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.0040723397,
				"type": "OTHER"
			},
			{
				"name": "estimate",
				"salience": 0.0039962977,
				"type": "OTHER"
			},
			{
				"name": "legs",
				"salience": 0.0039704326,
				"type": "OTHER"
			},
			{
				"name": "farmers",
				"salience": 0.003850363,
				"type": "PERSON"
			},
			{
				"name": "farmers",
				"salience": 0.003850363,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.0038005253,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0037203205,
				"type": "LOCATION"
			},
			{
				"name": "age",
				"salience": 0.0037203205,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.003703714,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0036272125,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0035364318,
				"type": "LOCATION"
			},
			{
				"name": "doubt",
				"salience": 0.0033616233,
				"type": "OTHER"
			},
			{
				"name": "fortresses",
				"salience": 0.003319287,
				"type": "OTHER"
			},
			{
				"name": "farming",
				"salience": 0.00326551,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0032362055,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.0032217577,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0032217577,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.0032217577,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0032217577,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.003212019,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.003212019,
				"type": "OTHER"
			},
			{
				"name": "slavery",
				"salience": 0.0031673468,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.003127455,
				"type": "LOCATION"
			},
			{
				"name": "slavery",
				"salience": 0.003127455,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.003127455,
				"type": "LOCATION"
			},
			{
				"name": "human life",
				"salience": 0.0030762232,
				"type": "OTHER"
			},
			{
				"name": "warming",
				"salience": 0.0030654937,
				"type": "EVENT"
			},
			{
				"name": "threat",
				"salience": 0.0030396,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0030107656,
				"type": "LOCATION"
			},
			{
				"name": "slaves",
				"salience": 0.0030107656,
				"type": "PERSON"
			},
			{
				"name": "existence",
				"salience": 0.0028893284,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.002875738,
				"type": "OTHER"
			},
			{
				"name": "apotheosis",
				"salience": 0.0028744198,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.002802464,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0026088653,
				"type": "OTHER"
			},
			{
				"name": "tyrant",
				"salience": 0.0026088653,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.0025656754,
				"type": "OTHER"
			},
			{
				"name": "Life",
				"salience": 0.0024798724,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.0023589,
				"type": "OTHER"
			},
			{
				"name": "subsistence existence",
				"salience": 0.0023589,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.0023589,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.0022708667,
				"type": "OTHER"
			},
			{
				"name": "improvement",
				"salience": 0.0022591471,
				"type": "OTHER"
			},
			{
				"name": "extinction",
				"salience": 0.0022591471,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.0022591471,
				"type": "LOCATION"
			},
			{
				"name": "civilization",
				"salience": 0.002231709,
				"type": "OTHER"
			},
			{
				"name": "raiders",
				"salience": 0.002174834,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.002174834,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.002174834,
				"type": "OTHER"
			},
			{
				"name": "enterprise",
				"salience": 0.002174834,
				"type": "OTHER"
			},
			{
				"name": "owners",
				"salience": 0.002174834,
				"type": "PERSON"
			},
			{
				"name": "enslavers",
				"salience": 0.002174834,
				"type": "PERSON"
			},
			{
				"name": "efficiency",
				"salience": 0.002174834,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.002174834,
				"type": "OTHER"
			},
			{
				"name": "human beings",
				"salience": 0.0021474343,
				"type": "PERSON"
			},
			{
				"name": "temperature",
				"salience": 0.0021298914,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0021298914,
				"type": "ORGANIZATION"
			},
			{
				"name": "farmers protection",
				"salience": 0.0021030577,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0020503993,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0y3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adam_and_Eve"
				},
				"name": "Adam and Eve",
				"salience": 0.0019833026,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0019075169,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.0018443435,
				"type": "LOCATION"
			},
			{
				"name": "surface",
				"salience": 0.0018443435,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0018443435,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0018443435,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.0017622275,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0017622275,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0016671926,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0016671926,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0015056675,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06cmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roman_Empire"
				},
				"name": "Roman Empire",
				"salience": 0.0014629231,
				"type": "ORGANIZATION"
			},
			{
				"name": "mountains",
				"salience": 0.0014494624,
				"type": "LOCATION"
			},
			{
				"name": "point",
				"salience": 0.001377771,
				"type": "OTHER"
			},
			{
				"name": "yard",
				"salience": 0.001377771,
				"type": "LOCATION"
			},
			{
				"name": "spouse",
				"salience": 0.001377771,
				"type": "PERSON"
			},
			{
				"name": "blaze",
				"salience": 0.001377771,
				"type": "OTHER"
			},
			{
				"name": "hair",
				"salience": 0.001377771,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.001377771,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0013604091,
				"type": "OTHER"
			},
			{
				"name": "air conditioners",
				"salience": 0.0013492929,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0012931206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03jm5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House"
				},
				"name": "HOUSE",
				"salience": 0.0012620456,
				"type": "ORGANIZATION"
			},
			{
				"name": "climate",
				"salience": 0.001221197,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.0011588128,
				"type": "OTHER"
			},
			{
				"name": "air conditioners",
				"salience": 0.0011588128,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011072085,
				"type": "PERSON"
			},
			{
				"name": "mess",
				"salience": 0.0010034146,
				"type": "OTHER"
			},
			{
				"name": "coal",
				"salience": 0.0010034146,
				"type": "OTHER"
			},
			{
				"name": "carbon dioxide",
				"salience": 0.0010034146,
				"type": "OTHER"
			},
			{
				"name": "gases",
				"salience": 0.0010034146,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.0010034146,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.0010034146,
				"type": "LOCATION"
			},
			{
				"name": "Fans",
				"salience": 0.0010034146,
				"type": "PERSON"
			},
			{
				"name": "fraction",
				"salience": 0.0010034146,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.0010034146,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.00096595264,
				"type": "OTHER"
			},
			{
				"name": "agriculture",
				"salience": 0.0009587285,
				"type": "OTHER"
			},
			{
				"name": "temperatures",
				"salience": 0.00086561666,
				"type": "OTHER"
			},
			{
				"name": "dislocations",
				"salience": 0.0008401642,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0007495275,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.0007495275,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07c37",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_Hobbes"
				},
				"name": "Thomas Hobbes",
				"salience": 0.00028848063,
				"type": "PERSON"
			},
			{
				"name": "Gene Wilder",
				"salience": 0.0002154765,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Global_Warming_ee550.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 18.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "2 Shares\n1 0 0 1\nIt looks as though civilization is under attack. Fundamentalists of various stripes, survivalists, and certain ideologues seem to be, at worst, determined to bring about its collapse. Worst of all, to my mind, the general population gazes upon the looming demise of civilization with an apparent indifference that is astonishing.\nScientifically, the exact process by which civilization got started is not known. It is known to have something to do with the development of farming.\nEven the Bible endorses that, for those who know the story of Cain, the farmer who killed his brother Abel and is credited with building the world's first city. (Technically, \"civilization\" means \"living in cities.\") Also, any estimated age of Earth that I have seen that was calculated using the Bible (which calculations always start with Cain's parents, Adam and Eve) has turned out to be a fair-to-excellent estimate of the age of civilization.\nAt any rate, farming made relatively large surpluses of food possible. That allowed for the existence of significant numbers of people who were not concerned with procuring food, other than to own a farm, buy food, or, in the case of slaves, have it provided by their owners.\nThere is no doubt that slavery was present from the beginning of civilization. My theory is that groups of warrior-like people offered farmers protection from raiders in exchange for food. Then they realized that they could turn their enterprise into a protection racket, in which they extorted most of the food from the farmers. Before long, they realized that maximum efficiency would be achieved by simply enslaving the farmers.\nThe enslavers also used slaves to build fortresses. Those fortresses became the seed crystals of cities, where people could live and be protected from the worst the world had to offer by submitting to the local tyrant.\nAs local tyrants conquered more territory their wealth grew and so did their cities. The Roman Empire was the apotheosis of that process.\n[Serfdom, the slightest possible moral improvement over slavery, was the basis of feudalism, which technically was not civilization because it was not predicated on the existence of cities.]\nCivilization is now threatened with extinction. It might not be much morally, but materially it is all we've got. Civilization as we know it does at least protect the farmers without extorting or enslaving them.\nIf civilization were to collapse there is no doubt that some human beings in small groups would be able to scratch out a subsistence existence here and there. Life would surely be, as Thomas Hobbes would say, \"nasty, brutish, and short,\" but human life would continue in some form.\nOr, we can make the effort to save civilization. If we want to avoid the worst, we have to start immediately.\nThe primary threat to civilization is a material threat. It is a scythe aimed at the legs upon which civilization has always stood: farming.\nThe threat is global warming. The temperature of the air and the water on surface of this planet is increasing.\nPeople who deny that global warming is happening are being irrational. I don't endorse locking them up, but I do endorse ignoring them while those of us who are not irrational (in that way, anyway) get on with saving civilization.\nFor as long as civilization has existed, Earth has had a stable-enough climate that has supported large-scale agriculture. Now that is changing.\nSome people seem to think that we can simply shift crops northward to suit the new temperatures. That would be wrong.\nGlobal warming will create such climatic dislocations that agriculture as we know it will cease to exist. If agriculture as we know it ceases to exist, civilization will cease to exist.\nThe ultimate cause of global warming is beside the point. Arguing about that is like standing in the yard while one's house is on fire, arguing with one's spouse about the cause of the blaze. As the late, great Gene Wilder would doubtlessly say, eyes and hair equally wild, The... HOUSE... is on... FIRE . PUT... the FIRE ... OUT !\nWhatever is the cause of global warming, we only have one response available to us. We have to reduce the amount of carbon dioxide and other heat-trapping gases being disgorged into the atmosphere.\nOne big thing we can do immediately is to turn off our air conditioners wherever that is at all feasible. (Modern high-rises don't permit it, but it can be done everywhere else.) Fans consume a small fraction of the electricity that air conditioners do. It is a great irony that burning mountains of coal to make ourselves cooler has contributed to getting us into this mess, but there you go.\nThe survival of civilization depends upon stopping global warming... now! If we fail to do that, civilization is kaput.",
		"thread_title": "Shall We Save Civilization, or Not? - American Herald Tribune",
		"title": "Shall We Save Civilization, or Not? - American Herald Tribune",
		"type": "bs",
		"uuid": "14c64e14d0b1b5d17d4a3975b92cf63a5d983f53"
	},
	"-KhIbKHHVOBaZh-6_YfA": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-03T18:03:57.355+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "1st Lt. Salam",
				"salience": 0.13192444,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.101022646,
				"type": "ORGANIZATION"
			},
			{
				"name": "lieutenant",
				"salience": 0.09182948,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.08322697,
				"type": "LOCATION"
			},
			{
				"name": "father",
				"salience": 0.038595464,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.03853709,
				"type": "LOCATION"
			},
			{
				"name": "nephew",
				"salience": 0.032922216,
				"type": "PERSON"
			},
			{
				"name": "carnage",
				"salience": 0.030377666,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.030377666,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.030377666,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.024460278,
				"type": "LOCATION"
			},
			{
				"name": "mother",
				"salience": 0.020445304,
				"type": "PERSON"
			},
			{
				"name": "special forces",
				"salience": 0.017986577,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.01764274,
				"type": "PERSON"
			},
			{
				"name": "nephew",
				"salience": 0.015952963,
				"type": "PERSON"
			},
			{
				"name": "checkpoint",
				"salience": 0.015586726,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.015586726,
				"type": "OTHER"
			},
			{
				"name": "soldier",
				"salience": 0.011940418,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.011647104,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.009611295,
				"type": "LOCATION"
			},
			{
				"name": "Golden Division",
				"salience": 0.009611295,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0094943885,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0094943885,
				"type": "LOCATION"
			},
			{
				"name": "producer",
				"salience": 0.009342701,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.008481401,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.008224386,
				"type": "ORGANIZATION"
			},
			{
				"name": "soldier",
				"salience": 0.008224386,
				"type": "PERSON"
			},
			{
				"name": "faces",
				"salience": 0.007427459,
				"type": "OTHER"
			},
			{
				"name": "outskirts",
				"salience": 0.006433324,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.006433324,
				"type": "PERSON"
			},
			{
				"name": "east",
				"salience": 0.006433324,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0060124914,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.005813655,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0057702493,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0055551673,
				"type": "ORGANIZATION"
			},
			{
				"name": "faces",
				"salience": 0.0052106967,
				"type": "OTHER"
			},
			{
				"name": "knees",
				"salience": 0.0045128055,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0045128055,
				"type": "OTHER"
			},
			{
				"name": "joy",
				"salience": 0.0045128055,
				"type": "OTHER"
			},
			{
				"name": "brother",
				"salience": 0.004344524,
				"type": "PERSON"
			},
			{
				"name": "adults",
				"salience": 0.004344524,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09tzx0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bartella"
				},
				"name": "Bartella",
				"salience": 0.003962204,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0039151404,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mosul ISIS",
				"salience": 0.0038686565,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0038198275,
				"type": "ORGANIZATION"
			},
			{
				"name": "Civilians",
				"salience": 0.0036847896,
				"type": "PERSON"
			},
			{
				"name": "Breathing Problems",
				"salience": 0.0036847896,
				"type": "OTHER"
			},
			{
				"name": "plotters",
				"salience": 0.0036847896,
				"type": "OTHER"
			},
			{
				"name": "grave",
				"salience": 0.0036847896,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0036847896,
				"type": "OTHER"
			},
			{
				"name": "rebellion",
				"salience": 0.0036847896,
				"type": "EVENT"
			},
			{
				"name": "air raid",
				"salience": 0.0036847896,
				"type": "EVENT"
			},
			{
				"name": "family",
				"salience": 0.0035319242,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0032876334,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0031791802,
				"type": "LOCATION"
			},
			{
				"name": "Iraqi Soldiers Erect Cross",
				"salience": 0.0027786756,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0027786756,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wb7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Church_(building)"
				},
				"name": "Church",
				"salience": 0.0027786756,
				"type": "ORGANIZATION"
			},
			{
				"name": "positions",
				"salience": 0.002753121,
				"type": "OTHER"
			},
			{
				"name": "air strikes",
				"salience": 0.002753121,
				"type": "EVENT"
			},
			{
				"name": "opportunity",
				"salience": 0.002753121,
				"type": "OTHER"
			},
			{
				"name": "nightmare",
				"salience": 0.002753121,
				"type": "EVENT"
			},
			{
				"name": "Mosul US",
				"salience": 0.0022685921,
				"type": "OTHER"
			},
			{
				"name": "Torches Sulphur Plant",
				"salience": 0.0022685921,
				"type": "LOCATION"
			},
			{
				"name": "Mosul Thousand",
				"salience": 0.0022685921,
				"type": "LOCATION"
			},
			{
				"name": "Karamless Village",
				"salience": 0.0022685921,
				"type": "LOCATION"
			},
			{
				"name": "doorstep",
				"salience": 0.0020053529,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0020053529,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.001914741,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.0017300507,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.0013999447,
				"type": "PERSON"
			},
			{
				"name": "Bazwaya",
				"salience": 0.00092205824,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Iraqi_Soldier_Family_Mosul_737bc.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.004",
		"text": "14 Shares\n4 9 0 1\nIt's a heartwarming moment amid the carnage of the battle to liberate Mosul.\nAn Iraqi lieutenant -- part of the elite Golden Division special forces fighting to take back Iraq's second city from ISIS -- was stationed at a checkpoint in Bartella, about 25 kilometers to the east of the city, when he spotted some familiar faces Tuesday.\nAmid a group of refugees fleeing the city's outskirts were his mother, his father, and his nephew, whom the soldier had been separated from for over two years.\nThe soldier gave his name as 1st. Lt. Salam to the CNN producer who captured the moment.\nAfter embracing a group of adults, including his mother, father and brother, he picks up his young nephew and holds him, walking away from the group. He then falls to his knees and kisses him, before picking him up and carrying him away. The joy on both their faces obvious to all.\nMORE... Muslim Iraqi Soldiers Erect Cross on Top of the Church in Newly Liberated Karamless Village Near Mosul Thousand of Iraqi Civilians Treated for Breathing Problems after ISIS Torches Sulphur Plant near Mosul ISIS executes 58 plotters, buries in mass grave amid reports on rebellion in Mosul US-led air raid kills 20 Iraqi pro-government fighters 1st Lt. Salam later told CNN his family flewitd Bazwaya a mere hour after ISIS turned up at their house and ordered them to go to Mosul.\nHe says his father asked the ISIS fighters if he could have a few minutes to get his family. His father then went back to his house to collect them. Not long after that, coalition air strikes hit ISIS positions in the city, giving the family an opportunity to escape.\n1st Lt. Salam says the last two and a half years have been a \"living nightmare\" and that he still can't believe his family are alive.\nIraqi forces were on the doorstep of ISIS-held Mosul on Tuesday, the closest they've been since launching an operation two weeks ago to wrest the city from more than two years of ISIS rule.",
		"thread_title": "Iraqi Soldier Battling in Mosul Reunited with His Family After Two Years of Estrangement",
		"title": "Iraqi Soldier Battling in Mosul Reunited with His Family After Two Years of Estrangement",
		"type": "bs",
		"uuid": "d88bb8271ae6131f88765724298cd6649c9e9a6c"
	},
	"-KhIbKPqirpPnY7MrXIq": {
		"author": "BarbaraMcK42",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-04T11:45:39.751+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "White Helmets",
				"salience": 0.19459489,
				"type": "ORGANIZATION"
			},
			{
				"name": "White Helmets",
				"salience": 0.11707805,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "questions",
				"salience": 0.06968145,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.044470157,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.040120352,
				"type": "ORGANIZATION"
			},
			{
				"name": "Government Organisations",
				"salience": 0.040120352,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.03942079,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.031470206,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.031470206,
				"type": "OTHER"
			},
			{
				"name": "NGO's",
				"salience": 0.031470206,
				"type": "ORGANIZATION"
			},
			{
				"name": "author",
				"salience": 0.02232485,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.018955274,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.018563978,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bibliography",
				"salience": 0.016161006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rpw9l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Avaaz"
				},
				"name": "Avaaz",
				"salience": 0.014766189,
				"type": "ORGANIZATION"
			},
			{
				"name": "author",
				"salience": 0.013316977,
				"type": "PERSON"
			},
			{
				"name": "organisation",
				"salience": 0.00908774,
				"type": "ORGANIZATION"
			},
			{
				"name": "propaganda",
				"salience": 0.008531008,
				"type": "OTHER"
			},
			{
				"name": "somewhere",
				"salience": 0.0077047227,
				"type": "LOCATION"
			},
			{
				"name": "functions",
				"salience": 0.0077047227,
				"type": "OTHER"
			},
			{
				"name": "video evidence",
				"salience": 0.0077047227,
				"type": "OTHER"
			},
			{
				"name": "video footage",
				"salience": 0.0071415524,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.0066738576,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0066738576,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.0066738576,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.0066738576,
				"type": "OTHER"
			},
			{
				"name": "evaluation",
				"salience": 0.0055901213,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.005405897,
				"type": "OTHER"
			},
			{
				"name": "video evidence",
				"salience": 0.005204417,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.005204417,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.005204417,
				"type": "PERSON"
			},
			{
				"name": "rescue workers",
				"salience": 0.005204417,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0049880845,
				"type": "OTHER"
			},
			{
				"name": "props",
				"salience": 0.004888544,
				"type": "OTHER"
			},
			{
				"name": "propaganda purposes",
				"salience": 0.004888544,
				"type": "OTHER"
			},
			{
				"name": "salaries",
				"salience": 0.004682049,
				"type": "OTHER"
			},
			{
				"name": "rescue scenes",
				"salience": 0.004682049,
				"type": "WORK_OF_ART"
			},
			{
				"name": "claim",
				"salience": 0.0045649493,
				"type": "OTHER"
			},
			{
				"name": "SCD",
				"salience": 0.0045075,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.0045075,
				"type": "EVENT"
			},
			{
				"name": "casualties",
				"salience": 0.0045075,
				"type": "OTHER"
			},
			{
				"name": "footage",
				"salience": 0.0044144522,
				"type": "WORK_OF_ART"
			},
			{
				"name": "uniforms",
				"salience": 0.0044144522,
				"type": "OTHER"
			},
			{
				"name": "uniforms",
				"salience": 0.0044144522,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0042006136,
				"type": "LOCATION"
			},
			{
				"name": "extremist groups",
				"salience": 0.003823162,
				"type": "ORGANIZATION"
			},
			{
				"name": "torture",
				"salience": 0.003823162,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.003823162,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.003823162,
				"type": "OTHER"
			},
			{
				"name": "prisoners",
				"salience": 0.003823162,
				"type": "PERSON"
			},
			{
				"name": "abuse",
				"salience": 0.003823162,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0036805873,
				"type": "OTHER"
			},
			{
				"name": "function",
				"salience": 0.0036045853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0032750382,
				"type": "LOCATION"
			},
			{
				"name": "issue",
				"salience": 0.0030435217,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g7hr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_and_Commonwealth_Office"
				},
				"name": "Foreign Office",
				"salience": 0.0028831712,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00285666,
				"type": "EVENT"
			},
			{
				"name": "nothing",
				"salience": 0.00285666,
				"type": "OTHER"
			},
			{
				"name": "propagandist-terrorist",
				"salience": 0.00285666,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.00285666,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mistakes",
				"salience": 0.002581226,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0025487172,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.002402935,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07l57d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib"
				},
				"name": "Idlib",
				"salience": 0.0023539744,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.0023539744,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.001988234,
				"type": "ORGANIZATION"
			},
			{
				"name": "organisations",
				"salience": 0.001988234,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0019477605,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.0017952195,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0017952195,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0017952195,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0017952195,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025szt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/No-fly_zone"
				},
				"name": "No-Fly Zone",
				"salience": 0.0017586331,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.0015545494,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0015545494,
				"type": "OTHER"
			},
			{
				"name": "wash",
				"salience": 0.0015545494,
				"type": "LOCATION"
			},
			{
				"name": "bodies",
				"salience": 0.0014045945,
				"type": "ORGANIZATION"
			},
			{
				"name": "policy",
				"salience": 0.0013868966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0012808825,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0012808825,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0010725225,
				"type": "LOCATION"
			},
			{
				"name": "view",
				"salience": 0.00092428667,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/white-helmets_566c9.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-04T06:21:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 7.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "The article explains a lot of the background to the White Helmets and asks some important questions about the relations between government and NGO's, or as the author terms them 'Near-Government Organisations. The author should also be commended for the extensive bibliography.\nThe author suggests that the truth about the White Helmets may lie somewhere in the middle, that the White Helmets is a dual-purpose organisation with both humanitarian and propaganda functions.\nThe author offers no evaluation of the video evidence provided by the White Helmets, which to a number of people seems incontrovertably fake and staged. If this video evidence is indeed faked, then it invites the question: why is this necessary? where are all the real casualties? Hasn't the Russian bombing killed any civilians at all?\n\"The SCD or White Helmets counts nearly 3,000 rescue workers\" This claim comes only from the White Helmets. It could well be that the Foreign Office is paying for 3,000 salaries, but whether those drawing\nthem are occupied in full-time humanitarian work is another matter.\nAfter watching carefully the dubious video footage of rescue scenes, and the far more convincing footage of White Helmets participating in torture and abuse of prisoners, it is difficult to see how the White\nHelmets are anything more than a set of expensive props and uniforms, provided to extremist groups in Aleppo and Idlib and donned for propaganda purposes, or when other uniforms are in the wash.\nFurthermore, given that the White Helmets are funded by the governments and organisations who are totally unmoved by the plight of civilians in the greater part of Syria, the idea that these bodies would pay for humanitarian duties on the part of the White Helmets seems somewhat optimistic.\nIf the White Helmets are have a dual-purpose function, it is not propagandist-humanitarian, but propagandist-terrorist.\nI would also take issue with the statement 'The sad thing is that [Avaaz] has learned nothing from its own campaign for a No-Fly Zone in Libya'. This view, like the idea that the US etc keep making 'mistakes', is 'following a mistaken policy', presupposes that Avaaz is well-intentioned, that it opposes the destruction of Iraq, Libya, Syria (Iran, Russia ...)",
		"thread_title": "How Grey are the White Helmets and Their Backers?",
		"title": "",
		"type": "bs",
		"uuid": "4117842dadca66dc30787854e964bcae4605982b"
	},
	"-KhIbLAVr46jJ4svbPe2": {
		"author": "Richard Behan",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-04T11:52:33.262+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Secretary Clinton",
				"salience": 0.23362815,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.0948158,
				"type": "PERSON"
			},
			{
				"name": "elite",
				"salience": 0.032734368,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.030839628,
				"type": "PERSON"
			},
			{
				"name": "wealth-holders",
				"salience": 0.027515026,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.020605642,
				"type": "LOCATION"
			},
			{
				"name": "wealth",
				"salience": 0.019537866,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.013711912,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.009896084,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.008467499,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.008410668,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.007932747,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06slz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Timothy_Geithner"
				},
				"name": "Timothy Geithner",
				"salience": 0.007429041,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Senator Sanders",
				"salience": 0.0073069436,
				"type": "PERSON"
			},
			{
				"name": "strategy",
				"salience": 0.0071376394,
				"type": "OTHER"
			},
			{
				"name": "oligarchs",
				"salience": 0.0067292196,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02wr9k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Rubin"
				},
				"name": "Robert Rubin",
				"salience": 0.005449087,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.005185655,
				"type": "EVENT"
			},
			{
				"name": "compatriots",
				"salience": 0.005158302,
				"type": "PERSON"
			},
			{
				"name": "Scott Foval",
				"salience": 0.004677507,
				"type": "PERSON"
			},
			{
				"name": "ethics",
				"salience": 0.0042365766,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.004176232,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0040053143,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.0038854585,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.0036220306,
				"type": "ORGANIZATION"
			},
			{
				"name": "bankers",
				"salience": 0.0036118908,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0vj4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dick_Cheney"
				},
				"name": "Richard Cheney",
				"salience": 0.0035950744,
				"type": "PERSON"
			},
			{
				"name": "welfare",
				"salience": 0.0035554988,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00353977,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00353977,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0034321663,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0034321663,
				"type": "EVENT"
			},
			{
				"name": "stratum",
				"salience": 0.0033180455,
				"type": "OTHER"
			},
			{
				"name": "stratum",
				"salience": 0.0033180455,
				"type": "OTHER"
			},
			{
				"name": "interdependence",
				"salience": 0.0031962963,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0031962963,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0031962963,
				"type": "PERSON"
			},
			{
				"name": "grouping",
				"salience": 0.0030654673,
				"type": "OTHER"
			},
			{
				"name": "paper trails",
				"salience": 0.0030363002,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0029236034,
				"type": "ORGANIZATION"
			},
			{
				"name": "Field Director",
				"salience": 0.0028989115,
				"type": "PERSON"
			},
			{
				"name": "investment bankers",
				"salience": 0.0027679703,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04cmyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Debbie_Wasserman_Schultz"
				},
				"name": "Wasserman-Schultz",
				"salience": 0.0027384057,
				"type": "PERSON"
			},
			{
				"name": "Clintons",
				"salience": 0.0026080331,
				"type": "ORGANIZATION"
			},
			{
				"name": "oligarchs",
				"salience": 0.0025945443,
				"type": "OTHER"
			},
			{
				"name": "contractors",
				"salience": 0.0025945443,
				"type": "PERSON"
			},
			{
				"name": "consultants",
				"salience": 0.0025945443,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.0025592851,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0025538248,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.002480638,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0024150438,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0024020467,
				"type": "OTHER"
			},
			{
				"name": "directors",
				"salience": 0.0023969926,
				"type": "PERSON"
			},
			{
				"name": "Others",
				"salience": 0.0023969926,
				"type": "PERSON"
			},
			{
				"name": "investors",
				"salience": 0.0023969926,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.0023969926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dfb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citigroup"
				},
				"name": "Citigroup",
				"salience": 0.002392107,
				"type": "ORGANIZATION"
			},
			{
				"name": "spectacle",
				"salience": 0.0023442754,
				"type": "OTHER"
			},
			{
				"name": "description",
				"salience": 0.0021821423,
				"type": "OTHER"
			},
			{
				"name": "football games",
				"salience": 0.0021688824,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "exposure",
				"salience": 0.0021688824,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0021643185,
				"type": "OTHER"
			},
			{
				"name": "domestic",
				"salience": 0.0021643185,
				"type": "LOCATION"
			},
			{
				"name": "suppliers",
				"salience": 0.0021643185,
				"type": "ORGANIZATION"
			},
			{
				"name": "wealthy",
				"salience": 0.0021643185,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.0021643185,
				"type": "OTHER"
			},
			{
				"name": "incomes",
				"salience": 0.0021643185,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.0021643185,
				"type": "PERSON"
			},
			{
				"name": "law firms",
				"salience": 0.0021643185,
				"type": "ORGANIZATION"
			},
			{
				"name": "names",
				"salience": 0.0021643185,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0021606858,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Executive_(government)"
				},
				"name": "Executive Branch",
				"salience": 0.0020617384,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07r8cv9"
				},
				"name": "Senator",
				"salience": 0.0019950937,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0018741903,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0018741903,
				"type": "OTHER"
			},
			{
				"name": "net worth",
				"salience": 0.0018741903,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0018741903,
				"type": "OTHER"
			},
			{
				"name": "precedent",
				"salience": 0.0018741903,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.0018741903,
				"type": "PERSON"
			},
			{
				"name": "general",
				"salience": 0.0018741903,
				"type": "PERSON"
			},
			{
				"name": "cohort",
				"salience": 0.0018741903,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ways",
				"salience": 0.0018741903,
				"type": "OTHER"
			},
			{
				"name": "hedge fund managers",
				"salience": 0.0018741903,
				"type": "PERSON"
			},
			{
				"name": "motherfucker",
				"salience": 0.0018741903,
				"type": "PERSON"
			},
			{
				"name": "factor",
				"salience": 0.0018741903,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.0018741903,
				"type": "EVENT"
			},
			{
				"name": "benefactors",
				"salience": 0.0018741903,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0017628473,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03n1q0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donna_Brazile"
				},
				"name": "Donna Brazile",
				"salience": 0.0017468398,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greeks",
				"salience": 0.0017197371,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.0017158096,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0017158096,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0017158096,
				"type": "OTHER"
			},
			{
				"name": "Democracy",
				"salience": 0.0017158096,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.001679581,
				"type": "OTHER"
			},
			{
				"name": "configurations",
				"salience": 0.0016612512,
				"type": "OTHER"
			},
			{
				"name": "Alterations",
				"salience": 0.0016612512,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0016242926,
				"type": "PERSON"
			},
			{
				"name": "executives",
				"salience": 0.001552418,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/080t3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lloyd_Blankfein"
				},
				"name": "Lloyd Blankfein",
				"salience": 0.0015056052,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.0014995374,
				"type": "OTHER"
			},
			{
				"name": "statesmanship",
				"salience": 0.0014995374,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0014995374,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.001475091,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04sg6z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rachel_Maddow"
				},
				"name": "Rachel Maddow",
				"salience": 0.0014583959,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0014575226,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0014575226,
				"type": "PERSON"
			},
			{
				"name": "paper-trail states",
				"salience": 0.0013806818,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0013806818,
				"type": "ORGANIZATION"
			},
			{
				"name": "strategy",
				"salience": 0.0013661613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0013322482,
				"type": "LOCATION"
			},
			{
				"name": "Americans United for Change",
				"salience": 0.0013322482,
				"type": "ORGANIZATION"
			},
			{
				"name": "wealth",
				"salience": 0.0013159984,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.0013159984,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0012620973,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0012620973,
				"type": "ORGANIZATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.0012620973,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0012620973,
				"type": "LOCATION"
			},
			{
				"name": "policy",
				"salience": 0.0012620973,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0012620973,
				"type": "LOCATION"
			},
			{
				"name": "lightweights",
				"salience": 0.0012267204,
				"type": "PERSON"
			},
			{
				"name": "corporations",
				"salience": 0.0012036533,
				"type": "ORGANIZATION"
			},
			{
				"name": "degree",
				"salience": 0.0011946842,
				"type": "OTHER"
			},
			{
				"name": "wishes",
				"salience": 0.0011647646,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0011581162,
				"type": "OTHER"
			},
			{
				"name": "campaigns",
				"salience": 0.0011564384,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0011564384,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0011564384,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02z84_3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Stumpf"
				},
				"name": "John Stumpf",
				"salience": 0.0011536126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03crtr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jamie_Dimon"
				},
				"name": "Jamie Dimon",
				"salience": 0.0011536126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03wr8k3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brian_Moynihan"
				},
				"name": "Brian Moynihan",
				"salience": 0.0011536126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03d62rz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_P._Gorman"
				},
				"name": "James Gorman",
				"salience": 0.0011536126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04g5mbg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Corbat"
				},
				"name": "Michael Corbat",
				"salience": 0.0011536126,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.0011395408,
				"type": "EVENT"
			},
			{
				"name": "service",
				"salience": 0.0011212837,
				"type": "OTHER"
			},
			{
				"name": "scientists",
				"salience": 0.0011212837,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.0010875295,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0010681036,
				"type": "ORGANIZATION"
			},
			{
				"name": "oligarchs",
				"salience": 0.0010681036,
				"type": "OTHER"
			},
			{
				"name": "Superdelegates",
				"salience": 0.0010681036,
				"type": "PERSON"
			},
			{
				"name": "conspiracy",
				"salience": 0.0010681036,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0010681036,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0010681036,
				"type": "OTHER"
			},
			{
				"name": "Representative",
				"salience": 0.0010413529,
				"type": "PERSON"
			},
			{
				"name": "terms",
				"salience": 0.0010068585,
				"type": "OTHER"
			},
			{
				"name": "lobbying",
				"salience": 0.000999329,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.000998631,
				"type": "WORK_OF_ART"
			},
			{
				"name": "voting",
				"salience": 0.000991163,
				"type": "EVENT"
			},
			{
				"name": "manufacturing jobs",
				"salience": 0.0009867352,
				"type": "OTHER"
			},
			{
				"name": "Email Investigation",
				"salience": 0.0009867352,
				"type": "WORK_OF_ART"
			},
			{
				"name": "margin",
				"salience": 0.0009867352,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.0009867352,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0009867352,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0009620502,
				"type": "OTHER"
			},
			{
				"name": "campaign funding",
				"salience": 0.0009620217,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.0009613497,
				"type": "OTHER"
			},
			{
				"name": "stranglehold",
				"salience": 0.00095783547,
				"type": "OTHER"
			},
			{
				"name": "delegates",
				"salience": 0.00090851163,
				"type": "PERSON"
			},
			{
				"name": "wealthy",
				"salience": 0.0008909092,
				"type": "PERSON"
			},
			{
				"name": "dominance",
				"salience": 0.0008909092,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0008909092,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0008909092,
				"type": "OTHER"
			},
			{
				"name": "incomes",
				"salience": 0.0008909092,
				"type": "OTHER"
			},
			{
				"name": "decay",
				"salience": 0.0008909092,
				"type": "OTHER"
			},
			{
				"name": "enterprise",
				"salience": 0.0008909092,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0008909092,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0008909092,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.00088883535,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00088821445,
				"type": "OTHER"
			},
			{
				"name": "household wealth",
				"salience": 0.00088821445,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0008518292,
				"type": "ORGANIZATION"
			},
			{
				"name": "administrations",
				"salience": 0.0008518292,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00083422026,
				"type": "PERSON"
			},
			{
				"name": "primaries",
				"salience": 0.000822747,
				"type": "EVENT"
			},
			{
				"name": "corporations",
				"salience": 0.0008123779,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporations",
				"salience": 0.0008123779,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporation",
				"salience": 0.0008123779,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.00079892884,
				"type": "OTHER"
			},
			{
				"name": "Senator",
				"salience": 0.00079892884,
				"type": "PERSON"
			},
			{
				"name": "strategy",
				"salience": 0.00079189846,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0007853356,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "neglect",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "accident",
				"salience": 0.00077143434,
				"type": "EVENT"
			},
			{
				"name": "Anointment",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "banana republic",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "preeminence",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "mega-corporations",
				"salience": 0.00077143434,
				"type": "ORGANIZATION"
			},
			{
				"name": "Demise",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "privilege",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.00077143434,
				"type": "PERSON"
			},
			{
				"name": "imperative",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "acquaintance",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "mindset",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00077143434,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.0007691008,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0007691008,
				"type": "ORGANIZATION"
			},
			{
				"name": "billions",
				"salience": 0.0007691008,
				"type": "OTHER"
			},
			{
				"name": "Elites",
				"salience": 0.0007638451,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.00075320154,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00074883865,
				"type": "EVENT"
			},
			{
				"name": "more",
				"salience": 0.00074883865,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.00074883865,
				"type": "OTHER"
			},
			{
				"name": "contributions",
				"salience": 0.00074883865,
				"type": "OTHER"
			},
			{
				"name": "Representative",
				"salience": 0.00074883865,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.00074883865,
				"type": "EVENT"
			},
			{
				"name": "governance",
				"salience": 0.00074883865,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00074883865,
				"type": "PERSON"
			},
			{
				"name": "campaign contributions",
				"salience": 0.00074883865,
				"type": "OTHER"
			},
			{
				"name": "campaign expenditures",
				"salience": 0.00074883865,
				"type": "OTHER"
			},
			{
				"name": "oligarchs",
				"salience": 0.00074883865,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0007272803,
				"type": "OTHER"
			},
			{
				"name": "contracts",
				"salience": 0.0007208802,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0007208802,
				"type": "PERSON"
			},
			{
				"name": "representatives",
				"salience": 0.0007208802,
				"type": "PERSON"
			},
			{
				"name": "positions",
				"salience": 0.0007208802,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0007208802,
				"type": "ORGANIZATION"
			},
			{
				"name": "effort",
				"salience": 0.0007102743,
				"type": "OTHER"
			},
			{
				"name": "financing",
				"salience": 0.0007058955,
				"type": "OTHER"
			},
			{
				"name": "capture",
				"salience": 0.00069699873,
				"type": "OTHER"
			},
			{
				"name": "lobbying",
				"salience": 0.00069178577,
				"type": "OTHER"
			},
			{
				"name": "campaign funding",
				"salience": 0.00069178577,
				"type": "OTHER"
			},
			{
				"name": "proportion",
				"salience": 0.00069178577,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.00069178577,
				"type": "OTHER"
			},
			{
				"name": "lobbyist",
				"salience": 0.00069178577,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama Administration",
				"salience": 0.00069039117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025st0_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Bill_Clinton"
				},
				"name": "Bill Clinton Administration",
				"salience": 0.00069039117,
				"type": "ORGANIZATION"
			},
			{
				"name": "primaries",
				"salience": 0.00068888965,
				"type": "EVENT"
			},
			{
				"name": "mainstream media",
				"salience": 0.00068888965,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.00067097537,
				"type": "OTHER"
			},
			{
				"name": "disgust",
				"salience": 0.00067097537,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.000665957,
				"type": "ORGANIZATION"
			},
			{
				"name": "cabinet-level",
				"salience": 0.000665957,
				"type": "OTHER"
			},
			{
				"name": "directors",
				"salience": 0.000665957,
				"type": "PERSON"
			},
			{
				"name": "senior associates",
				"salience": 0.000665957,
				"type": "PERSON"
			},
			{
				"name": "partners",
				"salience": 0.000665957,
				"type": "PERSON"
			},
			{
				"name": "Examples",
				"salience": 0.000665957,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00066251855,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0006521895,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.0006521895,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0006521895,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0006488221,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00064111134,
				"type": "LOCATION"
			},
			{
				"name": "costs",
				"salience": 0.0006245971,
				"type": "OTHER"
			},
			{
				"name": "priority",
				"salience": 0.0006245971,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.0006245971,
				"type": "PERSON"
			},
			{
				"name": "assets",
				"salience": 0.0006245971,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.0006245971,
				"type": "WORK_OF_ART"
			},
			{
				"name": "millions",
				"salience": 0.0006245971,
				"type": "PERSON"
			},
			{
				"name": "costs",
				"salience": 0.0006245971,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.0006245971,
				"type": "OTHER"
			},
			{
				"name": "enterprise",
				"salience": 0.0006245971,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0006245971,
				"type": "OTHER"
			},
			{
				"name": "taxpayers",
				"salience": 0.0006245971,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0006245971,
				"type": "PERSON"
			},
			{
				"name": "mechanisms",
				"salience": 0.0006245971,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0006112973,
				"type": "EVENT"
			},
			{
				"name": "race",
				"salience": 0.0006112973,
				"type": "EVENT"
			},
			{
				"name": "colleagues",
				"salience": 0.0006112973,
				"type": "PERSON"
			},
			{
				"name": "deception",
				"salience": 0.0006112973,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.00060728565,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.00060418085,
				"type": "EVENT"
			},
			{
				"name": "primary election",
				"salience": 0.00060418085,
				"type": "EVENT"
			},
			{
				"name": "grand strategy makers",
				"salience": 0.0006012763,
				"type": "PERSON"
			},
			{
				"name": "grand strategy makers",
				"salience": 0.0006012763,
				"type": "PERSON"
			},
			{
				"name": "taxpayers",
				"salience": 0.0006012763,
				"type": "PERSON"
			},
			{
				"name": "law firms",
				"salience": 0.0006012763,
				"type": "ORGANIZATION"
			},
			{
				"name": "mechanisms",
				"salience": 0.0006012763,
				"type": "OTHER"
			},
			{
				"name": "priority",
				"salience": 0.0006012763,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00059677917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "Bush",
				"salience": 0.0005858716,
				"type": "PERSON"
			},
			{
				"name": "personnel",
				"salience": 0.0005835957,
				"type": "PERSON"
			},
			{
				"name": "authors",
				"salience": 0.0005725067,
				"type": "PERSON"
			},
			{
				"name": "American Grand Strategies",
				"salience": 0.00056748645,
				"type": "OTHER"
			},
			{
				"name": "debates",
				"salience": 0.00056472135,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.00056472135,
				"type": "OTHER"
			},
			{
				"name": "debates",
				"salience": 0.00056472135,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00056472135,
				"type": "PERSON"
			},
			{
				"name": "status quo",
				"salience": 0.00056472135,
				"type": "OTHER"
			},
			{
				"name": "opponent",
				"salience": 0.0005618055,
				"type": "PERSON"
			},
			{
				"name": "prerequisite",
				"salience": 0.0005547244,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0005408288,
				"type": "PERSON"
			},
			{
				"name": "urge",
				"salience": 0.0005408288,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0005408288,
				"type": "OTHER"
			},
			{
				"name": "chest",
				"salience": 0.0005408288,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0005408288,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0005408288,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0005408288,
				"type": "OTHER"
			},
			{
				"name": "campaigning rise",
				"salience": 0.0005408288,
				"type": "EVENT"
			},
			{
				"name": "policy-making independence",
				"salience": 0.0005408288,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00053956965,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.00053956965,
				"type": "ORGANIZATION"
			},
			{
				"name": "democracy",
				"salience": 0.00053425704,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00053425704,
				"type": "OTHER"
			},
			{
				"name": "subprime loan frenzy",
				"salience": 0.0005206351,
				"type": "OTHER"
			},
			{
				"name": "van",
				"salience": 0.0005206351,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "title",
				"salience": 0.0005206351,
				"type": "OTHER"
			},
			{
				"name": "Elite Networks",
				"salience": 0.0005206351,
				"type": "OTHER"
			},
			{
				"name": "lottery",
				"salience": 0.0005206351,
				"type": "OTHER"
			},
			{
				"name": "no-bid",
				"salience": 0.0005206351,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.0005206351,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "repeal",
				"salience": 0.0005206351,
				"type": "OTHER"
			},
			{
				"name": "Primaries",
				"salience": 0.00051457755,
				"type": "EVENT"
			},
			{
				"name": "citizenry",
				"salience": 0.00051457755,
				"type": "PERSON"
			},
			{
				"name": "primaries",
				"salience": 0.00051457755,
				"type": "EVENT"
			},
			{
				"name": "campaigning",
				"salience": 0.0005135635,
				"type": "EVENT"
			},
			{
				"name": "dishonesty",
				"salience": 0.0005098713,
				"type": "OTHER"
			},
			{
				"name": "weekends",
				"salience": 0.0005098713,
				"type": "OTHER"
			},
			{
				"name": "voter database",
				"salience": 0.0005098713,
				"type": "OTHER"
			},
			{
				"name": "weekends",
				"salience": 0.0005098713,
				"type": "OTHER"
			},
			{
				"name": "distortion",
				"salience": 0.0005098713,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0005098713,
				"type": "OTHER"
			},
			{
				"name": "superdelegate endorsements",
				"salience": 0.0005098713,
				"type": "OTHER"
			},
			{
				"name": "caucuses",
				"salience": 0.0005098713,
				"type": "PERSON"
			},
			{
				"name": "ethics",
				"salience": 0.0005098713,
				"type": "OTHER"
			},
			{
				"name": "limits",
				"salience": 0.00050344464,
				"type": "OTHER"
			},
			{
				"name": "tilting",
				"salience": 0.000494878,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0004916874,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.0004911765,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election fraud",
				"salience": 0.00048716206,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.00048716206,
				"type": "OTHER"
			},
			{
				"name": "election fraud",
				"salience": 0.00048716206,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.00048716206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.00047476453,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00047476453,
				"type": "LOCATION"
			},
			{
				"name": "Clinton Could Hasten",
				"salience": 0.00047476453,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.00046834766,
				"type": "OTHER"
			},
			{
				"name": "discrepancies",
				"salience": 0.00045661538,
				"type": "OTHER"
			},
			{
				"name": "expense",
				"salience": 0.00045661538,
				"type": "OTHER"
			},
			{
				"name": "discrepancies",
				"salience": 0.00045661538,
				"type": "OTHER"
			},
			{
				"name": "voting machine counts",
				"salience": 0.00045661538,
				"type": "OTHER"
			},
			{
				"name": "discrepancy",
				"salience": 0.00045661538,
				"type": "OTHER"
			},
			{
				"name": "discrepancies",
				"salience": 0.00045661538,
				"type": "OTHER"
			},
			{
				"name": "counts",
				"salience": 0.00045661538,
				"type": "OTHER"
			},
			{
				"name": "delegate count",
				"salience": 0.00045661538,
				"type": "OTHER"
			},
			{
				"name": "superdelegates",
				"salience": 0.00045661538,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00045380404,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01gz4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohammed_VI_of_Morocco"
				},
				"name": "Mohammed VI of Morocco",
				"salience": 0.000448087,
				"type": "PERSON"
			},
			{
				"name": "rallies",
				"salience": 0.00044712293,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.00044455077,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00044364884,
				"type": "PERSON"
			},
			{
				"name": "superdelegate endorsements",
				"salience": 0.0004434685,
				"type": "OTHER"
			},
			{
				"name": "television journalists",
				"salience": 0.00044148706,
				"type": "PERSON"
			},
			{
				"name": "socialist",
				"salience": 0.00044148706,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.00044148706,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.00044148706,
				"type": "EVENT"
			},
			{
				"name": "each",
				"salience": 0.00044148706,
				"type": "PERSON"
			},
			{
				"name": "candidate space",
				"salience": 0.00044148706,
				"type": "OTHER"
			},
			{
				"name": "print",
				"salience": 0.00044148706,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00044148706,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00044148706,
				"type": "OTHER"
			},
			{
				"name": "guardian",
				"salience": 0.00044148706,
				"type": "OTHER"
			},
			{
				"name": "momentum",
				"salience": 0.00044148706,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00044148706,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.00043999407,
				"type": "PERSON"
			},
			{
				"name": "primary elections",
				"salience": 0.00043999407,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00043999407,
				"type": "EVENT"
			},
			{
				"name": "study",
				"salience": 0.00042690954,
				"type": "OTHER"
			},
			{
				"name": "day jobs",
				"salience": 0.00042182315,
				"type": "OTHER"
			},
			{
				"name": "exit polls",
				"salience": 0.00042182315,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.00042182315,
				"type": "OTHER"
			},
			{
				"name": "voting machine tallies",
				"salience": 0.00042182315,
				"type": "EVENT"
			},
			{
				"name": "voting machine tallies",
				"salience": 0.00042182315,
				"type": "OTHER"
			},
			{
				"name": "margins",
				"salience": 0.00042182315,
				"type": "OTHER"
			},
			{
				"name": "machine tallies",
				"salience": 0.00042182315,
				"type": "EVENT"
			},
			{
				"name": "sides",
				"salience": 0.00041167077,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00040984448,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00040984448,
				"type": "LOCATION"
			},
			{
				"name": "business interests",
				"salience": 0.0004097255,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0004097255,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0003958998,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government policy",
				"salience": 0.0003929385,
				"type": "OTHER"
			},
			{
				"name": "Interest Groups",
				"salience": 0.0003929385,
				"type": "ORGANIZATION"
			},
			{
				"name": "interest groups",
				"salience": 0.0003929385,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporate affiliations",
				"salience": 0.00038889097,
				"type": "ORGANIZATION"
			},
			{
				"name": "connections",
				"salience": 0.00038889097,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05p6s71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citizens_United_v._FEC"
				},
				"name": "Citizens United",
				"salience": 0.00038438843,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00038360854,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00038360854,
				"type": "EVENT"
			},
			{
				"name": "tampering",
				"salience": 0.0003808505,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.0003808505,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0003808505,
				"type": "OTHER"
			},
			{
				"name": "registration tampering",
				"salience": 0.0003808505,
				"type": "OTHER"
			},
			{
				"name": "voter suppression",
				"salience": 0.0003808505,
				"type": "EVENT"
			},
			{
				"name": "convention",
				"salience": 0.0003808505,
				"type": "EVENT"
			},
			{
				"name": "exit poll figures",
				"salience": 0.0003808505,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00037952108,
				"type": "OTHER"
			},
			{
				"name": "edge",
				"salience": 0.00037914884,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.00037473722,
				"type": "EVENT"
			},
			{
				"name": "citizens",
				"salience": 0.00037473722,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.00037473722,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.00037109235,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.00037109235,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.00037006786,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0003700352,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqis",
				"salience": 0.0003700352,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "Associated Press",
				"salience": 0.0003583252,
				"type": "ORGANIZATION"
			},
			{
				"name": "language",
				"salience": 0.00035744483,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.00035636345,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.00035477115,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/082x5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wehrmacht"
				},
				"name": "Wehrmacht",
				"salience": 0.00033283202,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00033283202,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.00033283202,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0178g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing"
				},
				"name": "Boeing",
				"salience": 0.00033283202,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.00033283202,
				"type": "LOCATION"
			},
			{
				"name": "deceit",
				"salience": 0.0003325248,
				"type": "OTHER"
			},
			{
				"name": "expertise",
				"salience": 0.0003325248,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.0003325248,
				"type": "OTHER"
			},
			{
				"name": "deception",
				"salience": 0.0003325248,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.00032976855,
				"type": "OTHER"
			},
			{
				"name": "patriots",
				"salience": 0.00032976855,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.00032976855,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.00032976855,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.00032976855,
				"type": "OTHER"
			},
			{
				"name": "magnitude",
				"salience": 0.00032976855,
				"type": "OTHER"
			},
			{
				"name": "error",
				"salience": 0.00032976855,
				"type": "OTHER"
			},
			{
				"name": "voter purging",
				"salience": 0.00032976855,
				"type": "EVENT"
			},
			{
				"name": "categories",
				"salience": 0.00032976855,
				"type": "OTHER"
			},
			{
				"name": "mass media",
				"salience": 0.00032593144,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.00032295033,
				"type": "OTHER"
			},
			{
				"name": "primary",
				"salience": 0.000321823,
				"type": "EVENT"
			},
			{
				"name": "Bastiaan",
				"salience": 0.0003204037,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nana de Graaff",
				"salience": 0.0003204037,
				"type": "PERSON"
			},
			{
				"name": "Apeldoorn",
				"salience": 0.0003204037,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04mxs9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Troubled_Asset_Relief_Program"
				},
				"name": "Troubled Asset Relief Program",
				"salience": 0.0003204037,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cvy3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halliburton"
				},
				"name": "Halliburton",
				"salience": 0.0003204037,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/079dy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saddam_Hussein"
				},
				"name": "Saddam Hussein",
				"salience": 0.0003204037,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015wqw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glass%E2%80%93Steagall_Legislation"
				},
				"name": "Glass-Steagall Act",
				"salience": 0.0003204037,
				"type": "WORK_OF_ART"
			},
			{
				"name": "limits",
				"salience": 0.00031887947,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "District of Columbia",
				"salience": 0.00031377908,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01rd8v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harper's_Magazine"
				},
				"name": "Harper's Magazine",
				"salience": 0.00030866198,
				"type": "WORK_OF_ART"
			},
			{
				"name": "proposals",
				"salience": 0.0003071867,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00030604337,
				"type": "OTHER"
			},
			{
				"name": "interruption",
				"salience": 0.00030604337,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0003031026,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0003031026,
				"type": "OTHER"
			},
			{
				"name": "Thomas Frank",
				"salience": 0.00029910664,
				"type": "PERSON"
			},
			{
				"name": "proposals",
				"salience": 0.00028830767,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.00027990807,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.00027734786,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.00027734786,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00027734786,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.00027734786,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.00027734786,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00027734786,
				"type": "OTHER"
			},
			{
				"name": "juggernaut",
				"salience": 0.0002761086,
				"type": "OTHER"
			},
			{
				"name": "Gloria Borger",
				"salience": 0.00027169223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.00027169223,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.00027169223,
				"type": "ORGANIZATION"
			},
			{
				"name": "George Stephanoplous",
				"salience": 0.00027169223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "HRC",
				"salience": 0.00027169223,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09d5h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS"
				},
				"name": "CBS",
				"salience": 0.00027169223,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_f2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vermont"
				},
				"name": "Vermont",
				"salience": 0.00027169223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.00027169223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/050l8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montana"
				},
				"name": "Montana",
				"salience": 0.00027169223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02b9p2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Dakotas"
				},
				"name": "North and South Dakota",
				"salience": 0.00027169223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00027169223,
				"type": "LOCATION"
			},
			{
				"name": "fraud",
				"salience": 0.000264994,
				"type": "OTHER"
			},
			{
				"name": "Democracy Lost: A Report",
				"salience": 0.00026154675,
				"type": "EVENT"
			},
			{
				"name": "campaign promises",
				"salience": 0.00025587276,
				"type": "OTHER"
			},
			{
				"name": "manipulation",
				"salience": 0.00025264733,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00024837675,
				"type": "OTHER"
			},
			{
				"name": "deceit",
				"salience": 0.00024837675,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00024837675,
				"type": "WORK_OF_ART"
			},
			{
				"name": "collusion",
				"salience": 0.00024837675,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00024837675,
				"type": "WORK_OF_ART"
			},
			{
				"name": "position",
				"salience": 0.00024837675,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00024837675,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07vzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politics_of_the_United_States"
				},
				"name": "American Politics",
				"salience": 0.0002418137,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "fiat",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.00024014708,
				"type": "EVENT"
			},
			{
				"name": "reform",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "backlash",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "hubris",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "geniuses",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "extermination",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "Scandals",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00024014708,
				"type": "PERSON"
			},
			{
				"name": "EndNotes",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "minimum wage",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.00024014708,
				"type": "OTHER"
			},
			{
				"name": "revolution",
				"salience": 0.00024014708,
				"type": "EVENT"
			},
			{
				"name": "dream",
				"salience": 0.00023117944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fzh9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Medicare_(United_States)"
				},
				"name": "Medicare",
				"salience": 0.00023061206,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Average Citizens",
				"salience": 0.00023061206,
				"type": "PERSON"
			},
			{
				"name": "delegates",
				"salience": 0.00022945013,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.00022945013,
				"type": "OTHER"
			},
			{
				"name": "chair",
				"salience": 0.00022945013,
				"type": "PERSON"
			},
			{
				"name": "complicity",
				"salience": 0.00022945013,
				"type": "OTHER"
			},
			{
				"name": "Testing Theories",
				"salience": 0.00022826526,
				"type": "OTHER"
			},
			{
				"name": "college education",
				"salience": 0.00022639945,
				"type": "OTHER"
			},
			{
				"name": "folk wisdom",
				"salience": 0.00022254663,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0227bg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Main_Street"
				},
				"name": "Main Street",
				"salience": 0.0002183244,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.00021794514,
				"type": "OTHER"
			},
			{
				"name": "caucuses",
				"salience": 0.00020716172,
				"type": "OTHER"
			},
			{
				"name": "dishonesty",
				"salience": 0.00020716172,
				"type": "OTHER"
			},
			{
				"name": "convention",
				"salience": 0.00020716172,
				"type": "EVENT"
			},
			{
				"name": "story",
				"salience": 0.00020716172,
				"type": "WORK_OF_ART"
			},
			{
				"name": "post",
				"salience": 0.00020716172,
				"type": "OTHER"
			},
			{
				"name": "Rodolfo Cortes Barragan",
				"salience": 0.00020293721,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pwq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stanford_University"
				},
				"name": "Stanford",
				"salience": 0.00020293721,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tilburg University",
				"salience": 0.00020293721,
				"type": "ORGANIZATION"
			},
			{
				"name": "Axel Geijel",
				"salience": 0.00020293721,
				"type": "PERSON"
			},
			{
				"name": "Election Justice USA",
				"salience": 0.00020293721,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00020293721,
				"type": "ORGANIZATION"
			},
			{
				"name": "jobs",
				"salience": 0.00019956517,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00019603192,
				"type": "OTHER"
			},
			{
				"name": "open market",
				"salience": 0.00019112077,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00018398375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09h5x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trans-Pacific_Partnership"
				},
				"name": "TPP",
				"salience": 0.00018104084,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "fans",
				"salience": 0.00017937442,
				"type": "PERSON"
			},
			{
				"name": "reduction",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "enrichment",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "tranche",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "mercy",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.00017937442,
				"type": "LOCATION"
			},
			{
				"name": "advance",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.00017937442,
				"type": "LOCATION"
			},
			{
				"name": "skepticism",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "sabotaging",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"name": "hip",
				"salience": 0.00017937442,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.00017650524,
				"type": "ORGANIZATION"
			},
			{
				"name": "Benjamin Page",
				"salience": 0.00017067665,
				"type": "OTHER"
			},
			{
				"name": "hosts",
				"salience": 0.00016206324,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0m27n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maricopa_County,_Arizona"
				},
				"name": "Maricopa County",
				"salience": 0.00015284754,
				"type": "LOCATION"
			},
			{
				"name": "Martin Gillens",
				"salience": 0.00014778295,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012qcd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/SWAT"
				},
				"name": "Swat Team",
				"salience": 0.00014778295,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00012748365,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.000110383415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.000110383415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.000110383415,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.000110383415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.000110383415,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03cjjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Podest%C3%A0"
				},
				"name": "Podesta",
				"salience": 0.000110383415,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.00010575571,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Rodham_Clinton_48f54.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 53.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "It doesn't matter what the friggin' legal and ethics people say. We need to win this motherfucker. -- Mr. Scott Foval, Field Director, Americans United for Change, retained by the Clinton campaign and the Democratic National Committee 107 Shares\n2 104 0 1\nAn elite stratum of wealthy and politically dominant people intends to make Hillary Clinton our next president. These are the oligarchs, the “1%” whose wealth and incomes continue growing while most American struggle. In her private life Hillary Clinton is well-positioned among this cohort, and they expect her as President to protect their wealth and maintain their dominance. She will.\nTo assure the oligarchs' success, the Democratic National Committee is brutalizing the presidential electoral process, willfully violating rules, laws, and precedent. The strategy succeeded in the primary elections, and it will win the general.\nWho are these people? The top 1% of wealth-holders numbers about 3.25 million. Predominantly they are citizens whose wealth depends on the huge American domestic and transnational corporations, either directly—executives, directors, investors, contractors, suppliers—or indirectly in other ways (e.g. investment bankers, hedge fund managers, consultants, top law firms). Two preeminent names in this grouping are Hillary and Bill Clinton, whose net worth (about $125 million) qualifies the couple for the 1% stratum by a factor of 16. Others are Wall Street bankers—the Clintons' primal financial benefactors and first-name friends: Lloyd Blankfein, Jamie Dimon, Robert Rubin, Brian Moynihan, Michael Corbat, James Gorman, Timothy Geithner, John Stumpf, etc. A more accurate description of the “1%” would be the corporate elite .\nCandidate Clinton's relationship to her elite compatriots is one of rigid interdependence: she needs their financial and political resources to win the election, and they need her in the White House to sustain their privileged status.\nThis privileged status did not result from accident, random chance, or neglect. It is a consequence of public policies consciously adopted over the past three or four decades which shift wealth and incomes systematically upward. (Cutting taxes for corporations and the wealthy, for example, while exporting 1/3 of the nation's manufacturing jobs.) In the process our democracy was transformed. Public policy is crafted today not primarily to advance the welfare of the nation's people, but to create, protect or enhance the financial interests of American corporate enterprise. This is acknowledged in the statements of public figures and supported in rigorous scholarly research. [1]\nMORE... A New Email Investigation on Clinton Could Hasten the Democratic Party's Demise The banana republic of America: Democracy be damned To the Superdelegates: Stand tall in statesmanship! Anointment of Hillary Clinton exposes a democracy that never was Though easily identifiable, the corporate elite has not constructed a conscious conspiracy against the American people at large with a preplanned agenda, strategy, and tactics. But they share a common mindset, they are networked by personal acquaintance, and they are driven by a common imperative. Their wealth and political dominance depend on the existing configurations of American domestic and foreign policy, both of which must be maintained essentially intact to sustain the group's position of privilege. Alterations in the status quo can be tolerated only if they are cosmetic, slight, and at the margin.\nInstead of conspiracy, the preeminence of the oligarchs is better seen as a malignant condition of contemporary American government, resulting from years of institutional decay and corruption. ( The story of moribund democracy is detailed here .) The economic and political power of mega-corporations—increasingly fewer but ever larger—has displaced functional democracy.\n(Yes, we vote as we always have, but voting and democracy are not interchangeable terms. The Russian people voted for Vladimir Putin, the Iraqis voted for Saddam Hussein. And voting isn't a prerequisite for democracy to function: the ancient Greeks chose their representatives by lottery.)\nThe priority of corporate interests has been achieved by three powerful mechanisms.\nPerhaps the least recognized is the degree to which corporate personnel enter government to staff the highest levels of the Executive Branch.\nA new book by political scientists Bastiaan van Apeldoorn and Nana de Graaff carries a sobering title: American Grand Strategies and Corporate Elite Networks . They looked into the “grand strategy makers,” the 30 most influential people in cabinet-level and senior advisory positions in the last three administrations—Bill Clinton's, Bush's, and Obama's. In the Clinton Administration, 25 of the 30 “grand strategy makers” (83%) were linked to 197 different transnational or financial corporations, as executives, directors, senior associates, or partners in law firms, either prior to their public service or after it. In the Bush Administration 27 of the 30 (90%) had connections to 157 corporations. In the Obama Administration 23 of the 30 (over 70%) had such “top-level corporate affiliations” with 111 companies.\nSmoking guns? Examples of wealth-shifting upward to the already rich? Certainly. (1) The repeal of the Glass-Steagall Act, rammed through in the Bill Clinton Administration by Treasury Secretary Robert Rubin from Citigroup. This enabled the subprime loan frenzy, enriching the New York banks but destroying $13 trillion in Americans' household wealth. (2) Halliburton's no-bid, obscenely profitable contracts in Iraq, served up by Vice President Richard Cheney during the Bush Administration; billions of taxpayers' dollars to the corporation Mr. Cheney once chaired. (3) In the Obama Administration Treasury Secretary Timothy Geithner from Wall Street administered the Troubled Asset Relief Program, bailing out his colleagues' banks, again with billions of taxpayers' money.\nFor the last 24 years the Executive Branch has been dominated by the corporate elite.\nTwo other mechanisms of corporate influence are far more familiar: the corporate financing of political campaigns and the ubiquitous enterprise of lobbying.\nThe two practices are related in direct proportion: the more you accept in contributions from Boeing, say, the more you feel obligated to yield to their lobbyist's wishes.\nYour policy-making independence will decrease, then, as the costs of campaigning rise, and contemporary costs are staggering. A Representative today must raise on average $1.7 million in campaign funding, a Senator $10.5 million. A presidential race runs in the hundreds of millions. (Hillary Clinton has taken in $688 million.) Since Citizens United corporate campaign funding has no limits, and with candidates in need of so many millions, the corporate capture of federal governance is undeniable and scarcely surprising.\nUndeniable but easily surmounted. We once had a law on the books (the UK still does) limiting not campaign contributions, but campaign expenditures. The limits were $10,000 for a Senate race, $5,000 for a Representative, sums easily provided from personal assets and those of family and friends. Reenacting such a law would break the corporate stranglehold; intense lobbying might continue, but no Senator, no Representative would feel the courteous urge to accommodate. The welfare of the American people could regain priority. The impact on the oligarchs, however, would be apocalyptic.\nThe commitment of the corporate elite to sustain the status quo is apparently absolute. By April of 2015 the Democratic National Committee and the Clinton campaign were one indistinguishable juggernaut, intent on blitzing the presidential campaign like Hitler's Wehrmacht stormed through Europe. The watch words seemed to be “first and most.” They amassed an early war-chest of a hundred million dollars or so and lined up 400 superdelegate endorsements—all before there was a single announced opponent. They invited 65 print and television journalists to meetings in early April, to help in “framing the HRC message and framing the race.” [2] Among them were George Stephanoplous and 4 others from ABC; Rachel Maddow and 4 more from MSNBC; Gloria Borger and 7 of her colleagues from CNN; and 5 from the New York Times. Bloomberg, Politico, and CBS each sent along two.\nThe first-and-most strategy worked. Secretary Clinton preempted the candidate space; the only others attracted to the race were lackluster lightweights, especially the wooly socialist from Vermont. But Senator Sanders' electrifying rallies made tangible the disgust of the American people with the status quo . Sanders' proposals were anything but cosmetic, slight, and at the margin: they posed a mortal threat to the corporate elite and its guardian, the Clinton campaign. To minimize Sanders' exposure, DNC Chair Wasserman-Schultz limited the number of debates and scheduled them on weekends and opposite football games. Sanders had to sue to gain access to the DNC's voter database. The deliberate tilting of the Democratic primaries gained momentum.\nTo minimize Sanders' exposure, DNC Chair Wasserman-Schultz limited the number of debates and scheduled them on weekends and opposite football games.\nThis may not be the first election in which ethics and law were abandoned, but never before has it been so reliably exposed.\nNot by the mainstream media, though. They either ignored the increasingly evident fraud or were complicit in it. From the Iowa caucuses onward, the press treated Clinton's superdelegate endorsements as tallied votes. This continued even after the distortion and dishonesty of doing so were pointed out. Based on precisely that deception, however, the Associated Press announced Clinton's presumptive nomination on Monday, June 6—one day before primaries were held in California, Montana, New Jersey, North and South Dakota, and the District of Columbia. From Iowa forward also the Washington Post and the New York Times hammered the Sanders campaign without mercy or interruption. (The story was detailed later by Thomas Frank in Harper's Magazine . [3] Frank concludes: I have never before seen the press take sides like they did this year, openly and even gleefully bad-mouthing candidates who did not meet with their approval .)\nNo, the major media failed to expose the fraud, but the social media and the Internet abounded with skepticism. Sanders fans questioned the uncounted caucuses in Iowa; the 70% reduction of polling places in Maricopa County, Arizona; the disqualified Sanders delegates at the Nevada convention; the cheap-shot call by the Associated Press. Many were certain the Clinton campaign and the Democratic National Committee were joined at the hip, but there was scant factual evidence.\nEnter Julian Assange and the leaked DNC emails. Now the illegal collusion was documented, the sabotaging of the Sanders campaign exposed. Wasserman-Schultz resigns as DNC chair. Then the Podesta emails and Hillary's paid speeches: “you need both a public position and a private position.” “My dream is a hemispheric open market, with open trade and open borders.” DNC vice-chair Donna Brazile, a CNN pundit, emails the Clinton campaign prior to the debate: “From time to time I get the questions in advance.” The attempt to reschedule the Illinois primary. Another tranche of emails arrives: Brazile's complicity with the Clinton campaign is broadened, she is fired/resigns from her CNN post. The Clinton Foundation hosts pay to play, the Clintons' personal enrichment, the $12 million deal with King Mohammed VI of Morocco....\nFinally the compliant mass media did take note: this is, after all, fine spectacle. Noted but not pursued. No determined effort was undertaken to investigate, to document further the deceit and dishonesty, and to assess its magnitude.\nOnce again that was left to the citizenry. The first careful, detailed study was published June 7, 2016 by two scholars, Axel Geijel of Tilburg University and Rodolfo Cortes Barragan at Stanford. It is entitled, Are we witnessing a dishonest election? They compared states who's voting systems produced verifying paper trails against states which did not. Sanders won the paper-trail states, where tampering with machine tallies could be quickly discovered; Clinton overpowered in states without paper trails, where tampering could never be detected. The authors also compared voting machine tallies with exit poll figures, and found disturbing discrepancies. They concluded, “...these data suggest that election fraud is occurring in the 2016 Democratic Party presidential primary election. This fraud has overwhelmingly benefited Secretary Clinton at the expense of Senator Sanders.” (The paper can be found here .)\nThen, with the primaries concluded a group of outraged patriots with day jobs, organized as Election Justice USA , published an exhaustive report. The study is entitled, Democracy Lost: A Report on the Fatally Flawed 2016 Democratic Primaries , and it is available here . It details, in 99 pages of carefully assembled and compelling evidence, examples of election fraud uncovered in four categories: voter suppression, registration tampering, illegal voter purging, and fraudulent voting machine tallies. In eleven states the group found discrepancies between exit polls and voting machine counts exceeding the statistical margins of error. Every single discrepancy favored Secretary Clinton—and no such discrepancies occurred in the Republican counts. The group's conclusion was troubling: 184 elected delegates, their report argues persuasively, were awarded fraudulently to Clinton and denied Sanders, accordingly.\nThat gave her the edge in delegate count going into the convention. In the end, however, she needed the additional votes of 163 unelected superdelegates, those empowered by the Democratic National Committee. Even after a primary season documented as fraudulent, then, Hillary Clinton's nomination was achieved by fiat, not democracy.\nBut the corporate elite will not be denied. Given the Clinton/DNC expertise and success in tipping the primary elections, she will be elected President in the general election, guaranteed.\nThe manipulation of the primaries was obscure but not invisible; a backlash of outrage might have been anticipated. The Clinton/DNC people, however, are unmatched in hubris and geniuses in the practice of deceit. Scandals were not even acknowledged, defiantly ignored. And the language of progressive democracy is omnipresent in the campaigning, brilliant deception. Hillary Clinton promises to work for Main Street, not Wall Street. She promises to bring back jobs, improve education, seek equal pay for women, boost the minimum wage, expand civil rights, provide free college education, move toward Medicare for all, oppose TPP, break up the too-big-to-fail Wall Street banks. Fine, appealing proposals all, but this is the language of Sanders' revolution, and the corporate elite will stand for none of it.\nBut folk wisdom tells us to take campaign promises lightly, and the American people are forgiving and trusting. Hillary Clinton is a woman of long experience, and we want to believe our democracy is robust.\nHere, now, we need to be vigilant.\nEndNotes\n[1] See “Testing Theories of American Politics: Elites, Interest Groups, and Average Citizens,” by Martin Gillens and Benjamin Page. They conclude, “...economic elites and business interests have substantial independent impact on U.S. government policy, while average citizens and mass-based interest groups have little or no independent influence.”\n[2] See, http://www.fury.news/2016/10/wikileaks-least-65-msm-reporters-busted-helping-hillary/\n[3] Thomas Frank, “Swat Team: the media's extermination of Bernie Sanders—and real reform,” Harper's Magazine, November, 2016.",
		"thread_title": "Clinton's Blitzkrieg Campaign: the Savage Politics of the Oligarchs",
		"title": "Clinton's Blitzkrieg Campaign: the Savage Politics of the Oligarchs",
		"type": "bs",
		"uuid": "be73d6053229d9a3a6fb708719bb8eaeb4777f70"
	},
	"-KhIbMmUv6u8WsohR6rN": {
		"author": "Mohsen Abdelmoumen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-04T11:52:41.591+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.32571816,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.2860072,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.16800617,
				"type": "LOCATION"
			},
			{
				"name": "Clintons",
				"salience": 0.012092405,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.008668702,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05st_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jill_Stein"
				},
				"name": "Jill Stein",
				"salience": 0.008382329,
				"type": "PERSON"
			},
			{
				"name": "Ann Garrison",
				"salience": 0.007843408,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02301x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Kagame"
				},
				"name": "Paul Kagame",
				"salience": 0.0036591166,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0035267472,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.003463852,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.0031209555,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0028341054,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.00254052,
				"type": "ORGANIZATION"
			},
			{
				"name": "oligarchs",
				"salience": 0.0024920802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.002491628,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0024692456,
				"type": "ORGANIZATION"
			},
			{
				"name": "dream",
				"salience": 0.0023265833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rhh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marc_Rich"
				},
				"name": "Mark Rich",
				"salience": 0.0023181967,
				"type": "PERSON"
			},
			{
				"name": "oligarchs",
				"salience": 0.0022901152,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0021920018,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0018716814,
				"type": "ORGANIZATION"
			},
			{
				"name": "television host",
				"salience": 0.0018651702,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0015542884,
				"type": "LOCATION"
			},
			{
				"name": "woman president",
				"salience": 0.0015148064,
				"type": "PERSON"
			},
			{
				"name": "Candidates",
				"salience": 0.0013756966,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017pf5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jerry_Brown"
				},
				"name": "Jerry Brown",
				"salience": 0.0013039318,
				"type": "PERSON"
			},
			{
				"name": "commander-in-chief",
				"salience": 0.0012737507,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.00124257,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06dfg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rwanda"
				},
				"name": "Rwandan",
				"salience": 0.0012107033,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.0011498077,
				"type": "OTHER"
			},
			{
				"name": "e-mail",
				"salience": 0.001135417,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0011276461,
				"type": "EVENT"
			},
			{
				"name": "capitalism",
				"salience": 0.0011072597,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0010920928,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0010610184,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0010561172,
				"type": "LOCATION"
			},
			{
				"name": "Ajamu Baraka",
				"salience": 0.0010287841,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0010012554,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libyan",
				"salience": 0.0009544786,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ft68",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nursultan_Nazarbayev"
				},
				"name": "Nursultan Nazarbayev",
				"salience": 0.00092704507,
				"type": "PERSON"
			},
			{
				"name": "rules",
				"salience": 0.0009172146,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0009172146,
				"type": "OTHER"
			},
			{
				"name": "presidents",
				"salience": 0.0009151027,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0009000001,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.00089982693,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.0008743491,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0008376715,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.0008374516,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00077388703,
				"type": "PERSON"
			},
			{
				"name": "democrats",
				"salience": 0.0007734161,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.0007733467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0007427321,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.00074251567,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.00073785475,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.00072539103,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00072539103,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0007014319,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0006978335,
				"type": "OTHER"
			},
			{
				"name": "college sophomore",
				"salience": 0.0006904318,
				"type": "PERSON"
			},
			{
				"name": "Mohsen Abdelmoumen",
				"salience": 0.00067493704,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02840y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alain_Jupp%C3%A9"
				},
				"name": "Alain Juppé",
				"salience": 0.0006622774,
				"type": "PERSON"
			},
			{
				"name": "funds",
				"salience": 0.0006583084,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.000657833,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0006549714,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0006549714,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0006549714,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0006549714,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0006549714,
				"type": "EVENT"
			},
			{
				"name": "county",
				"salience": 0.00063912495,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.00063912495,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.0006272006,
				"type": "OTHER"
			},
			{
				"name": "oligarchy",
				"salience": 0.0006250806,
				"type": "OTHER"
			},
			{
				"name": "editors",
				"salience": 0.00060736353,
				"type": "PERSON"
			},
			{
				"name": "military power",
				"salience": 0.0006050897,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0006050897,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.0005884731,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02pjpd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andrew_Cuomo"
				},
				"name": "Andrew Cuomo",
				"salience": 0.0005873765,
				"type": "PERSON"
			},
			{
				"name": "oligarchy",
				"salience": 0.0005866844,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.00057077693,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0005702023,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y7v49",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_New_Deal"
				},
				"name": "Green New Deal",
				"salience": 0.00054782844,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign contributions",
				"salience": 0.00054634194,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00054634194,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0005354249,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rwx6z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Frank_Giustra"
				},
				"name": "Frank Giustra",
				"salience": 0.00053019205,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.000524521,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00052396685,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00052396685,
				"type": "PERSON"
			},
			{
				"name": "wars",
				"salience": 0.00052396685,
				"type": "EVENT"
			},
			{
				"name": "office",
				"salience": 0.00052396685,
				"type": "ORGANIZATION"
			},
			{
				"name": "ballots",
				"salience": 0.00052396685,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00052396685,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0005207946,
				"type": "WORK_OF_ART"
			},
			{
				"name": "answer",
				"salience": 0.00047665535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01pl7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mario_Cuomo"
				},
				"name": "Mario Cuomo",
				"salience": 0.00045580638,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00045298005,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Republic_of_the_Congo"
				},
				"name": "Democratic Republic of the Congo",
				"salience": 0.0004498805,
				"type": "LOCATION"
			},
			{
				"name": "corruption",
				"salience": 0.0004434359,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0004434359,
				"type": "OTHER"
			},
			{
				"name": "Much",
				"salience": 0.0004434359,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0004434359,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0004434359,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0004434359,
				"type": "OTHER"
			},
			{
				"name": "classes",
				"salience": 0.0004434359,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.00043541397,
				"type": "PERSON"
			},
			{
				"name": "DR",
				"salience": 0.00042927635,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.00042334592,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01y7yh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pat_Brown"
				},
				"name": "Pat Brown",
				"salience": 0.000421086,
				"type": "PERSON"
			},
			{
				"name": "duopoly system",
				"salience": 0.0004171671,
				"type": "OTHER"
			},
			{
				"name": "superstars",
				"salience": 0.00041489545,
				"type": "PERSON"
			},
			{
				"name": "Disengagement",
				"salience": 0.00041274383,
				"type": "EVENT"
			},
			{
				"name": "concept",
				"salience": 0.00041274383,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.00040965746,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.00040965746,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00040965746,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.00040421268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026d_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Matt_Gonzalez"
				},
				"name": "Matt Gonzalez",
				"salience": 0.00038850034,
				"type": "PERSON"
			},
			{
				"name": "reputation",
				"salience": 0.00037014612,
				"type": "OTHER"
			},
			{
				"name": "Things",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "lobbies",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "ballot measures",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00036987662,
				"type": "LOCATION"
			},
			{
				"name": "minority",
				"salience": 0.00036987662,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00036987662,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "Aide",
				"salience": 0.00036987662,
				"type": "PERSON"
			},
			{
				"name": "hegemony",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00036987662,
				"type": "OTHER"
			},
			{
				"name": "billionaire",
				"salience": 0.00036460225,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.00036276563,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco",
				"salience": 0.0003499087,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03wcw6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uranium_One"
				},
				"name": "Uranium One",
				"salience": 0.000346685,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00034483563,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.000338245,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/074lfh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Cuomo"
				},
				"name": "Chris Cuomo",
				"salience": 0.0003292134,
				"type": "PERSON"
			},
			{
				"name": "depths",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "super elite",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "influence peddling machine",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "exceptions",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "Ties",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "inclusion",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "burden",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.00032027747,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wall",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.00032027747,
				"type": "PERSON"
			},
			{
				"name": "crosshairs",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00032027747,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00031956905,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00031944423,
				"type": "LOCATION"
			},
			{
				"name": "presidency",
				"salience": 0.00031856544,
				"type": "OTHER"
			},
			{
				"name": "Presidency",
				"salience": 0.00031856544,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00031856544,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00031856544,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00031856544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fpn9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohammad_Mosaddegh"
				},
				"name": "Mohammed Mossadegh",
				"salience": 0.00031715204,
				"type": "PERSON"
			},
			{
				"name": "Roosevelts",
				"salience": 0.0003145528,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0137v8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Atlantic"
				},
				"name": "CityLab",
				"salience": 0.00030756395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ps9k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicolas_Sarkozy"
				},
				"name": "Nicholas Sarkozy",
				"salience": 0.0003054921,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0169t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Burundi"
				},
				"name": "Burundi",
				"salience": 0.00030364277,
				"type": "LOCATION"
			},
			{
				"name": "peace offensive",
				"salience": 0.00030311002,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.0002983572,
				"type": "PERSON"
			},
			{
				"name": "reporting project",
				"salience": 0.00029814165,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.000293995,
				"type": "OTHER"
			},
			{
				"name": "Guistra",
				"salience": 0.0002938749,
				"type": "PERSON"
			},
			{
				"name": "intern",
				"salience": 0.00028762763,
				"type": "PERSON"
			},
			{
				"name": "laptop",
				"salience": 0.0002838776,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "power",
				"salience": 0.00027937244,
				"type": "OTHER"
			},
			{
				"name": "illusion",
				"salience": 0.00027506106,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0002613752,
				"type": "LOCATION"
			},
			{
				"name": "editor",
				"salience": 0.00025614767,
				"type": "PERSON"
			},
			{
				"name": "Greens",
				"salience": 0.00025214365,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.00024464622,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00024372932,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.00024180634,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00024175979,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00024175979,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.00024175979,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.00024175979,
				"type": "ORGANIZATION"
			},
			{
				"name": "oil",
				"salience": 0.00024175027,
				"type": "OTHER"
			},
			{
				"name": "boost",
				"salience": 0.00024072603,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.00023999785,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00023796299,
				"type": "PERSON"
			},
			{
				"name": "powers",
				"salience": 0.00023673435,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.00023343954,
				"type": "OTHER"
			},
			{
				"name": "contribution",
				"salience": 0.0002306433,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00022977339,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.00022764332,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00022486602,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05jylg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rosatom"
				},
				"name": "Rosatom",
				"salience": 0.00022218857,
				"type": "ORGANIZATION"
			},
			{
				"name": "chance",
				"salience": 0.00021825393,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00021565375,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.00021565375,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00021565375,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.00021565375,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00021565375,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0002155031,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00021500139,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europeans",
				"salience": 0.00021401947,
				"type": "PERSON"
			},
			{
				"name": "dynasty",
				"salience": 0.00021183623,
				"type": "OTHER"
			},
			{
				"name": "weapons manufacturers",
				"salience": 0.00020781113,
				"type": "ORGANIZATION"
			},
			{
				"name": "dream",
				"salience": 0.00020566527,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Muammar Gaddafi",
				"salience": 0.00020543177,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_01w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Ford"
				},
				"name": "Glen Ford",
				"salience": 0.00020074875,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York State",
				"salience": 0.00019979209,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.0001973545,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07xg1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Armed_Forces"
				},
				"name": "U.S. Armed Services",
				"salience": 0.00019711316,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018_n5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Israel_Public_Affairs_Committee"
				},
				"name": "AIPAC",
				"salience": 0.00019711316,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.00019711316,
				"type": "ORGANIZATION"
			},
			{
				"name": "Why Clinton's Policies Look Like a Death Sentence",
				"salience": 0.00019711316,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hwt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_people"
				},
				"name": "Black",
				"salience": 0.00019711316,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0137v8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Atlantic"
				},
				"name": "Atlantic",
				"salience": 0.00019711316,
				"type": "LOCATION"
			},
			{
				"name": "investigation",
				"salience": 0.00019470825,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.00019470825,
				"type": "EVENT"
			},
			{
				"name": "influence peddling operation",
				"salience": 0.00019470825,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00018957823,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00018900473,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.00018900473,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00018900473,
				"type": "EVENT"
			},
			{
				"name": "funds",
				"salience": 0.00018743823,
				"type": "OTHER"
			},
			{
				"name": "Nkurunziza",
				"salience": 0.00018614778,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.00018442971,
				"type": "PERSON"
			},
			{
				"name": "human rights offender",
				"salience": 0.00018249972,
				"type": "OTHER"
			},
			{
				"name": "sex offense",
				"salience": 0.00018249972,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.00018249972,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00018194763,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.00018137612,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_of_Representatives"
				},
				"name": "House of Representatives",
				"salience": 0.00018093224,
				"type": "ORGANIZATION"
			},
			{
				"name": "friends",
				"salience": 0.00018057963,
				"type": "PERSON"
			},
			{
				"name": "oligarchy",
				"salience": 0.00018037508,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0001778213,
				"type": "LOCATION"
			},
			{
				"name": "bonds",
				"salience": 0.00017754808,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kqpq9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glencore"
				},
				"name": "Glencore International",
				"salience": 0.00017701661,
				"type": "ORGANIZATION"
			},
			{
				"name": "Greens",
				"salience": 0.00017676945,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.00017591962,
				"type": "PERSON"
			},
			{
				"name": "oligarchy",
				"salience": 0.00016929045,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00016859434,
				"type": "OTHER"
			},
			{
				"name": "level dynasties",
				"salience": 0.00016859434,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00016808431,
				"type": "EVENT"
			},
			{
				"name": "powers",
				"salience": 0.00016699529,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0001652752,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00016460924,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.00016416002,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.00016365564,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.00016365564,
				"type": "LOCATION"
			},
			{
				"name": "oligarchy",
				"salience": 0.00016296931,
				"type": "OTHER"
			},
			{
				"name": "emergency room bill",
				"salience": 0.00016296931,
				"type": "OTHER"
			},
			{
				"name": "oligarchy",
				"salience": 0.00016296931,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.00016253442,
				"type": "OTHER"
			},
			{
				"name": "scam",
				"salience": 0.000161135,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00016091515,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.00015958253,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pw6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silicon_Valley"
				},
				"name": "Silicon Valley",
				"salience": 0.00015887879,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01gkgk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Member_of_Congress"
				},
				"name": "Congressman",
				"salience": 0.00015769509,
				"type": "PERSON"
			},
			{
				"name": "confrontation",
				"salience": 0.00015764464,
				"type": "EVENT"
			},
			{
				"name": "control",
				"salience": 0.00015764464,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00015764464,
				"type": "EVENT"
			},
			{
				"name": "control",
				"salience": 0.00015764464,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00015428766,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00015428766,
				"type": "EVENT"
			},
			{
				"name": "minority",
				"salience": 0.00015221878,
				"type": "PERSON"
			},
			{
				"name": "indictment",
				"salience": 0.00015221878,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00015221878,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00015221878,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.00015175829,
				"type": "EVENT"
			},
			{
				"name": "confrontation",
				"salience": 0.00015175829,
				"type": "EVENT"
			},
			{
				"name": "confrontation",
				"salience": 0.00015175829,
				"type": "EVENT"
			},
			{
				"name": "autocrats",
				"salience": 0.00015123254,
				"type": "PERSON"
			},
			{
				"name": "rules",
				"salience": 0.00015118584,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00015055286,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.00015055286,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.00014741567,
				"type": "ORGANIZATION"
			},
			{
				"name": "names",
				"salience": 0.00014588026,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.00014554062,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00014554062,
				"type": "PERSON"
			},
			{
				"name": "wars",
				"salience": 0.00014554062,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.00014554062,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00014253156,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.00014253156,
				"type": "OTHER"
			},
			{
				"name": "Wuyi Jacobs",
				"salience": 0.00014191215,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01qdcd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Blaise_Compaor%C3%A9"
				},
				"name": "Blaise Compaoré",
				"salience": 0.00014034584,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.00013982189,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0001387991,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.00013819402,
				"type": "PERSON"
			},
			{
				"name": "oligarchy",
				"salience": 0.00013819402,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00013819402,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.00013752963,
				"type": "OTHER"
			},
			{
				"name": "funders",
				"salience": 0.00013650092,
				"type": "PERSON"
			},
			{
				"name": "funding",
				"salience": 0.00013650092,
				"type": "OTHER"
			},
			{
				"name": "age group",
				"salience": 0.00013650092,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.00013631923,
				"type": "OTHER"
			},
			{
				"name": "presidents",
				"salience": 0.00013618311,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00013618311,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.00013460092,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.00013460092,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.000133313,
				"type": "EVENT"
			},
			{
				"name": "institutions",
				"salience": 0.0001324868,
				"type": "ORGANIZATION"
			},
			{
				"name": "zone",
				"salience": 0.00013239424,
				"type": "LOCATION"
			},
			{
				"name": "glory",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "obstruction",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "perjury",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "bribery",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.00013180269,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "ex-wife",
				"salience": 0.00013180269,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "employee",
				"salience": 0.00013180269,
				"type": "PERSON"
			},
			{
				"name": "testimony",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "degree",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "prosperity",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.00013180269,
				"type": "LOCATION"
			},
			{
				"name": "sexual harassment lawsuit",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "element",
				"salience": 0.00013180269,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.00013180269,
				"type": "EVENT"
			},
			{
				"name": "Senator",
				"salience": 0.00013140394,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.00013140394,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.00013140394,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.00013051223,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00012868711,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00012868711,
				"type": "EVENT"
			},
			{
				"name": "class",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "investment bankers",
				"salience": 0.00012794159,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "oil industry",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "ballot access",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.00012794159,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00012794159,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.00012649727,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.00012593206,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00012341457,
				"type": "EVENT"
			},
			{
				"name": "majority",
				"salience": 0.00012341457,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00012341457,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00012316418,
				"type": "OTHER"
			},
			{
				"name": "investment bank",
				"salience": 0.00012316418,
				"type": "ORGANIZATION"
			},
			{
				"name": "banks",
				"salience": 0.00012316418,
				"type": "ORGANIZATION"
			},
			{
				"name": "banking industry",
				"salience": 0.00012316418,
				"type": "OTHER"
			},
			{
				"name": "playing",
				"salience": 0.00012316418,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00012295523,
				"type": "OTHER"
			},
			{
				"name": "resource interests",
				"salience": 0.00012295523,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00012295523,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.0001221433,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00012177377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea",
				"salience": 0.000121724035,
				"type": "ORGANIZATION"
			},
			{
				"name": "slur",
				"salience": 0.0001213519,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0001209415,
				"type": "PERSON"
			},
			{
				"name": "Most",
				"salience": 0.00011930072,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.000118308744,
				"type": "LOCATION"
			},
			{
				"name": "profit",
				"salience": 0.00011819269,
				"type": "OTHER"
			},
			{
				"name": "weapons manufacturers",
				"salience": 0.00011819269,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.00011819269,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.00011819269,
				"type": "OTHER"
			},
			{
				"name": "ballot initiative",
				"salience": 0.00011819269,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.000117697826,
				"type": "ORGANIZATION"
			},
			{
				"name": "nomination",
				"salience": 0.000117697826,
				"type": "OTHER"
			},
			{
				"name": "Patrick Mbeko",
				"salience": 0.00011707241,
				"type": "PERSON"
			},
			{
				"name": "Interview",
				"salience": 0.0001153988,
				"type": "EVENT"
			},
			{
				"name": "watershed",
				"salience": 0.00011463676,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.00011463676,
				"type": "OTHER"
			},
			{
				"name": "women's rights",
				"salience": 0.00011377927,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00011377927,
				"type": "OTHER"
			},
			{
				"name": "Secretary of State",
				"salience": 0.00011377927,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.00011377927,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00011377927,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00011377927,
				"type": "PERSON"
			},
			{
				"name": "consciousness",
				"salience": 0.00011377927,
				"type": "OTHER"
			},
			{
				"name": "conscience",
				"salience": 0.00011377927,
				"type": "OTHER"
			},
			{
				"name": "Humboldt Counties",
				"salience": 0.00011350004,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0l35f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sonoma_County,_California"
				},
				"name": "Sonoma County",
				"salience": 0.00011350004,
				"type": "LOCATION"
			},
			{
				"name": "instance",
				"salience": 0.00011304205,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00011245537,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00011245537,
				"type": "LOCATION"
			},
			{
				"name": "reports",
				"salience": 0.000111426794,
				"type": "OTHER"
			},
			{
				"name": "operatives",
				"salience": 0.000111426794,
				"type": "ORGANIZATION"
			},
			{
				"name": "account",
				"salience": 0.00010953063,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.00010769713,
				"type": "OTHER"
			},
			{
				"name": "coast",
				"salience": 0.00010759149,
				"type": "LOCATION"
			},
			{
				"name": "zones",
				"salience": 0.00010671208,
				"type": "LOCATION"
			},
			{
				"name": "signatures",
				"salience": 0.00010671208,
				"type": "OTHER"
			},
			{
				"name": "breath",
				"salience": 0.00010671208,
				"type": "OTHER"
			},
			{
				"name": "visibility",
				"salience": 0.00010671208,
				"type": "OTHER"
			},
			{
				"name": "breath",
				"salience": 0.00010671208,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00010671208,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00010646362,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00010646362,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.000106423286,
				"type": "ORGANIZATION"
			},
			{
				"name": "course",
				"salience": 0.000104439576,
				"type": "OTHER"
			},
			{
				"name": "death-march industries",
				"salience": 0.000104439576,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.000104439576,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "U.S. Constitution",
				"salience": 0.000103754115,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01xvb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cleveland_Browns"
				},
				"name": "Browns",
				"salience": 0.000103754115,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00010333273,
				"type": "PERSON"
			},
			{
				"name": "resource nationalists",
				"salience": 0.000102944075,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.00010272731,
				"type": "OTHER"
			},
			{
				"name": "lobby",
				"salience": 0.00010272731,
				"type": "ORGANIZATION"
			},
			{
				"name": "liberals",
				"salience": 0.00010272731,
				"type": "PERSON"
			},
			{
				"name": "rationality",
				"salience": 0.00010272731,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00010272731,
				"type": "PERSON"
			},
			{
				"name": "ballot measure",
				"salience": 0.00010272731,
				"type": "OTHER"
			},
			{
				"name": "financialization scams",
				"salience": 0.00010272731,
				"type": "OTHER"
			},
			{
				"name": "proxy",
				"salience": 0.00010272731,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.00010272731,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.00010272731,
				"type": "OTHER"
			},
			{
				"name": "Léopold Munyakazi",
				"salience": 0.00010248881,
				"type": "PERSON"
			},
			{
				"name": "nominating conventions",
				"salience": 0.0001022683,
				"type": "EVENT"
			},
			{
				"name": "ethnicities",
				"salience": 0.00010206169,
				"type": "OTHER"
			},
			{
				"name": "partner",
				"salience": 0.000102042046,
				"type": "PERSON"
			},
			{
				"name": "resources",
				"salience": 0.00010119622,
				"type": "OTHER"
			},
			{
				"name": "military partners",
				"salience": 0.0000994857,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.00009917318,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.00009720844,
				"type": "OTHER"
			},
			{
				"name": "e-mail",
				"salience": 0.000096785334,
				"type": "OTHER"
			},
			{
				"name": "weapons manufacture",
				"salience": 0.0000964813,
				"type": "OTHER"
			},
			{
				"name": "death march",
				"salience": 0.0000964813,
				"type": "EVENT"
			},
			{
				"name": "humanity",
				"salience": 0.0000964813,
				"type": "PERSON"
			},
			{
				"name": "energy",
				"salience": 0.0000964813,
				"type": "OTHER"
			},
			{
				"name": "Profits",
				"salience": 0.0000964813,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.000096122196,
				"type": "EVENT"
			},
			{
				"name": "resource nationalists",
				"salience": 0.000096122196,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.000096122196,
				"type": "EVENT"
			},
			{
				"name": "resource extraction contracts",
				"salience": 0.000096122196,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.000096122196,
				"type": "PERSON"
			},
			{
				"name": "knee-jerk reaction",
				"salience": 0.000094773175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gqbt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shrub"
				},
				"name": "Bushes",
				"salience": 0.00009367585,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hhz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oval_Office"
				},
				"name": "Oval Office",
				"salience": 0.000093040144,
				"type": "LOCATION"
			},
			{
				"name": "task",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "attendants",
				"salience": 0.00009239891,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "ballot races",
				"salience": 0.00009239891,
				"type": "EVENT"
			},
			{
				"name": "each",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "goons",
				"salience": 0.00009239891,
				"type": "PERSON"
			},
			{
				"name": "ballot access requirements",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "hordes",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "grassroots organizing",
				"salience": 0.00009239891,
				"type": "ORGANIZATION"
			},
			{
				"name": "whole",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "roof",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "community gardens",
				"salience": 0.00009239891,
				"type": "LOCATION"
			},
			{
				"name": "co-operatives",
				"salience": 0.00009239891,
				"type": "ORGANIZATION"
			},
			{
				"name": "arms",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "buyers",
				"salience": 0.00009239891,
				"type": "PERSON"
			},
			{
				"name": "disarray",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "luminaries",
				"salience": 0.00009239891,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.00009218376,
				"type": "PERSON"
			},
			{
				"name": "genocide",
				"salience": 0.000090551715,
				"type": "OTHER"
			},
			{
				"name": "Cuomos",
				"salience": 0.000090525245,
				"type": "OTHER"
			},
			{
				"name": "Liberals",
				"salience": 0.000090488444,
				"type": "PERSON"
			},
			{
				"name": "determination",
				"salience": 0.000090488444,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/040cf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesse_Jackson"
				},
				"name": "Jesse Jackson",
				"salience": 0.000089774876,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00008953985,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00008953985,
				"type": "OTHER"
			},
			{
				"name": "assassination",
				"salience": 0.000089410256,
				"type": "EVENT"
			},
			{
				"name": "health problems",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.00008894855,
				"type": "LOCATION"
			},
			{
				"name": "crime",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "wake",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "faults",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "escalation",
				"salience": 0.00008894855,
				"type": "EVENT"
			},
			{
				"name": "hope",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "glimmers",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "Ambassador",
				"salience": 0.00008894855,
				"type": "PERSON"
			},
			{
				"name": "drones",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "scandal",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "crash",
				"salience": 0.00008894855,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.00008894855,
				"type": "WORK_OF_ART"
			},
			{
				"name": "income inequality",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "anti-racists",
				"salience": 0.00008894855,
				"type": "PERSON"
			},
			{
				"name": "armies",
				"salience": 0.00008894855,
				"type": "ORGANIZATION"
			},
			{
				"name": "economy",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "lame duck",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "majority stake",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "catastrophe",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "links",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "meddling",
				"salience": 0.00008894855,
				"type": "EVENT"
			},
			{
				"name": "edge",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "circumstances",
				"salience": 0.00008894855,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.00008791354,
				"type": "OTHER"
			},
			{
				"name": "corridor",
				"salience": 0.00008744503,
				"type": "LOCATION"
			},
			{
				"name": "student debt",
				"salience": 0.00008710942,
				"type": "OTHER"
			},
			{
				"name": "rationality",
				"salience": 0.00008710942,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.00008710942,
				"type": "OTHER"
			},
			{
				"name": "radio",
				"salience": 0.00008710942,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00008710942,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00008710942,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gmqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shell_corporation"
				},
				"name": "Shell Company",
				"salience": 0.00008541688,
				"type": "ORGANIZATION"
			},
			{
				"name": "examples",
				"salience": 0.00008492713,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.000084547646,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.000084547646,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0000832293,
				"type": "EVENT"
			},
			{
				"name": "massacres",
				"salience": 0.0000832293,
				"type": "EVENT"
			},
			{
				"name": "massacres",
				"salience": 0.0000832293,
				"type": "OTHER"
			},
			{
				"name": "massacres",
				"salience": 0.0000832293,
				"type": "EVENT"
			},
			{
				"name": "support",
				"salience": 0.000082857405,
				"type": "OTHER"
			},
			{
				"name": "competition",
				"salience": 0.000082510465,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.000081565406,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George Bush",
				"salience": 0.00008147512,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04d_ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Presidential_Center"
				},
				"name": "Clinton Presidential Library",
				"salience": 0.00008111106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06p83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silvio_Berlusconi"
				},
				"name": "Berlusconi",
				"salience": 0.00008111106,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06mzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Switzerland"
				},
				"name": "Switzerland",
				"salience": 0.00008111106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/047lj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kazakhstan"
				},
				"name": "Kazakhstan",
				"salience": 0.00008111106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fbrl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kennedy_family"
				},
				"name": "Kennedys",
				"salience": 0.00008111106,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00008018667,
				"type": "OTHER"
			},
			{
				"name": "resource riches",
				"salience": 0.00007801011,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00007801011,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.00007801011,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.00007801011,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.00007801011,
				"type": "OTHER"
			},
			{
				"name": "inland county",
				"salience": 0.00007784141,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.00007752977,
				"type": "EVENT"
			},
			{
				"name": "War",
				"salience": 0.00007752977,
				"type": "EVENT"
			},
			{
				"name": "War",
				"salience": 0.00007752977,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00007752977,
				"type": "EVENT"
			},
			{
				"name": "crusade",
				"salience": 0.00007736347,
				"type": "EVENT"
			},
			{
				"name": "Victoire Ingabire Umuhoza Democracy and Peace Prize",
				"salience": 0.00007658359,
				"type": "OTHER"
			},
			{
				"name": "Thomas Sankara",
				"salience": 0.00007655297,
				"type": "PERSON"
			},
			{
				"name": "People and Planet",
				"salience": 0.000075948774,
				"type": "ORGANIZATION"
			},
			{
				"name": "military budget",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "fossil fuel giants",
				"salience": 0.00007542532,
				"type": "ORGANIZATION"
			},
			{
				"name": "halt",
				"salience": 0.00007542532,
				"type": "EVENT"
			},
			{
				"name": "slogan",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "kindergarten",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "abolition",
				"salience": 0.00007542532,
				"type": "EVENT"
			},
			{
				"name": "health insurance",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "agriculture",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "cops",
				"salience": 0.00007542532,
				"type": "ORGANIZATION"
			},
			{
				"name": "half",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "protectors",
				"salience": 0.00007542532,
				"type": "PERSON"
			},
			{
				"name": "alternative",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "print",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "climate meltdown",
				"salience": 0.00007542532,
				"type": "EVENT"
			},
			{
				"name": "outlets",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "social media pages",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00007542532,
				"type": "OTHER"
			},
			{
				"name": "speaking engagement",
				"salience": 0.00007447453,
				"type": "OTHER"
			},
			{
				"name": "military presence",
				"salience": 0.00007407632,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00007407632,
				"type": "PERSON"
			},
			{
				"name": "aliies",
				"salience": 0.00007353572,
				"type": "OTHER"
			},
			{
				"name": "car repair",
				"salience": 0.00007353572,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00007321564,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar Al-Assad",
				"salience": 0.0000727351,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.0000720656,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0000720656,
				"type": "WORK_OF_ART"
			},
			{
				"name": "account",
				"salience": 0.0000720656,
				"type": "OTHER"
			},
			{
				"name": "tension",
				"salience": 0.0000720656,
				"type": "OTHER"
			},
			{
				"name": "tribe",
				"salience": 0.0000720656,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.0000720656,
				"type": "OTHER"
			},
			{
				"name": "tension",
				"salience": 0.0000720656,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.00007169345,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00007062487,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.00007021107,
				"type": "WORK_OF_ART"
			},
			{
				"name": "radio",
				"salience": 0.00007021107,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00006999865,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00006999865,
				"type": "ORGANIZATION"
			},
			{
				"name": "nations",
				"salience": 0.00006999865,
				"type": "LOCATION"
			},
			{
				"name": "conflicts",
				"salience": 0.00006999865,
				"type": "EVENT"
			},
			{
				"name": "conflicts",
				"salience": 0.00006999865,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00006989734,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.000069204216,
				"type": "PERSON"
			},
			{
				"name": "passes",
				"salience": 0.00006814622,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Report",
				"salience": 0.00006745291,
				"type": "OTHER"
			},
			{
				"name": "uranium mining lease",
				"salience": 0.000067287176,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.00006688064,
				"type": "OTHER"
			},
			{
				"name": "interventions",
				"salience": 0.00006688064,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.00006506522,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.00006506522,
				"type": "OTHER"
			},
			{
				"name": "destabilization",
				"salience": 0.00006506522,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.00006506522,
				"type": "OTHER"
			},
			{
				"name": "visit",
				"salience": 0.00006506522,
				"type": "EVENT"
			},
			{
				"name": "allegations",
				"salience": 0.00006506522,
				"type": "OTHER"
			},
			{
				"name": "autocrats",
				"salience": 0.00006506522,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00006506522,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00006506522,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.00006506522,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00006376443,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00006343515,
				"type": "OTHER"
			},
			{
				"name": "Operation Turquoise",
				"salience": 0.00006339801,
				"type": "OTHER"
			},
			{
				"name": "Lords of Capital",
				"salience": 0.0000629349,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.00006268657,
				"type": "OTHER"
			},
			{
				"name": "county",
				"salience": 0.000061169,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.000061169,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.00006106629,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.00006106629,
				"type": "OTHER"
			},
			{
				"name": "military bases",
				"salience": 0.000060793416,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.000060609484,
				"type": "PERSON"
			},
			{
				"name": "No one",
				"salience": 0.000060609484,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.000060609484,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.000060609484,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.000060609484,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.0000605288,
				"type": "OTHER"
			},
			{
				"name": "mistake",
				"salience": 0.000060296494,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07tp2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uganda"
				},
				"name": "Uganda",
				"salience": 0.000058405196,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03224f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rwandan_Genocide"
				},
				"name": "Rwandan Genocide",
				"salience": 0.000058405196,
				"type": "OTHER"
			},
			{
				"name": "military power",
				"salience": 0.000057909678,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.000057392324,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0l376",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trinity_County,_California"
				},
				"name": "Trinity",
				"salience": 0.00005686115,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/034td1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Santa_Cruz_Department_(Bolivia)"
				},
				"name": "Santa Cruz",
				"salience": 0.00005686115,
				"type": "LOCATION"
			},
			{
				"name": "riches",
				"salience": 0.00005680866,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.00005680866,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00005680866,
				"type": "OTHER"
			},
			{
				"name": "classes",
				"salience": 0.00005680866,
				"type": "OTHER"
			},
			{
				"name": "carnage",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "reconciliaton",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "tragedy",
				"salience": 0.000056337758,
				"type": "EVENT"
			},
			{
				"name": "guilt",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "film",
				"salience": 0.000056337758,
				"type": "WORK_OF_ART"
			},
			{
				"name": "advance",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.000056337758,
				"type": "PERSON"
			},
			{
				"name": "mandates",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.000056337758,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.000055627563,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gj00",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beni_Department"
				},
				"name": "Beni",
				"salience": 0.00005481557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.000054737768,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/021lry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow_Kremlin"
				},
				"name": "Kremlin",
				"salience": 0.000054737768,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.000054737768,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dc95",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oakland,_California"
				},
				"name": "Oakland",
				"salience": 0.000054737768,
				"type": "LOCATION"
			},
			{
				"name": "proxies",
				"salience": 0.000053112522,
				"type": "OTHER"
			},
			{
				"name": "hunger",
				"salience": 0.000052875188,
				"type": "OTHER"
			},
			{
				"name": "tribes",
				"salience": 0.000052479652,
				"type": "PERSON"
			},
			{
				"name": "piece",
				"salience": 0.000052479652,
				"type": "OTHER"
			},
			{
				"name": "tribe",
				"salience": 0.000052479652,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.000052479652,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.000052284315,
				"type": "OTHER"
			},
			{
				"name": "resource nationalist",
				"salience": 0.000052284315,
				"type": "PERSON"
			},
			{
				"name": "founders",
				"salience": 0.000052284315,
				"type": "PERSON"
			},
			{
				"name": "No one",
				"salience": 0.00005205068,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.00005048458,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05g2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Africa"
				},
				"name": "North Africa",
				"salience": 0.00005039589,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.000050141964,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.000050141964,
				"type": "ORGANIZATION"
			},
			{
				"name": "San Francisco Green Party",
				"salience": 0.000049345646,
				"type": "ORGANIZATION"
			},
			{
				"name": "leadership",
				"salience": 0.000049254195,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Republic_of_the_Congo"
				},
				"name": "Congolese",
				"salience": 0.000049086568,
				"type": "LOCATION"
			},
			{
				"name": "regime change",
				"salience": 0.000048235757,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.00004781914,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq_War"
				},
				"name": "Iraq War",
				"salience": 0.000047710575,
				"type": "EVENT"
			},
			{
				"name": "chaos",
				"salience": 0.000047381738,
				"type": "OTHER"
			},
			{
				"name": "provinces",
				"salience": 0.000047381738,
				"type": "LOCATION"
			},
			{
				"name": "mistake",
				"salience": 0.000047381738,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.000047381738,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.000047381738,
				"type": "OTHER"
			},
			{
				"name": "Everybody",
				"salience": 0.000047381738,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.000047381738,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ethnicities",
				"salience": 0.000047381738,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00004540851,
				"type": "OTHER"
			},
			{
				"name": "massacres",
				"salience": 0.00004527112,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.00004527112,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00004527112,
				"type": "OTHER"
			},
			{
				"name": "massacres",
				"salience": 0.00004527112,
				"type": "EVENT"
			},
			{
				"name": "Brilliant Genocide",
				"salience": 0.000044347915,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07tp2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uganda"
				},
				"name": "Ugandan",
				"salience": 0.000044347915,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g6l2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hutu"
				},
				"name": "Hutus",
				"salience": 0.00004278386,
				"type": "PERSON"
			},
			{
				"name": "Most",
				"salience": 0.000042432126,
				"type": "OTHER"
			},
			{
				"name": "industries",
				"salience": 0.000042432126,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.000042432126,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01rrtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Consolidated_city-county"
				},
				"name": "City and County",
				"salience": 0.000041447936,
				"type": "LOCATION"
			},
			{
				"name": "timber",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.000041026127,
				"type": "EVENT"
			},
			{
				"name": "pursuit",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "saying",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "aftermath",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "cassiterite",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "coltan",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "wolfram",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "diamonds",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "rivalries",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "scenes",
				"salience": 0.000041026127,
				"type": "WORK_OF_ART"
			},
			{
				"name": "animosity",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "geostrategic",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.000041026127,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00004072396,
				"type": "EVENT"
			},
			{
				"name": "First and Second Congo Wars",
				"salience": 0.00004063712,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.00004003989,
				"type": "LOCATION"
			},
			{
				"name": "Milton Allimadi",
				"salience": 0.00004003989,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02307h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omar_al-Bashir"
				},
				"name": "Omar al-Bashir",
				"salience": 0.00004003989,
				"type": "PERSON"
			},
			{
				"name": "ambition",
				"salience": 0.00003949405,
				"type": "OTHER"
			},
			{
				"name": "grounds",
				"salience": 0.000039374558,
				"type": "LOCATION"
			},
			{
				"name": "lifetime",
				"salience": 0.00003919861,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00003919861,
				"type": "PERSON"
			},
			{
				"name": "assassination",
				"salience": 0.00003919861,
				"type": "EVENT"
			},
			{
				"name": "authority",
				"salience": 0.00003919861,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00003919861,
				"type": "OTHER"
			},
			{
				"name": "installation",
				"salience": 0.00003919861,
				"type": "EVENT"
			},
			{
				"name": "uranium deal",
				"salience": 0.00003919861,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0418wx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WBAI"
				},
				"name": "WBAI",
				"salience": 0.000038400092,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01nyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_African_Republic"
				},
				"name": "Central African Republic",
				"salience": 0.00003666418,
				"type": "LOCATION"
			},
			{
				"name": "Black Star News",
				"salience": 0.000035585617,
				"type": "ORGANIZATION"
			},
			{
				"name": "destruction",
				"salience": 0.000035390778,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.000035390778,
				"type": "ORGANIZATION"
			},
			{
				"name": "resignation",
				"salience": 0.000035390778,
				"type": "EVENT"
			},
			{
				"name": "hegemony",
				"salience": 0.000035390778,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.000035390778,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.000035390778,
				"type": "OTHER"
			},
			{
				"name": "debt resister",
				"salience": 0.000035390778,
				"type": "OTHER"
			},
			{
				"name": "careers",
				"salience": 0.000035390778,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.000035390778,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.00003466905,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01qww2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yoweri_Museveni"
				},
				"name": "Museveni",
				"salience": 0.00003466905,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bsfy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Mugabe"
				},
				"name": "Mugabe",
				"salience": 0.00003466905,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/056_gw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rwandan_Defence_Forces"
				},
				"name": "Rwandan Patriotic Army",
				"salience": 0.00003466905,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01s_yv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cyprien_Ntaryamira"
				},
				"name": "Cyprien Ntaryamira",
				"salience": 0.00003466905,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01s_yc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Juv%C3%A9nal_Habyarimana"
				},
				"name": "Juvenal Habyarimana",
				"salience": 0.00003466905,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.000033639655,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.000033249205,
				"type": "LOCATION"
			},
			{
				"name": "danger",
				"salience": 0.000032650303,
				"type": "OTHER"
			},
			{
				"name": "mass murder",
				"salience": 0.00003064354,
				"type": "EVENT"
			},
			{
				"name": "sake",
				"salience": 0.00003064354,
				"type": "OTHER"
			},
			{
				"name": "nutshell",
				"salience": 0.00003064354,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.00003064354,
				"type": "LOCATION"
			},
			{
				"name": "eagerness",
				"salience": 0.00003064354,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.00003064354,
				"type": "OTHER"
			},
			{
				"name": "ouster",
				"salience": 0.00003064354,
				"type": "EVENT"
			},
			{
				"name": "colonies",
				"salience": 0.00003064354,
				"type": "ORGANIZATION"
			},
			{
				"name": "reasons",
				"salience": 0.00003064354,
				"type": "OTHER"
			},
			{
				"name": "activist",
				"salience": 0.00003064354,
				"type": "PERSON"
			},
			{
				"name": "term",
				"salience": 0.00003064354,
				"type": "EVENT"
			},
			{
				"name": "Sheriff",
				"salience": 0.00003064354,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000029157602,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02jfst",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hearts_of_Darkness:_A_Filmmaker's_Apocalypse"
				},
				"name": "Hearts of Darkness",
				"salience": 0.000029157602,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/029h_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Kivu"
				},
				"name": "North Kivu Province",
				"salience": 0.000029157602,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.0000291273,
				"type": "OTHER"
			},
			{
				"name": "human rights offenses",
				"salience": 0.000029000514,
				"type": "OTHER"
			},
			{
				"name": "Racist Image of Africa",
				"salience": 0.000028300063,
				"type": "WORK_OF_ART"
			},
			{
				"name": "https://twitter.com/AnnGarrison?lang=en",
				"salience": 0.000025246443,
				"type": "OTHER"
			},
			{
				"name": "San Francisco Bay View",
				"salience": 0.000025246443,
				"type": "ORGANIZATION"
			},
			{
				"name": "Global Research",
				"salience": 0.000025246443,
				"type": "OTHER"
			},
			{
				"name": "KPFA-Berkeley",
				"salience": 0.000025246443,
				"type": "OTHER"
			},
			{
				"name": "Womens International Network for Democracy and Peace",
				"salience": 0.000025246443,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hnv0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tutsi"
				},
				"name": "Tutsi",
				"salience": 0.000025246443,
				"type": "PERSON"
			},
			{
				"name": "AfrobeatRadio",
				"salience": 0.000025246443,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.000025246443,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04_zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/M16_rifle"
				},
				"name": "M16",
				"salience": 0.000025246443,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000025246443,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hqjh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Africa"
				},
				"name": "West",
				"salience": 0.000025246443,
				"type": "LOCATION"
			},
			{
				"name": "Beni Territory",
				"salience": 0.000025246443,
				"type": "LOCATION"
			},
			{
				"name": "How White Writers",
				"salience": 0.000025246443,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/079dy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saddam_Hussein"
				},
				"name": "Saddam Hussein",
				"salience": 0.000025246443,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01699",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Burkina_Faso"
				},
				"name": "Burkina Faso",
				"salience": 0.000024834691,
				"type": "LOCATION"
			},
			{
				"name": "uranium mines",
				"salience": 0.00002377635,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k4hb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_Great_Lakes"
				},
				"name": "African Great Lakes Region",
				"salience": 0.000021778542,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.000021778542,
				"type": "LOCATION"
			},
			{
				"name": "Diana Johnstone",
				"salience": 0.000019838813,
				"type": "PERSON"
			},
			{
				"name": "City and County Board of Supervisors",
				"salience": 0.000018857181,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05cc1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Niger"
				},
				"name": "Niger",
				"salience": 0.000018857181,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.000018857181,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04v09",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mali"
				},
				"name": "Mali",
				"salience": 0.000018857181,
				"type": "LOCATION"
			},
			{
				"name": "expert",
				"salience": 0.000001345884,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Clinton_Ann_Garisson_9b325.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 66,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "68 Shares\n67 0 0 1\nMohsen Abdelmoumen : Do you think the United States can claim to be democratic simply by electing a woman president? Can we talk about democracy in the USA with a candidate of the financial lobbies and AIPAC?\nAnn Garrison: No, of course not. No more than we could claim to be a democracy because we elected a Black president. These two elections signify nothing more than the inclusion of previously excluded classes of people in the super elite. The United States is an oligarchy of the .01%, 1% of the 1%. Any president who is not already among the .01%, like Bill Clinton, becomes part of the .01% by serving its interests and then peddling influence after leaving office. No one has developed an influence peddling machine as well-oiled as the Clintons, with Bill working the Clinton Foundation and the Clinton Global Initiative while Hillary was Secretary of State. Just imagine the new depths of corruption that the next eight years and beyond could bring. Obama has said he’s now considering a move from the White House to venture capitalism that has Silicon Valley slathering at the opportunity.\nEvery four years Americans are given the illusion of choice between oligarchs and/or aspiring oligarchs who will serve the interests of oligarchy. Candidates who aspire to actually represent the interests of the people are marginalized by the corporate media and the pay-to-play campaign contributions of the oligarchs.\nIn municipal and county elections and ballot measures, Americans often do have real choices, but the higher and more powerful the office, the greater the corruption and oligarchic control. Nevertheless, only a small minority of Americans actually vote n local elections; The Atlantic's CityLab reporting project recently concluded that fewer than 20% vote in mayoral elections in 15 of the 30 most populous cites. Disengagement is one of the most fundamental facts of American political life.\nRegarding federal elections, this concept of democracy within the largest, most lethal military power the world has ever seen is bogus to begin with. When U.S. citizens cast ballots to elect a new commander-in-chief who will continue the project of perpetual war, military industrial profits, and global hegemony, how democratic is that? The vast majority of those who will suffer and die don’t get to vote; the only exceptions are members of the U.S. Armed Services who die in U.S. wars. If those on the other side of the Pentagon’s crosshairs were able to vote, I’m sure they would elect our Green Party presidential candidate Jill Stein, who said, “We say to Trump, we don’t need no friggin’ wall! We just need to stop invading other countries.” Her running mate, vice presidential candidate Ajamu Baraka has called the humanitarian interventionist argument a new version of the white man’s burden and said, “You have to ask yourself, when was the last time the U.S. has been on the side of the people? And the answer is: NEVER.”\nMORE... Top Aide to Hillary Clinton Urges the FBI to Disclose what it Knows about Trump's Russia Ties What will Hillary Clinton do for India? Not Much and Here's Why Clinton's Policies Look Like a Death Sentence for Americans 10 Things to Expect with a Hillary Clinton Presidency How do you explain the dynastic governance Clinton? Is the American dream in all its glory?\nI’m not sure I can explain the Clinton dynasty except to agree that it is one. Chelsea has been very involved in the Clinton Foundation and is quite likely to enter political life and even run for president one day. We have had other political dynasties, most notably the Roosevelts, the Kennedys and the Bushes, and there are many lower level dynasties, like the Browns in California. Jerry Brown, the current governor of California, is the son of former California governor Pat Brown. New York State has the Cuomos; Governor Andrew Cuomo is the son of former Governor Mario Cuomo, and his brother Chris Cuomo is a prominent corporate television host.\nRegarding the American dream, I assume you're referring to the dream that if you work hard and play by the rules, you can achieve some proportionate degree of status, security and prosperity. If so, the Clintons certainly aren't living the American dream because, although they did well in school, they've hardly played by the rules. They've enriched themselves with that well-oiled influence peddling operation I mentioned earlier, the Clinton Foundation and the Clinton Global Initiative. We're all wondering whether Hillary Clinton, and maybe even Bill Clinton, might finally be indicted now that the FBI has reopened its investigation of Clinton e-mail because more of it was discovered on the laptop that Anthony Weiner - a former Congressman under FBI investigation for sex offense - shared with his wife, Clinton aide Huma Abedin. If Hillary Clinton is elected, she'll have to be impeached, convicted and removed from office, but that's extremely unlikely - no matter what's in the newly discovered e-mail - if her party, the Democrats, win a majority in the House and more than a one- third minority in the Senate. It takes a majority in the House to impeach a president and a two-thirds majority in the Senate to then convict and remove a president. So Hillary Clinton is at a Berlusconi moment in her sordid career; her best chance of avoiding indictment is getting elected. Getting back to the American dream that you can get ahead by working hard and playing by the rules, Bill Clinton was impeached by the House of Representatives, for perjury and obstruction of justice regarding his affair with a 19-year-old White House intern and his testimony in a sexual harassment lawsuit brought by another former employee. However, his own party held a majority in the Senate and they acquitted him. This was all legal, according to the U.S. Constitution, but does it really sound like he was \"playing by the rules\"? During the final days of his presidency, Clinton acquitted Glencore International founder Mark Rich, an international fugitive who had fled to Switzerland. His ex-wife had donated to the Democratic National Committee, the Clinton Presidential Library and Hillary Clinton's New York Senate campaign.\nAccording to the law, President Clinton had the authority to acquit Rich, but how would any rational person consider that anything but bribery and corruption?\nIn 2006, Clinton polished the reputation of President Nursultan Nazarbayev, Kazakhstan's autocratic leader and human rights offender, who then gave a uranium mining lease to Canadian businessman Frank Giustra's Shell Company, making it worth tens of millions of dollars overnight. Giustra then made a big contribution to the Clinton Foundation. No one has claimed that this was illegal, but is it \"playing by the rules\"?\nWhen Guistra sold a majority stake in his company, Uranium One, to Rosatom, the Russian atomic energy agency, it was approved by Secretary of State Hillary Clinton. Giustra then contributed $2.35 million to the Clinton Foundation and Bill Clinton was offered a $500,000 speaking engagement with a Russian investment bank with links to the Kremlin. Does that sound like playing by the rules? And now Hillary's trying to make us believe that Russia's meddling in our elections and threatening confrontation with Russia over Syria. I don't think she's kidding about the confrontation, but the Clinton Foundation rarely passes up the chance to make another million dollars or more in any circumstances.\nMeanwhile, most of the rest of us are not living the American dream. Sixty-three percent of Americans are living on the edge of financial catastrophe, unable to handle a $500 car repair or a $1000 emergency room bill . The Clintons, as I said, serve the oligarchy they have also managed to join. When Bill Clinton was on his way out, in the last months of his presidency, he worked with Republicans in the lame duck Congress to deregulate the banking industry. By 2008, its dishonest, excessive and abusive financialization scams had crashed the economy, costing millions of Americans their jobs and/or homes. Then, as a New York Senator, Hillary Clinton voted to bail out the big banks who committed the crime while many of the rest of us struggled in the crash’s wake.\nHow do you explain that candidate Clinton, who failed as Secretary of State with the death of the US Ambassador in Libya, her health problems, the scandal of emails, is the candidate of the Democrats?\nAgain, Clinton serves the interests of the oligarchy that she herself has joined. Many people believe that the nomination was stolen from Bernie Sanders, the Democratic candidate who spoke out against oligarchy, growing income inequality, and even the Israeli lobby’s dominance in American politics.\nBut there’s one other important element to this. Americans who identify as liberals, supporters of women's rights, and/or anti-racists have such a longstanding allegiance to the Democratic Party that supporting its nominee every four years is their knee-jerk reaction. Ever escalating foreign wars don’t seem to penetrate their consciousness or conscience, especially when those wars are waged primarily with drones and proxy armies instead of U.S. troops. And once the Republicans nominated the openly racist and misogynistic Donald Trump, defeating Trump became a liberal crusade.\nThere are, of course, glimmers of rationality and hope. Yesterday I was out canvassing for an Oakland, California ballot measure with a young Black man, a college sophomore. Despite Trump’s overt racism, he told me that he considers Clinton even more dangerous because he understands that she has essentially promised confrontation with Russia over Syria. He understands that such escalation increases the chance of a nuclear war, accidental or not, and that Trump, for all his faults, says that the Cold War is over, that NATO is largely obsolete, and that Clinton is recklessly risking confrontation with Russia by promising to remove Bashar Al-Assad.\nOur Green Party presidential candidate Jill Stein is reported to be polling at 16% among voters under 35, and much of Bernie Sanders’s support was quite visibly from the same age group. Local, grassroots organizing is also empowering people to create institutions free of oligarchic and corporate control. They include community gardens, renewable energy buyers' co-operatives, and GMO-free zones. If a ballot initiative to make California's Sonoma County GMO-free passes, the whole northwest coast of California will be a GMO-free zone, from Santa Cruz to Humboldt Counties and including one inland county, Trinity.\nDon't you think that the two-headed American system with the candidates of two traditional parties, Democratic and Republican is out of breath?\nI wouldn’t say it’s out of breath because it’s still very much in control. However, Trump has left the Republican Party in disarray, with many Republican luminaries and funders defecting to Clinton, who is welcoming them with open arms. As Black Agenda Report Editor Glen Ford has written , the Clintons “have succeeded in assembling under one party roof nearly the whole of the U.S. ruling class and their hordes of attendants and goons. The scam that undergirded the duopoly system that has served the Lords of Capital so well for so long, has come undone. Thanks to a white nationalist billionaire who was too spoiled to play by the corporate rules, the two parties of the ruling class have become one.”\nIt’s hard to say whether or not the Republican Party will survive this election or what it will be in another four years if it does.\nOne possibility could significantly change this. If Green Party presidential candidate Dr. Jill Stein wins 5% in this election, the Green Party will become an official national party eligible for 5% of the federal funds made available to official national parties to host their presidential nominating conventions and support their nominee. This year all federal funds went to the two official national parties, Republicans and Democrats, who also have access to huge amounts of plutocratic and corporate money. The Greens take no corporate money.\nFive percent of the vote and five percent of the federal funding for elections may not sound like much, but it would be a huge watershed for the U.S. Greens. It would be a big psychological and visibility boost, and it would mean starting the next presidential campaign year with more than twice the funds that Jill Stein’s campaign has been able to raise.\nWinning 5% would also ensure ballot access for the Greens in most states, not only in federal elections but also in down ballot races. As it is, Greens are required to spend much of their time and money just gathering enough signatures to satisfy all the byzantine ballot access requirements that vary in each of the 50 states.\nEveryone knows that Clinton is the future president of the USA. In your opinion, why they are facilitated her task and who has interest in seeing Clinton in the Oval Office?\nShe is backed by the oligarchy, corporate and dynastic, particularly the investment bankers, the oil industry, and the weapons manufacturers who not only profit but also lobby for foreign wars. They are advancing their own interests by promoting a candidate who will serve them. Liberals have been conditioned to function as unpaid Clinton operatives in this election, and the corporate media, like the cops, serve as protectors of the oligarchy. And again, the majority of Americans are politically disengaged.\nYou are close to Jill Stein, head of the Green party, which emerged late in the campaign. Why was this alternative sabotaged?\nWell, I wouldn’t say I’m close to Jill personally, but she knows who I am and I, of course, know who she is. I’ve reported on her campaign and on the U.S. Greens for the past year, on radio and in print and online outlets, and I’m always honored when she shares those reports on her social media pages. I write for the Black Agenda Report and feel politically and intellectually close to its editors, who have given their full support to the Green Party this year, even as Bernie Sanders surged in the polls and many imagined he might actually win the Democratic nomination. In these times that are so easy to see as the end times, shared rationality and humanity are the closest bonds that many of us have, regardless of the geographic distance between us.\nJill’s campaign could hardly compete with the Republicans' and Democrats' because neither she nor any other Greens solicit or accept corporate money. We stand behind the slogan, “People and Planet before Profits.” And we call for a halt to the death march led by the weapons manufacturers, fossil fuel giants, and agro-chemical companies who profit from it. Jill calls for immediately cutting the military budget by half, closing all the U.S. military bases in foreign countries and launching a “peace offensive.” She proposes free public education from kindergarten through college, the abolition of student debt, national health insurance and a “Green New Deal” that would reinvest the resources now squandered on weapons manufacture and all the illegal, immoral, lethal and environmentally catastrophic U.S. wars. The Green New Deal would create a renewable energy infrastructure and sustainable agriculture before it’s too late to stop the climate meltdown - if it isn’t too late already. And it would fully employ Americans in meaningful, dignified and cooperative work for the common good.\nOf course that all makes far too much sense and threatens the highly concentrated wealth and power of the death-march industries. I would not be surprised if there were voter fraud to prevent Jill Stein and Ajamu Baraka from winning the 5% that would make us an official national party.\nI have also seen enormous oligarchic determination to stop Greens at the local level. In 2003, Matt Gonzalez, the Green Party's mayoral candidate in San Francisco, seemed to have a good chance of winning. That so alarmed the Democratic Party that it sent all its best known, most powerful names and faces to San Francisco to campaign for the Democratic candidate. They sent Hillary and Bill. They sent Jesse Jackson. They sent many Democratic Party superstars more than once. They seemed to be more concerned about defeating Matt Gonzalez and the Greens in San Francisco than they were about defeating George Bush and the Republicans in the following year’s presidential election.\nOne of the founders of the San Francisco Green Party was elected to the City and County Board of Supervisors twice, but when he ran for Sheriff, an executive office, Democrats pulled him aside and said they could not allow his election unless he left the Greens and joined the Democratic Party, which he did. They still got rid of him after his first term, with a really ugly campaign, but that’s another complicated story in itself. The City and County of San Francisco once had more elected Greens than any city or county in the country, but many of those that Greens worked so hard to elect have since defected to the Democratic Party for the sake of their political careers.\nIs not Hillary Clinton a danger for humanity?\nHell yes. I agree with Congolese author and political activist Patrick Mbeko, who said she’s more dangerous than ISIS, for all the reasons I’ve already mentioned. Her dark alliance with the death-march industries, and her seeming eagerness to confront Russia over Syria and/or on Russia’s borders in the interest of global hegemony. Russian uranium deal aside, I think that Diana Johnstone was most likely right when she wrote that “her strategic ambition in a nutshell is regime change in Russia.”\nAnd I have to mention my friends from the African Great Lakes Region - particularly Uganda, Rwanda, Burundi and the Democratic Republic of the Congo - which became the killing grounds of the 1990s, as the U.S., using African proxies, established itself as the dominant power there. Most of my friends from that part of the world are horrified by the Clintons’ all but certain return to the White House. The Clintons are deeply committed to the false history of the Rwandan war and massacres that was used to justify the First and Second Congo Wars and later the “humanitarian” interventions in Libya, Syria, and Iraq. If the truth about Rwanda and DR Congo were known, Bill Clinton would be implicated in mass murder, but that's true of every U.S. president in office in my lifetime and probably long before that. No one's going to try to refer the most lethal military power in history to an international criminal court with more than symbolic authority.\nYou have many worked on Africa. How do you explain the French leadership in Africa?\nWell, I’m no expert in this, but I can say a few things.\nFirst, I wouldn’t call it leadership. I’d say that France sustains a neocolonial and military presence in Africa. France was a partner in the destruction of Libya. In Mali, Niger, the Central African Republic, and the Democratic Republic of Congo, France is protecting the uranium mines essential to the nuclear power that generates 75% of its electricity. There’s no doubt that France was complicit in the assassination of resource nationalist and debt resister President Thomas Sankara and the installation of President Blaise Compaoré in Burkina Faso. I don’t see any sign that French policy towards Burkina or any of its other former colonies is any more benign now, despite its resignation to Compaoré’s ouster by a popular movement.\nFrance and the U.S. now appear to be military partners in Africa more often than not, but during the Rwandan war and massacres and the Congo Wars of the 1990s, the U.S. displaced France as the dominant power there.\nHowever, a source of ongoing tension between France and the U.S. has been their divergent accounts of the massacres known as the Rwandan Genocide. The U.S. defends Rwandan President Paul Kagame’s account, in which he is the savior who swept in to stop the carnage. Kagame blames France, particularly for Operation Turquoise, in which French troops created a humanitarian corridor for Rwandan refugees, mostly Hutus, who were fleeing the advance of Kagame’s Rwandan Patriotic Army. This conflict has recently been renewed, first with France reopening its investigation of allegations that Kagame ordered the assassination of Rwanda and Burundi’s Hutu presidents, Juvenal Habyarimana and Cyprien Ntaryamira, in 1994. Rwanda responded by accusing 22 French officers of helping to plan and organize genocide in Rwanda.\nIn 2010, Nicholas Sarkozy attempted to ease the tension between France and the U.S. and Rwanda by accepting the U.S./Rwandan account of the massacres. He publicly apologized for France’s alleged guilt in Rwanda’s tragedy , and shortly thereafter, France was rewarded with greater access to DR Congo's resource riches. However, Alain Juppé, who was the French prime minister at the time of the Rwandan massacres and Operation Turquoise, was having none of that. He even left the country during Kagame’s 2011 \"reconciliaton\" visit to Paris . Now Juppé seems to be leading Sarkozy in the bid for his party’s nomination, and if he is elected president, the history of Rwanda and DR Congo in the 1990s will be more fiercely contested. Most of my Rwandan friends very much hope that Juppé will be elected because he defends the dissident history of what really happened. They believe, for one, that Operation Turquoise saved many Rwandan lives.\nWhile Africa is a young continent, How do you explain that the countries are often directed by old presidents with several mandates and who don't want lose the power?\nThe old presidents cling to power, and the Western powers with geo-strategic interests enable them because autocrats are easier to corrupt and control than rowdy democrats and resource nationalists who try to represent their own people. Rwanda’s Kagame and Uganda’s Museveni are two prime examples of autocrats who have proven very useful to the U.S. and other Western interests.\nFrance, the U.S., and all the rest of the NATO nations appear to be united in their determination to topple Burundi’s Nkurunziza, who has dared to raise an independent head and to favor the East, particularly Russia, in resource extraction contracts. I can't explain Mugabe's hold on power at age 92 or Omar al-Bashir's at 72, since neither are U.S. aliies. You'll have to ask Africans in those countries to explain that.\nIn your opinion, is not tribalism a major factor in the destabilization of Africa? Why doesn't Africa progress and does it stay in the tribal model?\nI really hesitate to say anything about that because I’m not African myself and I think Western media often use the word “‘tribe” as a racial slur that disguises Western resource interests at play in African conflicts. I recently wrote a piece about the new film A Brilliant Genocide , and Milton Allimadi, the Ugandan-born editor of the Black Star News, told me he loved the piece but asked me to remove the one instance in which I’d used the word “tribe.” I told him I'd been hesitant about using that word and was glad to remove it. I’m now reading his book, “ Hearts of Darkness: How White Writers Created the Racist Image of Africa .”\nWhy are Congolese being massacred in Beni Territory, North Kivu Province ? The first question I've asked to try to answer that question is, “What resources are there?” In Beni, the answer is oil, timber, gold, diamonds, wolfram, coltan and cassiterite. Beni is a vivid example of the saying, “Everybody wants a piece of Congo.” No one could convince me that the industrial nations’ hunger for all these riches is not at the heart of these conflicts. Why are all the deadly “ethnic” conflicts in DR Congo’s resource-rich eastern provinces?\nThe competition and/or animosity between ethnicities or groups is often real, as they are in the West, but in Africa, the geostrategic and resource interests of the industrial nations are always in play behind the scenes. Western powers often exacerbate local rivalries in pursuit of their own interests.\nI sometimes co-host a show called AfrobeatRadio with my friend Wuyi Jacobs on WBAI-New York City, and we both hope to someday produce a show about Rwanda and Burundi in which we won’t have to use the words “Hutu” or “Tutsi.” Dr. Léopold Munyakazi convinced me that these two groups are better understood not as tribes or ethnicities but as social classes in Rwandan history that were exaggerated by Europeans who have found it convenient to pit one group against the other.\nLibya lives total chaos. How do you analyze the situation in Libya?\nIt’s horrible. Like so much else, it makes me deeply ashamed to be an American. If you read Hillary Clinton’s e-mail, it’s easy to see that the U.S.]/NATO war on Libya was, for one, another Western war against another defiant resource nationalist, Muammar Gaddafi. Regardless of whatever human rights offenses Gaddafi or Saddam Hussein were guilty of, both were resource nationalists, as was Mohammed Mossadegh, the secular, democratically elected prime minister of Iran who nationalized Iranian oil before our CIA and the UK's M16 ousted him in the 1953 coup. I wrote about how this played out in Libya in “ Clinton E-MaIl: We came, we saw, we got oil .”\nObama says that failing to prepare for the aftermath of the Libyan War was the greatest mistake of his presidency, but I'd say his greatest mistake was waging the Libyan War in the first place. Like the Iraq War, it has created chaos and perpetual war that continues to spread through the Middle East and North Africa.\nInterview realized by Mohsen Abdelmoumen\nWho is Ann Garrison?\nAnn Garrison is an independent journalist who contributes to the San Francisco Bay View, Global Research, the Black Agenda Report and the Black Star News, and produces radio for KPFA-Berkeley and WBAI-New York City. In 2014, she was awarded the Victoire Ingabire Umuhoza Democracy and Peace Prize by the Womens International Network for Democracy and Peace . She can be reached at https://twitter.com/AnnGarrison?lang=en .",
		"thread_title": "Ann Garrison: Clinton Serves the Interests of the Oligarchy that She Herself Has Joined",
		"title": "Ann Garrison: Clinton Serves the Interests of the Oligarchy that She Herself Has Joined",
		"type": "bs",
		"uuid": "87d7bb4dec5ba06bbc5882390bca07a49fbbe6db"
	},
	"-KhIbN-PHGW8SUD8GH0S": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-04T11:59:40.923+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0kvg7ff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abdullah_bin_Mutaib_Al_Saud"
				},
				"name": "Abdullah Al-Saud",
				"salience": 0.19012259,
				"type": "PERSON"
			},
			{
				"name": "reporter",
				"salience": 0.15461248,
				"type": "PERSON"
			},
			{
				"name": "operators",
				"salience": 0.14224973,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.13169865,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.048918296,
				"type": "LOCATION"
			},
			{
				"name": "ambassador",
				"salience": 0.023302497,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.020204911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s0vkx"
				},
				"name": "Intercept",
				"salience": 0.018383805,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.01670846,
				"type": "LOCATION"
			},
			{
				"name": "diplomat",
				"salience": 0.011461072,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.010603648,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.010360042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.010339553,
				"type": "LOCATION"
			},
			{
				"name": "coalition",
				"salience": 0.010339207,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ckxt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Watch"
				},
				"name": "Human Rights Watch",
				"salience": 0.0102553135,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jalal al-Rawishan",
				"salience": 0.009667591,
				"type": "PERSON"
			},
			{
				"name": "Ali al-Rawishan",
				"salience": 0.008628443,
				"type": "PERSON"
			},
			{
				"name": "Muhaysini",
				"salience": 0.0064261025,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.0050497684,
				"type": "PERSON"
			},
			{
				"name": "politician",
				"salience": 0.0049349605,
				"type": "PERSON"
			},
			{
				"name": "ambassador",
				"salience": 0.0049349605,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0049349605,
				"type": "OTHER"
			},
			{
				"name": "Intercept",
				"salience": 0.0042613326,
				"type": "ORGANIZATION"
			},
			{
				"name": "human lives",
				"salience": 0.0040299753,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.0033326559,
				"type": "ORGANIZATION"
			},
			{
				"name": "wife",
				"salience": 0.0033177852,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0029980007,
				"type": "ORGANIZATION"
			},
			{
				"name": "war crimes",
				"salience": 0.0029980007,
				"type": "OTHER"
			},
			{
				"name": "airstrike",
				"salience": 0.0029980007,
				"type": "EVENT"
			},
			{
				"name": "funeral",
				"salience": 0.0029980007,
				"type": "EVENT"
			},
			{
				"name": "munitions",
				"salience": 0.0029980007,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0029980007,
				"type": "EVENT"
			},
			{
				"name": "roof",
				"salience": 0.0029980007,
				"type": "OTHER"
			},
			{
				"name": "hall",
				"salience": 0.0029980007,
				"type": "LOCATION"
			},
			{
				"name": "mourners",
				"salience": 0.0029980007,
				"type": "PERSON"
			},
			{
				"name": "funeral ceremony",
				"salience": 0.0029980007,
				"type": "EVENT"
			},
			{
				"name": "border",
				"salience": 0.0028861838,
				"type": "LOCATION"
			},
			{
				"name": "bombing campaign",
				"salience": 0.0028861838,
				"type": "EVENT"
			},
			{
				"name": "region",
				"salience": 0.0028861838,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0028861838,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0028861838,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.002867505,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.002826578,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0027257898,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Annual Arab",
				"salience": 0.002632152,
				"type": "LOCATION"
			},
			{
				"name": "Policymakers Conference",
				"salience": 0.002632152,
				"type": "EVENT"
			},
			{
				"name": "data",
				"salience": 0.0024478303,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.0024478303,
				"type": "PERSON"
			},
			{
				"name": "military sales",
				"salience": 0.0024478303,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0024478303,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0024478303,
				"type": "PERSON"
			},
			{
				"name": "calls",
				"salience": 0.0024478303,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.0023389007,
				"type": "PERSON"
			},
			{
				"name": "bomb",
				"salience": 0.0023389007,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.002337268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0021764664,
				"type": "LOCATION"
			},
			{
				"name": "intervention",
				"salience": 0.001967394,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0fyc5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sana'a"
				},
				"name": "Sanaa",
				"salience": 0.0018458156,
				"type": "LOCATION"
			},
			{
				"name": "A",
				"salience": 0.0018288383,
				"type": "OTHER"
			},
			{
				"name": "Military Aid",
				"salience": 0.0018288383,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0018288383,
				"type": "OTHER"
			},
			{
				"name": "news website",
				"salience": 0.0018288383,
				"type": "OTHER"
			},
			{
				"name": "dissidents",
				"salience": 0.0018288383,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0017118613,
				"type": "ORGANIZATION"
			},
			{
				"name": "Staff",
				"salience": 0.0017036848,
				"type": "PERSON"
			},
			{
				"name": "Staff",
				"salience": 0.0017036848,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.0015382931,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.0015382931,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle Eastern",
				"salience": 0.0015069426,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.0014742695,
				"type": "PERSON"
			},
			{
				"name": "AHT",
				"salience": 0.0013891046,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0013320661,
				"type": "ORGANIZATION"
			},
			{
				"name": "soldiers",
				"salience": 0.0013320661,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.0012942553,
				"type": "LOCATION"
			},
			{
				"name": "cluster bombs",
				"salience": 0.0012727603,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05gmxm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/King_Abdulaziz_International_Airport"
				},
				"name": "King Abdulaziz International Airport",
				"salience": 0.0012468463,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0011905093,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.0011491807,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011491807,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.0011491807,
				"type": "ORGANIZATION"
			},
			{
				"name": "King Abdullah Sports",
				"salience": 0.0011257564,
				"type": "ORGANIZATION"
			},
			{
				"name": "Enab",
				"salience": 0.0011257564,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0011257564,
				"type": "LOCATION"
			},
			{
				"name": "Jaish Al-Fatah Leader Admits Receiving Financial",
				"salience": 0.0011257564,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.0009950958,
				"type": "LOCATION"
			},
			{
				"name": "Foil ISIS",
				"salience": 0.0009950958,
				"type": "ORGANIZATION"
			},
			{
				"name": "No One Supports",
				"salience": 0.0009468616,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Borkan-1",
				"salience": 0.00081989414,
				"type": "PERSON"
			},
			{
				"name": "Volcano-1",
				"salience": 0.00081989414,
				"type": "OTHER"
			},
			{
				"name": "Taking Bribe",
				"salience": 0.00081989414,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.00081989414,
				"type": "LOCATION"
			},
			{
				"name": "Terror Attacks",
				"salience": 0.0006124515,
				"type": "EVENT"
			},
			{
				"name": "Stadium The Saudi Interior Ministry",
				"salience": 0.0005558391,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.00042005614,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Prince_Abdullah_Al-Saud_d8671.JPG",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "22 Shares\n3 18 0 1\nPrince Abdullah Al-Saud, Saudi Arabia’s ambassador to the United States, was confronted by a reporter from the Intercept .\n“Will you continue to use cluster weapons in Yemen?” the reporter asked the diplomat.\nAl-Saud laughed before answering: “This is like the question, ‘Will you stop beating your wife?’”\nAfter the reporter repeated the question, the ambassador again dismissed it, saying “You are political operators. I’m not a politician.”\nSpeaking at the Annual Arab-US Policymakers Conference last week, al-Saud insisted that the Saudi-led coalition will continue its bombing campaign in Yemen, the Intercept reported.\n“If anyone attacks human lives and disturbs the border, in whatever region, we’re going to continue hitting them, no matter what,” said al-Saud.\nHuman Rights Watch (HRW) has accused the Saudi-led coalition of war crimes following an airstrike on a funeral in Yemen on October 8. In that incident, at least two air-dropped munitions penetrated the roof of a hall containing over 1,000 mourners during the funeral ceremony of Ali al-Rawishan, the father of the Sanaa-based administration’s interior minister, Jalal al-Rawishan. At least 140 people were killed and 610 wounded.\nDespite calls by US officials to review its support for its Middle Eastern ally, Washington continues to sell arms to Saudi Arabia, approving more than $20 billion in military sales in 2015 alone, HRW reports.\nAccording to UN data from August this year, the Saudi intervention in Yemen has claimed the lives of at least 10,000 people, including almost 4,000 civilians. The UN and HRW have repeatedly accused the Saudi military of dropping cluster bombs in Yemeni residential areas.\nRecommended For You Saudis Foil ISIS Terror Attacks on Packed Stadium The Saudi Interior Ministry on Sunday announced that four men were arrested over plans to detonate a bomb at the King Abdullah Sports...\nBy AHT Staff Jaish Al-Fatah Leader Admits Receiving Financial, Military Aid from Saudi Arabia According to the Syrian dissidents' news website, Enab, Muhaysini has released a video recently in which he appreciated Riyadh and other A...\nBy AHT Staff Yemeni forces fire ballistic missile deep inside Saudi Arabia at Jeddah airport Yemeni soldiers and their allies fired a Borkan-1 (Volcano-1) missile towards King Abdulaziz International Airport, located 19 kilome...\nBy AHT Staff No One Supports, Defends Saudi Arabia without Taking Bribe: German Chancellor Angela Merkel",
		"thread_title": "‘Like Asking if You’ll Stop Beating Your Wife’: Saudi Ambassador to US Dodges Yemen Cluster Bomb Question - American Herald Tribune",
		"title": "‘Like Asking if You’ll Stop Beating Your Wife’: Saudi Ambassador to US Dodges Yemen Cluster Bomb Question - American Herald Tribune",
		"type": "bs",
		"uuid": "e18ae1800deaf50e70392e919419e77f2d58b797"
	},
	"-KhIbNGneqJVMbXUd6MU": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-05T10:46:49.411+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.17139304,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.10897862,
				"type": "ORGANIZATION"
			},
			{
				"name": "security source",
				"salience": 0.098178975,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.045422122,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.044690885,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.03620352,
				"type": "OTHER"
			},
			{
				"name": "satellite television Quote",
				"salience": 0.0350973,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0350973,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0350973,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0350973,
				"type": "PERSON"
			},
			{
				"name": "Staff",
				"salience": 0.032099105,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.028563892,
				"type": "EVENT"
			},
			{
				"name": "operations",
				"salience": 0.02747268,
				"type": "OTHER"
			},
			{
				"name": "al-Sumaria",
				"salience": 0.02173519,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.020350218,
				"type": "ORGANIZATION"
			},
			{
				"name": "You Iraqi Soldier Battling ISIS",
				"salience": 0.01928656,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.018617379,
				"type": "LOCATION"
			},
			{
				"name": "prison",
				"salience": 0.016823044,
				"type": "LOCATION"
			},
			{
				"name": "prisoners",
				"salience": 0.016823044,
				"type": "PERSON"
			},
			{
				"name": "liberation",
				"salience": 0.014581792,
				"type": "EVENT"
			},
			{
				"name": "allies",
				"salience": 0.0074686985,
				"type": "ORGANIZATION"
			},
			{
				"name": "stronghold",
				"salience": 0.0074686985,
				"type": "LOCATION"
			},
			{
				"name": "operstions",
				"salience": 0.006450353,
				"type": "OTHER"
			},
			{
				"name": "relief operation",
				"salience": 0.0054721157,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.005241121,
				"type": "EVENT"
			},
			{
				"name": "AHT",
				"salience": 0.0051953453,
				"type": "ORGANIZATION"
			},
			{
				"name": "east",
				"salience": 0.005045852,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0047221016,
				"type": "PERSON"
			},
			{
				"name": "Civilians",
				"salience": 0.0047221016,
				"type": "PERSON"
			},
			{
				"name": "Estrangement It",
				"salience": 0.0045072064,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0044689192,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0044689192,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.004445888,
				"type": "OTHER"
			},
			{
				"name": "Family",
				"salience": 0.0042801877,
				"type": "PERSON"
			},
			{
				"name": "carnage",
				"salience": 0.0042801877,
				"type": "OTHER"
			},
			{
				"name": "lieutenant",
				"salience": 0.0042801877,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0042801877,
				"type": "OTHER"
			},
			{
				"name": "security members",
				"salience": 0.0036932568,
				"type": "PERSON"
			},
			{
				"name": "Civilians",
				"salience": 0.00344073,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.00344073,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0032282507,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.0031985783,
				"type": "ORGANIZATION"
			},
			{
				"name": "media outlets",
				"salience": 0.0031985783,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0031078658,
				"type": "LOCATION"
			},
			{
				"name": "Central Mosul Iraqi",
				"salience": 0.002726133,
				"type": "ORGANIZATION"
			},
			{
				"name": "electrocution",
				"salience": 0.0026907157,
				"type": "OTHER"
			},
			{
				"name": "Mosul Reunited",
				"salience": 0.0026359097,
				"type": "OTHER"
			},
			{
				"name": "Golden Division",
				"salience": 0.0026359097,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.0023463266,
				"type": "LOCATION"
			},
			{
				"name": "ISIS milita",
				"salience": 0.0023301716,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j_my",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electric_chair"
				},
				"name": "Electrocution",
				"salience": 0.0022742136,
				"type": "OTHER"
			},
			{
				"name": "spe",
				"salience": 0.0017409312,
				"type": "ORGANIZATION"
			},
			{
				"name": "300 Iraqi Civilians",
				"salience": 0.0015828339,
				"type": "PERSON"
			},
			{
				"name": "Hammam al-Alil",
				"salience": 0.0014345077,
				"type": "PERSON"
			},
			{
				"name": "Arij Village",
				"salience": 0.0014345077,
				"type": "LOCATION"
			},
			{
				"name": "Mosul Member",
				"salience": 0.0012375705,
				"type": "PERSON"
			},
			{
				"name": "Hossam al-Din al-Abbar",
				"salience": 0.0010716437,
				"type": "PERSON"
			},
			{
				"name": "Nineveh Provincial Council",
				"salience": 0.0010716437,
				"type": "ORGANIZATION"
			},
			{
				"name": "Firing Squad North",
				"salience": 0.0010716437,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Mosul_Civilians_83b52.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.004",
		"text": "20 Shares\n3 16 0 1\nIraq's al-Sumaria satellite television Quote: d an unnamed security source that claimed Mosul residents on Friday evening killed ISIS terrorists serving as security for the city's main prison, resulting in the liberation of at least 45 prisoners.\nThis comes as Iraqi forces and their allies close in on the ISIS stronghold after launching full-scale operations October 17 to liberate the city.\nSimultaneous operstions are to liberate the city, particular from the east, whilst securing Iraq's borders with Syria.\nThe offensive on Mosul is expected to become the biggest battle fought in Iraq since the U.S.-led invasion in 2003 and it could require a massive humanitarian relief operation.\nRecommended For You Iraqi Soldier Battling ISIS in Mosul Reunited with His Family After Two Years of Estrangement\nIt's a heartwarming moment amid the carnage of the battle to liberate Mosul. An Iraqi lieutenant -- part of the elite Golden Division spe...\nBy AHT Staff ISIS Executes 300 Iraqi Civilians by Firing Squad North of Mosul Member of Nineveh Provincial Council, Hossam al-Din al-Abbar, announced, that the ISIS executed 300 civilians and former security members,...\nBy AHT Staff ISIS Executes 22 Civilians by Electrocution in Central Mosul Iraqi media outlets reported on Thursday, that the ISIS group executed 22 civilians by electrocution in central Mosul. “ISIS milita...\nBy AHT Staff ISIS Executes 190 Iraqi Civilians in Hammam al-Alil, 42 in Arij Village: Official",
		"thread_title": "Mosul Civilians Stormed City Main Prison and Free 45 ISIS Prisoners",
		"title": "Mosul Civilians Stormed City Main Prison and Free 45 ISIS Prisoners",
		"type": "bs",
		"uuid": "2bd9d93a72a6c5c38c26488d77471c4806e7b1d2"
	},
	"-KhIbNqnA8vgtwRuzPza": {
		"author": "Gearóid Ó Colmáin",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-06T00:28:50.211+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09rw5rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Comprehensive_Economic_and_Trade_Agreement"
				},
				"name": "CETA",
				"salience": 0.14997423,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.08222109,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.071442045,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.051543362,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.04711711,
				"type": "PERSON"
			},
			{
				"name": "Society for European Affairs Professionals",
				"salience": 0.025060099,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporations",
				"salience": 0.022390332,
				"type": "ORGANIZATION"
			},
			{
				"name": "worker",
				"salience": 0.019451464,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.013360576,
				"type": "PERSON"
			},
			{
				"name": "Jean- Frédéric Poisson",
				"salience": 0.010028841,
				"type": "PERSON"
			},
			{
				"name": "beginning",
				"salience": 0.009673955,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qg4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Hollande"
				},
				"name": "Francois Hollande",
				"salience": 0.009188617,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07qmcqq"
				},
				"name": "Fascist",
				"salience": 0.00888836,
				"type": "OTHER"
			},
			{
				"name": "landscape hold policies",
				"salience": 0.008220916,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.008162278,
				"type": "OTHER"
			},
			{
				"name": "annexation",
				"salience": 0.0074777096,
				"type": "EVENT"
			},
			{
				"name": "signing",
				"salience": 0.0074777096,
				"type": "EVENT"
			},
			{
				"name": "Shares",
				"salience": 0.0074777096,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.006505728,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0061657773,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North America",
				"salience": 0.005889226,
				"type": "LOCATION"
			},
			{
				"name": "lobbyists",
				"salience": 0.0057576713,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.005642764,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporations",
				"salience": 0.0052894847,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.004949395,
				"type": "PERSON"
			},
			{
				"name": "negotiations",
				"salience": 0.004923794,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.004887017,
				"type": "EVENT"
			},
			{
				"name": "act",
				"salience": 0.004695293,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.0046057617,
				"type": "LOCATION"
			},
			{
				"name": "imposture",
				"salience": 0.0044129356,
				"type": "OTHER"
			},
			{
				"name": "gains",
				"salience": 0.0044129356,
				"type": "OTHER"
			},
			{
				"name": "lobbying",
				"salience": 0.0044129356,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.004364814,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.004115825,
				"type": "PERSON"
			},
			{
				"name": "power block",
				"salience": 0.004071655,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.0039118784,
				"type": "OTHER"
			},
			{
				"name": "class struggle",
				"salience": 0.0038217,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.0038217,
				"type": "OTHER"
			},
			{
				"name": "doors",
				"salience": 0.0038217,
				"type": "OTHER"
			},
			{
				"name": "deputies",
				"salience": 0.0038217,
				"type": "PERSON"
			},
			{
				"name": "Gilles-William Goldnagel",
				"salience": 0.003789678,
				"type": "PERSON"
			},
			{
				"name": "gangs",
				"salience": 0.0037211413,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0037055775,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0036631806,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0036328172,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hp7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Front_(France)"
				},
				"name": "National Front",
				"salience": 0.003625977,
				"type": "ORGANIZATION"
			},
			{
				"name": "opportunists",
				"salience": 0.003455754,
				"type": "PERSON"
			},
			{
				"name": "terrorist attack",
				"salience": 0.0032346856,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0032324402,
				"type": "LOCATION"
			},
			{
				"name": "workers",
				"salience": 0.003207281,
				"type": "PERSON"
			},
			{
				"name": "Comprehensive Economic Trade Agreement",
				"salience": 0.0031774829,
				"type": "OTHER"
			},
			{
				"name": "say",
				"salience": 0.0030810053,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002997823,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.0029724233,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.0029724233,
				"type": "OTHER"
			},
			{
				"name": "Forian Philippot",
				"salience": 0.0029371218,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0029248262,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0028632323,
				"type": "PERSON"
			},
			{
				"name": "unions",
				"salience": 0.002855386,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/047drb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manuel_Valls"
				},
				"name": "Manuel Valls",
				"salience": 0.002754767,
				"type": "PERSON"
			},
			{
				"name": "stranglehold",
				"salience": 0.0027263933,
				"type": "OTHER"
			},
			{
				"name": "stranglehold",
				"salience": 0.0027263933,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02m0v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Parliament"
				},
				"name": "European Parliament",
				"salience": 0.0023528468,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporate",
				"salience": 0.002321064,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack police",
				"salience": 0.002270589,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.002178501,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.002178501,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.002178501,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.002084293,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.0020277495,
				"type": "OTHER"
			},
			{
				"name": "continent",
				"salience": 0.0020125897,
				"type": "LOCATION"
			},
			{
				"name": "migration",
				"salience": 0.0020125897,
				"type": "EVENT"
			},
			{
				"name": "youths",
				"salience": 0.0020125897,
				"type": "PERSON"
			},
			{
				"name": "instances",
				"salience": 0.0020125897,
				"type": "OTHER"
			},
			{
				"name": "installation",
				"salience": 0.0020125897,
				"type": "EVENT"
			},
			{
				"name": "problem",
				"salience": 0.0020125897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0r4t_pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Transatlantic_Trade_and_Investment_Partnership"
				},
				"name": "Trans-Atlantic Trade and Investment Partnership",
				"salience": 0.0019903013,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0019394278,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0018810569,
				"type": "OTHER"
			},
			{
				"name": "appeals",
				"salience": 0.0018171892,
				"type": "OTHER"
			},
			{
				"name": "transformation",
				"salience": 0.0018171892,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0017808782,
				"type": "OTHER"
			},
			{
				"name": "leftism",
				"salience": 0.0017505861,
				"type": "OTHER"
			},
			{
				"name": "power-elite",
				"salience": 0.0017273219,
				"type": "OTHER"
			},
			{
				"name": "police officer",
				"salience": 0.0017212948,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0017212948,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Benjamin Netanyahu",
				"salience": 0.0016801598,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0016570465,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0016570465,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0015806103,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.0015735505,
				"type": "OTHER"
			},
			{
				"name": "globalisation",
				"salience": 0.0015735505,
				"type": "OTHER"
			},
			{
				"name": "pilgrims",
				"salience": 0.0015735505,
				"type": "PERSON"
			},
			{
				"name": "tool",
				"salience": 0.0015735505,
				"type": "OTHER"
			},
			{
				"name": "tide",
				"salience": 0.0015735505,
				"type": "OTHER"
			},
			{
				"name": "axis",
				"salience": 0.0015735505,
				"type": "OTHER"
			},
			{
				"name": "deployment",
				"salience": 0.0015735505,
				"type": "EVENT"
			},
			{
				"name": "millions",
				"salience": 0.0015735505,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.0015735505,
				"type": "OTHER"
			},
			{
				"name": "peninsula",
				"salience": 0.0015735505,
				"type": "LOCATION"
			},
			{
				"name": "processes",
				"salience": 0.0015735505,
				"type": "OTHER"
			},
			{
				"name": "wedge",
				"salience": 0.0015735505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ppyrn"
				},
				"name": "Trotskyite",
				"salience": 0.0015425875,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0015341452,
				"type": "OTHER"
			},
			{
				"name": "Intermarium",
				"salience": 0.0015110978,
				"type": "LOCATION"
			},
			{
				"name": "component",
				"salience": 0.0015034872,
				"type": "OTHER"
			},
			{
				"name": "antifa",
				"salience": 0.0014704532,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0014673132,
				"type": "EVENT"
			},
			{
				"name": "guardians",
				"salience": 0.0014398936,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0014384673,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0014217495,
				"type": "OTHER"
			},
			{
				"name": "youths",
				"salience": 0.0014111182,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.0014111182,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0014111182,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.0014111182,
				"type": "PERSON"
			},
			{
				"name": "societies",
				"salience": 0.0014111182,
				"type": "OTHER"
			},
			{
				"name": "police officers",
				"salience": 0.0014052117,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.0014052117,
				"type": "OTHER"
			},
			{
				"name": "equivalent",
				"salience": 0.001386144,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0013686769,
				"type": "OTHER"
			},
			{
				"name": "demonstrations",
				"salience": 0.0013584422,
				"type": "EVENT"
			},
			{
				"name": "gang",
				"salience": 0.0013584422,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0013584422,
				"type": "PERSON"
			},
			{
				"name": "youths",
				"salience": 0.0013584422,
				"type": "PERSON"
			},
			{
				"name": "fascist",
				"salience": 0.0013584422,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013574935,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.0013303641,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0012740901,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.0012740901,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0012740901,
				"type": "OTHER"
			},
			{
				"name": "criminality",
				"salience": 0.0012740901,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0012740901,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0012711245,
				"type": "OTHER"
			},
			{
				"name": "class interests",
				"salience": 0.0012696438,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0012469653,
				"type": "OTHER"
			},
			{
				"name": "Eastern Mediterranean",
				"salience": 0.0012387836,
				"type": "LOCATION"
			},
			{
				"name": "mob",
				"salience": 0.0012265274,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0012265274,
				"type": "PERSON"
			},
			{
				"name": "intelligence services",
				"salience": 0.0012265274,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0012265274,
				"type": "LOCATION"
			},
			{
				"name": "mob",
				"salience": 0.0012265274,
				"type": "OTHER"
			},
			{
				"name": "demonstrations",
				"salience": 0.0011966449,
				"type": "EVENT"
			},
			{
				"name": "racism",
				"salience": 0.0011754651,
				"type": "OTHER"
			},
			{
				"name": "life-blood",
				"salience": 0.0011754651,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.0011606518,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0011606518,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.001157503,
				"type": "LOCATION"
			},
			{
				"name": "left",
				"salience": 0.0011519721,
				"type": "OTHER"
			},
			{
				"name": "labouring masses",
				"salience": 0.0011519721,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.0011519721,
				"type": "PERSON"
			},
			{
				"name": "bourgeoise",
				"salience": 0.0011519721,
				"type": "PERSON"
			},
			{
				"name": "context",
				"salience": 0.0011519721,
				"type": "OTHER"
			},
			{
				"name": "forgiveness",
				"salience": 0.001146025,
				"type": "OTHER"
			},
			{
				"name": "occurrence",
				"salience": 0.0011315827,
				"type": "OTHER"
			},
			{
				"name": "avant-garde",
				"salience": 0.0011315827,
				"type": "WORK_OF_ART"
			},
			{
				"name": "army",
				"salience": 0.0011315827,
				"type": "ORGANIZATION"
			},
			{
				"name": "problem",
				"salience": 0.0011231203,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01522",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Sea"
				},
				"name": "Baltic Sea",
				"salience": 0.0011184842,
				"type": "LOCATION"
			},
			{
				"name": "America Minor",
				"salience": 0.0011184842,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06x37b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elite"
				},
				"name": "Power-Elite",
				"salience": 0.0011184842,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015h7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Sea"
				},
				"name": "Black Sea",
				"salience": 0.0011184842,
				"type": "LOCATION"
			},
			{
				"name": "vice-president",
				"salience": 0.0011150655,
				"type": "PERSON"
			},
			{
				"name": "insubordination",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "deceased",
				"salience": 0.0011032413,
				"type": "PERSON"
			},
			{
				"name": "funeral",
				"salience": 0.0011032413,
				"type": "EVENT"
			},
			{
				"name": "reality",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "rank",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "working conditions",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "spot-checksm",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "suburbs",
				"salience": 0.0011032413,
				"type": "LOCATION"
			},
			{
				"name": "delinquents",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "masonry",
				"salience": 0.0011032413,
				"type": "OTHER"
			},
			{
				"name": "passtime",
				"salience": 0.001089338,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nightmare",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "acceptance",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "hoddies",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0010620543,
				"type": "PERSON"
			},
			{
				"name": "agents provocateurs",
				"salience": 0.0010620543,
				"type": "PERSON"
			},
			{
				"name": "identity",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "stones",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "pigs",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "slogans",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.0010620543,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.001047631,
				"type": "PERSON"
			},
			{
				"name": "danger",
				"salience": 0.0010401004,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0010401004,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0010401004,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0010401004,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0010401004,
				"type": "LOCATION"
			},
			{
				"name": "prospects",
				"salience": 0.0010401004,
				"type": "OTHER"
			},
			{
				"name": "gains",
				"salience": 0.0010401004,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.0010140495,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.0010095194,
				"type": "WORK_OF_ART"
			},
			{
				"name": "party",
				"salience": 0.0009937816,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.0009937816,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02qkt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurasia"
				},
				"name": "Eurasian",
				"salience": 0.0009684949,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0009684949,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f69h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neo-Nazism"
				},
				"name": "neo-Nazi",
				"salience": 0.0009684949,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05808s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_West_Records"
				},
				"name": "East-West",
				"salience": 0.0009684949,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02sn34",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kiev"
				},
				"name": "Kiev",
				"salience": 0.0009684949,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0009684949,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0009314765,
				"type": "EVENT"
			},
			{
				"name": "workers",
				"salience": 0.0009257422,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02vhjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_World_Order_(conspiracy_theory)"
				},
				"name": "New World Order",
				"salience": 0.0009050287,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/075k5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spanish_Civil_War"
				},
				"name": "Spanish Civil War",
				"salience": 0.0009050287,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02_570",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-fascism"
				},
				"name": "Antifa",
				"salience": 0.0009050287,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0009006193,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0009006193,
				"type": "OTHER"
			},
			{
				"name": "split",
				"salience": 0.0009006193,
				"type": "EVENT"
			},
			{
				"name": "dictatorship",
				"salience": 0.0009006193,
				"type": "OTHER"
			},
			{
				"name": "occasions",
				"salience": 0.0009006193,
				"type": "EVENT"
			},
			{
				"name": "capitalism",
				"salience": 0.0009006193,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0009006193,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0009006193,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0009006193,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0008932593,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.00089089095,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.00089081586,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d7x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jean-Marie_Le_Pen"
				},
				"name": "Le Pen",
				"salience": 0.0008621136,
				"type": "OTHER"
			},
			{
				"name": "demonisation",
				"salience": 0.00086051045,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rpw3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippe_de_Villiers"
				},
				"name": "Philippe de Villiers",
				"salience": 0.0007950475,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00078685355,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00077693636,
				"type": "LOCATION"
			},
			{
				"name": "criminality",
				"salience": 0.00077693636,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.00077693636,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.00077693636,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.00077693636,
				"type": "OTHER"
			},
			{
				"name": "illusions",
				"salience": 0.00073520216,
				"type": "OTHER"
			},
			{
				"name": "electorate",
				"salience": 0.00070245843,
				"type": "PERSON"
			},
			{
				"name": "worker",
				"salience": 0.0006915065,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black",
				"salience": 0.0006789879,
				"type": "PERSON"
			},
			{
				"name": "Magnanville",
				"salience": 0.0006789879,
				"type": "LOCATION"
			},
			{
				"name": "anti-racism",
				"salience": 0.0006783612,
				"type": "OTHER"
			},
			{
				"name": "media disinformation",
				"salience": 0.00067273894,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.00067273894,
				"type": "OTHER"
			},
			{
				"name": "homogenisation",
				"salience": 0.00067273894,
				"type": "OTHER"
			},
			{
				"name": "take",
				"salience": 0.00067273894,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.00067273894,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00067273894,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00067273894,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j17h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oswald_Mosley"
				},
				"name": "Oswald Mosley",
				"salience": 0.00065363606,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00063201773,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0006266753,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.0006266753,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0006266753,
				"type": "PERSON"
			},
			{
				"name": "masses",
				"salience": 0.0006266753,
				"type": "OTHER"
			},
			{
				"name": "prelude",
				"salience": 0.00060285494,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.00060285494,
				"type": "OTHER"
			},
			{
				"name": "prelude",
				"salience": 0.00060285494,
				"type": "OTHER"
			},
			{
				"name": "nationalisation",
				"salience": 0.00057103013,
				"type": "EVENT"
			},
			{
				"name": "lumpen proletariat",
				"salience": 0.00056580757,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00056580757,
				"type": "OTHER"
			},
			{
				"name": "oligarchy",
				"salience": 0.00056580757,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00056580757,
				"type": "OTHER"
			},
			{
				"name": "proletariat",
				"salience": 0.00056580757,
				"type": "PERSON"
			},
			{
				"name": "reasons",
				"salience": 0.00056580757,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00056580757,
				"type": "OTHER"
			},
			{
				"name": "Nuit Debout",
				"salience": 0.00055427063,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g9zr2q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_Spring"
				},
				"name": "Arab Spring",
				"salience": 0.00055427063,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Muslim",
				"salience": 0.0005295837,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.000524343,
				"type": "PERSON"
			},
			{
				"name": "civil war",
				"salience": 0.00050670886,
				"type": "EVENT"
			},
			{
				"name": "left",
				"salience": 0.00050670886,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00050670886,
				"type": "PERSON"
			},
			{
				"name": "Civil war",
				"salience": 0.00050670886,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00048992084,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hope",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "formation",
				"salience": 0.00048992084,
				"type": "EVENT"
			},
			{
				"name": "super-state",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "reification",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.00048992084,
				"type": "EVENT"
			},
			{
				"name": "bondage",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "norm",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "election abstentionism",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.00048992084,
				"type": "OTHER"
			},
			{
				"name": "Representative Council of Jewish Institutions",
				"salience": 0.00047814482,
				"type": "ORGANIZATION"
			},
			{
				"name": "oligarchs",
				"salience": 0.00047374403,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.0004680996,
				"type": "OTHER"
			},
			{
				"name": "bourgeoisie",
				"salience": 0.0004680996,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0004680996,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.0004680996,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0004680996,
				"type": "PERSON"
			},
			{
				"name": "militarist",
				"salience": 0.0004656825,
				"type": "PERSON"
			},
			{
				"name": "despair",
				"salience": 0.00045981264,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0004482939,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qdcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Party_(France)"
				},
				"name": "Socialist Party",
				"salience": 0.0004454035,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.0004261147,
				"type": "PERSON"
			},
			{
				"name": "labour appeal",
				"salience": 0.00042263189,
				"type": "OTHER"
			},
			{
				"name": "importation",
				"salience": 0.00042263189,
				"type": "OTHER"
			},
			{
				"name": "prospect",
				"salience": 0.00042263189,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00042263189,
				"type": "LOCATION"
			},
			{
				"name": "Takfiri anti-Islam",
				"salience": 0.0004174743,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.00041401398,
				"type": "OTHER"
			},
			{
				"name": "ultra-Zionist",
				"salience": 0.00041401398,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.00041401398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/089g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionism"
				},
				"name": "Zionists",
				"salience": 0.00041401398,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04f_ry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conseil_Repr%C3%A9sentatif_des_Institutions_juives_de_France"
				},
				"name": "CRIF",
				"salience": 0.00041401398,
				"type": "ORGANIZATION"
			},
			{
				"name": "programmes",
				"salience": 0.00039488607,
				"type": "OTHER"
			},
			{
				"name": "Jean-Luc Melanchon",
				"salience": 0.0003793742,
				"type": "PERSON"
			},
			{
				"name": "industries",
				"salience": 0.0003659458,
				"type": "OTHER"
			},
			{
				"name": "halt",
				"salience": 0.0003659458,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.0003659458,
				"type": "OTHER"
			},
			{
				"name": "bars",
				"salience": 0.0003659458,
				"type": "OTHER"
			},
			{
				"name": "cafes",
				"salience": 0.0003659458,
				"type": "LOCATION"
			},
			{
				"name": "claims",
				"salience": 0.0003659458,
				"type": "OTHER"
			},
			{
				"name": "leftist",
				"salience": 0.0003659458,
				"type": "PERSON"
			},
			{
				"name": "writings",
				"salience": 0.0003659458,
				"type": "WORK_OF_ART"
			},
			{
				"name": "plans",
				"salience": 0.0003659458,
				"type": "OTHER"
			},
			{
				"name": "horizon",
				"salience": 0.0003659458,
				"type": "OTHER"
			},
			{
				"name": "salaries",
				"salience": 0.00035677824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rdgs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_Le_Pen"
				},
				"name": "Marine Le Pen",
				"salience": 0.0003118301,
				"type": "PERSON"
			},
			{
				"name": "Trilateral Commission Herve de Carmoy",
				"salience": 0.0003014981,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gm51",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Euramerica"
				},
				"name": "Euramerica",
				"salience": 0.0003014981,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.0003014981,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic_of_Ireland"
				},
				"name": "Ireland",
				"salience": 0.0003014981,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/037mm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Genetically_modified_organism"
				},
				"name": "GMOS",
				"salience": 0.0003014981,
				"type": "OTHER"
			},
			{
				"name": "L'Euramerique",
				"salience": 0.00029023955,
				"type": "OTHER"
			},
			{
				"name": "Melanchon",
				"salience": 0.0002880685,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0002252002,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0002252002,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01mw2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kafir"
				},
				"name": "non-Muslims",
				"salience": 0.0002252002,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/CETA_46047.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 24.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "3 Shares\n2 0 0 1\nThe signing of the Comprehensive Economic Trade Agreement with Canada (CETA) on the 30th of October marks the beginning of North America's annexation of Europe. The negotiations for the treaty were carried out behind closed doors. For over 751 deputies in the European Parliament, there are more than 30 thousands lobbyists. The Society for European Affairs Professionals (SEAP) - the organisation which lobbying on behalf of multinational corporations – this is the real power block in Europe. The European worker has absolutely no say and henceforth he will lose the right to form join unions. Multinational corporations will have unlimited power over European workers, who will see the destruction of what is left of social gains won from over a century of class struggle.\nWill European workers lie down and accept this imposture? What concrete policies would weaken the stranglehold of corporations over European workers? Which parties in the current political landscape hold policies which, if implemented, would weaken the transatlantic stranglehold?\nThere are currently no political parties running in the major European elections with candidates who genuinely represent workers' interests. But there are some political movements which threaten the corporate 'power-elite'. We will mention them below.\nThere are two important geopolitical processes to consider here. The first is the East-West corporate , geopolitical axis. America is pulling the European peninsula away from the Eurasian continent. With the installation of a neo-Nazi regime in Kiev, Washington attempted to re-create an 'Intermarium' from the Baltic Sea to the Black Sea and down to the Eastern Mediterranean - driving a permanent wedge between Russia and Germany.\nIn order to facilitate the social transformation of Europe into a 'America Minor', millions of 'pilgrims' are necessary. Hence, the deployment of coercive engineered migration as a tool to replace class- conscious European workers with deracine youths - in some instances educated enough to do the low-paid work assigned to them and acculturated enough to pose no problem to the 'Power-Elite'.\nIn the new Trotskyite language of this imperial order, any leader who attempts to stem the tide of globalisation through populist appeals to tradition and national identity is 'fascist'. Fascist is a loaded term which generally connotes evil in the public mind. In each European country there is a ready-made army of youths from wealthy families whose job is to don hoddies, attack police and scream 'fascist' and 'racist' at working-class people desperately trying to find a way out of this nightmare. These 'antifa' are the modern equivalent to Oswald Mosley's fascist gangs in the 1930s; they represent the same class interests .Petty-bourgeois leftism is the New World Order's avant-garde.\nA favourite passtime of the 'Antifa' mob is throwing stones at police officers. One can only gain acceptance in the anti-fascist gang by showing how much one hates the 'pigs'. So, police officers from honest working-class families get burned alive while the anti-fa mob chants slogans from the Spanish Civil War. Such violence is now a regular occurrence in demonstrations. The agents provocateurs often receive help from the intelligence services. French police are finding it hard to cope with the chaos developing all over French suburbs. They complain that they are not sufficiently equipped and do not have the powers necessary to deal with the growing violence from delinquents. They have been demonstrating in Paris. They have been calling for an end to the control of the French police by free masonry. Exacerbating the problem is the deep-seated racism of many police officers who target Black youths with spot-checksm – very often without reason.\nThe recent demonstrations by French police in France against poor working conditions and low pay strongly suggests that there is the possibility that the rank and file of the French police could be waking up to the reality that France is government by a criminal gang. After the Magnanville terrorist attack in June where two police officers were killed, a police officer at the funeral of the deceased refused to shake the hand of President Hollande and Prime Minister Manuel Valls. It was a highly significant act of insubordination.\nThe police, who in capitalist societies are the guardians of the ruling class, are beginning to realise the criminality of the people they are protecting; they are perhaps beginning to understand that the role of the state is to impose the dictatorship of one class over another - that of the minority of super wealthy over the labouring masses.\nMany of these dissident police officers are linked to Le Pen's National Front. A reliable source in French intelligence informed me that the secret services spend more time watching the far-right than the so-called 'far left'. They see the far right as a real potential danger to the ruling order, whereas the far left present no danger but are in fact a key component of ruling class ideology. From the 'Arab Spring' to Nuit Debout, the far-left are the life-blood of capitalism. The potential of a major split between the national and compradore bourgeoise of imperial states for prospects of working-class gains is something that needs more study.\nWhat should we make of all this in the context of CETA? As I have said on numerous occasions, the far right in France are and always have been political opportunists who exploit the despair of the masses; they serve the interests of the national bourgeoisie. But the National Front are regularly denounced by the media, not for being right wing. Rather, they are dismissed as being closer to the far left. The prospect of raising worker's salaries, nationalisation of key industries and a halt on the importation of cheap labour appeal to working-class families.\nAs I have pointed out before, looking at a debate between the Trotskyist Jean-Luc Melanchon and Marine Le Pen in 2011, one would have thought that Le Pen was was the leftist and Melanchon the right-wing militarist. Melanchon shamelessly defended the NATO bombing campaign of Libya, while Le Pen opposed it!\nCivil war on the horizon\nThe right-wing presidential candidate Philippe de Villiers has said there are plans afoot to divide the French territory between Muslims and non-Muslims. He Quote: s Francois Hollande's own writings to back up his claims. Everyone is talking about an imminent civil war. In the bars and cafes of Paris one can hear more and more disgruntled French citizens talking about media disinformation, the demonisation of Russia, the homogenisation of thought and the criminality of the ruling class.\nThe scene has never been more propitious to a populist take over of French politics. But one should not have illusions about the National Front; they are following the menacious Zionist narrative on the war on terror: Muslims are the problem. The party's vice-president Forian Philippot is close to the ultra-Zionist lawyer Gilles-William Goldnagel, a friend of Israeli Prime Minister Benjamin Netanyahu.\nPhilippot recently condemned the comments of presidential candidate Jean- Frédéric Poisson who said Hillary Clinton presented the greatest threat for the world as she is in the pay of the Zionists. Poisson was subsequently forced to kneel before the Representative Council of Jewish Institutions in France (CRIF) where he sought forgiveness. He was told he would be forgiven but they they would never forget! In spite of the National Front's anti-Muslim bias, an increasing number of Muslims are voting for the party. Many Muslims prefer the National Front as they are sick and tired of being patronised and manipulated by the left – with their pseudo 'anti-racism' and 'humanitarian' wars.\nThere have also been major strikes by police in Ireland for similar reasons to France. French workers are losing everything and will soon become a lumpen proletariat. Meanwhile the French government has programmes in place to encourage migrants heading to Britain to stay in France. The Socialist Party is creating a new electorate. It is a wise move for them because after the next election abstentionism will be the norm and the indigenous lumpen proletariat will resent the migrants. The oligarchs will keep the masses in bondage through GMOS, Takfiri anti-Islam and total reification of life. CETA is the beginning of the end for social hope. It is the prelude to the Trans-Atlantic Trade and Investment Partnership (TTIP) – the most evil trade deal in history.\nFrench vice-president of the Trilateral Commission Herve de Carmoy wrote a book in 2007 entitled 'L'Euramerique' – Euramerica, where he argues for the formation of what amounts to a transatlantic super-state run by a financial oligarchy. CETA is the prelude to that project.",
		"thread_title": "CETA Is Step towards a Corporate Land Called Euramerica",
		"title": "CETA Is Step towards a Corporate Land Called Euramerica",
		"type": "bs",
		"uuid": "47c3bb012df0138032067dd7ed8b20f03c58e314"
	},
	"-KhIbOLWF9dHldOxPka-": {
		"author": "James M. Dorsey",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-06T12:40:58.818+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.31688648,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02zm3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FIFA"
				},
				"name": "FIFA",
				"salience": 0.10643124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dr5n0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestinian_Football_Association"
				},
				"name": "Palestine Football Association",
				"salience": 0.05407517,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04r7fk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine_national_football_team"
				},
				"name": "Palestine",
				"salience": 0.05264892,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.043984685,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.025201518,
				"type": "LOCATION"
			},
			{
				"name": "courts",
				"salience": 0.023004306,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/082pc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Bank"
				},
				"name": "West Bank",
				"salience": 0.018863017,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01html",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mahmoud_Abbas"
				},
				"name": "Mahmoud Abbas",
				"salience": 0.017021775,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.016253943,
				"type": "ORGANIZATION"
			},
			{
				"name": "bid",
				"salience": 0.0145625705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/032f6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_language"
				},
				"name": "Persian",
				"salience": 0.011455989,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.009329534,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.009161266,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.009161266,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Gulf",
				"salience": 0.008679045,
				"type": "LOCATION"
			},
			{
				"name": "counterpart",
				"salience": 0.00867538,
				"type": "PERSON"
			},
			{
				"name": "settlements",
				"salience": 0.008133707,
				"type": "OTHER"
			},
			{
				"name": "sports",
				"salience": 0.008133707,
				"type": "OTHER"
			},
			{
				"name": "testing",
				"salience": 0.0067888745,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.0067888745,
				"type": "LOCATION"
			},
			{
				"name": "soccer",
				"salience": 0.00665363,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.006186227,
				"type": "EVENT"
			},
			{
				"name": "Shares",
				"salience": 0.0058810976,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.0058810976,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.0058810976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041l8g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohammed_Dahlan"
				},
				"name": "Mohammed Dahlan",
				"salience": 0.005673255,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0044522383,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0038446076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Criminal_Court"
				},
				"name": "International Criminal Court",
				"salience": 0.0038011456,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Benyamin Netanyahu",
				"salience": 0.0034210032,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.003309599,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.0032767148,
				"type": "OTHER"
			},
			{
				"name": "players",
				"salience": 0.0032092745,
				"type": "PERSON"
			},
			{
				"name": "clubs",
				"salience": 0.003077784,
				"type": "ORGANIZATION"
			},
			{
				"name": "testing ground",
				"salience": 0.0030068618,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0028731232,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0604m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestinian_National_Authority"
				},
				"name": "Palestinian Authority",
				"salience": 0.00286944,
				"type": "ORGANIZATION"
			},
			{
				"name": "efforts",
				"salience": 0.0028223293,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.0021453367,
				"type": "OTHER"
			},
			{
				"name": "FIFA Council",
				"salience": 0.0021220043,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0db0q5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miri_Regev"
				},
				"name": "Miri Regev",
				"salience": 0.002086796,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dtfh6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jibril_Rajoub"
				},
				"name": "Jibril Rajoub",
				"salience": 0.002086796,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0020046302,
				"type": "EVENT"
			},
			{
				"name": "status",
				"salience": 0.0019317374,
				"type": "OTHER"
			},
			{
				"name": "council meeting",
				"salience": 0.0018289028,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.001788531,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0017515824,
				"type": "OTHER"
			},
			{
				"name": "settlements",
				"salience": 0.0017143117,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0017089308,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0016736252,
				"type": "EVENT"
			},
			{
				"name": "Sexwale",
				"salience": 0.0016592789,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.00158378,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ng0y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel_Football_Association"
				},
				"name": "Israel Football Association",
				"salience": 0.0015817482,
				"type": "ORGANIZATION"
			},
			{
				"name": "escort service",
				"salience": 0.0014758559,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03r121",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Court_of_Arbitration_for_Sport"
				},
				"name": "Court of Arbitration for Sport",
				"salience": 0.001451173,
				"type": "ORGANIZATION"
			},
			{
				"name": "success",
				"salience": 0.0014300416,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.0014300416,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0014300416,
				"type": "ORGANIZATION"
			},
			{
				"name": "pressure",
				"salience": 0.001354591,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.001354591,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.001354591,
				"type": "LOCATION"
			},
			{
				"name": "action",
				"salience": 0.0013193819,
				"type": "OTHER"
			},
			{
				"name": "recourse",
				"salience": 0.0013193819,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.0013040388,
				"type": "LOCATION"
			},
			{
				"name": "Mr.",
				"salience": 0.0013040388,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0012824589,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.0012824589,
				"type": "EVENT"
			},
			{
				"name": "impasse",
				"salience": 0.0012383413,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0012383413,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0012383413,
				"type": "OTHER"
			},
			{
				"name": "world soccer body",
				"salience": 0.0012383413,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.0012383413,
				"type": "OTHER"
			},
			{
				"name": "divisions",
				"salience": 0.0012383413,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0012345968,
				"type": "EVENT"
			},
			{
				"name": "settlements",
				"salience": 0.0012020833,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0011782605,
				"type": "OTHER"
			},
			{
				"name": "settlements",
				"salience": 0.001157219,
				"type": "OTHER"
			},
			{
				"name": "teams",
				"salience": 0.0011497248,
				"type": "ORGANIZATION"
			},
			{
				"name": "travel",
				"salience": 0.0011401996,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0011105305,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0011105305,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0011105305,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0011058829,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0011058829,
				"type": "LOCATION"
			},
			{
				"name": "occupation",
				"salience": 0.0010690812,
				"type": "OTHER"
			},
			{
				"name": "soccer association",
				"salience": 0.0010690812,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.001046987,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0010284594,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.0009856496,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0009813614,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.00097323034,
				"type": "PERSON"
			},
			{
				"name": "home federation",
				"salience": 0.00096527877,
				"type": "LOCATION"
			},
			{
				"name": "permission",
				"salience": 0.00096527877,
				"type": "OTHER"
			},
			{
				"name": "federation",
				"salience": 0.00096527877,
				"type": "ORGANIZATION"
			},
			{
				"name": "CAS",
				"salience": 0.00096527877,
				"type": "OTHER"
			},
			{
				"name": "Implementation",
				"salience": 0.0009059776,
				"type": "OTHER"
			},
			{
				"name": "challenges",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "attitudes",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "demands",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "boycott",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "divestment",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "penalization",
				"salience": 0.0008682638,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0008682638,
				"type": "EVENT"
			},
			{
				"name": "Condemnation",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0008682638,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0357_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gaza_Strip"
				},
				"name": "Gaza",
				"salience": 0.00086066546,
				"type": "LOCATION"
			},
			{
				"name": "clubs",
				"salience": 0.0008396031,
				"type": "ORGANIZATION"
			},
			{
				"name": "leagues",
				"salience": 0.0008358528,
				"type": "OTHER"
			},
			{
				"name": "fart",
				"salience": 0.0008358528,
				"type": "OTHER"
			},
			{
				"name": "committee",
				"salience": 0.0008358528,
				"type": "ORGANIZATION"
			},
			{
				"name": "territory",
				"salience": 0.00082613016,
				"type": "LOCATION"
			},
			{
				"name": "status",
				"salience": 0.00082613016,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00082613016,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0008185765,
				"type": "ORGANIZATION"
			},
			{
				"name": "nationals",
				"salience": 0.0008185765,
				"type": "PERSON"
			},
			{
				"name": "relations",
				"salience": 0.0008185765,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0008185765,
				"type": "OTHER"
			},
			{
				"name": "lip service",
				"salience": 0.0008185765,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00080826145,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.00080826145,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vnr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Security_Council"
				},
				"name": "United Nations Security Council",
				"salience": 0.00078939024,
				"type": "ORGANIZATION"
			},
			{
				"name": "congress",
				"salience": 0.00078449945,
				"type": "ORGANIZATION"
			},
			{
				"name": "soccer",
				"salience": 0.0007821268,
				"type": "OTHER"
			},
			{
				"name": "soccer player",
				"salience": 0.00075192784,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.0007330961,
				"type": "OTHER"
			},
			{
				"name": "players",
				"salience": 0.0007330961,
				"type": "PERSON"
			},
			{
				"name": "teams",
				"salience": 0.0007330961,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.0007330961,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bl_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sepp_Blatter"
				},
				"name": "Sepp Blatter",
				"salience": 0.0007194069,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.00071667694,
				"type": "LOCATION"
			},
			{
				"name": "cause",
				"salience": 0.000708813,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.000708813,
				"type": "OTHER"
			},
			{
				"name": "diplomatic mission",
				"salience": 0.000708813,
				"type": "EVENT"
			},
			{
				"name": "opening",
				"salience": 0.000708813,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.000708813,
				"type": "OTHER"
			},
			{
				"name": "kingdom",
				"salience": 0.000708813,
				"type": "LOCATION"
			},
			{
				"name": "Writing",
				"salience": 0.000708813,
				"type": "OTHER"
			},
			{
				"name": "representatives",
				"salience": 0.000708813,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.000708813,
				"type": "LOCATION"
			},
			{
				"name": "opposition",
				"salience": 0.000708813,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.000708813,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gzrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_citizens_of_Israel"
				},
				"name": "Palestinian-Israeli",
				"salience": 0.0006819478,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.00067724905,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00067724905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00061715825,
				"type": "LOCATION"
			},
			{
				"name": "development",
				"salience": 0.000611479,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.000611479,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.000611479,
				"type": "EVENT"
			},
			{
				"name": "bid",
				"salience": 0.000611479,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0006016655,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "UAE",
				"salience": 0.0005958146,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/046bwk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tokyo_Sexwale"
				},
				"name": "Tokyo Sexwale",
				"salience": 0.00059411756,
				"type": "PERSON"
			},
			{
				"name": "players",
				"salience": 0.0005761171,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00057448726,
				"type": "LOCATION"
			},
			{
				"name": "influence",
				"salience": 0.00054308015,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "United Arab Emirates",
				"salience": 0.0005343952,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0005343952,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02r6qpb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boycott,_Divestment_and_Sanctions"
				},
				"name": "BDS",
				"salience": 0.0005343952,
				"type": "ORGANIZATION"
			},
			{
				"name": "agreement",
				"salience": 0.0005339021,
				"type": "OTHER"
			},
			{
				"name": "crossings",
				"salience": 0.0005294774,
				"type": "LOCATION"
			},
			{
				"name": "promises",
				"salience": 0.0005294774,
				"type": "OTHER"
			},
			{
				"name": "obstacles",
				"salience": 0.0005294774,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0005294774,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0005294774,
				"type": "LOCATION"
			},
			{
				"name": "sports liaison officials",
				"salience": 0.0005294774,
				"type": "PERSON"
			},
			{
				"name": "heart",
				"salience": 0.0005294774,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0005294774,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedish",
				"salience": 0.00051444356,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0463dhb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Renewable_Energy_Agency"
				},
				"name": "International Renewable Energy Agency",
				"salience": 0.00050380867,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gxj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abu_Dhabi"
				},
				"name": "Abu Dhabi",
				"salience": 0.0004955939,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.0004932255,
				"type": "OTHER"
			},
			{
				"name": "implications",
				"salience": 0.00048666899,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.00046259398,
				"type": "OTHER"
			},
			{
				"name": "identity cards",
				"salience": 0.00045472293,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00044943253,
				"type": "PERSON"
			},
			{
				"name": "compromise",
				"salience": 0.00044532234,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00044532234,
				"type": "OTHER"
			},
			{
				"name": "return match",
				"salience": 0.00044532234,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.00044110062,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.00043624267,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0161c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bahrain"
				},
				"name": "Bahrain",
				"salience": 0.00043624267,
				"type": "LOCATION"
			},
			{
				"name": "strategy",
				"salience": 0.00042678014,
				"type": "OTHER"
			},
			{
				"name": "teams",
				"salience": 0.00039881084,
				"type": "ORGANIZATION"
			},
			{
				"name": "agreement",
				"salience": 0.0003937842,
				"type": "OTHER"
			},
			{
				"name": "scrutiny",
				"salience": 0.00038559834,
				"type": "OTHER"
			},
			{
				"name": "strip",
				"salience": 0.00038559834,
				"type": "EVENT"
			},
			{
				"name": "Hopes",
				"salience": 0.00038559834,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.00038559834,
				"type": "OTHER"
			},
			{
				"name": "peace making",
				"salience": 0.00038559834,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.00038559834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09lvk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hebron"
				},
				"name": "Hebron",
				"salience": 0.00033447114,
				"type": "LOCATION"
			},
			{
				"name": "successor",
				"salience": 0.00033264008,
				"type": "PERSON"
			},
			{
				"name": "compromise",
				"salience": 0.00033264008,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dfdff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Ahli_Dubai_F.C."
				},
				"name": "Al Ahli",
				"salience": 0.00032585746,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.00028802597,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00028802597,
				"type": "PERSON"
			},
			{
				"name": "grievances",
				"salience": 0.00028802597,
				"type": "OTHER"
			},
			{
				"name": "bone",
				"salience": 0.00028802597,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00028802597,
				"type": "OTHER"
			},
			{
				"name": "degree",
				"salience": 0.00028802597,
				"type": "OTHER"
			},
			{
				"name": "bar",
				"salience": 0.00028081072,
				"type": "LOCATION"
			},
			{
				"name": "differences",
				"salience": 0.00023811992,
				"type": "OTHER"
			},
			{
				"name": "Al Shejaia",
				"salience": 0.00023730255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6n6nc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine_Cup"
				},
				"name": "Palestine Cup",
				"salience": 0.00023730255,
				"type": "EVENT"
			},
			{
				"name": "final",
				"salience": 0.0001801328,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/palestine_soccer_9c8c2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 16.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "2 Shares\n2 0 0 0\nThe Palestine Football Association (PFA), in a first testing of Palestine's ability to fight its battle with Israel in international courts, plans to go to the world's top court for sports in a bid to force its Israeli counterpart to view Israeli settlements on the West Bank as occupied territory rather than an extension of the Jewish state.\nThe potential Palestinian move follows the Palestinian Authority's campaign to isolate Israel in international organizations and challenge Israel's occupation of the West Bank in the International Criminal Court (ICC).\nUsing soccer as a testing ground, Palestine's efforts to confront Israel in international organizations has produced mixed results. While Palestine succeeded in joining various international organizations, the PFA last year failed to muster sufficient votes to persuade world soccer body FIFA to suspend Israel. The PFA argued that the policies of the Israeli government and the Israel Football Association (IFA) violated FIFA rules as well as international law governing the status of occupied territory.\nThe PFA has since been unable to push FIFA towards any punitive steps against Israel. Instead, FIFA opted to monitor developments and attempt with little success to negotiate a way out of the impasse. Palestine is expected to take legal recourse if FIFA fails to take more decisive action at its next council meeting in January.\nThe PFA's focus since failing to get Israel suspended has been on banning six clubs that are based in Israeli settlements on the West Bank from playing in Israeli lower divisions. FIFA rules stipulate that clubs based in a recognized federation's territory cannot play in leagues of another soccer association without the permission of the home federation. The PFA rejects the notion of granting permission because it believes that it would legitimize Israeli settlements and the occupation.\nMORE... Swedish soccer player sent off for loud fart during match PFA President Jibril Rajoub suggested that the PFA would take its case to the Court of Arbitration for Sport (CAS) after a seven-hour meeting earlier this month of a FIFA committee headed by Tokyo Sexwale failed to resolve the issue.\nMr. Sexwale is scheduled to visit Israel later this month for a meeting with Israeli sports minister Miri Regev. The FIFA Council is scheduled to discuss the issue at its next meeting in January. The PFA is likely to prepare its case for CAS, but wait with filing it until after the January meeting.\nIsrael sees the Palestinian demands and threat as strengthening the growing boycott, divestment and sanctions movement (BDS) that sees penalization as a means of forcing the Jewish state to alter its policies and ultimately withdraw from territory occupied during the 1967 Middle East war.\nCondemnation of the Israeli occupation and settlements by the United Nations Security Council constitutes the legal basis for the PFA's approach as well as potential challenges in international courts.\nThe strength of the Palestinian position has been weakened changing [Persian] Gulf attitudes towards Israel and Saudi and United Arab Emirates pressure on Palestine Authority president Mahmoud Abbas. [Persian] Gulf states, despite paying lip service to the Palestinian cause, have become more public about their informal relations with Israel based on common opposition to expanding Iranian influence in the region.\nWriting in the kingdom's controlled press, a prominent Saudi journalist went as far as calling for the establishment of diplomatic relations with Israel. The UAE last year agreed to the opening of an Israeli diplomatic mission accredited to the Abu Dhabi-based International Renewable Energy Agency rather than the UAE government. Bahrain, as part of an agreement to host next year's FIFA congress, has consented to issue visas to representatives of the IFA. Israeli nationals are barred from travelling to [Persian] Gulf countries.\nAt the same time, Saudi Arabia and the UAE have been pressuring Mr. Abbas to resolve his differences with Mohammed Dahlan, the controversial former Abu Dhabi-based Gaza strongman who is an archenemy of the Palestinian president. Mr. Dahlan is widely seen as a successor to 81-year old Mr. Abbas, who would be acceptable to Israel.\nIsrael may be able to count on some degree of tacit [Persian] Gulf support within FIFA but is likely nonetheless to ultimately have to be seen to be accepting some kind of compromise that throws a bone to the Palestinians.\nThe Palestinians' focus on the Israeli West Bank teams has however raised the bar for Israel. An agreement between Prime Minister Benyamin Netanyahu and former FIFA president Sepp Blatter struck last year addresses many of the PFA's grievances but not the issue of six the West Bank teams. Their status goes to the heart of the Palestinian-Israeli conflict: the legal status of territory occupied by Israel since 1967.\nUnder the agreement, Mr. Netanyahu proposed to give Palestinian players special identity cards and place sports liaison officials at crossings between Palestinian areas and those under Israeli control in a bid to eliminate obstacles to free movement that complicated the development of Palestinian soccer. Mr. Netanyahu further suggested to create an escort service that would facilitate players' travel between the West Bank and Gaza that are separated by Israeli territory.\nIsrael initially appeared to live up to its promises by granting for the first time in 15 years, a West Bank team, Hebron's Al Ahli, passage to Gaza to play a Palestine Cup final against the strip's Al Shejaia. Hopes that this signalled a new beginning were however dashed when the PFA cancelled the return match in Hebron after Israel agreed to grant passage to only 33 of the 37 players who were scheduled to travel. Implementation of the agreement has since evaporated.\nThe PFA, by putting the West Bank teams at the top of their agenda, has made it tougher for FIFA and Israel to work out a compromise that would not have implications for the future of Israeli-Palestinian peace making. Israeli is likely to want to avoid subjecting its policies to the scrutiny of an international court. Yet, that may be exactly what would best serve the Palestine Authority's overall strategy.",
		"thread_title": "Palestine Considers Suing Israel in International Sports Court",
		"title": "Palestine Considers Suing Israel in International Sports Court",
		"type": "bs",
		"uuid": "473b15c1ac44f73a9d5692209d82bf45697d7a1f"
	},
	"-KhIbOdIpRVj5oQTSneH": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-06T12:41:18.896+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Hamam al-Alil",
				"salience": 0.18082713,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.15028515,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.13711572,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mohandes",
				"salience": 0.05278318,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.03378608,
				"type": "PERSON"
			},
			{
				"name": "terrorism",
				"salience": 0.027592111,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.021766322,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.019582279,
				"type": "LOCATION"
			},
			{
				"name": "mother",
				"salience": 0.017314581,
				"type": "PERSON"
			},
			{
				"name": "Soldier",
				"salience": 0.016759297,
				"type": "PERSON"
			},
			{
				"name": "Popular Mobilization Units",
				"salience": 0.01448702,
				"type": "ORGANIZATION"
			},
			{
				"name": "second-in-command",
				"salience": 0.014154818,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Abu Mahdi al-Mohandes",
				"salience": 0.012819028,
				"type": "LOCATION"
			},
			{
				"name": "remarks",
				"salience": 0.012636523,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.011853283,
				"type": "PERSON"
			},
			{
				"name": "product",
				"salience": 0.0108611025,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "terrorist groups",
				"salience": 0.010645038,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.009615593,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.009325459,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.009216864,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.00843673,
				"type": "OTHER"
			},
			{
				"name": "television network",
				"salience": 0.008330787,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "army",
				"salience": 0.0068503455,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mohandes",
				"salience": 0.006563209,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.005855264,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.005855264,
				"type": "PERSON"
			},
			{
				"name": "manhunt",
				"salience": 0.005700716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.005134203,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dwshc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Alam_News_Network"
				},
				"name": "al-Alam",
				"salience": 0.005134203,
				"type": "ORGANIZATION"
			},
			{
				"name": "operations",
				"salience": 0.0051133987,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.004754344,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.004038199,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence",
				"salience": 0.0039668316,
				"type": "OTHER"
			},
			{
				"name": "media campaign",
				"salience": 0.0039668316,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0034355717,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.0034355717,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0034355717,
				"type": "EVENT"
			},
			{
				"name": "terrorists",
				"salience": 0.003354478,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0031486023,
				"type": "PERSON"
			},
			{
				"name": "goal",
				"salience": 0.0031044735,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0030812826,
				"type": "OTHER"
			},
			{
				"name": "treasury",
				"salience": 0.0030812826,
				"type": "OTHER"
			},
			{
				"name": "units",
				"salience": 0.0030812826,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mosul ISIS",
				"salience": 0.0030324152,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.002761553,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028t63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haider_al-Abadi"
				},
				"name": "Haider al-Abadi",
				"salience": 0.0026723524,
				"type": "PERSON"
			},
			{
				"name": "treasury",
				"salience": 0.002515878,
				"type": "OTHER"
			},
			{
				"name": "terrorist group",
				"salience": 0.002515878,
				"type": "ORGANIZATION"
			},
			{
				"name": "plotters",
				"salience": 0.0024095343,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0024095343,
				"type": "PERSON"
			},
			{
				"name": "rebellion",
				"salience": 0.0024095343,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.0024095343,
				"type": "OTHER"
			},
			{
				"name": "grave",
				"salience": 0.0024095343,
				"type": "OTHER"
			},
			{
				"name": "Breathing Problems",
				"salience": 0.0024095343,
				"type": "OTHER"
			},
			{
				"name": "Civilians",
				"salience": 0.0024095343,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.0023898596,
				"type": "LOCATION"
			},
			{
				"name": "Family",
				"salience": 0.0023196472,
				"type": "PERSON"
			},
			{
				"name": "robbers",
				"salience": 0.0022904356,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.0022717323,
				"type": "LOCATION"
			},
			{
				"name": "commanders",
				"salience": 0.0022717323,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0021706366,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.0021697506,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ftlx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tehran"
				},
				"name": "Tehran",
				"salience": 0.0021154427,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/052dhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takfiri"
				},
				"name": "Takfiri",
				"salience": 0.0021154427,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.0021154427,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0021154427,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0021154427,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.0020959885,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0019672792,
				"type": "OTHER"
			},
			{
				"name": "escapees",
				"salience": 0.0019672792,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0018856389,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.0018797201,
				"type": "EVENT"
			},
			{
				"name": "terrorists",
				"salience": 0.0018258491,
				"type": "PERSON"
			},
			{
				"name": "Hashd al-Shaabi",
				"salience": 0.0016490915,
				"type": "ORGANIZATION"
			},
			{
				"name": "Karamless Village",
				"salience": 0.0016490915,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0015811078,
				"type": "LOCATION"
			},
			{
				"name": "Mosul Thousand",
				"salience": 0.001483388,
				"type": "LOCATION"
			},
			{
				"name": "Torches Sulphur Plant",
				"salience": 0.001483388,
				"type": "LOCATION"
			},
			{
				"name": "Mosul Meanwhile",
				"salience": 0.001483388,
				"type": "OTHER"
			},
			{
				"name": "limits",
				"salience": 0.0014697424,
				"type": "OTHER"
			},
			{
				"name": "directions",
				"salience": 0.0014697424,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wb7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Church_(building)"
				},
				"name": "Church",
				"salience": 0.0014280274,
				"type": "ORGANIZATION"
			},
			{
				"name": "Battling ISIS",
				"salience": 0.0014280274,
				"type": "EVENT"
			},
			{
				"name": "Mosul Reunited",
				"salience": 0.0014280274,
				"type": "OTHER"
			},
			{
				"name": "Estrangement Muslim Iraqi Soldiers Erect Cross",
				"salience": 0.0014280274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rvp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tal_Afar"
				},
				"name": "Tal Afar",
				"salience": 0.0014280274,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.0012362213,
				"type": "LOCATION"
			},
			{
				"name": "time",
				"salience": 0.0012362213,
				"type": "EVENT"
			},
			{
				"name": "terror campaign",
				"salience": 0.0012362213,
				"type": "EVENT"
			},
			{
				"name": "Abu al-Bara al-Qahtani",
				"salience": 0.0012110244,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0012110244,
				"type": "LOCATION"
			},
			{
				"name": "Mosul Heavy",
				"salience": 0.0012110244,
				"type": "PERSON"
			},
			{
				"name": "car bombs",
				"salience": 0.0011998828,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0011811819,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0011811819,
				"type": "LOCATION"
			},
			{
				"name": "government troops",
				"salience": 0.0011811819,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0011811819,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0010704754,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0010704754,
				"type": "OTHER"
			},
			{
				"name": "districts",
				"salience": 0.0010704754,
				"type": "LOCATION"
			},
			{
				"name": "Hashd al-Shaabi",
				"salience": 0.0010447535,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.0010299073,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.0010228117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00097323576,
				"type": "LOCATION"
			},
			{
				"name": "positions",
				"salience": 0.0009672061,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.00090466766,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03m_n0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peshmerga"
				},
				"name": "Peshmerga",
				"salience": 0.00090466766,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07pgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tigris"
				},
				"name": "Tigris River",
				"salience": 0.00090466766,
				"type": "LOCATION"
			},
			{
				"name": "treasury official",
				"salience": 0.0008306705,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.0007996604,
				"type": "LOCATION"
			},
			{
				"name": "airport",
				"salience": 0.0007996604,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.0007996604,
				"type": "LOCATION"
			},
			{
				"name": "snipers",
				"salience": 0.0007996604,
				"type": "PERSON"
			},
			{
				"name": "mortar fire",
				"salience": 0.0007996604,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.0007996604,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Abu_Mahdi_al-Mohandes_6e0a2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.001",
		"text": "Saudi Arabia is the “mother of all terrorism,” says the second-in-command of the Iraq’s Popular Mobilization Units, Abu Mahdi al-Mohandes. 76 Shares\n8 62 0 6\nMohandes made the remarks during an interview with the al-Alam television network on Saturday.\nHe stressed that both the ISIS and al-Qaeda terrorist groups are the product of Saudi Arabia, and that ISIS's psychological and media campaign is partially funded from Riyadh.\nMohandes noted that the operations to free Mosul from the Takfiri terrorists will take some time as the militants are receiving intelligence from several external sources, mainly the US.\nHe went on to praise Iran’s support for Iraq’s battle against terrorism, stressing that if Baghdad had not called for Tehran’s assistance, the Iraqi army would never have reached Mosul.\nHe also noted that the Hashd al-Shaabi forces, also known as the Popular Mobilization Units, will move on towards Tal Afar after Mosul is cleared of ISIS militants.\nMORE... Iraqi Soldier Battling ISIS in Mosul Reunited with His Family After Two Years of Estrangement Muslim Iraqi Soldiers Erect Cross on Top of the Church in Newly Liberated Karamless Village Near Mosul Thousand of Iraqi Civilians Treated for Breathing Problems after ISIS Torches Sulphur Plant near Mosul ISIS executes 58 plotters, buries in mass grave amid reports on rebellion in Mosul He stressed that the units’ goal is not just to push back ISIS militants, but to destroy them.\nISIS leaders rob own treasury, flee Mosul\nMeanwhile, as Iraqi forces push on with operations to liberate Mosul, five high-ranking ISIS commanders have looted the terrorist group’s treasury and fled towards Syria.\nThe robbers, including ISIS’s treasury official Abu al-Bara al-Qahtani and several other terrorists, have taken millions of dollars.\nThe terrorists have launched a manhunt to reclaim the stolen money and arrest and execute the escapees.\nIraqi troops fighting house to house in east Mosul\nHeavy fighting is underway in eastern Mosul as ISIS tries to hinder Iraqi forces advance in the city. The militants are using car bombs, mortar fire, and snipers to stop the government troops.\nA separate group of troops are advancing on the city’s northern side and have reached just within four kilometers of Mosul’s airport.\nIraqi forces have also attacked ISIS-held positions in the town of Hamam al-Alil which is located along the Tigris River some 15 kilometers south of Mosul.\nIraqi army troops, backed by Hashd al-Shaabi and Kurdish Peshmerga forces, are closing in on Mosul, ISIS’s last stronghold in Iraq, from almost all directions in a full-scale operation launched on October 17.\nIraqi troops managed to enter Mosul’s limits earlier in the week for the first time since June 2014, when the city fell to ISIS amid a large-scale terror campaign in northern and western Iraq. So far, a large number of the villages and districts around the city have been purged of the terrorists. Iraqi Prime Minister Haider al-Abadi has vowed that the country’s second largest city will be fully recaptured by year-end.",
		"thread_title": "Iraqi Commander: 'Saudi Arabia Mother of All Terrorism'",
		"title": "Iraqi Commander: 'Saudi Arabia Mother of All Terrorism'",
		"type": "bs",
		"uuid": "7e4aa649af47fc31e095eb06af0500e71fa7864a"
	},
	"-KhIbOq4otbKoLsbyL2F": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-06T12:41:27.186+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.23138078,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.15415858,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.074573405,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03slm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraqi_Army"
				},
				"name": "Iraqi Army",
				"salience": 0.06954759,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.06380522,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.04954795,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fahmi Abbas",
				"salience": 0.0336866,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0336209,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.021596115,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.021596115,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.018054198,
				"type": "OTHER"
			},
			{
				"name": "suicide dogs",
				"salience": 0.018054198,
				"type": "OTHER"
			},
			{
				"name": "advance",
				"salience": 0.016137604,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.011289957,
				"type": "OTHER"
			},
			{
				"name": "officer",
				"salience": 0.011100476,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03n7br",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Erbil"
				},
				"name": "Erbil",
				"salience": 0.009672512,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.008196502,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.006955874,
				"type": "PERSON"
			},
			{
				"name": "Staff",
				"salience": 0.005609368,
				"type": "PERSON"
			},
			{
				"name": "Corps",
				"salience": 0.005000571,
				"type": "ORGANIZATION"
			},
			{
				"name": "Iraqi Armored Units",
				"salience": 0.004952827,
				"type": "LOCATION"
			},
			{
				"name": "intention",
				"salience": 0.0049293377,
				"type": "OTHER"
			},
			{
				"name": "military official",
				"salience": 0.004586659,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.004238081,
				"type": "ORGANIZATION"
			},
			{
				"name": "advance",
				"salience": 0.004238081,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0041293027,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.003963492,
				"type": "PERSON"
			},
			{
				"name": "dogs",
				"salience": 0.003827392,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0033150811,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.0033150811,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0032368726,
				"type": "PERSON"
			},
			{
				"name": "military official",
				"salience": 0.003218157,
				"type": "PERSON"
			},
			{
				"name": "Soldier",
				"salience": 0.003052711,
				"type": "PERSON"
			},
			{
				"name": "suicide attacks",
				"salience": 0.002973382,
				"type": "EVENT"
			},
			{
				"name": "advance",
				"salience": 0.002973382,
				"type": "OTHER"
			},
			{
				"name": "suicide attacks",
				"salience": 0.0028625457,
				"type": "EVENT"
			},
			{
				"name": "interview",
				"salience": 0.0028605491,
				"type": "EVENT"
			},
			{
				"name": "animals",
				"salience": 0.0028477898,
				"type": "OTHER"
			},
			{
				"name": "city center",
				"salience": 0.002584928,
				"type": "LOCATION"
			},
			{
				"name": "suicide attacks",
				"salience": 0.002427991,
				"type": "EVENT"
			},
			{
				"name": "terror",
				"salience": 0.0024189672,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.0023254007,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0023254007,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.0023254007,
				"type": "LOCATION"
			},
			{
				"name": "off-guard",
				"salience": 0.0023254007,
				"type": "OTHER"
			},
			{
				"name": "aim",
				"salience": 0.0022386836,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.0022386836,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0022386836,
				"type": "OTHER"
			},
			{
				"name": "liberation operation",
				"salience": 0.0022386836,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0022386836,
				"type": "OTHER"
			},
			{
				"name": "security source",
				"salience": 0.0022241976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03g2w_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_Republic_News_Agency"
				},
				"name": "IRNA",
				"salience": 0.0020416714,
				"type": "ORGANIZATION"
			},
			{
				"name": "south",
				"salience": 0.0018987186,
				"type": "LOCATION"
			},
			{
				"name": "siege",
				"salience": 0.0018987186,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.0018142359,
				"type": "PERSON"
			},
			{
				"name": "nowhere",
				"salience": 0.0016516651,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0016381779,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.001430479,
				"type": "PERSON"
			},
			{
				"name": "Civilians",
				"salience": 0.001430479,
				"type": "PERSON"
			},
			{
				"name": "spe",
				"salience": 0.0014186314,
				"type": "ORGANIZATION"
			},
			{
				"name": "lieutenant",
				"salience": 0.0014186314,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.0014186314,
				"type": "EVENT"
			},
			{
				"name": "carnage",
				"salience": 0.0014186314,
				"type": "OTHER"
			},
			{
				"name": "Family",
				"salience": 0.0014186314,
				"type": "PERSON"
			},
			{
				"name": "Estrangement It",
				"salience": 0.0012937261,
				"type": "ORGANIZATION"
			},
			{
				"name": "security members",
				"salience": 0.0011932746,
				"type": "PERSON"
			},
			{
				"name": "Hammam al-Alili",
				"salience": 0.0011689577,
				"type": "PERSON"
			},
			{
				"name": "Central Mosul",
				"salience": 0.0011650068,
				"type": "LOCATION"
			},
			{
				"name": "AHT",
				"salience": 0.001077556,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.001068703,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0008914542,
				"type": "OTHER"
			},
			{
				"name": "300 Iraqi Civilians",
				"salience": 0.0008805801,
				"type": "PERSON"
			},
			{
				"name": "Golden Division",
				"salience": 0.0008732844,
				"type": "ORGANIZATION"
			},
			{
				"name": "Battling ISIS",
				"salience": 0.0008732844,
				"type": "EVENT"
			},
			{
				"name": "Mosul Reunited",
				"salience": 0.0008732844,
				"type": "OTHER"
			},
			{
				"name": "Hossam al-Din al-Abbar",
				"salience": 0.00081350864,
				"type": "PERSON"
			},
			{
				"name": "satellite television Quote",
				"salience": 0.00077193254,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.00077193254,
				"type": "ORGANIZATION"
			},
			{
				"name": "residents",
				"salience": 0.00077193254,
				"type": "PERSON"
			},
			{
				"name": "Prisoners Iraq",
				"salience": 0.00074129517,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mosul Member",
				"salience": 0.0007345174,
				"type": "PERSON"
			},
			{
				"name": "Firing Squad North",
				"salience": 0.0006360283,
				"type": "EVENT"
			},
			{
				"name": "Nineveh Provincial Council",
				"salience": 0.0006360283,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j_my",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electric_chair"
				},
				"name": "Electrocution",
				"salience": 0.0006360283,
				"type": "OTHER"
			},
			{
				"name": "You Mosul Civilians Stormed City Main Prison",
				"salience": 0.00054869126,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03cgmt0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Sumaria"
				},
				"name": "al-Sumaria",
				"salience": 0.00047511133,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07pgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tigris"
				},
				"name": "Tigris river",
				"salience": 0.00047511133,
				"type": "LOCATION"
			},
			{
				"name": "Dijlah",
				"salience": 0.00047511133,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/ISIS_Dogs_972c6.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Erbil- While Iraqi forces are advancing in Mosul to free the city, some Iraqi officers were informed about new plan of terrorists of ISIS to use 600 suicide dogs to restrain Iraqi Army’s advance. 20 Shares\n7 13 0 0\nFahmi Abbas, an officer in Iraqi Armored Units had an interview with IRNA and said: “ISIS terrorists have equipped 600 dogs with bombs and want to send them among Iraqi Army forces and explode them by remote control.”\nAs stated by this military official, ISIS’s intention is to hinder advance of Iraqi Army to the city center of Mosul.\nThis new plan was brought up when most of terrorists’ suicide attacks were neutralized by Iraqi heat-seeking missiles before reaching their aim.\nAccording to the statistics announced by Iraqi Army, during the 19 days since Mosul liberation operation began, terrorists of ISIS have performed 100 suicide attacks in different regions, although they didn’t succeed in delaying the advance of Iraqi forces.\nFahmi Abbas stressed that all Corps have been informed about terrorists’ new tactics and they won’t be taken off-guard.\nThis Iraqi military official also mentioned the possibility of using other animals for suicide attacks by the terrorists. He said that ISIS is under siege and terrorists have nowhere to escape, unless they surrender or get killed.\nOn Saturday (5th Nov), Iraqi Army entered “Hammam al-Alili” in south of Mosul and managed to free this part of city in the western bank of Dijlah (Tigris river).\nRecommended For You Mosul Civilians Stormed City Main Prison and Free 45 ISIS Prisoners Iraq's al-Sumaria satellite television Quote: d an unnamed security source that claimed Mosul residents on Friday evening killed ISIS terror...\nBy AHT Staff Iraqi Soldier Battling ISIS in Mosul Reunited with His Family After Two Years of Estrangement It's a heartwarming moment amid the carnage of the battle to liberate Mosul. An Iraqi lieutenant -- part of the elite Golden Division spe...\nBy AHT Staff ISIS Executes 300 Iraqi Civilians by Firing Squad North of Mosul Member of Nineveh Provincial Council, Hossam al-Din al-Abbar, announced, that the ISIS executed 300 civilians and former security members,...\nBy AHT Staff ISIS Executes 22 Civilians by Electrocution in Central Mosul",
		"thread_title": "ISIS Uses 600 Suicide Dogs to Restrain Iraqi Army’s Advance in Mosul",
		"title": "ISIS Uses 600 Suicide Dogs to Restrain Iraqi Army’s Advance in Mosul",
		"type": "bs",
		"uuid": "ed19105e855bc4dc75d24e66c5fe33579c344802"
	},
	"-KhIbOuHJ-u7ey78FFbU": {
		"author": "Bob Mackenzie",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-06T21:35:57.457+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "powers",
				"salience": 0.4816862,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.1036886,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.1036886,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.08480145,
				"type": "OTHER"
			},
			{
				"name": "JFK American",
				"salience": 0.065131016,
				"type": "LOCATION"
			},
			{
				"name": "self serving",
				"salience": 0.060706448,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.02608598,
				"type": "PERSON"
			},
			{
				"name": "world domination",
				"salience": 0.023598608,
				"type": "OTHER"
			},
			{
				"name": "catastrophe",
				"salience": 0.018359566,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.017241031,
				"type": "PERSON"
			},
			{
				"name": "notion",
				"salience": 0.015012487,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hillary_Clinton_13_4f87e.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-11-06T18:14:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.038",
		"text": "Ever since the powers to be assassinated JFK American society and foreign policy has been getting more and more barbaric and more and more arrogant and self serving. The next president just might bring this mistaken notion of their world domination to a final winner takes all catastrophe.",
		"thread_title": "Clinton's Policies Look Like a Death Sentence for Americans",
		"title": "",
		"type": "bs",
		"uuid": "4daec9cba9f02e38e05496202913ab975828867a"
	},
	"-KhIbP0Y4pCQOr-xS_Xn": {
		"author": "Harry Abrams",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-06T21:36:38.936+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.17099991,
				"type": "PERSON"
			},
			{
				"name": "supremacist masturbation fantasy",
				"salience": 0.16710633,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israelis",
				"salience": 0.10182553,
				"type": "PERSON"
			},
			{
				"name": "world map",
				"salience": 0.08761965,
				"type": "OTHER"
			},
			{
				"name": "fall",
				"salience": 0.08761965,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arabs",
				"salience": 0.06793782,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.042795632,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.03666131,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.029748566,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.028647874,
				"type": "LOCATION"
			},
			{
				"name": "Palestine Arabs",
				"salience": 0.026144736,
				"type": "ORGANIZATION"
			},
			{
				"name": "offers",
				"salience": 0.024835818,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman",
				"salience": 0.0226633,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h44w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mandatory_Palestine"
				},
				"name": "Palestine",
				"salience": 0.020338163,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.015776237,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0h44w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mandatory_Palestine"
				},
				"name": "Palestine",
				"salience": 0.012432054,
				"type": "LOCATION"
			},
			{
				"name": "generation",
				"salience": 0.011504277,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.011504277,
				"type": "PERSON"
			},
			{
				"name": "politicos",
				"salience": 0.010010628,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.009929058,
				"type": "EVENT"
			},
			{
				"name": "writers",
				"salience": 0.008600853,
				"type": "PERSON"
			},
			{
				"name": "Baroud",
				"salience": 0.0052983216,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Balfour_Declaration_a9ceb.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-06T19:29:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.009",
		"text": "Another Arab supremacist masturbation fantasy. The world map was re-shaped after the fall of the Ottoman empire almost 100 years ago. And the Palestine Arabs refused several very good offers since then to share the area with the Jews, who are native to the area called Palestine. And that conflict continues to this day. The Israelis have bent over backwards to try and accommodate them, and many Arabs would like to end the conflict, but the current politicos and lunatic blood-seeking writers like Baroud won't be happy without another war, seeking a Jew-free Palestine. Perhaps their next generation of leaders will want to look forward rather than backwards.",
		"thread_title": "Why Palestinians Want to Sue Britain: 99 Years since the Balfour Declaration",
		"title": "",
		"type": "bs",
		"uuid": "7677cc1219be7c6d70d7c61f136f938a62e084c5"
	},
	"-KhIbPVeGmXSIr7-3uhB": {
		"author": "Kim Petersen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-07T21:09:27.977+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.21754529,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.15806255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02cvn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David"
				},
				"name": "David",
				"salience": 0.066352606,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.065532595,
				"type": "LOCATION"
			},
			{
				"name": "empire",
				"salience": 0.037465833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.015843214,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.015159805,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedish",
				"salience": 0.01235255,
				"type": "LOCATION"
			},
			{
				"name": "crime",
				"salience": 0.01229762,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.011263748,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.010732174,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ecuador"
				},
				"name": "Ecuador",
				"salience": 0.0077138008,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.0065187137,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.006319445,
				"type": "OTHER"
			},
			{
				"name": "publisher",
				"salience": 0.0061847377,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cm45",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goliath"
				},
				"name": "David and Goliath",
				"salience": 0.005916101,
				"type": "LOCATION"
			},
			{
				"name": "stories",
				"salience": 0.0058931727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "underdog",
				"salience": 0.0058931727,
				"type": "PERSON"
			},
			{
				"name": "asylum",
				"salience": 0.0056273616,
				"type": "OTHER"
			},
			{
				"name": "telling",
				"salience": 0.005258716,
				"type": "EVENT"
			},
			{
				"name": "giant",
				"salience": 0.005258716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mismatch",
				"salience": 0.005258716,
				"type": "EVENT"
			},
			{
				"name": "hype",
				"salience": 0.005258716,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.005258716,
				"type": "OTHER"
			},
			{
				"name": "fairy tales",
				"salience": 0.005258716,
				"type": "WORK_OF_ART"
			},
			{
				"name": "man",
				"salience": 0.0049889903,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.004394321,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.00421637,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00391296,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.0037197033,
				"type": "OTHER"
			},
			{
				"name": "consciousness",
				"salience": 0.003551667,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0035177253,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Clinton",
				"salience": 0.0034775774,
				"type": "PERSON"
			},
			{
				"name": "founder",
				"salience": 0.0034366539,
				"type": "PERSON"
			},
			{
				"name": "prisoner",
				"salience": 0.0034366539,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0031513681,
				"type": "PERSON"
			},
			{
				"name": "weaponry",
				"salience": 0.0031032448,
				"type": "OTHER"
			},
			{
				"name": "publishing organization",
				"salience": 0.0031032448,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0031032448,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.0031032448,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0031032448,
				"type": "PERSON"
			},
			{
				"name": "detention",
				"salience": 0.0031032448,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0031032448,
				"type": "LOCATION"
			},
			{
				"name": "weapon",
				"salience": 0.0031032448,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.0031032448,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0031001142,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0028809782,
				"type": "WORK_OF_ART"
			},
			{
				"name": "facts",
				"salience": 0.002787896,
				"type": "OTHER"
			},
			{
				"name": "Clintonites",
				"salience": 0.0027155946,
				"type": "PERSON"
			},
			{
				"name": "surveillance",
				"salience": 0.0026874517,
				"type": "OTHER"
			},
			{
				"name": "encounter",
				"salience": 0.0026874517,
				"type": "EVENT"
			},
			{
				"name": "machinations",
				"salience": 0.0026874517,
				"type": "OTHER"
			},
			{
				"name": "foe",
				"salience": 0.0026874517,
				"type": "OTHER"
			},
			{
				"name": "fronts",
				"salience": 0.0026874517,
				"type": "OTHER"
			},
			{
				"name": "sling",
				"salience": 0.0026874517,
				"type": "OTHER"
			},
			{
				"name": "behemoth",
				"salience": 0.0026874517,
				"type": "OTHER"
			},
			{
				"name": "embassy",
				"salience": 0.0026874517,
				"type": "LOCATION"
			},
			{
				"name": "target",
				"salience": 0.0026874517,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0026874517,
				"type": "OTHER"
			},
			{
				"name": "vets",
				"salience": 0.002382242,
				"type": "PERSON"
			},
			{
				"name": "version",
				"salience": 0.0023377496,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "person",
				"salience": 0.0021645662,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0021059432,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation states",
				"salience": 0.0020611305,
				"type": "LOCATION"
			},
			{
				"name": "principals",
				"salience": 0.002055295,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0020328173,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c3tl_f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Manning"
				},
				"name": "Chelsea Manning",
				"salience": 0.0020226613,
				"type": "PERSON"
			},
			{
				"name": "temerity",
				"salience": 0.0020078982,
				"type": "OTHER"
			},
			{
				"name": "nation states",
				"salience": 0.0019592291,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0019185722,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.0018667285,
				"type": "ORGANIZATION"
			},
			{
				"name": "public",
				"salience": 0.0018100375,
				"type": "PERSON"
			},
			{
				"name": "Nations",
				"salience": 0.0018100375,
				"type": "ORGANIZATION"
			},
			{
				"name": "establishment",
				"salience": 0.0017262459,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0016545001,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.0016343242,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation states",
				"salience": 0.0016199484,
				"type": "LOCATION"
			},
			{
				"name": "prosecutor",
				"salience": 0.0016081475,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.0015318972,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0015318972,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0014152264,
				"type": "WORK_OF_ART"
			},
			{
				"name": "citizenry",
				"salience": 0.0014152264,
				"type": "PERSON"
			},
			{
				"name": "citizenry",
				"salience": 0.0014152264,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0014061154,
				"type": "LOCATION"
			},
			{
				"name": "caliber",
				"salience": 0.0013637781,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04cmyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Debbie_Wasserman_Schultz"
				},
				"name": "Debbie Wasserman Schultz",
				"salience": 0.0013049565,
				"type": "PERSON"
			},
			{
				"name": "kinds",
				"salience": 0.00130306,
				"type": "OTHER"
			},
			{
				"name": "troves",
				"salience": 0.0012883447,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.001277819,
				"type": "OTHER"
			},
			{
				"name": "collaborators",
				"salience": 0.001277819,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.001277819,
				"type": "OTHER"
			},
			{
				"name": "court approval",
				"salience": 0.001277819,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.001277819,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.001277819,
				"type": "OTHER"
			},
			{
				"name": "detention",
				"salience": 0.001277819,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.001277819,
				"type": "OTHER"
			},
			{
				"name": "color revolutions",
				"salience": 0.001277819,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0012691512,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02t7t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Evangelicalism"
				},
				"name": "Evangelicals",
				"salience": 0.0011972449,
				"type": "PERSON"
			},
			{
				"name": "assessment",
				"salience": 0.0011789183,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0011765376,
				"type": "PERSON"
			},
			{
				"name": "intent",
				"salience": 0.0011459197,
				"type": "OTHER"
			},
			{
				"name": "persecution",
				"salience": 0.0011459197,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0011392933,
				"type": "OTHER"
			},
			{
				"name": "State",
				"salience": 0.0011358379,
				"type": "LOCATION"
			},
			{
				"name": "slew",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0011064914,
				"type": "ORGANIZATION"
			},
			{
				"name": "exposes",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "workings",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "wraps",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "browbeating",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "military encirclement",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "saber rattling",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "might",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "standard",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.0011064914,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0010740879,
				"type": "EVENT"
			},
			{
				"name": "empire",
				"salience": 0.001036095,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0009997452,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.0009922694,
				"type": "LOCATION"
			},
			{
				"name": "assurance",
				"salience": 0.0009922694,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0009922694,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0009561907,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00093548343,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.00092369475,
				"type": "OTHER"
			},
			{
				"name": "deals",
				"salience": 0.00091482146,
				"type": "OTHER"
			},
			{
				"name": "Evidence",
				"salience": 0.00091482146,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.000900561,
				"type": "ORGANIZATION"
			},
			{
				"name": "justice",
				"salience": 0.0008959119,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0008959119,
				"type": "OTHER"
			},
			{
				"name": "distraction",
				"salience": 0.0008959119,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0008846217,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0008734737,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00086306897,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.0008624661,
				"type": "OTHER"
			},
			{
				"name": "schemers",
				"salience": 0.0008624661,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0008624661,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0008624661,
				"type": "LOCATION"
			},
			{
				"name": "punk computer hackers",
				"salience": 0.0008624661,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0008624661,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.0008624661,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0008624661,
				"type": "OTHER"
			},
			{
				"name": "assurance",
				"salience": 0.0008521925,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.00082655955,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0008125916,
				"type": "OTHER"
			},
			{
				"name": "prisoner",
				"salience": 0.0008100396,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0008100396,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0008100396,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0008066487,
				"type": "OTHER"
			},
			{
				"name": "interviews",
				"salience": 0.0008034202,
				"type": "OTHER"
			},
			{
				"name": "Assange UN",
				"salience": 0.0007864912,
				"type": "ORGANIZATION"
			},
			{
				"name": "request",
				"salience": 0.0007856741,
				"type": "OTHER"
			},
			{
				"name": "intrigue",
				"salience": 0.0007757726,
				"type": "OTHER"
			},
			{
				"name": "processes",
				"salience": 0.0007757726,
				"type": "OTHER"
			},
			{
				"name": "Disinformation",
				"salience": 0.0007757726,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.0007757726,
				"type": "OTHER"
			},
			{
				"name": "house arrest",
				"salience": 0.0007757726,
				"type": "EVENT"
			},
			{
				"name": "allegations",
				"salience": 0.0007757726,
				"type": "OTHER"
			},
			{
				"name": "publications",
				"salience": 0.0007739668,
				"type": "WORK_OF_ART"
			},
			{
				"name": "publications",
				"salience": 0.0007739668,
				"type": "WORK_OF_ART"
			},
			{
				"name": "asylum",
				"salience": 0.00076943316,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0007626626,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0007501616,
				"type": "PERSON"
			},
			{
				"name": "financing squeeze",
				"salience": 0.0007468104,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0007468104,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0007468104,
				"type": "OTHER"
			},
			{
				"name": "tabs",
				"salience": 0.0007468104,
				"type": "OTHER"
			},
			{
				"name": "tricks",
				"salience": 0.0007468104,
				"type": "OTHER"
			},
			{
				"name": "sex",
				"salience": 0.0007468104,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.0007468104,
				"type": "EVENT"
			},
			{
				"name": "self-defense",
				"salience": 0.0007468104,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0007468104,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0007423043,
				"type": "PERSON"
			},
			{
				"name": "journalists",
				"salience": 0.0007419725,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.0007407075,
				"type": "OTHER"
			},
			{
				"name": "pay-for-play",
				"salience": 0.0007326216,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00073137257,
				"type": "OTHER"
			},
			{
				"name": "grand jury investigation",
				"salience": 0.00073137257,
				"type": "EVENT"
			},
			{
				"name": "grand jury investigation",
				"salience": 0.00073137257,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.00073137257,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.00073137257,
				"type": "ORGANIZATION"
			},
			{
				"name": "democracy",
				"salience": 0.00072882,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0007105653,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0007098685,
				"type": "OTHER"
			},
			{
				"name": "court cases",
				"salience": 0.0006988019,
				"type": "OTHER"
			},
			{
				"name": "refugee cases",
				"salience": 0.0006988019,
				"type": "OTHER"
			},
			{
				"name": "persecution",
				"salience": 0.0006988019,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00069519406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bmh3b5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/July_12,_2007_Baghdad_airstrike"
				},
				"name": "Collateral Murder",
				"salience": 0.0006810206,
				"type": "OTHER"
			},
			{
				"name": "assurance",
				"salience": 0.0006612667,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00065498974,
				"type": "EVENT"
			},
			{
				"name": "documents",
				"salience": 0.00065498974,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.0006427577,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.0006376857,
				"type": "ORGANIZATION"
			},
			{
				"name": "deportation",
				"salience": 0.0006332915,
				"type": "EVENT"
			},
			{
				"name": "hubris",
				"salience": 0.0006332915,
				"type": "OTHER"
			},
			{
				"name": "zeal",
				"salience": 0.0006332915,
				"type": "OTHER"
			},
			{
				"name": "minions",
				"salience": 0.0006332915,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0006332915,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.0006332915,
				"type": "EVENT"
			},
			{
				"name": "result",
				"salience": 0.0006332915,
				"type": "OTHER"
			},
			{
				"name": "Neither",
				"salience": 0.00060964713,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.0006050876,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0006046649,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00058208907,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.00057559833,
				"type": "LOCATION"
			},
			{
				"name": "empire",
				"salience": 0.00056365796,
				"type": "OTHER"
			},
			{
				"name": "drone",
				"salience": 0.0005532934,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0005513622,
				"type": "OTHER"
			},
			{
				"name": "Most",
				"salience": 0.0005463198,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0005463198,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0005463198,
				"type": "OTHER"
			},
			{
				"name": "pardon",
				"salience": 0.000543879,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0005346869,
				"type": "EVENT"
			},
			{
				"name": "military intelligence",
				"salience": 0.000508913,
				"type": "OTHER"
			},
			{
				"name": "persons",
				"salience": 0.000508913,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.000508913,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "US Department of Justice",
				"salience": 0.00048353896,
				"type": "ORGANIZATION"
			},
			{
				"name": "books",
				"salience": 0.00047908878,
				"type": "WORK_OF_ART"
			},
			{
				"name": "drone attack",
				"salience": 0.00047305026,
				"type": "EVENT"
			},
			{
				"name": "barrage",
				"salience": 0.00047305026,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00047305026,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.00047305026,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.00047305026,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09w3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pentagon"
				},
				"name": "Pentagon",
				"salience": 0.00047142658,
				"type": "ORGANIZATION"
			},
			{
				"name": "reverberations",
				"salience": 0.00046327038,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00045961753,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stockholm"
				},
				"name": "Stockholm",
				"salience": 0.00045961753,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00045961753,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0004557588,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0004557588,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.00045340555,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.00044065932,
				"type": "OTHER"
			},
			{
				"name": "complex",
				"salience": 0.00044065932,
				"type": "LOCATION"
			},
			{
				"name": "arms companies",
				"salience": 0.00044065932,
				"type": "ORGANIZATION"
			},
			{
				"name": "possibility",
				"salience": 0.00041669607,
				"type": "OTHER"
			},
			{
				"name": "heads",
				"salience": 0.0004132904,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00039785853,
				"type": "OTHER"
			},
			{
				"name": "counter coup",
				"salience": 0.00039785853,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00039785853,
				"type": "EVENT"
			},
			{
				"name": "cronyism",
				"salience": 0.00039785853,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00039785853,
				"type": "LOCATION"
			},
			{
				"name": "revolution",
				"salience": 0.00039785853,
				"type": "EVENT"
			},
			{
				"name": "agencies",
				"salience": 0.00039785853,
				"type": "ORGANIZATION"
			},
			{
				"name": "banks",
				"salience": 0.00039785853,
				"type": "ORGANIZATION"
			},
			{
				"name": "cronies",
				"salience": 0.00039785853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.0003833904,
				"type": "ORGANIZATION"
			},
			{
				"name": "damage",
				"salience": 0.00037173994,
				"type": "OTHER"
			},
			{
				"name": "drama",
				"salience": 0.0003624276,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00036194836,
				"type": "WORK_OF_ART"
			},
			{
				"name": "war",
				"salience": 0.00035630178,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00035630178,
				"type": "EVENT"
			},
			{
				"name": "Clintonites",
				"salience": 0.00035229727,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.00034449686,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.00034449686,
				"type": "EVENT"
			},
			{
				"name": "exception",
				"salience": 0.00034449686,
				"type": "OTHER"
			},
			{
				"name": "media owners",
				"salience": 0.00034449686,
				"type": "PERSON"
			},
			{
				"name": "elsewhere",
				"salience": 0.00032915274,
				"type": "LOCATION"
			},
			{
				"name": "kind",
				"salience": 0.00032915274,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00032915274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "foundation",
				"salience": 0.00032915274,
				"type": "OTHER"
			},
			{
				"name": "security organizations",
				"salience": 0.0003267916,
				"type": "ORGANIZATION"
			},
			{
				"name": "Revelations",
				"salience": 0.00030870843,
				"type": "OTHER"
			},
			{
				"name": "hacking",
				"salience": 0.00029718105,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.00029718105,
				"type": "OTHER"
			},
			{
				"name": "intelligence agencies",
				"salience": 0.00029718105,
				"type": "ORGANIZATION"
			},
			{
				"name": "banks",
				"salience": 0.00029718105,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.00029718105,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00029718105,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00029718105,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.00027071484,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.000257321,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.000257321,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.000257321,
				"type": "EVENT"
			},
			{
				"name": "hysteria",
				"salience": 0.000257321,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.000257321,
				"type": "OTHER"
			},
			{
				"name": "disarray",
				"salience": 0.000257321,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.000257321,
				"type": "ORGANIZATION"
			},
			{
				"name": "anyone",
				"salience": 0.000257321,
				"type": "PERSON"
			},
			{
				"name": "jihadism",
				"salience": 0.000257321,
				"type": "OTHER"
			},
			{
				"name": "cabinet positions",
				"salience": 0.00024771225,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00021200326,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.00021200326,
				"type": "ORGANIZATION"
			},
			{
				"name": "neo-McCarthy",
				"salience": 0.00015835295,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.00015835295,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00015835295,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00015835295,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Julian_Assange_cfc6d.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 27.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "The ultimate underdog 23 Shares\n9 12 0 2\nEver since the telling of biblical fairy tales, few stories have lived up to the hype around the mismatch between the shepherd boy David and the giant Goliath. In the biblical encounter, David prevailed by keeping his foe Goliath at a distance with a formidable weapon, his sling.\nToday a modern-day version of David and Goliath is playing out.\nAlthough granted political asylum by Ecuador, a target of US empire finds himself ensconced under a form of arbitrary detention in Ecuador's London embassy under constant surveillance by British police. The fully weaponized US empire, which boasts of its full-spectrum dominance, has arrayed itself and its allies against one unarmed (as in having no conventional weaponry) man who heads a publishing organization.\nThis uppity publisher has had the temerity to expose the secret machinations and war crimes of the military-economic (albeit faltering on both fronts) behemoth to the world's public. The pro-transparency publisher Wikileaks, its founder (and de facto political prisoner) Julian Assange, and anti-secrecy collaborators infuriated the United States establishment with a slew of documents, emails, and graphic exposes like the \" Collateral Murder \" video that demonstrated a US military engaged in war crimes.\nNations states are adamant and fastidious about keeping their internal workings under wraps. But it is a one-way street, as many nation states seek to gather and store any and all information about the citizenry without seeking court approval or the approval of the citizenry in question.\nMORE... Swedish government implicated in charges against Assange UN body to rule on \"arbitrary detention\" of Wikileaks founder Web-savvy Wikileaks objects to this double standard, and it welcomes, vets, and publishes troves of secret information premised on the principle of the public's right to be informed about what their government is up to.\nEvidence makes it clear that the violent American establishment engages in browbeating, inciting so-called color revolutions to destabilize and overthrow disobedient governments, military encirclement, and saber rattling. This self-described indispensable nation which preens its might before major nation states such as China and Russia was not about to have its full-spectrum dominance challenged by punk computer hackers.\nLeaning on its allies, the US enacted a financing squeeze on Wikileaks. Many nation states have been severely crippled and devastated by US sanctions, but tiny Wikileaks proved more resilient and cleverer than the Washington schemers.\nIn an attempt to topple Wikileaks, the US establishment has sought to lop off the head of Wikileaks. It has kept close tabs on Julian Assange and is purportedly behind a scheme to bring Assange down in Sweden: \"We have been warned that the Pentagon, for example, is thinking of deploying dirty tricks to ruin us.\"\nIn Sweden consensual sex has been parlayed as rape. In self-defense Assange spoke to the facts of the situation :\nHere we have a case, the Swedish case, where I have never been charged with a crime, where I have already been cleared [by the Stockholm prosecutor] and found to be innocent, where the woman herself said that the police made it up, where the United Nations formally said the whole thing is illegal, where the State of Ecuador also investigated and found that I should be given asylum. Those are the facts, but what is the rhetoric?\n... the UN formally found that the whole thing is illegal, never even mentioning that Ecuador made a formal assessment through its formal processes and found that yes, I am subject to persecution by the United States.\nDisinformation and distraction are among the underhanded tactics of empire.\nWhile in Britain, Assange was eventually placed under house arrest. Sweden played out the drama while refusing to press charges or interview Assange in Britain on the allegations. It insisted he come to Sweden, which Assange was unwilling to do without an assurance that he would not be deported elsewhere, knowing full well that the US Department of Justice was preparing a case against him. Sweden refused to give such an assurance, which speaks strongly about Sweden's intent to seek justice for any alleged crimes committed against its citizens.\nDespite all this intrigue, Wikileaks has continued to publish and Assange has continued to give interviews. Assange did not cower, instead he chose to fight back against Hillary Clinton and the Democrats. This is because Hillary Clinton and the Democrats are the principals in power and the grand jury investigation into himself and Wikileaks has been occurring during their time in government.\nClinton and the Democrats are victims of their own zeal and hubris. Along the way many outs presented themselves to the Democrats. They could have dropped the grand jury investigation. They could have provided an assurance that there would be no request for Assange's deportation from Sweden. The US could even have given a presidential pardon to Assange. Extremely telling about the caliber of man that Assange is, is that he offered himself as a prisoner in exchange for the release of another political prisoner, Chelsea Manning.\nBut empire and its minions were dismissive as is the way of empire. Empire does not negotiate deals. It takes what it wants because it believes it can.\nThe result\nThe corruption in the Democratic party has come to light. Wikileaks revealed that the Democratic National Committee conspired against party aspirant Bernie Sanders and heads fell. Clinton tellingly hired the subsequently fallen DNC chair Debbie Wasserman Schultz.\nClinton's emails were leaked as were those of her campaign chair John Podesta. Revelations include \"pay-for-play, as they call it, giving access in exchange for money to states, individuals and corporations,\" a \" direct connection between Hillary Clinton and the foundation of jihadism, of ISIL, in the Middle East,\" \"Libya, more than anyone else's war, was Hillary Clinton's war,\" and banks buying cabinet positions.\nThe Clinton campaign has, predictably, been thrown into disarray.\nThe Clintonites could not refute what was in their own emails. Instead they sought to deflect attention elsewhere. The Clintonites blamed Russian hacking for interfering in the US presidential race. Finally, Julian Assange felt compelled to state :\nThe Clinton camp has been able to project that kind of neo-McCarthy hysteria: that Russia is responsible for everything. Hilary Clinton stated multiple times, falsely, that seventeen U.S. intelligence agencies had assessed that Russia was the source of our publications. That is false; we can say that the Russian government is not the source.\nNeither is Wikileaks complicit with Russia:\nWe have published about 800,000 documents of various kinds that relate to Russia. Most of those are critical; and a great many books have come out of our publications about Russia, most of which are critical. Our [Russia]documents have gone on to be used in quite a number of court cases: refugee cases of people fleeing some kind of claimed political persecution in Russia, which they use our documents to back up.\nGraciously toward Clinton, Assange said he feels sorry for the woman who wanted to \" drone \" him. Imagine what the response would have been if Assange had discussed the possibility of a drone attack against Clinton.\nPresently, Assange downplays the damage from the barrage of leaks to the Clinton campaign for the presidency.\nTrump would not be permitted to win. Why do I say that? Because he's had every establishment off side; Trump doesn't have one establishment, maybe with the exception of the Evangelicals, if you can call them an establishment, but banks, intelligence [agencies], arms companies... big foreign money ... are all united behind Hillary Clinton, and the media as well, media owners and even journalists themselves.\nHowever, a counter coup was announced against the coup by \"Clinton cronyism.\" It is said to include FBI, CIA, military intelligence, other security organizations \"through Julian Assange\" that have promised to stop Clinton from becoming president and to convict and indict her and her cronies.\nA revolution?\nNo matter what transpires on November 8, the reverberations from this confrontation should be monumental. US democracy has — again — been revealed to be glaringly corrupt. Most importantly, the world's preeminent military-industrial complex has been shown to be susceptible to the power of one person. Properly framed, it is the power of one person to work with other persons to form a greater consciousness, a consciousness that ultimately will transcend and defeat the corruption of empire.",
		"thread_title": "Political Prisoner Takes on US Military-Industrial Complex",
		"title": "Political Prisoner Takes on US Military-Industrial Complex",
		"type": "bs",
		"uuid": "c652d8e14a73873e34e2242a81d1b14c81608745"
	},
	"-KhIbPwcDccDC7oefU5m": {
		"author": "Daniel Haiphong",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-07T21:20:49.166+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "schools",
				"salience": 0.18253282,
				"type": "ORGANIZATION"
			},
			{
				"name": "education",
				"salience": 0.06799803,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "Massachusetts",
				"salience": 0.06356029,
				"type": "LOCATION"
			},
			{
				"name": "program",
				"salience": 0.03884411,
				"type": "OTHER"
			},
			{
				"name": "charter schools",
				"salience": 0.017300947,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.016494233,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.015358782,
				"type": "OTHER"
			},
			{
				"name": "ofMassachusetts",
				"salience": 0.015198794,
				"type": "LOCATION"
			},
			{
				"name": "charter school scam",
				"salience": 0.013115611,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.011932461,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.011599775,
				"type": "OTHER"
			},
			{
				"name": "privatization",
				"salience": 0.0107943015,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.010399337,
				"type": "LOCATION"
			},
			{
				"name": "players",
				"salience": 0.009170602,
				"type": "PERSON"
			},
			{
				"name": "cap",
				"salience": 0.009009138,
				"type": "OTHER"
			},
			{
				"name": "state district",
				"salience": 0.009009138,
				"type": "ORGANIZATION"
			},
			{
				"name": "charter school cap",
				"salience": 0.009009138,
				"type": "OTHER"
			},
			{
				"name": "Charter schools",
				"salience": 0.008803154,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition",
				"salience": 0.008465682,
				"type": "ORGANIZATION"
			},
			{
				"name": "Question",
				"salience": 0.008445959,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.007962961,
				"type": "PERSON"
			},
			{
				"name": "transformation",
				"salience": 0.007804227,
				"type": "EVENT"
			},
			{
				"name": "education system",
				"salience": 0.007804227,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0071461075,
				"type": "ORGANIZATION"
			},
			{
				"name": "charter schools",
				"salience": 0.0071461075,
				"type": "ORGANIZATION"
			},
			{
				"name": "Administration",
				"salience": 0.0070481165,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0070481165,
				"type": "OTHER"
			},
			{
				"name": "charter schools",
				"salience": 0.0068799327,
				"type": "ORGANIZATION"
			},
			{
				"name": "Charter schools",
				"salience": 0.0065808324,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.0062174937,
				"type": "ORGANIZATION"
			},
			{
				"name": "march",
				"salience": 0.0061048674,
				"type": "OTHER"
			},
			{
				"name": "deals",
				"salience": 0.0061048674,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.0061048674,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.005412265,
				"type": "OTHER"
			},
			{
				"name": "tentacles",
				"salience": 0.0052444604,
				"type": "OTHER"
			},
			{
				"name": "charter schools",
				"salience": 0.005142166,
				"type": "ORGANIZATION"
			},
			{
				"name": "schools",
				"salience": 0.005013577,
				"type": "ORGANIZATION"
			},
			{
				"name": "charter schools",
				"salience": 0.005013577,
				"type": "ORGANIZATION"
			},
			{
				"name": "Charter schools",
				"salience": 0.005013577,
				"type": "ORGANIZATION"
			},
			{
				"name": "schools",
				"salience": 0.005013577,
				"type": "ORGANIZATION"
			},
			{
				"name": "Save Our Schools",
				"salience": 0.004967442,
				"type": "ORGANIZATION"
			},
			{
				"name": "schools",
				"salience": 0.0048266873,
				"type": "ORGANIZATION"
			},
			{
				"name": "charter schools",
				"salience": 0.0048266873,
				"type": "ORGANIZATION"
			},
			{
				"name": "charter schools",
				"salience": 0.0048266873,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0043416466,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.004243694,
				"type": "LOCATION"
			},
			{
				"name": "charters",
				"salience": 0.0041958774,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0040939515,
				"type": "ORGANIZATION"
			},
			{
				"name": "testing withcurriculums",
				"salience": 0.003796395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.0037600836,
				"type": "PERSON"
			},
			{
				"name": "teachers union",
				"salience": 0.0037291732,
				"type": "ORGANIZATION"
			},
			{
				"name": "district",
				"salience": 0.0037142634,
				"type": "ORGANIZATION"
			},
			{
				"name": "district",
				"salience": 0.0037142634,
				"type": "LOCATION"
			},
			{
				"name": "districts",
				"salience": 0.0037142634,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.003622464,
				"type": "LOCATION"
			},
			{
				"name": "managers",
				"salience": 0.0035793425,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.0035632753,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0035184142,
				"type": "OTHER"
			},
			{
				"name": "closure",
				"salience": 0.003481637,
				"type": "EVENT"
			},
			{
				"name": "transformation",
				"salience": 0.0032166352,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0032166352,
				"type": "OTHER"
			},
			{
				"name": "privatization",
				"salience": 0.003141856,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0031406805,
				"type": "PERSON"
			},
			{
				"name": "mandates",
				"salience": 0.003017047,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0029044987,
				"type": "EVENT"
			},
			{
				"name": "mandates",
				"salience": 0.0029044987,
				"type": "OTHER"
			},
			{
				"name": "charter laboratories",
				"salience": 0.0029044987,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.0028848078,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0028848078,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0028848078,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.0028728165,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0028727408,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0028191654,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0027836626,
				"type": "ORGANIZATION"
			},
			{
				"name": "charter school students",
				"salience": 0.0027771874,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6k9_t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Race_to_the_Top"
				},
				"name": "Race to the Top",
				"salience": 0.0026074736,
				"type": "WORK_OF_ART"
			},
			{
				"name": "results",
				"salience": 0.0025473395,
				"type": "OTHER"
			},
			{
				"name": "mergers",
				"salience": 0.0025152566,
				"type": "OTHER"
			},
			{
				"name": "elimination",
				"salience": 0.0025152566,
				"type": "OTHER"
			},
			{
				"name": "capitalists",
				"salience": 0.0025152566,
				"type": "PERSON"
			},
			{
				"name": "billions",
				"salience": 0.0025152566,
				"type": "OTHER"
			},
			{
				"name": "incentive schemes",
				"salience": 0.0025152566,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0025152566,
				"type": "LOCATION"
			},
			{
				"name": "front",
				"salience": 0.0025152566,
				"type": "OTHER"
			},
			{
				"name": "roots",
				"salience": 0.0025152566,
				"type": "OTHER"
			},
			{
				"name": "district",
				"salience": 0.0025076533,
				"type": "LOCATION"
			},
			{
				"name": "school teachers",
				"salience": 0.0025076533,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0023553048,
				"type": "PERSON"
			},
			{
				"name": "closure",
				"salience": 0.00235053,
				"type": "EVENT"
			},
			{
				"name": "school closures",
				"salience": 0.00235053,
				"type": "EVENT"
			},
			{
				"name": "teachers",
				"salience": 0.002308968,
				"type": "PERSON"
			},
			{
				"name": "theDemocratic Party",
				"salience": 0.002259003,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.002255721,
				"type": "OTHER"
			},
			{
				"name": "education system",
				"salience": 0.00217155,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00217155,
				"type": "OTHER"
			},
			{
				"name": "backing",
				"salience": 0.0021700338,
				"type": "OTHER"
			},
			{
				"name": "Hundreds",
				"salience": 0.0021603443,
				"type": "PERSON"
			},
			{
				"name": "charter school cap",
				"salience": 0.0021266825,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0021013606,
				"type": "PERSON"
			},
			{
				"name": "test corporations",
				"salience": 0.0020367575,
				"type": "ORGANIZATION"
			},
			{
				"name": "policy",
				"salience": 0.0020367575,
				"type": "OTHER"
			},
			{
				"name": "rates",
				"salience": 0.0020367575,
				"type": "OTHER"
			},
			{
				"name": "rates",
				"salience": 0.0020367575,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0020367575,
				"type": "OTHER"
			},
			{
				"name": "charter school movement",
				"salience": 0.0020367575,
				"type": "OTHER"
			},
			{
				"name": "Question two",
				"salience": 0.0019934115,
				"type": "OTHER"
			},
			{
				"name": "tax payer dollars",
				"salience": 0.0019934115,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001960751,
				"type": "LOCATION"
			},
			{
				"name": "schools",
				"salience": 0.0019382917,
				"type": "ORGANIZATION"
			},
			{
				"name": "charter schools",
				"salience": 0.0019382917,
				"type": "ORGANIZATION"
			},
			{
				"name": "privatization",
				"salience": 0.0019046754,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0018791493,
				"type": "LOCATION"
			},
			{
				"name": "Charter schools",
				"salience": 0.0018424498,
				"type": "ORGANIZATION"
			},
			{
				"name": "funds",
				"salience": 0.0018416051,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jbl2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Education"
				},
				"name": "Department of Education",
				"salience": 0.0018258155,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black",
				"salience": 0.0017880867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama Administration",
				"salience": 0.0017880867,
				"type": "ORGANIZATION"
			},
			{
				"name": "elite",
				"salience": 0.0017637262,
				"type": "PERSON"
			},
			{
				"name": "addition",
				"salience": 0.0017637262,
				"type": "OTHER"
			},
			{
				"name": "suspension",
				"salience": 0.0017637262,
				"type": "EVENT"
			},
			{
				"name": "expulsion",
				"salience": 0.0017637262,
				"type": "EVENT"
			},
			{
				"name": "charter operators",
				"salience": 0.0017637262,
				"type": "ORGANIZATION"
			},
			{
				"name": "test scores",
				"salience": 0.0017637262,
				"type": "OTHER"
			},
			{
				"name": "cream",
				"salience": 0.0017637262,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0017637262,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.001759622,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0016979018,
				"type": "LOCATION"
			},
			{
				"name": "class",
				"salience": 0.0016979018,
				"type": "OTHER"
			},
			{
				"name": "segregation",
				"salience": 0.0016979018,
				"type": "OTHER"
			},
			{
				"name": "teacher layoffs",
				"salience": 0.0016979018,
				"type": "EVENT"
			},
			{
				"name": "impact",
				"salience": 0.0016979018,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0016979018,
				"type": "OTHER"
			},
			{
				"name": "strike",
				"salience": 0.0016979018,
				"type": "EVENT"
			},
			{
				"name": "Tens of thousands",
				"salience": 0.0016979018,
				"type": "OTHER"
			},
			{
				"name": "unions",
				"salience": 0.0016781556,
				"type": "ORGANIZATION"
			},
			{
				"name": "unions",
				"salience": 0.0016781556,
				"type": "ORGANIZATION"
			},
			{
				"name": "union",
				"salience": 0.0016781556,
				"type": "ORGANIZATION"
			},
			{
				"name": "schools",
				"salience": 0.0016647397,
				"type": "ORGANIZATION"
			},
			{
				"name": "drive",
				"salience": 0.0016628144,
				"type": "EVENT"
			},
			{
				"name": "upwards",
				"salience": 0.0016628144,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0016628144,
				"type": "ORGANIZATION"
			},
			{
				"name": "Civil Rights Project",
				"salience": 0.001649709,
				"type": "OTHER"
			},
			{
				"name": "educators",
				"salience": 0.0016446246,
				"type": "PERSON"
			},
			{
				"name": "bid",
				"salience": 0.0016345324,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0015887858,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0015887858,
				"type": "OTHER"
			},
			{
				"name": "teachers",
				"salience": 0.0015887858,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0015483705,
				"type": "LOCATION"
			},
			{
				"name": "families",
				"salience": 0.0014892037,
				"type": "PERSON"
			},
			{
				"name": "privatization",
				"salience": 0.0014594459,
				"type": "EVENT"
			},
			{
				"name": "donations",
				"salience": 0.0014398834,
				"type": "OTHER"
			},
			{
				"name": "manipulation",
				"salience": 0.0014398834,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0014398834,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0014398834,
				"type": "OTHER"
			},
			{
				"name": "privatization",
				"salience": 0.0013872687,
				"type": "ORGANIZATION"
			},
			{
				"name": "privatization",
				"salience": 0.0013872687,
				"type": "OTHER"
			},
			{
				"name": "education system",
				"salience": 0.0013757745,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0013363323,
				"type": "LOCATION"
			},
			{
				"name": "restriction",
				"salience": 0.0013068198,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0012486326,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0012421872,
				"type": "EVENT"
			},
			{
				"name": "labor victories",
				"salience": 0.0012421872,
				"type": "EVENT"
			},
			{
				"name": "charter school cap",
				"salience": 0.0012328988,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jzbh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walton_family"
				},
				"name": "Walton Family",
				"salience": 0.0012270332,
				"type": "PERSON"
			},
			{
				"name": "Families for Excellent Schools",
				"salience": 0.0012270332,
				"type": "WORK_OF_ART"
			},
			{
				"name": "push-back",
				"salience": 0.0011366731,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03r30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hedge_fund"
				},
				"name": "Hedge Fund",
				"salience": 0.0011335644,
				"type": "OTHER"
			},
			{
				"name": "era",
				"salience": 0.0011315958,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.0011315958,
				"type": "OTHER"
			},
			{
				"name": "Lobbying group",
				"salience": 0.0011032561,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hjjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ernie_Els"
				},
				"name": "ELS",
				"salience": 0.0010856151,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.0010846135,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0010756259,
				"type": "LOCATION"
			},
			{
				"name": "healthcare costs",
				"salience": 0.0010486873,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.0010450885,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f2tj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Orleans"
				},
				"name": "New Orleans",
				"salience": 0.0010450885,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09f2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Los_Angeles"
				},
				"name": "UCLA",
				"salience": 0.0010450885,
				"type": "ORGANIZATION"
			},
			{
				"name": "privatization",
				"salience": 0.0010363163,
				"type": "OTHER"
			},
			{
				"name": "privatization",
				"salience": 0.0010363163,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0010095387,
				"type": "OTHER"
			},
			{
				"name": "transformation",
				"salience": 0.0010019892,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.000971851,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0009689115,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.00095176214,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00090468384,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.00090468384,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00090468384,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00090468384,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00088624016,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0841v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walmart"
				},
				"name": "Wal-Mart",
				"salience": 0.00088624016,
				"type": "ORGANIZATION"
			},
			{
				"name": "Education Reform Now Advocacy",
				"salience": 0.00088624016,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rmd5p"
				},
				"name": "Yes",
				"salience": 0.00088624016,
				"type": "ORGANIZATION"
			},
			{
				"name": "closure",
				"salience": 0.0008102033,
				"type": "EVENT"
			},
			{
				"name": "families",
				"salience": 0.0008102033,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0007833639,
				"type": "PERSON"
			},
			{
				"name": "contextof",
				"salience": 0.0007833639,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0007833639,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.0007833639,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0007833639,
				"type": "ORGANIZATION"
			},
			{
				"name": "union members",
				"salience": 0.0007833639,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.0007833639,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0007833639,
				"type": "OTHER"
			},
			{
				"name": "privatization assault",
				"salience": 0.0007833639,
				"type": "OTHER"
			},
			{
				"name": "School Bus Drivers",
				"salience": 0.0007645371,
				"type": "PERSON"
			},
			{
				"name": "Harvard Dining Workers",
				"salience": 0.0007645371,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08ynx3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Veolia"
				},
				"name": "Veolia Corporation",
				"salience": 0.0007645371,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03ksy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_University"
				},
				"name": "Harvard",
				"salience": 0.0007645371,
				"type": "ORGANIZATION"
			},
			{
				"name": "Opposition",
				"salience": 0.00067578466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0006620063,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03wdkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UNITE_HERE"
				},
				"name": "UNITE HERE",
				"salience": 0.0006620063,
				"type": "ORGANIZATION"
			},
			{
				"name": "policy",
				"salience": 0.00063425803,
				"type": "OTHER"
			},
			{
				"name": "shock and awe",
				"salience": 0.0005851537,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0005851537,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.0005851537,
				"type": "OTHER"
			},
			{
				"name": "kingpins",
				"salience": 0.0005851537,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0005851537,
				"type": "OTHER"
			},
			{
				"name": "cap islifted",
				"salience": 0.0005851537,
				"type": "OTHER"
			},
			{
				"name": "charter schools",
				"salience": 0.0005384641,
				"type": "ORGANIZATION"
			},
			{
				"name": "fight",
				"salience": 0.00049619994,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/School_Privatization_b90fa.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "9 Shares\n5 3 0 1\nAn important question is on the 2016 election state-wide ballot in Massachusetts. Question 2 deals with the state’s charter school cap. Without the cap, upwards of 12 charter schools could be approved by the state district in the next fiscal year. The charter school scam has spread its tentacles into the state ofMassachusetts in large part due to the Obama Administration. A vote \"no\" is thus critical toward halting the march of privatization in the education system occurring nation-wide. As Massachusetts residents gear up to vote for the next President of the United States, it is important to remember that the transformation of public education into a private good will not cease as long as popular opposition fails to confront its roots in Washington.\nThe Obama Administration immediately created the Race to the Top program after the 2008 election. This program paved a direct path toward the elimination of public education as we know it. The Department of Education funneled billions of US dollars into incentive schemes to privatize public schools district by district. Federal funds were dangled in front of mostly poor, mostly Black cities as long as these districts met the \"mandates\" of the program. These mandates included the closure of \"failing schools,\" mergers with for-profit charter schools, and the complete transformation of public schools into charter laboratories. Race to the Top created favorable conditions for private capitalists to engulf the entire US public education system.\nThe results have been disastrous. Hundreds of public schools have closed around the country. Tens of thousands of public school teachers have been fired. In New Orleans, nearly every school operating in the district is a privately owned by \" publicly funded\" charter schools .The Chicago teachers union recently averted a strike but has been dealing with the consequences of the closure of fifty schools in the city in 2013 .\nThe impact of charter schools has extended beyond teacher layoffs and school closures. Charter schools have also promoted segregation based on race and class. The Civil Rights Project of UCLA has found that seventy percent of black charter school students attend intensely segregated charter schools . Furthermore, charter schools also demand an even more intense policy of standardized testing withcurriculums that are often guided by the test corporations themselves. All the while, these institutions have found ample time to discriminate against ELS and disabled students.\nIn addition, charter schools have been found to cheat students from a quality education. Charter schools are even more militarized than traditional public schools and sport higher rates of suspension and expulsion rates. Corporate charter operators also \"cream\" students from the top and toss the rest. Even so, charters have not proven to do any better than public schools in terms of test scores . What the charter school movement does possess is the backing of the elite, which has masterfully used media and non-profit manipulation to demonize public education.\nThe usual capitalist players have been the primary leaders in the drive to rid of the charter school cap in Massachusetts. The New York Lobbying group \"Families for Excellent Schools\" is controlled by Hedge Fund managers whose funds stem from donations from the Walton Family (i.e. Wal-Mart). Another organization, \"Education Reform Now Advocacy,\" has received upwards of 11 million dollars from the same source . Charter schools are often labeled \"public\" because they receive tax payer dollars. However, the schools are accountable to no one except the corporate interests that back them.\nA \"Yes\" vote on Question two would place the education of students in Massachusetts firmly in the hands of the kingpins of privatization. Not only would twelve charter schools per year be subject to approval, but forty-five public schools would be in danger of closure. Over 100 million more dollars per year would be siphoned from public schools across the state. At the moment, the charter school cap allows the state to operate no more than 72 charter schools. If the cap islifted, however, this restriction would no longer apply and leave the students, families, and educatorsvictimto the \"shock and awe\" privatization which has characterized national policy for over two decades.\nOpposition to privatization is being led by the organization Save Our Schools. Save Our Schools consists of families, teachers, students, and unions that are looking to prevent an era of unbridled privatization in the Massachusetts public education system. Charter schools already drain 450 million from public education in the stateeach year as it currently stands. A vote \"no\" would protect public schools and thus the unions that representtheir educators.\nA \"no\" vote would build upon numerous labor victories in the Massachusetts area over the last few years. The Boston School Bus Drivers union Local 8751 won a historic victory against the Veolia Corporation in 2015. The Harvard Dining Workers of Local 26 UNITE HERE followed by defeating Harvard's bid to raise healthcare costs in October of 2016. Now it is time to stand with teachers across the state in their effort to prevent full-scale privatization.\nDoing so will not be easy. The model of union-management cooperationwith theDemocratic Party continues to prevent workers in Massachusetts and across the country from taking offensive action against the privatization assault. A vote \"no\" on question 2 in Massachusetts would show that community and union members can organize a successful push-back against the forces behind privatization. However, a vision of transformation and radical change must be articulated if defense of public education is to materialize into a people's movement. The fight against privatization must be placed in the contextof the larger struggle to build a world that working and oppressed people would vote \"yes\" to.",
		"thread_title": "Massachusetts is the Next Laboratory for School Privatization, and Why it Must Be Stopped",
		"title": "Massachusetts is the Next Laboratory for School Privatization, and Why it Must Be Stopped",
		"type": "bs",
		"uuid": "9c3d0b715118ed84606f6d67f54ec0289c8ea7ff"
	},
	"-KhIbQ0nLN7xFPftiuWK": {
		"author": "antonw",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-08T08:00:19.878+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "change",
				"salience": 0.5418255,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.4581745,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/School_Privatization_b90fa.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-08T00:27:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "If you can't give something away change is needed.\nhttp://www.textbooksfree.org/E...",
		"thread_title": "Massachusetts is the Next Laboratory for School Privatization, and Why it Must Be Stopped",
		"title": "",
		"type": "bs",
		"uuid": "a185d39b163d6fb87ee38c896e0fae5a930986b3"
	},
	"-KhIbQK_DJPS-to8fEsT": {
		"author": "Prof. Tony Hall",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-08T17:41:11.262+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Professor Hall",
				"salience": 0.30545723,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.15055524,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cc80lf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mujahid_Kamran"
				},
				"name": "Mujahid Kamran",
				"salience": 0.13098828,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.06938516,
				"type": "LOCATION"
			},
			{
				"name": "Mike Mahon",
				"salience": 0.03148843,
				"type": "PERSON"
			},
			{
				"name": "Tony Hall",
				"salience": 0.024860345,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03p5zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Lethbridge"
				},
				"name": "Lethbridge",
				"salience": 0.021035546,
				"type": "LOCATION"
			},
			{
				"name": "Mike Mahon",
				"salience": 0.016333953,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.014904255,
				"type": "EVENT"
			},
			{
				"name": "sense",
				"salience": 0.012239388,
				"type": "OTHER"
			},
			{
				"name": "researcher",
				"salience": 0.010980037,
				"type": "PERSON"
			},
			{
				"name": "Suspension",
				"salience": 0.009716312,
				"type": "EVENT"
			},
			{
				"name": "suspension",
				"salience": 0.009716312,
				"type": "EVENT"
			},
			{
				"name": "Pay",
				"salience": 0.008422632,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.008422632,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0080824355,
				"type": "LOCATION"
			},
			{
				"name": "scholars",
				"salience": 0.00730008,
				"type": "PERSON"
			},
			{
				"name": "writer",
				"salience": 0.00730008,
				"type": "PERSON"
			},
			{
				"name": "Vice Chancellor",
				"salience": 0.0065950355,
				"type": "PERSON"
			},
			{
				"name": "writings",
				"salience": 0.0060544633,
				"type": "OTHER"
			},
			{
				"name": "sadness",
				"salience": 0.0057148244,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0057148244,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.0057148244,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ftw3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_the_Punjab"
				},
				"name": "University of the Punjab",
				"salience": 0.0052322787,
				"type": "ORGANIZATION"
			},
			{
				"name": "situation",
				"salience": 0.004419739,
				"type": "OTHER"
			},
			{
				"name": "Vice Chancellor",
				"salience": 0.003268701,
				"type": "PERSON"
			},
			{
				"name": "pay",
				"salience": 0.0024115033,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.0023519434,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.002325587,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0022389085,
				"type": "LOCATION"
			},
			{
				"name": "charge",
				"salience": 0.002144344,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.002100085,
				"type": "OTHER"
			},
			{
				"name": "suspension",
				"salience": 0.0020546697,
				"type": "EVENT"
			},
			{
				"name": "university",
				"salience": 0.0020546697,
				"type": "ORGANIZATION"
			},
			{
				"name": "suspension",
				"salience": 0.0020546697,
				"type": "EVENT"
			},
			{
				"name": "pay",
				"salience": 0.0017794847,
				"type": "OTHER"
			},
			{
				"name": "conspiracies",
				"salience": 0.0017510072,
				"type": "OTHER"
			},
			{
				"name": "Professor Hall",
				"salience": 0.0016347488,
				"type": "PERSON"
			},
			{
				"name": "pay",
				"salience": 0.0015677509,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0015411053,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0015411053,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0015411053,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0015411053,
				"type": "OTHER"
			},
			{
				"name": "scholarship",
				"salience": 0.0015411053,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.0014431393,
				"type": "PERSON"
			},
			{
				"name": "university",
				"salience": 0.0014411256,
				"type": "ORGANIZATION"
			},
			{
				"name": "suspension",
				"salience": 0.0014411256,
				"type": "EVENT"
			},
			{
				"name": "research",
				"salience": 0.0013915774,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.001387372,
				"type": "ORGANIZATION"
			},
			{
				"name": "impression",
				"salience": 0.001211356,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.0012051068,
				"type": "WORK_OF_ART"
			},
			{
				"name": "principles",
				"salience": 0.0012051068,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.0012051068,
				"type": "OTHER"
			},
			{
				"name": "due process",
				"salience": 0.0012051068,
				"type": "OTHER"
			},
			{
				"name": "scales",
				"salience": 0.0012051068,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0012051068,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.0012051068,
				"type": "OTHER"
			},
			{
				"name": "teacher",
				"salience": 0.0012051068,
				"type": "PERSON"
			},
			{
				"name": "Suspension",
				"salience": 0.001176646,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0011698355,
				"type": "PERSON"
			},
			{
				"name": "impression",
				"salience": 0.0011369756,
				"type": "OTHER"
			},
			{
				"name": "suspension",
				"salience": 0.0011327475,
				"type": "EVENT"
			},
			{
				"name": "justice",
				"salience": 0.00108077,
				"type": "OTHER"
			},
			{
				"name": "internet",
				"salience": 0.00108077,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.0010782558,
				"type": "PERSON"
			},
			{
				"name": "analysis",
				"salience": 0.0010482803,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0010404453,
				"type": "OTHER"
			},
			{
				"name": "decency",
				"salience": 0.0009758683,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0009758683,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0009758683,
				"type": "OTHER"
			},
			{
				"name": "freedom of speech",
				"salience": 0.00095510174,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0009394543,
				"type": "EVENT"
			},
			{
				"name": "fact finding committee",
				"salience": 0.0009394543,
				"type": "ORGANIZATION"
			},
			{
				"name": "matter",
				"salience": 0.0009394543,
				"type": "OTHER"
			},
			{
				"name": "Professor Hall",
				"salience": 0.000912589,
				"type": "PERSON"
			},
			{
				"name": "Mind Control Contaminates",
				"salience": 0.0008823724,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.0008823724,
				"type": "OTHER"
			},
			{
				"name": "grasp",
				"salience": 0.0008450609,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0008450609,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0008450609,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0008450609,
				"type": "LOCATION"
			},
			{
				"name": "prejudice",
				"salience": 0.0008450609,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0008450609,
				"type": "OTHER"
			},
			{
				"name": "faculty",
				"salience": 0.0008450609,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0008395888,
				"type": "EVENT"
			},
			{
				"name": "concept",
				"salience": 0.00081352436,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.00081352436,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.00081352436,
				"type": "ORGANIZATION"
			},
			{
				"name": "slave state",
				"salience": 0.00081352436,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00081352436,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00081352436,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.00081352436,
				"type": "OTHER"
			},
			{
				"name": "appointment",
				"salience": 0.00081352436,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00081352436,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.0007732975,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01f_2q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/B'nai_B'rith"
				},
				"name": "B'nai Brith",
				"salience": 0.0007309218,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.000713536,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.000713536,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.000713536,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.0006899061,
				"type": "WORK_OF_ART"
			},
			{
				"name": "movement",
				"salience": 0.0006899061,
				"type": "OTHER"
			},
			{
				"name": "human rights activists",
				"salience": 0.0006899061,
				"type": "PERSON"
			},
			{
				"name": "Due Diligence",
				"salience": 0.0006899061,
				"type": "OTHER"
			},
			{
				"name": "decision making",
				"salience": 0.0006899061,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.0006812139,
				"type": "OTHER"
			},
			{
				"name": "impression",
				"salience": 0.0006591907,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0006591907,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.00059518684,
				"type": "OTHER"
			},
			{
				"name": "B'nai Brithis",
				"salience": 0.00058792625,
				"type": "LOCATION"
			},
			{
				"name": "professor",
				"salience": 0.0005867293,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0005620865,
				"type": "PERSON"
			},
			{
				"name": "image",
				"salience": 0.0005153835,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wishes",
				"salience": 0.0005153835,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.0005153835,
				"type": "OTHER"
			},
			{
				"name": "regards",
				"salience": 0.0005153835,
				"type": "OTHER"
			},
			{
				"name": "prize",
				"salience": 0.0005050838,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0004961447,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.00047831578,
				"type": "ORGANIZATION"
			},
			{
				"name": "distinction",
				"salience": 0.00043348013,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Muslim",
				"salience": 0.00042464313,
				"type": "OTHER"
			},
			{
				"name": "The Public Sphere Irish",
				"salience": 0.00042464313,
				"type": "ORGANIZATION"
			},
			{
				"name": "speech",
				"salience": 0.00041417693,
				"type": "EVENT"
			},
			{
				"name": "Abdus Salam Prize",
				"salience": 0.00038912194,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.00038821122,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00038821122,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.00038821122,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.00037535146,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Author",
				"salience": 0.00037535146,
				"type": "PERSON"
			},
			{
				"name": "Star",
				"salience": 0.00037535146,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.00037535146,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.00035863594,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271fwy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sitara-i-Imtiaz"
				},
				"name": "Sitara- e -Imtiaz",
				"salience": 0.00030925893,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Prize"
				},
				"name": "Nobel Prize",
				"salience": 0.00029548595,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h6rm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Edinburgh"
				},
				"name": "University of Edinburgh",
				"salience": 0.00029438632,
				"type": "ORGANIZATION"
			},
			{
				"name": "society",
				"salience": 0.0002803807,
				"type": "OTHER"
			},
			{
				"name": "tolerance",
				"salience": 0.0002803807,
				"type": "OTHER"
			},
			{
				"name": "flag tactics",
				"salience": 0.0002803807,
				"type": "OTHER"
			},
			{
				"name": "Pride of Performance Award",
				"salience": 0.00023100738,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.00023100738,
				"type": "LOCATION"
			},
			{
				"name": "Beyond 2015 Winner",
				"salience": 0.00023100738,
				"type": "PERSON"
			},
			{
				"name": "The Grand Deception: Corporate America",
				"salience": 0.00023100738,
				"type": "EVENT"
			},
			{
				"name": "Perpetual War 2010 The Inspiring Life of Abdus Salam",
				"salience": 0.00023100738,
				"type": "WORK_OF_ART"
			},
			{
				"name": "The New World Order 2013 International Bankers",
				"salience": 0.00023100738,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cm2xh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_I"
				},
				"name": "World Wars I",
				"salience": 0.00023100738,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "II",
				"salience": 0.00023100738,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/064mvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Pakistan"
				},
				"name": "Government of Pakistan",
				"salience": 0.00023100738,
				"type": "ORGANIZATION"
			},
			{
				"name": "roots",
				"salience": 0.00022599644,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06q1r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scotland"
				},
				"name": "Scotland",
				"salience": 0.00017255274,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.00017255274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jcx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Albert_Einstein"
				},
				"name": "Einstein",
				"salience": 0.00009750068,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/Mujahid_Kamran_53382.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Professor Dr. Mujahid Kamran, Vice-Chancellor of the University of Punjab, on the Suspension without Pay of Prof. Tony Hall 1 Shares\n1 0 0 0\nProfessor Mike Mahon President and Vice Chancellor Lethbridge, Canada\nDear Professor Mike Mahon,\nIt is with a sense of great sadness that I have learnt of the suspension, without pay, of Professor Anthony Hall, one of the most distinguished scholars, not only of the , but a researcher and writer who is recognised and respected globally. In a country like Pakistan, which is far behind Canada in term of education, research and scholarship, no teacher, or non-teacher, of any university can be suspended without pay. When someone is suspended, he or she is entitled to draw full pay for the period of suspension. If Canada is doing better than us on various scales, then one would expect that suspension without pay puts Canada behind us in terms of due process and in terms of requirements demanded by the principles of justice and fair play. I may add respectfully that in Pakistani universities no one is generally suspended unless a fact finding committee has first looked into the matter thoroughly and found prima facie evidence of wrong doing. The decision of the administration also destroys the concept of a tenured appointment.\n From his writings, that I have read over a period of time, it is evident that Professor Anthony Hall is a scholar whose work exposes the crimes and conspiracies of those who are taking the world headlong into a global war and simultaneously transforming it into a global slave state. His analysis is impeccable and his grasp of facts masterly. And his writings are devoid of any prejudice against any ethnic group or nation. , or any university for that matter, should have been proud to have Professor Hall on its faculty. His suspension creates an impression, even from this distance from where I write, that certain powerful interests that aim destroying free speech, have targeted people like Professor Anthony Hall, who speak out for democracy, decency, peace and justice.\nI have found out from the internet that B’nai Brithis behind this movement against shutting down free speech. It is quite evident that the charge that Professor Anthony Hall has created a discriminatory atmosphere is highly dubious. To the contrary, it appears that an anti-Muslim bias has been created in your institution by Professor Hall’s unfortunate suspension.There is also a strong impression that B’nai Brith has taken over the administrative decision making at Lethbridge.\nMORE... Suspension of Tenured Professor Lacks Due Diligence Toxic Mind Control Contaminates The Public Sphere Irish human rights activists against freedom of speech? B’nai Brith attack on Canadian professor has roots in Zionist false flag tactics It is also worrying that B’nai Brith have now targeted Canadian universities and Canadian society. If this is the case then the situation is disturbing, not just for Lethbridge and Canada, but for all freedom loving people worldwide. When I was a young student at University of Edinburgh, Scotland in the 1970s, I used to meet many Canadian students and I found that they invariably stood for freedom of speech and for tolerance and justice. The suspension of Professor Hall is inconsistent with my image of the Canadian people that I had then formed.\nOn behalf of the academic community of the University of the Punjab (established 1882) I urge you to kindly reconsider your decision to suspend Professor Hall. It will go a long way in rehabilitating the impression of people worldwide about the upholding of free speech, academic freedom, and genuine scholarly discourse at Lethbridge.\nWith my humble regards and very best wishes\nProfessor Dr. Mujahid Kamran Vice Chancellor University of the Punjab (since January 2008) Author of a dozen books including: Einstein and Germany 2009 The Grand Deception: Corporate America and Perpetual War 2010 The Inspiring Life of Abdus Salam 2013 9/11 & The New World Order 2013 International Bankers, World Wars I, II and Beyond 2015 Winner Abdus Salam Prize 1985 (this prize was instituted from Salam’s Nobel Prize money) Presidential Pride of Performance Award 1999 Awarded Sitara- e -Imtiaz (i.e. Star of distinction, awarded by Government of Pakistan) 2015, etc",
		"thread_title": "Creating an Anti-Muslim Bias at a Canadian University",
		"title": "Creating an Anti-Muslim Bias at a Canadian University",
		"type": "bs",
		"uuid": "c8731ad5b0af7ac726d4ccea2215bd8d68b295d0"
	},
	"-KhIbQfZQ_tOXxZjSnuh": {
		"author": "Saurav Dutt",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-09T17:11:01.619+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.34151027,
				"type": "LOCATION"
			},
			{
				"name": "Donald Trump Trump",
				"salience": 0.24751097,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.022932483,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.019372614,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.018438665,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.013448725,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.012720967,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.011573508,
				"type": "OTHER"
			},
			{
				"name": "Grandfather",
				"salience": 0.009717763,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0l6n5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_European_Summer_Time"
				},
				"name": "West",
				"salience": 0.0080442885,
				"type": "PERSON"
			},
			{
				"name": "business experience",
				"salience": 0.0076606795,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0076606795,
				"type": "OTHER"
			},
			{
				"name": "cry",
				"salience": 0.0071816915,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.006836318,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.006836318,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.006836318,
				"type": "OTHER"
			},
			{
				"name": "pundits",
				"salience": 0.0065099997,
				"type": "PERSON"
			},
			{
				"name": "analysis",
				"salience": 0.005921451,
				"type": "OTHER"
			},
			{
				"name": "touch",
				"salience": 0.005921451,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0058474746,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0056582643,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.005059579,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.004037797,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.003844855,
				"type": "ORGANIZATION"
			},
			{
				"name": "weasel politicians",
				"salience": 0.0037876877,
				"type": "PERSON"
			},
			{
				"name": "scenes",
				"salience": 0.0036823917,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Hilton Ballroom",
				"salience": 0.0036471717,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0036027287,
				"type": "LOCATION"
			},
			{
				"name": "rejection",
				"salience": 0.0033241133,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rt003"
				},
				"name": "Left",
				"salience": 0.0031923712,
				"type": "ORGANIZATION"
			},
			{
				"name": "rejection",
				"salience": 0.0031200538,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0031200538,
				"type": "PERSON"
			},
			{
				"name": "rejection",
				"salience": 0.0031200538,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0031096176,
				"type": "OTHER"
			},
			{
				"name": "reckoning",
				"salience": 0.003006699,
				"type": "OTHER"
			},
			{
				"name": "hills",
				"salience": 0.0028172955,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012v1t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nancy_Pelosi"
				},
				"name": "Nancy Pelosi",
				"salience": 0.0026049577,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0204x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_Reid"
				},
				"name": "Harry Reid",
				"salience": 0.0026049577,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0025266379,
				"type": "LOCATION"
			},
			{
				"name": "leverage",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "ethics",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "spectrum",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0024397462,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0024323713,
				"type": "LOCATION"
			},
			{
				"name": "President",
				"salience": 0.0024323713,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0023786775,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.002331164,
				"type": "PERSON"
			},
			{
				"name": "concerns",
				"salience": 0.0022464446,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0022044831,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0021880057,
				"type": "ORGANIZATION"
			},
			{
				"name": "insight",
				"salience": 0.0021880057,
				"type": "OTHER"
			},
			{
				"name": "insights",
				"salience": 0.0021880057,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0021063625,
				"type": "ORGANIZATION"
			},
			{
				"name": "industries",
				"salience": 0.0019756183,
				"type": "OTHER"
			},
			{
				"name": "partnerships",
				"salience": 0.0019756183,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.0019756183,
				"type": "OTHER"
			},
			{
				"name": "competitors",
				"salience": 0.0019756183,
				"type": "ORGANIZATION"
			},
			{
				"name": "weaknesses",
				"salience": 0.0019756183,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0019756183,
				"type": "LOCATION"
			},
			{
				"name": "candidates",
				"salience": 0.0019756183,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.001933574,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.0019018941,
				"type": "OTHER"
			},
			{
				"name": "insights",
				"salience": 0.0018792476,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.001809117,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0017863262,
				"type": "PERSON"
			},
			{
				"name": "skill",
				"salience": 0.0017547196,
				"type": "OTHER"
			},
			{
				"name": "beatings",
				"salience": 0.0017547196,
				"type": "OTHER"
			},
			{
				"name": "Crooked Hillary",
				"salience": 0.001734415,
				"type": "ORGANIZATION"
			},
			{
				"name": "purge",
				"salience": 0.001710786,
				"type": "OTHER"
			},
			{
				"name": "significance",
				"salience": 0.001710786,
				"type": "OTHER"
			},
			{
				"name": "predator characteristics",
				"salience": 0.001710786,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.001710786,
				"type": "PERSON"
			},
			{
				"name": "economics",
				"salience": 0.001710786,
				"type": "OTHER"
			},
			{
				"name": "avenues",
				"salience": 0.001710786,
				"type": "LOCATION"
			},
			{
				"name": "trade agreements",
				"salience": 0.001710786,
				"type": "OTHER"
			},
			{
				"name": "antagonism",
				"salience": 0.001710786,
				"type": "OTHER"
			},
			{
				"name": "performance",
				"salience": 0.001646938,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.001646938,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.001646938,
				"type": "OTHER"
			},
			{
				"name": "exceptionalism",
				"salience": 0.001646938,
				"type": "OTHER"
			},
			{
				"name": "rose",
				"salience": 0.001646938,
				"type": "OTHER"
			},
			{
				"name": "business leaders",
				"salience": 0.001646938,
				"type": "PERSON"
			},
			{
				"name": "industry",
				"salience": 0.0016129042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.0015018965,
				"type": "LOCATION"
			},
			{
				"name": "negotiations",
				"salience": 0.0014325383,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.0013966666,
				"type": "EVENT"
			},
			{
				"name": "table",
				"salience": 0.0013966666,
				"type": "OTHER"
			},
			{
				"name": "devil",
				"salience": 0.0013966666,
				"type": "OTHER"
			},
			{
				"name": "vitriol",
				"salience": 0.0013966666,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0013966666,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0013966666,
				"type": "LOCATION"
			},
			{
				"name": "police tyranny",
				"salience": 0.0013966666,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0013966666,
				"type": "OTHER"
			},
			{
				"name": "frustration",
				"salience": 0.0013966666,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.0013966666,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.0013445355,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0013344825,
				"type": "PERSON"
			},
			{
				"name": "changemaker",
				"salience": 0.0013344825,
				"type": "PERSON"
			},
			{
				"name": "connections",
				"salience": 0.0013275943,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0012049057,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0012049057,
				"type": "ORGANIZATION"
			},
			{
				"name": "climate",
				"salience": 0.0011694843,
				"type": "OTHER"
			},
			{
				"name": "An America",
				"salience": 0.0011421802,
				"type": "LOCATION"
			},
			{
				"name": "decision",
				"salience": 0.0011308804,
				"type": "OTHER"
			},
			{
				"name": "mistakes",
				"salience": 0.0011258291,
				"type": "OTHER"
			},
			{
				"name": "engineer",
				"salience": 0.0011116423,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0010805249,
				"type": "PERSON"
			},
			{
				"name": "heartbreak",
				"salience": 0.0010701454,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.001053034,
				"type": "ORGANIZATION"
			},
			{
				"name": "something",
				"salience": 0.0010480259,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.0010433445,
				"type": "OTHER"
			},
			{
				"name": "era",
				"salience": 0.0010433445,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0010433445,
				"type": "OTHER"
			},
			{
				"name": "chains",
				"salience": 0.0010433445,
				"type": "ORGANIZATION"
			},
			{
				"name": "think tanker",
				"salience": 0.0010433445,
				"type": "OTHER"
			},
			{
				"name": "bank accounts",
				"salience": 0.0010433445,
				"type": "OTHER"
			},
			{
				"name": "nobility",
				"salience": 0.0010433445,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0010137239,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.0009231989,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00087753375,
				"type": "LOCATION"
			},
			{
				"name": "weakness",
				"salience": 0.00087753375,
				"type": "OTHER"
			},
			{
				"name": "NeverTrump",
				"salience": 0.0008596437,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ynh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Imperialism"
				},
				"name": "Imperialism",
				"salience": 0.0008596437,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0008596437,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.00075985526,
				"type": "OTHER"
			},
			{
				"name": "strengths",
				"salience": 0.00075985526,
				"type": "OTHER"
			},
			{
				"name": "landmark",
				"salience": 0.00075985526,
				"type": "LOCATION"
			},
			{
				"name": "guise",
				"salience": 0.00075985526,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00075985526,
				"type": "EVENT"
			},
			{
				"name": "world scale",
				"salience": 0.00075985526,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00075985526,
				"type": "LOCATION"
			},
			{
				"name": "isolationism",
				"salience": 0.00075985526,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007260158,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0007112297,
				"type": "PERSON"
			},
			{
				"name": "somebody",
				"salience": 0.000655505,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.000655505,
				"type": "LOCATION"
			},
			{
				"name": "facts",
				"salience": 0.000655505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00064214016,
				"type": "ORGANIZATION"
			},
			{
				"name": "answer",
				"salience": 0.00060475664,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.0005675941,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0005675941,
				"type": "OTHER"
			},
			{
				"name": "self-interest",
				"salience": 0.0005675941,
				"type": "OTHER"
			},
			{
				"name": "stables",
				"salience": 0.0005675941,
				"type": "LOCATION"
			},
			{
				"name": "mind",
				"salience": 0.0005675941,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0004676426,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Gaddafi",
				"salience": 0.0004676426,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0004676426,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bxhx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ross_Perot"
				},
				"name": "Ross Perot",
				"salience": 0.000303814,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Donald_Trump_President_31de9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "10 Shares\n4 5 0 1\n\"USA! USA! USA!\" they chanted together in the Hilton Ballroom as the results came in. Who needs polls? They never gave him a chance but now we have it: President Donald Trump. Not only were the polls spectacularly wrong (who will ever trust this particularly bankrupt form of moralising presumptive analysis and telling us how we do and should feel?) but also the pundits who were not just arrogant about the fact that Trump had no chance but also were hopelessly out of touch with what America was thinking across its societal spectrum, what it wanted, what was felt deep in its blood.\nIt is a rejection of the liberal consensus the entire West has wallowed in since the 90's and a rejection of Obama and the false hope he decried, the impotent nature of US political leverage around the world and the rejection of brazen corruption and questionable ethics as typified by \"Crooked Hillary\".\nThe world must live with it; democracy has spoken and they're going to have to get over the words President Trump. Some will head for the hills, some will run to Canada, others will continue to cry but as Obama said yesterday, regardless of the result \"tomorrow the sun will still shine.\"\nThis is a cry for American exceptionalism and like him or not Trump typifies that. He is committed to education, and demands high performance. Selling well is an admirable skill for a President to have. Negotiating with Congress, internationally, etc., is exceptionally useful. Trump has taken beatings financially and come out smelling like a rose.\nTrump's business experience involves negotiations with business leaders and even governments around the world, and he likely has connections behind the scenes that surpass those of simply purely political candidates -- this gives him keen, realistic insights into economics in different parts of the world, as well as additional avenues to pursue trade agreements, and even perhaps some nuanced insights of particular financial weaknesses of possible global competitors, not to mention experience and insight into the partnerships and/or antagonism between different industries and particular governments.\nMORE... Trump's sexual predator characteristics - His Grandfather was a pimp, but at least he paid the women he hired The significance of the GOP's attempted purge of Donald Trump Trump, Turkey, and police tyranny: The crisis of Imperialism finds political expression An America in denial This vote comes down to the reckoning that for too long, politicians have sold the American people out to foreign nations and global industry. What Donald Trump is doing is representing the absolute heartbreak and anger and frustration at a government gone mad and it seems the Left completely underestimated that in their vitriol in crying #NeverTrump and portraying him as the devil incarnate.\nAlthough it is entirely true that Trump is ostentatious and has his mistakes, he brings something to the Presidential table no other candidate had before; he speaks his mind.\nAmerica clearly is sick of weasel politicians who are too afraid to say what people want to hear, they want the facts straight.\nPresident Trump isn't cut from the political class, that class which is entrenched in its self-interest and has let the country down time and time again. Ross Perot once said that we need somebody to clean out the stables, a corrupted, ethically questionable President is therefore not the answer in order to accomplish that and I'm not talking about Donald Trump.\nTrump is a pragmatist in an era of rapidly approaching chaos, he is not a social engineer, a think tanker who wants to please those lining his bank accounts. The liberal Democratic policies of Obama, U.S. Rep. Nancy Pelosi, U.S. Sen. Harry Reid and their company created a climate that has led to this decision today.\nSo what if his language is intemperate and insulting? Even lacking in nobility from time to time? How can a true changemaker be straitjacketed by politically correct chains if he or she must express the will of the people, uncomfortable concerns that lie dormant for far too long?\nObama won because conservative voters stayed home. He had promise and he let so many down, what did Clinton have? And that is why conservative voters had to get out and vote.\nTrump prefers isolationism on a world scale, Clinton voted to take us to war in Iraq and to overthrow Libya's Gaddafi, all in the guise of being \"muscular.\"\nPerhaps today's landmark and historic decision is not so much about Trump's strengths and power but more about the crippled weakness of the country in 2016 and you simply cannot blame him for that.",
		"thread_title": "Arise President Trump (or Why it's not the End of the World as We Know it)",
		"title": "Arise President Trump (or Why it's not the End of the World as We Know it)",
		"type": "bs",
		"uuid": "0f6984e6177d873eea2ca0ae624426f1a3e52a8b"
	},
	"-KhIbR13X50hhe8j02aB": {
		"author": "Milad Amini Movahhed",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-09T17:16:51.807+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Aba Abd-Allah",
				"salience": 0.11598905,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0240rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Husayn_ibn_Ali"
				},
				"name": "Imam Hussein",
				"salience": 0.088181734,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0240sm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle_of_Karbala"
				},
				"name": "Karbala",
				"salience": 0.054599486,
				"type": "LOCATION"
			},
			{
				"name": "household",
				"salience": 0.048143607,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.043556705,
				"type": "OTHER"
			},
			{
				"name": "rituals",
				"salience": 0.043556705,
				"type": "OTHER"
			},
			{
				"name": "friendship",
				"salience": 0.043556705,
				"type": "OTHER"
			},
			{
				"name": "verse",
				"salience": 0.043556705,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shia Muslims",
				"salience": 0.040782455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/046g7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arba'een"
				},
				"name": "Arbaeen",
				"salience": 0.03572747,
				"type": "OTHER"
			},
			{
				"name": "shrine",
				"salience": 0.026168799,
				"type": "LOCATION"
			},
			{
				"name": "religions",
				"salience": 0.019875417,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bgl6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Purim"
				},
				"name": "Purim",
				"salience": 0.011118451,
				"type": "OTHER"
			},
			{
				"name": "life style",
				"salience": 0.010211219,
				"type": "OTHER"
			},
			{
				"name": "prophet",
				"salience": 0.010007112,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.00962828,
				"type": "OTHER"
			},
			{
				"name": "esteeming",
				"salience": 0.009038848,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Jesus Christ",
				"salience": 0.008754755,
				"type": "PERSON"
			},
			{
				"name": "Mavaddat",
				"salience": 0.008424747,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/096tx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quran"
				},
				"name": "Quranic",
				"salience": 0.008424747,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.008217793,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027l2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ali_al-Ridha"
				},
				"name": "Imam Reza",
				"salience": 0.007969005,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allah"
				},
				"name": "Allah",
				"salience": 0.006747451,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jzcl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hajj"
				},
				"name": "Hajj",
				"salience": 0.0064255395,
				"type": "PERSON"
			},
			{
				"name": "followers",
				"salience": 0.005910573,
				"type": "PERSON"
			},
			{
				"name": "magnetic",
				"salience": 0.005824491,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.0057371757,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.0056041875,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.00515801,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0048270365,
				"type": "PERSON"
			},
			{
				"name": "capacity",
				"salience": 0.0046612136,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.004623188,
				"type": "OTHER"
			},
			{
				"name": "social stream",
				"salience": 0.004623188,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.004623188,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.004623188,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.004623188,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.004623188,
				"type": "OTHER"
			},
			{
				"name": "social stream",
				"salience": 0.004623188,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j_4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Easter"
				},
				"name": "Easter",
				"salience": 0.0045323544,
				"type": "EVENT"
			},
			{
				"name": "Imam Sadigh",
				"salience": 0.0044936817,
				"type": "PERSON"
			},
			{
				"name": "publicity",
				"salience": 0.0042658555,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0040041213,
				"type": "OTHER"
			},
			{
				"name": "correlation",
				"salience": 0.0040041213,
				"type": "OTHER"
			},
			{
				"name": "shrine visitors",
				"salience": 0.0038695494,
				"type": "PERSON"
			},
			{
				"name": "carnival",
				"salience": 0.0037277471,
				"type": "OTHER"
			},
			{
				"name": "Imam",
				"salience": 0.003666086,
				"type": "PERSON"
			},
			{
				"name": "clothes",
				"salience": 0.0034138267,
				"type": "OTHER"
			},
			{
				"name": "freedom ring",
				"salience": 0.002954424,
				"type": "OTHER"
			},
			{
				"name": "massage",
				"salience": 0.0028983464,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.0028553086,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.002838489,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0028084165,
				"type": "WORK_OF_ART"
			},
			{
				"name": "message",
				"salience": 0.002750414,
				"type": "OTHER"
			},
			{
				"name": "pilgrims",
				"salience": 0.002717911,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0024741574,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/010pczvr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tasnim_News_Agency"
				},
				"name": "Tasnim",
				"salience": 0.0024656726,
				"type": "PERSON"
			},
			{
				"name": "Mashrigh",
				"salience": 0.0024656726,
				"type": "OTHER"
			},
			{
				"name": "carnival",
				"salience": 0.0024539542,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.002435616,
				"type": "PERSON"
			},
			{
				"name": "ceremonies",
				"salience": 0.0024247435,
				"type": "EVENT"
			},
			{
				"name": "pilgrimage",
				"salience": 0.0022007728,
				"type": "EVENT"
			},
			{
				"name": "celebration",
				"salience": 0.002189418,
				"type": "EVENT"
			},
			{
				"name": "Pure Mohammadi Islam",
				"salience": 0.002188137,
				"type": "OTHER"
			},
			{
				"name": "ceremonies",
				"salience": 0.0021092019,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.0021092019,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.0019044745,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0019044745,
				"type": "EVENT"
			},
			{
				"name": "calendar",
				"salience": 0.0019044745,
				"type": "OTHER"
			},
			{
				"name": "celebration",
				"salience": 0.0019044745,
				"type": "EVENT"
			},
			{
				"name": "religion",
				"salience": 0.0019044745,
				"type": "OTHER"
			},
			{
				"name": "shrines",
				"salience": 0.0018915597,
				"type": "LOCATION"
			},
			{
				"name": "Husayn ibn Ali The Jews",
				"salience": 0.0018557115,
				"type": "PERSON"
			},
			{
				"name": "tradition",
				"salience": 0.0017827728,
				"type": "OTHER"
			},
			{
				"name": "festival",
				"salience": 0.0017571114,
				"type": "EVENT"
			},
			{
				"name": "holiday",
				"salience": 0.0017571114,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.0017349769,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0017220075,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0016577455,
				"type": "OTHER"
			},
			{
				"name": "community-building",
				"salience": 0.0016491904,
				"type": "LOCATION"
			},
			{
				"name": "church",
				"salience": 0.0016491904,
				"type": "LOCATION"
			},
			{
				"name": "masks",
				"salience": 0.0016491904,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Synagogue",
				"salience": 0.0016491904,
				"type": "LOCATION"
			},
			{
				"name": "youth",
				"salience": 0.0016491904,
				"type": "PERSON"
			},
			{
				"name": "Husseini",
				"salience": 0.0016401714,
				"type": "PERSON"
			},
			{
				"name": "walks",
				"salience": 0.001610229,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.0015958799,
				"type": "OTHER"
			},
			{
				"name": "mourning clothes",
				"salience": 0.0015757751,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "reward",
				"salience": 0.0015559233,
				"type": "OTHER"
			},
			{
				"name": "shrine",
				"salience": 0.0015442914,
				"type": "LOCATION"
			},
			{
				"name": "shrine",
				"salience": 0.001524836,
				"type": "LOCATION"
			},
			{
				"name": "try",
				"salience": 0.0014901247,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0014901247,
				"type": "EVENT"
			},
			{
				"name": "clothes",
				"salience": 0.0014789844,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "unity",
				"salience": 0.0014789844,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0014779516,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0014058477,
				"type": "OTHER"
			},
			{
				"name": "Sheikh Mirza Hussein Noori",
				"salience": 0.0014024362,
				"type": "PERSON"
			},
			{
				"name": "followers",
				"salience": 0.0013943627,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0013463919,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.0013353922,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0013353922,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.0013353922,
				"type": "LOCATION"
			},
			{
				"name": "phenomenon",
				"salience": 0.0012877446,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0012368422,
				"type": "PERSON"
			},
			{
				"name": "guilt",
				"salience": 0.0012074197,
				"type": "OTHER"
			},
			{
				"name": "guilt",
				"salience": 0.0012074197,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.001192206,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0011563514,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0011563514,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.0011563514,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0011563514,
				"type": "OTHER"
			},
			{
				"name": "believer",
				"salience": 0.0011563514,
				"type": "OTHER"
			},
			{
				"name": "world travel",
				"salience": 0.0011131882,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0011131882,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0011131882,
				"type": "LOCATION"
			},
			{
				"name": "policy",
				"salience": 0.0011131882,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.0011131882,
				"type": "ORGANIZATION"
			},
			{
				"name": "education",
				"salience": 0.0011131882,
				"type": "OTHER"
			},
			{
				"name": "beauty",
				"salience": 0.0011131882,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0011131882,
				"type": "PERSON"
			},
			{
				"name": "joy",
				"salience": 0.0011131882,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.0011131882,
				"type": "LOCATION"
			},
			{
				"name": "ceremony",
				"salience": 0.0010909425,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0010901806,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.0010764435,
				"type": "OTHER"
			},
			{
				"name": "Pilgrims",
				"salience": 0.0010416387,
				"type": "PERSON"
			},
			{
				"name": "reward",
				"salience": 0.0010369859,
				"type": "OTHER"
			},
			{
				"name": "reward",
				"salience": 0.0010369859,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hxss",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adar"
				},
				"name": "Adar",
				"salience": 0.0010151378,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "DC",
				"salience": 0.0010151378,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01dpg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Book_of_Esther"
				},
				"name": "Esther",
				"salience": 0.0010151378,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hebrew_language"
				},
				"name": "Hebrew",
				"salience": 0.0010151378,
				"type": "OTHER"
			},
			{
				"name": "Ol-Hussein",
				"salience": 0.0010002953,
				"type": "PERSON"
			},
			{
				"name": "household",
				"salience": 0.00094890094,
				"type": "OTHER"
			},
			{
				"name": "rites finish",
				"salience": 0.0009440025,
				"type": "OTHER"
			},
			{
				"name": "favorites",
				"salience": 0.0009440025,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0009440025,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0009440025,
				"type": "LOCATION"
			},
			{
				"name": "pilgrimage tradition",
				"salience": 0.00093989493,
				"type": "OTHER"
			},
			{
				"name": "grade",
				"salience": 0.0009203605,
				"type": "OTHER"
			},
			{
				"name": "visitors",
				"salience": 0.0009019667,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00081437605,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.00081437605,
				"type": "OTHER"
			},
			{
				"name": "life style",
				"salience": 0.00081437605,
				"type": "OTHER"
			},
			{
				"name": "blessing",
				"salience": 0.00081437605,
				"type": "OTHER"
			},
			{
				"name": "servers",
				"salience": 0.00081437605,
				"type": "OTHER"
			},
			{
				"name": "sayyeds",
				"salience": 0.00081437605,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.00079125457,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.0007706353,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0007648722,
				"type": "OTHER"
			},
			{
				"name": "Imam Hassan Askari",
				"salience": 0.000758312,
				"type": "ORGANIZATION"
			},
			{
				"name": "tradition",
				"salience": 0.00073863677,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.00073863677,
				"type": "OTHER"
			},
			{
				"name": "pathology",
				"salience": 0.00073580263,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04v95n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Safa_and_Al-Marwah"
				},
				"name": "Safa",
				"salience": 0.0007117175,
				"type": "ORGANIZATION"
			},
			{
				"name": "Husseini Magnetic Attraction",
				"salience": 0.0007117175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/046zg5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ihram"
				},
				"name": "Ihram",
				"salience": 0.0007117175,
				"type": "OTHER"
			},
			{
				"name": "Marvah",
				"salience": 0.0007117175,
				"type": "PERSON"
			},
			{
				"name": "Beyn Al-Haramain",
				"salience": 0.0007117175,
				"type": "OTHER"
			},
			{
				"name": "elders",
				"salience": 0.000705168,
				"type": "PERSON"
			},
			{
				"name": "dealing",
				"salience": 0.000705168,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.000705168,
				"type": "LOCATION"
			},
			{
				"name": "gifts",
				"salience": 0.000705168,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.000705168,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.000705168,
				"type": "OTHER"
			},
			{
				"name": "journey",
				"salience": 0.000705168,
				"type": "EVENT"
			},
			{
				"name": "Alavi",
				"salience": 0.00068514614,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00068514614,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/047876",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine_(region)"
				},
				"name": "Palestine",
				"salience": 0.00068514614,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/058wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mecca"
				},
				"name": "Mecca",
				"salience": 0.00068514614,
				"type": "LOCATION"
			},
			{
				"name": "Role",
				"salience": 0.000661838,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00066004234,
				"type": "OTHER"
			},
			{
				"name": "visitors",
				"salience": 0.00065688824,
				"type": "PERSON"
			},
			{
				"name": "prophet",
				"salience": 0.00065688824,
				"type": "PERSON"
			},
			{
				"name": "guilt",
				"salience": 0.00065688824,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.0006481563,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0006319216,
				"type": "OTHER"
			},
			{
				"name": "esteeming",
				"salience": 0.00059309107,
				"type": "OTHER"
			},
			{
				"name": "blessings",
				"salience": 0.00059309107,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.00052674505,
				"type": "PERSON"
			},
			{
				"name": "destruction",
				"salience": 0.00051355065,
				"type": "EVENT"
			},
			{
				"name": "dictator",
				"salience": 0.00051355065,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.00051355065,
				"type": "OTHER"
			},
			{
				"name": "primer",
				"salience": 0.00051355065,
				"type": "WORK_OF_ART"
			},
			{
				"name": "work",
				"salience": 0.00051355065,
				"type": "OTHER"
			},
			{
				"name": "heaven",
				"salience": 0.00051355065,
				"type": "LOCATION"
			},
			{
				"name": "sadness",
				"salience": 0.00051355065,
				"type": "OTHER"
			},
			{
				"name": "sorrow",
				"salience": 0.00051355065,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0004466711,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0004430205,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0004430205,
				"type": "OTHER"
			},
			{
				"name": "Sayyed Al-Shohada",
				"salience": 0.00043398736,
				"type": "PERSON"
			},
			{
				"name": "risks",
				"salience": 0.0004087203,
				"type": "OTHER"
			},
			{
				"name": "Arbaien",
				"salience": 0.00040276622,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0003955013,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0003955013,
				"type": "OTHER"
			},
			{
				"name": "messenger",
				"salience": 0.0003853245,
				"type": "PERSON"
			},
			{
				"name": "success",
				"salience": 0.00038360286,
				"type": "OTHER"
			},
			{
				"name": "faults",
				"salience": 0.00038360286,
				"type": "OTHER"
			},
			{
				"name": "angel",
				"salience": 0.00033364387,
				"type": "PERSON"
			},
			{
				"name": "tidings",
				"salience": 0.0003294383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.00031604842,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gjq09",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hello"
				},
				"name": "Hello",
				"salience": 0.00023607096,
				"type": "PERSON"
			},
			{
				"name": "Sheikh Ansary",
				"salience": 0.00023607096,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02kby9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hegira"
				},
				"name": "Hegira",
				"salience": 0.00023607096,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Arbaeen_Iraq_9b04b.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 19.5,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.004",
		"text": "Visiting Aba Abd-Allah is a good evidence of esteeming and honoring the divine rituals, and display love and friendship with prophet's household, according to the Quranic verse of \"Mavaddat\". 4 Shares\n3 0 0 1\nPresenting and attendance million of Shias at Arbaeen, create a massive and international unity among Shias. This capacity can be useful for huge cultural action.\n\"Mashrigh\" and \"Tasnim\" report that different religions ever require their followers to attend in specific days in the year for solidarity and correlation between followers to identify the social stream. This kind of attendance is a good publicity of that social stream, and influences the international community.\nEaster, the Christians religious day\nFor example Christians celebrate \"Easter\" as the most important religious day with a long history every year.\n This day is a holiday in Christian’s calendar, and followers of Jesus Christ hold various ceremonies and celebration in the church.\nMORE... The 10th Day’s new campaign – community-building and social solidarity Shia Muslims gather in DC for anti-terror rally Letting freedom ring: How Islam’s universal message continues to speak through Imam Husayn ibn Ali The Jews carnival “Purim”\n\"Purim\" is a great religious festival in Jewish religion. Jews have named the fourteenth and fifteenth day of Adar in Hebrew calendar \"Purim”, and celebrate it.\nJews hold celebration in \"Synagogue\" with reading the book \"Esther\". After ceremonies, children and youth wear the colorful clothes and masks, and launch the carnival of joy in occupied Palestine territories and Jewish cities. This ceremony is advertised extensively by the Jewish dictatorial media..\nBut Muslims...\nAbout 5.5 million Muslims from all over the world travel to Mecca, Saudi Arabia in \"Hajj days\" and perform Hajj. But \" Pure Mohammadi Islam\" and \"Alavi education\" is not advertised and explained properly in Hajj because of the restrictive policy of Saudi regime.\nImam Reza, peace be upon him, stated: If the beauty of Islam is heard by others, they all will follow wholeheartedly the prophet's household inevitably.\n\"Arbaeen\", golden opportunity\nAttending million of Shias in Arbaeen create a massive and international unity among Shias .\nKarbala can be a \"symbol\" of unity and allegiance to Imam, that has the \"world's effects\". The start of Husseini Magnetic Attraction is in \"Arbaeen\". This is the magnetic that exists in my and your heart over the centuries.\nSo if we can't publish the Shia massage efficiently in Hajj, we can universalize it in Shia glorious presence in the Husseini massive rally.\nIn fact the Hajj pilgrimage for Imam Hussein followers is in Karbala, their try between Safa and Marvah in the \" Beyn Al-Haramain\", and their \"Ihram clothes\" is the \"mourning clothes for Aba Abd-Allah\".\nWalking to shrines is topical\nImam Hassan Askari, peace be upon him, mentioned that one of the real believer's sign is walking to visit Imam Hussein in Arbaeen.\nImam Sadigh, peace be upon him, told to one of his followers: Visit Imam Hussein's shrine, and don't give it up. I asked: What is the reward for visiting him? Imam –pbuh- stated: When you walk to visit Imam Hussein, Allah gives you a reward and removes your guilt, and raises your grade.\nAt the other time, Imam Sadigh said: If someone goes out of his home and walks to visit Imam Hussein's shrine, Allah gives him a reward and removes him guilt for each step to visit Aba Abd-Allah, when he reaches to shrine, Allah considers him among righteous favorites. When his rites finish, Allah registers him among success, when he is coming back an angel of God stays on him and tells: The messenger of Allah says Hello and gives tidings to you that all your faults are forgiven, start again your actions.\nWalking tradition has an old history.\nIn a way, walking tradition for Imam Hussein in Arbaien has an old history. Walking to visit Karbala was customary at Sheikh\nAnsary's time. But it was forgotten for a long time. It revives again by \"Sheikh Mirza Hussein Noori\". He walked to visit Aba Abd-Allah in 1319 (Hegira) for the last time.\nAlthough visiting Imam Hussein s shrine was often difficult, and pilgrims were not safe and secure, but they were willing to take risks and had an audience to Imam Hussein in Arbaeen.\nIslamic life style\nAt that time with full of great interest and knowledge, in the way \"Hussein path\" that leads to Karbala, Shias called each other just with \"Hussein visitors\" (zayer Al-Hussein), or \"Hussein server\" (khadem Ol-Hussein), that is a symbol of Islamic life style.\nPilgrims of this holy and spiritual journey have a lot of blessing and gifts from God, such as: the nice spiritual state with \"holy Sayyed Al-Shohada\" - generous dealing with pilgrims entertaining and receiving by Hussein servers- sacrificing and respecting for each other- treating elders and sayyeds kindly and considerately- visiting the Imam Hussein's holy shrine in Arbaeen.\nRole and place of Imam Hussein's visitors\nVisiting Aba Abd-Allah is a good evidence of esteeming and honoring the divine rituals, and display love and friendship with prophet's household, according to the Quranic verse of \"Mavaddat\".\nImam Hussein's holy shrine visitors enter into heaven before all, their guilt is disappeared, their life will be long, and God provides for them and removes their sadness and sorrow.\nOf course if this old tradition that is established again after destruction of Iraqi dictator, not to be cultural pathology, it will certainly have the negative effects.\nBecause every phenomenon is threatened, it seems if this pilgrimage tradition becomes a primer to the cultural work, it will be more effective and blessings than today.",
		"thread_title": "Why Muslims Hold the Biggest Human Gathering under the Threat of ISIS in Iraq?",
		"title": "Why Muslims Hold the Biggest Human Gathering under the Threat of ISIS in Iraq?",
		"type": "bs",
		"uuid": "69fbee8fcaefb254bc6a1e5d9168dd232b5ead22"
	},
	"-KhIbRjBwwbENXbNRdnK": {
		"author": "Rafiq",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-10T17:00:58.936+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04jwn0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_F._Noble"
				},
				"name": "David Noble",
				"salience": 0.07760693,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.040735308,
				"type": "LOCATION"
			},
			{
				"name": "Mahon",
				"salience": 0.035690546,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01k165",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stephen_Harper"
				},
				"name": "Harper",
				"salience": 0.03543164,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01f_2q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/B'nai_B'rith"
				},
				"name": "B'nai Brith",
				"salience": 0.029592851,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rafiq Islam",
				"salience": 0.024903845,
				"type": "PERSON"
			},
			{
				"name": "products",
				"salience": 0.024432736,
				"type": "EVENT"
			},
			{
				"name": "legislation",
				"salience": 0.020119432,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01s9tw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abdus_Salam"
				},
				"name": "Salam",
				"salience": 0.019498773,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.016435958,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.015877867,
				"type": "OTHER"
			},
			{
				"name": "Professor Hall",
				"salience": 0.015689554,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/093y4x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lorna_Marsden"
				},
				"name": "Lorna Marsden",
				"salience": 0.01453754,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07tf8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University"
				},
				"name": "University",
				"salience": 0.012986914,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.012687614,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05ftw3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_the_Punjab"
				},
				"name": "University of Punjab",
				"salience": 0.011462887,
				"type": "ORGANIZATION"
			},
			{
				"name": "public",
				"salience": 0.010915234,
				"type": "PERSON"
			},
			{
				"name": "Alan Rock",
				"salience": 0.01073321,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/065w2r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Johnston"
				},
				"name": "David Johnston",
				"salience": 0.010139262,
				"type": "PERSON"
			},
			{
				"name": "universities",
				"salience": 0.009514434,
				"type": "ORGANIZATION"
			},
			{
				"name": "Vice-Chancellor",
				"salience": 0.009041125,
				"type": "PERSON"
			},
			{
				"name": "Background",
				"salience": 0.009041125,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.00874135,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.008443876,
				"type": "PERSON"
			},
			{
				"name": "Hall Case",
				"salience": 0.007885279,
				"type": "OTHER"
			},
			{
				"name": "coast",
				"salience": 0.00783105,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.00783105,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.007318802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05l548",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omar_Khadr"
				},
				"name": "Omar Khadr",
				"salience": 0.00728342,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/099kxy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canadian_Islamic_Congress"
				},
				"name": "Canadian Islamic Congress",
				"salience": 0.006949753,
				"type": "ORGANIZATION"
			},
			{
				"name": "arena",
				"salience": 0.0066069188,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.006593032,
				"type": "WORK_OF_ART"
			},
			{
				"name": "speech",
				"salience": 0.0061063706,
				"type": "EVENT"
			},
			{
				"name": "University professor",
				"salience": 0.0060033733,
				"type": "PERSON"
			},
			{
				"name": "interest group",
				"salience": 0.0059013222,
				"type": "ORGANIZATION"
			},
			{
				"name": "Peter Rosenthal",
				"salience": 0.005807657,
				"type": "PERSON"
			},
			{
				"name": "university",
				"salience": 0.005590603,
				"type": "ORGANIZATION"
			},
			{
				"name": "interest group",
				"salience": 0.0055391765,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0261m0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Irwin_Cotler"
				},
				"name": "Irwin Cotler",
				"salience": 0.0054784534,
				"type": "PERSON"
			},
			{
				"name": "phenomenon",
				"salience": 0.005156185,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0051176683,
				"type": "OTHER"
			},
			{
				"name": "publications",
				"salience": 0.004673601,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hand",
				"salience": 0.0046211667,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0046211667,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0046211667,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.0044854265,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.0043466245,
				"type": "EVENT"
			},
			{
				"name": "university",
				"salience": 0.0042846426,
				"type": "ORGANIZATION"
			},
			{
				"name": "neo-conservatism movement",
				"salience": 0.004096424,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0040092785,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "voracity",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "pandering",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "reach",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "tentacles",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "Establishment",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "prominence",
				"salience": 0.004001984,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0035740966,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dtq8p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_rights_commission"
				},
				"name": "Human Rights Commission",
				"salience": 0.0035511665,
				"type": "ORGANIZATION"
			},
			{
				"name": "policy directive",
				"salience": 0.0034812237,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0885n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/York_University"
				},
				"name": "York University",
				"salience": 0.0034497948,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.0032734098,
				"type": "ORGANIZATION"
			},
			{
				"name": "academics",
				"salience": 0.0031887882,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0030924105,
				"type": "PERSON"
			},
			{
				"name": "modus operandi",
				"salience": 0.0026955896,
				"type": "OTHER"
			},
			{
				"name": "court ruling",
				"salience": 0.002650362,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0025796038,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0025706047,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0025706047,
				"type": "PERSON"
			},
			{
				"name": "professor",
				"salience": 0.0025360498,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/011kn2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Ottawa"
				},
				"name": "University of Ottawa",
				"salience": 0.0025299047,
				"type": "ORGANIZATION"
			},
			{
				"name": "professor",
				"salience": 0.0025204225,
				"type": "PERSON"
			},
			{
				"name": "professor",
				"salience": 0.0025204225,
				"type": "PERSON"
			},
			{
				"name": "professor",
				"salience": 0.0025204225,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.0024875754,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.0024722463,
				"type": "OTHER"
			},
			{
				"name": "extremist",
				"salience": 0.0024337203,
				"type": "PERSON"
			},
			{
				"name": "extremism",
				"salience": 0.0024337203,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.0024263614,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01k3s2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Alberta"
				},
				"name": "University of Alberta",
				"salience": 0.0024138542,
				"type": "ORGANIZATION"
			},
			{
				"name": "name",
				"salience": 0.0023906583,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00234453,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0022811922,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0022811922,
				"type": "ORGANIZATION"
			},
			{
				"name": "agenda",
				"salience": 0.0022811922,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0022785554,
				"type": "PERSON"
			},
			{
				"name": "University",
				"salience": 0.0022447426,
				"type": "ORGANIZATION"
			},
			{
				"name": "PhD",
				"salience": 0.0021364947,
				"type": "OTHER"
			},
			{
				"name": "manoeuvring",
				"salience": 0.0021074528,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0021074528,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack",
				"salience": 0.0020874548,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0019429901,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0019384682,
				"type": "OTHER"
			},
			{
				"name": "scandals",
				"salience": 0.0019028345,
				"type": "OTHER"
			},
			{
				"name": "Professor Hall travesty",
				"salience": 0.0019028345,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0019028345,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.0019028345,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0019028345,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.0019028345,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0018899271,
				"type": "OTHER"
			},
			{
				"name": "irony",
				"salience": 0.0018349373,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0018330897,
				"type": "ORGANIZATION"
			},
			{
				"name": "academic",
				"salience": 0.001802417,
				"type": "PERSON"
			},
			{
				"name": "conscience",
				"salience": 0.001802417,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.001802417,
				"type": "OTHER"
			},
			{
				"name": "academia",
				"salience": 0.001802417,
				"type": "LOCATION"
			},
			{
				"name": "academia",
				"salience": 0.001802417,
				"type": "PERSON"
			},
			{
				"name": "conscience",
				"salience": 0.001802417,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0017928156,
				"type": "EVENT"
			},
			{
				"name": "Stein",
				"salience": 0.0017593419,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vvwp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canadian_Security_Intelligence_Service"
				},
				"name": "Canadian Security Intelligence Service",
				"salience": 0.0017533051,
				"type": "ORGANIZATION"
			},
			{
				"name": "conscience",
				"salience": 0.0017351384,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0017351384,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.0017064185,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0017021778,
				"type": "PERSON"
			},
			{
				"name": "type",
				"salience": 0.0016477046,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0016477046,
				"type": "OTHER"
			},
			{
				"name": "neocon",
				"salience": 0.0016477046,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0016477046,
				"type": "OTHER"
			},
			{
				"name": "union",
				"salience": 0.0016477046,
				"type": "OTHER"
			},
			{
				"name": "epicentre",
				"salience": 0.0016477046,
				"type": "LOCATION"
			},
			{
				"name": "tenure",
				"salience": 0.0016477046,
				"type": "EVENT"
			},
			{
				"name": "spirit",
				"salience": 0.0016477046,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0016477046,
				"type": "OTHER"
			},
			{
				"name": "aspect",
				"salience": 0.0016477046,
				"type": "OTHER"
			},
			{
				"name": "extremism",
				"salience": 0.0016427215,
				"type": "OTHER"
			},
			{
				"name": "extremism",
				"salience": 0.0016427215,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0016198634,
				"type": "EVENT"
			},
			{
				"name": "scandals",
				"salience": 0.0016136488,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.0015994515,
				"type": "PERSON"
			},
			{
				"name": "attacker",
				"salience": 0.0015994515,
				"type": "PERSON"
			},
			{
				"name": "victim",
				"salience": 0.0015933153,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.001542875,
				"type": "OTHER"
			},
			{
				"name": "iota",
				"salience": 0.0015170962,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0015155686,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0014776128,
				"type": "EVENT"
			},
			{
				"name": "manoeuvring",
				"salience": 0.0014776128,
				"type": "EVENT"
			},
			{
				"name": "arena",
				"salience": 0.0014776128,
				"type": "LOCATION"
			},
			{
				"name": "academia",
				"salience": 0.0014714279,
				"type": "PERSON"
			},
			{
				"name": "rights",
				"salience": 0.0014714279,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0014714279,
				"type": "OTHER"
			},
			{
				"name": "academia",
				"salience": 0.0014714279,
				"type": "ORGANIZATION"
			},
			{
				"name": "human rights",
				"salience": 0.0014714279,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.0014253677,
				"type": "PERSON"
			},
			{
				"name": "hate crime",
				"salience": 0.0014224531,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0014224531,
				"type": "WORK_OF_ART"
			},
			{
				"name": "human rights activists",
				"salience": 0.0014224531,
				"type": "PERSON"
			},
			{
				"name": "Mind Control Contaminates",
				"salience": 0.0014224531,
				"type": "OTHER"
			},
			{
				"name": "hate crime",
				"salience": 0.0014224531,
				"type": "OTHER"
			},
			{
				"name": "manoeuvring",
				"salience": 0.0014224531,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.0014035468,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0013683953,
				"type": "OTHER"
			},
			{
				"name": "anti-Zionist Jew",
				"salience": 0.0013550101,
				"type": "PERSON"
			},
			{
				"name": "target",
				"salience": 0.0013392624,
				"type": "OTHER"
			},
			{
				"name": "university personnel",
				"salience": 0.0013341239,
				"type": "PERSON"
			},
			{
				"name": "assaults",
				"salience": 0.0013341239,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0013341239,
				"type": "PERSON"
			},
			{
				"name": "authority",
				"salience": 0.0013341239,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.0013341239,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.001330587,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0013057203,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.0013057203,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.0013057203,
				"type": "LOCATION"
			},
			{
				"name": "politicking",
				"salience": 0.0013057203,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0012852165,
				"type": "EVENT"
			},
			{
				"name": "freedom of speech",
				"salience": 0.0012843187,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0012843187,
				"type": "OTHER"
			},
			{
				"name": "travesty",
				"salience": 0.0012843187,
				"type": "EVENT"
			},
			{
				"name": "regime",
				"salience": 0.0012843187,
				"type": "OTHER"
			},
			{
				"name": "mindset",
				"salience": 0.0012843187,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0012843187,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0012372365,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.0012153375,
				"type": "OTHER"
			},
			{
				"name": "atrocity",
				"salience": 0.0012062488,
				"type": "OTHER"
			},
			{
				"name": "Muslim Organization",
				"salience": 0.0012058964,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0011572307,
				"type": "PERSON"
			},
			{
				"name": "finger",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "sympathizers",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "vendetta",
				"salience": 0.0011552209,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.0011552209,
				"type": "PERSON"
			},
			{
				"name": "prejudice",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "meanwhile",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "self defence",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0011552209,
				"type": "OTHER"
			},
			{
				"name": "professor",
				"salience": 0.0011194835,
				"type": "PERSON"
			},
			{
				"name": "University Suspension",
				"salience": 0.0011120924,
				"type": "EVENT"
			},
			{
				"name": "Due Diligence",
				"salience": 0.0011120924,
				"type": "OTHER"
			},
			{
				"name": "behaviour",
				"salience": 0.0011120924,
				"type": "OTHER"
			},
			{
				"name": "onslaught",
				"salience": 0.0011120924,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.0011120924,
				"type": "OTHER"
			},
			{
				"name": "conscience",
				"salience": 0.0010991548,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0010932985,
				"type": "OTHER"
			},
			{
				"name": "victim",
				"salience": 0.0010891035,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.0010891035,
				"type": "OTHER"
			},
			{
				"name": "University authority",
				"salience": 0.0010891035,
				"type": "ORGANIZATION"
			},
			{
				"name": "name",
				"salience": 0.0010891035,
				"type": "OTHER"
			},
			{
				"name": "recourse",
				"salience": 0.0010753777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0346_6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim_Students'_Association"
				},
				"name": "Muslim Student Association",
				"salience": 0.001014123,
				"type": "ORGANIZATION"
			},
			{
				"name": "politics",
				"salience": 0.00097535976,
				"type": "OTHER"
			},
			{
				"name": "trails",
				"salience": 0.00096727646,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.00096727646,
				"type": "PERSON"
			},
			{
				"name": "sewerage",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "helm",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.0009430483,
				"type": "WORK_OF_ART"
			},
			{
				"name": "collusion",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "complicity",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "category",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "dignity",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "subjugation",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "vilest",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "decency",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0009430483,
				"type": "OTHER"
			},
			{
				"name": "emotion",
				"salience": 0.0009251302,
				"type": "OTHER"
			},
			{
				"name": "University",
				"salience": 0.0009122912,
				"type": "ORGANIZATION"
			},
			{
				"name": "problem",
				"salience": 0.0009078389,
				"type": "OTHER"
			},
			{
				"name": "mystery",
				"salience": 0.0009078389,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0009078389,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0009010491,
				"type": "OTHER"
			},
			{
				"name": "Anti-Muslim Bias",
				"salience": 0.0008860197,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0008591735,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00085288926,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.00083935517,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00083935517,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00081353646,
				"type": "PERSON"
			},
			{
				"name": "intelligence community",
				"salience": 0.00081353646,
				"type": "OTHER"
			},
			{
				"name": "tactic",
				"salience": 0.00081353646,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00081353646,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00081353646,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00081353646,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00081353646,
				"type": "OTHER"
			},
			{
				"name": "special interest group",
				"salience": 0.0007861783,
				"type": "ORGANIZATION"
			},
			{
				"name": "path",
				"salience": 0.00078316143,
				"type": "OTHER"
			},
			{
				"name": "extremism",
				"salience": 0.0007675068,
				"type": "OTHER"
			},
			{
				"name": "recourse",
				"salience": 0.00076354394,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.00076354394,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0007578331,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0007578331,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0007578331,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00075392023,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0007185516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.00071570295,
				"type": "PERSON"
			},
			{
				"name": "court",
				"salience": 0.00071031624,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.00071031624,
				"type": "ORGANIZATION"
			},
			{
				"name": "target",
				"salience": 0.00071031624,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.00071031624,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "censorship",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "brush",
				"salience": 0.000704429,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "level",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "opponent",
				"salience": 0.000704429,
				"type": "PERSON"
			},
			{
				"name": "red scare",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.000704429,
				"type": "OTHER"
			},
			{
				"name": "The Public Sphere Irish",
				"salience": 0.000684426,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03pp1z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canadian_Jewish_Congress"
				},
				"name": "Canadian Jewish Congress",
				"salience": 0.000670276,
				"type": "ORGANIZATION"
			},
			{
				"name": "morale",
				"salience": 0.00066113996,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.000659346,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.00065619487,
				"type": "WORK_OF_ART"
			},
			{
				"name": "student",
				"salience": 0.00065619487,
				"type": "PERSON"
			},
			{
				"name": "atrocity",
				"salience": 0.00065619487,
				"type": "OTHER"
			},
			{
				"name": "hate crimes",
				"salience": 0.00065619487,
				"type": "OTHER"
			},
			{
				"name": "atrocity",
				"salience": 0.00065619487,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.0006232955,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00061268936,
				"type": "OTHER"
			},
			{
				"name": "untruths",
				"salience": 0.0006049667,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00060002226,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Professor Hall",
				"salience": 0.00059792784,
				"type": "PERSON"
			},
			{
				"name": "conscience",
				"salience": 0.00059792784,
				"type": "OTHER"
			},
			{
				"name": "conscience",
				"salience": 0.00059792784,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00059792784,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.00059792784,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.00059792784,
				"type": "PERSON"
			},
			{
				"name": "Professor Hall",
				"salience": 0.00059792784,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.00059245917,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00059245917,
				"type": "OTHER"
			},
			{
				"name": "misfeasance",
				"salience": 0.00059245917,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00059245917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0005709144,
				"type": "LOCATION"
			},
			{
				"name": "justice",
				"salience": 0.0005660712,
				"type": "OTHER"
			},
			{
				"name": "tactic",
				"salience": 0.00051529956,
				"type": "OTHER"
			},
			{
				"name": "appeals",
				"salience": 0.00051299715,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00051299715,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.00051299715,
				"type": "OTHER"
			},
			{
				"name": "Mathematics",
				"salience": 0.00051299715,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0clb0v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Greenwald"
				},
				"name": "Glenn Greenwald",
				"salience": 0.0005006663,
				"type": "PERSON"
			},
			{
				"name": "context",
				"salience": 0.00049014785,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00049014785,
				"type": "OTHER"
			},
			{
				"name": "activist",
				"salience": 0.00049014785,
				"type": "PERSON"
			},
			{
				"name": "misfortune",
				"salience": 0.0004836314,
				"type": "OTHER"
			},
			{
				"name": "General election day",
				"salience": 0.00044253812,
				"type": "EVENT"
			},
			{
				"name": "instance",
				"salience": 0.00044253812,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00044253812,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00044253812,
				"type": "WORK_OF_ART"
			},
			{
				"name": "works",
				"salience": 0.00044253812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Amendment_to_the_United_States_Constitution"
				},
				"name": "First Amendment",
				"salience": 0.00043351421,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.00043351421,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01q1bd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_Canada"
				},
				"name": "Green Party",
				"salience": 0.00043351421,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.00043351421,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0455m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_McCarthy"
				},
				"name": "Senator McCarthy",
				"salience": 0.00043351421,
				"type": "PERSON"
			},
			{
				"name": "Claire Lanyado",
				"salience": 0.00043351421,
				"type": "PERSON"
			},
			{
				"name": "voice",
				"salience": 0.00040827313,
				"type": "OTHER"
			},
			{
				"name": "Rafiq Islam",
				"salience": 0.00040382822,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.00038490148,
				"type": "OTHER"
			},
			{
				"name": "ranking",
				"salience": 0.00038318164,
				"type": "OTHER"
			},
			{
				"name": "maligning",
				"salience": 0.00038318164,
				"type": "EVENT"
			},
			{
				"name": "revulsion",
				"salience": 0.00038318164,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00038318164,
				"type": "LOCATION"
			},
			{
				"name": "prison",
				"salience": 0.00038318164,
				"type": "LOCATION"
			},
			{
				"name": "everyone",
				"salience": 0.00038318164,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.00038318164,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.00038318164,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.00038318164,
				"type": "LOCATION"
			},
			{
				"name": "Freeman-Maloy",
				"salience": 0.00031569807,
				"type": "PERSON"
			},
			{
				"name": "Jim Comeau",
				"salience": 0.00022989868,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/lethbridge_d3229.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-10T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 28.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.001",
		"text": "Prof. Rafiq Islam Responds to the Vice-Chancellor of the University of Punjab Outlining the Background of the Hall Case at the 2 Shares\n1 0 0 1\nDear Vice Chancellor Kamran:\nSalam from the East coast of Canada.\nThank you for taking the time to address this important issue regarding Professor Hall. Like yourself, we all have been stunned by the voracity of Dr. Mahon’s action. We used to think academics of certain reputation were above the reach of the tentacles of the Establishment. We all hoped that a president would not resort to such a shameless pandering to a special interest group. However, B’nai Brith is not just a special interest group, it is perhaps the most vindictive organization that has ever received prominence in the west. Allow me to elaborate.\nYou have correctly identified B’nai Brith to be “behind this movement against shutting down free speech.” While this statement is accurate, this phenomenon of targeting Canadian universities and Canadian society is not something that started now. Not too long ago, it used to be branded as ‘the hidden hand behind the hidden hand’. During the Harper era, this operation became a full-blown politically driven policy directive. The legislation that Dr. Mahon pathetically relies upon is a product of the Harper era. Harper had an extremist right-wing background and organizations like B’nai Brith have channelled that extremism to accomplish their hateful agenda. As early as the 1980s, I personally observed the spirit of this unholy union during my tenure as the president of Muslim Student Association at the University of Alberta. Although Harper didn’t attend that university, we were not too far from the epicentre of the neo-conservatism movement that was brewing in Canada. We fast-forward 30 years and come upon the type of events such as Professor Hall travesty that are products of that time. In fact, a web of such operations has been in full force for sometime in every aspect of Canadian lives. Only recently, we had this court ruling against Canadian Security Intelligence Service that was illegally spying on the public. This gangster-like involvement started in 2006, shortly after Harper and the neocon came to power.\nThis is not to say that the public is protected from such unconscionable manoeuvring under a liberal government. In fact, the most notorious scandals involving government and human rights have erupted during the liberal regime. Take for instance the case of Omar Khadr travesty .\nMORE... Creating an Anti-Muslim Bias at a Canadian University Suspension of Tenured Professor Lacks Due Diligence Toxic Mind Control Contaminates The Public Sphere Irish human rights activists against freedom of speech? This case is something we had known, albeit too late to intervene at the time, and has been subsequently discredited publicly, even during the Harper regime . The overwhelming theme was pointed out by then barely 16 year old, Omar Khadr, who said, “ You don’t care about me ”. This is what defines the mindset of these people, bent on extremism over extremism to subdue public conscience.\nThe attack on Professor Hall was particularly toxic, but equally sinister attacks have taken place before. Some decade ago, now defunct Canadian Islamic Congress faced onslaught from all sides based on planted stories and baited manoeuvring. It was the largest Muslim Organization at a time Canadian Muslims became the largest religious minority. One particular episode involved B’nai Brith’s planted story involving a University professor, who became the target of hate crime, while at the same time investigated for hate crime. If it wasn’t for the humane and civic behaviour of the then University president (current Governor General), David Johnston, it would have become career threatening, if not life threatening event of the professor. Top university personnel told me in private how the university faced pressure from ‘donors’ that wanted that professor to disappear from the academic as well as public arena. The vendetta of this sort beggars belief even today. What we don’t know is how many of these assaults on conscience took place and has been brewing.\nClearly, some of the faithful members/sympathizers apply it publicly. Such was the case of former professor turned politician, Irwin Cotler, who routinely infected the political arena with his prejudice and bias imported from the academia. Then there are others, such as Alan Rock of University of Ottawa that implanted manoeuvring of the political arena to the academia. A third group would be Lorna Marsden of York University that abused authority to run a vindictive agenda. Yet, others have found every other way possible to target a person of conscience all the meanwhile covering up all trails so the victim cannot point a finger to the attacker and has no recourse to justice or self defence. It doesn’t matter which category they belong to, they all produce scandals and drag down the good name of the academia while agencies that are supposed to be uphold the rights and dignity of the academia stand by and, for some cases, join in to the atrocity. This obscene attack on human rights and academic decency was once brought to light by late Professor David Noble, who ended up suing York University and Canadian Jewish Congress jointly for conspiring against him. Professor Noble, a Jew himself, faced the vilest of subjugation by organizations claiming to promote the rights of Jews. That wasn’t enough, Dr. Noble had to take on Human Rights Commission and other agencies that stood by either in complicity or in collusion with the University authority. Professor Noble passed away before the lawsuit could see a day in court but soon University of Ottawa would come in the picture with the infamous involvement of Alan Rock, a man without a PhD that was at the helm of the University. Mr. Rock recently left the University—but not before leaving the University’s good name in the sewerage of politicking. What Dr. Mahon has done is bring this insidious modus operandi to yet another victim.\nHad I not have the misfortune of being on the wrong side of this modus operandi in the last 30 years, I would almost not understand what is at works here. In old days, such tactic would be unheard-of in a University. Certainly, such things couldn’t happen in a civilized country, I would exclaim.\nSo, what happened to Professor Hall is not new. What is new is the waking up of the general public. Your letter reverberates the emotion of everyone with conscience that came to know about Professor Hall. People are waking up and are beginning to ask for justice. For instance, in the context of CSIS, an activist, Jim Comeau wrote, “I would say it's time to jail the highest ranking CSIS to send a clear message to the rest of them, do something illegal, straight to prison. They damn well knew what they were doing was illegal.”\nThe People’s revulsion to such atrocious maligning of people of conscience was summed up in recent letter of Julian Assange, who wrote on US General election day (November 8, 2016):\n“Yet, some weeks ago, in a tactic reminiscent of Senator McCarthy and the red scare, Wikileaks, Green Party candidate Stein, Glenn Greenwald and Clinton’s main opponent were painted with a broad, red brush. The Clinton campaign, when they were not spreading obvious untruths, pointed to unnamed sources or to speculative and vague statements from the intelligence community to suggest a nefarious allegiance with Russia. The campaign was unable to invoke evidence about our publications—because none exists.\nIn the end, those who have attempted to malign our groundbreaking work over the past four months seek to inhibit public understanding perhaps because it is embarrassing to them – a reason for censorship the First Amendment cannot tolerate. Only unsuccessfully do they try to claim that our publications are inaccurate.”\nOf course, recent events have allowed us to see this in the highest level of politics in the United States.\nTo anyone with an iota of conscience, there is no mystery here. People are making their voice clearly known. In the words of Claire Lanyado, “I prefer unpredictable to criminal and evil.” The problem is, when a president of University for whatever reason decides to use his position to serve the special interest group deliberately, there is no recourse for a professor to fight him/her. In other cases, if such atrocity were launched against a student (e.g. the case of Freeman-Maloy vs. Lorna Marsden of York University ), the student, an anti-Zionist Jew, could bring a lawsuit of misfeasance in public office with the help of yet another Jewish lawyer, Peter Rosenthal (who himself is a University professor of Mathematics). It was struck down by the court, and then it was overruled by the court of appeals. At the end, the University settled and Dr. Marsden, the embattled President was gone. The morale of this story is, the path to justice is steep, but for a professor, the path to justice is becoming impossible.\nThe irony is that it is the people harboring so much hate who tell others that they are committing hate crimes, just because they dare speak out against an atrocity. Of course, they pick their targets that are perceived as weak and vulnerable and they attack the target only after making sure that the target cannot run to anyone for justice.\nThat’s how extremism works.\n Sincerely,\nRafiq Islam",
		"thread_title": "The B'nai Brith and the History of the Mounting Assault on Academic Freedom in Canadian Universities",
		"title": "The B'nai Brith and the History of the Mounting Assault on Academic Freedom in Canadian Universities",
		"type": "bs",
		"uuid": "a52662903b2b0f5c34a55633582629ca5c0b9610"
	},
	"-KhIbRqsoBXJXmjVGUKz": {
		"author": "Kai Kieferle",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-11T05:09:13.198+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "letter",
				"salience": 0.22257759,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.11628409,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.07189763,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.055974588,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.05062972,
				"type": "OTHER"
			},
			{
				"name": "grasp",
				"salience": 0.04854264,
				"type": "OTHER"
			},
			{
				"name": "writings",
				"salience": 0.04854264,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.043900803,
				"type": "OTHER"
			},
			{
				"name": "prejudice",
				"salience": 0.0419624,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0419624,
				"type": "ORGANIZATION"
			},
			{
				"name": "prejudice",
				"salience": 0.03562994,
				"type": "OTHER"
			},
			{
				"name": "Hall",
				"salience": 0.034133006,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.032867096,
				"type": "LOCATION"
			},
			{
				"name": "ideas",
				"salience": 0.027899072,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.026663216,
				"type": "ORGANIZATION"
			},
			{
				"name": "argument",
				"salience": 0.02086932,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.01521529,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.014539565,
				"type": "ORGANIZATION"
			},
			{
				"name": "prejudices",
				"salience": 0.014539565,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.013131007,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.01286394,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.00937448,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/Mujahid_Kamran_53382.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-10T21:38:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 2.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "This looks like a fake letter. Especially this part; \"His analysis is impeccable and his grasp of facts masterly. And his writings are devoid of any prejudice against any ethnic group or nation.\"\nHall's \"analysis\" is laughable, his basic understanding of the ideas he talks about is vapid, and he clearly voices prejudice against an ethnic group, in fact he relies on prejudices against an ethnic group when he uses the 'dual - loyalty Jews' argument as 'evidence' that Israel was involved in 9/11.",
		"thread_title": "Creating an Anti-Muslim Bias at a Canadian University",
		"title": "",
		"type": "bs",
		"uuid": "bdaa67391ba99b3883e0768d68deff385bbd0e59"
	},
	"-KhIbTW3BCDp7wzl6jZ5": {
		"author": "B. J. Sabri",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-11T16:39:51.009+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.22441658,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1474525,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/089g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionism"
				},
				"name": "Zionistic",
				"salience": 0.08889056,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.045269776,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.022124924,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.01980365,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arabs",
				"salience": 0.016281107,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.011969452,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/048z7l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Jews"
				},
				"name": "Jewish-Americans",
				"salience": 0.010751263,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0077536753,
				"type": "LOCATION"
			},
			{
				"name": "System",
				"salience": 0.0069591366,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.006616024,
				"type": "OTHER"
			},
			{
				"name": "Social Base",
				"salience": 0.005875776,
				"type": "OTHER"
			},
			{
				"name": "American System",
				"salience": 0.0056381105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_H._W._Bush"
				},
				"name": "George H.W. Bush",
				"salience": 0.00460874,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.0046021133,
				"type": "EVENT"
			},
			{
				"name": "System",
				"salience": 0.0043268846,
				"type": "OTHER"
			},
			{
				"name": "Interviews",
				"salience": 0.00416372,
				"type": "EVENT"
			},
			{
				"name": "Zionism",
				"salience": 0.0040994193,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.003915751,
				"type": "LOCATION"
			},
			{
				"name": "Voting",
				"salience": 0.003721887,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0036215738,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025pr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jim_Lehrer"
				},
				"name": "Jim Lehrer",
				"salience": 0.0033629895,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.0033040855,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "U.S. Congress",
				"salience": 0.0032561605,
				"type": "ORGANIZATION"
			},
			{
				"name": "System",
				"salience": 0.0031131904,
				"type": "OTHER"
			},
			{
				"name": "Base",
				"salience": 0.0029988831,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestine",
				"salience": 0.00296149,
				"type": "LOCATION"
			},
			{
				"name": "systems",
				"salience": 0.002742803,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0026420755,
				"type": "OTHER"
			},
			{
				"name": "interviews",
				"salience": 0.0024446473,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/08_p2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Defense_(Israel)"
				},
				"name": "Israeli Defense Ministry",
				"salience": 0.0022906095,
				"type": "ORGANIZATION"
			},
			{
				"name": "Racism Zionism",
				"salience": 0.0022844519,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0021084023,
				"type": "OTHER"
			},
			{
				"name": "Zionism",
				"salience": 0.0020642162,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0020444498,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0019534065,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0019534065,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.0019175344,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0019175344,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0018409702,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.001795532,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/058w23",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Francis_Boyle"
				},
				"name": "Francis Boyle",
				"salience": 0.001779856,
				"type": "PERSON"
			},
			{
				"name": "discussion",
				"salience": 0.001753921,
				"type": "OTHER"
			},
			{
				"name": "interpretation",
				"salience": 0.0017048488,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0016841613,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0016605438,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/070ykr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Petras"
				},
				"name": "James Petras",
				"salience": 0.0016529938,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.0016442334,
				"type": "OTHER"
			},
			{
				"name": "clear-cut",
				"salience": 0.0016100723,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0016069678,
				"type": "PERSON"
			},
			{
				"name": "Base",
				"salience": 0.0016018436,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/042kg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmy_Carter"
				},
				"name": "Jimmy Carter",
				"salience": 0.0015978079,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/079dy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saddam_Hussein"
				},
				"name": "Saddam Hussein",
				"salience": 0.0015841263,
				"type": "PERSON"
			},
			{
				"name": "A.M. Rosenthal",
				"salience": 0.0015504529,
				"type": "PERSON"
			},
			{
				"name": "Voting",
				"salience": 0.0015415606,
				"type": "EVENT"
			},
			{
				"name": "relation",
				"salience": 0.0014694069,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0014465103,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0014465103,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0014465103,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0014465103,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0014465103,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0014465103,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0014465103,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0014465103,
				"type": "OTHER"
			},
			{
				"name": "Zionism",
				"salience": 0.0014200318,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0013450879,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0013450879,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0013450879,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0013450879,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.0013450879,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0013258483,
				"type": "OTHER"
			},
			{
				"name": "Jews",
				"salience": 0.0013236406,
				"type": "PERSON"
			},
			{
				"name": "interventions",
				"salience": 0.0013230582,
				"type": "OTHER"
			},
			{
				"name": "restraints",
				"salience": 0.0012983745,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0012542941,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0012526042,
				"type": "EVENT"
			},
			{
				"name": "class",
				"salience": 0.001236279,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016m7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pat_Buchanan"
				},
				"name": "Patrick J. Buchanan",
				"salience": 0.0012309757,
				"type": "PERSON"
			},
			{
				"name": "Base",
				"salience": 0.0012274438,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0012274438,
				"type": "OTHER"
			},
			{
				"name": "Base",
				"salience": 0.0012274438,
				"type": "LOCATION"
			},
			{
				"name": "Base",
				"salience": 0.0012274438,
				"type": "OTHER"
			},
			{
				"name": "Base",
				"salience": 0.0012274438,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00119227,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.001162053,
				"type": "ORGANIZATION"
			},
			{
				"name": "thinkers",
				"salience": 0.0011588061,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.0011289718,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0011159411,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.0011053189,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.0011053189,
				"type": "OTHER"
			},
			{
				"name": "System and Base",
				"salience": 0.0010633642,
				"type": "OTHER"
			},
			{
				"name": "mandate",
				"salience": 0.0010617921,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0010516811,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.0010516811,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0010516811,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0010516811,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0010166893,
				"type": "OTHER"
			},
			{
				"name": "INTRODUCTION",
				"salience": 0.0010103923,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.0009793603,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.0009793603,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.0009793603,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0009793603,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0009793603,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0009793603,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0009793603,
				"type": "OTHER"
			},
			{
				"name": "interviews",
				"salience": 0.00094534113,
				"type": "EVENT"
			},
			{
				"name": "wars",
				"salience": 0.00093924935,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00093924935,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00093924935,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00090355834,
				"type": "EVENT"
			},
			{
				"name": "patterns",
				"salience": 0.0008957576,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0008957576,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0008957576,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0008957576,
				"type": "ORGANIZATION"
			},
			{
				"name": "patterns",
				"salience": 0.0008957576,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0008888732,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.0008866714,
				"type": "PERSON"
			},
			{
				"name": "notion",
				"salience": 0.00087788,
				"type": "OTHER"
			},
			{
				"name": "Robert D. Kaplan",
				"salience": 0.0008762293,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00084804726,
				"type": "ORGANIZATION"
			},
			{
				"name": "imperialism",
				"salience": 0.00084804726,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00084804726,
				"type": "EVENT"
			},
			{
				"name": "Meaning",
				"salience": 0.00084804726,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.00084804726,
				"type": "OTHER"
			},
			{
				"name": "invasions",
				"salience": 0.00084804726,
				"type": "EVENT"
			},
			{
				"name": "sharing",
				"salience": 0.00084804726,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00084804726,
				"type": "ORGANIZATION"
			},
			{
				"name": "objectives",
				"salience": 0.00084804726,
				"type": "OTHER"
			},
			{
				"name": "meaning",
				"salience": 0.00084804726,
				"type": "OTHER"
			},
			{
				"name": "foreign policy objectives",
				"salience": 0.00084804726,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0007948859,
				"type": "OTHER"
			},
			{
				"name": "concepts",
				"salience": 0.0007948859,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0007948859,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0007948859,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.00076109276,
				"type": "OTHER"
			},
			{
				"name": "Dissident Voice Kim Petersen",
				"salience": 0.00075689785,
				"type": "PERSON"
			},
			{
				"name": "elites",
				"salience": 0.00075469643,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.00075393653,
				"type": "OTHER"
			},
			{
				"name": "yardstick",
				"salience": 0.0007398664,
				"type": "OTHER"
			},
			{
				"name": "reluctance",
				"salience": 0.0007398664,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00073433365,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "perception",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "tool work",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "colonies",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "colonialism",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "colonies",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.00073433365,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00072959857,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.00072016125,
				"type": "LOCATION"
			},
			{
				"name": "elites",
				"salience": 0.00070832734,
				"type": "PERSON"
			},
			{
				"name": "following",
				"salience": 0.0007064264,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.0007064264,
				"type": "OTHER"
			},
			{
				"name": "presidents",
				"salience": 0.0007052402,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.00068542286,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025n6y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Major_sixth"
				},
				"name": "Sixth",
				"salience": 0.00067945896,
				"type": "OTHER"
			},
			{
				"name": "duopoly party apparatchiks",
				"salience": 0.000674032,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.0006676205,
				"type": "OTHER"
			},
			{
				"name": "thesis",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "attributes",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "association",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "thesis",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.0006630219,
				"type": "ORGANIZATION"
			},
			{
				"name": "crimes",
				"salience": 0.0006630219,
				"type": "EVENT"
			},
			{
				"name": "majority",
				"salience": 0.0006630219,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0006515191,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0006407281,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0006393597,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0006354978,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01q1bd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_Canada"
				},
				"name": "Green Party of Canada",
				"salience": 0.0006182721,
				"type": "ORGANIZATION"
			},
			{
				"name": "problems",
				"salience": 0.0006071217,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0005954331,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0005954331,
				"type": "OTHER"
			},
			{
				"name": "System",
				"salience": 0.0005954331,
				"type": "OTHER"
			},
			{
				"name": "symbiosis",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "lobbying efforts",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0005741105,
				"type": "PERSON"
			},
			{
				"name": "attitudes",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "dependency",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "aversion",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "tenets",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "dichotomy",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "horrors",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "visions",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "inception",
				"salience": 0.0005741105,
				"type": "EVENT"
			},
			{
				"name": "destruction",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "Caveat",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "regularity",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0005741105,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0005733514,
				"type": "ORGANIZATION"
			},
			{
				"name": "power status",
				"salience": 0.0005536662,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0005536662,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.0005536662,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0005536662,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0005536662,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israelis",
				"salience": 0.0005527092,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.0005445945,
				"type": "OTHER"
			},
			{
				"name": "Israel Political Action Committee",
				"salience": 0.0005219504,
				"type": "ORGANIZATION"
			},
			{
				"name": "ideas",
				"salience": 0.00051966246,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.0005187161,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.0005180303,
				"type": "OTHER"
			},
			{
				"name": "associates",
				"salience": 0.00051484903,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00051292084,
				"type": "OTHER"
			},
			{
				"name": "invalidation",
				"salience": 0.0005073213,
				"type": "OTHER"
			},
			{
				"name": "Base",
				"salience": 0.0005052225,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0005052225,
				"type": "OTHER"
			},
			{
				"name": "Base",
				"salience": 0.0005052225,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0004892256,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.00048771387,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.00048771387,
				"type": "LOCATION"
			},
			{
				"name": "presence",
				"salience": 0.00047304254,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0004715601,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0004715601,
				"type": "OTHER"
			},
			{
				"name": "Zionism",
				"salience": 0.00046235017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0004599661,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00045931104,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00045931104,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00045632184,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00045441146,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.0004498023,
				"type": "OTHER"
			},
			{
				"name": "Villagers",
				"salience": 0.00044580278,
				"type": "PERSON"
			},
			{
				"name": "Zionists",
				"salience": 0.00044508764,
				"type": "PERSON"
			},
			{
				"name": "Zionism",
				"salience": 0.00044508764,
				"type": "OTHER"
			},
			{
				"name": "Zionism",
				"salience": 0.00044508764,
				"type": "OTHER"
			},
			{
				"name": "conquests",
				"salience": 0.00043986598,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.0004334447,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.00043285333,
				"type": "OTHER"
			},
			{
				"name": "military actions",
				"salience": 0.00043285333,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/047yc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kuwait"
				},
				"name": "Kuwait",
				"salience": 0.00043083087,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00042828082,
				"type": "LOCATION"
			},
			{
				"name": "relation",
				"salience": 0.00042405637,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.00042159992,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00041844667,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.00041199118,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0004101505,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00040307807,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.00040307807,
				"type": "OTHER"
			},
			{
				"name": "agendas",
				"salience": 0.00040307807,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00040307807,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00040307807,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00040185874,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.00039949393,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00039853487,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.00039661894,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rtwj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abraham_Foxman"
				},
				"name": "Abraham H. Foxman",
				"salience": 0.00039613227,
				"type": "PERSON"
			},
			{
				"name": "denial",
				"salience": 0.00039029933,
				"type": "EVENT"
			},
			{
				"name": "benefits",
				"salience": 0.0003894776,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.0003894776,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00038816052,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.0003857803,
				"type": "EVENT"
			},
			{
				"name": "interviewees",
				"salience": 0.00038180003,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00038180003,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00037973266,
				"type": "OTHER"
			},
			{
				"name": "Zionism",
				"salience": 0.00037742747,
				"type": "OTHER"
			},
			{
				"name": "Zionists",
				"salience": 0.00037742747,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.00037366743,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.00037366743,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.00037366743,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00037187102,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.00037111985,
				"type": "OTHER"
			},
			{
				"name": "patterns",
				"salience": 0.00036865962,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.00036865962,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.00036865962,
				"type": "LOCATION"
			},
			{
				"name": "propaganda book",
				"salience": 0.00036781104,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interest",
				"salience": 0.0003675444,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0003675444,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0003567459,
				"type": "ORGANIZATION"
			},
			{
				"name": "length",
				"salience": 0.0003567459,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048cl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Karl_Marx"
				},
				"name": "Marx",
				"salience": 0.00035332947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0651vn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marxism"
				},
				"name": "Marxian",
				"salience": 0.00035332947,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03n2xc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jewish_National_Fund"
				},
				"name": "Jewish National Fund",
				"salience": 0.00035332947,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03_gx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Judaism"
				},
				"name": "Judaism",
				"salience": 0.00035332947,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0003518946,
				"type": "WORK_OF_ART"
			},
			{
				"name": "alignment",
				"salience": 0.00035164872,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00035164872,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.00035058495,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00034901855,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.00034901855,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00034901855,
				"type": "OTHER"
			},
			{
				"name": "sharing",
				"salience": 0.00034901855,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00034901855,
				"type": "ORGANIZATION"
			},
			{
				"name": "means",
				"salience": 0.00034901855,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.00034901855,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00034901855,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.00034416068,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0003411915,
				"type": "ORGANIZATION"
			},
			{
				"name": "American Jewish Zionist",
				"salience": 0.00034074584,
				"type": "ORGANIZATION"
			},
			{
				"name": "point",
				"salience": 0.00033622156,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0003278918,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00032713416,
				"type": "OTHER"
			},
			{
				"name": "domination",
				"salience": 0.00032713416,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.00032332563,
				"type": "OTHER"
			},
			{
				"name": "observation",
				"salience": 0.00031893936,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.00031838578,
				"type": "OTHER"
			},
			{
				"name": "crack",
				"salience": 0.00031771543,
				"type": "OTHER"
			},
			{
				"name": "crack",
				"salience": 0.00031771543,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d4nvd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philip_Giraldi"
				},
				"name": "Philip Giraldi",
				"salience": 0.00031720655,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.00031686237,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0003127617,
				"type": "OTHER"
			},
			{
				"name": "intellectuals",
				"salience": 0.00031166998,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00031042233,
				"type": "EVENT"
			},
			{
				"name": "issues",
				"salience": 0.00030998228,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00030998228,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00030998228,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.00030478457,
				"type": "PERSON"
			},
			{
				"name": "activism",
				"salience": 0.00030345592,
				"type": "OTHER"
			},
			{
				"name": "military actions",
				"salience": 0.00030345592,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00030220812,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00030220812,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00030129388,
				"type": "OTHER"
			},
			{
				"name": "OBSERVATIONS",
				"salience": 0.00029933915,
				"type": "OTHER"
			},
			{
				"name": "attributes",
				"salience": 0.0002981904,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.0002972883,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00029710017,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029506464,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.00029354106,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0002933553,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0002933553,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.000292125,
				"type": "PERSON"
			},
			{
				"name": "coalition",
				"salience": 0.00029121712,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.00028600654,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00028258032,
				"type": "OTHER"
			},
			{
				"name": "Zionism",
				"salience": 0.0002819224,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.00027510276,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.00027453978,
				"type": "OTHER"
			},
			{
				"name": "operators",
				"salience": 0.00027285426,
				"type": "ORGANIZATION"
			},
			{
				"name": "alignment",
				"salience": 0.00027285426,
				"type": "OTHER"
			},
			{
				"name": "tax money",
				"salience": 0.00027285426,
				"type": "OTHER"
			},
			{
				"name": "structures",
				"salience": 0.00027285426,
				"type": "OTHER"
			},
			{
				"name": "surrender",
				"salience": 0.00027285426,
				"type": "OTHER"
			},
			{
				"name": "structures",
				"salience": 0.00027285426,
				"type": "LOCATION"
			},
			{
				"name": "result",
				"salience": 0.00027285426,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.00027285426,
				"type": "OTHER"
			},
			{
				"name": "surrender",
				"salience": 0.00027285426,
				"type": "OTHER"
			},
			{
				"name": "composition",
				"salience": 0.00027285426,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00027285426,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0002720288,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0002720288,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0002720288,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0002720288,
				"type": "OTHER"
			},
			{
				"name": "turning point",
				"salience": 0.00027100267,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00027100267,
				"type": "EVENT"
			},
			{
				"name": "Philip Weiss",
				"salience": 0.0002655929,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.0002650904,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0002650904,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00026285727,
				"type": "OTHER"
			},
			{
				"name": "rationale",
				"salience": 0.0002628495,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.0002628495,
				"type": "OTHER"
			},
			{
				"name": "freezing",
				"salience": 0.0002628495,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00026196058,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0002608834,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0002608834,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0002608834,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0002597911,
				"type": "OTHER"
			},
			{
				"name": "observance",
				"salience": 0.00025383194,
				"type": "OTHER"
			},
			{
				"name": "post-WWII American",
				"salience": 0.00025366765,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.00025172802,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00025140258,
				"type": "OTHER"
			},
			{
				"name": "viewers",
				"salience": 0.00025045944,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.000248799,
				"type": "OTHER"
			},
			{
				"name": "patterns",
				"salience": 0.000248799,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.000248799,
				"type": "PERSON"
			},
			{
				"name": "discussion",
				"salience": 0.000248799,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.000248799,
				"type": "OTHER"
			},
			{
				"name": "nationhood",
				"salience": 0.000248799,
				"type": "OTHER"
			},
			{
				"name": "military action",
				"salience": 0.0002477144,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0002477144,
				"type": "PERSON"
			},
			{
				"name": "vice president",
				"salience": 0.0002477144,
				"type": "PERSON"
			},
			{
				"name": "account",
				"salience": 0.0002465234,
				"type": "OTHER"
			},
			{
				"name": "Professors",
				"salience": 0.00024467942,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.00024467942,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.00024467942,
				"type": "PERSON"
			},
			{
				"name": "invasion",
				"salience": 0.00024467942,
				"type": "EVENT"
			},
			{
				"name": "commitment",
				"salience": 0.00024467942,
				"type": "OTHER"
			},
			{
				"name": "professor",
				"salience": 0.00024467942,
				"type": "PERSON"
			},
			{
				"name": "invasion",
				"salience": 0.00024467942,
				"type": "EVENT"
			},
			{
				"name": "imperialist",
				"salience": 0.00024467942,
				"type": "OTHER"
			},
			{
				"name": "Quote: d",
				"salience": 0.00024408539,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.00024201725,
				"type": "PERSON"
			},
			{
				"name": "amen corner",
				"salience": 0.0002394689,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0002394689,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.00023648966,
				"type": "OTHER"
			},
			{
				"name": "entrenchment",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "ranks",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "challenge",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "latter",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "endeavor",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "uniformity",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "slogans",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "configuration",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "misunderstanding",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "dissent",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "transformation",
				"salience": 0.00023625769,
				"type": "EVENT"
			},
			{
				"name": "behalf",
				"salience": 0.00023625769,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00023554293,
				"type": "EVENT"
			},
			{
				"name": "shares",
				"salience": 0.00023554293,
				"type": "OTHER"
			},
			{
				"name": "replacement",
				"salience": 0.00023554293,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00023554293,
				"type": "EVENT"
			},
			{
				"name": "replacement",
				"salience": 0.00023554293,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.00023280224,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "American War",
				"salience": 0.00023107433,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.00023067293,
				"type": "OTHER"
			},
			{
				"name": "internet publishing",
				"salience": 0.00022933657,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.00022933657,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.00022933657,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00022933657,
				"type": "OTHER"
			},
			{
				"name": "replies",
				"salience": 0.00022815431,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00022191885,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00022077291,
				"type": "PERSON"
			},
			{
				"name": "conclusion",
				"salience": 0.00022077291,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.00022077291,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.00022077291,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00022077291,
				"type": "EVENT"
			},
			{
				"name": "argument",
				"salience": 0.00022077291,
				"type": "OTHER"
			},
			{
				"name": "observations",
				"salience": 0.00022077291,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00022077291,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/033tf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Irish_American"
				},
				"name": "Irish-Americans",
				"salience": 0.00021829153,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-Americans",
				"salience": 0.00021829153,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.00021730525,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.00021730525,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00021477674,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00021376745,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.00021186138,
				"type": "OTHER"
			},
			{
				"name": "freeze",
				"salience": 0.00021186138,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00021186138,
				"type": "EVENT"
			},
			{
				"name": "threats",
				"salience": 0.00021186138,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00021186138,
				"type": "LOCATION"
			},
			{
				"name": "establishment",
				"salience": 0.00021186138,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.00021186138,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00021186138,
				"type": "ORGANIZATION"
			},
			{
				"name": "word",
				"salience": 0.0002109743,
				"type": "OTHER"
			},
			{
				"name": "objective",
				"salience": 0.00021012971,
				"type": "OTHER"
			},
			{
				"name": "diplomacy",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "diplomacy",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "rationales",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0002039502,
				"type": "WORK_OF_ART"
			},
			{
				"name": "administrations",
				"salience": 0.0002039502,
				"type": "EVENT"
			},
			{
				"name": "matters",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "administrations",
				"salience": 0.0002039502,
				"type": "EVENT"
			},
			{
				"name": "matters",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "dialog",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0002039502,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00020157706,
				"type": "OTHER"
			},
			{
				"name": "grounds",
				"salience": 0.00020157706,
				"type": "LOCATION"
			},
			{
				"name": "content",
				"salience": 0.00020157706,
				"type": "WORK_OF_ART"
			},
			{
				"name": "control",
				"salience": 0.00020157706,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00020157706,
				"type": "OTHER"
			},
			{
				"name": "lion share",
				"salience": 0.00019973333,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00019973333,
				"type": "OTHER"
			},
			{
				"name": "objective",
				"salience": 0.00019973333,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.00019973333,
				"type": "PERSON"
			},
			{
				"name": "accusation",
				"salience": 0.00019870194,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00019634022,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00019385952,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "scholarship",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "insight",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "making",
				"salience": 0.00019128209,
				"type": "EVENT"
			},
			{
				"name": "scope",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "complications",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "propaganda operatives",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "phone conversations",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "directions",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "University",
				"salience": 0.00019128209,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "emergence",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "scope",
				"salience": 0.00019128209,
				"type": "OTHER"
			},
			{
				"name": "proxy",
				"salience": 0.0001904274,
				"type": "OTHER"
			},
			{
				"name": "planners",
				"salience": 0.00018900746,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.00018836375,
				"type": "OTHER"
			},
			{
				"name": "medium",
				"salience": 0.00018720857,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00018720857,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.00018720857,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0001856568,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00018536337,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.00018502891,
				"type": "OTHER"
			},
			{
				"name": "propaganda apparatuses",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "society figure",
				"salience": 0.0001841393,
				"type": "PERSON"
			},
			{
				"name": "each",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0001841393,
				"type": "ORGANIZATION"
			},
			{
				"name": "rights",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "sympathy",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0001841393,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "making",
				"salience": 0.0001841393,
				"type": "EVENT"
			},
			{
				"name": "process",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0001841393,
				"type": "OTHER"
			},
			{
				"name": "offices",
				"salience": 0.0001841393,
				"type": "LOCATION"
			},
			{
				"name": "Recognition",
				"salience": 0.0001795262,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.00017886978,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00017886978,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00017886978,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00017886978,
				"type": "OTHER"
			},
			{
				"name": "amen corner",
				"salience": 0.00017886978,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.00017886978,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00017606023,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.00017515107,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.00017441768,
				"type": "OTHER"
			},
			{
				"name": "freezing",
				"salience": 0.0001729432,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0001729432,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0001729432,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0001729432,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0001723583,
				"type": "OTHER"
			},
			{
				"name": "polity",
				"salience": 0.0001723583,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0001723583,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0001722995,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0001722995,
				"type": "OTHER"
			},
			{
				"name": "viewers",
				"salience": 0.0001722995,
				"type": "PERSON"
			},
			{
				"name": "viewers",
				"salience": 0.0001722995,
				"type": "PERSON"
			},
			{
				"name": "advantage",
				"salience": 0.00016988133,
				"type": "OTHER"
			},
			{
				"name": "phenomenon",
				"salience": 0.00016988133,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.000166653,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.00016648513,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00016648513,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00016562542,
				"type": "PERSON"
			},
			{
				"name": "delay",
				"salience": 0.00016562542,
				"type": "EVENT"
			},
			{
				"name": "email correspondence",
				"salience": 0.00016562542,
				"type": "OTHER"
			},
			{
				"name": "occasion",
				"salience": 0.00016562542,
				"type": "EVENT"
			},
			{
				"name": "lightning bolt",
				"salience": 0.00016562542,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "co-editor",
				"salience": 0.00016562542,
				"type": "PERSON"
			},
			{
				"name": "fruition",
				"salience": 0.00016562542,
				"type": "OTHER"
			},
			{
				"name": "military capabilities",
				"salience": 0.00016562542,
				"type": "OTHER"
			},
			{
				"name": "embargo",
				"salience": 0.00016562542,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.00016562542,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00016562542,
				"type": "OTHER"
			},
			{
				"name": "writer",
				"salience": 0.00016562542,
				"type": "PERSON"
			},
			{
				"name": "ambassador",
				"salience": 0.00016562542,
				"type": "PERSON"
			},
			{
				"name": "bunkers",
				"salience": 0.00016562542,
				"type": "OTHER"
			},
			{
				"name": "witness",
				"salience": 0.00016562542,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00016562542,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition",
				"salience": 0.00016427162,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00016369818,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.00016304282,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.00016231429,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.0001605471,
				"type": "PERSON"
			},
			{
				"name": "indifference",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00015944059,
				"type": "PERSON"
			},
			{
				"name": "reverence",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "stratagems",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "legislations",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "dynamics",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "praxis",
				"salience": 0.00015944059,
				"type": "PERSON"
			},
			{
				"name": "diktat",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "readiness",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"name": "hostility",
				"salience": 0.00015944059,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/038_64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_F._Knowland"
				},
				"name": "William Knowland",
				"salience": 0.00015858916,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.00015840332,
				"type": "ORGANIZATION"
			},
			{
				"name": "nationalities",
				"salience": 0.00015758531,
				"type": "OTHER"
			},
			{
				"name": "discussions",
				"salience": 0.00015758531,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.00015625774,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00015614393,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00015614393,
				"type": "OTHER"
			},
			{
				"name": "talking heads",
				"salience": 0.00015614393,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00015614393,
				"type": "OTHER"
			},
			{
				"name": "antisemitism",
				"salience": 0.00015614393,
				"type": "OTHER"
			},
			{
				"name": "convictions",
				"salience": 0.00015614393,
				"type": "OTHER"
			},
			{
				"name": "inside",
				"salience": 0.00015614393,
				"type": "OTHER"
			},
			{
				"name": "Franklyn D. Roosevelt",
				"salience": 0.00015502439,
				"type": "PERSON"
			},
			{
				"name": "Zionist",
				"salience": 0.00015335127,
				"type": "OTHER"
			},
			{
				"name": "Zionists",
				"salience": 0.00015335127,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.00015248815,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00015234308,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.00015031314,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.00014918874,
				"type": "OTHER"
			},
			{
				"name": "expertise",
				"salience": 0.00014918874,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.00014918874,
				"type": "OTHER"
			},
			{
				"name": "COMMENT",
				"salience": 0.00014918874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "characterization",
				"salience": 0.00014918874,
				"type": "OTHER"
			},
			{
				"name": "commentaries",
				"salience": 0.00014918874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "diplomacy",
				"salience": 0.0001485221,
				"type": "OTHER"
			},
			{
				"name": "origins",
				"salience": 0.00014589257,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09f6v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anglo-Saxons"
				},
				"name": "Anglo-Saxon",
				"salience": 0.00014539175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027nyjc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine:_Peace_Not_Apartheid"
				},
				"name": "Palestine: Peace not Apartheid",
				"salience": 0.00014539175,
				"type": "OTHER"
			},
			{
				"name": "greenlight",
				"salience": 0.00014470007,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.00014223758,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.00014223758,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.00014107494,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.00014107494,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00014044456,
				"type": "OTHER"
			},
			{
				"name": "roots",
				"salience": 0.00014044456,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.00014001965,
				"type": "OTHER"
			},
			{
				"name": "corporation",
				"salience": 0.00013983325,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.00013983325,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.00013983325,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.00013983325,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.00013829784,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.00013764089,
				"type": "OTHER"
			},
			{
				"name": "The Arabists: The Romance of an American Elite",
				"salience": 0.00013586206,
				"type": "WORK_OF_ART"
			},
			{
				"name": "favor",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "uproar",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "generals",
				"salience": 0.00013519998,
				"type": "PERSON"
			},
			{
				"name": "standard",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "minutia",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "mass",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "fields",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "tirade",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "fashion",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "Whining",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00013519998,
				"type": "EVENT"
			},
			{
				"name": "blood",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "rebuttal",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "grip",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "journalism",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "proverbial nail",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "breath",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "tactic",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "denomination",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "spectrum",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.00013519998,
				"type": "WORK_OF_ART"
			},
			{
				"name": "retrospect",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "debts",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "loan guaranties",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "laureate hero",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "adversaries",
				"salience": 0.00013519998,
				"type": "ORGANIZATION"
			},
			{
				"name": "details",
				"salience": 0.00013519998,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.00013479093,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00013474273,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.00013181285,
				"type": "LOCATION"
			},
			{
				"name": "subject",
				"salience": 0.00013123911,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00013123911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00013037772,
				"type": "LOCATION"
			},
			{
				"name": "anti-Iraq",
				"salience": 0.00013037772,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00013025738,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00012918147,
				"type": "OTHER"
			},
			{
				"name": "truths",
				"salience": 0.00012917764,
				"type": "OTHER"
			},
			{
				"name": "dialogs",
				"salience": 0.00012917764,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00012917764,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.00012917764,
				"type": "EVENT"
			},
			{
				"name": "perception",
				"salience": 0.00012917764,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00012874075,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00012874075,
				"type": "WORK_OF_ART"
			},
			{
				"name": "politicians",
				"salience": 0.00012874075,
				"type": "PERSON"
			},
			{
				"name": "settler state",
				"salience": 0.00012874075,
				"type": "ORGANIZATION"
			},
			{
				"name": "policies",
				"salience": 0.00012874075,
				"type": "OTHER"
			},
			{
				"name": "Territory",
				"salience": 0.00012821134,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00012590457,
				"type": "LOCATION"
			},
			{
				"name": "Part",
				"salience": 0.00012547261,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.00012547261,
				"type": "OTHER"
			},
			{
				"name": "media campaigns",
				"salience": 0.00012529102,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.00012529102,
				"type": "OTHER"
			},
			{
				"name": "myth",
				"salience": 0.00012426688,
				"type": "OTHER"
			},
			{
				"name": "nonissue",
				"salience": 0.00012426688,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.00012270038,
				"type": "OTHER"
			},
			{
				"name": "following",
				"salience": 0.00012270038,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.00012123835,
				"type": "OTHER"
			},
			{
				"name": "Territory",
				"salience": 0.000120331424,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.000120331424,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.000120331424,
				"type": "LOCATION"
			},
			{
				"name": "point",
				"salience": 0.000120331424,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.000120331424,
				"type": "LOCATION"
			},
			{
				"name": "wars",
				"salience": 0.000120331424,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.000120331424,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0220q6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Illinois_at_Urbana%E2%80%93Champaign"
				},
				"name": "University of Illinois",
				"salience": 0.0001177129,
				"type": "ORGANIZATION"
			},
			{
				"name": "Glaspie",
				"salience": 0.0001177129,
				"type": "PERSON"
			},
			{
				"name": "College of Law",
				"salience": 0.0001177129,
				"type": "ORGANIZATION"
			},
			{
				"name": "pawns",
				"salience": 0.00011759057,
				"type": "PERSON"
			},
			{
				"name": "boundaries",
				"salience": 0.00011662939,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00011662939,
				"type": "OTHER"
			},
			{
				"name": "boundaries",
				"salience": 0.00011662939,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.00011662939,
				"type": "PERSON"
			},
			{
				"name": "news planners",
				"salience": 0.00011662939,
				"type": "PERSON"
			},
			{
				"name": "essence",
				"salience": 0.00011662939,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00011662939,
				"type": "OTHER"
			},
			{
				"name": "essence",
				"salience": 0.00011662939,
				"type": "OTHER"
			},
			{
				"name": "analyses",
				"salience": 0.00011662939,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00011662939,
				"type": "OTHER"
			},
			{
				"name": "charlatan",
				"salience": 0.00011575694,
				"type": "OTHER"
			},
			{
				"name": "Discussion",
				"salience": 0.000114757146,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.000114757146,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.000114757146,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.000114757146,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.00011379035,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.00011177238,
				"type": "WORK_OF_ART"
			},
			{
				"name": "objective",
				"salience": 0.00011143421,
				"type": "OTHER"
			},
			{
				"name": "stakes",
				"salience": 0.00011036338,
				"type": "OTHER"
			},
			{
				"name": "grounds",
				"salience": 0.00010964536,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.00010964536,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.00010964536,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.00010964536,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00010946127,
				"type": "OTHER"
			},
			{
				"name": "characterization",
				"salience": 0.00010864244,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00010864244,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.00010864244,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.000108497814,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rationales",
				"salience": 0.000108156964,
				"type": "OTHER"
			},
			{
				"name": "technique",
				"salience": 0.00010759843,
				"type": "OTHER"
			},
			{
				"name": "war mania",
				"salience": 0.00010759843,
				"type": "OTHER"
			},
			{
				"name": "mechanism",
				"salience": 0.00010759843,
				"type": "OTHER"
			},
			{
				"name": "farce",
				"salience": 0.00010759843,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antisemitism"
				},
				"name": "anti-Jewish",
				"salience": 0.00010642693,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00010624205,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0304b9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Augusta_National_Golf_Club"
				},
				"name": "Amen Corner",
				"salience": 0.00010556631,
				"type": "WORK_OF_ART"
			},
			{
				"name": "drums",
				"salience": 0.000104902756,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.00010411802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.00010192351,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g5rg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Binghamton,_New_York"
				},
				"name": "Binghamton",
				"salience": 0.00010192351,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/047yc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kuwait"
				},
				"name": "Kuwaiti",
				"salience": 0.00010192351,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.00010150954,
				"type": "EVENT"
			},
			{
				"name": "neutrality",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.00010098533,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "exclusion",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "astonishment",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.00010098533,
				"type": "EVENT"
			},
			{
				"name": "circumlocutions",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "news delivery",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "Psychology",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "indoctrination",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "appearance",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "manners",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00010098533,
				"type": "OTHER"
			},
			{
				"name": "presenters",
				"salience": 0.00010064378,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00010064378,
				"type": "PERSON"
			},
			{
				"name": "The Israeli Lobby",
				"salience": 0.00009981603,
				"type": "ORGANIZATION"
			},
			{
				"name": "subject",
				"salience": 0.00009927828,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f_tp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Suez_Crisis"
				},
				"name": "Suez War",
				"salience": 0.00009876961,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.00009859802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0126dc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Perfect_fifth"
				},
				"name": "Fifth",
				"salience": 0.000098117336,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.000098117336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06nxt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Second"
				},
				"name": "Second",
				"salience": 0.000098117336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.000098117336,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01sdzg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Third_baseman"
				},
				"name": "Third",
				"salience": 0.000098117336,
				"type": "ORGANIZATION"
			},
			{
				"name": "Amen corners",
				"salience": 0.00009729347,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.00009729347,
				"type": "OTHER"
			},
			{
				"name": "Amen corner",
				"salience": 0.00009729347,
				"type": "OTHER"
			},
			{
				"name": "amen corner",
				"salience": 0.00009729347,
				"type": "OTHER"
			},
			{
				"name": "amen corner",
				"salience": 0.00009729347,
				"type": "LOCATION"
			},
			{
				"name": "amen corner",
				"salience": 0.00009729347,
				"type": "LOCATION"
			},
			{
				"name": "group controls",
				"salience": 0.000095364194,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.00009527065,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.00009520407,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.000094778654,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italics",
				"salience": 0.00009452145,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.000094069655,
				"type": "OTHER"
			},
			{
				"name": "deception",
				"salience": 0.000094069655,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.00009371951,
				"type": "ORGANIZATION"
			},
			{
				"name": "world agenda",
				"salience": 0.00009371951,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00009371951,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00009371951,
				"type": "OTHER"
			},
			{
				"name": "superstition",
				"salience": 0.0000928189,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0000928189,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.00009092606,
				"type": "LOCATION"
			},
			{
				"name": "The McLaughlin Group",
				"salience": 0.0000903345,
				"type": "ORGANIZATION"
			},
			{
				"name": "territory",
				"salience": 0.00008987933,
				"type": "LOCATION"
			},
			{
				"name": "wars",
				"salience": 0.00008987933,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00008941518,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0000887463,
				"type": "OTHER"
			},
			{
				"name": "sympathies",
				"salience": 0.00008711412,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00008607864,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00008607864,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.000085715656,
				"type": "OTHER"
			},
			{
				"name": "patterns",
				"salience": 0.000085715656,
				"type": "OTHER"
			},
			{
				"name": "patterns",
				"salience": 0.000085715656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02zh41",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PBS_NewsHour"
				},
				"name": "The Macneil/Lehrer NewsHour",
				"salience": 0.00008559138,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lies",
				"salience": 0.00008493161,
				"type": "OTHER"
			},
			{
				"name": "MIND",
				"salience": 0.00008493161,
				"type": "OTHER"
			},
			{
				"name": "accusation",
				"salience": 0.00008493161,
				"type": "OTHER"
			},
			{
				"name": "envy",
				"salience": 0.00008493161,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.00008493161,
				"type": "OTHER"
			},
			{
				"name": "d",
				"salience": 0.00008493161,
				"type": "PERSON"
			},
			{
				"name": "perspicacity",
				"salience": 0.00008493161,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ddggn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington_Report_on_Middle_East_Affairs"
				},
				"name": "Washington Report on Middle East Affairs",
				"salience": 0.000082755294,
				"type": "WORK_OF_ART"
			},
			{
				"name": "program",
				"salience": 0.00008175994,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.000081394595,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.000081148326,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.000081148326,
				"type": "ORGANIZATION"
			},
			{
				"name": "imperialism",
				"salience": 0.000081148326,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.000081148326,
				"type": "OTHER"
			},
			{
				"name": "nonissue",
				"salience": 0.00008072926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01p06z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_Times"
				},
				"name": "Los Angeles Times",
				"salience": 0.0000772134,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporations",
				"salience": 0.00007605942,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporations",
				"salience": 0.00007605942,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporations",
				"salience": 0.00007605942,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.00007605942,
				"type": "OTHER"
			},
			{
				"name": "paradigm",
				"salience": 0.00007447805,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.00007386925,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00007353916,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anyone",
				"salience": 0.00007353916,
				"type": "PERSON"
			},
			{
				"name": "exchange",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "demagogy",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "city folks",
				"salience": 0.00007353916,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.00007353916,
				"type": "LOCATION"
			},
			{
				"name": "hand",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.00007353916,
				"type": "LOCATION"
			},
			{
				"name": "substance",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "shops",
				"salience": 0.00007353916,
				"type": "LOCATION"
			},
			{
				"name": "wall",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "drawing",
				"salience": 0.00007353916,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.00007353916,
				"type": "PERSON"
			},
			{
				"name": "Myth of Jewish Control",
				"salience": 0.00007177133,
				"type": "OTHER"
			},
			{
				"name": "implication",
				"salience": 0.000070792914,
				"type": "OTHER"
			},
			{
				"name": "assumption",
				"salience": 0.000070792914,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.00007026333,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00007026333,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00007026333,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.00006932909,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ks3n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Foster_Dulles"
				},
				"name": "John Foster Dulles",
				"salience": 0.00006883199,
				"type": "PERSON"
			},
			{
				"name": "post",
				"salience": 0.00006343779,
				"type": "OTHER"
			},
			{
				"name": "tax money",
				"salience": 0.00006343779,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.00006343779,
				"type": "WORK_OF_ART"
			},
			{
				"name": "program",
				"salience": 0.00006343779,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00006343779,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ddfh7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taylor_%26_Francis"
				},
				"name": "Frank Cass Publishers",
				"salience": 0.000062663545,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0q442",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Defamation_League"
				},
				"name": "Anti-Defamation League",
				"salience": 0.00006214409,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Deadliest Lies",
				"salience": 0.00006214409,
				"type": "WORK_OF_ART"
			},
			{
				"name": "say",
				"salience": 0.000059272694,
				"type": "OTHER"
			},
			{
				"name": "decision maker",
				"salience": 0.000058525482,
				"type": "ORGANIZATION"
			},
			{
				"name": "superstition",
				"salience": 0.00005659278,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "appointees",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "anchor",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "puppets",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "yoke",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "republic",
				"salience": 0.00005492836,
				"type": "LOCATION"
			},
			{
				"name": "trustees",
				"salience": 0.00005492836,
				"type": "PERSON"
			},
			{
				"name": "atheist",
				"salience": 0.00005492836,
				"type": "PERSON"
			},
			{
				"name": "board",
				"salience": 0.00005492836,
				"type": "ORGANIZATION"
			},
			{
				"name": "type",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "branches",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "monopoly",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "duration",
				"salience": 0.00005492836,
				"type": "OTHER"
			},
			{
				"name": "inconsistency",
				"salience": 0.000052877094,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Capitol Hill",
				"salience": 0.000052264822,
				"type": "LOCATION"
			},
			{
				"name": "Capitol Hills",
				"salience": 0.000052264822,
				"type": "LOCATION"
			},
			{
				"name": "The 1956 War: Collusion and Rivalry",
				"salience": 0.000052264822,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0dwc2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dialectic"
				},
				"name": "Dialectically",
				"salience": 0.0000503482,
				"type": "EVENT"
			},
			{
				"name": "someone",
				"salience": 0.000045613804,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00004525408,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptian",
				"salience": 0.00004525408,
				"type": "LOCATION"
			},
			{
				"name": "David Tal",
				"salience": 0.00004525408,
				"type": "PERSON"
			},
			{
				"name": "MondoWeiss Website",
				"salience": 0.00004525408,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00004525408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0430_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jerusalem"
				},
				"name": "Jerusalem",
				"salience": 0.00004525408,
				"type": "LOCATION"
			},
			{
				"name": "pro-Zionist",
				"salience": 0.00004525408,
				"type": "PERSON"
			},
			{
				"name": "palm",
				"salience": 0.00003850569,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.00003380135,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Israel_America_aeee7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-11T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 70,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.003",
		"text": "Part 1: Introduction 10 Shares\n9 0 0 1\nFor the last 30 years, I have witnessed and experienced the severe restraints on any free and balanced discussion of the facts. This reluctance to criticize any policies of the Israeli government is because of the extraordinary lobbying efforts of the American-Israel Political Action Committee and the absence of any significant contrary voices.\n— Former U.S. President Jimmy Carter [1]\nHow the Interviews Came About\nThe Marxian thesis that the dominant culture and ideology of a society (here referred to as Social Base or just Base) are those of the dominant class (here referred to as System) is a sharp tool to probe how political systems work and how they stay in power. Does this tool work in the U.S. model? Certainly, , the relation between the System and its Social Base has been regular since the inception of the thirteen colonies. Because of that sustained regularity, System and Base acted in convergent patterns of dependency. In historical perspective, it was not possible for the System to transform those colonies into states, and thereafter expand its conquests to form a continental empire without a solid social base that shared its purpose and visions for expansion. From that time onward, an ideological symbiosis ran between the System and the Base. Not only that, but each time the System modifies direction, philosophy, or ideology, the Base would adapt by modifying its attitudes and perception.\nThe patterns of ideological association between the U.S. System and its Social Base extended into modern times, and the yardstick to measure them is the presidential elections. If you look at voters' turnout since 1960 , you will notice that a relative-to-large majority of Americans had voted in those elections. My interpretation of the vote in relation to Marx's thesis is the following. Voting for a system that is known for its aggressive imperialist policies, crimes around the world, overthrowing foreign governments not in line with Washington, and countless military interventions and invasions that left millions of people dead means one thing: Voting for that system while knowing its attributes, policies, and actions amounts to active sharing in its ideology, culture, and violence.\nMORE... Zionism is Racism Zionism goes from bad to worse, taking Judaism with it How modern is Israel? Green Party of Canada calls to revoke Jewish National Fund charitable status Caveat! That does not necessarily mean that all voters share the System's imperialistic values of violence and destruction of foreign peoples. The pertinent meaning of voting interpreted in relation to the System's foreign policy objectives versus the objectives of the Base resides in two concepts. Discarding immediately the notion that the Base has been cohabitated by the system, the first concept has it that the Base has given a mandate to the System to carry out its ideology of empire and imperialism based on the undeclared condition to spare the people from the horrors of foreign wars. A dichotomy sets in here. The System has its way of life, and the Base has its own. The second concept has to do with the basic tenets of colonialism. Meaning, if the System could be successful to obtain unspecified benefits through wars, then the base could share in these benefits despite aversion to violence and opposition to the institution of war as a means to resolve problems between nations.\n A question: Would abstaining from voting resolve the issue of \"active sharing\" in the policies of the system? This subject is open for debate . . .\nThe relation between the American System and its Base was uniform up to a certain point in history (late 1920s). Until that point, the American state was still busy completing its structural transformation into a big power status. That uniformity, however, managed to keep the patterns of the political power unchanged. To be exact, despite persistent immigration that should have altered the relations between the Base and government, as well as the composition of the latter, the dominance of the traditional ruling elites was 1) not open for challenge, and 2) shaped by an exclusive American Anglo-Saxon experience.\nBut when Franklyn D. Roosevelt showed signs of surrender to the Zionist pressure on the issue of establishing a \"Jewish\" state in Palestine, he opened a large crack in the System. That was the first time in U.S. history where the powerful American imperialist state yielded to a foreign ideology that was not part of its basic project. With that, a movement with a limited religious social base began penetrating the files and ranks of the U.S. power. The rest is history. As a result, the unrelenting entrenchment inside the political structures of the United States coupled with accumulated changes in the configuration of the U.S. power, the dominant American System itself fell under the domination of one of its social factions—American Jewish Zionists.\nWhen Franklyn D. Roosevelt showed signs of surrender to the Zionist pressure on the issue of establishing a \"Jewish\" state in Palestine, he opened a large crack in the System.\nAs a group, American Jewish Zionists have all attributes of an independent establishment. They possess efficient organizational structures, have a monolithic political presence across the American system, and they know how to finance their activities with U.S. tax money. I must note that their alignment with the global agenda of U.S. imperialism is a two-point expedient. The first is focused on being recognized as earnest operators at the service of America's interests. The second is tactical. To reap, on behalf of Israel, the benefits of alignment with slogans such as \"Israel is our only trusted ally in the Middle East\".\nThe American Jewish Zionist experience is agenda driven. As such, their domestic and foreign agendas have precedence over any other Jewish-related consideration.\nOn the domestic front, the focus could not be more evident: to consolidate Zionism and turn it into a means to 1) perpetuate Israel as an American national issue, and 2) make of them the principal factor in defining American politics. You can notice the endeavor clearly during U.S. elections when the Zionist media question whether this or that candidate is good for the Jews, and for Israel. Today, voicing dissent against the policies of American Jewish Zionism or criticizing Israel amounts to crime. Jimmy Carter experienced this firsthand. When he published his book: Palestine: Peace not Apartheid , American Jewish Zionists unleashed the fire of hell upon him.\nAs for the Jewish Zionist foreign agenda, this is clear-cut and leaves no space for misunderstanding. It aims to induce, control, or lead the United States to 1) adopt hostile policies toward the Arab nations because due to their rejection of the Zionist state, and 2) undertake military actions against any country that appears as posing a potential or direct threat to Israel. Equally important, it demands that the United States keep denying the Palestinians rights for nationhood through American diplomacy. What is the rationale? Recognition of the Palestinian national rights means the invalidation of the Zionist state and its claim on Palestine.\nBecause the Jewish Zionist control of the U.S. System is real and dominant, how does the American society figure vis-à-vis this dominance? Based on observations of the American society and its multiple cultural and ideological patterns, there can be but one answer: Zionism is not the dominant culture and ideology of the American people. It is, however, the dominant culture and ideology of the U.S. political system.\nOBSERVATIONS\nFirst, despite gargantuan Zionist propaganda apparatuses directed to the American people, Jewish Zionists have consistently failed to create interest or sympathy for Zionist issues and for Israel,\nSecond, due to historically developed indifference to foreign issues, a majority of Americans have only vague ideas on what Zionism is,\nThird, to establish roots for their political dominance, Jewish Zionist activists invariably focus not on the American people, but on ways to control the American system from inside by controlling first the institutions that matter: White House and Congress.\nFourth, this control did not happen because of elections. It is preponderantly due to the practice of appointing Jewish Zionists to important positions inside the administrations,\nFifth, among the stratagems employed by Zionists when they run for elective offices, one was particularly effective: Take advantage of the reverence of the population for the idea of election. To do that, Jewish Zionist candidates rarely, if ever, talk about Israel or Zionism. Instead, they only debate matters of interest to the voters. Once elected though, promoting Israel via American legislations becomes the top hidden agenda,\nSixth, and to conclude this particular argument, the fact that one administration after another succumbed to the diktat of Jewish Zionists (thus indirectly to Israel) in matters of foreign policy and wars proves that the culture and praxis of those administrations are those of the dominant ideology and culture—Zionism.\nAnother point to discuss is the expansion of the Jewish Zionist power. By all accounts, such an expansion is not a phenomenon but an incremental process. In his book, The Arabists: The Romance of an American Elite , Robert D. Kaplan defined the issue that I framed as a process in terms of gradual replacement of traditional diplomatic elites with new ideological elites that had no interest in the ways of the old school of diplomacy. Kaplan was unambiguous. He called these new elites by their names: Irish-Americans and Jewish-Americans.\nKaplan's viewpoint on this replacement is important to our discussion. He argued that the old elites approached the U.S.-Arab relations with an open mind and readiness for dialog, all while keeping an eye on the U.S. imperialist interests. His argument opens the door for a veritable conclusion. The two groups of post-WWII American society that Kaplan mentioned had in fact changed the dynamics of U.S. foreign policy. (It is public knowledge that both groups are known for their hostility toward Arabs and Muslims—each for his own set of religious, political, and ideological rationales.). As for the successive shares of African-Americans and Hispanics in the making of the national policy of the United States, this is another argument.\nAs a witness to history, in early 2012, I began drafting a comprehensive analysis on the role of American Jewish Zionists in the making of U.S. policies and wars in the Arab world. In May of that year, as my work became broad in scope, I decided to seek more views on the subject. I came up with the idea to conduct several interviews where I pose the same questions. While some of the prospective interviewees declined, and others accepted but then withdrew, three prominent thinkers acclaimed for their knowledge, scholarship, and outstanding political activism graciously gave me their views.\nThey are Francis Boyle, a professor of international law, University of Illinois, College of Law; James Petras, a professor emeritus, University of Binghamton, New York; Canadian writer and former co-editor of the online publication of Dissident Voice Kim Petersen. Professors Boyle and Petras answered my questions via phone conversations, and, Petersen via email correspondence.\nHowever, in the weeks following the interviews, my work swelled up to such a length that it became unsuitable for internet publishing. In short, I was unable to honor my commitment to publish the interviews as planned. Today, as I thank Prof. Francis Boyle, Prof. James Petras, and Kim Petersen for sharing their invaluable insight, I apologize to them for the delay in putting the interviews out there to read.\nINTRODUCTION\nThe turning point in the emergence of Jewish Zionism as a dominant American political force came about when Iraq invaded Kuwait. (Discussing the origins and strategic complications of that invasion goes beyond the scope of this introduction.) The Jewish Zionist establishment seized the occasion, mobilized its omnipresent propaganda operatives, and led colossal media campaigns to promote military actions against Iraq. To bring their war mania to fruition, they unleashed their \"experts\" in all directions. They talked about Iraq's \"formidable\" military capabilities and about Saddam's one-million-man standing army ready to invade Saudi Arabia and seize its oil. They told stories about Saddam Hussein's personal life, his bunkers, and his mortal \"nuclear threats\" to Israel. And they talked about Iraq's threats to U.S. interests and \"allies\" in the Middle East. . . . Here is a brief account of those events.\nOn July 25, 1990, Iraqi president Saddam Hussein met with U.S. ambassador to Iraq, April Glaspie. It is on record that Glaspie gave Hussein an unambiguous but indirect greenlight to resolve Iraq's problems with Kuwait militarily. On August 2, Iraq invaded Kuwait. On August 3, George H. W. Bush ordered the freezing of Iraqi and Kuwaiti assets and immediately placed Iraq under hermetic embargo. Considering the prompt, extraordinary anti-Iraq measures that the United States took in the first 24 hours of that invasion, one wonders what was pushing the U.S. to move so quickly on Iraq knowing that only two days earlier, this was conducting a U.S. proxy against Iran. The observation that the U.S. did not take similar actions when Iraq invaded Iran in 1980, or when Israel invaded Lebanon in 1982 raises many questions. What were the U.S. rationales in taking such measures? Who conceived them? Did the U.S. entrap Iraq? Why? . . .\nThe atmosphere that followed the invasion was surrealistic. Like a lightning bolt, U.S. imperialist and Zionist forces instantly mobilized their media, talking heads, retired generals, and bogus experts on the Middle East. The deafening uproar they made and all lies they told about atrocities committed by Iraq in Kuwait hid a definite scheme: Incite for war . In the period August 2, 1990 – January 14, 1991, Israelis and Jewish Zionists from all fields appeared en mass and in every possible medium available to urge the Bush regime to give up diplomacy in favor of war. On January 15, 1991, a 30-member \"coalition\" in which the U.S. had the lion share—ninety-seven percent of the total force—attacked Iraq. By every standard and minutia of details, the war on Iraq in 1991 was an American War .\nAt the end of a war that destroyed one of Israel's Arab adversaries, George H. W. Bush might have thought of himself as America's \"laureate hero\". He did not predict though that his temporary freezing of the U.S. loan guaranties to Israel, would have unleashed the Jewish Zionist establishment against him. The fact that he lost to Bill Clinton (who opposed Bush's freeze, and who stated that Israel was the \"only country that paid back its debts\") indicated that American Jewish Zionists had finally reached their objective: To perfect ways to control the U.S. politics from the inside . In retrospect, it can be said that George H. W. Bush was the last non-Zionist American president. From Bill Clinton forward, U.S. presidents and their vice president became pawns in the Jewish Zionist play of power.\nNow, as the United States was preparing for war with Iraq to \"liberate\" Kuwait, thousands of antiwar activists and intellectuals from a wide spectrum of political convictions spoke loudly against it. But no one could have ever beaten Patrick J. Buchanan's memorable words about how American Jewish Zionists and Israel were pushing for that war. He said, ''There are only two groups that are beating the drums for war in the Middle East - the Israeli Defense Ministry and its amen corner .'' [2] With that, Buchanan hit the proverbial nail on the head. A.M. Rosenthal, a ringleader of U.S. Zionist journalism could not bear what he heard. In a rebuttal, he unleashed an acerbic attack against Buchanan. His weapon of argument, so to speak, was the stale and trite accusation of \"antisemitism\".\nWhining, Rosenthal twisted Buchanan's clear words and went on to imply that Buchanan was in effect engaging in an \"anti-Jewish\" tirade. He re-interpreted Buchanan's words and cast them in a standard Zionistic fashion. He wrote that Buchanan's intention was ''The Jews are trying to drag us into war. Only Jews want war. Israeli Jews want war to save Israel's hide. American Jews who talk of military action against Iraq want war because it would suit Israeli interests. They are willing to spill American blood for Israeli interests.\" [3]\nBy inserting the word, \"Jew\" in his reply, Rosenthal and the New York Times behind him spat on the face of U.S. political reality under the tight grip of Zionism. We need not waste our breath on Rosenthal's petty tactic. His clear objective was to distract from the central issue, which is, Buchanan's opposition to the planned war against Iraq was unrelated to the religious denomination of those who were promoting it. Rather he was unmistakably referring to their political identity.\nStill, Buchanan was honest. He pointed the finger to Israel and its \"Amen corner\" because that was the truth. The fact that most Israelis and \"Amen corners\" happened to be of Jewish faith was nonissue. To conclude, it is evident that Buchanan, a dreamer of an American \"republic\" not \"empire\", could not stand by idle while seeing the United States sheepishly fastened to the yoke of Zionism and gutlessly prostrating before a tiny settler state, Israel.\nBuchanan did not stop there. Truthful and resolute, he dared to describe in categorical terms the pitiful condition of the U.S. Congress vis-à-vis Israel and American Jewish Zionists. He dubbed it as \"An Israeli-occupied territory\" [4]. Buchanan powerfully hit the target in such a way that countless cowardly American politicians would dare not think, let alone say. Notice that Buchanan had placed Israel before its U.S. \"amen corner\". I view this as a statement. He clearly implied that Israel is the primary decision maker. Did that also imply that U.S. Zionist groups (amen corner) are puppets moved by Israel? Most likely, if so, which has more power in setting the U.S. world agenda and policies: Israel or American Jewish Zionists? Dialectically, the answer should be Israel by means of its \"amen corner'.\nNow, in December 1991, Jim Lehrer (a former co-anchor of The Macneil/Lehrer NewsHour, and later sole anchor of The NewsHour with Jim Lehrer ) interviewed Pat Buchanan. It is important to mention, that Jim Lehrer has monopolized a significant position funded by federal tax money for over 30 years starting in 1975. Is that an issue? Yes, and to debate it, the following applies. Whenever a specific group of people, be they Christian, Muslim, Jewish, atheist, duopoly party apparatchiks, etc., keeps an important public post for such a long duration, the implication is unescapable: the group controls that post because of its embedded importance. . . . But more important, they have the power to keep it.\nNonetheless, when a specific group continues to hold, throughout time, important positions inside public corporations, agencies, and branches of the U.S. government, a paradigm emerges. Either the group controls said corporations directly—that is why it is able to do what they want. Or, it controls them indirectly by controlling first who appoints the board of trustees and sets corporate policies and appointees. At any rate, considering this type of control, the assumption that such group has power over the government and its public corporations is reasonable.\nAdditionally, the issue of monopoly of news is critical in another respect. It means that someone within the context of U.S. imperialism has decided that the U.S. public discourse must conform to predetermined patterns. In these patterns, issues such as Israel, Zionism, Palestine, U.S. imperialism in the Middle East, wars, etc., are designed to move only on linear grounds without ever touching the core of the matter.\nBefore continuing, I must state that Lehrer's political views are not a subject to discuss vis-à-vis his program. For one, the NewsHour program is not about the personal views of presenters—it is about information prepared for the public from a public corporation. Second, whether Lehrer had sympathies for Israel or Zionism is nonissue because most viewers expect neutral discussions regardless of who delivers them. Nevertheless, a situation such as this has a consequence affecting the special relations between the narrated news/comments, the people who deliver them, and the people who hear them.\nFirstly, planning news delivery to attain specific results is a good technique for those in the business of indoctrination. Psychology and perception are the areas of expertise that news planners depend on to disseminate certain news and analyses. To be sure, these planners know that most viewers have no special or personal stakes on events happening in other countries. Still, the immediate consequence that controlled news and commentaries could generate is easy to predict. They also know they can seep to the viewers pre-conceived ideas through pleasant dialogs, affable manners, appearance of neutrality, and clever circumlocutions.\nTo be fair to Lehrer, he was consistent in making intelligent questions. However, he was also consistent at doing something else. He would calibrate his questions in such a way as not to reveal new truths or solicit critical replies that could go beyond boundaries deliberately conceived so as not to be crossed. It is pragmatic to say that the observance of these boundaries would nicely serve the Zionist and imperialist discourse. In essence, a practice thusly followed is a preemptive mechanism of control cloaked as a professional presentation.\nNow, in his interview, Lehrer played dumb when he asked Buchanan about his bold characterization of the Congress. He phrased his question as follows, \"You have also said that Congress is an Israeli-occupied territory. Now, what do you mean by that ?\" [Italics are mine]\nCOMMENT: Semantically as much as politically, Buchanan's figure of speech was terse and unequivocal. He plainly meant that the Congress observes Israel's agenda and acts accordingly. There was no need for Buchanan to say anything further because what he said had (and still has) basis in verifiable facts. With a question such as, \"what do you mean by that\" Lehrer was not seeking a rational reply from Buchanan. The form and content of the question had the objective of wanting to entrap Buchanan, make him retract, or at least contradict himself to show inconsistency. In essence, Lehrer had simply tried to deny that Israel controls the Congress through its \"amen corner\" because his \"what do you mean\" indicated astonishment rather than request for explanation. [5]\nTo wrap up the issue, without exclusion, any denial of the Jewish Zionist control of the United States is a farce. Take Abraham H. Foxman of the infamous Anti-Defamation League as an example. Foxman authored a master‑deceptive propaganda book that he called, \" The Deadliest Lies : The Israeli Lobby and the Myth of Jewish Control. [Italics are mine]. First, Foxman lied. He knew very well that the Jewish [Zionist] control is not a myth but a pervasive reality. Second, but most important, the problem is not the abstract \"Jewish control\" but the specific—Jewish Zionist control. This can be explained using a current universal truth: hundreds of thousands of Jews from all nationalities actively oppose Zionism on political, religious, ethical, historical, and ideological grounds.\nFoxman's denial means one of two things. Either he is a parochial charlatan when the subject is the undisputed power of American Jewish Zionism, or he is very ignorant of the history of Zionism , which is impossible. Either way, Foxman's business is propaganda, demagogy, and deception. Incidentally, Foxman's denial looks very similar to what some Arabs do in the Middle East. Villagers—but even some city folks—try to fend off \"envy\" by following an eon-old superstition. They fix a drawing on a wall in their shops or homes showing the palm of an open hand with an open eye in its center. It appears that Foxman and his associates have their own superstition. By decrying the \"deadliest lies\" against American Jewish Zionists, they try to fend off the accusation or the \"envy\" that Jews—specifically, Jewish Zionists—have power and influence.\nOf substance, did Foxman not learn or did anyone inform him about what John Foster Dulles told William Knowland (a pro-Zionist senator from California) back in February 1957? In an exchange about the proposed sanctions to get Israel out of Egyptian territory occupied by Israel in the Suez War, Dulles pronounced these prophetic words, \"We cannot have all our policies made in Jerusalem . . .\" [6]. That was in 1957. Today, all those who deride or deny the charge that Israel has a say on U.S. foreign policy and wars in the Middle East must prove that those who are making this charge are misinformed or just lying.\nInterestingly, years after Buchanan made that statement, the successive events proved his sharp assessment and political perspicacity. Two people vindicated his characterization of Capitol Hills as an Israeli-occupied territory\" and both used his words to make the point. The first is a former CIA officer Philip Giraldi, and the second is Philip Weiss, founder of MondoWeiss Website. In an article he wrote in 2011, Giraldi pointed to the Congress as, \" It’s Still Occupied Territory \". Weiss titled a piece he wrote in 2015 as such: \" Capitol Hill — still Israeli-occupied territory \".\nAt this point, do American Jewish Zionists control the United States? Do they control it as polity or only the political system? Do they have real influence in setting U.S. foreign policy and wars against the Arab and Muslim nations? Or maybe all this talk is no more than baseless allegations?\nNEXT\nPart 2: Discussion\nPart 3: Interview with Francis Boyle\nPart 4: Interview with James Petras\nPart 5: Interview with Kim Petersen\nNOTES\nJimmy carter, Speaking frankly about Israel and Palestine , Los Angeles Times, 8 December 2006 Pat Buchanan, The McLaughlin Group, Aug 26, 1990, Quote: d in the Washington Report on Middle East Affairs, What They Said: Israel and Its \"Amen Corner\" , February 1992 ON MY MIND; Forgive Them Not , The New York Times, 14 September 1990 Quote: d in the Washington Report on Middle East Affairs, Is Congress an Israeli-Occupied Territory ?, July 1995 The Washington Report on Middle East Affairs, What They Said: Israel and Its \"Amen Corner\" , Feb. 1992 David Tal, editor, The 1956 War: Collusion and Rivalry in the Middle East, Frank Cass Publishers, 2001, p. 40",
		"thread_title": "Readings in the Jewish Zionist Control of the United States: Interviews with Francis Boyle, James Petras, Kim Petersen",
		"title": "Readings in the Jewish Zionist Control of the United States: Interviews with Francis Boyle, James Petras, Kim Petersen",
		"type": "bs",
		"uuid": "c6c921415e268d9d1e5553dec6fbbc2f3b9ad179"
	},
	"-KhIbThJWQQ-QSMLM9xV": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-11T16:43:30.197+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.13399297,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.090239115,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.05506203,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attacks",
				"salience": 0.050388727,
				"type": "EVENT"
			},
			{
				"name": "spies",
				"salience": 0.046026986,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.033470593,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.02236311,
				"type": "OTHER"
			},
			{
				"name": "boys",
				"salience": 0.02099561,
				"type": "PERSON"
			},
			{
				"name": "government ally",
				"salience": 0.020472199,
				"type": "OTHER"
			},
			{
				"name": "film",
				"salience": 0.020472199,
				"type": "WORK_OF_ART"
			},
			{
				"name": "violence",
				"salience": 0.01946401,
				"type": "OTHER"
			},
			{
				"name": "Prisoners",
				"salience": 0.016829867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.016132217,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.015543198,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.014676753,
				"type": "WORK_OF_ART"
			},
			{
				"name": "child rants",
				"salience": 0.012743778,
				"type": "OTHER"
			},
			{
				"name": "Repent",
				"salience": 0.012622087,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.012434733,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sf4r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Nicholson_(East_India_Company_officer)"
				},
				"name": "John Nicholson",
				"salience": 0.012066459,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.011967559,
				"type": "OTHER"
			},
			{
				"name": "captives",
				"salience": 0.011962773,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.011230059,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.0101311095,
				"type": "LOCATION"
			},
			{
				"name": "Foil ISIS",
				"salience": 0.01010053,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.009887866,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07yld3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J%C3%A1n_Kubi%C5%A1"
				},
				"name": "Jan Kubis",
				"salience": 0.00979835,
				"type": "PERSON"
			},
			{
				"name": "terrorist channels",
				"salience": 0.008447976,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.008447976,
				"type": "LOCATION"
			},
			{
				"name": "caliphate",
				"salience": 0.007895279,
				"type": "OTHER"
			},
			{
				"name": "cubs",
				"salience": 0.007538077,
				"type": "OTHER"
			},
			{
				"name": "spies",
				"salience": 0.006842278,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.00658716,
				"type": "LOCATION"
			},
			{
				"name": "scene",
				"salience": 0.0059257657,
				"type": "OTHER"
			},
			{
				"name": "youngster",
				"salience": 0.0059257657,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.0059257657,
				"type": "EVENT"
			},
			{
				"name": "camera",
				"salience": 0.0059257657,
				"type": "OTHER"
			},
			{
				"name": "hand guns",
				"salience": 0.0059257657,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "military outfits",
				"salience": 0.0059257657,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.0059257657,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0059257657,
				"type": "OTHER"
			},
			{
				"name": "location",
				"salience": 0.005704773,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.005586969,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.005586969,
				"type": "PERSON"
			},
			{
				"name": "dog",
				"salience": 0.005586969,
				"type": "OTHER"
			},
			{
				"name": "Al-Mahlabiyyah",
				"salience": 0.0052027046,
				"type": "PERSON"
			},
			{
				"name": "Wilayat al-Jazirah",
				"salience": 0.0052027046,
				"type": "PERSON"
			},
			{
				"name": "Tal 'Afar",
				"salience": 0.0052027046,
				"type": "ORGANIZATION"
			},
			{
				"name": "Al-'Ayadiyyah",
				"salience": 0.0052027046,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ptmv3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Ba'aj"
				},
				"name": "Al-Ba'aj",
				"salience": 0.0052027046,
				"type": "LOCATION"
			},
			{
				"name": "caliphate",
				"salience": 0.0050040265,
				"type": "OTHER"
			},
			{
				"name": "child soldiers",
				"salience": 0.004838405,
				"type": "PERSON"
			},
			{
				"name": "opium revenue",
				"salience": 0.004838405,
				"type": "OTHER"
			},
			{
				"name": "heroin",
				"salience": 0.004838405,
				"type": "OTHER"
			},
			{
				"name": "ISIS poppy fields",
				"salience": 0.004838405,
				"type": "LOCATION"
			},
			{
				"name": "radio",
				"salience": 0.004838405,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.0046788026,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.0044841557,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0041744527,
				"type": "LOCATION"
			},
			{
				"name": "acronym",
				"salience": 0.0039503793,
				"type": "OTHER"
			},
			{
				"name": "Terror Attacks",
				"salience": 0.0038096,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.003691666,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0036485326,
				"type": "LOCATION"
			},
			{
				"name": "caliphate",
				"salience": 0.0036451675,
				"type": "OTHER"
			},
			{
				"name": "Khorasan Caliphate",
				"salience": 0.0036326644,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0036149763,
				"type": "ORGANIZATION"
			},
			{
				"name": "Wardiyyah",
				"salience": 0.003512393,
				"type": "PERSON"
			},
			{
				"name": "Sanuni",
				"salience": 0.003512393,
				"type": "PERSON"
			},
			{
				"name": "Khana Sor",
				"salience": 0.003512393,
				"type": "PERSON"
			},
			{
				"name": "Ibrat al-Saghira",
				"salience": 0.003512393,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0119qy69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Names_of_God_in_Islam"
				},
				"name": "Al-Badi",
				"salience": 0.003512393,
				"type": "PERSON"
			},
			{
				"name": "Al-Qanat",
				"salience": 0.003512393,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b8smr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sinjar"
				},
				"name": "Sinjar",
				"salience": 0.003512393,
				"type": "LOCATION"
			},
			{
				"name": "efforts",
				"salience": 0.003480088,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0033837673,
				"type": "ORGANIZATION"
			},
			{
				"name": "liberation operation",
				"salience": 0.0030407,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0030407,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "gov",
				"salience": 0.0029787337,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0029787337,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0029787337,
				"type": "LOCATION"
			},
			{
				"name": "'t",
				"salience": 0.0029787337,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.002890348,
				"type": "LOCATION"
			},
			{
				"name": "Agugust ISIS",
				"salience": 0.0027645493,
				"type": "OTHER"
			},
			{
				"name": "memebers",
				"salience": 0.002633076,
				"type": "PERSON"
			},
			{
				"name": "casualties",
				"salience": 0.002633076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cdcwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraqi_security_forces"
				},
				"name": "Iraqi Security Forces",
				"salience": 0.0025698156,
				"type": "ORGANIZATION"
			},
			{
				"name": "video",
				"salience": 0.002523776,
				"type": "WORK_OF_ART"
			},
			{
				"name": "children",
				"salience": 0.002515852,
				"type": "PERSON"
			},
			{
				"name": "dog",
				"salience": 0.002271583,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.002271583,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.0022252821,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03m_n0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peshmerga"
				},
				"name": "Peshmerga",
				"salience": 0.0022252821,
				"type": "ORGANIZATION"
			},
			{
				"name": "disbelievers",
				"salience": 0.0019670143,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0019670143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vnr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Security_Council"
				},
				"name": "Security Council",
				"salience": 0.0017345438,
				"type": "ORGANIZATION"
			},
			{
				"name": "official",
				"salience": 0.0017109067,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.0016207014,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0015725961,
				"type": "LOCATION"
			},
			{
				"name": "Terror Monitor",
				"salience": 0.0012106539,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/ISIS_Threatens_Russia_fe57b.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-11T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.007",
		"text": "26 Shares\n21 4 0 1\nA new video purportedly released by the Islamic State shows 2 young ISIS boys executing two “spies.”\nThe film, titled “Repent and you have safety from us,” is directed at Russians and Putin, threatening violence at the Syrian government ally. The nearly 14-minute video was released on ISIS terrorist channels on November 9 and comes from “Wilayat al-Jazirah,” northern Iraq.\nVulnerable cities in the ISIS-occupied region include “Tal ‘Afar, Al-Ba’aj, Al-‘Ayadiyyah, Al-Mahlabiyyah, Sinjar, Wardiyyah, Sanuni, Khana Sor, Ibrat al-Saghira, Al-Badi, [and] Al-Qanat.”\nPrisoners can be seen kneeling on the ground in an unknown location in northern Iraq, while so-called 'cubs of the caliphate', dressed in military outfits, stand behind them wielding hand guns.\nIn one scene a child rants to the camera about Putin's intervention in Syria before he and a second youngster shoot their captives - who were accused of being spies - in the back of the head.\nMORE... Saudis Foil ISIS Terror Attacks on Packed Stadium U.S. Commander John Nicholson: ISIS Attempting to Establish Khorasan Caliphate in Afghanistan ISIL executes Iraqi citizens listening to gov't radio Iraqi forces burn 16k m² ISIS poppy fields to curtail heroin and opium revenue The child soldiers threaten attacks on Russia and call Putin a 'dog', according to Terror Monitor.\nOne of the Russian children says: 'O Russian disbelievers... We will kill you and nothing will save you from that dog Putin.'\nThe video emerged on the same day that a senior UN official said the operation to liberate the city of Mosul marks the beginning of the end of the ISIS caliphate in Iraq.\nJan Kubis, the UN envoy for the country told the Security Council, said efforts by the Iraqi Security Forces, the Peshmerga and other allies are making steady progress in liberating the city, while seeking to minimise civilian casualties.\n'This liberation operation marks the beginning of the end of the so-called `Da'esh caliphate' in Iraq,' Kubis said, using an Arabic acronym to refer to the group.\nEarly on Agugust ISIS released a video urging his memebers to stage attacks in Russia.",
		"thread_title": "New ISIS Video Threatens Putin While Russian Child Executioners Execute 4 Men",
		"title": "New ISIS Video Threatens Putin While Russian Child Executioners Execute 4 Men",
		"type": "bs",
		"uuid": "927405b47e589f225f5a94283eff78e43987ca9b"
	},
	"-KhIbTt-c44qbSXwRcAt": {
		"author": "Harry Abrams",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-12T02:48:34.604+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "drivel",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/lethbridge_d3229.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-11T18:23:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.8
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.001",
		"text": "Racist drivel.",
		"thread_title": "The B'nai Brith and the History of the Mounting Assault on Academic Freedom in Canadian Universities",
		"title": "",
		"type": "bs",
		"uuid": "eb7ad13df4c7d4dde88c4287104f44ac79a769bc"
	},
	"-KhIbUIQF75EZ4sR-5II": {
		"author": "Ludwig Watzal",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-13T02:59:52.262+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.34981078,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.10919263,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.095843665,
				"type": "LOCATION"
			},
			{
				"name": "leftists",
				"salience": 0.036774658,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.01769422,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.012399255,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.008910183,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.008910183,
				"type": "LOCATION"
			},
			{
				"name": "defeat",
				"salience": 0.008910183,
				"type": "EVENT"
			},
			{
				"name": "liberals",
				"salience": 0.008804623,
				"type": "PERSON"
			},
			{
				"name": "Ann Garrison: Clinton",
				"salience": 0.007995703,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.007916649,
				"type": "OTHER"
			},
			{
				"name": "teeth",
				"salience": 0.007718967,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.007718967,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.007445148,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0071555683,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.006726175,
				"type": "EVENT"
			},
			{
				"name": "first",
				"salience": 0.005944754,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0056513227,
				"type": "OTHER"
			},
			{
				"name": "donations",
				"salience": 0.005461685,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0053084707,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.00503822,
				"type": "EVENT"
			},
			{
				"name": "embodiment",
				"salience": 0.005020372,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.004557115,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.004557115,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.004267623,
				"type": "PERSON"
			},
			{
				"name": "hypocrite par excellence",
				"salience": 0.0042048697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.004063996,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0040213712,
				"type": "LOCATION"
			},
			{
				"name": "return",
				"salience": 0.003946864,
				"type": "OTHER"
			},
			{
				"name": "doors",
				"salience": 0.003946864,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.003946864,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.003946864,
				"type": "PERSON"
			},
			{
				"name": "minorities",
				"salience": 0.003946864,
				"type": "PERSON"
			},
			{
				"name": "bankiers",
				"salience": 0.003946864,
				"type": "PERSON"
			},
			{
				"name": "outcome",
				"salience": 0.003946864,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.003946864,
				"type": "OTHER"
			},
			{
				"name": "Secretary of State",
				"salience": 0.003946864,
				"type": "PERSON"
			},
			{
				"name": "arms transfers",
				"salience": 0.003946864,
				"type": "OTHER"
			},
			{
				"name": "security establishment",
				"salience": 0.003684304,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0035997932,
				"type": "OTHER"
			},
			{
				"name": "President-elect",
				"salience": 0.0035485786,
				"type": "PERSON"
			},
			{
				"name": "establishment",
				"salience": 0.003357975,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0030385228,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0030147443,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0029767873,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0029767873,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.0029645609,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0028064274,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections",
				"salience": 0.002536901,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.0025088016,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0024303654,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0024303654,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi-Arabia",
				"salience": 0.0024303654,
				"type": "LOCATION"
			},
			{
				"name": "candidacy",
				"salience": 0.002187113,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0020789895,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.0020682625,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0020096742,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0019142601,
				"type": "PERSON"
			},
			{
				"name": "reporting",
				"salience": 0.001880394,
				"type": "OTHER"
			},
			{
				"name": "Steinmeier",
				"salience": 0.0017802359,
				"type": "PERSON"
			},
			{
				"name": "establishment",
				"salience": 0.001778151,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.001778151,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d499v"
				},
				"name": "Gabriel",
				"salience": 0.0017356667,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0017117948,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0017117948,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.0017101166,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0016508222,
				"type": "ORGANIZATION"
			},
			{
				"name": "payroll",
				"salience": 0.0016255575,
				"type": "OTHER"
			},
			{
				"name": "machinery",
				"salience": 0.0016255575,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0016255575,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.0016255575,
				"type": "WORK_OF_ART"
			},
			{
				"name": "corruption",
				"salience": 0.0016255575,
				"type": "OTHER"
			},
			{
				"name": "kid gloves",
				"salience": 0.0016255575,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0016255575,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0015779639,
				"type": "OTHER"
			},
			{
				"name": "election campaign",
				"salience": 0.0015190732,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.0014967326,
				"type": "OTHER"
			},
			{
				"name": "Much",
				"salience": 0.0014941817,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0013500564,
				"type": "PERSON"
			},
			{
				"name": "rhetoric",
				"salience": 0.0013162508,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0013162508,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0013162508,
				"type": "PERSON"
			},
			{
				"name": "suggestion",
				"salience": 0.0013162508,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0012797817,
				"type": "ORGANIZATION"
			},
			{
				"name": "suggestions",
				"salience": 0.0012671219,
				"type": "OTHER"
			},
			{
				"name": "fit",
				"salience": 0.0012614625,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.0011958237,
				"type": "PERSON"
			},
			{
				"name": "Ties",
				"salience": 0.0011901106,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0011901106,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0011555189,
				"type": "LOCATION"
			},
			{
				"name": "code",
				"salience": 0.0011397736,
				"type": "OTHER"
			},
			{
				"name": "honor",
				"salience": 0.0011397736,
				"type": "OTHER"
			},
			{
				"name": "thieves",
				"salience": 0.0011397736,
				"type": "OTHER"
			},
			{
				"name": "media propaganda",
				"salience": 0.0011397736,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.0011397736,
				"type": "PERSON"
			},
			{
				"name": "sort",
				"salience": 0.0011397736,
				"type": "OTHER"
			},
			{
				"name": "houses",
				"salience": 0.0011397736,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.0011397736,
				"type": "LOCATION"
			},
			{
				"name": "record",
				"salience": 0.0010972286,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.0010972286,
				"type": "OTHER"
			},
			{
				"name": "consumption",
				"salience": 0.0010972286,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0010972286,
				"type": "ORGANIZATION"
			},
			{
				"name": "hamburger",
				"salience": 0.0010972286,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "failures",
				"salience": 0.0010972286,
				"type": "OTHER"
			},
			{
				"name": "hot dog",
				"salience": 0.0010972286,
				"type": "OTHER"
			},
			{
				"name": "corner",
				"salience": 0.0010972286,
				"type": "LOCATION"
			},
			{
				"name": "frontiers",
				"salience": 0.0010972286,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0010745504,
				"type": "OTHER"
			},
			{
				"name": "colonization",
				"salience": 0.0010745504,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.001066849,
				"type": "ORGANIZATION"
			},
			{
				"name": "media class",
				"salience": 0.0010415821,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.0010354856,
				"type": "PERSON"
			},
			{
				"name": "Interests",
				"salience": 0.0010298184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.0010005826,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Islamic",
				"salience": 0.0010005826,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0010005826,
				"type": "ORGANIZATION"
			},
			{
				"name": "hindrance",
				"salience": 0.0009304664,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0009304664,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0009304664,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.0009304664,
				"type": "OTHER"
			},
			{
				"name": "adventurism",
				"salience": 0.0009304664,
				"type": "EVENT"
			},
			{
				"name": "Oligarchy",
				"salience": 0.0009304664,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0009273205,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0009273205,
				"type": "OTHER"
			},
			{
				"name": "declarations",
				"salience": 0.00091874093,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mass-immigration policy",
				"salience": 0.00085584394,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0008444682,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0008101524,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nobody",
				"salience": 0.00080931076,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0008026973,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0008026973,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0008026973,
				"type": "PERSON"
			},
			{
				"name": "skin color",
				"salience": 0.0008026973,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0008026973,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.0008026973,
				"type": "PERSON"
			},
			{
				"name": "disdain",
				"salience": 0.0007991115,
				"type": "OTHER"
			},
			{
				"name": "lead",
				"salience": 0.00075958343,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0007312255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0007205545,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.00070151006,
				"type": "LOCATION"
			},
			{
				"name": "election campaign",
				"salience": 0.00070086267,
				"type": "EVENT"
			},
			{
				"name": "movement",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "gender",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "creed",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "sexual orientation",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "dignity",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "Aide",
				"salience": 0.00069505436,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00069505436,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "trailblazer",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "authoritarian",
				"salience": 0.00069505436,
				"type": "PERSON"
			},
			{
				"name": "rollback",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "preacher",
				"salience": 0.00069505436,
				"type": "PERSON"
			},
			{
				"name": "stove",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "bed",
				"salience": 0.00069505436,
				"type": "OTHER"
			},
			{
				"name": "gays",
				"salience": 0.00069505436,
				"type": "PERSON"
			},
			{
				"name": "jail",
				"salience": 0.00069505436,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.00069505436,
				"type": "ORGANIZATION"
			},
			{
				"name": "unions",
				"salience": 0.00069505436,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.00069270417,
				"type": "OTHER"
			},
			{
				"name": "shame",
				"salience": 0.0006691048,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestine",
				"salience": 0.00066135917,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.00066135917,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.00064746663,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00064746663,
				"type": "ORGANIZATION"
			},
			{
				"name": "occasions",
				"salience": 0.00062799,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.000617947,
				"type": "ORGANIZATION"
			},
			{
				"name": "defeat",
				"salience": 0.0005845841,
				"type": "EVENT"
			},
			{
				"name": "cooperation",
				"salience": 0.00058197236,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0005726651,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0005726651,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0430_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jerusalem"
				},
				"name": "Jerusalem",
				"salience": 0.0005726651,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07qzv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tel_Aviv"
				},
				"name": "Tel Aviv",
				"salience": 0.0005726651,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0r4t_pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Transatlantic_Trade_and_Investment_Partnership"
				},
				"name": "TTIP",
				"salience": 0.0005726651,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09h5x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trans-Pacific_Partnership"
				},
				"name": "TPP",
				"salience": 0.0005726651,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Diplomatic_mission"
				},
				"name": "US Embassy",
				"salience": 0.0005726651,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.0005726651,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.0005726651,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Netanyahu",
				"salience": 0.0005726651,
				"type": "PERSON"
			},
			{
				"name": "Why Clinton's Policies Look Like a Death Sentence",
				"salience": 0.0005726651,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0005560535,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00052352814,
				"type": "EVENT"
			},
			{
				"name": "humility",
				"salience": 0.000506184,
				"type": "OTHER"
			},
			{
				"name": "coverage",
				"salience": 0.000506184,
				"type": "OTHER"
			},
			{
				"name": "side table",
				"salience": 0.000506184,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.000506184,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.000506184,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.000506184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.0004987964,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07p87rn"
				},
				"name": "Establishment",
				"salience": 0.00048608854,
				"type": "ORGANIZATION"
			},
			{
				"name": "class",
				"salience": 0.00048363974,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.00048363974,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00043666514,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00043666514,
				"type": "OTHER"
			},
			{
				"name": "rule of law",
				"salience": 0.00043666514,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00043666514,
				"type": "OTHER"
			},
			{
				"name": "congratulation",
				"salience": 0.00043666514,
				"type": "OTHER"
			},
			{
				"name": "revulsion",
				"salience": 0.00043471417,
				"type": "OTHER"
			},
			{
				"name": "worth",
				"salience": 0.00041320777,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "provocation",
				"salience": 0.0003780996,
				"type": "EVENT"
			},
			{
				"name": "freedom",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "blabber",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "impudence",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "guise",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0003780996,
				"type": "OTHER"
			},
			{
				"name": "morals",
				"salience": 0.00019302763,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Protest_against_Donald_Trump_f9e6a.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 22.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "5 Shares\n4 0 0 1\nSo-called liberals and leftists in the US and around the world, are now wailing and gnashing their teeth in reaction to Hillary Clinton’s crushing defeat. They are, however, the first to blame for the outcome of the US presidential elections. Their candidate, Hillary Clinton, was the embodiment of a totally corrupt political system. She is a hypocrite par excellence, talking to the bankiers of Wall Street behind closed doors differently than to the American people. Her rhetoric for the rights of women and blacks and other minorities sounded disingenuous. The Clinton Foundation received large donations from Saudi-Arabia and Qatar, countries rewarded in return by huge arms transfers overseen by her as Secretary of State. Her involvement in this corruption was no theme for the media. According to emails published by WikiLeaks, her campaign manager John Podesta was or is on the payroll of the Saudis. All of this was not considered worth reporting by the media. Virtually all national media in the United States supported Clinton's candidacy. Instead of reporting how the machinery of the Democratic Party and the Clinton team stole the primary elections to prevent the candidacy of Bernie Sanders, the media demonized Donald Trump.\nI do not wish here to defend Donald Trump. He made numerous stupid, racist, sexist, and anti-Islamic statements that were rightly criticized. Hillary Clinton, on the other hand, was treated with kid gloves while her huge criminal political record was glossed over. Instead of coming to grips with their abject failures, the liberals and their media continue in slandering Donald Trump. Trump’s first declarations show already that he has conquered new frontiers.\nAn American President is not a free and politically independent person. From day one, a President-elect can't anymore go around the corner and grab a hot dog or a hamburger. He is reigned in by a military and security establishment that holds the President fit for public consumption. Trump, as any other president, can be expected to follow their rule and political suggestions.\nI doubt very much that Trump will keep the promises of his election campaign, such as building a wall along the American-Mexican border, deport all illegal immigrants or ban Muslims from immigrating into the US. I even doubt that he will go after Hillary Clinton and her husband's dubious foundation. There exists a code of honor among thieves.\nTrump won precisely because of the shrill one-sided media propaganda and because of his rhetoric against the Washington establishment, including his own Republican Party. Now, this Republican establishment dominates both houses of Congress. Trump belongs also, however, to the US establishment but of another sort. Nobody should believe that the Washington establishment will follow Trump's lead. Even his positive statements about Vladimir Putin or his suggestion to discard NATO, will probably vanish. But what I do hope is that he stands to his rejection of TPP and TTIP and his pragmatic view of Vladimir Putin.\nMORE... Ann Garrison: Clinton Serves the Interests of the Oligarchy that She Herself Has Joined Top Aide to Hillary Clinton Urges the FBI to Disclose what it Knows about Trump's Russia Ties What will Hillary Clinton do for India? Not Much and Here's Why Clinton's Policies Look Like a Death Sentence for Americans Whether Trump will stop American adventurism in the Middle East has to be seen. His close ties with Netanyahu do not bode well for the Palestinians. He sees Zionist colonization of the rest of Palestine as no hindrance to peace. And while he has promised to move the US Embassy from Tel Aviv to Jerusalem, I doubt that he will carry out this provocation against international law and the entire Muslim world.\nThe German political and media class was not only surprised by the results of the US elections, but did not even try to hide its revulsion against the choice of the American people. The entire political class in Germany perceived and presented the Trump campaign in the same one-sided manner as American media did. Chancellor Angela Merkel sent the President-Elect Trump a warning in the guise of a congratulation. Her political impudence was garbed within obsequious blabber about the allegedly honorable nature of German-American ties: \"Germany and America are bound by common values — democracy, freedom, as well as respect for the rule of law and the dignity of each and every person, regardless of their origin, skin color, creed, gender, sexual orientation, or political views. It is based on these values that I wish to offer close cooperation, both with me personally and between our countries’ governments.” Other German politicians did not even attempt to hide their disdain for American voters by diplomatic language. Germany’s Foreign Minister Steinmeier called Trump a \"preacher of hate\", and Deputy Chancellor Gabriel cartooned Trump as a “trailblazer of a new authoritarian and chauvinist international movement... [who wants] a rollback to the bad old times in which women belonged by the stove or in bed, gays in jail and unions at best at the side table.” During the election campaign, Trump called Merkel's mass-immigration policy \"insane\" and “what Merkel did to Germany” a “sad shame”.\nThe media and the political class should at this point stop pontificating. Their double morals and unprofessional coverage of the US elections should prompt them to more humility. They should rather blame themselves for their biased reporting, which led directly to Clinton's defeat. Ordinary Americans are not as stupid as the Establishment wants us to believe. Established parties and media would be well advised to give the new US President a chance to prove his worth. There will be, without doubt, many occasions in the future for fact-based criticism.",
		"thread_title": "No Soul-searching by Liberals and US Presstitutes after Clinton's Defeat",
		"title": "No Soul-searching by Liberals and US Presstitutes after Clinton's Defeat",
		"type": "bs",
		"uuid": "702a23c7d314ef6ffe726f080b670a0ef5468837"
	},
	"-KhIbUbb85E2-Sm3ufBU": {
		"author": "Kim Petersen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-13T03:00:09.218+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.2169285,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.103708506,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.08968822,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05fv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Gore"
				},
				"name": "Al Gore",
				"salience": 0.04254505,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.031224577,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.028071953,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.025444236,
				"type": "EVENT"
			},
			{
				"name": "electoral college votes",
				"salience": 0.023865027,
				"type": "OTHER"
			},
			{
				"name": "goalposts",
				"salience": 0.018698515,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.017491084,
				"type": "OTHER"
			},
			{
				"name": "criteria",
				"salience": 0.017284214,
				"type": "OTHER"
			},
			{
				"name": "election coverage",
				"salience": 0.017284214,
				"type": "OTHER"
			},
			{
				"name": "electors",
				"salience": 0.016798439,
				"type": "PERSON"
			},
			{
				"name": "moderator",
				"salience": 0.01604219,
				"type": "PERSON"
			},
			{
				"name": "goalposts",
				"salience": 0.014615477,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.013533938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.012672367,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.011929691,
				"type": "OTHER"
			},
			{
				"name": "concession speech",
				"salience": 0.009996702,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Dump Clinton",
				"salience": 0.009175628,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00915056,
				"type": "OTHER"
			},
			{
				"name": "election coverage",
				"salience": 0.008855692,
				"type": "OTHER"
			},
			{
				"name": "loser",
				"salience": 0.00799838,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020sgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy_Now!"
				},
				"name": "Democracy Now!",
				"salience": 0.007591772,
				"type": "WORK_OF_ART"
			},
			{
				"name": "epitome",
				"salience": 0.0069286805,
				"type": "WORK_OF_ART"
			},
			{
				"name": "arrogance",
				"salience": 0.0069286805,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0053910865,
				"type": "EVENT"
			},
			{
				"name": "electoral college votes",
				"salience": 0.005053731,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.004870291,
				"type": "OTHER"
			},
			{
				"name": "penalty",
				"salience": 0.004149134,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0037818474,
				"type": "EVENT"
			},
			{
				"name": "electoral college votes",
				"salience": 0.0036823454,
				"type": "OTHER"
			},
			{
				"name": "comparison",
				"salience": 0.003679349,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.0036518676,
				"type": "EVENT"
			},
			{
				"name": "defeat",
				"salience": 0.0036518676,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0032976111,
				"type": "PERSON"
			},
			{
				"name": "loser",
				"salience": 0.0032976111,
				"type": "PERSON"
			},
			{
				"name": "electoral college votes",
				"salience": 0.003083894,
				"type": "OTHER"
			},
			{
				"name": "electoral fraud",
				"salience": 0.0028558096,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0028558096,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0028558096,
				"type": "OTHER"
			},
			{
				"name": "dimensions",
				"salience": 0.0028558096,
				"type": "OTHER"
			},
			{
				"name": "Electoral College",
				"salience": 0.002788376,
				"type": "ORGANIZATION"
			},
			{
				"name": "winner",
				"salience": 0.0027722393,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0025612079,
				"type": "PERSON"
			},
			{
				"name": "defeat",
				"salience": 0.0024656607,
				"type": "EVENT"
			},
			{
				"name": "criteria",
				"salience": 0.0024656607,
				"type": "OTHER"
			},
			{
				"name": "criteria",
				"salience": 0.0024656607,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.002361428,
				"type": "OTHER"
			},
			{
				"name": "Conventions",
				"salience": 0.002312647,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.0023023225,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.0022634403,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0022634403,
				"type": "LOCATION"
			},
			{
				"name": "winner",
				"salience": 0.0022634403,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0022634403,
				"type": "LOCATION"
			},
			{
				"name": "winner",
				"salience": 0.0022634403,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0022263634,
				"type": "PERSON"
			},
			{
				"name": "electoral college convention",
				"salience": 0.0022263634,
				"type": "EVENT"
			},
			{
				"name": "words",
				"salience": 0.0022263634,
				"type": "OTHER"
			},
			{
				"name": "electoral college vote",
				"salience": 0.0021627052,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0021135043,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.0021011396,
				"type": "LOCATION"
			},
			{
				"name": "type",
				"salience": 0.002054113,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.0020408137,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0020026925,
				"type": "EVENT"
			},
			{
				"name": "voice",
				"salience": 0.0020026925,
				"type": "OTHER"
			},
			{
				"name": "Bios",
				"salience": 0.0020026925,
				"type": "OTHER"
			},
			{
				"name": "offending team",
				"salience": 0.0020026925,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.0020026925,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0019279636,
				"type": "PERSON"
			},
			{
				"name": "standard",
				"salience": 0.0019279636,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0019279636,
				"type": "OTHER"
			},
			{
				"name": "fallacy",
				"salience": 0.0019279636,
				"type": "OTHER"
			},
			{
				"name": "sporting world",
				"salience": 0.0019279636,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0019279636,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.001905546,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.0018881294,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.0018881294,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0018881294,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0018881294,
				"type": "PERSON"
			},
			{
				"name": "bar",
				"salience": 0.0018796987,
				"type": "OTHER"
			},
			{
				"name": "Narrative Dump Trump",
				"salience": 0.0018208327,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0018176718,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0017582003,
				"type": "LOCATION"
			},
			{
				"name": "rules",
				"salience": 0.0016910264,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0016910264,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0016910264,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0016806208,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0016806208,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0016806208,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.0016350311,
				"type": "OTHER"
			},
			{
				"name": "ballots",
				"salience": 0.0016350311,
				"type": "OTHER"
			},
			{
				"name": "celebrity",
				"salience": 0.0016350311,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.001542563,
				"type": "PERSON"
			},
			{
				"name": "American Socialist",
				"salience": 0.0014236693,
				"type": "ORGANIZATION"
			},
			{
				"name": "game",
				"salience": 0.001410572,
				"type": "EVENT"
			},
			{
				"name": "game",
				"salience": 0.001410572,
				"type": "EVENT"
			},
			{
				"name": "participation",
				"salience": 0.0013879404,
				"type": "OTHER"
			},
			{
				"name": "participation",
				"salience": 0.0013879404,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.0013367608,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0013140233,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0012555192,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0012555192,
				"type": "EVENT"
			},
			{
				"name": "John Stauber",
				"salience": 0.0012327972,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/11bwfksq5j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mimi_Soltysik"
				},
				"name": "Mimi Soltysik",
				"salience": 0.0012327972,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021sj1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office"
				},
				"name": "Office",
				"salience": 0.0012327972,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01kysg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Party_USA"
				},
				"name": "Socialist Party USA",
				"salience": 0.0012327972,
				"type": "ORGANIZATION"
			},
			{
				"name": "precedent",
				"salience": 0.0012214549,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.0012214549,
				"type": "OTHER"
			},
			{
				"name": "match",
				"salience": 0.0012214549,
				"type": "EVENT"
			},
			{
				"name": "liking",
				"salience": 0.0012214549,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0012214549,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0012214549,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.0012214549,
				"type": "OTHER"
			},
			{
				"name": "slope",
				"salience": 0.0012214549,
				"type": "LOCATION"
			},
			{
				"name": "quandary",
				"salience": 0.0012214549,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0012214549,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.001176821,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0011047065,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.001036837,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0010273567,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0478__m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lady_Gaga"
				},
				"name": "Lady Gaga",
				"salience": 0.0010064142,
				"type": "PERSON"
			},
			{
				"name": "media coverage",
				"salience": 0.0009288908,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.00088959804,
				"type": "PERSON"
			},
			{
				"name": "party primaries",
				"salience": 0.00088959804,
				"type": "EVENT"
			},
			{
				"name": "barriers",
				"salience": 0.00088959804,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00088959804,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0007737619,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05p6s71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citizens_United_v._FEC"
				},
				"name": "Citizens United",
				"salience": 0.0007003217,
				"type": "ORGANIZATION"
			},
			{
				"name": "dictatorships",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "horn",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "bastion",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "attainment",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "nemeses",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "plurality",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "deficit",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.00066452264,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0006323071,
				"type": "PERSON"
			},
			{
				"name": "transparency",
				"salience": 0.0005779866,
				"type": "OTHER"
			},
			{
				"name": "Democracy The United States",
				"salience": 0.000566268,
				"type": "ORGANIZATION"
			},
			{
				"name": "party candidates",
				"salience": 0.0005547235,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0004089689,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Protest_against_Donald_Trump_2_22585.jpg",
		"ord_in_thread": "0",
		"participants_count": "2",
		"published": "2016-11-12T02:00:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 11.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Moving the goalposts on electoral criteria 34 Shares\n15 16 0 3\nDuring live US presidential election coverage on RT, after it became clear that Donald Trump was going to secure the required number of electoral college votes to win the election, word came that Hillary Clinton would not make a concession speech that night. The moderator of the live election coverage at RT was gobsmacked. He called Clinton's behavior the \"epitome of arrogance.\" It certainly did smack of being a poor loser.\nIt seems that being a sore loser has reached stratospheric dimensions, as some are trying to reverse the electoral defeat for Clinton because she won the popular vote. To be clear, there is no comparison to what befell Al Gore here. Gore also won the popular vote in the 2000 US presidential election, but he was considered by many to have won the majority of electoral college votes because of electoral fraud in Florida. Yet even Gore, who has a better case to have overturned his defeat in 2000 than Clinton has in 2016, eventually conceded defeat.\nThese people seeking to circumvent current electoral college convention are, in other words, trying to move the goalposts on Donald Trump and his supporters.\nMoving the goalposts is a type of logical fallacy whereby when a person has met the criteria required to succeed subsequently the criteria are changed to something different or raised to a higher standard (also referred to as \"raising the bar\").\nMoving the goalposts is unethical. When it occurs in the sporting world, a penalty is bestowed on the offending team.\nMORE... Bios of Clinton and Trump, if They were Running for Office in Cuba - An Alternate Narrative Dump Trump, Dump Clinton, Look To the Conventions John Stauber: The system that chooses and elects the American president is a farce A voice for the American Socialist: An interview with Mimi Soltysik, Socialist Party USA Presidential candidate On 8 November candidate Donald Trump surpassed 270 electoral college votes and was declared winner of the 2016 election. Yet we hear from Democracy Now! of a movement to overturn the system of winner take-all electoral college votes in a state. The show referred to a petition supported by the celebrity Lady Gaga asking: \"Electoral College: Make Hillary Clinton President on December 19.\"\nIt calls on the electors to ignore the current rules, which bind them to voting for the winner of their state, and cast their ballots instead for the winner of the popular vote, Hillary Clinton.\nDemocracy Now! reports than 2 million people have signed the petition.\nWhat it Signifies for US Democracy\nThe United States is not a democracy in any meaningful sense. Despite the US relentlessly tooting its own horn as the bastion of democracy, it is arguably inferior in level of democratic attainment even compared to nations it considers nemeses — Cuba and China — and that it fallaciously derides as being dictatorships.\nConferring victory upon the candidate who garners the plurality of votes in an election will do little to assuage the democratic deficit in the US.\nYes, deciding the outcome of an election through the electoral college vote seems out-dated at any point in time. However, overturning the rules of the game post hoc poses another logical quandary: the slippery slope. If a precedent is set whereby the rules of the game can be changed during play or after the match, then what is to stop the rules being tampered with again in the future when a result is not to a powerful side's liking?\nThere are many crucial steps required before the United States can present itself as a meaningful democracy: for example, among others, discarding the electoral college, bringing transparency to party primaries, overturning Citizens United , providing impartial and equal media coverage for all candidates (including \"third\" party candidates) during an election, easing the barriers for \"third\" party electoral participation, facilitating electoral participation for all Americans. These measures must be implemented before an election. They must not be implemented during or after an election to change the result. It is unfair. That is elementary morality that any child would comprehend.",
		"thread_title": "The Unethicality of the Sore Loser",
		"title": "The Unethicality of the Sore Loser",
		"type": "bs",
		"uuid": "3acd32f1e784c28d46641f0d1a92b9d5f0f9ce55"
	},
	"-KhIbUfaJ77v4YKfsYBK": {
		"author": "thecraziesarerunningtheasylum",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-13T03:00:09.325+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "voter fraud",
				"salience": 0.56678426,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.2635328,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.16968292,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Protest_against_Donald_Trump_2_22585.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-12T16:43:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "With all the voter fraud, she did not win the popular vote, no way no how~",
		"thread_title": "The Unethicality of the Sore Loser",
		"title": "",
		"type": "bs",
		"uuid": "7ebca06d6464ec9b63c55af795f3ac5c961d5bb9"
	},
	"-KhIbVVZS2XNAeo_PAVZ": {
		"author": "Mohsen Abdelmoumen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-13T03:00:58.713+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.591093,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.047568254,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.02162375,
				"type": "ORGANIZATION"
			},
			{
				"name": "Governments",
				"salience": 0.017054565,
				"type": "ORGANIZATION"
			},
			{
				"name": "Brian Cloughley",
				"salience": 0.013482809,
				"type": "PERSON"
			},
			{
				"name": "Donald Trump Trump",
				"salience": 0.011806223,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.010527221,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libyan",
				"salience": 0.008471602,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.006692428,
				"type": "LOCATION"
			},
			{
				"name": "infrastructure",
				"salience": 0.006666905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0066159237,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.006561376,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0057161963,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0052029695,
				"type": "LOCATION"
			},
			{
				"name": "Grandfather",
				"salience": 0.0051692934,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0042073047,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.0040321294,
				"type": "OTHER"
			},
			{
				"name": "cold war",
				"salience": 0.0035514678,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "Western",
				"salience": 0.0032890053,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Gaddafi",
				"salience": 0.0032779837,
				"type": "PERSON"
			},
			{
				"name": "other",
				"salience": 0.00315228,
				"type": "OTHER"
			},
			{
				"name": "tyranny",
				"salience": 0.0031327899,
				"type": "PERSON"
			},
			{
				"name": "despots",
				"salience": 0.003032608,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.0030024215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015qh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bulgaria"
				},
				"name": "Bulgaria",
				"salience": 0.0030024215,
				"type": "LOCATION"
			},
			{
				"name": "interest",
				"salience": 0.002934808,
				"type": "OTHER"
			},
			{
				"name": "monarchy",
				"salience": 0.002492603,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.0024655082,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0023364378,
				"type": "ORGANIZATION"
			},
			{
				"name": "continuation",
				"salience": 0.0022779289,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035rfz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_space_program"
				},
				"name": "Soviet",
				"salience": 0.0022710632,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.0022710632,
				"type": "PERSON"
			},
			{
				"name": "confrontation",
				"salience": 0.0022684059,
				"type": "EVENT"
			},
			{
				"name": "Jeremy Bash",
				"salience": 0.002215853,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.0020584543,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.002056969,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.001985123,
				"type": "LOCATION"
			},
			{
				"name": "End",
				"salience": 0.0019586678,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Criminal_Court"
				},
				"name": "International Criminal Court",
				"salience": 0.001958356,
				"type": "ORGANIZATION"
			},
			{
				"name": "dictatorship",
				"salience": 0.001954716,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mohsen Abdelmoumen",
				"salience": 0.0019168913,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.0019140044,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.0018602243,
				"type": "EVENT"
			},
			{
				"name": "superpowers",
				"salience": 0.0017814003,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0017814003,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0017681431,
				"type": "LOCATION"
			},
			{
				"name": "President",
				"salience": 0.0017591909,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0017186382,
				"type": "LOCATION"
			},
			{
				"name": "World",
				"salience": 0.0017186382,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.001707515,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0016707606,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "US State Department",
				"salience": 0.0016346767,
				"type": "ORGANIZATION"
			},
			{
				"name": "war-drum beaters",
				"salience": 0.0014357091,
				"type": "PERSON"
			},
			{
				"name": "extremist leaders",
				"salience": 0.0013388677,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0012892471,
				"type": "EVENT"
			},
			{
				"name": "alliance",
				"salience": 0.001259697,
				"type": "ORGANIZATION"
			},
			{
				"name": "military alliance",
				"salience": 0.001259697,
				"type": "ORGANIZATION"
			},
			{
				"name": "politicians",
				"salience": 0.0012214009,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0011679764,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0011637798,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0011637798,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.0011637798,
				"type": "LOCATION"
			},
			{
				"name": "continuation",
				"salience": 0.0011637798,
				"type": "OTHER"
			},
			{
				"name": "resurrection",
				"salience": 0.0011637798,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0011176057,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0011092809,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00105081,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00105081,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.00105081,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.00105081,
				"type": "OTHER"
			},
			{
				"name": "waters",
				"salience": 0.00105081,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.00105081,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0010140812,
				"type": "LOCATION"
			},
			{
				"name": "manifestation",
				"salience": 0.0009694953,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.00096753787,
				"type": "OTHER"
			},
			{
				"name": "military infrastructure",
				"salience": 0.0009553489,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.00090994535,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.00090994535,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.00090994535,
				"type": "LOCATION"
			},
			{
				"name": "spite",
				"salience": 0.00090994535,
				"type": "OTHER"
			},
			{
				"name": "predator characteristics",
				"salience": 0.00090994535,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.00090994535,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.00080655864,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0007829411,
				"type": "PERSON"
			},
			{
				"name": "internet",
				"salience": 0.00076598837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0948xk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tony_Blair"
				},
				"name": "Tony Blair",
				"salience": 0.00075734983,
				"type": "PERSON"
			},
			{
				"name": "confrontation",
				"salience": 0.0007530841,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0007474534,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.00070764427,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00070764427,
				"type": "ORGANIZATION"
			},
			{
				"name": "policy",
				"salience": 0.0006861168,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.0006696932,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06npd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slovakia"
				},
				"name": "Slovakia",
				"salience": 0.0006468212,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06t8v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slovenia"
				},
				"name": "Slovenia",
				"salience": 0.0006468212,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0006422469,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.000619895,
				"type": "ORGANIZATION"
			},
			{
				"name": "rights",
				"salience": 0.0005843862,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0005843862,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0005843862,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0005843862,
				"type": "OTHER"
			},
			{
				"name": "Members",
				"salience": 0.0005608842,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/084b2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Warsaw_Pact"
				},
				"name": "Warsaw Pact",
				"salience": 0.0005600906,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01mjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Czech_Republic"
				},
				"name": "Czech Republic",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03gj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hungary"
				},
				"name": "Hungary",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lithuania"
				},
				"name": "Lithuania",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0005600906,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonia",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04g5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latvia"
				},
				"name": "Latvia",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06c1y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Romania"
				},
				"name": "Romania",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0l51n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Corriere_della_Sera"
				},
				"name": "Corriere della Sera",
				"salience": 0.0005600906,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jtm8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_China_Sea"
				},
				"name": "South China Sea",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern",
				"salience": 0.0005600906,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.00055252225,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0005515851,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0005515851,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0005513277,
				"type": "EVENT"
			},
			{
				"name": "refugees",
				"salience": 0.00054439437,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0005185746,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.0005185746,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0005185746,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0005185746,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.0005185746,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00049766223,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00049614225,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0004913905,
				"type": "LOCATION"
			},
			{
				"name": "statements",
				"salience": 0.0004892378,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0004888392,
				"type": "OTHER"
			},
			{
				"name": "restrictions",
				"salience": 0.0004888392,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0004810467,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00047906907,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.00047906907,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00047906907,
				"type": "PERSON"
			},
			{
				"name": "blitz",
				"salience": 0.00047906907,
				"type": "OTHER"
			},
			{
				"name": "police tyranny",
				"salience": 0.00047906907,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00047762002,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00047762002,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00047762002,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00047762002,
				"type": "ORGANIZATION"
			},
			{
				"name": "each other",
				"salience": 0.00047097323,
				"type": "PERSON"
			},
			{
				"name": "silence",
				"salience": 0.00047058956,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.00046916615,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.00046406768,
				"type": "LOCATION"
			},
			{
				"name": "policy",
				"salience": 0.00046308787,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.00046086186,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00046086186,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00046086186,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.00045346568,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00045028454,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00043842223,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.0004325442,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0004325442,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0004325442,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0004325442,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.0004325442,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0004325442,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.0004325442,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0004325442,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0004325442,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00041669898,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00041669898,
				"type": "ORGANIZATION"
			},
			{
				"name": "military confrontation",
				"salience": 0.00040971275,
				"type": "EVENT"
			},
			{
				"name": "terrorist groups",
				"salience": 0.00040971275,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.00040971275,
				"type": "ORGANIZATION"
			},
			{
				"name": "insurrectionists groups",
				"salience": 0.00040971275,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00040502095,
				"type": "ORGANIZATION"
			},
			{
				"name": "parts",
				"salience": 0.00039441625,
				"type": "LOCATION"
			},
			{
				"name": "confrontation",
				"salience": 0.00039441625,
				"type": "EVENT"
			},
			{
				"name": "policy",
				"salience": 0.00039269708,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.00038788654,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.00037649253,
				"type": "LOCATION"
			},
			{
				"name": "military menaces",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "behest",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "purge",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "whole",
				"salience": 0.0003745376,
				"type": "LOCATION"
			},
			{
				"name": "posture",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "assembly",
				"salience": 0.0003745376,
				"type": "ORGANIZATION"
			},
			{
				"name": "disapproval",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "abuses",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "significance",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "association",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "arrest",
				"salience": 0.0003745376,
				"type": "EVENT"
			},
			{
				"name": "means",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "detention",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0003745376,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0003729077,
				"type": "PERSON"
			},
			{
				"name": "fleets",
				"salience": 0.00036515624,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00036356712,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.00036356712,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.00036356712,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00035635926,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime",
				"salience": 0.00035446047,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.00035264468,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.00035070445,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.00035070445,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.00035070445,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00035070445,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00035070445,
				"type": "EVENT"
			},
			{
				"name": "extremists",
				"salience": 0.000349993,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.000349993,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0003493993,
				"type": "PERSON"
			},
			{
				"name": "mass movement",
				"salience": 0.00034889372,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00034889372,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.00034453647,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0003401545,
				"type": "PERSON"
			},
			{
				"name": "explanation",
				"salience": 0.00033839824,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0003358673,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0003358673,
				"type": "PERSON"
			},
			{
				"name": "insurrectionists",
				"salience": 0.0003358673,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0003358673,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.00033446122,
				"type": "OTHER"
			},
			{
				"name": "affairs",
				"salience": 0.0003341332,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00033063095,
				"type": "LOCATION"
			},
			{
				"name": "miscalculation",
				"salience": 0.00032992187,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0003274924,
				"type": "EVENT"
			},
			{
				"name": "intervention",
				"salience": 0.0003274924,
				"type": "EVENT"
			},
			{
				"name": "mission",
				"salience": 0.0003243459,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00032332714,
				"type": "OTHER"
			},
			{
				"name": "blitz",
				"salience": 0.00032332714,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00032332714,
				"type": "EVENT"
			},
			{
				"name": "strategy",
				"salience": 0.00032332714,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00032332714,
				"type": "EVENT"
			},
			{
				"name": "murder",
				"salience": 0.00032332714,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0003195654,
				"type": "EVENT"
			},
			{
				"name": "review",
				"salience": 0.00031360058,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Interview",
				"salience": 0.00030736777,
				"type": "EVENT"
			},
			{
				"name": "headlines",
				"salience": 0.00030711736,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.00030324646,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.00030324646,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.00030254046,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00030254046,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.00030254046,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.00029678928,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.00029678928,
				"type": "OTHER"
			},
			{
				"name": "regimes",
				"salience": 0.00029678928,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00029585705,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00029432948,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00029333416,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00029192396,
				"type": "OTHER"
			},
			{
				"name": "bands",
				"salience": 0.00029192396,
				"type": "OTHER"
			},
			{
				"name": "bombardment",
				"salience": 0.00029192396,
				"type": "OTHER"
			},
			{
				"name": "http://www.beecluff.com/",
				"salience": 0.0002912463,
				"type": "OTHER"
			},
			{
				"name": "haven",
				"salience": 0.00028333988,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00028210675,
				"type": "OTHER"
			},
			{
				"name": "bombers",
				"salience": 0.0002774821,
				"type": "PERSON"
			},
			{
				"name": "flexibility",
				"salience": 0.00027624232,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00027549278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.00027549278,
				"type": "LOCATION"
			},
			{
				"name": "hand",
				"salience": 0.0002741762,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0002741762,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0002741762,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.0002741762,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0002741762,
				"type": "PERSON"
			},
			{
				"name": "Court",
				"salience": 0.0002741762,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03jt40",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democrat_Party_(Thailand)"
				},
				"name": "Democrat Party",
				"salience": 0.00027107092,
				"type": "ORGANIZATION"
			},
			{
				"name": "personalities",
				"salience": 0.0002625761,
				"type": "PERSON"
			},
			{
				"name": "sort",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "soil",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0002625761,
				"type": "PERSON"
			},
			{
				"name": "supply chains",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "rerun",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "intelligence agencies",
				"salience": 0.0002625761,
				"type": "ORGANIZATION"
			},
			{
				"name": "motives",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "fiasco",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "deliveries",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "airliners",
				"salience": 0.0002625761,
				"type": "ORGANIZATION"
			},
			{
				"name": "reports",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "publicity",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "catastrophe",
				"salience": 0.0002625761,
				"type": "OTHER"
			},
			{
				"name": "occasions",
				"salience": 0.0002625761,
				"type": "EVENT"
			},
			{
				"name": "Some",
				"salience": 0.00025408383,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00025302003,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00025302003,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0002527719,
				"type": "OTHER"
			},
			{
				"name": "task",
				"salience": 0.0002527719,
				"type": "OTHER"
			},
			{
				"name": "innocents",
				"salience": 0.0002527719,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.0002527719,
				"type": "EVENT"
			},
			{
				"name": "destruction",
				"salience": 0.0002527719,
				"type": "OTHER"
			},
			{
				"name": "skies",
				"salience": 0.0002527719,
				"type": "LOCATION"
			},
			{
				"name": "neocons",
				"salience": 0.0002527719,
				"type": "OTHER"
			},
			{
				"name": "seas",
				"salience": 0.0002527719,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0002527719,
				"type": "OTHER"
			},
			{
				"name": "cessation",
				"salience": 0.0002527719,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0002527719,
				"type": "ORGANIZATION"
			},
			{
				"name": "military-industrial complex",
				"salience": 0.0002527719,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.000252086,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01p9wn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anders_Fogh_Rasmussen"
				},
				"name": "Anders Fogh Rasmussen",
				"salience": 0.00025124653,
				"type": "PERSON"
			},
			{
				"name": "participation",
				"salience": 0.00024983086,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.00024983086,
				"type": "EVENT"
			},
			{
				"name": "scandals",
				"salience": 0.00024754595,
				"type": "OTHER"
			},
			{
				"name": "generals",
				"salience": 0.00024754595,
				"type": "PERSON"
			},
			{
				"name": "anywhere",
				"salience": 0.00024754595,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.00024754595,
				"type": "OTHER"
			},
			{
				"name": "dictators",
				"salience": 0.00024754595,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.00024754595,
				"type": "OTHER"
			},
			{
				"name": "scandals",
				"salience": 0.00024754595,
				"type": "OTHER"
			},
			{
				"name": "stink",
				"salience": 0.00024754595,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.00024668188,
				"type": "OTHER"
			},
			{
				"name": "noses",
				"salience": 0.00024643991,
				"type": "OTHER"
			},
			{
				"name": "drone attacks",
				"salience": 0.0002365204,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hz2r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rome_Statute_of_the_International_Criminal_Court"
				},
				"name": "Rome Statute of the International Criminal Court",
				"salience": 0.00023363413,
				"type": "WORK_OF_ART"
			},
			{
				"name": "War",
				"salience": 0.00023272398,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00023272398,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.00023050129,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03ynh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Imperialism"
				},
				"name": "Imperialism",
				"salience": 0.00023050129,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.00023050129,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.00023050129,
				"type": "ORGANIZATION"
			},
			{
				"name": "resolution",
				"salience": 0.00022940479,
				"type": "OTHER"
			},
			{
				"name": "ISIS-Daesh",
				"salience": 0.00022374904,
				"type": "ORGANIZATION"
			},
			{
				"name": "extremism",
				"salience": 0.00022168971,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00022168971,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00022168971,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.00022168971,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.00022168971,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00022032479,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00021821425,
				"type": "LOCATION"
			},
			{
				"name": "multipolarity",
				"salience": 0.00021530679,
				"type": "OTHER"
			},
			{
				"name": "button",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "intelligence sources",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "detainees",
				"salience": 0.0002143448,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0002143448,
				"type": "PERSON"
			},
			{
				"name": "theory",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "economies",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "chattels",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "genocide",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "Nobody",
				"salience": 0.0002143448,
				"type": "PERSON"
			},
			{
				"name": "concern",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "critics",
				"salience": 0.0002143448,
				"type": "PERSON"
			},
			{
				"name": "pretext",
				"salience": 0.0002143448,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00021361992,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00020933892,
				"type": "LOCATION"
			},
			{
				"name": "era",
				"salience": 0.00020634118,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00020634118,
				"type": "OTHER"
			},
			{
				"name": "world domination strategies",
				"salience": 0.00020479778,
				"type": "OTHER"
			},
			{
				"name": "t humanity",
				"salience": 0.00020479778,
				"type": "PERSON"
			},
			{
				"name": "suffering",
				"salience": 0.00020374027,
				"type": "EVENT"
			},
			{
				"name": "Boy Trumpeters",
				"salience": 0.00019892427,
				"type": "PERSON"
			},
			{
				"name": "Trumpeters",
				"salience": 0.00019892427,
				"type": "PERSON"
			},
			{
				"name": "alternative",
				"salience": 0.0001986364,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0001986364,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.0001986364,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01531v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northern_Europe"
				},
				"name": "Northern Europe",
				"salience": 0.00019486803,
				"type": "LOCATION"
			},
			{
				"name": "presidency",
				"salience": 0.000190064,
				"type": "OTHER"
			},
			{
				"name": "risks",
				"salience": 0.0001875856,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09h5_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FIM-92_Stinger"
				},
				"name": "Stinger",
				"salience": 0.00018662291,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.00018490524,
				"type": "EVENT"
			},
			{
				"name": "supporters",
				"salience": 0.00018490524,
				"type": "PERSON"
			},
			{
				"name": "future",
				"salience": 0.00018490524,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.00018490524,
				"type": "OTHER"
			},
			{
				"name": "domination",
				"salience": 0.00018490524,
				"type": "OTHER"
			},
			{
				"name": "military power",
				"salience": 0.00018490524,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.00018193717,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.00018016757,
				"type": "LOCATION"
			},
			{
				"name": "intelligence",
				"salience": 0.00017814591,
				"type": "OTHER"
			},
			{
				"name": "model intervention",
				"salience": 0.00017814591,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0001760526,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00017383344,
				"type": "EVENT"
			},
			{
				"name": "defense attaché",
				"salience": 0.0001722435,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime change",
				"salience": 0.00017058842,
				"type": "EVENT"
			},
			{
				"name": "fatality",
				"salience": 0.00017058842,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00017001151,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00016931743,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00016931743,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00016931743,
				"type": "LOCATION"
			},
			{
				"name": "Militia bands",
				"salience": 0.00016919411,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ps9k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicolas_Sarkozy"
				},
				"name": "Sarkozy",
				"salience": 0.00016365478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra",
				"salience": 0.00016159187,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0266lb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Cameron"
				},
				"name": "David Cameron",
				"salience": 0.00016159187,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.00016144272,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.00016144272,
				"type": "LOCATION"
			},
			{
				"name": "military mission",
				"salience": 0.00016144272,
				"type": "OTHER"
			},
			{
				"name": "discussions",
				"salience": 0.00016109785,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.00016093558,
				"type": "PERSON"
			},
			{
				"name": "ground operations",
				"salience": 0.00016010454,
				"type": "OTHER"
			},
			{
				"name": "military adventures",
				"salience": 0.00016010454,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00016010454,
				"type": "OTHER"
			},
			{
				"name": "gangs",
				"salience": 0.00016010454,
				"type": "PERSON"
			},
			{
				"name": "instability",
				"salience": 0.00016010454,
				"type": "OTHER"
			},
			{
				"name": "turn",
				"salience": 0.00016010454,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.00016010454,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.00016010454,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00016010454,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.00016010454,
				"type": "EVENT"
			},
			{
				"name": "coalition",
				"salience": 0.00016010454,
				"type": "ORGANIZATION"
			},
			{
				"name": "Washington-Brussels",
				"salience": 0.00015555783,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.00015555783,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00015555783,
				"type": "LOCATION"
			},
			{
				"name": "turmoil",
				"salience": 0.0001548178,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.00015425173,
				"type": "PERSON"
			},
			{
				"name": "pumping stations",
				"salience": 0.00015425173,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.00015234153,
				"type": "LOCATION"
			},
			{
				"name": "emergence",
				"salience": 0.00015218323,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.00014985714,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00014985714,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00014914089,
				"type": "OTHER"
			},
			{
				"name": "indications",
				"salience": 0.00014914089,
				"type": "OTHER"
			},
			{
				"name": "Insurrections",
				"salience": 0.00014914089,
				"type": "OTHER"
			},
			{
				"name": "Wars",
				"salience": 0.00014914089,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0001485858,
				"type": "ORGANIZATION"
			},
			{
				"name": "parts",
				"salience": 0.00014297059,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.00013465392,
				"type": "OTHER"
			},
			{
				"name": "Multipolarity",
				"salience": 0.00013465392,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00013465392,
				"type": "LOCATION"
			},
			{
				"name": "Turmoil",
				"salience": 0.00013465392,
				"type": "OTHER"
			},
			{
				"name": "deputy head",
				"salience": 0.00013465392,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.00013465392,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.00013465392,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0001324924,
				"type": "PERSON"
			},
			{
				"name": "Vote Hillary",
				"salience": 0.00013190808,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00012865604,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0001260325,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/051nv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mujahideen"
				},
				"name": "Mujahideen",
				"salience": 0.00012547214,
				"type": "ORGANIZATION"
			},
			{
				"name": "defense analyst",
				"salience": 0.0001242276,
				"type": "PERSON"
			},
			{
				"name": "evaluations",
				"salience": 0.00012111541,
				"type": "WORK_OF_ART"
			},
			{
				"name": "women",
				"salience": 0.00012058824,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.00012058824,
				"type": "OTHER"
			},
			{
				"name": "coordination",
				"salience": 0.00011808118,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00011659269,
				"type": "OTHER"
			},
			{
				"name": "armies",
				"salience": 0.00011659269,
				"type": "ORGANIZATION"
			},
			{
				"name": "material",
				"salience": 0.00011659269,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00011659269,
				"type": "EVENT"
			},
			{
				"name": "east",
				"salience": 0.00011659269,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.00011659269,
				"type": "OTHER"
			},
			{
				"name": "chemical",
				"salience": 0.00011659269,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.00011659269,
				"type": "OTHER"
			},
			{
				"name": "tension",
				"salience": 0.00011659269,
				"type": "OTHER"
			},
			{
				"name": "business magazine",
				"salience": 0.00011659269,
				"type": "ORGANIZATION"
			},
			{
				"name": "books",
				"salience": 0.00011659269,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Fabric Wings",
				"salience": 0.00011659269,
				"type": "ORGANIZATION"
			},
			{
				"name": "achievement",
				"salience": 0.00011659269,
				"type": "OTHER"
			},
			{
				"name": "redeployment",
				"salience": 0.000112238835,
				"type": "EVENT"
			},
			{
				"name": "murder",
				"salience": 0.00011139925,
				"type": "EVENT"
			},
			{
				"name": "blitz",
				"salience": 0.00011139925,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00011139925,
				"type": "OTHER"
			},
			{
				"name": "mistake",
				"salience": 0.00011082398,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00011082398,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0179qd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Telegraph"
				},
				"name": "Daily Telegraph",
				"salience": 0.000104979066,
				"type": "ORGANIZATION"
			},
			{
				"name": "Government of National Accord",
				"salience": 0.0001012761,
				"type": "ORGANIZATION"
			},
			{
				"name": "community",
				"salience": 0.00010057808,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.00010057808,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.00010057808,
				"type": "OTHER"
			},
			{
				"name": "Unipolarity",
				"salience": 0.000099784935,
				"type": "ORGANIZATION"
			},
			{
				"name": "Coups & Terror",
				"salience": 0.000099350604,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/052dhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takfiri"
				},
				"name": "Takfiri",
				"salience": 0.00009852706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000098193836,
				"type": "LOCATION"
			},
			{
				"name": "resolution",
				"salience": 0.00009560168,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.000095174495,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.000095174495,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06nn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Asia"
				},
				"name": "South Asian",
				"salience": 0.00009449209,
				"type": "LOCATION"
			},
			{
				"name": "column",
				"salience": 0.00009397473,
				"type": "WORK_OF_ART"
			},
			{
				"name": "adherents",
				"salience": 0.0000927901,
				"type": "PERSON"
			},
			{
				"name": "fault",
				"salience": 0.0000927901,
				"type": "OTHER"
			},
			{
				"name": "shambles",
				"salience": 0.0000927901,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.00009177983,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07pql3r"
				},
				"name": "Army",
				"salience": 0.00009177983,
				"type": "ORGANIZATION"
			},
			{
				"name": "pipelines",
				"salience": 0.00009162039,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.00009162039,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00008708718,
				"type": "OTHER"
			},
			{
				"name": "equation",
				"salience": 0.00008708718,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.00008708718,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00008708718,
				"type": "PERSON"
			},
			{
				"name": "influence",
				"salience": 0.00008708718,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.00008708718,
				"type": "OTHER"
			},
			{
				"name": "devastation",
				"salience": 0.00008708718,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.00008708718,
				"type": "OTHER"
			},
			{
				"name": "human beings",
				"salience": 0.00008708718,
				"type": "PERSON"
			},
			{
				"name": "anarchy",
				"salience": 0.00008708718,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australian",
				"salience": 0.00008286435,
				"type": "LOCATION"
			},
			{
				"name": "Drones: A History of Military Aviation",
				"salience": 0.00008286435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australian",
				"salience": 0.00008286435,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00007917321,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rrs4z"
				},
				"name": "Blue Chip",
				"salience": 0.00007174934,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00007174934,
				"type": "ORGANIZATION"
			},
			{
				"name": "Army Journal Hilal",
				"salience": 0.00007174934,
				"type": "PERSON"
			},
			{
				"name": "Strategic Culture Foundation",
				"salience": 0.00007174934,
				"type": "ORGANIZATION"
			},
			{
				"name": "IHS Global",
				"salience": 0.00007174934,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00007174934,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Story of the Royal Artillery",
				"salience": 0.00007174934,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Supersonic Fighters",
				"salience": 0.00007174934,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04f30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmir"
				},
				"name": "Kashmir",
				"salience": 0.00007174934,
				"type": "LOCATION"
			},
			{
				"name": "IHS/Jane's Sentinel",
				"salience": 0.00007174934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05hwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khyber_Pakhtunkhwa"
				},
				"name": "Northwest Frontier",
				"salience": 0.00007174934,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/024_zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CounterPunch"
				},
				"name": "Counterpunch",
				"salience": 0.000058874335,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.000053591662,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.000053591662,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0c3c27q"
				},
				"name": "A History of The Pakistan Army",
				"salience": 0.00003497144,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/BrianCloughley_77db3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 33.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.002",
		"text": "18 Shares\n17 0 0 1\nMohsen Abdelmoumen : Don't you think that we are in a continuation of the cold war between the USA and its allies in NATO on one side and China and Russia on the other, and who has interest to provoke a confrontation between these superpowers?\nBrian Cloughley: It’s not so much a continuation as a resurrection of the Cold War. After the Warsaw Pact disbanded in March 1991, NATO, although deprived of any reason to continue in existence, managed to keep going, and in 1999 added Poland, the Czech Republic and Hungary to its 16 members. As the BBC noted, these countries became “the first former Soviet bloc states to join NATO, taking the alliance’s borders some 400 miles towards Russia.” With good reason Moscow wondered what on earth the US-NATO military alliance might be planning.\nIn spite of facing no threat whatever from any country in the world, NATO continued to expand around Russia’s borders, inviting Bulgaria, Estonia, Latvia, Lithuania, Romania, Slovakia and Slovenia to join in 2002, which they did two years later.\nAs President Putin observed in an interview with Italy’s Corriere della Sera “we are not expanding anywhere; it is NATO infrastructure, including military infrastructure, that is moving towards our borders. Is this a manifestation of our aggression?”\nThe US is also implacably hostile to China and does what it can to provoke it in the South China Sea, but NATO has not yet ventured into Eastern waters.\nMORE... Arise President Trump (or Why it's not the End of the World as We Know it) Trump's sexual predator characteristics - His Grandfather was a pimp, but at least he paid the women he hired The significance of the GOP's attempted purge of Donald Trump Trump, Turkey, and police tyranny: The crisis of Imperialism finds political expression There is certainly confrontation — but it was originated by the western powers at the behest of Washington. It is dangerous to indulge in military menaces, but the US appears determined to continue such a policy, and the world as a whole will certainly not benefit from its posture.\nHow do you explain the silence of the media and Western Governments on the infamous war led by Saudi Arabia against the people of the Yemen?\nThe most important things are money and oil. Western governments and mainstream media may from time to time make statements that “regret” the Saudi war on Yemen, but they will never take action against the Riyadh royal dictatorship that might make it cease its merciless blitz on the Yemeni people. The US State Department records that in Saudi Arabia its “citizens lack the right and legal means to change their government” while there are “pervasive restrictions on universal rights such as freedom of expression, including on the internet, and freedom of assembly, association, movement and religion; and a lack of equal rights for women . . .”, but Washington takes no action to encourage the Saudi monarchy to relax or even modify its domestic tyranny.\nSaudi Arabia is a valued ally of the United States and indulges in “torture and other abuses [and] arbitrary arrest and detention,” while “freedom of religion is neither recognized nor protected under the law.” It might be imagined that the President of the United States might feel it proper to indicate his disapproval of the fact that in Saudi Arabia “civil law does not protect human rights, including freedom of the speech and of the press.” — but no US president will ever do anything to discourage the Saudi monarchy from continuing its domestic tyranny and murder of so many innocents in Yemen.\nDon’t you think that, with Hillary Clinton President of the USA, we’ll have a total war, knowing that she is supported by the neocons and the military-industrial complex?\nUnder a Clinton administration there would have been no cessation of US havoc-wreaking wars around the world, and desperate refugees would have died in their thousands. Her regime would have ensured that the Pentagon’s fleets continue to go down to the seas in confrontation, and the bombers would have streaked across the skies, deliberately provoking China and Russia. Remember that she is one of the Washington-Brussels war-drum beaters who planned the 2011 aerial blitz on Libya to destroy the government of President Gaddafi, about whose murder she giggled that “ We came; We saw; He died. ” The US-NATO attacks on Libya caused massive suffering and destruction, opened the way for feuding bands of militants to fight each other for control of parts of the country, and created a haven for the lunatic extremists of Islamic State [aka ISIS].\nHillary Clinton has not criticised or questioned Obama’s years of aerial bombardment around the world and her foreign policy adviser, Jeremy Bash, told London’s Daily Telegraph that she would order a “full review” of US strategy on Syria as a “first key task” of her presidency, resetting the policy to emphasise the “murderous” nature of the government. He said that Mrs. Clinton would work to get Bashar al-Assad, the Syrian president, “out of there.”\nPresident Assad has been selected as another target for the Clinton policy of “We came; We Saw; He died,” and his country appears doomed to a rerun of the Libya fiasco.\nIf Hillary Clinton had become President of the United States, as seemed only too likely, there would have been even greater emphasis on global airstrikes and military confrontation. Greater turmoil, chaos and catastrophe were to come.\nSeveral reports mention deliveries of Western arms to groups activated in Syria, weapons that ended up in the hands of terrorist groups, such as ISIS-Daesh and al-Nusra. How do you explain the miscalculation of governments that have delivered weapons to terrorists to find these weapons turned against them, as we have seen in various attacks on European soil?\nThe US supplies weapons to many rebels and insurrectionists around the world. One of the most absurd of these supply chains was in the 1980s when they gave hundreds of Stinger missiles to the Mujahideen in Afghanistan, then had to buy them back for half a million dollars each when it was realised that the Mujahideen were about to use them against civilian airliners. The British have also supplied ground-to-air missiles to insurrectionists groups, with much less publicity but on occasions with serious results. The only explanation for the motives of western governments in doing this sort of thing is that they are poorly informed by their vastly expensive intelligence agencies.\nThe Americans destroyed Iraq with their ally Tony Blair, Sarkozy made the same thing in Libya with David Cameron, how do you explain that these personalities are not judged, in particular via ICC, authority which judges only African despots?\nThe International Criminal Court (ICC) “investigates and, where warranted, tries individuals charged with the gravest crimes of concern to the international community: genocide, war crimes and crimes against humanity.” But the United States “is not at present a party to the Rome Statute of the International Criminal Court” and although Britain and France are in theory supportive of the ICC, there will never — ever — be a political leader of these countries arraigned before the Court for war crimes or anything else. The African despots it judges are no doubt guilty of heinous crimes, but they are also easy to arraign.\nHow do you explain that Hillary Clinton's candidacy was maintained while she does not stop making headlines with multiple scandals?\nBecause the Democrat Party desperately wanted a Democrat president. Members of the Party was prepared to hold their noses with one hand to keep out the stink of Hillary’s scandals while with the other hand pressing the button to Vote Hillary.\nIn your opinion, why do Western Governments continue to support old leaders and despotic regimes and to destabilize others according to their interests under the pretext of \"human rights\", \"democracy\", etc.? Who gave them this right?\nNobody gave them the right to support or destroy any government, anywhere, but Western politicians and generals continues to believe that, as in the old colonial days, they have a mission to alter the lives of those they consider inferior. There is flexibility in this policy, however, because if dictators are important for the economies of the West, they are permitted to torture detainees, treat women as chattels, forbid freedom of religion and imprison critics.\nSome of our European intelligence sources tell us that there was a mass movement of Daesh towards some countries of Northern Europe, result of the offensive on Daesh in Syria and Iraq. How do you explain that such redeployment towards Europe is possible with all the risks of attack that entails? Don’t you think that the coordination between European intelligence fails?\nI do not believe that there has been mass movement of Daesh/IS adherents to northern Europe.\nLibya is a terrorist sanctuary a few kilometers away from Europe. You have an experience in both military and diplomatic, how do you see the resolution of the Libyan equation, is a crisis that can only be resolved militarily or is the policy which should prevail?\nUnlike in Saudi Arabia, for example, in Gaddafi’s prosperous Libya there was freedom of religion and women were regarded as human beings. The entire population received free education and medical care. Then the country was reduced to anarchy by the US-NATO aerial blitz of March-October 2011 (Germany refused to join in), during which, among other devastation, water and oil pipelines and pumping stations were deliberately destroyed. Militia bands took over various parts of the country and continue to fight against each other, while extremist Islamic [Wahhabi] groups have grown in size and influence and the “Government of National Accord” is powerless.\nMany of those who energetically supported the war, such as the former secretary general of NATO, Anders Fogh Rasmussen, continue to claim that it was a success — “a model intervention” — and that it is the fault of “the international community” that the country is a shambles. But even US President Obama admitted that the war on Libya “didn’t work” and that failure to have a plan for the future of the country after the murder of President Gaddafi was “the worst mistake” of his presidency.\nGiven that the Obama presidency is in its last months, it is unlikely he will order an invasion of Libya to try to eradicate the Islamic [aka Takfiri] terrorists and rebuild the country he and his allies destroyed. He and his supporters in Europe, notably France and Britain, will continue clandestine ground operations, drone attacks and conventional airstrikes to try to assassinate extremist leaders and destroy their gangs, but these will fail. It is difficult to predict the future in Libya, other than to say that it is most likely that its people will continue suffering the appalling effects of the US-NATO war, and that there will be no peaceful resolution of its problems.\nIs the era of the American domination a fatality? Doesn ' t humanity may find it beneficial to see the emergence of a multipolar world ?\nIt should be remembered that in an August 2014 interview with the New York Times President Obama said “Our participation in the coalition that overthrew Qaddafi [emphasis added] in Libya. I absolutely believed that it was the right thing to do.” The name of the game is regime change, but America, the “indispensable nation” has failed in its military adventures all over the world and has created widening instability which in turn has led to growth in extremism and terrorism. Unipolarity, with the US possessing and exercising most military power, has not worked.\nIt appears that multipolarity might be a better alternative, with other nations restraining Washington from unilateral intervention aimed at overthrowing governments, but it is apparent that the US is determined to do all it can to prevent interference in its world domination strategies. In consequence it has engaged in a deliberate policy of confrontation with China and Russia that is entirely counter-productive and could well lead to war. Multipolarity would probably benefit humanity, but that is irrelevant to the indispensable nation.\nWhat do you think of the defeat of Hillary Clinton and the victory of Donald Trump?\nMr. Trump has not elucidated a foreign policy as such, and we can only hope that he will build on the positive indications he has given about America ceasing to meddle militarily all round the world. His greatest achievement would be engage in positive discussions with Russia and China, which would result in vastly diminished tension in east and west. The defeat of Clinton has meant that the threat of US international confrontation has at least diminished, because the world would have been a very dangerous place if she had got in to the White House.\nInterview realized by Mohsen Abdelmoumen\nWho is Brian Cloughley?\nBrian Cloughley is a British and Australian armies’ veteran, former deputy head of the UN military mission in Kashmir and Australian defense attaché in Pakistan.\nHe studied South Asian affairs for forty years and is South Asia defense analyst for IHS/Jane's Sentinel, covering Afghanistan, India and Pakistan, updating material regularly. Other evaluations include updating of nuclear, biological, chemical and radiological developments in the region for IHS Global. He has a weekly column in Strategic Culture Foundation and contribute pieces elsewhere, including Counterpunch , Pakistan's Army Journal Hilal and the business magazine Blue Chip .\nBrian Cloughley wrote books including A History of The Pakistan Army: Wars and Insurrections; War, Coups & Terror: Pakistan’s Army in Years of Turmoil; Trumpeters: The Story of the Royal Artillery’s Boy Trumpeters; From Fabric Wings to Supersonic Fighters and Drones: A History of Military Aviation on both sides of the Northwest Frontier.\nHis website: http://www.beecluff.com/",
		"thread_title": "Brian Cloughley: “The Greatest Achievement of Mr. Trump would be Engage in Positive Discussions with Russia and China”",
		"title": "Brian Cloughley: “The Greatest Achievement of Mr. Trump would be Engage in Positive Discussions with Russia and China”",
		"type": "bs",
		"uuid": "cd013bdded3eef1559b80c7886cbc4f8ed0c3239"
	},
	"-KhIbVZQmM0Df_VVpZlD": {
		"author": "Meriem Kheira Peillet",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-13T03:01:43.659+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "ignorance",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Balfour_Declaration_a9ceb.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-11-12T21:34:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.009",
		"text": "I am very sorry for your arrogant ignorance...",
		"thread_title": "Why Palestinians Want to Sue Britain: 99 Years since the Balfour Declaration",
		"title": "",
		"type": "bs",
		"uuid": "deb709c245abb305c1155f192eae2804d7ca6d72"
	},
	"-KhIbVsiBXxiJ50IuAEt": {
		"author": "Matt Peppe",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-13T03:16:59.773+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.19709662,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.10373165,
				"type": "LOCATION"
			},
			{
				"name": "Foreign Policy Commission Abolfazl Hassan Beiki",
				"salience": 0.08608956,
				"type": "PERSON"
			},
			{
				"name": "sabotage acts",
				"salience": 0.029718451,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.028068122,
				"type": "OTHER"
			},
			{
				"name": "provinces",
				"salience": 0.02553007,
				"type": "LOCATION"
			},
			{
				"name": "Ramezan Sharif",
				"salience": 0.025430301,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ftlx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tehran"
				},
				"name": "Tehran",
				"salience": 0.022383174,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04q3gn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Army_of_the_Guardians_of_the_Islamic_Revolution"
				},
				"name": "IRGC",
				"salience": 0.021710858,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.021045908,
				"type": "ORGANIZATION"
			},
			{
				"name": "explosives",
				"salience": 0.019996066,
				"type": "OTHER"
			},
			{
				"name": "assassination attempts",
				"salience": 0.019996066,
				"type": "EVENT"
			},
			{
				"name": "parliament",
				"salience": 0.017329646,
				"type": "ORGANIZATION"
			},
			{
				"name": "Deputy Chairman",
				"salience": 0.017329646,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.017249333,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01jwvm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_security"
				},
				"name": "National Security",
				"salience": 0.013658591,
				"type": "ORGANIZATION"
			},
			{
				"name": "provinces",
				"salience": 0.013088509,
				"type": "LOCATION"
			},
			{
				"name": "terrorist team",
				"salience": 0.012570622,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01724r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_(Govia_Thameslink_Railway)"
				},
				"name": "Southern",
				"salience": 0.01068841,
				"type": "LOCATION"
			},
			{
				"name": "assassination attempts",
				"salience": 0.010241862,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.009972775,
				"type": "ORGANIZATION"
			},
			{
				"name": "footprints",
				"salience": 0.008872165,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.007584185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018hq1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southwestern_United_States"
				},
				"name": "Southwestern",
				"salience": 0.006988408,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0062341294,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c10fn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southeastern_(train_operating_company)"
				},
				"name": "Southeastern",
				"salience": 0.0059058117,
				"type": "ORGANIZATION"
			},
			{
				"name": "clashes",
				"salience": 0.0055913217,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/029mz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khuzestan_Province"
				},
				"name": "Khouzestan",
				"salience": 0.0054659937,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/029n2p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sistan_and_Baluchestan_Province"
				},
				"name": "Sistan",
				"salience": 0.005333134,
				"type": "LOCATION"
			},
			{
				"name": "Balouchestan",
				"salience": 0.005333134,
				"type": "OTHER"
			},
			{
				"name": "terrorist team",
				"salience": 0.005251312,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence ministry",
				"salience": 0.00524617,
				"type": "ORGANIZATION"
			},
			{
				"name": "explosives",
				"salience": 0.0042226585,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0041826586,
				"type": "PERSON"
			},
			{
				"name": "terrorist groups",
				"salience": 0.004000008,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist groups",
				"salience": 0.0038508226,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chief of Staff",
				"salience": 0.0036569305,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0036569305,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.003570581,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/029n4h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan_Province"
				},
				"name": "Kurdistan",
				"salience": 0.0035342409,
				"type": "LOCATION"
			},
			{
				"name": "terrorist team",
				"salience": 0.0034570834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0613rs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Garmsar"
				},
				"name": "Garmsar",
				"salience": 0.0034231192,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0034174996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/011b0dk8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Armed_Forces_of_the_Islamic_Republic_of_Iran"
				},
				"name": "Iranian Armed Forces",
				"salience": 0.003324969,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.0032796906,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.0032659722,
				"type": "ORGANIZATION"
			},
			{
				"name": "teams",
				"salience": 0.0032659722,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0032253165,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.0031573414,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.003125239,
				"type": "PERSON"
			},
			{
				"name": "embassies",
				"salience": 0.0028509183,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0026677598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0025920584,
				"type": "PERSON"
			},
			{
				"name": "scholar",
				"salience": 0.0025645047,
				"type": "PERSON"
			},
			{
				"name": "promises",
				"salience": 0.0025645047,
				"type": "OTHER"
			},
			{
				"name": "auctions",
				"salience": 0.0025645047,
				"type": "OTHER"
			},
			{
				"name": "mercenaries",
				"salience": 0.0025645047,
				"type": "PERSON"
			},
			{
				"name": "sex slaves",
				"salience": 0.0025645047,
				"type": "PERSON"
			},
			{
				"name": "measures",
				"salience": 0.002468813,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.002468813,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0024401068,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0024401068,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.0024178044,
				"type": "PERSON"
			},
			{
				"name": "remarks",
				"salience": 0.0023467506,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.0023101836,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.002251428,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.002251428,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.002251428,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03hz03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Raqqah"
				},
				"name": "Raqqa",
				"salience": 0.002251428,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.002251428,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0021654104,
				"type": "LOCATION"
			},
			{
				"name": "Picture",
				"salience": 0.0021474727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "car accident",
				"salience": 0.0020937072,
				"type": "EVENT"
			},
			{
				"name": "stunt gun",
				"salience": 0.0020937072,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vegetable vendor",
				"salience": 0.0020937072,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0020937072,
				"type": "OTHER"
			},
			{
				"name": "bellwether",
				"salience": 0.0020937072,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0020937072,
				"type": "EVENT"
			},
			{
				"name": "sabotage operations",
				"salience": 0.0020937072,
				"type": "OTHER"
			},
			{
				"name": "insecurity",
				"salience": 0.0020005025,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0020005025,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0019431589,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0019431589,
				"type": "PERSON"
			},
			{
				"name": "Head",
				"salience": 0.0019403483,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0pd7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Army"
				},
				"name": "Ground Force",
				"salience": 0.0019035564,
				"type": "ORGANIZATION"
			},
			{
				"name": "embassies",
				"salience": 0.0018293301,
				"type": "LOCATION"
			},
			{
				"name": "Mecca Saudi",
				"salience": 0.0018230538,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.0018062824,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0018062824,
				"type": "LOCATION"
			},
			{
				"name": "intelligence",
				"salience": 0.0018062824,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0017773021,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.0016826495,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01fgl7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_republic"
				},
				"name": "Islamic Republic",
				"salience": 0.0015786375,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01h7l_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yazidis"
				},
				"name": "Yazidi",
				"salience": 0.0015786375,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0015786375,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hadka",
				"salience": 0.0015786375,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.001577181,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0015641135,
				"type": "LOCATION"
			},
			{
				"name": "light",
				"salience": 0.0015641135,
				"type": "OTHER"
			},
			{
				"name": "trans",
				"salience": 0.0015641135,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0015641135,
				"type": "OTHER"
			},
			{
				"name": "vehicles",
				"salience": 0.0015641135,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "night-vision goggles",
				"salience": 0.0015641135,
				"type": "OTHER"
			},
			{
				"name": "Islamic Revolution Guards Corps Public Relations Department",
				"salience": 0.0015197132,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0015197132,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0015197132,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0014629873,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0014570478,
				"type": "LOCATION"
			},
			{
				"name": "insecurity",
				"salience": 0.0014570478,
				"type": "OTHER"
			},
			{
				"name": "border guards",
				"salience": 0.0013155655,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.0013155655,
				"type": "LOCATION"
			},
			{
				"name": "The Bin Ladens",
				"salience": 0.001288748,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.0012569862,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0011781876,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.0011391615,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0011391615,
				"type": "OTHER"
			},
			{
				"name": "insecurity",
				"salience": 0.0010884341,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0010884341,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0010884341,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/057d1j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Province,_Zambia"
				},
				"name": "Western province",
				"salience": 0.0010356719,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06dkj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Komalah"
				},
				"name": "Komala",
				"salience": 0.0010135266,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08z65k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sardasht,_West_Azerbaijan"
				},
				"name": "Sardasht",
				"salience": 0.0009881417,
				"type": "LOCATION"
			},
			{
				"name": "border region",
				"salience": 0.000982733,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.000982733,
				"type": "OTHER"
			},
			{
				"name": "Jeish al-Adl",
				"salience": 0.0009626979,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07mb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toyota"
				},
				"name": "Toyota",
				"salience": 0.0009626979,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03jt40",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democrat_Party_(Thailand)"
				},
				"name": "Democrat Party",
				"salience": 0.0008967873,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.00085562904,
				"type": "LOCATION"
			},
			{
				"name": "statements",
				"salience": 0.0008547641,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0008509454,
				"type": "PERSON"
			},
			{
				"name": "ammunition",
				"salience": 0.0008509454,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.0008509454,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/027qhys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saravan,_Iran"
				},
				"name": "Saravan",
				"salience": 0.00079649006,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/092rym",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baneh"
				},
				"name": "Baneh",
				"salience": 0.0007011046,
				"type": "LOCATION"
			},
			{
				"name": "Khalfi",
				"salience": 0.0007011046,
				"type": "PERSON"
			},
			{
				"name": "Kouhak",
				"salience": 0.0005237002,
				"type": "LOCATION"
			},
			{
				"name": "commander",
				"salience": 0.00041481125,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Hasan_Beigi_bebf7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Deputy Chairman of the Iranian parliament's National Security and Foreign Policy Commission Abolfazl Hassan Beiki accused Saudi Arabia of orchestrating several assassination attempts in the Southern provinces of Iran and plotting to blow up three tons of explosives in Tehran. 8 Shares\n5 2 0 1\n\"We have witnessed the Saudis' footprints in several failed assassination attempts in the two (Southwestern and Southeastern) provinces of Khouzestan and Sistan and Balouchestan,\" Hassan Beiki, also a former advisor to Chief of Staff of the Iranian Armed Forces, said on Saturday.\nHe also said that a terrorist team which was disbanded in Garmsar recently and intended to blow up three tons of explosives in Tehran was affiliated to Riyadh, adding that the arrested terrorists in Garmsar and Tehran had received financial support from Saudi Arabia and had been trained in Iraq's Mosul and Syria's Raqqa.\n\"We should clearly announce that today, the Saudis are adopting measures against our national security through other countries' embassies, and unfortunately, we see today that certain Arab, African and European embassies are accompanying and uttering similar words like the Saudis (against Iran),\" Hassan Beiki said.\nEarlier this week, Head of the Islamic Revolution Guards Corps Public Relations Department General Ramezan Sharif announced that the IRGC forces have dismantled two terrorist groups who sought to carry out sabotage acts inside Iran, adding that they were mercenaries of Saudi Arabia.\n\"By hollow promises, Saudi Arabia attempted to make the terrorist groups, including Komala and the former Democrat group (Democratic Party of Iran's Kurdistan (Hadka) affiliated to Komala party), to confront the Islamic Republic,\" General Sharif said on Tuesday.\nMORE... Picture shows ISIS Yazidi sex slaves sold in horrifying auctions to Saudi Arabia Iran's leading scholar urges Muslims to conquer Mecca Saudi police attacks a vegetable vendor with a stunt gun for being involved in a car accident The Bin Ladens: A Saudi bellwether \"Two 12-member and 16-member teams of Democrat who had entered Iran for sabotage operations were disbanded by the IRGC's Ground Force and the intelligence ministry before they could do anything noteworthy,\" he added.\nHis remarks came two month after the IRGC dismantled a team of 9 terrorists \"sent by Saudi Arabia to foment insecurity inside the country\".\nThe IRGC killed four of the terrorists, including their commander, and injured two others in the city of Saravan in Sistan and Balouchestan province in Southeastern Iran.\nOfficial statements said the terrorist team which intended to carryout \"sabotage acts inside Iran was disbanded by the IRGC in the Kouhak border region of Saravan city\".\nThe IRGC also destroyed the weapons, ammunition, wireless equipment, night-vision goggles and three Toyota vehicles of the terrorists calling themselves Jeish al-Adl group.\nAlso in September, the Iranian intelligence and security forces dismantled a team of 12 terrorists sent by Saudi Arabia and certain trans-regional states to foment insecurity inside the country.\nThe terrorist team which was equipped with light and semi-heavy weapons and intended to carryout sabotage acts inside Iran was disbanded in the Western bordering areas of Sardasht city through cooperation with the IRGC forces.\nTen terrorists of the outlawed Democrat Party were also killed last month in armed clashes with the Iranian border guards in the Western province of Kurdistan.\nThe terrorists who were trying to sneak into the country through the Western Iranian borders in the village of Baneh and Khalfi in Sardasht region, sought to foment insecurity in Iran's Kurdistan province.\nBased on the latest information, 10 terrorists of the outlawed group were killed during the clashes.",
		"thread_title": "Senior MP Reveals Saudi Arabia's Role in Several Failed Assassination Attempts in Iran",
		"title": "Senior MP Reveals Saudi Arabia's Role in Several Failed Assassination Attempts in Iran",
		"type": "bs",
		"uuid": "65a9f19577f2102f769af9e0ea089e69b5fedc62"
	},
	"-KhIbWcDEPP5qUiEsV3d": {
		"author": "Stephen Yearwood",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-13T03:23:42.560+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/043s3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Locke"
				},
				"name": "John Locke",
				"salience": 0.08690308,
				"type": "PERSON"
			},
			{
				"name": "respect",
				"salience": 0.04812429,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.017614698,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.016106905,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.01584237,
				"type": "ORGANIZATION"
			},
			{
				"name": "liberty",
				"salience": 0.014560991,
				"type": "OTHER"
			},
			{
				"name": "Liberalism",
				"salience": 0.014560991,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.013224534,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.011859787,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.011583802,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.011463136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wc8l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Natural_and_legal_rights"
				},
				"name": "Natural Rights",
				"salience": 0.01087672,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.010789555,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.010256552,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.010031219,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.009649184,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.009426364,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.008995343,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.008928606,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.008645342,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.008644966,
				"type": "OTHER"
			},
			{
				"name": "predicate",
				"salience": 0.007848519,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.007481225,
				"type": "OTHER"
			},
			{
				"name": "libertarianism",
				"salience": 0.0074502006,
				"type": "OTHER"
			},
			{
				"name": "liberalism",
				"salience": 0.0074502006,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0074502006,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.007107151,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0067554615,
				"type": "OTHER"
			},
			{
				"name": "Ants",
				"salience": 0.0067070997,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.005898092,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0055172374,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0055172374,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.0055172374,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0053586336,
				"type": "ORGANIZATION"
			},
			{
				"name": "idea",
				"salience": 0.0053276387,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0052835485,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0049425703,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0049377643,
				"type": "ORGANIZATION"
			},
			{
				"name": "predicate",
				"salience": 0.0046827495,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0046030097,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/048cl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Karl_Marx"
				},
				"name": "Karl Marx",
				"salience": 0.0040342566,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.003986345,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.003986345,
				"type": "OTHER"
			},
			{
				"name": "conservatism",
				"salience": 0.003986345,
				"type": "OTHER"
			},
			{
				"name": "opposite",
				"salience": 0.0038746968,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0037830055,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0037366475,
				"type": "ORGANIZATION"
			},
			{
				"name": "show",
				"salience": 0.0037301686,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Rights",
				"salience": 0.0036595033,
				"type": "OTHER"
			},
			{
				"name": "organizing principles",
				"salience": 0.0035751364,
				"type": "OTHER"
			},
			{
				"name": "insects",
				"salience": 0.003522553,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.0034522035,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0034522035,
				"type": "OTHER"
			},
			{
				"name": "ideologies",
				"salience": 0.0034522035,
				"type": "OTHER"
			},
			{
				"name": "socialism",
				"salience": 0.0034522035,
				"type": "OTHER"
			},
			{
				"name": "elimination",
				"salience": 0.0033484402,
				"type": "OTHER"
			},
			{
				"name": "spoiler",
				"salience": 0.0033484402,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0031595044,
				"type": "PERSON"
			},
			{
				"name": "bees",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "bees",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "sustainability",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "Ants",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "unemployment",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0031171737,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.0030412737,
				"type": "PERSON"
			},
			{
				"name": "capacity",
				"salience": 0.0029498502,
				"type": "OTHER"
			},
			{
				"name": "www.ajustsolution.com",
				"salience": 0.0029047998,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00290003,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0028760114,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0027765865,
				"type": "PERSON"
			},
			{
				"name": "liberty",
				"salience": 0.002773676,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0027623416,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.002699393,
				"type": "OTHER"
			},
			{
				"name": "beings",
				"salience": 0.002699393,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.002699393,
				"type": "OTHER"
			},
			{
				"name": "hamlets",
				"salience": 0.002699393,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation-states",
				"salience": 0.002699393,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.002699393,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.002699393,
				"type": "PERSON"
			},
			{
				"name": "taxation",
				"salience": 0.002699393,
				"type": "OTHER"
			},
			{
				"name": "tract",
				"salience": 0.002699393,
				"type": "OTHER"
			},
			{
				"name": "Page",
				"salience": 0.002699393,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0026229243,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0025061928,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0024925782,
				"type": "PERSON"
			},
			{
				"name": "other",
				"salience": 0.002471317,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0024443069,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0024443069,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0023250734,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.002313143,
				"type": "OTHER"
			},
			{
				"name": "human communities",
				"salience": 0.002272413,
				"type": "OTHER"
			},
			{
				"name": "human communities",
				"salience": 0.002272413,
				"type": "OTHER"
			},
			{
				"name": "human community",
				"salience": 0.002272413,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.002272413,
				"type": "PERSON"
			},
			{
				"name": "human community",
				"salience": 0.002272413,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.002272413,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.002272413,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0022644857,
				"type": "OTHER"
			},
			{
				"name": "organizing principle",
				"salience": 0.002236742,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0022244037,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.0021731902,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.002168711,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.002168711,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0021525135,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0021525135,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0021525135,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0021525135,
				"type": "OTHER"
			},
			{
				"name": "Organizing principle",
				"salience": 0.0020993552,
				"type": "OTHER"
			},
			{
				"name": "organizing principle",
				"salience": 0.0020993552,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0020993552,
				"type": "OTHER"
			},
			{
				"name": "organizing principle",
				"salience": 0.0020993552,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0020749958,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0020721806,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0020721806,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.002063711,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0020377112,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0020377112,
				"type": "OTHER"
			},
			{
				"name": "justice /economics",
				"salience": 0.0020355002,
				"type": "OTHER"
			},
			{
				"name": "processes",
				"salience": 0.0020355002,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0020355002,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0019783697,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.001937486,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.0019369455,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0019369455,
				"type": "OTHER"
			},
			{
				"name": "goods",
				"salience": 0.0019012857,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "liberty",
				"salience": 0.0018723061,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0018723061,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0018646528,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0018646528,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0018646528,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0018646528,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0018472107,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0017632393,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0017572913,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0017572913,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0017572913,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0017488337,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0017337365,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0017337365,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0017337365,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0017280569,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0016998854,
				"type": "OTHER"
			},
			{
				"name": "Rights",
				"salience": 0.0016998854,
				"type": "OTHER"
			},
			{
				"name": "Rights",
				"salience": 0.0016998854,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0016613082,
				"type": "PERSON"
			},
			{
				"name": "conception",
				"salience": 0.0016413997,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.001634117,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0016302655,
				"type": "PERSON"
			},
			{
				"name": "governance",
				"salience": 0.0015933339,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.001593196,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0015812833,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0015812833,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0015812833,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0015812833,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0015581457,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0015385123,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.0015338595,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0015338595,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.0015338595,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.0015338595,
				"type": "OTHER"
			},
			{
				"name": "Equality",
				"salience": 0.0015337267,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0015337267,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0015222586,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0015144008,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.001490752,
				"type": "OTHER"
			},
			{
				"name": "Right",
				"salience": 0.0014785716,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0014624206,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0014578714,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0014578714,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0014578714,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0014320278,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rj_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberty"
				},
				"name": "Liberty",
				"salience": 0.0014296792,
				"type": "ORGANIZATION"
			},
			{
				"name": "era",
				"salience": 0.0014213197,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0014213197,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0013986749,
				"type": "OTHER"
			},
			{
				"name": "Rights",
				"salience": 0.0013877328,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.0013290333,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0013290333,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0013127426,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0013127426,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0013127426,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0013007392,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0013005881,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0012833017,
				"type": "OTHER"
			},
			{
				"name": "History",
				"salience": 0.0012833017,
				"type": "OTHER"
			},
			{
				"name": "whole",
				"salience": 0.0012833017,
				"type": "LOCATION"
			},
			{
				"name": "whole",
				"salience": 0.0012833017,
				"type": "LOCATION"
			},
			{
				"name": "structure",
				"salience": 0.0012833017,
				"type": "OTHER"
			},
			{
				"name": "functioning",
				"salience": 0.0012833017,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0012794203,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0012794203,
				"type": "OTHER"
			},
			{
				"name": "human",
				"salience": 0.0012745956,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.0012585709,
				"type": "OTHER"
			},
			{
				"name": "constraints",
				"salience": 0.001241806,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.0012270141,
				"type": "OTHER"
			},
			{
				"name": "philosopher",
				"salience": 0.0012270141,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0012155701,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0012155701,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0012155701,
				"type": "PERSON"
			},
			{
				"name": "organizing principle",
				"salience": 0.0012016514,
				"type": "OTHER"
			},
			{
				"name": "constraints",
				"salience": 0.001195448,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.0011839641,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0011812431,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0011812431,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0011812431,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0011650912,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0011650912,
				"type": "OTHER"
			},
			{
				"name": "injustice",
				"salience": 0.00115082,
				"type": "OTHER"
			},
			{
				"name": "injustice",
				"salience": 0.00115082,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.001134805,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0011265058,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.0011112186,
				"type": "OTHER"
			},
			{
				"name": "alternatives",
				"salience": 0.0011112186,
				"type": "OTHER"
			},
			{
				"name": "fruition",
				"salience": 0.0011112186,
				"type": "OTHER"
			},
			{
				"name": "happenstance",
				"salience": 0.0011112186,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0011112186,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.0011112186,
				"type": "OTHER"
			},
			{
				"name": "tasks",
				"salience": 0.0011112186,
				"type": "OTHER"
			},
			{
				"name": "stead",
				"salience": 0.0011112186,
				"type": "OTHER"
			},
			{
				"name": "laissez faire",
				"salience": 0.0011112186,
				"type": "EVENT"
			},
			{
				"name": "justice",
				"salience": 0.0011086648,
				"type": "OTHER"
			},
			{
				"name": "conception",
				"salience": 0.0011078576,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.0011021381,
				"type": "OTHER"
			},
			{
				"name": "treatise",
				"salience": 0.0010786728,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ideas",
				"salience": 0.0010786728,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0010786728,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0010745341,
				"type": "OTHER"
			},
			{
				"name": "formulation",
				"salience": 0.001061734,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0010567373,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0010567373,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0010567373,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0010567373,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0010384028,
				"type": "OTHER"
			},
			{
				"name": "treatises",
				"salience": 0.0010384028,
				"type": "OTHER"
			},
			{
				"name": "treatise",
				"salience": 0.0010384028,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0010040047,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0009964962,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0009964962,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0009964962,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0009964962,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0009941765,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.0009923247,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0009826747,
				"type": "LOCATION"
			},
			{
				"name": "governance",
				"salience": 0.0009716502,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.0009716502,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0009592931,
				"type": "OTHER"
			},
			{
				"name": "human society",
				"salience": 0.0009592931,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0009592931,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0009592931,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.00095605623,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.00095605623,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.0009530786,
				"type": "PERSON"
			},
			{
				"name": "account",
				"salience": 0.00094953197,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00094654155,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0009394626,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0009235059,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0009235059,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0009235059,
				"type": "OTHER"
			},
			{
				"name": "human equality",
				"salience": 0.0009235059,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0009203625,
				"type": "OTHER"
			},
			{
				"name": "outcomes",
				"salience": 0.0009118399,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.00089971896,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00089971896,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.00089971896,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00089971896,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.00088441087,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.0008805621,
				"type": "OTHER"
			},
			{
				"name": "contradiction",
				"salience": 0.0008805621,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00087031163,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00087031163,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0008661279,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0008661279,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0008661279,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0008661279,
				"type": "PERSON"
			},
			{
				"name": "topic",
				"salience": 0.0008661279,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0008661279,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0008602767,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0008602767,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0008488158,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.0008406608,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "chances",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "outcomes",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "Outcomes",
				"salience": 0.0008134742,
				"type": "OTHER"
			},
			{
				"name": "thrust",
				"salience": 0.00078900333,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.000779059,
				"type": "PERSON"
			},
			{
				"name": "grants",
				"salience": 0.000779059,
				"type": "OTHER"
			},
			{
				"name": "genderism",
				"salience": 0.000779059,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.000779059,
				"type": "OTHER"
			},
			{
				"name": "virtue",
				"salience": 0.000779059,
				"type": "OTHER"
			},
			{
				"name": "hearts",
				"salience": 0.000779059,
				"type": "OTHER"
			},
			{
				"name": "Lord",
				"salience": 0.000779059,
				"type": "PERSON"
			},
			{
				"name": "predicate",
				"salience": 0.0007772454,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.0007772454,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.00077566865,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00077143224,
				"type": "PERSON"
			},
			{
				"name": "slavery",
				"salience": 0.0007499718,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.0007499718,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.0007499718,
				"type": "OTHER"
			},
			{
				"name": "materialism",
				"salience": 0.0007499718,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.0007499718,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.0007499718,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0007499718,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0007412463,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.00073446735,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.00073446735,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.00073446735,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.00073446735,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00073446735,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00073446735,
				"type": "OTHER"
			},
			{
				"name": "predicate",
				"salience": 0.0007294837,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00072402775,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00072402775,
				"type": "PERSON"
			},
			{
				"name": "liberty",
				"salience": 0.0007141524,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0007141524,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0007141524,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0007141524,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0007141524,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.00070762116,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0007019759,
				"type": "LOCATION"
			},
			{
				"name": "injustice",
				"salience": 0.0007017564,
				"type": "OTHER"
			},
			{
				"name": "requirement",
				"salience": 0.0006647293,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.00065775594,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.00065775594,
				"type": "OTHER"
			},
			{
				"name": "contradictions",
				"salience": 0.00064127956,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0006392653,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03p3db",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Two_Treatises_of_Government"
				},
				"name": "Two Treatises of Government",
				"salience": 0.00063907844,
				"type": "OTHER"
			},
			{
				"name": "determiners",
				"salience": 0.00063596456,
				"type": "PERSON"
			},
			{
				"name": "mayhem",
				"salience": 0.00063596456,
				"type": "OTHER"
			},
			{
				"name": "complaints",
				"salience": 0.00063596456,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.00063596456,
				"type": "OTHER"
			},
			{
				"name": "evaluation",
				"salience": 0.00063596456,
				"type": "OTHER"
			},
			{
				"name": "property trump liberty",
				"salience": 0.00063596456,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.00063596456,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "money",
				"salience": 0.00063596456,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00063381396,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00063381396,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00063381396,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00063381396,
				"type": "PERSON"
			},
			{
				"name": "respect",
				"salience": 0.0006124998,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0006076397,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.0006076397,
				"type": "OTHER"
			},
			{
				"name": "starting point",
				"salience": 0.0006076397,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0006076397,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0005902137,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0005902137,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005762338,
				"type": "PERSON"
			},
			{
				"name": "other",
				"salience": 0.00057485985,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.00056603283,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.00056603283,
				"type": "OTHER"
			},
			{
				"name": "Rights",
				"salience": 0.00056392624,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00056392624,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0005604596,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05jp2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Natural_law"
				},
				"name": "Natural Law",
				"salience": 0.00055371685,
				"type": "ORGANIZATION"
			},
			{
				"name": "anyone",
				"salience": 0.0005486206,
				"type": "PERSON"
			},
			{
				"name": "belief",
				"salience": 0.0005437923,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00054082216,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00054082216,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00054082216,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.00053981465,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.00053981465,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0005285663,
				"type": "ORGANIZATION"
			},
			{
				"name": "governance",
				"salience": 0.0005285663,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.0005285663,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00051105424,
				"type": "OTHER"
			},
			{
				"name": "constraints",
				"salience": 0.00051105424,
				"type": "OTHER"
			},
			{
				"name": "injustice",
				"salience": 0.00051105424,
				"type": "OTHER"
			},
			{
				"name": "injustice",
				"salience": 0.00051105424,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00047945156,
				"type": "LOCATION"
			},
			{
				"name": "Iles",
				"salience": 0.00047945156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greeks",
				"salience": 0.00047945156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Catholic Church",
				"salience": 0.00047945156,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00047945156,
				"type": "PERSON"
			},
			{
				"name": "route",
				"salience": 0.00047503875,
				"type": "OTHER"
			},
			{
				"name": "presumption",
				"salience": 0.00047503875,
				"type": "OTHER"
			},
			{
				"name": "utilitarianism",
				"salience": 0.00047503875,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.00047503875,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.00047503875,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.00047503875,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.00047503875,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00047503875,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00047343224,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00047343224,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00047343224,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015j7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bible"
				},
				"name": "Bible",
				"salience": 0.0004615489,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chances",
				"salience": 0.00044251012,
				"type": "OTHER"
			},
			{
				"name": "conduct",
				"salience": 0.00044251012,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00044086314,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00042598665,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00042598665,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000425689,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.000425689,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.000425689,
				"type": "OTHER"
			},
			{
				"name": "philosophies",
				"salience": 0.00042280028,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00042280028,
				"type": "OTHER"
			},
			{
				"name": "philosophers",
				"salience": 0.00042280028,
				"type": "PERSON"
			},
			{
				"name": "institutions",
				"salience": 0.00040796254,
				"type": "ORGANIZATION"
			},
			{
				"name": "sustainability",
				"salience": 0.0003995277,
				"type": "OTHER"
			},
			{
				"name": "essay",
				"salience": 0.0003995277,
				"type": "WORK_OF_ART"
			},
			{
				"name": "essay",
				"salience": 0.0003995277,
				"type": "WORK_OF_ART"
			},
			{
				"name": "everyone",
				"salience": 0.0003995277,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.0003995277,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0003995277,
				"type": "OTHER"
			},
			{
				"name": "unemployment",
				"salience": 0.0003995277,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.0003995277,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.0003995277,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07c52",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Television"
				},
				"name": "T.V.",
				"salience": 0.00039138083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/039c26",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deadwood_(TV_series)"
				},
				"name": "Deadwood",
				"salience": 0.00039138083,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x3r3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Rawls"
				},
				"name": "John Rawls",
				"salience": 0.00039138083,
				"type": "PERSON"
			},
			{
				"name": "basis",
				"salience": 0.00038951897,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.0003817321,
				"type": "OTHER"
			},
			{
				"name": "Readers",
				"salience": 0.00036583588,
				"type": "PERSON"
			},
			{
				"name": "context",
				"salience": 0.000357795,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00034594018,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.00034594018,
				"type": "OTHER"
			},
			{
				"name": "mode",
				"salience": 0.00034594018,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.00034594018,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.00034594018,
				"type": "EVENT"
			},
			{
				"name": "interactions",
				"salience": 0.00034594018,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bpn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bertrand_Russell"
				},
				"name": "Bertrand Russell",
				"salience": 0.00034040696,
				"type": "PERSON"
			},
			{
				"name": "approach",
				"salience": 0.0003305312,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0003305312,
				"type": "OTHER"
			},
			{
				"name": "ethic",
				"salience": 0.00032613668,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00029842462,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00029842462,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.00029842462,
				"type": "OTHER"
			},
			{
				"name": "functioning",
				"salience": 0.00029842462,
				"type": "OTHER"
			},
			{
				"name": "ethic",
				"salience": 0.00029842462,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.00029842462,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00025839664,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00025839664,
				"type": "OTHER"
			},
			{
				"name": "bottom",
				"salience": 0.00025839664,
				"type": "OTHER"
			},
			{
				"name": "observation",
				"salience": 0.00025839664,
				"type": "OTHER"
			},
			{
				"name": "loathing",
				"salience": 0.00025839664,
				"type": "OTHER"
			},
			{
				"name": "lists",
				"salience": 0.00025839664,
				"type": "OTHER"
			},
			{
				"name": "incivility",
				"salience": 0.00025839664,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00025839664,
				"type": "OTHER"
			},
			{
				"name": "central bank",
				"salience": 0.00025839664,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.00024053341,
				"type": "OTHER"
			},
			{
				"name": "Frederick Nietzsche",
				"salience": 0.00021288842,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h25",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ayn_Rand"
				},
				"name": "Ayn Rand",
				"salience": 0.00021288842,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.00021269191,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0001590132,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/039n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georg_Wilhelm_Friedrich_Hegel"
				},
				"name": "Hegel",
				"salience": 0.0001590132,
				"type": "PERSON"
			},
			{
				"name": "G.W.F.",
				"salience": 0.0001590132,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03sbs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Immanuel_Kant"
				},
				"name": "Immanuel Kant",
				"salience": 0.0001590132,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/John_Locke_8f9bf.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-12T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 34.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "9 Shares\n8 0 0 1\n[ Note: Here \"Liberalism\" (capitalized) refers to an approach to just governance based on equality and liberty. Within that broader, philosophical ideology there are narrower, political ideologies ranging from libertarianism, to conservatism, to liberalism (lower case), to democratic socialism. Mutual respect beats all of them, separately or together. ]\nWe humans are by nature social beings. We live together in organized groups. (Let's call our groups, regardless of size, from hamlets to nation-states, \"communities.\")\nAnts and bees are social insects. They, too, live in organized groups.\nAnts and bees do not have the capacity to decide what the organization of their groups will be. We do.\nIn fact, we humans have no choice but to decide how a community will be organized, which largely determines how it will function. So, governance is an unavoidable issue for us.\nNot to be a spoiler, but the case for using mutual respect for governing governance ends with maximum practical liberty, reinforced political democracy, and a market-based economy. For the citizens of communities with those forms of social organization already in place, the only noticeable changes in their lives would be the elimination of unemployment, poverty, taxation, and public debt—well, those things plus passively helping with environmental sustainability.\n[Curious readers uninterested in slogging through a philosophical tract can go directly to www.ajustsolution.com (Page: real justice /economics).]\nTwo ubiquitous processes of human communities\nEvery human community will always have an economy and a political process. The economy is the process of producing and exchanging goods and services. The political process is the process of effecting choices for the community as a whole. [By \"effecting choices\" I mean choosing among perceived alternatives and taking action to bring that choice to fruition.]\nChoosing how the community's economy will be organized is one of the tasks for the political process. (To go with economic laissez faire is to effect a choice.) Choosing how the community's political process will be organized is itself a choice to be effected for the community as a whole.\nOrganizing principle\nThe structure and overall functioning of the political process is determined by an organizing principle. That principle can be implicit or explicit, secular or religious, consciously derived or a matter of happenstance. For every human community, though, there is always an organizing principle at work.\nHistory teaches us that there is a 'default value' for the organizing principle of communities. That is to say, there is one organizing principle that will be used if no other one is chosen in its stead. In the absence of any other, the organizing principle of human communities will be 'rule by the most ruthless'.\nUnderstandably, people have sought other organizing principles. The Modern era is defined, socially, by the attempt to use some secular conception of justice as an organizing principle for society. In doing that ideology was invented.\n[Karl Marx, whose work has been hugely influential in this era, denied that a principle of justice was at work in his \"scientific\" account of the 'inevitable' development of human society (\"dialectical materialism\"), but his work definitely had a moral content. Otherwise, there can be nothing wrong with \"exploitation,\" even to the point of slavery. To apply any conception of morality to governance can be said to be an attempt at justice.]\nEnter Locke... John Locke\nThe most influential account of justice in the Modern era is that of John Locke. In Two Treatises of Government , published in 1689 in England, he made equality and liberty the basis of justice. Every Western philosopher since him has been required to endorse or refute equality and liberty.\nEquality was the topic of the first of Locke's treatises. Though the thrust of his philosophy was to make governance more secular and less dependent on religion (ideological as opposed to theological), for him equality came from the Bible. In that treatise of his a fundamental moral equality among men is an underlying condition that must be upheld for there to be justice in the governance of a community.\n[A claim of moral equality can be purely secular, but in the England of Locke's time that was no more likely than claiming equality for women was. Also, in that time and place, as among so many others, the topic of governance left women out or treated them as property.]\nIn Locke's second treatise he made a case for liberty as the predicate of justice. He used two accounts of liberty to make that case.\nFirst, Locke asserted that liberty is a 'Natural Right'. He did not invent the idea of Natural Rights. Like so many ideas in Western culture, it can be traced back to the ancient Greeks. It was also discussed by scholars of the medieval Catholic Church—as grants of a kind ordained by God within the 'Natural Law', i.e. the law 'written on the hearts of men' by the Lord.\nThe idea of 'rights' was already deeply ingrained in the people populating the British Iles in Locke's time. Natural Rights is one formulation of the idea that there are certain Rights to which all people are entitled merely by virtue of being human (dropping the genderism). Locke said that the Natural Rights are life, liberty, and property. For people who believe in Natural Rights—or any other form of a priori Rights—for any of those Rights to be arbitrarily violated is on the face of it an injustice.\nIn Locke's other account of liberty as the predicate of justice he started by defining injustice as being \"subject to the arbitrary will\" of another person. Thus, freedom from the arbitrary will of any other person is justice. To be free of the arbitrary will of any other person is obviously at the same time to enjoy liberty. Locke therefore concluded with perfect logic that justice is liberty.\nThe problem Locke left us\nThere are all kinds of problems with liberty as the predicate of justice. On the face of it, can people running around doing whatever they want really be relied upon to result in just outcomes?\nIf justice is liberty, the answer has to be that whatever results from people doing whatever they want is just. Outcomes are beside the point. To see what that would look like, as my good friend who is a doctor is fond of saying, watch any episode of the T.V. show Deadwood . For my money, that show portrays a rather benign version of a community with unconstrained liberty as its organizing principle.\nFor Locke, the Natural Rights of life and property trump liberty of that kind. Everyone's liberty is constrained by those Rights. Yet, liberty itself is also a Right. Bertrand Russell said that Locke was a \"successful\" philosopher because every time he saw a contradiction looming he simply changed the subject.\nWhen constraints are put on liberty to achieve justice, then those constraints become the real determiners of justice. In that case, outcomes do enter into the evaluation of justice. Liberty becomes one possible \"social good\" (from John Rawls) among others.\nSetting aside more philosophical complaints and the chances for violent mayhem ending in rule by the most ruthless, focusing on rights, especially Rights, begets a self-centered approach to life. It's all about ' my right' to do this, have that, etc.\nRights are the basis of governance in the U.S. I blame that approach to governance for the incivility and the loathing to take other people into account that in my observation pervade this nation these days.\nTurning to mutual respect\nDon't get me wrong. I love liberty. I very much doubt anyone could love it more than I do.\nThere is a better way, however, to achieve liberty. That way is mutual respect. As a practical matter, mutual respect would maximize the liberty that co-existing people can enjoy simultaneously. \"Practical\" liberty is (as opposed to some idealized, hypothetical concept) 'real liberty', the liberty we experience in our day-to-day lives.\nAt bottom, \"respect\" in this context simply means taking other people into account. As an ethic it can operate on the personal level, in business, for the structure and overall functioning of the economy, and for the political process itself.\n[Readers should note that having the economy be passively governed by mutual respect would relieve it of being actively governed, as it is at present, by government and a quasi-governmental central bank.]\nMutual respect has a history in Western philosophy, too. It is present in the moral philosophies of both Immanuel Kant and G.W.F. Hegel (ranked one and two, in one order or the other, on most people's lists of 'greatest Modern philosophers'). It is also present in utilitarianism.\nFor that matter, any philosophy that includes, explicitly or implicitly, a belief in human equality includes a presumption of mutual respect. Adopting mutual respect for governing governance does not depend on that or any other belief, but a belief in equality does bring a requirement of mutual respect with it.\nBack to Locke for mutual respect\nThe mutual respect implicit in a belief in equality is manifested in Locke's thought as equal respect for people's Natural Rights. When Locke used a dialectical argument to make liberty the predicate of justice he was standing right in front of mutual respect, but was facing the wrong way, as it were.\nRecall that he defined injustice as being subject to the arbitrary of any other person. The opposite of being in that condition is justice. Since the opposite of being subject to the arbitrary will of anyone else is at the same time being at liberty, Locke surmised that justice is liberty.\nOn the other hand, there is a conclusion to be reached from Locke's starting point that is every bit as logical as the one Locke made. Philosophically, this conclusion beats his because it is more immediate, it raises no contradictions, and it does not result in a predicate of justice that itself must be constrained to prevent rule by the most ruthless. Practically, unlike equality per se and unconstrained liberty, taking this route to justice can efficaciously achieve just governance of both the economy and the political process while maximizing liberty.\n[The most focused readers will have noticed that Locke's definition of injustice must itself be substantiated, but we can leave that for another day. Besides, I've never seen it disputed except, indirectly, by Frederick Nietzsche and Ayn Rand in their hyper-romantic mode.]\nHere it is: if injustice is being subject to the arbitrary will of any other person, then justice requires that everyone refrain from subjecting any other person to one's own arbitrary will.\nWhen people are doing that, justice is the result. No constraints on such behavior are needed.\nTo refrain from arbitrarily subjecting other people to one's will is to take other people into account. To take other people into account is to respect them. So, most simply the predicate of justice is mutual respect.\nClosing\nAs I said at the beginning of this little essay, using mutual respect to govern governance would maximize practical liberty, reinforce political democracy, and retain the definitive institutions of the market-based economy. Applying it to the economy would allow us to eliminate unemployment, poverty, taxes, and public debt while passively enhancing our chances for environmental sustainability. It would also provide a universal ethic to govern personal interactions and the conduct of business.\nHow all of that follows from recognizing mutual respect as the predicate of justice is not all that difficult or complicated, but it is more than can be addressed in one essay. Much, much more is available for consideration at www.ajustsolution.com .",
		"thread_title": "Why Mutual Respect Beats Liberalism - American Herald Tribune",
		"title": "Why Mutual Respect Beats Liberalism - American Herald Tribune",
		"type": "bs",
		"uuid": "8257a9cc1e2006f643722d5459c45c4adc298725"
	},
	"-KhIbWoi940NYVcS6ycT": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-11-13T10:40:38.531+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0261xzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo_Governorate"
				},
				"name": "Aleppo",
				"salience": 0.10689547,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.10546993,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Northern Syria",
				"salience": 0.061152156,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.05391572,
				"type": "LOCATION"
			},
			{
				"name": "Kamal al-Jafa",
				"salience": 0.038928304,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.03292491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qffh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Bab"
				},
				"name": "al-Bab",
				"salience": 0.027280193,
				"type": "LOCATION"
			},
			{
				"name": "Fleet",
				"salience": 0.020924198,
				"type": "OTHER"
			},
			{
				"name": "Strikes",
				"salience": 0.019032141,
				"type": "EVENT"
			},
			{
				"name": "Terrorists",
				"salience": 0.019032141,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.017420126,
				"type": "LOCATION"
			},
			{
				"name": "terrorist groups",
				"salience": 0.017420126,
				"type": "ORGANIZATION"
			},
			{
				"name": "positions",
				"salience": 0.01547201,
				"type": "OTHER"
			},
			{
				"name": "Positions",
				"salience": 0.01547201,
				"type": "OTHER"
			},
			{
				"name": "expert",
				"salience": 0.014655707,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.014300932,
				"type": "PERSON"
			},
			{
				"name": "Navy",
				"salience": 0.014300932,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07806",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_aircraft_carrier_Admiral_Kuznetsov"
				},
				"name": "Admiral Kuznetsov",
				"salience": 0.012799501,
				"type": "PERSON"
			},
			{
				"name": "missile cruiser",
				"salience": 0.012777115,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.011196256,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.011196256,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.011196256,
				"type": "OTHER"
			},
			{
				"name": "waters",
				"salience": 0.011196256,
				"type": "OTHER"
			},
			{
				"name": "warships",
				"salience": 0.011196256,
				"type": "OTHER"
			},
			{
				"name": "affairs",
				"salience": 0.011196256,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.011196256,
				"type": "PERSON"
			},
			{
				"name": "cruise missiles",
				"salience": 0.010279301,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.008928772,
				"type": "LOCATION"
			},
			{
				"name": "cruise missile attacks",
				"salience": 0.007324681,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0069038956,
				"type": "LOCATION"
			},
			{
				"name": "AHT",
				"salience": 0.0069038956,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02hcv8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Time_Zone"
				},
				"name": "Eastern",
				"salience": 0.0069038956,
				"type": "LOCATION"
			},
			{
				"name": "strike",
				"salience": 0.0066793426,
				"type": "EVENT"
			},
			{
				"name": "Western Aleppo",
				"salience": 0.006459005,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.005877223,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0058653816,
				"type": "OTHER"
			},
			{
				"name": "terrorist centers",
				"salience": 0.0057303724,
				"type": "LOCATION"
			},
			{
				"name": "Kaliber",
				"salience": 0.005503424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07s1801"
				},
				"name": "North",
				"salience": 0.0045133866,
				"type": "LOCATION"
			},
			{
				"name": "Kalibr",
				"salience": 0.0044873427,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0036828816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.003529962,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.0033985195,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0033845652,
				"type": "EVENT"
			},
			{
				"name": "Gregorowich",
				"salience": 0.0033743635,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.003313505,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0032686158,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0031899482,
				"type": "OTHER"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.0028855372,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0028239775,
				"type": "PERSON"
			},
			{
				"name": "Sources",
				"salience": 0.0028103704,
				"type": "PERSON"
			},
			{
				"name": "fighter jets",
				"salience": 0.0027635903,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.002726891,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.002718651,
				"type": "PERSON"
			},
			{
				"name": "strikes",
				"salience": 0.002718651,
				"type": "EVENT"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.0027084076,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0027010562,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0026378494,
				"type": "PERSON"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.0026073863,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.0025830884,
				"type": "ORGANIZATION"
			},
			{
				"name": "source",
				"salience": 0.0024759064,
				"type": "PERSON"
			},
			{
				"name": "settlement",
				"salience": 0.0023615104,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0023615104,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0023615104,
				"type": "ORGANIZATION"
			},
			{
				"name": "framework",
				"salience": 0.0023615104,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0023615104,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0023615104,
				"type": "ORGANIZATION"
			},
			{
				"name": "preparations",
				"salience": 0.0023615104,
				"type": "OTHER"
			},
			{
				"name": "implementation",
				"salience": 0.0023615104,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.0023615104,
				"type": "EVENT"
			},
			{
				"name": "influence",
				"salience": 0.0023615104,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0023615104,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023057421,
				"type": "PERSON"
			},
			{
				"name": "positions",
				"salience": 0.002292397,
				"type": "OTHER"
			},
			{
				"name": "reconnaissance operations",
				"salience": 0.002292397,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.002292397,
				"type": "OTHER"
			},
			{
				"name": "aircraft carrier group",
				"salience": 0.0022186888,
				"type": "ORGANIZATION"
			},
			{
				"name": "cruiser",
				"salience": 0.0022113586,
				"type": "PERSON"
			},
			{
				"name": "navy fleet",
				"salience": 0.0022068762,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.0021178746,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.0021178746,
				"type": "OTHER"
			},
			{
				"name": "Large-Scale Military Operation",
				"salience": 0.0020125916,
				"type": "EVENT"
			},
			{
				"name": "source",
				"salience": 0.0019460615,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0019174623,
				"type": "ORGANIZATION"
			},
			{
				"name": "fleet",
				"salience": 0.0018716266,
				"type": "OTHER"
			},
			{
				"name": "navy fleet",
				"salience": 0.0018716266,
				"type": "OTHER"
			},
			{
				"name": "military operation",
				"salience": 0.0018716266,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0018409651,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0018409651,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0018122811,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019cpb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mikoyan_MiG-29"
				},
				"name": "Mig 29",
				"salience": 0.0018047533,
				"type": "ORGANIZATION"
			},
			{
				"name": "missile",
				"salience": 0.0017883219,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0017883219,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0017883219,
				"type": "OTHER"
			},
			{
				"name": "destroyer",
				"salience": 0.0017291115,
				"type": "OTHER"
			},
			{
				"name": "destroyer",
				"salience": 0.0017291115,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.0017226803,
				"type": "EVENT"
			},
			{
				"name": "strike",
				"salience": 0.0017226803,
				"type": "EVENT"
			},
			{
				"name": "strike",
				"salience": 0.0017226803,
				"type": "EVENT"
			},
			{
				"name": "source",
				"salience": 0.0017143755,
				"type": "OTHER"
			},
			{
				"name": "terrorist targets",
				"salience": 0.0016559983,
				"type": "OTHER"
			},
			{
				"name": "reconnaissance flights",
				"salience": 0.0016559983,
				"type": "EVENT"
			},
			{
				"name": "warplanes",
				"salience": 0.0016559983,
				"type": "OTHER"
			},
			{
				"name": "gatherings",
				"salience": 0.0016559983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mediterranean_Sea"
				},
				"name": "Mediterranean Sea",
				"salience": 0.0016415108,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0015942011,
				"type": "ORGANIZATION"
			},
			{
				"name": "coalition",
				"salience": 0.0015942011,
				"type": "ORGANIZATION"
			},
			{
				"name": "sovereignty",
				"salience": 0.0015942011,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0015942011,
				"type": "OTHER"
			},
			{
				"name": "aspirations",
				"salience": 0.0015942011,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0015942011,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0015612603,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.0015133718,
				"type": "EVENT"
			},
			{
				"name": "Northern Syrian",
				"salience": 0.0013585808,
				"type": "LOCATION"
			},
			{
				"name": "province",
				"salience": 0.001351964,
				"type": "LOCATION"
			},
			{
				"name": "source",
				"salience": 0.0013473941,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.0013349309,
				"type": "OTHER"
			},
			{
				"name": "expert",
				"salience": 0.001274609,
				"type": "PERSON"
			},
			{
				"name": "strikes",
				"salience": 0.0012547441,
				"type": "EVENT"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.0012033576,
				"type": "PERSON"
			},
			{
				"name": "battle cruiser",
				"salience": 0.0012033576,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rm8f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sukhoi"
				},
				"name": "Sukhoi",
				"salience": 0.0011771844,
				"type": "ORGANIZATION"
			},
			{
				"name": "Sukhoi 33",
				"salience": 0.0011771844,
				"type": "LOCATION"
			},
			{
				"name": "details",
				"salience": 0.001166354,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0011476397,
				"type": "ORGANIZATION"
			},
			{
				"name": "surface ship",
				"salience": 0.0010625217,
				"type": "OTHER"
			},
			{
				"name": "Criminal West's State Sponsorship of Terrorism",
				"salience": 0.0010193508,
				"type": "ORGANIZATION"
			},
			{
				"name": "type",
				"salience": 0.0010099718,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0009813004,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0009813004,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0009813004,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0009813004,
				"type": "LOCATION"
			},
			{
				"name": "Pyotr Veliky",
				"salience": 0.00094535114,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xp_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defence_minister"
				},
				"name": "Defense Ministry",
				"salience": 0.00094535114,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.00093733374,
				"type": "PERSON"
			},
			{
				"name": "missile strikes",
				"salience": 0.00093733374,
				"type": "EVENT"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.00093379914,
				"type": "OTHER"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.00089894084,
				"type": "ORGANIZATION"
			},
			{
				"name": "details",
				"salience": 0.00088241405,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00087550236,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0008573123,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0008573123,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/073q37",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukrainian_Premier_League"
				},
				"name": "PL",
				"salience": 0.00084277656,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01mlk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caspian_Sea"
				},
				"name": "Caspian Sea",
				"salience": 0.0007951,
				"type": "LOCATION"
			},
			{
				"name": "casualties",
				"salience": 0.0007738402,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.0007355629,
				"type": "LOCATION"
			},
			{
				"name": "transport routes",
				"salience": 0.0007355629,
				"type": "OTHER"
			},
			{
				"name": "base camps",
				"salience": 0.0007355629,
				"type": "LOCATION"
			},
			{
				"name": "facilities",
				"salience": 0.0007355629,
				"type": "LOCATION"
			},
			{
				"name": "storage",
				"salience": 0.0007355629,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.0007355629,
				"type": "OTHER"
			},
			{
				"name": "city residents",
				"salience": 0.0007355629,
				"type": "PERSON"
			},
			{
				"name": "human shields",
				"salience": 0.0007355629,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0007081022,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.00070280663,
				"type": "PERSON"
			},
			{
				"name": "destroyers",
				"salience": 0.00070280663,
				"type": "ORGANIZATION"
			},
			{
				"name": "transfer",
				"salience": 0.00063455256,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "NK",
				"salience": 0.00062161544,
				"type": "LOCATION"
			},
			{
				"name": "stir",
				"salience": 0.0005929006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.0005790555,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0005494546,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b7f30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_battlecruiser_Pyotr_Velikiy"
				},
				"name": "Peter the Great",
				"salience": 0.00045270007,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/053kb5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gazeta.ru"
				},
				"name": "Gazeta.ru",
				"salience": 0.0004306149,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Admiral_Kuznetsov_39bc5.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-13T10:40:38.531+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "BY AHT Staff Russian Navy Fleet Starts Strikes at Terrorists' Positions in Syria's Aleppo Russian warships deployed in Syrian waters targeted the terrorist groups' positions in the Western part of Aleppo city and in the Eastern side of the town of al-Bab, inflicting major damage on the militants, an expert in strategic affairs disclosed on Saturday. 5 Shares 0 1 \nKamal al-Jafa termed Moscow's Kaliber cruise missile attacks on terrorist centers in Western Aleppo city and the town of al-Bab, North of the city, as a sign of the crucial role that the Russian naval forces are to play in Aleppo's Large-Scale Military Operation. \n\"The attacks came as preparations for the implementation of al-Bab operation are over now,\" al-Jafa said. \n\"Turkey tries to increase its role in the diplomatic settlement of Syrian crisis via its influence in al-Bab region,\" he added. \n\"If the Syrian army seizes control of al-Bab within the framework of a coalition with Russia and Iran and diplomatic and logistical support of China, the aspirations and plans of the US, Turkey and even Saudi Arabia will fall flat and the Syrian government's sovereignty in Northern Syrian will be expanded,\" the expert underscored. \nA Russian military and diplomatic source had disclosed earlier today that the Russian fighter jets on 'Admiral Kuznetsov' aircraft carrier and the country's navy fleet would start strikes on terrorists in Aleppo in Northern Syria soon. MORE... The Criminal West’s State Sponsorship of Terrorism \n\"Russian warplanes, on board the Kuznetsov aircraft carrier, will soon hit the positions and gatherings of the terrorist groups in Aleppo,\" the source said. \n\"Mig 29 and Sukhoi 33 fighter jets have taken off Admiral Kuznetsov' aircraft carrier in recent days and have carried out reconnaissance operations over Syria,\" the source added. \n\"Mig 29 and Sukhoi 33 fighter jets' reconnaissance flights were aimed at identifying the new positions of the terrorists and preparing a list of terrorist targets to hand over to the navy fleet (a cruiser and destroyer),\"the sources went on to say. \n\"The Russian fleet, including Admiral Kuznetsov aircraft carrier, 'Pyotr Veliky' nuclear power guided missile cruiser and Admiral Gregorowich destroyer are ready for military operation,\" the source underlined. \nSources in the Russian Defense Ministry disclosed on Tuesday that the country's aircraft carrier group was ready to launch a strike targeting terrorists in the province of Aleppo. \nThe source told Russia's Gazeta that the attack, which would likely engage Kalibr cruise missiles, would target militants outside Aleppo, and not the residential areas. \nThe group, which includes Russia's 'Admiral Kuznetsov' aircraft carrier, 'Pyotr Veliky' nuclear power guided missile cruiser and two destroyers, completed its transfer to the Mediterranean Sea and is getting ready to strike, the Defense Ministry source said. \n\"The group's main goal is to carry out missile strikes on terrorists outside of Aleppo that are attempting to get into the city\", the source added. \nHe also said that Kalibr cruise missiles would be used in the strikes, but did not specify from which ships the missiles would be launched. \nNo Russian surface ship that was currently in the Med was capable of firing the Kalibr-NK missiles, but submarine-launched Kalibr-PL could be used in the strike. The surface-launched type of Kalibr missile could also be launched from the Caspian Sea. \nFinal details of the strike were being worked out, the source told Gazeta.ru, including zeroing in on the terrorists' locations, finding out the details of their transport routes, base camps and storage and training facilities. \n\"The strikes will avoid the city of Aleppo to prevent civilian casualties, because terrorists continue to use city residents as human shields.\" \nEarly in November, a Russian naval group, headed by Admiral Kuznetsov aircraft carrier and the battle cruiser Peter the Great, arrived in the Mediterranean Sea, causing quite a stir in the West.",
		"thread_title": "Russian Navy Fleet Starts Strikes at Terrorists' Positions in Syria's Aleppo",
		"title": "Russian Navy Fleet Starts Strikes at Terrorists' Positions in Syria's Aleppo",
		"type": "bs",
		"uuid": "c7d3131eec20787407513a7ee36b29c5d2863101"
	},
	"-KhIbWt-WwjaxQJgG5Ee": {
		"author": "bcguy",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-14T02:10:20.711+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "anything",
				"salience": 0.82946336,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.060184743,
				"type": "OTHER"
			},
			{
				"name": "race card",
				"salience": 0.05113606,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.038302764,
				"type": "OTHER"
			},
			{
				"name": "MR",
				"salience": 0.020913068,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/lethbridge_d3229.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-11-13T21:11:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 2.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.001",
		"text": "I didn't see anything racist in this.\nIs this how you dispel the truth when you dont agree with it, you just pull a race card. You just exposed yourself MR. In two words you described what you are....Well done.",
		"thread_title": "The B'nai Brith and the History of the Mounting Assault on Academic Freedom in Canadian Universities",
		"title": "",
		"type": "bs",
		"uuid": "e69a0cb5a7433bf78444cbc871878947c6a13486"
	},
	"-KhIbWzwpY0PTh2Dj11X": {
		"author": "Harry Abrams",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-14T02:17:29.953+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "second",
				"salience": 0.59952235,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.09961872,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0974964,
				"type": "OTHER"
			},
			{
				"name": "creation",
				"salience": 0.05986515,
				"type": "OTHER"
			},
			{
				"name": "Paksitan",
				"salience": 0.059661902,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.036658302,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.026991323,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.020185856,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Balfour_Declaration_a9ceb.jpg",
		"ord_in_thread": "3",
		"participants_count": "3",
		"published": "2016-11-13T20:23:00.000+02:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 1.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.009",
		"text": "Think about this for one second. What are the British supposed to do now? It's not a reversible thing. Paksitan was created much the same way as Israel. Do you want to undo the creation of Pakistan? Then what?",
		"thread_title": "Why Palestinians Want to Sue Britain: 99 Years since the Balfour Declaration",
		"title": "",
		"type": "bs",
		"uuid": "fcf6ec0c350585e19e43458bcb1271b610c5437f"
	},
	"-KhIbXFmbGttsffhgy1M": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-14T02:24:23.685+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.32302266,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "U.N.",
				"salience": 0.102699414,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.08396739,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.076102436,
				"type": "LOCATION"
			},
			{
				"name": "Ravina Shamdasani",
				"salience": 0.041408755,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.020208843,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.018263306,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.018263306,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.01583254,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.01583254,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.01583254,
				"type": "LOCATION"
			},
			{
				"name": "chemicals",
				"salience": 0.01583254,
				"type": "OTHER"
			},
			{
				"name": "human rights office",
				"salience": 0.013784271,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.013174208,
				"type": "PERSON"
			},
			{
				"name": "grave",
				"salience": 0.009849405,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.009364291,
				"type": "OTHER"
			},
			{
				"name": "mass graves",
				"salience": 0.008304065,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.008113167,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.006453493,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sf4r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Nicholson_(East_India_Company_officer)"
				},
				"name": "John Nicholson",
				"salience": 0.005852688,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.005396877,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03wky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Space_Station"
				},
				"name": "ISS",
				"salience": 0.0053306893,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.005007313,
				"type": "PERSON"
			},
			{
				"name": "Hammam al-Alil",
				"salience": 0.0050002425,
				"type": "PERSON"
			},
			{
				"name": "Foil ISIS",
				"salience": 0.004295821,
				"type": "ORGANIZATION"
			},
			{
				"name": "reports",
				"salience": 0.004215852,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0038633742,
				"type": "OTHER"
			},
			{
				"name": "execution",
				"salience": 0.0038633742,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.00356473,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.003512769,
				"type": "PERSON"
			},
			{
				"name": "sites",
				"salience": 0.0033459873,
				"type": "OTHER"
			},
			{
				"name": "killing grounds",
				"salience": 0.0033459873,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.0033459873,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0033459873,
				"type": "PERSON"
			},
			{
				"name": "killing fields",
				"salience": 0.0033459873,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0033358799,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0032481118,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.003042265,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0028981268,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.002850674,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0028147863,
				"type": "OTHER"
			},
			{
				"name": "sulfur pits",
				"salience": 0.002802225,
				"type": "OTHER"
			},
			{
				"name": "Video",
				"salience": 0.0027098071,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Child Executioners",
				"salience": 0.0027098071,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.0027098071,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.0026087384,
				"type": "PERSON"
			},
			{
				"name": "sulfur",
				"salience": 0.0026087384,
				"type": "OTHER"
			},
			{
				"name": "radio",
				"salience": 0.0023467282,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0023467282,
				"type": "PERSON"
			},
			{
				"name": "Men",
				"salience": 0.0023467282,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0023467282,
				"type": "OTHER"
			},
			{
				"name": "stockpiles",
				"salience": 0.0022591862,
				"type": "OTHER"
			},
			{
				"name": "proximity",
				"salience": 0.0022591862,
				"type": "OTHER"
			},
			{
				"name": "phosphor projectiles",
				"salience": 0.0022591862,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.0022591862,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0022125212,
				"type": "ORGANIZATION"
			},
			{
				"name": "poles",
				"salience": 0.001916009,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.001916009,
				"type": "ORGANIZATION"
			},
			{
				"name": "details",
				"salience": 0.001916009,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.001916009,
				"type": "OTHER"
			},
			{
				"name": "collaboration",
				"salience": 0.001916009,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0017042694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0016683758,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.0016530305,
				"type": "PERSON"
			},
			{
				"name": "propaganda video",
				"salience": 0.0016530305,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reports",
				"salience": 0.0015794502,
				"type": "OTHER"
			},
			{
				"name": "Khorasan Caliphate",
				"salience": 0.0014697314,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0014447357,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0014447357,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0014447357,
				"type": "LOCATION"
			},
			{
				"name": "Terror Attacks",
				"salience": 0.0014447357,
				"type": "EVENT"
			},
			{
				"name": "battlefield",
				"salience": 0.0014314458,
				"type": "LOCATION"
			},
			{
				"name": "boys",
				"salience": 0.0014314458,
				"type": "PERSON"
			},
			{
				"name": "teenagers",
				"salience": 0.0014314458,
				"type": "PERSON"
			},
			{
				"name": "alleys",
				"salience": 0.0014314458,
				"type": "OTHER"
			},
			{
				"name": "Qayyara",
				"salience": 0.0013908184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07jxbf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul_International_Airport"
				},
				"name": "Mosul airport",
				"salience": 0.0013908184,
				"type": "LOCATION"
			},
			{
				"name": "Tal al-Thahab",
				"salience": 0.0013908184,
				"type": "LOCATION"
			},
			{
				"name": "Old Mosul",
				"salience": 0.0013746441,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.0013732965,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.001333477,
				"type": "PERSON"
			},
			{
				"name": "belts",
				"salience": 0.0012609939,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0012040123,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.0012040123,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.0012040123,
				"type": "PERSON"
			},
			{
				"name": "mobile phone",
				"salience": 0.001168621,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "information",
				"salience": 0.0010782994,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0010782994,
				"type": "OTHER"
			},
			{
				"name": "genocide",
				"salience": 0.0010425865,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0010425865,
				"type": "PERSON"
			},
			{
				"name": "convoys",
				"salience": 0.0010425865,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0010425865,
				"type": "OTHER"
			},
			{
				"name": "spying",
				"salience": 0.0010425865,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00094623514,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.00094623514,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.00089943485,
				"type": "PERSON"
			},
			{
				"name": "caliphate",
				"salience": 0.00089943485,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0008954173,
				"type": "PERSON"
			},
			{
				"name": "Kokjali",
				"salience": 0.00088109996,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0008658594,
				"type": "PERSON"
			},
			{
				"name": "SIM cards",
				"salience": 0.00077882904,
				"type": "OTHER"
			},
			{
				"name": "sons",
				"salience": 0.00077882904,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uzbekistan"
				},
				"name": "Uzbek",
				"salience": 0.00064169744,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01h7l_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yazidis"
				},
				"name": "Yazidi",
				"salience": 0.00064169744,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0004295422,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Ravina_Shamdasani_b2523.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-13T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.005",
		"text": "43 Shares\n8 34 0 1\nISIS terrorists have executed scores more people around the northern Iraqi city of Mosul this week and are reported to be stockpiling dangerous chemicals in civilian areas, the U.N. human rights office said on Friday.\nA mass grave with over 100 bodies found in the town of Hammam al-Alil was one of several ISIS killing grounds, spokeswoman Ravina Shamdasani said. She cited testimony gleaned from sources including a man who had survived an execution of some 50 former Iraqi soldiers by playing dead.\n\"Clearly there are many other killing fields. We also have reports of other mass graves which we haven’t yet been able to verify,” Shamdasani told reporters, mentioning sites at Mosul airport and the village of Tal al-Thahab.\n Iraqi troops had found large stockpiles of sulfur and there were credible reports that ISIS had used \"phosphor projectiles\" over Qayyara, close to Mosul, Shamdasani said.\n\"Similar credible reports in Mosul state that they have placed sulfur pits in close proximity to civilians,\" she said.\nMORE... New ISIS Video Threatens Putin While Russian Child Executioners Execute 4 Men Saudis Foil ISIS Terror Attacks on Packed Stadium U.S. Commander John Nicholson: ISIS Attempting to Establish Khorasan Caliphate in Afghanistan ISIL executes Iraqi citizens listening to gov't radio The U.N.'s sources of information include people living in ISIS-held areas who risk their lives to speak out.\n\"We get so much information,\" Shamdasani said, without going into details. \"We’ve been in Iraq a very long time.”\nShamdasani said 40 civilians were reportedly shot on Tuesday for \"treason and collaboration\" with Iraqi government forces, and their bodies hung from electrical poles around Mosul.\nThe same day a 27-year-old man was shot for using a mobile phone, Shamdasani said. Six others had been hanged on Oct. 20 for hiding SIM cards, and 20 more were reportedly shot on Wednesday for leaking information to the Iraqi security forces.\nISIS had deployed what it calls \"sons of the caliphate\" wearing explosive belts in the alleys of Old Mosul, and the U.N. had unconfirmed reports that they were teenagers and young boys, Shamdasani said.\nISS also announced on Nov. 6 that it had beheaded seven of its own fighters for deserting the battlefield at Kokjali, Shamdasani said.\nThe U.N. had also verified an ISIS propaganda video showing four children, purportedly including one Russian and one Uzbek, executing four people for spying.\nThe U.N. had information that abducted women, including from the Yazidi minority, were being \"distributed\" to fighters or told they would be used to accompany ISIS convoys, Shamdasani said.\n\"We're talking about war crimes, crimes against humanity, even genocide,\" she said.",
		"thread_title": "ISIS Executes Scores and Hangs Their Bodies from Electrical Poles around Mosul: U.N.",
		"title": "ISIS Executes Scores and Hangs Their Bodies from Electrical Poles around Mosul: U.N.",
		"type": "bs",
		"uuid": "9675a93377e46ec9599d459a56fb3d250610c27f"
	},
	"-KhIbXgYRbpkR2KWsvDD": {
		"author": "Daniel Haiphong",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-14T15:28:07.072+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.14216125,
				"type": "ORGANIZATION"
			},
			{
				"name": "Donald Trump Trump",
				"salience": 0.10309185,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.100742795,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.09386091,
				"type": "OTHER"
			},
			{
				"name": "Millions",
				"salience": 0.05138314,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.047396768,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.016683737,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.014918695,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.014087442,
				"type": "PERSON"
			},
			{
				"name": "sister",
				"salience": 0.013593857,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05jj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_American_Free_Trade_Agreement"
				},
				"name": "NAFTA",
				"salience": 0.010927497,
				"type": "ORGANIZATION"
			},
			{
				"name": "racism",
				"salience": 0.009260819,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.008220818,
				"type": "OTHER"
			},
			{
				"name": "working class family",
				"salience": 0.0069500273,
				"type": "PERSON"
			},
			{
				"name": "pressure",
				"salience": 0.0068842378,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00627673,
				"type": "EVENT"
			},
			{
				"name": "Aunt",
				"salience": 0.0059771324,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0055805133,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.005436774,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.005436774,
				"type": "OTHER"
			},
			{
				"name": "brand",
				"salience": 0.005422338,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0051191137,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0050994544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03gqgt3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/War_on_Terror"
				},
				"name": "War on Terror",
				"salience": 0.004586744,
				"type": "EVENT"
			},
			{
				"name": "Grandfather",
				"salience": 0.004563379,
				"type": "PERSON"
			},
			{
				"name": "mother",
				"salience": 0.004384054,
				"type": "PERSON"
			},
			{
				"name": "sector",
				"salience": 0.004102651,
				"type": "OTHER"
			},
			{
				"name": "service sector",
				"salience": 0.004102651,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01tyl3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnamese_American"
				},
				"name": "Vietnamese Americans",
				"salience": 0.003866591,
				"type": "PERSON"
			},
			{
				"name": "wages",
				"salience": 0.0038457941,
				"type": "OTHER"
			},
			{
				"name": "wage",
				"salience": 0.0038457941,
				"type": "OTHER"
			},
			{
				"name": "billionaire",
				"salience": 0.0036643564,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0035531744,
				"type": "LOCATION"
			},
			{
				"name": "union job",
				"salience": 0.0035531744,
				"type": "OTHER"
			},
			{
				"name": "living wage job",
				"salience": 0.0035531744,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0035531744,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0035531744,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0035531744,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0035531744,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.0035531744,
				"type": "OTHER"
			},
			{
				"name": "contradiction",
				"salience": 0.003355765,
				"type": "OTHER"
			},
			{
				"name": "administrations",
				"salience": 0.0032084868,
				"type": "EVENT"
			},
			{
				"name": "union position",
				"salience": 0.0032084868,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0031925486,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0029192208,
				"type": "OTHER"
			},
			{
				"name": "nationalism",
				"salience": 0.0028441865,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0027786207,
				"type": "EVENT"
			},
			{
				"name": "conditions",
				"salience": 0.0027786207,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.0027786207,
				"type": "OTHER"
			},
			{
				"name": "student debt",
				"salience": 0.0027786207,
				"type": "OTHER"
			},
			{
				"name": "sums",
				"salience": 0.0027786207,
				"type": "OTHER"
			},
			{
				"name": "college expenses",
				"salience": 0.0027786207,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0027195362,
				"type": "PERSON"
			},
			{
				"name": "Brian Cloughley",
				"salience": 0.0026989465,
				"type": "PERSON"
			},
			{
				"name": "needs",
				"salience": 0.002417076,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.002170834,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0020954255,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0020954255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0020953189,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0020826035,
				"type": "ORGANIZATION"
			},
			{
				"name": "movements",
				"salience": 0.0020388681,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0019513771,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0019006471,
				"type": "ORGANIZATION"
			},
			{
				"name": "consistency",
				"salience": 0.0018855755,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0018166935,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0017848487,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.0017173461,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "Department of Homeland Security",
				"salience": 0.0017106703,
				"type": "ORGANIZATION"
			},
			{
				"name": "business class",
				"salience": 0.0016847011,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0016847011,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0016810899,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0016589409,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.001628388,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019x9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeb_Bush"
				},
				"name": "Jeb Bush",
				"salience": 0.0015865156,
				"type": "PERSON"
			},
			{
				"name": "other",
				"salience": 0.0015839098,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0015839098,
				"type": "PERSON"
			},
			{
				"name": "call",
				"salience": 0.0014743038,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0014693205,
				"type": "PERSON"
			},
			{
				"name": "consistency",
				"salience": 0.0014632817,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0014632817,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0014632817,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0014632817,
				"type": "LOCATION"
			},
			{
				"name": "class",
				"salience": 0.0014287095,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.0014287095,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0014287095,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0014287095,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0014144822,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.001407685,
				"type": "OTHER"
			},
			{
				"name": "aspect",
				"salience": 0.001407685,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.001383742,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0013682873,
				"type": "OTHER"
			},
			{
				"name": "contradictions",
				"salience": 0.0013473104,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.001321213,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.001284234,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0012632718,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0012632718,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0012632718,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0012632718,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0012632718,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.0012189567,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "loss",
				"salience": 0.0012164952,
				"type": "EVENT"
			},
			{
				"name": "wars",
				"salience": 0.0012164952,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0012047789,
				"type": "EVENT"
			},
			{
				"name": "millions",
				"salience": 0.0012047789,
				"type": "PERSON"
			},
			{
				"name": "electorate",
				"salience": 0.0012047789,
				"type": "PERSON"
			},
			{
				"name": "peoples",
				"salience": 0.0011995289,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.0011848381,
				"type": "EVENT"
			},
			{
				"name": "section",
				"salience": 0.0011848381,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.0011848381,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0011848381,
				"type": "EVENT"
			},
			{
				"name": "working class",
				"salience": 0.001181255,
				"type": "PERSON"
			},
			{
				"name": "liberalism",
				"salience": 0.001165633,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.001144072,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.001144072,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.001144072,
				"type": "OTHER"
			},
			{
				"name": "decay",
				"salience": 0.001144072,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.001144072,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.001144072,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.001144072,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.001144072,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0011406121,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections",
				"salience": 0.001130765,
				"type": "EVENT"
			},
			{
				"name": "President",
				"salience": 0.0011105689,
				"type": "PERSON"
			},
			{
				"name": "base",
				"salience": 0.0011105689,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0011079841,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0010879878,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0010793572,
				"type": "OTHER"
			},
			{
				"name": "bases",
				"salience": 0.0010691137,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0010691137,
				"type": "PERSON"
			},
			{
				"name": "base",
				"salience": 0.0010691137,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.0010673006,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0010259734,
				"type": "LOCATION"
			},
			{
				"name": "World",
				"salience": 0.0010259734,
				"type": "LOCATION"
			},
			{
				"name": "blame",
				"salience": 0.0009951157,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0009876746,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0009876746,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.0009745474,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0009263451,
				"type": "PERSON"
			},
			{
				"name": "End",
				"salience": 0.0009263451,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0009263451,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.0009263451,
				"type": "OTHER"
			},
			{
				"name": "nose",
				"salience": 0.0009222072,
				"type": "OTHER"
			},
			{
				"name": "righteousness",
				"salience": 0.00090662367,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00090662367,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black Americans",
				"salience": 0.0009019861,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00089607097,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00089607097,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00089607097,
				"type": "PERSON"
			},
			{
				"name": "assault",
				"salience": 0.00089176395,
				"type": "EVENT"
			},
			{
				"name": "business elites",
				"salience": 0.00089176395,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00089176395,
				"type": "PERSON"
			},
			{
				"name": "elites",
				"salience": 0.00089176395,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.00089176395,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0008546384,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.00083755754,
				"type": "EVENT"
			},
			{
				"name": "class interests",
				"salience": 0.00083755754,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.000834441,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.000834441,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.000834441,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.000834441,
				"type": "OTHER"
			},
			{
				"name": "liberal",
				"salience": 0.0008069471,
				"type": "OTHER"
			},
			{
				"name": "bowels",
				"salience": 0.0008021272,
				"type": "OTHER"
			},
			{
				"name": "mourning",
				"salience": 0.0008021272,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0008021272,
				"type": "PERSON"
			},
			{
				"name": "Discussions",
				"salience": 0.0008021272,
				"type": "EVENT"
			},
			{
				"name": "purge",
				"salience": 0.0008021272,
				"type": "OTHER"
			},
			{
				"name": "predator characteristics",
				"salience": 0.0008021272,
				"type": "OTHER"
			},
			{
				"name": "significance",
				"salience": 0.0008021272,
				"type": "OTHER"
			},
			{
				"name": "balance",
				"salience": 0.00078203715,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.0007773134,
				"type": "PERSON"
			},
			{
				"name": "liberal",
				"salience": 0.00077682163,
				"type": "OTHER"
			},
			{
				"name": "deathbed",
				"salience": 0.00077218155,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.00077218155,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00077218155,
				"type": "OTHER"
			},
			{
				"name": "table",
				"salience": 0.00077218155,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0007671794,
				"type": "ORGANIZATION"
			},
			{
				"name": "hand",
				"salience": 0.00075621955,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00075621955,
				"type": "OTHER"
			},
			{
				"name": "recovery",
				"salience": 0.00075621955,
				"type": "EVENT"
			},
			{
				"name": "turnout",
				"salience": 0.00075621955,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latino",
				"salience": 0.0007227689,
				"type": "PERSON"
			},
			{
				"name": "US-Mexico",
				"salience": 0.00070415786,
				"type": "LOCATION"
			},
			{
				"name": "base",
				"salience": 0.00067724305,
				"type": "OTHER"
			},
			{
				"name": "sexism",
				"salience": 0.00067724305,
				"type": "OTHER"
			},
			{
				"name": "sexism",
				"salience": 0.00067724305,
				"type": "OTHER"
			},
			{
				"name": "sexism",
				"salience": 0.00067724305,
				"type": "OTHER"
			},
			{
				"name": "sexism",
				"salience": 0.00067724305,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00065935135,
				"type": "PERSON"
			},
			{
				"name": "crusade",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "betrayal",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "sensibilities",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.00065480795,
				"type": "ORGANIZATION"
			},
			{
				"name": "graveyard",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00065480795,
				"type": "PERSON"
			},
			{
				"name": "knife",
				"salience": 0.00065480795,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.0006525938,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0006256462,
				"type": "OTHER"
			},
			{
				"name": "nationalism",
				"salience": 0.0006252092,
				"type": "OTHER"
			},
			{
				"name": "emergence",
				"salience": 0.0006028946,
				"type": "OTHER"
			},
			{
				"name": "liberation",
				"salience": 0.0006027785,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0006027785,
				"type": "OTHER"
			},
			{
				"name": "disgust",
				"salience": 0.0005991777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07hwkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_American"
				},
				"name": "White",
				"salience": 0.0005958045,
				"type": "PERSON"
			},
			{
				"name": "class arrangement",
				"salience": 0.00059529603,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.00059428107,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00058720127,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0005806406,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.00056573836,
				"type": "PERSON"
			},
			{
				"name": "aspect",
				"salience": 0.00056488253,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.00056488253,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00056488253,
				"type": "OTHER"
			},
			{
				"name": "Administrations",
				"salience": 0.00056488253,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.00056488253,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lq3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electoral_College_(United_States)"
				},
				"name": "Electoral College",
				"salience": 0.0005488428,
				"type": "ORGANIZATION"
			},
			{
				"name": "bed",
				"salience": 0.0005413623,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0005301705,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00052620523,
				"type": "ORGANIZATION"
			},
			{
				"name": "ideology",
				"salience": 0.000495368,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.00049366767,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00049366767,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Greatest Achievement",
				"salience": 0.00049366767,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wealth",
				"salience": 0.00048912433,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.00048912433,
				"type": "EVENT"
			},
			{
				"name": "income",
				"salience": 0.00048912433,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00048912433,
				"type": "OTHER"
			},
			{
				"name": "trade deals",
				"salience": 0.00048912433,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00048912433,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.00048912433,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0004874703,
				"type": "PERSON"
			},
			{
				"name": "capitalist system",
				"salience": 0.00045563313,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00045563313,
				"type": "LOCATION"
			},
			{
				"name": "control",
				"salience": 0.00045563313,
				"type": "OTHER"
			},
			{
				"name": "prison state",
				"salience": 0.00045563313,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.00045563313,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.00041879216,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00041137834,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.00041137834,
				"type": "EVENT"
			},
			{
				"name": "record numbers",
				"salience": 0.00041137834,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.00041137834,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00039305585,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.00039305585,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.00036840982,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.00036840982,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.00036840982,
				"type": "OTHER"
			},
			{
				"name": "vigor",
				"salience": 0.00035620385,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.00035620385,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.00035620385,
				"type": "OTHER"
			},
			{
				"name": "erection",
				"salience": 0.00035620385,
				"type": "EVENT"
			},
			{
				"name": "germs",
				"salience": 0.00035620385,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.00035620385,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00035620385,
				"type": "EVENT"
			},
			{
				"name": "rates",
				"salience": 0.00035620385,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00034762165,
				"type": "EVENT"
			},
			{
				"name": "politics",
				"salience": 0.0003403384,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.0003403384,
				"type": "OTHER"
			},
			{
				"name": "material struggle",
				"salience": 0.0003403384,
				"type": "OTHER"
			},
			{
				"name": "class-consciousness",
				"salience": 0.0003403384,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.00030728048,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.00030728048,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07j6ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ted_Cruz"
				},
				"name": "Ted Cruz",
				"salience": 0.0003010147,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.00028710748,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.0002694627,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.00026606605,
				"type": "EVENT"
			},
			{
				"name": "words",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "ills",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "demands",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "abandonment",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "material relief",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "stripes",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00026606605,
				"type": "OTHER"
			},
			{
				"name": "gender",
				"salience": 0.00026606605,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Donald_J._Trump_149fc.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-14T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 23.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.04",
		"text": "11 Shares\n10 0 0 1\nI grew up in a working class family and have experienced the deep racism of a society that views Vietnamese Americans as the targets of war. I've lived through successive Democratic Party administrations with little to celebrate. The Bill Clinton era brought NAFTA, which outsourced my Aunt's union job and forced her into the low-wage service sector. My mother never found a living wage job and relied on my father's public sector union position to meet our family's needs. In the 21st century, Obama expanded Bush’s War on Terror, which merged my father’s job with into the Department of Homeland Security.\nDownward pressure on wages and working conditions forced my father to refinance our home multiple times to pay college expenses for my sister and I. Even then, my sister and I graduated with large sums of student debt. I have worked four jobs in three years and only one has paid a truly living wage. Another four years of a Democratic Party President was not going to make anything better for my family. That is not to say that Donald Trump was the answer to the structural problems of exploitation. But Trump's victory is not the end of the world, either.\nTrump's victory is the product of global capitalism’s decay. Millions of people voted for Trump for a variety of reasons, namely because he clearly labeled problems and outlined solutions to them. I don’t agree with all of his solutions. White nationalism stains his domestic and international agenda. Trump’s call to further militarize the US-Mexico border yet make peace with Russia is a contradiction in and of itself. A white nationalist billionaire who speaks the language of racism on the one hand and the interests of peace on the other is not exactly a model of consistency.\nHowever, Trump’s consistency is not the most important aspect of this election. Millions of people have shown their disgust with the two-party system of the capitalist class. A number of mostly white workers and whites from the petty business class voted for Trump. Trump also received more votes than expected from the Black and Latino electorate. Meanwhile, the elections produced a low turnout for Clinton from the historic Democratic Party bases of Black voters, Latino voters, and women voters. Clinton may have won the electoral vote, but the balance of forces ensured the ruling class would gamble on Trump. Trump's base of white workers and petty business elites angered by thirty years of monopoly capitalist assault are more of a threat at the moment than the millions of Democratic party voters who are now without a home. The round table of elites called the Electoral College could not afford any more damage to the Democratic Party than what transpired during the election.\nSo the Democratic Party is now on its deathbed and there is only one class of people willing to resurrect it: white liberals. A large section of the Democratic Party base wanted Bernie Sanders to be their next President. They did not hold their nose for Clinton. The legitimate concerns that immigrants and oppressed people possess with Trump's racism should not be led into the bowels of the Democratic Party. Yet for white liberals, this is the ultimate mission.\nMORE... Brian Cloughley: “The Greatest Achievement of Mr. Trump would be Engage in Positive Discussions with Russia and China” Arise President Trump (or Why it's not the End of the World as We Know it) Trump's sexual predator characteristics - His Grandfather was a pimp, but at least he paid the women he hired The significance of the GOP's attempted purge of Donald Trump Trump's victory has energized the white liberal section of the United States to fight back. White liberals began the process in a deep state of mourning over Clinton's loss. They then placed blame for Trump’s victory on Russia, low-voter turnout, and the white working class. White liberals have blamed everyone except Hillary Clinton and the Democratic Party. Now, white liberals in the US hope to wage a crusade against Trump in hopes of a Democratic Party recovery. It is all too clear that their primary intention is to get ahead of the genuine forces that rejected both Trump and Clinton and lead them into the Democratic Party graveyard.\nWhite liberals love to hide their own racism and ruling class sensibilities through a process of appeal and betrayal. They speak with the authority of moral righteousness on the one hand and the knife of oppression on the other. They talk down to the struggle of peoples oppressed by white supremacy and attempt to steer it in a way that benefits their class interests. White liberals despise the working class because they understand that there will come a day when it destroys the system that they profit so handsomely from.\nWhite liberals usually originate from the ruling class, the managerial class, and various stripes of the professionalized sector. Their class has ordained themselves the true leaders of \"human rights\" based on race, gender, and sexual equality. However, White liberals speak of human rights on the basis of a complete abandonment of the material struggle for liberation. In other words, the white liberal is the ultimate counterrevolutionary force in US society. It has wielded the so-called struggle for human rights as a weapon to prevent the emergence of class-consciousness among the oppressed and its genuine leaders.\nThe 2016 elections have shown that the broad class arrangement of white liberals is indeed in crisis and only has itself to blame. White liberals cannot acknowledge that it was their brand of politics that led to the Trump moment. Their dominance over the left in the US ensured that no organized force existed strong enough to challenge the ills of capitalist decline. Millions of people voted for Sanders based on his demands for material relief. Millions of people voted for Trump for the similar reasons, his racism and sexism notwithstanding. Whatever racism and sexism existed in his rhetoric could not \"trump\" the fact that the trade deals and wars he spoke out against in part drove ordinary people to vote for him. If the Trump base wanted racism and sexism primarily, they would of voted for Ted Cruz or Jeb Bush in the primaries.\nSo White liberal anger about Trump's victory is not directed at sexism, racism, or any other aspect of Trump's politics. White liberals are afraid of the sharpening contradictions of US society that threaten to squeeze them out of their privileged position under the racist and capitalist order. Millions of people are now asking where white liberalism was during the massive loss in working class income and wealth that occurred over the last forty years? Where were the White liberals during the endless wars that have been waged even more fervently by Democratic Party Administrations? Where were the White liberals during the erection of the largest police and prison state in the world, the institutions that murder and incarcerate Black Americans in record numbers and deport undocumented peoples at historic rates?\nThe answer is that white liberals were supporting the US capitalist system's assault on the oppressed every step of the way. This is what they are trying to hide with their anger over Trump. We cannot defeat Trump's white nationalism if the white liberal is not defeated with just as much vigor. White liberal ideology has a history of infecting social movements. As it spreads, it breeds the germs of Democratic Party control over these movements. But the Democratic Party made its own bed by acting as the more effective evil of the ruling class. If a powerful movement of the working class is to emerge in the age of Trump, then we must fight hard against the white liberal forces working hard to resuscitate the Democratic Party and build an independent party of our own.",
		"thread_title": "Defeating White Liberalism in the Age of Trump",
		"title": "Defeating White Liberalism in the Age of Trump",
		"type": "bs",
		"uuid": "811240d291a48392d40734e74dc7b3bfb7a43a59"
	},
	"-KhIbY3kaWJ9y7rQezRI": {
		"author": "Kim Petersen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-14T15:51:01.483+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.28834382,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.1808054,
				"type": "PERSON"
			},
			{
				"name": "warming",
				"salience": 0.04296992,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.034883242,
				"type": "LOCATION"
			},
			{
				"name": "win",
				"salience": 0.026556784,
				"type": "EVENT"
			},
			{
				"name": "climate leadership role",
				"salience": 0.022462536,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.017765969,
				"type": "OTHER"
			},
			{
				"name": "climate change",
				"salience": 0.013958194,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.011538741,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.011538741,
				"type": "PERSON"
			},
			{
				"name": "climate agreement",
				"salience": 0.010818612,
				"type": "OTHER"
			},
			{
				"name": "leadership role",
				"salience": 0.010818612,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.010101739,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010072864,
				"type": "EVENT"
			},
			{
				"name": "negotiators",
				"salience": 0.0093253525,
				"type": "PERSON"
			},
			{
				"name": "partnership",
				"salience": 0.008647944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.008182994,
				"type": "LOCATION"
			},
			{
				"name": "planet",
				"salience": 0.007823403,
				"type": "LOCATION"
			},
			{
				"name": "climate change skeptic",
				"salience": 0.007823403,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.007823403,
				"type": "EVENT"
			},
			{
				"name": "Shares",
				"salience": 0.007823403,
				"type": "OTHER"
			},
			{
				"name": "vow",
				"salience": 0.007823403,
				"type": "OTHER"
			},
			{
				"name": "Zou Ji",
				"salience": 0.006514549,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.0057674805,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0055599627,
				"type": "OTHER"
			},
			{
				"name": "wishes",
				"salience": 0.0054209987,
				"type": "OTHER"
			},
			{
				"name": "momentum",
				"salience": 0.0052190227,
				"type": "OTHER"
			},
			{
				"name": "climate governance",
				"salience": 0.005081846,
				"type": "OTHER"
			},
			{
				"name": "Xie Ji",
				"salience": 0.004943437,
				"type": "PERSON"
			},
			{
				"name": "adaptation projects",
				"salience": 0.0046190526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n13b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Xinhua_News_Agency"
				},
				"name": "Xinhua",
				"salience": 0.00460835,
				"type": "ORGANIZATION"
			},
			{
				"name": "partnership",
				"salience": 0.0045268894,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.004124434,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0038914306,
				"type": "LOCATION"
			},
			{
				"name": "talks",
				"salience": 0.0037244319,
				"type": "EVENT"
			},
			{
				"name": "climate change",
				"salience": 0.0035881745,
				"type": "OTHER"
			},
			{
				"name": "climate change",
				"salience": 0.0035881745,
				"type": "OTHER"
			},
			{
				"name": "negotiator",
				"salience": 0.003588068,
				"type": "PERSON"
			},
			{
				"name": "climate change crisis Petition",
				"salience": 0.0035695676,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.0034364657,
				"type": "OTHER"
			},
			{
				"name": "pilot zones",
				"salience": 0.0033083197,
				"type": "LOCATION"
			},
			{
				"name": "transition",
				"salience": 0.003225551,
				"type": "EVENT"
			},
			{
				"name": "champion",
				"salience": 0.003225551,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.003225551,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.003225551,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.003225551,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.003225551,
				"type": "OTHER"
			},
			{
				"name": "emergence",
				"salience": 0.003225551,
				"type": "EVENT"
			},
			{
				"name": "round",
				"salience": 0.003225551,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccan",
				"salience": 0.00316214,
				"type": "LOCATION"
			},
			{
				"name": "agreement",
				"salience": 0.0031311798,
				"type": "OTHER"
			},
			{
				"name": "South-South Climate Cooperation Fund",
				"salience": 0.0030865427,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0030205233,
				"type": "LOCATION"
			},
			{
				"name": "climate agreement",
				"salience": 0.0030144027,
				"type": "OTHER"
			},
			{
				"name": "climate talks negotiator",
				"salience": 0.0028928698,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.0028928698,
				"type": "OTHER"
			},
			{
				"name": "climate change",
				"salience": 0.0026811676,
				"type": "EVENT"
			},
			{
				"name": "contrast",
				"salience": 0.0025147262,
				"type": "OTHER"
			},
			{
				"name": "Zhang Yucheng",
				"salience": 0.0025088938,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06ff60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Xi_Jinping"
				},
				"name": "Xi Jinping",
				"salience": 0.0025088938,
				"type": "PERSON"
			},
			{
				"name": "governance",
				"salience": 0.0023619726,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0023619726,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0023619726,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0022621222,
				"type": "OTHER"
			},
			{
				"name": "climate science",
				"salience": 0.0022621222,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0022621222,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.0022621222,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0022621222,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0022621222,
				"type": "EVENT"
			},
			{
				"name": "responsibility",
				"salience": 0.0022621222,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.0022621222,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00225686,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.00225686,
				"type": "LOCATION"
			},
			{
				"name": "capital",
				"salience": 0.0021777248,
				"type": "LOCATION"
			},
			{
				"name": "meet",
				"salience": 0.0021777248,
				"type": "EVENT"
			},
			{
				"name": "pact",
				"salience": 0.0021777248,
				"type": "OTHER"
			},
			{
				"name": "greenhouse gas emitters",
				"salience": 0.0021777248,
				"type": "OTHER"
			},
			{
				"name": "hoax",
				"salience": 0.0021777248,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0021777248,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.002171142,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0021327364,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.001985994,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01914",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beijing"
				},
				"name": "Beijing",
				"salience": 0.001985994,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hn9yf5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salaheddine_Mezouar"
				},
				"name": "Salaheddine Mezouar",
				"salience": 0.0018744743,
				"type": "PERSON"
			},
			{
				"name": "advantage",
				"salience": 0.0018704442,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cm61j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London_and_Paris_Conferences"
				},
				"name": "Paris Agreement",
				"salience": 0.0018559208,
				"type": "WORK_OF_ART"
			},
			{
				"name": "gesture",
				"salience": 0.0018468834,
				"type": "OTHER"
			},
			{
				"name": "welcome",
				"salience": 0.0018468834,
				"type": "OTHER"
			},
			{
				"name": "standing",
				"salience": 0.0018468834,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0018468834,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0018468834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ygnh9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South%E2%80%93South_cooperation"
				},
				"name": "South-South",
				"salience": 0.0017447007,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0016439097,
				"type": "ORGANIZATION"
			},
			{
				"name": "project",
				"salience": 0.0015933672,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0014666413,
				"type": "LOCATION"
			},
			{
				"name": "National Centre for Climate Change Strategy",
				"salience": 0.0013925728,
				"type": "ORGANIZATION"
			},
			{
				"name": "Canadian Big Media",
				"salience": 0.0013925728,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02s6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ExxonMobil"
				},
				"name": "ExxonMobil",
				"salience": 0.0013925728,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "DOJ",
				"salience": 0.0013925728,
				"type": "ORGANIZATION"
			},
			{
				"name": "climate change mitigation",
				"salience": 0.0013797617,
				"type": "OTHER"
			},
			{
				"name": "professionals",
				"salience": 0.0013797617,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0013405978,
				"type": "LOCATION"
			},
			{
				"name": "training programs",
				"salience": 0.0013342233,
				"type": "OTHER"
			},
			{
				"name": "offer",
				"salience": 0.0012950047,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0011949155,
				"type": "OTHER"
			},
			{
				"name": "climate issues",
				"salience": 0.0011605239,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.001068207,
				"type": "LOCATION"
			},
			{
				"name": "total",
				"salience": 0.0010049188,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0009399417,
				"type": "ORGANIZATION"
			},
			{
				"name": "development",
				"salience": 0.00086693163,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0008377822,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qdypp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Development_and_Reform_Commission"
				},
				"name": "National Development and Reform Commission",
				"salience": 0.00081448903,
				"type": "ORGANIZATION"
			},
			{
				"name": "session",
				"salience": 0.0007506787,
				"type": "EVENT"
			},
			{
				"name": "policies",
				"salience": 0.0007506787,
				"type": "OTHER"
			},
			{
				"name": "delegation",
				"salience": 0.0007506787,
				"type": "PERSON"
			},
			{
				"name": "Foreign Minister",
				"salience": 0.0006529273,
				"type": "PERSON"
			},
			{
				"name": "International Cooperation Division",
				"salience": 0.00061849854,
				"type": "ORGANIZATION"
			},
			{
				"name": "Department of Climate Change",
				"salience": 0.00061849854,
				"type": "ORGANIZATION"
			},
			{
				"name": "concrete program",
				"salience": 0.00061555667,
				"type": "OTHER"
			},
			{
				"name": "Climate Change Conference",
				"salience": 0.00053355866,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African continent",
				"salience": 0.00053355866,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07v96",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Framework_Convention_on_Climate_Change"
				},
				"name": "Conference of the Parties",
				"salience": 0.00053355866,
				"type": "EVENT"
			},
			{
				"name": "COP22",
				"salience": 0.0004620008,
				"type": "OTHER"
			},
			{
				"name": "COP 22",
				"salience": 0.0004620008,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Xi_Jinping_2_ba318.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-14T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Trump win opens way for China to take climate leadership role. 3 Shares\n2 0 0 1\nChina has warned Donald Trump that he will be defying the wishes of the entire planet if he acts on his vow to back away from the Paris climate agreement after he becomes US president next January.\nThe election of climate change skeptic Donald Trump as president is likely to end the U.S. leadership role in the international fight against global warming and may lead to the emergence of a new and unlikely champion: China.\n“It is global society’s will that all want to co-operate to combat climate change,” a senior Beijing negotiator said in Morocco on Friday, at the first round of UN talks since the Paris deal was sealed last December. The Chinese negotiators added that “any movement by the new US government” would not affect their transition towards becoming a greener economy.\nChina worked closely with the administration of outgoing President Barack Obama to build momentum ahead of the 2015 Paris Agreement on climate change. The partnership of the two biggest greenhouse gas emitters helped get nearly 200 countries to support the pact at the historic meet in France's capital.\nBy contrast, Trump has called global warming a hoax created by China to give it an economic advantage and said he plans to remove the United States from the historic climate agreement, as well as reverse many of Obama's measures to combat climate change.\nMORE... Canadian Big Media ignoring responsibility by failing to cover climate change crisis Petition calls for DOJ investigation into ExxonMobil's denial of climate science Zou Ji, deputy director of the National Centre for Climate Change Strategy and a senior Chinese climate talks negotiator, told Reuters that if Trump abandons efforts to implement the Paris agreement, \"China's influence and voice are likely to increase in global climate governance, which will then spill over into other areas of global governance and increase China's global standing, power and leadership.\"\nChina is expected to play a pivotal role in consolidating and enhancing South-South partnership, particularly when it comes to issues related to climate change.\nChina is steadily ramping up efforts to assist other developing countries in addressing climate change, a gesture that has received wide welcome.\nSpeaking to the Chinese news agency Xinhua, Moroccan Foreign Minister and Climate Change Conference (COP22) President Salaheddine Mezouar said that China has an “extremely important role to play in accompanying, reinforcing and boosting South-South partnership and support sustainable development policies in the African continent”.\nXie Ji, deputy chief of the Chinese delegation to the ongoing 22nd session of the Conference of the Parties (COP 22), said on Nov. 7 that China has ironed out a concrete program to help other developing countries to become more climate-resilient. \"We will help build up ten low-carbon pilot zones, launch 100 climate change mitigation and adaptation projects, and offer training programs for 1,000 climate-related professionals,\" he said.\nWhat Xie called the \"10-100-1000\" project is part of the effort that China has made in recent years to help other developing countries fight against climate change. The country has earmarked a total of 580 million yuan (about US$85 million) since 2011 to help developing countries, according to Zhang Yucheng, deputy director of the International Cooperation Division of the Department of Climate Change of the National Development and Reform Commission (NDRC).\nThe most recent offer is the South-South Climate Cooperation Fund, a US$3.1 billion fund pledged by Chinese President Xi Jinping last September to help developing countries address climate issues.",
		"thread_title": "China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b",
		"title": "China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b",
		"type": "bs",
		"uuid": "d158c3813605fca572c650ed645ba73dd736abb1"
	},
	"-KhIbY_OzctE4OHtqndF": {
		"author": "M.R. Islam",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-15T11:37:16.117+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Jaan Islam",
				"salience": 0.62585855,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/096tx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quran"
				},
				"name": "Qur'an",
				"salience": 0.04440824,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.031767152,
				"type": "OTHER"
			},
			{
				"name": "paradigm shift",
				"salience": 0.025241345,
				"type": "OTHER"
			},
			{
				"name": "Rafiq Islam",
				"salience": 0.0219407,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01c8x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ibn_Khaldun"
				},
				"name": "Ibn Khaldun",
				"salience": 0.0175498,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0445s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jihad"
				},
				"name": "Jihad",
				"salience": 0.017390585,
				"type": "PERSON"
			},
			{
				"name": "cognition",
				"salience": 0.012269384,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.010286133,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04s9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_in_Islam"
				},
				"name": "Muhammad",
				"salience": 0.00945709,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.006954399,
				"type": "WORK_OF_ART"
			},
			{
				"name": "history",
				"salience": 0.0067980364,
				"type": "OTHER"
			},
			{
				"name": "True Islam",
				"salience": 0.0051488616,
				"type": "OTHER"
			},
			{
				"name": "world peace",
				"salience": 0.0045657055,
				"type": "OTHER"
			},
			{
				"name": "Nova Scotia Book",
				"salience": 0.002703007,
				"type": "WORK_OF_ART"
			},
			{
				"name": "book",
				"salience": 0.0022434513,
				"type": "WORK_OF_ART"
			},
			{
				"name": "book",
				"salience": 0.0022434513,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chapter",
				"salience": 0.0021109057,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0225x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chapter_11,_Title_11,_United_States_Code"
				},
				"name": "Chapter 11",
				"salience": 0.0021017708,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0020398502,
				"type": "OTHER"
			},
			{
				"name": "Book Review",
				"salience": 0.0019758279,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Shares",
				"salience": 0.0019758279,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.0019758279,
				"type": "OTHER"
			},
			{
				"name": "writings",
				"salience": 0.0019732204,
				"type": "OTHER"
			},
			{
				"name": "cognition",
				"salience": 0.0019611372,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0018496136,
				"type": "LOCATION"
			},
			{
				"name": "point",
				"salience": 0.0018296187,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.0017869659,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07c37",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_Hobbes"
				},
				"name": "Hobbes",
				"salience": 0.0016209445,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.0016146603,
				"type": "OTHER"
			},
			{
				"name": "Chapter 8",
				"salience": 0.001581949,
				"type": "ORGANIZATION"
			},
			{
				"name": "philosophy",
				"salience": 0.0015746831,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.0015746831,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0015746831,
				"type": "OTHER"
			},
			{
				"name": "Terrorism: The Science of Islamic Foreign Policy -- Jaan S. Islam Publisher",
				"salience": 0.001556042,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nova Science Publishers ISBN",
				"salience": 0.001556042,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/043s3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Locke"
				},
				"name": "Locke",
				"salience": 0.0015116407,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0014909126,
				"type": "LOCATION"
			},
			{
				"name": "knowledge",
				"salience": 0.0013975579,
				"type": "OTHER"
			},
			{
				"name": "writings",
				"salience": 0.001291207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/036k0s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halifax,_Nova_Scotia"
				},
				"name": "Halifax",
				"salience": 0.0012168874,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02dj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dalhousie_University"
				},
				"name": "Dalhousie University",
				"salience": 0.0012168874,
				"type": "ORGANIZATION"
			},
			{
				"name": "Emertec R&D Ltd",
				"salience": 0.0012168874,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0011659352,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0011659352,
				"type": "OTHER"
			},
			{
				"name": "Terrorism",
				"salience": 0.0011659352,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.0011659352,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0011659352,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0011659352,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.001116409,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.001051524,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0010212761,
				"type": "OTHER"
			},
			{
				"name": "cognition technique",
				"salience": 0.0010097106,
				"type": "OTHER"
			},
			{
				"name": "masterpiece",
				"salience": 0.0010097106,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.0010097106,
				"type": "EVENT"
			},
			{
				"name": "gap",
				"salience": 0.0010097106,
				"type": "OTHER"
			},
			{
				"name": "thinkers",
				"salience": 0.0010097106,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0010097106,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0009798895,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.0009791822,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.0009244187,
				"type": "WORK_OF_ART"
			},
			{
				"name": "book",
				"salience": 0.0009244187,
				"type": "WORK_OF_ART"
			},
			{
				"name": "book",
				"salience": 0.0009244187,
				"type": "WORK_OF_ART"
			},
			{
				"name": "author",
				"salience": 0.0009190592,
				"type": "PERSON"
			},
			{
				"name": "religions",
				"salience": 0.0008634858,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00082329445,
				"type": "EVENT"
			},
			{
				"name": "author",
				"salience": 0.0008096516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026x8hr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nova_Science_Publishers"
				},
				"name": "Nova Science Publishers",
				"salience": 0.000795004,
				"type": "ORGANIZATION"
			},
			{
				"name": "premise",
				"salience": 0.0007495031,
				"type": "OTHER"
			},
			{
				"name": "research scholarship",
				"salience": 0.00073610165,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.00073610165,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.00072657055,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anyone",
				"salience": 0.00072404183,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.0007132579,
				"type": "PERSON"
			},
			{
				"name": "authors",
				"salience": 0.0007042731,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.0007042731,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.0007042731,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cvlw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Averroes"
				},
				"name": "Averröes",
				"salience": 0.0007006435,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.0006779916,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.0006733557,
				"type": "WORK_OF_ART"
			},
			{
				"name": "book",
				"salience": 0.0006733557,
				"type": "WORK_OF_ART"
			},
			{
				"name": "head of state",
				"salience": 0.00065532926,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.0006526902,
				"type": "PERSON"
			},
			{
				"name": "prophet",
				"salience": 0.00064856577,
				"type": "PERSON"
			},
			{
				"name": "science",
				"salience": 0.00064856577,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0006482272,
				"type": "WORK_OF_ART"
			},
			{
				"name": "authority",
				"salience": 0.00062833226,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0006276172,
				"type": "PERSON"
			},
			{
				"name": "wars",
				"salience": 0.0006276172,
				"type": "OTHER"
			},
			{
				"name": "distinction",
				"salience": 0.00062654755,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.0006237496,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0006140293,
				"type": "LOCATION"
			},
			{
				"name": "foundations",
				"salience": 0.0006031646,
				"type": "OTHER"
			},
			{
				"name": "chapter",
				"salience": 0.00058710406,
				"type": "WORK_OF_ART"
			},
			{
				"name": "author",
				"salience": 0.00058230787,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00057649286,
				"type": "LOCATION"
			},
			{
				"name": "integration",
				"salience": 0.000575546,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.000575546,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.00057497155,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.00057497155,
				"type": "PERSON"
			},
			{
				"name": "cognition",
				"salience": 0.00056652736,
				"type": "OTHER"
			},
			{
				"name": "Chapter 4",
				"salience": 0.00055407226,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cognition",
				"salience": 0.000545383,
				"type": "OTHER"
			},
			{
				"name": "cognition",
				"salience": 0.000545383,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00054280093,
				"type": "WORK_OF_ART"
			},
			{
				"name": "research",
				"salience": 0.00053171103,
				"type": "OTHER"
			},
			{
				"name": "theories",
				"salience": 0.00053171103,
				"type": "OTHER"
			},
			{
				"name": "traditions",
				"salience": 0.00053171103,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.00053171103,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00053171103,
				"type": "WORK_OF_ART"
			},
			{
				"name": "theology",
				"salience": 0.00053171103,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00052230206,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0005200298,
				"type": "OTHER"
			},
			{
				"name": "chapter",
				"salience": 0.00049788656,
				"type": "WORK_OF_ART"
			},
			{
				"name": "author",
				"salience": 0.00048145308,
				"type": "PERSON"
			},
			{
				"name": "disinformation",
				"salience": 0.00048008532,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.00048008532,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.00047538674,
				"type": "PERSON"
			},
			{
				"name": "west",
				"salience": 0.00047436752,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.0004624886,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0pf31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Appendix_(anatomy)"
				},
				"name": "Appendix",
				"salience": 0.0004555528,
				"type": "ORGANIZATION"
			},
			{
				"name": "topic",
				"salience": 0.00045474977,
				"type": "OTHER"
			},
			{
				"name": "social science",
				"salience": 0.00043777525,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00043777525,
				"type": "OTHER"
			},
			{
				"name": "philosophers",
				"salience": 0.00043777525,
				"type": "PERSON"
			},
			{
				"name": "philosophies",
				"salience": 0.00043777525,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00043777525,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.00043500852,
				"type": "PERSON"
			},
			{
				"name": "cognition point",
				"salience": 0.00043052915,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0004295271,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.0004295271,
				"type": "PERSON"
			},
			{
				"name": "conclusion",
				"salience": 0.00041918896,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "fields",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "seed",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "curriculum",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "inundation",
				"salience": 0.00041571556,
				"type": "EVENT"
			},
			{
				"name": "post",
				"salience": 0.00041571556,
				"type": "WORK_OF_ART"
			},
			{
				"name": "marker",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "sufferings",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00041571556,
				"type": "EVENT"
			},
			{
				"name": "everywhere",
				"salience": 0.00041571556,
				"type": "LOCATION"
			},
			{
				"name": "adversity",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "triumph",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "scapegoat",
				"salience": 0.00041571556,
				"type": "OTHER"
			},
			{
				"name": "starting point",
				"salience": 0.0004144583,
				"type": "OTHER"
			},
			{
				"name": "authors",
				"salience": 0.0004082832,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.00040354123,
				"type": "OTHER"
			},
			{
				"name": "criteria",
				"salience": 0.00040354123,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.00040354123,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0004031384,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.00038847732,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00038847732,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.00038276284,
				"type": "EVENT"
			},
			{
				"name": "allies",
				"salience": 0.00038276284,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.00037280112,
				"type": "EVENT"
			},
			{
				"name": "caliphs",
				"salience": 0.00037280112,
				"type": "OTHER"
			},
			{
				"name": "case laws",
				"salience": 0.00037280112,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.00037124066,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.0003687747,
				"type": "PERSON"
			},
			{
				"name": "jus ad bellum",
				"salience": 0.00036687095,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.00036188617,
				"type": "PERSON"
			},
			{
				"name": "Chapter 3",
				"salience": 0.00036137414,
				"type": "WORK_OF_ART"
			},
			{
				"name": "life",
				"salience": 0.00035888428,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.00035888428,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.00035888428,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.00035888428,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.0003570316,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0003541142,
				"type": "OTHER"
			},
			{
				"name": "distinction",
				"salience": 0.0003541142,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0003514661,
				"type": "LOCATION"
			},
			{
				"name": "finding",
				"salience": 0.0003350951,
				"type": "OTHER"
			},
			{
				"name": "criterion",
				"salience": 0.00032943246,
				"type": "OTHER"
			},
			{
				"name": "jus ad",
				"salience": 0.00032943246,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00032403282,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.00032403282,
				"type": "PERSON"
			},
			{
				"name": "basis",
				"salience": 0.00032403282,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0003199493,
				"type": "PERSON"
			},
			{
				"name": "interesting",
				"salience": 0.000317134,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.00031476238,
				"type": "PERSON"
			},
			{
				"name": "scholars",
				"salience": 0.00031476238,
				"type": "PERSON"
			},
			{
				"name": "starting point",
				"salience": 0.0003096031,
				"type": "OTHER"
			},
			{
				"name": "Chapter 5",
				"salience": 0.00030644727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Chapter 6",
				"salience": 0.00030644727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "head of state",
				"salience": 0.00030433573,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.00030433573,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00030433573,
				"type": "EVENT"
			},
			{
				"name": "citizens",
				"salience": 0.00030276456,
				"type": "PERSON"
			},
			{
				"name": "topic",
				"salience": 0.00029547117,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z0_h6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chapter_9,_Title_11,_United_States_Code"
				},
				"name": "Chapter 9",
				"salience": 0.00029500664,
				"type": "ORGANIZATION"
			},
			{
				"name": "case laws",
				"salience": 0.00029297388,
				"type": "OTHER"
			},
			{
				"name": "companions",
				"salience": 0.00029146136,
				"type": "PERSON"
			},
			{
				"name": "verses",
				"salience": 0.00029146136,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.00029146136,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00029146136,
				"type": "OTHER"
			},
			{
				"name": "cognition tools",
				"salience": 0.00029146136,
				"type": "OTHER"
			},
			{
				"name": "cognition axis",
				"salience": 0.00028058002,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.00028058002,
				"type": "OTHER"
			},
			{
				"name": "book deals",
				"salience": 0.00028058002,
				"type": "OTHER"
			},
			{
				"name": "brands",
				"salience": 0.00028058002,
				"type": "ORGANIZATION"
			},
			{
				"name": "narration",
				"salience": 0.00028058002,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00028058002,
				"type": "LOCATION"
			},
			{
				"name": "foundation",
				"salience": 0.0002747799,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0002747799,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00026254286,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.00026254286,
				"type": "PERSON"
			},
			{
				"name": "conclusion",
				"salience": 0.00026219344,
				"type": "OTHER"
			},
			{
				"name": "Modern Imperialism Another Ramadan",
				"salience": 0.0002558623,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09spb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orientalism"
				},
				"name": "Orientalist",
				"salience": 0.0002558623,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dgr_8x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neo-orientalism"
				},
				"name": "neo-Orientalism",
				"salience": 0.0002558623,
				"type": "OTHER"
			},
			{
				"name": "Zatzman",
				"salience": 0.0002558623,
				"type": "PERSON"
			},
			{
				"name": "conclusions",
				"salience": 0.00024608232,
				"type": "OTHER"
			},
			{
				"name": "conclusions",
				"salience": 0.00024608232,
				"type": "OTHER"
			},
			{
				"name": "jus ad bellum",
				"salience": 0.00024608232,
				"type": "OTHER"
			},
			{
				"name": "bello",
				"salience": 0.00024608232,
				"type": "PERSON"
			},
			{
				"name": "criteria",
				"salience": 0.00024608232,
				"type": "OTHER"
			},
			{
				"name": "jus ad",
				"salience": 0.00024608232,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00024107771,
				"type": "WORK_OF_ART"
			},
			{
				"name": "modus operandi",
				"salience": 0.00023793014,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.00023793014,
				"type": "EVENT"
			},
			{
				"name": "jurisprudence",
				"salience": 0.00023793014,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.00023793014,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.00023793014,
				"type": "OTHER"
			},
			{
				"name": "rebel",
				"salience": 0.00023793014,
				"type": "OTHER"
			},
			{
				"name": "imagination",
				"salience": 0.00023793014,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00023793014,
				"type": "OTHER"
			},
			{
				"name": "chapter",
				"salience": 0.0002356009,
				"type": "WORK_OF_ART"
			},
			{
				"name": "author",
				"salience": 0.00023367548,
				"type": "PERSON"
			},
			{
				"name": "Rashedun Caliphs",
				"salience": 0.00022944532,
				"type": "PERSON"
			},
			{
				"name": "Chapter 10",
				"salience": 0.00022891117,
				"type": "ORGANIZATION"
			},
			{
				"name": "laws",
				"salience": 0.00022733374,
				"type": "OTHER"
			},
			{
				"name": "myth",
				"salience": 0.00022330957,
				"type": "OTHER"
			},
			{
				"name": "head of state",
				"salience": 0.00021336415,
				"type": "PERSON"
			},
			{
				"name": "surprise",
				"salience": 0.00020525431,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00020525431,
				"type": "ORGANIZATION"
			},
			{
				"name": "room",
				"salience": 0.00019264121,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.00019120038,
				"type": "PERSON"
			},
			{
				"name": "discussion",
				"salience": 0.00018936332,
				"type": "EVENT"
			},
			{
				"name": "pages",
				"salience": 0.00018936332,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00018697655,
				"type": "OTHER"
			},
			{
				"name": "apology",
				"salience": 0.00018544843,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03kvm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hadith"
				},
				"name": "Hadith",
				"salience": 0.00017937743,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.00017921187,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00017921187,
				"type": "OTHER"
			},
			{
				"name": "offenders",
				"salience": 0.00017772653,
				"type": "ORGANIZATION"
			},
			{
				"name": "references",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "bibliography",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00017772653,
				"type": "LOCATION"
			},
			{
				"name": "index",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "faint",
				"salience": 0.00017772653,
				"type": "PERSON"
			},
			{
				"name": "heart",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "sequence",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "arena",
				"salience": 0.00017772653,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.00017772653,
				"type": "PERSON"
			},
			{
				"name": "novel",
				"salience": 0.00017772653,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pudding",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "arguments",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "genre",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "recommendation",
				"salience": 0.00017772653,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.00017327453,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christianity",
				"salience": 0.0001726798,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00017252042,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.00017123004,
				"type": "PERSON"
			},
			{
				"name": "scholars",
				"salience": 0.00017123004,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.00017109052,
				"type": "OTHER"
			},
			{
				"name": "researcher",
				"salience": 0.0001655571,
				"type": "PERSON"
			},
			{
				"name": "letters",
				"salience": 0.0001655571,
				"type": "WORK_OF_ART"
			},
			{
				"name": "topic",
				"salience": 0.0001607341,
				"type": "OTHER"
			},
			{
				"name": "writing",
				"salience": 0.0001593754,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.00015085634,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00014973193,
				"type": "OTHER"
			},
			{
				"name": "disinformation",
				"salience": 0.00014947662,
				"type": "OTHER"
			},
			{
				"name": "roof",
				"salience": 0.00014947662,
				"type": "OTHER"
			},
			{
				"name": "roof",
				"salience": 0.00014947662,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00014947662,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00014947662,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.00014947662,
				"type": "OTHER"
			},
			{
				"name": "world governance",
				"salience": 0.00014947662,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.00014389525,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.00014262884,
				"type": "OTHER"
			},
			{
				"name": "letters",
				"salience": 0.00014218083,
				"type": "WORK_OF_ART"
			},
			{
				"name": "criteria",
				"salience": 0.00013386356,
				"type": "OTHER"
			},
			{
				"name": "harmony",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "misinterpretation",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "submission",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "desk",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "pursuit",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "meaning",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.00012942842,
				"type": "LOCATION"
			},
			{
				"name": "depiction",
				"salience": 0.00012942842,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sense",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "essence",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.00012942842,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00012631735,
				"type": "LOCATION"
			},
			{
				"name": "topic",
				"salience": 0.00012471786,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h1dr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chapter_7,_Title_11,_United_States_Code"
				},
				"name": "Chapter 7",
				"salience": 0.00012452173,
				"type": "WORK_OF_ART"
			},
			{
				"name": "peace",
				"salience": 0.00012421858,
				"type": "OTHER"
			},
			{
				"name": "thought process",
				"salience": 0.00012366356,
				"type": "OTHER"
			},
			{
				"name": "cognition process",
				"salience": 0.00012366356,
				"type": "OTHER"
			},
			{
				"name": "lifetime",
				"salience": 0.00012366356,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00012366356,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.000120481396,
				"type": "OTHER"
			},
			{
				"name": "eye opener",
				"salience": 0.00011994307,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.00011165167,
				"type": "PERSON"
			},
			{
				"name": "controversy",
				"salience": 0.00011165167,
				"type": "OTHER"
			},
			{
				"name": "victor",
				"salience": 0.00011165167,
				"type": "PERSON"
			},
			{
				"name": "victors",
				"salience": 0.00011165167,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.00011165167,
				"type": "OTHER"
			},
			{
				"name": "Anyone",
				"salience": 0.00011081651,
				"type": "PERSON"
			},
			{
				"name": "Fort of Islam",
				"salience": 0.00011077124,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-Islamic non-Muslim",
				"salience": 0.000109374945,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.000105653446,
				"type": "OTHER"
			},
			{
				"name": "pro",
				"salience": 0.00009667609,
				"type": "OTHER"
			},
			{
				"name": "disservice",
				"salience": 0.00009667609,
				"type": "OTHER"
			},
			{
				"name": "scorn",
				"salience": 0.00009667609,
				"type": "OTHER"
			},
			{
				"name": "dexterity",
				"salience": 0.00009667609,
				"type": "OTHER"
			},
			{
				"name": "epoch",
				"salience": 0.00009667609,
				"type": "OTHER"
			},
			{
				"name": "disbelief",
				"salience": 0.00009667609,
				"type": "OTHER"
			},
			{
				"name": "eye brows",
				"salience": 0.00009667609,
				"type": "PERSON"
			},
			{
				"name": "eyes",
				"salience": 0.00009667609,
				"type": "OTHER"
			},
			{
				"name": "student",
				"salience": 0.00009667609,
				"type": "PERSON"
			},
			{
				"name": "readership",
				"salience": 0.00009667609,
				"type": "OTHER"
			},
			{
				"name": "demise",
				"salience": 0.00009667609,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.00009198851,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00008999293,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c0wvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crusades"
				},
				"name": "Crusade",
				"salience": 0.000079650075,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/026pgxk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caliphate"
				},
				"name": "Caliphate",
				"salience": 0.0000761022,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/American_Islam_c1567.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-15T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 25.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.01",
		"text": "1 Shares\n1 0 0 0\nBook Review – Dr. Rafiq Islam, Emertec R&D Ltd; Dalhousie University, Halifax, Nova Scotia\n Book title: True Islam, Jihad, and Terrorism: The Science of Islamic Foreign Policy – Jaan S. Islam\n Publisher: New York: Nova Science Publishers\n ISBN 978-1-63485-542-6.\n At a time of politics of fear, Jaan Islam counters fear with knowledge in his masterpiece, True Islam, Jihad and Terrorism (Nova Science Publishers, New York, 2016). During the 2016 US election, it has become clear world peace and security is connected to the state of Islam and how it is understood in today’s context. This is a very timely book that fills a gap in the western society about Islamic history, philosophy, and political science. This book presents the Islamic political philosophy as represented in the writings of great Muslim thinkers and scholars such as Ibn Khaldun. Jaan Islam uses the so-called ‘Islamic cognition technique’ and starts the book with a chapter dedicated to Islamic cognition. This chapter on cognition itself is a paradigm shift in the modern research scholarship and can be considered for advancing knowledge in other fields. Such an extension was first pointed by Islam, Zatzman and Islam (2013) in their ground-breaking work on educational curriculum.\nMORE... Stop using millenary religions as a scapegoat for the crimes of Modern Imperialism Another Ramadan for Muslims amid sufferings A conversation on equality, integration and Islam as a religious marker An open letter to young Muslims everywhere: The seed of triumph in every adversity Following the tradition of early Islamic scholars, Jaan Islam presented all theories in the book with evidence from the primary Islamic sources, Qur'an and authenticated traditions of the prophet . These sources were completely ignored in the in the Orientalist (now it has morphed into neo-Orientalism) writings, which led to the inundation of the post 9/11 world with disinformation and agenda-driven ‘research’ about Islamic history. The distinction between this book and these agenda-driven ones gives the book a special value.\n Although the book explains the Islamic foundations of political science and governance, it should not be looked at as a book of theology. It is a dogma-free approach that has been characterized as truly scientific elsewhere . Quite appropriately, the author starts off with a brilliant narration of Islamic cognition. It has been all but forgotten in the west that Islam is the religion that started the tradition of dogma-free, truly scientific cognition. The west does recognize Averröes, the famous Islamic scholar as the father of secular philosophy, whereas brands Islam as just another religion, similar to Christianity, infected with doctrinal philosophy. It is no surprise that with that starting point, Islam remains the most misunderstood religion in the west.\nChapter 3 of the book deals with fundamental philosophies of three major philosophers, namely Hobbes, Locke and Ibn Khaldun. In this chapter, the author debunks another myth, that is Ibn Khaldun’s political theory is somehow similar to those of Hobbes and Locke. Ibn Khaldun, the father of social science, indeed had a very different starting point in his cognition. The author points out how Ibn Khaldun’s first premise was Shahadah that formed the basis of the cognition axis by using Qur’an as the origin and prophet Muhammad’s life (through the book of Hadith) as the pivotal point. One the other hand, Locke had placed himself as the pivotal point, whereas Hobbes eliminated any cognition point. The author makes it clear that both Hobbes’ and Locke’s cognition tools are just as illogical as dogmatic cognition. In my researched opinion, this accurate distinction has not been made by any other author on the topic. It is because the eastern authors do not know about Hobbes and Locke and the western authors do not know about Islamic cognition that was obviously alive and well with Ibn Khaldun.\nIn Chapter 4, the author uses the case laws of the prophet and his four rightly guided caliphs (known as Rashedun Caliphs). Clearly, the author’s intention is to understand how the prophet and his closest followers went to war or which verses of the Qur’an they were enacting. For the first time anyone took this approach and not surprisingly, the author comes up with four rigid criteria from the Qur’an. No other author to the best of my knowledge connected them to specific wars that the prophet and his companions engaged in. This finding helps the author establish jus ad bellum that can explain every war that shaped the foundation of the young Islamic state of the time.\nSimilar to Chapter 4, the author discovers jus ad bello in Islamic jurisprudence in Chapter 5. Once again, the case laws are presented and analyzed in such a manner, one can take any new example and evaluate it to call it permissible or not. The theoretical basis for critiquing any modern warfare is set in this chapter.\nIn Chapter 6, the author addresses a difficult topic. When is it allowed or even mandatory to rebel against a head of state? It is often stated that Islam is a complete code of life. The author makes it clear that Islam didn’t leave anything to imagination and has left a strict criterion and modus operandi for any imaginable crisis that can occur at any time. The important question arises as to when a head of state that once claimed to have divine authority can be removed or when a head of state can be declared unfit and it becomes mandatory for the citizens to remove him or wage war if necessary. This is not an easy topic to cover even in today’s world. The author covers it with dexterity from an epoch he considers as exemplary. The history is not pretty and there is room for controversy as often the history is written by the victor and clearly after the demise of the rightly guided Caliphate, the victors were no longer rightly guided. The author weaves through this difficult process and makes it clear for the readership. This chapter can be an eye opener even for a student of Islam that has spent lifetime on the topic.\nOften when Islamic criteria are discussed, eyes roll and eye brows furrow in disbelief. If it is all that simple, why don’t Islamic scholars have consensus? The author handles this topic like a pro. In Chapter 7, he analyzes current Islamic scholars and deconstructs their thought process. He has kind words for some but has nothing but scorn for the self-righteous, apologist ‘scholars’ that have done great disservice to Islam and/or scientific cognition process. One doesn’t have to be personal, but the writing is so clear, one can hardly afford to not get angry at certain genre of scholars. To anyone’s surprise, this list is not made out of anti-Islamic non-Muslim scholars.\nChapter 8 is where proof of the pudding appears. The author analyzes every major event of today’s political arena and analyzes it with the Islamic criteria of both jus ad bello and jus ad bellum. The author comes up with an index to rank various countries and groups. Most interesting is the discussion on current US allies, such as Saudi Arabia, and how they rank among the biggest offenders of Islam and Islamic laws. This is not a topic for the faint of heart but the author did an excellent job making it easily readable, punctuated with numerous riveting arguments.\nChapter 9 is the conclusion and recommendation. I have studied Islam for some 30 years and yet I found these conclusions novel and entirely logical. I doubt anyone would agree with the conclusions unless of course that person reads the entire book prior to reading the conclusion. It is important to read the book in sequence.\nChapter 10 lists the bibliography and references. It is many pages long and is quite comprehensive.\nChapter 11 is the Appendix that lists the letters of the prophet. It is a great idea to give the letters in original Arabic, so there is no room for misinterpretation, let alone disinformation.\nAnyone with knowledge of Islam knows that Jihad is in the core of Islam and this book shows it is so and there needs to be no apology. Quite interestingly, the author even depicts Jihad as the roof of Islam. Without the roof, the Fort of Islam has no protection whatsoever. This depiction captures the essence of protection, security, as well as integrity and puts away the notion of Jihad being a weapon for Crusade like aggression.\nThis book belongs to the desk of any researcher interested in knowing about Islam or what Islam can do to bring about peace on earth in order to live out the true meaning of the word, Islam that means peace through submission to the creator. This book is equally useful for anyone interested in pursuit of peace and harmony that is truly elusive in today’s world. In this sense, this book is a manual for world governance in peace.",
		"thread_title": "Cognition and True Islam - A Book Review",
		"title": "Cognition and True Islam - A Book Review",
		"type": "bs",
		"uuid": "3ebec8d60b8f908adf8665eb0f571cb80c6f2532"
	},
	"-KhIbYhL5bvsUGnJbZu-": {
		"author": "Tyler Healey",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-15T22:35:29.071+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.5576713,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.13573696,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.13020182,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.04657553,
				"type": "LOCATION"
			},
			{
				"name": "end",
				"salience": 0.023406673,
				"type": "EVENT"
			},
			{
				"name": "climate crisis",
				"salience": 0.019653969,
				"type": "EVENT"
			},
			{
				"name": "humanity",
				"salience": 0.018930454,
				"type": "PERSON"
			},
			{
				"name": "humanity",
				"salience": 0.012052693,
				"type": "PERSON"
			},
			{
				"name": "human extinction",
				"salience": 0.011268052,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.010850683,
				"type": "PERSON"
			},
			{
				"name": "Guy McPherson",
				"salience": 0.010544955,
				"type": "PERSON"
			},
			{
				"name": "demise",
				"salience": 0.0104486495,
				"type": "EVENT"
			},
			{
				"name": "climate crisis",
				"salience": 0.0065828566,
				"type": "EVENT"
			},
			{
				"name": "denier",
				"salience": 0.006075431,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Donald_J._Trump_149fc.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-15T17:43:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 1.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.04",
		"text": "\"But Trump's victory is not the end of the world, either.\"\nIt might be the end of humanity, though. According to Guy McPherson, the climate crisis is poised to cause human extinction by 2030. Trump is a denier of the climate crisis, so he likely will hasten humanity's demise if the people allow him to do so.",
		"thread_title": "Defeating White Liberalism in the Age of Trump",
		"title": "",
		"type": "bs",
		"uuid": "17148cd6b73363b53685bb127b7421d8303b8eba"
	},
	"-KhIbYkgCjJQeKtZp9wU": {
		"author": "Chauncey Brooks",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-15T22:36:24.037+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Peterson",
				"salience": 0.7327187,
				"type": "PERSON"
			},
			{
				"name": "voting process",
				"salience": 0.13189812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.06875168,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0lq3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electoral_College_(United_States)"
				},
				"name": "Electoral College",
				"salience": 0.038055103,
				"type": "ORGANIZATION"
			},
			{
				"name": "China.Thanks",
				"salience": 0.028576385,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Protest_against_Donald_Trump_2_22585.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-11-15T15:21:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "\"Ms Peterson please participate in the voting process of Cuba or China.Thanks\"-The Electoral College",
		"thread_title": "The Unethicality of the Sore Loser",
		"title": "",
		"type": "bs",
		"uuid": "624d099b62b20a13f838fc72b023519847f8847a"
	},
	"-KhIbYrBygQyTgXAEOVm": {
		"author": "Professional Human",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-15T22:47:33.440+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 1,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Xi_Jinping_2_ba318.jpg",
		"ord_in_thread": "1",
		"participants_count": "6",
		"published": "2016-11-15T12:55:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.7
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Thank you, China.",
		"thread_title": "China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b",
		"title": "",
		"type": "bs",
		"uuid": "e8ce40cd7792504d3c10b3603fa552ff46b418cc"
	},
	"-KhIbYvtn9uZeXVkeMlo": {
		"author": "Justin Sawchuk",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-15T22:47:33.475+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "nukes",
				"salience": 0.37579557,
				"type": "LOCATION"
			},
			{
				"name": "hell",
				"salience": 0.26220787,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "CHINA",
				"salience": 0.14159063,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.12570496,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.09470098,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Xi_Jinping_2_ba318.jpg",
		"ord_in_thread": "2",
		"participants_count": "6",
		"published": "2016-11-15T13:29:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "hope he nukes the hell out of CHINA disgusting race of people",
		"thread_title": "China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b",
		"title": "",
		"type": "bs",
		"uuid": "3197b3f0b6bbd98a4e6b217d3b1eff19c62d1358"
	},
	"-KhIgN-46_5QTcDaxkB7": {
		"author": "billy crazy",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-15T22:47:33.484+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Nukes",
				"salience": 0.34844667,
				"type": "OTHER"
			},
			{
				"name": "Australia Donald",
				"salience": 0.30775535,
				"type": "PERSON"
			},
			{
				"name": "Pine Gap",
				"salience": 0.17949635,
				"type": "LOCATION"
			},
			{
				"name": "everyone",
				"salience": 0.082150824,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.082150824,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Xi_Jinping_2_ba318.jpg",
		"ord_in_thread": "3",
		"participants_count": "6",
		"published": "2016-11-15T15:11:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "If he's not nice to Australia Donald won't be able to track his Nukes from Pine Gap. So let's see how good he is at keeping everyone on side.",
		"thread_title": "China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b",
		"title": "",
		"type": "bs",
		"uuid": "c1ec27021bfb02078dc2d17b412736c18d74c4c9"
	},
	"-KhIgN4V94Mlm7LpfTrS": {
		"author": "nepali hercules",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-15T22:47:33.500+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "swine",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Xi_Jinping_2_ba318.jpg",
		"ord_in_thread": "4",
		"participants_count": "6",
		"published": "2016-11-15T15:14:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "you should've been swallowed you inbred swine",
		"thread_title": "China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b",
		"title": "",
		"type": "bs",
		"uuid": "dc84742f2581562ae696c448c461e437401281d1"
	},
	"-KhIgN8Y3AYY2DDrb7fS": {
		"author": "wjfox",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-15T22:47:33.518+02:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Xi_Jinping_2_ba318.jpg",
		"ord_in_thread": "5",
		"participants_count": "6",
		"published": "2016-11-15T16:51:00.000+02:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Wow, you sound completely psychotic.",
		"thread_title": "China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b",
		"title": "",
		"type": "bs",
		"uuid": "ba63cf4d75d1a728994a6d60ffd83db9d771d0c6"
	},
	"-KhIgNUw3XYz76uItSq6": {
		"author": "Tim King",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-16T09:13:53.539+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.66635954,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.06789442,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.045844935,
				"type": "PERSON"
			},
			{
				"name": "Citizens",
				"salience": 0.010196698,
				"type": "PERSON"
			},
			{
				"name": "dawning",
				"salience": 0.007930605,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0077708443,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0070864838,
				"type": "PERSON"
			},
			{
				"name": "Women",
				"salience": 0.006730846,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0060738456,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.0041172924,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0039424594,
				"type": "LOCATION"
			},
			{
				"name": "Grandfather",
				"salience": 0.0038718705,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0037796276,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.0037546854,
				"type": "OTHER"
			},
			{
				"name": "Millions",
				"salience": 0.0036531258,
				"type": "PERSON"
			},
			{
				"name": "Brian Cloughley",
				"salience": 0.0035220808,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.003293424,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0030936198,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0027222703,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0026071959,
				"type": "OTHER"
			},
			{
				"name": "Trump supporters",
				"salience": 0.0024614537,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.002430479,
				"type": "OTHER"
			},
			{
				"name": "wild card candidate",
				"salience": 0.002430479,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.002430479,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.002430479,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07hwkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_American"
				},
				"name": "White Americans",
				"salience": 0.0023044562,
				"type": "PERSON"
			},
			{
				"name": "turns",
				"salience": 0.0022425842,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0022425842,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.002154614,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.002104962,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.002104962,
				"type": "EVENT"
			},
			{
				"name": "swaths",
				"salience": 0.002104962,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.002104962,
				"type": "OTHER"
			},
			{
				"name": "criteria",
				"salience": 0.002104962,
				"type": "OTHER"
			},
			{
				"name": "acceptability",
				"salience": 0.002104962,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.002104962,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.002104962,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.002104962,
				"type": "EVENT"
			},
			{
				"name": "least",
				"salience": 0.002104962,
				"type": "OTHER"
			},
			{
				"name": "whipping pole",
				"salience": 0.002104962,
				"type": "OTHER"
			},
			{
				"name": "End",
				"salience": 0.0015111336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Blacks",
				"salience": 0.0014966754,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01g7zj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexican_American"
				},
				"name": "Mexicans",
				"salience": 0.0014966754,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0013522919,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0011516752,
				"type": "OTHER"
			},
			{
				"name": "perception",
				"salience": 0.0011170508,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0011087011,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0011087011,
				"type": "ORGANIZATION"
			},
			{
				"name": "anger",
				"salience": 0.0011087011,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0010684045,
				"type": "ORGANIZATION"
			},
			{
				"name": "Liberalism",
				"salience": 0.0010267824,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0010017755,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0010010761,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George Bush",
				"salience": 0.0009255992,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00091286795,
				"type": "PERSON"
			},
			{
				"name": "Insults",
				"salience": 0.0008779373,
				"type": "OTHER"
			},
			{
				"name": "blanket",
				"salience": 0.00086687657,
				"type": "OTHER"
			},
			{
				"name": "criminals",
				"salience": 0.00086687657,
				"type": "PERSON"
			},
			{
				"name": "traits",
				"salience": 0.00086687657,
				"type": "OTHER"
			},
			{
				"name": "knees",
				"salience": 0.00086687657,
				"type": "OTHER"
			},
			{
				"name": "rapists",
				"salience": 0.00086687657,
				"type": "EVENT"
			},
			{
				"name": "field harvesting",
				"salience": 0.00086687657,
				"type": "OTHER"
			},
			{
				"name": "human being",
				"salience": 0.00086687657,
				"type": "PERSON"
			},
			{
				"name": "doses",
				"salience": 0.00086687657,
				"type": "OTHER"
			},
			{
				"name": "mark",
				"salience": 0.00086687657,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00086687657,
				"type": "OTHER"
			},
			{
				"name": "roles",
				"salience": 0.00086687657,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0008642553,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00084149436,
				"type": "EVENT"
			},
			{
				"name": "track record",
				"salience": 0.00081727694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolph Hitler",
				"salience": 0.00081142015,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01g7zj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexican_American"
				},
				"name": "Mexican",
				"salience": 0.00081142015,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0007774033,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00075197953,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0007483871,
				"type": "EVENT"
			},
			{
				"name": "anger",
				"salience": 0.0007483871,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.00074786437,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.00070627726,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0007019215,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0007019215,
				"type": "OTHER"
			},
			{
				"name": "predator characteristics",
				"salience": 0.0007019215,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0006869796,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0006792272,
				"type": "PERSON"
			},
			{
				"name": "Age",
				"salience": 0.00067572115,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.00067572115,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0006394327,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.00063814136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00063769816,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.00063769816,
				"type": "LOCATION"
			},
			{
				"name": "nations",
				"salience": 0.00063465134,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00063465134,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.00063465134,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00063465134,
				"type": "ORGANIZATION"
			},
			{
				"name": "taxes",
				"salience": 0.0006313753,
				"type": "OTHER"
			},
			{
				"name": "lips",
				"salience": 0.0006313753,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0006187578,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0006183256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02189",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Communist_Party_of_China"
				},
				"name": "Communists",
				"salience": 0.0006162039,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.0006162039,
				"type": "PERSON"
			},
			{
				"name": "note",
				"salience": 0.000607807,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.000607807,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.000607807,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.000607807,
				"type": "OTHER"
			},
			{
				"name": "World",
				"salience": 0.000607807,
				"type": "LOCATION"
			},
			{
				"name": "request",
				"salience": 0.000607807,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.00058511813,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.00058511813,
				"type": "PERSON"
			},
			{
				"name": "Discussions",
				"salience": 0.00058511813,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.00058511813,
				"type": "OTHER"
			},
			{
				"name": "bully demeanor",
				"salience": 0.00058511813,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.00058511813,
				"type": "OTHER"
			},
			{
				"name": "point of view",
				"salience": 0.00058511813,
				"type": "OTHER"
			},
			{
				"name": "meltdown",
				"salience": 0.00058511813,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.0005815881,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.0005730241,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.0005730241,
				"type": "OTHER"
			},
			{
				"name": "human rights violations",
				"salience": 0.0005730241,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0005554424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "WWII",
				"salience": 0.0005335779,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.0005335779,
				"type": "PERSON"
			},
			{
				"name": "expose",
				"salience": 0.0005220059,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.0004961859,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "taxpayers",
				"salience": 0.0004961859,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0004961859,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0004961859,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0004961859,
				"type": "ORGANIZATION"
			},
			{
				"name": "volumes",
				"salience": 0.0004961859,
				"type": "OTHER"
			},
			{
				"name": "trillions",
				"salience": 0.0004961859,
				"type": "OTHER"
			},
			{
				"name": "killing",
				"salience": 0.0004961859,
				"type": "EVENT"
			},
			{
				"name": "understanding",
				"salience": 0.0004961859,
				"type": "OTHER"
			},
			{
				"name": "cable",
				"salience": 0.0004961859,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "peace",
				"salience": 0.0004831191,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Obamacare",
				"salience": 0.00047849322,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00047766225,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00047409013,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.00047409013,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.0004716426,
				"type": "OTHER"
			},
			{
				"name": "fraction",
				"salience": 0.00045982987,
				"type": "OTHER"
			},
			{
				"name": "debacle",
				"salience": 0.00045685112,
				"type": "OTHER"
			},
			{
				"name": "tax cuts",
				"salience": 0.00043157584,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00042834826,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00042804904,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.00042804904,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00042117934,
				"type": "PERSON"
			},
			{
				"name": "impeachment process",
				"salience": 0.000412772,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00037408815,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00037408815,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.00037408815,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.00037408815,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.00037374292,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00037374292,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.00037064552,
				"type": "OTHER"
			},
			{
				"name": "election gimmick",
				"salience": 0.00037064552,
				"type": "OTHER"
			},
			{
				"name": "needs",
				"salience": 0.00037064552,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00037064552,
				"type": "PERSON"
			},
			{
				"name": "moves",
				"salience": 0.00037064552,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.00037064552,
				"type": "PERSON"
			},
			{
				"name": "tempers",
				"salience": 0.00037064552,
				"type": "OTHER"
			},
			{
				"name": "wishes",
				"salience": 0.00037064552,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.00036597418,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.00036012143,
				"type": "OTHER"
			},
			{
				"name": "The Greatest Achievement",
				"salience": 0.00036012143,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.0003584085,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.00034526823,
				"type": "PERSON"
			},
			{
				"name": "hope",
				"salience": 0.00033066113,
				"type": "OTHER"
			},
			{
				"name": "goals",
				"salience": 0.00032237856,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00031461197,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.0003117347,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.00031034197,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.00030537872,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cvy3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halliburton"
				},
				"name": "Halliburton",
				"salience": 0.00030537872,
				"type": "ORGANIZATION"
			},
			{
				"name": "answer",
				"salience": 0.00028759998,
				"type": "OTHER"
			},
			{
				"name": "sync",
				"salience": 0.0002699264,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0002699264,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.0002699264,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.0002699264,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0002699264,
				"type": "EVENT"
			},
			{
				"name": "warmongering",
				"salience": 0.00025984782,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0002579043,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0002579043,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0002579043,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0002577241,
				"type": "LOCATION"
			},
			{
				"name": "task",
				"salience": 0.00025657262,
				"type": "OTHER"
			},
			{
				"name": "reconciliation",
				"salience": 0.00023285435,
				"type": "OTHER"
			},
			{
				"name": "violation",
				"salience": 0.00023285435,
				"type": "OTHER"
			},
			{
				"name": "liberal",
				"salience": 0.00023285435,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00023285435,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00023285435,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00023285435,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.00022810638,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.00020162348,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.00020162348,
				"type": "PERSON"
			},
			{
				"name": "law.",
				"salience": 0.00020162348,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.00020162348,
				"type": "OTHER"
			},
			{
				"name": "shape",
				"salience": 0.00020162348,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.00020162348,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00020162348,
				"type": "EVENT"
			},
			{
				"name": "line",
				"salience": 0.00020162348,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.00020162348,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.00020162348,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00020162348,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black",
				"salience": 0.00019184765,
				"type": "PERSON"
			},
			{
				"name": "post-WWII",
				"salience": 0.00016611599,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.00014329988,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00013220421,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.00012407912,
				"type": "ORGANIZATION"
			},
			{
				"name": "pro-Trump",
				"salience": 0.00012407912,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00012407912,
				"type": "PERSON"
			},
			{
				"name": "choices",
				"salience": 0.00010293224,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Anti_Trump_Protests_23a57.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-16T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 22.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "9 Shares\n7 0 0 2\nCitizens of the United States have chosen the wealthy businessman, Donald Trump, as their new President. Trump, who was considered a wild card candidate, will take control of the country in January to fill his four year term. Violent protests are raging and attacks against those who oppose Trump or fail to fit his criteria of acceptability are on the rise. Trump supporters have also been attacked. To say the very least, this is the dawning of a new age in America. To put it mildly, Trump alienated huge swaths of humanity during his campaign. Women, Mexicans, Muslims, Blacks, the media… have all taken their turns at his whipping pole. Trump’s harsh words have been used to condemn huge groups. The only people Trump hasn’t attacked are White American males.\nThe only people Trump hasn’t attacked are White American males.\nInterestingly, Trump shares many traits with the man who brought Germany to its knees during WWII, Adolph Hitler. Hitler rallied Germans by directing national anger toward two primary groups, the Communists and the Jews. Trump rallied Americans by directing high doses of anger toward Mexico and Muslims. Trump’s perception of Mexican immigrants is way off the mark, as the majority of those who emigrate to the US are hard working people willing to perform roles most White Americans avoid, like field harvesting. Nonetheless, Trump has described them as rapists and criminals, tossing a blanket over every human being who finds their way to the US through illegal means.\nWhen it comes to Muslims, Mr. Trump is exceptionally ignorant. He fulfills the thoughts of those in the Middle East who already believe the US has a long range plan to eliminate Islam.\nMillions of Americans are having a meltdown over the election of Trump, while those who supported his bid for presidency continue to express anger and simultaneously, imitate Trump’s bully demeanor by attacking those who disagree with their point of view, particularly in social media. Insults have never been so foul and widespread. Everyone is riled, people are unsure of what to do. It seems almost certain that things are going to get a lot worse before they could ever get better.\nMORE... Defeating White Liberalism in the Age of Trump Brian Cloughley: “The Greatest Achievement of Mr. Trump would be Engage in Positive Discussions with Russia and China” Arise President Trump (or Why it's not the End of the World as We Know it) Trump's sexual predator characteristics - His Grandfather was a pimp, but at least he paid the women he hired On a positive note, Trump has backed off on his threat to dismantle Obamacare. One thing is certain, Donald Trump is extremely willing to toss out ideas and positions and then change his mind the following day. Unfortunately, Trump did this when initially exposing the connection between Barack Obama and Hillary Clinton and ISIS.\nIt is an absolute fact that the United States was directly responsible for starting two more wars in the Middle East, in Syria and Libya. Both conflicts were deadly and destabilizing and waged at the request of Israel, as a Wikileaks cable recently confirmed. The mere idea that nations are trampled this way cements our understanding of how Obama and Clinton operate. It also speaks volumes about the dark ways that the US has been manipulated by the Zionist government of Israel, a nation that drains US taxpayers of more than $4 million a day. The track record of human rights violations in Israel goes well beyond unforgivable.\nThe ISIS expose was a golden moment for Trump, even though he didn’t stick to his guns. The wars the US has been waging in recent years are all unjustified conflicts used to make large amounts of money for groups like Halliburton and mercenary organizations. While the US government spends trillions on killing, it has historically ignored the suffering its allies direct toward their own citizens. One great example is Saudi Arabia, the radical Wahhabi government that still beheads people in public in strict violation of international law.These problems have sullied US support for many years.\nThe only hope for the future lies in peace and reconciliation. For Clinton, maintaining peace was a seemingly impossible task. Lest we forget it was her threats of war toward Russia and Iran that crossed the line for large numbers of Americans. Parading as a liberal, Hillary Clinton’s warmongering is legendary. The Democratic National Committee debacle that derailed the only promising candidate, Bernie Sanders, was equally reprehensible.\nIn the end, there were no good choices for US voters. The pro-Trump crowd may not feel as victorious once they realize that Mr. Trump does not care about them in any way, shape or form. Only days after the election, it is already being announced that the tax cuts Trump promised will only be a fraction of what he claimed, it is reminiscent of former US President George Bush's famous words, \"Read my lips: no new taxes\". Of course each man offered the promise as an election gimmick, each time it was enough to convince Republicans. Trump is here to promote his own needs and to meet his own goals. Perhaps some of his political moves will coincide with the wishes of his voters, perhaps not.\nIn the meanwhile tempers are flaring, and Americans are increasingly turning against each other. The real unavoidable truth is that Donald Trump will be the next US President. He says he is going to make America great again and many of us wonder exactly what that means. In the post-WWII years there was peace, unless you were Black. Americans had freedom, unless they were women or minorities.\nThe United States has always waged illegal wars, dating back to the very beginning when one treaty with Native people after another, was broken. Is Donald Trump going to keep the US out of wars for the next four years? It would be a very good thing if he did.\nOn one hand, it seems entirely doubtful that the country will make it through four years of Donald Trump, but giving up is not the answer. If Trump goes too far out of sync, or becomes embroiled in charges that he can't pay off or threaten away, there is an impeachment process that Americans can follow.",
		"thread_title": "Will America Survive the Next 4 Years?",
		"title": "Will America Survive the Next 4 Years?",
		"type": "bs",
		"uuid": "9369250898be7128056300197632276e576c30a2"
	},
	"-KhIgNiIra0wZCgf7ObQ": {
		"author": "Kim Petersen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-16T09:28:55.480+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.690588,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06406865,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Kingdom of Saudi Arabia",
				"salience": 0.042844716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0165_d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/OPEC"
				},
				"name": "Organization of Petroleum Exporting Countries",
				"salience": 0.011620885,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kingdom",
				"salience": 0.0112523,
				"type": "LOCATION"
			},
			{
				"name": "energy minister",
				"salience": 0.009799729,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.009756327,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05756s3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khalid_A._Al-Falih"
				},
				"name": "Khalid al-Falih",
				"salience": 0.00966296,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.007813225,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0069144955,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0063906303,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.0057730777,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.0057730777,
				"type": "OTHER"
			},
			{
				"name": "oil imports",
				"salience": 0.0050021987,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0050021987,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0050021987,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/054rw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marrakesh"
				},
				"name": "Marrakesh",
				"salience": 0.0045914343,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.0045788926,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0044358233,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0030168702,
				"type": "EVENT"
			},
			{
				"name": "producer",
				"salience": 0.0025383646,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.0023826847,
				"type": "PERSON"
			},
			{
				"name": "refining industry",
				"salience": 0.0020743608,
				"type": "OTHER"
			},
			{
				"name": "foes",
				"salience": 0.002063668,
				"type": "PERSON"
			},
			{
				"name": "oil cartels",
				"salience": 0.002063668,
				"type": "OTHER"
			},
			{
				"name": "campaign trail",
				"salience": 0.002063668,
				"type": "LOCATION"
			},
			{
				"name": "election process",
				"salience": 0.002063668,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.002063668,
				"type": "OTHER"
			},
			{
				"name": "nuts",
				"salience": 0.0020120589,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0018509062,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.0018509062,
				"type": "OTHER"
			},
			{
				"name": "oil industry",
				"salience": 0.0017818955,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0017818955,
				"type": "OTHER"
			},
			{
				"name": "Syndrome",
				"salience": 0.0017582403,
				"type": "OTHER"
			},
			{
				"name": "world leader",
				"salience": 0.0016090461,
				"type": "PERSON"
			},
			{
				"name": "Oil Minister",
				"salience": 0.0016090461,
				"type": "PERSON"
			},
			{
				"name": "product",
				"salience": 0.0016090461,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "oil supplier",
				"salience": 0.001542128,
				"type": "ORGANIZATION"
			},
			{
				"name": "climate change agreement",
				"salience": 0.0014474672,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0014474672,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0014474672,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0014474672,
				"type": "OTHER"
			},
			{
				"name": "energy culture",
				"salience": 0.0014474672,
				"type": "OTHER"
			},
			{
				"name": "bolts",
				"salience": 0.0013934798,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mentality syndrome",
				"salience": 0.0013821031,
				"type": "OTHER"
			},
			{
				"name": "Report",
				"salience": 0.001364701,
				"type": "OTHER"
			},
			{
				"name": "mentality",
				"salience": 0.001364701,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.0013246117,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qjg2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Aramco"
				},
				"name": "Saudi Aramco",
				"salience": 0.0013043872,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0012708283,
				"type": "ORGANIZATION"
			},
			{
				"name": "markets",
				"salience": 0.0011818344,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.0011818344,
				"type": "OTHER"
			},
			{
				"name": "shale revolution",
				"salience": 0.0011818344,
				"type": "OTHER"
			},
			{
				"name": "flag-bearer",
				"salience": 0.0011818344,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0011818344,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.0011818344,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0011818344,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North American",
				"salience": 0.0010291069,
				"type": "LOCATION"
			},
			{
				"name": "reports",
				"salience": 0.0010068,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0009527526,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.00089117256,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0008903506,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.0008829757,
				"type": "ORGANIZATION"
			},
			{
				"name": "oil purchases",
				"salience": 0.0008829757,
				"type": "OTHER"
			},
			{
				"name": "floor",
				"salience": 0.0008829757,
				"type": "OTHER"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.0008829757,
				"type": "EVENT"
			},
			{
				"name": "crude oil",
				"salience": 0.00087311585,
				"type": "OTHER"
			},
			{
				"name": "apartments",
				"salience": 0.00085002615,
				"type": "LOCATION"
			},
			{
				"name": "oil",
				"salience": 0.00081949047,
				"type": "OTHER"
			},
			{
				"name": "real estate magnate",
				"salience": 0.00076804386,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02jf15",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_News_(New_York)"
				},
				"name": "NY Daily News",
				"salience": 0.0007368437,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congressional",
				"salience": 0.0007275606,
				"type": "ORGANIZATION"
			},
			{
				"name": "ground troops",
				"salience": 0.0007208676,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0006882943,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00064601365,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0006431285,
				"type": "OTHER"
			},
			{
				"name": "spokeswoman",
				"salience": 0.0006431285,
				"type": "PERSON"
			},
			{
				"name": "regime",
				"salience": 0.0006431285,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0006431285,
				"type": "LOCATION"
			},
			{
				"name": "relations",
				"salience": 0.0006431285,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0006431285,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0006144951,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.0006144951,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0108kc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Financial_Times"
				},
				"name": "Financial Times",
				"salience": 0.0005790964,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0005717997,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.00054352026,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03xjb9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump_World_Tower"
				},
				"name": "Trump World Tower",
				"salience": 0.00054352026,
				"type": "LOCATION"
			},
			{
				"name": "records",
				"salience": 0.00053851947,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0004804363,
				"type": "EVENT"
			},
			{
				"name": "commodity",
				"salience": 0.0004804363,
				"type": "OTHER"
			},
			{
				"name": "equalization",
				"salience": 0.0004804363,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle Eastern",
				"salience": 0.00045714848,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.00039584775,
				"type": "ORGANIZATION"
			},
			{
				"name": "Saudi Mission",
				"salience": 0.00039584775,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01zq91",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Finance_minister"
				},
				"name": "Finance Department",
				"salience": 0.00039584775,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.00039584775,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Khalid_al-Falih_d3b9e.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-16T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Kingdom’s energy minister says move would risk damaging the US economy. 2 Shares\n1 0 0 1\nSaudi Arabia has warned Donald Trump that the incoming US president will risk the health of his country’s economy if he acts on his election promises to block oil imports.\nOver the course of the two-year American election process, Republican nominee Trump promised on the campaign trail to divest U.S. interests from “our foes and the oil cartels,” referring mainly to the Organization of Petroleum Exporting Countries (OPEC), of which the KSA is the largest producer and de facto leader.\n“At his heart President-elect Trump will see the benefits and I think the oil industry will also be advising him accordingly that blocking trade in any product is not healthy,” Khalid al-Falih , chairman of Aramco and Saudi Aramco Oil Minister, told the Financial Times in Marrakesh, where world leader’s are currently negotiating the nuts and bolts of the landmark 2015 climate change agreement.\nSaudi Arabia is the U.S.’ largest Middle Eastern oil supplier, though the North American country gets most of its energy from domestic and Canadian sources.\nAl-Falih added that the free trade energy culture currently in place benefits the United States because it has created a refining industry and ignited a job-hungry shale revolution.\nMORE... Setting the method to probe U.S.-Saudi wars How the occupied mentality syndrome works Will a 28 page Congressional Report on 9/11 unravel US foreign policy? The occupied mentality Syndrome “The U.S. is sort of the flag-bearer for capitalism and free markets,” according to Al-Falih. “The U.S. continues to be a very important part of a global industry that is interconnected, that is dealing with a fungible commodity which is crude oil. So having equalization through free trade is very healthy for oil.”\nDuring Presidential race Donald Trump had blamed Saudi Arabia for the 9/11 terrorist attacks and in March, the real estate magnate said he would consider stopping US oil purchases from Saudi Arabia and other Arab allies unless the Saudi government provided ground troops to fight ISIS.\nNY Daily News revealed Trump sold the 45th floor of Trump World Tower to the Kingdom of Saudi Arabia for $4.5 million in June 2001, according to a city Finance Department spokeswoman. In 2008, the apartments became part of the Saudi Mission to the United Nations, records show.\nThe reports emerged back then revealed the reality of Trump's relations with the Riyadh regime; but Mr Trump has not always expressed a positive view of the Middle Eastern country.",
		"thread_title": "Saudi Arabia Warns Trump on Blocking Oil Imports: FT",
		"title": "Saudi Arabia Warns Trump on Blocking Oil Imports: FT",
		"type": "bs",
		"uuid": "9dfc425da00aae187d2ba51a6f6b6e4caac2d3c1"
	},
	"-KhIgNuHOqDXJSagI0oc": {
		"author": "M.R. Islam",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-16T21:05:02.969+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Anthony Hall",
				"salience": 0.20873658,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.13994855,
				"type": "LOCATION"
			},
			{
				"name": "Persecution",
				"salience": 0.04879514,
				"type": "OTHER"
			},
			{
				"name": "Populations",
				"salience": 0.03993762,
				"type": "PERSON"
			},
			{
				"name": "Plea",
				"salience": 0.034635663,
				"type": "OTHER"
			},
			{
				"name": "Academic Careers of Steven Salaita",
				"salience": 0.024689348,
				"type": "OTHER"
			},
			{
				"name": "Indigenous Arab",
				"salience": 0.024689348,
				"type": "OTHER"
			},
			{
				"name": "Both",
				"salience": 0.02327834,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hgsqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Offensive_(military)"
				},
				"name": "Attacks",
				"salience": 0.023079446,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.02088078,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.01777069,
				"type": "OTHER"
			},
			{
				"name": "EDITOR",
				"salience": 0.01777069,
				"type": "PERSON"
			},
			{
				"name": "HERALD",
				"salience": 0.01777069,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mike Mahon",
				"salience": 0.017622393,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0829sy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israeli-occupied_territories"
				},
				"name": "Occupied Territories",
				"salience": 0.017064225,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018_3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norman_Finkelstein"
				},
				"name": "Norman Finkelstein",
				"salience": 0.017064225,
				"type": "PERSON"
			},
			{
				"name": "university professor",
				"salience": 0.015577375,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03p5zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Lethbridge"
				},
				"name": "LETHBRIDGE",
				"salience": 0.0101643745,
				"type": "LOCATION"
			},
			{
				"name": "suspension",
				"salience": 0.00948931,
				"type": "EVENT"
			},
			{
				"name": "Mike Mahon",
				"salience": 0.009040431,
				"type": "PERSON"
			},
			{
				"name": "suspension",
				"salience": 0.008467959,
				"type": "EVENT"
			},
			{
				"name": "neighbour",
				"salience": 0.008467959,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01s9tw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abdus_Salam"
				},
				"name": "Salam",
				"salience": 0.007830562,
				"type": "PERSON"
			},
			{
				"name": "position",
				"salience": 0.007334535,
				"type": "OTHER"
			},
			{
				"name": "sibling",
				"salience": 0.007334535,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.007334535,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.007334535,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.007334535,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadians",
				"salience": 0.0070439056,
				"type": "PERSON"
			},
			{
				"name": "academics",
				"salience": 0.00657856,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.0063006985,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.005940614,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0057762107,
				"type": "LOCATION"
			},
			{
				"name": "Tony Hall UK",
				"salience": 0.005705881,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0053976853,
				"type": "LOCATION"
			},
			{
				"name": "analysis",
				"salience": 0.0051449505,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.0051449505,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.0051449505,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0051449505,
				"type": "EVENT"
			},
			{
				"name": "cases",
				"salience": 0.0051449505,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.004953094,
				"type": "OTHER"
			},
			{
				"name": "chagrin",
				"salience": 0.004953094,
				"type": "OTHER"
			},
			{
				"name": "justness",
				"salience": 0.004953094,
				"type": "OTHER"
			},
			{
				"name": "draft dodgers",
				"salience": 0.004953094,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.004953094,
				"type": "PERSON"
			},
			{
				"name": "countrymen",
				"salience": 0.004953094,
				"type": "PERSON"
			},
			{
				"name": "persecution",
				"salience": 0.004850821,
				"type": "OTHER"
			},
			{
				"name": "populations",
				"salience": 0.004850821,
				"type": "PERSON"
			},
			{
				"name": "academics",
				"salience": 0.004702134,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.0044756876,
				"type": "OTHER"
			},
			{
				"name": "marginalization",
				"salience": 0.004200937,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.004200937,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.004200937,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.004200937,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012dwjb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_Salaita"
				},
				"name": "Steven Salaita",
				"salience": 0.0040512704,
				"type": "PERSON"
			},
			{
				"name": "Vice Chancellor",
				"salience": 0.0036244988,
				"type": "PERSON"
			},
			{
				"name": "Prof.",
				"salience": 0.0035663734,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0031387561,
				"type": "OTHER"
			},
			{
				"name": "coast",
				"salience": 0.0031387561,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam War",
				"salience": 0.0030496914,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0150zs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_American"
				},
				"name": "Arab",
				"salience": 0.0029866856,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0025863543,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/089g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionism"
				},
				"name": "Zionism",
				"salience": 0.0025863543,
				"type": "OTHER"
			},
			{
				"name": "Both",
				"salience": 0.0024780002,
				"type": "PERSON"
			},
			{
				"name": "Debacle",
				"salience": 0.0022862412,
				"type": "OTHER"
			},
			{
				"name": "Coverage",
				"salience": 0.0022862412,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.0022862412,
				"type": "PERSON"
			},
			{
				"name": "Anti-Muslim Bias",
				"salience": 0.0021657322,
				"type": "OTHER"
			},
			{
				"name": "neighbour",
				"salience": 0.001972376,
				"type": "LOCATION"
			},
			{
				"name": "peoples",
				"salience": 0.001972376,
				"type": "PERSON"
			},
			{
				"name": "M.R. Islam",
				"salience": 0.001932175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North America",
				"salience": 0.0017999201,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0017079321,
				"type": "LOCATION"
			},
			{
				"name": "playbook",
				"salience": 0.0017079321,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0017079321,
				"type": "OTHER"
			},
			{
				"name": "Genocide of Indigenous Peoples",
				"salience": 0.0014072408,
				"type": "OTHER"
			},
			{
				"name": "AHT",
				"salience": 0.0014072408,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0014072408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/047876",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine_(region)"
				},
				"name": "Palestine",
				"salience": 0.0014072408,
				"type": "LOCATION"
			},
			{
				"name": "Haldimand Deed Recognition Dinner",
				"salience": 0.0014072408,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02f5dj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kanata,_Ontario"
				},
				"name": "Kanata",
				"salience": 0.0014072408,
				"type": "LOCATION"
			},
			{
				"name": "Mohawk Village",
				"salience": 0.0014072408,
				"type": "LOCATION"
			},
			{
				"name": "Brantford Ontario",
				"salience": 0.0014072408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0013445775,
				"type": "PERSON"
			},
			{
				"name": "Teresa Ghannam Sacramento",
				"salience": 0.0010512068,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/lethbridge_herald_1b6cc.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-16T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.995",
		"text": "A Plea from California to Not Replicate in Canada the Attacks on the Academic Careers of Steven Salaita and Norman Finkelstein for Opposing \"the Persecution of the Indigenous Arab Populations of the Occupied Territories.\" 3 Shares\n2 0 0 1\nTO THE EDITOR OF THE LETHBRIDGE HERALD ON NOVEMBER 15, 2016.\nAs an American with Canadian friends, I have been following with some interest and concern the unfolding story of Anthony Hall’s recent suspension from his position at the .\nI have looked to our northern neighbour as one admires a wiser, older sibling. Canadians to me seem less radical, less extreme, and more ethical than my own more reactive countrymen and women. Canada, after all, accepted our draft dodgers of the ’70s who questioned the morality and justness of the Vietnam War. To me, that was something to be lauded. Imagine my chagrin upon learning that a university professor with a 30-year career, who encourages critical analysis and social responsibility, had been suspended without pay, apparently without a formal and unprejudiced investigation occurring first.\nHall’s suspension reminds me of the famous cases of two American academics, Steven Salaita and Norman Finkelstein. Both were openly critical of Zionism and spoke against the marginalization and persecution of the indigenous Arab populations of the Occupied Territories. Both were ostracized publicly for their vocal support of Palestinian rights and lost their jobs.\nI adjure the not to take a page out of the American playbook by punishing academics who dare to speak up for the marginalized peoples of the world. Please live up to the values of the wiser, more ethical and socially conscientious northern neighbour you have always represented for Americans like myself.\nTeresa Ghannam\nSacramento, Calif.\nRecommended For You Dear Vice Chancellor Kamran: Salam from the East coast of Canada. Thank you for taking the time to address this important issue re...\nBy M.R. Islam Creating an Anti-Muslim Bias at a Canadian University Professor Mike Mahon President and Vice Chancellor Lethbridge, Canada Dear Professor Mike Mahon, &...\nBy AHT Staff The Genocide of Indigenous Peoples in North America and Palestine-Israel Prof. Hall speaks at the Haldimand Deed Recognition Dinner at Kanata in the Mohawk Village near Brantford Ontario. Prof. Hall has been the...\nBy Prof. Tony Hall UK Coverage of the Debacle at the ",
		"thread_title": "Don't Make Universities Instruments of Assault on Marginalized Peoples",
		"title": "Don't Make Universities Instruments of Assault on Marginalized Peoples",
		"type": "bs",
		"uuid": "6ee1a525712ec84317515270616ba7c70cae43a5"
	},
	"-KhIgOB4GBhHQaiqGGjP": {
		"author": "Catherine Shakdam",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-16T21:11:00.185+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.22784044,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0600087,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shia Muslims",
				"salience": 0.051807426,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.03304123,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.028656214,
				"type": "OTHER"
			},
			{
				"name": "sectarianism",
				"salience": 0.028656214,
				"type": "OTHER"
			},
			{
				"name": "abomination",
				"salience": 0.0231446,
				"type": "OTHER"
			},
			{
				"name": "Messenger 40",
				"salience": 0.021669364,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "radicalism",
				"salience": 0.01928649,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.017090715,
				"type": "OTHER"
			},
			{
				"name": "distrust",
				"salience": 0.01700301,
				"type": "OTHER"
			},
			{
				"name": "entrepreneurs",
				"salience": 0.015439953,
				"type": "PERSON"
			},
			{
				"name": "hatred",
				"salience": 0.015439953,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.015439953,
				"type": "LOCATION"
			},
			{
				"name": "venom",
				"salience": 0.0133791035,
				"type": "OTHER"
			},
			{
				"name": "cohesion",
				"salience": 0.0133791035,
				"type": "OTHER"
			},
			{
				"name": "discord",
				"salience": 0.0133791035,
				"type": "OTHER"
			},
			{
				"name": "arrogance",
				"salience": 0.0133791035,
				"type": "OTHER"
			},
			{
				"name": "enmity",
				"salience": 0.0133791035,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0133791035,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.010764734,
				"type": "LOCATION"
			},
			{
				"name": "application",
				"salience": 0.009854316,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0082488,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.0082488,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0082488,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0240rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Husayn_ibn_Ali"
				},
				"name": "Husayn ibn Ali",
				"salience": 0.008141384,
				"type": "PERSON"
			},
			{
				"name": "dogma",
				"salience": 0.0074804886,
				"type": "OTHER"
			},
			{
				"name": "fanaticism",
				"salience": 0.0068464223,
				"type": "OTHER"
			},
			{
				"name": "heretic scholar",
				"salience": 0.0068464223,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0068098,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.0062856083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.005744593,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.005595289,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.005444256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/050jw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_ibn_Abd_al-Wahhab"
				},
				"name": "Muhammad Ibn Abdel-Wahhab",
				"salience": 0.0053922134,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.004689713,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/046g7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arba'een"
				},
				"name": "Arbaeen",
				"salience": 0.0043233833,
				"type": "OTHER"
			},
			{
				"name": "nationality",
				"salience": 0.0043138964,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0043138964,
				"type": "LOCATION"
			},
			{
				"name": "social media platform",
				"salience": 0.0041971393,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0039049156,
				"type": "OTHER"
			},
			{
				"name": "product",
				"salience": 0.0036077304,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "resistance",
				"salience": 0.0036077304,
				"type": "OTHER"
			},
			{
				"name": "freedom ring",
				"salience": 0.003411754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0240lv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Saud"
				},
				"name": "House of Saud",
				"salience": 0.003314974,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0032576793,
				"type": "LOCATION"
			},
			{
				"name": "Justice",
				"salience": 0.0032576793,
				"type": "OTHER"
			},
			{
				"name": "media platform",
				"salience": 0.0032576793,
				"type": "OTHER"
			},
			{
				"name": "Haidar Attouq",
				"salience": 0.003108636,
				"type": "PERSON"
			},
			{
				"name": "fortnight",
				"salience": 0.002999629,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0028571268,
				"type": "EVENT"
			},
			{
				"name": "apps",
				"salience": 0.0028211456,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "promotion",
				"salience": 0.0028211456,
				"type": "OTHER"
			},
			{
				"name": "extremism",
				"salience": 0.0028211456,
				"type": "OTHER"
			},
			{
				"name": "affirmation",
				"salience": 0.0028211456,
				"type": "OTHER"
			},
			{
				"name": "silence",
				"salience": 0.0028211456,
				"type": "OTHER"
			},
			{
				"name": "rebuttal",
				"salience": 0.0028211456,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0028211456,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0028211456,
				"type": "OTHER"
			},
			{
				"name": "Wahhabist Saudi Arabia",
				"salience": 0.0027437909,
				"type": "ORGANIZATION"
			},
			{
				"name": "principles",
				"salience": 0.0027385743,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0026597905,
				"type": "OTHER"
			},
			{
				"name": "developers",
				"salience": 0.0025976407,
				"type": "PERSON"
			},
			{
				"name": "oppression",
				"salience": 0.0025300705,
				"type": "OTHER"
			},
			{
				"name": "app",
				"salience": 0.0022844935,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "entrepreneurship",
				"salience": 0.0022844935,
				"type": "OTHER"
			},
			{
				"name": "tyranny",
				"salience": 0.0022844935,
				"type": "PERSON"
			},
			{
				"name": "principles",
				"salience": 0.0022358787,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ld_0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Resistance_movement"
				},
				"name": "Resistance",
				"salience": 0.0022212146,
				"type": "OTHER"
			},
			{
				"name": "Justice",
				"salience": 0.002199248,
				"type": "OTHER"
			},
			{
				"name": "refusal",
				"salience": 0.0021077269,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.0020784254,
				"type": "OTHER"
			},
			{
				"name": "empires",
				"salience": 0.001978272,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.001978272,
				"type": "OTHER"
			},
			{
				"name": "coding",
				"salience": 0.001978272,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.001978272,
				"type": "OTHER"
			},
			{
				"name": "shackles",
				"salience": 0.001978272,
				"type": "OTHER"
			},
			{
				"name": "ashes",
				"salience": 0.001978272,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.001978272,
				"type": "PERSON"
			},
			{
				"name": "Establishment",
				"salience": 0.001978272,
				"type": "ORGANIZATION"
			},
			{
				"name": "sound barrier",
				"salience": 0.001978272,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.001978272,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0019315366,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0019044449,
				"type": "EVENT"
			},
			{
				"name": "religion",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "Threat",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "theo-fascism",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "community-building",
				"salience": 0.0019044449,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "yearning",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "labels",
				"salience": 0.0019044449,
				"type": "OTHER"
			},
			{
				"name": "fortitude",
				"salience": 0.0018650917,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0018650917,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0018296693,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0017284753,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0016323598,
				"type": "LOCATION"
			},
			{
				"name": "Messenger 40.",
				"salience": 0.0016300506,
				"type": "PERSON"
			},
			{
				"name": "symbol",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "essence",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "mourning",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "darkness",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "suffocating",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "grandson",
				"salience": 0.0016150546,
				"type": "PERSON"
			},
			{
				"name": "piety",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.0016150546,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0014845146,
				"type": "EVENT"
			},
			{
				"name": "none",
				"salience": 0.0014047947,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01yd99"
				},
				"name": "Freedom",
				"salience": 0.0014019634,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tolerance",
				"salience": 0.0013933171,
				"type": "OTHER"
			},
			{
				"name": "construct",
				"salience": 0.0013696161,
				"type": "OTHER"
			},
			{
				"name": "Biggest Human Gathering",
				"salience": 0.001347718,
				"type": "EVENT"
			},
			{
				"name": "communication",
				"salience": 0.0012597848,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0012064985,
				"type": "PERSON"
			},
			{
				"name": "board",
				"salience": 0.0012064985,
				"type": "ORGANIZATION"
			},
			{
				"name": "death sentence",
				"salience": 0.0012064985,
				"type": "OTHER"
			},
			{
				"name": "forefather",
				"salience": 0.0012064985,
				"type": "OTHER"
			},
			{
				"name": "product",
				"salience": 0.0011974766,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "martyrdom",
				"salience": 0.0011912951,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0011722469,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "DC",
				"salience": 0.0011722469,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04s9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_in_Islam"
				},
				"name": "Prophet Muhammad",
				"salience": 0.0011480172,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02hkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Despotism"
				},
				"name": "Tyranny",
				"salience": 0.0011480172,
				"type": "EVENT"
			},
			{
				"name": "idea",
				"salience": 0.001132373,
				"type": "OTHER"
			},
			{
				"name": "Imam Hussain ibn Ali",
				"salience": 0.0011293011,
				"type": "PERSON"
			},
			{
				"name": "unity",
				"salience": 0.0011239053,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.0011239053,
				"type": "OTHER"
			},
			{
				"name": "acceptance",
				"salience": 0.0010231243,
				"type": "OTHER"
			},
			{
				"name": "IT industry professionals",
				"salience": 0.001014764,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.001014764,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.001014764,
				"type": "EVENT"
			},
			{
				"name": "efforts",
				"salience": 0.001014764,
				"type": "OTHER"
			},
			{
				"name": "IT industry professionals",
				"salience": 0.001014764,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.001014764,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.001014764,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.001014764,
				"type": "OTHER"
			},
			{
				"name": "tolerance",
				"salience": 0.001014764,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.001014764,
				"type": "OTHER"
			},
			{
				"name": "launch",
				"salience": 0.000972517,
				"type": "EVENT"
			},
			{
				"name": "principles",
				"salience": 0.00096828514,
				"type": "OTHER"
			},
			{
				"name": "app",
				"salience": 0.00096457,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "exchange",
				"salience": 0.0008786858,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.00083955517,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.00083955517,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0008224571,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ggbbjv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Prophets_and_messengers_in_Islam"
				},
				"name": "Messenger",
				"salience": 0.00079232675,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hatred",
				"salience": 0.000758019,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.000758019,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gj940r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terror_(politics)"
				},
				"name": "Terror",
				"salience": 0.0007425643,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dyns",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Karbala"
				},
				"name": "Karbala",
				"salience": 0.0007425643,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0240s6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yazid_I"
				},
				"name": "Yazid Ibn Mu'awiyah",
				"salience": 0.0007425643,
				"type": "PERSON"
			},
			{
				"name": "thanks",
				"salience": 0.0006563615,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.0006563615,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0006563615,
				"type": "OTHER"
			},
			{
				"name": "ownership",
				"salience": 0.0006563615,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.0006563615,
				"type": "OTHER"
			},
			{
				"name": "self-interest",
				"salience": 0.0006563615,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0006563615,
				"type": "PERSON"
			},
			{
				"name": "restrictions",
				"salience": 0.0006563615,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0006563615,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/40_Messenger_37059.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-16T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.131",
		"text": "2 Shares\n1 0 0 1\nAs radicalism and hatred continue to empty their venom onto the world: sowing discord, enmity, and self-righteous arrogance, a group of Shia Muslim entrepreneurs from Iran, Saudi Arabia, Pakistan, Iraq and the US, imagined a technology which would speak unity amid furious sectarianism, and cohesion where there was distrust.\nKeen not only denounce but oppose the ideological abomination which is Wahhabism – this dogma the House of Saud rose atop the fanaticism of one heretic scholar: Muhammad Ibn Abdel-Wahhab (18th century) Muslims have chosen to anchor their rebuttal of extremism through the promotion of a new media platform Messenger 40.\nwill likely argue that another social media platform is hardly revolutionary … especially if we consider how many apps are already available, this one particular product defiantly taps into a religious movement and expression Wahhabist Saudi Arabia has worked to silence.\nWhat in the world am I talking about?\nI am referring to Resistance … more particularly social resistance through the affirmation of Islam’s most sacred and universal principle: Justice.\nMORE... Why Muslims Hold the Biggest Human Gathering under the Threat of ISIS in Iraq? The 10th Day’s new campaign – community-building and social solidarity Shia Muslims gather in DC for anti-terror rally Letting freedom ring: How Islam’s universal message continues to speak through Imam Husayn ibn Ali If Islam has often been portrayed as the religion of peace, I would personally argue that Islam promotes in fact, Justice – this innate yearning we all share beyond the many labels we have chosen for ourselves. At the heart of most\nIt is our refusal to bow to tyranny and accept oppression which prompted communities of man to rise against the Establishment, and from the ashes of empires dream themselves free.\nToday such principles have been packaged into an app … several lines of coding put together to defy Saudi Arabia’s radical construct, a tool to break free from the shackles of religious oppression.\nWho said technology could not be revolutionary?\nhere is where Messenger 40 really promises to break the social sound barrier – beyond a simple exercise in technological entrepreneurship and an imperious need to reject theo-fascism, Messenger 40 carries the very essence of Islam’s tradition in it name: Arbaeen.\nArbaeen means 40 in Arabic, a reference to the mourning of Imam Hussain ibn Ali, the grandson of the Prophet Muhammad, and Third Imam of Islam.\nA symbol of fortitude, courage, and exceptional piety, Imam Hussain’s name has long echoed of Islam’s most brilliant principles - that before Tyranny none should relent, that even in the most suffocating of darkness it is Truth which must be spoken, beyond self-interest, and beyond all fears.\nIt is those principles Messenger 40 ambition to promote by speaking Freedom in a region locked in oppression – all thanks to Saudi Arabia’s desire to project hatred onto a faith it has proclaimed ownership over.\nShould you have missed the momentous act of resistance this one app represents, I would like to remind you that Saudi Arabia still forbids women to drive … that and a few other wonderful vapid social restrictions. In a region where being a religious minority often equates to a death sentence, thinking Freedom is a revolutionary act – never mind speaking tolerance, and acceptance.\nWith less than a fortnight to go before Arbaeen, just as millions are making their way to Karbala to remember the martyrdom of their Imam, he, who was claimed by the forefather of Terror: Yazid Ibn Mu’awiyah, Messenger 40 is preparing its grand launch.\nHaidar Attouq, a member of the board of developers, who refers to himself as a Saudi citizen explained how Messenger 40 aims to reform the way Muslims think communication by fostering tolerance and peaceful exchange.\n“This interactive application is the product of IT industry professionals, and efforts by young people from different Muslim countries, regardless of their nationality, race and language, to promote unity.”\nIf the idea is simple enough, the message behind it is powerful indeed!\n“This interactive application is the product of IT industry professionals, and efforts by young people from different Muslim countries, regardless of their nationality, race, and language, to promote unity.”",
		"thread_title": "Messenger 40 – Muslims Develop Technology to Promote Religious Unity against Radicalism",
		"title": "Messenger 40 – Muslims Develop Technology to Promote Religious Unity against Radicalism",
		"type": "bs",
		"uuid": "b44f390a68987494a8d90a86e53281ffc24ceb7c"
	},
	"-KhIgOEfvJCP9my3dRmh": {
		"author": "Dave Hunt",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-17T08:44:27.591+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "xenophobe",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Xi_Jinping_2_ba318.jpg",
		"ord_in_thread": "6",
		"participants_count": "7",
		"published": "2016-11-16T20:56:00.000+02:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 0.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Sad little xenophobe",
		"thread_title": "China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b",
		"title": "",
		"type": "bs",
		"uuid": "852051f48b68ab110bcb9c71d7c0e34fe7e1fc25"
	},
	"-KhIgOZWQcGcmRxjjNCo": {
		"author": "Daniel Haiphong",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-17T19:24:46.475+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.66301703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.037686087,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.021842247,
				"type": "LOCATION"
			},
			{
				"name": "victory",
				"salience": 0.018926848,
				"type": "EVENT"
			},
			{
				"name": "class",
				"salience": 0.017935267,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.012144058,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.011853332,
				"type": "ORGANIZATION"
			},
			{
				"name": "class",
				"salience": 0.007907319,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0036905934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/056vty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservative_Political_Action_Conference"
				},
				"name": "Conservative Political Action Conference",
				"salience": 0.0034550214,
				"type": "EVENT"
			},
			{
				"name": "crime legislation",
				"salience": 0.00332865,
				"type": "WORK_OF_ART"
			},
			{
				"name": "working class",
				"salience": 0.0031570208,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.002941793,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.002785391,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0027345845,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0026110818,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0026110818,
				"type": "OTHER"
			},
			{
				"name": "contradictions",
				"salience": 0.0026110818,
				"type": "OTHER"
			},
			{
				"name": "bourgeois",
				"salience": 0.0025560332,
				"type": "PERSON"
			},
			{
				"name": "difference",
				"salience": 0.0025265599,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black American",
				"salience": 0.002501883,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ynx29_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_(corporate_title)"
				},
				"name": "Presidents",
				"salience": 0.0024889575,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8t6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Christie"
				},
				"name": "Chris Christie",
				"salience": 0.002478176,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.002474421,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.002430638,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0024124903,
				"type": "EVENT"
			},
			{
				"name": "shock",
				"salience": 0.0024000558,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0023505224,
				"type": "EVENT"
			},
			{
				"name": "Administration",
				"salience": 0.0023265206,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Greatest Achievement",
				"salience": 0.002316937,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02wzcsn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Harbor,_Maryland"
				},
				"name": "National Harbor",
				"salience": 0.0022737014,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maryland"
				},
				"name": "Maryland",
				"salience": 0.0022737014,
				"type": "LOCATION"
			},
			{
				"name": "decline",
				"salience": 0.002178545,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.002178545,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.002178545,
				"type": "OTHER"
			},
			{
				"name": "agreements",
				"salience": 0.002178545,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0021387057,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0020860482,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018fzs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Newt_Gingrich"
				},
				"name": "Newt Gingrich",
				"salience": 0.0020676185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.002030228,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0020101217,
				"type": "EVENT"
			},
			{
				"name": "boardrooms",
				"salience": 0.0018867616,
				"type": "OTHER"
			},
			{
				"name": "Credit",
				"salience": 0.0018867616,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0018867616,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0018867616,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0018867616,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0018867616,
				"type": "ORGANIZATION"
			},
			{
				"name": "aspects",
				"salience": 0.0018867616,
				"type": "OTHER"
			},
			{
				"name": "military institutions",
				"salience": 0.0018867616,
				"type": "ORGANIZATION"
			},
			{
				"name": "anything",
				"salience": 0.0018867616,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0017686747,
				"type": "ORGANIZATION"
			},
			{
				"name": "debt schemes",
				"salience": 0.0016725581,
				"type": "OTHER"
			},
			{
				"name": "profit accumulation",
				"salience": 0.0016725581,
				"type": "OTHER"
			},
			{
				"name": "capitalist system",
				"salience": 0.001478629,
				"type": "OTHER"
			},
			{
				"name": "Brian Cloughley",
				"salience": 0.0013601414,
				"type": "PERSON"
			},
			{
				"name": "End",
				"salience": 0.0013544786,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0013401265,
				"type": "OTHER"
			},
			{
				"name": "wages",
				"salience": 0.0011657343,
				"type": "OTHER"
			},
			{
				"name": "Gage Skidmore",
				"salience": 0.001161736,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04dtx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flickr"
				},
				"name": "flickr",
				"salience": 0.001161736,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0011475724,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011475724,
				"type": "PERSON"
			},
			{
				"name": "campaign rhetoric",
				"salience": 0.0011058676,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0010756672,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0010635329,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0010291586,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0010193068,
				"type": "ORGANIZATION"
			},
			{
				"name": "profits",
				"salience": 0.0010057347,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0009937598,
				"type": "EVENT"
			},
			{
				"name": "opposite",
				"salience": 0.0009937598,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.0009833109,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.00096820487,
				"type": "OTHER"
			},
			{
				"name": "Liberalism",
				"salience": 0.0009560085,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0008979182,
				"type": "PERSON"
			},
			{
				"name": "decline",
				"salience": 0.00089729123,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00089729123,
				"type": "OTHER"
			},
			{
				"name": "complicity",
				"salience": 0.00089729123,
				"type": "OTHER"
			},
			{
				"name": "compulsion",
				"salience": 0.00089729123,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00089729123,
				"type": "OTHER"
			},
			{
				"name": "arsenal",
				"salience": 0.0008878559,
				"type": "OTHER"
			},
			{
				"name": "terrain",
				"salience": 0.0008709195,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0008662316,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.00084994733,
				"type": "OTHER"
			},
			{
				"name": "classes",
				"salience": 0.0008402181,
				"type": "OTHER"
			},
			{
				"name": "manipulation",
				"salience": 0.0008174248,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.000800533,
				"type": "OTHER"
			},
			{
				"name": "mistake",
				"salience": 0.00079695793,
				"type": "OTHER"
			},
			{
				"name": "working class base",
				"salience": 0.0007853285,
				"type": "PERSON"
			},
			{
				"name": "labor",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "innovation",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "fascism",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "concentration",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.00077700324,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "buying power",
				"salience": 0.00077700324,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.000761478,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0007261011,
				"type": "EVENT"
			},
			{
				"name": "policy",
				"salience": 0.00069388904,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.00069180893,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.000670797,
				"type": "OTHER"
			},
			{
				"name": "establishments",
				"salience": 0.000670797,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00066188246,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.00066188246,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.00065354275,
				"type": "OTHER"
			},
			{
				"name": "recall",
				"salience": 0.0006506238,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0006330502,
				"type": "OTHER"
			},
			{
				"name": "recognition",
				"salience": 0.0006330502,
				"type": "OTHER"
			},
			{
				"name": "Discussions",
				"salience": 0.0006291485,
				"type": "EVENT"
			},
			{
				"name": "Age",
				"salience": 0.0006291485,
				"type": "OTHER"
			},
			{
				"name": "bases",
				"salience": 0.0006291485,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0006291485,
				"type": "OTHER"
			},
			{
				"name": "ruling class",
				"salience": 0.0006276842,
				"type": "OTHER"
			},
			{
				"name": "contradictions",
				"salience": 0.00061575556,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.00061575556,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0006056643,
				"type": "EVENT"
			},
			{
				"name": "expansion",
				"salience": 0.0006056643,
				"type": "EVENT"
			},
			{
				"name": "legitimacy",
				"salience": 0.0006056643,
				"type": "OTHER"
			},
			{
				"name": "prisoner population",
				"salience": 0.0006056643,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07hwkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_American"
				},
				"name": "White America",
				"salience": 0.0006036393,
				"type": "PERSON"
			},
			{
				"name": "paymasters",
				"salience": 0.0006029591,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.0005982757,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.00059699814,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.000580452,
				"type": "OTHER"
			},
			{
				"name": "nationalists",
				"salience": 0.0005688522,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0005688522,
				"type": "EVENT"
			},
			{
				"name": "nationalism",
				"salience": 0.0005688522,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0005688522,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.0005688522,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.00055878464,
				"type": "OTHER"
			},
			{
				"name": "makeup",
				"salience": 0.0005447908,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0005447908,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0005447908,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0005447908,
				"type": "OTHER"
			},
			{
				"name": "World",
				"salience": 0.0005447908,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.00053890696,
				"type": "ORGANIZATION"
			},
			{
				"name": "servant",
				"salience": 0.00052445405,
				"type": "PERSON"
			},
			{
				"name": "flaws",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.00052445405,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.00052445405,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.00052445405,
				"type": "EVENT"
			},
			{
				"name": "cabinet",
				"salience": 0.00052445405,
				"type": "EVENT"
			},
			{
				"name": "possibilities",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.00052445405,
				"type": "OTHER"
			},
			{
				"name": "counterparts",
				"salience": 0.00052445405,
				"type": "PERSON"
			},
			{
				"name": "shift",
				"salience": 0.00052445405,
				"type": "EVENT"
			},
			{
				"name": "austerity",
				"salience": 0.00051361386,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.00051361386,
				"type": "EVENT"
			},
			{
				"name": "record",
				"salience": 0.00051361386,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.00051361386,
				"type": "PERSON"
			},
			{
				"name": "Others",
				"salience": 0.00049223186,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0004907431,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Sanders",
				"salience": 0.0004905427,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.00047825713,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.0004470496,
				"type": "OTHER"
			},
			{
				"name": "era",
				"salience": 0.0004447417,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0004447417,
				"type": "OTHER"
			},
			{
				"name": "waters",
				"salience": 0.0004447417,
				"type": "OTHER"
			},
			{
				"name": "antagonism",
				"salience": 0.0004447417,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.0004447417,
				"type": "OTHER"
			},
			{
				"name": "likes",
				"salience": 0.0004447417,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.00042493665,
				"type": "OTHER"
			},
			{
				"name": "wealth gap",
				"salience": 0.00038682998,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.00038366884,
				"type": "OTHER"
			},
			{
				"name": "resurrection",
				"salience": 0.00038366884,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.00038366884,
				"type": "OTHER"
			},
			{
				"name": "working class conditions",
				"salience": 0.00038366884,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.00038366884,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00038366884,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.00037898755,
				"type": "LOCATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.00037751134,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00037751134,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00035740077,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06gn7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rudy_Giuliani"
				},
				"name": "Rudy Giuliani",
				"salience": 0.0003353024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0003353024,
				"type": "ORGANIZATION"
			},
			{
				"name": "force",
				"salience": 0.00033499298,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.00033499298,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.00033221667,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00033221667,
				"type": "PERSON"
			},
			{
				"name": "apparatus",
				"salience": 0.00033221667,
				"type": "OTHER"
			},
			{
				"name": "dividends",
				"salience": 0.00033221667,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00033221667,
				"type": "OTHER"
			},
			{
				"name": "Capitalism",
				"salience": 0.00033221667,
				"type": "OTHER"
			},
			{
				"name": "segment",
				"salience": 0.00033221667,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.0003227837,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00031095644,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.00030947043,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.00030947043,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.00030947043,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00030947043,
				"type": "EVENT"
			},
			{
				"name": "class war",
				"salience": 0.00030947043,
				"type": "EVENT"
			},
			{
				"name": "check",
				"salience": 0.00030016087,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.00029264227,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00028807978,
				"type": "PERSON"
			},
			{
				"name": "rhetoric",
				"salience": 0.00028473564,
				"type": "OTHER"
			},
			{
				"name": "Trump Administration",
				"salience": 0.0002830953,
				"type": "ORGANIZATION"
			},
			{
				"name": "supremacist",
				"salience": 0.0002829802,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0002819925,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00027941357,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00027941357,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034jx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Depression"
				},
				"name": "Great Depression",
				"salience": 0.00027371655,
				"type": "EVENT"
			},
			{
				"name": "program",
				"salience": 0.00027119747,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.00025023002,
				"type": "LOCATION"
			},
			{
				"name": "pressure",
				"salience": 0.00025023002,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00025023002,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.00025023002,
				"type": "OTHER"
			},
			{
				"name": "outlook",
				"salience": 0.00024193987,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00024193987,
				"type": "OTHER"
			},
			{
				"name": "climate",
				"salience": 0.00024193987,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.00024193987,
				"type": "OTHER"
			},
			{
				"name": "emotions",
				"salience": 0.00024193987,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00024193987,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.00024193987,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0002311642,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.00020871143,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.00020871143,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00020871143,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00020871143,
				"type": "PERSON"
			},
			{
				"name": "dollar agreement",
				"salience": 0.00020871143,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.00020871143,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00020871143,
				"type": "PERSON"
			},
			{
				"name": "Don Debar",
				"salience": 0.0002070657,
				"type": "PERSON"
			},
			{
				"name": "CPR News",
				"salience": 0.00020445572,
				"type": "ORGANIZATION"
			},
			{
				"name": "set",
				"salience": 0.00018071858,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.00018071858,
				"type": "OTHER"
			},
			{
				"name": "escalation",
				"salience": 0.00018071858,
				"type": "EVENT"
			},
			{
				"name": "attempts",
				"salience": 0.00018071858,
				"type": "OTHER"
			},
			{
				"name": "proposals",
				"salience": 0.00018071858,
				"type": "OTHER"
			},
			{
				"name": "deportation",
				"salience": 0.00018071858,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.00018071858,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015wqw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glass%E2%80%93Steagall_Legislation"
				},
				"name": "Glass-Steagall Act",
				"salience": 0.00014889253,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Donald_Trump_8_b220a.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-17T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "18 Shares\n17 0 0 1 (Donald Trump speaking at the 2013 Conservative Political Action Conference (CPAC) in National Harbor, Maryland. Credit: Gage Skidmore / flickr)\nTrump's victory was a shock to most, especially given the broad support Hillary Clinton received from the forces of Wall Street. Although Trump is a billionaire himself, his criticism of free trade agreements and US policy toward Russia angered a broad section of the ruling class. It is the ruling class in control of the banks, military institutions, and corporate boardrooms that usually determine elections in the United States. Trump's victory is a product of the ruling system's decline and crisis more than anything else. The question is, now what?\nWhat is urgently needed is a deep investigation of all aspects and contradictions of the Trump moment. First, Trump won because the capitalist system is in crisis. The laws of the system have inevitably led to such a level of concentration that profit accumulation has turned into its opposite. Technological innovation has permanently replaced a large section of labor in the US, creating the deindustrialized terrain Trump spoke so much about in his campaign. At the end of the day, the profits that Wall Street speculated into the ground ultimately came from the compulsion to increase buying power with large debt schemes that could never be paid back by a working class whose wages have been in decline for over three decades .\nSo when Hillary Clinton decided to campaign as some sort of united front against fascism, few listened. Many people in the US saw Clinton as an extension of the ruling establishment that had pummeled working class people into the ground. The Black Lives Matter movement exposed her complicity in the crime legislation that led to the vast expansion of the Black prisoner population during her husband's rule. Hillary Clinton then made the mistake of coalescing with the ruling establishments of both parties in hopes of isolating Trump when in fact she merely exposed her role as a loyal servant of power.\nSome have claimed that since Clinton won the popular vote, she was the rightful winner regardless of her flaws. Others have argued that the Republican Party right-wing elites rigged the election . However true, there will be no recall this time around. Why? The DNC and the Clinton campaign rigged the primaries in order to defeat Sanders. In a stunning shift of political legitimacy, the Democratic Party has eviscerated all difference between itself and its Republican Party counterparts.\nNumerous pieces have been written about the dangers of the cabinet Trump will select. Indeed, Trump’s possibilities do not deviate from the standard Republican Party makeup. His potential choices for top positions include \"tough on crime\" Rudy Giuliani, austerity magnate Chris Christie, and privatization enthusiast Newt Gingrich. However, for the first time in a long time, the President of the United States is accountable to something other than the ruling class. In the past, Republican Party and Democratic Party Presidents dutifully served its paymasters while using manipulation to ensure that their respective bases were effectively neutralized.\nMORE... Defeating White Liberalism in the Age of Trump Brian Cloughley: “The Greatest Achievement of Mr. Trump would be Engage in Positive Discussions with Russia and China” Arise President Trump (or Why it's not the End of the World as We Know it) This is not the case with Trump. Just a month ago, Trump was the least desired choice of the ruling class . It was Trump's petty bourgeois and working class base of white America that propelled him to victory. It is clear that the need to politically survive in hostile waters will compel Trump to choose a neo-con Administration. But a neo-con agenda is exactly what his supporters voted against. Even those who directly or indirectly ascribe to white American nationalism are sick of endless war and austerity. However, nothing less can be expected from the likes of Chris Christie and Newt Gingrich.\nThe contradictions of the Trump era will breed a social confrontation between classes not seen since the Great Depression. White liberals and white nationalists will battle for the soul of the two-party system. The neo-con establishment will have to confront Trump's foreign and economic policy campaign rhetoric, much of which is in direct antagonism with the GOP's record. And the Democratic Party will attempt to use the age of Trump as a time to regroup and steer the forces of resistance back into its camp.\nHow should the forces of resistance position themselves under this new set of conditions? First, the anti-war left needs to confront Trump's foreign policy head on and place pressure on him to make good on his promises to scale back NATO and its escalation toward Russia. The left needs to resist any and all attempts by Trump to make good on some of his less savory proposals, such as a the deportation of the million immigrants and the expansion of the US nuclear arsenal. Of course, Trump’s rhetoric must be placed in its proper context. It was the Obama Administration that signed a one trillion dollar agreement to \"modernize\" the US nuclear arsenal and deported nearly three million immigrants in eight years, a number unseen in US history. This means resistance to the Trump Administration's use of the apparatus that Obama and the Democrats built should be directed at the entire ruling class, not just one of the two parties that represent it.\nThe vast majority of people simply cannot afford the resurrection of the two-party system. As Don Debar of CPR News has made clear, the check of white supremacy simply doesn't pay the same dividends anymore. While the wealth gap between White America and Black American would take over two centuries to even out , it is also true that merely ten percent White America owns almost all wealth in the US . Capitalism's crisis has forced a large segment of the population to live under working class conditions. A unique opportunity exists to build and strengthen a radical left agenda in the US and a start a discussion of what it will take to implement it.\nWhat is meant by “opportunity” is that a narrow outlook on this moment will breed narrow results. It should be imperative that the left force Trump's hand on foreign policy. It should demand that Trump use his executive powers to force through a 21st century Glass-Steagall Act and create a federal jobs program to rebuild infrastructure in the US. The left should not hesitate to condemn and protest whatever white supremacist and repressive policies come out of his Administration, with full recognition that it was Democratic and Republican Party consensus that got us here. As emotions run high and fear captures a number of people completely disenchanted with the current political climate in the United States, the time has come to spend the time and effort necessary to prepare the people for the war that existed long before Trump: class war.",
		"thread_title": "Won, Now What?",
		"title": "Won, Now What?",
		"type": "bs",
		"uuid": "959bf1a2ee99a2fefc4b6d6798fe833b80756da6"
	},
	"-KhIgP3wpm3psZJyDrF4": {
		"author": "Harun Yahya",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-17T19:25:50.735+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Protests",
				"salience": 0.12621142,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.05586536,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.032244436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03w66h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Otpor!"
				},
				"name": "OTPOR",
				"salience": 0.025735188,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vxgqf4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gezi_Park_protests"
				},
				"name": "Gezi Park Protests",
				"salience": 0.021032678,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.01849561,
				"type": "EVENT"
			},
			{
				"name": "matters",
				"salience": 0.018464737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.016491998,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.015729602,
				"type": "PERSON"
			},
			{
				"name": "coup d'etat attempt",
				"salience": 0.012531102,
				"type": "EVENT"
			},
			{
				"name": "demands",
				"salience": 0.011154572,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.010015511,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.009292937,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.009030667,
				"type": "ORGANIZATION"
			},
			{
				"name": "protests",
				"salience": 0.008666756,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.008390267,
				"type": "OTHER"
			},
			{
				"name": "Demonstrations",
				"salience": 0.008390267,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.008390267,
				"type": "OTHER"
			},
			{
				"name": "Democracy",
				"salience": 0.008390267,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.008390219,
				"type": "OTHER"
			},
			{
				"name": "coups",
				"salience": 0.008253774,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.008006656,
				"type": "ORGANIZATION"
			},
			{
				"name": "Protests",
				"salience": 0.00763664,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.007544194,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.007207926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09949m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Istanbul"
				},
				"name": "İstanbul",
				"salience": 0.0067982846,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0067375884,
				"type": "LOCATION"
			},
			{
				"name": "ways",
				"salience": 0.0065091723,
				"type": "OTHER"
			},
			{
				"name": "riots",
				"salience": 0.0061713527,
				"type": "OTHER"
			},
			{
				"name": "construction project",
				"salience": 0.005993981,
				"type": "OTHER"
			},
			{
				"name": "riots",
				"salience": 0.005979998,
				"type": "EVENT"
			},
			{
				"name": "nature",
				"salience": 0.005979998,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.00596709,
				"type": "EVENT"
			},
			{
				"name": "agents",
				"salience": 0.0057135695,
				"type": "PERSON"
			},
			{
				"name": "rallies",
				"salience": 0.0055250865,
				"type": "EVENT"
			},
			{
				"name": "freedom",
				"salience": 0.0055250865,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.0055250865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02yqn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taksim_Square"
				},
				"name": "Taksim Square",
				"salience": 0.0052071726,
				"type": "LOCATION"
			},
			{
				"name": "Demonstrations",
				"salience": 0.0050237696,
				"type": "EVENT"
			},
			{
				"name": "cases",
				"salience": 0.004989209,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.004989209,
				"type": "OTHER"
			},
			{
				"name": "matters",
				"salience": 0.004989209,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.004989209,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.004989209,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.0048979544,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.004603429,
				"type": "OTHER"
			},
			{
				"name": "pickets",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "drawbacks",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "negligence",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "essence",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.0043208757,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.0043208757,
				"type": "LOCATION"
			},
			{
				"name": "flickr",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "Credit",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "limits",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "boycotts",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.0043208757,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0042856033,
				"type": "OTHER"
			},
			{
				"name": "awareness",
				"salience": 0.0042127646,
				"type": "OTHER"
			},
			{
				"name": "government officer",
				"salience": 0.0038302608,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.0037219762,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0037219762,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0037114094,
				"type": "OTHER"
			},
			{
				"name": "civil wars",
				"salience": 0.0036572805,
				"type": "EVENT"
			},
			{
				"name": "demonstration",
				"salience": 0.0036374002,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0035867465,
				"type": "LOCATION"
			},
			{
				"name": "Protests",
				"salience": 0.0035497441,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0035497441,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0035497441,
				"type": "EVENT"
			},
			{
				"name": "security forces",
				"salience": 0.0035305205,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.003417323,
				"type": "EVENT"
			},
			{
				"name": "Legitimacy",
				"salience": 0.0031219688,
				"type": "OTHER"
			},
			{
				"name": "media organizations",
				"salience": 0.0030945428,
				"type": "ORGANIZATION"
			},
			{
				"name": "opinion",
				"salience": 0.0028953745,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbia",
				"salience": 0.0028367608,
				"type": "LOCATION"
			},
			{
				"name": "administrations",
				"salience": 0.0027156705,
				"type": "ORGANIZATION"
			},
			{
				"name": "Alan Hilditch",
				"salience": 0.002660335,
				"type": "PERSON"
			},
			{
				"name": "demands",
				"salience": 0.002627898,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0026100776,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0026100776,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0026100776,
				"type": "ORGANIZATION"
			},
			{
				"name": "methods",
				"salience": 0.0025913448,
				"type": "OTHER"
			},
			{
				"name": "Fighters",
				"salience": 0.0025858132,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0025126818,
				"type": "ORGANIZATION"
			},
			{
				"name": "protests",
				"salience": 0.0024892567,
				"type": "EVENT"
			},
			{
				"name": "legitimacy",
				"salience": 0.002453776,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.002453776,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0023940166,
				"type": "OTHER"
			},
			{
				"name": "demonstrations",
				"salience": 0.0023190356,
				"type": "EVENT"
			},
			{
				"name": "resignation",
				"salience": 0.002275644,
				"type": "EVENT"
			},
			{
				"name": "Social media",
				"salience": 0.0022020834,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.002130899,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.002130899,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.002130899,
				"type": "ORGANIZATION"
			},
			{
				"name": "masses",
				"salience": 0.0021110864,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0020547211,
				"type": "EVENT"
			},
			{
				"name": "cycles",
				"salience": 0.0020547211,
				"type": "OTHER"
			},
			{
				"name": "qualities",
				"salience": 0.0020547211,
				"type": "OTHER"
			},
			{
				"name": "validity",
				"salience": 0.0020547211,
				"type": "OTHER"
			},
			{
				"name": "cycle",
				"salience": 0.0020547211,
				"type": "OTHER"
			},
			{
				"name": "societies",
				"salience": 0.0020547211,
				"type": "OTHER"
			},
			{
				"name": "qualities",
				"salience": 0.0020547211,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0020547211,
				"type": "OTHER"
			},
			{
				"name": "resistance organization",
				"salience": 0.0020499397,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.002040785,
				"type": "LOCATION"
			},
			{
				"name": "coups",
				"salience": 0.0020227,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015qh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bulgaria"
				},
				"name": "Bulgaria",
				"salience": 0.0020142964,
				"type": "LOCATION"
			},
			{
				"name": "demonstrations",
				"salience": 0.0019794763,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.0019794763,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0019646192,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0019463002,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0019463002,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0019463002,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0019240194,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizations",
				"salience": 0.0019240194,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04bcmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stratfor"
				},
				"name": "Stratfor",
				"salience": 0.0018997914,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup attempts",
				"salience": 0.0018899733,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0018736584,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0018718215,
				"type": "OTHER"
			},
			{
				"name": "technique",
				"salience": 0.0018718215,
				"type": "OTHER"
			},
			{
				"name": "band",
				"salience": 0.0018249514,
				"type": "OTHER"
			},
			{
				"name": "Soldiers",
				"salience": 0.0017792542,
				"type": "PERSON"
			},
			{
				"name": "extent",
				"salience": 0.0017792542,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0017792542,
				"type": "OTHER"
			},
			{
				"name": "prices",
				"salience": 0.0017792542,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.0017792542,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0017792542,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.0017792542,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0017756614,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempt",
				"salience": 0.0017738737,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.0017271537,
				"type": "OTHER"
			},
			{
				"name": "validity",
				"salience": 0.0016988497,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.0016660657,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0016626868,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vsgmw5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taksim_Gezi_Park"
				},
				"name": "Gezi Park",
				"salience": 0.0016484109,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0016365817,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0015918853,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0015918853,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0015787216,
				"type": "ORGANIZATION"
			},
			{
				"name": "internal affairs",
				"salience": 0.0015375882,
				"type": "OTHER"
			},
			{
				"name": "provocations",
				"salience": 0.00153604,
				"type": "EVENT"
			},
			{
				"name": "separatist",
				"salience": 0.00153604,
				"type": "PERSON"
			},
			{
				"name": "demands",
				"salience": 0.0015042928,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0015042928,
				"type": "OTHER"
			},
			{
				"name": "Video",
				"salience": 0.0014898434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "demonstrations",
				"salience": 0.001478747,
				"type": "EVENT"
			},
			{
				"name": "demonstrations",
				"salience": 0.001478747,
				"type": "EVENT"
			},
			{
				"name": "another",
				"salience": 0.0014406652,
				"type": "OTHER"
			},
			{
				"name": "wake",
				"salience": 0.0014406652,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0014406652,
				"type": "LOCATION"
			},
			{
				"name": "media organizations",
				"salience": 0.001437312,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.001437312,
				"type": "ORGANIZATION"
			},
			{
				"name": "Methods",
				"salience": 0.0014279898,
				"type": "OTHER"
			},
			{
				"name": "riots",
				"salience": 0.0014099957,
				"type": "EVENT"
			},
			{
				"name": "Feasibility of Demands Democratic",
				"salience": 0.0014007448,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0013878562,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0013868869,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.0013868869,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0013868869,
				"type": "ORGANIZATION"
			},
			{
				"name": "ways",
				"salience": 0.0013868869,
				"type": "OTHER"
			},
			{
				"name": "uprising",
				"salience": 0.0013868869,
				"type": "EVENT"
			},
			{
				"name": "wake",
				"salience": 0.0013868869,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0013868869,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0013320076,
				"type": "ORGANIZATION"
			},
			{
				"name": "provocateurs",
				"salience": 0.0013025883,
				"type": "PERSON"
			},
			{
				"name": "Provocations",
				"salience": 0.0013025883,
				"type": "EVENT"
			},
			{
				"name": "coups",
				"salience": 0.0012977415,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.0012712125,
				"type": "EVENT"
			},
			{
				"name": "step",
				"salience": 0.0012634099,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025k7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Coup_d'%C3%A9tat"
				},
				"name": "Coup",
				"salience": 0.0012608985,
				"type": "ORGANIZATION"
			},
			{
				"name": "opinion",
				"salience": 0.0012539622,
				"type": "OTHER"
			},
			{
				"name": "teams",
				"salience": 0.0012474888,
				"type": "ORGANIZATION"
			},
			{
				"name": "manipulations",
				"salience": 0.0012474888,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0012474888,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0012474888,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.0012474888,
				"type": "OTHER"
			},
			{
				"name": "killers",
				"salience": 0.0012474888,
				"type": "PERSON"
			},
			{
				"name": "clashes",
				"salience": 0.0012474888,
				"type": "EVENT"
			},
			{
				"name": "fall",
				"salience": 0.0012474888,
				"type": "OTHER"
			},
			{
				"name": "fellows",
				"salience": 0.0012474888,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.001244585,
				"type": "OTHER"
			},
			{
				"name": "coup d'état",
				"salience": 0.0012162457,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0012009188,
				"type": "LOCATION"
			},
			{
				"name": "motion",
				"salience": 0.0012009188,
				"type": "OTHER"
			},
			{
				"name": "Shooting",
				"salience": 0.0012009188,
				"type": "EVENT"
			},
			{
				"name": "bombers",
				"salience": 0.0012009188,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0012009188,
				"type": "LOCATION"
			},
			{
				"name": "preservation",
				"salience": 0.0012009188,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.0012009188,
				"type": "OTHER"
			},
			{
				"name": "terrorist gangs",
				"salience": 0.0012009188,
				"type": "OTHER"
			},
			{
				"name": "nature lovers",
				"salience": 0.0012009188,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0012009188,
				"type": "OTHER"
			},
			{
				"name": "instrument",
				"salience": 0.0011760953,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "members",
				"salience": 0.0011760953,
				"type": "PERSON"
			},
			{
				"name": "institutions",
				"salience": 0.0011760953,
				"type": "ORGANIZATION"
			},
			{
				"name": "disturbance",
				"salience": 0.0011760953,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0011760953,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0011760953,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0011760953,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0011593808,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Gezi Park",
				"salience": 0.0011532501,
				"type": "LOCATION"
			},
			{
				"name": "alliance",
				"salience": 0.0011415174,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempt",
				"salience": 0.0011237226,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0010769707,
				"type": "OTHER"
			},
			{
				"name": "media organs",
				"salience": 0.0010736814,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.0010644107,
				"type": "EVENT"
			},
			{
				"name": "shadow organizations",
				"salience": 0.0010467899,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist organizations",
				"salience": 0.0010467899,
				"type": "ORGANIZATION"
			},
			{
				"name": "non-yielding",
				"salience": 0.0010183831,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.0010183831,
				"type": "PERSON"
			},
			{
				"name": "subcontractors",
				"salience": 0.0010183831,
				"type": "PERSON"
			},
			{
				"name": "outcomes",
				"salience": 0.0010183831,
				"type": "OTHER"
			},
			{
				"name": "employment",
				"salience": 0.0010183831,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.0010183831,
				"type": "PERSON"
			},
			{
				"name": "relations",
				"salience": 0.0010183831,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0010183831,
				"type": "OTHER"
			},
			{
				"name": "circles",
				"salience": 0.0010183831,
				"type": "OTHER"
			},
			{
				"name": "authors",
				"salience": 0.0010183831,
				"type": "PERSON"
			},
			{
				"name": "academicians",
				"salience": 0.0010183831,
				"type": "PERSON"
			},
			{
				"name": "destruction",
				"salience": 0.0009803631,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.0009733356,
				"type": "PERSON"
			},
			{
				"name": "statements",
				"salience": 0.0009730313,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0009730313,
				"type": "OTHER"
			},
			{
				"name": "residence",
				"salience": 0.0009730313,
				"type": "LOCATION"
			},
			{
				"name": "intelligence",
				"salience": 0.0009730313,
				"type": "OTHER"
			},
			{
				"name": "offshoot CANVAS",
				"salience": 0.0009730313,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0009730313,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0009657543,
				"type": "LOCATION"
			},
			{
				"name": "rallies",
				"salience": 0.00093670393,
				"type": "EVENT"
			},
			{
				"name": "requests",
				"salience": 0.0009085272,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0009064122,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0009064122,
				"type": "LOCATION"
			},
			{
				"name": "executives",
				"salience": 0.0008785322,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0008785322,
				"type": "PERSON"
			},
			{
				"name": "regime changes",
				"salience": 0.0008785322,
				"type": "OTHER"
			},
			{
				"name": "executive",
				"salience": 0.0008785322,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.0008785322,
				"type": "EVENT"
			},
			{
				"name": "administration",
				"salience": 0.0008785322,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.00086443225,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.00086443225,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00086443225,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.00086443225,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00086443225,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.0008419536,
				"type": "PERSON"
			},
			{
				"name": "training",
				"salience": 0.0008313421,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0008313421,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.00080389477,
				"type": "EVENT"
			},
			{
				"name": "pattern",
				"salience": 0.0008003033,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.000781934,
				"type": "ORGANIZATION"
			},
			{
				"name": "architect",
				"salience": 0.00076071284,
				"type": "PERSON"
			},
			{
				"name": "Prime Minister",
				"salience": 0.00076071284,
				"type": "PERSON"
			},
			{
				"name": "turn",
				"salience": 0.00076071284,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.00076071284,
				"type": "OTHER"
			},
			{
				"name": "leverage",
				"salience": 0.00076071284,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.00076071284,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.00076071284,
				"type": "OTHER"
			},
			{
				"name": "co-founders",
				"salience": 0.00076071284,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.00076071284,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00076071284,
				"type": "LOCATION"
			},
			{
				"name": "Turkey Dispute",
				"salience": 0.0007391125,
				"type": "EVENT"
			},
			{
				"name": "Their Heads 2",
				"salience": 0.0007391125,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j40h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan_Workers'_Party"
				},
				"name": "PKK",
				"salience": 0.0007391125,
				"type": "ORGANIZATION"
			},
			{
				"name": "2013 Gezi Park",
				"salience": 0.00073051336,
				"type": "LOCATION"
			},
			{
				"name": "rights",
				"salience": 0.00070862693,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00070862693,
				"type": "LOCATION"
			},
			{
				"name": "freedom",
				"salience": 0.00070862693,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00070862693,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.00070862693,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.00070862693,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00067706656,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00067706656,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0r5x_9b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sr%C4%91a_Popovi%C4%87_(activist)"
				},
				"name": "Srdja Popovic",
				"salience": 0.00067680515,
				"type": "PERSON"
			},
			{
				"name": "riots",
				"salience": 0.00064226566,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00063980103,
				"type": "EVENT"
			},
			{
				"name": "expression",
				"salience": 0.00063980103,
				"type": "OTHER"
			},
			{
				"name": "projects",
				"salience": 0.00063980103,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00063980103,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00063980103,
				"type": "PERSON"
			},
			{
				"name": "misapprehension",
				"salience": 0.0006209874,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0006159121,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0005902659,
				"type": "EVENT"
			},
			{
				"name": "nature",
				"salience": 0.0005729752,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.000561064,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.00055399205,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.00055399205,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.00055399205,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.00055399205,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00055399205,
				"type": "OTHER"
			},
			{
				"name": "rebellion",
				"salience": 0.00055399205,
				"type": "EVENT"
			},
			{
				"name": "claims",
				"salience": 0.00055399205,
				"type": "OTHER"
			},
			{
				"name": "representatives",
				"salience": 0.00055399205,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.00055399205,
				"type": "OTHER"
			},
			{
				"name": "CANVAS",
				"salience": 0.00052931753,
				"type": "OTHER"
			},
			{
				"name": "offshoot CANVAS",
				"salience": 0.00052931753,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00052931753,
				"type": "OTHER"
			},
			{
				"name": "disturbances",
				"salience": 0.0004779045,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0004779045,
				"type": "OTHER"
			},
			{
				"name": "Strategies",
				"salience": 0.0004779045,
				"type": "OTHER"
			},
			{
				"name": "uprisings",
				"salience": 0.0004779045,
				"type": "EVENT"
			},
			{
				"name": "streets",
				"salience": 0.0004779045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0004681597,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "Goldman Sachs",
				"salience": 0.0004681597,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern Europe",
				"salience": 0.0004681597,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0004681597,
				"type": "ORGANIZATION"
			},
			{
				"name": "portion",
				"salience": 0.00042443862,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.00041380592,
				"type": "OTHER"
			},
			{
				"name": "Center",
				"salience": 0.00041380592,
				"type": "LOCATION"
			},
			{
				"name": "CIA-coup college",
				"salience": 0.00041380592,
				"type": "ORGANIZATION"
			},
			{
				"name": "sorts",
				"salience": 0.00041380592,
				"type": "OTHER"
			},
			{
				"name": "research article",
				"salience": 0.00041380592,
				"type": "WORK_OF_ART"
			},
			{
				"name": "connections",
				"salience": 0.00041380592,
				"type": "OTHER"
			},
			{
				"name": "financial",
				"salience": 0.00041380592,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00041380592,
				"type": "OTHER"
			},
			{
				"name": "fist-logo",
				"salience": 0.00041380592,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.00041380592,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07pncwk"
				},
				"name": "Marxist",
				"salience": 0.0003409304,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptian",
				"salience": 0.00033537048,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01w2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cairo"
				},
				"name": "Cairo",
				"salience": 0.0002546545,
				"type": "LOCATION"
			},
			{
				"name": "Occupy.com",
				"salience": 0.0002546545,
				"type": "OTHER"
			},
			{
				"name": "Steve Horn",
				"salience": 0.0002546545,
				"type": "PERSON"
			},
			{
				"name": "Carl Gibson",
				"salience": 0.0002546545,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/087vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yugoslavia"
				},
				"name": "Yugoslavia",
				"salience": 0.0002546545,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015fr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brazil"
				},
				"name": "Brazil",
				"salience": 0.0002546545,
				"type": "LOCATION"
			},
			{
				"name": "Applied Non-Violent Action",
				"salience": 0.0002546545,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0002546545,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0002546545,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0kn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(country)"
				},
				"name": "Georgia",
				"salience": 0.0002546545,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Taksim_Square_7fa31.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-17T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 18.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "14 Shares\n12 0 0 2 (Taksim Square - Gezi Park Protests, İstanbul. Credit: Alan Hilditch / flickr)\nDemocracy grants people the right to protest, to show their opinion on matters that affect their lives and their nation’s. Protesting is a universally acknowledged fact belonging to the modern world. It serves to give voice to those who are disturbed by the faulty policies, drawbacks and negligence of their governments and who wish to raise public awareness on these matters. Demonstrations, rallies, strikes, pickets, boycotts and so on are all ways of protesting. As long as they are within the limits defined by the “law,” protests and acts of similar nature are in essence an indisputable part of democracy, freedom of opinion and expression.\nHowever, in some cases protesting is exploited and used as a means of opposing democracy itself. Protests that give way to riots are now methods of staging coups to shut down administrations and overthrow democratically elected governments.\nLegitimacy of Protests and Feasibility of Demands\nDemocratic protests are welcomed by societies and addressed by governments to the extent that their demands are tangible, justified and feasible . Protests lacking those qualities are most likely to fail in having their demands met.\nThe anti-government movement in Bulgaria in 2013-14 confirmed the validity of these qualities. The protests took place in three separate cycles. January and February witnessed rallies that objected to the high prices of electricity and demanded the government resign. They were successful as the requests were sensible. A later demonstration was against a government officer, and resulted in his resignation. Yet another cycle of protests called for a change of the system, along with some other illegal demands and faced defeat after turning into riots that were not supported by the overall society.\nMORE... Gruesome Video Shows Turkish Soldiers Execute Female Kurdish PKK Fighters by Shooting in Their Heads 2 bombers, stopped by police, blew themselves up in Turkey Dispute over Kurds and Coup attempt threatens U.S.-Turkey alliance The attempted coup d’état made Turkey band together The Gezi Park protests in Turkey in the same year followed the same pattern. Set in motion with a good willed and environmentalist approach, it was likely to succeed considering its solid and feasible calls and legitimate ways at first. The government heeded the nature lovers’ voices and took a positive step by postponing a construction project that required the destruction of Gezi Park. Yet the humanist approach of young people changed course in the wake of provocations of separatist and terrorist gangs and turned into a totally different nature. Demonstrations that began in Gezi Park in Istanbul and that demanded the preservation of Gezi Park as a recreational area spread to other cities of the country and transformed into armed and bloody uprising imposing the fall of government. It was a quite clear coup d’etat attempt that did not refrain from using violent methods and openly rejected the validity of a democratically elected government. The protests were contradictory considering people took to streets using their democratic rights, but then appealed to non-democratic methods to lay their claims ignoring the will of the nation.\nThough justified at the beginning, these two cases of protests demonstrate that they are open to hostile manipulations and may lose their legitimacy if left at the hands of ill-minded people. Recently some dark powers have been using this latest technique to manage countries’ internal affairs as they see fit and stage coups to overthrow governments. They bring in professional teams of brutal killers amidst peaceful protests, which then lead to violent anti-democratic clashes. These protests sometimes end up in civil wars where fellows of the same nation kill one another. It all happens in the wake of a government’s non-yielding to some dark power’s demands and a democratically elected government faces anti-democratic attempts.\nMethods of Provocations and OTPOR\nSuch dramatic outcomes come by the employment of social media. Social media becomes an instrument for organizing, stirring and agitating the masses that are presumed to join the demonstrations. Various provocative organizations undertake the organization of some agents and provocateurs who take part in demonstrations by inciting them to get violent. These illegal “subcontractors” organize the public relations part of the riots and channel intellectual circles of the country such as its authors, academicians, journalists and members of non-governmental institutions to act against democratically elected government in the name of democracy and to lead the public.\nOne of the most common groups among these “ professional revolutionary organizations ” is a Serbia-based resistance organization,OTPOR . Independent observers state that OTPOR organizes coup attempts and civil disturbance by providing training and logistic support for the US-backed dissident organizations in many countries such as the former Yugoslavia, Serbia, Georgia, Bulgaria, Ukraine, Egypt, Brazil, and Turkey. There is a consensus that the CIA has been creating riots and social disturbances in fifty countries OTPOR its offshoot CANVAS…\nA relevant source puts forward the following interesting findings OTPOR :\nThe (OTPOR 's ) fist-logo, would turn up 11 years later in the streets of Cairo , illustrating further the preposterous, foreign-backed nature of the Egyptian uprisings... Serbia’s OTPOR would continue receiving funds from the West and become a “CIA-coup college” of sorts under the name of CANVAS (Center for Applied Non-Violent Action and Strategies ).\nThe research article penned by Carl Gibson and Steve Horn and published on “Occupy.com” deals with the international financial, intelligence and political connections of OTPOR and features the following information based on WikiLeaks documents:\nSerbia’s Srdja Popovic is known by many as a leading architect of regime changes in Eastern Europe and elsewhere since the late-1990s , and as one of the co-founders of OTPOR… Popovic and OTPOR's offshoot CANVAS have also maintained close ties with a Goldman Sachs executive and the private intelligence firm Stratfor as well as the U.S. government …\nSuch examples are easy to find. The internal public opinion on OTPOR is that it is being employed as leverage to overthrow those governments which conflict with the interests of the U.S. No wonder some media organizations that act on behalf of the US administration speak highly of OTPOR at every turn. Moreover, the British media rigorously advocates that the executives of OTPOR have nothing to do with the organization of coups.\nLikewise, some Turkish media organizations disseminated similar statements during the 2013 Gezi Park demonstrations. The attempt to occupy the Prime Minister’s residence by armed groups, which is an act of rebellion against the state and treason by law, was orchestrated by OTPOR, according to reports. Yet the media deliberately defined it as “the exercise of legitimate, democratic rights, and freedom of expression by the people,” and thus desired to create misapprehension to display the members of the Marxist and separatist terrorist organizations who are far from representing even a slightest portion of the nation as the representatives of the nation. These media organs called the nation’s security forces who risked their lives to preserve public order and people’s lives as ‘the so-called enemies of freedom and democracy.’\nIn truth, such mass demonstrations that aim to topple governments, divide countries and organize bloody conflicts - and even civil wars - can no longer be called innocent rallies, but subtle projects of deep states and shadow organizations to take over countries from within.",
		"thread_title": "Crossing the Line in Democracy",
		"title": "Crossing the Line in Democracy",
		"type": "bs",
		"uuid": "01d6b7c634e6c69dd0d39c0ceacfa376b4a4e627"
	},
	"-KhIgPQ9uJJ0-iwYCiRs": {
		"author": "Paul Craig Roberts",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-18T18:09:56.289+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "army",
				"salience": 0.19664064,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.1778981,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.07656928,
				"type": "LOCATION"
			},
			{
				"name": "government forces",
				"salience": 0.03242345,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.031026911,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.025360305,
				"type": "LOCATION"
			},
			{
				"name": "parts",
				"salience": 0.018309968,
				"type": "LOCATION"
			},
			{
				"name": "Jeish al-Fatah",
				"salience": 0.016446298,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.01627567,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/072_vh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Province,_Sri_Lanka"
				},
				"name": "Eastern",
				"salience": 0.015673216,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.011356414,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.010843009,
				"type": "LOCATION"
			},
			{
				"name": "military operations",
				"salience": 0.0098420605,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0098420605,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.009287826,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.007445267,
				"type": "PERSON"
			},
			{
				"name": "concentration point",
				"salience": 0.0064218743,
				"type": "OTHER"
			},
			{
				"name": "Southwestern Aleppo",
				"salience": 0.006141305,
				"type": "LOCATION"
			},
			{
				"name": "province",
				"salience": 0.00602859,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0058166697,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0058166697,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.00580828,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.0052224426,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0051574516,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.0051381323,
				"type": "PERSON"
			},
			{
				"name": "military operations",
				"salience": 0.0050387746,
				"type": "OTHER"
			},
			{
				"name": "air force",
				"salience": 0.0050387746,
				"type": "ORGANIZATION"
			},
			{
				"name": "al-Rashedeen",
				"salience": 0.0047491863,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.004723672,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.004723672,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03m7d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hezbollah"
				},
				"name": "Hezbollah",
				"salience": 0.0042004315,
				"type": "ORGANIZATION"
			},
			{
				"name": "military positions",
				"salience": 0.0041629416,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0041629416,
				"type": "OTHER"
			},
			{
				"name": "army officer",
				"salience": 0.004006816,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018hq1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southwestern_United_States"
				},
				"name": "Southwestern",
				"salience": 0.003952375,
				"type": "ORGANIZATION"
			},
			{
				"name": "towns",
				"salience": 0.003936402,
				"type": "LOCATION"
			},
			{
				"name": "towns",
				"salience": 0.0036949916,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0036187836,
				"type": "PERSON"
			},
			{
				"name": "al-Rashedeen",
				"salience": 0.003468519,
				"type": "LOCATION"
			},
			{
				"name": "combat operations",
				"salience": 0.0034470416,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.003286836,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0031643214,
				"type": "LOCATION"
			},
			{
				"name": "Government forces",
				"salience": 0.0030174293,
				"type": "OTHER"
			},
			{
				"name": "collapse",
				"salience": 0.0026700562,
				"type": "EVENT"
			},
			{
				"name": "Shares",
				"salience": 0.0026700562,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0026700562,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0026700562,
				"type": "ORGANIZATION"
			},
			{
				"name": "artillery shells",
				"salience": 0.0026700562,
				"type": "OTHER"
			},
			{
				"name": "phase",
				"salience": 0.0026700562,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0026330454,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0025495156,
				"type": "PERSON"
			},
			{
				"name": "Rashedeen 4",
				"salience": 0.0024277577,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "terrorists",
				"salience": 0.002398174,
				"type": "PERSON"
			},
			{
				"name": "Terrorists",
				"salience": 0.002398174,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.0023347938,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.0023086467,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0023000396,
				"type": "ORGANIZATION"
			},
			{
				"name": "operations",
				"salience": 0.0020768798,
				"type": "OTHER"
			},
			{
				"name": "Army sources",
				"salience": 0.0020415764,
				"type": "PERSON"
			},
			{
				"name": "missiles",
				"salience": 0.001888272,
				"type": "OTHER"
			},
			{
				"name": "ministry",
				"salience": 0.0017553354,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.0017314852,
				"type": "OTHER"
			},
			{
				"name": "Positions",
				"salience": 0.0017153467,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0017153467,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0016818701,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0016818701,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0016818701,
				"type": "PERSON"
			},
			{
				"name": "Housing Project 1070",
				"salience": 0.0016440735,
				"type": "OTHER"
			},
			{
				"name": "al-Hikma",
				"salience": 0.0016440735,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0016191211,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0016191211,
				"type": "PERSON"
			},
			{
				"name": "Northwestern Aleppo",
				"salience": 0.0016107772,
				"type": "LOCATION"
			},
			{
				"name": "strikes",
				"salience": 0.0015752101,
				"type": "EVENT"
			},
			{
				"name": "army",
				"salience": 0.001552836,
				"type": "ORGANIZATION"
			},
			{
				"name": "army",
				"salience": 0.001552836,
				"type": "ORGANIZATION"
			},
			{
				"name": "army",
				"salience": 0.001552836,
				"type": "ORGANIZATION"
			},
			{
				"name": "towns",
				"salience": 0.0015222743,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.0015222743,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.0015222743,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0014984272,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0014984272,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0014983829,
				"type": "OTHER"
			},
			{
				"name": "calm",
				"salience": 0.0014906515,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0014545209,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0014425163,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0014425163,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.001402112,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.001402112,
				"type": "OTHER"
			},
			{
				"name": "special forces",
				"salience": 0.001402112,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0013786998,
				"type": "LOCATION"
			},
			{
				"name": "sources",
				"salience": 0.0013782689,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0013731427,
				"type": "PERSON"
			},
			{
				"name": "coordination",
				"salience": 0.0013640815,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03hv9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sergey_Shoygu"
				},
				"name": "Sergei Shoigu",
				"salience": 0.0013625931,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0013552493,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.001326838,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0013142497,
				"type": "LOCATION"
			},
			{
				"name": "news media",
				"salience": 0.0012698459,
				"type": "ORGANIZATION"
			},
			{
				"name": "artillery units",
				"salience": 0.0012698459,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0012428208,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0012233482,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0012233482,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0012233482,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0012233482,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.0012224577,
				"type": "PERSON"
			},
			{
				"name": "ground operations",
				"salience": 0.0011890782,
				"type": "OTHER"
			},
			{
				"name": "Navy Fleet Starts Strikes",
				"salience": 0.0011545232,
				"type": "EVENT"
			},
			{
				"name": "terrorist groups",
				"salience": 0.0011387945,
				"type": "ORGANIZATION"
			},
			{
				"name": "parts",
				"salience": 0.0011145567,
				"type": "LOCATION"
			},
			{
				"name": "Option",
				"salience": 0.0010996187,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.0010996187,
				"type": "LOCATION"
			},
			{
				"name": "offensive",
				"salience": 0.0010996187,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0010996187,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.0010996187,
				"type": "LOCATION"
			},
			{
				"name": "Military Aid",
				"salience": 0.0010996187,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0010996187,
				"type": "EVENT"
			},
			{
				"name": "sources",
				"salience": 0.0010970598,
				"type": "PERSON"
			},
			{
				"name": "flash point city",
				"salience": 0.0010914302,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.001091398,
				"type": "EVENT"
			},
			{
				"name": "districts",
				"salience": 0.0010674222,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0010674222,
				"type": "PERSON"
			},
			{
				"name": "districts",
				"salience": 0.0010674222,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0010674222,
				"type": "PERSON"
			},
			{
				"name": "districts",
				"salience": 0.0010275835,
				"type": "LOCATION"
			},
			{
				"name": "air",
				"salience": 0.0010275835,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.0009861249,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0009861249,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0009819978,
				"type": "OTHER"
			},
			{
				"name": "ultimatum",
				"salience": 0.00096076075,
				"type": "OTHER"
			},
			{
				"name": "food stuff warehouses",
				"salience": 0.0009325193,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.00091391243,
				"type": "PERSON"
			},
			{
				"name": "rule",
				"salience": 0.0009091683,
				"type": "OTHER"
			},
			{
				"name": "defense line",
				"salience": 0.0008977128,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.0008903784,
				"type": "OTHER"
			},
			{
				"name": "demonstrators",
				"salience": 0.0008903784,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0008903784,
				"type": "LOCATION"
			},
			{
				"name": "food stuff",
				"salience": 0.0008903784,
				"type": "OTHER"
			},
			{
				"name": "demonstrations",
				"salience": 0.0008903784,
				"type": "EVENT"
			},
			{
				"name": "task force",
				"salience": 0.0008883061,
				"type": "ORGANIZATION"
			},
			{
				"name": "operation",
				"salience": 0.0008883061,
				"type": "OTHER"
			},
			{
				"name": "combat operations",
				"salience": 0.0008883061,
				"type": "OTHER"
			},
			{
				"name": "military operations",
				"salience": 0.0008883061,
				"type": "OTHER"
			},
			{
				"name": "Ma'aret al-Artiq",
				"salience": 0.00086570793,
				"type": "PERSON"
			},
			{
				"name": "Zahiya al-Assad",
				"salience": 0.00086570793,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.0008571439,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.0008571439,
				"type": "PERSON"
			},
			{
				"name": "flanks",
				"salience": 0.0008571439,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0008533155,
				"type": "OTHER"
			},
			{
				"name": "Aleppo Jaish Al-Fatah Leader Admits Receiving Financial",
				"salience": 0.00081864506,
				"type": "ORGANIZATION"
			},
			{
				"name": "sons",
				"salience": 0.00081111287,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0008050479,
				"type": "PERSON"
			},
			{
				"name": "air assaults",
				"salience": 0.0008050479,
				"type": "OTHER"
			},
			{
				"name": "enemy targets",
				"salience": 0.0008050479,
				"type": "OTHER"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0007744558,
				"type": "LOCATION"
			},
			{
				"name": "clashes",
				"salience": 0.0007709965,
				"type": "EVENT"
			},
			{
				"name": "measures",
				"salience": 0.0007709965,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0007709965,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018hmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_United_States"
				},
				"name": "Southern",
				"salience": 0.0007654706,
				"type": "LOCATION"
			},
			{
				"name": "end",
				"salience": 0.0007422161,
				"type": "OTHER"
			},
			{
				"name": "advances",
				"salience": 0.0007422161,
				"type": "OTHER"
			},
			{
				"name": "news channel",
				"salience": 0.00072687515,
				"type": "ORGANIZATION"
			},
			{
				"name": "pauses",
				"salience": 0.00072687515,
				"type": "OTHER"
			},
			{
				"name": "Thousands",
				"salience": 0.00072687515,
				"type": "PERSON"
			},
			{
				"name": "corridors",
				"salience": 0.00072687515,
				"type": "LOCATION"
			},
			{
				"name": "passages",
				"salience": 0.0007236283,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.00069450855,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kvhj3l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anadan"
				},
				"name": "Andan",
				"salience": 0.0006768385,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0006768385,
				"type": "LOCATION"
			},
			{
				"name": "Maintaining Assad",
				"salience": 0.0006768385,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0w1f40c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kafr_Hamrah"
				},
				"name": "Kafr Hamra",
				"salience": 0.0006768385,
				"type": "LOCATION"
			},
			{
				"name": "Jamiat al-Zahra",
				"salience": 0.0006768385,
				"type": "PERSON"
			},
			{
				"name": "Admiral",
				"salience": 0.0006509703,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0006469633,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0006469633,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0006469633,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0006469633,
				"type": "OTHER"
			},
			{
				"name": "command center",
				"salience": 0.0006413942,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.00063595676,
				"type": "PERSON"
			},
			{
				"name": "corridor",
				"salience": 0.0006322317,
				"type": "LOCATION"
			},
			{
				"name": "paths",
				"salience": 0.0006294075,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.0006294075,
				"type": "OTHER"
			},
			{
				"name": "warplanes",
				"salience": 0.0006294075,
				"type": "OTHER"
			},
			{
				"name": "lull",
				"salience": 0.0006294075,
				"type": "EVENT"
			},
			{
				"name": "language",
				"salience": 0.0006294075,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00062426436,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.0006090548,
				"type": "EVENT"
			},
			{
				"name": "terrorist targets",
				"salience": 0.00060137943,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.00060137943,
				"type": "OTHER"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.0005907352,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.0005893601,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00058430526,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.0005628973,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.00055812293,
				"type": "PERSON"
			},
			{
				"name": "territories",
				"salience": 0.00055812293,
				"type": "LOCATION"
			},
			{
				"name": "leadership",
				"salience": 0.00054297707,
				"type": "OTHER"
			},
			{
				"name": "cruiser",
				"salience": 0.00054297707,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.00054297707,
				"type": "OTHER"
			},
			{
				"name": "provinces",
				"salience": 0.00054297707,
				"type": "LOCATION"
			},
			{
				"name": "cruiser",
				"salience": 0.00054297707,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.00053525995,
				"type": "ORGANIZATION"
			},
			{
				"name": "army",
				"salience": 0.00053525995,
				"type": "ORGANIZATION"
			},
			{
				"name": "army",
				"salience": 0.00053525995,
				"type": "ORGANIZATION"
			},
			{
				"name": "positions",
				"salience": 0.000534263,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0005297631,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07806",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_aircraft_carrier_Admiral_Kuznetsov"
				},
				"name": "Admiral Kuznetsov",
				"salience": 0.0005290675,
				"type": "PERSON"
			},
			{
				"name": "terrorist groups",
				"salience": 0.00050580234,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0004972113,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0004972113,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0004972113,
				"type": "PERSON"
			},
			{
				"name": "Eastern Aleppo",
				"salience": 0.00049349223,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.00048327688,
				"type": "ORGANIZATION"
			},
			{
				"name": "army operations",
				"salience": 0.00048327688,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0004826337,
				"type": "OTHER"
			},
			{
				"name": "al-Kelaseh",
				"salience": 0.00047452853,
				"type": "PERSON"
			},
			{
				"name": "Bostan al-Qasr",
				"salience": 0.00047452853,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.0004740906,
				"type": "OTHER"
			},
			{
				"name": "districts",
				"salience": 0.0004740906,
				"type": "LOCATION"
			},
			{
				"name": "fronts",
				"salience": 0.0004740906,
				"type": "OTHER"
			},
			{
				"name": "defense enterprises",
				"salience": 0.00047016158,
				"type": "ORGANIZATION"
			},
			{
				"name": "friends",
				"salience": 0.00047016158,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.00047016158,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.00047016158,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.00047016158,
				"type": "EVENT"
			},
			{
				"name": "frigate",
				"salience": 0.00047016158,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00047016158,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanese",
				"salience": 0.00045681192,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.0004410098,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07l57d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib"
				},
				"name": "Idlib",
				"salience": 0.00044007384,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.00040064438,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.00040064438,
				"type": "OTHER"
			},
			{
				"name": "street battle",
				"salience": 0.00039543395,
				"type": "EVENT"
			},
			{
				"name": "systems",
				"salience": 0.00039543395,
				"type": "OTHER"
			},
			{
				"name": "deadline",
				"salience": 0.00039543395,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.00039543395,
				"type": "EVENT"
			},
			{
				"name": "flanks",
				"salience": 0.00039543395,
				"type": "OTHER"
			},
			{
				"name": "air support",
				"salience": 0.00039543395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k0t9hr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Mayadeen"
				},
				"name": "al-Mayadeen",
				"salience": 0.00038737143,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.00038737143,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.00037782255,
				"type": "ORGANIZATION"
			},
			{
				"name": "suppression",
				"salience": 0.00037587175,
				"type": "EVENT"
			},
			{
				"name": "front",
				"salience": 0.0003541329,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0003530206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0003447765,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00034240054,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.00034240054,
				"type": "WORK_OF_ART"
			},
			{
				"name": "weapons",
				"salience": 0.00034240054,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.00034240054,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021wj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Navy"
				},
				"name": "Russian Navy",
				"salience": 0.0003341708,
				"type": "ORGANIZATION"
			},
			{
				"name": "blitzkrieg",
				"salience": 0.00032961596,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0003271506,
				"type": "ORGANIZATION"
			},
			{
				"name": "Command",
				"salience": 0.00031074852,
				"type": "ORGANIZATION"
			},
			{
				"name": "exit",
				"salience": 0.00030161065,
				"type": "LOCATION"
			},
			{
				"name": "pause",
				"salience": 0.00029537498,
				"type": "OTHER"
			},
			{
				"name": "deadline",
				"salience": 0.00029537498,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.0002893522,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k9qf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Homs"
				},
				"name": "Homs",
				"salience": 0.0002893522,
				"type": "LOCATION"
			},
			{
				"name": "Grigorovich",
				"salience": 0.0002715703,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jeish al-Fatah",
				"salience": 0.00025753368,
				"type": "ORGANIZATION"
			},
			{
				"name": "hope",
				"salience": 0.00025575885,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.00025575885,
				"type": "ORGANIZATION"
			},
			{
				"name": "siege",
				"salience": 0.00025575885,
				"type": "EVENT"
			},
			{
				"name": "human shield",
				"salience": 0.00025575885,
				"type": "OTHER"
			},
			{
				"name": "Bastion Coastal Defense Missile Systems",
				"salience": 0.00024335827,
				"type": "ORGANIZATION"
			},
			{
				"name": "ultimatum",
				"salience": 0.00022344773,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027cbfh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pantsir-S1"
				},
				"name": "Pantsir",
				"salience": 0.00021071782,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Defense experts",
				"salience": 0.00020971539,
				"type": "PERSON"
			},
			{
				"name": "units",
				"salience": 0.00016690306,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Aleppo_Syrian_Army_1c7c7.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-18T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.013",
		"text": "The Syrian army and Hezbollah resistance forces continued their military operations in Aleppo province, and managed to push back a large number of terrorists from al-Rashedeen region which is the most important concentration point of the terrorists in Southwestern Aleppo. 5 Shares\n4 0 0 1\nThe pro-government troops could bring the terrorists in al-Rashedeen region to verge of collapse after taking full control of Housing Project 1070 and al-Hikma school in the Southwestern part of Aleppo.\nThe Syrian government forces who have been trying to take back the towns of Rashedeen 4 and 5 started the new phase of their military operations on Thursday by hitting hard the terrorists' military positions in al-Rashedeen 4 and 5 towns with artillery shells.\nThe Syrian air force, for its part, pounded the terrorists' positions in al-Rashedeen 4 and 5 towns.\nSome news media also reported the start of the Syrian army's new operations in Zahiya al-Assad and Jamiat al-Zahra to the West of Aleppo.\nAlso in Northwestern Aleppo, the missile and artillery units of the Syrian army hit the terrorists' positions in the towns of Andan, Kafr Hamra and Ma'aret al-Artiq as well as their surrounding areas.\nMORE... Russian Navy Fleet Starts Strikes at Terrorists' Positions in Syria's Aleppo Jaish Al-Fatah Leader Admits Receiving Financial, Military Aid from Saudi Arabia Why do we only hear of the “humanitarian crisis in Aleppo” and not everywhere else in Syria? Is Maintaining Assad the Least Worst Option? Army sources disclosed on Wednesday that pro-government troops are making final coordination for a massive offensive on Jeish al-Fatah terrorists in the Eastern parts of Aleppo city.\n\"As the army's 24-hour ultimatum to the terrorists to leave the city came to an end and as relative calm has prevailed over the Western and Southwestern parts of Aleppo, the army, the Lebanese Hezbollah fighters and special forces are getting ready to start attacking militants' defense line from several Eastern and Southern flanks,\" an army officer said.\nMeantime, he appreciated the Russian help, saying, \"The Russian air and naval back up will speed up the Syrian army's advances in the operation.\"\n\"Government forces are about to start their operation against the terrorists in Aleppo any moment,\" he added.\nLocal sources disclosed earlier on Wednesday that civilians in the Eastern districts of Aleppo city took to the streets to oppose Jeish al-Fatah's rule in the city, calling on the militants to leave Aleppo immediately.\n\"Unprecedented clashes between people and terrorists have pushed the Eastern neighborhoods of Aleppo city into a new wave of tensions,\" sources said, adding, \"People have taken part in demonstrations across the districts of Bostan al-Qasr and al-Kelaseh, calling on the terrorists to leave the city now.\"\n\"People have also attacked terrorists' food stuff warehouses, fighting with the militants for looting their food stuff from their neighborhoods,\" the sources added.\nThe sources went on to say that terrorists have arrested a number of demonstrators, hitting them badly.\nCivilians in militant-held districts of Aleppo are tired of terrorist groups' measures, including suppression of people and banning food and medicine for the families who prevent their young sons from joining the terrorist groups.\nMeantime, Tens of fighter jets launched airstrikes on terrorists' positions in Aleppo on Tuesday to herald the long-awaited ground operations to capture the Eastern parts of the city.\nTens of warplanes started massive air assaults on enemy targets in the Eastern parts of Aleppo on Tuesday after three weeks of lull and as Russia's Admiral Kuznetsov aircraft carrier launched combat operations in Syria, the Arabic-language al-Mayadeen news channel reported.\nThe airstrikes started after several humanitarian pauses declared by the Syrian army and Russia to give a chance to the civilian population as well as the militants to leave the Eastern parts of the city through 8 corridors. Thousands of civilians left the city in the first few days, but militants blocked their exist paths, threatening to kill anyone who dares to approach the passages opened by the army. The terrorists aim to use the civilian population as a human shield.\nThe last such pause was declared on Monday when the army gave a 24-hour lone ultimatum to the Jeish al-Fatah coalition of terrorist groups to leave the flash point city. The deadline was not met by the militants, though.\nDefense experts believe that the blitzkrieg is the first part of the long-awaited army operations in Eastern Aleppo to take back the entire city. Aleppo is halved into the government-ruled West and militant-held East. The militants rejected a guaranteed exit to relocate to Idlib or other militant-ruled territories in the hope that over 30,000 fresh forces would penetrate the city through the Southwestern front to lift the army's several-month-long siege on Eastern Aleppo.\nJeish al-Fatah lost thousands of militants in over two weeks of bloody war in Southern and Southwestern Aleppo, but failed to open a corridor for entrapped friends in the East.\nThe massive airstrikes in Aleppo come as Russia's Admiral Kuznetsov aircraft-carrying cruiser began combat operations in Syria.\nRussian Defense Minister Sergei Shoigu announced earlier that Russian frigate Admiral Grigorovich launched missiles on terrorist targets in Syria.\n\"Today, we started a major operation to launch massive strikes on ISIL and al-Nusra Front (also known as Fatah al-Sham Front) targets in the Idlib and Homs provinces in Syria,\" Shoigu said at a meeting with the ministry’s leadership and defense enterprises.\n\"For the first time in history of Russian Navy, Admiral Kuznetsov aircraft-carrying cruiser has begun military operations,\" Shoigu said.\nRussian naval task force in Syria is reliably protected by Bastion Coastal Defense Missile Systems and Pantsir systems, the minister said.\nAlso, General Command of the Syrian Army announced earlier that the country's soldiers and popular forced are about to hit Jeish al-Fatah's positions in the Eastern districts of Aleppo from nine different flanks.\n\"Our forces, including very well trained units, are deployed in nine different fronts and are waiting for the specified deadline,\" the command center said in a statement.\nOther informed sources disclosed that the Syrian army has prepared a large number of forces, who are expert in street battle and are equipped with lethal weapons, ready to start final the battle with the terrorist groups.\nThe sources also added that these forces will be backed up by the missile and air support of the Syrian and Russian force",
		"thread_title": "Terrorists' Strategic Bastion Facing Collapse in Southwestern of Syria's Aleppo, Civilians Attack Terrorists' Food Stuff Warehouses",
		"title": "Terrorists' Strategic Bastion Facing Collapse in Southwestern of Syria's Aleppo, Civilians Attack Terrorists' Food Stuff Warehouses",
		"type": "bs",
		"uuid": "ae8b6e7109376a53013165a3ccda9e9ab9bf9a22"
	},
	"-KhIgPbcwI2pU3CZHh6b": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-18T18:36:17.690+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "district",
				"salience": 0.17696145,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.13204172,
				"type": "ORGANIZATION"
			},
			{
				"name": "militants",
				"salience": 0.08845174,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.06951022,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.04326508,
				"type": "PERSON"
			},
			{
				"name": "Sawfi",
				"salience": 0.032395028,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01c9bx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kirkuk"
				},
				"name": "Kirkuk",
				"salience": 0.029181222,
				"type": "LOCATION"
			},
			{
				"name": "extremist group",
				"salience": 0.027909696,
				"type": "ORGANIZATION"
			},
			{
				"name": "Leader",
				"salience": 0.027909696,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09f8j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hawija"
				},
				"name": "Hawija",
				"salience": 0.026982985,
				"type": "LOCATION"
			},
			{
				"name": "Hassan al-Sawfi",
				"salience": 0.025400762,
				"type": "PERSON"
			},
			{
				"name": "photo report",
				"salience": 0.02386413,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Shares",
				"salience": 0.021987556,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.021594511,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/013027rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Popular_Mobilization_Forces_(Iraq)"
				},
				"name": "al-Hashd al-Shaabi",
				"salience": 0.017253641,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.01494965,
				"type": "LOCATION"
			},
			{
				"name": "Wilayat Kirkuk",
				"salience": 0.011685518,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.01112812,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.009221567,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.009221567,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026pgxk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caliphate"
				},
				"name": "Caliphate",
				"salience": 0.008230491,
				"type": "OTHER"
			},
			{
				"name": "district",
				"salience": 0.008186302,
				"type": "LOCATION"
			},
			{
				"name": "press statement",
				"salience": 0.0068317433,
				"type": "WORK_OF_ART"
			},
			{
				"name": "caliphate",
				"salience": 0.0068317433,
				"type": "OTHER"
			},
			{
				"name": "abduction",
				"salience": 0.006715806,
				"type": "EVENT"
			},
			{
				"name": "Mosul Fahmi Abbas",
				"salience": 0.006317692,
				"type": "PERSON"
			},
			{
				"name": "security source",
				"salience": 0.0053132223,
				"type": "OTHER"
			},
			{
				"name": "southwest",
				"salience": 0.005110089,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0047932984,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.0046146433,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0046146433,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03slm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraqi_Army"
				},
				"name": "Iraqi Army",
				"salience": 0.0043553347,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.0042043636,
				"type": "OTHER"
			},
			{
				"name": "battles",
				"salience": 0.0041514537,
				"type": "EVENT"
			},
			{
				"name": "human shields",
				"salience": 0.0041514537,
				"type": "OTHER"
			},
			{
				"name": "AHT",
				"salience": 0.0041151703,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.0040515885,
				"type": "PERSON"
			},
			{
				"name": "ability",
				"salience": 0.0039966805,
				"type": "OTHER"
			},
			{
				"name": "district",
				"salience": 0.0039793123,
				"type": "LOCATION"
			},
			{
				"name": "Soldier",
				"salience": 0.003970825,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0037942228,
				"type": "PERSON"
			},
			{
				"name": "military operation",
				"salience": 0.0033898777,
				"type": "OTHER"
			},
			{
				"name": "terrorist channels",
				"salience": 0.0033898777,
				"type": "OTHER"
			},
			{
				"name": "Viewer discretion",
				"salience": 0.0033898777,
				"type": "OTHER"
			},
			{
				"name": "spies",
				"salience": 0.0033898777,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.0032390773,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0032390773,
				"type": "PERSON"
			},
			{
				"name": "dogs",
				"salience": 0.0029248074,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0026257432,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04ggc0f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamrin_Mountains"
				},
				"name": "Hamrin Mountains",
				"salience": 0.0024610288,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01ch7h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saladin_Governorate"
				},
				"name": "Salahuddin",
				"salience": 0.0024610288,
				"type": "PERSON"
			},
			{
				"name": "You ISIS Executes Scores",
				"salience": 0.0024101916,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.0023595998,
				"type": "PERSON"
			},
			{
				"name": "terror",
				"salience": 0.0023595998,
				"type": "OTHER"
			},
			{
				"name": "Advance",
				"salience": 0.0020419273,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018923826,
				"type": "EVENT"
			},
			{
				"name": "satellite television Quote",
				"salience": 0.0018450071,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0018450071,
				"type": "PERSON"
			},
			{
				"name": "Family",
				"salience": 0.0018450071,
				"type": "PERSON"
			},
			{
				"name": "mass",
				"salience": 0.0017761567,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.0017628793,
				"type": "PERSON"
			},
			{
				"name": "Suicide Dogs",
				"salience": 0.0015917395,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0015917395,
				"type": "LOCATION"
			},
			{
				"name": "scores",
				"salience": 0.0015917395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03g2w_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_Republic_News_Agency"
				},
				"name": "IRNA",
				"salience": 0.0015592994,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mosul Civilians Stormed City Main Prison",
				"salience": 0.0015592994,
				"type": "ORGANIZATION"
			},
			{
				"name": "Iraqi Armored Units",
				"salience": 0.0015592994,
				"type": "LOCATION"
			},
			{
				"name": "Prisoners Iraq",
				"salience": 0.0014525761,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0013783457,
				"type": "PERSON"
			},
			{
				"name": "Bodies",
				"salience": 0.0013783457,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cgmt0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Sumaria"
				},
				"name": "al-Sumaria",
				"salience": 0.0011356956,
				"type": "ORGANIZATION"
			},
			{
				"name": "Battling ISIS",
				"salience": 0.0011356956,
				"type": "EVENT"
			},
			{
				"name": "Mosul Reunited",
				"salience": 0.0011356956,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08f7c4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_alienation"
				},
				"name": "Estrangement",
				"salience": 0.0011356956,
				"type": "OTHER"
			},
			{
				"name": "stockpilin",
				"salience": 0.0010524908,
				"type": "OTHER"
			},
			{
				"name": "Electrical Poles",
				"salience": 0.00084837683,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/isis_kirkuk_tree_759c3.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-18T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "7 Shares\n1 5 0 1\nLeader at al-Hashd al-Shaabi in Hawija district, Hassan al-Sawfi, announced on Thursday, that the Islamic State extremist group abducted 75 civilians, southwest of Kirkuk for leaving the land of Caliphate.\nSawfi said in a press statement, “This evening, ISIS militants abducted 75 civilians from Hawija district, while fleeing the district,” adding that, “The civilians were abducted for leaving the land of caliphate and helping other civilians to flee the ISIS-held areas toward Kirkuk and Salahuddin.”\n“The abduction took place in the area between Hamrin Mountains and southwest of Kirkuk,” Sawfi explained. “ISIS militants are collapsing and lost their ability to fight,” Sawfi added.\nSawfi also called on officials to accelerate the battles to liberate the district of Hawija to rescue the civilians who are used as human shields.\nMeanwhile, a new photo report purportedly released by the ISIS shows Iraqi Army \"spies\" mass beheaded in \"Wilayat Kirkuk,\" southeast of the current Mosul military operation. The photo report was released on ISIS terrorist channels on November 17. Viewer discretion is advised.\nRecommended For You ISIS Executes Scores and Hangs Their Bodies from Electrical Poles around Mosul: U.N. ISIS terrorists have executed scores more people around the northern Iraqi city of Mosul this week and are reported to be stockpilin...\nBy AHT Staff ISIS Uses 600 Suicide Dogs to Restrain Iraqi Army’s Advance in Mosul Fahmi Abbas, an officer in Iraqi Armored Units had an interview with IRNA and said: “ISIS terrorists have equipped 600 dogs wi...\nBy AHT Staff Mosul Civilians Stormed City Main Prison and Free 45 ISIS Prisoners Iraq's al-Sumaria satellite television Quote: d an unnamed security source that claimed Mosul residents on Friday evening killed ISIS terror...\nBy AHT Staff Iraqi Soldier Battling ISIS in Mosul Reunited with His Family After Two Years of Estrangement",
		"thread_title": "ISIS Abducts 75 Civilians Southwest of Kirkuk, Ties ‘Iraqi Army Spies’ to Trees and Beheads Them",
		"title": "ISIS Abducts 75 Civilians Southwest of Kirkuk, Ties ‘Iraqi Army Spies’ to Trees and Beheads Them",
		"type": "bs",
		"uuid": "c8d625e18522bb30a03e09a697b3568f09082f61"
	},
	"-KhIgPjZuzUJIDJS5YtO": {
		"author": "Karl Simanonok",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-19T07:51:44.701+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07pvqfx"
				},
				"name": "Founders",
				"salience": 0.3054672,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0lq3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electoral_College_(United_States)"
				},
				"name": "Electoral College",
				"salience": 0.2508729,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.08385713,
				"type": "OTHER"
			},
			{
				"name": "safeguard",
				"salience": 0.08385713,
				"type": "OTHER"
			},
			{
				"name": "mob rule",
				"salience": 0.035514258,
				"type": "OTHER"
			},
			{
				"name": "factions",
				"salience": 0.035514258,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.024126936,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.024126936,
				"type": "ORGANIZATION"
			},
			{
				"name": "criterion",
				"salience": 0.023972753,
				"type": "OTHER"
			},
			{
				"name": "Fascism",
				"salience": 0.022618197,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.022027897,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.016771909,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.014750784,
				"type": "PERSON"
			},
			{
				"name": "danger",
				"salience": 0.01287835,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.010526797,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07qmcqq"
				},
				"name": "Fascist",
				"salience": 0.008831558,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06cx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic"
				},
				"name": "Republic",
				"salience": 0.007947603,
				"type": "LOCATION"
			},
			{
				"name": "MINORITY",
				"salience": 0.0057415473,
				"type": "ORGANIZATION"
			},
			{
				"name": "vote",
				"salience": 0.0057415473,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.004854344,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Protest_against_Donald_Trump_2_22585.jpg",
		"ord_in_thread": "3",
		"participants_count": "4",
		"published": "2016-11-19T04:28:00.000+02:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "The Electoral College was put in place by the Founders as a safeguard against mob rule or what they called 'factions' unrepresentative of ALL Americans coming to power and taking over the government. Obviously someone as unfit and Fascist as Donald Trump meets that criterion of danger to the Republic and it only remains to see if the Electoral College will now behave with the integrity that the Founders hoped they would have.\nAnd it is NO MORE UNFAIR for the Electoral College to say NO to American Fascism than it would be for Trump to 'win' with a MINORITY of the popular vote.",
		"thread_title": "The Unethicality of the Sore Loser",
		"title": "",
		"type": "bs",
		"uuid": "f86a99af7b77ae1c34a6504514415c0f4e56ce4c"
	},
	"-KhIgPvImuw4F05e23LC": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-11-19T12:49:54.257+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03hv9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sergey_Shoygu"
				},
				"name": "Sergei Shoigu",
				"salience": 0.23655348,
				"type": "PERSON"
			},
			{
				"name": "strikes",
				"salience": 0.16865556,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.09315875,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.07957279,
				"type": "LOCATION"
			},
			{
				"name": "Admiral",
				"salience": 0.037744552,
				"type": "PERSON"
			},
			{
				"name": "missiles",
				"salience": 0.037514407,
				"type": "OTHER"
			},
			{
				"name": "Grigorovich",
				"salience": 0.03156579,
				"type": "ORGANIZATION"
			},
			{
				"name": "combat operations",
				"salience": 0.026956808,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.025887255,
				"type": "OTHER"
			},
			{
				"name": "cruiser",
				"salience": 0.025547652,
				"type": "PERSON"
			},
			{
				"name": "ministry",
				"salience": 0.024151692,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0129g54z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sputnik_(news_agency)"
				},
				"name": "Sputnik",
				"salience": 0.023272494,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07806",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_aircraft_carrier_Admiral_Kuznetsov"
				},
				"name": "Admiral Kuznetsov",
				"salience": 0.017466474,
				"type": "PERSON"
			},
			{
				"name": "Admiral",
				"salience": 0.014565074,
				"type": "PERSON"
			},
			{
				"name": "frigate",
				"salience": 0.012346009,
				"type": "OTHER"
			},
			{
				"name": "terrorist targets",
				"salience": 0.012346009,
				"type": "OTHER"
			},
			{
				"name": "provinces",
				"salience": 0.011720241,
				"type": "LOCATION"
			},
			{
				"name": "time",
				"salience": 0.011720241,
				"type": "OTHER"
			},
			{
				"name": "cruise missiles",
				"salience": 0.006752309,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0057529546,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.0046268543,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k9qf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Homs"
				},
				"name": "Homs",
				"salience": 0.004178772,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07l57d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib"
				},
				"name": "Idlib",
				"salience": 0.004178772,
				"type": "LOCATION"
			},
			{
				"name": "military operations",
				"salience": 0.004038046,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.003922676,
				"type": "ORGANIZATION"
			},
			{
				"name": "cruiser",
				"salience": 0.0036810834,
				"type": "PERSON"
			},
			{
				"name": "frigate",
				"salience": 0.0035843365,
				"type": "OTHER"
			},
			{
				"name": "terrorist targets",
				"salience": 0.0034285164,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.0033118555,
				"type": "OTHER"
			},
			{
				"name": "task force",
				"salience": 0.0033118555,
				"type": "ORGANIZATION"
			},
			{
				"name": "operation",
				"salience": 0.0032980212,
				"type": "OTHER"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0029081053,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0028793837,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.0028793837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.0028727124,
				"type": "PERSON"
			},
			{
				"name": "cruise missile strikes",
				"salience": 0.0027046462,
				"type": "EVENT"
			},
			{
				"name": "terrorists",
				"salience": 0.0025904141,
				"type": "PERSON"
			},
			{
				"name": "frigate",
				"salience": 0.0025467065,
				"type": "OTHER"
			},
			{
				"name": "defense enterprises",
				"salience": 0.0024938534,
				"type": "ORGANIZATION"
			},
			{
				"name": "leadership",
				"salience": 0.0024938534,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.002488824,
				"type": "EVENT"
			},
			{
				"name": "military operation",
				"salience": 0.0024648854,
				"type": "EVENT"
			},
			{
				"name": "operation",
				"salience": 0.0024648854,
				"type": "OTHER"
			},
			{
				"name": "cruiser",
				"salience": 0.0023337668,
				"type": "PERSON"
			},
			{
				"name": "Bastion Coastal Defense Missile Systems",
				"salience": 0.0020399308,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0019444505,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0019444505,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0018250984,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027cbfh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pantsir-S1"
				},
				"name": "Pantsir",
				"salience": 0.001595231,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/021wj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Navy"
				},
				"name": "Russian Navy",
				"salience": 0.0015357244,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kalibr",
				"salience": 0.0014795009,
				"type": "OTHER"
			},
			{
				"name": "frigate",
				"salience": 0.0013863783,
				"type": "OTHER"
			},
			{
				"name": "Russian Naval Forces",
				"salience": 0.0012444825,
				"type": "ORGANIZATION"
			},
			{
				"name": "advance",
				"salience": 0.0011513429,
				"type": "OTHER"
			},
			{
				"name": "intelligence data",
				"salience": 0.0011513429,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0011513429,
				"type": "PERSON"
			},
			{
				"name": "missile systems",
				"salience": 0.0011000959,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06dz8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Armed_Forces"
				},
				"name": "Russian Armed Forces",
				"salience": 0.0009064669,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01q2rb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bastion"
				},
				"name": "Bastion",
				"salience": 0.0006114185,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Sergei_Shoigu_690a3.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-19T12:49:54.257+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "On Tuesday, Russian Admiral Kuznetsov aircraft-carrying cruiser began combat operations in Syria, Russian Defense Minister Sergei Shoigu said. \nShoigu said Russian frigate Admiral Grigorovich launched missiles on terrorist targets in Syria, Sputnik reported. \n\"Today, we started a major operation to launch massive strikes on ISIL and al-Nusra Front (also known as Fatah al-Sham Front) targets in the Idlib and Homs provinces in Syria,\" Shoigu said at a meeting with the ministry’s leadership and defense enterprises. \n\"For the first time in history of Russian Navy, Admiral Kuznetsov aircraft-carrying cruiser has begun military operations,\" Shoigu said. \nRussian naval task force in Syria is reliably protected by Bastion Coastal Defense Missile Systems and Pantsir systems, the minister said. \nRussian Admiral Grigorovich frigate targeted terrorists in Syria with Kalibr cruise missile strikes, Russian Defense Minister Sergei Shoigu said on Tuesday. \n\"Today, we started a large-scale operation on launching massive strikes on ISIL and al-Nusra Front targets in the Idlib and Homs provinces in Syria,\" Shoigu said, Sputnik reported. \nAccording to him, Admiral Grigorovich frigate, Bastion coastal missile systems and \"for the first time in history of the Russian Naval Forces\" Admiral Kuznetsov aircraft-carrying cruiser take part in the military operation. \n\"Admiral Grigorovich frigate takes part in the operation. Today, it launched Kalibr cruise missiles on terrorist targets that had been confirmed by intelligence data and determined in advance,\" the minister said at a meeting of Russian President Vladimir Putin with top officials of the Russian Armed Forces.",
		"thread_title": "Sergei Shoigu: Admiral Kuznetsov Aircraft-carrying Cruiser Has Begun Military Operations for the First Time in History of Russian Navy; Kills Over 50 Nusra Terrorists Including Commanders in Aleppo",
		"title": "Sergei Shoigu: Admiral Kuznetsov Aircraft-carrying Cruiser Has Begun Military Operations for the First Time in History of Russian Navy; Kills Over 50 Nusra Terrorists Including Commanders in Aleppo",
		"type": "bs",
		"uuid": "3d53659ace5282ae11c54ee9b9e4ec663e35f8cb"
	},
	"-KhIgQIF95a8KPKu8DLu": {
		"author": "Catherine Shakdam",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-19T17:53:04.724+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01dyns",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Karbala"
				},
				"name": "Karbala",
				"salience": 0.40672794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/046g7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arba'een"
				},
				"name": "Arbaeen",
				"salience": 0.24199146,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0240rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Husayn_ibn_Ali"
				},
				"name": "Hussain ibn Ali",
				"salience": 0.10930888,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04s9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_in_Islam"
				},
				"name": "Prophet Muhammad",
				"salience": 0.057872068,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shia Muslims",
				"salience": 0.03795934,
				"type": "OTHER"
			},
			{
				"name": "Imam Hussain ibn Ali",
				"salience": 0.0149163,
				"type": "PERSON"
			},
			{
				"name": "few",
				"salience": 0.006785042,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.0050886814,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.004671425,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0042477786,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.004041663,
				"type": "PERSON"
			},
			{
				"name": "generations",
				"salience": 0.0038859297,
				"type": "PERSON"
			},
			{
				"name": "pilgrims",
				"salience": 0.0030421263,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0028806617,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0240s6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yazid_I"
				},
				"name": "Yazid ibn Muawiyah",
				"salience": 0.0028118782,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.0027369969,
				"type": "OTHER"
			},
			{
				"name": "pilgrims",
				"salience": 0.0022171137,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.0019523547,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0240lv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Saud"
				},
				"name": "House of Saud",
				"salience": 0.0017376639,
				"type": "ORGANIZATION"
			},
			{
				"name": "orphans",
				"salience": 0.0016924863,
				"type": "PERSON"
			},
			{
				"name": "determination",
				"salience": 0.0016540447,
				"type": "OTHER"
			},
			{
				"name": "pilgrimage",
				"salience": 0.0015561258,
				"type": "EVENT"
			},
			{
				"name": "men",
				"salience": 0.0014733722,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.0014714147,
				"type": "PERSON"
			},
			{
				"name": "bigots",
				"salience": 0.001388175,
				"type": "PERSON"
			},
			{
				"name": "prayers",
				"salience": 0.0012760774,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0012760774,
				"type": "OTHER"
			},
			{
				"name": "tragedy",
				"salience": 0.0011523081,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.0011523081,
				"type": "OTHER"
			},
			{
				"name": "dogma",
				"salience": 0.0011523081,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.0011523081,
				"type": "OTHER"
			},
			{
				"name": "Hajj",
				"salience": 0.0011523081,
				"type": "OTHER"
			},
			{
				"name": "rites",
				"salience": 0.000997947,
				"type": "OTHER"
			},
			{
				"name": "mourning",
				"salience": 0.000997947,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.000997947,
				"type": "OTHER"
			},
			{
				"name": "ascent",
				"salience": 0.000997947,
				"type": "OTHER"
			},
			{
				"name": "offense",
				"salience": 0.000997947,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.000997947,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.000997947,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00091613136,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0008968446,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0008400845,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0008023737,
				"type": "LOCATION"
			},
			{
				"name": "tyranny",
				"salience": 0.00069681427,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.00069082546,
				"type": "PERSON"
			},
			{
				"name": "Black Flag Army",
				"salience": 0.000614425,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gj940r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terror_(politics)"
				},
				"name": "Terror",
				"salience": 0.000614425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xy4k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Good_and_evil"
				},
				"name": "Good and Evil",
				"salience": 0.000614425,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0006069333,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00059947546,
				"type": "OTHER"
			},
			{
				"name": "tyrants",
				"salience": 0.0005835081,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.00056889997,
				"type": "OTHER"
			},
			{
				"name": "faiths",
				"salience": 0.00056889997,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.00056889997,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.00052557676,
				"type": "PERSON"
			},
			{
				"name": "radicalism",
				"salience": 0.00052557676,
				"type": "OTHER"
			},
			{
				"name": "tragedy",
				"salience": 0.00052520976,
				"type": "OTHER"
			},
			{
				"name": "task",
				"salience": 0.00050647237,
				"type": "OTHER"
			},
			{
				"name": "refuge",
				"salience": 0.00049294997,
				"type": "OTHER"
			},
			{
				"name": "Dogmatism",
				"salience": 0.00047455254,
				"type": "OTHER"
			},
			{
				"name": "Compassion",
				"salience": 0.00047455254,
				"type": "OTHER"
			},
			{
				"name": "Justice",
				"salience": 0.00047455254,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.00047455254,
				"type": "OTHER"
			},
			{
				"name": "differences",
				"salience": 0.00047455254,
				"type": "OTHER"
			},
			{
				"name": "Piety",
				"salience": 0.00047455254,
				"type": "OTHER"
			},
			{
				"name": "differences",
				"salience": 0.00047455254,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.000449071,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01yd99"
				},
				"name": "Freedom",
				"salience": 0.0004260031,
				"type": "WORK_OF_ART"
			},
			{
				"name": "city",
				"salience": 0.00042557257,
				"type": "LOCATION"
			},
			{
				"name": "prophet",
				"salience": 0.00042557257,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00041617462,
				"type": "EVENT"
			},
			{
				"name": "resistance",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "attachment",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00041093098,
				"type": "LOCATION"
			},
			{
				"name": "beacon",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "character",
				"salience": 0.00041093098,
				"type": "PERSON"
			},
			{
				"name": "fashion",
				"salience": 0.00041093098,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.00039889792,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0003874171,
				"type": "EVENT"
			},
			{
				"name": "tyranny",
				"salience": 0.00038400874,
				"type": "PERSON"
			},
			{
				"name": "martyrdom",
				"salience": 0.00038400874,
				"type": "EVENT"
			},
			{
				"name": "pilgrimage",
				"salience": 0.00036697186,
				"type": "EVENT"
			},
			{
				"name": "legacy",
				"salience": 0.00035743124,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.00035743124,
				"type": "OTHER"
			},
			{
				"name": "Muslims",
				"salience": 0.0003547586,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.0003547586,
				"type": "OTHER"
			},
			{
				"name": "Radicalism",
				"salience": 0.0003547586,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0003547586,
				"type": "OTHER"
			},
			{
				"name": "Justice",
				"salience": 0.00035451085,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00034742634,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.00034696405,
				"type": "OTHER"
			},
			{
				"name": "rampart",
				"salience": 0.00034408915,
				"type": "OTHER"
			},
			{
				"name": "History",
				"salience": 0.0003412777,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0003354721,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nation-state",
				"salience": 0.00033273103,
				"type": "LOCATION"
			},
			{
				"name": "plain",
				"salience": 0.00033273103,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00033273103,
				"type": "PERSON"
			},
			{
				"name": "throne",
				"salience": 0.00033273103,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00032564768,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00032564768,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0003209988,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.0003203105,
				"type": "OTHER"
			},
			{
				"name": "tense",
				"salience": 0.0003203105,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.0003203105,
				"type": "OTHER"
			},
			{
				"name": "lips",
				"salience": 0.0003203105,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0003203105,
				"type": "OTHER"
			},
			{
				"name": "plain",
				"salience": 0.0003203105,
				"type": "OTHER"
			},
			{
				"name": "breath",
				"salience": 0.0003031077,
				"type": "PERSON"
			},
			{
				"name": "barbaric",
				"salience": 0.00028811544,
				"type": "OTHER"
			},
			{
				"name": "progeny",
				"salience": 0.00028811544,
				"type": "OTHER"
			},
			{
				"name": "sovereignty",
				"salience": 0.00028811544,
				"type": "OTHER"
			},
			{
				"name": "greed",
				"salience": 0.00028811544,
				"type": "OTHER"
			},
			{
				"name": "deeds",
				"salience": 0.00028811544,
				"type": "OTHER"
			},
			{
				"name": "abomination",
				"salience": 0.00028811544,
				"type": "EVENT"
			},
			{
				"name": "exceptionalism",
				"salience": 0.00028811544,
				"type": "OTHER"
			},
			{
				"name": "heresy",
				"salience": 0.00028811544,
				"type": "OTHER"
			},
			{
				"name": "slaughter",
				"salience": 0.00028811544,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.000279203,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.000279203,
				"type": "OTHER"
			},
			{
				"name": "yoke",
				"salience": 0.00027735974,
				"type": "OTHER"
			},
			{
				"name": "reluctance",
				"salience": 0.00027735974,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.00027735974,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.00027735974,
				"type": "EVENT"
			},
			{
				"name": "testimony",
				"salience": 0.00027735974,
				"type": "OTHER"
			},
			{
				"name": "community-building",
				"salience": 0.00027735974,
				"type": "LOCATION"
			},
			{
				"name": "Threat",
				"salience": 0.00027735974,
				"type": "OTHER"
			},
			{
				"name": "injustice",
				"salience": 0.00027735974,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0002756845,
				"type": "OTHER"
			},
			{
				"name": "custodians",
				"salience": 0.0002755631,
				"type": "PERSON"
			},
			{
				"name": "remembrance",
				"salience": 0.00027509333,
				"type": "OTHER"
			},
			{
				"name": "remembrance",
				"salience": 0.00027162657,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.00027162657,
				"type": "EVENT"
			},
			{
				"name": "principles",
				"salience": 0.00027162657,
				"type": "OTHER"
			},
			{
				"name": "refuge",
				"salience": 0.00027162657,
				"type": "OTHER"
			},
			{
				"name": "loyalty",
				"salience": 0.00027162657,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.00027162657,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03y1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Imam"
				},
				"name": "Imam",
				"salience": 0.00026566122,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00025953073,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00025953073,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.00025953073,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07cb8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Truth"
				},
				"name": "Truth",
				"salience": 0.00025292722,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06z49",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slavery"
				},
				"name": "Slavery",
				"salience": 0.00025292722,
				"type": "OTHER"
			},
			{
				"name": "Daesh Karbala",
				"salience": 0.00024494782,
				"type": "ORGANIZATION"
			},
			{
				"name": "oppression",
				"salience": 0.00024326002,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.00024326002,
				"type": "OTHER"
			},
			{
				"name": "tyrants",
				"salience": 0.00024326002,
				"type": "PERSON"
			},
			{
				"name": "contrary",
				"salience": 0.0002382038,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.00023520179,
				"type": "ORGANIZATION"
			},
			{
				"name": "denominations",
				"salience": 0.00023520179,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.00023520179,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00023520179,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00023520179,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.00023520179,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.00022472748,
				"type": "OTHER"
			},
			{
				"name": "prayers",
				"salience": 0.00022472748,
				"type": "OTHER"
			},
			{
				"name": "prayers",
				"salience": 0.00022472748,
				"type": "OTHER"
			},
			{
				"name": "radicalism",
				"salience": 0.00022472748,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0002152205,
				"type": "OTHER"
			},
			{
				"name": "doors",
				"salience": 0.00020457408,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00020395526,
				"type": "LOCATION"
			},
			{
				"name": "hearts",
				"salience": 0.0002030441,
				"type": "OTHER"
			},
			{
				"name": "compassion",
				"salience": 0.00020290226,
				"type": "OTHER"
			},
			{
				"name": "fail",
				"salience": 0.00020290226,
				"type": "OTHER"
			},
			{
				"name": "piety",
				"salience": 0.00020290226,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00020290226,
				"type": "PERSON"
			},
			{
				"name": "lips",
				"salience": 0.00020290226,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00020290226,
				"type": "PERSON"
			},
			{
				"name": "pilgrims",
				"salience": 0.00019964577,
				"type": "PERSON"
			},
			{
				"name": "Messenger 40",
				"salience": 0.00019714107,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Biggest Human Gathering",
				"salience": 0.00019626033,
				"type": "EVENT"
			},
			{
				"name": "thrones",
				"salience": 0.00019043426,
				"type": "OTHER"
			},
			{
				"name": "generosity",
				"salience": 0.00018816558,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/058wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mecca"
				},
				"name": "Mecca",
				"salience": 0.000177323,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06wzmn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ahl_al-Bayt"
				},
				"name": "AhlulBayt",
				"salience": 0.000177323,
				"type": "ORGANIZATION"
			},
			{
				"name": "allegiance",
				"salience": 0.00017715935,
				"type": "OTHER"
			},
			{
				"name": "martyrs",
				"salience": 0.00017715935,
				"type": "PERSON"
			},
			{
				"name": "pulpits",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"name": "repression",
				"salience": 0.00017569108,
				"type": "EVENT"
			},
			{
				"name": "poison",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"name": "depravity",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"name": "wisdom",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"name": "sectarianism",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"name": "rope",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.00017569108,
				"type": "PERSON"
			},
			{
				"name": "fanaticism",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"name": "roar",
				"salience": 0.00017569108,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00017070235,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "DC",
				"salience": 0.00017070235,
				"type": "LOCATION"
			},
			{
				"name": "Muslims Develop Technology to Promote Religious Unity",
				"salience": 0.00017070235,
				"type": "ORGANIZATION"
			},
			{
				"name": "shelter",
				"salience": 0.00016989037,
				"type": "LOCATION"
			},
			{
				"name": "hearts",
				"salience": 0.0001636615,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0001636615,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02plx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Evil"
				},
				"name": "Evil",
				"salience": 0.00016104407,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00014776572,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.00014776572,
				"type": "OTHER"
			},
			{
				"name": "believers",
				"salience": 0.00014776572,
				"type": "PERSON"
			},
			{
				"name": "shelter",
				"salience": 0.00014776572,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.00014776572,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0001466605,
				"type": "OTHER"
			},
			{
				"name": "Word of God",
				"salience": 0.0001447528,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni",
				"salience": 0.0001447528,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.0001447528,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01h7l_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yazidis"
				},
				"name": "Yezidis",
				"salience": 0.0001447528,
				"type": "PERSON"
			},
			{
				"name": "Hussainis Brahims",
				"salience": 0.0001447528,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.00014118447,
				"type": "LOCATION"
			},
			{
				"name": "humanity",
				"salience": 0.00014118447,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.00013233186,
				"type": "OTHER"
			},
			{
				"name": "martyrs",
				"salience": 0.00013233186,
				"type": "PERSON"
			},
			{
				"name": "humanity - martyr",
				"salience": 0.00013233186,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.00013233186,
				"type": "OTHER"
			},
			{
				"name": "faiths",
				"salience": 0.00013233186,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0001279476,
				"type": "LOCATION"
			},
			{
				"name": "vigil",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "sons",
				"salience": 0.0001279476,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "coffers",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "might",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "destitution",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "shame",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "expectation",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "tears",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "devotion",
				"salience": 0.0001279476,
				"type": "OTHER"
			},
			{
				"name": "fists",
				"salience": 0.0001279476,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.00012633487,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.00012380944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.000119758835,
				"type": "LOCATION"
			},
			{
				"name": "loyalty",
				"salience": 0.00011037471,
				"type": "OTHER"
			},
			{
				"name": "believers",
				"salience": 0.00011037471,
				"type": "PERSON"
			},
			{
				"name": "best",
				"salience": 0.00011037471,
				"type": "OTHER"
			},
			{
				"name": "station",
				"salience": 0.00011037471,
				"type": "LOCATION"
			},
			{
				"name": "best",
				"salience": 0.00011037471,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.00011037471,
				"type": "EVENT"
			},
			{
				"name": "love",
				"salience": 0.00011037471,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00011037471,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allah"
				},
				"name": "Allah",
				"salience": 0.000108124084,
				"type": "PERSON"
			},
			{
				"name": "food",
				"salience": 0.00010444524,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.00010182877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "space",
				"salience": 0.00009557076,
				"type": "LOCATION"
			},
			{
				"name": "walk",
				"salience": 0.00009557076,
				"type": "EVENT"
			},
			{
				"name": "fear",
				"salience": 0.00009557076,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00009557076,
				"type": "LOCATION"
			},
			{
				"name": "rubbles",
				"salience": 0.00009557076,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00009557076,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jzcl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hajj"
				},
				"name": "Hajj",
				"salience": 0.00009093687,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07sznm8"
				},
				"name": "History",
				"salience": 0.00006792464,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Arbaeen_2016_374aa.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-19T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 18.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.928",
		"text": "8 Shares\n7 0 0 1\nComing this weekend, over 25 million pilgrims will rally in the holy city of Karbala to mark the greatest pilgrimage of all – Arbaeen. Right at the heart of Iraq, surrounded by the Terror of the Black Flag Army it is communities of men which will gather in prayers, and in mourning to perform the last rites of Imam Hussain ibn Ali, the grandson of the Prophet Muhammad.\nWhile Arbaeen has eclipsed even the Hajj in terms of attendance, few … even within Islam have ever heard of the pilgrimage, let alone the tragedy it recalls, never mind the principles it saw enacted.\nArbaeen it needs to be said stands very much an offense to Wahhabism - this dogma the House of Saud has furiously promoted to assert its ascent to power. Arbaeen it needs to be emphasised, actually speaks of this eternal struggle in between Good and Evil, Freedom and Slavery, Piety and Dogmatism.\n Sidelined by mainstream media for it speaks of Islam’s attachment and commitment to such values as Justice, Freedom and Compassion towards all men, and all fashion of faiths, Arbaeen has nevertheless towered a beacon of hope amid the furious rise of radicalism. Arbaeen I would personally argue, has become a grand symbol of resistance against oppression – the coming together of communities beyond their differences, and most importantly perhaps in spite of their differences, so that together they could oppose tyranny and offer the oppressed a rampart behind which to find refuge.\nFor those of you who still have no idea what in the world I am talking about, allow me to tell you the story of a man - a man whose courage, resolute strength of character and yearning for Truth have echoed across the centuries to inspire generations upon generations to think themselves free, and to rise themselves independent from the yoke of tyranny.\nMORE... Messenger 40 – Muslims Develop Technology to Promote Religious Unity against Radicalism Why Muslims Hold the Biggest Human Gathering under the Threat of ISIS in Iraq? The 10th Day’s new campaign – community-building and social solidarity Shia Muslims gather in DC for anti-terror rally Imam Hussain ibn Ali’s martyrdom in the plain of Karbala over a millennium ago stands testimony to our collective struggle against injustice. And though it is Islam’s banner the Third Imam carried, his message was a universal call for freedom – an immovable promise that real tragedy lies not in our failure to defeat tyrants but in our reluctance to oppose them.\nAllow me to take you back a few centuries, back when Islam’s early History was still being written, back when the name of the Prophet Muhammad was still murmured in the present tense through the lips of his progeny: the House (AhlulBayt).\nOnly a few decades after Islam’s last prophet’s passed, Islam stood divided as a nation-state, its religious sovereignty challenged by men of greed and oppression: Yazid ibn Muawiyah was one of them … arguably the most barbaric of them all since he envisioned slaughter to be the legacy of his throne.\nAs bigots brandished Islam to rationalise their heresy, and proclaim righteous exceptionalism before the abomination of their deeds, Imam Hussain had no other choice but to march against Yazid … even if alone, for as long as there was breath in him, it is Justice he would command for all people.\nAnd so the Imam marched on … from the holy city of Mecca to the then-deserted plain of Karbala he walked knowing death would be his fate. And still he pushed on …\nIt is this determination to meet Evil and not relent in the task which Arbaeen speaks of most loudly. It is allegiance, loyalty and love, pilgrims manifest into reality as they walk towards their Imam, united not faith but in their humanity.\nArbaeen you most likely were never told is NOT exclusive to Islam. Arbaeen is neither Shia nor Sunni, Arbaeen is for all who dare think themselves free under God and in Him seek refuge.\nAnd while Arbaeen has long been associated to Shia Islam for its school of thought revolve around those very principles Imam Hussain consecrated with his death, the pilgrimage stands not in opposition or rejection of any faith – quite the contrary since Christians, Yezidis, Hussainis Brahims, alongside countless other religious denominations have year after year, centuries after centuries come to Karbala to remember.\nArbaeen is remembrance of Hussain ibn Ali, remembrance of the Word of God made complete through Hussain, the man the Prophet Muhammad called his son, and whose leadership he commanded all believers to forever follow.\nIf many failed in their allegiance for fear rendered them motionless before their Imam’s calls, Hussain’s station in Karbala has echoed ever since of a love so brilliant and unparalleled that all people, all nations, all faiths, across time and space have found themselves compelled to walk the great walk of Arbaeen … and through Hussain ibn Ali find their humanity.\nArbaeen I have to say speaks to the best of our humanity; it is home after all to the best of humanity - martyr among all martyrs, there has never been a day like Hussain’s day - and though his name Wahhabism has worked to bury under the rubbles of History, Karbala has remembered its Imam with fierce loyalty.\nA city build around and for Hussain ibn Ali, Karbala is a declaration of allegiance to the House of the prophet - those extraordinary men and women whose hearts, lips and prayers have spoken Islam in wisdom and piety, and without whom we would be orphans.\nEvery year without fail Karbala has fervently commemorated its Imam - even in oppression, especially when in oppression.\nBefore the poison of radicalism, Karbala has offered generosity and compassion, before brutal repression Karbala has opened its doors and to all oppressed offered a shelter, before the depravity of sectarianism Karbala’s pulpits have called upon men and women to hold to rope of Allah, never to disunite.\nA city surrounded by the evil of Daesh Karbala has never shun brighter.\nIn the face of insane fanaticism Imam Hussain’s followers have never been braver.\nAnd so coming this November 20-21, 2016 Karbala will let out a roar which will shook tyrants’ thrones. Karbala will offer all of its prayers and all of its devotion … Hussain’s name will be etched on believers’ hearts, tears of allegiance will flow, fists will rise to the sky, a promise that when called upon all will answer.\nIslam today is best manifested in Karbala since Karbala shuns no one. Karbala today has put Saudi Arabia to shame since it has provided food and shelter to tens of millions of pilgrims - without expectation, without any hope of a thank you.\nA city has proven more generous and compassionate in its destitution than Saudi Arabia in its wealth and might. Where the so-called custodians of Islam have cried the weight of the Hajj on their coffers, Karbala has provided beyond the mathematically feasible.\nIn a few short days Karbala will stop time once more … so that all could remember all martyrs are in fact alive and that the sons of Hussain are still standing vigil.",
		"thread_title": "The Walk Of Light – Arbaeen Pilgrimage Rises a Great Resistance against Radicalism",
		"title": "The Walk Of Light – Arbaeen Pilgrimage Rises a Great Resistance against Radicalism",
		"type": "bs",
		"uuid": "4c7fcdcb746e9c2cb4c87131230c6e13f3a28423"
	},
	"-KhIgQTHQKO2bI0fS_RY": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-11-19T22:48:48.478+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.13673292,
				"type": "LOCATION"
			},
			{
				"name": "Shaker Jodat",
				"salience": 0.13021332,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.059565265,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.049608227,
				"type": "ORGANIZATION"
			},
			{
				"name": "front",
				"salience": 0.049057905,
				"type": "LOCATION"
			},
			{
				"name": "Militants",
				"salience": 0.04438495,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018hmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_United_States"
				},
				"name": "Southern",
				"salience": 0.04141315,
				"type": "LOCATION"
			},
			{
				"name": "Staff",
				"salience": 0.03853171,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.03853171,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.03853171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.031075172,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rz5b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kill_(command)"
				},
				"name": "Kill",
				"salience": 0.023866234,
				"type": "PERSON"
			},
			{
				"name": "AHT",
				"salience": 0.023866234,
				"type": "ORGANIZATION"
			},
			{
				"name": "Iraqi Forces Recapture Southern Front",
				"salience": 0.023866234,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.012936622,
				"type": "ORGANIZATION"
			},
			{
				"name": "security forces",
				"salience": 0.012375859,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.011909217,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.011904464,
				"type": "PERSON"
			},
			{
				"name": "government troops",
				"salience": 0.010482047,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.010482047,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.009467991,
				"type": "PERSON"
			},
			{
				"name": "police forces",
				"salience": 0.00897005,
				"type": "ORGANIZATION"
			},
			{
				"name": "families",
				"salience": 0.008202505,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.008202505,
				"type": "OTHER"
			},
			{
				"name": "police chief",
				"salience": 0.008202505,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.007084201,
				"type": "LOCATION"
			},
			{
				"name": "car bombs",
				"salience": 0.0063979332,
				"type": "OTHER"
			},
			{
				"name": "motorbike bombs",
				"salience": 0.0063979332,
				"type": "OTHER"
			},
			{
				"name": "advances",
				"salience": 0.0063979332,
				"type": "EVENT"
			},
			{
				"name": "axis",
				"salience": 0.006009913,
				"type": "LOCATION"
			},
			{
				"name": "chemicals",
				"salience": 0.0057562343,
				"type": "OTHER"
			},
			{
				"name": "coast",
				"salience": 0.0057562343,
				"type": "LOCATION"
			},
			{
				"name": "mortar shells",
				"salience": 0.0057562343,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0055417875,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0055417875,
				"type": "OTHER"
			},
			{
				"name": "vehicles",
				"salience": 0.0055417875,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "belts",
				"salience": 0.0055417875,
				"type": "OTHER"
			},
			{
				"name": "news website",
				"salience": 0.0055417875,
				"type": "OTHER"
			},
			{
				"name": "press statement",
				"salience": 0.0054274662,
				"type": "WORK_OF_ART"
			},
			{
				"name": "areas",
				"salience": 0.0050981706,
				"type": "LOCATION"
			},
			{
				"name": "command",
				"salience": 0.004721974,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis",
				"salience": 0.004491917,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0043064076,
				"type": "ORGANIZATION"
			},
			{
				"name": "airport",
				"salience": 0.004056323,
				"type": "LOCATION"
			},
			{
				"name": "cleansing operations",
				"salience": 0.004056323,
				"type": "OTHER"
			},
			{
				"name": "Troops of Federal Policed",
				"salience": 0.0037020417,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03cgmt0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Sumaria"
				},
				"name": "al-Sumaria",
				"salience": 0.0034134116,
				"type": "ORGANIZATION"
			},
			{
				"name": "Joint Operations Command",
				"salience": 0.0032182648,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.003108899,
				"type": "WORK_OF_ART"
			},
			{
				"name": "advance",
				"salience": 0.0029552658,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01chdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nineveh_Governorate"
				},
				"name": "Nineveh",
				"salience": 0.0028950735,
				"type": "LOCATION"
			},
			{
				"name": "Troops of al-Hashd al-Shaabi",
				"salience": 0.002766263,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.0025592854,
				"type": "EVENT"
			},
			{
				"name": "coalition",
				"salience": 0.0025592854,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tel Afar Airport",
				"salience": 0.002497827,
				"type": "LOCATION"
			},
			{
				"name": "axis",
				"salience": 0.002445399,
				"type": "OTHER"
			},
			{
				"name": "al-Tahrir",
				"salience": 0.0021630812,
				"type": "PERSON"
			},
			{
				"name": "al-Ezba village",
				"salience": 0.0020046749,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.001693198,
				"type": "LOCATION"
			},
			{
				"name": "Army Aviation",
				"salience": 0.0015755738,
				"type": "ORGANIZATION"
			},
			{
				"name": "For You",
				"salience": 0.0015755738,
				"type": "WORK_OF_ART"
			},
			{
				"name": "al-Qadisiyah al-Oula",
				"salience": 0.0011770321,
				"type": "PERSON"
			},
			{
				"name": "al-Khadra",
				"salience": 0.0011770321,
				"type": "PERSON"
			},
			{
				"name": "al-Zahabiya",
				"salience": 0.0011770321,
				"type": "PERSON"
			},
			{
				"name": "al-Bakr",
				"salience": 0.0011770321,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Adan",
				"salience": 0.0011770321,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0lbqg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Counter-terrorism"
				},
				"name": "Anti-Terrorism",
				"salience": 0.0011770321,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/iraqi_forces_365f0.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-19T22:48:48.478+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "BY AHT Staff Iraqi Forces Recapture Southern Front of Mosul, Kill over 950 ISIS Militants Iraqi forces managed to win back full control of Mosul's Southern front, killing over 950 ISIS terrorists. 10 Shares 0 1 \nFederal police chief General Shaker Jodat said late Friday government troops had purged 1,850 square kilometers of Mosul’s Southern front of ISIS militants and freed more than 10,000 families, the al-Sumaria news website reported. \nThe Iraqi soldiers destroyed 25 car bombs, 83 motorbike bombs, 92 explosive belts and some vehicles equipped with weapons and missiles during their advances in the area, Jodat added. \nHe further noted that police forces had confiscated 36 mortar shells containing chemicals. \nOn Thursday, Joint Operations Command announced that the security forces continue liberating six areas in the western coast of the city of Mosul. \nThe command said in a press statement, “Troops of Federal Policed in the southwest axis of Nineveh managed, today, to fully liberate al-Ezba village,” adding that, “Anti-Terrorism forces in the eastern axis continue liberating the areas of Adan, al-Bakr, al-Zahabiya, al-Khadra’, al-Qadisiyah al-Oula and al-Tahrir.” \n“Troops of al-Hashd al-Shaabi in the western axis managed to besiege Tel Afar Airport, and continue the cleansing operations inside the airport,” the statement added. \nJoint security forces, backed by Army Aviation and international coalition continue their advance in the battle launched in 17 October 2016, to liberate the city of Mosul. Recommended For You",
		"thread_title": "Iraqi Forces Recapture Southern Front of Mosul, Kill over 950 ISIS Militants",
		"title": "Iraqi Forces Recapture Southern Front of Mosul, Kill over 950 ISIS Militants",
		"type": "bs",
		"uuid": "6759979ebdede7af1ee3787359507f7e66a7ede9"
	},
	"-KhIgQaRgcyTeNWl_hjR": {
		"author": "ELSEVAR",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-20T07:30:21.534+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Will America Survive",
				"salience": 0.35422927,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Hyperbole",
				"salience": 0.16532616,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.15071696,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.07243737,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.068101875,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.02845961,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.026225528,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.01927414,
				"type": "OTHER"
			},
			{
				"name": "paragraph",
				"salience": 0.01927414,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.016569622,
				"type": "LOCATION"
			},
			{
				"name": "regimes",
				"salience": 0.012240657,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.01164974,
				"type": "LOCATION"
			},
			{
				"name": "chance",
				"salience": 0.011491624,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "Bush Jr.",
				"salience": 0.010093097,
				"type": "PERSON"
			},
			{
				"name": "Slick Willie Clinton",
				"salience": 0.010093097,
				"type": "PERSON"
			},
			{
				"name": "predecessors",
				"salience": 0.008925153,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0066721737,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0041098823,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0041098823,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Anti_Trump_Protests_23a57.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-20T04:23:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Hyperbole is odious.\nThis is not a bad article for the most part, but the title, \"Will America Survive the Next 4 Years?\" , and the words in the last paragraph, \"it seems entirely doubtful that the country will make it through four years of Donald Trump\" , are clickbait silly.\nIf America could survive Slick Willie Clinton, Bush Jr., and Obama/Hillary (even though millions of foreign people did not survive their regimes), then it will survive Mr. Trump.\nThere is even a fair chance that Trump will not be worse than his predecessors.",
		"thread_title": "Will America Survive the Next 4 Years?",
		"title": "",
		"type": "bs",
		"uuid": "9d86f3566e3e008b09d4a1f5047cfca3d4af3b37"
	},
	"-KhIgQgIbBEeblNBaPki": {
		"author": "ELSEVAR",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-20T07:31:00.454+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.57366884,
				"type": "PERSON"
			},
			{
				"name": "booster",
				"salience": 0.11209808,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0108xl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tyler,_Texas"
				},
				"name": "Tyler",
				"salience": 0.070051104,
				"type": "PERSON"
			},
			{
				"name": "trips",
				"salience": 0.05575586,
				"type": "EVENT"
			},
			{
				"name": "fossil fuels industries",
				"salience": 0.045247056,
				"type": "OTHER"
			},
			{
				"name": "fracking technology",
				"salience": 0.030819528,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.016493369,
				"type": "OTHER"
			},
			{
				"name": "teeth",
				"salience": 0.016493369,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.013489039,
				"type": "OTHER"
			},
			{
				"name": "environmentalism",
				"salience": 0.013489039,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.013489039,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.013489039,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.010096918,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00981192,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.005507786,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Donald_J._Trump_149fc.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-11-20T05:16:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 1.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.04",
		"text": "Alas, Tyler, Hillary was/is an unapologetic booster of the fossil fuels industries, including making frequent trips abroad when she was Secretary of State boosting fracking technology. Like Obama, nothing with teeth was ever attempted by Hillary in the direction of environmentalism. In fact, quite the contrary.\nYou can research Hillary's anti-environmental history on your own, but here are two places to start ...\n- https://theintercept.com/2016/...\n- https://theintercept.com/2016/...\nAlso ...\n- http://www.motherjones.com/env...",
		"thread_title": "Defeating White Liberalism in the Age of Trump",
		"title": "",
		"type": "bs",
		"uuid": "f5017cc8d34d6c1a9079c1b71b80cd0f3e3ee810"
	},
	"-KhIgQlgek1Lruv30Yo2": {
		"author": "ELSEVAR",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-20T07:31:12.666+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.6041264,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.25829548,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07qmcqq"
				},
				"name": "Fascist",
				"salience": 0.033471312,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "Bush Jr",
				"salience": 0.02799641,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d33f3"
				},
				"name": "Karl",
				"salience": 0.014041376,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.01075921,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.009473073,
				"type": "EVENT"
			},
			{
				"name": "wars",
				"salience": 0.007745888,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.0067136423,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.005069308,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.005069308,
				"type": "LOCATION"
			},
			{
				"name": "list",
				"salience": 0.0050228722,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0040013776,
				"type": "OTHER"
			},
			{
				"name": "plenty",
				"salience": 0.0027381114,
				"type": "OTHER"
			},
			{
				"name": "objections",
				"salience": 0.0027381114,
				"type": "OTHER"
			},
			{
				"name": "killing",
				"salience": 0.0027381114,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Protest_against_Donald_Trump_2_22585.jpg",
		"ord_in_thread": "4",
		"participants_count": "5",
		"published": "2016-11-20T04:50:00.000+02:00",
		"replies_count": "4",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "How \"unfit and Fascist\" was Hillary in your mind, Karl, and was it \"obvious\"?\nDid it worry you that she was the driving force behind two wars (Libya and Syria) and responsible for as many deaths as Bush Jr is for his wars?\nThere are plenty of other serious objections to Hillary, but mass killing really does have to top the list. Did you endorse her bloody efforts, that is the interesting question.",
		"thread_title": "The Unethicality of the Sore Loser",
		"title": "",
		"type": "bs",
		"uuid": "1c92a78a21296e6b1dab7acf0fcf694367c5c435"
	},
	"-KhIgQynt5DLkywmm-ok": {
		"author": "James M. Dorsey",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-20T18:08:58.042+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "extremist group",
				"salience": 0.23884471,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptian",
				"salience": 0.17045796,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.06581314,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.048388656,
				"type": "PERSON"
			},
			{
				"name": "Suleiman Abu Heraz",
				"salience": 0.033593506,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.03308075,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.026389586,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.025441302,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0yqkzkc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ansar_Bait_al-Maqdis"
				},
				"name": "Ansar Bayt al-Maqdis",
				"salience": 0.023485437,
				"type": "PERSON"
			},
			{
				"name": "execution",
				"salience": 0.023082336,
				"type": "EVENT"
			},
			{
				"name": "Sheikh",
				"salience": 0.019240404,
				"type": "PERSON"
			},
			{
				"name": "ISIS-affiliate",
				"salience": 0.0109175695,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.009803807,
				"type": "PERSON"
			},
			{
				"name": "swathes",
				"salience": 0.009263007,
				"type": "OTHER"
			},
			{
				"name": "executioners",
				"salience": 0.0090720765,
				"type": "PERSON"
			},
			{
				"name": "allegiance",
				"salience": 0.008059875,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.007532954,
				"type": "ORGANIZATION"
			},
			{
				"name": "Abdel-Fattah",
				"salience": 0.0074867397,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.007229625,
				"type": "PERSON"
			},
			{
				"name": "Locals",
				"salience": 0.006528913,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.006528913,
				"type": "OTHER"
			},
			{
				"name": "Pictures",
				"salience": 0.0063373176,
				"type": "WORK_OF_ART"
			},
			{
				"name": "locals",
				"salience": 0.006285628,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0059042056,
				"type": "PERSON"
			},
			{
				"name": "ISIS-Sinai",
				"salience": 0.005732855,
				"type": "ORGANIZATION"
			},
			{
				"name": "beard",
				"salience": 0.005654855,
				"type": "OTHER"
			},
			{
				"name": "jumpsuit",
				"salience": 0.005654855,
				"type": "OTHER"
			},
			{
				"name": "neck",
				"salience": 0.005654855,
				"type": "OTHER"
			},
			{
				"name": "stand",
				"salience": 0.005654855,
				"type": "OTHER"
			},
			{
				"name": "swords",
				"salience": 0.0055134506,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.005444077,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.005444077,
				"type": "PERSON"
			},
			{
				"name": "priests",
				"salience": 0.005444077,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.005444077,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sheikh",
				"salience": 0.005136542,
				"type": "PERSON"
			},
			{
				"name": "Sulaiman Abu Haraz",
				"salience": 0.0049651824,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0049651824,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0049651824,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07hcc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tutankhamun"
				},
				"name": "Tutankhamun",
				"salience": 0.0046865987,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.0046176706,
				"type": "LOCATION"
			},
			{
				"name": "peninsula",
				"salience": 0.0046176706,
				"type": "LOCATION"
			},
			{
				"name": "farm",
				"salience": 0.0046176706,
				"type": "LOCATION"
			},
			{
				"name": "figures",
				"salience": 0.00450216,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06wjy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sinai_Peninsula"
				},
				"name": "Sinai",
				"salience": 0.0038712486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rvt_j"
				},
				"name": "Sufi",
				"salience": 0.003482465,
				"type": "PERSON"
			},
			{
				"name": "sale",
				"salience": 0.0034504468,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.0034504468,
				"type": "OTHER"
			},
			{
				"name": "fury",
				"salience": 0.0034504468,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0034504468,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0034504468,
				"type": "ORGANIZATION"
			},
			{
				"name": "anger",
				"salience": 0.0034504468,
				"type": "OTHER"
			},
			{
				"name": "ministry",
				"salience": 0.0034504468,
				"type": "ORGANIZATION"
			},
			{
				"name": "memos",
				"salience": 0.0034504468,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0033525643,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gqqw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bedouin"
				},
				"name": "Bedouins",
				"salience": 0.0033525643,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.0030397635,
				"type": "OTHER"
			},
			{
				"name": "Training",
				"salience": 0.0029024621,
				"type": "OTHER"
			},
			{
				"name": "headquarters",
				"salience": 0.0029024621,
				"type": "LOCATION"
			},
			{
				"name": "training",
				"salience": 0.0029024621,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0028531142,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02hh2g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arish"
				},
				"name": "el-Arish",
				"salience": 0.0028433292,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.0025134643,
				"type": "OTHER"
			},
			{
				"name": "cooperation b",
				"salience": 0.0025134643,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0025134643,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0023527073,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0023527073,
				"type": "LOCATION"
			},
			{
				"name": "James M. Dorsey",
				"salience": 0.0021242753,
				"type": "PERSON"
			},
			{
				"name": "dagger",
				"salience": 0.0019754593,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.0018777754,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0018777754,
				"type": "OTHER"
			},
			{
				"name": "wrapping",
				"salience": 0.0018777754,
				"type": "OTHER"
			},
			{
				"name": "mummy",
				"salience": 0.0018777754,
				"type": "OTHER"
			},
			{
				"name": "iron",
				"salience": 0.0018777754,
				"type": "OTHER"
			},
			{
				"name": "meteorite",
				"salience": 0.0018777754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cmn45",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tiran_Island"
				},
				"name": "Tiran Island",
				"salience": 0.0015472235,
				"type": "LOCATION"
			},
			{
				"name": "Heba Morad",
				"salience": 0.0015472235,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06jfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Red_Sea"
				},
				"name": "Red Sea",
				"salience": 0.0015472235,
				"type": "LOCATION"
			},
			{
				"name": "AHT",
				"salience": 0.0011558103,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/isis_sufi_5c556.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-20T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "7 Shares\n2 4 0 1\nAnsar Bayt al-Maqdis – ISIS-affiliated extremist group in Egypt – has released images purporting to show the execution of a 100-year-old man.\nThe group, who rebranded as ISIS-Sinai when they pledged allegiance to the extremist group holding swathes of Iraq and Syria, killed Sheikh Sulaiman Abu Haraz after kidnapping him earlier.\nThe ISIS-affiliate in Egypt mistakenly described in a statement as priests, but were later identified by locals as leading religious figures from among Sinai's Bedouins.\nPictures were posted on the Twitter accounts of the group's supporters. They showed one of the men, elderly with a white beard and kneeling in an orange jumpsuit with his neck pressed against a steel stand. Masked ISIS executioners dressed in black raised long swords over his head.\nLocals identified the man as the blind Sufi sheikh Suleiman Abu Heraz, who was abducted two weeks ago from his farm south of the peninsula's town of el-Arish. The second man was identified as sheikh Said Abdel-Fattah, a top Religious Endowment cleric abducted a month ago.\nRecommended For You A famous dagger found in the wrapping of Egyptian King Tutankhamun's mummy was made with iron from a meteorite, a study confirms...\nBy AHT Staff Leaked memos from Egypt's interior ministry discussing ways to counter mounting public anger at the government of general-turned-president...\nBy James M. Dorsey Egyptian fury on social media: Egypt is not for sale! The news on Saudi Arabia’s and Israel’s joint training in Tiran Island [considered the headquarters of the cooperation b...\nBy Heba Morad Saudi Arabia and Israel in joint Training, mutual interests in Red Sea",
		"thread_title": "ISIS in Egypt Beheads 100-year-old Sufi Cleric for Practicing Witchcraft",
		"title": "ISIS in Egypt Beheads 100-year-old Sufi Cleric for Practicing Witchcraft",
		"type": "bs",
		"uuid": "80de710d6d50583da300530cfc06b17996e4a3da"
	},
	"-KhIgR1BnZLms64d9C__": {
		"author": "Snowonweb",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-22T02:40:40.292+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "article",
				"salience": 1,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Justin_Trudeau_World_Bank_179d8.jpg",
		"ord_in_thread": "3",
		"participants_count": "4",
		"published": "2016-11-21T21:23:00.000+02:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.001",
		"text": "great article",
		"thread_title": "Justin Trudeau Doesn't Tell the Truth to Canadians about Syria",
		"title": "",
		"type": "bs",
		"uuid": "abba62ff01256f913baaec3a06161176cc7efddf"
	},
	"-KhIgRYCqvixWJr29-OW": {
		"author": "Ludwig Watzal",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-22T02:42:18.263+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.18573059,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/086dny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Zuckerberg"
				},
				"name": "Mark Zuckerberg",
				"salience": 0.10130206,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.03342156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.028455857,
				"type": "PERSON"
			},
			{
				"name": "hate-speech",
				"salience": 0.026174163,
				"type": "WORK_OF_ART"
			},
			{
				"name": "news",
				"salience": 0.023992436,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.022416646,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.020706253,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.01587492,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.013016879,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.011211747,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.010792289,
				"type": "LOCATION"
			},
			{
				"name": "defeat",
				"salience": 0.0098427115,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.009195909,
				"type": "ORGANIZATION"
			},
			{
				"name": "reason",
				"salience": 0.008332346,
				"type": "OTHER"
			},
			{
				"name": "spin",
				"salience": 0.0082135815,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.007972622,
				"type": "OTHER"
			},
			{
				"name": "media whores",
				"salience": 0.007821478,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.0076012122,
				"type": "EVENT"
			},
			{
				"name": "Anetta Kahane",
				"salience": 0.0075507425,
				"type": "PERSON"
			},
			{
				"name": "mouthpiece",
				"salience": 0.0073447987,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.007249325,
				"type": "OTHER"
			},
			{
				"name": "debacle",
				"salience": 0.007114289,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0064342953,
				"type": "OTHER"
			},
			{
				"name": "contempt",
				"salience": 0.0064342953,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0059954743,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0056699673,
				"type": "OTHER"
			},
			{
				"name": "media presstitutes",
				"salience": 0.0053683473,
				"type": "OTHER"
			},
			{
				"name": "embodiment",
				"salience": 0.0053406702,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.005032217,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.005032217,
				"type": "EVENT"
			},
			{
				"name": "attempts",
				"salience": 0.005032217,
				"type": "EVENT"
			},
			{
				"name": "attempt",
				"salience": 0.005032217,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0047508655,
				"type": "PERSON"
			},
			{
				"name": "campaign organization",
				"salience": 0.0046492913,
				"type": "ORGANIZATION"
			},
			{
				"name": "puppet",
				"salience": 0.004625316,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04dtx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flickr"
				},
				"name": "flickr",
				"salience": 0.0043816953,
				"type": "OTHER"
			},
			{
				"name": "Credit: Ken Yeung",
				"salience": 0.0043816953,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0043417877,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.004198236,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.004198236,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.004198236,
				"type": "OTHER"
			},
			{
				"name": "deplorables",
				"salience": 0.004198236,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.003854037,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0w4ytvj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Heiko_Maas"
				},
				"name": "Heiko Maas",
				"salience": 0.0037257867,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.003635727,
				"type": "OTHER"
			},
			{
				"name": "hurdle",
				"salience": 0.003635727,
				"type": "OTHER"
			},
			{
				"name": "crap",
				"salience": 0.003635727,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.003635727,
				"type": "PERSON"
			},
			{
				"name": "media outlets",
				"salience": 0.003635727,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.003635727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Establishment",
				"salience": 0.003635727,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.003635727,
				"type": "PERSON"
			},
			{
				"name": "journalists",
				"salience": 0.0034989973,
				"type": "PERSON"
			},
			{
				"name": "internet police",
				"salience": 0.0033937383,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0033343185,
				"type": "PERSON"
			},
			{
				"name": "character",
				"salience": 0.0031434163,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0030665132,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0029867475,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0029867475,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0029152646,
				"type": "OTHER"
			},
			{
				"name": "drums",
				"salience": 0.002821675,
				"type": "OTHER"
			},
			{
				"name": "mind-control",
				"salience": 0.002650547,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.00260975,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.002584773,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.002584773,
				"type": "PERSON"
			},
			{
				"name": "few",
				"salience": 0.0024968854,
				"type": "PERSON"
			},
			{
				"name": "censorship body",
				"salience": 0.0023898135,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0023353547,
				"type": "EVENT"
			},
			{
				"name": "media class",
				"salience": 0.0023353547,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0023353547,
				"type": "OTHER"
			},
			{
				"name": "entity",
				"salience": 0.0023299821,
				"type": "OTHER"
			},
			{
				"name": "criteria",
				"salience": 0.0022599243,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0022109982,
				"type": "OTHER"
			},
			{
				"name": "dinner meeting",
				"salience": 0.0021995876,
				"type": "EVENT"
			},
			{
				"name": "regime",
				"salience": 0.002175585,
				"type": "PERSON"
			},
			{
				"name": "determination",
				"salience": 0.0020724295,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0019305854,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0019081827,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.0019047091,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.0017743378,
				"type": "PERSON"
			},
			{
				"name": "government spin-doctors",
				"salience": 0.0017286988,
				"type": "PERSON"
			},
			{
				"name": "embodiment",
				"salience": 0.0017286988,
				"type": "OTHER"
			},
			{
				"name": "mouthpieces",
				"salience": 0.0017286988,
				"type": "OTHER"
			},
			{
				"name": "media report",
				"salience": 0.0017286988,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0017286988,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0017234711,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0017097868,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0016495332,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0016374715,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02q95mk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Justice_(United_Kingdom)"
				},
				"name": "Ministry of Justice",
				"salience": 0.0016083021,
				"type": "ORGANIZATION"
			},
			{
				"name": "policy",
				"salience": 0.0015763501,
				"type": "OTHER"
			},
			{
				"name": "internet",
				"salience": 0.0015763501,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0015502585,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0015502585,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0015253829,
				"type": "OTHER"
			},
			{
				"name": "International Convention for the Abolition of All Forms of Racial Discrimination",
				"salience": 0.0015246839,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contents",
				"salience": 0.0015172568,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0015172568,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.001516021,
				"type": "OTHER"
			},
			{
				"name": "masters",
				"salience": 0.001496918,
				"type": "PERSON"
			},
			{
				"name": "relevance",
				"salience": 0.001496918,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.001496918,
				"type": "OTHER"
			},
			{
				"name": "executions",
				"salience": 0.001496918,
				"type": "OTHER"
			},
			{
				"name": "whistleblowers",
				"salience": 0.001496918,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.001496918,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.001496918,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0014949392,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.0014923909,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0014807516,
				"type": "OTHER"
			},
			{
				"name": "detectives",
				"salience": 0.0014530808,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.001398839,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.001398839,
				"type": "ORGANIZATION"
			},
			{
				"name": "freedom of speech",
				"salience": 0.001398839,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.001398839,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0013944464,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.0013782624,
				"type": "PERSON"
			},
			{
				"name": "eminent",
				"salience": 0.0013525061,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0013423923,
				"type": "PERSON"
			},
			{
				"name": "censorship body",
				"salience": 0.0013423923,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0013423923,
				"type": "ORGANIZATION"
			},
			{
				"name": "class",
				"salience": 0.0013367734,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.001302017,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.001302017,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0012772484,
				"type": "OTHER"
			},
			{
				"name": "deplorables",
				"salience": 0.0012751046,
				"type": "WORK_OF_ART"
			},
			{
				"name": "minion",
				"salience": 0.0012655694,
				"type": "OTHER"
			},
			{
				"name": "censorship",
				"salience": 0.0012655694,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.0012655694,
				"type": "EVENT"
			},
			{
				"name": "attempt",
				"salience": 0.0012638853,
				"type": "OTHER"
			},
			{
				"name": "Axel Springer Award",
				"salience": 0.0012333697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0156q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Berlin"
				},
				"name": "Berlin",
				"salience": 0.001217827,
				"type": "LOCATION"
			},
			{
				"name": "kind",
				"salience": 0.001212035,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.001212035,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.001212035,
				"type": "OTHER"
			},
			{
				"name": "best practices",
				"salience": 0.001212035,
				"type": "OTHER"
			},
			{
				"name": "civil society groups",
				"salience": 0.001212035,
				"type": "ORGANIZATION"
			},
			{
				"name": "labeling stories",
				"salience": 0.0012050256,
				"type": "WORK_OF_ART"
			},
			{
				"name": "quest",
				"salience": 0.0011862307,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.0011862307,
				"type": "EVENT"
			},
			{
				"name": "defeat",
				"salience": 0.0011862307,
				"type": "EVENT"
			},
			{
				"name": "meaning",
				"salience": 0.0011764007,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0011667878,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0011667878,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.0011667878,
				"type": "OTHER"
			},
			{
				"name": "censorship",
				"salience": 0.0011434682,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0011334067,
				"type": "EVENT"
			},
			{
				"name": "freedom",
				"salience": 0.0011275554,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0011041195,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.0011011241,
				"type": "OTHER"
			},
			{
				"name": "privileges",
				"salience": 0.0010902049,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.001064005,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04_zt0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Springer_Science%2BBusiness_Media"
				},
				"name": "Springer",
				"salience": 0.001064005,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0010495044,
				"type": "OTHER"
			},
			{
				"name": "provisions",
				"salience": 0.0010495044,
				"type": "OTHER"
			},
			{
				"name": "hate speach",
				"salience": 0.0010495044,
				"type": "OTHER"
			},
			{
				"name": "anti-Semitism",
				"salience": 0.0010495044,
				"type": "OTHER"
			},
			{
				"name": "xenophobia",
				"salience": 0.0010495044,
				"type": "OTHER"
			},
			{
				"name": "internet watchdog",
				"salience": 0.0010495044,
				"type": "ORGANIZATION"
			},
			{
				"name": "agent",
				"salience": 0.0010495044,
				"type": "PERSON"
			},
			{
				"name": "forefront",
				"salience": 0.0010495044,
				"type": "OTHER"
			},
			{
				"name": "Internet giants",
				"salience": 0.0010495044,
				"type": "ORGANIZATION"
			},
			{
				"name": "excesses",
				"salience": 0.0010495044,
				"type": "OTHER"
			},
			{
				"name": "government failure",
				"salience": 0.0010495044,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "insults",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "Zionist",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "dissemination",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "restrictions",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "spheres",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "jurisprudence",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "prohibition",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "advertising",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0010103227,
				"type": "LOCATION"
			},
			{
				"name": "tobacco",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "alcohol",
				"salience": 0.0010103227,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Human rights law",
				"salience": 0.0010103227,
				"type": "OTHER"
			},
			{
				"name": "hate messages",
				"salience": 0.0010020664,
				"type": "WORK_OF_ART"
			},
			{
				"name": "class",
				"salience": 0.0009985692,
				"type": "EVENT"
			},
			{
				"name": "news",
				"salience": 0.0009985692,
				"type": "OTHER"
			},
			{
				"name": "ads policies",
				"salience": 0.0009985692,
				"type": "OTHER"
			},
			{
				"name": "Chancellor",
				"salience": 0.0009894377,
				"type": "PERSON"
			},
			{
				"name": "messages",
				"salience": 0.0009894377,
				"type": "WORK_OF_ART"
			},
			{
				"name": "practice",
				"salience": 0.0009894377,
				"type": "OTHER"
			},
			{
				"name": "operating",
				"salience": 0.00095412455,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0009524978,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.00094537437,
				"type": "OTHER"
			},
			{
				"name": "recourse",
				"salience": 0.00093629194,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.00093505403,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.00092131895,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00092131895,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.00092131895,
				"type": "LOCATION"
			},
			{
				"name": "sort",
				"salience": 0.00088997604,
				"type": "OTHER"
			},
			{
				"name": "farm detection",
				"salience": 0.0008861031,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.0008861031,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.0008861031,
				"type": "OTHER"
			},
			{
				"name": "mandate",
				"salience": 0.00085674855,
				"type": "OTHER"
			},
			{
				"name": "representatives",
				"salience": 0.00085674855,
				"type": "PERSON"
			},
			{
				"name": "companies",
				"salience": 0.00085674855,
				"type": "ORGANIZATION"
			},
			{
				"name": "help",
				"salience": 0.00085674855,
				"type": "OTHER"
			},
			{
				"name": "mass",
				"salience": 0.00085674855,
				"type": "OTHER"
			},
			{
				"name": "editors-in-chief",
				"salience": 0.00085674855,
				"type": "PERSON"
			},
			{
				"name": "mind control",
				"salience": 0.0008254338,
				"type": "OTHER"
			},
			{
				"name": "entity",
				"salience": 0.0008185929,
				"type": "OTHER"
			},
			{
				"name": "entity",
				"salience": 0.0008185929,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/g/120vmz72",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amadeu_Antonio_Foundation"
				},
				"name": "Amadeu Antonio Foundation",
				"salience": 0.00079479377,
				"type": "ORGANIZATION"
			},
			{
				"name": "values",
				"salience": 0.00078396115,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0007805494,
				"type": "OTHER"
			},
			{
				"name": "news economics",
				"salience": 0.0007390888,
				"type": "OTHER"
			},
			{
				"name": "economics",
				"salience": 0.0007390888,
				"type": "OTHER"
			},
			{
				"name": "news industry",
				"salience": 0.0007390888,
				"type": "OTHER"
			},
			{
				"name": "fact checking systems",
				"salience": 0.0007390888,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0007390888,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0007390888,
				"type": "OTHER"
			},
			{
				"name": "mind-control industry",
				"salience": 0.0007390888,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0007272263,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0007272263,
				"type": "OTHER"
			},
			{
				"name": "input",
				"salience": 0.0006993871,
				"type": "OTHER"
			},
			{
				"name": "ownership",
				"salience": 0.00069367123,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00068848307,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.0006818681,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0793z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stasi"
				},
				"name": "Stasi",
				"salience": 0.0006459106,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0006459106,
				"type": "OTHER"
			},
			{
				"name": "Gesicht zeigen",
				"salience": 0.0006459106,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0006453145,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.00063996605,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.00063996605,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00063996605,
				"type": "OTHER"
			},
			{
				"name": "spam",
				"salience": 0.00063996605,
				"type": "OTHER"
			},
			{
				"name": "scrutiny",
				"salience": 0.00063996605,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.00063996605,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00063996605,
				"type": "PERSON"
			},
			{
				"name": "sides",
				"salience": 0.00063996605,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.00063996605,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.00063996605,
				"type": "PERSON"
			},
			{
				"name": "Ergo",
				"salience": 0.0006217936,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rj0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iceland"
				},
				"name": "Iceland",
				"salience": 0.0006217936,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Muslim",
				"salience": 0.0006217936,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.0006217936,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0006006385,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005939273,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0005939273,
				"type": "PERSON"
			},
			{
				"name": "projects",
				"salience": 0.0005808065,
				"type": "OTHER"
			},
			{
				"name": "projects",
				"salience": 0.0005808065,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00057388673,
				"type": "OTHER"
			},
			{
				"name": "transparency",
				"salience": 0.0005496058,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.00054267823,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.00053824286,
				"type": "OTHER"
			},
			{
				"name": "Citizens",
				"salience": 0.00053824286,
				"type": "PERSON"
			},
			{
				"name": "corporation",
				"salience": 0.00053824286,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizen",
				"salience": 0.00053824286,
				"type": "PERSON"
			},
			{
				"name": "doctrinaires",
				"salience": 0.00053824286,
				"type": "PERSON"
			},
			{
				"name": "structure",
				"salience": 0.00053824286,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.00053824286,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.00053824286,
				"type": "ORGANIZATION"
			},
			{
				"name": "ownership",
				"salience": 0.00053824286,
				"type": "OTHER"
			},
			{
				"name": "billions",
				"salience": 0.0005158302,
				"type": "OTHER"
			},
			{
				"name": "censors",
				"salience": 0.0005142697,
				"type": "OTHER"
			},
			{
				"name": "fake",
				"salience": 0.0004903102,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.00048202282,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.00048202282,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.00048202282,
				"type": "OTHER"
			},
			{
				"name": "detection system",
				"salience": 0.00048202282,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.00048202282,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.00046605256,
				"type": "PERSON"
			},
			{
				"name": "human beings",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00046605256,
				"type": "LOCATION"
			},
			{
				"name": "corruption",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "guardians",
				"salience": 0.00046605256,
				"type": "PERSON"
			},
			{
				"name": "subjects",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "social science",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00046605256,
				"type": "EVENT"
			},
			{
				"name": "circumstances",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "finances",
				"salience": 0.00046605256,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.0004486501,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0004486501,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.00044529422,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00044529422,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.00044529422,
				"type": "WORK_OF_ART"
			},
			{
				"name": "third parties",
				"salience": 0.00044529422,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.00044529422,
				"type": "ORGANIZATION"
			},
			{
				"name": "work",
				"salience": 0.00044529422,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00044529422,
				"type": "OTHER"
			},
			{
				"name": "forums",
				"salience": 0.00041052926,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.00040204133,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.00040204133,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.00040204133,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Warnings",
				"salience": 0.00040204133,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.00040204133,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atlantic_Ocean"
				},
				"name": "Atlantic Ocean",
				"salience": 0.00039384322,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.00034811665,
				"type": "PERSON"
			},
			{
				"name": "Third party verification",
				"salience": 0.00034811665,
				"type": "OTHER"
			},
			{
				"name": "quality",
				"salience": 0.00034811665,
				"type": "OTHER"
			},
			{
				"name": "links",
				"salience": 0.00034811665,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.00034811665,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.00034811665,
				"type": "OTHER"
			},
			{
				"name": "roadmap",
				"salience": 0.00034811665,
				"type": "OTHER"
			},
			{
				"name": "News Feed",
				"salience": 0.00034811665,
				"type": "OTHER"
			},
			{
				"name": "bar",
				"salience": 0.0003393957,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.0003393957,
				"type": "PERSON"
			},
			{
				"name": "Leviathan",
				"salience": 0.0003055897,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.00028680853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.00028680853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d07ph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wikipedia"
				},
				"name": "Wikipedia",
				"salience": 0.00028680853,
				"type": "OTHER"
			},
			{
				"name": "warnings",
				"salience": 0.00021052087,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Mark_Zuckerberg_54968.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-21T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 38,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "3 Shares\n2 0 0 1\n(Credit: Ken Yeung / flickr)\nShortly after Hillary Clinton's crushing defeat, the media came up with another spin: Zuckerberg and Facebook were held responsible for her debacle! What crap! Facebook apparently carried \"fake news\". Didn't the media invent and promote precisely this kind of \"news\" to bounce Hillary over the last hurdle? It's convenient for media whores to blame everybody except themselves and Hillary's corrupt campaign organization for her defeat. Clinton labeled ordinary Americans \"deplorables\", displaying her contempt for half of the population. Hillary Clinton was favorite puppet of the Establishment. She was the embodiment of a hopelessly corrupt political system. And the American people realized it despite massive attempts by media presstitutes to sell her image. An estimated 95 per cent of media outlets beat the drums for her and for her husband's corrupt Clinton Foundation.\nThe real reason behind the attempt to blame Zuckerberg's Facebook is, that it makes everyone (and no one) responsible. What is posted on Facebook can no longer be controlled by the media and the political class. They lost control of public opinion. Established methods of mind-control do not work any longer. The fawning media report only what they are fed by government spin-doctors. It is more comfortable for them to act like the mouthpieces of their masters. This holds true for US media, as well of the media class in the European vassal states. German media were, for example, as manipulative as those in the United States. They celebrated President Obama as the embodiment of \"good America\", ignoring that he waged wars during his entire presidency, incarcerated several whistleblowers and signed off extra-legal executions. But he possessed a great advantage, he was black, or if you wish, non-white. Obama was thus a non-white and smarter version of George W. Bush.\nWhen Mark Zuckerberg visited Berlin in February 2016, he was bootlicked by the German political and media class. The Springer group, the most outspoken mouthpiece of U.S. interests US in Germany, awarded him the Axel Springer Award. Of greater political relevance was the dinner meeting between Zuckerberg and Chancellor Angela Merkel who tried to convince him to apply himself with more determination against so-called hate-speech on the internet. The Merkel regime considers that freedom of speech hurts her policy. Merkel’s minister of justice, Heiko Maas, has established some sort of a private internet police that hunts the web for \"hate speech\", whatever that means.\nThere is no agreed upon definition what \"hate speech\" implies, hence the meaning can be volatile or arbitrarily. The range of \"Hate speech\" can range from anti-Muslim rhetoric via personal insults and threats to a call \"to kill every Jewish Zionist\". There is a duty of government under the \"International Convention for the Abolition of All Forms of Racial Discrimination\", to prohibit the dissemination of racial propaganda. Ergo, there exists a legal and ethical basis for prohibiting certain forms of \"hate speech\".\nEven restrictions to “free speech” extend to other spheres, such as prohibition of deceitful advertising, slandering other people, and in some countries advertising tobacco and alcohol is forbidden in Iceland. Human rights law accepts the right of governments to restrict freedom of speech in order to protect other social values. There is a great deal of jurisprudence regarding the question who to weigh this right against other rights.\nIn Germany, this body of private detectives includes civil society groups such as \"klicksafe.de, \"jugendschutz.net\", \"Gesicht zeigen\" (Show your Face), to name a few. The most eminent of these is the Amadeu Antonio Foundation, run by a former Stasi agent by the name of Anetta Kahane, who claims to fight racism, anti-Semitism, and xenophobia. Today, she and her organization are at the forefront of criticizing people who dare to criticize the excesses of Merkel's policy of government failure.\nInternet giants such as Facebook, Google (and YouTube) and Twitter also participated \"voluntarily\" in this constitutive meeting in which this kind of internet watchdog was set up. In September 2015, this new \"censorship body\" was established in the German Ministry of Justice and works since then without legal basis! The participants agreed on \"best practices\" in handling hate messages. There are no publically known criteria according to which one can recognize \"hate speach\". That means that this censorship body makes it decisions arbitrarily. There are no rules or statutory provisions. Those whose messages are blocked have thus no legal recourse against such censorship. Despite such arbitrary practice, the interim results, which were presented in the Ministry of Justice on 27 September 2016 were not satisfactory. Google (and YouTube) and Facebook representatives participated in the presentation of the results. From August to September, 622 punishable contents were reported that were deleted by the companies. Nevertheless, the Ministry of Justice was not satisfied.\nThus, it is not only the American political class which is blaming Facebook for the defeat of its minion Hillary Clinton but also the German political class and its compliant media that intend to crack down on Facebook, fearing that ordinary people could endanger Merkel's quest for a renewed mandate as Chancellor. But what appears more important is their desperate attempt to control public opinion because the \"deplorables\", i.e. the mass of ordinary people, do not anymore wish to be bamboozled by half a dozen editors-in-chief. The attempt to free themselves from such control has to be crushed with the help of Facebook and Google.\nAt the beginning, Zuckerberg rejected the ridiculous accusations of being responsible for Clinton's defeat. After a while, it appears that he has accepted to do the dirty work for the censors and caved in. On Friday, November 18, 2016, Zuckerberg wrote on Facebook that the amount of \"misinformation is relatively small\", nonetheless there is \"much work ahead on our roadmap\". The following work in progress was outlined by him:\n\"A stronger detection system. The most important thing we can do is to improve our ability to classify misinformation. This means better technical systems to detect what people will flag as false before they do it themselves.\n- Easy reporting. Making it much easier for people to report stories as fake will help us catch more misinformation faster.\n- Third party verification. There are many respected fact checking organizations and, while we have reached out to some, we plan to learn from many more.\n- Warnings. We are exploring labeling stories that have been flagged as false by third parties or our community, and showing warnings when people read or share them.\n- Related articles quality. We are raising the bar for stories that appear in related articles under links in News Feed.\n- Disrupting fake news economics. A lot of misinformation is driven by financially motivated spam. We're looking into disrupting the economics with ads policies like the one we announced earlier this week, and better ad farm detection.\n- Listening. We will continue to work with journalists and others in the news industry to get their input, in particular, to better understand their fact checking systems and learn from them.\"\nApparently, Zuckerberg understands the importance of the issue. I beg to differ. The issue is not about fake news, it is about universal freedom of speech that poses a threat to the mind-control industry, owned by a few families on both sides of the Atlantic Ocean. If they lose this control of public opinion, they rightly fear to lose in the long run their privileges.\nDear Mr. Zuckerberg, take courage, and do not interfere with ordinary folks speaking their minds despite the pressure and intimidation by the political and media class.\nWhen one discusses freedom of expression and the role of Facebook one point needs special scrutiny, namely the private character of this entity. The private character of an entity precludes transparency. Citizens and users do not possess any rights to inspect the finances, let alone participate in determining Facebook projects and policies. As a citizen, one cannot accept that one unelected person, however, nice he may be, could determine the projects and policies of an entity that is now serving billions of human beings. Such a structure just cries for corruption and arbitrary rule. One can see this operating within Wikipedia where doctrinaires exert control over subjects of social science such as the circumstances of 9/11 or the Israel/Palestinian conflict. It's impossible to even insert critical question because they don't pass the censorship of certain guardians of mind control. Google is another such Leviathan that cries for public and transparent ownership. How such public ownership of a global corporation is to be accomplished is a question that begs for an answer. The first step would certainly be for civil society, without influence from the corporate world, to get together and consider a more democratic and transparent structure for such global services. It would be wise for civil society to get going before corporations will establish fake democratic forums to preempt this goal.",
		"thread_title": "Mark Zuckerberg, Don't Get Hoodwinked by Media and Politicians",
		"title": "Mark Zuckerberg, Don't Get Hoodwinked by Media and Politicians",
		"type": "bs",
		"uuid": "3b0238d488e397e5988ec2e26ae5310b32652980"
	},
	"-KhIgSOdvmwRToiydx04": {
		"author": "Prof. Tony Hall",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-22T02:49:50.848+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.2639888,
				"type": "LOCATION"
			},
			{
				"name": "Anthony J.Hall",
				"salience": 0.08219073,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.051612854,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.029151022,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.018173613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Sudbury"
				},
				"name": "University of Sudbury",
				"salience": 0.017583232,
				"type": "ORGANIZATION"
			},
			{
				"name": "institutions",
				"salience": 0.01574945,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.015106569,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0224jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ali_Khamenei"
				},
				"name": "Ayatollah Khamenei",
				"salience": 0.01300198,
				"type": "PERSON"
			},
			{
				"name": "protections",
				"salience": 0.011391529,
				"type": "OTHER"
			},
			{
				"name": "learning",
				"salience": 0.011391529,
				"type": "OTHER"
			},
			{
				"name": "environments",
				"salience": 0.010288949,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.007766586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.006078568,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01trsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Nations"
				},
				"name": "First Nations",
				"salience": 0.0060691833,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.0057771644,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04kkgm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bowl"
				},
				"name": "The Bowl",
				"salience": 0.005753683,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crackdown",
				"salience": 0.0052617444,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01bqvp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sky"
				},
				"name": "Sky",
				"salience": 0.0052136853,
				"type": "ORGANIZATION"
			},
			{
				"name": "freedom",
				"salience": 0.0051888335,
				"type": "OTHER"
			},
			{
				"name": "Joshua Blakeney",
				"salience": 0.005119766,
				"type": "PERSON"
			},
			{
				"name": "basis",
				"salience": 0.0050549484,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.004513523,
				"type": "EVENT"
			},
			{
				"name": "universities",
				"salience": 0.0043545514,
				"type": "ORGANIZATION"
			},
			{
				"name": "tenure",
				"salience": 0.0040756906,
				"type": "OTHER"
			},
			{
				"name": "accord",
				"salience": 0.0038974017,
				"type": "OTHER"
			},
			{
				"name": "conferences",
				"salience": 0.0037199247,
				"type": "EVENT"
			},
			{
				"name": "first",
				"salience": 0.0037161824,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0035033883,
				"type": "EVENT"
			},
			{
				"name": "Kevin Barrett",
				"salience": 0.0033613807,
				"type": "PERSON"
			},
			{
				"name": "Professor",
				"salience": 0.0032759842,
				"type": "PERSON"
			},
			{
				"name": "Part",
				"salience": 0.00319198,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0030289455,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0029489826,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.002812501,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/079fm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Global_studies"
				},
				"name": "Globalization Studies",
				"salience": 0.0027181194,
				"type": "OTHER"
			},
			{
				"name": "viewpoints",
				"salience": 0.0026683875,
				"type": "OTHER"
			},
			{
				"name": "viewpoints",
				"salience": 0.0026627735,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0026627735,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.0026627735,
				"type": "OTHER"
			},
			{
				"name": "Alberta Canada",
				"salience": 0.0026410434,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01f7jt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Back_to_the_Future_Part_II"
				},
				"name": "Part II",
				"salience": 0.0025874444,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Property",
				"salience": 0.0024959294,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0024959294,
				"type": "OTHER"
			},
			{
				"name": "Property",
				"salience": 0.0024959294,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.0024959294,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.0024959294,
				"type": "OTHER"
			},
			{
				"name": "Wars",
				"salience": 0.0024440791,
				"type": "OTHER"
			},
			{
				"name": "tour de force",
				"salience": 0.002382896,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0023232428,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.002305877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "books",
				"salience": 0.002305877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "process",
				"salience": 0.002305877,
				"type": "OTHER"
			},
			{
				"name": "Queen",
				"salience": 0.002305877,
				"type": "PERSON"
			},
			{
				"name": "Dr.",
				"salience": 0.002305877,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.002305877,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.002305877,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.002305877,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0c9t7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples"
				},
				"name": "Native",
				"salience": 0.002158388,
				"type": "PERSON"
			},
			{
				"name": "essay",
				"salience": 0.0021415,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Journal",
				"salience": 0.0021355015,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.0020864278,
				"type": "OTHER"
			},
			{
				"name": "edition",
				"salience": 0.0020820373,
				"type": "WORK_OF_ART"
			},
			{
				"name": "culmination",
				"salience": 0.002020846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/052nd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McGill_University"
				},
				"name": "McGill",
				"salience": 0.0018690502,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Bowl with One Spoon",
				"salience": 0.0018690502,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/020k9m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Meech_Lake_Accord"
				},
				"name": "Meech Lake accord",
				"salience": 0.0018679536,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0018277239,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0894zw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McGill-Queen's_University_Press"
				},
				"name": "McGill-Queen's University Press",
				"salience": 0.0018154331,
				"type": "ORGANIZATION"
			},
			{
				"name": "arbitration",
				"salience": 0.0018029278,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.0018029278,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.0018029278,
				"type": "OTHER"
			},
			{
				"name": "Decolonization",
				"salience": 0.0018029278,
				"type": "OTHER"
			},
			{
				"name": "Capitalism",
				"salience": 0.0018029278,
				"type": "OTHER"
			},
			{
				"name": "rank",
				"salience": 0.0018029278,
				"type": "OTHER"
			},
			{
				"name": "classroom",
				"salience": 0.0018029278,
				"type": "LOCATION"
			},
			{
				"name": "catastrophe",
				"salience": 0.0018029278,
				"type": "OTHER"
			},
			{
				"name": "peer review",
				"salience": 0.0018029278,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0017798161,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0016939383,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.0016800524,
				"type": "LOCATION"
			},
			{
				"name": "treatment",
				"salience": 0.001673906,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0016197895,
				"type": "PERSON"
			},
			{
				"name": "seed",
				"salience": 0.0015980782,
				"type": "OTHER"
			},
			{
				"name": "Khamenei.ir Professor Hall",
				"salience": 0.0015364321,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01y6kt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laurentian_University"
				},
				"name": "Laurentian University",
				"salience": 0.0014964628,
				"type": "ORGANIZATION"
			},
			{
				"name": "study",
				"salience": 0.001480968,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0014414588,
				"type": "OTHER"
			},
			{
				"name": "subjects",
				"salience": 0.0014271255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dywm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northern_Ontario"
				},
				"name": "Northern",
				"salience": 0.0014194035,
				"type": "LOCATION"
			},
			{
				"name": "One Spoon",
				"salience": 0.0014194035,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06sx5v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hassan_Rouhani"
				},
				"name": "Rouhani",
				"salience": 0.0013930191,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0013825818,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0013609782,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.001302402,
				"type": "OTHER"
			},
			{
				"name": "peers",
				"salience": 0.0012939661,
				"type": "PERSON"
			},
			{
				"name": "understanding",
				"salience": 0.0012939661,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0012815775,
				"type": "LOCATION"
			},
			{
				"name": "professor",
				"salience": 0.0012659453,
				"type": "PERSON"
			},
			{
				"name": "Professor",
				"salience": 0.0012659453,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.0012659453,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.0012573573,
				"type": "ORGANIZATION"
			},
			{
				"name": "universities",
				"salience": 0.0012573573,
				"type": "ORGANIZATION"
			},
			{
				"name": "parliamentarian",
				"salience": 0.0012456639,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hzt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Holocaust"
				},
				"name": "Holocaust",
				"salience": 0.0012338463,
				"type": "EVENT"
			},
			{
				"name": "M'bala M'bala Dieudonné",
				"salience": 0.001207107,
				"type": "PERSON"
			},
			{
				"name": "universities",
				"salience": 0.0012025806,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0011578705,
				"type": "LOCATION"
			},
			{
				"name": "law",
				"salience": 0.0011456911,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0011286847,
				"type": "OTHER"
			},
			{
				"name": "American Herald Tribune",
				"salience": 0.0011097321,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02gx51",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Library_Association"
				},
				"name": "American Library Association",
				"salience": 0.0011097321,
				"type": "ORGANIZATION"
			},
			{
				"name": "The UK Independent",
				"salience": 0.0011097321,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fourth World",
				"salience": 0.0011097321,
				"type": "OTHER"
			},
			{
				"name": "Northern Series",
				"salience": 0.0011097321,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01fhr0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_imperialism"
				},
				"name": "American Empire",
				"salience": 0.0011097321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Toronto"
				},
				"name": "University of Toronto",
				"salience": 0.0011038003,
				"type": "ORGANIZATION"
			},
			{
				"name": "History",
				"salience": 0.0010961951,
				"type": "OTHER"
			},
			{
				"name": "historian",
				"salience": 0.0010961951,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02kw88",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Canada"
				},
				"name": "Western Canada",
				"salience": 0.0010872444,
				"type": "LOCATION"
			},
			{
				"name": "strength",
				"salience": 0.0010786321,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.0010728572,
				"type": "OTHER"
			},
			{
				"name": "amendment",
				"salience": 0.0010719831,
				"type": "OTHER"
			},
			{
				"name": "First Ministers",
				"salience": 0.0010690751,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01bw2f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aboriginal_peoples_in_Canada"
				},
				"name": "Aboriginal",
				"salience": 0.0010690751,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.0010640904,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0010632236,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.0010274737,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.0010274737,
				"type": "OTHER"
			},
			{
				"name": "conferences",
				"salience": 0.0010274737,
				"type": "EVENT"
			},
			{
				"name": "universities",
				"salience": 0.001026448,
				"type": "ORGANIZATION"
			},
			{
				"name": "universities",
				"salience": 0.001026448,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01f_2q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/B'nai_B'rith"
				},
				"name": "B'nai Brith",
				"salience": 0.0010161949,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j95",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alberta"
				},
				"name": "Alberta",
				"salience": 0.0010072532,
				"type": "LOCATION"
			},
			{
				"name": "collaboration",
				"salience": 0.0009942487,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0009914322,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.0009491989,
				"type": "PERSON"
			},
			{
				"name": "entity",
				"salience": 0.0009442985,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02wrkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Academic_freedom"
				},
				"name": "Academic Freedom",
				"salience": 0.00093412865,
				"type": "OTHER"
			},
			{
				"name": "participation",
				"salience": 0.00092139794,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.00092139794,
				"type": "PERSON"
			},
			{
				"name": "colleague",
				"salience": 0.00092139794,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.0009131239,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00090161606,
				"type": "OTHER"
			},
			{
				"name": "quest",
				"salience": 0.00090161606,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0008869988,
				"type": "OTHER"
			},
			{
				"name": "instrument",
				"salience": 0.0008869988,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0008869988,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.00085761555,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0008570165,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0008570165,
				"type": "OTHER"
			},
			{
				"name": "appointment",
				"salience": 0.0008570165,
				"type": "EVENT"
			},
			{
				"name": "appointment",
				"salience": 0.0008570165,
				"type": "EVENT"
			},
			{
				"name": "bases",
				"salience": 0.0008570165,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00085442414,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.00085442414,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.000836232,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.000836232,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.0008256214,
				"type": "OTHER"
			},
			{
				"name": "present",
				"salience": 0.0008194225,
				"type": "OTHER"
			},
			{
				"name": "presentations",
				"salience": 0.0008194225,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.0008151919,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.00081177923,
				"type": "OTHER"
			},
			{
				"name": "interactions",
				"salience": 0.00081177923,
				"type": "OTHER"
			},
			{
				"name": "intervention",
				"salience": 0.00081177923,
				"type": "EVENT"
			},
			{
				"name": "activist",
				"salience": 0.00081177923,
				"type": "PERSON"
			},
			{
				"name": "secret",
				"salience": 0.00079067005,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00078147143,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.00078147143,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00078147143,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.00078147143,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.000780705,
				"type": "OTHER"
			},
			{
				"name": "Mind Control Contaminates",
				"salience": 0.00077834347,
				"type": "OTHER"
			},
			{
				"name": "university",
				"salience": 0.00076674466,
				"type": "ORGANIZATION"
			},
			{
				"name": "universities",
				"salience": 0.00076674466,
				"type": "ORGANIZATION"
			},
			{
				"name": "obstacles",
				"salience": 0.00076456583,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.00076456583,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.00076177076,
				"type": "ORGANIZATION"
			},
			{
				"name": "publishing project",
				"salience": 0.00076115015,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0007521699,
				"type": "PERSON"
			},
			{
				"name": "colleagues",
				"salience": 0.0007521699,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0007521699,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0007454151,
				"type": "OTHER"
			},
			{
				"name": "University Suspension",
				"salience": 0.00074208487,
				"type": "EVENT"
			},
			{
				"name": "Mounting Assault",
				"salience": 0.00074208487,
				"type": "EVENT"
			},
			{
				"name": "prospects",
				"salience": 0.00074208487,
				"type": "OTHER"
			},
			{
				"name": "phrase",
				"salience": 0.00074208487,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.00074208487,
				"type": "OTHER"
			},
			{
				"name": "Chair",
				"salience": 0.00074208487,
				"type": "PERSON"
			},
			{
				"name": "invitation",
				"salience": 0.00074208487,
				"type": "OTHER"
			},
			{
				"name": "graduate school",
				"salience": 0.00074208487,
				"type": "ORGANIZATION"
			},
			{
				"name": "province",
				"salience": 0.00074208487,
				"type": "LOCATION"
			},
			{
				"name": "hope",
				"salience": 0.00074208487,
				"type": "OTHER"
			},
			{
				"name": "contributions",
				"salience": 0.0007398401,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.0007398401,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.0007398401,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0007360203,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadians",
				"salience": 0.00073379837,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.0007245455,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0007245455,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0007245455,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.0007203485,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0007203485,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.0007203485,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0007203485,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.0007203485,
				"type": "EVENT"
			},
			{
				"name": "treatment",
				"salience": 0.0007203485,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.0006934534,
				"type": "OTHER"
			},
			{
				"name": "accord",
				"salience": 0.0006934534,
				"type": "OTHER"
			},
			{
				"name": "career move",
				"salience": 0.00069127535,
				"type": "EVENT"
			},
			{
				"name": "promotion process",
				"salience": 0.0006654655,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0006654655,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0006654655,
				"type": "EVENT"
			},
			{
				"name": "peoples",
				"salience": 0.0006654655,
				"type": "PERSON"
			},
			{
				"name": "treaty rights",
				"salience": 0.0006650006,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.0006626795,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0006626795,
				"type": "LOCATION"
			},
			{
				"name": "subject",
				"salience": 0.0006626795,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0006626795,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0006626795,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0006488718,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0006488718,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0006488718,
				"type": "OTHER"
			},
			{
				"name": "Quote",
				"salience": 0.0006412649,
				"type": "OTHER"
			},
			{
				"name": "ratification",
				"salience": 0.0006406191,
				"type": "OTHER"
			},
			{
				"name": "essays",
				"salience": 0.0006406191,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Department",
				"salience": 0.0006406191,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.0006406191,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.00063316576,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.00063316576,
				"type": "OTHER"
			},
			{
				"name": "Lethbridge Alberta",
				"salience": 0.0006323599,
				"type": "LOCATION"
			},
			{
				"name": "transition",
				"salience": 0.00063210283,
				"type": "OTHER"
			},
			{
				"name": "Lethbridge University",
				"salience": 0.00063172856,
				"type": "ORGANIZATION"
			},
			{
				"name": "answers",
				"salience": 0.0006292788,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.00062737515,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00062737515,
				"type": "EVENT"
			},
			{
				"name": "deal",
				"salience": 0.0006241359,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06xrp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_American_studies"
				},
				"name": "Native American Studies",
				"salience": 0.0006151868,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.00060850184,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0006008322,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0006008322,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0006008322,
				"type": "OTHER"
			},
			{
				"name": "promotion",
				"salience": 0.0006008322,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0006008322,
				"type": "OTHER"
			},
			{
				"name": "tenure",
				"salience": 0.0006008322,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0006008322,
				"type": "ORGANIZATION"
			},
			{
				"name": "position",
				"salience": 0.0006008322,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.0006008322,
				"type": "OTHER"
			},
			{
				"name": "faculty member",
				"salience": 0.0006008322,
				"type": "PERSON"
			},
			{
				"name": "journalists",
				"salience": 0.0006008322,
				"type": "PERSON"
			},
			{
				"name": "collaboration",
				"salience": 0.00059109036,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00058803835,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.00058803835,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.00058803835,
				"type": "OTHER"
			},
			{
				"name": "Department of Native American Studies",
				"salience": 0.0005841793,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01x42h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greater_Sudbury"
				},
				"name": "Sudbury",
				"salience": 0.0005841793,
				"type": "LOCATION"
			},
			{
				"name": "Native Studies Department",
				"salience": 0.0005841793,
				"type": "ORGANIZATION"
			},
			{
				"name": "subject",
				"salience": 0.00057995523,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.0005783985,
				"type": "EVENT"
			},
			{
				"name": "encounter",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "colonialism",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "committees",
				"salience": 0.0005783985,
				"type": "ORGANIZATION"
			},
			{
				"name": "veto power",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "encouragement",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.0005783985,
				"type": "WORK_OF_ART"
			},
			{
				"name": "treaty rights",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "characteristic",
				"salience": 0.0005783985,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0005618482,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0005618482,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0005618482,
				"type": "ORGANIZATION"
			},
			{
				"name": "universities",
				"salience": 0.0005583891,
				"type": "ORGANIZATION"
			},
			{
				"name": "Universities",
				"salience": 0.0005583891,
				"type": "ORGANIZATION"
			},
			{
				"name": "universities",
				"salience": 0.0005583891,
				"type": "ORGANIZATION"
			},
			{
				"name": "universities",
				"salience": 0.0005583891,
				"type": "ORGANIZATION"
			},
			{
				"name": "exchange",
				"salience": 0.00054323405,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00054323405,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00054323405,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rq04",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Constitution_Act,_1982"
				},
				"name": "Constitution Act",
				"salience": 0.00052743946,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/074sxr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Section_Thirty-five_of_the_Constitution_Act,_1982"
				},
				"name": "Section 35",
				"salience": 0.00052743946,
				"type": "OTHER"
			},
			{
				"name": "spiral",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.0005202503,
				"type": "LOCATION"
			},
			{
				"name": "foot",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "indicator",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.0005202503,
				"type": "WORK_OF_ART"
			},
			{
				"name": "security",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "blockages",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "shaping",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "geopolitics",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "turf",
				"salience": 0.0005202503,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0005202503,
				"type": "LOCATION"
			},
			{
				"name": "opposition",
				"salience": 0.00050307246,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "text",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "making",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "Due Diligence",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "framework",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "formulation",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "awareness",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "federalism",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "implications",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.00050082477,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.00050082477,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "law",
				"salience": 0.0004949976,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0004949976,
				"type": "LOCATION"
			},
			{
				"name": "surrender",
				"salience": 0.0004945121,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "openness",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "obstacles",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0004904704,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0317b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fatherland"
				},
				"name": "Mother Country",
				"salience": 0.0004809413,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01yx1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Wisconsin%E2%80%93Madison"
				},
				"name": "University of Wisconsin",
				"salience": 0.00047187702,
				"type": "ORGANIZATION"
			},
			{
				"name": "subjects",
				"salience": 0.00047050856,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025lh8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elijah_Harper"
				},
				"name": "Elijah Harper",
				"salience": 0.0004687716,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.00046862505,
				"type": "EVENT"
			},
			{
				"name": "view",
				"salience": 0.00046862505,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.00046862505,
				"type": "EVENT"
			},
			{
				"name": "volumes",
				"salience": 0.0004662053,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00046457796,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.00045827214,
				"type": "EVENT"
			},
			{
				"name": "Canadian Universities Creating an Anti-Muslim Bias",
				"salience": 0.00045669914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ksh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottawa"
				},
				"name": "Ottawa",
				"salience": 0.00045669914,
				"type": "LOCATION"
			},
			{
				"name": "Ph.D. Supervisor",
				"salience": 0.00045669914,
				"type": "PERSON"
			},
			{
				"name": "Leroy Little Bear",
				"salience": 0.00045669914,
				"type": "OTHER"
			},
			{
				"name": "J.M.S.",
				"salience": 0.00045669914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ps4ry"
				},
				"name": "Jesuit",
				"salience": 0.00045669914,
				"type": "ORGANIZATION"
			},
			{
				"name": "aspect",
				"salience": 0.00045249576,
				"type": "OTHER"
			},
			{
				"name": "ceremonies",
				"salience": 0.00045249576,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01k1xh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Land_of_Israel"
				},
				"name": "Eretz Israel",
				"salience": 0.00044332066,
				"type": "LOCATION"
			},
			{
				"name": "Greater Israel",
				"salience": 0.00044332066,
				"type": "ORGANIZATION"
			},
			{
				"name": "expression",
				"salience": 0.0004392404,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0004392404,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0004392404,
				"type": "OTHER"
			},
			{
				"name": "academy",
				"salience": 0.0004392404,
				"type": "ORGANIZATION"
			},
			{
				"name": "research",
				"salience": 0.0004392404,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0004392404,
				"type": "OTHER"
			},
			{
				"name": "achievement",
				"salience": 0.00042468763,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.00042468763,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00042468763,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00042468763,
				"type": "PERSON"
			},
			{
				"name": "core",
				"salience": 0.00042468763,
				"type": "OTHER"
			},
			{
				"name": "inclination",
				"salience": 0.00042468763,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00042468763,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00042468763,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00042283925,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.00040916319,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.00040916319,
				"type": "ORGANIZATION"
			},
			{
				"name": "colleagues",
				"salience": 0.00040916319,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gqgt3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/War_on_Terror"
				},
				"name": "Global War on Terror",
				"salience": 0.00040782648,
				"type": "EVENT"
			},
			{
				"name": "speech",
				"salience": 0.00040577177,
				"type": "EVENT"
			},
			{
				"name": "exchange",
				"salience": 0.00040577177,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00040577177,
				"type": "OTHER"
			},
			{
				"name": "higher learning",
				"salience": 0.00040577177,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00040577177,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00040577177,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00039413437,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00039413437,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00039413437,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.000391014,
				"type": "OTHER"
			},
			{
				"name": "input",
				"salience": 0.00038370478,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.00038370478,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.00037166866,
				"type": "EVENT"
			},
			{
				"name": "litigation",
				"salience": 0.00037166866,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01sq7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohawk_people"
				},
				"name": "Mohawk",
				"salience": 0.00036976126,
				"type": "LOCATION"
			},
			{
				"name": "condition",
				"salience": 0.00036635794,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00036635794,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00036635794,
				"type": "OTHER"
			},
			{
				"name": "pedagogy",
				"salience": 0.00036635794,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.00036635794,
				"type": "OTHER"
			},
			{
				"name": "subjects",
				"salience": 0.00036047722,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.00036047722,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00035697105,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c3b0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Legislature"
				},
				"name": "Legislature",
				"salience": 0.0003559541,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Public Sphere Section 35",
				"salience": 0.0003559541,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interest",
				"salience": 0.0003470167,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00034562752,
				"type": "PERSON"
			},
			{
				"name": "studies",
				"salience": 0.00034442102,
				"type": "OTHER"
			},
			{
				"name": "take",
				"salience": 0.0003423064,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.0003412708,
				"type": "OTHER"
			},
			{
				"name": "discoveries",
				"salience": 0.0003412708,
				"type": "EVENT"
			},
			{
				"name": "discourse",
				"salience": 0.0003412708,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0003412708,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.00034081654,
				"type": "OTHER"
			},
			{
				"name": "war criminals",
				"salience": 0.0003354733,
				"type": "PERSON"
			},
			{
				"name": "war criminal",
				"salience": 0.0003354733,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.0003354733,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0003354733,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.0003354733,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0003354733,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0003354733,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.0003337311,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.00033227852,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.0003310033,
				"type": "LOCATION"
			},
			{
				"name": "references",
				"salience": 0.0003295243,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.00032016638,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.00032016638,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.00032016638,
				"type": "LOCATION"
			},
			{
				"name": "New Horizon",
				"salience": 0.00032016638,
				"type": "LOCATION"
			},
			{
				"name": "academia",
				"salience": 0.00031987086,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.00031987086,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00031987086,
				"type": "OTHER"
			},
			{
				"name": "holocaust",
				"salience": 0.00031987086,
				"type": "EVENT"
			},
			{
				"name": "debate",
				"salience": 0.00031987086,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00031987086,
				"type": "OTHER"
			},
			{
				"name": "proponents",
				"salience": 0.00031987086,
				"type": "PERSON"
			},
			{
				"name": "academy",
				"salience": 0.00031987086,
				"type": "ORGANIZATION"
			},
			{
				"name": "publication",
				"salience": 0.00031987086,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.00031987086,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.00031987086,
				"type": "OTHER"
			},
			{
				"name": "Leader",
				"salience": 0.00031864326,
				"type": "PERSON"
			},
			{
				"name": "cartoons",
				"salience": 0.00031721947,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00031721947,
				"type": "LOCATION"
			},
			{
				"name": "essence",
				"salience": 0.00031721947,
				"type": "OTHER"
			},
			{
				"name": "hypocrisy",
				"salience": 0.00031721947,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00031721947,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.00031721947,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00031721947,
				"type": "EVENT"
			},
			{
				"name": "advocates",
				"salience": 0.00031721947,
				"type": "PERSON"
			},
			{
				"name": "channels",
				"salience": 0.00031721947,
				"type": "OTHER"
			},
			{
				"name": "invasions",
				"salience": 0.00031721947,
				"type": "EVENT"
			},
			{
				"name": "sanctities",
				"salience": 0.00031721947,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.00031721947,
				"type": "EVENT"
			},
			{
				"name": "caricatures",
				"salience": 0.00031721947,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.00031721947,
				"type": "EVENT"
			},
			{
				"name": "license",
				"salience": 0.00031721947,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00031066066,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02hwxxz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oji-Cree_language"
				},
				"name": "Oji-Cree",
				"salience": 0.00030821093,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04s7y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manitoba"
				},
				"name": "Manitoba",
				"salience": 0.00030821093,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00030821093,
				"type": "LOCATION"
			},
			{
				"name": "instance",
				"salience": 0.0003056231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North America",
				"salience": 0.0003046246,
				"type": "LOCATION"
			},
			{
				"name": "We Are Charlie Hebdo",
				"salience": 0.0003046246,
				"type": "OTHER"
			},
			{
				"name": "prohibitions",
				"salience": 0.0003015247,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.00029772386,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.00029549684,
				"type": "PERSON"
			},
			{
				"name": "rationality",
				"salience": 0.00029549684,
				"type": "OTHER"
			},
			{
				"name": "rationality",
				"salience": 0.00029549684,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00028660637,
				"type": "LOCATION"
			},
			{
				"name": "gift",
				"salience": 0.00028426375,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.00027821006,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.00026899198,
				"type": "OTHER"
			},
			{
				"name": "gifts",
				"salience": 0.00026679333,
				"type": "OTHER"
			},
			{
				"name": "endeavor",
				"salience": 0.00026679333,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.00026679333,
				"type": "OTHER"
			},
			{
				"name": "endeavor",
				"salience": 0.00026679333,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.00026029142,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02st53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Winnipeg"
				},
				"name": "University of Winnipeg",
				"salience": 0.0002566786,
				"type": "ORGANIZATION"
			},
			{
				"name": "view",
				"salience": 0.00025490954,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobia",
				"salience": 0.00024971142,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.00024971142,
				"type": "OTHER"
			},
			{
				"name": "military conflicts",
				"salience": 0.00023892456,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.00023892456,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00023892456,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.00023220715,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.00023100805,
				"type": "EVENT"
			},
			{
				"name": "equivalent",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "holocaust denial",
				"salience": 0.00023100805,
				"type": "EVENT"
			},
			{
				"name": "Creator",
				"salience": 0.00023100805,
				"type": "PERSON"
			},
			{
				"name": "development",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "observation",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "teaching",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "censorship",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "coin",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "receptiveness",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "elaboration",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "thought police agents",
				"salience": 0.00023100805,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.00023100805,
				"type": "EVENT"
			},
			{
				"name": "conception",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "symbols",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "state of affairs",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00023100805,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04s9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_in_Islam"
				},
				"name": "Prophet Mohammed",
				"salience": 0.00022545499,
				"type": "PERSON"
			},
			{
				"name": "foundation",
				"salience": 0.00022238163,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00022071812,
				"type": "PERSON"
			},
			{
				"name": "line",
				"salience": 0.00022071812,
				"type": "OTHER"
			},
			{
				"name": "protagonists",
				"salience": 0.00022071812,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00021622203,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06zpqzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimes_Against_Humanity_and_War_Crimes_Act"
				},
				"name": "Crimes Against Humanity and War Crimes Act",
				"salience": 0.00020644785,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.00019927783,
				"type": "EVENT"
			},
			{
				"name": "legislation",
				"salience": 0.00019927783,
				"type": "WORK_OF_ART"
			},
			{
				"name": "justice",
				"salience": 0.00019927783,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.00019927783,
				"type": "OTHER"
			},
			{
				"name": "pedagogy",
				"salience": 0.00019927783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.00019521409,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00019521409,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04k84",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Light"
				},
				"name": "Lights",
				"salience": 0.00019521409,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.00019521409,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01s105",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cabinetry"
				},
				"name": "Cabinet",
				"salience": 0.00019521409,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01r32",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calgary"
				},
				"name": "Calgary",
				"salience": 0.0001941716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.00018721948,
				"type": "PERSON"
			},
			{
				"name": "inquiry",
				"salience": 0.00018152971,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00017924137,
				"type": "OTHER"
			},
			{
				"name": "Israel First",
				"salience": 0.00017374543,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01yvs_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iranian_Revolution"
				},
				"name": "Islamic Revolution",
				"salience": 0.00017349786,
				"type": "OTHER"
			},
			{
				"name": "covenants",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.00017254792,
				"type": "PERSON"
			},
			{
				"name": "conventions",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "haven",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "exhibit",
				"salience": 0.00017254792,
				"type": "EVENT"
			},
			{
				"name": "peace",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "pushback",
				"salience": 0.00017254792,
				"type": "EVENT"
			},
			{
				"name": "engagement",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "victor",
				"salience": 0.00017254792,
				"type": "PERSON"
			},
			{
				"name": "enforcement",
				"salience": 0.00017254792,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.00017113752,
				"type": "OTHER"
			},
			{
				"name": "humor",
				"salience": 0.00017037279,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025qg4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Leader_of_Iran"
				},
				"name": "Supreme Leader",
				"salience": 0.00016418114,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00014215865,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09v0gf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sevens_(card_game)"
				},
				"name": "Parliament",
				"salience": 0.00012263184,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.00011209453,
				"type": "OTHER"
			},
			{
				"name": "Tried For International Crimes",
				"salience": 0.00010618238,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.00010618238,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Anthony_Hall_Lecturing_0e201.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-21T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 36.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "If academic freedom is not to be respected in institutions of supposedly higher learning then there can be no basis for freedom of speech in environments not subject to the protections of tenure. The first to suffer the crackdown in universities will be our students. 2 Shares\n1 0 0 1\nDr. Anthony J.Hall is a Professor of Globalization Studies at the in Alberta Canada. Professor Hall is the editor-in-chief of the American Herald Tribune. He is author of several books, including a two-volume publishing project at McGill-Queen’s University Press entitled “The Bowl with One Spoon”; American Empire and the Fourth World: The Bowl with One Spoon, Part I (McGill-Queen’s Native and Northern) Earth into Property: Colonization, Decolonization, and Capitalism: The Bowl with One Spoon, Part II (Mcgill-Queen’s Native and Northern Series). The Part II edition was recently selected by The UK Independent as one of the best books of 2010. The Journal of the American Library Association called Earth into Property, “A scholarly tour de force.” The books aim to set the 9/11 catastrophe and post 9/11 Wars in the context of global history, since 1492. Dr. Hall has been suspended and harshly pulled from his classroom, in mid-term without any process of arbitration: namely, for having expressed his viewpoints on Israeli crimes, calling for an open debate on the Holocaust and 9/11, despite being promoted to a Full Professor rank through a process of peer review. In an exclusive interview with Khamenei.ir Professor Hall elaborates on how academic freedom is perceived and practiced in the West:\nAyatollah Khamenei has stated that “genuine freedom of thought will help the country to progress. In the absence of a free intellectual atmosphere, there can be no opportunity for growth.” How do you– as a Professor– perceive it?\nI reflected very self-consciously on the prospects of contributing to the progress of my country Canada when I opted in the mid to late 1970s to go to graduate school at the University of Toronto. With the great Canadian historian, J.M.S. Careless, as my Ph.D. Supervisor I made a commitment to study the history of colonial relations with the First Nations of Canada. My course of study took me in 1982 to my first appointment in the Native Studies Department at the University of Sudbury. The University of Sudbury was in those years a Jesuit-run entity. It formed the institutional seed from which the secular Laurentian University would emerge in the decades prior to my appointment there.\nFor the next two decades I was able to work from my academic bases in Sudbury and then in Lethbridge Alberta beginning in 1990. At the invitation of the Leroy Little Bear, the Chair of the Department of Native American Studies I thus moved to the resource-rich province of Alberta. Once again I was motivated to make the transition in my professional work with the hope my I could contribute constructively to the progress of our country from an academic base in Western Canada.\nIn my years as a young professor I took an active part in four First Nations/First Ministers conferences that took place in Ottawa between 1983 and 1987. The purpose of these conferences was to negotiate a constitutional amendment to give greater definition to the phrase, “ the existing Aboriginal and treaty rights of the Aboriginal peoples of Canada are hereby recognized and affirmed.” (Section 35, Constitution Act, 1982) .\nMORE... The B'nai Brith and the History of the Mounting Assault on Academic Freedom in Canadian Universities Creating an Anti-Muslim Bias at a Canadian University Suspension of Tenured Professor Lacks Due Diligence Toxic Mind Control Contaminates The Public Sphere Section 35 was part of the text of the instrument facilitating the movement of authority over Canada’s constitutional structure from the British imperial Mother Country to the domestic institutions of Canadian federalism.\nThe culmination of my contributions to the formulation of a made-in-Canada version of the Canadian constitution involved my opposition between 1987 and 1990 to what became known as the Meech Lake accord. If this political deal between Canada’s First Ministers had become constitutional law, the First Nations of Canada would have been excluded from a very powerful legal definition of Canada’s “fundamental characteristic.”\nIn academic essays, in the mainstream media and in presentations to various legislative committees, I contributed to public awareness of the negative implications of the Meech Lake accord for fair-minded Canadians supportive of existing Aboriginal and treaty rights. More specifically I contributed to the strength of the platform from which an Oji-Cree parliamentarian by the name of Elijah Harper used his veto power in the Manitoba Legislature to block the ratification of the Meech Lake accord. Because of Elijah Harper’s actions the Meech Lake accord did not become part of Canada’s “supreme law.”\nI was able to contribute to discourse crucial to the progress of Canada until about the year 2000. Between 2000 and 2002 I had to adjust my work away from the activities of the Department of Native American Studies towards a field of my own making, Globalization Studies. I prepared two academic volumes to lay the academic foundation and methodological framework for my transition to a new academic role. The core focus of my emphasis on “Globalization Studies” was Indigenous peoples in encounter with colonialism globally from 1492 until the present.\nIt is in this context and with the encouragement of my very accomplished student, Joshua Blakeney, that I began to shift focus towards the treatment of Palestinian and other Arab peoples in the region of Greater Israel, Eretz Israel. It was Joshua who also led me to my first interactions with Iranian journalists resulting in my participation in the New Horizon conference of the autumn of 2014. As I have described in writing elsewhere this episode proved to make a major positive impact on me.\nDue to the intervention of my colleague, the Mohawk activist Splitting The Sky, I also began to see the events of 9/11 as a major factor in the shaping of the global geopolitics in the twenty-first century.\nMy quest for new academic turf at the has sometimes been bumpy and contested. Certainly many major obstacles were put in the way of my promotion to full professor. Eventually my academic peers were allowed to make their input into the promotion process apart from the artificial blockages thrown up by my University administration. In 2008 after what I took to be my obtaining a position of intellectual and professional security as a senior faculty member, I resolved that henceforth I would pursue difficult lines of research and publication. I made this decision with an understanding that less secure younger colleagues might eschew such a course of action.\nI have made no secret of the fact that I see the recent surrender of the high ground of academic freedom by the members of the administration of the as an indicator that Canada is on a downwards spiral. It seems to me there is a move a foot to sabotage the intellectual freedom of our universities. If academic freedom is not to be respected in institutions of supposedly higher learning, then there can be no basis for freedom of speech in environments not subject to the protections of tenure.\nThe first to suffer the crackdown in universities will be our students. They will have to deal with the fact that the treatment visited on me indicates it has become dangerous to ask pointed questions which might produce answers embarrassing to power. Our country, Canada, cannot progress to higher levels of discourse and achievement under these repressive conditions.\nAyatollah Khamenei believes “exchanging viewpoints and opinions are in the nature of academic work”; How is this principle practiced at Lethbridge University?\nI agree that exchanging viewpoints and opinions is a central aspect of academic work within universities and between universities. I found that there was a good deal of openness to the exchange of information and ideas with colleagues, media and public officials in the years between 1982 and 2001 when the core of my academic work revolved around the history of Canada-First Nations relations.\nUnfortunately I would have to say that the obstacles to the exchange of information and ideas began to mount significantly after 2008 when I began to question the official narrative of what happened on 9/11. Who really did what to whom during the initiating events of what soon became known as the Global War on Terror? As I began to become skeptical of the official narrative I noticed more and more inclination on the part of colleagues to distance themselves from the subjects that captured my professional interest. To put it bluntly, I suppose it became clear to me that, for a number of reasons, it was not a good career move for younger colleagues to show interest in the subject of 9/11 specifically and false flag terrorism more generally.\nAs I began to look more deeply into the existing research on 9/11 I was simultaneously drawn to the subject of war crimes and international law. My collaboration with Splitting The Sky became more intense when we went to work to organize in response to the decision of the former US President, George W. Bush, to give a talk in Calgary in 2009 as his first public engagement as (theoretically) a regular civilian citizen. Our collective action in Calgary in the spring of 2009 led to a trial that we dubbed Splitting The Sky versus George W. Bush . Although I had not yet associated the lies and crimes of 9/11 with Israel First protagonists, I ran into my first Zionist pushback for my 9/11 studies when I presented my essay, “Should George W. Bush Be Arrested in Calgary, Alberta, To Be Tried For International Crimes?” I originally presented the paper at an invited talk at the University of Winnipeg.\nMy essay eventually ended up as an exhibit in the litigation that we referred to as Splitting The Sky versus George W. Bush . Our stance was that the former US President should have been arrested in Canada for being a credibly-accused war criminal. We were far from alone in bringing forward evidence that Bush had violated many international covenants and conventions against, for instance, prohibited torture. Not only had he arguably violated international law but it seemed the former US President had violated Canada’s own Crimes Against Humanity and War Crimes Act . The legislation had passed through Parliament with the view that Canada should not become a haven for war criminals.\nIn pursuing this line of analysis I faced my first allegations that somehow my academic inquiry was anti-Semitic.\nAs I worked on this subject, one that I integrated into my pedagogy, it became clear to me that we have never seen anything but victor’s justice when it comes to the enforcement of international law against those that commit war crimes, crimes against humanity, crimes against the peace and crimes against democracy. It seems that only those on the losing side of military conflicts are ever brought to justice. Those on the “winning” side, the stronger side, are invariably held to be above the law.\nThis line of scholarly investigation did result in various channels of academic exchange opening up for me with colleagues in my own university and other universities. The most fruitful collaboration to develop, however, was that with Dr. Kevin Barrett who had lost his academic position at the University of Wisconsin for incorporating 9/11-related subjects into his research and pedagogy.\nFor sure I should not be made to feel so alone in the academy when it comes to the study of 9/11, the most transformative event of the twenty-first century. In my view the academic institutions in North America and Europe have failed abysmally in the study of false flag terrorism starting with the events of 9/11. I am particularly appalled by how this failure on the part of our institutions of higher learning has contributed to the rise of Islamophobia as the necessary psychological condition giving license to those promoting the invasions of Muslim-majority countries.\nIn a meeting with President Rouhani and his Cabinet, the Leader of the Islamic Revolution said: “When it comes to caricatures insulting the sanctities of Islam, the West suddenly becomes an advocates of freedom and the freedom of expression. However, when it comes to the Holocaust, there is no freedom of expression!” Why do you think we witness such double standards?\nA gross display of double standards plagues the ethnocentric way “freedom” is being defined in the so-called “West.” The psychological operations attending the “We Are Charlie Hebdo” ceremonies on Paris in early 2015 epitomized the hypocrisy. The whole essence of this strange event in the city of Lights seemed to signal that “freedom of speech and expression” in the West is virtually limitless when it comes to demeaning through cartoons of Prophet Mohammed as well as other sacred symbols of Islamic religion. The other side of the same coin are the many prohibitions imposed on, for instance, the French comedian M’bala M’bala Dieudonné. Dieudonné was barred from entering Canada for his efforts to make humor of the paranoid state of affairs attending any public references to Jews, Jewish institutions or the activities of Israel these days.\nOne of my discoveries through this period of crisis is the fact that the thought police agents in the B’nai Brith equate my call for open debate on “the holocaust,” and indeed open debate on all subjects, as the equivalent of so-called “holocaust denial.” How many of my colleagues at the and in other universities have bent before the harsh intimidation? How many have made themselves proponents of shutting down open debate and allowing censorship from outside the academy to regulate our research, teaching and publication?\nThere is a controversial Quote: from Ayatollah Khamenei in which he says’ “May God curse all those who put an end to political thoughts, work and endeavor in universities”. What’s your take on that? How essential do you think such a perspective is for the academia?\nI agree wholeheartedly with the Supreme Leader’s observation. One of the great gifts of the Creator to humans is the gift of reason and rationality. Our application of reason and rationality to our understanding of society will inevitably contribute to political thought, work and endeavor.\nThis type of applied reason should be especially vital in the work of universities where the highest level of political conception should be able to find expression, elaboration, and receptiveness. Indeed we need to make ourselves expert in Universities at making safe places for the development of political discourse. God curse us in the universities if we cannot be the home for vibrant political discourse.",
		"thread_title": "University of Lethbridge Is an Indicator that Canada Is on a Downwards Spiral: Interview with Prof. Anthony Hall",
		"title": "University of Lethbridge Is an Indicator that Canada Is on a Downwards Spiral: Interview with Prof. Anthony Hall",
		"type": "bs",
		"uuid": "9d4ebb07f432bd8db5c632c4c9afdf05d497190d"
	},
	"-KhIgSckcTuR1dJUZLJl": {
		"author": "Milad Amini Movahhed",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-22T02:58:13.879+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/046g7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arba'een"
				},
				"name": "Arbaeen",
				"salience": 0.16237405,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0240rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Husayn_ibn_Ali"
				},
				"name": "Imam Hussein",
				"salience": 0.14882213,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dyns",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Karbala"
				},
				"name": "Karbala",
				"salience": 0.11016766,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni Muslims",
				"salience": 0.082035035,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.07052161,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.02181059,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.02181059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.021397728,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.021356508,
				"type": "PERSON"
			},
			{
				"name": "shrine",
				"salience": 0.021161493,
				"type": "LOCATION"
			},
			{
				"name": "gathering",
				"salience": 0.019713366,
				"type": "EVENT"
			},
			{
				"name": "rituals",
				"salience": 0.017092329,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.017092329,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027kj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Imamah_(Shia_doctrine)"
				},
				"name": "Shia Imam",
				"salience": 0.016419379,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.010113698,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00959037,
				"type": "EVENT"
			},
			{
				"name": "pilgrims",
				"salience": 0.009081131,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.008763168,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.008635782,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shia Muslim",
				"salience": 0.008271936,
				"type": "OTHER"
			},
			{
				"name": "marchers",
				"salience": 0.008241784,
				"type": "PERSON"
			},
			{
				"name": "standard",
				"salience": 0.0077709253,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gk03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Day_of_Ashura"
				},
				"name": "Ashura",
				"salience": 0.007084474,
				"type": "EVENT"
			},
			{
				"name": "terror",
				"salience": 0.0056356927,
				"type": "OTHER"
			},
			{
				"name": "march",
				"salience": 0.0050024223,
				"type": "EVENT"
			},
			{
				"name": "lack",
				"salience": 0.004898675,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00462211,
				"type": "LOCATION"
			},
			{
				"name": "mourning",
				"salience": 0.0041740607,
				"type": "EVENT"
			},
			{
				"name": "reporting",
				"salience": 0.0041740607,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.003615189,
				"type": "EVENT"
			},
			{
				"name": "coverage",
				"salience": 0.003615189,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.003615189,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.003615189,
				"type": "ORGANIZATION"
			},
			{
				"name": "terror",
				"salience": 0.003528232,
				"type": "OTHER"
			},
			{
				"name": "marchers",
				"salience": 0.0033786278,
				"type": "PERSON"
			},
			{
				"name": "anniversary",
				"salience": 0.0032814997,
				"type": "EVENT"
			},
			{
				"name": "caliph",
				"salience": 0.003121566,
				"type": "PERSON"
			},
			{
				"name": "Millions",
				"salience": 0.003121566,
				"type": "PERSON"
			},
			{
				"name": "tyrant caliph",
				"salience": 0.003121566,
				"type": "OTHER"
			},
			{
				"name": "martyrdom",
				"salience": 0.0029279473,
				"type": "OTHER"
			},
			{
				"name": "mourning",
				"salience": 0.0029279473,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0028187612,
				"type": "LOCATION"
			},
			{
				"name": "caliphate",
				"salience": 0.0026475922,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.002570701,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.0025357008,
				"type": "ORGANIZATION"
			},
			{
				"name": "show",
				"salience": 0.0025357008,
				"type": "EVENT"
			},
			{
				"name": "devotion",
				"salience": 0.0025357008,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0025357008,
				"type": "PERSON"
			},
			{
				"name": "type",
				"salience": 0.0024411234,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0024411234,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0024411234,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0024411234,
				"type": "OTHER"
			},
			{
				"name": "dynasty",
				"salience": 0.0024411234,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0023907076,
				"type": "OTHER"
			},
			{
				"name": "terror attacks",
				"salience": 0.0023907076,
				"type": "EVENT"
			},
			{
				"name": "journey",
				"salience": 0.0021877775,
				"type": "EVENT"
			},
			{
				"name": "step",
				"salience": 0.002178012,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0021412338,
				"type": "EVENT"
			},
			{
				"name": "companions",
				"salience": 0.0020703562,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.0020703562,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.0020703562,
				"type": "OTHER"
			},
			{
				"name": "Tens of thousands",
				"salience": 0.0020703562,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0240s6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yazid_I"
				},
				"name": "Yazid",
				"salience": 0.0019877139,
				"type": "OTHER"
			},
			{
				"name": "significance",
				"salience": 0.0017862238,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.0017575739,
				"type": "OTHER"
			},
			{
				"name": "journey",
				"salience": 0.0016139713,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.001561167,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.001561167,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.001559727,
				"type": "EVENT"
			},
			{
				"name": "terrorist campaign",
				"salience": 0.001559727,
				"type": "OTHER"
			},
			{
				"name": "pilgrims",
				"salience": 0.001559727,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0015468075,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0015468075,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0015468075,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0015468075,
				"type": "PERSON"
			},
			{
				"name": "cry",
				"salience": 0.0015468075,
				"type": "OTHER"
			},
			{
				"name": "occasion",
				"salience": 0.0015468075,
				"type": "EVENT"
			},
			{
				"name": "solidarity",
				"salience": 0.0015468075,
				"type": "OTHER"
			},
			{
				"name": "community-building",
				"salience": 0.0015468075,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0015029097,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d7bt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Umayyad_Caliphate"
				},
				"name": "Umayyad",
				"salience": 0.0015029097,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01ch26",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Najaf"
				},
				"name": "Najaf",
				"salience": 0.0015029097,
				"type": "LOCATION"
			},
			{
				"name": "Arbaeen Procession",
				"salience": 0.0015029097,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabist",
				"salience": 0.0015029097,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0014409524,
				"type": "LOCATION"
			},
			{
				"name": "Muslims",
				"salience": 0.0013768079,
				"type": "PERSON"
			},
			{
				"name": "reporting",
				"salience": 0.0013010643,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0013010643,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0013010643,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0013010643,
				"type": "LOCATION"
			},
			{
				"name": "mainstream media blackout",
				"salience": 0.0011266383,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0011266383,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.00097195513,
				"type": "EVENT"
			},
			{
				"name": "Radicalism",
				"salience": 0.00097195513,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0008416317,
				"type": "OTHER"
			},
			{
				"name": "Resistance",
				"salience": 0.0008416317,
				"type": "OTHER"
			},
			{
				"name": "Threat",
				"salience": 0.0008416317,
				"type": "OTHER"
			},
			{
				"name": "Biggest Human Gathering",
				"salience": 0.00068778184,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hqjh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Africa"
				},
				"name": "West",
				"salience": 0.0005179969,
				"type": "LOCATION"
			},
			{
				"name": "Walk Of Light -- Arbaeen Pilgrimage Rises",
				"salience": 0.0005179969,
				"type": "OTHER"
			},
			{
				"name": "Radicalism Messenger",
				"salience": 0.0005179969,
				"type": "PERSON"
			},
			{
				"name": "Muslims Develop Technology to Promote Religious Unity",
				"salience": 0.0005179969,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Arbaeen_ISIS_6a930.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-21T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.043",
		"text": "The Iraqi city of Karbala, where the holy shrine of the third Shia Imam -Imam Hussein- is located, is swarming with millions of devoted Muslims, both Shiites and Sunnis, for mourning rituals marking Arbaeen, known as the largest religious gathering in the world. 15 Shares\n14 0 0 1\nGiven the mainstream media’s constant sensationalized reporting on terror and Muslims in the Western world, the utter lack of coverage of Arbaeen’s march on Sunday and Monday revealed the double standard that exists in reporting on peaceful Muslims.\nMonday marked the final day of the mourning for Imam Hussein who was martyred in a battle with the massive army of Yazid after refusing allegiance to the tyrant caliph. Yazid the caliph of Umayyad dynasty was promoting the same type of Islam as ISIS and Wahhabist preach today.\nMillions of marchers participated in the annual Arbaeen Procession in Karbala. The marchers are said to come from over 60 countries, and most of them have marched all the way to Karbala from other Iraqi cities like Najaf and Baghdad in a show of devotion. Each year, Sunni Muslims and followers of other religious groups such as Christians join the journey to mourn the martyrdom of Imam Hussein.\nArbaeen, or mourning, is a Shia Muslim tradition to mark the anniversary of seventh-century social justice leader Imam Husain. Arbaeen is commemorated 40 days after Ashura, the martyrdom anniversary of Imam Hussein (AS) and his companions in 680 AD. However, in light of ISIS terror attacks globally, several people took the controversial step of turning their march political in order to denounce terror in all forms.\nTens of thousands of Muslims have been killed and displaced by ISIS’s declared caliphate, an exponentially larger number than those killed in attacks in the West.\nMORE... The Walk Of Light – Arbaeen Pilgrimage Rises a Great Resistance against Radicalism Messenger 40 – Muslims Develop Technology to Promote Religious Unity against Radicalism Why Muslims Hold the Biggest Human Gathering under the Threat of ISIS in Iraq? The 10th Day’s new campaign – community-building and social solidarity The occasion has found additional significance in recent years as it has become a rallying cry for the campaign against ISIS terrorists who have frequently targeted the pilgrims.\nIraqi troops have been deployed to ensure security for the pilgrims. The northern and western parts of Iraq have been plagued by gruesome violence ever since ISIS terrorists began a campaign of terror in the country in June 2014.\nThe terrorist campaign, however, has not dissuaded pilgrims from around the world from making the journey.\nIt is noteworthy to mention the mainstream media blackout of the millions people marched gathering in war torn Iraq, battling the ISIS, as a clear sign of biased reporting.",
		"thread_title": "Media Blackout as Millions of Muslims March against ISIS and Umayyad Islam in Iraq for Arbaeen Rituals",
		"title": "Media Blackout as Millions of Muslims March against ISIS and Umayyad Islam in Iraq for Arbaeen Rituals",
		"type": "bs",
		"uuid": "3949a071925feabf1b0cc5eed8cfa15959a47978"
	},
	"-KhIgSpcEPdRyXEuNYwo": {
		"author": "ahtribune.com",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-22T14:32:43.850+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "military forces",
				"salience": 0.13168685,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01311nj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Army_of_Conquest"
				},
				"name": "Jaish al-Fatah",
				"salience": 0.119506635,
				"type": "PERSON"
			},
			{
				"name": "Eastern Aleppo",
				"salience": 0.09314186,
				"type": "LOCATION"
			},
			{
				"name": "military source",
				"salience": 0.038019795,
				"type": "PERSON"
			},
			{
				"name": "operations room",
				"salience": 0.035859454,
				"type": "LOCATION"
			},
			{
				"name": "operations room",
				"salience": 0.028070334,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.02620737,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.02466043,
				"type": "LOCATION"
			},
			{
				"name": "Jeish al-Fatah",
				"salience": 0.023983939,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.022844853,
				"type": "LOCATION"
			},
			{
				"name": "army soldiers",
				"salience": 0.019923521,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hv9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sergey_Shoygu"
				},
				"name": "Sergei Shoigu",
				"salience": 0.01750546,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.017343568,
				"type": "PERSON"
			},
			{
				"name": "clashes",
				"salience": 0.014415079,
				"type": "EVENT"
			},
			{
				"name": "Shares",
				"salience": 0.014415079,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.014415079,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.009328972,
				"type": "OTHER"
			},
			{
				"name": "government forces",
				"salience": 0.0092716245,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hananou",
				"salience": 0.008595277,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.008538491,
				"type": "ORGANIZATION"
			},
			{
				"name": "militants",
				"salience": 0.008229994,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0080672335,
				"type": "PERSON"
			},
			{
				"name": "districts",
				"salience": 0.007604416,
				"type": "LOCATION"
			},
			{
				"name": "control",
				"salience": 0.007604416,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.007604416,
				"type": "OTHER"
			},
			{
				"name": "operations room",
				"salience": 0.007604416,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.0068673925,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.0068673925,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0068367743,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.006820891,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0065055913,
				"type": "ORGANIZATION"
			},
			{
				"name": "government forces",
				"salience": 0.0065055913,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03n5sy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northern_Fleet"
				},
				"name": "Northern",
				"salience": 0.006165871,
				"type": "LOCATION"
			},
			{
				"name": "source",
				"salience": 0.006029727,
				"type": "PERSON"
			},
			{
				"name": "loss",
				"salience": 0.0059480355,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.005774107,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.005659822,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.0055588745,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.005334868,
				"type": "LOCATION"
			},
			{
				"name": "districts",
				"salience": 0.005334868,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0053125685,
				"type": "OTHER"
			},
			{
				"name": "army forces",
				"salience": 0.0053125685,
				"type": "PERSON"
			},
			{
				"name": "districts",
				"salience": 0.0051359804,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.0050976244,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0048174514,
				"type": "LOCATION"
			},
			{
				"name": "army soldiers",
				"salience": 0.0047150124,
				"type": "PERSON"
			},
			{
				"name": "Hananou Housings",
				"salience": 0.0046841125,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.004621657,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.004501626,
				"type": "EVENT"
			},
			{
				"name": "commandoes",
				"salience": 0.004356221,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.004356221,
				"type": "LOCATION"
			},
			{
				"name": "Hananou Housing Project",
				"salience": 0.0042297207,
				"type": "OTHER"
			},
			{
				"name": "Hundreds",
				"salience": 0.0041721384,
				"type": "OTHER"
			},
			{
				"name": "convoy",
				"salience": 0.0040165395,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.003933595,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0pd7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Army"
				},
				"name": "Army",
				"salience": 0.0038572573,
				"type": "ORGANIZATION"
			},
			{
				"name": "commanders",
				"salience": 0.0038130085,
				"type": "PERSON"
			},
			{
				"name": "Oweijeh",
				"salience": 0.0036630386,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0032549563,
				"type": "OTHER"
			},
			{
				"name": "Staff",
				"salience": 0.0032549563,
				"type": "PERSON"
			},
			{
				"name": "Staff",
				"salience": 0.0032549563,
				"type": "PERSON"
			},
			{
				"name": "army men",
				"salience": 0.0031173613,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "leadership",
				"salience": 0.002939065,
				"type": "OTHER"
			},
			{
				"name": "Navy",
				"salience": 0.002939065,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bostan al-Pasha",
				"salience": 0.0025687774,
				"type": "PERSON"
			},
			{
				"name": "Ba'aeidin",
				"salience": 0.0025687774,
				"type": "OTHER"
			},
			{
				"name": "Liwa al-Quds",
				"salience": 0.0025687774,
				"type": "ORGANIZATION"
			},
			{
				"name": "collapse",
				"salience": 0.0025451514,
				"type": "EVENT"
			},
			{
				"name": "region",
				"salience": 0.0025451514,
				"type": "LOCATION"
			},
			{
				"name": "complex",
				"salience": 0.0025451514,
				"type": "LOCATION"
			},
			{
				"name": "representatives",
				"salience": 0.0025451514,
				"type": "PERSON"
			},
			{
				"name": "Strikes",
				"salience": 0.0025451514,
				"type": "EVENT"
			},
			{
				"name": "Fleet",
				"salience": 0.0025451514,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0025451514,
				"type": "EVENT"
			},
			{
				"name": "al-Arz al-Hamra",
				"salience": 0.0024729252,
				"type": "PERSON"
			},
			{
				"name": "Sakhour",
				"salience": 0.0024729252,
				"type": "LOCATION"
			},
			{
				"name": "al-Heidariyeh",
				"salience": 0.0024729252,
				"type": "PERSON"
			},
			{
				"name": "Old Sheikh Najjar",
				"salience": 0.0024729252,
				"type": "PERSON"
			},
			{
				"name": "Sheikh Khezr",
				"salience": 0.0024729252,
				"type": "PERSON"
			},
			{
				"name": "Staff",
				"salience": 0.002370985,
				"type": "PERSON"
			},
			{
				"name": "Terrorists",
				"salience": 0.002370985,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.0022654452,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0021408203,
				"type": "LOCATION"
			},
			{
				"name": "Positions",
				"salience": 0.0021408203,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0021153279,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0021044114,
				"type": "PERSON"
			},
			{
				"name": "Western Aleppo",
				"salience": 0.0020205702,
				"type": "LOCATION"
			},
			{
				"name": "AHT",
				"salience": 0.0019332034,
				"type": "ORGANIZATION"
			},
			{
				"name": "cruise missile attacks",
				"salience": 0.0018538259,
				"type": "EVENT"
			},
			{
				"name": "town",
				"salience": 0.0018538259,
				"type": "LOCATION"
			},
			{
				"name": "terrorist centers",
				"salience": 0.0018538259,
				"type": "LOCATION"
			},
			{
				"name": "Military Aid",
				"salience": 0.0018538259,
				"type": "OTHER"
			},
			{
				"name": "Housing Proj",
				"salience": 0.0018092867,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0018092867,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h6l2s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Defence_(India)"
				},
				"name": "Defence Ministry",
				"salience": 0.0018092867,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0017712928,
				"type": "LOCATION"
			},
			{
				"name": "Cruiser",
				"salience": 0.0015993123,
				"type": "PERSON"
			},
			{
				"name": "al-Rashedeen",
				"salience": 0.0015667134,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07s1801"
				},
				"name": "North",
				"salience": 0.0014594692,
				"type": "LOCATION"
			},
			{
				"name": "order",
				"salience": 0.0013848774,
				"type": "OTHER"
			},
			{
				"name": "History",
				"salience": 0.0013848774,
				"type": "OTHER"
			},
			{
				"name": "Jaish Al-Fatah Leader Admits Receiving Financial",
				"salience": 0.0011410533,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02qffh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Bab"
				},
				"name": "al-Bab",
				"salience": 0.0011410533,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0011410533,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0011410533,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kaliber",
				"salience": 0.0011410533,
				"type": "ORGANIZATION"
			},
			{
				"name": "Aleppo Kamal al-Jafa",
				"salience": 0.0011410533,
				"type": "PERSON"
			},
			{
				"name": "Nusra Terrorists Including Commanders",
				"salience": 0.0010902414,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021wj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Navy"
				},
				"name": "Russian Navy",
				"salience": 0.0009843643,
				"type": "ORGANIZATION"
			},
			{
				"name": "Has Begun Military Operations for the First Time",
				"salience": 0.0008523576,
				"type": "OTHER"
			},
			{
				"name": "Admiral Kuznetsov Aircraft",
				"salience": 0.0008523576,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/Operations_Room_31833.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-22T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.334",
		"text": "Syrian military forces continued to advance against Jeish al-Fatah in Eastern Aleppo and captured their operations room, a military source said on Monday. 10 Shares\n3 7 0 0\n\"Following hours of non-stop clashes, the army soldiers pushed Jaish al-Fatah militants back from a part of Hananou Housings and seized full control over militants' operations room that led the battle with the government forces in the districts of Oweijeh and the Northern side of Hananou,\" the source said.\n\"With the loss of control over their operations room in the Northern side of Hananou Housing Project, Jaish al-Fatah will significantly lose its power in the districts of al-Heidariyeh, Sakhour, Sheikh Khezr, al-Arz al-Hamra and Old Sheikh Najjar,\" the source underlined.\nMeantime, a long convoy of more Army soldiers arrived in Aleppo on Sunday to join the government forces' anti-terrorism operation in the Eastern districts of the city.\n\"Several hundred soldiers arrived in Aleppo province to join the army men and Liwa al-Quds forces' operation in the neighborhoods of Ba'aeidin, Bostan al-Pasha and Hananou,\" the sources said.\n\"Hundreds more of army soldiers are also due to enter Aleppo province in the next few days,\" another source disclosed.\nThe source said that army forces are fully ready to enter the Eastern neighborhoods of Aleppo, adding, \"The army's special forces and commandoes have deployed in positions overlooking the Eastern neighborhoods of Aleppo, waiting for their commanders' order to start their operation.\"\nRecommended For You Sergei Shoigu: Admiral Kuznetsov Aircraft-carrying Cruiser Has Begun Military Operations for the First Time in History of Russian Navy; Kills Over 50 Nusra Terrorists Including Commanders in Aleppo (Defence Minister Sergei Shoigu before the meeting with Defence Ministry leadership and representatives of the military-industrial complex...\nBy AHT Staff The pro-government troops could bring the terrorists in al-Rashedeen region to verge of collapse after taking full control of Housing Proj...\nBy AHT Staff Russian Navy Fleet Starts Strikes at Terrorists' Positions in Syria's Aleppo Kamal al-Jafa termed Moscow's Kaliber cruise missile attacks on terrorist centers in Western Aleppo city and the town of al-Bab, North of ...\nBy AHT Staff Jaish Al-Fatah Leader Admits Receiving Financial, Military Aid from Saudi Arabia",
		"thread_title": "Syrian Army Wins Control over Terrorists' Operations Room in Aleppo",
		"title": "Syrian Army Wins Control over Terrorists' Operations Room in Aleppo",
		"type": "bs",
		"uuid": "8493f278b7096259950e4315c346ad6f7287e021"
	},
	"-KhIgTRAn3-U4fQtehaT": {
		"author": "Mohsen Abdelmoumen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-23T13:00:32.787+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07bbch",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wayne_Madsen"
				},
				"name": "Wayne Madsen",
				"salience": 0.6784787,
				"type": "PERSON"
			},
			{
				"name": "whistleblower",
				"salience": 0.055890936,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.024808189,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.011070583,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.008895694,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09v12g0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_T._Flynn"
				},
				"name": "Michael Flynn",
				"salience": 0.0075640604,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.0072006327,
				"type": "PERSON"
			},
			{
				"name": "anti-Trump",
				"salience": 0.006871565,
				"type": "EVENT"
			},
			{
				"name": "spearhead",
				"salience": 0.0059057083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "National Security Agency",
				"salience": 0.0052899113,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0049250936,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.004156323,
				"type": "OTHER"
			},
			{
				"name": "criminal",
				"salience": 0.003876415,
				"type": "PERSON"
			},
			{
				"name": "Clintons",
				"salience": 0.0038348187,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence agencies",
				"salience": 0.003831909,
				"type": "ORGANIZATION"
			},
			{
				"name": "puppet masters",
				"salience": 0.0035455504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Kingdom of Morocco",
				"salience": 0.0030308992,
				"type": "LOCATION"
			},
			{
				"name": "The Star and The Sword",
				"salience": 0.002942245,
				"type": "WORK_OF_ART"
			},
			{
				"name": "WayneMadsenReport.com",
				"salience": 0.002768265,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0027378593,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cshqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Evelyn_Robert_de_Rothschild"
				},
				"name": "Evelyn de Rothschild",
				"salience": 0.0027296133,
				"type": "PERSON"
			},
			{
				"name": "revolution",
				"salience": 0.0024724624,
				"type": "OTHER"
			},
			{
				"name": "newspapers",
				"salience": 0.0022894945,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.002163077,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0021488466,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shares",
				"salience": 0.0021414212,
				"type": "OTHER"
			},
			{
				"name": "Presidency",
				"salience": 0.002125494,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0020660167,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0020660167,
				"type": "LOCATION"
			},
			{
				"name": "imperialists",
				"salience": 0.0020053452,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "U.S. Navy",
				"salience": 0.0018073636,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0195b9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ibn_Saud"
				},
				"name": "Ibn Saud",
				"salience": 0.0017607731,
				"type": "PERSON"
			},
			{
				"name": "element",
				"salience": 0.0017450858,
				"type": "OTHER"
			},
			{
				"name": "Now What?",
				"salience": 0.0016506598,
				"type": "WORK_OF_ART"
			},
			{
				"name": "books",
				"salience": 0.0016157314,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protesters",
				"salience": 0.0015145367,
				"type": "PERSON"
			},
			{
				"name": "societies",
				"salience": 0.0014549366,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0013992585,
				"type": "OTHER"
			},
			{
				"name": "color revolution",
				"salience": 0.0013461239,
				"type": "OTHER"
			},
			{
				"name": "Mohsen Abdelmoumen",
				"salience": 0.0012866273,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0012817738,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0012795902,
				"type": "OTHER"
			},
			{
				"name": "destabilization operations",
				"salience": 0.0012634766,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.0012634766,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0012634766,
				"type": "ORGANIZATION"
			},
			{
				"name": "person",
				"salience": 0.0012634766,
				"type": "PERSON"
			},
			{
				"name": "figure",
				"salience": 0.0012634766,
				"type": "OTHER"
			},
			{
				"name": "element",
				"salience": 0.0012634766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0012468358,
				"type": "ORGANIZATION"
			},
			{
				"name": "Soros: Quantum of Chaos",
				"salience": 0.0011925325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Trump Trump",
				"salience": 0.0011487678,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jnc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ECHELON"
				},
				"name": "Echelon",
				"salience": 0.0011396807,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.001096503,
				"type": "LOCATION"
			},
			{
				"name": "drivers",
				"salience": 0.001094153,
				"type": "PERSON"
			},
			{
				"name": "protest coordinators",
				"salience": 0.001094153,
				"type": "PERSON"
			},
			{
				"name": "papers",
				"salience": 0.001094153,
				"type": "WORK_OF_ART"
			},
			{
				"name": "groups",
				"salience": 0.001094153,
				"type": "ORGANIZATION"
			},
			{
				"name": "Liberalism",
				"salience": 0.001094153,
				"type": "OTHER"
			},
			{
				"name": "Age",
				"salience": 0.001094153,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.001094153,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "family",
				"salience": 0.001094153,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack H. Obama",
				"salience": 0.0010845825,
				"type": "PERSON"
			},
			{
				"name": "alternative media",
				"salience": 0.0010608984,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00094761257,
				"type": "OTHER"
			},
			{
				"name": "ads",
				"salience": 0.000882046,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Others",
				"salience": 0.00083732506,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gk2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Holy_Roman_Empire"
				},
				"name": "Imperial",
				"salience": 0.0007778287,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05_mb2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Demo_(music)"
				},
				"name": "Demos",
				"salience": 0.0007778287,
				"type": "WORK_OF_ART"
			},
			{
				"name": "alliance",
				"salience": 0.00075656455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00073803175,
				"type": "LOCATION"
			},
			{
				"name": "agenda",
				"salience": 0.0007368788,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00067939603,
				"type": "OTHER"
			},
			{
				"name": "America Survive",
				"salience": 0.0006735505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.0006735505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0257nv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MoveOn.org"
				},
				"name": "MoveOn.org",
				"salience": 0.0006735505,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00066533574,
				"type": "ORGANIZATION"
			},
			{
				"name": "book",
				"salience": 0.00066533574,
				"type": "WORK_OF_ART"
			},
			{
				"name": "relations",
				"salience": 0.00066533574,
				"type": "OTHER"
			},
			{
				"name": "manipulations",
				"salience": 0.0006546779,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00065403816,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00065403816,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00065403816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3k14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy"
				},
				"name": "Kennedy",
				"salience": 0.0006438299,
				"type": "PERSON"
			},
			{
				"name": "authority",
				"salience": 0.00062363275,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00059666013,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00059666013,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.00059094664,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0005804714,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0005743888,
				"type": "LOCATION"
			},
			{
				"name": "both",
				"salience": 0.0005731572,
				"type": "PERSON"
			},
			{
				"name": "quantity",
				"salience": 0.000547637,
				"type": "OTHER"
			},
			{
				"name": "pedophile ring",
				"salience": 0.000527726,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0005201879,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005201879,
				"type": "PERSON"
			},
			{
				"name": "puppet masters",
				"salience": 0.0005201879,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.0005201879,
				"type": "OTHER"
			},
			{
				"name": "trail",
				"salience": 0.0005201879,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.0005201879,
				"type": "LOCATION"
			},
			{
				"name": "alternative media",
				"salience": 0.00049273385,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00049273385,
				"type": "OTHER"
			},
			{
				"name": "whistleblowing",
				"salience": 0.00048241307,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.0004789535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/047876",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine_(region)"
				},
				"name": "Palestine",
				"salience": 0.00047862084,
				"type": "LOCATION"
			},
			{
				"name": "Prism program",
				"salience": 0.00047783452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00046696025,
				"type": "ORGANIZATION"
			},
			{
				"name": "books",
				"salience": 0.00046648824,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.00046648824,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0pl7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Intelligence_Agency"
				},
				"name": "Defense Intelligence Agency",
				"salience": 0.00045356128,
				"type": "ORGANIZATION"
			},
			{
				"name": "involvement",
				"salience": 0.00045043623,
				"type": "OTHER"
			},
			{
				"name": "cults",
				"salience": 0.00045043623,
				"type": "OTHER"
			},
			{
				"name": "security adviser",
				"salience": 0.00045043623,
				"type": "PERSON"
			},
			{
				"name": "return",
				"salience": 0.00045043623,
				"type": "OTHER"
			},
			{
				"name": "human existence",
				"salience": 0.00045043623,
				"type": "OTHER"
			},
			{
				"name": "bane",
				"salience": 0.00045043623,
				"type": "OTHER"
			},
			{
				"name": "rituals",
				"salience": 0.00045043623,
				"type": "OTHER"
			},
			{
				"name": "resolutions",
				"salience": 0.00045043623,
				"type": "OTHER"
			},
			{
				"name": "chief",
				"salience": 0.00045043623,
				"type": "PERSON"
			},
			{
				"name": "institutions",
				"salience": 0.00045043623,
				"type": "ORGANIZATION"
			},
			{
				"name": "World Government",
				"salience": 0.00044907385,
				"type": "ORGANIZATION"
			},
			{
				"name": "telecommunications companies",
				"salience": 0.00043724416,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.00043724416,
				"type": "ORGANIZATION"
			},
			{
				"name": "loyalty",
				"salience": 0.00043362085,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mediterranean_Sea"
				},
				"name": "Mediterranean",
				"salience": 0.00043255693,
				"type": "LOCATION"
			},
			{
				"name": "documents",
				"salience": 0.00042815635,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Wayne Madsen Report",
				"salience": 0.00042349615,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/082qk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Sahara"
				},
				"name": "Western Sahara",
				"salience": 0.00042161377,
				"type": "LOCATION"
			},
			{
				"name": "territories",
				"salience": 0.00042092107,
				"type": "LOCATION"
			},
			{
				"name": "interventions",
				"salience": 0.00040910218,
				"type": "OTHER"
			},
			{
				"name": "whistleblower",
				"salience": 0.00040909008,
				"type": "PERSON"
			},
			{
				"name": "http://www.waynemadsenreport.com/",
				"salience": 0.0004045226,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0004039346,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0004039346,
				"type": "PERSON"
			},
			{
				"name": "decision-makers",
				"salience": 0.00039678498,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02vhjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_World_Order_(conspiracy_theory)"
				},
				"name": "New World Order",
				"salience": 0.00039072163,
				"type": "ORGANIZATION"
			},
			{
				"name": "career",
				"salience": 0.0003888546,
				"type": "OTHER"
			},
			{
				"name": "counterparts",
				"salience": 0.0003888546,
				"type": "PERSON"
			},
			{
				"name": "oligarchy",
				"salience": 0.0003888546,
				"type": "OTHER"
			},
			{
				"name": "military career",
				"salience": 0.0003888546,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0003888546,
				"type": "EVENT"
			},
			{
				"name": "researchers",
				"salience": 0.00038684707,
				"type": "PERSON"
			},
			{
				"name": "The Shocking Truth Behind the Army of Terror",
				"salience": 0.00038384183,
				"type": "WORK_OF_ART"
			},
			{
				"name": "military intelligence",
				"salience": 0.00037434848,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00037434848,
				"type": "OTHER"
			},
			{
				"name": "news sources",
				"salience": 0.00036936154,
				"type": "OTHER"
			},
			{
				"name": "caste",
				"salience": 0.0003647066,
				"type": "OTHER"
			},
			{
				"name": "caste",
				"salience": 0.0003647066,
				"type": "OTHER"
			},
			{
				"name": "homeland",
				"salience": 0.0003647066,
				"type": "LOCATION"
			},
			{
				"name": "websites",
				"salience": 0.0003647066,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.0003647066,
				"type": "OTHER"
			},
			{
				"name": "King Faisal",
				"salience": 0.00036407562,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.00035964805,
				"type": "LOCATION"
			},
			{
				"name": "Soros-Rothschild",
				"salience": 0.00035459924,
				"type": "PERSON"
			},
			{
				"name": "few",
				"salience": 0.00035109062,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00035109062,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00035109062,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theorist",
				"salience": 0.00034666585,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00033647293,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.00033647293,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.00033223233,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00033223233,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.00033223233,
				"type": "OTHER"
			},
			{
				"name": "state crimes",
				"salience": 0.00032974762,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00032974762,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.00032974762,
				"type": "ORGANIZATION"
			},
			{
				"name": "security",
				"salience": 0.00032852055,
				"type": "OTHER"
			},
			{
				"name": "flag attacks",
				"salience": 0.00032391076,
				"type": "EVENT"
			},
			{
				"name": "world oligarchy collapse",
				"salience": 0.00031579754,
				"type": "EVENT"
			},
			{
				"name": "iceberg",
				"salience": 0.00031579754,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.00031579754,
				"type": "OTHER"
			},
			{
				"name": "pillars",
				"salience": 0.00031579754,
				"type": "PERSON"
			},
			{
				"name": "shift",
				"salience": 0.00031579754,
				"type": "EVENT"
			},
			{
				"name": "product",
				"salience": 0.00031579754,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "quality",
				"salience": 0.00031579754,
				"type": "OTHER"
			},
			{
				"name": "globalization",
				"salience": 0.00031579754,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00031579754,
				"type": "PERSON"
			},
			{
				"name": "human beings",
				"salience": 0.00031579754,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.00031579754,
				"type": "PERSON"
			},
			{
				"name": "founding",
				"salience": 0.00031579754,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07rr8pm"
				},
				"name": "Zionist",
				"salience": 0.00031401968,
				"type": "OTHER"
			},
			{
				"name": "security network",
				"salience": 0.0003040071,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0003040071,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.0003040071,
				"type": "OTHER"
			},
			{
				"name": "mass media bankruptcy",
				"salience": 0.0003040071,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0003040071,
				"type": "OTHER"
			},
			{
				"name": "prophets",
				"salience": 0.0003040071,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0002977224,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theorists",
				"salience": 0.0002977224,
				"type": "OTHER"
			},
			{
				"name": "truths",
				"salience": 0.00029510242,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.00029408958,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00028446305,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j3fm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pharisees"
				},
				"name": "Pharisees",
				"salience": 0.00027722438,
				"type": "PERSON"
			},
			{
				"name": "Bonnie and Clyde",
				"salience": 0.00027722438,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0160sc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sanhedrin"
				},
				"name": "Sanhedrin",
				"salience": 0.00027722438,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02xq9m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sahrawi_people"
				},
				"name": "Sahrawi",
				"salience": 0.00027722438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00027722438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b1nrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lieutenant_general_(United_States)"
				},
				"name": "Lt Gen",
				"salience": 0.00027722438,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b5w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nile"
				},
				"name": "Nile Valley",
				"salience": 0.00027722438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/031p4j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_Province,_Sri_Lanka"
				},
				"name": "Southern Province",
				"salience": 0.00027722438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h0kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dionysus"
				},
				"name": "Dionysian",
				"salience": 0.00027722438,
				"type": "PERSON"
			},
			{
				"name": "weapon",
				"salience": 0.00027467308,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0002726268,
				"type": "PERSON"
			},
			{
				"name": "Presidency",
				"salience": 0.0002726268,
				"type": "PERSON"
			},
			{
				"name": "government role",
				"salience": 0.00027121115,
				"type": "OTHER"
			},
			{
				"name": "television news commentator",
				"salience": 0.00026662744,
				"type": "WORK_OF_ART"
			},
			{
				"name": "author",
				"salience": 0.00026662744,
				"type": "PERSON"
			},
			{
				"name": "programs",
				"salience": 0.00026662744,
				"type": "OTHER"
			},
			{
				"name": "television commentator",
				"salience": 0.00026662744,
				"type": "WORK_OF_ART"
			},
			{
				"name": "news events",
				"salience": 0.00026441764,
				"type": "EVENT"
			},
			{
				"name": "Interview",
				"salience": 0.00026244778,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0193q3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_George_W._Bush"
				},
				"name": "Bush White House",
				"salience": 0.0002590565,
				"type": "ORGANIZATION"
			},
			{
				"name": "links",
				"salience": 0.00025779428,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.00025779428,
				"type": "PERSON"
			},
			{
				"name": "lobby Zionist",
				"salience": 0.00025779428,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.00025779428,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00025779428,
				"type": "EVENT"
			},
			{
				"name": "eye",
				"salience": 0.00025779428,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00025779428,
				"type": "OTHER"
			},
			{
				"name": "ranks",
				"salience": 0.00025779428,
				"type": "OTHER"
			},
			{
				"name": "assassination",
				"salience": 0.00025779428,
				"type": "EVENT"
			},
			{
				"name": "entity",
				"salience": 0.00025779428,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00024860073,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00024631276,
				"type": "OTHER"
			},
			{
				"name": "journalism",
				"salience": 0.00024631276,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.00024631276,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.00024631276,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00024631276,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00024631276,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kt0d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bilderberg_Group"
				},
				"name": "Bilderbergs",
				"salience": 0.00024419994,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cnspv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rothschild_banking_family_of_England"
				},
				"name": "Rothschild",
				"salience": 0.00023931856,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01d_8r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_Foreign_Relations"
				},
				"name": "Council on Foreign Relations",
				"salience": 0.00023931856,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07qhs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Times"
				},
				"name": "Washington Times",
				"salience": 0.00023931856,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vzv0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edward_Snowden"
				},
				"name": "Snowden",
				"salience": 0.00023525165,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.00023437089,
				"type": "LOCATION"
			},
			{
				"name": "relationship",
				"salience": 0.00023221388,
				"type": "OTHER"
			},
			{
				"name": "Naval Officer",
				"salience": 0.0002223892,
				"type": "PERSON"
			},
			{
				"name": "inquiry",
				"salience": 0.0002223892,
				"type": "OTHER"
			},
			{
				"name": "COMSEC analyst",
				"salience": 0.0002223892,
				"type": "PERSON"
			},
			{
				"name": "training",
				"salience": 0.0002223892,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0pdbv90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Jazeera_America"
				},
				"name": "Al Jazeera America",
				"salience": 0.00021609323,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02zb0y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bohemian_Club"
				},
				"name": "Bohemian Club",
				"salience": 0.00021607417,
				"type": "ORGANIZATION"
			},
			{
				"name": "reference book",
				"salience": 0.00020716152,
				"type": "WORK_OF_ART"
			},
			{
				"name": "press",
				"salience": 0.00020364247,
				"type": "OTHER"
			},
			{
				"name": "pressures",
				"salience": 0.00020364247,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.00020364247,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.00020364247,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Westerners",
				"salience": 0.00020293746,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02zhhp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Newsday"
				},
				"name": "Newsday",
				"salience": 0.00020218217,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Danbury Newstimes",
				"salience": 0.00020218217,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.00020218217,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00019793467,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apple_Inc."
				},
				"name": "Apple",
				"salience": 0.0001943512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04sv4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Microsoft"
				},
				"name": "Microsoft",
				"salience": 0.0001943512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.0001943512,
				"type": "ORGANIZATION"
			},
			{
				"name": "author",
				"salience": 0.00019417184,
				"type": "PERSON"
			},
			{
				"name": "computer security programs",
				"salience": 0.00019417184,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.00019256245,
				"type": "OTHER"
			},
			{
				"name": "lieutenant",
				"salience": 0.00019256245,
				"type": "PERSON"
			},
			{
				"name": "military service",
				"salience": 0.00019256245,
				"type": "OTHER"
			},
			{
				"name": "affairs",
				"salience": 0.00019256245,
				"type": "OTHER"
			},
			{
				"name": "witness",
				"salience": 0.00019256245,
				"type": "PERSON"
			},
			{
				"name": "terrorism investigation",
				"salience": 0.00019256245,
				"type": "EVENT"
			},
			{
				"name": "MS",
				"salience": 0.00019256245,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.00019256245,
				"type": "PERSON"
			},
			{
				"name": "publications",
				"salience": 0.00019256245,
				"type": "WORK_OF_ART"
			},
			{
				"name": "security issues",
				"salience": 0.00019256245,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.00018709427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Reagan",
				"salience": 0.00018709427,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03tlf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran%E2%80%93Contra_affair"
				},
				"name": "Iran-Contra",
				"salience": 0.0001832261,
				"type": "OTHER"
			},
			{
				"name": "nuisance capacity",
				"salience": 0.00018184981,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0001802382,
				"type": "ORGANIZATION"
			},
			{
				"name": "Edwin Mellen Press",
				"salience": 0.00016778022,
				"type": "ORGANIZATION"
			},
			{
				"name": "cockroaches",
				"salience": 0.00016430121,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_of_Representatives"
				},
				"name": "House of Representatives",
				"salience": 0.00016408775,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.00016195356,
				"type": "ORGANIZATION"
			},
			{
				"name": "privacy",
				"salience": 0.00016195356,
				"type": "OTHER"
			},
			{
				"name": "data protection law",
				"salience": 0.00016195356,
				"type": "OTHER"
			},
			{
				"name": "Fascist Regime",
				"salience": 0.00016195356,
				"type": "OTHER"
			},
			{
				"name": "sword",
				"salience": 0.00016195356,
				"type": "OTHER"
			},
			{
				"name": "JASTA",
				"salience": 0.00015865118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.00015865118,
				"type": "LOCATION"
			},
			{
				"name": "Zionist-Wahhabi",
				"salience": 0.00015865118,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00015865118,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.00015865118,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "Russia Today",
				"salience": 0.00015606396,
				"type": "ORGANIZATION"
			},
			{
				"name": "experience",
				"salience": 0.00015520955,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.00015473999,
				"type": "OTHER"
			},
			{
				"name": "relative",
				"salience": 0.00015473999,
				"type": "PERSON"
			},
			{
				"name": "Wayne Madsen Report.com",
				"salience": 0.00015158467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024_zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CounterPunch"
				},
				"name": "Counterpunch",
				"salience": 0.00015158467,
				"type": "ORGANIZATION"
			},
			{
				"name": "Manufacturing",
				"salience": 0.00014941393,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.00014632472,
				"type": "ORGANIZATION"
			},
			{
				"name": "project",
				"salience": 0.00014567091,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00014503689,
				"type": "LOCATION"
			},
			{
				"name": "Plates",
				"salience": 0.00014023144,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "advocacy",
				"salience": 0.00014023144,
				"type": "OTHER"
			},
			{
				"name": "Insertion",
				"salience": 0.00014023144,
				"type": "OTHER"
			},
			{
				"name": "co-author",
				"salience": 0.00014023144,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dsc8s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RealClearPolitics"
				},
				"name": "Real Clear Politics",
				"salience": 0.00013686063,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p_b7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Philadelphia_Inquirer"
				},
				"name": "Philadelphia Inquirer",
				"salience": 0.00013686063,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00013686063,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0375bw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Plain_Dealer"
				},
				"name": "Cleveland Plain Dealer",
				"salience": 0.00013686063,
				"type": "ORGANIZATION"
			},
			{
				"name": "chaos",
				"salience": 0.00013398526,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.00013398526,
				"type": "OTHER"
			},
			{
				"name": "oligarchy",
				"salience": 0.00013398526,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.00013053743,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00012759354,
				"type": "LOCATION"
			},
			{
				"name": "shadow figures",
				"salience": 0.00012097055,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.00012097055,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.00012097055,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00012097055,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.00012097055,
				"type": "OTHER"
			},
			{
				"name": "media organizations",
				"salience": 0.00012097055,
				"type": "ORGANIZATION"
			},
			{
				"name": "Unmasking ISIS: The Shocking Truth",
				"salience": 0.00011949424,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Naval Data Automation Command",
				"salience": 0.00011949424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00011949424,
				"type": "LOCATION"
			},
			{
				"name": "Forbidden Truth",
				"salience": 0.00011949424,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02jrgp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Juneau_Empire"
				},
				"name": "Juneau Empire",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/083b4s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Morning_Call"
				},
				"name": "Allentown Morning Call",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01lcyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houston_Chronicle"
				},
				"name": "Houston Chronicle",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09d5h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS"
				},
				"name": "CBS",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05xbx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PBS"
				},
				"name": "PBS",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.000118503754,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09fsbl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-submarine_warfare"
				},
				"name": "Anti-Submarine Warfare",
				"salience": 0.000118503754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06dfg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rwanda"
				},
				"name": "Rwanda",
				"salience": 0.000118503754,
				"type": "LOCATION"
			},
			{
				"name": "UN Criminal Tribunal",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0195cz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Village_Voice"
				},
				"name": "The Village Voice",
				"salience": 0.000118503754,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/019s8j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electronic_Privacy_Information_Center"
				},
				"name": "Electronic Privacy Information Center",
				"salience": 0.00011365083,
				"type": "ORGANIZATION"
			},
			{
				"name": "Quantum of Chaos",
				"salience": 0.00011038875,
				"type": "OTHER"
			},
			{
				"name": "disinfectant",
				"salience": 0.00010474479,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.00010474479,
				"type": "OTHER"
			},
			{
				"name": "contributor agreement",
				"salience": 0.00010474479,
				"type": "OTHER"
			},
			{
				"name": "darkness",
				"salience": 0.00010474479,
				"type": "OTHER"
			},
			{
				"name": "apartment",
				"salience": 0.00010474479,
				"type": "LOCATION"
			},
			{
				"name": "sunshine",
				"salience": 0.00010474479,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00010474479,
				"type": "OTHER"
			},
			{
				"name": "domicile",
				"salience": 0.00010474479,
				"type": "OTHER"
			},
			{
				"name": "shore",
				"salience": 0.00010474479,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02wm20",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Covert_operation"
				},
				"name": "Covert Operations",
				"salience": 0.00009966589,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06gst",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RCA"
				},
				"name": "RCA Corporation",
				"salience": 0.00009966589,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0d3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Computer_Sciences_Corporation"
				},
				"name": "Computer Sciences Corporation",
				"salience": 0.00009966589,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/038lmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Press_Club_(United_States)"
				},
				"name": "National Press Club",
				"salience": 0.00009966589,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George Bush II",
				"salience": 0.00009966589,
				"type": "PERSON"
			},
			{
				"name": "Jaded Tasks: Big Oil",
				"salience": 0.00009966589,
				"type": "OTHER"
			},
			{
				"name": "L'Affaire Petraeus",
				"salience": 0.00008629751,
				"type": "PERSON"
			},
			{
				"name": "National Security Agency Surveillance: Reflections and Revelations",
				"salience": 0.00008629751,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04b2kz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_operation"
				},
				"name": "Black Ops",
				"salience": 0.00008629751,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00008629751,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05mg9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Osama_bin_Laden"
				},
				"name": "bin Laden",
				"salience": 0.00008629751,
				"type": "PERSON"
			},
			{
				"name": "Failed Search",
				"salience": 0.00008629751,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07jqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taliban"
				},
				"name": "Taliban",
				"salience": 0.00008629751,
				"type": "ORGANIZATION"
			},
			{
				"name": "Secret Oil Diplomacy",
				"salience": 0.00008629751,
				"type": "OTHER"
			},
			{
				"name": "Dandelion",
				"salience": 0.00008629751,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cjgc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nightmare"
				},
				"name": "Nightmare",
				"salience": 0.00008629751,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "Department of State",
				"salience": 0.00008629751,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.00008629751,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/038bj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Genocide"
				},
				"name": "Genocide",
				"salience": 0.00008629751,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/041f8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Macmillan_Publishers"
				},
				"name": "Macmillan",
				"salience": 0.00008629751,
				"type": "PERSON"
			},
			{
				"name": "The Handbook of Personal Data Protection",
				"salience": 0.00008629751,
				"type": "WORK_OF_ART"
			},
			{
				"name": "visits",
				"salience": 0.000078237696,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04k84",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Light"
				},
				"name": "Light",
				"salience": 0.000074444004,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01s91r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Progressive"
				},
				"name": "The Progressive",
				"salience": 0.00006925366,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00006445849,
				"type": "LOCATION"
			},
			{
				"name": "Satanist",
				"salience": 0.00006445849,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01pf89",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gulf_of_Aqaba"
				},
				"name": "Gulf of Aqaba",
				"salience": 0.00006445849,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Wayne_Madsen_682bc.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-23T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 33.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.002",
		"text": "90 Shares\n70 19 0 1\nMohsen Abdelmoumen : According to you, when we see the numerous demonstrations anti-Trump in the United States after the election of Donald Trump at the presidency, are we witnessing a colored revolution?\nWayne Madsen: It is classic Soros-funded color revolution. Soros is financing MoveOn.org, Black Lives Matter, Demos, and other of his groups to turn out protesters and is even running ads in papers looking for paid drivers and protest coordinators.\nIn your very relevant books devoted to George Soros: “Soros: Quantum of Chaos”, you reveal the true face of this figure who is the spearhead of several destabilization operations in the world. From where does all the power come that this criminal holds and why is he untouchable?\nSoros is very wealthy and actually a frontman for an even more powerful and wealthy person, Evelyn de Rothschild, along with his family. They are all the true puppet masters of the world.\nSoros remains a major element in the anti-Trump device. Can Trump resist him?\nMORE... Disrespecting the American Imperial Presidency Trump Won, Now What? Will America Survive the Next 4 Years? Defeating White Liberalism in the Age of Trump Trump is actually now being surrounded by people who will serve in his administration who will be loyal to the Soros-Rothschild puppet masters and certainly not to Trump.\nCan we say that the occult world is more powerful than legal institutions?\nSecret societies with their crazy rituals have been the bane of human existence since the time of the Sanhedrin and Pharisees in Palestine and the Dionysian cults of the Nile Valley and the Mediterranean region.\nIn your book “ ISIS is US - The Shocking Truth Behind the Army of Terror”, you detail the relations between the USA and ISIS/Daesh. What is the triggering element that has put you on this trail?\nTrump's national security adviser retired Lt Gen Michael Flynn revealed that the US was supporting ISIS and then he was forced to resign. My own sources in the Middle East confirmed this long before Flynn made his public statement and was fired as Defense Intelligence Agency chief by Obama.\nYou mention Western Sahara and the involvement of the Clintons in a deal with the Kingdom of Morocco while this case is under the authority of UN. Aren't the Clintons outlaws such Bonnie and Clyde by supporting Morocco against the Sahrawi people and the UN's resolutions?\nThe Clintons received at least $12 million from the Moroccan government in return for buying their loyalty to Morocco's agenda, which includes permanently annexing Western Sahara as the \"Southern Province.\" Morocco and Israel share the same policy on annexing illegally-occupied territories.\nAccording to your diverse very interesting analysis, can we assert that the World Government or the false prophets of the New World Order are the real decision-makers of this world?\nI mentioned a few already, Soros/Rothschild. Others are the Bilderbergs, Bohemian Club, and the Council on Foreign Relations and their counterparts.\nYou know very well some American intelligence agencies like the NSA. Do these intelligence agencies serve the US' interests or, rather, the oligarchy's interests?\nThe CIA has always served the interests of Wall Street. NSA now serves the interests of the global security network it leads.\nYou were an officer in the US Navy. Was the whistleblower you are today born after your military career or before?\nBefore. I was an FBI-Navy whistleblower in 1982 and helped to uncover a major pedophile ring in the US Navy that reached into the Reagan-Bush White House and was ultimately exposed in The Washington Times in 1988-89. My whistleblowing cost me my Navy career, however, and a subsequent series of fairly bad jobs.\nIn the recent US election, we saw the mass media bankruptcy despite their manipulations and their fake polls. Didn't one of the pillars of world oligarchy collapse under our eyes? Don't we witness a historic moment announcing the end of the New World Order and its purely capitalist product, globalization?\n99 percent of major newspapers endorsed Clinton. Many alternative news sources supported Trump. We are seeing a massive shift away from newspapers and corporate TV and websites to the alternative media, of which WayneMadsenReport.com has been prominent since its founding in 2005.\nSnowden has denounced the Prism program and you have denounced Echelon, both of which serve the interests of the world's oligarchic caste. What is known is not only the immersed part of the iceberg?\nWhat is still relatively unknown is the close cooperation between NSA and private companies like Microsoft, Apple, Google, Facebook, and major telecommunications companies. It is much greater than even Snowden's documents describe.\nThe quantity and especially the quality of your reports reveal to us a world unknown by millions of human beings. How all these truths have been hidden?\nThe major media cooperates with the government in covering up news events.\nI advise everyone to read the Wayne Madsen Report as well as your books and follow your various interventions in the alternative media. How do you explain that we, who are resisting to what I call the fascist oligarchic caste, are called conspiracy theorists? Is this concept the only weapon of the fascist imperialists to reduce to silence all those who resist them and to reinforce the ranks of those whose who have been brainwashed?\nThe term conspiracy theorist was developed by the CIA in the mid-1960s to ridicule those who believed there was a wide government role in the assassination of President Kennedy. It has been used ever since to describe legitimate researchers into Iran-Contra, 9/11, and other deep state crimes.\nYour book “ The Star and The Sword ” is one of the few to talk about intimate and opaque links between the Zionist entity of Israel and Saudi Arabia. You claim that they organize false flag attacks, including the 9/11. What is the origin and nature of this Israeli-Saudi strategic alliance? Do you think that the JASTA law will succeed or will it be countered by the Zionist allies of Saudi Arabia? Do the fact that the USA and the Westerners turn a blind eye on the criminal war led by the Saudis to Yemen isn't due to the weight of the lobby Zionist?\nThe Zionist-Wahhabi/Saudi alliance goes back to Ibn Saud who wrote the British and Zionist leaders that he did not oppose a Jewish homeland in Palestine so long as it did not lay claim to Saudi territory on the eastern shore of the Gulf of Aqaba. The relationship has always been close, except for the time of King Faisal, who was conveniently shot in the face and killed by a relative.\nDo you undergo pressure or threats in relation to the remarkable work you do? If so, how do you live it?\nI was forced to move my domicile from Washington because the outgoing Obama administration put pressure on some media organizations I did work for. These included RT (contributor agreement canceled) and Al Jazeera America (which is now defunct).\nThe FBI entered my apartment in Washington at least twice and I've had three visits by them at my new home in Florida.\nI was informed of 3 personal threats in Washington.\nI ignore all these pressures and continue to exercise the freedom of the press.\nAre you optimistic or do you think that the Satanist project of the oligarchy still has a nuisance capacity that can plunge the world into chaos?\nAs with cockroaches, which detest light, the shadow figures of covert power cannot stand what is known as the disinfectant of sunshine. Light has always fought against darkness and will continue to do so.\nInterview realized by Mohsen Abdelmoumen\nWho is Wayne Madsen?\nWayne Madsen is an American journalist, television news commentator, online editor of Wayne Madsen Report.com , investigative journalist and author specializing intelligence and international affairs. Starting in 1997, after his military service as a U.S. Navy lieutenant assigned to Anti-Submarine Warfare duties and to the National Security Agency as a COMSEC analyst, he applied his military intelligence training to investigative journalism. He has since written for many daily, weekly, and monthly publications including The Progressive , The Village Voice , Counterpunch , Philadelphia Inquirer , Houston Chronicle , Allentown Morning Call , Juneau Empire , Cleveland Plain Dealer , Real Clear Politics , Danbury Newstimes , Newsday and many others. Throughout his journalistic career, he has been a television commentator on many programs, including 60 Minutes , Russia Today , Press TV , and many others. He has been a frequent political and national security commentator on Fox News and has also appeared on ABC , NBC , CBS , PBS , CNN , BBC , Al Jazeera , and MS-NBC .\nHe has been invited to testify as a witness before the US House of Representatives, the UN Criminal Tribunal for Rwanda, and a terrorism investigation judicial inquiry of the French government. Wayne Madsen has some thirty-five years experience in security issues. As a U.S. Naval Officer, he managed one of the first computer security programs for the U.S. Navy. He subsequently worked for the National Security Agency, the Naval Data Automation Command, Department of State, RCA Corporation, and Computer Sciences Corporation. Wayne Madsen was a Senior Fellow for the Electronic Privacy Information Center (EPIC), a privacy public advocacy organization. Mr. Madsen is a member of the National Press Club.\nWayne Madsen is the author of The Handbook of Personal Data Protection (London: Macmillan, 1992), an acclaimed reference book on international data protection law; Genocide and Covert Operations in Africa 1993-1999 (Edwin Mellen Press, 1999); co-author of America's Nightmare: The Presidency of George Bush II ( Dandelion, 2003); Forbidden Truth: U.S.-Taliban Secret Oil Diplomacy, Saudi Arabia and the Failed Search for bin Laden ; author of Jaded Tasks: Big Oil, Black Ops & Brass Plates ; Overthrow a Fascist Regime on $15 a Day ; The star and the sword ; The Manufacturing of a President: the CIA's Insertion of Barack H. Obama, Jr. into the White House ; L'Affaire Petraeus ; and National Security Agency Surveillance: Reflections and Revelations ; Soros: Quantum of Chaos (2015); Unmasking ISIS: The Shocking Truth (2016).\nHis website: http://www.waynemadsenreport.com/",
		"thread_title": "Wayne Madsen: The CIA Has Always Served the Interests of Wall Street",
		"title": "Wayne Madsen: The CIA Has Always Served the Interests of Wall Street",
		"type": "bs",
		"uuid": "560a284e8ce11d072589a4424203d12490988c14"
	},
	"-KhIgToX9JWIHTTkJQNa": {
		"author": "Matt Peppe",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-23T13:00:43.184+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "presidency",
				"salience": 0.051249165,
				"type": "OTHER"
			},
			{
				"name": "presidents",
				"salience": 0.045496453,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.044424016,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.041729685,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.03843383,
				"type": "LOCATION"
			},
			{
				"name": "powers",
				"salience": 0.032793194,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05p4xt2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles_M._Blow"
				},
				"name": "Charles Blow",
				"salience": 0.026042,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.02424515,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.022378443,
				"type": "PERSON"
			},
			{
				"name": "powers",
				"salience": 0.018256148,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.01632937,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.015824666,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.013704193,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Johnson",
				"salience": 0.012851931,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.011744607,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.010722064,
				"type": "OTHER"
			},
			{
				"name": "flickr",
				"salience": 0.010722064,
				"type": "OTHER"
			},
			{
				"name": "buffoon",
				"salience": 0.010722064,
				"type": "OTHER"
			},
			{
				"name": "IoSonoUnaFotoCamera",
				"salience": 0.010722064,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Credit",
				"salience": 0.010722064,
				"type": "OTHER"
			},
			{
				"name": "dust",
				"salience": 0.010722064,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.010694243,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0m6r1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Charter"
				},
				"name": "UN Charter",
				"salience": 0.009606209,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.009308119,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00896068,
				"type": "EVENT"
			},
			{
				"name": "amount",
				"salience": 0.008811264,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0078284135,
				"type": "PERSON"
			},
			{
				"name": "Imperial Presidency",
				"salience": 0.007500631,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.007290772,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.007061482,
				"type": "OTHER"
			},
			{
				"name": "president-elect",
				"salience": 0.007008758,
				"type": "PERSON"
			},
			{
				"name": "president-elect",
				"salience": 0.007008758,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0064077284,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.0063290833,
				"type": "OTHER"
			},
			{
				"name": "executive",
				"salience": 0.0063290833,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/058f8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Magna_Carta"
				},
				"name": "Magna Carta",
				"salience": 0.0058080144,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.0056106797,
				"type": "OTHER"
			},
			{
				"name": "treaties",
				"salience": 0.0056106797,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.005481378,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.005481378,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.005481378,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.005210544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02nsb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Executive_Order_9066"
				},
				"name": "Executive Order 9066",
				"salience": 0.00509112,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.005018524,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.005018524,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0046210582,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.004446658,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.00431617,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/024gm7"
				},
				"name": "John",
				"salience": 0.004178445,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0041641165,
				"type": "ORGANIZATION"
			},
			{
				"name": "Trump Truman",
				"salience": 0.0040209945,
				"type": "PERSON"
			},
			{
				"name": "introduction",
				"salience": 0.0038193658,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.003692224,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.003692224,
				"type": "EVENT"
			},
			{
				"name": "presidents",
				"salience": 0.0035195025,
				"type": "PERSON"
			},
			{
				"name": "ability",
				"salience": 0.003429834,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0033338722,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0033338722,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0136kr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberal_Party_of_Canada"
				},
				"name": "Liberal",
				"salience": 0.00329291,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0031249737,
				"type": "LOCATION"
			},
			{
				"name": "due process",
				"salience": 0.0031249737,
				"type": "OTHER"
			},
			{
				"name": "invasions",
				"salience": 0.0031249737,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "U.S. Constitution",
				"salience": 0.0028923936,
				"type": "WORK_OF_ART"
			},
			{
				"name": "individual",
				"salience": 0.0028870178,
				"type": "PERSON"
			},
			{
				"name": "bombings",
				"salience": 0.0028870178,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.002877357,
				"type": "LOCATION"
			},
			{
				"name": "standard",
				"salience": 0.002853523,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.002840048,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0027820845,
				"type": "OTHER"
			},
			{
				"name": "monarchs",
				"salience": 0.0027470381,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.0027301111,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0026884086,
				"type": "ORGANIZATION"
			},
			{
				"name": "will",
				"salience": 0.0026067593,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.0026067593,
				"type": "OTHER"
			},
			{
				"name": "intervention",
				"salience": 0.0026067593,
				"type": "EVENT"
			},
			{
				"name": "kidnapping",
				"salience": 0.0026067593,
				"type": "EVENT"
			},
			{
				"name": "torture",
				"salience": 0.0026067593,
				"type": "OTHER"
			},
			{
				"name": "Commander-in-Chief",
				"salience": 0.0026067593,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0025988778,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.0025705283,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.002555477,
				"type": "LOCATION"
			},
			{
				"name": "authority",
				"salience": 0.00251123,
				"type": "OTHER"
			},
			{
				"name": "creation",
				"salience": 0.0023272855,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048n7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korean_War"
				},
				"name": "Korean War",
				"salience": 0.0022729593,
				"type": "EVENT"
			},
			{
				"name": "corner",
				"salience": 0.0022573022,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0022573022,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.0022573022,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.0022573022,
				"type": "PERSON"
			},
			{
				"name": "pretense",
				"salience": 0.0022573022,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.0022573022,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0022504765,
				"type": "LOCATION"
			},
			{
				"name": "Liberalism",
				"salience": 0.002191207,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.002191207,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.002191207,
				"type": "OTHER"
			},
			{
				"name": "due process",
				"salience": 0.002191207,
				"type": "OTHER"
			},
			{
				"name": "military/incarceration apparatus",
				"salience": 0.00215898,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035yg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grenada"
				},
				"name": "Grenada",
				"salience": 0.0021398547,
				"type": "LOCATION"
			},
			{
				"name": "charges",
				"salience": 0.0021094233,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0021094233,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.0020243141,
				"type": "EVENT"
			},
			{
				"name": "terrorist campaign",
				"salience": 0.0020243141,
				"type": "EVENT"
			},
			{
				"name": "Interests",
				"salience": 0.0020229004,
				"type": "OTHER"
			},
			{
				"name": "concentration camps",
				"salience": 0.001948756,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.001948756,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.001948756,
				"type": "PERSON"
			},
			{
				"name": "authority",
				"salience": 0.001948756,
				"type": "ORGANIZATION"
			},
			{
				"name": "individual",
				"salience": 0.001948756,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0018901495,
				"type": "OTHER"
			},
			{
				"name": "recourse",
				"salience": 0.001842817,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.001838528,
				"type": "EVENT"
			},
			{
				"name": "army",
				"salience": 0.0018277605,
				"type": "ORGANIZATION"
			},
			{
				"name": "land",
				"salience": 0.0018277605,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.001788852,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.001788852,
				"type": "PERSON"
			},
			{
				"name": "invasion",
				"salience": 0.001788852,
				"type": "EVENT"
			},
			{
				"name": "invasion",
				"salience": 0.001788852,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.001788852,
				"type": "PERSON"
			},
			{
				"name": "trials",
				"salience": 0.0017595353,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.0017595353,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0016938555,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guatemala"
				},
				"name": "Guatemala",
				"salience": 0.0016605242,
				"type": "LOCATION"
			},
			{
				"name": "military dictatorships",
				"salience": 0.0016525903,
				"type": "OTHER"
			},
			{
				"name": "creation",
				"salience": 0.0016525903,
				"type": "OTHER"
			},
			{
				"name": "air campaign",
				"salience": 0.0016525903,
				"type": "EVENT"
			},
			{
				"name": "military dictatorships",
				"salience": 0.0016525903,
				"type": "OTHER"
			},
			{
				"name": "feature",
				"salience": 0.0016233427,
				"type": "OTHER"
			},
			{
				"name": "alternative",
				"salience": 0.001612828,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cn68",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japanese_Americans"
				},
				"name": "Japanese Americans",
				"salience": 0.001584474,
				"type": "PERSON"
			},
			{
				"name": "use",
				"salience": 0.0015826884,
				"type": "OTHER"
			},
			{
				"name": "initiation",
				"salience": 0.0015826884,
				"type": "OTHER"
			},
			{
				"name": "firebombing",
				"salience": 0.0015826884,
				"type": "EVENT"
			},
			{
				"name": "provisions",
				"salience": 0.0015826884,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.0015826884,
				"type": "OTHER"
			},
			{
				"name": "military involvement",
				"salience": 0.0015826884,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0015634615,
				"type": "OTHER"
			},
			{
				"name": "perpetrators",
				"salience": 0.0015430519,
				"type": "PERSON"
			},
			{
				"name": "property",
				"salience": 0.0015236073,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0015236073,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0015236073,
				"type": "LOCATION"
			},
			{
				"name": "taxes",
				"salience": 0.0015236073,
				"type": "OTHER"
			},
			{
				"name": "pass legislation",
				"salience": 0.0015236073,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anyone",
				"salience": 0.0015137382,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.0014921149,
				"type": "PERSON"
			},
			{
				"name": "terrorist army",
				"salience": 0.0014921149,
				"type": "ORGANIZATION"
			},
			{
				"name": "operation",
				"salience": 0.0014921149,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0014921149,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0014921149,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0014921149,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0014921149,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06c6qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Matthew_Yglesias"
				},
				"name": "Matt Yglesias",
				"salience": 0.0014524162,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0014256719,
				"type": "LOCATION"
			},
			{
				"name": "proclamations",
				"salience": 0.0014237746,
				"type": "OTHER"
			},
			{
				"name": "Now What?",
				"salience": 0.0013487063,
				"type": "WORK_OF_ART"
			},
			{
				"name": "law",
				"salience": 0.0013362957,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.0013362957,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0013362957,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0013362957,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/042kg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmy_Carter"
				},
				"name": "Carter",
				"salience": 0.0013266003,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.001321627,
				"type": "LOCATION"
			},
			{
				"name": "ordnance",
				"salience": 0.0012920311,
				"type": "OTHER"
			},
			{
				"name": "misrepresentation",
				"salience": 0.0012920311,
				"type": "OTHER"
			},
			{
				"name": "ground troops",
				"salience": 0.0012920311,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.0012920311,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.0012920311,
				"type": "PERSON"
			},
			{
				"name": "ecosystems",
				"salience": 0.0012920311,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035jnk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atomic_bombings_of_Hiroshima_and_Nagasaki"
				},
				"name": "Hiroshima",
				"salience": 0.00128277,
				"type": "LOCATION"
			},
			{
				"name": "violations",
				"salience": 0.0012344947,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0012344947,
				"type": "PERSON"
			},
			{
				"name": "bombs",
				"salience": 0.0012344947,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0012344947,
				"type": "OTHER"
			},
			{
				"name": "military support",
				"salience": 0.0012180855,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02lx0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_Timor"
				},
				"name": "East Timor",
				"salience": 0.0012093541,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03ryn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indonesia"
				},
				"name": "Indonesian",
				"salience": 0.0012093541,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b78hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Noam_Chomsky"
				},
				"name": "Noam Chomsky",
				"salience": 0.0012084823,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0011990967,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0011679076,
				"type": "OTHER"
			},
			{
				"name": "presidents",
				"salience": 0.0011679076,
				"type": "PERSON"
			},
			{
				"name": "institution",
				"salience": 0.0011307603,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048fz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korea"
				},
				"name": "Korea",
				"salience": 0.0011249583,
				"type": "LOCATION"
			},
			{
				"name": "kidnapping",
				"salience": 0.0011146059,
				"type": "EVENT"
			},
			{
				"name": "killing program",
				"salience": 0.0011146059,
				"type": "OTHER"
			},
			{
				"name": "surveillance",
				"salience": 0.0011146059,
				"type": "OTHER"
			},
			{
				"name": "mass surveillance",
				"salience": 0.0011146059,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_America"
				},
				"name": "Central America",
				"salience": 0.0011010062,
				"type": "LOCATION"
			},
			{
				"name": "plant",
				"salience": 0.0010612793,
				"type": "OTHER"
			},
			{
				"name": "occupant",
				"salience": 0.0010461173,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3k14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy"
				},
				"name": "Kennedy",
				"salience": 0.0010247891,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/035cyx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ageing"
				},
				"name": "Age",
				"salience": 0.00097409484,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/028rk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dwight_D._Eisenhower"
				},
				"name": "Eisenhower",
				"salience": 0.00097409484,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07sgm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Article_Six_of_the_United_States_Constitution"
				},
				"name": "Article VI",
				"salience": 0.00097409484,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.00097409484,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07dfk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tokyo"
				},
				"name": "Tokyo",
				"salience": 0.00097409484,
				"type": "LOCATION"
			},
			{
				"name": "America Survive",
				"salience": 0.00097409484,
				"type": "OTHER"
			},
			{
				"name": "Wall Street Trump Won",
				"salience": 0.00097409484,
				"type": "OTHER"
			},
			{
				"name": "Wayne Madsen",
				"salience": 0.00097409484,
				"type": "PERSON"
			},
			{
				"name": "Conservatives",
				"salience": 0.0009731959,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.0009731959,
				"type": "PERSON"
			},
			{
				"name": "helm",
				"salience": 0.0009651304,
				"type": "OTHER"
			},
			{
				"name": "populations",
				"salience": 0.0009651304,
				"type": "PERSON"
			},
			{
				"name": "citizen",
				"salience": 0.0009651304,
				"type": "PERSON"
			},
			{
				"name": "destruction",
				"salience": 0.0009651304,
				"type": "OTHER"
			},
			{
				"name": "spying network",
				"salience": 0.0009651304,
				"type": "OTHER"
			},
			{
				"name": "imprisonment",
				"salience": 0.0009651304,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0009651304,
				"type": "OTHER"
			},
			{
				"name": "death squad",
				"salience": 0.0009651304,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0009651304,
				"type": "OTHER"
			},
			{
				"name": "misery",
				"salience": 0.0009651304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fifth_Amendment_to_the_United_States_Constitution"
				},
				"name": "Fifth Amendment",
				"salience": 0.0009377263,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0009377263,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02yy8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Franklin_D._Roosevelt"
				},
				"name": "Roosevelt",
				"salience": 0.0009377263,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05hdx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nuremberg_trials"
				},
				"name": "Nuremberg",
				"salience": 0.0009377263,
				"type": "LOCATION"
			},
			{
				"name": "opponents",
				"salience": 0.0009290965,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.00091738655,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.00090336654,
				"type": "PERSON"
			},
			{
				"name": "creation",
				"salience": 0.00089904945,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.00089904945,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0008984214,
				"type": "EVENT"
			},
			{
				"name": "medications",
				"salience": 0.0008984214,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "power",
				"salience": 0.0008957037,
				"type": "OTHER"
			},
			{
				"name": "air war",
				"salience": 0.000859009,
				"type": "EVENT"
			},
			{
				"name": "respect",
				"salience": 0.00081173034,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.00081173034,
				"type": "EVENT"
			},
			{
				"name": "office",
				"salience": 0.00081173034,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.00081173034,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.00081173034,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02zs4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ford_Motor_Company"
				},
				"name": "Ford",
				"salience": 0.0008053301,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04hhv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laos"
				},
				"name": "Laos",
				"salience": 0.00079517975,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dpsf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indochina"
				},
				"name": "Indochina",
				"salience": 0.00079517975,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01xbgx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cambodia"
				},
				"name": "Cambodia",
				"salience": 0.00079517975,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j4b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angola"
				},
				"name": "Angola",
				"salience": 0.00079517975,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02k8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/El_Salvador"
				},
				"name": "El Salvador",
				"salience": 0.00079517975,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06c97",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_Nixon"
				},
				"name": "Nixon",
				"salience": 0.00079517975,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South African",
				"salience": 0.00079517975,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hd0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gulf_of_Tonkin"
				},
				"name": "Gulf of Tonkin",
				"salience": 0.00079517975,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Reagan",
				"salience": 0.00079517975,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05c74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicaragua"
				},
				"name": "Nicaragua",
				"salience": 0.00079517975,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027v9wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elder_(Christianity)"
				},
				"name": "Elder",
				"salience": 0.00079517975,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0007269483,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0007269483,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Panama"
				},
				"name": "Panama",
				"salience": 0.00070939324,
				"type": "LOCATION"
			},
			{
				"name": "judgments",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "presidency ring",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "whims",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "hyperventilation",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "hand-wringing",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.0007028644,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "limits",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "revelations",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "fascism",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.0007028644,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t94w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joint_Special_Operations_Command"
				},
				"name": "Joint Special Operations Command",
				"salience": 0.00068597053,
				"type": "ORGANIZATION"
			},
			{
				"name": "hands",
				"salience": 0.00067155965,
				"type": "OTHER"
			},
			{
				"name": "Partisans",
				"salience": 0.0006378899,
				"type": "PERSON"
			},
			{
				"name": "equivalent",
				"salience": 0.000611328,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0006063315,
				"type": "PERSON"
			},
			{
				"name": "perspective",
				"salience": 0.0006063315,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0006063315,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0006063315,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.0006063315,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c0llt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guantanamo_Bay_detention_camp"
				},
				"name": "Guantanamo Bay",
				"salience": 0.00059396814,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "NSA",
				"salience": 0.00059396814,
				"type": "ORGANIZATION"
			},
			{
				"name": "Dolores Vek",
				"salience": 0.00058648136,
				"type": "PERSON"
			},
			{
				"name": "restraint",
				"salience": 0.00052500877,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00052500877,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.00052500877,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00052500877,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0004865328,
				"type": "OTHER"
			},
			{
				"name": "drone assassination program",
				"salience": 0.0004645372,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vzv0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edward_Snowden"
				},
				"name": "Snowden",
				"salience": 0.0004325502,
				"type": "PERSON"
			},
			{
				"name": "concentration",
				"salience": 0.00039391368,
				"type": "OTHER"
			},
			{
				"name": "Lesser",
				"salience": 0.00032308986,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06tw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sudan"
				},
				"name": "Sudan",
				"salience": 0.00032308986,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbia",
				"salience": 0.00032308986,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Donald_Trumo_Oil_on_Canvas_a8283.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-21T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 22,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.008",
		"text": "2 Shares\n1 0 0 1\n(Credit: IoSonoUnaFotoCamera / flickr)\nWhen the dust settled on the Nov. 8 election, we learned that a completely unpredictable, egomaniacal, narcissistic buffoon would inherit the White House and the vast powers that go along with it. This deeply offended many people who see Donald Trump’s racist and misogynistic rhetoric as “unpresidential.” Liberal New York Times columnist Charles Blow summed up this view: “I respect the presidency; I do not respect this president-elect.” That the president-elect should not be respected is a given. But why should we respect the presidency?\nThe Imperial Presidency of the United States has evolved over the last century to the point that the executive holds certain powers that can be considered dictatorial. Arguably, the most consequential decision in politics is to wage war. The Constitution specifically reserves this right for Congress. The President, as Commander-in-Chief, directs the wars that Congress declares. However, starting with Truman’s intervention in the Korean War in 1950 and continuing with invasions of Vietnam, Grenada, Iraq and Afghanistan and the bombings of dozens more countries, the President’s ability to unilaterally initiate war with a sovereign nation has been normalized. Congress has not declared war since 1941 despite the fact the U.S. military has intervened in nearly every corner of the world.\nIn recent years, George W. Bush assumed the power to kidnap, torture, and assassinate any individual, anywhere in the world, at any time, without even a pretense of due process. Upon replacing Bush, Barack Obama legitimized Bush’s kidnapping and torture (by refusing to prosecute the perpetrators or provide recourse to the victims) while enthusiastically embracing the power to assassinate at will. Noam Chomsky said Obama has trashed the 800-year-old Magna Carta, which King John of England would have approved of.\nCan there be anything more dictatorial than the power of a single individual to kill and make war at will? While American presidents thankfully do not have the power to unilaterally impose taxes, pass legislation, or incarcerate without charges inside U.S. borders, the illegitimate authority they do possess to carry out unrestrained violence across the world is unquestionably one feature of a dictator.\nThere has not been a single American president since World War II that has not exceeded his constitutional authority by committing crimes that would meet the standard by which officials were convicted and executed at the Nuremberg trials.\nRoosevelt’s Executive Order 9066 to imprison Japanese Americans in concentration camps was a flagrant violation of the Fifth Amendment right not to be deprived of life, liberty, or property, without due process of law.\nMORE... Wayne Madsen: The CIA Has Always Served the Interests of Wall Street Trump Won, Now What? Will America Survive the Next 4 Years? Defeating White Liberalism in the Age of Trump Truman’s firebombing of Tokyo, nuclear bombing of Hiroshima and Nagasaki, and invasion of Korea violated provisions of multiple treaties that are considered the “supreme law of the land” per Article VI of the U.S. Constitution.\nEisenhower’s use of the CIA to overthrow democratically elected presidents in Iran and Guatemala, as well as the initiation of a terrorist campaign against Cuba, violated the UN Charter, another international treaty that the Constitution regards as the supreme law of the land.\nKennedy was guilty of approving the creation of a mercenary army to invade Cuba, as well as covert warfare in Vietnam. Johnson massively escalated U.S. military involvement in Vietnam with the introduction of ground troops, which he fraudulently justified to the public through misrepresentation of the Gulf of Tonkin incident.\nSucceeding Johnson, Nixon waged a nearly genocidal air campaign against not only Vietnam but Cambodia and Laos, killing hundreds of thousands of people, destroying ecosystems across Indochina, and leaving an unfathomable amount of unexploded ordnance , which continues to kill and maim hundreds of people each year.\nFord covertly supported the South African invasion of Angola and overtly supported the Indonesian invasion of East Timor. Carter continued support of the Indonesian occupation of East Timor, as well as providing military support to military dictatorships in Guatemala and El Salvador. Reagan oversaw the creation and operation of a terrorist army in Nicaragua, sponsored military dictatorships throughout Central America, and directly invaded Grenada.\nBush the Elder invaded Panama and Iraq. Clinton oversaw sanctions in Iraq that killed as many as 1 million people, carried out an air war from 15,000 feet against Serbia, and bombed a pharmaceutical plant in Sudan that produced medications for half the country. Bush the Lesser invaded and occupied Afghanistan and Iraq. Obama continued both of those wars, as well as dramatically expanding the drone assassination program in as many as seven countries.\nSo I beg to differ with Blow and anyone else who claims the presidency deserves respect. Any institution or position that permits such illegal and immoral actions unchecked should be eradicated and replaced with some alternative that does not allow such concentration of power in the hands of a single person.\nLiberal Clinton defender Matt Yglesias argues that from a historical perspective, Trump is uniquely dangerous. “(P)ast presidents,” Yglesias writes, “have simply been restrained by restraint . By a belief that there are certain things one simply cannot try or do.”\nIt is hard to take such vacuous proclamations with a straight face. As we have seen, every single American president since at least WWII has engaged in serious violations of international and domestic law to cause death, destruction and misery across the world, from murdering individuals without due process to unleashing two nuclear bombs on civilian populations in a defeated country that was seeking to surrender.\nWhen Trump assumes the presidency, he will inherit a frightening surveillance/military/incarceration apparatus that includes a targeted killing program; a vast NSA domestic and international spying network; a death squad (the Joint Special Operations Command); and an extralegal system for indefinite kidnapping and imprisonment at Guantanamo Bay.\nPartisans see a problem only when the presidency is in the “wrong” hands. If Obama is at the helm, liberals are fine with unconstitutional mass surveillance or killing an American citizen without charge or trial every now and then. Conservatives trusted Bush to warrantlessly surveill Americans, but were outraged at the Snowden revelations.\nPrincipled opponents recognize that no one should be trusted with illegitimate authority. The hand-wringing and hyperventilation by liberals about the dangers of a Trump presidency ring hollow and hypocritical.\nAmerican presidents long ago became the equivalent of elected monarchs, beyond the democratic control of the those they purportedly serve. The occupant of the office is able to substitute his own judgments and whims for a universally applicable set of laws and limits on the exercise of power. It is what Dolores Vek describes as “actually existing fascism.” Both parties have contributed to it, the media has normalized it, and the public has accepted its creation and continued existence without rebelling against it. It’s time to stop treating the presidency itself with respect and start actively delegitimizing it.",
		"thread_title": "Disrespecting the American Imperial Presidency",
		"title": "Disrespecting the American Imperial Presidency",
		"type": "bs",
		"uuid": "b3b4fbd6a38f49326c43f8fa32a1a9aba5a84801"
	},
	"-KhIgTu3kI5TPYGCiSQD": {
		"author": "Hal Walter",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-23T13:00:57.985+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "lack",
				"salience": 0.23231092,
				"type": "OTHER"
			},
			{
				"name": "cowardice",
				"salience": 0.20985566,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.18341954,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.15230894,
				"type": "PERSON"
			},
			{
				"name": "TS/SCI clearance",
				"salience": 0.04047135,
				"type": "OTHER"
			},
			{
				"name": "SCIF",
				"salience": 0.028485276,
				"type": "ORGANIZATION"
			},
			{
				"name": "options",
				"salience": 0.020025097,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.019040491,
				"type": "OTHER"
			},
			{
				"name": "cowardice",
				"salience": 0.018885821,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.018566381,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.017213315,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0242kb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_Bank_of_India"
				},
				"name": "SBI",
				"salience": 0.01693951,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.012713944,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.010750854,
				"type": "PERSON"
			},
			{
				"name": "insults",
				"salience": 0.009506444,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.009506444,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Anti_Trump_Protests_23a57.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-11-23T05:53:00.000+02:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Your lack of knowledge and cowardice is appalling! You do not now, nor have ever held a TS/SCI clearance, never undergone an SBI, and have never worked in a SCIF. If you had, you would know voters were forced to make the best choice they could, given the options. It is easy to throw around insults, comparing people to Hitler, something you would never have the courage to do face to face with a man. Your cowardice is obvious.",
		"thread_title": "Will America Survive the Next 4 Years?",
		"title": "",
		"type": "bs",
		"uuid": "c6987343e6f3dacf1094b6e8ed2ad7d6750252c4"
	},
	"-KhIgU4z9eBFfU6Gsvzi": {
		"author": "Matt Peppe",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-23T13:02:40.018+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/054b8m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Borut_Pahor"
				},
				"name": "Borut Pahor",
				"salience": 0.65471303,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06t8v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slovenia"
				},
				"name": "Republic of Slovenia",
				"salience": 0.097270355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Islamic Republic of Iran",
				"salience": 0.0506632,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/021wn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_Consultative_Assembly"
				},
				"name": "Iranian Parliament",
				"salience": 0.04371465,
				"type": "ORGANIZATION"
			},
			{
				"name": "best",
				"salience": 0.01750173,
				"type": "OTHER"
			},
			{
				"name": "visit",
				"salience": 0.017057553,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.017057553,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02m7yd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ali_Larijani"
				},
				"name": "Ali Larijani",
				"salience": 0.0078089847,
				"type": "PERSON"
			},
			{
				"name": "honor",
				"salience": 0.006739181,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0047029154,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z8r7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mehr_News_Agency"
				},
				"name": "Mehr News Agency",
				"salience": 0.0046868315,
				"type": "ORGANIZATION"
			},
			{
				"name": "President",
				"salience": 0.0046298527,
				"type": "PERSON"
			},
			{
				"name": "visit",
				"salience": 0.0036223321,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.002932481,
				"type": "LOCATION"
			},
			{
				"name": "hope",
				"salience": 0.002541529,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0024875088,
				"type": "ORGANIZATION"
			},
			{
				"name": "relations",
				"salience": 0.0024797097,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.0024485108,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0022982957,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.0022982957,
				"type": "PERSON"
			},
			{
				"name": "relations",
				"salience": 0.0022982957,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0022012128,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0022012128,
				"type": "OTHER"
			},
			{
				"name": "opening",
				"salience": 0.0022012128,
				"type": "EVENT"
			},
			{
				"name": "embassy",
				"salience": 0.0022012128,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.002119149,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.002119149,
				"type": "PERSON"
			},
			{
				"name": "podium",
				"salience": 0.002119149,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001858919,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0017251516,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.001717453,
				"type": "PERSON"
			},
			{
				"name": "relations",
				"salience": 0.001717453,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.0015508202,
				"type": "EVENT"
			},
			{
				"name": "talks",
				"salience": 0.0015508202,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ftlx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tehran"
				},
				"name": "Tehran",
				"salience": 0.0013554809,
				"type": "LOCATION"
			},
			{
				"name": "plenty",
				"salience": 0.0013430169,
				"type": "OTHER"
			},
			{
				"name": "fields",
				"salience": 0.0013430169,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0013430169,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.0013430169,
				"type": "OTHER"
			},
			{
				"name": "potentialities",
				"salience": 0.0012511333,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.0012511333,
				"type": "OTHER"
			},
			{
				"name": "talks",
				"salience": 0.0011297027,
				"type": "EVENT"
			},
			{
				"name": "hope",
				"salience": 0.0011297027,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0011297027,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0011297027,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0010117829,
				"type": "LOCATION"
			},
			{
				"name": "experience",
				"salience": 0.0009782824,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0009782824,
				"type": "OTHER"
			},
			{
				"name": "capacities",
				"salience": 0.0009782824,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0009066308,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.00086627156,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.00084399263,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.00084399263,
				"type": "OTHER"
			},
			{
				"name": "Speaker",
				"salience": 0.00084399263,
				"type": "PERSON"
			},
			{
				"name": "core",
				"salience": 0.0007786774,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0007308449,
				"type": "OTHER"
			},
			{
				"name": "MP",
				"salience": 0.0007308449,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0224jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ali_Khamenei"
				},
				"name": "Ayatollah Khamenei",
				"salience": 0.00052378,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Borut_Pahor_Iran_751d9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-23T02:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.3,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Slovenian President Borut Pahor said today, in an unexpected visit to the Iranian Parliament \"I respect the work you do, and I wish you all the best\". 2 Shares\n1 0 0 1\nAccording to Mehr News Agency, Slovenian President Borut Pahor who had traveled to Iran yesterday, paid an unexpected visit to Parliament after meeting with Speaker Ali Larijani.\nPresident Pahor spoke to Parliament for a few minutes, saying \"It brings me great honor that I, a President of Slovenia, am addressing you from this podium.\"\nHe added: \"I came to your beautiful country yesterday, and have met with many of the kind people of Iran, with a goal in mind to attempt to establish the best political and economic relations possible between the Islamic Republic of Iran and the Republic of Slovenia.\"\nHe also expressed hope for the opening of a Slovenian embassy in Tehran saying: \"I've had excellent meetings with the political leaders of Iran, and also with the esteemed leader, and I've seen that there is great potential for good relations between our two countries.\"\n\"For years, I've served Slovenia as an MP and Speaker; Parliament is the essential core of democracy in all countries, and I greatly respect the work you do, and wish you all the best.\"\nYesterday in a meeting with Iran's leader, the Slovenian president said he had held very good talks with senior Iranian officials and expressed his country’s interest in deepening relations with Iran in all fields.\nPahor added that Iran and Slovenia share plenty of common experience and enjoy great potential for cooperation.\nFor his part, Ayatollah Khamenei said that Iran and Slovenia enjoy great potentialities and capacities to bolster cooperation and expressed hope that the future would back up the Tuesday talks.",
		"thread_title": "President of a NATO Member Country, First Ever Foreign President to Address Iran's Parliament",
		"title": "President of a NATO Member Country, First Ever Foreign President to Address Iran's Parliament",
		"type": "bs",
		"uuid": "f9ce514573f73c6d391ab0d3d9b5aeba4e3a4d26"
	},
	"-KhIgUCgHWxSQo1FOfdJ": {
		"author": "Kim Petersen",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-23T13:16:55.667+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.626105,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.06591634,
				"type": "LOCATION"
			},
			{
				"name": "bride",
				"salience": 0.052049,
				"type": "PERSON"
			},
			{
				"name": "Falih Al-Jabour",
				"salience": 0.038223214,
				"type": "PERSON"
			},
			{
				"name": "poet",
				"salience": 0.03390457,
				"type": "PERSON"
			},
			{
				"name": "Tiffany Trump",
				"salience": 0.021425024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordanian",
				"salience": 0.018828638,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.013899042,
				"type": "ORGANIZATION"
			},
			{
				"name": "willingness",
				"salience": 0.013899042,
				"type": "OTHER"
			},
			{
				"name": "daughter",
				"salience": 0.011714305,
				"type": "PERSON"
			},
			{
				"name": "Rai al-Youm",
				"salience": 0.008597201,
				"type": "PERSON"
			},
			{
				"name": "Shares",
				"salience": 0.008100478,
				"type": "OTHER"
			},
			{
				"name": "poem",
				"salience": 0.008089848,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.006334949,
				"type": "PERSON"
			},
			{
				"name": "poem",
				"salience": 0.003080424,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hand",
				"salience": 0.0029504397,
				"type": "OTHER"
			},
			{
				"name": "white house",
				"salience": 0.0029504397,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0029504397,
				"type": "OTHER"
			},
			{
				"name": "burka",
				"salience": 0.0027347528,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.0026664105,
				"type": "OTHER"
			},
			{
				"name": "bride",
				"salience": 0.002646514,
				"type": "PERSON"
			},
			{
				"name": "Unethicality",
				"salience": 0.0026158625,
				"type": "OTHER"
			},
			{
				"name": "poem",
				"salience": 0.0025479211,
				"type": "WORK_OF_ART"
			},
			{
				"name": "offer",
				"salience": 0.0024403539,
				"type": "OTHER"
			},
			{
				"name": "poet",
				"salience": 0.0023009495,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0022906899,
				"type": "PERSON"
			},
			{
				"name": "chaos",
				"salience": 0.002096422,
				"type": "PERSON"
			},
			{
				"name": "home land",
				"salience": 0.0020700456,
				"type": "LOCATION"
			},
			{
				"name": "marriage",
				"salience": 0.0020700456,
				"type": "OTHER"
			},
			{
				"name": "social networks",
				"salience": 0.0020700456,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.0019928871,
				"type": "OTHER"
			},
			{
				"name": "horses",
				"salience": 0.0019928871,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.0019928871,
				"type": "OTHER"
			},
			{
				"name": "tribe",
				"salience": 0.0016903684,
				"type": "OTHER"
			},
			{
				"name": "Oil Imports",
				"salience": 0.0016903684,
				"type": "OTHER"
			},
			{
				"name": "Risks",
				"salience": 0.0016903684,
				"type": "OTHER"
			},
			{
				"name": "Countries",
				"salience": 0.0014584966,
				"type": "LOCATION"
			},
			{
				"name": "t",
				"salience": 0.0012630885,
				"type": "OTHER"
			},
			{
				"name": "vow",
				"salience": 0.0012630885,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0012630885,
				"type": "LOCATION"
			},
			{
				"name": "AHT",
				"salience": 0.0011823284,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00108196,
				"type": "LOCATION"
			},
			{
				"name": "Staff",
				"salience": 0.0010624904,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0009901038,
				"type": "ORGANIZATION"
			},
			{
				"name": "el",
				"salience": 0.0009200918,
				"type": "OTHER"
			},
			{
				"name": "election coverage",
				"salience": 0.0009200918,
				"type": "OTHER"
			},
			{
				"name": "wishes",
				"salience": 0.0008746027,
				"type": "OTHER"
			},
			{
				"name": "camels",
				"salience": 0.0008419668,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0008105476,
				"type": "OTHER"
			},
			{
				"name": "Economy",
				"salience": 0.00079379976,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00079379976,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00079379976,
				"type": "LOCATION"
			},
			{
				"name": "Staff",
				"salience": 0.00079379976,
				"type": "PERSON"
			},
			{
				"name": "Climate Change Aid",
				"salience": 0.00077762327,
				"type": "OTHER"
			},
			{
				"name": "o",
				"salience": 0.00068738824,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.00068738824,
				"type": "OTHER"
			},
			{
				"name": "Sore Loser During",
				"salience": 0.0005663847,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.0005663847,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kim Petersen",
				"salience": 0.0005663847,
				"type": "PERSON"
			},
			{
				"name": "Climate Change Deal",
				"salience": 0.0004231019,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Tiffany_Trump_8cc5f.jpg",
		"ord_in_thread": "0",
		"participants_count": "2",
		"published": "2016-11-23T02:00:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 3.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.05",
		"text": "10 Shares\n8 1 0 1\nAccording to Rai al-Youm newspaper , a Bedouin Jordanian poet has expressed his willingness to marry the daughter of Donald Trump , the US president-elect.\nFalih Al-Jabour wrote in a poem that Jordanian officials are on their way to the white house to ask for the hand of Tiffany Trump, the president’s youngest daughter. He hoped the offer wouldn’t be turned down.\nAl-Jabour proposed to Tiffany in his strange and humorous poem and even offered to pay a substantial price for the bride including 50 camels, 200 thoroughbred horses and a 15.5-acre field.\nThis Jordanian poet published his poem in social networks and asked the bride’s family not to reject him.\nFalih Al-Jabour’s only condition for the marriage is that after marrying him and going to his home land, the bride has to wear burka, because she’s “so beautiful”, otherwise there will be a chaos in the tribe.\nRecommended For You Saudi Arabia Warns Trump on Blocking Oil Imports and the Risks for US Economy Saudi Arabia has warned Donald Trump that the incoming US president will risk the health of his country’s economy if he acts o...\nBy AHT Staff China Warns Trump against Abandoning Climate Change Deal, Increases Climate Change Aid to Developing Countries to $ 3.1b China has warned Donald Trump that he will be defying the wishes of the entire planet if he acts on his vow to back away from t...\nBy AHT Staff The Unethicality of the Sore Loser During live US presidential election coverage on RT, after it became clear that Donald Trump was going to secure the required number of el...\nBy Kim Petersen",
		"thread_title": "Jordanian Bedouin Poet Proposes to Tiffany Trump, Asks Her to Wear Burka",
		"title": "Jordanian Bedouin Poet Proposes to Tiffany Trump, Asks Her to Wear Burka",
		"type": "bs",
		"uuid": "ff0e21165351a0130af69868427fe26f08ce1c99"
	},
	"-KhIgUGFtrMEW2-dG7xO": {
		"author": "Thrishul",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-23T13:16:56.795+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "nnnndddd",
				"salience": 0.84110075,
				"type": "OTHER"
			},
			{
				"name": "drone striked",
				"salience": 0.15889926,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Tiffany_Trump_8cc5f.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-23T09:06:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.05",
		"text": "nnnndddd thats how you get drone striked....",
		"thread_title": "Jordanian Bedouin Poet Proposes to Tiffany Trump, Asks Her to Wear Burka",
		"title": "",
		"type": "bs",
		"uuid": "288d2d9ba5178b32aa65522e7ef99f91fbe74d6f"
	},
	"-KhIgURduMXWc20kJR5L": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-11-24T12:44:55.894+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.24913022,
				"type": "LOCATION"
			},
			{
				"name": "Generals",
				"salience": 0.13030463,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptian",
				"salience": 0.086183235,
				"type": "LOCATION"
			},
			{
				"name": "Partner",
				"salience": 0.046162535,
				"type": "ORGANIZATION"
			},
			{
				"name": "Staff",
				"salience": 0.040222492,
				"type": "PERSON"
			},
			{
				"name": "Pilots",
				"salience": 0.040222492,
				"type": "PERSON"
			},
			{
				"name": "Fight",
				"salience": 0.03490519,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.032701213,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.024911586,
				"type": "ORGANIZATION"
			},
			{
				"name": "jump",
				"salience": 0.021673614,
				"type": "OTHER"
			},
			{
				"name": "AHT",
				"salience": 0.021599876,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.021599876,
				"type": "LOCATION"
			},
			{
				"name": "Drafts Generals",
				"salience": 0.021599876,
				"type": "EVENT"
			},
			{
				"name": "Shares",
				"salience": 0.017945757,
				"type": "OTHER"
			},
			{
				"name": "Walid al-Muallem",
				"salience": 0.016675128,
				"type": "PERSON"
			},
			{
				"name": "developments",
				"salience": 0.013689224,
				"type": "OTHER"
			},
			{
				"name": "helicopter pilots",
				"salience": 0.011162564,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.010765833,
				"type": "OTHER"
			},
			{
				"name": "military formations",
				"salience": 0.0074162153,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0071995812,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0068866955,
				"type": "ORGANIZATION"
			},
			{
				"name": "relations",
				"salience": 0.006534966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptians",
				"salience": 0.005584234,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.005459085,
				"type": "LOCATION"
			},
			{
				"name": "fronts",
				"salience": 0.0054330495,
				"type": "OTHER"
			},
			{
				"name": "fronts",
				"salience": 0.0054330495,
				"type": "OTHER"
			},
			{
				"name": "military figures",
				"salience": 0.005203636,
				"type": "OTHER"
			},
			{
				"name": "Staff Headquarters",
				"salience": 0.005203636,
				"type": "LOCATION"
			},
			{
				"name": "hands",
				"salience": 0.0050097085,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.004946682,
				"type": "OTHER"
			},
			{
				"name": "Assafir Lebanese Daily",
				"salience": 0.0045690895,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mohammad Ballout",
				"salience": 0.0045690895,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04s3g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Armed_forces"
				},
				"name": "Armed Forces",
				"salience": 0.0044354685,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0043947133,
				"type": "ORGANIZATION"
			},
			{
				"name": "operations room",
				"salience": 0.004249344,
				"type": "LOCATION"
			},
			{
				"name": "unit",
				"salience": 0.0038888229,
				"type": "ORGANIZATION"
			},
			{
				"name": "security meetings",
				"salience": 0.0037195957,
				"type": "EVENT"
			},
			{
				"name": "support",
				"salience": 0.0036665213,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0036665213,
				"type": "ORGANIZATION"
			},
			{
				"name": "official",
				"salience": 0.003620368,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.0035140435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0129g6rl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_Front_of_the_Free_Syrian_Army"
				},
				"name": "Southern Front",
				"salience": 0.0033462103,
				"type": "ORGANIZATION"
			},
			{
				"name": "operations",
				"salience": 0.0032018428,
				"type": "OTHER"
			},
			{
				"name": "security official",
				"salience": 0.0031895696,
				"type": "PERSON"
			},
			{
				"name": "scale",
				"salience": 0.003175335,
				"type": "OTHER"
			},
			{
				"name": "Hamah Airbase",
				"salience": 0.003085266,
				"type": "LOCATION"
			},
			{
				"name": "participation",
				"salience": 0.002958138,
				"type": "OTHER"
			},
			{
				"name": "participation",
				"salience": 0.002958138,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0026710865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/044tyt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quneitra"
				},
				"name": "Quneitra",
				"salience": 0.002616672,
				"type": "LOCATION"
			},
			{
				"name": "task forces",
				"salience": 0.002392323,
				"type": "ORGANIZATION"
			},
			{
				"name": "operations",
				"salience": 0.002392323,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0023131254,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0022552253,
				"type": "OTHER"
			},
			{
				"name": "post-December 23rd",
				"salience": 0.0021363802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/065gsq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Command_%26_Conquer:_Generals_%E2%80%93_Zero_Hour"
				},
				"name": "Zero-Hour",
				"salience": 0.0019549802,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.0011664729,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0010637284,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01w2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cairo"
				},
				"name": "Cairo",
				"salience": 0.0010637284,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Egyptian_Air_Force_078ab.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-24T12:44:55.894+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "November 24 ,2016 BY AHT Staff Egypt Says No to Saudi, Drafts Generals and Pilots to Fight Alongside Syrian Army against ISIS Syria Finds New Partner in Fight against ISIS. 44 Shares 1 \n“The small jump needed for Egyptian-Syrian relations to go back to normal” that Syrian Prime Minister Walid al-Muallem spoke of has been achieved apparently. Mohammad Ballout, from Assafir Lebanese Daily , reported that some Egyptian military formations have recently arrived to Syria, signaling an end to the time where Egypt simply stood by, hands crossed, looking at the goings-on in Syria. \nIt seems that the Egyptians have sent 18 helicopter pilots to the Hamah Airbase, and it is hoped that they will see action in joint Egyptian-Syrian operations. \nFour senior Egyptian military figures also joined the unit when it first came to Syria, and two Major Generals have been operating at the Armed Forces Staff Headquarters in Damascus, near the operations room. The two Major Generals have been touring the fronts since they arrived a month ago, and have been reviewing the efforts made at the fronts, most recently the Southern Front at Quneitra. \nThese new developments are apparently the result of intensive, unannounced, high profile security meetings that began over a year ago between Cairo and Damascus. Arab sources also expect that these developments will go beyond these symbolic operations, and will see Egyptian task forces operating on a large scale in support of the Syrian army. \nMoreover, a senior Syrian security official also said that the Egyptians have promised to send forces to Syria, and have schedule post-December 23rd as the Zero-Hour, whereupon Egyptian participation in Syria will escalate. Another official also revealed that after December, a large number of Egyptian forces will also participate in the Syrian operations, and their participation will not be limited to Aerial support. MORE...",
		"thread_title": "Egypt Says No to Saudi, Drafts Generals and Pilots to Fight Alongside Syrian Army against ISIS",
		"title": "Egypt Says No to Saudi, Drafts Generals and Pilots to Fight Alongside Syrian Army against ISIS",
		"type": "bs",
		"uuid": "fe2c4f4594d5511edbf66842766f7cffbf6e533a"
	},
	"-KhIgUYISO-2hMQDSjcd": {
		"author": "Seapost",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-24T13:00:22.736+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "homogeneity",
				"salience": 0.18339059,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.18339059,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vhjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_World_Order_(conspiracy_theory)"
				},
				"name": "New World Order",
				"salience": 0.11534161,
				"type": "EVENT"
			},
			{
				"name": "elites",
				"salience": 0.07803219,
				"type": "PERSON"
			},
			{
				"name": "nonsense",
				"salience": 0.04030493,
				"type": "OTHER"
			},
			{
				"name": "heaven",
				"salience": 0.04030493,
				"type": "OTHER"
			},
			{
				"name": "mass-murderers",
				"salience": 0.037145022,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.02908103,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.02835874,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.02835874,
				"type": "OTHER"
			},
			{
				"name": "globalization",
				"salience": 0.02835874,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.02730852,
				"type": "PERSON"
			},
			{
				"name": "emigration",
				"salience": 0.02730852,
				"type": "OTHER"
			},
			{
				"name": "idiot",
				"salience": 0.023185814,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Assad",
				"salience": 0.021695964,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.017509403,
				"type": "LOCATION"
			},
			{
				"name": "military trigger-pullers",
				"salience": 0.01734908,
				"type": "PERSON"
			},
			{
				"name": "nationalism",
				"salience": 0.01734908,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dwc2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dialectic"
				},
				"name": "Hegelian Dialectic",
				"salience": 0.01685888,
				"type": "WORK_OF_ART"
			},
			{
				"name": "much",
				"salience": 0.012651948,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.009459251,
				"type": "OTHER"
			},
			{
				"name": "manipulation",
				"salience": 0.009459251,
				"type": "OTHER"
			},
			{
				"name": "hell on Earth",
				"salience": 0.00779717,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/media/Refugees_EU_ae2bf.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-24T06:50:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 2.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0",
		"text": "Repeal national identity for a wholesome homogeneity in a New World Order run by benevolent elites?\nThis whole murderous nonsense stinks to high heaven of the Hegelian Dialectic. Assad is the problem, mass emigration of refugees the reaction. And a fractured Europe ripe for further globalization the solution.\nI for one, am tired of being treated as an idiot without eyes, and being awake to the manipulation by the mass-murderers and their pet military trigger-pullers - prefer nationalism over an envisioned hell on Earth. But thank you so much for playing.",
		"thread_title": "10,000 children are missing and the world just looks away",
		"title": "",
		"type": "bs",
		"uuid": "4ef7561599e2baf3663781261df8f677d1f43a86"
	},
	"-KhIgUeQb-ssBZtKLcrs": {
		"author": "Seapost",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-11-24T13:10:16.644+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Naomi Wolf",
				"salience": 0.5043094,
				"type": "PERSON"
			},
			{
				"name": "love",
				"salience": 0.1231063,
				"type": "OTHER"
			},
			{
				"name": "broadcast",
				"salience": 0.062060203,
				"type": "WORK_OF_ART"
			},
			{
				"name": "event",
				"salience": 0.044955935,
				"type": "EVENT"
			},
			{
				"name": "Orlando Massacre",
				"salience": 0.034043845,
				"type": "WORK_OF_ART"
			},
			{
				"name": "farce",
				"salience": 0.018935246,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.018935246,
				"type": "PERSON"
			},
			{
				"name": "lid",
				"salience": 0.018935246,
				"type": "OTHER"
			},
			{
				"name": "morons",
				"salience": 0.018233351,
				"type": "PERSON"
			},
			{
				"name": "imbeciles",
				"salience": 0.018233351,
				"type": "OTHER"
			},
			{
				"name": "idiots",
				"salience": 0.018233351,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.01547851,
				"type": "OTHER"
			},
			{
				"name": "collapse",
				"salience": 0.01187581,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.011686743,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.011686743,
				"type": "ORGANIZATION"
			},
			{
				"name": "Crisis actors",
				"salience": 0.01157967,
				"type": "PERSON"
			},
			{
				"name": "demolition",
				"salience": 0.01157967,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01tfwf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/7_World_Trade_Center"
				},
				"name": "WTC Building 7",
				"salience": 0.009548077,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.008443201,
				"type": "PERSON"
			},
			{
				"name": "brain-cells",
				"salience": 0.008443201,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.007073143,
				"type": "OTHER"
			},
			{
				"name": "shot",
				"salience": 0.006311882,
				"type": "OTHER"
			},
			{
				"name": "backdrop",
				"salience": 0.006311882,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://ahtribune.com/images/Orlando_Shooting_in_Barcelona_c7294.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-11-24T09:05:00.000+02:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "ahtribune.com",
		"spam_score": "0.101",
		"text": "I'm secretly and totally in love with Naomi Wolf, since she's awake and vibrant and bright, writes amazingly well and just beautiful but the \"Orlando Massacre\" was a staged event. The bumbling idiots(?) imbeciles(?) morons(?) at CNN blew the lid off the farce just about as much as the BBC \"journalist\" did standing in front of WTC Building 7 doing a live broadcast announcing it's collapse with it still standing in the backdrop of the shot half an hour before the order came to \"pull it\" and the pre-set explosive demolition occurred.\nCrisis actors shouldn't be recycled if you want to fool anyone with a few brain-cells functioning.",
		"thread_title": "The Orlando Shooting and our reptilian minds",
		"title": "",
		"type": "bs",
		"uuid": "ddae3407c19f9dae5b33b8892a6a09722bd1b827"
	},
	"-KhIgVEtPS9BhLsWwV2A": {
		"author": "Mike Rivero",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-13T19:46:48.693+02:00",
		"domain_rank": "78393",
		"entities": [
			{
				"name": "Readers",
				"salience": 0.067028075,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.06700478,
				"type": "PERSON"
			},
			{
				"name": "Liz Spayd",
				"salience": 0.06535538,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.055161715,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.046497624,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.04636169,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.037012532,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6gkfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream_media"
				},
				"name": "MSM",
				"salience": 0.027433215,
				"type": "ORGANIZATION"
			},
			{
				"name": "opponents",
				"salience": 0.027307957,
				"type": "PERSON"
			},
			{
				"name": "Readers",
				"salience": 0.01660038,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.014707791,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.014039275,
				"type": "PERSON"
			},
			{
				"name": "Election",
				"salience": 0.013619926,
				"type": "EVENT"
			},
			{
				"name": "fight",
				"salience": 0.013563482,
				"type": "EVENT"
			},
			{
				"name": "LOSERS",
				"salience": 0.013046148,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.012932371,
				"type": "ORGANIZATION"
			},
			{
				"name": "reporters",
				"salience": 0.01209071,
				"type": "PERSON"
			},
			{
				"name": "Edge Alternative News On The Web",
				"salience": 0.009085069,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Michael Goodwin",
				"salience": 0.009010857,
				"type": "PERSON"
			},
			{
				"name": "Efforts",
				"salience": 0.0083367545,
				"type": "OTHER"
			},
			{
				"name": "Lies",
				"salience": 0.0083367545,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.007799143,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0069666887,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0063670776,
				"type": "OTHER"
			},
			{
				"name": "electors",
				"salience": 0.0061761527,
				"type": "PERSON"
			},
			{
				"name": "readers",
				"salience": 0.005957734,
				"type": "PERSON"
			},
			{
				"name": "Blinded By Journalistic Bigotry' - Boycott All Mainstream Media",
				"salience": 0.005929233,
				"type": "OTHER"
			},
			{
				"name": "All Original Stories All The Time",
				"salience": 0.005929233,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.0055771745,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0054486603,
				"type": "EVENT"
			},
			{
				"name": "few",
				"salience": 0.0052507804,
				"type": "PERSON"
			},
			{
				"name": "Turn Them Off And Tune Them Out!",
				"salience": 0.005135104,
				"type": "OTHER"
			},
			{
				"name": "The Best Mix Of Hard-Hitting REAL News & Cutting",
				"salience": 0.005135104,
				"type": "WORK_OF_ART"
			},
			{
				"name": "GASP",
				"salience": 0.0050971764,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.004939294,
				"type": "PERSON"
			},
			{
				"name": "riot",
				"salience": 0.004920131,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.004920131,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.004830129,
				"type": "PERSON"
			},
			{
				"name": "oxygen tanks",
				"salience": 0.0046849977,
				"type": "OTHER"
			},
			{
				"name": "headlines",
				"salience": 0.004677019,
				"type": "OTHER"
			},
			{
				"name": "Overthrow Of Our Republic And Their Continuing Provocations In Stirring Up Civil Strife - Let The New Battle Cry For Truth Be",
				"salience": 0.0045817685,
				"type": "WORK_OF_ART"
			},
			{
				"name": "party",
				"salience": 0.0045479224,
				"type": "ORGANIZATION"
			},
			{
				"name": "quote",
				"salience": 0.0042609815,
				"type": "OTHER"
			},
			{
				"name": "band",
				"salience": 0.0042609815,
				"type": "OTHER"
			},
			{
				"name": "meaning",
				"salience": 0.0042609815,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0042609815,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0042609815,
				"type": "OTHER"
			},
			{
				"name": "wind",
				"salience": 0.0042609815,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.004215037,
				"type": "PERSON"
			},
			{
				"name": "mea culpa",
				"salience": 0.0041204407,
				"type": "OTHER"
			},
			{
				"name": "convention",
				"salience": 0.003777122,
				"type": "EVENT"
			},
			{
				"name": "question",
				"salience": 0.003549195,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.0033141293,
				"type": "OTHER"
			},
			{
				"name": "Nick Crawford",
				"salience": 0.003233111,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton.",
				"salience": 0.003232186,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0032133567,
				"type": "OTHER"
			},
			{
				"name": "All News PipeLine Progressive",
				"salience": 0.0030294012,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.00300154,
				"type": "LOCATION"
			},
			{
				"name": "public",
				"salience": 0.0029924663,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0029065602,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/081k8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_Shakespeare"
				},
				"name": "William Shakespeare",
				"salience": 0.0026233522,
				"type": "PERSON"
			},
			{
				"name": "Susan Duclos",
				"salience": 0.0026233522,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.002591364,
				"type": "EVENT"
			},
			{
				"name": "decision",
				"salience": 0.0024547062,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0024395804,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0024289687,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.0022828132,
				"type": "PERSON"
			},
			{
				"name": "reporting",
				"salience": 0.0022372028,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.0022090178,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0021192103,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0021082726,
				"type": "OTHER"
			},
			{
				"name": "publisher",
				"salience": 0.0020983154,
				"type": "ORGANIZATION"
			},
			{
				"name": "paper",
				"salience": 0.0020661473,
				"type": "OTHER"
			},
			{
				"name": "reader",
				"salience": 0.0020554294,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.002044821,
				"type": "WORK_OF_ART"
			},
			{
				"name": "riots",
				"salience": 0.0020261272,
				"type": "EVENT"
			},
			{
				"name": "nomination.",
				"salience": 0.0020261272,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0020261272,
				"type": "PERSON"
			},
			{
				"name": "college",
				"salience": 0.0020261272,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0020261272,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0019272758,
				"type": "OTHER"
			},
			{
				"name": "progressives",
				"salience": 0.0019259299,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "letter",
				"salience": 0.00191921,
				"type": "WORK_OF_ART"
			},
			{
				"name": "editor",
				"salience": 0.00191921,
				"type": "PERSON"
			},
			{
				"name": "reporting",
				"salience": 0.0018972384,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.0018972384,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.0018655428,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.0018655428,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.0018457647,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0018306847,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jw67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Moore"
				},
				"name": "Michael Moore",
				"salience": 0.0018264365,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02l3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election"
				},
				"name": "ELECTION",
				"salience": 0.0017666526,
				"type": "EVENT"
			},
			{
				"name": "point",
				"salience": 0.0017623533,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.0017544819,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0017544819,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0017544819,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.0017544819,
				"type": "OTHER"
			},
			{
				"name": "pipe-dream",
				"salience": 0.0017544819,
				"type": "OTHER"
			},
			{
				"name": "Readers",
				"salience": 0.0017430728,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.001713025,
				"type": "PERSON"
			},
			{
				"name": "publisher",
				"salience": 0.001713025,
				"type": "ORGANIZATION"
			},
			{
				"name": "perspectives",
				"salience": 0.0017031047,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0016395329,
				"type": "ORGANIZATION"
			},
			{
				"name": "reader",
				"salience": 0.0016359887,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.001586786,
				"type": "WORK_OF_ART"
			},
			{
				"name": "editors",
				"salience": 0.0015667912,
				"type": "PERSON"
			},
			{
				"name": "editor",
				"salience": 0.0015667912,
				"type": "PERSON"
			},
			{
				"name": "letters",
				"salience": 0.0015667912,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.0015667912,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09rkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times"
				},
				"name": "The Times",
				"salience": 0.0014716894,
				"type": "ORGANIZATION"
			},
			{
				"name": "difference",
				"salience": 0.0014595744,
				"type": "OTHER"
			},
			{
				"name": "reader",
				"salience": 0.001459536,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.001458148,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.0014387252,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.0014205953,
				"type": "PERSON"
			},
			{
				"name": "media outlets",
				"salience": 0.0014205953,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.001390352,
				"type": "PERSON"
			},
			{
				"name": "news organizations",
				"salience": 0.0013698997,
				"type": "ORGANIZATION"
			},
			{
				"name": "home",
				"salience": 0.0013675644,
				"type": "LOCATION"
			},
			{
				"name": "losers",
				"salience": 0.0013675644,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0013675644,
				"type": "OTHER"
			},
			{
				"name": "deplorables",
				"salience": 0.0013675644,
				"type": "WORK_OF_ART"
			},
			{
				"name": "everything",
				"salience": 0.0013675644,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0013675644,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0013675644,
				"type": "OTHER"
			},
			{
				"name": "deplorables",
				"salience": 0.0013675644,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/02pjhgt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dean_Baquet"
				},
				"name": "Dean Baquet",
				"salience": 0.001366764,
				"type": "PERSON"
			},
			{
				"name": "journalists",
				"salience": 0.001358706,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.0012857324,
				"type": "OTHER"
			},
			{
				"name": "publisher",
				"salience": 0.0012796583,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.0012695297,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.0012694963,
				"type": "PERSON"
			},
			{
				"name": "Readers",
				"salience": 0.0012694963,
				"type": "PERSON"
			},
			{
				"name": "practices",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0012301042,
				"type": "PERSON"
			},
			{
				"name": "premise",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "life experiences",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "opinion.",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "honesty",
				"salience": 0.0012301042,
				"type": "OTHER"
			},
			{
				"name": "revolution",
				"salience": 0.0011841819,
				"type": "EVENT"
			},
			{
				"name": "obscurity",
				"salience": 0.0011841819,
				"type": "OTHER"
			},
			{
				"name": "celebrities",
				"salience": 0.0011841819,
				"type": "PERSON"
			},
			{
				"name": "wave",
				"salience": 0.0011841819,
				"type": "OTHER"
			},
			{
				"name": "prism",
				"salience": 0.0011841819,
				"type": "OTHER"
			},
			{
				"name": "descriptors.",
				"salience": 0.0011841819,
				"type": "OTHER"
			},
			{
				"name": "ink",
				"salience": 0.0011841819,
				"type": "OTHER"
			},
			{
				"name": "aisle",
				"salience": 0.0011765109,
				"type": "OTHER"
			},
			{
				"name": "editors",
				"salience": 0.0011704062,
				"type": "PERSON"
			},
			{
				"name": "editors",
				"salience": 0.0011704062,
				"type": "PERSON"
			},
			{
				"name": "election result",
				"salience": 0.0011692585,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0011597037,
				"type": "LOCATION"
			},
			{
				"name": "surprise",
				"salience": 0.0011597037,
				"type": "OTHER"
			},
			{
				"name": "mea culpas",
				"salience": 0.0011450887,
				"type": "OTHER"
			},
			{
				"name": "law firm",
				"salience": 0.0011256068,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0011084061,
				"type": "PERSON"
			},
			{
				"name": "readers",
				"salience": 0.0010902768,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0010798655,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.0010798655,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.0010798655,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobic",
				"salience": 0.0010798655,
				"type": "OTHER"
			},
			{
				"name": "fairness",
				"salience": 0.0010346055,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0010041856,
				"type": "WORK_OF_ART"
			},
			{
				"name": "shock",
				"salience": 0.0010041856,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.0010041856,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0010041856,
				"type": "LOCATION"
			},
			{
				"name": "nonreaders",
				"salience": 0.0010041856,
				"type": "PERSON"
			},
			{
				"name": "skyscraper",
				"salience": 0.0010041856,
				"type": "LOCATION"
			},
			{
				"name": "feelings",
				"salience": 0.0010041856,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0010041856,
				"type": "PERSON"
			},
			{
				"name": "complaint",
				"salience": 0.0010041856,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.0010041856,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0010007902,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.0009915299,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0009594651,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00095451146,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00093838014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0009322224,
				"type": "ORGANIZATION"
			},
			{
				"name": "findings",
				"salience": 0.0009306033,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00087341946,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0008662815,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stories",
				"salience": 0.0008662815,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bias",
				"salience": 0.0008662815,
				"type": "OTHER"
			},
			{
				"name": "fairness",
				"salience": 0.0008662815,
				"type": "OTHER"
			},
			{
				"name": "bigotry",
				"salience": 0.0008662815,
				"type": "OTHER"
			},
			{
				"name": "subscriptions",
				"salience": 0.0008662815,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0008662815,
				"type": "WORK_OF_ART"
			},
			{
				"name": "readers",
				"salience": 0.00081441633,
				"type": "PERSON"
			},
			{
				"name": "readers",
				"salience": 0.00081441633,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03l2n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houston"
				},
				"name": "Houston",
				"salience": 0.000790515,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Mich.",
				"salience": 0.000790515,
				"type": "LOCATION"
			},
			{
				"name": "reporting",
				"salience": 0.0007710285,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.00077048986,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06tnj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arthur_Ochs_Sulzberger,_Jr."
				},
				"name": "Arthur O. Sulzberger Jr.",
				"salience": 0.00075707043,
				"type": "PERSON"
			},
			{
				"name": "perspective",
				"salience": 0.0007563717,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "roots",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "bubble",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "writers",
				"salience": 0.0007501029,
				"type": "PERSON"
			},
			{
				"name": "tenet",
				"salience": 0.0007501029,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "news room",
				"salience": 0.0007501029,
				"type": "LOCATION"
			},
			{
				"name": "guarantee",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0007501029,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.000714028,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.00068945356,
				"type": "OTHER"
			},
			{
				"name": "letters",
				"salience": 0.00063669874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "something",
				"salience": 0.00063087564,
				"type": "OTHER"
			},
			{
				"name": "biases",
				"salience": 0.00063087564,
				"type": "OTHER"
			},
			{
				"name": "t change",
				"salience": 0.00063087564,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.00062805694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vrv1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Plymouth,_Michigan"
				},
				"name": "Plymouth",
				"salience": 0.0006180121,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0006180121,
				"type": "LOCATION"
			},
			{
				"name": "Kathleen Casey",
				"salience": 0.0006180121,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0006027771,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0005657341,
				"type": "ORGANIZATION"
			},
			{
				"name": "perspectives",
				"salience": 0.00056498114,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.000548393,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "conclusions",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "slant",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "news sites",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "hearts",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.0005462626,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.0005462626,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.0005258654,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00052193203,
				"type": "OTHER"
			},
			{
				"name": "kitchen sink",
				"salience": 0.00049984874,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.000496626,
				"type": "LOCATION"
			},
			{
				"name": "Trump.It",
				"salience": 0.00048818957,
				"type": "ORGANIZATION"
			},
			{
				"name": "anybody",
				"salience": 0.00047123578,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00047123578,
				"type": "LOCATION"
			},
			{
				"name": "subscribers",
				"salience": 0.00047123578,
				"type": "PERSON"
			},
			{
				"name": "outlets",
				"salience": 0.00047123578,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00046162683,
				"type": "OTHER"
			},
			{
				"name": "video clips",
				"salience": 0.00044592013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "links",
				"salience": 0.00044592013,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.00044029928,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "campaign season",
				"salience": 0.000408031,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "invitations",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "gatherings",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "campaign staff",
				"salience": 0.000408031,
				"type": "PERSON"
			},
			{
				"name": "carpet",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "ascension",
				"salience": 0.000408031,
				"type": "EVENT"
			},
			{
				"name": "audiences",
				"salience": 0.000408031,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "betrayal",
				"salience": 0.000408031,
				"type": "OTHER"
			},
			{
				"name": "determinations",
				"salience": 0.00040288767,
				"type": "OTHER"
			},
			{
				"name": "LINE",
				"salience": 0.0003878434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/075qbd2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Independent_politician"
				},
				"name": "Independent",
				"salience": 0.00033617186,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gray Lady",
				"salience": 0.00033617186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xcy2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Campaign"
				},
				"name": "HRC",
				"salience": 0.00025109964,
				"type": "ORGANIZATION"
			},
			{
				"name": "Amy Chozick",
				"salience": 0.00025109964,
				"type": "PERSON"
			},
			{
				"name": "Patrick Healy",
				"salience": 0.00025109964,
				"type": "PERSON"
			},
			{
				"name": "Maggie Haberman",
				"salience": 0.00025109964,
				"type": "PERSON"
			},
			{
				"name": "Jonathan Martin",
				"salience": 0.00025109964,
				"type": "PERSON"
			},
			{
				"name": "Gail Collins",
				"salience": 0.0001223903,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-13T19:46:48.693+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "allnewspipeline.com",
		"spam_score": "0",
		"text": "\"The Best Mix Of Hard-Hitting REAL News & Cutting-Edge Alternative News On The Web\" \"All Original Stories All The Time\" Share This November 12, 2016 Readers Enraged By MSM Election Reporting - 'You Misled Your Readers, Blinded By Journalistic Bigotry' - Boycott All Mainstream Media And Their Lies In Their Efforts To Initiate The Overthrow Of Our Republic And Their Continuing Provocations In Stirring Up Civil Strife - Let The New Battle Cry For Truth Be \"Turn Them Off And Tune Them Out!\" By Susan Duclos - All News PipeLine Progressive liberals, George Soros and his merry band of paid protesters, and the mainstream media are certainly giving new meaning to William Shakespeare's \" Fight to the last gasp ,\" quote, but what none of them seem to realize yet as they cry, scream, riot and offer their mea culpa's is that the fight is over, the election is finished, their opponents have gone home to celebrate and they are doing nothing but flailing in the wind while grunting incoherently.While anyone can see the headlines about the third day of protests and riots, and how those that are incapable of understanding quite how elections work and are holding out for a pipe-dream that maybe they can make electors of the electoral college change their vote, what many are missing is how the mainstream media is attempting to suck more air out oxygen tanks that have gone empty.... and they have no one to blame but themselves. THE ULTIMATE LOSERS IN THE 2016 ELECTION - THE MSM For the last year and a half we have witnessed and reported on the mainstream media's unrelenting and unapologetic campaign against Donald Trump, where 91 percent of the reporting since the party's convention, where he was named the GOP nominee, has been studied and found to have been negative, but even before that they treated Trump as if he didn't stand a chance to win that nomination.We have noted and reported via Wikileaks releases how that very same MSM had colluded with the DNC and the Clinton campaign in order to influence the public to elect Hillary Clinton.We have also observed and reported how Trump supporters were constantly labeled and portrayed as racist, sexist, xenophobic, Islamophobic, uneducated, uninformed, white nationalist deplorables, just to name a few of the colorful descriptors.How did that work out for them?Despite their biased reporting and throwing everything, including the kitchen sink, at Trump, we now have President-Elect Donald Trump headed for the White House, to be sworn in on January 20, 2017. While Hillary Clinton will fade into obscurity and the protesters will eventually go home just to criticize everything Trump does for the next four (maybe 8?) years, and progressives will get over their sworn \"revolution\" within the party between liberals and moderate Democrats, the ultimate losers are not Clinton supporters, celebrities that swore to leave the country if Trump won, nor Democrats as a party.... it is the mainstream media that was rendered irrelevant, crushed by a wave of \"deplorables\" and alternative media bypassing their once-influential status to communicate without their fasle prism of 'truth.' MSM'S LAST GASP Now they are offering their mea culpas, dedicating countless hours and ink to explaining and justifying how they were so wrong in their predictions that they knew ahead of time were based on a false premise, and taking their \"last gasp\" by swearing to \"rededicate\" themselves to reporting honestly, while at the same time claiming they reported on \"both candidates fairly.\"I kid you not.Below is a letter by Arthur O. Sulzberger Jr. and Dean Baquet, the publisher and editor of the New York Times:First point is that if they had been reporting \"fairly\" as claimed in the letter above, they would not need to \"rededicate\" themselves to honesty. Secondly, they did not strive \"to understand and reflect all political perspectives and life experiences,\" of Trump supporters, rather they maligned, criticized, belittled and mocked anybody that did not agree with their superior and smug political opinion.While it is to be expected that Trump supporters, verbally abused on a regular basis will not forget nor forgive media outlets such as the Times, the Public Editor Liz Spayd, who works independently, with the job of examining The Times with an eye to protecting journalistic integrity and good practices, describes the reaction from other members of the public to their reporting. Readers are sending letters of complaint at a rapid rate. Heres one that summed up the feelings succinctly, from Kathleen Casey of Houston: \"Now, that the world has been upended and you are all, to a person, in a state of surprise and shock, you may want to consider whether you should change your focus from telling the reader what and how to think, and instead devote yourselves to finding out what the reader (and nonreaders) actually think.\" Another letter, from Nick Crawford of Plymouth, Mich., made a similar point. \"Perhaps the election result would not be such a surprise if your reporting had acknowledged what ordinary Americans care about, rather than pushing the limited agenda of your editors,\" he wrote. \"Please come down from your New York City skyscraper and join the rest of us.\" What Ms. Spayd does not acknowledge is that their reporting will not and cannot change as long as their publisher and editor, the ones that wrote the letter in the image above, continue to insist their reporting during the campaign season was in any way fair, or to even pretend they attempted to \"understand and reflect all political perspectives.\" What Ms. Spayd also does not address is the fact that five different New York Times' reporters accepted the invitations for the off-the-record gatherings to \"frame the HRC message\" with the Clinton campaign staff before her campaign launched, including, Gail Collins, Jonathan Martin, Maggie Haberman, Patrick Healy, and Amy Chozick, all of which consistently penned hit pieces against Trump.It is heartening to see that outlets like the New York Times are being called to the carpet by their own readers, as well as admitting they are losing subscribers, because while Trump supporters were maligned and lied about, their readers were misinformed and lied to . The countrys major news organizations, as surprised as anybody by Donald J. Trumps ascension to the presidency, faced a question from their audiences on Wednesday that was laced with a sense of betrayal and anger: How did you get it so wrong? The question came in letters. (\"To editors and writers of The NYT,\" one reader wrote, \"you were so wrong for so long. You misled your readers and were blinded by your own journalistic bigotry.\") It came in Facebook posts. (\"You were in a bubble and werent paying attention to your fellow Americans,\" the filmmaker Michael Moore wrote in a post shared more than 100,000 times.) Most ominously, it came in the form of canceled subscriptions, something that will surely be monitored. Former Times' reporter Michael Goodwin offers the Times some free advice : Using an outside law firm or even in-house reporters, he must assess how and why Baquet made the decision to sever the paper from its roots. He must assess the impact on reporters and editors, and whether they felt pressure to conform their stories to Baquets political bias. Whatever the findings, the publisher must insist that the standards of fairness again become a fundamental tenet in the news room. As an added guarantee, he must insist that the paper enlarge its thinking about diversity to include journalists who disagree with the Times embedded liberal slant. There has to be a difference of perspective to judge where fairness lies. Readers, and former readers, should be part of the process. Many already know that the paper must get its head out of parochial New York and into the hearts and minds of Americans everywhere. This is about survival. If it doesnt change now, the Gray Ladys days surely are numbered. BOTTOM LINE Frankly I believe traditional media's days are numbered whatever they do, and they are on their last gasp. There are too many Independent journalists and alternative news sites from both sides of the political aisle that are rendering them irrelevant. While alternative media has its own set of biases, the majority always provide links, documents when available, video clips and other methods for readers to verify, research and come to their own conclusions, something mainstream media doesn't want readers to do because they feel they have the right to lead the public where the MSM wants them to go, rather than inform the public and trust them to make their own determinations.",
		"thread_title": "Readers Enraged By MSM Election Reporting - 'You Misled Your Readers, Blinded By Journalistic Bigotry'",
		"title": "Readers Enraged By MSM Election Reporting - 'You Misled Your Readers, Blinded By Journalistic Bigotry'",
		"type": "bs",
		"uuid": "3cc564e1268986f8274dffa9cbe69f3785d5fa83"
	},
	"-KhIgVQuMN_5_w3Qygki": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T23:33:16.110+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "staffers",
				"salience": 0.27792835,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.06522294,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.055115134,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.051299993,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.051299993,
				"type": "EVENT"
			},
			{
				"name": "De'Ara Balenger",
				"salience": 0.047750875,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.045813635,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.045536626,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03ksy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_University"
				},
				"name": "Harvard University",
				"salience": 0.041612297,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.03183691,
				"type": "ORGANIZATION"
			},
			{
				"name": "BizPac Review",
				"salience": 0.03183691,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "The Guardian",
				"salience": 0.02524469,
				"type": "WORK_OF_ART"
			},
			{
				"name": "agenda",
				"salience": 0.021383254,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_s50g8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shooting_of_Jordan_Davis"
				},
				"name": "Michael David Dunn",
				"salience": 0.0143471835,
				"type": "PERSON"
			},
			{
				"name": "essay",
				"salience": 0.010964807,
				"type": "WORK_OF_ART"
			},
			{
				"name": "study",
				"salience": 0.010964807,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.010964807,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0098372,
				"type": "PERSON"
			},
			{
				"name": "crime",
				"salience": 0.008355215,
				"type": "OTHER"
			},
			{
				"name": "mother",
				"salience": 0.007894375,
				"type": "PERSON"
			},
			{
				"name": "teenager",
				"salience": 0.0076972367,
				"type": "PERSON"
			},
			{
				"name": "narratives",
				"salience": 0.007410691,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.007410691,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.007410691,
				"type": "PERSON"
			},
			{
				"name": "ideas",
				"salience": 0.007410691,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.007410691,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "article",
				"salience": 0.0067827655,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05lr56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marie_Claire"
				},
				"name": "Marie Claire",
				"salience": 0.006759547,
				"type": "PERSON"
			},
			{
				"name": "anti-gun",
				"salience": 0.0064480705,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0062869517,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0062869517,
				"type": "OTHER"
			},
			{
				"name": "lynching",
				"salience": 0.0062869517,
				"type": "OTHER"
			},
			{
				"name": "murderer",
				"salience": 0.0060527707,
				"type": "PERSON"
			},
			{
				"name": "flag",
				"salience": 0.0060527707,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.006007606,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.0041615935,
				"type": "WORK_OF_ART"
			},
			{
				"name": "music",
				"salience": 0.0036016947,
				"type": "WORK_OF_ART"
			},
			{
				"name": "staffer",
				"salience": 0.0034390849,
				"type": "PERSON"
			},
			{
				"name": "shares",
				"salience": 0.003423739,
				"type": "OTHER"
			},
			{
				"name": "gun violence",
				"salience": 0.003423739,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.003423739,
				"type": "OTHER"
			},
			{
				"name": "excitement",
				"salience": 0.0025582043,
				"type": "OTHER"
			},
			{
				"name": "engagement",
				"salience": 0.0025582043,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.0025582043,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0021080347,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hillary for America",
				"salience": 0.0018186894,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americanlookout.com/wp-content/uploads/2016/09/Hillary-cyber-security-600x315.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:33:16.110+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "americanlookout.com",
		"spam_score": "0.028",
		"text": "\nFrom BizPac Review: \nNewly released emails from Wikileaks show Hillary Clinton staffers debating how they can best use the death of a black man to further their agenda. \nThe email began as a request for an essay by Clinton from Marie Claire who was partnering with Harvard University on a study about women and guns but it quickly devolved into brainstorming ideas on how to push the campaign’s anti-gun and racial narratives. \nThe team began discussing an article published in “The Guardian” where the mother of Jordan Davis, a black teenager murdered by a white man for playing music loud, called the killing a “legal lynching” despite the fact that the murderer, Michael David Dunn, was convicted and sentenced to life in prison. \nDe’Ara Balenger, the director of engagement for “Hillary for America” could hardly contain her excitement. \n“This is great,” she wrote. “The only flag here is that Jordan Davis was killed by a white man, so arguably – this crime was racially motivated, which takes this outside the discussion of gun violence. \nSee the email below: \nImagine if a Republican staffer had said this. shares ",
		"thread_title": "WIKILEAKS: Hillary Staffers Were Happy About Killing of Black Teen to Advance Gun Control “This is Great” – American Lookout",
		"title": "WIKILEAKS: Hillary Staffers Were Happy About Killing of Black Teen to Advance Gun Control “This is Great” – American Lookout",
		"type": "bs",
		"uuid": "3e504541190d38d966654463bed9a2ef1decd898"
	},
	"-KhIgVgp--0_i1i-0j_G": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T18:07:57.698+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.14180616,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.11945456,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.114129335,
				"type": "PERSON"
			},
			{
				"name": "immigrant",
				"salience": 0.048894987,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco",
				"salience": 0.045066506,
				"type": "LOCATION"
			},
			{
				"name": "Immigrants",
				"salience": 0.028240053,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04q85lk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Chiu_(politician)"
				},
				"name": "David Chiu",
				"salience": 0.021865949,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.021008648,
				"type": "ORGANIZATION"
			},
			{
				"name": "immigrants",
				"salience": 0.020230627,
				"type": "PERSON"
			},
			{
				"name": "Cities",
				"salience": 0.01977393,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.016574983,
				"type": "ORGANIZATION"
			},
			{
				"name": "conspiracy theories",
				"salience": 0.0154814385,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0154814385,
				"type": "OTHER"
			},
			{
				"name": "media allies",
				"salience": 0.0154814385,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0154814385,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.015137667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ppwk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alien_(law)"
				},
				"name": "Noncitizen",
				"salience": 0.011974957,
				"type": "PERSON"
			},
			{
				"name": "Immigrants",
				"salience": 0.011686937,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.011686937,
				"type": "PERSON"
			},
			{
				"name": "Immigrants",
				"salience": 0.010763625,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010441439,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09rnklz"
				},
				"name": "Ron Hayduk",
				"salience": 0.008305115,
				"type": "PERSON"
			},
			{
				"name": "Cities",
				"salience": 0.008169019,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.007377475,
				"type": "LOCATION"
			},
			{
				"name": "integrity",
				"salience": 0.007377475,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.007377475,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.007377475,
				"type": "EVENT"
			},
			{
				"name": "school board elections",
				"salience": 0.0073275324,
				"type": "EVENT"
			},
			{
				"name": "immigrants",
				"salience": 0.006699236,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.00639005,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00639005,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00639005,
				"type": "OTHER"
			},
			{
				"name": "daylight",
				"salience": 0.00639005,
				"type": "OTHER"
			},
			{
				"name": "noncitizens",
				"salience": 0.006370758,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.005910709,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.005731447,
				"type": "ORGANIZATION"
			},
			{
				"name": "school system",
				"salience": 0.005731447,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.005731447,
				"type": "OTHER"
			},
			{
				"name": "latest",
				"salience": 0.0055593248,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0055178157,
				"type": "LOCATION"
			},
			{
				"name": "right",
				"salience": 0.005114102,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.004982715,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.00468022,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.004482477,
				"type": "PERSON"
			},
			{
				"name": "visas",
				"salience": 0.004482477,
				"type": "OTHER"
			},
			{
				"name": "cards",
				"salience": 0.004482477,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.004482477,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.004482477,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.004472055,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.004315329,
				"type": "LOCATION"
			},
			{
				"name": "student",
				"salience": 0.004315329,
				"type": "PERSON"
			},
			{
				"name": "guardians",
				"salience": 0.004315329,
				"type": "PERSON"
			},
			{
				"name": "claims",
				"salience": 0.004315329,
				"type": "OTHER"
			},
			{
				"name": "measure",
				"salience": 0.004315329,
				"type": "OTHER"
			},
			{
				"name": "election fraud",
				"salience": 0.004315329,
				"type": "OTHER"
			},
			{
				"name": "voting rights",
				"salience": 0.0042291777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.004021461,
				"type": "ORGANIZATION"
			},
			{
				"name": "voice",
				"salience": 0.0039994726,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0039355825,
				"type": "ORGANIZATION"
			},
			{
				"name": "immigrants",
				"salience": 0.003717076,
				"type": "PERSON"
			},
			{
				"name": "say",
				"salience": 0.0036600353,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0032244294,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0031578275,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.0031578275,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0028768484,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.002763925,
				"type": "LOCATION"
			},
			{
				"name": "democracy",
				"salience": 0.0027574708,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0027346336,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0024341294,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01hlpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/K%E2%80%9312"
				},
				"name": "K-12",
				"salience": 0.0022533617,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06f32",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taiwan"
				},
				"name": "Taiwanese",
				"salience": 0.0022533617,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0022166383,
				"type": "LOCATION"
			},
			{
				"name": "noncitizens",
				"salience": 0.0021978454,
				"type": "PERSON"
			},
			{
				"name": "enterprise",
				"salience": 0.002122243,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0019918913,
				"type": "OTHER"
			},
			{
				"name": "non-citizens",
				"salience": 0.0019918913,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0019918913,
				"type": "OTHER"
			},
			{
				"name": "shares",
				"salience": 0.0019918913,
				"type": "OTHER"
			},
			{
				"name": "immigration system",
				"salience": 0.0019032173,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0017184387,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0016974774,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/013807",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco_State_University"
				},
				"name": "San Francisco State University",
				"salience": 0.0016834139,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.0014880433,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.0014880433,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americanlookout.com/wp-content/uploads/2016/07/old-voters-600x315.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T18:07:57.698+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "americanlookout.com",
		"spam_score": "0.004",
		"text": "WHAT? Some Cities Are Now Pushing For Noncitizen Immigrants TO VOTE shares \nEvery time Donald Trump suggests the election could be rigged in some way, Democrats and their many media allies scoff and laugh, then accuse Trump of promoting conspiracy theories. \nAt the same time, the left is trying to steal the election in broad daylight. \nBloomberg reports: \nSome Cities Want Their Noncitizen Immigrants to Vote \n“Look at illegal immigrants voting all over the country,” Donald Trump recently claimed in a Fox News interview, part of his ongoing effort to cast doubt on the integrity of the presidential election. There’s no evidence to support the Republican nominee’s claims of election fraud, but some cities are moving to expand voting rights to include noncitizens. \nThe latest is San Francisco, where the Nov. 8 ballot will include a measure allowing the parents or legal guardians of any student in the city’s public schools to vote in school board elections. The right would be extended to those with green cards, visas, or no documentation at all. “One out of three kids in the San Francisco unified school system has a parent who is an immigrant, who is disenfranchised and doesn’t have a voice,” says San Francisco Assemblyman David Chiu, the son of Taiwanese immigrants. “We’ve had legal immigrants who’ve had children go through the entire K-12 system without having a say.” Undocumented immigrants should also have the right, Chiu adds, to bypass the “broken immigration system in this country.” \nNoncitizen voting isn’t as radical as it might sound. For more than half of U.S. history, from 1776 until the 1920s, noncitizens were widely permitted to participate in elections. “We had 40 states that used to allow it,” says Ron Hayduk, an associate professor of political science at San Francisco State University. “Immigrants could vote, not just in local elections,” he says. “They could even run for office—and did win office.” The hope, Hayduk says, was that immigrants would feel more invested in civic life if they were able to participate in American democracy. \nDo you think Democrats would want non-citizens to vote if they tended to vote Republican? \nOf course not. \nThe Democrat party is a criminal enterprise and they’ll do whatever they have to do to win. shares ",
		"thread_title": "WHAT? Some Cities Are Now Pushing For Noncitizen Immigrants TO VOTE – American Lookout",
		"title": "WHAT? Some Cities Are Now Pushing For Noncitizen Immigrants TO VOTE – American Lookout",
		"type": "bs",
		"uuid": "bcd385dbdf1c77d453c6bbb6d30d6e5c6b0ad361"
	},
	"-KhIgVswH2jL6mkAftzB": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T23:54:04.371+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.37552062,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.26261887,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.033130486,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.03012675,
				"type": "ORGANIZATION"
			},
			{
				"name": "shares",
				"salience": 0.02765749,
				"type": "OTHER"
			},
			{
				"name": "gloves",
				"salience": 0.024312291,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Ties",
				"salience": 0.024011048,
				"type": "OTHER"
			},
			{
				"name": "VIDEO",
				"salience": 0.024011048,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.024011048,
				"type": "EVENT"
			},
			{
				"name": "New Ad",
				"salience": 0.023073314,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.019472504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.014873603,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.011838193,
				"type": "WORK_OF_ART"
			},
			{
				"name": "television ad",
				"salience": 0.008319716,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.0065330258,
				"type": "EVENT"
			},
			{
				"name": "email server",
				"salience": 0.006365657,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.00534798,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email scandal",
				"salience": 0.005112354,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.0047083,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "campaign",
				"salience": 0.0044123065,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.004252314,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.00405395,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pervert",
				"salience": 0.003987668,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.0035877277,
				"type": "OTHER"
			},
			{
				"name": "mark",
				"salience": 0.0034980632,
				"type": "OTHER"
			},
			{
				"name": "ad targets",
				"salience": 0.0034540726,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.003382821,
				"type": "PERSON"
			},
			{
				"name": "aide",
				"salience": 0.003382821,
				"type": "PERSON"
			},
			{
				"name": "ad",
				"salience": 0.0032867778,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0031078903,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.0029299913,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0027997298,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.002250641,
				"type": "PERSON"
			},
			{
				"name": "laptop",
				"salience": 0.0021896258,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "material",
				"salience": 0.0021896258,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sjhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Examiner"
				},
				"name": "Washington Examiner",
				"salience": 0.0021275312,
				"type": "ORGANIZATION"
			},
			{
				"name": "discovery",
				"salience": 0.0020552394,
				"type": "EVENT"
			},
			{
				"name": "narrator",
				"salience": 0.0019048029,
				"type": "PERSON"
			},
			{
				"name": "shares",
				"salience": 0.0018419808,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0018419808,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.001524192,
				"type": "EVENT"
			},
			{
				"name": "unsecured server",
				"salience": 0.0013762688,
				"type": "OTHER"
			},
			{
				"name": "handling",
				"salience": 0.0011918102,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0011918102,
				"type": "PERSON"
			},
			{
				"name": "Unfit",
				"salience": 0.0011340631,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americanlookout.com/wp-content/uploads/2016/11/Hillary-Weiner-ad-600x315.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-03T23:54:04.371+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "americanlookout.com",
		"spam_score": "0.105",
		"text": "WOW! Trump Ties Hillary To Pervert Anthony Weiner in New Ad (VIDEO) shares Facebook \nIn these final days of the election the gloves have truly come off. Trump has just released a new ad which ties Hillary’s email scandal and the new FBI investigation to Anthony Weiner, the husband of Hillary aide Huma Abedin. \nThe Washington Examiner reports: \nNew Trump ad targets ‘pervert’ Anthony Weiner, dubs Clinton ‘unfit to serve’ \nDonald Trump’s campaign has capitalized on the latest developments surrounding Hillary Clinton’s private email server, releasing a new television ad on Thursday that ties the Democratic presidential hopeful directly to disgraced ex-Congressman Anthony Weiner. \nWeiner, the estranged husband of top Clinton aide Huma Abedin, came back to haunt Democrats last week after FBI officials uncovered more than 650,000 new emails on a device of his, some of which may have originated from Clinton’s unsecured server. The discovery led FBI Director James Comey to reopen the agency’s investigation into Clinton’s handling of classified material. \n“Hillary Clinton is under FBI investigation again after her emails were found on pervert Anthony Weiner’s laptop,” says the narrator of the 30-second ad, which the Trump campaign titled “Unfit.” \nWatch the ad below: \nOuch! That’s gonna leave a mark! shares ",
		"thread_title": "WOW! Trump Ties Hillary To Pervert Anthony Weiner in New Ad (VIDEO) – American Lookout",
		"title": "WOW! Trump Ties Hillary To Pervert Anthony Weiner in New Ad (VIDEO) – American Lookout",
		"type": "bs",
		"uuid": "21cba2477502f0b7057f1eb03f51f649d3d7d746"
	},
	"-KhIgWPhhgs2BTSu8OdO": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T07:32:50.426+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan.",
				"salience": 0.4460138,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.17794874,
				"type": "PERSON"
			},
			{
				"name": "Della Melton",
				"salience": 0.13236757,
				"type": "PERSON"
			},
			{
				"name": "MOVEMENT",
				"salience": 0.08236698,
				"type": "ORGANIZATION"
			},
			{
				"name": "@DellaMelton57",
				"salience": 0.027396962,
				"type": "OTHER"
			},
			{
				"name": "@SoCal4Trump",
				"salience": 0.008611504,
				"type": "PERSON"
			},
			{
				"name": "Students",
				"salience": 0.008203982,
				"type": "PERSON"
			},
			{
				"name": "Crowd",
				"salience": 0.0079649165,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.007669009,
				"type": "PERSON"
			},
			{
				"name": "@asamjulian",
				"salience": 0.006047306,
				"type": "PERSON"
			},
			{
				"name": "@ChrisSnyderFox",
				"salience": 0.005822358,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.005760654,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.005760654,
				"type": "OTHER"
			},
			{
				"name": "View",
				"salience": 0.0055463286,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0055463286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.005393254,
				"type": "LOCATION"
			},
			{
				"name": "pic.twitter.com/8Hsibo968U",
				"salience": 0.0053268885,
				"type": "OTHER"
			},
			{
				"name": "2016 Trump",
				"salience": 0.0050642113,
				"type": "PERSON"
			},
			{
				"name": "MakeAmericaGreatAgain",
				"salience": 0.0050592604,
				"type": "LOCATION"
			},
			{
				"name": "pic.twitter.com/WbEfBcq3SQ",
				"salience": 0.004519435,
				"type": "OTHER"
			},
			{
				"name": "@MajorCBS",
				"salience": 0.00369295,
				"type": "OTHER"
			},
			{
				"name": "Asa J",
				"salience": 0.0035502338,
				"type": "OTHER"
			},
			{
				"name": "Chris Snyder",
				"salience": 0.0034179557,
				"type": "PERSON"
			},
			{
				"name": "@TopCapitalist",
				"salience": 0.002899289,
				"type": "OTHER"
			},
			{
				"name": "@DanScavino",
				"salience": 0.0026910568,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.0026509084,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0025632188,
				"type": "EVENT"
			},
			{
				"name": "lifetime",
				"salience": 0.0025632188,
				"type": "OTHER"
			},
			{
				"name": "pic.twitter.com/BoUQoz3HJV",
				"salience": 0.0024616076,
				"type": "OTHER"
			},
			{
				"name": "Major Garrett",
				"salience": 0.0021666118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0021666118,
				"type": "LOCATION"
			},
			{
				"name": "rally",
				"salience": 0.0019153594,
				"type": "EVENT"
			},
			{
				"name": "amphitheater",
				"salience": 0.0019153594,
				"type": "LOCATION"
			},
			{
				"name": "Trump pic.twitter.com/2P3sWWAB0G",
				"salience": 0.0018393986,
				"type": "OTHER"
			},
			{
				"name": "Dan Scavino Jr.",
				"salience": 0.0015783685,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vcdq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sterling_Heights,_Michigan"
				},
				"name": "Sterling Heights",
				"salience": 0.001179233,
				"type": "LOCATION"
			},
			{
				"name": "@realDonaldTrump",
				"salience": 0.001179233,
				"type": "OTHER"
			},
			{
				"name": "Campaign2016",
				"salience": 0.001179233,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americanlookout.com/wp-content/uploads/2016/11/Trump-in-Michigan-600x315.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-07T18:30:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.1,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "americanlookout.com",
		"spam_score": "0.71",
		"text": "\n— Della Melton (@DellaMelton57) November 7, 2016 Here's the crowd to see Trump in Michigan tonight. WOW! This is a MOVEMENT! In 2 days we are going to #MakeAmericaGreatAgain ! pic.twitter.com/WRj0VKQemn \n— Students for Trump (@SoCal4Trump) November 7, 2016 View of the crowd watching Trump tonight in Michigan pic.twitter.com/8Hsibo968U \n— Chris Snyder (@ChrisSnyderFox) November 7, 2016 Trump invited a group of kids on stage in Michigan! Crowd shouts “USA! USA!” pic.twitter.com/2pA5Lyl0Hk \n— Asa J 🇺🇸 (@asamjulian) November 7, 2016 25,000 for Trump in Michigan.Michigan is going red this year. pic.twitter.com/WbEfBcq3SQ \n— Top Capitalist 🇺🇸 (@TopCapitalist) November 7, 2016 360 degrees @realDonaldTrump rally Sterling Heights, Michigan. Raucous crowd spilled out of amphitheater #Campaign2016 #Trump pic.twitter.com/2P3sWWAB0G \n— Major Garrett (@MajorCBS) November 7, 2016 500+ days of campaigning across America – comes down to just 2 days before the biggest election of our lifetime. This was MICHIGAN tonight. pic.twitter.com/BoUQoz3HJV \n— Dan Scavino Jr. (@DanScavino) November 7, 2016 \nAmazing! ",
		"thread_title": "WOW! Look At The HUGE CROWD That Showed Up To See Trump IN MICHIGAN (PICS AND VIDEO) – American Lookout",
		"title": "WOW! Look At The HUGE CROWD That Showed Up To See Trump IN MICHIGAN (PICS AND VIDEO) – American Lookout",
		"type": "bs",
		"uuid": "437c74730c3670742e6d4da7cd7b84842a793099"
	},
	"-KhIgWh3NxCssBTlWmCm": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-10T21:56:30.578+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.618761,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025wqnl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Don_Lemon"
				},
				"name": "Don Lemon",
				"salience": 0.06525528,
				"type": "PERSON"
			},
			{
				"name": "CAMERAMAN",
				"salience": 0.02846577,
				"type": "PERSON"
			},
			{
				"name": "Protester",
				"salience": 0.026329504,
				"type": "PERSON"
			},
			{
				"name": "VIDEO",
				"salience": 0.026329504,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Nuts",
				"salience": 0.021713132,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.021639524,
				"type": "OTHER"
			},
			{
				"name": "shares",
				"salience": 0.020651573,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.016095519,
				"type": "WORK_OF_ART"
			},
			{
				"name": "end",
				"salience": 0.014869168,
				"type": "EVENT"
			},
			{
				"name": "crew members",
				"salience": 0.012810565,
				"type": "PERSON"
			},
			{
				"name": "Hillary Loss",
				"salience": 0.01276691,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.010931115,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protesters",
				"salience": 0.010931115,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025smhq"
				},
				"name": "Brian",
				"salience": 0.009612656,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.008557138,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0076773386,
				"type": "WORK_OF_ART"
			},
			{
				"name": "clip",
				"salience": 0.006676538,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0060902727,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.006007533,
				"type": "PERSON"
			},
			{
				"name": "version",
				"salience": 0.00578393,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meltdown",
				"salience": 0.00578393,
				"type": "EVENT"
			},
			{
				"name": "clip",
				"salience": 0.005593538,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cameramen",
				"salience": 0.00554446,
				"type": "PERSON"
			},
			{
				"name": "guy",
				"salience": 0.004907,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0042346,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.003417075,
				"type": "PERSON"
			},
			{
				"name": "cameraman",
				"salience": 0.0027638732,
				"type": "PERSON"
			},
			{
				"name": "credibility",
				"salience": 0.002672429,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.002672429,
				"type": "EVENT"
			},
			{
				"name": "name",
				"salience": 0.0019968697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024gm7"
				},
				"name": "John",
				"salience": 0.0012293489,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.0012293489,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americanlookout.com/wp-content/uploads/2016/11/Crazy-Lib-600x315.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-10T21:56:30.578+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "americanlookout.com",
		"spam_score": "0.842",
		"text": "WHAT? Leftist Protester Going Nuts On CNN Over Hillary Loss WAS A CNN CAMERAMAN? (VIDEO) shares Facebook \nIs CNN using their own crew members as fake protesters? Earlier today, we posted a video of a Hillary supporter having a total meltdown on CNN last night. \nIn a slightly longer version of the clip you can watch below, CNN’s Don Lemon remarks at the end of the video that he knows the man and that he’s a CNN cameraman. \nLemon says: \n“Brian, you know I used to live there and I know that guy, that’s John [last name]. He actually went to Africa with me as a cameraman but anyway, that’s another story.” \nWatch the clip to the end: CNN outs themselves as using their own cameramen as fake protesters pic.twitter.com/APanvukid6 \nHow does CNN ever recover their credibility after this election? \nThey failed so badly! ",
		"thread_title": "WHAT? Leftist Protester Going Nuts On CNN Over Hillary Loss WAS A CNN CAMERAMAN? (VIDEO) – American Lookout",
		"title": "WHAT? Leftist Protester Going Nuts On CNN Over Hillary Loss WAS A CNN CAMERAMAN? (VIDEO) – American Lookout",
		"type": "bs",
		"uuid": "91ad0ce5f18319c43b83ea35d5ea8b7e5133ec21"
	},
	"-KhIgWv7YL2JRKLA4KQC": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-11T21:32:39.014+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.5730302,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.082157925,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.055142086,
				"type": "PERSON"
			},
			{
				"name": "shares",
				"salience": 0.035107214,
				"type": "OTHER"
			},
			{
				"name": "VIDEO",
				"salience": 0.031751618,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president",
				"salience": 0.023067571,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02238b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmy_Kimmel"
				},
				"name": "Jimmy Kimmel",
				"salience": 0.021752704,
				"type": "PERSON"
			},
			{
				"name": "tweets",
				"salience": 0.015732078,
				"type": "WORK_OF_ART"
			},
			{
				"name": "another",
				"salience": 0.014070435,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.012021463,
				"type": "PERSON"
			},
			{
				"name": "audience",
				"salience": 0.011430073,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.011430073,
				"type": "EVENT"
			},
			{
				"name": "presidents",
				"salience": 0.010706501,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ft3c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmy_Kimmel_Live!"
				},
				"name": "Jimmy Kimmel Live",
				"salience": 0.009921892,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Things",
				"salience": 0.008934925,
				"type": "OTHER"
			},
			{
				"name": "Tweets",
				"salience": 0.008919757,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.008641149,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president",
				"salience": 0.008007895,
				"type": "PERSON"
			},
			{
				"name": "kicker",
				"salience": 0.0073469672,
				"type": "PERSON"
			},
			{
				"name": "Nickelback",
				"salience": 0.0065568336,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.006104921,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president",
				"salience": 0.005837837,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0w648l5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sharknado"
				},
				"name": "Sharknado",
				"salience": 0.0051649935,
				"type": "OTHER"
			},
			{
				"name": "Obama Fires Back",
				"salience": 0.0047626738,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04mzd6n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Beast"
				},
				"name": "Daily Beast",
				"salience": 0.0047626738,
				"type": "ORGANIZATION"
			},
			{
				"name": "shares",
				"salience": 0.004566642,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0043636616,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0030191261,
				"type": "LOCATION"
			},
			{
				"name": "@realDonaldTrump",
				"salience": 0.0030191261,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0026690308,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americanlookout.com/wp-content/uploads/2016/11/Obama-on-Trump-vid-600x315.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-10T19:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "americanlookout.com",
		"spam_score": "0.094",
		"text": "LOL! Remember When Obama Told Trump He’d Never Be President? (VIDEO) shares \nJust a few weeks ago on Jimmy Kimmel’s show, Obama mocked Donald Trump saying he’d never be president. The audience laughed and cheered. Everyone was so sure Obama was right. \nThe Daily Beast reported: \nObama Fires Back at Trump’s Mean Tweets on ‘Jimmy Kimmel Live’ \nFor the second time in two years, Obama read some “mean tweets” about himself on Jimmy Kimmel Live, including one that called him “the Nickelback of presidents” and another that compared him to Sharknado: “Loud, stupid and over-hyped!” \nBut the inevitable kicker came when Obama read one from Donald Trump. “President Obama will go down as perhaps the worst president in the history of the United States!” Trump once wrote of the president. “Really? Well, @realDonaldTrump, at least I will go down as a president,” Obama replied. \nHere’s the video: \nThings look a little different now, don’t they? shares ",
		"thread_title": "LOL! Remember When Obama Told Trump He’d Never Be President? (VIDEO) – American Lookout",
		"title": "LOL! Remember When Obama Told Trump He’d Never Be President? (VIDEO) – American Lookout",
		"type": "bs",
		"uuid": "d09c53c69de0522e183c2925fe595a3ec314929d"
	},
	"-KhIgX2NhWBJUGXgnfwu": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-19T05:47:37.920+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04rrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maryland"
				},
				"name": "Maryland",
				"salience": 0.1417077,
				"type": "LOCATION"
			},
			{
				"name": "walkout",
				"salience": 0.09965862,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.08570185,
				"type": "EVENT"
			},
			{
				"name": "high school",
				"salience": 0.07217282,
				"type": "LOCATION"
			},
			{
				"name": "Students",
				"salience": 0.06596618,
				"type": "PERSON"
			},
			{
				"name": "Protests",
				"salience": 0.055327803,
				"type": "EVENT"
			},
			{
				"name": "Students",
				"salience": 0.052527662,
				"type": "PERSON"
			},
			{
				"name": "Consequences",
				"salience": 0.051949862,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.043685988,
				"type": "PERSON"
			},
			{
				"name": "Maryland School Official Declares End To Student Trump",
				"salience": 0.02701113,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.023431072,
				"type": "OTHER"
			},
			{
				"name": "IT'S ABOUT TIME",
				"salience": 0.023431072,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.022217473,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.021414062,
				"type": "PERSON"
			},
			{
				"name": "Jack Smith",
				"salience": 0.014073723,
				"type": "PERSON"
			},
			{
				"name": "school official",
				"salience": 0.009699904,
				"type": "PERSON"
			},
			{
				"name": "school official",
				"salience": 0.009699904,
				"type": "PERSON"
			},
			{
				"name": "highway",
				"salience": 0.009303705,
				"type": "LOCATION"
			},
			{
				"name": "school",
				"salience": 0.00896434,
				"type": "LOCATION"
			},
			{
				"name": "Students",
				"salience": 0.008169934,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.008169934,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.008036524,
				"type": "EVENT"
			},
			{
				"name": "consequences",
				"salience": 0.0075344583,
				"type": "OTHER"
			},
			{
				"name": "school official",
				"salience": 0.0075344583,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.0072314152,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/058psj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montgomery_County_Public_Schools"
				},
				"name": "Montgomery County Public Schools",
				"salience": 0.006765454,
				"type": "ORGANIZATION"
			},
			{
				"name": "class",
				"salience": 0.006584902,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.006531253,
				"type": "OTHER"
			},
			{
				"name": "hat",
				"salience": 0.0055865417,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0054469616,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0052440865,
				"type": "OTHER"
			},
			{
				"name": "schoolchildren",
				"salience": 0.0048859813,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.004670144,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0046207206,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0044521694,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0044153444,
				"type": "EVENT"
			},
			{
				"name": "protest",
				"salience": 0.0044153444,
				"type": "EVENT"
			},
			{
				"name": "boy",
				"salience": 0.003497376,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bxbb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rockville,_Maryland"
				},
				"name": "Rockville",
				"salience": 0.003485391,
				"type": "LOCATION"
			},
			{
				"name": "anti-Trump",
				"salience": 0.003485391,
				"type": "ORGANIZATION"
			},
			{
				"name": "courthouse",
				"salience": 0.0034533632,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05_4_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Party"
				},
				"name": "Party",
				"salience": 0.00335545,
				"type": "ORGANIZATION"
			},
			{
				"name": "Conservative Review",
				"salience": 0.00335545,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.0033273215,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0031205942,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, D.C.",
				"salience": 0.0028460056,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0661nlt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WBQH"
				},
				"name": "WTOP",
				"salience": 0.0028460056,
				"type": "ORGANIZATION"
			},
			{
				"name": "incident",
				"salience": 0.0025159614,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.0025159614,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qn6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_Montgomery_High_School"
				},
				"name": "Richard Montgomery High School",
				"salience": 0.0022487578,
				"type": "LOCATION"
			},
			{
				"name": "schools",
				"salience": 0.002172319,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11bw1_6lwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Make_America_Great_Again"
				},
				"name": "Make America Great Again",
				"salience": 0.0021265168,
				"type": "OTHER"
			},
			{
				"name": "Love Trumps Hate",
				"salience": 0.0019708078,
				"type": "WORK_OF_ART"
			},
			{
				"name": "signs",
				"salience": 0.0018798299,
				"type": "OTHER"
			},
			{
				"name": "infraction",
				"salience": 0.0018798299,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.0016771614,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americanlookout.com/wp-content/uploads/2016/11/MD-students-600x315.png",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-19T01:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "americanlookout.com",
		"spam_score": "0.194",
		"text": "IT’S ABOUT TIME: Maryland School Official Declares End To Student Trump Protests With No Consequences shares Facebook \nStudents at a Maryland high school staged a walkout to protest the election of Trump on Monday. They ended up blocking a highway in the process, which is incredibly dangerous. \nOne school official has now said enough is enough. Students who try to protest during school time will suffer consequences. Better late than never, right? \nConservative Review reports: \nParty’s over, kids: MD school official declares end to consequence-free Trump protests \nA Maryland school official is finally promising disciplinary action for students who protest during school hours after student-led anti-Trump protests turned violent Wednesday morning in Rockville, Md. \nMontgomery County Public Schools Superintendent Jack Smith is “asking and expecting all students to remain in school and participate in the daily educational program as intended,” WTOP in Washington, D.C., reports. Students that refuse to attend class “may be subjected to the regular disciplinary actions that align with whatever infraction is involved.” \nEarlier this week, hundreds of students from Richard Montgomery High School carried signs reading “Love Trumps Hate” and made their way to the local courthouse chanting in protest of Donald Trump’s election. During the protest, a 15-year-old boy wearing a “Make America Great Again” hat was attacked by four students, unprovoked. (Just the latest incident nationwide.) \nHopefully, other schools will follow suit. \nWhen did this become acceptable for schoolchildren in the first place? ",
		"thread_title": "IT’S ABOUT TIME: Maryland School Official Declares End To Student Trump Protests With No Consequences – American Lookout",
		"title": "IT’S ABOUT TIME: Maryland School Official Declares End To Student Trump Protests With No Consequences – American Lookout",
		"type": "bs",
		"uuid": "82a78fd6a5aaccdee792eb07a865807237e89c16"
	},
	"-KhIgXImtUt5HuzziVyP": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-25T06:53:16.182+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "@myhairisblue",
				"salience": 0.15299682,
				"type": "OTHER"
			},
			{
				"name": "Intolerance",
				"salience": 0.07770166,
				"type": "OTHER"
			},
			{
				"name": "Sam Escobar 👻",
				"salience": 0.07592642,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/039cq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saturday_Night_Live"
				},
				"name": "Saturday Night Live",
				"salience": 0.067361586,
				"type": "WORK_OF_ART"
			},
			{
				"name": "joke",
				"salience": 0.052234694,
				"type": "OTHER"
			},
			{
				"name": "Joke",
				"salience": 0.034528077,
				"type": "OTHER"
			},
			{
				"name": "shares",
				"salience": 0.024434974,
				"type": "OTHER"
			},
			{
				"name": "fun",
				"salience": 0.024434974,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.024434974,
				"type": "OTHER"
			},
			{
				"name": "@SNLUpdate pic.twitter.com/Q3PTZghM5g",
				"salience": 0.024164163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0wfqsst",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tinder_(app)"
				},
				"name": "Tinder",
				"salience": 0.021763043,
				"type": "OTHER"
			},
			{
				"name": "conservatives",
				"salience": 0.021175401,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.021175401,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.021126365,
				"type": "OTHER"
			},
			{
				"name": "fun",
				"salience": 0.018051203,
				"type": "OTHER"
			},
			{
				"name": "Social Justice Warriors Were Triggered By This",
				"salience": 0.013058459,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.013058459,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cnz4yx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colin_Jost"
				},
				"name": "Colin Jost",
				"salience": 0.012114416,
				"type": "PERSON"
			},
			{
				"name": "fuck",
				"salience": 0.0112583,
				"type": "OTHER"
			},
			{
				"name": "@ColinJost",
				"salience": 0.011042353,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.010091658,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.010091658,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.010091658,
				"type": "EVENT"
			},
			{
				"name": "gender identity",
				"salience": 0.010091658,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.010023346,
				"type": "OTHER"
			},
			{
				"name": "Trans",
				"salience": 0.008741042,
				"type": "OTHER"
			},
			{
				"name": "@phippsdontlie",
				"salience": 0.008390337,
				"type": "OTHER"
			},
			{
				"name": "@nbcsnl",
				"salience": 0.00807766,
				"type": "OTHER"
			},
			{
				"name": "@ColinJost",
				"salience": 0.00807766,
				"type": "PERSON"
			},
			{
				"name": "gender",
				"salience": 0.007547964,
				"type": "OTHER"
			},
			{
				"name": "fallout",
				"salience": 0.0075090597,
				"type": "EVENT"
			},
			{
				"name": "oppression",
				"salience": 0.007079953,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.006816021,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.006816021,
				"type": "PERSON"
			},
			{
				"name": "Thanks",
				"salience": 0.006131759,
				"type": "OTHER"
			},
			{
				"name": "comedian",
				"salience": 0.006131759,
				"type": "PERSON"
			},
			{
				"name": "erasure",
				"salience": 0.00590312,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.00590312,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.005781239,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0053836694,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.005158261,
				"type": "PERSON"
			},
			{
				"name": "masses",
				"salience": 0.0050067487,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.0050067487,
				"type": "LOCATION"
			},
			{
				"name": "destruction",
				"salience": 0.0050067487,
				"type": "OTHER"
			},
			{
				"name": "commentary",
				"salience": 0.0050067487,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Emma Phipps",
				"salience": 0.0043598628,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0043197745,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0043197745,
				"type": "OTHER"
			},
			{
				"name": "@ColinJost",
				"salience": 0.0040688883,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0037408785,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0037408785,
				"type": "OTHER"
			},
			{
				"name": "messaging",
				"salience": 0.0037408785,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0037408785,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.0037408785,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.0037408785,
				"type": "ORGANIZATION"
			},
			{
				"name": "point",
				"salience": 0.0037408785,
				"type": "OTHER"
			},
			{
				"name": "@PWRBTTMBAND",
				"salience": 0.0037297579,
				"type": "OTHER"
			},
			{
				"name": "LOL DEMS",
				"salience": 0.003634733,
				"type": "PERSON"
			},
			{
				"name": "@louisvirtel",
				"salience": 0.0035596432,
				"type": "OTHER"
			},
			{
				"name": "mistake",
				"salience": 0.0033801498,
				"type": "OTHER"
			},
			{
				"name": "jokes",
				"salience": 0.0033298093,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.0033298093,
				"type": "OTHER"
			},
			{
				"name": "shares",
				"salience": 0.0031466512,
				"type": "OTHER"
			},
			{
				"name": "Louis Virtel",
				"salience": 0.0030825308,
				"type": "PERSON"
			},
			{
				"name": "rationale",
				"salience": 0.002794827,
				"type": "OTHER"
			},
			{
				"name": "@PWRBTTMBAND",
				"salience": 0.002786517,
				"type": "PERSON"
			},
			{
				"name": "self-examination",
				"salience": 0.002724854,
				"type": "EVENT"
			},
			{
				"name": "reminders",
				"salience": 0.0026566316,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0023620157,
				"type": "LOCATION"
			},
			{
				"name": "@PWRBTTMBAND It",
				"salience": 0.002302872,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.002302872,
				"type": "OTHER"
			},
			{
				"name": "skit",
				"salience": 0.0020356134,
				"type": "OTHER"
			},
			{
				"name": "actor",
				"salience": 0.0020356134,
				"type": "PERSON"
			},
			{
				"name": "snowflakes",
				"salience": 0.0020356134,
				"type": "WORK_OF_ART"
			},
			{
				"name": "jokes",
				"salience": 0.0019304362,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.001677239,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americanlookout.com/wp-content/uploads/2016/11/Colin-Jost-600x315.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-23T04:18:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "americanlookout.com",
		"spam_score": "0.762",
		"text": "LOL! Social Justice Warriors Were Triggered By This ‘GENDER IDENTITY’ Joke On Saturday Night Live shares Facebook \nSaturday Night Live definitely leans left, they love to make fun of conservatives. But every once in a while they poke fun at the left. In this case, they made a joke about gender identity on the dating application Tinder. They also pulled the election into it. \nIn case you didn’t see it, here’s the joke: \nSocial justice warriors on Twitter were not happy: What the fuck is this @SNLUpdate pic.twitter.com/Q3PTZghM5g \n— Sam Escobar 👻 (@myhairisblue) November 21, 2016 Trans & gender nonconforming people are more likely to be harassed, attacked, abused, discriminated against — but yeah. LOL DEMS! @SNLUpdate \n— Sam Escobar 👻 (@myhairisblue) November 21, 2016 Dear @ColinJost and @nbcsnl : thank you so much for supporting the erasure of non-cis people. Thanks for actively contributing to oppression. \n— Sam Escobar 👻 (@myhairisblue) November 21, 2016 @ColinJost i don't think, as a professional comedian, it can possibly escape you how this joke is punching way way down. \n— Emma Phipps (@phippsdontlie) November 22, 2016 @ColinJost You wish you had a point. Instead it's just tired old LGBT-shaming disguised as edgy commentary. \n— Louis Virtel (@louisvirtel) November 22, 2016 The fallout of this election has been a beautiful destruction. Intolerance is everywhere and it is eye opening to the masses. https://t.co/BbdFsO1Frh And before you say its \"just a joke,\" here are 2 reminders:1) jokes like these normalize oppression2) SNL doesn't know how to write jokes. \n— Sam Escobar 👻 (@myhairisblue) November 21, 2016 \nLighten up, snowflakes! \nThe actor in the skit ultimately responded: @PWRBTTMBAND so you think 100 percent of Trump voters were hatred and 0 percent had any other rationale? \n— Colin Jost (@ColinJost) November 22, 2016 @PWRBTTMBAND It's politics. A lot of politics is messaging and getting America on board. I want to examine how we failed at that goal. \n— Colin Jost (@ColinJost) November 22, 2016 @PWRBTTMBAND I worry about not doing any self-examination and making the same mistake again. \n— Colin Jost (@ColinJost) November 22, 2016 \nWow. It looks like Colin Jost is way ahead of the Democratic Party. shares ",
		"thread_title": "LOL! Social Justice Warriors Were Triggered By This ‘GENDER IDENTITY’ Joke On Saturday Night Live – American Lookout",
		"title": "LOL! Social Justice Warriors Were Triggered By This ‘GENDER IDENTITY’ Joke On Saturday Night Live – American Lookout",
		"type": "bs",
		"uuid": "29746f0fc5b85ade8bbbf44a98d197a832dce64c"
	},
	"-KhIgXR27dVmGVHGIYjm": {
		"author": "American News",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T21:53:36.001+02:00",
		"domain_rank": "25842",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.62455195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.119070284,
				"type": "PERSON"
			},
			{
				"name": "step",
				"salience": 0.047383,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.038492274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.029613297,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.022998432,
				"type": "EVENT"
			},
			{
				"name": "use",
				"salience": 0.019965354,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.019965354,
				"type": "OTHER"
			},
			{
				"name": "Secretary of State",
				"salience": 0.019965354,
				"type": "PERSON"
			},
			{
				"name": "investigators",
				"salience": 0.008024765,
				"type": "PERSON"
			},
			{
				"name": "hook",
				"salience": 0.0072227796,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.006954625,
				"type": "EVENT"
			},
			{
				"name": "eye",
				"salience": 0.006954625,
				"type": "OTHER"
			},
			{
				"name": "video footage",
				"salience": 0.0059024654,
				"type": "WORK_OF_ART"
			},
			{
				"name": "immigrants",
				"salience": 0.0059024654,
				"type": "PERSON"
			},
			{
				"name": "clip",
				"salience": 0.0049459287,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0044550872,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0044142297,
				"type": "WORK_OF_ART"
			},
			{
				"name": "administration",
				"salience": 0.003217724,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americannews.com/wp-content/uploads/2016/11/Screen-Shot-2016-11-06-at-8.09.28-PM.png",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-08T09:29:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "americannews.com",
		"spam_score": "0.008",
		"text": "ago 0 \nPresident Barack Obama has stood behind Hillary Clinton through every step of the FBI investigation into her use of a private email server as his Secretary of State. He has turned a blind eye to her many crimes and has encouraged investigators to let her off the hook. \nJust when Americans thought he couldn’t get any more corrupt, video footage has surfaced of Obama calling on illegal immigrants to vote today. \nThe clip below shows just how far Obama is willing to go to push his own agenda—an agenda that Clinton has promised to protect and push forward. \nHis comments, like his entire administration, are lawless. This is outrageous. \nDo you agree? ",
		"thread_title": "President Obama Makes Massive Call For Illegals To Vote With No Repercussions… This Is Sickening",
		"title": "President Obama Makes Massive Call For Illegals To Vote With No Repercussions… This Is Sickening",
		"type": "bs",
		"uuid": "af441735c23c63a8d283640443aab0828455498c"
	},
	"-KhIgXZ2lvXAZYFctrzG": {
		"author": "American News",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-11T23:03:48.117+02:00",
		"domain_rank": "25842",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.37801313,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01j7rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jon_Stewart"
				},
				"name": "Jon Stewart",
				"salience": 0.10147135,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.059201453,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.058472034,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.055641167,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.051577598,
				"type": "OTHER"
			},
			{
				"name": "celebrities",
				"salience": 0.0345982,
				"type": "PERSON"
			},
			{
				"name": "arrogance",
				"salience": 0.028706806,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.025964076,
				"type": "LOCATION"
			},
			{
				"name": "celebrities",
				"salience": 0.015188926,
				"type": "PERSON"
			},
			{
				"name": "Looks",
				"salience": 0.011889124,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.01102142,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010269618,
				"type": "EVENT"
			},
			{
				"name": "planet",
				"salience": 0.009634051,
				"type": "LOCATION"
			},
			{
				"name": "comedians",
				"salience": 0.009275557,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.009050278,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.0083459,
				"type": "OTHER"
			},
			{
				"name": "bigots",
				"salience": 0.0083459,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0083459,
				"type": "PERSON"
			},
			{
				"name": "sexists",
				"salience": 0.0083459,
				"type": "OTHER"
			},
			{
				"name": "election season",
				"salience": 0.0080351895,
				"type": "EVENT"
			},
			{
				"name": "majority",
				"salience": 0.0080351895,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0078695435,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.006816696,
				"type": "EVENT"
			},
			{
				"name": "magazine",
				"salience": 0.006816696,
				"type": "ORGANIZATION"
			},
			{
				"name": "list",
				"salience": 0.006114382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b3w054",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lena_Dunham"
				},
				"name": "Lena Dunham",
				"salience": 0.0051109833,
				"type": "PERSON"
			},
			{
				"name": "awards ceremony",
				"salience": 0.005094928,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.005094928,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02wcd14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amy_Schumer"
				},
				"name": "Amy Schumer",
				"salience": 0.004950502,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02jqxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/People_(magazine)"
				},
				"name": "People",
				"salience": 0.0048483266,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0047466415,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.004546132,
				"type": "OTHER"
			},
			{
				"name": "celebrities",
				"salience": 0.003899942,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0032028607,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/080h2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vancouver"
				},
				"name": "Vancouver",
				"salience": 0.0031376216,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.0027736842,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0027736842,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0027736842,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://americannews.com/wp-content/uploads/2016/11/Screen-Shot-2016-11-09-at-10.59.50-PM.png",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-10T12:26:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "americannews.com",
		"spam_score": "0.012",
		"text": "ago 0 \nRemember a few months ago when liberals thought there was no way Donald Trump would ever take the presidency? Remember when, in their arrogance, many celebrities promised to leave the country if he was ever elected? Looks like it’s time to start packing! \nThe list of celebrities that were supposedly set to lose after this election include liberal comedians like Jon Stewart and Amy Schumer. Stewart spent the majority of the election season calling Trump and his supporters racists, sexists, and bigots. “I would consider getting in a rocket and going to another planet because clearly this planet’s gone bonkers,” he said in an interview with People magazine. \nThe list also includes the ever-peachy Lena Dunham, who promised to stand by her threat no matter what. \n“I know a lot of people have been threatening to do this, but I really will,” Dunham said in April at an awards ceremony. “I know a lovely place in Vancouver, and I can get my work done from there.” \nBelow is a list of at least 23 celebrities who promised to leave if Trump won the election: \n• Comedian Jon Stewart ",
		"thread_title": "Rosie O’Donnell Leaving The Country for Good… She’s Never Coming Back",
		"title": "Rosie O’Donnell Leaving The Country for Good… She’s Never Coming Back",
		"type": "bs",
		"uuid": "ce1afc419d33820fb95a9b67c50dc4e42cc64dbd"
	},
	"-KhIgXlXmdabcOjNIyI_": {
		"author": "Brett Macdonald",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T12:08:12.697+03:00",
		"domain_rank": "3734",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0115nwkf"
				},
				"name": "Erica Garner",
				"salience": 0.13796368,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.07514873,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.06059564,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.057812594,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.046063185,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.042763975,
				"type": "PERSON"
			},
			{
				"name": "bro",
				"salience": 0.027473638,
				"type": "PERSON"
			},
			{
				"name": "hiding",
				"salience": 0.027206609,
				"type": "OTHER"
			},
			{
				"name": "whims",
				"salience": 0.023817213,
				"type": "OTHER"
			},
			{
				"name": "BREAKING",
				"salience": 0.023817213,
				"type": "EVENT"
			},
			{
				"name": "mom",
				"salience": 0.023817213,
				"type": "PERSON"
			},
			{
				"name": "outrage",
				"salience": 0.023817213,
				"type": "OTHER"
			},
			{
				"name": "WAY",
				"salience": 0.023817213,
				"type": "OTHER"
			},
			{
				"name": "ALL",
				"salience": 0.023817213,
				"type": "OTHER"
			},
			{
				"name": "Hillary Just LOST The Black Vote... Trump",
				"salience": 0.023337921,
				"type": "WORK_OF_ART"
			},
			{
				"name": "members",
				"salience": 0.018722508,
				"type": "PERSON"
			},
			{
				"name": "Martin Shkreli",
				"salience": 0.018244073,
				"type": "PERSON"
			},
			{
				"name": "Hillary Just Lost The Black Vote To a Black Lives Matter",
				"salience": 0.016965427,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.015773082,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.014700682,
				"type": "LOCATION"
			},
			{
				"name": "some",
				"salience": 0.01453672,
				"type": "PERSON"
			},
			{
				"name": "Brett MacDonald",
				"salience": 0.013130707,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.013130707,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.012648212,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.010834668,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.010822538,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01h1bf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Today_(U.S._TV_program)"
				},
				"name": "Today",
				"salience": 0.01011464,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "NEW YORK",
				"salience": 0.009818337,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.007430679,
				"type": "ORGANIZATION"
			},
			{
				"name": "community",
				"salience": 0.0069657434,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.005811994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.0058045457,
				"type": "ORGANIZATION"
			},
			{
				"name": "word",
				"salience": 0.005033655,
				"type": "OTHER"
			},
			{
				"name": "gun violence",
				"salience": 0.005033655,
				"type": "OTHER"
			},
			{
				"name": "ears",
				"salience": 0.005033655,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0050184494,
				"type": "EVENT"
			},
			{
				"name": "whatever",
				"salience": 0.004886414,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.004886414,
				"type": "OTHER"
			},
			{
				"name": "officer",
				"salience": 0.004346229,
				"type": "PERSON"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Death_of_Eric_Garner"
				},
				"name": "Eric Garner",
				"salience": 0.00434496,
				"type": "PERSON"
			},
			{
				"name": "kicker",
				"salience": 0.004269383,
				"type": "OTHER"
			},
			{
				"name": "default",
				"salience": 0.004076604,
				"type": "OTHER"
			},
			{
				"name": "crime bill",
				"salience": 0.004076604,
				"type": "OTHER"
			},
			{
				"name": "default",
				"salience": 0.004076604,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0038621991,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "DONALD J. TRUMP",
				"salience": 0.003787852,
				"type": "PERSON"
			},
			{
				"name": "revelation",
				"salience": 0.0033986997,
				"type": "OTHER"
			},
			{
				"name": "critics",
				"salience": 0.0033986997,
				"type": "PERSON"
			},
			{
				"name": "chokehold",
				"salience": 0.0033986997,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0033986997,
				"type": "PERSON"
			},
			{
				"name": "dad",
				"salience": 0.0033986997,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.0033767002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crime bill",
				"salience": 0.0033284978,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0033284978,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0033284978,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0032888774,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hate mail",
				"salience": 0.0032719106,
				"type": "OTHER"
			},
			{
				"name": "black community",
				"salience": 0.0029811212,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.0029696901,
				"type": "PERSON"
			},
			{
				"name": "officialERICA GARNER",
				"salience": 0.0024564823,
				"type": "PERSON"
			},
			{
				"name": "@es_snipes",
				"salience": 0.0024164496,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0022943832,
				"type": "WORK_OF_ART"
			},
			{
				"name": "music collection",
				"salience": 0.0021809356,
				"type": "OTHER"
			},
			{
				"name": "Negros",
				"salience": 0.0021734536,
				"type": "LOCATION"
			},
			{
				"name": "Nergos",
				"salience": 0.0021734536,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.002171449,
				"type": "WORK_OF_ART"
			},
			{
				"name": "course",
				"salience": 0.0021534606,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Beatles"
				},
				"name": "Beatles",
				"salience": 0.0020157062,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0827v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wu-Tang_Clan"
				},
				"name": "Wu-Tang",
				"salience": 0.0020157062,
				"type": "PERSON"
			},
			{
				"name": "VOTE",
				"salience": 0.0020060774,
				"type": "OTHER"
			},
			{
				"name": "music",
				"salience": 0.0019068763,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Compliments",
				"salience": 0.0017805031,
				"type": "OTHER"
			},
			{
				"name": "@MartinShkreli",
				"salience": 0.0016953943,
				"type": "PERSON"
			},
			{
				"name": "music community",
				"salience": 0.0016221907,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0016038851,
				"type": "EVENT"
			},
			{
				"name": "SHARES",
				"salience": 0.0015684644,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0015684644,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0015684644,
				"type": "PERSON"
			},
			{
				"name": "officialERICA GARNER",
				"salience": 0.0014793125,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.0013531082,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0013531082,
				"type": "OTHER"
			},
			{
				"name": "@ TweetBrettMac",
				"salience": 0.0013366006,
				"type": "OTHER"
			},
			{
				"name": "setback",
				"salience": 0.0011716696,
				"type": "OTHER"
			},
			{
				"name": "troll",
				"salience": 0.0011716696,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.000875228,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0b1zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nirvana_(band)"
				},
				"name": "Nirvana",
				"salience": 0.0008509906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "AMERICA",
				"salience": 0.00071202224,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.americasfreedomfighters.com/wp-content/uploads/2016/10/22-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T00:58:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "americasfreedomfighters.com",
		"spam_score": "0.052",
		"text": "BREAKING: Hillary Just LOST The Black Vote… Trump Is Going ALL THE WAY To The White House Hillary Just Lost The Black Vote To a Black Lives Matter mom’s outrage and a pharmaceutical bro’s whims. Here’s how: \nBrett MacDonald | Twitter | Facebook | \nNEW YORK — Today was not a great day for the Clinton campaign. Recently leaked emails from within the Clinton campaign have reached the ears of some prominent members of the Black Lives Matter community — members whom the emails were about. They are particularly upset about a series of emails that seems how to best “use” the victims of gun violence while making sure those victims were black. Understandably, some of the members have taken to speaking out against her campaign now. In a word, they’re pissed. \nErica Garner, the daughter of controversial man who died after being put in “chokehold” by a New York officer has been one of the most vocal critics. “I’m troubled by the revelation that you and this campaign actually discussed ‘using’ Eric Garner …. Why would you want to ‘use’ my dad?” she tweeted. \nThat was way earlier today. She hasn’t stopped since: “If you vote for her (Clinton) by default you are endorsing her and whatever she does. Remember her hiding being Negros(sic) that supported the crime bill?” If you vote for her by default you are endorsing her and whatever she does. Remember her hiding being Nergos that supported the crime bill? \n— officialERICA GARNER (@es_snipes) October 27, 2016 \nBut here’s the real kicker: “I don’t care what BLM activists endorse #Hillary … They WILL continue more of the same, they don’t care about Black lives and I got proof!” I dont care what BLM activists endorse #Hillary … They WILL continue more of the same, they dont care about Black lives and I got proof! \n— officialERICA GARNER (@es_snipes) October 27, 2016 \nBut that’s not the only setback the Clinton campaign saw today. Martin Shkreli, the controversial “pharma-bro” and top-tier troll, had a very alarming announcement for the music community: if Trump wins, he will release his previously unheard music from the Beatles, Nirvana, and, mot importantly to the black community, Wu-Tang. If Trump wins, my entire unreleased music collection, including unheard Nirvana, Beatles, and of course, Wu-Tang, comes out, for free. \n— Martin Shkreli (@MartinShkreli) October 27, 2016 This article was written by Brett MacDonald. If you enjoyed this story or did not, hate mail can be left in the comments below and the author totally won’t ignore it. Compliments or questions may be sent to @ TweetBrettMac . on Twitter! VOTE FOR DONALD J. TRUMP! TOGETHER WE WILL MAKE AMERICA GREAT AGAIN! Please like and share on Facebook and Twitter! 5.7K SHARES ",
		"thread_title": "BREAKING: Hillary Just LOST The Black Vote... Trump Is Going ALL THE WAY To The WHITE HOUSE",
		"title": "BREAKING: Hillary Just LOST The Black Vote... Trump Is Going ALL THE WAY To The WHITE HOUSE",
		"type": "bs",
		"uuid": "7eed7067a45f786da2fe07df5a1fea8d25b1696f"
	},
	"-KhIgXyHSpKuchMNq3r_": {
		"author": "Sean Brown",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T16:00:40.165+02:00",
		"domain_rank": "3734",
		"entities": [
			{
				"name": "email",
				"salience": 0.22924401,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.08816586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.051311415,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.039966024,
				"type": "PERSON"
			},
			{
				"name": "rituals",
				"salience": 0.037588045,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02d100",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marina_Abramovi%C4%87"
				},
				"name": "Marina Abramovic",
				"salience": 0.034249473,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.029006705,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.027240073,
				"type": "OTHER"
			},
			{
				"name": "staffers",
				"salience": 0.027240073,
				"type": "PERSON"
			},
			{
				"name": "Podestas",
				"salience": 0.025722735,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "Divine",
				"salience": 0.023667432,
				"type": "OTHER"
			},
			{
				"name": "tin foil",
				"salience": 0.022555215,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "FREEDOM FIGHTERS",
				"salience": 0.021644978,
				"type": "PERSON"
			},
			{
				"name": "ceremony",
				"salience": 0.017060898,
				"type": "EVENT"
			},
			{
				"name": "Sean Brown AMERICA",
				"salience": 0.016821533,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.016120084,
				"type": "OTHER"
			},
			{
				"name": "fiction",
				"salience": 0.014877998,
				"type": "OTHER"
			},
			{
				"name": "ritual",
				"salience": 0.013993175,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.012139809,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Spirit Cooking",
				"salience": 0.010081094,
				"type": "OTHER"
			},
			{
				"name": "performance",
				"salience": 0.009785527,
				"type": "OTHER"
			},
			{
				"name": "sacrament",
				"salience": 0.00891655,
				"type": "EVENT"
			},
			{
				"name": "dinner",
				"salience": 0.007973967,
				"type": "EVENT"
			},
			{
				"name": "spirit cooking dinner",
				"salience": 0.007973967,
				"type": "EVENT"
			},
			{
				"name": "spirit cooking",
				"salience": 0.007687148,
				"type": "OTHER"
			},
			{
				"name": "brother",
				"salience": 0.0066536325,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019yt6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baphomet"
				},
				"name": "Baphomet",
				"salience": 0.006152663,
				"type": "OTHER"
			},
			{
				"name": "Spirit cooking",
				"salience": 0.0059678615,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0057628206,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0057628206,
				"type": "LOCATION"
			},
			{
				"name": "blood",
				"salience": 0.0057197916,
				"type": "OTHER"
			},
			{
				"name": "dinner",
				"salience": 0.0053857495,
				"type": "OTHER"
			},
			{
				"name": "fuss",
				"salience": 0.0052075945,
				"type": "OTHER"
			},
			{
				"name": "ritual",
				"salience": 0.0051197116,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.004975998,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.004909942,
				"type": "WORK_OF_ART"
			},
			{
				"name": "painting",
				"salience": 0.0047301683,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Sean Brown",
				"salience": 0.004563107,
				"type": "PERSON"
			},
			{
				"name": "brother",
				"salience": 0.004493328,
				"type": "PERSON"
			},
			{
				"name": "john",
				"salience": 0.004493328,
				"type": "PERSON"
			},
			{
				"name": "politicalcult.com",
				"salience": 0.0044829105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cs_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marina"
				},
				"name": "Marina",
				"salience": 0.004366281,
				"type": "LOCATION"
			},
			{
				"name": "art",
				"salience": 0.004060246,
				"type": "WORK_OF_ART"
			},
			{
				"name": "religion",
				"salience": 0.0040421262,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.0040421262,
				"type": "OTHER"
			},
			{
				"name": "ritual",
				"salience": 0.0039238534,
				"type": "EVENT"
			},
			{
				"name": "message",
				"salience": 0.003891368,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.003891368,
				"type": "OTHER"
			},
			{
				"name": "sperm",
				"salience": 0.0038110039,
				"type": "OTHER"
			},
			{
				"name": "painting",
				"salience": 0.0036941697,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.003668855,
				"type": "WORK_OF_ART"
			},
			{
				"name": "urine",
				"salience": 0.0033003523,
				"type": "OTHER"
			},
			{
				"name": "breast milk",
				"salience": 0.0033003523,
				"type": "OTHER"
			},
			{
				"name": "art gallery",
				"salience": 0.0033003523,
				"type": "LOCATION"
			},
			{
				"name": "head",
				"salience": 0.0032734028,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00317723,
				"type": "PERSON"
			},
			{
				"name": "representation",
				"salience": 0.0028474305,
				"type": "OTHER"
			},
			{
				"name": "Paul Joseph Watson",
				"salience": 0.0024886753,
				"type": "PERSON"
			},
			{
				"name": "InfoWars",
				"salience": 0.0024886753,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0mr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleister_Crowley"
				},
				"name": "Aleister Crowley",
				"salience": 0.0024886753,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07grj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thelema"
				},
				"name": "Thelema",
				"salience": 0.0024886753,
				"type": "ORGANIZATION"
			},
			{
				"name": "dinner",
				"salience": 0.0024863798,
				"type": "OTHER"
			},
			{
				"name": "goat",
				"salience": 0.0024657852,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0024657852,
				"type": "OTHER"
			},
			{
				"name": "maxims",
				"salience": 0.0024657852,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "NYC",
				"salience": 0.0023958092,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05d2fpv"
				},
				"name": "Tony",
				"salience": 0.0023958092,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.0022970445,
				"type": "OTHER"
			},
			{
				"name": "breastmilk",
				"salience": 0.0020740512,
				"type": "OTHER"
			},
			{
				"name": "sperm",
				"salience": 0.0020740512,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0017960009,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01kvkm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Macrocosm_and_microcosm"
				},
				"name": "As Above, So Below",
				"salience": 0.0017528498,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pain",
				"salience": 0.0017160402,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.0017160402,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018pgt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hermeticism"
				},
				"name": "Hermeticism",
				"salience": 0.0015178382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04yx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Man"
				},
				"name": "Man",
				"salience": 0.0015178382,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07s2vgd"
				},
				"name": "Satanist",
				"salience": 0.0015178382,
				"type": "OTHER"
			},
			{
				"name": "microcosm",
				"salience": 0.0013416715,
				"type": "OTHER"
			},
			{
				"name": "union",
				"salience": 0.0013416715,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0013416715,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.0013416715,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0013416715,
				"type": "OTHER"
			},
			{
				"name": "recipe",
				"salience": 0.0013416715,
				"type": "WORK_OF_ART"
			},
			{
				"name": "@wikileaks",
				"salience": 0.0011054506,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0011054506,
				"type": "OTHER"
			},
			{
				"name": "God Bless",
				"salience": 0.0011054506,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0010411013,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.0009771317,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.americasfreedomfighters.com/wp-content/uploads/2016/11/10959.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-04T19:14:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "americasfreedomfighters.com",
		"spam_score": "0.059",
		"text": "\nSean Brown AMERICA’S FREEDOM FIGHTERS – \nWikileaks has revealed some rather troubling things about Hillary Clinton and her staffers, but perhaps the most disturbing, a bizarre, is the fact that John Podesta is involved with satanic rituals. \nNo, this isn’t fiction and I’m not wearing tin foil on my head. An email released by Wikileaks reveals Podesta was invited to a “spirit cooking dinner” by performance artist Marina Abramovic, and you can rest assured that it’s not anything like it sounds. \n“I am so looking forward to the Spirit Cooking dinner at my place. Do you think you will be able to let me know if your brother is joining? All my love, Marina,” an email dated June 28, 2015 read. \nShortly after, the emails, which was sent to Podesta’s brother Tony, was forwarded to john with the message, “Are you in NYC Thursday July 9 Marina wants you to come to dinner.” \nNow you’re probably wondering what all the fuss is about, and I seriously can’t blame you. So let’s turn to Paul Joseph Watson from InfoWars for a little background on what this “spirit cooking” is really all about. \nSpirit cooking refers to “a sacrament in the religion of Thelema which was founded by Aleister Crowley” and involves an occult performance during which menstrual blood, breast milk, urine and sperm are used to create a “painting”. \nAccording to Marina Abramovic, if the ritual is performed in an art gallery, it is merely art, but if the ritual is performed privately, then it represents an intimate spiritual ceremony. \nThe video embedded above depicts the bizarre nature of the ceremony. Abramovic mixes together thickly congealed blood as the “recipe” for the “painting,” which is comprised of the words, “With a sharp knife cut deeply into the middle finger of your left hand eat the pain.” \nThe ceremony is, “meant to symbolize the union between the microcosm, Man, and the macrocosm, the Divine, which is a representation of one of the prime maxims in Hermeticism “As Above, So Below.” \nBelow is a video of Abramovic conducting the satanic ritual: \nHow creepy. Even creepier is the same woman holding a bloody goat’s head – a representation of the Satanist symbol Baphomet. The Podestas'\"Spirit Cooking\" dinner?It's not what you think.It's blood, sperm and breastmilk. \n— WikiLeaks (@wikileaks) November 4, 2016 \nYeah… \nIf you enjoyed this story, be sure to follow Sean Brown on Facebook , and check out his website, politicalcult.com . \nGod Bless. ",
		"thread_title": "BREAKING: Wikileaks Reveals Hillary’s Campaign Chair Engages In SATANIC RITUALS",
		"title": "BREAKING: Wikileaks Reveals Hillary’s Campaign Chair Engages In SATANIC RITUALS",
		"type": "bs",
		"uuid": "39ef67a669661119e03fbee4a7c3cab9b7737cdd"
	},
	"-KhIgYFQMUWMaa4gtRVL": {
		"author": "Dean James",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-24T08:24:30.080+02:00",
		"domain_rank": "3734",
		"entities": [
			{
				"name": "personnel",
				"salience": 0.22452465,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Department of Defense",
				"salience": 0.09208891,
				"type": "ORGANIZATION"
			},
			{
				"name": "property",
				"salience": 0.0792423,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.048409846,
				"type": "OTHER"
			},
			{
				"name": "firearms",
				"salience": 0.036842994,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "directive",
				"salience": 0.029983513,
				"type": "OTHER"
			},
			{
				"name": "directive",
				"salience": 0.026618645,
				"type": "OTHER"
			},
			{
				"name": "firearms",
				"salience": 0.025995892,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "duties",
				"salience": 0.02505766,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.02505766,
				"type": "OTHER"
			},
			{
				"name": "priority",
				"salience": 0.018366432,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08lv8b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Military.com"
				},
				"name": "Military.com",
				"salience": 0.015119464,
				"type": "ORGANIZATION"
			},
			{
				"name": "D0D",
				"salience": 0.01341404,
				"type": "OTHER"
			},
			{
				"name": "Dean James AMERICA",
				"salience": 0.01341404,
				"type": "PERSON"
			},
			{
				"name": "zones",
				"salience": 0.0128545435,
				"type": "OTHER"
			},
			{
				"name": "FREEDOM FIGHTERS",
				"salience": 0.011973545,
				"type": "PERSON"
			},
			{
				"name": "provision",
				"salience": 0.011349129,
				"type": "OTHER"
			},
			{
				"name": "military basis",
				"salience": 0.011137896,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.011137896,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.009613825,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.009440543,
				"type": "PERSON"
			},
			{
				"name": "personnel",
				"salience": 0.009231665,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.008675323,
				"type": "PERSON"
			},
			{
				"name": "firearms",
				"salience": 0.007829499,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "authorizations",
				"salience": 0.006495834,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.0063578375,
				"type": "PERSON"
			},
			{
				"name": "commanders",
				"salience": 0.005874461,
				"type": "PERSON"
			},
			{
				"name": "services",
				"salience": 0.005874461,
				"type": "OTHER"
			},
			{
				"name": "Washington Free Beacon",
				"salience": 0.005641872,
				"type": "ORGANIZATION"
			},
			{
				"name": "firearm",
				"salience": 0.0054937075,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "firearm",
				"salience": 0.0054937075,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "firearm",
				"salience": 0.0052889767,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "service members",
				"salience": 0.005043026,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.004916924,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0048851236,
				"type": "PERSON"
			},
			{
				"name": "airmen",
				"salience": 0.0045946804,
				"type": "PERSON"
			},
			{
				"name": "sailors",
				"salience": 0.0045946804,
				"type": "PERSON"
			},
			{
				"name": "military sites",
				"salience": 0.0045946804,
				"type": "LOCATION"
			},
			{
				"name": "shootings",
				"salience": 0.0045946804,
				"type": "EVENT"
			},
			{
				"name": "commander",
				"salience": 0.0041209552,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.0040997076,
				"type": "EVENT"
			},
			{
				"name": "application",
				"salience": 0.003997156,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0039146314,
				"type": "OTHER"
			},
			{
				"name": "guidance",
				"salience": 0.0037518423,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0037212186,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0037212186,
				"type": "OTHER"
			},
			{
				"name": "performance",
				"salience": 0.0037212186,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0036046435,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0035824473,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.0035824473,
				"type": "OTHER"
			},
			{
				"name": "performance",
				"salience": 0.0035824473,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0035824473,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.003364899,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0032426605,
				"type": "OTHER"
			},
			{
				"name": "combat training",
				"salience": 0.0032226904,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.003102487,
				"type": "OTHER"
			},
			{
				"name": "open carry",
				"salience": 0.003102487,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.003102487,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.003102487,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.003102487,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.0030384113,
				"type": "OTHER"
			},
			{
				"name": "service members",
				"salience": 0.0030384113,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07xhy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Coast_Guard"
				},
				"name": "Coast Guard",
				"salience": 0.0028294048,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "Marines",
				"salience": 0.0028294048,
				"type": "ORGANIZATION"
			},
			{
				"name": "directive",
				"salience": 0.002721343,
				"type": "OTHER"
			},
			{
				"name": "Jennifer Baker",
				"salience": 0.0026705614,
				"type": "PERSON"
			},
			{
				"name": "roadblocks",
				"salience": 0.0026312615,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.0026312615,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0026312615,
				"type": "OTHER"
			},
			{
				"name": "military bases",
				"salience": 0.0025141647,
				"type": "OTHER"
			},
			{
				"name": "military bases",
				"salience": 0.0025141647,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j6f9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Rifle_Association"
				},
				"name": "NRA",
				"salience": 0.0024629969,
				"type": "ORGANIZATION"
			},
			{
				"name": "zones",
				"salience": 0.0022701463,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0022701463,
				"type": "PERSON"
			},
			{
				"name": "Kim Smith",
				"salience": 0.0021958794,
				"type": "PERSON"
			},
			{
				"name": "Conservative Tribune",
				"salience": 0.0019841136,
				"type": "ORGANIZATION"
			},
			{
				"name": "institution",
				"salience": 0.0019658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "alert",
				"salience": 0.0019658636,
				"type": "OTHER"
			},
			{
				"name": "scenarios",
				"salience": 0.0019658636,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0018313293,
				"type": "WORK_OF_ART"
			},
			{
				"name": "firearm",
				"salience": 0.0018245173,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "troops",
				"salience": 0.0016535413,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0djktd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Defense_Authorization_Act"
				},
				"name": "National Defense Authorization Act",
				"salience": 0.0016198412,
				"type": "WORK_OF_ART"
			},
			{
				"name": "implementation",
				"salience": 0.0015063526,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.0014318589,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart News",
				"salience": 0.0013974559,
				"type": "ORGANIZATION"
			},
			{
				"name": "directive",
				"salience": 0.0012881068,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0012352685,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0012352685,
				"type": "LOCATION"
			},
			{
				"name": "permission",
				"salience": 0.0012352685,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.001210089,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0010696381,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0010696381,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0009303637,
				"type": "OTHER"
			},
			{
				"name": "God Bless",
				"salience": 0.0008813094,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.americasfreedomfighters.com/wp-content/uploads/2016/11/16.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-23T22:06:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "americasfreedomfighters.com",
		"spam_score": "0.109",
		"text": "\nDean James AMERICA’S FREEDOM FIGHTERS – \nLast week, the Pentagon issued a Defense Department directive that allows “Department of Defense (D0D) personnel to carry firearms and employ deadly force while performing official duties.” \nThe Defense Department has been working on changing the “gun-free” zones on domestic military basis for several years in light of the deadly shootings at military sites in recent years. \nMilitary.com reports that the directive “also provides detailed guidance to the services for permitting soldiers, sailors, airmen, Marines and Coast Guard personnel to carry privately owned firearms on DoD property.” It authorizes “commanders, 05 and above…[to] grant permission to DoD personnel requesting to carry a privately owned firearm (concealed or open carry) on DoD property for a personal protection purpose not related to performance of an official duty or status.” \nThe directive also makes clear that DoD will consider further changes to grant “[standard] authorizations for other DoD personnel, who are trained in the scaled use of force or who have been previously qualified to use a government-issued firearm, to carry a firearm in the performance of official duties on DoD property.” This would allow DoD with certain combat training to carry firearms without going through the additional step of making application with a commander. \nKim Smith at Conservative Tribune notes that the policy was a response to an NRA-backed provision in the 2015 National Defense Authorization Act that required the Defense Department to allow more service members to carry firearms on base. \n“It is a good first step in that it recognizes personal protection is a valid issue for service members, but there are many roadblocks in the way of making that option available,” NRA spokeswoman Jennifer Baker told the Washington Free Beacon . \nThose wishing to apply for permission to carry a firearm must be at least 21 years old and meet all federal, state and local laws, the directive said. \nIt would appear that the Pentagon saw no problems with implementing a policy for which President-elect Donald Trump has expressed support. \nPresident-elect Donald Trump ran on removing gun-free zones from military bases. On July 9, 2015, Breitbart News reported that Trump pledged to end the gun-free scenarios for U.S. troops by “[mandating] that soldiers remain armed and on alert at our military bases.” \nThe immediate institution of this directive probably left President Barack Obama incensed, but he undoubtedly realized that there was nothing he could do to prevent its implementation in a couple of months anyway. And that’s good news because it works to ensure the safety of our troops, which should always be a priority. \nLet us know what you think about this in the comments below! \nGod Bless. ",
		"thread_title": "BREAKING: Trump Just Gave Obama HORRIBLE News... Check Out What The Pentagon JUST Did",
		"title": "BREAKING: Trump Just Gave Obama HORRIBLE News... Check Out What The Pentagon JUST Did",
		"type": "bs",
		"uuid": "c10db8a9696f29f1282bfe0f444de33ea1141fb7"
	},
	"-KhIgYneuSF67UNVd402": {
		"author": "Dan Roodt",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:53:19.289+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South African",
				"salience": 0.12580971,
				"type": "LOCATION"
			},
			{
				"name": "Liezel de Lange",
				"salience": 0.08430828,
				"type": "PERSON"
			},
			{
				"name": "#ScienceMustFall",
				"salience": 0.03463851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.03120019,
				"type": "LOCATION"
			},
			{
				"name": "Science",
				"salience": 0.018240921,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.017712064,
				"type": "OTHER"
			},
			{
				"name": "Renaud Camus",
				"salience": 0.015448231,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02pc51s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Kampuchea"
				},
				"name": "Democratic Kampuchea",
				"salience": 0.014979195,
				"type": "ORGANIZATION"
			},
			{
				"name": "Joel Modiri",
				"salience": 0.013792497,
				"type": "PERSON"
			},
			{
				"name": "subculture",
				"salience": 0.012780374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03l44",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Herbert_Marcuse"
				},
				"name": "Herbert Marcuse",
				"salience": 0.012560934,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02c4fw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Pretoria"
				},
				"name": "University of Pretoria",
				"salience": 0.011965284,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.01117558,
				"type": "LOCATION"
			},
			{
				"name": "blacks",
				"salience": 0.011151864,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGO",
				"salience": 0.010783387,
				"type": "ORGANIZATION"
			},
			{
				"name": "something",
				"salience": 0.009104686,
				"type": "OTHER"
			},
			{
				"name": "fallist'' movement",
				"salience": 0.008493865,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.007859887,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.0077713793,
				"type": "PERSON"
			},
			{
				"name": "target",
				"salience": 0.007641657,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019sc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black"
				},
				"name": "Blacks",
				"salience": 0.0074078287,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0s8wzb3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rapport_(newspaper)"
				},
				"name": "Rapport",
				"salience": 0.0069295256,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0063525615,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/031hxk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Cape_Town"
				},
				"name": "University of Cape Town",
				"salience": 0.0062500187,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bsfy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Mugabe"
				},
				"name": "Robert Mugabe",
				"salience": 0.0061786696,
				"type": "PERSON"
			},
			{
				"name": "victim",
				"salience": 0.0061081313,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedes",
				"salience": 0.006091063,
				"type": "ORGANIZATION"
			},
			{
				"name": "whites",
				"salience": 0.0059894905,
				"type": "PERSON"
			},
			{
				"name": "universities",
				"salience": 0.005886414,
				"type": "ORGANIZATION"
			},
			{
				"name": "third-worlders",
				"salience": 0.0058631124,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Westerners",
				"salience": 0.0058571994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07phrcj"
				},
				"name": "Liberals",
				"salience": 0.005793699,
				"type": "ORGANIZATION"
			},
			{
				"name": "#RhodesMustFall",
				"salience": 0.005676443,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0055511803,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.005449645,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0054177623,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Stuart Theobald",
				"salience": 0.005239655,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04645f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Renaissance_(magazine)"
				},
				"name": "American Renaissance",
				"salience": 0.0052317074,
				"type": "ORGANIZATION"
			},
			{
				"name": "fallist",
				"salience": 0.004975233,
				"type": "PERSON"
			},
			{
				"name": "science",
				"salience": 0.0049566366,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.004843742,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lp9j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Timbuktu"
				},
				"name": "Timbuktu",
				"salience": 0.004828285,
				"type": "LOCATION"
			},
			{
				"name": "Writing",
				"salience": 0.004807556,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.004807556,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.004807556,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.004807556,
				"type": "PERSON"
			},
			{
				"name": "science people",
				"salience": 0.0046906513,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qfcd4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dan_Roodt"
				},
				"name": "Dan Roodt",
				"salience": 0.004530824,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/062fg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pol_Pot"
				},
				"name": "Pol Pot",
				"salience": 0.004480129,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.004449744,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.004341102,
				"type": "WORK_OF_ART"
			},
			{
				"name": "visit",
				"salience": 0.004341102,
				"type": "EVENT"
			},
			{
				"name": "science",
				"salience": 0.0038470523,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0037594032,
				"type": "PERSON"
			},
			{
				"name": "notes",
				"salience": 0.0037594032,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0037594032,
				"type": "PERSON"
			},
			{
				"name": "suicide",
				"salience": 0.0037594032,
				"type": "OTHER"
			},
			{
				"name": "populations",
				"salience": 0.0037594032,
				"type": "PERSON"
			},
			{
				"name": "ideology",
				"salience": 0.0037594032,
				"type": "OTHER"
			},
			{
				"name": "world champion",
				"salience": 0.0037594032,
				"type": "EVENT"
			},
			{
				"name": "regulations",
				"salience": 0.0037594032,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0037594032,
				"type": "OTHER"
			},
			{
				"name": "neighbor",
				"salience": 0.0037594032,
				"type": "PERSON"
			},
			{
				"name": "everywhere",
				"salience": 0.0037594032,
				"type": "LOCATION"
			},
			{
				"name": "Nowhere",
				"salience": 0.0037594032,
				"type": "LOCATION"
			},
			{
				"name": "sports bodies",
				"salience": 0.0037594032,
				"type": "ORGANIZATION"
			},
			{
				"name": "blacks",
				"salience": 0.0035678353,
				"type": "PERSON"
			},
			{
				"name": "science",
				"salience": 0.0034976725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x82",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afrikaans"
				},
				"name": "Afrikaans",
				"salience": 0.0034557448,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.003446519,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedes",
				"salience": 0.0033705465,
				"type": "LOCATION"
			},
			{
				"name": "universities",
				"salience": 0.0032381855,
				"type": "ORGANIZATION"
			},
			{
				"name": "multiculturalism",
				"salience": 0.00318832,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.003167678,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0031481618,
				"type": "LOCATION"
			},
			{
				"name": "corporations",
				"salience": 0.0030693552,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedish",
				"salience": 0.0030473655,
				"type": "LOCATION"
			},
			{
				"name": "rebellion",
				"salience": 0.0030110716,
				"type": "EVENT"
			},
			{
				"name": "context",
				"salience": 0.002988565,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g5qq1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Western_sentiment"
				},
				"name": "anti-Western",
				"salience": 0.0029599634,
				"type": "OTHER"
			},
			{
				"name": "Free West Media",
				"salience": 0.0029599634,
				"type": "OTHER"
			},
			{
				"name": "university",
				"salience": 0.0026774646,
				"type": "ORGANIZATION"
			},
			{
				"name": "language",
				"salience": 0.0026400452,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0025970377,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0025970377,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0025970377,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0025802208,
				"type": "OTHER"
			},
			{
				"name": "literature",
				"salience": 0.0025378473,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0024838562,
				"type": "PERSON"
			},
			{
				"name": "Sunday newspaper",
				"salience": 0.0023665414,
				"type": "ORGANIZATION"
			},
			{
				"name": "student",
				"salience": 0.002344846,
				"type": "PERSON"
			},
			{
				"name": "Identitarian Conference",
				"salience": 0.0023143594,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/088q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zimbabwe"
				},
				"name": "Zimbabwe",
				"salience": 0.0023143594,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0023143594,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stockholm"
				},
				"name": "Stockholm",
				"salience": 0.0023143594,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.0022861355,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0022861355,
				"type": "PERSON"
			},
			{
				"name": "universities",
				"salience": 0.0022706296,
				"type": "ORGANIZATION"
			},
			{
				"name": "science",
				"salience": 0.0022024156,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.0021858849,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0qk1j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Samuel_P._Huntington"
				},
				"name": "Samuel Huntington",
				"salience": 0.002185667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jbg2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mona_Lisa"
				},
				"name": "Mona Lisa",
				"salience": 0.002185667,
				"type": "PERSON"
			},
			{
				"name": "piece",
				"salience": 0.0021346314,
				"type": "WORK_OF_ART"
			},
			{
				"name": "science",
				"salience": 0.0020935023,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07w16",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_South_Africa"
				},
				"name": "University of South Africa",
				"salience": 0.0020437161,
				"type": "ORGANIZATION"
			},
			{
				"name": "#AfrikaansMustFall",
				"salience": 0.0020367433,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0020200058,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0019796418,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0019796418,
				"type": "EVENT"
			},
			{
				"name": "university instruction",
				"salience": 0.0019796418,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.001969424,
				"type": "OTHER"
			},
			{
				"name": "black",
				"salience": 0.0019216732,
				"type": "OTHER"
			},
			{
				"name": "university",
				"salience": 0.0018537048,
				"type": "ORGANIZATION"
			},
			{
				"name": "language",
				"salience": 0.0018511164,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0017874264,
				"type": "OTHER"
			},
			{
				"name": "communism",
				"salience": 0.0017874264,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0017874264,
				"type": "OTHER"
			},
			{
				"name": "decolonization",
				"salience": 0.0017874264,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0017874264,
				"type": "OTHER"
			},
			{
				"name": "visit",
				"salience": 0.0017874264,
				"type": "EVENT"
			},
			{
				"name": "tuition fees",
				"salience": 0.0017874264,
				"type": "OTHER"
			},
			{
				"name": "fallist movement",
				"salience": 0.0017874264,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0017874264,
				"type": "OTHER"
			},
			{
				"name": "universe",
				"salience": 0.0017845127,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0017219096,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0016452885,
				"type": "OTHER"
			},
			{
				"name": "scientist",
				"salience": 0.0016452885,
				"type": "PERSON"
			},
			{
				"name": "elite",
				"salience": 0.0015477634,
				"type": "PERSON"
			},
			{
				"name": "influences",
				"salience": 0.0015477634,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0015477634,
				"type": "EVENT"
			},
			{
				"name": "upheavals",
				"salience": 0.0015477634,
				"type": "OTHER"
			},
			{
				"name": "hashtag",
				"salience": 0.0015477634,
				"type": "OTHER"
			},
			{
				"name": "genocide",
				"salience": 0.0015477634,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0015430823,
				"type": "PERSON"
			},
			{
				"name": "fallist",
				"salience": 0.0015111879,
				"type": "PERSON"
			},
			{
				"name": "trace",
				"salience": 0.0014526705,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.001387984,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.001387984,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.001387984,
				"type": "ORGANIZATION"
			},
			{
				"name": "paradigm",
				"salience": 0.0013718744,
				"type": "OTHER"
			},
			{
				"name": "black magic",
				"salience": 0.001370493,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0013686811,
				"type": "PERSON"
			},
			{
				"name": "ideas",
				"salience": 0.001336169,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.001336169,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.001336169,
				"type": "OTHER"
			},
			{
				"name": "pot",
				"salience": 0.001336169,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "black magic",
				"salience": 0.001336169,
				"type": "OTHER"
			},
			{
				"name": "magic",
				"salience": 0.001336169,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.001336169,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0013352357,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0013292711,
				"type": "OTHER"
			},
			{
				"name": "ridicule",
				"salience": 0.0013292711,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.001318409,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0013085497,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0012862874,
				"type": "OTHER"
			},
			{
				"name": "product",
				"salience": 0.001285389,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "science",
				"salience": 0.0012767061,
				"type": "OTHER"
			},
			{
				"name": "concepts",
				"salience": 0.0012531957,
				"type": "OTHER"
			},
			{
				"name": "concepts",
				"salience": 0.0012531957,
				"type": "OTHER"
			},
			{
				"name": "opposites",
				"salience": 0.0012531957,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0012531957,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.0012531957,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0012531957,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0012382675,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0012135549,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.0012064107,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.0012064107,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0012064107,
				"type": "PERSON"
			},
			{
				"name": "science",
				"salience": 0.0011982612,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0011982612,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0011982612,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0011982612,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0011982612,
				"type": "OTHER"
			},
			{
				"name": "Knowledge",
				"salience": 0.001180725,
				"type": "OTHER"
			},
			{
				"name": "error",
				"salience": 0.0011582926,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0011535262,
				"type": "OTHER"
			},
			{
				"name": "contributions",
				"salience": 0.0011330749,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016gnp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cecil_Rhodes"
				},
				"name": "Cecil Rhodes",
				"salience": 0.0011001349,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/11bwgw4gnv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FeesMustFall"
				},
				"name": "#FeesMustFall",
				"salience": 0.0011001349,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.0010989918,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0010851414,
				"type": "PERSON"
			},
			{
				"name": "negation",
				"salience": 0.0010851414,
				"type": "OTHER"
			},
			{
				"name": "desublimate",
				"salience": 0.0010851414,
				"type": "PERSON"
			},
			{
				"name": "apartheid",
				"salience": 0.0010851414,
				"type": "OTHER"
			},
			{
				"name": "segregation",
				"salience": 0.0010851414,
				"type": "OTHER"
			},
			{
				"name": "ignorance",
				"salience": 0.0010851414,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0010700902,
				"type": "LOCATION"
			},
			{
				"name": "solutions",
				"salience": 0.0010446284,
				"type": "OTHER"
			},
			{
				"name": "modernity",
				"salience": 0.0010446284,
				"type": "OTHER"
			},
			{
				"name": "dismissal",
				"salience": 0.0010446284,
				"type": "OTHER"
			},
			{
				"name": "vacuum",
				"salience": 0.0010446284,
				"type": "OTHER"
			},
			{
				"name": "student radicalism",
				"salience": 0.0010446284,
				"type": "OTHER"
			},
			{
				"name": "whole",
				"salience": 0.0010446284,
				"type": "LOCATION"
			},
			{
				"name": "founders",
				"salience": 0.0010446284,
				"type": "PERSON"
			},
			{
				"name": "acid",
				"salience": 0.0010446284,
				"type": "OTHER"
			},
			{
				"name": "grass",
				"salience": 0.0010446284,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.0010446284,
				"type": "EVENT"
			},
			{
				"name": "problems",
				"salience": 0.0010378611,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0010324755,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.0010230338,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0009774733,
				"type": "OTHER"
			},
			{
				"name": "student",
				"salience": 0.0009774733,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.0009774733,
				"type": "OTHER"
			},
			{
				"name": "educations",
				"salience": 0.00096808234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0729t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soweto"
				},
				"name": "Soweto",
				"salience": 0.0009526006,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01xbgx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cambodia"
				},
				"name": "Cambodia",
				"salience": 0.0009526006,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01c5dk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ng%C5%A9g%C4%A9_wa_Thiong'o"
				},
				"name": "Ngugi wa Thiong'o",
				"salience": 0.00094127323,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0009083198,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/096l67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Maverick"
				},
				"name": "The Daily Maverick",
				"salience": 0.000899078,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0008858366,
				"type": "ORGANIZATION"
			},
			{
				"name": "defense",
				"salience": 0.0008858366,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0008858366,
				"type": "OTHER"
			},
			{
				"name": "world learning",
				"salience": 0.0008858366,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0008858366,
				"type": "OTHER"
			},
			{
				"name": "hub",
				"salience": 0.0008858366,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0008858366,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0008858366,
				"type": "WORK_OF_ART"
			},
			{
				"name": "credit",
				"salience": 0.0008858366,
				"type": "OTHER"
			},
			{
				"name": "readings",
				"salience": 0.0008858366,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00084638473,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00084638473,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00084638473,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.0008383503,
				"type": "OTHER"
			},
			{
				"name": "attitudes",
				"salience": 0.00083140214,
				"type": "OTHER"
			},
			{
				"name": "Has the Great Library",
				"salience": 0.0008181057,
				"type": "WORK_OF_ART"
			},
			{
				"name": "correspondence university",
				"salience": 0.0008026411,
				"type": "ORGANIZATION"
			},
			{
				"name": "whites",
				"salience": 0.000797939,
				"type": "PERSON"
			},
			{
				"name": "posits",
				"salience": 0.00077525654,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.00076418003,
				"type": "OTHER"
			},
			{
				"name": "witchdoctor",
				"salience": 0.00076418003,
				"type": "PERSON"
			},
			{
				"name": "lecturers",
				"salience": 0.00076076586,
				"type": "PERSON"
			},
			{
				"name": "fallist student",
				"salience": 0.0007118554,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01bmx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afrocentrism"
				},
				"name": "Afrocentrist",
				"salience": 0.00069374026,
				"type": "PERSON"
			},
			{
				"name": "#ScienceMustFall nie so belaglik soos dit mag klink",
				"salience": 0.00066783716,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0006672208,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0006672208,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0006672208,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0006672208,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0006616907,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0006616907,
				"type": "WORK_OF_ART"
			},
			{
				"name": "beliefs",
				"salience": 0.0006616907,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0006616907,
				"type": "OTHER"
			},
			{
				"name": "edits",
				"salience": 0.0006616907,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dictum",
				"salience": 0.0006533505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ctby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hippie"
				},
				"name": "Hippie",
				"salience": 0.00064290105,
				"type": "PERSON"
			},
			{
				"name": "Umhlab'uyalingana",
				"salience": 0.00064290105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_zsd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marxist_philosophy"
				},
				"name": "Marxist",
				"salience": 0.00064290105,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0651vn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marxism"
				},
				"name": "Marxism",
				"salience": 0.00064290105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bh3l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KwaZulu-Natal"
				},
				"name": "KZN",
				"salience": 0.00064290105,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06lmhqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/An_Essay_on_Liberation"
				},
				"name": "An Essay on Liberation",
				"salience": 0.00064290105,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01mzkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinua_Achebe"
				},
				"name": "Chinua Achebe",
				"salience": 0.00062960945,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.00062960945,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00062102755,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.00061638246,
				"type": "PERSON"
			},
			{
				"name": "thinking",
				"salience": 0.00061638246,
				"type": "OTHER"
			},
			{
				"name": "fallists",
				"salience": 0.00061408844,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.00060818804,
				"type": "OTHER"
			},
			{
				"name": "tooth aches",
				"salience": 0.00060818804,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00056826184,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0005565131,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03rt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic_of_Ireland"
				},
				"name": "Ireland",
				"salience": 0.00054516544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00054516544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0858l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wole_Soyinka"
				},
				"name": "Wole Soyinka",
				"salience": 0.00054516544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0p_y8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tuareg_people"
				},
				"name": "Tuareg",
				"salience": 0.00054516544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "Al Qaeda",
				"salience": 0.00054516544,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07q5n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_Yorker"
				},
				"name": "New Yorker",
				"salience": 0.00054516544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00054516544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.00054516544,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.0005317258,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.00050474633,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.00049838406,
				"type": "OTHER"
			},
			{
				"name": "humiliation",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "voodoo",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "rituals",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "fuss",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "cure",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "methodology",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "appendicitis",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "straitjacket",
				"salience": 0.0004818715,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "favor",
				"salience": 0.0004818715,
				"type": "OTHER"
			},
			{
				"name": "dark arts",
				"salience": 0.0004818715,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "English",
				"salience": 0.00047028874,
				"type": "LOCATION"
			},
			{
				"name": "Europhobic",
				"salience": 0.00047028874,
				"type": "OTHER"
			},
			{
				"name": "The Clash of Civilizations and the Remaking of World Order",
				"salience": 0.00047028874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "medicine",
				"salience": 0.0004604084,
				"type": "OTHER"
			},
			{
				"name": "entanglement",
				"salience": 0.00045803096,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.00045803096,
				"type": "WORK_OF_ART"
			},
			{
				"name": "works",
				"salience": 0.00045225743,
				"type": "WORK_OF_ART"
			},
			{
				"name": "power",
				"salience": 0.00044092775,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00043405264,
				"type": "OTHER"
			},
			{
				"name": "disciplines",
				"salience": 0.000415687,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.000415687,
				"type": "OTHER"
			},
			{
				"name": "product",
				"salience": 0.000415687,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "words",
				"salience": 0.000415687,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.000415687,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0g284",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Johannesburg"
				},
				"name": "Johannesburg",
				"salience": 0.00040721055,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00040721055,
				"type": "LOCATION"
			},
			{
				"name": "charge",
				"salience": 0.00039837672,
				"type": "OTHER"
			},
			{
				"name": "heritages",
				"salience": 0.00039335506,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.00037866665,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Fall: Decolonisation",
				"salience": 0.00037791373,
				"type": "EVENT"
			},
			{
				"name": "astronomy",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "mathematics",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0003599316,
				"type": "PERSON"
			},
			{
				"name": "physics",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "false",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "rejuvenation",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "insight",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "wisdom",
				"salience": 0.0003599316,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0002938128,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0002558107,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.00022149789,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/078ffw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_Potter"
				},
				"name": "Harry Potter",
				"salience": 0.000075344404,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:53:19.289+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 21.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Posted on October 26, 2016 Blacks and Liberals Want to Abolish Science Dan Roodt, American Renaissance, October 26, 2016 The South African “fallist” movement finds another target. \nOn my recent visit to Stockholm for the Identitarian Conference, some Swedes and I compared notes on whose country was the most crazy-liberal and anti-white. The Swedes pointed to a short video recently released by an NGO that said Swedes should “integrate” into the culture of third-world immigrants to form a “new country.” \nMy Swedish colleagues agreed with French author Renaud Camus. Writing on Free West Media , he argues that, whereas white populations everywhere seem determined to be replaced by third-worlders, “the case of Sweden is even more tragic, more extreme, more insane. Nowhere else do a people and a nation show a stronger will to suicide.” \nBut I believe South Africa is worse. We have actual laws, regulations and policies that require corporations, universities and sports bodies to replace whites. Our country has become the world champion of anti-white, anti-Western ideology. Together with our northern neighbor Zimbabwe, we are to multiculturalism what Pol Pot’s short-lived Democratic Kampuchea was to communism: its most extreme expression. Pol Pot waged genocide against the entire middle class of Cambodia in order to start a “new society.” \nSouth Africa’s ruling elite also wants a “new society” that will be cleansed of Western influences and even the white race. As Robert Mugabe put it during his famous 2015 visit to Soweto: “I don’t want to see a white face.” \nThe current upheavals at our universities–known absurdly as the “fallist movement”–have been widely reported. Enraged black students, egged on by “understanding” whites, have demanded that one thing after another must “fall,” each accompanied by its own hashtag. First it was #RhodesMustFall (the statue of Cecil Rhodes at the University of Cape Town), then #AfrikaansMustFall (blacks want to eliminate Afrikaans as a language of university instruction), followed by #FeesMustFall (they want tuition fees abolished) and now, #ScienceMustFall. \nIn a video that has had nearly a million views, a female black student at the University of Cape Town called for science to be scrapped, saying: \nIf I personally were committed to decolonization, science as a whole is a product of Western modernity and the whole thing should be scratched off. So if you want practical solutions to how to decolonize science, we have to restart science from–I don’t know–from an African perspective, from our perspective, from how we’ve experienced science. For instance, I have a question for all the science people: There is a place in KZN called Umhlab’uyalingana. They believe that through the magic, the black magic–you call it black magic, they call it witchcraft–you are able to send lightening to strike someone. Can you explain that scientifically because it’s something that happens? \nThe initial reaction was widespread ridicule from ordinary whites, but I knew that her dismissal of Western science was not taking place in a vacuum and was connected with the cultural-Marxist ideas swirling through most Western universities. After all, Herbert Marcuse, one of the founders of cultural Marxism wrote this in “An Essay on Liberation” in 1969, at the height of US student radicalism: \nThis is the Hippie subculture: ‘trip,’‘grass,’‘pot,’‘acid,’ and so on. But a far more subversive universe of discourse announces itself in the language of black militants. Here is a systematic linguistic rebellion, which smashes the ideological context in which the words are employed and defined, and places them into the opposite context–negation of the established one. Thus, the blacks ‘take over’ some of the most sublime and sublimated concepts of Western civilization, desublimate and redefine them. (p. 35) \nNeedless to say, Marcuse approved of the black “take over,” and if he were alive today, he would surely applaud what is happening in South Africa. Not only are blacks taking over Western concepts and changing them into their opposites, they are taking over our institutions as well. \nIn universities and the mainstream media there was actually praising this young “fallist.” I was only slightly surprised to read a piece in Afrikaans entitled, “ #ScienceMustFall nie so belaglik soos dit mag klink ” (#ScienceMustFall not so ridiculous as it sounds). It was written by Liezel de Lange, the managing director of our Sunday newspaper Rapport , which once supported apartheid and segregation. \nMiss De Lange first confessed ignorance because she attended the University of Pretoria in the days when it still taught Western ideas and culture. She laments that when she studied English literature “almost all our prescribed works were from Britain (and Ireland), as well as the USA. I have to give my lecturers at the time credit for assigning readings from Wole Soyinka, Chinua Achebe and Ngugi wa Thiong’o.” Most Westerners no doubt have deficient educations because they have not been taught Ngugi wa Thiong’o. \nAlthough Liezel de Lange did not exactly endorse the science-must-fall idea, in defense of the young fallist she evoked the mythical “medieval African university” of Timbuktu as evidence that Africa’s vast contributions to world learning are being ignored. In fact, Timbuktu was a center for Islamic and Tuareg schools, not a hub of forgotten African or black science. Nor are Africans themselves united in wanting to preserve what is left of the “medieval African university.” Recent Al Qaeda activity in the region has been so destructive that the New Yorker recently ran a story called “ Has the Great Library of Timbuktu Been Lost? ” \nI asked Liezel de Lange on Twitter whether she was an Afrocentrist, but she evaded the question, answering that she merely “posits that not all knowledge, wisdom and insight come from the West.” It’s hard to disagree with that. \nMiss De Lange’s column was just a watered-down version of a more radical piece she had read on the left-wing website The Daily Maverick by Joel Modiri, called “ In the Fall: Decolonisation and the rejuvenation of the academic project in South Africa .” \nMr. Modiri is a black academic at UNISA (University of South Africa), which has been racially “transformed”–meaning that whites have been all but banished. It is Africa’s largest correspondence university, naturally founded by South African whites. Mr. Modiri explained that “her [the fallists] error proves her point.” He decried: \nthe presentation of knowledge by South African universities as predominantly the product of the West, and the failure to recognize that some of the major scientific disciplines (medicine, physics, astronomy, mathematics, among others) have deep heritages in Africa, China and India . . . . \nIn other words, she is a victim of the false, Eurocentric view that science is Western to begin with. Some American blacks have long maintained that the West stole its knowledge from Africa. They never explain how science could be “stolen” from one people by another, leaving no trace behind. Knowledge is not like the Mona Lisa, which cannot exist in more than one place, so it is strange that the wise Africans who conceived of science and culture no longer possessed it once it was “stolen” from them. \nBut we have to remember Samuel Huntington’s dictum in his book The Clash of Civilizations and the Remaking of World Order : “culture follows power.” If anything, this is what the rest of the world might learn from South Africa: Whoever dominates politically will impose his culture and beliefs, even if they are more primitive than those it replaces. Once the scientist has been politically and culturally subjugated he may have to bow down to the witchdoctor. \nUnfortunately, it is not only pseudo-intellectual blacks such as Mr. Modiri who hate the West. One of the most Europhobic statements in support of the black UCT student came from Stuart Theobald, a white-liberal English South African academic who “divides his time between London and Johannesburg.” \nIn the same Rapport that Liezel de Lange edits, Mr. Theobald writes of the need to “decolonize” science because “it has been used to justify racism” and to support “biological racism.” He continues: \nWe are kidding ourselves if we pretend that colonial attitudes are not still affecting the way science works today. This is why a deliberate effort to decolonise science is valuable and South African universities have the opportunity to lead the charge. \nHe adds that we need a new paradigm in science “that recognises the racism embedded in much of scientific practice and methodology,” and that “a postcolonial science” that is “shorn of the straitjacket of past thinking” will solve problems that now baffle us. He notes the “fuss” made over the fallist student’s comments and then asks: “But when you see the entanglement of racism and science, can you blame her?” \nAre South African blacks and white liberals ready to ditch science in favor of the “dark arts” as Harry Potter would say? If they have tooth aches or appendicitis, I suspect they will submit to the humiliation of “colonial science” rather than look for a cure in the traditional rituals and voodoo of Africa.",
		"thread_title": "Blacks and Liberals Want to Abolish Science",
		"title": "Blacks and Liberals Want to Abolish Science",
		"type": "bs",
		"uuid": "88ecc601dc5bd8f4942cca8f840ddade978c8461"
	},
	"-KhIgZ6qbFGSNXuZJa4l": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:53:28.898+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "identity",
				"salience": 0.29035053,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.18399592,
				"type": "PERSON"
			},
			{
				"name": "identity politics",
				"salience": 0.042183913,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.03379442,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.026004255,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.018793164,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.01339435,
				"type": "PERSON"
			},
			{
				"name": "minorities",
				"salience": 0.01339435,
				"type": "PERSON"
			},
			{
				"name": "rise",
				"salience": 0.012101014,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.012101014,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07hwkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_American"
				},
				"name": "White",
				"salience": 0.011815827,
				"type": "PERSON"
			},
			{
				"name": "Lot",
				"salience": 0.010486263,
				"type": "PERSON"
			},
			{
				"name": "commentators",
				"salience": 0.010486263,
				"type": "PERSON"
			},
			{
				"name": "antipathy",
				"salience": 0.010486263,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.008568039,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.007932369,
				"type": "LOCATION"
			},
			{
				"name": "attitudes",
				"salience": 0.0068600136,
				"type": "OTHER"
			},
			{
				"name": "preferences",
				"salience": 0.0068600136,
				"type": "OTHER"
			},
			{
				"name": "Eric D. Knowles",
				"salience": 0.006465903,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/069p0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quartz"
				},
				"name": "Quartz",
				"salience": 0.006465903,
				"type": "LOCATION"
			},
			{
				"name": "Linda R. Tropp",
				"salience": 0.006465903,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0062385947,
				"type": "PERSON"
			},
			{
				"name": "aspect",
				"salience": 0.0061956556,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0061956556,
				"type": "PERSON"
			},
			{
				"name": "rise",
				"salience": 0.0061956556,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0058801235,
				"type": "PERSON"
			},
			{
				"name": "focus",
				"salience": 0.0057172505,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0055656196,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.0053667855,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0053667855,
				"type": "OTHER"
			},
			{
				"name": "resentment",
				"salience": 0.0053667855,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0053667855,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.005158732,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0037640044,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.0037300116,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0037103142,
				"type": "PERSON"
			},
			{
				"name": "identities",
				"salience": 0.0032703874,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0031885798,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0031470608,
				"type": "PERSON"
			},
			{
				"name": "prejudice",
				"salience": 0.0030611728,
				"type": "OTHER"
			},
			{
				"name": "Ryan Enos",
				"salience": 0.0030226863,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.0028282178,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0027339687,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0027339687,
				"type": "PERSON"
			},
			{
				"name": "candidacy",
				"salience": 0.0025538192,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0025538192,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.0025538192,
				"type": "ORGANIZATION"
			},
			{
				"name": "identity politics",
				"salience": 0.0025365085,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0025365085,
				"type": "OTHER"
			},
			{
				"name": "identity politics",
				"salience": 0.002441897,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.002419141,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.002419141,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.002409467,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0023863392,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0023825718,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0023289023,
				"type": "OTHER"
			},
			{
				"name": "ballot box",
				"salience": 0.002211623,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.002211623,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.002211623,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.002211623,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.002211623,
				"type": "ORGANIZATION"
			},
			{
				"name": "animosity",
				"salience": 0.002211623,
				"type": "OTHER"
			},
			{
				"name": "turn",
				"salience": 0.002211623,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0020709992,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0019834477,
				"type": "PERSON"
			},
			{
				"name": "attitudes",
				"salience": 0.0019834477,
				"type": "OTHER"
			},
			{
				"name": "preferences",
				"salience": 0.0019834477,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.00197515,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0019094456,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0018056841,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0017909367,
				"type": "OTHER"
			},
			{
				"name": "aspect",
				"salience": 0.0017909367,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0017909367,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0017355633,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0017241109,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0017241109,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0017241109,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.001716413,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.001670802,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0016597767,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.001619356,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.001619356,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.001619356,
				"type": "PERSON"
			},
			{
				"name": "scale",
				"salience": 0.001619356,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.001557839,
				"type": "OTHER"
			},
			{
				"name": "sample",
				"salience": 0.0015508828,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0015508828,
				"type": "OTHER"
			},
			{
				"name": "anxieties",
				"salience": 0.0015508828,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.0015508828,
				"type": "OTHER"
			},
			{
				"name": "fringe",
				"salience": 0.0014930075,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0014930075,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0014930075,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0014930075,
				"type": "LOCATION"
			},
			{
				"name": "beliefs",
				"salience": 0.0014930075,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.001475646,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.001475646,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.001475646,
				"type": "OTHER"
			},
			{
				"name": "exposure",
				"salience": 0.0014621574,
				"type": "EVENT"
			},
			{
				"name": "relationship",
				"salience": 0.001397068,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0013850091,
				"type": "OTHER"
			},
			{
				"name": "prejudice",
				"salience": 0.00130951,
				"type": "OTHER"
			},
			{
				"name": "prejudice",
				"salience": 0.00130951,
				"type": "OTHER"
			},
			{
				"name": "prejudice",
				"salience": 0.00130951,
				"type": "OTHER"
			},
			{
				"name": "greatest",
				"salience": 0.0013053986,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.00129661,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.00129661,
				"type": "OTHER"
			},
			{
				"name": "salience",
				"salience": 0.0012661446,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0012661446,
				"type": "OTHER"
			},
			{
				"name": "items",
				"salience": 0.0012661446,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.0012661446,
				"type": "OTHER"
			},
			{
				"name": "graph",
				"salience": 0.0012661446,
				"type": "WORK_OF_ART"
			},
			{
				"name": "questionnaire",
				"salience": 0.0012661446,
				"type": "OTHER"
			},
			{
				"name": "Whites",
				"salience": 0.0012618648,
				"type": "PERSON"
			},
			{
				"name": "ones",
				"salience": 0.0012344414,
				"type": "LOCATION"
			},
			{
				"name": "attitudes",
				"salience": 0.0012097757,
				"type": "OTHER"
			},
			{
				"name": "immigration policies",
				"salience": 0.0011269703,
				"type": "OTHER"
			},
			{
				"name": "survey",
				"salience": 0.0011153665,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0010747887,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0010747887,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0010747887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fk1z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic"
				},
				"name": "Hispanic",
				"salience": 0.0010643391,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.0010433082,
				"type": "PERSON"
			},
			{
				"name": "characteristic",
				"salience": 0.00094585906,
				"type": "OTHER"
			},
			{
				"name": "pattern",
				"salience": 0.00094585906,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.00094585906,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00094585906,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00094266137,
				"type": "PERSON"
			},
			{
				"name": "Whites",
				"salience": 0.00094266137,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.00088110997,
				"type": "OTHER"
			},
			{
				"name": "neighborhoods",
				"salience": 0.00088110997,
				"type": "LOCATION"
			},
			{
				"name": "neighborhoods",
				"salience": 0.00088110997,
				"type": "LOCATION"
			},
			{
				"name": "Latinos",
				"salience": 0.0007955479,
				"type": "PERSON"
			},
			{
				"name": "exposure",
				"salience": 0.0007955479,
				"type": "OTHER"
			},
			{
				"name": "prediction",
				"salience": 0.0007721588,
				"type": "OTHER"
			},
			{
				"name": "credence",
				"salience": 0.00068886817,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00068886817,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00068886817,
				"type": "LOCATION"
			},
			{
				"name": "work",
				"salience": 0.00068886817,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00068886817,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.0006581912,
				"type": "OTHER"
			},
			{
				"name": "preference",
				"salience": 0.0006581912,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.0006581912,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.0006581912,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0005942698,
				"type": "PERSON"
			},
			{
				"name": "respondents",
				"salience": 0.0005942698,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0005942698,
				"type": "OTHER"
			},
			{
				"name": "respondents",
				"salience": 0.0005942698,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0005942698,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vpp0s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanophobia"
				},
				"name": "anti-Hispanic",
				"salience": 0.00058215385,
				"type": "PERSON"
			},
			{
				"name": "differences",
				"salience": 0.0005552618,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00051457365,
				"type": "OTHER"
			},
			{
				"name": "likelihood",
				"salience": 0.00051457365,
				"type": "OTHER"
			},
			{
				"name": "identity lead",
				"salience": 0.00051457365,
				"type": "OTHER"
			},
			{
				"name": "challengers",
				"salience": 0.00051457365,
				"type": "PERSON"
			},
			{
				"name": "analyses",
				"salience": 0.00051457365,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00031668166,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00031668166,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:14:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "A Lot of People in the US Are Suddenly Identifying as “White” Eric D. Knowles and Linda R. Tropp, Quartz, October 25, 2016 \nMany political commentators credit Donald Trump’s rise to white voters’ antipathy toward racial and ethnic minorities. However, we believe this focus on racial resentment obscures another important aspect of racial thinking. \nIn a study of white Americans’ attitudes and candidate preferences, we found that Trump’s success reflects the rise of “white identity politics”–an attempt to protect the collective interests of white voters via the ballot box. Whereas racial prejudice refers to animosity toward other racial groups, white identity reflects a sense of connection to fellow white Americans. \nWe’re not the first to tie Trump’s candidacy to white identity politics . But our data provide some of the clearest evidence that ongoing demographic changes in the United States are increasing white racial identity. White identity, in turn, is pushing white Americans to support Trump. \nWhite identity \nWhen we talk about white identity, we’re not referring to the alt-right fringe, the white nationalist movement, or others who espouse racist beliefs. Rather, we’re talking about everyday white Americans who, perhaps for the first time, are racially conscious. \n{snip} \nNon-Hispanic whites are projected to become a minority in the year 2044. This increasing diversity across the country is making whites’ own race harder and harder to ignore. {snip} \nTrump and white identity politics \nAs whites increasingly sense that their status in society is falling , white racial identity is becoming politicized. Trump’s promise to “make America great again” speaks to these anxieties by recalling a past in which white people dominated every aspect of politics and society. {snip} \n{snip} \nTo test our ideas about Trump and white identity politics, we surveyed a nationally representative sample of about 1,700 white Americans. The survey covered racial identities, attitudes, and political preferences. In examining the relationship between white identity and ethnic diversity, we chose to focus on an ethnic minority of particular salience in contemporary politics: Hispanics. {snip} \nDo whites from heavily Hispanic neighborhoods show stronger white racial identity? To measure identity, we used a widely-used questionnaire . On a five-point scale, participants rated their agreement with items such as “Being a white person is an important part of how I see myself” and “I feel solidarity with other white people.” As shown in the graph below, there is a positive relationship between exposure to Hispanics and white respondents’ sense of racial identity. \nAnd does white identity lead to support for Donald Trump? We examined the relationship between white identity and respondents’ likelihood of supporting Trump for the presidency versus Hillary Clinton or several Republican primary challengers. Consistent with others’ analyses , white identity strongly predicts a preference for Trump. \nWhites at the high end of the racial identity scale are more than four times as likely to support Trump than those at the low end of the scale. Perhaps that’s because whites highest in racial identity are also the ones most likely to harbor negative attitudes against Latinos. Indeed, we found white identity was significantly correlated with another characteristic–prejudice. \nHowever, differences in prejudice don’t explain the relationship between white identity and Trump support. The pattern in the figure above was tested while statistically controlling for levels of anti-Hispanic prejudice. Because the relationship between identity and support for Trump remains strong, we are confident that white identity independently predicts greater Trump support. \nWe’ve seen that living close to Hispanics leads whites to develop a strong sense of racial identity and that strong racial identity is associated with support for Donald Trump. We should therefore expect that whites in heavily Hispanic neighborhoods support Trump more often than those in neighborhoods with fewer Hispanics. This prediction gains credence from work by political scientist Ryan Enos, who finds that everyday exposure to Latinos can increase support for restrictive immigration policies. \nWhites’ support for Donald Trump is, in fact, greatest in areas with a large Hispanic population. \n{snip}",
		"thread_title": "A Lot of People in the US Are Suddenly Identifying as “White”",
		"title": "A Lot of People in the US Are Suddenly Identifying as “White”",
		"type": "bs",
		"uuid": "71a809c0d4982da124d8436248343b5a649cf60c"
	},
	"-KhIgZGEoe4tvLI466ft": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:53:30.351+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.24516602,
				"type": "LOCATION"
			},
			{
				"name": "data",
				"salience": 0.10894366,
				"type": "OTHER"
			},
			{
				"name": "City",
				"salience": 0.049912922,
				"type": "LOCATION"
			},
			{
				"name": "Size",
				"salience": 0.049912922,
				"type": "OTHER"
			},
			{
				"name": "Moms",
				"salience": 0.043375265,
				"type": "PERSON"
			},
			{
				"name": "Feds",
				"salience": 0.043375265,
				"type": "OTHER"
			},
			{
				"name": "babies",
				"salience": 0.03907118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h5df0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illegal_immigration"
				},
				"name": "Illegals",
				"salience": 0.031038353,
				"type": "PERSON"
			},
			{
				"name": "Orlando Paul Bedard",
				"salience": 0.026935728,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sjhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Examiner"
				},
				"name": "Washington Examiner",
				"salience": 0.026935728,
				"type": "ORGANIZATION"
			},
			{
				"name": "birth",
				"salience": 0.024168504,
				"type": "OTHER"
			},
			{
				"name": "babies",
				"salience": 0.02308679,
				"type": "PERSON"
			},
			{
				"name": "analysis",
				"salience": 0.02308679,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.020869434,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.020869434,
				"type": "LOCATION"
			},
			{
				"name": "citizens",
				"salience": 0.013722803,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ply0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orlando,_Florida"
				},
				"name": "Orlando",
				"salience": 0.012898556,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/040zkg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Center_for_Health_Statistics"
				},
				"name": "National Center for Health Statistics",
				"salience": 0.012898556,
				"type": "ORGANIZATION"
			},
			{
				"name": "analysis",
				"salience": 0.012629392,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.012422458,
				"type": "PERSON"
			},
			{
				"name": "birthrate",
				"salience": 0.011512883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.011178823,
				"type": "LOCATION"
			},
			{
				"name": "births",
				"salience": 0.011085519,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/08qtd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pew_Research_Center"
				},
				"name": "Pew Research Center",
				"salience": 0.010045167,
				"type": "PERSON"
			},
			{
				"name": "births",
				"salience": 0.009408619,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.008328716,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.008019032,
				"type": "OTHER"
			},
			{
				"name": "trajectory",
				"salience": 0.007977798,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.007522924,
				"type": "OTHER"
			},
			{
				"name": "illegals",
				"salience": 0.0072430824,
				"type": "OTHER"
			},
			{
				"name": "births",
				"salience": 0.00703658,
				"type": "EVENT"
			},
			{
				"name": "births",
				"salience": 0.00703658,
				"type": "EVENT"
			},
			{
				"name": "immigrants",
				"salience": 0.006517356,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.006274792,
				"type": "OTHER"
			},
			{
				"name": "drop",
				"salience": 0.0055997744,
				"type": "OTHER"
			},
			{
				"name": "Recession",
				"salience": 0.005323491,
				"type": "EVENT"
			},
			{
				"name": "births",
				"salience": 0.005129405,
				"type": "EVENT"
			},
			{
				"name": "increase",
				"salience": 0.0044592638,
				"type": "OTHER"
			},
			{
				"name": "newborns",
				"salience": 0.004029823,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0040123193,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0037071658,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0027703652,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0025016018,
				"type": "OTHER"
			},
			{
				"name": "births",
				"salience": 0.0019591525,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:13:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Feds: 275,000 Born to Illegals in One Year, Would Fill City the Size of Orlando Paul Bedard, Washington Examiner, October 26, 2016 \nMoms in the United States illegally gave birth to 275,000 babies in 2014, enough birthright U.S. citizens to fill a city the size of Orlando, Florida, according to an analysis of data from the National Center for Health Statistics. \nThe data showed that newborns to illegals accounted for 7 percent of all births in 2014, according to the analysis from the Pew Research Center. \n{snip} \nThe analysis also found that the growth in the birthrate of America is entirely driven by immigrants. \n“While the annual number of babies born in the U.S. has fluctuated in recent years–most markedly during the Great Recession when there was a significant drop in births nationwide–the trajectory over the past four decades or so has been upward. In 2014, there were 4 million births in the U.S., compared with 3.74 million in 1970,” said Pew. \n“This growth has been driven entirely by the increasing numbers of babies born to immigrant women. In 2014, immigrant women accounted for about 901,000 U.S. births, which marked a threefold increase from 1970 when immigrant women accounted for about 274,000 births. Meanwhile, the annual number of births to U.S.-born women dropped by 11 percent during that same time period, from 3.46 million in 1970 to 3.10 million in 2014,” added Pew.",
		"thread_title": "Feds: 275,000 Born to Illegals in One Year, Would Fill City the Size of Orlando",
		"title": "Feds: 275,000 Born to Illegals in One Year, Would Fill City the Size of Orlando",
		"type": "bs",
		"uuid": "aea9c33ec6de78c4da735cd2c36dc6bc42e13b9b"
	},
	"-KhIgZQIHq2myy3cFB4F": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:53:30.984+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "dozens",
				"salience": 0.17009142,
				"type": "PERSON"
			},
			{
				"name": "Chris Cabrera",
				"salience": 0.1027728,
				"type": "PERSON"
			},
			{
				"name": "Surge",
				"salience": 0.08608027,
				"type": "EVENT"
			},
			{
				"name": "men",
				"salience": 0.074838825,
				"type": "PERSON"
			},
			{
				"name": "Migrants Illegally Crossing U.S.-Mexico Border",
				"salience": 0.053598206,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS News",
				"salience": 0.046526708,
				"type": "ORGANIZATION"
			},
			{
				"name": "Election Manuel Bojorquez",
				"salience": 0.046526708,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.036063246,
				"type": "LOCATION"
			},
			{
				"name": "border patrol",
				"salience": 0.035386432,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.03127915,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.03127915,
				"type": "PERSON"
			},
			{
				"name": "migrant center",
				"salience": 0.03127915,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.024173334,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0103hp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McAllen,_Texas"
				},
				"name": "McAllen",
				"salience": 0.019330308,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.019330308,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03w9vbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sacred_Heart_Catholic_Church_(Tampa,_Florida)"
				},
				"name": "Sacred Heart Catholic Church",
				"salience": 0.019330308,
				"type": "LOCATION"
			},
			{
				"name": "wall",
				"salience": 0.015426942,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.013685907,
				"type": "EVENT"
			},
			{
				"name": "border",
				"salience": 0.012735947,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.012528046,
				"type": "OTHER"
			},
			{
				"name": "spikes",
				"salience": 0.011561872,
				"type": "OTHER"
			},
			{
				"name": "border patrol union",
				"salience": 0.011273349,
				"type": "ORGANIZATION"
			},
			{
				"name": "asylum",
				"salience": 0.010853956,
				"type": "OTHER"
			},
			{
				"name": "ankle monitors",
				"salience": 0.010853956,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stretch",
				"salience": 0.01063036,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.009209024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.007722472,
				"type": "LOCATION"
			},
			{
				"name": "nobody",
				"salience": 0.0070605376,
				"type": "PERSON"
			},
			{
				"name": "smugglers",
				"salience": 0.0070148977,
				"type": "PERSON"
			},
			{
				"name": "wall",
				"salience": 0.005791894,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.005791894,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.004692385,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0046492615,
				"type": "OTHER"
			},
			{
				"name": "surge",
				"salience": 0.00432832,
				"type": "EVENT"
			},
			{
				"name": "amnesty",
				"salience": 0.0037484795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0025541706,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:13:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Surge of Migrants Illegally Crossing U.S.-Mexico Border Ahead of Election Manuel Bojorquez, CBS News, October 25, 2016 \nEvery day, dozens of men, women and children stream through the streets of McAllen, Texas to a migrant center at Sacred Heart Catholic Church. \nThey have just illegally crossed into the U.S. and have been released by border patrol, with ankle monitors, while they file for asylum. \n{snip} \n“We’re getting mass spikes of people crossing and turning themselves in,” said Agent Chris Cabrera, who is with the local border patrol union. \nCabrera said on some days, they’ve encountered up to a thousand immigrants along this stretch of the border. He said the election is partly to blame for the surge. \n“The smugglers are telling them if Hillary gets elected, that there’ll be some sort of amnesty, that they need to get here by a certain date. They’re also being told that if Trump gets elected, there’s going to be some magical wall that pops up overnight and once that wall gets up, nobody will ever get in again,” Cabrera said. \n{snip}",
		"thread_title": "Surge of Migrants Illegally Crossing U.S.-Mexico Border Ahead of Election",
		"title": "Surge of Migrants Illegally Crossing U.S.-Mexico Border Ahead of Election",
		"type": "bs",
		"uuid": "59d99b42f234b4707327ff64134844d7dbe07098"
	},
	"-KhIgZaYa9GvxR643fCa": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:53:32.969+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Hispanic Crowd Boos Marco Rubio",
				"salience": 0.7046586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/085srz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patrick_Murphy_(Pennsylvania_politician)"
				},
				"name": "Patrick Murphy",
				"salience": 0.028844481,
				"type": "PERSON"
			},
			{
				"name": "sellout",
				"salience": 0.019403713,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.015789105,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.015572481,
				"type": "OTHER"
			},
			{
				"name": "Stage",
				"salience": 0.01481254,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.014508709,
				"type": "OTHER"
			},
			{
				"name": "festival",
				"salience": 0.0136980815,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.013504745,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.008654606,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.007690768,
				"type": "EVENT"
			},
			{
				"name": "Calle Orange",
				"salience": 0.0076537402,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c0sl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NPR"
				},
				"name": "NPR",
				"salience": 0.0067666676,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ply0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orlando,_Florida"
				},
				"name": "Orlando",
				"salience": 0.0066333804,
				"type": "LOCATION"
			},
			{
				"name": "Rafael Bernal",
				"salience": 0.0066333804,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Fla",
				"salience": 0.0066333804,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "R",
				"salience": 0.0066333804,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ttk_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hill_(newspaper)"
				},
				"name": "The Hill",
				"salience": 0.0064728227,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gkxl2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Puerto_Ricans_in_the_United_States"
				},
				"name": "Puerto Rican",
				"salience": 0.0064728227,
				"type": "LOCATION"
			},
			{
				"name": "Angel Marin",
				"salience": 0.005186427,
				"type": "PERSON"
			},
			{
				"name": "Festival attendants",
				"salience": 0.0051225713,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.004885152,
				"type": "PERSON"
			},
			{
				"name": "brothers",
				"salience": 0.0047652014,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03sjbt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nydia_Vel%C3%A1zquez"
				},
				"name": "Nydia Velazquez",
				"salience": 0.002978046,
				"type": "PERSON"
			},
			{
				"name": "boos",
				"salience": 0.002906286,
				"type": "OTHER"
			},
			{
				"name": "jeering",
				"salience": 0.0024839474,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0023913896,
				"type": "OTHER"
			},
			{
				"name": "festival",
				"salience": 0.0023735391,
				"type": "EVENT"
			},
			{
				"name": "crowd",
				"salience": 0.002354179,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0022733102,
				"type": "PERSON"
			},
			{
				"name": "applause",
				"salience": 0.0022733102,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.0022733102,
				"type": "OTHER"
			},
			{
				"name": "reelection",
				"salience": 0.0022733102,
				"type": "EVENT"
			},
			{
				"name": "crowd",
				"salience": 0.0022664464,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.0022068422,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0020389827,
				"type": "OTHER"
			},
			{
				"name": "boos",
				"salience": 0.0020389827,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001594621,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.001594621,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.001594621,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.001594621,
				"type": "WORK_OF_ART"
			},
			{
				"name": "freedom",
				"salience": 0.0015351542,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0015351542,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0015034543,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crowd",
				"salience": 0.0014365693,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.001400052,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04dbw3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuban_American"
				},
				"name": "Cuban",
				"salience": 0.001400052,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.0013020218,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0013020218,
				"type": "EVENT"
			},
			{
				"name": "points",
				"salience": 0.0013020218,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0013020218,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0012677617,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0012440876,
				"type": "OTHER"
			},
			{
				"name": "emcee",
				"salience": 0.0010903501,
				"type": "PERSON"
			},
			{
				"name": "average",
				"salience": 0.0010903501,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0010630589,
				"type": "PERSON"
			},
			{
				"name": "endorsement",
				"salience": 0.00097280287,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.000945198,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0009062361,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "D",
				"salience": 0.00080159097,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.0007328424,
				"type": "OTHER"
			},
			{
				"name": "bandwagon",
				"salience": 0.00070857443,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.00070857443,
				"type": "OTHER"
			},
			{
				"name": "booing",
				"salience": 0.0006821292,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0006112963,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01g7zj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexican_American"
				},
				"name": "Mexican",
				"salience": 0.0005988366,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.0005777272,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.00052933604,
				"type": "PERSON"
			},
			{
				"name": "Calle Orange",
				"salience": 0.0005036792,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00043991482,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:13:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Hispanic Crowd Boos Marco Rubio off Stage Rafael Bernal, The Hill, October 25, 2016 \nSen. Marco Rubio (R-Fla.) took the stage in Orlando at Calle Orange, a Puerto Rican-themed festival, on Sunday when some in the crowd started booing, NPR reported . \nThe jeering got louder as the Cuban-American senator, seeking reelection after dropping his presidential bid earlier this year, was introduced. \nAnd when the emcee asked for applause as Rubio took the same, boos drowned out any supporters in the crowd, NPR added. \n“Thank you for having me today,” Rubio said in Spanish. “I want you to enjoy this day. We’re not going to talk about politics today. Thank God for this beautiful day, and for our freedom, our democracy, our vote, and our country. God bless you all, thank you very much.” \nHe left the stage to more boos from the crowd, according to the report. \n{snip} \nRubio is running against Rep. Patrick Murphy (D), and the latest average of polls in the race shows Rubio ahead by about 3 points. \nMurphy’s campaign seized on the Sunday incident and blasted out video it says shows the booing. It also noted that Murphy attended the festival “with a leader for Puerto Rican communities, Rep. Nydia Velazquez,” while “Marco Rubio was booed off the stage.” \nRubio’s campaign shared a video with The Hill Monday that it says counters what the Murphy campaign sent out and shows him being greeted enthusiastically as he moves through the crowd. \n{snip} \nFestival attendants said they disapproved of Rubio’s endorsement of Trump, who is deeply unpopular among Hispanics. \n“When we have someone like Trump, who hits our Mexican brothers, our Latino brothers, then you jump on that bandwagon after all that stuff he says not only about you personally . . . as a Latino, you’re a freaking sellout. I would not vote for him if they paid me,” Calle Orange attendant Angel Marin told NPR about Rubio. \n{snip}",
		"thread_title": "Hispanic Crowd Boos Marco Rubio off Stage",
		"title": "Hispanic Crowd Boos Marco Rubio off Stage",
		"type": "bs",
		"uuid": "5c651cc4f181304d062484f6f37ffd34d53460d6"
	},
	"-KhIgZioH2-tVwfxWejS": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:53:36.182+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Daniel Pantaleo",
				"salience": 0.36928526,
				"type": "PERSON"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Death_of_Eric_Garner"
				},
				"name": "Eric Garner",
				"salience": 0.09483431,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Department of Justice",
				"salience": 0.093957834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.06671739,
				"type": "ORGANIZATION"
			},
			{
				"name": "defense",
				"salience": 0.03517335,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.030962748,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.018428853,
				"type": "OTHER"
			},
			{
				"name": "Eric Garner Case",
				"salience": 0.016770083,
				"type": "OTHER"
			},
			{
				"name": "Justice Department Faces Uphill Battle Should",
				"salience": 0.011386536,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02jf15",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_News_(New_York)"
				},
				"name": "NY Daily News",
				"salience": 0.011386536,
				"type": "ORGANIZATION"
			},
			{
				"name": "police chokehold case",
				"salience": 0.011248476,
				"type": "OTHER"
			},
			{
				"name": "civil rights probe",
				"salience": 0.009747978,
				"type": "EVENT"
			},
			{
				"name": "prosecutors",
				"salience": 0.009747978,
				"type": "PERSON"
			},
			{
				"name": "defense lawyer",
				"salience": 0.009747978,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.0088970205,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.008281134,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.0076637836,
				"type": "PERSON"
			},
			{
				"name": "dream",
				"salience": 0.007629685,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.007629685,
				"type": "EVENT"
			},
			{
				"name": "probe",
				"salience": 0.006425652,
				"type": "OTHER"
			},
			{
				"name": "Eric Franz",
				"salience": 0.0062489146,
				"type": "PERSON"
			},
			{
				"name": "Capers",
				"salience": 0.006155501,
				"type": "PERSON"
			},
			{
				"name": "Experts",
				"salience": 0.0054478967,
				"type": "PERSON"
			},
			{
				"name": "threshold",
				"salience": 0.0049319617,
				"type": "OTHER"
			},
			{
				"name": "split",
				"salience": 0.0047791605,
				"type": "EVENT"
			},
			{
				"name": "hands",
				"salience": 0.004506251,
				"type": "OTHER"
			},
			{
				"name": "department",
				"salience": 0.004475745,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.004041949,
				"type": "OTHER"
			},
			{
				"name": "Officer",
				"salience": 0.0038913358,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cr3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brooklyn"
				},
				"name": "Brooklyn",
				"salience": 0.003772294,
				"type": "LOCATION"
			},
			{
				"name": "Robert Capers",
				"salience": 0.0035059247,
				"type": "PERSON"
			},
			{
				"name": "prosecutors",
				"salience": 0.003500837,
				"type": "PERSON"
			},
			{
				"name": "feds",
				"salience": 0.003416731,
				"type": "ORGANIZATION"
			},
			{
				"name": "prosecutors",
				"salience": 0.0033703481,
				"type": "PERSON"
			},
			{
				"name": "trove",
				"salience": 0.0031873677,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0031387315,
				"type": "LOCATION"
			},
			{
				"name": "Defense lawyers",
				"salience": 0.0030456267,
				"type": "PERSON"
			},
			{
				"name": "recommendations",
				"salience": 0.003043502,
				"type": "OTHER"
			},
			{
				"name": "cop",
				"salience": 0.003043502,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0029169596,
				"type": "OTHER"
			},
			{
				"name": "John Marzulli",
				"salience": 0.002906962,
				"type": "PERSON"
			},
			{
				"name": "key",
				"salience": 0.0028802466,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0027521418,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0027315852,
				"type": "OTHER"
			},
			{
				"name": "justification",
				"salience": 0.0027315852,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0026476686,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0026476686,
				"type": "OTHER"
			},
			{
				"name": "investigators",
				"salience": 0.0026358545,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.0026358545,
				"type": "EVENT"
			},
			{
				"name": "division",
				"salience": 0.0025814301,
				"type": "OTHER"
			},
			{
				"name": "civil rights case",
				"salience": 0.002529893,
				"type": "OTHER"
			},
			{
				"name": "civil rights division",
				"salience": 0.0024851623,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.0024665971,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, D.C.",
				"salience": 0.0024039012,
				"type": "LOCATION"
			},
			{
				"name": "light",
				"salience": 0.0023518163,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.002245616,
				"type": "PERSON"
			},
			{
				"name": "witnesses",
				"salience": 0.0022355935,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0022355935,
				"type": "OTHER"
			},
			{
				"name": "branches",
				"salience": 0.0022355935,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.0022355935,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.002136126,
				"type": "OTHER"
			},
			{
				"name": "recommendation",
				"salience": 0.001928839,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.001928839,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.001796877,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0017796265,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0016703472,
				"type": "OTHER"
			},
			{
				"name": "dispute",
				"salience": 0.0016703472,
				"type": "EVENT"
			},
			{
				"name": "longshot",
				"salience": 0.0016703472,
				"type": "OTHER"
			},
			{
				"name": "memos",
				"salience": 0.0016703472,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0016229505,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0016229505,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0015560542,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0014867955,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0014050115,
				"type": "OTHER"
			},
			{
				"name": "criminal case",
				"salience": 0.0013424704,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0013295789,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0012166712,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0012166712,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.001162508,
				"type": "OTHER"
			},
			{
				"name": "cop",
				"salience": 0.001049643,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.0009089148,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0009089148,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:13:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Loading Posted on October 26, 2016 Justice Department Faces Uphill Battle Should Officer Daniel Pantaleo Be Charged in Eric Garner Case, Experts Say John Marzulli, NY Daily News, October 25, 2016 \nAs the Justice Department looks to indict NYPD Office Daniel Pantaleo by year’s end in the civil rights probe of the Eric Garner police chokehold case, experts said Tuesday that bitter in-fighting between prosecutors has made a potential trial a defense lawyer’s dream. \nThe probe is now firmly in the hands of the Department of Justice in Washington, D.C., which appears to have overruled recommendations from Brooklyn prosecutors and FBI investigators not to indict the NYPD cop, sources said. \nThe New York-based feds determined they could not bring a criminal civil rights case against Officer Pantaleo for Garner’s death–leading the Department of Justice to take control of the case. \nDefense lawyers and former prosecutors said the unusual split opens a trove of evidence that could potentially help Pantaleo if he’s indicted. \nWhen U.S. Attorney General Loretta Lynch gives the department’s civil rights division the green light to charge Pantaleo with violating Garner’s civil rights, it could reveal the deep division between the branches of the Justice Department. \nThe key, however, is the defense getting its hands on the information and being allowed by a judge to quiz witnesses about it, the sources said. \n{snip} \nThe federal civil rights criminal case would hinge on proving that Pantaleo “intended” to violate Garner’s civil rights, which is a high threshold because it aims to get inside the cop’s head when he brought Garner to the ground. \n{snip} \nDefense lawyer Eric Franz said he would seek any prosecutorial memos regarding justification of a federal civil rights charge to examine the factual reasons behind the Brooklyn office’s recommendation, but agreed it remains a longshot. \nA greater problem is the damage this dispute is doing to the Justice Department’s credibility, Franz said. \n“I have enormous respect for Mr. Capers (Robert Capers, Brooklyn U.S. attorney) and his office, and they were in the best position to determine whether charges are warranted,” he said. \n{snip}",
		"thread_title": "Justice Department Faces Uphill Battle Should Officer Daniel Pantaleo Be Charged in Eric Garner Case, Experts Say",
		"title": "Justice Department Faces Uphill Battle Should Officer Daniel Pantaleo Be Charged in Eric Garner Case, Experts Say",
		"type": "bs",
		"uuid": "d95ca039990a69d6233aaf2c9f6b7bd585b0aa20"
	},
	"-KhIgZzUS67TV5EvSwwz": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:53:36.447+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.25965792,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.2502057,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.054171532,
				"type": "PERSON"
			},
			{
				"name": "mainstream media",
				"salience": 0.03141515,
				"type": "ORGANIZATION"
			},
			{
				"name": "Matthew Vadum",
				"salience": 0.02444735,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.021539193,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.019749248,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.019084616,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.015349683,
				"type": "EVENT"
			},
			{
				"name": "Violence",
				"salience": 0.011385574,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0098667415,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00803601,
				"type": "PERSON"
			},
			{
				"name": "vandals",
				"salience": 0.0079097375,
				"type": "PERSON"
			},
			{
				"name": "social media",
				"salience": 0.0074513056,
				"type": "OTHER"
			},
			{
				"name": "assaults",
				"salience": 0.0072653773,
				"type": "EVENT"
			},
			{
				"name": "matters",
				"salience": 0.006985837,
				"type": "OTHER"
			},
			{
				"name": "video evidence",
				"salience": 0.0068411445,
				"type": "OTHER"
			},
			{
				"name": "Paul Foster",
				"salience": 0.0063944156,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.006105483,
				"type": "OTHER"
			},
			{
				"name": "LifeZette",
				"salience": 0.006084594,
				"type": "OTHER"
			},
			{
				"name": "Reports",
				"salience": 0.005830328,
				"type": "OTHER"
			},
			{
				"name": "arson",
				"salience": 0.005278256,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.005050451,
				"type": "LOCATION"
			},
			{
				"name": "operatives",
				"salience": 0.005050451,
				"type": "PERSON"
			},
			{
				"name": "banners",
				"salience": 0.005050451,
				"type": "OTHER"
			},
			{
				"name": "lawn signs",
				"salience": 0.005050451,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.004534756,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0043987837,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0k0b7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota_Democratic%E2%80%93Farmer%E2%80%93Labor_Party"
				},
				"name": "Democrat",
				"salience": 0.003977958,
				"type": "PERSON"
			},
			{
				"name": "Robert Creamer",
				"salience": 0.0036218425,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05tjbz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pat_McCrory"
				},
				"name": "Pat McCrory",
				"salience": 0.0035962926,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.0031412942,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0031382283,
				"type": "PERSON"
			},
			{
				"name": "tricks",
				"salience": 0.0031219572,
				"type": "OTHER"
			},
			{
				"name": "Scott Foval",
				"salience": 0.0031112581,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0030733563,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0030733563,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0030733563,
				"type": "OTHER"
			},
			{
				"name": "Zeitgeist",
				"salience": 0.0029741249,
				"type": "LOCATION"
			},
			{
				"name": "T-shirt",
				"salience": 0.002670081,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "shirt",
				"salience": 0.002670081,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "campaign",
				"salience": 0.0026617052,
				"type": "EVENT"
			},
			{
				"name": "rallies",
				"salience": 0.0024034807,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.0024034807,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0023450474,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0023155224,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0022767393,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.002191818,
				"type": "EVENT"
			},
			{
				"name": "goal",
				"salience": 0.0021896705,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0021555652,
				"type": "OTHER"
			},
			{
				"name": "crazies",
				"salience": 0.0020814491,
				"type": "OTHER"
			},
			{
				"name": "media coverage",
				"salience": 0.0020814491,
				"type": "OTHER"
			},
			{
				"name": "fisticuffs",
				"salience": 0.0020814491,
				"type": "OTHER"
			},
			{
				"name": "headquarters",
				"salience": 0.0020814491,
				"type": "LOCATION"
			},
			{
				"name": "aversion",
				"salience": 0.0020814491,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0020814491,
				"type": "OTHER"
			},
			{
				"name": "assaults",
				"salience": 0.0020751585,
				"type": "OTHER"
			},
			{
				"name": "shirt",
				"salience": 0.0019950909,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "T-shirt",
				"salience": 0.0019950909,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "homophobes",
				"salience": 0.0019047587,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.001866716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01fmnr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Periscope"
				},
				"name": "Periscope",
				"salience": 0.001814505,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "attacks",
				"salience": 0.0018123804,
				"type": "EVENT"
			},
			{
				"name": "crowbar",
				"salience": 0.0017988832,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0017970728,
				"type": "OTHER"
			},
			{
				"name": "firebombing",
				"salience": 0.0017430526,
				"type": "EVENT"
			},
			{
				"name": "rally",
				"salience": 0.0016855439,
				"type": "EVENT"
			},
			{
				"name": "cars",
				"salience": 0.0016855439,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cars",
				"salience": 0.0016855439,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "some",
				"salience": 0.0016855439,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0016388599,
				"type": "PERSON"
			},
			{
				"name": "TV broadcast news",
				"salience": 0.0016226538,
				"type": "OTHER"
			},
			{
				"name": "compilation",
				"salience": 0.0015551336,
				"type": "WORK_OF_ART"
			},
			{
				"name": "choice",
				"salience": 0.0015551336,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0014596266,
				"type": "OTHER"
			},
			{
				"name": "paint",
				"salience": 0.0014596266,
				"type": "OTHER"
			},
			{
				"name": "van",
				"salience": 0.0014596266,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "official",
				"salience": 0.0014412403,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.0014051591,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0014051591,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.0014051591,
				"type": "LOCATION"
			},
			{
				"name": "act",
				"salience": 0.0014051591,
				"type": "EVENT"
			},
			{
				"name": "swastika",
				"salience": 0.0014051591,
				"type": "OTHER"
			},
			{
				"name": "sentence",
				"salience": 0.0014051591,
				"type": "OTHER"
			},
			{
				"name": "street",
				"salience": 0.0013761254,
				"type": "LOCATION"
			},
			{
				"name": "assailant",
				"salience": 0.0013148683,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0n3x2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orange_County,_North_Carolina"
				},
				"name": "Orange County",
				"salience": 0.0012814252,
				"type": "LOCATION"
			},
			{
				"name": "other",
				"salience": 0.001253643,
				"type": "PERSON"
			},
			{
				"name": "barmaid",
				"salience": 0.001222255,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0011916524,
				"type": "PERSON"
			},
			{
				"name": "couple",
				"salience": 0.0011916524,
				"type": "PERSON"
			},
			{
				"name": "photo",
				"salience": 0.0011916524,
				"type": "WORK_OF_ART"
			},
			{
				"name": "service",
				"salience": 0.0011916524,
				"type": "OTHER"
			},
			{
				"name": "thugs",
				"salience": 0.0011916524,
				"type": "PERSON"
			},
			{
				"name": "back",
				"salience": 0.0011916524,
				"type": "OTHER"
			},
			{
				"name": "assaults",
				"salience": 0.0011880492,
				"type": "EVENT"
			},
			{
				"name": "motorist",
				"salience": 0.0011386018,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0011386018,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.0011386018,
				"type": "EVENT"
			},
			{
				"name": "reporters",
				"salience": 0.0011378067,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0010767103,
				"type": "OTHER"
			},
			{
				"name": "news outlet",
				"salience": 0.0010365235,
				"type": "OTHER"
			},
			{
				"name": "street",
				"salience": 0.0010280552,
				"type": "LOCATION"
			},
			{
				"name": "Blue Lives Matter",
				"salience": 0.0010155148,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0010115603,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0010115603,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04ykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota"
				},
				"name": "Minnesota",
				"salience": 0.0009989613,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.0009988731,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0009576862,
				"type": "OTHER"
			},
			{
				"name": "Feras Jabro",
				"salience": 0.00093855517,
				"type": "PERSON"
			},
			{
				"name": "mob",
				"salience": 0.0009365366,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobic",
				"salience": 0.0008984853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0tr3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bangor,_Maine"
				},
				"name": "Bangor",
				"salience": 0.0008984853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/050ks",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maine"
				},
				"name": "Maine",
				"salience": 0.0008984853,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.00089421263,
				"type": "PERSON"
			},
			{
				"name": "fundraiser",
				"salience": 0.0008902186,
				"type": "EVENT"
			},
			{
				"name": "profanities",
				"salience": 0.0008902186,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.0008649472,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0008649472,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi",
				"salience": 0.0008649472,
				"type": "ORGANIZATION"
			},
			{
				"name": "motorist",
				"salience": 0.0008292799,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0008292799,
				"type": "EVENT"
			},
			{
				"name": "campaign apparel",
				"salience": 0.000784195,
				"type": "OTHER"
			},
			{
				"name": "baseball cap",
				"salience": 0.000784195,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fpzwf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minneapolis"
				},
				"name": "Minneapolis",
				"salience": 0.00075861684,
				"type": "LOCATION"
			},
			{
				"name": "times",
				"salience": 0.0007487528,
				"type": "EVENT"
			},
			{
				"name": "GotNews",
				"salience": 0.0007334891,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco",
				"salience": 0.0007334891,
				"type": "LOCATION"
			},
			{
				"name": "Lilian Kim",
				"salience": 0.0007334891,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d_v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KGO-TV"
				},
				"name": "ABC 7 Bay Area",
				"salience": 0.0007334891,
				"type": "ORGANIZATION"
			},
			{
				"name": "door",
				"salience": 0.0007175818,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.00071541144,
				"type": "EVENT"
			},
			{
				"name": "list",
				"salience": 0.00069079373,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.00064835,
				"type": "OTHER"
			},
			{
				"name": "thighs",
				"salience": 0.00064835,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.00064835,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00064835,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.00061947794,
				"type": "EVENT"
			},
			{
				"name": "debate watch event",
				"salience": 0.00061947794,
				"type": "EVENT"
			},
			{
				"name": "gauntlet",
				"salience": 0.0006085132,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00058842415,
				"type": "EVENT"
			},
			{
				"name": "police spokesman",
				"salience": 0.0005639256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.0005479141,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mw1p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minneapolis_Convention_Center"
				},
				"name": "Minneapolis Convention Center",
				"salience": 0.0005479141,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xmk3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomfield,_New_Jersey"
				},
				"name": "Bloomfield",
				"salience": 0.0005479141,
				"type": "LOCATION"
			},
			{
				"name": "injuries",
				"salience": 0.0005226041,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00048430962,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.00041269982,
				"type": "OTHER"
			},
			{
				"name": "motorist",
				"salience": 0.00036828453,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0003442255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00029805806,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0r4yw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/El_Cajon,_California"
				},
				"name": "El Cajon",
				"salience": 0.00029805806,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0w8m0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Peter,_Minnesota"
				},
				"name": "St. Peter",
				"salience": 0.00029805806,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/045hc2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gustavus_Adolphus_College"
				},
				"name": "Gustavus Adolphus College",
				"salience": 0.00029805806,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11bw1_6lwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Make_America_Great_Again"
				},
				"name": "Make America Great Again",
				"salience": 0.00029805806,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:13:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Anti-Trump Violence Sweeps the Nation Matthew Vadum, LifeZette, October 26, 2016 \nWhile the mainstream media has been working day and night promoting Hillary Clinton’s candidacy, it has largely ignored or downplayed violent attacks against supporters of Donald Trump. \nBut assaults on Trump supporters appear to be growing increasingly common as Election Day approaches and tensions intensify. Reports of Trump lawn signs and banners being stolen and defaced are everywhere on social media. \nMaking matters worse, undercover video evidence emerged showing senior Democrat operatives Robert Creamer and Scott Foval acknowledging using dirty, likely illegal tricks against the Trump campaign. Their goal was to generate negative media coverage of Trump rallies by fomenting violence at them. The media eagerly used the various fisticuffs and melees the Democrats created to attempt to discredit Trump by depicting his supporters as violent, knuckle-dragging crazies. \n{snip} \nDespite their aversion to covering stories that put Trump in a sympathetic light, members of the media had no choice but to cover the extremely newsworthy Oct. 15 weekend firebombing of Republican Party headquarters in Orange County, North Carolina. Gov. Pat McCrory called the arson “an attack on our democracy,” while one GOP official called it an act of “political terrorism.” Spray-painted on the building next door were a swastika and the sentence “Nazi Republicans get out of town or else.” \nMeanwhile, most physical attacks on Trump supporters make only local news outlet–if that. Rarely do such assaults get mentioned on the evening TV broadcast news or in The New York Times or The Washington Post. That’s because they don’t fit the leftist narrative that Republicans are violent, racist, Islamophobic homophobes. \n{snip} \nHere is a compilation of some of the attacks on Trump supporters: \nOn Oct. 15 in Bangor, Maine, vandals spray-painted about 20 parked cars outside a Trump rally. Trump supporter Paul Foster, whose van was hit with white paint, told reporters, “Why can’t they do a peaceful protest instead of painting cars, all of this, to make their statement?” \nAround Oct. 3, a couple of Trump supporters were assaulted in Zeitgeist, a San Francisco bar, after they were allegedly refused service for expressing support for Trump, GotNews reports. “The two Trump supporters were attacked, punched, and chased into the street by ‘some thugs’ that a barmaid called out from the back.” Lilian Kim of ABC 7 Bay Area tweeted a photo of the men, in which one was wearing a Trump T-shirt and the other was wearing a “Blue Lives Matter” shirt. \nOn Sept. 28 in El Cajon, California, an angry mob at a Black Lives Matter protest beat 21-year-old Trump supporter Feras Jabro for wearing a “Make America Great Again” baseball cap. The assault was broadcast live using the smartphone app Periscope. \nOn Sept. 26 at Gustavus Adolphus College in St. Peter, Minnesota, as the first presidential debate was about to get underway, a woman wearing Trump campaign apparel was assaulted while heading to a debate watch event. {snip} \nOn Aug. 19 in Minneapolis, Minnesota, Trump supporters had to run a gauntlet of angry protesters to get into a Trump fundraiser at the Minneapolis Convention Center. When they left after the event they were hit, pushed, and spit on. \n{snip} \nOn Aug. 3 in Bloomfield, New Jersey, an assailant attacked a 62-year-old man who was walking down the street wearing a pro-Trump T-shirt, local police said. “The motorist inquired why [the man] was wearing the shirt, directing profanities at him,” a police spokesman said. “The [victim] continued to walk away as [the] motorist followed him.” The motorist hit the man several times with a crowbar, causing injuries to his arms, hands, and thighs, \n{snip} \nThis is not an exhaustive list of violent attacks on Trump supporters. \nNo doubt there will be plenty more such assaults in the final two weeks, as Americans head to the polls. \nAnd Hillary Clinton’s campaign may be involved in those attacks.",
		"thread_title": "Anti-Trump Violence Sweeps the Nation",
		"title": "Anti-Trump Violence Sweeps the Nation",
		"type": "bs",
		"uuid": "49af8e955d3daa0a9328c5a3b539d6505cc78c7a"
	},
	"-KhIg_8e3E1Q1mCIcL-6": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:53:55.531+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.083393976,
				"type": "EVENT"
			},
			{
				"name": "Schools",
				"salience": 0.06825708,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections",
				"salience": 0.06825708,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.06506136,
				"type": "LOCATION"
			},
			{
				"name": "Trouble",
				"salience": 0.037613574,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.03520884,
				"type": "ORGANIZATION"
			},
			{
				"name": "claims",
				"salience": 0.03317802,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.029630879,
				"type": "EVENT"
			},
			{
				"name": "polling places",
				"salience": 0.028448522,
				"type": "LOCATION"
			},
			{
				"name": "classes",
				"salience": 0.028448522,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.027079716,
				"type": "EVENT"
			},
			{
				"name": "Classes Newsmax",
				"salience": 0.023250422,
				"type": "ORGANIZATION"
			},
			{
				"name": "Schools",
				"salience": 0.021151703,
				"type": "ORGANIZATION"
			},
			{
				"name": "threats",
				"salience": 0.019311277,
				"type": "OTHER"
			},
			{
				"name": "passions",
				"salience": 0.019311277,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.019311277,
				"type": "PERSON"
			},
			{
				"name": "Vigilante observers",
				"salience": 0.019311277,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.016884053,
				"type": "PERSON"
			},
			{
				"name": "John Reinhart",
				"salience": 0.015046703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0tpc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Falmouth,_Maine"
				},
				"name": "Falmouth",
				"salience": 0.012766309,
				"type": "LOCATION"
			},
			{
				"name": "Ed Tolan",
				"salience": 0.011678479,
				"type": "PERSON"
			},
			{
				"name": "classes",
				"salience": 0.010500625,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.010368672,
				"type": "LOCATION"
			},
			{
				"name": "fear",
				"salience": 0.010269346,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.009733293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bwl7t0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brian_P._Kemp"
				},
				"name": "Brian Kemp",
				"salience": 0.009087725,
				"type": "PERSON"
			},
			{
				"name": "schools",
				"salience": 0.00835934,
				"type": "ORGANIZATION"
			},
			{
				"name": "classes",
				"salience": 0.008257171,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.007973631,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.007973631,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.007973631,
				"type": "PERSON"
			},
			{
				"name": "school hallways",
				"salience": 0.007973631,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.007973631,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.007973631,
				"type": "OTHER"
			},
			{
				"name": "confrontations",
				"salience": 0.007973631,
				"type": "EVENT"
			},
			{
				"name": "voting process",
				"salience": 0.0072057815,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.007151995,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.006885471,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.006885471,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.006247852,
				"type": "EVENT"
			},
			{
				"name": "schools",
				"salience": 0.006247852,
				"type": "ORGANIZATION"
			},
			{
				"name": "plenty",
				"salience": 0.0058843973,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/050ks",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maine"
				},
				"name": "Maine",
				"salience": 0.005868457,
				"type": "LOCATION"
			},
			{
				"name": "concern",
				"salience": 0.0056188,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0053851833,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.0053851833,
				"type": "OTHER"
			},
			{
				"name": "parking",
				"salience": 0.0053851833,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0053503443,
				"type": "OTHER"
			},
			{
				"name": "concert",
				"salience": 0.0052740094,
				"type": "EVENT"
			},
			{
				"name": "classes",
				"salience": 0.0050394353,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.0047904477,
				"type": "LOCATION"
			},
			{
				"name": "elsewhere",
				"salience": 0.0045675454,
				"type": "LOCATION"
			},
			{
				"name": "sporting event",
				"salience": 0.0045675454,
				"type": "EVENT"
			},
			{
				"name": "gathering",
				"salience": 0.0045675454,
				"type": "EVENT"
			},
			{
				"name": "schools",
				"salience": 0.004552118,
				"type": "ORGANIZATION"
			},
			{
				"name": "voting",
				"salience": 0.0045302603,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.004391393,
				"type": "PERSON"
			},
			{
				"name": "county election officials",
				"salience": 0.00436435,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.00436435,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.003911445,
				"type": "OTHER"
			},
			{
				"name": "personalities",
				"salience": 0.0036360626,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.003456338,
				"type": "OTHER"
			},
			{
				"name": "emotion",
				"salience": 0.003412811,
				"type": "OTHER"
			},
			{
				"name": "school board",
				"salience": 0.003412811,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.00340128,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0031793134,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.002870732,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.002812238,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.002812238,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fhy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nebraska"
				},
				"name": "Nebraska",
				"salience": 0.002812238,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.002812238,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.002812238,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wisconsin",
				"salience": 0.002812238,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.0024859428,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0024859428,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0023736246,
				"type": "PERSON"
			},
			{
				"name": "polling location",
				"salience": 0.002144688,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.002144688,
				"type": "OTHER"
			},
			{
				"name": "election committee",
				"salience": 0.002144688,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_7z2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Easton,_Pennsylvania"
				},
				"name": "Easton",
				"salience": 0.0021009783,
				"type": "LOCATION"
			},
			{
				"name": "backpack bomb",
				"salience": 0.0018571609,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03b_pxn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Association_of_Secretaries_of_State"
				},
				"name": "National Association of Secretaries of State",
				"salience": 0.0014620792,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.0011430841,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:12:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Fearing Election Day Trouble, Some US Schools Cancel Classes Newsmax, October 26, 2016 \nRigged elections. Vigilante observers. Angry voters. The claims, threats and passions surrounding the presidential race have led communities around the U.S. to move polling places out of schools or cancel classes on Election Day. \nThe fear is that the ugly rhetoric of the campaign could escalate into confrontations and even violence in school hallways, endangering students. \n“If anybody can sit there and say they don’t think this is a contentious election, then they aren’t paying much attention,” said Ed Tolan, police chief in Falmouth, Maine, which decided to call off classes on Election Day and put additional officers on duty Nov. 8. \n{snip} \nSchools are popular polling places because they have plenty of parking and are usually centrally located. It’s difficult to say how many school-based polling places have been moved this year, given how decentralized the voting process is across the country. \nBut state and local officials say voting has been removed or classes have been canceled on Election Day at schools in Illinois, Maine, Nebraska, New Hampshire, Ohio, Pennsylvania, Wisconsin and elsewhere. \n“There is a concern, just like at a concert, sporting event or other public gathering, that we didn’t have 15 or 20 years ago. What if someone walks in a polling location with a backpack bomb or something?” said Georgia Secretary of State Brian Kemp, co-chairman of the National Association of Secretaries of State election committee. “If that happens at a school, then that’s certainly concerning.” \n{snip} \nEaston Superintendent John Reinhart wanted to get voting out of schools altogether but was rebuffed by county election officials. So the school board canceled classes on Election Day. \n“If you take the personalities away and cast the emotion with the election aside, one has to ask the question: ‘Are our schools the best places for that activity to take place?'” he said. “I just think we’ve reached the point where we need to look at other locations.” \n{snip}",
		"thread_title": "Fearing Election Day Trouble, Some US Schools Cancel Classes",
		"title": "Fearing Election Day Trouble, Some US Schools Cancel Classes",
		"type": "bs",
		"uuid": "d89a5d717050084c9e88d90405cc5d041fee2c64"
	},
	"-KhIg_L-fp9bF5dPxEts": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:54:00.733+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05cc9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalis"
				},
				"name": "Somali",
				"salience": 0.13164175,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04ykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota"
				},
				"name": "Minnesota",
				"salience": 0.078179754,
				"type": "LOCATION"
			},
			{
				"name": "nonprofits",
				"salience": 0.05802436,
				"type": "ORGANIZATION"
			},
			{
				"name": "Groups",
				"salience": 0.04405925,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.04405925,
				"type": "LOCATION"
			},
			{
				"name": "lobbying front",
				"salience": 0.028368168,
				"type": "OTHER"
			},
			{
				"name": "recipients",
				"salience": 0.024459943,
				"type": "PERSON"
			},
			{
				"name": "community groups",
				"salience": 0.022637686,
				"type": "ORGANIZATION"
			},
			{
				"name": "leaders",
				"salience": 0.022637686,
				"type": "PERSON"
			},
			{
				"name": "Minnesota Department of Employment and Economic Development",
				"salience": 0.017925607,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01nf4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Star_Tribune"
				},
				"name": "Star Tribune",
				"salience": 0.017514043,
				"type": "ORGANIZATION"
			},
			{
				"name": "One Voice",
				"salience": 0.017514043,
				"type": "ORGANIZATION"
			},
			{
				"name": "Capitol Mila Koumpilova",
				"salience": 0.017514043,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01l42w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Dayton"
				},
				"name": "Mark Dayton",
				"salience": 0.01724946,
				"type": "PERSON"
			},
			{
				"name": "projects",
				"salience": 0.01678345,
				"type": "OTHER"
			},
			{
				"name": "lobbyist",
				"salience": 0.01678345,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.013347536,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_v7bmh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohamud_Noor"
				},
				"name": "Mohamud Noor",
				"salience": 0.013006745,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.012540333,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.010873615,
				"type": "ORGANIZATION"
			},
			{
				"name": "coalition",
				"salience": 0.010003853,
				"type": "ORGANIZATION"
			},
			{
				"name": "half",
				"salience": 0.008533243,
				"type": "OTHER"
			},
			{
				"name": "department",
				"salience": 0.008533243,
				"type": "ORGANIZATION"
			},
			{
				"name": "community initiatives",
				"salience": 0.0076694684,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0073785344,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.007172346,
				"type": "OTHER"
			},
			{
				"name": "extremists",
				"salience": 0.0071156756,
				"type": "PERSON"
			},
			{
				"name": "projects",
				"salience": 0.006925959,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.006925959,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.006925959,
				"type": "OTHER"
			},
			{
				"name": "nonprofits",
				"salience": 0.0069050463,
				"type": "ORGANIZATION"
			},
			{
				"name": "nonprofits",
				"salience": 0.0069050463,
				"type": "ORGANIZATION"
			},
			{
				"name": "nonprofits",
				"salience": 0.0068603926,
				"type": "ORGANIZATION"
			},
			{
				"name": "initiative",
				"salience": 0.006672476,
				"type": "OTHER"
			},
			{
				"name": "community leaders",
				"salience": 0.0065609887,
				"type": "PERSON"
			},
			{
				"name": "Weli",
				"salience": 0.0064082015,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0808dgk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohamed_Ahmed_(footballer)"
				},
				"name": "Mohamed Ahmed",
				"salience": 0.006329073,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0063164295,
				"type": "ORGANIZATION"
			},
			{
				"name": "leaders",
				"salience": 0.0063164295,
				"type": "PERSON"
			},
			{
				"name": "state legislators",
				"salience": 0.0059985667,
				"type": "PERSON"
			},
			{
				"name": "lieutenant governor",
				"salience": 0.0059985667,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.005655722,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0053800736,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0053575807,
				"type": "ORGANIZATION"
			},
			{
				"name": "Study participants",
				"salience": 0.0051794644,
				"type": "PERSON"
			},
			{
				"name": "state budget",
				"salience": 0.005046368,
				"type": "OTHER"
			},
			{
				"name": "grants",
				"salience": 0.0048581837,
				"type": "OTHER"
			},
			{
				"name": "investments",
				"salience": 0.0048581837,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0046607014,
				"type": "PERSON"
			},
			{
				"name": "nonprofits",
				"salience": 0.004376651,
				"type": "ORGANIZATION"
			},
			{
				"name": "bid",
				"salience": 0.0043153,
				"type": "OTHER"
			},
			{
				"name": "package",
				"salience": 0.0042073186,
				"type": "OTHER"
			},
			{
				"name": "disparities",
				"salience": 0.0042073186,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.004050385,
				"type": "WORK_OF_ART"
			},
			{
				"name": "others",
				"salience": 0.004050385,
				"type": "PERSON"
			},
			{
				"name": "host",
				"salience": 0.004050385,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.004050385,
				"type": "OTHER"
			},
			{
				"name": "coalition member",
				"salience": 0.004050385,
				"type": "PERSON"
			},
			{
				"name": "youth leadership",
				"salience": 0.004003307,
				"type": "OTHER"
			},
			{
				"name": "community leaders",
				"salience": 0.004003307,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.00396673,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00396673,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.00396673,
				"type": "OTHER"
			},
			{
				"name": "grants",
				"salience": 0.00396673,
				"type": "OTHER"
			},
			{
				"name": "proposals",
				"salience": 0.00396673,
				"type": "OTHER"
			},
			{
				"name": "proposal",
				"salience": 0.0038187602,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0037575231,
				"type": "PERSON"
			},
			{
				"name": "Confederation of Somali Community",
				"salience": 0.0036938593,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0035527784,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.003497027,
				"type": "OTHER"
			},
			{
				"name": "total",
				"salience": 0.0034351721,
				"type": "OTHER"
			},
			{
				"name": "nonprofit",
				"salience": 0.0034351721,
				"type": "ORGANIZATION"
			},
			{
				"name": "coalition",
				"salience": 0.003282296,
				"type": "ORGANIZATION"
			},
			{
				"name": "nonprofit",
				"salience": 0.0031882375,
				"type": "ORGANIZATION"
			},
			{
				"name": "initiative",
				"salience": 0.0031598334,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0031576273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/029cr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dayton,_Ohio"
				},
				"name": "Dayton",
				"salience": 0.002991229,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.0029637183,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.0027817073,
				"type": "OTHER"
			},
			{
				"name": "nonprofit",
				"salience": 0.0027732975,
				"type": "ORGANIZATION"
			},
			{
				"name": "Warfa",
				"salience": 0.0026926382,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/016q3x"
				},
				"name": "Pretenders",
				"salience": 0.0025902907,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0025879014,
				"type": "OTHER"
			},
			{
				"name": "stone",
				"salience": 0.0025664647,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.0025664647,
				"type": "OTHER"
			},
			{
				"name": "mistrust",
				"salience": 0.0025664647,
				"type": "OTHER"
			},
			{
				"name": "cartoons",
				"salience": 0.0025664647,
				"type": "OTHER"
			},
			{
				"name": "Minneapolis Foundation",
				"salience": 0.0024936274,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/065y4w7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Southern_California"
				},
				"name": "University of Southern California",
				"salience": 0.0024936274,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0024936274,
				"type": "LOCATION"
			},
			{
				"name": "accountable",
				"salience": 0.002481772,
				"type": "OTHER"
			},
			{
				"name": "Youthprise",
				"salience": 0.0024421015,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0024395653,
				"type": "OTHER"
			},
			{
				"name": "nonprofits",
				"salience": 0.0023819318,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.002234583,
				"type": "ORGANIZATION"
			},
			{
				"name": "Accountability",
				"salience": 0.002158717,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.002158717,
				"type": "PERSON"
			},
			{
				"name": "care",
				"salience": 0.002095266,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0019916513,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0019333328,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0018950155,
				"type": "LOCATION"
			},
			{
				"name": "each other",
				"salience": 0.0018693043,
				"type": "PERSON"
			},
			{
				"name": "monitoring effectiveness",
				"salience": 0.0018693043,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0016203567,
				"type": "PERSON"
			},
			{
				"name": "services",
				"salience": 0.0016126512,
				"type": "OTHER"
			},
			{
				"name": "Average Mohamed",
				"salience": 0.0014716344,
				"type": "PERSON"
			},
			{
				"name": "investments",
				"salience": 0.0014570751,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0013964173,
				"type": "OTHER"
			},
			{
				"name": "homeownership",
				"salience": 0.0013964173,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0013964173,
				"type": "OTHER"
			},
			{
				"name": "state agencies",
				"salience": 0.0013964173,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.0013964173,
				"type": "OTHER"
			},
			{
				"name": "entrepreneurship",
				"salience": 0.0013964173,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.0013964173,
				"type": "OTHER"
			},
			{
				"name": "mental health services",
				"salience": 0.001235614,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:12:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Minnesota Somali Groups Join to Speak with One Voice at Capitol Mila Koumpilova, Star Tribune, October 25, 2016 \nMinnesota’s largest Somali nonprofits are teaming up to present a unified lobbying front to the state this winter. \nIn recent months, the leaders of eight Somali community groups joined forces on several projects, hired a lobbyist and scored face time with the state’s lieutenant governor. Now, the new coalition is gearing up to ask state legislators for about $11 million for Somali community initiatives, building on $2 million Gov. Mark Dayton earmarked for such projects in this year’s budget. \n“Why not combine our separate efforts and do a better collaborative effort?” said Mohamud Noor, head of the Confederation of Somali Community, a coalition member. \nSpearheaded by the Minneapolis Foundation, the initiative is also a bid to nudge Somali-American nonprofits to better track and report results. \nA University of Southern California study last year found Somali-Americans celebrate the work of some leaders of 35 registered nonprofits and a host of more informal groups. But they distrust others. Study participants perceived some self-styled community leaders–dubbed “the Pretenders”–as adept at applying for grants but with little to show for it. \n{snip} \nThis year’s state budget includes $2 million for investments in the Somali community–part of Dayton’s package of $35 million for addressing racial disparities in Minnesota. The Minnesota Department of Employment and Economic Development, and the nonprofit Youthprise each received roughly half of the money, which they will distribute in grants. The department is now weighing 30 proposals worth a total of $6.7 million for its half. \n“The $2 million wasn’t even close to being sufficient,” Warfa said. “We are asking for more money.” \nWeli says the group also wants to push the state to entrust Somali-led nonprofits with funds directly, rather than steering resources to state agencies. \n“The system is not structured so that people of color serve themselves,” she said. “They are always the recipients of services.” \n{snip} \nThe group is calling for investments to encourage entrepreneurship and homeownership, expand mental health services, provide culturally sensitive prenatal care and spur youth leadership. \nA more specific proposal is still a work in progress, leaders acknowledge. \n{snip} \nMohamed Ahmed, a creator of cartoons lampooning extremists, who is not part of the coalition, says many in the community feel acute mistrust of local nonprofits and community leaders. \n“You can literally throw a stone and hit a nonprofit in the community; there are so many of them, God help us,” said Ahmed, whose Average Mohamed initiative recently became a nonprofit as well. “Accountability and monitoring effectiveness are big issues.” \nAhmed says Warfa is well-respected, and a group of nonprofits that will hold each other accountable is a promising step. \n{snip}",
		"thread_title": "Minnesota Somali Groups Join to Speak with One Voice at Capitol",
		"title": "Minnesota Somali Groups Join to Speak with One Voice at Capitol",
		"type": "bs",
		"uuid": "9759e022e106d44b52f25e559792c63197d504b0"
	},
	"-KhIg_YUPhIm5_YkvETj": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:54:06.385+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03v8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Criminal_Court"
				},
				"name": "International Criminal Court",
				"salience": 0.59354055,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.12670252,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hdx8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Gambia"
				},
				"name": "Gambia",
				"salience": 0.05038909,
				"type": "LOCATION"
			},
			{
				"name": "withdrawal",
				"salience": 0.028270148,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0169t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Burundi"
				},
				"name": "Burundi",
				"salience": 0.028076319,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.014892705,
				"type": "LOCATION"
			},
			{
				"name": "Sheriff Bojang",
				"salience": 0.014257541,
				"type": "PERSON"
			},
			{
				"name": "tribunal",
				"salience": 0.013189372,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0948xk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tony_Blair"
				},
				"name": "Tony Blair",
				"salience": 0.008572444,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07g0_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hague"
				},
				"name": "Hague",
				"salience": 0.008159197,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02dlk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agence_France-Presse"
				},
				"name": "AFP",
				"salience": 0.008159197,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0121zh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jewish_exodus_from_Arab_and_Muslim_countries"
				},
				"name": "Exodus",
				"salience": 0.008159197,
				"type": "WORK_OF_ART"
			},
			{
				"name": "persecution",
				"salience": 0.0069870483,
				"type": "OTHER"
			},
			{
				"name": "humiliation",
				"salience": 0.0063127303,
				"type": "OTHER"
			},
			{
				"name": "colour",
				"salience": 0.0063127303,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.003274016,
				"type": "EVENT"
			},
			{
				"name": "decisions",
				"salience": 0.0032328798,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02307h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omar_al-Bashir"
				},
				"name": "Omar al-Bashir",
				"salience": 0.002989722,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.0029486974,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.0029486974,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.002800474,
				"type": "LOCATION"
			},
			{
				"name": "institution",
				"salience": 0.002800474,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.002512013,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0024854974,
				"type": "LOCATION"
			},
			{
				"name": "persecution",
				"salience": 0.002418436,
				"type": "OTHER"
			},
			{
				"name": "withdrawal",
				"salience": 0.002268556,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.002268556,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.002268556,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.002258442,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.0021840276,
				"type": "EVENT"
			},
			{
				"name": "persecution",
				"salience": 0.0020515036,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0018916322,
				"type": "PERSON"
			},
			{
				"name": "state television",
				"salience": 0.0018916322,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0018525918,
				"type": "OTHER"
			},
			{
				"name": "humiliation",
				"salience": 0.0018525918,
				"type": "OTHER"
			},
			{
				"name": "colour",
				"salience": 0.0018525918,
				"type": "OTHER"
			},
			{
				"name": "International Caucasian Court",
				"salience": 0.0017946371,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0015893053,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0015331329,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.0013622156,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0012100578,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0012100578,
				"type": "LOCATION"
			},
			{
				"name": "shores",
				"salience": 0.0011989328,
				"type": "LOCATION"
			},
			{
				"name": "deaths",
				"salience": 0.0011989328,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.0011989328,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0011989328,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hqjh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Africa"
				},
				"name": "West",
				"salience": 0.0011649223,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0011542117,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0011169183,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.00087336445,
				"type": "OTHER"
			},
			{
				"name": "arrest warrant",
				"salience": 0.00087336445,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.000851502,
				"type": "OTHER"
			},
			{
				"name": "dispute",
				"salience": 0.0007992084,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05bmq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Namibia"
				},
				"name": "Namibia",
				"salience": 0.00074755057,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.0007381336,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06tw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sudan"
				},
				"name": "Sudanese",
				"salience": 0.0007381336,
				"type": "LOCATION"
			},
			{
				"name": "success",
				"salience": 0.0006524822,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.0006524822,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0006524822,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0006524822,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.0006524822,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0006151505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019rg5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kenya"
				},
				"name": "Kenya",
				"salience": 0.00053762476,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:12:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Gambia Joins South Africa and Burundi in Exodus from International Criminal Court AFP, October 26, 2016 \nGambia has announced its withdrawal from the International Criminal Court (ICC), accusing the Hague-based tribunal of the “persecution and humiliation of people of colour, especially Africans”. \nThe announcement late Tuesday comes after similar decisions this month by South Africa and Burundi to abandon the troubled institution, set up to try the world’s worst crimes. \nInformation Minister Sheriff Bojang said in an announcement on state television that the court had been used “for the persecution of Africans and especially their leaders” while ignoring crimes committed by the West. \nHe singled out the case of former British prime minister Tony Blair, who the ICC decided not to indict over the Iraq war. \n{snip} \nThe withdrawal, he said, “is warranted by the fact that the ICC, despite being called International Criminal Court, is in fact an International Caucasian Court for the persecution and humiliation of people of colour, especially Africans”. \nThe ICC, set up in 2002, is often accused of bias against Africa and has also struggled with a lack of cooperation, including from the United States, which has signed the court’s treaty but never ratified it. \nGambia has been trying without success to use the court to punish the European Union for deaths of thousands of African migrants trying to reach its shores. \n{snip} \nSouth Africa’s decision followed a dispute last year when Sudanese President Omar al-Bashir visited the country despite being the subject of an ICC arrest warrant over alleged war crimes. \nEarlier this month, Burundi said it would leave the court, while Namibia and Kenya have also raised the possibility. \n{snip}",
		"thread_title": "Gambia Joins South Africa and Burundi in Exodus from International Criminal Court",
		"title": "Gambia Joins South Africa and Burundi in Exodus from International Criminal Court",
		"type": "bs",
		"uuid": "6b752b1e96365b90a5dfd88d010ec81dd1c91e8c"
	},
	"-KhIg_dqyNhsnYmnpS6T": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:54:11.735+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "comment",
				"salience": 0.20421392,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0hdx8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Gambia"
				},
				"name": "Gambia",
				"salience": 0.12442984,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0169t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Burundi"
				},
				"name": "Burundi",
				"salience": 0.12442984,
				"type": "LOCATION"
			},
			{
				"name": "E",
				"salience": 0.12442984,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.0938505,
				"type": "LOCATION"
			},
			{
				"name": "comments",
				"salience": 0.086528994,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.043571252,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.043571252,
				"type": "OTHER"
			},
			{
				"name": "social media account",
				"salience": 0.030667108,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.029532261,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.02808362,
				"type": "OTHER"
			},
			{
				"name": "Commentary",
				"salience": 0.018922968,
				"type": "WORK_OF_ART"
			},
			{
				"name": "e-mail address",
				"salience": 0.018767009,
				"type": "OTHER"
			},
			{
				"name": "convenience",
				"salience": 0.018767009,
				"type": "OTHER"
			},
			{
				"name": "guest",
				"salience": 0.010234591,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:12:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.3,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Gambia Joins South Africa and Burundi in E... We welcome comments that add information or perspective, and we encourage polite debate. If you log in with a social media account, your comment should appear immediately. If you prefer to remain anonymous, you may comment as a guest, using a name and an e-mail address of convenience. Your comment will be moderated. Commentary",
		"thread_title": "Paris at War: Media Silence",
		"title": "Paris at War: Media Silence",
		"type": "bs",
		"uuid": "80c6f7b264b6ce2964152b89aeb1b4510100418d"
	},
	"-KhIg_p809ToFNXADX8G": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:46.179+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.16696239,
				"type": "PERSON"
			},
			{
				"name": "plutocrats",
				"salience": 0.1419573,
				"type": "PERSON"
			},
			{
				"name": "Women And Minorities Hardest Hit Ann Coulter",
				"salience": 0.09069132,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.045457035,
				"type": "PERSON"
			},
			{
				"name": "Country",
				"salience": 0.03344899,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.03111955,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.030667404,
				"type": "PERSON"
			},
			{
				"name": "whites bloc-votes",
				"salience": 0.026215142,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.023068635,
				"type": "LOCATION"
			},
			{
				"name": "working class",
				"salience": 0.01792627,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.017172892,
				"type": "PERSON"
			},
			{
				"name": "conquistadors",
				"salience": 0.0170035,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.014881214,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02yp0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/VDARE"
				},
				"name": "VDARE",
				"salience": 0.0140277,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.011646459,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.008366756,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.007605818,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.007375399,
				"type": "PERSON"
			},
			{
				"name": "Shana Maier",
				"salience": 0.0073100924,
				"type": "PERSON"
			},
			{
				"name": "settlers",
				"salience": 0.0072472524,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00709063,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0065766876,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.006529611,
				"type": "PERSON"
			},
			{
				"name": "irony",
				"salience": 0.006187702,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.005303136,
				"type": "PERSON"
			},
			{
				"name": "child rape",
				"salience": 0.004974275,
				"type": "EVENT"
			},
			{
				"name": "rape",
				"salience": 0.004974275,
				"type": "EVENT"
			},
			{
				"name": "class",
				"salience": 0.004974275,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.0048033274,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.0048033274,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0048033274,
				"type": "EVENT"
			},
			{
				"name": "Third World country",
				"salience": 0.004788818,
				"type": "LOCATION"
			},
			{
				"name": "class",
				"salience": 0.004788818,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.004772253,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.004498075,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0044889622,
				"type": "PERSON"
			},
			{
				"name": "male",
				"salience": 0.0043404377,
				"type": "PERSON"
			},
			{
				"name": "incest",
				"salience": 0.0043080156,
				"type": "EVENT"
			},
			{
				"name": "Latino culture",
				"salience": 0.0043080156,
				"type": "OTHER"
			},
			{
				"name": "acceptance",
				"salience": 0.00423185,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.004167254,
				"type": "LOCATION"
			},
			{
				"name": "working class",
				"salience": 0.004147363,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.004147363,
				"type": "PERSON"
			},
			{
				"name": "child rape",
				"salience": 0.004061724,
				"type": "EVENT"
			},
			{
				"name": "servants",
				"salience": 0.0040227454,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0038150665,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0038108488,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.003775815,
				"type": "OTHER"
			},
			{
				"name": "victim",
				"salience": 0.0037449896,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0033839701,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0033688657,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0033688657,
				"type": "PERSON"
			},
			{
				"name": "return",
				"salience": 0.0033688657,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0033688657,
				"type": "WORK_OF_ART"
			},
			{
				"name": "descendants",
				"salience": 0.0033688657,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0033325076,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0032431958,
				"type": "OTHER"
			},
			{
				"name": "elderly",
				"salience": 0.0032431958,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0032431958,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0032431958,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0031762065,
				"type": "PERSON"
			},
			{
				"name": "perpetrator",
				"salience": 0.0031762065,
				"type": "PERSON"
			},
			{
				"name": "victim",
				"salience": 0.0031762065,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0031762065,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0031762065,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06nm1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spanish_language"
				},
				"name": "Spanish",
				"salience": 0.0031534566,
				"type": "LOCATION"
			},
			{
				"name": "cultures",
				"salience": 0.0030788174,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.002957699,
				"type": "PERSON"
			},
			{
				"name": "household",
				"salience": 0.0027505513,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0027505513,
				"type": "PERSON"
			},
			{
				"name": "Latinos",
				"salience": 0.0027505513,
				"type": "PERSON"
			},
			{
				"name": "Hispanics",
				"salience": 0.0027505513,
				"type": "PERSON"
			},
			{
				"name": "purpose",
				"salience": 0.0026479254,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0026307823,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0026281346,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.0026281346,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.002573838,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.0024650146,
				"type": "OTHER"
			},
			{
				"name": "detective",
				"salience": 0.0023925754,
				"type": "PERSON"
			},
			{
				"name": "immigration policies",
				"salience": 0.0023730334,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0020740156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016cb8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jorge_Ramos_(news_anchor)"
				},
				"name": "Jorge Ramos",
				"salience": 0.0020740156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0020740156,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0020721024,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0020549374,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02p10m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Univision"
				},
				"name": "Univision",
				"salience": 0.0019966145,
				"type": "ORGANIZATION"
			},
			{
				"name": "perpetrator",
				"salience": 0.0019373687,
				"type": "PERSON"
			},
			{
				"name": "rich",
				"salience": 0.0019142977,
				"type": "PERSON"
			},
			{
				"name": "dishonor",
				"salience": 0.0017874371,
				"type": "OTHER"
			},
			{
				"name": "headline",
				"salience": 0.0017284438,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001651491,
				"type": "LOCATION"
			},
			{
				"name": "rape",
				"salience": 0.001651491,
				"type": "EVENT"
			},
			{
				"name": "Immigrant",
				"salience": 0.001651491,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.001651491,
				"type": "PERSON"
			},
			{
				"name": "child rape",
				"salience": 0.001651491,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0015479756,
				"type": "OTHER"
			},
			{
				"name": "parody",
				"salience": 0.0015158069,
				"type": "WORK_OF_ART"
			},
			{
				"name": "plan",
				"salience": 0.0014967076,
				"type": "OTHER"
			},
			{
				"name": "labor",
				"salience": 0.0014967076,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0014967076,
				"type": "OTHER"
			},
			{
				"name": "incest",
				"salience": 0.0014300668,
				"type": "OTHER"
			},
			{
				"name": "incest",
				"salience": 0.0014300668,
				"type": "EVENT"
			},
			{
				"name": "mind",
				"salience": 0.0014110609,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.0012912044,
				"type": "EVENT"
			},
			{
				"name": "murder",
				"salience": 0.0012912044,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0bsfy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Mugabe"
				},
				"name": "Mugabe",
				"salience": 0.0011428526,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/088q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zimbabwe"
				},
				"name": "Zimbabwe",
				"salience": 0.0011428526,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.001118067,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.001118067,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04p381",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_Sobran"
				},
				"name": "Joe Sobran",
				"salience": 0.0009212052,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0009212052,
				"type": "ORGANIZATION"
			},
			{
				"name": "Women and Minorities Hit Hardest",
				"salience": 0.0009212052,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:31:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Our New Country: Women And Minorities Hardest Hit Ann Coulter, VDARE, October 26, 2016 \nEvery ethnic group except whites bloc-votes for the Democrats. Coincidentally, the Democrats have brought in another 30 to 40 million nonwhite immigrants in the last few decades. \nIt doesn’t help that white voters can’t agree on what constitutes an acceptable candidate. In 2012, working-class whites sat out the election, rather than vote for the out-of-touch rich guy they saw in Mitt Romney. This year, the out-of-touch rich guys say they’ll vote for Hillary because Trump is tacky and gross. \nThe sad irony is that the only people who will be better off in our new country are mostly white plutocrats–the top .01 percent. The rest of us will be their servants. \nThe people who will be worse off are everybody else–the working class, the middle class (who will soon be working class) and, most of all, women, minorities, children, the elderly, the weakest and most vulnerable members of society. \nLook to Mexico for your future–or any Third World country. Or to Univision’s Jorge Ramos. The ruling class in Mexico is composed of European-looking, white descendants of Spanish conquistadors who raped the native population, giving them only their Spanish names in return. (British settlers in America brought women with them.) \nExplaining Latino culture’s acceptance of incest and child rape, criminal justice researcher Shana Maier writes in a book about rape that “the male is the head of the household, and women are subordinate to men. . . . Hispanics and Latinos are more likely than other racial/ethnic groups to blame the victim. The victim, not the perpetrator, is blamed for bringing dishonor to the family.” \nOne American detective said that, today, police are being taught to keep an “open mind” about child rape because “it’s a cultural thing.” \n{snip} \n, our media already have a totally “open mind” about incest and child rape–and murder!–when it’s committed by immigrants. \n{snip} \nImmigrant women arrive in America, thrilled to have escaped cultures where rape, incest and spousal murder are acceptable, only to discover that those crimes are perfectly acceptable in this country, too–provided the perpetrator is from the very culture they fled. \n{snip} \nPerhaps American men could do better, but, as American women may soon discover: They never had it so good. \nManifestly, the purpose of our immigration policies is not to help Americans–or the immigrants who wanted to live in a place like America. They are designed to funnel welfare-dependent voters to the Democrats and cheap labor to the rich. {snip} \nOur country will be Zimbabwe, but–if all goes according to the Democrats’ plan–they’ll get to be Mugabe! \nThat’s Hillary’s dream. If she wins, Joe Sobran’s parody of the typical New York Times headline (about anything) will come true: “Women and Minorities Hit Hardest.”",
		"thread_title": "Our New Country: Women And Minorities Hardest Hit",
		"title": "Our New Country: Women And Minorities Hardest Hit",
		"type": "bs",
		"uuid": "9d697f3e090803b7c77ed4e0413870bba40be15f"
	},
	"-KhIga-NPx4-tK_Izjdq": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:46.837+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.46144792,
				"type": "PERSON"
			},
			{
				"name": "champion",
				"salience": 0.09308477,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.080617845,
				"type": "LOCATION"
			},
			{
				"name": "deal",
				"salience": 0.034953743,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.027940145,
				"type": "PERSON"
			},
			{
				"name": "afternoon address",
				"salience": 0.027432887,
				"type": "EVENT"
			},
			{
				"name": "New Deal for Black America",
				"salience": 0.024971938,
				"type": "ORGANIZATION"
			},
			{
				"name": "Trump Promises",
				"salience": 0.019576725,
				"type": "OTHER"
			},
			{
				"name": "Ben Kamisar",
				"salience": 0.016973669,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ttk_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hill_(newspaper)"
				},
				"name": "The Hill",
				"salience": 0.016973669,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-Americans",
				"salience": 0.013561418,
				"type": "PERSON"
			},
			{
				"name": "gap",
				"salience": 0.011381959,
				"type": "OTHER"
			},
			{
				"name": "voting bloc",
				"salience": 0.011381959,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.00873816,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.007019916,
				"type": "EVENT"
			},
			{
				"name": "rule",
				"salience": 0.0058270143,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0058270143,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.00503217,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.0048811357,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0047203326,
				"type": "LOCATION"
			},
			{
				"name": "promises",
				"salience": 0.004544463,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.004544463,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0040884735,
				"type": "LOCATION"
			},
			{
				"name": "education",
				"salience": 0.003936098,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.003936098,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0038548682,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0038548682,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0035898904,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "N.C.",
				"salience": 0.0035898904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fsb8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charlotte,_North_Carolina"
				},
				"name": "Charlotte",
				"salience": 0.0035898904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.0035898904,
				"type": "ORGANIZATION"
			},
			{
				"name": "rights",
				"salience": 0.0033386592,
				"type": "OTHER"
			},
			{
				"name": "picket lines",
				"salience": 0.0033386592,
				"type": "OTHER"
			},
			{
				"name": "pews",
				"salience": 0.0033386592,
				"type": "OTHER"
			},
			{
				"name": "Revolution",
				"salience": 0.0033386592,
				"type": "EVENT"
			},
			{
				"name": "conscience",
				"salience": 0.0033386592,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0031901768,
				"type": "LOCATION"
			},
			{
				"name": "infrastructure",
				"salience": 0.0030169324,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0028807255,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.0028807255,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0028807255,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.0026918445,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0024947966,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0024947966,
				"type": "OTHER"
			},
			{
				"name": "murder rate",
				"salience": 0.0024947966,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0024947966,
				"type": "EVENT"
			},
			{
				"name": "lack",
				"salience": 0.0024947966,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0023241441,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.002098608,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.002098608,
				"type": "EVENT"
			},
			{
				"name": "gang members",
				"salience": 0.0018173604,
				"type": "PERSON"
			},
			{
				"name": "cartels",
				"salience": 0.0018173604,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.0018173604,
				"type": "OTHER"
			},
			{
				"name": "police brutality",
				"salience": 0.0018173604,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0015679204,
				"type": "OTHER"
			},
			{
				"name": "disaster areas",
				"salience": 0.0015679204,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.001510466,
				"type": "LOCATION"
			},
			{
				"name": "access",
				"salience": 0.0014837421,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0013577436,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0013577436,
				"type": "LOCATION"
			},
			{
				"name": "employment",
				"salience": 0.0013577436,
				"type": "OTHER"
			},
			{
				"name": "incentives",
				"salience": 0.0013577436,
				"type": "OTHER"
			},
			{
				"name": "credit",
				"salience": 0.0013577436,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0011187427,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:30:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Trump Promises ‘New Deal for Black America’ Ben Kamisar, The Hill, October 26, 2016 \nDonald Trump called for a “new deal for black America” in a Wednesday afternoon address as he works to bridge the gap he faces with the crucial voting bloc less than two weeks from Election Day. \nSpeaking in Charlotte, N.C., the GOP presidential nominee criticized years of Democratic rule for leaving black America behind and outlined his plan to help. \nMy “deal is grounded in three promises: safe communities, great education and high-paying jobs,” Trump said, speaking off what appeared to be scripted remarks \n“Whether you vote for me or not, I will be your greatest champion. We live in a very divided country, and I will be your greatest champion.” \n{snip} \n“African-American citizens have sacrificed so much for our nation. They fought and died in every war since the Revolution and from the pews and the picket lines, they’ve lifted up the conscience of our country in the long march for civil rights. Yet too many African-Americans have been left behind.” \nTrump called for incentives to move companies into blighted neighborhoods to bolster employment, help African-Americans get better access to credit and push cities to declare “blighted communities” disaster areas to help rebuild infrastructure. \nHe also said he’d support increasing the number of police officers in such areas, connecting a lack of officers to a rise in murder rate in major cities. \nBut while Trump’s call focused on removing “gang members and criminal cartels,” he blamed Clinton for promoting a “war on police.” He did not mention the accusations of police brutality by minorities who feel that they are disproportionately targeted. \n{snip}",
		"thread_title": "Trump Promises ‘New Deal for Black America’",
		"title": "Trump Promises ‘New Deal for Black America’",
		"type": "bs",
		"uuid": "0403ce62d96b68226e7ec480b1c22258573c2ade"
	},
	"-KhIgaEZSsP1gfgAO18r": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:47.206+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.09148178,
				"type": "LOCATION"
			},
			{
				"name": "law",
				"salience": 0.06022208,
				"type": "OTHER"
			},
			{
				"name": "Schools",
				"salience": 0.049282406,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.047654305,
				"type": "LOCATION"
			},
			{
				"name": "Lawyers",
				"salience": 0.036305886,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.030857312,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawsuit",
				"salience": 0.027347513,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.02535912,
				"type": "LOCATION"
			},
			{
				"name": "burden",
				"salience": 0.021097794,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.020818692,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.019860525,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.01830354,
				"type": "ORGANIZATION"
			},
			{
				"name": "plaintiffs",
				"salience": 0.017636053,
				"type": "PERSON"
			},
			{
				"name": "San Antonio Independent School District v. Rodriguez",
				"salience": 0.01683637,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.016083688,
				"type": "OTHER"
			},
			{
				"name": "teachers",
				"salience": 0.015193254,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.014723539,
				"type": "OTHER"
			},
			{
				"name": "third graders",
				"salience": 0.014723539,
				"type": "PERSON"
			},
			{
				"name": "assessment test",
				"salience": 0.012756789,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.010485399,
				"type": "ORGANIZATION"
			},
			{
				"name": "plaintiffs",
				"salience": 0.0090843635,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.008600432,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.008600432,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.008257679,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.007862779,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.007862779,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0077670743,
				"type": "OTHER"
			},
			{
				"name": "litigation",
				"salience": 0.0073911105,
				"type": "OTHER"
			},
			{
				"name": "plaintiffs",
				"salience": 0.0072811395,
				"type": "PERSON"
			},
			{
				"name": "schools",
				"salience": 0.0070838225,
				"type": "ORGANIZATION"
			},
			{
				"name": "levels",
				"salience": 0.006987878,
				"type": "OTHER"
			},
			{
				"name": "Geoffrey R. Stone",
				"salience": 0.0068409173,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.006778085,
				"type": "OTHER"
			},
			{
				"name": "Illiteracy",
				"salience": 0.006778085,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.00658868,
				"type": "ORGANIZATION"
			},
			{
				"name": "books",
				"salience": 0.0065254983,
				"type": "WORK_OF_ART"
			},
			{
				"name": "education",
				"salience": 0.0062913923,
				"type": "OTHER"
			},
			{
				"name": "teachers",
				"salience": 0.0060752514,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.0060569057,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0060569057,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.006034101,
				"type": "PERSON"
			},
			{
				"name": "schools",
				"salience": 0.0060088835,
				"type": "ORGANIZATION"
			},
			{
				"name": "litigation",
				"salience": 0.005702541,
				"type": "OTHER"
			},
			{
				"name": "norm",
				"salience": 0.005605668,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "school districts",
				"salience": 0.005448966,
				"type": "LOCATION"
			},
			{
				"name": "facilities",
				"salience": 0.0052617164,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.0052617164,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0052617164,
				"type": "LOCATION"
			},
			{
				"name": "toilet paper",
				"salience": 0.0052617164,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "school supplies",
				"salience": 0.0052617164,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "rodent feces",
				"salience": 0.0052617164,
				"type": "OTHER"
			},
			{
				"name": "courts",
				"salience": 0.0052458234,
				"type": "LOCATION"
			},
			{
				"name": "education",
				"salience": 0.0051375325,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0051375325,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0051375325,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0048521324,
				"type": "LOCATION"
			},
			{
				"name": "skills",
				"salience": 0.00477599,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.004699435,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0045713377,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0044970163,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.004490399,
				"type": "ORGANIZATION"
			},
			{
				"name": "district",
				"salience": 0.004449383,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.004449383,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0044295285,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.004313003,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.004261363,
				"type": "OTHER"
			},
			{
				"name": "disparities",
				"salience": 0.004136201,
				"type": "OTHER"
			},
			{
				"name": "school district",
				"salience": 0.0041237026,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.0041134637,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.004102435,
				"type": "OTHER"
			},
			{
				"name": "state constitutions",
				"salience": 0.004102435,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0040536146,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0038532906,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0038389652,
				"type": "OTHER"
			},
			{
				"name": "plaintiffs",
				"salience": 0.0037686927,
				"type": "PERSON"
			},
			{
				"name": "chapter",
				"salience": 0.0037374895,
				"type": "ORGANIZATION"
			},
			{
				"name": "property tax revenues",
				"salience": 0.003690429,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.003690429,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.003690429,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.003690429,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.0035527695,
				"type": "OTHER"
			},
			{
				"name": "clients",
				"salience": 0.0035527695,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0035114733,
				"type": "PERSON"
			},
			{
				"name": "school",
				"salience": 0.0034852342,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.0034793888,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0034379743,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0033346408,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.003324562,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.003324562,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0032712475,
				"type": "ORGANIZATION"
			},
			{
				"name": "schools",
				"salience": 0.0032712475,
				"type": "ORGANIZATION"
			},
			{
				"name": "saga",
				"salience": 0.0030131193,
				"type": "WORK_OF_ART"
			},
			{
				"name": "money",
				"salience": 0.0030131193,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.002879021,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.002830867,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.002796516,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0025578777,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "United States Constitution",
				"salience": 0.0025258053,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.002272021,
				"type": "LOCATION"
			},
			{
				"name": "state disinvestment",
				"salience": 0.002251122,
				"type": "OTHER"
			},
			{
				"name": "indifference",
				"salience": 0.002251122,
				"type": "OTHER"
			},
			{
				"name": "Amendment",
				"salience": 0.002251122,
				"type": "WORK_OF_ART"
			},
			{
				"name": "snip",
				"salience": 0.002097059,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0020892585,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.002003703,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.00195809,
				"type": "OTHER"
			},
			{
				"name": "literacy",
				"salience": 0.00195809,
				"type": "OTHER"
			},
			{
				"name": "proficiency",
				"salience": 0.0018934659,
				"type": "OTHER"
			},
			{
				"name": "sixth graders",
				"salience": 0.0018934659,
				"type": "PERSON"
			},
			{
				"name": "minority",
				"salience": 0.0018934659,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.0018612604,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0018091678,
				"type": "OTHER"
			},
			{
				"name": "subject areas",
				"salience": 0.0016396095,
				"type": "LOCATION"
			},
			{
				"name": "building block",
				"salience": 0.0016396095,
				"type": "OTHER"
			},
			{
				"name": "reading",
				"salience": 0.0016396095,
				"type": "OTHER"
			},
			{
				"name": "student proficiency rates",
				"salience": 0.0016396095,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0016396095,
				"type": "OTHER"
			},
			{
				"name": "skills",
				"salience": 0.0015854909,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0015666074,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0014627737,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0014144891,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.001154727,
				"type": "OTHER"
			},
			{
				"name": "district judge",
				"salience": 0.00089202065,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ct1rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Antonio_Independent_School_District_v._Rodriguez"
				},
				"name": "Rodriguez",
				"salience": 0.00087058236,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:30:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Are Detroit’s Most Terrible Schools Unconstitutional? Geoffrey R. Stone, New York Times, October 21, 2016 \nAt one Detroit school, just 4 percent of third graders scored proficient on Michigan’s English assessment test. At another, 9.5 percent did. Those students are among the plaintiffs in a lawsuit filed last month that asserts that children have a federal constitutional right to the opportunity to learn to read and write. \nIlliteracy is the norm at those “slumlike” schools and others in Michigan’s biggest city, according to the plaintiffs. The facilities are decrepit and unsafe. The first thing some teachers do each morning is clean up rodent feces before their students arrive. In some cases, teachers buy the books and school supplies, even the toilet paper. \nLawyers for the students are arguing, in effect, that Michigan is denying their clients the right to a minimally adequate education, an issue that has been raised over the years in courts in other states under their state constitutions. \n{snip} \nNow the litigation in Detroit is raising this issue under the United States Constitution. The Supreme Court has never addressed whether disparities among schools would be constitutionally permissible if, as the court put it in 1973, a state failed “to provide each child with an opportunity to acquire the basic minimal skills necessary” for success in life. \nIn that bitterly divided 5-4 decision, San Antonio Independent School District v. Rodriguez, the court upheld a Texas law that produced unequal levels of education to students living in different school districts based on the property tax revenues of each district. \nThe majority maintained that the law was constitutional because it served a rational policy of permitting each school district to decide for itself how much money to spend on education. Whether the level of education was at least minimally adequate in the state’s poorest schools was not at issue in the case. \nIn what is likely to be the opening chapter in a long legal saga, a federal district judge in Michigan must determine if a state can constitutionally provide a vast majority of its students with an excellent or at least adequate education while a minority of students receive an education that denies them the chance to acquire the minimum skills the court spoke of 43 years ago in Rodriguez. \n{snip} \nBut in the case of children who are attending a public school, how do we know whether a state has denied some of its children even the minimal level of education required by the 14th Amendment? That is the burden that the plaintiffs in the Detroit case must meet. After reviewing their evidence, the case seems to be open-and-shut. \nAs the plaintiffs demonstrate, “decades of state disinvestment in and deliberate indifference to the Detroit schools” have denied these children “access to the most basic building block of education: literacy.” At the schools involved in this litigation, which serve almost exclusively low-income minority children, the student proficiency rates “hover near zero in nearly all core subject areas.” At one school, for example, 100 percent of the sixth graders scored below proficiency in reading. \n{snip}",
		"thread_title": "Are Detroit’s Most Terrible Schools Unconstitutional?",
		"title": "Are Detroit’s Most Terrible Schools Unconstitutional?",
		"type": "bs",
		"uuid": "7e733a613bc0798a2c15d843a926ba30eedba85f"
	},
	"-KhIgaNrEqP1a7ttaXOk": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:47.555+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Blue Cat Cafe",
				"salience": 0.21296462,
				"type": "LOCATION"
			},
			{
				"name": "Katie Hall",
				"salience": 0.070960216,
				"type": "PERSON"
			},
			{
				"name": "Cat Cafe",
				"salience": 0.05140397,
				"type": "LOCATION"
			},
			{
				"name": "cafe",
				"salience": 0.05077033,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.046980795,
				"type": "EVENT"
			},
			{
				"name": "owner",
				"salience": 0.037229214,
				"type": "PERSON"
			},
			{
				"name": "Demonstrators",
				"salience": 0.03689248,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.03336086,
				"type": "PERSON"
			},
			{
				"name": "gentrification",
				"salience": 0.03336086,
				"type": "OTHER"
			},
			{
				"name": "Jumpolin",
				"salience": 0.032526925,
				"type": "OTHER"
			},
			{
				"name": "organizers",
				"salience": 0.028942445,
				"type": "PERSON"
			},
			{
				"name": "Defend Our Hoodz",
				"salience": 0.024044856,
				"type": "ORGANIZATION"
			},
			{
				"name": "East Austin",
				"salience": 0.022844186,
				"type": "LOCATION"
			},
			{
				"name": "Say Graffiti",
				"salience": 0.020645022,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0867ct",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austin_American-Statesman"
				},
				"name": "Statesman",
				"salience": 0.019314762,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.016579857,
				"type": "OTHER"
			},
			{
				"name": "vandalism",
				"salience": 0.013845099,
				"type": "EVENT"
			},
			{
				"name": "owner",
				"salience": 0.0093357125,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.009238254,
				"type": "PERSON"
			},
			{
				"name": "few",
				"salience": 0.00891527,
				"type": "PERSON"
			},
			{
				"name": "death threats",
				"salience": 0.008160366,
				"type": "OTHER"
			},
			{
				"name": "cafe",
				"salience": 0.00733594,
				"type": "LOCATION"
			},
			{
				"name": "cafe",
				"salience": 0.00733594,
				"type": "LOCATION"
			},
			{
				"name": "gentrification",
				"salience": 0.007088664,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.007088664,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.006778544,
				"type": "EVENT"
			},
			{
				"name": "protesters",
				"salience": 0.006778544,
				"type": "PERSON"
			},
			{
				"name": "owner",
				"salience": 0.0062246053,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.006140331,
				"type": "LOCATION"
			},
			{
				"name": "examples",
				"salience": 0.006140331,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.005960898,
				"type": "OTHER"
			},
			{
				"name": "owners",
				"salience": 0.0058429926,
				"type": "PERSON"
			},
			{
				"name": "doors",
				"salience": 0.005789679,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.005750484,
				"type": "EVENT"
			},
			{
				"name": "protest",
				"salience": 0.005750484,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0057388446,
				"type": "OTHER"
			},
			{
				"name": "business owners",
				"salience": 0.005484719,
				"type": "PERSON"
			},
			{
				"name": "demolition",
				"salience": 0.0044978736,
				"type": "EVENT"
			},
			{
				"name": "vandalism",
				"salience": 0.004494737,
				"type": "OTHER"
			},
			{
				"name": "piñata store",
				"salience": 0.0043078964,
				"type": "LOCATION"
			},
			{
				"name": "notification",
				"salience": 0.0043078964,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.004147308,
				"type": "LOCATION"
			},
			{
				"name": "demolition",
				"salience": 0.0041163377,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.0040617012,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0038124681,
				"type": "PERSON"
			},
			{
				"name": "East Cesar Chavez",
				"salience": 0.003782451,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01021j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Navasota,_Texas"
				},
				"name": "Navasota",
				"salience": 0.003782451,
				"type": "LOCATION"
			},
			{
				"name": "graffiti",
				"salience": 0.0035785043,
				"type": "OTHER"
			},
			{
				"name": "landowners",
				"salience": 0.003517695,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.003429693,
				"type": "LOCATION"
			},
			{
				"name": "Jumpolin",
				"salience": 0.0033924046,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.003131343,
				"type": "EVENT"
			},
			{
				"name": "walls",
				"salience": 0.0030790714,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0030601097,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austin,_Texas"
				},
				"name": "Austin",
				"salience": 0.002769929,
				"type": "LOCATION"
			},
			{
				"name": "Austinites",
				"salience": 0.002769929,
				"type": "PERSON"
			},
			{
				"name": "anguish",
				"salience": 0.0026284577,
				"type": "OTHER"
			},
			{
				"name": "cyber-bullying",
				"salience": 0.0026284577,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0026284577,
				"type": "OTHER"
			},
			{
				"name": "cafe",
				"salience": 0.002532467,
				"type": "LOCATION"
			},
			{
				"name": "cafe",
				"salience": 0.002532467,
				"type": "LOCATION"
			},
			{
				"name": "footage",
				"salience": 0.0024670758,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cats",
				"salience": 0.0022109947,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0019802188,
				"type": "ORGANIZATION"
			},
			{
				"name": "megaphones",
				"salience": 0.0019146558,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "profanity",
				"salience": 0.0019146558,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0019146558,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pictures",
				"salience": 0.0019146558,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pigs",
				"salience": 0.0019146558,
				"type": "OTHER"
			},
			{
				"name": "Editor's Note",
				"salience": 0.0019146558,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article link",
				"salience": 0.0019146558,
				"type": "OTHER"
			},
			{
				"name": "cats",
				"salience": 0.0016518389,
				"type": "OTHER"
			},
			{
				"name": "doors",
				"salience": 0.0016518389,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0014303965,
				"type": "OTHER"
			},
			{
				"name": "scum",
				"salience": 0.0014303965,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.001238768,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:30:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.5,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Demonstrators Protest Outside Blue Cat Cafe, Say Graffiti Didn’t Come from Them Katie Hall, Statesman, October 21, 2016 \nMore than a dozen people participated in a heated protest against gentrification outside an East Austin cafe Friday evening, but organizers denied being involved in the vandalism discovered at the business earlier today . \nThe protest was organized by Defend Our Hoodz , which pointed at Blue Cat Cafe, located at East Cesar Chavez and Navasota streets, as one of many examples of gentrification in the area. \n{snip} \nThe protest was heated at times. At one point, a few of the protesters surrounded and yelled at the cafe’s owner, who argued with them while standing outside the cafe. \n{snip} \nBlue Cat Cafe opened its doors a year ago on Oct. 17. It replaced the family-run piñata store Jumpolin, which was demolished in February 2015. Jumpolin’s owners said the eight-year-old business had been torn down with no notification, and the demolition sparked protests as people argued that the event symbolized how Austinites and Austin landowners are pushing out minority residents and business owners as the city grows. \n{snip} \nOn Friday morning, the owner of Blue Cat Cafe discovered graffiti on the business’ walls that read “you gentrified scum.” The doors had also been glued shut, temporarily trapping the cafe’s cats inside. \n{snip} \nThe cafe’s owner asked the Statesman not to use her name because of multiple death threats that she said she’s gotten from protesters who opposed the demolition of Jumpolin. \n“The vandalism and the mental anguish they’ve caused me and the cyber-bullying they do–it’s really out of control,” the owner said. “They show up with megaphones and they yell profanity; they send me emails with pictures of dead cats and pigs.” \n[Editor’s Note: There is footage of the protest at the original article link below.]",
		"thread_title": "Demonstrators Protest Outside Blue Cat Cafe, Say Graffiti Didn’t Come from Them",
		"title": "Demonstrators Protest Outside Blue Cat Cafe, Say Graffiti Didn’t Come from Them",
		"type": "bs",
		"uuid": "d54f1a7b381c1969a9f1de92276939b7afbe9cf3"
	},
	"-KhIgaXVR_-eYGHoqxax": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:47.822+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "miscreants",
				"salience": 0.118882276,
				"type": "PERSON"
			},
			{
				"name": "delinquents",
				"salience": 0.10177536,
				"type": "PERSON"
			},
			{
				"name": "junior environmental science major",
				"salience": 0.071999155,
				"type": "PERSON"
			},
			{
				"name": "check",
				"salience": 0.047734607,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.040646926,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.037582684,
				"type": "EVENT"
			},
			{
				"name": "teens",
				"salience": 0.037582684,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07hwc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Temple_in_Jerusalem"
				},
				"name": "The Temple",
				"salience": 0.02828935,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.023550877,
				"type": "PERSON"
			},
			{
				"name": "college students",
				"salience": 0.02225582,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philly",
				"salience": 0.020980783,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01jt2w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Temple_University"
				},
				"name": "Temple",
				"salience": 0.02049277,
				"type": "LOCATION"
			},
			{
				"name": "conversations",
				"salience": 0.02014037,
				"type": "EVENT"
			},
			{
				"name": "campus",
				"salience": 0.017422596,
				"type": "LOCATION"
			},
			{
				"name": "aggression",
				"salience": 0.015877863,
				"type": "OTHER"
			},
			{
				"name": "rage",
				"salience": 0.015095604,
				"type": "OTHER"
			},
			{
				"name": "passersby",
				"salience": 0.015095604,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.015095604,
				"type": "OTHER"
			},
			{
				"name": "chill",
				"salience": 0.014085695,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.01386137,
				"type": "PERSON"
			},
			{
				"name": "Street violence",
				"salience": 0.010808973,
				"type": "OTHER"
			},
			{
				"name": "police officer",
				"salience": 0.010441624,
				"type": "PERSON"
			},
			{
				"name": "delinquents",
				"salience": 0.010310378,
				"type": "PERSON"
			},
			{
				"name": "Most",
				"salience": 0.009475536,
				"type": "PERSON"
			},
			{
				"name": "high schoolers",
				"salience": 0.0093945265,
				"type": "PERSON"
			},
			{
				"name": "Jenice Armstrong",
				"salience": 0.009304781,
				"type": "PERSON"
			},
			{
				"name": "boys",
				"salience": 0.007672418,
				"type": "PERSON"
			},
			{
				"name": "chaos",
				"salience": 0.0069785225,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0064484375,
				"type": "OTHER"
			},
			{
				"name": "gentrification",
				"salience": 0.0062268535,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.0062268535,
				"type": "OTHER"
			},
			{
				"name": "race relations",
				"salience": 0.0062268535,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0056985663,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0056616985,
				"type": "OTHER"
			},
			{
				"name": "Anyone",
				"salience": 0.0055106725,
				"type": "PERSON"
			},
			{
				"name": "teens",
				"salience": 0.0053765685,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0050691995,
				"type": "OTHER"
			},
			{
				"name": "campus",
				"salience": 0.005043058,
				"type": "LOCATION"
			},
			{
				"name": "youngsters",
				"salience": 0.004854985,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.004594475,
				"type": "OTHER"
			},
			{
				"name": "teens",
				"salience": 0.004560149,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.004560149,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/077t63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Philadelphia"
				},
				"name": "North Philly",
				"salience": 0.0044277054,
				"type": "LOCATION"
			},
			{
				"name": "No one",
				"salience": 0.00442311,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0043674186,
				"type": "LOCATION"
			},
			{
				"name": "posting",
				"salience": 0.0043674186,
				"type": "OTHER"
			},
			{
				"name": "meet-up",
				"salience": 0.0043674186,
				"type": "EVENT"
			},
			{
				"name": "news reports",
				"salience": 0.0042045116,
				"type": "WORK_OF_ART"
			},
			{
				"name": "madness",
				"salience": 0.0042045116,
				"type": "OTHER"
			},
			{
				"name": "police horse",
				"salience": 0.0042045116,
				"type": "PERSON"
			},
			{
				"name": "bicycle",
				"salience": 0.0042045116,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "group",
				"salience": 0.0041176723,
				"type": "ORGANIZATION"
			},
			{
				"name": "girls",
				"salience": 0.0041176723,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0040686624,
				"type": "EVENT"
			},
			{
				"name": "kids",
				"salience": 0.004039506,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09n9rv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Broad_Street_(Philadelphia)"
				},
				"name": "Broad Street",
				"salience": 0.003970962,
				"type": "LOCATION"
			},
			{
				"name": "AMC North Broad Street 7",
				"salience": 0.003970962,
				"type": "LOCATION"
			},
			{
				"name": "People",
				"salience": 0.0039708354,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.003934449,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.003934449,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.0035658837,
				"type": "PERSON"
			},
			{
				"name": "football game",
				"salience": 0.0035658837,
				"type": "EVENT"
			},
			{
				"name": "Avenue North",
				"salience": 0.0034388136,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0028659655,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0glpjll",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Instagram"
				},
				"name": "Instagram",
				"salience": 0.0026888486,
				"type": "OTHER"
			},
			{
				"name": "Pearl Theater",
				"salience": 0.0026888486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05l5n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oxford"
				},
				"name": "Oxford",
				"salience": 0.0026888486,
				"type": "LOCATION"
			},
			{
				"name": "hair",
				"salience": 0.0026641157,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.0026641157,
				"type": "OTHER"
			},
			{
				"name": "boyfriend",
				"salience": 0.0026641157,
				"type": "PERSON"
			},
			{
				"name": "shoes",
				"salience": 0.0026305553,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "street violence",
				"salience": 0.0024817924,
				"type": "OTHER"
			},
			{
				"name": "attackers",
				"salience": 0.0024817924,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.002288136,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0022408518,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.0022408518,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0022408518,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01lc8p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lincoln_Financial_Field"
				},
				"name": "Lincoln Financial Field",
				"salience": 0.002195181,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.0021410896,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0020674288,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.002006891,
				"type": "EVENT"
			},
			{
				"name": "race",
				"salience": 0.002006891,
				"type": "EVENT"
			},
			{
				"name": "face",
				"salience": 0.0019404263,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0019404263,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0017982736,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0016740072,
				"type": "PERSON"
			},
			{
				"name": "theTab.com",
				"salience": 0.0016398838,
				"type": "OTHER"
			},
			{
				"name": "skin color",
				"salience": 0.0014495456,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.0014495456,
				"type": "PERSON"
			},
			{
				"name": "assailants",
				"salience": 0.0014495456,
				"type": "PERSON"
			},
			{
				"name": "Yo",
				"salience": 0.0013792813,
				"type": "PERSON"
			},
			{
				"name": "Lots",
				"salience": 0.0012768942,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.0011748523,
				"type": "PERSON"
			},
			{
				"name": "assumption",
				"salience": 0.0010691606,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0007401138,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/092h__",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Temple_Owls_football"
				},
				"name": "Temple",
				"salience": 0.00071073114,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:30:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Jenice Armstrong, Philly, October 26, 2016 \nThe Temple attacks were about troublemaking teens–not race. \nThe youngsters who jumped those college students as they walked to campus Friday night are delinquents who need to be put in check before it’s too late. \nThey were nothing but miscreants who took out their aggression and misdirected rage on random passersby. Why? Because they felt like wilding out that night. They were out to create chaos, so they did. \nSo, don’t talk to me about gentrification in North Philly. \nDon’t talk to me about poverty. \nDon’t talk to me about race relations. \nThose are whole other conversations and not what these attacks were about. \nNo one was safe from these teens that night. Not the six Temple students who were injured. Not the Temple police officer knocked from her bicycle by a 15-year-old. Not even a police horse. Anyone could have gotten caught up in that madness. \nAccording to news reports, a crowd of 150 youngsters started gathering after an Instagram advertised an 8 p.m. meet-up at the AMC North Broad Street 7 (formerly the Pearl Theater at Avenue North), on Broad Street near Oxford at the southern end of the campus. \n{snip} \nMost of the high schoolers who responded to the online posting were good kids looking to socialize. But then the delinquents did what they often do and ruined it for everybody. \nAccording to police, a group of 20 to 30 boys and girls in their early to late teens randomly attacked Temple students as they returned from a football game at Lincoln Financial Field. \n{snip} \nPeople keep trying to make this a racial thing because at least two of the victims were white and all of the assailants were African American. They make that assumption even though we don’t know the race of the other injured students. (Lots of African Americans go to Temple.) Nor do we know the race of the injured officers. \nStreet violence is street violence. It knows no skin color. {snip} \n{snip} \nAnother student, a junior environmental science major who didn’t give her name, told a website called theTab.com, “My boyfriend ran and got away but the second I tried to run, they grabbed me by my hair and started beating my head and back. \n“I remember shoes coming for my face and after that I heard other kids from the group saying, ‘Yo chill, yo chill, it’s just a girl,’ and they pulled my attackers off me.” \n{snip} \nTemple has promised increased security, but when it comes to random street violence, anything can happen to anyone–black or white.",
		"thread_title": "Armstrong: Stop Trying to Make Temple Attacks About Race",
		"title": "Armstrong: Stop Trying to Make Temple Attacks About Race",
		"type": "bs",
		"uuid": "6f12e1ad8f1480490c7586bcd73478cbc386ee17"
	},
	"-KhIgad6LG_S1OEA1D-Y": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:48.386+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.25012708,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.22868796,
				"type": "PERSON"
			},
			{
				"name": "City Council's Transportation Committee",
				"salience": 0.12342011,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01khdz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago_Sun-Times"
				},
				"name": "Chicago Sun-Times",
				"salience": 0.08573418,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.07477308,
				"type": "ORGANIZATION"
			},
			{
				"name": "aldermen",
				"salience": 0.023392234,
				"type": "PERSON"
			},
			{
				"name": "ego",
				"salience": 0.023392234,
				"type": "OTHER"
			},
			{
				"name": "Strips Trump of Honorary Street Designation Fran Spielman",
				"salience": 0.016695721,
				"type": "OTHER"
			},
			{
				"name": "spike",
				"salience": 0.014525876,
				"type": "EVENT"
			},
			{
				"name": "Hits Back",
				"salience": 0.014476461,
				"type": "WORK_OF_ART"
			},
			{
				"name": "city",
				"salience": 0.014301388,
				"type": "LOCATION"
			},
			{
				"name": "caricature",
				"salience": 0.00970845,
				"type": "OTHER"
			},
			{
				"name": "shootings",
				"salience": 0.00970845,
				"type": "EVENT"
			},
			{
				"name": "homicides",
				"salience": 0.00970845,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.0069542625,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f0mg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump_Plaza_Hotel_and_Casino"
				},
				"name": "Trump Plaza",
				"salience": 0.0052809147,
				"type": "LOCATION"
			},
			{
				"name": "recognition",
				"salience": 0.0049707843,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.004754786,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04nfwp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Beale"
				},
				"name": "Anthony Beale",
				"salience": 0.0043927175,
				"type": "PERSON"
			},
			{
				"name": "designation",
				"salience": 0.0042928006,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0042650574,
				"type": "WORK_OF_ART"
			},
			{
				"name": "times",
				"salience": 0.004026805,
				"type": "OTHER"
			},
			{
				"name": "street designation",
				"salience": 0.0036415865,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0033578428,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0033578428,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.003288552,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.0028482068,
				"type": "OTHER"
			},
			{
				"name": "straw",
				"salience": 0.0027075128,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0026734371,
				"type": "OTHER"
			},
			{
				"name": "Illinois Street",
				"salience": 0.0026443761,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0024931391,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0022894996,
				"type": "LOCATION"
			},
			{
				"name": "decision",
				"salience": 0.0022389826,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0021283426,
				"type": "EVENT"
			},
			{
				"name": "stop-and-frisk",
				"salience": 0.0021283426,
				"type": "OTHER"
			},
			{
				"name": "war zone",
				"salience": 0.0021283426,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0021283426,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/031n7n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump_International_Hotel_and_Tower_(Chicago)"
				},
				"name": "Trump International Hotel & Tower",
				"salience": 0.0020679727,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/063z_9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wabash_Avenue_Bridge"
				},
				"name": "Wabash Avenue",
				"salience": 0.0020679727,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bjpr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago_River"
				},
				"name": "Chicago River",
				"salience": 0.0020679727,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0019827634,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.0018162895,
				"type": "WORK_OF_ART"
			},
			{
				"name": "snip",
				"salience": 0.0017903628,
				"type": "OTHER"
			},
			{
				"name": "Reilly",
				"salience": 0.0015075261,
				"type": "PERSON"
			},
			{
				"name": "reputation",
				"salience": 0.0014737865,
				"type": "OTHER"
			},
			{
				"name": "hay",
				"salience": 0.0014368948,
				"type": "OTHER"
			},
			{
				"name": "honor",
				"salience": 0.0013376364,
				"type": "OTHER"
			},
			{
				"name": "punishment",
				"salience": 0.0013316638,
				"type": "OTHER"
			},
			{
				"name": "expense",
				"salience": 0.0011583334,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.0011583334,
				"type": "OTHER"
			},
			{
				"name": "thanks",
				"salience": 0.0011583334,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:30:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Chicago ‘Hits Back,’ Strips Trump of Honorary Street Designation Fran Spielman, Chicago Sun-Times, October 25, 2016 \nChicago aldermen on Tuesday hit Republican presidential nominee Donald Trump where it hurts–in his formidable ego–for using a spike in homicides and shootings to paint a “distorted caricature” of the city. \nThe City Council’s Transportation Committee unanimously agreed to strip Trump of a recognition he covets: “Trump Plaza,” the honorary designation for the east side of Wabash Avenue between Illinois Street and the Chicago River, outside the 96-story Trump International Hotel & Tower. \n“We can actually use his own words against him: ‘When you hit us, we hit back,’ ” said Transportation Committee Chairman Anthony Beale (9th). \n“You’ve hit Chicago numerous times. . . . When you hit Chicago, Chicago hits back.” \n{snip} \nAs for the honorary street designation, one of the Trump Plaza signs already has been stolen. So only one more needs to be removed. That will be done post-haste, if the full City Council approves the punishment, thanks to a so-called “pending passage” letter that Beale promised to sign. \nReilly said Trump no longer deserves the honor after making political hay at Chicago’s expense in a way that has damaged the city’s reputation on the global stage. \nTrump’s decision to portray Chicago as a “war zone” that needs stop-and-frisk during the first presidential debate was the final straw. \n“He was comparing us to a war-torn, third-world country. That was a set of comments that didn’t just insult me. It insulted anyone who loves this great city,” Reilly said. \n{snip}",
		"thread_title": "Chicago ‘Hits Back,’ Strips Trump of Honorary Street Designation",
		"title": "Chicago ‘Hits Back,’ Strips Trump of Honorary Street Designation",
		"type": "bs",
		"uuid": "57d2aaed45061e2e524cc3a6d09dcaf260256848"
	},
	"-KhIgawgziOyOIFjALfI": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:49.060+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01yhm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cleveland_Indians"
				},
				"name": "Cleveland",
				"salience": 0.24305801,
				"type": "LOCATION"
			},
			{
				"name": "baseball team",
				"salience": 0.11484961,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.08364896,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01n52c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Superuser"
				},
				"name": "Root",
				"salience": 0.074102,
				"type": "LOCATION"
			},
			{
				"name": "team",
				"salience": 0.068307914,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chief Wahoo",
				"salience": 0.039738536,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/084l5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington_Redskins"
				},
				"name": "Washington Redskins",
				"salience": 0.028453888,
				"type": "ORGANIZATION"
			},
			{
				"name": "Red-Face Team",
				"salience": 0.02626768,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04mjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_Dodgers"
				},
				"name": "Dodgers",
				"salience": 0.024327833,
				"type": "ORGANIZATION"
			},
			{
				"name": "field",
				"salience": 0.023788337,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01p06z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_Times"
				},
				"name": "Los Angeles Times",
				"salience": 0.016122425,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07qw07y"
				},
				"name": "Racist",
				"salience": 0.013972508,
				"type": "OTHER"
			},
			{
				"name": "Paul Thornton",
				"salience": 0.013972508,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Indians",
				"salience": 0.010137029,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.008257728,
				"type": "LOCATION"
			},
			{
				"name": "light",
				"salience": 0.0075016352,
				"type": "OTHER"
			},
			{
				"name": "Chief Wahoo",
				"salience": 0.0070663365,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0058988063,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.005636658,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.0055884114,
				"type": "LOCATION"
			},
			{
				"name": "mascot",
				"salience": 0.0055276677,
				"type": "OTHER"
			},
			{
				"name": "playoffs",
				"salience": 0.0055276677,
				"type": "EVENT"
			},
			{
				"name": "team",
				"salience": 0.005445462,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fjp3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Series"
				},
				"name": "World Series",
				"salience": 0.0054190946,
				"type": "EVENT"
			},
			{
				"name": "team",
				"salience": 0.005176603,
				"type": "ORGANIZATION"
			},
			{
				"name": "provincialism",
				"salience": 0.004787676,
				"type": "OTHER"
			},
			{
				"name": "appearance",
				"salience": 0.004787676,
				"type": "OTHER"
			},
			{
				"name": "pride",
				"salience": 0.004787676,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.004787676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04pn7c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daniel_Snyder"
				},
				"name": "Daniel Snyder",
				"salience": 0.0043003764,
				"type": "PERSON"
			},
			{
				"name": "season",
				"salience": 0.0042941347,
				"type": "EVENT"
			},
			{
				"name": "team ownership",
				"salience": 0.0038776621,
				"type": "OTHER"
			},
			{
				"name": "fans",
				"salience": 0.0038776621,
				"type": "PERSON"
			},
			{
				"name": "team",
				"salience": 0.0038686474,
				"type": "ORGANIZATION"
			},
			{
				"name": "mascot",
				"salience": 0.0037330776,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0036312286,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0035511146,
				"type": "PERSON"
			},
			{
				"name": "peoples",
				"salience": 0.003506413,
				"type": "PERSON"
			},
			{
				"name": "dark",
				"salience": 0.003358243,
				"type": "OTHER"
			},
			{
				"name": "franchises",
				"salience": 0.003358243,
				"type": "OTHER"
			},
			{
				"name": "playoff run",
				"salience": 0.003358243,
				"type": "EVENT"
			},
			{
				"name": "baseball drama",
				"salience": 0.0032329992,
				"type": "OTHER"
			},
			{
				"name": "summary",
				"salience": 0.0032329992,
				"type": "OTHER"
			},
			{
				"name": "sleeves",
				"salience": 0.0032329992,
				"type": "PERSON"
			},
			{
				"name": "curtain",
				"salience": 0.0032329992,
				"type": "OTHER"
			},
			{
				"name": "minstrel show",
				"salience": 0.0032329992,
				"type": "EVENT"
			},
			{
				"name": "caps",
				"salience": 0.0032329992,
				"type": "OTHER"
			},
			{
				"name": "C",
				"salience": 0.0032329992,
				"type": "OTHER"
			},
			{
				"name": "fans",
				"salience": 0.0031662362,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02n0b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahoos"
				},
				"name": "Wahoo",
				"salience": 0.0029395516,
				"type": "PERSON"
			},
			{
				"name": "term",
				"salience": 0.002742003,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.002742003,
				"type": "OTHER"
			},
			{
				"name": "advocates",
				"salience": 0.002742003,
				"type": "PERSON"
			},
			{
				"name": "hats",
				"salience": 0.002742003,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0026199904,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07l4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toronto_Blue_Jays"
				},
				"name": "Toronto Blue Jays",
				"salience": 0.0025648251,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0023999873,
				"type": "LOCATION"
			},
			{
				"name": "championship drought",
				"salience": 0.002325501,
				"type": "EVENT"
			},
			{
				"name": "Chief Wahoo",
				"salience": 0.0022038573,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059yj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Football_League"
				},
				"name": "NFL",
				"salience": 0.0020676728,
				"type": "ORGANIZATION"
			},
			{
				"name": "defeat",
				"salience": 0.0020486559,
				"type": "EVENT"
			},
			{
				"name": "metropolis",
				"salience": 0.0020486559,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0020486559,
				"type": "OTHER"
			},
			{
				"name": "population peak",
				"salience": 0.0020486559,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0019084659,
				"type": "OTHER"
			},
			{
				"name": "popularity",
				"salience": 0.0017232017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01d5z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston_Red_Sox"
				},
				"name": "Boston Red Sox",
				"salience": 0.0016880841,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.0016605712,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.0014921937,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0014921937,
				"type": "OTHER"
			},
			{
				"name": "dispute",
				"salience": 0.0014921937,
				"type": "EVENT"
			},
			{
				"name": "hardship",
				"salience": 0.0014921937,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0014921937,
				"type": "OTHER"
			},
			{
				"name": "misery",
				"salience": 0.0014921937,
				"type": "OTHER"
			},
			{
				"name": "exalting",
				"salience": 0.0014921937,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0014365008,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0012610903,
				"type": "LOCATION"
			},
			{
				"name": "pity",
				"salience": 0.0011876923,
				"type": "OTHER"
			},
			{
				"name": "soil",
				"salience": 0.0011147261,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.0011147261,
				"type": "OTHER"
			},
			{
				"name": "sports",
				"salience": 0.0011147261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.00091846584,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01yjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago_Cubs"
				},
				"name": "Cubs",
				"salience": 0.0006860872,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:29:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Don’t Root, Root, Root for the Racist, Red-Face Team from Cleveland Paul Thornton, Los Angeles Times, October 26, 2016 \nHow I wish it were the Dodgers who took the field Tuesday night in Cleveland. Yes, we’re all sad in Los Angeles that our team is now one year closer to celebrating the 30th anniversary of its last World Series appearance, but this goes beyond provincialism and wounded civil pride. \nThe Dodgers deserved the chance to humiliate a Cleveland baseball team that not only persists in identifying itself as the “Indians,” but also resurrected the laughably racist, red-faced mascot Chief Wahoo just in time for the playoffs. \nFor those who haven’t kept up with the baseball drama, here’s a summary: The Cleveland team drew the curtain on its regular-season minstrel show in the spring, having replaced Chief Wahoo on its caps with a vintage red “C.” It never officially retired the offending mascot, but Wahoo remained confined only to uniform sleeves throughout the regular season, leading reasonable people to believe that the team ownership had finally seen the light where other franchises such as the NFL’s Washington Redskins remained defiantly in the dark, and was easing its fans into the post-“Indians” era. \nOr so we thought. Chief Wahoo reappeared when the Cleveland team began its impressive playoff run against the Boston Red Sox, and he hasn’t left. He remained stitched on hats and held aloft by adoring Cleveland fans as the team convincingly defeated the Toronto Blue Jays, even surviving a legal attack by advocates of Canada’s indigenous peoples that threatened to forbid even so much as the use of the term “Indians” while the team was on Canadian soil. \n{snip} \nIt’s tempting to look past all this and take pity on a city that’s had it as rough as Cleveland. The Cubs’ championship drought has famously lasted for 107 baseball seasons, but the Cleveland team boasts a pitiable 67 years without a World Series title. Beyond sports, Cleveland’s decline as an important American metropolis is arguably unmatched, having tumbled from a population peak of 900,000-plus in 1950 to less than 400,000 today. {snip} \nBut Cleveland? Hey, I know some generous, wonderfully caring people from that part of Ohio, which makes wishing for their team’s brutal defeat personally difficult. But being on the right side of a moral dispute isn’t supposed to be easy, especially when the team in question isn’t the evil Washington Redskins and its infernal owner, Daniel Snyder. Cleveland’s municipal misery doesn’t excuse the disgraceful exalting of Chief Wahoo any more than white men’s economic hardship makes Donald Trump’s popularity OK. \n{snip}",
		"thread_title": "Don’t Root, Root, Root for the Racist, Red-Face Team from Cleveland",
		"title": "Don’t Root, Root, Root for the Racist, Red-Face Team from Cleveland",
		"type": "bs",
		"uuid": "08373ff248f3e96fc91e1118aedb0b5570b597ac"
	},
	"-KhIgb7IRQZchKGYy1lb": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:49.926+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cm6m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Mikado"
				},
				"name": "The Mikado",
				"salience": 0.30721676,
				"type": "WORK_OF_ART"
			},
			{
				"name": "group",
				"salience": 0.12739503,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.11582678,
				"type": "PERSON"
			},
			{
				"name": "stereotypes",
				"salience": 0.05536683,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.030219961,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Students",
				"salience": 0.024841225,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japanese",
				"salience": 0.019668886,
				"type": "LOCATION"
			},
			{
				"name": "Harvard-Radcliffe Gilbert and Sullivan Players",
				"salience": 0.019607369,
				"type": "PERSON"
			},
			{
				"name": "performances",
				"salience": 0.018287856,
				"type": "EVENT"
			},
			{
				"name": "George S. Qiao",
				"salience": 0.014803904,
				"type": "PERSON"
			},
			{
				"name": "Lack of Engagement with Controversial Past Derek G. Xiao",
				"salience": 0.012029516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01s1g7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Harvard_Crimson"
				},
				"name": "Harvard Crimson",
				"salience": 0.011738347,
				"type": "ORGANIZATION"
			},
			{
				"name": "opera",
				"salience": 0.0111426,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stereotypes",
				"salience": 0.010224436,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian American",
				"salience": 0.009429986,
				"type": "PERSON"
			},
			{
				"name": "erasure",
				"salience": 0.009151307,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0080434065,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.007237627,
				"type": "PERSON"
			},
			{
				"name": "production",
				"salience": 0.006425823,
				"type": "WORK_OF_ART"
			},
			{
				"name": "board",
				"salience": 0.005938461,
				"type": "ORGANIZATION"
			},
			{
				"name": "protest",
				"salience": 0.004798873,
				"type": "EVENT"
			},
			{
				"name": "culture",
				"salience": 0.00475974,
				"type": "OTHER"
			},
			{
				"name": "Players",
				"salience": 0.004551375,
				"type": "PERSON"
			},
			{
				"name": "play",
				"salience": 0.004551375,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Gentlemen of Japan",
				"salience": 0.0044014375,
				"type": "OTHER"
			},
			{
				"name": "tone",
				"salience": 0.0043367418,
				"type": "OTHER"
			},
			{
				"name": "Gilbert and Sullivan Players",
				"salience": 0.0042957095,
				"type": "PERSON"
			},
			{
				"name": "opera",
				"salience": 0.00426359,
				"type": "WORK_OF_ART"
			},
			{
				"name": "board",
				"salience": 0.0042472607,
				"type": "ORGANIZATION"
			},
			{
				"name": "engagement",
				"salience": 0.0041410737,
				"type": "OTHER"
			},
			{
				"name": "appropriation",
				"salience": 0.004122607,
				"type": "OTHER"
			},
			{
				"name": "email lists",
				"salience": 0.004122607,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.004122607,
				"type": "OTHER"
			},
			{
				"name": "storyline",
				"salience": 0.004122607,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0036976587,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0036822038,
				"type": "WORK_OF_ART"
			},
			{
				"name": "production",
				"salience": 0.0036822038,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.0035866022,
				"type": "OTHER"
			},
			{
				"name": "canon",
				"salience": 0.0034969023,
				"type": "WORK_OF_ART"
			},
			{
				"name": "town",
				"salience": 0.0033390615,
				"type": "LOCATION"
			},
			{
				"name": "culture",
				"salience": 0.0033390615,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0030809015,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0030421219,
				"type": "OTHER"
			},
			{
				"name": "caricatures",
				"salience": 0.0028918164,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0028918164,
				"type": "OTHER"
			},
			{
				"name": "misrepresentation",
				"salience": 0.0028918164,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0028918164,
				"type": "OTHER"
			},
			{
				"name": "bureaucracy",
				"salience": 0.0028918164,
				"type": "OTHER"
			},
			{
				"name": "staging",
				"salience": 0.0027839744,
				"type": "OTHER"
			},
			{
				"name": "tears",
				"salience": 0.0027839744,
				"type": "OTHER"
			},
			{
				"name": "sweat",
				"salience": 0.0027839744,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.0027839744,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0027839744,
				"type": "OTHER"
			},
			{
				"name": "setting",
				"salience": 0.0027264873,
				"type": "OTHER"
			},
			{
				"name": "script",
				"salience": 0.0027264873,
				"type": "WORK_OF_ART"
			},
			{
				"name": "setting",
				"salience": 0.0026248023,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.0024420153,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reimagining",
				"salience": 0.002361193,
				"type": "OTHER"
			},
			{
				"name": "rendition",
				"salience": 0.0022162287,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.002170452,
				"type": "LOCATION"
			},
			{
				"name": "Harvard-Radcliffe Gilbert & Sullivan Players",
				"salience": 0.0021468455,
				"type": "LOCATION"
			},
			{
				"name": "intent",
				"salience": 0.002037186,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0020045147,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.001780536,
				"type": "LOCATION"
			},
			{
				"name": "opera",
				"salience": 0.0017788939,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hotel",
				"salience": 0.0017641605,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0016434429,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0016434429,
				"type": "OTHER"
			},
			{
				"name": "script",
				"salience": 0.0014839108,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interview",
				"salience": 0.0014839108,
				"type": "EVENT"
			},
			{
				"name": "issues",
				"salience": 0.0014839108,
				"type": "OTHER"
			},
			{
				"name": "omission",
				"salience": 0.0013518336,
				"type": "OTHER"
			},
			{
				"name": "shows",
				"salience": 0.0013289965,
				"type": "WORK_OF_ART"
			},
			{
				"name": "shows",
				"salience": 0.0013289965,
				"type": "WORK_OF_ART"
			},
			{
				"name": "all",
				"salience": 0.001284987,
				"type": "OTHER"
			},
			{
				"name": "Gentlemen of the Strip",
				"salience": 0.0012541154,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03dpf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gilbert_and_Sullivan"
				},
				"name": "Gilbert and Sullivan",
				"salience": 0.001149235,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/029l86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas_Strip"
				},
				"name": "Las Vegas",
				"salience": 0.0010859793,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07qkq7w"
				},
				"name": "Oriental",
				"salience": 0.0010859793,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vzx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Player_(game)"
				},
				"name": "Players",
				"salience": 0.0009666006,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00095994136,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00095994136,
				"type": "PERSON"
			},
			{
				"name": "op-ed",
				"salience": 0.00095994136,
				"type": "OTHER"
			},
			{
				"name": "dilemma",
				"salience": 0.00095994136,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.00095994136,
				"type": "EVENT"
			},
			{
				"name": "Strike 'The Mikado",
				"salience": 0.00081803155,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0bx4c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zhou_dynasty"
				},
				"name": "Zhou",
				"salience": 0.0007944846,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asians",
				"salience": 0.00079093565,
				"type": "PERSON"
			},
			{
				"name": "Kathleen C. Zhou",
				"salience": 0.0006823266,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:29:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Students to Protest ‘Mikado’ for Lack of Engagement with Controversial Past Derek G. Xiao, Harvard Crimson, October 27, 2016 \nA group of Asian American students is planning to protest the Harvard-Radcliffe Gilbert and Sullivan Players’ upcoming production of “The Mikado” for how it handles the racial stereotypes that characterize traditional performances of the opera. \nOrganized by George S. Qiao ’18, the group of students had publicized their protest over various email lists, describing what they consider inadequate attempts to remove the Japanese stereotypes and appropriation of Japanese culture that remained latent in the adapted production’s storyline. But later Qiao said that he thought the tone of his initial concerns was unfair to the Players. \n“I fully believe that members of the Gilbert and Sullivan Players put their blood, sweat, and tears into trying to improve this staging of the production,” Qiao said. “However, I believe that there is still insufficient critical engagement [with] this play’s history of Japanese cultural misrepresentation.” \nPenned in 1884, “The Mikado” is a comical opera, set in the fictional Japanese town of Titipu and meant to satirically mask criticism of British political culture and bureaucracy with grossly exaggerated “Asian” names and stereotypical cultural caricatures. \n{snip} Hoping to avoid these issues in their own production, the board of the Gilbert and Sullivan Players made some changes to the setting and script of the opera, characterizing their rendition as a “reimagining” of the original production. \n“The board of the Harvard-Radcliffe Gilbert & Sullivan Players, whose mission is to produce the full canon of Gilbert and Sullivan’s shows, faced a dilemma this past January,” Kathleen C. Zhou ’17, the president of the Players, wrote in an op-ed for The Crimson Tuesday. “Strike ‘The Mikado’ from our season, and ignore one of the most problematic but well-known G&S; shows, or try to confront it by reimagining it and subverting authorial intent.” \nThe setting of their show is no longer the 19th century town of Titipu, and instead is now 20th century “Las Vegas themed Oriental hotel.” And, the opening number “Gentlemen of Japan” has been rewritten as “Gentlemen of the Strip.” \n{snip} \nZhou said in an interview that in rethinking the comical opera’s script, the complete omission of all of the original production’s issues was “an erasure in itself in that it does not acknowledge how problematic the show has been to [Asians].” \n{snip}",
		"thread_title": "Students to Protest ‘Mikado’ for Lack of Engagement with Controversial Past",
		"title": "Students to Protest ‘Mikado’ for Lack of Engagement with Controversial Past",
		"type": "bs",
		"uuid": "9e0644078889aa06fc17a7000d1768820acbc8cb"
	},
	"-KhIgbK0E-JDR6PHsh5j": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:50.401+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japanese",
				"salience": 0.20159262,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.07870874,
				"type": "PERSON"
			},
			{
				"name": "census",
				"salience": 0.066544,
				"type": "OTHER"
			},
			{
				"name": "census",
				"salience": 0.066544,
				"type": "ORGANIZATION"
			},
			{
				"name": "Population Declines",
				"salience": 0.043894403,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07dfk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tokyo"
				},
				"name": "Tokyo",
				"salience": 0.041944504,
				"type": "LOCATION"
			},
			{
				"name": "results",
				"salience": 0.039719597,
				"type": "OTHER"
			},
			{
				"name": "First Time",
				"salience": 0.032421555,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/015tck",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Japan_Times"
				},
				"name": "Japan Times",
				"salience": 0.032421555,
				"type": "ORGANIZATION"
			},
			{
				"name": "decline",
				"salience": 0.022023652,
				"type": "OTHER"
			},
			{
				"name": "survey",
				"salience": 0.017042974,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.016916763,
				"type": "PERSON"
			},
			{
				"name": "populations",
				"salience": 0.015582898,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0118808355,
				"type": "PERSON"
			},
			{
				"name": "census",
				"salience": 0.0100056315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03_w61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gaijin"
				},
				"name": "non-Japanese",
				"salience": 0.009876147,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.009705923,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.009705923,
				"type": "PERSON"
			},
			{
				"name": "census",
				"salience": 0.009633285,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.009161035,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.009111346,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.008471868,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.008471868,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.007632743,
				"type": "PERSON"
			},
			{
				"name": "internal affairs ministry",
				"salience": 0.00759321,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0075365617,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.007348462,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0072560683,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.0068062427,
				"type": "OTHER"
			},
			{
				"name": "census figures",
				"salience": 0.0068062427,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.006725536,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.006413439,
				"type": "OTHER"
			},
			{
				"name": "prefectures",
				"salience": 0.006393337,
				"type": "OTHER"
			},
			{
				"name": "prefectures",
				"salience": 0.006393337,
				"type": "OTHER"
			},
			{
				"name": "prefectures",
				"salience": 0.006393337,
				"type": "OTHER"
			},
			{
				"name": "government data",
				"salience": 0.0063129244,
				"type": "OTHER"
			},
			{
				"name": "vicinity",
				"salience": 0.0061233975,
				"type": "OTHER"
			},
			{
				"name": "census",
				"salience": 0.0061091706,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0059216153,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.0058952104,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.0058952104,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00517156,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.004778138,
				"type": "PERSON"
			},
			{
				"name": "census",
				"salience": 0.0044514383,
				"type": "OTHER"
			},
			{
				"name": "household",
				"salience": 0.004314696,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00386459,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.003767898,
				"type": "LOCATION"
			},
			{
				"name": "municipalities",
				"salience": 0.0037367058,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "U.N.",
				"salience": 0.0036307184,
				"type": "ORGANIZATION"
			},
			{
				"name": "average",
				"salience": 0.0035073266,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0034811217,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0034811217,
				"type": "ORGANIZATION"
			},
			{
				"name": "household",
				"salience": 0.0031433352,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018jmn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chiba_Prefecture"
				},
				"name": "Chiba",
				"salience": 0.0030793028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gqm3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kanagawa_Prefecture"
				},
				"name": "Kanagawa",
				"salience": 0.0030793028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018qd6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saitama_Prefecture"
				},
				"name": "Saitama",
				"salience": 0.0030793028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02lf_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aichi_Prefecture"
				},
				"name": "Aichi",
				"salience": 0.0030793028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018jhx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shiga_Prefecture"
				},
				"name": "Shiga",
				"salience": 0.0030793028,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gqkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fukuoka"
				},
				"name": "Fukuoka",
				"salience": 0.0030793028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05mkn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Okinawa_Prefecture"
				},
				"name": "Okinawa",
				"salience": 0.0030793028,
				"type": "LOCATION"
			},
			{
				"name": "data",
				"salience": 0.0029152213,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0028152987,
				"type": "OTHER"
			},
			{
				"name": "nationals",
				"salience": 0.0028152987,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0028152987,
				"type": "LOCATION"
			},
			{
				"name": "nationality",
				"salience": 0.0028152987,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0028152987,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.002722102,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.002722102,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.0026322932,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0026009558,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.0023485015,
				"type": "PERSON"
			},
			{
				"name": "government data",
				"salience": 0.0021780233,
				"type": "OTHER"
			},
			{
				"name": "expatriates",
				"salience": 0.0020337033,
				"type": "PERSON"
			},
			{
				"name": "nationals",
				"salience": 0.0018065107,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "North Korea",
				"salience": 0.0014456627,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06qd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Korea"
				},
				"name": "South Korea",
				"salience": 0.0014456627,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.0012518273,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:29:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Japan’s Population Declines in 2015 for First Time Since 1920 Japan Times, October 27, 2016 \nJapan’s population stood at 127,094,745 as of Oct. 1, 2015, the final results of the census showed, down 0.8 percent from the previous census five years earlier and marking the first decline since the survey began in 1920. \nOf the total population, including non-Japanese residents, those aged 65 or older accounted for a record-high 26.6 percent, while those below 15 years old fell to a record-low 12.6 percent, the internal affairs ministry said. \nThe government data showed that the number of people 65 or older rose 3.6 percentage points from the previous census in 2010 to 33,465,441. In contrast, those 14 or younger fell by 0.6 points to 15,886,810. \nComparing the new census figures against U.N. estimates, Japan remains the 10th-most populous nation. However, among the top 20 countries, it was the only one whose population declined between 2010 and 2015. \nThe latest results by the census, conducted every five years, also showed that the population is concentrated in Tokyo and its vicinity. \nOf the 47 prefectures, the capital and neighboring Saitama, Chiba and Kanagawa prefectures accounted for 28.4 percent of the total population. \nThe population rose only in eight prefectures–the four above as well as Aichi, Shiga, Fukuoka and Okinawa. \nThe population of Japanese nationals totaled 124,283,901, while the number of non-Japanese residents in the country totaled 1,752,368, the government data showed. \nBy nationality, Chinese nationals accounted for the largest number of expatriates at 511,118, followed by people from both South Korea and North Korea together at 376,954. \nOf the country’s 1,719 municipalities, the populations in 1,419 of them decreased, according to the census. \nThe male population totaled 61,841,738, while the female population stood at 65,253,007. \nTokyo had the lowest number of people in a household at 1.99, falling below 2 for the first time since the government began compiling such information in 1970, the data showed. The national average of members per household is 2.33. \nThe preliminary figures for the census, released in February, showed the country’s population fell by 947,305 from 128,057,352 in 2010.",
		"thread_title": "Japan’s Population Declines in 2015 for First Time Since 1920",
		"title": "Japan’s Population Declines in 2015 for First Time Since 1920",
		"type": "bs",
		"uuid": "e1b8aa70085fdb0fce73f7ec960600dbf79fd824"
	},
	"-KhIgbU_vOLRKnnko2i0": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T09:03:50.607+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.15840639,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.15267198,
				"type": "LOCATION"
			},
			{
				"name": "muggers",
				"salience": 0.14776766,
				"type": "PERSON"
			},
			{
				"name": "suburb",
				"salience": 0.052394163,
				"type": "LOCATION"
			},
			{
				"name": "police protection",
				"salience": 0.03504886,
				"type": "OTHER"
			},
			{
				"name": "Muggers",
				"salience": 0.03241882,
				"type": "PERSON"
			},
			{
				"name": "suburb",
				"salience": 0.02931313,
				"type": "LOCATION"
			},
			{
				"name": "prey",
				"salience": 0.025428291,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.025428291,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.021755284,
				"type": "PERSON"
			},
			{
				"name": "Immigrants Demand Protection",
				"salience": 0.02170621,
				"type": "OTHER"
			},
			{
				"name": "Chaoling Zhang",
				"salience": 0.015905242,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0179qd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Telegraph"
				},
				"name": "Telegraph",
				"salience": 0.015720382,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025sl9b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cun_(unit)"
				},
				"name": "Sun",
				"salience": 0.015720382,
				"type": "PERSON"
			},
			{
				"name": "David Chazan",
				"salience": 0.015720382,
				"type": "PERSON"
			},
			{
				"name": "demonstrator",
				"salience": 0.015200178,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.014656598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03g_gn8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fang"
				},
				"name": "Fang",
				"salience": 0.014652675,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.008509228,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0068925275,
				"type": "OTHER"
			},
			{
				"name": "robbery",
				"salience": 0.006224919,
				"type": "EVENT"
			},
			{
				"name": "slogan",
				"salience": 0.0061971834,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.005897161,
				"type": "PERSON"
			},
			{
				"name": "silence",
				"salience": 0.0053920248,
				"type": "OTHER"
			},
			{
				"name": "running complaint",
				"salience": 0.0053920248,
				"type": "OTHER"
			},
			{
				"name": "urgency",
				"salience": 0.0053920248,
				"type": "OTHER"
			},
			{
				"name": "tailor",
				"salience": 0.0053920248,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0053920248,
				"type": "EVENT"
			},
			{
				"name": "poverty",
				"salience": 0.0053571723,
				"type": "OTHER"
			},
			{
				"name": "Dominique Darden",
				"salience": 0.005008496,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.0049569854,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02jb8_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aubervilliers"
				},
				"name": "Aubervilliers",
				"salience": 0.004678539,
				"type": "LOCATION"
			},
			{
				"name": "Some",
				"salience": 0.0046562245,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0043675764,
				"type": "EVENT"
			},
			{
				"name": "arrests",
				"salience": 0.003979298,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0038309584,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0037663118,
				"type": "EVENT"
			},
			{
				"name": "Olivier Wang",
				"salience": 0.0036495635,
				"type": "PERSON"
			},
			{
				"name": "homage",
				"salience": 0.0036417237,
				"type": "OTHER"
			},
			{
				"name": "T-shirt",
				"salience": 0.0036417237,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "two",
				"salience": 0.0036417237,
				"type": "PERSON"
			},
			{
				"name": "red",
				"salience": 0.0036417237,
				"type": "OTHER"
			},
			{
				"name": "bloodstains",
				"salience": 0.0036417237,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0035994165,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian",
				"salience": 0.0033213182,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0033213182,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.003121889,
				"type": "LOCATION"
			},
			{
				"name": "wealthy",
				"salience": 0.0030888212,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0030888212,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0030888212,
				"type": "PERSON"
			},
			{
				"name": "prejudices",
				"salience": 0.0030888212,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0030888212,
				"type": "EVENT"
			},
			{
				"name": "origin",
				"salience": 0.0026650594,
				"type": "OTHER"
			},
			{
				"name": "robbers",
				"salience": 0.0026650594,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0026650594,
				"type": "PERSON"
			},
			{
				"name": "Franco-Chinese Friendship Association",
				"salience": 0.002329372,
				"type": "ORGANIZATION"
			},
			{
				"name": "protests",
				"salience": 0.0023272242,
				"type": "EVENT"
			},
			{
				"name": "shops",
				"salience": 0.0023079528,
				"type": "LOCATION"
			},
			{
				"name": "restaurants",
				"salience": 0.0023079528,
				"type": "LOCATION"
			},
			{
				"name": "Maike Song",
				"salience": 0.002242473,
				"type": "WORK_OF_ART"
			},
			{
				"name": "community",
				"salience": 0.0021500522,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0019413758,
				"type": "EVENT"
			},
			{
				"name": "No one",
				"salience": 0.0016811625,
				"type": "PERSON"
			},
			{
				"name": "muggings",
				"salience": 0.0016063286,
				"type": "EVENT"
			},
			{
				"name": "origin",
				"salience": 0.0014503878,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0014503878,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0014077583,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.0012559452,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0012559452,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0012559452,
				"type": "PERSON"
			},
			{
				"name": "handbag",
				"salience": 0.0012559452,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0007730407,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0007730407,
				"type": "PERSON"
			},
			{
				"name": "Community workers",
				"salience": 0.00036867463,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:29:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Chinese Immigrants Demand Protection from Paris Muggers David Chazan, Telegraph, August 21, 2016 \nThousands of angry Chinese immigrants demonstrated in a Paris suburb yesterday (Sun) to demand police protection from muggers who they say prey on them because they are seen as easy targets. \nThe death of a 49-year-old Chinese tailor after being badly beaten in a robbery earlier this month has lent new urgency to the long running complaint that Asian immigrants are systematically attacked and robbed in the French capital. \n“The Chinese community is dying in silence,” read a slogan on a T-shirt splashed with red to symbolise bloodstains worn by one demonstrator, Maike Song. \nHe said he joined the protest in Aubervilliers to pay homage to Chaoling Zhang, the father of two who died on August 14 after being punched to ground in the north-eastern suburb that is home to some 4,000 Chinese immigrants. \nNo arrests have been made over the attack. \nAbout 100 Chinese residents of Aubervilliers have been attacked and robbed since November, according to the Franco-Chinese Friendship Association. \n“It is because of prejudices that Chinese people are weak, docile and wealthy,” said Fang, a young female student. “I’ve been attacked three times in three years and my friends are suffering the same thing. Some have moved away from this area because of it. I don’t go out with a handbag any more.” \nCommunity workers say many muggings are committed by members of other minorities living in the area, generally of Arab or African origin. \nParis officials corroborated the figures but declined to identify the robbers by ethnic origin. \nMany Chinese immigrants own restaurants or shops and tend to be relatively well-off, but are often reluctant to go to the police. “Some victims have been illegal immigrants,” said Dominique Darden, a social worker. \nThe Chinese community of Paris has held other protests in recent years over the attacks. \n“They happen almost every day because of poverty but it’s unbearable,” said a spokesman, Olivier Wang. “No one should have to put up with this.”",
		"thread_title": "Chinese Immigrants Demand Protection from Paris Muggers",
		"title": "Chinese Immigrants Demand Protection from Paris Muggers",
		"type": "bs",
		"uuid": "197a0c0ee98235e7200ddfdacef8db3c797e53f6"
	},
	"-KhIgbjW1wT_Ga_qKEeh": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T02:24:56.602+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.44376022,
				"type": "OTHER"
			},
			{
				"name": "Users",
				"salience": 0.104615904,
				"type": "PERSON"
			},
			{
				"name": "advertisers",
				"salience": 0.07199604,
				"type": "ORGANIZATION"
			},
			{
				"name": "copies",
				"salience": 0.03149527,
				"type": "OTHER"
			},
			{
				"name": "Julia Angwin",
				"salience": 0.026683513,
				"type": "PERSON"
			},
			{
				"name": "Advertisers",
				"salience": 0.01966079,
				"type": "ORGANIZATION"
			},
			{
				"name": "ads",
				"salience": 0.017058551,
				"type": "WORK_OF_ART"
			},
			{
				"name": "advertisers",
				"salience": 0.01628961,
				"type": "ORGANIZATION"
			},
			{
				"name": "newspaper",
				"salience": 0.015543696,
				"type": "ORGANIZATION"
			},
			{
				"name": "policies",
				"salience": 0.014839588,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.012498415,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.010792298,
				"type": "PERSON"
			},
			{
				"name": "social network",
				"salience": 0.0078739375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cgx4k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ProPublica"
				},
				"name": "Pro Publica",
				"salience": 0.0076855863,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkzf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jim_Crow_laws"
				},
				"name": "Jim Crow",
				"salience": 0.0066590626,
				"type": "PERSON"
			},
			{
				"name": "Terry Parris Jr.",
				"salience": 0.0066590626,
				"type": "PERSON"
			},
			{
				"name": "Ads",
				"salience": 0.006264607,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Affinities",
				"salience": 0.0049220645,
				"type": "OTHER"
			},
			{
				"name": "John Relman",
				"salience": 0.0038388695,
				"type": "PERSON"
			},
			{
				"name": "affinity",
				"salience": 0.00372621,
				"type": "OTHER"
			},
			{
				"name": "Steve Satterfield",
				"salience": 0.003582746,
				"type": "PERSON"
			},
			{
				"name": "dwelling",
				"salience": 0.0034393629,
				"type": "LOCATION"
			},
			{
				"name": "housing",
				"salience": 0.003365012,
				"type": "OTHER"
			},
			{
				"name": "advertisers",
				"salience": 0.003279711,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ethnic Affinity",
				"salience": 0.0032666936,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0032043043,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.0031544096,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.0031544096,
				"type": "WORK_OF_ART"
			},
			{
				"name": "snip",
				"salience": 0.0031544096,
				"type": "OTHER"
			},
			{
				"name": "advertisement",
				"salience": 0.0029264851,
				"type": "WORK_OF_ART"
			},
			{
				"name": "race",
				"salience": 0.0029047302,
				"type": "EVENT"
			},
			{
				"name": "notice",
				"salience": 0.0028038705,
				"type": "OTHER"
			},
			{
				"name": "targeting options",
				"salience": 0.0027097238,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0026318256,
				"type": "OTHER"
			},
			{
				"name": "employment",
				"salience": 0.0026318256,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0026318256,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0026318256,
				"type": "ORGANIZATION"
			},
			{
				"name": "members",
				"salience": 0.002487359,
				"type": "PERSON"
			},
			{
				"name": "advertisers",
				"salience": 0.0023896801,
				"type": "ORGANIZATION"
			},
			{
				"name": "advertisements",
				"salience": 0.0023896801,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Violators",
				"salience": 0.002348271,
				"type": "PERSON"
			},
			{
				"name": "house hunting",
				"salience": 0.002279307,
				"type": "EVENT"
			},
			{
				"name": "interests",
				"salience": 0.002279307,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.002279307,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.002279307,
				"type": "PERSON"
			},
			{
				"name": "factors",
				"salience": 0.002279307,
				"type": "OTHER"
			},
			{
				"name": "gender",
				"salience": 0.002279307,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0022126222,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.0021301047,
				"type": "WORK_OF_ART"
			},
			{
				"name": "policies",
				"salience": 0.0020506603,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.0020442263,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.0019578303,
				"type": "OTHER"
			},
			{
				"name": "violation",
				"salience": 0.0018932535,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0018458755,
				"type": "OTHER"
			},
			{
				"name": "limitation",
				"salience": 0.0018458755,
				"type": "OTHER"
			},
			{
				"name": "preference",
				"salience": 0.0018458755,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0018458755,
				"type": "OTHER"
			},
			{
				"name": "print",
				"salience": 0.0018458755,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0018066078,
				"type": "OTHER"
			},
			{
				"name": "advertising",
				"salience": 0.0017855958,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0017770196,
				"type": "PERSON"
			},
			{
				"name": "discrimination",
				"salience": 0.0016690791,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.0016690791,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0015985217,
				"type": "OTHER"
			},
			{
				"name": "handicap",
				"salience": 0.0015985217,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0015985217,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.0015985217,
				"type": "OTHER"
			},
			{
				"name": "rental",
				"salience": 0.0015985217,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.0015985217,
				"type": "OTHER"
			},
			{
				"name": "sex",
				"salience": 0.0015985217,
				"type": "OTHER"
			},
			{
				"name": "exclusion",
				"salience": 0.0015388835,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0015388835,
				"type": "PERSON"
			},
			{
				"name": "notices",
				"salience": 0.0015070932,
				"type": "OTHER"
			},
			{
				"name": "limitation",
				"salience": 0.0015070932,
				"type": "OTHER"
			},
			{
				"name": "preference",
				"salience": 0.0015070932,
				"type": "OTHER"
			},
			{
				"name": "printing",
				"salience": 0.0015070932,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.0015070932,
				"type": "OTHER"
			},
			{
				"name": "specification",
				"salience": 0.001305099,
				"type": "OTHER"
			},
			{
				"name": "employment recruitment",
				"salience": 0.001305099,
				"type": "OTHER"
			},
			{
				"name": "fines",
				"salience": 0.001305099,
				"type": "OTHER"
			},
			{
				"name": "tens of thousands",
				"salience": 0.001305099,
				"type": "PERSON"
			},
			{
				"name": "harassment",
				"salience": 0.001305099,
				"type": "OTHER"
			},
			{
				"name": "disparagement",
				"salience": 0.001305099,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.001305099,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0012470076,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_v5q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_Rights_Act_of_1968"
				},
				"name": "Fair Housing Act",
				"salience": 0.0012116183,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/019twb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_Rights_Act_of_1964"
				},
				"name": "Civil Rights Act of 1964",
				"salience": 0.001166404,
				"type": "WORK_OF_ART"
			},
			{
				"name": "options",
				"salience": 0.0011160505,
				"type": "OTHER"
			},
			{
				"name": "targeting options",
				"salience": 0.0011019907,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-American",
				"salience": 0.001093998,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.001093998,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0010608647,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_3ng",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fair_Housing_Act"
				},
				"name": "Fair Housing Act of 1968",
				"salience": 0.0010406285,
				"type": "WORK_OF_ART"
			},
			{
				"name": "same",
				"salience": 0.0010388219,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0009831567,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0009750116,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pages",
				"salience": 0.0009750116,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0009750116,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0009750116,
				"type": "OTHER"
			},
			{
				"name": "advertisers",
				"salience": 0.0009717159,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian",
				"salience": 0.00094733667,
				"type": "LOCATION"
			},
			{
				"name": "categories",
				"salience": 0.00094283215,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0008809625,
				"type": "OTHER"
			},
			{
				"name": "housing ad",
				"salience": 0.00084439095,
				"type": "WORK_OF_ART"
			},
			{
				"name": "minority groups",
				"salience": 0.00082008826,
				"type": "ORGANIZATION"
			},
			{
				"name": "demographics",
				"salience": 0.00082008826,
				"type": "OTHER"
			},
			{
				"name": "category",
				"salience": 0.00082008826,
				"type": "OTHER"
			},
			{
				"name": "Demographics",
				"salience": 0.00082008826,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.0007101304,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0007101304,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.0007101304,
				"type": "LOCATION"
			},
			{
				"name": "representation",
				"salience": 0.0007101304,
				"type": "OTHER"
			},
			{
				"name": "ads",
				"salience": 0.00067851006,
				"type": "WORK_OF_ART"
			},
			{
				"name": "law",
				"salience": 0.0006126218,
				"type": "OTHER"
			},
			{
				"name": "stand",
				"salience": 0.0005651993,
				"type": "OTHER"
			},
			{
				"name": "enforcement action",
				"salience": 0.0005651993,
				"type": "OTHER"
			},
			{
				"name": "advertising practices",
				"salience": 0.00053047156,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.00053047156,
				"type": "OTHER"
			},
			{
				"name": "privacy",
				"salience": 0.00053047156,
				"type": "OTHER"
			},
			{
				"name": "compliance",
				"salience": 0.00043304396,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T20:05:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.6,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Facebook Lets Advertisers Exclude Users by Race Julia Angwin and Terry Parris Jr., Pro Publica, October 28, 2016 \nImagine if, during the Jim Crow era, a newspaper offered advertisers the option of placing ads only in copies that went to white readers. \nThat’s basically what Facebook is doing nowadays. \nThe ubiquitous social network not only allows advertisers to target users by their interests or background, it also gives advertisers the ability to exclude specific groups it calls “Ethnic Affinities.” Ads that exclude people based on race, gender and other sensitive factors are prohibited by federal law in housing and employment. \n{snip} \nThe ad we purchased was targeted to Facebook members who were house hunting and excluded anyone with an “affinity” for African-American, Asian-American or Hispanic people. ( Here’s the ad itself .) \nWhen we showed Facebook’s racial exclusion options to a prominent civil rights lawyer John Relman , he gasped and said, “This is horrifying. This is massively illegal. This is about as blatant a violation of the federal Fair Housing Act as one can find.” \nThe Fair Housing Act of 1968 makes it illegal “to make, print, or publish, or cause to be made, printed, or published any notice, statement, or advertisement, with respect to the sale or rental of a dwelling that indicates any preference, limitation, or discrimination based on race, color, religion, sex, handicap, familial status, or national origin.” Violators can face tens of thousands of dollars in fines . \nThe Civil Rights Act of 1964 also prohibits the “printing or publication of notices or advertisements indicating prohibited preference, limitation, specification or discrimination” in employment recruitment. \n{snip} \nFacebook says its policies prohibit advertisers from using the targeting options for discrimination, harassment, disparagement or predatory advertising practices. \n“We take a strong stand against advertisers misusing our platform: Our policies prohibit using our targeting options to discriminate, and they require compliance with the law,” said Steve Satterfield, privacy and public policy manager at Facebook. “We take prompt enforcement action when we determine that ads violate our policies.” \n{snip} \nHe said Facebook began offering the “Ethnic Affinity” categories within the past two years as part of a “multicultural advertising” effort. \nSatterfield added that the “Ethnic Affinity” is not the same as race–which Facebook does not ask its members about. Facebook assigns members an “Ethnic Affinity” based on pages and posts they have liked or engaged with on Facebook. \nWhen we asked why “Ethnic Affinity” was included in the “Demographics” category of its ad-targeting tool if it’s not a representation of demographics, Facebook responded that it plans to move “Ethnic Affinity” to another section. \nFacebook declined to answer questions about why our housing ad excluding minority groups was approved 15 minutes after we placed the order. \n{snip}",
		"thread_title": "Facebook Lets Advertisers Exclude Users by Race",
		"title": "Facebook Lets Advertisers Exclude Users by Race",
		"type": "bs",
		"uuid": "36e68a2c384e80bb73d1d22615e5868edf6135b6"
	},
	"-KhIgcYOty3bJO3_oPvH": {
		"author": "Jared Taylor",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:38:59.696+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Heil Donald Trump",
				"salience": 0.822388,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.023976443,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.006793123,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04645f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Renaissance_(magazine)"
				},
				"name": "American Renaissance",
				"salience": 0.006190651,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04736l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jared_Taylor"
				},
				"name": "Jared Taylor",
				"salience": 0.0054188953,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0050382954,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02bpjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Duke"
				},
				"name": "David Duke",
				"salience": 0.004759922,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0037205128,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0028310323,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0025865901,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0025008607,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0021463856,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0019777669,
				"type": "PERSON"
			},
			{
				"name": "supremacists",
				"salience": 0.0017801358,
				"type": "PERSON"
			},
			{
				"name": "articles",
				"salience": 0.0017557195,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0017547214,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06sf9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jake_Tapper"
				},
				"name": "Jake Tapper",
				"salience": 0.0015911914,
				"type": "PERSON"
			},
			{
				"name": "Alt-Right",
				"salience": 0.0015438743,
				"type": "OTHER"
			},
			{
				"name": "shouts",
				"salience": 0.0015336807,
				"type": "OTHER"
			},
			{
				"name": "news hounds",
				"salience": 0.0013973106,
				"type": "PERSON"
			},
			{
				"name": "dishonesty",
				"salience": 0.0013949316,
				"type": "OTHER"
			},
			{
				"name": "hysteria",
				"salience": 0.0012080868,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0012052779,
				"type": "OTHER"
			},
			{
				"name": "haters",
				"salience": 0.0012044369,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0012040067,
				"type": "PERSON"
			},
			{
				"name": "supremacist",
				"salience": 0.0011655308,
				"type": "OTHER"
			},
			{
				"name": "white supremacists",
				"salience": 0.0011655308,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0010707433,
				"type": "PERSON"
			},
			{
				"name": "rulers",
				"salience": 0.0010307091,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0010145594,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.0010093754,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.0010093754,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0010093754,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.0009828311,
				"type": "PERSON"
			},
			{
				"name": "opposite",
				"salience": 0.0009734955,
				"type": "OTHER"
			},
			{
				"name": "Media dishonesty",
				"salience": 0.00096603716,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00096266845,
				"type": "PERSON"
			},
			{
				"name": "demonization campaign",
				"salience": 0.00093547604,
				"type": "EVENT"
			},
			{
				"name": "irony",
				"salience": 0.00091828953,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.0009114274,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0008855177,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0008741402,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.00085432763,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0008452818,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0007942686,
				"type": "PERSON"
			},
			{
				"name": "AmRen.com",
				"salience": 0.0007901181,
				"type": "OTHER"
			},
			{
				"name": "closet",
				"salience": 0.0007892837,
				"type": "LOCATION"
			},
			{
				"name": "rulers",
				"salience": 0.0007892837,
				"type": "PERSON"
			},
			{
				"name": "bigot",
				"salience": 0.0007892837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00076857687,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0007596835,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.00074488664,
				"type": "PERSON"
			},
			{
				"name": "Media Self-Destruct",
				"salience": 0.0007438332,
				"type": "OTHER"
			},
			{
				"name": "cast-iron orthodoxy",
				"salience": 0.0007126745,
				"type": "OTHER"
			},
			{
				"name": "dissidents",
				"salience": 0.0007126745,
				"type": "PERSON"
			},
			{
				"name": "angle",
				"salience": 0.0007126745,
				"type": "OTHER"
			},
			{
				"name": "contempt",
				"salience": 0.00070469815,
				"type": "OTHER"
			},
			{
				"name": "Millions",
				"salience": 0.0006786538,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.000656001,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.0006171465,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0006171465,
				"type": "OTHER"
			},
			{
				"name": "agony",
				"salience": 0.0006171465,
				"type": "OTHER"
			},
			{
				"name": "fan",
				"salience": 0.0006171465,
				"type": "PERSON"
			},
			{
				"name": "neck",
				"salience": 0.0006171465,
				"type": "OTHER"
			},
			{
				"name": "deviations",
				"salience": 0.0006171465,
				"type": "OTHER"
			},
			{
				"name": "media credibility",
				"salience": 0.0006171465,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0006171465,
				"type": "ORGANIZATION"
			},
			{
				"name": "fantasies",
				"salience": 0.0006171465,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0006171465,
				"type": "EVENT"
			},
			{
				"name": "publicity",
				"salience": 0.00053004903,
				"type": "OTHER"
			},
			{
				"name": "Racists",
				"salience": 0.00052881555,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.00052267936,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00052231434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.0005002269,
				"type": "LOCATION"
			},
			{
				"name": "reasons",
				"salience": 0.0004964851,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0004934253,
				"type": "OTHER"
			},
			{
				"name": "Voters",
				"salience": 0.00049205904,
				"type": "PERSON"
			},
			{
				"name": "journalists",
				"salience": 0.0004905723,
				"type": "PERSON"
			},
			{
				"name": "millennials",
				"salience": 0.00048405316,
				"type": "PERSON"
			},
			{
				"name": "supremacists",
				"salience": 0.0004799504,
				"type": "PERSON"
			},
			{
				"name": "racists",
				"salience": 0.00047780687,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.00047568427,
				"type": "ORGANIZATION"
			},
			{
				"name": "journalists",
				"salience": 0.00047226218,
				"type": "PERSON"
			},
			{
				"name": "hate",
				"salience": 0.00046250212,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.00045824362,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.00042992027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.00042134538,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.0004156013,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.00041421014,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0003963569,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00038554173,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00038354148,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00037987944,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00037119313,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00034838764,
				"type": "PERSON"
			},
			{
				"name": "The White Nationalists Who",
				"salience": 0.00034777078,
				"type": "ORGANIZATION"
			},
			{
				"name": "bigot",
				"salience": 0.00034619996,
				"type": "OTHER"
			},
			{
				"name": "supremacist",
				"salience": 0.0003451529,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00034217286,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.0003418373,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.0003418373,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00033995643,
				"type": "OTHER"
			},
			{
				"name": "closet",
				"salience": 0.0003249294,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.0003249294,
				"type": "PERSON"
			},
			{
				"name": "reporter",
				"salience": 0.0003249294,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0003249294,
				"type": "EVENT"
			},
			{
				"name": "supremacy",
				"salience": 0.00032394662,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.00032394662,
				"type": "OTHER"
			},
			{
				"name": "supremacist",
				"salience": 0.00032394662,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00032372036,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi",
				"salience": 0.0003140746,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.000314019,
				"type": "ORGANIZATION"
			},
			{
				"name": "whatever",
				"salience": 0.00031185328,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.00030091166,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00029736175,
				"type": "PERSON"
			},
			{
				"name": "Back",
				"salience": 0.00029337514,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.00029337514,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.00029248776,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00028751162,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f69h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neo-Nazism"
				},
				"name": "Neo-Nazis",
				"salience": 0.00028585986,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.0002840867,
				"type": "OTHER"
			},
			{
				"name": "contribution",
				"salience": 0.00028262008,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.00028050653,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.00028050653,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00028050653,
				"type": "EVENT"
			},
			{
				"name": "rioters",
				"salience": 0.00027234326,
				"type": "PERSON"
			},
			{
				"name": "attention",
				"salience": 0.00027187893,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0002701177,
				"type": "PERSON"
			},
			{
				"name": "implication",
				"salience": 0.0002672533,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0002672533,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.000263087,
				"type": "PERSON"
			},
			{
				"name": "hate",
				"salience": 0.000263087,
				"type": "OTHER"
			},
			{
				"name": "titles",
				"salience": 0.0002540333,
				"type": "OTHER"
			},
			{
				"name": "Extremist Leaders",
				"salience": 0.0002540333,
				"type": "PERSON"
			},
			{
				"name": "reader",
				"salience": 0.0002540333,
				"type": "PERSON"
			},
			{
				"name": "chairman",
				"salience": 0.0002540333,
				"type": "PERSON"
			},
			{
				"name": "excuse",
				"salience": 0.0002540333,
				"type": "OTHER"
			},
			{
				"name": "snorts",
				"salience": 0.0002540333,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0002540333,
				"type": "OTHER"
			},
			{
				"name": "endorsement",
				"salience": 0.0002540333,
				"type": "OTHER"
			},
			{
				"name": "indignation respectability",
				"salience": 0.0002540333,
				"type": "OTHER"
			},
			{
				"name": "advocacy",
				"salience": 0.00025032513,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00024802942,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00024683308,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.00024564654,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00024117583,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00023786881,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.00023786881,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00023786881,
				"type": "EVENT"
			},
			{
				"name": "conditions",
				"salience": 0.00022232356,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00022212548,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00022212548,
				"type": "PERSON"
			},
			{
				"name": "sky",
				"salience": 0.00022095296,
				"type": "LOCATION"
			},
			{
				"name": "Horde",
				"salience": 0.00022095296,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.00021930046,
				"type": "OTHER"
			},
			{
				"name": "exchanges",
				"salience": 0.00021930046,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00021930046,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00021930046,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00021787973,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.00021653651,
				"type": "EVENT"
			},
			{
				"name": "Anyone",
				"salience": 0.00021638525,
				"type": "PERSON"
			},
			{
				"name": "answers",
				"salience": 0.00021541852,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0002147669,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0002147669,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00021198425,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00021022887,
				"type": "PERSON"
			},
			{
				"name": "No one",
				"salience": 0.00020830629,
				"type": "PERSON"
			},
			{
				"name": "angle",
				"salience": 0.00020568087,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.00020568087,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00020568087,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.00020323052,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00020130134,
				"type": "EVENT"
			},
			{
				"name": "crime",
				"salience": 0.00020130134,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00020130134,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.00020130134,
				"type": "EVENT"
			},
			{
				"name": "dissent",
				"salience": 0.00020052888,
				"type": "OTHER"
			},
			{
				"name": "White Supremacists Show Support",
				"salience": 0.00019998034,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02bb8j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Communist_Party_USA"
				},
				"name": "American Communist Party",
				"salience": 0.00019998034,
				"type": "ORGANIZATION"
			},
			{
				"name": "story",
				"salience": 0.000199633,
				"type": "WORK_OF_ART"
			},
			{
				"name": "way",
				"salience": 0.00019902909,
				"type": "OTHER"
			},
			{
				"name": "tweets",
				"salience": 0.00019800148,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anyone",
				"salience": 0.00019800148,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.00019800148,
				"type": "PERSON"
			},
			{
				"name": "shouts",
				"salience": 0.00019800148,
				"type": "OTHER"
			},
			{
				"name": "Business Insider",
				"salience": 0.00019800148,
				"type": "ORGANIZATION"
			},
			{
				"name": "tweets",
				"salience": 0.00019800148,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.00019746335,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.00019217934,
				"type": "OTHER"
			},
			{
				"name": "analyses",
				"salience": 0.00018975715,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.00018975715,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.00018975715,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00018598573,
				"type": "PERSON"
			},
			{
				"name": "reporters",
				"salience": 0.0001859641,
				"type": "PERSON"
			},
			{
				"name": "Things",
				"salience": 0.0001859641,
				"type": "OTHER"
			},
			{
				"name": "closet",
				"salience": 0.0001859641,
				"type": "LOCATION"
			},
			{
				"name": "interest",
				"salience": 0.0001859641,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0001859641,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0001859641,
				"type": "OTHER"
			},
			{
				"name": "feistiness",
				"salience": 0.00018267216,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ttk_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hill_(newspaper)"
				},
				"name": "The Hill",
				"salience": 0.00018055736,
				"type": "ORGANIZATION"
			},
			{
				"name": "engagement",
				"salience": 0.00018000542,
				"type": "OTHER"
			},
			{
				"name": "nigger",
				"salience": 0.00017809638,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.00017809638,
				"type": "OTHER"
			},
			{
				"name": "colors",
				"salience": 0.00017809638,
				"type": "OTHER"
			},
			{
				"name": "deplorables",
				"salience": 0.00017809638,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.00017809638,
				"type": "LOCATION"
			},
			{
				"name": "zeal",
				"salience": 0.00017809638,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00017809638,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.00017809638,
				"type": "ORGANIZATION"
			},
			{
				"name": "basket",
				"salience": 0.00017809638,
				"type": "OTHER"
			},
			{
				"name": "surge",
				"salience": 0.00017809638,
				"type": "EVENT"
			},
			{
				"name": "racism",
				"salience": 0.00017768175,
				"type": "OTHER"
			},
			{
				"name": "joy",
				"salience": 0.00017144666,
				"type": "OTHER"
			},
			{
				"name": "explanations",
				"salience": 0.00017144666,
				"type": "OTHER"
			},
			{
				"name": "retweets",
				"salience": 0.00017144666,
				"type": "PERSON"
			},
			{
				"name": "consciousness",
				"salience": 0.00017144666,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00017144666,
				"type": "OTHER"
			},
			{
				"name": "ignorance",
				"salience": 0.00017144666,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00017144666,
				"type": "OTHER"
			},
			{
				"name": "skeleton staff",
				"salience": 0.00017144666,
				"type": "PERSON"
			},
			{
				"name": "Liberals",
				"salience": 0.0001703359,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.00016790218,
				"type": "OTHER"
			},
			{
				"name": "observations",
				"salience": 0.00016790218,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00016790218,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00016790218,
				"type": "OTHER"
			},
			{
				"name": "observations",
				"salience": 0.00016790218,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00016590182,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vpsrmz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_News"
				},
				"name": "Bloomberg News",
				"salience": 0.00016191427,
				"type": "ORGANIZATION"
			},
			{
				"name": "hate",
				"salience": 0.0001604241,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0001604241,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.00015784915,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rlryq"
				},
				"name": "Kluxer",
				"salience": 0.00015634162,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "Klansmen",
				"salience": 0.00015634162,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.00015634162,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00015437888,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00015228459,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00015036513,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.00014694185,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.0001453834,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0001453834,
				"type": "OTHER"
			},
			{
				"name": "landing pages",
				"salience": 0.0001453834,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0001453834,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0001453834,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0001453834,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0001453834,
				"type": "OTHER"
			},
			{
				"name": "bigot",
				"salience": 0.00013890809,
				"type": "OTHER"
			},
			{
				"name": "journalism",
				"salience": 0.00013890809,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00013890809,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence",
				"salience": 0.00013890809,
				"type": "OTHER"
			},
			{
				"name": "backbone",
				"salience": 0.00013706138,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00013472908,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0001293964,
				"type": "PERSON"
			},
			{
				"name": "sociopath",
				"salience": 0.00012541583,
				"type": "OTHER"
			},
			{
				"name": "classes",
				"salience": 0.00012541583,
				"type": "EVENT"
			},
			{
				"name": "opposite",
				"salience": 0.00012541583,
				"type": "OTHER"
			},
			{
				"name": "insiders",
				"salience": 0.00012541583,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00012541583,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.0001234027,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00012244302,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.00012172772,
				"type": "LOCATION"
			},
			{
				"name": "@realDonaldTrump",
				"salience": 0.00011978078,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.00011867832,
				"type": "OTHER"
			},
			{
				"name": "trust newspapers",
				"salience": 0.000116827876,
				"type": "WORK_OF_ART"
			},
			{
				"name": "news",
				"salience": 0.000116827876,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.000116827876,
				"type": "ORGANIZATION"
			},
			{
				"name": "anger",
				"salience": 0.000115705305,
				"type": "OTHER"
			},
			{
				"name": "cheat",
				"salience": 0.000115705305,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.000115705305,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.00011280676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.000109603294,
				"type": "ORGANIZATION"
			},
			{
				"name": "egomaniac",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "temper",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "brat",
				"salience": 0.0001085945,
				"type": "PERSON"
			},
			{
				"name": "bore",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "scowl",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "blowhard",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "prig",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "liar",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "bully",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "outbursts",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "misogynist",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "demagogue",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "predator",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0001085945,
				"type": "ORGANIZATION"
			},
			{
				"name": "bromides",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "Beltway baloney",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0001085945,
				"type": "PERSON"
			},
			{
				"name": "direction",
				"salience": 0.0001085945,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00010738105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00010551063,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00010115826,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00010115826,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.000100781755,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.000100781755,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.00009981335,
				"type": "OTHER"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shooting_of_Trayvon_Martin"
				},
				"name": "Trayvon Martin",
				"salience": 0.00009532852,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.00009133226,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00009133226,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00009133226,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00009133226,
				"type": "OTHER"
			},
			{
				"name": "dictionary",
				"salience": 0.00009133226,
				"type": "OTHER"
			},
			{
				"name": "ruling class",
				"salience": 0.00009133226,
				"type": "OTHER"
			},
			{
				"name": "orthodoxy",
				"salience": 0.00009018098,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.00008946985,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bymv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_McCain"
				},
				"name": "John McCain",
				"salience": 0.00008946985,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.00008946985,
				"type": "PERSON"
			},
			{
				"name": "Black Lives Matters",
				"salience": 0.00008946985,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/011l2bwd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shooting_of_Michael_Brown"
				},
				"name": "Michael Brown",
				"salience": 0.00008946985,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00008801077,
				"type": "ORGANIZATION"
			},
			{
				"name": "voter turnout",
				"salience": 0.00008752892,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00008726411,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00008642558,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.00008642558,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.000081791986,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.000081791986,
				"type": "LOCATION"
			},
			{
				"name": "criminals",
				"salience": 0.000081791986,
				"type": "PERSON"
			},
			{
				"name": "media objectivity",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "collusion",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.00007908193,
				"type": "LOCATION"
			},
			{
				"name": "shrieking",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "rage",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "pretense",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "frothing",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "wordiness",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.00007908193,
				"type": "PERSON"
			},
			{
				"name": "tone",
				"salience": 0.00007908193,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00007808506,
				"type": "OTHER"
			},
			{
				"name": "hypocrites",
				"salience": 0.000077100754,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00007686749,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.00007555939,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00007555939,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.00007555939,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00007555939,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00007484202,
				"type": "LOCATION"
			},
			{
				"name": "sense",
				"salience": 0.00007455479,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00007455479,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.00007455479,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.00007455479,
				"type": "OTHER"
			},
			{
				"name": "contest",
				"salience": 0.00007091558,
				"type": "EVENT"
			},
			{
				"name": "young",
				"salience": 0.00006821973,
				"type": "PERSON"
			},
			{
				"name": "instinct",
				"salience": 0.00006821973,
				"type": "OTHER"
			},
			{
				"name": "engagement",
				"salience": 0.00006821973,
				"type": "OTHER"
			},
			{
				"name": "instincts",
				"salience": 0.00006821973,
				"type": "OTHER"
			},
			{
				"name": "Roger Cohen",
				"salience": 0.000066876804,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asians",
				"salience": 0.00006682858,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "AP",
				"salience": 0.00006682858,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.000066602566,
				"type": "LOCATION"
			},
			{
				"name": "editors",
				"salience": 0.000060587117,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.000059069243,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.000059069243,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.000059069243,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.000059069243,
				"type": "LOCATION"
			},
			{
				"name": "sanctuary cities",
				"salience": 0.000059069243,
				"type": "LOCATION"
			},
			{
				"name": "illegals",
				"salience": 0.000059069243,
				"type": "PERSON"
			},
			{
				"name": "welfare",
				"salience": 0.000059069243,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.000059069243,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.000059069243,
				"type": "OTHER"
			},
			{
				"name": "fracas",
				"salience": 0.000049457103,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bigfoot"
				},
				"name": "Bigfoot",
				"salience": 0.000048666006,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.000046417426,
				"type": "OTHER"
			},
			{
				"name": "advocates",
				"salience": 0.00002601262,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:38:59.696+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 45.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Posted on October 28, 2016 Media Self-Destruct over Trump Jared Taylor, American Renaissance, October 28, 2016 Their hysteria and dishonesty have backfired. \nFrom the start of Donald Trump’s campaign, the media have covered him dishonestly. They have consistently portrayed him as a closet “white supremacist” who deliberately appeals to “racists.” They have tried to tie him to a wicked movement known as the “Alt-Right.” They are now working on another dishonest angle: that Donald Trump is “mainstreaming hate” and bringing “racism” into public discourse. The media clearly want to stampede voters into Mrs. Clinton’s camp so as to spare us the agony of a “racist” in the White House. \nThe demonization campaign has backfired. By trying to hang racial dissidents around Donald Trump’s neck, the media have given American Renaissance and other organizations far more publicity than ever before. At the same time, constant shouts of “racist” and “bigot” don’t seem to hurt Mr. Trump: instead they are wrecking what is left of media credibility. The biggest irony, though, is that Donald Trump is probably not one of us at all. But even small deviations from the cast-iron orthodoxy of race are enough to plunge our rulers into dark fantasies about Donald Trump as a secret David Duke fan. \nMedia dishonesty started immediately. When Mr. Trump pointed out that some immigrants from Mexico were criminals, the press acted as if he had said all Mexican immigrants are criminals. Then, when alert news hounds discovered that those of us they love to call “haters” and “white supremacists” liked Mr. Trump, there was no end of articles with titles such as: “ Meet the Horde of Neo-Nazis, Klansmen, and Other Extremist Leaders Endorsing Donald Trump ,” “ Top Racists And Neo-Nazis Back Donald Trump ,” “ ‘Heil Donald Trump’: Neo-Nazis, White Supremacists Show Support ,” and “ The White Nationalists Who Support Donald Trump .” \nThese articles had a simpleminded purpose: discredit Mr. Trump by parading before the reader any Nazi, Kluxer, or racially conscious white person who had anything nice to say about the candidate. The implication was that if “racists” were going to vote for Donald Trump he must be “racist,” too. \nThis was deceitful and one-sided. When the chairman of the American Communist Party endorsed Hillary Clinton , no one suggested this meant she was a communist. \nIt is true that Mr. Trump gave the media just enough of an excuse to pretend he really is a closet “bigot” because he did not repudiate “racists” with the snorts of indignation respectability requires. There was the famous exchange in February when a reporter pushed Mr. Trump to disavow an endorsement from David Duke. As The Hill reported it: “ ‘David Duke endorsed me? OK, alright. I disavow, OK?’ Trump said, seeking to quickly move on to another question.” \nThat same month, there was another famous exchange with Jake Tapper of CNN : \nTapper : Will you unequivocally condemn David Duke and say that you don’t want his vote or that of other white supremacists in this election? \nDonald Trump : Well just so you understand, I don’t know anything about David Duke, OK? I don’t know anything about what you’re even talking about with white supremacy or white supremacists. So, I don’t know. I don’t know, did he endorse me, or what’s going on? Because, you know, I know nothing about David Duke. I know nothing about white supremacists. \nThe media leaped on these exchanges with shouts of joy. “Trump refuses to disavow white supremacists! That’s because he is one!” \nThere are far better explanations. First, Donald Trump is a pugnacious man. He doesn’t like being pushed around by anyone, especially not by journalists who hate him. If Mr. Tapper had belligerently demanded that Mr. Trump agree that the sky is blue, Mr. Trump would have bridled at that. \nSecond, Donald Trump probably doesn’t know anything about David Duke or white supremacy. I would be astonished if he has ever looked into the thinking of David Duke or any other alleged “white supremacist.” It is his feistiness and his ignorance of white advocacy that explain his answers, not some carefully concealed racial consciousness. \nThe press has also pounced on Donald Trump’s retweets of “racist” material, which is supposed to be yet more proof that he is a secret supremacist. Business Insider, for example, published this shocking story: “ 5 times Donald Trump has engaged with alt-right racists on Twitter .” Not one of these tweets is obviously “racist,” and it would be surprising if Mr. Trump or his skeleton staff took the time to vet the sources of the thousands of tweets @realDonaldTrump has sent during the campaign. \nNow the press is working on another smear-Trump angle. Recently, I have been contacted by journalists from such places as Bloomberg News, Reuters, and the New York Times , who clearly want to write that Donald Trump is “mainstreaming hate,” that he is responsible for a huge surge in the Alt-Right. They want to know about all the people who have been flocking to AmRen.com because of what Donald Trump says. They want me to tell them about people who have been “emboldened” to “speak out against minorities” because Donald Trump has led the way. They would love to find someone who now thinks he is free to run down the street shouting “nigger!” because Mr. Trump wants to take a hard look at Muslim immigrants. \nI have explained to them as patiently as I can that they have it the wrong way around. No one comes looking for AmRen.com because Donald Trump wants to build a wall. They come looking for us because the media have written about us in their attempt to convince the world that Mr. Trump is a “racist.” They come looking for us because Mrs. Clinton kindly called attention to us by complaining about the Alt-Right and her “basket of deplorables.” I also try to explain that if the media had not launched its malicious campaign of trying to hold Donald Trump responsible for the views of certain people who support him, few people would have heard of the Alt-Right. In their zeal to paint their enemy in the darkest colors, they are promoting the Alt-Right, not Donald Trump. \nI explain that racial dissent has been growing like never before, for reasons that have nothing to do with the campaign. It is Trayvon Martin, Michael Brown, Black Lives Matters, and black rioters who are sending hundreds of thousands of frustrated white people our way– not Donald Trump. This will not change whether Mr. Trump wins or loses. The top landing pages on AmRen.com are analyses of race and crime–something Mr. Trump never talks about. \nI also explain to reporters that it is idiotic to think Mr. Trump has mainstreamed “hate,” by which they mean sensible observations about race. I ask them to name a single person who has been “emboldened” to say something “racist” just because Donald Trump is the GOP nominee. Of course, they can’t. If anything, it is the opposite. Mr. Trump has been called every name under the sun for the mildest, most common-sense observations about Muslims and immigration. Anyone tempted to come out of the closet is likely to hesitate more than ever. Things could change if Mr. Trump becomes president, but the candidate himself has done very little to spread our ideas. \nWhat Donald Trump has done is spark an unprecedented interest in politics among disaffected young people who recognize that Mitt Romney and John McCain are no different from Barack Obama when it comes to preserving whites, their society, and their culture. I know a number of millennials who never bothered to vote before but who certainly will in November. I know some who have made their first political contribution or who have spent weekends volunteering for the Trump campaign. \nI point out to reporters that this is what elections are supposed to be all about: giving the voters real choices. I note that the Trump/Clinton contest will almost certainly produce a record voter turnout for a modern election. Haven’t our rulers been wringing their hands over a lack of political engagement, especially among the young? Well, now they have engagement, alright, but they don’t like it. They don’t like it because so many people are stumping for the candidate they love to call a “ threat to democracy .” Liberals are such transparent hypocrites. They claim to love democracy, but suddenly start worrying about its health if the people refuse vote the way they tell them to. \nThe whole Trump-is-a-racist fracas shows just how painfully fragile orthodoxy has become. I may be wrong, but I have no reason to think Donald Trump thinks at all as we do. He has never said or done anything to suggest he is anything more than an ordinary American with normal instincts: He doesn’t want criminals sneaking across the border, he thinks sanctuary cities for illegals are crazy, he doesn’t see why we need more Muslims, and he is angry when immigrants go on welfare. Millions of ordinary Americans clearly agree with him, and not because they are racially aware. It is because they are decent, fair-minded people who also have a nagging sense that the country is changing in unwelcome ways. \nI am convinced that Mr. Trump does not have a sophisticated understanding of race. So far as I can tell, he doesn’t have a sophisticated understanding of much of anything. He has stumbled by instinct onto a few sensible policies that white advocates have been promoting for a long time, but not because he is one of us. \nMaybe–just maybe–he will move in our direction. It’s not impossible to imagine a President Trump asking, in an offhand way, “What’s wrong with white people wanting to remain a majority in the United States?” Or he might casually note that you can’t expect as many blacks as Asians in AP classes because they don’t have the same levels of intelligence. But I can imagine the opposite, too: President Trump so bogged down in Beltway baloney that he never even builds the wall. \nThere is one thing that Donald Trump has changed. He has proven that Republican bromides about taxes and small government don’t excite people. He has proven that there is tremendous anger against political insiders of both parties. He has proven that Americans do want their country to come first. They don’t want it to try to save the world or to be a dumping ground for people who have wrecked their own countries. \nAnd even if he has not “mainstreamed racism,” he has shown that if you have a backbone you can withstand what is surely the most intense and concentrated program of hate ever directed at an American. On October 11, Roger Cohen wrote in the New York Times that Donald Trump is a “phony, liar, blowhard, cheat, bully, misogynist, demagogue, predator, bigot, bore, egomaniac, racist, sexist, sociopath,” and a “dictator-in-waiting with a brat’s temper and a prig’s scowl.” This must be one of the most unhinged, hysterical outbursts in the history of American political journalism. And it is unusual only for its wordiness, not its tone. \nDon’t the editors of the Times realize that this kind of frothing explains why more Americans believe in Bigfoot (29 percent) than trust newspapers (20 percent)? Virtually the entire industry is so consumed with rage at Donald Trump and contempt for his supporters that it cannot control itself. Open, petulant bias is driving more and more Americans to social media and to sites like AmRen.com for their news. \nDespite the concerted shrieking of virtually the entire American ruling class, Donald Trump is going to get close to half of the vote on November 8. Some 60 million people are going to vote for a man for whom Roger Cohen has emptied his dictionary trying to insult. Only one major newspaper has endorsed Donald Trump. Only one . And this is a man whom the American people might choose as their president. What better proof could we have of the stark difference between printed opinion and public opinion, between what Americans think and what our rulers want us to think? Donald Trump has ripped away whatever was left of the pretense of media objectivity. \nWhether he wins or not, whether he is one of us or not, Donald Trump has laid bare the collusion between big media and a political system in which both parties collaborate to run the country in their interests and those of their big donors. Voters–finally–have a chance to vote against the entire corrupt system. On November 8th they could bring it crashing down, but even if it still stands, it is visibly weakened, badly discredited. These are the perfect conditions in which our ideas will flourish as never before.",
		"thread_title": "Media Self-Destruct over Trump",
		"title": "Media Self-Destruct over Trump",
		"type": "bs",
		"uuid": "d99a31ef0b677887a7088a121d1eaae13ad5b1b1"
	},
	"-KhIgci7RrOJcP4DUO0L": {
		"author": "Jared Taylor",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:00.164+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07r_cc9"
				},
				"name": "Blacks",
				"salience": 0.09495616,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04736l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jared_Taylor"
				},
				"name": "Jared Taylor",
				"salience": 0.08950599,
				"type": "PERSON"
			},
			{
				"name": "Blacks Riot",
				"salience": 0.08352545,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.08249535,
				"type": "LOCATION"
			},
			{
				"name": "comment",
				"salience": 0.069396146,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04645f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Renaissance_(magazine)"
				},
				"name": "American Renaissance",
				"salience": 0.06681974,
				"type": "OTHER"
			},
			{
				"name": "2016 Trump",
				"salience": 0.0667724,
				"type": "PERSON"
			},
			{
				"name": "rights",
				"salience": 0.055558033,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.044907037,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.037671547,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "DOJ",
				"salience": 0.03438199,
				"type": "ORGANIZATION"
			},
			{
				"name": "comments",
				"salience": 0.03286638,
				"type": "WORK_OF_ART"
			},
			{
				"name": "episode",
				"salience": 0.024869408,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Death_of_Eric_Garner"
				},
				"name": "Eric Garner",
				"salience": 0.023270557,
				"type": "PERSON"
			},
			{
				"name": "editor",
				"salience": 0.021377126,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.020070141,
				"type": "PERSON"
			},
			{
				"name": "posts",
				"salience": 0.020070141,
				"type": "WORK_OF_ART"
			},
			{
				"name": "download",
				"salience": 0.01932443,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.01639891,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.01639891,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.013396838,
				"type": "OTHER"
			},
			{
				"name": "Commentary",
				"salience": 0.012364232,
				"type": "WORK_OF_ART"
			},
			{
				"name": "guest",
				"salience": 0.012262066,
				"type": "PERSON"
			},
			{
				"name": "White Identity: Racial Consciousness",
				"salience": 0.010108102,
				"type": "OTHER"
			},
			{
				"name": "e-mail address",
				"salience": 0.008937149,
				"type": "OTHER"
			},
			{
				"name": "convenience",
				"salience": 0.008937149,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0066793077,
				"type": "OTHER"
			},
			{
				"name": "social media account",
				"salience": 0.0066793077,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:00.164+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Posted on October 28, 2016 Trump Reaches Out to Blacks; Blacks Riot in Philadelphia Jared Taylor, American Renaissance, October 28, 2016 And DOJ prepares a politically motivated “civil rights” case in the death of Eric Garner. \nThis episode is available for download here . Share This View all posts by Jared Taylor Jared Taylor is the editor of American Renaissance and the author of White Identity: Racial Consciousness in the 21st Century . We welcome comments that add information or perspective, and we encourage polite debate. If you log in with a social media account, your comment should appear immediately. If you prefer to remain anonymous, you may comment as a guest, using a name and an e-mail address of convenience. Your comment will be moderated. Commentary",
		"thread_title": "Trump Reaches Out to Blacks; Blacks Riot in Philadelphia",
		"title": "Trump Reaches Out to Blacks; Blacks Riot in Philadelphia",
		"type": "bs",
		"uuid": "84ff452d5478d74ef420588d02a037fc7023cd26"
	},
	"-KhIgcqLXFMyH1OK9wIf": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:02.722+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco",
				"salience": 0.12332124,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.12247079,
				"type": "PERSON"
			},
			{
				"name": "Cities",
				"salience": 0.070597924,
				"type": "LOCATION"
			},
			{
				"name": "immigrant",
				"salience": 0.051730398,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.04695228,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.039864123,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.036877383,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.033349518,
				"type": "EVENT"
			},
			{
				"name": "Noncitizen Immigrants",
				"salience": 0.029133262,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.02893511,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04q85lk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Chiu_(politician)"
				},
				"name": "David Chiu",
				"salience": 0.028715989,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.019565387,
				"type": "EVENT"
			},
			{
				"name": "Caroline Winter",
				"salience": 0.017896686,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03s60l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_Businessweek"
				},
				"name": "Bloomberg Businessweek",
				"salience": 0.017896686,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.017896686,
				"type": "ORGANIZATION"
			},
			{
				"name": "immigrants",
				"salience": 0.017358739,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.016150689,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0138847465,
				"type": "LOCATION"
			},
			{
				"name": "integrity",
				"salience": 0.013845689,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.012991663,
				"type": "PERSON"
			},
			{
				"name": "doubt",
				"salience": 0.011998585,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.009088537,
				"type": "OTHER"
			},
			{
				"name": "noncitizens",
				"salience": 0.009061151,
				"type": "PERSON"
			},
			{
				"name": "legislation",
				"salience": 0.0080591105,
				"type": "WORK_OF_ART"
			},
			{
				"name": "latest",
				"salience": 0.007908986,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0070899054,
				"type": "LOCATION"
			},
			{
				"name": "school board elections",
				"salience": 0.006779772,
				"type": "EVENT"
			},
			{
				"name": "schools",
				"salience": 0.006466612,
				"type": "ORGANIZATION"
			},
			{
				"name": "election fraud",
				"salience": 0.0061415206,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0061415206,
				"type": "PERSON"
			},
			{
				"name": "claims",
				"salience": 0.0061415206,
				"type": "OTHER"
			},
			{
				"name": "voting rights",
				"salience": 0.0060190684,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0057516415,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0057400013,
				"type": "LOCATION"
			},
			{
				"name": "school system",
				"salience": 0.0055088624,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.00530363,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.00530363,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.004915768,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.004708195,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00449889,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.0043088854,
				"type": "OTHER"
			},
			{
				"name": "documentation",
				"salience": 0.0043088854,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0043088854,
				"type": "PERSON"
			},
			{
				"name": "school board elections",
				"salience": 0.004298872,
				"type": "EVENT"
			},
			{
				"name": "measure",
				"salience": 0.0041482737,
				"type": "OTHER"
			},
			{
				"name": "guardians",
				"salience": 0.0041482737,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0041482737,
				"type": "PERSON"
			},
			{
				"name": "cards",
				"salience": 0.0041482737,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.0041482737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0037833587,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0037798723,
				"type": "LOCATION"
			},
			{
				"name": "city council",
				"salience": 0.0037323018,
				"type": "ORGANIZATION"
			},
			{
				"name": "say",
				"salience": 0.0035185574,
				"type": "OTHER"
			},
			{
				"name": "noncitizens",
				"salience": 0.0032102657,
				"type": "PERSON"
			},
			{
				"name": "school board elections",
				"salience": 0.0031321344,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0031321344,
				"type": "EVENT"
			},
			{
				"name": "towns",
				"salience": 0.0030999125,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0030999125,
				"type": "PERSON"
			},
			{
				"name": "noncitizens",
				"salience": 0.0028282544,
				"type": "PERSON"
			},
			{
				"name": "school boards",
				"salience": 0.0026510989,
				"type": "ORGANIZATION"
			},
			{
				"name": "population",
				"salience": 0.002629148,
				"type": "PERSON"
			},
			{
				"name": "state approval",
				"salience": 0.002629148,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0023402993,
				"type": "EVENT"
			},
			{
				"name": "residents",
				"salience": 0.0022298028,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0022115936,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.002185266,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01hlpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/K%E2%80%9312"
				},
				"name": "K-12",
				"salience": 0.0021665355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06f32",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taiwan"
				},
				"name": "Taiwanese",
				"salience": 0.0021665355,
				"type": "LOCATION"
			},
			{
				"name": "jurisdictions",
				"salience": 0.0021327147,
				"type": "LOCATION"
			},
			{
				"name": "noncitizens",
				"salience": 0.0021131688,
				"type": "PERSON"
			},
			{
				"name": "parent advisory councils",
				"salience": 0.001980764,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.001980764,
				"type": "LOCATION"
			},
			{
				"name": "immigration system",
				"salience": 0.001829941,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0016523043,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "Massachusetts",
				"salience": 0.0016186326,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.0012560977,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maryland"
				},
				"name": "Maryland",
				"salience": 0.00088068855,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:02.722+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Some Cities Want Their Noncitizen Immigrants to Vote Caroline Winter, Bloomberg Businessweek, October 28, 2016 \n“Look at illegal immigrants voting all over the country,” Donald Trump recently claimed in a Fox News interview, part of his ongoing effort to cast doubt on the integrity of the presidential election. There’s no evidence to support the Republican nominee’s claims of election fraud, but some cities are moving to expand voting rights to include noncitizens. \nThe latest is San Francisco, where the Nov. 8 ballot will include a measure allowing the parents or legal guardians of any student in the city’s public schools to vote in school board elections. The right would be extended to those with green cards, visas, or no documentation at all. “One out of three kids in the San Francisco unified school system has a parent who is an immigrant, who is disenfranchised and doesn’t have a voice,” says San Francisco Assemblyman David Chiu, the son of Taiwanese immigrants. “We’ve had legal immigrants who’ve had children go through the entire K-12 system without having a say.” Undocumented immigrants should also have the right, Chiu adds, to bypass the “broken immigration system in this country.” \n{snip} \nToday there are six jurisdictions in Maryland that let noncitizens vote in local elections. Chicago allows them to take part in elected parent advisory councils but not to vote in school board elections. Four towns in Massachusetts have moved to allow noncitizen voting and are awaiting state approval. And in New York City, where noncitizens make up 21 percent of the voting-age population, the city council is drafting legislation that would allow more than 1.3 million legal residents to take part in municipal elections. The city previously allowed noncitizens to vote in school board elections, but that ended when New York’s school boards were dissolved in 2002. \n{snip}",
		"thread_title": "Some Cities Want Their Noncitizen Immigrants to Vote",
		"title": "Some Cities Want Their Noncitizen Immigrants to Vote",
		"type": "bs",
		"uuid": "d51e69b31f03bb17b34098f5c24c35d3b9ea4c57"
	},
	"-KhIgdA4q2Ah4BzlCo8V": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:05.622+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09vqjr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tammy_Duckworth"
				},
				"name": "Tammy Duckworth",
				"salience": 0.48981777,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0256rr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Kirk"
				},
				"name": "Mark Kirk",
				"salience": 0.10882451,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.05198948,
				"type": "WORK_OF_ART"
			},
			{
				"name": "family",
				"salience": 0.044702303,
				"type": "PERSON"
			},
			{
				"name": "Alexandra Jaffe",
				"salience": 0.031940795,
				"type": "PERSON"
			},
			{
				"name": "Opponent",
				"salience": 0.016514082,
				"type": "ORGANIZATION"
			},
			{
				"name": "opponent",
				"salience": 0.016514082,
				"type": "PERSON"
			},
			{
				"name": "military service",
				"salience": 0.016514082,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.014924656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jnh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Revolutionary_War"
				},
				"name": "Revolution",
				"salience": 0.012138854,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.00820244,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.008097033,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.0079866545,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0079866545,
				"type": "ORGANIZATION"
			},
			{
				"name": "Traci G. Lee",
				"salience": 0.0079866545,
				"type": "PERSON"
			},
			{
				"name": "Illinois Senator Draws Fire for Racially Charged Attack",
				"salience": 0.0079866545,
				"type": "WORK_OF_ART"
			},
			{
				"name": "family",
				"salience": 0.005684636,
				"type": "PERSON"
			},
			{
				"name": "dad",
				"salience": 0.005559596,
				"type": "PERSON"
			},
			{
				"name": "ones",
				"salience": 0.0053818817,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.004718656,
				"type": "ORGANIZATION"
			},
			{
				"name": "family",
				"salience": 0.0044703716,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vsn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Revolution"
				},
				"name": "American Revolution",
				"salience": 0.003957897,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0038694472,
				"type": "LOCATION"
			},
			{
				"name": "immigrant",
				"salience": 0.003713883,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019fz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Franklin"
				},
				"name": "Franklin",
				"salience": 0.0036863326,
				"type": "PERSON"
			},
			{
				"name": "service",
				"salience": 0.0034967996,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.003220052,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0031577656,
				"type": "EVENT"
			},
			{
				"name": "uniform",
				"salience": 0.0031577656,
				"type": "OTHER"
			},
			{
				"name": "Families",
				"salience": 0.0031363757,
				"type": "PERSON"
			},
			{
				"name": "desire",
				"salience": 0.0027348944,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0027348944,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0027348944,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0027348944,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0025559068,
				"type": "EVENT"
			},
			{
				"name": "parents",
				"salience": 0.0024824187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07f1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thailand"
				},
				"name": "Thailand",
				"salience": 0.0024189008,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0023614126,
				"type": "LOCATION"
			},
			{
				"name": "drums",
				"salience": 0.0021323147,
				"type": "OTHER"
			},
			{
				"name": "drums",
				"salience": 0.0021323147,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0021273703,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0020028139,
				"type": "PERSON"
			},
			{
				"name": "service",
				"salience": 0.0020028139,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0019181616,
				"type": "OTHER"
			},
			{
				"name": "legs",
				"salience": 0.0019181616,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.001846609,
				"type": "PERSON"
			},
			{
				"name": "war sound",
				"salience": 0.001846609,
				"type": "OTHER"
			},
			{
				"name": "entrepreneurs",
				"salience": 0.0018346563,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.0018084672,
				"type": "PERSON"
			},
			{
				"name": "mother",
				"salience": 0.0018084672,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0018084672,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jnh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Revolutionary_War"
				},
				"name": "Revolutionary War",
				"salience": 0.001634765,
				"type": "EVENT"
			},
			{
				"name": "senator",
				"salience": 0.0016197317,
				"type": "PERSON"
			},
			{
				"name": "photo",
				"salience": 0.0015661112,
				"type": "WORK_OF_ART"
			},
			{
				"name": "descent",
				"salience": 0.0015661112,
				"type": "OTHER"
			},
			{
				"name": "medals",
				"salience": 0.0015661112,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0015661112,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0014250795,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.0014045145,
				"type": "PERSON"
			},
			{
				"name": "ancestor",
				"salience": 0.0013707345,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.0013511622,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Washington"
				},
				"name": "George Washington",
				"salience": 0.0013069564,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq_War"
				},
				"name": "Iraq",
				"salience": 0.0011809086,
				"type": "LOCATION"
			},
			{
				"name": "controversy",
				"salience": 0.0011700459,
				"type": "OTHER"
			},
			{
				"name": "hero",
				"salience": 0.0011700459,
				"type": "PERSON"
			},
			{
				"name": "apologies",
				"salience": 0.0011700459,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.0011700459,
				"type": "EVENT"
			},
			{
				"name": "backlash",
				"salience": 0.0011700459,
				"type": "OTHER"
			},
			{
				"name": "profile",
				"salience": 0.0011700459,
				"type": "OTHER"
			},
			{
				"name": "Anthony Breznican",
				"salience": 0.0011133467,
				"type": "PERSON"
			},
			{
				"name": "opportunities",
				"salience": 0.001089969,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0010414454,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0009841478,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.00096408924,
				"type": "LOCATION"
			},
			{
				"name": "@Breznican",
				"salience": 0.00096408924,
				"type": "ORGANIZATION"
			},
			{
				"name": "pic.twitter.com/DHd3kWrUsN",
				"salience": 0.00096408924,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0009079808,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.000901192,
				"type": "LOCATION"
			},
			{
				"name": "cash payment",
				"salience": 0.00085220183,
				"type": "OTHER"
			},
			{
				"name": "prisoners",
				"salience": 0.00085220183,
				"type": "PERSON"
			},
			{
				"name": "release",
				"salience": 0.00085220183,
				"type": "EVENT"
			},
			{
				"name": "exchange",
				"salience": 0.00085220183,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00085220183,
				"type": "ORGANIZATION"
			},
			{
				"name": "chief",
				"salience": 0.00085220183,
				"type": "OTHER"
			},
			{
				"name": "drug dealer",
				"salience": 0.00085220183,
				"type": "ORGANIZATION"
			},
			{
				"name": "uniform",
				"salience": 0.0007351923,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-American",
				"salience": 0.0007262233,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.00072020566,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02dx64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mother_Jones_(magazine)"
				},
				"name": "Mother Jones",
				"salience": 0.00072020566,
				"type": "PERSON"
			},
			{
				"name": "coat",
				"salience": 0.000636611,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "lineage",
				"salience": 0.000636611,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.0005424919,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.00052452134,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:05.622+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Illinois Senator Draws Fire for Racially Charged Attack on Opponent’s Family Alexandra Jaffe and Traci G. Lee, NBC News, October 28, 2016 \nIllinois Sen. Mark Kirk is again under fire for making racially-charged comments, this time for questioning the military service of his Democratic opponent’s family. \nDuring Thursday night’s debate between Kirk and challenger Rep. Tammy Duckworth, Duckworth spoke about her desire to be in the Senate as a voice of reason and referenced her family’s history of service, saying, “My family has served this nation in uniform, going back to the Revolution. I’m a daughter of the American Revolution. I’ve bled for this nation. But I still want to be there in the Senate when the drums of war sound. Because people are quick to sound the drums of war, and I want to be there to say this is what it costs, this is what you’re asking us to do. . . . Families like mine are the ones that bleed first.” \nKirk responded: “I had forgotten that your parents came all the way from Thailand to serve George Washington.” Tammy Duckworth is a vet who lost both legs in Iraq. Her family has served since the Revolutionary War. And yet… pic.twitter.com/DHd3kWrUsN \n— Anthony Breznican (@Breznican) October 28, 2016 \nThough Duckworth, who was born in Thailand to a Thai mother of Chinese descent and an American father, did not respond on the stage, she tweeted a photo after the debate of herself with her parents–her father displaying medals of service on his coat. “My mom is an immigrant and my dad and his family have served this nation in uniform since the Revolution,” Duckworth wrote. \nDuckworth’s late father, Franklin, served in World War II and has “traced his lineage back to an ancestor who fought in the American Revolution,” according to a 2012 Mother Jones profile on Duckworth’s run for Congress. \n{snip} \nOn Friday, Kirk tried to tamp down the backlash and tweeted “sincere apologies to an American hero.” \nIt’s not the first time the Illinois senator has courted controversy with racially-charged comments–he previously said President Obama was “acting like the drug dealer in chief” for the administration’s cash payment to Iran in exchange for the release of American prisoners, and talked about fostering opportunities for African-American entrepreneurs so “that the black community is not the one we drive faster through.” \n{snip}",
		"thread_title": "Illinois Senator Draws Fire for Racially Charged Attack on Opponent’s Family",
		"title": "Illinois Senator Draws Fire for Racially Charged Attack on Opponent’s Family",
		"type": "bs",
		"uuid": "86355353876994ccd20af8cc04aa01e16ede93a3"
	},
	"-KhIgdNa395BFRa66eGM": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:06.431+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Joe Seiwert",
				"salience": 0.40199268,
				"type": "PERSON"
			},
			{
				"name": "meme",
				"salience": 0.09442034,
				"type": "OTHER"
			},
			{
				"name": "singer",
				"salience": 0.08398388,
				"type": "PERSON"
			},
			{
				"name": "anthem",
				"salience": 0.038006105,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.034071766,
				"type": "OTHER"
			},
			{
				"name": "Protester Dion Lefler",
				"salience": 0.025766117,
				"type": "PERSON"
			},
			{
				"name": "game",
				"salience": 0.019469421,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.017593563,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0t6hk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lawrence,_Kansas"
				},
				"name": "Lawrence",
				"salience": 0.014852062,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.014745511,
				"type": "PERSON"
			},
			{
				"name": "Go Back to Where You Claim Home",
				"salience": 0.014648873,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0jm2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami_Heat"
				},
				"name": "Miami Heat",
				"salience": 0.013318367,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.011326624,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.010860711,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0488g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas"
				},
				"name": "Kansas",
				"salience": 0.010860711,
				"type": "LOCATION"
			},
			{
				"name": "comment",
				"salience": 0.010802492,
				"type": "WORK_OF_ART"
			},
			{
				"name": "freedom",
				"salience": 0.010248691,
				"type": "OTHER"
			},
			{
				"name": "Kansas Lawmaker Tells",
				"salience": 0.009410223,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-American",
				"salience": 0.009410223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04fcd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wichita_Eagle"
				},
				"name": "Wichita Eagle",
				"salience": 0.009410223,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07mx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Star-Spangled_Banner"
				},
				"name": "The Star Spangled Banner",
				"salience": 0.009410223,
				"type": "WORK_OF_ART"
			},
			{
				"name": "woman",
				"salience": 0.0069268914,
				"type": "PERSON"
			},
			{
				"name": "R-Pretty Prairie",
				"salience": 0.0048140627,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.004247598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.0038186044,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0037193384,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.0032411243,
				"type": "OTHER"
			},
			{
				"name": "photo",
				"salience": 0.003235605,
				"type": "WORK_OF_ART"
			},
			{
				"name": "speech",
				"salience": 0.0032211677,
				"type": "EVENT"
			},
			{
				"name": "T-shirt",
				"salience": 0.0032211677,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "constituents",
				"salience": 0.0032211677,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0032211677,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0032211677,
				"type": "ORGANIZATION"
			},
			{
				"name": "follow-up",
				"salience": 0.0032211677,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.00312693,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0030103172,
				"type": "OTHER"
			},
			{
				"name": "preseason game",
				"salience": 0.0027812056,
				"type": "EVENT"
			},
			{
				"name": "basketball team",
				"salience": 0.0027812056,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0027812056,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meme",
				"salience": 0.0027237681,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0026858975,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0026086466,
				"type": "LOCATION"
			},
			{
				"name": "anthem",
				"salience": 0.0025531538,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0024814485,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.0023274678,
				"type": "OTHER"
			},
			{
				"name": "pro-Donald Trump Facebook",
				"salience": 0.002290276,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0022779498,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meme",
				"salience": 0.0022522577,
				"type": "OTHER"
			},
			{
				"name": "worker",
				"salience": 0.0021748047,
				"type": "PERSON"
			},
			{
				"name": "game-night employee",
				"salience": 0.0021748047,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0021298784,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0021298784,
				"type": "OTHER"
			},
			{
				"name": "team officials",
				"salience": 0.0020511178,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Amendment_to_the_United_States_Constitution"
				},
				"name": "First Amendment",
				"salience": 0.0019833376,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Denasia Lawrence",
				"salience": 0.001977342,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0019075739,
				"type": "OTHER"
			},
			{
				"name": "upset",
				"salience": 0.0018444175,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0018444175,
				"type": "OTHER"
			},
			{
				"name": "profanity",
				"salience": 0.0017532278,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.0016665431,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.001614299,
				"type": "OTHER"
			},
			{
				"name": "ANTHEM",
				"salience": 0.0015973733,
				"type": "OTHER"
			},
			{
				"name": "comment",
				"salience": 0.0014617227,
				"type": "WORK_OF_ART"
			},
			{
				"name": "snip",
				"salience": 0.0013894414,
				"type": "OTHER"
			},
			{
				"name": "disrespect",
				"salience": 0.0013779306,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0013779306,
				"type": "LOCATION"
			},
			{
				"name": "race",
				"salience": 0.0013779306,
				"type": "EVENT"
			},
			{
				"name": "color",
				"salience": 0.0013779306,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0013779306,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0358cs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sun-Sentinel"
				},
				"name": "Miami Sun-Sentinel",
				"salience": 0.0013388196,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jm4v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia_76ers"
				},
				"name": "Philadelphia 76ers",
				"salience": 0.0013388196,
				"type": "ORGANIZATION"
			},
			{
				"name": "photo",
				"salience": 0.0012192876,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anything",
				"salience": 0.0011887559,
				"type": "OTHER"
			},
			{
				"name": "BLACKS",
				"salience": 0.0011589881,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0011589881,
				"type": "LOCATION"
			},
			{
				"name": "KNEELING",
				"salience": 0.0010558103,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.0010035918,
				"type": "OTHER"
			},
			{
				"name": "capital letters",
				"salience": 0.0010035918,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.00086578884,
				"type": "PERSON"
			},
			{
				"name": "TV",
				"salience": 0.0007496907,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.000707278,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:06.431+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "‘Go Back to Where You Claim Home,’ Kansas Lawmaker Tells Protester Dion Lefler, Wichita Eagle, October 25, 2016 \nKansas state Rep. Joe Seiwert commented on Facebook that an African-American singer who knelt while performing “The Star Spangled Banner” at a Miami Heat game should “go back” to where she claims as home. \nSeiwert, R-Pretty Prairie, posted that comment and a longer follow-up on an anti-black meme that was originally posted to a pro-Donald Trump Facebook group and then shared by one of Seiwert’s constituents. \nSeiwert confirmed the comments were his and said he was exercising his First Amendment right to free speech, as he says the woman in the meme did when she wore a Black Lives Matter T-shirt and knelt while singing the anthem. \n{snip} \nThe photo in the meme is of Denasia Lawrence, a Miami social worker and, according to the Miami Sun-Sentinel, a part-time game-night employee of the Heat professional basketball team. The team has issued a statement saying team officials were unaware that Lawrence planned to protest when they asked her to sing the anthem at Friday’s preseason game with the Philadelphia 76ers. \n{snip} \nTo which Seiwert responded: “I am where I claim home and like it, they want to claim it and it is their right to go where ever they like, so if they don’t like it here, I believe that their freedom completely allows them to go wherever they believe is more free and non racist if that’s what they believe.” \nSeiwert said he didn’t see the profanity in the meme when he commented and didn’t do anything wrong. \n“I have a personal life besides a legislative life,” he said. “Maybe it was inappropriate; I don’t believe so, because I said nothing derogatory. And I believe that (if) people are that upset with the national anthem, they can do whatever they want to on their own time, but when they’re using it on national TV to make a statement, that’s not right. \n“I said if she (Lawrence) doesn’t like it here, then go where she would like it. What’s wrong with that?” he said. \nAsked why a person should leave rather than try to change things where they are, Seiwert responded: “Because maybe there’s other people who don’t want their place changed.” \nHe also said he did not think his comments had anything to do with race. \n“It don’t make any difference if they’re black, white or green, it’s the disrespect to our country,” he said. “And why does everybody put the color to it?” \n{snip} \nThe person who made the meme took a photo of Lawrence from the web and added, in capital letters, “KNEELING WHILE SINGING THE NATIONAL ANTHEM . . . I’M SO SICK OF THESE ANTI-AMERICAN BLACKS . . . (Expletive) BLACK LIVES MATTER.” \nSeiwert’s comment, directed at Lawrence, was: “Go back to where you claim home than (sic).” \n{snip}",
		"thread_title": "‘Go Back to Where You Claim Home,’ Kansas Lawmaker Tells Protester",
		"title": "‘Go Back to Where You Claim Home,’ Kansas Lawmaker Tells Protester",
		"type": "bs",
		"uuid": "62f7ac04dc94f02613c9ce1de36bbcfbaa1d8b18"
	},
	"-KhIgdgwE0N77lbtgUom": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:07.365+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "rancher",
				"salience": 0.3277387,
				"type": "PERSON"
			},
			{
				"name": "Rancher Yearns for Trump Wall",
				"salience": 0.19737864,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.060146514,
				"type": "PERSON"
			},
			{
				"name": "wall",
				"salience": 0.044997424,
				"type": "OTHER"
			},
			{
				"name": "ranch",
				"salience": 0.044286106,
				"type": "OTHER"
			},
			{
				"name": "Jim Chilton",
				"salience": 0.041345313,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.03746848,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.02356828,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.012947224,
				"type": "PERSON"
			},
			{
				"name": "US-Mexico",
				"salience": 0.011045331,
				"type": "LOCATION"
			},
			{
				"name": "issue",
				"salience": 0.010748457,
				"type": "OTHER"
			},
			{
				"name": "desert plains",
				"salience": 0.008594109,
				"type": "LOCATION"
			},
			{
				"name": "no-man",
				"salience": 0.008529818,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.008387012,
				"type": "LOCATION"
			},
			{
				"name": "US-Mexico Border AFP",
				"salience": 0.007991576,
				"type": "ORGANIZATION"
			},
			{
				"name": "sleep",
				"salience": 0.007248452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0071381326,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0053470586,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.005202573,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.005007089,
				"type": "LOCATION"
			},
			{
				"name": "barrier",
				"salience": 0.0045982925,
				"type": "OTHER"
			},
			{
				"name": "boundary",
				"salience": 0.003974941,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.003892942,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.003382302,
				"type": "LOCATION"
			},
			{
				"name": "ranchers",
				"salience": 0.0033639749,
				"type": "PERSON"
			},
			{
				"name": "drug smugglers",
				"salience": 0.0031595777,
				"type": "PERSON"
			},
			{
				"name": "ranch",
				"salience": 0.0030211948,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.002915344,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.002736454,
				"type": "OTHER"
			},
			{
				"name": "insight",
				"salience": 0.002736454,
				"type": "OTHER"
			},
			{
				"name": "border system",
				"salience": 0.002736454,
				"type": "OTHER"
			},
			{
				"name": "cattle",
				"salience": 0.002736454,
				"type": "OTHER"
			},
			{
				"name": "troubles",
				"salience": 0.002736454,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.002728188,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.002728188,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.002454275,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.002441619,
				"type": "OTHER"
			},
			{
				"name": "border patrol",
				"salience": 0.0023627512,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0022276645,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0022161754,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0021445802,
				"type": "OTHER"
			},
			{
				"name": "scouts",
				"salience": 0.0021066573,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.002044775,
				"type": "OTHER"
			},
			{
				"name": "drug cartel",
				"salience": 0.002003943,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidates",
				"salience": 0.0019192416,
				"type": "PERSON"
			},
			{
				"name": "ranch",
				"salience": 0.0019147777,
				"type": "OTHER"
			},
			{
				"name": "cartel scouts",
				"salience": 0.0018796007,
				"type": "OTHER"
			},
			{
				"name": "roads",
				"salience": 0.0018476476,
				"type": "LOCATION"
			},
			{
				"name": "anybody",
				"salience": 0.0018476476,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0018476476,
				"type": "OTHER"
			},
			{
				"name": "frontier",
				"salience": 0.0018325609,
				"type": "LOCATION"
			},
			{
				"name": "smugglers",
				"salience": 0.0018094837,
				"type": "PERSON"
			},
			{
				"name": "mountains",
				"salience": 0.0018094837,
				"type": "LOCATION"
			},
			{
				"name": "mountains",
				"salience": 0.0018094837,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0017012788,
				"type": "PERSON"
			},
			{
				"name": "desert",
				"salience": 0.0016885648,
				"type": "LOCATION"
			},
			{
				"name": "lookouts",
				"salience": 0.0015669882,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.0015669882,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.0015669882,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.0015616931,
				"type": "LOCATION"
			},
			{
				"name": "border patrol",
				"salience": 0.0014972473,
				"type": "OTHER"
			},
			{
				"name": "drug cartels",
				"salience": 0.0014972473,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0014158821,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0014043179,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0014043179,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0011815659,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0011815659,
				"type": "ORGANIZATION"
			},
			{
				"name": "cowboys",
				"salience": 0.001170697,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.001170697,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.001170697,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.001170697,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0010905748,
				"type": "OTHER"
			},
			{
				"name": "desert",
				"salience": 0.0010905748,
				"type": "LOCATION"
			},
			{
				"name": "extremist groups",
				"salience": 0.0010849463,
				"type": "ORGANIZATION"
			},
			{
				"name": "crossing",
				"salience": 0.001057781,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01gfkk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sinaloa"
				},
				"name": "Sinaloa",
				"salience": 0.00096462405,
				"type": "LOCATION"
			},
			{
				"name": "sector",
				"salience": 0.0008526737,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00081470853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qtlv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Border_Patrol"
				},
				"name": "Border Patrol",
				"salience": 0.000671273,
				"type": "ORGANIZATION"
			},
			{
				"name": "bodies",
				"salience": 0.0006616628,
				"type": "OTHER"
			},
			{
				"name": "pistol",
				"salience": 0.0006369623,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "door",
				"salience": 0.0006369623,
				"type": "OTHER"
			},
			{
				"name": "bedside",
				"salience": 0.0006369623,
				"type": "OTHER"
			},
			{
				"name": "rifle",
				"salience": 0.0006369623,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "favor",
				"salience": 0.0006369623,
				"type": "OTHER"
			},
			{
				"name": "operatives",
				"salience": 0.0006369623,
				"type": "ORGANIZATION"
			},
			{
				"name": "hip",
				"salience": 0.0006369623,
				"type": "OTHER"
			},
			{
				"name": "gun",
				"salience": 0.0006369623,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "border areas",
				"salience": 0.0006369623,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fr0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tucson,_Arizona"
				},
				"name": "Tucson",
				"salience": 0.0005248103,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.00045273954,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:07.365+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Rancher Yearns for Trump Wall on US-Mexico Border AFP, October 28, 2016 \nTo many, Donald Trump’s pledge to build a wall along the US-Mexico border is unrealistic. But for Jim Chilton, it’s the only way he’ll get a good night’s sleep. \nThe 77-year-old, a fifth-generation rancher on the Arizona border with Mexico, says he has grown weary of seeing drug smugglers–rather than just cattle–on his ranch and a wall is the answer to his troubles. \n“I really admire Trump for having the insight and the knowledge to know what’s wrong with the current border system,” he said, as he surveyed the sprawling desert plains of his 75-square-mile ranch that stretches to the Mexican border. \n“We need a wall. I’ve been saying that for 10 years . . . and we need roads along the boundary and the border patrol to be deployed there and not let anybody in,” he added. “It would make my life so much better and I’d feel more secure.” \n{snip} \nChilton, who admits that Trump was not his first choice among the Republican candidates for the White House, says building a barrier to secure the 2,000-mile (3,200-kilometer) US-Mexico frontier not only makes sense but is also a question of national security. \n{snip} \n“I live in a no-man’s land. I live in a land that is occupied by the Sinaloa drug cartel,” he sighed, pointing to mountains on his ranch where he said scouts equipped with sophisticated equipment are posted as lookouts for smugglers. \n“I have seen cartel scouts on these two mountains before . . . and even in my front yard,” he said. “I wave at them and they often yell ‘hola’ and wave back.” \nChilton–who keeps a gun holstered on his hip, a rifle by his front door and a pistol by his bedside–added that he and other ranchers are also in favor of beefed up security in remote border areas as extremist groups like Islamic State (IS) may be using them to slip operatives into the United States. \n{snip} \nBut beyond the drug cartels and threat of terrorism, Chilton insists that Trump’s wall is all the more necessary for humanitarian reasons. \n“It’s just outrageous for me to find a dead body on my ranch. It’s outrageous for the border patrol to find a dead body and it’s outrageous for my cowboys,” he said, referring to migrants who often die making the crossing into the US through the brutal desert. \n“This is as big a humanitarian issue as it is a national security issue.” \n{snip} \nAccording to the US Border Patrol, nearly 2,600 bodies have been recovered since 1998 from the desert in the Tucson, Arizona sector which covers 262 miles of the border. \n{snip}",
		"thread_title": "Rancher Yearns for Trump Wall on US-Mexico Border",
		"title": "Rancher Yearns for Trump Wall on US-Mexico Border",
		"type": "bs",
		"uuid": "2fc9f2cd7d8dbecffe836591ced4802632d1d2b2"
	},
	"-KhIgds9D7hymMaaz7F4": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:08.112+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03cm6b3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colin_Kaepernick"
				},
				"name": "Colin Kaepernick",
				"salience": 0.48952782,
				"type": "PERSON"
			},
			{
				"name": "pessimism",
				"salience": 0.051774517,
				"type": "OTHER"
			},
			{
				"name": "49ers",
				"salience": 0.033611044,
				"type": "PERSON"
			},
			{
				"name": "49ers",
				"salience": 0.033611044,
				"type": "PERSON"
			},
			{
				"name": "Victories",
				"salience": 0.024393685,
				"type": "PERSON"
			},
			{
				"name": "home start",
				"salience": 0.024393685,
				"type": "EVENT"
			},
			{
				"name": "patrons",
				"salience": 0.024393685,
				"type": "PERSON"
			},
			{
				"name": "football funk",
				"salience": 0.024393685,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0by88",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Panther_Party"
				},
				"name": "Black Panther Party",
				"salience": 0.021581635,
				"type": "ORGANIZATION"
			},
			{
				"name": "49ers",
				"salience": 0.019666763,
				"type": "OTHER"
			},
			{
				"name": "ratings",
				"salience": 0.019303285,
				"type": "OTHER"
			},
			{
				"name": "freefall",
				"salience": 0.016016955,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dwb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Jose_Mercury_News"
				},
				"name": "Mercury News",
				"salience": 0.015086096,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kaepernick Elliott Almond",
				"salience": 0.015086096,
				"type": "ORGANIZATION"
			},
			{
				"name": "activism",
				"salience": 0.014195581,
				"type": "OTHER"
			},
			{
				"name": "Thousands",
				"salience": 0.008692,
				"type": "PERSON"
			},
			{
				"name": "fans",
				"salience": 0.00867452,
				"type": "PERSON"
			},
			{
				"name": "Nessa Diab",
				"salience": 0.0067797913,
				"type": "PERSON"
			},
			{
				"name": "defeat",
				"salience": 0.0059758234,
				"type": "EVENT"
			},
			{
				"name": "Few",
				"salience": 0.005309066,
				"type": "PERSON"
			},
			{
				"name": "seats",
				"salience": 0.0051764147,
				"type": "OTHER"
			},
			{
				"name": "league",
				"salience": 0.004474654,
				"type": "ORGANIZATION"
			},
			{
				"name": "game",
				"salience": 0.004470157,
				"type": "EVENT"
			},
			{
				"name": "interception",
				"salience": 0.0041930876,
				"type": "OTHER"
			},
			{
				"name": "passes",
				"salience": 0.0041930876,
				"type": "OTHER"
			},
			{
				"name": "passing",
				"salience": 0.0041930876,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0040368303,
				"type": "ORGANIZATION"
			},
			{
				"name": "defeats",
				"salience": 0.0040368303,
				"type": "EVENT"
			},
			{
				"name": "T-shirt",
				"salience": 0.0037918524,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "game",
				"salience": 0.0037918524,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0037918524,
				"type": "OTHER"
			},
			{
				"name": "offense",
				"salience": 0.0036317017,
				"type": "OTHER"
			},
			{
				"name": "touchdown",
				"salience": 0.0036317017,
				"type": "OTHER"
			},
			{
				"name": "carries",
				"salience": 0.0036317017,
				"type": "OTHER"
			},
			{
				"name": "flashes",
				"salience": 0.0036317017,
				"type": "OTHER"
			},
			{
				"name": "anniversary",
				"salience": 0.003586005,
				"type": "EVENT"
			},
			{
				"name": "lead",
				"salience": 0.0034963258,
				"type": "OTHER"
			},
			{
				"name": "survey",
				"salience": 0.0034963258,
				"type": "OTHER"
			},
			{
				"name": "anthem",
				"salience": 0.0034963258,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0034963258,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0269w0y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Levi's_Stadium"
				},
				"name": "Levi's Stadium",
				"salience": 0.0031887498,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07l24",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tampa_Bay_Buccaneers"
				},
				"name": "Tampa Bay Buccaneers",
				"salience": 0.0031887498,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06rny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco_49ers"
				},
				"name": "San Francisco",
				"salience": 0.0031887498,
				"type": "LOCATION"
			},
			{
				"name": "team",
				"salience": 0.003173604,
				"type": "ORGANIZATION"
			},
			{
				"name": "oppression",
				"salience": 0.0031336616,
				"type": "OTHER"
			},
			{
				"name": "tribute",
				"salience": 0.0029655579,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0028336497,
				"type": "OTHER"
			},
			{
				"name": "black",
				"salience": 0.0023909563,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0022159142,
				"type": "OTHER"
			},
			{
				"name": "veterans",
				"salience": 0.0022159142,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0020643226,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.0018639807,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018639807,
				"type": "EVENT"
			},
			{
				"name": "scrambling",
				"salience": 0.0018556593,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05l71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oakland_Raiders"
				},
				"name": "Oakland",
				"salience": 0.0018260039,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.0018092111,
				"type": "EVENT"
			},
			{
				"name": "shirt",
				"salience": 0.0016225288,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.0016141565,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.0016141565,
				"type": "OTHER"
			},
			{
				"name": "shirt",
				"salience": 0.0015423094,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "game",
				"salience": 0.0015423094,
				"type": "EVENT"
			},
			{
				"name": "gift",
				"salience": 0.0015343508,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034ndv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouGov"
				},
				"name": "YouGov",
				"salience": 0.0013642117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059yj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Football_League"
				},
				"name": "NFL",
				"salience": 0.0013642117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027_drs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yahoo!_Sports"
				},
				"name": "Yahoo Sports",
				"salience": 0.0013642117,
				"type": "ORGANIZATION"
			},
			{
				"name": "face",
				"salience": 0.0012059057,
				"type": "OTHER"
			},
			{
				"name": "police shootings",
				"salience": 0.0012059057,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04rqd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MTV"
				},
				"name": "MTV",
				"salience": 0.0007422542,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h353",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_Ali"
				},
				"name": "Muhammad Ali",
				"salience": 0.0007422542,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.0007422542,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01c_d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Buffalo_Bills"
				},
				"name": "Buffalo",
				"salience": 0.0007422542,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.00056347,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:08.112+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "49ers Fans Care More About Victories Than Kaepernick Elliott Almond, Mercury News, October 24, 2016 \nColin Kaepernick’s first home start in a year didn’t stop the pessimism that has left red-jerseyed 49ers’ patrons in a football funk. \nThousands of empty red seats at Levi’s Stadium underscored San Francisco’s freefall that continued unabated Sunday in a 34-17 defeat to the Tampa Bay Buccaneers. \nFew were thinking about Kaepernick’s season-long activism in which he again kneeled during the national anthem to protest oppression against minorities. These days, fans just want to see their team win a game after six consecutive defeats. \n{snip} \nAfter leading the 49ers to a promising 14-0 first-quarter lead, Kaepernick and the offense sputtered. He completed just 16 of 34 passes for 134 yards with one touchdown and one interception. \nKaepernick’s scrambling–he led the team with 84 rushing yards on nine carries–and occasional flashes of accurate downfield passing, weren’t enough, even with the 49ers firmly in the game midway through the fourth quarter. \n{snip} \nKaepernick donned a T-shirt Sunday paying tribute to the Black Panther Party, an Oakland activist group that celebrated its 50th anniversary this weekend. The quarterback said the shirt was a gift from his girlfriend, MTV host Nessa Diab. \nLast week, he wore a shirt with Muhammad Ali’s face before the game at Buffalo. \nKaepernick’s protest against police shootings of unarmed African Americans has been divisive because some say it is disrespectful to veterans. A recent survey by Yahoo Sports and YouGov found that a decline in NFL ratings partially is attributed to the quarterback’s action. \n“I don’t know much about ratings and how they are affected,” he said in a postgame interview. “But I don’t understand why ratings would go down fighting for justice for people, to try to stop oppression, especially in the league that is predominately black.” \n{snip}",
		"thread_title": "49ers Fans Care More About Victories Than Kaepernick",
		"title": "49ers Fans Care More About Victories Than Kaepernick",
		"type": "bs",
		"uuid": "5bbba7278fbae3b346122bef8621c158ad22b1a3"
	},
	"-KhIge-iDuuprY4zDP30": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:09.817+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "migrants",
				"salience": 0.14626598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vqq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_High_Commissioner_for_Refugees"
				},
				"name": "UNHCR",
				"salience": 0.10641978,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mediterranean Hit Record",
				"salience": 0.0916738,
				"type": "LOCATION"
			},
			{
				"name": "UN: Migrant Deaths",
				"salience": 0.0916738,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/049rl0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC_News"
				},
				"name": "BBC News",
				"salience": 0.07969322,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04swx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mediterranean_Sea"
				},
				"name": "Mediterranean Sea",
				"salience": 0.073132426,
				"type": "LOCATION"
			},
			{
				"name": "record",
				"salience": 0.06190261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.038388077,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.029246522,
				"type": "OTHER"
			},
			{
				"name": "boats",
				"salience": 0.029096903,
				"type": "OTHER"
			},
			{
				"name": "route",
				"salience": 0.02744584,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.024835385,
				"type": "EVENT"
			},
			{
				"name": "route",
				"salience": 0.01929098,
				"type": "OTHER"
			},
			{
				"name": "migrant crossings",
				"salience": 0.01872704,
				"type": "LOCATION"
			},
			{
				"name": "drop",
				"salience": 0.01872704,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.018342093,
				"type": "PERSON"
			},
			{
				"name": "agency",
				"salience": 0.015965264,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.015189718,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0137206465,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0110760145,
				"type": "OTHER"
			},
			{
				"name": "Smugglers",
				"salience": 0.009958947,
				"type": "PERSON"
			},
			{
				"name": "ratio",
				"salience": 0.0088874195,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.008280389,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0073257866,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.0073257866,
				"type": "LOCATION"
			},
			{
				"name": "arrivals",
				"salience": 0.006476924,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.006476924,
				"type": "OTHER"
			},
			{
				"name": "comparison",
				"salience": 0.006476924,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.0039888807,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0039888807,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:09.817+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "UN: Migrant Deaths in Mediterranean Hit Record in 2016 BBC News, October 26, 2016 \nAt least 3,800 migrants have died or are missing in the Mediterranean Sea in 2016–the deadliest year on record, the UN refugee agency (UNHCR) has said. \nIt said this was despite a significant drop in migrant crossings compared with 2015, when 3,771 deaths were reported. \nSmugglers were now more often using flimsy boats and putting more people aboard, the UNHCR said. \n{snip} \nThe agency said the most dangerous route had been between Libya and Italy, with one death in every 47 arrivals recorded. \nBy comparison, another–much shorter–route from Turkey to Greece had a ratio of 1 in 88. \n{snip} \nNearly 330,000 people have crossed the Mediterranean Sea this year, compared with more than one million in 2015. \n{snip}",
		"thread_title": "UN: Migrant Deaths in Mediterranean Hit Record in 2016",
		"title": "UN: Migrant Deaths in Mediterranean Hit Record in 2016",
		"type": "bs",
		"uuid": "9c34090da9875678a7010fb00c4239fd4c9569b5"
	},
	"-KhIgeCRH7LsLSPaoQdW": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:10.675+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04g0k_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Geert_Wilders"
				},
				"name": "Geert Wilders",
				"salience": 0.35620677,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Anti-Islam",
				"salience": 0.12143571,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.10042705,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccans",
				"salience": 0.051638793,
				"type": "PERSON"
			},
			{
				"name": "hate speech trial",
				"salience": 0.045018364,
				"type": "EVENT"
			},
			{
				"name": "trial",
				"salience": 0.028399719,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.025245968,
				"type": "LOCATION"
			},
			{
				"name": "elections",
				"salience": 0.024931785,
				"type": "EVENT"
			},
			{
				"name": "travesty",
				"salience": 0.022537882,
				"type": "OTHER"
			},
			{
				"name": "travesty",
				"salience": 0.017197523,
				"type": "EVENT"
			},
			{
				"name": "Snub Hate Speech Trial AFP",
				"salience": 0.012074064,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccans",
				"salience": 0.009868117,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bwzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Rutte"
				},
				"name": "Mark Rutte",
				"salience": 0.007235467,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0069064028,
				"type": "PERSON"
			},
			{
				"name": "Jan Knoops",
				"salience": 0.006822682,
				"type": "PERSON"
			},
			{
				"name": "politician",
				"salience": 0.006107173,
				"type": "PERSON"
			},
			{
				"name": "politician",
				"salience": 0.006107173,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0060095903,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.005290176,
				"type": "LOCATION"
			},
			{
				"name": "defence",
				"salience": 0.0051967585,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0047775223,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.004745177,
				"type": "EVENT"
			},
			{
				"name": "trial",
				"salience": 0.004568383,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.0044084033,
				"type": "OTHER"
			},
			{
				"name": "freedoms",
				"salience": 0.004344177,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.0041380213,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0041380213,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0041380213,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0041380213,
				"type": "ORGANIZATION"
			},
			{
				"name": "charges",
				"salience": 0.0041380213,
				"type": "OTHER"
			},
			{
				"name": "bench",
				"salience": 0.0041380213,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0035731385,
				"type": "EVENT"
			},
			{
				"name": "trial",
				"salience": 0.0035684216,
				"type": "EVENT"
			},
			{
				"name": "neck",
				"salience": 0.0033515578,
				"type": "OTHER"
			},
			{
				"name": "seats",
				"salience": 0.0033515578,
				"type": "OTHER"
			},
			{
				"name": "parliament",
				"salience": 0.0033515578,
				"type": "ORGANIZATION"
			},
			{
				"name": "comment",
				"salience": 0.0033515578,
				"type": "WORK_OF_ART"
			},
			{
				"name": "party",
				"salience": 0.0032266004,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0032266004,
				"type": "WORK_OF_ART"
			},
			{
				"name": "snip",
				"salience": 0.0030307032,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0029026447,
				"type": "EVENT"
			},
			{
				"name": "trial",
				"salience": 0.0028958956,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.0027944,
				"type": "EVENT"
			},
			{
				"name": "politicians",
				"salience": 0.0026149508,
				"type": "PERSON"
			},
			{
				"name": "Fewer",
				"salience": 0.00237004,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.00237004,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00237004,
				"type": "LOCATION"
			},
			{
				"name": "crowd",
				"salience": 0.00237004,
				"type": "PERSON"
			},
			{
				"name": "opinion polls",
				"salience": 0.0023401976,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0021965215,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0020448219,
				"type": "OTHER"
			},
			{
				"name": "judges",
				"salience": 0.0019451003,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.001935065,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qdmf3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberal_Party_(Belgium)"
				},
				"name": "Liberals",
				"salience": 0.001787212,
				"type": "ORGANIZATION"
			},
			{
				"name": "position",
				"salience": 0.0017707752,
				"type": "OTHER"
			},
			{
				"name": "Millions",
				"salience": 0.0017707752,
				"type": "PERSON"
			},
			{
				"name": "intolerance",
				"salience": 0.0017707752,
				"type": "OTHER"
			},
			{
				"name": "lawyers",
				"salience": 0.0017012617,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0016496058,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05c1b5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Party_for_Freedom"
				},
				"name": "Freedom Party",
				"salience": 0.0014320528,
				"type": "ORGANIZATION"
			},
			{
				"name": "Politicians",
				"salience": 0.0014231735,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.0012898078,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0012898078,
				"type": "PERSON"
			},
			{
				"name": "nuisance",
				"salience": 0.0012898078,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.0012898078,
				"type": "OTHER"
			},
			{
				"name": "Judges",
				"salience": 0.0012323871,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0012323871,
				"type": "OTHER"
			},
			{
				"name": "parliament",
				"salience": 0.0011127347,
				"type": "LOCATION"
			},
			{
				"name": "expression",
				"salience": 0.0009635441,
				"type": "OTHER"
			},
			{
				"name": "election campaign",
				"salience": 0.0009635441,
				"type": "EVENT"
			},
			{
				"name": "arguments",
				"salience": 0.0009635441,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0009635441,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07g0_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hague"
				},
				"name": "Hague",
				"salience": 0.00059304404,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:10.675+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Dutch Anti-Islam MP Wilders to Snub Hate Speech Trial AFP, October 28, 2016 \nDefiant Dutch anti-Islam politician Geert Wilders said Friday he will refuse to attend his hate speech trial next week, dubbing it a travesty aimed at silencing him as the country prepares for 2017 elections. \nThe trial opens on Monday before a three-judge bench with the far-right politician facing charges of insulting a racial group and inciting racial hatred for comments he made about Moroccans living in the Netherlands. \n“It is my right and my duty as a politician to speak about the problems in our country,” Wilders said in a statement Friday, dubbing the case “a political trial, in which I refuse to cooperate”. \nIt comes as opinion polls have shown his far-right Freedom Party (PVV) doing well ahead of March elections. \nAfter riding high amid the migrant crisis, the party is now polling neck-and-neck with Prime Minister Mark Rutte’s Liberals each predicted to win between 25 to 29 seats in the 150-seat parliament. \nSet to last until November 25, the trial focuses on a comment made at a March 2014 rally when Wilders asked supporters if they wanted “fewer or more Moroccans in your city and in the Netherlands?” \nWhen the crowd shouted back “Fewer! Fewer!” Wilders answered: “We’re going to organise that.” \n{snip} \nWilders said Friday he would leave his defence in the hands of his lawyer Geert-Jan Knoops and instead “go to work” in the parliament in The Hague. \n{snip} \nJudges earlier this month dismissed arguments by Wilders’ lawyers that the trial was “politically motivated” adding they did not believe it will impact the PVV’s election campaign. \nPoliticians “are granted broad freedoms of expression because of their official position,” the judges ruled last month. \n“Precisely therefore politicians have an important role to avoid feeding intolerance by making these kind of public statements.” \nWilders hit back Friday saying “it is a travesty that I have to stand trial because I spoke about fewer Moroccans.” \n“Millions of Dutch citizens (43 percent of the population) want fewer Moroccans,” he claimed. \n“Not because they despise all Moroccans or want all Moroccans out of the country, but because they are sick and tired of the nuisance and terror caused by so many Moroccans.” \n{snip}",
		"thread_title": "Dutch Anti-Islam MP Wilders to Snub Hate Speech Trial",
		"title": "Dutch Anti-Islam MP Wilders to Snub Hate Speech Trial",
		"type": "bs",
		"uuid": "8624863792e4c90faaa7eadd7f79775d5a1bb893"
	},
	"-KhIgeRJgry1Gmp1WKxM": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:11.311+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.122885294,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.12141391,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.10217239,
				"type": "PERSON"
			},
			{
				"name": "start",
				"salience": 0.102020465,
				"type": "EVENT"
			},
			{
				"name": "migrants",
				"salience": 0.052680008,
				"type": "PERSON"
			},
			{
				"name": "Colombe Brossel",
				"salience": 0.044843,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.04137905,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.03591083,
				"type": "OTHER"
			},
			{
				"name": "third",
				"salience": 0.03591083,
				"type": "PERSON"
			},
			{
				"name": "Calais Camp",
				"salience": 0.02835755,
				"type": "ORGANIZATION"
			},
			{
				"name": "Migrants Pitch Tents",
				"salience": 0.02835755,
				"type": "OTHER"
			},
			{
				"name": "Paris Streets",
				"salience": 0.025631944,
				"type": "LOCATION"
			},
			{
				"name": "Ingrid Melander",
				"salience": 0.022225231,
				"type": "PERSON"
			},
			{
				"name": "Ama",
				"salience": 0.01806892,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01y3fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jungle"
				},
				"name": "Jungle",
				"salience": 0.016862202,
				"type": "WORK_OF_ART"
			},
			{
				"name": "shanty town",
				"salience": 0.014905615,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.013609276,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.012974497,
				"type": "PERSON"
			},
			{
				"name": "tents",
				"salience": 0.009754254,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06tw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sudan"
				},
				"name": "Sudanese",
				"salience": 0.008723297,
				"type": "PERSON"
			},
			{
				"name": "corner",
				"salience": 0.007632045,
				"type": "LOCATION"
			},
			{
				"name": "canal",
				"salience": 0.007632045,
				"type": "LOCATION"
			},
			{
				"name": "boulevards",
				"salience": 0.007632045,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.007632045,
				"type": "OTHER"
			},
			{
				"name": "tents",
				"salience": 0.006846091,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "presence",
				"salience": 0.0066406606,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0064551886,
				"type": "PERSON"
			},
			{
				"name": "total",
				"salience": 0.005633324,
				"type": "OTHER"
			},
			{
				"name": "base camp",
				"salience": 0.005591279,
				"type": "LOCATION"
			},
			{
				"name": "increase",
				"salience": 0.0055624694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06tw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sudan"
				},
				"name": "Sudan",
				"salience": 0.0054290467,
				"type": "LOCATION"
			},
			{
				"name": "teams",
				"salience": 0.005355197,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.005155631,
				"type": "OTHER"
			},
			{
				"name": "security issues",
				"salience": 0.005155631,
				"type": "OTHER"
			},
			{
				"name": "autumn chill",
				"salience": 0.005155631,
				"type": "OTHER"
			},
			{
				"name": "cardboard",
				"salience": 0.005155631,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.005155631,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.004373153,
				"type": "LOCATION"
			},
			{
				"name": "route",
				"salience": 0.0033944852,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0032848292,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.0030589707,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.003044367,
				"type": "OTHER"
			},
			{
				"name": "city authorities",
				"salience": 0.0030286643,
				"type": "PERSON"
			},
			{
				"name": "Deputy Mayor",
				"salience": 0.0027489562,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0023805683,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0023805683,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.0022746208,
				"type": "LOCATION"
			},
			{
				"name": "shelters",
				"salience": 0.0017785354,
				"type": "LOCATION"
			},
			{
				"name": "channel",
				"salience": 0.0017785354,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.0017785354,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0010947572,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.0010947572,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:11.311+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "More Migrants Pitch Tents on Paris Streets as Calais Camp Shuts Ingrid Melander, Reuters, October 28, 2016 \nThe number of migrants sleeping rough on the streets of Paris has risen by at least a third since the start of the week when the “Jungle” shanty town in Calais was evacuated, officials said on Friday. \nAlong the bustling boulevards and a canal in a northeastern corner of Paris, hundreds of tents have been pitched by migrants–mostly Africans who say they are from Sudan–with cardboard on the ground to try and insulate them from the autumn chill. \nWhile the presence of migrants there is not new, it has grown substantially this week, Colombe Brossel, Paris deputy mayor in charge of security issues, told Reuters. \n“We have seen a big increase since the start of the week. Last night, our teams counted 40 to 50 new tents there in two days,” Brossel said, adding there was now a total of 700 to 750. \nThis means there are some 2,000-2,500 sleeping in the area, up from around 1,500 a few days before, she said. \n{snip} \nAfter years as serving as an illegal base camp for migrants trying to get to Britain, the “Jungle” at Calais was finally bulldozed this week and the more than 6,000 residents of the ramshackle camp near the English channel were relocated to shelters around France. \n{snip} \nAma, a 24-year-old Sudanese who is six months pregnant, said she had come to Paris from Calais, but that was months ago. \n“I was in Calais before but I did not find the route (to Britain),” she said. “I couldn’t stay over there being pregnant, it was too hard.” \nDeputy Mayor Brossel said it was up to the central government, and not city authorities, to act. \n“These people must be sheltered,” she said. \n{snip}",
		"thread_title": "More Migrants Pitch Tents on Paris Streets as Calais Camp Shuts",
		"title": "More Migrants Pitch Tents on Paris Streets as Calais Camp Shuts",
		"type": "bs",
		"uuid": "af1790484d9da0609a0af412e550bfb8008d5263"
	},
	"-KhIgedLtsmodkfdvcmF": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:13.331+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Misao Dean",
				"salience": 0.26804397,
				"type": "PERSON"
			},
			{
				"name": "canoers",
				"salience": 0.11081969,
				"type": "PERSON"
			},
			{
				"name": "canoe",
				"salience": 0.054025065,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.048136722,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02hl32",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBC_Radio"
				},
				"name": "CBC Radio",
				"salience": 0.043287095,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.03380783,
				"type": "OTHER"
			},
			{
				"name": "colonialism",
				"salience": 0.03380783,
				"type": "OTHER"
			},
			{
				"name": "genocide",
				"salience": 0.030567298,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.026514318,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.026514318,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.02417286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wlt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Victoria"
				},
				"name": "University of Victoria",
				"salience": 0.016388815,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.016388815,
				"type": "OTHER"
			},
			{
				"name": "Lukas Mikelionis",
				"salience": 0.016388815,
				"type": "PERSON"
			},
			{
				"name": "Heat Street",
				"salience": 0.016388815,
				"type": "LOCATION"
			},
			{
				"name": "professor",
				"salience": 0.011529553,
				"type": "PERSON"
			},
			{
				"name": "narratives",
				"salience": 0.009959593,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.009420113,
				"type": "OTHER"
			},
			{
				"name": "coincidence",
				"salience": 0.008915946,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.008160973,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.008160973,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.007495607,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0070891785,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.0064884513,
				"type": "OTHER"
			},
			{
				"name": "radio interview",
				"salience": 0.0064884513,
				"type": "WORK_OF_ART"
			},
			{
				"name": "society",
				"salience": 0.0064884513,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0059692445,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.005820067,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.005790086,
				"type": "PERSON"
			},
			{
				"name": "wilderness canoers",
				"salience": 0.0056964187,
				"type": "PERSON"
			},
			{
				"name": "appropriation",
				"salience": 0.0056202086,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.005603245,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.005175524,
				"type": "OTHER"
			},
			{
				"name": "canoe",
				"salience": 0.004956032,
				"type": "OTHER"
			},
			{
				"name": "genocide",
				"salience": 0.00455232,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02b5jh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Justin_Trudeau"
				},
				"name": "Justin Trudeau",
				"salience": 0.00437248,
				"type": "PERSON"
			},
			{
				"name": "canoe",
				"salience": 0.004257439,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.0041475873,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0040619746,
				"type": "OTHER"
			},
			{
				"name": "theft",
				"salience": 0.0039427117,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.0039427117,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fs2zg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jim_Brown_(radio_host)"
				},
				"name": "Jim Brown",
				"salience": 0.00385237,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0037173515,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.003562774,
				"type": "OTHER"
			},
			{
				"name": "canoeing",
				"salience": 0.0035207928,
				"type": "OTHER"
			},
			{
				"name": "canoeing",
				"salience": 0.0035207928,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0032193977,
				"type": "OTHER"
			},
			{
				"name": "canoe",
				"salience": 0.0031018548,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0030761752,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0030761752,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0027776998,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0027776998,
				"type": "OTHER"
			},
			{
				"name": "touch",
				"salience": 0.002405484,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.002405484,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.002405484,
				"type": "ORGANIZATION"
			},
			{
				"name": "canoe",
				"salience": 0.0023176277,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.002086117,
				"type": "OTHER"
			},
			{
				"name": "somebody",
				"salience": 0.002023402,
				"type": "PERSON"
			},
			{
				"name": "symbol",
				"salience": 0.0019333413,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.0019333413,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0017917453,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0017521858,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.0017521858,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadians",
				"salience": 0.0017100942,
				"type": "PERSON"
			},
			{
				"name": "colonialism",
				"salience": 0.0016741881,
				"type": "OTHER"
			},
			{
				"name": "colonialism",
				"salience": 0.0016741881,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01trsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Nations"
				},
				"name": "First Nations",
				"salience": 0.0014808465,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05d8v6f"
				},
				"name": "Sophie",
				"salience": 0.0013898824,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.0013161969,
				"type": "LOCATION"
			},
			{
				"name": "academic",
				"salience": 0.0013089941,
				"type": "PERSON"
			},
			{
				"name": "pic.twitter.com/gm76BwAe4p",
				"salience": 0.0010785497,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:13.331+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Lukas Mikelionis, Heat Street, October 24, 2016 \n{snip} According to Misao Dean, Professor of English at the University of Victoria, the canoe can be a symbol of colonialism, imperialism and genocide due to history. She also accused the canoers of cultural appropriation because they are primarily white men and have a privileged place in society. \nIn a radio interview for CBC Radio , which wasn’t picked up by the Internet until several months later, she claimed “we have a whole set of narratives that make the canoe into a kind of morally untouchable symbol, something that seems natural, that seems ordinary, and seems to promote values that we ascribe to.” \n“But I think if you look a little further that narrative obscures or erases another narrative–and that narrative is about, to be blunt, it’s about theft and genocide”, the professor said. \n{snip} \n“It’s not a coincidence that it was white men of a certain age . . . Certainly the majority of wilderness canoers are people who have a very privileged place in society. They’re frequently highly educated people. They’re almost completely white,” she said. \nCBC Radio host Jim Brown then asked a question: “Should we look at the canoe as a non-controversial symbol or should we look at it as a symbol of colonialism?” \nTo which the academic replied: “Absolutely a symbol of colonialism. It seems to me that this narrative we tell ourselves about the canoe about how canoeing makes us in touch with nature, how canoeing makes us in some way guiltless of the terrible things that the Canadian government and Canadians in general did to First Nations people.” \n{snip} \nEither way, somebody should break the news to Canada’s woke Prime Minister Justin Trudeau about this. It’s 2016, after all. Thrilled to let you know we’re going to need another seat in our canoe: Sophie is pregnant! #threeisthenewtwo pic.twitter.com/gm76BwAe4p",
		"thread_title": "Canoes Reek of Genocide, Theft and White Privilege, Says Canadian Professor",
		"title": "Canoes Reek of Genocide, Theft and White Privilege, Says Canadian Professor",
		"type": "bs",
		"uuid": "feda634378d10c9727e4601ad17622954c6d27bf"
	},
	"-KhIgf_PpAQy9sPQWX5c": {
		"author": "Sacco Vandal",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:39:17.891+03:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0142mv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinese_literature"
				},
				"name": "Chinese",
				"salience": 0.17673363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05jb8w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yan_Fu"
				},
				"name": "Yan Fu",
				"salience": 0.096036,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02bns",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Darwinism"
				},
				"name": "Darwinism",
				"salience": 0.0560693,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0498022,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016m7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pat_Buchanan"
				},
				"name": "Patrick Buchanan",
				"salience": 0.039440382,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "People's Republic of China",
				"salience": 0.036238115,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Westerners",
				"salience": 0.03359577,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.020248763,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.01999245,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.01822531,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.016087692,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.01570358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_qp4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liang_Qichao"
				},
				"name": "Liang Qichao",
				"salience": 0.013774698,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j8pm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Westernization"
				},
				"name": "Westernization",
				"salience": 0.011687742,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nkz9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kang_Youwei"
				},
				"name": "Kang Youwei",
				"salience": 0.011481491,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01kznw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Herbert_Spencer"
				},
				"name": "Herbert Spencer",
				"salience": 0.009181068,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06b9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qing_dynasty"
				},
				"name": "Qing Dynasty",
				"salience": 0.0078021903,
				"type": "ORGANIZATION"
			},
			{
				"name": "Many",
				"salience": 0.006289629,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cm2xh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_I"
				},
				"name": "First World War",
				"salience": 0.006136988,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0056205466,
				"type": "LOCATION"
			},
			{
				"name": "dynamism",
				"salience": 0.004862018,
				"type": "OTHER"
			},
			{
				"name": "literati",
				"salience": 0.004407864,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.004060469,
				"type": "OTHER"
			},
			{
				"name": "True Way",
				"salience": 0.004023965,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0037654506,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0037492958,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0037375332,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles_Darwin"
				},
				"name": "Darwinian",
				"salience": 0.0036952754,
				"type": "LOCATION"
			},
			{
				"name": "faith",
				"salience": 0.0036152988,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0034346047,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.003410961,
				"type": "ORGANIZATION"
			},
			{
				"name": "half",
				"salience": 0.00325579,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0031722235,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.0029607199,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00290661,
				"type": "PERSON"
			},
			{
				"name": "Sources",
				"salience": 0.0027664138,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.002758162,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.00274713,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00274713,
				"type": "LOCATION"
			},
			{
				"name": "dynamism",
				"salience": 0.0025750124,
				"type": "OTHER"
			},
			{
				"name": "countrymen",
				"salience": 0.0024584052,
				"type": "PERSON"
			},
			{
				"name": "Perils of Westernization Sacco Vandal",
				"salience": 0.0024267316,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.0022688336,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0022688336,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0022688336,
				"type": "EVENT"
			},
			{
				"name": "competition",
				"salience": 0.0021979741,
				"type": "OTHER"
			},
			{
				"name": "dilemma",
				"salience": 0.002182031,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.0021657206,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0021642083,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.002013421,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.002013421,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.002013421,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.002013421,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.002012786,
				"type": "PERSON"
			},
			{
				"name": "intellectuals",
				"salience": 0.0020110938,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0020110938,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0020014744,
				"type": "LOCATION"
			},
			{
				"name": "Somewhere",
				"salience": 0.0018600891,
				"type": "LOCATION"
			},
			{
				"name": "everywhere",
				"salience": 0.0018600891,
				"type": "LOCATION"
			},
			{
				"name": "book",
				"salience": 0.0018600891,
				"type": "WORK_OF_ART"
			},
			{
				"name": "men",
				"salience": 0.0018600891,
				"type": "PERSON"
			},
			{
				"name": "American Renaissance",
				"salience": 0.00175295,
				"type": "ORGANIZATION"
			},
			{
				"name": "faith",
				"salience": 0.0016795025,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.0016795025,
				"type": "EVENT"
			},
			{
				"name": "dominance",
				"salience": 0.0016795025,
				"type": "OTHER"
			},
			{
				"name": "superpower",
				"salience": 0.0016795025,
				"type": "OTHER"
			},
			{
				"name": "explorers",
				"salience": 0.0016795025,
				"type": "PERSON"
			},
			{
				"name": "strongest",
				"salience": 0.0016795025,
				"type": "OTHER"
			},
			{
				"name": "inversion",
				"salience": 0.0016720019,
				"type": "OTHER"
			},
			{
				"name": "empires",
				"salience": 0.0015991735,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0015650372,
				"type": "LOCATION"
			},
			{
				"name": "first",
				"salience": 0.0015495212,
				"type": "OTHER"
			},
			{
				"name": "dynamism",
				"salience": 0.0014929018,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.0014841718,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "missionaries",
				"salience": 0.0014543326,
				"type": "PERSON"
			},
			{
				"name": "mankind",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "tones",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "resurgence",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "sole",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "lamentations",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "doom",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "entity",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "enthusiasm",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "corners",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0014543326,
				"type": "EVENT"
			},
			{
				"name": "ascension",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "colonizers",
				"salience": 0.0014543326,
				"type": "PERSON"
			},
			{
				"name": "ancestry",
				"salience": 0.0014543326,
				"type": "OTHER"
			},
			{
				"name": "conquerors",
				"salience": 0.0014543326,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0014543326,
				"type": "PERSON"
			},
			{
				"name": "reformers",
				"salience": 0.0014341522,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.0013061013,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0013061013,
				"type": "OTHER"
			},
			{
				"name": "Westernization",
				"salience": 0.0012972412,
				"type": "OTHER"
			},
			{
				"name": "Westernization",
				"salience": 0.0012972412,
				"type": "OTHER"
			},
			{
				"name": "assertion",
				"salience": 0.0012890757,
				"type": "OTHER"
			},
			{
				"name": "wound",
				"salience": 0.0012890757,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0650q1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Columbia_University_Press"
				},
				"name": "Columbia University Press",
				"salience": 0.001168684,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0011560059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0011466045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05nj0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oswald_Spengler"
				},
				"name": "Oswald Spengler",
				"salience": 0.0011282047,
				"type": "PERSON"
			},
			{
				"name": "claim",
				"salience": 0.0011212367,
				"type": "OTHER"
			},
			{
				"name": "birth",
				"salience": 0.0011002832,
				"type": "EVENT"
			},
			{
				"name": "modernization",
				"salience": 0.0010965632,
				"type": "OTHER"
			},
			{
				"name": "modernization",
				"salience": 0.0010965632,
				"type": "OTHER"
			},
			{
				"name": "modernization",
				"salience": 0.0010965632,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0010600724,
				"type": "OTHER"
			},
			{
				"name": "traditionalism",
				"salience": 0.0010600724,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0010600724,
				"type": "OTHER"
			},
			{
				"name": "dynamism",
				"salience": 0.0010600724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinese_culture"
				},
				"name": "Chinese Tradition",
				"salience": 0.000989045,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0009793163,
				"type": "LOCATION"
			},
			{
				"name": "blessings",
				"salience": 0.0009449558,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.0009137599,
				"type": "OTHER"
			},
			{
				"name": "intellectuals",
				"salience": 0.0009105709,
				"type": "PERSON"
			},
			{
				"name": "reformers",
				"salience": 0.0008802873,
				"type": "PERSON"
			},
			{
				"name": "wisdom",
				"salience": 0.000873948,
				"type": "OTHER"
			},
			{
				"name": "Richard Lufrano",
				"salience": 0.00087138254,
				"type": "PERSON"
			},
			{
				"name": "William Theodore de Bary",
				"salience": 0.00087138254,
				"type": "PERSON"
			},
			{
				"name": "warnings",
				"salience": 0.0008468059,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0008375397,
				"type": "EVENT"
			},
			{
				"name": "democratization",
				"salience": 0.00082877616,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.0008157852,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.0008157852,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.0008157852,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.0008157852,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.0008157852,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.00081576104,
				"type": "OTHER"
			},
			{
				"name": "Westernization",
				"salience": 0.000791077,
				"type": "OTHER"
			},
			{
				"name": "household",
				"salience": 0.00077785074,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.00076879596,
				"type": "OTHER"
			},
			{
				"name": "liberalization",
				"salience": 0.0007656351,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0007656351,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0007475395,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0007432094,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j5xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Sino-Japanese_War"
				},
				"name": "Sino-Japanese War",
				"salience": 0.00073524145,
				"type": "EVENT"
			},
			{
				"name": "program",
				"salience": 0.00072725234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lkfx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Meiji_period"
				},
				"name": "Meiji",
				"salience": 0.00072203897,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0007154613,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0007154613,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0007154613,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0006912761,
				"type": "OTHER"
			},
			{
				"name": "Devastation",
				"salience": 0.0006912761,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0006912761,
				"type": "OTHER"
			},
			{
				"name": "military disadvantage",
				"salience": 0.0006912761,
				"type": "OTHER"
			},
			{
				"name": "backwater",
				"salience": 0.0006912761,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0006912761,
				"type": "OTHER"
			},
			{
				"name": "pragmatism",
				"salience": 0.0006912761,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.00068918505,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00068658567,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0006837113,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0006837113,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0006837113,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.0006800683,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.00066595146,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00066095113,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligentsia",
				"salience": 0.0006547858,
				"type": "PERSON"
			},
			{
				"name": "intellectuals",
				"salience": 0.0006547858,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.0006547858,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00064988853,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.0006472871,
				"type": "LOCATION"
			},
			{
				"name": "progress",
				"salience": 0.0006406203,
				"type": "OTHER"
			},
			{
				"name": "intellectuals",
				"salience": 0.00063033827,
				"type": "PERSON"
			},
			{
				"name": "model",
				"salience": 0.00062759063,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00062457356,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.0006199022,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0006199022,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0006199022,
				"type": "ORGANIZATION"
			},
			{
				"name": "Liang",
				"salience": 0.0006091813,
				"type": "PERSON"
			},
			{
				"name": "industrialization",
				"salience": 0.00060620817,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "barbarians",
				"salience": 0.00059856754,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.00059856754,
				"type": "LOCATION"
			},
			{
				"name": "products",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "abundance",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "treaties",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "tenets",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "might",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "trouble",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "key",
				"salience": 0.00059856754,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.00059856754,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wars",
				"salience": 0.00059856754,
				"type": "EVENT"
			},
			{
				"name": "revolution",
				"salience": 0.0005967569,
				"type": "EVENT"
			},
			{
				"name": "wealth",
				"salience": 0.0005967569,
				"type": "OTHER"
			},
			{
				"name": "superintendent",
				"salience": 0.00059367565,
				"type": "PERSON"
			},
			{
				"name": "ministers",
				"salience": 0.0005792092,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.0005604768,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0005604768,
				"type": "LOCATION"
			},
			{
				"name": "publication",
				"salience": 0.00055933977,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.00055933977,
				"type": "PERSON"
			},
			{
				"name": "scholarship",
				"salience": 0.00055933977,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0005583909,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0005583909,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0005391728,
				"type": "PERSON"
			},
			{
				"name": "minister",
				"salience": 0.00053676387,
				"type": "PERSON"
			},
			{
				"name": "reform movement",
				"salience": 0.00053676387,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.00053676387,
				"type": "OTHER"
			},
			{
				"name": "world history",
				"salience": 0.00053676387,
				"type": "OTHER"
			},
			{
				"name": "emperor",
				"salience": 0.00053676387,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.00053676387,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00053676387,
				"type": "OTHER"
			},
			{
				"name": "prescience",
				"salience": 0.0005355142,
				"type": "OTHER"
			},
			{
				"name": "preservation",
				"salience": 0.0005355142,
				"type": "OTHER"
			},
			{
				"name": "Meiji Reform",
				"salience": 0.00053493737,
				"type": "OTHER"
			},
			{
				"name": "human race",
				"salience": 0.0005345166,
				"type": "EVENT"
			},
			{
				"name": "races",
				"salience": 0.0005345166,
				"type": "EVENT"
			},
			{
				"name": "instances",
				"salience": 0.00052999833,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.00052726176,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0005174709,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.00051672204,
				"type": "EVENT"
			},
			{
				"name": "everywhere",
				"salience": 0.00051672204,
				"type": "LOCATION"
			},
			{
				"name": "evolutionist",
				"salience": 0.00051672204,
				"type": "PERSON"
			},
			{
				"name": "evolution",
				"salience": 0.00051672204,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00051672204,
				"type": "PERSON"
			},
			{
				"name": "evolution",
				"salience": 0.00051672204,
				"type": "OTHER"
			},
			{
				"name": "Writing",
				"salience": 0.00051672204,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00051672204,
				"type": "WORK_OF_ART"
			},
			{
				"name": "origins",
				"salience": 0.00051636103,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00051636103,
				"type": "OTHER"
			},
			{
				"name": "On Strength",
				"salience": 0.00050851697,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0005060392,
				"type": "OTHER"
			},
			{
				"name": "revolution",
				"salience": 0.0005060392,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0005060392,
				"type": "ORGANIZATION"
			},
			{
				"name": "revolutionaries",
				"salience": 0.0005060392,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0005060392,
				"type": "ORGANIZATION"
			},
			{
				"name": "consequence",
				"salience": 0.00050342624,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01pjk7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hundred_Days'_Reform"
				},
				"name": "Hundred Days Reform",
				"salience": 0.00050206395,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.00050001015,
				"type": "OTHER"
			},
			{
				"name": "stress",
				"salience": 0.00049708085,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rjsp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Xinhai_Revolution"
				},
				"name": "1911 Revolution",
				"salience": 0.0004898259,
				"type": "WORK_OF_ART"
			},
			{
				"name": "efforts",
				"salience": 0.00048462898,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00048462898,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.00048462898,
				"type": "OTHER"
			},
			{
				"name": "customs",
				"salience": 0.00048462898,
				"type": "OTHER"
			},
			{
				"name": "customs",
				"salience": 0.00048462898,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.00048462898,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00048462898,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.00048462898,
				"type": "OTHER"
			},
			{
				"name": "World",
				"salience": 0.00048350068,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01ndbr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qianlong_Emperor"
				},
				"name": "Qianlong emperor",
				"salience": 0.00047119634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01k_v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Li_Hongzhang"
				},
				"name": "Li Hongzhang",
				"salience": 0.00047119634,
				"type": "PERSON"
			},
			{
				"name": "modernization",
				"salience": 0.00046878718,
				"type": "OTHER"
			},
			{
				"name": "works",
				"salience": 0.00046653344,
				"type": "WORK_OF_ART"
			},
			{
				"name": "explanation",
				"salience": 0.00046653344,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.00046653344,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00046653344,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00046653344,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00046653344,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00046653344,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.00046653344,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.00046653344,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Confucianism"
				},
				"name": "Confucianism",
				"salience": 0.00045911229,
				"type": "OTHER"
			},
			{
				"name": "Benjamin Schwartz",
				"salience": 0.00045332537,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00045267405,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.00044027326,
				"type": "LOCATION"
			},
			{
				"name": "culture",
				"salience": 0.00043816908,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00043816908,
				"type": "OTHER"
			},
			{
				"name": "Writing",
				"salience": 0.00043816908,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.00043816908,
				"type": "OTHER"
			},
			{
				"name": "shock",
				"salience": 0.00043590655,
				"type": "EVENT"
			},
			{
				"name": "account",
				"salience": 0.00043041207,
				"type": "OTHER"
			},
			{
				"name": "Westernization",
				"salience": 0.00043033296,
				"type": "OTHER"
			},
			{
				"name": "Westernization",
				"salience": 0.00043033296,
				"type": "OTHER"
			},
			{
				"name": "outsider",
				"salience": 0.00042498685,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00042498685,
				"type": "OTHER"
			},
			{
				"name": "West The First World War",
				"salience": 0.00042077288,
				"type": "EVENT"
			},
			{
				"name": "persecution",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.00041962997,
				"type": "EVENT"
			},
			{
				"name": "battle",
				"salience": 0.00041962997,
				"type": "EVENT"
			},
			{
				"name": "descendants",
				"salience": 0.00041962997,
				"type": "PERSON"
			},
			{
				"name": "worry",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"name": "pursuit",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"name": "elimination",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"name": "neighbors",
				"salience": 0.00041962997,
				"type": "PERSON"
			},
			{
				"name": "Majesty",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"name": "appeals",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.00041962997,
				"type": "EVENT"
			},
			{
				"name": "advocates",
				"salience": 0.00041962997,
				"type": "PERSON"
			},
			{
				"name": "protégé",
				"salience": 0.00041962997,
				"type": "PERSON"
			},
			{
				"name": "flurry",
				"salience": 0.00041962997,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.00041878392,
				"type": "LOCATION"
			},
			{
				"name": "scholars",
				"salience": 0.0004150966,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.00040396108,
				"type": "WORK_OF_ART"
			},
			{
				"name": "outlook",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "remedy",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "newspaper essay",
				"salience": 0.00040396108,
				"type": "WORK_OF_ART"
			},
			{
				"name": "orientation",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "claw",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "tooth",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "potentialities",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "fittest",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "actualization",
				"salience": 0.00040396108,
				"type": "EVENT"
			},
			{
				"name": "colleagues",
				"salience": 0.00040396108,
				"type": "PERSON"
			},
			{
				"name": "emphasis",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "astronomy",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "ruthlessness",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "mercy",
				"salience": 0.00040396108,
				"type": "OTHER"
			},
			{
				"name": "fountainhead",
				"salience": 0.00040396108,
				"type": "LOCATION"
			},
			{
				"name": "race",
				"salience": 0.0003992608,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0003992608,
				"type": "OTHER"
			},
			{
				"name": "Statue",
				"salience": 0.0003992608,
				"type": "OTHER"
			},
			{
				"name": "monarchy",
				"salience": 0.0003956091,
				"type": "OTHER"
			},
			{
				"name": "selfishness",
				"salience": 0.0003956091,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.0003956091,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0003956091,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0003956091,
				"type": "PERSON"
			},
			{
				"name": "influence",
				"salience": 0.0003956091,
				"type": "OTHER"
			},
			{
				"name": "backwardness",
				"salience": 0.0003956091,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.0003956091,
				"type": "EVENT"
			},
			{
				"name": "monarchy",
				"salience": 0.0003956091,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.0003956091,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00039422818,
				"type": "OTHER"
			},
			{
				"name": "In Search of Wealth and Power",
				"salience": 0.0003860524,
				"type": "OTHER"
			},
			{
				"name": "nationalism",
				"salience": 0.00037348477,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/043njm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Communist_Party_of_India_(Maoist)"
				},
				"name": "Maoist",
				"salience": 0.0003683688,
				"type": "ORGANIZATION"
			},
			{
				"name": "generation",
				"salience": 0.0003666164,
				"type": "PERSON"
			},
			{
				"name": "carnage",
				"salience": 0.00036037774,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.00035428643,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.00035428643,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00035317353,
				"type": "LOCATION"
			},
			{
				"name": "transformation",
				"salience": 0.00035292676,
				"type": "EVENT"
			},
			{
				"name": "Beiyang Naval School",
				"salience": 0.0003442254,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fallen Civilizations",
				"salience": 0.0003436414,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04m8n6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_University_Press"
				},
				"name": "Harvard University Press",
				"salience": 0.00034308335,
				"type": "ORGANIZATION"
			},
			{
				"name": "corruption",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "traits",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "slaughter",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "attraction",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "fuel",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "shortcomings",
				"salience": 0.00034254804,
				"type": "EVENT"
			},
			{
				"name": "upheaval",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "perturbations",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"name": "shamelessness",
				"salience": 0.00034254804,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01nd77",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guangxu_Emperor"
				},
				"name": "Guangxu emperor",
				"salience": 0.0003303308,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03qq06",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Penguin_Group"
				},
				"name": "Penguin Press",
				"salience": 0.0003295617,
				"type": "ORGANIZATION"
			},
			{
				"name": "instability",
				"salience": 0.00032729039,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.00032729039,
				"type": "PERSON"
			},
			{
				"name": "Thinkers",
				"salience": 0.00032729039,
				"type": "PERSON"
			},
			{
				"name": "path",
				"salience": 0.00032729039,
				"type": "OTHER"
			},
			{
				"name": "liberalism",
				"salience": 0.00032729039,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.00032706172,
				"type": "OTHER"
			},
			{
				"name": "copy",
				"salience": 0.00032560033,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00032560033,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "English",
				"salience": 0.00031799593,
				"type": "OTHER"
			},
			{
				"name": "Sources",
				"salience": 0.0003179036,
				"type": "PERSON"
			},
			{
				"name": "On Stength",
				"salience": 0.00030890293,
				"type": "WORK_OF_ART"
			},
			{
				"name": "civilization",
				"salience": 0.00030374355,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.00030374355,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.00030374355,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.00030374355,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00029978267,
				"type": "OTHER"
			},
			{
				"name": "warnings",
				"salience": 0.00029927146,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rq1n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empress_dowager"
				},
				"name": "Empress Dowager",
				"salience": 0.00029824415,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/043n30s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Post-American_World"
				},
				"name": "The Post-American World",
				"salience": 0.00029754973,
				"type": "WORK_OF_ART"
			},
			{
				"name": "views",
				"salience": 0.00029549905,
				"type": "OTHER"
			},
			{
				"name": "domination",
				"salience": 0.00029549905,
				"type": "OTHER"
			},
			{
				"name": "decadence",
				"salience": 0.00029549905,
				"type": "OTHER"
			},
			{
				"name": "wisdom",
				"salience": 0.00029549905,
				"type": "OTHER"
			},
			{
				"name": "pragmatism",
				"salience": 0.00029549905,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00029549905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06k70y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Martin's_Press"
				},
				"name": "St. Martin's Press",
				"salience": 0.00029290194,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.00028809623,
				"type": "OTHER"
			},
			{
				"name": "Regnery Publishing",
				"salience": 0.00028713263,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0c1t1n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/On_the_Origin_of_Species"
				},
				"name": "The Origin of Species",
				"salience": 0.00028710728,
				"type": "WORK_OF_ART"
			},
			{
				"name": "suit",
				"salience": 0.0002796238,
				"type": "OTHER"
			},
			{
				"name": "Unnecessary War",
				"salience": 0.00027933402,
				"type": "EVENT"
			},
			{
				"name": "editor",
				"salience": 0.00027261866,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j8r1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/May_Fourth_Movement"
				},
				"name": "May Fourth Movement",
				"salience": 0.0002696506,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vk5w1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Culture_Movement"
				},
				"name": "New Cultural Movement",
				"salience": 0.0002696506,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00026300273,
				"type": "LOCATION"
			},
			{
				"name": "Sacco Vandal",
				"salience": 0.00025958137,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06f891",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China%E2%80%93Japan_relations"
				},
				"name": "Sino-Japanese",
				"salience": 0.0002582409,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.0002582409,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7kz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empress_Dowager_Cixi"
				},
				"name": "Empress Dowager Cixi",
				"salience": 0.0002582409,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0002582409,
				"type": "LOCATION"
			},
			{
				"name": "Democracy",
				"salience": 0.00025800255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern Europe",
				"salience": 0.00025763962,
				"type": "LOCATION"
			},
			{
				"name": "caution",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "coauthor",
				"salience": 0.00025586394,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "Non-whites",
				"salience": 0.00025586394,
				"type": "PERSON"
			},
			{
				"name": "invasion",
				"salience": 0.00025586394,
				"type": "EVENT"
			},
			{
				"name": "challenges",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "Lessons",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "heterogeneity",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.00025586394,
				"type": "PERSON"
			},
			{
				"name": "inferiority",
				"salience": 0.00025586394,
				"type": "OTHER"
			},
			{
				"name": "modernization",
				"salience": 0.00025499862,
				"type": "OTHER"
			},
			{
				"name": "modernization",
				"salience": 0.00025499862,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.00025499862,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Newtonian",
				"salience": 0.00024859767,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07d6q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_Henry_Huxley"
				},
				"name": "Thomas Huxley",
				"salience": 0.00024859767,
				"type": "PERSON"
			},
			{
				"name": "traditionalism",
				"salience": 0.00024651035,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01npqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinese_University_of_Hong_Kong"
				},
				"name": "The Chinese University Press",
				"salience": 0.00023999662,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05cm52",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Martin_Jacques"
				},
				"name": "Martin Jacques",
				"salience": 0.0002394872,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03h64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hong_Kong"
				},
				"name": "Hong Kong",
				"salience": 0.0002394872,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0002394872,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01b_fn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mencius"
				},
				"name": "Mencius",
				"salience": 0.0002394872,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.00023567917,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00021994954,
				"type": "PERSON"
			},
			{
				"name": "Hugo House Publishers",
				"salience": 0.00021802634,
				"type": "ORGANIZATION"
			},
			{
				"name": "human race",
				"salience": 0.0002171769,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0002171769,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0002171769,
				"type": "OTHER"
			},
			{
				"name": "chapter",
				"salience": 0.00021519043,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01qh7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cambridge,_Massachusetts"
				},
				"name": "Cambridge",
				"salience": 0.00020967651,
				"type": "LOCATION"
			},
			{
				"name": "Benjamin Schwarz",
				"salience": 0.0002090976,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.00020560507,
				"type": "OTHER"
			},
			{
				"name": "VandalVoid.com",
				"salience": 0.00020141233,
				"type": "OTHER"
			},
			{
				"name": "Modern History Sourcebook: Qianlong: Letter to George III",
				"salience": 0.0001956355,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Internet History Sourcebooks",
				"salience": 0.0001956355,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018_d0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Random_House"
				},
				"name": "Random House",
				"salience": 0.00019377265,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k0mg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Death_of_the_West"
				},
				"name": "The Death of the West",
				"salience": 0.00019377265,
				"type": "WORK_OF_ART"
			},
			{
				"name": "In Search of Wealth and Power",
				"salience": 0.00019316393,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.00019271173,
				"type": "EVENT"
			},
			{
				"name": "concession",
				"salience": 0.00018632635,
				"type": "OTHER"
			},
			{
				"name": "Discos",
				"salience": 0.00018632635,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00018184731,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rpgt_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Athletic_Conference"
				},
				"name": "The American",
				"salience": 0.00018184731,
				"type": "LOCATION"
			},
			{
				"name": "methods",
				"salience": 0.0001780266,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.0001780266,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0001780266,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.00017565959,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.00017207746,
				"type": "LOCATION"
			},
			{
				"name": "half",
				"salience": 0.00016497873,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.00016161801,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/082xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Winston_Churchill"
				},
				"name": "Churchill",
				"salience": 0.00016161801,
				"type": "LOCATION"
			},
			{
				"name": "study",
				"salience": 0.00016073312,
				"type": "OTHER"
			},
			{
				"name": "meantime",
				"salience": 0.00016073312,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00016073312,
				"type": "OTHER"
			},
			{
				"name": "devastation",
				"salience": 0.00016073312,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00016073312,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00016073312,
				"type": "OTHER"
			},
			{
				"name": "First Democrat",
				"salience": 0.00015877147,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05mqyf1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_P._Goldman"
				},
				"name": "David Goldman",
				"salience": 0.00015745536,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0zdnzf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/How_Civilizations_Die"
				},
				"name": "How Civilizations Die",
				"salience": 0.00015745536,
				"type": "ORGANIZATION"
			},
			{
				"name": "Alt-Right",
				"salience": 0.00015745536,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.00015745536,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0df4y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tianjin"
				},
				"name": "Tianjin",
				"salience": 0.00015745536,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/028_0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deng_Xiaoping"
				},
				"name": "Deng Xiaoping",
				"salience": 0.00015745536,
				"type": "PERSON"
			},
			{
				"name": "Larry Kelley",
				"salience": 0.00015745536,
				"type": "PERSON"
			},
			{
				"name": "post-Mao",
				"salience": 0.00015745536,
				"type": "LOCATION"
			},
			{
				"name": "Militant Nationalist Manifesto",
				"salience": 0.00015745536,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austin,_Texas"
				},
				"name": "Austin",
				"salience": 0.00015745536,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02nkg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/W._W._Norton_%26_Company"
				},
				"name": "W.W. Norton & Company",
				"salience": 0.00015745536,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/030tq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Steyn"
				},
				"name": "Mark Steyn",
				"salience": 0.00015745536,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03wc6z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fareed_Zakaria"
				},
				"name": "Fareed Zakaria",
				"salience": 0.00015745536,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01rll",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Confucius"
				},
				"name": "Confucius",
				"salience": 0.00015618208,
				"type": "PERSON"
			},
			{
				"name": "communism",
				"salience": 0.00015018023,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00014828706,
				"type": "OTHER"
			},
			{
				"name": "Panteon Books",
				"salience": 0.00014667254,
				"type": "WORK_OF_ART"
			},
			{
				"name": "course",
				"salience": 0.00014641773,
				"type": "OTHER"
			},
			{
				"name": "thinkers",
				"salience": 0.0001462241,
				"type": "PERSON"
			},
			{
				"name": "enmity",
				"salience": 0.00013917316,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.00013917316,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00013917316,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.00013917316,
				"type": "ORGANIZATION"
			},
			{
				"name": "sentiment",
				"salience": 0.00013917316,
				"type": "OTHER"
			},
			{
				"name": "curiosities",
				"salience": 0.00013917316,
				"type": "OTHER"
			},
			{
				"name": "importation",
				"salience": 0.00013917316,
				"type": "OTHER"
			},
			{
				"name": "alternative",
				"salience": 0.00013917316,
				"type": "OTHER"
			},
			{
				"name": "tyranny",
				"salience": 0.00013917316,
				"type": "EVENT"
			},
			{
				"name": "realm",
				"salience": 0.00013917316,
				"type": "OTHER"
			},
			{
				"name": "teachings",
				"salience": 0.00013917316,
				"type": "OTHER"
			},
			{
				"name": "Chapter 1",
				"salience": 0.00013242464,
				"type": "WORK_OF_ART"
			},
			{
				"name": "The Meaning of Freedom",
				"salience": 0.00013242464,
				"type": "OTHER"
			},
			{
				"name": "The Need for Reforming Institutions",
				"salience": 0.00013242464,
				"type": "WORK_OF_ART"
			},
			{
				"name": "character",
				"salience": 0.00012259133,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.0001186259,
				"type": "OTHER"
			},
			{
				"name": "Renewing the People",
				"salience": 0.00011466167,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Travel Impressions from Europe",
				"salience": 0.00011466167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06zg_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orville_Schell"
				},
				"name": "Orville Schell",
				"salience": 0.00011466167,
				"type": "PERSON"
			},
			{
				"name": "http://www.fordham.edu/halsall/mod/1793Qianlong.asp",
				"salience": 0.00011466167,
				"type": "OTHER"
			},
			{
				"name": "Throes of Reform",
				"salience": 0.00011466167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04xzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mao_Zedong"
				},
				"name": "Mao Zedong",
				"salience": 0.00011279164,
				"type": "PERSON"
			},
			{
				"name": "Max Ko-wu Huang",
				"salience": 0.000108988286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.00009891173,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asian",
				"salience": 0.00008564392,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09w8sc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Japanese_sentiment"
				},
				"name": "anti-Japanese",
				"salience": 0.00008564392,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d_61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palace_of_Versailles"
				},
				"name": "Versailles",
				"salience": 0.00008564392,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet",
				"salience": 0.00008564392,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0clhb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maoism"
				},
				"name": "Maoism",
				"salience": 0.00008564392,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06f32",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taiwan"
				},
				"name": "Taiwan",
				"salience": 0.00008564392,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:39:17.891+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 47.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Posted on October 28, 2016 The Chinese Who Saw the Perils of Westernization Sacco Vandal, American Renaissance, October 28, 2016 They cautioned their countrymen 100 years ago. \nMany Westerners fear the decline of their own society while they foresee Chinese ascension and impending dominance–with alternating tones of fear or enthusiasm. The United States is growing demographically and may remain a viable cultural entity, but the consensus is that Europe faces demographic disaster. China and the West seem to be approaching an inversion of their relationship of just over a century ago, during the late Qing period, when the West was dominant and China was peripheral. [1] \nPatrick Buchanan described the Western dilemma in 2008: \nWhat happened to us? What happened to our world? When the twentieth century opened, the West was everywhere supreme. For four hundred years, explorers, missionaries, conquerors, and colonizers departed from Europe for the four corners of the Earth to erect empires that were to bring the blessings and benefits of Western civilization to all mankind. . . . Whatever became of those men? Somewhere in the last century, Western man suffered a catastrophic loss of faith–in himself, in his civilization, and in the faith that gave it birth. [2] \nAlthough the United States remains the strongest–but not the sole–superpower, European peoples are in decline everywhere. In another book, Mr. Buchanan points out that “In 1960, people of European ancestry were one-fourth of the world’s population; in 2000, they were one-sixth; in 2050, they will be one-tenth. These are the statistics of a vanishing race.” [3] Mr. Buchanan is hardly the first to warn of impending doom for the West. The lamentations of Oswald Spengler (1880–1936) are well known. Less known, however, are the Chinese from the same period who dreamed of a resurgence for China and warned of Western decline. These voices from the late Qing Dynasty may now seem prescient. \nSpengler saw the First World War as a sign of the West’s inevitable decline. Many of the Chinese literati who had at first been smitten with the dynamism of the West also came to see the war in the same way: Western civilization was in a state of crisis that would lead to its destruction. Today, Mr. Buchanan also calls the First World War a “mortal wound” that was “inflicted upon our civilization.” [4] Meanwhile, the Chinese, who have resurrected many of the tenets of their traditional civilization after decades of Maoist rule, argue that Western liberalization and democratization are not the True Way by which they will inherit the Earth. As China begins to return to traditional Chinese pragmatism and the West implodes, certain late Qing intellectuals now appear vindicated. Devastation after WWI. \nFirst among them were Yan Fu (1854–1921) and Liang Qichao (1873–1929). The dynamism of the West at first impressed them, leading them to promote Westernization in China. However, by the end of their lives, both men had come to see the dynamism of the West as self-destructive. They exhorted China to take a middle path between traditionalism and modernization, hoping that this might by the key to supplanting the West. \nChina in trouble \nIn the latter half of the 19th century, China was at a technological and military disadvantage. It lost a series of wars with Western powers and was forced to accept unequal treaties. This led various ministers of the Qing Dynasty, such as Li Hongzhang (1823–1901) to advocate mild forms of modernization. Meanwhile, the Meiji government in Japan had started an ambitious effort of full-scale Westernization beginning in 1868. And in 1895, after Japan defeated China in the Sino-Japanese War, it became obvious to most Chinese intellectuals that their nation’s program of limited modernization was not enough. \nUntil the mid 19th century, Europe had been an inconsequential backwater for China. As late as 1793, a British attempt to establish a greater amount of trade with the Qing was rebuffed with the assertion by the Qianlong emperor (1711–1799) that China “possesses all things in prolific abundance and lacks no products within its own borders,” and thus had “no need to import the manufactures of outside barbarians.” [5] By the mid 19th century, industrialization had made the West vastly more rich and powerful. However, some Chinese thought the sudden dynamism of the West also had intellectual origins. In the latter half of the nineteenth century, China found itself at the mercy of the Western powers that it once looked down upon. \nDarwin’s dangerous idea \nIn 1895, Yan Fu was superintendent of the Beiyang Naval School. In an explanation of Western civilization to fellow Chinese intellectuals, he focused on the theory of evolution. As a young man, he had studied in England and become familiar with social Darwinism, and came to see it as the cultural fountainhead of wealth and power. “Since the publication of [Darwin’s The Origin of Species ],” wrote Yan, “of which nearly every household in Europe and America now has a copy, there has been a tremendous change in the scholarship, politics, and religion of the West. The claim that the revolution in outlook and intellectual orientation occasioned by Darwin’s book exceeds that of Newtonian astronomy is hardly an empty one.” [6] Yan spent the next ten years translating works on English evolutionist thought by men such as Herbert Spencer (1820–1903) and Thomas Huxley (1825–1895) in the hope of converting his colleagues to social Darwinism. Yan Fu was attracted to social Darwinism while studying in England. \nPerhaps it took an outsider to see the power of evolutionary thought. Darwin’s theory shook Westerners but it also gave them a certain will to power. Herbert Spencer, who coined the term “survival of the fittest,” led the transformation of Darwinism into social Darwinism, which called upon Western man to glorify victory in social competition. Victory in competition was the purpose of all life everywhere. \nYan quickly saw the winning-at-all-costs ruthlessness of social Darwinism as a remedy for China. Writing in his work on Yan’s life, Benjamin Schwartz writes: \nWhat interests [Yan] is not so much the Darwinian account of biological evolution qua science. It is precisely the stress on the values of struggle–assertive energy, the emphasis on the actualization of potentialities within a competitive situation. The image of ‘nature red in tooth and claw’ does not depress him. It exhilarates him. [7] \nYan nevertheless worried that it might be too late for China to adopt social Darwinism, and that his country would be overwhelmed by the nations that had. In a 1895 newspaper essay, “On Strength,” he wrote: \nMonths and years slip by, and with rapacious neighbors all around, I fear that we will be too late, that we will follow Poland and India, providing an example of Darwin’s [elimination] before we have been able to implement Spencer’s methods. . . . Alas, our individual lives are not worth the worry, but what of our descendants, and the 400,000,000 of our race? [8] \nThe battle for reform \nAfter defeat in the Sino-Japanese war, many Chinese intellectuals, such as Yan, began to advocate full-scale Westernization. Japan had already adopted social Darwinism in its pursuit of Western wealth and power, and the Chinese intelligentsia began to believe that China should follow suit. In 1898, the Guangxu emperor (1871–1908) appointed the minister Kang Youwei (1858–1927) to head a reform movement after Kang had requested permission to imitate Japan: \nAs to the republican governments of the United States and France and the constitutional governments of Britain and Germany, these countries are far away and their customs are different from ours. Their changes occurred a long time ago and can no longer be traced. Consequently I beg Your Majesty. . . to take the Meiji Reform of Japan as the model for our reform. The time and place of Japan’s reform are not remote and her religion and customs are somewhat similar to ours. Her success is manifest; her example can easily be followed. [9] \nThe emperor agreed, and the minister initiated a flurry of Meiji-style reform. A bright young man named Liang Qichao worked with Kang as his protégé, and he became one of the most influential Chinese advocates for Westernization. However, Kang and Liang’s efforts were quickly aborted after an imperial coup under the Empress Dowager Cixi (1835–1908). Liang Qichao \nAfter the Empress Dowager cut short what later became known as the Hundred Days Reform, Kang and Liang escaped political persecution by fleeing to Japan. Once there, Kang continued to support the Qing dynasty and to justify an agenda for Chinese reform via cautious appeals to Confucianism. Liang, however, ultimately broke with Kang and–like Yan–began to espouse “a new view of world history strongly colored by social Darwinism: a struggle for survival among nations and races.” [10] \nHe wrote: \nIf we wish to make our nation strong, we must investigate extensively the methods followed by other nations in becoming independent. We should select the superior points and appropriate them to make up for our own shortcomings. [11] \nLiang increasingly came to see social Darwinism as the fuel of the West’s dynamism, one of the “superior points” that China would do well to “appropriate.” Writing from Japan, he exerted great influence on young Chinese. Together, Yan and Liang instilled in an entire generation of Chinese students a fervent desire for change. But this influence did not bring social Darwinism to China. Instead, it brought the 1911 Revolution, the New Cultural Movement (1915–1921), and the May Fourth Movement of 1919–perturbations that would spin China into over half a century of upheaval. \nAccommodative versus transformative thought \nDespite their attraction to social Darwinism and their sometimes radical calls for reform, Yan and Liang were not revolutionaries. Indeed, although Liang and–especially–Yan attacked various instances of Chinese backwardness, they continued to support the Qing Dynasty, advocating slow transition into a constitutional monarchy based on the British model. Once the 1911 Revolution succeeded, however, Liang grudgingly threw his support behind the new republican government, but Yan continued to support monarchy. \nQuestioning the West \nThe First World War was a shock to reformers who wanted to embrace the West. As the war dragged on, aging reformers such as Yan and Liang became increasingly disillusioned with not only transformative revolution, but Westernization and even the West. Yan wrote that the carnage of the war was a consequence of Western traits: “Such has been the effect on the human race of civilization and science! When I look back on our [Chinese] sacred wisdom and culture, I find that it foresaw this even at that early date. . .” [12] \nYan explained further: \nAs I have grown older and have observed the seven years of republican government in China and the four years of bloody war in Europe–a war such as the world has never known–I have come to feel that [the West’s] progress . . . has lead only to selfishness, slaughter, corruption, and shamelessness. When I look back upon the ways of Confucius and Mencius, I find that they . . . have profoundly benefited the realm. This is not my opinion alone. Many thinking people in the West have gradually come to feel this way. [13] \nLiang wrote that “recently many Western scholars have wanted to import Asian civilization as a corrective to their own,” and, indeed, the latter half of the 20th century saw the importation of philosophical, religious, and cultural curiosities from the East and into the West. In the meantime he stated his goal for China: \nI therefore hope that our dear young people will, first of all, have a sincere purpose of respecting and protecting our civilization; second, that they will apply Western methods to the study of our civilization and discover its true character; third, that they will put our own civilization in order and supplement it with others’ so that it will be transformed and become a new civilization; and fourth, that they will extend this new civilization to the outside world so that it can benefit the whole human race. [14] \nBecause of the devastation of the First World War, these two thinkers who had once promoted modernization and Westernization instead advocated a modernization without Westernization (or at least minimal Westernization). They seemed to believe that the course of the West was not sustainable and that the West could be supplanted by China if it modernized in a way that was compatible with its nature and culture. They seem to have realized that social Darwinism was a false promise, and that the forces it unleashed could destroy the West. \nChina and the West today \nIn the end, China did not follow Japan down the path of Westernization. A burgeoning Chinese nationalism grew up around anti-Japanese sentiment, and this enmity was extended to the West after Japan instead of China was awarded Germany’s Chinese concession at Versailles in 1919. Ultimately, communism on the Soviet model provided the Chinese with an alternative to both Chinese traditionalism and the West. China entered a period of socialist tyranny under Mao Zedong (1893–1976). \nAfter Mao’s death, China began to abandon Maoism. It is still nominally communist, but since the 1980’s, it has followed the example of Hong Kong and Taiwan and has increasingly returned to the teachings of Confucius and Mencius. Chinese now praise Yan and Liang for their wisdom and prescience. The post-Mao leadership of the People’s Republic of China–beginning with Deng Xiaoping–has espoused views nearly identical to those advocated by Liang over a century ago. [15] Statue of Liang Qichao in Tianjin. \nAt the same time, Westerners are now studying the warnings of Yan and Liang about the inherent instability of the West. As Western liberals such as Martin Jacques herald the coming Chinese domination, there may be a generation of European and American scholars who find themselves in a position similar to that of Yan and Liang: struggling to understand why their civilization has fallen behind that of a rival whose inferiority was once taken for granted. \nThus, while China has found its way back to the middle path, balancing its modernization and Westernization with pragmatism, caution, and Confucianism, the West is disintegrating in a chaos of heterogeneity and decadence. The warnings of Spengler have come true, and Patrick Buchanan forecasts the death of the West. Russia and parts of Eastern Europe are trying to save themselves from liberalism and democracy, but success is not guaranteed. \nThinkers in the Alt-Right are wrestling with the question of how to save our own white civilization. The old order is collapsing due to challenges from abroad and the immigrant invasion. Non-whites are chopping up the West the way the West once chopped up China. We are Yan Fu and Liang Qichao. We must forge a plan for the preservation of our race. \n“Sacco Vandal is a founding editor of VandalVoid.com and coauthor of The American Militant Nationalist Manifesto .” See Patrick Buchanan, The Death of the West (New York: St. Martin’s Press, 2002); David Goldman, How Civilizations Die (Washington: Regnery Publishing, 2011); Martin Jacques, When China Rules the World (New York: Penguin Press, 2009); Larry Kelley, Lessons From Fallen Civilizations (Austin: Hugo House Publishers, 2012); Mark Steyn, America Alone (Washington: Regnery Publishing, 2009); and Fareed Zakaria, The Post-American World (New York: W. W. Norton & Company, 2008). Patrick Buchanan, Churchill, Hitler, and the Unnecessary War (New York: Random House, 2008), ix-x. Patrick Buchanan, Death of the West (New York: St. Martin’s Press, 2002), 11-12. Patrick Buchanan, Churchill, Hitler, and the Unnecessary War (New York: Random House, 2008), 502. “Modern History Sourcebook: Qianlong: Letter to George III, 1793” Internet History Sourcebooks, accessed March 20, 2014, http://www.fordham.edu/halsall/mod/1793Qianlong.asp . Yan Fu, “On Stength” in vol. 2 of Sources of Chinese Tradition , edited by William Theodore de Bary and Richard Lufrano (New York: Columbia University Press, 2000), 256. Benjamin Schwartz, In Search of Wealth and Power (Cambridge: Harvard University Press, 1964), 46. Yan Fu, “On Stength” in vol. 2 of Sources of Chinese Tradition , edited by William Theodore de Bary and Richard Lufrano (New York: Columbia University Press, 2000), 258. Kang Youwei, “The Need for Reforming Institutions” in vol. 2 of Sources of Chinese Tradition , edited by William Theodore de Bary and Richard Lufrano (New York: Columbia University Press, 2000), 270. William Theodore de Bary and Richard Lufrano, ed., Sources of Chinese Tradition , vol. 2 (New York: Columbia University Press, 2000), 288. Liang Qichao, “Renewing the People” in vol. 2 of Sources of Chinese Tradition , edited by William Theodore de Bary and Richard Lufrano (New York: Columbia University Press, 2000), 290. Yan Fu, quoted in In Search of Wealth and Power , Benjamin Schwarz (Cambridge: Harvard University Press, 1964), 235. Yan Fu, quoted in In Search of Wealth and Power , Benjamin Schwarz (Cambridge: Harvard University Press, 1964), 235. Liang Qichao, “Travel Impressions from Europe” in vol. 2 of Sources of Chinese Tradition , edited by William Theodore de Bary and Richard Lufrano (New York: Columbia University Press, 2000), 378-379. See Max Ko-wu Huang, The Meaning of Freedom (Hong Kong: The Chinese University Press, 2008), Chapter 1; and Orville Schell, Discos and Democracy: China in the Throes of Reform (New York: Panteon Books, 1988), chapter “Liang Qichao: China’s First Democrat.”",
		"thread_title": "The Chinese Who Saw the Perils of Westernization",
		"title": "The Chinese Who Saw the Perils of Westernization",
		"type": "bs",
		"uuid": "07f932c9278628708ace0d2268b2a8c9019accf7"
	},
	"-KhIgh-tJGmIfG8c2-7A": {
		"author": "AR Staff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T17:58:10.730+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0f3v0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Comanche"
				},
				"name": "Comanche",
				"salience": 0.73523176,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fk39",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lakota_people"
				},
				"name": "Sioux Indians",
				"salience": 0.01187779,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t2k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ulysses_S._Grant"
				},
				"name": "Grant",
				"salience": 0.011783196,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0064730356,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texans",
				"salience": 0.005620749,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05m7ht",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ranald_S._Mackenzie"
				},
				"name": "Ranald S. Mackenzie",
				"salience": 0.0054627983,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0052812262,
				"type": "PERSON"
			},
			{
				"name": "tribe",
				"salience": 0.005070957,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09bb89",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Comanche_Campaign"
				},
				"name": "Comanche War",
				"salience": 0.004542504,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01dh1w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mirabeau_B._Lamar"
				},
				"name": "Mirabeau Buonaparte Lamar",
				"salience": 0.0043618935,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05mph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma"
				},
				"name": "Oklahoma",
				"salience": 0.004276063,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.00421358,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Indians",
				"salience": 0.0041532987,
				"type": "LOCATION"
			},
			{
				"name": "tribes",
				"salience": 0.0038854566,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0037590207,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Indian",
				"salience": 0.003339792,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025sjdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexican_Army"
				},
				"name": "Mexican Army",
				"salience": 0.0033046207,
				"type": "ORGANIZATION"
			},
			{
				"name": "whites",
				"salience": 0.0032343243,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sdncw"
				},
				"name": "Northwest",
				"salience": 0.0032025732,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/022215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas_Ranger_Division"
				},
				"name": "Texas Rangers",
				"salience": 0.0023130262,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0z53k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lawton,_Oklahoma"
				},
				"name": "Lawton",
				"salience": 0.0023045903,
				"type": "LOCATION"
			},
			{
				"name": "Texans",
				"salience": 0.0022059924,
				"type": "PERSON"
			},
			{
				"name": "War",
				"salience": 0.0020585437,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06c5n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic_of_Texas"
				},
				"name": "Republic of Texas",
				"salience": 0.0019731435,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.0018481965,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican Republic",
				"salience": 0.00171539,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0016461036,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.001599575,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0pzgm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Armstrong_Custer"
				},
				"name": "George Custer",
				"salience": 0.001442442,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cl_m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_Tecumseh_Sherman"
				},
				"name": "William T. Sherman",
				"salience": 0.0013972548,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05brcx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fort_Sill"
				},
				"name": "Fort Sill",
				"salience": 0.001390499,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spaniards",
				"salience": 0.0012781607,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.0012668889,
				"type": "LOCATION"
			},
			{
				"name": "girl",
				"salience": 0.0012316903,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0012057078,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0010974314,
				"type": "PERSON"
			},
			{
				"name": "moon",
				"salience": 0.0010795922,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0235bw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Chivington"
				},
				"name": "John Chivington",
				"salience": 0.0010719659,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0009416789,
				"type": "PERSON"
			},
			{
				"name": "John H. Moore",
				"salience": 0.00091417023,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0008990345,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_War"
				},
				"name": "Civil War",
				"salience": 0.0008409195,
				"type": "EVENT"
			},
			{
				"name": "Kohmahts",
				"salience": 0.00078881346,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0007788715,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0007648177,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0007611429,
				"type": "LOCATION"
			},
			{
				"name": "license plate",
				"salience": 0.0007466879,
				"type": "OTHER"
			},
			{
				"name": "Henry W. Karnes",
				"salience": 0.00072506646,
				"type": "PERSON"
			},
			{
				"name": "coin",
				"salience": 0.00071561226,
				"type": "OTHER"
			},
			{
				"name": "raids",
				"salience": 0.0007021069,
				"type": "EVENT"
			},
			{
				"name": "whites",
				"salience": 0.0006892089,
				"type": "PERSON"
			},
			{
				"name": "neighbors",
				"salience": 0.0006802265,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0006746697,
				"type": "PERSON"
			},
			{
				"name": "horses",
				"salience": 0.00062702515,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00062661275,
				"type": "LOCATION"
			},
			{
				"name": "field artillery brigades",
				"salience": 0.000618621,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0005925952,
				"type": "PERSON"
			},
			{
				"name": "guns",
				"salience": 0.0005884898,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "conflict",
				"salience": 0.0005860408,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0005786569,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0005786569,
				"type": "EVENT"
			},
			{
				"name": "posting",
				"salience": 0.0005762785,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ch2qkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lawrie_Tatum"
				},
				"name": "Lawrie Tatum",
				"salience": 0.00057065685,
				"type": "PERSON"
			},
			{
				"name": "horses",
				"salience": 0.00055940374,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00055940374,
				"type": "LOCATION"
			},
			{
				"name": "horse",
				"salience": 0.00055940374,
				"type": "OTHER"
			},
			{
				"name": "horse",
				"salience": 0.00055940374,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.000555939,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0005447652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.0005426062,
				"type": "LOCATION"
			},
			{
				"name": "Edmond J. Davis",
				"salience": 0.0005390605,
				"type": "PERSON"
			},
			{
				"name": "counter",
				"salience": 0.0005388645,
				"type": "OTHER"
			},
			{
				"name": "Quaker Tatum",
				"salience": 0.0005315279,
				"type": "PERSON"
			},
			{
				"name": "farmers",
				"salience": 0.00053110253,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.00052512536,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.00052443123,
				"type": "OTHER"
			},
			{
				"name": "settlements",
				"salience": 0.0005167946,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.0005043608,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0004958388,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00049565313,
				"type": "PERSON"
			},
			{
				"name": "continent",
				"salience": 0.0004928646,
				"type": "LOCATION"
			},
			{
				"name": "light cavalry",
				"salience": 0.0004928646,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0004908922,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.00048092633,
				"type": "PERSON"
			},
			{
				"name": "offshoot",
				"salience": 0.0004761284,
				"type": "EVENT"
			},
			{
				"name": "mountain northwest",
				"salience": 0.00046661333,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.00046661333,
				"type": "LOCATION"
			},
			{
				"name": "buffalo",
				"salience": 0.00046661333,
				"type": "OTHER"
			},
			{
				"name": "buffalo",
				"salience": 0.00046661333,
				"type": "OTHER"
			},
			{
				"name": "plains",
				"salience": 0.00046661333,
				"type": "LOCATION"
			},
			{
				"name": "plains",
				"salience": 0.00046661333,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.0004655384,
				"type": "PERSON"
			},
			{
				"name": "races",
				"salience": 0.0004583552,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.00045092517,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09gn1dz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Linnville,_Calhoun_County,_Texas"
				},
				"name": "Linnville",
				"salience": 0.00044989996,
				"type": "LOCATION"
			},
			{
				"name": "tribe",
				"salience": 0.00043991065,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cfrp2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army_Field_Artillery_School"
				},
				"name": "Field Artillery School",
				"salience": 0.000439731,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.00043736288,
				"type": "PERSON"
			},
			{
				"name": "panhandle",
				"salience": 0.00043736288,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.00043736288,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.00043736288,
				"type": "OTHER"
			},
			{
				"name": "captives",
				"salience": 0.00043510893,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01624k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle_of_San_Jacinto"
				},
				"name": "Battle of San Jacinto",
				"salience": 0.00042815163,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02k87p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bureau_of_Indian_Affairs"
				},
				"name": "Office of Indian Affairs",
				"salience": 0.00042464124,
				"type": "ORGANIZATION"
			},
			{
				"name": "captives",
				"salience": 0.0004135879,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.000412337,
				"type": "PERSON"
			},
			{
				"name": "misery",
				"salience": 0.00040709,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00040709,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.00040709,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.00040709,
				"type": "OTHER"
			},
			{
				"name": "prairie",
				"salience": 0.00040404577,
				"type": "LOCATION"
			},
			{
				"name": "game",
				"salience": 0.00040404577,
				"type": "WORK_OF_ART"
			},
			{
				"name": "remains",
				"salience": 0.00040404577,
				"type": "OTHER"
			},
			{
				"name": "circumstances",
				"salience": 0.00040404577,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.00040404577,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00040404577,
				"type": "EVENT"
			},
			{
				"name": "game",
				"salience": 0.00040404577,
				"type": "OTHER"
			},
			{
				"name": "Fort Sill Reservation",
				"salience": 0.00039705937,
				"type": "ORGANIZATION"
			},
			{
				"name": "first",
				"salience": 0.00039260776,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0003886906,
				"type": "OTHER"
			},
			{
				"name": "Comanche Duncan Hengest",
				"salience": 0.0003807667,
				"type": "LOCATION"
			},
			{
				"name": "American Renaissance",
				"salience": 0.0003807667,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighters",
				"salience": 0.0003766858,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.00037368544,
				"type": "LOCATION"
			},
			{
				"name": "San Antonio Council House",
				"salience": 0.00037090527,
				"type": "ORGANIZATION"
			},
			{
				"name": "Eastern New Mexico",
				"salience": 0.00036733964,
				"type": "LOCATION"
			},
			{
				"name": "planes",
				"salience": 0.0003648086,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0003648086,
				"type": "PERSON"
			},
			{
				"name": "grasslands",
				"salience": 0.0003648086,
				"type": "LOCATION"
			},
			{
				"name": "cultures",
				"salience": 0.0003648086,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.0003648086,
				"type": "OTHER"
			},
			{
				"name": "herds",
				"salience": 0.0003648086,
				"type": "OTHER"
			},
			{
				"name": "diet",
				"salience": 0.0003648086,
				"type": "OTHER"
			},
			{
				"name": "stranger",
				"salience": 0.0003648086,
				"type": "PERSON"
			},
			{
				"name": "Everywhere",
				"salience": 0.0003648086,
				"type": "LOCATION"
			},
			{
				"name": "language",
				"salience": 0.0003648086,
				"type": "OTHER"
			},
			{
				"name": "crew cannon",
				"salience": 0.0003648086,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "diet",
				"salience": 0.0003648086,
				"type": "OTHER"
			},
			{
				"name": "thumbs",
				"salience": 0.00036317893,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gr2tk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/T._R._Fehrenbach"
				},
				"name": "T.R Fehrenbach",
				"salience": 0.0003598876,
				"type": "PERSON"
			},
			{
				"name": "villages",
				"salience": 0.00034595633,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.00034312924,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00033536117,
				"type": "PERSON"
			},
			{
				"name": "attackers",
				"salience": 0.00033466046,
				"type": "PERSON"
			},
			{
				"name": "census",
				"salience": 0.00033232648,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05mph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma"
				},
				"name": "Oklahoma",
				"salience": 0.00033166585,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.00032538417,
				"type": "PERSON"
			},
			{
				"name": "raids",
				"salience": 0.0003232582,
				"type": "EVENT"
			},
			{
				"name": "raiding",
				"salience": 0.0003232582,
				"type": "EVENT"
			},
			{
				"name": "raiders",
				"salience": 0.0003232582,
				"type": "OTHER"
			},
			{
				"name": "remnants",
				"salience": 0.00031588762,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.00031588762,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.00031588762,
				"type": "OTHER"
			},
			{
				"name": "cashier",
				"salience": 0.00031588762,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00031588762,
				"type": "LOCATION"
			},
			{
				"name": "economy",
				"salience": 0.00031588762,
				"type": "OTHER"
			},
			{
				"name": "ride",
				"salience": 0.00031588762,
				"type": "EVENT"
			},
			{
				"name": "car",
				"salience": 0.00031588762,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "person",
				"salience": 0.00031588762,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.00031588762,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.00031588762,
				"type": "OTHER"
			},
			{
				"name": "conquest",
				"salience": 0.00031588762,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Westerns",
				"salience": 0.00030334803,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lgb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_frontier"
				},
				"name": "Wild West",
				"salience": 0.00030334803,
				"type": "OTHER"
			},
			{
				"name": "raids",
				"salience": 0.0002995716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02n_3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stand_Watie"
				},
				"name": "Stand Watie",
				"salience": 0.00029733145,
				"type": "PERSON"
			},
			{
				"name": "license plates",
				"salience": 0.00029405463,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "whites",
				"salience": 0.00028368447,
				"type": "PERSON"
			},
			{
				"name": "piracy",
				"salience": 0.00027998578,
				"type": "OTHER"
			},
			{
				"name": "captives",
				"salience": 0.00027913883,
				"type": "PERSON"
			},
			{
				"name": "pennies",
				"salience": 0.0002747527,
				"type": "OTHER"
			},
			{
				"name": "lords",
				"salience": 0.0002747527,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.000272063,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00026732963,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.00026517556,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.00026172234,
				"type": "ORGANIZATION"
			},
			{
				"name": "horse",
				"salience": 0.00025807976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexicans",
				"salience": 0.00025657116,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01npch",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kiowa"
				},
				"name": "Kiowa",
				"salience": 0.00025579674,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02n_2g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Department_of_Motor_Vehicles"
				},
				"name": "DMV",
				"salience": 0.0002537455,
				"type": "ORGANIZATION"
			},
			{
				"name": "alliance",
				"salience": 0.00025271508,
				"type": "ORGANIZATION"
			},
			{
				"name": "west",
				"salience": 0.00025002673,
				"type": "OTHER"
			},
			{
				"name": "Attacks",
				"salience": 0.00024844403,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00024785197,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/043q0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jefferson_Davis"
				},
				"name": "Jefferson Davis",
				"salience": 0.00024599038,
				"type": "PERSON"
			},
			{
				"name": "villages",
				"salience": 0.00024563965,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.00024563965,
				"type": "ORGANIZATION"
			},
			{
				"name": "men",
				"salience": 0.00024563965,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00024563965,
				"type": "PERSON"
			},
			{
				"name": "raiders",
				"salience": 0.00024454945,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.000244284,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.00024404612,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.000238165,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.000238165,
				"type": "ORGANIZATION"
			},
			{
				"name": "race war",
				"salience": 0.00023559076,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00023559076,
				"type": "EVENT"
			},
			{
				"name": "diseases",
				"salience": 0.0002329871,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00023023815,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00023023815,
				"type": "PERSON"
			},
			{
				"name": "horse",
				"salience": 0.00023023815,
				"type": "OTHER"
			},
			{
				"name": "Comanche: A History",
				"salience": 0.00022741978,
				"type": "WORK_OF_ART"
			},
			{
				"name": "whites",
				"salience": 0.00022717941,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0002267945,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0002267945,
				"type": "EVENT"
			},
			{
				"name": "reprisal raids",
				"salience": 0.00022662891,
				"type": "EVENT"
			},
			{
				"name": "raids",
				"salience": 0.00022662891,
				"type": "EVENT"
			},
			{
				"name": "raids",
				"salience": 0.00022662891,
				"type": "EVENT"
			},
			{
				"name": "raid",
				"salience": 0.00022662891,
				"type": "EVENT"
			},
			{
				"name": "detachment",
				"salience": 0.00022545208,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North American",
				"salience": 0.0002245213,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.00022331192,
				"type": "OTHER"
			},
			{
				"name": "braves",
				"salience": 0.00022186514,
				"type": "PERSON"
			},
			{
				"name": "tribes",
				"salience": 0.00022178203,
				"type": "PERSON"
			},
			{
				"name": "tribe",
				"salience": 0.00022178203,
				"type": "PERSON"
			},
			{
				"name": "revenge raids",
				"salience": 0.00021816717,
				"type": "EVENT"
			},
			{
				"name": "raiding",
				"salience": 0.00021816717,
				"type": "OTHER"
			},
			{
				"name": "raiders",
				"salience": 0.00021816717,
				"type": "PERSON"
			},
			{
				"name": "raids",
				"salience": 0.00021816717,
				"type": "EVENT"
			},
			{
				"name": "Part",
				"salience": 0.00021518354,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00021414904,
				"type": "PERSON"
			},
			{
				"name": "treaty",
				"salience": 0.00021340157,
				"type": "OTHER"
			},
			{
				"name": "chiefs",
				"salience": 0.00021269593,
				"type": "PERSON"
			},
			{
				"name": "settlements",
				"salience": 0.00021269593,
				"type": "OTHER"
			},
			{
				"name": "chiefs",
				"salience": 0.00021269593,
				"type": "PERSON"
			},
			{
				"name": "settlements",
				"salience": 0.00021269593,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.00021254734,
				"type": "PERSON"
			},
			{
				"name": "ability",
				"salience": 0.0002114499,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.00021117029,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01v1r2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas_Panhandle"
				},
				"name": "Texas Panhandle",
				"salience": 0.00021074271,
				"type": "LOCATION"
			},
			{
				"name": "fire",
				"salience": 0.00020958902,
				"type": "OTHER"
			},
			{
				"name": "Raiders",
				"salience": 0.00020343377,
				"type": "PERSON"
			},
			{
				"name": "treaty",
				"salience": 0.00020284428,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.00020284428,
				"type": "OTHER"
			},
			{
				"name": "peace treaty",
				"salience": 0.00020284428,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.00020284428,
				"type": "OTHER"
			},
			{
				"name": "farmhouses",
				"salience": 0.00020284428,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0001981322,
				"type": "PERSON"
			},
			{
				"name": "militia",
				"salience": 0.00019785545,
				"type": "PERSON"
			},
			{
				"name": "Texans",
				"salience": 0.00019578151,
				"type": "PERSON"
			},
			{
				"name": "raiding",
				"salience": 0.0001946305,
				"type": "EVENT"
			},
			{
				"name": "Public Health Service Indian Hospital",
				"salience": 0.00019440931,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07jcrb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ute_people"
				},
				"name": "Ute",
				"salience": 0.00019440931,
				"type": "OTHER"
			},
			{
				"name": "Numunuh",
				"salience": 0.00019440931,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03s5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idaho"
				},
				"name": "Idaho",
				"salience": 0.00019440931,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02nk7_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shoshone"
				},
				"name": "Shoshone",
				"salience": 0.00019440931,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.00019231772,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00019231772,
				"type": "EVENT"
			},
			{
				"name": "plains",
				"salience": 0.00019203735,
				"type": "LOCATION"
			},
			{
				"name": "moon",
				"salience": 0.00019203735,
				"type": "LOCATION"
			},
			{
				"name": "captives",
				"salience": 0.00019203735,
				"type": "PERSON"
			},
			{
				"name": "moon",
				"salience": 0.00019203735,
				"type": "LOCATION"
			},
			{
				"name": "captives",
				"salience": 0.00019203735,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0001914564,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00019073425,
				"type": "ORGANIZATION"
			},
			{
				"name": "affairs",
				"salience": 0.0001899407,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0001893661,
				"type": "PERSON"
			},
			{
				"name": "bows",
				"salience": 0.00018895997,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "others",
				"salience": 0.00018895997,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.00018794808,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.00018715988,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.00018715988,
				"type": "PERSON"
			},
			{
				"name": "skin",
				"salience": 0.00018626009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05h33q6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Comanchero_Motorcycle_Club"
				},
				"name": "Comancheros",
				"salience": 0.0001856473,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fbfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reconstruction_Era"
				},
				"name": "Reconstruction",
				"salience": 0.00018438387,
				"type": "WORK_OF_ART"
			},
			{
				"name": "village",
				"salience": 0.00018117148,
				"type": "LOCATION"
			},
			{
				"name": "scale",
				"salience": 0.0001799961,
				"type": "OTHER"
			},
			{
				"name": "traders",
				"salience": 0.0001799961,
				"type": "PERSON"
			},
			{
				"name": "band",
				"salience": 0.0001799961,
				"type": "OTHER"
			},
			{
				"name": "republic",
				"salience": 0.0001799961,
				"type": "ORGANIZATION"
			},
			{
				"name": "meeting",
				"salience": 0.00017850423,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.00017510769,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00017510769,
				"type": "ORGANIZATION"
			},
			{
				"name": "treachery",
				"salience": 0.00017420351,
				"type": "EVENT"
			},
			{
				"name": "villages",
				"salience": 0.00017220838,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.00017220838,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.00017220838,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.00017220838,
				"type": "LOCATION"
			},
			{
				"name": "waxing",
				"salience": 0.00017183903,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00017125791,
				"type": "OTHER"
			},
			{
				"name": "militia",
				"salience": 0.00016991896,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0001685693,
				"type": "ORGANIZATION"
			},
			{
				"name": "cavalry",
				"salience": 0.00016769888,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00016727143,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.00016702757,
				"type": "LOCATION"
			},
			{
				"name": "conflict",
				"salience": 0.00016696783,
				"type": "EVENT"
			},
			{
				"name": "policy",
				"salience": 0.00016696783,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00016696783,
				"type": "OTHER"
			},
			{
				"name": "raiding parties",
				"salience": 0.00016696783,
				"type": "ORGANIZATION"
			},
			{
				"name": "People",
				"salience": 0.00016696783,
				"type": "PERSON"
			},
			{
				"name": "alliance",
				"salience": 0.00016628127,
				"type": "ORGANIZATION"
			},
			{
				"name": "lands",
				"salience": 0.00016628127,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.00016628127,
				"type": "ORGANIZATION"
			},
			{
				"name": "ground",
				"salience": 0.00016577824,
				"type": "OTHER"
			},
			{
				"name": "supplies",
				"salience": 0.00016572449,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "man",
				"salience": 0.00016572449,
				"type": "PERSON"
			},
			{
				"name": "raids",
				"salience": 0.00016504242,
				"type": "EVENT"
			},
			{
				"name": "Whites",
				"salience": 0.00016235079,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.00016141027,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.00016141027,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.00016141027,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.00016141027,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.00016141027,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.00016141027,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.00016141027,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.00016141027,
				"type": "LOCATION"
			},
			{
				"name": "parts",
				"salience": 0.00016073333,
				"type": "LOCATION"
			},
			{
				"name": "conflict",
				"salience": 0.00016073333,
				"type": "EVENT"
			},
			{
				"name": "parts",
				"salience": 0.00016073333,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.00016073333,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0001602338,
				"type": "OTHER"
			},
			{
				"name": "cattle",
				"salience": 0.0001602338,
				"type": "OTHER"
			},
			{
				"name": "secret",
				"salience": 0.00015996057,
				"type": "OTHER"
			},
			{
				"name": "Lipan Indian",
				"salience": 0.00015959617,
				"type": "PERSON"
			},
			{
				"name": "agent",
				"salience": 0.0001587641,
				"type": "PERSON"
			},
			{
				"name": "lead",
				"salience": 0.0001579443,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00015670685,
				"type": "OTHER"
			},
			{
				"name": "tribes",
				"salience": 0.00015548164,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00015548164,
				"type": "PERSON"
			},
			{
				"name": "tribes",
				"salience": 0.00015548164,
				"type": "PERSON"
			},
			{
				"name": "horses",
				"salience": 0.00015538324,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00015538324,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.00015538324,
				"type": "LOCATION"
			},
			{
				"name": "range",
				"salience": 0.00015538324,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00015538324,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.00015538324,
				"type": "EVENT"
			},
			{
				"name": "defeat",
				"salience": 0.0001545809,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06c5n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic_of_Texas"
				},
				"name": "Texan",
				"salience": 0.00015414353,
				"type": "LOCATION"
			},
			{
				"name": "slaughter",
				"salience": 0.00015357936,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00015294272,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.00015169269,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fjy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Mexico"
				},
				"name": "New Mexico",
				"salience": 0.00015117199,
				"type": "LOCATION"
			},
			{
				"name": "targets",
				"salience": 0.00015013016,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00015013016,
				"type": "OTHER"
			},
			{
				"name": "goodwill",
				"salience": 0.00015013016,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.00015013016,
				"type": "EVENT"
			},
			{
				"name": "goods",
				"salience": 0.00015013016,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.00015013016,
				"type": "PERSON"
			},
			{
				"name": "grassland",
				"salience": 0.00015013016,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.00015013016,
				"type": "EVENT"
			},
			{
				"name": "relations",
				"salience": 0.00015013016,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.00015013016,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.00015013016,
				"type": "OTHER"
			},
			{
				"name": "languages",
				"salience": 0.00015013016,
				"type": "OTHER"
			},
			{
				"name": "militia",
				"salience": 0.00014967597,
				"type": "PERSON"
			},
			{
				"name": "inland tribes",
				"salience": 0.00014967597,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.00014945936,
				"type": "PERSON"
			},
			{
				"name": "reservations",
				"salience": 0.00014911138,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00014911138,
				"type": "EVENT"
			},
			{
				"name": "settlements",
				"salience": 0.00014911138,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00014848707,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00014848707,
				"type": "ORGANIZATION"
			},
			{
				"name": "occupation government",
				"salience": 0.00014848707,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00014848707,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00014848707,
				"type": "ORGANIZATION"
			},
			{
				"name": "whites",
				"salience": 0.00014668387,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02176xn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ranger,_Texas"
				},
				"name": "Ranger",
				"salience": 0.00014663688,
				"type": "PERSON"
			},
			{
				"name": "infantry",
				"salience": 0.00014387853,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00014365268,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00014365268,
				"type": "EVENT"
			},
			{
				"name": "chiefs",
				"salience": 0.00014354354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025t7ly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quakers"
				},
				"name": "Society of Friends",
				"salience": 0.00014305678,
				"type": "ORGANIZATION"
			},
			{
				"name": "newcomers",
				"salience": 0.0001429463,
				"type": "PERSON"
			},
			{
				"name": "cavalry",
				"salience": 0.00014220443,
				"type": "OTHER"
			},
			{
				"name": "post-Civil War",
				"salience": 0.00013957328,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.00013957328,
				"type": "EVENT"
			},
			{
				"name": "raiding",
				"salience": 0.00013818766,
				"type": "EVENT"
			},
			{
				"name": "raiding",
				"salience": 0.00013818766,
				"type": "EVENT"
			},
			{
				"name": "raids",
				"salience": 0.00013818766,
				"type": "EVENT"
			},
			{
				"name": "raids",
				"salience": 0.00013818766,
				"type": "EVENT"
			},
			{
				"name": "center",
				"salience": 0.00013689445,
				"type": "LOCATION"
			},
			{
				"name": "parts",
				"salience": 0.00013629768,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.00013629768,
				"type": "EVENT"
			},
			{
				"name": "sanctuary",
				"salience": 0.00013573721,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.00013462777,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00013462777,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.00013462777,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00013444858,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.00013275383,
				"type": "PERSON"
			},
			{
				"name": "east",
				"salience": 0.00013176084,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00013176084,
				"type": "LOCATION"
			},
			{
				"name": "war parties",
				"salience": 0.00013120823,
				"type": "ORGANIZATION"
			},
			{
				"name": "source",
				"salience": 0.0001305774,
				"type": "PERSON"
			},
			{
				"name": "niche",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "dread",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "gesture",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.00012999396,
				"type": "EVENT"
			},
			{
				"name": "manner",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "nose",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "beatings",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "courthouse",
				"salience": 0.00012999396,
				"type": "LOCATION"
			},
			{
				"name": "boundary",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "feet",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "youngsters",
				"salience": 0.00012999396,
				"type": "PERSON"
			},
			{
				"name": "demand",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "stealth",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "military precision",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.00012999396,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00012893145,
				"type": "OTHER"
			},
			{
				"name": "chiefs",
				"salience": 0.00012805652,
				"type": "PERSON"
			},
			{
				"name": "slaughter",
				"salience": 0.00012779671,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0001269211,
				"type": "LOCATION"
			},
			{
				"name": "pressure",
				"salience": 0.0001269211,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/010bdw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Victoria,_Texas"
				},
				"name": "Victoria",
				"salience": 0.00012628002,
				"type": "PERSON"
			},
			{
				"name": "generations",
				"salience": 0.00012618581,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.00012618581,
				"type": "OTHER"
			},
			{
				"name": "bands",
				"salience": 0.00012618581,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.00012618581,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00012513988,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/058mx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minutemen"
				},
				"name": "Minutemen",
				"salience": 0.00012488756,
				"type": "ORGANIZATION"
			},
			{
				"name": "fence",
				"salience": 0.00012356247,
				"type": "OTHER"
			},
			{
				"name": "killing",
				"salience": 0.0001226382,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00012234668,
				"type": "PERSON"
			},
			{
				"name": "forts",
				"salience": 0.00012172086,
				"type": "LOCATION"
			},
			{
				"name": "frontier",
				"salience": 0.00012172086,
				"type": "OTHER"
			},
			{
				"name": "settlers",
				"salience": 0.00012172086,
				"type": "PERSON"
			},
			{
				"name": "frontier",
				"salience": 0.00012172086,
				"type": "LOCATION"
			},
			{
				"name": "actions",
				"salience": 0.00012172086,
				"type": "OTHER"
			},
			{
				"name": "fortresses",
				"salience": 0.00012172086,
				"type": "LOCATION"
			},
			{
				"name": "settlers",
				"salience": 0.00012172086,
				"type": "PERSON"
			},
			{
				"name": "frontier",
				"salience": 0.00012172086,
				"type": "OTHER"
			},
			{
				"name": "frontier",
				"salience": 0.00012172086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f25y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Santa_Fe,_New_Mexico"
				},
				"name": "Santa Fe",
				"salience": 0.00012167386,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.00012147391,
				"type": "OTHER"
			},
			{
				"name": "city fighting",
				"salience": 0.00012147391,
				"type": "EVENT"
			},
			{
				"name": "rifles",
				"salience": 0.00012147391,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "threat",
				"salience": 0.00012147391,
				"type": "OTHER"
			},
			{
				"name": "slaughter",
				"salience": 0.00012147391,
				"type": "OTHER"
			},
			{
				"name": "slaughter",
				"salience": 0.00012147391,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.000121267825,
				"type": "PERSON"
			},
			{
				"name": "regulars",
				"salience": 0.000119686476,
				"type": "PERSON"
			},
			{
				"name": "shore",
				"salience": 0.000119686476,
				"type": "LOCATION"
			},
			{
				"name": "ambush",
				"salience": 0.0001165706,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.0001165706,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0001165706,
				"type": "EVENT"
			},
			{
				"name": "tactics",
				"salience": 0.0001165706,
				"type": "OTHER"
			},
			{
				"name": "ambush detachment",
				"salience": 0.0001165706,
				"type": "OTHER"
			},
			{
				"name": "ambush detachment",
				"salience": 0.0001165706,
				"type": "EVENT"
			},
			{
				"name": "sanctuary",
				"salience": 0.0001165706,
				"type": "LOCATION"
			},
			{
				"name": "warfare",
				"salience": 0.0001165706,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0001165706,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/010bdw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Victoria,_Texas"
				},
				"name": "Victoria",
				"salience": 0.000116335556,
				"type": "LOCATION"
			},
			{
				"name": "control",
				"salience": 0.00011608251,
				"type": "OTHER"
			},
			{
				"name": "south",
				"salience": 0.00011608251,
				"type": "LOCATION"
			},
			{
				"name": "insult",
				"salience": 0.00011596865,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0001153112,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07hyk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Theodore_Roosevelt"
				},
				"name": "T.R.",
				"salience": 0.00011495342,
				"type": "PERSON"
			},
			{
				"name": "delegation",
				"salience": 0.00011306343,
				"type": "PERSON"
			},
			{
				"name": "body",
				"salience": 0.00011306343,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00011268105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01s47p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spanish_Empire"
				},
				"name": "Spanish Empire",
				"salience": 0.00011267532,
				"type": "LOCATION"
			},
			{
				"name": "welfare",
				"salience": 0.0001122177,
				"type": "OTHER"
			},
			{
				"name": "council house killings",
				"salience": 0.0001122177,
				"type": "EVENT"
			},
			{
				"name": "army",
				"salience": 0.00011091195,
				"type": "ORGANIZATION"
			},
			{
				"name": "offence",
				"salience": 0.000110725734,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.000110725734,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00010989749,
				"type": "LOCATION"
			},
			{
				"name": "plains",
				"salience": 0.00010989749,
				"type": "LOCATION"
			},
			{
				"name": "hand",
				"salience": 0.000109406436,
				"type": "OTHER"
			},
			{
				"name": "offending",
				"salience": 0.000109329994,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.000107625245,
				"type": "PERSON"
			},
			{
				"name": "coast",
				"salience": 0.00010659107,
				"type": "LOCATION"
			},
			{
				"name": "frontier",
				"salience": 0.000105867715,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.00010575591,
				"type": "ORGANIZATION"
			},
			{
				"name": "buffalo hunts",
				"salience": 0.00010524744,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.00010524744,
				"type": "ORGANIZATION"
			},
			{
				"name": "movements",
				"salience": 0.00010524744,
				"type": "OTHER"
			},
			{
				"name": "savages",
				"salience": 0.00010524744,
				"type": "OTHER"
			},
			{
				"name": "strategies",
				"salience": 0.00010524744,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.00010524744,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.00010524744,
				"type": "EVENT"
			},
			{
				"name": "men",
				"salience": 0.000105002386,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.000105002386,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.000105002386,
				"type": "ORGANIZATION"
			},
			{
				"name": "men",
				"salience": 0.000105002386,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.00010409826,
				"type": "EVENT"
			},
			{
				"name": "Things",
				"salience": 0.00010399341,
				"type": "OTHER"
			},
			{
				"name": "traders",
				"salience": 0.0001030061,
				"type": "PERSON"
			},
			{
				"name": "expense",
				"salience": 0.0001030061,
				"type": "OTHER"
			},
			{
				"name": "defensive",
				"salience": 0.0001030061,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0001030061,
				"type": "OTHER"
			},
			{
				"name": "sentimentalists",
				"salience": 0.0001030061,
				"type": "PERSON"
			},
			{
				"name": "firepower",
				"salience": 0.0001030061,
				"type": "OTHER"
			},
			{
				"name": "expense",
				"salience": 0.0001030061,
				"type": "OTHER"
			},
			{
				"name": "lever-action rifles",
				"salience": 0.0001030061,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "form",
				"salience": 0.0001030061,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.0001030061,
				"type": "OTHER"
			},
			{
				"name": "panhandle",
				"salience": 0.0001030061,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.0001030061,
				"type": "EVENT"
			},
			{
				"name": "policy",
				"salience": 0.00010180681,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00010180681,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00010180681,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.00010131732,
				"type": "LOCATION"
			},
			{
				"name": "losses",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "shooters",
				"salience": 0.00010131732,
				"type": "PERSON"
			},
			{
				"name": "stages",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.00010131732,
				"type": "PERSON"
			},
			{
				"name": "enemy",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "revenge",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "savagery",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.00010131732,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.00010131732,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0222bq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quanah_Parker"
				},
				"name": "Quanah Parker",
				"salience": 0.00010108209,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d3178",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Comanchero"
				},
				"name": "Comanchero",
				"salience": 0.000100983954,
				"type": "PERSON"
			},
			{
				"name": "herds",
				"salience": 0.000100660836,
				"type": "OTHER"
			},
			{
				"name": "raids",
				"salience": 0.00010063274,
				"type": "EVENT"
			},
			{
				"name": "effect",
				"salience": 0.00010011011,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00010011011,
				"type": "EVENT"
			},
			{
				"name": "status",
				"salience": 0.00009841793,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00009841793,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.00009841793,
				"type": "LOCATION"
			},
			{
				"name": "mistake",
				"salience": 0.00009753394,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.00009709813,
				"type": "OTHER"
			},
			{
				"name": "Agent",
				"salience": 0.000096177115,
				"type": "PERSON"
			},
			{
				"name": "difference",
				"salience": 0.00009587415,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00009587415,
				"type": "OTHER"
			},
			{
				"name": "welfare",
				"salience": 0.00009515699,
				"type": "OTHER"
			},
			{
				"name": "prairies",
				"salience": 0.00009515699,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.00009515699,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.00009515699,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0kn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(country)"
				},
				"name": "Georgian",
				"salience": 0.00009512917,
				"type": "LOCATION"
			},
			{
				"name": "settler militia",
				"salience": 0.00009480281,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00009434544,
				"type": "OTHER"
			},
			{
				"name": "lever-action rifles",
				"salience": 0.00009425356,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "weapons",
				"salience": 0.00009389183,
				"type": "OTHER"
			},
			{
				"name": "band",
				"salience": 0.00009306544,
				"type": "OTHER"
			},
			{
				"name": "Karnes",
				"salience": 0.00009239002,
				"type": "LOCATION"
			},
			{
				"name": "Eastern Kansas",
				"salience": 0.00009239002,
				"type": "LOCATION"
			},
			{
				"name": "ingredient",
				"salience": 0.000092294016,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.000092294016,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0msd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calhoun_County,_Texas"
				},
				"name": "Calhoun County",
				"salience": 0.0000921105,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.00009113059,
				"type": "LOCATION"
			},
			{
				"name": "scouts",
				"salience": 0.00009113059,
				"type": "PERSON"
			},
			{
				"name": "torch",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "crime watches",
				"salience": 0.00009113059,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "challenges",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "tragedy",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "command",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "opponent",
				"salience": 0.00009113059,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.00009113059,
				"type": "PERSON"
			},
			{
				"name": "desolation",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "prey",
				"salience": 0.00009113059,
				"type": "PERSON"
			},
			{
				"name": "masacreing",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "inhabitants",
				"salience": 0.00009113059,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.00009113059,
				"type": "LOCATION"
			},
			{
				"name": "seasons",
				"salience": 0.00009113059,
				"type": "OTHER"
			},
			{
				"name": "colonists",
				"salience": 0.00009091841,
				"type": "PERSON"
			},
			{
				"name": "frontier",
				"salience": 0.00009091841,
				"type": "LOCATION"
			},
			{
				"name": "carpetbag elite",
				"salience": 0.000090385714,
				"type": "PERSON"
			},
			{
				"name": "arrows",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.000087727574,
				"type": "PERSON"
			},
			{
				"name": "lances",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "gunfire",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "seeds",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "revolvers",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "incomprehension",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "wrath",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.000087727574,
				"type": "LOCATION"
			},
			{
				"name": "antagonists",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "burden",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "ships",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "reach",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "loot",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "mobility",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "myriad",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "successes",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "disappointments",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.000087727574,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/023ry6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/7th_Cavalry_Regiment"
				},
				"name": "7th Cavalry",
				"salience": 0.00008751227,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.000086747255,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.000086706765,
				"type": "LOCATION"
			},
			{
				"name": "line",
				"salience": 0.00008662171,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00008632875,
				"type": "EVENT"
			},
			{
				"name": "homesteaders",
				"salience": 0.00008591368,
				"type": "PERSON"
			},
			{
				"name": "torture",
				"salience": 0.00008591368,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.00008591368,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.00008591368,
				"type": "PERSON"
			},
			{
				"name": "cavalry regiment",
				"salience": 0.00008591368,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.00008591368,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.00008591368,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.00008591368,
				"type": "OTHER"
			},
			{
				"name": "assimilation program",
				"salience": 0.00008591368,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.000085529784,
				"type": "OTHER"
			},
			{
				"name": "chiefs",
				"salience": 0.000085330634,
				"type": "PERSON"
			},
			{
				"name": "trial",
				"salience": 0.00008483068,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.000084692336,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.000084166,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gbjz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sam_Houston"
				},
				"name": "Sam Houston",
				"salience": 0.00008284938,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00008257058,
				"type": "PERSON"
			},
			{
				"name": "sentiment",
				"salience": 0.00008094413,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.00008076908,
				"type": "ORGANIZATION"
			},
			{
				"name": "East",
				"salience": 0.000080338636,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.00008024883,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fk3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sioux"
				},
				"name": "Sioux",
				"salience": 0.00008011131,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_5cg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apache"
				},
				"name": "Apache",
				"salience": 0.00007999761,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gw52",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pawnee_people"
				},
				"name": "Pawnee",
				"salience": 0.00007999761,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/060wq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pueblo,_Colorado"
				},
				"name": "Pueblo",
				"salience": 0.00007999761,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.00007999761,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.00007999761,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02rpgv1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle_of_Plum_Creek"
				},
				"name": "Battle of Plum Creek",
				"salience": 0.00007975558,
				"type": "EVENT"
			},
			{
				"name": "Whites",
				"salience": 0.00007878238,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.00007861339,
				"type": "OTHER"
			},
			{
				"name": "panic",
				"salience": 0.000078262114,
				"type": "EVENT"
			},
			{
				"name": "job",
				"salience": 0.000078262114,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00007813926,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00007813926,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00007813926,
				"type": "EVENT"
			},
			{
				"name": "policy",
				"salience": 0.00007799743,
				"type": "OTHER"
			},
			{
				"name": "wagon convoy",
				"salience": 0.00007762241,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00007701421,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000076939206,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.000076939206,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.000076939206,
				"type": "EVENT"
			},
			{
				"name": "scalpings",
				"salience": 0.000076939206,
				"type": "OTHER"
			},
			{
				"name": "braves",
				"salience": 0.000076939206,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.000076939206,
				"type": "OTHER"
			},
			{
				"name": "sentences",
				"salience": 0.000076939206,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.000076939206,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.00007664392,
				"type": "OTHER"
			},
			{
				"name": "villages",
				"salience": 0.00007646546,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.00007646546,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.00007646546,
				"type": "ORGANIZATION"
			},
			{
				"name": "escape route",
				"salience": 0.00007630144,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.000076123775,
				"type": "OTHER"
			},
			{
				"name": "militia",
				"salience": 0.00007544879,
				"type": "PERSON"
			},
			{
				"name": "production",
				"salience": 0.0000753396,
				"type": "EVENT"
			},
			{
				"name": "denomination",
				"salience": 0.00007485142,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "fury",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "cholera epidemic",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.000074389885,
				"type": "EVENT"
			},
			{
				"name": "ways",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "haciendas",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "plunder",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "plague",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "balance",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "properties",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "twist",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "geopolitics",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "annexation",
				"salience": 0.000074389885,
				"type": "EVENT"
			},
			{
				"name": "most",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "depopulation",
				"salience": 0.000074389885,
				"type": "OTHER"
			},
			{
				"name": "peace policy",
				"salience": 0.00007413829,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00007413829,
				"type": "PERSON"
			},
			{
				"name": "peace policy",
				"salience": 0.00007413829,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00007413829,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.00007413829,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00007413829,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.00007413829,
				"type": "EVENT"
			},
			{
				"name": "forces",
				"salience": 0.00007413829,
				"type": "OTHER"
			},
			{
				"name": "Lipans",
				"salience": 0.00007352854,
				"type": "PERSON"
			},
			{
				"name": "Soldiers",
				"salience": 0.0000732299,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00007167036,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00007167036,
				"type": "PERSON"
			},
			{
				"name": "horses",
				"salience": 0.00007167036,
				"type": "OTHER"
			},
			{
				"name": "horses",
				"salience": 0.00007167036,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00007167036,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ztn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cavalry"
				},
				"name": "Cavalry",
				"salience": 0.000071436196,
				"type": "ORGANIZATION"
			},
			{
				"name": "killing",
				"salience": 0.00007107626,
				"type": "EVENT"
			},
			{
				"name": "welfare handouts",
				"salience": 0.00007107626,
				"type": "OTHER"
			},
			{
				"name": "affairs",
				"salience": 0.00007107626,
				"type": "OTHER"
			},
			{
				"name": "volunteer army officer",
				"salience": 0.00007107626,
				"type": "PERSON"
			},
			{
				"name": "compunction",
				"salience": 0.00007107626,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.00007107626,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.00007107626,
				"type": "PERSON"
			},
			{
				"name": "posts",
				"salience": 0.00007107626,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0k7ny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South"
				},
				"name": "South",
				"salience": 0.00007027117,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.00006905772,
				"type": "LOCATION"
			},
			{
				"name": "militia",
				"salience": 0.00006903768,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0106l2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado_City,_Texas"
				},
				"name": "Colorado City",
				"salience": 0.00006900947,
				"type": "LOCATION"
			},
			{
				"name": "foray",
				"salience": 0.000068937756,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00006837426,
				"type": "ORGANIZATION"
			},
			{
				"name": "reservation",
				"salience": 0.000066208886,
				"type": "OTHER"
			},
			{
				"name": "reservation",
				"salience": 0.000066208886,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00006596245,
				"type": "PERSON"
			},
			{
				"name": "Plum Creek",
				"salience": 0.00006476812,
				"type": "LOCATION"
			},
			{
				"name": "Set-tank",
				"salience": 0.000064171945,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Help",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.000064171945,
				"type": "LOCATION"
			},
			{
				"name": "Set-tank",
				"salience": 0.000064171945,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "menace",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.000064171945,
				"type": "EVENT"
			},
			{
				"name": "unit",
				"salience": 0.000064171945,
				"type": "ORGANIZATION"
			},
			{
				"name": "offshoot",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"name": "convoy",
				"salience": 0.000064171945,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "death",
				"salience": 0.000064171945,
				"type": "EVENT"
			},
			{
				"name": "wagon wheel",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.000064171945,
				"type": "EVENT"
			},
			{
				"name": "call",
				"salience": 0.000064171945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dbxy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cherokee"
				},
				"name": "Cherokee",
				"salience": 0.00006352546,
				"type": "PERSON"
			},
			{
				"name": "Texas Reconstruction",
				"salience": 0.00006338877,
				"type": "EVENT"
			},
			{
				"name": "weapons",
				"salience": 0.000063363,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0488g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas"
				},
				"name": "Kansas",
				"salience": 0.00006234947,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.00006190836,
				"type": "PERSON"
			},
			{
				"name": "circus",
				"salience": 0.00006181876,
				"type": "EVENT"
			},
			{
				"name": "sanctuary",
				"salience": 0.00006181876,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.000060329192,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.000060329192,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.00005977736,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.00005977736,
				"type": "PERSON"
			},
			{
				"name": "moon",
				"salience": 0.00005977736,
				"type": "LOCATION"
			},
			{
				"name": "trooper",
				"salience": 0.00005977736,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00005977736,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00005977736,
				"type": "PERSON"
			},
			{
				"name": "buffalo",
				"salience": 0.00005977736,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.000059697784,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.000059697784,
				"type": "OTHER"
			},
			{
				"name": "Set-tainte",
				"salience": 0.000059042268,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Lyndon Baines Johnson",
				"salience": 0.000058558344,
				"type": "PERSON"
			},
			{
				"name": "farmers",
				"salience": 0.000058514015,
				"type": "PERSON"
			},
			{
				"name": "pacifism",
				"salience": 0.000058456615,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.000058456615,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mr96",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hutchinson_County,_Texas"
				},
				"name": "Hutchinson County",
				"salience": 0.000058340378,
				"type": "LOCATION"
			},
			{
				"name": "policy",
				"salience": 0.000058258905,
				"type": "OTHER"
			},
			{
				"name": "arrest",
				"salience": 0.00005771971,
				"type": "EVENT"
			},
			{
				"name": "frontier",
				"salience": 0.000057585312,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.000057114605,
				"type": "ORGANIZATION"
			},
			{
				"name": "villages",
				"salience": 0.000057114605,
				"type": "LOCATION"
			},
			{
				"name": "pressure groups",
				"salience": 0.000057114605,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020d5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Confederate_States_of_America"
				},
				"name": "Confederate",
				"salience": 0.000056453664,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.000056319543,
				"type": "EVENT"
			},
			{
				"name": "north",
				"salience": 0.00005610339,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0my9m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caddo_County,_Oklahoma"
				},
				"name": "Caddo",
				"salience": 0.000056080466,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fk48",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle_of_the_Little_Bighorn"
				},
				"name": "Little Big Horn",
				"salience": 0.000056080466,
				"type": "LOCATION"
			},
			{
				"name": "Tonkowa",
				"salience": 0.000056080466,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0000560287,
				"type": "OTHER"
			},
			{
				"name": "supplies",
				"salience": 0.0000560287,
				"type": "OTHER"
			},
			{
				"name": "rifles",
				"salience": 0.0000560287,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "braves",
				"salience": 0.0000560287,
				"type": "PERSON"
			},
			{
				"name": "generations",
				"salience": 0.0000560287,
				"type": "OTHER"
			},
			{
				"name": "trader",
				"salience": 0.0000560287,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colorado",
				"salience": 0.000055949884,
				"type": "LOCATION"
			},
			{
				"name": "ringleaders",
				"salience": 0.00005556426,
				"type": "PERSON"
			},
			{
				"name": "inspection tour",
				"salience": 0.00005556426,
				"type": "EVENT"
			},
			{
				"name": "mountain howitzers",
				"salience": 0.00005556426,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.00005556426,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00005556426,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.00005556426,
				"type": "EVENT"
			},
			{
				"name": "struggle",
				"salience": 0.00005556426,
				"type": "OTHER"
			},
			{
				"name": "Wealth",
				"salience": 0.00005556426,
				"type": "OTHER"
			},
			{
				"name": "aborigines",
				"salience": 0.00005556426,
				"type": "PERSON"
			},
			{
				"name": "reservation rations",
				"salience": 0.00005556426,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.00005556426,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.000055376335,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.000055376335,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.000055376335,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Indian",
				"salience": 0.000054984514,
				"type": "LOCATION"
			},
			{
				"name": "stink",
				"salience": 0.000054172197,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austin,_Texas"
				},
				"name": "Austin",
				"salience": 0.00005398623,
				"type": "LOCATION"
			},
			{
				"name": "tactics",
				"salience": 0.000053766955,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00005360428,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trade_union"
				},
				"name": "Union",
				"salience": 0.00005334414,
				"type": "LOCATION"
			},
			{
				"name": "effect",
				"salience": 0.000053089167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/010bxh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wichita_Falls,_Texas"
				},
				"name": "Wichita Falls",
				"salience": 0.00005286995,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0m8cr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_Coast_of_the_United_States"
				},
				"name": "East Coast",
				"salience": 0.00005286995,
				"type": "LOCATION"
			},
			{
				"name": "outcome",
				"salience": 0.000052149215,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fk55",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cheyenne"
				},
				"name": "Cheyenne",
				"salience": 0.000052007694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt41",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Yankees"
				},
				"name": "Yankees",
				"salience": 0.000052007694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04csc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kit_Carson"
				},
				"name": "Kit Carson",
				"salience": 0.000052007694,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012bd95m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Big_Tree_(war_chief)"
				},
				"name": "Big Tree",
				"salience": 0.000052007694,
				"type": "PERSON"
			},
			{
				"name": "prairie",
				"salience": 0.000051759107,
				"type": "LOCATION"
			},
			{
				"name": "campaigns",
				"salience": 0.000051759107,
				"type": "EVENT"
			},
			{
				"name": "guns",
				"salience": 0.000051759107,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "canyon",
				"salience": 0.000051759107,
				"type": "LOCATION"
			},
			{
				"name": "prison camp",
				"salience": 0.000051759107,
				"type": "LOCATION"
			},
			{
				"name": "canyon",
				"salience": 0.000051759107,
				"type": "OTHER"
			},
			{
				"name": "canyon",
				"salience": 0.000051759107,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.000051759107,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.000051759107,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.000051759107,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00005156645,
				"type": "ORGANIZATION"
			},
			{
				"name": "hunters",
				"salience": 0.000051387786,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02d4rz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dog_Soldiers"
				},
				"name": "Dog Soldiers",
				"salience": 0.000050514867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0585tl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Battle_of_Adobe_Walls"
				},
				"name": "Battle of Adobe Walls",
				"salience": 0.000050514867,
				"type": "EVENT"
			},
			{
				"name": "Agent Tatum",
				"salience": 0.000050514867,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.000049983257,
				"type": "OTHER"
			},
			{
				"name": "band",
				"salience": 0.000049983257,
				"type": "ORGANIZATION"
			},
			{
				"name": "incursions",
				"salience": 0.00004979142,
				"type": "EVENT"
			},
			{
				"name": "group",
				"salience": 0.00004967548,
				"type": "ORGANIZATION"
			},
			{
				"name": "activity",
				"salience": 0.000049453505,
				"type": "OTHER"
			},
			{
				"name": "military action",
				"salience": 0.000049453505,
				"type": "OTHER"
			},
			{
				"name": "reservation",
				"salience": 0.000049453505,
				"type": "OTHER"
			},
			{
				"name": "victories",
				"salience": 0.000049453505,
				"type": "EVENT"
			},
			{
				"name": "reservations",
				"salience": 0.000049453505,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.000049163744,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.000048731436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0lfzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Hawk_War"
				},
				"name": "Blackhawk War",
				"salience": 0.00004808555,
				"type": "EVENT"
			},
			{
				"name": "faith",
				"salience": 0.000047932026,
				"type": "OTHER"
			},
			{
				"name": "farmland",
				"salience": 0.000047162564,
				"type": "OTHER"
			},
			{
				"name": "farmers",
				"salience": 0.000047162564,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.000047162564,
				"type": "OTHER"
			},
			{
				"name": "farming",
				"salience": 0.000047162564,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.000047162564,
				"type": "OTHER"
			},
			{
				"name": "agent",
				"salience": 0.000046973746,
				"type": "PERSON"
			},
			{
				"name": "skins",
				"salience": 0.000046731166,
				"type": "OTHER"
			},
			{
				"name": "wagon wheel",
				"salience": 0.000046731166,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.000046731166,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.000046731166,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.000046731166,
				"type": "OTHER"
			},
			{
				"name": "hostage",
				"salience": 0.000046522346,
				"type": "OTHER"
			},
			{
				"name": "Pro-Indian",
				"salience": 0.000045778183,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fk1z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic"
				},
				"name": "Hispanic",
				"salience": 0.000045778183,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013n60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amarillo,_Texas"
				},
				"name": "Amarillo",
				"salience": 0.000045778183,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fz6v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Gold_Rush"
				},
				"name": "Forty-niners",
				"salience": 0.000045778183,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025x2b6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Hills_Gold_Rush"
				},
				"name": "Gold Rush",
				"salience": 0.000045778183,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02vq8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rio_Grande_Valley"
				},
				"name": "Rio Grande Valley",
				"salience": 0.000045778183,
				"type": "LOCATION"
			},
			{
				"name": "soldier",
				"salience": 0.00004464952,
				"type": "PERSON"
			},
			{
				"name": "agent",
				"salience": 0.00004464952,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.00004464952,
				"type": "PERSON"
			},
			{
				"name": "each other",
				"salience": 0.00004464952,
				"type": "PERSON"
			},
			{
				"name": "desire",
				"salience": 0.000044418943,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.000044418943,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.000044027973,
				"type": "OTHER"
			},
			{
				"name": "incursions",
				"salience": 0.00004385899,
				"type": "EVENT"
			},
			{
				"name": "tales",
				"salience": 0.000043112577,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Things",
				"salience": 0.000042790067,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.000041849496,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.000041849496,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.000041849496,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.000041849496,
				"type": "OTHER"
			},
			{
				"name": "expense",
				"salience": 0.000041849496,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.000041849496,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.000041849496,
				"type": "OTHER"
			},
			{
				"name": "supplies",
				"salience": 0.000041849496,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.000041849496,
				"type": "OTHER"
			},
			{
				"name": "encounter",
				"salience": 0.000041502586,
				"type": "EVENT"
			},
			{
				"name": "whites",
				"salience": 0.000040731793,
				"type": "PERSON"
			},
			{
				"name": "location",
				"salience": 0.000040462797,
				"type": "LOCATION"
			},
			{
				"name": "families",
				"salience": 0.000040462797,
				"type": "PERSON"
			},
			{
				"name": "food stores",
				"salience": 0.000040462797,
				"type": "LOCATION"
			},
			{
				"name": "teepees",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "stake",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "demographics",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "destiny",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "Clashes",
				"salience": 0.000040462797,
				"type": "EVENT"
			},
			{
				"name": "acquiescence",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "elders",
				"salience": 0.000040462797,
				"type": "PERSON"
			},
			{
				"name": "railroads",
				"salience": 0.000040462797,
				"type": "ORGANIZATION"
			},
			{
				"name": "books",
				"salience": 0.000040462797,
				"type": "WORK_OF_ART"
			},
			{
				"name": "movies",
				"salience": 0.000040462797,
				"type": "WORK_OF_ART"
			},
			{
				"name": "high",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "want",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "pardon",
				"salience": 0.000040462797,
				"type": "OTHER"
			},
			{
				"name": "relocation",
				"salience": 0.000039952713,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.000039490096,
				"type": "LOCATION"
			},
			{
				"name": "sentiments",
				"salience": 0.000039277344,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.000038660368,
				"type": "LOCATION"
			},
			{
				"name": "lands",
				"salience": 0.000038660368,
				"type": "LOCATION"
			},
			{
				"name": "circumstances",
				"salience": 0.000038660368,
				"type": "OTHER"
			},
			{
				"name": "government aid",
				"salience": 0.000038293303,
				"type": "OTHER"
			},
			{
				"name": "finances",
				"salience": 0.00003797587,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ancestors",
				"salience": 0.00003797587,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03f2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gatling_gun"
				},
				"name": "Gatling",
				"salience": 0.000037872815,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016hjr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Continental_Army"
				},
				"name": "Continental Army",
				"salience": 0.00003712529,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bn7vp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Second_Battle_of_Adobe_Walls"
				},
				"name": "Second Battle of Adobe Walls",
				"salience": 0.000036785696,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dkwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Plains"
				},
				"name": "Southern Plains",
				"salience": 0.000036785696,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02dr5w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Buffalo_Bisons"
				},
				"name": "buffalo",
				"salience": 0.000036785696,
				"type": "LOCATION"
			},
			{
				"name": "general",
				"salience": 0.000036398567,
				"type": "PERSON"
			},
			{
				"name": "schools",
				"salience": 0.00003490481,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "assignment",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "mistake",
				"salience": 0.00003490481,
				"type": "EVENT"
			},
			{
				"name": "call",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "garrison duty",
				"salience": 0.00003490481,
				"type": "OTHER"
			},
			{
				"name": "survivors",
				"salience": 0.00003490481,
				"type": "PERSON"
			},
			{
				"name": "survivors",
				"salience": 0.00003490481,
				"type": "PERSON"
			},
			{
				"name": "wars",
				"salience": 0.00003490481,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04ykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota"
				},
				"name": "Minnesota",
				"salience": 0.00003419299,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0603p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Puritans"
				},
				"name": "Puritan",
				"salience": 0.00003419299,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/051kv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Methodism"
				},
				"name": "Methodist",
				"salience": 0.00003419299,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jbjh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_the_Interior"
				},
				"name": "Department of the Interior",
				"salience": 0.00003419299,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00003419299,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.00003419299,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.000033916484,
				"type": "LOCATION"
			},
			{
				"name": "menace",
				"salience": 0.00003275948,
				"type": "OTHER"
			},
			{
				"name": "cannon",
				"salience": 0.00003275948,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Cherokee removal",
				"salience": 0.000031796008,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0bm8cs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Militia_(United_States)"
				},
				"name": "Illinois Militia",
				"salience": 0.00003173278,
				"type": "ORGANIZATION"
			},
			{
				"name": "edge",
				"salience": 0.000030608608,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.000030358404,
				"type": "OTHER"
			},
			{
				"name": "instructions",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "grain",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "sums",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "coffee",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "sugar",
				"salience": 0.000030222744,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "blankets",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "inaction",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "piety",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "dress",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "thrift",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "expulsion",
				"salience": 0.000030222744,
				"type": "EVENT"
			},
			{
				"name": "wards",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.000030222744,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.000030222744,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018hmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_United_States"
				},
				"name": "Southerners",
				"salience": 0.000029022685,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ztlw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle_of_Fallen_Timbers"
				},
				"name": "Battle of Fallen Timbers",
				"salience": 0.000027476193,
				"type": "EVENT"
			},
			{
				"name": "mill",
				"salience": 0.000026621774,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "troubles",
				"salience": 0.000024985524,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02cz79",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Llano_Estacado"
				},
				"name": "Llano Estacado",
				"salience": 0.00002489975,
				"type": "LOCATION"
			},
			{
				"name": "deeds",
				"salience": 0.000022862328,
				"type": "OTHER"
			},
			{
				"name": "Great Society",
				"salience": 0.000021479464,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.000021479464,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.000021479464,
				"type": "LOCATION"
			},
			{
				"name": "Sac and Fox Indians",
				"salience": 0.000019566369,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01wb7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Church_(building)"
				},
				"name": "Church",
				"salience": 0.000018598215,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04tgp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mississippi"
				},
				"name": "Mississippi",
				"salience": 0.000018598215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jg8j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trail_of_Tears"
				},
				"name": "Trail of Tears",
				"salience": 0.000018598215,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.000018598215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03x1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iroquois"
				},
				"name": "Iroquois",
				"salience": 0.000018598215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.000018598215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.000018598215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0q76g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Midwestern_United_States"
				},
				"name": "Midwest",
				"salience": 0.000018598215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abraham_Lincoln"
				},
				"name": "Abraham Lincoln",
				"salience": 0.000018598215,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wisconsin",
				"salience": 0.000018598215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02jx5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northern_United_States"
				},
				"name": "Northerners",
				"salience": 0.000014026219,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T17:58:10.730+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 98.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "War With the Comanche Duncan Hengest, American Renaissance, July 2010 \nFort Sill, north of Lawton, Oklahoma, is home to the Army’s Field Artillery School as well as many field artillery brigades. Over the decades, thousands of Americans have learned how to crew cannon there, and I am one of them. A posting to Fort Sill allowed me to explore what remains of the Wild West when I was off duty. I’d always been a fan of Westerns and of the real history of America’s pioneering conquest of the continent, and the Lawton area was and is the center of Comanche territory. \nDuring the early days of the Texas Republic, the Comanche were the world’s best light cavalry. In fact, they were such fantastic fighters that the Spanish never even tried to subdue them, and the Comanche halted the expansion of settlements into the panhandle and northern Texas for nearly 50 years. Yet the Comanche today are a pitiful group, the defeated remnants of a terrible racial conflict. \nEverywhere you go in Lawton, you see obese Indians. In Oklahoma each tribe has its own license plates, so you can tell a person’s tribe by watching him get into his car. (I tried to get a license plate that said “Comanche” but the DMV would not give me one.) Sometimes it seems as though all the Comanche are unhealthy; the white man’s diet does not seem suited to a people adapted to living on game from the North American prairie. When the Comanche get sick they go to the Public Health Service Indian Hospital at the eastern end of Lawton. If you drive by you are likely to see ancient Indians — poor and disheveled — holding out their thumbs for a ride. Their hands tremble. \nIt seems that the Comanche are as badly adapted to the white man’s economy as to his diet. I once watched a heavy Comanche woman slowly pushing pennies towards a white cashier. She carefully slid each coin across the counter as though it was very difficult to part with. \nThe Comanche’s misery is the result of their absolute defeat during a fierce conflict with whites in the 19th Century. The Comanche War, as that conflict has come to be known, was lengthy and cruel. This terrible war that cursed both the Indians and the Americans was largely inherent in their circumstances; different races and cultures, especially aggressive ones, should not try to share the same territory. \nAlways against us \nThe name Comanche is a Spanish corruption of the Ute word Kohmahts , meaning enemy, stranger, or those who are always against us. Like many tribes, the Comanche called themselves simply “the people,” or Numunuh in their own language. They are an offshoot of the Shoshone, who hail from the area of today’s southern Idaho. Sometime during the 1500s, they left the mountain northwest and settled in southwest Oklahoma. There, they acquired horses from the Spanish, and began to dominate the high plains of western Oklahoma, the Texas Panhandle, and Eastern New Mexico. This vast territory was well watered and its grasslands fed the Comanche’s horses, endless herds of buffalo, and other smaller game. With the horse, the Comanche could travel rapidly on the planes, and easily kill buffalo. \nIn the mountain Northwest, the Comanche had been a poor, foot-bound people; with the horse they became lords of the western plains. Their population exploded. There was no census, but estimates of their numbers vary from 10 to 30 thousand. As they grew more powerful, they started raiding their neighbors. They raided the Apache and Pueblo in Arizona and New Mexico, and the Pawnee in Eastern Kansas. They traded with the Spaniards around Santa Fe but also raided settlements in Mexico and Texas. They often took captives in Mexico and ransomed them back to traders in Santa Fe for finished goods. Neither the Spanish Empire nor the Mexican Republic had the means to stop this well-organized piracy. \nDespite constant raiding, some time around 1790 the Comanche made a lasting alliance with the Kiowa. Like the Comanche, the Kiowa had come from the mountain Northwest, moved into the southern plains, and acquired the horse. The Kiowa and Comanche spoke different languages, but lived in a very similar manner. The Kiowa were a much smaller tribe, and perhaps they fitted into a special niche: not worth raiding and too small to be a threat, but useful allies. This alliance between two extremely warlike people held year after year. The two tribes raided together so consistently that Comanche raids were often Comanche-and-Kiowa raids. \nThe Comanche came to the attention of Americans when Texas became free of Mexico. Shortly after independence, in 1838, the new republic signed its first peace treaty with the Comanche — a treaty that was probably doomed from the start. It was made with only one Comanche band, it did not define a boundary between Texas and Comanche lands, and it was never ratified by the Texas Senate. Essentially it required that the Comanche stop attacking whites — a not unreasonable demand — and some Comanche may have intended to abide by it. However, the Republic of Texas was a young, independent state with relatively wealthy white newcomers living in isolated settlements. They were irresistible targets for raiders, and the treaty was soon broken. \nComanche raids were striking examples of military precision and stealth. Raiding parties could number up to 1,500, and could move undetected across the grassland. Attacks on this scale had proven brilliantly successful against traditional Comanche targets: larger villages of mostly unarmed Mexicans or other Indians. These villages had no way to fight off the Comanche or pursue them as they retreated. \nRaiders were most active during the full moon, when they could see at night. The waxing of the moon became a source of dread for Texas whites, who began to call the full moon a “Comanche moon.” When they sacked Texas farmhouses they usually killed the men and captured the youngsters and women. Comanche women often tortured and mutilated older girls and women to make them less attractive. The women also took the lead in torturing men. They might cut the skin off their feet, tie them to a horse, and make them walk behind until they collapsed and were dragged to death. \nBy 1840, just two years after the treaty, relations between whites and Comanche were murderous and getting worse by the day. In March, the Texas government sent Colonel Henry W. Karnes at the head of a group to meet a delegation of Comanche chiefs at the San Antonio Council House. Karnes was charged with recovering Texas captives and trying to improve relations. The Texans estimated that the Comanche held some 200 captives, and promised that their return would be taken as a gesture of goodwill. \nThe meeting went badly. The Comanche arrived with only one of the promised captives, a young girl whose nose had been burned off. She was badly bruised from beatings, and said she had been repeatedly gang-raped. Texan soldiers, who were already angry over the raids and the broken treaty, killed the chiefs outright. Other whites opened fire on the Comanche who were outside the courthouse. \nTo the Comanche, the Council House slaughter was treachery of the lowest sort. What the Texans considered savagery — raiding, torture, and slaughter of captives — were to them the normal practices of war. From this mutual incomprehension, and from the slaughter of the chiefs, the seeds of long-term hatred were planted. The Comanche never forgave the Texans. Throughout the decades they were pillaging Texas, Comanche could have raided Kansas — it was no farther away than many parts of Texas — but they saved their wrath for Texas. \nThe Comanche did not wait long for revenge. In early August they launched a massive attack on the coastal towns of Victoria and Linnville. In Victoria, the local militia, often called “Minutemen,” managed to drive off the attackers. They fired from inside buildings, and the Comanche, unused to city fighting, retreated. At Linnville, the raiders killed some 20 residents; the others survived only by boarding ships and moving just off shore, where they watched as the Comanche burned the town to the ground. Linnville never rebuilt, and the area is now a residential part of Calhoun County. \nLinnville and Victoria are hundreds of miles from the center of Comanche territory in Oklahoma, and the attacks demonstrate the extraordinary reach and mobility the raiders enjoyed. At that time, the Comanche often hunted and camped in territory as far south as Austin. The barbed wire fence had yet to be invented, so there was little to stop them. Indeed, Texans had settled only the eastern and coastal parts of the state, so the coast was well within range of inland tribes. \nThe warfare that began with the council house killings and the revenge raids on Linnville and Victoria lasted until the late 1870s, and this nearly 40-year war can be divided into three stages. The first, which lasted until Texas joined the Union in 1845, pitted the Comanche against locally-organized whites supported by a Texas government that was highly sympathetic to them. The second, from 1845 until 1861, was much like the Cold War in that the federal government contained the Comanche but did not destroy their ability to make war. In the last stage of the conflict, after the Civil War, a vindictive Reconstruction government ignored bloody and repeated Comanche attacks on disarmed whites and supported the Comanche through a myriad of welfare and reform policies. Only after the post-Civil War elite was directly threatened did it take action, permanently ending the Comanche threat in 1879. \nTexans strike back \nImmediately after the great raids on Linnville and Victoria, the Texans called out the militia and assembled Ranger companies, and defeated the retreating Comanche force at the Battle of Plum Creek on August 14, 1840. The Comanche were slowed by the burden of their loot from Linnville, and also faced an enemy that was better armed and organized than their earlier Indian and Mexican antagonists. Since the 1830s, Texas Rangers had carried six-shooter revolvers as well as long rifles. The Comanche were still mostly armed with bows and arrows as well as lances, and usually retreated on their fast horses in the face of sustained gunfire. When the mounted Rangers could catch them, they would ride next to the Indians and inflict terrible losses with their six-shooters. \nAnother important ingredient in subsequent successes against the Comanche was the leadership of the dynamic and aggressive Texas president, Mirabeau Buonaparte Lamar. Lamar was a Georgian who had moved to Texas to escape disappointments in his career and personal life. He fought at the Battle of San Jacinto, where the Mexican Army was defeated and Texas won independence. The Texas constitution allowed for a single presidential term in office, and Lamar was elected to succeed Sam Houston. One of the new president’s first challenges was the Comanche. As he put it, “The fierce and perfidious savages are waging upon our exposed and defenseless inhabitants, an un-provoked and cruel warfare, masacreing [sic] the women and children, and threatening the whole line of our unprotected borders with speedy desolation.” \nAfter the victory at Plum Creek, Lamar began a policy of retaliatory raids on villages in the Comanche sanctuary in the Texas Panhandle and Oklahoma. Colonel John H. Moore, accompanied by Lipan Indian scouts, led the initial foray. The Rangers moved on an area that is now Colorado City, Texas, and the Lipans discovered a village with little security. Moore sent a detachment to cover a likely escape route, and ordered the main body of his command to attack. He caught the Comanche by surprise and killed 50 in the village. The ambush detachment killed another 80 retreating Indians. The killing was somewhat indiscriminate and included women and children. Moore’s tactics of attack and ambush were duplicated by the Rangers, and later, by the US cavalry. \n(Interestingly, this was the same basic plan George Custer used at Little Big Horn in 1876. The difference was that the Sioux village was massive. The Indians also had lever-action rifles and pinned down the ambush detachment while sending a larger force to overwhelm the 7th Cavalry’s main attack. Custer never had a chance.) \nLamar saw the conflict as a race war, and made no secret of his desire to rid the state of all Indian tribes. He probably would have exterminated the Comanche if he could have, but took different measures against less war-like tribes. His administration pointedly sent no aid when diseases swept through Indian territory. He began the process that moved the Cherokee, Caddo, and Tonkowa onto reservations in Oklahoma, but once they were settled peacefully, he never harried them. \nAgainst the Comanche, Lamar developed both defensive and offensive strategies. The Rangers’ ability to defeat large groups prevented the Comanche from forming large raiding parties, and the Minutemen in the Texas settlements — almost like local crime watches — defended against smaller raids. The system was not perfect, but the raids became smaller and less frequent. Rangers also continued to maul Comanche villages. As T. R. Fehrenbach wrote in his definitive Comanche: A History of a People , there were many retaliatory actions “no one bothered to report.” \nPart of the tragedy of the war is that although the Comanche had raided for generations, they had never faced an opponent like the Texans and did not understand them. Spaniards and Mexicans were disorganized prey, and could not mount a full-scale defense. Nor did they have a militia to call out. The Comanche assumed that white men were like themselves, loosely organized bands for whom an offence against one was not an insult to all. Texans saw things differently, and united against what they considered a threat to the entire state. \nUntil they took on the Texans, the Comanche had always been safe from reprisal raids, so for them, the war was over when the raiding party came home. The Texans were different. Months after a raid, they would surprise an offending — or completely innocent — Comanche village and put it to the torch. Also, Comanche movements were limited by the seasons and buffalo hunts, whereas the Texans could campaign any time of year. By the end of Lamar’s administration a generation of Comanche warriors was dead. T.R. Fehrenbach estimates that from 1838 to 1840, a quarter of the braves had been killed, most of them in the actions following the Council House fight. \nWhat saved the Comanche and kept the war alive were larger questions of geopolitics. The Texans were going broke. The country’s finances were unsound, and the Comanche campaign was just one of several conflicts Lamar had to finance. There were constant Mexican incursions, and Lamar even sent troops into Mexico at great expense. The United States was receptive to annexation, so Texas joined the Union in 1845. The expensive Ranger companies were cut back and federal troops took over their job. At first, the Army sent only infantry to forts along the frontier, and they could not stop the Comanche from moving freely over the prairies. Secretary of War Jefferson Davis formed a cavalry regiment to send to Texas, which managed to prevent some raiding. Its efforts were helped by a cholera epidemic the “Forty-niners” brought when they crossed the plains during the Gold Rush. It is estimated that the Comanche population dropped from 20,000 to 12,000 during this time. \nWhites began to push the internal Texas frontier forward. The east and south were settled by then, but the north and west — where Wichita Falls and Amarillo are today — were still raw frontier. With the Comanche more or less under control, white settlers began to fill the empty parts of the state. \nBy 1860, the Comanche were on the defensive — reduced by plague and harried by the US Cavalry. Their final defeat would have been just a matter of time, but the Civil War changed the balance of power. The federal troops left, and Confederate forces went East. The pressure lifted, and midway through the war the Comanche started raiding again. They went back to their old ways of rape, plunder, and torture, but with a new twist. They soon found they could steal Texas cattle and trade them with Comancheros — Hispanic traders in the Rio Grande Valley — for lever-action rifles. The Texans lost the advantage in firepower they had always enjoyed. The Comanche had always been able to get a few modern weapons, but massive industrial production and increasing trade made them much easier to get. \nThe Texas Reconstruction government therefore inherited a new Comanche war that was blowing with a terrible fury, but did not take it seriously. The carpetbag elite was less interested in fighting Indians than in enriching itself at local expense and supporting the newly freed blacks. Things only got worse as the 1860s wore on, and T.R. Fehrenbach writes that by 1870, “long-settled regions were regressing toward depopulation. Only hundreds of settlers were being killed, but meanwhile thousands were deserting the frontier. The panic was very real.” The frontier retreated — an early form of white flight — as farmers left their properties for safer areas. Those who stayed behind turned their haciendas into fortresses. The effect was to hold back growth; the panhandle could not be settled until the 1880s. Lyndon Baines Johnson’s ancestors were among those the Comanche harried. \nEven as the Comanche were murdering white homesteaders, the government attempted a sanctuary, welfare buy-off, faith-based assimilation program that is reminiscent of modern times. During the final Comanche War from 1865 to 1879, Texas whites were disarmed by the Reconstruction government, and prevented by law from retaliatory raiding into Comanche territory. They could do little more than lobby a hostile occupation government for aid — not always to much effect. Pro-Indian liberals in government as well as East Coast sentimentalists even prevented several murderous Indian chiefs from being hanged. Ironically, the attack those chiefs led was the very incident that caused the Army and federal government finally to act decisively. \nMore humane policy \nOne of the causes of federal inaction was a genuine desire to handle Indian troubles in a humane way. East of the Mississippi, Indian wars had been bloody affairs that ended with the Indians absolutely destroyed or confined. If anything, Northerners were slightly more violent than Southerners. Yankees tended to wipe out Indians and remove any survivors to small, out of-the-way reservations. In upstate New York, the Continental Army destroyed more than 40 Iroquois villages and left survivors to starve or seek aid from the British. In 1794 at the Battle of Fallen Timbers, American troops defeated an Indian force and then removed all remaining Indians from Ohio. After victories in the Midwest, whites paid the surviving Indians paltry sums for their land and sent them West with essentially no support. Abraham Lincoln’s sole experience as a soldier was a brief period of garrison duty with the Illinois Militia in the otherwise bloody Blackhawk War, in which the Sac and Fox Indians were destroyed and forced out of Illinois and Wisconsin. \nIn the South, the Cherokee were the source of the longest-running conflict, and held lands in Georgia long after the northeastern states had destroyed their Indians. As tensions with whites mounted, relocation became the favored solution rather than war and ad hoc expulsion, and was carried out mainly though an admittedly one-sided legal process. Cherokee removal was a relatively peaceful and fair solution to two incompatible peoples living close to each other with a long history of violence. Stand Watie, a Cherokee chief who later became a Confederate general, supported the move from Georgia to Oklahoma, and brought his band West well before the now-notorious “Trail of Tears.” \nIn that context it is understandable that after the Civil War, many pressure groups in the East, no longer threatened by Indians, pushed for more peaceful measures. Also backing the changes was the Office of Indian Affairs, which wanted more control over Indians at the expense of the Army. President Grant therefore tried to treat Indians as wards of government rather than independent nations, and to assimilate and civilize them rather than destroy them. \nIn the past, Indian wars were often sparked when a dishonest Indian Agent stole government aid to the Indians for his own profit, so in 1869, Grant charged religious groups with carrying out his new policy of turning Indians into peaceful farmers. The denomination that got the Comanche assignment was the Society of Friends, or Quakers. Quakers are one of America’s oldest and most influential founding groups. They live a life of piety and thrift, and disavow fancy dress and military action, but it may have been a mistake to pick a group religiously opposed to war in any form. \nPresident Grant’s agent to the Comanche was Lawrie Tatum of Iowa, who had probably never seen an Indian before he answered his Church’s call and headed West. Tatum arrived at Fort Sill in 1869 and enacted a sort of Great Society program. He started schools, gave deeds of farmland to the Comanche with instructions for farming, and established a mill for grinding grain. The Comanche also got free coffee, sugar, and blankets, and lived in safety. Soldiers secured Fort Sill and the agent’s supplies, but did not interfere with Comanche activity or take to the field. Quakers would not use the military to keep the Comanche on their reservation and avoid war. \nTatum worked hard to teach the Comanche to be civilized farmers but was defeated by circumstances. The Comanche culture’s central focus was on warfare and raiding. Wealth and status could only be acquired through war, and Quaker pacifism was too foreign to graft onto their way of life. Also, welfare handouts are always unsatisfying. The Comanche were not happy with reservation rations and it was far more rewarding to plunder Texans. The Fort Sill Reservation became a sanctuary from which they could wage war. In 1871 there were even scalpings within a short distance of Army posts. Whites had sent a capable and honest agent to deal with the Comanche and bring about peace, but the Comanche were not willing to be peaceful. \nSherman and the Comanche \nJust as it is today, it was whites who lived furthest from the menace who were convinced they knew best how to handle it. In Philadelphia or New York it was easy to talk about humane Indian policies, but on the frontier, whether in Confederate or Yankee territory, sentiments were different. In Minnesota in 1862, Sioux Indians attacked whites, killing hundreds. Many whites were fresh from northern Europe or descended from the very liberal Puritan and Quaker colonists. Yet they rallied and pushed the Sioux out of the state. \nIn Colorado in 1864, Methodist minister and volunteer army officer John Chivington, a fervent abolitionist, led a force of mostly settler militia against a group of Cheyenne after a series of murderous raids. His militia massacred Indians without compunction but his force also included a few regulars from the East who were appalled by the killing and raised a stink. Chivington also made a bad mistake: He attacked a peaceful band of Indians, not the hostile Dog Soldiers, an out-of-control offshoot of the Cheyenne, who were actually doing the raiding. \nAlso in 1864 an Army unit under Kit Carson fought the Comanche at the Battle of Adobe Walls, in Hutchinson County, Texas. The Indians surrounded the force but were held off with two mountain howitzers. The cannon were decisive. Carson’s men were outnumbered nearly ten to one, but killed nearly 100 Indians for a loss of six whites. \nTexans therefore eventually got help from people who knew Indians first hand. Help arrived, ironically, in the form of William T. Sherman, who never had much faith in Grant’s Indian policy. In 1871 he toured Texas to inspect damage from Comanche raids, and had a near encounter with Indians that had an effect on policy. A group of braves led by Set-tainte, Set-tank, and Big Tree attacked a wagon convoy of Army supplies that passed just minutes behind Sherman’s lightly guarded inspection tour. The dozen men on the convoy fought back, but seven were killed, scalped, and mutilated. One man died after being tied upside down to a wagon wheel with a fire set under his head. \nSherman was shaken by this close call, and sent out the cavalry under Colonel Ranald S. Mackenzie to investigate. With information from Agent Tatum, Mackenzie cornered the three ringleaders. Set-tank died resisting arrest, but the other two were sent back to Texas for trial. \nSet-tainte and Big Tree were sentenced to death, but not executed. The trial became a circus, with the two Indians at the center of a political struggle they must have found bewildering. As T.R Fehrenbach explains, “There was much popular sentiment in the East against hanging the aborigines; more important, the Indian Bureau and Department of the Interior strongly resented the army’s interference in Indian affairs.” President Grant wired the Reconstruction governor Edmond J. Davis and asked him to commute the sentences to life in prison. Davis did so. Eventually the two were released after serving less than a year. Texans were outraged. Even Quaker Tatum, who by this time was thoroughly disillusioned with the peace policy, was indignant. \nAlthough President Grant had pushed for a pardon, he reconsidered the peace policy and quietly let Colonel Mackenzie take the field. Mackenzie brought along Gatling guns, which gave his men a real edge over larger forces. (Rapid-fire weapons were rarely used against mass charges of Indians — they were too smart to try that — but having them meant Mackenzie’s men rarely had to face such charges. Things might have turned out differently for Custer if he had taken Gatling guns.) \nMackenzie drove ruthlessly into Comanche territory. He was a hard man, who pursued Indians wherever they fled — even into Mexico — and his men certainly killed women and children. One of his harshest tactics was to capture any Indians he could — women, children, elders — and hold them hostage. This meant Comanche war parties were forced to move with their entire villages, lest their families wind up in prison camp or dead from a trigger-happy trooper. The Comanche had even more to fear from the militia. Local men who may have known people killed in raids were invariably more vengeful than professional soldiers. \nThis policy of interning non-combatant Indians was part of one of the last full-scale campaigns against the Comanche, starting in August 1874, when Mackenzie pursued a force led by Chief Quanah Parker into the Llano Estacado of the Southern Plains. In late September, Mackenzie’s men captured a New Mexican Comanchero trader and made him talk by stretching him over a wagon wheel. He revealed the location of a large Comanche village in a canyon. Mackenzie’s men rode all night and stormed the canyon, capturing the horses, food stores, and teepees. The braves, always excellent fighters, held off the army until the women and children climbed out of the canyon, but Mackenzie burned their supplies and killed their horses. Over the next several days, he pursued and defeated the hungry, foot-bound Comanche. Many braves surrendered and returned to the reservation. \nThese tactics greatly reduced the Indian menace by the end of 1875, but the Comanche faced yet another threat. The expanding railroads brought whites armed with new buffalo guns onto the prairie to hunt the buffalo for their skins. The result was a slaughter that nearly wiped out the great herds on which the Comanche had depended for generations. The hunters themselves were dangerous; one group defeated a larger force of Comanche with their excellent rifles in 1874, at the Second Battle of Adobe Walls. Constantly pursued by the Army, starving for want of game, by 1879 the Comanche were a beaten people and never again threatened Texas. From a possible high of 30,000 at the start of the 19th century, the Comanche were reduced to roughly 1,500 by 1878. A once-proud people finally submitted permanently to the reservation. \nThe Comanche War is now history, its many tales preserved in movies and books. No Texan now living ever feared a Comanche moon. Today, tribal conflict takes different forms, and it is incursions from the South that are pushing back the white frontier. Clashes are not so sharp as those in the 19th century, but the outcome is no different. The destiny of Texas is being decided through immigration and demographics rather than armed conflict, but the questions remain the same: who will populate and who will rule? Earlier Americans understood what was at stake; today’s Americans have been numbed into acquiescence.",
		"thread_title": "War With the Comanche",
		"title": "War With the Comanche",
		"type": "bs",
		"uuid": "afb2a8a4bd2e9b88c997b138d425c9bbd5818e1d"
	},
	"-KhIgh8ABsZAfW2krSdU": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T06:57:14.473+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "stages",
				"salience": 0.20662229,
				"type": "OTHER"
			},
			{
				"name": "Video Archive Latest",
				"salience": 0.17969006,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "@whyvert",
				"salience": 0.14380336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.13061546,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.12056207,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.07744235,
				"type": "EVENT"
			},
			{
				"name": "HBD",
				"salience": 0.048271473,
				"type": "ORGANIZATION"
			},
			{
				"name": "credibility",
				"salience": 0.02940099,
				"type": "OTHER"
			},
			{
				"name": "@ 3",
				"salience": 0.01750657,
				"type": "OTHER"
			},
			{
				"name": "RT @jartaylor",
				"salience": 0.016511386,
				"type": "OTHER"
			},
			{
				"name": "Media Self-Destruct over Trump",
				"salience": 0.014310097,
				"type": "OTHER"
			},
			{
				"name": "@ 11",
				"salience": 0.0078052445,
				"type": "OTHER"
			},
			{
				"name": "@jartaylor",
				"salience": 0.0074586556,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T01:11:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Video Archive Latest Tweets \nRT @whyvert : The three stages of HBD denial: Can't be true! Let us hope it is not true! Let us pray that it will not become generally known! – Saturday, Oct 29 @ 3:50pm \nRT @jartaylor : \"Media Self-Destruct over Trump,\" by @jartaylor . The media lose all credibility when they can't control themselves. https://… – Friday, Oct 28 @ 11:37pm",
		"thread_title": "Comments of the Week, October 30, 2016",
		"title": "Comments of the Week, October 30, 2016",
		"type": "bs",
		"uuid": "53754da9f265918f997ea066823ef3a10dfb42fd"
	},
	"-KhIgheJAUC9bQMQ0c-E": {
		"author": "Chris Roberts",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T15:58:50.831+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0151l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Birth_of_a_Nation"
				},
				"name": "Birth of a Nation",
				"salience": 0.17702317,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.04539674,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.04418602,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.037016947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.03572315,
				"type": "LOCATION"
			},
			{
				"name": "news",
				"salience": 0.030993564,
				"type": "OTHER"
			},
			{
				"name": "films",
				"salience": 0.025505546,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0gwjw0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Django_Unchained"
				},
				"name": "Django Unchained",
				"salience": 0.025044976,
				"type": "WORK_OF_ART"
			},
			{
				"name": "moviegoers",
				"salience": 0.022890918,
				"type": "PERSON"
			},
			{
				"name": "cinephiles",
				"salience": 0.017336365,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.016686775,
				"type": "PERSON"
			},
			{
				"name": "production costs",
				"salience": 0.015972506,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lkvn87",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Butler"
				},
				"name": "The Butler",
				"salience": 0.015902614,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07r_cc9"
				},
				"name": "Blacks",
				"salience": 0.014667297,
				"type": "PERSON"
			},
			{
				"name": "film",
				"salience": 0.014651518,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01d63g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oscar_Micheaux"
				},
				"name": "Oscar Micheaux",
				"salience": 0.014258698,
				"type": "PERSON"
			},
			{
				"name": "Bombs",
				"salience": 0.013977159,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.011772545,
				"type": "OTHER"
			},
			{
				"name": "films",
				"salience": 0.01159722,
				"type": "WORK_OF_ART"
			},
			{
				"name": "privilege",
				"salience": 0.011350577,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.010959933,
				"type": "PERSON"
			},
			{
				"name": "vitriol",
				"salience": 0.010720504,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05wm88",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tyler_Perry"
				},
				"name": "Tyler Perry",
				"salience": 0.00995572,
				"type": "PERSON"
			},
			{
				"name": "Chris Roberts",
				"salience": 0.009947799,
				"type": "PERSON"
			},
			{
				"name": "movies",
				"salience": 0.009160951,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cost",
				"salience": 0.009142804,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04645f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Renaissance_(magazine)"
				},
				"name": "American Renaissance",
				"salience": 0.008617452,
				"type": "ORGANIZATION"
			},
			{
				"name": "problems",
				"salience": 0.0082745915,
				"type": "OTHER"
			},
			{
				"name": "ticket sales",
				"salience": 0.008220425,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0077990466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wmxfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jamie_Foxx"
				},
				"name": "Jamie Foxx",
				"salience": 0.0073969825,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0071523814,
				"type": "ORGANIZATION"
			},
			{
				"name": "rise",
				"salience": 0.0071523814,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0071523814,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0071523814,
				"type": "OTHER"
			},
			{
				"name": "Birth of Nation",
				"salience": 0.0065038744,
				"type": "EVENT"
			},
			{
				"name": "movies",
				"salience": 0.006267458,
				"type": "WORK_OF_ART"
			},
			{
				"name": "university system",
				"salience": 0.0058772764,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00464438,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0040670764,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0040670764,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0040670764,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.0038406423,
				"type": "PERSON"
			},
			{
				"name": "failure",
				"salience": 0.0037973048,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.003768935,
				"type": "OTHER"
			},
			{
				"name": "guilt",
				"salience": 0.003768935,
				"type": "OTHER"
			},
			{
				"name": "southerners",
				"salience": 0.003768935,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0036320174,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0034494468,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0034312555,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0034032406,
				"type": "OTHER"
			},
			{
				"name": "slave",
				"salience": 0.0034032406,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.003370995,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.0033363204,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0031997499,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0030192132,
				"type": "PERSON"
			},
			{
				"name": "mainstream",
				"salience": 0.002947199,
				"type": "OTHER"
			},
			{
				"name": "servant",
				"salience": 0.002947199,
				"type": "PERSON"
			},
			{
				"name": "success",
				"salience": 0.002947199,
				"type": "OTHER"
			},
			{
				"name": "heroin epidemic",
				"salience": 0.0028015121,
				"type": "OTHER"
			},
			{
				"name": "waste",
				"salience": 0.0027313894,
				"type": "OTHER"
			},
			{
				"name": "pornography",
				"salience": 0.002575156,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0025444974,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0025444974,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.002510694,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.002510694,
				"type": "OTHER"
			},
			{
				"name": "disgust",
				"salience": 0.0024680016,
				"type": "OTHER"
			},
			{
				"name": "trends",
				"salience": 0.002436915,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0023865665,
				"type": "LOCATION"
			},
			{
				"name": "theories",
				"salience": 0.0023865665,
				"type": "OTHER"
			},
			{
				"name": "Twelve Years a Slave",
				"salience": 0.0023204598,
				"type": "WORK_OF_ART"
			},
			{
				"name": "race film",
				"salience": 0.0023086034,
				"type": "WORK_OF_ART"
			},
			{
				"name": "things",
				"salience": 0.0022975116,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0022975116,
				"type": "OTHER"
			},
			{
				"name": "film makers",
				"salience": 0.0022826353,
				"type": "PERSON"
			},
			{
				"name": "films",
				"salience": 0.0022224553,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0021579112,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.0020666616,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0020666616,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0020666616,
				"type": "EVENT"
			},
			{
				"name": "anyone",
				"salience": 0.0020666616,
				"type": "PERSON"
			},
			{
				"name": "microaggressions",
				"salience": 0.0020666616,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.0020666616,
				"type": "PERSON"
			},
			{
				"name": "coincidence",
				"salience": 0.0020666616,
				"type": "OTHER"
			},
			{
				"name": "suicide rate",
				"salience": 0.0020666616,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0020666616,
				"type": "OTHER"
			},
			{
				"name": "commentators",
				"salience": 0.0020666616,
				"type": "PERSON"
			},
			{
				"name": "pride",
				"salience": 0.0019895355,
				"type": "OTHER"
			},
			{
				"name": "villains",
				"salience": 0.0019895355,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0019895355,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0019895355,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0019895355,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0019895355,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0019484239,
				"type": "LOCATION"
			},
			{
				"name": "movies",
				"salience": 0.0018930123,
				"type": "WORK_OF_ART"
			},
			{
				"name": "whites",
				"salience": 0.0018772364,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0018772364,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0018772364,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0018772364,
				"type": "PERSON"
			},
			{
				"name": "films",
				"salience": 0.0018610192,
				"type": "WORK_OF_ART"
			},
			{
				"name": "whites",
				"salience": 0.0018302335,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0018143299,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Ronald Reagan",
				"salience": 0.0017246092,
				"type": "PERSON"
			},
			{
				"name": "hemisphere",
				"salience": 0.0016872144,
				"type": "LOCATION"
			},
			{
				"name": "gender fluidity",
				"salience": 0.0016872144,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0016872144,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.0016872144,
				"type": "OTHER"
			},
			{
				"name": "music",
				"salience": 0.0016872144,
				"type": "WORK_OF_ART"
			},
			{
				"name": "doctrine",
				"salience": 0.0016872144,
				"type": "OTHER"
			},
			{
				"name": "sports",
				"salience": 0.0016872144,
				"type": "OTHER"
			},
			{
				"name": "blockbusters",
				"salience": 0.0016872144,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0016872144,
				"type": "OTHER"
			},
			{
				"name": "films",
				"salience": 0.001681511,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04nfgd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Derbyshire"
				},
				"name": "John Derbyshire",
				"salience": 0.001618668,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.0015582514,
				"type": "PERSON"
			},
			{
				"name": "cast",
				"salience": 0.0014555693,
				"type": "OTHER"
			},
			{
				"name": "cast",
				"salience": 0.0014555693,
				"type": "PERSON"
			},
			{
				"name": "Reconstruction",
				"salience": 0.0014555693,
				"type": "OTHER"
			},
			{
				"name": "theater",
				"salience": 0.0014555693,
				"type": "LOCATION"
			},
			{
				"name": "movies",
				"salience": 0.0014141671,
				"type": "WORK_OF_ART"
			},
			{
				"name": "whites",
				"salience": 0.0014023797,
				"type": "PERSON"
			},
			{
				"name": "boycott",
				"salience": 0.0013259856,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016m7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pat_Buchanan"
				},
				"name": "Pat Buchanan",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/029jpy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_England"
				},
				"name": "New England",
				"salience": 0.0012721082,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0012721082,
				"type": "LOCATION"
			},
			{
				"name": "Thomas Bertonneau",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01h_pp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Gottfried"
				},
				"name": "Paul Gottfried",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03nshz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peter_Brimelow"
				},
				"name": "Peter Brimelow",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01tw7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Heritage_Foundation"
				},
				"name": "Jason Richwine",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"name": "Leif Parsell",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b0m6t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Weissberg"
				},
				"name": "Robert Weissberg",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"name": "Jack Hunter",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05q416r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Frank_Borzellieri"
				},
				"name": "Frank Borzellieri",
				"salience": 0.0012721082,
				"type": "PERSON"
			},
			{
				"name": "anywhere",
				"salience": 0.0012604033,
				"type": "LOCATION"
			},
			{
				"name": "resistance",
				"salience": 0.0012604033,
				"type": "OTHER"
			},
			{
				"name": "race film",
				"salience": 0.0012561422,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0012246213,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04lp9p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tea_party"
				},
				"name": "Tea Party",
				"salience": 0.0012246213,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0011741199,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0011697512,
				"type": "PERSON"
			},
			{
				"name": "film-maker",
				"salience": 0.001060102,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.001060102,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.0010384904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bkmf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clark_Gable"
				},
				"name": "Clark Gable",
				"salience": 0.0010254032,
				"type": "PERSON"
			},
			{
				"name": "box office bonanzas",
				"salience": 0.0010159675,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.0009657132,
				"type": "EVENT"
			},
			{
				"name": "blaxploitation",
				"salience": 0.0009179439,
				"type": "OTHER"
			},
			{
				"name": "curiosity",
				"salience": 0.0009179439,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0009179439,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0009179439,
				"type": "OTHER"
			},
			{
				"name": "entertainment",
				"salience": 0.0009179439,
				"type": "OTHER"
			},
			{
				"name": "Gravity",
				"salience": 0.0009179439,
				"type": "OTHER"
			},
			{
				"name": "guilt",
				"salience": 0.0008770649,
				"type": "OTHER"
			},
			{
				"name": "habits",
				"salience": 0.00083996117,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.0007984105,
				"type": "OTHER"
			},
			{
				"name": "theater",
				"salience": 0.0007918857,
				"type": "LOCATION"
			},
			{
				"name": "Things",
				"salience": 0.0007918857,
				"type": "OTHER"
			},
			{
				"name": "Reconstruction",
				"salience": 0.0007918857,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05f5j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Negro"
				},
				"name": "Negro",
				"salience": 0.0007757406,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05hpy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Association_for_the_Advancement_of_Colored_People"
				},
				"name": "NAACP",
				"salience": 0.0007757406,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_War"
				},
				"name": "Civil War",
				"salience": 0.0007757406,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cgbf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joan_Crawford"
				},
				"name": "Joan Crawford",
				"salience": 0.0007757406,
				"type": "PERSON"
			},
			{
				"name": "redeemers",
				"salience": 0.00068568625,
				"type": "PERSON"
			},
			{
				"name": "version",
				"salience": 0.00068568625,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "shooting",
				"salience": 0.00068568625,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.00068568625,
				"type": "OTHER"
			},
			{
				"name": "dispossession",
				"salience": 0.00068568625,
				"type": "OTHER"
			},
			{
				"name": "grievance porn",
				"salience": 0.0006800825,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fkf28",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Interstellar_(film)"
				},
				"name": "Interstellar",
				"salience": 0.00065244327,
				"type": "PERSON"
			},
			{
				"name": "industry",
				"salience": 0.00064355065,
				"type": "OTHER"
			},
			{
				"name": "cold shoulder",
				"salience": 0.0005888738,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025h5s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Lord_of_the_Rings_(film_series)"
				},
				"name": "The Lord of the Rings",
				"salience": 0.0005649407,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06pjs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spike_Lee"
				},
				"name": "Spike Lee",
				"salience": 0.0005649407,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018hmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_United_States"
				},
				"name": "South",
				"salience": 0.000539779,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/011l2bwd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shooting_of_Michael_Brown"
				},
				"name": "Michael Brown",
				"salience": 0.0004219864,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j5slsv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Zimmerman"
				},
				"name": "George Zimmerman",
				"salience": 0.0004219864,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T15:58:50.831+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Posted on October 31, 2016 “Birth of a Nation” Bombs Chris Roberts, American Renaissance, October 29, 2016 Are whites fed up with white-guilt films? \nThe results are in: The new Birth of a Nation is a box-office disaster. Its ticket sales are going to fall several millions of dollars short of the cost to make and market the film–maybe as much as ten million dollars short . This is excellent news for white America. Birth of Nation glorifies black-on-white violence at a time when black-on-white violence is on the rise , and the anti-white vitriol from groups like Black Lives Matter has never been more mainstream . \nThe financial failure of Birth of a Nation is even better news when you consider the success of other recent films that cultivate white guilt and glorify black violence. In 2012, Django Unchained , another story of a black slave killing white southerners, made well over 150 percent of its production costs. In 2013, Twelve Years a Slave nearly tripled its production costs, and The Butler , the story of a sad black servant in the White House, did even better. \nHave American moviegoers lost interest in movies that tell them to feel guilty about their history? If so, the reason must surely be the rising disgust among whites at always being cast as the villains of history, and I suspect Donald Trump has had something to do with this. Win or lose, Mr. Trump has sparked a sense of pride in whites, and that affects many things, including movie-going habits. \nThink back to 2012 and 2013, when anti-white films were box office bonanzas. That 24-month period may well have been the lowest point for whites in American history. Politically, the implicitly white Tea Party movement disintegrated, and Mitt Romney lost to Barack Obama despite winning as much of the white vote as Ronald Reagan had decades earlier. Meanwhile, the number of journalists and commentators being purged for “racism” was higher than ever: John Derbyshire, Jason Richwine, Robert Weissberg, Jack Hunter, Frank Borzellieri, Pat Buchanan, Leif Parsell, Peter Brimelow, Paul Gottfried, and Thomas Bertonneau all lost jobs. \nThe white world outside of politics was not looking good either. The catastrophic waste of our wars in the Middle East had become obvious to anyone. Perhaps not by coincidence, the heroin epidemic in New England was starting and the white suicide rate was rising. The university system was becoming more and more aggressive with its theories of “white privilege,” microaggressions, and gender fluidity–and there seemed to be no one fighting back. The longstanding trends of black dominance in music and sports continued, and America seemed on its way to becoming this hemisphere’s South Africa . \nIn such a world, why not laugh along with black actor Jamie Foxx when he joked about enjoying killing all the white people in Django Unchained ? When the theory of “white privilege” is all but doctrine, blockbusters naturally vilify whites. \nPeople often make their conditions worse. Frustrated young men often compound their problems by watching pornography. Frustrated jobless people often compound their problems by drinking too much. A few years ago, white America only hastened its cultural and political dispossession by going to the theater and watching The Butler . \nThings are different now. The George Zimmerman trial, the Michael Brown shooting, and Black Lives Matter have helped many whites shed their last feelings of guilt. At the same time, Donald Trump has arrived almost like a modern version of the “ redeemers ” who helped end Reconstruction in the South. All this helps whites give “ black grievance porn ” the cold shoulder. \nIn any case, blacks and whites have always watched different movies. From about 1915 until the early 1950s, the “ race film ” industry produced no fewer than 500 movies that touted an “all black cast,” or an “all-star Negro cast.” Oscar Micheaux was a major black producer in his day, but the only whites who know about him now are dorky cinephiles. Blacks didn’t want to watch Clark Gable or Joan Crawford, and when they went to a “race film” they could sit anywhere they liked in the theater. The original (and excellent) Birth of a Nation , about the Civil War and southern resistance to Reconstruction, was boycotted by the NAACP , but a boycott by blacks was mostly symbolic. In the 1970s, blacks gorged themselves on “ blaxploitation ” films, while whites occasionally watched one out of curiosity. \nToday, playwright and film-maker Tyler Perry is overwhelmingly popular with blacks–he made $130 million in 2011, making him the highest paid man in entertainment that year–but many whites have never even heard of him. Who honestly thinks there are many blacks who watch contemporary white films such as Interstellar or The Lord of the Rings or Gravity ? \nOnly in recent and unfortunate times have large numbers of whites watched movies made by black film makers like Spike Lee who are openly contemptuous of whites. Let us hope this has finally come to an end.",
		"thread_title": "“Birth of a Nation” Bombs",
		"title": "“Birth of a Nation” Bombs",
		"type": "bs",
		"uuid": "4d72e3980cd1e107f64d87f7bbc58c38da3ac386"
	},
	"-KhIghkGDblAwGoSkIlM": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:55:49.018+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "comments",
				"salience": 0.19837612,
				"type": "WORK_OF_ART"
			},
			{
				"name": "American Renaissance",
				"salience": 0.14943832,
				"type": "ORGANIZATION"
			},
			{
				"name": "comment",
				"salience": 0.1260856,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Bombs",
				"salience": 0.1012633,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.06894495,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.06894495,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.06894495,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0151l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Birth_of_a_Nation"
				},
				"name": "Birth of a Nation",
				"salience": 0.0629722,
				"type": "WORK_OF_ART"
			},
			{
				"name": "social media account",
				"salience": 0.03688094,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.03377525,
				"type": "OTHER"
			},
			{
				"name": "Commentary",
				"salience": 0.022761067,
				"type": "WORK_OF_ART"
			},
			{
				"name": "guest",
				"salience": 0.022573525,
				"type": "PERSON"
			},
			{
				"name": "e-mail address",
				"salience": 0.022573525,
				"type": "OTHER"
			},
			{
				"name": "convenience",
				"salience": 0.01646528,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:55:49.018+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "American Renaissance, October 31, 2016 Share This “Birth of a Nation” Bombs We welcome comments that add information or perspective, and we encourage polite debate. If you log in with a social media account, your comment should appear immediately. If you prefer to remain anonymous, you may comment as a guest, using a name and an e-mail address of convenience. Your comment will be moderated. Commentary",
		"thread_title": "Extended Interview: Jorge Ramos Talks Race with Jared Taylor",
		"title": "Extended Interview: Jorge Ramos Talks Race with Jared Taylor",
		"type": "bs",
		"uuid": "096aa0e777a7b7c443d6774218422eb959abf3be"
	},
	"-KhIgiVw8UZNbaM2TSW9": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:55:51.773+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04736l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jared_Taylor"
				},
				"name": "Jared Taylor",
				"salience": 0.6026664,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.029765166,
				"type": "WORK_OF_ART"
			},
			{
				"name": "apple pie",
				"salience": 0.01983373,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.014579727,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "AR",
				"salience": 0.013199127,
				"type": "LOCATION"
			},
			{
				"name": "article",
				"salience": 0.010460536,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.010156263,
				"type": "PERSON"
			},
			{
				"name": "struggle",
				"salience": 0.009934523,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cmd7rf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_B._Spencer"
				},
				"name": "Richard Spencer",
				"salience": 0.007384336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0062590726,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.006230228,
				"type": "EVENT"
			},
			{
				"name": "harassment",
				"salience": 0.005207959,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0036424296,
				"type": "OTHER"
			},
			{
				"name": "entirety",
				"salience": 0.0032745115,
				"type": "OTHER"
			},
			{
				"name": "Editor's Note",
				"salience": 0.0032745115,
				"type": "WORK_OF_ART"
			},
			{
				"name": "creature",
				"salience": 0.0032692603,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0031591887,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0029764422,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02lvz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_American_Conservative"
				},
				"name": "American Conservative",
				"salience": 0.0025785242,
				"type": "ORGANIZATION"
			},
			{
				"name": "conferences",
				"salience": 0.0025276705,
				"type": "EVENT"
			},
			{
				"name": "city politics",
				"salience": 0.0024705562,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.0021556257,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "racism",
				"salience": 0.0021395173,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0021395173,
				"type": "PERSON"
			},
			{
				"name": "most",
				"salience": 0.0021241845,
				"type": "OTHER"
			},
			{
				"name": "contention",
				"salience": 0.0020323428,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09bqhf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scott_McConnell"
				},
				"name": "Scott McConnell",
				"salience": 0.0020163315,
				"type": "PERSON"
			},
			{
				"name": "conferences",
				"salience": 0.0019868042,
				"type": "EVENT"
			},
			{
				"name": "means",
				"salience": 0.0019318801,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.0019318801,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0019318801,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0019318801,
				"type": "LOCATION"
			},
			{
				"name": "newsletter",
				"salience": 0.0019318801,
				"type": "WORK_OF_ART"
			},
			{
				"name": "journalism",
				"salience": 0.0019318801,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0019318801,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0019318801,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0017759803,
				"type": "LOCATION"
			},
			{
				"name": "intellectuals",
				"salience": 0.001773443,
				"type": "PERSON"
			},
			{
				"name": "extremist",
				"salience": 0.0017599682,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01d7k4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Commentary_(magazine)"
				},
				"name": "Commentary",
				"salience": 0.0017342995,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Neal Kozodoy",
				"salience": 0.0017196091,
				"type": "PERSON"
			},
			{
				"name": "writing",
				"salience": 0.0016729579,
				"type": "OTHER"
			},
			{
				"name": "doses",
				"salience": 0.0016729579,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0016729579,
				"type": "PERSON"
			},
			{
				"name": "fax",
				"salience": 0.0016729579,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.0016729579,
				"type": "WORK_OF_ART"
			},
			{
				"name": "argument",
				"salience": 0.0016729579,
				"type": "OTHER"
			},
			{
				"name": "prospect",
				"salience": 0.0016729579,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0016729579,
				"type": "LOCATION"
			},
			{
				"name": "race relations",
				"salience": 0.0016729579,
				"type": "OTHER"
			},
			{
				"name": "eminences",
				"salience": 0.0016729579,
				"type": "OTHER"
			},
			{
				"name": "journal",
				"salience": 0.0016177559,
				"type": "WORK_OF_ART"
			},
			{
				"name": "parts",
				"salience": 0.0016072813,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g5_45",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pepe_(footballer,_born_1983)"
				},
				"name": "Pepe",
				"salience": 0.0015936722,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0015814992,
				"type": "PERSON"
			},
			{
				"name": "summer vacation",
				"salience": 0.0015702142,
				"type": "EVENT"
			},
			{
				"name": "alt-right",
				"salience": 0.0015030557,
				"type": "OTHER"
			},
			{
				"name": "campaign speech",
				"salience": 0.001482913,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article",
				"salience": 0.0013546725,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.001301081,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0012898844,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0012873989,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.0012615066,
				"type": "EVENT"
			},
			{
				"name": "fans",
				"salience": 0.0012498379,
				"type": "PERSON"
			},
			{
				"name": "doctrines",
				"salience": 0.0012287231,
				"type": "OTHER"
			},
			{
				"name": "alt-right",
				"salience": 0.0012195368,
				"type": "OTHER"
			},
			{
				"name": "immigration rates",
				"salience": 0.0012094333,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New Yorkers",
				"salience": 0.0011892675,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.0011747634,
				"type": "OTHER"
			},
			{
				"name": "anxieties",
				"salience": 0.0011654671,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0011532455,
				"type": "EVENT"
			},
			{
				"name": "world war",
				"salience": 0.0011274681,
				"type": "EVENT"
			},
			{
				"name": "keyboard pranksters",
				"salience": 0.0011219674,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.001061444,
				"type": "EVENT"
			},
			{
				"name": "Race",
				"salience": 0.001061444,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.0010585076,
				"type": "EVENT"
			},
			{
				"name": "civilization",
				"salience": 0.0010534663,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rtwj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abraham_Foxman"
				},
				"name": "Abe Foxman",
				"salience": 0.0010298216,
				"type": "PERSON"
			},
			{
				"name": "Paved With Good Intentions",
				"salience": 0.0010298216,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "New York Post",
				"salience": 0.0010298216,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0q442",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Defamation_League"
				},
				"name": "Anti-Defamation League",
				"salience": 0.0010298216,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04645f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Renaissance_(magazine)"
				},
				"name": "American Renaissance",
				"salience": 0.0010298216,
				"type": "ORGANIZATION"
			},
			{
				"name": "kind",
				"salience": 0.0010172611,
				"type": "OTHER"
			},
			{
				"name": "alt-right",
				"salience": 0.0009830615,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0009802772,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.00095349626,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.00095349626,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00095349626,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0009352726,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0009296183,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.00091912743,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00089148403,
				"type": "WORK_OF_ART"
			},
			{
				"name": "truth",
				"salience": 0.00088750204,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0008808657,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0008808657,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0008808657,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0008790868,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00087758823,
				"type": "EVENT"
			},
			{
				"name": "core doctrine",
				"salience": 0.00086151116,
				"type": "OTHER"
			},
			{
				"name": "doctrine",
				"salience": 0.00086151116,
				"type": "OTHER"
			},
			{
				"name": "killing",
				"salience": 0.0008488385,
				"type": "EVENT"
			},
			{
				"name": "vehicle",
				"salience": 0.0008488385,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "lie",
				"salience": 0.00083814206,
				"type": "OTHER"
			},
			{
				"name": "endgame vision",
				"salience": 0.0008367133,
				"type": "OTHER"
			},
			{
				"name": "tasks",
				"salience": 0.00083297584,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0008236708,
				"type": "OTHER"
			},
			{
				"name": "alt-right",
				"salience": 0.00082314975,
				"type": "OTHER"
			},
			{
				"name": "alt-right",
				"salience": 0.00082314975,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0007953286,
				"type": "PERSON"
			},
			{
				"name": "influence",
				"salience": 0.0007953286,
				"type": "OTHER"
			},
			{
				"name": "websites",
				"salience": 0.0007953286,
				"type": "OTHER"
			},
			{
				"name": "stress",
				"salience": 0.0007953286,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007533517,
				"type": "PERSON"
			},
			{
				"name": "press conference",
				"salience": 0.0007533517,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0007447256,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0007447256,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0007447256,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0455m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_McCarthy"
				},
				"name": "Senator McCarthy",
				"salience": 0.00072660245,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00072522805,
				"type": "PERSON"
			},
			{
				"name": "civil war",
				"salience": 0.0007220672,
				"type": "EVENT"
			},
			{
				"name": "third",
				"salience": 0.00071859645,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00071322266,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.00069606054,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00069295114,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.0006922533,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dissolution",
				"salience": 0.0006886795,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.0006886795,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.0006886795,
				"type": "EVENT"
			},
			{
				"name": "attack ad",
				"salience": 0.0006886795,
				"type": "WORK_OF_ART"
			},
			{
				"name": "core ideas",
				"salience": 0.0006886795,
				"type": "OTHER"
			},
			{
				"name": "magazines",
				"salience": 0.0006886795,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rewrite",
				"salience": 0.0006886795,
				"type": "EVENT"
			},
			{
				"name": "players",
				"salience": 0.0006886795,
				"type": "PERSON"
			},
			{
				"name": "significance",
				"salience": 0.0006886795,
				"type": "OTHER"
			},
			{
				"name": "portion",
				"salience": 0.0006886795,
				"type": "OTHER"
			},
			{
				"name": "dispossession",
				"salience": 0.0006886795,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.0006886795,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0006886795,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00067862717,
				"type": "PERSON"
			},
			{
				"name": "intellectuals",
				"salience": 0.00067240384,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.0006685092,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0006685092,
				"type": "PERSON"
			},
			{
				"name": "internet neo-Nazis",
				"salience": 0.0006659442,
				"type": "PERSON"
			},
			{
				"name": "Alt",
				"salience": 0.00064801687,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.00064355176,
				"type": "OTHER"
			},
			{
				"name": "anti-Semitism",
				"salience": 0.00064355176,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00064355176,
				"type": "OTHER"
			},
			{
				"name": "reduction",
				"salience": 0.0006421773,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0006415306,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.0006334456,
				"type": "OTHER"
			},
			{
				"name": "consciousness",
				"salience": 0.00061758,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "DC",
				"salience": 0.00060901407,
				"type": "LOCATION"
			},
			{
				"name": "banner",
				"salience": 0.00060664857,
				"type": "OTHER"
			},
			{
				"name": "internet trolling",
				"salience": 0.00059900305,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0005945233,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0005945233,
				"type": "OTHER"
			},
			{
				"name": "internet crowd",
				"salience": 0.0005945233,
				"type": "PERSON"
			},
			{
				"name": "race matters",
				"salience": 0.000594108,
				"type": "OTHER"
			},
			{
				"name": "pole",
				"salience": 0.000594108,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00058966485,
				"type": "OTHER"
			},
			{
				"name": "anti-Trump",
				"salience": 0.000586859,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0005822333,
				"type": "LOCATION"
			},
			{
				"name": "politicians",
				"salience": 0.0005822333,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00057192735,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.0005576021,
				"type": "OTHER"
			},
			{
				"name": "human identity",
				"salience": 0.0005576021,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0005576021,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0005576021,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0005576021,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.000556304,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.000556304,
				"type": "OTHER"
			},
			{
				"name": "doctrine",
				"salience": 0.0005457296,
				"type": "OTHER"
			},
			{
				"name": "refugee",
				"salience": 0.0005457296,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00053678395,
				"type": "OTHER"
			},
			{
				"name": "nationalists",
				"salience": 0.00053678395,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00053678395,
				"type": "LOCATION"
			},
			{
				"name": "former",
				"salience": 0.00053678395,
				"type": "OTHER"
			},
			{
				"name": "emergence",
				"salience": 0.0005333065,
				"type": "OTHER"
			},
			{
				"name": "visibility",
				"salience": 0.00052333873,
				"type": "OTHER"
			},
			{
				"name": "alt-right",
				"salience": 0.0005214255,
				"type": "OTHER"
			},
			{
				"name": "alt-right",
				"salience": 0.0005214255,
				"type": "OTHER"
			},
			{
				"name": "strike",
				"salience": 0.00051023014,
				"type": "EVENT"
			},
			{
				"name": "murders",
				"salience": 0.0005041517,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.0005041517,
				"type": "PERSON"
			},
			{
				"name": "representative",
				"salience": 0.00049522746,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00048617306,
				"type": "PERSON"
			},
			{
				"name": "hole",
				"salience": 0.00048282283,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.00048282283,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00048282283,
				"type": "PERSON"
			},
			{
				"name": "graduate program",
				"salience": 0.00048282283,
				"type": "OTHER"
			},
			{
				"name": "peg",
				"salience": 0.00048282283,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.00048282283,
				"type": "OTHER"
			},
			{
				"name": "Armageddon",
				"salience": 0.00048282283,
				"type": "ORGANIZATION"
			},
			{
				"name": "assertions",
				"salience": 0.00048282283,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00048282283,
				"type": "ORGANIZATION"
			},
			{
				"name": "shield",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00046479594,
				"type": "PERSON"
			},
			{
				"name": "pamphlets",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "internet cartoon frog",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "punk rock bands",
				"salience": 0.00046479594,
				"type": "ORGANIZATION"
			},
			{
				"name": "imagery",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "shock effect",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "resurgence",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.00046479594,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "symptoms",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00046479594,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0004593883,
				"type": "PERSON"
			},
			{
				"name": "shock",
				"salience": 0.00045518705,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00045518705,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00045518705,
				"type": "OTHER"
			},
			{
				"name": "emergence",
				"salience": 0.00045518705,
				"type": "OTHER"
			},
			{
				"name": "newspapers",
				"salience": 0.00045518705,
				"type": "ORGANIZATION"
			},
			{
				"name": "migrant",
				"salience": 0.00045518705,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00045518705,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.00045518705,
				"type": "PERSON"
			},
			{
				"name": "streamlining",
				"salience": 0.00045518705,
				"type": "EVENT"
			},
			{
				"name": "reality",
				"salience": 0.00045518705,
				"type": "OTHER"
			},
			{
				"name": "ethnostate",
				"salience": 0.00045518705,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.00045518705,
				"type": "OTHER"
			},
			{
				"name": "ethnostate",
				"salience": 0.00045518705,
				"type": "OTHER"
			},
			{
				"name": "revitalization",
				"salience": 0.00044744194,
				"type": "EVENT"
			},
			{
				"name": "effort",
				"salience": 0.00044744194,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/061f6y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Diane_Rehm"
				},
				"name": "Diane Rehm",
				"salience": 0.00042384697,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c0sl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NPR"
				},
				"name": "NPR",
				"salience": 0.00042384697,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.00042183083,
				"type": "OTHER"
			},
			{
				"name": "strides",
				"salience": 0.00042183083,
				"type": "OTHER"
			},
			{
				"name": "factions",
				"salience": 0.00041465316,
				"type": "OTHER"
			},
			{
				"name": "jolt",
				"salience": 0.00041465316,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.00040942684,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0004081883,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.00040764498,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01pl3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Year's_Eve"
				},
				"name": "New Year's Eve",
				"salience": 0.0004000316,
				"type": "EVENT"
			},
			{
				"name": "think tank",
				"salience": 0.00039917097,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.00039917097,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antisemitism"
				},
				"name": "anti-Semitic",
				"salience": 0.0003960696,
				"type": "PERSON"
			},
			{
				"name": "propagation",
				"salience": 0.00039413973,
				"type": "OTHER"
			},
			{
				"name": "Hundreds",
				"salience": 0.00039413973,
				"type": "PERSON"
			},
			{
				"name": "people-smuggling routes",
				"salience": 0.00039413973,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.00039413973,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.00039413973,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.00039413973,
				"type": "EVENT"
			},
			{
				"name": "model neoconservatism",
				"salience": 0.00039413973,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.00039413973,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.00039413973,
				"type": "PERSON"
			},
			{
				"name": "dream",
				"salience": 0.00039413973,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.00039413973,
				"type": "OTHER"
			},
			{
				"name": "flows",
				"salience": 0.00039413973,
				"type": "OTHER"
			},
			{
				"name": "procedure",
				"salience": 0.0003891719,
				"type": "OTHER"
			},
			{
				"name": "welcome",
				"salience": 0.0003842667,
				"type": "OTHER"
			},
			{
				"name": "pan-Asian",
				"salience": 0.00038008348,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03sydf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pan-Africanism"
				},
				"name": "pan-African",
				"salience": 0.00038008348,
				"type": "ORGANIZATION"
			},
			{
				"name": "alt-right",
				"salience": 0.0003797327,
				"type": "OTHER"
			},
			{
				"name": "assaults",
				"salience": 0.0003765854,
				"type": "OTHER"
			},
			{
				"name": "crime rates",
				"salience": 0.0003765854,
				"type": "OTHER"
			},
			{
				"name": "law-enforcement issue",
				"salience": 0.0003765854,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.0003765854,
				"type": "OTHER"
			},
			{
				"name": "murderers",
				"salience": 0.0003765854,
				"type": "OTHER"
			},
			{
				"name": "attorney general",
				"salience": 0.0003765854,
				"type": "PERSON"
			},
			{
				"name": "murder rates",
				"salience": 0.0003765854,
				"type": "OTHER"
			},
			{
				"name": "consciousness",
				"salience": 0.0003765854,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.00035610658,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.00035344306,
				"type": "OTHER"
			},
			{
				"name": "depiction",
				"salience": 0.00034493668,
				"type": "WORK_OF_ART"
			},
			{
				"name": "priest",
				"salience": 0.00034493668,
				"type": "PERSON"
			},
			{
				"name": "themes",
				"salience": 0.00034281,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00034000818,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.00034000818,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00034000818,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00034000818,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00034000818,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00034000818,
				"type": "PERSON"
			},
			{
				"name": "rock concerts",
				"salience": 0.00034000818,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00034000818,
				"type": "PERSON"
			},
			{
				"name": "cities",
				"salience": 0.00034000818,
				"type": "LOCATION"
			},
			{
				"name": "developments",
				"salience": 0.00034000818,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01p62z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jewish_state"
				},
				"name": "Jewish State",
				"salience": 0.00033585905,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f69h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neo-Nazism"
				},
				"name": "neo-Nazis",
				"salience": 0.00033035304,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.0003220588,
				"type": "EVENT"
			},
			{
				"name": "dichotomy",
				"salience": 0.0003217429,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00031672636,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00031672636,
				"type": "OTHER"
			},
			{
				"name": "coincidence",
				"salience": 0.0003136831,
				"type": "OTHER"
			},
			{
				"name": "race war",
				"salience": 0.0003126223,
				"type": "EVENT"
			},
			{
				"name": "race war",
				"salience": 0.0003126223,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.00030261936,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Parisian",
				"salience": 0.00029911773,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.00029911773,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088qpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Policy_Institute"
				},
				"name": "National Policy Institute",
				"salience": 0.00029714056,
				"type": "ORGANIZATION"
			},
			{
				"name": "Radix",
				"salience": 0.00029714056,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02shq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Treatment_Action_Campaign"
				},
				"name": "TAC",
				"salience": 0.00029714056,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0134r63m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AlternativeRight.com"
				},
				"name": "AlternativeRight.com",
				"salience": 0.00029714056,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dzst",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Duke_University"
				},
				"name": "Duke",
				"salience": 0.00029714056,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mad Max",
				"salience": 0.00029714056,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.00029686632,
				"type": "OTHER"
			},
			{
				"name": "spikes",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "television",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "fashion",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0002944057,
				"type": "LOCATION"
			},
			{
				"name": "rioters",
				"salience": 0.0002944057,
				"type": "PERSON"
			},
			{
				"name": "desire",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.0002944057,
				"type": "WORK_OF_ART"
			},
			{
				"name": "question",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "domestic-policy advances",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0002944057,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "sovereignty",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0002944057,
				"type": "OTHER"
			},
			{
				"name": "world war",
				"salience": 0.0002934101,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0002934101,
				"type": "EVENT"
			},
			{
				"name": "refugee crisis",
				"salience": 0.0002922036,
				"type": "EVENT"
			},
			{
				"name": "words",
				"salience": 0.00029069476,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00028604534,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00028604534,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi",
				"salience": 0.00028604534,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06z90w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charlie_Hebdo"
				},
				"name": "Charlie Hebdo",
				"salience": 0.00027556307,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.00027556307,
				"type": "LOCATION"
			},
			{
				"name": "cultures",
				"salience": 0.00027424603,
				"type": "OTHER"
			},
			{
				"name": "scientist",
				"salience": 0.00027282993,
				"type": "PERSON"
			},
			{
				"name": "market",
				"salience": 0.00027282993,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0148d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-communism"
				},
				"name": "anti-Communist",
				"salience": 0.00027071004,
				"type": "PERSON"
			},
			{
				"name": "spokesmen",
				"salience": 0.00026764546,
				"type": "PERSON"
			},
			{
				"name": "refugee crisis",
				"salience": 0.0002640056,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03hzt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Holocaust"
				},
				"name": "Holocaust",
				"salience": 0.00025518387,
				"type": "EVENT"
			},
			{
				"name": "press conference",
				"salience": 0.00024989323,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.00024989323,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.00024760765,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00024760765,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00024760765,
				"type": "PERSON"
			},
			{
				"name": "respect",
				"salience": 0.00024760765,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00024760765,
				"type": "OTHER"
			},
			{
				"name": "liberalism",
				"salience": 0.00024760765,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00024760765,
				"type": "OTHER"
			},
			{
				"name": "polemicists",
				"salience": 0.00024760765,
				"type": "PERSON"
			},
			{
				"name": "former",
				"salience": 0.00024760765,
				"type": "OTHER"
			},
			{
				"name": "anti-racism",
				"salience": 0.00024542838,
				"type": "OTHER"
			},
			{
				"name": "anti-First Amendment",
				"salience": 0.00024255861,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0qlp_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Theodor_Herzl"
				},
				"name": "Theodore Herzl",
				"salience": 0.00024255861,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/089g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionism"
				},
				"name": "Zionism",
				"salience": 0.00024255861,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.00024255861,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.00024255861,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.00024255861,
				"type": "LOCATION"
			},
			{
				"name": "immigration",
				"salience": 0.00022174374,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.00022174374,
				"type": "PERSON"
			},
			{
				"name": "train station",
				"salience": 0.00022174374,
				"type": "LOCATION"
			},
			{
				"name": "vocabulary",
				"salience": 0.00021990573,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00021826082,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00021826082,
				"type": "OTHER"
			},
			{
				"name": "accuracy",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "multiculturalism",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "faceoff",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "faults",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "latter",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "suicide pact",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "iterations",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "pushback",
				"salience": 0.0002143967,
				"type": "EVENT"
			},
			{
				"name": "segments",
				"salience": 0.0002143967,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.00021169416,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.00020924311,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0002076713,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.00020484698,
				"type": "OTHER"
			},
			{
				"name": "assaults",
				"salience": 0.00020484698,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.00020484698,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00020484698,
				"type": "EVENT"
			},
			{
				"name": "struggle",
				"salience": 0.00020484698,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.00020186398,
				"type": "LOCATION"
			},
			{
				"name": "terrorism aspect",
				"salience": 0.00020122032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.00020067429,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hcmw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Irving_Kristol"
				},
				"name": "Irving Kristol",
				"salience": 0.000195647,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.00018494888,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00018494888,
				"type": "OTHER"
			},
			{
				"name": "continent",
				"salience": 0.00018494888,
				"type": "LOCATION"
			},
			{
				"name": "identity",
				"salience": 0.00018494888,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.00018494888,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00018117743,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "bluntness",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "remark",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0001601415,
				"type": "LOCATION"
			},
			{
				"name": "edge",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "migrant surge",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "trenches",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "mass",
				"salience": 0.0001601415,
				"type": "OTHER"
			},
			{
				"name": "theater",
				"salience": 0.0001601415,
				"type": "LOCATION"
			},
			{
				"name": "execution",
				"salience": 0.0001601415,
				"type": "EVENT"
			},
			{
				"name": "seaside promenade",
				"salience": 0.0001601415,
				"type": "LOCATION"
			},
			{
				"name": "police forces",
				"salience": 0.00015029927,
				"type": "ORGANIZATION"
			},
			{
				"name": "Religion",
				"salience": 0.0001392837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n6bs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huntington,_West_Virginia"
				},
				"name": "Huntington",
				"salience": 0.00013880557,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cm0jf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sound_clash"
				},
				"name": "Clash",
				"salience": 0.00013193775,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05d8k75"
				},
				"name": "Samuel",
				"salience": 0.00013193775,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.00013193775,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03ksy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_University"
				},
				"name": "Harvard",
				"salience": 0.00013193775,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d33k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rouen"
				},
				"name": "Rouen",
				"salience": 0.00009854853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01yzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christendom"
				},
				"name": "Christendom",
				"salience": 0.00009854853,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "II",
				"salience": 0.00009854853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cp6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nice"
				},
				"name": "Nice",
				"salience": 0.00009854853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.00009854853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cm2xh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_I"
				},
				"name": "World War I",
				"salience": 0.00009854853,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01nrn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels_Airport"
				},
				"name": "Brussels Airport",
				"salience": 0.00009854853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cologne"
				},
				"name": "Cologne",
				"salience": 0.00009854853,
				"type": "LOCATION"
			},
			{
				"name": "Bataclan",
				"salience": 0.00009854853,
				"type": "LOCATION"
			},
			{
				"name": "role",
				"salience": 0.00007480531,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:55:51.773+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 37,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Scott McConnell, The American Conservative, October 31, 2016 \n[Editor’s Note: This article is worth reading in its entirety. A redacted version is below.] \nTwenty-one years ago I was assigned by Commentary to write about Jared Taylor–today known as one of the eminences of the “alt-right.” Taylor had written a grim book on American race relations, Paved With Good Intentions , which had been published by a mainstream house and was widely, if critically, reviewed. Though unusually skeptical about the prospect of blacks and whites living together harmoniously in the United States, it stopped well short of any systematically racist argument. The book had several fans among New Yorkers I knew prominent in journalism and city politics. \nWhen I referred to it in passing in a New York Post column, we quickly received a fax from Abe Foxman of the Anti-Defamation League stating that Taylor was far more extremist than I had let on. Curious to explore further, I queried Commentary –where I then did most of my non-newspaper writing–and they were interested. \nI interviewed Taylor, read back issues of his monthly newsletter, American Renaissance ( AR ), and drafted a piece. AR was devoted primarily to demonstrating that in American history racism was as accepted as apple pie and that this was by no means a bad thing. It contained large doses of the evolutionary and biological racial thought fairly commonplace amongst American elites in the ’20s and ’30s. A central contention was that the United States could not thrive as an increasingly multiracial and multicultural country and that American whites were facing a kind of cultural dispossession. \nI summarized this, quoting liberally, and concluded that the endgame vision of the AR crowd was potentially horrific, leading to national dissolution or civil war, while adding that continued mass immigration really would put the common culture of America under grave stress. If immigration rates went down, Taylor and AR would remain fringe players. If they rose, white racial anxieties would bubble to the surface, and Taylor might one day have his moment. \nThe piece was never published: Neal Kozodoy, Commentary ’s editor, told me I had indulged Taylor too much and asked for a shorter, tighter rewrite. By then my brief summer vacation had ended, other tasks intervened, and I eventually lost interest. \nJared Taylor’s moment has not arrived, but clearly he has edged into the national conversation. He has been pictured and quoted in an anti-Trump attack ad produced by Hillary Clinton’s campaign, he has been a guest on Diane Rehm’s show on NPR, and his core ideas have been broadcast–and excoriated–in magazines and websites great and small. He is now touted as one of the intellectual leaders of the alt-right, a diffuse movement of uncertain significance, but one deemed sufficiently important by the Clinton campaign for Hillary to devote a large portion of an August campaign speech to it. Donald Trump–who has almost surely never read a single article by an alt-right figure–is claimed by Clinton and other liberals to be under its influence and propagating its doctrines. \nThe truth is quite different: parts of the alt-right have raised their own visibility by attaching themselves to Trump. At the same time, Trump and his unanticipated success in winning the Republican nomination are symptoms of the same political and civilizational crisis that makes alt-rightish themes–at least in a more or less bowdlerized and soft-core form–compelling to a growing number of people. \n♦♦♦ \nTaylor, 65, is old by alt-right standards, and is an atypical representative, though just how much so is difficult to discern, for much of the alt-right is anonymous. The movement fields no candidates, publishes few books or pamphlets. It is a creature of the web, strongest on Twitter. Pepe, an internet cartoon frog, is an alt-right character–and has actually been formally denounced by the Clinton campaign. Alt-right internet trolling, sometimes ugly, blatantly racist and anti-Semitic, is also part of the movement. There is some debate whether it should be taken as an offensive and unfunny joke–merry keyboard pranksters who enjoy pretending to be internet neo-Nazis, rather like punk rock bands of the late ’70s deploying Nazi imagery for shock effect–or is something more sinister, a genuine resurgence of hardcore racism and anti-Semitism. Likely it’s more the former, but it’s also likely that the alt-right banner has given the minute number of genuine neo-Nazis in the country a kind of protective shield. \nRichard Spencer may serve as a bridge between older white nationalists such as Taylor and a younger alt-right internet crowd. It’s mistaken to call him or anyone else a leader–the movement has no procedure for choosing leaders–but he is clearly a pole of influence. He’s an intellectual entrepreneur who arrived in DC roughly ten years ago from a Duke graduate program. He worked at TAC for seven or eight months, where he was kind of a square peg in a round hole. Sometime thereafter his ideology began to crystallize. He started a website called AlternativeRight.com and later revitalized a white-nationalist think tank, the National Policy Institute, and launched a journal, Radix . \nSpencer can be engaging and amusing, but his core doctrine is likely to remain, barring some sort of Mad Max-type Armageddon, well outside what most Americans would consider plausible or desirable. \nWhat is the doctrine? At a recent press conference in DC, Spencer explained that the core of alt-right thought is race. Race is real, race matters, race is foundational to human identity. You cannot understand who you are without race. Many people would agree–at least privately or partially–with the first two assertions, but the third is the critical one, and has never been true historically or sociologically. (Not that there haven’t been groups of self-proclaimed pan-Asian or pan-African intellectuals who sought to make it true. Spencer fits into their tradition.) In any case, Spencer hopes somehow to spur whites into a kind of pan-white racial consciousness and galvanize them to become “aware of who we are,” and to prepare themselves, one day somehow, to form a white ethnostate. He refers to Theodore Herzl’s propagation of Zionism as a model for how such an ethnostate, seemingly a distant dream, could be eventually achieved. He fails to add that it took a Holocaust to make a Jewish State a reality. \n{snip} \nPrior to last fall, and before Hillary introduced the alt-right to a national audience, Spencer and Taylor held periodic conferences that could gather perhaps 200 people. (These were often held under shameful harassment by the leftist anti-First Amendment crowd, but that’s a different issue.) Spencer says he sees the alt-right as a vehicle that will influence politicians and intellectuals, taking as its model neoconservatism. {snip} \n{snip} \nWhat spurred this sudden emergence? It was not white-nationalist conferences or doctrine, which had been around forever, but events. Last year the West received a nasty high-voltage shock of political reality. The first jolt was the Charlie Hebdo attack in January. France had experienced jihadist murders before, but this time, the strike came in the center of Paris, and France was alarmed to find no small amount of support for the killing among its five million Muslim residents, many of them second- and third-generation citizens. \nThat spring and summer, European newspapers began to fill with reports of intensifying migrant and refugee flows, driven partially by the Syrian civil war and partially by the expansion and streamlining of people-smuggling routes from Africa. {snip} \nBy 2016 the welcome had grown cold. Hundreds of migrants sexually assaulted German women in and around the central train station of Cologne on New Year’s Eve, a mass assault that German authorities initially tried to cover up. {snip} \nIf the sexual assaults could be seen as the cultural edge of the migrant surge, it was more difficult for even liberal “anti-racist” European leaders to ignore or explain away the terrorism aspect. The Charlie Hebdo attack was followed by the mass slaughters at the Bataclan theater in Paris, at the Brussels Airport, then on a seaside promenade in Nice, culminating in the execution by knife of an aging French priest by two “assimilated” Muslim migrants in his church outside of Rouen. {snip} \n{snip} Richard Spencer may be incorrect about America, but one remark from his press conference in DC last month was arresting: \nThe refugee crisis in Europe is something like a world war. It is in many ways a race war. In terms of direct violence it does not resemble World War I or II. It is a demographic struggle, a struggle for identity, a struggle of who is going to define the continent, period. It is a new kind of war, a postmodern war, a war through immigration. There are no trenches, no guns. But it is a world war. \nOf course, it is not primarily a race war. Religion, or religious culture, plays a major and perhaps decisive role in the conflict, and conflict between Christendom and Islam is not new by any means. Still, there is something in the bluntness of Spencer’s depiction that rings more true than 90 percent of what appears in the American media, which invariably depicts the refugee crisis in humanitarian terms and terrorism as a barely related law-enforcement issue. It is surely not a coincidence that the alt-right began making strides into American consciousness precisely at the moment Muslims were surging into Europe as refugees, while others were blowing up Parisian rock concerts or mounting mass sexual assaults on European women. \n{snip} \nWhatever one might say about the alt-right, it is not perplexed. Few other political factions in America had a vocabulary ready for–or even made an effort to interpret seriously–what was going on in Europe, at a time when many people were seeking one. \n{snip} \nAmerican developments in the fall of last year, while less critical than those in Europe, also spurred the alt-right. The rise of Black Lives Matter put into question one of the outstanding domestic-policy advances of the past generation, the dramatic reduction in urban crime rates, which has made possible the revitalization of many cities. The lie which held that America’s police forces were chock full of marauding racist murderers suddenly became mainstream, repeated endlessly on television and pushed in only slightly more subtle fashion by Obama’s own attorney general. Meanwhile, some urban neighborhoods were looted by rioters, and others saw dramatic spikes in their murder rates. \n{snip} \nIt was predictable that such developments, touching on visceral areas of personal security, national sovereignty, and freedom of expression, would stir desire for a muscular response. Donald Trump filled the bill, if not always eloquently. So too, occasionally, did segments of the more established conservative media. But there was a market for a pushback as scathing and polemically unafraid as the left’s own polemicists, which might not have been the case four years earlier. This, as much as anything, accounts for the emergence of the alt-right, at least in its less ideologically extreme iterations. \n{snip} \nAnd though [Samuel] Huntington was a famous and deeply respected Harvard political scientist and a life-long Democrat, the concerns of Clash are those raised implicitly by Trump and explicitly by what I call the soft-core elements of the alt-right. There is, of course, much racism in American history, and there are enormous crimes for which Europe continues to strive to atone. But neither anti-racism nor respect for other cultures should be turned into a national or civilizational suicide pact. Here what Irving Kristol famously wrote about Sen. Joseph McCarthy comes to mind: “There is one thing that the American people know about Senator McCarthy: he like them is unequivocally anti-Communist. About the spokesmen for American liberalism, they feel they know no such thing.” \nIn the now global faceoff between Western civilization versus mass immigration fused with multiculturalism, Kristol’s words describe with uncanny accuracy the dichotomy between Donald Trump and his supporters on one hand and those most feverishly denouncing him on the other. Among the former, for all their faults, are those who want, unequivocally, Western civilization to survive. About the latter, no such thing is certain.",
		"thread_title": "Rise of the Alt-Right",
		"title": "Rise of the Alt-Right",
		"type": "bs",
		"uuid": "6efb8921ef57e3654f448f1d58b7ceab9e077377"
	},
	"-KhIgifXRh-xXwMxozE3": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:02.119+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Jorge Ramos Fusion",
				"salience": 0.1880752,
				"type": "PERSON"
			},
			{
				"name": "alt-right movement",
				"salience": 0.12752567,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0868627,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0868627,
				"type": "OTHER"
			},
			{
				"name": "supremacist groups",
				"salience": 0.08472757,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "Ku Klux Klan",
				"salience": 0.079343975,
				"type": "ORGANIZATION"
			},
			{
				"name": "ideas",
				"salience": 0.05012095,
				"type": "OTHER"
			},
			{
				"name": "Editor's Note",
				"salience": 0.04124939,
				"type": "WORK_OF_ART"
			},
			{
				"name": "gatherings",
				"salience": 0.038017917,
				"type": "EVENT"
			},
			{
				"name": "version",
				"salience": 0.03660973,
				"type": "OTHER"
			},
			{
				"name": "Hate Rising",
				"salience": 0.02872016,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.02845746,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016cb8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jorge_Ramos_(news_anchor)"
				},
				"name": "Jorge Ramos",
				"salience": 0.02777758,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.020758737,
				"type": "EVENT"
			},
			{
				"name": "thanks",
				"salience": 0.015523312,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.015523312,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.015523312,
				"type": "OTHER"
			},
			{
				"name": "campaign trail",
				"salience": 0.015523312,
				"type": "LOCATION"
			},
			{
				"name": "Jared Taylor",
				"salience": 0.012797009,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:02.119+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Hate Rising with Jorge Ramos Fusion, October 28, 2016 \nFrom the Ku Klux Klan to the so called alt-right movement, white supremacist groups are growing in numbers and influence. In “Hate Rising,” Jorge Ramos shows us how their ideas, usually confined to private and secretive gatherings, are becoming mainstream thanks in part to the rhetoric on the campaign trail this election cycle. [Editor’s Note: An extended version of the interview with Jared Taylor is available here .]",
		"thread_title": "Hate Rising with Jorge Ramos",
		"title": "Hate Rising with Jorge Ramos",
		"type": "bs",
		"uuid": "099073900e92c6b84924f4545cc98768b9a86b67"
	},
	"-KhIgixyvjBrCAf95aME": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:03.010+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Ben Cohen",
				"salience": 0.07515461,
				"type": "PERSON"
			},
			{
				"name": "Blacks",
				"salience": 0.07227111,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.05683501,
				"type": "PERSON"
			},
			{
				"name": "Jared Taylor",
				"salience": 0.05537965,
				"type": "PERSON"
			},
			{
				"name": "King",
				"salience": 0.042386156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asians",
				"salience": 0.032055177,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.026766948,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.020060709,
				"type": "PERSON"
			},
			{
				"name": "readers",
				"salience": 0.019131834,
				"type": "PERSON"
			},
			{
				"name": "cuckservatives",
				"salience": 0.019078063,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.019078063,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.018628348,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.01778536,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/051cc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Martin_Luther_King,_Jr."
				},
				"name": "Martin Luther King",
				"salience": 0.016971987,
				"type": "PERSON"
			},
			{
				"name": "opponents",
				"salience": 0.015531662,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.0131830145,
				"type": "OTHER"
			},
			{
				"name": "arguments",
				"salience": 0.011913315,
				"type": "OTHER"
			},
			{
				"name": "American Thinker",
				"salience": 0.011766298,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.011703131,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.011703131,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.011091173,
				"type": "PERSON"
			},
			{
				"name": "quotas",
				"salience": 0.010814205,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.009877414,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.009766782,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.008460025,
				"type": "OTHER"
			},
			{
				"name": "colorblindness",
				"salience": 0.008460025,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.008460025,
				"type": "OTHER"
			},
			{
				"name": "preservationist argument",
				"salience": 0.008151493,
				"type": "OTHER"
			},
			{
				"name": "Advocates",
				"salience": 0.0075004455,
				"type": "PERSON"
			},
			{
				"name": "character",
				"salience": 0.007122953,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0069955443,
				"type": "PERSON"
			},
			{
				"name": "arguments",
				"salience": 0.006741813,
				"type": "OTHER"
			},
			{
				"name": "interest argument",
				"salience": 0.006169979,
				"type": "OTHER"
			},
			{
				"name": "racialists",
				"salience": 0.005886714,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.005700597,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.005700597,
				"type": "EVENT"
			},
			{
				"name": "preservationist argument",
				"salience": 0.0056465636,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.0055755,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.005249256,
				"type": "PERSON"
			},
			{
				"name": "genetics",
				"salience": 0.0050566737,
				"type": "OTHER"
			},
			{
				"name": "Prisoners",
				"salience": 0.0049607162,
				"type": "PERSON"
			},
			{
				"name": "Afro-Hispanic-Caribbean-Asiatic America",
				"salience": 0.0045756185,
				"type": "LOCATION"
			},
			{
				"name": "identity politics",
				"salience": 0.004458097,
				"type": "OTHER"
			},
			{
				"name": "character",
				"salience": 0.004458097,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0044444264,
				"type": "LOCATION"
			},
			{
				"name": "minority",
				"salience": 0.004197603,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.00418574,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0041288636,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0040255436,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0038242007,
				"type": "PERSON"
			},
			{
				"name": "minorities",
				"salience": 0.0037006908,
				"type": "PERSON"
			},
			{
				"name": "Liberals",
				"salience": 0.0036937473,
				"type": "PERSON"
			},
			{
				"name": "coalition",
				"salience": 0.003575613,
				"type": "ORGANIZATION"
			},
			{
				"name": "agenda",
				"salience": 0.003486123,
				"type": "OTHER"
			},
			{
				"name": "fathers",
				"salience": 0.003486123,
				"type": "PERSON"
			},
			{
				"name": "grandchildren",
				"salience": 0.003486123,
				"type": "PERSON"
			},
			{
				"name": "disposal",
				"salience": 0.003486123,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.003486123,
				"type": "OTHER"
			},
			{
				"name": "miscegenation",
				"salience": 0.003486123,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0033840903,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0032453435,
				"type": "OTHER"
			},
			{
				"name": "purity",
				"salience": 0.0031264427,
				"type": "OTHER"
			},
			{
				"name": "quote",
				"salience": 0.0031264427,
				"type": "OTHER"
			},
			{
				"name": "purity",
				"salience": 0.0031264427,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0031264427,
				"type": "OTHER"
			},
			{
				"name": "identity politics",
				"salience": 0.0031264427,
				"type": "OTHER"
			},
			{
				"name": "purity",
				"salience": 0.0031264427,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0031133632,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0030097915,
				"type": "PERSON"
			},
			{
				"name": "marriage",
				"salience": 0.0030097915,
				"type": "OTHER"
			},
			{
				"name": "marriage",
				"salience": 0.0030097915,
				"type": "OTHER"
			},
			{
				"name": "marriage",
				"salience": 0.0030097915,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0028853663,
				"type": "PERSON"
			},
			{
				"name": "fault line",
				"salience": 0.0028589955,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0028462303,
				"type": "PERSON"
			},
			{
				"name": "appeals",
				"salience": 0.0028229838,
				"type": "OTHER"
			},
			{
				"name": "appeals",
				"salience": 0.0028229838,
				"type": "OTHER"
			},
			{
				"name": "prison system",
				"salience": 0.0028229838,
				"type": "OTHER"
			},
			{
				"name": "nationalism",
				"salience": 0.0028229838,
				"type": "OTHER"
			},
			{
				"name": "sunbelt states",
				"salience": 0.0027176456,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0027176456,
				"type": "LOCATION"
			},
			{
				"name": "millennials",
				"salience": 0.0027176456,
				"type": "PERSON"
			},
			{
				"name": "genetics",
				"salience": 0.0027176456,
				"type": "OTHER"
			},
			{
				"name": "race riots",
				"salience": 0.0026714313,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0025984927,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.0025717437,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0025525196,
				"type": "EVENT"
			},
			{
				"name": "race",
				"salience": 0.0024886157,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.002444585,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.002444585,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.002444585,
				"type": "OTHER"
			},
			{
				"name": "arrival",
				"salience": 0.002444585,
				"type": "EVENT"
			},
			{
				"name": "fashion",
				"salience": 0.002444585,
				"type": "OTHER"
			},
			{
				"name": "press conference",
				"salience": 0.002444585,
				"type": "EVENT"
			},
			{
				"name": "immigration",
				"salience": 0.0024388968,
				"type": "EVENT"
			},
			{
				"name": "author",
				"salience": 0.0023679482,
				"type": "PERSON"
			},
			{
				"name": "preferences",
				"salience": 0.0023533565,
				"type": "OTHER"
			},
			{
				"name": "newlyweds",
				"salience": 0.0023533565,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.0023533565,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0023533565,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0023533565,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0023259895,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0023047274,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0023047274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09g7kt3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-Hispanic_whites"
				},
				"name": "non-Hispanic",
				"salience": 0.0022599732,
				"type": "PERSON"
			},
			{
				"name": "presidents",
				"salience": 0.0022021276,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0021922935,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.0020731294,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0019957547,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0019957547,
				"type": "OTHER"
			},
			{
				"name": "inmates",
				"salience": 0.0019957547,
				"type": "PERSON"
			},
			{
				"name": "separation",
				"salience": 0.0019957547,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.0019957547,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.0019957547,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0019957547,
				"type": "ORGANIZATION"
			},
			{
				"name": "argument",
				"salience": 0.0019228321,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.001921266,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0019069015,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0019069015,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0017466999,
				"type": "PERSON"
			},
			{
				"name": "affirmative action beneficiaries",
				"salience": 0.0017217514,
				"type": "OTHER"
			},
			{
				"name": "affirmative action beneficiaries",
				"salience": 0.0017217514,
				"type": "OTHER"
			},
			{
				"name": "majority minority nation",
				"salience": 0.0017217514,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.0016941249,
				"type": "OTHER"
			},
			{
				"name": "Alt",
				"salience": 0.0015047424,
				"type": "ORGANIZATION"
			},
			{
				"name": "clout",
				"salience": 0.0014908971,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0014908971,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0014908971,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0014908971,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0014908971,
				"type": "OTHER"
			},
			{
				"name": "host",
				"salience": 0.0014908971,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ch2n72",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Christian_Adams"
				},
				"name": "J. Christian Adams",
				"salience": 0.0013955033,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0013888355,
				"type": "PERSON"
			},
			{
				"name": "quote",
				"salience": 0.0013888355,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0013888355,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0013269921,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0012655398,
				"type": "PERSON"
			},
			{
				"name": "cuckservatives",
				"salience": 0.0012539678,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0012539678,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0012284041,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0011981276,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.0011230143,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.0010996723,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0010858135,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mailing list",
				"salience": 0.0010858135,
				"type": "OTHER"
			},
			{
				"name": "gift card",
				"salience": 0.0010858135,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0010858135,
				"type": "OTHER"
			},
			{
				"name": "likes",
				"salience": 0.0010858135,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0010858135,
				"type": "OTHER"
			},
			{
				"name": "immigration restriction",
				"salience": 0.0010858135,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0010452763,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07phrcj"
				},
				"name": "Liberals",
				"salience": 0.0010427115,
				"type": "ORGANIZATION"
			},
			{
				"name": "charges",
				"salience": 0.0010374591,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0010367343,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0009367032,
				"type": "PERSON"
			},
			{
				"name": "voter intimidation",
				"salience": 0.0009367032,
				"type": "OTHER"
			},
			{
				"name": "voter intimidation",
				"salience": 0.0009367032,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0008362388,
				"type": "PERSON"
			},
			{
				"name": "club",
				"salience": 0.00081108295,
				"type": "ORGANIZATION"
			},
			{
				"name": "voting rights division",
				"salience": 0.00081108295,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0007091191,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuban",
				"salience": 0.0006682562,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081mh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Virginia"
				},
				"name": "West Virginia",
				"salience": 0.0006682562,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06j3g0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Krikorian"
				},
				"name": "Mark Krikorian",
				"salience": 0.0006682562,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/040db",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jorge_Luis_Borges"
				},
				"name": "Jorge Borges",
				"salience": 0.0006682562,
				"type": "PERSON"
			},
			{
				"name": "thugs",
				"salience": 0.0005543754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.0004991591,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hk__",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Black_Panther_Party"
				},
				"name": "NBPP",
				"salience": 0.0004991591,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:03.010+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 21,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Ben Cohen, American Thinker, October 31, 2016 \nIn his “An open letter to cuckservatives”, Jared Taylor wrote, \nWhy do you evoke Martin Luther King when you call for a “colorblind” America? You know he wanted quotas for blacks. You evoke King because you think he’ll help you silence blacks and liberals. But it doesn’t work, does it? That’s because only whites–and Asians, when it suits them–even think in terms of “colorblindness.” Blacks and Hispanics will squeeze every unfair advantage out of you they can. At what point will they ever abandon their aggressive racial agenda? When they’re the majority just think how hard they’ll squeeze your grandchildren. \nAdvocates of white identity politics have two basic arguments at their disposal. The first argument could be called the racial preservationist argument, and the second could be called the collective interest argument. \nThe first argument holds that national character reflects the genetics of the national population, therefore miscegenation and non-white immigration will radically alter the national character. As Jared Taylor put it, the future “Afro-Hispanic-Caribbean-Asiatic America” will be totally unrecognizable to the founding fathers, and completely alien from the America we grew up in. \nWhatever relationship exists between national genetics and national culture, the preservationist argument has largely failed to persuade white Americans. In 1958 only 4 percent of Americans approved of white-black marriage, by 2013 87% of Americans approved of white-black marriage. For millennials, the numbers are even higher. \nBut what about revealed preferences? For decades, white Americans have migrated from more homogeneous northern states to more diverse sunbelt states. In 2010, 9.4% of non-Hispanic white newlyweds married either a Hispanic person or a non-white person. \nUndoubtedly, passionate opponents of interracial marriage still exist–not all of them white–but their arguments haven’t persuaded many people. Any argument for white nationalism or white identity politics centered on the need for racial purity is pretty much dead on arrival, because most white people don’t care about racial purity. \nWith appeals to racial purity out of fashion, racialists are left with appeals to collective interest. At the Alt-right press conference, Jared Taylor warned white people that their children wouldn’t simply be a minority, but “the way things are going, a hated minority.” \nThis quote sticks out. Within our prison system, violent race riots have claimed the lives of many inmates. Prisoners largely segregate themselves by race, and enforce a fairly rigid system of racial separation. Based on past experience, race appears to be a particularly violent and nasty fault line. \nEven people who aren’t racist will band together along racial lines, if they perceive themselves to be under threat. Most liberals find the idea of white people being persecuted ridiculous, and at the present moment it is. \nBut the possibility of anti-white discrimination isn’t as remote as many liberals would like to think. As J. Christian Adams documented, the Obama administration refused to prosecute minorities who engaged in voter intimidation. According to Adams they didn’t simply drop charges against the NBPP members caught brandishing a club at voters in Philadelphia, they actually instructed the voting rights division not to prosecute any non-white person for voter intimidation. \nIf a white president refused to prosecute racist white thugs for intimidating black voters, black people would be rightfully alarmed. There is no reason to expect whites to react differently. \nAt this point, liberal readers will be saying to themselves, “blacks are twelve percent of the population, what do we have to worry about?” \nExcept, when America becomes a majority minority nation, future presidents will no longer have to depend on white votes to get elected. Future leaders could build a coalition of black and Hispanic voters, held together by shared interests. \nIf this is starting to make sense to liberal readers, keep reading, it gets worse. Non-white immigrants benefit from a host of affirmative action and “diversity” programs. In other words, immigration increases the political clout of affirmative action beneficiaries. Why exactly should white people welcome immigrants who will be favored over them? \nEspecially galling is the fact that many affirmative action beneficiaries are neither poor nor disadvantaged. What are poor whites in West Virginia supposed to think about millionaire Cuban immigrants being favored over them? \nThis author supports moderate immigration restriction of the type advocated by the likes of Jorge Borges or Mark Krikorian; however, he does not want white Americans to hate or fear non-white immigrants. Liberals, on the other hand, seem intent on pursuing policies almost guaranteed to revive white racism. \nThis article began with a quote from Jared Taylor’s letter to cuckservatives. He should add liberals to his mailing list. Liberals supplied Jared with his most persuasive argument; they deserve a thank you note and a gift card.",
		"thread_title": "Affirmative Action, Immigration and the Politics of Racial Solidarity",
		"title": "Affirmative Action, Immigration and the Politics of Racial Solidarity",
		"type": "bs",
		"uuid": "91a2c7e9ef05fd31688e4cacf41e6930ff9f022e"
	},
	"-KhIgjDRLsq3TD3WUcri": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:03.970+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Michael Rectenwald",
				"salience": 0.24725257,
				"type": "PERSON"
			},
			{
				"name": "Professor",
				"salience": 0.16656463,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bwfn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_University"
				},
				"name": "NYU",
				"salience": 0.14787833,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/076vsnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Post_(Ohio_newspaper)"
				},
				"name": "The Post",
				"salience": 0.031705696,
				"type": "ORGANIZATION"
			},
			{
				"name": "professor",
				"salience": 0.025221724,
				"type": "PERSON"
			},
			{
				"name": "PC Culture",
				"salience": 0.016509434,
				"type": "OTHER"
			},
			{
				"name": "incivility",
				"salience": 0.016509434,
				"type": "OTHER"
			},
			{
				"name": "student coddling",
				"salience": 0.014308938,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.014308938,
				"type": "PERSON"
			},
			{
				"name": "classroom",
				"salience": 0.014308938,
				"type": "LOCATION"
			},
			{
				"name": "correctness",
				"salience": 0.014308938,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.012946366,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "New York Post",
				"salience": 0.011278855,
				"type": "ORGANIZATION"
			},
			{
				"name": "community",
				"salience": 0.01063283,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.010133492,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.010094771,
				"type": "OTHER"
			},
			{
				"name": "instructor",
				"salience": 0.0096417535,
				"type": "PERSON"
			},
			{
				"name": "NYU Melkorka Licea",
				"salience": 0.00882685,
				"type": "LOCATION"
			},
			{
				"name": "paid leave",
				"salience": 0.008458173,
				"type": "OTHER"
			},
			{
				"name": "committee",
				"salience": 0.007697249,
				"type": "ORGANIZATION"
			},
			{
				"name": "rest",
				"salience": 0.0073272786,
				"type": "OTHER"
			},
			{
				"name": "semester",
				"salience": 0.0073272786,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.006481851,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.005333455,
				"type": "OTHER"
			},
			{
				"name": "Halloween costumes",
				"salience": 0.004361284,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0041804714,
				"type": "OTHER"
			},
			{
				"name": "participation",
				"salience": 0.0040603057,
				"type": "OTHER"
			},
			{
				"name": "trigger warnings",
				"salience": 0.0034877995,
				"type": "OTHER"
			},
			{
				"name": "PC culture",
				"salience": 0.0034877995,
				"type": "OTHER"
			},
			{
				"name": "academia",
				"salience": 0.0034877995,
				"type": "PERSON"
			},
			{
				"name": "spaces",
				"salience": 0.0034877995,
				"type": "LOCATION"
			},
			{
				"name": "ideas",
				"salience": 0.0034877995,
				"type": "OTHER"
			},
			{
				"name": "campus",
				"salience": 0.0034877995,
				"type": "LOCATION"
			},
			{
				"name": "Deplorable NYU Prof",
				"salience": 0.0032920432,
				"type": "PERSON"
			},
			{
				"name": "assistant professor",
				"salience": 0.003061573,
				"type": "PERSON"
			},
			{
				"name": "trigger warning",
				"salience": 0.0030341088,
				"type": "OTHER"
			},
			{
				"name": "PC Gestapo",
				"salience": 0.0030205683,
				"type": "ORGANIZATION"
			},
			{
				"name": "aspects",
				"salience": 0.0030205683,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0030205683,
				"type": "OTHER"
			},
			{
				"name": "campus trends",
				"salience": 0.0030205683,
				"type": "OTHER"
			},
			{
				"name": "tweets",
				"salience": 0.0030205683,
				"type": "WORK_OF_ART"
			},
			{
				"name": "name",
				"salience": 0.0030205683,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0029321858,
				"type": "OTHER"
			},
			{
				"name": "Deplorable NYU Prof",
				"salience": 0.002827726,
				"type": "PERSON"
			},
			{
				"name": "contention",
				"salience": 0.0026275832,
				"type": "OTHER"
			},
			{
				"name": "department",
				"salience": 0.0024461194,
				"type": "ORGANIZATION"
			},
			{
				"name": "alt-right",
				"salience": 0.0024352001,
				"type": "OTHER"
			},
			{
				"name": "instructor",
				"salience": 0.0023548638,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.0023548638,
				"type": "WORK_OF_ART"
			},
			{
				"name": "spaces",
				"salience": 0.0023548638,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.0023252075,
				"type": "WORK_OF_ART"
			},
			{
				"name": "asses",
				"salience": 0.0021183013,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0021183013,
				"type": "OTHER"
			},
			{
				"name": "Matt Nagel",
				"salience": 0.0020436582,
				"type": "PERSON"
			},
			{
				"name": "reporting",
				"salience": 0.0020392644,
				"type": "OTHER"
			},
			{
				"name": "feed",
				"salience": 0.0020392644,
				"type": "OTHER"
			},
			{
				"name": "witch hunt",
				"salience": 0.0020392644,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.0020392644,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.0020392644,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0020392644,
				"type": "ORGANIZATION"
			},
			{
				"name": "work",
				"salience": 0.0019971335,
				"type": "OTHER"
			},
			{
				"name": "incivility",
				"salience": 0.0019971335,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0019971335,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0019971335,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0019971335,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0019971335,
				"type": "OTHER"
			},
			{
				"name": "professors",
				"salience": 0.00189146,
				"type": "PERSON"
			},
			{
				"name": "exchange",
				"salience": 0.0017294402,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.0017294402,
				"type": "OTHER"
			},
			{
				"name": "civility",
				"salience": 0.0017294402,
				"type": "OTHER"
			},
			{
				"name": "illogic",
				"salience": 0.0017294402,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0017294402,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.0017294402,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.0017294402,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0016723692,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Students",
				"salience": 0.0016662583,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0016662583,
				"type": "PERSON"
			},
			{
				"name": "student paper",
				"salience": 0.0016513016,
				"type": "ORGANIZATION"
			},
			{
				"name": "cry",
				"salience": 0.0016439278,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0016304991,
				"type": "OTHER"
			},
			{
				"name": "leave",
				"salience": 0.0015110702,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0014920331,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.0014920331,
				"type": "OTHER"
			},
			{
				"name": "department dean",
				"salience": 0.0014920331,
				"type": "PERSON"
			},
			{
				"name": "Independent Student Newspaper",
				"salience": 0.0014496844,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/078d2b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington_Square_News"
				},
				"name": "Washington Square News",
				"salience": 0.0014496844,
				"type": "ORGANIZATION"
			},
			{
				"name": "Liberal Studies Diversity",
				"salience": 0.0013040006,
				"type": "OTHER"
			},
			{
				"name": "Equity and Inclusion Working Group",
				"salience": 0.0013040006,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0013027976,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0012920039,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0012920039,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0012920039,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0012920039,
				"type": "PERSON"
			},
			{
				"name": "HR representative",
				"salience": 0.0012920039,
				"type": "PERSON"
			},
			{
				"name": "studies",
				"salience": 0.001244794,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.001244794,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0012126346,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.0010867029,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0010867029,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0009409914,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0009409914,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0009174249,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0008540216,
				"type": "OTHER"
			},
			{
				"name": "deans",
				"salience": 0.00084325916,
				"type": "PERSON"
			},
			{
				"name": "integrity",
				"salience": 0.00081177865,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00081177865,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00081177865,
				"type": "OTHER"
			},
			{
				"name": "academia",
				"salience": 0.00081177865,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ygrn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RateMyProfessors.com"
				},
				"name": "ratemyprofessors.com",
				"salience": 0.0007952293,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00078791153,
				"type": "EVENT"
			},
			{
				"name": "witch trial",
				"salience": 0.00070291903,
				"type": "EVENT"
			},
			{
				"name": "efforts",
				"salience": 0.00070291903,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0005184475,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0tz54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salem,_Massachusetts"
				},
				"name": "Salem",
				"salience": 0.0004326035,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:03.970+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.9,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Professor Who Tweeted Against PC Culture Is Out at NYU Melkorka Licea, New York Post, October 30, 2016 \nAn NYU professor crusading against political correctness and student coddling was booted from the classroom last week after his colleagues complained about his “incivility,” The Post has learned. \nLiberal studies prof Michael Rectenwald, 57, said he was forced Wednesday to go on paid leave for the rest of the semester. \n{snip} \nRectenwald launched an undercover Twitter account called Deplorable NYU Prof on Sept. 12 to argue against campus trends like “safe spaces,” “trigger warnings” policing Halloween costumes and other aspects of academia’s growing PC culture. \nHe chose to be anonymous, he explained in one of his first tweets, because he was afraid “the PC Gestapo would ruin me” if he put his name ­behind his conservative ideas on the famously liberal campus. \n{snip} \nBut the Twitter feed soon sparked a “witch hunt” by the growing army of “social justice warriors,” he said. \nIn an interview published Monday in the Washington Square News, NYU’s Independent Student Newspaper, the eight-year instructor admitted he was the Deplorable NYU Prof. \n“My contention is that trigger warning, safe spaces and bias hot-line reporting is not politically correct. It is insane,” he told the student paper. “The crazier and crazier that this left gets . . . the more the alt-right is going to be laughing their asses off [and] getting more pissed.”, he was quoted as saying. \n{snip} \nBut Rectenwald says he began getting “dirty looks” in his department and on Wednesday figured out why: A 12-person committee calling itself the Liberal Studies Diversity, Equity and Inclusion Working Group, including two deans, published a letter to the editor in the same paper. \n“As long as he airs his views with so little appeal to evidence and civility, we must find him guilty of illogic and incivility in a community that predicates its work in great part on rational thought and the civil exchange of ideas,” they wrote of the untenured assistant professor. \n“We seek to create a dynamic community that values full participation. Such efforts are not the ‘destruction of academic integrity’ Professor Rectenwald suggests, but rather what make possible our program’s approach to global studies,” they argued. Rectenwald likened the attack to “a Salem witch trial. They took my views personally. I never even mentioned them and I never even said NYU liberal studies program. I was talking about academia at large,” said the professor, a popular instructor who was graded 4.4 out of 5 on ratemyprofessors.com . \nThe same day the letter was published, Rectenwald was summoned to a meeting with his department dean and an HR representative, he says. \n“They claimed they were worried about me and a couple people had expressed concern about my mental health. They suggested my voicing these opinions was a cry for help,” Rectenwald told The Post. “Then they said I should leave and get help.” \n{snip} \nStudents told him that professors openly discussed with students how he may be fired. \nThe leave has “absolutely zero to do with his Twitter account or his opinions on issues of the day,” said NYU spokesman Matt Nagel. \nBut Rectenwald is disheartened. \n“I’m afraid my academic career is over,” he said Rectenwald. “Academic freedom: It’s great, as long as you don’t use it.”",
		"thread_title": "Professor Who Tweeted Against PC Culture Is Out at NYU",
		"title": "Professor Who Tweeted Against PC Culture Is Out at NYU",
		"type": "bs",
		"uuid": "61b285862f0161d715db42c8d1b160fa69de2441"
	},
	"-KhIgjTG_Mrtt25ZJI6J": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:14.790+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "police",
				"salience": 0.25274235,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.089213006,
				"type": "PERSON"
			},
			{
				"name": "forum",
				"salience": 0.037565168,
				"type": "OTHER"
			},
			{
				"name": "poster-hanging(s)",
				"salience": 0.023529021,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.02109127,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01j_cy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan_State_University"
				},
				"name": "Michigan State University",
				"salience": 0.019020483,
				"type": "ORGANIZATION"
			},
			{
				"name": "events",
				"salience": 0.017451117,
				"type": "EVENT"
			},
			{
				"name": "group",
				"salience": 0.01597828,
				"type": "ORGANIZATION"
			},
			{
				"name": "Alt-Right",
				"salience": 0.014236088,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.013900779,
				"type": "OTHER"
			},
			{
				"name": "student newspaper",
				"salience": 0.01384762,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack dogs",
				"salience": 0.01384762,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.01384762,
				"type": "EVENT"
			},
			{
				"name": "leftists",
				"salience": 0.01384762,
				"type": "PERSON"
			},
			{
				"name": "veteran",
				"salience": 0.01384762,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04vz2x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lou_Anna_Simon"
				},
				"name": "Lou Anna Simon",
				"salience": 0.012387821,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.012281624,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.012281624,
				"type": "EVENT"
			},
			{
				"name": "Posters",
				"salience": 0.009914272,
				"type": "OTHER"
			},
			{
				"name": "Kyle Bristow",
				"salience": 0.009449477,
				"type": "PERSON"
			},
			{
				"name": "bulletin boards",
				"salience": 0.009080193,
				"type": "ORGANIZATION"
			},
			{
				"name": "Foundation for the Marketplace of Ideas",
				"salience": 0.008540801,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06rmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_Poverty_Law_Center"
				},
				"name": "SPLC",
				"salience": 0.008540801,
				"type": "ORGANIZATION"
			},
			{
				"name": "campus",
				"salience": 0.0079096295,
				"type": "LOCATION"
			},
			{
				"name": "university buildings",
				"salience": 0.007348825,
				"type": "LOCATION"
			},
			{
				"name": "views",
				"salience": 0.007308741,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.006600734,
				"type": "ORGANIZATION"
			},
			{
				"name": "individuals",
				"salience": 0.006600734,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.006600734,
				"type": "EVENT"
			},
			{
				"name": "kind",
				"salience": 0.006488707,
				"type": "OTHER"
			},
			{
				"name": "campus community",
				"salience": 0.005717464,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.005717464,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.005717464,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.0051642475,
				"type": "WORK_OF_ART"
			},
			{
				"name": "language",
				"salience": 0.005037692,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.0049412027,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.004901837,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0048335777,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0048335777,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.0046380977,
				"type": "WORK_OF_ART"
			},
			{
				"name": "posters",
				"salience": 0.0046380977,
				"type": "OTHER"
			},
			{
				"name": "postering",
				"salience": 0.0046380977,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004604353,
				"type": "PERSON"
			},
			{
				"name": "posters",
				"salience": 0.004465217,
				"type": "OTHER"
			},
			{
				"name": "postering",
				"salience": 0.004465217,
				"type": "OTHER"
			},
			{
				"name": "postering",
				"salience": 0.004465217,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.004465217,
				"type": "WORK_OF_ART"
			},
			{
				"name": "poster",
				"salience": 0.004465217,
				"type": "OTHER"
			},
			{
				"name": "postering campaigns",
				"salience": 0.0040444047,
				"type": "OTHER"
			},
			{
				"name": "identification",
				"salience": 0.0040019182,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0038039281,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.0037873965,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.0037873965,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.0037873965,
				"type": "OTHER"
			},
			{
				"name": "poster",
				"salience": 0.0037873965,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0037648026,
				"type": "OTHER"
			},
			{
				"name": "attorney",
				"salience": 0.0037366834,
				"type": "PERSON"
			},
			{
				"name": "rights",
				"salience": 0.0034562177,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0033742047,
				"type": "OTHER"
			},
			{
				"name": "campus events",
				"salience": 0.0033742047,
				"type": "EVENT"
			},
			{
				"name": "tape",
				"salience": 0.0032074735,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "glue",
				"salience": 0.0032074735,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.0031931598,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.0031931598,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "attorney",
				"salience": 0.0030700064,
				"type": "PERSON"
			},
			{
				"name": "Tape",
				"salience": 0.0030489704,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "glue",
				"salience": 0.0030489704,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.003035363,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0028666798,
				"type": "EVENT"
			},
			{
				"name": "statements",
				"salience": 0.0027712672,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0027363715,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0027019146,
				"type": "PERSON"
			},
			{
				"name": "diversity-mongers",
				"salience": 0.0026906843,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0026342957,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0025229405,
				"type": "PERSON"
			},
			{
				"name": "universities",
				"salience": 0.0024708258,
				"type": "ORGANIZATION"
			},
			{
				"name": "universities",
				"salience": 0.0024708258,
				"type": "ORGANIZATION"
			},
			{
				"name": "security cameras",
				"salience": 0.0022780867,
				"type": "OTHER"
			},
			{
				"name": "interlopers",
				"salience": 0.0022780867,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0022780867,
				"type": "PERSON"
			},
			{
				"name": "case cameras",
				"salience": 0.0022780867,
				"type": "OTHER"
			},
			{
				"name": "consent state",
				"salience": 0.0021782198,
				"type": "ORGANIZATION"
			},
			{
				"name": "bulletin board",
				"salience": 0.0021396875,
				"type": "OTHER"
			},
			{
				"name": "viewpoint",
				"salience": 0.0021396875,
				"type": "OTHER"
			},
			{
				"name": "posters",
				"salience": 0.0020615289,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0020492217,
				"type": "OTHER"
			},
			{
				"name": "edges",
				"salience": 0.0020492217,
				"type": "LOCATION"
			},
			{
				"name": "classrooms",
				"salience": 0.0020492217,
				"type": "LOCATION"
			},
			{
				"name": "dormitories",
				"salience": 0.0020492217,
				"type": "LOCATION"
			},
			{
				"name": "identifiers",
				"salience": 0.0020270993,
				"type": "OTHER"
			},
			{
				"name": "distribution",
				"salience": 0.0019727573,
				"type": "OTHER"
			},
			{
				"name": "teams",
				"salience": 0.0019727573,
				"type": "ORGANIZATION"
			},
			{
				"name": "vicinity",
				"salience": 0.0019727573,
				"type": "OTHER"
			},
			{
				"name": "advance",
				"salience": 0.0019727573,
				"type": "OTHER"
			},
			{
				"name": "suggestions",
				"salience": 0.0019727573,
				"type": "OTHER"
			},
			{
				"name": "forum",
				"salience": 0.0019319978,
				"type": "EVENT"
			},
			{
				"name": "speech",
				"salience": 0.0019319978,
				"type": "EVENT"
			},
			{
				"name": "building",
				"salience": 0.0019319978,
				"type": "LOCATION"
			},
			{
				"name": "Amendments",
				"salience": 0.0018991437,
				"type": "WORK_OF_ART"
			},
			{
				"name": "someone",
				"salience": 0.0018868468,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0017771138,
				"type": "ORGANIZATION"
			},
			{
				"name": "argument",
				"salience": 0.0017600484,
				"type": "OTHER"
			},
			{
				"name": "First",
				"salience": 0.0016730211,
				"type": "LOCATION"
			},
			{
				"name": "government actors",
				"salience": 0.0016730211,
				"type": "PERSON"
			},
			{
				"name": "wall",
				"salience": 0.0016730211,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.0016730211,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0016730211,
				"type": "PERSON"
			},
			{
				"name": "episode",
				"salience": 0.0016519447,
				"type": "WORK_OF_ART"
			},
			{
				"name": "right",
				"salience": 0.0016057147,
				"type": "OTHER"
			},
			{
				"name": "attorney present",
				"salience": 0.0015773029,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0015600903,
				"type": "PERSON"
			},
			{
				"name": "posters",
				"salience": 0.0015401393,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state",
				"salience": 0.0014891367,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.0014433482,
				"type": "PERSON"
			},
			{
				"name": "interactions",
				"salience": 0.0014433482,
				"type": "OTHER"
			},
			{
				"name": "tacks",
				"salience": 0.0014369022,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0014335583,
				"type": "OTHER"
			},
			{
				"name": "Normies",
				"salience": 0.0012614437,
				"type": "OTHER"
			},
			{
				"name": "recording purposes",
				"salience": 0.001249838,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.001249838,
				"type": "EVENT"
			},
			{
				"name": "court",
				"salience": 0.001249838,
				"type": "LOCATION"
			},
			{
				"name": "suspect",
				"salience": 0.001249838,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.001249838,
				"type": "ORGANIZATION"
			},
			{
				"name": "venue",
				"salience": 0.001249838,
				"type": "LOCATION"
			},
			{
				"name": "Cops",
				"salience": 0.001249838,
				"type": "ORGANIZATION"
			},
			{
				"name": "Targets",
				"salience": 0.001249838,
				"type": "OTHER"
			},
			{
				"name": "scope",
				"salience": 0.001249838,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.001249838,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0012456129,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0012456129,
				"type": "PERSON"
			},
			{
				"name": "obligation",
				"salience": 0.0011953934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gl3g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Basic_Law_for_the_Federal_Republic_of_Germany"
				},
				"name": "Constitution",
				"salience": 0.0011892611,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0011892611,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0011642849,
				"type": "PERSON"
			},
			{
				"name": "viewers",
				"salience": 0.0011642849,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.0010512305,
				"type": "OTHER"
			},
			{
				"name": "identifiers",
				"salience": 0.0009414557,
				"type": "OTHER"
			},
			{
				"name": "victim",
				"salience": 0.00091027113,
				"type": "PERSON"
			},
			{
				"name": "protection order",
				"salience": 0.00091027113,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.00091027113,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.00091027113,
				"type": "OTHER"
			},
			{
				"name": "litigation",
				"salience": 0.00091027113,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00091027113,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00087363896,
				"type": "OTHER"
			},
			{
				"name": "police officer",
				"salience": 0.00083668245,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.00078527356,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.00067996595,
				"type": "OTHER"
			},
			{
				"name": "birth date",
				"salience": 0.00067996595,
				"type": "OTHER"
			},
			{
				"name": "phone number",
				"salience": 0.00067996595,
				"type": "OTHER"
			},
			{
				"name": "address",
				"salience": 0.00067996595,
				"type": "OTHER"
			},
			{
				"name": "driver's license",
				"salience": 0.00067996595,
				"type": "OTHER"
			},
			{
				"name": "trespass",
				"salience": 0.00067996595,
				"type": "OTHER"
			},
			{
				"name": "vandalism",
				"salience": 0.00067996595,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.00059896824,
				"type": "OTHER"
			},
			{
				"name": "Brandenburg v. Ohio",
				"salience": 0.00056023244,
				"type": "ORGANIZATION"
			},
			{
				"name": "name",
				"salience": 0.0005550766,
				"type": "OTHER"
			},
			{
				"name": "Acute Triggering Syndrome",
				"salience": 0.00045156587,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:14.790+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Kyle Bristow, Foundation for the Marketplace of Ideas, October 30, 2016 \n{snip} As a veteran of trolling leftists for an entire decade (the SPLC whines I have “been playing * * * [this] same kind of game for many years” and that I am “one of the Alt-Right’s most vicious attack dogs” ; the student newspaper of Michigan State University noted in 2006 that my group planned to “have more events such as chalking * * * [and] poster-hanging[s]” ; Michigan State University’s President Lou Anna Simon releases a statement in 2007 which pertinently states “In recent weeks, there have been incidents on campus that once again compel us to look at the issues of free speech and how we as a campus community engage with one another in ways that respect the views of multiple groups and individuals. * * * There are individuals who speak at campus events whose rhetoric and ideas I find reprehensible[.]” ), I have personal experience with postering campaigns, and as an attorney, I know exactly where the line is that cannot be crossed. Here are suggestions to Alt-Right activists who are interested in hanging up posters: Do not get caught. Targets for postering should be explored in advance of distribution so as to make sure that there are no security cameras in the vicinity. (Do not wear similar clothing when the venue is explored as is worn at the time of the postering in case cameras are present.) Use teams of at least three–one person hangs up posters and two people watch for interlopers. The best time to poster is between 10:00 p.m. and midnight—any earlier, and one is likely to run into Normies, and any later, one will attract unwanted attention. Tape is best to use for postering and the tape should be used along all four edges of the posters so as to prevent them from being ripped down; tacks can easily be removed to take down posters and glue should not be used because glue is too messy and time-consuming. Hanging up posters in university buildings that contain only classrooms at night is better than dormitories because one is less likely to run into people who may tear down the posters. Only hang up posters at public–not private–universities and on public bulletin boards. Public universities must comply with the U.S. Constitution–and the First and Fourteenth Amendments prohibit government actors from discriminating against viewpoint or the content of speech. Only hang up posters on public bulletin boards since an argument can be made if one is caught that this is either a public forum or limited public forum . If one hangs up a poster on a wall of a building or on a non-public bulletin board, diversity-mongers who are offended by the posters may allege that criminal vandalism or criminal trespass occurred. Do not voluntarily disclose information if caught. If someone who is not a police officer demands one’s identification, one is under no obligation to provide it. If a police officer demands one’s identification, only the identifiers on a driver’s license and identifiers that are not incriminating should be provided (name, address, phone number, birth date, etc). One should not say anything else to the police other than “I respectfully invoke my right to remain silent, I respectfully invoke my right to have an attorney present, and am I being detained?” Such language invokes rights that are outside the scope of this brief article, but anyone who has ever watched an episode of Cops would know that statements made by a criminal suspect can be used against that person in court and lying to the police during an investigation is a crime in and of itself. If one’s state is a one-party consent state for recording purposes , one should secretly record any and all interactions with law enforcement. One should immediately consult with a licensed attorney in their state who is experienced with criminal defense or civil litigation if police become involved due to one hanging up posters. Do not publish posters that target individual people. This could result in harassment-related criminal charges, a civil lawsuit, or a personal protection order being pursued by the victim. Posters that are merely generically inflammatory but which do not direct the viewers to “imminent lawless action” are constitutionally permissible. Brandenburg v. Ohio , 395 U.S. 444 (1969) . \nNow go out and cause Acute Triggering Syndrome.",
		"thread_title": "Postering Advice for Alt-Right Guerrilla Activists",
		"title": "Postering Advice for Alt-Right Guerrilla Activists",
		"type": "bs",
		"uuid": "85cd548ac02b4dab0a8fd991ddad0de93c710db1"
	},
	"-KhIgjfL5MpmR35Fpyvq": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:16.742+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "effort",
				"salience": 0.37139335,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0svqyn7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Airbnb"
				},
				"name": "Airbnb",
				"salience": 0.16359796,
				"type": "ORGANIZATION"
			},
			{
				"name": "Community Commitment",
				"salience": 0.16061191,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.058495495,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.03520368,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.029072965,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.01495849,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.012607131,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.008856128,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.007235625,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.007235625,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0071389666,
				"type": "PERSON"
			},
			{
				"name": "account",
				"salience": 0.0070641353,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0061845947,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.005409887,
				"type": "OTHER"
			},
			{
				"name": "heads",
				"salience": 0.005313764,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.005010383,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0048237657,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.0046478594,
				"type": "OTHER"
			},
			{
				"name": "judgment",
				"salience": 0.0043398878,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0043398878,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.0043398878,
				"type": "OTHER"
			},
			{
				"name": "orientation",
				"salience": 0.004178186,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.004178186,
				"type": "EVENT"
			},
			{
				"name": "religion",
				"salience": 0.004178186,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.004178186,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.004178186,
				"type": "OTHER"
			},
			{
				"name": "disability",
				"salience": 0.004178186,
				"type": "OTHER"
			},
			{
				"name": "sex",
				"salience": 0.004178186,
				"type": "OTHER"
			},
			{
				"name": "gender identity",
				"salience": 0.004178186,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0041256323,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.0039427043,
				"type": "OTHER"
			},
			{
				"name": "tablet",
				"salience": 0.0035441483,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "app",
				"salience": 0.0035441483,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "feedback",
				"salience": 0.0033416145,
				"type": "OTHER"
			},
			{
				"name": "feedback",
				"salience": 0.0030581262,
				"type": "OTHER"
			},
			{
				"name": "guests",
				"salience": 0.002582239,
				"type": "PERSON"
			},
			{
				"name": "reservations",
				"salience": 0.002582239,
				"type": "OTHER"
			},
			{
				"name": "nondiscrimination efforts",
				"salience": 0.0024673643,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0019294188,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0019294188,
				"type": "WORK_OF_ART"
			},
			{
				"name": "option",
				"salience": 0.0015752658,
				"type": "OTHER"
			},
			{
				"name": "trips",
				"salience": 0.0014415077,
				"type": "EVENT"
			},
			{
				"name": "book",
				"salience": 0.0014415077,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Airbnb Team",
				"salience": 0.0011877816,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:16.742+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Airbnb, October 29, 2016 \nHi, \nEarlier this year, we launched a comprehensive effort to fight bias and discrimination in the Airbnb community. As a result of this effort, we’re asking everyone to agree to a Community Commitment beginning November 1, 2016. Agreeing to this commitment will affect your use of Airbnb, so we wanted to give you a heads up about it. \nWhat is the Community Commitment? \nYou commit to treat everyone–regardless of race, religion, national origin, ethnicity, disability, sex, gender identity, sexual orientation or age–with respect, and without judgment or bias. \nHow do I accept the commitment? \nOn or after November 1, we’ll show you the commitment when you log in to or open the Airbnb website, mobile or tablet app and we’ll automatically ask you to accept. \nWhat if I decline the commitment? \nIf you decline the commitment, you won’t be able to host or book using Airbnb, and you have the option to cancel your account. Once your account is canceled, future booked trips will be canceled. You will still be able to browse Airbnb but you won’t be able to book any reservations or host any guests. \nWhat if I have feedback about the commitment? \nWe welcome your feedback about the Community Commitment and all of our nondiscrimination efforts. Feel free to read more about the commitment. You can also reach out to us at [email protected] \nThe Airbnb Team",
		"thread_title": "The Airbnb Community Commitment",
		"title": "The Airbnb Community Commitment",
		"type": "bs",
		"uuid": "088156d5d342c47b21650b647ce5f5fe96a04f60"
	},
	"-KhIgjsRBl5ZOd_J6M80": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:19.428+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02qtlv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Border_Patrol"
				},
				"name": "U.S. Border Patrol",
				"salience": 0.16323133,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.1025009,
				"type": "LOCATION"
			},
			{
				"name": "Brandon Judd",
				"salience": 0.08245846,
				"type": "PERSON"
			},
			{
				"name": "Breitbart Texas",
				"salience": 0.07306672,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.043707453,
				"type": "LOCATION"
			},
			{
				"name": "Agents",
				"salience": 0.037464213,
				"type": "PERSON"
			},
			{
				"name": "Election",
				"salience": 0.030499874,
				"type": "EVENT"
			},
			{
				"name": "record number",
				"salience": 0.030499874,
				"type": "OTHER"
			},
			{
				"name": "custody",
				"salience": 0.030499874,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/038r8p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._Customs_and_Border_Protection"
				},
				"name": "Customs and Border Protection",
				"salience": 0.029699393,
				"type": "ORGANIZATION"
			},
			{
				"name": "aliens",
				"salience": 0.025495678,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.02333071,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.018866748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.018866748,
				"type": "PERSON"
			},
			{
				"name": "Rio Grande Valley Sector",
				"salience": 0.017440084,
				"type": "LOCATION"
			},
			{
				"name": "Accuse Feds of Covering Up Record Border Detainee Numbers",
				"salience": 0.0157577,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02vq8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rio_Grande_Valley"
				},
				"name": "RGV",
				"salience": 0.014025297,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05b43nv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brandon_Darby"
				},
				"name": "Brandon Darby",
				"salience": 0.013656738,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.012801553,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.012354747,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Johnson",
				"salience": 0.008200579,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cc5v7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Border_Patrol_Council"
				},
				"name": "National Border Patrol Council",
				"salience": 0.008052935,
				"type": "ORGANIZATION"
			},
			{
				"name": "parent agency",
				"salience": 0.007973459,
				"type": "ORGANIZATION"
			},
			{
				"name": "Agent",
				"salience": 0.007206366,
				"type": "PERSON"
			},
			{
				"name": "border",
				"salience": 0.0065435222,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.00647523,
				"type": "EVENT"
			},
			{
				"name": "leadership",
				"salience": 0.006210217,
				"type": "OTHER"
			},
			{
				"name": "information secret",
				"salience": 0.0059830784,
				"type": "OTHER"
			},
			{
				"name": "Agent",
				"salience": 0.005595395,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0047791055,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0045695286,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0045431056,
				"type": "OTHER"
			},
			{
				"name": "custody",
				"salience": 0.0043737707,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0043737707,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0041975314,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.004038235,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0037098487,
				"type": "EVENT"
			},
			{
				"name": "public",
				"salience": 0.0036491184,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0036491184,
				"type": "OTHER"
			},
			{
				"name": "aliens",
				"salience": 0.0036491184,
				"type": "OTHER"
			},
			{
				"name": "pull factors",
				"salience": 0.0035419615,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0032827272,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0032827272,
				"type": "LOCATION"
			},
			{
				"name": "conscience",
				"salience": 0.0032827272,
				"type": "OTHER"
			},
			{
				"name": "amnesty",
				"salience": 0.0031603044,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.0031603044,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0031603044,
				"type": "PERSON"
			},
			{
				"name": "breaking point",
				"salience": 0.0031603044,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0030950445,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0029910768,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0029816923,
				"type": "WORK_OF_ART"
			},
			{
				"name": "custody",
				"salience": 0.002772112,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.002772112,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0026942603,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.0026803627,
				"type": "ORGANIZATION"
			},
			{
				"name": "truth",
				"salience": 0.0026803627,
				"type": "OTHER"
			},
			{
				"name": "loved ones",
				"salience": 0.0026803627,
				"type": "PERSON"
			},
			{
				"name": "reporter",
				"salience": 0.002561096,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.002561096,
				"type": "OTHER"
			},
			{
				"name": "RGV Sector",
				"salience": 0.002488437,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0023022282,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.0021067702,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0020026169,
				"type": "OTHER"
			},
			{
				"name": "UPDATE",
				"salience": 0.0020026169,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0019378917,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.0018655802,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statistics",
				"salience": 0.0018655802,
				"type": "OTHER"
			},
			{
				"name": "press release section",
				"salience": 0.0018655802,
				"type": "OTHER"
			},
			{
				"name": "parent agency",
				"salience": 0.0018586415,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.0016844826,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0015086273,
				"type": "EVENT"
			},
			{
				"name": "border security",
				"salience": 0.0014586687,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0014586687,
				"type": "PERSON"
			},
			{
				"name": "family units",
				"salience": 0.0014586687,
				"type": "LOCATION"
			},
			{
				"name": "website",
				"salience": 0.0014586687,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0013937296,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0012584104,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0010896862,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0010896862,
				"type": "OTHER"
			},
			{
				"name": "denials",
				"salience": 0.0010896862,
				"type": "OTHER"
			},
			{
				"name": "assertions",
				"salience": 0.0010896862,
				"type": "OTHER"
			},
			{
				"name": "games",
				"salience": 0.0010896862,
				"type": "EVENT"
			},
			{
				"name": "DHS.gov",
				"salience": 0.00089783646,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00067067886,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.000509123,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:19.428+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Agents Accuse Feds of Covering Up Record Border Detainee Numbers for 2016 Election Brandon Darby, Breitbart, October 30, 2016 \nA record number of illegal aliens have crossed the U.S.- Mexico border and are in U.S. Border Patrol custody in Texas’ Rio Grande Valley Sector (RGV), according to the National Border Patrol Council (NBPC). Border Patrol Agent and NBPC President Brandon Judd spoke exclusively with Breitbart Texas and condemned the leadership of the Border Patrol’s parent agency, Customs and Border Protection (CBP), for allegedly “keeping this information secret” ahead of the 2016 U.S. presidential election. \n“We are at breaking point. We have the highest number of illegal aliens in custody in history in Border Patrol’s RGV Sector and this information has been kept from the American public,” said Agent Judd. “The talk of amnesty has once again created pull factors and encouraged people from all over the world to cross Mexico and then cross our porous southern border to illegally enter the U.S. We are simply overwhelmed.” {snip} \nAgent Judd told Breitbart Texas that Americans should vote their conscience, but they should do so with all of the information available. “This is an issue of the federal government restricting crucial information from the public ahead of a presidential election and it is unacceptable. Americans deserve to know the truth. Our Border Patrol agents deserve for Americans to know what they are really facing. Too many Border Patrol agents have given their lives and left loved ones to grieve for CBP leadership to play these types of political games ahead of such an impactful election.” \n{snip} \nHistorically, CBP, Border Patrol’s parent agency, has had to correct false assertions and denials. Perhaps the most glaring example occurred in June 2014 when an official CBP Twitter account directly accused this reporter of publishing a false report, only to later admit the report was accurate and true . \n{snip} \nUPDATE: Breitbart Texas received this response from CBP: \nFirst, the number in custody in RGV is less than half what is was in June 2014. \nAlso, I would refer you to Secretary Johnson’s statement about southwest border security issued October 17. In it, the Secretary addresses the specific issue of unaccompanied children and family units. The statement includes statistics for the full year of fiscal year 2016. \nYou can find it on DHS.gov in the press release section of the website.",
		"thread_title": "Agents Accuse Feds of Covering Up Record Border Detainee Numbers for 2016 Election",
		"title": "Agents Accuse Feds of Covering Up Record Border Detainee Numbers for 2016 Election",
		"type": "bs",
		"uuid": "a3b8cdaa9fa805af20fcb2f67c795d897e9446c7"
	},
	"-KhIgjyQC7GKSMEfwfJw": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:20.925+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "tail",
				"salience": 0.3971771,
				"type": "OTHER"
			},
			{
				"name": "ability differences",
				"salience": 0.14826241,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0578334,
				"type": "OTHER"
			},
			{
				"name": "Abstract Male",
				"salience": 0.03962372,
				"type": "PERSON"
			},
			{
				"name": "Science Direct",
				"salience": 0.034424018,
				"type": "PERSON"
			},
			{
				"name": "Matthew C. Makel",
				"salience": 0.034424018,
				"type": "PERSON"
			},
			{
				"name": "differences",
				"salience": 0.026714604,
				"type": "OTHER"
			},
			{
				"name": "achievement",
				"salience": 0.023183499,
				"type": "OTHER"
			},
			{
				"name": "adults",
				"salience": 0.023183499,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.023183499,
				"type": "OTHER"
			},
			{
				"name": "95th percentile",
				"salience": 0.023183499,
				"type": "OTHER"
			},
			{
				"name": "tail",
				"salience": 0.0130307125,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.012535717,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.011144238,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.011144238,
				"type": "PERSON"
			},
			{
				"name": "math",
				"salience": 0.009664521,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.009459915,
				"type": "PERSON"
			},
			{
				"name": "ratios",
				"salience": 0.009108662,
				"type": "OTHER"
			},
			{
				"name": "ability ratios",
				"salience": 0.008338692,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.008315219,
				"type": "LOCATION"
			},
			{
				"name": "science",
				"salience": 0.007897869,
				"type": "OTHER"
			},
			{
				"name": "sample",
				"salience": 0.007897869,
				"type": "OTHER"
			},
			{
				"name": "reasoning",
				"salience": 0.006843008,
				"type": "OTHER"
			},
			{
				"name": "males",
				"salience": 0.0059065223,
				"type": "PERSON"
			},
			{
				"name": "tail",
				"salience": 0.0058120475,
				"type": "OTHER"
			},
			{
				"name": "ratios",
				"salience": 0.0051594004,
				"type": "OTHER"
			},
			{
				"name": "domain",
				"salience": 0.005116768,
				"type": "OTHER"
			},
			{
				"name": "tail",
				"salience": 0.004345164,
				"type": "OTHER"
			},
			{
				"name": "females",
				"salience": 0.0043055248,
				"type": "OTHER"
			},
			{
				"name": "sample",
				"salience": 0.0043055248,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.004149339,
				"type": "LOCATION"
			},
			{
				"name": "ratios",
				"salience": 0.0038568343,
				"type": "OTHER"
			},
			{
				"name": "math ability",
				"salience": 0.0038568343,
				"type": "OTHER"
			},
			{
				"name": "patterns",
				"salience": 0.003824939,
				"type": "OTHER"
			},
			{
				"name": "Results",
				"salience": 0.0027871705,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:20.925+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Matthew C. Makel et al., Science Direct, October 31, 2016 \nAbstract \nMale–female ability differences in the right tail (at or above the 95th percentile) have been widely discussed for their potential role in achievement and occupational differences in adults. The present study provides updated male-female ability ratios from 320,000 7th grade students in the United States in the right tail (top 5%) through the extreme right tail (top 0.01%) from 2011 to 2015 using measures of math, verbal, and science reasoning. Additionally, the present study establishes male-female ability ratios in a sample of over 7000 7th grade students in the right tail from 2011 to 2015 in India. Results indicate that ratios in the extreme right tail of math ability in the U.S. have shrunk in the last 20 years (still favoring males) and remained relatively stable in the verbal domain (still favoring females). Similar patterns of male-female ratios in the extreme right tail were found in the Indian sample.",
		"thread_title": "Sex Differences in the Right Tail of Cognitive Abilities: An Update and Cross Cultural Extension",
		"title": "Sex Differences in the Right Tail of Cognitive Abilities: An Update and Cross Cultural Extension",
		"type": "bs",
		"uuid": "5cb142a8027e305cb4fa06496601c502cf6af457"
	},
	"-KhIgk3dbIexW7VzZsLD": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:22.857+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.46809822,
				"type": "PERSON"
			},
			{
				"name": "Speeches",
				"salience": 0.099951185,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.03318264,
				"type": "OTHER"
			},
			{
				"name": "corporation",
				"salience": 0.032714207,
				"type": "ORGANIZATION"
			},
			{
				"name": "limits",
				"salience": 0.029591573,
				"type": "OTHER"
			},
			{
				"name": "American Renaissance",
				"salience": 0.029360749,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.02272903,
				"type": "OTHER"
			},
			{
				"name": "limit",
				"salience": 0.020552125,
				"type": "OTHER"
			},
			{
				"name": "tax-deductible",
				"salience": 0.02004104,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.019702457,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.019702457,
				"type": "EVENT"
			},
			{
				"name": "fee",
				"salience": 0.017813487,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.017129939,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.015984768,
				"type": "ORGANIZATION"
			},
			{
				"name": "corporation",
				"salience": 0.015380534,
				"type": "ORGANIZATION"
			},
			{
				"name": "speech",
				"salience": 0.014633794,
				"type": "OTHER"
			},
			{
				"name": "tax-deductible",
				"salience": 0.01390377,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0133275855,
				"type": "PERSON"
			},
			{
				"name": "contributions",
				"salience": 0.0133275855,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.013053333,
				"type": "OTHER"
			},
			{
				"name": "business expense",
				"salience": 0.013053333,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.010889043,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.009286889,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0066839946,
				"type": "ORGANIZATION"
			},
			{
				"name": "engagements",
				"salience": 0.006163291,
				"type": "OTHER"
			},
			{
				"name": "expectation",
				"salience": 0.005318344,
				"type": "OTHER"
			},
			{
				"name": "pockets",
				"salience": 0.004606153,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.004606153,
				"type": "PERSON"
			},
			{
				"name": "doubt",
				"salience": 0.004606153,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.004606153,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:22.857+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Who Paid Hillary Clinton $21.7 Million to Give Speeches? American Renaissance, October 31, 2016 \nThere are legal limits on the amount of money a corporation can contribute to a political campaign, and the contributions are not tax-deductible. However, if a corporation pays someone to give a speech, there is no legal limit on what the company may pay, and the speaker’s fee is tax-deductible as a business expense. It is a very effective way to put money into the pockets of politician–no doubt with the expectation of future benefits. \nIn the last three years, companies have paid Hillary Clinton $21.7 million to give speeches. Here is a list of her 92 speaking engagements, the companies that hired her, and how much she was paid.",
		"thread_title": "Who Paid Hillary Clinton $21.7 Million to Give Speeches?",
		"title": "Who Paid Hillary Clinton $21.7 Million to Give Speeches?",
		"type": "bs",
		"uuid": "4c7bb1a900fcc3513d6647827e25c13bf3324110"
	},
	"-KhIgkIn6HMItyeRTA1y": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:56:23.312+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.20885506,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.1396945,
				"type": "PERSON"
			},
			{
				"name": "Siobhan McFadyen",
				"salience": 0.047005903,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.036890272,
				"type": "PERSON"
			},
			{
				"name": "Thousands",
				"salience": 0.029775508,
				"type": "PERSON"
			},
			{
				"name": "migrant policy",
				"salience": 0.027139066,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.022459975,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Gatestone Institute",
				"salience": 0.021313012,
				"type": "ORGANIZATION"
			},
			{
				"name": "catastrophe",
				"salience": 0.014447469,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.013941167,
				"type": "EVENT"
			},
			{
				"name": "crime",
				"salience": 0.013941167,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.013519549,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.013519549,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.010377971,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.010372961,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.010104592,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.009434162,
				"type": "PERSON"
			},
			{
				"name": "Express",
				"salience": 0.008913789,
				"type": "ORGANIZATION"
			},
			{
				"name": "crimes",
				"salience": 0.008683457,
				"type": "EVENT"
			},
			{
				"name": "aggression",
				"salience": 0.008683116,
				"type": "OTHER"
			},
			{
				"name": "robberies",
				"salience": 0.008541577,
				"type": "EVENT"
			},
			{
				"name": "drug trafficking",
				"salience": 0.008541577,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.007882594,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09_ztc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Criminal_Police_Office_(Germany)"
				},
				"name": "Federal Criminal Police Office",
				"salience": 0.007607895,
				"type": "ORGANIZATION"
			},
			{
				"name": "woes",
				"salience": 0.0073997844,
				"type": "OTHER"
			},
			{
				"name": "spate",
				"salience": 0.0073997844,
				"type": "OTHER"
			},
			{
				"name": "burglaries",
				"salience": 0.0073997844,
				"type": "EVENT"
			},
			{
				"name": "home invasions",
				"salience": 0.0073997844,
				"type": "EVENT"
			},
			{
				"name": "stabbings",
				"salience": 0.0073997844,
				"type": "OTHER"
			},
			{
				"name": "assaults",
				"salience": 0.0073997844,
				"type": "OTHER"
			},
			{
				"name": "Migrants",
				"salience": 0.006581532,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.00587332,
				"type": "PERSON"
			},
			{
				"name": "respondents",
				"salience": 0.005853451,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0055834646,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0055834646,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0055834646,
				"type": "LOCATION"
			},
			{
				"name": "Tania Kambouri",
				"salience": 0.0049776332,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.004757107,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thousands",
				"salience": 0.004368903,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.00434065,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0043139374,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0040398785,
				"type": "EVENT"
			},
			{
				"name": "migrants",
				"salience": 0.0039171455,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0039171455,
				"type": "LOCATION"
			},
			{
				"name": "crimes",
				"salience": 0.0038892839,
				"type": "EVENT"
			},
			{
				"name": "crime",
				"salience": 0.0038892839,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0037711181,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0037711181,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.0037287395,
				"type": "OTHER"
			},
			{
				"name": "rapes",
				"salience": 0.0036130971,
				"type": "EVENT"
			},
			{
				"name": "leader",
				"salience": 0.0035227227,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0035227227,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.0033192586,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0032125823,
				"type": "WORK_OF_ART"
			},
			{
				"name": "home countries",
				"salience": 0.0031985964,
				"type": "LOCATION"
			},
			{
				"name": "infrastructure",
				"salience": 0.0030508563,
				"type": "OTHER"
			},
			{
				"name": "invitation",
				"salience": 0.0030508563,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0030508563,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0030508563,
				"type": "PERSON"
			},
			{
				"name": "reality",
				"salience": 0.0030508563,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0030508563,
				"type": "LOCATION"
			},
			{
				"name": "elections",
				"salience": 0.0030508563,
				"type": "EVENT"
			},
			{
				"name": "surges",
				"salience": 0.0030508563,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.0026322945,
				"type": "OTHER"
			},
			{
				"name": "police officer",
				"salience": 0.0025797298,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0025797298,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gg68",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian_Democratic_Union_of_Germany"
				},
				"name": "Christian Democratic Union",
				"salience": 0.0024731886,
				"type": "ORGANIZATION"
			},
			{
				"name": "increase",
				"salience": 0.0024706905,
				"type": "OTHER"
			},
			{
				"name": "robbery",
				"salience": 0.0024706905,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.002464944,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.002464944,
				"type": "EVENT"
			},
			{
				"name": "respect",
				"salience": 0.0024412828,
				"type": "OTHER"
			},
			{
				"name": "suspect",
				"salience": 0.0024286895,
				"type": "PERSON"
			},
			{
				"name": "offenders",
				"salience": 0.0024105413,
				"type": "PERSON"
			},
			{
				"name": "rape",
				"salience": 0.0023785247,
				"type": "EVENT"
			},
			{
				"name": "spiralling levels",
				"salience": 0.0023785247,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0023785247,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0023702302,
				"type": "WORK_OF_ART"
			},
			{
				"name": "migrant offenders",
				"salience": 0.0022340436,
				"type": "PERSON"
			},
			{
				"name": "data",
				"salience": 0.0022225182,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.002139601,
				"type": "OTHER"
			},
			{
				"name": "pretences",
				"salience": 0.002139601,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.002139601,
				"type": "PERSON"
			},
			{
				"name": "asylum seekers",
				"salience": 0.002139601,
				"type": "PERSON"
			},
			{
				"name": "offenders",
				"salience": 0.002096865,
				"type": "PERSON"
			},
			{
				"name": "limit",
				"salience": 0.002059774,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.002059774,
				"type": "LOCATION"
			},
			{
				"name": "girl",
				"salience": 0.002059774,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.002059774,
				"type": "LOCATION"
			},
			{
				"name": "towns",
				"salience": 0.002059774,
				"type": "LOCATION"
			},
			{
				"name": "police report",
				"salience": 0.0020358271,
				"type": "WORK_OF_ART"
			},
			{
				"name": "courts",
				"salience": 0.002017222,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.00181456,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0017955521,
				"type": "EVENT"
			},
			{
				"name": "book",
				"salience": 0.0017468502,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attack",
				"salience": 0.0017468502,
				"type": "OTHER"
			},
			{
				"name": "leniency",
				"salience": 0.0017468502,
				"type": "OTHER"
			},
			{
				"name": "justice system",
				"salience": 0.0017468502,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0017468502,
				"type": "OTHER"
			},
			{
				"name": "behaviour",
				"salience": 0.0017468502,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0017409467,
				"type": "PERSON"
			},
			{
				"name": "figure",
				"salience": 0.0016604812,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.0016056865,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.001560025,
				"type": "WORK_OF_ART"
			},
			{
				"name": "consequences",
				"salience": 0.0015070641,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0015070641,
				"type": "OTHER"
			},
			{
				"name": "courts",
				"salience": 0.0015070641,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.0013414193,
				"type": "ORGANIZATION"
			},
			{
				"name": "Freddi Lohse",
				"salience": 0.0013171448,
				"type": "PERSON"
			},
			{
				"name": "police files",
				"salience": 0.0013050276,
				"type": "OTHER"
			},
			{
				"name": "probation",
				"salience": 0.0013050276,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.0013050276,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0013006163,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/070zc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saxony"
				},
				"name": "Saxony",
				"salience": 0.0012679849,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04kf4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leipzig"
				},
				"name": "Leipzig",
				"salience": 0.0012679849,
				"type": "LOCATION"
			},
			{
				"name": "German Police Union",
				"salience": 0.0012417806,
				"type": "ORGANIZATION"
			},
			{
				"name": "increase",
				"salience": 0.0011547743,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03hrz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamburg"
				},
				"name": "Hamburg",
				"salience": 0.0010752898,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.000950487,
				"type": "EVENT"
			},
			{
				"name": "subways",
				"salience": 0.000950487,
				"type": "OTHER"
			},
			{
				"name": "train stations",
				"salience": 0.000950487,
				"type": "LOCATION"
			},
			{
				"name": "property",
				"salience": 0.000950487,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.000950487,
				"type": "OTHER"
			},
			{
				"name": "lawlessness",
				"salience": 0.000950487,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.000950487,
				"type": "OTHER"
			},
			{
				"name": "body language",
				"salience": 0.0009150059,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.00090816367,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0008960932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.0008641425,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01jfhb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bild"
				},
				"name": "Bild",
				"salience": 0.0008032575,
				"type": "ORGANIZATION"
			},
			{
				"name": "streets",
				"salience": 0.00071001734,
				"type": "LOCATION"
			},
			{
				"name": "insults",
				"salience": 0.00071001734,
				"type": "OTHER"
			},
			{
				"name": "cop",
				"salience": 0.00071001734,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.00069223397,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034ndv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouGov"
				},
				"name": "YouGov",
				"salience": 0.00058499665,
				"type": "ORGANIZATION"
			},
			{
				"name": "traffic stop",
				"salience": 0.0005236858,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:56:23.312+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Siobhan McFadyen, Express, October 31, 2016 \nGerman Chancellor Angela Merkel is facing catastrophe over her failed migrant policy, according to a new report. \nDuring the first six months of 2016, migrants committed 142,500 crimes, according to the Federal Criminal Police Office. \nAnd the country has been hit by a spate of horrendous violent crime including rapes, sexual and physical assaults, stabbings, home invasions, robberies, burglaries and drug trafficking. \nAdding to the country’s woes is the fact that thousands of people have gone missing after travelling to the country on invitation from the country’s leader. \nGermany took in more than 1.1million migrants in the past year and parts of the country are crippled with a lack of infrastructure. \nNow the true reality is hitting home ahead of next year’s elections as the far right surges in the polls threatening to topple the Christian Democratic Union (CDU) leader Mrs Merkel. \nAccording to a report by the international policy council the Gatestone Institute, local police in many parts of the country admit that they are stretched to the limit. \nThe report states: “The rape of a ten-year-old girl in Leipzig, the largest city in Saxony, has drawn renewed attention to the spiralling levels of violent crime perpetrated by migrants in cities and towns across Germany. \n“During the first six months of 2016, migrants committed 142,500 crimes, according to the Federal Criminal Police Office. This is equivalent to 780 crimes committed by migrants every day, an increase of nearly 40 per cent over 2015. The data includes only those crimes in which a suspect has been caught. \n“Thousands of migrants who entered the country as ‘asylum seekers’ or ‘refugees’ have gone missing. They are, presumably, economic migrants who entered Germany on false pretences. \n“Many are thought to be engaging in robbery and criminal violence.” \nAccording to Freddi Lohse of the German Police Union in Hamburg, many migrant offenders view the leniency of the German justice system as a green light to continue delinquent behaviour, says the report. \nHe said: “They are used to tougher consequences in their home countries. \n“They have no respect for us.” \nMeanwhile a female police officer has admitted that officers are under attack and that the courts are a “joke.” \nIn a new book, Tania Kambouri, a German police officer, said: “For weeks, months and years I have noticed that Muslims, mostly young men, do not have even a minimum level of respect for the police. \n“When we are out patrolling the streets, we are verbally abused by young Muslims. \n“There is the body language, and insults like ‘s*** cop’ when passing by. \n“If we make a traffic stop, the aggression increases ever further, this is overwhelmingly the case with migrants. \n“It cannot be that offenders continue to fill the police files, hurt us physically, insult us, whatever, and there are no consequences. \n“Many cases are closed or offenders are released on probation or whatever. \n“Yes, what is happening in the courts today is a joke.” \nMigrants committed 208,344 crimes in 2015, according to a confidential police report leaked to Bild. \nThis figure represents an 80 per cent increase since 2014 and is equivalent to 570 crimes committed by migrants every day, or 23 crimes each hour, in 2015 alone. \nThe report added: “The growing sense of lawlessness is substantiated by an October 24 YouGov poll which found that 68 per cent of Germans believe that security in the country has deteriorated during the past several years. \n“Nearly 70 per cent of respondents said they fear for their lives and property in German train stations and subways, while 63 per cent feel unsafe at large public events.”",
		"thread_title": "‘We Are Losing Control of the Streets’ Merkel’s Germany Descends into Lawlessness",
		"title": "‘We Are Losing Control of the Streets’ Merkel’s Germany Descends into Lawlessness",
		"type": "bs",
		"uuid": "82af1cb2d31787f07e982af0f05bf0ce376e147b"
	},
	"-KhIgkWe5q5ifAJcfKhU": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:33.137+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.48632044,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.10480032,
				"type": "ORGANIZATION"
			},
			{
				"name": "Places",
				"salience": 0.023442,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.023442,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.023442,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0q76g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Midwestern_United_States"
				},
				"name": "Midwestern",
				"salience": 0.021717293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.018891893,
				"type": "LOCATION"
			},
			{
				"name": "Rapid Demographic Change",
				"salience": 0.018504912,
				"type": "EVENT"
			},
			{
				"name": "analysis",
				"salience": 0.01646152,
				"type": "OTHER"
			},
			{
				"name": "Paul Overberg",
				"salience": 0.014499135,
				"type": "PERSON"
			},
			{
				"name": "Janet Adamy",
				"salience": 0.014499135,
				"type": "PERSON"
			},
			{
				"name": "The Journal",
				"salience": 0.012193932,
				"type": "WORK_OF_ART"
			},
			{
				"name": "diversity index",
				"salience": 0.010968439,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0097207455,
				"type": "EVENT"
			},
			{
				"name": "immigration wave",
				"salience": 0.0097207455,
				"type": "EVENT"
			},
			{
				"name": "counties",
				"salience": 0.0075340527,
				"type": "LOCATION"
			},
			{
				"name": "newcomers",
				"salience": 0.00722378,
				"type": "PERSON"
			},
			{
				"name": "counties",
				"salience": 0.007027174,
				"type": "LOCATION"
			},
			{
				"name": "changes",
				"salience": 0.0062009785,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0057660006,
				"type": "OTHER"
			},
			{
				"name": "cluster",
				"salience": 0.005743941,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.005743941,
				"type": "LOCATION"
			},
			{
				"name": "shift",
				"salience": 0.00567176,
				"type": "OTHER"
			},
			{
				"name": "counties",
				"salience": 0.0051227463,
				"type": "LOCATION"
			},
			{
				"name": "census data",
				"salience": 0.0049755997,
				"type": "OTHER"
			},
			{
				"name": "needle",
				"salience": 0.0049755997,
				"type": "OTHER"
			},
			{
				"name": "emergence",
				"salience": 0.004384219,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0043428987,
				"type": "ORGANIZATION"
			},
			{
				"name": "immigration",
				"salience": 0.004030467,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0038802768,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.0038802768,
				"type": "PERSON"
			},
			{
				"name": "Hundreds",
				"salience": 0.0036722254,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.00364481,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0034908764,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.0034908764,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0034908764,
				"type": "OTHER"
			},
			{
				"name": "counties",
				"salience": 0.0034827637,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.0033607553,
				"type": "LOCATION"
			},
			{
				"name": "burst",
				"salience": 0.0033607553,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.0033607553,
				"type": "LOCATION"
			},
			{
				"name": "influxes",
				"salience": 0.0033607553,
				"type": "OTHER"
			},
			{
				"name": "shift",
				"salience": 0.00329139,
				"type": "EVENT"
			},
			{
				"name": "primaries",
				"salience": 0.00329139,
				"type": "EVENT"
			},
			{
				"name": "aberrations",
				"salience": 0.0031545565,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00294812,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.002850586,
				"type": "PERSON"
			},
			{
				"name": "epicenter",
				"salience": 0.002850586,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.002723796,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.002500501,
				"type": "OTHER"
			},
			{
				"name": "cluster",
				"salience": 0.0024595582,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0024595582,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00214979,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00214979,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_America"
				},
				"name": "Central America",
				"salience": 0.00214979,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v1s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indiana"
				},
				"name": "Indiana",
				"salience": 0.0020695988,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.0020695988,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latino",
				"salience": 0.0020695988,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wisconsin",
				"salience": 0.0020695988,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04ykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota"
				},
				"name": "Minnesota",
				"salience": 0.0020695988,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.0020695988,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.001984312,
				"type": "OTHER"
			},
			{
				"name": "counties",
				"salience": 0.0018960112,
				"type": "LOCATION"
			},
			{
				"name": "county",
				"salience": 0.0018960112,
				"type": "LOCATION"
			},
			{
				"name": "primaries",
				"salience": 0.0017917394,
				"type": "EVENT"
			},
			{
				"name": "counties",
				"salience": 0.0017795912,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0017552353,
				"type": "LOCATION"
			},
			{
				"name": "diversity index",
				"salience": 0.0015596497,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.001551602,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0014825406,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0012667553,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.0011591781,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011591781,
				"type": "PERSON"
			},
			{
				"name": "economists",
				"salience": 0.0011591781,
				"type": "PERSON"
			},
			{
				"name": "scientists",
				"salience": 0.0011591781,
				"type": "PERSON"
			},
			{
				"name": "tool",
				"salience": 0.0011591781,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:33.137+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Places Most Unsettled by Rapid Demographic Change Are Drawn to Donald Trump Janet Adamy and Paul Overberg, Wall Street Journal, November 1, 2016 \nSmall towns in the Midwest have diversified more quickly than almost any part of the U.S. since the start of an immigration wave at the beginning of this century. The resulting cultural changes appear to be moving the political needle. \nA Wall Street Journal analysis of census data shows that counties in a distinct cluster of Midwestern states–Iowa, Indiana, Wisconsin, Illinois and Minnesota–saw among the fastest influxes of nonwhite residents of anywhere in the U.S. between 2000 and 2015. Hundreds of cities long dominated by white residents got a burst of Latino newcomers who migrated from Central America or uprooted from California and Texas. \nThat shift helps explain the emergence of Republican presidential nominee Donald J. Trump as a political force, and signals that tensions over immigration will likely outlive his candidacy. Among GOP voters in this year’s presidential primaries, counties that diversified rapidly were more likely to vote for the New York businessman, the Journal’s analysis shows. \n{snip} \nThe Journal identified the epicenter of this shift using the diversity index, a tool often used by social scientists and economists. It measures the chance that any two people in a county will have a different race or ethnicity. In 244 counties, that diversity index at least doubled between 2000 and 2015, and more than half those counties were in the cluster of five Midwestern states. The analysis excludes tiny counties that produce numeric aberrations. \n{snip} \nMr. Trump won about 71% of sizable counties nationwide during the Republican presidential primaries. He took 73% of those where diversity at least doubled since 2000, and 80% of those where the diversity index rose at least 150%, the Journal’s analysis found. \n{snip}",
		"thread_title": "Places Most Unsettled by Rapid Demographic Change Are Drawn to Donald Trump",
		"title": "Places Most Unsettled by Rapid Demographic Change Are Drawn to Donald Trump",
		"type": "bs",
		"uuid": "805565b138003cf56979ca9d73294e90c7c54ca5"
	},
	"-KhIgkhsdYie4rRLpsfS": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:35.007+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "pro-Democratic African-Americans",
				"salience": 0.11098006,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.10410005,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-American",
				"salience": 0.07055205,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.05382136,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.050090563,
				"type": "PERSON"
			},
			{
				"name": "Turnout",
				"salience": 0.040034562,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.03473155,
				"type": "OTHER"
			},
			{
				"name": "boost",
				"salience": 0.03473155,
				"type": "OTHER"
			},
			{
				"name": "prospects",
				"salience": 0.03473155,
				"type": "OTHER"
			},
			{
				"name": "Data Shows African American",
				"salience": 0.03161117,
				"type": "OTHER"
			},
			{
				"name": "blizzard",
				"salience": 0.02913889,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.029043688,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.026860869,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.021476086,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.02100952,
				"type": "PERSON"
			},
			{
				"name": "swing-states",
				"salience": 0.01838894,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.01529249,
				"type": "LOCATION"
			},
			{
				"name": "voting",
				"salience": 0.014778696,
				"type": "EVENT"
			},
			{
				"name": "voters",
				"salience": 0.01333393,
				"type": "PERSON"
			},
			{
				"name": "Neil Munro",
				"salience": 0.0112865055,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.010871083,
				"type": "EVENT"
			},
			{
				"name": "Michael Bitzer",
				"salience": 0.010790145,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.009417769,
				"type": "LOCATION"
			},
			{
				"name": "Daniel Smith",
				"salience": 0.008703384,
				"type": "PERSON"
			},
			{
				"name": "percentage",
				"salience": 0.0076296893,
				"type": "OTHER"
			},
			{
				"name": "push",
				"salience": 0.0070040994,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02qry6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wolf_Blitzer"
				},
				"name": "Blitzer",
				"salience": 0.0065926583,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0063624303,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0061367373,
				"type": "ORGANIZATION"
			},
			{
				"name": "districts",
				"salience": 0.0059680464,
				"type": "LOCATION"
			},
			{
				"name": "politics",
				"salience": 0.005745629,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0053969286,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0053015533,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hilary Clinton",
				"salience": 0.00524028,
				"type": "PERSON"
			},
			{
				"name": "birther movement",
				"salience": 0.005168973,
				"type": "OTHER"
			},
			{
				"name": "urgency",
				"salience": 0.005168973,
				"type": "OTHER"
			},
			{
				"name": "appeals",
				"salience": 0.005168973,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.005168973,
				"type": "OTHER"
			},
			{
				"name": "adults",
				"salience": 0.005168973,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.005168973,
				"type": "OTHER"
			},
			{
				"name": "flirtations",
				"salience": 0.005168973,
				"type": "OTHER"
			},
			{
				"name": "trends",
				"salience": 0.0051355395,
				"type": "OTHER"
			},
			{
				"name": "deficit",
				"salience": 0.004976282,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.004976282,
				"type": "OTHER"
			},
			{
				"name": "enthusiasm",
				"salience": 0.004976282,
				"type": "OTHER"
			},
			{
				"name": "districts",
				"salience": 0.0048735626,
				"type": "LOCATION"
			},
			{
				"name": "shift",
				"salience": 0.0042208084,
				"type": "EVENT"
			},
			{
				"name": "resources",
				"salience": 0.0042208084,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0042208084,
				"type": "LOCATION"
			},
			{
				"name": "some",
				"salience": 0.0036717535,
				"type": "OTHER"
			},
			{
				"name": "worry",
				"salience": 0.0034029582,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.003183086,
				"type": "LOCATION"
			},
			{
				"name": "absentee ballots",
				"salience": 0.0031538182,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.0031538182,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0031538182,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0031538182,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0979qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catawba_College"
				},
				"name": "Catawba College",
				"salience": 0.0030643437,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ykg_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salisbury,_North_Carolina"
				},
				"name": "Salisbury",
				"salience": 0.0030643437,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0029521529,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0029380564,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.00265291,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.00265291,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0025539272,
				"type": "OTHER"
			},
			{
				"name": "races",
				"salience": 0.002297338,
				"type": "EVENT"
			},
			{
				"name": "blog",
				"salience": 0.002297338,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0019819895,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.0019415976,
				"type": "PERSON"
			},
			{
				"name": "continuation",
				"salience": 0.0017603637,
				"type": "OTHER"
			},
			{
				"name": "millenials",
				"salience": 0.001716286,
				"type": "PERSON"
			},
			{
				"name": "Old North State Politics",
				"salience": 0.0016331079,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/043gmq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tampa_Bay_Times"
				},
				"name": "Tampa Bay Times",
				"salience": 0.0014625919,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0012199815,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:35.007+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Early Voting Data Shows African American Turnout Dropping Neil Munro, Breitbart, October 31, 2016 \nA blizzard of early reports show that early voting by pro-Democratic African-Americans has dropped significantly compared to 2012, giving a boost to Donald Trump’s prospects in critical swing-states, such as North Carolina and Ohio. \nIn North Carolina, early voting by African-Americans is sharply down, so “you will see a very heavy push in this state for the African-American vote by Hilary Clinton to try to make up some of deficit,” said Michael Bitzer, a professor of politics and history at Catawba College, in Salisbury, N.C. \n{snip} \nNationally, “African-American enthusiasm has dipped compared with that in 2012,” according to the New York Times . That’s “a surprising and disquieting development for Democrats who believed Trump’s racial appeals and flirtations with the birther movement would generate more urgency,” the Times reported . For example, in the two Virginia districts with the largest percentage of African American adults, early voting has dropped by more than 50 percent, the Times said. \nIn Ohio, the decline of early voting in heavily Democratic African-American districts is causing worry for Democrats–and a shift of resources into the low-turnout areas. {snip} \nIn Florida, “the bad news for Clinton/good news for Trump is that African-Americans and millenials are voting considerably lighter–so far–than four years ago,” the Tampa Bay Times reported Oct. 31. \nDaniel Smith, a political science professor in Florida noted the rising level of early voting among whites and Hispanics, compared to to African-Americans. \nIn North Carolina, “white voters are currently 72 percent of all absentee ballots cast, with black voters being 22 percent and all other races 6 percent. This represents a steady continuation of the trends that we have seen, with white voters over-performing their 2012 numbers and black voters under-performing their 2012 numbers,” Blitzer said at his blog, Old North State Politics . \n{snip}",
		"thread_title": "Early Voting Data Shows African American Turnout Dropping",
		"title": "Early Voting Data Shows African American Turnout Dropping",
		"type": "bs",
		"uuid": "4ea593110cf4d217e7894f00a00551c306b71331"
	},
	"-KhIgktDVeeIT729J04P": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:35.857+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.24337286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.17636853,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.087857865,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.07011904,
				"type": "ORGANIZATION"
			},
			{
				"name": "returns",
				"salience": 0.033897478,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.031952184,
				"type": "PERSON"
			},
			{
				"name": "coalition",
				"salience": 0.02344315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07rqr6p"
				},
				"name": "Democrats",
				"salience": 0.019033957,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.018286124,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.01690685,
				"type": "EVENT"
			},
			{
				"name": "lifeline",
				"salience": 0.015279621,
				"type": "OTHER"
			},
			{
				"name": "news coverage",
				"salience": 0.013246423,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.013246423,
				"type": "ORGANIZATION"
			},
			{
				"name": "inquiry",
				"salience": 0.013246423,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.012304979,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.008176608,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09gk968",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Weigel"
				},
				"name": "David Weigel",
				"salience": 0.008176608,
				"type": "PERSON"
			},
			{
				"name": "places",
				"salience": 0.0067886864,
				"type": "LOCATION"
			},
			{
				"name": "minorities",
				"salience": 0.0067886864,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.006572006,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.006230989,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.006230989,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0061996942,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.005091873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latinos",
				"salience": 0.0043748724,
				"type": "PERSON"
			},
			{
				"name": "trend",
				"salience": 0.00419851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.004184133,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.004133201,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.0038746006,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0038746006,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.003579967,
				"type": "EVENT"
			},
			{
				"name": "returns",
				"salience": 0.003579967,
				"type": "OTHER"
			},
			{
				"name": "Enthusiasm",
				"salience": 0.003490462,
				"type": "PERSON"
			},
			{
				"name": "turnout",
				"salience": 0.0032328693,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0029769605,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0028995865,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.0027999408,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.0027999408,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0027999408,
				"type": "OTHER"
			},
			{
				"name": "polling",
				"salience": 0.002718042,
				"type": "OTHER"
			},
			{
				"name": "tracking poll",
				"salience": 0.002718042,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.002616696,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.002417576,
				"type": "LOCATION"
			},
			{
				"name": "battleground states",
				"salience": 0.002417576,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0023676564,
				"type": "PERSON"
			},
			{
				"name": "Sunia Wilson",
				"salience": 0.0022800728,
				"type": "PERSON"
			},
			{
				"name": "Polling",
				"salience": 0.002276327,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0022676021,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0022676021,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0022406173,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0022406173,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.002151819,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.002076595,
				"type": "EVENT"
			},
			{
				"name": "enthusiasm",
				"salience": 0.0020504484,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0020504484,
				"type": "LOCATION"
			},
			{
				"name": "views",
				"salience": 0.0020504484,
				"type": "OTHER"
			},
			{
				"name": "nonwhites",
				"salience": 0.0019637828,
				"type": "PERSON"
			},
			{
				"name": "lead",
				"salience": 0.0019637828,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0019637828,
				"type": "LOCATION"
			},
			{
				"name": "blacks",
				"salience": 0.0018990049,
				"type": "PERSON"
			},
			{
				"name": "chances",
				"salience": 0.0018905285,
				"type": "OTHER"
			},
			{
				"name": "counties",
				"salience": 0.0018905285,
				"type": "LOCATION"
			},
			{
				"name": "ones",
				"salience": 0.0018905285,
				"type": "LOCATION"
			},
			{
				"name": "trouble",
				"salience": 0.0018905285,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.0018905285,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0018905285,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0017241086,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0016582551,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0016582551,
				"type": "OTHER"
			},
			{
				"name": "dislike",
				"salience": 0.0016033594,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.0015435371,
				"type": "OTHER"
			},
			{
				"name": "boost",
				"salience": 0.0014672286,
				"type": "OTHER"
			},
			{
				"name": "Washington Post-ABC News",
				"salience": 0.0013961392,
				"type": "ORGANIZATION"
			},
			{
				"name": "TV ad",
				"salience": 0.0013946894,
				"type": "WORK_OF_ART"
			},
			{
				"name": "track",
				"salience": 0.0013832981,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0013832981,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.00120788,
				"type": "OTHER"
			},
			{
				"name": "obligation",
				"salience": 0.0011978742,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.0011978742,
				"type": "LOCATION"
			},
			{
				"name": "level",
				"salience": 0.0011978742,
				"type": "OTHER"
			},
			{
				"name": "voting restrictions",
				"salience": 0.0011978742,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.0011978742,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0011978742,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0011638766,
				"type": "ORGANIZATION"
			},
			{
				"name": "story",
				"salience": 0.0010288156,
				"type": "WORK_OF_ART"
			},
			{
				"name": "buts",
				"salience": 0.0008724705,
				"type": "OTHER"
			},
			{
				"name": "ands",
				"salience": 0.0008724705,
				"type": "OTHER"
			},
			{
				"name": "ifs",
				"salience": 0.0008724705,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.0008724705,
				"type": "OTHER"
			},
			{
				"name": "passion",
				"salience": 0.0008724705,
				"type": "OTHER"
			},
			{
				"name": "enthusiasm",
				"salience": 0.0008336241,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.000752678,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.000752678,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.000752678,
				"type": "ORGANIZATION"
			},
			{
				"name": "clip",
				"salience": 0.00074931607,
				"type": "WORK_OF_ART"
			},
			{
				"name": "apology",
				"salience": 0.00065175205,
				"type": "OTHER"
			},
			{
				"name": "crime bill",
				"salience": 0.00065175205,
				"type": "WORK_OF_ART"
			},
			{
				"name": "offenders",
				"salience": 0.00065175205,
				"type": "PERSON"
			},
			{
				"name": "super-predators",
				"salience": 0.00065175205,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00065175205,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.00065175205,
				"type": "PERSON"
			},
			{
				"name": "quote",
				"salience": 0.00065175205,
				"type": "OTHER"
			},
			{
				"name": "Chavis Community Center",
				"salience": 0.00053699646,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fvyg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raleigh,_North_Carolina"
				},
				"name": "Raleigh",
				"salience": 0.00053699646,
				"type": "LOCATION"
			},
			{
				"name": "Black Lives Matters",
				"salience": 0.00040112596,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:35.857+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "David Weigel, Washington Post, October 31, 2016 \n{snip} \nFollowing the latest FBI inquiry, which has dominated news coverage for days and has been described as a potential lifeline for Republican nominee Donald Trump, Clinton’s campaign is counting on its organization more than ever to revive the coalition that twice elected Barack Obama. \nIn places such as Michigan, that means turning out minorities in big numbers to overcome Trump’s advantage among white voters. The trend in early-voting returns has been both encouraging and worrying for the Clinton campaign: Enthusiasm among Latinos appears to be up, in some cases considerably, but African Americans are turning out in smaller numbers than they did with Obama on the ticket. \nThat’s the picture in Florida. Early returns show a boost in turnout in heavily Latino counties and a decline in largely African American ones. In a state such as Nevada, where Democrats are relying heavily on Latinos, early returns show they are voting in similar numbers as in 2012, boosting Democratic chances. But in battleground states such as Ohio where Democrats are counting on African Americans to put them over the top, they could be in trouble if blacks stay home. \nPolling shows a similar story. Clinton maintains a large lead among nonwhite voters in the Washington Post-ABC News tracking poll, but by a smaller margin than Obama did. In polling since Oct. 20, Clinton has led Trump by more than 3 to 1 among all nonwhites (69 percent to 19 percent), compared with President Obama’s margin of 80 percent to 19 percent in 2012. \nMoreover, nonwhite voters are more united by their strong dislike of Trump than positive views of Clinton–only 39 percent have a strongly favorable view of Clinton, while 68 percent have strongly unfavorable views toward Trump. \n{snip} \nIn closer states, Trump’s campaign is working to soften enthusiasm for Clinton among young black voters. One TV ad plays a clip of Clinton, then supportive of a new crime bill, referring to a group of young black offenders as “super-predators.” That two-decade-old quote–even after an apology–has dogged Clinton with some Black Lives Matters activists. Trump has also sought to dampen enthusiasm by casting life in black communities as something akin to apocalyptic. \n{snip} In North Carolina, where Democrats and civil rights groups won a high-profile lawsuit against Republican-backed voting restrictions, the early look is mixed. Total black turnout has fallen 17 percent from its 2012 level, but Democrats point to a shrunken number of early-voting locations to claim that they are on track. At the polls, the voters who are showing up said they feel an obligation, if not passion. \n“It’s not like four years ago when we knew we were going for Barack Obama, no ifs, ands and buts,” Sunia Wilson, 38, said after casting a ballot at the Chavis Community Center in Raleigh. “This year it’s like, ‘Hmmm. I don’t know.’ But I’ve got to vote.” \n{snip}",
		"thread_title": "As Race Tightens, Clinton Campaign Is Counting on Minority Support",
		"title": "As Race Tightens, Clinton Campaign Is Counting on Minority Support",
		"type": "bs",
		"uuid": "42a941931e456a2e7fccdece9fda31de6fd2adbf"
	},
	"-KhIgl9K1iPDoQlVq8lL": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:37.291+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0wdpqnj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyft"
				},
				"name": "Lyft Inc.",
				"salience": 0.24281988,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gx0wlr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uber_(company)"
				},
				"name": "Uber Technologies Inc.",
				"salience": 0.10853249,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d9jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Seattle"
				},
				"name": "Seattle",
				"salience": 0.030769978,
				"type": "LOCATION"
			},
			{
				"name": "Drivers",
				"salience": 0.029869871,
				"type": "PERSON"
			},
			{
				"name": "Drivers",
				"salience": 0.029869871,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0svqyn7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Airbnb"
				},
				"name": "Airbnb Inc.",
				"salience": 0.028565058,
				"type": "ORGANIZATION"
			},
			{
				"name": "rides",
				"salience": 0.028411103,
				"type": "OTHER"
			},
			{
				"name": "home-rental company",
				"salience": 0.02530091,
				"type": "ORGANIZATION"
			},
			{
				"name": "names",
				"salience": 0.02396599,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.021663811,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.021663811,
				"type": "PERSON"
			},
			{
				"name": "Discrimination",
				"salience": 0.02031943,
				"type": "OTHER"
			},
			{
				"name": "Study",
				"salience": 0.02031943,
				"type": "OTHER"
			},
			{
				"name": "drivers",
				"salience": 0.015363821,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.01177588,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.011730402,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.010426139,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.01025609,
				"type": "OTHER"
			},
			{
				"name": "customers",
				"salience": 0.009635537,
				"type": "PERSON"
			},
			{
				"name": "riders",
				"salience": 0.009102193,
				"type": "PERSON"
			},
			{
				"name": "Eric Newcomer",
				"salience": 0.009082779,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.009082779,
				"type": "ORGANIZATION"
			},
			{
				"name": "training",
				"salience": 0.008609066,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.008554311,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.008335105,
				"type": "PERSON"
			},
			{
				"name": "findings",
				"salience": 0.0076365955,
				"type": "OTHER"
			},
			{
				"name": "drivers",
				"salience": 0.00743705,
				"type": "PERSON"
			},
			{
				"name": "customers",
				"salience": 0.0057746675,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.0054487847,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.0050833044,
				"type": "PERSON"
			},
			{
				"name": "drivers",
				"salience": 0.0045707165,
				"type": "PERSON"
			},
			{
				"name": "drivers",
				"salience": 0.0044564623,
				"type": "PERSON"
			},
			{
				"name": "drivers",
				"salience": 0.0044564623,
				"type": "PERSON"
			},
			{
				"name": "technology companies",
				"salience": 0.0043033944,
				"type": "ORGANIZATION"
			},
			{
				"name": "discrimination",
				"salience": 0.0043033944,
				"type": "OTHER"
			},
			{
				"name": "riders",
				"salience": 0.0042360662,
				"type": "PERSON"
			},
			{
				"name": "rides",
				"salience": 0.0042360662,
				"type": "OTHER"
			},
			{
				"name": "research assistants",
				"salience": 0.004108753,
				"type": "PERSON"
			},
			{
				"name": "e-mails",
				"salience": 0.0040570637,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.004006023,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0039384393,
				"type": "ORGANIZATION"
			},
			{
				"name": "All",
				"salience": 0.0038317712,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0035905682,
				"type": "OTHER"
			},
			{
				"name": "drivers",
				"salience": 0.0035036206,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.003503214,
				"type": "OTHER"
			},
			{
				"name": "riders",
				"salience": 0.0034592312,
				"type": "PERSON"
			},
			{
				"name": "names",
				"salience": 0.003433297,
				"type": "OTHER"
			},
			{
				"name": "black",
				"salience": 0.0034013195,
				"type": "OTHER"
			},
			{
				"name": "drivers",
				"salience": 0.0031856354,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0031356465,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.0031096942,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.0031096942,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0030634145,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0030187268,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0029120601,
				"type": "OTHER"
			},
			{
				"name": "photos",
				"salience": 0.00290616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "photos",
				"salience": 0.00290616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.0028458235,
				"type": "OTHER"
			},
			{
				"name": "passengers",
				"salience": 0.0027890077,
				"type": "PERSON"
			},
			{
				"name": "apps",
				"salience": 0.0026849953,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "men",
				"salience": 0.0026295497,
				"type": "PERSON"
			},
			{
				"name": "appearance",
				"salience": 0.002539149,
				"type": "OTHER"
			},
			{
				"name": "photos",
				"salience": 0.0024648502,
				"type": "WORK_OF_ART"
			},
			{
				"name": "researchers",
				"salience": 0.0024387578,
				"type": "PERSON"
			},
			{
				"name": "site",
				"salience": 0.0024244857,
				"type": "OTHER"
			},
			{
				"name": "hosts",
				"salience": 0.0024244857,
				"type": "PERSON"
			},
			{
				"name": "hosts",
				"salience": 0.0024244857,
				"type": "PERSON"
			},
			{
				"name": "apps",
				"salience": 0.0022772306,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "passenger",
				"salience": 0.0022772306,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pwq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stanford_University"
				},
				"name": "Stanford University",
				"salience": 0.002211083,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Washington"
				},
				"name": "University of Washington",
				"salience": 0.002211083,
				"type": "ORGANIZATION"
			},
			{
				"name": "cars",
				"salience": 0.0022087877,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "calls",
				"salience": 0.0021809735,
				"type": "OTHER"
			},
			{
				"name": "biases",
				"salience": 0.002163165,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.002153509,
				"type": "WORK_OF_ART"
			},
			{
				"name": "test",
				"salience": 0.00212639,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.0020996123,
				"type": "OTHER"
			},
			{
				"name": "workforce",
				"salience": 0.0020996123,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0020996123,
				"type": "OTHER"
			},
			{
				"name": "advocates",
				"salience": 0.0020996123,
				"type": "PERSON"
			},
			{
				"name": "guests",
				"salience": 0.0020996123,
				"type": "PERSON"
			},
			{
				"name": "platform",
				"salience": 0.0020996123,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.002056242,
				"type": "EVENT"
			},
			{
				"name": "sounding",
				"salience": 0.002056242,
				"type": "OTHER"
			},
			{
				"name": "Drivers",
				"salience": 0.001981142,
				"type": "PERSON"
			},
			{
				"name": "driver",
				"salience": 0.001981142,
				"type": "PERSON"
			},
			{
				"name": "drivers",
				"salience": 0.001981142,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts_Institute_of_Technology"
				},
				"name": "Massachusetts Institute of Technology",
				"salience": 0.0019147766,
				"type": "ORGANIZATION"
			},
			{
				"name": "riders",
				"salience": 0.0018830446,
				"type": "PERSON"
			},
			{
				"name": "riders",
				"salience": 0.0018830446,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.0018732738,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0017806666,
				"type": "PERSON"
			},
			{
				"name": "headshot",
				"salience": 0.0017806666,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0017014128,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0015817725,
				"type": "OTHER"
			},
			{
				"name": "customer photos",
				"salience": 0.0015817725,
				"type": "WORK_OF_ART"
			},
			{
				"name": "races",
				"salience": 0.0015362588,
				"type": "EVENT"
			},
			{
				"name": "drivers",
				"salience": 0.0014801357,
				"type": "PERSON"
			},
			{
				"name": "drivers",
				"salience": 0.0014801357,
				"type": "PERSON"
			},
			{
				"name": "riders",
				"salience": 0.0014068279,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco",
				"salience": 0.0013426745,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.001341436,
				"type": "OTHER"
			},
			{
				"name": "app",
				"salience": 0.0013303233,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "same",
				"salience": 0.0013303233,
				"type": "OTHER"
			},
			{
				"name": "ride requests",
				"salience": 0.0013303233,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.0013303233,
				"type": "OTHER"
			},
			{
				"name": "passengers",
				"salience": 0.0012392737,
				"type": "PERSON"
			},
			{
				"name": "names",
				"salience": 0.0011841013,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0011841013,
				"type": "OTHER"
			},
			{
				"name": "tips",
				"salience": 0.0011139555,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African American",
				"salience": 0.0010961462,
				"type": "PERSON"
			},
			{
				"name": "discrimination",
				"salience": 0.0010021196,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0010021196,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0010021196,
				"type": "ORGANIZATION"
			},
			{
				"name": "discrimination",
				"salience": 0.0010021196,
				"type": "OTHER"
			},
			{
				"name": "fare",
				"salience": 0.0009689293,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00092578697,
				"type": "OTHER"
			},
			{
				"name": "apps",
				"salience": 0.00092578697,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "taxis",
				"salience": 0.00083588954,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.00083021884,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.00083021884,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0007238034,
				"type": "WORK_OF_ART"
			},
			{
				"name": "taxi industry",
				"salience": 0.0007238034,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.0007238034,
				"type": "OTHER"
			},
			{
				"name": "Knittel",
				"salience": 0.00051870104,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:37.291+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Study Finds Racial Discrimination by Uber and Lyft Drivers Eric Newcomer, Bloomberg, October 31, 2016 \nDrivers for Uber Technologies Inc. in Boston canceled rides for men with black-sounding names more than twice as often as for other men. Black people in Seattle using Uber and Lyft Inc. faced notably longer wait times to get paired with drivers than white customers. The findings come from a study published on Monday by researchers at the Massachusetts Institute of Technology, Stanford University and the University of Washington. \n{snip} \nA new generation of technology companies have begun to grapple with how they can minimize racial discrimination. Airbnb Inc. recently released an extensive report studying racial bias on the site and proposed some changes to its policies. The home-rental company committed to offering more training for its hosts and hiring a more diverse workforce. It sent e-mails to customers over the weekend saying they must agree not to discriminate in order to use the site starting next month. However, Airbnb has resisted advocates’ calls to remove photos of guests and hosts from its platform. \nIn the case of ride-hailing apps, researchers similarly believe that names and photos are an issue. Such information gives drivers the means to discriminate against prospective riders. Uber doesn’t show customer photos to drivers. Lyft does, but passengers aren’t required to provide a headshot. Both San Francisco-based companies give riders’ names to their drivers. \n{snip} \nThe study, conducted in Seattle and Boston, included almost 1,500 rides. Four black and four white research assistants–split evenly among men and women–ordered cars over six weeks in Seattle. All used their photos on the ride-sharing apps. A second test was held in Boston with riders “whose appearance allowed them to plausibly travel as a passenger of either race,” although they used either “African American sounding” or “white sounding” names, the researchers said. The study found that Uber drivers disproportionately canceled on riders with black-sounding names, even though the company penalizes drivers who cancel frequently. \n{snip} \nThe research also observed discrimination in the taxi industry–a well-known, decades-old issue. The paper doesn’t compare the rate of discrimination between traditional drivers for taxis or ride-hailing apps. Uber has suggested that it doesn’t offer tips in its app, as many drivers have asked for, because they can introduce racial biases. \nLyft and Uber face different issues. While researchers found that drivers took noticeably longer to accept ride requests from black men on both services in Seattle, total wait times were the same for both races on Lyft. On Uber, total wait times were longer for black men. Drivers using Lyft didn’t cancel on black riders disproportionately, but the researchers said that because Lyft shows riders’ names and faces upfront, its drivers could simply screen out black passengers. Uber doesn’t show names until after the driver accepts the fare. “In Lyft, you can discriminate without ever having to accept and hit cancel,” Knittel said. \n{snip}",
		"thread_title": "Study Finds Racial Discrimination by Uber and Lyft Drivers",
		"title": "Study Finds Racial Discrimination by Uber and Lyft Drivers",
		"type": "bs",
		"uuid": "b46b86638010451a58f14d575b5fb75032992af6"
	},
	"-KhIglGxJJUwXQ8dnPwQ": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:39.123+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.5219653,
				"type": "LOCATION"
			},
			{
				"name": "homicides",
				"salience": 0.17908186,
				"type": "EVENT"
			},
			{
				"name": "homicides",
				"salience": 0.10648118,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.051158164,
				"type": "LOCATION"
			},
			{
				"name": "Chicago Soars Past 600 Homicides",
				"salience": 0.03523575,
				"type": "ORGANIZATION"
			},
			{
				"name": "time",
				"salience": 0.027439034,
				"type": "OTHER"
			},
			{
				"name": "homicides",
				"salience": 0.015256771,
				"type": "OTHER"
			},
			{
				"name": "Homicides",
				"salience": 0.015256771,
				"type": "EVENT"
			},
			{
				"name": "shootings",
				"salience": 0.010003041,
				"type": "EVENT"
			},
			{
				"name": "victims",
				"salience": 0.008181035,
				"type": "PERSON"
			},
			{
				"name": "homicides",
				"salience": 0.0068343095,
				"type": "OTHER"
			},
			{
				"name": "pace",
				"salience": 0.005306894,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.003870335,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.003870335,
				"type": "OTHER"
			},
			{
				"name": "homicides",
				"salience": 0.003824842,
				"type": "OTHER"
			},
			{
				"name": "shooting victims",
				"salience": 0.0033405393,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0028937855,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:39.123+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Chicago Soars Past 600 Homicides After Bloody October CBS Chicago, November 1, 2016 \nWith 78 homicides, October was the second deadliest month of 2016, and Chicago surpassed 600 homicides for the first time in more than a decade. \nThe last time Chicago had at least 600 homicides in a single year was 2003. \nHomicides and non-fatal shootings have skyrocketed in 2016, with 605 homicides and more than 3,600 shooting victims through the end of October. \nIn October, there were 78 homicides and 427 shooting victims. Only August had more homicides, when 90 people were slain in Chicago. It was the bloodiest month in the city in 20 years. \nThe city is on pace for 726 homicides in 2016, a number not seen since the late 1990s. \n{snip}",
		"thread_title": "Chicago Soars Past 600 Homicides After Bloody October",
		"title": "Chicago Soars Past 600 Homicides After Bloody October",
		"type": "bs",
		"uuid": "a197729aa2c4d039cc48c435121c9cb4f1e103c8"
	},
	"-KhIglTFYuerU1PRSmgp": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:40.867+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02qwy1s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indianapolis_Metropolitan_Police_Department"
				},
				"name": "IMPD",
				"salience": 0.19796546,
				"type": "ORGANIZATION"
			},
			{
				"name": "Damoine Wilcoxson",
				"salience": 0.11833982,
				"type": "PERSON"
			},
			{
				"name": "Damoine Wilcoxson Wilcoxson",
				"salience": 0.09799136,
				"type": "PERSON"
			},
			{
				"name": "shell casings",
				"salience": 0.04142277,
				"type": "OTHER"
			},
			{
				"name": "HQ Shootings",
				"salience": 0.028408607,
				"type": "EVENT"
			},
			{
				"name": "shootings",
				"salience": 0.028408607,
				"type": "EVENT"
			},
			{
				"name": "suspect",
				"salience": 0.026449095,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.025069991,
				"type": "EVENT"
			},
			{
				"name": "headquarters",
				"salience": 0.025069991,
				"type": "LOCATION"
			},
			{
				"name": "standoff",
				"salience": 0.023749858,
				"type": "EVENT"
			},
			{
				"name": "shooting",
				"salience": 0.020040955,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0sk89",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionsville,_Indiana"
				},
				"name": "Zionsville",
				"salience": 0.018686196,
				"type": "LOCATION"
			},
			{
				"name": "Standoff Suspect",
				"salience": 0.018614264,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.016137337,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.016137337,
				"type": "PERSON"
			},
			{
				"name": "Zionsville Murder",
				"salience": 0.015501491,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012qcd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/SWAT"
				},
				"name": "SWAT",
				"salience": 0.015112124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ftxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indianapolis"
				},
				"name": "Indianapolis",
				"salience": 0.015112124,
				"type": "LOCATION"
			},
			{
				"name": "Troy Riggs",
				"salience": 0.01480307,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06l8j5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WTHR"
				},
				"name": "WTHR",
				"salience": 0.009961081,
				"type": "ORGANIZATION"
			},
			{
				"name": "David Macanally",
				"salience": 0.009961081,
				"type": "PERSON"
			},
			{
				"name": "Rich van Wyk",
				"salience": 0.009961081,
				"type": "PERSON"
			},
			{
				"name": "boy",
				"salience": 0.008534299,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.0066280244,
				"type": "EVENT"
			},
			{
				"name": "officers",
				"salience": 0.0054942803,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0053179017,
				"type": "OTHER"
			},
			{
				"name": "standoff",
				"salience": 0.005035236,
				"type": "EVENT"
			},
			{
				"name": "standoff",
				"salience": 0.005035236,
				"type": "EVENT"
			},
			{
				"name": "Detectives",
				"salience": 0.0043582222,
				"type": "PERSON"
			},
			{
				"name": "headquarters shootings",
				"salience": 0.004233754,
				"type": "OTHER"
			},
			{
				"name": "apartment",
				"salience": 0.0039384146,
				"type": "LOCATION"
			},
			{
				"name": "son",
				"salience": 0.003920849,
				"type": "PERSON"
			},
			{
				"name": "headquarters",
				"salience": 0.0037308526,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0037308526,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0035917712,
				"type": "OTHER"
			},
			{
				"name": "shootings",
				"salience": 0.0034572918,
				"type": "EVENT"
			},
			{
				"name": "street",
				"salience": 0.0034110032,
				"type": "LOCATION"
			},
			{
				"name": "apartment complex",
				"salience": 0.0034110032,
				"type": "LOCATION"
			},
			{
				"name": "everyone",
				"salience": 0.0034110032,
				"type": "PERSON"
			},
			{
				"name": "ordeal",
				"salience": 0.0034110032,
				"type": "OTHER"
			},
			{
				"name": "standoff",
				"salience": 0.0034007,
				"type": "EVENT"
			},
			{
				"name": "notes",
				"salience": 0.0033961802,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0033462842,
				"type": "PERSON"
			},
			{
				"name": "notes",
				"salience": 0.0033112303,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.003187767,
				"type": "PERSON"
			},
			{
				"name": "Detra Boyd",
				"salience": 0.0031681892,
				"type": "PERSON"
			},
			{
				"name": "grandmother",
				"salience": 0.0031613824,
				"type": "PERSON"
			},
			{
				"name": "headquarters",
				"salience": 0.0030464819,
				"type": "LOCATION"
			},
			{
				"name": "No one",
				"salience": 0.0027624862,
				"type": "PERSON"
			},
			{
				"name": "court documents",
				"salience": 0.0027624862,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officers",
				"salience": 0.0027037296,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0027037296,
				"type": "PERSON"
			},
			{
				"name": "murder charge",
				"salience": 0.0026594563,
				"type": "OTHER"
			},
			{
				"name": "stepfather",
				"salience": 0.0025761297,
				"type": "PERSON"
			},
			{
				"name": "threats",
				"salience": 0.0023923612,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0023031197,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0023031197,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0023031197,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.0023031197,
				"type": "PERSON"
			},
			{
				"name": "shooting death",
				"salience": 0.0023031197,
				"type": "EVENT"
			},
			{
				"name": "murder",
				"salience": 0.0022763482,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0022763482,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0022555487,
				"type": "OTHER"
			},
			{
				"name": "police stations",
				"salience": 0.0022555487,
				"type": "LOCATION"
			},
			{
				"name": "Shadeland Ave. & Mill",
				"salience": 0.0021003801,
				"type": "LOCATION"
			},
			{
				"name": "least",
				"salience": 0.0019532784,
				"type": "OTHER"
			},
			{
				"name": "rounds",
				"salience": 0.0019532784,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.0019161913,
				"type": "OTHER"
			},
			{
				"name": "murder charges",
				"salience": 0.0018415528,
				"type": "OTHER"
			},
			{
				"name": "IMPD Northwest District",
				"salience": 0.0017008343,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigators",
				"salience": 0.0016990681,
				"type": "PERSON"
			},
			{
				"name": "court documents",
				"salience": 0.0016851907,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crimes",
				"salience": 0.0016851907,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0016581591,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0016581591,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0016581591,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0016581591,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0015698697,
				"type": "PERSON"
			},
			{
				"name": "police station attacks",
				"salience": 0.0014592997,
				"type": "EVENT"
			},
			{
				"name": "probe",
				"salience": 0.0014592997,
				"type": "EVENT"
			},
			{
				"name": "John Clements",
				"salience": 0.0014178824,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y7l_g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionsville_Community_High_School"
				},
				"name": "Zionsville High School",
				"salience": 0.0014178824,
				"type": "ORGANIZATION"
			},
			{
				"name": "shootings",
				"salience": 0.0014059845,
				"type": "EVENT"
			},
			{
				"name": "IMPD North District",
				"salience": 0.0013885833,
				"type": "ORGANIZATION"
			},
			{
				"name": "shootings",
				"salience": 0.0013364607,
				"type": "EVENT"
			},
			{
				"name": "tooth",
				"salience": 0.0012274445,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.0012274445,
				"type": "PERSON"
			},
			{
				"name": "tooth",
				"salience": 0.0012274445,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0012274445,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0012274445,
				"type": "OTHER"
			},
			{
				"name": "notes",
				"salience": 0.001099287,
				"type": "OTHER"
			},
			{
				"name": "note",
				"salience": 0.001099287,
				"type": "OTHER"
			},
			{
				"name": "shell casing",
				"salience": 0.001099287,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.0010628795,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0010628795,
				"type": "WORK_OF_ART"
			},
			{
				"name": "run-ins",
				"salience": 0.0010628795,
				"type": "EVENT"
			},
			{
				"name": "lies",
				"salience": 0.0010628795,
				"type": "OTHER"
			},
			{
				"name": "Detectives",
				"salience": 0.0010409125,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0009169434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0008982518,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0008982518,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0008650739,
				"type": "PERSON"
			},
			{
				"name": "stepfather",
				"salience": 0.00079755386,
				"type": "PERSON"
			},
			{
				"name": "crime scene",
				"salience": 0.0007939912,
				"type": "LOCATION"
			},
			{
				"name": "match",
				"salience": 0.0007939912,
				"type": "EVENT"
			},
			{
				"name": "DNA sample",
				"salience": 0.0007939912,
				"type": "OTHER"
			},
			{
				"name": "profile",
				"salience": 0.0007939912,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0007939912,
				"type": "OTHER"
			},
			{
				"name": "gun",
				"salience": 0.0007939912,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "evidence",
				"salience": 0.0007939912,
				"type": "OTHER"
			},
			{
				"name": "Kill mankind",
				"salience": 0.00065419124,
				"type": "OTHER"
			},
			{
				"name": "Prosecutors",
				"salience": 0.0005856315,
				"type": "PERSON"
			},
			{
				"name": "shell casings",
				"salience": 0.0005613136,
				"type": "OTHER"
			},
			{
				"name": "Court papers",
				"salience": 0.00020178109,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:40.867+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "SWAT Standoff Suspect Linked to Zionsville Murder, IMPD HQ Shootings Rich van Wyk and David Macanally, WTHR (Indianapolis), October 31, 2016 \nThe suspect in a SWAT standoff on Indianapolis’ far northeast side Monday afternoon has been connected to recent shootings at IMPD headquarters and the September murder of an 82-year-old Zionsville man. \nDamoine Wilcoxson surrendered peacefully around 4:15 p.m. after a hours-long standoff with IMPD at an apartment complex near Shadeland Ave. & Mill View Dr. Damoine Wilcoxson \nWilcoxson was holding his 6-month-old son inside the apartment during the standoff. The boy’s grandmother stood across the street during the ordeal, waiting alongside everyone else and hoping he would be okay. \n{snip} \nWilcoxson was armed during the standoff and police say he fired at officers through the door. No one was injured and officers did not return fire due to concerns for the child. \n{snip} \nProsecutors say Wilcoxson faces a murder charge for the shooting death of John Clements less than half a mile from Zionsville High School on Sept. 28 . It was the first murder Zionsville has seen in 20 years. \n{snip} \nAccording to court documents, investigators believe Wilcoxson is also related to the IMPD headquarters shootings that occurred on October 4 and October 13. Detectives found handwritten notes demanding $100,000 and threats including “white must die” near the shell casings that were connected with the Oct. 4 shooting at IMPD Northwest District headquarters. Similar notes were found near the shell casings discovered after the Oct. 13 shooting at IMPD North District headquarters. \n“At least in one of those shootings, we believe that he intentionally targeted two police officers inside,” IMPD Chief Troy Riggs said, “and we’re going to be requesting attempted murder charges.” \nHe allegedly fired almost 50 rounds at those police stations earlier this month. No officers were hurt, but he allegedly left a note at the crime scene threatening more shootings if he didn’t get $100,000. \nDetectives discovered that the shell casings from both IMPD shootings were a match. A DNA sample from one of the notes and a shell casing matched Wilcoxson’s profile. \nCourt papers say forensic evidence links his gun to all those cases, but his stepfather says, “No, no, no, he’s not.” \nThe stepfather doesn’t believe Damoine is connected to those crimes. \nHis aunt, Detra Boyd, said, “He had a moment. That’s all.” \n{snip} \nFBI undercover agents friended him on Facebook during the probe into the police station attacks and the Zionsville murder. According to court documents, they found anti-white remarks and posts like “Kill mankind. No one should survive. We all live in lies,” plus “eye-4-eye, tooth for tooth, head for head, life for life.” \n{snip} \nWilcoxson has a long criminal history that includes run-ins with police since he was 14 years old. \n{snip}",
		"thread_title": "SWAT Standoff Suspect Linked to Zionsville Murder, IMPD HQ Shootings",
		"title": "SWAT Standoff Suspect Linked to Zionsville Murder, IMPD HQ Shootings",
		"type": "bs",
		"uuid": "f01954eaa2cc2a2550174f7ce7ef2ccece450ac5"
	},
	"-KhIgljhmBZ6ZfluYXI1": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:42.196+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "slavery",
				"salience": 0.34641248,
				"type": "OTHER"
			},
			{
				"name": "Duke Pesta",
				"salience": 0.1011856,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.07481402,
				"type": "PERSON"
			},
			{
				"name": "College Students",
				"salience": 0.04139199,
				"type": "PERSON"
			},
			{
				"name": "Pesta",
				"salience": 0.037925143,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.036588002,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.035241663,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.03147524,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.019304331,
				"type": "PERSON"
			},
			{
				"name": "associate professor",
				"salience": 0.014246916,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019fz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Franklin"
				},
				"name": "Ben Franklin",
				"salience": 0.012712172,
				"type": "PERSON"
			},
			{
				"name": "Professor",
				"salience": 0.012269645,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.012269645,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.011087415,
				"type": "OTHER"
			},
			{
				"name": "quizzes",
				"salience": 0.010731587,
				"type": "OTHER"
			},
			{
				"name": "Students",
				"salience": 0.0097921565,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.0096106315,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.0096106315,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07cbs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_Jefferson"
				},
				"name": "Thomas Jefferson",
				"salience": 0.008039934,
				"type": "PERSON"
			},
			{
				"name": "College Fix",
				"salience": 0.0068442537,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0068218573,
				"type": "PERSON"
			},
			{
				"name": "Kate Hardiman",
				"salience": 0.0059301527,
				"type": "PERSON"
			},
			{
				"name": "America Invented Slavery",
				"salience": 0.0059301527,
				"type": "ORGANIZATION"
			},
			{
				"name": "experiment",
				"salience": 0.0049230526,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0049230526,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.0049230526,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.003944986,
				"type": "PERSON"
			},
			{
				"name": "slavery",
				"salience": 0.003591442,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0033480679,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.003222039,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.003141416,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0029967548,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0029306822,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.0027330515,
				"type": "PERSON"
			},
			{
				"name": "phenomenon",
				"salience": 0.0025821517,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.002506638,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0023182086,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0023182086,
				"type": "PERSON"
			},
			{
				"name": "Most",
				"salience": 0.0021723015,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.0021374824,
				"type": "ORGANIZATION"
			},
			{
				"name": "liberal arts colleges",
				"salience": 0.0021374824,
				"type": "ORGANIZATION"
			},
			{
				"name": "anything",
				"salience": 0.0021194387,
				"type": "OTHER"
			},
			{
				"name": "quizzes",
				"salience": 0.00210214,
				"type": "OTHER"
			},
			{
				"name": "slaves",
				"salience": 0.0020574364,
				"type": "PERSON"
			},
			{
				"name": "slavery",
				"salience": 0.0020574364,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0020298844,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.001820532,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.001820532,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0017526309,
				"type": "OTHER"
			},
			{
				"name": "research institutions",
				"salience": 0.0017526309,
				"type": "ORGANIZATION"
			},
			{
				"name": "quizzes",
				"salience": 0.0017383223,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02hg3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Wisconsin%E2%80%93Oshkosh"
				},
				"name": "University of Wisconsin Oshkosh",
				"salience": 0.0017328025,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.0017322614,
				"type": "PERSON"
			},
			{
				"name": "quiz",
				"salience": 0.0017164354,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0016466504,
				"type": "PERSON"
			},
			{
				"name": "socialism",
				"salience": 0.0016438888,
				"type": "OTHER"
			},
			{
				"name": "campuses",
				"salience": 0.0015825684,
				"type": "LOCATION"
			},
			{
				"name": "gamut",
				"salience": 0.0015556653,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0014864407,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0014864407,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0014236048,
				"type": "OTHER"
			},
			{
				"name": "sentence",
				"salience": 0.0014236048,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.0014236048,
				"type": "OTHER"
			},
			{
				"name": "syllabus",
				"salience": 0.0014236048,
				"type": "OTHER"
			},
			{
				"name": "economics",
				"salience": 0.0014236048,
				"type": "OTHER"
			},
			{
				"name": "courses",
				"salience": 0.0014236048,
				"type": "OTHER"
			},
			{
				"name": "Classics",
				"salience": 0.0013704932,
				"type": "WORK_OF_ART"
			},
			{
				"name": "literature",
				"salience": 0.0013704932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vs64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_State_University%E2%80%93Stillwater"
				},
				"name": "Oklahoma State University",
				"salience": 0.001316126,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03lpld",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ursinus_College"
				},
				"name": "Ursinus College",
				"salience": 0.001316126,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02zg4q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Tennessee_at_Martin"
				},
				"name": "University of Tennessee Martin",
				"salience": 0.001316126,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05x_5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Purdue_University"
				},
				"name": "Purdue University",
				"salience": 0.001316126,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.001282448,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_War"
				},
				"name": "Civil War",
				"salience": 0.001249836,
				"type": "EVENT"
			},
			{
				"name": "shift",
				"salience": 0.0011622926,
				"type": "EVENT"
			},
			{
				"name": "quiz responses",
				"salience": 0.0011622926,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.0010771683,
				"type": "WORK_OF_ART"
			},
			{
				"name": "biographies",
				"salience": 0.0010172785,
				"type": "PERSON"
			},
			{
				"name": "socialism",
				"salience": 0.0010027516,
				"type": "OTHER"
			},
			{
				"name": "The College Fix",
				"salience": 0.0009742923,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.0009547709,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.00093412487,
				"type": "OTHER"
			},
			{
				"name": "ignorance",
				"salience": 0.0008683263,
				"type": "OTHER"
			},
			{
				"name": "fairness",
				"salience": 0.0008683263,
				"type": "OTHER"
			},
			{
				"name": "humility",
				"salience": 0.0008683263,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0008683263,
				"type": "ORGANIZATION"
			},
			{
				"name": "ideology",
				"salience": 0.0008683263,
				"type": "OTHER"
			},
			{
				"name": "markets",
				"salience": 0.0008683263,
				"type": "OTHER"
			},
			{
				"name": "evils",
				"salience": 0.0008683263,
				"type": "OTHER"
			},
			{
				"name": "fathers",
				"salience": 0.0008683263,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0008683263,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.0008436797,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0008088939,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0008088939,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0008088939,
				"type": "ORGANIZATION"
			},
			{
				"name": "anything",
				"salience": 0.0008088939,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.00073709444,
				"type": "OTHER"
			},
			{
				"name": "campus",
				"salience": 0.0007303555,
				"type": "LOCATION"
			},
			{
				"name": "micro-aggression",
				"salience": 0.00067382667,
				"type": "EVENT"
			},
			{
				"name": "indoctrination",
				"salience": 0.0006324296,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0006324296,
				"type": "OTHER"
			},
			{
				"name": "superiority",
				"salience": 0.0006324296,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.0006324296,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0006324296,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0006324296,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0006042692,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.0005935747,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_zsd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marxist_philosophy"
				},
				"name": "Marxist",
				"salience": 0.00053446833,
				"type": "ORGANIZATION"
			},
			{
				"name": "wickedness",
				"salience": 0.00047242935,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00047242935,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00047242935,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.00044539096,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06cx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic"
				},
				"name": "Republic",
				"salience": 0.00029075507,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:42.196+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Most College Students Think America Invented Slavery, Professor Finds Kate Hardiman, College Fix, October 31, 2016 \nFor 11 years, Professor Duke Pesta gave quizzes to his students at the beginning of the school year to test their knowledge on basic facts about American history and Western culture. \nThe most surprising result from his 11-year experiment? Students’ overwhelming belief that slavery began in the United States and was almost exclusively an American phenomenon, he said. \n“Most of my students could not tell me anything meaningful about slavery outside of America,” Pesta told The College Fix . “They are convinced that slavery was an American problem that more or less ended with the Civil War, and they are very fuzzy about the history of slavery prior to the Colonial era. Their entire education about slavery was confined to America.” \nPesta , currently an associate professor of English at the University of Wisconsin Oshkosh, has taught the gamut of Western literature–from the Classics to the modern–at seven different universities, ranging from large research institutions to small liberal arts colleges to branch campuses. He said he has given the quizzes to students at Purdue University, University of Tennessee Martin, Ursinus College, Oklahoma State University, and University of Wisconsin Oshkosh. \n{snip} \nBefore even distributing the syllabus for his courses, Pesta administered his short quizzes with basic questions about American history, economics and Western culture. For instance, the questions asked students to circle which of three historical figures was a president of the United States, or to name three slave-holding countries over the last 2,000 years, or define “capitalism” and “socialism” in one sentence each. \nOften, more students connected Thomas Jefferson to slavery than could identify him as president, according to Pesta. On one quiz, 29 out of 32 students responding knew that Jefferson owned slaves, but only three out of the 32 correctly identified him as president. Interestingly, more students–six of 32–actually believed Ben Franklin had been president. \n{snip} \nWhat’s more, he began to observe a shift in his students’ quiz responses in the early 2000s. Before that time, Pesta described his students as “often historically ignorant, but not politicized.” Since the early 2000s, Pesta has found that “many students come to college preprogrammed in certain ways.” \n“They cannot tell you many historical facts or relate anything meaningful about historical biographies, but they are, however, stridently vocal about the corrupt nature of the Republic, about the wickedness of the founding fathers, and about the evils of free markets,” Pesta said. “Most alarmingly, they know nothing about the fraught history of Marxist ideology and communist governments over the last century, but often reductively define socialism as ‘fairness.’” \nPesta also noted that, early on, his students’ “blissful ignorance was accompanied by a basic humility about what they did not know.” But over time he said he increasingly saw “a sense of moral superiority in not knowing anything about our ‘racist and sexist’ history and our ‘biased’ institutions.” \n“As we now see on campus,” Pesta said, “social justice warriors are arguing that even reading the great books of Western culture is at best a micro-aggression, and at worst an insidious form of cultural imperialism and indoctrination.” \n{snip}",
		"thread_title": "Most College Students Think America Invented Slavery, Professor Finds",
		"title": "Most College Students Think America Invented Slavery, Professor Finds",
		"type": "bs",
		"uuid": "86b75c3572bb49fad99f13b50b1406321e40e69a"
	},
	"-KhIglyjFFQFT8OJPrtj": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:42.602+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.089952774,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.06215817,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.05919106,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.055605207,
				"type": "LOCATION"
			},
			{
				"name": "politics",
				"salience": 0.05543722,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.050959073,
				"type": "PERSON"
			},
			{
				"name": "border",
				"salience": 0.03198197,
				"type": "LOCATION"
			},
			{
				"name": "America Is Better Without Borders Steven Hahn",
				"salience": 0.03109196,
				"type": "PERSON"
			},
			{
				"name": "descendants",
				"salience": 0.029710466,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.022268405,
				"type": "EVENT"
			},
			{
				"name": "logic",
				"salience": 0.02198927,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07c_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Time"
				},
				"name": "TIME",
				"salience": 0.021100273,
				"type": "ORGANIZATION"
			},
			{
				"name": "dollar wall",
				"salience": 0.01752015,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.011935485,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.011913811,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.01171302,
				"type": "PERSON"
			},
			{
				"name": "slave trade",
				"salience": 0.011326024,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.010800087,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.010201263,
				"type": "LOCATION"
			},
			{
				"name": "immigration",
				"salience": 0.010001313,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.009240957,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.009240957,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0072278255,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0072278255,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0072278255,
				"type": "OTHER"
			},
			{
				"name": "slogan",
				"salience": 0.0072278255,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0072278255,
				"type": "OTHER"
			},
			{
				"name": "coffee mugs",
				"salience": 0.0072278255,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Tee-shirts",
				"salience": 0.0072278255,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "border vigilance",
				"salience": 0.0072278255,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0072278255,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0072278255,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0070470655,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0066763517,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.006655635,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.005977239,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.005932592,
				"type": "LOCATION"
			},
			{
				"name": "citizens",
				"salience": 0.0058538276,
				"type": "PERSON"
			},
			{
				"name": "intention",
				"salience": 0.0058538276,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.005662721,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.005635532,
				"type": "EVENT"
			},
			{
				"name": "nation",
				"salience": 0.0055268756,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0053331577,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0052933153,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.005134253,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0050696116,
				"type": "PERSON"
			},
			{
				"name": "will",
				"salience": 0.0050696116,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0050696116,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.005057822,
				"type": "LOCATION"
			},
			{
				"name": "citizen",
				"salience": 0.0050282236,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0048805233,
				"type": "OTHER"
			},
			{
				"name": "boundaries",
				"salience": 0.0048805233,
				"type": "OTHER"
			},
			{
				"name": "diplomacy",
				"salience": 0.0048805233,
				"type": "OTHER"
			},
			{
				"name": "conquest",
				"salience": 0.0048805233,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0048805233,
				"type": "EVENT"
			},
			{
				"name": "economy",
				"salience": 0.0048489366,
				"type": "OTHER"
			},
			{
				"name": "migration",
				"salience": 0.0043544862,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0041835816,
				"type": "PERSON"
			},
			{
				"name": "captives",
				"salience": 0.0041392506,
				"type": "PERSON"
			},
			{
				"name": "ethnocentrism",
				"salience": 0.0041392506,
				"type": "OTHER"
			},
			{
				"name": "shores",
				"salience": 0.0041392506,
				"type": "LOCATION"
			},
			{
				"name": "Truth",
				"salience": 0.0039848275,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Ronald Reagan",
				"salience": 0.0038717655,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0036844423,
				"type": "LOCATION"
			},
			{
				"name": "dealings",
				"salience": 0.0036229126,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_America"
				},
				"name": "Central America",
				"salience": 0.0036043348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c16t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexican%E2%80%93American_War"
				},
				"name": "U.S.-Mexican War",
				"salience": 0.0036043348,
				"type": "EVENT"
			},
			{
				"name": "lifeways",
				"salience": 0.0035711864,
				"type": "OTHER"
			},
			{
				"name": "prosperity",
				"salience": 0.0035711864,
				"type": "OTHER"
			},
			{
				"name": "slave",
				"salience": 0.0035711864,
				"type": "OTHER"
			},
			{
				"name": "Oregon Territory",
				"salience": 0.00346985,
				"type": "LOCATION"
			},
			{
				"name": "lifeblood",
				"salience": 0.0033946342,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North American",
				"salience": 0.003259033,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03gh4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hawaii"
				},
				"name": "Hawaii",
				"salience": 0.0031212317,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.0031212317,
				"type": "LOCATION"
			},
			{
				"name": "labor",
				"salience": 0.0030925227,
				"type": "OTHER"
			},
			{
				"name": "resourcefulness",
				"salience": 0.0030925227,
				"type": "OTHER"
			},
			{
				"name": "origins",
				"salience": 0.0030925227,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0030925227,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0030925227,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0030820712,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.0030820712,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.0030820712,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0030047584,
				"type": "LOCATION"
			},
			{
				"name": "Louisiana Territory",
				"salience": 0.0027971703,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0027526438,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0027526438,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0026012098,
				"type": "PERSON"
			},
			{
				"name": "prospects",
				"salience": 0.0026012098,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0026012098,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0025481964,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0025481964,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.0025247547,
				"type": "ORGANIZATION"
			},
			{
				"name": "goods",
				"salience": 0.0022524812,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "movement",
				"salience": 0.0022524812,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0022524812,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0022524812,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0022524812,
				"type": "OTHER"
			},
			{
				"name": "sustenance",
				"salience": 0.0022524812,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0021684084,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0019432241,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0016826693,
				"type": "OTHER"
			},
			{
				"name": "stick",
				"salience": 0.0016826693,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "chance",
				"salience": 0.0016826693,
				"type": "OTHER"
			},
			{
				"name": "investors",
				"salience": 0.0016826693,
				"type": "PERSON"
			},
			{
				"name": "policy makers",
				"salience": 0.0016826693,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0016826693,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0016826693,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:42.602+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "America Is Better Without Borders Steven Hahn, TIME, November 1, 2016 \n“A nation without borders,” Donald Trump has warned us , “is not a nation at all.” Trump was explaining the logic of the multi-billion dollar wall he promises to build along the U.S.-Mexican border, but he was hardly the first to make the case. Years ago, Ronald Reagan said much the same about the threat of illegal immigration, and others urging border vigilance have wrapped themselves in the high-flown rhetoric. Tee-shirts and coffee mugs have turned the idea into a saleable slogan. \n{snip} \n{snip} For much of its early history, the United States had hazy borders in good part because through war, conquest and diplomacy the country was constantly expanding and the shifting boundaries were not clearly marked. There was no agreement about how far west the Louisiana Territory reached or how far south the state of Texas stretched or how far north the Oregon Territory extended. Highly charged political words and brutal conflict followed (like the U.S.-Mexican War), while the imperial eyes of many leaders fell on Cuba, Central America and Hawaii. \nWhat’s more, the borders that were agreed upon were remarkably porous. Until well into the nineteenth century, immigrants could come and go at will and even participate in electoral politics if they simply declared an intention to become citizens; indeed, for decades it was not at all clear what a citizen of the United States was. The only international migration policed was the African slave trade, which Congress outlawed in 1808 after nearly half a million captives had been forcibly deposited on North American shores. \n{snip} \nIt is easy, when politics and ethnocentrism serve, to proclaim the principle of the nation with borders as the nation itself, while the borders are, in fact, regularly traversed by policy makers, investors and moneyed interests pursuing the main chance and wielding the big stick. Trump himself regularly touts, though refuses to reveal, his international dealings, many of which confound his goal of keeping jobs within American borders if they don’t outright violate American laws. \nTruth is that the nation’s prosperity has long rested on the labor and resourcefulness of immigrants–voluntary and involuntary, free and slave–and that those who most loudly denounce a “nation without borders” are likely descendants of immigrants who were themselves harassed for their origins, faith and lifeways at some point in the past. We would do well to recognize that in a global economy such as ours, where the movement of people and goods are the lifeblood of our sustenance, a nation’s security is best maintained not by walling itself off but by lifting the prospects–and thereby creating political allies–of working people around the world.",
		"thread_title": "America Is Better Without Borders",
		"title": "America Is Better Without Borders",
		"type": "bs",
		"uuid": "c1e7b3ba4b4d8b059b09e62379ddc4cd86277fa2"
	},
	"-KhIgmBpLuRe25SpkM8G": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:43.600+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedish",
				"salience": 0.58550906,
				"type": "LOCATION"
			},
			{
				"name": "police officers",
				"salience": 0.01315717,
				"type": "PERSON"
			},
			{
				"name": "crime",
				"salience": 0.01264651,
				"type": "OTHER"
			},
			{
				"name": "police force",
				"salience": 0.011977184,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.011977184,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rfl82"
				},
				"name": "Brink",
				"salience": 0.011291272,
				"type": "LOCATION"
			},
			{
				"name": "crisis",
				"salience": 0.010379979,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.010379979,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.010135594,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05ws7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Police"
				},
				"name": "Police Force",
				"salience": 0.009512478,
				"type": "ORGANIZATION"
			},
			{
				"name": "Express",
				"salience": 0.009376962,
				"type": "OTHER"
			},
			{
				"name": "brink",
				"salience": 0.009376962,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.009376962,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.009376962,
				"type": "OTHER"
			},
			{
				"name": "Police Association",
				"salience": 0.008976844,
				"type": "ORGANIZATION"
			},
			{
				"name": "police officers",
				"salience": 0.008845808,
				"type": "PERSON"
			},
			{
				"name": "2016 Sweden",
				"salience": 0.008528903,
				"type": "LOCATION"
			},
			{
				"name": "police association",
				"salience": 0.008276622,
				"type": "ORGANIZATION"
			},
			{
				"name": "migrants",
				"salience": 0.008167079,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.008124901,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.008124901,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.006566399,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.006369319,
				"type": "PERSON"
			},
			{
				"name": "Dan Eliasson",
				"salience": 0.006249192,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0062102997,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07rb0jd"
				},
				"name": "Breaking Point",
				"salience": 0.005782054,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crimes",
				"salience": 0.005225349,
				"type": "EVENT"
			},
			{
				"name": "Lizzie Stromme",
				"salience": 0.0050086356,
				"type": "PERSON"
			},
			{
				"name": "Violence amid Migrant Influx",
				"salience": 0.0050086356,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0140kd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Germanic_languages"
				},
				"name": "Scandinavian",
				"salience": 0.0050086356,
				"type": "LOCATION"
			},
			{
				"name": "trend",
				"salience": 0.0048386627,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0048121004,
				"type": "OTHER"
			},
			{
				"name": "police officers",
				"salience": 0.004642722,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.004303257,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.004285603,
				"type": "EVENT"
			},
			{
				"name": "Thomas Stjernfeldt",
				"salience": 0.0042219968,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.004142927,
				"type": "PERSON"
			},
			{
				"name": "service",
				"salience": 0.0038701869,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0038701869,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.0038701869,
				"type": "EVENT"
			},
			{
				"name": "crime",
				"salience": 0.0036662659,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0035142626,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0035142626,
				"type": "PERSON"
			},
			{
				"name": "resignations",
				"salience": 0.003352017,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.003352017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "some",
				"salience": 0.002714819,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.002714819,
				"type": "EVENT"
			},
			{
				"name": "levels",
				"salience": 0.002714819,
				"type": "OTHER"
			},
			{
				"name": "breaching point",
				"salience": 0.002714819,
				"type": "OTHER"
			},
			{
				"name": "no-go zone'' list",
				"salience": 0.002714819,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0026945404,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.0026570857,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.0026135829,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.00241147,
				"type": "PERSON"
			},
			{
				"name": "Second World War Sweden",
				"salience": 0.0023763815,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons",
				"salience": 0.002351132,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.002351132,
				"type": "PERSON"
			},
			{
				"name": "drug dealing",
				"salience": 0.002351132,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0022634405,
				"type": "OTHER"
			},
			{
				"name": "asylum applications",
				"salience": 0.0022634405,
				"type": "OTHER"
			},
			{
				"name": "moves",
				"salience": 0.0022634405,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0022634405,
				"type": "LOCATION"
			},
			{
				"name": "warning",
				"salience": 0.0022487917,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0022166953,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0022166953,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01b2fg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/G%C3%B6taland"
				},
				"name": "Götaland",
				"salience": 0.0020793912,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0020623154,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.001985384,
				"type": "LOCATION"
			},
			{
				"name": "south-east",
				"salience": 0.0019196663,
				"type": "LOCATION"
			},
			{
				"name": "control",
				"salience": 0.0019196663,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0019131803,
				"type": "PERSON"
			},
			{
				"name": "faith",
				"salience": 0.0017791037,
				"type": "OTHER"
			},
			{
				"name": "rapes",
				"salience": 0.0017791037,
				"type": "EVENT"
			},
			{
				"name": "situation",
				"salience": 0.0017127267,
				"type": "OTHER"
			},
			{
				"name": "National Criminal Investigation Service",
				"salience": 0.0016715912,
				"type": "ORGANIZATION"
			},
			{
				"name": "migrants",
				"salience": 0.0016562182,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.0016562182,
				"type": "EVENT"
			},
			{
				"name": "attempted murder",
				"salience": 0.0016562182,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0016296539,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0015428903,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0014342299,
				"type": "OTHER"
			},
			{
				"name": "overtime",
				"salience": 0.0014342299,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0014342299,
				"type": "LOCATION"
			},
			{
				"name": "cases",
				"salience": 0.0014342299,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0014342299,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0014293828,
				"type": "PERSON"
			},
			{
				"name": "Sex assaults",
				"salience": 0.0012009871,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0011526691,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0010446445,
				"type": "PERSON"
			},
			{
				"name": "law and order",
				"salience": 0.0010446445,
				"type": "OTHER"
			},
			{
				"name": "union",
				"salience": 0.0010446445,
				"type": "ORGANIZATION"
			},
			{
				"name": "ability",
				"salience": 0.0010446445,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0010446445,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0010446445,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0009438752,
				"type": "PERSON"
			},
			{
				"name": "arsonist attacks",
				"salience": 0.00090121996,
				"type": "EVENT"
			},
			{
				"name": "car fire attacks",
				"salience": 0.00090121996,
				"type": "EVENT"
			},
			{
				"name": "regions",
				"salience": 0.00090121996,
				"type": "LOCATION"
			},
			{
				"name": "southeast",
				"salience": 0.00090121996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03zv5y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/V%C3%A4xj%C3%B6"
				},
				"name": "Växjö",
				"salience": 0.00088284985,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.00083146465,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Sweden",
				"salience": 0.0008193556,
				"type": "LOCATION"
			},
			{
				"name": "citizens",
				"salience": 0.0008106422,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xfw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sveriges_Television"
				},
				"name": "SVT",
				"salience": 0.0007976806,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.0007803818,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.0007803818,
				"type": "OTHER"
			},
			{
				"name": "working environment",
				"salience": 0.00068743486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_myf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Express"
				},
				"name": "Express.co.uk",
				"salience": 0.0005546876,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:43.600+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Sweden on the Brink? Police Force Pushed to Breaking Point by Violence amid Migrant Influx Lizzie Stromme, Express, November 1, 2016 \nSweden is on the brink of becoming a lawless state as the police force is losing the battle against unprecedented levels of crime and violence amid a growing migrant crisis. \nThe Scandinavian country is facing an existential crisis with on average three police officers handing in their resignations a day. \nIf the alarming trend continues, and police officers continue to resign more than 1,000 officers will have quit the service by New Years. \nSince the migrant crisis began last summer, Sweden has been hit by a series of brutal crimes and violent incidents . \nIn 2015 alone Sweden, with a population of 9.5 million, received over 160,000 asylum applications and the country is expected to take as many as 190,000 refugees, or two per cent of the population, by the end of 2016. \nSince the Second World War Sweden has prided itself on helping migrants who cross their borders despite some moves to the political right in recent years. \nBut police have now admitted the force has reached breaching point as more than 50 areas in the country have now been placed on a “no-go zone” list . \nIn February a report from Sweden’s National Criminal Investigation Service announced there were 52 areas where officers would not cope with the levels of crime being committed . \nSex assaults , drug dealing and children carrying weapons were just some of the incidents mentioned in the report. \nIn September, Swedish officials were forced to add another three areas to the list. \nNow the Police Association have said they need at least 200 new officers to regain control in the south-east of the country. \nThomas Stjernfeldt, from the region’s police association, told SVT : “We are missing extremely many officers in the operational sector, right now we need 200 more officers to be added to the force to establish a reasonable working environment in the southeast of Götaland.” \nGötaland is one of the regions in the country that has been hit hard by the car fire attacks, which have been occurring throughout Sweden. \nOn Monday, Express.co.uk reported a number of the arsonist attacks in the city of Växjö, in Götaland, had been committed by frustrated migrants . \nCurrently there are more than 6,000 suspected crimes that are unsolved in the area and 400 of these cases are suspected to be rapes, murder or attempted murder. \nMr Stjernfeldt said the figures are alarming and police officers are constantly forced to work overtime in an attempt to solve the reported crimes. \nThe Police Association admitted it fears the public will lose faith in the force and their ability to protect citizens if the situation is not resolved. \nThe union’s call for more resources echoes National Police Commissioner Dan Eliasson’s February warning, where he said he needed a further 4,100 officers and specialist staff to reestablish law and order in Sweden.",
		"thread_title": "Sweden on the Brink? Police Force Pushed to Breaking Point by Violence amid Migrant Influx",
		"title": "Sweden on the Brink? Police Force Pushed to Breaking Point by Violence amid Migrant Influx",
		"type": "bs",
		"uuid": "b3bf512fad9ed815f41ba0c04a4f71e999dc5b12"
	},
	"-KhIgmg-q5Pg3rlC8_EU": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:54:43.887+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australia",
				"salience": 0.32630184,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07630d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Shorten"
				},
				"name": "Bill Shorten",
				"salience": 0.110774405,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.058266178,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01tpld",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malcolm_Turnbull"
				},
				"name": "Malcolm Turnbull",
				"salience": 0.030601112,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05br2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nauru"
				},
				"name": "Nauru",
				"salience": 0.021756345,
				"type": "LOCATION"
			},
			{
				"name": "coalition",
				"salience": 0.020050481,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0q96",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australian_Labor_Party"
				},
				"name": "Labor",
				"salience": 0.01492267,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0l8lg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/One_Nation_(Australia)"
				},
				"name": "One Nation",
				"salience": 0.014171047,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01st5y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manus_Island"
				},
				"name": "Manus Island",
				"salience": 0.013839453,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.012280435,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02q0d7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peter_Dutton"
				},
				"name": "Peter Dutton",
				"salience": 0.011558477,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j5pc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pauline_Hanson"
				},
				"name": "Pauline Hanson",
				"salience": 0.01113332,
				"type": "PERSON"
			},
			{
				"name": "Refugees",
				"salience": 0.010888963,
				"type": "PERSON"
			},
			{
				"name": "asylum seekers",
				"salience": 0.0105651645,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.009101891,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00806026,
				"type": "ORGANIZATION"
			},
			{
				"name": "stance",
				"salience": 0.0071218237,
				"type": "OTHER"
			},
			{
				"name": "adults",
				"salience": 0.006955782,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0062862164,
				"type": "ORGANIZATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.0058008595,
				"type": "PERSON"
			},
			{
				"name": "advocates",
				"salience": 0.0053770565,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.005336601,
				"type": "PERSON"
			},
			{
				"name": "Asylum seekers",
				"salience": 0.0052423375,
				"type": "PERSON"
			},
			{
				"name": "refugee",
				"salience": 0.005116878,
				"type": "PERSON"
			},
			{
				"name": "Propose Law That Bans Boat Asylum Seekers",
				"salience": 0.004859116,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.004655829,
				"type": "OTHER"
			},
			{
				"name": "boat",
				"salience": 0.004655829,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0162kb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australian_Senate"
				},
				"name": "Senate",
				"salience": 0.004647789,
				"type": "ORGANIZATION"
			},
			{
				"name": "message",
				"salience": 0.00459101,
				"type": "OTHER"
			},
			{
				"name": "asylum seekers",
				"salience": 0.004528159,
				"type": "PERSON"
			},
			{
				"name": "layer",
				"salience": 0.0044169948,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Papua_New_Guinea"
				},
				"name": "Papua New Guinea",
				"salience": 0.004397466,
				"type": "LOCATION"
			},
			{
				"name": "lifetime ban",
				"salience": 0.004364428,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.004364428,
				"type": "OTHER"
			},
			{
				"name": "ban",
				"salience": 0.004364428,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.004364428,
				"type": "OTHER"
			},
			{
				"name": "tourists",
				"salience": 0.004364428,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0266wf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_Di_Natale"
				},
				"name": "Richard Di Natale",
				"salience": 0.004201815,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.0040324396,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0040324396,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/013fn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australian_Broadcasting_Corporation"
				},
				"name": "ABC radio",
				"salience": 0.0039248867,
				"type": "ORGANIZATION"
			},
			{
				"name": "Australia Permanently News",
				"salience": 0.003800428,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0037642193,
				"type": "PERSON"
			},
			{
				"name": "Malcolm Roberts",
				"salience": 0.003605785,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03d67gq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scott_Morrison_(politician)"
				},
				"name": "Scott Morrison",
				"salience": 0.0032414922,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0031536047,
				"type": "EVENT"
			},
			{
				"name": "immigration centres",
				"salience": 0.0031536047,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0029917257,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0025908172,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0025908172,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0025908172,
				"type": "ORGANIZATION"
			},
			{
				"name": "senators",
				"salience": 0.002539145,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0023855863,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02tcpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tanya_Plibersek"
				},
				"name": "Tanya Plibersek",
				"salience": 0.0022463202,
				"type": "PERSON"
			},
			{
				"name": "prime minister",
				"salience": 0.0022148667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03skpf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2GB"
				},
				"name": "2GB",
				"salience": 0.002188515,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02pz7_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julie_Bishop"
				},
				"name": "Julie Bishop",
				"salience": 0.0021199228,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.0020688404,
				"type": "PERSON"
			},
			{
				"name": "ban",
				"salience": 0.001989711,
				"type": "OTHER"
			},
			{
				"name": "limbo",
				"salience": 0.00198626,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.001933815,
				"type": "OTHER"
			},
			{
				"name": "businesswoman",
				"salience": 0.0019180209,
				"type": "PERSON"
			},
			{
				"name": "businessman",
				"salience": 0.0019180209,
				"type": "PERSON"
			},
			{
				"name": "Ming Yu Hah",
				"salience": 0.0019036975,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0018873055,
				"type": "WORK_OF_ART"
			},
			{
				"name": "territory",
				"salience": 0.0018873055,
				"type": "LOCATION"
			},
			{
				"name": "everyone",
				"salience": 0.0018168818,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0018168341,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0018168341,
				"type": "ORGANIZATION"
			},
			{
				"name": "tourist",
				"salience": 0.0017978336,
				"type": "PERSON"
			},
			{
				"name": "ban",
				"salience": 0.0017528258,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0017377129,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.0016890601,
				"type": "PERSON"
			},
			{
				"name": "legislation",
				"salience": 0.0016609292,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.0016416153,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.0016193462,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.0014996879,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0014996879,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0014832835,
				"type": "ORGANIZATION"
			},
			{
				"name": "message",
				"salience": 0.0014310187,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021l9k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kevin_Rudd"
				},
				"name": "Kevin Rudd",
				"salience": 0.0014222219,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06y57",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sydney"
				},
				"name": "Sydney",
				"salience": 0.0013798769,
				"type": "LOCATION"
			},
			{
				"name": "aim",
				"salience": 0.0013661974,
				"type": "OTHER"
			},
			{
				"name": "boat",
				"salience": 0.0013449055,
				"type": "OTHER"
			},
			{
				"name": "migration policies",
				"salience": 0.0013449055,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.0013066892,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.0012986362,
				"type": "EVENT"
			},
			{
				"name": "citizen",
				"salience": 0.0012986362,
				"type": "PERSON"
			},
			{
				"name": "track",
				"salience": 0.0012986362,
				"type": "LOCATION"
			},
			{
				"name": "old",
				"salience": 0.0012986362,
				"type": "OTHER"
			},
			{
				"name": "extremists",
				"salience": 0.0012986362,
				"type": "PERSON"
			},
			{
				"name": "praise",
				"salience": 0.0012986362,
				"type": "OTHER"
			},
			{
				"name": "win",
				"salience": 0.0012986362,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0012981925,
				"type": "ORGANIZATION"
			},
			{
				"name": "policy",
				"salience": 0.0012947092,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0012739362,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.0012726872,
				"type": "OTHER"
			},
			{
				"name": "minister",
				"salience": 0.0012679525,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0012606101,
				"type": "LOCATION"
			},
			{
				"name": "Concerns",
				"salience": 0.001218861,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.001215555,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mtq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Australia"
				},
				"name": "South Australia",
				"salience": 0.0011999243,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0011645933,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.0011645933,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0011211233,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07q5f35"
				},
				"name": "Federal Government",
				"salience": 0.001118373,
				"type": "ORGANIZATION"
			},
			{
				"name": "people smuggling networks",
				"salience": 0.0011080833,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0011080833,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0011080833,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.0010979521,
				"type": "OTHER"
			},
			{
				"name": "boat",
				"salience": 0.0010979521,
				"type": "OTHER"
			},
			{
				"name": "boat",
				"salience": 0.0010979521,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.0010525765,
				"type": "LOCATION"
			},
			{
				"name": "issue",
				"salience": 0.0010515125,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0010515125,
				"type": "PERSON"
			},
			{
				"name": "parliament",
				"salience": 0.0010515125,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugees",
				"salience": 0.0010171502,
				"type": "PERSON"
			},
			{
				"name": "convention",
				"salience": 0.0010122615,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.0010122615,
				"type": "OTHER"
			},
			{
				"name": "obligations",
				"salience": 0.0010122615,
				"type": "OTHER"
			},
			{
				"name": "obligations",
				"salience": 0.0010122615,
				"type": "OTHER"
			},
			{
				"name": "refugee convention",
				"salience": 0.0010122615,
				"type": "EVENT"
			},
			{
				"name": "life",
				"salience": 0.0010122615,
				"type": "OTHER"
			},
			{
				"name": "country resettlements",
				"salience": 0.0009681631,
				"type": "PERSON"
			},
			{
				"name": "visa",
				"salience": 0.00095073465,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.00095073465,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0009339081,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00092213956,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0009105192,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0009105192,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.0009105192,
				"type": "OTHER"
			},
			{
				"name": "crossbenchers",
				"salience": 0.0009105192,
				"type": "PERSON"
			},
			{
				"name": "proposal",
				"salience": 0.0009105192,
				"type": "OTHER"
			},
			{
				"name": "tune",
				"salience": 0.00087652914,
				"type": "OTHER"
			},
			{
				"name": "entry",
				"salience": 0.00087652914,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.00087652914,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.00087652914,
				"type": "OTHER"
			},
			{
				"name": "mode",
				"salience": 0.00087652914,
				"type": "OTHER"
			},
			{
				"name": "arrival",
				"salience": 0.00087652914,
				"type": "EVENT"
			},
			{
				"name": "breach",
				"salience": 0.00087652914,
				"type": "EVENT"
			},
			{
				"name": "cruelty",
				"salience": 0.00087652914,
				"type": "OTHER"
			},
			{
				"name": "outback",
				"salience": 0.00087652914,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.0008654833,
				"type": "OTHER"
			},
			{
				"name": "parliament",
				"salience": 0.0008584112,
				"type": "ORGANIZATION"
			},
			{
				"name": "interest",
				"salience": 0.0008584112,
				"type": "OTHER"
			},
			{
				"name": "people smuggler",
				"salience": 0.0008584112,
				"type": "ORGANIZATION"
			},
			{
				"name": "message",
				"salience": 0.0008087721,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0008070236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g39h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Queensland"
				},
				"name": "Queensland",
				"salience": 0.00079931744,
				"type": "LOCATION"
			},
			{
				"name": "message",
				"salience": 0.00076876703,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0007566948,
				"type": "PERSON"
			},
			{
				"name": "bar",
				"salience": 0.0007433013,
				"type": "LOCATION"
			},
			{
				"name": "immigration processing",
				"salience": 0.0007433013,
				"type": "EVENT"
			},
			{
				"name": "categories",
				"salience": 0.0007433013,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.0007433013,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04xq6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Special_Rapporteur"
				},
				"name": "UN Special Rapporteur",
				"salience": 0.00072219735,
				"type": "EVENT"
			},
			{
				"name": "protection",
				"salience": 0.00071020017,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00071020017,
				"type": "OTHER"
			},
			{
				"name": "tourist visa",
				"salience": 0.00071020017,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.000658807,
				"type": "PERSON"
			},
			{
				"name": "reporters",
				"salience": 0.00064167584,
				"type": "PERSON"
			},
			{
				"name": "people smugglers",
				"salience": 0.0006412276,
				"type": "OTHER"
			},
			{
				"name": "sea",
				"salience": 0.0006412276,
				"type": "LOCATION"
			},
			{
				"name": "sea",
				"salience": 0.0006412276,
				"type": "LOCATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.00063093635,
				"type": "PERSON"
			},
			{
				"name": "legislation",
				"salience": 0.0006177189,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media",
				"salience": 0.00061452965,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00060283777,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.0005973248,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.00057976134,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c04b_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nick_Xenophon"
				},
				"name": "Nick Xenophon",
				"salience": 0.00056039105,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/122hctz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Cr%C3%A9peau"
				},
				"name": "Francois Crepeau",
				"salience": 0.00056039105,
				"type": "PERSON"
			},
			{
				"name": "position",
				"salience": 0.0005598739,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0005598739,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0005598739,
				"type": "LOCATION"
			},
			{
				"name": "case load",
				"salience": 0.0005552338,
				"type": "OTHER"
			},
			{
				"name": "cohort",
				"salience": 0.0005552338,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0005552338,
				"type": "LOCATION"
			},
			{
				"name": "syndicates",
				"salience": 0.0005552338,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00054585,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.00054188917,
				"type": "ORGANIZATION"
			},
			{
				"name": "position",
				"salience": 0.000518847,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.0005172174,
				"type": "WORK_OF_ART"
			},
			{
				"name": "laws",
				"salience": 0.0005172174,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04jc7_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Derryn_Hinch"
				},
				"name": "Derryn Hinch",
				"salience": 0.00048741337,
				"type": "PERSON"
			},
			{
				"name": "resettlement option",
				"salience": 0.00048509488,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.00047684077,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00046698266,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00046698266,
				"type": "ORGANIZATION"
			},
			{
				"name": "policy",
				"salience": 0.00044618422,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00044618422,
				"type": "OTHER"
			},
			{
				"name": "border protection policies",
				"salience": 0.00044618422,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00044462684,
				"type": "ORGANIZATION"
			},
			{
				"name": "option",
				"salience": 0.00044388042,
				"type": "OTHER"
			},
			{
				"name": "tourist",
				"salience": 0.00043442848,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02h758",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Seven_Network"
				},
				"name": "Seven Network",
				"salience": 0.00042047264,
				"type": "ORGANIZATION"
			},
			{
				"name": "portfolio",
				"salience": 0.0004043522,
				"type": "OTHER"
			},
			{
				"name": "mismanagement",
				"salience": 0.0004043522,
				"type": "OTHER"
			},
			{
				"name": "distraction",
				"salience": 0.0004043522,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0004043522,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0003863427,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.0003863427,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.00034906104,
				"type": "PERSON"
			},
			{
				"name": "moves",
				"salience": 0.00034881718,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.00034881718,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.00034881718,
				"type": "OTHER"
			},
			{
				"name": "discussions",
				"salience": 0.00032591782,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.00030203257,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00030203257,
				"type": "LOCATION"
			},
			{
				"name": "stage",
				"salience": 0.00030203257,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.00030203257,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00030203257,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.00025938457,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g4g7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gold_Coast,_Queensland"
				},
				"name": "Gold Coast",
				"salience": 0.0002488417,
				"type": "LOCATION"
			},
			{
				"name": "Naru",
				"salience": 0.0002488417,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:54:43.887+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Turnbull to Propose Law That Bans Boat Asylum Seekers from Australia Permanently News, October 31, 2016 \nFederal Labor will look closely at the government’s new tough stance on refugees but says it’s ridiculous that some banned from Australia won’t ever be allowed to visit for business, accusing Malcolm Turnbull of pandering to One Nation. \nThe opposition has not entirely ruled out the government’s proposed lifetime ban on asylum seekers who arrive by boat, instead saying it will look at the legislation before coming up with a position. \nUnder the plan, all adults sent to offshore immigration centres on Nauru and Papua New Guinea’s Manus Island would be prevented from ever entering Australia, even as tourists or on business, regardless of whether they’re found to be refugees or not. \nThe coalition is ramping up its attack on Opposition Leader Bill Shorten for not publicly stating a position on the ban within 24 hours of its announcement. \n“This bloke is weak,” former immigration minister Scott Morrison told Sydney radio station 2GB. \nMr Shorten says Labor will look closely at the legislation “when the government can be bothered releasing it”. \n“It seems ridiculous to me that a genuine refugee who settles in the US or Canada and becomes a US or Canadian citizen is banned from visiting Australia as a tourist, businessman or businesswoman 40 years down the track,” he said. \nHe also took aim at the prime minister, saying the Mr Turnbull of old would never have proposed this to keep the right-wing extremists in his party happy. \n“He’s earning the praise of Pauline Hanson–I hope he’s proud of that.” \nMeanwhile, One Nation is both applauding and claiming a win over the government’s tough stance. \nIts Queensland senator Malcolm Roberts said the government was “dancing to our tune’, while leader Pauline Hanson put it more bluntly. \n“Refugees are not welcome here,” she told the Seven Network. \nConcerns have also been raised the ban may contravene article 31 of the international refugee convention, which states signatory nations shall not penalise refugees for illegal entry when they have come directly from a territory where their life or freedom was threatened. \nAmnesty International says the outrageous and unnecessary law discriminates against people seeking safety based on their mode of arrival, a clear breach of Australia’s obligations. \n““This is yet another layer of cruelty in Australia’s already deliberately abusive policy,” refugee campaigner Ming Yu Hah said. \nBut Prime Minister Malcolm Turnbull insists the plan does not contravene the convention. \n“We have taken legal advice and we are satisfied it is within power and consistent with our international obligations,” he told reporters in outback South Australia on Monday. \nGreens leader Richard Di Natale told ABC radio he was hopeful that “if Labor shows a little bit of courage on this issue”, it could be struck down. \nMr Turnbull said the government has spoken to just one of the 11 Senate crossbenchers about the proposal, which it will put to parliament next week. \nIndependent senators Derryn Hinch and Nick Xenophon separately said they supported the government in general but wanted to see details. \nMeanwhile, the debate comes as the UN Special Rapporteur on the human rights of migrants, Francois Crepeau, is due to arrive on Tuesday to look at the government’s migration policies and laws. \nEarlier \nThe Federal Government wants to pass laws to make sure no asylum seekers who tried to come to Australia by boat, even those found to be refugees, can ever enter the country. \nThe Prime Minister Malcolm Turnbull today told media “the door to Australia is closed to those who seek to come here by boat with a people smuggler”. \n“That absolutely unflinching, unequivocal message has to be loud and clear,” he told reporters in Sydney this morning. \nThe government will ask parliament to ban everyone who was sent to Nauru or Papua New Guinea’s Manus Island for offshore immigration processing after July 19, 2013–the date Labor prime minister Kevin Rudd declared: “As of today, asylum seekers who come here by boat without a visa will never be settled in Australia.” \nThe ban would apply whether or not they were found to be refugees and extends to all types of visas, including tourist and business categories. Asylum seekers aged under 18 at the time they were sent to Nauru or Manus Island would be exempt. \nThe minister would also have power to lift the bar if they believe it’s in the public interest for someone to be allowed in to Australia. \nImmigration Minister Peter Dutton described the plan as one of the government’s strongest moves, building on the success of its border protection policies over the past three years. \nIt sent a clear message that Australia was not an option. \n“There are still people, advocates in Australia and elsewhere, who are messaging to people on Nauru and Manus, that at some stage you’ll come to Australia,” Mr Dutton said. \n“Those people are living in false hope and it cannot continue.” The legislation would reflect the coalition’s long-standing policy and what it understood to be Labor’s position, Mr Turnbull said. \nHe expects the opposition will give “unequivocal support” to the move. \nForeign Minister Julie Bishop earlier this morning said the government would enshrine in law what had been a longstanding policy. \n“This is a tough message we are sending to the people smuggling syndicates and those who pay people smugglers to try and enter Australia,” she told ABC TV. \n“We are sending a strong message to those currently in Manus and Nauru, if they are found to be owed protection, they will not be resettled in Australia. If they’re not found to be owed protection, they should return home.” \nThis would even apply to accepted refugees later attempting to visit via tourist visa, she said. \n“I will never forget 1200 people that we know of drowned at sea coming to Australia under these people smuggling networks,” she said. “We cannot have situations where people are drowning at sea and that is why we are working through the case load, the cohort of people who are on Manus and Nauru, to find third country resettlements for them and if they want to stay in PNG and in Nauru, they can be resettled there.” \nMr Turnbull expects Labor and its leader Bill Shorten will support the laws, saying they are “entirely consistent with his party’s stated public position”. \nMr Dutton added Australia has ‘discussions ongoing with a number of countries’ on the issue of resettling the asylum seekers already at Naru and Manus. \nDeputy Opposition Leader Tanya Plibersek said it was too soon to determine if Labor would support the bill. \n“What I’d say is it’s a distraction from Peter Dutton’s hopeless mismanagement of his portfolio,” she told reporters on the Gold Coast. \n“It is extraordinary that, three years on, the government has not found third countries to resettle those people who are in limbo on Manus Island and Nauru.” She said Mr Dutton needed to find a permanent resettlement option for these people left in limbo.",
		"thread_title": "Turnbull to Propose Law That Bans Boat Asylum Seekers from Australia Permanently",
		"title": "Turnbull to Propose Law That Bans Boat Asylum Seekers from Australia Permanently",
		"type": "bs",
		"uuid": "349905e67a1c429dbdacf50c09b593f72443fd10"
	},
	"-KhIgnDRpKJl3r4Gtmuq": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:26.097+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "crisis",
				"salience": 0.21484709,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02_m3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whiteness_studies"
				},
				"name": "Whiteness",
				"salience": 0.08844847,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.05570092,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.042514965,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.026610557,
				"type": "PERSON"
			},
			{
				"name": "whiteness",
				"salience": 0.021578932,
				"type": "OTHER"
			},
			{
				"name": "membership",
				"salience": 0.021489758,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.014919028,
				"type": "LOCATION"
			},
			{
				"name": "Eric Kaufmann",
				"salience": 0.012633986,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.011887642,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.011777919,
				"type": "PERSON"
			},
			{
				"name": "nationalism",
				"salience": 0.0105428435,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.009358674,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.009221358,
				"type": "OTHER"
			},
			{
				"name": "Amanda Taub",
				"salience": 0.008359241,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.008150353,
				"type": "ORGANIZATION"
			},
			{
				"name": "context",
				"salience": 0.007809504,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.007585845,
				"type": "OTHER"
			},
			{
				"name": "privilege",
				"salience": 0.0072061582,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0068393885,
				"type": "PERSON"
			},
			{
				"name": "anxiety",
				"salience": 0.0067642005,
				"type": "OTHER"
			},
			{
				"name": "tumult",
				"salience": 0.0067642005,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0067642005,
				"type": "OTHER"
			},
			{
				"name": "mouthful",
				"salience": 0.0067642005,
				"type": "PERSON"
			},
			{
				"name": "capture",
				"salience": 0.0067642005,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.0067642005,
				"type": "OTHER"
			},
			{
				"name": "skin color",
				"salience": 0.0067642005,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0067642005,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.005767494,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.0054394426,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.0054189363,
				"type": "PERSON"
			},
			{
				"name": "sort",
				"salience": 0.0052402816,
				"type": "OTHER"
			},
			{
				"name": "fragility",
				"salience": 0.0051533077,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.005104066,
				"type": "OTHER"
			},
			{
				"name": "adults",
				"salience": 0.004629499,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0046155117,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.00434647,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.00434647,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.004206171,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norway"
				},
				"name": "Norway",
				"salience": 0.0041659363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.0041659363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.0041659363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0041659363,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.0041659363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austria",
				"salience": 0.0041659363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03gj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hungary"
				},
				"name": "Hungary",
				"salience": 0.0041659363,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0041151657,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0041151657,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.003965669,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0038574084,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0037892254,
				"type": "PERSON"
			},
			{
				"name": "norm",
				"salience": 0.0036364025,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "identity",
				"salience": 0.0035784817,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0035784817,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0035784817,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0034342934,
				"type": "LOCATION"
			},
			{
				"name": "traditions",
				"salience": 0.0032179342,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.0032179342,
				"type": "LOCATION"
			},
			{
				"name": "politics",
				"salience": 0.0032179342,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0032179342,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.0032179342,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0030840489,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0030481943,
				"type": "LOCATION"
			},
			{
				"name": "identity",
				"salience": 0.0029216835,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0027866608,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0027866608,
				"type": "OTHER"
			},
			{
				"name": "appearance",
				"salience": 0.0027866608,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0027866608,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0027782365,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0026931365,
				"type": "LOCATION"
			},
			{
				"name": "wages",
				"salience": 0.0026488905,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.002643543,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.0026041488,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.002565857,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.002529219,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0024991045,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0024886478,
				"type": "OTHER"
			},
			{
				"name": "income",
				"salience": 0.0024041666,
				"type": "OTHER"
			},
			{
				"name": "populist parties",
				"salience": 0.0023561355,
				"type": "OTHER"
			},
			{
				"name": "feeling",
				"salience": 0.0023439766,
				"type": "OTHER"
			},
			{
				"name": "opportunities",
				"salience": 0.0022565033,
				"type": "OTHER"
			},
			{
				"name": "incomes",
				"salience": 0.0022565033,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0022565033,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0022136488,
				"type": "OTHER"
			},
			{
				"name": "identity vacuum",
				"salience": 0.0021901834,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0021827808,
				"type": "OTHER"
			},
			{
				"name": "opportunities",
				"salience": 0.0021722922,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0021722922,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0021722922,
				"type": "OTHER"
			},
			{
				"name": "self-esteem",
				"salience": 0.002135347,
				"type": "OTHER"
			},
			{
				"name": "mantra",
				"salience": 0.0020556543,
				"type": "OTHER"
			},
			{
				"name": "grandparents",
				"salience": 0.0019540016,
				"type": "PERSON"
			},
			{
				"name": "generation",
				"salience": 0.0019540016,
				"type": "PERSON"
			},
			{
				"name": "industry",
				"salience": 0.0019540016,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.0019540016,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.0019540016,
				"type": "LOCATION"
			},
			{
				"name": "reversal",
				"salience": 0.0018810726,
				"type": "OTHER"
			},
			{
				"name": "multiculturalism",
				"salience": 0.0018810726,
				"type": "OTHER"
			},
			{
				"name": "civil rights movement",
				"salience": 0.0018810726,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.0018810726,
				"type": "OTHER"
			},
			{
				"name": "university admissions",
				"salience": 0.0018810726,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.0018810726,
				"type": "OTHER"
			},
			{
				"name": "demise",
				"salience": 0.0018810726,
				"type": "EVENT"
			},
			{
				"name": "safety net",
				"salience": 0.0018810726,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.0018810726,
				"type": "OTHER"
			},
			{
				"name": "phenomenon",
				"salience": 0.0018453437,
				"type": "OTHER"
			},
			{
				"name": "societies",
				"salience": 0.0018421985,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0018421985,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0018421985,
				"type": "PERSON"
			},
			{
				"name": "loss",
				"salience": 0.0018421985,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0017601805,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345gh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Birkbeck,_University_of_London"
				},
				"name": "Birkbeck College, University of London",
				"salience": 0.0017154036,
				"type": "ORGANIZATION"
			},
			{
				"name": "Robin DiAngelo",
				"salience": 0.0016606324,
				"type": "PERSON"
			},
			{
				"name": "bigotry",
				"salience": 0.001595209,
				"type": "OTHER"
			},
			{
				"name": "broadening",
				"salience": 0.001595209,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.001595209,
				"type": "LOCATION"
			},
			{
				"name": "gatherings",
				"salience": 0.001595209,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.001595209,
				"type": "EVENT"
			},
			{
				"name": "rallies",
				"salience": 0.001595209,
				"type": "EVENT"
			},
			{
				"name": "demand",
				"salience": 0.001595209,
				"type": "OTHER"
			},
			{
				"name": "descent",
				"salience": 0.001595209,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.001595209,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.001595209,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.001595209,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0015898162,
				"type": "OTHER"
			},
			{
				"name": "identities",
				"salience": 0.0015898162,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0015767466,
				"type": "LOCATION"
			},
			{
				"name": "fears",
				"salience": 0.0015425545,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0015241819,
				"type": "EVENT"
			},
			{
				"name": "manufacturing",
				"salience": 0.0014972078,
				"type": "OTHER"
			},
			{
				"name": "whiteness",
				"salience": 0.0014198453,
				"type": "OTHER"
			},
			{
				"name": "whiteness",
				"salience": 0.0014198453,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0013761799,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0013761799,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0013761799,
				"type": "LOCATION"
			},
			{
				"name": "trade",
				"salience": 0.0013761799,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0013761799,
				"type": "OTHER"
			},
			{
				"name": "identity politics",
				"salience": 0.0013761799,
				"type": "OTHER"
			},
			{
				"name": "whiteness",
				"salience": 0.0013668438,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0013540963,
				"type": "ORGANIZATION"
			},
			{
				"name": "nations",
				"salience": 0.0013540963,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0013540963,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00130227,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0012858594,
				"type": "PERSON"
			},
			{
				"name": "mayor",
				"salience": 0.0012858594,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0012558367,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dhqxv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gallup_(company)"
				},
				"name": "Gallup",
				"salience": 0.001202714,
				"type": "ORGANIZATION"
			},
			{
				"name": "majorities",
				"salience": 0.0012016041,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0011916469,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.0011916469,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0011916469,
				"type": "OTHER"
			},
			{
				"name": "vocabulary",
				"salience": 0.0011916469,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011916469,
				"type": "LOCATION"
			},
			{
				"name": "drugs",
				"salience": 0.0011916469,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "war",
				"salience": 0.0011916469,
				"type": "EVENT"
			},
			{
				"name": "crime",
				"salience": 0.0011916469,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0011916469,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0011876179,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.0010766757,
				"type": "EVENT"
			},
			{
				"name": "society",
				"salience": 0.0010022622,
				"type": "OTHER"
			},
			{
				"name": "Immigration",
				"salience": 0.0010022622,
				"type": "OTHER"
			},
			{
				"name": "pro-Brexit",
				"salience": 0.0009818288,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.0009818288,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0009818288,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.0009771589,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0009576282,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0009576282,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.00094842806,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.00094842806,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.00086785416,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.00086785416,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.00086785416,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00086785416,
				"type": "OTHER"
			},
			{
				"name": "masse",
				"salience": 0.00086785416,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00082920416,
				"type": "OTHER"
			},
			{
				"name": "background hum",
				"salience": 0.00079768745,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.00074866996,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.00074866996,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.00074866996,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.00074866996,
				"type": "OTHER"
			},
			{
				"name": "default",
				"salience": 0.00074866996,
				"type": "OTHER"
			},
			{
				"name": "backlash",
				"salience": 0.00074866996,
				"type": "OTHER"
			},
			{
				"name": "hum",
				"salience": 0.00074866996,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03w86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamism"
				},
				"name": "Islamist",
				"salience": 0.00073340535,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.00069952453,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00069070776,
				"type": "EVENT"
			},
			{
				"name": "stress",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.00064826274,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "outsiders",
				"salience": 0.00064826274,
				"type": "PERSON"
			},
			{
				"name": "insecurity",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "belonging",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "reassurance",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "defensiveness",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "customs",
				"salience": 0.00064826274,
				"type": "OTHER"
			},
			{
				"name": "economies",
				"salience": 0.0006007567,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:26.097+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Amanda Taub, New York Times, November 1, 2016 \nCall it the crisis of whiteness. \nWhite anxiety has fueled this year’s political tumult in the West: Britain’s surprising vote to exit the European Union, Donald J. Trump’s unexpected capture of the Republican presidential nomination in the United States, the rise of right-wing nationalism in Norway, Hungary, Austria and Greece. \nWhiteness, in this context, is more than just skin color. You could define it as membership in the “ethno-national majority,” but that’s a mouthful. What it really means is the privilege of not being defined as “other.” \nWhiteness means being part of the group whose appearance, traditions, religion and even food are the default norm. It’s being a person who, by unspoken rules, was long entitled as part of “us” instead of “them.” \n{snip} \n“It’s fundamentally about ‘who are we?’” said Eric Kaufmann, a professor of politics at Birkbeck College, University of London. “What does it mean to be part of this nation? Is it not ‘our’ nation anymore, ‘our’ meaning the ethnic majority? \n“These kinds of questions are really front and center, even though they’re not necessarily verbalized.” \nThe questions can seem like a sudden reversal after decades of rising multiculturalism, through the civil rights movement in the United States and the European Union’s opening up of borders. \n{snip} \nWhite people’s officially privileged status waned over the latter half of the 20th century with the demise of discriminatory practices in, say, university admissions. But rising wages, an expanding social safety net and new educational opportunities helped offset that. Most white adults were wealthier and more successful than their parents, and confident that their children would do better still. \nThat feeling of success may have provided a sort of identity in itself. \nBut as Western manufacturing and industry have declined, taking many working-class towns with them, parents and grandparents have found that the opportunities they once had are unavailable to the next generation. \nThat creates an identity vacuum to be filled. \n“For someone who is lower income or lower class,” Professor Kaufmann explained, “you’re going to get more self-esteem out of a communal identity such as ethnicity or the nation than you would out of any sort of achieved identity.” \n{snip} \nA recent Gallup study found that Mr. Trump’s supporters tend to earn above-average incomes for their communities, but also tend to live in majority-white areas where children are likely to be worse off than their parents. \n{snip} \nThe formal rejection of racial discrimination in those societies has, by extension, constructed a new, broader national identity. The United States has a black president; London has a Muslim mayor of Pakistani descent. \nBut that broadening can, to some, feel like a painful loss, articulated in the demand voiced over and over at Trump rallies, pro-Brexit events and gatherings for populist parties throughout Europe: “I want my country back.” \nThe mantra is not all about bigotry. Rather, being part of a culture designed around people’s own community and customs is a constant background hum of reassurance, of belonging. \nThe loss of that comforting hum has accelerated a phenomenon that Robin DiAngelo, a lecturer and author, calls “white fragility”–the stress white people feel when they confront the knowledge that they are neither special nor the default; that whiteness is just a race like any other. \nFragility leads to feelings of insecurity, defensiveness, even threat. And it can trigger a backlash against those who are perceived as outsiders. \n{snip} \nFor decades, the language of white identity has only existed in the context of white supremacy. When that became taboo, it left white identity politics without a vocabulary. \nIf you are a working-class white person and you fear that the new, cosmopolitan world will destroy or diminish an identity you cherish, you have no culturally acceptable way to articulate what you perceive as a crisis. \nSome of these people have instead reached for issues that feel close to their concerns: trade, crime, the war on drugs, controlling the borders, fear of Islamist terrorism. All are significant in their own right, and create very real fears for many people, but they have also become a means to have a public conversation about what society’s changes mean for white majorities. \n{snip} \nThere will not likely be a return to the whiteness of social dominance and exclusive national identity. Immigration cannot be halted without damaging Western nations’ economies; immigrants who have already arrived cannot be expelled en masse without causing social and moral damage. And the other groups who seem to be “cutting in line” are in fact getting a chance at progress that was long denied them. \nWestern whites have a place within their nations’ new, broader national identities. But unless they accept it, the crisis of whiteness seems likely to continue.",
		"thread_title": "Behind 2016’s Turmoil, a Crisis of White Identity",
		"title": "Behind 2016’s Turmoil, a Crisis of White Identity",
		"type": "bs",
		"uuid": "704345f036857a5bcc96c6c75062cb34e845fcc1"
	},
	"-KhIgnbtm7g-jwFr0BVN": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:28.935+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-Americans",
				"salience": 0.20810167,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.14610322,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.11464724,
				"type": "LOCATION"
			},
			{
				"name": "Voting",
				"salience": 0.045186255,
				"type": "EVENT"
			},
			{
				"name": "Soft",
				"salience": 0.041546278,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.036352854,
				"type": "LOCATION"
			},
			{
				"name": "levels",
				"salience": 0.0308025,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.026029939,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.019063683,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jeremy Peters",
				"salience": 0.019063683,
				"type": "PERSON"
			},
			{
				"name": "Boding Ill",
				"salience": 0.019063683,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.018833159,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.018253176,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.016990824,
				"type": "EVENT"
			},
			{
				"name": "problem",
				"salience": 0.016522061,
				"type": "OTHER"
			},
			{
				"name": "lead",
				"salience": 0.012785286,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.011437767,
				"type": "PERSON"
			},
			{
				"name": "share",
				"salience": 0.0099951085,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.009416024,
				"type": "EVENT"
			},
			{
				"name": "turnout",
				"salience": 0.008728771,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.008728771,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.008366707,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.007886313,
				"type": "PERSON"
			},
			{
				"name": "decline",
				"salience": 0.0065463837,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0065266388,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.006382872,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0058722314,
				"type": "LOCATION"
			},
			{
				"name": "electorate",
				"salience": 0.0055369358,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.005265306,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0051905625,
				"type": "PERSON"
			},
			{
				"name": "churches",
				"salience": 0.0048319814,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.004593418,
				"type": "OTHER"
			},
			{
				"name": "push",
				"salience": 0.004593418,
				"type": "EVENT"
			},
			{
				"name": "voter enthusiasm",
				"salience": 0.0044222404,
				"type": "OTHER"
			},
			{
				"name": "impediments",
				"salience": 0.0044222404,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.0044222404,
				"type": "OTHER"
			},
			{
				"name": "appeals court",
				"salience": 0.0044222404,
				"type": "ORGANIZATION"
			},
			{
				"name": "assault",
				"salience": 0.0044222404,
				"type": "EVENT"
			},
			{
				"name": "election boards",
				"salience": 0.0044222404,
				"type": "ORGANIZATION"
			},
			{
				"name": "constituencies",
				"salience": 0.0043936446,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0041397316,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0037510707,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0037510707,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0037510707,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0035842604,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0035842604,
				"type": "LOCATION"
			},
			{
				"name": "voting",
				"salience": 0.00301527,
				"type": "EVENT"
			},
			{
				"name": "turnout",
				"salience": 0.00301527,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0027945598,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0026113046,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00241844,
				"type": "OTHER"
			},
			{
				"name": "gap",
				"salience": 0.002259822,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.002231364,
				"type": "OTHER"
			},
			{
				"name": "voter drives",
				"salience": 0.0021210657,
				"type": "EVENT"
			},
			{
				"name": "gains",
				"salience": 0.0020419317,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0020419317,
				"type": "PERSON"
			},
			{
				"name": "drop-off",
				"salience": 0.0020419317,
				"type": "EVENT"
			},
			{
				"name": "visit",
				"salience": 0.0019409886,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0016076828,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.001525538,
				"type": "LOCATION"
			},
			{
				"name": "voter participation",
				"salience": 0.001525538,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.0012570083,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07l5z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toledo,_Ohio"
				},
				"name": "Toledo",
				"salience": 0.00093902764,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01smm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Columbus,_Ohio"
				},
				"name": "Columbus",
				"salience": 0.00093902764,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01sn3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cleveland"
				},
				"name": "Cleveland",
				"salience": 0.00093902764,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:28.935+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Black Turnout Soft in Early Voting, Boding Ill for Hillary Clinton Jeremy Peters et al., New York Times, November 1, 2016 \nAfrican-Americans are failing to vote at the robust levels they did four years ago in several states that could help decide the presidential election, creating a vexing problem for Hillary Clinton as she clings to a deteriorating lead over Donald J. Trump with Election Day just a week away. \n{snip} \nThe reasons for the decline appear to be both political and logistical, with lower voter enthusiasm and newly enacted impediments to voting at play. In North Carolina, where a federal appeals court accused Republicans of an “almost surgical” assault on black turnout and Republican-run election boards curtailed early-voting sites, black turnout is down 16 percent . White turnout, however, is up 15 percent. Democrats are planning an aggressive final push, including a visit by President Obama to the state on Wednesday. \nBut in Florida, which extended early voting after long lines left some voters waiting for hours in 2012, African-Americans’ share of the electorate that has gone to the polls in person so far has decreased , to 15 percent today from 25 percent four years ago. \nThe problems for Democrats do not end there. In Ohio, which also cut back its early voting, voter participation in the heavily Democratic areas near Cleveland, Columbus and Toledo has been down, though the Clinton campaign said it was encouraged by a busy day on Sunday when African-American churches led voter drives across the state. \n{snip} \nThe Clinton campaign believes it can close the gap, especially in North Carolina and Florida, by Election Day. And Democrats are seeing substantial gains in turnout for other key constituencies like Hispanics and college-educated women, which have the potential to more than make up for any drop-off in black voting. \n{snip}",
		"thread_title": "Black Turnout Soft in Early Voting, Boding Ill for Hillary Clinton",
		"title": "Black Turnout Soft in Early Voting, Boding Ill for Hillary Clinton",
		"type": "bs",
		"uuid": "e9a6f58481becff7b6939e59034878ea1feabe94"
	},
	"-KhIgnnkLe3MZ_hFPKMV": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:32.049+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.2257107,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.17194456,
				"type": "PERSON"
			},
			{
				"name": "John Gramlich",
				"salience": 0.07928175,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.06290732,
				"type": "PERSON"
			},
			{
				"name": "Backers",
				"salience": 0.037504178,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08qtd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pew_Research_Center"
				},
				"name": "Pew Research Center",
				"salience": 0.034994386,
				"type": "ORGANIZATION"
			},
			{
				"name": "trouble",
				"salience": 0.034902357,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.03474815,
				"type": "PERSON"
			},
			{
				"name": "Respect Trump",
				"salience": 0.032782763,
				"type": "OTHER"
			},
			{
				"name": "tone",
				"salience": 0.03256073,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.03256073,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.025706764,
				"type": "PERSON"
			},
			{
				"name": "Harder for Clinton Supporters",
				"salience": 0.023257833,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.015545664,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.013535388,
				"type": "EVENT"
			},
			{
				"name": "another",
				"salience": 0.013535388,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.013517615,
				"type": "PERSON"
			},
			{
				"name": "college graduates",
				"salience": 0.013208131,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.010115038,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.009738869,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0082732625,
				"type": "PERSON"
			},
			{
				"name": "backers",
				"salience": 0.008003726,
				"type": "PERSON"
			},
			{
				"name": "survey",
				"salience": 0.0069340626,
				"type": "OTHER"
			},
			{
				"name": "opposite",
				"salience": 0.006267065,
				"type": "OTHER"
			},
			{
				"name": "difficulty",
				"salience": 0.005909398,
				"type": "OTHER"
			},
			{
				"name": "trouble",
				"salience": 0.0055511245,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0048662345,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.004684957,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.004684957,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.004447814,
				"type": "PERSON"
			},
			{
				"name": "college",
				"salience": 0.0041100415,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0029699537,
				"type": "OTHER"
			},
			{
				"name": "difficulty",
				"salience": 0.0027301188,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.0022377342,
				"type": "OTHER"
			},
			{
				"name": "share",
				"salience": 0.0021636686,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0021636686,
				"type": "PERSON"
			},
			{
				"name": "nonwhites",
				"salience": 0.0021636686,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0021636686,
				"type": "OTHER"
			},
			{
				"name": "college degree",
				"salience": 0.0016165582,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:32.049+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "It’s Harder for Clinton Supporters to Respect Trump Backers Than Vice Versa John Gramlich, Pew Research, November 1, 2016 Given the rancorous tone and often highly personal nature of this year’s presidential campaign, supporters of Hillary Clinton and Donald Trump might be expected to hold similarly negative views of one another. But a new Pew Research Center survey finds that Clinton backers–particularly highly educated ones–have more difficulty respecting Trump supporters than the other way around. Nearly six-in-ten registered voters who back Clinton (58%) say they have a “hard time” respecting someone who supports Trump for president; 40% say they have “no trouble” with it. Nearly the opposite is true among Trump supporters, with 56% saying they have no trouble respecting someone who backs Clinton and 40% saying they do have trouble with it. Among Clinton supporters, those with a college degree have a harder time respecting someone who prefers Trump than those who have not graduated from college. About two-thirds (66%) of college graduates who back Clinton say they have a hard time, compared with a narrower majority (53%) among Clinton supporters who have not completed college. White women who back Clinton also are particularly likely to say they have difficulty respecting those who favor Trump: 68% say this, compared with a smaller share of white men (59%) and fewer nonwhites. \n{snip}",
		"thread_title": "It’s Harder for Clinton Supporters to Respect Trump Backers Than Vice Versa",
		"title": "It’s Harder for Clinton Supporters to Respect Trump Backers Than Vice Versa",
		"type": "bs",
		"uuid": "dcab0fd7024a22210a7e5b95130d20ba9bc1fe37"
	},
	"-KhIgo1CwSaQtbk0l5lz": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:34.163+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Professor",
				"salience": 0.14028572,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.12284119,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.10785175,
				"type": "PERSON"
			},
			{
				"name": "law professor",
				"salience": 0.041261867,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.04091473,
				"type": "OTHER"
			},
			{
				"name": "Susan Benesch",
				"salience": 0.036564633,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.021302922,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.020598212,
				"type": "OTHER"
			},
			{
				"name": "speaker",
				"salience": 0.01969778,
				"type": "PERSON"
			},
			{
				"name": "research",
				"salience": 0.019569235,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.017356332,
				"type": "OTHER"
			},
			{
				"name": "Devotes Her Life to Countering Dangerous Speech",
				"salience": 0.014046337,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.013116336,
				"type": "LOCATION"
			},
			{
				"name": "Colby Itkowitz",
				"salience": 0.012070049,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.011660782,
				"type": "LOCATION"
			},
			{
				"name": "case study",
				"salience": 0.011660782,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.011660782,
				"type": "LOCATION"
			},
			{
				"name": "means",
				"salience": 0.0107871555,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.009467032,
				"type": "PERSON"
			},
			{
				"name": "context",
				"salience": 0.009344286,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.008798766,
				"type": "EVENT"
			},
			{
				"name": "speech act",
				"salience": 0.0072548427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04xn_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Myanmar"
				},
				"name": "Burma",
				"salience": 0.0071855057,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/019rg5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kenya"
				},
				"name": "Kenya",
				"salience": 0.0071855057,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.0071855057,
				"type": "ORGANIZATION"
			},
			{
				"name": "area",
				"salience": 0.0065560527,
				"type": "LOCATION"
			},
			{
				"name": "speech",
				"salience": 0.006493711,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.005967874,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.005967874,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.005967874,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.005770468,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.005745393,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.005709507,
				"type": "PERSON"
			},
			{
				"name": "election system",
				"salience": 0.005551459,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.005551459,
				"type": "WORK_OF_ART"
			},
			{
				"name": "violence",
				"salience": 0.004873131,
				"type": "OTHER"
			},
			{
				"name": "mass atrocities",
				"salience": 0.0048078713,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0048078713,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0048078713,
				"type": "OTHER"
			},
			{
				"name": "faculty associate",
				"salience": 0.0048078713,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0046672095,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.0044931504,
				"type": "ORGANIZATION"
			},
			{
				"name": "extent",
				"salience": 0.0044271178,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.004151174,
				"type": "PERSON"
			},
			{
				"name": "meaning",
				"salience": 0.004096046,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0040182956,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0038936099,
				"type": "OTHER"
			},
			{
				"name": "grievances",
				"salience": 0.0038936099,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0037483682,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0037483682,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0036412107,
				"type": "OTHER"
			},
			{
				"name": "relevan t audience",
				"salience": 0.0035206832,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03ksy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_University"
				},
				"name": "Harvard University",
				"salience": 0.003418407,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kw4j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_University"
				},
				"name": "American University",
				"salience": 0.003418407,
				"type": "ORGANIZATION"
			},
			{
				"name": "news",
				"salience": 0.0033718522,
				"type": "OTHER"
			},
			{
				"name": "dissemination",
				"salience": 0.0033718522,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0033718522,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0033718522,
				"type": "OTHER"
			},
			{
				"name": "episodes",
				"salience": 0.0033718522,
				"type": "WORK_OF_ART"
			},
			{
				"name": "call",
				"salience": 0.0033718522,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.0033718522,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0033718522,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0033718522,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.0032460543,
				"type": "OTHER"
			},
			{
				"name": "undertone",
				"salience": 0.0032460543,
				"type": "OTHER"
			},
			{
				"name": "framework",
				"salience": 0.0032460543,
				"type": "OTHER"
			},
			{
				"name": "indicators",
				"salience": 0.0032460543,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0032460543,
				"type": "OTHER"
			},
			{
				"name": "degree",
				"salience": 0.0032460543,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0032460543,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.003178997,
				"type": "EVENT"
			},
			{
				"name": "grievances",
				"salience": 0.0030218414,
				"type": "OTHER"
			},
			{
				"name": "groundwork",
				"salience": 0.002847186,
				"type": "OTHER"
			},
			{
				"name": "risks",
				"salience": 0.0028362675,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.0028053222,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.002794045,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.0027529192,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.0027529192,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.0026666243,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0026523536,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0026523536,
				"type": "OTHER"
			},
			{
				"name": "incitement",
				"salience": 0.0026501939,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0025347786,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0024377306,
				"type": "EVENT"
			},
			{
				"name": "institutions",
				"salience": 0.0023750393,
				"type": "ORGANIZATION"
			},
			{
				"name": "unrest",
				"salience": 0.0020566473,
				"type": "EVENT"
			},
			{
				"name": "balloting",
				"salience": 0.0020566473,
				"type": "EVENT"
			},
			{
				"name": "practices",
				"salience": 0.0020566473,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0020566473,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0020566473,
				"type": "OTHER"
			},
			{
				"name": "disobedience",
				"salience": 0.0020566473,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0019059908,
				"type": "PERSON"
			},
			{
				"name": "messages",
				"salience": 0.0017298586,
				"type": "OTHER"
			},
			{
				"name": "intergroup",
				"salience": 0.0017298586,
				"type": "ORGANIZATION"
			},
			{
				"name": "institutions",
				"salience": 0.0017298586,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07shq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Second_Amendment_to_the_United_States_Constitution"
				},
				"name": "Second Amendment",
				"salience": 0.0016945986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "member",
				"salience": 0.0016790073,
				"type": "PERSON"
			},
			{
				"name": "danger",
				"salience": 0.0014979182,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0014979182,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0014979182,
				"type": "OTHER"
			},
			{
				"name": "hallmark",
				"salience": 0.0014238314,
				"type": "LOCATION"
			},
			{
				"name": "competition",
				"salience": 0.0014238314,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.0012922379,
				"type": "OTHER"
			},
			{
				"name": "trafficking",
				"salience": 0.0011189538,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0011189538,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0011189538,
				"type": "OTHER"
			},
			{
				"name": "founders",
				"salience": 0.0011189538,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0009829956,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.00088087027,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:34.163+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Loading Posted on November 2, 2016 This Professor Devotes Her Life to Countering Dangerous Speech. She Can’t Ignore Donald Trump’s. Colby Itkowitz, Washington Post, October 24, 2016 \nWhen Susan Benesch began looking at how speech could incite mass violence, her research took her to far-flung places like Kenya and Burma. \nLately, she’s been unable to ignore a case study at home in the United States. \nThe American University law professor and Harvard University faculty associate has grappled for months with whether Donald Trump’s rhetoric constitutes dangerous speech as she has come to define it. She has examined election-year speech before, but only abroad where the risks of mass atrocities were great. \nBut in the past week, with Trump claiming that the election system and the media are rigged against him, his messages have the type of undertone that increases the risk of violence between groups, she said. \nBenesch, 52, has dedicated the past six years of her life to developing and testing a framework for identifying dangerous speech. To rise to that level, at least two of these five indicators must be true: A powerful speaker with a high degree of influence over the audience. The audience has grievances and fears that the speaker can cultivate. A speech act that is clearly understood as a call to violence. A social or historical context that is propitious for violence, for any of a variety of reasons, including long-standing competition between groups for resources, lack of efforts to solve grievances or previous episodes of violence. A means of dissemination that is influential in itself, for example because it is the sole or primary source of news for the relevan t audience. \n“Trump’s speech is very difficult in the sense that he is so often slippery with it,” Benesch said in a recent interview. “The meaning is so often ambiguous.” \nBut when Trump said his supporters could use the Second Amendment against Hillary Clinton, “it seems to me impossible that people didn’t understand that as a reference to violence,” she said. Or when he suggested that Clinton and President Obama were founders of the Islamic State, something he alluded to again at Wednesday’s final debate, that was a “hallmark of dangerous speech to describe an in-group member as the enemy,” she said. \nAnd now, with Trump trafficking in the conspiracy theory that if he loses the election it will be because of a rigged system against him, he’s definitely laying the groundwork for potential unrest after the balloting. Direct incitement of violence is illegal, but Trump falls short of actually calling for any kind of civil disobedience. \nBecause of that, it’s still a gray area that surrounds whether Trump does use dangerous speech. \n“Trump may well be undermining the extent to which his supporters trust the essential institutions and practices of U.S. democracy,” Benesch said. “Some of them–those who are most susceptible to being inflamed by such messages–may therefore be more likely to commit violence. However, the United States is not in danger of mass intergroup violence, in my view. It is deeply irresponsible, though, since it can undermine some Americans’ belief in our own democratic institutions, which can make them more susceptible to dangerous speech going forward.” \n{snip}",
		"thread_title": "This Professor Devotes Her Life to Countering Dangerous Speech. She Can’t Ignore Donald Trump’s.",
		"title": "This Professor Devotes Her Life to Countering Dangerous Speech. She Can’t Ignore Donald Trump’s.",
		"type": "bs",
		"uuid": "5497a9a498e2552aaa6c9a7b357a4617dad0581f"
	},
	"-KhIgoG437SWndErM3Xi": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:34.547+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.33794388,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.12202891,
				"type": "PERSON"
			},
			{
				"name": "view",
				"salience": 0.048636112,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.048186183,
				"type": "OTHER"
			},
			{
				"name": "Poll",
				"salience": 0.04460136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA Today",
				"salience": 0.032844514,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Alt-Right",
				"salience": 0.029948022,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0134kj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Millennials"
				},
				"name": "Millennials",
				"salience": 0.025362158,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f4r5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bureau_of_Land_Management"
				},
				"name": "BLM",
				"salience": 0.021723904,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/087fqp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Susan_Page"
				},
				"name": "Susan Page",
				"salience": 0.021723904,
				"type": "PERSON"
			},
			{
				"name": "Karina Shedrofsky",
				"salience": 0.021723904,
				"type": "PERSON"
			},
			{
				"name": "alt-right",
				"salience": 0.01681966,
				"type": "OTHER"
			},
			{
				"name": "attitudes",
				"salience": 0.014580977,
				"type": "OTHER"
			},
			{
				"name": "alt-right movement",
				"salience": 0.013207484,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.01203419,
				"type": "OTHER"
			},
			{
				"name": "Rock the Vote Millennial Poll",
				"salience": 0.01149672,
				"type": "OTHER"
			},
			{
				"name": "activist movement",
				"salience": 0.0103303995,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.008138021,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian Americans",
				"salience": 0.0076817507,
				"type": "PERSON"
			},
			{
				"name": "survey",
				"salience": 0.0074717253,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.007449208,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.007449208,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0072536618,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0070504737,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0067028534,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0067028534,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0061351154,
				"type": "OTHER"
			},
			{
				"name": "Whites",
				"salience": 0.0060538016,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.006010532,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.005925275,
				"type": "OTHER"
			},
			{
				"name": "impression",
				"salience": 0.0057295305,
				"type": "OTHER"
			},
			{
				"name": "adults",
				"salience": 0.0052440027,
				"type": "PERSON"
			},
			{
				"name": "alt-right",
				"salience": 0.0051874984,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.005162451,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.0050486904,
				"type": "EVENT"
			},
			{
				"name": "deaths",
				"salience": 0.0050486904,
				"type": "EVENT"
			},
			{
				"name": "opinion",
				"salience": 0.0047248565,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0042828075,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0042828075,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.0042828075,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0042828075,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0036956582,
				"type": "PERSON"
			},
			{
				"name": "divide",
				"salience": 0.0030043432,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0029819035,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.0028114412,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0026378045,
				"type": "PERSON"
			},
			{
				"name": "Ipsos Public Affairs",
				"salience": 0.0026378045,
				"type": "ORGANIZATION"
			},
			{
				"name": "over-sample",
				"salience": 0.0018098091,
				"type": "OTHER"
			},
			{
				"name": "anti-Semites",
				"salience": 0.0017422838,
				"type": "PERSON"
			},
			{
				"name": "supremacists",
				"salience": 0.0017422838,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.00044295218,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:34.547+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Poll: How Millennials View BLM and the Alt-Right Susan Page and Karina Shedrofsky, USA Today, October 31, 2016 \nMost Millennials have a positive view of the Black Lives Matter movement, a USA TODAY/Rock the Vote Millennial Poll finds, but attitudes are more mixed about the less well-known alt-right. \nIn the survey of Americans 18 to 34 years old, 58% say they have a favorable opinion about Black Lives Matter, an activist movement that grew from protests over the shooting deaths of unarmed African Americans. Among blacks, an overwhelming 81% have a favorable view, including 50% who are “very favorable.” Just 14% of blacks have an unfavorable opinion. \nWhites have a positive impression of the movement by 53%-39%, Hispanics by 64%-31%, and Asian Americans by 54%-40%. \n{snip} \nThe online poll of 1,299 young adults, including an over-sample of minorities, was taken Oct. 21-24 by Ipsos Public Affairs. {snip} \nThe alt-right movement, which includes groups on the far right, has gained attention recently because of the support for Donald Trump by some white supremacists and anti-Semites. But it is much less well-known among Millennials. Nearly half of those surveyed, 45%, say they don’t know enough about the alt-right to have an opinion of it, compared with just 8% who say that of Black Lives Matter. \nAmong those who express an opinion, 34% say they have a favorable opinion of the alt-right, 21% an unfavorable one. \nAmong whites, the favorable-unfavorable divide is 33%-19%. Among African Americans, it is 31%-27%. Among Hispanics, 46%-23%. Among Asian Americans, 37%-23%. \n{snip}",
		"thread_title": "Poll: How Millennials View BLM and the Alt-Right",
		"title": "Poll: How Millennials View BLM and the Alt-Right",
		"type": "bs",
		"uuid": "9e70c9cfeac66c2da9e19ca07512a73c2151d920"
	},
	"-KhIgoNlHA4ER8cMG6Z5": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:35.169+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "undergraduate",
				"salience": 0.11792732,
				"type": "PERSON"
			},
			{
				"name": "Martínez",
				"salience": 0.09616178,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.07086313,
				"type": "OTHER"
			},
			{
				"name": "student",
				"salience": 0.057180587,
				"type": "PERSON"
			},
			{
				"name": "Tiffany Martínez",
				"salience": 0.051838204,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.05148655,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.05148655,
				"type": "OTHER"
			},
			{
				"name": "Charles H.F. Davis III",
				"salience": 0.040968183,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0czqx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Inside_Higher_Ed"
				},
				"name": "Inside Higher Ed",
				"salience": 0.031876933,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latina",
				"salience": 0.031876933,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vrdk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Suffolk_University"
				},
				"name": "Suffolk University",
				"salience": 0.031876933,
				"type": "ORGANIZATION"
			},
			{
				"name": "professor",
				"salience": 0.030092137,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.019941775,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.017233819,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.016508233,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.012640694,
				"type": "OTHER"
			},
			{
				"name": "plea",
				"salience": 0.01095075,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.01095075,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.01095075,
				"type": "WORK_OF_ART"
			},
			{
				"name": "scholar",
				"salience": 0.01095075,
				"type": "PERSON"
			},
			{
				"name": "journal author",
				"salience": 0.01095075,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.010464494,
				"type": "OTHER"
			},
			{
				"name": "sociology professor",
				"salience": 0.010235188,
				"type": "PERSON"
			},
			{
				"name": "professor",
				"salience": 0.008683114,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.008541115,
				"type": "EVENT"
			},
			{
				"name": "comment",
				"salience": 0.008186295,
				"type": "WORK_OF_ART"
			},
			{
				"name": "paste",
				"salience": 0.0076843174,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0076843174,
				"type": "WORK_OF_ART"
			},
			{
				"name": "claim",
				"salience": 0.0073979953,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0073979953,
				"type": "OTHER"
			},
			{
				"name": "plagiarism",
				"salience": 0.0073979953,
				"type": "OTHER"
			},
			{
				"name": "invalidating",
				"salience": 0.0073979953,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0072453585,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.006887607,
				"type": "OTHER"
			},
			{
				"name": "Academia, Love Me Back",
				"salience": 0.0067474335,
				"type": "WORK_OF_ART"
			},
			{
				"name": "McNair",
				"salience": 0.0067474335,
				"type": "PERSON"
			},
			{
				"name": "sentences",
				"salience": 0.0062753246,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.0062753246,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.0062753246,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.005996292,
				"type": "PERSON"
			},
			{
				"name": "stories",
				"salience": 0.0054593002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "marginalization",
				"salience": 0.005414747,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.005414747,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0047285906,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0047285906,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0047285906,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.004689448,
				"type": "OTHER"
			},
			{
				"name": "campus climate assessments",
				"salience": 0.004689448,
				"type": "OTHER"
			},
			{
				"name": "professor",
				"salience": 0.0042451606,
				"type": "PERSON"
			},
			{
				"name": "color",
				"salience": 0.003944832,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.003416219,
				"type": "PERSON"
			},
			{
				"name": "writing",
				"salience": 0.003416219,
				"type": "OTHER"
			},
			{
				"name": "class discussions",
				"salience": 0.003416219,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0032641892,
				"type": "OTHER"
			},
			{
				"name": "self-doubt",
				"salience": 0.0025523175,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0025523175,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0025523175,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.0025523175,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:35.169+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Charles H.F. Davis III, Inside Higher Ed, November 1, 2016 \n{snip} \nThe recent case involving a first-generation Latina student , Tiffany Martínez, at Suffolk University, is but one example. An accomplished undergraduate, published journal author and McNair scholar, Martínez wrote a personal blog post titled “Academia, Love Me Back.” In her heartfelt plea, Martínez first recounts an experience she described as both disrespectful and invalidating and then explains that a sociology professor accused her of plagiarism, not privately, but in front of the entire class. The professor’s claim was further illustrated by emphatic written statements on her paper such as “this is not your word” and “please go back and indicate where you cut and paste.” \nOne such comment was written in the margin near the word “hence,” which the professor had circled, an important detail, given Martínez merely used it as an appropriate transition to connect two related sentences. Was it that surprising to Martínez’s professor that she knew how to appropriately use a transitional word? \nAlthough some may dismiss this as a minor incident, Martínez reminds us of the internalized racism and self-doubt resulting from years of educational violence. Like the many students of color from whom we hear similar stories in our campus climate assessments , what transpired for Martínez was yet another debilitating and painful experience of marginalization. \n{snip} \nIt is imperative that our colleagues stop being surprised when students of color are able to thoughtfully articulate themselves in their writing and in class discussions. {snip} \n{snip}",
		"thread_title": "Hence, This Is Racist",
		"title": "Hence, This Is Racist",
		"type": "bs",
		"uuid": "b0b3709bb7c54e00c237596219adf2e9943b0434"
	},
	"-KhIgoZRHKHAnCWybTLA": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:36.291+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Students",
				"salience": 0.23401591,
				"type": "PERSON"
			},
			{
				"name": "club",
				"salience": 0.1903134,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_m3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whiteness_studies"
				},
				"name": "Whiteness",
				"salience": 0.079360634,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.061232533,
				"type": "OTHER"
			},
			{
				"name": "Whites",
				"salience": 0.04699224,
				"type": "PERSON"
			},
			{
				"name": "Racism",
				"salience": 0.038601927,
				"type": "OTHER"
			},
			{
				"name": "Group",
				"salience": 0.03573339,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.03573339,
				"type": "PERSON"
			},
			{
				"name": "club",
				"salience": 0.032340247,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.028086932,
				"type": "OTHER"
			},
			{
				"name": "Wreck White",
				"salience": 0.0240025,
				"type": "OTHER"
			},
			{
				"name": "Quincy Clarke",
				"salience": 0.020074984,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019n9w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pomona_College"
				},
				"name": "Pomona College",
				"salience": 0.020074984,
				"type": "ORGANIZATION"
			},
			{
				"name": "Campus Reform",
				"salience": 0.017414749,
				"type": "OTHER"
			},
			{
				"name": "White People for Deconstructing Whiteness",
				"salience": 0.008328279,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.007655755,
				"type": "PERSON"
			},
			{
				"name": "We've Got Work To Do",
				"salience": 0.007216722,
				"type": "OTHER"
			},
			{
				"name": "whiteness",
				"salience": 0.0066633765,
				"type": "OTHER"
			},
			{
				"name": "Ian Haney López",
				"salience": 0.0063961702,
				"type": "PERSON"
			},
			{
				"name": "racist.",
				"salience": 0.0056005814,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0053753336,
				"type": "ORGANIZATION"
			},
			{
				"name": "W",
				"salience": 0.004854909,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.004854909,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0165sw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Claremont_Colleges"
				},
				"name": "Claremont Colleges",
				"salience": 0.004263523,
				"type": "ORGANIZATION"
			},
			{
				"name": "advertisement",
				"salience": 0.004205569,
				"type": "WORK_OF_ART"
			},
			{
				"name": "microaggressive",
				"salience": 0.004205569,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.004118855,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0040489533,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0040489533,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0039654593,
				"type": "OTHER"
			},
			{
				"name": "W",
				"salience": 0.0039654593,
				"type": "OTHER"
			},
			{
				"name": "peers",
				"salience": 0.0039477875,
				"type": "PERSON"
			},
			{
				"name": "no one",
				"salience": 0.0038981538,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0032821367,
				"type": "ORGANIZATION"
			},
			{
				"name": "page",
				"salience": 0.0032241535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/082kg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_supremacy"
				},
				"name": "White Supremacy",
				"salience": 0.0028799374,
				"type": "OTHER"
			},
			{
				"name": "guilt",
				"salience": 0.00256707,
				"type": "OTHER"
			},
			{
				"name": "5C",
				"salience": 0.0024942877,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0018702633,
				"type": "OTHER"
			},
			{
				"name": "inequality",
				"salience": 0.0018702633,
				"type": "OTHER"
			},
			{
				"name": "vortex",
				"salience": 0.0018702633,
				"type": "OTHER"
			},
			{
				"name": "construct",
				"salience": 0.0018702633,
				"type": "OTHER"
			},
			{
				"name": "edifice",
				"salience": 0.0018702633,
				"type": "OTHER"
			},
			{
				"name": "self-deprecation",
				"salience": 0.0018702633,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0018702633,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0018005051,
				"type": "OTHER"
			},
			{
				"name": "character",
				"salience": 0.0017778346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07hwkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_American"
				},
				"name": "White",
				"salience": 0.0016716385,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.001580771,
				"type": "OTHER"
			},
			{
				"name": "fantasy",
				"salience": 0.0014888162,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0013973962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0011514706,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:36.291+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "White Students Start Whites-Only Group to Wreck White Racism Quincy Clarke, Campus Reform, November 2, 2016 \nA number of white Pomona College students formed a new club called “We’ve Got Work To Do: White People for Deconstructing Whiteness.” The club, open to students from all five of the Claremont Colleges, aims to “work on owning our racism, deconstructing our Whiteness, and to engage in movement & action toward dismantling White Supremacy.” \n“White people at the 5C’s: we’re all racist. we’re all microaggressive. [W]e are all not only complicit in, but actively perpetuating white supremacy,” states an advertisement for the group. “Pretending that we are not racist and hoping that no one will discover our racism really doesn’t cut it. [W]e need to ACTIVELY be doing work to deconstruct our whiteness (and holding our peers accountable in doing the same).” \n“Recognizing that White identity is a self-fashioned, hierarchical fantasy, Whites should attempt to dismantle Whiteness as it currently exists,” explains the group’s Facebook page , quoting Ian Haney López, a leading racial justice scholar. “Whites should renounce their privileged racial character, though not simply out of guilt or any sense of self-deprecation. Rather, they should dismantle the edifice of Whiteness because this mythological construct stands at the vortex of racial inequality in America.” \n{snip}",
		"thread_title": "White Students Start Whites-Only Group to Wreck White Racism",
		"title": "White Students Start Whites-Only Group to Wreck White Racism",
		"type": "bs",
		"uuid": "545d442baa94fc60af692fd3bb7626fabe4fb862"
	},
	"-KhIgrHb2-56Sy48B-h2": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:36.946+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cf98",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pim_Fortuyn"
				},
				"name": "Pim Fortuyn",
				"salience": 0.30718902,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.1794653,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03ts0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/French_people"
				},
				"name": "French",
				"salience": 0.049580224,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04g0k_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Geert_Wilders"
				},
				"name": "Geert Wilders",
				"salience": 0.043199614,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hp7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Front_(France)"
				},
				"name": "Front National",
				"salience": 0.037867505,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.033359237,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01wgkb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Frits_Bolkestein"
				},
				"name": "Frits Bolkestein",
				"salience": 0.022423215,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d7x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jean-Marie_Le_Pen"
				},
				"name": "Jean-Marie Le Pen",
				"salience": 0.017772451,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02433z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Danish_People's_Party"
				},
				"name": "Danish People's Party",
				"salience": 0.016817663,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.007198073,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09xg8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jacques_Chirac"
				},
				"name": "Jacques Chirac",
				"salience": 0.0069193807,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.006284984,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Denmark",
				"salience": 0.006196876,
				"type": "LOCATION"
			},
			{
				"name": "immigrants",
				"salience": 0.005561066,
				"type": "PERSON"
			},
			{
				"name": "centre-right parties",
				"salience": 0.004789652,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ahmed Marcouch",
				"salience": 0.004476128,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0044741537,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b8qx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Naser_Khader"
				},
				"name": "Naser Khader",
				"salience": 0.0036664174,
				"type": "PERSON"
			},
			{
				"name": "gasp",
				"salience": 0.002634574,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hrb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lionel_Jospin"
				},
				"name": "Lionel Jospin",
				"salience": 0.002537973,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d2s4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Labour_Party_(Netherlands)"
				},
				"name": "Dutch Labour party",
				"salience": 0.002501138,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02rdgs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_Le_Pen"
				},
				"name": "Marine Le Pen",
				"salience": 0.0024232836,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.0024220147,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.0020343766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05c1b5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Party_for_Freedom"
				},
				"name": "Party for Freedom",
				"salience": 0.0019772535,
				"type": "ORGANIZATION"
			},
			{
				"name": "voters",
				"salience": 0.0019524354,
				"type": "PERSON"
			},
			{
				"name": "phrase welfare state",
				"salience": 0.0019267409,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0019136509,
				"type": "ORGANIZATION"
			},
			{
				"name": "rightwing parties",
				"salience": 0.0018895607,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.0018895607,
				"type": "ORGANIZATION"
			},
			{
				"name": "streets",
				"salience": 0.0016783098,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/024310",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Democrats_(Denmark)"
				},
				"name": "Social Democrats",
				"salience": 0.0015938181,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.0015698874,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01gkql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alain_Finkielkraut"
				},
				"name": "Alain Finkielkraut",
				"salience": 0.0014978009,
				"type": "PERSON"
			},
			{
				"name": "graduates",
				"salience": 0.0014406601,
				"type": "PERSON"
			},
			{
				"name": "Right",
				"salience": 0.0013354352,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dnn6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pim_Fortuyn_List"
				},
				"name": "Pim Fortuyn List",
				"salience": 0.0011925772,
				"type": "ORGANIZATION"
			},
			{
				"name": "voters",
				"salience": 0.0010970606,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6p50r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mette_Frederiksen"
				},
				"name": "Mette Frederiksen",
				"salience": 0.001092785,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0010663817,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d2rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/People's_Party_for_Freedom_and_Democracy"
				},
				"name": "People's Party for Freedom and Democracy",
				"salience": 0.0010528582,
				"type": "ORGANIZATION"
			},
			{
				"name": "Thomas Gyldal Petersen",
				"salience": 0.0010359298,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0009885991,
				"type": "EVENT"
			},
			{
				"name": "nation",
				"salience": 0.0009664953,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0008920109,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.00087891956,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0008778472,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.0008778472,
				"type": "ORGANIZATION"
			},
			{
				"name": "establishment parties",
				"salience": 0.0008778472,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.0008778472,
				"type": "OTHER"
			},
			{
				"name": "establishment parties",
				"salience": 0.0008778472,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.0008778472,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amsterdam"
				},
				"name": "Amsterdam",
				"salience": 0.000877817,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ps9k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicolas_Sarkozy"
				},
				"name": "Nicolas Sarkozy",
				"salience": 0.0008710054,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0008611404,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03k5sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ayaan_Hirsi_Ali"
				},
				"name": "Ayaan Hirsi Ali",
				"salience": 0.00085736805,
				"type": "PERSON"
			},
			{
				"name": "integration",
				"salience": 0.00085697277,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.00081986905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02840y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alain_Jupp%C3%A9"
				},
				"name": "Alain Juppé",
				"salience": 0.0008118706,
				"type": "PERSON"
			},
			{
				"name": "opposite",
				"salience": 0.000780512,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00077481696,
				"type": "PERSON"
			},
			{
				"name": "welfare state",
				"salience": 0.00076717895,
				"type": "OTHER"
			},
			{
				"name": "adversaries",
				"salience": 0.0007655997,
				"type": "ORGANIZATION"
			},
			{
				"name": "young",
				"salience": 0.00072925637,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0006875621,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0006820519,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "gay rights",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0006820519,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.0006820519,
				"type": "OTHER"
			},
			{
				"name": "obstacle",
				"salience": 0.00067965593,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.00066932465,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0006645251,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00064572523,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.0006360409,
				"type": "OTHER"
			},
			{
				"name": "body politic",
				"salience": 0.0006360409,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0006360409,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00063269626,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.00062608096,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.00062608096,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048kc0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Theo_van_Gogh_(film_director)"
				},
				"name": "Theo van Gogh",
				"salience": 0.000621637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01pmbg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poul_Nyrup_Rasmussen"
				},
				"name": "Poul Nyrup Rasmussen",
				"salience": 0.0006175996,
				"type": "PERSON"
			},
			{
				"name": "political parties",
				"salience": 0.0006153088,
				"type": "ORGANIZATION"
			},
			{
				"name": "round",
				"salience": 0.0006043326,
				"type": "EVENT"
			},
			{
				"name": "round",
				"salience": 0.0006043326,
				"type": "EVENT"
			},
			{
				"name": "ideas",
				"salience": 0.0006025049,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0005878267,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00057542336,
				"type": "OTHER"
			},
			{
				"name": "crowds",
				"salience": 0.00057542336,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.00055914314,
				"type": "PERSON"
			},
			{
				"name": "rhetoric",
				"salience": 0.0005522676,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00055132614,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.000534219,
				"type": "OTHER"
			},
			{
				"name": "counterparts",
				"salience": 0.0005332501,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0005332501,
				"type": "LOCATION"
			},
			{
				"name": "Politicians",
				"salience": 0.00052624464,
				"type": "PERSON"
			},
			{
				"name": "Rebranding",
				"salience": 0.00052329845,
				"type": "EVENT"
			},
			{
				"name": "centre",
				"salience": 0.00051940064,
				"type": "LOCATION"
			},
			{
				"name": "establishment",
				"salience": 0.00051940064,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00051940064,
				"type": "LOCATION"
			},
			{
				"name": "detractors",
				"salience": 0.0005170775,
				"type": "PERSON"
			},
			{
				"name": "benefits",
				"salience": 0.0005156604,
				"type": "OTHER"
			},
			{
				"name": "elderly",
				"salience": 0.000509518,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.0005048457,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0005048457,
				"type": "ORGANIZATION"
			},
			{
				"name": "left",
				"salience": 0.0005048457,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0005048457,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0005048457,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0005048457,
				"type": "EVENT"
			},
			{
				"name": "left",
				"salience": 0.0005048457,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0005048457,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0005048457,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0005048457,
				"type": "EVENT"
			},
			{
				"name": "left",
				"salience": 0.0005048457,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0005048457,
				"type": "OTHER"
			},
			{
				"name": "antisemites",
				"salience": 0.0004894857,
				"type": "PERSON"
			},
			{
				"name": "anti-immigration",
				"salience": 0.0004894857,
				"type": "OTHER"
			},
			{
				"name": "antisemitism",
				"salience": 0.0004894857,
				"type": "OTHER"
			},
			{
				"name": "accords",
				"salience": 0.00048431568,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00047598852,
				"type": "OTHER"
			},
			{
				"name": "socialists",
				"salience": 0.00047477012,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.00047319633,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00047319633,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00047264923,
				"type": "LOCATION"
			},
			{
				"name": "break",
				"salience": 0.0004689472,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.0004678556,
				"type": "PERSON"
			},
			{
				"name": "welfare",
				"salience": 0.00045581913,
				"type": "OTHER"
			},
			{
				"name": "fringe ideas",
				"salience": 0.00045581913,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.00045581913,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00045581913,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00045581913,
				"type": "EVENT"
			},
			{
				"name": "fear",
				"salience": 0.00045581913,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00045581913,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0004371472,
				"type": "OTHER"
			},
			{
				"name": "mayor",
				"salience": 0.0004371472,
				"type": "PERSON"
			},
			{
				"name": "ideology",
				"salience": 0.00043489033,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0004284202,
				"type": "PERSON"
			},
			{
				"name": "causes",
				"salience": 0.00041690175,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.00041690175,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00041552336,
				"type": "OTHER"
			},
			{
				"name": "cartoons",
				"salience": 0.00041031817,
				"type": "WORK_OF_ART"
			},
			{
				"name": "voters",
				"salience": 0.0004080289,
				"type": "PERSON"
			},
			{
				"name": "communists",
				"salience": 0.00039741886,
				"type": "PERSON"
			},
			{
				"name": "influx",
				"salience": 0.00039469296,
				"type": "OTHER"
			},
			{
				"name": "nostalgia",
				"salience": 0.00039469296,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00039469296,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00039469296,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.00039469296,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00039469296,
				"type": "OTHER"
			},
			{
				"name": "extremists",
				"salience": 0.00039469296,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00038746465,
				"type": "OTHER"
			},
			{
				"name": "Danes",
				"salience": 0.00038744937,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0003862926,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.000385076,
				"type": "OTHER"
			},
			{
				"name": "euro",
				"salience": 0.00038340027,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0003801316,
				"type": "OTHER"
			},
			{
				"name": "constituency",
				"salience": 0.00037273814,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "Guardian",
				"salience": 0.00037195068,
				"type": "ORGANIZATION"
			},
			{
				"name": "republic",
				"salience": 0.00036994726,
				"type": "LOCATION"
			},
			{
				"name": "voting",
				"salience": 0.00036994726,
				"type": "EVENT"
			},
			{
				"name": "resentment",
				"salience": 0.00036994726,
				"type": "OTHER"
			},
			{
				"name": "attachment",
				"salience": 0.00036994726,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.00036994726,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.00036994726,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.00036994726,
				"type": "OTHER"
			},
			{
				"name": "Democratic Muslims",
				"salience": 0.00036524303,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ln61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reporters_Without_Borders"
				},
				"name": "Reporters Without Borders",
				"salience": 0.00036381863,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11bwfmmbjb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom_withdrawal_from_the_European_Union"
				},
				"name": "Brexit",
				"salience": 0.00036367006,
				"type": "PERSON"
			},
			{
				"name": "wave",
				"salience": 0.00036225741,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00036132734,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00036132734,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00036132734,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00036132734,
				"type": "ORGANIZATION"
			},
			{
				"name": "establishment party",
				"salience": 0.00036132734,
				"type": "ORGANIZATION"
			},
			{
				"name": "message",
				"salience": 0.00036068095,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00034600587,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.00034496532,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.00034496532,
				"type": "OTHER"
			},
			{
				"name": "daughter",
				"salience": 0.0003443371,
				"type": "PERSON"
			},
			{
				"name": "victory speech",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "establishment figures",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "homophobes",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "homophobes",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "liberties",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0003417618,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0003417618,
				"type": "PERSON"
			},
			{
				"name": "base",
				"salience": 0.0003417618,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.00033999726,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.00033999726,
				"type": "EVENT"
			},
			{
				"name": "Immigrants",
				"salience": 0.0003358554,
				"type": "PERSON"
			},
			{
				"name": "road",
				"salience": 0.0003352682,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.00033243353,
				"type": "PERSON"
			},
			{
				"name": "rabble-rouser",
				"salience": 0.00033148093,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00032757284,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.00032265886,
				"type": "PERSON"
			},
			{
				"name": "Sasha Polakow-Suransky",
				"salience": 0.00032206866,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00031890473,
				"type": "PERSON"
			},
			{
				"name": "intolerance",
				"salience": 0.00031508275,
				"type": "OTHER"
			},
			{
				"name": "communist party",
				"salience": 0.00031427376,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.00031371426,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.00031371426,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.00031200558,
				"type": "PERSON"
			},
			{
				"name": "Andrew Hussey",
				"salience": 0.00030998583,
				"type": "PERSON"
			},
			{
				"name": "correctness",
				"salience": 0.00030921996,
				"type": "OTHER"
			},
			{
				"name": "anxiety",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "backbone",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "skinheads",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "opponents",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "prospect",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "north",
				"salience": 0.00030856894,
				"type": "LOCATION"
			},
			{
				"name": "regions",
				"salience": 0.00030856894,
				"type": "LOCATION"
			},
			{
				"name": "defenders",
				"salience": 0.00030856894,
				"type": "PERSON"
			},
			{
				"name": "triumph",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "feminists",
				"salience": 0.00030856894,
				"type": "PERSON"
			},
			{
				"name": "anxiety",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00030856894,
				"type": "PERSON"
			},
			{
				"name": "anger",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "celebrations",
				"salience": 0.00030856894,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.00030856894,
				"type": "OTHER"
			},
			{
				"name": "revellers",
				"salience": 0.00030856894,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Dutch",
				"salience": 0.00030494266,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00030356852,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01qdcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Party_(France)"
				},
				"name": "Socialist",
				"salience": 0.00029674007,
				"type": "ORGANIZATION"
			},
			{
				"name": "Søren Espersen",
				"salience": 0.00029626486,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Danes",
				"salience": 0.00029431607,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01l3vx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France_national_football_team"
				},
				"name": "France",
				"salience": 0.00029039587,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.0002893402,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.00028467932,
				"type": "OTHER"
			},
			{
				"name": "Julian Rochedy",
				"salience": 0.00028443008,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.00028324482,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.00028129446,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.00028109123,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00028071215,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.00028071215,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00028071215,
				"type": "OTHER"
			},
			{
				"name": "gay rights",
				"salience": 0.00028071215,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00028071215,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.00028053237,
				"type": "LOCATION"
			},
			{
				"name": "reflex",
				"salience": 0.00027941397,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0002734965,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00026990112,
				"type": "ORGANIZATION"
			},
			{
				"name": "victories",
				"salience": 0.00026776592,
				"type": "PERSON"
			},
			{
				"name": "vacuum",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "gates",
				"salience": 0.00026718527,
				"type": "LOCATION"
			},
			{
				"name": "barbarians",
				"salience": 0.00026718527,
				"type": "PERSON"
			},
			{
				"name": "bulwark",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "encouragement",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "symbols",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "south",
				"salience": 0.00026718527,
				"type": "LOCATION"
			},
			{
				"name": "upwards",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "ambitions",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "net",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "demagoguery",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "baggage",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "normal",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "landscape",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "border security measures",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "pillar",
				"salience": 0.00026718527,
				"type": "OTHER"
			},
			{
				"name": "extremists",
				"salience": 0.000266377,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00026575683,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0002634994,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0002632034,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03chm60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_M%C3%A9nard"
				},
				"name": "Robert Ménard",
				"salience": 0.000262863,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.00026176998,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00026176998,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00026176998,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00026176998,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00026176998,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.00026176998,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0002601792,
				"type": "LOCATION"
			},
			{
				"name": "immigration",
				"salience": 0.00025766972,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.00025766972,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.00025766972,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00025609188,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ppyrn"
				},
				"name": "Trotskyist",
				"salience": 0.0002546655,
				"type": "PERSON"
			},
			{
				"name": "Aydin Soei",
				"salience": 0.00025333875,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00025331503,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00025331503,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00025331503,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0glsn6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bent_Melchior"
				},
				"name": "Bent Melchior",
				"salience": 0.00025307582,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.00024909337,
				"type": "OTHER"
			},
			{
				"name": "death threat",
				"salience": 0.0002478072,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00024685625,
				"type": "OTHER"
			},
			{
				"name": "Anti-racism",
				"salience": 0.00024676797,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00024525687,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.00024385662,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00024385662,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00024385662,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00024385662,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00024385662,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.00024385662,
				"type": "ORGANIZATION"
			},
			{
				"name": "activists",
				"salience": 0.0002395216,
				"type": "PERSON"
			},
			{
				"name": "civilisation",
				"salience": 0.00023942979,
				"type": "OTHER"
			},
			{
				"name": "inheritors",
				"salience": 0.0002368157,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.0002328053,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rwhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NRC_Handelsblad"
				},
				"name": "NRC Handelsblad",
				"salience": 0.0002321856,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.00023184804,
				"type": "OTHER"
			},
			{
				"name": "government official",
				"salience": 0.00023121804,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0002301139,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0002301139,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00022389628,
				"type": "PERSON"
			},
			{
				"name": "republic",
				"salience": 0.00022129511,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00021945513,
				"type": "LOCATION"
			},
			{
				"name": "assassin",
				"salience": 0.00021744799,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f69h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neo-Nazism"
				},
				"name": "neo-Nazis",
				"salience": 0.00021654413,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.00021535864,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00021463034,
				"type": "OTHER"
			},
			{
				"name": "Klaas Dijkhoff",
				"salience": 0.00021325637,
				"type": "PERSON"
			},
			{
				"name": "integration",
				"salience": 0.000211925,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00021147379,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00020832208,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ltg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands_national_football_team"
				},
				"name": "Oranje",
				"salience": 0.00020788738,
				"type": "LOCATION"
			},
			{
				"name": "elections",
				"salience": 0.00020776286,
				"type": "EVENT"
			},
			{
				"name": "ground",
				"salience": 0.00020776286,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00020776286,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.00020703765,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00020678491,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.00020470406,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.00020443337,
				"type": "OTHER"
			},
			{
				"name": "radio interview",
				"salience": 0.00020144026,
				"type": "EVENT"
			},
			{
				"name": "argument",
				"salience": 0.0001999402,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0001998653,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00019974056,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00019939213,
				"type": "ORGANIZATION"
			},
			{
				"name": "voters",
				"salience": 0.00019679467,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.00019679467,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00019679467,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00019655444,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00019473689,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0001947352,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0001947352,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.00019372965,
				"type": "OTHER"
			},
			{
				"name": "illegals",
				"salience": 0.00019226283,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.00019128938,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.00019048847,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00018944635,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.00018944635,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00018944635,
				"type": "PERSON"
			},
			{
				"name": "yearning",
				"salience": 0.00018903057,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00018758248,
				"type": "LOCATION"
			},
			{
				"name": "party office",
				"salience": 0.00018758248,
				"type": "OTHER"
			},
			{
				"name": "contingent",
				"salience": 0.00018749491,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.00018693262,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00018674434,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00018630954,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00018630954,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00018630954,
				"type": "PERSON"
			},
			{
				"name": "Bas Heijne",
				"salience": 0.00018499064,
				"type": "PERSON"
			},
			{
				"name": "danger",
				"salience": 0.00018457633,
				"type": "OTHER"
			},
			{
				"name": "skin",
				"salience": 0.00018457633,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.00018143543,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.00018096954,
				"type": "ORGANIZATION"
			},
			{
				"name": "debate",
				"salience": 0.00017989693,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00017989693,
				"type": "OTHER"
			},
			{
				"name": "backwards",
				"salience": 0.00017989693,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00017935268,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00017914372,
				"type": "LOCATION"
			},
			{
				"name": "figure",
				"salience": 0.000178968,
				"type": "OTHER"
			},
			{
				"name": "monetary policy",
				"salience": 0.00017666188,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.00017551724,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.00017501104,
				"type": "LOCATION"
			},
			{
				"name": "road",
				"salience": 0.00017335408,
				"type": "LOCATION"
			},
			{
				"name": "battles",
				"salience": 0.00017335408,
				"type": "EVENT"
			},
			{
				"name": "society",
				"salience": 0.00017104484,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00017104484,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0001688411,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gg6s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Democratic_Party_of_Germany"
				},
				"name": "Social Democratic",
				"salience": 0.00016818676,
				"type": "ORGANIZATION"
			},
			{
				"name": "demons",
				"salience": 0.00016813418,
				"type": "OTHER"
			},
			{
				"name": "mayor",
				"salience": 0.00016563265,
				"type": "PERSON"
			},
			{
				"name": "old",
				"salience": 0.00016483208,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045tp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Judeo-Christian"
				},
				"name": "Judeo-Christian",
				"salience": 0.00016442919,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03hpbyp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Place_de_la_R%C3%A9publique"
				},
				"name": "Place de la République",
				"salience": 0.00016442919,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c8wxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholicism"
				},
				"name": "Catholic",
				"salience": 0.00016442919,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01c7nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Provence-Alpes-C%C3%B4te_d'Azur"
				},
				"name": "Côte d'Azur",
				"salience": 0.00016442919,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05f725",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leaf_vegetable"
				},
				"name": "Greens",
				"salience": 0.00016442919,
				"type": "ORGANIZATION"
			},
			{
				"name": "largest",
				"salience": 0.00016315187,
				"type": "EVENT"
			},
			{
				"name": "force",
				"salience": 0.00016242288,
				"type": "OTHER"
			},
			{
				"name": "assassinations",
				"salience": 0.00016242288,
				"type": "EVENT"
			},
			{
				"name": "rhetoric",
				"salience": 0.00016242288,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.00016242288,
				"type": "EVENT"
			},
			{
				"name": "values",
				"salience": 0.00016242288,
				"type": "OTHER"
			},
			{
				"name": "assassination",
				"salience": 0.00016242288,
				"type": "EVENT"
			},
			{
				"name": "influence",
				"salience": 0.00016242288,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00016242288,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00016242288,
				"type": "OTHER"
			},
			{
				"name": "assassination",
				"salience": 0.00016242288,
				"type": "EVENT"
			},
			{
				"name": "leaders",
				"salience": 0.00016132066,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.00016064521,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00016064521,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00016064521,
				"type": "OTHER"
			},
			{
				"name": "gay rights",
				"salience": 0.00016064521,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00016064521,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.00016016203,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.00015981989,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nostalgia",
				"salience": 0.00015835394,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.0001576647,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0001576647,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00015759248,
				"type": "PERSON"
			},
			{
				"name": "economists",
				"salience": 0.0001565155,
				"type": "PERSON"
			},
			{
				"name": "party leaders",
				"salience": 0.00015529677,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.00015529677,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.00015518827,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.00015445777,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00015445777,
				"type": "ORGANIZATION"
			},
			{
				"name": "career",
				"salience": 0.00015418141,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00015384798,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00015384798,
				"type": "LOCATION"
			},
			{
				"name": "centrepiece",
				"salience": 0.00015370164,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0001532944,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.00015323209,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00015323209,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0001522379,
				"type": "EVENT"
			},
			{
				"name": "health care",
				"salience": 0.0001522379,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.0001522379,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.0001522379,
				"type": "OTHER"
			},
			{
				"name": "housing",
				"salience": 0.0001522379,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01v8x4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/French_Communist_Party"
				},
				"name": "French Communist party",
				"salience": 0.00015198726,
				"type": "ORGANIZATION"
			},
			{
				"name": "nostalgia",
				"salience": 0.00015051926,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00014985114,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.00014985114,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00014980412,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.00014980412,
				"type": "PERSON"
			},
			{
				"name": "thought police",
				"salience": 0.00014980412,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.00014980412,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00014954398,
				"type": "ORGANIZATION"
			},
			{
				"name": "profile",
				"salience": 0.00014907292,
				"type": "OTHER"
			},
			{
				"name": "remains",
				"salience": 0.00014907292,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00014810312,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00014810312,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00014810312,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.0001475102,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.00014745745,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00014745745,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.00014745745,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00014565079,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00014565079,
				"type": "EVENT"
			},
			{
				"name": "society",
				"salience": 0.00014504095,
				"type": "OTHER"
			},
			{
				"name": "sociologists",
				"salience": 0.00014504095,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.00014425551,
				"type": "LOCATION"
			},
			{
				"name": "centre",
				"salience": 0.00014425551,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.00014121817,
				"type": "OTHER"
			},
			{
				"name": "trains",
				"salience": 0.00014093422,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.00014063746,
				"type": "OTHER"
			},
			{
				"name": "animal rights activist",
				"salience": 0.00014063746,
				"type": "OTHER"
			},
			{
				"name": "women's liberation",
				"salience": 0.00014063746,
				"type": "ORGANIZATION"
			},
			{
				"name": "parliament",
				"salience": 0.00014063746,
				"type": "LOCATION"
			},
			{
				"name": "platform",
				"salience": 0.00014063746,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00014063746,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00014063746,
				"type": "OTHER"
			},
			{
				"name": "trail",
				"salience": 0.00014063746,
				"type": "LOCATION"
			},
			{
				"name": "ways",
				"salience": 0.00014063746,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00014058939,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.00014021198,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00014021198,
				"type": "EVENT"
			},
			{
				"name": "watershed",
				"salience": 0.00013991124,
				"type": "LOCATION"
			},
			{
				"name": "influence",
				"salience": 0.00013948794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europeans",
				"salience": 0.00013936013,
				"type": "PERSON"
			},
			{
				"name": "Integration",
				"salience": 0.00013768038,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00013651742,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00013651742,
				"type": "PERSON"
			},
			{
				"name": "pioneer",
				"salience": 0.00013640619,
				"type": "PERSON"
			},
			{
				"name": "street",
				"salience": 0.0001359935,
				"type": "LOCATION"
			},
			{
				"name": "antisemites",
				"salience": 0.00013594487,
				"type": "OTHER"
			},
			{
				"name": "anti-fascism",
				"salience": 0.00013594487,
				"type": "OTHER"
			},
			{
				"name": "antisemitism",
				"salience": 0.00013594487,
				"type": "OTHER"
			},
			{
				"name": "Rudy Vercucque",
				"salience": 0.00013433624,
				"type": "PERSON"
			},
			{
				"name": "appeals",
				"salience": 0.0001341005,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00013358584,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.00013309855,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.00013150286,
				"type": "EVENT"
			},
			{
				"name": "family",
				"salience": 0.00013150286,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.00013141963,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.00013141963,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.00013141963,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.00013141963,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.00013141963,
				"type": "EVENT"
			},
			{
				"name": "presidency",
				"salience": 0.00013141963,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00013141963,
				"type": "EVENT"
			},
			{
				"name": "causes",
				"salience": 0.00012978459,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/043bb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tilburg_University"
				},
				"name": "Tilburg University",
				"salience": 0.00012939585,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02wzv25",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Collier"
				},
				"name": "Paul Collier",
				"salience": 0.00012725026,
				"type": "PERSON"
			},
			{
				"name": "success",
				"salience": 0.00012697646,
				"type": "OTHER"
			},
			{
				"name": "triumph",
				"salience": 0.00012697646,
				"type": "OTHER"
			},
			{
				"name": "fragmentation bomb",
				"salience": 0.00012697646,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00012697646,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.00012697646,
				"type": "WORK_OF_ART"
			},
			{
				"name": "defeat",
				"salience": 0.00012697646,
				"type": "EVENT"
			},
			{
				"name": "elsewhere",
				"salience": 0.00012697646,
				"type": "LOCATION"
			},
			{
				"name": "popularity",
				"salience": 0.00012697646,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.00012697646,
				"type": "OTHER"
			},
			{
				"name": "successor",
				"salience": 0.00012697646,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0001265923,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00012611476,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.00012611476,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00012558671,
				"type": "LOCATION"
			},
			{
				"name": "presence",
				"salience": 0.00012491742,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00012414827,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00012400362,
				"type": "LOCATION"
			},
			{
				"name": "asylum centre",
				"salience": 0.00012388565,
				"type": "LOCATION"
			},
			{
				"name": "type",
				"salience": 0.00012324227,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.000122324,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.000122324,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.000121405385,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.000121405385,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.000121320554,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.00012116012,
				"type": "PERSON"
			},
			{
				"name": "housing estate",
				"salience": 0.00012078204,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00011999271,
				"type": "OTHER"
			},
			{
				"name": "Lars Trier Mogensen",
				"salience": 0.000119889744,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.000118895165,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.000118895165,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.000118895165,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.000118895165,
				"type": "OTHER"
			},
			{
				"name": "brand",
				"salience": 0.00011864014,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.00011775268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08k_rv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jyllands-Posten"
				},
				"name": "Jyllands-Posten",
				"salience": 0.00011739721,
				"type": "ORGANIZATION"
			},
			{
				"name": "idea",
				"salience": 0.00011731439,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00011727682,
				"type": "LOCATION"
			},
			{
				"name": "fraternity",
				"salience": 0.000117144606,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00011684379,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/049t5w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohammed_Bouyeri"
				},
				"name": "Mohammed Bouyeri",
				"salience": 0.00011682672,
				"type": "PERSON"
			},
			{
				"name": "jihadi culture",
				"salience": 0.000116790194,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00011626833,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0001157815,
				"type": "PERSON"
			},
			{
				"name": "contender",
				"salience": 0.0001157815,
				"type": "OTHER"
			},
			{
				"name": "anti-colonialism",
				"salience": 0.000115276736,
				"type": "OTHER"
			},
			{
				"name": "news sites",
				"salience": 0.00011516447,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.00011516447,
				"type": "OTHER"
			},
			{
				"name": "Merijn Oudenampsen",
				"salience": 0.000114655304,
				"type": "PERSON"
			},
			{
				"name": "welfare state",
				"salience": 0.00011445536,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.00011386432,
				"type": "LOCATION"
			},
			{
				"name": "freedom",
				"salience": 0.00011386432,
				"type": "OTHER"
			},
			{
				"name": "extremist",
				"salience": 0.00011386432,
				"type": "PERSON"
			},
			{
				"name": "nostalgia",
				"salience": 0.00011386432,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00011386432,
				"type": "EVENT"
			},
			{
				"name": "thinking",
				"salience": 0.00011386432,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.00011386432,
				"type": "EVENT"
			},
			{
				"name": "force",
				"salience": 0.00011386432,
				"type": "ORGANIZATION"
			},
			{
				"name": "security",
				"salience": 0.00011386432,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00011386432,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.00011371275,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0001135992,
				"type": "PERSON"
			},
			{
				"name": "media clout",
				"salience": 0.00011335553,
				"type": "OTHER"
			},
			{
				"name": "celebrations",
				"salience": 0.00011327633,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01y3fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jungle"
				},
				"name": "Jungle",
				"salience": 0.00011308031,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.00011248058,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00011248058,
				"type": "ORGANIZATION"
			},
			{
				"name": "establishment parties",
				"salience": 0.00011248058,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.00011248058,
				"type": "LOCATION"
			},
			{
				"name": "immigration policy",
				"salience": 0.0001118948,
				"type": "OTHER"
			},
			{
				"name": "Labour",
				"salience": 0.00011143943,
				"type": "EVENT"
			},
			{
				"name": "threat",
				"salience": 0.00011143943,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.00011143943,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.00011143943,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.00011086396,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.00011078747,
				"type": "PERSON"
			},
			{
				"name": "majority immigrant",
				"salience": 0.000110141926,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.000110141926,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.000110141926,
				"type": "PERSON"
			},
			{
				"name": "favour",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "traditionalists",
				"salience": 0.000109944995,
				"type": "PERSON"
			},
			{
				"name": "headquarters",
				"salience": 0.000109944995,
				"type": "LOCATION"
			},
			{
				"name": "canals",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.000109944995,
				"type": "PERSON"
			},
			{
				"name": "package",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "kingmaker",
				"salience": 0.000109944995,
				"type": "PERSON"
			},
			{
				"name": "trouncing",
				"salience": 0.000109944995,
				"type": "EVENT"
			},
			{
				"name": "hiding",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "garb",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "staffer",
				"salience": 0.000109944995,
				"type": "PERSON"
			},
			{
				"name": "xenophobia",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "tolerance",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "security services",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.000109944995,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "chest",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "throat",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "depiction",
				"salience": 0.000109944995,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ban",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "incorrectness",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "limelight",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.000109944995,
				"type": "OTHER"
			},
			{
				"name": "nostalgia",
				"salience": 0.00010961236,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00010961236,
				"type": "OTHER"
			},
			{
				"name": "constituencies",
				"salience": 0.00010961236,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.00010961236,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.00010961236,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.00010961236,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.00010946645,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00010890212,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00010841264,
				"type": "PERSON"
			},
			{
				"name": "welfare society",
				"salience": 0.00010833689,
				"type": "ORGANIZATION"
			},
			{
				"name": "Julien Rochedy",
				"salience": 0.00010809166,
				"type": "PERSON"
			},
			{
				"name": "security official",
				"salience": 0.00010734596,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.00010734596,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00010734596,
				"type": "OTHER"
			},
			{
				"name": "Idealism",
				"salience": 0.00010734596,
				"type": "OTHER"
			},
			{
				"name": "victories",
				"salience": 0.00010734596,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.00010672404,
				"type": "PERSON"
			},
			{
				"name": "radicalism",
				"salience": 0.00010672404,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00010672404,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00010661747,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.00010460781,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.00010372346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04s9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_in_Islam"
				},
				"name": "Muhammad",
				"salience": 0.00010341034,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.00010337266,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00010294757,
				"type": "OTHER"
			},
			{
				"name": "commenters",
				"salience": 0.00010294757,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.00010294757,
				"type": "OTHER"
			},
			{
				"name": "era",
				"salience": 0.00010273869,
				"type": "OTHER"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.00010273869,
				"type": "EVENT"
			},
			{
				"name": "racists",
				"salience": 0.00010273869,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.00010273869,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.00010273869,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.00010273869,
				"type": "PERSON"
			},
			{
				"name": "migration",
				"salience": 0.00010273869,
				"type": "EVENT"
			},
			{
				"name": "left",
				"salience": 0.00010273869,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.00010273869,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.00010273869,
				"type": "LOCATION"
			},
			{
				"name": "hijab",
				"salience": 0.00010188707,
				"type": "OTHER"
			},
			{
				"name": "trust",
				"salience": 0.00010122688,
				"type": "OTHER"
			},
			{
				"name": "self-discipline",
				"salience": 0.00010112491,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00010046701,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0000999482,
				"type": "LOCATION"
			},
			{
				"name": "share",
				"salience": 0.00009985016,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.00009978039,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.000099432065,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00009859147,
				"type": "OTHER"
			},
			{
				"name": "refugee crisis",
				"salience": 0.00009859147,
				"type": "EVENT"
			},
			{
				"name": "sort",
				"salience": 0.00009859147,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00009859147,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.00009859147,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.00009859147,
				"type": "PERSON"
			},
			{
				"name": "elderly",
				"salience": 0.00009859147,
				"type": "PERSON"
			},
			{
				"name": "minimum",
				"salience": 0.00009859147,
				"type": "OTHER"
			},
			{
				"name": "kebab shops",
				"salience": 0.00009859147,
				"type": "LOCATION"
			},
			{
				"name": "sort",
				"salience": 0.00009859147,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.00009859147,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0000983619,
				"type": "PERSON"
			},
			{
				"name": "leadership",
				"salience": 0.0000983619,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.00009817864,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.00009817864,
				"type": "PERSON"
			},
			{
				"name": "cause",
				"salience": 0.00009817864,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.00009817864,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00009817864,
				"type": "OTHER"
			},
			{
				"name": "classrooms",
				"salience": 0.00009817864,
				"type": "LOCATION"
			},
			{
				"name": "controversies",
				"salience": 0.00009817864,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.00009817864,
				"type": "LOCATION"
			},
			{
				"name": "detail",
				"salience": 0.00009808234,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.00009795262,
				"type": "EVENT"
			},
			{
				"name": "welfare state",
				"salience": 0.00009705411,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.00009605432,
				"type": "PERSON"
			},
			{
				"name": "player",
				"salience": 0.0000956251,
				"type": "PERSON"
			},
			{
				"name": "moratorium",
				"salience": 0.0000956251,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.0000956251,
				"type": "OTHER"
			},
			{
				"name": "fan",
				"salience": 0.0000956251,
				"type": "PERSON"
			},
			{
				"name": "future",
				"salience": 0.0000956251,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0000956251,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00009549613,
				"type": "OTHER"
			},
			{
				"name": "homophobia",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.00009490979,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.00009490979,
				"type": "PERSON"
			},
			{
				"name": "cloud",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "couples",
				"salience": 0.00009490979,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "car repair shop",
				"salience": 0.00009490979,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "tea shops",
				"salience": 0.00009490979,
				"type": "LOCATION"
			},
			{
				"name": "clouds",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "liberal",
				"salience": 0.00009490979,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.000094843475,
				"type": "OTHER"
			},
			{
				"name": "personality",
				"salience": 0.000094843475,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.000094622636,
				"type": "PERSON"
			},
			{
				"name": "slogans",
				"salience": 0.00009441967,
				"type": "OTHER"
			},
			{
				"name": "asylum",
				"salience": 0.00009419982,
				"type": "OTHER"
			},
			{
				"name": "democrats",
				"salience": 0.00009380539,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccan",
				"salience": 0.00009368598,
				"type": "LOCATION"
			},
			{
				"name": "ammunition",
				"salience": 0.00009364789,
				"type": "OTHER"
			},
			{
				"name": "official",
				"salience": 0.00009336456,
				"type": "PERSON"
			},
			{
				"name": "newspaper",
				"salience": 0.00009294736,
				"type": "ORGANIZATION"
			},
			{
				"name": "culture",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "security issues",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00009294736,
				"type": "OTHER"
			},
			{
				"name": "assassinations",
				"salience": 0.00009294736,
				"type": "EVENT"
			},
			{
				"name": "site",
				"salience": 0.00009282363,
				"type": "OTHER"
			},
			{
				"name": "radicalisation",
				"salience": 0.00009165351,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.00009145771,
				"type": "OTHER"
			},
			{
				"name": "natives",
				"salience": 0.000091368296,
				"type": "PERSON"
			},
			{
				"name": "line",
				"salience": 0.00009130175,
				"type": "OTHER"
			},
			{
				"name": "Marxist",
				"salience": 0.00009015081,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.00009009454,
				"type": "PERSON"
			},
			{
				"name": "template",
				"salience": 0.00008974798,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.00008947644,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00008947644,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.00008901438,
				"type": "LOCATION"
			},
			{
				"name": "prosperity",
				"salience": 0.00008901438,
				"type": "OTHER"
			},
			{
				"name": "Marxists",
				"salience": 0.00008901438,
				"type": "PERSON"
			},
			{
				"name": "hatred",
				"salience": 0.00008901438,
				"type": "OTHER"
			},
			{
				"name": "dignity",
				"salience": 0.00008901438,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00008901438,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.00008901438,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00008901438,
				"type": "LOCATION"
			},
			{
				"name": "court",
				"salience": 0.00008901438,
				"type": "LOCATION"
			},
			{
				"name": "suburbs",
				"salience": 0.00008901438,
				"type": "LOCATION"
			},
			{
				"name": "expression",
				"salience": 0.00008901438,
				"type": "OTHER"
			},
			{
				"name": "rich",
				"salience": 0.00008901438,
				"type": "PERSON"
			},
			{
				"name": "civilisation",
				"salience": 0.00008901438,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.000088807115,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.000088807115,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.000088807115,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.00008837614,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.000087953726,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qst",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Euroscepticism"
				},
				"name": "Euroscepticism",
				"salience": 0.00008772328,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00008738151,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.00008738151,
				"type": "OTHER"
			},
			{
				"name": "protest vote",
				"salience": 0.00008738151,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.00008738151,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.00008711867,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.00008711867,
				"type": "PERSON"
			},
			{
				"name": "news site",
				"salience": 0.00008711867,
				"type": "LOCATION"
			},
			{
				"name": "radicalisation",
				"salience": 0.00008711867,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00008711867,
				"type": "EVENT"
			},
			{
				"name": "site",
				"salience": 0.00008711867,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00008711867,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.00008711867,
				"type": "OTHER"
			},
			{
				"name": "migration",
				"salience": 0.00008711867,
				"type": "EVENT"
			},
			{
				"name": "everywhere",
				"salience": 0.00008711867,
				"type": "LOCATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.00008711867,
				"type": "PERSON"
			},
			{
				"name": "village",
				"salience": 0.00008711867,
				"type": "LOCATION"
			},
			{
				"name": "resettlement",
				"salience": 0.00008711867,
				"type": "OTHER"
			},
			{
				"name": "refugee resettlement",
				"salience": 0.00008711867,
				"type": "OTHER"
			},
			{
				"name": "asylum seekers",
				"salience": 0.00008711867,
				"type": "PERSON"
			},
			{
				"name": "guards",
				"salience": 0.00008678431,
				"type": "PERSON"
			},
			{
				"name": "integration",
				"salience": 0.000086104315,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.00008602046,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.00008575023,
				"type": "PERSON"
			},
			{
				"name": "rejection",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "halal meat",
				"salience": 0.00008569031,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "buildings",
				"salience": 0.00008569031,
				"type": "LOCATION"
			},
			{
				"name": "view",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "apartment",
				"salience": 0.00008569031,
				"type": "LOCATION"
			},
			{
				"name": "vape smoke",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "fascism",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "fascists",
				"salience": 0.00008569031,
				"type": "PERSON"
			},
			{
				"name": "suburb",
				"salience": 0.00008569031,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.00008569031,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00008546021,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00008485127,
				"type": "PERSON"
			},
			{
				"name": "balance",
				"salience": 0.000084669264,
				"type": "OTHER"
			},
			{
				"name": "secession",
				"salience": 0.00008423203,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0000840359,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00008401572,
				"type": "ORGANIZATION"
			},
			{
				"name": "pressure",
				"salience": 0.00008323803,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00008323803,
				"type": "EVENT"
			},
			{
				"name": "death threats",
				"salience": 0.00008323803,
				"type": "OTHER"
			},
			{
				"name": "death threats",
				"salience": 0.00008323803,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.000081955855,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00008193055,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.00008167236,
				"type": "ORGANIZATION"
			},
			{
				"name": "politics",
				"salience": 0.000081484286,
				"type": "OTHER"
			},
			{
				"name": "integration policy",
				"salience": 0.000081484286,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.000081484286,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00008108654,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.00008108654,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00008084121,
				"type": "OTHER"
			},
			{
				"name": "progressives",
				"salience": 0.00008047997,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "elites",
				"salience": 0.00008047997,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.00008047997,
				"type": "EVENT"
			},
			{
				"name": "universalism",
				"salience": 0.00008047997,
				"type": "OTHER"
			},
			{
				"name": "share",
				"salience": 0.00008047997,
				"type": "OTHER"
			},
			{
				"name": "Style",
				"salience": 0.00008047997,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00008047997,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.00008047997,
				"type": "PERSON"
			},
			{
				"name": "identity",
				"salience": 0.00008047997,
				"type": "OTHER"
			},
			{
				"name": "tabloid fearmongering",
				"salience": 0.00008018041,
				"type": "EVENT"
			},
			{
				"name": "enemies",
				"salience": 0.00007946544,
				"type": "OTHER"
			},
			{
				"name": "anthropologists",
				"salience": 0.00007905508,
				"type": "PERSON"
			},
			{
				"name": "admirer",
				"salience": 0.00007905508,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00007889328,
				"type": "OTHER"
			},
			{
				"name": "clash",
				"salience": 0.000078135155,
				"type": "EVENT"
			},
			{
				"name": "salafi",
				"salience": 0.0000780585,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.000077474586,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.00007728444,
				"type": "LOCATION"
			},
			{
				"name": "heroes",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "capitulation",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "human being",
				"salience": 0.0000770745,
				"type": "PERSON"
			},
			{
				"name": "settlers",
				"salience": 0.0000770745,
				"type": "PERSON"
			},
			{
				"name": "banks",
				"salience": 0.0000770745,
				"type": "ORGANIZATION"
			},
			{
				"name": "pieds-noirs",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "peak",
				"salience": 0.0000770745,
				"type": "LOCATION"
			},
			{
				"name": "beards",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "mantle",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "opening",
				"salience": 0.0000770745,
				"type": "EVENT"
			},
			{
				"name": "demise",
				"salience": 0.0000770745,
				"type": "EVENT"
			},
			{
				"name": "analogies",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "must",
				"salience": 0.0000770745,
				"type": "OTHER"
			},
			{
				"name": "asylum",
				"salience": 0.000076895034,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00007684131,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.000076793345,
				"type": "PERSON"
			},
			{
				"name": "doctor",
				"salience": 0.000076575074,
				"type": "PERSON"
			},
			{
				"name": "surgeon",
				"salience": 0.000076575074,
				"type": "PERSON"
			},
			{
				"name": "hair",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "youth wing",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "banlieues",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.00007419628,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tropes",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "loop",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "shutters",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "advisers",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "pitch",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "indulgence",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.00007419628,
				"type": "PERSON"
			},
			{
				"name": "nativity scenes",
				"salience": 0.00007419628,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ethos",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "assimilation",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "cows",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "pretext",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00007419628,
				"type": "OTHER"
			},
			{
				"name": "restaurant",
				"salience": 0.00007419628,
				"type": "LOCATION"
			},
			{
				"name": "butchers",
				"salience": 0.00007419628,
				"type": "PERSON"
			},
			{
				"name": "individual",
				"salience": 0.000073715506,
				"type": "PERSON"
			},
			{
				"name": "mother",
				"salience": 0.000073715506,
				"type": "PERSON"
			},
			{
				"name": "Others",
				"salience": 0.000073715506,
				"type": "PERSON"
			},
			{
				"name": "coup",
				"salience": 0.000073641255,
				"type": "EVENT"
			},
			{
				"name": "welfare system",
				"salience": 0.000073641255,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0000735898,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00007341894,
				"type": "PERSON"
			},
			{
				"name": "cartoon controversy",
				"salience": 0.00007333289,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03w86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamism"
				},
				"name": "Islamism",
				"salience": 0.00007316641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/071jd_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamization"
				},
				"name": "Islamisation",
				"salience": 0.00007316641,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.00007266212,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anger",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"name": "poorest",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"name": "feminism",
				"salience": 0.00007266212,
				"type": "PERSON"
			},
			{
				"name": "none",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.00007266212,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "smoke bombs",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"name": "fireworks",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"name": "theology",
				"salience": 0.00007266212,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Algeria"
				},
				"name": "Algerian",
				"salience": 0.00007214113,
				"type": "LOCATION"
			},
			{
				"name": "ferry terminal",
				"salience": 0.000071796305,
				"type": "LOCATION"
			},
			{
				"name": "leaders",
				"salience": 0.000071629125,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c2cl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michel_de_Montaigne"
				},
				"name": "Montaigne",
				"salience": 0.00007125024,
				"type": "PERSON"
			},
			{
				"name": "trajectory",
				"salience": 0.000070525144,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00007043187,
				"type": "OTHER"
			},
			{
				"name": "Mayors",
				"salience": 0.000070360926,
				"type": "PERSON"
			},
			{
				"name": "meat",
				"salience": 0.00006994866,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00006994866,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00006978579,
				"type": "LOCATION"
			},
			{
				"name": "campaign victory",
				"salience": 0.00006973703,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.00006954217,
				"type": "OTHER"
			},
			{
				"name": "valuables",
				"salience": 0.00006942541,
				"type": "OTHER"
			},
			{
				"name": "immigration numbers",
				"salience": 0.00006942541,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00006942541,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.00006942541,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.00006942541,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00006942541,
				"type": "PERSON"
			},
			{
				"name": "everybody",
				"salience": 0.00006942541,
				"type": "PERSON"
			},
			{
				"name": "everybody",
				"salience": 0.00006942541,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00006942541,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.00006942541,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.00006911518,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00006911518,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.00006890607,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.00006882577,
				"type": "OTHER"
			},
			{
				"name": "anti-PC",
				"salience": 0.000068578105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b85js",
					"wikipedia_url": "http://en.wikipedia.org/wiki/GeenStijl.nl"
				},
				"name": "Geen Stijl",
				"salience": 0.000068571666,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.000067658424,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.000067658424,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0242ym",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venstre_(Denmark)"
				},
				"name": "Venstre",
				"salience": 0.000067658424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07q5n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_Yorker"
				},
				"name": "New Yorker",
				"salience": 0.000067658424,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rfdxh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alternative_for_Germany"
				},
				"name": "Alternative für Deutschland",
				"salience": 0.000067658424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j29lvv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scapegoat"
				},
				"name": "scapegoats",
				"salience": 0.000067658424,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somali",
				"salience": 0.000067658424,
				"type": "LOCATION"
			},
			{
				"name": "Rochedy",
				"salience": 0.000067453715,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.000067336536,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.000067336536,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.000067336536,
				"type": "OTHER"
			},
			{
				"name": "jolt",
				"salience": 0.00006703564,
				"type": "OTHER"
			},
			{
				"name": "tone",
				"salience": 0.00006703564,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00006683282,
				"type": "ORGANIZATION"
			},
			{
				"name": "nativism",
				"salience": 0.000066536144,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.000065268025,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.000065268025,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.000065268025,
				"type": "OTHER"
			},
			{
				"name": "asylum-seekers",
				"salience": 0.0000650717,
				"type": "PERSON"
			},
			{
				"name": "migration",
				"salience": 0.0000650717,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0000650717,
				"type": "OTHER"
			},
			{
				"name": "cartoonists",
				"salience": 0.0000650717,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.0000650717,
				"type": "EVENT"
			},
			{
				"name": "journalists",
				"salience": 0.0000650717,
				"type": "PERSON"
			},
			{
				"name": "ammunition",
				"salience": 0.00006482195,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00006467101,
				"type": "LOCATION"
			},
			{
				"name": "elections",
				"salience": 0.00006467101,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.00006467101,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.00006467101,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.00006467101,
				"type": "EVENT"
			},
			{
				"name": "victors",
				"salience": 0.00006462582,
				"type": "OTHER"
			},
			{
				"name": "balance",
				"salience": 0.00006404955,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00006385576,
				"type": "PERSON"
			},
			{
				"name": "accords",
				"salience": 0.00006324213,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00006324213,
				"type": "OTHER"
			},
			{
				"name": "roots",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "supermarkets",
				"salience": 0.00006291554,
				"type": "LOCATION"
			},
			{
				"name": "tirades",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "terrorism increases",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "panoply",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "jihad",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.00006291554,
				"type": "WORK_OF_ART"
			},
			{
				"name": "kids",
				"salience": 0.00006291554,
				"type": "PERSON"
			},
			{
				"name": "reactors",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "sex",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "teenagers",
				"salience": 0.00006291554,
				"type": "PERSON"
			},
			{
				"name": "crime",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "visit",
				"salience": 0.00006291554,
				"type": "EVENT"
			},
			{
				"name": "perception",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "flames",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.00006291554,
				"type": "WORK_OF_ART"
			},
			{
				"name": "neck",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00006291554,
				"type": "EVENT"
			},
			{
				"name": "angst",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "locals",
				"salience": 0.00006291554,
				"type": "PERSON"
			},
			{
				"name": "mirrors",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "killer",
				"salience": 0.00006291554,
				"type": "PERSON"
			},
			{
				"name": "blog",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "memes",
				"salience": 0.00006291554,
				"type": "WORK_OF_ART"
			},
			{
				"name": "knowledge",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "midst",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.00006291554,
				"type": "ORGANIZATION"
			},
			{
				"name": "observance",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "grievances",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "lens",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "fasting",
				"salience": 0.00006291554,
				"type": "OTHER"
			},
			{
				"name": "Ramadan",
				"salience": 0.00006291554,
				"type": "EVENT"
			},
			{
				"name": "antisemites",
				"salience": 0.00006270275,
				"type": "PERSON"
			},
			{
				"name": "eyes",
				"salience": 0.00006212242,
				"type": "OTHER"
			},
			{
				"name": "survey",
				"salience": 0.00006212242,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00006179024,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00006179024,
				"type": "PERSON"
			},
			{
				"name": "mayor",
				"salience": 0.000061196464,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.00006107229,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.000060880433,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.000060880433,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.00006061543,
				"type": "EVENT"
			},
			{
				"name": "key",
				"salience": 0.000060566035,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.000060566035,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.000060566035,
				"type": "OTHER"
			},
			{
				"name": "newcomers",
				"salience": 0.000060173577,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.000060119954,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.000060112965,
				"type": "EVENT"
			},
			{
				"name": "identity",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "share",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "jewellery law",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "refugee crisis",
				"salience": 0.000060112965,
				"type": "EVENT"
			},
			{
				"name": "sort",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "progressivism",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "healthcare",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.000060112965,
				"type": "ORGANIZATION"
			},
			{
				"name": "response",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.000060112965,
				"type": "OTHER"
			},
			{
				"name": "reflex",
				"salience": 0.000059313697,
				"type": "OTHER"
			},
			{
				"name": "welfare",
				"salience": 0.000058388778,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.000058388778,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.000058388778,
				"type": "OTHER"
			},
			{
				"name": "Muslim",
				"salience": 0.000057869835,
				"type": "PERSON"
			},
			{
				"name": "platform",
				"salience": 0.000057868117,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.000057693032,
				"type": "PERSON"
			},
			{
				"name": "De-Islamise",
				"salience": 0.000057371646,
				"type": "OTHER"
			},
			{
				"name": "jewellery provision",
				"salience": 0.000057098696,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00005620832,
				"type": "OTHER"
			},
			{
				"name": "mayor",
				"salience": 0.000055996272,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.000055996272,
				"type": "OTHER"
			},
			{
				"name": "currency",
				"salience": 0.000055419416,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.000055251738,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.000055178185,
				"type": "LOCATION"
			},
			{
				"name": "stereotype",
				"salience": 0.000055060307,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ltf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liverpool_F.C."
				},
				"name": "Liverpool",
				"salience": 0.000054777713,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01qrpv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/French_Algeria"
				},
				"name": "French Algeria",
				"salience": 0.000054777713,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Algeria"
				},
				"name": "Algeria",
				"salience": 0.000054777713,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/017bdl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takbir"
				},
				"name": "Allahu Akbar",
				"salience": 0.000054532935,
				"type": "WORK_OF_ART"
			},
			{
				"name": "course",
				"salience": 0.00005427349,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.00005427349,
				"type": "OTHER"
			},
			{
				"name": "warnings",
				"salience": 0.00005427349,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.00005427349,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.00005427349,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00005427349,
				"type": "OTHER"
			},
			{
				"name": "columnists",
				"salience": 0.00005427349,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.00005427349,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Morocco",
				"salience": 0.0000536111,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.000053402222,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.000053402222,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.000053402222,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mx8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scandinavia"
				},
				"name": "Scandinavian",
				"salience": 0.000052882762,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccan",
				"salience": 0.000052736752,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05r4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portugal"
				},
				"name": "Portuguese",
				"salience": 0.0000527321,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.00005272902,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.000052283234,
				"type": "EVENT"
			},
			{
				"name": "editors",
				"salience": 0.000051588067,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.000051407973,
				"type": "OTHER"
			},
			{
				"name": "teachers",
				"salience": 0.000051357543,
				"type": "PERSON"
			},
			{
				"name": "resettlement programmes",
				"salience": 0.000050973355,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.000050556686,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.000050556686,
				"type": "OTHER"
			},
			{
				"name": "Rhetoric",
				"salience": 0.000050556686,
				"type": "OTHER"
			},
			{
				"name": "unwillingness",
				"salience": 0.000050070852,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.000049511305,
				"type": "PERSON"
			},
			{
				"name": "goal",
				"salience": 0.000049439644,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0000490698,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000048702725,
				"type": "OTHER"
			},
			{
				"name": "anti-racism",
				"salience": 0.000048651287,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.000048304617,
				"type": "ORGANIZATION"
			},
			{
				"name": "leftists",
				"salience": 0.000048304617,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hzt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Holocaust"
				},
				"name": "Holocaust",
				"salience": 0.00004803553,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.000047840425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britons",
				"salience": 0.00004742998,
				"type": "PERSON"
			},
			{
				"name": "de-Calais",
				"salience": 0.00004742998,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n0b1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/B%C3%A9ziers"
				},
				"name": "Béziers",
				"salience": 0.00004742998,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0211n9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pan-Malaysian_Islamic_Party"
				},
				"name": "Pas",
				"salience": 0.00004742998,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dj5q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles_de_Gaulle"
				},
				"name": "De Gaulle",
				"salience": 0.00004742998,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02p3bb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C3%89vian-les-Bains"
				},
				"name": "Evian",
				"salience": 0.00004742998,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01r973",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C3%89cole_nationale_d'administration"
				},
				"name": "Ecole Nationale d'Administration",
				"salience": 0.00004742998,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.0000473862,
				"type": "LOCATION"
			},
			{
				"name": "election results",
				"salience": 0.0000473862,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.0000473862,
				"type": "OTHER"
			},
			{
				"name": "asylum seekers",
				"salience": 0.0000473862,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.0000473862,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.0000473862,
				"type": "PERSON"
			},
			{
				"name": "racists",
				"salience": 0.0000473862,
				"type": "PERSON"
			},
			{
				"name": "strategy",
				"salience": 0.0000473862,
				"type": "OTHER"
			},
			{
				"name": "villages",
				"salience": 0.0000473862,
				"type": "LOCATION"
			},
			{
				"name": "cheats",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "tens",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.00004699339,
				"type": "PERSON"
			},
			{
				"name": "balance tips",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "poor",
				"salience": 0.00004699339,
				"type": "PERSON"
			},
			{
				"name": "abuse",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "sake",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "leeches",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.00004699339,
				"type": "EVENT"
			},
			{
				"name": "flat",
				"salience": 0.00004699339,
				"type": "LOCATION"
			},
			{
				"name": "rent",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "boycotts",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "organisation",
				"salience": 0.00004699339,
				"type": "ORGANIZATION"
			},
			{
				"name": "bastion",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "zeal",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "subsidies",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "equivalent",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "misfortunes",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "campaign rallies",
				"salience": 0.00004699339,
				"type": "EVENT"
			},
			{
				"name": "stance",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "wake",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "deterrence",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "family reunification",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "products",
				"salience": 0.00004699339,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sums",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "imams",
				"salience": 0.00004699339,
				"type": "PERSON"
			},
			{
				"name": "pockets",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "suggestion",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "spectrum",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "embassies",
				"salience": 0.00004699339,
				"type": "LOCATION"
			},
			{
				"name": "combination",
				"salience": 0.00004699339,
				"type": "OTHER"
			},
			{
				"name": "intentions",
				"salience": 0.000046834448,
				"type": "OTHER"
			},
			{
				"name": "Bataclan",
				"salience": 0.000045658748,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/058vp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marcel_Proust"
				},
				"name": "Proust",
				"salience": 0.000045658748,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qtwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jardin_du_Luxembourg"
				},
				"name": "Jardin du Luxembourg",
				"salience": 0.000045658748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05g56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Normandy"
				},
				"name": "Normandy",
				"salience": 0.000045658748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06z90w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charlie_Hebdo"
				},
				"name": "Charlie Hebdo",
				"salience": 0.000045658748,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0y64z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Le_Monde"
				},
				"name": "Le Monde",
				"salience": 0.000045658748,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03wtx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nanterre"
				},
				"name": "Nanterre",
				"salience": 0.000045658748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01k9fh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vichy_France"
				},
				"name": "Vichy",
				"salience": 0.000045658748,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cp6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nice"
				},
				"name": "Nice",
				"salience": 0.000045658748,
				"type": "ORGANIZATION"
			},
			{
				"name": "message",
				"salience": 0.0000456166,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.000045041546,
				"type": "OTHER"
			},
			{
				"name": "backing",
				"salience": 0.00004430304,
				"type": "OTHER"
			},
			{
				"name": "motivation",
				"salience": 0.00004410507,
				"type": "OTHER"
			},
			{
				"name": "blind spot",
				"salience": 0.00004410507,
				"type": "OTHER"
			},
			{
				"name": "incentive",
				"salience": 0.00004410507,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/052576c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Herlev"
				},
				"name": "Herlev",
				"salience": 0.000043985376,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.00004377513,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.00004377513,
				"type": "LOCATION"
			},
			{
				"name": "ways",
				"salience": 0.00004377513,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.00004377513,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.00004377513,
				"type": "OTHER"
			},
			{
				"name": "merits",
				"salience": 0.00004377513,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.00004377513,
				"type": "OTHER"
			},
			{
				"name": "terminal",
				"salience": 0.00004377513,
				"type": "LOCATION"
			},
			{
				"name": "discussion",
				"salience": 0.00004377513,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00004377513,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00004377513,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.00004377513,
				"type": "LOCATION"
			},
			{
				"name": "families",
				"salience": 0.000043612188,
				"type": "PERSON"
			},
			{
				"name": "party office",
				"salience": 0.000043612188,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.000043612188,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.000043549066,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.000043079912,
				"type": "LOCATION"
			},
			{
				"name": "satellite town",
				"salience": 0.00004249969,
				"type": "LOCATION"
			},
			{
				"name": "gay community",
				"salience": 0.00004182514,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00004005528,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.000039887553,
				"type": "OTHER"
			},
			{
				"name": "labour classes",
				"salience": 0.000039887553,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.000039887553,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.000039887553,
				"type": "PERSON"
			},
			{
				"name": "businesses",
				"salience": 0.000039848426,
				"type": "ORGANIZATION"
			},
			{
				"name": "Olivier Faye",
				"salience": 0.000039711627,
				"type": "PERSON"
			},
			{
				"name": "apartment",
				"salience": 0.000039522693,
				"type": "LOCATION"
			},
			{
				"name": "tent city",
				"salience": 0.000039522693,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.000039522693,
				"type": "OTHER"
			},
			{
				"name": "revenues",
				"salience": 0.000039522693,
				"type": "OTHER"
			},
			{
				"name": "media institutions",
				"salience": 0.000039522693,
				"type": "ORGANIZATION"
			},
			{
				"name": "hatred",
				"salience": 0.000039522693,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.000039522693,
				"type": "OTHER"
			},
			{
				"name": "dignitary",
				"salience": 0.000039522693,
				"type": "PERSON"
			},
			{
				"name": "instability",
				"salience": 0.000039522693,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.000038933587,
				"type": "ORGANIZATION"
			},
			{
				"name": "mistake",
				"salience": 0.00003885007,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.000038732524,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0000387167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rwdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/De_Volkskrant"
				},
				"name": "Volkskrant",
				"salience": 0.0000387167,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kustaw Bessems",
				"salience": 0.0000387167,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.0000387167,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.0000387167,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d9s5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Utrecht"
				},
				"name": "Utrecht",
				"salience": 0.0000387167,
				"type": "LOCATION"
			},
			{
				"name": "mosques",
				"salience": 0.000037876725,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.000037762125,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.000037762125,
				"type": "LOCATION"
			},
			{
				"name": "constituencies",
				"salience": 0.000037762125,
				"type": "LOCATION"
			},
			{
				"name": "extremists",
				"salience": 0.000037762125,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.000037762125,
				"type": "EVENT"
			},
			{
				"name": "fishermen",
				"salience": 0.000037399237,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01c9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Labour_Party_(UK)"
				},
				"name": "Labour",
				"salience": 0.000036692887,
				"type": "ORGANIZATION"
			},
			{
				"name": "malaise",
				"salience": 0.000036462243,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03d9rk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anne_Frank"
				},
				"name": "Anne Frank",
				"salience": 0.0000362627,
				"type": "PERSON"
			},
			{
				"name": "schools",
				"salience": 0.000036189478,
				"type": "ORGANIZATION"
			},
			{
				"name": "Retake Calais",
				"salience": 0.000035930996,
				"type": "ORGANIZATION"
			},
			{
				"name": "enemies",
				"salience": 0.000035733257,
				"type": "OTHER"
			},
			{
				"name": "youth culture",
				"salience": 0.000035441164,
				"type": "PERSON"
			},
			{
				"name": "places",
				"salience": 0.000035393983,
				"type": "LOCATION"
			},
			{
				"name": "message",
				"salience": 0.000035393983,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.000035393983,
				"type": "EVENT"
			},
			{
				"name": "care",
				"salience": 0.000035393983,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.000034221175,
				"type": "EVENT"
			},
			{
				"name": "physics degree",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "town hall",
				"salience": 0.000034221175,
				"type": "LOCATION"
			},
			{
				"name": "flaws",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "park",
				"salience": 0.000034221175,
				"type": "LOCATION"
			},
			{
				"name": "lessons",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "skills",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "job market",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "allowance",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.000034221175,
				"type": "ORGANIZATION"
			},
			{
				"name": "keys",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "sprawling",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "seagulls",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "buses",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.000034221175,
				"type": "EVENT"
			},
			{
				"name": "burden",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "barbed wire",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "layers",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "fences",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.000034221175,
				"type": "EVENT"
			},
			{
				"name": "tourism",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.000034221175,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.00003269676,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00003269676,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.00003269676,
				"type": "OTHER"
			},
			{
				"name": "elderly",
				"salience": 0.00003269676,
				"type": "PERSON"
			},
			{
				"name": "base",
				"salience": 0.00003269676,
				"type": "OTHER"
			},
			{
				"name": "couples",
				"salience": 0.00003269676,
				"type": "PERSON"
			},
			{
				"name": "MP",
				"salience": 0.00003269676,
				"type": "PERSON"
			},
			{
				"name": "boss",
				"salience": 0.000032527903,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00003226201,
				"type": "PERSON"
			},
			{
				"name": "taboos",
				"salience": 0.000032117845,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.000032030683,
				"type": "LOCATION"
			},
			{
				"name": "step",
				"salience": 0.00003145372,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.00003145372,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.00003139846,
				"type": "LOCATION"
			},
			{
				"name": "family members",
				"salience": 0.00003078383,
				"type": "PERSON"
			},
			{
				"name": "surface",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"name": "gay pride parade",
				"salience": 0.00002952048,
				"type": "EVENT"
			},
			{
				"name": "bread",
				"salience": 0.00002952048,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "rivals",
				"salience": 0.00002952048,
				"type": "ORGANIZATION"
			},
			{
				"name": "voting",
				"salience": 0.00002952048,
				"type": "EVENT"
			},
			{
				"name": "health benefits",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"name": "persecution",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.00002952048,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"name": "parallels",
				"salience": 0.00002952048,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.000029160188,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00002891846,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00002891846,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Sweden",
				"salience": 0.00002891846,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07tgn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Oxford"
				},
				"name": "Oxford",
				"salience": 0.00002891846,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stockholm"
				},
				"name": "Stockholm",
				"salience": 0.00002891846,
				"type": "LOCATION"
			},
			{
				"name": "Kenneth Kristensen Berth",
				"salience": 0.00002891846,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.00002891846,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05d8k75"
				},
				"name": "Samuel",
				"salience": 0.0000278586,
				"type": "PERSON"
			},
			{
				"name": "Yohann Faviere",
				"salience": 0.0000278586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0268_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Danes"
				},
				"name": "Dane",
				"salience": 0.000026938005,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.000026552203,
				"type": "ORGANIZATION"
			},
			{
				"name": "atmosphere",
				"salience": 0.000025886962,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "lesbians",
				"salience": 0.00002556062,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "foreigners",
				"salience": 0.00002556062,
				"type": "PERSON"
			},
			{
				"name": "hurdle",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "manhood",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "environment",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "tinge",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "satisfaction",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "seats",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "neighbourhoods",
				"salience": 0.00002556062,
				"type": "LOCATION"
			},
			{
				"name": "laugh",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "displays",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "capacity",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"name": "sentiment",
				"salience": 0.00002556062,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Dutch",
				"salience": 0.00002454567,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wtdx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Le_Touquet"
				},
				"name": "Le Touquet",
				"salience": 0.000021058706,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01b0x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Blaise_Pascal"
				},
				"name": "Pascal",
				"salience": 0.000021058706,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012650wy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Natacha_Bouchart"
				},
				"name": "Natacha Bouchart",
				"salience": 0.000021058706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.000020120617,
				"type": "PERSON"
			},
			{
				"name": "meetings",
				"salience": 0.00001909181,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitler",
				"salience": 0.0000167593,
				"type": "PERSON"
			},
			{
				"name": "thing nobody",
				"salience": 0.000016395696,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lfy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Copenhagen"
				},
				"name": "Copenhagen",
				"salience": 0.000015729214,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.000015147995,
				"type": "OTHER"
			},
			{
				"name": "energies",
				"salience": 0.000013727547,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:36.946+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 124,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "The Ruthlessly Effective Rebranding of Europe’s New Far Right Sasha Polakow-Suransky, Guardian, November 1, 2016 \nIn April 2002, Jean-Marie Le Pen stunned all of Europe by defeating the socialist candidate, Lionel Jospin, in the first round of the French presidential election, and advancing to the final round between the top two candidates. Terrified by the prospect of a far-right victory, the French left–including communists, Greens and the Socialist party–threw their support behind the incumbent president, Jacques Chirac , a pillar of the centre-right establishment who had served as mayor of Paris for 18 years before becoming president in 1995. This electoral strategy effectively isolated Le Pen’s Front National (FN), depicting it as a cancerous force in the French body politic. \nTwo weeks later, on 5 May, Chirac won the election with an astronomical 82% of the vote, trouncing Le Pen by the biggest margin in a French presidential election since 1848. Raucous celebrations spilled into the streets of Paris. “We have gone through a time of serious anxiety for the country–but tonight France has reaffirmed its attachment to the values of the republic,” Chirac declared in his victory speech . Then, speaking to the joyous crowds in the Place de la République, he lauded them for rejecting “intolerance and demagoguery”. \nBut May 2002 was not, in fact, a moment of triumph. Rather it was the dying gasp of an old order, in which the fate of European nations was controlled by large establishment parties. \nJean-Marie Le Pen was an easy target for the left, and for establishment figures such as Chirac. He was a political provocateur who appealed as much to antisemites and homophobes as to voters upset about immigration, drawing his support largely from the most reactionary elements of the old Catholic right. In other words, he was a familiar villain–and his ideology represented an archaic France, a defeated past. Moreover, he did not seriously aim for power, and never really came close to acquiring it; his role was to be a rabble-rouser and to inject his ideas into the national debate. \nEurope’s new far right is different. From Denmark to the Netherlands to Germany, a new wave of rightwing parties has emerged over the past decade-and-a-half, and they are casting a much wider net than Jean-Marie Le Pen ever attempted to. And by deftly appealing to fear, nostalgia and resentment of elites, they are rapidly broadening their base. \nLe Pen’s own daughter is a prime example of the new ambitions of the right: unlike her incendiary father, Marine Le Pen is running a disciplined political operation and has already proven that her party can win upwards of 40% of the vote in regions from Calais in the north to the Côte d’Azur in the south. She and her Danish and Dutch counterparts are not–as some on the left would like to believe–neo-Nazis or inconsequential extremists with fringe ideas lacking popular appeal. \nThese parties have built a coherent ideology and steadily chipped away at the establishment parties’ hold on power by pursuing a new and devastatingly effective electoral strategy. They have made a very public break with the symbols of the old right’s past, distancing themselves from skinheads, neo-Nazis and homophobes. They have also deftly co-opted the causes, policies and rhetoric of their opponents. They have sought to outflank the left when it comes to defending a strong welfare state and protecting social benefits that they claim are threatened by an influx of freeloading migrants. \nThey have effectively claimed the progressive causes of the left–from gay rights to women’s equality and protecting Jews from antisemitism–as their own, by depicting Muslim immigrants as the primary threat to all three groups. As fear of Islam has spread, with their encouragement, they have presented themselves as the only true defenders of western identity and western liberties–the last bulwark protecting a besieged Judeo-Christian civilisation from the barbarians at the gates. \nThese parties have steadily filled an electoral vacuum left open by social democratic and centre-right parties, who ignored voters’ growing anger over immigration–some of it legitimate, some of it bigoted–or simply waited too long to address it. \nThey have shed some of the right’s most unsavoury baggage while responding to both economic anxiety and fear of terrorism by blending a nativist economic policy–more welfare, but only for us –and tough anti-immigration and border security measures. Their message is beginning to resonate widely with a fearful population that believes the liberal governing elite no longer listens to them. \nBrexit was just the start. Europe’s new far right is poised to transform the continent’s political landscape–either by winning elections or simply by pulling a besieged political centre so far in its direction that its ideas become the new normal. And when that happens, groups that would never have contemplated voting for a far-right party 10 years ago–the young, gay people, Jews, feminists–may join the working-class voters who have already abandoned parties of the left to become the new backbone of the populist right. \nOn 6 May 2002, one day after revellers filled the streets of Paris to celebrate Chirac’s historic victory, the flamboyant and iconoclastic leader of the Dutch far right, Pim Fortuyn, was gunned down by a radical animal rights activist as he emerged from a radio interview. His assassin later claimed that he had killed Fortuyn to stop him from using Muslims as “scapegoats”. In national elections nine days later, Fortuyn’s eponymous party–the Pim Fortuyn List– became the second largest in the Netherlands with 17% of the vote. \nFortuyn, a former communist and openly gay man who boasted of sleeping with Muslim immigrants while calling for a ban on Muslim immigration, was an electrifying figure in a country known for its staid politics. His time in the limelight was short but transformative. \nIt was Fortuyn who blazed the trail for the new generation of far-right leaders across Europe. He may not have intended to be a pioneer, but his brand of plain-spoken political incorrectness and his depiction of Islamic culture as a “backwards” and reactionary threat to the hard-won progressive values of western Europe would provide a potent template for a modernised far right. His ideological inheritors in Dutch politics, as well as the revamped Front National in France, the Danish People’s Party and Germany’s Alternative für Deutschland have all emulated Fortuyn in their own ways. \nFortuyn proved that the winning argument for the European far right was not a US-style appeal to conservative religious values, but rather to claim it was “defending secular, progressive culture from the threat of immigration,” argues Merijn Oudenampsen of Tilburg University. The Netherlands was a perfect laboratory for this new strategy because, unlike France, it did not have a strong contingent of religious traditionalists opposed to women’s liberation and gay rights. \nBefore founding his own party in 2002, Fortuyn had tried to join an establishment centre-right party, the People’s Party for Freedom and Democracy (VVD), in the late 1990s. The party’s then-leader, Frits Bolkestein, who had been one of the first figures to speak critically about immigration in the early 1990s, remembers Fortuyn as a talented but inflammatory politician. “He had a thoroughly theatrical personality, and that played in his favour,” said Bolkestein, now in his 80s, from his office overlooking the canals of Amsterdam. “I didn’t want him to be in my parliamentary group, so I cold-shouldered him . . . He would have acted as a fragmentation bomb.” \nFortuyn took his explosive rhetoric elsewhere and, by creating a new type of far-right politics in progressive garb–“a form of xenophobia ideally suited to a nation that prides itself on its tolerance,” as a New Yorker profile once described it–he redirected the entire national debate in a way that has endured long after his death. \nTwo years after Fortuyn was killed, the Netherlands was traumatised by another political assassination. Early one morning in November 2004, the filmmaker Theo van Gogh was murdered by a young Dutch-Moroccan, Mohammed Bouyeri, who shot van Gogh eight times, slashed his throat and then pinned a letter to his chest with a knife. The letter was a death threat aimed at the Somali-born Dutch parliamentarian Ayaan Hirsi Ali –a vocal critic of Islam who was soon placed under the protection of the Dutch security services. \nThe two assassinations shook the Netherlands to its core and catapulted a little-known and theatrically coiffed politician, Geert Wilders , to popularity as an ideological successor to Fortuyn. Wilders had also flirted with Bolkestein’s VVD, beginning his political career as a staffer in the party office. In late 2004, he split off and formed his own. With Hirsi Ali in hiding, he quickly became the most prominent anti-immigration voice in the country–and has remained so ever since. \nFor those who cared to look, the political ground had already begun to shift. Six months before Chirac’s trouncing of Le Pen and Fortuyn’s assassination, Denmark had an election. On its surface the result was not a historical watershed; the centre-right Venstre party ousted the Social Democrats, handing power from one establishment party to the other. What had changed was that the Danish People’s Party, which had campaigned on an overtly anti-immigrant platform, took 12% of the vote–transforming it into a kingmaker in parliament. \nUnlike France, which revelled in its triumph over the FN, or the Netherlands, where the remains of Fortuyn’s party failed to become a real parliamentary force, the DPP immediately became a serious player with real influence over policy. And it was not only taking votes from the right; it was also attracting disgruntled social democratic voters who felt that their leaders had abandoned them. \nThe DPP had crafted a social and economic policy that was in many ways more socialist than that of the Social Democrats–promising better health care, better care for the elderly, and more subsidised housing. As the outgoing Social Democratic prime minister Poul Nyrup Rasmussen told me in 2002, a few months after his defeat: “They took a part of our rhetoric and tried to sell it as a new package to the people, and with some success, one may say.” Back then, Naser Khader, a Danish member of parliament who immigrated from Syria as a child, argued that “the best way to weaken the DPP is to give them influence”. He was wrong. \nThe headquarters of the Front National sits on a quiet street in the unassuming Paris suburb of Nanterre, near a car repair shop and a Portuguese restaurant. Only when you approach the grey building with its mostly closed blue shutters do the armed guards come into view. In her modest second-floor office, surrounded by books and a cloud of vape smoke, Marine Le Pen explained earlier this year how she transformed a party previously known for calling the Holocaust a “ detail of history ” into a genuine contender for the presidency. \n“Voluntarily or not, he gave ammunition to our adversaries,” Le Pen said of her father. But she insisted that she has now cleaned house. “I fired them all . . . all those people who expressed an ideology or held views that I found unacceptable.” \nJulien Rochedy, a 28-year-old who headed the FN’s youth wing but has since left the party, told me that he believes the changes are real. Whereas the party’s former leader used to pepper his speeches with lines that made Jews’ hair stand on end, today, if someone tells a racist joke within the party, “you will be attacked straight away,” Rochedy said. “There is such self-discipline these days. They are so afraid they’ll be accused once again of being antisemitic or racist.” \nStill, the party’s detractors continue to level the same charges at the FN, which outrages Marine Le Pen . “Today our adversaries no longer have that ammunition, and they repeat on loop” old tropes about fascists and racists. “At a certain point this argument loses its force,” she continued, “because voters see clearly that there’s absolutely nothing in our platform that remotely resembles fascism or racism.” \nLe Pen has done more than kick out the most blatant racists and antisemites. She has consciously crafted a campaign designed to appeal to voters of the centre and left–and other constituencies–who could never have imagined voting for her father’s Front National. \nAs Le Monde’s Olivier Faye has written , she is “trying to erase another image that has stuck to the skin of the FN–that of homophobia”. And it is working: a survey showed that her share of the vote among married gay couples in the 2015 regional elections was over 32%–up from just 19% in a similar poll from 2012. \nAs Le Pen has filled her inner circle with more and more openly gay advisers and party leaders, she has also made her pitch to Jewish voters more explicit: “For a lot of French Jews, the FN appears to be the only movement that can defend them from this new antisemitism nourished in the banlieues ,” Le Pen told me. “In a very natural way they have turned toward the FN, because the FN is capable, I think, of protecting them from that.” \nAmong French voters threatened by the country’s new diversity, rejection of a multicultural society increasingly takes the form of longing for a bygone era. And peddling nostalgia is the centrepiece of many new far-right parties across Europe . In France, Marine Le Pen has promised a return to a time when the French had their own currency and monetary policy, when there were fewer mosques and less halal meat, when no one complained about nativity scenes in public buildings, and when French schools promoted a republican ethos of assimilation. \n“A growing number of French people feel uncomfortable in their own country,” the prominent philosopher, Alain Finkielkraut , declared in January during a debate with the centre-right presidential candidate Alain Juppé–who has taken a less strident line on Islam and migration than his rival Nicolas Sarkozy. Finkielkraut depicted contemporary France as a country of halal butchers and tea shops filled only with men, pleading that “the public good isn’t in the clouds, it’s made from tangible things–the French of Proust and Montaigne . . . the Jardin du Luxembourg and the cows of Normandy”. \nFinkielkraut, a 67-year-old Jewish liberal, is not an admirer of the Front National, but Marine Le Pen’s deliberate appeals to Jews and gay people have given political expression to an argument that he first made more than a decade ago–that the left, with its indulgence of Islam, poses a greater threat to France than the far right. After Chirac “saved” the republic from Jean-Marie Le Pen in 2002, Finkielkraut watched the celebrations in the streets and warned that the victors were the real danger: “The future of hate is in their camp and not in the camp of those nostalgic for Vichy,” he wrote, “ . . . in the camp of the multicultural society and not that of the ethnic nation–in the camp of respect, not that of rejection.” \nFourteen years later, after the terrorist attacks on Charlie Hebdo, the Bataclan and Nice, Finkielkraut is even more certain he was correct. “Anti-racism today frequently serves as a pretext for not seeing the true danger that threatens us,” he told me when we met in his Paris apartment this summer. While he is still no fan of the FN, he believes it has changed and argues that it “should be resisted, but for what it is today and not what it was in the past, and not in the name of anti-fascism”. The French must, he insisted, “avoid simplistic analogies with the 1930s. We must not mistake what era we live in. Europe doesn’t only have demons; it also has enemies, and it needs to know how to fight those enemies.” \nHe worries that integration has been such a failure that France will have to “reconquer” its “lost territories”–by which he means the suburbs surrounding Paris. “Integrating people is not telling them ‘You are how you are and we are how we are’ . . . Integration means making them an integral part of our civilisation.” And if that doesn’t happen, he warned darkly, “at best we’ll have secession and at worst civil war”. Continued immigration from Muslim countries, he argues, is nothing less than the “planned demise of Europe”. \nAcross the country, nostalgia for an older, whiter France has become a potent political force. In the southern city of Béziers, Mayor Robert Ménard, a former Trotskyist who cofounded the press freedom group Reporters Without Borders , is seeking to place a moratorium on the opening of kebab shops and has renamed a street after one of the French officers who joined a failed coup against De Gaulle in 1961 to prevent Algerian independence . Ménard comes from a family of pieds-noirs , French settlers in Algeria. He regards the Evian accords that ended the Algerian war as a “capitulation”, and those who tried to preserve French Algeria as heroes. \nThis nostalgia has an unmistakable appeal, but not necessarily for the sort of voters one might expect. Whereas young Britons overwhelmingly voted to remain in the EU and the elderly voted to leave, in France it is the opposite. According to Julian Rochedy, the former FN youth leader, appeals to nostalgia work better with the young in France–who dream of an era they never witnessed–than with the old, who lived through the era Marine Le Pen promises to restore. It is older voters, Rochedy argues, who are the greatest obstacle to Le Pen’s victory. “They are afraid of leaving the euro,” he says. “They are afraid of huge changes.” Rochedy is convinced that the FN will never win simply by fetishising the past. “They just want to go back 30 years,” he said of his erstwhile colleagues. “It’s a discourse that doesn’t at all take into account the world as it is and what France has become.” \nEven if Le Pen cannot win over enough older voters for her to become president, there is one ageing constituency that has already moved significantly to the right–the former members of what used to be the largest communist party in western Europe. \nAs the French Communist party collapsed, its supporters were left rudderless. According to Andrew Hussey, a Liverpool-born academic who teaches in Paris, the technocratic leaders of the Socialist party– many of them graduates of the ultra-elite Ecole Nationale d’Administration–“are so disconnected from ordinary people” that even former Marxists won’t consider voting for them. Distrustful of the establishment and searching for a state that protects them, many have turned to the FN. “I think you’ve got a big political question here about who looks after you,” Hussey said. “This is a very communist way of thinking.” \nLe Pen knows that she is attracting these people. Many of her supporters “used to be socialists, but they aren’t any more”, she told me. Although she prefers to avoid the phrase welfare state–“That’s a socialist concept,” she insisted–Le Pen has appealed directly to this yearning for a large and nurturing state that fights for the common man and not the rich. \n“I defend fraternity–the idea that a developed country should be able to be able to provide the poorest with the minimum needed to live with dignity as a human being. The French state no longer does that,” she told me. “We’re in a world today in which you either defend the interests of the people or the interests of the banks.” And she has seen results. She points to the northern Pas-de-Calais region. “It was socialist-communist for 80 years,” she says. “I won 45%.” \nAt the same time as Marine Le Pen was working to “de-demonise” the FN, the leaders of the Dutch far right successfully seized the mantle of radicalism by positioning itself as the only force that dares to challenge an out-of-touch political establishment, and the only party willing to speak out about what many voters fear: extremist Islam. \nGeert Wilders and his Party for Freedom (PVV) have surpassed the Dutch Labour party to take up a close second place in polls ahead of the March 2017 election. Last September, Wilders declared that Europe was facing an “ Islamic invasion ”–the sort of comments that landed him in court this week on charges of inciting racial hatred , which he dismisses as an attack on freedom of expression. \nThe presence of “masses of young men in their 20s with beards singing ‘Allahu Akbar’ across Europe”, Wilders warned at the peak of last year’s refugee crisis, posed a dire threat to “our prosperity, our security, our culture and identity”. Across the country, grassroots groups responded to Wilders’s warning, attempting to block the resettlement of asylum seekers in their towns. Last October, Klaas Dijkhoff, the deputy minister responsible for refugee resettlement, arrived for a visit to the tiny north-eastern village of Oranje, where the Dutch government had decided to place 700 refugees. Outraged locals blocked the road leading to town, kicked Dijkhoff’s car and tore off its rearview mirrors. A few days later, near Utrecht, an asylum centre was attacked by masked men with smoke bombs and fireworks. \nIn the decade following the assassinations of Fortuyn and Van Gogh, the integration of Muslim immigrants became the most divisive issue in Dutch politics. Suddenly, Turkish and Moroccan-born Dutch citizens became “Muslims”. And as the public debate over Islam and migration grew even more hostile, even the most basic forms of visible religious observance–wearing the hijab, buying halal meat, fasting during Ramadan–became politically loaded. \nThe Dutch Labour MP Ahmed Marcouch, who came to the Netherlands from rural Morocco when he was 10, recounted how controversies have erupted everywhere from supermarkets to classrooms. It is a jolt to the traditionally liberal Netherlands when teenage girls tell their male teachers they can’t shake hands, or that they fast and pray while many other Dutch kids are out drinking and having sex. As Marcouch remarked, it runs against everything that Dutch youth culture promotes. \nWilders’s PVV has capitalised on this cultural angst by using simple and deliberately brash slogans about immigration, crime, and refugees–one of his latest memes is simply “De-Islamise”–to win over voters who feel that everything familiar to them is slipping away. \nBy framing its anti-migrant politics as a battle against imperious elites and political correctness, the PVV has been able to capitalise on a panoply of grievances, from anger over asylum seekers to Euroscepticism. Meanwhile, many causes of the radical left–including anti-racism and anti-colonialism–have now become establishment thinking in the Netherlands. “Idealism has been bureaucratised,” argues the journalist Bas Heijne, who writes a column in the liberal daily newspaper NRC Handelsblad. “And when the establishment enforces universalism, you react against it.” That’s why there is such a strong anti-PC tone to the Dutch right: do not tell us what to say, what to celebrate and who we must live next to. \nJust as Marine Le Pen’s FN has become a huge presence on social media in France, the right is in the midst of colonising the Dutch media. Geen Stijl (“No Style”), a popular Breitbart-style news site featuring abrasive articles and videos, encourages its best and angriest commenters to visit mainstream news sites and go on the attack. “It is massively important,” says Tilburg University’s Merijn Oudenampsen, “like a social movement”. The site began as a blog dedicated to those who felt politically homeless after Fortuyn’s murder, and has since become a ubiquitous presence in Dutch public debate, with an army of “reactors” on Twitter. According to Oudenampsen, some politicians have told him that Geen Stijl is the first site they check in the morning. \nThe right’s newfound media clout has also helped shape what the journalist Kustaw Bessems, from the leftwing Volkskrant newspaper, sees as a new, inverted, form of political correctness. In the old days, he says, there were taboos enforced by the left: badmouth immigrants and “you were immediately called a racist and extreme right and basically pressured to shut up”. Now, it’s the other way around. “As soon as you say anything other than ‘immigration is a problem’ or ‘Islam is the cause of terrorism’ . . . the thought police immediately jump on your neck to correct you.” \nA Dutch government official who focuses on security issues complained that even as the integration of Muslim immigrants and the threat of radical Islam had become the most heated and polarising issues in the Netherlands, almost none of the feverish public debate was informed by knowledge of Islamism or terrorism. While politicians fan the flames of fear, the official said, “the economists look for the economic roots of the problem, sociologists look for social causes and the anthropologists try to explain jihadi culture–but none of them have any idea about theology”. Even scholars of radicalisation tend to study today’s extremists through the historical lens of the European radical left–which does little to explain what leads a small number of young Muslim men such as Van Gogh’s killer, Mohamed Bouyeri, to devote themselves to the cause of jihad. “It’s easy to be a Marxist,” the security official quipped. “It’s fucking hard to be a salafi.” \nAs the perception that the state is helpless to prevent the radicalisation of Muslim teenagers deepens and the fear of terrorism increases, so does the share of voters who are newly receptive to the far right’s tirades about “Islamisation”. These days it is not only anti-migration activists pushing back against the bureaucratised consensus. There are also many disappointed progressives–the people who saw the cultural victories of the 1960s and 1970s as major battles that had long since been won, making sexual freedom, feminism and gay rights an unquestioned part of Dutch society. Suddenly those old victories seem tenuous. “There is a sense that, ‘We are welcoming and then they do this,’ says Bas Heijne. “They have been terribly let down in their good intentions.” And in such an environment, traditionally leftist constituencies such as gay people and Jews feel threatened–and some have become reflexively suspicious of Muslims. \nThe stereotype that observant Muslims hate gay men and lesbians has become so entrenched in the Netherlands that neither side can fathom evidence to the contrary. When the Moroccan-born Labour MP Ahmed Marcouch first joined in Amsterdam’s legendary gay pride parade , he was, as he puts it, the “first hetero-active Muslim” to participate. The gay community feared violence from extremists; conservative Muslims were baffled and angry. Both groups concluded, “Oh, maybe Marcouch is homosexual too,” he says with a laugh. Neither group could imagine a straight Muslim doing what he did. \nBut public displays of solidarity such as Marcouch’s are rare. Among openly gay couples and religious Jews alike, there is a palpable fear of being targeted by homophobic or antisemitic young Muslim men. Much as in France, this fraught atmosphere has made far-right parties seem a palatable option for groups who would never previously have considered voting for them. \nIn Amsterdam earlier this year, I had several meetings with a staunch Jewish supporter of Wilders’s PVV, who insisted on remaining anonymous. He described his own backing for the far right in terms that echoed Alain Finkielkraut. “It’s an outdated reflex for Jews to always say the problem is the extreme right,” he told me. “We have new enemies and we need new ideas.” \nThe experience of his own family during the second world war has convinced him that Europe’s capacity for murderous violence is always lurking beneath the surface. “Anne Frank wasn’t betrayed by the Germans,” he argued. “But by Dutch people. Regular Dutch.” Jews need to find new allies in a new war, he argues, because they will never be safe. “The trains for the Jews will always come,” he added, ominously. “I’d rather be wrong than be too calm and end up on the trains.” \nHe is not unsympathetic to the plight of European Muslims, and told me that he even sees parallels with the persecution his own family faced. “If I were a Muslim in Europe at this moment I’d be very uneasy,” he admitted. “If Europeans regain their manhood, it could be bad. It’s the history of Europe to treat foreigners terribly. We Jews know that.” \nFor that reason, he argues, Muslims should regard Wilders as a lesser evil. “Every Muslim should be happy Geert Wilders exists. If someone else channelled these hateful feelings it would be much worse,” he told me menacingly. “Wilders is civil. He is a democrat. He is not the new Hitler.” \nTo Frits Bolkestein, who led the Netherlands’ centre-right VVD in the 1990s–and was briefly Wilders’ boss when he was a young aide in the party office–the rise of the far right is as much about class as it is about Islam. The Dutch Labour party, he argues, gave up on its working-class base: “They made a major mistake,” he says of his old rivals, with a tinge of satisfaction. Faced with “the choice between the foreign-born and the labour classes, they chose the foreign-born … and they’ve paid for it dearly”. Current polls project that the party will drop from the 36 seats it now holds (out of 150) to just 10. \nMarcouch concedes that, like the old leftists in France, many former Labour voters now back Wilders. Moreover, he says, they still live in the very neighbourhoods that families such as his own moved into in the 1980s, as many white Dutch families were moving out. “Their message to the Labour party,” he said, “is: ‘You ignored us. You let it happen.’” \nThe Danish People’s Party has been seeking out such voters for years, and they have masterfully leveraged anti-immigrant sentiment to siphon away the Social Democrats’ traditional base–people who fear that the “bread will be buttered more thinly”, as the Danish journalist Lars Trier Mogensen puts it. \nThe DPP has effectively combined anti-immigrant rhetoric with a strong pro-welfare message that stresses quality health benefits and good care for the elderly. Søren Espersen, the DPP’s deputy leader, doesn’t think that former Social Democrats will ever go back. “When one of those takes the step to vote for us, it is a very, very huge step he is taking,” he says of voters who supported the Social Democrats all their lives. “And why should he go back? I mean, to come over this first hurdle of voting for us, then he’s done it.” \nThe Social Democrats first began to lose their dominance in and around the major cities in the 1990s, with many of their votes going to the DPP. One of those places is the small satellite town of Herlev, about 10 miles west of Copenhagen. The 41-year-old Social Democratic mayor, Thomas Gyldal Petersen, has lived there all his life, and he is adamant that controlling immigration numbers is the only way to reverse his party’s political misfortunes. \nFor Gyldal Petersen, the key to successful integration is a demographic balance. As soon as a school or housing estate becomes majority immigrant–or majority unemployed–he says, problems start to arise. He blames his own party’s leaders: “Mayors in the 80s, they were warning, something is going wrong, you have to change.” But the party leadership “shut their eyes”, he says. \nThen came the Muhammad cartoons . In 2005, the editors at Jyllands-Posten, Denmark’s largest newspaper, invited a group of well-known cartoonists to draw the prophet. The initial response was underwhelming, but within a few months–through a combination of diplomatic pressure, a dismissive response from the Danish government, and a concerted campaign by local imams–the cartoons became a full-blown crisis, with boycotts of Danish products and violent protests occurring throughout the Middle East. Danes who had never contemplated voting for the DPP now saw their embassies on fire and death threats against some of their best-known journalists. Suddenly, the DPP’s platform was making sense. They had warned that Muslims were extremists in waiting, and now those warnings seemed to come true. Politicians such as Naser Khader, who once warned that giving the DPP influence would weaken them, found themselves moving steadily to the right of the political spectrum. When Khader founded a new organisation called “Democratic Muslims” in the wake of the cartoon controversy, he received death threats. \nThose at the top of the Social Democrats are now taking a tough stance, too. Earlier this year the party leader, Mette Frederiksen, went to Stockholm to meet with fellow Scandinavian social democrats. There she gave a speech that rattled her colleagues. “We social democrats must accept that there is a clash,” she declared. “It is a very strong part of our identity that we help when people need help . . . but just as strong is our value that we must have a well-functioning welfare state.” Frederiksen continued: “My position is that a universally funded Scandinavian welfare state with free and equal access to healthcare, education and social subsidies is not compatible with an open immigration policy.” \nBut in its zeal to get tough on migration, Denmark has damaged its international reputation as a bastion of progressivism–the sort of place that Bernie Sanders liked to mention at campaign rallies. In January, just three months after the refugee crisis peaked, Denmark passed what became known as the “ jewellery law ”, which stipulated that any refugees carrying valuables worth more than 10,000 kroner (£1,200) would have them confiscated to fund the cost of accommodating asylum-seekers. Editorial pages and columnists across the world lined up to condemn the law. According to Kenneth Kristensen Berth, a babyfaced MP for the DPP, it was about deterrence. “The goal was, of course, that we should try to tell people that they should not seek asylum in Denmark,” he said. The jewellery provision was a minor part. “More important is the fact that many people will be waiting longer for family reunification, like waiting three years,” he added. And it wasn’t just the DPP and government who supported it–the Social Democrats voted for it, too. \nBent Melchior, Denmark’s 87-year-old former chief rabbi, was outraged. He bristled at the suggestion that refugees are rich because they flee with some money in their pockets. He would know: although Denmark is always hailed for saving its Jews during the second world war, it is often forgotten that Danish Jews paid fishermen huge sums to ferry them across to Sweden. Melchior’s family paid the equivalent of “almost a year’s rent of a six-room flat” just for his own passage. “Denmark is not a poor country, for God’s sake,” Melchior says. “There’s food for everybody here, and even if we get a few tens of thousands more people, there will still be food for everybody.” \nThe road that led a centre-left party to support such a law has been long and tortuous, but the trajectory has been clear. The Scandinavian welfare system has always been premised on solidarity, with everyone paying their fair share and receiving what they deserve. As the country has become more diverse, some of the trust sustaining it has broken down. There has been abuse of the system by immigrants, and there has been even more tabloid fearmongering depicting immigrants as cheats and leeches sucking the system dry. But the larger issue, as the Oxford economist Paul Collier has argued, is the growing unwillingness of natives to subsidise those seen as the foreign poor. \nHerlev’s mayor does not oppose asylum, but he insists that the numbers have to be capped. “We have to help refugees, and we have to take refugees to Denmark in a number that we can help. If the balance tips, the welfare society cannot hold together,” Petersen warns. \nBut such balance may only help so much. Aydin Soei, a Danish sociologist and the son of immigrants from Iran, believes there is a larger blind spot in the thinking of the Danish government–one that native Danes who have never been on the receiving end of the state’s integration policy have failed to see. “A lot of refugees were just parked on social welfare instead of [the state] recognising their education and their skills,” Soei told me, citing the case of his own mother, who arrived in Denmark with a physics degree that was regarded as worthless. “If your motivation is to create a liberal society where the individual can create a good life for him or herself, then you would have solved this problem years ago,” he argues. \nInstead the state has effectively provided newcomers with an allowance and keys to an apartment, and ignored them–assuming that its work was done. The problem, Soei claims, is that there is no political incentive to integrate asylum seekers into the job market. “It doesn’t have consequences for the politicians . . . because they don’t have the right to vote.” Either way, it plays into the DPP’s argument. “Immigrants can’t do right,” said Gyldal Petersen. “When they’re unemployed they’re a burden to society. When they’re in a job, they just stole the job from a Dane.” \nWhether or not Marine Le Pen wins next year’s French election or Wilders’ PVV becomes the largest party in the Netherlands, the new far right is not going away. The reflex among many establishment parties–and media institutions–has been to dismiss them, sideline them or mock them. Others, however, have begun to mimic them in an effort to win their old voters back. \nRhetoric might, in the long run, matter more than election results. When I spoke again recently with the Jewish Wilders supporter from Amsterdam, he was convinced that the battle has in some ways already been won–regardless of the outcome of next year’s elections. “The PVV has shifted the whole political discussion to the right. The Labour party is saying almost exactly the same thing Wilders said five years ago,” he told me. “You can have a lot of influence in politics by steering the debate.” \nIf traditional political parties want to win, they must first abandon the old strategy of marginalising populist movements and instead engage them on the merits–and flaws–of their policies and counter their messages of fear. \nNot least among the lessons of Brexit was that, for millions of disaffected voters, immigration is just one more thing nobody asked them about . This is what makes the issue an especially potent weapon: it combines the resentful energies of nativism, economic instability, and hatred of a remote and unaccountable political elite. And the leaders of the new far right have learned to wield it effectively. They know better than to let themselves be dismissed, as Jean-Marie Le Pen was, as antisemites or racists. \nIn France, the new majority Marine Le Pen hopes to build is strikingly similar to the coalition that brought the Brexit campaign victory. In a park near Calais’ castle-like town hall in May, Samuel and Pascal, activists from a group named Retake Calais, railed against the town’s centre-right mayor. They blamed her for the growth of the sprawling, trash-strewn tent city known as the Jungle, which sat three miles east of the town until it was dismantled this month . “Those who govern us are completely against us. The illegals, who aren’t French, can do whatever they want,” they told me. For them, even Marine Le Pen is “too soft”. \nIf resettlement programmes take refugees away from Calais to other parts of France, as dozens of buses have in the past week since the destruction of the camp, they would not be any happier. “They’re sending them to all the little villages in France,” says Samuel. After they start to open businesses and bring family members, “in two years the village will be dead”. \nAbout a mile down the road, the Calais ferry terminal lies behind layers of tall steel fences and coiled barbed wire. I met Rudy Vercucque and Yohann Faviere, the local FN leaders, on a blustery morning in June outside the terminal, where they were anxiously awaiting a visiting EU dignitary. Giant seagulls circled and squawked above as they denounced the mayor, Natacha Bouchart, a member of Sarkozy’s Republicans party. \n“It’s she who has permitted this,” Vercucque, a portly 35-year-old, fumed. And it was Sarkozy, he reminded me, who negotiated the notorious Le Touquet accords , effectively moving the British border to where we were standing. Calais depends on British tourism and revenues are down sharply. The result is crippling economic and social malaise: “Find a doctor who wants to move to Calais. Find a surgeon who wants to move to Calais,” Vercucque exclaimed. “You work your whole life, you pay off your house and you lose money. It’s intolerable.” Their support locally may have once been a protest vote, said Faviere, but no longer. “Today we really have people who adhere to our ideas.” \nVercucque was more blunt: “We say out loud what people think deep down.”",
		"thread_title": "The Ruthlessly Effective Rebranding of Europe’s New Far Right",
		"title": "The Ruthlessly Effective Rebranding of Europe’s New Far Right",
		"type": "bs",
		"uuid": "f1fa11e5965c9783715454143a0933a54293463e"
	},
	"-KhIgreVsFPPXpHCCz9M": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:37.972+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.106833756,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.05991039,
				"type": "PERSON"
			},
			{
				"name": "Ted Cantle",
				"salience": 0.057668276,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.036616627,
				"type": "LOCATION"
			},
			{
				"name": "academic",
				"salience": 0.03615234,
				"type": "PERSON"
			},
			{
				"name": "academic",
				"salience": 0.020375479,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.020307995,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.01784131,
				"type": "PERSON"
			},
			{
				"name": "Politicians",
				"salience": 0.015935535,
				"type": "PERSON"
			},
			{
				"name": "Eric Kaufmann",
				"salience": 0.015887666,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.014940891,
				"type": "OTHER"
			},
			{
				"name": "polarisation",
				"salience": 0.013807268,
				"type": "OTHER"
			},
			{
				"name": "Action",
				"salience": 0.013807268,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.013363546,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.012471257,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.012471257,
				"type": "OTHER"
			},
			{
				"name": "pockets",
				"salience": 0.012471257,
				"type": "OTHER"
			},
			{
				"name": "Segregation",
				"salience": 0.012471257,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c9cw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slough"
				},
				"name": "Slough",
				"salience": 0.011759627,
				"type": "LOCATION"
			},
			{
				"name": "towns",
				"salience": 0.010804068,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k33p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Birmingham"
				},
				"name": "Birmingham",
				"salience": 0.010437934,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.010195801,
				"type": "LOCATION"
			},
			{
				"name": "families",
				"salience": 0.010094956,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.009414561,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.009414561,
				"type": "WORK_OF_ART"
			},
			{
				"name": "trend",
				"salience": 0.009388579,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.008971536,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.007644751,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.007644751,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0075953314,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.007563918,
				"type": "OTHER"
			},
			{
				"name": "societies",
				"salience": 0.007063468,
				"type": "OTHER"
			},
			{
				"name": "community cohesion",
				"salience": 0.007063468,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "Guardian",
				"salience": 0.0068328395,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0067515653,
				"type": "OTHER"
			},
			{
				"name": "Nazia Parveen",
				"salience": 0.0066572134,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0066572134,
				"type": "LOCATION"
			},
			{
				"name": "Anushka Asthana",
				"salience": 0.0066572134,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0057308753,
				"type": "OTHER"
			},
			{
				"name": "race riots",
				"salience": 0.005524521,
				"type": "EVENT"
			},
			{
				"name": "intolerance",
				"salience": 0.005524521,
				"type": "OTHER"
			},
			{
				"name": "prejudice",
				"salience": 0.005524521,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.005524521,
				"type": "EVENT"
			},
			{
				"name": "amount",
				"salience": 0.0052841464,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dhdp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leicester"
				},
				"name": "Leicester",
				"salience": 0.005266036,
				"type": "LOCATION"
			},
			{
				"name": "trend",
				"salience": 0.0049548824,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.004893082,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.004171437,
				"type": "ORGANIZATION"
			},
			{
				"name": "Politicians",
				"salience": 0.0038870063,
				"type": "PERSON"
			},
			{
				"name": "pockets",
				"salience": 0.0038182663,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.003721566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cnty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chuka_Umunna"
				},
				"name": "Chuka Umunna",
				"salience": 0.0034718795,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345gh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Birkbeck,_University_of_London"
				},
				"name": "Birkbeck, University of London",
				"salience": 0.0034018867,
				"type": "ORGANIZATION"
			},
			{
				"name": "focus",
				"salience": 0.0033914964,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0033604172,
				"type": "OTHER"
			},
			{
				"name": "authority area",
				"salience": 0.003262064,
				"type": "LOCATION"
			},
			{
				"name": "interviews",
				"salience": 0.003154078,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0031498831,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0031498831,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.003140362,
				"type": "LOCATION"
			},
			{
				"name": "council areas",
				"salience": 0.0030231962,
				"type": "LOCATION"
			},
			{
				"name": "opposite",
				"salience": 0.0029319734,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.002799523,
				"type": "EVENT"
			},
			{
				"name": "Dame Louise Casey",
				"salience": 0.0027741047,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.0026632843,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0026632843,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0026632843,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0026632843,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0026632843,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.0026377114,
				"type": "PERSON"
			},
			{
				"name": "flight",
				"salience": 0.0026275956,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0026275956,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0026275956,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.002609777,
				"type": "PERSON"
			},
			{
				"name": "facts",
				"salience": 0.0025636058,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.002544443,
				"type": "PERSON"
			},
			{
				"name": "studies",
				"salience": 0.0025123914,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0023564377,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0023564377,
				"type": "OTHER"
			},
			{
				"name": "bones",
				"salience": 0.002333809,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0023236575,
				"type": "OTHER"
			},
			{
				"name": "cohort",
				"salience": 0.0022753787,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mixing",
				"salience": 0.0022753787,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.0022753787,
				"type": "OTHER"
			},
			{
				"name": "stereotypes",
				"salience": 0.0022753787,
				"type": "OTHER"
			},
			{
				"name": "motivations",
				"salience": 0.0022753787,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0022753787,
				"type": "OTHER"
			},
			{
				"name": "contact",
				"salience": 0.0022753787,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0022753787,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0022087602,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0021263286,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0021263286,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0021263286,
				"type": "OTHER"
			},
			{
				"name": "Jonathan Portes",
				"salience": 0.002113258,
				"type": "PERSON"
			},
			{
				"name": "declines",
				"salience": 0.0020405448,
				"type": "OTHER"
			},
			{
				"name": "declines",
				"salience": 0.0020405448,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.0020405448,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.0020405448,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0020211823,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.0020044378,
				"type": "OTHER"
			},
			{
				"name": "faith schools",
				"salience": 0.0020003906,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.0019643873,
				"type": "PERSON"
			},
			{
				"name": "diversity",
				"salience": 0.0019643873,
				"type": "OTHER"
			},
			{
				"name": "polarisation",
				"salience": 0.0019643873,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0019643873,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0019497008,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.001943498,
				"type": "PERSON"
			},
			{
				"name": "policymakers",
				"salience": 0.001923792,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.001923792,
				"type": "OTHER"
			},
			{
				"name": "pupils",
				"salience": 0.0018659402,
				"type": "PERSON"
			},
			{
				"name": "boroughs",
				"salience": 0.0018424304,
				"type": "LOCATION"
			},
			{
				"name": "borough",
				"salience": 0.0018424304,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.0018262223,
				"type": "ORGANIZATION"
			},
			{
				"name": "choices",
				"salience": 0.0018032127,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.001784111,
				"type": "OTHER"
			},
			{
				"name": "street",
				"salience": 0.0017736629,
				"type": "LOCATION"
			},
			{
				"name": "census data",
				"salience": 0.0017736629,
				"type": "OTHER"
			},
			{
				"name": "ethnicities",
				"salience": 0.0017736629,
				"type": "OTHER"
			},
			{
				"name": "report authors",
				"salience": 0.0016859465,
				"type": "PERSON"
			},
			{
				"name": "choices",
				"salience": 0.0016711141,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0016658668,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0016658668,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0016596691,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.0016596691,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.001653928,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0266lb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Cameron"
				},
				"name": "David Cameron",
				"salience": 0.0016399133,
				"type": "PERSON"
			},
			{
				"name": "polarisation",
				"salience": 0.0016036859,
				"type": "OTHER"
			},
			{
				"name": "ward level",
				"salience": 0.0015954081,
				"type": "OTHER"
			},
			{
				"name": "data set",
				"salience": 0.0015954081,
				"type": "EVENT"
			},
			{
				"name": "average",
				"salience": 0.0015954081,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0015916948,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.001557709,
				"type": "WORK_OF_ART"
			},
			{
				"name": "community cohesion officer",
				"salience": 0.0015358558,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.001525908,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0015041123,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0nlc7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London_Borough_of_Newham"
				},
				"name": "Newham",
				"salience": 0.0014933321,
				"type": "LOCATION"
			},
			{
				"name": "Green St East",
				"salience": 0.001382927,
				"type": "LOCATION"
			},
			{
				"name": "research",
				"salience": 0.0013642403,
				"type": "OTHER"
			},
			{
				"name": "Integration",
				"salience": 0.001348844,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.001347049,
				"type": "ORGANIZATION"
			},
			{
				"name": "Some",
				"salience": 0.0013327776,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.0013024308,
				"type": "PERSON"
			},
			{
				"name": "benefits",
				"salience": 0.0013024308,
				"type": "OTHER"
			},
			{
				"name": "salesmanship",
				"salience": 0.0013024308,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0013024308,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0013024308,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0013024308,
				"type": "OTHER"
			},
			{
				"name": "Southall Green",
				"salience": 0.0012711326,
				"type": "PERSON"
			},
			{
				"name": "review",
				"salience": 0.0012594361,
				"type": "WORK_OF_ART"
			},
			{
				"name": "community cohesion",
				"salience": 0.0012444343,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0012444343,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.001208753,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asian",
				"salience": 0.0012028619,
				"type": "LOCATION"
			},
			{
				"name": "sources",
				"salience": 0.0011619446,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0011592399,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0011592399,
				"type": "OTHER"
			},
			{
				"name": "pupils",
				"salience": 0.0011235859,
				"type": "PERSON"
			},
			{
				"name": "findings",
				"salience": 0.0011235859,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0011055543,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0010825214,
				"type": "LOCATION"
			},
			{
				"name": "parts",
				"salience": 0.0010466621,
				"type": "OTHER"
			},
			{
				"name": "integration",
				"salience": 0.0010466621,
				"type": "OTHER"
			},
			{
				"name": "integration",
				"salience": 0.0010466621,
				"type": "OTHER"
			},
			{
				"name": "policymakers",
				"salience": 0.0010466621,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.0010158883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fg6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Luton"
				},
				"name": "Luton",
				"salience": 0.0009819486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020d8d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bradford"
				},
				"name": "Bradford",
				"salience": 0.0009819486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01w2dq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Blackburn"
				},
				"name": "Blackburn",
				"salience": 0.0009819486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0206h8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Darwen"
				},
				"name": "Darwen",
				"salience": 0.0009819486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h73zs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Birmingham_Small_Heath_(UK_Parliament_constituency)"
				},
				"name": "Small Heath",
				"salience": 0.0009819486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02w1dv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Handsworth,_West_Midlands"
				},
				"name": "Handsworth",
				"salience": 0.0009819486,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0009810424,
				"type": "LOCATION"
			},
			{
				"name": "issues",
				"salience": 0.0009729122,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0009729122,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0009729122,
				"type": "PERSON"
			},
			{
				"name": "religions",
				"salience": 0.0009729122,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0009729122,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.00095280015,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/094vy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yorkshire"
				},
				"name": "Yorkshire",
				"salience": 0.0009452882,
				"type": "LOCATION"
			},
			{
				"name": "divisions",
				"salience": 0.00093658915,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.00090630096,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00090630096,
				"type": "OTHER"
			},
			{
				"name": "parliamentary group",
				"salience": 0.00090630096,
				"type": "ORGANIZATION"
			},
			{
				"name": "numbers",
				"salience": 0.00090566784,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.00090566784,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0009029283,
				"type": "WORK_OF_ART"
			},
			{
				"name": "changes",
				"salience": 0.0008506108,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0008258329,
				"type": "PERSON"
			},
			{
				"name": "street",
				"salience": 0.00081828056,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.0008079674,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0n9vx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London_Borough_of_Ealing"
				},
				"name": "Ealing",
				"salience": 0.00080159697,
				"type": "LOCATION"
			},
			{
				"name": "Mid Sussex",
				"salience": 0.00080159697,
				"type": "LOCATION"
			},
			{
				"name": "Bassetlaw",
				"salience": 0.00080159697,
				"type": "LOCATION"
			},
			{
				"name": "mid-Devon",
				"salience": 0.00080159697,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01zjn0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barrow-in-Furness"
				},
				"name": "Barrow-in-Furness",
				"salience": 0.00080159697,
				"type": "LOCATION"
			},
			{
				"name": "places",
				"salience": 0.0007977841,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.0007942199,
				"type": "OTHER"
			},
			{
				"name": "integration",
				"salience": 0.0007818376,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.000774326,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.00076123927,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00073281705,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.00073281705,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.00073281705,
				"type": "LOCATION"
			},
			{
				"name": "approach",
				"salience": 0.00070853933,
				"type": "OTHER"
			},
			{
				"name": "pace",
				"salience": 0.00070853933,
				"type": "OTHER"
			},
			{
				"name": "referendum campaign",
				"salience": 0.00070853933,
				"type": "EVENT"
			},
			{
				"name": "challenges",
				"salience": 0.00070853933,
				"type": "OTHER"
			},
			{
				"name": "globalisation",
				"salience": 0.00070853933,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.00070853933,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0006769828,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0006769828,
				"type": "OTHER"
			},
			{
				"name": "description",
				"salience": 0.0006734873,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.0006631943,
				"type": "ORGANIZATION"
			},
			{
				"name": "diversity",
				"salience": 0.0006600248,
				"type": "OTHER"
			},
			{
				"name": "segregation",
				"salience": 0.00064304203,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.00061122957,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.00057839486,
				"type": "WORK_OF_ART"
			},
			{
				"name": "more",
				"salience": 0.0005736676,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0005292517,
				"type": "EVENT"
			},
			{
				"name": "bit",
				"salience": 0.0005292517,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0005292517,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0005292517,
				"type": "OTHER"
			},
			{
				"name": "directions",
				"salience": 0.0005292517,
				"type": "OTHER"
			},
			{
				"name": "surge",
				"salience": 0.0005292517,
				"type": "EVENT"
			},
			{
				"name": "hate crime",
				"salience": 0.0005292517,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.0005292517,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0005292517,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0005292517,
				"type": "OTHER"
			},
			{
				"name": "Kauffman",
				"salience": 0.000503591,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.0003617346,
				"type": "OTHER"
			},
			{
				"name": "Brexit",
				"salience": 0.00032570373,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00032570373,
				"type": "LOCATION"
			},
			{
				"name": "referendum result",
				"salience": 0.00029905495,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.00022337525,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:37.972+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Call for Action to Tackle Growing Ethnic Segregation Across UK Anushka Asthana and Nazia Parveen, Guardian, November 1, 2016 \nPoliticians must urgently tackle the increasing ethnic polarisation of many of Britain’s towns and cities, according to a senior academic, as he revealed figures showing how rapidly the white British population had dwindled in urban “pockets” across England. \nProf Ted Cantle, who first authored a report into community cohesion after a series of race riots in 2001, said his new study showed that in the most extreme cases the white British population had more than halved in two decades. \nCantle, who co-authored the report with Prof Eric Kaufmann at Birkbeck, University of London, told the Guardian that white British families should be encouraged to remain in ethnically diverse areas to reduce the trend. \nHe warned that segregated societies “breed intolerance and prejudice”, adding: “And we know the opposite is true–there is a huge amount of research that shows any form of contact does break down stereotypes.” \nThe leading academic said he would not describe the trend as white flight because that indicated that people were moving because of ethnic mixing, while this research only established the facts and not necessarily the causes. \n“White people are leaving urban areas in a disproportionate number–and they avoid moving to diverse areas when they do move. But we can’t say that is white flight because the motivations are many and various,” he said, arguing it could be to do with the dream of a place in the country or an older cohort retiring to rural communities. \nBut he said interviews he had carried out in recent years as part of the study had highlighted a sense among some white British people that an area they had lived in was “no longer for them”. \nIn one case a community cohesion officer in Yorkshire told Cantle he was the first Asian to move into a particular street and that within three years virtually every white British family had gone. “Some of those families made no bones about it, they said they are moving out because ‘they’ are moving in,” he said. \nThe research looked at two existing studies and drew from census data from 1991, 2001 and 2011–examining the figures in a way that has not been done before. \nThe report authors stressed that the findings were nuanced, with more diversity in some areas, and different ethnic groups mixing together. \nHowever, when looking at the white British population compared with all other ethnicities together it found increasing polarisation, with the steepest decline in the white population in “urban pockets” where the numbers were already well below the national average. \nSome of the largest declines were in Slough, where the white population fell from 58.3% to 34.5%, in Birmingham, where it went from 65.6% to 53.1% and in Leicester, where it decreased from 60.5% to 45.1%. \nIn one London borough, Newham, the figure was just 16.7% in the latest data set. \nBut the study found even more marked changes when it examined the figures at ward level. In one part of the Blackburn and Darwen authority area 7.8% of the population was white British, down from 42.3% in 1991. \nSmaller council areas in Birmingham saw similar declines, from 40.4% to 11.2% in Small Heath and from 30.7% to 7.2% in Handsworth. The trend was repeated in parts of Bradford, Luton and across London boroughs. \nGreen St East in Newham had a white British population of 31.6% in 1991. Twenty years later is had declined to just 4.8%. While Southall Green, in Ealing, went from 18.9% to 4.6% in the same period. \nMeanwhile, there were only tiny changes in ethnic diversity in the most predominantly white areas, such as Barrow-in-Furness, mid-Devon, Bassetlaw and Mid Sussex. \n“The focus of policy needs to shift; this is not just about minorities,” said Cantle. “Politicians and policymakers need to encourage white British residents to remain in diverse areas; to choose, rather than avoid, diverse areas when they do relocate, encouraging similar choices with respect to placing pupils in diverse schools; in other words to create a positive choice for mixed areas and a shared society.” \nCantle called for “salesmanship” of the positive benefits of mixed areas, including the cultural choices, and activities. We’ve never sold the idea that mixed communities are more exciting places with more going on,” he said, adding that after the Brexit vote there had been a bit of move in the opposite directions with the immediate surge in hate crime. \nBut he also argued that some negative practices ought to be stamped out–including businesses recruiting workers from single, eastern European countries. \nThe publication of the report triggered an immediate debate with experts claiming that the diversity in areas with fewer white British families meant segregation was the wrong description. “It is simply wrong to suggest that inner cities have become more ‘ethnically segregated’. In fact, people are more likely to live near those of a different ethnicity than ever before. What is undoubtedly true is that more needs to be done to promote integration–and not just in the most diverse areas,” said the economist, Jonathan Portes. \nHowever, Cantle’s report argues that polarisation between the white British majority and other ethnic groups is a significant fact that requires urgent action. \nCantle’s research comes after the government was accused of sitting on a major study into community cohesion by Dame Louise Casey. The study is thought to include some uncomfortable findings. \nCasey, whose report has been finalised, will warn that successive governments have failed to do enough to tackle the difficult issues raised by Cantle 15 years ago. \nShe is expected to suggest that faith schools should make their pupils mix with children of other religions, in a report that she has promised will be “making the difficult choices and telling the truth”. \nIt is not clear why her review has not yet been published although sources have pointed out that much has changed since she was first appointed by the then prime minister, David Cameron, including the EU referendum result and a new government. The government insists the review will be out by the end of the year. \nChuka Umunna MP, chair of the all-party parliamentary group on social integration, said the report from Cantle and Kauffman laid “bare the striking pace of change in some of our communities”. \nIn a foreward to the study, he argued there were consequences for policymakers. “It is clear we cannot carry on with a laissez-faire approach to integration in our country. Integration is a two-way street and all parts of society have a role to play in preventing the UK becoming more fragmented. \n“If we fail to do so, we risk sleepwalking into a situation where the divisions exposed during the EU referendum campaign become deeper as we grapple with the challenges thrown up by globalisation.”",
		"thread_title": "Call for Action to Tackle Growing Ethnic Segregation Across UK",
		"title": "Call for Action to Tackle Growing Ethnic Segregation Across UK",
		"type": "bs",
		"uuid": "d9bb0b290af7a4298b7bce0e90c0f941266dddcf"
	},
	"-KhIgsAcGo0fSl4dvs8A": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:48:40.897+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Stalingrad Metro station",
				"salience": 0.07006274,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.059955824,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.057279438,
				"type": "LOCATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.041091356,
				"type": "PERSON"
			},
			{
				"name": "Asylum seekers",
				"salience": 0.027001785,
				"type": "PERSON"
			},
			{
				"name": "demolition",
				"salience": 0.026538918,
				"type": "EVENT"
			},
			{
				"name": "Streets",
				"salience": 0.021401092,
				"type": "LOCATION"
			},
			{
				"name": "streets",
				"salience": 0.021401092,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.021401092,
				"type": "OTHER"
			},
			{
				"name": "lengths",
				"salience": 0.021154545,
				"type": "OTHER"
			},
			{
				"name": "migrant turf war",
				"salience": 0.019336926,
				"type": "EVENT"
			},
			{
				"name": "neighbourhoods",
				"salience": 0.019336926,
				"type": "LOCATION"
			},
			{
				"name": "Capital",
				"salience": 0.019336926,
				"type": "LOCATION"
			},
			{
				"name": "War",
				"salience": 0.019336926,
				"type": "EVENT"
			},
			{
				"name": "clubs",
				"salience": 0.019336926,
				"type": "ORGANIZATION"
			},
			{
				"name": "Faisal",
				"salience": 0.017676298,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.017544117,
				"type": "PERSON"
			},
			{
				"name": "pulp",
				"salience": 0.016759096,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.016759096,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.016634492,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0140134,
				"type": "PERSON"
			},
			{
				"name": "tops",
				"salience": 0.013869773,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.012517287,
				"type": "PERSON"
			},
			{
				"name": "locals",
				"salience": 0.012246851,
				"type": "PERSON"
			},
			{
				"name": "refugee battleground",
				"salience": 0.010967282,
				"type": "LOCATION"
			},
			{
				"name": "each other",
				"salience": 0.010967282,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.010967282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_myf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Express"
				},
				"name": "Express",
				"salience": 0.01033758,
				"type": "ORGANIZATION"
			},
			{
				"name": "Armed Migrants Fight Running Battles",
				"salience": 0.01033758,
				"type": "EVENT"
			},
			{
				"name": "Nick Gutteridge",
				"salience": 0.01033758,
				"type": "PERSON"
			},
			{
				"name": "clubs",
				"salience": 0.009905758,
				"type": "ORGANIZATION"
			},
			{
				"name": "gangs",
				"salience": 0.009905758,
				"type": "PERSON"
			},
			{
				"name": "scenes",
				"salience": 0.009905758,
				"type": "WORK_OF_ART"
			},
			{
				"name": "refugee camp",
				"salience": 0.00940155,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j7wv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stalingrad_(Paris_M%C3%A9tro)"
				},
				"name": "Stalingrad",
				"salience": 0.008653103,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.008194372,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01y3fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jungle"
				},
				"name": "Jungle",
				"salience": 0.0075910063,
				"type": "LOCATION"
			},
			{
				"name": "migrant camp",
				"salience": 0.0064743888,
				"type": "ORGANIZATION"
			},
			{
				"name": "camp",
				"salience": 0.0064743888,
				"type": "EVENT"
			},
			{
				"name": "People",
				"salience": 0.006032177,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d62c8"
				},
				"name": "Marie",
				"salience": 0.0055961097,
				"type": "PERSON"
			},
			{
				"name": "Thousands",
				"salience": 0.005139068,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.004818911,
				"type": "OTHER"
			},
			{
				"name": "Monique",
				"salience": 0.004781088,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.0045418623,
				"type": "EVENT"
			},
			{
				"name": "squatters",
				"salience": 0.0045374464,
				"type": "PERSON"
			},
			{
				"name": "brawl",
				"salience": 0.004523215,
				"type": "OTHER"
			},
			{
				"name": "brawls",
				"salience": 0.004523215,
				"type": "EVENT"
			},
			{
				"name": "each other",
				"salience": 0.004523215,
				"type": "PERSON"
			},
			{
				"name": "brawl",
				"salience": 0.004523215,
				"type": "OTHER"
			},
			{
				"name": "locals",
				"salience": 0.004508092,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.0041394252,
				"type": "PERSON"
			},
			{
				"name": "gangs",
				"salience": 0.0040844674,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.004056788,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.004035868,
				"type": "PERSON"
			},
			{
				"name": "squalor",
				"salience": 0.0039472813,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.003905504,
				"type": "PERSON"
			},
			{
				"name": "locals",
				"salience": 0.0037522353,
				"type": "PERSON"
			},
			{
				"name": "fight",
				"salience": 0.0035372847,
				"type": "EVENT"
			},
			{
				"name": "wood",
				"salience": 0.0035372847,
				"type": "OTHER"
			},
			{
				"name": "pedestrians",
				"salience": 0.0035372847,
				"type": "PERSON"
			},
			{
				"name": "people smugglers",
				"salience": 0.0035372847,
				"type": "PERSON"
			},
			{
				"name": "squat",
				"salience": 0.0034337789,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.003420616,
				"type": "LOCATION"
			},
			{
				"name": "place",
				"salience": 0.0033373488,
				"type": "OTHER"
			},
			{
				"name": "Jeanne",
				"salience": 0.0031423676,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0030540645,
				"type": "OTHER"
			},
			{
				"name": "squatters",
				"salience": 0.0028933953,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0028645464,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.0028645464,
				"type": "ORGANIZATION"
			},
			{
				"name": "camp",
				"salience": 0.0027709883,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.0027709883,
				"type": "EVENT"
			},
			{
				"name": "tents",
				"salience": 0.0027576778,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "nightlife scene",
				"salience": 0.0027576778,
				"type": "OTHER"
			},
			{
				"name": "neighbourhood",
				"salience": 0.0027576778,
				"type": "LOCATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.0026566465,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0025901492,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0025680782,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.0024806424,
				"type": "OTHER"
			},
			{
				"name": "muggings",
				"salience": 0.0024806424,
				"type": "EVENT"
			},
			{
				"name": "eyesore",
				"salience": 0.0024806424,
				"type": "OTHER"
			},
			{
				"name": "district",
				"salience": 0.0024806424,
				"type": "LOCATION"
			},
			{
				"name": "hell",
				"salience": 0.0024806424,
				"type": "OTHER"
			},
			{
				"name": "occasions",
				"salience": 0.0024806424,
				"type": "EVENT"
			},
			{
				"name": "migrants",
				"salience": 0.0024748712,
				"type": "PERSON"
			},
			{
				"name": "tourists",
				"salience": 0.0023880834,
				"type": "PERSON"
			},
			{
				"name": "restaurants",
				"salience": 0.0023880834,
				"type": "LOCATION"
			},
			{
				"name": "attempts",
				"salience": 0.0023880834,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0023880834,
				"type": "EVENT"
			},
			{
				"name": "bars",
				"salience": 0.0023880834,
				"type": "OTHER"
			},
			{
				"name": "go zone",
				"salience": 0.0023880834,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.002338745,
				"type": "OTHER"
			},
			{
				"name": "faeces",
				"salience": 0.002338745,
				"type": "OTHER"
			},
			{
				"name": "rubbish",
				"salience": 0.002338745,
				"type": "OTHER"
			},
			{
				"name": "Life",
				"salience": 0.002309286,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.0021778143,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qg4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Hollande"
				},
				"name": "François Hollande",
				"salience": 0.0020555137,
				"type": "PERSON"
			},
			{
				"name": "stench",
				"salience": 0.0020510938,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0020252555,
				"type": "EVENT"
			},
			{
				"name": "urine",
				"salience": 0.0020252555,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0020252555,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0020184105,
				"type": "EVENT"
			},
			{
				"name": "encampments",
				"salience": 0.0019997426,
				"type": "LOCATION"
			},
			{
				"name": "bust",
				"salience": 0.001949676,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0019251143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01p3xl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Metro_station"
				},
				"name": "Metro station",
				"salience": 0.001880179,
				"type": "ORGANIZATION"
			},
			{
				"name": "migrants",
				"salience": 0.0017799521,
				"type": "PERSON"
			},
			{
				"name": "noises",
				"salience": 0.0017616267,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.0017472355,
				"type": "OTHER"
			},
			{
				"name": "tents",
				"salience": 0.0017472355,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0015129887,
				"type": "OTHER"
			},
			{
				"name": "battle authorities",
				"salience": 0.0015129887,
				"type": "PERSON"
			},
			{
				"name": "police operation",
				"salience": 0.0015129887,
				"type": "EVENT"
			},
			{
				"name": "face",
				"salience": 0.0015129887,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0015078741,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01r5r1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/10th_arrondissement_of_Paris"
				},
				"name": "10th Arrondissement",
				"salience": 0.0014700408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sudan"
				},
				"name": "Sudan",
				"salience": 0.0014700408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0014700408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0014700408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02khs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eritrea"
				},
				"name": "Eritrea",
				"salience": 0.0014700408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.0014700408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kwbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Le_Figaro"
				},
				"name": "Le Figaro",
				"salience": 0.0014255787,
				"type": "ORGANIZATION"
			},
			{
				"name": "streets",
				"salience": 0.0014094249,
				"type": "LOCATION"
			},
			{
				"name": "screams",
				"salience": 0.0012830532,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "middle",
				"salience": 0.0012725698,
				"type": "LOCATION"
			},
			{
				"name": "faeces",
				"salience": 0.0012725698,
				"type": "OTHER"
			},
			{
				"name": "rubbish",
				"salience": 0.0012725698,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0012154713,
				"type": "EVENT"
			},
			{
				"name": "locals",
				"salience": 0.001139684,
				"type": "PERSON"
			},
			{
				"name": "loss",
				"salience": 0.0011019341,
				"type": "EVENT"
			},
			{
				"name": "situation",
				"salience": 0.0011019341,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0011019341,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0011019341,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.001060798,
				"type": "OTHER"
			},
			{
				"name": "Police",
				"salience": 0.0010528653,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.000884359,
				"type": "PERSON"
			},
			{
				"name": "handbags",
				"salience": 0.0008231405,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "passers",
				"salience": 0.0008231405,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0008231405,
				"type": "OTHER"
			},
			{
				"name": "jewellery",
				"salience": 0.0008231405,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bread",
				"salience": 0.0008231405,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "law",
				"salience": 0.0008231405,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0008231405,
				"type": "OTHER"
			},
			{
				"name": "Residents",
				"salience": 0.00080668804,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:48:40.897+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "War on the Streets of Paris: Armed Migrants Fight Running Battles in the French Capital Nick Gutteridge, Express, November 2, 2016 \nA migrant turf war erupted into violence on the streets of one of Paris’ trendiest neighbourhoods early this morning as asylum seekers beat each other to a pulp with wooden clubs. \nThe area around Stalingrad Metro station was turned into a refugee battleground as rival gangs of migrants set upon each other in shocking scenes of violence. \nAsylum seekers wearing hooded tops wielded makeshift clubs fashioned from lengths of wood which they used to bludgeon each other as horrified pedestrians looked on. \nThe blood-curdling brawl erupted just yards from the Stalingrad Metro station, where a squalid migrant camp has popped up following the demolition of the Jungle. \nIt was not immediately clear what sparked the early morning fight, but rival gangs of people smugglers have previously been involved in violent brawls in Calais. \nAnd despite the horrific brawl, a pro-migrant rally is apparently being organised to take place at the camp at 6pm tonight. \nThe once peaceful neighbourhood, in Paris’ 10th Arrondissement, used to be a popular area with tourists, boasting a lively nightlife scene bustling with restaurants and bars. \nBut worried residents have revealed how it has become a no go zone in recent weeks following the establishment of the refugee camp, which has brought squalor and violence. \nThousands of migrants–mostly from Sudan, Libya, Afghanistan, and Eritrea–have pitched tents under the Metro station after the demolition of the Jungle hampered their attempts to reach Britain. \nFrench police have tried and failed on many occasions to clear the squalid squat, but asylum seekers simply keep on returning and reestablishing it. \nThere are now nore than 2,500 migrants pitching up in the makeshift camp, with locals saying the eyesore is ruining their businesses and making life a “living hell”. \nResidents in the once popular district say that the squatters are now becoming increasingly violent and dangerous, with increased reports of muggings. \nFaisal, a shopkeeper, told the French daily Le Figaro that Stalingrad locals are living in fear, threatening the future of his business. \nHe said: “The stench of urine, faeces, and rubbish has made Stalingrad an insalubrious place to live. The place is dead – no-one wants to come here anymore. People are afraid to go out and lock themselves in. \n“I’m making less than €60 (£53) a day. A few more weeks like this and I’ll go bust! \n“French people have been kind to them. I know they’re desperate, but the least they can do is respect the law and try and integrate into French society.” \nJeanne, another Stalingrad resident, told Le Figaro the migrants had become increasingly violent towards locals. \nShe said: “Brazen migrants are snatching jewellery and handbags off passers-by–they’re even stealing bread. I’ve seen them beat people up too.” \nPolice have raided the camp some 30 times in the past year, and on Monday French president François Hollande vowed to close the camp for good. \nBut within 24 hours of a police operation to move migrants on tents had sprung up again, showing the uphill battle authorities in the French capital face to shut down such illegal encampments. \nFurious locals have demanded that the camp be closed once and for all, describing how they have heard “blood-curdling noises” coming from it in the middle of the night. \nMarie, who lives right next to the makeshift camp, told Le Figaro: “Life here has become unbearable. More than 2,500 squatters were evacuated in September, and now, less than two months later, they’re back. And now that the ‘Jungle’ camp has been closed, things are about to get even worse.” \nAnother local, Monique, said that she was at “a loss for words” and “utterly distraught” over the situation. \nShe said: “The streets are littered with rubbish and faeces. We can hear blood-curdling screams coming from the camp in the middle of the night.",
		"thread_title": "War on the Streets of Paris: Armed Migrants Fight Running Battles in the French Capital",
		"title": "War on the Streets of Paris: Armed Migrants Fight Running Battles in the French Capital",
		"type": "bs",
		"uuid": "5cfb9a671e0727fcbb162d3944754f5a9fc1c2d7"
	},
	"-KhIgsOHIYcvA8ABpw7Z": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:08.595+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "voters",
				"salience": 0.13688357,
				"type": "PERSON"
			},
			{
				"name": "contest",
				"salience": 0.12932312,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.042642884,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.036798995,
				"type": "ORGANIZATION"
			},
			{
				"name": "Election Contest",
				"salience": 0.02770287,
				"type": "OTHER"
			},
			{
				"name": "gender",
				"salience": 0.02770287,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.02597832,
				"type": "ORGANIZATION"
			},
			{
				"name": "rifts",
				"salience": 0.025041845,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.025041845,
				"type": "OTHER"
			},
			{
				"name": "divisions",
				"salience": 0.025041845,
				"type": "OTHER"
			},
			{
				"name": "factors",
				"salience": 0.025041845,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.022369798,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.021715356,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.021715356,
				"type": "LOCATION"
			},
			{
				"name": "belief",
				"salience": 0.021715356,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.021715356,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.021715356,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.01733098,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.016416257,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01v3sw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ABC_News"
				},
				"name": "ABC News",
				"salience": 0.013413046,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lie Deep Rifts Among Groups Gary Langer",
				"salience": 0.013413046,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.009757544,
				"type": "PERSON"
			},
			{
				"name": "gender gap",
				"salience": 0.009410947,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.008581364,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.008128573,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.008128573,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.008128573,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.008128573,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.007960356,
				"type": "PERSON"
			},
			{
				"name": "leaners",
				"salience": 0.006675331,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0063595134,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0063595134,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.006022546,
				"type": "OTHER"
			},
			{
				"name": "nonwhites",
				"salience": 0.0058761463,
				"type": "PERSON"
			},
			{
				"name": "college",
				"salience": 0.0058761463,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0058761463,
				"type": "EVENT"
			},
			{
				"name": "group",
				"salience": 0.0052906424,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.005007019,
				"type": "OTHER"
			},
			{
				"name": "slippage",
				"salience": 0.0047742077,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.004764582,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0047597927,
				"type": "OTHER"
			},
			{
				"name": "gap",
				"salience": 0.0046936697,
				"type": "OTHER"
			},
			{
				"name": "norm",
				"salience": 0.0045962795,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "gaps",
				"salience": 0.0045962795,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0045962795,
				"type": "PERSON"
			},
			{
				"name": "evangelicals",
				"salience": 0.0045962795,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.004582401,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0037226696,
				"type": "PERSON"
			},
			{
				"name": "nomination",
				"salience": 0.0037226696,
				"type": "OTHER"
			},
			{
				"name": "Differences",
				"salience": 0.0037226696,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0037226696,
				"type": "OTHER"
			},
			{
				"name": "Whites",
				"salience": 0.0036899557,
				"type": "PERSON"
			},
			{
				"name": "gap",
				"salience": 0.0036435132,
				"type": "OTHER"
			},
			{
				"name": "gender",
				"salience": 0.0036320852,
				"type": "OTHER"
			},
			{
				"name": "factors",
				"salience": 0.003583868,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.003583868,
				"type": "PERSON"
			},
			{
				"name": "nomination",
				"salience": 0.003583868,
				"type": "OTHER"
			},
			{
				"name": "nonwhites",
				"salience": 0.0033662687,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0033537569,
				"type": "ORGANIZATION"
			},
			{
				"name": "turnout",
				"salience": 0.003224024,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.003224024,
				"type": "OTHER"
			},
			{
				"name": "constituency",
				"salience": 0.003224024,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0031999396,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0031037887,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0031037887,
				"type": "OTHER"
			},
			{
				"name": "nonwhites",
				"salience": 0.002946515,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0027225344,
				"type": "PERSON"
			},
			{
				"name": "latter",
				"salience": 0.002632425,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.002632425,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0025152904,
				"type": "EVENT"
			},
			{
				"name": "groups",
				"salience": 0.0024432216,
				"type": "ORGANIZATION"
			},
			{
				"name": "battleground group",
				"salience": 0.0024432216,
				"type": "ORGANIZATION"
			},
			{
				"name": "education",
				"salience": 0.0022711894,
				"type": "OTHER"
			},
			{
				"name": "differences",
				"salience": 0.0022711894,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0021157933,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0021048768,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.0020189374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Protestantism"
				},
				"name": "Protestants",
				"salience": 0.0019850526,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.0019667957,
				"type": "OTHER"
			},
			{
				"name": "Stein",
				"salience": 0.0019109834,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Johnson",
				"salience": 0.0019109834,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.00189495,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.00189495,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0018322092,
				"type": "OTHER"
			},
			{
				"name": "largest",
				"salience": 0.0016543498,
				"type": "OTHER"
			},
			{
				"name": "divide",
				"salience": 0.0015926115,
				"type": "OTHER"
			},
			{
				"name": "gap",
				"salience": 0.0014816395,
				"type": "OTHER"
			},
			{
				"name": "college degree",
				"salience": 0.0014325744,
				"type": "OTHER"
			},
			{
				"name": "margins",
				"salience": 0.0014325744,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0013687965,
				"type": "OTHER"
			},
			{
				"name": "exit polls",
				"salience": 0.001070191,
				"type": "OTHER"
			},
			{
				"name": "average",
				"salience": 0.001070191,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.001070191,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.000658679,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:02:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Beneath a Close Election Contest Lie Deep Rifts Among Groups Gary Langer et al., ABC News, November 3, 2016 \nProfound rifts among groups lie beneath the close presidential contest, underscoring the country’s fundamental political divisions not only by gender, education, race and ethnicity but also by factors ranging from religious belief to residential area. \n{snip} \nThere’s a 22 point gender gap in the contest, nearly double the norm in elections since 1976. And that pales compared with other gaps–44 points between college- and non-college-educated whites, 65 points between whites and nonwhites, 66 points between rural and urban residents and 97 points between white evangelicals and likely voters who don’t profess a particular religion. \n{snip} \nTrump is doing less well with Republicans and GOP leaners who wanted someone else to win the nomination; he has 75 percent support in this group, with 15 percent going to Clinton, 7 percent to Johnson or Stein. Two factors mitigate the damage: leaning Republicans have grown more apt to say they supported Trump in the first place (47 percent, up from 40 percent in August), and there’s no slippage evident in turnout among leaning Republicans who preferred someone else for the nomination. \n{snip} \nDifferences among groups abound, with one of the largest between evangelical white Protestants–a core Republican constituency–and those who profess no religion. The former back Trump by 77 to 19 percent; the latter, Clinton by 64 to 25 percent. The groups are identical in size, each making up 17 percent of likely voters. The gap between them is typical. \n{snip} \nThe racial gap, while wide, is narrower than typical. Whites support Trump by 53 to 39 percent; nonwhites favor Clinton, 72 to 21 percent. But that 65 point divide is a bit smaller than the average in exit polls since 1976, 73 points, as well as 26 points smaller than the record racial gap, 91 points, in 1984. That’s mostly because of lower support for Clinton among nonwhites who are not black or Hispanic; 48 percent back her, versus 66 percent for Barack Obama in 2012. \nIn a particularly prominent result in this election, gender and education continue to spell broad differences among whites. College-educated white women, consistently strong for Clinton all year, now back her by 59 to 32 percent. Non-college-educated white men, steadily one of Trump’s best groups, support him 64 to 26 percent. \nWhite men with a college degree continue to divide closely, making them a battleground group. Non-college-educated white women–the largest of these groups, at 24 percent of likely voters–have wavered in their support, generally for Trump but by varying margins. Lately, they look more settled on Trump, now by 61 to 33 percent. \n{snip}",
		"thread_title": "Beneath a Close Election Contest Lie Deep Rifts Among Groups",
		"title": "Beneath a Close Election Contest Lie Deep Rifts Among Groups",
		"type": "bs",
		"uuid": "b126ce1ce03c92b8b22afcc4fde326bf46b22b0f"
	},
	"-KhIgsf6I9sfXecd-rkk": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:10.252+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.22646022,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.14660595,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.04369723,
				"type": "ORGANIZATION"
			},
			{
				"name": "voters",
				"salience": 0.038685683,
				"type": "PERSON"
			},
			{
				"name": "compositions",
				"salience": 0.031678975,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.02935187,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.023950493,
				"type": "PERSON"
			},
			{
				"name": "college degree",
				"salience": 0.020758914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.019569881,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.01666697,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Francis Wilkinson",
				"salience": 0.016401745,
				"type": "PERSON"
			},
			{
				"name": "shift",
				"salience": 0.016251542,
				"type": "EVENT"
			},
			{
				"name": "share",
				"salience": 0.016251542,
				"type": "OTHER"
			},
			{
				"name": "rage",
				"salience": 0.010562665,
				"type": "OTHER"
			},
			{
				"name": "Stories",
				"salience": 0.010490435,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/08qtd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pew_Research_Center"
				},
				"name": "Pew Research Center",
				"salience": 0.010020523,
				"type": "ORGANIZATION"
			},
			{
				"name": "college degree",
				"salience": 0.009368366,
				"type": "OTHER"
			},
			{
				"name": "college degree",
				"salience": 0.009368366,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.008860252,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.008545783,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027913b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_B._Edsall"
				},
				"name": "Thomas Edsall",
				"salience": 0.00829459,
				"type": "PERSON"
			},
			{
				"name": "temptation",
				"salience": 0.008056843,
				"type": "OTHER"
			},
			{
				"name": "rage",
				"salience": 0.0077489037,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0073355995,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.006706986,
				"type": "OTHER"
			},
			{
				"name": "sage",
				"salience": 0.006706986,
				"type": "OTHER"
			},
			{
				"name": "consequence",
				"salience": 0.006706986,
				"type": "OTHER"
			},
			{
				"name": "proportion",
				"salience": 0.006706986,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0065487535,
				"type": "OTHER"
			},
			{
				"name": "millionaires",
				"salience": 0.006544014,
				"type": "PERSON"
			},
			{
				"name": "rage",
				"salience": 0.006328186,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.006060912,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.006015657,
				"type": "PERSON"
			},
			{
				"name": "opposite",
				"salience": 0.005834984,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0057615587,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.005393385,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0053167692,
				"type": "ORGANIZATION"
			},
			{
				"name": "collars",
				"salience": 0.0053167692,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.005229737,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.005229737,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.004912223,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.004912223,
				"type": "ORGANIZATION"
			},
			{
				"name": "Great Democratic Inversion",
				"salience": 0.0047695898,
				"type": "EVENT"
			},
			{
				"name": "analysis",
				"salience": 0.0047046635,
				"type": "OTHER"
			},
			{
				"name": "vote totals",
				"salience": 0.0045292187,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0045292187,
				"type": "OTHER"
			},
			{
				"name": "majorities",
				"salience": 0.0045292187,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0044765864,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.004435695,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0041306266,
				"type": "ORGANIZATION"
			},
			{
				"name": "inversion",
				"salience": 0.0040081316,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.003982191,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.0038414074,
				"type": "OTHER"
			},
			{
				"name": "class allegiances",
				"salience": 0.0038414074,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.0038414074,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "billionaires",
				"salience": 0.0038414074,
				"type": "PERSON"
			},
			{
				"name": "demarcations",
				"salience": 0.0038414074,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.0036704836,
				"type": "ORGANIZATION"
			},
			{
				"name": "straps",
				"salience": 0.0033142874,
				"type": "OTHER"
			},
			{
				"name": "straitjacket",
				"salience": 0.0033142874,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0032611352,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0032611352,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0031906392,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0028967483,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0028967483,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0028967483,
				"type": "LOCATION"
			},
			{
				"name": "failure",
				"salience": 0.0028701073,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0028701073,
				"type": "OTHER"
			},
			{
				"name": "class identities",
				"salience": 0.0028701073,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0028701073,
				"type": "OTHER"
			},
			{
				"name": "ranks",
				"salience": 0.0028701073,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0028701073,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.0028701073,
				"type": "OTHER"
			},
			{
				"name": "torso",
				"salience": 0.0028701073,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05k41",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Deal"
				},
				"name": "New Deal",
				"salience": 0.0027886638,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0026737135,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0024364432,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.0023854268,
				"type": "ORGANIZATION"
			},
			{
				"name": "deindustrialized America",
				"salience": 0.0023649759,
				"type": "LOCATION"
			},
			{
				"name": "office workers",
				"salience": 0.0021621445,
				"type": "PERSON"
			},
			{
				"name": "service workers",
				"salience": 0.0021621445,
				"type": "PERSON"
			},
			{
				"name": "nonwhites",
				"salience": 0.0020905458,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0020905458,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0020905458,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0018035421,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0015617312,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0015617312,
				"type": "ORGANIZATION"
			},
			{
				"name": "kids",
				"salience": 0.0015617312,
				"type": "PERSON"
			},
			{
				"name": "dislocation",
				"salience": 0.0015617312,
				"type": "OTHER"
			},
			{
				"name": "factory",
				"salience": 0.0015617312,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanic",
				"salience": 0.0009612174,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:02:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Francis Wilkinson, Bloomberg, November 1, 2016 \nThe class compositions of the Republican and Democratic parties keep evolving. {snip} \nA Pew Research Center report last month detailed the shift. \nSince 1992, the share of Democratic and Democratic-leaning registered voters with at least a college degree has increased sharply, from 21 percent to 37 percent. Among Republicans, 31 percent have at least a college degree, up only slightly from 28 percent in 1992. As a consequence, a greater proportion of Democrats than Republicans now have a college degree or more education. \nIn the New York Times last week, political sage Thomas Edsall called this process the “Great Democratic Inversion.” \nWhat these figures suggest is that the 2016 election will represent a complete inversion of the New Deal order among white voters. From the 1930s into the 1980s and early 1990s, majorities of downscale whites voted Democratic and upscale whites voted Republican. Now, looking at combined male and female vote totals, the opposite is true. \nA key word in Edsall’s analysis is “white.” Stories about the disaffected working-class supporters of Donald Trump apply almost exclusively to white voters. Other working-class voters–blacks and Hispanics –are poised to provide lopsided support to Hillary Clinton. \n{snip} \nThere is no expansive, working-class rage in the U.S. There is white conservative rage (along with a more modest left-wing version). While it may burn brightest in deindustrialized America, conservative rage extends across class and educational demarcations, from blue collars to billionaires . \nThis complicates the story of the parties switching class allegiances. For Democrats, it leaves them managing an increasingly unwieldy coalition extending from white cosmopolitan millionaires who send their kids to private schools to low-paid Hispanic service workers and black factory and office workers facing economic dislocation. {snip} \nKeeping that coalition pointed in the same general direction might be impossible without the dedicated efforts of the Republican Party. The GOP has proved incapable of breaking out of its racial straitjacket. So it has opted instead to tighten the straps around its torso. \n{snip} \nRepublicans’ constant struggle with racism in their ranks, and their recurring failure to resist the temptation to exploit it, eases pressure on the Democrats’ sprawling coalition. The parties won’t fully exchange their class identities for the simple reason that working-class blacks and Hispanics can’t trust the GOP to represent them. \nIf it doesn’t diversify and become more accommodating to nonwhites, the GOP will only grow crazier and scarier , and its effort to wield power with the support of a shrinking white base will become even more extreme. {snip} \n{snip}",
		"thread_title": "Race, Not Class, Dictates Republican Future",
		"title": "Race, Not Class, Dictates Republican Future",
		"type": "bs",
		"uuid": "bba847b7f2e9866b64ebbfea2c6c8b9e1423e974"
	},
	"-KhIgspVdKTMMhNNp7di": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:10.599+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07pqyvm"
				},
				"name": "White Men",
				"salience": 0.19593018,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026brmb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andy_Carroll"
				},
				"name": "Carroll",
				"salience": 0.124836184,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03qr3y2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Carroll_Dunham"
				},
				"name": "Carroll Dunham",
				"salience": 0.12397984,
				"type": "PERSON"
			},
			{
				"name": "extinction",
				"salience": 0.10063661,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0b3w054",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lena_Dunham"
				},
				"name": "Lena Dunham",
				"salience": 0.07810505,
				"type": "PERSON"
			},
			{
				"name": "Video",
				"salience": 0.04297425,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.036311667,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.034767196,
				"type": "PERSON"
			},
			{
				"name": "evolution",
				"salience": 0.032445382,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.024097688,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.023879996,
				"type": "PERSON"
			},
			{
				"name": "Charlie Nash",
				"salience": 0.020971578,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.020971578,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.017971627,
				"type": "WORK_OF_ART"
			},
			{
				"name": "support",
				"salience": 0.016243862,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.014084463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.010441686,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0086299535,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.007346056,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.006237899,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dad",
				"salience": 0.006193323,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0050920895,
				"type": "PERSON"
			},
			{
				"name": "guys",
				"salience": 0.0041405493,
				"type": "PERSON"
			},
			{
				"name": "males",
				"salience": 0.0041405493,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0041405493,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0038433555,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0038433555,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0038433555,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0035730791,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0035730791,
				"type": "PERSON"
			},
			{
				"name": "campaign trail",
				"salience": 0.0030947255,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0022649132,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0022548065,
				"type": "OTHER"
			},
			{
				"name": "animation",
				"salience": 0.0022548065,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0019058321,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0019058321,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0016847717,
				"type": "OTHER"
			},
			{
				"name": "Sophie Koko Gate",
				"salience": 0.0013882963,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:02:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Lena Dunham Posts Video Celebrating the‘Extinction of White Men’ on Twitter Charlie Nash, Breitbart, November 3, 2016 \nBoth Lena Dunham and her father, Carroll Dunham, expressed their support for “the extinction of white men” in a bizarre video posted to Dunham’s Twitter account on Wednesday. \n“How are you feeling about the extinction of white men?” Lena asks her father in the video. \n“Well, white men are a problem. Straight white men are a big problem, that’s for sure,” declared Carroll. \n“But I actually feel pretty good about it,” he continued. “I think straight white guys have been screwing things up for long enough. High time for straight white males to step back and let some other people do it.” \n“That’s my dad!” replied Lena, as Carroll laughed. \n{snip} \nLena Dunham has expressed monumental support for Democratic presidential candidate Hillary Clinton this year, even hitting the campaign trail in North Carolina to encourage young people to vote for Clinton . It’s not the end of men, it’s the evolution of men into better men. (beautiful animation by Sophie Koko Gate!) pic.twitter.com/Qtf0xyT5Ad",
		"thread_title": "Lena Dunham Posts Video Celebrating the ‘Extinction of White Men’ on Twitter",
		"title": "Lena Dunham Posts Video Celebrating the ‘Extinction of White Men’ on Twitter",
		"type": "bs",
		"uuid": "809ec10774b56cb95275246af9c293d51ac680ec"
	},
	"-KhIgt-Ak9aO_l_TaN9X": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:12.728+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07szy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Michigan"
				},
				"name": "University of Michigan",
				"salience": 0.28951308,
				"type": "ORGANIZATION"
			},
			{
				"name": "Derek Draplin",
				"salience": 0.17425917,
				"type": "PERSON"
			},
			{
				"name": "chief diversity officer",
				"salience": 0.06247547,
				"type": "PERSON"
			},
			{
				"name": "Chief Diversity Officer",
				"salience": 0.06096048,
				"type": "PERSON"
			},
			{
				"name": "inclusion",
				"salience": 0.05205208,
				"type": "OTHER"
			},
			{
				"name": "U-M's New",
				"salience": 0.030576875,
				"type": "ORGANIZATION"
			},
			{
				"name": "Michigan Capitol Confidential",
				"salience": 0.030576875,
				"type": "OTHER"
			},
			{
				"name": "U-M diversity plan",
				"salience": 0.02621329,
				"type": "OTHER"
			},
			{
				"name": "VPEI-CDO",
				"salience": 0.022603525,
				"type": "OTHER"
			},
			{
				"name": "job titles",
				"salience": 0.020554062,
				"type": "OTHER"
			},
			{
				"name": "Sellers",
				"salience": 0.0197352,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_frb_3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Schlissel"
				},
				"name": "Mark Schlissel",
				"salience": 0.015043905,
				"type": "PERSON"
			},
			{
				"name": "Robert Sellers",
				"salience": 0.014309471,
				"type": "PERSON"
			},
			{
				"name": "Sellers",
				"salience": 0.010922273,
				"type": "PERSON"
			},
			{
				"name": "vice provost for equity",
				"salience": 0.009464446,
				"type": "PERSON"
			},
			{
				"name": "position",
				"salience": 0.009112691,
				"type": "OTHER"
			},
			{
				"name": "chief diversity officer",
				"salience": 0.009112691,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.008728843,
				"type": "OTHER"
			},
			{
				"name": "vice provost",
				"salience": 0.007732786,
				"type": "PERSON"
			},
			{
				"name": "position",
				"salience": 0.007732786,
				"type": "OTHER"
			},
			{
				"name": "professor",
				"salience": 0.0074068354,
				"type": "PERSON"
			},
			{
				"name": "psychology",
				"salience": 0.0074068354,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0074068354,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.0074068354,
				"type": "ORGANIZATION"
			},
			{
				"name": "job",
				"salience": 0.0069843447,
				"type": "OTHER"
			},
			{
				"name": "appointment",
				"salience": 0.006127439,
				"type": "OTHER"
			},
			{
				"name": "capacity",
				"salience": 0.006050438,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.005709061,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0054273773,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0053868904,
				"type": "OTHER"
			},
			{
				"name": "teaching",
				"salience": 0.004522839,
				"type": "OTHER"
			},
			{
				"name": "scholarship",
				"salience": 0.004522839,
				"type": "OTHER"
			},
			{
				"name": "support innovation",
				"salience": 0.004522839,
				"type": "OTHER"
			},
			{
				"name": "university community",
				"salience": 0.004522839,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0040264656,
				"type": "OTHER"
			},
			{
				"name": "university",
				"salience": 0.0036360614,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.0032956917,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0032956917,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0032956917,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0032956917,
				"type": "OTHER"
			},
			{
				"name": "inclusion",
				"salience": 0.0031491222,
				"type": "OTHER"
			},
			{
				"name": "equity",
				"salience": 0.0031491222,
				"type": "OTHER"
			},
			{
				"name": "diversity plan",
				"salience": 0.00307035,
				"type": "OTHER"
			},
			{
				"name": "leadership voice",
				"salience": 0.0024626981,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ctrlg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vendor"
				},
				"name": "Sellers",
				"salience": 0.002239154,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:02:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "U-M’s New ‘Chief Diversity Officer’ Will Collect $385,000 per Year Derek Draplin, Michigan Capitol Confidential, October 28, 2016 \nThe University of Michigan’s new chief diversity officer will collect $385,000 a year under his various job titles, including a new one created by a recently revealed $85 million, five-year U-M diversity plan . \nRobert Sellers’ appointment to a new position called “vice provost for equity and inclusion and chief diversity officer” (VPEI-CDO) was approved Oct. 20 by the university’s governing board. Sellers previously served as “vice provost for equity and inclusion,” and is also listed as a professor of both psychology and education. In 2014-15 Sellers was paid $347,295 in his capacity as vice provost, a position created in 2014. \nPresident Mark Schlissel nominated Sellers for the job several weeks ago. The new full-time administrative position “will serve as a leadership voice on diversity, equity and inclusion for the entire university.” \nThe diversity plan Sellers will oversee will spend $17 million a year over the next five years. It seeks to “recruit, retain and develop a diverse university community” and “support innovation and inclusive scholarship and teaching” through a number of new and expanded programs. \nThe $85 million plan is in addition to the $40 million a year the university already spends promoting diversity. \n{snip}",
		"thread_title": "U-M’s New ‘Chief Diversity Officer’ Will Collect $385,000 per Year",
		"title": "U-M’s New ‘Chief Diversity Officer’ Will Collect $385,000 per Year",
		"type": "bs",
		"uuid": "3dbdd44d5f0ebef00bc0c98e53a90e8908772efc"
	},
	"-KhIgt7S4PXnXbij33Ps": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:15.136+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Patrick Gorman",
				"salience": 0.11167082,
				"type": "PERSON"
			},
			{
				"name": "killer",
				"salience": 0.08525883,
				"type": "PERSON"
			},
			{
				"name": "stranger",
				"salience": 0.07720244,
				"type": "PERSON"
			},
			{
				"name": "He Was The Best Man",
				"salience": 0.06216338,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Family Remembers Queens Sucker Punch Victim",
				"salience": 0.05394667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04xmfp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WCBS-TV"
				},
				"name": "CBS New York",
				"salience": 0.05394667,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.042555004,
				"type": "ORGANIZATION"
			},
			{
				"name": "assault",
				"salience": 0.04032127,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.039699256,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.03624551,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.031501528,
				"type": "PERSON"
			},
			{
				"name": "Jamaica Hospital",
				"salience": 0.026204992,
				"type": "LOCATION"
			},
			{
				"name": "suspects",
				"salience": 0.02145566,
				"type": "PERSON"
			},
			{
				"name": "connection",
				"salience": 0.018592067,
				"type": "OTHER"
			},
			{
				"name": "Authorities",
				"salience": 0.018592067,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.018416578,
				"type": "PERSON"
			},
			{
				"name": "game",
				"salience": 0.01790111,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.015729772,
				"type": "PERSON"
			},
			{
				"name": "bus home",
				"salience": 0.015452427,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.015066856,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.014516494,
				"type": "PERSON"
			},
			{
				"name": "corner",
				"salience": 0.0130529115,
				"type": "LOCATION"
			},
			{
				"name": "sucker punch attack",
				"salience": 0.012567106,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.012308109,
				"type": "WORK_OF_ART"
			},
			{
				"name": "police",
				"salience": 0.011858193,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.011026162,
				"type": "OTHER"
			},
			{
				"name": "surveillance video",
				"salience": 0.010442004,
				"type": "WORK_OF_ART"
			},
			{
				"name": "suspect",
				"salience": 0.010053106,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ccvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Queens"
				},
				"name": "Queens",
				"salience": 0.009899622,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.008035842,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.008035842,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.008035842,
				"type": "OTHER"
			},
			{
				"name": "stroke",
				"salience": 0.007969371,
				"type": "EVENT"
			},
			{
				"name": "brain hemorrhage",
				"salience": 0.007969371,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01d6g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltimore_Orioles"
				},
				"name": "Baltimore Orioles",
				"salience": 0.0077435034,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gvtrf7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Main_Street_(Queens)"
				},
				"name": "Main Street",
				"salience": 0.0065682284,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04mnqx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Queens_Boulevard"
				},
				"name": "Queens Boulevard",
				"salience": 0.0065682284,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.006406563,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ws7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Police"
				},
				"name": "Police",
				"salience": 0.006197143,
				"type": "PERSON"
			},
			{
				"name": "hair",
				"salience": 0.0058067506,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.004338903,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.004338903,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.004338903,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:01:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Family Remembers Queens Sucker Punch Victim ‘He Was The Best Man I Knew’ CBS New York, October 2, 2016 \nThe NYPD is looking for a killer who walked up to a stranger and punched him for apparently no reason. \nAuthorities are looking for two suspects in connection with the sucker punch attack of a Queens man just after midnight on June 26th. His family says he had taken a bus home after attending a Baltimore Orioles game. \nThe NYPD released new surveillance video Wednesday of the assault, which police said happened outside 64-year-old Patrick Gorman’s home on the corner of Queens Boulevard and Main Street just after midnight on June 26. \nIn the video, police said a man can be seen approaching Gorman and punching him in the head, knocking him to the ground. The man is then joined by a woman and calmly walks away as Gorman is seen struggling to get up. \nGorman was taken to Jamaica Hospital, where he died nine hours later after suffering a stroke and brain hemorrhage. {snip} Patrick Gorman \n{snip} \nPolice described the first suspect as a black man in his 30s with short hair. {snip} \n{snip}",
		"thread_title": "Family Remembers Queens Sucker Punch Victim ‘He Was The Best Man I Knew’",
		"title": "Family Remembers Queens Sucker Punch Victim ‘He Was The Best Man I Knew’",
		"type": "bs",
		"uuid": "0c4ece3343fc14de9d5c7ae5c0bd4f3e1bf228e5"
	},
	"-KhIgtP2Ad5WixVu8OLA": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:21.578+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/025qb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nigel_Farage"
				},
				"name": "Nigel Farage",
				"salience": 0.23719034,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/11bwfmmbjb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom_withdrawal_from_the_European_Union"
				},
				"name": "Brexit",
				"salience": 0.096399516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.09054657,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.059664123,
				"type": "LOCATION"
			},
			{
				"name": "Article",
				"salience": 0.028991098,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anger",
				"salience": 0.023817318,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.021524679,
				"type": "OTHER"
			},
			{
				"name": "exit",
				"salience": 0.021524679,
				"type": "LOCATION"
			},
			{
				"name": "public",
				"salience": 0.021524679,
				"type": "PERSON"
			},
			{
				"name": "Warns",
				"salience": 0.018660152,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.018660152,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.016137179,
				"type": "PERSON"
			},
			{
				"name": "ruling",
				"salience": 0.015607416,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.014888929,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0120ypxs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arron_Banks"
				},
				"name": "Arron Banks",
				"salience": 0.014260547,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rc3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/High_Court_of_Justice"
				},
				"name": "High Court",
				"salience": 0.012324076,
				"type": "ORGANIZATION"
			},
			{
				"name": "Public Anger' Following",
				"salience": 0.011517837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/054_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mirror"
				},
				"name": "Mirror",
				"salience": 0.011517837,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chris Kitching",
				"salience": 0.011517837,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.009562652,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01fvsv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UK_Independence_Party"
				},
				"name": "Ukip",
				"salience": 0.008353801,
				"type": "ORGANIZATION"
			},
			{
				"name": "Government",
				"salience": 0.0071106246,
				"type": "ORGANIZATION"
			},
			{
				"name": "betrayal",
				"salience": 0.00649514,
				"type": "OTHER"
			},
			{
				"name": "ruling",
				"salience": 0.006446683,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.006148804,
				"type": "ORGANIZATION"
			},
			{
				"name": "Article",
				"salience": 0.006148804,
				"type": "WORK_OF_ART"
			},
			{
				"name": "power",
				"salience": 0.005509883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/010p21z1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Suzanne_Evans"
				},
				"name": "Suzanne Evans",
				"salience": 0.0054274015,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0628_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Farron"
				},
				"name": "Tim Farron",
				"salience": 0.0046885572,
				"type": "PERSON"
			},
			{
				"name": "judges",
				"salience": 0.004688485,
				"type": "PERSON"
			},
			{
				"name": "Government",
				"salience": 0.004683073,
				"type": "ORGANIZATION"
			},
			{
				"name": "referendum",
				"salience": 0.004553733,
				"type": "OTHER"
			},
			{
				"name": "shock result",
				"salience": 0.004553733,
				"type": "OTHER"
			},
			{
				"name": "independence day",
				"salience": 0.004553733,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.004553733,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0041529215,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.004126057,
				"type": "ORGANIZATION"
			},
			{
				"name": "power grab",
				"salience": 0.004052454,
				"type": "OTHER"
			},
			{
				"name": "betrayal",
				"salience": 0.003964346,
				"type": "OTHER"
			},
			{
				"name": "horizon",
				"salience": 0.0039439066,
				"type": "OTHER"
			},
			{
				"name": "exit process",
				"salience": 0.0039439066,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.003828544,
				"type": "OTHER"
			},
			{
				"name": "judges",
				"salience": 0.003828544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025m87",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeremy_Corbyn"
				},
				"name": "Jeremy Corbyn",
				"salience": 0.0036631518,
				"type": "PERSON"
			},
			{
				"name": "anger",
				"salience": 0.0035372172,
				"type": "OTHER"
			},
			{
				"name": "ruling",
				"salience": 0.0034229609,
				"type": "OTHER"
			},
			{
				"name": "triggering",
				"salience": 0.0034053088,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0032347818,
				"type": "OTHER"
			},
			{
				"name": "judges",
				"salience": 0.00312612,
				"type": "PERSON"
			},
			{
				"name": "leadership",
				"salience": 0.00312612,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00312612,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.003074929,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0030226633,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0027661019,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.0027661019,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0027661019,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.0027661019,
				"type": "EVENT"
			},
			{
				"name": "class",
				"salience": 0.0026629171,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0026629171,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0026629171,
				"type": "OTHER"
			},
			{
				"name": "court ruling",
				"salience": 0.0025576144,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0024679396,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p5vf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Member_of_parliament"
				},
				"name": "MPs",
				"salience": 0.0024285018,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.0023574214,
				"type": "ORGANIZATION"
			},
			{
				"name": "parliament",
				"salience": 0.002335742,
				"type": "ORGANIZATION"
			},
			{
				"name": "parliament",
				"salience": 0.002335742,
				"type": "ORGANIZATION"
			},
			{
				"name": "delay",
				"salience": 0.0022685453,
				"type": "OTHER"
			},
			{
				"name": "favour",
				"salience": 0.0022584174,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0022584174,
				"type": "WORK_OF_ART"
			},
			{
				"name": "trick",
				"salience": 0.0022584174,
				"type": "OTHER"
			},
			{
				"name": "People power",
				"salience": 0.0021579037,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0021579037,
				"type": "PERSON"
			},
			{
				"name": "transparency",
				"salience": 0.0020930308,
				"type": "OTHER"
			},
			{
				"name": "ruling",
				"salience": 0.0020102444,
				"type": "OTHER"
			},
			{
				"name": "feeling",
				"salience": 0.001989552,
				"type": "OTHER"
			},
			{
				"name": "delay",
				"salience": 0.0019484458,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0019484458,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.001917191,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ruling",
				"salience": 0.0019108554,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v0gf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sevens_(card_game)"
				},
				"name": "Parliament",
				"salience": 0.0018933181,
				"type": "ORGANIZATION"
			},
			{
				"name": "Article",
				"salience": 0.0018456486,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01c9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Labour_Party_(UK)"
				},
				"name": "Labour",
				"salience": 0.0017491399,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0017029288,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.0016948325,
				"type": "EVENT"
			},
			{
				"name": "need",
				"salience": 0.0016872641,
				"type": "OTHER"
			},
			{
				"name": "accountability",
				"salience": 0.0016872641,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0016872641,
				"type": "OTHER"
			},
			{
				"name": "Spectator Parliamentary Awards",
				"salience": 0.0016393764,
				"type": "EVENT"
			},
			{
				"name": "timetable",
				"salience": 0.0014191874,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013964174,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0013273596,
				"type": "ORGANIZATION"
			},
			{
				"name": "democracy",
				"salience": 0.0012710089,
				"type": "OTHER"
			},
			{
				"name": "activist judges",
				"salience": 0.0012710089,
				"type": "PERSON"
			},
			{
				"name": "negotiating terms",
				"salience": 0.001266133,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0012289138,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.0012289138,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.0012289138,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0012289138,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0010472457,
				"type": "PERSON"
			},
			{
				"name": "trap",
				"salience": 0.0009781161,
				"type": "OTHER"
			},
			{
				"name": "party chair",
				"salience": 0.00091802026,
				"type": "PERSON"
			},
			{
				"name": "will",
				"salience": 0.00091802026,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fml",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberal_Party_(UK)"
				},
				"name": "Liberal",
				"salience": 0.0007563814,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.0006857544,
				"type": "OTHER"
			},
			{
				"name": "negotiating",
				"salience": 0.0006303112,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0005650016,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:01:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Nigel Farage Fears Brexit ‘Betrayal’ and Warns of ‘Public Anger’ Following Historic Article 50 Ruling Chris Kitching, Mirror, November 3, 2016 \nNigel Farage has warned fellow politicians that any attempt to block or delay Britain’s exit from the European Union will be met with untold anger from the public. \nIn a statement released after the historic High Court ruling on Article 50 the interim Ukip leader said he fears a Brexit “betrayal” is on the horizon. \nThe judges ruled that the government doesn’t have the power to trigger two-year exit process Article 50 without a vote by MPs. \nFarage campaigned vigorously for Brexit and declared the June 23 referendum Britain’s “independence day” after the shock result was confirmed. \nAfter the High Court ruling was announced on Thursday morning Farage said: “I worry that a betrayal may be near at hand. \n“Last night at the Spectator Parliamentary Awards I had a distinct feeling that our political class, who were out in force, do not accept the 23rd of June Referendum result. \n“I now fear that every attempt will be made to block or delay the triggering of Article 50 . \n“If this is so, they have no idea of the level of public anger they will provoke.” \nThree of England’s top judges gave the ruling after a costly three-day hearing. \nThe Government immediately announced it would appeal to the Supreme Court. \nUkip millionaire donor Arron Banks accused the “legal establishment” of “declaring war on British democracy”. \nHe added: “Parliament voted six-to-one in favour of letting the people decide. \n“They didn’t get the answer they wanted, and now they’re going to use every dirty trick in the book to try to sabotage, delay or water down Brexit.” \nUkip leadership hopeful Suzanne Evans blasted the judges and said the court ruling “undermines democracy”. \nThe former party chair urged the government to appeal. \nShe wrote on Twitter : “How dare these activist judges attempt to overturn our will? It’s a power grab & undermines democracy. Time we had the right to sack them. \n” Article 50 is an EU trap we must not fall in to. It will tie us into the EU for years. The government must appeal. People power must win.” \nLabour Leader Jeremy Corbyn said: “This ruling underlines the need for the Government to bring its negotiating terms to parliament without delay. \n“Labour respects the decision of the British people to leave the European Union. \n“But there must be transparency and accountability to parliament on the terms of Brexit . \n“Labour will be pressing the case for a Brexit that works for Britain, putting jobs, living standards and the economy first.” \nLiberal Democrats Leader Tim Farron welcomed the ruling. \nHe said: “Given the strict two year timetable of exiting the EU once Article 50 is triggered, it is critical that the government now lay out their negotiating to Parliament, before such a vote is held.”",
		"thread_title": "Nigel Farage Fears Brexit ‘Betrayal’ and Warns of ‘Public Anger’ Following Historic Article 50 Ruling",
		"title": "Nigel Farage Fears Brexit ‘Betrayal’ and Warns of ‘Public Anger’ Following Historic Article 50 Ruling",
		"type": "bs",
		"uuid": "eedab87d518811b62c0c95ea4854f9aabd722bef"
	},
	"-KhIgtUFUvnwlReUmmED": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:24.946+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.17150731,
				"type": "LOCATION"
			},
			{
				"name": "mosques",
				"salience": 0.13251117,
				"type": "LOCATION"
			},
			{
				"name": "Mosques for Promoting 'Radical Ideology",
				"salience": 0.09332206,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "AP",
				"salience": 0.08115842,
				"type": "ORGANIZATION"
			},
			{
				"name": "closure",
				"salience": 0.07784831,
				"type": "EVENT"
			},
			{
				"name": "interior minister",
				"salience": 0.054778494,
				"type": "PERSON"
			},
			{
				"name": "ideology",
				"salience": 0.04741091,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.04001859,
				"type": "LOCATION"
			},
			{
				"name": "shutdowns",
				"salience": 0.037197582,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.037197582,
				"type": "OTHER"
			},
			{
				"name": "state of emergency",
				"salience": 0.032551043,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.023890024,
				"type": "LOCATION"
			},
			{
				"name": "closing",
				"salience": 0.018717535,
				"type": "EVENT"
			},
			{
				"name": "risks",
				"salience": 0.017496081,
				"type": "OTHER"
			},
			{
				"name": "worship",
				"salience": 0.016220948,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.01400365,
				"type": "LOCATION"
			},
			{
				"name": "cover",
				"salience": 0.01213313,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.01213313,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.01213313,
				"type": "EVENT"
			},
			{
				"name": "reality",
				"salience": 0.01213313,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.011305467,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.010211105,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.008885181,
				"type": "WORK_OF_ART"
			},
			{
				"name": "violence",
				"salience": 0.006612115,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.006612115,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.006612115,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.0053996695,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:01:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "France Closes 4 Mosques for Promoting ‘Radical Ideology’ AP, November 2, 2016 \nFrance’s interior minister has ordered the closure of four mosques that allegedly espoused a ‘radical ideology,’ the latest such shutdowns among dozens since the Nov. 13 Paris attacks nearly a year ago. \nA state of emergency in France allows for the closing of places of worship where the preaching risks provoking hate, violence or acts of terrorism. \n{snip} \n“Under cover of religion, these places held meetings that in reality were aimed at promoting a radical ideology,” the statement said. \n{snip}",
		"thread_title": "France Closes 4 Mosques for Promoting ‘Radical Ideology’",
		"title": "France Closes 4 Mosques for Promoting ‘Radical Ideology’",
		"type": "bs",
		"uuid": "5c3b0aec59d9873814c1383f82114257cec2cb79"
	},
	"-KhIgtypsWH6piMc9HYA": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:36.124+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02r8fzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Savile_Town"
				},
				"name": "Savile Town",
				"salience": 0.13093193,
				"type": "LOCATION"
			},
			{
				"name": "Mufti Mohammed Pandor",
				"salience": 0.10273426,
				"type": "PERSON"
			},
			{
				"name": "Lorraine Matthews",
				"salience": 0.03382385,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.025466343,
				"type": "OTHER"
			},
			{
				"name": "passers",
				"salience": 0.023545189,
				"type": "PERSON"
			},
			{
				"name": "Jean Wood",
				"salience": 0.022535313,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.02104185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.021034889,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0134bf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Yorkshire"
				},
				"name": "Yorkshire",
				"salience": 0.018378174,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hb7w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deobandi"
				},
				"name": "Deobandis",
				"salience": 0.01828856,
				"type": "OTHER"
			},
			{
				"name": "Sue Reid",
				"salience": 0.016399907,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.016194936,
				"type": "LOCATION"
			},
			{
				"name": "mosque",
				"salience": 0.014994847,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.013329781,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.013137169,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.012292697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06x91h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohammad_Sidique_Khan"
				},
				"name": "Mohammed Sidique Khan",
				"salience": 0.010299303,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.008997334,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.008874224,
				"type": "LOCATION"
			},
			{
				"name": "wives",
				"salience": 0.0080614835,
				"type": "PERSON"
			},
			{
				"name": "wife",
				"salience": 0.0070812167,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03c_v10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Owen_Bennett-Jones"
				},
				"name": "Owen Bennett-Jones",
				"salience": 0.006748944,
				"type": "PERSON"
			},
			{
				"name": "burkas",
				"salience": 0.006638248,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.006127101,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.005843733,
				"type": "LOCATION"
			},
			{
				"name": "Go Away",
				"salience": 0.0057745506,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0055328403,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0055328403,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.0051863804,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0051863804,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.004904738,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.004791691,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.004791691,
				"type": "OTHER"
			},
			{
				"name": "corner shops",
				"salience": 0.0044653346,
				"type": "LOCATION"
			},
			{
				"name": "followers",
				"salience": 0.0044409335,
				"type": "PERSON"
			},
			{
				"name": "The Corner of Yorkshire That",
				"salience": 0.004439637,
				"type": "WORK_OF_ART"
			},
			{
				"name": "faces",
				"salience": 0.004326787,
				"type": "OTHER"
			},
			{
				"name": "veils",
				"salience": 0.004326787,
				"type": "OTHER"
			},
			{
				"name": "sect",
				"salience": 0.004326787,
				"type": "OTHER"
			},
			{
				"name": "gowns",
				"salience": 0.004326787,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "contact",
				"salience": 0.0040945904,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0138kk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dewsbury"
				},
				"name": "Dewsbury",
				"salience": 0.0040320726,
				"type": "ORGANIZATION"
			},
			{
				"name": "preachers",
				"salience": 0.003747017,
				"type": "PERSON"
			},
			{
				"name": "chatter",
				"salience": 0.003747017,
				"type": "OTHER"
			},
			{
				"name": "tongue",
				"salience": 0.003747017,
				"type": "OTHER"
			},
			{
				"name": "suburb",
				"salience": 0.003747017,
				"type": "LOCATION"
			},
			{
				"name": "gaps",
				"salience": 0.003747017,
				"type": "OTHER"
			},
			{
				"name": "Lots",
				"salience": 0.003747017,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.003747017,
				"type": "EVENT"
			},
			{
				"name": "person",
				"salience": 0.003747017,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.003747017,
				"type": "OTHER"
			},
			{
				"name": "canal path",
				"salience": 0.003747017,
				"type": "OTHER"
			},
			{
				"name": "flat",
				"salience": 0.003747017,
				"type": "LOCATION"
			},
			{
				"name": "heritage",
				"salience": 0.003747017,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.003747017,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0034882252,
				"type": "OTHER"
			},
			{
				"name": "jihadists",
				"salience": 0.0034501725,
				"type": "PERSON"
			},
			{
				"name": "mills",
				"salience": 0.0033638147,
				"type": "LOCATION"
			},
			{
				"name": "newcomers",
				"salience": 0.003321449,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.003266434,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.0031801204,
				"type": "PERSON"
			},
			{
				"name": "textile town",
				"salience": 0.0031544394,
				"type": "LOCATION"
			},
			{
				"name": "glimpse",
				"salience": 0.003137799,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0031143464,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0030870314,
				"type": "OTHER"
			},
			{
				"name": "bombers",
				"salience": 0.0026895863,
				"type": "PERSON"
			},
			{
				"name": "Don't Come Back",
				"salience": 0.0026638443,
				"type": "OTHER"
			},
			{
				"name": "forebears",
				"salience": 0.0026275562,
				"type": "PERSON"
			},
			{
				"name": "lads",
				"salience": 0.0024343354,
				"type": "PERSON"
			},
			{
				"name": "burka",
				"salience": 0.0023340278,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/083jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White"
				},
				"name": "White",
				"salience": 0.0023067512,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.0023067512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.0023067512,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.0023067512,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.0023067512,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.0022786201,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sycg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Asian"
				},
				"name": "Asian",
				"salience": 0.0022506162,
				"type": "LOCATION"
			},
			{
				"name": "madrasah school",
				"salience": 0.0022421223,
				"type": "LOCATION"
			},
			{
				"name": "girl",
				"salience": 0.0022421223,
				"type": "PERSON"
			},
			{
				"name": "customers",
				"salience": 0.0022421223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/096tx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quran"
				},
				"name": "Koran",
				"salience": 0.0022222619,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0021358083,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.0021358083,
				"type": "PERSON"
			},
			{
				"name": "terrace streets",
				"salience": 0.0021358083,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0021358083,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0021358083,
				"type": "PERSON"
			},
			{
				"name": "burkas",
				"salience": 0.0021358083,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.002098033,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.002098033,
				"type": "LOCATION"
			},
			{
				"name": "breakdown",
				"salience": 0.0020390588,
				"type": "EVENT"
			},
			{
				"name": "window",
				"salience": 0.0019731373,
				"type": "OTHER"
			},
			{
				"name": "lessons",
				"salience": 0.0019256676,
				"type": "OTHER"
			},
			{
				"name": "teenager",
				"salience": 0.0019151827,
				"type": "PERSON"
			},
			{
				"name": "homes",
				"salience": 0.0018677074,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.0018209377,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.001781555,
				"type": "OTHER"
			},
			{
				"name": "blonde",
				"salience": 0.001781555,
				"type": "OTHER"
			},
			{
				"name": "ladies",
				"salience": 0.001781555,
				"type": "PERSON"
			},
			{
				"name": "census",
				"salience": 0.001781555,
				"type": "OTHER"
			},
			{
				"name": "opposite",
				"salience": 0.001781555,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.001781555,
				"type": "LOCATION"
			},
			{
				"name": "census",
				"salience": 0.001781555,
				"type": "OTHER"
			},
			{
				"name": "alcohol",
				"salience": 0.001781555,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.0017621105,
				"type": "PERSON"
			},
			{
				"name": "terrace house",
				"salience": 0.0016875356,
				"type": "LOCATION"
			},
			{
				"name": "backgrounds",
				"salience": 0.0016858809,
				"type": "OTHER"
			},
			{
				"name": "clerics",
				"salience": 0.0016538559,
				"type": "PERSON"
			},
			{
				"name": "mosque",
				"salience": 0.0016245437,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0015976537,
				"type": "LOCATION"
			},
			{
				"name": "line",
				"salience": 0.001542681,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.001542681,
				"type": "OTHER"
			},
			{
				"name": "strictures",
				"salience": 0.001542681,
				"type": "OTHER"
			},
			{
				"name": "dentist",
				"salience": 0.001542681,
				"type": "PERSON"
			},
			{
				"name": "grid",
				"salience": 0.001542681,
				"type": "OTHER"
			},
			{
				"name": "labour",
				"salience": 0.001542681,
				"type": "EVENT"
			},
			{
				"name": "jobs",
				"salience": 0.001542681,
				"type": "OTHER"
			},
			{
				"name": "arrivals",
				"salience": 0.001542681,
				"type": "PERSON"
			},
			{
				"name": "perfumes",
				"salience": 0.001542681,
				"type": "OTHER"
			},
			{
				"name": "prayer mats",
				"salience": 0.001542681,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "women",
				"salience": 0.0015380154,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0015380154,
				"type": "LOCATION"
			},
			{
				"name": "detachment",
				"salience": 0.0015232415,
				"type": "OTHER"
			},
			{
				"name": "mobile butcher",
				"salience": 0.0015040468,
				"type": "PERSON"
			},
			{
				"name": "Life",
				"salience": 0.0014975026,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0014416012,
				"type": "LOCATION"
			},
			{
				"name": "strangers",
				"salience": 0.001420395,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.0013834275,
				"type": "PERSON"
			},
			{
				"name": "robes",
				"salience": 0.0013317829,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hair salon",
				"salience": 0.0013249078,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.0013042545,
				"type": "PERSON"
			},
			{
				"name": "houses",
				"salience": 0.0012766988,
				"type": "LOCATION"
			},
			{
				"name": "followers",
				"salience": 0.0012659088,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0012490825,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0012490825,
				"type": "OTHER"
			},
			{
				"name": "suicide bombers",
				"salience": 0.0012490825,
				"type": "PERSON"
			},
			{
				"name": "spokesman",
				"salience": 0.0012490825,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0012490825,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0012490825,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jlhz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC_Radio_4"
				},
				"name": "Radio 4",
				"salience": 0.0012401292,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.0012224889,
				"type": "OTHER"
			},
			{
				"name": "Muslim",
				"salience": 0.0012224889,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britons",
				"salience": 0.0012144675,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0012144675,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.0012144675,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.0012024513,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0012024513,
				"type": "WORK_OF_ART"
			},
			{
				"name": "alcohol",
				"salience": 0.0012024513,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ladies",
				"salience": 0.0012024513,
				"type": "PERSON"
			},
			{
				"name": "homes",
				"salience": 0.0011982548,
				"type": "LOCATION"
			},
			{
				"name": "TV",
				"salience": 0.0011670976,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.0011523893,
				"type": "OTHER"
			},
			{
				"name": "music",
				"salience": 0.0011378663,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lady",
				"salience": 0.0010953858,
				"type": "PERSON"
			},
			{
				"name": "followers",
				"salience": 0.0010871937,
				"type": "PERSON"
			},
			{
				"name": "buses",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "explosions",
				"salience": 0.0010815808,
				"type": "EVENT"
			},
			{
				"name": "programme",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "trains",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "farewell",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "folk",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "enclave",
				"salience": 0.0010815808,
				"type": "LOCATION"
			},
			{
				"name": "torrent",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "trickle",
				"salience": 0.0010815808,
				"type": "OTHER"
			},
			{
				"name": "perms",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "pubs",
				"salience": 0.001041201,
				"type": "LOCATION"
			},
			{
				"name": "flesh",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "hijab",
				"salience": 0.001041201,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "park",
				"salience": 0.001041201,
				"type": "LOCATION"
			},
			{
				"name": "lamb",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "playing",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "divorce",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "ostrich",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "boys",
				"salience": 0.001041201,
				"type": "PERSON"
			},
			{
				"name": "court",
				"salience": 0.001041201,
				"type": "ORGANIZATION"
			},
			{
				"name": "disputes",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "grocery",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "clothes",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "nowhere",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "van",
				"salience": 0.001041201,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "justice code",
				"salience": 0.001041201,
				"type": "OTHER"
			},
			{
				"name": "ice creams",
				"salience": 0.001041201,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "worshippers",
				"salience": 0.001041201,
				"type": "PERSON"
			},
			{
				"name": "bloke opposite",
				"salience": 0.0010390979,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0010290879,
				"type": "LOCATION"
			},
			{
				"name": "light",
				"salience": 0.0010280787,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0010196771,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0010196771,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0010196771,
				"type": "PERSON"
			},
			{
				"name": "sect",
				"salience": 0.0010196771,
				"type": "PERSON"
			},
			{
				"name": "kitchen",
				"salience": 0.0010196771,
				"type": "LOCATION"
			},
			{
				"name": "reporter",
				"salience": 0.0010196771,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03k6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Lords"
				},
				"name": "House of Lords",
				"salience": 0.0009998687,
				"type": "ORGANIZATION"
			},
			{
				"name": "veil",
				"salience": 0.000994137,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0009816078,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0009742665,
				"type": "PERSON"
			},
			{
				"name": "shops",
				"salience": 0.0009692364,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bs7l_v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistanis"
				},
				"name": "Pakistani",
				"salience": 0.0009494755,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03kbr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hindu"
				},
				"name": "Hindus",
				"salience": 0.0009494755,
				"type": "OTHER"
			},
			{
				"name": "mosques",
				"salience": 0.0009416612,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.00092979317,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.00092979317,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.00091318286,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00091318286,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00091318286,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.00090105156,
				"type": "OTHER"
			},
			{
				"name": "attackers",
				"salience": 0.0008942008,
				"type": "PERSON"
			},
			{
				"name": "thinking",
				"salience": 0.00088293076,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.00088293076,
				"type": "PERSON"
			},
			{
				"name": "passport checks",
				"salience": 0.00088293076,
				"type": "OTHER"
			},
			{
				"name": "airports",
				"salience": 0.00088293076,
				"type": "LOCATION"
			},
			{
				"name": "adviser",
				"salience": 0.00088293076,
				"type": "PERSON"
			},
			{
				"name": "universities",
				"salience": 0.00088293076,
				"type": "ORGANIZATION"
			},
			{
				"name": "higher education institutions",
				"salience": 0.00088293076,
				"type": "ORGANIZATION"
			},
			{
				"name": "style",
				"salience": 0.00088293076,
				"type": "OTHER"
			},
			{
				"name": "basics",
				"salience": 0.00088293076,
				"type": "OTHER"
			},
			{
				"name": "turn",
				"salience": 0.00088293076,
				"type": "OTHER"
			},
			{
				"name": "preserve",
				"salience": 0.00088293076,
				"type": "OTHER"
			},
			{
				"name": "goat",
				"salience": 0.00087180274,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0008436085,
				"type": "OTHER"
			},
			{
				"name": "robes",
				"salience": 0.0008436085,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "children",
				"salience": 0.0008436085,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.0008436085,
				"type": "OTHER"
			},
			{
				"name": "cultures",
				"salience": 0.0008436085,
				"type": "OTHER"
			},
			{
				"name": "repercussions",
				"salience": 0.00080791797,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00078845385,
				"type": "LOCATION"
			},
			{
				"name": "few",
				"salience": 0.0007616738,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0007616738,
				"type": "PERSON"
			},
			{
				"name": "door",
				"salience": 0.00072449923,
				"type": "OTHER"
			},
			{
				"name": "suspicions",
				"salience": 0.00066793984,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.0006656472,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f1_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gujarat"
				},
				"name": "Gujarat",
				"salience": 0.0006656472,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0006656472,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04jgv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London_Underground"
				},
				"name": "Tube",
				"salience": 0.0006656472,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.0006656472,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.0006656472,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0006650329,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.0006650329,
				"type": "OTHER"
			},
			{
				"name": "lifetime",
				"salience": 0.0006650329,
				"type": "OTHER"
			},
			{
				"name": "knock",
				"salience": 0.0006595209,
				"type": "OTHER"
			},
			{
				"name": "cash",
				"salience": 0.0006595209,
				"type": "OTHER"
			},
			{
				"name": "bags",
				"salience": 0.0006595209,
				"type": "OTHER"
			},
			{
				"name": "retirement",
				"salience": 0.0006595209,
				"type": "EVENT"
			},
			{
				"name": "kind",
				"salience": 0.0006595209,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0006595209,
				"type": "PERSON"
			},
			{
				"name": "places",
				"salience": 0.0006595209,
				"type": "LOCATION"
			},
			{
				"name": "omens",
				"salience": 0.0006595209,
				"type": "OTHER"
			},
			{
				"name": "edge",
				"salience": 0.0006595209,
				"type": "OTHER"
			},
			{
				"name": "faiths",
				"salience": 0.0006595209,
				"type": "OTHER"
			},
			{
				"name": "kitchen table",
				"salience": 0.0006595209,
				"type": "OTHER"
			},
			{
				"name": "tea",
				"salience": 0.0006512081,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00064079295,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/074hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sharia"
				},
				"name": "Sharia",
				"salience": 0.00064079295,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.0006214052,
				"type": "ORGANIZATION"
			},
			{
				"name": "door",
				"salience": 0.0006143614,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.00061393215,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.00059587875,
				"type": "PERSON"
			},
			{
				"name": "cap",
				"salience": 0.0005809518,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0005598085,
				"type": "LOCATION"
			},
			{
				"name": "mosque",
				"salience": 0.0005598085,
				"type": "OTHER"
			},
			{
				"name": "note",
				"salience": 0.0005546885,
				"type": "OTHER"
			},
			{
				"name": "wads",
				"salience": 0.00055221014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/066dv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Prophet"
				},
				"name": "Prophet",
				"salience": 0.00054337806,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020d8d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bradford"
				},
				"name": "Bradford",
				"salience": 0.00054337806,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/013wf1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huddersfield"
				},
				"name": "Huddersfield",
				"salience": 0.00054337806,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.00052998256,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0004967502,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0004967502,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0004967502,
				"type": "WORK_OF_ART"
			},
			{
				"name": "community",
				"salience": 0.0004967502,
				"type": "OTHER"
			},
			{
				"name": "burkas",
				"salience": 0.0004967502,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0004967502,
				"type": "PERSON"
			},
			{
				"name": "flight",
				"salience": 0.00048642317,
				"type": "OTHER"
			},
			{
				"name": "note",
				"salience": 0.00048244745,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.0004802918,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0004802918,
				"type": "OTHER"
			},
			{
				"name": "divide",
				"salience": 0.0004802918,
				"type": "OTHER"
			},
			{
				"name": "uncle",
				"salience": 0.0004802918,
				"type": "PERSON"
			},
			{
				"name": "loss",
				"salience": 0.0004802918,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0004802918,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0004802918,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0004802918,
				"type": "OTHER"
			},
			{
				"name": "neighbour",
				"salience": 0.0004802918,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0004763662,
				"type": "OTHER"
			},
			{
				"name": "windows",
				"salience": 0.0004588991,
				"type": "OTHER"
			},
			{
				"name": "robes",
				"salience": 0.0004588991,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "corners",
				"salience": 0.0004588991,
				"type": "OTHER"
			},
			{
				"name": "tale",
				"salience": 0.00044509282,
				"type": "WORK_OF_ART"
			},
			{
				"name": "some",
				"salience": 0.0004168949,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.00041432443,
				"type": "OTHER"
			},
			{
				"name": "canal",
				"salience": 0.00041432443,
				"type": "LOCATION"
			},
			{
				"name": "surprise",
				"salience": 0.00041432443,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.00041432443,
				"type": "OTHER"
			},
			{
				"name": "jeans",
				"salience": 0.00041432443,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01mw2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kafir"
				},
				"name": "non-Muslim",
				"salience": 0.00040587576,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00037742546,
				"type": "OTHER"
			},
			{
				"name": "behaviour",
				"salience": 0.0003587519,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0003587519,
				"type": "OTHER"
			},
			{
				"name": "mosque entrance",
				"salience": 0.0003587519,
				"type": "OTHER"
			},
			{
				"name": "directions",
				"salience": 0.0003587519,
				"type": "OTHER"
			},
			{
				"name": "South Street",
				"salience": 0.00030569945,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:01:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 27.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Loading Posted on November 3, 2016 ‘Go Away, You Shouldn’t Be Here. Don’t Come Back’: The Corner of Yorkshire That Has Almost No White Residents Sue Reid, Daily Mail, November 3, 2016 \nFrom the window of her flat overlooking the canal path in a suburb of Dewsbury in Yorkshire, a blonde woman watches two female figures walking past as they chatter in a foreign tongue. \nBoth the passers-by are covered in black Islamic gowns, only a glimpse of their eyes show from in the two gaps in the veils across their faces. \nThey, like many Muslim women who live here, speak little or no English. Lots of them will have no contact with any person from another religion or culture. Almost all have been brought to the UK to wed the British men of south Asian heritage who have made this area their home. \nThe wives have restricted lives: bringing up children, cooking for families, or going to women-only events at the huge local mosque run by the Deobandis, a powerful sect of Islam whose most outspoken preachers have urged followers not to mix with Christians, Jews or Hindus. \nWe are in Savile Town, one of the most racially homogeneous parts of Britain: not because everyone is an indigenous Yorkshire man or woman, but exactly the opposite. \nIn fact there are almost no white residents to be found in Savile Town. Astonishingly, a detailed breakdown of the last census of 2011 recorded that only 48 of the 4,033 people living here were white British. \nThis would not surprise the blonde Lorraine Matthews, looking out at the ladies in burkas from her window. She is a 53-year-old dentist’s receptionist, one of the handful of white Britons left in Savile Town’s grid of terrace streets. Almost all the other residents, according to that census, have Pakistani or Indian backgrounds. \nTheir forebears were enticed to Savile Town as cheap labour for back-breaking jobs in the woollen mills which had made Dewsbury a renowned textile town. \nThese hard-working newcomers bought their own homes, and opened corner shops that sold burkas, prayer mats and perfumes that contained no alcohol, in line with the strictures of the Koran. \nSoon the new arrivals had built the mosque which is designed to accommodate 4,000 worshippers. Today, a Sharia court nearby–criticised in a House of Lords report for discriminating against women in divorce and matrimonial disputes–does brisk business espousing the strict Islamic justice code. \nEven the lady selling ice creams from a van during the summer wears a burka, and the mobile butcher going round the streets offers only halal goat, lamb and ostrich. \nStand in Savile Town, as I have, and you will see scores of boys in Islamic robes walking to and from lessons at the mosque’s madrasah school, where for hours at a time they rote-learn the Koran by heart. \nAnd, distressingly, every girl I saw–even those of six and seven playing in the park–was wrapped up in a hijab and shoulder-to-toe-gown lest a man glimpse her flesh. \nEight of the nine pubs in the area have shut because there are hardly any local customers who drink alcohol. The hair salon, once giving stern perms to Yorkshire ladies, closed down long ago, the Western grocery and clothes shops, too. \nNeedless to say, with nowhere to socialise or shop for what they like, the local white folk departed, first in a trickle, then a torrent. \nSavile Town was left to become an ethnic enclave. And it seems that this detachment from mainstream society had disturbing repercussions. For this small area has produced several young jihadists who disappeared to fight–and die as suicide bombers–for Islamic State in the Middle East. \n(Mohammed Sidique Khan, the leader of the bombers who attacked London on July 7, 2005, was brought up nearby. He bade farewell to his pregnant wife at their terrace house before leading his fellow attackers to the capital to claim 52 innocent lives in explosions on Tube trains and buses.) \nLife in Savile Town was investigated earlier this year by Owen Bennett-Jones, the BBC’s former Pakistan correspondent, who threw light on the influence of the Deobandi movement over the Muslim population here. \nInterviewed for the Radio 4 programme was Mufti Mohammed Pandor, a civil servant and spokesman for the Deobandis. He arrived from India’s Gujarat in 1964 as a small child with his family. \nHe lives near Savile Town, and would call himself a British Muslim. Yet he refused to let interviewer Bennett-Jones see his wife when the reporter visited the couple’s home, although she was permitted to make the tea in the kitchen. \nPandor insists she is completely covered at almost all times, allowing her only to raise her veil for passport checks at airports. His family rarely watches British TV and says all music is un-Islamic. \nDespite being a religious adviser to two universities–Bradford and Huddersfield–he told the BBC that Muslim men should only be permitted to enter higher education institutions to study and pray, and ‘not to look at women’. \n‘If Mohammed did not do it, we don’t do it,’ Pandor told the BBC, saying the Deobandi are a ‘back to basics’ movement whose followers live in the style of the Prophet’s life, 14 centuries ago. \nYou might dismiss such desperately backward thinking as being the preserve of a small outlandish sect, but the Deobandis run nearly half the 1,600 registered UK mosques, and train 80 per cent of all domestic Islamic clerics who, in turn, play a huge part in influencing the growing population of British Muslims. \nPerhaps it’s little surprise that the few indigenous Yorkshire people remaining in Savile Town feel somewhat beleaguered. \nLorraine Matthews, in the house near the canal, is outspoken in her comments about the community in which she now lives: ‘I wouldn’t go out at night on my own as it is dangerous if you’re not from the Muslim community. It isn’t sensible for a woman to walk there after dark. The Asian lads gather on the corners, they make you feel intimidated because they don’t respect white women.’ \nWhen I myself walked down South Street towards the mosque, figures in burkas peered out of their lace-curtained windows in surprise at seeing an uncovered woman’s face. \nI asked one tall teenager, wearing an Islamic cap and white robes over his jeans, for directions to the mosque entrance. His response was to spit at me and shout: ‘Go away, you shouldn’t be here. Don’t come back.’ \nIt is depressing to be confronted with such aggression. And I’ve no doubt many Muslims, too, will feel distressed at such behaviour. Not all British followers of Islam wish to live in areas where people of other faiths or cultures might fear to tread. \nYet in places such as Savile Town, the omens are not good. \nFor however unpalatable it may be to British liberals, the fact is that many Muslims here only want to live with those from their own culture. \nIndeed, some of the few remaining non-Muslim residents say they are regularly targeted by members of the local Islamic community who want to buy their houses. \nSome have even received a knock on the door from complete strangers in religious robes offering wads of cash in plastic bags to purchase their homes. \nYorkshire-born Jean Wood, 76, a church-goer, is one long-time resident who feels that she is being edged out. Her children beg her to move to an area where she can share her retirement with the kind of people she grew up with. \nAt her neat home on the edge of Savile Town, she told me the tale of what happened a day after her husband died suddenly while sitting at the kitchen table. \n‘He had not gone 24 hours when a Muslim neighbour pushed a note through the door saying she wanted to buy this house,’ she remembers. ‘We had lived here all our married life. I was grieving, although the note did not mention my loss. \n‘But I gathered my strength. I phoned the number on the piece of paper and said my home was not for sale and never would be in my lifetime.’ \nThey were brave words, but–inevitably–the Deobandis’ spokesman Mufti Pandor views it differently. \nHe described, on Radio 4, how ‘white flight’ ensued when his family came to Savile Town. ‘Who was going to buy the house next door to us?’ said Pandor. ‘It certainly wasn’t going to be a white guy . . . so my uncle bought it. Then there were two of us. So then guess what happened? The bloke opposite said: ‘Bugger this, I’m going’–so he left.’ \nIt’s not hard to see why, with suspicions running deep on both sides of the cultural divide, Savile Town is, for good or bad, changing for ever.",
		"thread_title": "‘Go Away, You Shouldn’t Be Here. Don’t Come Back’: The Corner of Yorkshire That Has Almost No White Residents",
		"title": "‘Go Away, You Shouldn’t Be Here. Don’t Come Back’: The Corner of Yorkshire That Has Almost No White Residents",
		"type": "bs",
		"uuid": "86a3fc5a75725c9014463b584fddc2adb898561e"
	},
	"-KhIguHQPwXFOT9We9R9": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T14:13:38.725+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.24382909,
				"type": "LOCATION"
			},
			{
				"name": "Hundreds",
				"salience": 0.076692574,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.07647589,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.057648983,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.033734962,
				"type": "EVENT"
			},
			{
				"name": "Julian Robinson",
				"salience": 0.030974574,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qg4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Hollande"
				},
				"name": "Francois Hollande",
				"salience": 0.02248953,
				"type": "PERSON"
			},
			{
				"name": "camps",
				"salience": 0.021250304,
				"type": "LOCATION"
			},
			{
				"name": "Migrants",
				"salience": 0.0194516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.016491167,
				"type": "LOCATION"
			},
			{
				"name": "Hundreds",
				"salience": 0.0158568,
				"type": "PERSON"
			},
			{
				"name": "Treatment",
				"salience": 0.014429349,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.014429349,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.014429349,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qdcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Party_(France)"
				},
				"name": "Socialists",
				"salience": 0.0111512365,
				"type": "PERSON"
			},
			{
				"name": "march",
				"salience": 0.011090489,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.008854216,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghans",
				"salience": 0.0077597597,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.0077120783,
				"type": "ORGANIZATION"
			},
			{
				"name": "Migrants Protest",
				"salience": 0.0077120783,
				"type": "EVENT"
			},
			{
				"name": "Peter Allen",
				"salience": 0.0077120783,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0073898416,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0073898416,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.0073421155,
				"type": "EVENT"
			},
			{
				"name": "centre",
				"salience": 0.006932759,
				"type": "LOCATION"
			},
			{
				"name": "pavements",
				"salience": 0.006775329,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.006401465,
				"type": "OTHER"
			},
			{
				"name": "speaker",
				"salience": 0.006401465,
				"type": "PERSON"
			},
			{
				"name": "human",
				"salience": 0.006401465,
				"type": "PERSON"
			},
			{
				"name": "encampment",
				"salience": 0.006401465,
				"type": "LOCATION"
			},
			{
				"name": "destruction",
				"salience": 0.0060733347,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.0051944503,
				"type": "EVENT"
			},
			{
				"name": "beast",
				"salience": 0.0049076225,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/g/11btw_7mgd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais_jungle"
				},
				"name": "Calais Jungle",
				"salience": 0.004857801,
				"type": "LOCATION"
			},
			{
				"name": "activists",
				"salience": 0.004784934,
				"type": "PERSON"
			},
			{
				"name": "Jean Brossard",
				"salience": 0.0047377096,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.0044979346,
				"type": "EVENT"
			},
			{
				"name": "migrants",
				"salience": 0.0041145086,
				"type": "PERSON"
			},
			{
				"name": "sticks",
				"salience": 0.003957251,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.0036841235,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0036628451,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.003651749,
				"type": "PERSON"
			},
			{
				"name": "Stalingrad Metro station",
				"salience": 0.0035662574,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.003373889,
				"type": "PERSON"
			},
			{
				"name": "centre",
				"salience": 0.0032029545,
				"type": "ORGANIZATION"
			},
			{
				"name": "centre",
				"salience": 0.0031832322,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.0031550454,
				"type": "LOCATION"
			},
			{
				"name": "camps",
				"salience": 0.0031550454,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0030465885,
				"type": "LOCATION"
			},
			{
				"name": "riot police",
				"salience": 0.0030465885,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighting",
				"salience": 0.0030465885,
				"type": "EVENT"
			},
			{
				"name": "refugee camp",
				"salience": 0.003037383,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.0029443903,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01y3fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jungle"
				},
				"name": "Jungle",
				"salience": 0.0029443903,
				"type": "LOCATION"
			},
			{
				"name": "resettlement centres",
				"salience": 0.002913086,
				"type": "LOCATION"
			},
			{
				"name": "centres",
				"salience": 0.002894234,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0027783026,
				"type": "PERSON"
			},
			{
				"name": "gangs",
				"salience": 0.0026384075,
				"type": "PERSON"
			},
			{
				"name": "site",
				"salience": 0.0026384075,
				"type": "LOCATION"
			},
			{
				"name": "wake",
				"salience": 0.0026384075,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0026384075,
				"type": "OTHER"
			},
			{
				"name": "demolition workers",
				"salience": 0.0026384075,
				"type": "PERSON"
			},
			{
				"name": "clubs",
				"salience": 0.0026384075,
				"type": "ORGANIZATION"
			},
			{
				"name": "centre",
				"salience": 0.0024706637,
				"type": "LOCATION"
			},
			{
				"name": "fight",
				"salience": 0.002456203,
				"type": "EVENT"
			},
			{
				"name": "tents",
				"salience": 0.0024144468,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.0022779508,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.002136583,
				"type": "OTHER"
			},
			{
				"name": "clearance",
				"salience": 0.002136583,
				"type": "OTHER"
			},
			{
				"name": "hub",
				"salience": 0.002136583,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.0020911214,
				"type": "PERSON"
			},
			{
				"name": "facility",
				"salience": 0.0019464518,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.0019319034,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.0019247185,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.0019247185,
				"type": "EVENT"
			},
			{
				"name": "buses",
				"salience": 0.0018738232,
				"type": "OTHER"
			},
			{
				"name": "riot police",
				"salience": 0.0018585187,
				"type": "PERSON"
			},
			{
				"name": "north",
				"salience": 0.0018502205,
				"type": "LOCATION"
			},
			{
				"name": "processing centres",
				"salience": 0.0018459157,
				"type": "LOCATION"
			},
			{
				"name": "possessions",
				"salience": 0.0017811797,
				"type": "OTHER"
			},
			{
				"name": "razing",
				"salience": 0.0017811797,
				"type": "EVENT"
			},
			{
				"name": "scuffles",
				"salience": 0.0017811797,
				"type": "OTHER"
			},
			{
				"name": "hub",
				"salience": 0.0017443775,
				"type": "LOCATION"
			},
			{
				"name": "council",
				"salience": 0.0017443775,
				"type": "ORGANIZATION"
			},
			{
				"name": "area",
				"salience": 0.0017443775,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.0016908754,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0016667302,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0016667302,
				"type": "PERSON"
			},
			{
				"name": "beds",
				"salience": 0.0016507248,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0015105453,
				"type": "LOCATION"
			},
			{
				"name": "business owners",
				"salience": 0.0015105453,
				"type": "PERSON"
			},
			{
				"name": "people smugglers",
				"salience": 0.0015105453,
				"type": "PERSON"
			},
			{
				"name": "criminals",
				"salience": 0.0015105453,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.0015105453,
				"type": "OTHER"
			},
			{
				"name": "doorsteps",
				"salience": 0.0015105453,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_h1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Volgograd"
				},
				"name": "Stalingrad",
				"salience": 0.0014566999,
				"type": "LOCATION"
			},
			{
				"name": "Gare du Nord Eurostar",
				"salience": 0.0014566999,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0013375761,
				"type": "PERSON"
			},
			{
				"name": "gesture",
				"salience": 0.0013220548,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0012822642,
				"type": "PERSON"
			},
			{
				"name": "Migrants",
				"salience": 0.0012822642,
				"type": "PERSON"
			},
			{
				"name": "capacity",
				"salience": 0.0012331945,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.0012194206,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0012139743,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0012139743,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02r6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurostar"
				},
				"name": "Eurostar",
				"salience": 0.0011892302,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0011871654,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vbwp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Compagnies_R%C3%A9publicaines_de_S%C3%A9curit%C3%A9"
				},
				"name": "CRS",
				"salience": 0.001138932,
				"type": "ORGANIZATION"
			},
			{
				"name": "suburb",
				"salience": 0.0011284532,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.0011284532,
				"type": "ORGANIZATION"
			},
			{
				"name": "closure",
				"salience": 0.0011284532,
				"type": "EVENT"
			},
			{
				"name": "boys",
				"salience": 0.0011284532,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.0011284532,
				"type": "OTHER"
			},
			{
				"name": "teenagers",
				"salience": 0.0011284532,
				"type": "PERSON"
			},
			{
				"name": "places",
				"salience": 0.0011284532,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0011284532,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02khs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eritrea"
				},
				"name": "Eritreans",
				"salience": 0.0010964194,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0010390079,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.000898157,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0008218614,
				"type": "OTHER"
			},
			{
				"name": "child welfare services",
				"salience": 0.0008218614,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.0008218614,
				"type": "OTHER"
			},
			{
				"name": "asylum",
				"salience": 0.0008218614,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.0008218614,
				"type": "OTHER"
			},
			{
				"name": "Others",
				"salience": 0.0007852631,
				"type": "PERSON"
			},
			{
				"name": "None",
				"salience": 0.0007239685,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00070900295,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03t469",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ivry-sur-Seine"
				},
				"name": "Ivry-sur-Seine",
				"salience": 0.0006945483,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.0006830104,
				"type": "PERSON"
			},
			{
				"name": "effect",
				"salience": 0.00067092065,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0006364467,
				"type": "LOCATION"
			},
			{
				"name": "Everybody",
				"salience": 0.0006139226,
				"type": "PERSON"
			},
			{
				"name": "football pitch",
				"salience": 0.0006139226,
				"type": "OTHER"
			},
			{
				"name": "immigrant crisis",
				"salience": 0.0006139226,
				"type": "EVENT"
			},
			{
				"name": "tokenism",
				"salience": 0.0006139226,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0005058177,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.0005058177,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_Channel"
				},
				"name": "English Channel",
				"salience": 0.0005058177,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.0004911449,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00048329,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T06:01:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Hundreds of Migrants Protest in Paris over Their Treatment by French Authorities Julian Robinson and Peter Allen, Daily Mail, November 3, 2016 \nMigrants have staged a mass protest in Paris over their treatment by French authorities following the destruction of their makeshift camps. \nHundreds of refugees sleeping rough in the French capital joined local activists to demonstrate close to their encampment near the Stalingrad Metro station. \nOne man held up a sign saying ‘human, no beast’ as a man used a loud speaker to lead the march, which happened late last night. \nIt came 24 hours after violence broke out at the site with gangs of men attacking each other using sticks as makeshift clubs. \nThe fighting unfolded just hours after demolition workers supported by riot police began smashing up an illegal camp full of UK-bound migrants in Paris. \nIt also came in the wake of the destruction of the Calais Jungle which saw refugees transported around the country. It is not yet known what caused the fight in Paris. \nThere had already been scuffles on Monday as mainly Afghans and Eritreans tried to save their possessions during the raid, which started soon after 8am. \nIt followed thousands of migrants arriving in the French capital following the razing of the Calais Jungle refugee camp last week. \nWhile some 5,000 Jungle residents agreed to be bused to resettlement centres around France, many others headed off independently, saying they still wanted to get to Britain. \nUp to 3,000 set up tents on the pavements around the Stalingrad Metro station, which is close to the Gare du Nord Eurostar hub in the north of Paris. \nShortly before Monday’s clearance French president Francois Hollande said: ‘We won’t tolerate the camps any longer.’ \nReferring to the Paris clearance, Mr Hollande said: ‘We are going to carry out the same operation as in Calais.’ \nCRS riot police around Stalingrad said there would be a ‘gradual operation’ which is likely to go on all week until all the camps are gone. \nMeanwhile, the first ever official centre for refugees in Paris is due to be opened by the city’s Socialist council later this week. \nThe £6m facility is also close to the Eurostar hub, and will have beds for 400 men. \nBut local residents and business owners say it will attract people smugglers, and other criminals. \nJean Brossard, who has been living in the area for 30 years, said: ‘None of us asked for an immigrant centre on our doorsteps. \n‘Everybody in the area is complaining. If these men want to go to England, then send them to England.’ \nOthers have accused the Socialists of tokenism, saying they are simply opening the camps as a humanitarian gesture that will have no long term effect on Europe’s immigrant crisis. \nThe official centre, which will include a football pitch, will only allow residents to stay for between five and 10 weeks, and is likely to shut down within two years. \nAnother centre for women with children will also open in the Paris suburb of Ivry-sur-Seine later this year, or early next, but it too will only have a limited capacity of 350 temporary places. \nMeanwhile, French authorities have started transporting migrant children out of Calais to processing centres around France, amid tensions around the closure of the vast Jungle camp. \nThree buses carried a group of unaccompanied boys, mainly teenagers, out of the camp on Wednesday morning. \nFrench authorities transferred more than 5,000 adult migrants out of Calais last week, but the fate of its 1,500 unaccompanied children remained unclear. \nMigrants from the Middle East and Africa converged on the Jungle in hopes of crossing the English Channel to Britain. \nPresident Francois Hollande said this week that the children would be transferred within days to ‘dedicated centres’ where British officials can explore whether they have the right to UK asylum. \nMr Hollande said the others would be put in the care of French child welfare services.",
		"thread_title": "Hundreds of Migrants Protest in Paris over Their Treatment by French Authorities",
		"title": "Hundreds of Migrants Protest in Paris over Their Treatment by French Authorities",
		"type": "bs",
		"uuid": "c6ee6439950304684988875c617cc786f7105b9f"
	},
	"-KhIgup8_O1poOflR_K-": {
		"author": "Guillaume Durocher",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:01.032+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.21255593,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ps9k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicolas_Sarkozy"
				},
				"name": "Nicolas Sarkozy",
				"salience": 0.197276,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qg4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Hollande"
				},
				"name": "François Hollande",
				"salience": 0.10875536,
				"type": "PERSON"
			},
			{
				"name": "totalitarianism",
				"salience": 0.02580592,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hp7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Front_(France)"
				},
				"name": "Front National",
				"salience": 0.022536457,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03wj6f0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nadine_Morano"
				},
				"name": "Nadine Morano",
				"salience": 0.016831787,
				"type": "PERSON"
			},
			{
				"name": "foreigners",
				"salience": 0.016123815,
				"type": "PERSON"
			},
			{
				"name": "attitudes",
				"salience": 0.011788497,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.0115184905,
				"type": "OTHER"
			},
			{
				"name": "Robert Ménard",
				"salience": 0.011380454,
				"type": "PERSON"
			},
			{
				"name": "Nothing",
				"salience": 0.00708491,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0068888743,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015v8f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alexis_de_Tocqueville"
				},
				"name": "Alexis de Tocqueville",
				"salience": 0.006829947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04ynb4b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy_in_America"
				},
				"name": "Democracy in America",
				"salience": 0.006118605,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0058793626,
				"type": "LOCATION"
			},
			{
				"name": "patriots",
				"salience": 0.00519754,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0051382347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/071jd_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamization"
				},
				"name": "Islamization",
				"salience": 0.00436407,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0042954474,
				"type": "OTHER"
			},
			{
				"name": "Patrick Buisson",
				"salience": 0.0041483957,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.004011269,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0036222108,
				"type": "OTHER"
			},
			{
				"name": "Socialists",
				"salience": 0.0035899605,
				"type": "PERSON"
			},
			{
				"name": "Fear Islamization",
				"salience": 0.0035437385,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0033133016,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0033133016,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0032109986,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0031606003,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0031369883,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0031369883,
				"type": "LOCATION"
			},
			{
				"name": "race",
				"salience": 0.0029405097,
				"type": "EVENT"
			},
			{
				"name": "book",
				"salience": 0.0029405097,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.0029215242,
				"type": "PERSON"
			},
			{
				"name": "establishments",
				"salience": 0.0028076333,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0027371396,
				"type": "PERSON"
			},
			{
				"name": "burkinis",
				"salience": 0.0027166875,
				"type": "OTHER"
			},
			{
				"name": "Conservatives",
				"salience": 0.0027166875,
				"type": "PERSON"
			},
			{
				"name": "attitude",
				"salience": 0.0026135226,
				"type": "OTHER"
			},
			{
				"name": "American Renaissance",
				"salience": 0.0025602828,
				"type": "OTHER"
			},
			{
				"name": "Guillaume Durocher",
				"salience": 0.0025602828,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0024808976,
				"type": "PERSON"
			},
			{
				"name": "secularism",
				"salience": 0.0024530569,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0024530569,
				"type": "PERSON"
			},
			{
				"name": "interviews",
				"salience": 0.0024530569,
				"type": "EVENT"
			},
			{
				"name": "situation",
				"salience": 0.0024530569,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.0024530569,
				"type": "OTHER"
			},
			{
				"name": "flood",
				"salience": 0.0024530569,
				"type": "EVENT"
			},
			{
				"name": "assimilation",
				"salience": 0.002391661,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03n0sf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afro"
				},
				"name": "Afro",
				"salience": 0.0022859406,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018hmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_United_States"
				},
				"name": "South",
				"salience": 0.002202191,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.0022021823,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.002192978,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d7x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jean-Marie_Le_Pen"
				},
				"name": "Le Pen",
				"salience": 0.002178511,
				"type": "PERSON"
			},
			{
				"name": "inactivity",
				"salience": 0.0021243053,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.0021243053,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.0021243053,
				"type": "OTHER"
			},
			{
				"name": "awareness",
				"salience": 0.0021243053,
				"type": "OTHER"
			},
			{
				"name": "silence",
				"salience": 0.0021243053,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.0021243053,
				"type": "WORK_OF_ART"
			},
			{
				"name": "problems",
				"salience": 0.0020597398,
				"type": "OTHER"
			},
			{
				"name": "Left",
				"salience": 0.0019647619,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.001907024,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rdgs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marine_Le_Pen"
				},
				"name": "Marine Le Pen",
				"salience": 0.001845477,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/023qsr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Croatian_Democratic_Union"
				},
				"name": "Democratic Union",
				"salience": 0.001765177,
				"type": "ORGANIZATION"
			},
			{
				"name": "conservative party",
				"salience": 0.0017505282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018hmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_United_States"
				},
				"name": "Southerners",
				"salience": 0.0016725195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.0016725195,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0016521242,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027jgr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C3%89ric_Zemmour"
				},
				"name": "Éric Zemmour",
				"salience": 0.001641437,
				"type": "PERSON"
			},
			{
				"name": "partition",
				"salience": 0.0016018747,
				"type": "OTHER"
			},
			{
				"name": "partition",
				"salience": 0.0016018747,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0016018747,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0015899526,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0014306438,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0014306438,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.0014246943,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0013644056,
				"type": "EVENT"
			},
			{
				"name": "problems",
				"salience": 0.0013644056,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0013289368,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dj5q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles_de_Gaulle"
				},
				"name": "Charles de Gaulle",
				"salience": 0.0013076906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07s1801"
				},
				"name": "North",
				"salience": 0.0013076906,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hwt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_people"
				},
				"name": "Blacks",
				"salience": 0.0013076906,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0012917417,
				"type": "ORGANIZATION"
			},
			{
				"name": "immigrants",
				"salience": 0.0012917417,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.0012917417,
				"type": "EVENT"
			},
			{
				"name": "immigration",
				"salience": 0.0012917417,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0012917417,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.0012917417,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0012710493,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0012430828,
				"type": "ORGANIZATION"
			},
			{
				"name": "identity",
				"salience": 0.0012107746,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0012107746,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0012107746,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.0011823974,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0011642334,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.001158407,
				"type": "PERSON"
			},
			{
				"name": "policemen",
				"salience": 0.001158407,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0011185497,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0011185497,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.0011185497,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0011151669,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.0011151669,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0010864809,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0010632281,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.001019255,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0010106415,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.0010099355,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0010099355,
				"type": "PERSON"
			},
			{
				"name": "Whites",
				"salience": 0.0010099355,
				"type": "PERSON"
			},
			{
				"name": "theme",
				"salience": 0.0010099355,
				"type": "OTHER"
			},
			{
				"name": "foreigners",
				"salience": 0.0010099355,
				"type": "PERSON"
			},
			{
				"name": "theme",
				"salience": 0.0010099355,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.0010099355,
				"type": "EVENT"
			},
			{
				"name": "nothing",
				"salience": 0.0010068811,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00095663354,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00095663354,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.00095153705,
				"type": "WORK_OF_ART"
			},
			{
				"name": "party",
				"salience": 0.00091690844,
				"type": "ORGANIZATION"
			},
			{
				"name": "future",
				"salience": 0.00087843667,
				"type": "OTHER"
			},
			{
				"name": "salience",
				"salience": 0.00087451265,
				"type": "OTHER"
			},
			{
				"name": "naturalizations",
				"salience": 0.00087451265,
				"type": "OTHER"
			},
			{
				"name": "predecessors",
				"salience": 0.00087451265,
				"type": "PERSON"
			},
			{
				"name": "bombs",
				"salience": 0.00087451265,
				"type": "OTHER"
			},
			{
				"name": "race-baiting",
				"salience": 0.00087451265,
				"type": "EVENT"
			},
			{
				"name": "accumulation",
				"salience": 0.00087451265,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00087451265,
				"type": "PERSON"
			},
			{
				"name": "segregation",
				"salience": 0.00087451265,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.00087451265,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.0008718676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "Frenchmen",
				"salience": 0.00086909655,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0008538457,
				"type": "OTHER"
			},
			{
				"name": "Books",
				"salience": 0.0008489003,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mainstream media",
				"salience": 0.0008188701,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0008172091,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05c1gn_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dominique_Venner"
				},
				"name": "Dominique Venner",
				"salience": 0.00081218407,
				"type": "PERSON"
			},
			{
				"name": "price",
				"salience": 0.00080022356,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.0007850204,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.0007842299,
				"type": "OTHER"
			},
			{
				"name": "considerations",
				"salience": 0.0007842299,
				"type": "OTHER"
			},
			{
				"name": "monetary union",
				"salience": 0.0007842299,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0007842299,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0007842299,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00078094704,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.00078094704,
				"type": "EVENT"
			},
			{
				"name": "burkinis",
				"salience": 0.00075495214,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.00075495214,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00075495214,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.00075495214,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00075495214,
				"type": "OTHER"
			},
			{
				"name": "burkinis",
				"salience": 0.00075495214,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00075495214,
				"type": "OTHER"
			},
			{
				"name": "offering",
				"salience": 0.0007449171,
				"type": "OTHER"
			},
			{
				"name": "surprises",
				"salience": 0.0007449171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qdcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Party_(France)"
				},
				"name": "Socialists",
				"salience": 0.00074009434,
				"type": "PERSON"
			},
			{
				"name": "civil war",
				"salience": 0.00070806895,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.00070806895,
				"type": "EVENT"
			},
			{
				"name": "religion",
				"salience": 0.00070806895,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0007064207,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0007064207,
				"type": "OTHER"
			},
			{
				"name": "integration",
				"salience": 0.00069914525,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.00069299305,
				"type": "OTHER"
			},
			{
				"name": "frontrunner",
				"salience": 0.0006821102,
				"type": "LOCATION"
			},
			{
				"name": "family reunification",
				"salience": 0.0006816337,
				"type": "EVENT"
			},
			{
				"name": "assimilation",
				"salience": 0.0006816337,
				"type": "OTHER"
			},
			{
				"name": "disenchantment",
				"salience": 0.0006816337,
				"type": "OTHER"
			},
			{
				"name": "family reunification",
				"salience": 0.0006816337,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.0006816337,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0006816337,
				"type": "PERSON"
			},
			{
				"name": "rhinoceros",
				"salience": 0.0006816337,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0006816337,
				"type": "OTHER"
			},
			{
				"name": "party primaries",
				"salience": 0.0006816337,
				"type": "EVENT"
			},
			{
				"name": "nothing",
				"salience": 0.0006795719,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0195tf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurozone"
				},
				"name": "Eurozone",
				"salience": 0.00066828117,
				"type": "LOCATION"
			},
			{
				"name": "book",
				"salience": 0.0006671205,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0l5_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sahel"
				},
				"name": "Sahel",
				"salience": 0.00066417165,
				"type": "LOCATION"
			},
			{
				"name": "speakers",
				"salience": 0.00065325364,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.00064502057,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.00064502057,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.00064502057,
				"type": "OTHER"
			},
			{
				"name": "inhabitants",
				"salience": 0.00064502057,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.00064019655,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.00064019655,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00064019655,
				"type": "OTHER"
			},
			{
				"name": "security threats",
				"salience": 0.00064019655,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00064019655,
				"type": "OTHER"
			},
			{
				"name": "Nothing",
				"salience": 0.00063781417,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ctzb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_people"
				},
				"name": "Whites",
				"salience": 0.00062158436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fmhy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Right-wing_politics"
				},
				"name": "Right",
				"salience": 0.00062158436,
				"type": "OTHER"
			},
			{
				"name": "conservatives",
				"salience": 0.0006201175,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "homogeneity",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "checks",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "welfare",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "best-seller lists",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.00061311264,
				"type": "PERSON"
			},
			{
				"name": "evening news",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "rock concert",
				"salience": 0.00061311264,
				"type": "EVENT"
			},
			{
				"name": "fruits",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "truck",
				"salience": 0.00061311264,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fanatics",
				"salience": 0.00061311264,
				"type": "PERSON"
			},
			{
				"name": "mass murder",
				"salience": 0.00061311264,
				"type": "EVENT"
			},
			{
				"name": "liberties",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "abrogation",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "government surveillance",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "mankind",
				"salience": 0.00061311264,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00061168533,
				"type": "PERSON"
			},
			{
				"name": "presidents",
				"salience": 0.00061168533,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.00061168533,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00061168533,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "fecklessness",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "gravity",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "ban",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.0005902216,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "water-pistol",
				"salience": 0.0005902216,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "housing",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0005902216,
				"type": "LOCATION"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0005902216,
				"type": "LOCATION"
			},
			{
				"name": "conditions",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "average",
				"salience": 0.0005902216,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0005902216,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.00058335485,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.00058335485,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.00057802,
				"type": "OTHER"
			},
			{
				"name": "mayor",
				"salience": 0.00057802,
				"type": "PERSON"
			},
			{
				"name": "schools",
				"salience": 0.00057802,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.00057802,
				"type": "PERSON"
			},
			{
				"name": "primaries",
				"salience": 0.00057802,
				"type": "EVENT"
			},
			{
				"name": "hundreds",
				"salience": 0.0005754376,
				"type": "OTHER"
			},
			{
				"name": "school children",
				"salience": 0.000560282,
				"type": "PERSON"
			},
			{
				"name": "History",
				"salience": 0.0005564388,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00055227714,
				"type": "OTHER"
			},
			{
				"name": "nationalists",
				"salience": 0.00055227714,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.00055227714,
				"type": "OTHER"
			},
			{
				"name": "nationalist",
				"salience": 0.00055227714,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/11bcdk9m5_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Republicans_(France)"
				},
				"name": "Les Républicains",
				"salience": 0.0005382234,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.00053659524,
				"type": "ORGANIZATION"
			},
			{
				"name": "politicians",
				"salience": 0.0005144627,
				"type": "PERSON"
			},
			{
				"name": "figure",
				"salience": 0.000506889,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "felon",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "heights",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "challenge",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "bounds",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "lengths",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.00050050014,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.0004941919,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.00048265106,
				"type": "LOCATION"
			},
			{
				"name": "divide",
				"salience": 0.00048181272,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00048063038,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.00047820905,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00047820905,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00047820905,
				"type": "PERSON"
			},
			{
				"name": "Term",
				"salience": 0.00047820905,
				"type": "OTHER"
			},
			{
				"name": "choke points",
				"salience": 0.00047820905,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00044546506,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00044546506,
				"type": "OTHER"
			},
			{
				"name": "alternative media",
				"salience": 0.00044546506,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Protestantism"
				},
				"name": "Protestants",
				"salience": 0.00043577256,
				"type": "PERSON"
			},
			{
				"name": "working class",
				"salience": 0.0004317619,
				"type": "PERSON"
			},
			{
				"name": "offer",
				"salience": 0.0004317619,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.0004317619,
				"type": "OTHER"
			},
			{
				"name": "fringe",
				"salience": 0.0004317619,
				"type": "OTHER"
			},
			{
				"name": "surprises",
				"salience": 0.0004317619,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00042483173,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00042483173,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.00040219768,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.00040219768,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00040219768,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugee center",
				"salience": 0.00039712817,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.00039399677,
				"type": "ORGANIZATION"
			},
			{
				"name": "penetration",
				"salience": 0.0003933124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Catholics",
				"salience": 0.00037732677,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0282pp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_culture"
				},
				"name": "Western Civilization",
				"salience": 0.00037732677,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018zg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bastille_Day"
				},
				"name": "Bastille Day",
				"salience": 0.00037732677,
				"type": "EVENT"
			},
			{
				"name": "Will Europe turn African",
				"salience": 0.00037732677,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09ft8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Protestant_Reformation"
				},
				"name": "Protestant Reformation",
				"salience": 0.00037732677,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle Eastern",
				"salience": 0.00037732677,
				"type": "LOCATION"
			},
			{
				"name": "non-Whites",
				"salience": 0.00037732677,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.00037385392,
				"type": "OTHER"
			},
			{
				"name": "gains",
				"salience": 0.00037385392,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.00037385392,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.00037385392,
				"type": "EVENT"
			},
			{
				"name": "cliquishness",
				"salience": 0.00037385392,
				"type": "OTHER"
			},
			{
				"name": "media personality",
				"salience": 0.00037385392,
				"type": "OTHER"
			},
			{
				"name": "unemployment",
				"salience": 0.00037385392,
				"type": "OTHER"
			},
			{
				"name": "aspirations",
				"salience": 0.00037385392,
				"type": "OTHER"
			},
			{
				"name": "stranglehold",
				"salience": 0.00037385392,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00037258965,
				"type": "OTHER"
			},
			{
				"name": "precedent",
				"salience": 0.0003691416,
				"type": "OTHER"
			},
			{
				"name": "floodgates",
				"salience": 0.00036612456,
				"type": "OTHER"
			},
			{
				"name": "occupants",
				"salience": 0.0003575626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01b85",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bordeaux"
				},
				"name": "Bordeaux",
				"salience": 0.00035572765,
				"type": "LOCATION"
			},
			{
				"name": "tradition",
				"salience": 0.00035087878,
				"type": "OTHER"
			},
			{
				"name": "choke points",
				"salience": 0.00034825428,
				"type": "OTHER"
			},
			{
				"name": "prelude",
				"salience": 0.000337777,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.00031732992,
				"type": "EVENT"
			},
			{
				"name": "shift",
				"salience": 0.00031701865,
				"type": "EVENT"
			},
			{
				"name": "levels",
				"salience": 0.00031442754,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.00031442754,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.00031442754,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.00031442754,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00031442754,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02840y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alain_Jupp%C3%A9"
				},
				"name": "Alain Juppé",
				"salience": 0.00030801602,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.00030042257,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00030042257,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europeans",
				"salience": 0.00029675633,
				"type": "LOCATION"
			},
			{
				"name": "enemy",
				"salience": 0.0002900822,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.00028158425,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00028158425,
				"type": "OTHER"
			},
			{
				"name": "dispossession",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "migrant invasion",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "reflex",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "premises",
				"salience": 0.0002722546,
				"type": "LOCATION"
			},
			{
				"name": "lowest",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "takeover",
				"salience": 0.0002722546,
				"type": "EVENT"
			},
			{
				"name": "rest",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "colonization",
				"salience": 0.0002722546,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.0002722546,
				"type": "OTHER"
			},
			{
				"name": "referendum",
				"salience": 0.0002620883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hqjh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Africa"
				},
				"name": "West",
				"salience": 0.00026155985,
				"type": "LOCATION"
			},
			{
				"name": "proportion",
				"salience": 0.0002587846,
				"type": "OTHER"
			},
			{
				"name": "marriage",
				"salience": 0.00024912122,
				"type": "OTHER"
			},
			{
				"name": "Un Quinquennat Pour Rien",
				"salience": 0.0002451366,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00024106348,
				"type": "PERSON"
			},
			{
				"name": "imposition",
				"salience": 0.00023981865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00023951077,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.00023486014,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.00023486014,
				"type": "OTHER"
			},
			{
				"name": "leftist",
				"salience": 0.00023486014,
				"type": "PERSON"
			},
			{
				"name": "fringe",
				"salience": 0.00023486014,
				"type": "EVENT"
			},
			{
				"name": "score",
				"salience": 0.00023486014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02l6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Euro"
				},
				"name": "Euro",
				"salience": 0.0002216603,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.00022064913,
				"type": "LOCATION"
			},
			{
				"name": "prospect",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.00020335832,
				"type": "LOCATION"
			},
			{
				"name": "death penalty",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00020335832,
				"type": "LOCATION"
			},
			{
				"name": "law",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.00020335832,
				"type": "PERSON"
			},
			{
				"name": "runoff",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.00020335832,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00020335832,
				"type": "LOCATION"
			},
			{
				"name": "fight",
				"salience": 0.00020335832,
				"type": "EVENT"
			},
			{
				"name": "incorrectness",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.00020335832,
				"type": "OTHER"
			},
			{
				"name": "pace",
				"salience": 0.00019086008,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0btv2z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Disenchantment"
				},
				"name": "Disenchantment",
				"salience": 0.00018627213,
				"type": "OTHER"
			},
			{
				"name": "lead",
				"salience": 0.0001814168,
				"type": "OTHER"
			},
			{
				"name": "classes",
				"salience": 0.00017993394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ck8x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_Christians"
				},
				"name": "Christian",
				"salience": 0.0001675435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rfdxh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alternative_for_Germany"
				},
				"name": "Alternative for Germany",
				"salience": 0.00014453032,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06fz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rhine"
				},
				"name": "Rhine",
				"salience": 0.00014453032,
				"type": "LOCATION"
			},
			{
				"name": "Frauke Petry",
				"salience": 0.00012514378,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ln61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reporters_Without_Borders"
				},
				"name": "Reporters Without Borders",
				"salience": 0.00012514378,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01n0b1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/B%C3%A9ziers"
				},
				"name": "Béziers",
				"salience": 0.00012514378,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01f_2q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/B'nai_B'rith"
				},
				"name": "B'nai B'rith",
				"salience": 0.00012514378,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.00009878076,
				"type": "PERSON"
			},
			{
				"name": "branch",
				"salience": 0.000097434146,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:26:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 30.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Posted on November 4, 2016 The French Fear Islamization but Do Nothing Guillaume Durocher, American Renaissance, November 2, 2016 Not even the Front National is prepared to act. \nIn his classic study Democracy in America , Alexis de Tocqueville wrote about Southerners’ attitudes towards the rapidly expanding population of Blacks: \nIn the states of the South, they are quiet; they do not speak about the future to foreigners; they avoid explaining themselves with their friends; everyone is in denial about it even with themselves. There is something more frightening about the silence of the South than the noisy fears of the North. [1] \nAlmost two centuries later, there is a similar attitude of denial among French politicians about the steady Afro-Islamization of France. Conservatives are happy to talk about “Islamic totalitarianism,” “secularism,” “burkinis,” etc, but not the underlying problem, which is continued Muslim immigration. Socialists recognize the problem in private, but do nothing either to stop the flood of Africans and Muslims. There is something surreal about the situation. \nThe most striking example of awareness combined with inactivity was provided recently by the publication of a book of exclusive interviews with our painfully uncharismatic and ineffectual president, the Socialist François Hollande. Among Mr. Hollande’s statements , one finds: On conservative politician Nadine Morano’s saying that France is “a country of the white race” (quoting Charles de Gaulle): “I am convinced that, when one asks the French, the majority have her position. [. . .] They think: ‘We are for the most part Whites. There are more Whites than others.’ ” On Islamic immigration: “There are at the same time things which work very well and the accumulation of potential bombs linked to a continuous immigration. Because it continues.” On the salience of race in politics: “The Left cannot win on the theme of identity, but it can lose on the theme of identity.” On ethnic segregation and potential civil war: “How can we avoid partition? Because that is really what is happening: partition.” \nMr. Hollande recognizes that integration, let alone assimilation, is not happening and that “at some point [immigration] will have to stop.” And yet, during his four years as president, he has done nothing to stop it. Instead, his government has radically increased the rate of naturalizations of foreigners , providing the flagging Socialists with thousands of new voters in time for national elections next spring. \nOn the Right, we have the conservative party, now called “Les Républicains,” led by former president Nicolas Sarkozy. He knows racial problems well, having made a career from a sort of low-level race-baiting while, as president, actually letting more immigrants settle in France than his Socialist predecessors. Mr. Sarkozy is also well aware of the medium-term existential threat to France. As he said recently at a political meeting: \nThe Sahel will in 30 years have 200 million inhabitants. There are 6 to 8 children per family on average in the Sahel. Can we continue family reunification in these conditions? Is the future of the Sahel’s children to end up in our cities’ neighborhoods? Even though we have no jobs, no housing, and we no longer have the means to pay benefits for families who do not pay one cent in taxes. \nWell said! But can Mr. Sarkozy claim to have been unaware of these facts while he was president from 2007 to 2012? The end of family reunification would be welcome, but in the face of the demographic threat to France and all of Europe, this is like fending off a rhinoceros with a water-pistol. Other than this, Mr. Sarkozy has mainly been trying to win the conservative party primaries by complaining about “burkinis” and demanding “assimilation.” However, as a former adviser Patrick Buisson –a Rightist who recently published a book on his disenchantment with Mr. Sarkozy–has said: “He is ready to say what is needed to get elected and to then do nothing.” French police ask a woman to remove some of her clothing to comply with a ban on “burkinis.” \nThe gravity of the situation is matched only by the sheer fecklessness of European politicians . According to United Nations statistics, the population of Europe (including a growing proportion of highly-fertile non-Whites) will stagnate and decline this century while that of Africa is set to quadruple to a whopping 4 billion. The most important, tragic, horrifying, ungodly, evil question facing Western Civilization and mankind this century is this: Will Europe turn African ? \nBooks warning against Islamization, whether by journalists or second-rate politicians, top the best-seller lists, but most French people care more about welfare and pay checks than long-term considerations. Even on economic issues, they would rather stay in denial, vaguely hoping the problems of a heavily state-run French economy in an inefficient Eurozone monetary union will sort themselves out on their own, rather than ask hard questions. Ethno-religious questions are even more inconceivable. \nIt is true that diversity is not yet an unmanageable problem in the daily lives of most Frenchmen, aside from the unpleasant evening news about Muslims shooting up hundreds of people at a rock concert, running down dozens of people with a truck on Bastille Day, or trying to burn policemen to death . Incidentally, the last time France’s religious homogeneity was broken–during the Protestant Reformation–this led to a civil war between Catholics and Protestants. \nWe are told that mass government surveillance, abrogation of civil liberties, and mass murder by the fanatics of a Middle Eastern religion are the price we pay for enjoying the fruits of diversity. And if you don’t like it, you will join the scores of European patriots who have been fined and even jailed under anti-free-speech laws for “inciting hatred.” (By the way, France has passed special laws to counter the Islamic terrorism. These same laws have been invoked to spy on thousands of patriots who have been designated as “security threats.”) \nNonetheless, the current offering for next spring’s presidential elections in France is dismal. Besides Mr. Hollande and Mr. Sarkozy, with whom the French are thoroughly disenchanted, there is the frontrunner in the conservative primaries, Alain Juppé, a felon guilty of misusing public funds, who is proud of France’s “diversity.” He speaks of France’s new “happy identity,” and is being called a “steady,” “serious” candidate–who will change nothing. As mayor of Bordeaux, he noted that 60 percent of the students in some of his schools are “foreign-language speakers,” but appeared to think this was nothing worse than an exciting challenge. \nThen there is the eternal promise of the Front National, a party that has risen to unprecedented heights in polls and secondary elections. But this has come at a significant cost: Marine Le Pen has gone to great lengths to “detoxify” the party and stay within the bounds acceptable to France’s heavily policed and state-dependent mainstream media. The “new FN” talks more about dismantling the European Union and the Euro than about identity and Islam, let alone race. \nMarine Le Pen is breaking no new ground in the fight against political incorrectness, in contrast with the Alternative for Germany’s Frauke Petry on the other side of the Rhine. And yet, a solid two-thirds of French people still strongly oppose Miss Le Pen. She will probably reach the second-round runoff of the presidential elections and then lose in a landslide, though surely with a better score than her father’s 18 percent in 2002. The majority of Frenchmen are likely to be repelled by the prospect of an FN government that represents the working classes and the ethnocentric fringe. The conservatives, for their part, have refused to work with the FN ever since the French branch of the B’nai B’rith asked them to in 1986 . Marine Le Pen \nThe most groundbreaking politician in France today is probably the mayor of Béziers, Robert Ménard, who, in a former life as a leftist, founded Reporters Without Borders, but now calls himself a reactionary. He has broken French law by counting the city’s school children by religion–he found that 65 percent were Muslim, judging from their first names. He wants to reinstate the death penalty, opposes homosexual marriage, and he visited a refugee center to tell the occupants they are not welcome in France. Recently he proposed a municipal referendum to reject the imposition of “refugees” on his town. \nDisenchantment is severe among the French: 83 percent think Mr. Hollande is “disqualified” as president due to his failure on unemployment. Two-thirds think Mr. Sarkozy and Mr. Hollande were equally bad presidents , and a solid majority, continuously egged on by a hostile media, are “worried” by Marine Le Pen . I am inclined to agree with best-selling author Éric Zemmour , whose latest book is Un Quinquennat Pour Rien (“A Five-Year Term for Nothing”), when he says that the next year’s elections are pointless. \nWhy is there such a divide between the aspirations of French voters and the politicians on offer? I believe this can be explained only by the authoritarian cliquishness of the French political system: The parties and the media serve as critical choke points to prevent the penetration of nationalist and identitarian movements that might appeal to a majority of the French people. No Trump-like figure–half independent billionaire half media personality–has emerged to break this stranglehold by uniting the nationalist fringe of the disenfranchised white working class with mainstream conservative voters. \nAll this is depressing, but one must not forget that, as the great European historian Dominique Venner said: “History is nothing but a set of strategic surprises.” The presidential elections are in April and May, and six months is a long time in politics. France cannot remain unaffected by the enormous political and cultural gains made in recent years by nationalists across the West. Happy surprises do happen. If Donald Trump were to win, this would set a patriotic and anti-immigration precedent for many Europeans governments. There is a long tradition of opportunistic European politicians slavishly following the American political and cultural lead. \nThe mainstream political establishments across Europe are reeling from the economic crisis, the migrant invasion, and–one must not underestimate this–the mainstream media’s own economic and legitimacy crisis due to the rise of alternative media. These establishments are merely trying, in a dull bovine reflex, to keep the ship on course without ever questioning their premises. But this is proving harder and harder. German Chancellor Angela Merkel, who for her role in opening the floodgates to Afro-Islamic colonization is an objective enemy of Europe, is facing real problems. Her party, the so-called Christian-Democratic Union, has reached its lowest ever levels of support , falling to less than 30 percent. \nThe critical media-political choke points of power in the “democratic” West–particularly in America, Germany, and France–are more open for takeover than ever. If one or two go, particularly America, many of the rest are likely to follow. If we are lucky, a major shift towards national-populist governments could be possible. This would appeal to the great majority of our people and drastically reduce the pace of dispossession. And that could be a prelude for far greater things to come.",
		"thread_title": "The French Fear Islamization but Do Nothing",
		"title": "The French Fear Islamization but Do Nothing",
		"type": "bs",
		"uuid": "7e0651bab350a52896168d4eb65da16363b3d193"
	},
	"-KhIgv2DzXR9HbfuTH2K": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:03.395+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02qtlv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Border_Patrol"
				},
				"name": "Border Patrol",
				"salience": 0.15287718,
				"type": "ORGANIZATION"
			},
			{
				"name": "People",
				"salience": 0.089015685,
				"type": "PERSON"
			},
			{
				"name": "Immigrants",
				"salience": 0.050372668,
				"type": "PERSON"
			},
			{
				"name": "ones",
				"salience": 0.037283372,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Art Del Cueto",
				"salience": 0.036927804,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.033251777,
				"type": "PERSON"
			},
			{
				"name": "Race",
				"salience": 0.033035442,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.033035442,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/084lpn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico%E2%80%93United_States_border"
				},
				"name": "US-Mexico Border",
				"salience": 0.030063096,
				"type": "LOCATION"
			},
			{
				"name": "Election Day",
				"salience": 0.028646043,
				"type": "EVENT"
			},
			{
				"name": "border",
				"salience": 0.02498143,
				"type": "LOCATION"
			},
			{
				"name": "race",
				"salience": 0.02352853,
				"type": "EVENT"
			},
			{
				"name": "narrative",
				"salience": 0.02127369,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.020931078,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.020414755,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.017692324,
				"type": "ORGANIZATION"
			},
			{
				"name": "William La Jeunesse",
				"salience": 0.017692324,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.016532263,
				"type": "OTHER"
			},
			{
				"name": "Chris Cabrera",
				"salience": 0.015997598,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.014691453,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.0138833085,
				"type": "OTHER"
			},
			{
				"name": "papers",
				"salience": 0.012957786,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Smugglers",
				"salience": 0.011337804,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.010619102,
				"type": "LOCATION"
			},
			{
				"name": "agent",
				"salience": 0.009906909,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cc5v7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Border_Patrol_Council"
				},
				"name": "National Border Patrol Council",
				"salience": 0.009154367,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.009057551,
				"type": "LOCATION"
			},
			{
				"name": "immigrants",
				"salience": 0.008647254,
				"type": "PERSON"
			},
			{
				"name": "cartels",
				"salience": 0.008640227,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.007309856,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.006999058,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.006144313,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.0060620746,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0060620746,
				"type": "OTHER"
			},
			{
				"name": "agent",
				"salience": 0.006047987,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0053454,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.005164969,
				"type": "OTHER"
			},
			{
				"name": "field agents",
				"salience": 0.005096787,
				"type": "PERSON"
			},
			{
				"name": "immigration numbers",
				"salience": 0.004909815,
				"type": "OTHER"
			},
			{
				"name": "apprehensions",
				"salience": 0.004909815,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.004887909,
				"type": "OTHER"
			},
			{
				"name": "narratives",
				"salience": 0.0047267424,
				"type": "OTHER"
			},
			{
				"name": "amnesty",
				"salience": 0.0044731554,
				"type": "OTHER"
			},
			{
				"name": "sectors",
				"salience": 0.0042521292,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.004093547,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.004093547,
				"type": "OTHER"
			},
			{
				"name": "candidate wins",
				"salience": 0.004093547,
				"type": "EVENT"
			},
			{
				"name": "apprehensions",
				"salience": 0.004009012,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.004009012,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Ariz.",
				"salience": 0.0037332685,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fr0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tucson,_Arizona"
				},
				"name": "Tucson",
				"salience": 0.0037332685,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0034718532,
				"type": "OTHER"
			},
			{
				"name": "surge",
				"salience": 0.0034718532,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0034718532,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0034718532,
				"type": "OTHER"
			},
			{
				"name": "faction",
				"salience": 0.0033573252,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.003278886,
				"type": "OTHER"
			},
			{
				"name": "courts",
				"salience": 0.003038798,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_America"
				},
				"name": "Central America",
				"salience": 0.0030232165,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0028346248,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0103hp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McAllen,_Texas"
				},
				"name": "McAllen",
				"salience": 0.0026180274,
				"type": "LOCATION"
			},
			{
				"name": "checkpoint",
				"salience": 0.0025939485,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.0025939485,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vq8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rio_Grande_Valley"
				},
				"name": "Rio Grande Valley",
				"salience": 0.0025203377,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025203377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0025203377,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0024991916,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haitians",
				"salience": 0.0024572432,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asia",
				"salience": 0.0021374004,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.0021374004,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0021004395,
				"type": "OTHER"
			},
			{
				"name": "backing",
				"salience": 0.0019378912,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0018893685,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.0018893685,
				"type": "WORK_OF_ART"
			},
			{
				"name": "immigration law",
				"salience": 0.0018893685,
				"type": "OTHER"
			},
			{
				"name": "factors",
				"salience": 0.0016931734,
				"type": "OTHER"
			},
			{
				"name": "asylum",
				"salience": 0.0016299752,
				"type": "OTHER"
			},
			{
				"name": "asylum",
				"salience": 0.0016299752,
				"type": "OTHER"
			},
			{
				"name": "somebody",
				"salience": 0.0014114291,
				"type": "PERSON"
			},
			{
				"name": "claim",
				"salience": 0.0014114291,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0014114291,
				"type": "OTHER"
			},
			{
				"name": "immigration policy",
				"salience": 0.0014114291,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "D.C.",
				"salience": 0.0011629302,
				"type": "LOCATION"
			},
			{
				"name": "work permits",
				"salience": 0.0011522291,
				"type": "OTHER"
			},
			{
				"name": "Beeson",
				"salience": 0.000755575,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Illegal Immigrants Surging to US-Mexico Border in Race Against Election Day William La Jeunesse, Fox News, November 3, 2016 \nAmericans aren’t the only ones motivated by Tuesday’s election. The presidential race has immigrants from around the world racing to the U.S.-Mexican border, as the cartels exploit a powerful narrative: get into the U.S. while you still can. \n“Smugglers are telling them that they need to come across now while there’s a chance,” said Art Del Cueto, a Border Patrol agent in Tucson, Ariz., whose views were echoed by another agent in Texas. \n“People think if one candidate wins, certain things will happen, like a giant wall being built and then they can never get through,” said Chris Cabrera, an agent in the Rio Grande Valley. “Another faction believes that if the other candidate wins, they’ll get amnesty if they’re here by a certain date.” \nThose two competing narratives–triggered by the rhetoric of Donald Trump and Hillary Clinton, respectively–are driving immigration numbers the Border Patrol hasn’t seen in years in some sectors. \n“We are overwhelmed,” said a veteran agent in McAllen, Texas. “We are seeing 800 to 1,000 apprehensions every night.” \nIn fiscal 2016, the Border Patrol apprehended 117,200 immigrants from Central America, almost one-third of all apprehensions border-wide–and 5,000 more than during the so-called surge of 2014. The agency also apprehended 5,000 Haitians, up from just 700 last year. The number of immigrants claiming to be from Africa and Asia also is up. \n{snip} \nThe poverty and violence plaguing many of these countries helps push immigrants north, Beeson said. Pull factors include available and good-paying jobs in the U.S. and immigration policy that provides work permits and freedom for immigrants while the courts adjudicate their ‘asylum’ claim. \n“When you stop somebody, you ask their name and the first thing they tell you is–‘I’m here for asylum, I can’t go home because they’ll kill me.’ . . . When it takes a good five or six minutes just to get their name out of them, they have a rehearsed story,” said Cabrera. “Once they get those papers saying they can pass through our checkpoint, we’ll never see them again.” \nDel Cueto said the agents are “not getting any backing” from D.C. and “we need to start enforcing every single immigration law we have on the books.” \nDel Cueto and Cabrera belong to the National Border Patrol Council, which represents the Border Patrol’s 18,000 field agents who are prohibited from talking openly to the media.",
		"thread_title": "Illegal Immigrants Surging to US-Mexico Border in Race Against Election Day",
		"title": "Illegal Immigrants Surging to US-Mexico Border in Race Against Election Day",
		"type": "bs",
		"uuid": "3a4f17f3d9bdef04600feca2f15c76d012a0362a"
	},
	"-KhIgvNb7Pn21Ob8wKOO": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:05.518+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "immigrants",
				"salience": 0.16799487,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.06460105,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/086w7r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Center_for_Immigration_Studies"
				},
				"name": "Center for Immigration Studies",
				"salience": 0.058276627,
				"type": "ORGANIZATION"
			},
			{
				"name": "Immigration",
				"salience": 0.03641037,
				"type": "OTHER"
			},
			{
				"name": "immigrant population",
				"salience": 0.03154329,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.03026054,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.026681809,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.023297299,
				"type": "LOCATION"
			},
			{
				"name": "data",
				"salience": 0.022067575,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.019450126,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.018729573,
				"type": "EVENT"
			},
			{
				"name": "increases",
				"salience": 0.01793586,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.015920395,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.014982781,
				"type": "OTHER"
			},
			{
				"name": "Immigration Studies",
				"salience": 0.013629096,
				"type": "OTHER"
			},
			{
				"name": "Steven Camarota",
				"salience": 0.012648207,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.012528553,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.011672398,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.011317351,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.011317351,
				"type": "OTHER"
			},
			{
				"name": "Steven A. CamarotaCenter",
				"salience": 0.010668035,
				"type": "PERSON"
			},
			{
				"name": "guest workers",
				"salience": 0.010459542,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.010070609,
				"type": "PERSON"
			},
			{
				"name": "increase",
				"salience": 0.010019216,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02t7jb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Community_Survey"
				},
				"name": "ACS",
				"salience": 0.00924266,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02t7jb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Community_Survey"
				},
				"name": "American Community Survey",
				"salience": 0.00924266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqj4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Census_Bureau"
				},
				"name": "Census Bureau",
				"salience": 0.008359807,
				"type": "ORGANIZATION"
			},
			{
				"name": "Karen Zeigler",
				"salience": 0.007743526,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.0077426904,
				"type": "OTHER"
			},
			{
				"name": "green card holders",
				"salience": 0.0076724784,
				"type": "PERSON"
			},
			{
				"name": "findings",
				"salience": 0.0076724784,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007583482,
				"type": "LOCATION"
			},
			{
				"name": "immigrants",
				"salience": 0.00708672,
				"type": "PERSON"
			},
			{
				"name": "visitors",
				"salience": 0.006833216,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0068228357,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0064915377,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0063451,
				"type": "OTHER"
			},
			{
				"name": "slowdown",
				"salience": 0.0059189154,
				"type": "EVENT"
			},
			{
				"name": "percentage",
				"salience": 0.005863446,
				"type": "OTHER"
			},
			{
				"name": "guest workers",
				"salience": 0.0057105804,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.005433087,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0052306396,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0052306396,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0049320557,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.004442237,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.004436849,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.004436849,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.004436849,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.004377456,
				"type": "PERSON"
			},
			{
				"name": "guest workers",
				"salience": 0.004377456,
				"type": "PERSON"
			},
			{
				"name": "arrivals",
				"salience": 0.004044438,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "surge",
				"salience": 0.004023587,
				"type": "EVENT"
			},
			{
				"name": "data",
				"salience": 0.0039110966,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.003861872,
				"type": "OTHER"
			},
			{
				"name": "business community",
				"salience": 0.003652152,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.0036411188,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0034921388,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0034596045,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0034596045,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0034596045,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0034596045,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0033697465,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.003330588,
				"type": "LOCATION"
			},
			{
				"name": "immigrants",
				"salience": 0.0033155603,
				"type": "PERSON"
			},
			{
				"name": "share",
				"salience": 0.0033001646,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0031629074,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.0031629074,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0031629074,
				"type": "WORK_OF_ART"
			},
			{
				"name": "behest",
				"salience": 0.0031629074,
				"type": "OTHER"
			},
			{
				"name": "Director of Research",
				"salience": 0.0031629074,
				"type": "PERSON"
			},
			{
				"name": "whole",
				"salience": 0.0031629074,
				"type": "LOCATION"
			},
			{
				"name": "Data",
				"salience": 0.0031533502,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0028580148,
				"type": "OTHER"
			},
			{
				"name": "arrivals",
				"salience": 0.00283666,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "arrivals",
				"salience": 0.00283666,
				"type": "PERSON"
			},
			{
				"name": "increase",
				"salience": 0.0027905281,
				"type": "OTHER"
			},
			{
				"name": "percentage",
				"salience": 0.0026069283,
				"type": "OTHER"
			},
			{
				"name": "share",
				"salience": 0.0025613927,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dgs1dm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Recession_in_the_United_States"
				},
				"name": "Great Recession",
				"salience": 0.0025092121,
				"type": "EVENT"
			},
			{
				"name": "immigrants",
				"salience": 0.0024153402,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0023406958,
				"type": "LOCATION"
			},
			{
				"name": "increases",
				"salience": 0.0023074304,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.002304094,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0022697824,
				"type": "OTHER"
			},
			{
				"name": "track",
				"salience": 0.0022181282,
				"type": "OTHER"
			},
			{
				"name": "projections",
				"salience": 0.0022181282,
				"type": "OTHER"
			},
			{
				"name": "mortality",
				"salience": 0.0022181282,
				"type": "OTHER"
			},
			{
				"name": "trends",
				"salience": 0.0022181282,
				"type": "OTHER"
			},
			{
				"name": "high",
				"salience": 0.0022181282,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0022181282,
				"type": "OTHER"
			},
			{
				"name": "remainder",
				"salience": 0.002135367,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.002135367,
				"type": "OTHER"
			},
			{
				"name": "percentage",
				"salience": 0.0019477146,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0018045359,
				"type": "PERSON"
			},
			{
				"name": "States",
				"salience": 0.0014959436,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_America"
				},
				"name": "Central America",
				"salience": 0.0012873245,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0012873245,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06nn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Asia"
				},
				"name": "South Asia",
				"salience": 0.0012873245,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qnk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_Asia"
				},
				"name": "East Asia",
				"salience": 0.0012873245,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.0012663398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03h2c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Honduras"
				},
				"name": "Honduras",
				"salience": 0.0012663398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guatemala"
				},
				"name": "Guatemala",
				"salience": 0.0012663398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05cgv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nigeria"
				},
				"name": "Nigeria",
				"salience": 0.0012663398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.0012663398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dominican_Republic"
				},
				"name": "Dominican Republic",
				"salience": 0.0012663398,
				"type": "LOCATION"
			},
			{
				"name": "regions",
				"salience": 0.0011328352,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0011147223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0261m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caribbean"
				},
				"name": "Caribbean",
				"salience": 0.0011147223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06qtn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sub-Saharan_Africa"
				},
				"name": "Sub-Saharan Africa",
				"salience": 0.0011147223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0011147223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02k8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/El_Salvador"
				},
				"name": "El Salvador",
				"salience": 0.0011147223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.0011147223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00096166134,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04ykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota"
				},
				"name": "Minnesota",
				"salience": 0.0009222913,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0008547156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0008547156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maryland"
				},
				"name": "Maryland",
				"salience": 0.0008547156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "Massachusetts",
				"salience": 0.00083270797,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.00083270797,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00083270797,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00083270797,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00083270797,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.00083270797,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.00083270797,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/035dk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ghana"
				},
				"name": "Ghana",
				"salience": 0.00083270797,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Dakota"
				},
				"name": "South Dakota",
				"salience": 0.0007003653,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.0007003653,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081mh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Virginia"
				},
				"name": "West Virginia",
				"salience": 0.0007003653,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0162b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bangladesh"
				},
				"name": "Bangladesh",
				"salience": 0.0006889459,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.0006889459,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0006889459,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05mph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma"
				},
				"name": "Oklahoma",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fhy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nebraska"
				},
				"name": "Nebraska",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/026mj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Delaware"
				},
				"name": "Delaware",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hjy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alaska"
				},
				"name": "Alaska",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04tgp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mississippi"
				},
				"name": "Mississippi",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07h34",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tennessee"
				},
				"name": "Tennessee",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0846v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wyoming"
				},
				"name": "Wyoming",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0006064412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/019pcs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ethiopia"
				},
				"name": "Ethiopia",
				"salience": 0.0004529923,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egypt",
				"salience": 0.0004529923,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0004529923,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.0004529923,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01ls2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colombia"
				},
				"name": "Colombia",
				"salience": 0.0004529923,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ylj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venezuela"
				},
				"name": "Venezuela",
				"salience": 0.0004529923,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haiti",
				"salience": 0.0004529923,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Immigration Surging; 1.5 Million Arriving Each Year Karen Zeigler and Steven A. CamarotaCenter for Immigration Studies, November 1, 2016 \nA Center for Immigration Studies (CIS) analysis of newly released data from the Census Bureau’s American Community Survey (ACS) shows that 1.5 million new immigrants (legal and illegal) settled in the country in 2014. The number who entered in 2014 represent an increase of 38 percent over the number who were arriving as recently as 2011. The findings confirm a CIS study published in June of this year based on other data showing a surge in legal and illegal immigration in 2014 and 2015. Newly arrived immigrants include new green card holders (permanent residents); long-term “temporary” visitors who often stay permanently, such as guest workers and foreign students; and new illegal immigrants. \nView the entire report here . \n“The data makes clear that the slowdown in immigration that occurred after the Great Recession is over,” said the Center’s Director of Research Steven Camarota. He added, “many of these new arrivals are guest workers brought in at the behest of the business community. Whether this is in the best interest of American workers or the country as a whole is a question seldom asked in Washington.” \n• Newly released data show 1.5 million new immigrants (legal and illegal) arrived in 2014. Data released for the first six months of 2015 indicates that 1.6 million new immigrants likely arrived in 2015. \n• The number who arrived in 2014 represents a 17% increase over the number who came in 2013 and a 38 percent increase over the low point in 2011. \n• Between two-third and three-fourths of the 1.5 million new immigrants settling in the country are legal immigrants, including permanent residents as well as long-term visitors (e.g. guest workers and foreign students). The remainder are new illegal immigrants. \n• The overall immigrant population grew about twice as fast from 2013 to 2015 as it did in the prior four years, hitting a new record high of 43.3 million. \n• It is important to note that arrivals are offset by those immigrants who leave the country each year and by normal mortality of about 300,000 annually among the existing immigrant population. Therefore, growth in the overall immigrant population is less than new arrivals. \n• As a share of the U.S. population, 13.5 percent are now immigrants–the highest percentage in 105 years. As recently as 1970, less than 5 percent of the population were immigrants. \n• Based on current trends and Census Bureau projections, the immigrant share of the population is on track to surpass the highest level in American history seven years from now. \n• Sending regions with the largest numerical increases in immigrants living in the United States since 2010 were East Asia (up 847,000), South Asia (up 825,000), the Caribbean (up 434,000), Sub-Saharan Africa (up 390,000), the Middle East (up 362,000), and Central America (up 332,000). The number of European immigrants declined by 31,000. \n• Major sending countries with the largest numerical increases in immigrants living in the United States since 2010 were India (up 609,000), China (up 510,000), the Philippines (up 205,000), the Dominican Republic (up 184,000), El Salvador (up 138,000), Cuba (up 106,000), Nigeria (up 104,000), Guatemala (up 97,000), Haiti (up 88,000), Pakistan (up 80,000), Honduras (up 76,000), Bangladesh (up 75,000), Venezuela (up 71,000), Colombia (up 63,000), Vietnam (up 60,000), and Iraq (up 55,000). \n• Major sending-countries with the largest percentage increases in immigrants living in the United States since 2010 were Saudi Arabia (up 115 percent), Bangladesh (up 49 percent), Nigeria (up 48 percent), Egypt and Iraq (each up 35 percent), India (up 34 percent), Ethiopia (up 32 percent), Pakistan (up 27 percent), Ghana (up 25 percent), the Dominican Republic (up 21 percent), Honduras (up 15 percent), Guatemala and the Philippines (each up 12 percent), and Iran (up 11 percent). \n• States with the largest numerical increases in the number of immigrants from 2010 to 2015 were California (up 538,000), Texas (up 529,000), Florida (up 428,000), New York (up 232,000), New Jersey (up 133,000), Massachusetts (up 112,000), Maryland (up 108,000), Virginia (up 108,000), Pennsylvania (up 98,000), Washington (up 94,000), Georgia (up 81,000), Minnesota (up 79,000), and North Carolina (up 76,000). \n• States with the largest percentage increases in the number of immigrants from 2010 to 2015 were North Dakota (up 72 percent), Wyoming (up 39 percent), West Virginia (up 31 percent), South Dakota (up 25 percent), Delaware (up 22 percent), Minnesota (up 21 percent), Alaska (up 19 percent), Mississippi (up 18 percent), Tennessee and New Hampshire (each up 15 percent), Nebraska and Oklahoma (each up 14 percent), and Maryland, Pennsylvania, and Texas (each up 13 percent).",
		"thread_title": "Immigration Surging; 1.5 Million Arriving Each Year",
		"title": "Immigration Surging; 1.5 Million Arriving Each Year",
		"type": "bs",
		"uuid": "32796de019cf79e73f88c5f77579ca8371856b55"
	},
	"-KhIgvWssRtKClkqYg0j": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:10.018+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.09495367,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06z1m0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pew_Charitable_Trusts"
				},
				"name": "Pew",
				"salience": 0.09495367,
				"type": "PERSON"
			},
			{
				"name": "labor",
				"salience": 0.077959985,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0712026,
				"type": "OTHER"
			},
			{
				"name": "Million Illegal Immigrant Workers",
				"salience": 0.068519294,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.060808755,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sjhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Examiner"
				},
				"name": "Washington Examiner",
				"salience": 0.04980907,
				"type": "ORGANIZATION"
			},
			{
				"name": "Joseph Lawler",
				"salience": 0.04980907,
				"type": "PERSON"
			},
			{
				"name": "workforce",
				"salience": 0.04617438,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.03349368,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.024417974,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03qk63k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Recession"
				},
				"name": "Great Recession",
				"salience": 0.020702679,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.01883284,
				"type": "PERSON"
			},
			{
				"name": "immigrant",
				"salience": 0.014549711,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08qtd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pew_Research_Center"
				},
				"name": "Pew Research Center",
				"salience": 0.014003271,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.013936967,
				"type": "WORK_OF_ART"
			},
			{
				"name": "researchers",
				"salience": 0.013936967,
				"type": "PERSON"
			},
			{
				"name": "workforce",
				"salience": 0.013641531,
				"type": "OTHER"
			},
			{
				"name": "labor force",
				"salience": 0.01341889,
				"type": "OTHER"
			},
			{
				"name": "share",
				"salience": 0.01341889,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.013387877,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.013151815,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.012075207,
				"type": "LOCATION"
			},
			{
				"name": "reliance",
				"salience": 0.012075207,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.012075207,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.011531399,
				"type": "WORK_OF_ART"
			},
			{
				"name": "immigrant workforce",
				"salience": 0.01020125,
				"type": "PERSON"
			},
			{
				"name": "migration",
				"salience": 0.009864363,
				"type": "EVENT"
			},
			{
				"name": "much",
				"salience": 0.009864363,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqj4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Census_Bureau"
				},
				"name": "U.S. Census",
				"salience": 0.007442559,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jeffrey Passel",
				"salience": 0.007442559,
				"type": "PERSON"
			},
			{
				"name": "D'Vera Cohn",
				"salience": 0.007442559,
				"type": "PERSON"
			},
			{
				"name": "deportation",
				"salience": 0.007374222,
				"type": "EVENT"
			},
			{
				"name": "crash",
				"salience": 0.007374222,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.00687039,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.00687039,
				"type": "OTHER"
			},
			{
				"name": "executive orders",
				"salience": 0.006204387,
				"type": "OTHER"
			},
			{
				"name": "orders",
				"salience": 0.006204387,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.0060781213,
				"type": "LOCATION"
			},
			{
				"name": "labor force",
				"salience": 0.004636683,
				"type": "ORGANIZATION"
			},
			{
				"name": "crisis",
				"salience": 0.004636683,
				"type": "EVENT"
			},
			{
				"name": "share",
				"salience": 0.004636683,
				"type": "OTHER"
			},
			{
				"name": "housing bubble",
				"salience": 0.004015569,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Pew: 8 Million Illegal Immigrant Workers in the U.S. in 2014 Joseph Lawler, Washington Examiner, November 3, 2016 \nThere were about 8 million illegal immigrants in the U.S. workforce in 2014, a number that didn’t change significantly since the end of the Great Recession in 2009, according to the Pew Research Center. \nBut as a share of the overall labor force, illegal immigrants have declined slightly from 2009 to 2014, from 5.2 percent to 5 percent. \nThursday’s report, written by researchers Jeffrey Passel and D’Vera Cohn and based on U.S. Census figures, indicates that the country’s reliance on unauthorized labor hasn’t changed much since the 2008 financial crisis, which drastically slowed or even reversed migration from Mexico. The report examines the illegal immigrant workforce up through 2014. \nBefore the crisis, especially as the housing bubble inflated, the share of unauthorized labor soared, from below 3 percent of the labor force in the 1990s to 5.4 percent just prior to the crash. \n{snip} \nAbout 10 percent of the illegal immigrant workforce has been protected from deportation, according to Pew, by executive orders from President Obama . Hillary Clinton has said that she will expand on those orders. {snip} \n{snip}",
		"thread_title": "Pew: 8 Million Illegal Immigrant Workers in the U.S. in 2014",
		"title": "Pew: 8 Million Illegal Immigrant Workers in the U.S. in 2014",
		"type": "bs",
		"uuid": "53ca572a79f346e9907824d0aca344a963de10af"
	},
	"-KhIgvkWEOixqBHY-dy2": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:10.432+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "probe",
				"salience": 0.14091755,
				"type": "OTHER"
			},
			{
				"name": "art",
				"salience": 0.11393679,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Vandalism",
				"salience": 0.10043114,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0237m8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boyle_Heights,_Los_Angeles"
				},
				"name": "Boyle Heights",
				"salience": 0.08959369,
				"type": "LOCATION"
			},
			{
				"name": "gallery",
				"salience": 0.06776656,
				"type": "LOCATION"
			},
			{
				"name": "hate crime",
				"salience": 0.056150213,
				"type": "OTHER"
			},
			{
				"name": "Brittny Mejia",
				"salience": 0.04104512,
				"type": "PERSON"
			},
			{
				"name": "galleries",
				"salience": 0.03226352,
				"type": "LOCATION"
			},
			{
				"name": "art galleries",
				"salience": 0.03210653,
				"type": "LOCATION"
			},
			{
				"name": "hate crimes",
				"salience": 0.022983592,
				"type": "EVENT"
			},
			{
				"name": "vandalism",
				"salience": 0.02125276,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.016657157,
				"type": "OTHER"
			},
			{
				"name": "galleries",
				"salience": 0.016157353,
				"type": "ORGANIZATION"
			},
			{
				"name": "Possible Hate Crimes Sparked",
				"salience": 0.014213132,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01g0n9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_Police_Department"
				},
				"name": "Los Angeles Police Department",
				"salience": 0.012046314,
				"type": "ORGANIZATION"
			},
			{
				"name": "gentrification",
				"salience": 0.011792926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01p06z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_Times"
				},
				"name": "Los Angeles Times",
				"salience": 0.010286859,
				"type": "ORGANIZATION"
			},
			{
				"name": "Defend Boyle Heights",
				"salience": 0.007627211,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.0071478854,
				"type": "LOCATION"
			},
			{
				"name": "graffiti",
				"salience": 0.0070674377,
				"type": "OTHER"
			},
			{
				"name": "Galleries",
				"salience": 0.006839891,
				"type": "ORGANIZATION"
			},
			{
				"name": "Defend Boyle Heights",
				"salience": 0.0053960043,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0052018953,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.00450585,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.00450585,
				"type": "LOCATION"
			},
			{
				"name": "art",
				"salience": 0.0038909537,
				"type": "WORK_OF_ART"
			},
			{
				"name": "gentrification",
				"salience": 0.0038547276,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0036497375,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.0036147335,
				"type": "OTHER"
			},
			{
				"name": "downtown",
				"salience": 0.0035243453,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.0035243453,
				"type": "OTHER"
			},
			{
				"name": "art scene",
				"salience": 0.0035243453,
				"type": "OTHER"
			},
			{
				"name": "artists",
				"salience": 0.0035243453,
				"type": "PERSON"
			},
			{
				"name": "Activists",
				"salience": 0.0034909775,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.003161014,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.003161014,
				"type": "LOCATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.003081952,
				"type": "LOCATION"
			},
			{
				"name": "families",
				"salience": 0.0030660627,
				"type": "PERSON"
			},
			{
				"name": "station",
				"salience": 0.0030431643,
				"type": "ORGANIZATION"
			},
			{
				"name": "activists",
				"salience": 0.0029803414,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0029803414,
				"type": "OTHER"
			},
			{
				"name": "Community activists",
				"salience": 0.0029803414,
				"type": "PERSON"
			},
			{
				"name": "Nicodim Gallery",
				"salience": 0.0029569631,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.0028544224,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.0027479855,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0027479855,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0025811256,
				"type": "LOCATION"
			},
			{
				"name": "home prices",
				"salience": 0.0024720503,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0024720503,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0024720503,
				"type": "OTHER"
			},
			{
				"name": "flashpoint",
				"salience": 0.0024720503,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0024720503,
				"type": "OTHER"
			},
			{
				"name": "curse",
				"salience": 0.0023798526,
				"type": "OTHER"
			},
			{
				"name": "anti-white",
				"salience": 0.0023798526,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0023307053,
				"type": "PERSON"
			},
			{
				"name": "Gentrification",
				"salience": 0.0022077954,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bk5xk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arts_District,_Los_Angeles"
				},
				"name": "Arts District",
				"salience": 0.0021703925,
				"type": "LOCATION"
			},
			{
				"name": "Latino Eastside",
				"salience": 0.0021703925,
				"type": "LOCATION"
			},
			{
				"name": "art galleries",
				"salience": 0.002134432,
				"type": "LOCATION"
			},
			{
				"name": "change",
				"salience": 0.0021233591,
				"type": "OTHER"
			},
			{
				"name": "zone",
				"salience": 0.0020184102,
				"type": "LOCATION"
			},
			{
				"name": "property values",
				"salience": 0.0020184102,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0019285926,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.0019208064,
				"type": "LOCATION"
			},
			{
				"name": "eviction notices",
				"salience": 0.0018351071,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_4s8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Highland_Park,_Los_Angeles"
				},
				"name": "Highland Park",
				"salience": 0.0017575828,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027sjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Echo_Park,_Los_Angeles"
				},
				"name": "Echo Park",
				"salience": 0.0017575828,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.001755758,
				"type": "PERSON"
			},
			{
				"name": "gentrification",
				"salience": 0.0017134894,
				"type": "OTHER"
			},
			{
				"name": "Hollenbeck",
				"salience": 0.0016920068,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.001622265,
				"type": "OTHER"
			},
			{
				"name": "hate crime",
				"salience": 0.0015206126,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0015206126,
				"type": "OTHER"
			},
			{
				"name": "rebel",
				"salience": 0.0015080175,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0015080175,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0015080175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vjs6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detective"
				},
				"name": "Det",
				"salience": 0.0014652223,
				"type": "WORK_OF_ART"
			},
			{
				"name": "snip",
				"salience": 0.0014048208,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0014048208,
				"type": "WORK_OF_ART"
			},
			{
				"name": "gentrifiers",
				"salience": 0.0012801467,
				"type": "PERSON"
			},
			{
				"name": "John Parra",
				"salience": 0.0012745043,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b44hm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._Route_101_in_California"
				},
				"name": "101 Freeway",
				"salience": 0.0012425942,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01g7zj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexican_American"
				},
				"name": "Mexican American",
				"salience": 0.0012425942,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0011702836,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0011702836,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0011667449,
				"type": "OTHER"
			},
			{
				"name": "displacement",
				"salience": 0.0011409812,
				"type": "OTHER"
			},
			{
				"name": "art washing",
				"salience": 0.0010983968,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.001084558,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0010494951,
				"type": "OTHER"
			},
			{
				"name": "dialogue",
				"salience": 0.00095540064,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0009475948,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0008967068,
				"type": "OTHER"
			},
			{
				"name": "activist group",
				"salience": 0.0008205404,
				"type": "ORGANIZATION"
			},
			{
				"name": "gallery owners",
				"salience": 0.0008205404,
				"type": "PERSON"
			},
			{
				"name": "couple",
				"salience": 0.0008205404,
				"type": "PERSON"
			},
			{
				"name": "Hollenbeck Division",
				"salience": 0.00050502,
				"type": "ORGANIZATION"
			},
			{
				"name": "incidents",
				"salience": 0.00036142327,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "LAPD Investigating Boyle Heights Vandalism as Possible Hate Crimes Sparked by Gentrification Fight Brittny Mejia, Los Angeles Times, November 3, 2016 \nThe Los Angeles Police Department is treating three acts of vandalism in the last month targeting art galleries in Boyle Heights, including graffiti at one gallery that attacked “white art,” as possible hate crimes. \nThe probe comes amid a debate in the predominantly Latino Eastside neighborhood over the growing art scene there and whether it’s part of a gentrification that some activists fear will push working-class families out. Galleries have been popping up in the area over the last few years as some artists get priced out of downtown’s Arts District and other areas. \n“We don’t know who actually did [the vandalism], but because it actually made a reference to anti-white art or anti-white, it’s basically saying that it’s a hate crime based on that,” Det. John Parra of the LAPD’s Hollenbeck station said of a vulgar curse against “white art” that in one of the incidents was spray-painted on the Nicodim Gallery. \nBoyle Heights has become a flashpoint as Los Angeles undergoes a wave of gentrification fueled by rising home prices and a renewed interest in urban neighborhoods by many. It’s already transformed once-working-class communities such as Echo Park and Highland Park. But some in Boyle Heights–for decades the heart of L.A.’s Mexican American community–have vowed to fight the change. \nIn the last three years, more than a dozen galleries have appeared in the area , many in an industrial zone just west of the 101 Freeway. Community activists fear the galleries will inflate property values and push poorer residents out. \nIn September, activists marched through Boyle Heights and posted mock eviction notices for “gentrifiers,” which included a couple of galleries. \n{snip} \nBut the three incidents prompted the Hollenbeck Division to call a meeting with gallery owners last week to try to get an understanding of the problem and come up with a plan, including attempting to open a dialogue with the activist group Defend Boyle Heights, which has been a driving force of opposition to the galleries. \n{snip} \nOn Thursday afternoon, Defend Boyle Heights issued a statement saying it was not responsible for vandalizing the galleries. \n“We don’t know who tagged up these galleries, but we . . . certainly don’t condemn it. It is right to rebel! We are glad to see the community rise up to resist displacement, art washing and gentrification–however they see fit! Your anger is justified,” the statement read. \n“Gentrification is the true, highest form of hate crime!” \nActivists have demanded that the art galleries leave the neighborhood and allow the community to decide what will take their place. \n{snip}",
		"thread_title": "LAPD Investigating Boyle Heights Vandalism as Possible Hate Crimes Sparked by Gentrification Fight",
		"title": "LAPD Investigating Boyle Heights Vandalism as Possible Hate Crimes Sparked by Gentrification Fight",
		"type": "bs",
		"uuid": "72137dd153d272fb45dbb419fcbe292e9ef44c9a"
	},
	"-KhIgw2d1Cv-2SnS9DLj": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:11.882+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.5746184,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fzdz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Arpaio"
				},
				"name": "Joe Arpaio",
				"salience": 0.10142165,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.06703414,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0m27n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maricopa_County,_Arizona"
				},
				"name": "Maricopa County",
				"salience": 0.05282702,
				"type": "LOCATION"
			},
			{
				"name": "law enforcement campaigns",
				"salience": 0.017665643,
				"type": "EVENT"
			},
			{
				"name": "spending",
				"salience": 0.013296343,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.010421201,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06y3r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steve_Jobs"
				},
				"name": "Steve Jobs",
				"salience": 0.00994526,
				"type": "PERSON"
			},
			{
				"name": "Defeat Arpaio Scott Bland",
				"salience": 0.008219447,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0mrhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harris_County,_Texas"
				},
				"name": "Harris County",
				"salience": 0.0076361448,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0074262316,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.0074262316,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025zhrp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laurene_Powell_Jobs"
				},
				"name": "Laurene Powell Jobs",
				"salience": 0.0070163477,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02cl1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denver"
				},
				"name": "Denver",
				"salience": 0.0050947065,
				"type": "LOCATION"
			},
			{
				"name": "Bill Montgomery",
				"salience": 0.0044509033,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01btlh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Political_action_committee"
				},
				"name": "PAC",
				"salience": 0.0038372197,
				"type": "ORGANIZATION"
			},
			{
				"name": "Paul Penzone",
				"salience": 0.0038353726,
				"type": "PERSON"
			},
			{
				"name": "campaign finance documents",
				"salience": 0.0037044077,
				"type": "OTHER"
			},
			{
				"name": "Maricopa Strong",
				"salience": 0.0034459755,
				"type": "OTHER"
			},
			{
				"name": "energy billionaires",
				"salience": 0.0028189903,
				"type": "PERSON"
			},
			{
				"name": "spending",
				"salience": 0.002547533,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.0025457568,
				"type": "OTHER"
			},
			{
				"name": "funding campaigns",
				"salience": 0.0025380715,
				"type": "EVENT"
			},
			{
				"name": "counties",
				"salience": 0.0024116293,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0023217518,
				"type": "LOCATION"
			},
			{
				"name": "prosecutors",
				"salience": 0.0022614822,
				"type": "PERSON"
			},
			{
				"name": "ones",
				"salience": 0.0022614822,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0022049327,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0021616078,
				"type": "ORGANIZATION"
			},
			{
				"name": "district attorney races",
				"salience": 0.0020606644,
				"type": "EVENT"
			},
			{
				"name": "groups",
				"salience": 0.0020091275,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.0017580044,
				"type": "EVENT"
			},
			{
				"name": "race",
				"salience": 0.0017478341,
				"type": "EVENT"
			},
			{
				"name": "sheriff",
				"salience": 0.0017478341,
				"type": "PERSON"
			},
			{
				"name": "Maricopa Strong",
				"salience": 0.0017363792,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.0017192195,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.001619909,
				"type": "EVENT"
			},
			{
				"name": "billionaire",
				"salience": 0.0016148271,
				"type": "PERSON"
			},
			{
				"name": "immigration reform",
				"salience": 0.0016148271,
				"type": "OTHER"
			},
			{
				"name": "reform",
				"salience": 0.0016148271,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0016088246,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05d5804"
				},
				"name": "Laura",
				"salience": 0.0015679324,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07df0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_D._Arnold"
				},
				"name": "John Arnold",
				"salience": 0.0015679324,
				"type": "PERSON"
			},
			{
				"name": "investment",
				"salience": 0.001553519,
				"type": "OTHER"
			},
			{
				"name": "campaign finance filings",
				"salience": 0.0015465864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "incumbent",
				"salience": 0.0015465864,
				"type": "PERSON"
			},
			{
				"name": "criminal justice reform measures",
				"salience": 0.0014889048,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.0014889048,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.0014581567,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0014581567,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apple_Inc."
				},
				"name": "Apple",
				"salience": 0.0013578604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0013578604,
				"type": "LOCATION"
			},
			{
				"name": "dollar investment",
				"salience": 0.0013343911,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0013175885,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0013060041,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0013060041,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0013060041,
				"type": "OTHER"
			},
			{
				"name": "policy passion",
				"salience": 0.001262776,
				"type": "OTHER"
			},
			{
				"name": "bogeyman",
				"salience": 0.001262776,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0011720102,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00095221755,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0p061",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gilpin_County,_Colorado"
				},
				"name": "Gilpin",
				"salience": 0.00095221755,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0p03t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jefferson_County,_Colorado"
				},
				"name": "Jefferson",
				"salience": 0.00095221755,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d35y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix,_Arizona"
				},
				"name": "Phoenix",
				"salience": 0.00095221755,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0009513393,
				"type": "OTHER"
			},
			{
				"name": "disclosure rules",
				"salience": 0.0009434595,
				"type": "OTHER"
			},
			{
				"name": "globalist",
				"salience": 0.0009434595,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03l2n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houston"
				},
				"name": "Houston",
				"salience": 0.00091668556,
				"type": "LOCATION"
			},
			{
				"name": "campaigns",
				"salience": 0.0008756276,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.00080089684,
				"type": "LOCATION"
			},
			{
				"name": "TV ads",
				"salience": 0.00079357583,
				"type": "WORK_OF_ART"
			},
			{
				"name": "millions",
				"salience": 0.0007737068,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0007107256,
				"type": "EVENT"
			},
			{
				"name": "attempt",
				"salience": 0.0006871889,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0006871889,
				"type": "OTHER"
			},
			{
				"name": "name recognition",
				"salience": 0.0006871889,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0006871889,
				"type": "OTHER"
			},
			{
				"name": "TV ads",
				"salience": 0.00059284276,
				"type": "WORK_OF_ART"
			},
			{
				"name": "funder",
				"salience": 0.00059284276,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/041jxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Arizona_Republic"
				},
				"name": "Arizona Republic",
				"salience": 0.00058075873,
				"type": "ORGANIZATION"
			},
			{
				"name": "donations",
				"salience": 0.000577997,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0005754154,
				"type": "OTHER"
			},
			{
				"name": "flurry",
				"salience": 0.00051335385,
				"type": "OTHER"
			},
			{
				"name": "mailers",
				"salience": 0.00051335385,
				"type": "WORK_OF_ART"
			},
			{
				"name": "others",
				"salience": 0.00051335385,
				"type": "PERSON"
			},
			{
				"name": "Arnolds",
				"salience": 0.0003648883,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Soros Spends $2 Million to Defeat Arpaio Scott Bland, Politico, November 4, 2016 \nGeorge Soros has contributed $2 million to a group working to defeat Maricopa County Sheriff Joe Arpaio in Arizona, the latest target of Soros’ big spending in local law enforcement campaigns over the past year. \nThe Soros-funded PAC, Maricopa Strong, will file campaign finance documents Friday showing Soros’ multi-million dollar investment against Arpaio, along with $500,000 from Texas energy billionaires Laura and John Arnold and $250,000 from Laurene Powell Jobs (the widow of Apple co-founder Steve Jobs). The group had previously reported a $300,000 donation from Soros, one of the Democratic Party’s biggest donors. \nSoros has spent millions in 2015 and 2016 funding campaigns to defeat local prosecutors around the country and elect new ones who back criminal justice reform measures. Soros-backed groups are currently spending big in three big-city district attorney races: Houston’s Harris County, where Soros has contributed over $1 million, according to local campaign finance filings; Gilpin and Jefferson counties outside Denver, where Soros has given about $1.5 million to unseat an incumbent; and Phoenix’s Maricopa County, where a Soros-funded PAC has also spent over $1 million against the Republican district attorney, Bill Montgomery. \nBut Soros’ spending against Arpaio, a high-profile liberal bogeyman, is his single biggest investment in a local race this year, as well as the billionaire’s first effort against a sheriff. It folds in immigration reform, another policy passion of Soros’, alongside criminal justice reform. \n{snip} \nMaricopa Strong has spent $2.9 million in the sheriff’s race, with the donations from Soros and others funding a flurry of mailers and TV ads boosting Democratic candidate Paul Penzone and hammering Arpaio. Soros has typically been the sole funder of his local outside-spending campaigns around the country, though Jobs and the Arnolds joined him in funding Maricopa Strong. \n{snip} \nArpaio’s campaign has attacked Soros’ efforts, calling him a “far-left globalist,” saying he is trying to buy a local race, and alleging that his group has broken disclosure rules, per the Arizona Republic. \n{snip} \nArpaio has aired about $2.8 million of his own TV ads, according to a media-tracking source, and has leaned on his national name recognition to raise millions more for his campaign, while Penzone’s campaign has been less well-funded. But several polls this fall have shown Penzone leading Arpaio in his second attempt to unseat the sheriff. \n{snip}",
		"thread_title": "Soros Spends $2 Million to Defeat Arpaio",
		"title": "Soros Spends $2 Million to Defeat Arpaio",
		"type": "bs",
		"uuid": "00ecd7fc7097c0078eabe3f6dcb3077da971f47e"
	},
	"-KhIgwLk9rUpz7ja2hdo": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:17.730+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Devaluation of Black Communities Brian Flood",
				"salience": 0.12806933,
				"type": "OTHER"
			},
			{
				"name": "Studies",
				"salience": 0.04528253,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.045036342,
				"type": "LOCATION"
			},
			{
				"name": "study participants",
				"salience": 0.03715982,
				"type": "PERSON"
			},
			{
				"name": "Pollution",
				"salience": 0.036771122,
				"type": "OTHER"
			},
			{
				"name": "biases",
				"salience": 0.036771122,
				"type": "OTHER"
			},
			{
				"name": "pollution",
				"salience": 0.036771122,
				"type": "OTHER"
			},
			{
				"name": "devaluation",
				"salience": 0.03324391,
				"type": "OTHER"
			},
			{
				"name": "black communities",
				"salience": 0.03324391,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.03324391,
				"type": "OTHER"
			},
			{
				"name": "psychologist",
				"salience": 0.03324391,
				"type": "PERSON"
			},
			{
				"name": "neighborhood",
				"salience": 0.026483981,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01y17m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Illinois_at_Chicago"
				},
				"name": "University of Illinois at Chicago",
				"salience": 0.02519276,
				"type": "LOCATION"
			},
			{
				"name": "citizens",
				"salience": 0.020411488,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.019173305,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.014797789,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.014272313,
				"type": "LOCATION"
			},
			{
				"name": "target area",
				"salience": 0.01177455,
				"type": "LOCATION"
			},
			{
				"name": "researchers",
				"salience": 0.011117916,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.010801025,
				"type": "LOCATION"
			},
			{
				"name": "observers",
				"salience": 0.010635307,
				"type": "PERSON"
			},
			{
				"name": "Courtney Bonam",
				"salience": 0.010160526,
				"type": "PERSON"
			},
			{
				"name": "chemical plant",
				"salience": 0.009675049,
				"type": "LOCATION"
			},
			{
				"name": "spaces",
				"salience": 0.009520287,
				"type": "OTHER"
			},
			{
				"name": "spaces",
				"salience": 0.009520287,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.009520287,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.009197981,
				"type": "OTHER"
			},
			{
				"name": "houses",
				"salience": 0.00901471,
				"type": "LOCATION"
			},
			{
				"name": "pollution",
				"salience": 0.008861802,
				"type": "OTHER"
			},
			{
				"name": "stereotyping",
				"salience": 0.008451171,
				"type": "OTHER"
			},
			{
				"name": "stereotypes",
				"salience": 0.008451171,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.008302077,
				"type": "PERSON"
			},
			{
				"name": "bias",
				"salience": 0.0078090313,
				"type": "OTHER"
			},
			{
				"name": "proposal",
				"salience": 0.0076139434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "proposal",
				"salience": 0.0076139434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "perceptions",
				"salience": 0.0070524425,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.006681016,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.006432118,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.006432118,
				"type": "LOCATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.006191444,
				"type": "LOCATION"
			},
			{
				"name": "discrimination",
				"salience": 0.0061086,
				"type": "OTHER"
			},
			{
				"name": "stereotypes",
				"salience": 0.005930029,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.005763655,
				"type": "LOCATION"
			},
			{
				"name": "participants",
				"salience": 0.005679677,
				"type": "PERSON"
			},
			{
				"name": "sample",
				"salience": 0.005475232,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0052748434,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.00518163,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0051659825,
				"type": "PERSON"
			},
			{
				"name": "findings",
				"salience": 0.004947783,
				"type": "OTHER"
			},
			{
				"name": "psychology",
				"salience": 0.004763339,
				"type": "OTHER"
			},
			{
				"name": "stereotypes",
				"salience": 0.0047214855,
				"type": "OTHER"
			},
			{
				"name": "neighborhood",
				"salience": 0.0046272525,
				"type": "LOCATION"
			},
			{
				"name": "Half",
				"salience": 0.0044741803,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.0044741803,
				"type": "OTHER"
			},
			{
				"name": "segment",
				"salience": 0.0043116985,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.0042851535,
				"type": "OTHER"
			},
			{
				"name": "judgment",
				"salience": 0.0042851535,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0042851535,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.0041253725,
				"type": "OTHER"
			},
			{
				"name": "lead author",
				"salience": 0.0041253725,
				"type": "PERSON"
			},
			{
				"name": "harms",
				"salience": 0.0041253725,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.0040917015,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0040774387,
				"type": "OTHER"
			},
			{
				"name": "chemical plant",
				"salience": 0.003939123,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.003910919,
				"type": "LOCATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.0035464545,
				"type": "LOCATION"
			},
			{
				"name": "opposition",
				"salience": 0.0034989545,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0034549017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "neighborhood",
				"salience": 0.003371195,
				"type": "LOCATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.003371195,
				"type": "LOCATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.003371195,
				"type": "LOCATION"
			},
			{
				"name": "Half",
				"salience": 0.0033432837,
				"type": "PERSON"
			},
			{
				"name": "characteristics",
				"salience": 0.0033260393,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0032051178,
				"type": "OTHER"
			},
			{
				"name": "sample",
				"salience": 0.003018869,
				"type": "OTHER"
			},
			{
				"name": "perceptions",
				"salience": 0.003018869,
				"type": "OTHER"
			},
			{
				"name": "attitudes",
				"salience": 0.0026143123,
				"type": "OTHER"
			},
			{
				"name": "class level",
				"salience": 0.0026143123,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.0026143123,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.002540133,
				"type": "PERSON"
			},
			{
				"name": "pictures",
				"salience": 0.0022454327,
				"type": "WORK_OF_ART"
			},
			{
				"name": "value",
				"salience": 0.0021990398,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0021990398,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0021011569,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0019042685,
				"type": "ORGANIZATION"
			},
			{
				"name": "findings",
				"salience": 0.0016428509,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0014225941,
				"type": "LOCATION"
			},
			{
				"name": "property values",
				"salience": 0.00122727,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Studies Examine Racial Bias in Pollution, Devaluation of Black Communities Brian Flood, UIC, November 3, 2016 \nPresent-day racial biases may contribute to the pollution and devaluation of lower- and middle-class black communities, according to new research led by a social psychologist at the University of Illinois at Chicago. \nThe investigation was based on several studies demonstrating that physical spaces, such as houses or neighborhoods, are targets of racial stereotyping, discrimination, and implicit racial bias. \nThe researchers found study participants applied negative stereotypes, such as “impoverished,” “crime-ridden,” or “dirty,” in their perceptions of physical spaces associated with black Americans. \n“These space-focused stereotypes can make people feel less connected to a space, assume it has low-quality characteristics, monetarily devalue it, and dampen its protection from environmental harms,” said Courtney Bonam, UIC assistant professor of psychology and the study’s lead author. \n“Some of the findings show that space-focused stereotypes figuratively pollute the way observers imagine a target area and their judgment about an existing structure in it, while other work demonstrates how this presumed figurative pollution leads observers to consider literally polluting black space.” \n{snip} \nOne study asked a national sample of over 400 white U.S. citizens to read a proposal to build a potentially hazardous chemical plant near a residential neighborhood. Half of the participants were told the nearby neighborhood is mostly black, while the other half was told that the area is mostly white. \nEven though all participants read the same proposal, they were less likely to report opposition to building the chemical plant when the nearby neighborhood was mostly black. \n“They assumed it was an industrial area when it was black, which led them to devalue and subsequently pollute the land there,” Bonam said. “Additionally, these findings held when participants were told that the neighborhood had middle-class property values; and when accounting both for participants’ perceptions of the neighborhood’s class level, and their negative attitudes toward black people in general.” \nIn another study, a national sample of more than 200 white U.S. citizens were given pictures of the same middle-class, suburban house. Half of the people were told the house was in a predominately black neighborhood, while the other segment was informed that it was in a mostly white neighborhood. \nThose who thought the house was in a black neighborhood estimated its value at $20,000 less than the other group, and were less likely to say they would live in or buy the house. \n{snip}",
		"thread_title": "Studies Examine Racial Bias in Pollution, Devaluation of Black Communities",
		"title": "Studies Examine Racial Bias in Pollution, Devaluation of Black Communities",
		"type": "bs",
		"uuid": "b886e76842bb603e0ae6df46169ca6bb076d7923"
	},
	"-KhIgwb3qHXnmY9TZ3_B": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:19.122+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Khavich",
				"salience": 0.2857847,
				"type": "PERSON"
			},
			{
				"name": "Milo Yiannopoulos",
				"salience": 0.18075019,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.07215182,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.02687092,
				"type": "OTHER"
			},
			{
				"name": "college event",
				"salience": 0.02105961,
				"type": "EVENT"
			},
			{
				"name": "views",
				"salience": 0.02105961,
				"type": "OTHER"
			},
			{
				"name": "student newspaper",
				"salience": 0.02105961,
				"type": "ORGANIZATION"
			},
			{
				"name": "column",
				"salience": 0.02048926,
				"type": "WORK_OF_ART"
			},
			{
				"name": "College Fix",
				"salience": 0.016609691,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.014485867,
				"type": "PERSON"
			},
			{
				"name": "immigration enforcement",
				"salience": 0.01389893,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.013004918,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ks67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rutgers_University"
				},
				"name": "Rutgers University",
				"salience": 0.013004918,
				"type": "ORGANIZATION"
			},
			{
				"name": "term",
				"salience": 0.011935312,
				"type": "OTHER"
			},
			{
				"name": "Toni Airaksinen",
				"salience": 0.011319253,
				"type": "PERSON"
			},
			{
				"name": "straw",
				"salience": 0.0110602705,
				"type": "OTHER"
			},
			{
				"name": "Aviv",
				"salience": 0.0107986685,
				"type": "PERSON"
			},
			{
				"name": "editor",
				"salience": 0.009589928,
				"type": "PERSON"
			},
			{
				"name": "term",
				"salience": 0.00841383,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.0075629735,
				"type": "WORK_OF_ART"
			},
			{
				"name": "immigrant",
				"salience": 0.006945106,
				"type": "PERSON"
			},
			{
				"name": "trigger",
				"salience": 0.006679948,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09t2g_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Targum"
				},
				"name": "The Daily Targum",
				"salience": 0.006657081,
				"type": "ORGANIZATION"
			},
			{
				"name": "collapse",
				"salience": 0.0061647645,
				"type": "EVENT"
			},
			{
				"name": "aliens",
				"salience": 0.0051439987,
				"type": "OTHER"
			},
			{
				"name": "columns",
				"salience": 0.0049187657,
				"type": "OTHER"
			},
			{
				"name": "columns",
				"salience": 0.0049187657,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.004872969,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.004872969,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0046913554,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.0046867626,
				"type": "PERSON"
			},
			{
				"name": "Justice",
				"salience": 0.0046485276,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.004455302,
				"type": "LOCATION"
			},
			{
				"name": "phrase",
				"salience": 0.004455302,
				"type": "OTHER"
			},
			{
				"name": "demand",
				"salience": 0.004455302,
				"type": "OTHER"
			},
			{
				"name": "firing",
				"salience": 0.004455302,
				"type": "EVENT"
			},
			{
				"name": "wake",
				"salience": 0.004455302,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.0044449475,
				"type": "WORK_OF_ART"
			},
			{
				"name": "editors",
				"salience": 0.004350171,
				"type": "PERSON"
			},
			{
				"name": "Style",
				"salience": 0.0037586743,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0036270998,
				"type": "OTHER"
			},
			{
				"name": "alien",
				"salience": 0.0036083972,
				"type": "OTHER"
			},
			{
				"name": "Justice",
				"salience": 0.0036083972,
				"type": "OTHER"
			},
			{
				"name": "Daily",
				"salience": 0.0034738425,
				"type": "ORGANIZATION"
			},
			{
				"name": "deportation",
				"salience": 0.0033293748,
				"type": "EVENT"
			},
			{
				"name": "instance",
				"salience": 0.0031250138,
				"type": "OTHER"
			},
			{
				"name": "phone interview",
				"salience": 0.0031250138,
				"type": "EVENT"
			},
			{
				"name": "family",
				"salience": 0.0031250138,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0031250138,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0031250138,
				"type": "PERSON"
			},
			{
				"name": "column",
				"salience": 0.0031177467,
				"type": "WORK_OF_ART"
			},
			{
				"name": "two",
				"salience": 0.0030084606,
				"type": "PERSON"
			},
			{
				"name": "editing changes",
				"salience": 0.0030084606,
				"type": "OTHER"
			},
			{
				"name": "security threat",
				"salience": 0.0030084606,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0030084606,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0029889906,
				"type": "PERSON"
			},
			{
				"name": "articles",
				"salience": 0.0029889906,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.002743669,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.002743669,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/013b6_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ashkenazi_Jews"
				},
				"name": "Ashkenazi Jewish",
				"salience": 0.002743669,
				"type": "PERSON"
			},
			{
				"name": "Editor in Chief",
				"salience": 0.0025515396,
				"type": "PERSON"
			},
			{
				"name": "top",
				"salience": 0.0025515396,
				"type": "OTHER"
			},
			{
				"name": "draft",
				"salience": 0.0025515396,
				"type": "EVENT"
			},
			{
				"name": "opinion",
				"salience": 0.0025515396,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0025515396,
				"type": "OTHER"
			},
			{
				"name": "editing",
				"salience": 0.002368137,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0163v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belarus"
				},
				"name": "Belarus",
				"salience": 0.0023566028,
				"type": "ORGANIZATION"
			},
			{
				"name": "termination",
				"salience": 0.0020507518,
				"type": "EVENT"
			},
			{
				"name": "snip",
				"salience": 0.0019654164,
				"type": "OTHER"
			},
			{
				"name": "questioning",
				"salience": 0.0019063265,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0018522271,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0018522271,
				"type": "LOCATION"
			},
			{
				"name": "The College Fix",
				"salience": 0.001661079,
				"type": "ORGANIZATION"
			},
			{
				"name": "immigrant",
				"salience": 0.0016182654,
				"type": "OTHER"
			},
			{
				"name": "narratives",
				"salience": 0.0016034725,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0016034725,
				"type": "OTHER"
			},
			{
				"name": "Dan Corey",
				"salience": 0.0015707939,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.001556344,
				"type": "PERSON"
			},
			{
				"name": "excuse",
				"salience": 0.0013885086,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.0013885086,
				"type": "OTHER"
			},
			{
				"name": "Stylebook",
				"salience": 0.0013266902,
				"type": "WORK_OF_ART"
			},
			{
				"name": "law",
				"salience": 0.001303213,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0010372613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "Associated Press",
				"salience": 0.000912547,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09rv1xz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Tab"
				},
				"name": "The Tab",
				"salience": 0.00085463637,
				"type": "WORK_OF_ART"
			},
			{
				"name": "column",
				"salience": 0.00075367297,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0j_326x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Fix_(book)"
				},
				"name": "The Fix",
				"salience": 0.0007377919,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:25:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Toni Airaksinen, College Fix, November 4, 2016 \n{snip} \nThe Rutgers University student who hosted anti-feminist provocateur Milo Yiannopoulos for his first U.S. college event says the student newspaper fired him Monday because of his conservative views. \nAviv Khavich published his final column for The Daily Targum Sunday night, arguing that immigration enforcement is not “anti-immigrant.” \nHe spoke as an immigrant himself, born in Israel after his Ashkenazi Jewish parents fled Belarus in the wake of the Soviet Union’s collapse. \nBut the trigger for the firing may have been Khavich’s demand that his column include the phrase “illegal aliens” to describe those in the country illegally. \nIt was the final straw for the Daily’s editor, who said Khavich repeatedly fought over “stylistic” editing changes to his columns over the past several months. \n{snip} \nBut two of his last three [columns] were about immigration. Khavich opposes accepting Syrian refugees into America as a security threat, and his final column Sunday said flatly: “Justice is mass deportation. Justice is respecting my [legal immigrant] family and millions of others like us.” \nKhavich told The College Fix in a phone interview that “every instance of ‘illegal alien’ I wrote was changed to ‘undocumented immigrant’” by his editors. “But I considered it a part of my opinion to not use” the latter term, which he finds “politically correct and also inaccurate.” \nWhen Khavich complained to his editor about the edited draft, she said the “illegal” edit came from the top: Editor in Chief Dan Corey wanted the column to follow Associated Press Style. \nThe AP Stylebook was revised three years ago to disapprove of using “illegal” to describe a person, as opposed to an action, after having affirmed “illegal immigrant” just a year earlier . \nBut AP Style also frowns upon “undocumented”–the term used in Khavich’s published column–because the term is “not precise.” Khavich notes that federal law uses the term “alien.” \nHis editor was “not happy” after being confronted, Khavich said, and he was fired the next day. \n{snip} \n“At the slightest questioning of their ‘unbiased editing,’ they jump at the excuse to rid themselves of someone who has been challenging their narrative,” he wrote in The Tab. \n“I was writing articles that very strongly challenged narratives,” he told The Fix. “I am sure that it was a termination was based on political bias.”",
		"thread_title": "Rutgers Student Fired from Campus Newspaper After Writing ‘Illegal Alien’ in Column",
		"title": "Rutgers Student Fired from Campus Newspaper After Writing ‘Illegal Alien’ in Column",
		"type": "bs",
		"uuid": "720bb5531bf891bd9417f8e5e2fb09bd925a4beb"
	},
	"-KhIgwpkYAMBt-g5_j7V": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:20.656+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.19670582,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.048723936,
				"type": "PERSON"
			},
			{
				"name": "Refugee Crisis",
				"salience": 0.045410123,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03zcq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dadaab"
				},
				"name": "Dadaab",
				"salience": 0.04114845,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.031234894,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.026614431,
				"type": "LOCATION"
			},
			{
				"name": "refugee crisis",
				"salience": 0.02334521,
				"type": "EVENT"
			},
			{
				"name": "Is White Privilege",
				"salience": 0.020843986,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.020775886,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.019479666,
				"type": "PERSON"
			},
			{
				"name": "responsibility",
				"salience": 0.019305587,
				"type": "OTHER"
			},
			{
				"name": "asylum-seekers",
				"salience": 0.01914873,
				"type": "PERSON"
			},
			{
				"name": "Work Mehdi Hasan",
				"salience": 0.01806392,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.01806392,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugees",
				"salience": 0.01685195,
				"type": "PERSON"
			},
			{
				"name": "test",
				"salience": 0.01597701,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02_fg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Tusk"
				},
				"name": "Donald Tusk",
				"salience": 0.01541626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.01541626,
				"type": "PERSON"
			},
			{
				"name": "throes",
				"salience": 0.014999657,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vqq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_High_Commissioner_for_Refugees"
				},
				"name": "United Nations High Commissioner for Refugees",
				"salience": 0.014716642,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06qtn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sub-Saharan_Africa"
				},
				"name": "Sub-Saharan Africa",
				"salience": 0.011744415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05xgmmg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Curtis_(British_author)"
				},
				"name": "Mark Curtis",
				"salience": 0.010822748,
				"type": "PERSON"
			},
			{
				"name": "asylum",
				"salience": 0.009841783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.009675254,
				"type": "ORGANIZATION"
			},
			{
				"name": "residents",
				"salience": 0.00933631,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.009320434,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.009247145,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.009247145,
				"type": "LOCATION"
			},
			{
				"name": "migration",
				"salience": 0.009203277,
				"type": "EVENT"
			},
			{
				"name": "refugees",
				"salience": 0.009072808,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.008734916,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.008734916,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.008475402,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.008045721,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0065932744,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0065506375,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0061888173,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0061888173,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.006007839,
				"type": "PERSON"
			},
			{
				"name": "asylum",
				"salience": 0.0057838843,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0055508004,
				"type": "LOCATION"
			},
			{
				"name": "asylum-seekers",
				"salience": 0.0050124195,
				"type": "PERSON"
			},
			{
				"name": "poor",
				"salience": 0.0050124195,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0049058306,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0048255147,
				"type": "LOCATION"
			},
			{
				"name": "homes",
				"salience": 0.0048255147,
				"type": "LOCATION"
			},
			{
				"name": "persecution",
				"salience": 0.0048255147,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.004794292,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0045542438,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.0045325053,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.0045325053,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.0045325053,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02m1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Council"
				},
				"name": "European Council",
				"salience": 0.0044008815,
				"type": "ORGANIZATION"
			},
			{
				"name": "unpeople",
				"salience": 0.004340967,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.004340967,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0042863158,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.004179066,
				"type": "EVENT"
			},
			{
				"name": "borders",
				"salience": 0.004179066,
				"type": "LOCATION"
			},
			{
				"name": "crisis",
				"salience": 0.004130497,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0040927627,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0040346496,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01hw4n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/14th_Dalai_Lama"
				},
				"name": "Dalai Lama",
				"salience": 0.00381125,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.00381125,
				"type": "LOCATION"
			},
			{
				"name": "coverage",
				"salience": 0.0037762083,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0036656996,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0035443667,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.0035443667,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.0035443667,
				"type": "OTHER"
			},
			{
				"name": "media frenzy",
				"salience": 0.0035443667,
				"type": "OTHER"
			},
			{
				"name": "standard",
				"salience": 0.0034121436,
				"type": "OTHER"
			},
			{
				"name": "refugee crisis",
				"salience": 0.003246661,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.0030089198,
				"type": "EVENT"
			},
			{
				"name": "refugee crisis",
				"salience": 0.0030089198,
				"type": "EVENT"
			},
			{
				"name": "tendency",
				"salience": 0.0028938144,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019rg5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kenya"
				},
				"name": "Kenyan",
				"salience": 0.002873083,
				"type": "LOCATION"
			},
			{
				"name": "GDP",
				"salience": 0.0026481072,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.002622198,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0025197964,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.002466892,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.002443487,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0023690094,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0023690094,
				"type": "LOCATION"
			},
			{
				"name": "privilege",
				"salience": 0.002227413,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.002182019,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01y3fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jungle"
				},
				"name": "Jungle",
				"salience": 0.002182019,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hyperbole",
				"salience": 0.00205504,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.0019948685,
				"type": "OTHER"
			},
			{
				"name": "shores",
				"salience": 0.0019288055,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.0017536142,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0016639944,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0016639944,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.0016639944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05rznz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Sudan"
				},
				"name": "South Sudan",
				"salience": 0.0016300767,
				"type": "LOCATION"
			},
			{
				"name": "oxygen",
				"salience": 0.0014408844,
				"type": "OTHER"
			},
			{
				"name": "publicity",
				"salience": 0.0014408844,
				"type": "OTHER"
			},
			{
				"name": "host",
				"salience": 0.0014408844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0008868247,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01nyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_African_Republic"
				},
				"name": "Central African Republic",
				"salience": 0.0008868247,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.0008868247,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:24:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Obsessing over Europe’s Refugee Crisis While Ignoring Africa’s Is White Privilege at Work Mehdi Hasan, Washington Post, November 3, 2016 \nHave you not heard? Europe is in the throes of a refugee crisis. Hosting asylum-seekers from Syria is a “historic test of Europe,” says Germany’s Angela Merkel. “The most responsibility [for refugees] is and will continue to be placed on Europe,” adds European Council President Donald Tusk. \nFor President Obama, “uncontrolled migration into Europe” is a “major national security issue” for the United States. Even the Dalai Lama agrees that there are “too many” refugees inside the European Union. \nReally? “Too many”? “Historic”? Consider these facts: More than 65 million people were forced from their homes by conflict or persecution in 2015, according to the United Nations High Commissioner for Refugees (UNHCR) , including 21.3 million people classified as refugees living outside the borders of their own countries. \nAdmittedly, a record 1.3 million refugees sought asylum within the European Union last year, with thousands more applying for asylum every month. Yet what of Sub-Saharan Africa, home to 4.4 million refugees and a whopping 19.5 million “people of concern” to the UN High Commissioner for Refugees? \nWe don’t often hear about these particular refugees or asylum-seekers, do we? They are, to borrow a term from British historian Mark Curtis, “unpeople,” the poor, nonwhite residents of the developing world who tend to be ignored by the Western media. \nWhere is the rolling coverage of Kenya’s Dadaab camp, for example? Dadaab is the largest refugee camp in the world, but in a move that could displace as many as 300,000 people , Kenyan authorities are in the process of closing it down. It puts the recent British media frenzy over the so-called “Jungle” camp in Calais, France, with its 10,000 migrants, into some perspective, doesn’t it? \n{snip} \nYet Europe’s refugee crisis continues to suck up all the oxygen of global publicity. The UNHCR fundraises for a whole host of “special situations” involving refugees. As of the end of October, the “ Central African Republic situation ” was 17 percent funded; the “ Somalia situation ” 21 percent funded and the “ South Sudan situation ” 25 percent funded. The “ crisis in Europe ,” however? Fifty-six percent funded. \nThe double standard is as brazen as it is shameful. Remember: The European Union accounts for 17 percent of global GDP ; Sub-Saharan Africa accounts for a little more than 3 percent . \n{snip} \nThis is not just navel-gazing hyperbole but white privilege, plain and simple. How else to describe a collective tendency to obsess over a refugee crisis in (rich, white) Europe, rather than in (poor, black) Africa? In what warped world are thousands of penniless and homeless refugees considered to constitute a crisis only when they wash up on the shores of western Europe?",
		"thread_title": "Obsessing over Europe’s Refugee Crisis While Ignoring Africa’s Is White Privilege at Work",
		"title": "Obsessing over Europe’s Refugee Crisis While Ignoring Africa’s Is White Privilege at Work",
		"type": "bs",
		"uuid": "369347b2c6ebf220653784ac9f1ce5a14691b4cf"
	},
	"-KhIgx28S3ztDRJsysMf": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:25.177+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "team",
				"salience": 0.43231177,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03ksy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_University"
				},
				"name": "Harvard",
				"salience": 0.09596662,
				"type": "ORGANIZATION"
			},
			{
				"name": "Robert L. Scalise",
				"salience": 0.032206852,
				"type": "PERSON"
			},
			{
				"name": "soccer team",
				"salience": 0.03053024,
				"type": "ORGANIZATION"
			},
			{
				"name": "documents",
				"salience": 0.02694469,
				"type": "OTHER"
			},
			{
				"name": "Men",
				"salience": 0.025784578,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.025784578,
				"type": "PERSON"
			},
			{
				"name": "Soccer Season",
				"salience": 0.02461145,
				"type": "EVENT"
			},
			{
				"name": "season",
				"salience": 0.02461145,
				"type": "EVENT"
			},
			{
				"name": "soccer team",
				"salience": 0.021589939,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.017968975,
				"type": "PERSON"
			},
			{
				"name": "review",
				"salience": 0.015873417,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027qj05",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drew_Gilpin_Faust"
				},
				"name": "Drew G. Faust",
				"salience": 0.014581789,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/080pdl8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_Crimson"
				},
				"name": "Harvard Crimson",
				"salience": 0.0113190655,
				"type": "ORGANIZATION"
			},
			{
				"name": "Finding Sexually Explicit 'Reports",
				"salience": 0.009811548,
				"type": "OTHER"
			},
			{
				"name": "Andrew M. Duehren",
				"salience": 0.009811548,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05_wyz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_counsel"
				},
				"name": "Office of General Counsel",
				"salience": 0.009811548,
				"type": "PERSON"
			},
			{
				"name": "Men",
				"salience": 0.009336698,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00828425,
				"type": "PERSON"
			},
			{
				"name": "appearance",
				"salience": 0.0075888615,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.0075888615,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.007227588,
				"type": "WORK_OF_ART"
			},
			{
				"name": "team",
				"salience": 0.006526982,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04116d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Open_Geospatial_Consortium"
				},
				"name": "OGC",
				"salience": 0.005881831,
				"type": "ORGANIZATION"
			},
			{
				"name": "season",
				"salience": 0.0052434523,
				"type": "EVENT"
			},
			{
				"name": "student athletes",
				"salience": 0.004301117,
				"type": "PERSON"
			},
			{
				"name": "team",
				"salience": 0.00374251,
				"type": "ORGANIZATION"
			},
			{
				"name": "season",
				"salience": 0.0037267704,
				"type": "EVENT"
			},
			{
				"name": "men",
				"salience": 0.003714478,
				"type": "PERSON"
			},
			{
				"name": "soccer season",
				"salience": 0.0035428402,
				"type": "EVENT"
			},
			{
				"name": "scouting report",
				"salience": 0.0033820933,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rest",
				"salience": 0.0033646696,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0032805705,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0030179524,
				"type": "PERSON"
			},
			{
				"name": "season",
				"salience": 0.0030053423,
				"type": "EVENT"
			},
			{
				"name": "decision",
				"salience": 0.0028669313,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0027972811,
				"type": "ORGANIZATION"
			},
			{
				"name": "teams",
				"salience": 0.0027972811,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.0026256768,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pieter S. Lehrer",
				"salience": 0.0025522243,
				"type": "PERSON"
			},
			{
				"name": "Tournament",
				"salience": 0.0023603966,
				"type": "EVENT"
			},
			{
				"name": "position",
				"salience": 0.0023603966,
				"type": "OTHER"
			},
			{
				"name": "soccer recruits",
				"salience": 0.0023603966,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0023549097,
				"type": "PERSON"
			},
			{
				"name": "remainder",
				"salience": 0.0022723924,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0022723924,
				"type": "OTHER"
			},
			{
				"name": "games",
				"salience": 0.0022723924,
				"type": "EVENT"
			},
			{
				"name": "opportunity",
				"salience": 0.0022723924,
				"type": "OTHER"
			},
			{
				"name": "championship",
				"salience": 0.0022723924,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0021060898,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0019360072,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0019273678,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0019273678,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0019273678,
				"type": "OTHER"
			},
			{
				"name": "lawyers",
				"salience": 0.0019273678,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0018416244,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0018284294,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01s1g7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Harvard_Crimson"
				},
				"name": "The Crimson",
				"salience": 0.0016783662,
				"type": "ORGANIZATION"
			},
			{
				"name": "coaches",
				"salience": 0.001662935,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0016224525,
				"type": "WORK_OF_ART"
			},
			{
				"name": "matter",
				"salience": 0.0015937587,
				"type": "OTHER"
			},
			{
				"name": "Harvard Athletics",
				"salience": 0.0015369727,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gh43",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Collegiate_Athletic_Association"
				},
				"name": "NCAA",
				"salience": 0.0014534649,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0014521246,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0014521246,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v_m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ivy_League"
				},
				"name": "Ivy League",
				"salience": 0.0013992399,
				"type": "ORGANIZATION"
			},
			{
				"name": "media thing",
				"salience": 0.0013012406,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0012818625,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.001211357,
				"type": "WORK_OF_ART"
			},
			{
				"name": "decision",
				"salience": 0.001211357,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.001048987,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.001048987,
				"type": "ORGANIZATION"
			},
			{
				"name": "actions",
				"salience": 0.0009049877,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0009049877,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0009049877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "respect",
				"salience": 0.0009049877,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j1s3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google_Groups"
				},
				"name": "Google Group",
				"salience": 0.0008865434,
				"type": "ORGANIZATION"
			},
			{
				"name": "value",
				"salience": 0.00083495036,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00078366,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.00078366,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:24:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Harvard Cancels Men’s Soccer Season After Finding Sexually Explicit ‘Reports’ Continued Through 2016 Andrew M. Duehren et al., Harvard Crimson, November 3, 2016 \nHarvard has cancelled the men’s soccer team’s season after an Office of General Counsel review found that the team continued to produce vulgar and explicit documents rating women on their perceived sexual appeal and physical appearance. \nAthletics Director Robert L. Scalise wrote in an email to Harvard student athletes that he decided to cancel the rest of the team’s season because the “practice appears to be more widespread across the team and has continued beyond 2012, including in 2016.” \n“As a direct result of what Harvard Athletics has learned, we have decided to cancel the remainder of the 2016 men’s soccer season,” Scalise wrote. “The team will forfeit its remaining games and will decline any opportunity to achieve an Ivy League championship or to participate in the NCAA Tournament this year.” \nLast week, The Crimson reported that the 2012 men’s soccer team created a “scouting report” of that year’s women’s soccer recruits, rating them numerically and assigning each a hypothetical sexual position. University President Drew G. Faust instructed OGC, Harvard’s team of lawyers, to “review” the matter. \n{snip} \n“The decision to cancel a season is serious and consequential, and reflects Harvard’s view that both the team’s behavior and the failure to be forthcoming when initially questioned are completely unacceptable, have no place at Harvard, and run counter to the mutual respect that is a core value of our community,” Faust wrote in a statement. \nFaust wrote she “was deeply distressed to learn that the appalling actions of the 2012 men’s soccer team were not isolated to one year or the actions of a few individuals.” \n{snip} \nLast week, when Scalise first saw the documents—which were, until recently, publicly accessible through the 2012 team’s Google Group—he said he would immediately reach out to coaches of both men’s and women’s teams to discuss the report, but added that any response should be internal to Harvard and “not a media thing.” \n{snip} \nMen’s soccer coach Pieter S. Lehrer wrote in a statement that the team is “beyond disappointed that our season has ended in this way, but we respect the decision made by our administration.” \n{snip}",
		"thread_title": "Harvard Cancels Men’s Soccer Season After Finding Sexually Explicit ‘Reports’ Continued Through 2016",
		"title": "Harvard Cancels Men’s Soccer Season After Finding Sexually Explicit ‘Reports’ Continued Through 2016",
		"type": "bs",
		"uuid": "24c4b32d5b45892af0e189199baf3ff8274515db"
	},
	"-KhIgxIgAvtvESGcLWuE": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:30:28.566+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.28542337,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austrian",
				"salience": 0.0953505,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.09114321,
				"type": "LOCATION"
			},
			{
				"name": "migrant",
				"salience": 0.08943712,
				"type": "PERSON"
			},
			{
				"name": "boy",
				"salience": 0.032946058,
				"type": "PERSON"
			},
			{
				"name": "rationale",
				"salience": 0.02377848,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.01857564,
				"type": "PERSON"
			},
			{
				"name": "emergency",
				"salience": 0.018400356,
				"type": "EVENT"
			},
			{
				"name": "Migrants",
				"salience": 0.017204965,
				"type": "PERSON"
			},
			{
				"name": "Handling",
				"salience": 0.016744794,
				"type": "OTHER"
			},
			{
				"name": "handling",
				"salience": 0.016744794,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.016416185,
				"type": "OTHER"
			},
			{
				"name": "child rape",
				"salience": 0.014583821,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.013481905,
				"type": "EVENT"
			},
			{
				"name": "asylum seekers",
				"salience": 0.013481905,
				"type": "PERSON"
			},
			{
				"name": "values",
				"salience": 0.013481905,
				"type": "OTHER"
			},
			{
				"name": "Child Rape",
				"salience": 0.012699464,
				"type": "EVENT"
			},
			{
				"name": "Dilution",
				"salience": 0.010559051,
				"type": "OTHER"
			},
			{
				"name": "Shows",
				"salience": 0.010559051,
				"type": "WORK_OF_ART"
			},
			{
				"name": "society",
				"salience": 0.009840647,
				"type": "OTHER"
			},
			{
				"name": "National Values",
				"salience": 0.008323598,
				"type": "OTHER"
			},
			{
				"name": "continent",
				"salience": 0.00768766,
				"type": "LOCATION"
			},
			{
				"name": "refugee crisis",
				"salience": 0.006911097,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.0065144068,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jennifer Newton",
				"salience": 0.0065144068,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0062258756,
				"type": "WORK_OF_ART"
			},
			{
				"name": "boy",
				"salience": 0.005820926,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.005243899,
				"type": "OTHER"
			},
			{
				"name": "disbelief",
				"salience": 0.0047949376,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbian",
				"salience": 0.00472386,
				"type": "LOCATION"
			},
			{
				"name": "Konstantin Romodanovsky",
				"salience": 0.0043772925,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.003476482,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.0033643523,
				"type": "LOCATION"
			},
			{
				"name": "crime",
				"salience": 0.003280235,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05wyn38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Commission"
				},
				"name": "The European Commission",
				"salience": 0.0031734125,
				"type": "ORGANIZATION"
			},
			{
				"name": "handling",
				"salience": 0.0030855897,
				"type": "OTHER"
			},
			{
				"name": "differences",
				"salience": 0.0029775198,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0029051949,
				"type": "LOCATION"
			},
			{
				"name": "swimming pool",
				"salience": 0.00257437,
				"type": "LOCATION"
			},
			{
				"name": "migrant",
				"salience": 0.002556926,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0025237696,
				"type": "LOCATION"
			},
			{
				"name": "child",
				"salience": 0.0023088946,
				"type": "PERSON"
			},
			{
				"name": "back",
				"salience": 0.0022295257,
				"type": "OTHER"
			},
			{
				"name": "conviction",
				"salience": 0.0022295257,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.0021288542,
				"type": "EVENT"
			},
			{
				"name": "migrants",
				"salience": 0.0020878043,
				"type": "PERSON"
			},
			{
				"name": "rape",
				"salience": 0.0020835735,
				"type": "EVENT"
			},
			{
				"name": "court",
				"salience": 0.0020770363,
				"type": "ORGANIZATION"
			},
			{
				"name": "rape case",
				"salience": 0.001991204,
				"type": "OTHER"
			},
			{
				"name": "attacker",
				"salience": 0.0019394743,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0018689606,
				"type": "OTHER"
			},
			{
				"name": "migration policy",
				"salience": 0.0018055392,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0018055392,
				"type": "LOCATION"
			},
			{
				"name": "head",
				"salience": 0.0018055392,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0017393988,
				"type": "ORGANIZATION"
			},
			{
				"name": "custody",
				"salience": 0.0017381847,
				"type": "OTHER"
			},
			{
				"name": "victim",
				"salience": 0.001644891,
				"type": "PERSON"
			},
			{
				"name": "values",
				"salience": 0.0016325982,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0016037207,
				"type": "OTHER"
			},
			{
				"name": "guilt",
				"salience": 0.00156358,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00156358,
				"type": "PERSON"
			},
			{
				"name": "press conference",
				"salience": 0.001505243,
				"type": "EVENT"
			},
			{
				"name": "asylum seekers",
				"salience": 0.0014289382,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fhp9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vienna"
				},
				"name": "Vienna",
				"salience": 0.0013727158,
				"type": "LOCATION"
			},
			{
				"name": "handling",
				"salience": 0.0013202751,
				"type": "OTHER"
			},
			{
				"name": "multiculturalism",
				"salience": 0.0012928464,
				"type": "OTHER"
			},
			{
				"name": "swimming pool",
				"salience": 0.0012902364,
				"type": "LOCATION"
			},
			{
				"name": "dissolution",
				"salience": 0.001276561,
				"type": "OTHER"
			},
			{
				"name": "chord",
				"salience": 0.001276561,
				"type": "OTHER"
			},
			{
				"name": "mother",
				"salience": 0.0012682952,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0012446025,
				"type": "OTHER"
			},
			{
				"name": "migrant crisis",
				"salience": 0.0012197378,
				"type": "EVENT"
			},
			{
				"name": "sex",
				"salience": 0.001124566,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0010160989,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.00095368276,
				"type": "PERSON"
			},
			{
				"name": "chaos",
				"salience": 0.00095368276,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00095368276,
				"type": "PERSON"
			},
			{
				"name": "option",
				"salience": 0.00095368276,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00095368276,
				"type": "EVENT"
			},
			{
				"name": "Amir A.",
				"salience": 0.0009266125,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.00088840607,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.00088840607,
				"type": "PERSON"
			},
			{
				"name": "asylum seekers",
				"salience": 0.00088840607,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0008095466,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00080214505,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00080214505,
				"type": "LOCATION"
			},
			{
				"name": "customs",
				"salience": 0.00080214505,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00080214505,
				"type": "LOCATION"
			},
			{
				"name": "differences",
				"salience": 0.00080214505,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00080214505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbs",
				"salience": 0.0007857944,
				"type": "PERSON"
			},
			{
				"name": "friction",
				"salience": 0.0007687541,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.00071838533,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.0006945909,
				"type": "OTHER"
			},
			{
				"name": "capabilities",
				"salience": 0.0006945909,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0006945909,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0006945909,
				"type": "OTHER"
			},
			{
				"name": "member states",
				"salience": 0.0006945909,
				"type": "LOCATION"
			},
			{
				"name": "traditions",
				"salience": 0.0006945909,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0006945909,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0006636619,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.0006025123,
				"type": "ORGANIZATION"
			},
			{
				"name": "trial",
				"salience": 0.00059921446,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01fttg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_(Sweden)"
				},
				"name": "Green party",
				"salience": 0.00058699877,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gh7zqd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Migration_Service"
				},
				"name": "Federal Migration Service",
				"salience": 0.00058699877,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nobert Hofer",
				"salience": 0.00058699877,
				"type": "PERSON"
			},
			{
				"name": "communities position",
				"salience": 0.00051886094,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00051886094,
				"type": "PERSON"
			},
			{
				"name": "hospital treatment",
				"salience": 0.00051886094,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042749883,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00042749883,
				"type": "OTHER"
			},
			{
				"name": "Theresienbad",
				"salience": 0.00031932892,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.00013185429,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:24:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.2,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Loading Posted on November 4, 2016 Putin Condemns Europe’s Handling of Migrants and Says the Child Rape in Austria Shows ‘a Dilution of National Values’ Jennifer Newton, Daily Mail, November 3, 2016 \nVladimir Putin has waded into the migrant crisis condemning Europe’s handling of asylum seekers and saying a case of child rape in Austria ‘dilutes national values’. \nThe Russian president has largely kept quiet over the refugee crisis in Europe but has now spoken out of his disbelief over its handling claiming that a continent that ‘can’t protect its children’ has no future. \nHis comments come off the back of a case in Austria last week, which saw an Iraqi migrant have his conviction of raping a 10-year-old boy at a swimming pool in Vienna overturned. \nHe was originally convicted of the crime but it was overturned because a court didn’t prove he realised the boy was saying no. \nIt came after the migrant, identified as 20-year-old Amir A., claimed that it was a ‘sexual emergency’ because he had not had sex for four months. \nA second trial for the rape is expected to take place next year, but the attacker is likely to remain in custody until then. \nAnd speaking at a press conference this week, Putin slammed Europe’s migration policy and cited the case, where the victim was from a Serbian family living in Austria. \nHe said: ‘In a European country, a child is raped by a migrant, and the court releases him. \n‘It doesn’t fit into my head what on earth they’re thinking over there. \n‘I can’t even explain the rationale–is it a sense of guilt before the migrants? What’s going on? It’s not clear.’ \nHe also claimed that the case highlighted ‘the dissolution of traditional national values’ adding: ‘A society that cannot defend its children has no future.’ \nAnd Putin’s words appeared to have struck a chord, as he is extremely popular with Serbs. \nIn the rape case, the boy had arrived in Austria with his Serbian mother, who paid for him to go to the Theresienbad swimming pool, where he was violently attacked. \nThe boy was so badly injured that he needed hospital treatment but he will be forced to go back to court for the Iraqi man’s second trial, outraging the Austrian Serbian community. \nAustrian media say the case has hardened the communities position against asylum seekers, who were previously divided about whether to vote for the left-leaning Green party candidate or the far right option Nobert Hofer in upcoming elections. \nHowever, it is not the first time Russia has lashed out at the EU’s handling of the migrant crisis. \nIn March, Konstantin Romodanovsky, head of Russia’s Federal Migration Service accused leaders of willfully ignoring cultural differences that have caused such widespread friction and chaos across the Continent. \nHe also added that ‘multiculturalism has failed’ because Europe never formed a unified strategy to integrate refugees into Western society. \nHe said: ‘The European Commission left it up to individual nations to decide how they want to treat asylum seekers–despite the fact the policies and capabilities of member states are very different. \nRomodanovsky also accused EU countries of ignoring the ‘differences in culture, religious traditions, and customs’ with the refugees, the vast majority of whom are Islamic.",
		"thread_title": "Putin Condemns Europe’s Handling of Migrants and Says the Child Rape in Austria Shows ‘a Dilution of National Values’",
		"title": "Putin Condemns Europe’s Handling of Migrants and Says the Child Rape in Austria Shows ‘a Dilution of National Values’",
		"type": "bs",
		"uuid": "8155a3d08ebb90bf491d86d2d692059bdafef438"
	},
	"-KhIgyjuyC_fCuX0q0tC": {
		"author": "AR Staff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T16:03:07.410+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01kpf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boer"
				},
				"name": "Boers",
				"salience": 0.26231334,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026zm4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andries_Pretorius"
				},
				"name": "Andries Pretorius",
				"salience": 0.2579038,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gwrmk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zulu_Kingdom"
				},
				"name": "Zulu kingdom",
				"salience": 0.039317105,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09fm7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Piet_Retief"
				},
				"name": "Piet Retief",
				"salience": 0.023017136,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026vgq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dingane_kaSenzangakhona"
				},
				"name": "Dingaan",
				"salience": 0.021907102,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/088zs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zulu_people"
				},
				"name": "Zulu",
				"salience": 0.020158526,
				"type": "PERSON"
			},
			{
				"name": "blow",
				"salience": 0.014460587,
				"type": "OTHER"
			},
			{
				"name": "revenge",
				"salience": 0.01175211,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.009862349,
				"type": "EVENT"
			},
			{
				"name": "spear",
				"salience": 0.008817333,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "warrior",
				"salience": 0.008261841,
				"type": "PERSON"
			},
			{
				"name": "treaty",
				"salience": 0.005492686,
				"type": "OTHER"
			},
			{
				"name": "king",
				"salience": 0.0039807777,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09v1gmq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Blood_River"
				},
				"name": "Blood River",
				"salience": 0.0039353976,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.0036306628,
				"type": "PERSON"
			},
			{
				"name": "trekkers",
				"salience": 0.0033949257,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c49t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cape_Colony"
				},
				"name": "Cape Colony",
				"salience": 0.003378374,
				"type": "LOCATION"
			},
			{
				"name": "river",
				"salience": 0.00301473,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.0029025364,
				"type": "ORGANIZATION"
			},
			{
				"name": "whites",
				"salience": 0.0028628525,
				"type": "PERSON"
			},
			{
				"name": "masters",
				"salience": 0.0026009085,
				"type": "PERSON"
			},
			{
				"name": "warriors",
				"salience": 0.0024915051,
				"type": "PERSON"
			},
			{
				"name": "Boers",
				"salience": 0.0024119993,
				"type": "PERSON"
			},
			{
				"name": "Boers",
				"salience": 0.0023963887,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South African",
				"salience": 0.0022922799,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.002166205,
				"type": "LOCATION"
			},
			{
				"name": "Boers",
				"salience": 0.0021653632,
				"type": "PERSON"
			},
			{
				"name": "spear point",
				"salience": 0.0021287797,
				"type": "OTHER"
			},
			{
				"name": "assegai",
				"salience": 0.0021287797,
				"type": "OTHER"
			},
			{
				"name": "spear point",
				"salience": 0.0021287797,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0021057532,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gwrmk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zulu_Kingdom"
				},
				"name": "Zulus",
				"salience": 0.0020289267,
				"type": "PERSON"
			},
			{
				"name": "angle",
				"salience": 0.0019188588,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0017822576,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jan Bezuidenhout",
				"salience": 0.001715135,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hj35",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Xhosa_people"
				},
				"name": "Xhosas",
				"salience": 0.0016489323,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.0016465524,
				"type": "LOCATION"
			},
			{
				"name": "trekkers",
				"salience": 0.0016319638,
				"type": "PERSON"
			},
			{
				"name": "impi",
				"salience": 0.0015363811,
				"type": "OTHER"
			},
			{
				"name": "Red",
				"salience": 0.0015138354,
				"type": "OTHER"
			},
			{
				"name": "battlefield",
				"salience": 0.0014887736,
				"type": "LOCATION"
			},
			{
				"name": "battles",
				"salience": 0.0014887736,
				"type": "EVENT"
			},
			{
				"name": "battle",
				"salience": 0.0014887736,
				"type": "EVENT"
			},
			{
				"name": "warrior",
				"salience": 0.0014006714,
				"type": "PERSON"
			},
			{
				"name": "warriors",
				"salience": 0.0014006714,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0013529063,
				"type": "PERSON"
			},
			{
				"name": "treaty",
				"salience": 0.0013497581,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0013358273,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0013177443,
				"type": "PERSON"
			},
			{
				"name": "cattle",
				"salience": 0.0012751082,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.0012646917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gnjxx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gustav_Preller"
				},
				"name": "Gustav Preller",
				"salience": 0.0012630287,
				"type": "PERSON"
			},
			{
				"name": "commander",
				"salience": 0.0012262235,
				"type": "PERSON"
			},
			{
				"name": "commander",
				"salience": 0.0012262235,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0011580364,
				"type": "LOCATION"
			},
			{
				"name": "ground",
				"salience": 0.0011419053,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0011419053,
				"type": "LOCATION"
			},
			{
				"name": "deception",
				"salience": 0.0011419053,
				"type": "OTHER"
			},
			{
				"name": "Umgungundhlovo",
				"salience": 0.0011131223,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06v36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Swaziland"
				},
				"name": "Swazis",
				"salience": 0.0011015058,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0010951399,
				"type": "LOCATION"
			},
			{
				"name": "spears",
				"salience": 0.0010951399,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0010951399,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0010951399,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0010799122,
				"type": "PERSON"
			},
			{
				"name": "spear",
				"salience": 0.0010677169,
				"type": "OTHER"
			},
			{
				"name": "defenders",
				"salience": 0.0010528862,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0010528702,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.0010444325,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0010444325,
				"type": "PERSON"
			},
			{
				"name": "tributary",
				"salience": 0.0010444325,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0010444325,
				"type": "OTHER"
			},
			{
				"name": "colonialism",
				"salience": 0.0010444325,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0010444325,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0010444325,
				"type": "OTHER"
			},
			{
				"name": "Arthur Kemp",
				"salience": 0.0010398284,
				"type": "PERSON"
			},
			{
				"name": "descendents",
				"salience": 0.001012535,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0010121558,
				"type": "EVENT"
			},
			{
				"name": "nations",
				"salience": 0.0009888065,
				"type": "ORGANIZATION"
			},
			{
				"name": "assegai",
				"salience": 0.0009888065,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0009888065,
				"type": "LOCATION"
			},
			{
				"name": "army",
				"salience": 0.0009888065,
				"type": "ORGANIZATION"
			},
			{
				"name": "greatest",
				"salience": 0.0009888065,
				"type": "OTHER"
			},
			{
				"name": "assegai",
				"salience": 0.0009888065,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0009888065,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempt",
				"salience": 0.0009888065,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.00094896957,
				"type": "OTHER"
			},
			{
				"name": "Spinning round",
				"salience": 0.00093087467,
				"type": "EVENT"
			},
			{
				"name": "weapon",
				"salience": 0.0009268245,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.0009268245,
				"type": "OTHER"
			},
			{
				"name": "wagon",
				"salience": 0.0009252696,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09pg9b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sarel_Cilliers"
				},
				"name": "Sarel Cilliers",
				"salience": 0.00092505873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.00091199565,
				"type": "LOCATION"
			},
			{
				"name": "Conestogas",
				"salience": 0.00091005804,
				"type": "OTHER"
			},
			{
				"name": "Boers",
				"salience": 0.00090354675,
				"type": "PERSON"
			},
			{
				"name": "Hans De Lange",
				"salience": 0.0008886126,
				"type": "PERSON"
			},
			{
				"name": "farmers",
				"salience": 0.0008764449,
				"type": "PERSON"
			},
			{
				"name": "horse",
				"salience": 0.0008562249,
				"type": "OTHER"
			},
			{
				"name": "feet",
				"salience": 0.0008562249,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0008562249,
				"type": "OTHER"
			},
			{
				"name": "Boers",
				"salience": 0.00084742275,
				"type": "PERSON"
			},
			{
				"name": "River Ran",
				"salience": 0.0008068957,
				"type": "ORGANIZATION"
			},
			{
				"name": "American Renaissance",
				"salience": 0.0008068957,
				"type": "ORGANIZATION"
			},
			{
				"name": "message",
				"salience": 0.00079767156,
				"type": "OTHER"
			},
			{
				"name": "historians",
				"salience": 0.00079349277,
				"type": "PERSON"
			},
			{
				"name": "highest",
				"salience": 0.00077787467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02clv0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle_of_Blood_River"
				},
				"name": "Battle of Blood River",
				"salience": 0.0007761168,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.00077337614,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00077307975,
				"type": "OTHER"
			},
			{
				"name": "single-shot",
				"salience": 0.00077307975,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00077307975,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00077307975,
				"type": "LOCATION"
			},
			{
				"name": "surrender terms",
				"salience": 0.00077307975,
				"type": "OTHER"
			},
			{
				"name": "chest",
				"salience": 0.00077307975,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00077307975,
				"type": "OTHER"
			},
			{
				"name": "gun",
				"salience": 0.00077307975,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "throat",
				"salience": 0.00077307975,
				"type": "OTHER"
			},
			{
				"name": "fighting gates",
				"salience": 0.0007492035,
				"type": "OTHER"
			},
			{
				"name": "trek",
				"salience": 0.0007142701,
				"type": "EVENT"
			},
			{
				"name": "clash",
				"salience": 0.0007042484,
				"type": "EVENT"
			},
			{
				"name": "Boers",
				"salience": 0.0006963061,
				"type": "PERSON"
			},
			{
				"name": "Boers",
				"salience": 0.0006963061,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0006878625,
				"type": "OTHER"
			},
			{
				"name": "mountain range",
				"salience": 0.00068522326,
				"type": "LOCATION"
			},
			{
				"name": "Boers",
				"salience": 0.00067031133,
				"type": "PERSON"
			},
			{
				"name": "Boers",
				"salience": 0.00067031133,
				"type": "PERSON"
			},
			{
				"name": "captive",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.0006694133,
				"type": "EVENT"
			},
			{
				"name": "hit",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "magic shooting stick",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "flurry",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "butt",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "combat",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "musket",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "midst",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "stabbing",
				"salience": 0.0006694133,
				"type": "EVENT"
			},
			{
				"name": "shank",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "horror",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "point cuts",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "palm",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "ear",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "jabs",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "ball whiz",
				"salience": 0.0006694133,
				"type": "OTHER"
			},
			{
				"name": "wagons",
				"salience": 0.00061282644,
				"type": "OTHER"
			},
			{
				"name": "wagons",
				"salience": 0.00061282644,
				"type": "OTHER"
			},
			{
				"name": "compensation",
				"salience": 0.000603604,
				"type": "OTHER"
			},
			{
				"name": "search",
				"salience": 0.0005933343,
				"type": "OTHER"
			},
			{
				"name": "manifesto",
				"salience": 0.0005933343,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0005902555,
				"type": "LOCATION"
			},
			{
				"name": "babies",
				"salience": 0.0005858566,
				"type": "PERSON"
			},
			{
				"name": "plain",
				"salience": 0.00057870516,
				"type": "OTHER"
			},
			{
				"name": "Ncome",
				"salience": 0.0005704406,
				"type": "OTHER"
			},
			{
				"name": "laager",
				"salience": 0.00056633994,
				"type": "OTHER"
			},
			{
				"name": "Scotsman Edward Parker",
				"salience": 0.00056212075,
				"type": "PERSON"
			},
			{
				"name": "raid",
				"salience": 0.0005605071,
				"type": "EVENT"
			},
			{
				"name": "camps",
				"salience": 0.00054291333,
				"type": "LOCATION"
			},
			{
				"name": "chance",
				"salience": 0.0005395806,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0005395806,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.00053083705,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.00051605643,
				"type": "EVENT"
			},
			{
				"name": "attempt",
				"salience": 0.00050489244,
				"type": "EVENT"
			},
			{
				"name": "land",
				"salience": 0.00050471193,
				"type": "LOCATION"
			},
			{
				"name": "king",
				"salience": 0.00050471193,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00049310114,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00048274387,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.0004799159,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g60hh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colony_of_Natal"
				},
				"name": "Natal",
				"salience": 0.00047584134,
				"type": "LOCATION"
			},
			{
				"name": "guard",
				"salience": 0.0004714206,
				"type": "PERSON"
			},
			{
				"name": "trekker",
				"salience": 0.00046999453,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00046999453,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012fh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afrikaner"
				},
				"name": "Afrikaners",
				"salience": 0.0004687172,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0004583935,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0004583935,
				"type": "OTHER"
			},
			{
				"name": "colony",
				"salience": 0.0004522353,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.00044885298,
				"type": "LOCATION"
			},
			{
				"name": "bodies",
				"salience": 0.00044809945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00043374317,
				"type": "LOCATION"
			},
			{
				"name": "army",
				"salience": 0.00043360758,
				"type": "ORGANIZATION"
			},
			{
				"name": "territory",
				"salience": 0.00042986308,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00042986308,
				"type": "PERSON"
			},
			{
				"name": "colony",
				"salience": 0.00042986308,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.00042986308,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00042986308,
				"type": "OTHER"
			},
			{
				"name": "wagons",
				"salience": 0.00042963855,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "battle",
				"salience": 0.00042963855,
				"type": "OTHER"
			},
			{
				"name": "Boers",
				"salience": 0.00042459773,
				"type": "PERSON"
			},
			{
				"name": "unit",
				"salience": 0.00042218342,
				"type": "ORGANIZATION"
			},
			{
				"name": "missionary",
				"salience": 0.00042128167,
				"type": "PERSON"
			},
			{
				"name": "scouts",
				"salience": 0.00041526256,
				"type": "OTHER"
			},
			{
				"name": "wagons",
				"salience": 0.00041359695,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "settlement",
				"salience": 0.0004069618,
				"type": "OTHER"
			},
			{
				"name": "north",
				"salience": 0.0004069618,
				"type": "LOCATION"
			},
			{
				"name": "frontier farmers",
				"salience": 0.0004069618,
				"type": "PERSON"
			},
			{
				"name": "attempts",
				"salience": 0.0004069618,
				"type": "EVENT"
			},
			{
				"name": "border farmers",
				"salience": 0.0004069618,
				"type": "PERSON"
			},
			{
				"name": "north",
				"salience": 0.0004069618,
				"type": "LOCATION"
			},
			{
				"name": "farmers",
				"salience": 0.0004069618,
				"type": "PERSON"
			},
			{
				"name": "north",
				"salience": 0.0004069618,
				"type": "LOCATION"
			},
			{
				"name": "settlement",
				"salience": 0.0004069618,
				"type": "OTHER"
			},
			{
				"name": "settlement",
				"salience": 0.0004069618,
				"type": "OTHER"
			},
			{
				"name": "grazing requirements",
				"salience": 0.00040555204,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00040420037,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00040420037,
				"type": "PERSON"
			},
			{
				"name": "warriors",
				"salience": 0.00040420037,
				"type": "PERSON"
			},
			{
				"name": "capital",
				"salience": 0.00040211334,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.00040083352,
				"type": "PERSON"
			},
			{
				"name": "disaster",
				"salience": 0.0003997576,
				"type": "EVENT"
			},
			{
				"name": "counterattack",
				"salience": 0.000394719,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cssmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle_of_Italeni"
				},
				"name": "Battle of Italeni",
				"salience": 0.00039031738,
				"type": "EVENT"
			},
			{
				"name": "warrior",
				"salience": 0.00038910838,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00038910838,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00038910838,
				"type": "PERSON"
			},
			{
				"name": "warriors",
				"salience": 0.00038910838,
				"type": "PERSON"
			},
			{
				"name": "dancing warriors",
				"salience": 0.00038910838,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0003854786,
				"type": "EVENT"
			},
			{
				"name": "armies",
				"salience": 0.00038483148,
				"type": "ORGANIZATION"
			},
			{
				"name": "servants",
				"salience": 0.0003843226,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.00038144476,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00038144476,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00037894148,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europeans",
				"salience": 0.00037725683,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.00037469546,
				"type": "ORGANIZATION"
			},
			{
				"name": "tribe",
				"salience": 0.00037388198,
				"type": "PERSON"
			},
			{
				"name": "slaughter",
				"salience": 0.00037072154,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.00037046254,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.00037046254,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02bv9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dutch_language"
				},
				"name": "Dutch",
				"salience": 0.00036806377,
				"type": "LOCATION"
			},
			{
				"name": "blood",
				"salience": 0.0003649415,
				"type": "OTHER"
			},
			{
				"name": "life blood",
				"salience": 0.0003649415,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00035956877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nations",
				"salience": 0.00035848102,
				"type": "LOCATION"
			},
			{
				"name": "range",
				"salience": 0.00035663001,
				"type": "OTHER"
			},
			{
				"name": "commander in chief",
				"salience": 0.000353836,
				"type": "PERSON"
			},
			{
				"name": "command",
				"salience": 0.000353836,
				"type": "OTHER"
			},
			{
				"name": "pioneers",
				"salience": 0.0003523811,
				"type": "PERSON"
			},
			{
				"name": "frontier border",
				"salience": 0.0003523811,
				"type": "LOCATION"
			},
			{
				"name": "opening",
				"salience": 0.0003523811,
				"type": "EVENT"
			},
			{
				"name": "border",
				"salience": 0.0003523811,
				"type": "LOCATION"
			},
			{
				"name": "station",
				"salience": 0.0003523811,
				"type": "LOCATION"
			},
			{
				"name": "descent",
				"salience": 0.0003523811,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.0003523811,
				"type": "OTHER"
			},
			{
				"name": "waves",
				"salience": 0.0003523811,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0003523811,
				"type": "OTHER"
			},
			{
				"name": "patrols",
				"salience": 0.0003521349,
				"type": "PERSON"
			},
			{
				"name": "wagons",
				"salience": 0.00035072246,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "wagons",
				"salience": 0.00035072246,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "battle",
				"salience": 0.00035072246,
				"type": "EVENT"
			},
			{
				"name": "wagons",
				"salience": 0.00035072246,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "battle",
				"salience": 0.00035072246,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.00035056158,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00034712945,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0003431129,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0003420587,
				"type": "ORGANIZATION"
			},
			{
				"name": "All",
				"salience": 0.0003420587,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.00034062416,
				"type": "PERSON"
			},
			{
				"name": "king",
				"salience": 0.00034062416,
				"type": "PERSON"
			},
			{
				"name": "kingdom",
				"salience": 0.00034062416,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.00034062416,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.00034062416,
				"type": "LOCATION"
			},
			{
				"name": "sermon",
				"salience": 0.0003395656,
				"type": "EVENT"
			},
			{
				"name": "directions",
				"salience": 0.0003395656,
				"type": "OTHER"
			},
			{
				"name": "Boer",
				"salience": 0.0003379248,
				"type": "OTHER"
			},
			{
				"name": "attackers",
				"salience": 0.00033370123,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.00033244252,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.00032995595,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00032995595,
				"type": "PERSON"
			},
			{
				"name": "warriors",
				"salience": 0.00032995595,
				"type": "PERSON"
			},
			{
				"name": "brass cannon",
				"salience": 0.00032949506,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "trekkers",
				"salience": 0.00032949506,
				"type": "PERSON"
			},
			{
				"name": "cannon",
				"salience": 0.00032949506,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "party",
				"salience": 0.00032928653,
				"type": "EVENT"
			},
			{
				"name": "slaughter",
				"salience": 0.0003265573,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.00032109115,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00031994152,
				"type": "LOCATION"
			},
			{
				"name": "slavery",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "slave",
				"salience": 0.00031815443,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "grievances",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "coast",
				"salience": 0.00031815443,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.00031815443,
				"type": "LOCATION"
			},
			{
				"name": "coast",
				"salience": 0.00031815443,
				"type": "LOCATION"
			},
			{
				"name": "grievances",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "manifest destiny",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "contact",
				"salience": 0.00031815443,
				"type": "OTHER"
			},
			{
				"name": "east",
				"salience": 0.00031815443,
				"type": "LOCATION"
			},
			{
				"name": "negotiation",
				"salience": 0.00031815443,
				"type": "EVENT"
			},
			{
				"name": "trekkers",
				"salience": 0.00031719194,
				"type": "PERSON"
			},
			{
				"name": "cattle",
				"salience": 0.0003159955,
				"type": "OTHER"
			},
			{
				"name": "laager",
				"salience": 0.0003159955,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.0003159955,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0003159955,
				"type": "OTHER"
			},
			{
				"name": "stones",
				"salience": 0.00031480705,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "camp",
				"salience": 0.0003146725,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.0003146725,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.0003146725,
				"type": "EVENT"
			},
			{
				"name": "ammunition",
				"salience": 0.00031018452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01yj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cape_Town"
				},
				"name": "Cape Town",
				"salience": 0.0003091471,
				"type": "LOCATION"
			},
			{
				"name": "Umgungundhlovo",
				"salience": 0.00030565722,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0003052056,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.00030419638,
				"type": "LOCATION"
			},
			{
				"name": "treaty",
				"salience": 0.00030419638,
				"type": "OTHER"
			},
			{
				"name": "cattle",
				"salience": 0.00030419638,
				"type": "OTHER"
			},
			{
				"name": "settlers",
				"salience": 0.0003020143,
				"type": "PERSON"
			},
			{
				"name": "servants",
				"salience": 0.0003020143,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.00030135858,
				"type": "LOCATION"
			},
			{
				"name": "time",
				"salience": 0.00030135858,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.00030135858,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00029781053,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0002925285,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0002901059,
				"type": "PERSON"
			},
			{
				"name": "peoples",
				"salience": 0.0002901059,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0002901059,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0002901059,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01d2sd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Trek"
				},
				"name": "Great Trek",
				"salience": 0.00028924513,
				"type": "EVENT"
			},
			{
				"name": "commemoration",
				"salience": 0.00028884123,
				"type": "OTHER"
			},
			{
				"name": "command",
				"salience": 0.00028884123,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00028876422,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02bv9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dutch_language"
				},
				"name": "Dutch",
				"salience": 0.0002855912,
				"type": "LOCATION"
			},
			{
				"name": "few",
				"salience": 0.00028530246,
				"type": "OTHER"
			},
			{
				"name": "mark",
				"salience": 0.0002825611,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00027940376,
				"type": "EVENT"
			},
			{
				"name": "scouting parties",
				"salience": 0.00027922695,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawlessness",
				"salience": 0.00027548266,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.00027548266,
				"type": "LOCATION"
			},
			{
				"name": "expansion",
				"salience": 0.00027548266,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.00027548266,
				"type": "EVENT"
			},
			{
				"name": "antecedents",
				"salience": 0.00027548266,
				"type": "OTHER"
			},
			{
				"name": "tip",
				"salience": 0.00027548266,
				"type": "OTHER"
			},
			{
				"name": "neighbors",
				"salience": 0.00027548266,
				"type": "PERSON"
			},
			{
				"name": "audacity",
				"salience": 0.00027548266,
				"type": "OTHER"
			},
			{
				"name": "discontent",
				"salience": 0.00027548266,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00027548266,
				"type": "ORGANIZATION"
			},
			{
				"name": "merchant",
				"salience": 0.00027548266,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "misunderstanding",
				"salience": 0.00027548266,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00027548266,
				"type": "OTHER"
			},
			{
				"name": "firearms",
				"salience": 0.00027464924,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "front",
				"salience": 0.00027464924,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.00027464924,
				"type": "ORGANIZATION"
			},
			{
				"name": "natives",
				"salience": 0.0002728697,
				"type": "PERSON"
			},
			{
				"name": "Desperate Zulu",
				"salience": 0.00027217707,
				"type": "ORGANIZATION"
			},
			{
				"name": "error",
				"salience": 0.0002714607,
				"type": "OTHER"
			},
			{
				"name": "laager",
				"salience": 0.0002713769,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.00026897076,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack",
				"salience": 0.00026897076,
				"type": "EVENT"
			},
			{
				"name": "surprise attack",
				"salience": 0.00026897076,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0002682343,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bmd1_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Buffalo_River_(KwaZulu-Natal)"
				},
				"name": "Buffalo River",
				"salience": 0.00026741592,
				"type": "LOCATION"
			},
			{
				"name": "account",
				"salience": 0.00026741254,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00026741254,
				"type": "PERSON"
			},
			{
				"name": "charity",
				"salience": 0.00026741254,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.00026741254,
				"type": "LOCATION"
			},
			{
				"name": "signing",
				"salience": 0.00026657255,
				"type": "EVENT"
			},
			{
				"name": "prisoners",
				"salience": 0.0002646603,
				"type": "PERSON"
			},
			{
				"name": "wagons",
				"salience": 0.00026197342,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "battlefield",
				"salience": 0.00026197342,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0002598946,
				"type": "OTHER"
			},
			{
				"name": "cattle",
				"salience": 0.00025795057,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00025795057,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00025795057,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00025795057,
				"type": "OTHER"
			},
			{
				"name": "cattle",
				"salience": 0.00025795057,
				"type": "OTHER"
			},
			{
				"name": "cattle",
				"salience": 0.00025795057,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00025795057,
				"type": "OTHER"
			},
			{
				"name": "messenger",
				"salience": 0.00025742725,
				"type": "PERSON"
			},
			{
				"name": "accordance",
				"salience": 0.00025742725,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00025742725,
				"type": "PERSON"
			},
			{
				"name": "unit",
				"salience": 0.00025742725,
				"type": "ORGANIZATION"
			},
			{
				"name": "message",
				"salience": 0.00025742725,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00025742725,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00025742725,
				"type": "PERSON"
			},
			{
				"name": "reed",
				"salience": 0.00025742725,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00025742725,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0002546991,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.00024925877,
				"type": "PERSON"
			},
			{
				"name": "slaughter",
				"salience": 0.00024703628,
				"type": "OTHER"
			},
			{
				"name": "heads",
				"salience": 0.00024703628,
				"type": "OTHER"
			},
			{
				"name": "encampments",
				"salience": 0.00024703628,
				"type": "LOCATION"
			},
			{
				"name": "dozens",
				"salience": 0.00024703628,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.00024703628,
				"type": "OTHER"
			},
			{
				"name": "pursuers",
				"salience": 0.00024703628,
				"type": "PERSON"
			},
			{
				"name": "warriors",
				"salience": 0.00024646113,
				"type": "PERSON"
			},
			{
				"name": "tributary",
				"salience": 0.00024600196,
				"type": "OTHER"
			},
			{
				"name": "tributary",
				"salience": 0.00024600196,
				"type": "OTHER"
			},
			{
				"name": "cavalry",
				"salience": 0.00024600196,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.00024600196,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ct9hn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Piet_Uys"
				},
				"name": "Piet Uys",
				"salience": 0.00024360922,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.00024277417,
				"type": "EVENT"
			},
			{
				"name": "spike",
				"salience": 0.00024067941,
				"type": "EVENT"
			},
			{
				"name": "commando",
				"salience": 0.00023879368,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.00023781175,
				"type": "OTHER"
			},
			{
				"name": "feet",
				"salience": 0.00023781175,
				"type": "OTHER"
			},
			{
				"name": "expeditions",
				"salience": 0.00023781175,
				"type": "OTHER"
			},
			{
				"name": "encampments",
				"salience": 0.00023781175,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.00023781175,
				"type": "PERSON"
			},
			{
				"name": "possession",
				"salience": 0.00023781175,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.00023505084,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.00023504464,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0g60hh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colony_of_Natal"
				},
				"name": "Natal",
				"salience": 0.00023474546,
				"type": "LOCATION"
			},
			{
				"name": "laager",
				"salience": 0.00023305765,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00023289483,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.00023289483,
				"type": "EVENT"
			},
			{
				"name": "Afrikaners",
				"salience": 0.00023208186,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.0002316922,
				"type": "OTHER"
			},
			{
				"name": "Boers",
				"salience": 0.00023096646,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.00023065695,
				"type": "OTHER"
			},
			{
				"name": "cavalry unit",
				"salience": 0.00022965303,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.00022798637,
				"type": "LOCATION"
			},
			{
				"name": "head",
				"salience": 0.00022604589,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.00022588794,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.00022588794,
				"type": "OTHER"
			},
			{
				"name": "baby daughter",
				"salience": 0.00022304057,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.00022304057,
				"type": "PERSON"
			},
			{
				"name": "formation",
				"salience": 0.00022304057,
				"type": "OTHER"
			},
			{
				"name": "indecision",
				"salience": 0.00022304057,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.00022304057,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.00022304057,
				"type": "LOCATION"
			},
			{
				"name": "animals",
				"salience": 0.00022304057,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.00022304057,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.00022304057,
				"type": "OTHER"
			},
			{
				"name": "widows",
				"salience": 0.00022304057,
				"type": "PERSON"
			},
			{
				"name": "aftermath",
				"salience": 0.00022304057,
				"type": "OTHER"
			},
			{
				"name": "survivors",
				"salience": 0.00022304057,
				"type": "PERSON"
			},
			{
				"name": "blood",
				"salience": 0.00022252125,
				"type": "OTHER"
			},
			{
				"name": "harm",
				"salience": 0.00022204396,
				"type": "OTHER"
			},
			{
				"name": "soil erosion ditch",
				"salience": 0.00021829076,
				"type": "OTHER"
			},
			{
				"name": "gates",
				"salience": 0.00021829076,
				"type": "OTHER"
			},
			{
				"name": "defenders",
				"salience": 0.00021829076,
				"type": "PERSON"
			},
			{
				"name": "enemy",
				"salience": 0.00021760505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018lkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orange_Free_State"
				},
				"name": "Orange Free State",
				"salience": 0.00021685808,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.00021574924,
				"type": "LOCATION"
			},
			{
				"name": "king",
				"salience": 0.00021574924,
				"type": "PERSON"
			},
			{
				"name": "commando",
				"salience": 0.00021574924,
				"type": "OTHER"
			},
			{
				"name": "grass huts",
				"salience": 0.00021471194,
				"type": "OTHER"
			},
			{
				"name": "custom",
				"salience": 0.00021471194,
				"type": "OTHER"
			},
			{
				"name": "chieftain",
				"salience": 0.00021471194,
				"type": "PERSON"
			},
			{
				"name": "hunting",
				"salience": 0.00021471194,
				"type": "EVENT"
			},
			{
				"name": "dance",
				"salience": 0.00021471194,
				"type": "OTHER"
			},
			{
				"name": "reed ropes",
				"salience": 0.00021471194,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.00021471194,
				"type": "PERSON"
			},
			{
				"name": "widows",
				"salience": 0.00020933301,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.00020797666,
				"type": "PERSON"
			},
			{
				"name": "Waschbank River",
				"salience": 0.00020305657,
				"type": "LOCATION"
			},
			{
				"name": "openings",
				"salience": 0.0002016571,
				"type": "EVENT"
			},
			{
				"name": "light",
				"salience": 0.0002016571,
				"type": "OTHER"
			},
			{
				"name": "scouting expedition",
				"salience": 0.0002016571,
				"type": "OTHER"
			},
			{
				"name": "horses",
				"salience": 0.0002016571,
				"type": "OTHER"
			},
			{
				"name": "encampment",
				"salience": 0.0002016571,
				"type": "LOCATION"
			},
			{
				"name": "surprises",
				"salience": 0.0002016571,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0002016571,
				"type": "OTHER"
			},
			{
				"name": "attackers",
				"salience": 0.00020090652,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.00019865151,
				"type": "PERSON"
			},
			{
				"name": "camps",
				"salience": 0.00019679822,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/032yv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Far_East"
				},
				"name": "Far East",
				"salience": 0.0001957934,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "American West",
				"salience": 0.0001957934,
				"type": "LOCATION"
			},
			{
				"name": "Dragon Mountains",
				"salience": 0.0001957934,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01v5p9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_Company"
				},
				"name": "Virginia Company",
				"salience": 0.0001957934,
				"type": "ORGANIZATION"
			},
			{
				"name": "word",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "height",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "weeping",
				"salience": 0.00019312443,
				"type": "EVENT"
			},
			{
				"name": "livestock",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "orphans",
				"salience": 0.00019312443,
				"type": "PERSON"
			},
			{
				"name": "quest",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "I",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "massacre",
				"salience": 0.00019312443,
				"type": "EVENT"
			},
			{
				"name": "rest",
				"salience": 0.00019312443,
				"type": "PERSON"
			},
			{
				"name": "sheep",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "challenge",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "wagon wheels",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "H",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.00019312443,
				"type": "LOCATION"
			},
			{
				"name": "column",
				"salience": 0.00019312443,
				"type": "WORK_OF_ART"
			},
			{
				"name": "family",
				"salience": 0.00019312443,
				"type": "PERSON"
			},
			{
				"name": "spear stroke",
				"salience": 0.00019312443,
				"type": "EVENT"
			},
			{
				"name": "reinforcements",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "trekker call",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "undergrowth",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "crib",
				"salience": 0.00019312443,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "test",
				"salience": 0.00019312443,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00019267476,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.00019267476,
				"type": "LOCATION"
			},
			{
				"name": "cattle",
				"salience": 0.00019267476,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.00019267476,
				"type": "OTHER"
			},
			{
				"name": "laager",
				"salience": 0.00019267476,
				"type": "PERSON"
			},
			{
				"name": "women prisoner",
				"salience": 0.00019154589,
				"type": "PERSON"
			},
			{
				"name": "lanterns",
				"salience": 0.00019069,
				"type": "OTHER"
			},
			{
				"name": "lawyer",
				"salience": 0.00019069,
				"type": "PERSON"
			},
			{
				"name": "fathers",
				"salience": 0.00018591281,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "volunteers",
				"salience": 0.00018591281,
				"type": "PERSON"
			},
			{
				"name": "body",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "wizards",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "elephant",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.00018591281,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hunting knives",
				"salience": 0.00018591281,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "death",
				"salience": 0.00018591281,
				"type": "EVENT"
			},
			{
				"name": "guests",
				"salience": 0.00018591281,
				"type": "PERSON"
			},
			{
				"name": "heart",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "vultures",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "might",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "enclosure",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "reed walls",
				"salience": 0.00018591281,
				"type": "LOCATION"
			},
			{
				"name": "X",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "dogs",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "sentries",
				"salience": 0.00018591281,
				"type": "ORGANIZATION"
			},
			{
				"name": "visits",
				"salience": 0.00018591281,
				"type": "EVENT"
			},
			{
				"name": "outcome",
				"salience": 0.00018591281,
				"type": "OTHER"
			},
			{
				"name": "celebration",
				"salience": 0.00018591281,
				"type": "EVENT"
			},
			{
				"name": "rise",
				"salience": 0.00018470819,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0001840835,
				"type": "PERSON"
			},
			{
				"name": "cavalry",
				"salience": 0.00018374952,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.00018374952,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00018374952,
				"type": "OTHER"
			},
			{
				"name": "cavalry",
				"salience": 0.00018374952,
				"type": "PERSON"
			},
			{
				"name": "tribe",
				"salience": 0.00018374952,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.00018374952,
				"type": "OTHER"
			},
			{
				"name": "cavalry",
				"salience": 0.00018374952,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0001830139,
				"type": "OTHER"
			},
			{
				"name": "armies",
				"salience": 0.00018206883,
				"type": "ORGANIZATION"
			},
			{
				"name": "guard",
				"salience": 0.00018206883,
				"type": "PERSON"
			},
			{
				"name": "day patrols",
				"salience": 0.00018206883,
				"type": "PERSON"
			},
			{
				"name": "covenant",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "cloth",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "leather ropes",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "formation",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "animal-skin shields",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.00018206883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04zwk6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Weenen"
				},
				"name": "Weenen",
				"salience": 0.00018076343,
				"type": "LOCATION"
			},
			{
				"name": "orders",
				"salience": 0.00017989945,
				"type": "OTHER"
			},
			{
				"name": "orders",
				"salience": 0.00017648074,
				"type": "OTHER"
			},
			{
				"name": "north",
				"salience": 0.00017395894,
				"type": "LOCATION"
			},
			{
				"name": "cannon fire",
				"salience": 0.00017395894,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.00017372737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01v2x2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_people"
				},
				"name": "Bushmen",
				"salience": 0.00016953157,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01tpyf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khoikhoi"
				},
				"name": "Hottentots",
				"salience": 0.00016953157,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k1l9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jamestown,_Virginia"
				},
				"name": "Jamestown Island",
				"salience": 0.00016953157,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/064_8sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/French_language"
				},
				"name": "French",
				"salience": 0.00016953157,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01bh60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drakensberg"
				},
				"name": "Drakensberg",
				"salience": 0.00016953157,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bs8j6d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Transvaal_Colony"
				},
				"name": "Transvaal",
				"salience": 0.00016953157,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00016953157,
				"type": "LOCATION"
			},
			{
				"name": "By1836",
				"salience": 0.00016953157,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cbvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Napoleonic_Wars"
				},
				"name": "Napoleonic Wars",
				"salience": 0.00016953157,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0818n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voortrekkers"
				},
				"name": "Voortrekkers",
				"salience": 0.00016953157,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00016953157,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.00016953157,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.0001646131,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00016326757,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.00016305024,
				"type": "OTHER"
			},
			{
				"name": "gates",
				"salience": 0.00016305024,
				"type": "PERSON"
			},
			{
				"name": "units",
				"salience": 0.00016305024,
				"type": "LOCATION"
			},
			{
				"name": "openings",
				"salience": 0.00016253804,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.00016183057,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00016099488,
				"type": "OTHER"
			},
			{
				"name": "shot",
				"salience": 0.00015933781,
				"type": "OTHER"
			},
			{
				"name": "folklore",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "offer",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "horizon",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "betrayal",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "honor",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "oath",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "innovation",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "ends",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "oxen",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "hippopotamus path",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "ploy",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.00015764774,
				"type": "OTHER"
			},
			{
				"name": "lands",
				"salience": 0.00015711457,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.00015711457,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.00015711457,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.00015711457,
				"type": "LOCATION"
			},
			{
				"name": "strike",
				"salience": 0.00015566047,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.00015188454,
				"type": "OTHER"
			},
			{
				"name": "feet",
				"salience": 0.00015062555,
				"type": "OTHER"
			},
			{
				"name": "wagon circle",
				"salience": 0.00015062555,
				"type": "LOCATION"
			},
			{
				"name": "horsemen",
				"salience": 0.00015062555,
				"type": "PERSON"
			},
			{
				"name": "pursuit",
				"salience": 0.00015062555,
				"type": "OTHER"
			},
			{
				"name": "pursuit",
				"salience": 0.00015062555,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.00015062555,
				"type": "PERSON"
			},
			{
				"name": "enemy",
				"salience": 0.00015062555,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.00015062555,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.00014999484,
				"type": "EVENT"
			},
			{
				"name": "capital",
				"salience": 0.00014949881,
				"type": "LOCATION"
			},
			{
				"name": "experiment",
				"salience": 0.00014872679,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00014446108,
				"type": "PERSON"
			},
			{
				"name": "wagons",
				"salience": 0.00014249896,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "wagons",
				"salience": 0.00014249896,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "wagons",
				"salience": 0.00014249896,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "battle",
				"salience": 0.00014249896,
				"type": "EVENT"
			},
			{
				"name": "wagons",
				"salience": 0.00014249896,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "battle",
				"salience": 0.00014249896,
				"type": "EVENT"
			},
			{
				"name": "breasts",
				"salience": 0.00014063809,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.00014031063,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vrh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pietermaritzburg"
				},
				"name": "Pietermaritzburg",
				"salience": 0.00013976682,
				"type": "LOCATION"
			},
			{
				"name": "water red",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "wounds",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "spike",
				"salience": 0.00013599395,
				"type": "EVENT"
			},
			{
				"name": "chest",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "contents",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "cloths",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "revenge",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "ranks",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "reed huts",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "covenant",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.00013599395,
				"type": "PERSON"
			},
			{
				"name": "assegai wounds",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "sight",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.00013599395,
				"type": "OTHER"
			},
			{
				"name": "mistake",
				"salience": 0.00013427963,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.00013381087,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00013381087,
				"type": "PERSON"
			},
			{
				"name": "victors",
				"salience": 0.00013381087,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.00013381087,
				"type": "LOCATION"
			},
			{
				"name": "victors",
				"salience": 0.00013381087,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.00013381087,
				"type": "EVENT"
			},
			{
				"name": "peoples",
				"salience": 0.00013381087,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.00013381087,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00013381087,
				"type": "EVENT"
			},
			{
				"name": "numbers",
				"salience": 0.00013381087,
				"type": "OTHER"
			},
			{
				"name": "tribes",
				"salience": 0.00013381087,
				"type": "PERSON"
			},
			{
				"name": "Gun barrels",
				"salience": 0.00012868762,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00012772498,
				"type": "LOCATION"
			},
			{
				"name": "demography",
				"salience": 0.00012763574,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.00012719016,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.00012668096,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.00012668096,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00012668096,
				"type": "PERSON"
			},
			{
				"name": "church services",
				"salience": 0.00012668096,
				"type": "OTHER"
			},
			{
				"name": "settlement",
				"salience": 0.00012668096,
				"type": "OTHER"
			},
			{
				"name": "farms",
				"salience": 0.00012668096,
				"type": "LOCATION"
			},
			{
				"name": "majority population",
				"salience": 0.00012668096,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.00012668096,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.00012668096,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.00012452879,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.00012400368,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0001239389,
				"type": "EVENT"
			},
			{
				"name": "cavalry charge",
				"salience": 0.0001233428,
				"type": "OTHER"
			},
			{
				"name": "republic",
				"salience": 0.00011979118,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/039ktt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hendrik_Potgieter"
				},
				"name": "Hendrik Potgieter",
				"salience": 0.0001188465,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0001187368,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0001187368,
				"type": "LOCATION"
			},
			{
				"name": "civilizations",
				"salience": 0.0001187368,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0001187368,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0001187368,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0001187368,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0001187368,
				"type": "OTHER"
			},
			{
				"name": "skeletons",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "remains",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "rear",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "thongs",
				"salience": 0.000117752556,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vest",
				"salience": 0.000117752556,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "outskirts",
				"salience": 0.000117752556,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "ox hide",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "shoulder bone",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "arm",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "corpses",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "wives",
				"salience": 0.000117752556,
				"type": "PERSON"
			},
			{
				"name": "anus",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "fulfillment",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "saddle",
				"salience": 0.000117752556,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "chase",
				"salience": 0.000117752556,
				"type": "EVENT"
			},
			{
				"name": "threat",
				"salience": 0.000117752556,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00011739629,
				"type": "PERSON"
			},
			{
				"name": "possession",
				"salience": 0.000116871706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zyhy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tl%C3%B4kwa_tribe"
				},
				"name": "Tlokwa",
				"salience": 0.000114408394,
				"type": "PERSON"
			},
			{
				"name": "Hill of Execution",
				"salience": 0.000114408394,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hlomo Amabutho",
				"salience": 0.000114408394,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.000113864095,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00011344774,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighting gates",
				"salience": 0.00011286188,
				"type": "PERSON"
			},
			{
				"name": "labor",
				"salience": 0.00010968867,
				"type": "OTHER"
			},
			{
				"name": "pioneers",
				"salience": 0.00010968867,
				"type": "PERSON"
			},
			{
				"name": "labor",
				"salience": 0.00010968867,
				"type": "OTHER"
			},
			{
				"name": "labor",
				"salience": 0.00010968867,
				"type": "OTHER"
			},
			{
				"name": "cannon",
				"salience": 0.00010928039,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannon",
				"salience": 0.00010928039,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "attack",
				"salience": 0.00010928039,
				"type": "EVENT"
			},
			{
				"name": "cannon",
				"salience": 0.00010928039,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ground",
				"salience": 0.00010928039,
				"type": "LOCATION"
			},
			{
				"name": "fire",
				"salience": 0.00010879207,
				"type": "EVENT"
			},
			{
				"name": "Church of the Vow",
				"salience": 0.00010844619,
				"type": "ORGANIZATION"
			},
			{
				"name": "culture",
				"salience": 0.000106865904,
				"type": "OTHER"
			},
			{
				"name": "black",
				"salience": 0.000105518746,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.00010533337,
				"type": "PERSON"
			},
			{
				"name": "treatment",
				"salience": 0.00010480263,
				"type": "OTHER"
			},
			{
				"name": "laager",
				"salience": 0.00010480263,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00010480263,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00010480263,
				"type": "OTHER"
			},
			{
				"name": "laager",
				"salience": 0.00010480263,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.00010480263,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack",
				"salience": 0.00010387334,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.00010251602,
				"type": "EVENT"
			},
			{
				"name": "terrain",
				"salience": 0.0001012237,
				"type": "OTHER"
			},
			{
				"name": "front line",
				"salience": 0.00009994766,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.00009994766,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.00009984962,
				"type": "PERSON"
			},
			{
				"name": "norms",
				"salience": 0.00009903344,
				"type": "OTHER"
			},
			{
				"name": "norms",
				"salience": 0.00009903344,
				"type": "OTHER"
			},
			{
				"name": "Boer republics",
				"salience": 0.00009903344,
				"type": "ORGANIZATION"
			},
			{
				"name": "values",
				"salience": 0.00009903344,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.00009903344,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.00009903344,
				"type": "LOCATION"
			},
			{
				"name": "race",
				"salience": 0.00009903344,
				"type": "EVENT"
			},
			{
				"name": "demographics",
				"salience": 0.00009903344,
				"type": "OTHER"
			},
			{
				"name": "error",
				"salience": 0.00009903344,
				"type": "OTHER"
			},
			{
				"name": "setbacks",
				"salience": 0.00009859091,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k0p9lk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zandspruit"
				},
				"name": "Zandspruit",
				"salience": 0.00009701387,
				"type": "LOCATION"
			},
			{
				"name": "front",
				"salience": 0.00009462201,
				"type": "OTHER"
			},
			{
				"name": "servants",
				"salience": 0.00009462201,
				"type": "PERSON"
			},
			{
				"name": "servants",
				"salience": 0.00009462201,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.00009462201,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.00009462201,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00009462201,
				"type": "OTHER"
			},
			{
				"name": "cannon fire",
				"salience": 0.00009462201,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.000094133364,
				"type": "EVENT"
			},
			{
				"name": "sight",
				"salience": 0.000094133364,
				"type": "OTHER"
			},
			{
				"name": "assegai",
				"salience": 0.00009342919,
				"type": "PERSON"
			},
			{
				"name": "burst",
				"salience": 0.00009177501,
				"type": "EVENT"
			},
			{
				"name": "arbiter",
				"salience": 0.000091364906,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.00009061808,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.00009021315,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.000088688175,
				"type": "OTHER"
			},
			{
				"name": "ditch",
				"salience": 0.000088688175,
				"type": "OTHER"
			},
			{
				"name": "erosion ditch",
				"salience": 0.000088688175,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.000088688175,
				"type": "OTHER"
			},
			{
				"name": "bag",
				"salience": 0.000087953,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle"
				},
				"name": "Battle",
				"salience": 0.000087691296,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "fall",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "sacrifices",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "factories",
				"salience": 0.000085749474,
				"type": "LOCATION"
			},
			{
				"name": "decay",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "downtown slum",
				"salience": 0.000085749474,
				"type": "LOCATION"
			},
			{
				"name": "province",
				"salience": 0.000085749474,
				"type": "LOCATION"
			},
			{
				"name": "municipality",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.000085749474,
				"type": "LOCATION"
			},
			{
				"name": "benefits",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "friendship",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "psyche",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "festivals",
				"salience": 0.000085749474,
				"type": "EVENT"
			},
			{
				"name": "reenactments",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "darkness",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "heathens",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.000085749474,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.000082666906,
				"type": "ORGANIZATION"
			},
			{
				"name": "tens of thousands",
				"salience": 0.00008192975,
				"type": "PERSON"
			},
			{
				"name": "lighting",
				"salience": 0.00008192975,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.00008192975,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.00008192975,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.00008192975,
				"type": "OTHER"
			},
			{
				"name": "wagon circle",
				"salience": 0.00008192975,
				"type": "OTHER"
			},
			{
				"name": "survivors",
				"salience": 0.0000778215,
				"type": "PERSON"
			},
			{
				"name": "count",
				"salience": 0.0000778215,
				"type": "OTHER"
			},
			{
				"name": "ditch",
				"salience": 0.00007616412,
				"type": "OTHER"
			},
			{
				"name": "noise",
				"salience": 0.000074580574,
				"type": "OTHER"
			},
			{
				"name": "holiday",
				"salience": 0.000074580574,
				"type": "EVENT"
			},
			{
				"name": "shields",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "paces",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "perimeter",
				"salience": 0.000073970936,
				"type": "LOCATION"
			},
			{
				"name": "gunpowder smoke",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "ranks",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.000073970936,
				"type": "EVENT"
			},
			{
				"name": "mist",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "shoulders",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "spirits",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "spirits",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "disarray",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "wagon perimeter",
				"salience": 0.000073970936,
				"type": "OTHER"
			},
			{
				"name": "bursts",
				"salience": 0.000073970936,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01bh3l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KwaZulu-Natal"
				},
				"name": "Kwa-Zulu Natal",
				"salience": 0.00007306814,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j_4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mpande_kaSenzangakhona"
				},
				"name": "Mpande",
				"salience": 0.00007246245,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.00007239556,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00007179543,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06q1r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scotland"
				},
				"name": "Scotsman",
				"salience": 0.00006749999,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lmx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scottish_people"
				},
				"name": "Scotsmen",
				"salience": 0.00006416011,
				"type": "PERSON"
			},
			{
				"name": "resort",
				"salience": 0.00006404865,
				"type": "LOCATION"
			},
			{
				"name": "figure",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "breeze",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "ox-whips",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "blasts",
				"salience": 0.00006404865,
				"type": "EVENT"
			},
			{
				"name": "silence",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "edge",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00006404865,
				"type": "PERSON"
			},
			{
				"name": "wagon canvasses",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "gunfire",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "retreat",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "readiness",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "spear shafts",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "comrades",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "billows",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.00006404865,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.00006404865,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "paces",
				"salience": 0.0000635251,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00006244399,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christianity",
				"salience": 0.000060942864,
				"type": "OTHER"
			},
			{
				"name": "defenders",
				"salience": 0.000059850405,
				"type": "PERSON"
			},
			{
				"name": "Philip Fourie",
				"salience": 0.000055923487,
				"type": "PERSON"
			},
			{
				"name": "cannon",
				"salience": 0.000055786946,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "lines",
				"salience": 0.00005102253,
				"type": "OTHER"
			},
			{
				"name": "lights",
				"salience": 0.00004182433,
				"type": "OTHER"
			},
			{
				"name": "orders",
				"salience": 0.00004182433,
				"type": "OTHER"
			},
			{
				"name": "Estimates",
				"salience": 0.000037592614,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T16:03:07.410+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 71.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "When the River Ran Red Arthur Kemp, American Renaissance, September 2008 \nThe year is 1838. Dodging a flurry of spears, the Boer commander, Andries Pretorius, rides forward to seize a Zulu warrior. In the midst of an epic battle between more than 15,000 warriors and just 468 Boers, Pretorius has decided to take a Zulu alive. He wants to send the captive back to his king, Dingaan, to convey surrender terms to the Zulu nation. \nThe warrior has no intention of being taken alive, and jabs viciously at Pretorius with his assegai. This is a Zulu spear, normally a long-shafted throwing weapon, but the warrior broke its shank earlier for close-quarter stabbing. Pretorius gives up on capturing the Zulu, and tries to shoot him. \nWith a single-shot, muzzle-loading musket, he has only one chance of a hit. There is no time to reload in close combat. To his horror, Pretorius sees the smoke-trailing ball whiz past the Zulu’s ear. At the same time, the Zulu lunges forward, causing Pretorius’s horse to stumble backwards, throwing the white commander to the ground. \nLeaping to his feet, he meets the attacking Zulu, who knows he is now on equal terms with the white man, who can no longer use his magic shooting stick and carries no weapon comparable to the assegai. Pretorius is now fighting for his life. He just manages to sidestep the spear point, striking it away with the butt of his gun. \nSpinning round, the Zulu raises his spear high above his head and thrusts down, as he has been trained to do in the Zulus’ disciplined army. It is a blow that will be fatal if it strikes home, but Pretorius sees it coming. He grabs the spear point with his left hand to ward it away from his chest. The sharp point cuts deeply into his palm, embedding itself at an angle that makes it impossible for the Zulu to pull it out. Pretorius seizes the Zulu by the throat with his free right hand and throws him to the ground in an attempt to strangle him. \nThe Zulu struggles, and with the help of two good hands is about to break free, when one of Pretorius’s men comes upon the scene. He pulls the assegai out of the commander’s hand, and plunges it into the Zulu’s side, ending the struggle. \nPretorius remounts and heads back to the Boer camp for treatment. He is not worried, as he knows by now that this greatest of all battles between Boers and Zulus has already been won. The main Zulu army has been broken in two, and the river that runs along one side of the Boer camp is stained red with Zulu blood. The place and the tributary known previously as the Ncome will be renamed Blood River. Pretorius knows that the Zulu defeat, which will include some 3,000 killed on the battlefield, is a fit revenge for the deception and murder committed by the Zulus 10 months earlier. \nPrelude to War \nThe great clash between the Boer and Zulu nations was not, as leftist historians like to claim, the result of ruthless white colonialism suppressing an indigenous people. It came about because the Zulus rejected an extremely reasonable attempt at negotiation by the Boers. \nThe Boers, pioneers of Dutch, French, and German descent, were the people who opened up much of what was later to become South Africa. Their first antecedents had landed on the southernmost tip of Africa in 1652, only 45 years after the Virginia Company settled on Jamestown Island. \nWhen they arrived in the area now known as Cape Town, whites came into contact only with Hottentots and Bushmen. As the number of Europeans increased, they expanded east and north, only meeting their first black tribe, the Xhosa, some 500 miles away, on South Africa’s east coast. The Xhosas were migrating south, fleeing the warlike Zulu to the north, who were engaged in imperialist expansion of their own. \nFor just under a century white settlement halted at this eastern frontier border formed by the coast and firm Xhosa settlement. It was not, however, a time of peace, as Xhosa were constantly raiding the Boers who lived on the border. This caused much harm and discontent among the farmers, who blamed the Dutch-ruled colonial government back in Cape Town for the lawlessness. \nIt only added to the border farmers’ grievances when the British took the Cape Colony from the Dutch in 1806 to prevent the colony from falling into French hands during the Napoleonic Wars. It was vital to control the merchant and naval refitting station on the way to the Far East. The new colonial masters not only started anglicizing the colony, when they abolished slavery they offered compensation that amounted to hardly a quarter of a slave’s value. \nExasperated by incessant Xhosa attacks and British attempts to suppress their language and culture, groups of frontier farmers, filled with a sense of manifest destiny not seen again until the opening of the American West, set forth to the north and the east in a movement known as the Great Trek. The trekkers (they became known as Voortrekkers, or pioneers, only after 1880) bypassed the Xhosa in search of new, unsettled territory, in which they could establish independent Boer nations. All told, it was only a small minority of no more than 12,000 Boers who made the trek to the future Natal, Orange Free State, and Transvaal regions. They traveled in several waves of covered, ox-drawn wagons much like the Conestogas in which Americans opened the West. \nThe Boer leader of the time, Piet Retief, had written the trekker “manifesto,” in which he spelled out the farmers’ long-held grievances against the British. By1836, the Boer wagons had crossed the great mountain range into Natal, in an act of audacity that few thought possible. The range, the highest in southern Africa, had been named the Drakensberg—the Dragon Mountains—because they were said to be impassable. \nRetief had identified a large piece of uninhabited land to the north of the Zulu kingdom, which lay open to settlement. Retief knew that if he wanted the land for his people, he could take it unopposed. However, he wanted to live in peace with his Zulu neighbors, and before taking possession, he opened negotiations with the Zulu king, Dingaan. He wanted no misunderstanding between the two peoples. \nHe sent a letter to the Zulu king explaining why he wanted to speak to him, and first visited Dingaan’s capital—a large circle of reed and grass huts—on November 5, 1837. Retief left the main body of trekkers and went to the Zulu king’s capital, Umgungundhlovo (“the place of the elephant”), to negotiate a treaty that would allow Boers peacefully to settle land adjoining the Zulu kingdom. Dingaan said he would let the Boers live in Natal if they recovered cattle stolen by a Tlokwa chieftain. Retief and his men did so, and Dingaan agreed to give the land to the Boers. \nRetief returned to Umgungundhlovo on February 3, 1838, to finalize the agreement. He arrived with 60 volunteers, including his own son and three children of other men—it was common for children to accompany their fathers on expeditions of this kind. The next day, Retief and Dingaan formally signed a treaty—the Zulu king made his mark by scratching an “X” on the document—giving possession of the land to the Boers. Delighted, the Boers sent scouts back to the main encampments to report the successful outcome and made ready to leave. As Retief and his party were about to saddle up, a messenger arrived from Dingaan inviting the Boer party to a special celebration to mark the signing. Retief was suspicious but did not want to offend Dingaan. As they had on previous visits, the Boers stacked their firearms neatly outside the reed walls and entered the royal enclosure unarmed. \nAs they ate and drank, a Zulu impi, or warrior unit, put on a dance for the guests. According to the account of a white missionary who was present, the dancing warriors drew ever closer to the Boers, till they were just in front of the seated whites. When the Zulu king leaped to his feet and shouted, “Kill the white wizards!” the impi fell upon the surprised Boers. Some of them drew their hunting knives and tried to fight off the attackers, but they were quickly overwhelmed. \nThe Zulu warriors bound the whites with reed ropes and dragged them to Hlomo Amabutho, the Hill of Execution, near the Zulu capital. There they clubbed the Boers to death, one by one, with Retief kept until last and forced to watch his son being murdered. After Retief’s heart was extracted and presented to Dingaan as proof that the Boer leader was dead, the bodies were left for the vultures, in accordance with Zulu custom. \nDingaan then gave orders for the full might of his army to attack the Boer camps. The settlers had received the message Retief had sent earlier and believed everything had gone well. They were therefore completely unprepared and badly undermanned. The 60 men in Retief’s party were all dead. Many other men had gone hunting, leaving only a light guard for the women and children. The Boers were so confident there would be peace that they had not even posted sentries. Just before dawn, barking dogs aroused the outlying wagons. Then, thousands of Zulu warriors attacked the several hundred trekkers — women, children, and old men — as they lay sleeping. \nThe Boer historian, Gustav Preller, who interviewed survivors, left a harrowing account of the aftermath: “All around dozens and dozens of bodies … babies who had had their heads smashed open against the wagon wheels, women, dishonored and in some Zulu custom, their breasts cut off … [I]n a wagon, blood filled to a height of several inches, the life blood of an entire family ebbed out where they lay … Jan Bezuidenhout, one of the few young men who had not gone ahead with the Retief party, grabbed his four-month-old baby daughter out of her crib and ran off through the undergrowth … [H]aving lost his pursuers a few miles away, Bezuidenhout checked for the first time on his daughter in his arms. She was dead; a single spear stroke had killed her.” \nThe slaughter became known as the Weenen, the Dutch word for weeping, and a town of that name still stands near the site. Of the 600 Boers camped in the area, Zulus killed some 300, including 185 children. The rest survived because grazing requirements for their animals meant that the Boer camps had to be widely dispersed. If Dingaan’s men had scouted more thoroughly, found all the encampments, and attacked them simultaneously, the slaughter would have been far greater. \nPretorius arrives \nThe Boers now faced their greatest challenge. Their camps were full of wounded men, orphaned children, and widows. The Zulus had stolen an estimated 25,000 head of cattle and sheep during the Weenen slaughter, and ammunition was running low. The Zulu armies might return at any time, and they were a formidable force, as the Boers discovered when they launched a raid to avenge the massacre. On April 6, 1838, 347 trekkers under a divided command of Piet Uys and Hendrik Potgieter rode into Zulu territory only to be defeated by some 7,000 warriors not far from Umgungundhlovo in what became known as the Battle of Italeni. \nThis new disaster forced the Boers to face reality: They had to either abandon their quest for independence and return to the Cape Colony, or find some means to fight their way through. The widows and orphans argued strongly for pushing on. They knew that if they fell back to the Cape they would have to live on charity, whereas if Dingaan could be defeated they could at least recover their livestock. Many Boers were also convinced that God favored them, and that setbacks were only a test of faith. \nIt was at this moment of indecision that a popular lawyer named Andries Pretorius answered the trekker call for reinforcements, and rode into camp with 60 men and a brass cannon. The Boers appointed him commander in chief on November 25, and he immediately began preparing a strike against the Zulu. \nHis means were few. A force of only about 468 Boers, including three Scotsmen, set out on November 27 seeking battle. For extra protection, the Boer column of 64 wagons traveled four abreast, instead of the usual single file. Each night, they formed a circular defensive formation, known as a laager. \nPretorius realized that even with two front-loading cannon, his force was too weak to defeat the Zulu army in an open field. He therefore decided to draw the enemy into an attack on the Boer encampment. Each day patrols and scouting parties rode ahead, sometimes led by Pretorius himself, to make sure no unexpected surprises were waiting over the horizon. \nOn December 9, 1838, the Boer party reached the Zandspruit tributary of the Waschbank River. It was here that the Boer chaplain, Sarel Cilliers, first pledged during his nightly sermon that if God helped them defeat the Zulus, they and their descendents would celebrate that day in honor of God, and that they would build a church in commemoration. The Boers repeated this oath, known in Afrikaner folklore as “the covenant,” every night until they met the enemy. \nThere appeared to be no movement from the Zulu side. On December 12, Pretorius decided to move camp to the Buffalo River, hoping to provoke the Zulus by moving farther into their territory. That day, he sent out two patrols, one under the command of his deputy, Commandant Hans De Lange, and another, under the Scotsman Edward Parker. This latter group saw action when they came upon a small group of Zulus. They killed the warriors and took the women prisoner. \nPretorius drew up a message for Dingaan on a white cloth, explaining that he was leading a commando to punish the Zulus. If, however, Dingaan was willing to cooperate, Pretorius wrote, he was still willing to make peace—a generous offer in light of the earlier betrayal. He freed the prisoners and told them to give the message to Dingaan. He received no answer. \nOn December 13, the Boers spotted Zulus and what appeared to be a large number of cattle near their camp. Piet Uys had been tricked by such a ploy at the Battle of Italeni. Zulu warriors, crouching behind toughened animal-skin shields, looked like cattle from a distance, and Uys dropped his guard. He was killed in a surprise attack by the “cattle.” \nPretorius did not make the same mistake, and he sent a 120-strong mounted unit to investigate the “cattle.” They turned out to be Zulus, and in the short fight that followed the Boers killed eight warriors but suffered no casualties. Pretorius now suspected that the Zulus were preparing for battle. \nOn December 15 he moved the Boer camp to a position alongside the Ncome River, itself a tributary of the Buffalo River. A scouting expedition that day confirmed the presence of two huge Zulu armies a short distance away. \nPretorius prepared for battle. His men drew the wagons into a D-shaped formation, one side overlooking a large hippopotamus path facing the Ncome River, another side facing a soil erosion ditch, and the third side facing the open plain. Pretorius chose the site to limit the directions from which the Zulus could attack. \nThe laager was large enough to contain all the horses and oxen. The defenders tied the wagons together with leather ropes, and closed off all openings between and below the wagons with a Pretorius innovation, so-called fighting gates, which were slatted wood fixtures through which defenders could fire. They left two small openings, sealed with removable fighting gates, so cavalry could leave the laager. Finally, they attached lanterns to the ends of large ox-whips planted upright in the ground. These dangled in front of the laager and were to serve as forward lighting during the dark hours when Zulu usually attacked. Zulus captured after the battle said they had believed the lights waving in the breeze above the Boer camp were spirits, and that fear of the spirits kept them from attacking that night. \nBattle is joined \nIn Pretorius’s own account of the battle, he wrote that as the mist cleared on the morning of December 16, he saw that the Boer camp was completely encircled by tens of thousands of Zulu warriors, even where the terrain would have made an attack difficult. Estimates placed the number of Zulus at between 15,000 and 25,000, although no official count was possible. Whatever the figure, Pretorius wrote that it was a “terrible sight.” \nThe Boers had been ready and armed since two hours before daybreak. The two cannon were in position, and the fighting gates closed. The defenders expected to run out of ammunition for the cannon, and had stacked up suitably sized stones at strategic points along the perimeter to fire as a last resort. The Boers would fire stones that day. \nThe front lines of the Zulu force were still, squatting, only about 40 paces from the wagons, waiting for the signal to attack. Pretorius decided to strike first. At his signal, three bursts of fire from the Boer guns and two blasts from the cannon broke the silence. The Boers’ orders were to then hold their fire. As the billows of gunpowder smoke lifted, they saw that the surviving Zulus had fled some 500 paces from their former front line, leaving behind dozens of dying and dead comrades. \nThe Boers then heard the noise of the Zulus breaking their spear shafts to make them into short, stabbing weapons. A frontal assault was coming. A few minutes later, the Zulu force stormed the wagons, screaming wildly, shields held high, and assegais in readiness. Withering gunfire ripped through the Zulu ranks, and while some managed to reach the wagons, they were gunned down before they could cut through the wagon canvasses. \nAnother group of Zulus tried to attack from inside the erosion ditch by standing on each others’ shoulders and scrambling over the edge. Pretorius ordered Cilliers, the fighting churchman, to see off the attack. He led a group of men out of the relative safety of the wagon perimeter, and they proceeded to kill some 400 Zulus. One Boer, Philip Fourie, was wounded when an assegai struck him in the side. \nThe Boers then wheeled one of their cannon out of the laager, pointed it into the ditch, and fired a shot that literally blew apart the assaulting party. The survivors fled the ditch in disarray. This sparked a temporary retreat by the Zulu, and marked the end of the second unsuccessful attempt to break the Boer lines. The wounded Boer, Fourie, returned to the wagon circle for treatment. \nAs the Zulus waited for new orders, Pretorius ordered another burst of cannon fire into their ranks, provoking a spontaneous charge against the wagons. Although it was the longest single assault of the nine-hour battle, it was utterly defeated, as the Boers cut down wave after wave of attackers. Gun barrels got so hot men had to hold them with wet cloths for reloading. \nAs the third attack fell back, the Boers launched their first surprise counterattack, as the mobile fighting gates swung open and a cavalry unit charged the Zulu lines. Shooting from the saddle, the Boers tried to turn the Zulu lines to their left. Desperate Zulu resistance, which saw hundreds more of their number killed, stopped the encircling action, and the Boer horsemen rode back to the wagons. They regrouped and launched a second attempt, driving the Zulus further away. A third mounted charge finally broke through the Zulu lines. The Boer cavalry then turned and attacked the Zulus from the rear. Pinned between the cavalry and cannon fire from within the wagon circle, the main Zulu force facing the open plain scattered. \nA reserve Zulu force tried to cross the Ncome River to attack the laager but so many warriors were gunned down that their blood stained the water red. Pretorius himself then led another cavalry charge from within the laager. Cut to pieces, with thousands dead, the Zulu army, which had courageously charged repeatedly against a better-armed enemy, finally broke ranks and fled. \nPretorius divided his cavalry into two units and sent them in pursuit. Mounted Boers killed hundreds of warriors during a three-hour chase. It was during this pursuit that Pretorius was wounded. Two other Boers, including Fourie, suffered nonfatal assegai wounds, but these were the only Boer casualties. An estimated 3,000 Zulus died on the battlefield, and many more died later from wounds. \nThe Aftermath \nEarly the next morning, Pretorius ordered the camp broken, and marched the commando straight to the Zulu king’s capital. He was confident the Zulus no longer posed any significant threat, but he hardly expected the sight that awaited him on December 20 at Umgungundhlovo. Dingaan had fled with his wives and cattle, leaving the circular camp of reed huts burning, as a symbol of the destruction of Zulu power. \nOn the outskirts of the capital the Boers found the skeletons of Retief and his men. “Their hands and feet were still bound fast with thongs of ox hide,” wrote Cilliers, “and in nearly all the corpses a spike as thick as an arm had been forced into the anus so that the point of the spike was in the chest.” Retief, who was identified by the remains of a satin vest he had worn, still had a leather bag draped over his shoulder bone. In it was the treaty, signed by Dingaan, giving the Boers the unoccupied land to the north. According to one of the Boers who saw it, the treaty was astonishingly well preserved—as if it had been “left in a closed box.” Pretorius’s men buried Retief and his party on Christmas Day 1838. \nDingaan fled north but was captured by a rival tribe, the Swazis. Earlier, he had persecuted the Swazis, and they murdered him in revenge. The new Zulu king, Mpande, was officially installed in 1840, and confirmed the contents of the treaty with the Boers, who established their first republic in southern Africa. Also in 1840, in fulfillment of their covenant, the Boers built a church to mark the Blood River victory. \nThe Battle of Blood River entered the Afrikaner psyche as a divinely-inspired victory, and December 16 became a public holiday in South Africa, celebrated each year with festivals, church services, and reenactments. The battle represented the victory of European civilization over the darkness of Africa, of Christianity over heathens. It helped justify white supremacy and the self-appointed right of Afrikaners to rule over, not apart from, the black tribes. \nYet the Battle of Blood River, in many ways, symbolized all that was wrong with the white settlement of southern Africa, and why that experiment failed. The Boers are to be praised for wanting to settle unoccupied land peacefully, and for seeking the friendship of neighboring peoples, but neither they nor their descendents understood that demography is the arbiter of nations. Those who form the majority population of a territory will rule that territory, no matter how powerful a ruling elite may be. They will determine its culture and society. A majority-European population will create a society that reflects European values and norms. A majority-African population will create a society that reflects African norms. \nThe Boers never understood this. Even at the Battle of Blood River they had at least 60 black servants and an indeterminate number of mixed-race servants, who helped load weapons. Parker, one of the Scotsman, had more than 100 black servants. \nTo the present day, the overwhelming majority of Afrikaners have black servants who work on farms, in factories, and in homes. Afrikaners failed to understand that by giving the native population the benefits of European civilization, blacks would grow in numbers and overwhelm their society. The Cape Colony and the original Boer republics, which were largely uninhabited by natives when they were settled by Europeans, are today home to tens of millions of Africans. \nThe Church of the Vow, built by the Boers in 1840, still stands in the town of Pietermaritzburg, named after Piet Retief. But Pietermaritzburg, supposedly the symbol of the Boer victory over the Zulus, is today part of a municipality called Umgungundhlovo, named after Dingaan’s capital. It is also the capital of the South African province of Kwa-Zulu Natal, and its population is more than 95 percent black. \nThe Church of the Vow stands alone, graffiti-scarred and abandoned, in a dirty downtown slum. Its decay illustrates the fatal error made by the victors of the Battle of Blood River, that of ignoring the demographics of race. If whites had taken possession of those unoccupied lands and kept them for themselves alone the history of South Africa would have been entirely different. \nIf the Boers had inhabited and worked their own land rather than rely on black labor, the states they created might still be strong and independent today. Their decision to use non-white labor was a critical error that undid all of the sacrifices of the early pioneers. \nThe only way to maintain a civilization is for the majority to occupy its own land with its own people, and to do its own manual labor. This law governs the rise and fall of civilizations, and the victors of Blood River ignored it, to their cost.",
		"thread_title": "When the River Ran Red",
		"title": "When the River Ran Red",
		"type": "bs",
		"uuid": "d3f4070558ca01d80284e4c3a5562f3d77b460e6"
	},
	"-KhIgz0rScd9GqAl5p99": {
		"author": "Stanley Hornbeck",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T17:45:01.884+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.46593636,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Senator Sanders",
				"salience": 0.18161052,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African Americans",
				"salience": 0.030978767,
				"type": "PERSON"
			},
			{
				"name": "piece",
				"salience": 0.023367515,
				"type": "OTHER"
			},
			{
				"name": "Steven Thrasher",
				"salience": 0.019490318,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.015418958,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.0133159505,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0127556585,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.010639121,
				"type": "OTHER"
			},
			{
				"name": "low",
				"salience": 0.0097712325,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.0075903055,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.007378578,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.007378578,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.007378578,
				"type": "OTHER"
			},
			{
				"name": "Black Vote Ethnomasochism",
				"salience": 0.0060249288,
				"type": "ORGANIZATION"
			},
			{
				"name": "nomination",
				"salience": 0.005992572,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.005904661,
				"type": "PERSON"
			},
			{
				"name": "primary",
				"salience": 0.005260349,
				"type": "EVENT"
			},
			{
				"name": "play",
				"salience": 0.005000753,
				"type": "OTHER"
			},
			{
				"name": "chattering class",
				"salience": 0.005000753,
				"type": "OTHER"
			},
			{
				"name": "pandering",
				"salience": 0.005000753,
				"type": "OTHER"
			},
			{
				"name": "commenter",
				"salience": 0.0048757866,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hands",
				"salience": 0.0043314886,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0043314886,
				"type": "OTHER"
			},
			{
				"name": "quotient",
				"salience": 0.0043314886,
				"type": "OTHER"
			},
			{
				"name": "debates",
				"salience": 0.0043314886,
				"type": "OTHER"
			},
			{
				"name": "How Hillary Courts",
				"salience": 0.004208743,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0035315782,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.0035157627,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0031101832,
				"type": "OTHER"
			},
			{
				"name": "minority votes",
				"salience": 0.003042911,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.003042911,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.0027456824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "The Guardian",
				"salience": 0.0026678115,
				"type": "OTHER"
			},
			{
				"name": "experiences",
				"salience": 0.0026607318,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02d2xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.0025195712,
				"type": "EVENT"
			},
			{
				"name": "activists",
				"salience": 0.002060761,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.002060761,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.002060761,
				"type": "EVENT"
			},
			{
				"name": "problem",
				"salience": 0.002060761,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0020545325,
				"type": "OTHER"
			},
			{
				"name": "supporter",
				"salience": 0.001897505,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanic",
				"salience": 0.001840473,
				"type": "PERSON"
			},
			{
				"name": "contributions",
				"salience": 0.0017956514,
				"type": "OTHER"
			},
			{
				"name": "accusation",
				"salience": 0.0017845889,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0017845889,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0017845889,
				"type": "OTHER"
			},
			{
				"name": "comparison",
				"salience": 0.0017845889,
				"type": "OTHER"
			},
			{
				"name": "turn",
				"salience": 0.0017845889,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.001742438,
				"type": "PERSON"
			},
			{
				"name": "electorates",
				"salience": 0.0016004456,
				"type": "PERSON"
			},
			{
				"name": "momentum",
				"salience": 0.0014450889,
				"type": "OTHER"
			},
			{
				"name": "moments",
				"salience": 0.0013911613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0013879336,
				"type": "PERSON"
			},
			{
				"name": "privilege",
				"salience": 0.0013563316,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.001283507,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.0012673371,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0012513708,
				"type": "OTHER"
			},
			{
				"name": "ocean",
				"salience": 0.0012513708,
				"type": "LOCATION"
			},
			{
				"name": "shore",
				"salience": 0.0012513708,
				"type": "LOCATION"
			},
			{
				"name": "middle",
				"salience": 0.0012513708,
				"type": "LOCATION"
			},
			{
				"name": "memo",
				"salience": 0.0012513708,
				"type": "WORK_OF_ART"
			},
			{
				"name": "quest",
				"salience": 0.0012046677,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0012046677,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.0012046677,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0012046677,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0012046677,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.001179773,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.001179773,
				"type": "OTHER"
			},
			{
				"name": "primary",
				"salience": 0.001179773,
				"type": "EVENT"
			},
			{
				"name": "racism",
				"salience": 0.001179773,
				"type": "OTHER"
			},
			{
				"name": "barriers",
				"salience": 0.001179773,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0011693948,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0011272492,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0010884674,
				"type": "EVENT"
			},
			{
				"name": "emphasis",
				"salience": 0.0010747532,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0010346381,
				"type": "OTHER"
			},
			{
				"name": "barriers",
				"salience": 0.001032549,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0010216018,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0010216018,
				"type": "OTHER"
			},
			{
				"name": "Tef Poe",
				"salience": 0.00094104867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.00088951964,
				"type": "LOCATION"
			},
			{
				"name": "answer",
				"salience": 0.00088133523,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00088133523,
				"type": "PERSON"
			},
			{
				"name": "low",
				"salience": 0.0008702296,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0008484362,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0288j83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0008042667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.00077024655,
				"type": "LOCATION"
			},
			{
				"name": "hot sauce",
				"salience": 0.00076315907,
				"type": "OTHER"
			},
			{
				"name": "bag",
				"salience": 0.00076315907,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00076315907,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.00076315907,
				"type": "OTHER"
			},
			{
				"name": "hosts",
				"salience": 0.00076315907,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.00076315907,
				"type": "PERSON"
			},
			{
				"name": "doubt",
				"salience": 0.00076315907,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016cb8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jorge_Ramos_(news_anchor)"
				},
				"name": "Jorge Ramos",
				"salience": 0.0007414927,
				"type": "PERSON"
			},
			{
				"name": "Iowa Brown",
				"salience": 0.0007414927,
				"type": "PERSON"
			},
			{
				"name": "Black Forum",
				"salience": 0.0007414927,
				"type": "ORGANIZATION"
			},
			{
				"name": "pandering",
				"salience": 0.0007194839,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00071091356,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00071091356,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0006709029,
				"type": "PERSON"
			},
			{
				"name": "ethnomasochism",
				"salience": 0.00064187497,
				"type": "OTHER"
			},
			{
				"name": "killings",
				"salience": 0.00063900754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08hz3z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Schomburg_Center_for_Research_in_Black_Culture"
				},
				"name": "Schomburg Center for Research in Black Culture",
				"salience": 0.0006287891,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06yxd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Carolina"
				},
				"name": "South Carolina",
				"salience": 0.0006287891,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f94t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harlem"
				},
				"name": "Harlem",
				"salience": 0.0006287891,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.000555798,
				"type": "OTHER"
			},
			{
				"name": "niggas",
				"salience": 0.000555798,
				"type": "PERSON"
			},
			{
				"name": "riots",
				"salience": 0.000555798,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.000555798,
				"type": "LOCATION"
			},
			{
				"name": "displays",
				"salience": 0.000555798,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.000555798,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.000555798,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.000555798,
				"type": "PERSON"
			},
			{
				"name": "sister",
				"salience": 0.000555798,
				"type": "PERSON"
			},
			{
				"name": "fellow",
				"salience": 0.000555798,
				"type": "PERSON"
			},
			{
				"name": "rules",
				"salience": 0.000555798,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.000555798,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00047947018,
				"type": "OTHER"
			},
			{
				"name": "privilege",
				"salience": 0.00047947018,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.0004696944,
				"type": "ORGANIZATION"
			},
			{
				"name": "ways",
				"salience": 0.00046537182,
				"type": "OTHER"
			},
			{
				"name": "passion",
				"salience": 0.00045371495,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00041516728,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.00041516728,
				"type": "OTHER"
			},
			{
				"name": "practice humility",
				"salience": 0.00041516728,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00041516728,
				"type": "PERSON"
			},
			{
				"name": "radio show",
				"salience": 0.00041516728,
				"type": "EVENT"
			},
			{
				"name": "pain",
				"salience": 0.0004099345,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07hwkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_American"
				},
				"name": "White Americans",
				"salience": 0.00037418515,
				"type": "PERSON"
			},
			{
				"name": "skills",
				"salience": 0.00026972554,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T08:08:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Posted on November 6, 2016 How Hillary Courts the Black Vote Ethnomasochism reaches a new low. \nThe Democratic presidential primary was one of unprecedented pandering for the non-white vote. As The Guardian summed up one of the debates: “Hillary Clinton and Bernie Sanders made a conspicuous play for Latino and African American voters.” Mrs. Clinton won the “conspicuous play” hands down, and with it, the nomination. The failure of Senator Sanders to win the necessary quotient of non-white votes was repeatedly pointed out by the chattering class up until the time he dropped out. \nIn February one black commenter pointedly wrote that Sen. Sanders, “has many miles to go to convince black voters that he can fight for our interests.” By May, black commenter Steven Thrasher wrote a piece titled, “ Bernie Sanders isn’t winning minority votes – and it’s his own fault .” Mr. Thrasher identified Sen. Sanders’s problem as “failing to talk about racism at every turn.” \nThis accusation may seem ludicrous, since Sen. Sanders surrendered his stage to Black Lives Matter activists several times. But in comparison to Mrs. Clinton, Mr. Thrasher was right about Sen. Sanders. No mainstream candidate in the history of the United States has more thoroughly debased himself in the quest for the black vote than Mrs. Clinton. Since this helped her win the Democratic nomination, she has continued the strategy. In the few days remaining before November 8th, let’s take a look at Hillary Clinton’s most ethnomasochistic moments. \n1) In January of 2016, Mrs. Clinton was at something called the Iowa Brown and Black Forum (with none other than Jorge Ramos ), where she was asked “Can you tell us what the term ‘white privilege’ means to you? And can you give me an example from your life or career when you think you have benefitted from it?” This is how she began her answer: \nWhere do I start? I think it is hard when you are swimming in the ocean to know exactly what is happening around you so much as it is when you’re standing on the shore perhaps watching . . . . I was born white, middle-class, in the middle of America. . . . \n2) Early in the Democratic nomination, Mrs. Clinton’s campaign released a memo aimed at stifling the rising momentum of Bernie Sanders: \n[W]hereas the electorates in Iowa and New Hampshire are largely rural/suburban and predominantly white, the March [primary] states better reflect the true diversity of the Democratic Party and the nation . . . . It will be very difficult, if not impossible, for a Democrat to win the nomination without strong levels of support among African American and Hispanic voters. We believe that’s how it should be. emphasis added \n3) Shortly before the South Carolina primary, at Schomburg Center for Research in Black Culture in Harlem, Mrs. Clinton explained how to break down barriers for African Americans: \nEnding systemic racism requires contributions from all of us—especially those of us who haven’t experienced it ourselves. White Americans need to do a better job of listening when African Americans talk about the seen and unseen barriers that you face every day. \nWe need to recognize our privilege and practice humility, rather than assume that our experiences are everyone’s experiences. All of us need to bring our skills to bear—and especially young people coming up today, who have a passion for social justice and are helping to create new ways to solve intractable problems. \n4) In April of 2016, while on a back radio show, Mrs. Clinton was asked what she always carries in her bag. She immediately answered, “hot sauce.” When one of the black hosts noted that she would be accused of pandering to black people for giving that answer, she asked hopeully, “Is it working?” \n5) Just a few weeks after a Black Lives Matter supporter murdered five police officers , the Democratic National Convention that convened to nominate Mrs. Clinton passed a resolution, no doubt with her approval, supporting Black Lives Matter : \n[T]he DNC joins with Americans across the country in affirming ‘Black lives matter’ and the ‘say her name’ efforts to make visible the pain of our fellow and sister Americans as they condemn extrajudicial killings of unarmed African American men, women and children. \nWhite politicians have tried to win elections through public displays of ethnomasochism for decades, but this election has set a new low. And if Mrs. Clinton loses, her pandering could live on in another form. As the Black Lives Matter activist Tef Poe explained , if Mr. Trump wins, “young niggas such as myself are fully hell bent on inciting riots everywhere we go . . . ain’t no more rules. We’ve been too nice as is.”",
		"thread_title": "How Hillary Courts the Black Vote",
		"title": "How Hillary Courts the Black Vote",
		"type": "bs",
		"uuid": "4d5e9991a3d157afaa914f8a292e1866ef64d9ae"
	},
	"-KhIgzaJMu83TBlt107v": {
		"author": "Jared Taylor",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:31.876+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.7031921,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bymv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_McCain"
				},
				"name": "John McCain",
				"salience": 0.117081255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.013710096,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.010715143,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.008530393,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.008530393,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0052629085,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0039594155,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0035342602,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0033601907,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0033122234,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0032142522,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0027801313,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.002637581,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0019648732,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0017844535,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0017844535,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0017799924,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0015820301,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0015368956,
				"type": "OTHER"
			},
			{
				"name": "black",
				"salience": 0.0014126124,
				"type": "OTHER"
			},
			{
				"name": "black",
				"salience": 0.0014126124,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0014126124,
				"type": "PERSON"
			},
			{
				"name": "spectacle",
				"salience": 0.0013730013,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0013527895,
				"type": "OTHER"
			},
			{
				"name": "Win",
				"salience": 0.0013527895,
				"type": "PERSON"
			},
			{
				"name": "white",
				"salience": 0.0013427277,
				"type": "OTHER"
			},
			{
				"name": "product",
				"salience": 0.0013091298,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "blacks",
				"salience": 0.0012522966,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.0012150243,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0011424412,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0011388577,
				"type": "OTHER"
			},
			{
				"name": "race man",
				"salience": 0.0011303512,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.001078063,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.001078063,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04736l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jared_Taylor"
				},
				"name": "Jared Taylor",
				"salience": 0.001073315,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0009907417,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.0009901609,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.0009709599,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.0009567698,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00090612326,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0008969981,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00089060003,
				"type": "LOCATION"
			},
			{
				"name": "race",
				"salience": 0.0008839456,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.0008839456,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0008839456,
				"type": "OTHER"
			},
			{
				"name": "movie-blacks",
				"salience": 0.0008783264,
				"type": "PERSON"
			},
			{
				"name": "television-blacks",
				"salience": 0.0008783264,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0008722062,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04645f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Renaissance_(magazine)"
				},
				"name": "American Renaissance",
				"salience": 0.0008330565,
				"type": "ORGANIZATION"
			},
			{
				"name": "balance",
				"salience": 0.00080892595,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00079816865,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00079816865,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.00079816865,
				"type": "ORGANIZATION"
			},
			{
				"name": "generation",
				"salience": 0.000793002,
				"type": "OTHER"
			},
			{
				"name": "favorite",
				"salience": 0.0007553285,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00075117504,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00073526835,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00073526835,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00073050853,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0006912027,
				"type": "OTHER"
			},
			{
				"name": "handouts",
				"salience": 0.0006912027,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0006912027,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0006912027,
				"type": "EVENT"
			},
			{
				"name": "taxes",
				"salience": 0.0006912027,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0006912027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0006515488,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.000611264,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00059475336,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.00058924296,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005872616,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0005720783,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00053294207,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005277352,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00052216515,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0005219297,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0005169039,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.00050989166,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0004963454,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0167xk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Sharpton"
				},
				"name": "Al Sharpton",
				"salience": 0.0004913727,
				"type": "PERSON"
			},
			{
				"name": "leg",
				"salience": 0.00048467837,
				"type": "OTHER"
			},
			{
				"name": "opponent",
				"salience": 0.00048153967,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0004655037,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00046356785,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00045430538,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0004519606,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/040cf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesse_Jackson"
				},
				"name": "Jesse Jackson",
				"salience": 0.00042549765,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.00042549765,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00040800078,
				"type": "PERSON"
			},
			{
				"name": "stomach",
				"salience": 0.00040502817,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00039396345,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.00039277205,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00038782312,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00038777807,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00038473008,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.00037025375,
				"type": "OTHER"
			},
			{
				"name": "Whites",
				"salience": 0.00036839256,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.0003639555,
				"type": "EVENT"
			},
			{
				"name": "racism",
				"salience": 0.0003639555,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0003530096,
				"type": "EVENT"
			},
			{
				"name": "denial",
				"salience": 0.0003530096,
				"type": "EVENT"
			},
			{
				"name": "thesis",
				"salience": 0.00035072313,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.00034163546,
				"type": "PERSON"
			},
			{
				"name": "Mr.",
				"salience": 0.00034057276,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.00033983245,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.00033705577,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.00033307986,
				"type": "PERSON"
			},
			{
				"name": "blackness",
				"salience": 0.00033307986,
				"type": "OTHER"
			},
			{
				"name": "Most",
				"salience": 0.0003288445,
				"type": "PERSON"
			},
			{
				"name": "credentials",
				"salience": 0.0003286148,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0003286148,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0003286148,
				"type": "OTHER"
			},
			{
				"name": "self-control",
				"salience": 0.000327147,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00031656903,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00031444064,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00031444064,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00031444064,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0003142018,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00031127146,
				"type": "PERSON"
			},
			{
				"name": "memory",
				"salience": 0.00031096625,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.00030535817,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0003037314,
				"type": "LOCATION"
			},
			{
				"name": "calling",
				"salience": 0.00030317839,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0003025661,
				"type": "ORGANIZATION"
			},
			{
				"name": "History",
				"salience": 0.00029845245,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00029845245,
				"type": "OTHER"
			},
			{
				"name": "brothers",
				"salience": 0.00028997008,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.00028455103,
				"type": "OTHER"
			},
			{
				"name": "patriotism",
				"salience": 0.00028455103,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00028455103,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.00028455103,
				"type": "OTHER"
			},
			{
				"name": "bigot",
				"salience": 0.00028455103,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.00028455103,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0002836904,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.0002762173,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00026845364,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.00026664863,
				"type": "PERSON"
			},
			{
				"name": "bones",
				"salience": 0.0002619939,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0002619939,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00025631988,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.00025517485,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.00025517485,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00025517485,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.00025517485,
				"type": "OTHER"
			},
			{
				"name": "pressures",
				"salience": 0.00024881266,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.00024881266,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.00024881266,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.00024881266,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.00024881266,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.00024589608,
				"type": "OTHER"
			},
			{
				"name": "address",
				"salience": 0.0002397373,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.00023671599,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.00023333424,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.00023039359,
				"type": "LOCATION"
			},
			{
				"name": "amnesty",
				"salience": 0.00023039359,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.00023039359,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.00022548818,
				"type": "PERSON"
			},
			{
				"name": "emphasis",
				"salience": 0.0002236195,
				"type": "OTHER"
			},
			{
				"name": "bases",
				"salience": 0.00022179207,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.00022179207,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00022179207,
				"type": "PERSON"
			},
			{
				"name": "baseball",
				"salience": 0.00022179207,
				"type": "OTHER"
			},
			{
				"name": "assassination",
				"salience": 0.00021899684,
				"type": "EVENT"
			},
			{
				"name": "diet",
				"salience": 0.0002180185,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00020987885,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.000209244,
				"type": "OTHER"
			},
			{
				"name": "backbone",
				"salience": 0.00020554017,
				"type": "OTHER"
			},
			{
				"name": "radio ads",
				"salience": 0.00020204301,
				"type": "WORK_OF_ART"
			},
			{
				"name": "event",
				"salience": 0.00020204301,
				"type": "EVENT"
			},
			{
				"name": "debates",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "geezer",
				"salience": 0.00019949662,
				"type": "PERSON"
			},
			{
				"name": "definition",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "orators",
				"salience": 0.00019949662,
				"type": "PERSON"
			},
			{
				"name": "sentence",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "illegals",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "weather",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "toothpaste",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "arrogance",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "sage advice",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "notes",
				"salience": 0.00019949662,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0001991835,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.00019903219,
				"type": "PERSON"
			},
			{
				"name": "reasons",
				"salience": 0.00019800459,
				"type": "OTHER"
			},
			{
				"name": "credence",
				"salience": 0.00019786628,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00019734165,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00019734165,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.0001920483,
				"type": "OTHER"
			},
			{
				"name": "prospect",
				"salience": 0.0001920483,
				"type": "OTHER"
			},
			{
				"name": "discovery",
				"salience": 0.0001920483,
				"type": "OTHER"
			},
			{
				"name": "exclamation mark",
				"salience": 0.0001920483,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.0001920483,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0001920483,
				"type": "EVENT"
			},
			{
				"name": "Editors",
				"salience": 0.0001920483,
				"type": "PERSON"
			},
			{
				"name": "line",
				"salience": 0.0001920483,
				"type": "OTHER"
			},
			{
				"name": "writing headlines",
				"salience": 0.0001920483,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.00019166114,
				"type": "PERSON"
			},
			{
				"name": "march",
				"salience": 0.00018962783,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.00018807812,
				"type": "LOCATION"
			},
			{
				"name": "interest",
				"salience": 0.00018807812,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00018807812,
				"type": "EVENT"
			},
			{
				"name": "much",
				"salience": 0.00017797534,
				"type": "OTHER"
			},
			{
				"name": "division",
				"salience": 0.00017797534,
				"type": "OTHER"
			},
			{
				"name": "mulatto president",
				"salience": 0.00017443814,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00017223957,
				"type": "PERSON"
			},
			{
				"name": "whites",
				"salience": 0.00017106143,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00016843471,
				"type": "LOCATION"
			},
			{
				"name": "everywhere",
				"salience": 0.00016843471,
				"type": "LOCATION"
			},
			{
				"name": "flames",
				"salience": 0.00016285459,
				"type": "OTHER"
			},
			{
				"name": "secretaries",
				"salience": 0.00016285459,
				"type": "PERSON"
			},
			{
				"name": "family member",
				"salience": 0.00016285459,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.00016285459,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.00016285459,
				"type": "OTHER"
			},
			{
				"name": "airways",
				"salience": 0.00016285459,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00016080198,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03lp2g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miss_USA"
				},
				"name": "Miss USA",
				"salience": 0.00015823026,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.00015560145,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00015560145,
				"type": "PERSON"
			},
			{
				"name": "brutes",
				"salience": 0.00015479804,
				"type": "PERSON"
			},
			{
				"name": "change",
				"salience": 0.00015218175,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00015159776,
				"type": "OTHER"
			},
			{
				"name": "stomach",
				"salience": 0.00015159776,
				"type": "OTHER"
			},
			{
				"name": "blunder",
				"salience": 0.00015092044,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.00014943561,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027lnzs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/IPhone"
				},
				"name": "iPhone",
				"salience": 0.00014663493,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cities",
				"salience": 0.00014345418,
				"type": "LOCATION"
			},
			{
				"name": "choice",
				"salience": 0.00014164603,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.00014048837,
				"type": "OTHER"
			},
			{
				"name": "balance",
				"salience": 0.00014048837,
				"type": "OTHER"
			},
			{
				"name": "sharks",
				"salience": 0.00014048837,
				"type": "OTHER"
			},
			{
				"name": "amnesty",
				"salience": 0.00014048837,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00014048837,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.00013823342,
				"type": "OTHER"
			},
			{
				"name": "the Second Coming",
				"salience": 0.00013649903,
				"type": "WORK_OF_ART"
			},
			{
				"name": "black",
				"salience": 0.00013535304,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.00013535304,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.00013535304,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00013535304,
				"type": "PERSON"
			},
			{
				"name": "most",
				"salience": 0.0001353373,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00013405252,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.00012277612,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f5bn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/H._L._Mencken"
				},
				"name": "H.L. Mencken",
				"salience": 0.00012277612,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.00012277612,
				"type": "ORGANIZATION"
			},
			{
				"name": "change",
				"salience": 0.00012266281,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.00012266281,
				"type": "OTHER"
			},
			{
				"name": "judges",
				"salience": 0.000121646124,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.000121646124,
				"type": "EVENT"
			},
			{
				"name": "non-whites",
				"salience": 0.000121646124,
				"type": "PERSON"
			},
			{
				"name": "cabinet",
				"salience": 0.000121646124,
				"type": "OTHER"
			},
			{
				"name": "civil rights",
				"salience": 0.000121646124,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.000121646124,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.00012011282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.000118819014,
				"type": "LOCATION"
			},
			{
				"name": "Battle of Lepanto",
				"salience": 0.00011819175,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/097gl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pearl_Harbor"
				},
				"name": "Pearl Harbor",
				"salience": 0.00011819175,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apple_Inc."
				},
				"name": "Apple",
				"salience": 0.00011819175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07g9y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Third_World"
				},
				"name": "Third-World",
				"salience": 0.00011574814,
				"type": "ORGANIZATION"
			},
			{
				"name": "telling",
				"salience": 0.000114170405,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.00011386061,
				"type": "PERSON"
			},
			{
				"name": "love feast",
				"salience": 0.000109907305,
				"type": "PERSON"
			},
			{
				"name": "nomination",
				"salience": 0.00010852194,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.000108269276,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.00010325417,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00010325417,
				"type": "PERSON"
			},
			{
				"name": "no one",
				"salience": 0.00010315289,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.00010230978,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00010230978,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00010230978,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00010230978,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026023l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeremiah_Wright"
				},
				"name": "Jeremiah Wright",
				"salience": 0.00010022359,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00010022359,
				"type": "LOCATION"
			},
			{
				"name": "voting",
				"salience": 0.00009930113,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.000097752796,
				"type": "OTHER"
			},
			{
				"name": "assassination",
				"salience": 0.00009481185,
				"type": "EVENT"
			},
			{
				"name": "fool",
				"salience": 0.00008971833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_ssl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Center_(basketball)"
				},
				"name": "Big Man",
				"salience": 0.00008920218,
				"type": "PERSON"
			},
			{
				"name": "dollar",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "incarceration rates",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "unemployment",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "wheezing",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "revenues",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "paint job",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.00008858741,
				"type": "OTHER"
			},
			{
				"name": "cousins",
				"salience": 0.00008858741,
				"type": "PERSON"
			},
			{
				"name": "Turning Up the Pressure",
				"salience": 0.000086458,
				"type": "WORK_OF_ART"
			},
			{
				"name": "most",
				"salience": 0.000084641564,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.000084641564,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00007641986,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asians",
				"salience": 0.000074861535,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06npx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sea"
				},
				"name": "Sea",
				"salience": 0.000074861535,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.000074861535,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mystic Knights",
				"salience": 0.000074861535,
				"type": "ORGANIZATION"
			},
			{
				"name": "guest bedrooms",
				"salience": 0.000073237505,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "AR",
				"salience": 0.00007115764,
				"type": "LOCATION"
			},
			{
				"name": "endorsement",
				"salience": 0.00007050268,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.00007050268,
				"type": "OTHER"
			},
			{
				"name": "doors",
				"salience": 0.000066169676,
				"type": "OTHER"
			},
			{
				"name": "heroes",
				"salience": 0.000066169676,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.000066169676,
				"type": "OTHER"
			},
			{
				"name": "figureheads",
				"salience": 0.000066169676,
				"type": "PERSON"
			},
			{
				"name": "miscegenation",
				"salience": 0.000066169676,
				"type": "EVENT"
			},
			{
				"name": "killing",
				"salience": 0.000066169676,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.000066169676,
				"type": "OTHER"
			},
			{
				"name": "quandary",
				"salience": 0.000066169676,
				"type": "OTHER"
			},
			{
				"name": "style",
				"salience": 0.000066169676,
				"type": "OTHER"
			},
			{
				"name": "dispossession",
				"salience": 0.000066169676,
				"type": "OTHER"
			},
			{
				"name": "daughter",
				"salience": 0.000066169676,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.00006533557,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02w_y5r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Side,_Chicago"
				},
				"name": "South Side",
				"salience": 0.000062961226,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05hpy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Association_for_the_Advancement_of_Colored_People"
				},
				"name": "NAACP",
				"salience": 0.000054516106,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.000054516106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/019rg5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kenya"
				},
				"name": "Kenya",
				"salience": 0.000054516106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African",
				"salience": 0.000054516106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07p6zym"
				},
				"name": "First-Lady",
				"salience": 0.000054516106,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.000054516106,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.000054516106,
				"type": "ORGANIZATION"
			},
			{
				"name": "co-workers",
				"salience": 0.00005401431,
				"type": "PERSON"
			},
			{
				"name": "fantasies",
				"salience": 0.000048186314,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0162b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bangladesh"
				},
				"name": "Bangladeshi",
				"salience": 0.0000407199,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0000407199,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:31.876+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 32.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Why Obama Will Win Jared Taylor, American Renaissance, August 2008 \nIt is time to get used to the idea that the next president of the United States will be black. Why will a nation we are so often assured is “racist” elect a black president? And will it make a difference? \nEver since Hillary Clinton dropped out of the race, the polls have reported consistently that Barack Obama will beat John McCain. The media love to tell us that whites say they support the black candidate and then vote for the white, but there is no reason for whites to lie in this campaign. Mr. Obama will not get a majority of the white vote but he will get enough to beat Mr. McCain. Why will so many whites vote for Mr. Obama? \nFirst, some support his policies. They want to end the war in Iraq, and they want the standard liberal program of socialized medicine, higher taxes, more handouts, and more government. There has always been a substantial minority of whites who vote this way, and they have a clear favorite in Mr. Obama. \nSecond, as many people have pointed out, an enormous number of whites think it is deeply virtuous to vote for a black—not for an out-and-out race man such as Jesse Jackson or Al Sharpton, but for an unthreatening, well-scrubbed black who speaks standard English and promises to “bring us together.” Even if they live sharply segregated lives, whites thrill to the language of “coming together,” and they adore blacks who don’t act or sound black. \nFor many whites, voting for Mr. Obama will be an act of high patriotism. Electing him will prove America is not “racist,” and many whites believe that rising above “racism” is America’s sacred calling. One must never underestimate the importance to whites of feeling virtuous. Most would rather lose a leg than be thought a “bigot,” and a vote for Obama is a painless way to burnish anti-racist credentials. \nThird, young whites will line up for Mr. Obama. They have been swallowing anti-white, multi-culti propaganda all their lives and have not knocked around enough to discover it is false. Some who know their parents will vote for Mr. McCain will make a special point of voting for Mr. Obama. Every new generation thinks it is cooler, hipper, and wiser than any generation that ever lived, and what could be cooler, hipper, or wiser than putting a black man in the White House? For many young whites, a vote for Mr. Obama will be a denial of every uncool, unhip, and especially every even faintly race-realist thing their parents ever said or did. \nFourth, although the country seems to have a collective memory of no more than two weeks, Americans think everything is “historic.” Whenever someone breaks an obscure record in professional baseball we are told history was made. If you ask someone why he waited in line all night to buy the first Apple iPhone he will tell you it’s a “historic” product. Americans love anything that is “historic,” and for people who think a few more stolen bases are “history” right up there with the Battle of Lepanto, putting a black man in the White House will be the discovery of America, Pearl Harbor, and the Second Coming all rolled into one. Many whites will vote for Mr. Obama because they want to think they helped “make history.” \nThe media, which has its own grim reasons for supporting Mr. Obama, is mesmerized by the same prospect. Editors salivate at the thought of writing headlines like “History is Made” the day after the election, and some will lose all self-control and add an exclamation mark. The emphasis, of course, will be on Mr. Obama as the first black president, implying more to come. The media, which always subtly boost the Democrat, will be even more blatantly partisan this time, downplaying every blunder Mr. Obama makes and highlighting Mr. McCain’s. \nFifth, many whites will vote for Mr. Obama—or at least not vote for Mr. McCain—because the Republicans have nominated the most stunningly unattractive candidate in years. Old and pock-marked, Mr. McCain is thoroughly disliked in the Senate for arrogance that he cannot even hide from voters when he is not speaking from notes. He has dismayed Republicans by promoting amnesty for illegals, and dismayed everyone else by saying America should stay in Iraq for 100 years if it takes that long to “win.” Mr. Obama therefore has the enormous advantage of running against an opponent that not even Republicans like. \nMr. Obama will also crush Mr. McCain in face-to-face debates. Mr. McCain cannot put an unscripted sentence together any better than George W. Bush can, and will come across as a thick-witted geezer. Mr. Obama, who is as glib as any politician, gives credence to H.L. Mencken’s definition of democracy as “rule by orators.” \nBut what about America’s storied “racism”? Isn’t America brimming with people who can’t bear the thought of a black president? Americans have been numbed for decades by attractive television-blacks who read the news, forecast the weather, and tell us which brand of toothpaste to buy. Americans get a steady diet of heroic movie-blacks who outsmart and beat up white brutes, solve baffling technical problems, dispense sage advice, and save the world. Even the current Miss USA is black. There are millions of whites who do not want to live with blacks or have much to do with them, but would a black president be much different from nearly eight years of black secretaries of state? The march of blackness may be vaguely worrying to whites but they think there is nothing they can do about it and that they shouldn’t even if they could. \nThe final reason why whites will vote for Mr. Obama is that the Republicans do not have the backbone to attack him in the only way that would work. If they were serious, they would fill the airways with Jeremiah Wright prancing and raving, along with the message: “This is the man who married Mr. and Mrs. Obama, baptized their children, and whom Mr. Obama calls a ‘family member’.” They would buy radio ads quoting Michelle Obama’s thesis in which she says she will always be black first and American second. Mr. McCain has nothing like the stomach for a campaign like this. \nMany blacks probably think he has the stomach for considerably worse: 57 percent think Mr. Obama is in greater physical danger than any white politician, and many say they would have warned him not to run, for fear he would be killed. An assassination would certainly be a shattering event. There is no telling how many cities would go up in flames, and Third-World countries, which have followed the Obama nomination with unprecedented interest, would help make it the most widely reported killing in history. (I have just returned from a Muslim country in which everyone has heard of Mr. Obama and likes him, but most have never heard of John McCain.) Whatever gruesome fantasies blacks may be spinning, however, assassination has gone out of style in America, and white resistance—such as it is—is dependably nonviolent. Mr. Obama will be perfectly safe. \nIn any case, Mr. Obama will win far more white votes than he will lose because he is black. Whites who don’t want a black president would not vote for a Democrat anyway. As for black voters, even nominal Republicans are said to be running for the doors, but strictly racial voting has always been fine for blacks. Not so for whites, of course. Just try telling your co-workers that you disagree with Mr. McCain but are voting for him because he is white. \nRacially conscious whites will be in a quandary in November. Even if Mr. McCain’s policies are worse than Mr. Obama’s should they vote for the white man—one with an adopted Bangladeshi daughter and who long ago betrayed white interests? Even after years of being softened up with black heroes and figureheads, a black in the White House is a powerful symbol of white dispossession. A mulatto president is an almost explicit endorsement of miscegenation. This is bitter medicine. \nSome whites have argued that a black president would undercut the charges of “racism” whites are forever facing, but they are dreaming. The entire government could look like a meeting of the Mystic Knights of the Sea, but as long as blacks are worse off than whites we will be blamed for it. Sensible whites cannot cheerfully vote for either man; I suspect most will stay home or vote for a minor candidate. \nAside from the symbolic impact, which cannot be calculated, will President Obama be much different from a President Hillary Clinton? She would lard her cabinet with blacks and Hispanics, nominate ultra-liberal judges, push for amnesty, grovel before non-whites everywhere, and load up the “civil rights” division of the Justice Department with anti-white sharks. She would certainly make a bigger fool of herself over Hispanics and Asians (see “ Turning Up the Pressure ,” AR, May 2008). Our choice, therefore, could not be more disagreeable. On balance, we get to decide which is the more degrading spectacle: deluded white people giving their country away or clear-eyed blacks helping themselves to it. \nPresident Obama will, however, face special pressures. He can’t let the pushier brothers walk all over him, but he will have to throw them enough bones to keep them off his back. It will be a tricky balance. Mr. Obama’s first annual address to the NAACP will be a love feast, but every year after that it will be harder to explain why black unemployment, poverty, and incarceration rates haven’t changed at all. \nEven Mr. Obama’s star-struck white supporters will eventually wonder what happened to all that “change” he promised. There is not going to be change. The system is far too stuck in its self-serving ways for that. With the help of an enlarged Democratic majority in Congress, Mr. Obama may set up some wheezing, byzantine form of socialized medicine, but no one will be happy with it. If Mr. Obama inherits a sick economy, a weak dollar, expensive oil, and shrinking revenues, Americans will not at all like the change they get. \nOn the bright side, with Mr. Obama we have a good chance of piquant First-Lady behavior. What will the White House be like with Michelle in charge? Will she want a new exterior paint job? How and whom will she entertain? Will the Big Man’s guest bedrooms—in the African tradition—be turned over to third cousins from Kenya and the South Side of Chicago? There is no telling with what improprieties large and small Mrs. Obama will entertain us as she makes up her mind whether she is an American. \nIt will be an edifying presidency; and whites may be a little less deluded in 2012.",
		"thread_title": "Why Obama Will Win",
		"title": "Why Obama Will Win",
		"type": "bs",
		"uuid": "28d045708d9eef2f71f9060ae642953693890077"
	},
	"-KhIgzg6Pqk8_u75LrJJ": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:31.911+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Minorities",
				"salience": 0.15171203,
				"type": "PERSON"
			},
			{
				"name": "Election",
				"salience": 0.12776218,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.09025744,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.07057476,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sjhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Examiner"
				},
				"name": "Washington Examiner",
				"salience": 0.06965977,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.060047697,
				"type": "ORGANIZATION"
			},
			{
				"name": "Paul Bedard",
				"salience": 0.060047697,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.054119058,
				"type": "PERSON"
			},
			{
				"name": "minorities",
				"salience": 0.043961003,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.042185858,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.03189584,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.023496825,
				"type": "PERSON"
			},
			{
				"name": "survey",
				"salience": 0.017011026,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.017011026,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.014109184,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.013902437,
				"type": "OTHER"
			},
			{
				"name": "models",
				"salience": 0.013902437,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bottom line",
				"salience": 0.010397949,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.010397949,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.008750419,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.008750419,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.008750419,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07pk4vb"
				},
				"name": "Secrets",
				"salience": 0.008572549,
				"type": "WORK_OF_ART"
			},
			{
				"name": "WalletHub",
				"salience": 0.008572549,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latin American",
				"salience": 0.008572549,
				"type": "LOCATION"
			},
			{
				"name": "minority",
				"salience": 0.007839021,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.006408303,
				"type": "PERSON"
			},
			{
				"name": "turnout",
				"salience": 0.0056658024,
				"type": "OTHER"
			},
			{
				"name": "population projections",
				"salience": 0.0056658024,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:31.911+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Last Majority White Election, Minorities to Give Democrats White House Through 2060 Paul Bedard, Washington Examiner, November 6, 2016 \nThis may be the last year that a Republican will be elected president, as the growth of liberal-leaning minorities all but guarantees that Democrats will hold the majority at least for the next four decades. \nThat’s according to an unusual survey on the impact of minorities, mostly Latin American, done for WalletHub and provided to Secrets . \nThe study used two models based on population projections and matched to the overwhelming 65 percent minority turnout for President Obama in 2012 and the underwhelming 50 percent response for George W. Bush in 2004. \nThe bottom line: In no presidential election from 2020-60 do the Republicans win. {snip} \n{snip}",
		"thread_title": "Last Majority White Election, Minorities to Give Democrats White House Through 2060",
		"title": "Last Majority White Election, Minorities to Give Democrats White House Through 2060",
		"type": "bs",
		"uuid": "c0f5187cb2377352e8e7b8120396b275e0229780"
	},
	"-KhIgzqmdopC4Nd0ZmPd": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:32.193+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.2440896,
				"type": "PERSON"
			},
			{
				"name": "future",
				"salience": 0.2093131,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.085794486,
				"type": "LOCATION"
			},
			{
				"name": "transformation",
				"salience": 0.034619518,
				"type": "EVENT"
			},
			{
				"name": "Address",
				"salience": 0.02717184,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.02717184,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latinos",
				"salience": 0.019723082,
				"type": "PERSON"
			},
			{
				"name": "White Majority",
				"salience": 0.019391382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.019391382,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.019391382,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.016813243,
				"type": "LOCATION"
			},
			{
				"name": "Tim Kaine Cheers",
				"salience": 0.016813243,
				"type": "PERSON"
			},
			{
				"name": "Julia Hahn",
				"salience": 0.016813243,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.016813243,
				"type": "PERSON"
			},
			{
				"name": "immigration policies",
				"salience": 0.014398699,
				"type": "OTHER"
			},
			{
				"name": "DAPA",
				"salience": 0.014016809,
				"type": "ORGANIZATION"
			},
			{
				"name": "future",
				"salience": 0.012604096,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.011274773,
				"type": "LOCATION"
			},
			{
				"name": "audience",
				"salience": 0.009213505,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.00870321,
				"type": "OTHER"
			},
			{
				"name": "immigration policies",
				"salience": 0.0075176605,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0073397066,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0066634705,
				"type": "PERSON"
			},
			{
				"name": "transformation",
				"salience": 0.006419933,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0061623594,
				"type": "PERSON"
			},
			{
				"name": "color",
				"salience": 0.005772339,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.005527807,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.00524011,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0051778383,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0051778383,
				"type": "OTHER"
			},
			{
				"name": "visa issuance policies",
				"salience": 0.0051778383,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0051091756,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0049849777,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.004314794,
				"type": "OTHER"
			},
			{
				"name": "transformation",
				"salience": 0.0042287195,
				"type": "EVENT"
			},
			{
				"name": "immigration controls",
				"salience": 0.0040501547,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0040501547,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.0040501547,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0040501547,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0038187446,
				"type": "ORGANIZATION"
			},
			{
				"name": "family detention",
				"salience": 0.0038187446,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0033073835,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.003096019,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0028537477,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vbl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calvin_Coolidge"
				},
				"name": "Calvin Coolidge",
				"salience": 0.0024943703,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0024714388,
				"type": "PERSON"
			},
			{
				"name": "hold",
				"salience": 0.0024714388,
				"type": "OTHER"
			},
			{
				"name": "pledge",
				"salience": 0.0024714388,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08qtd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pew_Research_Center"
				},
				"name": "Pew Research Center",
				"salience": 0.002401335,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0023023866,
				"type": "OTHER"
			},
			{
				"name": "dissolution",
				"salience": 0.0021498855,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0020789648,
				"type": "PERSON"
			},
			{
				"name": "amnesty",
				"salience": 0.0018939807,
				"type": "OTHER"
			},
			{
				"name": "substance",
				"salience": 0.0018003529,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0018003529,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.0018003529,
				"type": "OTHER"
			},
			{
				"name": "detention facilities",
				"salience": 0.001689794,
				"type": "LOCATION"
			},
			{
				"name": "freeze deportations",
				"salience": 0.001689794,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0015532497,
				"type": "PERSON"
			},
			{
				"name": "benefits",
				"salience": 0.0013450412,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0013450412,
				"type": "OTHER"
			},
			{
				"name": "voting privileges",
				"salience": 0.0013450412,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.0013450412,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.0011552101,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.00096399203,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:32.193+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Tim Kaine Cheers End of White Majority in Spanish Address Julia Hahn, Breitbart, November 5, 2016 \nDuring an Arizona speech delivered in Spanish, Sen. Tim Kaine cheered the demographic transformation of the United States caused by the nation’s federal immigration policies, telling his Latino audience on Thursday, “You are the future of America.” \n“By 2050, communities of color will represent the majority of our population,” Kaine said. “So, of course, Latinos will help shape the future of America because you are the future of America.” \nAs the Pew Research Center has documented, this demographic transformation is largely the result of the changes to visa issuance policies enacted into law in 1965 that lifted the immigration controls put in place by Calvin Coolidge during the 1920s. {snip} \n{snip} \nYet during his remarks, Kaine laid out how a Clinton administration plans to hasten the demographic transformation through expansive immigration policies that would essentially bring about the dissolution of national borders . Kaine explained how a Clinton-Kaine administration would “end family detention,” “close private detention facilities,” freeze deportations, and would give citizenship–and, by extension, voting privileges and access to federal benefits–to the illegal population. \nKaine also doubled down on his pledge to expand President Obama’s executive amnesty: \nA few months ago, the Supreme Court put DAPA on hold. That was devastating for millions of families. But it’s important to note that the Court didn’t actually rule on the substance of the case. Hillary and I have always said that DAPA is squarely within the President’s authority, and we will keep fighting for it. \n{snip}",
		"thread_title": "Tim Kaine Cheers End of White Majority in Spanish Address",
		"title": "Tim Kaine Cheers End of White Majority in Spanish Address",
		"type": "bs",
		"uuid": "9a24e24ad94e8c676c5b80b5df64952b03444138"
	},
	"-KhIgzxijIf6QuD2hYWw": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:35.405+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Minnesotans",
				"salience": 0.23447256,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.17236772,
				"type": "PERSON"
			},
			{
				"name": "Refugees",
				"salience": 0.09662524,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04ykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota"
				},
				"name": "Minnesota",
				"salience": 0.060616575,
				"type": "LOCATION"
			},
			{
				"name": "Tessa Berenson",
				"salience": 0.03906515,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07s52",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Time_(magazine)"
				},
				"name": "TIME",
				"salience": 0.03906515,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugee program",
				"salience": 0.03027973,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.029691068,
				"type": "LOCATION"
			},
			{
				"name": "pitch",
				"salience": 0.026262864,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.026262864,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somali",
				"salience": 0.022813452,
				"type": "LOCATION"
			},
			{
				"name": "rally",
				"salience": 0.022728123,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.022705447,
				"type": "LOCATION"
			},
			{
				"name": "immigrants",
				"salience": 0.017786955,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.014738104,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0120946355,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.009831109,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.009465425,
				"type": "OTHER"
			},
			{
				"name": "refugee vetting",
				"salience": 0.009465425,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0089255525,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.007830556,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.007732159,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.007732159,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0066730143,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0066730143,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fpzwf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minneapolis"
				},
				"name": "Minneapolis",
				"salience": 0.006591795,
				"type": "LOCATION"
			},
			{
				"name": "generations",
				"salience": 0.005780061,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.004907842,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.004863039,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.004552244,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.004211858,
				"type": "OTHER"
			},
			{
				"name": "extremism",
				"salience": 0.004211858,
				"type": "OTHER"
			},
			{
				"name": "radicalism",
				"salience": 0.004211858,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.004211858,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.004211858,
				"type": "OTHER"
			},
			{
				"name": "refugee program",
				"salience": 0.0036341806,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.003560177,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0031473301,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:35.405+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Donald Trump: Minnesota Has ‘Suffered Enough’ Accepting Refugees Tessa Berenson, TIME, November 6, 2016 \nIn a pitch to suspend the nation’s Syrian refugee program , Donald Trump said Minnesotans have “suffered enough” from accepting Somali immigrants into their state. \n“Here in Minnesota you have seen firsthand the problems caused with faulty refugee vetting, with large numbers of Somali refugees coming into your state, without your knowledge, without your support or approval,” Trump said at a Minneapolis rally Sunday afternoon. \nHe said his administration would suspend the Syrian refugee program and not resettle refugees anywhere in the United States without support from the communities, while Hillary Clinton’s “plan will import generations of terrorism, extremism and radicalism into your schools and throughout your communities.” \n{snip}",
		"thread_title": "Donald Trump: Minnesota Has ‘Suffered Enough’ Accepting Refugees",
		"title": "Donald Trump: Minnesota Has ‘Suffered Enough’ Accepting Refugees",
		"type": "bs",
		"uuid": "15dfc1b3b87b2b1060f92822c702ed52c69e4aaa"
	},
	"-KhIh-6f8zJhF8RHLR-I": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:36.825+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Little",
				"salience": 0.28708264,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.2552638,
				"type": "PERSON"
			},
			{
				"name": "Scholars",
				"salience": 0.055389624,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.05407118,
				"type": "OTHER"
			},
			{
				"name": "higher education",
				"salience": 0.040530052,
				"type": "OTHER"
			},
			{
				"name": "Cash",
				"salience": 0.026221586,
				"type": "OTHER"
			},
			{
				"name": "campaign contributions",
				"salience": 0.026221586,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bymv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_McCain"
				},
				"name": "John McCain",
				"salience": 0.020481685,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0548yy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Chronicle_of_Higher_Education"
				},
				"name": "Chronicle of Higher Education",
				"salience": 0.018728528,
				"type": "ORGANIZATION"
			},
			{
				"name": "Peter Olsen",
				"salience": 0.016242918,
				"type": "PERSON"
			},
			{
				"name": "Phillips",
				"salience": 0.016242918,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.011380194,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidates",
				"salience": 0.0108986655,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.010657893,
				"type": "PERSON"
			},
			{
				"name": "donations",
				"salience": 0.009505065,
				"type": "OTHER"
			},
			{
				"name": "committees",
				"salience": 0.009123636,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign money",
				"salience": 0.0081025595,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0064443145,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.0055830153,
				"type": "OTHER"
			},
			{
				"name": "rift",
				"salience": 0.0055830153,
				"type": "OTHER"
			},
			{
				"name": "chasm",
				"salience": 0.0055830153,
				"type": "OTHER"
			},
			{
				"name": "gap",
				"salience": 0.005443633,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.005399291,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.004888154,
				"type": "OTHER"
			},
			{
				"name": "donations",
				"salience": 0.004540604,
				"type": "OTHER"
			},
			{
				"name": "races",
				"salience": 0.0045232275,
				"type": "EVENT"
			},
			{
				"name": "professionals",
				"salience": 0.0045232275,
				"type": "PERSON"
			},
			{
				"name": "data",
				"salience": 0.0043547866,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0041968334,
				"type": "ORGANIZATION"
			},
			{
				"name": "nominees",
				"salience": 0.0037720664,
				"type": "PERSON"
			},
			{
				"name": "professionals",
				"salience": 0.0036942554,
				"type": "PERSON"
			},
			{
				"name": "fraction",
				"salience": 0.0036777863,
				"type": "OTHER"
			},
			{
				"name": "cycles",
				"salience": 0.0031997366,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0031594816,
				"type": "OTHER"
			},
			{
				"name": "campaign committee",
				"salience": 0.0030574827,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01jlfh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Election_Commission"
				},
				"name": "Federal Election Commission",
				"salience": 0.0029708138,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0029656626,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04qk7z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Center_for_Responsive_Politics"
				},
				"name": "Center for Responsive Politics",
				"salience": 0.0029576297,
				"type": "ORGANIZATION"
			},
			{
				"name": "faculty members",
				"salience": 0.0028366481,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0027866026,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0027609975,
				"type": "PERSON"
			},
			{
				"name": "donations",
				"salience": 0.0024111671,
				"type": "OTHER"
			},
			{
				"name": "PACs",
				"salience": 0.0023912103,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0023912103,
				"type": "OTHER"
			},
			{
				"name": "academe",
				"salience": 0.0023912103,
				"type": "OTHER"
			},
			{
				"name": "comparison",
				"salience": 0.0023912103,
				"type": "OTHER"
			},
			{
				"name": "ratio",
				"salience": 0.0020539768,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00201156,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0017420324,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0016645144,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.001472351,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.0014296712,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0013015324,
				"type": "PERSON"
			},
			{
				"name": "inflation",
				"salience": 0.0013015324,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:36.825+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Little-Loved by Scholars, Trump Also Gets Little of Their Cash Peter Olsen-Phillips, Chronicle of Higher Education, November 7, 2016 \nIt’s no secret that campaign contributions from higher education have favored Democratic candidates for years. When it comes to the current presidential race, however, data show that the gap between left and right has grown from a rift into a chasm. \nA Chronicle analysis of Federal Election Commission data provided by the Center for Responsive Politics shows Donald Trump raising a tiny fraction of the campaign money that the previous two Republican nominees, Mitt Romney and John McCain, drew from higher-education professionals over comparable time periods. \nAcross higher education, donations in congressional and Senate races showed a ratio of Democratic to Republican giving similar to that of the two previous presidential-campaign cycles. But support for Mr. Trump stood at less than 8 percent of what Senator McCain raised from higher-ed professionals, and around 4 percent of the donations that Mr. Romney pulled in over the same time period, once the figures were adjusted for inflation. \nAs of June 30, faculty members and others who work in higher education had donated $76,668 to Mr. Trump’s campaign committee and to support “super PACs”–independent committees that can raise and spend unlimited funds. By comparison, people working in academe had given $6.4 million to Hillary Clinton. Those figures account for donations of at least $200 that the Center for Responsive Politics has determined come from people associated with higher education. They are the most-recent figures available. \n{snip}",
		"thread_title": "Little-Loved by Scholars, Trump Also Gets Little of Their Cash",
		"title": "Little-Loved by Scholars, Trump Also Gets Little of Their Cash",
		"type": "bs",
		"uuid": "d5d33458a740acbbb59289c9fdb9d7b396686c37"
	},
	"-KhIh-GCPp0vBz-y3iYz": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:38.559+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.45368737,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05z_d0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Proposition_227_(1998)"
				},
				"name": "Proposition 227",
				"salience": 0.06686332,
				"type": "OTHER"
			},
			{
				"name": "swing state",
				"salience": 0.04863858,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.043143976,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.031485062,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06nm1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spanish_language"
				},
				"name": "Spanish",
				"salience": 0.029374313,
				"type": "LOCATION"
			},
			{
				"name": "California Set",
				"salience": 0.025064971,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.020347726,
				"type": "LOCATION"
			},
			{
				"name": "Let Public Schools Teach Primarily",
				"salience": 0.01951095,
				"type": "ORGANIZATION"
			},
			{
				"name": "Blake Neff",
				"salience": 0.01951095,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "Daily Caller",
				"salience": 0.01951095,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.016839512,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.01671475,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.013094174,
				"type": "LOCATION"
			},
			{
				"name": "stake",
				"salience": 0.013094174,
				"type": "OTHER"
			},
			{
				"name": "classes",
				"salience": 0.011025714,
				"type": "OTHER"
			},
			{
				"name": "voter referendum",
				"salience": 0.00973586,
				"type": "OTHER"
			},
			{
				"name": "schoolchildren",
				"salience": 0.009276398,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.009084533,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.008572958,
				"type": "EVENT"
			},
			{
				"name": "hundreds",
				"salience": 0.006709089,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.006270899,
				"type": "ORGANIZATION"
			},
			{
				"name": "programs",
				"salience": 0.0061789434,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0054357704,
				"type": "PERSON"
			},
			{
				"name": "proficiency",
				"salience": 0.0054357704,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.005320354,
				"type": "ORGANIZATION"
			},
			{
				"name": "LEP",
				"salience": 0.0049395957,
				"type": "ORGANIZATION"
			},
			{
				"name": "español",
				"salience": 0.0045331987,
				"type": "OTHER"
			},
			{
				"name": "thanks",
				"salience": 0.0045331987,
				"type": "OTHER"
			},
			{
				"name": "requirement",
				"salience": 0.0045331987,
				"type": "OTHER"
			},
			{
				"name": "classes",
				"salience": 0.0044397,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0044397,
				"type": "PERSON"
			},
			{
				"name": "proficiency",
				"salience": 0.0044397,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.0040967125,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Proposition 58",
				"salience": 0.0038642597,
				"type": "WORK_OF_ART"
			},
			{
				"name": "math scores",
				"salience": 0.0038454689,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.0035641894,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0034091545,
				"type": "PERSON"
			},
			{
				"name": "measure",
				"salience": 0.0033182453,
				"type": "OTHER"
			},
			{
				"name": "tongues",
				"salience": 0.0028738661,
				"type": "OTHER"
			},
			{
				"name": "immersion",
				"salience": 0.0028738661,
				"type": "OTHER"
			},
			{
				"name": "Proposition",
				"salience": 0.0027898015,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0024176207,
				"type": "OTHER"
			},
			{
				"name": "speakers",
				"salience": 0.0020937072,
				"type": "PERSON"
			},
			{
				"name": "environment",
				"salience": 0.0020937072,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.0020937072,
				"type": "EVENT"
			},
			{
				"name": "multilingualism",
				"salience": 0.0020937072,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.0020937072,
				"type": "OTHER"
			},
			{
				"name": "Polls",
				"salience": 0.0015643077,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0015643077,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0015643077,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:38.559+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "California Set to Let Public Schools Teach Primarily in Spanish Blake Neff, Daily Caller, November 6, 2016 \nCalifornia isn’t even close to a swing state in the 2016 presidential election, but that doesn’t mean nothing is at stake for voters in the nation’s largest state. \nAfter Tuesday’s vote, hundreds of thousands of California schoolchildren may start attending classes primarily en español, thanks to a voter referendum that would repeal the requirement that schools teach primarily in English. \nCalifornia’s Proposition 58 would repeal Proposition 227 , a measure that easily passed nearly two decades ago, in 1998. Proposition 227 required all public schools in the state teach “overwhelmingly” in English, with limited-English proficiency (LEP) students transitioning to fully English classes as quickly as possible. \n{snip} \nAcross the state, the English proficiency of LEP students tripled in just a few years , and math scores rose as well. \nBut now, with California’s immigrant population higher than ever, the state is poised to reverse course. \nPolls indicate the Proposition 58 is likely to pass. Ironically, supporters of the measure place an emphasis on English rather than foreign tongues. They argue that the bill will allow for “dual immersion” programs, where both native English and native Spanish speakers can learn in a bilingual environment. In the long run, they argue, this will increase multilingualism and provide the state with a competitive advantage. \n{snip}",
		"thread_title": "California Set to Let Public Schools Teach Primarily in Spanish",
		"title": "California Set to Let Public Schools Teach Primarily in Spanish",
		"type": "bs",
		"uuid": "9cef9c93c90a0399a048d76f27dafba3d33a7509"
	},
	"-KhIh-ZMRMYlNc0JohO1": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:41.889+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.58529234,
				"type": "LOCATION"
			},
			{
				"name": "Dianna Barindelli",
				"salience": 0.088968195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.018040491,
				"type": "LOCATION"
			},
			{
				"name": "time",
				"salience": 0.015758729,
				"type": "EVENT"
			},
			{
				"name": "stay-at-home mom",
				"salience": 0.014175867,
				"type": "PERSON"
			},
			{
				"name": "Surrogates",
				"salience": 0.012141207,
				"type": "OTHER"
			},
			{
				"name": "daughters",
				"salience": 0.010095817,
				"type": "PERSON"
			},
			{
				"name": "baby",
				"salience": 0.00885848,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.00846246,
				"type": "OTHER"
			},
			{
				"name": "Families",
				"salience": 0.007197454,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0071555786,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h_9v3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WeChat"
				},
				"name": "WeChat",
				"salience": 0.0069300546,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "surrogates",
				"salience": 0.0062233773,
				"type": "OTHER"
			},
			{
				"name": "Demand",
				"salience": 0.0060079913,
				"type": "OTHER"
			},
			{
				"name": "Center for Surrogate Parenting",
				"salience": 0.005083903,
				"type": "ORGANIZATION"
			},
			{
				"name": "clients",
				"salience": 0.0050636237,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.004817705,
				"type": "LOCATION"
			},
			{
				"name": "agencies",
				"salience": 0.0045356527,
				"type": "ORGANIZATION"
			},
			{
				"name": "surrogacy agencies",
				"salience": 0.0045356527,
				"type": "ORGANIZATION"
			},
			{
				"name": "couple",
				"salience": 0.004350353,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.0034832996,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0034030913,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0034030913,
				"type": "OTHER"
			},
			{
				"name": "GloZell Green",
				"salience": 0.0033952892,
				"type": "PERSON"
			},
			{
				"name": "IPs",
				"salience": 0.0032586812,
				"type": "OTHER"
			},
			{
				"name": "Kalee Thompson",
				"salience": 0.0032073832,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03cg25",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hollywood_Reporter"
				},
				"name": "Hollywood Reporter",
				"salience": 0.0032073832,
				"type": "ORGANIZATION"
			},
			{
				"name": "People",
				"salience": 0.0027172652,
				"type": "PERSON"
			},
			{
				"name": "couples",
				"salience": 0.0026913062,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0026617097,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0026617097,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.0025371818,
				"type": "LOCATION"
			},
			{
				"name": "travels",
				"salience": 0.0023596054,
				"type": "OTHER"
			},
			{
				"name": "dads",
				"salience": 0.0022430297,
				"type": "PERSON"
			},
			{
				"name": "embryo transfer",
				"salience": 0.002128574,
				"type": "EVENT"
			},
			{
				"name": "baby boy",
				"salience": 0.0020526897,
				"type": "PERSON"
			},
			{
				"name": "Todd Holland",
				"salience": 0.0018092236,
				"type": "PERSON"
			},
			{
				"name": "surrogacy",
				"salience": 0.0018004931,
				"type": "OTHER"
			},
			{
				"name": "surrogate",
				"salience": 0.0018004931,
				"type": "OTHER"
			},
			{
				"name": "IPs",
				"salience": 0.0017930976,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.0017930976,
				"type": "PERSON"
			},
			{
				"name": "surrogacy",
				"salience": 0.0017333333,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0281y0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Encino,_Los_Angeles"
				},
				"name": "Encino",
				"salience": 0.0016390802,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0r7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Modesto,_California"
				},
				"name": "Modesto",
				"salience": 0.0016390802,
				"type": "LOCATION"
			},
			{
				"name": "birth",
				"salience": 0.0015176671,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0015176671,
				"type": "PERSON"
			},
			{
				"name": "mom",
				"salience": 0.0014750375,
				"type": "PERSON"
			},
			{
				"name": "surrogates",
				"salience": 0.0014700536,
				"type": "OTHER"
			},
			{
				"name": "Barindelli",
				"salience": 0.0014224745,
				"type": "OTHER"
			},
			{
				"name": "couples",
				"salience": 0.0014093929,
				"type": "PERSON"
			},
			{
				"name": "ultrasound pictures",
				"salience": 0.0014021214,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pictures",
				"salience": 0.0014021214,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mom",
				"salience": 0.0014021214,
				"type": "PERSON"
			},
			{
				"name": "parent applications",
				"salience": 0.0013948872,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.001334149,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0013318758,
				"type": "OTHER"
			},
			{
				"name": "baby",
				"salience": 0.0013111249,
				"type": "PERSON"
			},
			{
				"name": "baby",
				"salience": 0.001262203,
				"type": "PERSON"
			},
			{
				"name": "IPs",
				"salience": 0.0012574453,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.0012105247,
				"type": "PERSON"
			},
			{
				"name": "couple",
				"salience": 0.0012105247,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0012034375,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0011992395,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0011992395,
				"type": "OTHER"
			},
			{
				"name": "surrogacy services",
				"salience": 0.0011741301,
				"type": "OTHER"
			},
			{
				"name": "enclaves",
				"salience": 0.0011657132,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.0011657132,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.0011353857,
				"type": "PERSON"
			},
			{
				"name": "surrogate",
				"salience": 0.0010982933,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0010963309,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0010963309,
				"type": "LOCATION"
			},
			{
				"name": "surrogacy fees",
				"salience": 0.0010963309,
				"type": "OTHER"
			},
			{
				"name": "updates",
				"salience": 0.0010963309,
				"type": "OTHER"
			},
			{
				"name": "wedding photos",
				"salience": 0.0010963309,
				"type": "WORK_OF_ART"
			},
			{
				"name": "boutique agency",
				"salience": 0.0010704313,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rival agency",
				"salience": 0.0010704313,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.0010704313,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.0010704313,
				"type": "ORGANIZATION"
			},
			{
				"name": "birth",
				"salience": 0.0010642337,
				"type": "EVENT"
			},
			{
				"name": "translation",
				"salience": 0.001060152,
				"type": "OTHER"
			},
			{
				"name": "IPs",
				"salience": 0.0010265991,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.0010245176,
				"type": "EVENT"
			},
			{
				"name": "college fund",
				"salience": 0.0010032305,
				"type": "OTHER"
			},
			{
				"name": "infertility",
				"salience": 0.0009905916,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0009905916,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0009831861,
				"type": "LOCATION"
			},
			{
				"name": "surrogacy services",
				"salience": 0.0009831861,
				"type": "OTHER"
			},
			{
				"name": "marketing",
				"salience": 0.0009717779,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00094649254,
				"type": "LOCATION"
			},
			{
				"name": "child",
				"salience": 0.00094649254,
				"type": "PERSON"
			},
			{
				"name": "demand",
				"salience": 0.0009458316,
				"type": "OTHER"
			},
			{
				"name": "foreigners",
				"salience": 0.0009458316,
				"type": "PERSON"
			},
			{
				"name": "baby",
				"salience": 0.00091936084,
				"type": "PERSON"
			},
			{
				"name": "Expect Miracles Surrogacy",
				"salience": 0.0009049721,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-American",
				"salience": 0.00090256426,
				"type": "PERSON"
			},
			{
				"name": "clients",
				"salience": 0.00090252154,
				"type": "PERSON"
			},
			{
				"name": "state laws",
				"salience": 0.0008877323,
				"type": "OTHER"
			},
			{
				"name": "enclaves",
				"salience": 0.0008877323,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0008877323,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0008545991,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.0008545991,
				"type": "LOCATION"
			},
			{
				"name": "embryos",
				"salience": 0.0008545991,
				"type": "OTHER"
			},
			{
				"name": "baby",
				"salience": 0.00079967524,
				"type": "PERSON"
			},
			{
				"name": "nationality",
				"salience": 0.00077852263,
				"type": "OTHER"
			},
			{
				"name": "surrogate",
				"salience": 0.0007700895,
				"type": "OTHER"
			},
			{
				"name": "physicians",
				"salience": 0.00076871325,
				"type": "PERSON"
			},
			{
				"name": "location",
				"salience": 0.00076871325,
				"type": "LOCATION"
			},
			{
				"name": "court documents",
				"salience": 0.00076871325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one-child policy",
				"salience": 0.00076871325,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.00076871325,
				"type": "PERSON"
			},
			{
				"name": "bill",
				"salience": 0.00076871325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "People",
				"salience": 0.00076041167,
				"type": "PERSON"
			},
			{
				"name": "Molly O'Brien",
				"salience": 0.000741615,
				"type": "PERSON"
			},
			{
				"name": "options",
				"salience": 0.00074001995,
				"type": "OTHER"
			},
			{
				"name": "gay",
				"salience": 0.00074001995,
				"type": "OTHER"
			},
			{
				"name": "singles",
				"salience": 0.00074001995,
				"type": "WORK_OF_ART"
			},
			{
				"name": "parts",
				"salience": 0.00074001995,
				"type": "LOCATION"
			},
			{
				"name": "son",
				"salience": 0.00074001995,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gx1l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_California"
				},
				"name": "Southern California",
				"salience": 0.0007382045,
				"type": "LOCATION"
			},
			{
				"name": "foreigners",
				"salience": 0.0007247253,
				"type": "PERSON"
			},
			{
				"name": "mix",
				"salience": 0.000685805,
				"type": "OTHER"
			},
			{
				"name": "Surrogate selection",
				"salience": 0.0006518857,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0006490493,
				"type": "PERSON"
			},
			{
				"name": "movie stars",
				"salience": 0.0006342766,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.00063279475,
				"type": "PERSON"
			},
			{
				"name": "doctors",
				"salience": 0.000630367,
				"type": "PERSON"
			},
			{
				"name": "birth tourism",
				"salience": 0.0006275513,
				"type": "OTHER"
			},
			{
				"name": "permutation",
				"salience": 0.0006275513,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.0006275513,
				"type": "OTHER"
			},
			{
				"name": "overseas",
				"salience": 0.0006275513,
				"type": "LOCATION"
			},
			{
				"name": "parents",
				"salience": 0.00062565325,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.00061183487,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.0005996073,
				"type": "OTHER"
			},
			{
				"name": "blond surrogates",
				"salience": 0.00059758004,
				"type": "OTHER"
			},
			{
				"name": "surrogacy",
				"salience": 0.00059758004,
				"type": "OTHER"
			},
			{
				"name": "surrogate",
				"salience": 0.00059758004,
				"type": "OTHER"
			},
			{
				"name": "surrogate",
				"salience": 0.00059758004,
				"type": "OTHER"
			},
			{
				"name": "surrogates",
				"salience": 0.00059758004,
				"type": "OTHER"
			},
			{
				"name": "assisted-reproduction agencies",
				"salience": 0.00058241526,
				"type": "ORGANIZATION"
			},
			{
				"name": "clients",
				"salience": 0.0005574258,
				"type": "PERSON"
			},
			{
				"name": "places",
				"salience": 0.0005413798,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0005326917,
				"type": "OTHER"
			},
			{
				"name": "IPs",
				"salience": 0.0005176331,
				"type": "ORGANIZATION"
			},
			{
				"name": "TV",
				"salience": 0.0005123023,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.0005084711,
				"type": "PERSON"
			},
			{
				"name": "blonde",
				"salience": 0.0004994712,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.00048696136,
				"type": "OTHER"
			},
			{
				"name": "cable packages",
				"salience": 0.00046878145,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00046878145,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00046878145,
				"type": "OTHER"
			},
			{
				"name": "culture shock",
				"salience": 0.00046878145,
				"type": "OTHER"
			},
			{
				"name": "shop",
				"salience": 0.00046878145,
				"type": "LOCATION"
			},
			{
				"name": "speakers",
				"salience": 0.00046878145,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.00046878145,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.00046878145,
				"type": "ORGANIZATION"
			},
			{
				"name": "hotel",
				"salience": 0.00046878145,
				"type": "LOCATION"
			},
			{
				"name": "couples",
				"salience": 0.0004676902,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.0004554715,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07f1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thailand"
				},
				"name": "Thailand",
				"salience": 0.0004554715,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06f32",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taiwan"
				},
				"name": "Taiwanese",
				"salience": 0.0004554715,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016zwt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nepal"
				},
				"name": "Nepal",
				"salience": 0.0004554715,
				"type": "LOCATION"
			},
			{
				"name": "surrogate",
				"salience": 0.0004463906,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ctzb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_people"
				},
				"name": "Caucasian",
				"salience": 0.00044605607,
				"type": "PERSON"
			},
			{
				"name": "Gifted Journeys",
				"salience": 0.00044605607,
				"type": "OTHER"
			},
			{
				"name": "Growing Generations",
				"salience": 0.0004387832,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.00043668642,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.00043668642,
				"type": "PERSON"
			},
			{
				"name": "government services",
				"salience": 0.00043668642,
				"type": "OTHER"
			},
			{
				"name": "baby",
				"salience": 0.00043506137,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.00041953544,
				"type": "LOCATION"
			},
			{
				"name": "IPs",
				"salience": 0.00041723892,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0003979147,
				"type": "OTHER"
			},
			{
				"name": "offices",
				"salience": 0.00039427576,
				"type": "LOCATION"
			},
			{
				"name": "doctors offices",
				"salience": 0.00039427576,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.00039427576,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.00039427576,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latina",
				"salience": 0.0003862371,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/071vr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Diego"
				},
				"name": "San Diego",
				"salience": 0.0003862371,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0mzww",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pasadena,_California"
				},
				"name": "Pasadena",
				"salience": 0.0003862371,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0m66w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sarah_Jessica_Parker"
				},
				"name": "Sarah Jessica Parker",
				"salience": 0.0003862371,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d68qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/30_Rock"
				},
				"name": "30 Rock",
				"salience": 0.0003862371,
				"type": "WORK_OF_ART"
			},
			{
				"name": "allure",
				"salience": 0.0003778595,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.0003564809,
				"type": "WORK_OF_ART"
			},
			{
				"name": "families",
				"salience": 0.00035309696,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.00035309696,
				"type": "PERSON"
			},
			{
				"name": "passport",
				"salience": 0.00034139925,
				"type": "OTHER"
			},
			{
				"name": "babies",
				"salience": 0.00034139925,
				"type": "PERSON"
			},
			{
				"name": "information sessions",
				"salience": 0.00034139925,
				"type": "EVENT"
			},
			{
				"name": "Expect Miracles' Anderson",
				"salience": 0.0003331938,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0002945124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.00028850738,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d7k1z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Irvine,_California"
				},
				"name": "Irvine",
				"salience": 0.00028850738,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Culver_City,_California"
				},
				"name": "Culver City",
				"salience": 0.00028850738,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05mph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma"
				},
				"name": "Oklahoma",
				"salience": 0.00028850738,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0488g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas"
				},
				"name": "Kansas",
				"salience": 0.00028850738,
				"type": "LOCATION"
			},
			{
				"name": "fantasy",
				"salience": 0.0002786916,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.00025501286,
				"type": "PERSON"
			},
			{
				"name": "associates",
				"salience": 0.00025501286,
				"type": "PERSON"
			},
			{
				"name": "concept",
				"salience": 0.00025501286,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.00025501286,
				"type": "PERSON"
			},
			{
				"name": "baby girl",
				"salience": 0.00021998827,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0r111",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Torrance,_California"
				},
				"name": "Torrance",
				"salience": 0.00021010402,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00021010402,
				"type": "LOCATION"
			},
			{
				"name": "Synesiou",
				"salience": 0.00018274027,
				"type": "PERSON"
			},
			{
				"name": "Gifted Journey",
				"salience": 0.00018124665,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian",
				"salience": 0.00015693647,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s9b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ingmar_Bergman"
				},
				"name": "Bergman",
				"salience": 0.00015693647,
				"type": "PERSON"
			},
			{
				"name": "Wilson-Miller",
				"salience": 0.00013649657,
				"type": "PERSON"
			},
			{
				"name": "agency heads",
				"salience": 0.00006479716,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:41.889+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Why American Surrogates Are in Demand for Chinese Families Kalee Thompson, Hollywood Reporter, November 4, 2016 \nThe first time Dianna Barindelli carried a baby that wasn’t her own was in 2012. “We were done having kids, but I still wanted to be pregnant,” says the Modesto, Calif., stay-at-home mom, whose own daughters are 6 and 9. Barindelli signed up with the Center for Surrogate Parenting in Encino, one of the most exclusive surrogacy agencies in the world. In 2014, she matched with a Chinese couple. Unlike many agencies, CSP first shows parent applications to the surrogates, rather than the other way around. “It’s little things that you’ll connect with people over,” says Barindelli, who was attracted to pictures of the couple’s extended travels and their traditional wedding photos. \nThe embryo transfer took place in late 2014. Barindelli emailed the mom weekly, sending updates and ultrasound pictures with WeChat, an app that offers instantaneous translation. The intended parents (IPs) planned to be there for the birth, but the baby boy arrived two weeks early, 24 hours before they arrived. Says Barindelli: “I texted and made sure [the mom] was OK with him staying in my room. I cleared everything with her. I didn’t want her to feel bad that she wasn’t there.” \nBarindelli, who used her surrogacy fees to set up a college fund for her girls, is pregnant again, this time with the baby, due Feb. 1, of a Taiwanese couple. She may not be done: Her first Chinese couple emailed her recently, soon after their son’s first birthday. They still have frozen embryos and hope that Barindelli, now 40, will carry their second child. \nCommercial surrogacy is banned in most parts of the world, as well as in many U.S. states. Until recently, infertile couples, singles and gay would-be dads had a handful of options to turn to when it came to finding a surrogate, among them India, Thailand, Nepal and Mexico, where surrogacy services have cost a quarter of the $100,000 to $200,000 bill typical in the U.S. But in the past few years, those countries have started enforcing laws banning international surrogacy. Meanwhile, China–the world’s most populous country, with a growing wealthy elite and where some doctors believe infertility is more common than in the U.S.–lifted its decades-long one-child policy. The result is a soaring Chinese demand for U.S. surrogacy services, one that is flourishing particularly in California, with its culturally friendly enclaves, excellent physicians and favorable state laws that regard IPs as a baby’s legal parents even before birth, if proper court documents are filed. {snip} \n{snip} Despite CSP’s Southern California location, 51 percent of its clients now are foreigners, up from 15 percent a decade ago. Rival agency Growing Generations (clients have included Sarah Jessica Parker and 30 Rock director Todd Holland) also sees half of its clients coming from overseas, as does Gifted Journeys, a boutique agency in Pasadena. At San Diego’s Expect Miracles Surrogacy, international clients account for 80 percent of IPs. And of foreigners participating in this permutation of California’s birth tourism, the number of Chinese IPs is growing the fastest, making up the most common single foreign nationality for many agencies right now. \n{snip} \nMost local agencies have a mix of Caucasian, Latina and African-American surrogates. “I can’t think of a time when we’ve had an Asian surrogate,” says Growing Generations’ Bergman. Multiple agency heads say Chinese IPs tend to strongly prefer a Caucasian surrogate. “People really have this fantasy because of a lot of the marketing that was done in China,” says Gifted Journey’s Wilson-Miller. “They have this picture of blond surrogates who look like movie stars carrying the baby with their traditional families.” {snip} \nThe concept of cross-race surrogacy can confound friends, family and associates of surrogates and IPs alike. In August, comedian GloZell Green, who is African-American, and her husband, also African-American, had a baby girl via a surrogate. “Our surrogate is a blue-eyed blonde,” the YouTube star told potential IPs gathered in a Culver City hotel in early October. People in her life “kept asking if the baby was going to be white.” \nSurrogate selection aside, California has the added allure of numerous enclaves where families can be surrounded by Chinese speakers and businesses. “People from China can stay in Irvine, for example, and they have Chinese TV on their cable packages. Throughout California there are places they can go and shop and find stuff in Chinese. If they go to Kansas or Oklahoma? It’s total culture shock,” says Expect Miracles’ Anderson. {snip} \nOf course, any baby born via surrogate in the U.S. has birthright citizenship. “The Chinese couples really like that because a lot of them want to come back and forth,” says Molly O’Brien, a fertility lawyer with offices in Torrance who frequently travels to China to participate in information sessions for would-be parents, often sponsored by doctors offices or assisted-reproduction agencies. “Maybe they eventually want that child to be able to go to college here.” Unlike the U.S., China forbids dual citizenship, and most American-born Chinese babies remain U.S. citizens. “Most Chinese couples just keep that American passport. It’s only if you want to use the government services that you’ve got to be Chinese,” says CSP’s Synesiou. \n{snip}",
		"thread_title": "Why American Surrogates Are in Demand for Chinese Families",
		"title": "Why American Surrogates Are in Demand for Chinese Families",
		"type": "bs",
		"uuid": "6b3ae456757202373f011937063b153941cdc299"
	},
	"-KhIh-m7qy0_nQZWLCZ6": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:45.665+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Michael Beal",
				"salience": 0.13997917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09v84mk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cook_County_State's_Attorney"
				},
				"name": "Cook County State's Attorney",
				"salience": 0.07320604,
				"type": "PERSON"
			},
			{
				"name": "Joshua Beal",
				"salience": 0.066165805,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.051603973,
				"type": "LOCATION"
			},
			{
				"name": "Shooting",
				"salience": 0.03679117,
				"type": "EVENT"
			},
			{
				"name": "police shooting",
				"salience": 0.03679117,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.031918213,
				"type": "PERSON"
			},
			{
				"name": "Video",
				"salience": 0.0315906,
				"type": "WORK_OF_ART"
			},
			{
				"name": "shooting",
				"salience": 0.030556012,
				"type": "EVENT"
			},
			{
				"name": "Protesters",
				"salience": 0.028852873,
				"type": "PERSON"
			},
			{
				"name": "Protesters Clash After Mount Greenwood Police",
				"salience": 0.028176473,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.02502078,
				"type": "LOCATION"
			},
			{
				"name": "site",
				"salience": 0.02502078,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04st2_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mount_Greenwood,_Chicago"
				},
				"name": "Mount Greenwood",
				"salience": 0.024122206,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.019880788,
				"type": "PERSON"
			},
			{
				"name": "Will Jones",
				"salience": 0.015455716,
				"type": "PERSON"
			},
			{
				"name": "Laura Podesta",
				"salience": 0.015455716,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03j9ft",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WLS-TV"
				},
				"name": "ABC 7",
				"salience": 0.015455716,
				"type": "ORGANIZATION"
			},
			{
				"name": "Investigators",
				"salience": 0.011170344,
				"type": "PERSON"
			},
			{
				"name": "police sergeant",
				"salience": 0.010899524,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.009357168,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.008879856,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.008655473,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.008655473,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.008341671,
				"type": "PERSON"
			},
			{
				"name": "funeral services",
				"salience": 0.0081440825,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ftxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indianapolis"
				},
				"name": "Indianapolis",
				"salience": 0.007913501,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.006799306,
				"type": "PERSON"
			},
			{
				"name": "arrest",
				"salience": 0.005501638,
				"type": "EVENT"
			},
			{
				"name": "firefighter",
				"salience": 0.005485028,
				"type": "PERSON"
			},
			{
				"name": "vehicle",
				"salience": 0.005485028,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "police narrative",
				"salience": 0.0052966075,
				"type": "WORK_OF_ART"
			},
			{
				"name": "battery",
				"salience": 0.0052966075,
				"type": "OTHER"
			},
			{
				"name": "family members",
				"salience": 0.0052534,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.005217819,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.00514174,
				"type": "OTHER"
			},
			{
				"name": "Ja'Mal Green",
				"salience": 0.0049607498,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0048310063,
				"type": "PERSON"
			},
			{
				"name": "clash",
				"salience": 0.004726148,
				"type": "EVENT"
			},
			{
				"name": "firearm",
				"salience": 0.0044791377,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "firefighter",
				"salience": 0.0044791377,
				"type": "PERSON"
			},
			{
				"name": "vehicle",
				"salience": 0.0044791377,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "side",
				"salience": 0.004289916,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0041299686,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0041299686,
				"type": "OTHER"
			},
			{
				"name": "cemetery",
				"salience": 0.0037153028,
				"type": "LOCATION"
			},
			{
				"name": "traffic",
				"salience": 0.0037153028,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0037153028,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0037153028,
				"type": "LOCATION"
			},
			{
				"name": "court",
				"salience": 0.0035767495,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.0035767495,
				"type": "ORGANIZATION"
			},
			{
				"name": "residents",
				"salience": 0.0035767495,
				"type": "PERSON"
			},
			{
				"name": "chants",
				"salience": 0.0035767495,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.0034000047,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jt5l1z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago_Fire_(TV_series)"
				},
				"name": "Chicago fire",
				"salience": 0.0033781095,
				"type": "ORGANIZATION"
			},
			{
				"name": "family members",
				"salience": 0.0033504248,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.003137408,
				"type": "OTHER"
			},
			{
				"name": "altercation",
				"salience": 0.0030722541,
				"type": "EVENT"
			},
			{
				"name": "hands",
				"salience": 0.0030335695,
				"type": "OTHER"
			},
			{
				"name": "fire lane",
				"salience": 0.0030335695,
				"type": "LOCATION"
			},
			{
				"name": "business",
				"salience": 0.0030335695,
				"type": "OTHER"
			},
			{
				"name": "occupants",
				"salience": 0.0030335695,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.0029204104,
				"type": "OTHER"
			},
			{
				"name": "West 111th Street",
				"salience": 0.0026415852,
				"type": "LOCATION"
			},
			{
				"name": "South Troy Street",
				"salience": 0.0026415852,
				"type": "LOCATION"
			},
			{
				"name": "gun",
				"salience": 0.0026056098,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Black Lives Matters",
				"salience": 0.0025430333,
				"type": "OTHER"
			},
			{
				"name": "Blue Lives Matters",
				"salience": 0.0025430333,
				"type": "OTHER"
			},
			{
				"name": "driver",
				"salience": 0.0025083988,
				"type": "PERSON"
			},
			{
				"name": "shooting",
				"salience": 0.00243822,
				"type": "EVENT"
			},
			{
				"name": "assumptions",
				"salience": 0.0023391228,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/038fg2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago_Police_Department"
				},
				"name": "CPD",
				"salience": 0.002287558,
				"type": "ORGANIZATION"
			},
			{
				"name": "video",
				"salience": 0.0022854481,
				"type": "WORK_OF_ART"
			},
			{
				"name": "snip",
				"salience": 0.0022854481,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.0022665192,
				"type": "EVENT"
			},
			{
				"name": "gunfire",
				"salience": 0.0022665192,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "KKK",
				"salience": 0.0022022026,
				"type": "ORGANIZATION"
			},
			{
				"name": "everybody",
				"salience": 0.0021819482,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0021383604,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.0020174424,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0019648597,
				"type": "PERSON"
			},
			{
				"name": "gunshots",
				"salience": 0.0019064639,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.0019064639,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.0018619064,
				"type": "PERSON"
			},
			{
				"name": "vehicles",
				"salience": 0.0018215977,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vehicles",
				"salience": 0.0018215977,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vehicle",
				"salience": 0.0018215977,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.001766825,
				"type": "OTHER"
			},
			{
				"name": "snip",
				"salience": 0.0017074356,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0017074356,
				"type": "PERSON"
			},
			{
				"name": "weapon permit",
				"salience": 0.0016932907,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0016508937,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.0016508937,
				"type": "WORK_OF_ART"
			},
			{
				"name": "moments",
				"salience": 0.0016508937,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0014242461,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.0014242461,
				"type": "OTHER"
			},
			{
				"name": "funeral procession",
				"salience": 0.0012332879,
				"type": "EVENT"
			},
			{
				"name": "shots",
				"salience": 0.0012332879,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.0009570069,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:45.665+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Protesters Clash After Mount Greenwood Police-Involved Shooting Laura Podesta and Will Jones, ABC 7 (Chicago), November 7, 2016 \nProtesters clashed Sunday afternoon near the site of a deadly police shooting of a 25-year-old man in Chicago’s Mount Greenwood neighborhood. \nInvestigators said Joshua Beal, of Indianapolis, was armed when a confrontation between him and officers resulted in him being fatally shot. However, family members dispute the police narrative. \nMichael Beal, Joshua Beal’s brother, was charged with aggravated battery to a police officer, resisting arrest and attempting to disarm a police officer, a Cook County State’s Attorney spokesperson said Monday. He is scheduled to appear in court at 1:30 p.m. Tuesday. \nOn Sunday, Mount Greenwood residents squared off against activists demonstrating against the shooting. The clash between Black Lives Matters and Blue Lives Matters groups became tense at times as they exchanged chants such as “KKK” on one side and “CPD” on the other side. \n{snip} \nAccording to police, the shooting occurred after a vehicle leaving funeral services at a nearby cemetery stopped in traffic in front of a Chicago fire house near West 111th Street and South Troy Street. An off-duty firefighter told the driver that they were illegally blocking the fire lane. The occupants exited the vehicle and a verbal/physical altercation ensured, police said. An off-duty Chicago police officer was inside a nearby business and assisted the firefighter. \nA Chicago police sergeant driving to work stopped when he observed a man with a firearm in his hands. After the man “failed to drop his weapon, shots were fired striking the individual multiple times,” police said. \n{snip} \nAccording to family, an off-duty officer in an unmarked vehicle cut off one of the vehicles in the funeral procession. The family members and officer got out of their vehicles. After a verbal exchange, gunfire erupted but Beal’s family said that he did not provoke the officer, and merely disclosing that he had a concealed weapon permit. \n{snip} \nVideo circulated online on Sunday that claimed to show Beal holding a gun. \n“The problem is everybody is making their assumptions based on the little stuff they see, the picture, the video. No one knows what happened,” activist Ja’Mal Green said. \nThe video appears to capture the tense moments before the shooting, showing at least two people with their guns out. In another video, gunshots can be heard. \n{snip}",
		"thread_title": "Protesters Clash After Mount Greenwood Police-Involved Shooting",
		"title": "Protesters Clash After Mount Greenwood Police-Involved Shooting",
		"type": "bs",
		"uuid": "554a6304ca400d23c88c28156a235462c3b77a63"
	},
	"-KhIh-uHN1cQishj2p19": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:46.264+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "Lee Harris",
				"salience": 0.47929618,
				"type": "PERSON"
			},
			{
				"name": "victim",
				"salience": 0.078988336,
				"type": "PERSON"
			},
			{
				"name": "Sonya Toler",
				"salience": 0.07721267,
				"type": "PERSON"
			},
			{
				"name": "complaint",
				"salience": 0.048025347,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.03631357,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.026578741,
				"type": "PERSON"
			},
			{
				"name": "Kelly Brennan",
				"salience": 0.02250787,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04k_st",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WTAE-TV"
				},
				"name": "WTAE",
				"salience": 0.02250787,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/068p2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pittsburgh"
				},
				"name": "Pittsburgh",
				"salience": 0.02250787,
				"type": "LOCATION"
			},
			{
				"name": "apartment",
				"salience": 0.015107172,
				"type": "LOCATION"
			},
			{
				"name": "block",
				"salience": 0.015107172,
				"type": "LOCATION"
			},
			{
				"name": "snip",
				"salience": 0.0114151435,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.011073624,
				"type": "PERSON"
			},
			{
				"name": "knife",
				"salience": 0.011002271,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Gertrude Street",
				"salience": 0.010760857,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/035mt1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hazelwood_(Pittsburgh)"
				},
				"name": "Hazelwood",
				"salience": 0.009324299,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.008351023,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.006038757,
				"type": "LOCATION"
			},
			{
				"name": "sexual assault",
				"salience": 0.006038757,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.005936296,
				"type": "OTHER"
			},
			{
				"name": "victim",
				"salience": 0.005672624,
				"type": "PERSON"
			},
			{
				"name": "neighborhood",
				"salience": 0.005433247,
				"type": "LOCATION"
			},
			{
				"name": "knife-point",
				"salience": 0.005230886,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0051230057,
				"type": "LOCATION"
			},
			{
				"name": "intersection",
				"salience": 0.0051001725,
				"type": "LOCATION"
			},
			{
				"name": "police state",
				"salience": 0.004437364,
				"type": "ORGANIZATION"
			},
			{
				"name": "pocket",
				"salience": 0.004437364,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.004079261,
				"type": "PERSON"
			},
			{
				"name": "floor",
				"salience": 0.0038844277,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.0038317896,
				"type": "PERSON"
			},
			{
				"name": "snip",
				"salience": 0.0035672747,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.003316269,
				"type": "LOCATION"
			},
			{
				"name": "sexual assault",
				"salience": 0.0027898117,
				"type": "OTHER"
			},
			{
				"name": "Jumonville",
				"salience": 0.0027329968,
				"type": "LOCATION"
			},
			{
				"name": "Watson",
				"salience": 0.0027329968,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.0024160456,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charges",
				"salience": 0.0024160456,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.0024160456,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.002084521,
				"type": "LOCATION"
			},
			{
				"name": "neck",
				"salience": 0.0018051589,
				"type": "OTHER"
			},
			{
				"name": "Jane Doe",
				"salience": 0.0013785122,
				"type": "PERSON"
			},
			{
				"name": "rape",
				"salience": 0.0010203472,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:46.264+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "Kelly Brennan, WTAE (Pittsburgh), November 5, 2016 \n{snip} \nPublic safety spokeswoman Sonya Toler said officers determined 47-year-old Lee Harris was inside an apartment in the 5200 block of Gertrude Street in Hazelwood early Saturday morning. \n{snip} \nAccording to the criminal complaint, Harris ordered a woman at knife-point into an abandoned building in September. \nThe victim, who is not being identified since she is a victim of sexual assault, told police she knew Harris from seeing him in the neighborhood before but she never knew his name and didn’t have a relationship with him. \n{snip} \nIn the criminal complaint, police state the victim and Harris approached the intersection of Watson and Jumonville streets, and Harris “pulled out a knife from his pocket, put it to her neck and ordered Jane Doe to walk to an abandoned building.” \n{snip} \nOnce inside, “she was forced to go to the second floor where Harris pushed her into a small room.” It’s there he allegedly assaulted, raped and threatened the woman. \nWhen she asked why he was doing it, he told her “because you’re white.” \nHarris was arrested on a series of charges including rape, sexual assault and ethnic intimidation. \n{snip}",
		"thread_title": "Alleged Rape Suspect Arrested; Woman Says He Raped Her ‘Because She’s White’",
		"title": "Alleged Rape Suspect Arrested; Woman Says He Raped Her ‘Because She’s White’",
		"type": "bs",
		"uuid": "9b55e810cbe29bc791660dafc63bba768e1de561"
	},
	"-KhIh01L54iBy_Le9RaF": {
		"author": "Henry Wolff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T05:20:47.227+02:00",
		"domain_rank": "94243",
		"entities": [
			{
				"name": "migrants",
				"salience": 0.5131684,
				"type": "PERSON"
			},
			{
				"name": "Migrants",
				"salience": 0.088942796,
				"type": "PERSON"
			},
			{
				"name": "coast",
				"salience": 0.0376857,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.034943268,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.031271774,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07nz5q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian_ministry"
				},
				"name": "Ministry",
				"salience": 0.029822625,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01zqgj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Interior_ministry"
				},
				"name": "Interior Ministry",
				"salience": 0.029822625,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.026642125,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.020315288,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04swx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mediterranean_Sea"
				},
				"name": "Mediterranean",
				"salience": 0.018858172,
				"type": "LOCATION"
			},
			{
				"name": "sea",
				"salience": 0.01573552,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.0136437,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.010148233,
				"type": "OTHER"
			},
			{
				"name": "shift",
				"salience": 0.0086698495,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0g2558",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Welt_am_Sonntag"
				},
				"name": "Welt am Sonntag",
				"salience": 0.008424979,
				"type": "ORGANIZATION"
			},
			{
				"name": "ministry",
				"salience": 0.0060697044,
				"type": "ORGANIZATION"
			},
			{
				"name": "coast",
				"salience": 0.005668718,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.005668718,
				"type": "LOCATION"
			},
			{
				"name": "sea",
				"salience": 0.005668718,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.005457778,
				"type": "LOCATION"
			},
			{
				"name": "prospect",
				"salience": 0.0049107643,
				"type": "OTHER"
			},
			{
				"name": "elimination",
				"salience": 0.0049107643,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.0049107643,
				"type": "LOCATION"
			},
			{
				"name": "processing",
				"salience": 0.0049107643,
				"type": "EVENT"
			},
			{
				"name": "asylum policies",
				"salience": 0.004727941,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.004727941,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0046685203,
				"type": "OTHER"
			},
			{
				"name": "journey",
				"salience": 0.004630474,
				"type": "EVENT"
			},
			{
				"name": "paper",
				"salience": 0.004010974,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ministry spokeswoman",
				"salience": 0.004010974,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.004010974,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0029978782,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australian",
				"salience": 0.0029128972,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.0029128972,
				"type": "ORGANIZATION"
			},
			{
				"name": "asylum",
				"salience": 0.002792945,
				"type": "OTHER"
			},
			{
				"name": "ministry",
				"salience": 0.0024099005,
				"type": "ORGANIZATION"
			},
			{
				"name": "snip",
				"salience": 0.0021842439,
				"type": "OTHER"
			},
			{
				"name": "asylum applications",
				"salience": 0.0021842439,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0021842439,
				"type": "LOCATION"
			},
			{
				"name": "journey",
				"salience": 0.0018845773,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0018461903,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07fj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tunisia"
				},
				"name": "Tunisia",
				"salience": 0.0018461903,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egypt",
				"salience": 0.0018461903,
				"type": "LOCATION"
			},
			{
				"name": "proposal",
				"salience": 0.0016739428,
				"type": "OTHER"
			},
			{
				"name": "people-smuggling organizations",
				"salience": 0.0016320479,
				"type": "ORGANIZATION"
			},
			{
				"name": "basis",
				"salience": 0.0016320479,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amren.com/wp-content/uploads/2014/03/AmRen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T05:20:47.227+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "amren.com",
		"spam_score": "0",
		"text": "German Ministry Wants Migrants Returned to Africa: Report Reuters, November 6, 2016 \nThe German Interior Ministry wants to stop migrants ever reaching Europe’s Mediterranean coast by picking them up at sea and returning them to Africa, the Welt am Sonntag newspaper reported on Sunday. \nIn what would be a huge shift for a country with one of the most generous asylum policies, the ministry says the European Union should adopt an Australian-style system under which migrants intercepted at sea are sent for processing at camps in third countries. \n“The elimination of the prospect of reaching the European coast could convince migrants to avoid embarking on the life-threatening and costly journey in the first place,” the paper quoted a ministry spokeswoman as saying. \n“The goal must be to remove the basis for people-smuggling organizations and to save migrants from the life-threatening journey.” \nThe ministry’s proposal calls for migrants picked up in the Mediterranean–most of whom set off from conflict-torn Libya–to be sent to Tunisia, Egypt or other north African states to apply for asylum from there. \nIf their asylum applications are accepted, the migrants could then be transported safely to Europe. \n{snip}",
		"thread_title": "German Ministry Wants Migrants Returned to Africa: Report",
		"title": "German Ministry Wants Migrants Returned to Africa: Report",
		"type": "bs",
		"uuid": "df1bfe8022579ca33a8f8a6fda3c937c2cb6391f"
	},
	"-KhIh0CRyhLnf1cY2FGA": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T03:59:07.180+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/096x1p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Porsche_911_GT3"
				},
				"name": "RS",
				"salience": 0.15626517,
				"type": "ORGANIZATION"
			},
			{
				"name": "TIMES Russia",
				"salience": 0.14669295,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.108691745,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05gpf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nuclear_weapon"
				},
				"name": "Nuclear Weapon",
				"salience": 0.08810697,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.040128097,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.028475223,
				"type": "LOCATION"
			},
			{
				"name": "size",
				"salience": 0.028475223,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.028293848,
				"type": "ORGANIZATION"
			},
			{
				"name": "Update",
				"salience": 0.024698375,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.024698375,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.020669106,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0435zp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/R-36_(missile)"
				},
				"name": "SS-18 Satan",
				"salience": 0.019330375,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.017201636,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.012173907,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.012173907,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03qmgdn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Kelley"
				},
				"name": "Robert Kelley",
				"salience": 0.009938517,
				"type": "PERSON"
			},
			{
				"name": "Satan 2",
				"salience": 0.009025061,
				"type": "WORK_OF_ART"
			},
			{
				"name": "designers",
				"salience": 0.0072408584,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0061194724,
				"type": "WORK_OF_ART"
			},
			{
				"name": "public",
				"salience": 0.005233907,
				"type": "PERSON"
			},
			{
				"name": "image",
				"salience": 0.005233907,
				"type": "WORK_OF_ART"
			},
			{
				"name": "military muscle",
				"salience": 0.005233907,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.005233907,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.005233907,
				"type": "EVENT"
			},
			{
				"name": "designer",
				"salience": 0.0050809155,
				"type": "PERSON"
			},
			{
				"name": "chief designer",
				"salience": 0.0050809155,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.004901512,
				"type": "OTHER"
			},
			{
				"name": "warheads",
				"salience": 0.00481976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.004759282,
				"type": "LOCATION"
			},
			{
				"name": "missile system",
				"salience": 0.0047510313,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.004239362,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Reports",
				"salience": 0.0037350962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0037222952,
				"type": "LOCATION"
			},
			{
				"name": "news site",
				"salience": 0.003671634,
				"type": "OTHER"
			},
			{
				"name": "bomb",
				"salience": 0.003671634,
				"type": "OTHER"
			},
			{
				"name": "Y",
				"salience": 0.003671634,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.003671634,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.0035347356,
				"type": "OTHER"
			},
			{
				"name": "deterrent",
				"salience": 0.0035347356,
				"type": "OTHER"
			},
			{
				"name": "objectives",
				"salience": 0.0035347356,
				"type": "OTHER"
			},
			{
				"name": "military direction",
				"salience": 0.0035347356,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0035347356,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0035347356,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0035347356,
				"type": "LOCATION"
			},
			{
				"name": "defenses",
				"salience": 0.0035347356,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.0035347356,
				"type": "OTHER"
			},
			{
				"name": "fallout",
				"salience": 0.0035347356,
				"type": "EVENT"
			},
			{
				"name": "size",
				"salience": 0.0034617586,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.0034617586,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.0032684214,
				"type": "OTHER"
			},
			{
				"name": "Makeyev Rocket Design Bureau",
				"salience": 0.0032237102,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012ngfw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RS-28_Sarmat"
				},
				"name": "Sarmat",
				"salience": 0.0032237102,
				"type": "OTHER"
			},
			{
				"name": "News website",
				"salience": 0.003194078,
				"type": "OTHER"
			},
			{
				"name": "portions",
				"salience": 0.0029980238,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.0028074435,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.0025910975,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.0025866837,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.0025866837,
				"type": "OTHER"
			},
			{
				"name": "RS-28",
				"salience": 0.0023606368,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0129g54z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sputnik_(news_agency)"
				},
				"name": "Sputnik",
				"salience": 0.0022608445,
				"type": "ORGANIZATION"
			},
			{
				"name": "V. Degtar",
				"salience": 0.0022608445,
				"type": "OTHER"
			},
			{
				"name": "Kaverin",
				"salience": 0.0022608445,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.0022608445,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.0022608445,
				"type": "ORGANIZATION"
			},
			{
				"name": "flexibility",
				"salience": 0.0022400538,
				"type": "OTHER"
			},
			{
				"name": "confidence",
				"salience": 0.0022400538,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0022400538,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0022400538,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.0022400538,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.0022400538,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ndwhc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimea"
				},
				"name": "Crimea",
				"salience": 0.0021764957,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0021764957,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0021764957,
				"type": "LOCATION"
			},
			{
				"name": "missiles",
				"salience": 0.001993912,
				"type": "OTHER"
			},
			{
				"name": "reliability",
				"salience": 0.001973389,
				"type": "OTHER"
			},
			{
				"name": "upgrade",
				"salience": 0.0019606126,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.0016389897,
				"type": "OTHER"
			},
			{
				"name": "circuits",
				"salience": 0.0016316709,
				"type": "OTHER"
			},
			{
				"name": "payload capacity",
				"salience": 0.0016316709,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0016316709,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027lnzs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/IPhone"
				},
				"name": "iPhone",
				"salience": 0.0016055888,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "weapons",
				"salience": 0.0015590362,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0014192739,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0014076795,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.0014076795,
				"type": "OTHER"
			},
			{
				"name": "payload",
				"salience": 0.0014076795,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.001218955,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.001218955,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "electronics",
				"salience": 0.001218955,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0009458989,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gy_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Energy"
				},
				"name": "U.S. Department of Energy",
				"salience": 0.0007502615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.00064768444,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/zxchaaaaaaaaaaaaaaaaaaah-676x450.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:59:07.180+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Russia Unveils Update of Advanced Nuclear Weapon 10/26/2016 \nEPOCH TIMES \nRussia has unveiled a new nuclear missile that “is capable of wiping out parts of the earth the size of Texas or France.” \nReports say that the RS-28 missile, dubbed the “Satan 2,” was unveiled this week, with the first image of the weapon being released to the public by designers at the Makeyev Rocket Design Bureau . It’s also known as “Sarmat” in Russian. \nThe report comes as Moscow has been flexing its military muscle amid tensions with the United States over the war in Syria and lingering fallout from the invasion of Crimea in Ukraine. NATO, meanwhile, has been shoring up its defenses in countries near Russia’s border amid concerns about its military direction. \n“The prospective strategic missile system is being developed in order to assuredly and effectively fulfill objectives of nuclear deterrent by Russia’s strategic forces,” according to a statement from V. Degtar and Y. Kaverin, listed as the bomb’s chief designer and leading designer, respectively, reported RT , a Russian government-funded news site. \nEarlier this year, the Kremlin-aligned Sputnik News website said the missile could “wipe out” portions of the earth the “size of Texas or France.” \nThe RS-28 will replace the R-36, which was called the “SS-18 Satan” by NATO when it was introduced in the 1970s. \nRobert Kelley, a former nuclear weapons expert at the U.S. Department of Energy, told NBC News that the new missile most likely had an upgrade in the device’s electronics, rather than an increase in its explosive payload or range. \n“The range of the missiles will be about the same, the explosive destructive power will be about the same [but] the reliability, flexibility and confidence [in the warheads’ ability to hit their targets] will go way up,” said Kelley. \nHe noted: “Your iPhone can do thousands of more things today than in the 1970s when these systems were first deployed. Many of the clunky electronic circuits of that era no longer exist and no one knows how to make them anymore.” \nThe RS-28 weighs about 100 tons, and it features a large, 10-ton nuclear payload capacity. The missile is expected to enter service in 2018.",
		"thread_title": "Russia Unveils Update of Advanced Nuclear Weapon",
		"title": "Russia Unveils Update of Advanced Nuclear Weapon",
		"type": "bs",
		"uuid": "1b1dae3da4bcbdc57afad22e20d8bed710778b68"
	},
	"-KhIh0KwRirmEsZ2E3NN": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T03:59:07.211+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "TIMES Russia",
				"salience": 0.4520967,
				"type": "ORGANIZATION"
			},
			{
				"name": "Update",
				"salience": 0.10469147,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.07586393,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05gpf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nuclear_weapon"
				},
				"name": "Nuclear Weapon",
				"salience": 0.066114835,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.044829614,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.044829614,
				"type": "LOCATION"
			},
			{
				"name": "star",
				"salience": 0.04079214,
				"type": "PERSON"
			},
			{
				"name": "earth",
				"salience": 0.030535195,
				"type": "LOCATION"
			},
			{
				"name": "size",
				"salience": 0.030535195,
				"type": "OTHER"
			},
			{
				"name": "T",
				"salience": 0.030535195,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.018759344,
				"type": "OTHER"
			},
			{
				"name": "EMPIRE",
				"salience": 0.016341206,
				"type": "OTHER"
			},
			{
				"name": "Trump Behind Gym",
				"salience": 0.010096113,
				"type": "OTHER"
			},
			{
				"name": "DAILY CALLER Astronomers",
				"salience": 0.010003766,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012gx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Biden"
				},
				"name": "Biden",
				"salience": 0.009721398,
				"type": "PERSON"
			},
			{
				"name": "Scientists",
				"salience": 0.0054569724,
				"type": "PERSON"
			},
			{
				"name": "AMTV Archives",
				"salience": 0.004498584,
				"type": "OTHER"
			},
			{
				"name": "Aliens Around Weird Star 10",
				"salience": 0.004298733,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/mad-joe-biden.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:59:07.211+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Russia Unveils Update of Advanced Nuclear Weapon 10/26/2016 EPOCH TIMES Russia has unveiled a new nuclear missile that “is capable of wiping out parts of the earth the size of T ... Biden: I’d Take on Trump Behind Gym 10/26/2016 ANOTHER DAY IN THE EMPIRE Just when you thought this election cycle couldn’t get any more slimy and absurd. Enter ... Scientists About To Pour $100 Million Into Looking For Aliens Around Weird Star 10/26/2016 THE DAILY CALLER Astronomers are about to pour $100 million into investigating a star that may be surrounded by a lar ... AMTV Archives",
		"thread_title": "Biden: I’d Take on Trump Behind Gym",
		"title": "Biden: I’d Take on Trump Behind Gym",
		"type": "bs",
		"uuid": "d533544ad04bfc5c5ee11a988d3fc70a4525205e"
	},
	"-KhIh0c-xYVVw_uNXFiI": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T03:59:07.272+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "star",
				"salience": 0.18698885,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/11bwfmqjbg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andrew_Siemion"
				},
				"name": "Andrew Siemion",
				"salience": 0.06364804,
				"type": "PERSON"
			},
			{
				"name": "behavior",
				"salience": 0.058780547,
				"type": "OTHER"
			},
			{
				"name": "DAILY CALLER Astronomers",
				"salience": 0.034707386,
				"type": "ORGANIZATION"
			},
			{
				"name": "astronomers",
				"salience": 0.034346778,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.027208177,
				"type": "OTHER"
			},
			{
				"name": "Scientists",
				"salience": 0.025517885,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06_10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Search_for_extraterrestrial_intelligence"
				},
				"name": "Search for Extraterrestrial Intelligence",
				"salience": 0.02518221,
				"type": "ORGANIZATION"
			},
			{
				"name": "star",
				"salience": 0.024965124,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.02427637,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.020570174,
				"type": "PERSON"
			},
			{
				"name": "structure",
				"salience": 0.01847646,
				"type": "OTHER"
			},
			{
				"name": "Astronomers",
				"salience": 0.014878363,
				"type": "ORGANIZATION"
			},
			{
				"name": "Researchers",
				"salience": 0.013086559,
				"type": "PERSON"
			},
			{
				"name": "program telescope",
				"salience": 0.012093706,
				"type": "OTHER"
			},
			{
				"name": "Aliens Around Weird Star 10",
				"salience": 0.011399592,
				"type": "OTHER"
			},
			{
				"name": "Astronomers",
				"salience": 0.011246226,
				"type": "ORGANIZATION"
			},
			{
				"name": "program",
				"salience": 0.010923581,
				"type": "OTHER"
			},
			{
				"name": "wavelength",
				"salience": 0.010746141,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.009463375,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.009463375,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.00922708,
				"type": "PERSON"
			},
			{
				"name": "forms",
				"salience": 0.009099137,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.008081974,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.007911865,
				"type": "OTHER"
			},
			{
				"name": "Scientists",
				"salience": 0.007743838,
				"type": "PERSON"
			},
			{
				"name": "astronomer",
				"salience": 0.007364082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02zd460",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Berkeley"
				},
				"name": "University of California, Berkeley",
				"salience": 0.006732401,
				"type": "ORGANIZATION"
			},
			{
				"name": "Scientists",
				"salience": 0.0059752567,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.0059651406,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.0059651406,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.0059651406,
				"type": "PERSON"
			},
			{
				"name": "stars",
				"salience": 0.0059651406,
				"type": "PERSON"
			},
			{
				"name": "scientists",
				"salience": 0.0058982344,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/11c3kvql92",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breakthrough_Listen"
				},
				"name": "Breakthrough Listen",
				"salience": 0.0058312416,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.005742841,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.005668101,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.004988963,
				"type": "OTHER"
			},
			{
				"name": "telescope",
				"salience": 0.004988963,
				"type": "OTHER"
			},
			{
				"name": "stars",
				"salience": 0.0048712282,
				"type": "PERSON"
			},
			{
				"name": "dimming",
				"salience": 0.0047869207,
				"type": "EVENT"
			},
			{
				"name": "explanation",
				"salience": 0.004682848,
				"type": "OTHER"
			},
			{
				"name": "dimming",
				"salience": 0.004638461,
				"type": "EVENT"
			},
			{
				"name": "Nothing",
				"salience": 0.004620688,
				"type": "OTHER"
			},
			{
				"name": "Ben Montet",
				"salience": 0.004600679,
				"type": "PERSON"
			},
			{
				"name": "radio",
				"salience": 0.004505111,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0043954863,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/g/11bwd2ghzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KIC_8462852"
				},
				"name": "KIC 8462852",
				"salience": 0.0043540243,
				"type": "OTHER"
			},
			{
				"name": "dust",
				"salience": 0.004148395,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.0040405453,
				"type": "OTHER"
			},
			{
				"name": "press statement",
				"salience": 0.003901654,
				"type": "WORK_OF_ART"
			},
			{
				"name": "experiments",
				"salience": 0.003901654,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.003901654,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gh85ks",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kepler_Input_Catalog"
				},
				"name": "KIC",
				"salience": 0.0036711735,
				"type": "ORGANIZATION"
			},
			{
				"name": "Researchers",
				"salience": 0.003646245,
				"type": "PERSON"
			},
			{
				"name": "signal",
				"salience": 0.0036226483,
				"type": "OTHER"
			},
			{
				"name": "civilizations",
				"salience": 0.0035597421,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0034992364,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.003368718,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.003368718,
				"type": "PERSON"
			},
			{
				"name": "masses",
				"salience": 0.003368718,
				"type": "OTHER"
			},
			{
				"name": "dimming",
				"salience": 0.0033367716,
				"type": "EVENT"
			},
			{
				"name": "civilization",
				"salience": 0.0032991436,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.003282126,
				"type": "OTHER"
			},
			{
				"name": "Astronomers",
				"salience": 0.0031523472,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.0031455928,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0030418283,
				"type": "OTHER"
			},
			{
				"name": "intervals",
				"salience": 0.0030418283,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0030418283,
				"type": "OTHER"
			},
			{
				"name": "dimming",
				"salience": 0.002939623,
				"type": "EVENT"
			},
			{
				"name": "formations",
				"salience": 0.002857055,
				"type": "OTHER"
			},
			{
				"name": "Berkeley SETI Research Center",
				"salience": 0.0027740553,
				"type": "ORGANIZATION"
			},
			{
				"name": "solution",
				"salience": 0.0027711752,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0027504652,
				"type": "OTHER"
			},
			{
				"name": "vicinity",
				"salience": 0.002736275,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.002736275,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.002736275,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.002736275,
				"type": "ORGANIZATION"
			},
			{
				"name": "planets",
				"salience": 0.0026341868,
				"type": "LOCATION"
			},
			{
				"name": "output",
				"salience": 0.0026341868,
				"type": "OTHER"
			},
			{
				"name": "aliens",
				"salience": 0.0025797682,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02d2b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dyson_sphere"
				},
				"name": "Dyson Spheres",
				"salience": 0.0025137216,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cw9p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/W._M._Keck_Observatory"
				},
				"name": "Keck",
				"salience": 0.002402267,
				"type": "PERSON"
			},
			{
				"name": "Tabby",
				"salience": 0.002402267,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b0m2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hubble_Space_Telescope"
				},
				"name": "Hubble",
				"salience": 0.002402267,
				"type": "OTHER"
			},
			{
				"name": "astronomy",
				"salience": 0.0022962808,
				"type": "OTHER"
			},
			{
				"name": "artifacts",
				"salience": 0.0022339975,
				"type": "OTHER"
			},
			{
				"name": "megastuctures",
				"salience": 0.0022339975,
				"type": "OTHER"
			},
			{
				"name": "solar system",
				"salience": 0.0022339975,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.0022339975,
				"type": "OTHER"
			},
			{
				"name": "energy problems",
				"salience": 0.0022339975,
				"type": "OTHER"
			},
			{
				"name": "graduate student",
				"salience": 0.0022157505,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gzbb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kepler_(spacecraft)"
				},
				"name": "Kepler Space Telescope",
				"salience": 0.0021543736,
				"type": "OTHER"
			},
			{
				"name": "comets",
				"salience": 0.0021345576,
				"type": "OTHER"
			},
			{
				"name": "formation",
				"salience": 0.0021345576,
				"type": "EVENT"
			},
			{
				"name": "sign",
				"salience": 0.002087672,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.001981082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08815",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yale_University"
				},
				"name": "Yale University",
				"salience": 0.0019452354,
				"type": "ORGANIZATION"
			},
			{
				"name": "front",
				"salience": 0.0019273417,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0019273417,
				"type": "OTHER"
			},
			{
				"name": "phenomenon",
				"salience": 0.0018320385,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0018238571,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.0018159231,
				"type": "OTHER"
			},
			{
				"name": "civilization",
				"salience": 0.001795434,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0017781911,
				"type": "OTHER"
			},
			{
				"name": "comets",
				"salience": 0.0017426618,
				"type": "OTHER"
			},
			{
				"name": "pulsar",
				"salience": 0.0017414448,
				"type": "OTHER"
			},
			{
				"name": "astronomers",
				"salience": 0.0017155033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.0016844593,
				"type": "ORGANIZATION"
			},
			{
				"name": "radio signal",
				"salience": 0.0016829054,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0016689629,
				"type": "OTHER"
			},
			{
				"name": "diameter",
				"salience": 0.0016689629,
				"type": "OTHER"
			},
			{
				"name": "chances",
				"salience": 0.0016689629,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.0016479355,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.0016271728,
				"type": "PERSON"
			},
			{
				"name": "research",
				"salience": 0.0012571914,
				"type": "OTHER"
			},
			{
				"name": "occurrences",
				"salience": 0.0012155509,
				"type": "OTHER"
			},
			{
				"name": "abnormalities",
				"salience": 0.0012155509,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0012155509,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0012155509,
				"type": "OTHER"
			},
			{
				"name": "dust",
				"salience": 0.0011754256,
				"type": "OTHER"
			},
			{
				"name": "comets",
				"salience": 0.0011614249,
				"type": "OTHER"
			},
			{
				"name": "observations",
				"salience": 0.0011408693,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.001048641,
				"type": "OTHER"
			},
			{
				"name": "phenomena",
				"salience": 0.001048641,
				"type": "OTHER"
			},
			{
				"name": "mass",
				"salience": 0.0010101993,
				"type": "OTHER"
			},
			{
				"name": "hypothesis",
				"salience": 0.0009080211,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0009080211,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0009080211,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03y3h7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PSR_B1919%2B21"
				},
				"name": "LGM-1",
				"salience": 0.0007481357,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02sjgpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Institute_of_Technology"
				},
				"name": "Caltech",
				"salience": 0.0005588358,
				"type": "ORGANIZATION"
			},
			{
				"name": "None",
				"salience": 0.0005330188,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x951",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gizmodo"
				},
				"name": "Gizmodo",
				"salience": 0.0003771448,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/a-brief-history-of-scientists-searching-for-extraterrestrial-life-511-body-image-1448841875.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:58:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Scientists About To Pour $100 Million Into Looking For Aliens Around Weird Star 10/26/2016 \nTHE DAILY CALLER \nAstronomers are about to pour $100 million into investigating a star that may be surrounded by a large structure built by an alien civilization. \nResearchers at the University of California, Berkeley’s Breakthrough Listen project of the Search for Extraterrestrial Intelligence (SETI) are turning the program’s $100 million budget into investigating the star’s unique behavior. \n“Everyone, every SETI program telescope, I mean every astronomer that has any kind of telescope in any wavelength that can see Tabby’s star has looked at it,” Dr. Andrew Siemion, director of the Berkeley SETI Research Center, said in a press statement . “It’s been looked at with Hubble, it’s been looked at with Keck, it’s been looked at in the infrared and radio and high energy, and every possible thing you can imagine, including a whole range of SETI experiments. Nothing has been found.” \nResearchers will repeatedly scan the star for eight hours per night over the next two months to examine its extremely unusually dimming behavior. The star randomly dims by as much as 22 percent of its output at extremely irregular intervals. This is consistent with large orbiting masses, much larger than planets, blocking out some of the star’s light when they pass in front of it. All the natural forms of large masses which could cause KIC 8462852’s dimming aren’t consistent with the star’s age . \nScientists found the first possible evidence of this extraterrestrial civilization around KIC 8462852 last October , when astronomers with Yale University and other top schools published a study that used NASA’s Kepler Space Telescope. \nSo far, astronomers haven’t found a single naturalistic explanation for the star’s exceedingly unusual dimming, which explains the extremely unusual behavior of the star. Astronomers have examined 500 other stars in the vicinity of KIC 8462852, and seen nothing else like it. \nThe dense formations near KIC 8462852 are similar to “Dyson Spheres,” hypothetical, are energy-harvesting “megastuctures” theoretical aliens could hypothetically build by rearranging the solar system. Scientists have pondered the existence of Dyson Spheres since the 1960s, thinking they could be a potential solution to energy problems faced by an extremely old civilization. SETI scientists have long argued humans could detect distant alien civilizations by looking for technological artifacts like Dyson Spheres orbiting other stars. \n“We spent a long time trying to convince ourselves this wasn’t real. We just weren’t able to,” Ben Montet, a Caltech astronomer who co-authored research on the star, told Gizmodo . “None of the considered phenomena can alone explain the observations.” \nThe best naturalistic explanation favored by astronomers, involves a huge mass of comets erratically orbiting the star and creating enough dust to dim the light, but a January analysis of the star’s history renders that hypothesis implausible, since the unprecedented dimming has continued for over a century. In order to dim for such a long time period, the star would need to have millions of times more dust and comets orbiting it than is the case. \nAstronomers estimate that the dimming would require roughly 648,000 giant comets of 200 kilometers in diameter, all aligned to pass in front of the star. The chances of such a formation render it essentially impossible, and there is currently no remotely plausible scientific explanation for what is going on with KIC 8462852. \nAstronomers have previously frequently misjudge abnormal stellar occurrences and, usually, the abnormalities are simply a new phenomenon. \nA graduate student in astronomy, found an usual pulsing radio signal so predictable it seemed to be a sign of intelligent life in 1967. The astronomers even nicknamed the signal LGM-1, for “little green men,” and believed they had detected a signal from an extraterrestrial civilization , but it turned out to be the first pulsar.",
		"thread_title": "Scientists About To Pour $100 Million Into Looking For Aliens Around Weird Star",
		"title": "Scientists About To Pour $100 Million Into Looking For Aliens Around Weird Star",
		"type": "bs",
		"uuid": "f0c9ebff27c55214c15b9e24409bdf243d2cf284"
	},
	"-KhIh0uHHWmih354e-jQ": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T03:59:07.371+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.3201661,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.1704558,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.04926936,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.027395705,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01b8g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jens_Stoltenberg"
				},
				"name": "Jens Stoltenberg",
				"salience": 0.02251262,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.01719611,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.01719611,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.016135026,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.016135026,
				"type": "PERSON"
			},
			{
				"name": "planes",
				"salience": 0.011291214,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.01071522,
				"type": "LOCATION"
			},
			{
				"name": "tanks",
				"salience": 0.0101997955,
				"type": "OTHER"
			},
			{
				"name": "artillery",
				"salience": 0.00883749,
				"type": "OTHER"
			},
			{
				"name": "military build-up",
				"salience": 0.00883749,
				"type": "EVENT"
			},
			{
				"name": "fighter jets",
				"salience": 0.00883749,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.00883749,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.00876934,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.008048852,
				"type": "ORGANIZATION"
			},
			{
				"name": "battle groups",
				"salience": 0.008046061,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.008037504,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.007701797,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.00738734,
				"type": "OTHER"
			},
			{
				"name": "warships",
				"salience": 0.0064764232,
				"type": "OTHER"
			},
			{
				"name": "cruise missiles",
				"salience": 0.005779565,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.005447339,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "REUTERS",
				"salience": 0.005447339,
				"type": "ORGANIZATION"
			},
			{
				"name": "defense ministers",
				"salience": 0.005219539,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.005219539,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.005018463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06c1y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Romania"
				},
				"name": "Romania",
				"salience": 0.0043406645,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spain",
				"salience": 0.003824439,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.00349431,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04kch_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ash_Carter"
				},
				"name": "Ash Carter",
				"salience": 0.003388373,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0274prg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East/West"
				},
				"name": "East-West",
				"salience": 0.0032150776,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01522",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Sea"
				},
				"name": "Baltic Sea",
				"salience": 0.0032150776,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0030459587,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019tjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_states"
				},
				"name": "Baltics",
				"salience": 0.002970682,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Sweden",
				"salience": 0.002784388,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/056_y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Madrid"
				},
				"name": "Madrid",
				"salience": 0.002784388,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.002784388,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Denmark",
				"salience": 0.002784388,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.002692794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.0026781103,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.0026425284,
				"type": "ORGANIZATION"
			},
			{
				"name": "battalion task force",
				"salience": 0.0024248173,
				"type": "OTHER"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.0023950227,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.0023917581,
				"type": "PERSON"
			},
			{
				"name": "warships",
				"salience": 0.0023819334,
				"type": "OTHER"
			},
			{
				"name": "carrier battle group",
				"salience": 0.0023819334,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.0023025374,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.0021522846,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0021507824,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0021507824,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0021362002,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0021362002,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0020565032,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/026j7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Fallon"
				},
				"name": "Michael Fallon",
				"salience": 0.0020411932,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0019527792,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0019527792,
				"type": "PERSON"
			},
			{
				"name": "ministry",
				"salience": 0.0018708877,
				"type": "ORGANIZATION"
			},
			{
				"name": "diplomats",
				"salience": 0.0018708877,
				"type": "PERSON"
			},
			{
				"name": "enclave",
				"salience": 0.0018625348,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.0018625348,
				"type": "PERSON"
			},
			{
				"name": "coast",
				"salience": 0.0018625348,
				"type": "LOCATION"
			},
			{
				"name": "response",
				"salience": 0.0018625348,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0017950606,
				"type": "LOCATION"
			},
			{
				"name": "battalion",
				"salience": 0.001663353,
				"type": "PERSON"
			},
			{
				"name": "aim",
				"salience": 0.0016201218,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0016080112,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0016080112,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0015916569,
				"type": "ORGANIZATION"
			},
			{
				"name": "need",
				"salience": 0.0015206162,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.0015081951,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0015081951,
				"type": "OTHER"
			},
			{
				"name": "flank",
				"salience": 0.0014519108,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0014519108,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.0014404685,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0014238968,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0014147307,
				"type": "LOCATION"
			},
			{
				"name": "vessels",
				"salience": 0.0013914838,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.0013586091,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0013529647,
				"type": "LOCATION"
			},
			{
				"name": "equipment",
				"salience": 0.0013060119,
				"type": "OTHER"
			},
			{
				"name": "annexation",
				"salience": 0.0013060119,
				"type": "EVENT"
			},
			{
				"name": "peninsula",
				"salience": 0.0013060119,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.0013060119,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.0013060119,
				"type": "OTHER"
			},
			{
				"name": "total",
				"salience": 0.0013060119,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0013029727,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.0012572682,
				"type": "PERSON"
			},
			{
				"name": "promise",
				"salience": 0.0012572682,
				"type": "OTHER"
			},
			{
				"name": "warheads",
				"salience": 0.0012572682,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0012572682,
				"type": "PERSON"
			},
			{
				"name": "targets",
				"salience": 0.0012572682,
				"type": "OTHER"
			},
			{
				"name": "weapons-grade plutonium agreement",
				"salience": 0.0012572682,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0012312859,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.0012312859,
				"type": "OTHER"
			},
			{
				"name": "fighter aircraft",
				"salience": 0.0012312859,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ndwhc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimea"
				},
				"name": "Crimea",
				"salience": 0.0011918518,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.0011873913,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/049hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kaliningrad"
				},
				"name": "Kaliningrad",
				"salience": 0.0011768352,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07806",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_aircraft_carrier_Admiral_Kuznetsov"
				},
				"name": "Kuznetsov",
				"salience": 0.0011465397,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05g2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Africa"
				},
				"name": "North African",
				"salience": 0.0011465397,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01x1k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ceuta"
				},
				"name": "Ceuta",
				"salience": 0.0011465397,
				"type": "LOCATION"
			},
			{
				"name": "ships",
				"salience": 0.0010984961,
				"type": "OTHER"
			},
			{
				"name": "flanks",
				"salience": 0.001084655,
				"type": "OTHER"
			},
			{
				"name": "deterrence",
				"salience": 0.0010662047,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0010662047,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0010662047,
				"type": "OTHER"
			},
			{
				"name": "warships",
				"salience": 0.0010187322,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0010187322,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0009633492,
				"type": "PERSON"
			},
			{
				"name": "troop contributions",
				"salience": 0.00095121015,
				"type": "OTHER"
			},
			{
				"name": "dispute",
				"salience": 0.00091981125,
				"type": "EVENT"
			},
			{
				"name": "decision",
				"salience": 0.00091981125,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00091981125,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.00091981125,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.00091981125,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.00079647393,
				"type": "OTHER"
			},
			{
				"name": "grievances",
				"salience": 0.00079647393,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00079647393,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0007937811,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0007937811,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dv_mb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/9K720_Iskander"
				},
				"name": "Iskander",
				"salience": 0.00077386136,
				"type": "PERSON"
			},
			{
				"name": "ex-Soviet",
				"salience": 0.00077386136,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/015h7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Sea"
				},
				"name": "Black Sea",
				"salience": 0.0007578652,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonia",
				"salience": 0.0007455091,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.000739186,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.00070890674,
				"type": "OTHER"
			},
			{
				"name": "breakdown",
				"salience": 0.0006698935,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.0006698935,
				"type": "EVENT"
			},
			{
				"name": "break",
				"salience": 0.0006698935,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.0006698935,
				"type": "EVENT"
			},
			{
				"name": "weapons-grade plutonium",
				"salience": 0.0006698935,
				"type": "OTHER"
			},
			{
				"name": "disputes",
				"salience": 0.0006698935,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00065623625,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.00065623625,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016dy9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurofighter_Typhoon"
				},
				"name": "Typhoon",
				"salience": 0.00065623625,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Danish",
				"salience": 0.00065623625,
				"type": "LOCATION"
			},
			{
				"name": "commitments",
				"salience": 0.00058266113,
				"type": "OTHER"
			},
			{
				"name": "disarmament",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"name": "worsening",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0005800581,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005800581,
				"type": "EVENT"
			},
			{
				"name": "accusations",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"name": "bargaining chip",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"name": "Editing",
				"salience": 0.0005800581,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00057078176,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gkh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West"
				},
				"name": "West",
				"salience": 0.0005661172,
				"type": "LOCATION"
			},
			{
				"name": "troop announcements",
				"salience": 0.0005444147,
				"type": "EVENT"
			},
			{
				"name": "demonstration",
				"salience": 0.0005375532,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01g4l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balts"
				},
				"name": "Baltic",
				"salience": 0.00049019523,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00049019523,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04dnx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kremlin"
				},
				"name": "Kremlin",
				"salience": 0.00049019523,
				"type": "ORGANIZATION"
			},
			{
				"name": "Diplomats",
				"salience": 0.00043523216,
				"type": "PERSON"
			},
			{
				"name": "military personnel",
				"salience": 0.0004332876,
				"type": "PERSON"
			},
			{
				"name": "bond",
				"salience": 0.0004332876,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0004332876,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04g5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latvia"
				},
				"name": "Latvia",
				"salience": 0.00040555777,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lithuania"
				},
				"name": "Lithuania",
				"salience": 0.00040555777,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0003569861,
				"type": "LOCATION"
			},
			{
				"name": "Sabine Siebold",
				"salience": 0.0003569861,
				"type": "PERSON"
			},
			{
				"name": "Tom Heneghan",
				"salience": 0.0003569861,
				"type": "PERSON"
			},
			{
				"name": "SYRIAN SHADOW",
				"salience": 0.00026665156,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "140",
				"salience": 0.00026665156,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.00026665156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.00026665156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05b4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norway"
				},
				"name": "Norway",
				"salience": 0.00026665156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0154j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belgium"
				},
				"name": "Belgium",
				"salience": 0.00026665156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01pj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Croatia"
				},
				"name": "Croatia",
				"salience": 0.00026665156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04g61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Luxembourg"
				},
				"name": "Luxembourg",
				"salience": 0.00026665156,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/LYNXNPEC9O1MX.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T02:54:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Britain, U.S. sending planes, troops to deter Russia in the east 10/26/2016 \nREUTERS \nBritain said on Wednesday it will send fighter jets to Romania next year and the United States promised troops, tanks and artillery to Poland in NATO’s biggest military build-up on Russia’s borders since the Cold War. \nGermany, Canada and other NATO allies also pledged forces at a defense ministers meeting in Brussels on the same day two Russian warships armed with cruise missiles entered the Baltic Sea between Sweden and Denmark, underscoring East-West tensions. \nIn Madrid, the foreign ministry said Russia had withdrawn a request to refuel three warships in Spain’s North African enclave of Ceuta after NATO allies said they could be used to target civilians in Syria. \nThe ships were part of an eight-ship carrier battle group – including Russia’s sole aircraft carrier Admiral Kuznetsov – that is expected to join around 10 other Russian vessels already off the Syrian coast, diplomats said. \nNATO Secretary-General Jens Stoltenberg said the troop contributions to a new 4,000-strong force in the Baltics and eastern Europe were a measured response to what the alliance believes are some 330,000 Russian troops stationed on Russia’s western flank near Moscow. \n“This month alone, Russia has deployed nuclear-capable Iskander missiles to Kaliningrad and suspended a weapons-grade plutonium agreement with the United States,” Stoltenberg said, also accusing Russia of continued support for rebels in Ukraine. \nThose ballistic missiles can hit targets across Poland and the Baltics, although NATO officials declined to say if Russia had moved nuclear warheads to Kaliningrad. \nNATO’s aim is to make good on a July promise by NATO leaders to deter Russia in Europe’s ex-Soviet states, after Moscow orchestrated the annexation of the Crimea peninsula in 2014. \nNATO’s plan is to set up four battle groups with a total of some 4,000 troops from early next year, backed by a 40,000-strong rapid-reaction force, and if need be, follow-on forces. \nAs part of that, U.S. Secretary of Defense Ash Carter announced a “battle-ready battalion task force” of about 900 soldiers would be sent to eastern Poland, as well as another, separate force equipped with tanks and other heavy equipment to move across eastern Europe. \n“It’s a major sign of the U.S. commitment to strengthening deterrence here,” Carter said. \nBritain’s Defence Secretary Michael Fallon said Britain would send an 800-strong battalion to Estonia, supported by French and Danish troops, starting from May. The United States wants its troops in position by June. \nLondon is also sending Typhoon fighter aircraft to Romania to patrol around the Black Sea, partly in support of Turkey. \n“Although we are leaving the European Union, we will be doing more to help secure the eastern and southern flanks of NATO,” Fallon said. \nSYRIAN SHADOW \nOthers NATO allies joined the four battle groups led by the United States, Germany, Britain and Canada to go to Poland, Lithuania, Estonia and Latvia. Canada said it was sending 450 troops to Latvia, joined by 140 military personnel from Italy. \nGermany said it was sending between 400 and 600 troops to Lithuania, with additional forces from the Netherlands, Norway, Belgium, Croatia and Luxembourg. \nStoltenberg said allies’ commitments would be “a clear demonstration of our transatlantic bond.” Diplomats said it would also send a message to Republican presidential nominee Donald Trump, who has complained that European allies do not pay their way in the alliance. \nFor the Kremlin, the U.S.-led alliance’s plans are already too much given Russia’s grievances at NATO’s expansion eastwards, although Stoltenberg denied going too far. \nBut NATO’s troop announcements in the Baltic states and Poland were partly overshadowed by the dispute about whether Spain should refuel the Russian warships, which was later resolved by Moscow’s decision to withdraw its request. \nNATO’s tensions with Russia have been building since Crimea and the West’s decision to impose retaliatory sanctions. \nBut the breakdown of a U.S-Russia brokered ceasefire in Syria on Oct. 3, followed by U.S. accusations that Russia has used cyber attacks to disrupt the presidential election, have signaled a worsening of ties. \nEven before the break down of the Syrian ceasefire, Russian President Vladimir Putin suspended a treaty with Washington on cleaning up weapons-grade plutonium, signaling he was willing to use nuclear disarmament as a new bargaining chip in disputes with the United States over Ukraine and Syria. \n(Additional reporting by Sabine Siebold; Editing by Tom Heneghan)",
		"thread_title": "Britain, U.S. sending planes, troops to deter Russia in the east",
		"title": "Britain, U.S. sending planes, troops to deter Russia in the east",
		"type": "bs",
		"uuid": "90c18d984e865819e641ebaaa2d3075cbad3436c"
	},
	"-KhIh16ZRWaXGhU1j4Si": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T14:45:42.782+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.19915366,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.13270606,
				"type": "ORGANIZATION"
			},
			{
				"name": "defenses",
				"salience": 0.124901146,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.042367432,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.03831301,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.02358592,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.02358592,
				"type": "OTHER"
			},
			{
				"name": "DAILY CALLER",
				"salience": 0.020557113,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.019701855,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.019701855,
				"type": "PERSON"
			},
			{
				"name": "battle groups",
				"salience": 0.01945536,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/049hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kaliningrad"
				},
				"name": "Kaliningrad",
				"salience": 0.019307643,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.019075189,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/026j7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Fallon"
				},
				"name": "Michael Fallon",
				"salience": 0.015371782,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.010535257,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.010485337,
				"type": "OTHER"
			},
			{
				"name": "reaction force",
				"salience": 0.009757018,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04kch_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ash_Carter"
				},
				"name": "Ash Carter",
				"salience": 0.009697227,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01522",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Sea"
				},
				"name": "Baltic",
				"salience": 0.008254928,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.008142973,
				"type": "PERSON"
			},
			{
				"name": "battle groups",
				"salience": 0.008142973,
				"type": "ORGANIZATION"
			},
			{
				"name": "deployment",
				"salience": 0.0077412617,
				"type": "EVENT"
			},
			{
				"name": "fulfillment",
				"salience": 0.0075142467,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.007053657,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.007053657,
				"type": "OTHER"
			},
			{
				"name": "reinforcements",
				"salience": 0.007053657,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0067909313,
				"type": "EVENT"
			},
			{
				"name": "plan",
				"salience": 0.0065672393,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0063269967,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.006120459,
				"type": "LOCATION"
			},
			{
				"name": "missiles",
				"salience": 0.0060912725,
				"type": "OTHER"
			},
			{
				"name": "battalion",
				"salience": 0.005965608,
				"type": "PERSON"
			},
			{
				"name": "battalion",
				"salience": 0.005965608,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hv9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sergey_Shoygu"
				},
				"name": "Sergey Shoigu",
				"salience": 0.0059211226,
				"type": "PERSON"
			},
			{
				"name": "defense ministers",
				"salience": 0.0057137236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dv_mb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/9K720_Iskander"
				},
				"name": "Iskander",
				"salience": 0.0056728437,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04gzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lithuania"
				},
				"name": "Lithuania",
				"salience": 0.0051917457,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.0051300027,
				"type": "LOCATION"
			},
			{
				"name": "sights",
				"salience": 0.004948749,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0047642784,
				"type": "OTHER"
			},
			{
				"name": "weapons-grade plutonium agreement",
				"salience": 0.0047642784,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.004665941,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.004665941,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet",
				"salience": 0.0043451595,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0041792965,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0040410263,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.0040410263,
				"type": "OTHER"
			},
			{
				"name": "military presence",
				"salience": 0.0039399355,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.003861281,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.003515381,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.0034866834,
				"type": "LOCATION"
			},
			{
				"name": "deployment",
				"salience": 0.0034866834,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.003182037,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0030475426,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0154j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belgium"
				},
				"name": "Belgium",
				"salience": 0.0030475426,
				"type": "LOCATION"
			},
			{
				"name": "flank",
				"salience": 0.0030195222,
				"type": "OTHER"
			},
			{
				"name": "military build-up",
				"salience": 0.0027984437,
				"type": "EVENT"
			},
			{
				"name": "Stoltenberg",
				"salience": 0.002552089,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonia",
				"salience": 0.0024882096,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0024882096,
				"type": "LOCATION"
			},
			{
				"name": "largest",
				"salience": 0.002199535,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.002199535,
				"type": "OTHER"
			},
			{
				"name": "tips",
				"salience": 0.002199535,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0021016325,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0021016325,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0016854317,
				"type": "OTHER"
			},
			{
				"name": "fighter aircraft",
				"salience": 0.001643231,
				"type": "OTHER"
			},
			{
				"name": "contingent",
				"salience": 0.001643231,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.001643231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0014609903,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0013539616,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gkh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West"
				},
				"name": "West",
				"salience": 0.0013539616,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0013539616,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italians",
				"salience": 0.0010114348,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04g5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latvia"
				},
				"name": "Latvia",
				"salience": 0.0010114348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.0010114348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06c1y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Romania"
				},
				"name": "Romania",
				"salience": 0.0010114348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016dy9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurofighter_Typhoon"
				},
				"name": "Typhoon",
				"salience": 0.0010114348,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/or-37431.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T14:45:42.782+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "  \nDAILY CALLER \n  330,000 Russian troops amassing along European borders. \nNATO will contribute a 4,000-strong force to bolster the defenses of its members in the Baltic states and eastern Europe. Four battle groups will be created out of forces by early next year. The battle groups will be bolstered by a 40,000-strong reaction force, and various reinforcements as needed. The plan is the fulfillment of a promise to increase the defenses of former Soviet-bloc members under threat from Russian aggression. \n“This month alone, Russia is deploying nuclear-capable Iskander missiles to Kaliningrad and suspending a weapons-grade plutonium agreement with the United States,” said Stoltenberg Wednesday while attending a meeting of NATO defense ministers in Brussels, Belgium. The deployment of the missiles to Kaliningrad, a small Russian satellite territory located between Poland and Lithuania, puts Poland and the Baltic states directly in Russia’s sights. \nU.S. Secretary of Defense Ash Carter announced a battalion of 900 “battle-ready” soldiers will be deployed to eastern Poland as part of the new commitment. British Defense Secretary Michael Fallon said his country will be sending a battalion of 800 soldiers to Estonia, in addition to a contingent of Typhoon fighter aircraft to Romania. Canada plans to send 450 troops to Latvia, backed by 140 Italians. Germany will contribute 400 to 600 troops to Lithuania. \nRussia steadily built up its military presence on the European border for several months. Russian Defense Minister Sergey Shoigu announced a plan to recruit 30,000 additional forces to be stationed on Russia’s eastern flank in May, followed by the deployment of the Iskander missiles to Kaliningrad in early October. \nThe massive military build-up represents one of the largest since the Cold War, and comes at a time when tensions between the West and Moscow at are dangerously tense. \nSend tips to [email protected] .",
		"thread_title": "Russia And NATO Engage In One Of The Largest Military Build-Ups Since The Cold War",
		"title": "Russia And NATO Engage In One Of The Largest Military Build-Ups Since The Cold War",
		"type": "bs",
		"uuid": "5440d39ca15d93d66c7516934eaae3549966dfc6"
	},
	"-KhIh1Xdk-AUs4TcpzSp": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T14:58:47.676+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.16336238,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.10273012,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0qjfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood_Walk_of_Fame"
				},
				"name": "Hollywood Walk of Fame",
				"salience": 0.07457746,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.041571815,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.03671494,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.033620194,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.033620194,
				"type": "WORK_OF_ART"
			},
			{
				"name": "police",
				"salience": 0.027471157,
				"type": "PERSON"
			},
			{
				"name": "pick-axe",
				"salience": 0.026354872,
				"type": "EVENT"
			},
			{
				"name": "sledgehammer",
				"salience": 0.026354872,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.02284986,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.021855965,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.021398941,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.017763201,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.014778204,
				"type": "PERSON"
			},
			{
				"name": "vandalism",
				"salience": 0.013272585,
				"type": "OTHER"
			},
			{
				"name": "Liliana Preciado",
				"salience": 0.012902778,
				"type": "PERSON"
			},
			{
				"name": "James Lambert Otis",
				"salience": 0.01175402,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.01094884,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.010751477,
				"type": "LOCATION"
			},
			{
				"name": "family members",
				"salience": 0.00940781,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.008840332,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02pgkkk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Apprentice_(U.S._TV_series)"
				},
				"name": "The Apprentice",
				"salience": 0.008450838,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0081362,
				"type": "PERSON"
			},
			{
				"name": "hard-hat",
				"salience": 0.007816436,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "man",
				"salience": 0.007611107,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.006256699,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0059742955,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reality TV star",
				"salience": 0.0059721638,
				"type": "PERSON"
			},
			{
				"name": "Hollywood Chamber of Commerce",
				"salience": 0.005737728,
				"type": "ORGANIZATION"
			},
			{
				"name": "sledgehammer",
				"salience": 0.0055789608,
				"type": "OTHER"
			},
			{
				"name": "pick-axe",
				"salience": 0.0055789608,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.005467647,
				"type": "WORK_OF_ART"
			},
			{
				"name": "star",
				"salience": 0.0050658416,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.004831943,
				"type": "OTHER"
			},
			{
				"name": "darkness",
				"salience": 0.004831943,
				"type": "OTHER"
			},
			{
				"name": "emblem",
				"salience": 0.004831943,
				"type": "OTHER"
			},
			{
				"name": "vest",
				"salience": 0.004831943,
				"type": "OTHER"
			},
			{
				"name": "media industry website",
				"salience": 0.004831943,
				"type": "OTHER"
			},
			{
				"name": "chips",
				"salience": 0.004831943,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.004831943,
				"type": "OTHER"
			},
			{
				"name": "comment",
				"salience": 0.004333743,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0041692397,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.0041184323,
				"type": "LOCATION"
			},
			{
				"name": "spokeswoman",
				"salience": 0.003913356,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.0037855937,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.0037855937,
				"type": "PERSON"
			},
			{
				"name": "campaign appearances",
				"salience": 0.0037674166,
				"type": "EVENT"
			},
			{
				"name": "appearance",
				"salience": 0.0037674166,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.0033890773,
				"type": "LOCATION"
			},
			{
				"name": "investigators",
				"salience": 0.0033890773,
				"type": "PERSON"
			},
			{
				"name": "vandalism attack",
				"salience": 0.0033890773,
				"type": "EVENT"
			},
			{
				"name": "Leron Gubler",
				"salience": 0.0032696929,
				"type": "PERSON"
			},
			{
				"name": "real estate developer",
				"salience": 0.0032626656,
				"type": "ORGANIZATION"
			},
			{
				"name": "host",
				"salience": 0.0032626656,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.0032626656,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.0032626656,
				"type": "LOCATION"
			},
			{
				"name": "traffic barriers",
				"salience": 0.0032626656,
				"type": "OTHER"
			},
			{
				"name": "cones",
				"salience": 0.0032626656,
				"type": "OTHER"
			},
			{
				"name": "work site",
				"salience": 0.0032626656,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0032382873,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0031671878,
				"type": "PERSON"
			},
			{
				"name": "art piece",
				"salience": 0.0031206333,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k8xhj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deadline.com"
				},
				"name": "Deadline.com",
				"salience": 0.0029754792,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0029401274,
				"type": "ORGANIZATION"
			},
			{
				"name": "sexual assault",
				"salience": 0.0027671033,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.0027577537,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0027322548,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0023873397,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0022523492,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05zwcnj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/City_News_Service"
				},
				"name": "City News Service",
				"salience": 0.002242993,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0020865374,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign pledge",
				"salience": 0.0020673452,
				"type": "OTHER"
			},
			{
				"name": "street artist",
				"salience": 0.0020673452,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0020673452,
				"type": "PERSON"
			},
			{
				"name": "flags",
				"salience": 0.0020673452,
				"type": "OTHER"
			},
			{
				"name": "barbed wire",
				"salience": 0.0020673452,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0020673452,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0020413026,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0020086735,
				"type": "ORGANIZATION"
			},
			{
				"name": "installation",
				"salience": 0.0019159254,
				"type": "OTHER"
			},
			{
				"name": "chamber",
				"salience": 0.0017388968,
				"type": "ORGANIZATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0015057692,
				"type": "OTHER"
			},
			{
				"name": "repairs",
				"salience": 0.0015057692,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0015057692,
				"type": "WORK_OF_ART"
			},
			{
				"name": "CEO",
				"salience": 0.0015057692,
				"type": "PERSON"
			},
			{
				"name": "neighborhood",
				"salience": 0.0015057692,
				"type": "LOCATION"
			},
			{
				"name": "sidewalks",
				"salience": 0.0015057692,
				"type": "LOCATION"
			},
			{
				"name": "star plaques",
				"salience": 0.0015057692,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0015057692,
				"type": "LOCATION"
			},
			{
				"name": "comment",
				"salience": 0.0014387278,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0013433719,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0012990297,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0011310389,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0011248486,
				"type": "WORK_OF_ART"
			},
			{
				"name": "condemnations",
				"salience": 0.0011248486,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0011248486,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0011248486,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0011248486,
				"type": "PERSON"
			},
			{
				"name": "microphone",
				"salience": 0.0011248486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.0009267981,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/TRUMP.jpeg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T14:58:47.676+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Reuters Donald Trump’s Hollywood Walk of Fame star vandalized on video 10/27/2016 \nREUTERS \nDonald Trump’s star on the Hollywood Walk of Fame was defaced by a vandal wielding a sledgehammer and a pick-axe on Wednesday in an act captured on video, police said. \nLos Angeles police expect to arrest someone for the vandalism, which left Trump’s name scratched out of the star, the emblem in the middle dislodged and chips missing. \nA video posted at Deadline.com, a Hollywood media industry website, showed a man wearing a hard-hat and reflective vest swinging a sledgehammer and pick-axe in the pre-dawn darkness. \nThe area had been cordoned off with traffic barriers and cones, giving it the appearance of a legitimate work site. \nThe Republican presidential nominee, real estate developer and reality TV star has faced several large protests during his campaign appearances in California, where polls show him far behind Democratic presidential nominee Hillary Clinton. \nThe former host of the NBC show “The Apprentice,” Trump received his Walk of Fame star in 2007. A spokeswoman for Trump could not be reached for comment. \nLos Angeles police spokeswoman Liliana Preciado at the scene confirmed investigators have video capturing the vandalism attack and she said police expected to arrest whoever was responsible. \nLos Angeles-based City News Service reported a man identifying himself as James Lambert Otis said he damaged the installation “to make a point.” \nCity News reported the man said he had family members who were victims of sexual assault and had intended to remove the star, which he was unable to do, and auction it off to benefit women who have alleged Trump groped them. Trump has denied the allegations. \nOtis could not be reached for comment on the report. \nTrump drew widespread condemnations from voters and a number of Republican elected officials after a 2005 video emerged in which he was heard talking on an open microphone about groping women and trying to seduce a married woman. \nHis star on the Walk of Fame was previously targeted. \nIn the summer, a street artist erected a tiny wall around the star, complete with miniature American flags and barbed wire. The art piece, which was later removed, made light of Trump’s campaign pledge to build a wall along the U.S. border with Mexico. \nThe Hollywood Chamber of Commerce administers the hundreds of star plaques on sidewalks in the Los Angeles neighborhood. They are purchased for $30,000 each. \nLeron Gubler, president and CEO of the chamber, said in a statement the star would be covered for several days during repairs.",
		"thread_title": "Reuters Donald Trump’s Hollywood Walk of Fame star vandalized on video",
		"title": "Reuters Donald Trump’s Hollywood Walk of Fame star vandalized on video",
		"type": "bs",
		"uuid": "28879d30f2f6c88081344cd4b69f45d211f5951b"
	},
	"-KhIh2CFPvSPwLuRwqMF": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T15:20:32.738+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Gamblers",
				"salience": 0.18586715,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/029l86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas_Strip"
				},
				"name": "Las Vegas Strip",
				"salience": 0.17870237,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.15976705,
				"type": "LOCATION"
			},
			{
				"name": "Lucky Dragon",
				"salience": 0.0813734,
				"type": "OTHER"
			},
			{
				"name": "Bill Weidner",
				"salience": 0.017702587,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian American",
				"salience": 0.014207122,
				"type": "LOCATION"
			},
			{
				"name": "David Jacoby",
				"salience": 0.013369837,
				"type": "PERSON"
			},
			{
				"name": "casino",
				"salience": 0.011834518,
				"type": "LOCATION"
			},
			{
				"name": "resort",
				"salience": 0.009924785,
				"type": "LOCATION"
			},
			{
				"name": "investors",
				"salience": 0.00885359,
				"type": "PERSON"
			},
			{
				"name": "gamblers",
				"salience": 0.008291339,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04thp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Macau"
				},
				"name": "Macau",
				"salience": 0.0077898107,
				"type": "LOCATION"
			},
			{
				"name": "restaurants",
				"salience": 0.007354898,
				"type": "LOCATION"
			},
			{
				"name": "LOS ANGELES TIMES Casino",
				"salience": 0.005962588,
				"type": "ORGANIZATION"
			},
			{
				"name": "gamers",
				"salience": 0.0055693435,
				"type": "PERSON"
			},
			{
				"name": "property",
				"salience": 0.005216066,
				"type": "OTHER"
			},
			{
				"name": "resort",
				"salience": 0.00461983,
				"type": "LOCATION"
			},
			{
				"name": "resort",
				"salience": 0.00461983,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.004565173,
				"type": "LOCATION"
			},
			{
				"name": "gaming experience",
				"salience": 0.004087914,
				"type": "OTHER"
			},
			{
				"name": "visitors",
				"salience": 0.0040822667,
				"type": "PERSON"
			},
			{
				"name": "hotel",
				"salience": 0.003950126,
				"type": "LOCATION"
			},
			{
				"name": "game",
				"salience": 0.0037885744,
				"type": "EVENT"
			},
			{
				"name": "baccarat",
				"salience": 0.0036133842,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0035448354,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0034211741,
				"type": "OTHER"
			},
			{
				"name": "visitors",
				"salience": 0.003206971,
				"type": "PERSON"
			},
			{
				"name": "egg rolls",
				"salience": 0.003206971,
				"type": "OTHER"
			},
			{
				"name": "operators",
				"salience": 0.0030368501,
				"type": "ORGANIZATION"
			},
			{
				"name": "tourists",
				"salience": 0.0030362164,
				"type": "PERSON"
			},
			{
				"name": "tea bar",
				"salience": 0.0029629457,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0029629457,
				"type": "OTHER"
			},
			{
				"name": "entrance",
				"salience": 0.002802021,
				"type": "OTHER"
			},
			{
				"name": "Las Vegas Casino ONLY",
				"salience": 0.0027924152,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0026755019,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06wjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shanghai"
				},
				"name": "Shanghai",
				"salience": 0.0024932807,
				"type": "LOCATION"
			},
			{
				"name": "Lucky Dragon Hotel & Casino",
				"salience": 0.0024326562,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0023492223,
				"type": "LOCATION"
			},
			{
				"name": "dragon motif",
				"salience": 0.0023170293,
				"type": "OTHER"
			},
			{
				"name": "superstition",
				"salience": 0.0023170293,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0023170293,
				"type": "OTHER"
			},
			{
				"name": "gaming salons",
				"salience": 0.0023170293,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "festivities",
				"salience": 0.0023170293,
				"type": "EVENT"
			},
			{
				"name": "performances",
				"salience": 0.0023170293,
				"type": "EVENT"
			},
			{
				"name": "pop stars",
				"salience": 0.0023170293,
				"type": "OTHER"
			},
			{
				"name": "affinity",
				"salience": 0.0023170293,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.0023170293,
				"type": "PERSON"
			},
			{
				"name": "lion dance",
				"salience": 0.0023170293,
				"type": "ORGANIZATION"
			},
			{
				"name": "host",
				"salience": 0.0023170293,
				"type": "PERSON"
			},
			{
				"name": "signage",
				"salience": 0.0023170293,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0022405987,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012m47",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinese_New_Year"
				},
				"name": "Lunar New Year",
				"salience": 0.0022251287,
				"type": "EVENT"
			},
			{
				"name": "company",
				"salience": 0.002204669,
				"type": "ORGANIZATION"
			},
			{
				"name": "colony",
				"salience": 0.0020538936,
				"type": "OTHER"
			},
			{
				"name": "high rollers",
				"salience": 0.001993779,
				"type": "PERSON"
			},
			{
				"name": "boutique resort",
				"salience": 0.0019034474,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04v0y7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas_Sands"
				},
				"name": "Las Vegas Sands Corp",
				"salience": 0.0017881321,
				"type": "LOCATION"
			},
			{
				"name": "casino",
				"salience": 0.0016861454,
				"type": "LOCATION"
			},
			{
				"name": "hotel",
				"salience": 0.0016271898,
				"type": "LOCATION"
			},
			{
				"name": "Global Gaming Asset Management",
				"salience": 0.0016078266,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.0015723185,
				"type": "OTHER"
			},
			{
				"name": "bar",
				"salience": 0.0015723185,
				"type": "LOCATION"
			},
			{
				"name": "floor",
				"salience": 0.0015514285,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0015460164,
				"type": "OTHER"
			},
			{
				"name": "casino resort",
				"salience": 0.001496044,
				"type": "LOCATION"
			},
			{
				"name": "property",
				"salience": 0.0014883237,
				"type": "OTHER"
			},
			{
				"name": "hotel",
				"salience": 0.0014702607,
				"type": "LOCATION"
			},
			{
				"name": "John DeCree",
				"salience": 0.0014527633,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0393g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guangzhou"
				},
				"name": "Guangzhou",
				"salience": 0.0014264672,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03h64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hong_Kong"
				},
				"name": "Hong Kong",
				"salience": 0.0014264672,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06f32",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taiwan"
				},
				"name": "Taiwan",
				"salience": 0.0014264672,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0252np",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trans-Siberian_Orchestra"
				},
				"name": "Tso",
				"salience": 0.0014264672,
				"type": "ORGANIZATION"
			},
			{
				"name": "resort",
				"salience": 0.0014220715,
				"type": "LOCATION"
			},
			{
				"name": "resort",
				"salience": 0.0013347244,
				"type": "LOCATION"
			},
			{
				"name": "market",
				"salience": 0.0013207637,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0013207637,
				"type": "OTHER"
			},
			{
				"name": "investment",
				"salience": 0.0012974051,
				"type": "OTHER"
			},
			{
				"name": "room numbers",
				"salience": 0.0012201743,
				"type": "OTHER"
			},
			{
				"name": "gambling revenues",
				"salience": 0.0012193222,
				"type": "OTHER"
			},
			{
				"name": "luck",
				"salience": 0.0012144335,
				"type": "OTHER"
			},
			{
				"name": "gamblers",
				"salience": 0.0011794815,
				"type": "PERSON"
			},
			{
				"name": "casino industry",
				"salience": 0.0011017063,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0011017063,
				"type": "OTHER"
			},
			{
				"name": "fortunes",
				"salience": 0.0011017063,
				"type": "OTHER"
			},
			{
				"name": "chief operating officer",
				"salience": 0.0011017063,
				"type": "PERSON"
			},
			{
				"name": "fortune",
				"salience": 0.0011017063,
				"type": "OTHER"
			},
			{
				"name": "gambling revenue",
				"salience": 0.0011017063,
				"type": "OTHER"
			},
			{
				"name": "rooms",
				"salience": 0.0010435674,
				"type": "LOCATION"
			},
			{
				"name": "gaming resorts",
				"salience": 0.001022714,
				"type": "OTHER"
			},
			{
				"name": "neophyte",
				"salience": 0.0010164373,
				"type": "OTHER"
			},
			{
				"name": "properties",
				"salience": 0.001004615,
				"type": "OTHER"
			},
			{
				"name": "restaurants",
				"salience": 0.0009879869,
				"type": "LOCATION"
			},
			{
				"name": "Food",
				"salience": 0.0009879869,
				"type": "OTHER"
			},
			{
				"name": "foreigners",
				"salience": 0.0009845654,
				"type": "PERSON"
			},
			{
				"name": "brain trust",
				"salience": 0.0009784971,
				"type": "OTHER"
			},
			{
				"name": "For The Times) Competition",
				"salience": 0.00096018444,
				"type": "ORGANIZATION"
			},
			{
				"name": "digit",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "phone directory",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "feng shui master",
				"salience": 0.0009539932,
				"type": "PERSON"
			},
			{
				"name": "development",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0009539932,
				"type": "PERSON"
			},
			{
				"name": "government figures",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "gaming licenses",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "monopoly",
				"salience": 0.0009539932,
				"type": "OTHER"
			},
			{
				"name": "kitchens",
				"salience": 0.00093010266,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.0009260558,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.0009260558,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.0008932994,
				"type": "EVENT"
			},
			{
				"name": "games",
				"salience": 0.0008932994,
				"type": "OTHER"
			},
			{
				"name": "card game",
				"salience": 0.0008932994,
				"type": "OTHER"
			},
			{
				"name": "visitors",
				"salience": 0.00089148764,
				"type": "PERSON"
			},
			{
				"name": "rollers",
				"salience": 0.00089148764,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00089148764,
				"type": "OTHER"
			},
			{
				"name": "Alon Las Vegas",
				"salience": 0.0008801942,
				"type": "ORGANIZATION"
			},
			{
				"name": "casino",
				"salience": 0.00087209535,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.0008555142,
				"type": "PERSON"
			},
			{
				"name": "customer",
				"salience": 0.0008555142,
				"type": "PERSON"
			},
			{
				"name": "baccarat",
				"salience": 0.0008519333,
				"type": "OTHER"
			},
			{
				"name": "challenge",
				"salience": 0.0008297831,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0008235781,
				"type": "OTHER"
			},
			{
				"name": "Crown Resort",
				"salience": 0.00082155754,
				"type": "LOCATION"
			},
			{
				"name": "place",
				"salience": 0.0008182434,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.000806555,
				"type": "OTHER"
			},
			{
				"name": "expansion",
				"salience": 0.0007887408,
				"type": "OTHER"
			},
			{
				"name": "casinos",
				"salience": 0.0007879595,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.0007724375,
				"type": "OTHER"
			},
			{
				"name": "gambling activity",
				"salience": 0.0007724375,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.0007559924,
				"type": "OTHER"
			},
			{
				"name": "visa",
				"salience": 0.0007441212,
				"type": "OTHER"
			},
			{
				"name": "VIP parlors",
				"salience": 0.0007436014,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0007436014,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.0007436014,
				"type": "OTHER"
			},
			{
				"name": "flights",
				"salience": 0.0007436014,
				"type": "EVENT"
			},
			{
				"name": "baccarat",
				"salience": 0.0007410064,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cbjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baccarat_(card_game)"
				},
				"name": "Baccarat",
				"salience": 0.00072915724,
				"type": "ORGANIZATION"
			},
			{
				"name": "Union Gaming",
				"salience": 0.00072903617,
				"type": "EVENT"
			},
			{
				"name": "North Strip",
				"salience": 0.00072903617,
				"type": "LOCATION"
			},
			{
				"name": "pool",
				"salience": 0.00072497776,
				"type": "OTHER"
			},
			{
				"name": "hotel",
				"salience": 0.0006958018,
				"type": "LOCATION"
			},
			{
				"name": "draw",
				"salience": 0.00067739334,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0006688565,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0006688565,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0006688565,
				"type": "EVENT"
			},
			{
				"name": "economy",
				"salience": 0.0006688565,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0006688565,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.0006688565,
				"type": "OTHER"
			},
			{
				"name": "hospitality",
				"salience": 0.0006688565,
				"type": "OTHER"
			},
			{
				"name": "casino giant",
				"salience": 0.0006688565,
				"type": "ORGANIZATION"
			},
			{
				"name": "architecture",
				"salience": 0.0006688565,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.0006688565,
				"type": "PERSON"
			},
			{
				"name": "Plans",
				"salience": 0.0006688565,
				"type": "OTHER"
			},
			{
				"name": "dining options",
				"salience": 0.0006467753,
				"type": "OTHER"
			},
			{
				"name": "guests",
				"salience": 0.000643886,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.000643886,
				"type": "OTHER"
			},
			{
				"name": "dispute",
				"salience": 0.000643886,
				"type": "EVENT"
			},
			{
				"name": "gap",
				"salience": 0.000643886,
				"type": "OTHER"
			},
			{
				"name": "relationships",
				"salience": 0.000643886,
				"type": "OTHER"
			},
			{
				"name": "tea room",
				"salience": 0.0006363954,
				"type": "LOCATION"
			},
			{
				"name": "resort",
				"salience": 0.0006316361,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0006305759,
				"type": "LOCATION"
			},
			{
				"name": "gambling activity",
				"salience": 0.0006305759,
				"type": "OTHER"
			},
			{
				"name": "Isaac Brekken",
				"salience": 0.0006103751,
				"type": "PERSON"
			},
			{
				"name": "staples",
				"salience": 0.0006043222,
				"type": "OTHER"
			},
			{
				"name": "investors",
				"salience": 0.0006024942,
				"type": "PERSON"
			},
			{
				"name": "investors",
				"salience": 0.0006024942,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01914",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beijing"
				},
				"name": "Beijing",
				"salience": 0.0005871636,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05zjd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portuguese_language"
				},
				"name": "Portuguese",
				"salience": 0.0005871636,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03zddt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Venetian_Las_Vegas"
				},
				"name": "Venetian",
				"salience": 0.00058018183,
				"type": "LOCATION"
			},
			{
				"name": "Jacoby of Lucky Dragon",
				"salience": 0.00056819234,
				"type": "PERSON"
			},
			{
				"name": "projects",
				"salience": 0.0005647204,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00055298203,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dd903",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marina_Bay_Sands"
				},
				"name": "Marina Bay Sands",
				"salience": 0.00054868596,
				"type": "LOCATION"
			},
			{
				"name": "growth",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "congee",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "terrace",
				"salience": 0.0005460127,
				"type": "LOCATION"
			},
			{
				"name": "access",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "menu",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "sum",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "wonton noodles",
				"salience": 0.0005460127,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "addition",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "seafood",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "slump",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "headwinds",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "proxy",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "popularity",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "baccarat play",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "skill",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"name": "attitudes",
				"salience": 0.0005460127,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c4f1d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hard_Rock_Hotel_and_Casino_(Biloxi)"
				},
				"name": "Hard Rock Hotel & Casino",
				"salience": 0.0005449272,
				"type": "LOCATION"
			},
			{
				"name": "customer",
				"salience": 0.00052169594,
				"type": "PERSON"
			},
			{
				"name": "customers",
				"salience": 0.00052169594,
				"type": "PERSON"
			},
			{
				"name": "visa program",
				"salience": 0.00052169594,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00052169594,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.00052169594,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0005086285,
				"type": "OTHER"
			},
			{
				"name": "tax subsidies",
				"salience": 0.0005060024,
				"type": "OTHER"
			},
			{
				"name": "competitors",
				"salience": 0.00050011545,
				"type": "PERSON"
			},
			{
				"name": "vacationers",
				"salience": 0.00047785483,
				"type": "PERSON"
			},
			{
				"name": "casino",
				"salience": 0.00047443833,
				"type": "LOCATION"
			},
			{
				"name": "staff",
				"salience": 0.00047102763,
				"type": "PERSON"
			},
			{
				"name": "handful",
				"salience": 0.00047102763,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00047102763,
				"type": "PERSON"
			},
			{
				"name": "dining options",
				"salience": 0.00047102763,
				"type": "OTHER"
			},
			{
				"name": "nightclubs",
				"salience": 0.00047102763,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rytvxm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Resorts_World_Las_Vegas"
				},
				"name": "Resorts World",
				"salience": 0.0004634946,
				"type": "ORGANIZATION"
			},
			{
				"name": "competitors",
				"salience": 0.00046346756,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.00046346756,
				"type": "ORGANIZATION"
			},
			{
				"name": "backers",
				"salience": 0.0004586037,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01npw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MGM_Resorts_International"
				},
				"name": "MGM",
				"salience": 0.00045765282,
				"type": "ORGANIZATION"
			},
			{
				"name": "VIP baccarat tables",
				"salience": 0.0004571773,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.0004571773,
				"type": "OTHER"
			},
			{
				"name": "odds",
				"salience": 0.00044010763,
				"type": "OTHER"
			},
			{
				"name": "casino industry",
				"salience": 0.00043100902,
				"type": "OTHER"
			},
			{
				"name": "SLS Hotel & Casino",
				"salience": 0.0004282303,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.0004236752,
				"type": "LOCATION"
			},
			{
				"name": "commitments",
				"salience": 0.0004149162,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australia",
				"salience": 0.00041164467,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09pmkv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malaysia"
				},
				"name": "Malaysian",
				"salience": 0.00041164467,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d2dq0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Wall_of_China"
				},
				"name": "Great Wall",
				"salience": 0.00041164467,
				"type": "LOCATION"
			},
			{
				"name": "project",
				"salience": 0.00041126474,
				"type": "OTHER"
			},
			{
				"name": "gambling experience",
				"salience": 0.00041126474,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.00040785613,
				"type": "OTHER"
			},
			{
				"name": "residency",
				"salience": 0.00040785613,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00040785613,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00040785613,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.00040785613,
				"type": "LOCATION"
			},
			{
				"name": "portion",
				"salience": 0.00040785613,
				"type": "OTHER"
			},
			{
				"name": "applicants",
				"salience": 0.00040785613,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.00040785613,
				"type": "LOCATION"
			},
			{
				"name": "construction",
				"salience": 0.00040785613,
				"type": "OTHER"
			},
			{
				"name": "bars",
				"salience": 0.00040785613,
				"type": "OTHER"
			},
			{
				"name": "gamble",
				"salience": 0.00040647693,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.00039627473,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05f5dq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hainan_Airlines"
				},
				"name": "Hainan Airlines",
				"salience": 0.00039627473,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d2by",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinese_Americans"
				},
				"name": "Chinese Americans",
				"salience": 0.00039627473,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01mz2g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McCarran_International_Airport"
				},
				"name": "McCarran International Airport",
				"salience": 0.00039627473,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06t2t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Singapore"
				},
				"name": "Singapore",
				"salience": 0.00039627473,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08chth",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas_Convention_and_Visitors_Authority"
				},
				"name": "Las Vegas Convention and Visitors Authority",
				"salience": 0.00039627473,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/038gnb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wynn_Las_Vegas"
				},
				"name": "Wynn",
				"salience": 0.00039627473,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gqp8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/EB-5_visa"
				},
				"name": "EB-5",
				"salience": 0.00038175378,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.00036552676,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07q3hh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palms_Casino_Resort"
				},
				"name": "Palms Casino Resort",
				"salience": 0.00036484582,
				"type": "LOCATION"
			},
			{
				"name": "properties",
				"salience": 0.00034619356,
				"type": "LOCATION"
			},
			{
				"name": "comparison",
				"salience": 0.00034619356,
				"type": "OTHER"
			},
			{
				"name": "rooms",
				"salience": 0.00034619356,
				"type": "LOCATION"
			},
			{
				"name": "clubbers",
				"salience": 0.00034302732,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00034302732,
				"type": "PERSON"
			},
			{
				"name": "partygoers",
				"salience": 0.00034302732,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.00034302732,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.00034302732,
				"type": "PERSON"
			},
			{
				"name": "price tag",
				"salience": 0.0003371903,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f265g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada_Gaming_Control_Board"
				},
				"name": "Nevada Gaming Control Board",
				"salience": 0.00033603288,
				"type": "ORGANIZATION"
			},
			{
				"name": "pool",
				"salience": 0.00033021896,
				"type": "LOCATION"
			},
			{
				"name": "food",
				"salience": 0.000327749,
				"type": "OTHER"
			},
			{
				"name": "restaurants",
				"salience": 0.000327749,
				"type": "LOCATION"
			},
			{
				"name": "restaurants",
				"salience": 0.000327749,
				"type": "ORGANIZATION"
			},
			{
				"name": "food",
				"salience": 0.000327749,
				"type": "OTHER"
			},
			{
				"name": "restaurants",
				"salience": 0.000327749,
				"type": "LOCATION"
			},
			{
				"name": "strategy",
				"salience": 0.00029701987,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00029701987,
				"type": "LOCATION"
			},
			{
				"name": "demographic",
				"salience": 0.00029701987,
				"type": "OTHER"
			},
			{
				"name": "snag",
				"salience": 0.00029701987,
				"type": "OTHER"
			},
			{
				"name": "track",
				"salience": 0.00029701987,
				"type": "OTHER"
			},
			{
				"name": "gongs",
				"salience": 0.00029701987,
				"type": "OTHER"
			},
			{
				"name": "tapestries",
				"salience": 0.00029701987,
				"type": "WORK_OF_ART"
			},
			{
				"name": "caricature-stuff",
				"salience": 0.00029701987,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.00028592916,
				"type": "OTHER"
			},
			{
				"name": "whiskey bar",
				"salience": 0.00028379043,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0002649745,
				"type": "OTHER"
			},
			{
				"name": "project cost",
				"salience": 0.00026163447,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00025721214,
				"type": "OTHER"
			},
			{
				"name": "parlors",
				"salience": 0.00025622503,
				"type": "LOCATION"
			},
			{
				"name": "nightclub",
				"salience": 0.00025622503,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.00025622503,
				"type": "PERSON"
			},
			{
				"name": "cuisine",
				"salience": 0.00025622503,
				"type": "OTHER"
			},
			{
				"name": "cuisine",
				"salience": 0.00025622503,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00025622503,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03115z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mandarin_Chinese"
				},
				"name": "Mandarin",
				"salience": 0.0002510003,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03h71d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/L.A._Live"
				},
				"name": "L.A. Live",
				"salience": 0.0002510003,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0002510003,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0002510003,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07_8dk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JW_Marriott_Hotels"
				},
				"name": "JW Marriott",
				"salience": 0.0002510003,
				"type": "LOCATION"
			},
			{
				"name": "manner",
				"salience": 0.0002455553,
				"type": "OTHER"
			},
			{
				"name": "Gold Coast Hotel & Casino",
				"salience": 0.00023294224,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.00022874027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0pnb8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinatown,_Manhattan"
				},
				"name": "Chinatown",
				"salience": 0.00022339802,
				"type": "LOCATION"
			},
			{
				"name": "mega-casinos",
				"salience": 0.00022185837,
				"type": "OTHER"
			},
			{
				"name": "stalwart",
				"salience": 0.00022185837,
				"type": "LOCATION"
			},
			{
				"name": "backyard variety",
				"salience": 0.00022185837,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00022185837,
				"type": "OTHER"
			},
			{
				"name": "owners",
				"salience": 0.00022185837,
				"type": "PERSON"
			},
			{
				"name": "concentration",
				"salience": 0.00022185837,
				"type": "OTHER"
			},
			{
				"name": "outpost",
				"salience": 0.00022185837,
				"type": "LOCATION"
			},
			{
				"name": "emphasis",
				"salience": 0.00021630041,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/033vpy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MGM_Grand_Las_Vegas"
				},
				"name": "MGM Grand",
				"salience": 0.00018278616,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08l7vk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cosmopolitan_of_Las_Vegas"
				},
				"name": "Cosmopolitan",
				"salience": 0.00018278616,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hn10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LGBT"
				},
				"name": "LGBT",
				"salience": 0.00018278616,
				"type": "OTHER"
			},
			{
				"name": "Paiza Club",
				"salience": 0.00015767972,
				"type": "ORGANIZATION"
			},
			{
				"name": "media reports",
				"salience": 0.00015163382,
				"type": "OTHER"
			},
			{
				"name": "Ping Pang Pong",
				"salience": 0.0001365297,
				"type": "ORGANIZATION"
			},
			{
				"name": "China MaMa",
				"salience": 0.0001365297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hbbx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sichuan"
				},
				"name": "Sichuan",
				"salience": 0.0001365297,
				"type": "LOCATION"
			},
			{
				"name": "Chengdu Taste",
				"salience": 0.0001365297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0295rf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Gabriel_Valley"
				},
				"name": "San Gabriel Valley",
				"salience": 0.0001365297,
				"type": "LOCATION"
			},
			{
				"name": "handful",
				"salience": 0.00008284837,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/la-1477006617-snap-photo.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T15:20:32.738+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 23.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "New Las Vegas Casino ONLY for Chinese Gamblers 10/27/2016 \nLOS ANGELES TIMES \nCasino operators know there are no gamblers quite like the Chinese. \nWith their affinity for baccarat, the most lucrative game in Las Vegas, Chinese gamblers have long commanded special treatment — be it with private Chinese gaming salons, Lunar New Year festivities or performances from pop stars flown in from Hong Kong and Taiwan. \nNo one in Las Vegas, however, has built a casino and hotel strictly for Chinese visitors until now. \nThe Lucky Dragon Hotel & Casino is billing itself as Las Vegas’ first Asian-themed resort, funded in large part by Chinese investors. The property, set to open Dec. 3 with a traditional lion dance, will offer bilingual staff and signage, a luxury tea bar and a host of restaurants with food that wouldn’t look or taste out of place in Guangzhou or Shanghai. \n“No General Tso’s or egg rolls here,” said David Jacoby, chief operating officer for the resort, which left no Chinese superstition unturned. \nThe rose-colored resort’s front entrance is designed in a dragon motif. A feng shui master blessed its kitchens. The main bar is eight-sided for good fortune. And it’s hard to find a No. 4 on the property. The unlucky digit is absent from room numbers and the phone directory. The nine-story hotel even skips a fourth floor. \n“This place is heavily feng shui’ed” Jacoby said. \nWith all that attention to detail, you’d think Lucky Dragon’s brain trust was born in Beijing. But the idea behind the 203-room boutique resort off the northern end of the Las Vegas Strip was largely conceived by an American veteran gaming executive, Bill Weidner, the former president and chief operating officer of Las Vegas Sands Corp. \nWeidner, an advisor to Lucky Dragon, is no neophyte to the Chinese market. He worked with some of China’s most powerful government figures to lead Sands’ expansion into Macau when the former Portuguese colony relaxed its monopoly on gaming licenses in 2002. Macau now generates nearly five times the gambling revenue of the Las Vegas Strip, forever changing the fortunes of the global casino industry. \nWeidner was also involved in the development of the $5.5-billion Marina Bay Sands in Singapore before leaving the company in a bitter dispute in 2009. \nWeidner and Jacoby know major Las Vegas gaming resorts like the Sands’ Venetian, MGM or Wynn already cater to China’s high rollers with VIP parlors and relationships forged in Macau. \nLucky Dragon, though tiny compared with those properties, addresses what they see as a gap in the market: middle-class Chinese gamblers, Chinese Americans as well as the broader Asian American community. \n“Let them fight over the 1% and let us fight over the remaining 99%,” said Jacoby, who previously worked for Weidner’s firm, Global Gaming Asset Management, opening a casino resort in the Philippines. \nThat pool of Chinese gamers will almost certainly grow. On Dec. 2, Hainan Airlines will fly the first direct flights from China to Las Vegas’s McCarran International Airport (Lucky Dragon guests are confirmed to be on that flight, Jacoby said). \nAlready, a record 206,743 visitors from China traveled to Las Vegas last year, nearly double the number in 2010, according to the Las Vegas Convention and Visitors Authority. \nMeanwhile, ground was broken on another Asian-themed resort, this one much bigger than Lucky Dragon. Resorts World, a Malaysian hospitality and casino giant with decades of Asian gaming experience, is spending up to $4 billion for a 3,200-room property on the North Strip that will feature Chinese architecture such as an ersatz Great Wall. It’s slated to open in 2019. \nPlans are also underway to build a $2-billion resort on the Strip called Alon Las Vegas. The project is owned by Australia’s Crown Resort, who count Chinese gamers as a major source of business. \n“It’s going to be even more of a competitive market,” said John DeCree, an analyst at Union Gaming in Las Vegas. “Everyone’s coming for the same customer. It’s going to be a challenge.” With 203 rooms, the hotel is small compared with many on the Strip. But with five restaurants, it offers more dining options than many its size. (Isaac Brekken / For The Times) \nCompetition could also be fierce for Chinese high rollers, whose gambling activity has been curtailed by a slowing Chinese economy and an anti-corruption campaign at home that, until recently, sent Macau gambling revenues into a two-year slump. \nLas Vegas isn’t immune to those headwinds. After years of explosive growth, casinos on the Strip experienced a decline in the amount of money bet on baccarat to about $10 billion in 2015. That’s nearly $2 billion less than 2014, according to the Nevada Gaming Control Board. \nThe casino industry uses the card game as a proxy for Chinese gambling activity because of its massive popularity within the culture. That’s both for practical and superstitious reasons. Baccarat has the best statistical odds of beating the house compared with other games. And as a game of chance over skill, baccarat also plays into Chinese fatalistic attitudes toward luck. \n“The vast majority of baccarat play comes from the Asian market,” said Jacoby of Lucky Dragon. \nJacoby’s casino will offer seven VIP baccarat tables on a second-floor terrace with access to a vast menu of authentic Chinese food. In addition to live seafood flown in from all over the world, the property will serve staples like congee, wonton noodles and dim sum. \nFood is expected to be a big draw because Chinese vacationers overwhelmingly prefer their native cuisine over others. \nLas Vegas has a number of well-regarded Chinese restaurants such as Ping Pang Pong at Gold Coast Hotel & Casino, China MaMa in Chinatown and an outpost of Chengdu Taste, the San Gabriel Valley stalwart for Sichuan cuisine. High-end Chinese food is also served at high-roller rooms such as the Venetian’s Paiza Club. \nNo casino, however, boasts the concentration of Chinese restaurants that Lucky Dragon will, with five altogether. The hope is Chinese tourists staying at other properties will choose to eat — and gamble — at Lucky Dragon when they venture off the Strip. \nThe emphasis on food means Lucky Dragon’s owners can eschew things that aren’t particularly important to Chinese tourists, like a whiskey bar or nightclub. And because Chinese tourists often don’t like to sunbathe, Lucky Dragon’s pool isn’t much bigger than the backyard variety. \nJacoby says his competitors on the Strip offer Chinese gamers a diluted experience by operating a handful of Chinese restaurants and parlors in mega-casinos that have to serve all manner of people, not just Chinese. By comparison, visitors to Lucky Dragon can start conversing in Mandarin with staff as soon as they walk in, he said. \n“We’re trying to take [the Asian gaming experience] and bring that front and center instead of hiding the most valuable customer in a segregated portion of a large building,” Jacoby said. \nThough Lucky Dragon will rely heavily on Asian American customers at first, its funding was largely drawn from mainland Chinese investors through the federal EB-5 visa program. The visa allows foreigners and their immediate family to gain permanent U.S. residency in exchange for a minimum investment of $500,000 that also creates American jobs. Rather than focusing on bars and nightclubs, the casino is prioritizing dining options. That includes a tea room, still under construction. (Isaac Brekken / For The Times) \nChinese investors have dominated the program nationwide, accounting for 80% of applicants awaiting EB-5 visas. Though occasionally subject to fraud, the program has successfully funded a handful of mixed-used projects in New York, the JW Marriott hotel at L.A. Live and the SLS Hotel & Casino across from Lucky Dragon. \nJacoby declined to say how many Chinese investors are involved in Lucky Dragon, which is expected to employ 800 people. Jacoby also declined to disclose how much the project cost, adding that earlier media reports pegging the price tag at about $370 million were inaccurate. \nThe company hit a snag last year when it unsuccessfully sought tax subsidies from the city. But financial commitments from Weidner’s family and others put the project back on track. \nLucky Dragon isn’t the first Las Vegas resort to target a specific demographic. The Hard Rock Hotel & Casino and the Palms Casino Resort opened years ago catering to young partygoers and clubbers before eventually being overshadowed by larger competitors on the Strip such as the MGM Grand and the Cosmopolitan. \nLucky Dragon’s early backers even considered building an LGBT resort before settling on their current strategy, one they say will live and die on being able to deliver an authentic Chinese gambling experience. \n“We set out trying to put together a place that would stand alone in Shanghai if you dropped it off down there today,” Jacoby said. “We didn’t want to [have] just gongs, Asian tapestries and caricature-stuff like that.”",
		"thread_title": "New Las Vegas Casino ONLY for Chinese Gamblers",
		"title": "New Las Vegas Casino ONLY for Chinese Gamblers",
		"type": "bs",
		"uuid": "94afa9da4226e7c66291a5532bcfad8bd5a05223"
	},
	"-KhIh2dJ9GxboWjFE80z": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T15:20:34.698+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "head",
				"salience": 0.051293142,
				"type": "PERSON"
			},
			{
				"name": "Mike Barrett",
				"salience": 0.047880314,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/049rl0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC_News"
				},
				"name": "BBC NEWS",
				"salience": 0.040859345,
				"type": "ORGANIZATION"
			},
			{
				"name": "World wildlife",
				"salience": 0.029515551,
				"type": "OTHER"
			},
			{
				"name": "wildlife populations",
				"salience": 0.029515551,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.023422943,
				"type": "WORK_OF_ART"
			},
			{
				"name": "trend",
				"salience": 0.017524272,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.015977168,
				"type": "OTHER"
			},
			{
				"name": "wildlife populations",
				"salience": 0.015122469,
				"type": "OTHER"
			},
			{
				"name": "declines",
				"salience": 0.014700116,
				"type": "OTHER"
			},
			{
				"name": "declines",
				"salience": 0.01397531,
				"type": "OTHER"
			},
			{
				"name": "Robin Freeman",
				"salience": 0.013803112,
				"type": "PERSON"
			},
			{
				"name": "decline",
				"salience": 0.011856799,
				"type": "OTHER"
			},
			{
				"name": "Human activity",
				"salience": 0.011247674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020ljd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zoological_Society_of_London"
				},
				"name": "Zoological Society of London",
				"salience": 0.010985879,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0829b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Wide_Fund_for_Nature"
				},
				"name": "WWF",
				"salience": 0.010905066,
				"type": "ORGANIZATION"
			},
			{
				"name": "vertebrates",
				"salience": 0.009962191,
				"type": "OTHER"
			},
			{
				"name": "wildlife trade",
				"salience": 0.009962191,
				"type": "OTHER"
			},
			{
				"name": "losses",
				"salience": 0.009962191,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.009743828,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.009680757,
				"type": "ORGANIZATION"
			},
			{
				"name": "assessment",
				"salience": 0.00914624,
				"type": "OTHER"
			},
			{
				"name": "pressures",
				"salience": 0.009015556,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vnvj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stuart_Pimm"
				},
				"name": "Stuart Pimm",
				"salience": 0.008271425,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.0079759,
				"type": "OTHER"
			},
			{
				"name": "pollution",
				"salience": 0.007792173,
				"type": "OTHER"
			},
			{
				"name": "climate change",
				"salience": 0.007792173,
				"type": "OTHER"
			},
			{
				"name": "wetlands",
				"salience": 0.007792173,
				"type": "LOCATION"
			},
			{
				"name": "rivers",
				"salience": 0.007792173,
				"type": "LOCATION"
			},
			{
				"name": "science",
				"salience": 0.007792173,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.007792173,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.007792173,
				"type": "OTHER"
			},
			{
				"name": "lakes",
				"salience": 0.007792173,
				"type": "LOCATION"
			},
			{
				"name": "figures",
				"salience": 0.0076313564,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.007461393,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0069078687,
				"type": "OTHER"
			},
			{
				"name": "wildlife populations",
				"salience": 0.0062361215,
				"type": "PERSON"
			},
			{
				"name": "wildlife",
				"salience": 0.0062361215,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0060615707,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0060615707,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0056819743,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.0056819743,
				"type": "WORK_OF_ART"
			},
			{
				"name": "elephants",
				"salience": 0.005499487,
				"type": "OTHER"
			},
			{
				"name": "species",
				"salience": 0.0054735322,
				"type": "OTHER"
			},
			{
				"name": "species",
				"salience": 0.0054735322,
				"type": "OTHER"
			},
			{
				"name": "freshwater species",
				"salience": 0.0054735322,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024cl7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Living_Planet"
				},
				"name": "Living Planet",
				"salience": 0.0051850677,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.005070494,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.005040028,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.005040028,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0050066523,
				"type": "LOCATION"
			},
			{
				"name": "population data",
				"salience": 0.0047047646,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0045493934,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.004443243,
				"type": "LOCATION"
			},
			{
				"name": "decline",
				"salience": 0.0042511765,
				"type": "OTHER"
			},
			{
				"name": "declines",
				"salience": 0.0042511765,
				"type": "OTHER"
			},
			{
				"name": "habitat loss",
				"salience": 0.004210366,
				"type": "EVENT"
			},
			{
				"name": "methodology",
				"salience": 0.004157343,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.004135895,
				"type": "OTHER"
			},
			{
				"name": "vertebrates",
				"salience": 0.004104987,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.004092579,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.004092579,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.004092579,
				"type": "OTHER"
			},
			{
				"name": "declines",
				"salience": 0.0040410375,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0039848383,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Some",
				"salience": 0.0039681406,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.0039558187,
				"type": "OTHER"
			},
			{
				"name": "The Living Planet Report",
				"salience": 0.003921158,
				"type": "WORK_OF_ART"
			},
			{
				"name": "freshwater species",
				"salience": 0.0038385948,
				"type": "OTHER"
			},
			{
				"name": "species",
				"salience": 0.0038385948,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.003753859,
				"type": "OTHER"
			},
			{
				"name": "Image copyright",
				"salience": 0.0037065796,
				"type": "OTHER"
			},
			{
				"name": "caption",
				"salience": 0.0037065796,
				"type": "OTHER"
			},
			{
				"name": "species",
				"salience": 0.003695375,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.003695375,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0036814467,
				"type": "OTHER"
			},
			{
				"name": "species",
				"salience": 0.0036714508,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.003627709,
				"type": "OTHER"
			},
			{
				"name": "wildlife populations",
				"salience": 0.0035708796,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.003544085,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.003544085,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0035233367,
				"type": "OTHER"
			},
			{
				"name": "Dr",
				"salience": 0.003511047,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.003511047,
				"type": "LOCATION"
			},
			{
				"name": "declines",
				"salience": 0.0034708641,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0033800378,
				"type": "LOCATION"
			},
			{
				"name": "populations",
				"salience": 0.0033515843,
				"type": "PERSON"
			},
			{
				"name": "trend",
				"salience": 0.0033374627,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.0033374627,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.0033241115,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.0033241115,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.0032097758,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0032097758,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0032097758,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.0032097758,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.0032000716,
				"type": "OTHER"
			},
			{
				"name": "wildlife populations",
				"salience": 0.0031858773,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0031158084,
				"type": "ORGANIZATION"
			},
			{
				"name": "things",
				"salience": 0.0030647595,
				"type": "OTHER"
			},
			{
				"name": "species",
				"salience": 0.0030554936,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0030056299,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0030056299,
				"type": "OTHER"
			},
			{
				"name": "conservation groups",
				"salience": 0.0029995355,
				"type": "ORGANIZATION"
			},
			{
				"name": "government statistics",
				"salience": 0.0029995355,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0027739012,
				"type": "PERSON"
			},
			{
				"name": "amphibians",
				"salience": 0.0027711089,
				"type": "OTHER"
			},
			{
				"name": "amphibians",
				"salience": 0.0027711089,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0027429229,
				"type": "OTHER"
			},
			{
				"name": "populations",
				"salience": 0.0027362795,
				"type": "PERSON"
			},
			{
				"name": "WWF Image",
				"salience": 0.0027353992,
				"type": "ORGANIZATION"
			},
			{
				"name": "assessment",
				"salience": 0.002642378,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0026261173,
				"type": "OTHER"
			},
			{
				"name": "average",
				"salience": 0.0025990806,
				"type": "OTHER"
			},
			{
				"name": "water systems",
				"salience": 0.0025990806,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0025990806,
				"type": "OTHER"
			},
			{
				"name": "freshwater systems",
				"salience": 0.0025990806,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0025930323,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.0025020782,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0025020782,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0025020782,
				"type": "OTHER"
			},
			{
				"name": "birds",
				"salience": 0.0025020782,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.0025020782,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.0025020782,
				"type": "OTHER"
			},
			{
				"name": "birds",
				"salience": 0.0025020782,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0024394286,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.0024305135,
				"type": "WORK_OF_ART"
			},
			{
				"name": "numbers",
				"salience": 0.0023858582,
				"type": "OTHER"
			},
			{
				"name": "wildlife trade",
				"salience": 0.0023500223,
				"type": "OTHER"
			},
			{
				"name": "wildlife trade",
				"salience": 0.0023500223,
				"type": "OTHER"
			},
			{
				"name": "overexploitation",
				"salience": 0.0023500223,
				"type": "OTHER"
			},
			{
				"name": "overexploitation",
				"salience": 0.0023500223,
				"type": "OTHER"
			},
			{
				"name": "overfishing",
				"salience": 0.0023500223,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.002282654,
				"type": "OTHER"
			},
			{
				"name": "surplus",
				"salience": 0.0022506332,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.0022506332,
				"type": "OTHER"
			},
			{
				"name": "dam building",
				"salience": 0.0022506332,
				"type": "LOCATION"
			},
			{
				"name": "fragmentation",
				"salience": 0.0022506332,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0022506332,
				"type": "OTHER"
			},
			{
				"name": "freshwater environment",
				"salience": 0.0022506332,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0022453954,
				"type": "OTHER"
			},
			{
				"name": "population sizes",
				"salience": 0.0021666286,
				"type": "OTHER"
			},
			{
				"name": "fish",
				"salience": 0.0021666286,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.0021666286,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0021666286,
				"type": "OTHER"
			},
			{
				"name": "NGOs",
				"salience": 0.0021666286,
				"type": "ORGANIZATION"
			},
			{
				"name": "surveys",
				"salience": 0.0021666286,
				"type": "OTHER"
			},
			{
				"name": "mammals",
				"salience": 0.0021666286,
				"type": "OTHER"
			},
			{
				"name": "reptiles",
				"salience": 0.0021666286,
				"type": "OTHER"
			},
			{
				"name": "average",
				"salience": 0.0021218506,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0020722486,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0020426502,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09738",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arctic"
				},
				"name": "Arctic",
				"salience": 0.0020280108,
				"type": "LOCATION"
			},
			{
				"name": "data",
				"salience": 0.0020122179,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.0019826032,
				"type": "PERSON"
			},
			{
				"name": "CARLOS DREWS",
				"salience": 0.0019758004,
				"type": "PERSON"
			},
			{
				"name": "population decline",
				"salience": 0.0018885975,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0018885975,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0018885975,
				"type": "OTHER"
			},
			{
				"name": "report authors",
				"salience": 0.0018845481,
				"type": "PERSON"
			},
			{
				"name": "declines",
				"salience": 0.0018413017,
				"type": "OTHER"
			},
			{
				"name": "sharks",
				"salience": 0.0018373536,
				"type": "OTHER"
			},
			{
				"name": "poaching",
				"salience": 0.0018373536,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0018373536,
				"type": "OTHER"
			},
			{
				"name": "trends",
				"salience": 0.0017705037,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0017687676,
				"type": "OTHER"
			},
			{
				"name": "population loss",
				"salience": 0.0017555414,
				"type": "EVENT"
			},
			{
				"name": "researchers",
				"salience": 0.0017103807,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0017052077,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.001635362,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0016185213,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0016080373,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0015850666,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0015596302,
				"type": "LOCATION"
			},
			{
				"name": "Dr",
				"salience": 0.0015596302,
				"type": "PERSON"
			},
			{
				"name": "wildlife",
				"salience": 0.0015270063,
				"type": "OTHER"
			},
			{
				"name": "wildlife populations",
				"salience": 0.0014514758,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0014108006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04_r5c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_elephant"
				},
				"name": "African",
				"salience": 0.0013852637,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.0013839854,
				"type": "ORGANIZATION"
			},
			{
				"name": "tropics",
				"salience": 0.0013725164,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0013725164,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.0013725164,
				"type": "LOCATION"
			},
			{
				"name": "team",
				"salience": 0.0013441449,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.0013223536,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reports",
				"salience": 0.0013223536,
				"type": "OTHER"
			},
			{
				"name": "Indicators & Assessments Unit",
				"salience": 0.0013059817,
				"type": "ORGANIZATION"
			},
			{
				"name": "amphibians",
				"salience": 0.0012785494,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0012737917,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0012615543,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0012299565,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011650341,
				"type": "LOCATION"
			},
			{
				"name": "trends",
				"salience": 0.0011650341,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.0011029703,
				"type": "OTHER"
			},
			{
				"name": "stats",
				"salience": 0.001033817,
				"type": "OTHER"
			},
			{
				"name": "estimate",
				"salience": 0.0009995684,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.0009995684,
				"type": "LOCATION"
			},
			{
				"name": "blender",
				"salience": 0.0009995684,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "extinctions",
				"salience": 0.0009745308,
				"type": "OTHER"
			},
			{
				"name": "vertebrates",
				"salience": 0.00095505134,
				"type": "OTHER"
			},
			{
				"name": "Image copyright",
				"salience": 0.0008622925,
				"type": "OTHER"
			},
			{
				"name": "gaps",
				"salience": 0.0008622925,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0008622925,
				"type": "OTHER"
			},
			{
				"name": "caption",
				"salience": 0.0008622925,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00084471086,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06n3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_America"
				},
				"name": "South America",
				"salience": 0.00084471086,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.00084471086,
				"type": "LOCATION"
			},
			{
				"name": "gaps",
				"salience": 0.00080930314,
				"type": "OTHER"
			},
			{
				"name": "conservation ecology",
				"salience": 0.0007466447,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0007466447,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0007466447,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dzst",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Duke_University"
				},
				"name": "Duke University",
				"salience": 0.00069885934,
				"type": "LOCATION"
			},
			{
				"name": "criticisms",
				"salience": 0.00065769616,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0006362384,
				"type": "LOCATION"
			},
			{
				"name": "SCOTT DICKERSON Image",
				"salience": 0.0006362384,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/92102611_medium_ww211056.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T15:20:34.698+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 19.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "World wildlife ‘falls by 58% in 40 years’ 10/27/2016 \nBBC NEWS Global wildlife populations have fallen by 58% since 1970, a report says. \nThe Living Planet assessment, by the Zoological Society of London (ZSL) and WWF, suggests that if the trend continues that decline could reach two-thirds among vertebrates by 2020. \nThe figures suggest that animals living in lakes, rivers and wetlands are suffering the biggest losses. \nHuman activity, including habitat loss, wildlife trade, pollution and climate change contributed to the declines. \nDr Mike Barrett. head of science and policy at WWF, said: “It’s pretty clear under ‘business as usual’ we will see continued declines in these wildlife populations. But I think now we’ve reached a point where there isn’t really any excuse to let this carry on. \n“We know what the causes are and we know the scale of the impact that humans are having on nature and on wildlife populations – it really is now down to us to act.” \nHowever the methodology of the report has been criticised. Image copyright CARLOS DREWS / WWF Image caption The report looked at data collected on 3,700 species of vertebrates over the last 40 years \nThe Living Planet Report is published every two years and aims to provide an assessment of the state of the world’s wildlife. \nFor freshwater species alone, the decline stands at 81% since 1970 Dr Mike Barrett, WWF \nThis analysis looked at 3,700 different species of birds, fish, mammals, amphibians and reptiles – about 6% of the total number of vertebrate species in the world. \nThe team collected data from peer-reviewed studies, government statistics and surveys collated by conservation groups and NGOs. \nAny species with population data going back to 1970, with two or more time points (to show trends) was included in the study. \nThe researchers then analysed how the population sizes had changed over time. \nSome of this information was weighted to take into account the groups of animals that had a great deal of data (there are many records on Arctic and near Arctic birds, for example) or very little data (tropical amphibians, for example). The report authors said this was to make sure a surplus of information about declines in some animals did not skew the overall picture. \nThe last report, published in 2014, estimated that the world’s wildlife populations had halved over the last 40 years. \nThis assessment suggests that the trend has continued: since 1970, populations have declined by an average of 58%. \nDr Barrett said some groups of animals had fared worse than others. \n“We do see particularly strong declines in the freshwater environment – for freshwater species alone, the decline stands at 81% since 1970. This is related to the way water is used and taken out of fresh water systems, and also the fragmentation of freshwater systems through dam building, for example.” \nIt also highlighted other species, such as African elephants , which have suffered huge declines in recent years with the increase in poaching, and sharks, which are threatened by overfishing. \nIf pressures – overexploitation, illegal wildlife trade for example – increase or worsen, then that trend may be worse Dr Robin Freeman, ZSL \nThe researchers conclude that vertebrate populations are declining by an average of 2% each year, and warn that if nothing is done, wildlife populations could fall by 67% (below 1970 levels) by the end of the decade. \nDr Robin Freeman, head of ZSL’s Indicators & Assessments Unit, said: “But that’s assuming things continue as we expect. If pressures – overexploitation, illegal wildlife trade, for example – increase or worsen, then that trend may be worse. \n“But one of the things I think is most important about these stats, these trends are declines in the number of animals in wildlife populations – they are not extinctions. By and large they are not vanishing, and that presents us with an opportunity to do something about it.” Image copyright SCOTT DICKERSON Image caption There are still many gaps in our knowledge of the world’s vertebrates \nHowever, Living Planet reports have drawn some criticisms. \nThere are some numbers [in the report] that are sensible, but there are some numbers that are very very sketchy Stuart Pimm, Duke University \nStuart Pimm, professor of conservation ecology at Duke University in the United States, said that while wildlife was in decline, there were too many gaps in the data to boil population loss down to a single figure. \n“There are some numbers [in the report] that are sensible, but there are some numbers that are very, very sketchy,” he told BBC News. \n“For example, if you look at where the data comes from, not surprisingly, it is massively skewed towards western Europe. \n“When you go elsewhere, not only do the data become far fewer, but in practice they become much, much sketchier… there is almost nothing from South America, from tropical Africa, there is not much from the tropics, period. Any time you are trying to mix stuff like that, it is is very very hard to know what the numbers mean. \n“They’re trying to pull this stuff in a blender and spew out a single number…. It’s flawed.” \nBut Dr Freeman said the team had taken the best data possible from around the world. \n“It’s completely true that in some regions and in some groups, like tropical amphibians for example, we do have a lack of data. But that’s because there is a lack of data. \n“We’re confident that the method we are using is the best method to present an overall estimate of population decline. \n“It’s entirely possible that species that aren’t being monitored as effectively may be doing much worse – but I’d be very surprised if they were doing much better than we observed. “",
		"thread_title": "World wildlife ‘falls by 58% in 40 years’",
		"title": "World wildlife ‘falls by 58% in 40 years’",
		"type": "bs",
		"uuid": "63749145fb0e6730c71a120b6e061bac5e90d9f5"
	},
	"-KhIh2sbNy1mG8daF5x_": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T15:31:55.537+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "UPLIFT CONNECT Economics",
				"salience": 0.30406472,
				"type": "OTHER"
			},
			{
				"name": "Form",
				"salience": 0.09025666,
				"type": "OTHER"
			},
			{
				"name": "Opinion",
				"salience": 0.07866132,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Economics"
				},
				"name": "Economics",
				"salience": 0.06226261,
				"type": "OTHER"
			},
			{
				"name": "economics",
				"salience": 0.05799328,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01sbk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brain_damage"
				},
				"name": "Brain Damage",
				"salience": 0.04421461,
				"type": "OTHER"
			},
			{
				"name": "Economics",
				"salience": 0.042153817,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.037946884,
				"type": "OTHER"
			},
			{
				"name": "Science",
				"salience": 0.035063755,
				"type": "OTHER"
			},
			{
				"name": "king",
				"salience": 0.027524076,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01jjpg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Real_life"
				},
				"name": "Real World",
				"salience": 0.023535801,
				"type": "WORK_OF_ART"
			},
			{
				"name": "economy",
				"salience": 0.01586309,
				"type": "OTHER"
			},
			{
				"name": "scientist",
				"salience": 0.015536019,
				"type": "PERSON"
			},
			{
				"name": "economics",
				"salience": 0.013468624,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.011569044,
				"type": "OTHER"
			},
			{
				"name": "Everyone",
				"salience": 0.011139579,
				"type": "PERSON"
			},
			{
				"name": "science",
				"salience": 0.010380936,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.010373723,
				"type": "OTHER"
			},
			{
				"name": "economics",
				"salience": 0.009462124,
				"type": "OTHER"
			},
			{
				"name": "geneticist",
				"salience": 0.00933586,
				"type": "PERSON"
			},
			{
				"name": "broadcaster",
				"salience": 0.00933586,
				"type": "ORGANIZATION"
			},
			{
				"name": "activist",
				"salience": 0.00933586,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.00933586,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.008413483,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.008413483,
				"type": "LOCATION"
			},
			{
				"name": "earth",
				"salience": 0.007627766,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01346x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Suzuki"
				},
				"name": "David Suzuki",
				"salience": 0.0062933536,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.0062311343,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.005112304,
				"type": "OTHER"
			},
			{
				"name": "brain damage",
				"salience": 0.00479889,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0045856405,
				"type": "OTHER"
			},
			{
				"name": "Money",
				"salience": 0.0034970294,
				"type": "OTHER"
			},
			{
				"name": "equations",
				"salience": 0.0031063969,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0031063969,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/Screen-shot-2013-08-09-at-8.01.03-AM.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T15:31:55.537+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Opinion: Economics is a Form of Brain Damage 10/27/2016 \nUPLIFT CONNECT \nEconomics is Not a Science and is Not Based in the Real World \nIn today’s world, economics is king. Everyone’s talking money and economy, yet none of it is actually even real. \nAward winning scientist, author, environmental activist, broadcaster, and geneticist, David Suzuki, gives us the thought provoking truth about economics. \n“Economics is not a science – it doesn’t even include the earth in its equations. Economics is not based in anything like the real world.” \n“Money now grows faster than the real world and economics is so fundamentally disconnected from the real world that it is destructive.” \nHere David Suzuki explains how conventional economics is a form of brain damage.",
		"thread_title": "Opinion: Economics is a Form of Brain Damage",
		"title": "Opinion: Economics is a Form of Brain Damage",
		"type": "bs",
		"uuid": "5980cc03781907c4da2d6f247b97f9d9938420c8"
	},
	"-KhIh36V7oYKbF__uydj": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T15:31:55.575+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "thoughts",
				"salience": 0.083295204,
				"type": "OTHER"
			},
			{
				"name": "Computers",
				"salience": 0.05290791,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Christian Herff",
				"salience": 0.045222893,
				"type": "PERSON"
			},
			{
				"name": "Voice-recognition technology",
				"salience": 0.044692732,
				"type": "OTHER"
			},
			{
				"name": "MIND",
				"salience": 0.028323237,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.023816066,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Computers",
				"salience": 0.023421932,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "signals",
				"salience": 0.023131337,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.020300929,
				"type": "OTHER"
			},
			{
				"name": "text",
				"salience": 0.019986246,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.019890051,
				"type": "ORGANIZATION"
			},
			{
				"name": "activity",
				"salience": 0.016609777,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.016401505,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.015795656,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.014524305,
				"type": "OTHER"
			},
			{
				"name": "typing",
				"salience": 0.014459707,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6d3h6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Siri"
				},
				"name": "Siri",
				"salience": 0.01413951,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.013529186,
				"type": "OTHER"
			},
			{
				"name": "epilepsy patients",
				"salience": 0.013147122,
				"type": "PERSON"
			},
			{
				"name": "computers",
				"salience": 0.012705604,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "speech",
				"salience": 0.01260217,
				"type": "EVENT"
			},
			{
				"name": "Tanja Schultz",
				"salience": 0.011567673,
				"type": "PERSON"
			},
			{
				"name": "device",
				"salience": 0.01030897,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "scientists",
				"salience": 0.010235326,
				"type": "PERSON"
			},
			{
				"name": "Andrew Anderson",
				"salience": 0.010000867,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.00945773,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.00945773,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "kind",
				"salience": 0.009174004,
				"type": "OTHER"
			},
			{
				"name": "brain activity",
				"salience": 0.009056677,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.008914208,
				"type": "ORGANIZATION"
			},
			{
				"name": "science fiction",
				"salience": 0.008541519,
				"type": "OTHER"
			},
			{
				"name": "speech interfaces",
				"salience": 0.008541519,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.008541519,
				"type": "OTHER"
			},
			{
				"name": "patients",
				"salience": 0.008385474,
				"type": "PERSON"
			},
			{
				"name": "Hackers",
				"salience": 0.007920108,
				"type": "PERSON"
			},
			{
				"name": "patients",
				"salience": 0.0076250657,
				"type": "PERSON"
			},
			{
				"name": "capabilities",
				"salience": 0.0073985145,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0073985145,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0072509437,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.0071822586,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.006613928,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.0063328254,
				"type": "PERSON"
			},
			{
				"name": "method",
				"salience": 0.005736006,
				"type": "OTHER"
			},
			{
				"name": "brain imaging techniques",
				"salience": 0.0056521674,
				"type": "OTHER"
			},
			{
				"name": "imaging",
				"salience": 0.005276607,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0051977006,
				"type": "EVENT"
			},
			{
				"name": "texts",
				"salience": 0.0050383764,
				"type": "WORK_OF_ART"
			},
			{
				"name": "database",
				"salience": 0.00460103,
				"type": "OTHER"
			},
			{
				"name": "imaging",
				"salience": 0.004475492,
				"type": "OTHER"
			},
			{
				"name": "pros",
				"salience": 0.0044294517,
				"type": "PERSON"
			},
			{
				"name": "scientists",
				"salience": 0.0042195804,
				"type": "PERSON"
			},
			{
				"name": "brain",
				"salience": 0.0042068306,
				"type": "OTHER"
			},
			{
				"name": "brains",
				"salience": 0.0042068306,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.0038984264,
				"type": "WORK_OF_ART"
			},
			{
				"name": "technologies",
				"salience": 0.003768496,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.003631758,
				"type": "OTHER"
			},
			{
				"name": "BRAIN",
				"salience": 0.0035679433,
				"type": "OTHER"
			},
			{
				"name": "brain",
				"salience": 0.0035679433,
				"type": "OTHER"
			},
			{
				"name": "science fiction",
				"salience": 0.0035201472,
				"type": "OTHER"
			},
			{
				"name": "realms",
				"salience": 0.0035201472,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0035201472,
				"type": "PERSON"
			},
			{
				"name": "journal",
				"salience": 0.0035201472,
				"type": "WORK_OF_ART"
			},
			{
				"name": "speech",
				"salience": 0.0035095084,
				"type": "EVENT"
			},
			{
				"name": "speech",
				"salience": 0.0035095084,
				"type": "EVENT"
			},
			{
				"name": "computer program",
				"salience": 0.0034628047,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.003365857,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026fzr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Traction_control_system"
				},
				"name": "ASR",
				"salience": 0.0032548422,
				"type": "OTHER"
			},
			{
				"name": "screen",
				"salience": 0.0032412906,
				"type": "OTHER"
			},
			{
				"name": "technologies",
				"salience": 0.0031961084,
				"type": "OTHER"
			},
			{
				"name": "HACKERS",
				"salience": 0.0031428922,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.003092928,
				"type": "PERSON"
			},
			{
				"name": "lunch",
				"salience": 0.003048418,
				"type": "OTHER"
			},
			{
				"name": "motor function",
				"salience": 0.003048418,
				"type": "OTHER"
			},
			{
				"name": "speech difficulties",
				"salience": 0.003048418,
				"type": "OTHER"
			},
			{
				"name": "brain-computer interfaces",
				"salience": 0.0030235234,
				"type": "OTHER"
			},
			{
				"name": "stock image",
				"salience": 0.0028545682,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.0028545682,
				"type": "WORK_OF_ART"
			},
			{
				"name": "neurons",
				"salience": 0.0028487812,
				"type": "OTHER"
			},
			{
				"name": "neurons",
				"salience": 0.0028487812,
				"type": "OTHER"
			},
			{
				"name": "text",
				"salience": 0.0028487812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g0t_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cerebral_cortex"
				},
				"name": "Cerebral Cortex",
				"salience": 0.002737857,
				"type": "WORK_OF_ART"
			},
			{
				"name": "electrocorticography",
				"salience": 0.0027338795,
				"type": "OTHER"
			},
			{
				"name": "brain activity",
				"salience": 0.0027134456,
				"type": "OTHER"
			},
			{
				"name": "technique",
				"salience": 0.0026764404,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.0026318694,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0026318694,
				"type": "OTHER"
			},
			{
				"name": "authors",
				"salience": 0.0025740643,
				"type": "PERSON"
			},
			{
				"name": "authors",
				"salience": 0.0024780128,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0024685091,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0024685091,
				"type": "OTHER"
			},
			{
				"name": "screen",
				"salience": 0.0024685091,
				"type": "OTHER"
			},
			{
				"name": "neurons",
				"salience": 0.0024159763,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0023878664,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0023763934,
				"type": "PERSON"
			},
			{
				"name": "Experts",
				"salience": 0.002365782,
				"type": "PERSON"
			},
			{
				"name": "sentence",
				"salience": 0.0023610059,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0023577863,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00233598,
				"type": "OTHER"
			},
			{
				"name": "hackers",
				"salience": 0.0022319949,
				"type": "PERSON"
			},
			{
				"name": "variety",
				"salience": 0.0022319949,
				"type": "OTHER"
			},
			{
				"name": "Frontiers in Human Neuroscience",
				"salience": 0.0021671334,
				"type": "ORGANIZATION"
			},
			{
				"name": "speech elements",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "grids",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "algorithms",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "dictionary",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "patterns",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "phones",
				"salience": 0.0021376098,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "language",
				"salience": 0.0021376098,
				"type": "OTHER"
			},
			{
				"name": "models",
				"salience": 0.0021376098,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "brain signals",
				"salience": 0.0021326356,
				"type": "OTHER"
			},
			{
				"name": "authors",
				"salience": 0.0021014987,
				"type": "PERSON"
			},
			{
				"name": "both",
				"salience": 0.0020578334,
				"type": "PERSON"
			},
			{
				"name": "cons",
				"salience": 0.0020578334,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.0019169901,
				"type": "OTHER"
			},
			{
				"name": "sentences",
				"salience": 0.0018676849,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0018473022,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.0017614196,
				"type": "OTHER"
			},
			{
				"name": "degree",
				"salience": 0.0017451257,
				"type": "OTHER"
			},
			{
				"name": "brands",
				"salience": 0.0017451257,
				"type": "ORGANIZATION"
			},
			{
				"name": "apps",
				"salience": 0.0017451257,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "reaction",
				"salience": 0.0017451257,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0017451257,
				"type": "OTHER"
			},
			{
				"name": "pop-up",
				"salience": 0.0017451257,
				"type": "OTHER"
			},
			{
				"name": "logos",
				"salience": 0.0017451257,
				"type": "WORK_OF_ART"
			},
			{
				"name": "accuracy",
				"salience": 0.0017451257,
				"type": "OTHER"
			},
			{
				"name": "thought-detection device",
				"salience": 0.001667428,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "electrodes",
				"salience": 0.001667428,
				"type": "OTHER"
			},
			{
				"name": "imaging",
				"salience": 0.0015532913,
				"type": "OTHER"
			},
			{
				"name": "milestone",
				"salience": 0.0015179265,
				"type": "EVENT"
			},
			{
				"name": "brain",
				"salience": 0.0014505079,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.001413031,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Washington"
				},
				"name": "University of Washington",
				"salience": 0.0013738762,
				"type": "ORGANIZATION"
			},
			{
				"name": "study",
				"salience": 0.0013612349,
				"type": "OTHER"
			},
			{
				"name": "phrases",
				"salience": 0.0013036561,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0013036561,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0013036561,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0013036561,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fhr05",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Karlsruhe_Institute_of_Technology"
				},
				"name": "Karlsruhe Institute of Technology",
				"salience": 0.0012666456,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.0012235598,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0012144101,
				"type": "OTHER"
			},
			{
				"name": "brain activity",
				"salience": 0.0012053287,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.0011603322,
				"type": "WORK_OF_ART"
			},
			{
				"name": "work",
				"salience": 0.00106424,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.001037585,
				"type": "OTHER"
			},
			{
				"name": "MRI",
				"salience": 0.0010033308,
				"type": "OTHER"
			},
			{
				"name": "stroke",
				"salience": 0.00094943953,
				"type": "EVENT"
			},
			{
				"name": "brain scans",
				"salience": 0.00094943953,
				"type": "OTHER"
			},
			{
				"name": "resonance",
				"salience": 0.00094943953,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.00094943953,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0009187362,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vfj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Rochester"
				},
				"name": "University of Rochester",
				"salience": 0.00091215037,
				"type": "ORGANIZATION"
			},
			{
				"name": "method",
				"salience": 0.0009071574,
				"type": "OTHER"
			},
			{
				"name": "electrodes",
				"salience": 0.0009071574,
				"type": "OTHER"
			},
			{
				"name": "MRI",
				"salience": 0.0008508203,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.00081905455,
				"type": "OTHER"
			},
			{
				"name": "government officials",
				"salience": 0.00081905455,
				"type": "PERSON"
			},
			{
				"name": "game",
				"salience": 0.00081905455,
				"type": "OTHER"
			},
			{
				"name": "video game users",
				"salience": 0.0008153953,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.00076872454,
				"type": "PERSON"
			},
			{
				"name": "lie detector test",
				"salience": 0.0007092103,
				"type": "OTHER"
			},
			{
				"name": "criminals",
				"salience": 0.0007092103,
				"type": "PERSON"
			},
			{
				"name": "customers",
				"salience": 0.0007092103,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0007092103,
				"type": "OTHER"
			},
			{
				"name": "advertisers",
				"salience": 0.0007092103,
				"type": "ORGANIZATION"
			},
			{
				"name": "cap",
				"salience": 0.0007092103,
				"type": "OTHER"
			},
			{
				"name": "stress levels",
				"salience": 0.0007092103,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0007092103,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/39BAD89B00000578-0-image-a-1_1477473629093.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T15:31:55.575+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Computers that can read your MIND and convert your thoughts 10/27/2016 \nTHE DAILY MAIL Voice-recognition technology can be useful for dictating text when you have no way of typing. But computers could soon be able to decode your thoughts into actual speech or written words, without you even saying a word. This kind of technology sounds like science fiction, but there are a variety of ways scientists are edging towards making it a reality, according to a new review. Computers that can read our minds might enhance the capabilities of already existing speech interfaces with devices, like Siri and Ok Google. But it could be even more important for those with speech difficulties, and even more so for patients who lack any speech or motor function at all. ‘So instead of saying “Siri, what is the weather like today” or “Ok Google, where can I go for lunch?” I just imagine saying these things,’ said Christian Herff, author of a review recently published in the journal Frontiers in Human Neuroscience . Reading someone’s thoughts might still belong to the realms of science fiction, but scientists are already decoding speech from signals generated in our brains when we speak or listen to someone talking. In the new study, Mr Herff and co-author Dr Tanja Schultz, both from the Karlsruhe Institute of Technology, compared the pros and cons of using various brain imaging techniques to take neural signals from the brain and decode them to text. There are a variety of technologies out there, the authors said, including functional MRI and near infrared imaging that detect neural signals based on the metabolic activity of neurons. Another method can detect electromagnetic activity of neurons responding to speech. But there was one method in particular, called electrocorticography, which stood out in the new review, the authors said. This technique uses a brain-to-text system. demonstrated on epilepsy patients who already had electrode grids implanted for treatment of their condition. The patients read out texts presented on a screen in front of them while their brain activity was recorded. This formed the basis of a database of patterns of neural signals that could now be matched to speech elements or ‘phones’. When the researchers included language and dictionary models in their algorithms, they were able to decode neural signals to text with a high degree of accuracy. There are a variety of technologies out there, the authors said, including functional MRI (stock image pictured) and near infrared imaging that detect neural signals based on the metabolic activity of neurons COULD HACKERS GET INSIDE YOUR BRAIN? Experts at the University of Washington have revealed how hackers could inserting images into dodgy apps and recording our brain’s unintentional reaction using brain-computer interfaces. For example, when playing a video game users may see logos of familiar brands pop-up on the screen that just vanish. Hackers put those images in the game and they were recording your ‘brain’s unintentional response to them’ using a BCI, which can be a wearable device that monitors stress levels or a cap covered in electrodes. This technology could one day be used by advertisers to gather more information about their customers. Also, police officers and government officials could use this method to convict criminals or as a ‘remote lie detector test’. ‘For the first time, we could show that brain activity can be decoded specifically enough to use ASR (automated speech recognition) technology on brain signals,’ said Mr Herff. ‘However, the current need for implanted electrodes renders it far from usable in day-to-day life.’ To go from here to a functioning thought-detection device will still require some work. ‘A first milestone would be to actually decode imagined phrases from brain activity, but a lot of technical issues need to be solved for that,’ said Herff. Earlier this year researchers at the University of Rochester revealed a computer program that searches for the brain activity related to certain words and then use this to predict a sentence being thought, even it hasn’t seen it before. They said the system is able to get the predictions right around 70 per cent of the time. Dr Andrew Anderson, a research fellow at the University of Rochester who led the study, said the technology could be used to help people who have suffered from a stroke to communicate. The researchers, whose study was published in the journal Cerebral Cortex, used brain scans taken with functional magnetic resonance imaging from 14 participants as they silently read 240 unique sentences.",
		"thread_title": "Computers that can read your MIND and convert your thoughts",
		"title": "Computers that can read your MIND and convert your thoughts",
		"type": "bs",
		"uuid": "3b37694bd5b91c2111b9c18ff3fcf0095f7e2a77"
	},
	"-KhIh3NJm3EXTKr0qf1U": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T15:40:06.051+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02ys79",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reed_Hastings"
				},
				"name": "Reed Hastings",
				"salience": 0.21005398,
				"type": "PERSON"
			},
			{
				"name": "TV",
				"salience": 0.14868243,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.13777392,
				"type": "ORGANIZATION"
			},
			{
				"name": "drugs",
				"salience": 0.034570355,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "future",
				"salience": 0.028909093,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.026492152,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.025075544,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.025075544,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.022088973,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dq_5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chief_executive_officer"
				},
				"name": "Ceo",
				"salience": 0.016095668,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.01594858,
				"type": "OTHER"
			},
			{
				"name": "Hallucination Pills 10",
				"salience": 0.015498819,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.01497501,
				"type": "OTHER"
			},
			{
				"name": "streaming services",
				"salience": 0.014853427,
				"type": "OTHER"
			},
			{
				"name": "streaming TV company",
				"salience": 0.014853427,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0mgkg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amazon.com"
				},
				"name": "Amazon",
				"salience": 0.009841742,
				"type": "ORGANIZATION"
			},
			{
				"name": "something",
				"salience": 0.009769265,
				"type": "OTHER"
			},
			{
				"name": "drug",
				"salience": 0.009171316,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "experiences",
				"salience": 0.008868639,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.008103991,
				"type": "OTHER"
			},
			{
				"name": "opera",
				"salience": 0.00806791,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0071689677,
				"type": "PERSON"
			},
			{
				"name": "version",
				"salience": 0.006932163,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "TV screen",
				"salience": 0.006213954,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0061358362,
				"type": "PERSON"
			},
			{
				"name": "entertainments",
				"salience": 0.0061358362,
				"type": "WORK_OF_ART"
			},
			{
				"name": "trouble",
				"salience": 0.0060714474,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.006058697,
				"type": "PERSON"
			},
			{
				"name": "boss",
				"salience": 0.005842973,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.005781826,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.005338557,
				"type": "OTHER"
			},
			{
				"name": "novel",
				"salience": 0.0053147585,
				"type": "WORK_OF_ART"
			},
			{
				"name": "films",
				"salience": 0.0053147585,
				"type": "WORK_OF_ART"
			},
			{
				"name": "TV shows",
				"salience": 0.0053147585,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cinema",
				"salience": 0.0053147585,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0hhs506",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Mirror_(TV_series)"
				},
				"name": "Black Mirror",
				"salience": 0.005268781,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.004763756,
				"type": "EVENT"
			},
			{
				"name": "gaming",
				"salience": 0.004623943,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.004589424,
				"type": "OTHER"
			},
			{
				"name": "pill",
				"salience": 0.004488746,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0044516106,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.004304888,
				"type": "OTHER"
			},
			{
				"name": "blue pill",
				"salience": 0.0042133788,
				"type": "OTHER"
			},
			{
				"name": "screen",
				"salience": 0.0041444246,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0041444246,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0041444246,
				"type": "EVENT"
			},
			{
				"name": "hallucination",
				"salience": 0.0038928576,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0038928576,
				"type": "OTHER"
			},
			{
				"name": "challenges",
				"salience": 0.0036351455,
				"type": "OTHER"
			},
			{
				"name": "Both",
				"salience": 0.003611628,
				"type": "PERSON"
			},
			{
				"name": "anywhere",
				"salience": 0.003589393,
				"type": "LOCATION"
			},
			{
				"name": "pill",
				"salience": 0.0034843965,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0034273537,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0032580157,
				"type": "OTHER"
			},
			{
				"name": "hallucination",
				"salience": 0.002908958,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0028215414,
				"type": "OTHER"
			},
			{
				"name": "arguments",
				"salience": 0.0028032807,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_ny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virtual_reality"
				},
				"name": "VR",
				"salience": 0.0023547658,
				"type": "OTHER"
			},
			{
				"name": "tech billionaires",
				"salience": 0.0022747181,
				"type": "PERSON"
			},
			{
				"name": "universe",
				"salience": 0.0022747181,
				"type": "OTHER"
			},
			{
				"name": "virtual reality world",
				"salience": 0.0022747181,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.0022101775,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07cz2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Matrix"
				},
				"name": "The Matrix",
				"salience": 0.0021292516,
				"type": "WORK_OF_ART"
			},
			{
				"name": "companies",
				"salience": 0.0019134034,
				"type": "ORGANIZATION"
			},
			{
				"name": "drugs",
				"salience": 0.0016920848,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "source",
				"salience": 0.0015950958,
				"type": "OTHER"
			},
			{
				"name": "references",
				"salience": 0.0015820661,
				"type": "OTHER"
			},
			{
				"name": "human entertainment",
				"salience": 0.0014294736,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kx06l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sam_Altman"
				},
				"name": "Sam Altman",
				"salience": 0.0014003398,
				"type": "PERSON"
			},
			{
				"name": "normality",
				"salience": 0.0012378293,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.0008678776,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03nzf1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elon_Musk"
				},
				"name": "Elon Musk",
				"salience": 0.0005911865,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/gettyimages-455692374.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T15:40:06.051+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Netflix Ceo: TV’s Future includes Hallucination Pills 10/27/2016 \nINDEPENDENT \nThe future of TV might everyone taking hallucinogenic drugs, according to the head of Netflix. \nThe threats to the streaming TV company might not be Amazon or other streaming services, but instead “pharmacological” ways of entertaining people, Reed Hastings has said. \nAnd just as films and TV shows are a supposedly improved version of other entertainments, those same things might eventually become defunct, he said. In the same way that the cinema and TV screen made “the opera and the novel” much smaller, something else might be on the way to do the same thing, the Netflix boss said at a Wall Street Journal event. \nThose challenges could come from anywhere, he said. They might not be another form of screen: “Is it VR, is it gaming, is it pharmacological?” Mr Hastings asked the event. \nHe went on to say that it might be possible that in the coming years someone will develop a drug that will make people get the same experiences that at the moment come from streaming services like Netflix. Apparently making reference to The Matrix, he said that we might be able to take one pill to escape into a hallucination and then another to come back. \n“In twenty or fifty years, taking a personalized blue pill you just hallucinate in an entertaining way and then a white pill brings you back to normality is perfectly viable,” Mr Hastings said. “And if the source of human entertainment in thirty or forty years is pharmacological we’ll be in real trouble.” \nHis references to The Matrix – and to being in “trouble” – recall arguments that have recently been made by tech billionaires including Elon Musk and Sam Altman. Both have suggested that it might be possible that we are part of a simulated universe – something that they said might be part of a virtual reality world, but could just as easily be the result of a drug-induced hallucination. \nMr Hastings didn’t indicate whether or not Netflix would look to make such drugs itself, or how it would fend off any companies that did. But it does sound a little like something out Black Mirror, which Netflix is showing the new season of at the moment.",
		"thread_title": "Netflix Ceo: TV’s Future includes Hallucination Pills",
		"title": "Netflix Ceo: TV’s Future includes Hallucination Pills",
		"type": "bs",
		"uuid": "83c8e398f090bf1c63481010f3a51be719831cff"
	},
	"-KhIh4OV8bEBAk4E8YpJ": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T15:48:52.100+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.5353544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.07052209,
				"type": "PERSON"
			},
			{
				"name": "Elections",
				"salience": 0.036289994,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.036289994,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.03161454,
				"type": "OTHER"
			},
			{
				"name": "plethora",
				"salience": 0.029154548,
				"type": "OTHER"
			},
			{
				"name": "REVOLT",
				"salience": 0.02147669,
				"type": "EVENT"
			},
			{
				"name": "TRUTH",
				"salience": 0.02147669,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.02147669,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.019240027,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.018739754,
				"type": "EVENT"
			},
			{
				"name": "notion",
				"salience": 0.009003968,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.008601595,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0068394057,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0068111247,
				"type": "LOCATION"
			},
			{
				"name": "Freedom Center",
				"salience": 0.006678294,
				"type": "ORGANIZATION"
			},
			{
				"name": "notion",
				"salience": 0.005264838,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.005264838,
				"type": "WORK_OF_ART"
			},
			{
				"name": "elections",
				"salience": 0.005248962,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.005248962,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.005108895,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00496582,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.004560677,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.004560677,
				"type": "OTHER"
			},
			{
				"name": "darnedest",
				"salience": 0.004560677,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.004560677,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0044531655,
				"type": "EVENT"
			},
			{
				"name": "Video",
				"salience": 0.0035567973,
				"type": "WORK_OF_ART"
			},
			{
				"name": "elections",
				"salience": 0.003328571,
				"type": "EVENT"
			},
			{
				"name": "campaign question",
				"salience": 0.0031998921,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0031998921,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.0031998921,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0030806279,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0030806279,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.0028096535,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidates",
				"salience": 0.0027282757,
				"type": "PERSON"
			},
			{
				"name": "machines",
				"salience": 0.0026130176,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "elections",
				"salience": 0.002425297,
				"type": "EVENT"
			},
			{
				"name": "parties",
				"salience": 0.0022546013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0022086867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.0019706623,
				"type": "LOCATION"
			},
			{
				"name": "defenders",
				"salience": 0.0019525447,
				"type": "PERSON"
			},
			{
				"name": "social contract",
				"salience": 0.0019525447,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0019525447,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0018189803,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.001742093,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0016424612,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaigns",
				"salience": 0.0016424612,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.0016089999,
				"type": "LOCATION"
			},
			{
				"name": "results",
				"salience": 0.0014223398,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0014223398,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0014223398,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0014223398,
				"type": "OTHER"
			},
			{
				"name": "outset",
				"salience": 0.0014223398,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0012021082,
				"type": "LOCATION"
			},
			{
				"name": "tendency",
				"salience": 0.001161232,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0010626193,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0010626193,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0010626193,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/Obama4.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T15:48:52.100+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Obama Admits to Rigged Elections back in 2008 10/27/2016 \nTRUTH REVOLT \nThere’s a lot of accusations going around that the 2016 election is rigged. From Democrats suggesting Russia is tampering with the presidential election to a plethora of documents and undercover video that proves Democrats are trying their darnedest to sway the outcome. \nPresident Obama has laughed off the notion that Bernie Sanders was forced out by the DNC and believes Donald Trump is out of his mind for suggesting elections are rigged. And of course, Obama would never admit that Hillary Clinton could do something wrong. But candidate Obama, in 2008, sure was concerned that the election might be rigged against him. \nVideo of him answering a campaign question has surfaced to put to rest the notion that he doesn’t believe in the possibility: \n“Well, I tell you what: it helps in Ohio that we’ve got Democrats in charge of the machines. [Cheering] But look, I come from Chicago, so I want to be honest, it’s not as if it’s just Republicans who have monkeyed around with elections in the past, sometimes Democrats have too. You know, whenever people are in power, they’re — you know, they have this tendency to try to, you know, tilt things in their direction.” \nWatch above. \nThe Freedom Center is a 501c3 non-profit organization. Therefore we do not endorse political candidates either in primary or general elections. However, as defenders of America’s social contract, we insist that the rules laid down by both parties at the outset of campaigns be respected, and that the results be decided by free elections. We will oppose any attempt to rig the system and deny voters of either party their constitutional right to elect candidates of their choice.",
		"thread_title": "Obama Admits to Rigged Elections back in 2008",
		"title": "Obama Admits to Rigged Elections back in 2008",
		"type": "bs",
		"uuid": "4cb47587a044823fdfe1e62a45ca8fdbce8b0093"
	},
	"-KhIh4_gqUpYF3dbZuXa": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:35:13.475+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Proof of Life Video",
				"salience": 0.15978976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.15978976,
				"type": "PERSON"
			},
			{
				"name": "FAKE",
				"salience": 0.14897628,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.08650789,
				"type": "WORK_OF_ART"
			},
			{
				"name": "TV",
				"salience": 0.06739114,
				"type": "OTHER"
			},
			{
				"name": "AMTV",
				"salience": 0.050758366,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.03899513,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.03030636,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tube",
				"salience": 0.022786109,
				"type": "OTHER"
			},
			{
				"name": "attorney",
				"salience": 0.022786109,
				"type": "PERSON"
			},
			{
				"name": "TRUMP",
				"salience": 0.0203421,
				"type": "OTHER"
			},
			{
				"name": "TRUTH",
				"salience": 0.018622918,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.018622918,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.018622918,
				"type": "OTHER"
			},
			{
				"name": "REVOLT",
				"salience": 0.018622918,
				"type": "EVENT"
			},
			{
				"name": "Julians",
				"salience": 0.017962147,
				"type": "PERSON"
			},
			{
				"name": "future",
				"salience": 0.016076874,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.013929125,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.013040922,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hallucination Pills 10",
				"salience": 0.010974148,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.010154571,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "head",
				"salience": 0.010154571,
				"type": "PERSON"
			},
			{
				"name": "thr",
				"salience": 0.010154571,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.009776435,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0zg6dwl"
				},
				"name": "Ceo",
				"salience": 0.0048559643,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/julian333.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T05:35:13.475+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Julian Assange Proof of Life Video a FAKE 10/27/2016 In today’s video, Christopher Greene of AMTV reports on a fake Julian Assange Proof of Life Video. 09/27/2016 Jump 4 TRUMP \nI saw a video on you tube today stating that Julians’ attorney was murdered a couple days ago. Follow AMTV! 10/27/2016 TRUTH REVOLT http://youtu.be/PsVNKmb6jEc There’s a lot of accusations going around that the 2016 election is r ... Netflix Ceo: TV’s Future includes Hallucination Pills 10/27/2016 INDEPENDENT The future of TV might everyone taking hallucinogenic drugs, according to the head of Netflix. The thr ...",
		"thread_title": "Julian Assange Proof of Life Video a FAKE",
		"title": "Julian Assange Proof of Life Video a FAKE",
		"type": "bs",
		"uuid": "383cb0f482152ed519a837daa8352bf3007e979e"
	},
	"-KhIh4fdQuV2B04RPFIh": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:35:13.555+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Alex Jones Declares Trump Landslide Victory",
				"salience": 0.1547007,
				"type": "WORK_OF_ART"
			},
			{
				"name": "TV",
				"salience": 0.11215561,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.10476808,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.06512152,
				"type": "PERSON"
			},
			{
				"name": "AMTV",
				"salience": 0.06512152,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0z6rwt7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Landslide_victory"
				},
				"name": "Landslide Victory",
				"salience": 0.05093582,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.05093582,
				"type": "PERSON"
			},
			{
				"name": "Alex Jones Prediction",
				"salience": 0.044178057,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.040092777,
				"type": "EVENT"
			},
			{
				"name": "accusations",
				"salience": 0.038127694,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.038127694,
				"type": "OTHER"
			},
			{
				"name": "TRUTH",
				"salience": 0.038127694,
				"type": "OTHER"
			},
			{
				"name": "REVOLT",
				"salience": 0.038127694,
				"type": "EVENT"
			},
			{
				"name": "future",
				"salience": 0.026923215,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.02333258,
				"type": "PERSON"
			},
			{
				"name": "drugs",
				"salience": 0.02333258,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.021847123,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0zg6dwl"
				},
				"name": "Ceo",
				"salience": 0.019985437,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.017017683,
				"type": "PERSON"
			},
			{
				"name": "thr",
				"salience": 0.017017683,
				"type": "OTHER"
			},
			{
				"name": "Hallucination Pills 10",
				"salience": 0.010023011,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/alexjones.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T05:35:13.555+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Alex Jones Declares Trump Landslide Victory 10/27/2016 In today’s video, Christopher Greene of AMTV reports on Alex Jones Prediction of a Donald Trump Landslide Victory. 10/27/2016 TRUTH REVOLT http://youtu.be/PsVNKmb6jEc There’s a lot of accusations going around that the 2016 election is r ... Netflix Ceo: TV’s Future includes Hallucination Pills 10/27/2016 INDEPENDENT The future of TV might everyone taking hallucinogenic drugs, according to the head of Netflix. The thr ...",
		"thread_title": "Alex Jones Declares Trump Landslide Victory",
		"title": "Alex Jones Declares Trump Landslide Victory",
		"type": "bs",
		"uuid": "3354cc972ffe95bbd7d26dc6553e1a07b85eee4e"
	},
	"-KhIh4mJOob6dllJr9wT": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T20:50:44.675+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "REVOLT",
				"salience": 0.20716433,
				"type": "EVENT"
			},
			{
				"name": "TRUTH",
				"salience": 0.20716433,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.17084596,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.08977531,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.08977531,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.07846203,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.03766403,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0zg6dwl"
				},
				"name": "Ceo",
				"salience": 0.021143284,
				"type": "PERSON"
			},
			{
				"name": "drugs",
				"salience": 0.02017449,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "head",
				"salience": 0.02017449,
				"type": "PERSON"
			},
			{
				"name": "Hallucination Pills 10",
				"salience": 0.019203968,
				"type": "OTHER"
			},
			{
				"name": "thr",
				"salience": 0.014724651,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.012712658,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.011015144,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/^0D29765E4958FD15368E12279A8B01FE43A543001974A1F2CF^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T20:50:44.675+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "10/27/2016 TRUTH REVOLT http://youtu.be/PsVNKmb6jEc There’s a lot of accusations going around that the 2016 election is r ... Netflix Ceo: TV’s Future includes Hallucination Pills 10/27/2016 INDEPENDENT The future of TV might everyone taking hallucinogenic drugs, according to the head of Netflix. The thr ...",
		"thread_title": "Julian Assange PREDICTS Trump Will Lose – Still Missing Day 12",
		"title": "Julian Assange PREDICTS Trump Will Lose – Still Missing Day 12",
		"type": "bs",
		"uuid": "deb51b419520624095171db43ceba435cd3cd1a6"
	},
	"-KhIh4wA_L0KazGT1dmn": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T20:50:45.635+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.2531765,
				"type": "PERSON"
			},
			{
				"name": "TV",
				"salience": 0.10797162,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.100859694,
				"type": "WORK_OF_ART"
			},
			{
				"name": "AMTV",
				"salience": 0.06269215,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.06269215,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07qhbjh"
				},
				"name": "Rants",
				"salience": 0.04252999,
				"type": "OTHER"
			},
			{
				"name": "Complacent Mainstream Media",
				"salience": 0.04252999,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.03859711,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.036705334,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.036705334,
				"type": "OTHER"
			},
			{
				"name": "TRUTH",
				"salience": 0.036705334,
				"type": "OTHER"
			},
			{
				"name": "REVOLT",
				"salience": 0.036705334,
				"type": "EVENT"
			},
			{
				"name": "future",
				"salience": 0.02591884,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.022462154,
				"type": "PERSON"
			},
			{
				"name": "drugs",
				"salience": 0.022462154,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.021032112,
				"type": "ORGANIZATION"
			},
			{
				"name": "head",
				"salience": 0.016382834,
				"type": "PERSON"
			},
			{
				"name": "thr",
				"salience": 0.016382834,
				"type": "OTHER"
			},
			{
				"name": "Hallucination Pills 10",
				"salience": 0.009649101,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0zg6dwl"
				},
				"name": "Ceo",
				"salience": 0.007839414,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/^A936D279204D3BBADFE465ED506B7022CACC5595D7E47FFA12^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T20:50:45.635+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Julian Assange October Surprise REVEALED 10/28/2016 In today’s video, Christopher Greene of AMTV reports on the Julian Assange October Surprise & Rants about a Complacent Mainstream Media. 10/27/2016 TRUTH REVOLT http://youtu.be/PsVNKmb6jEc There’s a lot of accusations going around that the 2016 election is r ... Netflix Ceo: TV’s Future includes Hallucination Pills 10/27/2016 INDEPENDENT The future of TV might everyone taking hallucinogenic drugs, according to the head of Netflix. The thr ...",
		"thread_title": "Julian Assange October Surprise REVEALED",
		"title": "Julian Assange October Surprise REVEALED",
		"type": "bs",
		"uuid": "bd52102dd9d9fe8760e28754f0297eb0709ddfcd"
	},
	"-KhIh51itv7XdPZio_Gs": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T05:04:39.748+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08rp_m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bombshell_(sex_symbol)"
				},
				"name": "BOMBSHELL",
				"salience": 0.14126833,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Investigation",
				"salience": 0.11787153,
				"type": "EVENT"
			},
			{
				"name": "TV",
				"salience": 0.102287084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.09527516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.073332295,
				"type": "ORGANIZATION"
			},
			{
				"name": "video",
				"salience": 0.04931913,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.03648643,
				"type": "EVENT"
			},
			{
				"name": "somebody",
				"salience": 0.035580087,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.03469607,
				"type": "OTHER"
			},
			{
				"name": "TRUTH",
				"salience": 0.03469607,
				"type": "OTHER"
			},
			{
				"name": "REVOLT",
				"salience": 0.03469607,
				"type": "EVENT"
			},
			{
				"name": "rug",
				"salience": 0.033410724,
				"type": "OTHER"
			},
			{
				"name": "AMTV",
				"salience": 0.030488117,
				"type": "WORK_OF_ART"
			},
			{
				"name": "accusations",
				"salience": 0.02836534,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.024491845,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0212232,
				"type": "PERSON"
			},
			{
				"name": "drugs",
				"salience": 0.0212232,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.019871155,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.017948678,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.015476286,
				"type": "PERSON"
			},
			{
				"name": "thr",
				"salience": 0.015476286,
				"type": "OTHER"
			},
			{
				"name": "Hallucination Pills 10",
				"salience": 0.009113265,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0zg6dwl"
				},
				"name": "Ceo",
				"salience": 0.0074036596,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/^133E5CD4FDA575CE0290AF492619F77090C402C2C94F37679F^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T05:04:39.748+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "BOMBSHELL! FBI Reopens Investigation on Hillary Clinton 10/28/2016 In today’s video, Christopher Greene of AMTV explains somebody very powerful just pulled the rug from under Hillary Clinton. 10/27/2016 TRUTH REVOLT http://youtu.be/PsVNKmb6jEc There’s a lot of accusations going around that the 2016 election is r ... Netflix Ceo: TV’s Future includes Hallucination Pills 10/27/2016 INDEPENDENT The future of TV might everyone taking hallucinogenic drugs, according to the head of Netflix. The thr ...",
		"thread_title": "BOMBSHELL! FBI Reopens Investigation on Hillary Clinton",
		"title": "BOMBSHELL! FBI Reopens Investigation on Hillary Clinton",
		"type": "bs",
		"uuid": "59eb51cee5a413904f883f9b37c1e49cfb382653"
	},
	"-KhIh57jFWCMm6R_bRP2": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T23:55:06.709+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.47033194,
				"type": "PERSON"
			},
			{
				"name": "Hillary Email Investigation",
				"salience": 0.07459387,
				"type": "EVENT"
			},
			{
				"name": "Possibilities",
				"salience": 0.07126618,
				"type": "OTHER"
			},
			{
				"name": "possibilities",
				"salience": 0.0630342,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.046960417,
				"type": "OTHER"
			},
			{
				"name": "email investigation",
				"salience": 0.03433846,
				"type": "OTHER"
			},
			{
				"name": "extreme",
				"salience": 0.029798757,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.027207514,
				"type": "ORGANIZATION"
			},
			{
				"name": "ass",
				"salience": 0.025008198,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.01843954,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.01673122,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.01590972,
				"type": "OTHER"
			},
			{
				"name": "TRUTH",
				"salience": 0.01590972,
				"type": "OTHER"
			},
			{
				"name": "REVOLT",
				"salience": 0.01590972,
				"type": "EVENT"
			},
			{
				"name": "accusations",
				"salience": 0.013005312,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.011228558,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.009729438,
				"type": "PERSON"
			},
			{
				"name": "drugs",
				"salience": 0.009729438,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.009109394,
				"type": "ORGANIZATION"
			},
			{
				"name": "head",
				"salience": 0.007094123,
				"type": "PERSON"
			},
			{
				"name": "thr",
				"salience": 0.007094123,
				"type": "OTHER"
			},
			{
				"name": "Hallucination Pills 10",
				"salience": 0.0041769207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0zg6dwl"
				},
				"name": "Ceo",
				"salience": 0.0033932459,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/^60B994C453520DA6A0FA41838AEAE42B31A323B99CF16D60F1^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T23:55:06.709+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "5 Possibilities Why Comey Reopened Hillary Email Investigation 10/29/2016 \n  explains 5 possibilities why FBI Director James Comey reopened the Hillary Clinton email investigation from covering his ass to the extreme. 10/27/2016 TRUTH REVOLT http://youtu.be/PsVNKmb6jEc There’s a lot of accusations going around that the 2016 election is r ... Netflix Ceo: TV’s Future includes Hallucination Pills 10/27/2016 INDEPENDENT The future of TV might everyone taking hallucinogenic drugs, according to the head of Netflix. The thr ...",
		"thread_title": "5 Possibilities Why Comey Reopened Hillary Email Investigation",
		"title": "5 Possibilities Why Comey Reopened Hillary Email Investigation",
		"type": "bs",
		"uuid": "8bb9d788d4d8ac1608b782dcc0a9e77d6441fb38"
	},
	"-KhIh5GV9GGnzl8yX_XS": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T19:28:21.739+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "World War 3",
				"salience": 0.22990403,
				"type": "EVENT"
			},
			{
				"name": "Horizon 10",
				"salience": 0.13975902,
				"type": "LOCATION"
			},
			{
				"name": "implications",
				"salience": 0.09322135,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.079918765,
				"type": "OTHER"
			},
			{
				"name": "mini-doc",
				"salience": 0.07464322,
				"type": "OTHER"
			},
			{
				"name": "Election",
				"salience": 0.058483377,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.046358544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d1n2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Horizon"
				},
				"name": "Horizon",
				"salience": 0.036249433,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.032899294,
				"type": "EVENT"
			},
			{
				"name": "REVOLT",
				"salience": 0.02712711,
				"type": "EVENT"
			},
			{
				"name": "TRUTH",
				"salience": 0.02712711,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.02712711,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.022178844,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.019150907,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.016595602,
				"type": "PERSON"
			},
			{
				"name": "drugs",
				"salience": 0.016595602,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/017rf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netflix"
				},
				"name": "Netflix",
				"salience": 0.015538573,
				"type": "ORGANIZATION"
			},
			{
				"name": "head",
				"salience": 0.012102469,
				"type": "PERSON"
			},
			{
				"name": "thr",
				"salience": 0.012102469,
				"type": "OTHER"
			},
			{
				"name": "Hallucination Pills 10",
				"salience": 0.0071270373,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0zg6dwl"
				},
				"name": "Ceo",
				"salience": 0.0057901386,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/^35435F770AC52776C342BA68A2BEFF83CC4269DE4F295A2986^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T19:28:21.739+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "World War 3 is on the Horizon 10/30/2016 In today’s mini-doc, we explain the implications of the U.S. Election and why World War 3 is on the Horizon. 10/27/2016 TRUTH REVOLT http://youtu.be/PsVNKmb6jEc There’s a lot of accusations going around that the 2016 election is r ... Netflix Ceo: TV’s Future includes Hallucination Pills 10/27/2016 INDEPENDENT The future of TV might everyone taking hallucinogenic drugs, according to the head of Netflix. The thr ...",
		"thread_title": "World War 3 is on the Horizon",
		"title": "World War 3 is on the Horizon",
		"type": "bs",
		"uuid": "f6cc01bf0cffe7bd4e107e87bac7f91ce1d4b6c5"
	},
	"-KhIh5WWdgw0cRVnPClj": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:34:11.905+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.3696264,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japanese",
				"salience": 0.1581544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.066640556,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.04857274,
				"type": "EVENT"
			},
			{
				"name": "islands",
				"salience": 0.028929662,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07dfk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tokyo"
				},
				"name": "Tokyo",
				"salience": 0.024820227,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.023617323,
				"type": "ORGANIZATION"
			},
			{
				"name": "territories",
				"salience": 0.021590898,
				"type": "LOCATION"
			},
			{
				"name": "islands",
				"salience": 0.020515013,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.010748433,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fwk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sea_of_Okhotsk"
				},
				"name": "Sea of Okhotsk",
				"salience": 0.00829104,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fxrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hokkaido"
				},
				"name": "Hokkaido",
				"salience": 0.00718356,
				"type": "LOCATION"
			},
			{
				"name": "islet group",
				"salience": 0.0068836045,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.006264492,
				"type": "ORGANIZATION"
			},
			{
				"name": "defeat",
				"salience": 0.0059634615,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01lmgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Treaty_of_San_Francisco"
				},
				"name": "San Francisco Peace Treaty",
				"salience": 0.00572746,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0055619697,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.005473284,
				"type": "LOCATION"
			},
			{
				"name": "sources",
				"salience": 0.005275337,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t7hy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shinz%C5%8D_Abe"
				},
				"name": "Shinzo Abe",
				"salience": 0.005010184,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06rvn7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Habomai_Islands"
				},
				"name": "Habomai",
				"salience": 0.0047967792,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03nvd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shikotan"
				},
				"name": "Shikotan",
				"salience": 0.0047967792,
				"type": "LOCATION"
			},
			{
				"name": "Etorofu",
				"salience": 0.00479333,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0046977596,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01px32",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kuril_Islands_dispute"
				},
				"name": "Southern Kurils",
				"salience": 0.0046977596,
				"type": "LOCATION"
			},
			{
				"name": "prime minister",
				"salience": 0.0045868517,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.004019561,
				"type": "PERSON"
			},
			{
				"name": "peace treaty",
				"salience": 0.0038337659,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ntx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kunashir_Island"
				},
				"name": "Kunashiri",
				"salience": 0.0036746587,
				"type": "LOCATION"
			},
			{
				"name": "trade territories",
				"salience": 0.0034027218,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0032079064,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.003170645,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.003143888,
				"type": "EVENT"
			},
			{
				"name": "islets",
				"salience": 0.003143888,
				"type": "LOCATION"
			},
			{
				"name": "islands",
				"salience": 0.003051942,
				"type": "LOCATION"
			},
			{
				"name": "islands",
				"salience": 0.003051942,
				"type": "LOCATION"
			},
			{
				"name": "sources",
				"salience": 0.0028920863,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03c7pxm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fumio_Kishida"
				},
				"name": "Fumio Kishida",
				"salience": 0.0027267942,
				"type": "PERSON"
			},
			{
				"name": "security treaty",
				"salience": 0.002589041,
				"type": "OTHER"
			},
			{
				"name": "visit",
				"salience": 0.002458706,
				"type": "EVENT"
			},
			{
				"name": "rift",
				"salience": 0.002458706,
				"type": "OTHER"
			},
			{
				"name": "chain",
				"salience": 0.002458706,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.002458706,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.002386771,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sources",
				"salience": 0.0023615083,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0023024217,
				"type": "PERSON"
			},
			{
				"name": "Article",
				"salience": 0.0022977563,
				"type": "WORK_OF_ART"
			},
			{
				"name": "territories",
				"salience": 0.0022977563,
				"type": "LOCATION"
			},
			{
				"name": "scenario",
				"salience": 0.0022217156,
				"type": "OTHER"
			},
			{
				"name": "islands",
				"salience": 0.0020607468,
				"type": "LOCATION"
			},
			{
				"name": "government source",
				"salience": 0.002002872,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.0019911497,
				"type": "OTHER"
			},
			{
				"name": "consent",
				"salience": 0.0019911497,
				"type": "OTHER"
			},
			{
				"name": "news agency",
				"salience": 0.0019694318,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01c298",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kuril_Islands"
				},
				"name": "Kuril",
				"salience": 0.0019360136,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0019168733,
				"type": "LOCATION"
			},
			{
				"name": "Yasuhira Kawamura",
				"salience": 0.0019124275,
				"type": "PERSON"
			},
			{
				"name": "Article 5",
				"salience": 0.0017931665,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0017243236,
				"type": "OTHER"
			},
			{
				"name": "peace deal",
				"salience": 0.0016599909,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.0016599909,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.001625698,
				"type": "OTHER"
			},
			{
				"name": "islet group",
				"salience": 0.0015850049,
				"type": "ORGANIZATION"
			},
			{
				"name": "change",
				"salience": 0.0015650415,
				"type": "OTHER"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0015533441,
				"type": "PERSON"
			},
			{
				"name": "territories",
				"salience": 0.0014560114,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0014504277,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ties",
				"salience": 0.001407804,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.001407804,
				"type": "OTHER"
			},
			{
				"name": "foundations",
				"salience": 0.001407804,
				"type": "OTHER"
			},
			{
				"name": "islands",
				"salience": 0.0013563753,
				"type": "LOCATION"
			},
			{
				"name": "islands",
				"salience": 0.0013563753,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.001323793,
				"type": "ORGANIZATION"
			},
			{
				"name": "waters",
				"salience": 0.0012145588,
				"type": "OTHER"
			},
			{
				"name": "peace treaty",
				"salience": 0.0011950741,
				"type": "OTHER"
			},
			{
				"name": "treaties",
				"salience": 0.0011950741,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lh9g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kyodo_News"
				},
				"name": "Kyodo News",
				"salience": 0.0011800873,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01c298",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kuril_Islands"
				},
				"name": "Kuril Islands",
				"salience": 0.0011463363,
				"type": "LOCATION"
			},
			{
				"name": "change",
				"salience": 0.0011399568,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0010517361,
				"type": "OTHER"
			},
			{
				"name": "Soviet Joint Declaration",
				"salience": 0.001021883,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.001021883,
				"type": "ORGANIZATION"
			},
			{
				"name": "islands",
				"salience": 0.0010133073,
				"type": "LOCATION"
			},
			{
				"name": "administration",
				"salience": 0.0009264891,
				"type": "ORGANIZATION"
			},
			{
				"name": "will",
				"salience": 0.0009032887,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.00088462,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.00088462,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0008516,
				"type": "LOCATION"
			},
			{
				"name": "government source",
				"salience": 0.0008142506,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.0007922494,
				"type": "ORGANIZATION"
			},
			{
				"name": "military",
				"salience": 0.0007922494,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.00077926513,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reassessment",
				"salience": 0.0007660087,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0007660087,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0007660087,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0007660087,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/015tck",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Japan_Times"
				},
				"name": "Japan Times",
				"salience": 0.00074812426,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01t_55",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_minister"
				},
				"name": "Foreign Ministry",
				"salience": 0.0006964228,
				"type": "ORGANIZATION"
			},
			{
				"name": "waters",
				"salience": 0.0006608266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0283lh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_News_Agency_TASS"
				},
				"name": "TASS",
				"salience": 0.000647355,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b18t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nikkei_225"
				},
				"name": "Nikkei",
				"salience": 0.000647355,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.000639197,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.00063331524,
				"type": "OTHER"
			},
			{
				"name": "route",
				"salience": 0.0005722118,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0005722118,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.0005722118,
				"type": "ORGANIZATION"
			},
			{
				"name": "military drills",
				"salience": 0.0005722118,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0005722118,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.0005722118,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fwk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sea_of_Okhotsk"
				},
				"name": "Sea of Okhotsk",
				"salience": 0.00040671002,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05rgl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pacific_Ocean"
				},
				"name": "Pacific Ocean",
				"salience": 0.00035216438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.00031818182,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/58170711c36188ab3d8b4567.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T17:34:11.905+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "  \n  block the US from being stationed on the islands off Hokkaido in the strategic Sea of Okhotsk, if this helps persuade Russia to give them back. \nThe islands are inhabited, and in Russia are called the Southern Kurils – but for Japan they are Etorofu, Kunashiri, Shikotan, and the Habomai islet group. These territories, which became Russian after Japan’s defeat in World War II under the San Francisco Peace Treaty of 1951, saw a rift between the two countries preventing them from signing the peace treaty to formally end the war. Tokyo insists the four islets are not part of the Kuril chain and should be returned under its control. \nIn September, Russian President Vladimir Putin told Bloomberg that Russia does not “trade territories.” But ahead of his visit to Tokyo in mid-December, Japan’s diplomatic sources told Kyodo News that Moscow would hand over Shikotan and Habomai islet group following the peace deal, as stated by the 1956 Japan-Soviet Joint Declaration. \nThe sources, however, said Russia may be concerned that the US military could be stationed on the territories after Japan gets them back. According to Article 5 of the Japan-US security treaty, Washington is allowed to station its troops in areas administered by Japan. \nThe Japanese government is now looking into the potential consequences, should they exclude the islands from Article 5, the sources said, with one of them adding that Japanese Prime Minister Shinzo Abe could go as far as announcing that the islands do not fall under Article 5. \nOther sources, however, think that “a realistic scenario is that the prime minister shows his political will and seeks consent from the United States.” \nAt the same time, “Russia won’t agree to hand over [the islands] unless the possibility of stationing the US military there is ruled out,” a source familiar with the Japanese-Russian ties told The Japan Times over the weekend. \nNevertheless, convincing the US to okay such conditions seems very difficult, a Japanese government source said, adding that “It could even shake the foundations of the [Japan-US military] alliance.” \nFor Russia, the area around the disputed islands is of “extremely high importance” because it faces the Sea of Okhotsk, a Japanese government source said, and a foreign military in these waters could hamper both essential military drills and the use of a major access route to the Pacific Ocean. \nTokyo has already rejected the report, saying they are not planning to review Article 5, TASS news agency said, citing Prime Minister Shinzo Abe. Japanese Foreign Minister Fumio Kishida reiterated it, adding that the Japan-US treaty “applies and will apply” to all territories and waters which are administered by Japan. \nEarlier in the month, Tokyo also denied Nikkei’s report that Japan and Russia were discussing joint administration of the Kuril Islands. \n“There is no change in Japan’s fundamental position that Japan will conclude the peace treaty with Russia by resolving the issue of the possession of the four northern islands,” Japanese Foreign Ministry spokesman Yasuhira Kawamura told Reuters in an email at that time. \nRussia has always insisted that any change in the status of the islands is out of the question, as it would constitute a reassessment of the results of World War II, which is expressly banned by international treaties.",
		"thread_title": "Tokyo could ban US troops from stationing on disputed isles",
		"title": "Tokyo could ban US troops from stationing on disputed isles",
		"type": "bs",
		"uuid": "b569015051b3e192cd95c7e37b361c4ca7fa3d1c"
	},
	"-KhIh6HiQJD7tsHolJkv": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:42:32.122+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0ckb6b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malheur_National_Wildlife_Refuge"
				},
				"name": "Malheur National Wildlife Refuge",
				"salience": 0.057658378,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01074p2d"
				},
				"name": "Ammon Bundy",
				"salience": 0.045252334,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qpm8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon_Public_Broadcasting"
				},
				"name": "OPB",
				"salience": 0.034659658,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.023540102,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.02273018,
				"type": "LOCATION"
			},
			{
				"name": "employees",
				"salience": 0.022021763,
				"type": "PERSON"
			},
			{
				"name": "Oregon Billy Williams",
				"salience": 0.021522189,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/010h3lhj"
				},
				"name": "Ryan Bundy",
				"salience": 0.017487936,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.017057942,
				"type": "ORGANIZATION"
			},
			{
				"name": "David Fry",
				"salience": 0.015752068,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02frhbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland,_Oregon"
				},
				"name": "Portland",
				"salience": 0.013917441,
				"type": "LOCATION"
			},
			{
				"name": "Kenneth Medenbach",
				"salience": 0.013665713,
				"type": "PERSON"
			},
			{
				"name": "Defendants",
				"salience": 0.0120634865,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.011534374,
				"type": "PERSON"
			},
			{
				"name": "prosecution",
				"salience": 0.011470816,
				"type": "PERSON"
			},
			{
				"name": "statute",
				"salience": 0.011191129,
				"type": "WORK_OF_ART"
			},
			{
				"name": "occupation",
				"salience": 0.011183403,
				"type": "OTHER"
			},
			{
				"name": "defendants",
				"salience": 0.010369259,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02pr6q9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malheur_Lake"
				},
				"name": "Malheur",
				"salience": 0.009656129,
				"type": "LOCATION"
			},
			{
				"name": "prosecutors",
				"salience": 0.009576989,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.009042048,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.009036098,
				"type": "LOCATION"
			},
			{
				"name": "Matt Schindler",
				"salience": 0.008978581,
				"type": "PERSON"
			},
			{
				"name": "Shawna Cox",
				"salience": 0.00800372,
				"type": "PERSON"
			},
			{
				"name": "conspiracy",
				"salience": 0.007973455,
				"type": "OTHER"
			},
			{
				"name": "Neil Wampler",
				"salience": 0.0077958303,
				"type": "PERSON"
			},
			{
				"name": "Prosecutors",
				"salience": 0.0076163374,
				"type": "PERSON"
			},
			{
				"name": "Jarvis Kennedy",
				"salience": 0.0068491143,
				"type": "PERSON"
			},
			{
				"name": "Prosecution",
				"salience": 0.006469828,
				"type": "PERSON"
			},
			{
				"name": "defendants",
				"salience": 0.00637021,
				"type": "PERSON"
			},
			{
				"name": "Jeff Banta",
				"salience": 0.006242241,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.0062073553,
				"type": "PERSON"
			},
			{
				"name": "defendants",
				"salience": 0.0060994774,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.005994118,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0059742616,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04sdj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Married..._with_Children"
				},
				"name": "Bundys",
				"salience": 0.0058088773,
				"type": "WORK_OF_ART"
			},
			{
				"name": "occupation",
				"salience": 0.005719748,
				"type": "OTHER"
			},
			{
				"name": "refuge occupation",
				"salience": 0.005719748,
				"type": "OTHER"
			},
			{
				"name": "prosecutors",
				"salience": 0.0056516947,
				"type": "PERSON"
			},
			{
				"name": "prosecution",
				"salience": 0.0054764487,
				"type": "EVENT"
			},
			{
				"name": "prosecution",
				"salience": 0.0054764487,
				"type": "PERSON"
			},
			{
				"name": "defense",
				"salience": 0.00530262,
				"type": "OTHER"
			},
			{
				"name": "trees",
				"salience": 0.0052038003,
				"type": "OTHER"
			},
			{
				"name": "shadow",
				"salience": 0.0052038003,
				"type": "OTHER"
			},
			{
				"name": "defense attorneys",
				"salience": 0.005056733,
				"type": "PERSON"
			},
			{
				"name": "newspapers",
				"salience": 0.0049551865,
				"type": "ORGANIZATION"
			},
			{
				"name": "verdicts",
				"salience": 0.004815166,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04csldy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/OregonLive.com"
				},
				"name": "OregonLive",
				"salience": 0.0046896082,
				"type": "ORGANIZATION"
			},
			{
				"name": "trial",
				"salience": 0.0046024253,
				"type": "EVENT"
			},
			{
				"name": "pictures",
				"salience": 0.004506842,
				"type": "WORK_OF_ART"
			},
			{
				"name": "park",
				"salience": 0.004358231,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.004348098,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.004348098,
				"type": "PERSON"
			},
			{
				"name": "trial",
				"salience": 0.004348098,
				"type": "EVENT"
			},
			{
				"name": "Juror",
				"salience": 0.0038361007,
				"type": "PERSON"
			},
			{
				"name": "Pete Santilli",
				"salience": 0.0036878544,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0036388554,
				"type": "PERSON"
			},
			{
				"name": "jury",
				"salience": 0.003591363,
				"type": "PERSON"
			},
			{
				"name": "conspiracy charge",
				"salience": 0.003538094,
				"type": "OTHER"
			},
			{
				"name": "defendants",
				"salience": 0.0034909106,
				"type": "PERSON"
			},
			{
				"name": "prosecutors",
				"salience": 0.0034484733,
				"type": "PERSON"
			},
			{
				"name": "Prosecutors",
				"salience": 0.003278032,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0032690242,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0032256336,
				"type": "PERSON"
			},
			{
				"name": "movements",
				"salience": 0.0031872105,
				"type": "OTHER"
			},
			{
				"name": "Leader",
				"salience": 0.0031872105,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0031835283,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02frhbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland,_Oregon"
				},
				"name": "PDX",
				"salience": 0.0031548662,
				"type": "LOCATION"
			},
			{
				"name": "stand",
				"salience": 0.0031449047,
				"type": "LOCATION"
			},
			{
				"name": "Andy Dunbar",
				"salience": 0.0030905795,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.003029463,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0029700852,
				"type": "LOCATION"
			},
			{
				"name": "victory",
				"salience": 0.0029445689,
				"type": "EVENT"
			},
			{
				"name": "result",
				"salience": 0.0029445689,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0029445689,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0029445689,
				"type": "OTHER"
			},
			{
				"name": "Dissecting The Oregon Standoff Trial",
				"salience": 0.0027750172,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Chapman Square",
				"salience": 0.0027750172,
				"type": "LOCATION"
			},
			{
				"name": "Defendants",
				"salience": 0.0026917753,
				"type": "PERSON"
			},
			{
				"name": "victory barbecue",
				"salience": 0.0026587802,
				"type": "EVENT"
			},
			{
				"name": "occupation opponents",
				"salience": 0.0026587802,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.0026587802,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0026572007,
				"type": "PERSON"
			},
			{
				"name": "Mike Arnold",
				"salience": 0.0026373388,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0108bx7v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bundy_standoff"
				},
				"name": "Cliven Bundy",
				"salience": 0.0026326503,
				"type": "PERSON"
			},
			{
				"name": "occupiers",
				"salience": 0.0025747241,
				"type": "PERSON"
			},
			{
				"name": "David Zion Brugger",
				"salience": 0.002491511,
				"type": "PERSON"
			},
			{
				"name": "occupation",
				"salience": 0.0023561055,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0023561055,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.0023340709,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.0023113838,
				"type": "LOCATION"
			},
			{
				"name": "face",
				"salience": 0.0023024103,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.0023024103,
				"type": "OTHER"
			},
			{
				"name": "meaning",
				"salience": 0.0023024103,
				"type": "OTHER"
			},
			{
				"name": "peers",
				"salience": 0.0023024103,
				"type": "PERSON"
			},
			{
				"name": "siblings",
				"salience": 0.0023024103,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0023024103,
				"type": "PERSON"
			},
			{
				"name": "co-defendants",
				"salience": 0.0023024103,
				"type": "PERSON"
			},
			{
				"name": "moment",
				"salience": 0.0023024103,
				"type": "OTHER"
			},
			{
				"name": "hotdog",
				"salience": 0.0023024103,
				"type": "OTHER"
			},
			{
				"name": "phones",
				"salience": 0.0023024103,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stack",
				"salience": 0.0023024103,
				"type": "OTHER"
			},
			{
				"name": "Prosecutors",
				"salience": 0.0022557725,
				"type": "PERSON"
			},
			{
				"name": "prosecution",
				"salience": 0.0022557725,
				"type": "PERSON"
			},
			{
				"name": "peace sign",
				"salience": 0.0022447691,
				"type": "OTHER"
			},
			{
				"name": "trespass charges",
				"salience": 0.002199988,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.002199988,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.0021442366,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0294qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Attorney"
				},
				"name": "U.S. Attorney",
				"salience": 0.00210271,
				"type": "PERSON"
			},
			{
				"name": "Kevin Sali",
				"salience": 0.0020585735,
				"type": "PERSON"
			},
			{
				"name": "defense",
				"salience": 0.0020241207,
				"type": "PERSON"
			},
			{
				"name": "verdict",
				"salience": 0.0019831194,
				"type": "OTHER"
			},
			{
				"name": "closing argument",
				"salience": 0.0019195876,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0018869557,
				"type": "OTHER"
			},
			{
				"name": "Amelia Templeton",
				"salience": 0.0018509859,
				"type": "PERSON"
			},
			{
				"name": "weapons charges",
				"salience": 0.0018421983,
				"type": "OTHER"
			},
			{
				"name": "Charges",
				"salience": 0.0018421983,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.0018421983,
				"type": "OTHER"
			},
			{
				"name": "theft charge",
				"salience": 0.0018421983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/010f6q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cedar_City,_Utah"
				},
				"name": "Cedar City",
				"salience": 0.0018126944,
				"type": "LOCATION"
			},
			{
				"name": "refuge",
				"salience": 0.0017905874,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.001769236,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0017619055,
				"type": "OTHER"
			},
			{
				"name": "Teressa Raiford",
				"salience": 0.0017333806,
				"type": "PERSON"
			},
			{
				"name": "air",
				"salience": 0.001708922,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0016783583,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0016783583,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0016783583,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0016520573,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0016520573,
				"type": "PERSON"
			},
			{
				"name": "occupiers",
				"salience": 0.0016520573,
				"type": "PERSON"
			},
			{
				"name": "Marcus Mumford",
				"salience": 0.0016505736,
				"type": "PERSON"
			},
			{
				"name": "occupation supporters",
				"salience": 0.0016486725,
				"type": "PERSON"
			},
			{
				"name": "Ammon Bundy Hometown",
				"salience": 0.0016366987,
				"type": "LOCATION"
			},
			{
				"name": "Ryan Bundy Hometown",
				"salience": 0.0016366987,
				"type": "LOCATION"
			},
			{
				"name": "occupation",
				"salience": 0.0015903945,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.0015816893,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0015703092,
				"type": "OTHER"
			},
			{
				"name": "state court",
				"salience": 0.0015505233,
				"type": "ORGANIZATION"
			},
			{
				"name": "prosecution",
				"salience": 0.0015226515,
				"type": "PERSON"
			},
			{
				"name": "prosecutors",
				"salience": 0.0015226515,
				"type": "PERSON"
			},
			{
				"name": "conspiracy",
				"salience": 0.00149735,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0014941527,
				"type": "OTHER"
			},
			{
				"name": "felony charges",
				"salience": 0.0014849877,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0014849877,
				"type": "OTHER"
			},
			{
				"name": "defendants",
				"salience": 0.0014742566,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0014427403,
				"type": "PERSON"
			},
			{
				"name": "hurry",
				"salience": 0.001430956,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03s5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idaho"
				},
				"name": "Idaho",
				"salience": 0.0014172563,
				"type": "LOCATION"
			},
			{
				"name": "Sarah Foultner",
				"salience": 0.0014172563,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07srw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Utah"
				},
				"name": "Utah",
				"salience": 0.0014172563,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0s1st",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Emmett,_Idaho"
				},
				"name": "Emmett",
				"salience": 0.0014172563,
				"type": "PERSON"
			},
			{
				"name": "NoDAPL",
				"salience": 0.0014172563,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.0013827613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05p6z10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anna_J._Brown"
				},
				"name": "Anna Brown",
				"salience": 0.0013729917,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.0013588544,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0013486936,
				"type": "PERSON"
			},
			{
				"name": "occupation",
				"salience": 0.0013486936,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0013486936,
				"type": "OTHER"
			},
			{
				"name": "Dave Blanchard",
				"salience": 0.0013384356,
				"type": "PERSON"
			},
			{
				"name": "jury",
				"salience": 0.0013360761,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0013122122,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0013122122,
				"type": "PERSON"
			},
			{
				"name": "prosecution",
				"salience": 0.0012912413,
				"type": "PERSON"
			},
			{
				"name": "prosecutors",
				"salience": 0.0012912413,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01yqvd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Oregonian"
				},
				"name": "Oregonian",
				"salience": 0.0012907323,
				"type": "PERSON"
			},
			{
				"name": "trial",
				"salience": 0.0012554531,
				"type": "EVENT"
			},
			{
				"name": "defense",
				"salience": 0.0012501982,
				"type": "OTHER"
			},
			{
				"name": "defendants",
				"salience": 0.0012501982,
				"type": "PERSON"
			},
			{
				"name": "defendants",
				"salience": 0.0012501982,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.0012122537,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.0012122537,
				"type": "EVENT"
			},
			{
				"name": "verdict",
				"salience": 0.0011941913,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.0011941913,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0011803661,
				"type": "OTHER"
			},
			{
				"name": "jurors",
				"salience": 0.0011774959,
				"type": "PERSON"
			},
			{
				"name": "government computers",
				"salience": 0.0011514887,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "brothers",
				"salience": 0.0011440299,
				"type": "PERSON"
			},
			{
				"name": "slam dunk",
				"salience": 0.001141357,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.0011351244,
				"type": "OTHER"
			},
			{
				"name": "stand",
				"salience": 0.0011335391,
				"type": "OTHER"
			},
			{
				"name": "stand",
				"salience": 0.0011335391,
				"type": "OTHER"
			},
			{
				"name": "standoff",
				"salience": 0.0011335391,
				"type": "EVENT"
			},
			{
				"name": "result",
				"salience": 0.0011304027,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0011292644,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government surveillance cameras",
				"salience": 0.0010945331,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0010945331,
				"type": "OTHER"
			},
			{
				"name": "brother",
				"salience": 0.0010945331,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0010945331,
				"type": "PERSON"
			},
			{
				"name": "intimidation",
				"salience": 0.0010945331,
				"type": "OTHER"
			},
			{
				"name": "misdemeanor trespassing",
				"salience": 0.0010945331,
				"type": "OTHER"
			},
			{
				"name": "rancher",
				"salience": 0.0010945331,
				"type": "PERSON"
			},
			{
				"name": "theft",
				"salience": 0.0010945331,
				"type": "OTHER"
			},
			{
				"name": "defendants",
				"salience": 0.0010941591,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0010712304,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0010512195,
				"type": "PERSON"
			},
			{
				"name": "courtroom",
				"salience": 0.0010465236,
				"type": "LOCATION"
			},
			{
				"name": "court",
				"salience": 0.0010465236,
				"type": "LOCATION"
			},
			{
				"name": "courtroom",
				"salience": 0.0010465236,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0010465236,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.0010367627,
				"type": "PERSON"
			},
			{
				"name": "employees",
				"salience": 0.0010367627,
				"type": "PERSON"
			},
			{
				"name": "Wildlife",
				"salience": 0.0010367627,
				"type": "OTHER"
			},
			{
				"name": "dunk",
				"salience": 0.001031239,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.001024891,
				"type": "PERSON"
			},
			{
				"name": "timeline",
				"salience": 0.0010143362,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0010074843,
				"type": "PERSON"
			},
			{
				"name": "occupiers",
				"salience": 0.0010074843,
				"type": "PERSON"
			},
			{
				"name": "occupation",
				"salience": 0.0010074843,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.00097646815,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.00095201127,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0009477584,
				"type": "OTHER"
			},
			{
				"name": "conduct",
				"salience": 0.0009477584,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0009477584,
				"type": "OTHER"
			},
			{
				"name": "muster",
				"salience": 0.0009477584,
				"type": "OTHER"
			},
			{
				"name": "co-conspirators",
				"salience": 0.0009477584,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0009477584,
				"type": "PERSON"
			},
			{
				"name": "government property",
				"salience": 0.0009477584,
				"type": "OTHER"
			},
			{
				"name": "removal",
				"salience": 0.0009477584,
				"type": "EVENT"
			},
			{
				"name": "jurors",
				"salience": 0.0009253592,
				"type": "PERSON"
			},
			{
				"name": "closing argument",
				"salience": 0.0009199993,
				"type": "OTHER"
			},
			{
				"name": "closing argument",
				"salience": 0.0009199993,
				"type": "EVENT"
			},
			{
				"name": "threat",
				"salience": 0.0009199993,
				"type": "OTHER"
			},
			{
				"name": "courthouse",
				"salience": 0.0008874523,
				"type": "LOCATION"
			},
			{
				"name": "slam dunk",
				"salience": 0.0008856521,
				"type": "OTHER"
			},
			{
				"name": "dunk",
				"salience": 0.0008856521,
				"type": "OTHER"
			},
			{
				"name": "intent",
				"salience": 0.00084990903,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00084990903,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.00084990903,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.0008479305,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.0008479305,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mx9b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harney_County,_Oregon"
				},
				"name": "Harney County",
				"salience": 0.0008358069,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.00081817777,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0008036951,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.0007870807,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conspiracy",
				"salience": 0.0007842033,
				"type": "OTHER"
			},
			{
				"name": "attorneys",
				"salience": 0.00077961624,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0007718877,
				"type": "OTHER"
			},
			{
				"name": "Verdict Defense",
				"salience": 0.00076945574,
				"type": "OTHER"
			},
			{
				"name": "land management",
				"salience": 0.000767366,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.000767366,
				"type": "OTHER"
			},
			{
				"name": "refusal",
				"salience": 0.0007655796,
				"type": "OTHER"
			},
			{
				"name": "occupation trial",
				"salience": 0.0007655796,
				"type": "EVENT"
			},
			{
				"name": "mounds",
				"salience": 0.0007639377,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.0007639377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0xc84",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bunkerville,_Nevada"
				},
				"name": "Bunkerville",
				"salience": 0.000761865,
				"type": "LOCATION"
			},
			{
				"name": "prosecutors",
				"salience": 0.0007580088,
				"type": "PERSON"
			},
			{
				"name": "jury",
				"salience": 0.00075505,
				"type": "PERSON"
			},
			{
				"name": "count",
				"salience": 0.0007510268,
				"type": "OTHER"
			},
			{
				"name": "closing arguments",
				"salience": 0.0007510268,
				"type": "OTHER"
			},
			{
				"name": "basketball",
				"salience": 0.0007387157,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0007387157,
				"type": "PERSON"
			},
			{
				"name": "basketball",
				"salience": 0.0007387157,
				"type": "OTHER"
			},
			{
				"name": "facility",
				"salience": 0.0007387157,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.0007387157,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.0007387157,
				"type": "PERSON"
			},
			{
				"name": "folks",
				"salience": 0.0007339299,
				"type": "PERSON"
			},
			{
				"name": "occupiers",
				"salience": 0.0007337251,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "U.S. Constitution",
				"salience": 0.00072424434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "felonies",
				"salience": 0.0007111348,
				"type": "OTHER"
			},
			{
				"name": "trust",
				"salience": 0.00069903483,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0006938066,
				"type": "EVENT"
			},
			{
				"name": "actions",
				"salience": 0.0006938066,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0006938066,
				"type": "OTHER"
			},
			{
				"name": "double-standard",
				"salience": 0.0006912246,
				"type": "OTHER"
			},
			{
				"name": "endorsement",
				"salience": 0.0006902244,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.00067293516,
				"type": "OTHER"
			},
			{
				"name": "triumphalism",
				"salience": 0.0006644536,
				"type": "OTHER"
			},
			{
				"name": "impartiality",
				"salience": 0.0006644536,
				"type": "OTHER"
			},
			{
				"name": "refuge takeover",
				"salience": 0.0006644536,
				"type": "EVENT"
			},
			{
				"name": "Fish",
				"salience": 0.0006644536,
				"type": "OTHER"
			},
			{
				"name": "length",
				"salience": 0.0006644536,
				"type": "OTHER"
			},
			{
				"name": "divinity",
				"salience": 0.0006644536,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0006644536,
				"type": "PERSON"
			},
			{
				"name": "occupation case",
				"salience": 0.0006629067,
				"type": "OTHER"
			},
			{
				"name": "watch tower",
				"salience": 0.00063964474,
				"type": "LOCATION"
			},
			{
				"name": "dismissal",
				"salience": 0.00063964474,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00063964474,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.00063964474,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.00063964474,
				"type": "OTHER"
			},
			{
				"name": "firearms",
				"salience": 0.00063964474,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "table",
				"salience": 0.00063964474,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0006322027,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0006322027,
				"type": "LOCATION"
			},
			{
				"name": "lands",
				"salience": 0.0006322027,
				"type": "LOCATION"
			},
			{
				"name": "beliefs",
				"salience": 0.00062642095,
				"type": "OTHER"
			},
			{
				"name": "acquittal",
				"salience": 0.00062642095,
				"type": "EVENT"
			},
			{
				"name": "beliefs",
				"salience": 0.00062642095,
				"type": "OTHER"
			},
			{
				"name": "celebration",
				"salience": 0.00062642095,
				"type": "EVENT"
			},
			{
				"name": "form",
				"salience": 0.00062642095,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.00062642095,
				"type": "ORGANIZATION"
			},
			{
				"name": "verdict",
				"salience": 0.0006175169,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.0006175169,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.0006175169,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00057361665,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.0005711982,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.0005621337,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.00056099327,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.00055792916,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.0005575394,
				"type": "EVENT"
			},
			{
				"name": "trial",
				"salience": 0.0005575394,
				"type": "EVENT"
			},
			{
				"name": "occupiers",
				"salience": 0.0005480686,
				"type": "PERSON"
			},
			{
				"name": "occupation",
				"salience": 0.0005480686,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j75z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_district_court"
				},
				"name": "U.S. District Court",
				"salience": 0.0005461712,
				"type": "ORGANIZATION"
			},
			{
				"name": "glory",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "cries",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0005424073,
				"type": "WORK_OF_ART"
			},
			{
				"name": "failures",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "affirmation",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "aspirations",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.0005424073,
				"type": "EVENT"
			},
			{
				"name": "scrutiny",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "shock",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "government overreach",
				"salience": 0.0005424073,
				"type": "EVENT"
			},
			{
				"name": "responsibility",
				"salience": 0.0005424073,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0005315647,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.0005221545,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.000518249,
				"type": "PERSON"
			},
			{
				"name": "standoff",
				"salience": 0.00050338625,
				"type": "EVENT"
			},
			{
				"name": "defendants",
				"salience": 0.00047681198,
				"type": "PERSON"
			},
			{
				"name": "opponents",
				"salience": 0.00046791148,
				"type": "PERSON"
			},
			{
				"name": "militia groups",
				"salience": 0.00046791148,
				"type": "ORGANIZATION"
			},
			{
				"name": "tribe",
				"salience": 0.00046791148,
				"type": "PERSON"
			},
			{
				"name": "member",
				"salience": 0.00046791148,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.00046791148,
				"type": "PERSON"
			},
			{
				"name": "compound",
				"salience": 0.00046791148,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.00046791148,
				"type": "OTHER"
			},
			{
				"name": "barbecue",
				"salience": 0.00046791148,
				"type": "EVENT"
			},
			{
				"name": "verdict",
				"salience": 0.00046126018,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.00046126018,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0004604009,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0004604009,
				"type": "PERSON"
			},
			{
				"name": "Implication Ammon",
				"salience": 0.00044161492,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0004358712,
				"type": "EVENT"
			},
			{
				"name": "land battles",
				"salience": 0.00043168306,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.00041645722,
				"type": "EVENT"
			},
			{
				"name": "trial",
				"salience": 0.00041645722,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f4r5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bureau_of_Land_Management"
				},
				"name": "Bureau of Land Management",
				"salience": 0.00040891735,
				"type": "ORGANIZATION"
			},
			{
				"name": "patriot movement",
				"salience": 0.00040853993,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00040853993,
				"type": "OTHER"
			},
			{
				"name": "trial verdict",
				"salience": 0.0004063084,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.00040515367,
				"type": "EVENT"
			},
			{
				"name": "courthouse steps",
				"salience": 0.00040515367,
				"type": "LOCATION"
			},
			{
				"name": "effort",
				"salience": 0.00040515367,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.00040515367,
				"type": "EVENT"
			},
			{
				"name": "custody",
				"salience": 0.00040515367,
				"type": "OTHER"
			},
			{
				"name": "grill",
				"salience": 0.00040515367,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "shouting match",
				"salience": 0.00040515367,
				"type": "EVENT"
			},
			{
				"name": "client",
				"salience": 0.00040515367,
				"type": "PERSON"
			},
			{
				"name": "rights",
				"salience": 0.00040515367,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.00040515367,
				"type": "OTHER"
			},
			{
				"name": "exception",
				"salience": 0.00040515367,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.00040515367,
				"type": "OTHER"
			},
			{
				"name": "justice system",
				"salience": 0.00040515367,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.00040515367,
				"type": "ORGANIZATION"
			},
			{
				"name": "social media",
				"salience": 0.00040515367,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00040376294,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.00040212314,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.00039002506,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016wtv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paiute"
				},
				"name": "Paiute",
				"salience": 0.00037922262,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03wdjz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland_City_Hall_(Oregon)"
				},
				"name": "City Hall",
				"salience": 0.00037922262,
				"type": "LOCATION"
			},
			{
				"name": "Standoff",
				"salience": 0.00037600545,
				"type": "PERSON"
			},
			{
				"name": "facility",
				"salience": 0.00036306353,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00034389613,
				"type": "PERSON"
			},
			{
				"name": "Judge",
				"salience": 0.0003407507,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.0003407507,
				"type": "OTHER"
			},
			{
				"name": "downtown shade-trees",
				"salience": 0.0003407507,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.00032557297,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.00032557297,
				"type": "EVENT"
			},
			{
				"name": "rally",
				"salience": 0.0003157777,
				"type": "EVENT"
			},
			{
				"name": "heart",
				"salience": 0.000310404,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0003051572,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00029657784,
				"type": "PERSON"
			},
			{
				"name": "win",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "behalf",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "limbo",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.00029504634,
				"type": "LOCATION"
			},
			{
				"name": "buttons",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "shirt",
				"salience": 0.00029504634,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mind",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "penalties",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00029504634,
				"type": "EVENT"
			},
			{
				"name": "hat",
				"salience": 0.00029504634,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.00029504634,
				"type": "EVENT"
			},
			{
				"name": "father",
				"salience": 0.00029504634,
				"type": "PERSON"
			},
			{
				"name": "proceedings",
				"salience": 0.00029504634,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.00028795406,
				"type": "LOCATION"
			},
			{
				"name": "acquittal",
				"salience": 0.00028530363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00028072382,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.00027691326,
				"type": "OTHER"
			},
			{
				"name": "Celebration",
				"salience": 0.00026776927,
				"type": "EVENT"
			},
			{
				"name": "Anna Griffin",
				"salience": 0.0002656577,
				"type": "PERSON"
			},
			{
				"name": "cameras",
				"salience": 0.00025452083,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "rally",
				"salience": 0.00025452083,
				"type": "EVENT"
			},
			{
				"name": "activist group",
				"salience": 0.00025452083,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00025141463,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.00024933062,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Native",
				"salience": 0.00024933062,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pacific Patriots Network",
				"salience": 0.00024933062,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0zd0l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Burns,_Oregon"
				},
				"name": "Burns",
				"salience": 0.00024933062,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.00024318363,
				"type": "EVENT"
			},
			{
				"name": "point",
				"salience": 0.00024084681,
				"type": "OTHER"
			},
			{
				"name": "jury members",
				"salience": 0.00023887817,
				"type": "PERSON"
			},
			{
				"name": "potential",
				"salience": 0.00023781077,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.0002282377,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.00022038148,
				"type": "PERSON"
			},
			{
				"name": "campus",
				"salience": 0.00022038148,
				"type": "LOCATION"
			},
			{
				"name": "anger",
				"salience": 0.00022038148,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.00022038148,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.00022038148,
				"type": "OTHER"
			},
			{
				"name": "blocks",
				"salience": 0.00022038148,
				"type": "OTHER"
			},
			{
				"name": "construction site",
				"salience": 0.00022038148,
				"type": "LOCATION"
			},
			{
				"name": "waves",
				"salience": 0.00021760339,
				"type": "OTHER"
			},
			{
				"name": "Raiford",
				"salience": 0.00021163115,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "American West",
				"salience": 0.0002096954,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01gwck",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland_State_University"
				},
				"name": "Portland State University",
				"salience": 0.00020627555,
				"type": "ORGANIZATION"
			},
			{
				"name": "Amanda Peacher",
				"salience": 0.00019432655,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0p6f_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marshals_Service"
				},
				"name": "U.S. Marshals",
				"salience": 0.00018156818,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bradley W. Parks",
				"salience": 0.00015662839,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.00015662839,
				"type": "LOCATION"
			},
			{
				"name": "crowd",
				"salience": 0.00014872388,
				"type": "PERSON"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.00013561892,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/20161028_occupation_barbecue_dont_shoot_pdx_BP-17_yld9ws.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T17:42:32.122+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 35.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "41 Days And 8 Months Later: Dissecting The Oregon Standoff Trial 10/31/2016 \nOPB \nIn the shadow of trees covering Chapman Square park in downtown Portland, four of seven defendants acquitted of conspiracy in the occupation of the Malheur National Wildlife Refuge posed for pictures. \nDavid Fry smiled as he flashed a peace sign. He slung his arms around co-defendants Neil Wampler — clutching a hotdog from the victory barbecue and a stack of newspapers with his face on them — and Shawna Cox. Jeff Banta stood to the far right. An alternate juror named Sarah Foultner stood between them while a supporter cycled through phones to capture the moment for everyone. \nThe prosecution didn’t picture the trial ending like this. \n“Disappointing,” said U.S. Attorney for Oregon Billy Williams of the not guilty verdicts. “Bitterly so.” \nJust as quickly as the defense proclaimed a victory for rural America, occupation opponents dubbed the result an embarrassing loss for the prosecution. And supporters of other movements — #BlackLivesMatter and #NoDAPL to name two — wondered aloud about the meaning of justice. \nBut 41 days and eight months later, the leaders of the armed occupation in eastern Oregon were found not guilty by a jury of peers. \nStill, questions remain: How did it happen? And what happens next? Ammon Bundy Hometown: Emmett, Idaho NOT GUILTY \nLeader of the Malheur refuge occupation. Before Oregon, Ammon Bundy was less prominent than his siblings in protesting the federal government. Ryan Bundy Hometown: Cedar City, Utah NOT GUILTY \nEldest of Nevada rancher Cliven Bundy’s 14 children. Worked alongside his brother, Ammon Bundy, as a leader of the Malheur occupation. The Charges \nAmmon Bundy, Ryan Bundy and five others were charged with conspiracy to impede federal employees from doing their jobs by force, threat or intimidation. \n“It’s a favorite charge of prosecutors,” said Portland defense attorney Kevin Sali before the trial began. “When people are involved in a conspiracy they can be liable … for things their co-conspirators did.” \nThe Bundys, Fry, Banta and Cox also faced weapons charges. (Prosecutors dropped those against Cox .) Ryan Bundy and Kenneth Medenbach were also charged with theft of government property. Internet radio show host Pete Santilli also faced a conspiracy charge but it was later dropped . \nThe jury found the defendants not guilty on all but one charge. They failed to reach consensus on Ryan Bundy’s theft charge stemming from the removal of government surveillance cameras at the refuge. \nIn light of the verdict, questions swirled about whether the prosecution brought the proper charges. \nWilliams, the U.S. Attorney for Oregon, said prosecutors could have brought criminal trespass charges and tried the occupiers in state court. But misdemeanor trespassing didn’t seem to pass for muster — prosecutors wanted to bring felonies. \n“If there had been some other federal statute that specifically addresses the conduct, we would have considered using it,” Williams said in an interview with OPB’s Amelia Templeton . “We have and still believe we brought the most applicable and appropriate charges under the evidence, which is our duty.” A watch tower at the Malheur National Wildlife Refuge. Andy Dunbar, a rancher who lives adjacent to the refuge, explained his view of the occupation in court. Amelia Templeton/OPB The Prosecution \nSome described the prosecution’s case as a “slam dunk.” In basketball, a slam dunk is a show of force. \nMike Arnold, Ammon Bundy’s previous attorney, told OPB’s Anna Griffin he thinks the prosecution brought felony charges to make a powerful statement with “serious prison time.” \n“Their goal is to prevent any sort of activity like this in the future from the actual defendants themselves and other like-minded folks,” Arnold said. \nProsecutors brought mounds of evidence to the table — sometimes literally, like when they brought a large display of firearms and ammunition into the courtroom. \nAnd rarely did defendants dispute the facts of the case. They admitted to illegally taking over a federal facility, even to bringing their arms. \n“It didn’t bother me to be arrested because I’m where I want to be right now,” Medenbach said on the stand . “Like the Bundys, I’ve been called by a higher power … we all know this is what God called us to do.” \nBut prosecutors missed the dunk. And just like in basketball, a missed dunk in the courtroom can be humiliating. \nJuror No. 4 — who earlier sparked a fellow juror’s dismissal by questioning his impartiality — wrote the Oregonian/OregonLive saying the prosecution came off as arrogant in its case. \n“The air of triumphalism that the prosecution brought was not lost on any of us,” the juror wrote. \nThe prosecution moved through its case quickly. Prosecutors rested after 13 days. They cross-examined Ammon Bundy for just 15 minutes . Their closing argument lasted less than two hours. \nWilliams admitted the hurry with which prosecutors prepared their case may have hurt it. He called the legal timeline “extraordinary.” \nThe prosecution focused heavily on the occupiers’ intent behind the refuge takeover. But the jury ultimately determined the prosecution failed to prove impeding federal employees was the occupiers’ goal — even if the occupation actually did impede employees. The Defense \nMatt Schindler, Medenbach’s hybrid counsel, delivered a thunderous closing argument on Oct. 19. \nThe charge all seven occupiers faced was conspiracy to impede federal employees from doing their jobs by threat, force or intimidation. \n“I just sat through five weeks of a trial about threatening federal employees without hearing a single threat,” Schindler said in his closing argument. \nThe defense tried to make its case bigger than the Bureau of Land Management and U.S. Fish and Wildlife employees in Harney County. \nFive defendants ended up taking the stand, speaking at length about the U.S. Constitution, land management, divinity, and the 2014 standoff in Bunkerville, Nevada. Ryan Bundy questioned his wife on the stand. David Fry giggled when prosecutors asked him about using government computers. Medenbach reveled in the glory of public testimony after decades of protesting the federal government. \nIn their closing arguments, defense attorneys attempted to instill into the jurors a sense of political responsibility. \n“We’re counting on you to stop government overreach,” Marcus Mumford, Ammon Bundy’s attorney, told the jury. “Our trust is in you.” \nA jury found seven defendants charged in the occupation of the Malheur National Wildlife Refuge not guilty, following a trial that lasted several weeks. The Verdict \nDefense attorneys expressed shock at the verdict; even they did not expect such a result. It came despite scrutiny from U.S. District Court Judge Anna Brown and prosecutors for lack of organization . \nDefendants and their supporters erupted into tearful celebration outside the federal courthouse in downtown Portland (and streamed it live online, just like much of the occupation). \n“We came to Oregon — to Harney County — seeking justice,” defendant Neil Wampler said after his acquittal, “and today we found it.” \nBut despite defendants’ and supporters’ cries of victory, Juror No. 4 wrote in his letter to the Oregonian that the verdict was not an endorsement of the occupiers’ political beliefs. \n“It should be known that all 12 jurors felt that this verdict was a statement regarding the various failures of the prosecution to prove ‘conspiracy’ in the count itself — and not any form of affirmation of the defense’s various beliefs, actions or aspirations,” the juror wrote. \nDefendants and their supporters celebrated a not guilty verdict in the trial of seven people involved in the occupation of the Malheur National Wildlife Refuge. The Celebration \nThe mood was jubilant among occupiers and their supporters, who grilled, milled and posed for cameras in downtown Portland on the Friday following the verdict. \nMany people have said they fear the verdict will embolden defendants and their supporters. Cox and Fry both said they would participate in protests like the Oregon Standoff again. \n“If I have a compelling urge to come out here to join a protest, if I think it’s a legitimate reason to come, I’ll absolutely protest,” Fry told OPB. Teressa Raiford speaks at a Don’t Shoot PDX-organized rally on Portland State University’s campus. Bradley W. Parks/OPB \nThe reaction was different just a few blocks away. \nDon’t Shoot PDX, a Portland activist group supportive of the Black Lives Matter movement, was holding what was supposed to be a rally, unrelated to the trial, at Portland State University. \n“I don’t know how I can keep telling people to protest,” lead organizer Teressa Raiford told the crowd. Raiford seemed exhausted. \nThe occupiers’ acquittal came the same day more than 100 protesters in North Dakota were forcibly removed from the construction site of the Dakota Access Pipeline and arrested. It came weeks after Don’t Shoot PDX protesters were pushed out of City Hall and pepper-sprayed by Portland police. \nRaiford expressed anger at having to discuss the Malheur trial verdict. She and countless others on social media highlighted what many see as a double-standard in how law enforcement and the justice system punish people of color. With the exception of David Fry, defendants in the occupation case were all white. All jury members were also white. \n“Forty-one days at a compound on federal land,” Raiford said, pointing to weapons at the refuge, occupiers’ refusal to leave, and threats made by occupiers against the FBI. \n“The difference is we would have been murdered,” Raiford said. \nJarvis Kennedy, of the Burns, Oregon, Paiute tribe told OPB’s Amanda Peacher he was angry with the verdict. Kennedy and the Paiute tribe have been vocal opponents of the Malheur occupation from the start. However, Kennedy added he was now more motivated to fight for Native lands and rights . \nDon’t Shoot PDX eventually marched past the occupation supporters’ barbecue Friday, where they staged a die-in near the courthouse steps and burned an American flag . \nAfter a brief shouting match, Bundy supporters went back to the grill and Don’t Shoot PDX continued to City Hall. A member of the Pacific Patriots Network at the Malheur National Wildlife Refuge in January. Many wonder if the verdict in the Oregon occupation trial will embolden militia groups to take up armed land battles throughout the West. Dave Blanchard/OPB The Implication \nAmmon and Ryan Bundy are still in federal custody, despite an animated effort by Marcus Mumford to win his client’s release upon receiving the verdict. \nAfter arguing with Judge Brown for Ammon Bundy to be let go, Mumford was tackled by U.S. Marshals, allegedly tased, briefly detained and later released. \nThe Bundy brothers still face charges for the 2014 standoff in Bunkerville led by their father, Cliven Bundy. \nSeven Oregon occupiers still await trial in February, though the status of those proceedings could be in limbo. \nShawna Cox called Thursday’s outcome “just one win” in a larger movement to change how the federal government manages land in the American West. \nU.S. Attorney Billy Williams seemed to hope more people would shun the Bundys’ form of protest. \n“There are a good number of folks in rural America who are of the mind that you don’t take arms and take over a federal facility to prove your point,” Williams said. \nThe Oregon verdict will certainly color the conversation around the impending trial in Nevada. The result there — where the penalties for alleged crimes are slightly more harsh than Oregon — has the potential to make even bigger waves in the so-called patriot movement . \nBut occupiers and their supporters cooking out in downtown Portland took heart in the Oregon verdict and envisioned a long fight ahead of them on behalf of rural Americans. \nUnder downtown shade-trees, defendant Jeff Banta approached supporter David Zion Brugger, who decorated his hat and shirt with “NOT GUILTY” buttons, and shook his hand. \nIn a hushed voice, Banta said, “See you down the road.” Share On:",
		"thread_title": "41 Days And 8 Months Later: Dissecting The Oregon Standoff Trial",
		"title": "41 Days And 8 Months Later: Dissecting The Oregon Standoff Trial",
		"type": "bs",
		"uuid": "ac37153a9f6c4ba0a1168b775779551177164ff9"
	},
	"-KhIh6YKBQz8i8ewoNHy": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:51:12.571+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.20174095,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.193471,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j3cyz8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_Pifer"
				},
				"name": "Steven Pifer",
				"salience": 0.07527353,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.052626953,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.022328077,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.020940354,
				"type": "ORGANIZATION"
			},
			{
				"name": "tensions",
				"salience": 0.016967563,
				"type": "OTHER"
			},
			{
				"name": "Photo",
				"salience": 0.015337706,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.013926872,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.013926872,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.013926872,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.013695083,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.012581225,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c0sl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NPR"
				},
				"name": "NPR",
				"salience": 0.01233619,
				"type": "ORGANIZATION"
			},
			{
				"name": "situation",
				"salience": 0.012122525,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.011970199,
				"type": "OTHER"
			},
			{
				"name": "cheating",
				"salience": 0.010901431,
				"type": "OTHER"
			},
			{
				"name": "pacts",
				"salience": 0.010901431,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.009095131,
				"type": "EVENT"
			},
			{
				"name": "experts",
				"salience": 0.008270846,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.007927067,
				"type": "ORGANIZATION"
			},
			{
				"name": "point",
				"salience": 0.0075956313,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0071301963,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.006439438,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0063545206,
				"type": "OTHER"
			},
			{
				"name": "official",
				"salience": 0.006216974,
				"type": "PERSON"
			},
			{
				"name": "turn",
				"salience": 0.0058673318,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05zkzys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hans_M._Kristensen"
				},
				"name": "Hans Kristensen",
				"salience": 0.0058101895,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0055994056,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0054444512,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.0051748473,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.004705358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.004538547,
				"type": "PERSON"
			},
			{
				"name": "range",
				"salience": 0.0035843332,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01x7wr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brookings_Institution"
				},
				"name": "Brookings Institution",
				"salience": 0.003435475,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.0033579527,
				"type": "EVENT"
			},
			{
				"name": "each other",
				"salience": 0.0029389588,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.0029389588,
				"type": "EVENT"
			},
			{
				"name": "gesture",
				"salience": 0.0029238,
				"type": "OTHER"
			},
			{
				"name": "James Petras",
				"salience": 0.002732412,
				"type": "PERSON"
			},
			{
				"name": "missile launchers",
				"salience": 0.002653776,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.0026445216,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0025565624,
				"type": "PERSON"
			},
			{
				"name": "serviceman",
				"salience": 0.0025433737,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0025400138,
				"type": "ORGANIZATION"
			},
			{
				"name": "treaty",
				"salience": 0.002513808,
				"type": "OTHER"
			},
			{
				"name": "ranges",
				"salience": 0.002513808,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.002513808,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/029fm4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Intermediate-Range_Nuclear_Forces_Treaty"
				},
				"name": "Intermediate Range Nuclear Forces Treaty",
				"salience": 0.0024789672,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.0024200259,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.0024200259,
				"type": "LOCATION"
			},
			{
				"name": "administration",
				"salience": 0.0023395263,
				"type": "ORGANIZATION"
			},
			{
				"name": "issues",
				"salience": 0.0022981432,
				"type": "OTHER"
			},
			{
				"name": "displeasure",
				"salience": 0.0022981432,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0022981432,
				"type": "LOCATION"
			},
			{
				"name": "battery",
				"salience": 0.0022981432,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0022981432,
				"type": "EVENT"
			},
			{
				"name": "aircraft",
				"salience": 0.0022981432,
				"type": "OTHER"
			},
			{
				"name": "air campaign",
				"salience": 0.0022981432,
				"type": "EVENT"
			},
			{
				"name": "experts",
				"salience": 0.0022308754,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0021511712,
				"type": "LOCATION"
			},
			{
				"name": "treaty",
				"salience": 0.0020523928,
				"type": "OTHER"
			},
			{
				"name": "Photo",
				"salience": 0.0019841117,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conflict",
				"salience": 0.001971265,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01g4l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balts"
				},
				"name": "Baltic",
				"salience": 0.0018628389,
				"type": "LOCATION"
			},
			{
				"name": "arms",
				"salience": 0.0018609565,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0018609565,
				"type": "OTHER"
			},
			{
				"name": "missile launchers",
				"salience": 0.0017915115,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0016826517,
				"type": "ORGANIZATION"
			},
			{
				"name": "developments",
				"salience": 0.0016114961,
				"type": "OTHER"
			},
			{
				"name": "arsenals",
				"salience": 0.0016114961,
				"type": "OTHER"
			},
			{
				"name": "military exercises",
				"salience": 0.0016114961,
				"type": "EVENT"
			},
			{
				"name": "cruise",
				"salience": 0.0016114961,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0015609735,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.0015513541,
				"type": "OTHER"
			},
			{
				"name": "rehearsal",
				"salience": 0.0015513541,
				"type": "EVENT"
			},
			{
				"name": "parade",
				"salience": 0.0015513541,
				"type": "EVENT"
			},
			{
				"name": "images",
				"salience": 0.0015513541,
				"type": "WORK_OF_ART"
			},
			{
				"name": "warheads",
				"salience": 0.0015513541,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0015513541,
				"type": "LOCATION"
			},
			{
				"name": "size",
				"salience": 0.0015513541,
				"type": "OTHER"
			},
			{
				"name": "bombers",
				"salience": 0.0015513541,
				"type": "OTHER"
			},
			{
				"name": "Tensions",
				"salience": 0.0015333125,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.0014236873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0014147311,
				"type": "LOCATION"
			},
			{
				"name": "clarification",
				"salience": 0.001315609,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.001315609,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.001315609,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.001315609,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.001315609,
				"type": "EVENT"
			},
			{
				"name": "compliance",
				"salience": 0.001315609,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.001315609,
				"type": "OTHER"
			},
			{
				"name": "anonymity",
				"salience": 0.001315609,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0012826651,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c0bv_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow_International_Business_Center"
				},
				"name": "Moscow International Business Center",
				"salience": 0.001257427,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.0011886985,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0011349779,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0011349779,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.0011167658,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.0011167658,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern Europe",
				"salience": 0.001102758,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.0010877311,
				"type": "OTHER"
			},
			{
				"name": "suspension",
				"salience": 0.001008039,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/014vjs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federation_of_American_Scientists"
				},
				"name": "Federation of American Scientists",
				"salience": 0.0009919207,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nuclear Information Project",
				"salience": 0.0009919207,
				"type": "ORGANIZATION"
			},
			{
				"name": "experts",
				"salience": 0.0009910055,
				"type": "PERSON"
			},
			{
				"name": "escalation",
				"salience": 0.0009827936,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.0009827936,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0009827936,
				"type": "OTHER"
			},
			{
				"name": "convoy",
				"salience": 0.0009827936,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0009827936,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0009827936,
				"type": "LOCATION"
			},
			{
				"name": "military equipment",
				"salience": 0.0009827936,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.0009827936,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0009827936,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0009827936,
				"type": "ORGANIZATION"
			},
			{
				"name": "nonproliferation",
				"salience": 0.0009827936,
				"type": "OTHER"
			},
			{
				"name": "disagreements",
				"salience": 0.0009827936,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.0009827936,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.00096707884,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.00095489214,
				"type": "ORGANIZATION"
			},
			{
				"name": "Satan 2",
				"salience": 0.00095489214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01xq1w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Victory_Day_(9_May)"
				},
				"name": "Victory Day",
				"salience": 0.00095489214,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dv_mb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/9K720_Iskander"
				},
				"name": "Iskander-M",
				"salience": 0.00095489214,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00095489214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonia",
				"salience": 0.0009199084,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04g5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latvia"
				},
				"name": "Latvia",
				"salience": 0.0009199084,
				"type": "LOCATION"
			},
			{
				"name": "President",
				"salience": 0.0008747448,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.0008342347,
				"type": "OTHER"
			},
			{
				"name": "Special Verification Commission",
				"salience": 0.0008097545,
				"type": "ORGANIZATION"
			},
			{
				"name": "terms",
				"salience": 0.00071575755,
				"type": "OTHER"
			},
			{
				"name": "co-existence",
				"salience": 0.00071575755,
				"type": "OTHER"
			},
			{
				"name": "saber-rattling",
				"salience": 0.00071575755,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00071575755,
				"type": "PERSON"
			},
			{
				"name": "horizon",
				"salience": 0.00071575755,
				"type": "LOCATION"
			},
			{
				"name": "professor",
				"salience": 0.00071575755,
				"type": "PERSON"
			},
			{
				"name": "powers",
				"salience": 0.00071575755,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.00071575755,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00071575755,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04f47py",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Pressphoto_Agency"
				},
				"name": "European Pressphoto Agency",
				"salience": 0.00069855567,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.000683882,
				"type": "OTHER"
			},
			{
				"name": "news conference",
				"salience": 0.000683882,
				"type": "EVENT"
			},
			{
				"name": "File photo",
				"salience": 0.000683882,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bit",
				"salience": 0.00068035116,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00062174775,
				"type": "ORGANIZATION"
			},
			{
				"name": "words",
				"salience": 0.0006174634,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0006174634,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0006174634,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.00060487416,
				"type": "LOCATION"
			},
			{
				"name": "Liepupe",
				"salience": 0.00060487416,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "US Army",
				"salience": 0.00060487416,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lithuania"
				},
				"name": "Lithuania",
				"salience": 0.00060487416,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0005582735,
				"type": "OTHER"
			},
			{
				"name": "poke",
				"salience": 0.0005346545,
				"type": "OTHER"
			},
			{
				"name": "weapons-grade plutonium",
				"salience": 0.0005346545,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0005346545,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0005346545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00044050367,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.00044050367,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02dlk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agence_France-Presse"
				},
				"name": "AFP",
				"salience": 0.00032903632,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/a4a0ca7d-03f6-4b58-a858-7b44fa2c7c3c.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T17:51:12.571+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Nuclear tensions between US, Russia reach ‘dangerous’ point 10/31/2016 \nPRESS TV \nUS-Russian relations have slipped to their lowest point since the end of the Cold War, with tensions now spilling over to nuclear pacts and each side accusing the other of cheating, experts say. \n“I would have to say that, without question, this is the low point in US-Russian relations since the end of the Cold War,” Steven Pifer, an arms control expert at the Brookings Institution, told NPR. \nThe relationship took a turn for the worse two years ago with the conflict in Ukraine and slid lower last year with Russia’s air campaign in Syria, noted Pifer, a former US ambassador to Ukraine. \nThis year, tensions have continued to mount with Russian and US aircraft buzzing each other over the Baltic and Washington accusing Moscow of trying to interfere in the US presidential elections, he added. \nBickering over nuclear issues has also increased markedly in recent months. \nEarly this month, Russia moved a battery of nuclear-capable missile launchers within range of three Baltic states, in what US officials said was a gesture to express displeasure with NATO. A Russian serviceman walks past Russian Iskander-M missile launchers before a rehearsal for the Victory Day parade, with the Moscow International Business Center also known as ”Moskva-City” seen in the background, at a range in Moscow, Russia, May 5, 2016. (Photo by Reuters) \nIn late October, Russia unveiled images of a new intercontinental ballistic missile dubbed the Satan 2, which, it says, can carry up to 15 separate warheads powerful enough to destroy an area the size of Texas. \nThe US, in September, flew three long-range nuclear bombers over Eastern Europe to participate in NATO military exercises. \nThese developments have worried nuclear arms experts. \n“We are in a dangerous situation,” Hans Kristensen, director of the Nuclear Information Project at the Federation of American Scientists, told NPR. “Certainly a situation that is much more dire or tense than it was 10 years ago.” \nIn 1987, four years before the Soviet Union collapsed, Washington and Moscow signed a long-negotiated treaty – known as the Intermediate Range Nuclear Forces Treaty – to eliminate their arsenals of nuclear and conventional ground-launched ballistic and cruise missiles with ranges of 500 to 5,500 kilometers. \n“Since May 2013, the Obama administration has repeatedly raised concerns with Russia regarding its lack of compliance with the INF Treaty,” a senior administration official told NPR on condition of anonymity. \nThe official said Washington has called for a rare meeting of the treaty’s Special Verification Commission “in the coming weeks” to try to resolve the matter. \n“I actually think this is a good step,” Pifer said of the decision. \nThe US claims that an intermediate-range missile being developed by Russia is not in line with the INF Treaty and wants clarification from Moscow. \n“What the administration has said is that they provided enough information to the Russians so that the Russians could identify the missile in question. The Russians thus far have said no, they haven’t got enough information, so you’re in that kind of war of words,” Pifer added. President Putin speaks during a news conference. (File photo by AFP) \nThe war of words further escalated in early October when Russian President Vladimir Putin announced the suspension of a Cold War deal with the US to dispose of weapons-grade plutonium. \n“That, I believe, was a little bit of a poke at President Obama, who attaches a lot of importance to the nuclear nonproliferation agenda,” Pifer said. \nTensions are bound to mount even further over the next few months as the US and its NATO allies prepare to move thousands of troops as well as heavy military equipment to countries along and near Russia’s border, namely Estonia, Latvia and Lithuania. A US Army convoy rolls through Liepupe, Latvia, on its way from Estonia to Germany. (Photo by European Pressphoto Agency) \n“This is a gradual sort of escalation of tensions between the two sides that goes beyond discourse and just disagreements over a treaty,” Kristensen said. “It’s getting pretty deep now.” \nThe rising tensions between the two nuclear powers have other experts worried. \n“We could head into a nuclear conflict which would devastate humanity,” American writer and retired professor James Petras told Press TV earlier this month. \n“We need to move away from this saber-rattling from Washington into a position that could come to terms with peaceful co-existence, but I don’t see that on the horizon in present or the near future with either Hillary Clinton or Donald Trump as presidential candidates,” he said.",
		"thread_title": "Nuclear tensions between US, Russia reach ‘dangerous’ point",
		"title": "Nuclear tensions between US, Russia reach ‘dangerous’ point",
		"type": "bs",
		"uuid": "41b34b4ee36f7aa8ceb9b8ab63254658743d423b"
	},
	"-KhIh6dE-LhtPxaq7vIs": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:51:13.787+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01wmgs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freddy_Krueger"
				},
				"name": "Freddy Krueger",
				"salience": 0.28649828,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.16281027,
				"type": "PERSON"
			},
			{
				"name": "Man",
				"salience": 0.09656682,
				"type": "PERSON"
			},
			{
				"name": "costume",
				"salience": 0.060579043,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Freddy Krueger Costume Crashes Halloween Party",
				"salience": 0.044111412,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.040908176,
				"type": "EVENT"
			},
			{
				"name": "fire",
				"salience": 0.034514304,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.034237057,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lq2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halloween"
				},
				"name": "Halloween",
				"salience": 0.021209579,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.018390954,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.017548708,
				"type": "PERSON"
			},
			{
				"name": "partygoers",
				"salience": 0.016000178,
				"type": "PERSON"
			},
			{
				"name": "house party",
				"salience": 0.014836228,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.014286168,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.012389589,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.010736651,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.010556119,
				"type": "PERSON"
			},
			{
				"name": "horror film series",
				"salience": 0.010337783,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Violence",
				"salience": 0.008772936,
				"type": "OTHER"
			},
			{
				"name": "guests",
				"salience": 0.008772936,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f2w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Antonio"
				},
				"name": "San Antonio",
				"salience": 0.007642539,
				"type": "LOCATION"
			},
			{
				"name": "All",
				"salience": 0.0069003487,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05tfy7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KENS"
				},
				"name": "KENS 5",
				"salience": 0.006620787,
				"type": "ORGANIZATION"
			},
			{
				"name": "hospital",
				"salience": 0.006560043,
				"type": "LOCATION"
			},
			{
				"name": "suspects",
				"salience": 0.006560043,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08ll52",
					"wikipedia_url": "http://en.wikipedia.org/wiki/A_Nightmare_on_Elm_Street"
				},
				"name": "Nightmare on Elm Street",
				"salience": 0.006374328,
				"type": "LOCATION"
			},
			{
				"name": "incident",
				"salience": 0.0061580907,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.004781372,
				"type": "OTHER"
			},
			{
				"name": "costume",
				"salience": 0.0045688683,
				"type": "WORK_OF_ART"
			},
			{
				"name": "men",
				"salience": 0.004125949,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.003573486,
				"type": "PERSON"
			},
			{
				"name": "gun",
				"salience": 0.003573486,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "authorities",
				"salience": 0.0031087522,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06nnpz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Antonio_Express-News"
				},
				"name": "San Antonio Express-News",
				"salience": 0.0029450268,
				"type": "ORGANIZATION"
			},
			{
				"name": "conditions",
				"salience": 0.0024436861,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/fox59-background17.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T17:51:13.787+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Man in Freddy Krueger Costume Crashes Halloween Party and Shoots 5 People 10/31/2016 \nTIME \nA man wearing a Freddy Krueger costume opened fire at a Halloween party in Texas on Sunday, injuring five people , police said. \nThe man, dressed as the villain from the Nightmare on Elm Street horror film series, arrived at the San Antonio house party uninvited and with several other men, KENS 5 reports. Violence erupted about 5 a.m. when partygoers tried kicking out the unwelcome guests. The unidentified man dressed as Freddy Krueger whipped out a gun from his costume and fired, striking four men and one woman, authorities said. \nAll of the suspects fled, and those injured were taken to the hospital, according to the San Antonio Express-News . Their conditions were unclear Monday. \nThe incident is under investigation.",
		"thread_title": "Man in Freddy Krueger Costume Crashes Halloween Party and Shoots 5 People",
		"title": "Man in Freddy Krueger Costume Crashes Halloween Party and Shoots 5 People",
		"type": "bs",
		"uuid": "922e96b9bb0897f7cb8b7e18e5b1eb8e65528689"
	},
	"-KhIh6r3R8P2iodKvSbw": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T19:54:37.563+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.36909768,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.27983174,
				"type": "LOCATION"
			},
			{
				"name": "Fight Terrorism",
				"salience": 0.044871848,
				"type": "OTHER"
			},
			{
				"name": "Joint Drills",
				"salience": 0.016613409,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01561c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Special_forces"
				},
				"name": "Special Forces",
				"salience": 0.01432397,
				"type": "ORGANIZATION"
			},
			{
				"name": "drills",
				"salience": 0.014290771,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.013557248,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.012924006,
				"type": "OTHER"
			},
			{
				"name": "combat capability",
				"salience": 0.01203664,
				"type": "OTHER"
			},
			{
				"name": "NEWS",
				"salience": 0.01203664,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.009096507,
				"type": "PERSON"
			},
			{
				"name": "drills",
				"salience": 0.008529442,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.008291011,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.006315075,
				"type": "OTHER"
			},
			{
				"name": "combat skills",
				"salience": 0.0061699487,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.0061699487,
				"type": "OTHER"
			},
			{
				"name": "Fei",
				"salience": 0.005692463,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c0rd6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/People's_Liberation_Army_Special_Operations_Forces"
				},
				"name": "Special Forces of China",
				"salience": 0.00486127,
				"type": "ORGANIZATION"
			},
			{
				"name": "members",
				"salience": 0.004276366,
				"type": "PERSON"
			},
			{
				"name": "military experts",
				"salience": 0.0041300976,
				"type": "PERSON"
			},
			{
				"name": "Sputnik",
				"salience": 0.0039679077,
				"type": "ORGANIZATION"
			},
			{
				"name": "drills",
				"salience": 0.003946589,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0037046445,
				"type": "OTHER"
			},
			{
				"name": "exercises",
				"salience": 0.0032540117,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0029789964,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0026356368,
				"type": "LOCATION"
			},
			{
				"name": "place",
				"salience": 0.0026238805,
				"type": "OTHER"
			},
			{
				"name": "partnership",
				"salience": 0.0025990123,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.00254507,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.00254507,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.00254507,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00254507,
				"type": "EVENT"
			},
			{
				"name": "attention",
				"salience": 0.00254507,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00254507,
				"type": "LOCATION"
			},
			{
				"name": "vicinity",
				"salience": 0.00254507,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00254507,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0024706323,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0024706323,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.002431888,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0022928827,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0022859715,
				"type": "LOCATION"
			},
			{
				"name": "military exercises",
				"salience": 0.0021975376,
				"type": "EVENT"
			},
			{
				"name": "oil",
				"salience": 0.002152165,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.002152165,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0020173853,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.0020173853,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0019857388,
				"type": "OTHER"
			},
			{
				"name": "combat training",
				"salience": 0.0019843532,
				"type": "OTHER"
			},
			{
				"name": "Expert",
				"salience": 0.0018023718,
				"type": "PERSON"
			},
			{
				"name": "oil producer",
				"salience": 0.0017850726,
				"type": "ORGANIZATION"
			},
			{
				"name": "title",
				"salience": 0.0017850726,
				"type": "OTHER"
			},
			{
				"name": "regard",
				"salience": 0.0017850726,
				"type": "OTHER"
			},
			{
				"name": "oil reserves",
				"salience": 0.0017850726,
				"type": "OTHER"
			},
			{
				"name": "economics",
				"salience": 0.0017850726,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0017850726,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0017850726,
				"type": "OTHER"
			},
			{
				"name": "improvement",
				"salience": 0.0017184886,
				"type": "OTHER"
			},
			{
				"name": "hostage rescue",
				"salience": 0.0017184886,
				"type": "OTHER"
			},
			{
				"name": "Academy",
				"salience": 0.0017184886,
				"type": "ORGANIZATION"
			},
			{
				"name": "sphere",
				"salience": 0.0017184886,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0016829952,
				"type": "LOCATION"
			},
			{
				"name": "importer",
				"salience": 0.0016829952,
				"type": "ORGANIZATION"
			},
			{
				"name": "importer",
				"salience": 0.0016829952,
				"type": "ORGANIZATION"
			},
			{
				"name": "expert",
				"salience": 0.0016081074,
				"type": "PERSON"
			},
			{
				"name": "exercises",
				"salience": 0.0016009292,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017236",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chongqing"
				},
				"name": "Chungqing",
				"salience": 0.0015672214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghan",
				"salience": 0.0015672214,
				"type": "LOCATION"
			},
			{
				"name": "partner",
				"salience": 0.0015073634,
				"type": "PERSON"
			},
			{
				"name": "expansion joint interest",
				"salience": 0.0015073634,
				"type": "OTHER"
			},
			{
				"name": "supplier",
				"salience": 0.0014574655,
				"type": "ORGANIZATION"
			},
			{
				"name": "addition",
				"salience": 0.0014574655,
				"type": "OTHER"
			},
			{
				"name": "Cooperation",
				"salience": 0.0014093813,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0014030893,
				"type": "OTHER"
			},
			{
				"name": "Gao Fei",
				"salience": 0.0013530884,
				"type": "OTHER"
			},
			{
				"name": "Arab East",
				"salience": 0.0012217544,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0011713915,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0011713915,
				"type": "LOCATION"
			},
			{
				"name": "partner",
				"salience": 0.0011698334,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/053n6l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Federation_for_Equestrian_Sports"
				},
				"name": "Fei",
				"salience": 0.0011475215,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.0010888905,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0010888905,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0010888905,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0010350498,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0010220105,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0010220105,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.0010143704,
				"type": "LOCATION"
			},
			{
				"name": "role",
				"salience": 0.0009635385,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00093200954,
				"type": "LOCATION"
			},
			{
				"name": "hostage",
				"salience": 0.0009158919,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0009158919,
				"type": "OTHER"
			},
			{
				"name": "Ajdar Kuratov",
				"salience": 0.00088656,
				"type": "PERSON"
			},
			{
				"name": "diplomacy",
				"salience": 0.00082385045,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0008202663,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.0007931005,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.0007931005,
				"type": "EVENT"
			},
			{
				"name": "presence",
				"salience": 0.0007931005,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0007931005,
				"type": "PERSON"
			},
			{
				"name": "Cases",
				"salience": 0.0007931005,
				"type": "OTHER"
			},
			{
				"name": "airplanes",
				"salience": 0.0007931005,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.00076349766,
				"type": "OTHER"
			},
			{
				"name": "expert",
				"salience": 0.0007611888,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.000757789,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.000728994,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0006842084,
				"type": "OTHER"
			},
			{
				"name": "Russian Institute for Strategic Studies",
				"salience": 0.00067026133,
				"type": "ORGANIZATION"
			},
			{
				"name": "specifics",
				"salience": 0.0006612048,
				"type": "OTHER"
			},
			{
				"name": "player",
				"salience": 0.0006312485,
				"type": "PERSON"
			},
			{
				"name": "affairs",
				"salience": 0.00059246534,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00059246534,
				"type": "OTHER"
			},
			{
				"name": "arena",
				"salience": 0.00059246534,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/1036026365.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T19:54:37.563+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Joint Drills Between China, Saudis To ‘Fight Terrorism’ 10/31/2016 \nSPUTNIK NEWS \nChina is improving its Special Forces combat capability to protect national interests abroad. Sputnik spoke with Russian experts about the first antiterrorist drills of the Special Forces of China and Saudi Arabia. \nThe joint drills demonstrating combat skills and tactics took place for two weeks on the ground, in the vicinity of the Chinese city of Chungqing. \nThe drills came to an end on Thursday and according to reports, 25 members of the Special Forces from each side took part in the exercises. Among the observers were Afghan military experts, who drew attention to the training that was focused on hostage rescue and improvement of overall combat training. \nSaudi Arabia is the first country in the Arab East with whom China has held bilateral military exercises. \nExpert from the Diplomatic Academy of China, Gao Fei, believes that it is natural for China and Saudi Arabia to have a partnership in this sphere. \n“Saudi Arabia is a major regional power and the largest oil-producing country. It competes with Russia for the title of the world’s leading oil producer. In regard to oil reserves, it also holds the first place in the world,” Fei said. \nHe further said that the country plays an important role in economics, politics and security in the whole region. In short, Saudi Arabia is an influential regional power. \nAccording to Fei, “Last month, China surpassed the US as world’s largest importer of oil. Cooperation between China and Saudi Arabia as an importer and supplier of oil shows mutual benefit and common interests.” \nIn addition, China is already a major player in the international arena; its diplomacy has its own specifics. It not only gives meaning to its own interests, but also in international affairs takes the role of the responsible power. \nThe expert further said that in the long term “cooperation between China and Saudi Arabia will contribute to solving existing global problems, form a new world order, help search for consensus on specific issues and contribute to expansion joint interest.” \nThe choice of Saudi Arabia as China’s partner to conduct anti-terrorist exercises is not surprising, according to an expert at the Russian Institute for Strategic Studies, Ajdar Kuratov. \nKuratov said that Saudi Arabia is the main economic partner of China in the Middle East, a region where growth of China’s presence is particularly noticeable. \nChina’s leadership is likely quite concerned with terrorism against the country and its citizens. Cases such as hostage taking on airplanes and other public places and attacks on public buildings are a big concern for the country.",
		"thread_title": "Joint Drills Between China, Saudis To ‘Fight Terrorism’",
		"title": "Joint Drills Between China, Saudis To ‘Fight Terrorism’",
		"type": "bs",
		"uuid": "9179176732b0686c9fe67a0e17c43aebe380aa22"
	},
	"-KhIh78vXDsZbtYT3EAX": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T19:54:37.595+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.26216152,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.22415203,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.056807738,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.022265851,
				"type": "OTHER"
			},
			{
				"name": "info",
				"salience": 0.020129682,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.018881978,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.018881978,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01914",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beijing"
				},
				"name": "Beijing",
				"salience": 0.018565174,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.018511815,
				"type": "WORK_OF_ART"
			},
			{
				"name": "war plans",
				"salience": 0.017458528,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.017458528,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.017458528,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.015779017,
				"type": "PERSON"
			},
			{
				"name": "agencies",
				"salience": 0.015779017,
				"type": "ORGANIZATION"
			},
			{
				"name": "Glenn Duffie Shriver",
				"salience": 0.014155349,
				"type": "PERSON"
			},
			{
				"name": "email accounts",
				"salience": 0.01368025,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.01368025,
				"type": "EVENT"
			},
			{
				"name": "nukes",
				"salience": 0.01368025,
				"type": "LOCATION"
			},
			{
				"name": "staple",
				"salience": 0.008987265,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "RUSSIA",
				"salience": 0.0084457565,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.004727886,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.004727886,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0043641003,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.004269802,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.004269802,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.004002688,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.004002688,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0039235046,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0038854294,
				"type": "ORGANIZATION"
			},
			{
				"name": "version",
				"salience": 0.0037261604,
				"type": "WORK_OF_ART"
			},
			{
				"name": "plans",
				"salience": 0.0036983488,
				"type": "OTHER"
			},
			{
				"name": "entities",
				"salience": 0.0036983488,
				"type": "ORGANIZATION"
			},
			{
				"name": "military forces",
				"salience": 0.0033398103,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.0033398103,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0033171896,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0033171896,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0030458812,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.0029955343,
				"type": "OTHER"
			},
			{
				"name": "intelligence collection operations",
				"salience": 0.0029955343,
				"type": "OTHER"
			},
			{
				"name": "draft",
				"salience": 0.0028926006,
				"type": "EVENT"
			},
			{
				"name": "designs",
				"salience": 0.0028926006,
				"type": "WORK_OF_ART"
			},
			{
				"name": "weapons systems",
				"salience": 0.0028926006,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0028838639,
				"type": "OTHER"
			},
			{
				"name": "sectors",
				"salience": 0.0028689967,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0028079986,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.0027847607,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0027639635,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.002752409,
				"type": "WORK_OF_ART"
			},
			{
				"name": "war plans",
				"salience": 0.0025943501,
				"type": "OTHER"
			},
			{
				"name": "cyber operations",
				"salience": 0.0024460442,
				"type": "OTHER"
			},
			{
				"name": "sectors",
				"salience": 0.0023426844,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0022553178,
				"type": "ORGANIZATION"
			},
			{
				"name": "document",
				"salience": 0.0022553178,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0022475857,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0022474548,
				"type": "WORK_OF_ART"
			},
			{
				"name": "data",
				"salience": 0.0021183554,
				"type": "OTHER"
			},
			{
				"name": "entities",
				"salience": 0.0021183554,
				"type": "OTHER"
			},
			{
				"name": "infrastructure entities",
				"salience": 0.0021183554,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.0021183554,
				"type": "OTHER"
			},
			{
				"name": "spies",
				"salience": 0.0020288252,
				"type": "ORGANIZATION"
			},
			{
				"name": "human infiltration",
				"salience": 0.0020288252,
				"type": "OTHER"
			},
			{
				"name": "platforms",
				"salience": 0.0019531492,
				"type": "OTHER"
			},
			{
				"name": "approaches",
				"salience": 0.0019531492,
				"type": "OTHER"
			},
			{
				"name": "contingencies",
				"salience": 0.0019531492,
				"type": "ORGANIZATION"
			},
			{
				"name": "region",
				"salience": 0.0019531492,
				"type": "LOCATION"
			},
			{
				"name": "efforts",
				"salience": 0.0019531492,
				"type": "OTHER"
			},
			{
				"name": "insight",
				"salience": 0.0019531492,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.0019260694,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0018276952,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0018046796,
				"type": "OTHER"
			},
			{
				"name": "Washington Free Beacon",
				"salience": 0.0017812263,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.0016776107,
				"type": "OTHER"
			},
			{
				"name": "networks",
				"salience": 0.001656483,
				"type": "OTHER"
			},
			{
				"name": "power grids",
				"salience": 0.001656483,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cxd4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Pacific_Command"
				},
				"name": "US Pacific Command",
				"salience": 0.0015974544,
				"type": "ORGANIZATION"
			},
			{
				"name": "data",
				"salience": 0.0015827637,
				"type": "OTHER"
			},
			{
				"name": "China Economic and Security Review Commission",
				"salience": 0.0015378534,
				"type": "ORGANIZATION"
			},
			{
				"name": "academics",
				"salience": 0.0014683359,
				"type": "PERSON"
			},
			{
				"name": "government agents",
				"salience": 0.0014291406,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0014291406,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0014291406,
				"type": "PERSON"
			},
			{
				"name": "duplicates",
				"salience": 0.0013871436,
				"type": "OTHER"
			},
			{
				"name": "fingerprints",
				"salience": 0.0013608028,
				"type": "OTHER"
			},
			{
				"name": "intelligence operations",
				"salience": 0.0013313455,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0013019523,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.001237579,
				"type": "ORGANIZATION"
			},
			{
				"name": "predation",
				"salience": 0.001237579,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.001223188,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Party",
				"salience": 0.0010409574,
				"type": "ORGANIZATION"
			},
			{
				"name": "access",
				"salience": 0.00090139883,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00090139883,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.00090139883,
				"type": "ORGANIZATION"
			},
			{
				"name": "target",
				"salience": 0.00086126546,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.0007776374,
				"type": "WORK_OF_ART"
			},
			{
				"name": "studies",
				"salience": 0.0007776374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0007617859,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hmvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/People's_Liberation_Army"
				},
				"name": "People's Liberation Army",
				"salience": 0.00073060044,
				"type": "ORGANIZATION"
			},
			{
				"name": "airstrikes",
				"salience": 0.0006733668,
				"type": "EVENT"
			},
			{
				"name": "groups",
				"salience": 0.0006733668,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h7m520",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Front_Work_Department"
				},
				"name": "United Front Work Department",
				"salience": 0.0006407265,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0464w4s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/People's_Liberation_Army_General_Political_Department"
				},
				"name": "PLA General Political Department",
				"salience": 0.0006407265,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02189",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Communist_Party_of_China"
				},
				"name": "Communist Party",
				"salience": 0.0006407265,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04vf8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manuscript"
				},
				"name": "MSS",
				"salience": 0.0005548075,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.00041443223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cmcxm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Atomics_MQ-9_Reaper"
				},
				"name": "MQ-9 Reaper",
				"salience": 0.00041443223,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.00041443223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00041443223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gwx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_State_Security_(China)"
				},
				"name": "Ministry of State Security",
				"salience": 0.00023418489,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/581338b4c461884e208b4593.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T19:54:37.595+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "China repeatedly hacked US, stole data on nukes, FBI & war plans 10/31/2016 \nRUSSIA TODAY Chinese intelligence repeatedly targeted US national security agencies and email accounts of US officials, a soon-to-be-released report says, adding that Beijing spies targeted info on nuclear weapons, FBI investigations and war plans. \n“Chinese intelligence has repeatedly infiltrated US national security entities and extracted information with serious consequences for US national security, including information on the plans and operations of US military forces and the designs of US weapons and weapons systems,” a draft annual report for 2016 said, as cited by the Washington Free Beacon. \nThe final version of the report of the US-China Economic and Security Review Commission is to be released November 16. \nThe hacks allowed Beijing to gain “insight into the operation of US platforms and the operational approaches of US forces to potential contingencies in the region,” it goes on. \nAccording to the document, China applied efforts at “cyber and human infiltration” of national security sectors, including the FBI and the US Pacific Command. The report says that Washington “faces a large and growing threat to its national security from Chinese intelligence collection operations.” \nChinese spies reportedly hacked into secret US war plans, gaining information about nuclear weapons, and snooping into electrical power grids and financial networks. US Diplomatic, economic, and defense industrial sectors have also been the targets of China. \n“US critical infrastructure entities are a major target of Chinese cyber operations, and China is capable of significantly disrupting or damaging these entities,” the report said. \nThe Chinese allegedly hacked into secret data of the MQ-9 Reaper drone, which has been a staple of US airstrikes in Iraq, Afghanistan and Pakistan over the past 9 years. \nUS academics who work for the groups involved in China studies have also been reportedly targeted by Beijing. The document names an American student in China, Glenn Duffie Shriver, as a target. Shriver was convicted of conspiracy to spy for China in 2010. He was released in 2013. \nObama administration officials have not escaped China’s alleged digital predation. \n“Among the information extracted were 5.6 million fingerprints, some of which could be used to identify undercover US government agents or to create duplicates of biometric data to obtain access to classified areas,” the report said. \nSeveral organizations allegedly contribute to China’s intelligence operations, including the Ministry of State Security (MSS), the People’s Liberation Army (PLA), and Communist Party military, as well as the PLA General Political Department and the Party’s United Front Work Department.",
		"thread_title": "China repeatedly hacked US, stole data on nukes, FBI & war plans",
		"title": "China repeatedly hacked US, stole data on nukes, FBI & war plans",
		"type": "bs",
		"uuid": "046dc3d06f7181f4e9e7e0ba7d0bfc521befe988"
	},
	"-KhIh7dD6bpDLRPd_7ZM": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T19:54:37.665+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.16863906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.11343332,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.04419443,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.028086247,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.025561752,
				"type": "PERSON"
			},
			{
				"name": "vandals",
				"salience": 0.025265614,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.018954765,
				"type": "PERSON"
			},
			{
				"name": "circumstances",
				"salience": 0.017409736,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.01682575,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.016544342,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.016124247,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.012373684,
				"type": "OTHER"
			},
			{
				"name": "Ready For Civil Unrest",
				"salience": 0.012214288,
				"type": "ORGANIZATION"
			},
			{
				"name": "matter",
				"salience": 0.010837058,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.010247125,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.009802108,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.009802108,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.009057105,
				"type": "OTHER"
			},
			{
				"name": "survey",
				"salience": 0.008740031,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01sb5r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Walsh"
				},
				"name": "Walsh",
				"salience": 0.008709031,
				"type": "PERSON"
			},
			{
				"name": "unrest",
				"salience": 0.008668768,
				"type": "OTHER"
			},
			{
				"name": "headquarters",
				"salience": 0.0078505315,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0076103318,
				"type": "EVENT"
			},
			{
				"name": "amount",
				"salience": 0.0071377424,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0070844563,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0063975286,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.0063975286,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0063975286,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0063975286,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0063975286,
				"type": "LOCATION"
			},
			{
				"name": "BLOG",
				"salience": 0.0062097125,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.005838922,
				"type": "ORGANIZATION"
			},
			{
				"name": "voting machines",
				"salience": 0.0055407505,
				"type": "OTHER"
			},
			{
				"name": "temper tantrum",
				"salience": 0.0055407505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b76qwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Walsh_(Illinois_politician)"
				},
				"name": "Joe Walsh",
				"salience": 0.0055362247,
				"type": "PERSON"
			},
			{
				"name": "transfer",
				"salience": 0.005367199,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0051618665,
				"type": "PERSON"
			},
			{
				"name": "other",
				"salience": 0.005048567,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01fmnr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Periscope"
				},
				"name": "Periscope",
				"salience": 0.0048920265,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Clintons",
				"salience": 0.004560276,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-Trump",
				"salience": 0.0043630237,
				"type": "ORGANIZATION"
			},
			{
				"name": "something",
				"salience": 0.0041915663,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.004039883,
				"type": "EVENT"
			},
			{
				"name": "Paul Foster",
				"salience": 0.0039943513,
				"type": "PERSON"
			},
			{
				"name": "enemies",
				"salience": 0.0038651107,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0037323516,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0037323516,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0037323516,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0036589524,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0034117221,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.0033701295,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0qjfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood_Walk_of_Fame"
				},
				"name": "Hollywood Walk of Fame",
				"salience": 0.0032868008,
				"type": "LOCATION"
			},
			{
				"name": "Zeitgeist",
				"salience": 0.0032612388,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.003124315,
				"type": "LOCATION"
			},
			{
				"name": "democracy",
				"salience": 0.0029536076,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0029184418,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.0029184418,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.0029033825,
				"type": "OTHER"
			},
			{
				"name": "confidence",
				"salience": 0.002879669,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0027722141,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0027298909,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.0027187308,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0027074264,
				"type": "OTHER"
			},
			{
				"name": "following",
				"salience": 0.0026369889,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0026351477,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0026351477,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0026351477,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0026351477,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.0026351477,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0026351477,
				"type": "PERSON"
			},
			{
				"name": "sledgehammer",
				"salience": 0.0026351477,
				"type": "OTHER"
			},
			{
				"name": "pick-ax",
				"salience": 0.0026351477,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "violence",
				"salience": 0.0026172767,
				"type": "OTHER"
			},
			{
				"name": "musket",
				"salience": 0.0026074392,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.002573561,
				"type": "LOCATION"
			},
			{
				"name": "star",
				"salience": 0.0025517514,
				"type": "PERSON"
			},
			{
				"name": "Feras Jabro",
				"salience": 0.0025309245,
				"type": "PERSON"
			},
			{
				"name": "mob",
				"salience": 0.0025254826,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.002519606,
				"type": "PERSON"
			},
			{
				"name": "shirt",
				"salience": 0.0024421401,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "T-shirt",
				"salience": 0.0024421401,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "supporters",
				"salience": 0.0023424095,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0023128993,
				"type": "OTHER"
			},
			{
				"name": "hits",
				"salience": 0.002281901,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.002281901,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.002281901,
				"type": "OTHER"
			},
			{
				"name": "reverse swastika",
				"salience": 0.0022632598,
				"type": "OTHER"
			},
			{
				"name": "Rick Darling",
				"salience": 0.0021193079,
				"type": "PERSON"
			},
			{
				"name": "baseball cap",
				"salience": 0.0021147504,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0021147504,
				"type": "OTHER"
			},
			{
				"name": "progressives",
				"salience": 0.0021010549,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0020463835,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.0020463835,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.001992582,
				"type": "ORGANIZATION"
			},
			{
				"name": "protest",
				"salience": 0.0019700045,
				"type": "EVENT"
			},
			{
				"name": "article",
				"salience": 0.0019351435,
				"type": "WORK_OF_ART"
			},
			{
				"name": "other",
				"salience": 0.0019024485,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0018476943,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.0018476943,
				"type": "LOCATION"
			},
			{
				"name": "cases",
				"salience": 0.0018476943,
				"type": "OTHER"
			},
			{
				"name": "cars",
				"salience": 0.0018476943,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "swastika",
				"salience": 0.0018476943,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0018476943,
				"type": "OTHER"
			},
			{
				"name": "pick-ax",
				"salience": 0.0017787274,
				"type": "OTHER"
			},
			{
				"name": "sledgehammer",
				"salience": 0.0017787274,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0017787274,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.0017787274,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0017278466,
				"type": "EVENT"
			},
			{
				"name": "excerpt",
				"salience": 0.0017046854,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protest",
				"salience": 0.0016706197,
				"type": "EVENT"
			},
			{
				"name": "anti-Trump",
				"salience": 0.0016586463,
				"type": "OTHER"
			},
			{
				"name": "measure",
				"salience": 0.0016203754,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0016012617,
				"type": "EVENT"
			},
			{
				"name": "van",
				"salience": 0.0015999574,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "paint",
				"salience": 0.0015999574,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0015999574,
				"type": "EVENT"
			},
			{
				"name": "coast",
				"salience": 0.0015999574,
				"type": "LOCATION"
			},
			{
				"name": "building",
				"salience": 0.0015999574,
				"type": "LOCATION"
			},
			{
				"name": "incidents",
				"salience": 0.0015999574,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0015999574,
				"type": "EVENT"
			},
			{
				"name": "policies",
				"salience": 0.0015999574,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0015999574,
				"type": "OTHER"
			},
			{
				"name": "instances",
				"salience": 0.0015402334,
				"type": "OTHER"
			},
			{
				"name": "city construction worker",
				"salience": 0.0015402334,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0015402334,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.0015402334,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0015402334,
				"type": "EVENT"
			},
			{
				"name": "majority",
				"salience": 0.0015276483,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0015083982,
				"type": "OTHER"
			},
			{
				"name": "cars",
				"salience": 0.0015083982,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "supporter",
				"salience": 0.0015028848,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0014716502,
				"type": "PERSON"
			},
			{
				"name": "barmaid",
				"salience": 0.0013396887,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0013228062,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0013201346,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.0013061364,
				"type": "EVENT"
			},
			{
				"name": "service",
				"salience": 0.0013061364,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0013061364,
				"type": "PERSON"
			},
			{
				"name": "couple",
				"salience": 0.0013061364,
				"type": "PERSON"
			},
			{
				"name": "photo",
				"salience": 0.0013061364,
				"type": "WORK_OF_ART"
			},
			{
				"name": "back",
				"salience": 0.0013061364,
				"type": "OTHER"
			},
			{
				"name": "thugs",
				"salience": 0.0013061364,
				"type": "PERSON"
			},
			{
				"name": "street",
				"salience": 0.0013061364,
				"type": "LOCATION"
			},
			{
				"name": "host",
				"salience": 0.0012791379,
				"type": "PERSON"
			},
			{
				"name": "following",
				"salience": 0.001263901,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0012479732,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0012479732,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.0012005444,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0261md",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cinema_of_the_United_States"
				},
				"name": "Tinseltown",
				"salience": 0.0011760691,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0n3x2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orange_County,_North_Carolina"
				},
				"name": "Orange County",
				"salience": 0.0011372434,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0011267782,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.0011267782,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.0011267782,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "statement",
				"salience": 0.0011125779,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.0010847116,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0010798658,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.0010582823,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0tr3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bangor,_Maine"
				},
				"name": "Bangor",
				"salience": 0.0009847353,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0009847353,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi",
				"salience": 0.0009847353,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lifezette",
				"salience": 0.0009847353,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/050ks",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maine"
				},
				"name": "Maine",
				"salience": 0.0009847353,
				"type": "LOCATION"
			},
			{
				"name": "percentage",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0009756732,
				"type": "ORGANIZATION"
			},
			{
				"name": "another",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "suburbs",
				"salience": 0.0009756732,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "phone interview",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "martial law",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0009756732,
				"type": "ORGANIZATION"
			},
			{
				"name": "track",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0009756732,
				"type": "OTHER"
			},
			{
				"name": "6801 Hollywood Blvd",
				"salience": 0.00094797026,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02pgkkk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Apprentice_(U.S._TV_series)"
				},
				"name": "Apprentice",
				"salience": 0.00094797026,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00094001216,
				"type": "PERSON"
			},
			{
				"name": "Blue Lives Matter",
				"salience": 0.00092837325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.00092837325,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.00090887165,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00090887165,
				"type": "PERSON"
			},
			{
				"name": "outcome",
				"salience": 0.00088153116,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00082059996,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00082059996,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0r4yw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/El_Cajon,_California"
				},
				"name": "El Cajon",
				"salience": 0.0008038688,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05d_v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KGO-TV"
				},
				"name": "ABC 7 Bay Area",
				"salience": 0.0008038688,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lilian Kim",
				"salience": 0.0008038688,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0008038688,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco",
				"salience": 0.0008038688,
				"type": "LOCATION"
			},
			{
				"name": "GotNews",
				"salience": 0.0008038688,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11bw1_6lwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Make_America_Great_Again"
				},
				"name": "Make America Great Again",
				"salience": 0.0008038688,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA Today",
				"salience": 0.0007680669,
				"type": "WORK_OF_ART"
			},
			{
				"name": "victory",
				"salience": 0.00071373483,
				"type": "EVENT"
			},
			{
				"name": "fate",
				"salience": 0.000710546,
				"type": "OTHER"
			},
			{
				"name": "miracle",
				"salience": 0.000710546,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.000710546,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.000710546,
				"type": "OTHER"
			},
			{
				"name": "television",
				"salience": 0.000710546,
				"type": "OTHER"
			},
			{
				"name": "Harrison Township",
				"salience": 0.00069346774,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.00069346774,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0006788996,
				"type": "LOCATION"
			},
			{
				"name": "tea party",
				"salience": 0.0006788996,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0006788996,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.00062589947,
				"type": "OTHER"
			},
			{
				"name": "confrontations",
				"salience": 0.0006129593,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.000600461,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.000600461,
				"type": "LOCATION"
			},
			{
				"name": "revolution",
				"salience": 0.0005307485,
				"type": "EVENT"
			},
			{
				"name": "example",
				"salience": 0.0005307485,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.0005307485,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.0005307485,
				"type": "PERSON"
			},
			{
				"name": "edge",
				"salience": 0.0005307485,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0005307485,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0005307485,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0005044902,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.0003266234,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/City-Abstract-Public-Domain-460x325.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T19:54:37.665+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 20.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Get Ready For Civil Unrest 10/31/2016 \nECONOMIC COLLAPSE BLOG \nCould we see violence no matter who wins on November 8th? Let’s hope that it doesn’t happen, but as you will see below, anti-Trump violence is already sweeping the nation. If Trump were to actually win the election, that would likely send the radical left into a violent post-election temper tantrum unlike anything that we have ever seen before. Alternatively, there is a tremendous amount of concern on the right that this election could be stolen by Hillary Clinton. And as I showed yesterday, it appears that voting machines in Texas are already switching votes from Donald Trump to Hillary Clinton . If Hillary Clinton wins this election under suspicious circumstances, that also may be enough to set off widespread civil unrest all across the country. \nAt this moment there is less than two weeks to go until November 8th, and a brand new survey has found that a majority of Americans are concerned “about the possibility of violence” on election day… \nA 51% majority of likely voters express at least some concern about the possibility of violence on Election Day; one in five are “very concerned.” Three of four say they have confidence that the United States will have the peaceful transfer of power that has marked American democracy for more than 200 years, but just 40% say they are “very confident” about that. \nMore than four in 10 of Trump supporters say they won’t recognize the legitimacy of Clinton as president, if she prevails, because they say she wouldn’t have won fair and square. \nBut many on the left are not waiting until after the election to commit acts of violence. On Wednesday, Donald Trump’s star on the Walk of Fame was smashed into pieces by a man with a sledgehammer and a pick-ax… \nDonald Trump took a lot of hits today, and not just in the Presidential race. With less than two weeks to go before America decides if the ex- Apprentice host will pull off a surprise victory over Hillary Clinton, Trump’s star on the Hollywood Walk of Fame was destroyed early Wednesday morning by a man dressed as a city construction worker and wielding a sledgehammer and pick-ax in what looks to be a Tinseltown first. \nAnd there were two other instances earlier this year when Donald Trump’s star was also vandalized. One came in January, and the other happened in June … \nThis is of course not the first time the GOP candidate’s star has been attacked or defaced since Trump announced his White House bid in summer 2015. The most extreme measure was a reverse swastika being sprayed on the star at 6801 Hollywood Blvd in late January. In June this summer, a mute sign was painted on Trump’s star in a seemingly protest against the antagonistic language and policies some have accused Trump of promoting and reveling in during the campaign. In both cases, Trump’s star was quickly cleaned and back as new within a day. \nWe have seen anti-Trump violence on the east coast as well. Earlier this month, someone decided to firebomb the Republican Party headquarters in Orange County, North Carolina. On the building next to the headquarters, someone spray-painted “Nazi Republicans get out of town or else” along with a swastika. \nThere have also been other disturbing incidents of anti-Trump violence all over the nation in recent days. A recent Lifezette article put together quite a long list, and the following is just a short excerpt from that piece… \nOn Oct. 15 in Bangor, Maine, vandals spray-painted about 20 parked cars outside a Trump rally. Trump supporter Paul Foster, whose van was hit with white paint, told reporters, “Why can’t they do a peaceful protest instead of painting cars, all of this, to make their statement?” \nAround Oct. 3, a couple of Trump supporters were assaulted in Zeitgeist, a San Francisco bar, after they were allegedly refused service for expressing support for Trump, GotNews reports. “The two Trump supporters were attacked, punched, and chased into the street by ‘some thugs’ that a barmaid called out from the back.” Lilian Kim of ABC 7 Bay Area tweeted a photo of the men, in which one was wearing a Trump T-shirt and the other was wearing a “Blue Lives Matter” shirt. \nOn Sept. 28 in El Cajon, California, an angry mob at a Black Lives Matter protest beat 21-year-old Trump supporter Feras Jabro for wearing a “Make America Great Again” baseball cap. The assault was broadcast live using the smartphone app Periscope. \nThere is a move to get Trump supporters to wear red on election day, but in many parts of America that might just turn his supporters into easy targets. Let’s certainly hope that we don’t see the kind of violent confrontations at voting locations that many experts are anticipating. \nOf course there are also many on the right that are fighting mad, and a Hillary Clinton victory under suspicious circumstances may be enough to push them over the edge. \nFor example, this week former Congressman Joe Walsh said that he is “grabbing my musket” if Donald Trump loses the election… \nFormer Rep. Joe Walsh appeared to call for armed revolution Wednesday if Donald Trump is not elected president. \nWalsh, a former tea party congressman from Illinois who is now a conservative talk radio host, tweeted, “On November 8th, I’m voting for Trump. On November 9th, if Trump loses, I’m grabbing my musket. You in?” \nAnd without a doubt, many ordinary Americans are stocking up on guns and ammunition just in case Hillary Clinton is victorious. The following comes from USA Today … \n“Since the polls are starting to shift quite a bit towards Hillary Clinton, I’ve been buying a lot more ammunition,” says Rick Darling, 69, an engineer from Harrison Township, in Michigan’s Detroit suburbs. In a follow-up phone interview after being surveyed, the Trump supporter said he fears progressives will want to “declare martial law and take our guns away” after the election. \nToday America is more divided than I have ever seen it before, and the mainstream media is constantly fueling the hatred and the anger that various groups feel toward one another. \nIronically, Donald Trump has been working very hard to bring America together. In fact, he is solidly on track to win a higher percentage of the black vote than any Republican presidential candidate since 1960 . \nIf Hillary Clinton and the Democrats win on November 8th, things will not go well for Hillary Clinton’s political enemies. The Clintons used the power of the White House to go after their enemies the first time around, and Hillary is even more angry and more bitter now than she was back then. \nAnd the radical left is very clear about who their enemies are. This is something that I discussed on national television earlier this month … \nAs I write this, it is difficult for me to even imagine how horrible a Hillary Clinton presidency would be. \nBut at this point that appears to be the most likely outcome . \nOut of all the candidates that we could have chosen, the American people are about to put the most evil one by far into the White House. \nPerhaps Donald Trump can still pull off a miracle and we can avoid that fate, but time is rapidly slipping away and November 8th will be here before we know it. Share On:",
		"thread_title": "Get Ready For Civil Unrest",
		"title": "Get Ready For Civil Unrest",
		"type": "bs",
		"uuid": "7e8e053bbe2ed4978c6b8a69c58fb0441fd4cbf8"
	},
	"-KhIh7roUvWNnRn7fI8Q": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T19:54:37.833+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.21638021,
				"type": "LOCATION"
			},
			{
				"name": "modification",
				"salience": 0.11023598,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.055821948,
				"type": "OTHER"
			},
			{
				"name": "Crops",
				"salience": 0.046100643,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.046100643,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.042512536,
				"type": "OTHER"
			},
			{
				"name": "Yields",
				"salience": 0.03619762,
				"type": "OTHER"
			},
			{
				"name": "controversy",
				"salience": 0.03347934,
				"type": "OTHER"
			},
			{
				"name": "Fail",
				"salience": 0.026255876,
				"type": "OTHER"
			},
			{
				"name": "GOV",
				"salience": 0.026255876,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.015740642,
				"type": "LOCATION"
			},
			{
				"name": "pesticides",
				"salience": 0.014895425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.013923988,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.013478592,
				"type": "OTHER"
			},
			{
				"name": "examination",
				"salience": 0.013478592,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.0114951795,
				"type": "ORGANIZATION"
			},
			{
				"name": "use",
				"salience": 0.009092039,
				"type": "OTHER"
			},
			{
				"name": "chemical pesticides",
				"salience": 0.008211949,
				"type": "OTHER"
			},
			{
				"name": "pests",
				"salience": 0.008211949,
				"type": "OTHER"
			},
			{
				"name": "crop yields",
				"salience": 0.007698674,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.007482913,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.007482913,
				"type": "OTHER"
			},
			{
				"name": "modification",
				"salience": 0.0071137957,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.0067581213,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.005640392,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.005640392,
				"type": "OTHER"
			},
			{
				"name": "weedkillers",
				"salience": 0.00556493,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00556493,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.00556493,
				"type": "OTHER"
			},
			{
				"name": "increases",
				"salience": 0.00556493,
				"type": "OTHER"
			},
			{
				"name": "reduction",
				"salience": 0.00556493,
				"type": "OTHER"
			},
			{
				"name": "pesticides",
				"salience": 0.0055481326,
				"type": "OTHER"
			},
			{
				"name": "introduction",
				"salience": 0.005494942,
				"type": "EVENT"
			},
			{
				"name": "yields",
				"salience": 0.00540227,
				"type": "OTHER"
			},
			{
				"name": "toxins",
				"salience": 0.005124609,
				"type": "OTHER"
			},
			{
				"name": "spraying",
				"salience": 0.0050601466,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.0050290115,
				"type": "WORK_OF_ART"
			},
			{
				"name": "continents",
				"salience": 0.0049914713,
				"type": "LOCATION"
			},
			{
				"name": "promise",
				"salience": 0.004507524,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.0042155394,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.0042155394,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.003903904,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.003903904,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.003903904,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.003903904,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0038948287,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0038948287,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0037583497,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.0037583497,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0037507834,
				"type": "LOCATION"
			},
			{
				"name": "producers",
				"salience": 0.0036807584,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0033534002,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09rkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times"
				},
				"name": "The Times",
				"salience": 0.0033273783,
				"type": "ORGANIZATION"
			},
			{
				"name": "analysis",
				"salience": 0.003269502,
				"type": "OTHER"
			},
			{
				"name": "yield gains",
				"salience": 0.0031876997,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0031475683,
				"type": "OTHER"
			},
			{
				"name": "applications",
				"salience": 0.003068813,
				"type": "OTHER"
			},
			{
				"name": "insecticides",
				"salience": 0.0030458856,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0030458856,
				"type": "OTHER"
			},
			{
				"name": "insects",
				"salience": 0.0030458856,
				"type": "OTHER"
			},
			{
				"name": "herbicide use",
				"salience": 0.0028375448,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0028375448,
				"type": "OTHER"
			},
			{
				"name": "corn",
				"salience": 0.0027503457,
				"type": "OTHER"
			},
			{
				"name": "cotton",
				"salience": 0.0027503457,
				"type": "OTHER"
			},
			{
				"name": "soybeans",
				"salience": 0.0027503457,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0026799492,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "U.N.",
				"salience": 0.002403897,
				"type": "ORGANIZATION"
			},
			{
				"name": "herbicides",
				"salience": 0.0024016805,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.002218831,
				"type": "OTHER"
			},
			{
				"name": "insecticides",
				"salience": 0.002218831,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.002209182,
				"type": "OTHER"
			},
			{
				"name": "herbicide use",
				"salience": 0.00212008,
				"type": "OTHER"
			},
			{
				"name": "fungicides",
				"salience": 0.0020034695,
				"type": "OTHER"
			},
			{
				"name": "fungi",
				"salience": 0.0020034695,
				"type": "OTHER"
			},
			{
				"name": "measure",
				"salience": 0.0019945242,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.001962646,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ckt_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Academy_of_Sciences"
				},
				"name": "National Academy of Sciences",
				"salience": 0.001962646,
				"type": "ORGANIZATION"
			},
			{
				"name": "herbicides",
				"salience": 0.0017943364,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.001734923,
				"type": "OTHER"
			},
			{
				"name": "volumes",
				"salience": 0.001734923,
				"type": "OTHER"
			},
			{
				"name": "third",
				"salience": 0.001734923,
				"type": "OTHER"
			},
			{
				"name": "corn",
				"salience": 0.0014967604,
				"type": "OTHER"
			},
			{
				"name": "soybeans",
				"salience": 0.0014967604,
				"type": "OTHER"
			},
			{
				"name": "cotton",
				"salience": 0.0014967604,
				"type": "OTHER"
			},
			{
				"name": "producer",
				"salience": 0.0014967604,
				"type": "PERSON"
			},
			{
				"name": "use",
				"salience": 0.0014866086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035nm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Motors"
				},
				"name": "GM",
				"salience": 0.0014662553,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01b69s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Geological_Survey"
				},
				"name": "U.S. Geological Survey",
				"salience": 0.0014662553,
				"type": "ORGANIZATION"
			},
			{
				"name": "varieties",
				"salience": 0.0012960952,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.0012477183,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/corn1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T19:54:37.833+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Genetically Modified Crops in U.S. Fail to Deliver Expected Yields 10/31/2016 \nALL GOV \nThe controversy over genetically modified crops has long focused on largely unsubstantiated fears that they are unsafe to eat. \nBut an extensive examination by The New York Times indicates that the debate has missed a more basic problem — genetic modification in the United States and Canada has not accelerated increases in crop yields or led to an overall reduction in the use of chemical pesticides. \nThe promise of genetic modification was twofold: By making crops immune to the effects of weedkillers and inherently resistant to many pests, they would grow so robustly that they would become indispensable to feeding the world’s growing population, while also requiring fewer applications of sprayed pesticides. \nTwenty years ago, Europe largely rejected genetic modification at the same time the United States and Canada were embracing it. Comparing results on the two continents, using independent data as well as academic and industry research, shows how the technology has fallen short of the promise. \nAn analysis by The Times using U.N. data showed that the United States and Canada have gained no discernible advantage in yields when measured against Western Europe, a region with comparably modernized agricultural producers like France and Germany . Also, a recent National Academy of Sciences report found “there was little evidence” that the introduction of genetically modified crops in the United States had led to yield gains beyond those seen in conventional crops. \nAt the same time, herbicide use has increased in the United States, even as major crops like corn, soybeans and cotton have been converted to modified varieties. And the United States has fallen behind Europe’s biggest producer, France, in reducing the overall use of pesticides, which includes both herbicides and insecticides. \nOne measure, contained in data from the U.S. Geological Survey , shows the stark difference in the use of pesticides. Since GM crops were introduced in the United States two decades ago for crops like corn, cotton and soybeans, the use of toxins that kill insects and fungi has fallen by a third, but the spraying of herbicides, which are used in much higher volumes, has risen 21 percent. \nBy contrast, in France, use of insecticides and fungicides has fallen 65 percent and herbicide use has decreased 36 percent. \nTo Learn More:",
		"thread_title": "Genetically Modified Crops in U.S. Fail to Deliver Expected Yields",
		"title": "Genetically Modified Crops in U.S. Fail to Deliver Expected Yields",
		"type": "bs",
		"uuid": "3d54c1afa3131e1e29a4ec729d9013e6c1ec5b6e"
	},
	"-KhIh80eqcjlMmzpRZWd": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T19:54:37.919+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.35462418,
				"type": "PERSON"
			},
			{
				"name": "Assange Promises Hillary",
				"salience": 0.33678925,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.06605771,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.04634184,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.023993555,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.012320906,
				"type": "EVENT"
			},
			{
				"name": "e-mail scandal",
				"salience": 0.012320906,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.011962091,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.011517946,
				"type": "OTHER"
			},
			{
				"name": "batches",
				"salience": 0.009986939,
				"type": "ORGANIZATION"
			},
			{
				"name": "batch",
				"salience": 0.009615774,
				"type": "OTHER"
			},
			{
				"name": "arrest",
				"salience": 0.009615774,
				"type": "EVENT"
			},
			{
				"name": "message",
				"salience": 0.008653093,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0075999387,
				"type": "ORGANIZATION"
			},
			{
				"name": "broadcast",
				"salience": 0.0070690457,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0070690457,
				"type": "OTHER"
			},
			{
				"name": "reporter",
				"salience": 0.0061511085,
				"type": "PERSON"
			},
			{
				"name": "e-mail hacking",
				"salience": 0.0061009806,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0053337226,
				"type": "OTHER"
			},
			{
				"name": "coffin",
				"salience": 0.0052847546,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.00522372,
				"type": "LOCATION"
			},
			{
				"name": "hacking",
				"salience": 0.0044464706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "Russia Today",
				"salience": 0.0043559885,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0043559885,
				"type": "LOCATION"
			},
			{
				"name": "Video",
				"salience": 0.0038511653,
				"type": "WORK_OF_ART"
			},
			{
				"name": "holes",
				"salience": 0.0038511653,
				"type": "OTHER"
			},
			{
				"name": "nail",
				"salience": 0.0035693955,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0032553738,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.0023716348,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.002349829,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.0019929034,
				"type": "OTHER"
			},
			{
				"name": "servers",
				"salience": 0.0019678043,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/wikileaks-logo-wallpaper.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T19:54:37.919+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Wikileaks’ Assange Promises Hillary’s Arrest With Next Release 10/31/2016 \nTRUTHREVOLT.ORG \nIt has been a devastating period for the Hillary Clinton campaign. First, the FBI re-opened the investigation into her e-mail scandal and now, Julian Assange has promised that what’s in the next batch of e-mails to be published to Wikileaks will lead to her arrest. \nSince the first week of October, there have been 21 batches released totaling 35,594 e-mails. According to a message on Twitter, there are more than 50,000 remaining. \nIn a broadcast for Russia Today, a London reporter said, “Assange will be releasing more material in what he says will provide enough evidence to see Hillary Clinton arrested.” \nThese will be the nail in Hillary Clinton’s coffin, she added. \nAssange assured Russia has no involvement in his e-mail hacking like Democrats are claiming. The DNC servers, he said, were “ripe for hacking” and “riddled with holes.” \nVideo below:",
		"thread_title": "Wikileaks’ Assange Promises Hillary’s Arrest With Next Release",
		"title": "Wikileaks’ Assange Promises Hillary’s Arrest With Next Release",
		"type": "bs",
		"uuid": "837c4fb2b1eec6f939ffefba1fff14ba91a31ea0"
	},
	"-KhIh8BqoESU6ZJmwzR_": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T19:54:37.937+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "Army",
				"salience": 0.29247132,
				"type": "ORGANIZATION"
			},
			{
				"name": "John Rossi",
				"salience": 0.17840199,
				"type": "PERSON"
			},
			{
				"name": "general",
				"salience": 0.12382019,
				"type": "PERSON"
			},
			{
				"name": "general",
				"salience": 0.07194403,
				"type": "PERSON"
			},
			{
				"name": "command",
				"salience": 0.03257821,
				"type": "OTHER"
			},
			{
				"name": "suicide",
				"salience": 0.031881746,
				"type": "EVENT"
			},
			{
				"name": "suicide",
				"salience": 0.0303396,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.024844391,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01j_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Army"
				},
				"name": "The Army",
				"salience": 0.021336218,
				"type": "ORGANIZATION"
			},
			{
				"name": "death",
				"salience": 0.019599924,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.019599924,
				"type": "LOCATION"
			},
			{
				"name": "Military suicides",
				"salience": 0.01615589,
				"type": "EVENT"
			},
			{
				"name": "lieutenant general",
				"salience": 0.014536422,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.011677376,
				"type": "PERSON"
			},
			{
				"name": "military base",
				"salience": 0.008133685,
				"type": "LOCATION"
			},
			{
				"name": "suicide",
				"salience": 0.006487363,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/043_4r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army_Space_and_Missile_Defense_Command"
				},
				"name": "Army Space and Missile Defense Command",
				"salience": 0.005558364,
				"type": "ORGANIZATION"
			},
			{
				"name": "suicide-prevention help",
				"salience": 0.005129552,
				"type": "OTHER"
			},
			{
				"name": "thanks",
				"salience": 0.005129552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ghn3n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Redstone_Arsenal"
				},
				"name": "Redstone Arsenal",
				"salience": 0.005020398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alabama"
				},
				"name": "Alabama",
				"salience": 0.005016791,
				"type": "LOCATION"
			},
			{
				"name": "Rossi",
				"salience": 0.005012414,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0037830276,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mention",
				"salience": 0.0036233705,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00305076,
				"type": "WORK_OF_ART"
			},
			{
				"name": "air defense artillery officer",
				"salience": 0.00292194,
				"type": "PERSON"
			},
			{
				"name": "training",
				"salience": 0.00292194,
				"type": "OTHER"
			},
			{
				"name": "academy",
				"salience": 0.00292194,
				"type": "ORGANIZATION"
			},
			{
				"name": "military members",
				"salience": 0.0028130459,
				"type": "PERSON"
			},
			{
				"name": "duty",
				"salience": 0.0028130459,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0028130459,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0028130459,
				"type": "OTHER"
			},
			{
				"name": "record-keeping",
				"salience": 0.0028130459,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.0027948546,
				"type": "PERSON"
			},
			{
				"name": "suicide",
				"salience": 0.0027803774,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.002542057,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0024677147,
				"type": "PERSON"
			},
			{
				"name": "family statement",
				"salience": 0.0023984518,
				"type": "WORK_OF_ART"
			},
			{
				"name": "support",
				"salience": 0.002386087,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.0019324578,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0017978953,
				"type": "PERSON"
			},
			{
				"name": "need",
				"salience": 0.0017830107,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07x4c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Military_Academy"
				},
				"name": "West Point",
				"salience": 0.0017324352,
				"type": "LOCATION"
			},
			{
				"name": "times",
				"salience": 0.0016610504,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.0014998654,
				"type": "OTHER"
			},
			{
				"name": "prayers",
				"salience": 0.0012988637,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.0012988637,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0012988637,
				"type": "PERSON"
			},
			{
				"name": "space",
				"salience": 0.0012410562,
				"type": "LOCATION"
			},
			{
				"name": "Maj. Gen. Rossi",
				"salience": 0.0011225415,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/AAjvZXk.jpeg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T19:54:37.937+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Army says 2-star general committed suicide 10/31/2016 \nMSN \nThe Army said Friday it has determined that suicide was the cause of death of a two-star general who was found dead in his home on a military base in Alabama. \nMaj. Gen. John Rossi was found dead July 31 at Redstone Arsenal, two days before he was to assume command of Army Space and Missile Defense Command. \nHe is the first Army general to commit suicide on active duty since record-keeping began in 2000, according to the Army. Military suicides soared earlier this decade and remain a major source of concern; they typically have affected lower-ranking military members. \nRossi, a West Point academy graduate and an air defense artillery officer by training, had just moved onto Redstone Arsenal and was scheduled to be promoted to lieutenant general when he took command of Space and Missile Defense Command. \nA written statement by the Army on Friday made no mention of what might have prompted Rossi to take his own life. \nThe Rossi family issued a statement through the Army expressing thanks for wide support and urging those who may need suicide-prevention help to seek it immediately. \n“To the Army, he was Maj. Gen. Rossi,” it said. “To us, he was John — husband, dad.” \n“We ask for the time and space to grieve in private, and for the Army to continue to better understand suicide, and to help and treat those in need,” the family statement added. “For our family, this has been an incredibly painful time, and we ask that you continue to keep us in your thoughts and prayers. To all the other families out there, to the man or woman who may be facing challenging times, please seek assistance immediately. Compassionate and confidential assistance is available.”",
		"thread_title": "Army says 2-star general committed suicide",
		"title": "Army says 2-star general committed suicide",
		"type": "bs",
		"uuid": "a7d6fd8dac6b4873869e6e308dec11cf470a8776"
	},
	"-KhIh8UFe-ksm8F3NdZc": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T19:54:38.054+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.7158301,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.034619253,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.03338299,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.020433126,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.019967157,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0grkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ken_Starr"
				},
				"name": "Kenneth Starr",
				"salience": 0.013108443,
				"type": "PERSON"
			},
			{
				"name": "strategy",
				"salience": 0.009166691,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.0068525802,
				"type": "PERSON"
			},
			{
				"name": "director",
				"salience": 0.006515913,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0063925176,
				"type": "ORGANIZATION"
			},
			{
				"name": "kind",
				"salience": 0.0059531354,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0054410095,
				"type": "WORK_OF_ART"
			},
			{
				"name": "corruption charges",
				"salience": 0.0047541,
				"type": "OTHER"
			},
			{
				"name": "cahoots",
				"salience": 0.004714892,
				"type": "OTHER"
			},
			{
				"name": "probe",
				"salience": 0.004714892,
				"type": "EVENT"
			},
			{
				"name": "lady",
				"salience": 0.004221707,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.0037929818,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02v7pb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vast_right-wing_conspiracy"
				},
				"name": "Vast Right-Wing Conspiracy",
				"salience": 0.0037154818,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0033378443,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Hillary Reboots",
				"salience": 0.0029071234,
				"type": "ORGANIZATION"
			},
			{
				"name": "LIFEZETTE",
				"salience": 0.0029071234,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0027856107,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0027856107,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0027221043,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.002666414,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.0025653255,
				"type": "PERSON"
			},
			{
				"name": "facts",
				"salience": 0.0024129257,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0023648639,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0022503415,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "U.S. Senate",
				"salience": 0.0020281258,
				"type": "ORGANIZATION"
			},
			{
				"name": "battle",
				"salience": 0.0018555472,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/025st0_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Bill_Clinton"
				},
				"name": "Clinton White House",
				"salience": 0.0017429966,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.0017399743,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/043g3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Janet_Reno"
				},
				"name": "Janet Reno",
				"salience": 0.0016614443,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0014863323,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.0013938289,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.0013762836,
				"type": "WORK_OF_ART"
			},
			{
				"name": "salvo",
				"salience": 0.0012811164,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0012474125,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0509p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monica_Lewinsky"
				},
				"name": "Monica Lewinsky",
				"salience": 0.0012470641,
				"type": "PERSON"
			},
			{
				"name": "operatives",
				"salience": 0.0011430506,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.001059366,
				"type": "OTHER"
			},
			{
				"name": "habit",
				"salience": 0.001059366,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0010490349,
				"type": "PERSON"
			},
			{
				"name": "claim",
				"salience": 0.0010460261,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0009943234,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0009943234,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0009943234,
				"type": "ORGANIZATION"
			},
			{
				"name": "announcement",
				"salience": 0.0009943234,
				"type": "EVENT"
			},
			{
				"name": "letter",
				"salience": 0.0009775324,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigations",
				"salience": 0.0009292117,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.0009031103,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0009031103,
				"type": "EVENT"
			},
			{
				"name": "authorities",
				"salience": 0.00089726376,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.00088800554,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.0008832773,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.000858465,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00084327895,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.00083097676,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0913_n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_B._Fiske"
				},
				"name": "Robert Fiske",
				"salience": 0.0008096129,
				"type": "PERSON"
			},
			{
				"name": "attorney general",
				"salience": 0.0008051838,
				"type": "PERSON"
			},
			{
				"name": "husband",
				"salience": 0.0008051838,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0008051838,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.00078804966,
				"type": "OTHER"
			},
			{
				"name": "investment",
				"salience": 0.00078804966,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00077513925,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00076537544,
				"type": "WORK_OF_ART"
			},
			{
				"name": "laptop",
				"salience": 0.0006972568,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "law enforcement",
				"salience": 0.0006972568,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0006972568,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0006972568,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.0006798003,
				"type": "LOCATION"
			},
			{
				"name": "earnest",
				"salience": 0.0006712365,
				"type": "OTHER"
			},
			{
				"name": "demand",
				"salience": 0.0006712365,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0006712365,
				"type": "OTHER"
			},
			{
				"name": "table",
				"salience": 0.0006712365,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0006712365,
				"type": "OTHER"
			},
			{
				"name": "transparency",
				"salience": 0.0006712365,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00066343084,
				"type": "PERSON"
			},
			{
				"name": "counsel",
				"salience": 0.0006573665,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0006573665,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0006352704,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.00061698904,
				"type": "WORK_OF_ART"
			},
			{
				"name": "job",
				"salience": 0.00059885444,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00056924066,
				"type": "OTHER"
			},
			{
				"name": "sexual harassment",
				"salience": 0.00056924066,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.00056924066,
				"type": "ORGANIZATION"
			},
			{
				"name": "trial",
				"salience": 0.00056924066,
				"type": "EVENT"
			},
			{
				"name": "story",
				"salience": 0.0005479948,
				"type": "WORK_OF_ART"
			},
			{
				"name": "director",
				"salience": 0.0005186285,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027rnt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daytona_International_Speedway"
				},
				"name": "Daytona",
				"salience": 0.00047714822,
				"type": "LOCATION"
			},
			{
				"name": "charges",
				"salience": 0.0004287965,
				"type": "OTHER"
			},
			{
				"name": "scandals",
				"salience": 0.00042524352,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.00042524352,
				"type": "PERSON"
			},
			{
				"name": "settings",
				"salience": 0.00042524352,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00041317136,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rsjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daytona_Beach,_Florida"
				},
				"name": "Daytona Beach",
				"salience": 0.00041317136,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01dgg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drudge_Report"
				},
				"name": "Drudge Report",
				"salience": 0.0004046315,
				"type": "WORK_OF_ART"
			},
			{
				"name": "authorities",
				"salience": 0.00039613308,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.00039613308,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.0003609661,
				"type": "OTHER"
			},
			{
				"name": "midterm elections",
				"salience": 0.00035766547,
				"type": "EVENT"
			},
			{
				"name": "lesson",
				"salience": 0.00035158062,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rqpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paula_Jones"
				},
				"name": "Paula Jones",
				"salience": 0.0003503741,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fcfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Newsweek"
				},
				"name": "Newsweek",
				"salience": 0.0003503741,
				"type": "ORGANIZATION"
			},
			{
				"name": "Whitewater Development Corp",
				"salience": 0.0003503741,
				"type": "ORGANIZATION"
			},
			{
				"name": "battle",
				"salience": 0.0003314594,
				"type": "EVENT"
			},
			{
				"name": "seats",
				"salience": 0.00030970364,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00030970364,
				"type": "LOCATION"
			},
			{
				"name": "obstruction",
				"salience": 0.00030970364,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.00030970364,
				"type": "OTHER"
			},
			{
				"name": "perjury",
				"salience": 0.00030970364,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.0002693749,
				"type": "EVENT"
			},
			{
				"name": "anywhere",
				"salience": 0.0002693749,
				"type": "LOCATION"
			},
			{
				"name": "backfire",
				"salience": 0.00024963613,
				"type": "OTHER"
			},
			{
				"name": "punishments",
				"salience": 0.00024648986,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00023134335,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.00023134335,
				"type": "EVENT"
			},
			{
				"name": "opposition",
				"salience": 0.00019370331,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.0001478967,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0001423743,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01h1bf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Today_(U.S._TV_program)"
				},
				"name": "The Today Show",
				"salience": 0.0001423743,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/049_zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Matt_Lauer"
				},
				"name": "Matt Lauer",
				"salience": 0.000068217494,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/45683114.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T19:54:38.054+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Hillary Reboots ‘Vast Right-Wing Conspiracy’ Playbook 10/31/2016 \nLIFEZETTE \nBefore even 24 hours had passed since the FBI director informed Congress on Friday that it was reopening the probe into Hillary Clinton’s emails, Clinton suggested the director was in cahoots with the Republican Party. \n“We’ve made it very clear that, if they are going to be sending this kind of letter that is only going originally to Republican members of the House, that they need to share whatever facts they claim to have with the American people,” Clinton said on Friday, after initially being blindsided by the FBI’s announcement. \nThe claim wasn’t true. All you had to do is turn the page and find Democratic members of Congress who had also received the letter from the FBI. But it shows how ready Clinton is to fight anyone in the government who dares investigate or question her. It is likely a habit Clinton picked up when she was first lady, from 1993 to 2001. \nClinton’s opening salvo, though weak, is a sign of more to come. Her coming attack on the FBI and its director, James Comey, will likely begin in earnest on Monday, with her operatives using the letter to Congress as proof Clinton is the victim of a political conspiracy. \nClinton previewed her attack in Daytona Beach, Florida, on Saturday, when she said the letter was “unprecedented and deeply troubling.” \nClinton will also turn the issue into one of “transparency” — even though FBI investigations are inherently not transparent. In Daytona, she called on Comey to “explain everything right away, put it all right on the table” — a demand she knows will go unheeded. \nBut many of Clinton’s allies in the media are likely to demand to see the emails found on former Rep. Anthony Weiner’s laptop. \nIt’s a strategy that could work, even with only a few days left until Election Day. \nSuch attacks on law enforcement worked fairly well for Clinton in 1998, when she and her husband, then-President Bill Clinton, vilified independent counsel Kenneth Starr. Starr had been tasked by Bill Clinton’s own attorney general to investigate corruption charges, but likely rued the day he ever took the job. \nIn 1994, Bill Clinton faced questions from many, including The New York Times, about an investment the Clintons made in a company called Whitewater Development Corp. Bill Clinton’s attorney general, Janet Reno, made Robert Fiske the independent counsel. \nFiske would later be replaced by Starr. Starr’s investigation would later reach into charges that President Clinton had lied in the Paula Jones sexual harassment civil trial. With explosive charges being published by the Drudge Report and Newsweek in January 1998 that Bill Clinton had seduced an intern, Monica Lewinsky, the Clintons could have been expected to admit the truth and take the punishments. \nInstead, the Clinton White House and the Democrats began attacking Starr and the Republicans. \nOn Jan. 27, 1998, Hillary Clinton went on NBC’s “The Today Show” and goaded the press into covering the opposition rather than President Bill Clinton, who had lied about his affair with Lewinsky just one day earlier. \nMatt Lauer asked if Hillary Clinton had said the fight against Starr would be the “last great battle” of the Clinton White House. \n“Well, I don’t know if I’ve been that dramatic,” Hillary Clinton replied. “But I do believe that this is a battle. I mean, look at the very people who are involved in this — they have popped up in other settings. This is — the great story here for anybody willing to find it and write about it and explain it is this vast right-wing conspiracy that has been conspiring against my husband since the day he announced for president.” \nThe Starr report on the Clinton scandals was released months later. But what the Clintons are really proud of that is that the Democrats actually gained seats in the 1998 midterm elections, helping to cause a backfire against the GOP. \nThe GOP didn’t have anywhere near the two-thirds majority in the Senate to remove Bill Clinton. In early 1999, the U.S. Senate acquitted Bill Clinton on two charges: obstruction of justice, and perjury. \nIt taught the Clintons the wrong lesson: to fight authorities if authorities questioned them — even authorities within the Democratic Party. Clinton will be targeting and attacking President Obama’s own FBI director as Obama leaves office.",
		"thread_title": "Hillary Reboots ‘Vast Right-Wing Conspiracy’ Playbook",
		"title": "Hillary Reboots ‘Vast Right-Wing Conspiracy’ Playbook",
		"type": "bs",
		"uuid": "9db17df9724263c681fae61e3571c476480468b3"
	},
	"-KhIh8i9AklF1l6eqty1": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T19:01:13.845+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03nzf1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elon_Musk"
				},
				"name": "Elon Musk",
				"salience": 0.66492933,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03fkyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/SpaceX"
				},
				"name": "SpaceX",
				"salience": 0.12695235,
				"type": "ORGANIZATION"
			},
			{
				"name": "session",
				"salience": 0.053295907,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09cws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mars"
				},
				"name": "Mars",
				"salience": 0.013560771,
				"type": "LOCATION"
			},
			{
				"name": "True Mars On Earth Plan",
				"salience": 0.009617102,
				"type": "OTHER"
			},
			{
				"name": "founder",
				"salience": 0.009165009,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.0060004396,
				"type": "LOCATION"
			},
			{
				"name": "follow-up",
				"salience": 0.005830655,
				"type": "PERSON"
			},
			{
				"name": "2016 GAME N GUIDE",
				"salience": 0.005666299,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Reddit Ask Me Anything",
				"salience": 0.005666299,
				"type": "OTHER"
			},
			{
				"name": "spaceships",
				"salience": 0.005259655,
				"type": "LOCATION"
			},
			{
				"name": "session",
				"salience": 0.0046715476,
				"type": "EVENT"
			},
			{
				"name": "company",
				"salience": 0.004410073,
				"type": "ORGANIZATION"
			},
			{
				"name": "plans",
				"salience": 0.0033102683,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0033102683,
				"type": "LOCATION"
			},
			{
				"name": "company",
				"salience": 0.0032574406,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.0028807344,
				"type": "OTHER"
			},
			{
				"name": "reliability",
				"salience": 0.0028221153,
				"type": "OTHER"
			},
			{
				"name": "refueling station",
				"salience": 0.0025481007,
				"type": "LOCATION"
			},
			{
				"name": "conglomerate",
				"salience": 0.0024844694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.0023434022,
				"type": "LOCATION"
			},
			{
				"name": "plans",
				"salience": 0.0023235804,
				"type": "OTHER"
			},
			{
				"name": "domes",
				"salience": 0.0023013188,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0022438318,
				"type": "EVENT"
			},
			{
				"name": "habitation",
				"salience": 0.0022438318,
				"type": "OTHER"
			},
			{
				"name": "refueling site",
				"salience": 0.0022438318,
				"type": "OTHER"
			},
			{
				"name": "space rockets",
				"salience": 0.0019377492,
				"type": "OTHER"
			},
			{
				"name": "rockets",
				"salience": 0.0019377492,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0018950409,
				"type": "OTHER"
			},
			{
				"name": "rockets",
				"salience": 0.0016437632,
				"type": "OTHER"
			},
			{
				"name": "rockets",
				"salience": 0.0016437632,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.0015743492,
				"type": "PERSON"
			},
			{
				"name": "quantities",
				"salience": 0.0014526704,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.0014408182,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0014183918,
				"type": "LOCATION"
			},
			{
				"name": "International Astronautical Congress",
				"salience": 0.001413492,
				"type": "ORGANIZATION"
			},
			{
				"name": "mum",
				"salience": 0.0013635444,
				"type": "PERSON"
			},
			{
				"name": "spaceship",
				"salience": 0.001360375,
				"type": "LOCATION"
			},
			{
				"name": "glass panels",
				"salience": 0.0013294416,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0013127108,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0013127108,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.0013019985,
				"type": "PERSON"
			},
			{
				"name": "vision",
				"salience": 0.0012856126,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.001197218,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0011765329,
				"type": "EVENT"
			},
			{
				"name": "en",
				"salience": 0.0011134123,
				"type": "OTHER"
			},
			{
				"name": "species",
				"salience": 0.0011134123,
				"type": "OTHER"
			},
			{
				"name": "span",
				"salience": 0.0011134123,
				"type": "OTHER"
			},
			{
				"name": "parking orbit",
				"salience": 0.0011134123,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011134123,
				"type": "PERSON"
			},
			{
				"name": "propellant tankers",
				"salience": 0.0011134123,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.0009911181,
				"type": "LOCATION"
			},
			{
				"name": "human habitation",
				"salience": 0.00096066296,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.0008615654,
				"type": "OTHER"
			},
			{
				"name": "droids",
				"salience": 0.000857121,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jp26",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guadalajara"
				},
				"name": "Guadalajara",
				"salience": 0.0008396605,
				"type": "LOCATION"
			},
			{
				"name": "carbon fiber frames",
				"salience": 0.00083193975,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.00083193975,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/057dvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Engadget"
				},
				"name": "Engadget",
				"salience": 0.0008083366,
				"type": "ORGANIZATION"
			},
			{
				"name": "colonization event",
				"salience": 0.00080090354,
				"type": "EVENT"
			},
			{
				"name": "tunneling droids",
				"salience": 0.00079436344,
				"type": "OTHER"
			},
			{
				"name": "spacecraft",
				"salience": 0.0007889778,
				"type": "OTHER"
			},
			{
				"name": "glass domes",
				"salience": 0.0006998022,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.0006060047,
				"type": "OTHER"
			},
			{
				"name": "miner",
				"salience": 0.0006060047,
				"type": "PERSON"
			},
			{
				"name": "operations",
				"salience": 0.0006060047,
				"type": "OTHER"
			},
			{
				"name": "living",
				"salience": 0.0006060047,
				"type": "OTHER"
			},
			{
				"name": "refueling station",
				"salience": 0.0005790297,
				"type": "LOCATION"
			},
			{
				"name": "site",
				"salience": 0.0005228184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01p06z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_Times"
				},
				"name": "LA Times",
				"salience": 0.0005121634,
				"type": "ORGANIZATION"
			},
			{
				"name": "settlers",
				"salience": 0.00045850532,
				"type": "PERSON"
			},
			{
				"name": "methane fuel",
				"salience": 0.00045272853,
				"type": "OTHER"
			},
			{
				"name": "refueling station",
				"salience": 0.00036683324,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.00032180964,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bw2gf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dragon_(spacecraft)"
				},
				"name": "Dragon",
				"salience": 0.00027865736,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/vanity-fair-new-establishment-summit-day-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T19:01:13.845+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Here is Elon Musk’s True Mars On Earth Plan 11/01/2016 \nGAME N GUIDE \nElon Musk, the founder of SpaceX recently held a Reddit Ask Me Anything session at 6:00 p.m. ET on Oct. 23. The session was said to be a follow-up to the executive’s speech in Mexico last month. Musk unveiled his plans for a refueling site and eventually habitation in the methane-rich planet. SpaceX is said to have raised more questions lately than it has revealed. The inventor and conglomerate went to Twitter to announce the session, Engadget reported. For instance, the company’s plan on colonizing Mars is yet to be discussed as well as the reliability of its space rockets and how it can be improved. In addition, the company also previously revealed that it would be reusing their rockets but have kept mum on how. Previously, Musk had a speech at the International Astronautical Congress in Guadalajara, Mexico in September. In the said Congress, Musk revealed his plans of sending humans to Mars apparently costing a whooping $10 billion each. Moreover he stated that humans will be turned into a multi-planetary species within the span of 40 years to a century. Musk revealed his vision with massive reusable rockets launching into a parking orbit stating that the rockets may be refueled by propellant tankers. Additionally, Musk plans to launch a thousand spaceships with a hundred people each en masse for Mars. He further revealed that a refueling station would be placed on the red planet to harvest methane fuel so settlers may come back to Earth. Hence, the first rocket to be sent is the Dragon spacecraft to search for a site to plant the refueling station followed by a spaceship with equipment to build the refueling station, LA Times reported. Musk went on to describe his ideal vision for human habitation on Mars. Musk revealed that glass panels with carbon fiber frames would be brought to the red planet to build geodesic domes on the planet’s surface. Furthermore, several miner and tunneling droids would also be sent to Mars. The droids are expected to be used to build large quantities of pressurized space for industrial operations along with glass domes for green living. Watch Elon Musk’s Mars colonization event in 5 minutes.",
		"thread_title": "Here is Elon Musk’s True Mars On Earth Plan",
		"title": "Here is Elon Musk’s True Mars On Earth Plan",
		"type": "bs",
		"uuid": "8bf9d33d5d1ee112eb095dad3de554b989ce0f35"
	},
	"-KhIh9-bI8HtJN0M2zQ_": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T19:01:14.207+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.21518134,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.19001497,
				"type": "LOCATION"
			},
			{
				"name": "asteroid",
				"salience": 0.10178516,
				"type": "OTHER"
			},
			{
				"name": "2016 UR36",
				"salience": 0.076398,
				"type": "OTHER"
			},
			{
				"name": "Object",
				"salience": 0.04283556,
				"type": "OTHER"
			},
			{
				"name": "City",
				"salience": 0.040206924,
				"type": "LOCATION"
			},
			{
				"name": "Warning System",
				"salience": 0.03720379,
				"type": "OTHER"
			},
			{
				"name": "city-killer",
				"salience": 0.033654626,
				"type": "PERSON"
			},
			{
				"name": "asteroid warning system",
				"salience": 0.027239246,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.01952104,
				"type": "OTHER"
			},
			{
				"name": "Earth 11",
				"salience": 0.018083794,
				"type": "LOCATION"
			},
			{
				"name": "DAILY CALLER",
				"salience": 0.018083794,
				"type": "ORGANIZATION"
			},
			{
				"name": "asteroid",
				"salience": 0.009675731,
				"type": "OTHER"
			},
			{
				"name": "bomb",
				"salience": 0.009364553,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j2mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles_Bolden"
				},
				"name": "Charles Bolden",
				"salience": 0.008867735,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0071705203,
				"type": "OTHER"
			},
			{
				"name": "telescope",
				"salience": 0.0062118457,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.0062118457,
				"type": "OTHER"
			},
			{
				"name": "detection programs",
				"salience": 0.0056141126,
				"type": "OTHER"
			},
			{
				"name": "asteroid",
				"salience": 0.005548974,
				"type": "OTHER"
			},
			{
				"name": "meteor",
				"salience": 0.005302624,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.005032376,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.005032376,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.005032376,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0049254782,
				"type": "LOCATION"
			},
			{
				"name": "size",
				"salience": 0.0048449263,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.004358895,
				"type": "EVENT"
			},
			{
				"name": "response",
				"salience": 0.0043233456,
				"type": "OTHER"
			},
			{
				"name": "space terms",
				"salience": 0.0041964757,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.0041964757,
				"type": "OTHER"
			},
			{
				"name": "asteroids",
				"salience": 0.004147749,
				"type": "OTHER"
			},
			{
				"name": "detection",
				"salience": 0.0041098907,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gh4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hawaii"
				},
				"name": "Hawaii",
				"salience": 0.0038274378,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0036813873,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0033838134,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.003071464,
				"type": "ORGANIZATION"
			},
			{
				"name": "asteroid",
				"salience": 0.0030222347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.0026847157,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0g3cw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hiroshima"
				},
				"name": "Hiroshima",
				"salience": 0.0026847157,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0026600373,
				"type": "LOCATION"
			},
			{
				"name": "diameter",
				"salience": 0.0026600373,
				"type": "OTHER"
			},
			{
				"name": "disaster response",
				"salience": 0.002605109,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0025845922,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d_23",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Natural_satellite"
				},
				"name": "Moon",
				"salience": 0.0025845922,
				"type": "LOCATION"
			},
			{
				"name": "reporters",
				"salience": 0.0024036353,
				"type": "PERSON"
			},
			{
				"name": "agencies",
				"salience": 0.0022376552,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0021816571,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0021490783,
				"type": "LOCATION"
			},
			{
				"name": "objects",
				"salience": 0.0021380882,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.0021380882,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.0021380882,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06p5g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Solar_System"
				},
				"name": "Solar System",
				"salience": 0.0020945333,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0019378024,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0js8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Emergency_Management_Agency"
				},
				"name": "Federal Emergency Management Agency",
				"salience": 0.0018138812,
				"type": "ORGANIZATION"
			},
			{
				"name": "sizes",
				"salience": 0.0016718537,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0016377881,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.0014477613,
				"type": "PERSON"
			},
			{
				"name": "Planetary Defense Coordination Office",
				"salience": 0.0012081512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Department of Defense",
				"salience": 0.00119293,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03v7p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Astronomical_Union"
				},
				"name": "International Astronomical Union",
				"salience": 0.00089116616,
				"type": "ORGANIZATION"
			},
			{
				"name": "Minor Planets Center",
				"salience": 0.00089116616,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/507480.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T19:01:14.207+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Asteroid Warning System Found ‘City-Killer’ Object Heading Toward Earth 11/01/2016 \nDAILY CALLER \nNASA’s new asteroid warning system detected a large “city-killer” asteroid hurtling toward Earth less than a week before it narrowly missed. \nThe rock, officially named 2016 UR36, was first detected Oct. 25 by a telescope in Hawaii and passed by Earth five days later. The asteroid missed by a distance of only 310,000 miles, around 1.3 times further away than the Moon. That’s incredibly close in space terms. \n2016 UR36 could be up to 82 feet across, roughly comparable in size to the meteor that exploded over Russia in February 2013, causing hundreds of injuries . \nIf 2016 UR36 had slammed into Earth, it would have struck with a force 55 times stronger than the atomic bomb that destroyed Hiroshima near the end of World War II. That’s more than enough force to level a city. \nNASA director Charles Bolden told reporters in 2013 that the only response to a such a late detection of an asteroid set to collide with Earth was to “ Pray .” \nGlobal asteroid detection programs found more than 15,176 near-Earth objects of all sizes with 1,562 new near-Earth objects being identified this year alone, according to International Astronomical Union’s Minor Planets Center . These newly discovered near-Earth objects are part of a much larger population of more than 700,000 known asteroids in our Solar System. \nNASA and its European partners are now focused on finding objects that are 450 feet in diameter or larger, which could devastate a city or country if they struck Earth. \nIn the event an asteroid couldn’t be prevented from hitting Earth, the Planetary Defense Coordination Office would work with Federal Emergency Management Agency (FEMA), the Department of Defense, and other federal agencies to coordinate disaster response.",
		"thread_title": "Asteroid Warning System Found ‘City-Killer’ Object Heading Toward Earth",
		"title": "Asteroid Warning System Found ‘City-Killer’ Object Heading Toward Earth",
		"type": "bs",
		"uuid": "2e38d4713885e853c77bd16be1e2e439a763d0f9"
	},
	"-KhIh9KnZM0CP7nbCeJS": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T19:01:14.347+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01074p2d"
				},
				"name": "Ammon Bundy",
				"salience": 0.26644728,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0qs901r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sally_Jewell"
				},
				"name": "Sally Jewell",
				"salience": 0.07004994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.069319315,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.03919501,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.02503511,
				"type": "PERSON"
			},
			{
				"name": "lands",
				"salience": 0.019067965,
				"type": "LOCATION"
			},
			{
				"name": "acquittal",
				"salience": 0.016227076,
				"type": "OTHER"
			},
			{
				"name": "standoff",
				"salience": 0.013491739,
				"type": "EVENT"
			},
			{
				"name": "verdict",
				"salience": 0.012650367,
				"type": "OTHER"
			},
			{
				"name": "wildlife sanctuary",
				"salience": 0.010560869,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.010560869,
				"type": "ORGANIZATION"
			},
			{
				"name": "fears",
				"salience": 0.010297479,
				"type": "OTHER"
			},
			{
				"name": "prosecutors",
				"salience": 0.009737651,
				"type": "PERSON"
			},
			{
				"name": "dispute",
				"salience": 0.009149959,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ckb6b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malheur_National_Wildlife_Refuge"
				},
				"name": "Malheur National Wildlife Refuge",
				"salience": 0.008582211,
				"type": "LOCATION"
			},
			{
				"name": "verdict",
				"salience": 0.0078282,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.007295024,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.007295024,
				"type": "ORGANIZATION"
			},
			{
				"name": "standoff case",
				"salience": 0.0071868203,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.0069074845,
				"type": "PERSON"
			},
			{
				"name": "tribes",
				"salience": 0.0065084533,
				"type": "PERSON"
			},
			{
				"name": "activity",
				"salience": 0.006475534,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.006475534,
				"type": "OTHER"
			},
			{
				"name": "defendants",
				"salience": 0.006475534,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Native Americans",
				"salience": 0.006244615,
				"type": "PERSON"
			},
			{
				"name": "activist",
				"salience": 0.0060393075,
				"type": "PERSON"
			},
			{
				"name": "conspiracy case",
				"salience": 0.0059833582,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.0059525394,
				"type": "OTHER"
			},
			{
				"name": "William C. Fisher",
				"salience": 0.0056742635,
				"type": "PERSON"
			},
			{
				"name": "New Land Disputes",
				"salience": 0.0056393603,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0056393603,
				"type": "LOCATION"
			},
			{
				"name": "AGWEB",
				"salience": 0.0056393603,
				"type": "ORGANIZATION"
			},
			{
				"name": "juror",
				"salience": 0.0056341677,
				"type": "PERSON"
			},
			{
				"name": "Oregon Standoff Acquittal Sparks Fears",
				"salience": 0.0055933753,
				"type": "OTHER"
			},
			{
				"name": "LaVoy Finicum",
				"salience": 0.005553935,
				"type": "PERSON"
			},
			{
				"name": "John Freemuth",
				"salience": 0.0054635797,
				"type": "PERSON"
			},
			{
				"name": "site",
				"salience": 0.0051454855,
				"type": "LOCATION"
			},
			{
				"name": "authorities",
				"salience": 0.0050807637,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.004923266,
				"type": "OTHER"
			},
			{
				"name": "Joel Hansen",
				"salience": 0.004756842,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018hr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_United_States"
				},
				"name": "West",
				"salience": 0.004698379,
				"type": "LOCATION"
			},
			{
				"name": "endorsement",
				"salience": 0.0046801614,
				"type": "OTHER"
			},
			{
				"name": "Supporters",
				"salience": 0.0046801614,
				"type": "PERSON"
			},
			{
				"name": "confrontations",
				"salience": 0.0046801614,
				"type": "EVENT"
			},
			{
				"name": "employees",
				"salience": 0.0046801614,
				"type": "PERSON"
			},
			{
				"name": "ranch",
				"salience": 0.0044815065,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.004368924,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.004100879,
				"type": "OTHER"
			},
			{
				"name": "lands",
				"salience": 0.0040318468,
				"type": "LOCATION"
			},
			{
				"name": "High Desert Partnership",
				"salience": 0.0038370138,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.003395221,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0032860972,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0030072206,
				"type": "ORGANIZATION"
			},
			{
				"name": "Steve Grasty",
				"salience": 0.0029415963,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0028706132,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0028278776,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0027690367,
				"type": "ORGANIZATION"
			},
			{
				"name": "land",
				"salience": 0.0027223967,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0025612132,
				"type": "PERSON"
			},
			{
				"name": "telephone interview",
				"salience": 0.0024656681,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.0024656681,
				"type": "PERSON"
			},
			{
				"name": "Bundybrothers",
				"salience": 0.0024616916,
				"type": "PERSON"
			},
			{
				"name": "verdict",
				"salience": 0.002411526,
				"type": "OTHER"
			},
			{
				"name": "Chris Rasmussen",
				"salience": 0.002396708,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.0023760747,
				"type": "PERSON"
			},
			{
				"name": "refuge",
				"salience": 0.0023543,
				"type": "LOCATION"
			},
			{
				"name": "takeover",
				"salience": 0.0023421543,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.0022263755,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0022263755,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.0021736454,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05x86wy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laurie_Levenson"
				},
				"name": "Laurie Levenson",
				"salience": 0.0021129278,
				"type": "PERSON"
			},
			{
				"name": "occupiers",
				"salience": 0.0021089332,
				"type": "PERSON"
			},
			{
				"name": "demonstrators",
				"salience": 0.0020803302,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.002030245,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.002030245,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.002030245,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.0019279801,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0019279801,
				"type": "OTHER"
			},
			{
				"name": "memorial",
				"salience": 0.0019279801,
				"type": "EVENT"
			},
			{
				"name": "prosecution",
				"salience": 0.0019221515,
				"type": "PERSON"
			},
			{
				"name": "guys",
				"salience": 0.0019036952,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0018913692,
				"type": "OTHER"
			},
			{
				"name": "acquittal",
				"salience": 0.0018656653,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0018017024,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0018017024,
				"type": "OTHER"
			},
			{
				"name": "jurors",
				"salience": 0.0018017024,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.0018017024,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0017565967,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0017250008,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.0017250008,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.0017250008,
				"type": "LOCATION"
			},
			{
				"name": "charges",
				"salience": 0.0017217891,
				"type": "OTHER"
			},
			{
				"name": "misdemeanor trespassing charges",
				"salience": 0.0017217891,
				"type": "OTHER"
			},
			{
				"name": "felony conspiracy charges",
				"salience": 0.0017217891,
				"type": "OTHER"
			},
			{
				"name": "Few",
				"salience": 0.0016736512,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0016645003,
				"type": "OTHER"
			},
			{
				"name": "conspiracy charge",
				"salience": 0.0016575354,
				"type": "OTHER"
			},
			{
				"name": "militancy",
				"salience": 0.0016423841,
				"type": "OTHER"
			},
			{
				"name": "prosecutor",
				"salience": 0.0016301064,
				"type": "PERSON"
			},
			{
				"name": "refuge",
				"salience": 0.0016301064,
				"type": "LOCATION"
			},
			{
				"name": "protesters",
				"salience": 0.0015611729,
				"type": "PERSON"
			},
			{
				"name": "jail",
				"salience": 0.0015611729,
				"type": "LOCATION"
			},
			{
				"name": "protests",
				"salience": 0.0015611729,
				"type": "EVENT"
			},
			{
				"name": "defendants",
				"salience": 0.0015279455,
				"type": "PERSON"
			},
			{
				"name": "standoff",
				"salience": 0.0015107058,
				"type": "EVENT"
			},
			{
				"name": "occupiers",
				"salience": 0.0015069522,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.0014773476,
				"type": "OTHER"
			},
			{
				"name": "ownership",
				"salience": 0.0014709209,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04csldy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/OregonLive.com"
				},
				"name": "OregonLive",
				"salience": 0.0014673026,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01yqvd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Oregonian"
				},
				"name": "The Oregonian",
				"salience": 0.0014673026,
				"type": "ORGANIZATION"
			},
			{
				"name": "dominion",
				"salience": 0.0014222101,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0014115773,
				"type": "PERSON"
			},
			{
				"name": "land stewardship",
				"salience": 0.0013951975,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/099ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boise,_Idaho"
				},
				"name": "Boise",
				"salience": 0.0013705528,
				"type": "LOCATION"
			},
			{
				"name": "bean bags",
				"salience": 0.0013518794,
				"type": "OTHER"
			},
			{
				"name": "pepper spray",
				"salience": 0.0013518794,
				"type": "OTHER"
			},
			{
				"name": "riot gear",
				"salience": 0.0013518794,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0013518794,
				"type": "PERSON"
			},
			{
				"name": "oil pipeline",
				"salience": 0.0013518794,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0013518794,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.0013518794,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.0013518794,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.0013518794,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0013348467,
				"type": "PERSON"
			},
			{
				"name": "refuge headquarters",
				"salience": 0.001301422,
				"type": "LOCATION"
			},
			{
				"name": "failure",
				"salience": 0.001301422,
				"type": "OTHER"
			},
			{
				"name": "aspirations",
				"salience": 0.001301422,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.001301422,
				"type": "WORK_OF_ART"
			},
			{
				"name": "panel",
				"salience": 0.001301422,
				"type": "ORGANIZATION"
			},
			{
				"name": "half",
				"salience": 0.001301422,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.001301422,
				"type": "OTHER"
			},
			{
				"name": "affirmation",
				"salience": 0.001301422,
				"type": "OTHER"
			},
			{
				"name": "beliefs",
				"salience": 0.001301422,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0012862858,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0012745261,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0012564161,
				"type": "LOCATION"
			},
			{
				"name": "anger",
				"salience": 0.0012269543,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0012214743,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/010h3lhj"
				},
				"name": "Ryan Bundy",
				"salience": 0.0012029252,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03s5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idaho"
				},
				"name": "Idaho",
				"salience": 0.0011868008,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0011868008,
				"type": "LOCATION"
			},
			{
				"name": "approach",
				"salience": 0.0011610652,
				"type": "OTHER"
			},
			{
				"name": "convictions",
				"salience": 0.0011036422,
				"type": "OTHER"
			},
			{
				"name": "gunbattle",
				"salience": 0.0011036422,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.0011036422,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0010760041,
				"type": "OTHER"
			},
			{
				"name": "downside",
				"salience": 0.0010690348,
				"type": "OTHER"
			},
			{
				"name": "upside",
				"salience": 0.0010690348,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0010624456,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0010545012,
				"type": "OTHER"
			},
			{
				"name": "ranchers",
				"salience": 0.0010545012,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0010545012,
				"type": "PERSON"
			},
			{
				"name": "locals",
				"salience": 0.00097656116,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.0009609462,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.0009385736,
				"type": "LOCATION"
			},
			{
				"name": "occupiers",
				"salience": 0.0009368255,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0009368255,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0009368255,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0009368255,
				"type": "WORK_OF_ART"
			},
			{
				"name": "verdicts",
				"salience": 0.00092009193,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0105ckdm"
				},
				"name": "Cliven Bundy",
				"salience": 0.00089860917,
				"type": "PERSON"
			},
			{
				"name": "Dakota Access",
				"salience": 0.00083209045,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lwyk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boise_State_University"
				},
				"name": "Boise State University",
				"salience": 0.00083209045,
				"type": "ORGANIZATION"
			},
			{
				"name": "timber business owners",
				"salience": 0.00083132257,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00083132257,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0008244336,
				"type": "OTHER"
			},
			{
				"name": "options",
				"salience": 0.0008244336,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.0008244336,
				"type": "OTHER"
			},
			{
				"name": "miners",
				"salience": 0.0008244336,
				"type": "PERSON"
			},
			{
				"name": "loggers",
				"salience": 0.0008244336,
				"type": "PERSON"
			},
			{
				"name": "feelings",
				"salience": 0.0008244336,
				"type": "OTHER"
			},
			{
				"name": "compatriots",
				"salience": 0.0008244336,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.0008244336,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0008244336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.00080102665,
				"type": "LOCATION"
			},
			{
				"name": "Congressional Overview of Federal Land Ownership",
				"salience": 0.00080102665,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.0007844686,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.00077167846,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.00076799106,
				"type": "EVENT"
			},
			{
				"name": "jury",
				"salience": 0.0007640262,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04sdj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Married..._with_Children"
				},
				"name": "Bundys",
				"salience": 0.000724331,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charges",
				"salience": 0.0006998065,
				"type": "OTHER"
			},
			{
				"name": "assault charge",
				"salience": 0.0006998065,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0006998065,
				"type": "OTHER"
			},
			{
				"name": "sanctuary",
				"salience": 0.00069340697,
				"type": "LOCATION"
			},
			{
				"name": "takeover",
				"salience": 0.00069340697,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03b8c4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loyola_Law_School"
				},
				"name": "Loyola Law School",
				"salience": 0.00067927,
				"type": "ORGANIZATION"
			},
			{
				"name": "standoff",
				"salience": 0.0006625268,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.00064789207,
				"type": "OTHER"
			},
			{
				"name": "feds",
				"salience": 0.0006004167,
				"type": "OTHER"
			},
			{
				"name": "swaths",
				"salience": 0.0006004167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mx9b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harney_County,_Oregon"
				},
				"name": "Harney County",
				"salience": 0.0005619927,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.00055641925,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.00051795924,
				"type": "PERSON"
			},
			{
				"name": "jail",
				"salience": 0.00051795924,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02hkr7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Nature_Conservancy"
				},
				"name": "Nature Conservancy",
				"salience": 0.00051163894,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indians",
				"salience": 0.0005073985,
				"type": "PERSON"
			},
			{
				"name": "locals",
				"salience": 0.0005049849,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.00044849294,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.00044849294,
				"type": "OTHER"
			},
			{
				"name": "traffic stop",
				"salience": 0.00044849294,
				"type": "LOCATION"
			},
			{
				"name": "negotiations",
				"salience": 0.00044849294,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.00044849294,
				"type": "EVENT"
			},
			{
				"name": "holdouts",
				"salience": 0.00044849294,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f4r5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bureau_of_Land_Management"
				},
				"name": "Bureau of Land Management",
				"salience": 0.0003695129,
				"type": "ORGANIZATION"
			},
			{
				"name": "roads",
				"salience": 0.00036149725,
				"type": "LOCATION"
			},
			{
				"name": "most",
				"salience": 0.00035402333,
				"type": "OTHER"
			},
			{
				"name": "Finicum",
				"salience": 0.0003187619,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/Lavoy_Finicum.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T19:01:14.347+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Oregon Standoff Acquittal Sparks Fears of New Land Disputes 11/01/2016 \nAGWEB \nThe stunning acquittal of seven people who occupied a federal wildlife sanctuary in Oregon during an armed standoff raised fears Friday that the verdict could embolden other militant groups in a long-running dispute over government-owned Western lands. \nMeanwhile, a juror said the decision was a rejection of the prosecution’s conspiracy case, not an endorsement of the defendants’ actions. \nSupporters of Ammon Bundy celebrated the verdict and said it could invite more confrontations. The government’s top federal land official, Interior Secretary Sally Jewell, issued a statement urging all employees to “remain vigilant and report any suspicious activity.” \nAn activist from Boise, Idaho, who once camped by a memorial to occupier LaVoy Finicum at the site where he was shot dead by police, predicted that the verdict would encourage others to act. \n“I think a lot more people will be revolting, rebelling and standing up against what we see as a tyrannical government,” William C. Fisher said in a telephone interview. \nThe 41-day takeover of the Malheur National Wildlife Refuge last January in remote eastern Oregon was part of a larger debate about the use of federal lands in the West. The militants led by Bundy, a small business owner from Arizona, wanted to hand the refuge over to local officials, saying the federal government should not have dominion over it. \nThe U.S. government owns nearly half of all land in the West, compared with only 4 percent in other states, according to the Congressional Overview of Federal Land Ownership. \nOne of the jurors in the case asserted Friday that the panel was not endorsing militancy to resolve those issues. \nThe juror, identified only as Juror No. 4, wrote in an email to The Oregonian/OregonLive that the verdicts were a “statement” about the prosecution’s failure to prove a conspiracy charge “and not any form of affirmation of the defense’s various beliefs, actions or aspirations.” \nThe acquittal of the white occupiers came on the same day that officers in riot gear evicted protesters from private land in the path of the Dakota Access oil pipeline in rural North Dakota. Officers fired bean bags and pepper spray as they surrounded demonstrators, many of them Native Americans who have spent months fighting over tribal rights and the project’s environmental effects. At least 117 people were arrested. \n“Are we going to look at these protests the same way?” asked John Freemuth, a public land policy expert at Boise State University. “I certainly think the tribes will have a point if they find themselves arrested and in jail and these Oregon guys get off.” \nBundy, his brother Ryan Bundy and five others were charged with conspiring to impede federal workers from their jobs at the refuge. \nChris Rasmussen, a defense lawyer in an armed standoff case that happened two years ago at Bundy’s father’s ranch in Nevada, said it is “obvious” that Oregon prosecutors gambled in seeking convictions on felony conspiracy charges instead of misdemeanor trespassing charges. \nBut prosecutors had few other options for serious charges because the defendants never attacked anyone, said Laurie Levenson, a professor at Loyola Law School in Los Angeles and a former federal prosecutor. \nRather than attempting to retake the refuge headquarters and risking a gunbattle, authorities took a cautious approach. They closed nearby roads and stayed miles away while urging the occupiers to abandon the land. \n“The upside of not confronting them was it was less likely there would be violence,” Levenson said. “The downside was it was less likely that they could use the assault charge.” \nThe standoff finally ended when the Bundys and other key figures were arrested in a Jan. 26 traffic stop outside the refuge. That’s when Finicum was killed. Most occupiers left after his death, but four holdouts remained until Feb. 11, when they surrendered following lengthy negotiations. \nBundy remains in jail because he still faces charges in the standoff at his father’s Nevada ranch. \nJoel Hansen, Cliven Bundy’s attorney, said Friday that he thinks the jury in Oregon “saw through the lies” of a government that “is trying to prove these Bundybrothers and their compatriots were some kind of terrorists.” \nFor Hansen and some others in the rural West, ownership of public land is a constitutional question that has not been settled. \n“There is a seething anger among those who use the land,” he said, citing the feelings of ranchers, loggers, miners and Indians. “It’s all part of tyrannical oppression. Their goal is to manage them out of business to get them off the land.” \nThe Oregon occupiers had chosen, perhaps inadvertently, a part of Oregon where locals and the feds had a recent history of working together. Few who live near the sanctuary welcomed the occupiers, most of whom were from out of state. \nNot long before the takeover began on Jan. 2, locals and federal officials had determined the fate of large swaths of land, Harney County Judge Steve Grasty, the top local administrative official, said last summer in an interview. \nThe High Desert Partnership in Harney County, a group that includes the Bureau of Land Management, the Nature Conservancy and timber business owners, had been working quietly to determine land stewardship, which Jewell credited in her statement on Friday.",
		"thread_title": "Oregon Standoff Acquittal Sparks Fears of New Land Disputes",
		"title": "Oregon Standoff Acquittal Sparks Fears of New Land Disputes",
		"type": "bs",
		"uuid": "fe070842076caeed33954c33d99e264a63f7d50b"
	},
	"-KhIh9dsiWmH8v8hDHX2": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T19:08:59.803+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0l8sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Time_Warner"
				},
				"name": "Time-Warner",
				"salience": 0.13794781,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0plw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AOL"
				},
				"name": "AOL",
				"salience": 0.058280747,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.03991017,
				"type": "ORGANIZATION"
			},
			{
				"name": "Government",
				"salience": 0.034990974,
				"type": "ORGANIZATION"
			},
			{
				"name": "many",
				"salience": 0.02450941,
				"type": "PERSON"
			},
			{
				"name": "monopoly power",
				"salience": 0.022144973,
				"type": "OTHER"
			},
			{
				"name": "communications firm",
				"salience": 0.019192295,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/032mx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Food_and_Drug_Administration"
				},
				"name": "Food and Drug Administration",
				"salience": 0.018229743,
				"type": "ORGANIZATION"
			},
			{
				"name": "concerns",
				"salience": 0.016917659,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.016729588,
				"type": "PERSON"
			},
			{
				"name": "Not Markets For Monopoly",
				"salience": 0.016368456,
				"type": "ORGANIZATION"
			},
			{
				"name": "competitors",
				"salience": 0.01592806,
				"type": "ORGANIZATION"
			},
			{
				"name": "merger",
				"salience": 0.015307643,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.014457387,
				"type": "ORGANIZATION"
			},
			{
				"name": "costs",
				"salience": 0.014260314,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0130148055,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016lh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ron_Paul"
				},
				"name": "Ron Paul",
				"salience": 0.011837683,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qkt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurasia"
				},
				"name": "EURASIA",
				"salience": 0.011837683,
				"type": "LOCATION"
			},
			{
				"name": "government action",
				"salience": 0.009826248,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.009826248,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.009826248,
				"type": "OTHER"
			},
			{
				"name": "cable company",
				"salience": 0.009256919,
				"type": "ORGANIZATION"
			},
			{
				"name": "takeover",
				"salience": 0.009148846,
				"type": "EVENT"
			},
			{
				"name": "businesses",
				"salience": 0.008794472,
				"type": "ORGANIZATION"
			},
			{
				"name": "merger",
				"salience": 0.008777457,
				"type": "OTHER"
			},
			{
				"name": "competitors",
				"salience": 0.008466261,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.008466261,
				"type": "ORGANIZATION"
			},
			{
				"name": "competition",
				"salience": 0.008466261,
				"type": "OTHER"
			},
			{
				"name": "competitors",
				"salience": 0.008466261,
				"type": "ORGANIZATION"
			},
			{
				"name": "regulations",
				"salience": 0.008159093,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.007438707,
				"type": "PERSON"
			},
			{
				"name": "consumers",
				"salience": 0.00690463,
				"type": "PERSON"
			},
			{
				"name": "managers",
				"salience": 0.006880758,
				"type": "PERSON"
			},
			{
				"name": "competitors",
				"salience": 0.006656592,
				"type": "ORGANIZATION"
			},
			{
				"name": "Legislation",
				"salience": 0.0066020307,
				"type": "WORK_OF_ART"
			},
			{
				"name": "merger",
				"salience": 0.006316101,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08z129",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AT%26T"
				},
				"name": "AT&T",
				"salience": 0.006053905,
				"type": "ORGANIZATION"
			},
			{
				"name": "mergers",
				"salience": 0.0060041607,
				"type": "EVENT"
			},
			{
				"name": "marketplace",
				"salience": 0.0059801666,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.005939655,
				"type": "ORGANIZATION"
			},
			{
				"name": "entry",
				"salience": 0.0052182525,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0052006315,
				"type": "ORGANIZATION"
			},
			{
				"name": "quality",
				"salience": 0.0051792786,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.0051301806,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.005006717,
				"type": "ORGANIZATION"
			},
			{
				"name": "failure",
				"salience": 0.0048980094,
				"type": "EVENT"
			},
			{
				"name": "competition",
				"salience": 0.0048501203,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0048501203,
				"type": "ORGANIZATION"
			},
			{
				"name": "prices",
				"salience": 0.004694866,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.004662742,
				"type": "PERSON"
			},
			{
				"name": "regulations",
				"salience": 0.004645177,
				"type": "OTHER"
			},
			{
				"name": "leviathan",
				"salience": 0.0045395154,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0041052923,
				"type": "OTHER"
			},
			{
				"name": "Big business",
				"salience": 0.0041052923,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.004050304,
				"type": "OTHER"
			},
			{
				"name": "markets",
				"salience": 0.0040380647,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.003807156,
				"type": "PERSON"
			},
			{
				"name": "regulations",
				"salience": 0.0037928103,
				"type": "OTHER"
			},
			{
				"name": "government regulations",
				"salience": 0.0037928103,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.0037928103,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.0037928103,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0037851231,
				"type": "OTHER"
			},
			{
				"name": "Monopolies",
				"salience": 0.0037851231,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0037851231,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.003659841,
				"type": "OTHER"
			},
			{
				"name": "competitors",
				"salience": 0.003624044,
				"type": "ORGANIZATION"
			},
			{
				"name": "creations",
				"salience": 0.003568248,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investors",
				"salience": 0.0034969847,
				"type": "PERSON"
			},
			{
				"name": "products",
				"salience": 0.0034969847,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "investors",
				"salience": 0.0034969847,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.0034614296,
				"type": "PERSON"
			},
			{
				"name": "Examples",
				"salience": 0.003334595,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0032799751,
				"type": "OTHER"
			},
			{
				"name": "franchise",
				"salience": 0.0032799751,
				"type": "OTHER"
			},
			{
				"name": "``mainstream'' media",
				"salience": 0.0032799751,
				"type": "ORGANIZATION"
			},
			{
				"name": "boards",
				"salience": 0.0031576043,
				"type": "ORGANIZATION"
			},
			{
				"name": "management",
				"salience": 0.0031576043,
				"type": "OTHER"
			},
			{
				"name": "takeovers",
				"salience": 0.0031576043,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0030904186,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0030262235,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.0029657753,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.0029547457,
				"type": "PERSON"
			},
			{
				"name": "costs",
				"salience": 0.0028915366,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.0028403846,
				"type": "PERSON"
			},
			{
				"name": "lapdogs",
				"salience": 0.0028403846,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0028403846,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0028403846,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0028403846,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0028403846,
				"type": "PERSON"
			},
			{
				"name": "licensing fees",
				"salience": 0.0028403846,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.0028403846,
				"type": "OTHER"
			},
			{
				"name": "television",
				"salience": 0.0028403846,
				"type": "OTHER"
			},
			{
				"name": "cartels",
				"salience": 0.0027344,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0027344,
				"type": "PERSON"
			},
			{
				"name": "harm",
				"salience": 0.0027344,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0027344,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0027344,
				"type": "OTHER"
			},
			{
				"name": "returns",
				"salience": 0.0027344,
				"type": "OTHER"
			},
			{
				"name": "board members",
				"salience": 0.0027344,
				"type": "PERSON"
			},
			{
				"name": "directors",
				"salience": 0.0027344,
				"type": "PERSON"
			},
			{
				"name": "efficiency",
				"salience": 0.0027344,
				"type": "OTHER"
			},
			{
				"name": "drug",
				"salience": 0.0026779051,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "politicians",
				"salience": 0.0026779051,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.0026779051,
				"type": "OTHER"
			},
			{
				"name": "Government taxes",
				"salience": 0.0026779051,
				"type": "OTHER"
			},
			{
				"name": "competition",
				"salience": 0.0026398646,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0026288885,
				"type": "WORK_OF_ART"
			},
			{
				"name": "free market",
				"salience": 0.0025587082,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0024395722,
				"type": "OTHER"
			},
			{
				"name": "prices",
				"salience": 0.0023983626,
				"type": "OTHER"
			},
			{
				"name": "lobbyists",
				"salience": 0.0023189466,
				"type": "PERSON"
			},
			{
				"name": "industry",
				"salience": 0.0023189466,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0023189466,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.002311109,
				"type": "ORGANIZATION"
			},
			{
				"name": "prices",
				"salience": 0.002251053,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.002234225,
				"type": "ORGANIZATION"
			},
			{
				"name": "products",
				"salience": 0.0022157163,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "investors",
				"salience": 0.0022157163,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.0022042815,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.0020640702,
				"type": "OTHER"
			},
			{
				"name": "intuitions",
				"salience": 0.00202959,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.0020170824,
				"type": "OTHER"
			},
			{
				"name": "monetary policy",
				"salience": 0.0020006043,
				"type": "OTHER"
			},
			{
				"name": "competitors",
				"salience": 0.001972179,
				"type": "ORGANIZATION"
			},
			{
				"name": "competitors",
				"salience": 0.001972179,
				"type": "ORGANIZATION"
			},
			{
				"name": "free market",
				"salience": 0.0018636719,
				"type": "OTHER"
			},
			{
				"name": "products",
				"salience": 0.0018553485,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fiasco",
				"salience": 0.0018457723,
				"type": "OTHER"
			},
			{
				"name": "consumers",
				"salience": 0.0018021604,
				"type": "PERSON"
			},
			{
				"name": "Monopolies",
				"salience": 0.0017468581,
				"type": "ORGANIZATION"
			},
			{
				"name": "prices",
				"salience": 0.0017468581,
				"type": "OTHER"
			},
			{
				"name": "mergers",
				"salience": 0.001734085,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.0017323848,
				"type": "OTHER"
			},
			{
				"name": "acquisitions",
				"salience": 0.0017323848,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0017323848,
				"type": "OTHER"
			},
			{
				"name": "dot.com bubble",
				"salience": 0.0017323848,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0017265285,
				"type": "ORGANIZATION"
			},
			{
				"name": "example",
				"salience": 0.0016816553,
				"type": "OTHER"
			},
			{
				"name": "mergers",
				"salience": 0.0016275551,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0016259593,
				"type": "OTHER"
			},
			{
				"name": "quality",
				"salience": 0.0016138017,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.0014570995,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0014570995,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0014142633,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0013741133,
				"type": "PERSON"
			},
			{
				"name": "playing field",
				"salience": 0.0012617185,
				"type": "OTHER"
			},
			{
				"name": "business cycle",
				"salience": 0.0012617185,
				"type": "OTHER"
			},
			{
				"name": "crony capitalists",
				"salience": 0.0012617185,
				"type": "PERSON"
			},
			{
				"name": "favor",
				"salience": 0.0012617185,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0012046918,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xmb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Reserve_System"
				},
				"name": "Federal Reserve",
				"salience": 0.0011879836,
				"type": "ORGANIZATION"
			},
			{
				"name": "radio station",
				"salience": 0.0010611997,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0010042004,
				"type": "OTHER"
			},
			{
				"name": "alternatives",
				"salience": 0.0009424962,
				"type": "OTHER"
			},
			{
				"name": "purchases",
				"salience": 0.0009424962,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0009424962,
				"type": "PERSON"
			},
			{
				"name": "Internet retailers",
				"salience": 0.0009424962,
				"type": "ORGANIZATION"
			},
			{
				"name": "stores",
				"salience": 0.0009424962,
				"type": "LOCATION"
			},
			{
				"name": "pharmaceuticals",
				"salience": 0.0009424962,
				"type": "OTHER"
			},
			{
				"name": "limit consumers ability",
				"salience": 0.0009424962,
				"type": "OTHER"
			},
			{
				"name": "sales tax",
				"salience": 0.0009424962,
				"type": "OTHER"
			},
			{
				"name": "RonPaul Institute",
				"salience": 0.000776535,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09ggjpz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dodd%E2%80%93Frank_Wall_Street_Reform_and_Consumer_Protection_Act"
				},
				"name": "Dodd-Frank",
				"salience": 0.00066988857,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/Ron-Paul.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T19:08:59.803+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Ron Paul: Blame Government, Not Markets For Monopoly 11/01/2016 \nEURASIA REVIEW \nWhen Time-Warner announced it planned to merge with another major communications firm, many feared the new company would exercise near-total monopoly power. These concerns led some to call for government action to block the merger in order to protect both Time-Warner’s competitors and consumers. \nNo, I am not talking about Time-Warner’s recent announced plan to merge with AT&T, but the reaction to Time-Warner’s merger with (then) Internet giant AOL in 2000. Far from creating an untouchable leviathan crushing all competitors, the AOL-Time-Warner merger fell apart in under a decade. \nThe failure of AOL-Time-Warner demonstrates that even the biggest companies are vulnerable to competition if there is open entry into the marketplace. AOL-Time-Warner failed because consumers left them for competitors offering lower prices and/or better quality. \nCorporate mergers and “hostile” takeovers can promote economic efficiency by removing inefficient management and boards of directors. These managers and board members often work together to promote their own interests instead of generating maximum returns for investors by providing consumers with affordable, quality products. Thus, laws making it difficult to launch a “hostile” takeover promote inefficient use of resources and harm investors, workers, and consumers. \nMonopolies and cartels are creations of government, not markets. For example, the reason the media is dominated by a few large companies is that no one can operate a television or radio station unless they obtain federal approval and pay federal licensing fees. Similarly, anyone wishing to operate a cable company must not only comply with federal regulations, they must sign a “franchise” agreement with their local government. Fortunately, the Internet has given Americans greater access to news and ideas shut out by the government-licensed lapdogs of the “mainstream” media. This may be why so many politicians are anxious to regulate the web. \nGovernment taxes and regulations are effective means of limiting competition in an industry. Large companies can afford the costs of complying with government regulations, costs which cripple their smaller competitors. Big business can also afford to hire lobbyists to ensure that new laws and regulations favor big business. \nExamples of regulations that benefit large corporations include the Food and Drug Administration’s (FDA) regulations that raise costs of developing a new drug, as well as limit consumers ability to learn about natural alternatives to pharmaceuticals. Another example is the Dodd-Frank legislation, which has strengthened large financial intuitions while harming their weaker competitors. \nLegislation forcing consumers to pay out-of-state sales tax on their online purchases is a classic case of business seeking to use government to harm less politically-powerful competitors. This legislation is being pushed by large brick-and-mortar stores and Internet retailers who are seeking a government-granted advantage over smaller competitors. \nMany failed mergers and acquisitions result from the distorted signals sent to business and investors by the Federal Reserve’s inflationary monetary policy. Perhaps the most famous example of this is the AOL-Time-Warner fiasco, which was a direct result of the Fed-created dot.com bubble. \nIn a free market, mergers between businesses enable consumers to benefit from new products and reduced prices. Any businesses that charge high prices or offer substandard products will soon face competition from businesses offering consumers lower prices and/or higher quality. Monopolies only exist when government tilts the playing field in favor of well-connected crony capitalists. Therefore those concerned about excessive corporate power should join supporters of the free market in repudiating the regulations, taxes, and subsides that benefit politically-powerful businesses. The most important step is to end the boom-bust business cycle by ending the Federal Reserve. \nThis article was published by RonPaul Institute .",
		"thread_title": "Ron Paul: Blame Government, Not Markets For Monopoly",
		"title": "Ron Paul: Blame Government, Not Markets For Monopoly",
		"type": "bs",
		"uuid": "c6db551a65a035a1bc72863046bf652c39fbdc0e"
	},
	"-KhIhA1z0SyuQ_xwEvuL": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T19:08:59.936+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.28722522,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "U.S. Department of Justice",
				"salience": 0.19016623,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.11411769,
				"type": "ORGANIZATION"
			},
			{
				"name": "Andrew McCabe",
				"salience": 0.023690507,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07qphl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Journal_(newspaper)"
				},
				"name": "The Journal",
				"salience": 0.022191186,
				"type": "WORK_OF_ART"
			},
			{
				"name": "devices",
				"salience": 0.018573537,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "The Wall Street Journal",
				"salience": 0.018225506,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.013446032,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.013446032,
				"type": "EVENT"
			},
			{
				"name": "official",
				"salience": 0.0118814055,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.011470627,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.011201794,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.010638117,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.009934363,
				"type": "LOCATION"
			},
			{
				"name": "bombshell report",
				"salience": 0.009127755,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.00898127,
				"type": "ORGANIZATION"
			},
			{
				"name": "family charity",
				"salience": 0.00881948,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dgtb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terry_McAuliffe"
				},
				"name": "Terry McAuliffe",
				"salience": 0.0074085044,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.006894156,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.006894156,
				"type": "PERSON"
			},
			{
				"name": "investigators",
				"salience": 0.006894156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d4tjn"
				},
				"name": "Jill",
				"salience": 0.0049117715,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "DAILY CALLER",
				"salience": 0.0046181935,
				"type": "ORGANIZATION"
			},
			{
				"name": "attorneys",
				"salience": 0.004425144,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.004425144,
				"type": "OTHER"
			},
			{
				"name": "law enforcement sources",
				"salience": 0.0041483934,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0038656609,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Clinton Foundation Investigation 11",
				"salience": 0.0036126687,
				"type": "OTHER"
			},
			{
				"name": "Richard Pollock",
				"salience": 0.0035035997,
				"type": "PERSON"
			},
			{
				"name": "lawyers",
				"salience": 0.0034615549,
				"type": "PERSON"
			},
			{
				"name": "attorney general",
				"salience": 0.0034615549,
				"type": "PERSON"
			},
			{
				"name": "Prosecutors",
				"salience": 0.0034615549,
				"type": "PERSON"
			},
			{
				"name": "investigators",
				"salience": 0.0032481449,
				"type": "PERSON"
			},
			{
				"name": "agreements",
				"salience": 0.0030688315,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.002998142,
				"type": "OTHER"
			},
			{
				"name": "email investigation",
				"salience": 0.0028442494,
				"type": "EVENT"
			},
			{
				"name": "revelation",
				"salience": 0.002657901,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0025338694,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0023821208,
				"type": "EVENT"
			},
			{
				"name": "Information",
				"salience": 0.002317171,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0022077772,
				"type": "EVENT"
			},
			{
				"name": "official",
				"salience": 0.002098686,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.002098686,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0019949782,
				"type": "EVENT"
			},
			{
				"name": "investigations",
				"salience": 0.0019949782,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.0019263914,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.0019205702,
				"type": "EVENT"
			},
			{
				"name": "attorneys offices",
				"salience": 0.0019205702,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lgh_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_District_Court_for_the_Eastern_District_of_New_York"
				},
				"name": "Eastern District of New York",
				"salience": 0.0018463687,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0017096133,
				"type": "OTHER"
			},
			{
				"name": "relationships",
				"salience": 0.0016395268,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0016288711,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0016288711,
				"type": "EVENT"
			},
			{
				"name": "office",
				"salience": 0.0016288711,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.0016288711,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0016288711,
				"type": "EVENT"
			},
			{
				"name": "office",
				"salience": 0.0016288711,
				"type": "ORGANIZATION"
			},
			{
				"name": "field offices",
				"salience": 0.0016288711,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0016083583,
				"type": "OTHER"
			},
			{
				"name": "field office agents",
				"salience": 0.0015996095,
				"type": "PERSON"
			},
			{
				"name": "devices",
				"salience": 0.0015794649,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "The Daily Caller News Foundation",
				"salience": 0.0015544055,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.001512694,
				"type": "OTHER"
			},
			{
				"name": "lawyers",
				"salience": 0.0014261724,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0014261724,
				"type": "OTHER"
			},
			{
				"name": "immunity agreement",
				"salience": 0.0014261724,
				"type": "OTHER"
			},
			{
				"name": "immunity",
				"salience": 0.0014261724,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.0013509386,
				"type": "OTHER"
			},
			{
				"name": "official",
				"salience": 0.0013468547,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.0013285867,
				"type": "EVENT"
			},
			{
				"name": "reporting",
				"salience": 0.0013005309,
				"type": "OTHER"
			},
			{
				"name": "rationale",
				"salience": 0.0012992561,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.0012585296,
				"type": "OTHER"
			},
			{
				"name": "Clintonworld",
				"salience": 0.0012487159,
				"type": "PERSON"
			},
			{
				"name": "mishandling",
				"salience": 0.00123502,
				"type": "EVENT"
			},
			{
				"name": "outrage",
				"salience": 0.00123502,
				"type": "OTHER"
			},
			{
				"name": "laptops",
				"salience": 0.00123502,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "email system",
				"salience": 0.00123502,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00123502,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0012312862,
				"type": "OTHER"
			},
			{
				"name": "interviews",
				"salience": 0.0012257885,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0012169692,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.0012169692,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0012062975,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026swz9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cheryl_Mills"
				},
				"name": "Cheryl Mills",
				"salience": 0.0011560256,
				"type": "PERSON"
			},
			{
				"name": "Heather Samuelson",
				"salience": 0.0011560256,
				"type": "PERSON"
			},
			{
				"name": "call",
				"salience": 0.0011075696,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.0011029349,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charity probe",
				"salience": 0.0010442038,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0010062505,
				"type": "LOCATION"
			},
			{
				"name": "action",
				"salience": 0.0009955796,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0009787604,
				"type": "OTHER"
			},
			{
				"name": "grand jury",
				"salience": 0.0009627224,
				"type": "PERSON"
			},
			{
				"name": "subpoenas",
				"salience": 0.0009627224,
				"type": "OTHER"
			},
			{
				"name": "RELATED",
				"salience": 0.0009627224,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.00090043223,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.00089770945,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.00088639895,
				"type": "PERSON"
			},
			{
				"name": "details",
				"salience": 0.00086597475,
				"type": "OTHER"
			},
			{
				"name": "discord",
				"salience": 0.00086597475,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00086597475,
				"type": "OTHER"
			},
			{
				"name": "displeasure",
				"salience": 0.00086597475,
				"type": "OTHER"
			},
			{
				"name": "pushback",
				"salience": 0.0008336525,
				"type": "EVENT"
			},
			{
				"name": "turns",
				"salience": 0.0008336525,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0008336525,
				"type": "OTHER"
			},
			{
				"name": "EXCLUSIVE",
				"salience": 0.0008336525,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0008336525,
				"type": "OTHER"
			},
			{
				"name": "super PAC",
				"salience": 0.00081642345,
				"type": "OTHER"
			},
			{
				"name": "official",
				"salience": 0.000771,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0007602281,
				"type": "PERSON"
			},
			{
				"name": "Attorneys Conducting Joint Probe Of Clinton Foundation",
				"salience": 0.00075792894,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.00075323344,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.00075323344,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0007311756,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0007069583,
				"type": "OTHER"
			},
			{
				"name": "contributions",
				"salience": 0.0007069583,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0007069583,
				"type": "EVENT"
			},
			{
				"name": "state senate",
				"salience": 0.0007069583,
				"type": "ORGANIZATION"
			},
			{
				"name": "help",
				"salience": 0.0007069583,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.00067547953,
				"type": "PERSON"
			},
			{
				"name": "email investigation",
				"salience": 0.0006621673,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0006621673,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0006621673,
				"type": "EVENT"
			},
			{
				"name": "investigations",
				"salience": 0.0006621673,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.00066172483,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0006155144,
				"type": "WORK_OF_ART"
			},
			{
				"name": "orders",
				"salience": 0.00060988625,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00060988625,
				"type": "OTHER"
			},
			{
				"name": "phone conversation",
				"salience": 0.00060988625,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00059769745,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00059426384,
				"type": "LOCATION"
			},
			{
				"name": "claim",
				"salience": 0.0005919558,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0005681337,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00054746115,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.00053251657,
				"type": "OTHER"
			},
			{
				"name": "inquiry",
				"salience": 0.0005281036,
				"type": "OTHER"
			},
			{
				"name": "chain",
				"salience": 0.0005281036,
				"type": "OTHER"
			},
			{
				"name": "command",
				"salience": 0.0005281036,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.0005281036,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00049194804,
				"type": "OTHER"
			},
			{
				"name": "interviews",
				"salience": 0.00049194804,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.0004526193,
				"type": "PERSON"
			},
			{
				"name": "conversation",
				"salience": 0.00044417154,
				"type": "OTHER"
			},
			{
				"name": "subpoenas",
				"salience": 0.00044417154,
				"type": "OTHER"
			},
			{
				"name": "grand jury",
				"salience": 0.00044417154,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00043511583,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ftvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Little_Rock,_Arkansas"
				},
				"name": "Little Rock",
				"salience": 0.00043511583,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0004243906,
				"type": "OTHER"
			},
			{
				"name": "email probe",
				"salience": 0.0004243906,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0003977825,
				"type": "OTHER"
			},
			{
				"name": "Others",
				"salience": 0.00038633068,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.00038633068,
				"type": "PERSON"
			},
			{
				"name": "pause",
				"salience": 0.0003846047,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.0003846047,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.0003846047,
				"type": "OTHER"
			},
			{
				"name": "tools",
				"salience": 0.0003846047,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0003846047,
				"type": "EVENT"
			},
			{
				"name": "career",
				"salience": 0.0003846047,
				"type": "OTHER"
			},
			{
				"name": "super PAC",
				"salience": 0.0003317851,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0003317851,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0003317851,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0003317851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0003250202,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.0003250202,
				"type": "ORGANIZATION"
			},
			{
				"name": "prosecutors",
				"salience": 0.00031537135,
				"type": "PERSON"
			},
			{
				"name": "board member",
				"salience": 0.00028728726,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.00028728726,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.00028728726,
				"type": "EVENT"
			},
			{
				"name": "donations",
				"salience": 0.00028728726,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.00028728726,
				"type": "OTHER"
			},
			{
				"name": "bank records",
				"salience": 0.00028728726,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0002609119,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.00025229694,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/2016-10-28T181331Z_1_LYNXNPEC9R196_RTROPTP_4_USA-ELECTION-CLINTON-620x413.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T19:08:59.936+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 16.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "DOJ Tried Repeatedly To Kill FBI’s Clinton Foundation Investigation 11/01/2016 \nTHE DAILY CALLER \nSenior-level Justice Department officials pushed back heavily on an ongoing FBI investigation of the Clinton Foundation, according to a bombshell report from The Wall Street Journal. \nThe newspaper laid out numerous examples, based on law enforcement sources, of senior DOJ officials intervening to quash the probe. \nProsecutors with the U.S. attorneys office in the Eastern District of New York — which Loretta Lynch led before taking over as attorney general last year — refused to allow FBI investigators probing the Clinton family charity to review emails found on devices turned over this year by two of Clinton’s lawyers during the separate investigation into the mishandling of classified information on Clinton’s private email system. \nThe rationale, according to The Journal , was that the devices were covered by partial immunity and limited-use agreements that the Clinton lawyers — Cheryl Mills and Heather Samuelson — agreed to with the DOJ. Information recovered from the laptops could only be used in the email investigation and not in others. \nAs part of the immunity agreement, the FBI and Justice Department agreed to destroy Mills’ and Samuelson’s devices, a revelation that sparked outrage from congressional Republicans when it was announced earlier this month. \nThe Journal’s report largely confirms reporting in August from The Daily Caller News Foundation’s Richard Pollock that the FBI and several U.S. attorneys offices were conducting an unorthodox, joint investigation into the Clinton Foundation. (RELATED: EXCLUSIVE: FBI-US Attorneys Conducting Joint Probe Of Clinton Foundation) \nCNN reported at around the same time that a Clinton Foundation probe was tabled by the Justice Department. Pollock’s report and the new piece from The Journal undermine CNN’s reporting. \nWhile the investigation has gone forward, the Justice Department has stymied the investigation at several turns, according to The Journal. \nThe DOJ refused to grant the FBI the power to issue subpoenas or conduct formal interviews. It also refused to convene a grand jury to weigh evidence in the case. \nMore pushback occurred in August, when a senior DOJ official contacted the FBI’s deputy director, Andrew McCabe, to voice his displeasure that New York field office agents were continuing the investigation even though the DOJ had declined to provide investigative support. \nThe official was “very pissed off” that the FBI was continuing its efforts, according to The Journal. \nThe call occurred on Aug. 12, a day after CNN reported details of FBI-DOJ discord over whether to investigate the Clinton Foundation. It was also a day after Pollock reported that an investigation was underway. \nMcCabe figures prominently in The Journal’s reporting and in the overlapping Clintonworld investigations. \nIt was revealed last week that McCabe’s wife, Jill, received nearly $470,000 in contributions to a Virginia state senate campaign last year from Gov. Terry McAuliffe’s super PAC. \nMcAuliffe is a close Clinton ally and is the subject of a separate FBI investigation. \nAccording to The Journal, McCabe refocused the Clinton Foundation investigation a week after FBI director James Comey announced in early July that he would recommend to the Justice Department that charges not be filed against Clinton for mishandling classified information in her emails. \nThe charity probe would be led by the FBI’s New York office with help from the Little Rock office, according to The Journal. FBI field offices in Los Angeles and Washington were also involved in the Clinton Foundation investigation. \nThe Los Angeles office subpoenaed bank records related to the Clinton Foundation after obtaining information during a separate public corruption case. The office in Washington was investigating McAuliffe’s financial relationships from before he joined the Clinton Foundation as a board member. \nAfter Comey’s announcement on the Clinton email investigation in July, McCabe decided that the Washington FBI office would focus on the separate McAuliffe matter. He recused himself from that investigation because of the donations his wife received from McAuliffe’s super PAC in 2015. \nWhile the FBI has insisted that McCabe is not compromised in any of the investigations — the email probe, the Clinton Foundation, or the McAuliffe matter — The Journal reports that some agents believe he has issued “stand down” orders in the Clinton Foundation inquiry. U.S. Attorney General Loretta Lynch looks on after announcing federal action related to North Carolina, at the U.S. Department of Justice (Getty Images) \nThat claim came from FBI agents lower on the chain of command from senior-level officials. Still other sources denied that McCabe issued a “stand down” order. They asserted that McCabe ordered investigators to continue on their investigative path. \nMcCabe’s Aug. 12 phone conversation with the senior DOJ official would seem to suggest that he supported the investigation. \n“Are you telling me that I need to shut down a validly predicated investigation?” McCabe asked the DOJ official, according to a Journal source who was familiar with the conversation. \n“Of course not,” the official reportedly said, after a brief pause. \nThe new report also details a presentation that FBI officials made to the Justice Department in February to lay out the case against the Clinton Foundation. \nSome of the Journal’s sources said that the DOJ’s career public integrity prosecutors did not believe that the case was strong. \n“Others said that from the start, the Justice Department officials were stern, icy and dismissive of the case,” The Journal reported. \nDOJ officials told the FBI at the meeting additional investigative tools — subpoenas, interviews or a grand jury — would not be authorized.",
		"thread_title": "DOJ Tried Repeatedly To Kill FBI’s Clinton Foundation Investigation",
		"title": "DOJ Tried Repeatedly To Kill FBI’s Clinton Foundation Investigation",
		"type": "bs",
		"uuid": "3bd8d8494dcaf6dea79c462f9b378c8a1f372375"
	},
	"-KhIhArXvRwQa_f39Ndu": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T19:18:15.734+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "devices",
				"salience": 0.12596618,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "protesters",
				"salience": 0.026803957,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.025476603,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.02058557,
				"type": "PERSON"
			},
			{
				"name": "Dave Archambault II",
				"salience": 0.020170478,
				"type": "PERSON"
			},
			{
				"name": "shots",
				"salience": 0.017208451,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.01700556,
				"type": "LOCATION"
			},
			{
				"name": "property",
				"salience": 0.015706068,
				"type": "LOCATION"
			},
			{
				"name": "Kyle Kirchmeier",
				"salience": 0.014836558,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.014174769,
				"type": "LOCATION"
			},
			{
				"name": "water protectors",
				"salience": 0.011684079,
				"type": "OTHER"
			},
			{
				"name": "Protesters",
				"salience": 0.009193024,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.009193024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock Sioux Tribe",
				"salience": 0.009124069,
				"type": "LOCATION"
			},
			{
				"name": "Protesters",
				"salience": 0.009058634,
				"type": "PERSON"
			},
			{
				"name": "department",
				"salience": 0.008517754,
				"type": "ORGANIZATION"
			},
			{
				"name": "highway",
				"salience": 0.008481672,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.008425064,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.008144859,
				"type": "PERSON"
			},
			{
				"name": "department",
				"salience": 0.007746457,
				"type": "ORGANIZATION"
			},
			{
				"name": "activists",
				"salience": 0.007128797,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.00696201,
				"type": "PERSON"
			},
			{
				"name": "oil pipeline",
				"salience": 0.006931861,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.006796192,
				"type": "PERSON"
			},
			{
				"name": "law enforcement agencies",
				"salience": 0.006689794,
				"type": "ORGANIZATION"
			},
			{
				"name": "construction vehicles",
				"salience": 0.006685135,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.006581575,
				"type": "OTHER"
			},
			{
				"name": "Authorities",
				"salience": 0.006228315,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.006096027,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.005949481,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0058704675,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0057479814,
				"type": "LOCATION"
			},
			{
				"name": "fires",
				"salience": 0.0057479814,
				"type": "EVENT"
			},
			{
				"name": "water",
				"salience": 0.0056544924,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.005544601,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "The Associated Press",
				"salience": 0.00548272,
				"type": "ORGANIZATION"
			},
			{
				"name": "pipeline protesters",
				"salience": 0.005270979,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.005270979,
				"type": "PERSON"
			},
			{
				"name": "chairman",
				"salience": 0.0052108523,
				"type": "PERSON"
			},
			{
				"name": "gear",
				"salience": 0.0052108523,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "woman",
				"salience": 0.0052048415,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.0050011063,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.0049719894,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.004921639,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.0048461203,
				"type": "PERSON"
			},
			{
				"name": "rivers",
				"salience": 0.0047508487,
				"type": "LOCATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.004708908,
				"type": "ORGANIZATION"
			},
			{
				"name": "protest site",
				"salience": 0.004615964,
				"type": "LOCATION"
			},
			{
				"name": "site",
				"salience": 0.004615964,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.0046055424,
				"type": "EVENT"
			},
			{
				"name": "rights",
				"salience": 0.0045914194,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.0045914194,
				"type": "PERSON"
			},
			{
				"name": "pepper spray",
				"salience": 0.0045483294,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.004348016,
				"type": "OTHER"
			},
			{
				"name": "fire bombs",
				"salience": 0.004348016,
				"type": "OTHER"
			},
			{
				"name": "helicopters",
				"salience": 0.004348016,
				"type": "OTHER"
			},
			{
				"name": "Camp 11",
				"salience": 0.004336315,
				"type": "LOCATION"
			},
			{
				"name": "Morton County Sheriff's Department",
				"salience": 0.004189779,
				"type": "ORGANIZATION"
			},
			{
				"name": "standoff",
				"salience": 0.0041619423,
				"type": "EVENT"
			},
			{
				"name": "Cecily Fong",
				"salience": 0.0041597732,
				"type": "PERSON"
			},
			{
				"name": "path",
				"salience": 0.0040970133,
				"type": "OTHER"
			},
			{
				"name": "horses",
				"salience": 0.0040970133,
				"type": "OTHER"
			},
			{
				"name": "pipeline",
				"salience": 0.004031642,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC NEWS",
				"salience": 0.0038614727,
				"type": "ORGANIZATION"
			},
			{
				"name": "dignity",
				"salience": 0.0038309516,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.0037021595,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.0037021595,
				"type": "ORGANIZATION"
			},
			{
				"name": "department",
				"salience": 0.0036960642,
				"type": "ORGANIZATION"
			},
			{
				"name": "injuries",
				"salience": 0.0036417404,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.003598565,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.0035446659,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.0035446659,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.0035446659,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pipe",
				"salience": 0.0035446659,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.0034937612,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.0034643773,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0034643773,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.003418291,
				"type": "OTHER"
			},
			{
				"name": "peak",
				"salience": 0.0033681754,
				"type": "OTHER"
			},
			{
				"name": "bean bags",
				"salience": 0.0033681754,
				"type": "OTHER"
			},
			{
				"name": "PVC",
				"salience": 0.0032908462,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0032643275,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.0032494275,
				"type": "EVENT"
			},
			{
				"name": "cause",
				"salience": 0.0032085294,
				"type": "OTHER"
			},
			{
				"name": "demonstrators",
				"salience": 0.003116608,
				"type": "PERSON"
			},
			{
				"name": "demonstrations",
				"salience": 0.003116608,
				"type": "EVENT"
			},
			{
				"name": "highway",
				"salience": 0.003046078,
				"type": "LOCATION"
			},
			{
				"name": "Backwater Bridge",
				"salience": 0.002925015,
				"type": "LOCATION"
			},
			{
				"name": "fires",
				"salience": 0.0028953243,
				"type": "EVENT"
			},
			{
				"name": "activists",
				"salience": 0.0028905554,
				"type": "PERSON"
			},
			{
				"name": "confrontation",
				"salience": 0.0027814612,
				"type": "EVENT"
			},
			{
				"name": "authorities",
				"salience": 0.0027759867,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0027746642,
				"type": "PERSON"
			},
			{
				"name": "property",
				"salience": 0.002772275,
				"type": "LOCATION"
			},
			{
				"name": "emergency services official",
				"salience": 0.0027112104,
				"type": "PERSON"
			},
			{
				"name": "burial sites",
				"salience": 0.002644015,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0026380396,
				"type": "EVENT"
			},
			{
				"name": "Protesters",
				"salience": 0.0025883077,
				"type": "PERSON"
			},
			{
				"name": "cars",
				"salience": 0.0025868763,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "trucks",
				"salience": 0.0025814357,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "water",
				"salience": 0.0025412317,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0025412317,
				"type": "PERSON"
			},
			{
				"name": "tires",
				"salience": 0.002346497,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "police",
				"salience": 0.0023244505,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.0023244505,
				"type": "PERSON"
			},
			{
				"name": "Demonstrators",
				"salience": 0.002274574,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0022007257,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0022007257,
				"type": "OTHER"
			},
			{
				"name": "riot gear",
				"salience": 0.0020628541,
				"type": "OTHER"
			},
			{
				"name": "revolver",
				"salience": 0.0020628541,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.002061432,
				"type": "PERSON"
			},
			{
				"name": "blockades",
				"salience": 0.0020592767,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0020592767,
				"type": "OTHER"
			},
			{
				"name": "elders",
				"salience": 0.0020592767,
				"type": "PERSON"
			},
			{
				"name": "page",
				"salience": 0.0019574817,
				"type": "OTHER"
			},
			{
				"name": "Hundreds",
				"salience": 0.0019574817,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.0019574817,
				"type": "LOCATION"
			},
			{
				"name": "reservation",
				"salience": 0.0019574817,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.0019095417,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0019095417,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0019095417,
				"type": "PERSON"
			},
			{
				"name": "prayer",
				"salience": 0.0019058007,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.0018033901,
				"type": "PERSON"
			},
			{
				"name": "Demonstrators",
				"salience": 0.0017994555,
				"type": "PERSON"
			},
			{
				"name": "sleeping dragon",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "buses",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "military Humvees",
				"salience": 0.0017208217,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "items",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.0017208217,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "airplane",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.0017208217,
				"type": "EVENT"
			},
			{
				"name": "earth",
				"salience": 0.0017208217,
				"type": "LOCATION"
			},
			{
				"name": "human beings",
				"salience": 0.0017208217,
				"type": "PERSON"
			},
			{
				"name": "act",
				"salience": 0.0017208217,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0015592972,
				"type": "EVENT"
			},
			{
				"name": "law enforcement",
				"salience": 0.0015249152,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.0015249152,
				"type": "ORGANIZATION"
			},
			{
				"name": "Law enforcement",
				"salience": 0.0015249152,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.0015249152,
				"type": "ORGANIZATION"
			},
			{
				"name": "camp",
				"salience": 0.001482199,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.001482199,
				"type": "EVENT"
			},
			{
				"name": "Play Protesters",
				"salience": 0.0014819257,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0014599751,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pipeline",
				"salience": 0.0014599751,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.001444862,
				"type": "OTHER"
			},
			{
				"name": "sheriff",
				"salience": 0.0014371189,
				"type": "PERSON"
			},
			{
				"name": "sheriff",
				"salience": 0.0014371189,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0014204443,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.0013604836,
				"type": "ORGANIZATION"
			},
			{
				"name": "camp",
				"salience": 0.0013563298,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.0013389956,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.0013281581,
				"type": "PERSON"
			},
			{
				"name": "Authorities",
				"salience": 0.0013114255,
				"type": "PERSON"
			},
			{
				"name": "line north",
				"salience": 0.0012918059,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.0012890229,
				"type": "EVENT"
			},
			{
				"name": "protesters",
				"salience": 0.0012890229,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0012890229,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0012835029,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0012835029,
				"type": "PERSON"
			},
			{
				"name": "Demonstrators",
				"salience": 0.0012835029,
				"type": "PERSON"
			},
			{
				"name": "Officers",
				"salience": 0.0012835029,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0012835029,
				"type": "PERSON"
			},
			{
				"name": "pipeline",
				"salience": 0.0012699278,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n353",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morton_County,_North_Dakota"
				},
				"name": "Morton County",
				"salience": 0.0012313882,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0011922936,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.001184537,
				"type": "ORGANIZATION"
			},
			{
				"name": "fire",
				"salience": 0.0011333312,
				"type": "OTHER"
			},
			{
				"name": "sheriff",
				"salience": 0.0010940522,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.00109314,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.00109314,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010910298,
				"type": "LOCATION"
			},
			{
				"name": "rocks",
				"salience": 0.001086251,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.0010736453,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.0010706292,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.0010692282,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.0010692282,
				"type": "ORGANIZATION"
			},
			{
				"name": "county road",
				"salience": 0.0010463679,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.00103927,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.00103927,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.00103927,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.0010236839,
				"type": "WORK_OF_ART"
			},
			{
				"name": "oil pipeline",
				"salience": 0.0010236839,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0010236839,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pipe",
				"salience": 0.0010236839,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0010004777,
				"type": "EVENT"
			},
			{
				"name": "pipeline",
				"salience": 0.0009854732,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0009854732,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pipeline",
				"salience": 0.0009854732,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.0009850647,
				"type": "OTHER"
			},
			{
				"name": "sheriff",
				"salience": 0.0009700416,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.000957045,
				"type": "LOCATION"
			},
			{
				"name": "shots",
				"salience": 0.000957045,
				"type": "OTHER"
			},
			{
				"name": "pepper spray",
				"salience": 0.000957045,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.00095671794,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.000944059,
				"type": "OTHER"
			},
			{
				"name": "Play Authorities",
				"salience": 0.0009195053,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0008999237,
				"type": "PERSON"
			},
			{
				"name": "demonstrators",
				"salience": 0.0008999237,
				"type": "PERSON"
			},
			{
				"name": "demonstrations",
				"salience": 0.0008999237,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.00089257053,
				"type": "EVENT"
			},
			{
				"name": "highway",
				"salience": 0.0008795356,
				"type": "LOCATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.0008728832,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.0008728832,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.0008728832,
				"type": "ORGANIZATION"
			},
			{
				"name": "Law enforcement",
				"salience": 0.0008728832,
				"type": "ORGANIZATION"
			},
			{
				"name": "demonstrators",
				"salience": 0.00086633035,
				"type": "PERSON"
			},
			{
				"name": "law enforcement officers",
				"salience": 0.00086633035,
				"type": "PERSON"
			},
			{
				"name": "law enforcement line",
				"salience": 0.00084927166,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00084927166,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.00084927166,
				"type": "OTHER"
			},
			{
				"name": "revolver",
				"salience": 0.00084927166,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.00084842386,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.00084842386,
				"type": "EVENT"
			},
			{
				"name": "highway",
				"salience": 0.0008467031,
				"type": "LOCATION"
			},
			{
				"name": "fires",
				"salience": 0.000835961,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.000835961,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.0008356988,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pipeline",
				"salience": 0.0008356988,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0008356988,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sheriff",
				"salience": 0.0008226116,
				"type": "PERSON"
			},
			{
				"name": "sheriff",
				"salience": 0.0008226116,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0008166016,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0008166016,
				"type": "EVENT"
			},
			{
				"name": "Protesters",
				"salience": 0.0008166016,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0008166016,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0008166016,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0008166016,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.0008099905,
				"type": "PERSON"
			},
			{
				"name": "fire",
				"salience": 0.00080475444,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00080475444,
				"type": "OTHER"
			},
			{
				"name": "emergency services official",
				"salience": 0.0007827502,
				"type": "PERSON"
			},
			{
				"name": "North Dakota State Emergency Services",
				"salience": 0.00078140676,
				"type": "ORGANIZATION"
			},
			{
				"name": "tires",
				"salience": 0.00077712984,
				"type": "OTHER"
			},
			{
				"name": "trucks",
				"salience": 0.0007452482,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "line north",
				"salience": 0.0007394107,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0007346569,
				"type": "PERSON"
			},
			{
				"name": "activists",
				"salience": 0.0007336309,
				"type": "PERSON"
			},
			{
				"name": "tribes",
				"salience": 0.0007331667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/010f4nxx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cannonball_(Duane_Eddy_song)"
				},
				"name": "Cannonball",
				"salience": 0.00072311825,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.00071040407,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.00070838555,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.00070838555,
				"type": "OTHER"
			},
			{
				"name": "debris",
				"salience": 0.00070838555,
				"type": "OTHER"
			},
			{
				"name": "bean bag rounds",
				"salience": 0.00070838555,
				"type": "EVENT"
			},
			{
				"name": "custody",
				"salience": 0.00070838555,
				"type": "OTHER"
			},
			{
				"name": "county road",
				"salience": 0.0007062429,
				"type": "LOCATION"
			},
			{
				"name": "drinking water",
				"salience": 0.0007062429,
				"type": "OTHER"
			},
			{
				"name": "DAPL",
				"salience": 0.0006944446,
				"type": "ORGANIZATION"
			},
			{
				"name": "fire",
				"salience": 0.0006911467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Dakota"
				},
				"name": "South Dakota",
				"salience": 0.00069065747,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.00069065747,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0006824366,
				"type": "LOCATION"
			},
			{
				"name": "Molotov cocktails",
				"salience": 0.0006733456,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0006709956,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0006709956,
				"type": "ORGANIZATION"
			},
			{
				"name": "pepper spray",
				"salience": 0.0006709956,
				"type": "OTHER"
			},
			{
				"name": "demonstrators",
				"salience": 0.0006554105,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.0006520461,
				"type": "ORGANIZATION"
			},
			{
				"name": "bridge",
				"salience": 0.0006459452,
				"type": "LOCATION"
			},
			{
				"name": "pepper spray",
				"salience": 0.0006459452,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0006459452,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.0006459452,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.00063525175,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.000633773,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.000633773,
				"type": "LOCATION"
			},
			{
				"name": "pipeline",
				"salience": 0.00062426634,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00062426634,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.00062426634,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.00062426634,
				"type": "WORK_OF_ART"
			},
			{
				"name": "standoff",
				"salience": 0.0006138909,
				"type": "EVENT"
			},
			{
				"name": "roadblocks",
				"salience": 0.00060653785,
				"type": "OTHER"
			},
			{
				"name": "county road",
				"salience": 0.00059889373,
				"type": "LOCATION"
			},
			{
				"name": "activists",
				"salience": 0.00059889373,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.00059889373,
				"type": "OTHER"
			},
			{
				"name": "riot gear",
				"salience": 0.00059542473,
				"type": "OTHER"
			},
			{
				"name": "revolver",
				"salience": 0.00059542473,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.0005947206,
				"type": "EVENT"
			},
			{
				"name": "arrests",
				"salience": 0.0005935547,
				"type": "EVENT"
			},
			{
				"name": "counties",
				"salience": 0.0005869234,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.00057319476,
				"type": "PERSON"
			},
			{
				"name": "oil",
				"salience": 0.00057319476,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.00057319476,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.00057319476,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/02yfc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Bismarck_Tribune"
				},
				"name": "The Bismarck Tribune",
				"salience": 0.0005720393,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mekasi Horinek",
				"salience": 0.00056289614,
				"type": "PERSON"
			},
			{
				"name": "demonstrators",
				"salience": 0.00054878095,
				"type": "PERSON"
			},
			{
				"name": "Law enforcement officials",
				"salience": 0.00054878095,
				"type": "PERSON"
			},
			{
				"name": "shots",
				"salience": 0.0005477587,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0005477587,
				"type": "LOCATION"
			},
			{
				"name": "state highways",
				"salience": 0.00053634605,
				"type": "OTHER"
			},
			{
				"name": "highway",
				"salience": 0.00053634605,
				"type": "LOCATION"
			},
			{
				"name": "Highway",
				"salience": 0.00053634605,
				"type": "LOCATION"
			},
			{
				"name": "project",
				"salience": 0.0005295247,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.000518578,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0005097696,
				"type": "LOCATION"
			},
			{
				"name": "Dakota Access",
				"salience": 0.0005039814,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "peak",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "military Humvees",
				"salience": 0.0004966388,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "buses",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "airplane",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "sleeping dragon",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "items",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.0004966388,
				"type": "PERSON"
			},
			{
				"name": "bean bags",
				"salience": 0.0004966388,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ykz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Missouri_River"
				},
				"name": "Missouri",
				"salience": 0.00049307855,
				"type": "LOCATION"
			},
			{
				"name": "Xochitl Hinojosa",
				"salience": 0.000489594,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.00048606397,
				"type": "PERSON"
			},
			{
				"name": "law enforcement line",
				"salience": 0.00048606397,
				"type": "OTHER"
			},
			{
				"name": "revolver",
				"salience": 0.00048606397,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.00048606397,
				"type": "OTHER"
			},
			{
				"name": "encampment",
				"salience": 0.0004841988,
				"type": "LOCATION"
			},
			{
				"name": "flames",
				"salience": 0.00047809613,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.00047809613,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tone",
				"salience": 0.00047809613,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.00047486616,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.00047486616,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.00047486616,
				"type": "ORGANIZATION"
			},
			{
				"name": "camp",
				"salience": 0.00046744884,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0004615572,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0004615572,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.0004546332,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.0004546332,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.0004546332,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0004528585,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0004528585,
				"type": "OTHER"
			},
			{
				"name": "prayer",
				"salience": 0.00044903063,
				"type": "OTHER"
			},
			{
				"name": "county roads",
				"salience": 0.00044735955,
				"type": "LOCATION"
			},
			{
				"name": "roadblocks",
				"salience": 0.00044735955,
				"type": "OTHER"
			},
			{
				"name": "roadblocks",
				"salience": 0.00044735955,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.00044424206,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.00044424206,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.00044424206,
				"type": "PERSON"
			},
			{
				"name": "pipeline",
				"salience": 0.00043765848,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.000429032,
				"type": "OTHER"
			},
			{
				"name": "sheriff department",
				"salience": 0.00041672838,
				"type": "ORGANIZATION"
			},
			{
				"name": "workers",
				"salience": 0.00041129466,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00040916022,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00040916022,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.00040916022,
				"type": "PERSON"
			},
			{
				"name": "pepper spray",
				"salience": 0.00040916022,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00040821842,
				"type": "ORGANIZATION"
			},
			{
				"name": "fight",
				"salience": 0.0004054182,
				"type": "EVENT"
			},
			{
				"name": "custody",
				"salience": 0.0004054182,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.0004054182,
				"type": "LOCATION"
			},
			{
				"name": "human beings",
				"salience": 0.0004054182,
				"type": "PERSON"
			},
			{
				"name": "act",
				"salience": 0.0004054182,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0004054182,
				"type": "OTHER"
			},
			{
				"name": "demonstrators",
				"salience": 0.0003996555,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0003954266,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Molotov cocktails",
				"salience": 0.00038536146,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.00038419804,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.00037598205,
				"type": "LOCATION"
			},
			{
				"name": "arrests",
				"salience": 0.0003759709,
				"type": "EVENT"
			},
			{
				"name": "demonstrators",
				"salience": 0.00037509558,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "U.S. Department of Justice",
				"salience": 0.00037381647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Ill",
				"salience": 0.00037301471,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03cwns",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patoka_River"
				},
				"name": "Patoka",
				"salience": 0.00037301471,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.00037301471,
				"type": "LOCATION"
			},
			{
				"name": "Morton County Sheriff's Department Facebook",
				"salience": 0.00037301471,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Native Americans",
				"salience": 0.00037301471,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0yrfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cannon_Ball,_North_Dakota"
				},
				"name": "Cannon Ball",
				"salience": 0.00037301471,
				"type": "LOCATION"
			},
			{
				"name": "authorities",
				"salience": 0.0003689493,
				"type": "PERSON"
			},
			{
				"name": "path",
				"salience": 0.0003630731,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0003630731,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.0003447663,
				"type": "EVENT"
			},
			{
				"name": "pipeline",
				"salience": 0.00033959403,
				"type": "OTHER"
			},
			{
				"name": "pipeline",
				"salience": 0.00033959403,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00033959403,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tribes",
				"salience": 0.00033821215,
				"type": "PERSON"
			},
			{
				"name": "sheriff",
				"salience": 0.00033427463,
				"type": "PERSON"
			},
			{
				"name": "Highway 1806",
				"salience": 0.00033008278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04tzzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KFYR_(AM)"
				},
				"name": "KFYR",
				"salience": 0.0003219103,
				"type": "ORGANIZATION"
			},
			{
				"name": "Authorities",
				"salience": 0.00030502336,
				"type": "PERSON"
			},
			{
				"name": "Officers",
				"salience": 0.0002985256,
				"type": "PERSON"
			},
			{
				"name": "law enforcement officers",
				"salience": 0.0002985256,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0002985256,
				"type": "PERSON"
			},
			{
				"name": "Demonstrators",
				"salience": 0.0002985256,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0002985256,
				"type": "PERSON"
			},
			{
				"name": "highway",
				"salience": 0.00029176043,
				"type": "LOCATION"
			},
			{
				"name": "Mike McCleary",
				"salience": 0.00028218207,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.00028209382,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00027730173,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00027730173,
				"type": "OTHER"
			},
			{
				"name": "tires",
				"salience": 0.00026778042,
				"type": "OTHER"
			},
			{
				"name": "encampment",
				"salience": 0.00026675276,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.00026475746,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00026440504,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00026440504,
				"type": "OTHER"
			},
			{
				"name": "Chairman",
				"salience": 0.00026440504,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.00026221346,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.00026221346,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00026221346,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.00026221346,
				"type": "OTHER"
			},
			{
				"name": "tribes",
				"salience": 0.0002526281,
				"type": "PERSON"
			},
			{
				"name": "rocks",
				"salience": 0.0002526281,
				"type": "OTHER"
			},
			{
				"name": "state agencies",
				"salience": 0.00024425786,
				"type": "ORGANIZATION"
			},
			{
				"name": "ground",
				"salience": 0.00024425786,
				"type": "LOCATION"
			},
			{
				"name": "infrastructure projects",
				"salience": 0.00024425786,
				"type": "OTHER"
			},
			{
				"name": "prayer",
				"salience": 0.00024425786,
				"type": "OTHER"
			},
			{
				"name": "arrests",
				"salience": 0.00024425786,
				"type": "EVENT"
			},
			{
				"name": "county road",
				"salience": 0.00024334874,
				"type": "LOCATION"
			},
			{
				"name": "drinking water",
				"salience": 0.00024334874,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.00024101042,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.00022908628,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.00022256761,
				"type": "LOCATION"
			},
			{
				"name": "pepper spray",
				"salience": 0.00022256761,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.00021134832,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.00019749587,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.00019749587,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.00019749587,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "everyone",
				"salience": 0.00019095215,
				"type": "PERSON"
			},
			{
				"name": "abuses",
				"salience": 0.00019095215,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.00019095215,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.00019095215,
				"type": "WORK_OF_ART"
			},
			{
				"name": "situation",
				"salience": 0.00019095215,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.00019095215,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.00019095215,
				"type": "LOCATION"
			},
			{
				"name": "beginning",
				"salience": 0.00019095215,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.00019095215,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00019095215,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.00019095215,
				"type": "OTHER"
			},
			{
				"name": "contractors",
				"salience": 0.00019095215,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.00019095215,
				"type": "ORGANIZATION"
			},
			{
				"name": "pipeline company",
				"salience": 0.00019095215,
				"type": "ORGANIZATION"
			},
			{
				"name": "project",
				"salience": 0.00018244659,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.00016472416,
				"type": "OTHER"
			},
			{
				"name": "bean bag rounds",
				"salience": 0.00016472416,
				"type": "EVENT"
			},
			{
				"name": "objects",
				"salience": 0.00016472416,
				"type": "OTHER"
			},
			{
				"name": "flames",
				"salience": 0.00016472416,
				"type": "OTHER"
			},
			{
				"name": "debris",
				"salience": 0.00016472416,
				"type": "OTHER"
			},
			{
				"name": "tone",
				"salience": 0.00016472416,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.00016472416,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tribe",
				"salience": 0.00016205298,
				"type": "PERSON"
			},
			{
				"name": "Cannonball Ranch",
				"salience": 0.00016136508,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04b7m_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fort_Rice"
				},
				"name": "Fort Rice",
				"salience": 0.00016136508,
				"type": "ORGANIZATION"
			},
			{
				"name": "Opponents",
				"salience": 0.00012646623,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00011750954,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.000080589685,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/2016-10-27t22-37-07-466z-1280x720.nbcnews-ux-1240-700.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T19:18:15.734+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 32.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Dakota Access Pipeline: More Than 100 Arrested as Protesters Ousted From Camp 11/01/2016 \nNBC NEWS \nAuthorities used pepper spray and fired bean bags at activists demonstrating against a controversial North Dakota oil pipeline as the standoff there reached a new peak Thursday, according to officials. \nArmed soldiers and police in riot gear removed the demonstrators using trucks, military Humvees, and buses Thursday afternoon, according to The Associated Press. Two helicopters and an airplane scanned the operation from the air. \nAt least 141 protesters were arrested as of midnight Thursday (1 a.m. ET) after law enforcement slowly closed in and tensions escalated, the Morton County Sheriff’s Department said in a statement. \nSeven protesters used “sleeping dragon” devices, which typically involve PVC or other pipe, to attach themselves to items, and fires were set on a highway and improvised fire bombs were thrown at law enforcement, the Morton County Sheriff’s Department said in a statement. \nOne woman allegedly fired three shots from a revolver at police, an emergency services official said. No one was hit. \nThe chairman of the Standing Rock Sioux Tribe criticized law enforcement’s “militarized” response to the camp and called for demonstrations to remain peaceful, but stressed that activists would not give up their cause. \n“Militarized law enforcement agencies moved in on water protectors with tanks and riot gear today. We continue to pray for peace,” Dave Archambault II said in a statement Thursday evening. \n“We won’t step down from this fight,” he added. “As peoples of this earth, we all need water. This is about our water, our rights, and our dignity as human beings.” \nArchambault also called on activists to “remain in peace and prayer.”“Any act of violence hurts our case and is not welcome here,” he said. \nLaw enforcement were holding a line north of the Backwater Bridge early Friday morning, the sheriff’s department. \nA woman who was being arrested pulled a .38 caliber revolver and fired three shots at law enforcement, “narrowly missing a sheriff’s deputy,” North Dakota State Emergency Services Spokeswoman Cecily Fong told NBC News. The woman was taken into custody and no shots were fired by law enforcement, she said. \nThe protesters were ousted from the camp that authorities said was on private property in the path of the pipeline late Thursday afternoon, Morton County Sheriff Kyle Kirchmeier told the AP. \nThe sheriff said that while the camp was secure, officers were still dealing with protesters in the surrounding area, according to the AP. Kirchmeier added that authorities would maintain a presence in the area for the time being to keep protesters off the land. Fong confirmed to NBC News that the camp was cleared. \nProtesters allegedly started two fires on the Backwater Bridge protest site and threw Molotov cocktails at law enforcement Thursday night, Fong said. \nAbout 250 protesters had gathered at the camp and another 80 demonstrators with a dozen horses were at the site of a county road, according to a statement from the Morton County Sheriff’s Department. \nProtesters on horseback galloped toward the law enforcement line before wheeling around and some had begun throwing objects at the officers, Fong said. Demonstrators also allegedly set four DAPL construction vehicles ablaze, Fong said Thursday evening. \n“They’ve definitely escalated, they’re throwing rocks and debris,” she said. A handful of officers suffered minor injuries, she said. \nOfficers fired bean bag rounds and used pepper spray on protesters, Fong said. \nAuthorities also used a long-range acoustic device with a high-pitched tone to disperse the protesters, who set tires on fire on the highway Thursday afternoon, according to a post on the Morton County Sheriff’s Department Facebook page . Demonstrators stand next to burning tires as armed soldiers and law enforcement officers assemble on Oct. 27, 2016, to force Dakota Access pipeline protesters off private land where they had camped to block construction. The pipeline is to carry oil from western North Dakota through South Dakota and Iowa to an existing pipeline in Patoka, Ill. Mike McCleary / The Bismarck Tribune via AP \nThe department said they repeatedly told the demonstrators they were “free to go,” asking them to move to a separate camp further south and let authorities put out the flames. \nThe protesters also set an area on fire near a bridge on a county road, according to a statement from the sheriff’s department. \nThe protesters, comprised of a group that includes Native Americans and environmental activists, had been camped on private property since Sunday near the $3.8 billion Dakota Access Pipeline, near the town of Cannon Ball. \nThe 1,172-mile pipeline would run within a half-mile of the Standing Rock Sioux reservation. Opponents of the project say the pipeline could adversely impact drinking water and would disturb sacred burial sites. \nHundreds of protesters from Standing Rock and other tribes have set up camp for months in protest a few miles away from where Thursday’s confrontation occurred, close to where the Missouri and Cannonball rivers meet. \nThursday’s incident came less than a week after more than 80 people were arrested and authorities used pepper spray on demonstrators. The arrests came during a five-hour conflict with police and around 300 protesters, some of whom stubbornly parked cars on the highway near the camp to block authorities from reaching them, according to the AP. They also set a small fire at one of two blockades they set up on the highway. \nThe majority of the protesters were retreating from the area of confrontation on the highway outside the camp, but had not fully left the area of private land, according to the AP. About 200 protesters remained in the area, listening to tribal elders speak and praying as authorities continued to approach. Play \nAuthorities used pepper spray and fired bean bags at activists demonstrating against a controversial North Dakota oil pipeline as the standoff there reached a new peak Thursday, according to officials. \nArmed soldiers and police in riot gear removed the demonstrators using trucks, military Humvees, and buses Thursday afternoon, according to The Associated Press. Two helicopters and an airplane scanned the operation from the air. \nAt least 141 protesters were arrested as of midnight Thursday (1 a.m. ET) after law enforcement slowly closed in and tensions escalated, the Morton County Sheriff’s Department said in a statement. \nSeven protesters used “sleeping dragon” devices, which typically involve PVC or other pipe, to attach themselves to items, and fires were set on a highway and improvised fire bombs were thrown at law enforcement, the Morton County Sheriff’s Department said in a statement. \nOne woman allegedly fired three shots from a revolver at police, an emergency services official said. No one was hit. \nThe chairman of the Standing Rock Sioux Tribe criticized law enforcement’s “militarized” response to the camp and called for demonstrations to remain peaceful, but stressed that activists would not give up their cause. \n“Militarized law enforcement agencies moved in on water protectors with tanks and riot gear today. We continue to pray for peace,” Dave Archambault II said in a statement Thursday evening. \n“We won’t step down from this fight,” he added. “As peoples of this earth, we all need water. This is about our water, our rights, and our dignity as human beings.” \nArchambault also called on activists to “remain in peace and prayer.”“Any act of violence hurts our case and is not welcome here,” he said. \nLaw enforcement were holding a line north of the Backwater Bridge early Friday morning, the sheriff’s department. \nA woman who was being arrested pulled a .38 caliber revolver and fired three shots at law enforcement, “narrowly missing a sheriff’s deputy,” North Dakota State Emergency Services Spokeswoman Cecily Fong told NBC News. The woman was taken into custody and no shots were fired by law enforcement, she said. \nThe protesters were ousted from the camp that authorities said was on private property in the path of the pipeline late Thursday afternoon, Morton County Sheriff Kyle Kirchmeier told the AP. \nThe sheriff said that while the camp was secure, officers were still dealing with protesters in the surrounding area, according to the AP. Kirchmeier added that authorities would maintain a presence in the area for the time being to keep protesters off the land. Fong confirmed to NBC News that the camp was cleared. Play \nProtesters allegedly started two fires on the Backwater Bridge protest site and threw Molotov cocktails at law enforcement Thursday night, Fong said. \nAbout 250 protesters had gathered at the camp and another 80 demonstrators with a dozen horses were at the site of a county road, according to a statement from the Morton County Sheriff’s Department. \nProtesters on horseback galloped toward the law enforcement line before wheeling around and some had begun throwing objects at the officers, Fong said. Demonstrators also allegedly set four DAPL construction vehicles ablaze, Fong said Thursday evening. \n“They’ve definitely escalated, they’re throwing rocks and debris,” she said. A handful of officers suffered minor injuries, she said. \nOfficers fired bean bag rounds and used pepper spray on protesters, Fong said. \nAuthorities also used a long-range acoustic device with a high-pitched tone to disperse the protesters, who set tires on fire on the highway Thursday afternoon, according to a post on the Morton County Sheriff’s Department Facebook page . Demonstrators stand next to burning tires as armed soldiers and law enforcement officers assemble on Oct. 27, 2016, to force Dakota Access pipeline protesters off private land where they had camped to block construction. The pipeline is to carry oil from western North Dakota through South Dakota and Iowa to an existing pipeline in Patoka, Ill. Mike McCleary / The Bismarck Tribune via AP \nThe department said they repeatedly told the demonstrators they were “free to go,” asking them to move to a separate camp further south and let authorities put out the flames. \nThe protesters also set an area on fire near a bridge on a county road, according to a statement from the sheriff’s department. \nThe protesters, comprised of a group that includes Native Americans and environmental activists, had been camped on private property since Sunday near the $3.8 billion Dakota Access Pipeline, near the town of Cannon Ball. \nThe 1,172-mile pipeline would run within a half-mile of the Standing Rock Sioux reservation. Opponents of the project say the pipeline could adversely impact drinking water and would disturb sacred burial sites. \nHundreds of protesters from Standing Rock and other tribes have set up camp for months in protest a few miles away from where Thursday’s confrontation occurred, close to where the Missouri and Cannonball rivers meet. \nThursday’s incident came less than a week after more than 80 people were arrested and authorities used pepper spray on demonstrators. The arrests came during a five-hour conflict with police and around 300 protesters, some of whom stubbornly parked cars on the highway near the camp to block authorities from reaching them, according to the AP. They also set a small fire at one of two blockades they set up on the highway. \nThe majority of the protesters were retreating from the area of confrontation on the highway outside the camp, but had not fully left the area of private land, according to the AP. About 200 protesters remained in the area, listening to tribal elders speak and praying as authorities continued to approach. Play \nLaw enforcement officials began taking steps to remove roadblocks and protesters of the Dakota Access Pipeline near Highway 1806 at around 11:15 a.m. local time (12:15 p.m. ET), Kirchmeier said in a statement. \n“Protesters’ escalated unlawful behavior this weekend by setting up illegal roadblocks, trespassing onto private property and establishing an encampment, has forced law enforcement to respond at this time,” he said in the statement. \n“I can’t stress it enough, this is a public safety issue,” the sheriff said. “We cannot have protesters blocking county roads, blocking state highways, or trespassing on private property.” \nThe protesters had created a camp in the pipeline’s path on private property known as the Cannonball Ranch on the side of the highway and set up the roadblocks along on Sunday, according to the statement. \nHighway 1806 remained closed Thursday between Fort Rice and Cannonball, according to the sheriff department’s statement. Various counties, cities, state agencies and out-of-state law enforcement were helping the Morton County Sheriff’s Department, the statement said. \nDemocratic presidential nominee Hillary Clinton’s campaign weighed in on the protests Thursday evening. \n“From the beginning of this campaign, Secretary Clinton has been clear that she thinks all voices should be heard and all views considered in federal infrastructure projects,” Spokeswoman Xochitl Hinojosa said in a statement. \n“Now, all of the parties involved — including the federal government, the pipeline company and contractors, the state of North Dakota, and the tribes — need to find a path forward that serves the broadest public interest,” Hinojosa said. “As that happens, it’s important that on the ground in North Dakota, everyone respects demonstrators’ rights to protest peacefully, and workers’ rights to do their jobs safely.” \nProtest camp coordinator Mekasi Horinek told NBC affiliate KFYR on Wednesday that the protesters had no plans of leaving their encampment. \n“We don’t have any plans on retreating. If they’re going to come in here and they’re going to arrest one of us, they’re going to arrest every one of us,” Horinek said. “We’re going to stand in unity, we’re going to stand in prayer, we’re going to stand in peace.” \nStanding Rock Sioux Tribe chairman Dave Archambault II told NBC News on Sunday the tribe had asked the U.S. Department of Justice to intervene in the escalating situation with law enforcement. \n“The DOJ should be enlisted and expected to investigate the overwhelming reports and videos demonstrating clear strong-arm tactics, abuses and unlawful arrests by law enforcement,” Chairman Dave Archambault II said.",
		"thread_title": "Dakota Access Pipeline: More Than 100 Arrested as Protesters Ousted From Camp",
		"title": "Dakota Access Pipeline: More Than 100 Arrested as Protesters Ousted From Camp",
		"type": "bs",
		"uuid": "ed98524ec8a84d4e889f1f211c24809446b69b2e"
	},
	"-KhIhBDrEUgEriouHYxO": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T20:57:41.748+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.44735345,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.20756787,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03h1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Holy_See"
				},
				"name": "The Vatican",
				"salience": 0.07405257,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01914",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beijing"
				},
				"name": "Beijing",
				"salience": 0.03563031,
				"type": "LOCATION"
			},
			{
				"name": "agreement",
				"salience": 0.019113952,
				"type": "OTHER"
			},
			{
				"name": "bishops",
				"salience": 0.01639958,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ngt2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope_Francis"
				},
				"name": "Francis",
				"salience": 0.014311954,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Catholic Church",
				"salience": 0.012108847,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01wb7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Church_(building)"
				},
				"name": "Church",
				"salience": 0.011425004,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.008851509,
				"type": "OTHER"
			},
			{
				"name": "churches",
				"salience": 0.0057965913,
				"type": "LOCATION"
			},
			{
				"name": "Wu Weiqing",
				"salience": 0.0055721337,
				"type": "PERSON"
			},
			{
				"name": "bishops",
				"salience": 0.0045367815,
				"type": "PERSON"
			},
			{
				"name": "bishops",
				"salience": 0.0045367815,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.004247456,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.003992463,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0038053128,
				"type": "OTHER"
			},
			{
				"name": "pope",
				"salience": 0.0036847827,
				"type": "PERSON"
			},
			{
				"name": "Richard Madsen",
				"salience": 0.003618787,
				"type": "PERSON"
			},
			{
				"name": "authorization",
				"salience": 0.0034048627,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "DAILY CALLER",
				"salience": 0.0032092032,
				"type": "PERSON"
			},
			{
				"name": "Vatican Makes Unprecedented Agreement With Chinese Gov",
				"salience": 0.0032092032,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.0029253347,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.00274599,
				"type": "OTHER"
			},
			{
				"name": "dispute",
				"salience": 0.0026635688,
				"type": "EVENT"
			},
			{
				"name": "heart",
				"salience": 0.0026635688,
				"type": "OTHER"
			},
			{
				"name": "input",
				"salience": 0.0026635688,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0020722342,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09wpt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope_Benedict_XVI"
				},
				"name": "Benedict XVI",
				"salience": 0.0018490277,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02189",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Communist_Party_of_China"
				},
				"name": "Communist Party of China",
				"salience": 0.0016515291,
				"type": "ORGANIZATION"
			},
			{
				"name": "deal",
				"salience": 0.0016328336,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0016206368,
				"type": "OTHER"
			},
			{
				"name": "churches",
				"salience": 0.0016157406,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02kkqv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinese_Patriotic_Catholic_Association"
				},
				"name": "Chinese Patriotic Catholic Association",
				"salience": 0.0015113811,
				"type": "ORGANIZATION"
			},
			{
				"name": "restoration",
				"salience": 0.0014140897,
				"type": "EVENT"
			},
			{
				"name": "appointments",
				"salience": 0.0014035247,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0014035247,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0013992835,
				"type": "ORGANIZATION"
			},
			{
				"name": "churches",
				"salience": 0.0013703856,
				"type": "LOCATION"
			},
			{
				"name": "agreement",
				"salience": 0.0013124659,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0012673389,
				"type": "OTHER"
			},
			{
				"name": "bishops",
				"salience": 0.0012635088,
				"type": "PERSON"
			},
			{
				"name": "bishop",
				"salience": 0.0012635088,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.0012553306,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0011993219,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.001186762,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.001186762,
				"type": "ORGANIZATION"
			},
			{
				"name": "interactions",
				"salience": 0.0011365948,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0010975087,
				"type": "OTHER"
			},
			{
				"name": "missionaries",
				"salience": 0.0010975087,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0010975087,
				"type": "OTHER"
			},
			{
				"name": "envoy",
				"salience": 0.0010975087,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0010975087,
				"type": "OTHER"
			},
			{
				"name": "intervention",
				"salience": 0.0010941913,
				"type": "EVENT"
			},
			{
				"name": "bishops",
				"salience": 0.001071588,
				"type": "PERSON"
			},
			{
				"name": "churches",
				"salience": 0.0010238973,
				"type": "LOCATION"
			},
			{
				"name": "shift",
				"salience": 0.0009961283,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0009842691,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0009842691,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0009791906,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0009546791,
				"type": "PERSON"
			},
			{
				"name": "state authorization",
				"salience": 0.0009475435,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0009475435,
				"type": "ORGANIZATION"
			},
			{
				"name": "appointment",
				"salience": 0.0009475435,
				"type": "OTHER"
			},
			{
				"name": "interactions",
				"salience": 0.00092796684,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0009074801,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.0008887305,
				"type": "OTHER"
			},
			{
				"name": "accord",
				"salience": 0.0008887305,
				"type": "OTHER"
			},
			{
				"name": "negotiators",
				"salience": 0.0008887305,
				"type": "PERSON"
			},
			{
				"name": "Negotiations",
				"salience": 0.0008887305,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.0008887305,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0008887305,
				"type": "LOCATION"
			},
			{
				"name": "access",
				"salience": 0.0008887305,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0008887305,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.0008555669,
				"type": "OTHER"
			},
			{
				"name": "affairs",
				"salience": 0.0008555669,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03mcss5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Tong_Hon"
				},
				"name": "John Tong",
				"salience": 0.00085358194,
				"type": "PERSON"
			},
			{
				"name": "appointment",
				"salience": 0.0008035804,
				"type": "OTHER"
			},
			{
				"name": "human rights record",
				"salience": 0.0007695996,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0007695996,
				"type": "WORK_OF_ART"
			},
			{
				"name": "occurrences",
				"salience": 0.0007695996,
				"type": "OTHER"
			},
			{
				"name": "wound",
				"salience": 0.0007695996,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0007695996,
				"type": "OTHER"
			},
			{
				"name": "churches",
				"salience": 0.00075531594,
				"type": "LOCATION"
			},
			{
				"name": "oversight",
				"salience": 0.00074087834,
				"type": "OTHER"
			},
			{
				"name": "rapprochement",
				"salience": 0.00074087834,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.00074087834,
				"type": "OTHER"
			},
			{
				"name": "frustration",
				"salience": 0.00074087834,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00074087834,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00074087834,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0007255686,
				"type": "PERSON"
			},
			{
				"name": "citizen",
				"salience": 0.0007074018,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.0007074018,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0007074018,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.000678941,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vqf6v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antonio_Riberi"
				},
				"name": "Antonio Riberi",
				"salience": 0.00067563297,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.0006350309,
				"type": "PERSON"
			},
			{
				"name": "Haidian Church",
				"salience": 0.0006303007,
				"type": "LOCATION"
			},
			{
				"name": "betrayal",
				"salience": 0.00062829617,
				"type": "OTHER"
			},
			{
				"name": "sociology",
				"salience": 0.00062829617,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.000600323,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.000600323,
				"type": "OTHER"
			},
			{
				"name": "divisions",
				"salience": 0.00058488164,
				"type": "OTHER"
			},
			{
				"name": "accord",
				"salience": 0.0005630504,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.00055715034,
				"type": "LOCATION"
			},
			{
				"name": "church",
				"salience": 0.00055715034,
				"type": "ORGANIZATION"
			},
			{
				"name": "criticisms",
				"salience": 0.0005396126,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00052609947,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.0005049296,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0005049296,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.0004693558,
				"type": "OTHER"
			},
			{
				"name": "scripture",
				"salience": 0.0004693558,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0004655207,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.00043722478,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00043722478,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.00042407407,
				"type": "PERSON"
			},
			{
				"name": "step",
				"salience": 0.00042407407,
				"type": "OTHER"
			},
			{
				"name": "division",
				"salience": 0.00041530834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_San_Diego"
				},
				"name": "University of California at San Diego",
				"salience": 0.00038671796,
				"type": "ORGANIZATION"
			},
			{
				"name": "intentions",
				"salience": 0.00037718637,
				"type": "OTHER"
			},
			{
				"name": "surrender",
				"salience": 0.00034182795,
				"type": "OTHER"
			},
			{
				"name": "uncertainty",
				"salience": 0.00034182795,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.00034182795,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00034182795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/062l3r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roman_Catholic_Diocese_of_Hong_Kong"
				},
				"name": "Bishop of Hong Kong",
				"salience": 0.00033684899,
				"type": "PERSON"
			},
			{
				"name": "state power",
				"salience": 0.00032660514,
				"type": "OTHER"
			},
			{
				"name": "pastors",
				"salience": 0.00029488554,
				"type": "PERSON"
			},
			{
				"name": "shift",
				"salience": 0.00029488554,
				"type": "EVENT"
			},
			{
				"name": "control",
				"salience": 0.00029356816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0245k8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kingship_and_kingdom_of_God"
				},
				"name": "Kingdom of God",
				"salience": 0.00028887333,
				"type": "LOCATION"
			},
			{
				"name": "Christians",
				"salience": 0.00028407428,
				"type": "PERSON"
			},
			{
				"name": "suspicions",
				"salience": 0.00025533835,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.00025533835,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00025533835,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00025533835,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vkzt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_Administration_for_Religious_Affairs"
				},
				"name": "State Administration for Religious Affairs",
				"salience": 0.00021037448,
				"type": "ORGANIZATION"
			},
			{
				"name": "propensity",
				"salience": 0.00020581107,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.00019495761,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06qd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Korea"
				},
				"name": "South Korea",
				"salience": 0.0001571405,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Jesus",
				"salience": 0.00014748328,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0001192835,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/1477867706691.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T20:57:41.748+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Vatican Makes Unprecedented Agreement With Chinese Gov’t 11/01/2016 \nDAILY CALLER \nThe Vatican and Beijing reached an agreement that will elevate the Chinese government above the Church, reports the Wall Street Journal. \nThe question of who has the authority to ordain bishops has been at the heart of a decades-old dispute between China and the Vatican. \nThe new agreement will give China the power to select bishops with only limited input from the Vatican. Furthermore, the Vatican will stop ordaining bishops for underground churches without the authorization of the Chinese government. While the pope will be acknowledged as the head of the Catholic Church in China, the Chinese government will have the last word on all appointments. The state will be able to pick individuals loyal to Beijing. \nThe new deal is likely to help repair ties between the Vatican and the Chinese government, but the full restoration of diplomatic relations is still a long way off. \nThe Chinese government and the Vatican have been estranged since the Communist Party of China (CPC) expelled Vatican envoy Antonio Riberi from the country in 1951, banned missionaries, and began oppressing organized religion. Pope Francis has been actively pursuing rapprochement with China. \nChina insists on appointing its own bishops, claiming that oversight by the Holy See, the judicial body within the Catholic Church, constitutes unnecessary foreign intervention in Chinese affairs. China also opposes attempts by the Vatican to appoint bishops for underground churches without state authorization. \nIn China, all Catholic organizations must register with the Chinese Patriotic Catholic Association. The Vatican expressed frustration over the Chinese government’s 2010 appointment of a bishop without Pope Benedict XVI’s approval. The Vatican called the move, one of a number of such occurrences, a “ painful wound ” to the Church. \nThe new agreement could thaw relations between Beijing and the Vatican, giving the world’s largest religious organization access to the world’s most populous country. For China, normal interactions with the Vatican could improve its international image, potentially reducing criticisms of China’s human rights record. \nNegotiations for the new agreement reportedly began in April. Having reached an accord, negotiators are waiting for papal approval and a formal decision from the Chinese government. Once the agreement passes, it will mark an unprecedented shift in the Vatican’s interactions with foreign governments. The Vatican would officially accept the appointment of eight bishops, three of which were previously excommunicated. \nSome observers expect members of underground churches in China to protest the accord. \n“If the Vatican should be perceived as abandoning them, it could be seen as a betrayal” and “cause serious divisions in the Chinese Catholic Church,” Richard Madsen, a professor of sociology at the University of California at San Diego, told the WSJ. “The government would probably actually like this. Its action over the years show that it would like to see the church weakened, and a deeper division in the church would help accomplish that,” he added, highlighting his suspicions of Beijing’s intentions. \nChina has a documented propensity for dominating and oppressing religion in order to better preserve state power. Christians played an important role in the shift from a dictatorship to a democracy in South Korea, and now there are an estimated 100 million Christians in China. \nHaving failed to eradicate religion, the Chinese government, which is officially atheist, set up state-run churches with pastors loyal to China. These churches advocate morality, not scripture, and that the state is superior to religion. \n“We have to remember first of all we are a citizen of this country. We are a citizen of the Kingdom of God, but that comes second,” Pastor Wu Weiqing of the state-owned Haidian Church in Beijing told BBC. He further stated that if Jesus were alive today, he would probably be a member of the Communist Party. While the deal between the Vatican and Beijing could give the Catholic Church greater access to Chinese Christians, it could also give the Chinese government greater control over the Church and organized religion. \nPope Francis “would not accept any agreement that would harm the integrity of faith of the universal Church,” the Bishop of Hong Kong, Cardinal John Tong argued in July, according to the WSJ. \nThe future of the Catholic Church in China remains shrouded in uncertainty. The new agreement between Beijing and the Vatican could be a positive step forward or a dangerous surrender of religious power to political organizations like the Chinese Patriotic Catholic Association and the State Administration for Religious Affairs.",
		"thread_title": "Vatican Makes Unprecedented Agreement With Chinese Gov’t",
		"title": "Vatican Makes Unprecedented Agreement With Chinese Gov’t",
		"type": "bs",
		"uuid": "763166c17a5e2790dad65c8342043b1c1d0e6f77"
	},
	"-KhIhBUkcSsYP7NJ34Ig": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T20:57:41.886+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.2890125,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/056vv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montenegro"
				},
				"name": "Montenegro",
				"salience": 0.12483644,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.09369268,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.055126302,
				"type": "LOCATION"
			},
			{
				"name": "exercises",
				"salience": 0.03936474,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.028842513,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.027724953,
				"type": "PERSON"
			},
			{
				"name": "partner",
				"salience": 0.027724953,
				"type": "PERSON"
			},
			{
				"name": "drills",
				"salience": 0.024645615,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.022791972,
				"type": "LOCATION"
			},
			{
				"name": "signal",
				"salience": 0.02169369,
				"type": "OTHER"
			},
			{
				"name": "war games",
				"salience": 0.020512989,
				"type": "EVENT"
			},
			{
				"name": "each other",
				"salience": 0.01786843,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0110390885,
				"type": "LOCATION"
			},
			{
				"name": "opportunity",
				"salience": 0.010418966,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.009167433,
				"type": "LOCATION"
			},
			{
				"name": "Aleksandr Grushko",
				"salience": 0.0063282605,
				"type": "PERSON"
			},
			{
				"name": "drills",
				"salience": 0.0060161166,
				"type": "EVENT"
			},
			{
				"name": "weaknesses",
				"salience": 0.0057072276,
				"type": "OTHER"
			},
			{
				"name": "Dusko Markovic",
				"salience": 0.005542374,
				"type": "PERSON"
			},
			{
				"name": "Slavic Brotherhood 2016",
				"salience": 0.0053738947,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0046757916,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.004454406,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.0043682903,
				"type": "LOCATION"
			},
			{
				"name": "responses",
				"salience": 0.0043682903,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.003984003,
				"type": "PERSON"
			},
			{
				"name": "paratroopers",
				"salience": 0.0037835895,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.0037835895,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.0037835895,
				"type": "OTHER"
			},
			{
				"name": "chemical spills",
				"salience": 0.0037835895,
				"type": "OTHER"
			},
			{
				"name": "disaster scenarios",
				"salience": 0.0037835895,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01829z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Airborne_Troops"
				},
				"name": "Russian Airborne Troops",
				"salience": 0.0036336626,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0036002828,
				"type": "OTHER"
			},
			{
				"name": "capacity",
				"salience": 0.003183179,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.00306665,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0030645106,
				"type": "OTHER"
			},
			{
				"name": "disasters",
				"salience": 0.0030645106,
				"type": "EVENT"
			},
			{
				"name": "ability",
				"salience": 0.0030645106,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.0030645106,
				"type": "OTHER"
			},
			{
				"name": "capabilities",
				"salience": 0.0029502588,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0029399763,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0026906822,
				"type": "LOCATION"
			},
			{
				"name": "Serbia 150",
				"salience": 0.0026906822,
				"type": "LOCATION"
			},
			{
				"name": "vehicles",
				"salience": 0.0026659516,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "member",
				"salience": 0.002654056,
				"type": "PERSON"
			},
			{
				"name": "burden",
				"salience": 0.002654056,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.002566537,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0025253936,
				"type": "OTHER"
			},
			{
				"name": "exercises",
				"salience": 0.0025253936,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0025229198,
				"type": "PERSON"
			},
			{
				"name": "combat vehicles",
				"salience": 0.0025023257,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "drills",
				"salience": 0.0022412508,
				"type": "OTHER"
			},
			{
				"name": "drones",
				"salience": 0.0021670754,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0021670754,
				"type": "OTHER"
			},
			{
				"name": "partnership goals",
				"salience": 0.0021670754,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0020706533,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0020706533,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0020706533,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.001896791,
				"type": "LOCATION"
			},
			{
				"name": "activity",
				"salience": 0.0018697137,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0017470742,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.0016191391,
				"type": "OTHER"
			},
			{
				"name": "floods",
				"salience": 0.0015987457,
				"type": "EVENT"
			},
			{
				"name": "signal",
				"salience": 0.0015083475,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.001463,
				"type": "OTHER"
			},
			{
				"name": "partner",
				"salience": 0.0013744958,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0013744958,
				"type": "PERSON"
			},
			{
				"name": "exercise",
				"salience": 0.0013744958,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0013744958,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.0013619324,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0163v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belarus"
				},
				"name": "Belarusian",
				"salience": 0.0013341786,
				"type": "LOCATION"
			},
			{
				"name": "Russian Military Transport Aviation",
				"salience": 0.0013341786,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbian",
				"salience": 0.0013124349,
				"type": "LOCATION"
			},
			{
				"name": "drills",
				"salience": 0.0012197547,
				"type": "OTHER"
			},
			{
				"name": "flank",
				"salience": 0.0011793633,
				"type": "OTHER"
			},
			{
				"name": "framework",
				"salience": 0.0011793633,
				"type": "OTHER"
			},
			{
				"name": "defence",
				"salience": 0.0011793633,
				"type": "OTHER"
			},
			{
				"name": "military security",
				"salience": 0.0011268602,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0011268602,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.0010174544,
				"type": "LOCATION"
			},
			{
				"name": "essence",
				"salience": 0.0008810398,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0008810398,
				"type": "OTHER"
			},
			{
				"name": "Map",
				"salience": 0.0008810398,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/tanks-727622.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T20:57:41.886+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Russia and NATO hold war games next to each other 11/01/2016 \nEXPRESS Around 680 troops from 32 NATO states and partner countries – including Israel and Ukraine – have been carrying out drills in Montenegro since Monday. Joint exercises codenamed Crna Gora 2016 are taking places until November 4 testing Western allies responses to a number of disaster scenarios, including floods and chemical spills. At the same time, a few miles over the border in Serbia 150 paratroopers from Russian Airborne Troops will be conducting drills from November 2 for two weeks. The exercises will see hundreds of heavily-armed and battle-ready Russian and NATO troops placed within a few hundreds miles of each. Montenegro’s Deputy Prime Minister Dusko Markovic said: “This is an opportunity to work with NATO during the four-day exercise to determine our capacity and the capabilities of our response to natural disasters, as well as to recognise our weaknesses and eliminate them in time. “Montenegro has demonstrated the ability as a future member of NATO, not only through organising this exercise, but also bearing its burden. “Montenegro has demonstrated the ability to not only willing to accept but also help realise partnership goals.” Slavic Brotherhood 2016 will involve Russian troops and Serbian and Belarusian forces. Fifty soldiers from the Russian Military Transport Aviation will take part along with combat vehicles, all-terrain vehicles and drones. Aleksandr Grushko, Russia’s NATO Representative, said of the latest drills: “NATO’s efforts have been changing the very essence of the military security in the regions which are adjacent to the Russian border. \nRussian troops on exercise \nAround 680 troops from 32 NATO states and partner countries are taking part \nMap of Serbia and Montenegro, where the exercises are taking part “This seriously worsens the regional security and the security of those countries that participate in these drills and this activity. “I think it’s a double signal. First of all, it’s a signal to western public opinion that all NATO actions on its eastern flank are calibrated and do not transcend the framework of reasonable defence. “Secondly, it’s also an apparent attempt to send a signal to us, so that Russia will not react in what they believe to be an excessive and aggressive manner.”",
		"thread_title": "Russia and NATO hold war games next to each other",
		"title": "Russia and NATO hold war games next to each other",
		"type": "bs",
		"uuid": "1b3d5c80ff9cfc748cde6246309bfe44a0e06672"
	},
	"-KhIhBjuNQWz4fmbZdOL": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T20:57:43.477+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.2556533,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.10658454,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.10389311,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "Federal Bureau of Investigation",
				"salience": 0.10051644,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.06915624,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.036885895,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.01705499,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.01705499,
				"type": "PERSON"
			},
			{
				"name": "links",
				"salience": 0.01705499,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.016559761,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.016087027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.01106726,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.010532246,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.010532246,
				"type": "ORGANIZATION"
			},
			{
				"name": "Paul Manafort",
				"salience": 0.009512347,
				"type": "PERSON"
			},
			{
				"name": "findings",
				"salience": 0.008751841,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.008255387,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.008255387,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.007737773,
				"type": "ORGANIZATION"
			},
			{
				"name": "email channel",
				"salience": 0.0076110605,
				"type": "OTHER"
			},
			{
				"name": "bureau",
				"salience": 0.006249654,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.0060359156,
				"type": "PERSON"
			},
			{
				"name": "real estate mogul",
				"salience": 0.00524074,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0049927547,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0049927547,
				"type": "EVENT"
			},
			{
				"name": "claims",
				"salience": 0.0041660657,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0039836555,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0039836555,
				"type": "WORK_OF_ART"
			},
			{
				"name": "indications",
				"salience": 0.003748006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.003684829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.003684829,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.003608307,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.003608307,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0035027885,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0035027885,
				"type": "PERSON"
			},
			{
				"name": "intelligence officials",
				"salience": 0.0035027885,
				"type": "PERSON"
			},
			{
				"name": "law enforcement officials",
				"salience": 0.0033722129,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0033722129,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0032227861,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0032227861,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0032109073,
				"type": "ORGANIZATION"
			},
			{
				"name": "series",
				"salience": 0.003060581,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.0029336577,
				"type": "EVENT"
			},
			{
				"name": "intervention",
				"salience": 0.002813442,
				"type": "EVENT"
			},
			{
				"name": "great leader",
				"salience": 0.0027308166,
				"type": "PERSON"
			},
			{
				"name": "website",
				"salience": 0.0025309308,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.0025309308,
				"type": "OTHER"
			},
			{
				"name": "countermeasures",
				"salience": 0.0025309308,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0025309308,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0025309308,
				"type": "ORGANIZATION"
			},
			{
				"name": "breaches",
				"salience": 0.0025309308,
				"type": "EVENT"
			},
			{
				"name": "advisors",
				"salience": 0.0024365361,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0024365361,
				"type": "OTHER"
			},
			{
				"name": "ranks",
				"salience": 0.0024365361,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0024082186,
				"type": "EVENT"
			},
			{
				"name": "claims",
				"salience": 0.0023862177,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0022721589,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0020973443,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0020664816,
				"type": "OTHER"
			},
			{
				"name": "bureau",
				"salience": 0.0019745238,
				"type": "ORGANIZATION"
			},
			{
				"name": "marketing emails",
				"salience": 0.0018394316,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.0017542962,
				"type": "EVENT"
			},
			{
				"name": "business ties",
				"salience": 0.0015967982,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0015582619,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.0015439296,
				"type": "LOCATION"
			},
			{
				"name": "allegations",
				"salience": 0.0015313191,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0013742512,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0013742512,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0013742512,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigations",
				"salience": 0.0013106308,
				"type": "EVENT"
			},
			{
				"name": "banks",
				"salience": 0.0012986502,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.0012765635,
				"type": "PERSON"
			},
			{
				"name": "connection",
				"salience": 0.0011830558,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.001124552,
				"type": "PERSON"
			},
			{
				"name": "respect",
				"salience": 0.001124552,
				"type": "OTHER"
			},
			{
				"name": "spam",
				"salience": 0.001124552,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.001124552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0009503834,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet",
				"salience": 0.0009503834,
				"type": "LOCATION"
			},
			{
				"name": "trove",
				"salience": 0.0008726531,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0008400782,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.0008400782,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/037ppp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alfa-Bank"
				},
				"name": "Alfa Bank",
				"salience": 0.00079935824,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.00034894896,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/3ab40b94-1cb7-4c69-be96-d956716c03a5.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T20:57:43.477+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "FBI sees no ties between Trump, Putin 11/01/2016 \nPRESS TV \nThe US Federal Bureau of Investigation (FBI) has found no clear links between Republican presidential nominee Donald Trump and Russia, officials say, proving false allegations by the candidate’s Democratic rival Hillary Clinton. \nThe FBI spent most of the summer to verify claims by the Clinton campaign that Trump was linked to President Vladimir Putin, and Moscow was trying to influence the November 8 vote in his favor. \nHowever, the bureau failed to find any indications of the alleged ties after scrutinizing advisors close to Trump, investigating the real estate mogul’s financial ties and even his emails, the New York Times reported Tuesday, citing law enforcement officials. \nClinton’s campaign voiced concerns about Moscow’s intervention after a series of emails belonging to various ranks of the Democratic Party were released by the anti-secrecy website Wikileaks. \nAmerican intelligence officials blamed the hacks on Russia and even threatened to come up with countermeasures of the same nature. President Barack Obama and high-ranking officials in his administration also blamed Russia for the breaches. \nUnder immense pressure from Clinton’s supporters, who were mad at Trump for calling Putin a great leader, the FBI started its investigation into the claims. \nThe Clinton campaign has called on the FBI to publicly discuss their findings about the case, as they did with their new investigation into Clinton’s new emails. \nFBI chief James Comey told Congress on Friday that he was reopening investigations into Clinton’s emails after finding a trove of new emails on a laptop belonging to former representative Anthony Weiner, who was once married to Clinton’s top aide Huma Abedin. \nAt some point during its investigation, the FBI questioned Paul Manafort, Trump’s former campaign boss, who has reportedly had extensive business ties in Russia and other former Soviet states, especially Ukraine, the Times noted. \nThe bureau’s agents also investigated an email channel between Trump and the Alfa Bank, one of Russia’s biggest banks. \nAfter weeks of detailed investigation, the FBI concluded that the connection was nothing more than marketing emails or spam \nTrump has rejected Clinton’s allegations against Russia, and has pledged to work with Moscow and earn Putin’s respect.",
		"thread_title": "FBI sees no ties between Trump, Putin",
		"title": "FBI sees no ties between Trump, Putin",
		"type": "bs",
		"uuid": "f093f81bb523beb90bd08e46f70af92743916843"
	},
	"-KhIhByuV0aHC2rBC5yy": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:13:11.744+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.22385918,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.19558202,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/056vv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montenegro"
				},
				"name": "Montenegrin",
				"salience": 0.08783355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbia",
				"salience": 0.051139534,
				"type": "LOCATION"
			},
			{
				"name": "Exercises",
				"salience": 0.047216963,
				"type": "OTHER"
			},
			{
				"name": "military exercises",
				"salience": 0.047216963,
				"type": "EVENT"
			},
			{
				"name": "forces",
				"salience": 0.038104527,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.038104527,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.029905729,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.019624904,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.018503701,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01jjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balkans"
				},
				"name": "Balkans",
				"salience": 0.016980138,
				"type": "LOCATION"
			},
			{
				"name": "military exercise",
				"salience": 0.009843695,
				"type": "OTHER"
			},
			{
				"name": "military drills",
				"salience": 0.008426797,
				"type": "EVENT"
			},
			{
				"name": "forces",
				"salience": 0.008118955,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup",
				"salience": 0.007393198,
				"type": "EVENT"
			},
			{
				"name": "state union",
				"salience": 0.007300316,
				"type": "ORGANIZATION"
			},
			{
				"name": "drill",
				"salience": 0.006971324,
				"type": "EVENT"
			},
			{
				"name": "war games",
				"salience": 0.00635227,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.00635227,
				"type": "OTHER"
			},
			{
				"name": "republics",
				"salience": 0.0060701086,
				"type": "PERSON"
			},
			{
				"name": "partner states",
				"salience": 0.00569802,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00569802,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.0054857777,
				"type": "PERSON"
			},
			{
				"name": "republics",
				"salience": 0.0046535223,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0046535223,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.0046535223,
				"type": "ORGANIZATION"
			},
			{
				"name": "floods",
				"salience": 0.0044570146,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0044570146,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.0042909035,
				"type": "OTHER"
			},
			{
				"name": "transport planes",
				"salience": 0.0042909035,
				"type": "OTHER"
			},
			{
				"name": "air force staffers",
				"salience": 0.0042909035,
				"type": "PERSON"
			},
			{
				"name": "paratroopers",
				"salience": 0.0042909035,
				"type": "PERSON"
			},
			{
				"name": "The Slavic Brotherhood 2016",
				"salience": 0.0039134887,
				"type": "ORGANIZATION"
			},
			{
				"name": "personnel",
				"salience": 0.00387753,
				"type": "PERSON"
			},
			{
				"name": "stance",
				"salience": 0.0033941644,
				"type": "OTHER"
			},
			{
				"name": "neighbors",
				"salience": 0.003185859,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01rhrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Federal_Republic_of_Yugoslavia"
				},
				"name": "Socialist Federal Republic of Yugoslavia",
				"salience": 0.0028660411,
				"type": "LOCATION"
			},
			{
				"name": "exercises",
				"salience": 0.002742386,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0027196812,
				"type": "OTHER"
			},
			{
				"name": "invitation",
				"salience": 0.0027196812,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0027196812,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0027196812,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0163v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belarus"
				},
				"name": "Belarus",
				"salience": 0.0026425347,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.002533646,
				"type": "PERSON"
			},
			{
				"name": "alliance",
				"salience": 0.002533646,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01xp_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defence_minister"
				},
				"name": "Defense Ministry",
				"salience": 0.0022987048,
				"type": "ORGANIZATION"
			},
			{
				"name": "partner",
				"salience": 0.00228778,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rxj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Orthodox_Church"
				},
				"name": "Christian Orthodox",
				"salience": 0.0022411728,
				"type": "ORGANIZATION"
			},
			{
				"name": "equipment",
				"salience": 0.0019811802,
				"type": "OTHER"
			},
			{
				"name": "soil",
				"salience": 0.0019811802,
				"type": "OTHER"
			},
			{
				"name": "accession bid",
				"salience": 0.0019811802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "pro-Western",
				"salience": 0.0019335955,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0016466217,
				"type": "LOCATION"
			},
			{
				"name": "Northern Atlantic Alliance",
				"salience": 0.0015998904,
				"type": "ORGANIZATION"
			},
			{
				"name": "offer",
				"salience": 0.0014801327,
				"type": "OTHER"
			},
			{
				"name": "directions",
				"salience": 0.0014801327,
				"type": "OTHER"
			},
			{
				"name": "split",
				"salience": 0.0014801327,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0012195879,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/f2a54edb-e622-4c42-897c-b0a03c59e8d9.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:13:11.744+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "NATO, Russia To Hold Parallel Exercises In Balkans 11/02/2016 \nPRESS TV \nRussia’s military and NATO forces are holding parallel military exercises in two neighboring Balkan countries. \nRussian troops will participate in war games in Serbia while NATO is conducting military drills in Montenegro, media reported on Monday. \nRussian forces’ 13-day military exercise in Serbia is named “The Slavic Brotherhood 2016” and begins on Wednesday. \nIt will include 150 Russian paratroopers, 50 air force staffers, three transport planes and an unspecified number of troops from Serbia and Belarus, Russia’s Defense Ministry said. \nThe five-day NATO drill in Montenegro started on Monday and involves responding to floods and chemical attacks. It will involve 680 unarmed personnel from seven NATO countries and 10 partner states. \nIn the past both Serbia and Montenegro were constitutional republics of the Socialist Federal Republic of Yugoslavia. \nBoth countries are socialist republics and traditional Russian Christian Orthodox allies. In 2003 this state union was re-formed into Serbia and Montenegro, and in 2006 the two became independent states. \nSince their split, the two Balkan neighbors seem to have headed in different directions strategically. \nMontenegro has taken a pro-Western stance which has been awarded by NATO with an offer to join the Northern Atlantic Alliance. \nThe NATO invitation to Montenegro has met strong opposition from Russia. \nMeanwhile, Montenegrin officials have accused Russia of staging an alleged coup in October to topple its pro-Western government because of the NATO accession bid. \nSerbia, a NATO partner, has held exercises with the Western alliance, but not such a large one or with foreign troops and equipment participating on its soil.",
		"thread_title": "NATO, Russia To Hold Parallel Exercises In Balkans",
		"title": "NATO, Russia To Hold Parallel Exercises In Balkans",
		"type": "bs",
		"uuid": "a0a3b30b590882ba3da26d114ab263f8d3ae1ef7"
	},
	"-KhIhCJiHQ6u0ByEvgXF": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:13:11.901+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.23011133,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06qd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Korea"
				},
				"name": "South Korean",
				"salience": 0.14651433,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hsqf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Seoul"
				},
				"name": "Seoul",
				"salience": 0.095120944,
				"type": "LOCATION"
			},
			{
				"name": "Kim Jung-shik",
				"salience": 0.06448316,
				"type": "PERSON"
			},
			{
				"name": "coast guard",
				"salience": 0.05032889,
				"type": "OTHER"
			},
			{
				"name": "coast guard vessels",
				"salience": 0.03964361,
				"type": "OTHER"
			},
			{
				"name": "news agency",
				"salience": 0.0351365,
				"type": "ORGANIZATION"
			},
			{
				"name": "coast",
				"salience": 0.030217802,
				"type": "LOCATION"
			},
			{
				"name": "machine gun shootout",
				"salience": 0.02758771,
				"type": "EVENT"
			},
			{
				"name": "fire",
				"salience": 0.026657851,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.026657851,
				"type": "OTHER"
			},
			{
				"name": "boats",
				"salience": 0.025815034,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01914",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beijing"
				},
				"name": "Beijing",
				"salience": 0.019424444,
				"type": "LOCATION"
			},
			{
				"name": "trawlers",
				"salience": 0.019193886,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/048fz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korea"
				},
				"name": "Korea",
				"salience": 0.01599482,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.010290276,
				"type": "ORGANIZATION"
			},
			{
				"name": "incident",
				"salience": 0.0077106445,
				"type": "EVENT"
			},
			{
				"name": "fishing boats",
				"salience": 0.005499114,
				"type": "OTHER"
			},
			{
				"name": "coast guard members",
				"salience": 0.0052931304,
				"type": "PERSON"
			},
			{
				"name": "ships",
				"salience": 0.0051239654,
				"type": "OTHER"
			},
			{
				"name": "vessels",
				"salience": 0.004881668,
				"type": "OTHER"
			},
			{
				"name": "crew service weapon",
				"salience": 0.004285271,
				"type": "OTHER"
			},
			{
				"name": "coast guard",
				"salience": 0.004215976,
				"type": "OTHER"
			},
			{
				"name": "fishermen",
				"salience": 0.0038703703,
				"type": "PERSON"
			},
			{
				"name": "boats",
				"salience": 0.0038592967,
				"type": "OTHER"
			},
			{
				"name": "machine guns",
				"salience": 0.0035286774,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "order",
				"salience": 0.0035286774,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0035286774,
				"type": "LOCATION"
			},
			{
				"name": "confrontation",
				"salience": 0.0035286774,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "North Korea",
				"salience": 0.0033888863,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.0033271178,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/010lsj6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hua_Chunying"
				},
				"name": "Hua Chunying",
				"salience": 0.0032776576,
				"type": "PERSON"
			},
			{
				"name": "boats",
				"salience": 0.003151827,
				"type": "OTHER"
			},
			{
				"name": "fishermen",
				"salience": 0.0028928015,
				"type": "PERSON"
			},
			{
				"name": "trawlers",
				"salience": 0.0027516466,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "coast guard",
				"salience": 0.0027416034,
				"type": "PERSON"
			},
			{
				"name": "coast guard",
				"salience": 0.00267304,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0024754342,
				"type": "OTHER"
			},
			{
				"name": "fish",
				"salience": 0.0024696798,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0023831395,
				"type": "ORGANIZATION"
			},
			{
				"name": "bows",
				"salience": 0.0023831395,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "air",
				"salience": 0.0023831395,
				"type": "OTHER"
			},
			{
				"name": "fishing boats",
				"salience": 0.0023554515,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "shooting",
				"salience": 0.0023339395,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0df4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yellow_Sea"
				},
				"name": "Yellow Sea",
				"salience": 0.0021734503,
				"type": "LOCATION"
			},
			{
				"name": "first",
				"salience": 0.0021534727,
				"type": "OTHER"
			},
			{
				"name": "firearms policy",
				"salience": 0.002021295,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.002021295,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.001995848,
				"type": "OTHER"
			},
			{
				"name": "fishermen",
				"salience": 0.0017992643,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.0017439722,
				"type": "EVENT"
			},
			{
				"name": "fishing boat",
				"salience": 0.0017160076,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "resistance",
				"salience": 0.0016090729,
				"type": "OTHER"
			},
			{
				"name": "coast guard vessel",
				"salience": 0.0015228863,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0015228863,
				"type": "OTHER"
			},
			{
				"name": "vessel",
				"salience": 0.0015228863,
				"type": "OTHER"
			},
			{
				"name": "search",
				"salience": 0.001510275,
				"type": "OTHER"
			},
			{
				"name": "waters",
				"salience": 0.001510275,
				"type": "OTHER"
			},
			{
				"name": "complaint",
				"salience": 0.001510275,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017kjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yonhap"
				},
				"name": "Yonhap",
				"salience": 0.001467424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02626pc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Foreign_Affairs_of_the_People's_Republic_of_China"
				},
				"name": "Foreign Ministry",
				"salience": 0.0014499875,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons",
				"salience": 0.0014238942,
				"type": "OTHER"
			},
			{
				"name": "coast guard",
				"salience": 0.0012818888,
				"type": "OTHER"
			},
			{
				"name": "tools",
				"salience": 0.0012330519,
				"type": "OTHER"
			},
			{
				"name": "sinking",
				"salience": 0.0011001008,
				"type": "EVENT"
			},
			{
				"name": "grenades",
				"salience": 0.0010457054,
				"type": "OTHER"
			},
			{
				"name": "law enforcement activities",
				"salience": 0.0008218436,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0008218436,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/8e8a9080-50df-4159-b4c7-634b8eea012d.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:13:11.901+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "S Korea coast guard opens fire on China boats 11/02/2016 \nPRESS TV \nSouth Korean coast guard vessels have opened fire on Chinese trawlers allegedly fishing illegally off South Korea’s coast, prompting Beijing to censure Seoul. \nOn Wednesday, senior coast guard official Kim Jung-shik said the order to fire machine guns had been given during a confrontation with some 30 Chinese fishing boats. \nThe Chinese vessels had been allegedly operating illegally near South Korea’s Yellow Sea border with North Korea on Tuesday. \n“They tried to ram our ships although we repeatedly warned them,” Yonhap news agency quoted Kim as saying. \nThe South Korean coast guard forces initially fired into the air but were later ordered to fire on the bows of the trawlers. \n“I thought our officers would be in danger if I allowed any more resistance so we ended up using the crew service weapon,” Kim said. \nTwo Chinese boats were seized in the incident, which reportedly caused no casualties. \nThe machine gun shootout is the first of its kind since the South Korean coast guard declared in September that it would apply a “more aggressive” firearms policy with Chinese boats. \nThe shooting left Beijing “strongly dissatisfied” with China’s Foreign Ministry calling on Seoul to “discipline” its coast guard. \n“Using destructive weapons can easily hurt fishermen and we urge the ROK (South Korea) side to … avoid using any excessive or extreme tools in their law enforcement activities,” said China’s Foreign Ministry spokeswoman Hua Chunying. \nNumerous incidents have occurred in recent years between South Korea’s coast guard and Chinese fishing boats venturing across international waters in search of fish. \nOn October 10, Seoul said it had lodged a formal complaint with Beijing over the alleged sinking of a South Korean coast guard vessel by Chinese fishermen on October 7. \nOn September 29, three Chinese fishermen died after their fishing boat was set on fire by South Korean coast guard members who threw grenades into their vessel.",
		"thread_title": "S Korea coast guard opens fire on China boats",
		"title": "S Korea coast guard opens fire on China boats",
		"type": "bs",
		"uuid": "fe88118b5cc98d1d4b8e9644f00b06d52f54b242"
	},
	"-KhIhCRiCKC4UTyX-OK8": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:13:13.092+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/035rnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Ruffalo"
				},
				"name": "Mark Ruffalo",
				"salience": 0.5279291,
				"type": "PERSON"
			},
			{
				"name": "Terrorist Watch",
				"salience": 0.08319613,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS NEWS",
				"salience": 0.04513074,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.04405391,
				"type": "LOCATION"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.038715597,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.030383097,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bmcs3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gasland"
				},
				"name": "Gasland",
				"salience": 0.026199404,
				"type": "WORK_OF_ART"
			},
			{
				"name": "communities",
				"salience": 0.019217534,
				"type": "OTHER"
			},
			{
				"name": "film",
				"salience": 0.019217534,
				"type": "WORK_OF_ART"
			},
			{
				"name": "f",
				"salience": 0.015515706,
				"type": "OTHER"
			},
			{
				"name": "terror advisory list",
				"salience": 0.013493664,
				"type": "OTHER"
			},
			{
				"name": "natural gas drilling",
				"salience": 0.012660289,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09tqkv2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Kids_Are_All_Right_(film)"
				},
				"name": "The Kids Are All Right",
				"salience": 0.011121389,
				"type": "WORK_OF_ART"
			},
			{
				"name": "concerns",
				"salience": 0.010970533,
				"type": "OTHER"
			},
			{
				"name": "star",
				"salience": 0.009916522,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vn_9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zodiac_(film)"
				},
				"name": "Zodiac",
				"salience": 0.009636118,
				"type": "ORGANIZATION"
			},
			{
				"name": "light",
				"salience": 0.008963359,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01v9vx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco_Chronicle"
				},
				"name": "San Francisco Chronicle",
				"salience": 0.006763931,
				"type": "ORGANIZATION"
			},
			{
				"name": "airports",
				"salience": 0.006701858,
				"type": "LOCATION"
			},
			{
				"name": "screenings",
				"salience": 0.006701858,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0065120813,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "Office of Homeland Security",
				"salience": 0.0065120813,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/093d58y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Josh_Fox"
				},
				"name": "Josh Fox",
				"salience": 0.005524444,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03mdt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HBO"
				},
				"name": "HBO",
				"salience": 0.005524444,
				"type": "ORGANIZATION"
			},
			{
				"name": "situation",
				"salience": 0.004884399,
				"type": "OTHER"
			},
			{
				"name": "magazine",
				"salience": 0.004884399,
				"type": "WORK_OF_ART"
			},
			{
				"name": "kin",
				"salience": 0.004527132,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0039887046,
				"type": "OTHER"
			},
			{
				"name": "natural gas drilling boom",
				"salience": 0.0036503149,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02pypc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/GQ"
				},
				"name": "GQ",
				"salience": 0.0030082704,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/062zm5h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Avengers_(2012_film)"
				},
				"name": "The Avengers",
				"salience": 0.0022477177,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07rgn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hulk_(comics)"
				},
				"name": "Hulk",
				"salience": 0.0022477177,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/mark-ruffalo-terrorism.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:13:13.092+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Mark Ruffalo Reportedly Placed on U.S. Terrorist Watch List 11/02/2016 \nCBS NEWS \nActor Mark Ruffalo has reportedly been added to the government’s terrorist watch list. \nThe “The Kids Are All Right” and “Zodiac” star was placed on the terror advisory list by Pennsylvania’s Office of Homeland Security earlier this year after helping to promote the documentary “Gasland” and speaking out about his concerns of natural gas drilling, according to the San Francisco Chronicle. \nWritten and directed by Josh Fox, the film, which premiered on HBO this summer, put a light on the communities that are impacted by the natural gas drilling boom in the U.S. \nWhile Ruffalo, who will next appear as The Hulk in “The Avengers,” may now face tedious secondary screenings at airports, the 43-year-old isn’t too put off by the whole situation. \n[It’s] pretty f–kin’ funny,” he tells the December issue of GQ magazine .",
		"thread_title": "Mark Ruffalo Reportedly Placed on U.S. Terrorist Watch List",
		"title": "Mark Ruffalo Reportedly Placed on U.S. Terrorist Watch List",
		"type": "bs",
		"uuid": "5a04e887e006a23ff61fb4a406a55a78349d4062"
	},
	"-KhIhCaj4It4aO4L3tmX": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:13:13.486+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.1310441,
				"type": "LOCATION"
			},
			{
				"name": "UN for War Crimes",
				"salience": 0.11630107,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.10369426,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.06815518,
				"type": "WORK_OF_ART"
			},
			{
				"name": "coast guard",
				"salience": 0.049456716,
				"type": "OTHER"
			},
			{
				"name": "AMTV",
				"salience": 0.0486751,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0486751,
				"type": "ORGANIZATION"
			},
			{
				"name": "coast guard vessels",
				"salience": 0.035081178,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c_p1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/War_crime"
				},
				"name": "War Crimes",
				"salience": 0.03297649,
				"type": "EVENT"
			},
			{
				"name": "military exercises",
				"salience": 0.02832293,
				"type": "EVENT"
			},
			{
				"name": "fire",
				"salience": 0.02705088,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.025861582,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.024883868,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.024656203,
				"type": "ORGANIZATION"
			},
			{
				"name": "countrie",
				"salience": 0.024656203,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.02374081,
				"type": "ORGANIZATION"
			},
			{
				"name": "boats",
				"salience": 0.020149084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048fz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korea"
				},
				"name": "Korea",
				"salience": 0.015208208,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01jjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balkans"
				},
				"name": "Balkan",
				"salience": 0.015208208,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.014642307,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.014642307,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.012680644,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06qd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Korea"
				},
				"name": "South Korean",
				"salience": 0.012422833,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.012220831,
				"type": "LOCATION"
			},
			{
				"name": "fire",
				"salience": 0.011033427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.01072089,
				"type": "ORGANIZATION"
			},
			{
				"name": "documents",
				"salience": 0.010442142,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "DAILY CALLER",
				"salience": 0.009286069,
				"type": "PERSON"
			},
			{
				"name": "trawlers",
				"salience": 0.008209993,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "FBI Releases Clinton Foundation Investigation Records",
				"salience": 0.008078923,
				"type": "ORGANIZATION"
			},
			{
				"name": "AMTV Archives",
				"salience": 0.0067663877,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07q3j97"
				},
				"name": "South",
				"salience": 0.005056085,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^6330B0C21C3D34B4051B5A40B909E3E2B0D560D02C40BF557D^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:13:13.486+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Putin being FRAMED at UN for War Crimes in Syria Explained 11/02/2016 In today’s video, Christopher Greene of AMTV explains why the UN is framing Vladimir Putin for War Crimes in Syria. 11/02/2016 PRESS TV Russia's military and NATO forces are holding parallel military exercises in two neighboring Balkan countrie ... S Korea coast guard opens fire on China boats 11/02/2016 PRESS TV South Korean coast guard vessels have opened fire on Chinese trawlers allegedly fishing illegally off South ... FBI Releases Clinton Foundation Investigation Records 11/02/2016 DAILY CALLER The FBI on Tuesday released documents related to a now-closed federal investigation of an alleged pay-to ... AMTV Archives",
		"thread_title": "Putin being FRAMED at UN for War Crimes in Syria Explained",
		"title": "Putin being FRAMED at UN for War Crimes in Syria Explained",
		"type": "bs",
		"uuid": "5ae895897e7f7b2755b71539e2e4d12b3fb91d17"
	},
	"-KhIhCnGjSWtV8dA1xEc": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:13:14.334+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08yntn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Red_herring"
				},
				"name": "Red Herring",
				"salience": 0.112882406,
				"type": "ORGANIZATION"
			},
			{
				"name": "video",
				"salience": 0.098861724,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Comey Investigation",
				"salience": 0.080913655,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.07893301,
				"type": "PERSON"
			},
			{
				"name": "AMTV",
				"salience": 0.07147343,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Wikileaks Dump 11",
				"salience": 0.07085116,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.061517328,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.04137732,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Data Dump",
				"salience": 0.040026795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.029509714,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.024515886,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.019862905,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.019862905,
				"type": "EVENT"
			},
			{
				"name": "gang",
				"salience": 0.019208396,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.017363885,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.017222656,
				"type": "ORGANIZATION"
			},
			{
				"name": "rights",
				"salience": 0.015578797,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.014811262,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.014792327,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.014367462,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.014367462,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.013013939,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.01164948,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.010342727,
				"type": "OTHER"
			},
			{
				"name": "speculation",
				"salience": 0.009708816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0091981,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.009189633,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.009189633,
				"type": "EVENT"
			},
			{
				"name": "scale",
				"salience": 0.0091136545,
				"type": "OTHER"
			},
			{
				"name": "Somebody",
				"salience": 0.0091136545,
				"type": "PERSON"
			},
			{
				"name": "Citizen Quasar Publishing",
				"salience": 0.00885548,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.008663836,
				"type": "PERSON"
			},
			{
				"name": "excuse",
				"salience": 0.0057050628,
				"type": "OTHER"
			},
			{
				"name": "Citizen Quasar Further",
				"salience": 0.005613951,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0g6yn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pledge_of_Allegiance"
				},
				"name": "Pledge of Allegiance",
				"salience": 0.0023415522,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^C86B94772A447D8153CD1A29CA6E308B7B58A79CC3D602C6D4^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T04:54:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Comey Investigation a Red Herring to Cover Up Wikileaks Dump 11/01/2016 In today’s video, Christopher Greene of AMTV explains why the Comey Investigation into Hillary Clinton’s emails is a Red Herring to Cover Up Wikileaks Data Dump. 10/10/2016 Citizen Quasar \nPublishing news about one of the candidates before an election is NOT “interfering” with an election. \nThe criminal gang that controls the United States today is systemically inherent in representational government. NO government will be constructed that protects rights until people know what rights are. For Americans, this is decades, if not centuries, in the future from now. \nIn the meantime, Americans will continue saying the Pledge of Allegiance and continue thinking this is patriotic and puzzling over how Americans couldever be taught the definition of a right on such a wide scale. Citizen Quasar \nFurther, here is some speculation: \nSomebody shoots Hillary Clinton dead two days before the election. This gives President Obama an excuse to “temporarily” delay the election. Follow AMTV!",
		"thread_title": "Comey Investigation a Red Herring to Cover Up Wikileaks Dump",
		"title": "Comey Investigation a Red Herring to Cover Up Wikileaks Dump",
		"type": "bs",
		"uuid": "a7a9774157bc8eac6a8509ffbeda683e9d8a5cdc"
	},
	"-KhIhD3ftWVKSfytPmJk": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:22:22.850+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/012sgt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MGM-140_ATACMS"
				},
				"name": "ATACMS",
				"salience": 0.41858885,
				"type": "ORGANIZATION"
			},
			{
				"name": "Will Roper",
				"salience": 0.08096712,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04kch_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ash_Carter"
				},
				"name": "Ashton Carter",
				"salience": 0.06252831,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "Army",
				"salience": 0.046389367,
				"type": "ORGANIZATION"
			},
			{
				"name": "Strategic Capabilities Office",
				"salience": 0.036781304,
				"type": "ORGANIZATION"
			},
			{
				"name": "panel",
				"salience": 0.025462255,
				"type": "EVENT"
			},
			{
				"name": "missile system",
				"salience": 0.025007524,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.020553714,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.020553714,
				"type": "LOCATION"
			},
			{
				"name": "sea",
				"salience": 0.020553714,
				"type": "LOCATION"
			},
			{
				"name": "NEWS",
				"salience": 0.016110295,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.012526538,
				"type": "ORGANIZATION"
			},
			{
				"name": "Long Range Rocket",
				"salience": 0.011481089,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.010810496,
				"type": "LOCATION"
			},
			{
				"name": "Carter Reveals Upgrades",
				"salience": 0.009950016,
				"type": "OTHER"
			},
			{
				"name": "combat",
				"salience": 0.009499652,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.008404695,
				"type": "OTHER"
			},
			{
				"name": "menace",
				"salience": 0.008262351,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.008262351,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.007955235,
				"type": "OTHER"
			},
			{
				"name": "capabilities",
				"salience": 0.0056310515,
				"type": "OTHER"
			},
			{
				"name": "missile system",
				"salience": 0.0053142556,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0052983654,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.005093891,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.005093891,
				"type": "ORGANIZATION"
			},
			{
				"name": "Secretary",
				"salience": 0.003936212,
				"type": "PERSON"
			},
			{
				"name": "protege",
				"salience": 0.0034092602,
				"type": "OTHER"
			},
			{
				"name": "capabilities",
				"salience": 0.0031862033,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0031362444,
				"type": "PERSON"
			},
			{
				"name": "systems",
				"salience": 0.003045027,
				"type": "OTHER"
			},
			{
				"name": "offset",
				"salience": 0.0029438115,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02n4mz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Center_for_Strategic_and_International_Studies"
				},
				"name": "Center for Strategic and International Studies",
				"salience": 0.0027640294,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.0027612387,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0027612387,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0026582805,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hkqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lockheed_Martin"
				},
				"name": "Lockheed Martin",
				"salience": 0.002652118,
				"type": "ORGANIZATION"
			},
			{
				"name": "idea",
				"salience": 0.0024020812,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.002391362,
				"type": "ORGANIZATION"
			},
			{
				"name": "concerns",
				"salience": 0.002391362,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.002391362,
				"type": "OTHER"
			},
			{
				"name": "writing",
				"salience": 0.002391362,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.002391362,
				"type": "OTHER"
			},
			{
				"name": "Ken Musculus",
				"salience": 0.0023071344,
				"type": "PERSON"
			},
			{
				"name": "door",
				"salience": 0.0023021766,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0023021766,
				"type": "PERSON"
			},
			{
				"name": "adversaries",
				"salience": 0.0023021766,
				"type": "ORGANIZATION"
			},
			{
				"name": "missile system",
				"salience": 0.0022754217,
				"type": "OTHER"
			},
			{
				"name": "missile system",
				"salience": 0.0022754217,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0022546349,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019tjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_states"
				},
				"name": "Baltics",
				"salience": 0.0020995592,
				"type": "LOCATION"
			},
			{
				"name": "capability",
				"salience": 0.0020193798,
				"type": "OTHER"
			},
			{
				"name": "seeker",
				"salience": 0.001973451,
				"type": "OTHER"
			},
			{
				"name": "Breaking Defense",
				"salience": 0.0019620925,
				"type": "OTHER"
			},
			{
				"name": "morning session",
				"salience": 0.0019525412,
				"type": "EVENT"
			},
			{
				"name": "potential",
				"salience": 0.0019525412,
				"type": "OTHER"
			},
			{
				"name": "features",
				"salience": 0.0019525412,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0018656568,
				"type": "LOCATION"
			},
			{
				"name": "sea",
				"salience": 0.0018656568,
				"type": "LOCATION"
			},
			{
				"name": "targets",
				"salience": 0.0018656568,
				"type": "OTHER"
			},
			{
				"name": "CSIS Carter",
				"salience": 0.001775281,
				"type": "PERSON"
			},
			{
				"name": "missiles",
				"salience": 0.0017380172,
				"type": "OTHER"
			},
			{
				"name": "domain",
				"salience": 0.0016845962,
				"type": "OTHER"
			},
			{
				"name": "seeker technology",
				"salience": 0.0016845962,
				"type": "OTHER"
			},
			{
				"name": "artillery rocket system",
				"salience": 0.0016575782,
				"type": "OTHER"
			},
			{
				"name": "contract",
				"salience": 0.0016424302,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.001458815,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.001458815,
				"type": "LOCATION"
			},
			{
				"name": "plans",
				"salience": 0.001458815,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0013181277,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.0012984948,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0012984948,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Defense Department",
				"salience": 0.0012486547,
				"type": "ORGANIZATION"
			},
			{
				"name": "strike requirements",
				"salience": 0.0010625651,
				"type": "OTHER"
			},
			{
				"name": "customers",
				"salience": 0.0010625651,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0010152593,
				"type": "LOCATION"
			},
			{
				"name": "sea",
				"salience": 0.0010152593,
				"type": "LOCATION"
			},
			{
				"name": "targets",
				"salience": 0.0010152593,
				"type": "OTHER"
			},
			{
				"name": "domains",
				"salience": 0.00091668445,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00079377595,
				"type": "OTHER"
			},
			{
				"name": "munitions",
				"salience": 0.00079377595,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00079377595,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00079377595,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.00079377595,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/1040913389.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:22:22.850+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.7,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Carter Reveals Upgrades To US Long Range Rocket 11/02/2016 \nSPUTNIK NEWS \nOn Tuesday US Defense Secretary Ashton Carter announced that the Army’s tactical missile system (ATACMS) will be upgraded to strike both land and sea targets. Such technology will go a long way to defending allies against the Chinese menace and battling Moscow’s “aggression” in the Baltics. \nThe missile system is sponsored by an office created by Carter in 2012, the Strategic Capabilities Office, which is currently being lead by Will Roper, a protege’ of the Secretary’s. During a panel at the Center for Strategic and International Studies (CSIS) on Friday Roper told an audience, “How you offset the adversaries trying to offset your offset? It’s very simple to do that, you just don’t talk about your best capabilities…We are keeping our best ideas behind the door and probably always will,” according to Breaking Defense. \nAfter the panel, he continued, “We thought it was important to come out (in public) with ATACMS for the Army because there’s been a lot of writing, a lot of speeches, on the need for the Army to go cross-domain.” High ranking officials in the US military have been calling for the ATACMS to extend its capabilities seaward for some time, and Roper responded to these concerns saying, “it’s time for us to show it isn’t just a theoretical idea, it’s something we can potentially get to quickly with something that we already have.” \nDuring a morning session at CSIS Carter spoke of the new innovative features of the ATACMS, and how the SCO tries to maximize the potential of existing systems. \n“A prominent theme of SCO’s work is spearheading creative and unexpected new ways to use our existing missiles and advanced munitions, and across varied domains”, he said, adding, “… By integrating an existing seeker onto the front of the missile, they’re enabling it to hit moving targets, both at sea as well as on land. With this capability, what was previously an Army surface-to-surface missile system can project power from coastal locations up to 300 kilometers into the maritime domain.” \nCarter detailed the SCO’s plans to utilize seeker technology that the Defense Department has already developed so the missile system can hit targets both on sea and land. \nLockheed Martin was awarded the $174 million contract for the long range artillery rocket system in May 2015. Ken Musculus, vice president of tactical missiles at the defense contractor said at the time that ATACMS is “reliable and proven in combat, which is why it continues to be our customers’ choice for long-range strike requirements.”",
		"thread_title": "Carter Reveals Upgrades To US Long Range Rocket",
		"title": "Carter Reveals Upgrades To US Long Range Rocket",
		"type": "bs",
		"uuid": "99ffca232b8c6aca5752ccb6779f561c1a3a1b26"
	},
	"-KhIhDGgPTAAFUlDEQnB": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:22:23.260+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian Federation",
				"salience": 0.4388478,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.102765895,
				"type": "LOCATION"
			},
			{
				"name": "procedure",
				"salience": 0.06344277,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.041918617,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.02931599,
				"type": "LOCATION"
			},
			{
				"name": "measure",
				"salience": 0.023957126,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.02354061,
				"type": "OTHER"
			},
			{
				"name": "Plutonium Deal",
				"salience": 0.02354061,
				"type": "OTHER"
			},
			{
				"name": "weapons-grade plutonium",
				"salience": 0.020370195,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.019687658,
				"type": "WORK_OF_ART"
			},
			{
				"name": "warheads",
				"salience": 0.017078154,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.012540978,
				"type": "WORK_OF_ART"
			},
			{
				"name": "plutonium",
				"salience": 0.012253593,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.010634749,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RUSSIA TODAY",
				"salience": 0.010557633,
				"type": "ORGANIZATION"
			},
			{
				"name": "agreement",
				"salience": 0.009086805,
				"type": "OTHER"
			},
			{
				"name": "plutonium",
				"salience": 0.008503964,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6h97",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RIA_Novosti"
				},
				"name": "RIA Novosti",
				"salience": 0.008050085,
				"type": "ORGANIZATION"
			},
			{
				"name": "deal",
				"salience": 0.00500926,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00500926,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.0040401784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02n670",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sergey_Lavrov"
				},
				"name": "Sergey Lavrov",
				"salience": 0.0038658432,
				"type": "PERSON"
			},
			{
				"name": "weapons-grade plutonium",
				"salience": 0.0038127752,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0038090448,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0036210436,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0036210436,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0036210436,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0036210436,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0036210436,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0035152126,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.003384245,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0032479332,
				"type": "OTHER"
			},
			{
				"name": "weapons-grade plutonium",
				"salience": 0.0032343632,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.00278339,
				"type": "ORGANIZATION"
			},
			{
				"name": "changes",
				"salience": 0.002540306,
				"type": "OTHER"
			},
			{
				"name": "circumstances",
				"salience": 0.002540306,
				"type": "OTHER"
			},
			{
				"name": "dilutants",
				"salience": 0.002540306,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0knsm_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Magnitsky_Act"
				},
				"name": "Magnitsky Act",
				"salience": 0.002463303,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Sergey Ryabkov",
				"salience": 0.0024508638,
				"type": "PERSON"
			},
			{
				"name": "plant",
				"salience": 0.0024455988,
				"type": "LOCATION"
			},
			{
				"name": "fuel",
				"salience": 0.0024455988,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0023951128,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0021452764,
				"type": "PERSON"
			},
			{
				"name": "rise",
				"salience": 0.0020742917,
				"type": "OTHER"
			},
			{
				"name": "obligations",
				"salience": 0.0020742917,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0020742917,
				"type": "OTHER"
			},
			{
				"name": "inability",
				"salience": 0.0020742917,
				"type": "OTHER"
			},
			{
				"name": "stability",
				"salience": 0.0020742917,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0020742917,
				"type": "OTHER"
			},
			{
				"name": "accordance",
				"salience": 0.0020742917,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.002048179,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0017897118,
				"type": "OTHER"
			},
			{
				"name": "suspension",
				"salience": 0.0017897118,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.001562837,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0015498954,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.0015498954,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0015498954,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0015498954,
				"type": "ORGANIZATION"
			},
			{
				"name": "suspension",
				"salience": 0.0013037198,
				"type": "EVENT"
			},
			{
				"name": "security",
				"salience": 0.0011289738,
				"type": "OTHER"
			},
			{
				"name": "commitments",
				"salience": 0.0011289738,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0011289738,
				"type": "OTHER"
			},
			{
				"name": "parliament",
				"salience": 0.0011289738,
				"type": "ORGANIZATION"
			},
			{
				"name": "bill",
				"salience": 0.0010787192,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/045vz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Russian_sentiment"
				},
				"name": "anti-Russian",
				"salience": 0.0009541471,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.0008434201,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.0008434201,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.0008434201,
				"type": "PERSON"
			},
			{
				"name": "entry",
				"salience": 0.0008434201,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0008434201,
				"type": "OTHER"
			},
			{
				"name": "military presence",
				"salience": 0.0008187233,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05jzn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Treaty_on_the_Non-Proliferation_of_Nuclear_Weapons"
				},
				"name": "Nuclear Non-Proliferation Treaty",
				"salience": 0.0006949407,
				"type": "OTHER"
			},
			{
				"name": "bloc",
				"salience": 0.0006300604,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/581787bec46188db298b45b4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:22:23.260+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Russia-US Plutonium Deal No Longer In Effect 11/02/2016 \nRUSSIA TODAY President Vladimir Putin has signed an act suspending a 2000 agreement between the US and Russia on reprocessing weapons-grade plutonium extracted from decommissioned warheads. \nThe bill has already been published on Russia’s official legal information website, meaning it’s now in force. \nIt mentions that a decision to restore the agreement can only be made by Russia’s president. \nThe deal between Moscow and Washington was ratified in 2000. As a means to safely utilize weapons-grade plutonium, it suggested a specific procedure to turn it into nuclear plant fuel. Starting from 2018, it was planned to reprocess 34 tons (68,000 pounds) of plutonium, which would have been enough to produce thousands of nuclear weapons, RIA Novosti reported. \nYet, while Russia has prepared the infrastructure necessary for the process, the US said it found the procedure too costly and instead opted for mixing plutonium with special dilutants to store it indefinitely. \nRussia suspended the deal “ due to drastic changes of circumstances, the rise of threat to strategic stability as a result of hostile actions of the US towards the Russian Federation and the inability of the US to provide for the accepted obligations to utilize the excess weapons-grade plutonium in accordance with the agreement ,” the new bill read. \nFor the agreement to be resumed, Washington should reduce the US military presence on the territory of NATO members that joined the bloc after 2000, cancel its Magnitsky Act which bans entry to the US to a list of Russian citizens, as well as lift other anti-Russian sanctions and compensate the loss Moscow suffered as a result of such policy. \nThe bill on suspension – which is a “ forced measure ,” according to Russian Foreign Minister Sergey Lavrov – was first submitted by the president’s office earlier this month and then approved by parliament. \nCommenting on the suspension of the deal, Russian Deputy Foreign Minister Sergey Ryabkov has said that it would not affect any of Moscow’s other commitments related to international nuclear security and does not interfere with the Nuclear Non-Proliferation Treaty.",
		"thread_title": "Russia-US Plutonium Deal No Longer In Effect",
		"title": "Russia-US Plutonium Deal No Longer In Effect",
		"type": "bs",
		"uuid": "22de95c66d2fd9f2b9aa5240696b7e0e1de96779"
	},
	"-KhIhDWyhdtr8uB_6yfO": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:22:23.760+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.28631282,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.26542455,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.047818042,
				"type": "PERSON"
			},
			{
				"name": "respondents",
				"salience": 0.039081536,
				"type": "PERSON"
			},
			{
				"name": "aggravation",
				"salience": 0.02206152,
				"type": "OTHER"
			},
			{
				"name": "Half",
				"salience": 0.021966675,
				"type": "PERSON"
			},
			{
				"name": "opinion poll",
				"salience": 0.020311808,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.01913625,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.018359017,
				"type": "EVENT"
			},
			{
				"name": "military conflict",
				"salience": 0.018359017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.017928174,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.016083814,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.01591839,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gkh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West"
				},
				"name": "West",
				"salience": 0.012817889,
				"type": "ORGANIZATION"
			},
			{
				"name": "respondents",
				"salience": 0.010888443,
				"type": "PERSON"
			},
			{
				"name": "share",
				"salience": 0.010505312,
				"type": "OTHER"
			},
			{
				"name": "probability",
				"salience": 0.008955861,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.005244687,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War Three",
				"salience": 0.0050314134,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.0046593053,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.0044427793,
				"type": "PERSON"
			},
			{
				"name": "research center",
				"salience": 0.004305092,
				"type": "LOCATION"
			},
			{
				"name": "citizens",
				"salience": 0.004302091,
				"type": "PERSON"
			},
			{
				"name": "opinion",
				"salience": 0.0038877872,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar Assad",
				"salience": 0.003595056,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.0035133027,
				"type": "EVENT"
			},
			{
				"name": "society",
				"salience": 0.0033672608,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.003297761,
				"type": "EVENT"
			},
			{
				"name": "operation",
				"salience": 0.0032687867,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.003146929,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0030201043,
				"type": "LOCATION"
			},
			{
				"name": "answer",
				"salience": 0.002892511,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0027271651,
				"type": "EVENT"
			},
			{
				"name": "operation",
				"salience": 0.002669169,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.0026254684,
				"type": "EVENT"
			},
			{
				"name": "probability",
				"salience": 0.0026254684,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0024660407,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.0024577933,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05pmd2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yuri_Levada"
				},
				"name": "Levada",
				"salience": 0.0023944238,
				"type": "ORGANIZATION"
			},
			{
				"name": "scenario",
				"salience": 0.0023919386,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0023618243,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0023618243,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.0023618243,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.0023618243,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.002273734,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0021585082,
				"type": "PERSON"
			},
			{
				"name": "air force",
				"salience": 0.0019944126,
				"type": "ORGANIZATION"
			},
			{
				"name": "counter-terrorism operation",
				"salience": 0.0019944126,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0019283962,
				"type": "OTHER"
			},
			{
				"name": "fifth",
				"salience": 0.0019283962,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0019283962,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0019283962,
				"type": "OTHER"
			},
			{
				"name": "awareness",
				"salience": 0.0019283962,
				"type": "OTHER"
			},
			{
				"name": "familiarity",
				"salience": 0.0019283962,
				"type": "OTHER"
			},
			{
				"name": "research center",
				"salience": 0.0018425811,
				"type": "LOCATION"
			},
			{
				"name": "attitude",
				"salience": 0.0017646861,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00166375,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0582hs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Air_Force"
				},
				"name": "Russian Air Force",
				"salience": 0.0016434626,
				"type": "ORGANIZATION"
			},
			{
				"name": "basis",
				"salience": 0.0015744377,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0015429867,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0015156899,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0014527859,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0014407523,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0014407523,
				"type": "OTHER"
			},
			{
				"name": "wrongdoing",
				"salience": 0.0014407523,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0014407523,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0013421563,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0013421563,
				"type": "PERSON"
			},
			{
				"name": "developments",
				"salience": 0.0012854014,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0012118606,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0012118606,
				"type": "ORGANIZATION"
			},
			{
				"name": "air operations",
				"salience": 0.0010853384,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.0010493952,
				"type": "OTHER"
			},
			{
				"name": "air force contingent",
				"salience": 0.0010493952,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0010493952,
				"type": "OTHER"
			},
			{
				"name": "military help",
				"salience": 0.0010493952,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0010493952,
				"type": "ORGANIZATION"
			},
			{
				"name": "war planes",
				"salience": 0.0010493952,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0010493952,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00090531836,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.00090531836,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0008868647,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03k9hn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Public_Opinion_Research_Center"
				},
				"name": "VTSIOM",
				"salience": 0.0008868647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.0008868647,
				"type": "LOCATION"
			},
			{
				"name": "poll",
				"salience": 0.00083957973,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0007839307,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b6tz8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Levada_Center"
				},
				"name": "Levada Center",
				"salience": 0.00061714416,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/58173f89c3618814488b4610.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:22:23.760+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Half Of Russians Fear Syria Could Spark WW3 11/02/2016 \nRUSSIA TODAY Almost half of all respondents in a recent Russian opinion poll said they feared that the aggravation of relations between Russia and the West caused by the ongoing crisis in Syria could develop into a global military conflict. \nThe share of those who see the probability of World War Three in the near future as high or very high is now at 48 percent and those who appraise it as low or very low comprise 42 percent of society, the privately-owned public opinion research center Levada reported on Monday. The remaining 10 percent of respondents said they couldn’t give a simple answer to the question. \nWhen researchers asked citizens if they considered it possible that Russia and the West would eventually find a mutually acceptable solution to the crisis, 35 percent answered that this scenario was likely or very likely. Thirty-nine percent evaluate the probability of such an outcome as low or very low and 26 percent said that they couldn’t answer the question. \nJust over half – 52 percent – of Russians said they approve of their country’s involvement in the Syrian conflict and 26 percent said they had a negative or sharply negative attitude to this. Just under a quarter – 23 percent – couldn’t answer the question about their personal view on the subject. Those who thought that Russia should continue the operation and those who thought that airstrikes should be stopped were divided 49 percent against 28 percent respectively, with 24 percent finding the question too difficult to answer. \nThe level of awareness about the situation in Syria and the Russian Air Force operation against Islamic State (IS, formerly ISIS/ISIL) terrorists there remained fairly high. Eighteen percent said they were very closely following developments in Syria and 64 percent revealed partial familiarity with the issue. Just under a fifth – 17 percent – said that they were not interested in news about Syria. \nA similar poll conducted a year ago by the independent Levada Center showed that over 70 percent of Russian citizens supported the air operations against IS terrorists in Syria, and almost a half of them agreed that it was right for Russia to support the government of Syria’s democratically-elected President Bashar Assad. \nA different poll conducted earlier this month by the state-run research center VTSIOM showed that 73 percent of Russians believed that Western criticism of the air force’s counter-terrorism operation in Aleppo, Syria, was ungrounded and prejudiced. Only 6 percent said the allegations of wrongdoing on the part of the Russian military have some basis in reality. \nRussia first deployed an air force contingent in Syria in 2015, after receiving a request for military help from the Syrian government, which is currently battling Islamic State and affiliated groups. Russian war planes began launching airstrikes on terrorists in Syria on September 30, 2015. Their work has aided the Syrian military in achieving considerable success in driving jihadist forces out of the country.",
		"thread_title": "Half Of Russians Fear Syria Could Spark WW3",
		"title": "Half Of Russians Fear Syria Could Spark WW3",
		"type": "bs",
		"uuid": "300be09af2ffbb36147f0bdc82faa765e7881864"
	},
	"-KhIhDq2XSU1CtHk5VMR": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:22:24.792+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01rhh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marc_Rich"
				},
				"name": "Marcell David Reich",
				"salience": 0.1957499,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.15591788,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.11327558,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "William J. Clinton Foundation",
				"salience": 0.10280756,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.061547015,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0465sdr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Holder"
				},
				"name": "Eric Holder",
				"salience": 0.05324767,
				"type": "PERSON"
			},
			{
				"name": "materials",
				"salience": 0.02916124,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.021616003,
				"type": "EVENT"
			},
			{
				"name": "pardon",
				"salience": 0.01462224,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.012734416,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.011783692,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.011102257,
				"type": "EVENT"
			},
			{
				"name": "pardon",
				"salience": 0.010650112,
				"type": "EVENT"
			},
			{
				"name": "documents",
				"salience": 0.010194995,
				"type": "WORK_OF_ART"
			},
			{
				"name": "FBI Releases Clinton Foundation Investigation Records",
				"salience": 0.009455636,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "DAILY CALLER",
				"salience": 0.0078585,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0074818702,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.007446827,
				"type": "PERSON"
			},
			{
				"name": "Denise",
				"salience": 0.0067054923,
				"type": "PERSON"
			},
			{
				"name": "tax evasion",
				"salience": 0.006524106,
				"type": "OTHER"
			},
			{
				"name": "Roger Adams",
				"salience": 0.0047060587,
				"type": "PERSON"
			},
			{
				"name": "release",
				"salience": 0.0045254715,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pardon",
				"salience": 0.00439782,
				"type": "EVENT"
			},
			{
				"name": "reading room",
				"salience": 0.0041126627,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02t27n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_of_Information_Act_(United_States)"
				},
				"name": "FOIA",
				"salience": 0.0037054468,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0036359113,
				"type": "LOCATION"
			},
			{
				"name": "dump",
				"salience": 0.0034657468,
				"type": "OTHER"
			},
			{
				"name": "entry",
				"salience": 0.0034000087,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.003106301,
				"type": "EVENT"
			},
			{
				"name": "administration",
				"salience": 0.003106301,
				"type": "ORGANIZATION"
			},
			{
				"name": "email investigation",
				"salience": 0.0030969188,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0030969188,
				"type": "EVENT"
			},
			{
				"name": "Brian Fallon",
				"salience": 0.002872325,
				"type": "PERSON"
			},
			{
				"name": "controversy",
				"salience": 0.0026902615,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0026902615,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0026902615,
				"type": "OTHER"
			},
			{
				"name": "entities",
				"salience": 0.0026902615,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0026267562,
				"type": "EVENT"
			},
			{
				"name": "procedures",
				"salience": 0.0026115596,
				"type": "OTHER"
			},
			{
				"name": "file",
				"salience": 0.0026115596,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.0026115596,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.0026115596,
				"type": "OTHER"
			},
			{
				"name": "pardon standards",
				"salience": 0.0021787155,
				"type": "OTHER"
			},
			{
				"name": "standoff",
				"salience": 0.0020974488,
				"type": "OTHER"
			},
			{
				"name": "field offices",
				"salience": 0.0020974488,
				"type": "PERSON"
			},
			{
				"name": "file",
				"salience": 0.0020014567,
				"type": "OTHER"
			},
			{
				"name": "deputy attorney general",
				"salience": 0.0019700518,
				"type": "PERSON"
			},
			{
				"name": "none",
				"salience": 0.0018867758,
				"type": "OTHER"
			},
			{
				"name": "reprieve",
				"salience": 0.0018867758,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.0018867758,
				"type": "OTHER"
			},
			{
				"name": "handling",
				"salience": 0.0018163872,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0018163872,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0018163872,
				"type": "PERSON"
			},
			{
				"name": "releases",
				"salience": 0.0017952714,
				"type": "WORK_OF_ART"
			},
			{
				"name": "release",
				"salience": 0.0017952714,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.001778866,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.001778866,
				"type": "ORGANIZATION"
			},
			{
				"name": "director",
				"salience": 0.001778866,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.0017142309,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.0016564796,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0016564796,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0016564796,
				"type": "ORGANIZATION"
			},
			{
				"name": "indictments",
				"salience": 0.0015404571,
				"type": "OTHER"
			},
			{
				"name": "merits",
				"salience": 0.0015404571,
				"type": "OTHER"
			},
			{
				"name": "grand jury",
				"salience": 0.0014829773,
				"type": "PERSON"
			},
			{
				"name": "request",
				"salience": 0.0014718926,
				"type": "OTHER"
			},
			{
				"name": "requests",
				"salience": 0.0014718926,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0014718926,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0014340435,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0013290141,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0013290141,
				"type": "WORK_OF_ART"
			},
			{
				"name": "release",
				"salience": 0.0013076944,
				"type": "EVENT"
			},
			{
				"name": "website",
				"salience": 0.0013064124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0011615409,
				"type": "ORGANIZATION"
			},
			{
				"name": "procedures",
				"salience": 0.0011604694,
				"type": "OTHER"
			},
			{
				"name": "procedure",
				"salience": 0.0011604694,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0011508557,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.0011508557,
				"type": "OTHER"
			},
			{
				"name": "Update",
				"salience": 0.0011508557,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025st0_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Bill_Clinton"
				},
				"name": "Clinton White House",
				"salience": 0.0011181906,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.0010720874,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0010720874,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0010720874,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0010680992,
				"type": "EVENT"
			},
			{
				"name": "pardon",
				"salience": 0.0010243573,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.0009769283,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.0009679969,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.00094826653,
				"type": "PERSON"
			},
			{
				"name": "investigation records",
				"salience": 0.0008669236,
				"type": "OTHER"
			},
			{
				"name": "files",
				"salience": 0.0008669236,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0008669236,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.00083821046,
				"type": "OTHER"
			},
			{
				"name": "out",
				"salience": 0.00083821046,
				"type": "EVENT"
			},
			{
				"name": "FIFO",
				"salience": 0.00083821046,
				"type": "OTHER"
			},
			{
				"name": "accordance",
				"salience": 0.00083821046,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.00080088794,
				"type": "OTHER"
			},
			{
				"name": "Records Management Division",
				"salience": 0.00070837646,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.00069944974,
				"type": "ORGANIZATION"
			},
			{
				"name": "bulk",
				"salience": 0.00063414365,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.00062615203,
				"type": "ORGANIZATION"
			},
			{
				"name": "site",
				"salience": 0.00062615203,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/DEM-2016-Convention-F_phil-ap-676x450.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:22:24.792+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "FBI Releases Clinton Foundation Investigation Records 11/02/2016 \nDAILY CALLER \nThe FBI on Tuesday released documents related to a now-closed federal investigation of an alleged pay-to-play scheme involving Bill Clinton and the Clinton Foundation. \nThe documents, which are heavily redacted, regard the investigation of Clinton’s last-minute pardon of Marc Rich, a billionaire fugitive who was wanted in the U.S. for tax evasion. \nThe Jan. 20, 2001 pardon sparked the last controversy to befall the scandal-plagued Clinton administration. Rich’s ex-wife, Denise, donated more than $1 million to various Clinton and Democratic entities, including the Democratic National Committee, Hillary Clinton’s New York Senate campaign and the Clinton Foundation. \nThe release provides little in the way of information that has not already been publicized. But the dump is noteworthy for two reasons. It reminds voters that the Clinton White House and Clinton Foundation were embroiled in an investigation concerning pay-to-play allegations. The Clinton Foundation is reportedly being investigated at the present by multiple FBI field offices. \nIt also comes as the FBI is locked in a bitter standoff with the Clinton Foundation and the Justice Department over FBI director James Comey’s handling of the Hillary Clinton email investigation. \nThe newly-released files include one entry which shows that “the required pardon standards and procedures were not followed” prior to the Rich pardon. \nRoger Adams, the U.S. Pardon Attorney at the time, testified to Congress in Feb. 2001 that “none of the regular procedures were followed” ahead of the Rich reprieve. \nFormer Attorney General Eric Holder is also mentioned in the file. It cites Holder’s testimony that he was the only person who worked at DOJ — he was deputy attorney general at the time — about the Rich pardon. From the FBI’s Clinton Foundation investigation files \nA grand jury was convened to weigh the merits of the case, but no indictments were handed down. Ironically, the law enforcement official who closed the case was FBI director Comey. He served as deputy attorney general in the George W. Bush administration. \nThe FBI’s website suggests that more Clinton Foundation investigation records could be coming in the future. \n“This initial release consists of material from the FBI’s files related to the William J. Clinton Foundation , a non-profit 501(c)(3) organization,” the site reads. “The bulk of these records come from a 2001 FBI investigation into the pardon of Marc Rich (1934-2013), aka Marcell David Reich, by President Clinton in 2001; it was closed in 2005.” \nThe FBI did not respond to a request for more information on future releases. \nUpdate: Clinton campaign press secretary Brian Fallon questioned the release. \nThe FBI issued a statement late Tuesday afternoon saying that the file was released in response to a FOIA request. \n“The FBI’s Records Management Division receives thousands of FOIA requests annually which are processed on a first in, first out (FIFO) basis,” the statement reads. \n“By law, FOIA materials that have been requested three or more times are posted electronically to the FBI’s public reading room shortly after they are processed. Per the standard procedure for FOIA, these materials became available for release and were posted automatically and electronically to the FBI’s public reading room in accordance with the law and established procedures.”",
		"thread_title": "FBI Releases Clinton Foundation Investigation Records",
		"title": "FBI Releases Clinton Foundation Investigation Records",
		"type": "bs",
		"uuid": "9c8b143ef8fa9f302e9cb1dad1e207178cc8ed01"
	},
	"-KhIhEMSAXY1YGxpTMNp": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:36:20.532+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.44683796,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.07167615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0382np",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Bank_of_Russia"
				},
				"name": "Bank of Russia",
				"salience": 0.028153175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.026224747,
				"type": "LOCATION"
			},
			{
				"name": "petrodollar",
				"salience": 0.024290584,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.015032393,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.014018721,
				"type": "OTHER"
			},
			{
				"name": "Gold",
				"salience": 0.011936144,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00803791,
				"type": "LOCATION"
			},
			{
				"name": "Weapon",
				"salience": 0.007992268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.007902139,
				"type": "PERSON"
			},
			{
				"name": "gold",
				"salience": 0.0070239017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cx1t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Society_for_Worldwide_Interbank_Financial_Telecommunication"
				},
				"name": "Society for Worldwide Interbank Financial Telecommunication",
				"salience": 0.0068921605,
				"type": "ORGANIZATION"
			},
			{
				"name": "missile",
				"salience": 0.006593853,
				"type": "OTHER"
			},
			{
				"name": "Gold",
				"salience": 0.0061119413,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.0061119413,
				"type": "OTHER"
			},
			{
				"name": "Jay Syrmopoulos",
				"salience": 0.0060667573,
				"type": "PERSON"
			},
			{
				"name": "Monetary policy",
				"salience": 0.0060355547,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.005805201,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0057708453,
				"type": "WORK_OF_ART"
			},
			{
				"name": "strength",
				"salience": 0.005745135,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0051586065,
				"type": "OTHER"
			},
			{
				"name": "The Free Thought Project",
				"salience": 0.005048718,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gttwyy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Rickards"
				},
				"name": "Jim Rickards",
				"salience": 0.0044557843,
				"type": "PERSON"
			},
			{
				"name": "ruble",
				"salience": 0.0043451404,
				"type": "OTHER"
			},
			{
				"name": "currencies",
				"salience": 0.0042438684,
				"type": "OTHER"
			},
			{
				"name": "Currencies",
				"salience": 0.0042438684,
				"type": "OTHER"
			},
			{
				"name": "grip",
				"salience": 0.0040823976,
				"type": "OTHER"
			},
			{
				"name": "SWIFTNet Network",
				"salience": 0.0038138118,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.003763428,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.003739823,
				"type": "LOCATION"
			},
			{
				"name": "countermoves",
				"salience": 0.003739823,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0036269063,
				"type": "OTHER"
			},
			{
				"name": "comeback",
				"salience": 0.0033984808,
				"type": "EVENT"
			},
			{
				"name": "assets",
				"salience": 0.003319234,
				"type": "OTHER"
			},
			{
				"name": "gold reserves",
				"salience": 0.0031610983,
				"type": "OTHER"
			},
			{
				"name": "world order",
				"salience": 0.003066691,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.003066691,
				"type": "OTHER"
			},
			{
				"name": "backing",
				"salience": 0.003025979,
				"type": "OTHER"
			},
			{
				"name": "self-reliance",
				"salience": 0.0027919991,
				"type": "OTHER"
			},
			{
				"name": "Rate",
				"salience": 0.0027692092,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.0027692092,
				"type": "OTHER"
			},
			{
				"name": "shift",
				"salience": 0.0027692092,
				"type": "EVENT"
			},
			{
				"name": "petrodollar",
				"salience": 0.002685404,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00260589,
				"type": "ORGANIZATION"
			},
			{
				"name": "gold",
				"salience": 0.0025194902,
				"type": "OTHER"
			},
			{
				"name": "thumb",
				"salience": 0.00239821,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00239821,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.00239821,
				"type": "OTHER"
			},
			{
				"name": "Editor",
				"salience": 0.00239821,
				"type": "PERSON"
			},
			{
				"name": "landscape",
				"salience": 0.00239821,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.00239821,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.0022938137,
				"type": "OTHER"
			},
			{
				"name": "alternative",
				"salience": 0.0022326012,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "weapon",
				"salience": 0.0021701497,
				"type": "OTHER"
			},
			{
				"name": "inflation",
				"salience": 0.002155353,
				"type": "OTHER"
			},
			{
				"name": "Comment",
				"salience": 0.001983054,
				"type": "WORK_OF_ART"
			},
			{
				"name": "weapon",
				"salience": 0.0019609153,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0019065479,
				"type": "PERSON"
			},
			{
				"name": "rules",
				"salience": 0.001769273,
				"type": "OTHER"
			},
			{
				"name": "currency",
				"salience": 0.0017484123,
				"type": "OTHER"
			},
			{
				"name": "currency",
				"salience": 0.0017484123,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0016727534,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0015405121,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.0014764897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0014764897,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03vs5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Intercontinental_ballistic_missile"
				},
				"name": "ICBM",
				"salience": 0.0014764897,
				"type": "ORGANIZATION"
			},
			{
				"name": "Next World War Will Be Fought",
				"salience": 0.0014764897,
				"type": "EVENT"
			},
			{
				"name": "ruble",
				"salience": 0.0014584857,
				"type": "OTHER"
			},
			{
				"name": "ruble",
				"salience": 0.0014584857,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.0014425332,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0014224158,
				"type": "LOCATION"
			},
			{
				"name": "euro symbol",
				"salience": 0.0013670843,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.0013670843,
				"type": "OTHER"
			},
			{
				"name": "monetary policy",
				"salience": 0.0012681833,
				"type": "OTHER"
			},
			{
				"name": "transaction",
				"salience": 0.0012629713,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.0012629713,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0012629713,
				"type": "OTHER"
			},
			{
				"name": "correspondent banks",
				"salience": 0.0012591524,
				"type": "ORGANIZATION"
			},
			{
				"name": "currency",
				"salience": 0.001225992,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0012249935,
				"type": "OTHER"
			},
			{
				"name": "stockpile",
				"salience": 0.0012149862,
				"type": "OTHER"
			},
			{
				"name": "trade policy",
				"salience": 0.0012129466,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0011809822,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0s8wz2z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Development_Bank"
				},
				"name": "New Development Bank",
				"salience": 0.0011733386,
				"type": "ORGANIZATION"
			},
			{
				"name": "relationship",
				"salience": 0.0011403527,
				"type": "OTHER"
			},
			{
				"name": "paradigm shift",
				"salience": 0.0011403527,
				"type": "OTHER"
			},
			{
				"name": "dollar sign",
				"salience": 0.0011403527,
				"type": "OTHER"
			},
			{
				"name": "pound sign",
				"salience": 0.0011403527,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0011403527,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.0011403527,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/011185q1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_Infrastructure_Investment_Bank"
				},
				"name": "Asian Infrastructure Investment Bank",
				"salience": 0.0011153143,
				"type": "ORGANIZATION"
			},
			{
				"name": "gold",
				"salience": 0.0010776627,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.0010776627,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.0010776627,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.0010776627,
				"type": "OTHER"
			},
			{
				"name": "gold reserves",
				"salience": 0.0010710809,
				"type": "OTHER"
			},
			{
				"name": "designation",
				"salience": 0.0010520956,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0010398589,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0010398589,
				"type": "LOCATION"
			},
			{
				"name": "monetary policy",
				"salience": 0.0010353276,
				"type": "OTHER"
			},
			{
				"name": "state policy",
				"salience": 0.0010353276,
				"type": "OTHER"
			},
			{
				"name": "state policy",
				"salience": 0.0010353276,
				"type": "OTHER"
			},
			{
				"name": "state policy",
				"salience": 0.0010353276,
				"type": "OTHER"
			},
			{
				"name": "petrodollar",
				"salience": 0.0010226481,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0010226481,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0010052824,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.0009874628,
				"type": "OTHER"
			},
			{
				"name": "sectors",
				"salience": 0.0009874628,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0009874628,
				"type": "ORGANIZATION"
			},
			{
				"name": "individuals",
				"salience": 0.0009874628,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.0009874628,
				"type": "OTHER"
			},
			{
				"name": "burden",
				"salience": 0.0009874628,
				"type": "OTHER"
			},
			{
				"name": "hierarchy",
				"salience": 0.0009874628,
				"type": "OTHER"
			},
			{
				"name": "deterioration",
				"salience": 0.0009874628,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0009874628,
				"type": "WORK_OF_ART"
			},
			{
				"name": "weapons",
				"salience": 0.00096412963,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0009434961,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0009227663,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0008922032,
				"type": "EVENT"
			},
			{
				"name": "warfare",
				"salience": 0.0008855318,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0008855318,
				"type": "OTHER"
			},
			{
				"name": "banking institutions",
				"salience": 0.0008855318,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0008855318,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0008855318,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0008855318,
				"type": "OTHER"
			},
			{
				"name": "member institutions",
				"salience": 0.0008855318,
				"type": "ORGANIZATION"
			},
			{
				"name": "chart",
				"salience": 0.00088491326,
				"type": "OTHER"
			},
			{
				"name": "alternative",
				"salience": 0.0008627522,
				"type": "OTHER"
			},
			{
				"name": "payment orders",
				"salience": 0.000852476,
				"type": "OTHER"
			},
			{
				"name": "payment system",
				"salience": 0.000852476,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.000852476,
				"type": "ORGANIZATION"
			},
			{
				"name": "transaction",
				"salience": 0.000852476,
				"type": "OTHER"
			},
			{
				"name": "transactions",
				"salience": 0.000852476,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00084807543,
				"type": "OTHER"
			},
			{
				"name": "chart",
				"salience": 0.00084114587,
				"type": "OTHER"
			},
			{
				"name": "state rubles",
				"salience": 0.00083485607,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0008305464,
				"type": "OTHER"
			},
			{
				"name": "gold reserve",
				"salience": 0.00082067796,
				"type": "OTHER"
			},
			{
				"name": "reserves",
				"salience": 0.00082067796,
				"type": "OTHER"
			},
			{
				"name": "reserves",
				"salience": 0.00082067796,
				"type": "OTHER"
			},
			{
				"name": "reserves",
				"salience": 0.00082067796,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03y48",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Monetary_Fund"
				},
				"name": "International Monetary Fund",
				"salience": 0.0008123129,
				"type": "ORGANIZATION"
			},
			{
				"name": "stocks",
				"salience": 0.00079954235,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.00079954235,
				"type": "ORGANIZATION"
			},
			{
				"name": "book",
				"salience": 0.00079954235,
				"type": "WORK_OF_ART"
			},
			{
				"name": "gold",
				"salience": 0.0007848807,
				"type": "OTHER"
			},
			{
				"name": "state monetary assets",
				"salience": 0.0007825206,
				"type": "OTHER"
			},
			{
				"name": "policymaking",
				"salience": 0.0007734126,
				"type": "OTHER"
			},
			{
				"name": "stranglehold",
				"salience": 0.00076969515,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.00076969515,
				"type": "WORK_OF_ART"
			},
			{
				"name": "compliance",
				"salience": 0.00076969515,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.00076969515,
				"type": "OTHER"
			},
			{
				"name": "processing",
				"salience": 0.00076969515,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00076969515,
				"type": "OTHER"
			},
			{
				"name": "ear",
				"salience": 0.000728356,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.000728356,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05q4058",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Currency_Wars"
				},
				"name": "Currency Wars",
				"salience": 0.0007263801,
				"type": "WORK_OF_ART"
			},
			{
				"name": "weapon of choice",
				"salience": 0.00072021934,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0007101142,
				"type": "EVENT"
			},
			{
				"name": "shorthand",
				"salience": 0.0007101142,
				"type": "OTHER"
			},
			{
				"name": "bonds",
				"salience": 0.0006923291,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0006923291,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0006923291,
				"type": "LOCATION"
			},
			{
				"name": "whims",
				"salience": 0.0006923291,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0006923291,
				"type": "OTHER"
			},
			{
				"name": "warfare campaigns",
				"salience": 0.0006923291,
				"type": "EVENT"
			},
			{
				"name": "universality",
				"salience": 0.0006923291,
				"type": "OTHER"
			},
			{
				"name": "turnaround",
				"salience": 0.0006923291,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00066648284,
				"type": "LOCATION"
			},
			{
				"name": "resistance bloc",
				"salience": 0.00066648284,
				"type": "OTHER"
			},
			{
				"name": "de-dollarization",
				"salience": 0.00066648284,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.00066648284,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.00066648284,
				"type": "LOCATION"
			},
			{
				"name": "hegemony",
				"salience": 0.00066648284,
				"type": "OTHER"
			},
			{
				"name": "clearing",
				"salience": 0.00066648284,
				"type": "EVENT"
			},
			{
				"name": "build-up",
				"salience": 0.00065270584,
				"type": "OTHER"
			},
			{
				"name": "build-up",
				"salience": 0.00065270584,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.00065270584,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.00062553136,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06wzv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Satan"
				},
				"name": "SATAN",
				"salience": 0.0006077709,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0006077709,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.00059769227,
				"type": "LOCATION"
			},
			{
				"name": "gold",
				"salience": 0.0005863037,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.0005863037,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00056517654,
				"type": "ORGANIZATION"
			},
			{
				"name": "peculiarities",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "layman",
				"salience": 0.00056517654,
				"type": "PERSON"
			},
			{
				"name": "priority",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00056517654,
				"type": "ORGANIZATION"
			},
			{
				"name": "military arsenal",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "price stability",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "framework",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.00056517654,
				"type": "PERSON"
			},
			{
				"name": "well-being",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.00056517654,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0005632655,
				"type": "OTHER"
			},
			{
				"name": "paradigm",
				"salience": 0.0005465174,
				"type": "OTHER"
			},
			{
				"name": "fiat currency",
				"salience": 0.00054451945,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0005440758,
				"type": "OTHER"
			},
			{
				"name": "lockup",
				"salience": 0.0005440758,
				"type": "PERSON"
			},
			{
				"name": "dollar",
				"salience": 0.0005400068,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.00053044804,
				"type": "PERSON"
			},
			{
				"name": "weapon",
				"salience": 0.00052452163,
				"type": "WORK_OF_ART"
			},
			{
				"name": "weapons",
				"salience": 0.00052452163,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00048756087,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.00048756087,
				"type": "OTHER"
			},
			{
				"name": "competition",
				"salience": 0.00048756087,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03jyp3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barrick_Gold"
				},
				"name": "Barrick Gold",
				"salience": 0.0004751877,
				"type": "ORGANIZATION"
			},
			{
				"name": "Corbett Report",
				"salience": 0.00047371682,
				"type": "WORK_OF_ART"
			},
			{
				"name": "holding",
				"salience": 0.0004579204,
				"type": "EVENT"
			},
			{
				"name": "state gold reserves",
				"salience": 0.00044646332,
				"type": "OTHER"
			},
			{
				"name": "reserves",
				"salience": 0.00044646332,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00044280142,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.00042570118,
				"type": "OTHER"
			},
			{
				"name": "total",
				"salience": 0.00042217295,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.00042217295,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.00042217295,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.00042217295,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.00041542112,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "U.K.",
				"salience": 0.00041542112,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western",
				"salience": 0.00041018517,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gyrf98",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BRICS"
				},
				"name": "BRICS",
				"salience": 0.00041018517,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01sf8y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington_Consensus"
				},
				"name": "Washington Consensus",
				"salience": 0.00041018517,
				"type": "ORGANIZATION"
			},
			{
				"name": "currency",
				"salience": 0.00040674148,
				"type": "OTHER"
			},
			{
				"name": "writing",
				"salience": 0.00040128766,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0003962298,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09gd5v1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Business_Insider"
				},
				"name": "Business Insider",
				"salience": 0.0003951547,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0003932662,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.00037831796,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Goldstrike",
				"salience": 0.00036083328,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0003583466,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0003583466,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vk52z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Bank"
				},
				"name": "World Bank",
				"salience": 0.00035753314,
				"type": "ORGANIZATION"
			},
			{
				"name": "back",
				"salience": 0.00035506923,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01r2l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinese_language"
				},
				"name": "Chinese",
				"salience": 0.00033233728,
				"type": "LOCATION"
			},
			{
				"name": "opportunity",
				"salience": 0.0003275783,
				"type": "OTHER"
			},
			{
				"name": "custody",
				"salience": 0.0003275783,
				"type": "OTHER"
			},
			{
				"name": "house of cards",
				"salience": 0.0003275783,
				"type": "LOCATION"
			},
			{
				"name": "gold assets",
				"salience": 0.00031798237,
				"type": "OTHER"
			},
			{
				"name": "tyrants",
				"salience": 0.0003074472,
				"type": "PERSON"
			},
			{
				"name": "bureaucracies",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0003074472,
				"type": "WORK_OF_ART"
			},
			{
				"name": "corporations",
				"salience": 0.0003074472,
				"type": "ORGANIZATION"
			},
			{
				"name": "silver",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "hedging",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0003074472,
				"type": "OTHER"
			},
			{
				"name": "uptick",
				"salience": 0.0002959672,
				"type": "EVENT"
			},
			{
				"name": "gold holdings",
				"salience": 0.00029375346,
				"type": "LOCATION"
			},
			{
				"name": "warfare",
				"salience": 0.00029375346,
				"type": "OTHER"
			},
			{
				"name": "state holdings",
				"salience": 0.00029375346,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00029375346,
				"type": "OTHER"
			},
			{
				"name": "output",
				"salience": 0.00026522053,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00026522053,
				"type": "WORK_OF_ART"
			},
			{
				"name": "strategy",
				"salience": 0.00026522053,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.00026522053,
				"type": "PERSON"
			},
			{
				"name": "mine",
				"salience": 0.00026522053,
				"type": "OTHER"
			},
			{
				"name": "output",
				"salience": 0.00026522053,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.00026522053,
				"type": "OTHER"
			},
			{
				"name": "gold mine",
				"salience": 0.00026522053,
				"type": "LOCATION"
			},
			{
				"name": "effort",
				"salience": 0.0002446852,
				"type": "OTHER"
			},
			{
				"name": "equivalent",
				"salience": 0.0002296476,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.0002296476,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.00021494919,
				"type": "LOCATION"
			},
			{
				"name": "gold reserves",
				"salience": 0.00017911755,
				"type": "OTHER"
			},
			{
				"name": "Turquoise Ridge",
				"salience": 0.00014132353,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/clip_image001_thumb2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:36:20.532+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Russia’s Most Potent Weapon: “Hoarding Gold” 11/02/2016 \nSHTFPLAN.COM \nThis article was written by Jay Syrmopoulos and originally published at The Free Thought Project . \nEditor’s Comment: He who holds the gold makes the rules? Fresh attempts at containing Russia and continuing the empire have been met with countermoves. Russia appears to be building strength in every way. Putin and his country have no intention of being under the American thumb, and are developing rapid resistance as the U.S. petrodollar loses its grip and China, Russia and the East shift into new currencies and shifting world order. \nWhat lies ahead? It will be a strong hand for the countries that have the most significant backing in gold and hard assets; and China and Russia have positioned themselves very well. Prepare for a changing economic landscape, and one in which self-reliance might be all we have. \nRussia is Hoarding Gold at an Alarming Rate — The Next World War Will Be Fought with Currencies \nby Jay Syrmopoulos \nWith all eyes on Russia’s unveiling their latest nuclear intercontinental ballistic missile (ICBM), which NATO has dubbed the “SATAN” missile , as tensions with the U.S. increase, Moscow’s most potent “weapon” may be something drastically different. \nThe rapidly evolving geopolitical “weapon” brandished by Russia is an ever increasing stockpile of gold, as well as Russia’s native currency, the ruble. \nTake a look at the symbol below, as it could soon come to change the entire hierarchy of the international order – potentially ushering in a complete international paradigm shift – and much sooner than you might think. \nimage: http://thefreethoughtproject.com/wp-content/uploads/2016/10/bankofrussia-e1475520013798.png \nThe symbol is the new designation of the Russian ruble, Russia’s national currency. \nSimilar to how the U.S. uses the dollar sign ($), the U.K. uses the pound sign (£), and the European Union uses the euro symbol (€), Russia is about to begin exporting its symbol internationally. \nAfter the failed “reset” in U.S./Russian relations by the Obama administration, and the continued deterioration of the countries relationship, Washington began targeting entire sectors of the Russian economy, as well as specific individuals, meant to impose an economic burden so severe that it would force Moscow into compliance. \nInstead of decimating Russia, what it precipitated was a Russian response of gradually weaning themselves off of the hegemony of the U.S. petrodollar, and working with China to create an alternative to the SWIFT payment system that isn’t solely controlled by Western interests (see Asian Infrastructure Investment Bank , New Development Bank). \nAccording to the Corbett Report : \nNew reports indicate that China is ready to launch its SWIFT alternative, and for those who have their ear to the ground this is the most significant move yet in the unfolding process of de-dollarization that is seeing the BRICS-led “resistance bloc” breaking away from the financial stranglehold of the US-led “Washington Consensus.” \nFor those who don’t know, SWIFT stands for the Society for Worldwide Interbank Financial Telecommunication and is shorthand for the SWIFTNet Network that is used by over 10,500 financial institutions in 215 countries and territories to transmit financial transaction data around the world. SWIFT does not do any of the clearing or processing for these transactions itself, but instead sends the payment orders that are then settled by correspondent banks of the member institutions. Still, given the system’s near universality in the financial system, it means that virtually every international transaction between banking institutions goes through the SWIFT network. \nThis is why de-listing from the SWIFT network remains one of the primary financial weapons wielded by the US and its allies in their increasingly important financial warfare campaigns. \nRecently, financial guru Jim Rickards, author of the book “Currency Wars,” wrote that “Russia is poised for a major comeback in its economy. Russian bonds and stocks and the Russian currency, the ruble, will all benefit.” Rickards believes a “strong turnaround” is coming within Russia, and that this comeback will benefit the ruble. \nWhile still suffering from the economic warfare being waged by the U.S., Russia has realized that as long they are subservient to the petrodollar, there remains a clear and present danger of the Russian economy being devastated by the whims of Washington. \nThe Bank of Russia, that nation’s central bank, is extremely clear about its mission, and monetary policy declaring on its website: \nMonetary policy constitutes an integral part of the state policy and is aimed at enhancing well-being of Russian citizens. The Bank of Russia implements monetary policy in the framework of inflation-targeting regime, and sees price stability, albeit sustainably low inflation, as its priority. Given structural peculiarities of the Russian economy, the target is to reduce inflation to 4% by 2017 and maintain it within that range in the medium run. \nIn layman’s terms, that means that monetary policy, similar to nuclear weapons and the military, are “an integral part of the state policy” in Russia. While many analysts have noted the increased build-up in Russia’s military arsenal, seemingly few have highlighted the massive build-up of Russian gold reserves over the past decade. \nBelow is a chart showing Russian gold reserves between 1994 and last year, 2015: \nSince 2006, there has been a year-on-year increase that reveals a significant upward trend. The chart clearly reveals that Russia’s state policy of increasing state monetary assets, in the form of gold. Additionally, the Russian government has been converting state rubles into gold assets. From 2006 to 2015, Russia’s state holdings of gold tripled. \nWithin just the past year Russia has substantially increased its gold holdings \nAccording to the Business Insider : \nIn July of this year, the central bank of Russia added 200,000 ounces of gold to its reserves. The one-month uptick in Russian gold reserves — 200,000 ounces — is approximately equal to the entire annual output of Barrick Gold’s Turquoise Ridge gold mine in Nevada. \nAt that same rate — 200,000 ounces per month — in a mere five months, Russia would add to state gold reserves the equivalent of the entire annual output of Barrick’s massive Goldstrike mine in Nevada. \nCurrently, Russian gold reserves rank seventh in the world. It’s clear that there is a concerted effort by Russian authorities to build up the country’s gold reserves as part of a national strategy to negate the effects of economic warfare waged by the United States. \nRickards, in his 2011 book “Currency Wars,” theorized that Russia and China could combine their gold reserves to form a global gold-backed currency to compete against the U.S. dollar. Currently, Russian reserves stand at roughly 1,500 tonnes, with Chinese reserves totaling over 1,800 tonnes (according to China — it’s likely more), which would amount to a combined total of roughly 3,300 tonnes of gold. \nThe U.S. is about to lose overarching control of policymaking within the International Monetary Fund (IMF), thus the U.S. lockup on global gold is about to vanish, according to Business Insider. \nImagine for a moment the distinctly real possibility that Russian-Chinese alliance could exercise indirect (or even direct) control over the IMF’s gold reserve of over 2,800 tonnes. Russian, Chinese and IMF gold combined would equal roughly 6,100 tonnes, and would allow for direct competition with the U.S. gold reserves, estimated at 8,100 tonnes. \nRussia and China have realized that the petrodollar is wielded by Washington as it’s weapon of choice when opposing a well-armed state, and clearly see the writing on the wall – thus working together to create a new global financial paradigm. \nThe reality is that the United States is $20 trillion dollars in debt, and eventually the time will come when the U.S. economy begins to implode — and all the fiat currency people are stuck holding will essentially be worth nothing more than the paper it’s printed on. Hard assets, such as gold and silver, should be bought and taken custody of while there is still an opportunity to do so, as a means of hedging against the potentially disastrous results of the U.S. using the petrodollar as a “weapon.” \nUltimately, the United States, Russia and China are all controlled by centralized power-hungry tyrants attempting to command powerful global bureaucracies like the IMF, the World Bank, SWIFT, New Development Bank and the Asian Infrastructure Investment Bank. \nIt’s not Russian nuclear weapons that people should fear, as the policy of mutually assured destruction essentially voids any benefit of a state launching a first-strike nuclear attack. The true threat to America is our economic house of cards, built upon the back of a neoliberal trade policy that puts the “rights” of corporations over that of people . \nThis article was written by Jay Syrmopoulos and originally published at The Free Thought Project .",
		"thread_title": "Russia’s Most Potent Weapon: “Hoarding Gold”",
		"title": "Russia’s Most Potent Weapon: “Hoarding Gold”",
		"type": "bs",
		"uuid": "ffc9556ad614b43948e1d0ec58ea685be124d540"
	},
	"-KhIhFJIkrBly1GX6lGP": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:36:20.940+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.15465224,
				"type": "ORGANIZATION"
			},
			{
				"name": "killer robots",
				"salience": 0.030803943,
				"type": "OTHER"
			},
			{
				"name": "China Airport Security Robot",
				"salience": 0.024785351,
				"type": "OTHER"
			},
			{
				"name": "factors",
				"salience": 0.024407836,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.024046294,
				"type": "OTHER"
			},
			{
				"name": "replacement",
				"salience": 0.016334131,
				"type": "OTHER"
			},
			{
				"name": "robotics",
				"salience": 0.015792536,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.015658703,
				"type": "PERSON"
			},
			{
				"name": "robots",
				"salience": 0.014639824,
				"type": "OTHER"
			},
			{
				"name": "attacker robot",
				"salience": 0.012818579,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.012783794,
				"type": "LOCATION"
			},
			{
				"name": "Gamma 2 Robotics",
				"salience": 0.0120627675,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01n13b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Xinhua_News_Agency"
				},
				"name": "Xinhua",
				"salience": 0.011878729,
				"type": "ORGANIZATION"
			},
			{
				"name": "workforce",
				"salience": 0.011322239,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.011322239,
				"type": "OTHER"
			},
			{
				"name": "robots",
				"salience": 0.011014011,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.01090958,
				"type": "OTHER"
			},
			{
				"name": "robots",
				"salience": 0.009828874,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.009025391,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.008609878,
				"type": "LOCATION"
			},
			{
				"name": "drone",
				"salience": 0.008604516,
				"type": "OTHER"
			},
			{
				"name": "human-machine interface",
				"salience": 0.008524428,
				"type": "OTHER"
			},
			{
				"name": "news agency",
				"salience": 0.007751636,
				"type": "ORGANIZATION"
			},
			{
				"name": "sales",
				"salience": 0.00740171,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.00740171,
				"type": "OTHER"
			},
			{
				"name": "record sales",
				"salience": 0.00740171,
				"type": "OTHER"
			},
			{
				"name": "robots",
				"salience": 0.007254149,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0071794507,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.006684033,
				"type": "LOCATION"
			},
			{
				"name": "Robot security guards",
				"salience": 0.006684033,
				"type": "PERSON"
			},
			{
				"name": "police robots",
				"salience": 0.006514976,
				"type": "OTHER"
			},
			{
				"name": "prisons",
				"salience": 0.0057888995,
				"type": "LOCATION"
			},
			{
				"name": "units",
				"salience": 0.0057888995,
				"type": "LOCATION"
			},
			{
				"name": "growth",
				"salience": 0.0057888995,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0057888995,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0057888995,
				"type": "OTHER"
			},
			{
				"name": "graphic",
				"salience": 0.0057888995,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0057888995,
				"type": "OTHER"
			},
			{
				"name": "slowdown",
				"salience": 0.0057888995,
				"type": "EVENT"
			},
			{
				"name": "care facilities",
				"salience": 0.0057888995,
				"type": "LOCATION"
			},
			{
				"name": "robotics industry",
				"salience": 0.0057888995,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0057888995,
				"type": "ORGANIZATION"
			},
			{
				"name": "range",
				"salience": 0.0057888995,
				"type": "OTHER"
			},
			{
				"name": "uses",
				"salience": 0.0057888995,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0055275676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0179dd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Transportation_Security_Administration"
				},
				"name": "TSA",
				"salience": 0.00547298,
				"type": "ORGANIZATION"
			},
			{
				"name": "presence",
				"salience": 0.005467301,
				"type": "OTHER"
			},
			{
				"name": "robots",
				"salience": 0.005391606,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.004602469,
				"type": "PERSON"
			},
			{
				"name": "robots",
				"salience": 0.0043991576,
				"type": "OTHER"
			},
			{
				"name": "robot",
				"salience": 0.0043991576,
				"type": "OTHER"
			},
			{
				"name": "supercomputer",
				"salience": 0.0042789616,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "security",
				"salience": 0.0042208317,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.004211825,
				"type": "OTHER"
			},
			{
				"name": "HIT Robot Group",
				"salience": 0.004173261,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gamma 2 Robotics",
				"salience": 0.0040119453,
				"type": "ORGANIZATION"
			},
			{
				"name": "development",
				"salience": 0.0038794125,
				"type": "OTHER"
			},
			{
				"name": "robot",
				"salience": 0.003730991,
				"type": "OTHER"
			},
			{
				"name": "security robot",
				"salience": 0.003730991,
				"type": "OTHER"
			},
			{
				"name": "Chen Deqiang",
				"salience": 0.0036302323,
				"type": "PERSON"
			},
			{
				"name": "device",
				"salience": 0.0036151174,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sighting telescope",
				"salience": 0.0035989787,
				"type": "OTHER"
			},
			{
				"name": "ordnance disposal",
				"salience": 0.0034647058,
				"type": "OTHER"
			},
			{
				"name": "supervision",
				"salience": 0.0033004726,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.0033004726,
				"type": "PERSON"
			},
			{
				"name": "intruders",
				"salience": 0.0030721324,
				"type": "PERSON"
			},
			{
				"name": "capabilities",
				"salience": 0.00304917,
				"type": "OTHER"
			},
			{
				"name": "security patrol",
				"salience": 0.00304917,
				"type": "OTHER"
			},
			{
				"name": "models",
				"salience": 0.00304917,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "weapons",
				"salience": 0.00304917,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.002959909,
				"type": "OTHER"
			},
			{
				"name": "sorts",
				"salience": 0.0029383497,
				"type": "OTHER"
			},
			{
				"name": "robots",
				"salience": 0.002932486,
				"type": "OTHER"
			},
			{
				"name": "killer robots",
				"salience": 0.0027874976,
				"type": "OTHER"
			},
			{
				"name": "gases",
				"salience": 0.0027531881,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0027531881,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0027531881,
				"type": "LOCATION"
			},
			{
				"name": "security guard",
				"salience": 0.0027531881,
				"type": "PERSON"
			},
			{
				"name": "production",
				"salience": 0.0027531881,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0027531881,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0027531881,
				"type": "OTHER"
			},
			{
				"name": "latest",
				"salience": 0.0027531881,
				"type": "OTHER"
			},
			{
				"name": "force multiplier",
				"salience": 0.0026722748,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0024833519,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0023948147,
				"type": "OTHER"
			},
			{
				"name": "mass roll-out",
				"salience": 0.0023841201,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.0023841201,
				"type": "WORK_OF_ART"
			},
			{
				"name": "form",
				"salience": 0.0023841201,
				"type": "OTHER"
			},
			{
				"name": "motion",
				"salience": 0.0023841201,
				"type": "OTHER"
			},
			{
				"name": "throttle",
				"salience": 0.0023841201,
				"type": "OTHER"
			},
			{
				"name": "smoke",
				"salience": 0.0023841201,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.0023841201,
				"type": "LOCATION"
			},
			{
				"name": "heat",
				"salience": 0.0023841201,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0023841201,
				"type": "PERSON"
			},
			{
				"name": "Infrastructure",
				"salience": 0.0023841201,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.0023841201,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.002336485,
				"type": "OTHER"
			},
			{
				"name": "cloud services",
				"salience": 0.0022779836,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0022279406,
				"type": "OTHER"
			},
			{
				"name": "reconnaissance",
				"salience": 0.0022279406,
				"type": "OTHER"
			},
			{
				"name": "cameras",
				"salience": 0.0022231839,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "source",
				"salience": 0.0021929643,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.002138054,
				"type": "PERSON"
			},
			{
				"name": "airports",
				"salience": 0.002138054,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.002109642,
				"type": "OTHER"
			},
			{
				"name": "scouts",
				"salience": 0.0020737587,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01914",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beijing"
				},
				"name": "Beijing",
				"salience": 0.002068134,
				"type": "LOCATION"
			},
			{
				"name": "robot model",
				"salience": 0.002058254,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "weapons",
				"salience": 0.002058254,
				"type": "OTHER"
			},
			{
				"name": "patrol",
				"salience": 0.002058254,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.002058254,
				"type": "PERSON"
			},
			{
				"name": "robot",
				"salience": 0.0020562157,
				"type": "OTHER"
			},
			{
				"name": "robotics",
				"salience": 0.0020303084,
				"type": "OTHER"
			},
			{
				"name": "robots",
				"salience": 0.0020303084,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0020157176,
				"type": "OTHER"
			},
			{
				"name": "patrols",
				"salience": 0.002006715,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0019463672,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0019304652,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0019304652,
				"type": "ORGANIZATION"
			},
			{
				"name": "deployment",
				"salience": 0.0019304652,
				"type": "EVENT"
			},
			{
				"name": "police force",
				"salience": 0.0019304652,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacker",
				"salience": 0.0019304652,
				"type": "PERSON"
			},
			{
				"name": "threats",
				"salience": 0.0018893722,
				"type": "OTHER"
			},
			{
				"name": "recognition",
				"salience": 0.0018893722,
				"type": "OTHER"
			},
			{
				"name": "supercomputers",
				"salience": 0.0018893722,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "RAMSEE",
				"salience": 0.0018769772,
				"type": "PERSON"
			},
			{
				"name": "RAMSEE",
				"salience": 0.0018769772,
				"type": "OTHER"
			},
			{
				"name": "RAMSEE",
				"salience": 0.0018769772,
				"type": "ORGANIZATION"
			},
			{
				"name": "explosives",
				"salience": 0.0018584093,
				"type": "OTHER"
			},
			{
				"name": "deployment",
				"salience": 0.0018584093,
				"type": "EVENT"
			},
			{
				"name": "gases",
				"salience": 0.0018584093,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06cdcb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dmitry_Rogozin"
				},
				"name": "Dmitry Rogozin",
				"salience": 0.0018540965,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0017902919,
				"type": "WORK_OF_ART"
			},
			{
				"name": "job",
				"salience": 0.0017586087,
				"type": "OTHER"
			},
			{
				"name": "supercomputer connection",
				"salience": 0.0017586087,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0017586087,
				"type": "OTHER"
			},
			{
				"name": "cloud services",
				"salience": 0.0017454592,
				"type": "OTHER"
			},
			{
				"name": "processing capabilities",
				"salience": 0.0017454592,
				"type": "OTHER"
			},
			{
				"name": "learning capabilities",
				"salience": 0.0017454592,
				"type": "OTHER"
			},
			{
				"name": "bomb",
				"salience": 0.0017364494,
				"type": "OTHER"
			},
			{
				"name": "Hexagon Safety",
				"salience": 0.0016947248,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "buyers",
				"salience": 0.0016716317,
				"type": "PERSON"
			},
			{
				"name": "transportation",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0016716317,
				"type": "LOCATION"
			},
			{
				"name": "trigger",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "notions",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "travel",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "agriculture",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "forestry",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "fire fighting",
				"salience": 0.0016716317,
				"type": "OTHER"
			},
			{
				"name": "drone",
				"salience": 0.001667741,
				"type": "OTHER"
			},
			{
				"name": "police drones",
				"salience": 0.001667741,
				"type": "OTHER"
			},
			{
				"name": "drones",
				"salience": 0.001667741,
				"type": "OTHER"
			},
			{
				"name": "drones",
				"salience": 0.001667741,
				"type": "OTHER"
			},
			{
				"name": "drones",
				"salience": 0.001667741,
				"type": "OTHER"
			},
			{
				"name": "EOD",
				"salience": 0.0016092325,
				"type": "OTHER"
			},
			{
				"name": "grenade launchers",
				"salience": 0.0016092325,
				"type": "OTHER"
			},
			{
				"name": "rifles",
				"salience": 0.0016092325,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mission",
				"salience": 0.0016092325,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0016092325,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.0016092325,
				"type": "OTHER"
			},
			{
				"name": "chemicals",
				"salience": 0.0016092325,
				"type": "OTHER"
			},
			{
				"name": "unveiling",
				"salience": 0.0016092325,
				"type": "EVENT"
			},
			{
				"name": "battlefield",
				"salience": 0.0016092325,
				"type": "LOCATION"
			},
			{
				"name": "protest suppression",
				"salience": 0.0015759714,
				"type": "OTHER"
			},
			{
				"name": "cattle-prod",
				"salience": 0.0015759714,
				"type": "OTHER"
			},
			{
				"name": "robot TSA",
				"salience": 0.0015759714,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0015759714,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0015491615,
				"type": "OTHER"
			},
			{
				"name": "robots",
				"salience": 0.001516698,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0014990704,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.001469565,
				"type": "OTHER"
			},
			{
				"name": "human",
				"salience": 0.0014294133,
				"type": "PERSON"
			},
			{
				"name": "human",
				"salience": 0.0014114003,
				"type": "PERSON"
			},
			{
				"name": "systems",
				"salience": 0.0013882673,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0013646493,
				"type": "LOCATION"
			},
			{
				"name": "Image Credit",
				"salience": 0.0013646493,
				"type": "OTHER"
			},
			{
				"name": "tech show",
				"salience": 0.0013646493,
				"type": "EVENT"
			},
			{
				"name": "announcement",
				"salience": 0.0013474522,
				"type": "EVENT"
			},
			{
				"name": "talk",
				"salience": 0.0013137049,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0013038808,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0013038808,
				"type": "WORK_OF_ART"
			},
			{
				"name": "use",
				"salience": 0.0013038808,
				"type": "OTHER"
			},
			{
				"name": "tasers",
				"salience": 0.0013038808,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0013038808,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0012146147,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0012146147,
				"type": "PERSON"
			},
			{
				"name": "drones",
				"salience": 0.0012146147,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0011943186,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0011772568,
				"type": "LOCATION"
			},
			{
				"name": "investigation",
				"salience": 0.0011719976,
				"type": "EVENT"
			},
			{
				"name": "processing power",
				"salience": 0.0011719976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05knkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shenzhen_Bao'an_International_Airport"
				},
				"name": "Shenzhen airport",
				"salience": 0.0010742988,
				"type": "LOCATION"
			},
			{
				"name": "tabloid",
				"salience": 0.0010455716,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0123gq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harbin"
				},
				"name": "Harbin",
				"salience": 0.001028851,
				"type": "LOCATION"
			},
			{
				"name": "Taser corporation",
				"salience": 0.0010193828,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.0010193828,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.0010193828,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0010193828,
				"type": "OTHER"
			},
			{
				"name": "tip-toe",
				"salience": 0.0010193828,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.0010193828,
				"type": "LOCATION"
			},
			{
				"name": "stun gun",
				"salience": 0.0010193828,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Discussion",
				"salience": 0.0010193828,
				"type": "OTHER"
			},
			{
				"name": "World Robot Conference",
				"salience": 0.000990439,
				"type": "EVENT"
			},
			{
				"name": "AnBot",
				"salience": 0.0009699641,
				"type": "PERSON"
			},
			{
				"name": "AnBot",
				"salience": 0.0009699641,
				"type": "OTHER"
			},
			{
				"name": "killing",
				"salience": 0.0009495888,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06fgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robot"
				},
				"name": "Robots",
				"salience": 0.000933477,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00090729835,
				"type": "PERSON"
			},
			{
				"name": "policing",
				"salience": 0.00090729835,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00088750664,
				"type": "OTHER"
			},
			{
				"name": "human-machine interface",
				"salience": 0.00086527603,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00086527603,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0008573628,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0008573628,
				"type": "ORGANIZATION"
			},
			{
				"name": "many",
				"salience": 0.0008573628,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.0008573628,
				"type": "ORGANIZATION"
			},
			{
				"name": "trend",
				"salience": 0.0008573628,
				"type": "OTHER"
			},
			{
				"name": "suppression",
				"salience": 0.0008573628,
				"type": "EVENT"
			},
			{
				"name": "source link",
				"salience": 0.0008573628,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00084655685,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0nbtlq2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tianhe-2"
				},
				"name": "Tianhe-2",
				"salience": 0.0008398821,
				"type": "LOCATION"
			},
			{
				"name": "precision",
				"salience": 0.0008321526,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.00082535174,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.0007909858,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00076781615,
				"type": "OTHER"
			},
			{
				"name": "abuses",
				"salience": 0.00074237864,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.00074237864,
				"type": "OTHER"
			},
			{
				"name": "convergence",
				"salience": 0.00074237864,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.00074237864,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.00074237864,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00074237864,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00074237864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.00074237864,
				"type": "OTHER"
			},
			{
				"name": "author attribution",
				"salience": 0.00074237864,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.00072753907,
				"type": "ORGANIZATION"
			},
			{
				"name": "cloud services",
				"salience": 0.00070931454,
				"type": "OTHER"
			},
			{
				"name": "learning process",
				"salience": 0.00070931454,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.00070931454,
				"type": "WORK_OF_ART"
			},
			{
				"name": "experts",
				"salience": 0.00069675787,
				"type": "PERSON"
			},
			{
				"name": "Examples",
				"salience": 0.0006652602,
				"type": "OTHER"
			},
			{
				"name": "systems development efforts",
				"salience": 0.00064042024,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00064042024,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.00064042024,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.000627362,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.000627362,
				"type": "ORGANIZATION"
			},
			{
				"name": "John Vibes",
				"salience": 0.00061164645,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0005983784,
				"type": "ORGANIZATION"
			},
			{
				"name": "emphasis",
				"salience": 0.0005833888,
				"type": "OTHER"
			},
			{
				"name": "tasks",
				"salience": 0.00055452646,
				"type": "OTHER"
			},
			{
				"name": "execution",
				"salience": 0.00055452646,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00055452646,
				"type": "OTHER"
			},
			{
				"name": "pound",
				"salience": 0.00055452646,
				"type": "OTHER"
			},
			{
				"name": "feature",
				"salience": 0.00055452646,
				"type": "OTHER"
			},
			{
				"name": "ActivistPost.com",
				"salience": 0.0005276401,
				"type": "OTHER"
			},
			{
				"name": "autonomy",
				"salience": 0.0004823063,
				"type": "OTHER"
			},
			{
				"name": "Security Review",
				"salience": 0.0004823063,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6hk5f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Sun_(United_Kingdom)"
				},
				"name": "The Sun",
				"salience": 0.00045687056,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00045687056,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.00045687056,
				"type": "PERSON"
			},
			{
				"name": "Nicholas West",
				"salience": 0.0003973674,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0q4yb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/C-4_(explosive)"
				},
				"name": "C-4",
				"salience": 0.00034125661,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d07ph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wikipedia"
				},
				"name": "Wikipedia",
				"salience": 0.00034125661,
				"type": "OTHER"
			},
			{
				"name": "Internet Cloud Brain",
				"salience": 0.00034125661,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dallas"
				},
				"name": "Dallas",
				"salience": 0.00034125661,
				"type": "LOCATION"
			},
			{
				"name": "People",
				"salience": 0.00028309625,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/FOREIGN201609221412000466856985734-768x512.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:36:20.940+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 16.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "China Airport Security Robot Gives Electroshocks 11/02/2016 \nACTIVIST POST \nWhile debate surrounds the threat of autonomous “killer robots,” the mechanized replacement of humans continues across the workforce. \nThe industrial robotics industry is logging record sales worldwide, and there appears to be no sign of a slowdown. As you can see in the graphic below, 2015 sales surged 12% over a previous record year to reach almost 1/4 million units. \nThere are many factors driving this growth, which you can read about here; but one point worth noting is that the two leading countries are the US and China, with China leading the way. \nThe nature of robotics is also changing, as new developments in artificial intelligence are giving robots an increasing range of potential uses. One key area, of course, is security. Robot security guards have already begun appearing at prisons , care facilities , and schools, in various locations around the world. \nOne U.S. robot company, Gamma 2 Robotics, has designed several models for mass production. Their latest – RAMSEE – can be seen in the video below. A true mass roll-out of this fully autonomous security guard could significantly impact the 1.5 million humans that are currently employed in some form of security patrol. \nRAMSEE advertises the following capabilities: Is a physical presence that autonomously patrols without supervision Provides real-time data: intruders, motion, heat, fire, smoke, gases & more Is a human-machine interface that creates a powerful force multiplier \nSignificantly, Gamma 2 Robotics has partnered with Hexagon Safety & Infrastructure: “the global leader in public safety and security solutions.” \nHowever, RAMSEE is missing one thing: weapons. For that, we have to travel to China, where they seem to have embraced police robots full throttle. \nIn late 2015, I covered an announcement from China’s Xinhua news agency where they announced the development and deployment of 3 weaponized “anti-terrorism” robots that would be far more active than a mere patrol: \n“The toy-sized robots can coordinate with each other on the battlefield,” said the report, following their unveiling at the 2015 World Robot Conference in Beijing. \nThe first model is known as a “reconnaissance” robot, which scouts for poisonous gases, dangerous chemicals and explosives before transmitting its findings back to base.If this initial investigation detects a simple bomb is the source of danger, the second robot model – a small explosive ordnance disposal (EOD) machine – would be sent in to diffuse it. \nBut with other, more complicated threats, an attacker robot would start its mission, armed with “minor-caliber weapons, recoilless rifles and grenade launchers”. \n“With a sighting telescope, a trigger and a safe installed, the attacker can hit its target from a long distance,” Xinhua said. \nThe local police force in Beijing was reported to be among the buyers for the three robots , which are priced at 1.5 million yuan (£156,000) for the set by manufacturers HIT Robot Group, who are based in the northern city of Harbin. \n“Apart from anti-terror operations, they can also be applied in fire fighting, public security, forestry and agriculture,” the company’s sales manager Chen Deqiang said, according to Xinhua. \nIf we have learned anything about anti-terrorism efforts, authorities consider front-line deployment to be areas of public travel. We were given the TSA based on such notions, and have since witnessed its intrusive role in airports, and soon-to-be at other public transportation if authorities have their way. \nChina has gone to the next level with a robot TSA of sorts called AnBot that is equipped with what is essentially a taser-like device that is being fittingly compared to a cattle-prod. \nImage Credit \nIt was first introduced at a tech show earlier in the year, and was speculated to have been designed for protest suppression. For now, its first job is to patrol China’s Shenzhen airport. \nMost alarming, however, is that it is tied to one of the most powerful supercomputers on the planet. \nThe back end of this “intelligent security robot” is l inked to China’s Tianhe-2 supercomputer , where it has access to cloud services . AnBot conducts patrols, recognizes threats and has multiple cameras that use facial recognition. \nThese cloud services give the robots petascale processing power , well beyond onboard processing capabilities in the robot. The supercomputer connection is there “to enhance the intelligent learning capabilities and human-machine interface of these devices,” said the U.S.-China Economic and Security Review, in a report released Tuesday that examines China’s autonomous systems development efforts . [emphasis added] \n( Source ) \nThis link to “cloud services” is a new trend in robot artificial intelligence that also has been referred to as the Wikipedia for Robots – essentially an Internet Cloud Brain. Through robot-to-robot information sharing they can speed up their learning process … autonomously. Examples have included robots that can learn to cook, and robots that can learn the tasks involved in care-giving. However, when applied to policing, things become much more ethically troubling. \nPeople were outraged in the U.S., for example, when a robot in Dallas was used to deliver a pound of C-4 explosive to a U.S. citizen whom the police deemed a sufficient threat worthy of immediate execution. At least, in that case, a human made the decision. But it is being viewed as a tip-toe along the path to the widespread use of “killer robots” much as we have seen with the use of drones. Discussion was once limited to overseas – egregious enough – but there has been a growing voice of those who are urging weaponized domestic police drones. \nAs John Vibes wrote , it might be inevitable: \nThe Taser corporation is planning on building a drone that is equipped with a stun gun, according to a recent report by the Wall Street Journal. \nNot only will the drones be equipped with tasers, but there is also talk of them being autonomous, meaning that an actual human won’t necessarily be needed to fly the drone. \nThis is actually already being done in India , the first country to have approved the use of drones attached with “non-lethal” weapons. And, just this week, British tabloid, The Sun , had a feature entitled “Vladimir Putin’s Russia is preparing an army of robots and drones to take on its enemies, Deputy PM Dmitry Rogozin admits.” Given the available facts, this title no longer seems so deliberately sensational. \nClearly we are entering a potentially dangerous convergence of expanding robotic artificial intelligence along with the political will to continue allowing robots more and more autonomy as they carry out the traditional duties of the military and police. Some experts argue that the precision of robotics will curb many of the abuses we have seen from our military and police. But is that the trend we are actually seeing? Or will automated systems of violent control inevitably lead to even greater industrial-level suppression and killing? \nNicholas West writes for ActivistPost.com . This article may be republished in part or in full with author attribution and source link .",
		"thread_title": "China Airport Security Robot Gives Electroshocks",
		"title": "China Airport Security Robot Gives Electroshocks",
		"type": "bs",
		"uuid": "6e0287202041ffe0588fff3d221014b087e97449"
	},
	"-KhIhFgAAgL3OQUbuMjB": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:47:19.431+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFOs",
				"salience": 0.18578404,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0286w1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Gairy"
				},
				"name": "Eric Gairy",
				"salience": 0.08218824,
				"type": "PERSON"
			},
			{
				"name": "Grenadian UFO",
				"salience": 0.070602186,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.058394823,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/035yg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grenada"
				},
				"name": "Grenada",
				"salience": 0.05153215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.02950879,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04cc1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurt_Waldheim"
				},
				"name": "Kurt Waldheim",
				"salience": 0.02879141,
				"type": "PERSON"
			},
			{
				"name": "Special Political Committee",
				"salience": 0.028776078,
				"type": "ORGANIZATION"
			},
			{
				"name": "Documents",
				"salience": 0.024583483,
				"type": "OTHER"
			},
			{
				"name": "LEE SPEIGEL",
				"salience": 0.020531137,
				"type": "PERSON"
			},
			{
				"name": "speculation",
				"salience": 0.016421907,
				"type": "OTHER"
			},
			{
				"name": "Interest",
				"salience": 0.015398234,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.014066978,
				"type": "PERSON"
			},
			{
				"name": "committee",
				"salience": 0.01308164,
				"type": "ORGANIZATION"
			},
			{
				"name": "UFOs: The Credibility Factor",
				"salience": 0.011518985,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Outer Space Committee",
				"salience": 0.011236093,
				"type": "ORGANIZATION"
			},
			{
				"name": "set",
				"salience": 0.011138777,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.011138777,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conversations",
				"salience": 0.011138777,
				"type": "OTHER"
			},
			{
				"name": "extraterrestrials",
				"salience": 0.011138777,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.009898424,
				"type": "ORGANIZATION"
			},
			{
				"name": "documents",
				"salience": 0.009311061,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w_pp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gordon_Cooper"
				},
				"name": "Gordon Cooper",
				"salience": 0.009254704,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0090685915,
				"type": "LOCATION"
			},
			{
				"name": "interactions",
				"salience": 0.007883745,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.007284657,
				"type": "ORGANIZATION"
			},
			{
				"name": "HUFFINGTON POST Revelations",
				"salience": 0.006865923,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.0065788063,
				"type": "OTHER"
			},
			{
				"name": "items",
				"salience": 0.00569828,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "world",
				"salience": 0.00569828,
				"type": "LOCATION"
			},
			{
				"name": "Richard Petree",
				"salience": 0.0052966587,
				"type": "PERSON"
			},
			{
				"name": "document",
				"salience": 0.0052029155,
				"type": "WORK_OF_ART"
			},
			{
				"name": "UFO presentation",
				"salience": 0.004812515,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.004221172,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03k6g3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Allen_Hynek"
				},
				"name": "J. Allen Hynek",
				"salience": 0.0041086026,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059vf_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jacques_Vall%C3%A9e"
				},
				"name": "Jacques Vallee",
				"salience": 0.0041086026,
				"type": "PERSON"
			},
			{
				"name": "Claude Poher",
				"salience": 0.0041086026,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.003839218,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "U.S. State Department",
				"salience": 0.00350953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0284s71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leonard_H._Stringfield"
				},
				"name": "Leonard Stringfield",
				"salience": 0.0033547874,
				"type": "PERSON"
			},
			{
				"name": "David Saunders",
				"salience": 0.0033547874,
				"type": "PERSON"
			},
			{
				"name": "activities",
				"salience": 0.0032496236,
				"type": "OTHER"
			},
			{
				"name": "Committee",
				"salience": 0.003014652,
				"type": "ORGANIZATION"
			},
			{
				"name": "ambassadors",
				"salience": 0.0030022687,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.0029021965,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0027213548,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.0027109208,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0027109208,
				"type": "PERSON"
			},
			{
				"name": "committee",
				"salience": 0.0026558272,
				"type": "ORGANIZATION"
			},
			{
				"name": "presentation",
				"salience": 0.0025868346,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.002496151,
				"type": "PERSON"
			},
			{
				"name": "document",
				"salience": 0.0024953808,
				"type": "WORK_OF_ART"
			},
			{
				"name": "community",
				"salience": 0.0024613526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0024211234,
				"type": "LOCATION"
			},
			{
				"name": "delegate-adviser",
				"salience": 0.002407879,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.002407879,
				"type": "OTHER"
			},
			{
				"name": "crusade",
				"salience": 0.0023476062,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0023476062,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0023476062,
				"type": "OTHER"
			},
			{
				"name": "documentary record album",
				"salience": 0.0023476062,
				"type": "WORK_OF_ART"
			},
			{
				"name": "American UN",
				"salience": 0.002254469,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0021938533,
				"type": "ORGANIZATION"
			},
			{
				"name": "representatives",
				"salience": 0.0021053609,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0020267977,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.0020163388,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.0020075685,
				"type": "OTHER"
			},
			{
				"name": "COURTESY",
				"salience": 0.0019009864,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0019009864,
				"type": "ORGANIZATION"
			},
			{
				"name": "Topic",
				"salience": 0.0019009864,
				"type": "OTHER"
			},
			{
				"name": "proposal",
				"salience": 0.0018686568,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0018605285,
				"type": "OTHER"
			},
			{
				"name": "presentation",
				"salience": 0.0018605285,
				"type": "EVENT"
			},
			{
				"name": "U.N. Special Political Committee",
				"salience": 0.0018559522,
				"type": "ORGANIZATION"
			},
			{
				"name": "COURTESY",
				"salience": 0.0018300441,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0018300441,
				"type": "EVENT"
			},
			{
				"name": "speakers",
				"salience": 0.0018300441,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.00175388,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0017395526,
				"type": "WORK_OF_ART"
			},
			{
				"name": "countries",
				"salience": 0.0017188375,
				"type": "LOCATION"
			},
			{
				"name": "representatives",
				"salience": 0.0017188375,
				"type": "PERSON"
			},
			{
				"name": "Ambassador",
				"salience": 0.0017188375,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.0016671522,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0016461484,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.0016461484,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.0016461484,
				"type": "PERSON"
			},
			{
				"name": "Uses",
				"salience": 0.0016461484,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0015847103,
				"type": "WORK_OF_ART"
			},
			{
				"name": "handshake deal",
				"salience": 0.0015847103,
				"type": "EVENT"
			},
			{
				"name": "front",
				"salience": 0.0015847103,
				"type": "OTHER"
			},
			{
				"name": "cable",
				"salience": 0.0015519613,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0015519613,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0015519613,
				"type": "EVENT"
			},
			{
				"name": "concern",
				"salience": 0.0015519613,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0015324078,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resolution",
				"salience": 0.001514158,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09d5h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS"
				},
				"name": "CBS Inc.",
				"salience": 0.0014451443,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0014451443,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.0014256194,
				"type": "ORGANIZATION"
			},
			{
				"name": "action",
				"salience": 0.0013899206,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0013899206,
				"type": "OTHER"
			},
			{
				"name": "Misoff",
				"salience": 0.0013639701,
				"type": "PERSON"
			},
			{
				"name": "channels",
				"salience": 0.0013438874,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0013438874,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.0013438874,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0013438874,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0013438874,
				"type": "EVENT"
			},
			{
				"name": "interest",
				"salience": 0.0013045337,
				"type": "OTHER"
			},
			{
				"name": "referral",
				"salience": 0.0012937248,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.0012840513,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0012840513,
				"type": "OTHER"
			},
			{
				"name": "negotiating sessions",
				"salience": 0.0012217752,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01833w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Outer_space"
				},
				"name": "Outer Space",
				"salience": 0.0011701344,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hmrpgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Huffington_Post"
				},
				"name": "Huffington Post",
				"salience": 0.0011701344,
				"type": "ORGANIZATION"
			},
			{
				"name": "member states",
				"salience": 0.0011593679,
				"type": "LOCATION"
			},
			{
				"name": "steps",
				"salience": 0.001069627,
				"type": "OTHER"
			},
			{
				"name": "Morton Gleisner",
				"salience": 0.0010132324,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "USAF",
				"salience": 0.0010132324,
				"type": "ORGANIZATION"
			},
			{
				"name": "activities",
				"salience": 0.0010122973,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0010039089,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0010039089,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0010039089,
				"type": "EVENT"
			},
			{
				"name": "mandate",
				"salience": 0.0010039089,
				"type": "OTHER"
			},
			{
				"name": "capitals",
				"salience": 0.0010039089,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0010039089,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0010039089,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00095853454,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.00093518087,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qd_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Colorado_Boulder"
				},
				"name": "University of Colorado",
				"salience": 0.0008271479,
				"type": "ORGANIZATION"
			},
			{
				"name": "flexibility",
				"salience": 0.0008195363,
				"type": "OTHER"
			},
			{
				"name": "member nations",
				"salience": 0.00080676016,
				"type": "LOCATION"
			},
			{
				"name": "tip",
				"salience": 0.00077899685,
				"type": "OTHER"
			},
			{
				"name": "each",
				"salience": 0.00076917914,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00073113,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.00073113,
				"type": "EVENT"
			},
			{
				"name": "initiative",
				"salience": 0.00073113,
				"type": "OTHER"
			},
			{
				"name": "observations",
				"salience": 0.00073113,
				"type": "OTHER"
			},
			{
				"name": "back burner",
				"salience": 0.00073113,
				"type": "OTHER"
			},
			{
				"name": "evaluation",
				"salience": 0.00073113,
				"type": "OTHER"
			},
			{
				"name": "iceberg",
				"salience": 0.00073113,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.00073113,
				"type": "OTHER"
			},
			{
				"name": "secretary-general",
				"salience": 0.00071651634,
				"type": "PERSON"
			},
			{
				"name": "following",
				"salience": 0.00069856923,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.00069856923,
				"type": "OTHER"
			},
			{
				"name": "representation",
				"salience": 0.00069856923,
				"type": "OTHER"
			},
			{
				"name": "military speakers",
				"salience": 0.000630723,
				"type": "PERSON"
			},
			{
				"name": "cable",
				"salience": 0.000630723,
				"type": "OTHER"
			},
			{
				"name": "concurrence",
				"salience": 0.000630723,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.000630723,
				"type": "EVENT"
			},
			{
				"name": "attempt",
				"salience": 0.000630723,
				"type": "OTHER"
			},
			{
				"name": "The General Assembly",
				"salience": 0.00058729755,
				"type": "ORGANIZATION"
			},
			{
				"name": "introduction",
				"salience": 0.00054613454,
				"type": "EVENT"
			},
			{
				"name": "draft decision",
				"salience": 0.00054613454,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00054613454,
				"type": "OTHER"
			},
			{
				"name": "compromise solution",
				"salience": 0.00054613454,
				"type": "OTHER"
			},
			{
				"name": "flying objects",
				"salience": 0.00042376356,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austria",
				"salience": 0.00033609945,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "USSR",
				"salience": 0.00033609945,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/5813c33d190000ec02c2fb08.jpeg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:47:19.431+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.7,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "WikiLeaks Documents Reveal United Nations Interest In UFOs 11/02/2016 \nHUFFINGTON POST \nRevelations in a set of hacked emails released by WikiLeaks earlier this month have sparked new conversations about UFOs and speculation that extraterrestrials have been visiting Earth. But a very significant ― and possibly overlooked ― group of WikiLeaks items relevant to the topic was released on May 18, 2015. \nWikiLeaks posted more than half a million U.S. State Department diplomatic documents from 1978 detailing America’s interactions with countries all around the world ― including Grenada Prime Minister Eric Gairy’s efforts to organize a United Nations-based committee to research and investigate global UFO reports. \nMany of the documents, written by American UN officials, indicated how closely they were monitoring Grenada’s UFO-related activities. \nOne document , from Nov. 18, 1978, revealed my involvement in helping Grenada to produce a credible UFO presentation. \nI had an opportunity in early 1978 to meet Gairy in New York to present an idea about how I thought the UN would pay attention to his UFO crusade. Through his ambassadors, I gave him a copy of a documentary record album, “UFOs: The Credibility Factor,” that I produced for CBS Inc. in 1975. \nGairy and I met, and after I convinced him I could bring a very credible group of speakers to the UN, he agreed to sponsor my proposal (see image below). Shortly after a handshake deal, he made me a temporary delegate-adviser of Grenada and the rest was, well, history. COURTESY OF LEE SPEIGEL This 1978 letter from Grenada to Lee Speigel confirmed that country’s commitment to sponsor Speigel’s UFO presentation at the United Nations. \nThe following image shows part of the group I brought together in July 1978 to meet with UN Secretary-General Kurt Waldheim. He wanted to know what we were planning to do at our November event in front of the Special Political Committee, which included representatives from the Committee on the Peaceful Uses of Outer Space. COURTESY OF LEE SPEIGEL On July 14, 1978, producer Lee Speigel (now a Huffington Post writer) brought together a group of military, scientific and psychological experts to meet with United Nations Secretary-General Kurt Waldheim to discuss Speigel’s upcoming presentation to the U.N. Special Political Committee later that year. Topic: The importance of establishing an international UFO committee. Pictured from left: USAF astronaut Col. Gordon Cooper, astronomer Jacques Vallee, astronomer/astrophysicist Claude Poher, astronomer J. Allen Hynek, Grenada Prime Minister Sir Eric Gairy, Waldheim, Morton Gleisner of the Special Political Committee, Lee Speigel, researcher Leonard Stringfield and University of Colorado psychologist David Saunders. \nAnother cable posted on WikiLeaks , from Nov. 24, 1978, refers to Ambassador Richard Petree’s meeting with Grenada representatives “to discuss their UFO resolution. Ambassador Petree acknowledged the high level of interest in UFOs among some elements of the private sector and scientific community … and pointed to the budgetary impact as a major concern of the U.S. and other countries.” \nOn Nov. 28, 1978, the day after our presentation at the UN, this document was sent through official channels, detailing the actual UFO event, describing what each of the invited scientific and military speakers had to say to the member nations. \nA few days after that, on Dec. 2, 1978, a follow-up cable was transmitted, including the following: \nSubsequent to the introduction of the Grenadian UFO resolution, Misoff [Mission Officer] has engaged in two separate informal negotiating sessions, which included representation from Austria, USSR and Grenada, in an attempt to arrive at a mutually acceptable compromise solution to the problem. \nA draft decision to be taken by the Special Political Committee (SPC) has been agreed upon by the participants in the informal negotiations, subject to concurrence of their respective capitals. We think referral of the [UFO] matter to the Outer Space Committee (OSC) without a preordained mandate as to what action is to be taken, provides the flexibility the OSC needs to take whatever action it deems appropriate. \nIt will also obviate the need to vote on a resolution (and gamble on the results). \nThe following week brought forth another document , on Dec. 8, 1978, which stated: \n“The General Assembly invites interested member states to take appropriate steps to coordinate on a national level scientific research and investigation into extraterrestrial life, including unidentified flying objects, and to inform the secretary-general of the observations, research and evaluation of such activities.” \nIt was further suggested that Grenada’s views on UFOs could be discussed in 1979. Unfortunately, that didn’t come to pass, as Grenada Prime Minister Gairy was overthrown in a 1979 coup. \nNeedless to say, without the Gairy-based initiative on UFOs, it was quietly relegated to Grenada’s back burner. \nThis is the tip of the UFO-UN iceberg. It shows how the subject of UFOs wasn’t merely officially ridiculed or slapped aside. There was, and perhaps still is, some interest there, just waiting to emerge.",
		"thread_title": "WikiLeaks Documents Reveal United Nations Interest In UFOs",
		"title": "WikiLeaks Documents Reveal United Nations Interest In UFOs",
		"type": "bs",
		"uuid": "b5174e7bcf5638e731f0abd2c2edffb795b7c05a"
	},
	"-KhIhGCKYFHD3qc9pOpO": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T19:14:58.033+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02j3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Des_Moines,_Iowa"
				},
				"name": "Des Moines",
				"salience": 0.07385588,
				"type": "LOCATION"
			},
			{
				"name": "Chad Underwood",
				"salience": 0.045512162,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.039742228,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01g2j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sergeant"
				},
				"name": "Sgt",
				"salience": 0.035823446,
				"type": "PERSON"
			},
			{
				"name": "Anthony ``Tony'' Beminio",
				"salience": 0.03125568,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.030845996,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0stx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Urbandale,_Iowa"
				},
				"name": "Urbandale",
				"salience": 0.030793859,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.023981193,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0stwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Redfield,_Iowa"
				},
				"name": "Redfield",
				"salience": 0.022659902,
				"type": "LOCATION"
			},
			{
				"name": "Photo",
				"salience": 0.021489885,
				"type": "WORK_OF_ART"
			},
			{
				"name": "police",
				"salience": 0.01834977,
				"type": "PERSON"
			},
			{
				"name": "killing",
				"salience": 0.017291278,
				"type": "EVENT"
			},
			{
				"name": "suspect",
				"salience": 0.017291278,
				"type": "PERSON"
			},
			{
				"name": "killings",
				"salience": 0.017291278,
				"type": "EVENT"
			},
			{
				"name": "officers",
				"salience": 0.014136661,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.014035381,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.013534419,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA TODAY",
				"salience": 0.0126153445,
				"type": "ORGANIZATION"
			},
			{
				"name": "Parizek",
				"salience": 0.012599637,
				"type": "PERSON"
			},
			{
				"name": "cars",
				"salience": 0.012423724,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "area",
				"salience": 0.011726001,
				"type": "LOCATION"
			},
			{
				"name": "Authorities",
				"salience": 0.011726001,
				"type": "PERSON"
			},
			{
				"name": "cops",
				"salience": 0.011726001,
				"type": "PERSON"
			},
			{
				"name": "line",
				"salience": 0.010739577,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.010300211,
				"type": "PERSON"
			},
			{
				"name": "Justin Martin",
				"salience": 0.010233119,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.00948598,
				"type": "PERSON"
			},
			{
				"name": "suspect",
				"salience": 0.00885189,
				"type": "PERSON"
			},
			{
				"name": "killings",
				"salience": 0.00885189,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ns5v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greene_County,_Iowa"
				},
				"name": "Greene",
				"salience": 0.008712914,
				"type": "PERSON"
			},
			{
				"name": "act",
				"salience": 0.0077383104,
				"type": "EVENT"
			},
			{
				"name": "road",
				"salience": 0.007667523,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.0073878886,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.006922885,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ns5v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greene_County,_Iowa"
				},
				"name": "Greene",
				"salience": 0.0067647244,
				"type": "LOCATION"
			},
			{
				"name": "slain officers",
				"salience": 0.006531913,
				"type": "PERSON"
			},
			{
				"name": "Scott Michael Greene",
				"salience": 0.006512643,
				"type": "PERSON"
			},
			{
				"name": "scene",
				"salience": 0.0060242587,
				"type": "LOCATION"
			},
			{
				"name": "police officers",
				"salience": 0.0060149645,
				"type": "PERSON"
			},
			{
				"name": "license plate",
				"salience": 0.005997392,
				"type": "OTHER"
			},
			{
				"name": "custody",
				"salience": 0.005997392,
				"type": "OTHER"
			},
			{
				"name": "Police",
				"salience": 0.0056632347,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.005591973,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.005591973,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.005591973,
				"type": "PERSON"
			},
			{
				"name": "Iowa Methodist Medical Center",
				"salience": 0.0055037434,
				"type": "ORGANIZATION"
			},
			{
				"name": "Dallas County Sheriff's Department",
				"salience": 0.005111931,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/011ggh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sheridan,_Wyoming"
				},
				"name": "Sheridan",
				"salience": 0.0048279576,
				"type": "PERSON"
			},
			{
				"name": "Officer",
				"salience": 0.0046403394,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.0045819297,
				"type": "PERSON"
			},
			{
				"name": "patrol officers",
				"salience": 0.0045819297,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0045819297,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0045819297,
				"type": "PERSON"
			},
			{
				"name": "slain officers",
				"salience": 0.0045819297,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.004411068,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.004411068,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0pf6v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terry_Branstad"
				},
				"name": "Terry Branstad",
				"salience": 0.0041358024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States of America",
				"salience": 0.00407678,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.003922223,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.003922223,
				"type": "PERSON"
			},
			{
				"name": "Violence",
				"salience": 0.0038936678,
				"type": "OTHER"
			},
			{
				"name": "police officer",
				"salience": 0.003837239,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0037088147,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03mnql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ford_F-Series"
				},
				"name": "Ford F-150",
				"salience": 0.00369343,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "suspect",
				"salience": 0.0036484136,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0036484136,
				"type": "EVENT"
			},
			{
				"name": "ambulance",
				"salience": 0.0034198693,
				"type": "OTHER"
			},
			{
				"name": "police departments",
				"salience": 0.0034198693,
				"type": "ORGANIZATION"
			},
			{
				"name": "reports",
				"salience": 0.0034198693,
				"type": "OTHER"
			},
			{
				"name": "intersection",
				"salience": 0.0034198693,
				"type": "LOCATION"
			},
			{
				"name": "officers",
				"salience": 0.003274606,
				"type": "PERSON"
			},
			{
				"name": "news conference",
				"salience": 0.0031595244,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gg4wkg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joni_Ernst"
				},
				"name": "Joni Ernst",
				"salience": 0.0030924191,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.0028670381,
				"type": "PERSON"
			},
			{
				"name": "shootings",
				"salience": 0.002852883,
				"type": "EVENT"
			},
			{
				"name": "scene",
				"salience": 0.002852883,
				"type": "LOCATION"
			},
			{
				"name": "shots",
				"salience": 0.002852883,
				"type": "OTHER"
			},
			{
				"name": "#officersdown",
				"salience": 0.0028212187,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.002795273,
				"type": "PERSON"
			},
			{
				"name": "law enforcement officials",
				"salience": 0.002795273,
				"type": "PERSON"
			},
			{
				"name": "struggle",
				"salience": 0.0025990035,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0025662666,
				"type": "OTHER"
			},
			{
				"name": "suspect",
				"salience": 0.0025585084,
				"type": "PERSON"
			},
			{
				"name": "@newsmanone",
				"salience": 0.0025401781,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0025150012,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0024705073,
				"type": "LOCATION"
			},
			{
				"name": "gunfire",
				"salience": 0.0024705073,
				"type": "OTHER"
			},
			{
				"name": "hospital",
				"salience": 0.0024705073,
				"type": "LOCATION"
			},
			{
				"name": "injury",
				"salience": 0.0024705073,
				"type": "OTHER"
			},
			{
				"name": "interaction",
				"salience": 0.0024287777,
				"type": "OTHER"
			},
			{
				"name": "killings",
				"salience": 0.0024013775,
				"type": "EVENT"
			},
			{
				"name": "Des Moines Police",
				"salience": 0.0023247022,
				"type": "ORGANIZATION"
			},
			{
				"name": "Officers",
				"salience": 0.00231125,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.0023086912,
				"type": "OTHER"
			},
			{
				"name": "intersection",
				"salience": 0.0023086912,
				"type": "LOCATION"
			},
			{
				"name": "news conference",
				"salience": 0.002215559,
				"type": "EVENT"
			},
			{
				"name": "patrol cars",
				"salience": 0.0021328768,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "attack",
				"salience": 0.0020624886,
				"type": "EVENT"
			},
			{
				"name": "ID",
				"salience": 0.0020426814,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.00203605,
				"type": "PERSON"
			},
			{
				"name": "Merle Hay Road",
				"salience": 0.0020128828,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.0020004706,
				"type": "LOCATION"
			},
			{
				"name": "investigators",
				"salience": 0.0020004706,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.0020004706,
				"type": "WORK_OF_ART"
			},
			{
				"name": "series",
				"salience": 0.0020004706,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Daniel P. Finney",
				"salience": 0.001986136,
				"type": "PERSON"
			},
			{
				"name": "intersection",
				"salience": 0.0019578924,
				"type": "LOCATION"
			},
			{
				"name": "shooting",
				"salience": 0.0019258104,
				"type": "EVENT"
			},
			{
				"name": "Photo",
				"salience": 0.0019258104,
				"type": "WORK_OF_ART"
			},
			{
				"name": "message",
				"salience": 0.0018224015,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0018087764,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y3dv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington_State_Route_99"
				},
				"name": "Aurora Avenue",
				"salience": 0.0017562071,
				"type": "LOCATION"
			},
			{
				"name": "70th Street",
				"salience": 0.0017562071,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.0017426856,
				"type": "ORGANIZATION"
			},
			{
				"name": "leads",
				"salience": 0.0017322787,
				"type": "OTHER"
			},
			{
				"name": "tips",
				"salience": 0.0017322787,
				"type": "OTHER"
			},
			{
				"name": "family members",
				"salience": 0.0017322787,
				"type": "PERSON"
			},
			{
				"name": "names",
				"salience": 0.0017322787,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Des_Moines,_Iowa"
				},
				"name": "Des Moines",
				"salience": 0.0016918895,
				"type": "LOCATION"
			},
			{
				"name": "details",
				"salience": 0.0016751036,
				"type": "OTHER"
			},
			{
				"name": "coward",
				"salience": 0.0016676221,
				"type": "OTHER"
			},
			{
				"name": "appearances",
				"salience": 0.0016676221,
				"type": "EVENT"
			},
			{
				"name": "another",
				"salience": 0.0016676221,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0016331575,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.0016331575,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "law enforcement",
				"salience": 0.0016331575,
				"type": "ORGANIZATION"
			},
			{
				"name": "details",
				"salience": 0.0016331575,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0015851496,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0015631075,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0015604431,
				"type": "EVENT"
			},
			{
				"name": "reporters",
				"salience": 0.0015583668,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.0015210268,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0015210268,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.0015210268,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02r0d88",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa_Department_of_Natural_Resources"
				},
				"name": "Department of Natural Resources",
				"salience": 0.0015207456,
				"type": "ORGANIZATION"
			},
			{
				"name": "thoughts",
				"salience": 0.0015135139,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Va.",
				"salience": 0.0014305518,
				"type": "LOCATION"
			},
			{
				"name": "distrust",
				"salience": 0.0014141859,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.0014141859,
				"type": "EVENT"
			},
			{
				"name": "ambush attack",
				"salience": 0.0014099089,
				"type": "EVENT"
			},
			{
				"name": "Iowans",
				"salience": 0.0014007823,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0013512166,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.0012200052,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0012200052,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0012200052,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0012200052,
				"type": "WORK_OF_ART"
			},
			{
				"name": "prayers",
				"salience": 0.0012200052,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0012108821,
				"type": "EVENT"
			},
			{
				"name": "Sheridan Ave.",
				"salience": 0.0011853689,
				"type": "LOCATION"
			},
			{
				"name": "place",
				"salience": 0.0011399321,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.0010746928,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.0010652364,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.0010652364,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0010652364,
				"type": "WORK_OF_ART"
			},
			{
				"name": "safety",
				"salience": 0.0010564089,
				"type": "OTHER"
			},
			{
				"name": "suspect",
				"salience": 0.0010138942,
				"type": "PERSON"
			},
			{
				"name": "department",
				"salience": 0.0010125448,
				"type": "ORGANIZATION"
			},
			{
				"name": "Sheridan Avenue",
				"salience": 0.0010051982,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/050v08",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Des_Moines_Register"
				},
				"name": "The Des Moines Register",
				"salience": 0.000988809,
				"type": "WORK_OF_ART"
			},
			{
				"name": "first",
				"salience": 0.0009871844,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.000984084,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.000984084,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.000984084,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.000984084,
				"type": "PERSON"
			},
			{
				"name": "@dmpolice",
				"salience": 0.0009273824,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0008885129,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0008885129,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0008885129,
				"type": "OTHER"
			},
			{
				"name": "prayers",
				"salience": 0.0008885129,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0008845435,
				"type": "OTHER"
			},
			{
				"name": "Brian Powers",
				"salience": 0.000870398,
				"type": "PERSON"
			},
			{
				"name": "level",
				"salience": 0.00086238806,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c5bn_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Merle_Hay"
				},
				"name": "Merle Hay",
				"salience": 0.00083163515,
				"type": "PERSON"
			},
			{
				"name": "killing",
				"salience": 0.00082767947,
				"type": "EVENT"
			},
			{
				"name": "duty",
				"salience": 0.0007957172,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.0007957172,
				"type": "OTHER"
			},
			{
				"name": "harm",
				"salience": 0.00076935656,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00076935656,
				"type": "PERSON"
			},
			{
				"name": "news conference",
				"salience": 0.0007350924,
				"type": "EVENT"
			},
			{
				"name": "incidents",
				"salience": 0.0006636972,
				"type": "EVENT"
			},
			{
				"name": "officer shot",
				"salience": 0.0006636972,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.0006636972,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "@charlyhaley",
				"salience": 0.0006555985,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0005746845,
				"type": "OTHER"
			},
			{
				"name": "tragedy",
				"salience": 0.0005746845,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.0005746845,
				"type": "LOCATION"
			},
			{
				"name": "drunk driver",
				"salience": 0.0005746845,
				"type": "PERSON"
			},
			{
				"name": "Carlos Puente-Morales",
				"salience": 0.0005379048,
				"type": "PERSON"
			},
			{
				"name": "Haley",
				"salience": 0.00047348152,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00047348152,
				"type": "OTHER"
			},
			{
				"name": "Stanglin",
				"salience": 0.00047348152,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/010m55",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McLean,_Virginia"
				},
				"name": "McLean",
				"salience": 0.00047348152,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03hjhbh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Owen_Farrell"
				},
				"name": "Farrell",
				"salience": 0.00040845052,
				"type": "PERSON"
			},
			{
				"name": "Susan Farrell",
				"salience": 0.00040845052,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/29906170001_5193548811001_VPCNOW-DES-MOINES-POLICE-SHOOTING-PHOTO.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T19:14:58.033+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 16.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Suspect captured in ‘ambush-style’ killings of two Iowa cops 11/02/2016 \nUSA TODAY \nAuthorities captured a 46-year-old male suspect without incident Wednesday, hours after an early-morning “ambush-style” killing of two police officers in the Des Moines metro area. \nThe suspect in the back-to-back killings was identified as Scott Michael Greene, said Urbandale police spokesman Sgt. Chad Underwood. Before capturing him, police had described Greene, who was last seen driving a blue Ford F-150 with an Iowa license plate, as armed and dangerous. \nGreene was taken into custody by the Dallas County Sheriff’s Department while walking along a rural road in Redfield, about 35 miles west of where the shootings occurred. \nAccording to police, Greene flagged down a passing Department of Natural Resources officer, handed over his ID and told the officer to call police. No shots were fired and there was no struggle, according to police. \nThe suspect was taken by ambulance to a Des Moines hospital with an unknown injury. \nIn a late morning news conference, police identified the slain officers as Urbandale Police Officer Justin Martin and Des Moines police Sgt. Anthony “Tony” Beminio. \nThe attacks began around 1:06 a.m. CT, when police departments from both cities responded to reports of gunfire at the intersection of 70th Street and Aurora Avenue in Urbandale. \nThe first officers arriving on the scene found Martin fatally wounded. About 20 minutes later, some two miles away, Beminio was was shot near the intersection of Merle Hay Road and Sheridan Ave. while responding to reports of the first officer’s shooting. Beminio was transported to Iowa Methodist Medical Center, where he died. Scott Michael Greene (Photo: Des Moines Police) \nBoth officers were gunned down in their patrol cars. \n“It doesn’t look like there was any interaction between these officers and whoever the coward is that shot them while they sat in their cars,” a visibly emotional Parizek told reporters. \n“In all appearances it looks … that these officers were ambushed,” he added. Officer from Des Moines and another from Urbandale were shot and killed in their cars, @dmpolice said. #officersdown \n— Daniel P. Finney (@newsmanone) November 2, 2016 \nDes Moines police, fearing officers were being singled out, paired up its patrol officers so none were on the street alone, Parizek said. \n“There’s literally a clear and present danger if you’re a police officer,” he said. \nPolice did not offer many details on how investigators identified Greene as a suspect. Underwood said he was identified “through a series of leads and a series of investigative tips.” \nAs of an early-morning news conference, police were still notifying the family members of the slain officers and planned to withhold the officers’ names, years of service and other details until later in the day, Parizek said. \nAttorney General Loretta Lynch condemned the killings, saying “violence has no place in the United States of America.’’ \n“Let me be clear, there is no message in murder,’’ the attorney general said, referring to simmering distrust between law enforcement and many communities across the country. “Violence creates nothing; it only destroys.’’ A Des Moines police officer was found fatally shot in a vehicle near the intersection of Merle Hay Road and Sheridan Avenue in Des Moines on Wednesday, Nov. 2, 2016. (Photo: Brian Powers, The Des Moines Register) \nIt’s the first time Des Moines has seen a police officer shot and killed in the line of duty since two officers were gunned down in separate incidents in 1977. \nTwo Des Moines officers, Susan Farrell and Carlos Puente-Morales, died earlier this year when their vehicle was struck head-on by a wrong-way drunk driver. \nThe killing of the Urbandale officer appeared to be the city’s first for an officer shot in the line of duty, Underwood said at the news conference. \nParizek thanked the community for its support when the department lost Farrell and Puente-Morales, as well as with this tragedy. \n“I don’t even know where to begin on how bad this year is,” he said. But, “this is what we do. We come in day in and day out, we go out there and provide the same level of service regardless of what’s going on in our personal and professional lives.” Officers investigate the scene at Merle Hay and Sheridan ave. where an officer was found shot at about 1:26 A.M. on on Wednesday, Nov. 2, 2016, in Urbandale. \nIn a statement, Iowa Gov. Terry Branstad called the attack on the officers “an attack on the public safety of all Iowans.” \n“We call on Iowans to support our law enforcement officials in bringing this suspect to justice,” he said. “Our thoughts and prayers go out to the families of the police officers who were tragically killed in the line of duty as well as the officers who continue to put themselves in harm’s way.” \nIowa Sen. Joni Ernst extended her thoughts and prayers to the families of the officers killed. \n“Although the investigation is still unfolding, what appears to be an ambush attack of police in the line of duty is an attack on the community at large and all of the men and women who risk their lives every day to protect us,” Ernst said. “This was a senseless act of violence and it cannot be tolerated.” \nFinney and Haley report for The Des Moines Register. Follow them on Twitter: @newsmanone and @charlyhaley . Stanglin reports for USA TODAY in McLean, Va.",
		"thread_title": "Suspect captured in ‘ambush-style’ killings of two Iowa cops",
		"title": "Suspect captured in ‘ambush-style’ killings of two Iowa cops",
		"type": "bs",
		"uuid": "ff5530621968a76a280c82d1ae6e10c4f9e8324c"
	},
	"-KhIhGMh6_9B0OEQ8IUS": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T19:14:58.593+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.15636803,
				"type": "LOCATION"
			},
			{
				"name": "brothers",
				"salience": 0.09041996,
				"type": "PERSON"
			},
			{
				"name": "jail",
				"salience": 0.088296704,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/010h3lhj"
				},
				"name": "Ryan Bundy",
				"salience": 0.08216004,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03vd3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Bundy"
				},
				"name": "Bundy",
				"salience": 0.063422844,
				"type": "PERSON"
			},
			{
				"name": "OREGONLIVE Ammon Bundy",
				"salience": 0.063422844,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.049866058,
				"type": "LOCATION"
			},
			{
				"name": "two",
				"salience": 0.04738406,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0p6f_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marshals_Service"
				},
				"name": "U.S. Marshals Service",
				"salience": 0.039213598,
				"type": "ORGANIZATION"
			},
			{
				"name": "conspiracy",
				"salience": 0.037127636,
				"type": "OTHER"
			},
			{
				"name": "weapon charges",
				"salience": 0.033570953,
				"type": "OTHER"
			},
			{
				"name": "takeover",
				"salience": 0.029121948,
				"type": "EVENT"
			},
			{
				"name": "jail",
				"salience": 0.025180675,
				"type": "LOCATION"
			},
			{
				"name": "custody",
				"salience": 0.022757519,
				"type": "OTHER"
			},
			{
				"name": "Malheur National Wildlife Refuge",
				"salience": 0.012179207,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02frhbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland,_Oregon"
				},
				"name": "Portland",
				"salience": 0.012179207,
				"type": "LOCATION"
			},
			{
				"name": "custody",
				"salience": 0.012121552,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.009903783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04sdj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Married..._with_Children"
				},
				"name": "Bundys",
				"salience": 0.009196548,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0105ckdm"
				},
				"name": "Cliven Bundy",
				"salience": 0.008707809,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.008579986,
				"type": "PERSON"
			},
			{
				"name": "jail spokeswoman",
				"salience": 0.008579986,
				"type": "PERSON"
			},
			{
				"name": "conspiracy",
				"salience": 0.00819907,
				"type": "OTHER"
			},
			{
				"name": "felony counts",
				"salience": 0.0074050063,
				"type": "OTHER"
			},
			{
				"name": "Multnomah County Detention Center",
				"salience": 0.0064737545,
				"type": "LOCATION"
			},
			{
				"name": "offense",
				"salience": 0.00641432,
				"type": "OTHER"
			},
			{
				"name": "obstruction",
				"salience": 0.00641432,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.00641432,
				"type": "OTHER"
			},
			{
				"name": "officer",
				"salience": 0.0059761186,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.0059761186,
				"type": "PERSON"
			},
			{
				"name": "conspiracy",
				"salience": 0.0059761186,
				"type": "OTHER"
			},
			{
				"name": "officer",
				"salience": 0.005681107,
				"type": "PERSON"
			},
			{
				"name": "assault",
				"salience": 0.004674315,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.003951179,
				"type": "ORGANIZATION"
			},
			{
				"name": "father",
				"salience": 0.0034930455,
				"type": "PERSON"
			},
			{
				"name": "grazing rights",
				"salience": 0.0034930455,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0034930455,
				"type": "PERSON"
			},
			{
				"name": "standoff",
				"salience": 0.0034930455,
				"type": "OTHER"
			},
			{
				"name": "extortion",
				"salience": 0.0027111159,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/21439794-mmmain.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T19:14:58.593+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Bundy brothers discharged from Oregon jail, headed to Nevada with U.S. Marshals 11/02/2016 \nOREGONLIVE \nAmmon Bundy and his older brother Ryan Bundy, both acquitted last Thursday of federal conspiracy and weapon charges in the takeover of the Malheur National Wildlife Refuge, are no longer in custody in the downtown Portland jail. \nThe Bundys were discharged from the Multnomah County Detention Center about 7:45 a.m. Wednesday to the custody of the U.S. Marshals Service, according to a jail spokeswoman. \nThe two are being flown to Nevada, where they’re among 19 people indicted on federal charges in the 2014 armed standoff with federal agents over grazing rights near their father Cliven Bundy’s ranch. \nIn Nevada, they face 16 felony counts, including extortion, obstruction of justice, conspiracy to commit an offense against the United States, conspiracy to impede or injure a federal officer, assault on a federal officer, and threatening a federal officer.",
		"thread_title": "Bundy brothers discharged from Oregon jail, headed to Nevada with U.S. Marshals",
		"title": "Bundy brothers discharged from Oregon jail, headed to Nevada with U.S. Marshals",
		"type": "bs",
		"uuid": "e5c051173c7efd9a46dc2449146c544e20f931ba"
	},
	"-KhIhGdhr5C2XENroBq5": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T19:24:00.901+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.32580587,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.1827829,
				"type": "LOCATION"
			},
			{
				"name": "Clinton & Co.",
				"salience": 0.046548504,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.038466934,
				"type": "OTHER"
			},
			{
				"name": "Warning",
				"salience": 0.034778398,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.022812787,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.022812787,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.01955277,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.017866854,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01snm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cincinnati"
				},
				"name": "Cincinnati",
				"salience": 0.01665599,
				"type": "LOCATION"
			},
			{
				"name": "divisions",
				"salience": 0.011566908,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.01107945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.009549446,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03lcyd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.009549446,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart.com",
				"salience": 0.009549446,
				"type": "OTHER"
			},
			{
				"name": "Charlie Spiering",
				"salience": 0.0093110185,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.009282648,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00884367,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.008389536,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.008171764,
				"type": "OTHER"
			},
			{
				"name": "divisiveness",
				"salience": 0.008171764,
				"type": "OTHER"
			},
			{
				"name": "Anything",
				"salience": 0.00758211,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.007380093,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.007235193,
				"type": "LOCATION"
			},
			{
				"name": "civil war",
				"salience": 0.0063731708,
				"type": "EVENT"
			},
			{
				"name": "divisions",
				"salience": 0.0061083487,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_War"
				},
				"name": "Civil War",
				"salience": 0.00581278,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.005446767,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0054061017,
				"type": "EVENT"
			},
			{
				"name": "challenge",
				"salience": 0.0049847653,
				"type": "OTHER"
			},
			{
				"name": "challenges",
				"salience": 0.0049847653,
				"type": "OTHER"
			},
			{
				"name": "greatest",
				"salience": 0.0049847653,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.0049000834,
				"type": "OTHER"
			},
			{
				"name": "stock",
				"salience": 0.004777532,
				"type": "OTHER"
			},
			{
				"name": "slavery",
				"salience": 0.0043171723,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0043171723,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.0040012114,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lq2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halloween"
				},
				"name": "Halloween",
				"salience": 0.0039372994,
				"type": "EVENT"
			},
			{
				"name": "gender",
				"salience": 0.0036616558,
				"type": "OTHER"
			},
			{
				"name": "skin",
				"salience": 0.0036616558,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0036616558,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0036616558,
				"type": "EVENT"
			},
			{
				"name": "message",
				"salience": 0.003525089,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0031592632,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0029148832,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0029148832,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0029148832,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.0027359044,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0027359044,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0027359044,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0027359044,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0027359044,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0025487123,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.002301328,
				"type": "OTHER"
			},
			{
				"name": "fear-mongering",
				"salience": 0.002301328,
				"type": "OTHER"
			},
			{
				"name": "fear-mongering",
				"salience": 0.0021327832,
				"type": "EVENT"
			},
			{
				"name": "hint",
				"salience": 0.0020965133,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0020052078,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.001992852,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.001992852,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.001992852,
				"type": "OTHER"
			},
			{
				"name": "fingerpointing",
				"salience": 0.001992852,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abraham_Lincoln"
				},
				"name": "Abraham Lincoln",
				"salience": 0.0018405477,
				"type": "PERSON"
			},
			{
				"name": "discussion",
				"salience": 0.0017334395,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0014887786,
				"type": "EVENT"
			},
			{
				"name": "post",
				"salience": 0.0014887786,
				"type": "WORK_OF_ART"
			},
			{
				"name": "topic",
				"salience": 0.0014887786,
				"type": "OTHER"
			},
			{
				"name": "Barracuda Brigade",
				"salience": 0.0009163367,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07phrcj"
				},
				"name": "Liberals",
				"salience": 0.0009163367,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0z0y2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kent,_Ohio"
				},
				"name": "Kent",
				"salience": 0.0009163367,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/hillary-yelling.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T19:24:00.901+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Warning or threat? Hillary hints at second civil war if Trump wins 11/02/2016 \nWhile speaking to supporters in Cincinnati on Monday, Democrat Hillary Clinton hinted at a second civil war if GOP nominee Donald Trump wins, Breitbart.com reported. \nCharlie Spiering wrote: \n“He has a dark and divisive vision for America that could tear our country apart,” Clinton said to supporters in Cincinnati, Ohio on Halloween. \nClinton specifically referred to the Civil War, suggesting that the country faced a similar threat of divisiveness from Donald Trump. \n“Abraham Lincoln understood a house divided against itself cannot stand, and that was over the greatest of challenges – the challenge posed by slavery – and we fought a civil war,” she said. \nShe warned voters that it was time for the country to take the divisions in the country seriously. \n“But we also have to take stock of how divided we are today, the kinds of divisions that need to be healed to bring people together,” she added, failing to admit that her side is the one that has divided America by race, class and gender. \nShe also claimed that Trump would start a nuclear war if a foreign leader got under his skin. \n“I know there are some who will say that any discussion of this topic could be fear-mongering, but I don’t think so,” she said at a rally in Kent, Ohio, earlier in the day. \nA post at Barracuda Brigade observed: \nLiberals especially the Clinton are always projecting. Anything that they accuse the other side of is what they are doing. She suggests that her message is one of “hope and change” when in fact it is just more of the same. \nMoreover, Trump has spent a great deal of time talking about policies and issues while Clinton & Co. have done absolutely nothing but engage in fear-mongering and fingerpointing. \nStill, we have to ask — was Clinton’s “hint” a “warning” or a “threat?” \nRelated:",
		"thread_title": "Warning or threat? Hillary hints at second civil war if Trump wins",
		"title": "Warning or threat? Hillary hints at second civil war if Trump wins",
		"type": "bs",
		"uuid": "0c9d01b2bc7e6e5be2ebecd52b54468b5bf1e731"
	},
	"-KhIhH-IONypgj5d5GaA": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T19:24:01.278+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05wr30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christopher_R._Hill"
				},
				"name": "Chris Hill",
				"salience": 0.3208404,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.090833224,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.084265925,
				"type": "PERSON"
			},
			{
				"name": "Three Percent Security Force",
				"salience": 0.052131448,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.026144406,
				"type": "LOCATION"
			},
			{
				"name": "militia",
				"salience": 0.016219627,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.015449369,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.014059129,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.013085238,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06rmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_Poverty_Law_Center"
				},
				"name": "Southern Poverty Law Center",
				"salience": 0.011277403,
				"type": "ORGANIZATION"
			},
			{
				"name": "rifle practice",
				"salience": 0.011007459,
				"type": "OTHER"
			},
			{
				"name": "campaign rally",
				"salience": 0.011007459,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.010260651,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.010260651,
				"type": "ORGANIZATION"
			},
			{
				"name": "country road",
				"salience": 0.00953791,
				"type": "LOCATION"
			},
			{
				"name": "hand-to-hand combat training",
				"salience": 0.00953791,
				"type": "OTHER"
			},
			{
				"name": "trouble",
				"salience": 0.00953791,
				"type": "OTHER"
			},
			{
				"name": "militia members",
				"salience": 0.00862832,
				"type": "PERSON"
			},
			{
				"name": "militia members",
				"salience": 0.007651145,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.006830463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k4rxv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oath_Keepers"
				},
				"name": "Oath Keepers",
				"salience": 0.006718868,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0063034706,
				"type": "PERSON"
			},
			{
				"name": "trees",
				"salience": 0.0062385523,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "REUTERS",
				"salience": 0.0058800364,
				"type": "ORGANIZATION"
			},
			{
				"name": "chance",
				"salience": 0.0057632965,
				"type": "OTHER"
			},
			{
				"name": "code name",
				"salience": 0.0056342045,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0056342045,
				"type": "PERSON"
			},
			{
				"name": "memory",
				"salience": 0.004880258,
				"type": "OTHER"
			},
			{
				"name": "morning sunlight",
				"salience": 0.004880258,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.004880258,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0048188814,
				"type": "OTHER"
			},
			{
				"name": "militia groups",
				"salience": 0.0048162495,
				"type": "ORGANIZATION"
			},
			{
				"name": "guns",
				"salience": 0.0044102776,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "members",
				"salience": 0.0039385254,
				"type": "PERSON"
			},
			{
				"name": "Ooh-rah!",
				"salience": 0.0034708362,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.003323459,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bloodagent",
				"salience": 0.003005948,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0029693202,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0029693202,
				"type": "EVENT"
			},
			{
				"name": "office building",
				"salience": 0.0029217973,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.0028873656,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.002783361,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.0026934454,
				"type": "ORGANIZATION"
			},
			{
				"name": "members",
				"salience": 0.0025117411,
				"type": "PERSON"
			},
			{
				"name": "EXTREMIST GROUPS",
				"salience": 0.0024962714,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.0024962714,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0024648402,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0024046788,
				"type": "PERSON"
			},
			{
				"name": "extremist groups",
				"salience": 0.0024031587,
				"type": "ORGANIZATION"
			},
			{
				"name": "members",
				"salience": 0.0024031587,
				"type": "PERSON"
			},
			{
				"name": "promise",
				"salience": 0.0023219963,
				"type": "OTHER"
			},
			{
				"name": "Wayne Root",
				"salience": 0.0021199558,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b76qwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Walsh_(Illinois_politician)"
				},
				"name": "Joe Walsh",
				"salience": 0.002093258,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0020381378,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.0020381378,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0020381378,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.002010831,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.002010831,
				"type": "LOCATION"
			},
			{
				"name": "immigrants",
				"salience": 0.002010831,
				"type": "PERSON"
			},
			{
				"name": "mogul",
				"salience": 0.002010831,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.002010831,
				"type": "LOCATION"
			},
			{
				"name": "shot",
				"salience": 0.002010831,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.002010831,
				"type": "EVENT"
			},
			{
				"name": "unrest",
				"salience": 0.002010831,
				"type": "EVENT"
			},
			{
				"name": "possibility",
				"salience": 0.002010831,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.002010831,
				"type": "OTHER"
			},
			{
				"name": "Ryan Lenz",
				"salience": 0.0018675964,
				"type": "PERSON"
			},
			{
				"name": "rights",
				"salience": 0.0017491374,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0017378125,
				"type": "EVENT"
			},
			{
				"name": "county",
				"salience": 0.0016979337,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0016283063,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.0016283063,
				"type": "PERSON"
			},
			{
				"name": "rifle",
				"salience": 0.0015936542,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "rifles",
				"salience": 0.0015936542,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "campfire",
				"salience": 0.0015936542,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0015936542,
				"type": "OTHER"
			},
			{
				"name": "prominence",
				"salience": 0.0015675441,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0015675441,
				"type": "ORGANIZATION"
			},
			{
				"name": "fraud",
				"salience": 0.0015675441,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0015675441,
				"type": "PERSON"
			},
			{
				"name": "signs",
				"salience": 0.0015675441,
				"type": "OTHER"
			},
			{
				"name": "voting sites",
				"salience": 0.0015675441,
				"type": "OTHER"
			},
			{
				"name": "pistols",
				"salience": 0.001557394,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "extremist groups",
				"salience": 0.0015227154,
				"type": "ORGANIZATION"
			},
			{
				"name": "gun ownership",
				"salience": 0.0014900373,
				"type": "OTHER"
			},
			{
				"name": "countrymen",
				"salience": 0.0014673675,
				"type": "PERSON"
			},
			{
				"name": "militia",
				"salience": 0.0014668182,
				"type": "PERSON"
			},
			{
				"name": "clashes",
				"salience": 0.0014280254,
				"type": "OTHER"
			},
			{
				"name": "wildlife refuge",
				"salience": 0.0014100353,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.0014100353,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.0014100353,
				"type": "WORK_OF_ART"
			},
			{
				"name": "land-use disputes",
				"salience": 0.0014100353,
				"type": "EVENT"
			},
			{
				"name": "same",
				"salience": 0.0014100353,
				"type": "OTHER"
			},
			{
				"name": "ruin",
				"salience": 0.0014100353,
				"type": "LOCATION"
			},
			{
				"name": "left",
				"salience": 0.0014100353,
				"type": "OTHER"
			},
			{
				"name": "conspiracy charges",
				"salience": 0.0014100353,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.0013574125,
				"type": "EVENT"
			},
			{
				"name": "confrontations",
				"salience": 0.0013574125,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.0013574125,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0013574125,
				"type": "EVENT"
			},
			{
				"name": "numbers",
				"salience": 0.0013574125,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.0013574125,
				"type": "OTHER"
			},
			{
				"name": "militia sympathizer",
				"salience": 0.0013574125,
				"type": "ORGANIZATION"
			},
			{
				"name": "fraud",
				"salience": 0.0013293623,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.0013293623,
				"type": "OTHER"
			},
			{
				"name": "voting sites",
				"salience": 0.0013293623,
				"type": "OTHER"
			},
			{
				"name": "tree",
				"salience": 0.0012485766,
				"type": "OTHER"
			},
			{
				"name": "pistols",
				"salience": 0.0012477047,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0012477047,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0012378708,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0012378708,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.0012378708,
				"type": "LOCATION"
			},
			{
				"name": "militias",
				"salience": 0.0011824166,
				"type": "PERSON"
			},
			{
				"name": "race riots",
				"salience": 0.001151141,
				"type": "EVENT"
			},
			{
				"name": "face",
				"salience": 0.001151141,
				"type": "OTHER"
			},
			{
				"name": "turns",
				"salience": 0.001151141,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.001151141,
				"type": "OTHER"
			},
			{
				"name": "blasts",
				"salience": 0.001151141,
				"type": "OTHER"
			},
			{
				"name": "target range",
				"salience": 0.001151141,
				"type": "OTHER"
			},
			{
				"name": "Security Force",
				"salience": 0.0010687573,
				"type": "ORGANIZATION"
			},
			{
				"name": "ideas",
				"salience": 0.0009930925,
				"type": "OTHER"
			},
			{
				"name": "landscape",
				"salience": 0.0009930925,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0009930925,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0008679201,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.0008679201,
				"type": "LOCATION"
			},
			{
				"name": "sort",
				"salience": 0.0008599341,
				"type": "OTHER"
			},
			{
				"name": "musket",
				"salience": 0.0008599341,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0008599341,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0008599341,
				"type": "PERSON"
			},
			{
				"name": "fringe",
				"salience": 0.0008599341,
				"type": "EVENT"
			},
			{
				"name": "campaign season",
				"salience": 0.0008599341,
				"type": "EVENT"
			},
			{
				"name": "rule of law",
				"salience": 0.0008599341,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0008599341,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/039jzz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Waco_siege"
				},
				"name": "Waco",
				"salience": 0.00083552074,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05mfw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_City_bombing"
				},
				"name": "Oklahoma City",
				"salience": 0.00083552074,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02hxmn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ruby_Ridge"
				},
				"name": "Ruby Ridge",
				"salience": 0.00083552074,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00083552074,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idaho"
				},
				"name": "Idaho",
				"salience": 0.00083552074,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.00082850765,
				"type": "ORGANIZATION"
			},
			{
				"name": "trees",
				"salience": 0.0008010646,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.00073250383,
				"type": "OTHER"
			},
			{
				"name": "rifle practice",
				"salience": 0.0007232726,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0007232726,
				"type": "EVENT"
			},
			{
				"name": "protesters",
				"salience": 0.0007109675,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0w_s6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ferguson,_Missouri"
				},
				"name": "Ferguson",
				"salience": 0.0007085276,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04ych",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Missouri"
				},
				"name": "Missouri",
				"salience": 0.0007085276,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/013yq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atlanta"
				},
				"name": "Atlanta",
				"salience": 0.0007085276,
				"type": "LOCATION"
			},
			{
				"name": "capabilities",
				"salience": 0.0006262816,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0006262816,
				"type": "OTHER"
			},
			{
				"name": "obstacle course",
				"salience": 0.0006262816,
				"type": "OTHER"
			},
			{
				"name": "midday sun",
				"salience": 0.0006262816,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0006262816,
				"type": "EVENT"
			},
			{
				"name": "gun owners",
				"salience": 0.0005402755,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0005402755,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.0005292601,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.00047591646,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00046781864,
				"type": "PERSON"
			},
			{
				"name": "notion",
				"salience": 0.00046781864,
				"type": "OTHER"
			},
			{
				"name": "war games",
				"salience": 0.00046781864,
				"type": "EVENT"
			},
			{
				"name": "plans",
				"salience": 0.00046781864,
				"type": "OTHER"
			},
			{
				"name": "march",
				"salience": 0.00046781864,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.00045610033,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00038676523,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservative_Party_(UK)"
				},
				"name": "Conservative",
				"salience": 0.00038543768,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00038543768,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cv3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas"
				},
				"name": "Las Vegas",
				"salience": 0.00038543768,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "Marines",
				"salience": 0.00038543768,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jnh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Revolutionary_War"
				},
				"name": "Revolutionary War",
				"salience": 0.00033250073,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.00028790478,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00028790478,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/download.jpeg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T19:24:01.278+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "U.S. militia girds for trouble as presidential election nears 11/02/2016 \nREUTERS \nDown a Georgia country road, camouflaged members of the Three Percent Security Force have mobilized for rifle practice, hand-to-hand combat training — and an impromptu campaign rally for Republican presidential candidate Donald Trump. \n“How many people are voting for Trump? Ooh-rah!” asks Chris Hill, a paralegal who goes by the code name “Bloodagent.” \n“Ooh-rah!” shout a dozen militia members in response, as morning sunlight sifted through the trees last weekend. \nAs the most divisive presidential election in recent memory nears its conclusion, some armed militia groups are preparing for the possibility of a stolen election on Nov. 8 and civil unrest in the days following a victory by Democrat Hillary Clinton. \nThey say they won’t fire the first shot, but they’re not planning to leave their guns at home, either. \nTrump’s populist campaign has energized militia members like Hill, who admire the Republican mogul’s promise to deport illegal immigrants, stop Muslims from entering the country and build a wall along the Mexico border. Trump has repeatedly warned that the election may be “rigged,” and has said he may not respect the results if he does not win. At least one paramilitary group, the Oath Keepers, has called on members to monitor voting sites for signs of fraud. \nArmed paramilitary groups first gained prominence in the early 1990s, fueled by confrontations in Ruby Ridge, Idaho and Waco, Texas, culminating in a militia sympathizer’s 1995 bombing of a federal office building in Oklahoma City that killed 168 people. \nTheir numbers dwindled following that attack but have spiked in recent years, driven by fears that President Barack Obama will threaten gun ownership and erode the power of local government. The Southern Poverty Law Center, which tracks extremist groups, estimates there were 276 active militias last year, up from 42 in 2008. \nIn recent years, armed groups have confronted federal authorities in a series of land-use disputes in the western United States. Federal officials fear more clashes could come after seven militants were acquitted on conspiracy charges for occupying a federal wildlife refuge in Oregon. \nMany fear Clinton would push the county further to the left. \n“This is the last chance to save America from ruin,” Hill said. “I’m surprised I was able to survive or suffer through eight years of Obama without literally going insane, but Hillary is going to be more of the same.” \n\nEXTREMIST GROUPS EMBOLDENED \nThe Oath Keepers, a prominent anti-government force that sent gun-toting members to the 2014 race riots in Ferguson, Missouri, called on members last week to monitor voting sites on election day for any signs of fraud. \nAn hour south of Atlanta, the Three Percent Security Force started the day around the campfire, taking turns shooting automatic pistols and rifles at a makeshift target range. They whooped with approval when blasts from one member’s high-powered rifle knocked down a tree. \nThe group operates independently, but is affiliated with a national armed movement that calls for members to defend individual rights in the face of what they see as an overreaching federal government. The movement draws its name from the notion that no more than 3 percent of the American population fought in the Revolutionary War against Britain. \nAmid the war games, Hill weighed plans for a possible armed march on Washington if Clinton wins. \nHe said he doesn’t want his members leading the way, but they will defend the protesters if need be. His group will not hesitate to act if a President Clinton tries to disarm gun owners, he said. \n“I will be there to render assistance to my fellow countrymen, and prevent them from being disarmed, and I will fight and I will kill and I may die in the process,” said Hill, who founded the militia several years ago. \nTrump’s candidacy has emboldened extremist groups to speak more openly about challenging the rule of law, said Ryan Lenz, a researcher at the Southern Poverty Law Center. \n“Prior to this campaign season, these ideas were relegated to sort of the political fringe of the American political landscape,” he said. “Now these ideas are legitimized.” \nOver the past week, some prominent Trump supporters have hinted at violence. \n“If Trump loses, I’m grabbing my musket,” former Illinois Representative Joe Walsh wrote on Twitter last week. Conservative commentator Wayne Root fantasized about Clinton’s death while speaking at a Trump rally in Las Vegas on Sunday. \nBack in Georgia, the Three Percent Security Force wrapped up rifle practice in the midday sun. They then headed further into the trees to tackle an obstacle course with loaded pistols at their sides, ready for whatever may come. \n“We’ve building up for this, just like the Marines,” he said. “We are going to really train harder and try to increase our operational capabilities in the event that this is the day that we hoped would never come.” Share On:",
		"thread_title": "U.S. militia girds for trouble as presidential election nears",
		"title": "U.S. militia girds for trouble as presidential election nears",
		"type": "bs",
		"uuid": "705bbad66afa88a8b0c0c8854d107be3a4369bad"
	},
	"-KhIhH7xjDJCvPVFg02I": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T03:45:27.666+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.31835887,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.21962413,
				"type": "PERSON"
			},
			{
				"name": "Spy",
				"salience": 0.07921871,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04b6p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KGB"
				},
				"name": "KGB",
				"salience": 0.07400387,
				"type": "ORGANIZATION"
			},
			{
				"name": "video",
				"salience": 0.035755794,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04q7gbh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Americans"
				},
				"name": "American People",
				"salience": 0.029938627,
				"type": "PERSON"
			},
			{
				"name": "AMTV",
				"salience": 0.02576171,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.024567535,
				"type": "PERSON"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.02214562,
				"type": "PERSON"
			},
			{
				"name": "campaign accusation",
				"salience": 0.01911116,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.010704288,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.010437408,
				"type": "OTHER"
			},
			{
				"name": "Citizen",
				"salience": 0.010437408,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.010437408,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.010437408,
				"type": "OTHER"
			},
			{
				"name": "witch hunt",
				"salience": 0.010049456,
				"type": "EVENT"
			},
			{
				"name": "trial",
				"salience": 0.010049456,
				"type": "EVENT"
			},
			{
				"name": "voting",
				"salience": 0.008527579,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.008527579,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.008464037,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0069141174,
				"type": "EVENT"
			},
			{
				"name": "Quasar",
				"salience": 0.0064349207,
				"type": "OTHER"
			},
			{
				"name": "election results",
				"salience": 0.0063758623,
				"type": "OTHER"
			},
			{
				"name": "crotches",
				"salience": 0.0063758623,
				"type": "OTHER"
			},
			{
				"name": "Somebody",
				"salience": 0.0063758623,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0455m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_McCarthy"
				},
				"name": "McCarthy",
				"salience": 0.0061953035,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0tz54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salem,_Massachusetts"
				},
				"name": "Salem",
				"salience": 0.0061953035,
				"type": "LOCATION"
			},
			{
				"name": "cap",
				"salience": 0.0046467124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0179dd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Transportation_Security_Administration"
				},
				"name": "TSA",
				"salience": 0.003927995,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^641A05DAD2314C04DF5729F246E0A3CE0A82712ADA326651EB^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T03:45:27.666+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Donald Trump a KGB Spy? 11/02/2016 In today’s video, Christopher Greene of AMTV reports Hillary Clinton campaign accusation that Donald Trump is a KGB spy is about as weak and baseless a claim as a Salem witch hunt or McCarthy era trial. It’s only because Hillary Clinton is losing that she is lobbing conspiracy theory. Citizen Quasar \nThe way I see it, one of two things will happen: \n1. Trump will win by a landslide but the election will be stolen via electronic voting, just like I have been predicting for over a decade, and the American People will accept the skewed election results just like they accept the TSA into their crotches. \n2. Somebody will bust a cap in Hillary’s @$$ killing her and the election will be postponed. Follow AMTV!",
		"thread_title": "Donald Trump a KGB Spy?",
		"title": "Donald Trump a KGB Spy?",
		"type": "bs",
		"uuid": "da8dad964c1fdbc0126a37b5fbb697191053fd56"
	},
	"-KhIhHOtm2Hi4t2QzGL8": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:03:58.143+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0hqly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_Seagal"
				},
				"name": "Steven Seagal",
				"salience": 0.51151884,
				"type": "PERSON"
			},
			{
				"name": "citizenship",
				"salience": 0.109175175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.07862631,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.057703376,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.049343683,
				"type": "LOCATION"
			},
			{
				"name": "citizenship",
				"salience": 0.01645561,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ndwhc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimea"
				},
				"name": "Crimea",
				"salience": 0.014767589,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0280k2k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dmitry_Peskov"
				},
				"name": "Dmitry Peskov",
				"salience": 0.0134284,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.012815106,
				"type": "OTHER"
			},
			{
				"name": "decree",
				"salience": 0.008113798,
				"type": "OTHER"
			},
			{
				"name": "passport handout",
				"salience": 0.008113798,
				"type": "WORK_OF_ART"
			},
			{
				"name": "celebrity",
				"salience": 0.008113798,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.0063404744,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0057785558,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.0050089653,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0050089653,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.0044741645,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizenship",
				"salience": 0.0032883286,
				"type": "OTHER"
			},
			{
				"name": "annexation",
				"salience": 0.003007307,
				"type": "EVENT"
			},
			{
				"name": "citizenship",
				"salience": 0.0027200778,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.0025634163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c9hm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/G%C3%A9rard_Depardieu"
				},
				"name": "Gerard Depardieu",
				"salience": 0.00248352,
				"type": "PERSON"
			},
			{
				"name": "citizenship",
				"salience": 0.0024582124,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0024582124,
				"type": "PERSON"
			},
			{
				"name": "citizen",
				"salience": 0.0024582124,
				"type": "PERSON"
			},
			{
				"name": "citizen",
				"salience": 0.0024582124,
				"type": "PERSON"
			},
			{
				"name": "CITIZENSHIP",
				"salience": 0.0023666322,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0023666322,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0019806651,
				"type": "LOCATION"
			},
			{
				"name": "citizens",
				"salience": 0.0019327106,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0017929053,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0017898532,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0017764878,
				"type": "LOCATION"
			},
			{
				"name": "bromance",
				"salience": 0.0017154417,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.0017154417,
				"type": "OTHER"
			},
			{
				"name": "nationality",
				"salience": 0.0017102603,
				"type": "OTHER"
			},
			{
				"name": "nationality",
				"salience": 0.0017102603,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0014735528,
				"type": "PERSON"
			},
			{
				"name": "nationality",
				"salience": 0.0014506079,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0014506079,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014kb2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alexander_Lukashenko"
				},
				"name": "Alexander Lukashenko",
				"salience": 0.001351409,
				"type": "PERSON"
			},
			{
				"name": "latest",
				"salience": 0.0013384307,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.0013374967,
				"type": "OTHER"
			},
			{
				"name": "instances",
				"salience": 0.0012031748,
				"type": "OTHER"
			},
			{
				"name": "loyalty",
				"salience": 0.0012031748,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.001158295,
				"type": "PERSON"
			},
			{
				"name": "encounter",
				"salience": 0.0011507979,
				"type": "EVENT"
			},
			{
				"name": "allegiance",
				"salience": 0.0011343714,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0011343714,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0010563363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0010563363,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bln_8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeff_Monson"
				},
				"name": "Jeff Monson",
				"salience": 0.0009970306,
				"type": "PERSON"
			},
			{
				"name": "string",
				"salience": 0.0009823577,
				"type": "OTHER"
			},
			{
				"name": "Westerners",
				"salience": 0.0009823577,
				"type": "PERSON"
			},
			{
				"name": "purpose",
				"salience": 0.0009823577,
				"type": "OTHER"
			},
			{
				"name": "passport",
				"salience": 0.00097433536,
				"type": "OTHER"
			},
			{
				"name": "allegiances",
				"salience": 0.00096206425,
				"type": "OTHER"
			},
			{
				"name": "strongmen leaders",
				"salience": 0.0009386386,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0009036172,
				"type": "OTHER"
			},
			{
				"name": "pledge",
				"salience": 0.00088763225,
				"type": "OTHER"
			},
			{
				"name": "martial arts fan",
				"salience": 0.00073392875,
				"type": "PERSON"
			},
			{
				"name": "films",
				"salience": 0.00073392875,
				"type": "WORK_OF_ART"
			},
			{
				"name": "declaration",
				"salience": 0.00072468317,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00071309926,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0006837005,
				"type": "OTHER"
			},
			{
				"name": "living world leaders",
				"salience": 0.0006837005,
				"type": "PERSON"
			},
			{
				"name": "citizenship",
				"salience": 0.0006751657,
				"type": "OTHER"
			},
			{
				"name": "annexation",
				"salience": 0.00061732397,
				"type": "EVENT"
			},
			{
				"name": "star",
				"salience": 0.0006095464,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0006047422,
				"type": "LOCATION"
			},
			{
				"name": "blues band",
				"salience": 0.0005345602,
				"type": "OTHER"
			},
			{
				"name": "carrots",
				"salience": 0.0005345602,
				"type": "OTHER"
			},
			{
				"name": "mockery",
				"salience": 0.0005345602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00046116495,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbian",
				"salience": 0.00045176438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00045176438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hqnw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Above_the_Law_(film)"
				},
				"name": "Above the Law",
				"salience": 0.00045176438,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.00045176438,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hqqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Under_Siege"
				},
				"name": "Under Siege",
				"salience": 0.00045176438,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fame",
				"salience": 0.00039932862,
				"type": "OTHER"
			},
			{
				"name": "tea",
				"salience": 0.00039932862,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "boxer",
				"salience": 0.00039932862,
				"type": "OTHER"
			},
			{
				"name": "rate hikes",
				"salience": 0.00039932862,
				"type": "OTHER"
			},
			{
				"name": "ire",
				"salience": 0.00039932862,
				"type": "OTHER"
			},
			{
				"name": "tax exile",
				"salience": 0.00034733242,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015h7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Sea"
				},
				"name": "Black Sea",
				"salience": 0.0003290187,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0163v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belarus"
				},
				"name": "Belarussian",
				"salience": 0.0003290187,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01r_334",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roy_Jones,_Jr."
				},
				"name": "Roy Jones Jr",
				"salience": 0.00024577134,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/article-doc-hq4yp-vCzQrrGoE078947232bf09aa4ef-869_634x427.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:03:58.143+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Putin grants Steven Seagal Russian citizenship 11/03/2016 \nDAILY MAIL President Vladimir Putin signed off Thursday on a decree granting Russian citizenship to American action hero actor Steven Seagal, the latest high-profile passport handout to a Western celebrity. Hollywood star Seagal and judo-loving Kremlin tough guy Putin have struck up a bromance in recent years, with Seagal visiting Russia repeatedly and defending Moscow’s 2014 annexation of Crimea from Ukraine. ‘He was asking quite insistently and over a lengthy period to be granted citizenship,’ Kremlin spokesman Dmitry Peskov told journalists. ‘He is well known for his warm feelings towards our country and has never hidden them.’ DUAL CITIZENSHIP IN THE U.S. Americans are allowed to hold dual citizenship, such as Steven Seagal now has with Russia. U.S. law does not mention dual nationality not does it require its citizens to choose one nationality over the other. People that become U.S. citizens are asked to make a pledge of loyalty to the U.S., renouncing all previous allegiances, but the statement is more symbolic than contractual. However, there are rare cases in which a U.S. citizen can forfeit their citizenship by becoming the citizen of another nation. That can happen in instances when an American citizen joins the armed forces of a foreign nation or they make a declaration of allegiance to a foreign state with the express purpose of relinquishing their U.S. nationality. Seagal is the latest in a string of high-profile Westerners to be granted Russian citizenship after buddying up with Putin. Veteran French actor Gerard Depardieu was given a Russian passport in 2013 after the star became a tax exile in ire over rate hikes in his native country. Putin has also handed out citizenship to American boxer Roy Jones Jr after sipping tea with him in Crimea and to American mixed martial artist Jeff Monson. Seagal’s fame peaked in the late 1980s and early 1990s with films such as ‘Under Siege’ and ‘Above the Law’, but he remains hugely popular in eastern Europe and was granted Serbian citizenship in January. Like Depardieu, he has previously hung out with Putin, a fellow martial arts fan, and other strongmen leaders from the former Soviet Union. After Russia’s annexation of Crimea, Seagal called Putin ‘one of the great living world leaders’ and even performed with his blues band in the annexed Black Sea peninsula. In August, veteran Belarussian leader Alexander Lukashenko made Seagal eat one of his homegrown carrots in an awkward encounter that drew mockery online.",
		"thread_title": "Putin grants Steven Seagal Russian citizenship",
		"title": "Putin grants Steven Seagal Russian citizenship",
		"type": "bs",
		"uuid": "5f730d5c691f556533af5249645f9e795153069c"
	},
	"-KhIhHYqluKMPhDjShe1": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:00.553+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "woman",
				"salience": 0.17405908,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.104211144,
				"type": "PERSON"
			},
			{
				"name": "brain",
				"salience": 0.071241595,
				"type": "OTHER"
			},
			{
				"name": "eye implant",
				"salience": 0.06254617,
				"type": "OTHER"
			},
			{
				"name": "breakthrough",
				"salience": 0.053615917,
				"type": "OTHER"
			},
			{
				"name": "human sight",
				"salience": 0.039577454,
				"type": "OTHER"
			},
			{
				"name": "Scientists",
				"salience": 0.035962526,
				"type": "PERSON"
			},
			{
				"name": "colours",
				"salience": 0.035515085,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.035515085,
				"type": "OTHER"
			},
			{
				"name": "shapes",
				"salience": 0.033779614,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "RUSSIA",
				"salience": 0.021965245,
				"type": "LOCATION"
			},
			{
				"name": "eye implant",
				"salience": 0.018808713,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09f2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Los_Angeles"
				},
				"name": "University of California, Los Angeles",
				"salience": 0.014522635,
				"type": "ORGANIZATION"
			},
			{
				"name": "Robert Greenberg",
				"salience": 0.013172775,
				"type": "PERSON"
			},
			{
				"name": "Nader Pouratian",
				"salience": 0.01206702,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0107176695,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.009634136,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.009284895,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.009053042,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "surgeons",
				"salience": 0.008701221,
				"type": "PERSON"
			},
			{
				"name": "brain",
				"salience": 0.0078052003,
				"type": "OTHER"
			},
			{
				"name": "product",
				"salience": 0.007537261,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "human test",
				"salience": 0.007537261,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.007106872,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.006671126,
				"type": "OTHER"
			},
			{
				"name": "blind",
				"salience": 0.0065154694,
				"type": "OTHER"
			},
			{
				"name": "cortex",
				"salience": 0.0061054956,
				"type": "OTHER"
			},
			{
				"name": "sight",
				"salience": 0.005900576,
				"type": "OTHER"
			},
			{
				"name": "computer",
				"salience": 0.0058779772,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stimulator chip",
				"salience": 0.005633683,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.005288087,
				"type": "OTHER"
			},
			{
				"name": "programme",
				"salience": 0.005288087,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.005288087,
				"type": "OTHER"
			},
			{
				"name": "nerve",
				"salience": 0.005288087,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0050909715,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lines",
				"salience": 0.0050909715,
				"type": "OTHER"
			},
			{
				"name": "spots",
				"salience": 0.0050909715,
				"type": "OTHER"
			},
			{
				"name": "side effects",
				"salience": 0.0050909715,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0050909715,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0049858927,
				"type": "OTHER"
			},
			{
				"name": "flashes",
				"salience": 0.004839512,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05dd3_1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Second_Sight_(The_Avengers)"
				},
				"name": "Second Sight",
				"salience": 0.00450731,
				"type": "ORGANIZATION"
			},
			{
				"name": "patient",
				"salience": 0.004318138,
				"type": "PERSON"
			},
			{
				"name": "cells",
				"salience": 0.004318138,
				"type": "OTHER"
			},
			{
				"name": "stimulation",
				"salience": 0.00417867,
				"type": "OTHER"
			},
			{
				"name": "implant",
				"salience": 0.00412607,
				"type": "OTHER"
			},
			{
				"name": "stimulator",
				"salience": 0.00412607,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0037257904,
				"type": "ORGANIZATION"
			},
			{
				"name": "trials",
				"salience": 0.0037091635,
				"type": "EVENT"
			},
			{
				"name": "go",
				"salience": 0.0035258674,
				"type": "OTHER"
			},
			{
				"name": "Orion 1",
				"salience": 0.0032565407,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "approval",
				"salience": 0.003226599,
				"type": "OTHER"
			},
			{
				"name": "camera",
				"salience": 0.003226599,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "pair",
				"salience": 0.003226599,
				"type": "OTHER"
			},
			{
				"name": "glasses",
				"salience": 0.003226599,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "results",
				"salience": 0.0030058683,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0030058683,
				"type": "OTHER"
			},
			{
				"name": "surgery",
				"salience": 0.0027141531,
				"type": "EVENT"
			},
			{
				"name": "cortex",
				"salience": 0.0027141531,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0276stk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manchester_Royal_Eye_Hospital"
				},
				"name": "Manchester Royal Eye Hospital",
				"salience": 0.0026588554,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0r4t218",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Argus_retinal_prosthesis"
				},
				"name": "Argus II",
				"salience": 0.0026588554,
				"type": "ORGANIZATION"
			},
			{
				"name": "step",
				"salience": 0.0026128895,
				"type": "OTHER"
			},
			{
				"name": "brain",
				"salience": 0.002593361,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.002350386,
				"type": "OTHER"
			},
			{
				"name": "quality",
				"salience": 0.002350386,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.002350386,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.0021880197,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.002027766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/032mx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Food_and_Drug_Administration"
				},
				"name": "FDA",
				"salience": 0.0019864424,
				"type": "ORGANIZATION"
			},
			{
				"name": "sight",
				"salience": 0.0019596086,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.0018947191,
				"type": "OTHER"
			},
			{
				"name": "manufacturer",
				"salience": 0.0017559332,
				"type": "ORGANIZATION"
			},
			{
				"name": "reason",
				"salience": 0.0017559332,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.0017559332,
				"type": "OTHER"
			},
			{
				"name": "diabetic retinopathy",
				"salience": 0.0017559332,
				"type": "OTHER"
			},
			{
				"name": "trauma",
				"salience": 0.0017559332,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.0016346073,
				"type": "OTHER"
			},
			{
				"name": "glaucoma",
				"salience": 0.00074131193,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/58190223c36188ce358b4614.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:00.553+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "New bionic eye implant connects directly to brain 11/03/2016 \nRUSSIA TODAY Scientists may have made a significant breakthrough in restoring human sight, as a woman who had been blind for seven years has regained the ability to see shapes and colours with a bionic eye implant. \nThe 30-year-old woman had a wireless visual stimulator chip inserted into her brain by University of California, Los Angeles (UCLA) surgeons in the first human test of the product. As a result, she could see colored flashes, lines, and spots when signals were sent to her brain from a computer. \nThe woman, who wished to remain anonymous, suffered no significant adverse side effects in the process, according to a statement. \nThe device, which was developed as part of the Orion 1 programme by Second Sight, uses technology to restore sight by bypassing the optic nerve to stimulate the brain’s visual cortex, according to chairman Robert Greenberg. \nIt is designed for those who cannot benefit from the Argus II retinal system that was unveiled at Manchester Royal Eye Hospital last year, but has limited application, as it depends on the patient having some retinal cells. \nThis new system goes one step further by sending signals directly to the brain. It has the potential to restore sight to those who have gone completely blind for virtually any reason, including glaucoma, cancer, diabetic retinopathy, or trauma, according to the manufacturer. \nThe next step is to connect the implant to a camera on a pair of glasses, and the company plans to seek FDA approval in 2017 to get the go ahead to conduct these trials. \nUCLA neurosurgeon Nader Pouratian, who implanted the stimulator, said the results of the surgery are promising. \n“Based on these results, stimulation of the visual cortex has the potential to restore useful vision to the blind, which is important for independence and improving quality of life,” he said.",
		"thread_title": "New bionic eye implant connects directly to brain",
		"title": "New bionic eye implant connects directly to brain",
		"type": "bs",
		"uuid": "c172348f3ee7cff3d829e89fa8efbc51b52578a8"
	},
	"-KhIhHqZOaSOZcli83yK": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:00.615+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/017g21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roger_Waters"
				},
				"name": "Roger Waters",
				"salience": 0.5576286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01w6dw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Express"
				},
				"name": "American Express",
				"salience": 0.1382806,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.02882486,
				"type": "PERSON"
			},
			{
				"name": "protest tactic",
				"salience": 0.017047377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0qrrp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rogers,_Arkansas"
				},
				"name": "Rogers",
				"salience": 0.012010235,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.011309123,
				"type": "EVENT"
			},
			{
				"name": "views",
				"salience": 0.009431498,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "New York Post",
				"salience": 0.008516692,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0478c9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestinian_nationalism"
				},
				"name": "pro-Palestinian",
				"salience": 0.007942853,
				"type": "PERSON"
			},
			{
				"name": "brick",
				"salience": 0.007864493,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.007383591,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0dfxl7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel_and_the_apartheid_analogy"
				},
				"name": "Israeli Apartheid",
				"salience": 0.0058185,
				"type": "OTHER"
			},
			{
				"name": "tour",
				"salience": 0.0055755028,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01hdgtt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall"
				},
				"name": "The Wall",
				"salience": 0.005255325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sponsorship",
				"salience": 0.005227114,
				"type": "OTHER"
			},
			{
				"name": "military occupation",
				"salience": 0.005227114,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wv9xn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pink_Floyd"
				},
				"name": "Pink Floyd",
				"salience": 0.00507416,
				"type": "ORGANIZATION"
			},
			{
				"name": "singer",
				"salience": 0.0048301076,
				"type": "PERSON"
			},
			{
				"name": "solidarity",
				"salience": 0.004362308,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0037786777,
				"type": "PERSON"
			},
			{
				"name": "apartheid system",
				"salience": 0.0037786777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03j24kf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_McCartney"
				},
				"name": "Paul McCartney",
				"salience": 0.003647899,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07mvp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Rolling_Stones"
				},
				"name": "the Rolling Stones",
				"salience": 0.0036020263,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01dfb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citigroup"
				},
				"name": "Citi",
				"salience": 0.0033252602,
				"type": "ORGANIZATION"
			},
			{
				"name": "shirts",
				"salience": 0.0033079626,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.003063893,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hn9dw9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apartheid"
				},
				"name": "South African Apartheid",
				"salience": 0.0029761246,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01mpq7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beyonc%C3%A9"
				},
				"name": "Beyonce",
				"salience": 0.0029416394,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.0028779455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0026875478,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0025298446,
				"type": "LOCATION"
			},
			{
				"name": "decision",
				"salience": 0.002380048,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02sk3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Them_(band)"
				},
				"name": "Them",
				"salience": 0.0023276184,
				"type": "WORK_OF_ART"
			},
			{
				"name": "occupation",
				"salience": 0.0021552807,
				"type": "OTHER"
			},
			{
				"name": "pig balloon",
				"salience": 0.0019681705,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0019314239,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0019156565,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tour",
				"salience": 0.0018304284,
				"type": "EVENT"
			},
			{
				"name": "tour",
				"salience": 0.0018304284,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.0017980593,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0017980593,
				"type": "OTHER"
			},
			{
				"name": "Waters",
				"salience": 0.0017322511,
				"type": "OTHER"
			},
			{
				"name": "sisters",
				"salience": 0.0015571252,
				"type": "PERSON"
			},
			{
				"name": "love",
				"salience": 0.0015571252,
				"type": "OTHER"
			},
			{
				"name": "campuses",
				"salience": 0.0015571252,
				"type": "LOCATION"
			},
			{
				"name": "cancellation",
				"salience": 0.0015571252,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0015571252,
				"type": "ORGANIZATION"
			},
			{
				"name": "hope",
				"salience": 0.0015571252,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0015571252,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.0015571252,
				"type": "ORGANIZATION"
			},
			{
				"name": "brothers",
				"salience": 0.0015571252,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.0014551594,
				"type": "EVENT"
			},
			{
				"name": "sponsor",
				"salience": 0.0014551594,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS News",
				"salience": 0.001432771,
				"type": "ORGANIZATION"
			},
			{
				"name": "views",
				"salience": 0.001396472,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02r6qpb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boycott,_Divestment_and_Sanctions"
				},
				"name": "Boycott, Divestment and Sanctions",
				"salience": 0.0013700101,
				"type": "ORGANIZATION"
			},
			{
				"name": "pig",
				"salience": 0.0013605667,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.0013039542,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0013039542,
				"type": "OTHER"
			},
			{
				"name": "pre-sale",
				"salience": 0.0012770147,
				"type": "EVENT"
			},
			{
				"name": "human rights",
				"salience": 0.0012609299,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0012609299,
				"type": "OTHER"
			},
			{
				"name": "performance",
				"salience": 0.0012609299,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0012471725,
				"type": "PERSON"
			},
			{
				"name": "occupation",
				"salience": 0.0012340975,
				"type": "OTHER"
			},
			{
				"name": "performances",
				"salience": 0.0012138797,
				"type": "EVENT"
			},
			{
				"name": "line",
				"salience": 0.0010919146,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0010919146,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0010919146,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.0010919146,
				"type": "PERSON"
			},
			{
				"name": "set",
				"salience": 0.0010919146,
				"type": "OTHER"
			},
			{
				"name": "options",
				"salience": 0.0010511663,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0010511663,
				"type": "OTHER"
			},
			{
				"name": "contract",
				"salience": 0.0010511663,
				"type": "OTHER"
			},
			{
				"name": "spokesman",
				"salience": 0.0010511663,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.0010294457,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.0010294457,
				"type": "EVENT"
			},
			{
				"name": "solidarity",
				"salience": 0.0010294457,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0010294457,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0010036714,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0009836183,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tour",
				"salience": 0.0009836183,
				"type": "EVENT"
			},
			{
				"name": "article",
				"salience": 0.0009836183,
				"type": "WORK_OF_ART"
			},
			{
				"name": "artists",
				"salience": 0.0009836183,
				"type": "PERSON"
			},
			{
				"name": "representative",
				"salience": 0.0009618992,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/047876",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine_(region)"
				},
				"name": "Palestine",
				"salience": 0.00095859915,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkzf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jim_Crow_laws"
				},
				"name": "Jim Crow",
				"salience": 0.00095859915,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00095859915,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.00093781494,
				"type": "PERSON"
			},
			{
				"name": "sponsorship",
				"salience": 0.0009219715,
				"type": "OTHER"
			},
			{
				"name": "Emily Smith",
				"salience": 0.0008997164,
				"type": "PERSON"
			},
			{
				"name": "display",
				"salience": 0.0008914394,
				"type": "OTHER"
			},
			{
				"name": "living",
				"salience": 0.0008914394,
				"type": "OTHER"
			},
			{
				"name": "human beings",
				"salience": 0.0008914394,
				"type": "PERSON"
			},
			{
				"name": "outfit",
				"salience": 0.0008914394,
				"type": "OTHER"
			},
			{
				"name": "art",
				"salience": 0.0008914394,
				"type": "WORK_OF_ART"
			},
			{
				"name": "police oppression",
				"salience": 0.0008914394,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00084735575,
				"type": "OTHER"
			},
			{
				"name": "Derriba el muro",
				"salience": 0.0007925736,
				"type": "PERSON"
			},
			{
				"name": "kinds",
				"salience": 0.00073703966,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.0007277527,
				"type": "OTHER"
			},
			{
				"name": "tour",
				"salience": 0.00071640953,
				"type": "EVENT"
			},
			{
				"name": "artists",
				"salience": 0.00071640953,
				"type": "PERSON"
			},
			{
				"name": "artist",
				"salience": 0.00071640953,
				"type": "PERSON"
			},
			{
				"name": "sponsor",
				"salience": 0.00071545626,
				"type": "ORGANIZATION"
			},
			{
				"name": "paper",
				"salience": 0.00070952816,
				"type": "WORK_OF_ART"
			},
			{
				"name": "festival",
				"salience": 0.00070952816,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0m2l9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Neil_Young"
				},
				"name": "Neil Young",
				"salience": 0.00067212194,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02h71z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Coachella_Valley_Music_and_Arts_Festival"
				},
				"name": "Coachella",
				"salience": 0.00067212194,
				"type": "PERSON"
			},
			{
				"name": "Waters' Oldchella Desert Trip",
				"salience": 0.00067212194,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01vrncs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bob_Dylan"
				},
				"name": "Bob Dylan",
				"salience": 0.00067212194,
				"type": "PERSON"
			},
			{
				"name": "shows",
				"salience": 0.00067150174,
				"type": "EVENT"
			},
			{
				"name": "stakes",
				"salience": 0.0006659377,
				"type": "OTHER"
			},
			{
				"name": "clarification",
				"salience": 0.0006659377,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.0006659377,
				"type": "EVENT"
			},
			{
				"name": "Update",
				"salience": 0.0006659377,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.0006575462,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kzhd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Zionism"
				},
				"name": "anti-Israel",
				"salience": 0.0006470325,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0006203503,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00057193136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "Klan",
				"salience": 0.0005486911,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0005486911,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01skgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ignorance"
				},
				"name": "Ignorant",
				"salience": 0.0005486911,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.0005436421,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.00053240475,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.00053002645,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.00050161686,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0004996922,
				"type": "OTHER"
			},
			{
				"name": "concerts",
				"salience": 0.00048500055,
				"type": "EVENT"
			},
			{
				"name": "opportunity",
				"salience": 0.00048500055,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.00048500055,
				"type": "PERSON"
			},
			{
				"name": "acts",
				"salience": 0.00048500055,
				"type": "OTHER"
			},
			{
				"name": "cardmembers",
				"salience": 0.00048500055,
				"type": "PERSON"
			},
			{
				"name": "tickets",
				"salience": 0.00048500055,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hlzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citibank"
				},
				"name": "Citibank",
				"salience": 0.00044093753,
				"type": "ORGANIZATION"
			},
			{
				"name": "nerve",
				"salience": 0.00036228716,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00036228716,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.00036228716,
				"type": "OTHER"
			},
			{
				"name": "tless",
				"salience": 0.00036228716,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00036228716,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.00036228716,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.00036228716,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.00035321244,
				"type": "OTHER"
			},
			{
				"name": "http://mondoweiss.net/2016/10/american-express-palestinian/#sthash.cGAw7DW9.dpuf",
				"salience": 0.00029849086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0002873458,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.00025749597,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07qdg8t"
				},
				"name": "anti-Semite",
				"salience": 0.00022296027,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi",
				"salience": 0.00022296027,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/rogerWaters.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:00.615+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "American Express disowns Pink Floyd singer Roger Waters because of pro-Palestinian views 11/03/2016 \nMONDOWEISS When it comes to aiding Israeli Apartheid, American Express is just another brick in The Wall, according to a new report. Roger Waters, lead singer behind Pink Floyd, lost a multimillion dollar American Express sponsorship for his 2017 US+Them tour after expressing solidarity this month with Palestinian students trying to end Israel’s apartheid system of military occupation using the same protest tactic that helped dismantle South African Apartheid (and, earlier, America’s Jim Crow): Boycott, Divestment and Sanctions, or BDS. “I’m going to send out all of my most heartfelt love and support to all those young people on the campuses of the universities of California who are standing up for their brothers and sisters in Palestine and supporting the BDS movement,” Rogers said, according to CBS News , “in the hope that we may encourage the government of Israel to end the occupation.” American Express decided it would be a good idea to leak the cancellation of the contract to the New York Post , where Page Six’s Emily Smith has the exclusive story . “Roger is putting on a huge show. The company was asked to sponsor his tour for $4 million, but pulled out because it did not want to be part of his anti-Israel rhetoric,” an American Express spokesman told the paper. “We never committed to sponsoring Roger Waters’ upcoming tour. When we were approached with the options, we passed on making a bid.” American Express had helped sponsor Waters’ Oldchella Desert Trip festival (Coachella for the senior set featuring Neil Young, Bob Dylan, Paul McCartney, and the Rolling Stones) where he made the comments expressing support for human rights. But without anybody even asking them, American Express decided it had to go out of its way to bash Waters for “putting on a huge show.” Noteworthy about American Express’s decision is that it comes even as Waters included more mainstream political views, like featuring in the performance a line of children wearing shirts that said “Derriba el muro,” (Tear down the wall). He also showed Trump in a Klan outfit, and the show featured a floating pig balloon that calls the Republican candidate an “Ignorant, lying, racist, sexist pig,” CBS reported. Waters more mainstream kinds of leftist protest didn’t make up for his audacious display of solidarity with his fellow human beings living and dying under a ceaseless occupation. American Express has also sponsored Beyonce’s performances, where she has used art to make reference to police oppression of communities of color . But AmEx lost its nerve when Waters brought up Palestinian rights. According to the New York Post , Waters has known that there are consequences for standing up against the occupation, and that keeps others silent. “I have been accused of being a Nazi and an anti-Semite for the past 10 years. My industry has been particularly recalcitrant in even raising a voice [against Israel] . . . I’ve talked to a lot of them, and they are scared s – – tless. If they say something in public, they will no longer have a career. They will be destroyed,” he said, according to the Post. But Waters is already famous, and 75, so the stakes aren’t the same as for young artists. Update (11/1/16) This article originally quoted the New York Post as saying that Citi had assumed sponsorship of the tour after American Express dropped out, but after publication a representative of Citi contacted us with this clarification: In your article “ American Express disowns Pink Floyd singer Roger Waters because of pro-Palestinian views ”, it mentions that “Citibank grabbed the opportunity to sponsor one of the biggest and best acts of the 20th century.” However, Citi is not a sponsor of Roger Waters’ upcoming tour. Two weeks ago, Citi offered a limited time pre-sale of tickets for cardmembers for select shows, as we do for thousands of concerts by different artists every year. The pre-sale has ended and we have no plans to work with this artist in the future. \n– See more at: http://mondoweiss.net/2016/10/american-express-palestinian/#sthash.cGAw7DW9.dpuf",
		"thread_title": "American Express disowns Pink Floyd singer Roger Waters because of pro-Palestinian views",
		"title": "American Express disowns Pink Floyd singer Roger Waters because of pro-Palestinian views",
		"type": "bs",
		"uuid": "97a40d1daec7128514ab1388da0c6b12d115bf78"
	},
	"-KhIhIAoRPYqvmLbijqV": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:00.689+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Erin Schrode",
				"salience": 0.440631,
				"type": "PERSON"
			},
			{
				"name": "demonstrators",
				"salience": 0.10428192,
				"type": "PERSON"
			},
			{
				"name": "shoreline",
				"salience": 0.021237848,
				"type": "LOCATION"
			},
			{
				"name": "water protectors",
				"salience": 0.018943166,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.01890403,
				"type": "PERSON"
			},
			{
				"name": "pipeline",
				"salience": 0.018035304,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.015938433,
				"type": "PERSON"
			},
			{
				"name": "Police",
				"salience": 0.014864935,
				"type": "PERSON"
			},
			{
				"name": "pipeline protesters",
				"salience": 0.014374928,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock Sioux",
				"salience": 0.013554426,
				"type": "LOCATION"
			},
			{
				"name": "campground",
				"salience": 0.012374387,
				"type": "LOCATION"
			},
			{
				"name": "shoreline",
				"salience": 0.012008959,
				"type": "LOCATION"
			},
			{
				"name": "rubber bullets",
				"salience": 0.011261621,
				"type": "OTHER"
			},
			{
				"name": "rubber bullets",
				"salience": 0.011261621,
				"type": "OTHER"
			},
			{
				"name": "pepper spray",
				"salience": 0.00940475,
				"type": "OTHER"
			},
			{
				"name": "2016 KGW Police",
				"salience": 0.009183188,
				"type": "ORGANIZATION"
			},
			{
				"name": "riot gear",
				"salience": 0.008150195,
				"type": "OTHER"
			},
			{
				"name": "Morton County Sheriff's Department",
				"salience": 0.008027162,
				"type": "ORGANIZATION"
			},
			{
				"name": "Cempoalli Twenny",
				"salience": 0.007925664,
				"type": "PERSON"
			},
			{
				"name": "E'sha Hoferer",
				"salience": 0.007288441,
				"type": "PERSON"
			},
			{
				"name": "river",
				"salience": 0.0071039596,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.006842449,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.0062521105,
				"type": "PERSON"
			},
			{
				"name": "hill",
				"salience": 0.0061679566,
				"type": "LOCATION"
			},
			{
				"name": "Cantapeta Creek",
				"salience": 0.0058016726,
				"type": "LOCATION"
			},
			{
				"name": "oil pipeline",
				"salience": 0.005770538,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.005469032,
				"type": "PERSON"
			},
			{
				"name": "hill",
				"salience": 0.0054578935,
				"type": "LOCATION"
			},
			{
				"name": "river action",
				"salience": 0.0053323796,
				"type": "EVENT"
			},
			{
				"name": "Standing Rock Sioux Indian Reservation",
				"salience": 0.0050260937,
				"type": "LOCATION"
			},
			{
				"name": "social media",
				"salience": 0.004171867,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.004171867,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/093d58y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Josh_Fox"
				},
				"name": "Josh Fox",
				"salience": 0.0039488394,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.0031406758,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0030790654,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.003053948,
				"type": "LOCATION"
			},
			{
				"name": "river",
				"salience": 0.0029312475,
				"type": "LOCATION"
			},
			{
				"name": "river",
				"salience": 0.0029312475,
				"type": "LOCATION"
			},
			{
				"name": "bridge",
				"salience": 0.0028843582,
				"type": "OTHER"
			},
			{
				"name": "Demonstrators",
				"salience": 0.0026476171,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.0025700333,
				"type": "LOCATION"
			},
			{
				"name": "water",
				"salience": 0.0022753614,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.002207752,
				"type": "ORGANIZATION"
			},
			{
				"name": "water protector",
				"salience": 0.0021615725,
				"type": "OTHER"
			},
			{
				"name": "trespass",
				"salience": 0.0020666416,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0020560645,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0019793834,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.001960387,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0018806894,
				"type": "PERSON"
			},
			{
				"name": "Officers",
				"salience": 0.0018806894,
				"type": "PERSON"
			},
			{
				"name": "officers",
				"salience": 0.0018806894,
				"type": "PERSON"
			},
			{
				"name": "demonstrators",
				"salience": 0.0018806894,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0018431839,
				"type": "PERSON"
			},
			{
				"name": "site",
				"salience": 0.001810541,
				"type": "OTHER"
			},
			{
				"name": "demonstrators",
				"salience": 0.001810541,
				"type": "PERSON"
			},
			{
				"name": "water protectors",
				"salience": 0.0017427166,
				"type": "PERSON"
			},
			{
				"name": "stream",
				"salience": 0.0017193718,
				"type": "LOCATION"
			},
			{
				"name": "base",
				"salience": 0.0017193718,
				"type": "OTHER"
			},
			{
				"name": "prayer",
				"salience": 0.0017193718,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.0017141755,
				"type": "ORGANIZATION"
			},
			{
				"name": "water",
				"salience": 0.00167877,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0016690542,
				"type": "EVENT"
			},
			{
				"name": "camp",
				"salience": 0.0016690542,
				"type": "EVENT"
			},
			{
				"name": "law enforcement",
				"salience": 0.00162945,
				"type": "ORGANIZATION"
			},
			{
				"name": "camp",
				"salience": 0.0016067909,
				"type": "EVENT"
			},
			{
				"name": "rubber bullet",
				"salience": 0.0016067909,
				"type": "OTHER"
			},
			{
				"name": "rubber bullet",
				"salience": 0.0016067909,
				"type": "OTHER"
			},
			{
				"name": "police line",
				"salience": 0.0015419933,
				"type": "OTHER"
			},
			{
				"name": "press release",
				"salience": 0.0015419933,
				"type": "WORK_OF_ART"
			},
			{
				"name": "site",
				"salience": 0.001535543,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0015116618,
				"type": "PERSON"
			},
			{
				"name": "shoreline",
				"salience": 0.0014537997,
				"type": "LOCATION"
			},
			{
				"name": "police line",
				"salience": 0.0014473094,
				"type": "OTHER"
			},
			{
				"name": "pedestrian bridge",
				"salience": 0.0014188385,
				"type": "LOCATION"
			},
			{
				"name": "protesters",
				"salience": 0.0014049461,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.0013923377,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0013923377,
				"type": "ORGANIZATION"
			},
			{
				"name": "pepper spray",
				"salience": 0.0013923377,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0013439928,
				"type": "PERSON"
			},
			{
				"name": "release",
				"salience": 0.0013413242,
				"type": "WORK_OF_ART"
			},
			{
				"name": "back",
				"salience": 0.0013403879,
				"type": "OTHER"
			},
			{
				"name": "point blank range",
				"salience": 0.0013403879,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.0013403879,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.0013020604,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.0012602198,
				"type": "OTHER"
			},
			{
				"name": "police pepper",
				"salience": 0.0012589515,
				"type": "PERSON"
			},
			{
				"name": "tear gas",
				"salience": 0.0012057202,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.0012057202,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0012057202,
				"type": "PERSON"
			},
			{
				"name": "standoff",
				"salience": 0.001202915,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.0011607278,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.0011607278,
				"type": "EVENT"
			},
			{
				"name": "bottles",
				"salience": 0.0011461063,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "burial ground",
				"salience": 0.0011367446,
				"type": "OTHER"
			},
			{
				"name": "creek",
				"salience": 0.0011367446,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0011367446,
				"type": "PERSON"
			},
			{
				"name": "hill",
				"salience": 0.0011282472,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.001122425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0010585181,
				"type": "OTHER"
			},
			{
				"name": "provocation",
				"salience": 0.0010355687,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.0009843617,
				"type": "OTHER"
			},
			{
				"name": "Law enforcement vehicles",
				"salience": 0.0009843617,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "kind",
				"salience": 0.0009843617,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0009843617,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0009843617,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.0009843617,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0009810346,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.0009733683,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.00094053947,
				"type": "EVENT"
			},
			{
				"name": "press release",
				"salience": 0.00094053947,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sites",
				"salience": 0.00091315195,
				"type": "OTHER"
			},
			{
				"name": "clash",
				"salience": 0.00090076315,
				"type": "EVENT"
			},
			{
				"name": "standoff",
				"salience": 0.0008761647,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.0008492231,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0008492231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n353",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morton_County,_North_Dakota"
				},
				"name": "Morton County",
				"salience": 0.000846384,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0008355975,
				"type": "OTHER"
			},
			{
				"name": "burial sites",
				"salience": 0.0008355975,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0008355975,
				"type": "OTHER"
			},
			{
				"name": "demonstrators",
				"salience": 0.0008355975,
				"type": "PERSON"
			},
			{
				"name": "drums",
				"salience": 0.0008036202,
				"type": "OTHER"
			},
			{
				"name": "law enforcement move",
				"salience": 0.0008036202,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.000791095,
				"type": "ORGANIZATION"
			},
			{
				"name": "hill",
				"salience": 0.000791095,
				"type": "LOCATION"
			},
			{
				"name": "pipeline",
				"salience": 0.00074150757,
				"type": "OTHER"
			},
			{
				"name": "state laws",
				"salience": 0.0007353637,
				"type": "OTHER"
			},
			{
				"name": "boat",
				"salience": 0.0007353637,
				"type": "OTHER"
			},
			{
				"name": "gun",
				"salience": 0.0007353637,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "police",
				"salience": 0.0007328777,
				"type": "ORGANIZATION"
			},
			{
				"name": "river",
				"salience": 0.00068247673,
				"type": "LOCATION"
			},
			{
				"name": "river",
				"salience": 0.00068247673,
				"type": "LOCATION"
			},
			{
				"name": "river",
				"salience": 0.00068247673,
				"type": "LOCATION"
			},
			{
				"name": "public information officer",
				"salience": 0.0006242139,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.0006185063,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0006185063,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0005634384,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.000549327,
				"type": "OTHER"
			},
			{
				"name": "grandchildren",
				"salience": 0.00053556886,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00053556886,
				"type": "PERSON"
			},
			{
				"name": "encounter",
				"salience": 0.00053556886,
				"type": "EVENT"
			},
			{
				"name": "center",
				"salience": 0.00053556886,
				"type": "LOCATION"
			},
			{
				"name": "construction",
				"salience": 0.00053556886,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0005117192,
				"type": "OTHER"
			},
			{
				"name": "mallet",
				"salience": 0.0004658303,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00046202354,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00046202354,
				"type": "LOCATION"
			},
			{
				"name": "Walker River Paiute Tribe",
				"salience": 0.00045260406,
				"type": "LOCATION"
			},
			{
				"name": "someone",
				"salience": 0.00040006367,
				"type": "PERSON"
			},
			{
				"name": "might",
				"salience": 0.00040006367,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00040006367,
				"type": "OTHER"
			},
			{
				"name": "orders",
				"salience": 0.00030265053,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0l9wb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army_Corps_of_Engineers"
				},
				"name": "U.S. Army Corps of Engineers",
				"salience": 0.0002462108,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.00022245155,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/DAPL-rubber-bullets_1478191133143_6732759_ver1.0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:00.689+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Police fire rubber bullets at pipeline protesters 11/03/2016 \nKGW \nPolice in riot gear shot rubber bullets and used pepper spray on demonstrators — who call themselves water protectors — on the shoreline of the Cantapeta Creek, just north of the Standing Rock Sioux Indian Reservation on Wednesday. \nAfter a few relatively peaceful days at the campground, where thousands have gathered to demonstrate against a controversial North Dakota oil pipeline, demonstrators put out calls on social media to “make your way to the river” for a “river action,” but to do so “in prayer.” \nIn a Facebook Live stream, Cempoalli Twenny , who says he is at Standing Rock to protect the water, said, “The pipeline is getting really close to the river now, so it’s crunch time.” \nDemonstrators on the shoreline prayed, played drums, sang, and waded into the river towards the base of the hill where armed police stood. \nIt was a “100 percent peaceful protest,” according to activist Erin Schrode, who was shot in the lower back with a rubber bullet while standing on the shoreline opposite police. Schrode had joined others from the camp in solidarity as they prayed on the shoreline. \nA confrontation erupted after law enforcement dismantled a wooden bridge that demonstrators constructed to access the sacred site. \n“I was shot in point blank range,” said Schrode, who says she is shaken but physically will recover. “Another water protector was also shot at twice at point blank range, but the rubber bullet hit the water, and not him.” \nIn a press release, the Morton County Sheriff’s Department said it used “less-than-lethal ammunition to control the situation” when a man threw bottles at officers on the police line and when another charged the police line. “Officers also deployed pepper spray and tear gas to disperse the group of protesters who came across the water and camp at officers,” the release said. \nEven as law enforcement warned protesters to leave the area and return to their camp, demonstrators could be heard yelling back at police. \n“There was absolutely no provocation of any kind,” said film director Josh Fox, who was also on scene. “The police pepper sprayed people sitting in the water.” \nLaw enforcement vehicles and personnel have been stationed on a hill overlooking the shoreline in question for a number of days, and the hill is recognized as a burial ground and sacred site by the Standing Rock Sioux. \nOn Monday, people who identified themselves as water protectors waded across the creek to the hill to request that law enforcement move off the sacred area. \nAccording to the Morton County Sheriff’s Department public information officer, the police remained there “to prevent criminal trespass on private property.” \nWednesday, the Department said The U.S. Army Corps of Engineers gave Morton County orders to remove a wooden pedestrian bridge that had been constructed across the river and arrest any individuals who cross the river for criminal trespass. \n“I was facing the line of officers from across the river and all of a sudden, I felt as if someone swung a mallet with all their might against my lower back. It obliterated me,” said Schrode. “I turned around and I had no idea what just happened. And there was an officer pointing his gun in my direction from a boat.” \nMorton County called the situation a “standoff” and, in a press release, stated that “protesters involved in this activity are violating numerous federal and state laws.” \nE’sha Hoferer , who is a member of the Walker River Paiute Tribe and who says he is in Standing Rock to protect the water for his children and grandchildren, told NBC News before Wednesday’s encounter with law enforcement that the construction of the pipeline is “desecrating a lot of sacred sites” and that “a lot of the traditional ecological knowledge that we have – that Standing Rock has – shows that we have ceremonial sites up there, sacred sites, burial sites,” referring to the hill at the center of the standoff. \nThe last big clash between police and demonstrators took place on Thursday, October 27, when 141 protesters were arrested .",
		"thread_title": "Police fire rubber bullets at pipeline protesters",
		"title": "Police fire rubber bullets at pipeline protesters",
		"type": "bs",
		"uuid": "3049896a83c35e20cdb82e11c6334f2a1f81c195"
	},
	"-KhIhIN3SViyPSgHm2Db": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:00.760+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.22210072,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.14619559,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.080812946,
				"type": "ORGANIZATION"
			},
			{
				"name": "Report",
				"salience": 0.049816705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.047852103,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0475602,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.043156024,
				"type": "PERSON"
			},
			{
				"name": "indictment",
				"salience": 0.038877446,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0322529,
				"type": "EVENT"
			},
			{
				"name": "Clinton Foundation Probe Will 'Likely",
				"salience": 0.03042326,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06c5nr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Epoch_Times"
				},
				"name": "EPOCH TIMES",
				"salience": 0.021794824,
				"type": "ORGANIZATION"
			},
			{
				"name": "Sources",
				"salience": 0.021583112,
				"type": "PERSON"
			},
			{
				"name": "law enforcement agency",
				"salience": 0.018671444,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06rgxb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bret_Baier"
				},
				"name": "Bret Baier",
				"salience": 0.017639067,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.010601527,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.009227223,
				"type": "PERSON"
			},
			{
				"name": "news outlet",
				"salience": 0.008793104,
				"type": "ORGANIZATION"
			},
			{
				"name": "Agents",
				"salience": 0.007824498,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.007668733,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.007494675,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0074440055,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0066934307,
				"type": "EVENT"
			},
			{
				"name": "priority",
				"salience": 0.0064927056,
				"type": "OTHER"
			},
			{
				"name": "avalanche",
				"salience": 0.0058679716,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.0051320926,
				"type": "EVENT"
			},
			{
				"name": "foundation case",
				"salience": 0.0050640316,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0050640316,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0047568567,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.004556036,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.004556036,
				"type": "OTHER"
			},
			{
				"name": "division",
				"salience": 0.0043862755,
				"type": "ORGANIZATION"
			},
			{
				"name": "secretary of state",
				"salience": 0.0043862755,
				"type": "PERSON"
			},
			{
				"name": "links",
				"salience": 0.0043862755,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004295777,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.004295777,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0039545954,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0037206435,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.0037206435,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0032104068,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0031054562,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.002975459,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Yes",
				"salience": 0.0027803765,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0027803765,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.0027803765,
				"type": "OTHER"
			},
			{
				"name": "hackers",
				"salience": 0.0027803765,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White-collar_crime"
				},
				"name": "White Collar Crime",
				"salience": 0.0027015198,
				"type": "ORGANIZATION"
			},
			{
				"name": "indictment",
				"salience": 0.0025902165,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.002474978,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.0022912507,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0020254783,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0019353398,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interviews",
				"salience": 0.0017475,
				"type": "EVENT"
			},
			{
				"name": "obstruction",
				"salience": 0.0016747845,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.0015132705,
				"type": "OTHER"
			},
			{
				"name": "aides",
				"salience": 0.0015132705,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/GettyImages-460497956-676x450.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:00.760+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Report: FBI’s Clinton Foundation Probe Will ‘Likely’ Lead to Indictment 11/03/2016 \nEPOCH TIMES \nThe FBI investigation into the Clinton Foundation is likely to lead to an indictment, sources with the federal law enforcement agency said. \nThose sources said that the probe into the Clinton Foundation is being taken as a “very high priority,” reported Fox News on Wednesday evening. The news outlet described them as “separate sources” within the agency. \nAgents have interviewed several people involved in the foundation case, looking for possible pay-to-play links between then-secretary of state Hillary Clinton and the Clinton Foundation. The White Collar Crime division of the FBI is conducting the investigation. \n“There is an avalanche of new information coming in every day,” a source told Fox News. \nSources, meanwhile, told Fox that FBI agents collected a significant amount of evidence even before WikiLeaks started releasing emails linked to the Democratic National Committee and the Clinton campaign. \nAs FBI agents are “actively and aggressively pursuing this case,” they’ll interview the same people again—possibly some for a third time, the report stated. They’ll also look into what Hillary Clinton and her aides told them in previous interviews. \nWhile on the air, Fox News reporter Bret Baier, citing unnamed sources, said that Clinton’s private email server has been breached by at least five separate foreign intelligence hackers. \n“I pressed again and again on this very issue, and these sources said, ‘Yes, the investigations will continue’” if Clinton defeats rival Donald Trump on Election Day, Baier said on Fox News. \n“And barring some obstruction in some way, they believe they’ll continue to likely an indictment,” Baier added .",
		"thread_title": "Report: FBI’s Clinton Foundation Probe Will ‘Likely’ Lead to Indictment",
		"title": "Report: FBI’s Clinton Foundation Probe Will ‘Likely’ Lead to Indictment",
		"type": "bs",
		"uuid": "bbc70ee7305eb66ae0663646d3d4b41abea8cbd9"
	},
	"-KhIhJ-Mv8zg0XBYxX2e": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:00.833+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.5533098,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar Assad",
				"salience": 0.11302474,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.083806045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.020494796,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.017110018,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.008718048,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.006544652,
				"type": "ORGANIZATION"
			},
			{
				"name": "proxy war",
				"salience": 0.0058883326,
				"type": "EVENT"
			},
			{
				"name": "terrorists",
				"salience": 0.005607984,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0054344675,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0051021636,
				"type": "PERSON"
			},
			{
				"name": "hills",
				"salience": 0.0048592733,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.0046162717,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00368943,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0036630495,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0032106517,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/050tsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deir_ez-Zor"
				},
				"name": "Deir Ez-Zor",
				"salience": 0.0032025075,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02sgpz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politika"
				},
				"name": "Politika",
				"salience": 0.0031767425,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist groups",
				"salience": 0.003003444,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.002964841,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.0028863242,
				"type": "OTHER"
			},
			{
				"name": "motives",
				"salience": 0.0028863242,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0028863242,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0026940363,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0026105426,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0026049786,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0024410645,
				"type": "EVENT"
			},
			{
				"name": "mask",
				"salience": 0.0023150519,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0023085761,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.0023005335,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.0023005335,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.0020014278,
				"type": "WORK_OF_ART"
			},
			{
				"name": "collaboration",
				"salience": 0.0019007043,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0018745237,
				"type": "EVENT"
			},
			{
				"name": "groups",
				"salience": 0.0018101027,
				"type": "ORGANIZATION"
			},
			{
				"name": "news agency",
				"salience": 0.0017035306,
				"type": "ORGANIZATION"
			},
			{
				"name": "things",
				"salience": 0.0017035306,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0017035306,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0015896782,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.001571804,
				"type": "OTHER"
			},
			{
				"name": "fingerprint",
				"salience": 0.001523172,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.0014753252,
				"type": "EVENT"
			},
			{
				"name": "failure",
				"salience": 0.0014753252,
				"type": "OTHER"
			},
			{
				"name": "initiative",
				"salience": 0.0014753252,
				"type": "OTHER"
			},
			{
				"name": "moving",
				"salience": 0.0014753252,
				"type": "OTHER"
			},
			{
				"name": "attrition",
				"salience": 0.0014753252,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.001356162,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.0013263988,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0012478732,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0011080436,
				"type": "OTHER"
			},
			{
				"name": "innocents",
				"salience": 0.0010892304,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0010756117,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0010756117,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.00103231,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.0009970111,
				"type": "EVENT"
			},
			{
				"name": "pictures",
				"salience": 0.0009940234,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.00095238315,
				"type": "PERSON"
			},
			{
				"name": "ceasefire",
				"salience": 0.0009477206,
				"type": "EVENT"
			},
			{
				"name": "ceasefires",
				"salience": 0.0009477206,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.0009477206,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0009477206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03b_7cq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Arab_News_Agency"
				},
				"name": "SANA",
				"salience": 0.0009083365,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/077qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Serbia"
				},
				"name": "Serbian",
				"salience": 0.0009083365,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.0008828914,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00087099365,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00087099365,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00087099365,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0008410339,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0007970318,
				"type": "EVENT"
			},
			{
				"name": "everything",
				"salience": 0.0007769865,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0007769865,
				"type": "PERSON"
			},
			{
				"name": "coalition",
				"salience": 0.00076323876,
				"type": "ORGANIZATION"
			},
			{
				"name": "targets",
				"salience": 0.0007536235,
				"type": "OTHER"
			},
			{
				"name": "hills",
				"salience": 0.0007325329,
				"type": "LOCATION"
			},
			{
				"name": "mistake",
				"salience": 0.0007195712,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.000702752,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0007015543,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0007015543,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0007015543,
				"type": "OTHER"
			},
			{
				"name": "truce",
				"salience": 0.0007015543,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0007015543,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0007015543,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.000664535,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.000664535,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.00064595306,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0006291443,
				"type": "EVENT"
			},
			{
				"name": "terrorists",
				"salience": 0.00061575236,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0006112661,
				"type": "PERSON"
			},
			{
				"name": "armament",
				"salience": 0.00060749886,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.00060749886,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.00060749886,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.00060749886,
				"type": "OTHER"
			},
			{
				"name": "bargain",
				"salience": 0.00060749886,
				"type": "OTHER"
			},
			{
				"name": "air campaign",
				"salience": 0.00060749886,
				"type": "EVENT"
			},
			{
				"name": "promise",
				"salience": 0.00060749886,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00060749886,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0005922865,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00058970967,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00057273696,
				"type": "LOCATION"
			},
			{
				"name": "position",
				"salience": 0.00057273696,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00056845456,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0005676982,
				"type": "ORGANIZATION"
			},
			{
				"name": "same",
				"salience": 0.0005447918,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0005447918,
				"type": "LOCATION"
			},
			{
				"name": "government forces",
				"salience": 0.0005447918,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.00054251164,
				"type": "LOCATION"
			},
			{
				"name": "order",
				"salience": 0.00054251164,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.0005375515,
				"type": "WORK_OF_ART"
			},
			{
				"name": "guy",
				"salience": 0.0005375515,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0005269739,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/087vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yugoslavia"
				},
				"name": "Yugoslavia",
				"salience": 0.0005269739,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0005269739,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.00052445615,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00052445615,
				"type": "OTHER"
			},
			{
				"name": "mask",
				"salience": 0.00052445615,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00052174897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00050730375,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.00050487916,
				"type": "OTHER"
			},
			{
				"name": "truce",
				"salience": 0.00049816904,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.0004959438,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.0004918916,
				"type": "OTHER"
			},
			{
				"name": "partitioning",
				"salience": 0.0004918916,
				"type": "EVENT"
			},
			{
				"name": "guy",
				"salience": 0.0004918916,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0004918916,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.0004918916,
				"type": "EVENT"
			},
			{
				"name": "allies",
				"salience": 0.0004918916,
				"type": "ORGANIZATION"
			},
			{
				"name": "atrocities",
				"salience": 0.0004918916,
				"type": "OTHER"
			},
			{
				"name": "mistake",
				"salience": 0.00047352965,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00047352965,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0004596084,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00044750544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00044688227,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.000444747,
				"type": "PERSON"
			},
			{
				"name": "civilization",
				"salience": 0.000444747,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0004428854,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.00042814427,
				"type": "OTHER"
			},
			{
				"name": "wrongdoing",
				"salience": 0.00042593403,
				"type": "OTHER"
			},
			{
				"name": "aggressors",
				"salience": 0.00042593403,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.00042593403,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00042593403,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.00042593403,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00041216108,
				"type": "PERSON"
			},
			{
				"name": "suffering",
				"salience": 0.00041003333,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.00041003333,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.00040526348,
				"type": "LOCATION"
			},
			{
				"name": "order",
				"salience": 0.00040526348,
				"type": "OTHER"
			},
			{
				"name": "ordeal",
				"salience": 0.00040526348,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0004015577,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0004015577,
				"type": "LOCATION"
			},
			{
				"name": "mainstream media",
				"salience": 0.0004015577,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.00039867937,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00038688185,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00038688185,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00038688185,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00038688185,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00038688185,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00038688185,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.00038539743,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.00038169505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0003739135,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0003739135,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.00036306816,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.000359622,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000359622,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0003477091,
				"type": "EVENT"
			},
			{
				"name": "approach",
				"salience": 0.0003477091,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.0003477091,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0003477091,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0003477091,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.0003477091,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.00033752492,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.0003350007,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00033222444,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.00033222444,
				"type": "OTHER"
			},
			{
				"name": "differences",
				"salience": 0.00033222444,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.00033222444,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.0003305092,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.00030016885,
				"type": "ORGANIZATION"
			},
			{
				"name": "places",
				"salience": 0.00029995915,
				"type": "LOCATION"
			},
			{
				"name": "thinking",
				"salience": 0.00029995915,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0002990518,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00029514494,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.00028899548,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.00028067554,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01jgp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balkan_Wars"
				},
				"name": "Balkan Wars",
				"salience": 0.00026214414,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00026214414,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.00026214414,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.00026190223,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00026190223,
				"type": "PERSON"
			},
			{
				"name": "each other",
				"salience": 0.00026190223,
				"type": "PERSON"
			},
			{
				"name": "each other",
				"salience": 0.00026190223,
				"type": "PERSON"
			},
			{
				"name": "beliefs",
				"salience": 0.0002597316,
				"type": "OTHER"
			},
			{
				"name": "traditions",
				"salience": 0.0002597316,
				"type": "OTHER"
			},
			{
				"name": "rituals",
				"salience": 0.0002597316,
				"type": "OTHER"
			},
			{
				"name": "ethnicities",
				"salience": 0.0002597316,
				"type": "OTHER"
			},
			{
				"name": "sects",
				"salience": 0.0002597316,
				"type": "OTHER"
			},
			{
				"name": "colors",
				"salience": 0.0002597316,
				"type": "OTHER"
			},
			{
				"name": "multiconfessional entity",
				"salience": 0.0002597316,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.00025235652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00024917585,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.00023810592,
				"type": "LOCATION"
			},
			{
				"name": "aspect",
				"salience": 0.00022981767,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0002290155,
				"type": "LOCATION"
			},
			{
				"name": "aspects",
				"salience": 0.00021844826,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00021844826,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.00021399414,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.00021399414,
				"type": "PERSON"
			},
			{
				"name": "effect",
				"salience": 0.00021202465,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.00021043881,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00020935222,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.00020871889,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.00020871889,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.00019750667,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.00018915023,
				"type": "OTHER"
			},
			{
				"name": "lesson",
				"salience": 0.00018915023,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.00018915023,
				"type": "OTHER"
			},
			{
				"name": "extremist",
				"salience": 0.00018915023,
				"type": "PERSON"
			},
			{
				"name": "spite",
				"salience": 0.00018915023,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00018072555,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00018072555,
				"type": "LOCATION"
			},
			{
				"name": "policy",
				"salience": 0.00018072555,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00018072555,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00018072555,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00016317148,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.00015984428,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.00015984428,
				"type": "PERSON"
			},
			{
				"name": "hopes",
				"salience": 0.00014128615,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.00014128615,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.00014128615,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00014128615,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00014128615,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00014128615,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.00010474339,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.000096565534,
				"type": "LOCATION"
			},
			{
				"name": "United Nation's Charter",
				"salience": 0.00008694682,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/581b06c4c46188051c8b45aa.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:00.833+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 19.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Assad: US waging proxy war in Syria against Russia & Iran 11/03/2016 \nBLACKLISTEDNEWS.COM Despite claiming humanitarian motives, US actions in Syria are meant to undermine the power of Russia and Iran, with Washington trying to achieve this goal by directly supporting terrorists, Syrian President Bashar Assad has said. The US’ secret collaboration with terrorists is the reason why all attempts at a ceasefire and political transition in Syria have so far failed, the Syrian leader told Serbian newspaper Politika. The interview was also published by the Syria’s SANA news agency.\n“Supporting the terrorists is a war of attrition against Syria, against Iran, against Russia, that’s how they look at it. That’s why not only this ceasefire – every attempt regarding ceasefire or political moving or political initiative, every failure of these things, the United States was to blame,” the Syrian president said. \nAssad was referring to the deal negotiated by the US and Russia in September, which it was hoped would pave the way for a lasting truce in Syria. In practice, the agreement was derailed by armed groups, which had rejected it from the very beginning. The US pledged to convince the so-called moderate opposition to stick to the bargain and separate from terrorists, who would then be legitimate targets for a joint Russian-American air campaign. Washington didn’t deliver on this promise, however. \nAccording to the Syrian president, a lasting ceasefire was not what Washington sought from the deal in the first place. \n“They always ask for ceasefire only when the terrorists are in a bad situation, not for the civilians. And they try to use those ceasefires in order to support the terrorists, bring them logistic support, armament, money, everything, in order to re-attack and to become stronger again,” he said. \nSometimes the US support for terrorist groups goes through its allies such as Turkey, Saudi Arabia and Qatar, Assad believes, while occasionally they provide direct support even to Islamic State (IS, formerly ISIS/ISIL), a group that the Washington-led coalition was supposedly formed to defeat. An example of this came during an American attack on Syrian Army troops near Deir Ez-Zor, which happened while the US-Russian truce was in force, and which the US claimed was the result of a mistake. \n“They attacked a very big area. They didn’t attack a building to say, ‘we made a mistake.’ They attacked three big hills, not other groups neighboring these hills,” he said. “In less than one hour, ISIS attacked those hills. It means that ISIS gathered their forces to attack those hills. How did ISIS know that the Americans would attack that Syrian position? It means they were ready, they were prepared.” \nHumanitarian mask, like in Yugoslavia, Afghanistan or Iraq Western media are currently focusing on civilian suffering in Syria and alleged atrocities committed by the Syrian government and its allies to justify deeper involvement in the war by whatever means the White House chooses, Assad said in the interview. \n“You have a black-and-white picture; very, very bad guy against very, very good guy. It’s like the narrative of George W. Bush during the war on Iraq and on Afghanistan,” he described. \n“The war in your country has been portrayed in the same way; as a humanitarian war where the West wanted to intervene in order to protect a certain community against the aggressors from the other community,” Assad said, referring to the Balkan Wars and the partitioning of Yugoslavia. “So, many people in the world believe that story, the same in Syria; they use the same mask, the humanitarian mask.” \nWhile stressing any wrongdoing on the part of the government forces, the West ignores whatever atrocities the opposition commits, the president said. \n“The terrorists killed during the last three days more than 80 innocent civilians in Aleppo, and wounded more than 300. You don’t read anything about them in the Western mainstream media,” he said. “They only single out some pictures and some incidents in the area under the control of the terrorists just to use them for their political agenda in order to condemn and to blame the Syrian government, not because they are worried about the Syrians.” \n“They don’t care about our children, or about innocents, and about civilization, about infrastructure,” he added. “But actually, they only care about using everything that would serve their vested interests.” \nThe Syrian president doesn’t expect the US approach to Syria to change, regardless of who wins the presidential election next week, he told the newspaper. Both Hillary Clinton and Donald Trump would be bad for his country, he said. \n“We don’t see any good signs that the United States is going to change dramatically its policy toward what’s happening in the world… or to obey the international law, or to care about the United Nation’s Charter,” he said. \n“It’s not about who’s going to be president; the difference will be very minimal, each one of them is going to be allowed to leave his own fingerprint, just personal fingerprint, but doesn’t mean change of policies. That’s why we don’t pin our hopes, we don’t waste our time with it.” \nA year without interference to stop war Assad reiterated his assessment that if Syria were left to settle its problems without foreign interference, it would take it no more than a year to end the conflict, saying that “it is not very complicated internally.” \n“Of course, that looks not realistic, because everybody knows that the United States wanted to undermine the position of Russia as a great power in the world, including in Syria. Saudi Arabia has been looking how to destroy Iran for years now, and Syria could be one of the places where they can achieve that, according to their way of thinking,” he said. \n“But if we say that we could achieve that situation where all those foreign powers leave Syria alone, we don’t have a problem in solving our problem.” \nThe president said Syria has existed as a multiethnic multiconfessional entity for centuries and has significant experience in overcoming differences. \n“Without all different colors of the society – Christians, Muslims, and the different sects and ethnicities – you won’t have Syria. So, every Syrian citizen should feel fully free in practicing his rituals, his traditions, his beliefs. He should be free in order to have a stable country. Otherwise you won’t have Syria as a stable country,” Assad said. \nThe war has been a huge ordeal for Syrian society, but it has made Syrians as a nation more united, not less, he added. \n“Many Syrians before the war didn’t tell the difference between being fanatic and being extremist, between being extremist and being terrorist. Those borders weren’t clear for many,” the president said. “Because of the war, because of the destruction, because of the heavy price that affected every Syrian, many Syrians learned the lesson and now they know that the only way to protect the country and to preserve the country is to be homogenous, to live with each other, to integrate, to accept, to love each other.” \n“That’s why I think the effect of the war, in spite of all the bad aspects of any war like this war, but this aspect was positive for the Syrian society. So, I’m not worried about the structure of Syrian society after the war. I think it’s going to be healthier,” Assad added.",
		"thread_title": "Assad: US waging proxy war in Syria against Russia & Iran",
		"title": "Assad: US waging proxy war in Syria against Russia & Iran",
		"type": "bs",
		"uuid": "afa2e02588d28111096bc6a8fd36e0d2a8d4619f"
	},
	"-KhIhJExoic836DZ_oPY": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:01.253+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "effect",
				"salience": 0.1596613,
				"type": "OTHER"
			},
			{
				"name": "moon",
				"salience": 0.10637795,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA TODAY",
				"salience": 0.089781225,
				"type": "ORGANIZATION"
			},
			{
				"name": "supermoon",
				"salience": 0.073665686,
				"type": "EVENT"
			},
			{
				"name": "moon",
				"salience": 0.06825303,
				"type": "LOCATION"
			},
			{
				"name": "moon",
				"salience": 0.0657594,
				"type": "LOCATION"
			},
			{
				"name": "supermoon",
				"salience": 0.06348049,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gh7ht6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supermoon"
				},
				"name": "Richard Nolle",
				"salience": 0.042312358,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08nf7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slooh"
				},
				"name": "Slooh.com",
				"salience": 0.035950646,
				"type": "OTHER"
			},
			{
				"name": "moon",
				"salience": 0.033088356,
				"type": "LOCATION"
			},
			{
				"name": "moon",
				"salience": 0.020650126,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.019067014,
				"type": "LOCATION"
			},
			{
				"name": "supermoon",
				"salience": 0.01789643,
				"type": "OTHER"
			},
			{
				"name": "beaver moon",
				"salience": 0.017528504,
				"type": "LOCATION"
			},
			{
				"name": "supermoon",
				"salience": 0.015188976,
				"type": "OTHER"
			},
			{
				"name": "beaver moon",
				"salience": 0.014689802,
				"type": "LOCATION"
			},
			{
				"name": "term",
				"salience": 0.012605751,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.012136869,
				"type": "OTHER"
			},
			{
				"name": "beaver traps",
				"salience": 0.0104287965,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.01029777,
				"type": "OTHER"
			},
			{
				"name": "astronomy site",
				"salience": 0.01029777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_qpw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AccuWeather"
				},
				"name": "AccuWeather",
				"salience": 0.00776956,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mark Paquette",
				"salience": 0.00776956,
				"type": "PERSON"
			},
			{
				"name": "tribes",
				"salience": 0.0076982207,
				"type": "PERSON"
			},
			{
				"name": "supply",
				"salience": 0.0076982207,
				"type": "OTHER"
			},
			{
				"name": "swamps",
				"salience": 0.0076982207,
				"type": "OTHER"
			},
			{
				"name": "colonists",
				"salience": 0.0076982207,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05f4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NASA"
				},
				"name": "NASA",
				"salience": 0.0074801184,
				"type": "ORGANIZATION"
			},
			{
				"name": "moon",
				"salience": 0.0071456167,
				"type": "LOCATION"
			},
			{
				"name": "winter furs",
				"salience": 0.005609758,
				"type": "OTHER"
			},
			{
				"name": "Contributing",
				"salience": 0.005609758,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/046hhn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Algonquian_peoples"
				},
				"name": "Algonquin",
				"salience": 0.004741844,
				"type": "LOCATION"
			},
			{
				"name": "folklore name",
				"salience": 0.0041919993,
				"type": "OTHER"
			},
			{
				"name": "@MaryBowerman",
				"salience": 0.0039889864,
				"type": "OTHER"
			},
			{
				"name": "@USATODAYWeather",
				"salience": 0.0039889864,
				"type": "OTHER"
			},
			{
				"name": "Mary Bowerman",
				"salience": 0.0034545052,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0034545052,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wxpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Old_Farmer's_Almanac"
				},
				"name": "Old Farmer's Almanac",
				"salience": 0.0025809805,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Doyle Rice",
				"salience": 0.002302693,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/29906170001_5195287185001_5195147462001-vs.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:01.253+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "November supermoon biggest in nearly 70 years 11/03/2016 \nUSA TODAY \nSupersized! November supermoon will be biggest in nearly 70 years. The supermoon occurs when the moon is slightly closer to Earth than it typically is, and the effect is most noticeable when it occurs around the same time as a full moon. \nIt can appear 14% bigger and 30% brighter than usual, according to NASA. \nThe word supermoon was coined in 1979 by astrologer Richard Nolle, AccuWeather’s Mark Paquette says. Nolle used the term to describe a new or full moon that occurs when the moon is at or near its closest approach to Earth. \nInstead of a supermoon, astronomy site Slooh.com is calling it a “mega beaver moon,” which includes the moon’s folklore name for November. \nAccording to the Old Farmer’s Almanac , the November moon was named the beaver moon partly because, “for both the colonists and the Algonquin tribes, this was the time to set beaver traps before the swamps froze, to ensure a supply of warm winter furs.” \nContributing: Mary Bowerman, USA TODAY \nFollow @MaryBowerman on Twitter. Follow Doyle Rice at @USATODAYWeather . Share On:",
		"thread_title": "November supermoon biggest in nearly 70 years",
		"title": "November supermoon biggest in nearly 70 years",
		"type": "bs",
		"uuid": "c9a8dce0a18a9abdb5919e6b024512b41ef7ec67"
	},
	"-KhIhJaA_LqVlisXTl7Z": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:02.463+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.24230054,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.07739244,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.061451837,
				"type": "OTHER"
			},
			{
				"name": "Murad Gazdiev",
				"salience": 0.0605339,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.058544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.05576136,
				"type": "LOCATION"
			},
			{
				"name": "assault",
				"salience": 0.054296065,
				"type": "EVENT"
			},
			{
				"name": "crew",
				"salience": 0.030956555,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.027090916,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.024526509,
				"type": "LOCATION"
			},
			{
				"name": "crew",
				"salience": 0.023802282,
				"type": "PERSON"
			},
			{
				"name": "assault",
				"salience": 0.022913612,
				"type": "EVENT"
			},
			{
				"name": "Gazdiev",
				"salience": 0.022706589,
				"type": "ORGANIZATION"
			},
			{
				"name": "fire",
				"salience": 0.021276735,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.021276735,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.01998946,
				"type": "ORGANIZATION"
			},
			{
				"name": "VIDEO",
				"salience": 0.0166937,
				"type": "WORK_OF_ART"
			},
			{
				"name": "offer",
				"salience": 0.010413281,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.010006695,
				"type": "PERSON"
			},
			{
				"name": "offensive",
				"salience": 0.008840947,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.007987463,
				"type": "LOCATION"
			},
			{
				"name": "blockade",
				"salience": 0.007987463,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0076497872,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.00692182,
				"type": "OTHER"
			},
			{
				"name": "neighborhood",
				"salience": 0.0053096376,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.005302645,
				"type": "ORGANIZATION"
			},
			{
				"name": "military",
				"salience": 0.004424176,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.004062298,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0038746742,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.0035321643,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0033179387,
				"type": "LOCATION"
			},
			{
				"name": "attempts",
				"salience": 0.003175668,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0030594883,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.002996372,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0027629156,
				"type": "ORGANIZATION"
			},
			{
				"name": "corridors",
				"salience": 0.00274505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0026076892,
				"type": "LOCATION"
			},
			{
				"name": "shells",
				"salience": 0.0024856406,
				"type": "OTHER"
			},
			{
				"name": "car bombs",
				"salience": 0.0024856406,
				"type": "OTHER"
			},
			{
				"name": "radio communications",
				"salience": 0.0024856406,
				"type": "WORK_OF_ART"
			},
			{
				"name": "city",
				"salience": 0.0024798638,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0024798638,
				"type": "LOCATION"
			},
			{
				"name": "dozens",
				"salience": 0.0023929873,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0023929873,
				"type": "PERSON"
			},
			{
				"name": "blockade",
				"salience": 0.0023435955,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0023435955,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.0022461629,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.0020105042,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.00193944,
				"type": "PERSON"
			},
			{
				"name": "offer",
				"salience": 0.00193944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.0017596509,
				"type": "ORGANIZATION"
			},
			{
				"name": "militants",
				"salience": 0.0017232132,
				"type": "PERSON"
			},
			{
				"name": "fire",
				"salience": 0.001644935,
				"type": "EVENT"
			},
			{
				"name": "civilians",
				"salience": 0.0016315057,
				"type": "PERSON"
			},
			{
				"name": "human shields",
				"salience": 0.0015166478,
				"type": "PERSON"
			},
			{
				"name": "warplanes",
				"salience": 0.0015166478,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0013500206,
				"type": "LOCATION"
			},
			{
				"name": "attempts",
				"salience": 0.001275775,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0011047879,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0011047879,
				"type": "PERSON"
			},
			{
				"name": "corridors",
				"salience": 0.0009531419,
				"type": "LOCATION"
			},
			{
				"name": "casualties",
				"salience": 0.00082536816,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.00082536816,
				"type": "OTHER"
			},
			{
				"name": "flurry",
				"salience": 0.00082536816,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.00082536816,
				"type": "EVENT"
			},
			{
				"name": "purpose",
				"salience": 0.00082536816,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00082536816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gkh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West"
				},
				"name": "West",
				"salience": 0.0005080286,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.00044187804,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/581b2b7fc461880b1c8b467c.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:02.463+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "RT crew comes under fire as Aleppo militants launch massive new assault (VIDEO) 11/03/2016 \nRUSSIA TODAY RT’s Murad Gazdiev and his crew came under fire in Aleppo as militant groups holding the eastern part of the city launched a new assault on government-held western areas, trying to break the blockade, after rejecting an offer to leave the city with their arms. \nThe neighborhood “ has been relatively quiet for the past two days and we wanted to see what was happening there ,” RT’s Gazdiev reported from Aleppo. “ There are still dozens of civilians there, not everyone managed to leave. ” \nThe rebels apparently launched a major new offensive against the government-held part of the city, radio communications intercepted by the Syrian military indicate. \n“ There were apparently two or three suicide car bombs blown up very close to us. We hid. We saw many shells landing meters away from us, ” Gazdiev said. \nThe Syrian Army helped the RT crew along with civilians being evacuated from the area. \nEarlier on Wednesday, the Russian military said that last week’s attempts by the militants to break through the blockade around the city had failed, and suggested that they leave Aleppo through one of two corridors opened for that purpose. \nRussia and Syria halted airstrikes on eastern Aleppo two weeks ago amid a flurry of criticism from the West over civilian casualties in the city. Moscow said civilians were being held by the militants as human shields, but agreed to keep warplanes away from the city. \nThe offer to leave Aleppo by Friday night was rejected by some groups controlling the eastern part of the city. \nRussia’s earlier attempts to allow militants to leave and civilians to be evacuated from eastern Aleppo were thwarted by the more belligerent groups, which opened fire at anyone trying to use the corridors – both those meant for armed people and unarmed civilians.",
		"thread_title": "RT crew comes under fire as Aleppo militants launch massive new assault (VIDEO)",
		"title": "RT crew comes under fire as Aleppo militants launch massive new assault (VIDEO)",
		"type": "bs",
		"uuid": "32acd21266e10bcab38342864663acf05a1658cf"
	},
	"-KhIhJsr8CMFTAteaGGz": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:03.044+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.20394823,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01g8_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kunduz"
				},
				"name": "Kunduz",
				"salience": 0.11733033,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.09181389,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.06978121,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.057771064,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07jqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taliban"
				},
				"name": "Taliban",
				"salience": 0.046184868,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.03191795,
				"type": "ORGANIZATION"
			},
			{
				"name": "dozens",
				"salience": 0.031754475,
				"type": "PERSON"
			},
			{
				"name": "airstrike",
				"salience": 0.024507478,
				"type": "EVENT"
			},
			{
				"name": "airstrike",
				"salience": 0.024507478,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.022664225,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.022664225,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.017768277,
				"type": "OTHER"
			},
			{
				"name": "military alliance",
				"salience": 0.017768277,
				"type": "ORGANIZATION"
			},
			{
				"name": "assault",
				"salience": 0.01355748,
				"type": "EVENT"
			},
			{
				"name": "militants",
				"salience": 0.011208535,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.010977214,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.0075431843,
				"type": "PERSON"
			},
			{
				"name": "north",
				"salience": 0.0073549943,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0069454233,
				"type": "PERSON"
			},
			{
				"name": "demonstration",
				"salience": 0.006904724,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.006366152,
				"type": "LOCATION"
			},
			{
				"name": "Mahmood Danish",
				"salience": 0.0063336855,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0057673757,
				"type": "PERSON"
			},
			{
				"name": "Taza Gul",
				"salience": 0.0046755928,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0046354057,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.0043438063,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.0043438063,
				"type": "PERSON"
			},
			{
				"name": "insurgents",
				"salience": 0.0043438063,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.004324443,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.003957795,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0038737236,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0037792344,
				"type": "PERSON"
			},
			{
				"name": "bombardment",
				"salience": 0.0037623825,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.0037623825,
				"type": "ORGANIZATION"
			},
			{
				"name": "others",
				"salience": 0.0037150527,
				"type": "PERSON"
			},
			{
				"name": "Airstrike",
				"salience": 0.0035162591,
				"type": "ORGANIZATION"
			},
			{
				"name": "airstrike",
				"salience": 0.0035162591,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.0033745847,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0031817392,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0030473343,
				"type": "LOCATION"
			},
			{
				"name": "governor",
				"salience": 0.0030473343,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0030473343,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0030337402,
				"type": "EVENT"
			},
			{
				"name": "forces",
				"salience": 0.0029825435,
				"type": "ORGANIZATION"
			},
			{
				"name": "relatives",
				"salience": 0.0029337227,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0027556121,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.0026391803,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0026391803,
				"type": "PERSON"
			},
			{
				"name": "bodies",
				"salience": 0.0026391803,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.0025407632,
				"type": "EVENT"
			},
			{
				"name": "protest rally",
				"salience": 0.0025407632,
				"type": "EVENT"
			},
			{
				"name": "media outlets",
				"salience": 0.0025407632,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0024883002,
				"type": "ORGANIZATION"
			},
			{
				"name": "Relatives",
				"salience": 0.0024883002,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0024883002,
				"type": "PERSON"
			},
			{
				"name": "body",
				"salience": 0.002154929,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.002154929,
				"type": "EVENT"
			},
			{
				"name": "control",
				"salience": 0.0018592341,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.001610064,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.001610064,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.001610064,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01prjh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Americanism"
				},
				"name": "anti-US",
				"salience": 0.0015643768,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0013715765,
				"type": "OTHER"
			},
			{
				"name": "clashes",
				"salience": 0.0013542988,
				"type": "OTHER"
			},
			{
				"name": "provinces",
				"salience": 0.0013542988,
				"type": "LOCATION"
			},
			{
				"name": "insurgency",
				"salience": 0.0013542988,
				"type": "EVENT"
			},
			{
				"name": "presence",
				"salience": 0.0013542988,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0013542988,
				"type": "PERSON"
			},
			{
				"name": "security forces",
				"salience": 0.0012129181,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0011727532,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0011727532,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0011205442,
				"type": "LOCATION"
			},
			{
				"name": "control",
				"salience": 0.0010117516,
				"type": "OTHER"
			},
			{
				"name": "clashes",
				"salience": 0.0010117516,
				"type": "EVENT"
			},
			{
				"name": "name",
				"salience": 0.00087610167,
				"type": "OTHER"
			},
			{
				"name": "Photo",
				"salience": 0.00087610167,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0005392266,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/227fa959-ca8c-4737-91d1-1773f930064f.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:03.044+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "US-led airstrike kills at least 30 Afghan civilians 11/03/2016 \nPRESS TV \nAt least 30 Afghan civilians, including women and children, have lost their lives in Afghanistan in an airstrike carried out by the so-called US-led military alliance in the country’s volatile north. \nLocal Afghan officials said more than two dozen civilians were also injured in the aerial assault which took place in the northern province of Kunduz on Thursday. \n“Afghan forces and coalition troops conducted a joint operation against the Taliban insurgents. In the bombardment, 30 Afghan civilians were martyred and 25 others were wounded,” media outlets quoted provincial spokesman, Mahmood Danish, as saying. \nAirstrike sparks anti-US protest rally \nFollowing the deadly airstrike, dozens of the relatives of those killed in the US-led raid staged a demonstration outside the governor’s office in Kunduz to condemn the attack as they were carrying the bodies of the victims. \n“I am heartbroken. I have lost seven members of my family. I want to know, why these innocent children were killed? Were they Taliban?” said Taza Gul, a 55-year-old laborer, adding, “No, they were innocent children.” \nAfghan government forces are engaged in fierce fighting against the militants in and around Kunduz. Relatives and members of civilians sit next the dead body of a man who was killed during clashes between Afghan security forces and the Taliban in Kunduz, Afghanistan November 3, 2016. (Photo by Reuters) \nTaliban militants briefly overran the city of Kunduz, the provincial capital with the same name, in early October. They had briefly seized control of the city a year earlier but they were pushed out of Kunduz weeks later. They now seek to gain full control over the city. \nTaliban militants were removed from power following the 2001 US-led invasion of Afghanistan, but they have stepped up their activities in recent months, attempting to overrun several provinces. \nAfghan forces have been engaged in fierce clashes with Taliban to contain the ongoing insurgency across various parts of the violence-wrecked country. \nThe rising violence in Afghanistan comes despite the presence of thousands of foreign troops in the country.",
		"thread_title": "US-led airstrike kills at least 30 Afghan civilians",
		"title": "US-led airstrike kills at least 30 Afghan civilians",
		"type": "bs",
		"uuid": "34777dd34c3349ad9b0e91be5c6549680ac1796b"
	},
	"-KhIhKAMcxixFgPNbLZx": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T21:04:03.190+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "land",
				"salience": 0.13238491,
				"type": "LOCATION"
			},
			{
				"name": "Protesters",
				"salience": 0.09790335,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0452819,
				"type": "PERSON"
			},
			{
				"name": "construction",
				"salience": 0.042544864,
				"type": "EVENT"
			},
			{
				"name": "Standing Rock Sioux Reservation",
				"salience": 0.039381452,
				"type": "LOCATION"
			},
			{
				"name": "pepper spray",
				"salience": 0.027096571,
				"type": "OTHER"
			},
			{
				"name": "standoff",
				"salience": 0.0269167,
				"type": "EVENT"
			},
			{
				"name": "officers",
				"salience": 0.024167802,
				"type": "PERSON"
			},
			{
				"name": "North Dakota Pipeline 11",
				"salience": 0.023657518,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.023495987,
				"type": "OTHER"
			},
			{
				"name": "NPR Police",
				"salience": 0.02137897,
				"type": "ORGANIZATION"
			},
			{
				"name": "protesters",
				"salience": 0.020693086,
				"type": "PERSON"
			},
			{
				"name": "pipeline",
				"salience": 0.019656988,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.019031873,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.018203069,
				"type": "LOCATION"
			},
			{
				"name": "protesters",
				"salience": 0.017568914,
				"type": "PERSON"
			},
			{
				"name": "Stephanie Jasper",
				"salience": 0.016512102,
				"type": "PERSON"
			},
			{
				"name": "Paul Laney",
				"salience": 0.015552883,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.014542101,
				"type": "PERSON"
			},
			{
				"name": "Police Still Clashing",
				"salience": 0.0145111205,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0mb31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sheriff"
				},
				"name": "Sheriff's Department",
				"salience": 0.014292025,
				"type": "ORGANIZATION"
			},
			{
				"name": "wood pedestrian bridge",
				"salience": 0.013731776,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0l9wb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army_Corps_of_Engineers"
				},
				"name": "U.S. Army Corps of Engineers",
				"salience": 0.013528289,
				"type": "ORGANIZATION"
			},
			{
				"name": "protesters",
				"salience": 0.012034223,
				"type": "PERSON"
			},
			{
				"name": "Officers",
				"salience": 0.011684877,
				"type": "PERSON"
			},
			{
				"name": "sight",
				"salience": 0.010472966,
				"type": "OTHER"
			},
			{
				"name": "river",
				"salience": 0.01037394,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "N.D.",
				"salience": 0.010197476,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.009648972,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.009407855,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.007750145,
				"type": "ORGANIZATION"
			},
			{
				"name": "Demonstrators",
				"salience": 0.007629857,
				"type": "PERSON"
			},
			{
				"name": "protest camp",
				"salience": 0.0063564973,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0063564973,
				"type": "PERSON"
			},
			{
				"name": "clash",
				"salience": 0.006323753,
				"type": "EVENT"
			},
			{
				"name": "law enforcement",
				"salience": 0.005793283,
				"type": "ORGANIZATION"
			},
			{
				"name": "creek north",
				"salience": 0.0057404106,
				"type": "LOCATION"
			},
			{
				"name": "demonstrations",
				"salience": 0.0057404106,
				"type": "EVENT"
			},
			{
				"name": "protesters",
				"salience": 0.005530527,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.0049941866,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0049568997,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.0048115337,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0046466123,
				"type": "LOCATION"
			},
			{
				"name": "law enforcement",
				"salience": 0.004440724,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement officers",
				"salience": 0.004440724,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.004293114,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.0042044893,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.004026855,
				"type": "OTHER"
			},
			{
				"name": "river",
				"salience": 0.0039412263,
				"type": "LOCATION"
			},
			{
				"name": "river",
				"salience": 0.0039412263,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0n353",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morton_County,_North_Dakota"
				},
				"name": "Morton County",
				"salience": 0.003915397,
				"type": "LOCATION"
			},
			{
				"name": "bridge",
				"salience": 0.0038767038,
				"type": "LOCATION"
			},
			{
				"name": "boats",
				"salience": 0.0038767038,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.003641313,
				"type": "EVENT"
			},
			{
				"name": "colleagues",
				"salience": 0.0034874387,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0034874387,
				"type": "OTHER"
			},
			{
				"name": "boats",
				"salience": 0.0032880409,
				"type": "OTHER"
			},
			{
				"name": "pepper spray",
				"salience": 0.0032880409,
				"type": "OTHER"
			},
			{
				"name": "protester",
				"salience": 0.003011154,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02n023",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cannonball_River"
				},
				"name": "Cannonball River",
				"salience": 0.0029722822,
				"type": "LOCATION"
			},
			{
				"name": "mirrors",
				"salience": 0.0028474792,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0028474792,
				"type": "OTHER"
			},
			{
				"name": "police helicopter",
				"salience": 0.0028474792,
				"type": "ORGANIZATION"
			},
			{
				"name": "tribe",
				"salience": 0.0027207707,
				"type": "PERSON"
			},
			{
				"name": "tribe",
				"salience": 0.0027207707,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0027207707,
				"type": "PERSON"
			},
			{
				"name": "law enforcement official",
				"salience": 0.0025430284,
				"type": "PERSON"
			},
			{
				"name": "pipeline",
				"salience": 0.0025346265,
				"type": "OTHER"
			},
			{
				"name": "pipeline",
				"salience": 0.0025346265,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0024567195,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0024567195,
				"type": "ORGANIZATION"
			},
			{
				"name": "person",
				"salience": 0.0022955635,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0022497755,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Fla",
				"salience": 0.0021471996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02z4zg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tampa_Bay"
				},
				"name": "Tampa Bay",
				"salience": 0.0021471996,
				"type": "LOCATION"
			},
			{
				"name": "rights",
				"salience": 0.0021274507,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0021274507,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0021274507,
				"type": "PERSON"
			},
			{
				"name": "construction route",
				"salience": 0.0021274507,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0021274507,
				"type": "PERSON"
			},
			{
				"name": "pipeline spill",
				"salience": 0.0021274507,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0019858102,
				"type": "PERSON"
			},
			{
				"name": "conspiracy",
				"salience": 0.0019818668,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0018936475,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.0018059834,
				"type": "OTHER"
			},
			{
				"name": "creek",
				"salience": 0.001789475,
				"type": "LOCATION"
			},
			{
				"name": "study",
				"salience": 0.001781484,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00154958,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.00154958,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00154958,
				"type": "PERSON"
			},
			{
				"name": "kayaks",
				"salience": 0.00154958,
				"type": "OTHER"
			},
			{
				"name": "obstruction",
				"salience": 0.00154958,
				"type": "OTHER"
			},
			{
				"name": "government function",
				"salience": 0.00154958,
				"type": "OTHER"
			},
			{
				"name": "press release",
				"salience": 0.00154958,
				"type": "WORK_OF_ART"
			},
			{
				"name": "canoes",
				"salience": 0.0014917449,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0n3dv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cass_County,_North_Dakota"
				},
				"name": "Cass County",
				"salience": 0.0014569212,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock Sioux Tribe",
				"salience": 0.0014569212,
				"type": "ORGANIZATION"
			},
			{
				"name": "disregard",
				"salience": 0.0012024791,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.0011575929,
				"type": "OTHER"
			},
			{
				"name": "Everybody",
				"salience": 0.0011575929,
				"type": "PERSON"
			},
			{
				"name": "Morton County Sheriff's Department",
				"salience": 0.00095806393,
				"type": "ORGANIZATION"
			},
			{
				"name": "view",
				"salience": 0.00086472975,
				"type": "OTHER"
			},
			{
				"name": "Jasper",
				"salience": 0.00071566575,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/rtx2rls7edit_custom-22f44e631e1358967ba6daeb39fc172f5b15242b-s1300-c85.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T21:04:03.190+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Protesters, Police Still Clashing Over Disputed North Dakota Pipeline 11/03/2016 \nNPR \nPolice used pepper spray and what they called nonlethal ammunition to remove Dakota Access Pipeline protesters from federal land Wednesday. Demonstrators say they were trying to occupy land just north of the Standing Rock Sioux Reservation where construction of the controversial pipeline is scheduled. \nThis was the first significant clash between law enforcement and protesters since demonstrations turned violent last week and more than 100 people were arrested. \nAccording to the Morton County, N.D., Sheriff’s Department, a group of people began building a wood pedestrian bridge across a creek north of the main protest camp early Wednesday morning. The U.S. Army Corps of Engineers owns the land and had asked law enforcement to remove any protesters who try to reach it. \nOfficers in boats pulled the makeshift bridge apart and warned protesters they would be arrested if they continued to trespass. After a several-hour standoff with police, protesters dispersed and returned to their main camp. \nDuring the standoff, a few protesters watched from across the nearby Cannonball River. They waded into the water — some chest-deep — to shout support for colleagues closer to officers. \n“I decided to get into the river and just be a presence there,” says Stephanie Jasper of Tampa Bay, Fla. She watched as law enforcement pushed protesters back toward the main camp, and says she saw officers use pepper spray. She says it was a chaotic sight as a police helicopter hovered overhead. \nSeveral protesters standing in the river held mirrors directed at law enforcement officers lined up on the other side and at police on the river in boats. \n“Everybody was just sharing love to these officers and explaining why it is we’re here and questioning why they were,” says Jasper. \nOne law enforcement official had a very different view of the protest. “In my 27 years in law enforcement, I have never seen such an absolute disregard for the law or other people’s rights because of someone else’s ideology,” said Cass County, N.D., Sheriff Paul Laney. \nThe Standing Rock Sioux Tribe says the Dakota Access Pipeline construction route crosses land that is sacred to its members. And the tribe worries a pipeline spill could pollute local water. The tribe wants the federal government to stop work on the pipeline and conduct a full environmental impact study of the pipeline. \nThe Morton County Sheriff’s Department says one person was arrested for “conspiracy to commit obstruction of a government function.” In a press release, the agency says the protester was buying canoes and kayaks for others to cross the creek.",
		"thread_title": "Protesters, Police Still Clashing Over Disputed North Dakota Pipeline",
		"title": "Protesters, Police Still Clashing Over Disputed North Dakota Pipeline",
		"type": "bs",
		"uuid": "9cf9163fcb8564e3e3e51f13b7dc78a1eeb60445"
	},
	"-KhIhKL89VzibJvJteD1": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T01:06:58.724+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States of America",
				"salience": 0.13483016,
				"type": "LOCATION"
			},
			{
				"name": "Coup Taking Place",
				"salience": 0.13336119,
				"type": "ORGANIZATION"
			},
			{
				"name": "video",
				"salience": 0.116079345,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.077486366,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.056160275,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.04873422,
				"type": "WORK_OF_ART"
			},
			{
				"name": "coup d'état",
				"salience": 0.04873422,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.036694568,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017g21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roger_Waters"
				},
				"name": "Roger Waters",
				"salience": 0.036610283,
				"type": "PERSON"
			},
			{
				"name": "AMTV",
				"salience": 0.034778822,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.030154673,
				"type": "PERSON"
			},
			{
				"name": "Steve Pieczenik",
				"salience": 0.030154673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.020031165,
				"type": "LOCATION"
			},
			{
				"name": "eye implant",
				"salience": 0.01996766,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.019557128,
				"type": "OTHER"
			},
			{
				"name": "decree",
				"salience": 0.017600749,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.017600749,
				"type": "OTHER"
			},
			{
				"name": "Scientists",
				"salience": 0.014563682,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01w6dw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Express"
				},
				"name": "American Express",
				"salience": 0.0129630305,
				"type": "ORGANIZATION"
			},
			{
				"name": "woman",
				"salience": 0.012591892,
				"type": "PERSON"
			},
			{
				"name": "views",
				"salience": 0.010752784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hqly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_Seagal"
				},
				"name": "Steven Seagal",
				"salience": 0.010448321,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.010448321,
				"type": "ORGANIZATION"
			},
			{
				"name": "breakthrough",
				"salience": 0.008894266,
				"type": "OTHER"
			},
			{
				"name": "brick",
				"salience": 0.00834892,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wv9xn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pink_Floyd"
				},
				"name": "Pink Floyd",
				"salience": 0.006624897,
				"type": "ORGANIZATION"
			},
			{
				"name": "pro-Palestinian",
				"salience": 0.006624897,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dfxl7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel_and_the_apartheid_analogy"
				},
				"name": "Israeli Apartheid",
				"salience": 0.004826829,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hdgtt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall"
				},
				"name": "The Wall",
				"salience": 0.004826829,
				"type": "WORK_OF_ART"
			},
			{
				"name": "AMTV Archives",
				"salience": 0.004826829,
				"type": "OTHER"
			},
			{
				"name": "human sight",
				"salience": 0.0047222506,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^294607A164A9F5A8A0164B7F0C4330A3537F09AF4CDB30D4F5^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T01:06:58.724+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "A Coup Taking Place in the United States 11/03/2016 In today’s video, Christopher Greene of AMTV reports on Steve Pieczenik controversial report that a coup d’état is taking place in the United States of America. Putin grants Steven Seagal Russian citizenship 11/03/2016 DAILY MAIL President Vladimir Putin signed off Thursday on a decree granting Russian citizenship to American action her ... New bionic eye implant connects directly to brain 11/03/2016 RUSSIA TODAY Scientists may have made a significant breakthrough in restoring human sight, as a woman who had been blin ... American Express disowns Pink Floyd singer Roger Waters because of pro-Palestinian views 11/03/2016 MONDOWEISS When it comes to aiding Israeli Apartheid, American Express is just another brick in The Wall, according ... AMTV Archives",
		"thread_title": "A Coup Taking Place in the United States",
		"title": "A Coup Taking Place in the United States",
		"type": "bs",
		"uuid": "7be1da6680e20e6308cf79d89a102d7f0ff8e3b9"
	},
	"-KhIhL9xOk6VcvJBk9-E": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T02:44:42.655+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "business administration student",
				"salience": 0.12992659,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.042108778,
				"type": "PERSON"
			},
			{
				"name": "Ammon Bundy",
				"salience": 0.037324768,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05p6z10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anna_J._Brown"
				},
				"name": "Anna J. Brown",
				"salience": 0.025735287,
				"type": "PERSON"
			},
			{
				"name": "Ethan Knight",
				"salience": 0.023345958,
				"type": "PERSON"
			},
			{
				"name": "judge",
				"salience": 0.019283129,
				"type": "PERSON"
			},
			{
				"name": "discussions",
				"salience": 0.017555699,
				"type": "EVENT"
			},
			{
				"name": "jury",
				"salience": 0.01679606,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.013607865,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.013118605,
				"type": "OTHER"
			},
			{
				"name": "defendants",
				"salience": 0.010962789,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.009648261,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Ryan Payne",
				"salience": 0.008809195,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.008052778,
				"type": "PERSON"
			},
			{
				"name": "OREGONLIVE Juror 4",
				"salience": 0.0076290364,
				"type": "ORGANIZATION"
			},
			{
				"name": "refuge truck",
				"salience": 0.0075197956,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "conspiracy",
				"salience": 0.0075164703,
				"type": "OTHER"
			},
			{
				"name": "jurors",
				"salience": 0.007190957,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.0068309586,
				"type": "PERSON"
			},
			{
				"name": "absence",
				"salience": 0.006774183,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.006714163,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.006714163,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.0064246864,
				"type": "PERSON"
			},
			{
				"name": "verdict",
				"salience": 0.0064037275,
				"type": "OTHER"
			},
			{
				"name": "Count",
				"salience": 0.00613704,
				"type": "OTHER"
			},
			{
				"name": "email exchanges",
				"salience": 0.006119159,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.005940205,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.005683553,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0055420888,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.0052358685,
				"type": "PERSON"
			},
			{
				"name": "note",
				"salience": 0.005171511,
				"type": "OTHER"
			},
			{
				"name": "Juror explanation",
				"salience": 0.005116195,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.004969537,
				"type": "OTHER"
			},
			{
				"name": "juror",
				"salience": 0.0049078534,
				"type": "PERSON"
			},
			{
				"name": "several",
				"salience": 0.0048040356,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0045080055,
				"type": "OTHER"
			},
			{
				"name": "fellow",
				"salience": 0.0044815084,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ckb6b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malheur_National_Wildlife_Refuge"
				},
				"name": "Malheur National Wildlife Refuge",
				"salience": 0.004475586,
				"type": "LOCATION"
			},
			{
				"name": "points",
				"salience": 0.004469714,
				"type": "OTHER"
			},
			{
				"name": "juror",
				"salience": 0.0043789893,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.004278322,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.004226862,
				"type": "OTHER"
			},
			{
				"name": "acquittal",
				"salience": 0.004106482,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.0039617987,
				"type": "PERSON"
			},
			{
				"name": "Ammon Bundy",
				"salience": 0.003943619,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.003941363,
				"type": "WORK_OF_ART"
			},
			{
				"name": "juror",
				"salience": 0.003936614,
				"type": "PERSON"
			},
			{
				"name": "explanation",
				"salience": 0.0038716604,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0038413582,
				"type": "OTHER"
			},
			{
				"name": "juror",
				"salience": 0.0038381005,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0037897709,
				"type": "PERSON"
			},
			{
				"name": "counts",
				"salience": 0.0037214514,
				"type": "OTHER"
			},
			{
				"name": "count",
				"salience": 0.0037136236,
				"type": "OTHER"
			},
			{
				"name": "refuge",
				"salience": 0.0037136236,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.003577351,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.003577351,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.003577351,
				"type": "PERSON"
			},
			{
				"name": "verdict",
				"salience": 0.003442289,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.0034309162,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0034309162,
				"type": "EVENT"
			},
			{
				"name": "occupation",
				"salience": 0.0034309162,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0034051104,
				"type": "OTHER"
			},
			{
				"name": "juror",
				"salience": 0.0033725544,
				"type": "PERSON"
			},
			{
				"name": "defense",
				"salience": 0.0032721316,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0031710563,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0031363298,
				"type": "OTHER"
			},
			{
				"name": "transcript",
				"salience": 0.0031073287,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.003103223,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conspiring",
				"salience": 0.0030979356,
				"type": "OTHER"
			},
			{
				"name": "standard",
				"salience": 0.003054849,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0030412371,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0029038263,
				"type": "WORK_OF_ART"
			},
			{
				"name": "actions",
				"salience": 0.0029038263,
				"type": "OTHER"
			},
			{
				"name": "objectivity",
				"salience": 0.0029038263,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.00275836,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0027435988,
				"type": "PERSON"
			},
			{
				"name": "beliefs",
				"salience": 0.0026827154,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0026827154,
				"type": "OTHER"
			},
			{
				"name": "Another",
				"salience": 0.0026462388,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0026079507,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.0025739656,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.002462666,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.0024222957,
				"type": "EVENT"
			},
			{
				"name": "safety",
				"salience": 0.0024222957,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0024222957,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.0024222957,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.0024222957,
				"type": "OTHER"
			},
			{
				"name": "failures",
				"salience": 0.0024222957,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0024222957,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0024222957,
				"type": "PERSON"
			},
			{
				"name": "most",
				"salience": 0.0023633004,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mx9b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harney_County,_Oregon"
				},
				"name": "Harney County",
				"salience": 0.0022862381,
				"type": "LOCATION"
			},
			{
				"name": "retribution",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "news stories",
				"salience": 0.0020975738,
				"type": "WORK_OF_ART"
			},
			{
				"name": "decision",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0020975738,
				"type": "PERSON"
			},
			{
				"name": "ranchers",
				"salience": 0.0020975738,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0020975738,
				"type": "PERSON"
			},
			{
				"name": "body",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "takeover",
				"salience": 0.0020975738,
				"type": "EVENT"
			},
			{
				"name": "fear",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "reasoning",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.0020975738,
				"type": "PERSON"
			},
			{
				"name": "clarity",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "brevity",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "editing",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "affirmation",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "aspirations",
				"salience": 0.0020975738,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0019775578,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.0018870007,
				"type": "OTHER"
			},
			{
				"name": "instructions",
				"salience": 0.0018592471,
				"type": "OTHER"
			},
			{
				"name": "juror",
				"salience": 0.0018286395,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0018286395,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0018286395,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.0018286395,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.0018286395,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0018286395,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0018286395,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0017713021,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.0017603852,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0017603852,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01yqvd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Oregonian"
				},
				"name": "The Oregonian",
				"salience": 0.0016513728,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0016513728,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04csldy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/OregonLive.com"
				},
				"name": "OregonLive",
				"salience": 0.0016513728,
				"type": "ORGANIZATION"
			},
			{
				"name": "jury",
				"salience": 0.0016312309,
				"type": "PERSON"
			},
			{
				"name": "note",
				"salience": 0.0015919841,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0015816062,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0015816062,
				"type": "OTHER"
			},
			{
				"name": "references",
				"salience": 0.0015472292,
				"type": "OTHER"
			},
			{
				"name": "juror",
				"salience": 0.0014928478,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0014928478,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0014928478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f4r5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bureau_of_Land_Management"
				},
				"name": "U.S. Bureau of Land Management",
				"salience": 0.0014910226,
				"type": "ORGANIZATION"
			},
			{
				"name": "word",
				"salience": 0.0014909358,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.0014728358,
				"type": "PERSON"
			},
			{
				"name": "prosecution",
				"salience": 0.0014728358,
				"type": "EVENT"
			},
			{
				"name": "mind",
				"salience": 0.0014728358,
				"type": "OTHER"
			},
			{
				"name": "sentiments",
				"salience": 0.0014492397,
				"type": "OTHER"
			},
			{
				"name": "relief",
				"salience": 0.0014309776,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0014125094,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.0014125094,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0014125094,
				"type": "OTHER"
			},
			{
				"name": "Kennth Medenbach",
				"salience": 0.0013945056,
				"type": "PERSON"
			},
			{
				"name": "verdict(s)",
				"salience": 0.0013470987,
				"type": "OTHER"
			},
			{
				"name": "statute",
				"salience": 0.0013417075,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0013035745,
				"type": "OTHER"
			},
			{
				"name": "imaginations",
				"salience": 0.0012955392,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "Navy",
				"salience": 0.0012910933,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq_War"
				},
				"name": "Iraq War",
				"salience": 0.0012910933,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0j__m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Fish_and_Wildlife_Service"
				},
				"name": "U.S. Fish & Wildlife Service",
				"salience": 0.0012910933,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05l0ry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marylhurst_University"
				},
				"name": "Marylhurst University",
				"salience": 0.0012910933,
				"type": "ORGANIZATION"
			},
			{
				"name": "feelings",
				"salience": 0.001275344,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0012575965,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0012575965,
				"type": "OTHER"
			},
			{
				"name": "wording",
				"salience": 0.0012403128,
				"type": "OTHER"
			},
			{
				"name": "object",
				"salience": 0.0011953919,
				"type": "OTHER"
			},
			{
				"name": "theory",
				"salience": 0.0011953919,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0011953919,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0011953919,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0011953919,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0011953919,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0011617924,
				"type": "OTHER"
			},
			{
				"name": "Readers",
				"salience": 0.0011609809,
				"type": "PERSON"
			},
			{
				"name": "jury",
				"salience": 0.0011436815,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0011151665,
				"type": "PERSON"
			},
			{
				"name": "juror",
				"salience": 0.0011151665,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0011151665,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0011151665,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.0011151665,
				"type": "PERSON"
			},
			{
				"name": "thinking",
				"salience": 0.0011043249,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0011043249,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.0011043249,
				"type": "OTHER"
			},
			{
				"name": "penalty",
				"salience": 0.0010986236,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.001077751,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0010674855,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0010605704,
				"type": "PERSON"
			},
			{
				"name": "jurors",
				"salience": 0.001033455,
				"type": "PERSON"
			},
			{
				"name": "judge",
				"salience": 0.0010326131,
				"type": "PERSON"
			},
			{
				"name": "counts",
				"salience": 0.0010319597,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0010266319,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0010136934,
				"type": "OTHER"
			},
			{
				"name": "Others",
				"salience": 0.0010133737,
				"type": "PERSON"
			},
			{
				"name": "sort",
				"salience": 0.0009970774,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.0009970774,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0009970774,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0009970774,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0009970774,
				"type": "PERSON"
			},
			{
				"name": "orders",
				"salience": 0.0009970774,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0009970774,
				"type": "OTHER"
			},
			{
				"name": "judgment",
				"salience": 0.0009940615,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.0009940615,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0009940615,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0009940615,
				"type": "OTHER"
			},
			{
				"name": "mindset",
				"salience": 0.0009940615,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.00095430063,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0009533396,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0009533396,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0009533396,
				"type": "OTHER"
			},
			{
				"name": "occupiers",
				"salience": 0.0009471636,
				"type": "PERSON"
			},
			{
				"name": "court",
				"salience": 0.00094444724,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.00094444724,
				"type": "ORGANIZATION"
			},
			{
				"name": "each other",
				"salience": 0.00094444724,
				"type": "PERSON"
			},
			{
				"name": "verdicts",
				"salience": 0.00094444724,
				"type": "OTHER"
			},
			{
				"name": "Inference",
				"salience": 0.0009316297,
				"type": "OTHER"
			},
			{
				"name": "day one",
				"salience": 0.0009091863,
				"type": "EVENT"
			},
			{
				"name": "defendant",
				"salience": 0.0009091863,
				"type": "PERSON"
			},
			{
				"name": "verdicts",
				"salience": 0.0009091863,
				"type": "OTHER"
			},
			{
				"name": "verdict",
				"salience": 0.0009091863,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.00090522337,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.0008941343,
				"type": "OTHER"
			},
			{
				"name": "feeling",
				"salience": 0.0008941343,
				"type": "OTHER"
			},
			{
				"name": "resort",
				"salience": 0.0008895179,
				"type": "LOCATION"
			},
			{
				"name": "relief",
				"salience": 0.0008895179,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.00088554394,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.00088169024,
				"type": "OTHER"
			},
			{
				"name": "counts",
				"salience": 0.0008750961,
				"type": "OTHER"
			},
			{
				"name": "trespass",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "bullets",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "patience",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "dismissal",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "closing argument",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "prejudices",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "triumphalism",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "burden",
				"salience": 0.0008633629,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0008607513,
				"type": "LOCATION"
			},
			{
				"name": "note",
				"salience": 0.0008607513,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.00085517496,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.0008429571,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00084003713,
				"type": "PERSON"
			},
			{
				"name": "standard",
				"salience": 0.00083807425,
				"type": "OTHER"
			},
			{
				"name": "deliberations",
				"salience": 0.00083807425,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.00083807425,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0008145156,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.0008145156,
				"type": "OTHER"
			},
			{
				"name": "jurors",
				"salience": 0.0008121461,
				"type": "PERSON"
			},
			{
				"name": "Juror",
				"salience": 0.0008121461,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.00080842373,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00080842373,
				"type": "OTHER"
			},
			{
				"name": "deliberations",
				"salience": 0.00080678373,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.00080678373,
				"type": "OTHER"
			},
			{
				"name": "theories",
				"salience": 0.00080678373,
				"type": "OTHER"
			},
			{
				"name": "theories",
				"salience": 0.00080678373,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.00080678373,
				"type": "OTHER"
			},
			{
				"name": "theories",
				"salience": 0.00080678373,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.00080678373,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.00079491385,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.00077422184,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.00077422184,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.00077422184,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.00077098055,
				"type": "ORGANIZATION"
			},
			{
				"name": "court",
				"salience": 0.00077098055,
				"type": "LOCATION"
			},
			{
				"name": "words",
				"salience": 0.00077098055,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.00077098055,
				"type": "ORGANIZATION"
			},
			{
				"name": "letter",
				"salience": 0.0007453148,
				"type": "WORK_OF_ART"
			},
			{
				"name": "parties",
				"salience": 0.0007453148,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0007453148,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.00074479415,
				"type": "WORK_OF_ART"
			},
			{
				"name": "question",
				"salience": 0.00073974044,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00073823973,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0007354068,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0007354068,
				"type": "OTHER"
			},
			{
				"name": "feelings",
				"salience": 0.0007299065,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0007299065,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0007299065,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00071974756,
				"type": "OTHER"
			},
			{
				"name": "examination",
				"salience": 0.00070794876,
				"type": "EVENT"
			},
			{
				"name": "failure",
				"salience": 0.00070794876,
				"type": "EVENT"
			},
			{
				"name": "prosecution",
				"salience": 0.0007058071,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.0006990257,
				"type": "OTHER"
			},
			{
				"name": "contents",
				"salience": 0.0006990257,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0006906977,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00068414095,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00068414095,
				"type": "OTHER"
			},
			{
				"name": "deliberations",
				"salience": 0.00068414095,
				"type": "EVENT"
			},
			{
				"name": "consensus",
				"salience": 0.0006761764,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0006761764,
				"type": "EVENT"
			},
			{
				"name": "landscape",
				"salience": 0.00067292573,
				"type": "OTHER"
			},
			{
				"name": "responses",
				"salience": 0.00067292573,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00067292573,
				"type": "OTHER"
			},
			{
				"name": "Matt Schindler",
				"salience": 0.00067136355,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.0006683595,
				"type": "OTHER"
			},
			{
				"name": "video/audio evidence",
				"salience": 0.00066243403,
				"type": "OTHER"
			},
			{
				"name": "refuge",
				"salience": 0.00065367064,
				"type": "LOCATION"
			},
			{
				"name": "refuge",
				"salience": 0.00065367064,
				"type": "LOCATION"
			},
			{
				"name": "proof",
				"salience": 0.0006502955,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.0006301024,
				"type": "PERSON"
			},
			{
				"name": "mindset",
				"salience": 0.00062966225,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.00062966225,
				"type": "OTHER"
			},
			{
				"name": "rapidity",
				"salience": 0.00062082603,
				"type": "OTHER"
			},
			{
				"name": "seed",
				"salience": 0.00061680377,
				"type": "OTHER"
			},
			{
				"name": "consistency",
				"salience": 0.00061092793,
				"type": "OTHER"
			},
			{
				"name": "jurors",
				"salience": 0.0006066459,
				"type": "PERSON"
			},
			{
				"name": "regard",
				"salience": 0.0006052744,
				"type": "OTHER"
			},
			{
				"name": "making",
				"salience": 0.0006052744,
				"type": "OTHER"
			},
			{
				"name": "reset",
				"salience": 0.0006052744,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0006052744,
				"type": "OTHER"
			},
			{
				"name": "challenge",
				"salience": 0.0006052744,
				"type": "OTHER"
			},
			{
				"name": "leanings",
				"salience": 0.0006052744,
				"type": "EVENT"
			},
			{
				"name": "ballots",
				"salience": 0.0006052744,
				"type": "OTHER"
			},
			{
				"name": "impulse",
				"salience": 0.0006052744,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0006052744,
				"type": "OTHER"
			},
			{
				"name": "regret",
				"salience": 0.0005826742,
				"type": "OTHER"
			},
			{
				"name": "shock/disbelief",
				"salience": 0.0005826742,
				"type": "OTHER"
			},
			{
				"name": "cracks",
				"salience": 0.0005826742,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0005826742,
				"type": "OTHER"
			},
			{
				"name": "stress",
				"salience": 0.0005826742,
				"type": "OTHER"
			},
			{
				"name": "phrasing",
				"salience": 0.0005788991,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.000577912,
				"type": "OTHER"
			},
			{
				"name": "intent",
				"salience": 0.0005735894,
				"type": "OTHER"
			},
			{
				"name": "intent",
				"salience": 0.0005735894,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0005706277,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0005706277,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0005706277,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0005706277,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.0005548581,
				"type": "OTHER"
			},
			{
				"name": "intent",
				"salience": 0.0005452122,
				"type": "OTHER"
			},
			{
				"name": "court system",
				"salience": 0.0005433234,
				"type": "OTHER"
			},
			{
				"name": "fellow",
				"salience": 0.0005288097,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0005269638,
				"type": "PERSON"
			},
			{
				"name": "grievance",
				"salience": 0.0005264469,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00052214414,
				"type": "OTHER"
			},
			{
				"name": "unanimity",
				"salience": 0.0005198112,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00051102525,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00051102525,
				"type": "OTHER"
			},
			{
				"name": "deliberations",
				"salience": 0.00051102525,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00051102525,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.00051102525,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00051102525,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.0005078789,
				"type": "PERSON"
			},
			{
				"name": "whiff",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "extremes",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "mistrial",
				"salience": 0.00049409416,
				"type": "EVENT"
			},
			{
				"name": "result",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "impasse",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "silence",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "input",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "trepidation",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "credit",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "pace",
				"salience": 0.00049409416,
				"type": "OTHER"
			},
			{
				"name": "objections",
				"salience": 0.0004919437,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.00047777942,
				"type": "PERSON"
			},
			{
				"name": "refuge",
				"salience": 0.00047603255,
				"type": "LOCATION"
			},
			{
				"name": "refuge",
				"salience": 0.00047603255,
				"type": "LOCATION"
			},
			{
				"name": "theft",
				"salience": 0.0004720869,
				"type": "EVENT"
			},
			{
				"name": "testimony",
				"salience": 0.0004720869,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.0004720869,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0004720869,
				"type": "OTHER"
			},
			{
				"name": "Ryan Bundy",
				"salience": 0.00046673988,
				"type": "PERSON"
			},
			{
				"name": "contentions",
				"salience": 0.00045993907,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0004585476,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0004585476,
				"type": "OTHER"
			},
			{
				"name": "hang",
				"salience": 0.00045788402,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0004549173,
				"type": "LOCATION"
			},
			{
				"name": "knowledge",
				"salience": 0.00045211238,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.0004464135,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0004397602,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.00043241034,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.00043241034,
				"type": "EVENT"
			},
			{
				"name": "discussion",
				"salience": 0.0004262317,
				"type": "EVENT"
			},
			{
				"name": "opportunity",
				"salience": 0.0004262317,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0004262317,
				"type": "OTHER"
			},
			{
				"name": "state police officer",
				"salience": 0.0004262317,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0004262317,
				"type": "OTHER"
			},
			{
				"name": "surveillance cameras",
				"salience": 0.0004262317,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.00041938992,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.00041938992,
				"type": "OTHER"
			},
			{
				"name": "wording",
				"salience": 0.00041938992,
				"type": "OTHER"
			},
			{
				"name": "property theft charge",
				"salience": 0.00041800304,
				"type": "OTHER"
			},
			{
				"name": "property theft charge",
				"salience": 0.00041800304,
				"type": "OTHER"
			},
			{
				"name": "bureau",
				"salience": 0.0004000369,
				"type": "ORGANIZATION"
			},
			{
				"name": "feelings",
				"salience": 0.00039704458,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00039704458,
				"type": "LOCATION"
			},
			{
				"name": "Count",
				"salience": 0.00037407895,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00037214727,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00037214727,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00037214727,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0003690626,
				"type": "OTHER"
			},
			{
				"name": "removal",
				"salience": 0.0003690626,
				"type": "EVENT"
			},
			{
				"name": "votes",
				"salience": 0.0003690626,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0003690626,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.0003690626,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.0003690626,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "rig",
				"salience": 0.0003690626,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0003690626,
				"type": "OTHER"
			},
			{
				"name": "resource center",
				"salience": 0.0003690626,
				"type": "LOCATION"
			},
			{
				"name": "surprise",
				"salience": 0.0003690626,
				"type": "OTHER"
			},
			{
				"name": "arrest",
				"salience": 0.0003690626,
				"type": "EVENT"
			},
			{
				"name": "utility poles",
				"salience": 0.0003690626,
				"type": "LOCATION"
			},
			{
				"name": "claim",
				"salience": 0.0003690626,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00036781444,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conspiracy",
				"salience": 0.00036781444,
				"type": "OTHER"
			},
			{
				"name": "objections",
				"salience": 0.00036745623,
				"type": "OTHER"
			},
			{
				"name": "cameras",
				"salience": 0.0003568759,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "refuge",
				"salience": 0.00035557104,
				"type": "LOCATION"
			},
			{
				"name": "version",
				"salience": 0.00035528129,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "all",
				"salience": 0.00034378984,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.00034378984,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00034378984,
				"type": "OTHER"
			},
			{
				"name": "answers",
				"salience": 0.00034378984,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.00034378984,
				"type": "OTHER"
			},
			{
				"name": "beliefs",
				"salience": 0.00034378984,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.00034378984,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.00034378984,
				"type": "OTHER"
			},
			{
				"name": "sentiments",
				"salience": 0.00034354962,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00034251023,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.00034251023,
				"type": "PERSON"
			},
			{
				"name": "prosecution",
				"salience": 0.00034251023,
				"type": "PERSON"
			},
			{
				"name": "sort",
				"salience": 0.00033921903,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0003377033,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.0003377033,
				"type": "PERSON"
			},
			{
				"name": "occupation",
				"salience": 0.00032847657,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.0003185938,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0003132606,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.00031039532,
				"type": "PERSON"
			},
			{
				"name": "visits",
				"salience": 0.00031039532,
				"type": "EVENT"
			},
			{
				"name": "presence",
				"salience": 0.00031039532,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.00031039532,
				"type": "OTHER"
			},
			{
				"name": "jury",
				"salience": 0.000305769,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.00030511315,
				"type": "OTHER"
			},
			{
				"name": "informants",
				"salience": 0.00030313616,
				"type": "OTHER"
			},
			{
				"name": "intent",
				"salience": 0.0002965694,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0002965694,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00028636123,
				"type": "OTHER"
			},
			{
				"name": "victim",
				"salience": 0.00028275145,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.000277972,
				"type": "WORK_OF_ART"
			},
			{
				"name": "proof",
				"salience": 0.000277972,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.000277972,
				"type": "PERSON"
			},
			{
				"name": "thinking",
				"salience": 0.00027015677,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.00026876168,
				"type": "WORK_OF_ART"
			},
			{
				"name": "law enforcement/engagement",
				"salience": 0.00026876168,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.00026876168,
				"type": "OTHER"
			},
			{
				"name": "negotiation",
				"salience": 0.00026876168,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.00026876168,
				"type": "OTHER"
			},
			{
				"name": "defense attorneys",
				"salience": 0.00026876168,
				"type": "PERSON"
			},
			{
				"name": "tactic",
				"salience": 0.00026876168,
				"type": "OTHER"
			},
			{
				"name": "appeals",
				"salience": 0.00026876168,
				"type": "OTHER"
			},
			{
				"name": "lawyer",
				"salience": 0.00026876168,
				"type": "PERSON"
			},
			{
				"name": "commenters",
				"salience": 0.00026876168,
				"type": "PERSON"
			},
			{
				"name": "inconsistency",
				"salience": 0.00026876168,
				"type": "OTHER"
			},
			{
				"name": "A",
				"salience": 0.00026876168,
				"type": "OTHER"
			},
			{
				"name": "phone calls",
				"salience": 0.00026702022,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.00025679008,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.00025679008,
				"type": "OTHER"
			},
			{
				"name": "witness",
				"salience": 0.00024906397,
				"type": "PERSON"
			},
			{
				"name": "evidence record",
				"salience": 0.00024391417,
				"type": "OTHER"
			},
			{
				"name": "protest/rally",
				"salience": 0.00023184583,
				"type": "EVENT"
			},
			{
				"name": "moments",
				"salience": 0.00023184583,
				"type": "OTHER"
			},
			{
				"name": "evidence record",
				"salience": 0.00023184583,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00023184583,
				"type": "LOCATION"
			},
			{
				"name": "moments",
				"salience": 0.00023184583,
				"type": "OTHER"
			},
			{
				"name": "degree turn",
				"salience": 0.00023184583,
				"type": "OTHER"
			},
			{
				"name": "visit",
				"salience": 0.00023184583,
				"type": "EVENT"
			},
			{
				"name": "leadership",
				"salience": 0.00023184583,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.00023184583,
				"type": "PERSON"
			},
			{
				"name": "doubt",
				"salience": 0.00023184583,
				"type": "OTHER"
			},
			{
				"name": "reading",
				"salience": 0.00023184583,
				"type": "OTHER"
			},
			{
				"name": "refuge truck",
				"salience": 0.00023184583,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "wedge issue",
				"salience": 0.00022334409,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "F.B.I.",
				"salience": 0.00021910814,
				"type": "ORGANIZATION"
			},
			{
				"name": "holes",
				"salience": 0.0002166242,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.00020074745,
				"type": "OTHER"
			},
			{
				"name": "deed",
				"salience": 0.00020074745,
				"type": "OTHER"
			},
			{
				"name": "doctrine",
				"salience": 0.00020074745,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.00020074745,
				"type": "OTHER"
			},
			{
				"name": "assertion",
				"salience": 0.00020074745,
				"type": "OTHER"
			},
			{
				"name": "pleas",
				"salience": 0.00020074745,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00020074745,
				"type": "OTHER"
			},
			{
				"name": "definitions",
				"salience": 0.00018840937,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00018686929,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03mwrb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KATU"
				},
				"name": "KATU",
				"salience": 0.00016539166,
				"type": "ORGANIZATION"
			},
			{
				"name": "Steve Dunn",
				"salience": 0.00016539166,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "twitter",
				"salience": 0.00016539166,
				"type": "OTHER"
			},
			{
				"name": "Maxine Bernstein",
				"salience": 0.00016539166,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lpnx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Safeway_Inc."
				},
				"name": "Safeway",
				"salience": 0.0001426736,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempts",
				"salience": 0.00013720288,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0sn4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hammond,_Indiana"
				},
				"name": "Hammond",
				"salience": 0.00012353579,
				"type": "LOCATION"
			},
			{
				"name": "Ye Olde Castle",
				"salience": 0.00012353579,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0zd0l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Burns,_Oregon"
				},
				"name": "Burns",
				"salience": 0.00012353579,
				"type": "PERSON"
			},
			{
				"name": "Fabio",
				"salience": 0.00012197847,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/bethnakamurajpg-265ea83b6c276579.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:44:42.655+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 40.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Juror explanation for Ammon Bundy verdict 11/03/2016 \nOREGONLIVE \nJuror 4 has so far provided the only public explanation of the behind-the-scenes discussions that led to the acquittal of Ammon Bundy, his brother and five others on federal conspiracy charges stemming from the Malheur National Wildlife Refuge occupation. \nReaders have asked to hear more from him about the jury’s reasoning in reaching the surprising decision. \nJuror 4 – a 44-year-old business administration student at Marylhurst University who served in the Navy during the Iraq War – went into detail in a series of email exchanges with The Oregonian/OregonLive that were used in news stories. \nHere’s a transcript of the emails, with some minor editing for brevity or clarity. He’s asked not to be identified for fear of retribution. The judge sealed the names of all nine women and three men on the jury, citing public safety. \nJuror 4 makes references to U.S. District Judge Anna J. Brown; prosecutor Ethan Knight; Juror 11 who the judge removed from the jury after Juror 4 questioned his objectivity; Juror 18, who replaced Juror 11; and Ryan Payne, one of the leaders of the occupation with Ammon Bundy. \nHe also references a Jan. 2 rally for Harney County ranchers and then the takeover of the refuge later that day. \nAll seven defendants faced a charge of conspiring to impede employees of the U.S. Fish & Wildlife Service or U.S. Bureau of Land Management from doing their work through intimidation, threat or force during the 41-day occupation. \nHis initial email: \nIt should be known that all 12 jurors felt that this verdict was a statement regarding the various failures of the prosecution to prove “conspiracy” in the count itself – and not any form of affirmation of the defense’s various beliefs, actions, or aspirations. Proving the elements of conspiracy, especially given the body of evidence we were forced to restrict ourselves to consider when judging, was far too great a standard to meet (without using our imaginations, prejudices, etc.). \nThe judge floored us when she said that there was no statute against impeding federal officers (by force, threat, or intimidation), nor was there a significant penalty applied to criminal trespass. We all queried about alternative charges that could stick and were amazed that this ‘conspiracy’ charge seemed the best possible option. It was not lost on us that our verdict(s) might inspire future actions that are regrettable, but that sort of thinking was not permitted when considering the charges before us. \nThe prosecution asked us to neglect Judge Brown’s final (binding) instructions when they asserted in closing that adverse possession = conspiracy to impede (as per Mr. Knight’s closing argument), as if defining actions was all that was needed to convict. All 12 agreed that impeding existed, even if as an effect of the occupation, and that something was very wrong. But we were not asked to judge on bullets and hurt feelings, rather to decide if an agreement was made with an illegal object in mind. It seemed this basic, high standard of proof was lost upon the prosecution throughout. Inference, while possibly compelling, proved to be insulting or inadequate to 12 diversely situated people as a means to convict. The air of triumphalism that the prosecution brought was not lost on any of us, nor was it warranted given their burden of proof. \nRegarding my role in crafting the letter that led to the dismissal of juror 11, I can say that it was not only necessary but also borne out of much patience in dealing with a fellow who had zero business being on this jury in the first place. He effectively wasted a great deal of our time as he (irrationally) promoted his theory of conspiracy despite the absence of evidence. Also, he violated Judge Brown’s explicit orders by hearkening to ‘evidence’ that was never admitted in this case, refused to consider the defendant’s state of mind, and used imaginative theories to explain key actions. How this juror slipped through the cracks is mind boggling and very disconcerting. \nYou should know that the sentiments expressed in that letter were the exact thoughts I had when juror 11 first made his opening remarks on day one of deliberations, but I resisted the impulse to send the question at that time and give this fellow the chance to convince/explain. It seemed wise to suspend my shock/disbelief in him until a thorough examination of his mindset was complete (and the other jurors could weigh in themselves on his various theories). The vast majority of time was spent trying to deal with his bizarre theories, compared against what was admitted and/or expected of us as standards of judgment. While I wish now that I had sent the letter on day one, since it would have alleviated much stress for all of us, I would wish to have the time/opportunity to expand or alter my perspective that we afforded him. \nAs I peruse the responses of many interested parties in this case, many of which express ‘profound regret’ over the verdicts, I am baffled by the flippant sentiments that seem to dominate the landscape. Several questions immediately percolate in my mind: do these folks even know what it took to arrive at a verdict on any one of these counts? How could 12 diverse people find such agreement unless there was a colossal failure on the part of the prosecution? Don’t they know that ‘not guilty’ does not mean ‘innocent’? I have many such thoughts swirling around in my head that I’d like to vent, but I need to break it off for now. \n*** \n\nWe asked a series of follow-up questions : How did the jury feel about starting all over again? Did other jurors know about your note regarding Juror 11 — and how did they react to it? How did the jury start anew? Why the substantially shorter time period for the final verdicts? \n\nJuror 4’s response: \nThe feeling, at the time of the reset, was universal relief that we even had a chance to hear from a more objective juror. It was not a relief to think we could be there today (Friday ) or Monday, frankly, but all said they were more than willing to start over in order to erase the ill feelings created while deliberating with juror 11. We had no knowledge about juror 18’s leanings in any regard prior to her coming in (we maintained a strict standard to not discuss the case with each other before deliberating). \nOnly juror #1 knew about my note (since he had to pass it on to the judge), or so I thought. Juror 11, when we later were arguing about his bias, said he knew what I must have been doing when I folded a note and quietly handed it to Juror 1. My note was a last resort, frankly, because I made the entire jury uneasy by directly challenging juror 11 (on Tuesday morning; more than 16 hours of deliberations had passed) about his stated bias. Many jurors were upset at my direct approach and seemingly personal challenge to him. What I had said to him was far more upsetting than the contents of my note, and so I don’t think the jurors should have been surprised. Of course, I didn’t openly state to the jury that I had an open question before the court until the next morning (Wednesday) when juror 11 played the victim. I again reiterated that this whole issue was of his own making, and although he calmly explained what his bias was or meant to him in this case, I was anxious to hear from the court. \nIt is a fact that we were so exhausted by this time that we nearly submitted final ballots on Wednesday, with juror 11’s input (equaling a mistrial on most counts). It is also true that I told the jury that if I did not get an answer to my question from the court, I would be forced to take my grievance to the media immediately afterwards. We had no idea of what had transpired in court as a result of my question, but you begin to feel neglected after almost 24 hours of silence. \nAll of the other 10 jurors were relieved that juror 11 was excused, and most of them personally thanked me for doing what I did (even though I upset them in the process). \nStarting anew was filled with trepidation by the remaining 11 jurors, because we didn’t want to allow any whiff of prior deliberations to influence our new juror. This was all about her, frankly. We let her purge her feelings, as we all had the opportunity to do, and we let her direct the review of evidence. To her credit, she was fairly focused on getting her thoughts communicated quickly and purposefully so that time was not lost. The rapidity of her pace caused us to caution her, slow her a bit, but she was very business-like. It was clear that by 11:00 a.m., our new juror had resolved any questions regarding counts 1 and 2. She was relieved, and perhaps a bit surprised, that there was unanimity on these points. \nWhile we had a robust process for counts 4 and 5, we had reached a point of impasse by 2:00. There were no throw away words expressed on this day. The extremes we felt pressed into really crystallized our purpose, even if we had to go through the essential elements again, and it made for a swift process. \nBefore we sent our final word to the court, I asked our new juror if she could explain why this process was so fast, to which she replied confidently and affirmatively. She’s a sharp lady and can handle herself, I think. \n\nQ. Wondered if there were turning points or particular moments in the trial that stuck out for jurors in helping the jury reach the not guilty pleas. \nA. Turning points? Let me begin by speaking for myself before I attempt to recall those of others. I expected there to be a witness to the January 2nd meeting at Ye Olde Castle before the protest/rally that would confirm the prosecution’s assertion of intent to impede, and the absence of such evidence became a seed of doubt that grew. I expected that there must be proof of conspiracy between Ammon and Ryan Payne (most logical link, owing to their initial visit to the Hammond’s place in early November) but he wasn’t even called for either side, nor were there any phone calls, emails, etc. that would demonstrate agreement here. These two major holes in the evidence record proved to cause insurmountable doubt for me. \nOthers said that, while the evidence record was not adequate, certain moments turned them. One said they did a full 180 degree turn when they realized there were six informants that went unnamed on the refuge during the occupation, and the choice of the prosecution to allow that much room for mysterious influence there (remember Fabio?) was decisive. One said that the doctrine of adverse possession seemed to govern every thought, word, and deed of the ‘leadership’ such that it could not be deemed intent to impede federal workers. Another said that the repeated objections to the reading of the constitution became a wedge issue for them. Those turning points are the most distinct ones I can remember, and so I’ll leave it there. \nQ. What about counts 4 and 5? What was the thinking with those? (Count 4 was a property theft charge against defendant Kennth Medenbach for driving a refuge truck to the Safeway in Burns and Count 5 was a property theft charge against Ryan Bundy for helping to remove FBI surveillance cameras from two utility poles near the refuge.) \n\nA. With count four, we were split for a good while and it didn’t look like we could agree. Because this law requires us to consider intent, one of the jurors pressed hard on the issue of what Medenbach was thinking (adverse possession: he believed it was no longer a refuge truck). The video/audio evidence of his arrest was instructive, confirming a mindset. Some jurors were impressed by the surprise Medenbach expressed to the state police officer when told that the rig was reported as stolen. Another said if he had been caught with it while not doing ‘resource center’ business, so to speak, then it would have demonstrated his intent was not consistent with the claim. Eventually, none of us could imagine he was not going to return the vehicle to the refuge. \nCount five plagued us most of the day. We had to table the discussion a couple times because the contentions over the wording of the law as it relates to ‘knowingly stole’ proved to be a major hang up for one juror. There were many different definitions of ‘stole’ at play in the minds of several jurors. In the morning, 11 out of 12 were prepared to vote guilty, but after simmering and revisiting the debate a few times, the number of votes for not guilty grew to three. A couple of jurors came to believe that having the media present, offering back the cameras to the F.B.I., and taking steps to safeguard them after removal was proof of something other than theft. The majority could not deny that the intent to deprive was clearly present in Ryan. Since we were moving the opposite way of consensus and three jurors were resolved to vote not guilty, we agreed to end deliberations. \nQ. What did you and others think of Ammon Bundy’s testimony? \nA. It was clear that there was no juror who received Ammon’s testimony as fully honest, and several who felt manipulated. Even those who felt he was sincere in his beliefs found examples of inconsistency in his testimony. \nThe continual objections to Ammon’s answers (usually owing to his own misleading phrasing that was disallowed) became tedious to myself, especially since altering one word would make the answer acceptable (and often did). The emotional appeals riddled throughout, while understandable as a tactic, also became tiresome to me since our feelings as jurors are irrelevant after all. And I don’t think it was endearing to us jurors for him to characterize the entire federal court system, of which we were a key part of, as rigged against himself. \nA few outstanding things Ammon testified to stood out to me. There apparently were multiple attempts to meet personally with the F.B.I. by Ammon and yet no face-to-face meet up ever occurred, presumably because the bureau did not wish to have that sort of negotiation. And the lack of law enforcement/engagement throughout the occupation, coupled with the visits to the refuge by many politicians, caused me to see how occupiers could view their presence as something other than illegal. Also, after watching an edited version of KATU’s Steve Dunn interview with Ammon at the refuge (this was played for the jury by Ammon Bundy’s lawyer ), there seemed to be consistency of message/belief that I did not expect — especially if you have 9 months to ponder your defense, even I might alter my emphasis or eliminate something unfavorable. Because of the law’s wording, Ammon’s state of mind weighed heavily. \n\nQ. Why do you wish to remain anonymous? \nA: Because I’d rather not encounter any of the angry commenters on your articles, I prefer to remain simply as Juror 4. I read on twitter that Matt Schindler (one of the defense attorneys) is receiving threats, which is very troubling to me. \n— Maxine Bernstein",
		"thread_title": "Juror explanation for Ammon Bundy verdict",
		"title": "Juror explanation for Ammon Bundy verdict",
		"type": "bs",
		"uuid": "1563b686711efea3931a11a8792788b3d830f3cc"
	},
	"-KhIhLsIqbz62o7Vb1rJ": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T02:44:42.831+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.21205737,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.12609282,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.05149661,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.03379801,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.033255365,
				"type": "ORGANIZATION"
			},
			{
				"name": "William Weld",
				"salience": 0.023746457,
				"type": "PERSON"
			},
			{
				"name": "Nick Giambruno",
				"salience": 0.01677047,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.014005324,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.012740623,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0288kjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doug_Casey"
				},
				"name": "Doug Casey",
				"salience": 0.010645981,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07w42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libertarian_Party_(United_States)"
				},
				"name": "Libertarian Party",
				"salience": 0.009071917,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.007643748,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0071484195,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.007001231,
				"type": "PERSON"
			},
			{
				"name": "hologram",
				"salience": 0.006806028,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.006756376,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0065882737,
				"type": "OTHER"
			},
			{
				"name": "cuts",
				"salience": 0.0062489016,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.0058932784,
				"type": "PERSON"
			},
			{
				"name": "Election",
				"salience": 0.0055497074,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0055402066,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.004953817,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0kbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_War"
				},
				"name": "Civil War",
				"salience": 0.0048796977,
				"type": "EVENT"
			},
			{
				"name": "War",
				"salience": 0.0044810683,
				"type": "EVENT"
			},
			{
				"name": "War",
				"salience": 0.0044810683,
				"type": "EVENT"
			},
			{
				"name": "sports war",
				"salience": 0.004313987,
				"type": "EVENT"
			},
			{
				"name": "The 2nd American Civil War",
				"salience": 0.004191653,
				"type": "EVENT"
			},
			{
				"name": "Cards",
				"salience": 0.004162805,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0040492276,
				"type": "EVENT"
			},
			{
				"name": "kind",
				"salience": 0.003773902,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.003773902,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003553747,
				"type": "PERSON"
			},
			{
				"name": "debt",
				"salience": 0.003546518,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0034781294,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.0034493897,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0033993952,
				"type": "ORGANIZATION"
			},
			{
				"name": "Source",
				"salience": 0.003255338,
				"type": "ORGANIZATION"
			},
			{
				"name": "Voting",
				"salience": 0.0030496344,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0030139554,
				"type": "LOCATION"
			},
			{
				"name": "crisis",
				"salience": 0.0028554017,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.002835856,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.0028126237,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00281092,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.0028019878,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.0027755196,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0027197674,
				"type": "LOCATION"
			},
			{
				"name": "State",
				"salience": 0.0027197674,
				"type": "LOCATION"
			},
			{
				"name": "crisis",
				"salience": 0.00268007,
				"type": "EVENT"
			},
			{
				"name": "debt",
				"salience": 0.002583513,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.002460025,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01tqr5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gary_Johnson"
				},
				"name": "Gary Johnson",
				"salience": 0.0024339745,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.002410845,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0023836675,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/023qcy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republicrat"
				},
				"name": "Republicrats",
				"salience": 0.0023801788,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.0023713293,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.002355579,
				"type": "ORGANIZATION"
			},
			{
				"name": "problems",
				"salience": 0.002331277,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01mv3x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lew_Rockwell"
				},
				"name": "LEW ROCKWELL",
				"salience": 0.0023143706,
				"type": "PERSON"
			},
			{
				"name": "problems",
				"salience": 0.002301912,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.002301912,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0022212036,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0022090962,
				"type": "PERSON"
			},
			{
				"name": "Spending",
				"salience": 0.0022075176,
				"type": "OTHER"
			},
			{
				"name": "welfare",
				"salience": 0.0021266264,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016lh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ron_Paul"
				},
				"name": "Ron Paul",
				"salience": 0.0020600664,
				"type": "PERSON"
			},
			{
				"name": "Richard Hubal",
				"salience": 0.0020041456,
				"type": "PERSON"
			},
			{
				"name": "MN Artists",
				"salience": 0.0020041456,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.0020010956,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0019770903,
				"type": "OTHER"
			},
			{
				"name": "credit collapse",
				"salience": 0.0019728523,
				"type": "EVENT"
			},
			{
				"name": "parties",
				"salience": 0.0019708986,
				"type": "ORGANIZATION"
			},
			{
				"name": "things",
				"salience": 0.0019521835,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jgd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Argentina"
				},
				"name": "Argentina",
				"salience": 0.0019435411,
				"type": "LOCATION"
			},
			{
				"name": "loss",
				"salience": 0.001935995,
				"type": "OTHER"
			},
			{
				"name": "score",
				"salience": 0.0019201804,
				"type": "OTHER"
			},
			{
				"name": "prospect",
				"salience": 0.0019201804,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0019201804,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.0019201804,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.0019201804,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0019201804,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0019201804,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0019201804,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0019201804,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.001819109,
				"type": "PERSON"
			},
			{
				"name": "health",
				"salience": 0.0017715838,
				"type": "OTHER"
			},
			{
				"name": "deficits",
				"salience": 0.0017143127,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0016651701,
				"type": "EVENT"
			},
			{
				"name": "freedom",
				"salience": 0.0016627614,
				"type": "OTHER"
			},
			{
				"name": "odds",
				"salience": 0.0016627614,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0016627614,
				"type": "ORGANIZATION"
			},
			{
				"name": "others",
				"salience": 0.0016627614,
				"type": "PERSON"
			},
			{
				"name": "memories",
				"salience": 0.0016627614,
				"type": "OTHER"
			},
			{
				"name": "serfs",
				"salience": 0.0016627614,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0016627614,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0016627614,
				"type": "LOCATION"
			},
			{
				"name": "destruction",
				"salience": 0.0016627614,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0016627614,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.001566643,
				"type": "PERSON"
			},
			{
				"name": "testimony",
				"salience": 0.0015344443,
				"type": "OTHER"
			},
			{
				"name": "Politicians",
				"salience": 0.0014941047,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.0014693757,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0014479083,
				"type": "ORGANIZATION"
			},
			{
				"name": "ancestors",
				"salience": 0.0014375024,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0013996953,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0013772724,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0011675159,
				"type": "EVENT"
			},
			{
				"name": "types",
				"salience": 0.001148811,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.001104812,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0010827319,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0010508996,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.001025953,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.001023446,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07f1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thailand"
				},
				"name": "Thailand",
				"salience": 0.001023446,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.001023446,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.001015878,
				"type": "PERSON"
			},
			{
				"name": "debt",
				"salience": 0.0010109614,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.0010109614,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.0010109614,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0009876522,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0009876522,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0009876522,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.0009812544,
				"type": "PERSON"
			},
			{
				"name": "libertarian",
				"salience": 0.00096481683,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0009566625,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.0009559943,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.00095376896,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00095376896,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00094471616,
				"type": "ORGANIZATION"
			},
			{
				"name": "reasons",
				"salience": 0.0009134219,
				"type": "OTHER"
			},
			{
				"name": "Military spending",
				"salience": 0.0009087062,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0009007102,
				"type": "OTHER"
			},
			{
				"name": "Bourne",
				"salience": 0.00089018035,
				"type": "PERSON"
			},
			{
				"name": "deficit",
				"salience": 0.00087539264,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00087539264,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00087539264,
				"type": "PERSON"
			},
			{
				"name": "welfare",
				"salience": 0.00087539264,
				"type": "OTHER"
			},
			{
				"name": "dollar",
				"salience": 0.00087539264,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.00087539264,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.00087539264,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.0008697476,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0008643603,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0008490607,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "party",
				"salience": 0.0008375296,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0008375296,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0008375296,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0008364085,
				"type": "OTHER"
			},
			{
				"name": "dollar deficit",
				"salience": 0.0008320903,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0008185461,
				"type": "EVENT"
			},
			{
				"name": "ideas",
				"salience": 0.00080599345,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00079037686,
				"type": "OTHER"
			},
			{
				"name": "student loans",
				"salience": 0.00079037686,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.00079037686,
				"type": "ORGANIZATION"
			},
			{
				"name": "wife",
				"salience": 0.00079037686,
				"type": "PERSON"
			},
			{
				"name": "auto loans",
				"salience": 0.00079037686,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.00079037686,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.00079037686,
				"type": "OTHER"
			},
			{
				"name": "Elections",
				"salience": 0.00078798603,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00078798603,
				"type": "EVENT"
			},
			{
				"name": "most",
				"salience": 0.00078798603,
				"type": "OTHER"
			},
			{
				"name": "Deep State",
				"salience": 0.00077412557,
				"type": "ORGANIZATION"
			},
			{
				"name": "currency units",
				"salience": 0.0007671374,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00075570564,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.00074865663,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.00074865663,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0007362622,
				"type": "OTHER"
			},
			{
				"name": "bet",
				"salience": 0.00072918856,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00072601525,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.00072070514,
				"type": "OTHER"
			},
			{
				"name": "lesser",
				"salience": 0.0007141142,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00071245176,
				"type": "OTHER"
			},
			{
				"name": "family dynasty",
				"salience": 0.00071092386,
				"type": "OTHER"
			},
			{
				"name": "Voting",
				"salience": 0.0007087733,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.0007087733,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0007087733,
				"type": "OTHER"
			},
			{
				"name": "brother",
				"salience": 0.0006843808,
				"type": "PERSON"
			},
			{
				"name": "air",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.0006843808,
				"type": "PERSON"
			},
			{
				"name": "climax",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "sea",
				"salience": 0.0006843808,
				"type": "LOCATION"
			},
			{
				"name": "hand",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "house mortgages",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "bonds",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "defaults",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "mix",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "inflation",
				"salience": 0.0006843808,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00068231055,
				"type": "OTHER"
			},
			{
				"name": "divide",
				"salience": 0.000679947,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00067508564,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.0006643344,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0006643344,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0006643344,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0006643344,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.000654543,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.00064520835,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.0006408304,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.00063953036,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.00063953036,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.00063953036,
				"type": "OTHER"
			},
			{
				"name": "slaves",
				"salience": 0.0006301211,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0006256159,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0006256159,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0006183433,
				"type": "OTHER"
			},
			{
				"name": "evils",
				"salience": 0.0006137185,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0006137185,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.0006137185,
				"type": "LOCATION"
			},
			{
				"name": "evils",
				"salience": 0.0006137185,
				"type": "PERSON"
			},
			{
				"name": "government offices",
				"salience": 0.0006137185,
				"type": "LOCATION"
			},
			{
				"name": "any",
				"salience": 0.0006111492,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.0006111492,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.00059841503,
				"type": "ORGANIZATION"
			},
			{
				"name": "choice",
				"salience": 0.0005979275,
				"type": "OTHER"
			},
			{
				"name": "general",
				"salience": 0.0005908039,
				"type": "PERSON"
			},
			{
				"name": "interest groups",
				"salience": 0.0005908039,
				"type": "ORGANIZATION"
			},
			{
				"name": "depression",
				"salience": 0.0005908039,
				"type": "EVENT"
			},
			{
				"name": "tendencies",
				"salience": 0.0005908039,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.0005908039,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.0005908039,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0005908039,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0005839302,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0005785898,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0005785898,
				"type": "OTHER"
			},
			{
				"name": "socialism",
				"salience": 0.0005785898,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.00057466375,
				"type": "EVENT"
			},
			{
				"name": "civil war",
				"salience": 0.00057466375,
				"type": "EVENT"
			},
			{
				"name": "deals",
				"salience": 0.0005730307,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0005674206,
				"type": "EVENT"
			},
			{
				"name": "Things",
				"salience": 0.0005670242,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0005586766,
				"type": "PERSON"
			},
			{
				"name": "scores",
				"salience": 0.0005541106,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.0005541106,
				"type": "OTHER"
			},
			{
				"name": "sand",
				"salience": 0.0005541106,
				"type": "OTHER"
			},
			{
				"name": "lesser",
				"salience": 0.0005541106,
				"type": "OTHER"
			},
			{
				"name": "The Greater Depression",
				"salience": 0.00055052276,
				"type": "WORK_OF_ART"
			},
			{
				"name": "vote",
				"salience": 0.00054923416,
				"type": "OTHER"
			},
			{
				"name": "tendencies",
				"salience": 0.000547509,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fh83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Medicaid"
				},
				"name": "Medicaid",
				"salience": 0.00053875253,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fzh9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Medicare_(United_States)"
				},
				"name": "Medicare",
				"salience": 0.00053875253,
				"type": "ORGANIZATION"
			},
			{
				"name": "trade",
				"salience": 0.0005334212,
				"type": "OTHER"
			},
			{
				"name": "businessman",
				"salience": 0.0005334212,
				"type": "PERSON"
			},
			{
				"name": "free market",
				"salience": 0.0005334212,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0005334212,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.0005334212,
				"type": "OTHER"
			},
			{
				"name": "illusion",
				"salience": 0.0005334212,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00052206253,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0005128251,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dggd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Prohibition_of_drugs"
				},
				"name": "War on Some Drugs",
				"salience": 0.0005044674,
				"type": "OTHER"
			},
			{
				"name": "backup",
				"salience": 0.0005009909,
				"type": "PERSON"
			},
			{
				"name": "evil",
				"salience": 0.0005009909,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0005009909,
				"type": "OTHER"
			},
			{
				"name": "welfare",
				"salience": 0.0005009909,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0005009909,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0004991263,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xmb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Reserve_System"
				},
				"name": "Federal Reserve",
				"salience": 0.00048642443,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05jd_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nelson_Rockefeller"
				},
				"name": "Rockefeller",
				"salience": 0.00048642443,
				"type": "PERSON"
			},
			{
				"name": "act",
				"salience": 0.00047979422,
				"type": "WORK_OF_ART"
			},
			{
				"name": "finger",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "pulse",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "opponent",
				"salience": 0.00047979422,
				"type": "PERSON"
			},
			{
				"name": "registering",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "government computer database",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.00047979422,
				"type": "EVENT"
			},
			{
				"name": "hoi polloi",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "coercion",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.00047979422,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "privacy",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "grain",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "mandate",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "busybody mode",
				"salience": 0.00047979422,
				"type": "OTHER"
			},
			{
				"name": "bureaucrats",
				"salience": 0.00047979422,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.00047867716,
				"type": "LOCATION"
			},
			{
				"name": "home countries",
				"salience": 0.00047867716,
				"type": "LOCATION"
			},
			{
				"name": "kinds",
				"salience": 0.00047620552,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.00047620552,
				"type": "OTHER"
			},
			{
				"name": "natives",
				"salience": 0.0004758728,
				"type": "PERSON"
			},
			{
				"name": "notions",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "creatures",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.00046187913,
				"type": "PERSON"
			},
			{
				"name": "killing",
				"salience": 0.00046187913,
				"type": "EVENT"
			},
			{
				"name": "torture",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "endorsement",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "supernumeraries",
				"salience": 0.00046187913,
				"type": "PERSON"
			},
			{
				"name": "Executive Orders",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "rice bowls",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "enthusiasm",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "apple carts",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "Establishment",
				"salience": 0.00046187913,
				"type": "ORGANIZATION"
			},
			{
				"name": "outsider",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "academia",
				"salience": 0.00046187913,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.00046187913,
				"type": "EVENT"
			},
			{
				"name": "respect",
				"salience": 0.00046187913,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.00045650508,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00045560548,
				"type": "PERSON"
			},
			{
				"name": "Everybody",
				"salience": 0.00045407243,
				"type": "PERSON"
			},
			{
				"name": "principle",
				"salience": 0.0004523299,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0004523299,
				"type": "OTHER"
			},
			{
				"name": "statist",
				"salience": 0.0004523299,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.0004523299,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0004523299,
				"type": "OTHER"
			},
			{
				"name": "backup system",
				"salience": 0.0004523299,
				"type": "OTHER"
			},
			{
				"name": "War",
				"salience": 0.0004459001,
				"type": "EVENT"
			},
			{
				"name": "civil war",
				"salience": 0.0004459001,
				"type": "EVENT"
			},
			{
				"name": "Demopublicans",
				"salience": 0.00044354174,
				"type": "PERSON"
			},
			{
				"name": "tariffs",
				"salience": 0.00043902843,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.00043902843,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00043579526,
				"type": "ORGANIZATION"
			},
			{
				"name": "take",
				"salience": 0.0004334946,
				"type": "OTHER"
			},
			{
				"name": "turbulence",
				"salience": 0.0004334946,
				"type": "OTHER"
			},
			{
				"name": "Libertarians",
				"salience": 0.00042845073,
				"type": "PERSON"
			},
			{
				"name": "grasp",
				"salience": 0.0004280305,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cbw2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Evita_(musical)"
				},
				"name": "Evita",
				"salience": 0.00042118455,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d3k14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy"
				},
				"name": "Kennedy",
				"salience": 0.00042118455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019x9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeb_Bush"
				},
				"name": "Jeb Bush",
				"salience": 0.00042118455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01df1y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Juan_Per%C3%B3n"
				},
				"name": "Juan Peron",
				"salience": 0.00042118455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02yy8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Franklin_D._Roosevelt"
				},
				"name": "Roosevelt",
				"salience": 0.00042118455,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Security_(United_States)"
				},
				"name": "Social Security",
				"salience": 0.00042118455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.00042118455,
				"type": "PERSON"
			},
			{
				"name": "difference",
				"salience": 0.00041918096,
				"type": "OTHER"
			},
			{
				"name": "duck",
				"salience": 0.00041730804,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.00040868015,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00040508335,
				"type": "OTHER"
			},
			{
				"name": "tendencies",
				"salience": 0.00040381093,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00040258927,
				"type": "OTHER"
			},
			{
				"name": "beach",
				"salience": 0.00039166218,
				"type": "LOCATION"
			},
			{
				"name": "suit",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "regulations",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "gender",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "beliefs",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "promoter",
				"salience": 0.00039166218,
				"type": "PERSON"
			},
			{
				"name": "neocon",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "toker",
				"salience": 0.00039166218,
				"type": "PERSON"
			},
			{
				"name": "race baiters",
				"salience": 0.00039166218,
				"type": "PERSON"
			},
			{
				"name": "like",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.00039166218,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0003912741,
				"type": "PERSON"
			},
			{
				"name": "nonsense",
				"salience": 0.0003867253,
				"type": "OTHER"
			},
			{
				"name": "illusion",
				"salience": 0.00037872963,
				"type": "OTHER"
			},
			{
				"name": "dollar",
				"salience": 0.0003742172,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0003742172,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0003742172,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00037228485,
				"type": "OTHER"
			},
			{
				"name": "pot",
				"salience": 0.00037228485,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0003534094,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00034859206,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00034859206,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00034859206,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.00034349968,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/014cwh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Statism"
				},
				"name": "Statist",
				"salience": 0.00034100682,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00034031493,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.00034031493,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "reserve banking system",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "fiat currency",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "points of view",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00033786814,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.00033306523,
				"type": "EVENT"
			},
			{
				"name": "civil war",
				"salience": 0.00033306523,
				"type": "EVENT"
			},
			{
				"name": "assets",
				"salience": 0.00031971696,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00031971696,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00031710372,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00031332546,
				"type": "OTHER"
			},
			{
				"name": "clashes",
				"salience": 0.00030526269,
				"type": "OTHER"
			},
			{
				"name": "goods",
				"salience": 0.00030526269,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "things",
				"salience": 0.00030455194,
				"type": "OTHER"
			},
			{
				"name": "Reps",
				"salience": 0.0003019296,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.0002962855,
				"type": "OTHER"
			},
			{
				"name": "Bernie-istas",
				"salience": 0.00029526843,
				"type": "PERSON"
			},
			{
				"name": "Everything",
				"salience": 0.0002949959,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0002949959,
				"type": "PERSON"
			},
			{
				"name": "widescreen",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "upset",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "trends",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "nerve",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "edge",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "coffee shop",
				"salience": 0.00029255069,
				"type": "LOCATION"
			},
			{
				"name": "feet",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "silver",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.00029255069,
				"type": "OTHER"
			},
			{
				"name": "bones",
				"salience": 0.00028886297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.00028424265,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00028424265,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.00028424265,
				"type": "LOCATION"
			},
			{
				"name": "steps",
				"salience": 0.00027932448,
				"type": "OTHER"
			},
			{
				"name": "credit card",
				"salience": 0.00027251724,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.00027251724,
				"type": "OTHER"
			},
			{
				"name": "cards",
				"salience": 0.00027251724,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00027251724,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00027251724,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.00026215764,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0002491869,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00024831702,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00024604576,
				"type": "OTHER"
			},
			{
				"name": "prosperity",
				"salience": 0.00024604576,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.00024604576,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.00024604576,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0651vn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marxism"
				},
				"name": "Marxists",
				"salience": 0.00024102839,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02m6pd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Hospers"
				},
				"name": "John Hospers",
				"salience": 0.00024102839,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazis",
				"salience": 0.00024102839,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0qfsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_Browne"
				},
				"name": "Harry Browne",
				"salience": 0.00024102839,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fdg8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bob_Barr"
				},
				"name": "Bob Barr",
				"salience": 0.00024102839,
				"type": "PERSON"
			},
			{
				"name": "ex-Congressman",
				"salience": 0.00024102839,
				"type": "PERSON"
			},
			{
				"name": "somebody",
				"salience": 0.00023508609,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00023508609,
				"type": "OTHER"
			},
			{
				"name": "riots",
				"salience": 0.00022801306,
				"type": "EVENT"
			},
			{
				"name": "unpleasantness",
				"salience": 0.00022413277,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.00022034415,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00021548464,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0xs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._state"
				},
				"name": "States",
				"salience": 0.00021452177,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.00021399949,
				"type": "OTHER"
			},
			{
				"name": "conflagrations",
				"salience": 0.00021304325,
				"type": "EVENT"
			},
			{
				"name": "bombings",
				"salience": 0.00021304325,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.00021304325,
				"type": "PERSON"
			},
			{
				"name": "ghetto",
				"salience": 0.00021304325,
				"type": "OTHER"
			},
			{
				"name": "cusp",
				"salience": 0.00021304325,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00021304325,
				"type": "OTHER"
			},
			{
				"name": "secession",
				"salience": 0.00021304325,
				"type": "OTHER"
			},
			{
				"name": "fascists",
				"salience": 0.00021304325,
				"type": "PERSON"
			},
			{
				"name": "communists",
				"salience": 0.00021304325,
				"type": "PERSON"
			},
			{
				"name": "sun",
				"salience": 0.00021304325,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.00021304325,
				"type": "OTHER"
			},
			{
				"name": "hat",
				"salience": 0.00021304325,
				"type": "OTHER"
			},
			{
				"name": "revolution",
				"salience": 0.00021304325,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.00020792203,
				"type": "LOCATION"
			},
			{
				"name": "recipients",
				"salience": 0.00020770596,
				"type": "PERSON"
			},
			{
				"name": "generals",
				"salience": 0.00020355351,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.00020355351,
				"type": "ORGANIZATION"
			},
			{
				"name": "bunch",
				"salience": 0.00020355351,
				"type": "OTHER"
			},
			{
				"name": "free market",
				"salience": 0.00019581536,
				"type": "OTHER"
			},
			{
				"name": "Children",
				"salience": 0.00018529511,
				"type": "PERSON"
			},
			{
				"name": "Boobus Americanus",
				"salience": 0.00018505596,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.00018378052,
				"type": "OTHER"
			},
			{
				"name": "street rioting",
				"salience": 0.00018378052,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00018378052,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.00018378052,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00018378052,
				"type": "OTHER"
			},
			{
				"name": "heads",
				"salience": 0.00018378052,
				"type": "OTHER"
			},
			{
				"name": "traditionalists",
				"salience": 0.00018378052,
				"type": "PERSON"
			},
			{
				"name": "type",
				"salience": 0.00018378052,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00018378052,
				"type": "OTHER"
			},
			{
				"name": "doggy dish",
				"salience": 0.0001829593,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.00018003277,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00018003277,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00018003277,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cubans",
				"salience": 0.00018003277,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnamese",
				"salience": 0.00018003277,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ylj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venezuela"
				},
				"name": "Venezuelans",
				"salience": 0.00018003277,
				"type": "PERSON"
			},
			{
				"name": "Rhodesians",
				"salience": 0.00018003277,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0001739068,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "redemption",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "military dictatorship",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.00015912925,
				"type": "ORGANIZATION"
			},
			{
				"name": "government benefits",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "bullets",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "coin",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00015912925,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00013727153,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0w_s6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ferguson,_Missouri"
				},
				"name": "Ferguson",
				"salience": 0.00013110321,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spain",
				"salience": 0.00013110321,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/094jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltimore"
				},
				"name": "Baltimore",
				"salience": 0.00013110321,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0841v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walmart"
				},
				"name": "Wal-Mart",
				"salience": 0.00013110321,
				"type": "ORGANIZATION"
			},
			{
				"name": "Watts",
				"salience": 0.00013110321,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.00013110321,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09gs3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Guard_of_the_United_States"
				},
				"name": "National Guard",
				"salience": 0.00013110321,
				"type": "ORGANIZATION"
			},
			{
				"name": "value",
				"salience": 0.00012825894,
				"type": "OTHER"
			},
			{
				"name": "non-Democrats",
				"salience": 0.0000979247,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0000979247,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "NSA",
				"salience": 0.0000979247,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0000979247,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01c1fm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Praetorian_Guard"
				},
				"name": "Praetorian",
				"salience": 0.0000979247,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0000979247,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f5bn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/H._L._Mencken"
				},
				"name": "H.L. Mencken",
				"salience": 0.00008516988,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/IMC1019.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:44:42.831+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 67.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Doug Casey: A Civil War Could Be in the Cards After the Election 11/03/2016 \nLEW ROCKWELL \n( Source: The 2nd American Civil War by Richard Hubal, via MN Artists ) \nNick Giambruno: The US presidential election is only days away. What are the country’s greatest problems right now? \nDoug Casey: Domestically, I’d say the continual and accelerating loss of freedom, compounded by the prospect of what I suspect will be the biggest financial/economic crisis of modern times. What might that crisis be like? That’s unpredictable, although the odds are it will be unlike any others that are still fresh in people’s memories, simply because people tend to be most prepared for the things that have most recently scared them. The big problems usually come from an unexpected quarter, and/or at an unexpected time. Like the monetary crisis of 1998, that materialized in Thailand. \nThat said, the question remains of where to look. It could come from outside American borders, in the form of war. War is perhaps the worst thing that can happen, not only for the destruction it will cause in itself, but because it will immensely exacerbate America’s domestic problems. As Bourne famously said, “War is the health of the State.” Certainly, the US government is actively provoking other governments in a score of places around the world. The next war could be serious, not just a sports war, like those in Iraq and Afghanistan. \nNick Giambruno: In 2000, the federal government’s debt was just over $5 trillion. Now, it’s about $20 trillion. It doesn’t matter who’s in power. The debt continues to grow exponentially. Unless the government makes radical cuts to welfare and the military—which won’t happen no matter who is elected—it will grow indefinitely. \nIf Americans are destined to be indebted serfs no matter who’s in power, do the elections even matter? \nDoug Casey: If the economy goes off of the deep end over the next year—and I think it will—the US government is going to be running much bigger deficits. Spending is going to go up for welfare. Medicare, Medicaid, Social Security—that’s already about two-thirds of the US government’s budget. Military spending is also going up. All that is going to go up, regardless of who wins the election on November 8. \nWe could easily see a trillion dollar deficit, perhaps much more. Now, where are they going to get all that money? The Chinese aren’t going to lend it to the US anymore. They’re basically going to finance the deficit by selling the debt to the Federal Reserve. And that means creating more currency units out of thin air. \nBut, on the other hand, the average guy—and for that matter, most businesses—aren’t borrowing money now. They’re too afraid. They don’t want to be in debt. The question is: As this comes to a real climax, are we going to have something resembling a runaway inflation in the dollar? Or are we going to have a massive credit collapse, which could be caused by defaults on bonds, house mortgages, student loans, or auto loans? I’m not sure which is going to happen. I mean, you buy a car now in the US, it costs you what a house did a couple generations ago. It all floats on a sea of debt. I’m just betting on financial chaos. That is the safe bet. \nNo matter which way this election goes, it’s going to be ugly. \nBoth candidates, Trump and Clinton, are disastrous. To me, it’s a sign of how degraded the US has become. About a year ago, they gave us a choice between Hillary, the wife of a previous president, pretty much playing the role of Argentina’s Evita, Juan Peron’s brassy wife. And Jeb Bush, the brother of one previous president and the son of another. The US has gone so far downhill that we can only choose which family dynasty we prefer to rule. If only a Kennedy, a Roosevelt, or a Rockefeller could be thrown into the mix as well… Maybe next time. Although I think we’re due for a general or two. \nElections are, quite frankly, meaningless. These two corrupt parties, the Republicrats, and the Demopublicans, run by political hacks and funded by interest groups, simply appoint the people that they want and then present the American people with the illusion of a choice. The people who run these parties have become increasingly bold and arrogant. They’re absolutely horrible creatures, the same types that used to thrive in the Soviet Union. Americans should be ashamed of themselves for treating them with any respect at all. \nHowever, if forced to choose between the two candidates, I would definitely go for Trump, simply because he’s something of an outsider. The media, Hollywood, academia, and the Establishment hate him. And I believe he hates them. If elected, he will likely overturn a lot of apple carts in Washington and break a lot of rice bowls of people who live off the Deep State. That would be an excellent thing. It’s also possible he would retract most of Obama’s Executive Orders, and fire a bunch of supernumeraries. But he might replace them with a bunch of his own. \nHowever, it’s clear Trump has all kinds of dangerous authoritarian tendencies—don’t forget his endorsement of torture and the killing of families of accused terrorists as a policy. He also has all kinds of really silly and destructive economic notions—he appears to think he can cut “deals” with foreign governments. That has nothing to do with the concept of free trade. He’s threatened punitive tariffs, something that would immensely aggravate The Greater Depression. Worse, since as a businessman he’s associated with the free market—unfortunately, and incorrectly—capitalism will wind up being blamed for this depression as well as a result. \nIncidentally, I believe—as I have for over a year—that Trump is going to win. Why? It’s not just the immense enthusiasm of his supporters, as opposed to the lukewarm support that Hillary gets. It’s that Bernie Sanders was the other “protest” candidate in this election. His numerous and enthusiastic supporters believe—correctly—that Hillary and the Democratic machine stole the nomination from him. They’re genuinely pissed off. I believe only the most oblivious ones will vote for Hillary. A few might be mad enough to want to burn the house down by voting for Trump. \nI haven’t heard anyone talking about the absence of the Bernie-istas. I don’t keep my finger on the pulse of the hoi polloi . But, if I’m right, it will result in a landslide for Trump. \nUnfortunately, Trump is no libertarian—but neither is the dim-bulb candidate of the Libertarian Party. That said Trump is a lot better than Hillary—this is no time for a corrupt, hostile, elderly, debilitated, mildly demented Statist to become president. So, sure, I’d prefer Trump. \nAm I going to vote for him? I don’t believe in being complicit in a criminal act, so I don’t vote. \nNick Giambruno: Please elaborate… \nDoug Casey: There are at least five reasons not to vote: Voting in a political election is unethical. The political process is one of institutionalized coercion and force. If you disapprove of those things, then you shouldn’t participate in them, even indirectly. Voting compromises your privacy. It gets your name in yet another government computer database. Voting, as well as registering, entails hanging around government offices and dealing with petty bureaucrats. Most people can find something more enjoyable or productive to do with their time. Voting encourages politicians. A vote against one candidate—a major, and quite understandable, the reason why most people vote—is always interpreted as a vote for his opponent. And even though you may be voting for the lesser of two evils, the lesser of two evils is still evil. It amounts to giving the candidate a tacit mandate to impose his will on society. Your vote doesn’t count. Politicians like to say it counts because it is to their advantage to get everyone into a busybody mode. But, statistically, one vote in scores of millions makes no more difference than a single grain of sand on a beach. That’s entirely apart from the fact that officials manifestly do what they want, not what you want, once they are in office. \nNick Giambruno: What about voting for the Libertarian Party? \nDoug Casey: The Libertarian Party once had a claim to being the party of principle, back in the days when people like John Hospers, Harry Browne, and Ron Paul were their candidates. Then they for some reason put forward the empty suit Bob Barr, an ex-Congressman. \nIt appears that the Libertarian Party has been captured by the Republicans, which is surprisingly clever on the Republicans’ part. Now they have two parties that are registered in all 50 states. It’s kind of a backup system to the regular Republican Party. They’ll need a backup since the old GOP is a dead duck. \nRegarding Gary Johnson, I don’t know what his philosophical beliefs, if any, are. I suspect neither, does he. The only thing we really know is that he wants to see pot legalized on a national scale. Well, bravo. I’m all for that, even though I’m not a toker. It’s a step in the right direction toward dismantling the insane War on Some Drugs. But does he have any other libertarian tendencies? He doesn’t seem to even have a grasp of the basic principles… although he seems better than the average politician. But that’s not saying much. \nI’m especially concerned about his running mate, William Weld, who’s an actual neocon. He’s an overt statist, an active promoter of warfare, welfare, taxes and regulations. He has no libertarian tendencies at all that I’m aware of. He’s a pure Deep State guy. \nOne thing you’ve got to say about the Democratic Party is that, while their ideas are destructive and evil, at least they’re honest about them. Democrats make no bones about being the party of socialism, and they naturally attract the envy-driven, the class warriors, the politically correct, the cultural Marxists, the race baiters, the gender Nazis, and the like. The Democratic Party is beyond redemption. It needs to be flushed. It has zero redeeming value. \nThe Republicans attract a different group. Religious people. Cultural traditionalists. People who generally favor what they think is the free market. They tend to be much more nationalistic and pro-military than the Democrats. But, unlike the Dems, the Reps have no real philosophical foundation. They’re basically just non-Democrats… \nThe Democrats can be viewed as the evil party and the Republicans as the stupid party. But they’re really just two sides of the same coin, at least when it comes to their leadership—who are all Deep State members. \nThe Libertarians must now be viewed, at best, as the smart wing of the stupid party. It’s a sad testimony to the nature of politics… \nThe situation has actually gotten out of control, and the government is so big and so powerful at this point that it can’t be reversed. Even if Ron Paul were elected, it wouldn’t do any good. \nThe first thing that would happen is that he would be sat down with a bunch of generals and heads of Praetorian agencies, like the FBI, the NSA and the CIA, who would inform him—politely, but firmly—how things really work. If he didn’t play by their rules, his life would be at risk. And if for some reason he dodged those bullets, he would be impeached by Congress before he had the chance to actually change anything. And if for some reason that didn’t work, the average American would be out in the street rioting, because his doggy dish was going to be broken. Don’t forget, almost 50% of Americans are net recipients of government benefits. \nI’m afraid that when the looming crisis blows up, the American people— Boobus Americanus as H. L. Mencken said—is going to clamor for somebody to kiss it all and make it better. We could very well wind up with some type of a military dictatorship. \nNick Giambruno: I agree, Doug. I also do not vote. And there are far more powerful ways to vote anyway. \nYou can vote with your money by swapping fiat currency stored in a fractional reserve banking system (like the US dollar) for physical gold and silver. \nYou can also vote with your feet by leaving the country. \nInstead of voting for a politician, which only creates the illusion of making a difference, those two steps can actually make a positive change in your life. \nWhat’s your take? \nDoug Casey: I agree. The thing is that all of our ancestors—all of us who are Americans—came from foreign countries. Everybody came to America because they wanted to get away from being turned into slaves in their home countries. The problem is that the US government is going in the same direction as those governments that our ancestors ran away from. Now we have to go someplace else ourselves. We have to find a new America. \nI’m very pleased that I can watch all this nonsense on a widescreen in a coffee shop in Argentina and not be very adversely affected by it. Argentina, incidentally, is now going the right way from many points of view. \nIt’s dangerous to stay rooted in one place when the natives get restless. Ask Russians in the 20’s, Germans in the 30’s, any European in the 40’s, Chinese in the 50’s, Cubans in the 60’s, Vietnamese in the 70’s, Rhodesians in the 80’s—or Venezuelans today. And that’s just an incomplete list off the top of my head. It’s especially risky if you have some assets during real economic upset, or ideas that aren’t mainstream when there’s real political turbulence. \nNick Giambruno: Most Americans are effectively stuck in the US. So, looking at these disturbing socio-political trends, what else could happen? \nDoug Casey: It’s amazing, and disturbing, that most of the young people in the US support Bernie, an avowed socialist, whose ideas are, if anything, worse than Hillary’s. But it just shows how unhappy young people are with the status quo. Justifiably unhappy. \nBernie and Trump hit the same nerve—they sensed that we’re on the edge of a revolution in this country. We really are. The situation is not unlike that before the War Between the States, very unstable. \nBoth sides are extremely antagonistic. People either hate Trump or they hate Hillary. It doesn’t matter who wins; the other side is going to be very, very unhappy. And with tensions already running high in the country, and racial, cultural and social clashes in the background, it almost feels like a civil war is in the cards for the US. \nOf course, it seemed like we could have had a civil war back in the late 60’s and early 70’s when there were not just a few, but thousands of bombings. Not just little riots, like in Ferguson and Baltimore, but conflagrations like in Watts, DC, and Detroit, where the National Guard was raking the ghetto with .50 cals. \nBut the country’s prosperity was still increasing in those days. Now we’re on the cusp of The Greater Depression. Things could get ugly. \nContrary to what most believe, the US hasn’t had a real civil war yet. The unpleasantness of 1861–65 was actually a war of secession. A civil war is one where two or more groups are vying for the control of the same government, as in Spain during the 30’s, between the fascists and the communists. \nBut this time in the US it could turn into a real civil war. I don’t know what form it would take, but a lot of things could be really tough going: economically, financially, politically, socially, militarily. Most important, there’s a cultural divide that’s arisen in the US. \nI don’t think most people are even aware of what is going on. When you walk outside, the sun is shining. Children are still playing. You can go down to the Wal-Mart and buy cheap goods. Everything looks pretty good on the surface, despite the fact everyone’s credit card is maxed out. But I think it’s all a hologram that’s about to be exposed. So, hold on to your hat.",
		"thread_title": "Doug Casey: A Civil War Could Be in the Cards After the Election",
		"title": "Doug Casey: A Civil War Could Be in the Cards After the Election",
		"type": "bs",
		"uuid": "0d16b7b8853e18fde62e354b863a0f0d05f95cfe"
	},
	"-KhIhM43dn69DyPKCxlS": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T02:44:43.180+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Juror explanation",
				"salience": 0.17590214,
				"type": "OTHER"
			},
			{
				"name": "discussions",
				"salience": 0.14707822,
				"type": "EVENT"
			},
			{
				"name": "verdict",
				"salience": 0.14271577,
				"type": "OTHER"
			},
			{
				"name": "OREGONLIVE Juror 4",
				"salience": 0.10277347,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ammon Bundy",
				"salience": 0.08937793,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0569349,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.044842295,
				"type": "PERSON"
			},
			{
				"name": "Cards",
				"salience": 0.021856325,
				"type": "OTHER"
			},
			{
				"name": "Election",
				"salience": 0.021856325,
				"type": "EVENT"
			},
			{
				"name": "citizenship",
				"salience": 0.02035501,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.017863763,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_War"
				},
				"name": "Civil War",
				"salience": 0.017436687,
				"type": "EVENT"
			},
			{
				"name": "citizenship",
				"salience": 0.015421903,
				"type": "OTHER"
			},
			{
				"name": "LEW ROCKWELL",
				"salience": 0.013485554,
				"type": "PERSON"
			},
			{
				"name": "Doug Casey",
				"salience": 0.012984003,
				"type": "PERSON"
			},
			{
				"name": "The 2nd American Civil War",
				"salience": 0.0127166,
				"type": "EVENT"
			},
			{
				"name": "Richard Hubal",
				"salience": 0.011016727,
				"type": "PERSON"
			},
			{
				"name": "MN Artists",
				"salience": 0.011016727,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.010837664,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.010837664,
				"type": "LOCATION"
			},
			{
				"name": "decree",
				"salience": 0.009741456,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.009741456,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.008235886,
				"type": "ORGANIZATION"
			},
			{
				"name": "AMTV Archives",
				"salience": 0.0060016764,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hqly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_Seagal"
				},
				"name": "Steven Seagal",
				"salience": 0.0044849273,
				"type": "PERSON"
			},
			{
				"name": "Nick Giambruno",
				"salience": 0.0044849273,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^516E4811A794AF675C857856DE2BA3B89B661DD5D634F25476^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:44:43.180+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.3,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Juror explanation for Ammon Bundy verdict 11/03/2016 OREGONLIVE Juror 4 has so far provided the only public explanation of the behind-the-scenes discussions that led to t ... Doug Casey: A Civil War Could Be in the Cards After the Election 11/03/2016 LEW ROCKWELL (Source: The 2nd American Civil War by Richard Hubal, via MN Artists) Nick Giambruno: The US preside ... Putin grants Steven Seagal Russian citizenship 11/03/2016 DAILY MAIL President Vladimir Putin signed off Thursday on a decree granting Russian citizenship to American action her ... AMTV Archives",
		"thread_title": "FBI Believe Clinton Foundation Case Moving Towards ‘Likely an Indictment’",
		"title": "FBI Believe Clinton Foundation Case Moving Towards ‘Likely an Indictment’",
		"type": "bs",
		"uuid": "7d8714795405dca20edae23ca393a0e6af98e806"
	},
	"-KhIhMGWIPNY68xPvPx2": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T02:44:43.932+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "video",
				"salience": 0.14202811,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Preparing Hillary Victory Results",
				"salience": 0.10196706,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6gkfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream_media"
				},
				"name": "MSM",
				"salience": 0.088586226,
				"type": "ORGANIZATION"
			},
			{
				"name": "discussions",
				"salience": 0.07897563,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.05966005,
				"type": "OTHER"
			},
			{
				"name": "election results",
				"salience": 0.05559162,
				"type": "OTHER"
			},
			{
				"name": "AMTV",
				"salience": 0.042580638,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.036920514,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fkcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream"
				},
				"name": "Mainstream",
				"salience": 0.036920514,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.036920514,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.029997597,
				"type": "PERSON"
			},
			{
				"name": "Juror explanation",
				"salience": 0.025829246,
				"type": "OTHER"
			},
			{
				"name": "Election",
				"salience": 0.022499038,
				"type": "EVENT"
			},
			{
				"name": "verdict",
				"salience": 0.02075121,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.02032425,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.02006929,
				"type": "OTHER"
			},
			{
				"name": "Cards",
				"salience": 0.017609691,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.015199752,
				"type": "OTHER"
			},
			{
				"name": "OREGONLIVE Juror 4",
				"salience": 0.014769618,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_War"
				},
				"name": "Civil War",
				"salience": 0.014584088,
				"type": "EVENT"
			},
			{
				"name": "Doug Casey",
				"salience": 0.013289348,
				"type": "PERSON"
			},
			{
				"name": "Ammon Bundy",
				"salience": 0.012794609,
				"type": "OTHER"
			},
			{
				"name": "LEW ROCKWELL",
				"salience": 0.010854414,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.009597006,
				"type": "OTHER"
			},
			{
				"name": "decree",
				"salience": 0.009597006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hqly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_Seagal"
				},
				"name": "Steven Seagal",
				"salience": 0.008112837,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.008112837,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0072118803,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0072118803,
				"type": "LOCATION"
			},
			{
				"name": "Source",
				"salience": 0.007172461,
				"type": "ORGANIZATION"
			},
			{
				"name": "AMTV Archives",
				"salience": 0.005911009,
				"type": "OTHER"
			},
			{
				"name": "The 2nd American Civil War",
				"salience": 0.005100058,
				"type": "EVENT"
			},
			{
				"name": "MN Artists",
				"salience": 0.004416667,
				"type": "ORGANIZATION"
			},
			{
				"name": "Richard Hubal",
				"salience": 0.004416667,
				"type": "PERSON"
			},
			{
				"name": "Nick Giambruno",
				"salience": 0.004416667,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^47616041B92D6455F843492A99E8C1AD5D6BC30241469D590E^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:44:43.932+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "MSM Caught Preparing Hillary Victory Results Prior to Election 11/03/2016 \nIn today’s video, Christopher Greene of AMTV reports the Mainstream media caught preparing Hillary Clinton election results prior to November 8. Juror explanation for Ammon Bundy verdict 11/03/2016 OREGONLIVE Juror 4 has so far provided the only public explanation of the behind-the-scenes discussions that led to t ... Doug Casey: A Civil War Could Be in the Cards After the Election 11/03/2016 LEW ROCKWELL (Source: The 2nd American Civil War by Richard Hubal, via MN Artists) Nick Giambruno: The US preside ... Putin grants Steven Seagal Russian citizenship 11/03/2016 DAILY MAIL President Vladimir Putin signed off Thursday on a decree granting Russian citizenship to American action her ... AMTV Archives",
		"thread_title": "MSM Caught Preparing Hillary Victory Results Prior to Election",
		"title": "MSM Caught Preparing Hillary Victory Results Prior to Election",
		"type": "bs",
		"uuid": "cd5ab70eb6c90919568d9371553555f347668a4b"
	},
	"-KhIhMaUKUR0DeetXe1h": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T02:44:44.106+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.14987625,
				"type": "PERSON"
			},
			{
				"name": "Prerecorded RT Interview",
				"salience": 0.10018782,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.096312925,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.06751918,
				"type": "EVENT"
			},
			{
				"name": "Election",
				"salience": 0.06751918,
				"type": "EVENT"
			},
			{
				"name": "discussions",
				"salience": 0.06353833,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.058587883,
				"type": "WORK_OF_ART"
			},
			{
				"name": "AMTV",
				"salience": 0.041806437,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.03624665,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.029447526,
				"type": "PERSON"
			},
			{
				"name": "Juror explanation",
				"salience": 0.025354285,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.020368326,
				"type": "EVENT"
			},
			{
				"name": "verdict",
				"salience": 0.020368326,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.01994914,
				"type": "OTHER"
			},
			{
				"name": "Election",
				"salience": 0.01994914,
				"type": "EVENT"
			},
			{
				"name": "citizenship",
				"salience": 0.019698821,
				"type": "OTHER"
			},
			{
				"name": "Cards",
				"salience": 0.017284092,
				"type": "OTHER"
			},
			{
				"name": "OREGONLIVE Juror 4",
				"salience": 0.015056368,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizenship",
				"salience": 0.01491826,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_War"
				},
				"name": "Civil War",
				"salience": 0.014313887,
				"type": "EVENT"
			},
			{
				"name": "Ammon Bundy",
				"salience": 0.01255728,
				"type": "OTHER"
			},
			{
				"name": "Doug Casey",
				"salience": 0.010652814,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.009418611,
				"type": "OTHER"
			},
			{
				"name": "decree",
				"salience": 0.009418611,
				"type": "OTHER"
			},
			{
				"name": "Nick Giambruno",
				"salience": 0.007961882,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hqly",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_Seagal"
				},
				"name": "Steven Seagal",
				"salience": 0.007961882,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0070776097,
				"type": "LOCATION"
			},
			{
				"name": "Source",
				"salience": 0.007038921,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.0058008637,
				"type": "ORGANIZATION"
			},
			{
				"name": "AMTV Archives",
				"salience": 0.0058008637,
				"type": "OTHER"
			},
			{
				"name": "The 2nd American Civil War",
				"salience": 0.0050049727,
				"type": "EVENT"
			},
			{
				"name": "MN Artists",
				"salience": 0.0043342854,
				"type": "ORGANIZATION"
			},
			{
				"name": "Richard Hubal",
				"salience": 0.0043342854,
				"type": "PERSON"
			},
			{
				"name": "LEW ROCKWELL",
				"salience": 0.0043342854,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^F29A9D6A69D451ABA8A7561F4FDB2001C0F1D738D987C2E53D^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T02:44:44.106+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Julian Assange to Speak Prerecorded RT Interview (11/5/16) 11/03/2016 \nIn today’s video, Christopher Greene of AMTV reports on a prerecorded Julian Assange interview to be aired prior to the U.S. Election on Saturday November 5, 2016. Start Your FREE 14-day trial! Juror explanation for Ammon Bundy verdict 11/03/2016 OREGONLIVE Juror 4 has so far provided the only public explanation of the behind-the-scenes discussions that led to t ... Doug Casey: A Civil War Could Be in the Cards After the Election 11/03/2016 LEW ROCKWELL (Source: The 2nd American Civil War by Richard Hubal, via MN Artists) Nick Giambruno: The US preside ... Putin grants Steven Seagal Russian citizenship 11/03/2016 DAILY MAIL President Vladimir Putin signed off Thursday on a decree granting Russian citizenship to American action her ... AMTV Archives",
		"thread_title": "Julian Assange to Speak Prerecorded RT Interview (11/5/16)",
		"title": "Julian Assange to Speak Prerecorded RT Interview (11/5/16)",
		"type": "bs",
		"uuid": "ef09902d08145669c50535130fcaedba90594757"
	},
	"-KhIhMwxuSQg3ICQ1UAl": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T22:44:05.359+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.23182425,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.17825778,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.1459694,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.085619554,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.017870598,
				"type": "OTHER"
			},
			{
				"name": "Candidate",
				"salience": 0.017870598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01tqr5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gary_Johnson"
				},
				"name": "Gary Johnson",
				"salience": 0.016288042,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.015405398,
				"type": "PERSON"
			},
			{
				"name": "Analyst",
				"salience": 0.014930937,
				"type": "PERSON"
			},
			{
				"name": "Hoenig",
				"salience": 0.014535061,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.01362145,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.013090558,
				"type": "ORGANIZATION"
			},
			{
				"name": "high",
				"salience": 0.0129432725,
				"type": "OTHER"
			},
			{
				"name": "par",
				"salience": 0.0129432725,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.011185687,
				"type": "PERSON"
			},
			{
				"name": "unpopularity",
				"salience": 0.010447605,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.010419425,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05st_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jill_Stein"
				},
				"name": "Jill Stein",
				"salience": 0.009660061,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.009419356,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.007654747,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0062158094,
				"type": "ORGANIZATION"
			},
			{
				"name": "poll",
				"salience": 0.0059680906,
				"type": "OTHER"
			},
			{
				"name": "CBS News Poll",
				"salience": 0.00565435,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.004718607,
				"type": "ORGANIZATION"
			},
			{
				"name": "remarks",
				"salience": 0.004652989,
				"type": "OTHER"
			},
			{
				"name": "mockery",
				"salience": 0.004153441,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0040374016,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0034969267,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0034969267,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.0034969267,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0034271516,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.0034202116,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0030195268,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0028253992,
				"type": "ORGANIZATION"
			},
			{
				"name": "stock",
				"salience": 0.0028050914,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0027349237,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0027349237,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0027349237,
				"type": "EVENT"
			},
			{
				"name": "indictment",
				"salience": 0.002518361,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0023614082,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0022149077,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0022149077,
				"type": "OTHER"
			},
			{
				"name": "poll numbers",
				"salience": 0.0021322945,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0021322945,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.0020435965,
				"type": "OTHER"
			},
			{
				"name": "impeachment",
				"salience": 0.002002786,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0019513017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.0019314274,
				"type": "ORGANIZATION"
			},
			{
				"name": "lies",
				"salience": 0.0019181295,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0019181295,
				"type": "EVENT"
			},
			{
				"name": "assistance",
				"salience": 0.0019181295,
				"type": "OTHER"
			},
			{
				"name": "smears",
				"salience": 0.0019181295,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.0019181295,
				"type": "OTHER"
			},
			{
				"name": "main stream media",
				"salience": 0.0019181295,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0019181295,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07w42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libertarian_Party_(United_States)"
				},
				"name": "Libertarian Party",
				"salience": 0.001859376,
				"type": "ORGANIZATION"
			},
			{
				"name": "ignorance",
				"salience": 0.0018465737,
				"type": "OTHER"
			},
			{
				"name": "interest group",
				"salience": 0.0018465737,
				"type": "ORGANIZATION"
			},
			{
				"name": "nomination",
				"salience": 0.0018465737,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0018346205,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.0018084303,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0015894601,
				"type": "PERSON"
			},
			{
				"name": "ink",
				"salience": 0.0015660664,
				"type": "OTHER"
			},
			{
				"name": "inauguration",
				"salience": 0.0015660664,
				"type": "EVENT"
			},
			{
				"name": "choices",
				"salience": 0.0015660664,
				"type": "OTHER"
			},
			{
				"name": "nightmare",
				"salience": 0.0015268645,
				"type": "EVENT"
			},
			{
				"name": "impeachment",
				"salience": 0.001496364,
				"type": "OTHER"
			},
			{
				"name": "congressman",
				"salience": 0.0014484475,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0013939686,
				"type": "ORGANIZATION"
			},
			{
				"name": "article",
				"salience": 0.0013511139,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reason",
				"salience": 0.0013511139,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0011797703,
				"type": "PERSON"
			},
			{
				"name": "impropriety",
				"salience": 0.0011699969,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0011699969,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0011699969,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0011699969,
				"type": "OTHER"
			},
			{
				"name": "impeachment",
				"salience": 0.0010492419,
				"type": "OTHER"
			},
			{
				"name": "commentator",
				"salience": 0.0010176895,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0009841004,
				"type": "PERSON"
			},
			{
				"name": "whiff",
				"salience": 0.0009673613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyvl0_"
				},
				"name": "Jan",
				"salience": 0.0009640422,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.0009431379,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.000852157,
				"type": "OTHER"
			},
			{
				"name": "chances",
				"salience": 0.000852157,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.000852157,
				"type": "EVENT"
			},
			{
				"name": "kind",
				"salience": 0.000852157,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.000852157,
				"type": "LOCATION"
			},
			{
				"name": "analyst",
				"salience": 0.0008136454,
				"type": "PERSON"
			},
			{
				"name": "opponents",
				"salience": 0.00077977474,
				"type": "PERSON"
			},
			{
				"name": "pardon",
				"salience": 0.00063657295,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0006128084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_of_Representatives"
				},
				"name": "House of Representatives",
				"salience": 0.0003917806,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0c_md_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gerald_Ford"
				},
				"name": "Ford",
				"salience": 0.00034075926,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/10/votehere2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T22:44:05.359+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Analyst: Most Americans like neither Candidate 11/04/2016 \nPRESS TV US Democratic presidential candidate Hillary Clinton’s unpopularity among American voters has reached a new high, according to recent polls, putting her on par with her Republican rival Donald Trump. \nAccording to the final pre-election New York Times/CBS News Poll released on Thursday, an overwhelming majority of American voters are disgusted by the state of US politics, and most view Trump and Clinton as dishonest. \nMore than 80 percent of voters say the presidential campaign has left them repulsed rather than excited, the poll found. \n“Having the two most hated politicians running for president of the US representing the two largest political parties has made a mockery of our democracy and electoral process,” Hoenig told Press TV on Friday. \n“Hillary Clinton lied and stole her way to the nomination for the Democrats and Trump bullied his way by insulting every interest group in America, including his fellow Republican opponents,” he added. \n“For the third parties we have Gary Johnson of the Libertarian Party, who has been made a laughing stock for his ignorance of foreign policy. His poll numbers are dropping. The other 3rd party candidate is Jill Stein of the Green Party who is seeing an actual rise in her numbers in spite of lies and smears coming from mostly the Democrats, with assistance from the main stream media,” he said. \n“That the race is tightening is no surprise. It often happens at this time but the reasons now are not because people are becoming more assured of who they want but more and more disgusted in the choices they have,” he stated. \n“Regardless of who wins, and it’s most probable that it’ll be either Clinton or Trump, this country’s nightmare will only begin on Jan 21st, the day after the inauguration. If it’s Clinton one wouldn’t be surprised if the ink on the articles of impeachment isn’t already dried. By then, it’s possible that criminal charges will have been presented to her or that she had received by then a presidential pardon from the outgoing President Obama,” the analyst noted. \n“President Ford once said, when he was a leader in the House of Representatives, that impeachment is for whatever the Congress wants it to be. Simply the whiff of impropriety or criminal behavior would make any partisan congressman see that as reason enough for such an article of impeachment. Compound that with an actual indictment and it’s guaranteed,” he said. \nThe commentator said, “Trump has a different set of problems if he were to be inaugurated in January. His positions are so outlandish that even his own party, which by and large has rejected him, would pounce on anything he does that would jeopardize their chances as a party and individually in the next off-year elections of 2018.” \n“We have to look inward as to what kind of nation we are that we have degenerated to the point where a majority of Americans want neither candidate to win,” he said in his concluding remarks.",
		"thread_title": "Analyst: Most Americans like neither Candidate",
		"title": "Analyst: Most Americans like neither Candidate",
		"type": "bs",
		"uuid": "e76849e6bb894a39447f6e31bd58b7377903b998"
	},
	"-KhIhN6GKZXU0v7MzvMb": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T22:44:05.725+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.31078133,
				"type": "LOCATION"
			},
			{
				"name": "shield",
				"salience": 0.07738788,
				"type": "OTHER"
			},
			{
				"name": "magnetosphere",
				"salience": 0.062330365,
				"type": "OTHER"
			},
			{
				"name": "rays",
				"salience": 0.06160612,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025w300",
					"wikipedia_url": "http://en.wikipedia.org/wiki/GRAPES-3"
				},
				"name": "GRAPES-3",
				"salience": 0.038010303,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "corona",
				"salience": 0.03604275,
				"type": "OTHER"
			},
			{
				"name": "burst",
				"salience": 0.03354989,
				"type": "EVENT"
			},
			{
				"name": "cosmic ray monitor",
				"salience": 0.03007818,
				"type": "PERSON"
			},
			{
				"name": "shield",
				"salience": 0.02912059,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.022843659,
				"type": "LOCATION"
			},
			{
				"name": "crack",
				"salience": 0.022843659,
				"type": "OTHER"
			},
			{
				"name": "scientists",
				"salience": 0.022843659,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.018577037,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07l3cm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_News_and_Analysis"
				},
				"name": "DNA INDIA",
				"salience": 0.017569842,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.01629343,
				"type": "LOCATION"
			},
			{
				"name": "radius",
				"salience": 0.0110356165,
				"type": "OTHER"
			},
			{
				"name": "storm",
				"salience": 0.009336946,
				"type": "EVENT"
			},
			{
				"name": "muon telescope",
				"salience": 0.0073875324,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "burst",
				"salience": 0.0071494873,
				"type": "EVENT"
			},
			{
				"name": "Cosmic Ray Laboratory",
				"salience": 0.0066294083,
				"type": "LOCATION"
			},
			{
				"name": "storm",
				"salience": 0.006193665,
				"type": "EVENT"
			},
			{
				"name": "speed",
				"salience": 0.0055938046,
				"type": "OTHER"
			},
			{
				"name": "plasma",
				"salience": 0.0055938046,
				"type": "OTHER"
			},
			{
				"name": "cloud",
				"salience": 0.0055234963,
				"type": "OTHER"
			},
			{
				"name": "night-side",
				"salience": 0.005151449,
				"type": "OTHER"
			},
			{
				"name": "compression",
				"salience": 0.0049953256,
				"type": "EVENT"
			},
			{
				"name": "burst",
				"salience": 0.004830791,
				"type": "EVENT"
			},
			{
				"name": "burst",
				"salience": 0.004830791,
				"type": "EVENT"
			},
			{
				"name": "radius",
				"salience": 0.0047038128,
				"type": "OTHER"
			},
			{
				"name": "computing farm",
				"salience": 0.0045189275,
				"type": "ORGANIZATION"
			},
			{
				"name": "rays",
				"salience": 0.0041842507,
				"type": "OTHER"
			},
			{
				"name": "radiations",
				"salience": 0.0038414602,
				"type": "OTHER"
			},
			{
				"name": "speed",
				"salience": 0.0037786027,
				"type": "OTHER"
			},
			{
				"name": "plasma",
				"salience": 0.0037786027,
				"type": "OTHER"
			},
			{
				"name": "cloud",
				"salience": 0.0037310633,
				"type": "OTHER"
			},
			{
				"name": "rays",
				"salience": 0.003549276,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012n8khs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ooty"
				},
				"name": "Ooty",
				"salience": 0.0035214168,
				"type": "LOCATION"
			},
			{
				"name": "compression",
				"salience": 0.0035046162,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04m567",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tata_Institute_of_Fundamental_Research"
				},
				"name": "Tata Institute of Fundamental Research",
				"salience": 0.0034462542,
				"type": "ORGANIZATION"
			},
			{
				"name": "study",
				"salience": 0.0033993584,
				"type": "OTHER"
			},
			{
				"name": "journal",
				"salience": 0.0033993584,
				"type": "WORK_OF_ART"
			},
			{
				"name": "countries",
				"salience": 0.0033993584,
				"type": "LOCATION"
			},
			{
				"name": "radio signal blackouts",
				"salience": 0.0033993584,
				"type": "OTHER"
			},
			{
				"name": "aurora borealis",
				"salience": 0.0033993584,
				"type": "PERSON"
			},
			{
				"name": "simulations",
				"salience": 0.003205079,
				"type": "OTHER"
			},
			{
				"name": "burst",
				"salience": 0.0030625395,
				"type": "EVENT"
			},
			{
				"name": "line",
				"salience": 0.0027757909,
				"type": "OTHER"
			},
			{
				"name": "defence",
				"salience": 0.0027757909,
				"type": "OTHER"
			},
			{
				"name": "flow",
				"salience": 0.0027757909,
				"type": "OTHER"
			},
			{
				"name": "storms",
				"salience": 0.0024272217,
				"type": "EVENT"
			},
			{
				"name": "simulation",
				"salience": 0.0023949896,
				"type": "EVENT"
			},
			{
				"name": "muon telescope",
				"salience": 0.0023949896,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0021544506,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_j5j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Physical_Review_Letters"
				},
				"name": "Physical Review Letters",
				"salience": 0.0020933305,
				"type": "WORK_OF_ART"
			},
			{
				"name": "power grids",
				"salience": 0.0020740824,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0020740824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07c98",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tamil_Nadu"
				},
				"name": "Tamil Nadu",
				"salience": 0.0020152396,
				"type": "LOCATION"
			},
			{
				"name": "physicists",
				"salience": 0.001744661,
				"type": "PERSON"
			},
			{
				"name": "human civilisation",
				"salience": 0.0015108205,
				"type": "OTHER"
			},
			{
				"name": "positioning systems",
				"salience": 0.0015108205,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.0015108205,
				"type": "PERSON"
			},
			{
				"name": "team",
				"salience": 0.0015108205,
				"type": "ORGANIZATION"
			},
			{
				"name": "satellite operations",
				"salience": 0.0015108205,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.0015108205,
				"type": "OTHER"
			},
			{
				"name": "cosmic ray particles",
				"salience": 0.0014609663,
				"type": "PERSON"
			},
			{
				"name": "particles",
				"salience": 0.0013034332,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.0013034332,
				"type": "PERSON"
			},
			{
				"name": "disruption",
				"salience": 0.0012179085,
				"type": "EVENT"
			},
			{
				"name": "degree",
				"salience": 0.0011286951,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.0011286951,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.0011286951,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.0011286951,
				"type": "OTHER"
			},
			{
				"name": "reconnection",
				"salience": 0.0011286951,
				"type": "OTHER"
			},
			{
				"name": "occurrence",
				"salience": 0.0011286951,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0344_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Global_Positioning_System"
				},
				"name": "GPS",
				"salience": 0.00092999864,
				"type": "OTHER"
			},
			{
				"name": "Pravata K Mohanty",
				"salience": 0.00029324912,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/516288-the-wind-spacecraft-space-magnetic-field-magnetosphere-earth-solar-wind-nasa.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T22:44:05.725+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Crack in Earth’s magnetic shield detected 11/04/2016 \nDNA INDIA \nThe world’s largest and most sensitive cosmic ray monitor, located in India, has recorded a burst of galactic cosmic rays that indicates a crack in the Earth’s magnetic shield, according to scientists. \nThe burst occurred when a giant cloud of plasma ejected from the solar corona struck Earth at a very high speed causing massive compression of the Earth’s magnetosphere and triggering a severe geomagnetic storm. \nThe GRAPES-3 muon telescope located at Tata Institute of Fundamental Research’s Cosmic Ray Laboratory in Ooty in Tamil Nadu recorded a burst of galactic cosmic rays of about 20 GeV last year lasting for two hours. \nThe burst occurred when a giant cloud of plasma ejected from the solar corona, and moving with a speed of about 2.5 million kilometres per hour struck our planet, causing a severe compression of Earth’s magnetosphere from 11 to 4 times the radius of Earth. \nIt triggered a severe geomagnetic storm that generated aurora borealis and radio signal blackouts in many high latitude countries, according to the study published in the journal Physical Review Letters this week. \nEarth’s magnetosphere extends over a radius of a million kilometres, which acts as the first line of defence, shielding us from the continuous flow of solar and galactic cosmic rays, thus protecting life on our planet from these high intensity energetic radiations. \nNumerical simulations performed by the GRAPES-3 researchers, including Pravata K Mohanty, indicate that the Earth’s magnetic shield temporarily cracked due to the occurrence of magnetic reconnection, allowing the lower energy galactic cosmic ray particles to enter our atmosphere. \nEarth’s magnetic field bent these particles about 180 degree, from the day-side to the night-side of the Earth where it was detected as a burst by the GRAPES-3 muon telescope around mid-night on 22 June 2015. \nThe data was analysed and interpreted through extensive simulation over several weeks by using the 1280-core computing farm that was built in-house by the GRAPES-3 team of physicists and engineers at the Cosmic Ray Laboratory in Ooty. \nSolar storms can cause major disruption to human civilisation by crippling large electrical power grids, global positioning systems (GPS), satellite operations and communications.",
		"thread_title": "Crack in Earth’s magnetic shield detected",
		"title": "Crack in Earth’s magnetic shield detected",
		"type": "bs",
		"uuid": "c2ce8510ff260a0e9ea8037869d52b7e9db0154f"
	},
	"-KhIhNX5WIIoEC6tgsHb": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T22:44:06.026+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.101371706,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gjsd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_de_Blasio"
				},
				"name": "Bill de Blasio",
				"salience": 0.03850757,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.036146395,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.036146395,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.034824997,
				"type": "ORGANIZATION"
			},
			{
				"name": "law enforcement authorities",
				"salience": 0.03390235,
				"type": "PERSON"
			},
			{
				"name": "terrorism task forces",
				"salience": 0.032315694,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.031342793,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cfpjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/His_Honour"
				},
				"name": "Hizzoner",
				"salience": 0.02847826,
				"type": "PERSON"
			},
			{
				"name": "alert",
				"salience": 0.028323596,
				"type": "OTHER"
			},
			{
				"name": "feds",
				"salience": 0.028323596,
				"type": "OTHER"
			},
			{
				"name": "Feds",
				"salience": 0.025935233,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.024661325,
				"type": "PERSON"
			},
			{
				"name": "warning",
				"salience": 0.024551922,
				"type": "OTHER"
			},
			{
				"name": "eve",
				"salience": 0.024551922,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al Qaeda",
				"salience": 0.022991054,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.020533228,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.019765515,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.019587515,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.01935657,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.017837066,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bkj0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Port_Authority_of_New_York_and_New_Jersey"
				},
				"name": "Port Authority of New York and New Jersey",
				"salience": 0.016849771,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence officials",
				"salience": 0.016073119,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.013532328,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.012578165,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02pjpd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andrew_Cuomo"
				},
				"name": "Andrew Cuomo",
				"salience": 0.0106256185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.010167113,
				"type": "PERSON"
			},
			{
				"name": "campaigns",
				"salience": 0.009342997,
				"type": "EVENT"
			},
			{
				"name": "threat",
				"salience": 0.00847872,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.007751297,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.007751297,
				"type": "LOCATION"
			},
			{
				"name": "news",
				"salience": 0.00648633,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0059887227,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.005948149,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.005673052,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/076vsnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Post_(Ohio_newspaper)"
				},
				"name": "The Post",
				"salience": 0.0053766626,
				"type": "ORGANIZATION"
			},
			{
				"name": "news",
				"salience": 0.0052965777,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0051866206,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0051866206,
				"type": "OTHER"
			},
			{
				"name": "radio show",
				"salience": 0.0051866206,
				"type": "EVENT"
			},
			{
				"name": "briefings",
				"salience": 0.0051866206,
				"type": "EVENT"
			},
			{
				"name": "threat",
				"salience": 0.0051745614,
				"type": "OTHER"
			},
			{
				"name": "state police",
				"salience": 0.005083079,
				"type": "ORGANIZATION"
			},
			{
				"name": "Police",
				"salience": 0.004651721,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0043857507,
				"type": "EVENT"
			},
			{
				"name": "alert",
				"salience": 0.0042003905,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0036375502,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.0036375502,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0036290889,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0036290889,
				"type": "OTHER"
			},
			{
				"name": "police presence",
				"salience": 0.0035018455,
				"type": "OTHER"
			},
			{
				"name": "victory celebrations",
				"salience": 0.0035018455,
				"type": "EVENT"
			},
			{
				"name": "memory",
				"salience": 0.0035018455,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0035018455,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0035018455,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0035018455,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0034947777,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0034611358,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0034611358,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0034295074,
				"type": "OTHER"
			},
			{
				"name": "counterterrorism",
				"salience": 0.0032768818,
				"type": "OTHER"
			},
			{
				"name": "counterparts",
				"salience": 0.0032768818,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_3by",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WNYC"
				},
				"name": "WNYC",
				"salience": 0.0031935547,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence",
				"salience": 0.0030715636,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0030715636,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.0030715636,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04yh68",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steve_Coleman"
				},
				"name": "Steve Coleman",
				"salience": 0.003014237,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.0028376845,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacks",
				"salience": 0.0027094826,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05xtft",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eleventh_Avenue_(Manhattan)"
				},
				"name": "11th Avenue",
				"salience": 0.0025860122,
				"type": "LOCATION"
			},
			{
				"name": "safety",
				"salience": 0.0025622253,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03vhxl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sixth_Avenue_(Manhattan)"
				},
				"name": "Sixth Avenue",
				"salience": 0.002489508,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09gs3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Guard_of_the_United_States"
				},
				"name": "National Guard",
				"salience": 0.0024471693,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0023868745,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacks",
				"salience": 0.0023868745,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07fnrc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jacob_K._Javits_Convention_Center"
				},
				"name": "Javits Convention Center",
				"salience": 0.00223935,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027k61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Marathon"
				},
				"name": "New York City Marathon",
				"salience": 0.00223935,
				"type": "EVENT"
			},
			{
				"name": "community partners",
				"salience": 0.0022187496,
				"type": "ORGANIZATION"
			},
			{
				"name": "basis",
				"salience": 0.0022187496,
				"type": "OTHER"
			},
			{
				"name": "shares",
				"salience": 0.0022187496,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.002155774,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0by1f7_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Hilton_Midtown"
				},
				"name": "New York Hilton Midtown",
				"salience": 0.002155774,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_39t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brian_Lehrer"
				},
				"name": "Brian Lehrer",
				"salience": 0.002155774,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.002155774,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/034vbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joint_Terrorism_Task_Force"
				},
				"name": "Joint Terrorism Task Force",
				"salience": 0.0021112245,
				"type": "ORGANIZATION"
			},
			{
				"name": "hackers",
				"salience": 0.0020303165,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0018990567,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0018834317,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Counterterrorism and Intelligence Bureaus",
				"salience": 0.0018281741,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.0018133976,
				"type": "ORGANIZATION"
			},
			{
				"name": "official",
				"salience": 0.0017978108,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fytk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Homeland_Security"
				},
				"name": "Department of Homeland Security",
				"salience": 0.0016805488,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.001678655,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0016713515,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0016713515,
				"type": "OTHER"
			},
			{
				"name": "cyberattacks",
				"salience": 0.0016159951,
				"type": "EVENT"
			},
			{
				"name": "havoc",
				"salience": 0.0016159951,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0016159951,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.0015440403,
				"type": "ORGANIZATION"
			},
			{
				"name": "safety",
				"salience": 0.0013941055,
				"type": "OTHER"
			},
			{
				"name": "department",
				"salience": 0.0013430009,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Department of Defense",
				"salience": 0.0012721916,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.0012071644,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0012071644,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0012071644,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0012071644,
				"type": "OTHER"
			},
			{
				"name": "facilities",
				"salience": 0.0012071644,
				"type": "LOCATION"
			},
			{
				"name": "bridges",
				"salience": 0.0012071644,
				"type": "LOCATION"
			},
			{
				"name": "tunnels",
				"salience": 0.0012071644,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0011741903,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0011474525,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.0010769477,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0009946096,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0009946096,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "National Security Agency",
				"salience": 0.0009946096,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "Big Apple",
				"salience": 0.0007429485,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00041981452,
				"type": "ORGANIZATION"
			},
			{
				"name": "airports",
				"salience": 0.00039038734,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/091816terrorism2hs.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T22:44:06.026+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Feds warn NYC officials about possible al Qaeda attack 11/04/2016 \nNEW YORK POST \nNew York City law enforcement authorities are on high alert after receiving a warning by the feds about a possible attack by al Qaeda on the eve of Election Day, sources said. \nUS intelligence officials alerted joint terrorism task forces of the threat, which also included Texas and Virginia — though specific sites targeted for Monday in the three states were not mentioned, a federal source told The Post. \nMayor Bill de Blasio said Friday he had learned of the threat several days ago during classified briefings. \n“We are still very much assessing the credibility. It is not at all clear how credible this is,” de Blasio told WNYC’s Brian Lehrer on his weekly radio show. “We’re certainly in a vigilant position.” \nHizzoner said the NYPD is planning an “extraordinary” police presence for Tuesday, when Americans go to the polls. \n“For the first time in memory there will be two presidential campaigns having their victory celebrations in New York City on Tuesday night,” he said, quickly correcting himself that only one candidate will be celebrating. \nDonald Trump, the Republican nominee, will be at the New York Hilton Midtown on Sixth Avenue, while Hillary Clinton, his Democratic counterpart, will be at the Javits Convention Center across town on 11th Avenue. \nPolice also will be heavily deployed for the New York City Marathon on Sunday, de Blasio said. \nMeanwhile, Gov. Andrew Cuomo declined to confirm the threat Friday but also noted the high state of alert for Election Day. \n“We have more state police, more National Guard, more soldiers on duty than ever before,” he said. “So the bad news is New York is often a threat. The good news is we’ve been dealing with this now for over a decade and we have prepared for it.” \nThe NYPD and the Port Authority of New York and New Jersey said they had been alerted to the possible attacks. \n“We are aware of the information. We have been working with the FBI through the Joint Terrorism Task Force and our Counterterrorism and Intelligence Bureaus,” the NYPD said in a statement. \n“We continue to encourage anyone with any information that could be relevant to the safety of our city to contact law enforcement,” the department said. \nThe Port Authority — which operates airports, tunnels and bridges in and around the Big Apple — said it too was prepared. \n“We are continuing the high level of security we have had in place at all of our facilities for many months,” spokesman Steve Coleman told The Post. \nThe FBI did not comment specifically about the threat against the three states, but said counterterrorism and Homeland Security authorities “remain vigilant and well-postured” to handle attacks. \n“The FBI, working with our federal, state and local counterparts, shares and assesses intelligence on a daily basis and will continue to work closely with law enforcement and intelligence community partners to identify and disrupt any potential threat to public safety,” an FBI official said. \nFriday’s threat followed a report by NBC News that the US government believes hackers from Russia or other countries may try to unleash cyberattacks to wreak havoc ahead of Election Day. \nAn effort coordinated by the White House and the Department of Homeland Security — and including the CIA, the National Security Agency and other elements of the Department of Defense — is being conducted to avert attacks, NBC News reported.",
		"thread_title": "Feds warn NYC officials about possible al Qaeda attack",
		"title": "Feds warn NYC officials about possible al Qaeda attack",
		"type": "bs",
		"uuid": "749f9f57c95f83f285af6890a9677441fb63622e"
	},
	"-KhIhNfWaBgFoFqWlw7G": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T00:33:12.210+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.102621995,
				"type": "PERSON"
			},
			{
				"name": "shoe",
				"salience": 0.10013082,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Jefferey Epstein",
				"salience": 0.08889007,
				"type": "PERSON"
			},
			{
				"name": "Ring",
				"salience": 0.08654167,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.08654167,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Hillary Lolita Express",
				"salience": 0.05381376,
				"type": "ORGANIZATION"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.05381376,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.046236664,
				"type": "PERSON"
			},
			{
				"name": "pedophile",
				"salience": 0.04171479,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.036182273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.032386415,
				"type": "PERSON"
			},
			{
				"name": "AMTV",
				"salience": 0.025798999,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Candidate",
				"salience": 0.015053552,
				"type": "PERSON"
			},
			{
				"name": "Analyst",
				"salience": 0.0130424565,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.012557289,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.011852966,
				"type": "LOCATION"
			},
			{
				"name": "h",
				"salience": 0.010654346,
				"type": "OTHER"
			},
			{
				"name": "shield",
				"salience": 0.010654346,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.010654346,
				"type": "PERSON"
			},
			{
				"name": "unpopularity",
				"salience": 0.0085929,
				"type": "OTHER"
			},
			{
				"name": "Feds",
				"salience": 0.00841568,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00803845,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.00803845,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00803845,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.007964638,
				"type": "EVENT"
			},
			{
				"name": "burst",
				"salience": 0.007964638,
				"type": "EVENT"
			},
			{
				"name": "galact",
				"salience": 0.007964638,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.007964638,
				"type": "PERSON"
			},
			{
				"name": "Podesta",
				"salience": 0.007738976,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.007738976,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.007738976,
				"type": "ORGANIZATION"
			},
			{
				"name": "feds",
				"salience": 0.0067010834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.006564703,
				"type": "LOCATION"
			},
			{
				"name": "alert",
				"salience": 0.005803814,
				"type": "OTHER"
			},
			{
				"name": "law enforcement authorities",
				"salience": 0.005803814,
				"type": "ORGANIZATION"
			},
			{
				"name": "warning",
				"salience": 0.005803814,
				"type": "OTHER"
			},
			{
				"name": "cosmic ray monitor",
				"salience": 0.0057307775,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "NYC",
				"salience": 0.004905846,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al Qaeda",
				"salience": 0.004905846,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.004360813,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.004336968,
				"type": "LOCATION"
			},
			{
				"name": "AMTV Archives",
				"salience": 0.003573951,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07l3cm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_News_and_Analysis"
				},
				"name": "DNA INDIA",
				"salience": 0.003083487,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.003083487,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^F04EF997486A3AE26ADE33989E218081943C7C111A00E83658^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:33:12.210+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "🚨Bill Clinton and Hillary Lolita Express Pedophilia Ring🚨 11/04/2016 In today’s video, Christopher Greene of AMTV breaks down the connection between convicted felon Jefferey Epstein ‘known pedophile” and the Clinton’s. Will this be the next shoe to drop in the Wikileaks Podesta dump? Will find out this weekend in an Exclusive RT interview with the man himself Julian Assange. Analyst: Most Americans like neither Candidate 11/04/2016 PRESS TV US Democratic presidential candidate Hillary Clinton’s unpopularity among American voters has reached a new h ... Crack in Earth’s magnetic shield detected 11/04/2016 DNA INDIA The world's largest and most sensitive cosmic ray monitor, located in India, has recorded a burst of galact ... Feds warn NYC officials about possible al Qaeda attack 11/04/2016 NEW YORK POST New York City law enforcement authorities are on high alert after receiving a warning by the feds about ... AMTV Archives",
		"thread_title": "🚨Bill Clinton and Hillary Lolita Express Pedophilia Ring🚨",
		"title": "🚨Bill Clinton and Hillary Lolita Express Pedophilia Ring🚨",
		"type": "bs",
		"uuid": "97b1c7d89d0c2856afb7d729ad79038ea88b6943"
	},
	"-KhIhOA31ohDCagYkBRw": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T02:09:02.970+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Austyn Crites",
				"salience": 0.523604,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.10937751,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.09995448,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fynw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secret_Service"
				},
				"name": "Secret Service",
				"salience": 0.027982607,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.021369068,
				"type": "PERSON"
			},
			{
				"name": "Michael Newton",
				"salience": 0.01085865,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.010420113,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.009227088,
				"type": "EVENT"
			},
			{
				"name": "nominee",
				"salience": 0.008527931,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0077037537,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06kx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reno,_Nevada"
				},
				"name": "Reno",
				"salience": 0.006981471,
				"type": "LOCATION"
			},
			{
				"name": "rally disturbance",
				"salience": 0.006674976,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0066391816,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.0057284003,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.005579809,
				"type": "OTHER"
			},
			{
				"name": "commotion",
				"salience": 0.005384672,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0047245333,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.0043655406,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA TODAY",
				"salience": 0.004114619,
				"type": "WORK_OF_ART"
			},
			{
				"name": "event",
				"salience": 0.003942567,
				"type": "EVENT"
			},
			{
				"name": "audience",
				"salience": 0.003942567,
				"type": "PERSON"
			},
			{
				"name": "gun",
				"salience": 0.003942567,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Donald Newton",
				"salience": 0.003901367,
				"type": "PERSON"
			},
			{
				"name": "displeasure",
				"salience": 0.0035024644,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0034236459,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0034149124,
				"type": "PERSON"
			},
			{
				"name": "Members",
				"salience": 0.0034149124,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0028525032,
				"type": "PERSON"
			},
			{
				"name": "Republicans Against Trump",
				"salience": 0.0026894235,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.0023008413,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0023008413,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0021944062,
				"type": "PERSON"
			},
			{
				"name": "anti-Trump",
				"salience": 0.0021032663,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.001947509,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.0018593468,
				"type": "PERSON"
			},
			{
				"name": "auditorium",
				"salience": 0.0016246715,
				"type": "LOCATION"
			},
			{
				"name": "guys",
				"salience": 0.0016246715,
				"type": "PERSON"
			},
			{
				"name": "will",
				"salience": 0.0016174191,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0015389776,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0015389776,
				"type": "PERSON"
			},
			{
				"name": "effect",
				"salience": 0.00140694,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00140694,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00140694,
				"type": "LOCATION"
			},
			{
				"name": "hand contact someone",
				"salience": 0.0013657565,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.0013147966,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0012564842,
				"type": "PERSON"
			},
			{
				"name": "weapon",
				"salience": 0.0012138325,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0012084127,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0011693534,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.0011392821,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0011392821,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.0011392821,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0011249303,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0011249303,
				"type": "WORK_OF_ART"
			},
			{
				"name": "handcuffs",
				"salience": 0.0011150357,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0010967663,
				"type": "ORGANIZATION"
			},
			{
				"name": "things",
				"salience": 0.0010781138,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0010378791,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0010378791,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0r785",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Santa_Rosa,_California"
				},
				"name": "Santa Rosa",
				"salience": 0.0010350645,
				"type": "LOCATION"
			},
			{
				"name": "ballots",
				"salience": 0.0009865573,
				"type": "OTHER"
			},
			{
				"name": "push",
				"salience": 0.0009865573,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00096876954,
				"type": "PERSON"
			},
			{
				"name": "knee",
				"salience": 0.0009497374,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0009497374,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0009386921,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.00093011075,
				"type": "EVENT"
			},
			{
				"name": "weapons",
				"salience": 0.00093011075,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.00093011075,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00093011075,
				"type": "LOCATION"
			},
			{
				"name": "arms",
				"salience": 0.0009259569,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.00088016625,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bfg56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reno-Sparks_Convention_Center"
				},
				"name": "Reno-Sparks Convention Center",
				"salience": 0.00086609484,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.0008473147,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.00083299895,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00083299895,
				"type": "EVENT"
			},
			{
				"name": "legs",
				"salience": 0.000805411,
				"type": "OTHER"
			},
			{
				"name": "magnetometers",
				"salience": 0.000805411,
				"type": "OTHER"
			},
			{
				"name": "campaign sites",
				"salience": 0.000805411,
				"type": "LOCATION"
			},
			{
				"name": "neck",
				"salience": 0.000805411,
				"type": "OTHER"
			},
			{
				"name": "aftermath",
				"salience": 0.000805411,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0007168731,
				"type": "OTHER"
			},
			{
				"name": "brother",
				"salience": 0.00069482706,
				"type": "PERSON"
			},
			{
				"name": "dictator incitement",
				"salience": 0.00069482706,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00069482706,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0qkcb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Newton,_Massachusetts"
				},
				"name": "Newton",
				"salience": 0.0006863505,
				"type": "LOCATION"
			},
			{
				"name": "difference",
				"salience": 0.0006575112,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colorado",
				"salience": 0.0006072467,
				"type": "LOCATION"
			},
			{
				"name": "rally",
				"salience": 0.0006066864,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.00060165906,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00060165906,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00060165906,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.00060165906,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "Calif.",
				"salience": 0.0005845777,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.00057486724,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.00056337804,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00056046963,
				"type": "PERSON"
			},
			{
				"name": "guys",
				"salience": 0.00056007813,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.000541246,
				"type": "EVENT"
			},
			{
				"name": "brother",
				"salience": 0.0005060409,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.0005060409,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.0005060409,
				"type": "WORK_OF_ART"
			},
			{
				"name": "connection",
				"salience": 0.00048497246,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.00045319228,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.00045319228,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00043817938,
				"type": "OTHER"
			},
			{
				"name": "thug",
				"salience": 0.00043817938,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.00043817938,
				"type": "OTHER"
			},
			{
				"name": "assassin",
				"salience": 0.00043817938,
				"type": "OTHER"
			},
			{
				"name": "applause",
				"salience": 0.00043817938,
				"type": "OTHER"
			},
			{
				"name": "shill",
				"salience": 0.00043817938,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00043817938,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.00043817938,
				"type": "WORK_OF_ART"
			},
			{
				"name": "remarks",
				"salience": 0.00043817938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00042764845,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.00040607125,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00037800404,
				"type": "PERSON"
			},
			{
				"name": "air",
				"salience": 0.00037800404,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00037800404,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00037029703,
				"type": "ORGANIZATION"
			},
			{
				"name": "frustration",
				"salience": 0.0003273089,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0003273089,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.00031144018,
				"type": "LOCATION"
			},
			{
				"name": "gun",
				"salience": 0.00028235654,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00026967048,
				"type": "OTHER"
			},
			{
				"name": "@SethARichardson",
				"salience": 0.00026967048,
				"type": "PERSON"
			},
			{
				"name": "panic",
				"salience": 0.00026382075,
				"type": "OTHER"
			},
			{
				"name": "Seth A. Richardson",
				"salience": 0.00017969855,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/636139958247519037-AP-Campaign-2016-Trump-001.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T02:09:02.970+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 16.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "The man behind the Trump rally disturbance in Reno 11/06/2016 \nUSA TODAY \nThe man who caused a commotion at a Donald Trump rally Saturday said he’s a registered Republican who wanted only to show his displeasure with his party’s nominee. \nMembers of the audience at the event for the GOP presidential nominee tackled Austyn Crites, 33, of Reno after someone yelled “gun” while others were trying to rip away his anti-Trump sign. \n“I just went with sign that said ‘Republicans Against Trump,’ ” Crites said. “It’s a sign that you can find online. I held up the sign and initially people around me were just booing me telling me to get out of there. Then a couple of these guys tried grabbing the sign out of my hands.” \nCrites had no weapon. Secret Service agents later released a statement to that effect and let him go without charges. \nAgents whisked Trump offstage because Crites was near the front of the auditorium at the Reno-Sparks Convention Center. \nCrites said he holds no ill will toward the Secret Service or Reno police, who were just doing their job. \n“I was trying to get the Secret Service’s attention for them to respond,” said Michael Newton, 45, of Santa Rosa, Calif., who helped restrain Crites. “They didn’t respond. I thought I had to do something. I put my knee on what I think was his head, so I’m not really sure. There were five guys on him and he was moving. I tried to help them immobilize him.” In final Colorado push, Trump urges supporters to hand-deliver ballots \nNewton said he felt as if Crites were the aggressor. \n“I saw his hand contact someone’s face,” he said. “Maybe two people.” \nCrites said he didn’t strike anyone, but after he was taken to the ground, he felt as if he were being mobbed. \n“Multiple people just tackled me down, kicking me choking me and just beating me up,” he said. “That’s when things even got crazier. I was on the ground and people were holding my arms, legs and I kept saying I can barely breathe. I was turning my neck just to get a little bit of air to keep from passing out.” \nThat’s when police intervened, taking Crites away in handcuffs. \nNewton’s partner, Donald Newton, 47, of Santa Rosa took video of the immediate aftermath. \nThe Secret Service said its investigation is ongoing. The agency uses magnetometers at presidential campaign sites, making it difficult for weapons to be smuggled into events. \nWhat’s baffling to Crites is how anyone could have thought he had a gun. His sign was in the air for some time and he wasn’t making any sudden movements, he said. \n“It wasn’t like they noticed something suspicious and tackled me,” Crites said. “That’s not the case.” \nHe said he backs some GOP candidates and just wanted to voice frustration with Trump, not cause panic. \n“I love all the people in that rally,” he said. “We’re all fellow Americans. They’re doing their patriotic duty. They support their candidate. I’m just there showing that I’m a Republican. I’m all of your people’s brother. I just have a slight difference of opinion.” \nLater on Facebook, Crites wrote that he has no connection with the campaign of Democratic presidential nominee Hillary Clinton but has canvassed for her for about three hours, contributed to her campaign and voted for her. \n“Take what happened to me tonight as a classic example of dictator incitement of violence — against your own Republican brother with a stupid sign,” he wrote. The post and his entire account were taken down soon afterward as some Trump supporters on social media called him a “Clinton thug,”“Hillary shill” and “Trump assassin.” \nShortly after the incident at the rally, Trump returned to the stage to raucous applause, thanking the Secret Service and launching back into his prepared remarks. His campaign later issued a statement also thanking the Secret Service and his supporters. \nFollow Seth A. Richardson on Twitter: @SethARichardson",
		"thread_title": "The man behind the Trump rally disturbance in Reno",
		"title": "The man behind the Trump rally disturbance in Reno",
		"type": "bs",
		"uuid": "90a88dea19de6122ea113ba62835ee226d2e1b3e"
	},
	"-KhIhPw0_aICKHWOVnST": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T02:09:03.024+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.32810268,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0p_54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jack_Parsons_(rocket_engineer)"
				},
				"name": "Jack Parsons",
				"salience": 0.28835112,
				"type": "PERSON"
			},
			{
				"name": "fetus",
				"salience": 0.04247746,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.03869404,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0by8ry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Babalon"
				},
				"name": "Babalon",
				"salience": 0.01940176,
				"type": "OTHER"
			},
			{
				"name": "bomb",
				"salience": 0.017530736,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/014cnw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ordo_Templi_Orientis"
				},
				"name": "O.T.O.",
				"salience": 0.012828724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleister_Crowley"
				},
				"name": "Crowley",
				"salience": 0.011378151,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.010437653,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bdm_d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marjorie_Cameron"
				},
				"name": "Marjorie Cameron",
				"salience": 0.010421041,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.010250872,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019qql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whore_of_Babylon"
				},
				"name": "Whore of Babylon",
				"salience": 0.009436197,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article",
				"salience": 0.009260758,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Opinion",
				"salience": 0.008024677,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.008024677,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.007109275,
				"type": "OTHER"
			},
			{
				"name": "TWYMAN",
				"salience": 0.0063709454,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.005249181,
				"type": "OTHER"
			},
			{
				"name": "Anti-Christ",
				"salience": 0.0050502415,
				"type": "ORGANIZATION"
			},
			{
				"name": "canister",
				"salience": 0.005017617,
				"type": "OTHER"
			},
			{
				"name": "Human 11",
				"salience": 0.0049475636,
				"type": "OTHER"
			},
			{
				"name": "Charles Stanfield Jones",
				"salience": 0.0047720666,
				"type": "PERSON"
			},
			{
				"name": "segments",
				"salience": 0.004106428,
				"type": "OTHER"
			},
			{
				"name": "clues",
				"salience": 0.004106428,
				"type": "OTHER"
			},
			{
				"name": "hunch",
				"salience": 0.004106428,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.004106428,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.004106428,
				"type": "OTHER"
			},
			{
				"name": "Revelation",
				"salience": 0.0036406408,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.002539958,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0025294255,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f04c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palo_Alto,_California"
				},
				"name": "Palo Alto",
				"salience": 0.0024505074,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0024434815,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0024179185,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.0021638873,
				"type": "PERSON"
			},
			{
				"name": "ritual",
				"salience": 0.0021638873,
				"type": "EVENT"
			},
			{
				"name": "incarnation",
				"salience": 0.0020988616,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0020555162,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04jh8st"
				},
				"name": "Moonchild",
				"salience": 0.0020407957,
				"type": "ORGANIZATION"
			},
			{
				"name": "womb",
				"salience": 0.0019539294,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0019539294,
				"type": "PERSON"
			},
			{
				"name": "womb",
				"salience": 0.0019539294,
				"type": "OTHER"
			},
			{
				"name": "somebody",
				"salience": 0.0016996876,
				"type": "PERSON"
			},
			{
				"name": "blood",
				"salience": 0.0016921001,
				"type": "OTHER"
			},
			{
				"name": "occultist",
				"salience": 0.0016921001,
				"type": "PERSON"
			},
			{
				"name": "rocket scientist",
				"salience": 0.0016921001,
				"type": "PERSON"
			},
			{
				"name": "cup",
				"salience": 0.0016921001,
				"type": "OTHER"
			},
			{
				"name": "forum",
				"salience": 0.0016921001,
				"type": "EVENT"
			},
			{
				"name": "ritual",
				"salience": 0.0015175156,
				"type": "OTHER"
			},
			{
				"name": "fetus",
				"salience": 0.0015175156,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.0015175156,
				"type": "PERSON"
			},
			{
				"name": "voice",
				"salience": 0.0014414869,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0014414869,
				"type": "OTHER"
			},
			{
				"name": "Scarlet Whore",
				"salience": 0.0013322665,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Hilarion",
				"salience": 0.0013314537,
				"type": "PERSON"
			},
			{
				"name": "canister",
				"salience": 0.001319091,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.001319091,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.001319091,
				"type": "PERSON"
			},
			{
				"name": "ritual",
				"salience": 0.0012389412,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01hlmj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Babalon_Working"
				},
				"name": "Babalon Working",
				"salience": 0.001202939,
				"type": "OTHER"
			},
			{
				"name": "attachment",
				"salience": 0.0011865515,
				"type": "OTHER"
			},
			{
				"name": "degree",
				"salience": 0.0011865515,
				"type": "OTHER"
			},
			{
				"name": "spirit",
				"salience": 0.0011865515,
				"type": "OTHER"
			},
			{
				"name": "heir",
				"salience": 0.0011865515,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0011865515,
				"type": "OTHER"
			},
			{
				"name": "consorts",
				"salience": 0.0011865515,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0011422705,
				"type": "OTHER"
			},
			{
				"name": "progranm",
				"salience": 0.0011422705,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0011422705,
				"type": "ORGANIZATION"
			},
			{
				"name": "cahoots",
				"salience": 0.0011422705,
				"type": "OTHER"
			},
			{
				"name": "plutonium",
				"salience": 0.0011422705,
				"type": "OTHER"
			},
			{
				"name": "bomb test",
				"salience": 0.0011422705,
				"type": "OTHER"
			},
			{
				"name": "Book of Babalon : Her",
				"salience": 0.0011264256,
				"type": "WORK_OF_ART"
			},
			{
				"name": "judgement trump",
				"salience": 0.0011186668,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0011186668,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0011186668,
				"type": "PERSON"
			},
			{
				"name": "Scarlet Women",
				"salience": 0.001114829,
				"type": "PERSON"
			},
			{
				"name": "jokes",
				"salience": 0.001099641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rpn6z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Beast_(Revelation)"
				},
				"name": "Beast",
				"salience": 0.0010416784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hvwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Icke"
				},
				"name": "David Icke",
				"salience": 0.0010416784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j8p6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._John's,_Newfoundland_and_Labrador"
				},
				"name": "St. John's",
				"salience": 0.0010416784,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kgfy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cybele"
				},
				"name": "Cybele",
				"salience": 0.0009831714,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.00097372226,
				"type": "PERSON"
			},
			{
				"name": "fruition",
				"salience": 0.00096869655,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.00096869655,
				"type": "WORK_OF_ART"
			},
			{
				"name": "group",
				"salience": 0.00096869655,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jeanne Foster",
				"salience": 0.0009293414,
				"type": "PERSON"
			},
			{
				"name": "human",
				"salience": 0.00092556875,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.00083570025,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00083570025,
				"type": "PERSON"
			},
			{
				"name": "festival",
				"salience": 0.00083570025,
				"type": "EVENT"
			},
			{
				"name": "rule",
				"salience": 0.00083570025,
				"type": "OTHER"
			},
			{
				"name": "THE SCARLET WOMAN HILARION",
				"salience": 0.00082550565,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interviewer",
				"salience": 0.00080091285,
				"type": "PERSON"
			},
			{
				"name": "Crossing the Abyss",
				"salience": 0.0007303682,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.00072689477,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00072364794,
				"type": "OTHER"
			},
			{
				"name": "priests",
				"salience": 0.00072364794,
				"type": "PERSON"
			},
			{
				"name": "lies",
				"salience": 0.00072364794,
				"type": "OTHER"
			},
			{
				"name": "Jumbo",
				"salience": 0.00070310413,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gbmz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trinity_(nuclear_test)"
				},
				"name": "Trinity",
				"salience": 0.00070310413,
				"type": "LOCATION"
			},
			{
				"name": "The Book of the Antichrist",
				"salience": 0.00068857137,
				"type": "WORK_OF_ART"
			},
			{
				"name": "first",
				"salience": 0.0006878561,
				"type": "OTHER"
			},
			{
				"name": "garage",
				"salience": 0.0006086471,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.0006086471,
				"type": "OTHER"
			},
			{
				"name": "garage",
				"salience": 0.0006086471,
				"type": "LOCATION"
			},
			{
				"name": "stone",
				"salience": 0.0005859252,
				"type": "OTHER"
			},
			{
				"name": "festival",
				"salience": 0.00057854125,
				"type": "EVENT"
			},
			{
				"name": "reply",
				"salience": 0.0005544548,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0005270286,
				"type": "OTHER"
			},
			{
				"name": "deodorant",
				"salience": 0.0005270286,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0005270286,
				"type": "PERSON"
			},
			{
				"name": "human being",
				"salience": 0.0005270286,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.00052361446,
				"type": "PERSON"
			},
			{
				"name": "rule",
				"salience": 0.00047831459,
				"type": "OTHER"
			},
			{
				"name": "resurrection",
				"salience": 0.00047617775,
				"type": "OTHER"
			},
			{
				"name": "meteorite stone",
				"salience": 0.0004546536,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kqwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Galli"
				},
				"name": "Galli",
				"salience": 0.00044538404,
				"type": "PERSON"
			},
			{
				"name": "gates",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.00039368027,
				"type": "LOCATION"
			},
			{
				"name": "walls",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "irons",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "Birth",
				"salience": 0.00039368027,
				"type": "EVENT"
			},
			{
				"name": "form",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "legend states",
				"salience": 0.00039368027,
				"type": "LOCATION"
			},
			{
				"name": "sex",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00039368027,
				"type": "PERSON"
			},
			{
				"name": "bleeding",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00039368027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dz299",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hilaria"
				},
				"name": "Hilaria",
				"salience": 0.00035292932,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/076vlrm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BuzzFeed"
				},
				"name": "Buzzfeed",
				"salience": 0.0003243554,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06pwq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stanford_University"
				},
				"name": "Stanford University",
				"salience": 0.0003243554,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k79m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alma_mater"
				},
				"name": "Alma Mater",
				"salience": 0.0003243554,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/037ywk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Body_odor"
				},
				"name": "B.O.",
				"salience": 0.0002614392,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06c62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rome"
				},
				"name": "Rome",
				"salience": 0.00024227958,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/whore-667x381.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T02:09:03.024+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Opinion: Hillary is the Whore of Babylon and is not Human 11/06/2016 \nTRACY TWYMAN \nI put some of this information in an article I published yesterday morning about a larger subject. Today I have decided to isolate these segments and add more for a comprehensive piece on the subject because other relevant information has emerged. \nPeople in the FBI think Hillary Clinton is the Anti-Christ . They are close. She is the Whore of Babylon. \nHillary was born in 1948, supposedly. I looked for this information on a hunch, after noticing several clues. And sure enough, back in 2008, someone on David Icke’s forum speculated that Hillary may have been the “Moonchild” that, according to artist Marjorie Cameron , was implanted into her own womb by rocket scientist, occultist, and Crowley associate Jack Parsons during a ritual called the “ Babalon Working .” The purpose was to birth a child to be an incarnation of what Crowley called “ Babalon ,” the Scarlet Whore with the cup of blood foretold in St. John’s Revelation that rides the Beast. \nCameron actually claimed that this fetus, after being taken from her womb, was delivered to people involved in the military’s nuclear weapons progranm, who were apparently in cahoots with Parsons, and placed inside of a nuclear bomb that was tested. But the fetus “survived,” she said, because it had been placed inside of a special canister made exactly for this purpose. For the 1945 “Trinity” bomb test they made a special canister called “Jumbo” that was supposed to to preserve the plutonium if the bomb did failed to go off. They reportedly didn’t end up using it for that, but it has been suggested that this is what preserved the fetus of the Moonchild. Presumably, it grew up to be somebody. \nCrowley named one of his female consorts (who he always called his “Scarlet Women”) “Hilarion.” Her name was Jeanne Foster. Crowley’s attempt to conceive an heir as a “magical child” with Hilarion resulted, supposedly, in the child’s spirit being attached to his protege Charles Stanfield Jones back in 1909. The “attachment” allegedly occurred when Jones went through the ritual for “Crossing the Abyss” in the 11th degree of the O.T.O., which involves being ritually sodomized by everyone in the group. \nJack Parsons, another person who had willingly subjected himself to this ritual, channeled The Book of the Antichrist in 1949, where he foretold: \nAnd within seven years of this time, BABALON, THE SCARLET WOMAN HILARION will manifest among ye, and bring this my work to its fruition. \nI also believe that Hillary, with her notorious cracking voice, and possibly her rival Trump, were foretold in another document channeled by Parsons, the Book of Babalon : \nHer voice is sure as the judgement trump to crack the house of wrong, Though walls are high and stone is hard and the rule of hell was long The gates shall fall and the irons break in the Birth of BABALON. \nIn Rome the Hilaria was a festival to the goddess Cybele (worshipped in the form of a black meteorite stone) to celebrate the “resurrection” of her son, who, as the legend states, she had been having sex with. She then became jealous of his love of others, castrated him, and let him die of bleeding (the reason why all of her priests, the Galli, were castrated, and actually considered women). She later regretted this and caused him to be brought back to life, then forced everyone under her rule to celebrate by laughing and partying joyously, as commemorated in this festival. Consider this next time you notice Hillary Clinton laughing “inappropriately.” \nAlso note that Hillary Clinton has made several self-depricating jokes about herself being “ not even human ” and “short-circuiting” when she gets herself twisted up in her own lies. Specifically, in October 2015, when her interviewer at Buzzfeed noted that she seemed to not be sweating, even though it was a hot day (odd, because Hillary has notoriously bad B.O.), she asked Hillary what kind of deodorant she used. Clinton’s reply was astounding. \nYou guys are the first to realize that I’m really not even a human being. I was constructed in a garage in Palo Alto a very long time ago… I mean, a man whose name shall remain nameless created me in his garage. \nPalo Alto is the location of Stanford University, Jack Parsons’ Alma Mater.",
		"thread_title": "Opinion: Hillary is the Whore of Babylon and is not Human",
		"title": "Opinion: Hillary is the Whore of Babylon and is not Human",
		"type": "bs",
		"uuid": "513893b7169c720d7685813c4a174b3a514b2585"
	},
	"-KhIhQKR_FbItUoGNzDN": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T20:01:08.261+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.21074054,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.068019725,
				"type": "ORGANIZATION"
			},
			{
				"name": "military hackers",
				"salience": 0.062250257,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.061350126,
				"type": "LOCATION"
			},
			{
				"name": "mischief",
				"salience": 0.02937051,
				"type": "OTHER"
			},
			{
				"name": "Military Hackers",
				"salience": 0.029341316,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.029341316,
				"type": "OTHER"
			},
			{
				"name": "NEWS",
				"salience": 0.027524168,
				"type": "OTHER"
			},
			{
				"name": "telecommunications networks",
				"salience": 0.027524168,
				"type": "OTHER"
			},
			{
				"name": "television network",
				"salience": 0.027524168,
				"type": "ORGANIZATION"
			},
			{
				"name": "Penetration",
				"salience": 0.025450813,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.023237688,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.023004156,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hackers",
				"salience": 0.020693848,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.019946227,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.019946227,
				"type": "EVENT"
			},
			{
				"name": "command systems",
				"salience": 0.019946227,
				"type": "OTHER"
			},
			{
				"name": "grid",
				"salience": 0.019946227,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.012317031,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.011791535,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.010264142,
				"type": "PERSON"
			},
			{
				"name": "network",
				"salience": 0.008265661,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.008206385,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reports",
				"salience": 0.0062281,
				"type": "OTHER"
			},
			{
				"name": "penetration",
				"salience": 0.005259853,
				"type": "OTHER"
			},
			{
				"name": "malware",
				"salience": 0.005232753,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.004871778,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.004871778,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.004871778,
				"type": "EVENT"
			},
			{
				"name": "series",
				"salience": 0.004871778,
				"type": "WORK_OF_ART"
			},
			{
				"name": "claims",
				"salience": 0.004871778,
				"type": "OTHER"
			},
			{
				"name": "penetration",
				"salience": 0.0047532953,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.00436965,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.00436965,
				"type": "WORK_OF_ART"
			},
			{
				"name": "concerns",
				"salience": 0.0042924313,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.0042195176,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0042195176,
				"type": "ORGANIZATION"
			},
			{
				"name": "efforts",
				"salience": 0.0042195176,
				"type": "OTHER"
			},
			{
				"name": "preparation",
				"salience": 0.0042195176,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0042195176,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0037845015,
				"type": "EVENT"
			},
			{
				"name": "concerns",
				"salience": 0.003417423,
				"type": "OTHER"
			},
			{
				"name": "mischief",
				"salience": 0.003417423,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.003289988,
				"type": "EVENT"
			},
			{
				"name": "intelligence official",
				"salience": 0.003289988,
				"type": "PERSON"
			},
			{
				"name": "scenario",
				"salience": 0.0029596174,
				"type": "OTHER"
			},
			{
				"name": "adversaries",
				"salience": 0.002849232,
				"type": "ORGANIZATION"
			},
			{
				"name": "warning",
				"salience": 0.002849232,
				"type": "OTHER"
			},
			{
				"name": "leak",
				"salience": 0.002849232,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.002849232,
				"type": "OTHER"
			},
			{
				"name": "cyberspace",
				"salience": 0.002849232,
				"type": "LOCATION"
			},
			{
				"name": "computer",
				"salience": 0.0027903896,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "secretary of State",
				"salience": 0.0027903896,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.0027903896,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0027205637,
				"type": "WORK_OF_ART"
			},
			{
				"name": "public",
				"salience": 0.002708421,
				"type": "PERSON"
			},
			{
				"name": "social media accounts",
				"salience": 0.002708421,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.0026662361,
				"type": "OTHER"
			},
			{
				"name": "media reports",
				"salience": 0.0026662361,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0025984526,
				"type": "ORGANIZATION"
			},
			{
				"name": "intelligence",
				"salience": 0.0024992158,
				"type": "OTHER"
			},
			{
				"name": "decisions",
				"salience": 0.0024938823,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0024913729,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0024525814,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0024164908,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0024164908,
				"type": "ORGANIZATION"
			},
			{
				"name": "headquarters",
				"salience": 0.0024164908,
				"type": "LOCATION"
			},
			{
				"name": "network",
				"salience": 0.0024059832,
				"type": "OTHER"
			},
			{
				"name": "prospect",
				"salience": 0.002239551,
				"type": "OTHER"
			},
			{
				"name": "intelligence services",
				"salience": 0.0020848627,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.0020848627,
				"type": "PERSON"
			},
			{
				"name": "server",
				"salience": 0.0020848627,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.0020755548,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.001932184,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0ds33",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Armageddon_(1998_film)"
				},
				"name": "Armageddon",
				"salience": 0.0018221836,
				"type": "EVENT"
			},
			{
				"name": "tenure",
				"salience": 0.0018054236,
				"type": "EVENT"
			},
			{
				"name": "business",
				"salience": 0.0018054236,
				"type": "OTHER"
			},
			{
				"name": "links",
				"salience": 0.0018054236,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0017179423,
				"type": "ORGANIZATION"
			},
			{
				"name": "pay-for-play",
				"salience": 0.0016313032,
				"type": "OTHER"
			},
			{
				"name": "schemes",
				"salience": 0.0016313032,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0015185984,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0014876493,
				"type": "PERSON"
			},
			{
				"name": "internet",
				"salience": 0.0013600526,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.0013150118,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.0013150118,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0013150118,
				"type": "OTHER"
			},
			{
				"name": "speaking engagements",
				"salience": 0.0013150118,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0012820839,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0012564652,
				"type": "EVENT"
			},
			{
				"name": "narrative",
				"salience": 0.0011344678,
				"type": "WORK_OF_ART"
			},
			{
				"name": "computers",
				"salience": 0.0011344678,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "campaign",
				"salience": 0.0011344678,
				"type": "ORGANIZATION"
			},
			{
				"name": "responsibility",
				"salience": 0.0009823557,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0009823557,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.0009823557,
				"type": "OTHER"
			},
			{
				"name": "Clinton State Department",
				"salience": 0.0008093971,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0008093971,
				"type": "ORGANIZATION"
			},
			{
				"name": "messages",
				"salience": 0.000743189,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/1040324467.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T20:01:08.261+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.7,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "US Military Hackers Claim Penetration of Russia 11/07/2016 \nSPUTNIK NEWS \nUS military hackers have penetrated Russia’s electric grid, telecommunications networks and Kremlin’s command systems, making them vulnerable to attack by secret American cyber weapons, according to a series of reports by a major US television network. \nNBC News disclosed the penetration in a series of reports, explaining that US efforts parallel claims, also by US officials, that Russia, China and other nations have placed hidden malware on parts of US critical infrastructure. \nThe penetration by all sides appears to be in preparation for an all-out war in cyberspace, according to NBC News, which said it was briefed by a US intelligence official and given an opportunity to review highly classified documents. \nAt the same time, the network downplayed the prospect of a cyber war, making it appear as if the leak was intended as a warning to US adversaries. \nNBC News then attempted to link its explosive report to Tuesday’s US presidential election, citing concerns of mischief by Russian hackers that would fall far short of the Armageddon-like scenario that the report implied. \nInstead, the network explained US election-related concerns as “cyber mischief,” which could involve releasing fake documents or creating bogus social media accounts to spread misinformation. \nThe Obama administration has created a public, but unconfirmed narrative, that hackers controlled by the Russian government have stolen emails from the Democratic Party headquarters, a private computer used by presidential candidate Hillary Clinton while serving as secretary of State and computers used by Clinton campaign Chairman John Podesta. \nAccording to the narrative, Russia stole the emails and gave the messages to WikiLeaks, which has flooded the internet with the material on a daily basis leading up to Tuesday’s election. \nRussia has denied any responsibility for the Clinton-related hacks and links between WikiLeaks and Russian intelligence have never been substantiated. \nMoreover, recent media reports in the United States indicate that Clinton’s private server she used for official business during her tenure as secretary of state had been penetrated by at least five foreign intelligence services. \nThe emails have proved especially embarrassing for the Clinton campaign by disclosing decisions in the Clinton State Department that favored large donors to the Clinton Foundation in what appear to be “pay-for-play” schemes of selling access and influence. \nMoreover, the activity appears to coincide with lucrative speaking engagements for former President Bill Clinton.",
		"thread_title": "US Military Hackers Claim Penetration of Russia",
		"title": "US Military Hackers Claim Penetration of Russia",
		"type": "bs",
		"uuid": "7312027c193bc6b72aed6af0f49c150d5af0c11c"
	},
	"-KhIhQtVBHtL1JtRODym": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T20:01:08.418+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.14579342,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.13926196,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.075024374,
				"type": "PERSON"
			},
			{
				"name": "tsunami",
				"salience": 0.0668062,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/047c82x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Valerie_Jarrett"
				},
				"name": "Valerie Jarrett",
				"salience": 0.052361142,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Affordable Care Act",
				"salience": 0.017927952,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.015126566,
				"type": "EVENT"
			},
			{
				"name": "America On The Brink Of Civil War",
				"salience": 0.014258248,
				"type": "WORK_OF_ART"
			},
			{
				"name": "many",
				"salience": 0.014181737,
				"type": "PERSON"
			},
			{
				"name": "secretary of State",
				"salience": 0.013742455,
				"type": "PERSON"
			},
			{
				"name": "change",
				"salience": 0.013482804,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.011836175,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.011836175,
				"type": "WORK_OF_ART"
			},
			{
				"name": "understatement",
				"salience": 0.01049458,
				"type": "OTHER"
			},
			{
				"name": "missives",
				"salience": 0.010253061,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.010253061,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.010253061,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.010253061,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bit",
				"salience": 0.010253061,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.010253061,
				"type": "PERSON"
			},
			{
				"name": "lap",
				"salience": 0.010253061,
				"type": "EVENT"
			},
			{
				"name": "luxury",
				"salience": 0.010253061,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0075109457,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08xc4g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PJ_Media"
				},
				"name": "PJ MEDIA",
				"salience": 0.007292975,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.006865109,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.006316432,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.006316432,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0057119047,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0054280115,
				"type": "EVENT"
			},
			{
				"name": "consequences",
				"salience": 0.005403792,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.005403792,
				"type": "OTHER"
			},
			{
				"name": "media outlets",
				"salience": 0.005207521,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026dx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Lynch"
				},
				"name": "Lynch",
				"salience": 0.0049303183,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.004879563,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.004879563,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.004879563,
				"type": "OTHER"
			},
			{
				"name": "legacy problems",
				"salience": 0.004879563,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.004879563,
				"type": "PERSON"
			},
			{
				"name": "election season",
				"salience": 0.0042796806,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0042447383,
				"type": "PERSON"
			},
			{
				"name": "footnote",
				"salience": 0.0042257924,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0042257924,
				"type": "OTHER"
			},
			{
				"name": "hawkishness",
				"salience": 0.0042257924,
				"type": "OTHER"
			},
			{
				"name": "election process",
				"salience": 0.0042257924,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.004102127,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0037898498,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0037898498,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.0036759337,
				"type": "OTHER"
			},
			{
				"name": "aftermath",
				"salience": 0.0036759337,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0036759337,
				"type": "PERSON"
			},
			{
				"name": "Anything",
				"salience": 0.0036759337,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0036484627,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0036484627,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0035730954,
				"type": "EVENT"
			},
			{
				"name": "task",
				"salience": 0.003538792,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0034220393,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0034220393,
				"type": "PERSON"
			},
			{
				"name": "outrage",
				"salience": 0.0032943613,
				"type": "OTHER"
			},
			{
				"name": "Clintonistas",
				"salience": 0.003111321,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0031080903,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0030942133,
				"type": "OTHER"
			},
			{
				"name": "inauguration",
				"salience": 0.0029633855,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.0029633855,
				"type": "OTHER"
			},
			{
				"name": "bars",
				"salience": 0.0029633855,
				"type": "OTHER"
			},
			{
				"name": "collusion",
				"salience": 0.0029633855,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0029633855,
				"type": "PERSON"
			},
			{
				"name": "stomach cancer",
				"salience": 0.0028528061,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0028528061,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0028528061,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0026914827,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0026896035,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0026694979,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0025892328,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0025847552,
				"type": "ORGANIZATION"
			},
			{
				"name": "many",
				"salience": 0.0025022023,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0024502124,
				"type": "EVENT"
			},
			{
				"name": "reminder",
				"salience": 0.0024193444,
				"type": "OTHER"
			},
			{
				"name": "dollar donation",
				"salience": 0.0024193444,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.0024193444,
				"type": "OTHER"
			},
			{
				"name": "gay rights",
				"salience": 0.0024193444,
				"type": "OTHER"
			},
			{
				"name": "women's",
				"salience": 0.0024193444,
				"type": "PERSON"
			},
			{
				"name": "birthday",
				"salience": 0.0024193444,
				"type": "EVENT"
			},
			{
				"name": "honor",
				"salience": 0.0024193444,
				"type": "OTHER"
			},
			{
				"name": "store",
				"salience": 0.0024193444,
				"type": "LOCATION"
			},
			{
				"name": "paragon",
				"salience": 0.0024193444,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0024193444,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.0024020083,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0023331032,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0023290527,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0022238116,
				"type": "OTHER"
			},
			{
				"name": "Nostradamus",
				"salience": 0.0021784876,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.0019589898,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0019589898,
				"type": "OTHER"
			},
			{
				"name": "firestorm",
				"salience": 0.0018073685,
				"type": "EVENT"
			},
			{
				"name": "successor",
				"salience": 0.0018073685,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0018073685,
				"type": "LOCATION"
			},
			{
				"name": "Rumors",
				"salience": 0.0018073685,
				"type": "OTHER"
			},
			{
				"name": "accuracy rate",
				"salience": 0.0018073685,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.0018073685,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "The New York Post",
				"salience": 0.0017560618,
				"type": "ORGANIZATION"
			},
			{
				"name": "American Humpty Dumpty",
				"salience": 0.0017560618,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0017197673,
				"type": "ORGANIZATION"
			},
			{
				"name": "answer",
				"salience": 0.0016963332,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.001683649,
				"type": "OTHER"
			},
			{
				"name": "lion",
				"salience": 0.0016612725,
				"type": "OTHER"
			},
			{
				"name": "doors",
				"salience": 0.0016612725,
				"type": "OTHER"
			},
			{
				"name": "man-eating lion",
				"salience": 0.0016196693,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0015602985,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0015201602,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0015201602,
				"type": "PERSON"
			},
			{
				"name": "door",
				"salience": 0.0015201602,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0014891715,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.0014891715,
				"type": "PERSON"
			},
			{
				"name": "Assange et al",
				"salience": 0.0014891715,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.0013163189,
				"type": "EVENT"
			},
			{
				"name": "suicide",
				"salience": 0.0013163189,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0013163189,
				"type": "WORK_OF_ART"
			},
			{
				"name": "title",
				"salience": 0.0013163189,
				"type": "OTHER"
			},
			{
				"name": "revelations",
				"salience": 0.0013163189,
				"type": "OTHER"
			},
			{
				"name": "military putsch",
				"salience": 0.0013163189,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0012577017,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.0012577017,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0011355607,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0011355607,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011355607,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0011355607,
				"type": "PERSON"
			},
			{
				"name": "greed",
				"salience": 0.0009832766,
				"type": "OTHER"
			},
			{
				"name": "rule of law",
				"salience": 0.0009832766,
				"type": "OTHER"
			},
			{
				"name": "email disclosures",
				"salience": 0.0009832766,
				"type": "OTHER"
			},
			{
				"name": "ball",
				"salience": 0.0009832766,
				"type": "OTHER"
			},
			{
				"name": "suggestion",
				"salience": 0.0009832766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bygs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dennis_Prager"
				},
				"name": "Dennis Prager",
				"salience": 0.0009799019,
				"type": "PERSON"
			},
			{
				"name": "No one",
				"salience": 0.0008811398,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.00081013213,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tyler Durden",
				"salience": 0.0007227332,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/Election-Civil-War.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T20:01:08.418+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Is America On The Brink Of Civil War? 11/07/2016 \nPJ MEDIA \nValerie Jarrett—Barack Obama’s closest consigliere who has lived in the lap of luxury in and out of the White House—is calling for James Comey’s head because the FBI director reopened the matter of Hillary Clinton’s emails only days before the election. \nAs we all know, Comey did this after some 650,000 digital missives, many from Clinton’s server, were discovered on Anthony Weiner’s laptop by the NYPD. \nObama, however, is a bit uneasy about Jarrett’s hawkishness toward Comey. \n“Valerie argued that Comey was interfering deliberately in the election process and had to be stopped,” a source told The New York Post . The same source said Obama, though, is “worried about the consequences of taking such an action – the tsunami of outrage that would come his way, and possibly become a major footnote, or worse, in the history of the presidency.” \nAh, those legacy problems, not that the president has much of one outside the comically named Affordable Care Act, which is about as popular as stomach cancer. \nNevertheless, he’s right about the tsunami of outrage. In fact it’s an understatement. The bad news is this: As miserable as this endless election season has been, the aftermath is likely to be far worse. You don’t have to be Nostradamus to see that putting the American Humpty Dumpty together again is going to be a herculean task. Our country could be permanently fractured in ways few of us would have anticipated even a year ago. Anything is possible now. \nIf Hillary Clinton is elected, the very next day millions of Americans will be watching to see what will happen with the FBI and the Justice Department. Since we can now assume this will be a close election, that would be nearly half the voters in this country, sixty to seventy million people, almost all of whom believe Clinton, the woman a few weeks from inauguration as president, should have been charged with serious crimes and belonged behind bars, not in the White House. \nMoreover, many have seen the WikiLeaks that reek of collusion between the Clintonistas and officials at the FBI and Justice, not to mention with virtually all the mainstream media outlets that were distrusted to begin with and are now reviled. \nIf that’s not an explosive situation, what is? And we don’t know what Assange et al have in store for us after the election. Just now we learned that the Clinton Foundation accepted—while Her Ladyship was secretary of State and in honor of Bill’s birthday—an unreported one million dollar donation from that paragon of women’s and gay rights, Qatar. This is chump change in the grand Clinton scheme of things, but another reminder of their unending greed and corruption. More importantly, as Tyler Durden points out, this time there should be legal consequences for the foundation—or would be normally in a country governed by the rule of law. \nOnly we’re not anymore. \nThis and a thousand other things put Obama, quite possibly liable himself from the email disclosures, and his attorney general Lynch behind a treacherous eight ball going forward, because they are not dealing with a few thousand disgruntled people, but those many millions. If they were to go ahead with Jarrett’s suggestion, take Comey’s head (i. e. fire him) and replace him with a yet more complaisant successor, who knows what would happen? \nBut if they don’t, and even if they do, the investigation may reveal things so shocking the nation will never be the same. Rumors have been flying that are so extreme that even a ten percent accuracy rate could ignite a firestorm. \nThe problem for all of us is that there is literally nothing Clinton can do to get out of this box, even if, as many predict, Obama pardons her. The corruption is so pervasive there is no way short of an actual military putsch to stop the continuing revelations. And such an action would itself unleash … well, you know the title of this article. \nWould a Trump victory save us from all this? No one knows. Dennis Prager perhaps put it best. When you have two doors and behind one is a man-eating lion and the other one may or may not have such a lion, which door do you choose? Unless you want to commit suicide, the answer is self-evident.",
		"thread_title": "Is America On The Brink Of Civil War?",
		"title": "Is America On The Brink Of Civil War?",
		"type": "bs",
		"uuid": "3e0db7cadf624070f8be4ae81e38ed339f204e0b"
	},
	"-KhIhSIpd2SRlbHt9NfW": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T20:01:08.529+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.16466671,
				"type": "PERSON"
			},
			{
				"name": "mask",
				"salience": 0.08061718,
				"type": "OTHER"
			},
			{
				"name": "stump speech",
				"salience": 0.05727353,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.05727353,
				"type": "OTHER"
			},
			{
				"name": "musicians",
				"salience": 0.049695823,
				"type": "PERSON"
			},
			{
				"name": "stump speech riff",
				"salience": 0.049695823,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.04346669,
				"type": "LOCATION"
			},
			{
				"name": "mask",
				"salience": 0.033608377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "POLITICO",
				"salience": 0.030742783,
				"type": "ORGANIZATION"
			},
			{
				"name": "Midway",
				"salience": 0.030742783,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.029978892,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.026326282,
				"type": "EVENT"
			},
			{
				"name": "crowd",
				"salience": 0.023997512,
				"type": "PERSON"
			},
			{
				"name": "mask",
				"salience": 0.021490136,
				"type": "OTHER"
			},
			{
				"name": "attendee",
				"salience": 0.020613,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.018478224,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vw20h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jay_Z"
				},
				"name": "Jay-Z",
				"salience": 0.012712249,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01mpq7s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beyonc%C3%A9"
				},
				"name": "Beyonce",
				"salience": 0.012712249,
				"type": "PERSON"
			},
			{
				"name": "mask",
				"salience": 0.01209867,
				"type": "OTHER"
			},
			{
				"name": "mask",
				"salience": 0.01209867,
				"type": "OTHER"
			},
			{
				"name": "mask",
				"salience": 0.011648289,
				"type": "OTHER"
			},
			{
				"name": "crusade",
				"salience": 0.010551819,
				"type": "OTHER"
			},
			{
				"name": "mask",
				"salience": 0.0098820245,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00918086,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00822913,
				"type": "LOCATION"
			},
			{
				"name": "rally",
				"salience": 0.0074417153,
				"type": "EVENT"
			},
			{
				"name": "eye",
				"salience": 0.0074033616,
				"type": "OTHER"
			},
			{
				"name": "podium",
				"salience": 0.0074033616,
				"type": "OTHER"
			},
			{
				"name": "billionaire",
				"salience": 0.007159353,
				"type": "PERSON"
			},
			{
				"name": "greatness",
				"salience": 0.0071274224,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0071274224,
				"type": "OTHER"
			},
			{
				"name": "rubber",
				"salience": 0.0071274224,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0071274224,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.006980323,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03337q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Billy_Graham"
				},
				"name": "Billy Graham",
				"salience": 0.0065004756,
				"type": "PERSON"
			},
			{
				"name": "microphone",
				"salience": 0.006045526,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.006045526,
				"type": "OTHER"
			},
			{
				"name": "tariff",
				"salience": 0.005603095,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0052162735,
				"type": "LOCATION"
			},
			{
				"name": "first",
				"salience": 0.0048128734,
				"type": "OTHER"
			},
			{
				"name": "proposal",
				"salience": 0.0045174216,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0045174216,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0045174216,
				"type": "ORGANIZATION"
			},
			{
				"name": "remarks",
				"salience": 0.0045174216,
				"type": "OTHER"
			},
			{
				"name": "job growth",
				"salience": 0.0045174216,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.0043892744,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.0032907228,
				"type": "EVENT"
			},
			{
				"name": "two",
				"salience": 0.0032907228,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.0031679363,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0031442577,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0027811907,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rrwt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sarasota,_Florida"
				},
				"name": "Sarasota",
				"salience": 0.0027811907,
				"type": "LOCATION"
			},
			{
				"name": "fun",
				"salience": 0.0026193555,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0024584674,
				"type": "OTHER"
			},
			{
				"name": "hair",
				"salience": 0.0024584674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0020256997,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.0020256997,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0020256997,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0020256997,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v1s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indiana"
				},
				"name": "Indiana",
				"salience": 0.0020256997,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/rs-229194-R1256_FEA_GOP_C.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T20:01:08.529+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Trump breaks from stump speech to admire ‘beautiful’ Trump mask 11/07/2016 \nPOLITICO \nMidway through a stump speech riff lamenting that Hillary Clinton had appeared on stage with less-than-family-friendly musicians like Jay-Z and Beyonce, Donald Trump paused at an election-eve rally in Florida Monday morning to gawk at an attendee’s mask. \n“This is different than a Billy Graham crusade, but you know what? We’re all looking for the same thing. We’re looking for greatness for our country. We’re looking for religious liberty,” the Manhattan billionaire said before the rubber Trump mask caught his eye. “Look at this mask. Look at this mask. Oh wow. Wow, that’s beautiful. Look at that. Looks just like me.” \nTrump then left the podium for a few seconds as the mask made its way up to the stage. He returned to the microphone and held up the mask next to his own face, before examining it closer. He held it up once more time and joked “nice head of hair, I’ll say that,” before tossing it back. \n“Is there any place more fun to be than a Trump rally?” has asked the crowd before resuming his remarks, turning to his proposal to stimulate job growth in the U.S. by placing a tariff on companies who move production out of the country. \nThe Sarasota, Florida, rally is the first of five for Trump on Monday. From Florida, he will head to events in North Carolina, Pennsylvania, New Hampshire and Michigan. He will be joined at the final two by his running mate, Indiana Gov. Mike Pence.",
		"thread_title": "Trump breaks from stump speech to admire ‘beautiful’ Trump mask",
		"title": "Trump breaks from stump speech to admire ‘beautiful’ Trump mask",
		"type": "bs",
		"uuid": "1f98a7928d70702eabfbb2f87fddb96ad2d12954"
	},
	"-KhIhUFxOWNjuP_uW3km": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T20:01:08.682+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.37512323,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.10662476,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea Clinton",
				"salience": 0.059918202,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.025997737,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.0190476,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.018792234,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.015762964,
				"type": "ORGANIZATION"
			},
			{
				"name": "nominee",
				"salience": 0.014392022,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.013758117,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Department of Justice",
				"salience": 0.013575088,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.010133165,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.009837029,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.009191175,
				"type": "EVENT"
			},
			{
				"name": "nominee",
				"salience": 0.007289205,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.0071920664,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.006849003,
				"type": "OTHER"
			},
			{
				"name": "spending",
				"salience": 0.005062201,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.004265115,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.004145932,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.004103185,
				"type": "LOCATION"
			},
			{
				"name": "email",
				"salience": 0.0038842307,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0038842307,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rally",
				"salience": 0.0036776168,
				"type": "EVENT"
			},
			{
				"name": "justice",
				"salience": 0.0036776168,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0036776168,
				"type": "OTHER"
			},
			{
				"name": "relief",
				"salience": 0.0035767346,
				"type": "OTHER"
			},
			{
				"name": "reduction",
				"salience": 0.0035767346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.003449898,
				"type": "PERSON"
			},
			{
				"name": "foundation",
				"salience": 0.0034473613,
				"type": "OTHER"
			},
			{
				"name": "phrasing",
				"salience": 0.0034433806,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0033357164,
				"type": "PERSON"
			},
			{
				"name": "exchange",
				"salience": 0.003128738,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07dk8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Boston_Globe"
				},
				"name": "BOSTON GLOBE",
				"salience": 0.003001737,
				"type": "ORGANIZATION"
			},
			{
				"name": "review",
				"salience": 0.0029895618,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.002985729,
				"type": "ORGANIZATION"
			},
			{
				"name": "handling",
				"salience": 0.0028760612,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0028760612,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0028760612,
				"type": "OTHER"
			},
			{
				"name": "wedding",
				"salience": 0.0028760612,
				"type": "EVENT"
			},
			{
				"name": "servers",
				"salience": 0.0028760612,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0027943233,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.00277945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rrwt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sarasota,_Florida"
				},
				"name": "Sarasota",
				"salience": 0.002680183,
				"type": "LOCATION"
			},
			{
				"name": "Band",
				"salience": 0.002679346,
				"type": "ORGANIZATION"
			},
			{
				"name": "stock",
				"salience": 0.00265363,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0025498506,
				"type": "ORGANIZATION"
			},
			{
				"name": "spokesman",
				"salience": 0.0025494955,
				"type": "PERSON"
			},
			{
				"name": "ex-aide",
				"salience": 0.0024907214,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0024907214,
				"type": "PERSON"
			},
			{
				"name": "ballot box",
				"salience": 0.0024907214,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0024907214,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0024907214,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.0024907214,
				"type": "PERSON"
			},
			{
				"name": "quotation marks",
				"salience": 0.0024907214,
				"type": "OTHER"
			},
			{
				"name": "blitz",
				"salience": 0.0024907214,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0022538495,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0l8ps43",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Josh_Earnest"
				},
				"name": "Josh Earnest",
				"salience": 0.0020394388,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.001978692,
				"type": "LOCATION"
			},
			{
				"name": "crowd",
				"salience": 0.0019417261,
				"type": "PERSON"
			},
			{
				"name": "campaigning",
				"salience": 0.0019372087,
				"type": "EVENT"
			},
			{
				"name": "weeklong strike",
				"salience": 0.0018931212,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.001815825,
				"type": "LOCATION"
			},
			{
				"name": "foundation resources",
				"salience": 0.0015386852,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.0015147078,
				"type": "EVENT"
			},
			{
				"name": "rally",
				"salience": 0.0015147078,
				"type": "EVENT"
			},
			{
				"name": "Band",
				"salience": 0.0015147078,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band",
				"salience": 0.0015147078,
				"type": "ORGANIZATION"
			},
			{
				"name": "mask",
				"salience": 0.0014904474,
				"type": "OTHER"
			},
			{
				"name": "strike",
				"salience": 0.0014323791,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.001406211,
				"type": "ORGANIZATION"
			},
			{
				"name": "agreement",
				"salience": 0.0013554689,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0013116496,
				"type": "OTHER"
			},
			{
				"name": "Band",
				"salience": 0.0012845438,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.0012749486,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0012732437,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0012732437,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0012732437,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0012732437,
				"type": "LOCATION"
			},
			{
				"name": "elections",
				"salience": 0.0012264977,
				"type": "EVENT"
			},
			{
				"name": "hands",
				"salience": 0.0011843009,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0011843009,
				"type": "PERSON"
			},
			{
				"name": "wedding",
				"salience": 0.0011843009,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0011507849,
				"type": "ORGANIZATION"
			},
			{
				"name": "polls",
				"salience": 0.0011218037,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.0011218037,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8t6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Christie"
				},
				"name": "Chris Christie",
				"salience": 0.0011190709,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0011004949,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anyone",
				"salience": 0.0010904333,
				"type": "PERSON"
			},
			{
				"name": "bureau",
				"salience": 0.001085563,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.0010799312,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0010799312,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0010799312,
				"type": "WORK_OF_ART"
			},
			{
				"name": "transit system",
				"salience": 0.0010708055,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0010700575,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0010686473,
				"type": "PERSON"
			},
			{
				"name": "battleground states",
				"salience": 0.0010394481,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.0010394481,
				"type": "WORK_OF_ART"
			},
			{
				"name": "issues",
				"salience": 0.0010255144,
				"type": "OTHER"
			},
			{
				"name": "consulting firm",
				"salience": 0.0010255144,
				"type": "ORGANIZATION"
			},
			{
				"name": "comment",
				"salience": 0.0010255144,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fairgrounds arena",
				"salience": 0.0010255144,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0010255144,
				"type": "OTHER"
			},
			{
				"name": "campaign pace",
				"salience": 0.0010255144,
				"type": "OTHER"
			},
			{
				"name": "outsiders",
				"salience": 0.0010255144,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.0010255144,
				"type": "ORGANIZATION"
			},
			{
				"name": "messages",
				"salience": 0.0010255144,
				"type": "WORK_OF_ART"
			},
			{
				"name": "daughter",
				"salience": 0.0010255144,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.0010255144,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0010178464,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0010081867,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0010012815,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0010012815,
				"type": "EVENT"
			},
			{
				"name": "voter intimidation",
				"salience": 0.0009954828,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00095832313,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.00095832313,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charges",
				"salience": 0.00095832313,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00095832313,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0009533883,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.0009513152,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.000942617,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04cxlc4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doug_Band"
				},
				"name": "Doug Band",
				"salience": 0.0009323581,
				"type": "PERSON"
			},
			{
				"name": "reporters",
				"salience": 0.0009158036,
				"type": "PERSON"
			},
			{
				"name": "voter",
				"salience": 0.0009158036,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.00090689876,
				"type": "LOCATION"
			},
			{
				"name": "investigation",
				"salience": 0.0008853227,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0008853227,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.0008735557,
				"type": "OTHER"
			},
			{
				"name": "restraint",
				"salience": 0.00085167814,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.0008371891,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00083034823,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.00083034823,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00083034823,
				"type": "PERSON"
			},
			{
				"name": "staffers",
				"salience": 0.00083034823,
				"type": "PERSON"
			},
			{
				"name": "serve",
				"salience": 0.00083034823,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00082841545,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00082841545,
				"type": "EVENT"
			},
			{
				"name": "presence",
				"salience": 0.0008126703,
				"type": "OTHER"
			},
			{
				"name": "tones",
				"salience": 0.00081093475,
				"type": "OTHER"
			},
			{
				"name": "likeness",
				"salience": 0.0007993504,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0007993504,
				"type": "OTHER"
			},
			{
				"name": "recommendation",
				"salience": 0.0007993504,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000789277,
				"type": "PERSON"
			},
			{
				"name": "high court",
				"salience": 0.00074796734,
				"type": "ORGANIZATION"
			},
			{
				"name": "reporters",
				"salience": 0.00074761827,
				"type": "PERSON"
			},
			{
				"name": "reporters",
				"salience": 0.00072889356,
				"type": "PERSON"
			},
			{
				"name": "announcement",
				"salience": 0.00072817877,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00072054716,
				"type": "EVENT"
			},
			{
				"name": "Subways",
				"salience": 0.000719002,
				"type": "PERSON"
			},
			{
				"name": "schedule",
				"salience": 0.000719002,
				"type": "OTHER"
			},
			{
				"name": "union",
				"salience": 0.000719002,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.000719002,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.000719002,
				"type": "LOCATION"
			},
			{
				"name": "race",
				"salience": 0.000719002,
				"type": "EVENT"
			},
			{
				"name": "jurisdictions",
				"salience": 0.000719002,
				"type": "LOCATION"
			},
			{
				"name": "civil rights violations",
				"salience": 0.000719002,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0006952654,
				"type": "EVENT"
			},
			{
				"name": "Kellyanne Conway",
				"salience": 0.0006936516,
				"type": "PERSON"
			},
			{
				"name": "rival",
				"salience": 0.00069215946,
				"type": "ORGANIZATION"
			},
			{
				"name": "scrutiny",
				"salience": 0.00069215946,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00069215946,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.00069215946,
				"type": "PERSON"
			},
			{
				"name": "fun",
				"salience": 0.00069215946,
				"type": "OTHER"
			},
			{
				"name": "hair",
				"salience": 0.00069215946,
				"type": "OTHER"
			},
			{
				"name": "notice",
				"salience": 0.00069215946,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0006841073,
				"type": "WORK_OF_ART"
			},
			{
				"name": "vote",
				"salience": 0.0006841073,
				"type": "OTHER"
			},
			{
				"name": "swing",
				"salience": 0.0006778515,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.0006778515,
				"type": "PERSON"
			},
			{
				"name": "voter rally",
				"salience": 0.0006476646,
				"type": "EVENT"
			},
			{
				"name": "confidence",
				"salience": 0.00064432085,
				"type": "OTHER"
			},
			{
				"name": "voter intimidation",
				"salience": 0.0006386511,
				"type": "OTHER"
			},
			{
				"name": "transit workers",
				"salience": 0.00063620054,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.00063118467,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.0006267244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0006236795,
				"type": "LOCATION"
			},
			{
				"name": "judge",
				"salience": 0.00060705893,
				"type": "PERSON"
			},
			{
				"name": "court judge",
				"salience": 0.00060705893,
				"type": "PERSON"
			},
			{
				"name": "intimidation",
				"salience": 0.00060705893,
				"type": "OTHER"
			},
			{
				"name": "court charges",
				"salience": 0.00060705893,
				"type": "OTHER"
			},
			{
				"name": "campaigning",
				"salience": 0.0006033218,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0006033218,
				"type": "EVENT"
			},
			{
				"name": "provision",
				"salience": 0.0005869487,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.0005869487,
				"type": "PERSON"
			},
			{
				"name": "monitors",
				"salience": 0.0005869487,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0005869487,
				"type": "PERSON"
			},
			{
				"name": "opinion",
				"salience": 0.0005869487,
				"type": "OTHER"
			},
			{
				"name": "airport",
				"salience": 0.0005869487,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.0005625758,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contempt",
				"salience": 0.00056080887,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0005463798,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "U.S. Supreme Court",
				"salience": 0.00053717114,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.00052363024,
				"type": "OTHER"
			},
			{
				"name": "judges",
				"salience": 0.00052135147,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00051368104,
				"type": "ORGANIZATION"
			},
			{
				"name": "mayor",
				"salience": 0.00051368104,
				"type": "PERSON"
			},
			{
				"name": "emergency request",
				"salience": 0.0005131637,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.000506342,
				"type": "PERSON"
			},
			{
				"name": "appeals court order",
				"salience": 0.000506342,
				"type": "OTHER"
			},
			{
				"name": "restraining order",
				"salience": 0.000506342,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.000506342,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.000506342,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.000506342,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.00049821514,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00049821514,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.00049011986,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00048777758,
				"type": "LOCATION"
			},
			{
				"name": "agenda",
				"salience": 0.0004731039,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00046364704,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j757",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_courts_of_appeals"
				},
				"name": "U.S. Circuit Court of Appeals",
				"salience": 0.0004603361,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign manager",
				"salience": 0.0004404021,
				"type": "PERSON"
			},
			{
				"name": "merits",
				"salience": 0.00043843448,
				"type": "OTHER"
			},
			{
				"name": "harassment",
				"salience": 0.00043843448,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.00043843448,
				"type": "LOCATION"
			},
			{
				"name": "success",
				"salience": 0.00043843448,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.00043843448,
				"type": "OTHER"
			},
			{
				"name": "aides",
				"salience": 0.00043843448,
				"type": "OTHER"
			},
			{
				"name": "ruling",
				"salience": 0.00043843448,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.00042598476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0130v6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Air_Force_One"
				},
				"name": "Air Force One",
				"salience": 0.00042598476,
				"type": "OTHER"
			},
			{
				"name": "city officials",
				"salience": 0.00042395844,
				"type": "PERSON"
			},
			{
				"name": "swing state",
				"salience": 0.00042240843,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.00041717794,
				"type": "LOCATION"
			},
			{
				"name": "crowd",
				"salience": 0.00041333845,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00041037519,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.00041037519,
				"type": "LOCATION"
			},
			{
				"name": "review",
				"salience": 0.00040841397,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00040841397,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00040841397,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00040841397,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00040841397,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00040841397,
				"type": "EVENT"
			},
			{
				"name": "panel",
				"salience": 0.00038133646,
				"type": "PERSON"
			},
			{
				"name": "lane closure controversy",
				"salience": 0.0003784842,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00036874533,
				"type": "PERSON"
			},
			{
				"name": "reconciliation",
				"salience": 0.00036874533,
				"type": "OTHER"
			},
			{
				"name": "confidence",
				"salience": 0.00036874533,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00036874533,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00036409745,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fh70",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voting_Rights_Act_of_1965"
				},
				"name": "Voting Rights Act",
				"salience": 0.0003612265,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charges",
				"salience": 0.00035634422,
				"type": "OTHER"
			},
			{
				"name": "runner-up",
				"salience": 0.00035050235,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01my6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/SEPTA"
				},
				"name": "Southeastern Pennsylvania Transportation Authority",
				"salience": 0.0003477386,
				"type": "ORGANIZATION"
			},
			{
				"name": "nomination",
				"salience": 0.00033022967,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0003192886,
				"type": "EVENT"
			},
			{
				"name": "cloud",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "qualifications",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "temperament",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "healing",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "dark visions",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "strongholds",
				"salience": 0.0003192886,
				"type": "LOCATION"
			},
			{
				"name": "flurry",
				"salience": 0.0003192886,
				"type": "OTHER"
			},
			{
				"name": "lawmakers",
				"salience": 0.0003192886,
				"type": "PERSON"
			},
			{
				"name": "momentum",
				"salience": 0.0003073664,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0003067467,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.00030506734,
				"type": "LOCATION"
			},
			{
				"name": "choice",
				"salience": 0.00030349207,
				"type": "OTHER"
			},
			{
				"name": "vice presidential pick",
				"salience": 0.0002958893,
				"type": "PERSON"
			},
			{
				"name": "vice",
				"salience": 0.00027543528,
				"type": "PERSON"
			},
			{
				"name": "bridge",
				"salience": 0.00027543528,
				"type": "LOCATION"
			},
			{
				"name": "access lanes",
				"salience": 0.00027543528,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01snm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cincinnati"
				},
				"name": "Cincinnati",
				"salience": 0.00026981885,
				"type": "LOCATION"
			},
			{
				"name": "likelihood",
				"salience": 0.00026515033,
				"type": "OTHER"
			},
			{
				"name": "revenge",
				"salience": 0.00023849204,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00023849204,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00023849204,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00023849204,
				"type": "LOCATION"
			},
			{
				"name": "plot",
				"salience": 0.00023849204,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.00023849204,
				"type": "OTHER"
			},
			{
				"name": "voter intimidation lawsuit",
				"salience": 0.00023849204,
				"type": "OTHER"
			},
			{
				"name": "Department officials",
				"salience": 0.0002110213,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.00019968441,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01h1bf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Today_(U.S._TV_program)"
				},
				"name": "Today Show",
				"salience": 0.00019649045,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.00019649045,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/019jg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Washington_Bridge"
				},
				"name": "George Washington Bridge",
				"salience": 0.0001695017,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0v9qg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_Rapids,_Michigan"
				},
				"name": "Grand Rapids",
				"salience": 0.00014676599,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hr3xn9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_This_Morning"
				},
				"name": "CBS This Morning",
				"salience": 0.00014676599,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/068p2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pittsburgh"
				},
				"name": "Pittsburgh",
				"salience": 0.00014676599,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.00014676599,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.00014676599,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fvyg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raleigh,_North_Carolina"
				},
				"name": "Raleigh",
				"salience": 0.00014676599,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/trump-scnshot1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T20:01:08.682+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 30.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Donald Trump kicks off final campaign day with Fla. rally 11/07/2016 \nBOSTON GLOBE \n\nDonald Trump is criticizing the FBI’s decision not to criminally charge Hillary Clinton. He says ‘‘now it’s up to the American people to deliver justice at the ballot box.’’ \nTrump kicked off his Election Day eve blitz with a rally Monday in Florida. He told the Sarasota crowd that ‘‘the system is rigged, but at least we know it.’’ \nHe claimed that ‘‘our country is a laughing stock all over the world.’’ \nThe Republican nominee than pantomimed quotation marks when he said the word ‘‘justice’’ as he hit the FBI and the Department of Justice for their handling of the case. \nFBI Director James Comey notified Congress Sunday that a review of new emails connected to Clinton’s servers did produce evidence that would warrant charges. \n11:45 a.m. \nAn ex-aide to former President Bill Clinton alleged in a hacked email that Chelsea Clinton used the family’s charitable foundation to help underwrite her 2010 wedding. \nThe 2012 exchange between Doug Band and Hillary Clinton campaign chairman John Podesta was released by the WikiLeaks organization. Stolen messages have chronicled tensions within the Clinton Foundation between Band and the daughter of the Democratic presidential nominee. \nBand told Podesta that Chelsea Clinton was gossiping to outsiders that she was investigating questionable spending. Band suggested that she is the one who should be scrutinized for ‘‘using foundation resources for her wedding.’’ He did not provide details about this. A Clinton Foundation spokesman did not immediately respond to a request for comment. \nBand was later forced out amid issues with his outside consulting firm. \n___ \n11:40 a.m. \nDonald Trump is kicking off his last, breakneck day of campaigning before polls open with a rally in Sarasota, Florida. \nTrump is telling thousands of supporters packed into a local fairgrounds arena Monday that the election is now in their hands. \nHe told them: ‘‘Get out there. I mean, I did my thing. I worked.’’ \nTrump is planning to continue a frenzied campaign pace, with rallies in five states Monday, including North Carolina, Pennsylvania, New Hampshire and Michigan. \nTrump is also continuing to paint rival Hillary Clinton as a corrupt and alluding to the scrutiny of her use of a private email sever as secretary of state. \nTrump is also having some fun. At one point, he held up a mask in his likeness and complimented its hair. \n___ \n11:30 a.m. \nThe White House says it will ‘‘neither defend nor criticize’’ FBI Director James Comey’s decision to send a new letter to Congress about Hillary Clinton’s emails. \nThat’s the same phrasing the White House used when Comey initially announced that the FBI was looking into more emails related to its investigation of Clinton. In a follow-up letter Sunday, Comey said the FBI review was completed and it was standing by its recommendation that no charges be filed. \nWhite House spokesman Josh Earnest on Monday told reporters aboard Air Force One that the White House hasn’t been briefed on the investigation and didn’t receive advance notice about Comey’s latest letter. \nEarnest says Obama still has confidence in Comey. \n___ \n10:50 a.m. \nPhiladelphia’s public transit system will be up and running in time for Election Day now that a weeklong strike has ended. That’s a relief to the state’s Democrats. \nDemocratic city officials were worried that the strike could affect turnout at the polls Tuesday. Pennsylvania does not offer early voting, so Election Day turnout is key. \nThe state has favored Democrats in recent presidential elections, but polls suggest the race is tightening. Democrat Hillary Clinton is counting on strong support in the Philadelphia area. Both candidates are campaigning in the state Tuesday. \nThe Southeastern Pennsylvania Transportation Authority and the union representing roughly 4,700 transit workers announced a tentative agreement early Monday. Subways were soon operating on a reduced schedule and limited trolled serve was restored. \n___ \n10:30 a.m. \nThe Justice Department says it will send more than 500 staffers to 28 states on Election Day to monitor the polls. That’s a 35 percent reduction from the number four years ago. \nDepartment officials say personnel will be sent to 67 jurisdictions to watch for potential civil rights violations. Monday’s announcement comes amid rising concerns about voter intimidation, particularly aimed at minorities. \nThe number of personnel is less than the roughly 780 monitors and observers who were dispatched in 2012. \nThe Justice Department has said its poll-watching presence has been curtailed by a 2013 Supreme Court opinion that gutted a key provision of the Voting Rights Act. \nIn a statement, Attorney General Loretta Lynch said the department is committed to ensuring that every eligible voter can participate in the election. \n___ \n10:25 a.m. \nHillary Clinton is departing on a multi-stop swing of the presidential battleground states on the day before the election. She’s telling reporters that ‘‘we’re just going to work until the last vote is counted.’’ \nClinton said Monday that while she thinks she has ‘‘some work to do to bring the country together,’’ she wants to be the president for those who vote for her and those who don’t. She was speaking to reporters at an airport outside New York City. \nClinton said she has ‘‘a big agenda ahead of us’’ and is vowing to ‘‘get a lot done’’ if she defeats Republican Donald Trump. \nThe Democratic presidential nominee was campaigning in Pittsburgh; Grand Rapids, Michigan; Philadelphia and Raleigh, North Carolina. \n___ \n8:55 a.m. \nNew Jersey Gov. Chris Christie says he doesn’t know if the George Washington Bridge lane closure controversy cost him the vice presidential nomination. \nChristie said Monday on ‘‘CBS This Morning’’ that he was runner-up to be Republican Donald Trump’s vice presidential pick. He denied a report that Trump had offered him the job, then rescinded it. He said he thinks Trump thought Indian governor Mike Pence was the better choice. \nTwo of Christie’s former allies were convicted Friday for their role in re-aligning access lanes to the bridge in a political revenge plot against a Democratic mayor who didn’t endorse him. \nChristie says he thinks Trump will defeat Democrat Hillary Clinton Tuesday because the momentum is on his side and the country wants change. \n___ \n8:35 a.m. \nOhio Democrats want the U.S. Supreme Court to intervene in their voter intimidation lawsuit in the swing state. \nThe party has filed an emergency request for the nation’s high court to lift a Cincinnati-based federal appeals court order. That ruling Sunday granted the Donald Trump campaign’s request to block a federal judge’s restraining order Democrats said was needed to prevent voter intimidation. \nA 6th U.S. Circuit Court of Appeals three-judge panel said Ohio Democrats didn’t show ‘‘a likelihood of success’’ on their case’s merits. \nThe party told the U.S. Supreme Court the appellate judges ruled without reviewing ‘‘critical evidence’’ a lower court judge relied on in ruling that anyone engaging in intimidation or harassment inside or near polling places would face contempt of court charges. \n___ \n7:35 a.m. \nDonald Trump’s campaign manager says it’s not true that his staff has stopped him from tweeting. \nTrump has exhibited unusual restraint on social media in the final days of the campaign. The New York Times reported on Sunday that aides ‘‘have finally wrested away’’ his Twitter account. \nPresident Barack Obama seized on the report at a voter rally in Florida, telling the crowd that anyone who can’t be trusted with a Twitter account shouldn’t be trusted with control of the America’s nuclear weapons. \nWhen asked Monday about the Times report by NBC’s ‘‘Today Show,’’ campaign manager Kellyanne Conway said: ‘‘No, it’s not true.’’ \n___ \n3:15 a.m. \nWith the cloud of an FBI investigation lifted, Hillary Clinton and Donald Trump struck strikingly different tones as they moved into the final hours of a volatile, nearly two-year-long presidential campaign. \nAfter days of attacks on Trump’s qualifications and temperament, Clinton cast herself as the candidate of ‘‘healing and reconciliation,’’ perhaps a surprising position for one of the most divisive figures in American politics. Trump, meanwhile, voiced new confidence as he brought his campaign — and his dark visions of a rigged American economic and political system— to longtime Democratic strongholds. \nOvershadowing the flurry of last-minute campaigning was FBI Director James Comey’s latest letter to Congress, informing lawmakers the bureau had found no evidence in its hurried review of newly discovered emails to warrant criminal charges against Clinton.",
		"thread_title": "Donald Trump kicks off final campaign day with Fla. rally",
		"title": "Donald Trump kicks off final campaign day with Fla. rally",
		"type": "bs",
		"uuid": "144fc0dba9ee289bf18660cf906c1e08cfaeb749"
	},
	"-KhIhVKJypxGlutNLo04": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T20:01:08.718+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.7194475,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.06645449,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01b8g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jens_Stoltenberg"
				},
				"name": "Jens Stoltenberg",
				"salience": 0.021999145,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.014000722,
				"type": "PERSON"
			},
			{
				"name": "reinforcement",
				"salience": 0.01266112,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.01266112,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.01266112,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0280k2k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dmitry_Peskov"
				},
				"name": "Dmitry Peskov",
				"salience": 0.012404445,
				"type": "PERSON"
			},
			{
				"name": "preparations",
				"salience": 0.010984949,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.010357813,
				"type": "ORGANIZATION"
			},
			{
				"name": "RUSSIA TODAY Reports",
				"salience": 0.007836653,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.007681161,
				"type": "OTHER"
			},
			{
				"name": "blocs",
				"salience": 0.0069159647,
				"type": "OTHER"
			},
			{
				"name": "Agression 11",
				"salience": 0.0067939325,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "character",
				"salience": 0.005787768,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0056688953,
				"type": "OTHER"
			},
			{
				"name": "military personnel",
				"salience": 0.003621556,
				"type": "PERSON"
			},
			{
				"name": "daily",
				"salience": 0.0035154873,
				"type": "ORGANIZATION"
			},
			{
				"name": "military alliance",
				"salience": 0.0032247528,
				"type": "OTHER"
			},
			{
				"name": "peace-building",
				"salience": 0.002331303,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.002331303,
				"type": "OTHER"
			},
			{
				"name": "bloc",
				"salience": 0.0022631835,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.002116297,
				"type": "WORK_OF_ART"
			},
			{
				"name": "troops",
				"salience": 0.002013234,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0020028616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nature",
				"salience": 0.0018180803,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0018180803,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.0017077512,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.0016356251,
				"type": "OTHER"
			},
			{
				"name": "secretary-general",
				"salience": 0.0016356251,
				"type": "PERSON"
			},
			{
				"name": "representative",
				"salience": 0.0016356251,
				"type": "PERSON"
			},
			{
				"name": "bloc",
				"salience": 0.0016179864,
				"type": "ORGANIZATION"
			},
			{
				"name": "alert",
				"salience": 0.0015746565,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0015746565,
				"type": "PERSON"
			},
			{
				"name": "bases",
				"salience": 0.0015746565,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0014361347,
				"type": "LOCATION"
			},
			{
				"name": "defense ministers",
				"salience": 0.0014050285,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.0013356163,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09rkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times"
				},
				"name": "Times",
				"salience": 0.0011485512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.0010072603,
				"type": "LOCATION"
			},
			{
				"name": "Adam Thomson",
				"salience": 0.0010072603,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0010072603,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0009979991,
				"type": "OTHER"
			},
			{
				"name": "regard",
				"salience": 0.0009979991,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0009979991,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0009979991,
				"type": "OTHER"
			},
			{
				"name": "defense spending",
				"salience": 0.0009979991,
				"type": "OTHER"
			},
			{
				"name": "military capabilities",
				"salience": 0.0009979991,
				"type": "OTHER"
			},
			{
				"name": "chief",
				"salience": 0.00086813874,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0008394977,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0008394977,
				"type": "LOCATION"
			},
			{
				"name": "statements",
				"salience": 0.0008394977,
				"type": "OTHER"
			},
			{
				"name": "military bloc",
				"salience": 0.0008112874,
				"type": "ORGANIZATION"
			},
			{
				"name": "discussions",
				"salience": 0.0007456489,
				"type": "EVENT"
			},
			{
				"name": "anyone",
				"salience": 0.00072698324,
				"type": "PERSON"
			},
			{
				"name": "defense",
				"salience": 0.0006946251,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.000632361,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.00062719564,
				"type": "PERSON"
			},
			{
				"name": "reinforcement",
				"salience": 0.00062719564,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0006144141,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0006087623,
				"type": "OTHER"
			},
			{
				"name": "notice",
				"salience": 0.0005431167,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0005431167,
				"type": "EVENT"
			},
			{
				"name": "nature",
				"salience": 0.00043976877,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0003342979,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/582096a9c46188d83d8b465c.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T20:01:08.718+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Kremlin: NATO was Created for Agression 11/07/2016 \nRUSSIA TODAY Reports of the new reinforcement of NATO troops close to Russia’s borders show “the aggressive character of the organization,” the Kremlin has said, commenting on recently announced preparations to deter an alleged Russian threat. \nThe Western military alliance was established “ not for peace-building, but exactly for aggressive actions ,” Kremlin spokesman Dmitry Peskov said on Monday. Despite the fact that blocs which opposed NATO no longer exist, it’s impossible to change the alliance’s “ aggressive nature ” due to its ideological and political bases. \nEarlier on Monday, the Times published a report suggesting that “ hundreds of thousands of NATO troops will be put on a higher state of alert amid growing tensions with Russia .” According to the British daily – which cites the alliance’s secretary-general, Jens Stoltenberg, and the UK’s outgoing permanent representative to the bloc, Adam Thomson – NATO aims to largely speed up the time its troops can be deployed. \nIt reportedly aims to have up to 300,000 military personnel from nations across the alliance at the ready, having shortened their response time to about two months, compared to the current 180 days. \n“ We are responding with the biggest reinforcement of our collective defense since the end of the Cold War ,” Stoltenberg told the Times . The bloc is looking into how more of its 3 million personnel “ can be ready on a shorter notice ,” he added, saying that NATO defense ministers have already had discussions on the issue. \nHaving accused Moscow of “ assertive ” behavior, the NATO chief said Russia had increased its defense spending and was “ developing new military capabilities .” \n“ In regard to its national security, Russia acts within its national borders, undoubtedly posing no threat to anyone ,” Peskov said, commenting on Stoltenberg’s statements. The way the military bloc has reacted “ once again shows the organization’s aggressive nature ,” he added.",
		"thread_title": "Kremlin: NATO was Created for Agression",
		"title": "Kremlin: NATO was Created for Agression",
		"type": "bs",
		"uuid": "c308f137a67647b16a3c0efdfa0baad7b96eaf0e"
	},
	"-KhIhVfM-KZDP6QRTD_y": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T20:01:08.775+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.7659531,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.039248258,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.012572386,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.012082679,
				"type": "ORGANIZATION"
			},
			{
				"name": "lead",
				"salience": 0.011624829,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.01050677,
				"type": "EVENT"
			},
			{
				"name": "poll",
				"salience": 0.008956846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05st_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jill_Stein"
				},
				"name": "Jill Stein",
				"salience": 0.006747993,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "PRESS TV",
				"salience": 0.0056243567,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0056243567,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0056243567,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.00548872,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01tqr5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gary_Johnson"
				},
				"name": "Gary Johnson",
				"salience": 0.005048374,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0047552404,
				"type": "ORGANIZATION"
			},
			{
				"name": "Politics",
				"salience": 0.0046699625,
				"type": "OTHER"
			},
			{
				"name": "committee chairmen",
				"salience": 0.004110119,
				"type": "PERSON"
			},
			{
				"name": "tracking poll",
				"salience": 0.003222783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.0028786282,
				"type": "ORGANIZATION"
			},
			{
				"name": "Selzer & Co",
				"salience": 0.0028786282,
				"type": "ORGANIZATION"
			},
			{
				"name": "voters",
				"salience": 0.0028337683,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.002740428,
				"type": "EVENT"
			},
			{
				"name": "points",
				"salience": 0.002463039,
				"type": "OTHER"
			},
			{
				"name": "lead",
				"salience": 0.002463039,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.002461322,
				"type": "EVENT"
			},
			{
				"name": "letter",
				"salience": 0.002461322,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0023209576,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.0020370388,
				"type": "PERSON"
			},
			{
				"name": "matchup",
				"salience": 0.001926446,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.001870104,
				"type": "WORK_OF_ART"
			},
			{
				"name": "poll",
				"salience": 0.0018003833,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0017553505,
				"type": "EVENT"
			},
			{
				"name": "development",
				"salience": 0.0017408229,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0017278212,
				"type": "EVENT"
			},
			{
				"name": "lead",
				"salience": 0.0016633967,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0016633967,
				"type": "EVENT"
			},
			{
				"name": "letter",
				"salience": 0.001560219,
				"type": "WORK_OF_ART"
			},
			{
				"name": "probe",
				"salience": 0.001560219,
				"type": "EVENT"
			},
			{
				"name": "secretary of state",
				"salience": 0.0015020348,
				"type": "PERSON"
			},
			{
				"name": "relief",
				"salience": 0.0014395644,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0014395644,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.001369847,
				"type": "ORGANIZATION"
			},
			{
				"name": "review",
				"salience": 0.0013511959,
				"type": "OTHER"
			},
			{
				"name": "conclusions",
				"salience": 0.0013511959,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0013453217,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chief",
				"salience": 0.0013173845,
				"type": "PERSON"
			},
			{
				"name": "break",
				"salience": 0.001300797,
				"type": "EVENT"
			},
			{
				"name": "billionaire businessman",
				"salience": 0.001300797,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.0012739314,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07w42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libertarian_Party_(United_States)"
				},
				"name": "Libertarian",
				"salience": 0.0011862994,
				"type": "ORGANIZATION"
			},
			{
				"name": "rally",
				"salience": 0.0011409913,
				"type": "EVENT"
			},
			{
				"name": "stage",
				"salience": 0.0011032221,
				"type": "OTHER"
			},
			{
				"name": "frenzy",
				"salience": 0.0011032221,
				"type": "OTHER"
			},
			{
				"name": "Photo",
				"salience": 0.0011032221,
				"type": "WORK_OF_ART"
			},
			{
				"name": "survey",
				"salience": 0.0010893284,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00095181447,
				"type": "PERSON"
			},
			{
				"name": "campaign racing",
				"salience": 0.00094143,
				"type": "EVENT"
			},
			{
				"name": "path",
				"salience": 0.00088937255,
				"type": "OTHER"
			},
			{
				"name": "midnight-rally",
				"salience": 0.00083112024,
				"type": "EVENT"
			},
			{
				"name": "rally",
				"salience": 0.00083112024,
				"type": "EVENT"
			},
			{
				"name": "ballot box",
				"salience": 0.0008242358,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0008242358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00080084393,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01v3sw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ABC_News"
				},
				"name": "ABC News",
				"salience": 0.00080084393,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00080084393,
				"type": "ORGANIZATION"
			},
			{
				"name": "battleground states",
				"salience": 0.00076782866,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0006932864,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02dlk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agence_France-Presse"
				},
				"name": "AFP",
				"salience": 0.00067915674,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.00067915674,
				"type": "ORGANIZATION"
			},
			{
				"name": "Loudoun Fairgrounds",
				"salience": 0.00067915674,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/010n34",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leesburg,_Virginia"
				},
				"name": "Leesburg",
				"salience": 0.00067915674,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00067915674,
				"type": "LOCATION"
			},
			{
				"name": "charges",
				"salience": 0.0006644311,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0006477943,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.00062604743,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0005619322,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0005619322,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0005518153,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.0005073578,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0005073578,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0004884191,
				"type": "LOCATION"
			},
			{
				"name": "server",
				"salience": 0.00044847032,
				"type": "OTHER"
			},
			{
				"name": "email issue",
				"salience": 0.00044847032,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00044847032,
				"type": "EVENT"
			},
			{
				"name": "line",
				"salience": 0.00044847032,
				"type": "OTHER"
			},
			{
				"name": "email controversy",
				"salience": 0.00044847032,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.00044847032,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.00044847032,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00044847032,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00044847032,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.000369509,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0v9qg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_Rapids,_Michigan"
				},
				"name": "Grand Rapids",
				"salience": 0.000369509,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fvyg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Raleigh,_North_Carolina"
				},
				"name": "Raleigh",
				"salience": 0.000369509,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/68dca318-2e7c-455f-980c-64a1ff3d86f5.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T20:01:08.775+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Hillary Clinton in lead a day before Election Day 11/07/2016 \nPRESS TV \nDemocratic presidential nominee Hillary Clinton leads her Republican rival by three percentage points nationally as they head into the final day of a tight race for the White House, according to a new poll. \nThe final Bloomberg Politics-Selzer & Co poll released on Monday has Clinton ahead of Trump, 44 percent to 41 percent. \nLibertarian candidate Gary Johnson was at 4 percent and Green Party candidate Jill Stein had 2 percent support. \nClinton also leads Trump by three points in a hypothetical two-way matchup when third-party candidates are not included. \nAnother tracking poll released early on Monday also put Clinton in the lead. \nThe former secretary of state held a four-point lead over the billionaire businessman in the latest ABC News/Washington Post poll. The survey showed 47 percent of likely US voters backed Clinton while 43 percent said they supported Trump. \nThe Clinton campaign received a late break with FBI Director James Comey announcing Sunday that no criminal charges were forthcoming in the probe of Clinton’s newly-found emails. \n“Based on our review, we have not changed our conclusions that we expressed in July,” the FBI chief wrote in a new letter to congressional committee chairmen. \nThe development is a major relief to Clinton, who is spending the final hours of her campaign trying to close Trump’s path to presidency. Donald Trump walks off the stage after holding a rally at Loudoun Fairgrounds in Leesburg, Virginia, early in the morning on November 7, 2016. (Photo by AFP) \nComey sent the presidential race into a frenzy last month when he sent a letter to Congress saying the FBI had discovered emails in a separate probe that could be linked to the investigation into Clinton’s use of a private server when she was secretary of state. \nThe surprise move infuriated Democrats and lifted the presidential hopes of Trump, who has turned the email controversy into a favorite line of attack against Clinton. \nStill, Trump continued to seize on the email issue, insisting that Clinton is “guilty.” \n“Hillary Clinton is guilty. She knows it, the FBI knows it, the people know,” he said Sunday at a rally in Detroit, Michigan. “And now it’s up to the American people to deliver justice at the ballot box on November 8.” \nBoth Clinton and Trump plan to spend the last day of the campaign racing across key battleground states that could determine the results of Tuesday’s election. \nTrump will visit Florida, North Carolina, Pennsylvania, and New Hampshire and finish the day with a rally in Grand Rapids, Michigan. \nClinton is travelling to Pennsylvania and Michigan before closing with a midnight-rally in Raleigh, North Carolina.",
		"thread_title": "Hillary Clinton in lead a day before Election Day",
		"title": "Hillary Clinton in lead a day before Election Day",
		"type": "bs",
		"uuid": "3144f77474072fe03b136d63e83a472b35dec307"
	},
	"-KhIhWN_Bng5yzoU2uRU": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T20:01:08.838+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/043g3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Janet_Reno"
				},
				"name": "Janet Reno",
				"salience": 0.4007113,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06kx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reno,_Nevada"
				},
				"name": "Reno",
				"salience": 0.24621609,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vxbh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jamie_Gorelick"
				},
				"name": "Jamie Gorelick",
				"salience": 0.1308427,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.055610616,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.037379734,
				"type": "PERSON"
			},
			{
				"name": "No. 1 pick",
				"salience": 0.006717067,
				"type": "PERSON"
			},
			{
				"name": "Gabrielle D'Alemberte",
				"salience": 0.0052059283,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06v202",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walter_E._Dellinger_III"
				},
				"name": "Walter Dellinger",
				"salience": 0.0051397034,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.004633279,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c0sl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NPR"
				},
				"name": "NPR",
				"salience": 0.004597755,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.004205553,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0037006794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01rz3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Koresh"
				},
				"name": "David Koresh",
				"salience": 0.0023229367,
				"type": "PERSON"
			},
			{
				"name": "attorney general",
				"salience": 0.0022074608,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0021931832,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0017797517,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0016569559,
				"type": "PERSON"
			},
			{
				"name": "complications",
				"salience": 0.0016188528,
				"type": "OTHER"
			},
			{
				"name": "Parkinson's disease",
				"salience": 0.001495756,
				"type": "OTHER"
			},
			{
				"name": "Margaret Hurchalla",
				"salience": 0.0014912501,
				"type": "PERSON"
			},
			{
				"name": "compound",
				"salience": 0.0014475854,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07lvn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ted_Kaczynski"
				},
				"name": "Theodore Kaczynski",
				"salience": 0.0013837267,
				"type": "PERSON"
			},
			{
				"name": "siege",
				"salience": 0.0012077863,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/039jzz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Waco_siege"
				},
				"name": "Waco",
				"salience": 0.0011668211,
				"type": "LOCATION"
			},
			{
				"name": "deputy attorney general",
				"salience": 0.0011286612,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0010898707,
				"type": "PERSON"
			},
			{
				"name": "NPR. Reno",
				"salience": 0.0010746913,
				"type": "LOCATION"
			},
			{
				"name": "great-uncle",
				"salience": 0.0010237222,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0010191813,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0010146337,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0009774783,
				"type": "LOCATION"
			},
			{
				"name": "prosecutor",
				"salience": 0.00097243744,
				"type": "PERSON"
			},
			{
				"name": "two",
				"salience": 0.0009621049,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.00088326045,
				"type": "ORGANIZATION"
			},
			{
				"name": "job",
				"salience": 0.00088264403,
				"type": "OTHER"
			},
			{
				"name": "confirmation hearing",
				"salience": 0.00088264403,
				"type": "EVENT"
			},
			{
				"name": "pick",
				"salience": 0.0008780916,
				"type": "EVENT"
			},
			{
				"name": "choice",
				"salience": 0.0008780916,
				"type": "OTHER"
			},
			{
				"name": "controversy",
				"salience": 0.0008273576,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0008273576,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.0007698898,
				"type": "PERSON"
			},
			{
				"name": "prosecutor",
				"salience": 0.0007643777,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.0007447274,
				"type": "OTHER"
			},
			{
				"name": "First Female",
				"salience": 0.00072036835,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00071230636,
				"type": "LOCATION"
			},
			{
				"name": "friends",
				"salience": 0.0006901972,
				"type": "PERSON"
			},
			{
				"name": "independence",
				"salience": 0.0006901972,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0006901972,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0006901972,
				"type": "OTHER"
			},
			{
				"name": "tenure",
				"salience": 0.0006901972,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2v0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami"
				},
				"name": "Miami",
				"salience": 0.00062524213,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07x_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cabinet_of_the_United_States"
				},
				"name": "Cabinet",
				"salience": 0.0006000236,
				"type": "ORGANIZATION"
			},
			{
				"name": "person",
				"salience": 0.00059927197,
				"type": "PERSON"
			},
			{
				"name": "tragedy",
				"salience": 0.0005976943,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0005976943,
				"type": "PERSON"
			},
			{
				"name": "accomplishments",
				"salience": 0.0005976943,
				"type": "OTHER"
			},
			{
				"name": "second",
				"salience": 0.0005976943,
				"type": "OTHER"
			},
			{
				"name": "confirmation flames",
				"salience": 0.0005976943,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022r4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dan_Burton"
				},
				"name": "Dan Burton",
				"salience": 0.0005844088,
				"type": "PERSON"
			},
			{
				"name": "passing",
				"salience": 0.0005827322,
				"type": "OTHER"
			},
			{
				"name": "oversight committee",
				"salience": 0.0005528031,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuban",
				"salience": 0.000546636,
				"type": "LOCATION"
			},
			{
				"name": "controversies",
				"salience": 0.0005142878,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00048137747,
				"type": "ORGANIZATION"
			},
			{
				"name": "many",
				"salience": 0.00047917097,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jhy9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami-Dade_County,_Florida"
				},
				"name": "Miami-Dade County",
				"salience": 0.0004705748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "The Associated Press",
				"salience": 0.00045944442,
				"type": "ORGANIZATION"
			},
			{
				"name": "connections",
				"salience": 0.00044652887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0004426219,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.000440013,
				"type": "PERSON"
			},
			{
				"name": "views",
				"salience": 0.00042899567,
				"type": "OTHER"
			},
			{
				"name": "D'Alemberte",
				"salience": 0.00042488912,
				"type": "PERSON"
			},
			{
				"name": "boy",
				"salience": 0.00041298437,
				"type": "PERSON"
			},
			{
				"name": "boy",
				"salience": 0.00041298437,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.0004025191,
				"type": "EVENT"
			},
			{
				"name": "official",
				"salience": 0.0003730322,
				"type": "PERSON"
			},
			{
				"name": "outing",
				"salience": 0.0003714808,
				"type": "OTHER"
			},
			{
				"name": "hearings",
				"salience": 0.00036343705,
				"type": "EVENT"
			},
			{
				"name": "hearing",
				"salience": 0.00036343705,
				"type": "EVENT"
			},
			{
				"name": "compound",
				"salience": 0.000340656,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000340656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018grr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Will_Ferrell"
				},
				"name": "Will Ferrell",
				"salience": 0.00033781515,
				"type": "PERSON"
			},
			{
				"name": "women's health clinics",
				"salience": 0.00033531728,
				"type": "ORGANIZATION"
			},
			{
				"name": "fire",
				"salience": 0.00033357652,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.0003266821,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.00031470746,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.00031470746,
				"type": "PERSON"
			},
			{
				"name": "critics",
				"salience": 0.00031470746,
				"type": "PERSON"
			},
			{
				"name": "attorney general",
				"salience": 0.00031375568,
				"type": "PERSON"
			},
			{
				"name": "mistake",
				"salience": 0.00031308294,
				"type": "EVENT"
			},
			{
				"name": "followers",
				"salience": 0.0003052423,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.00030326517,
				"type": "OTHER"
			},
			{
				"name": "appointment",
				"salience": 0.00028287852,
				"type": "OTHER"
			},
			{
				"name": "vice president",
				"salience": 0.0002822201,
				"type": "PERSON"
			},
			{
				"name": "government official",
				"salience": 0.0002822201,
				"type": "PERSON"
			},
			{
				"name": "warrant",
				"salience": 0.00027231855,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00027231855,
				"type": "WORK_OF_ART"
			},
			{
				"name": "regret",
				"salience": 0.000258849,
				"type": "OTHER"
			},
			{
				"name": "hearing",
				"salience": 0.00025481393,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.00025236607,
				"type": "OTHER"
			},
			{
				"name": "guns",
				"salience": 0.00024604544,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "explosives",
				"salience": 0.00024604544,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00024604544,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00024604544,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00024604544,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.00024604544,
				"type": "EVENT"
			},
			{
				"name": "sets",
				"salience": 0.00024604544,
				"type": "EVENT"
			},
			{
				"name": "deaths",
				"salience": 0.00024604544,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.00024188755,
				"type": "OTHER"
			},
			{
				"name": "contributions",
				"salience": 0.0002388392,
				"type": "OTHER"
			},
			{
				"name": "bombers",
				"salience": 0.0002388392,
				"type": "PERSON"
			},
			{
				"name": "bombers",
				"salience": 0.0002388392,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00023039,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00022992268,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.00022992268,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.00022992268,
				"type": "LOCATION"
			},
			{
				"name": "controversies",
				"salience": 0.00022992268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06kx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reno,_Nevada"
				},
				"name": "Reno",
				"salience": 0.00022600433,
				"type": "LOCATION"
			},
			{
				"name": "negotiations",
				"salience": 0.00022514368,
				"type": "EVENT"
			},
			{
				"name": "reign",
				"salience": 0.00022064376,
				"type": "EVENT"
			},
			{
				"name": "counsels",
				"salience": 0.00022064376,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.00022064376,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.00021342617,
				"type": "ORGANIZATION"
			},
			{
				"name": "course",
				"salience": 0.0002124063,
				"type": "OTHER"
			},
			{
				"name": "great-uncle",
				"salience": 0.0002124063,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.0002124063,
				"type": "OTHER"
			},
			{
				"name": "great-uncle",
				"salience": 0.0002124063,
				"type": "PERSON"
			},
			{
				"name": "agents",
				"salience": 0.0002124063,
				"type": "PERSON"
			},
			{
				"name": "hearing",
				"salience": 0.00020801547,
				"type": "EVENT"
			},
			{
				"name": "newspaper",
				"salience": 0.00020512051,
				"type": "ORGANIZATION"
			},
			{
				"name": "community",
				"salience": 0.00020175823,
				"type": "PERSON"
			},
			{
				"name": "newspaper owners",
				"salience": 0.00020085688,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00019921546,
				"type": "EVENT"
			},
			{
				"name": "pursuit",
				"salience": 0.00019921546,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00019921546,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00019921546,
				"type": "OTHER"
			},
			{
				"name": "attorney general",
				"salience": 0.0001987517,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.00019543043,
				"type": "PERSON"
			},
			{
				"name": "bomber",
				"salience": 0.00019497378,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.00019470393,
				"type": "ORGANIZATION"
			},
			{
				"name": "reputation",
				"salience": 0.00019053537,
				"type": "OTHER"
			},
			{
				"name": "essay",
				"salience": 0.00018936076,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00018686474,
				"type": "ORGANIZATION"
			},
			{
				"name": "brother",
				"salience": 0.00018613889,
				"type": "PERSON"
			},
			{
				"name": "ideas",
				"salience": 0.00018011924,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00018011924,
				"type": "OTHER"
			},
			{
				"name": "disease",
				"salience": 0.00018011924,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00018011924,
				"type": "PERSON"
			},
			{
				"name": "reign",
				"salience": 0.00018011924,
				"type": "OTHER"
			},
			{
				"name": "Parkinson's disease",
				"salience": 0.00018011924,
				"type": "OTHER"
			},
			{
				"name": "life term",
				"salience": 0.00017999341,
				"type": "OTHER"
			},
			{
				"name": "oath",
				"salience": 0.00017693087,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01j3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Branch_Davidians"
				},
				"name": "Branch Davidian",
				"salience": 0.00017488263,
				"type": "LOCATION"
			},
			{
				"name": "result",
				"salience": 0.00017249907,
				"type": "OTHER"
			},
			{
				"name": "solving",
				"salience": 0.00017249907,
				"type": "OTHER"
			},
			{
				"name": "counsel investigation",
				"salience": 0.00017249907,
				"type": "EVENT"
			},
			{
				"name": "example",
				"salience": 0.00017249907,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.00017249907,
				"type": "OTHER"
			},
			{
				"name": "impeachment",
				"salience": 0.00017249907,
				"type": "OTHER"
			},
			{
				"name": "apprehension",
				"salience": 0.00017249907,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00017249907,
				"type": "OTHER"
			},
			{
				"name": "crosswinds",
				"salience": 0.00017249907,
				"type": "OTHER"
			},
			{
				"name": "staffer",
				"salience": 0.00017249907,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0001720975,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.0001720975,
				"type": "EVENT"
			},
			{
				"name": "interview",
				"salience": 0.0001720975,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.00017120894,
				"type": "PERSON"
			},
			{
				"name": "mother",
				"salience": 0.0001660586,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.0001660586,
				"type": "OTHER"
			},
			{
				"name": "sea",
				"salience": 0.0001660586,
				"type": "LOCATION"
			},
			{
				"name": "living parent",
				"salience": 0.0001660586,
				"type": "PERSON"
			},
			{
				"name": "refugee",
				"salience": 0.0001660586,
				"type": "PERSON"
			},
			{
				"name": "removal",
				"salience": 0.0001660586,
				"type": "EVENT"
			},
			{
				"name": "experience",
				"salience": 0.0001660586,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0001660586,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0001660586,
				"type": "PERSON"
			},
			{
				"name": "fishermen",
				"salience": 0.0001660586,
				"type": "PERSON"
			},
			{
				"name": "uproar",
				"salience": 0.0001660586,
				"type": "OTHER"
			},
			{
				"name": "furor",
				"salience": 0.0001660586,
				"type": "OTHER"
			},
			{
				"name": "orders",
				"salience": 0.0001660586,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.0001660586,
				"type": "PERSON"
			},
			{
				"name": "ceremony",
				"salience": 0.0001660586,
				"type": "EVENT"
			},
			{
				"name": "series",
				"salience": 0.0001660586,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03dr00",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton_presidential_campaign,_1992"
				},
				"name": "Clinton-Gore",
				"salience": 0.00016565112,
				"type": "PERSON"
			},
			{
				"name": "manifesto",
				"salience": 0.00016396564,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00016262563,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.00016262563,
				"type": "OTHER"
			},
			{
				"name": "pursuit",
				"salience": 0.00016262563,
				"type": "OTHER"
			},
			{
				"name": "essay",
				"salience": 0.00016262563,
				"type": "WORK_OF_ART"
			},
			{
				"name": "terror campaign",
				"salience": 0.00016262563,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.00016145979,
				"type": "PERSON"
			},
			{
				"name": "secret",
				"salience": 0.00015985852,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00015538279,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00015142874,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dl3mz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Davidian_Seventh-day_Adventist"
				},
				"name": "Davidian",
				"salience": 0.00015142874,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.00014659223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c8wc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eli%C3%A1n_Gonz%C3%A1lez_custody_battle"
				},
				"name": "Elián González",
				"salience": 0.00014608908,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00014583435,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00014564024,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00014564024,
				"type": "OTHER"
			},
			{
				"name": "dress",
				"salience": 0.00014325275,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "dress",
				"salience": 0.00014325275,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "combination",
				"salience": 0.00014261271,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00014232464,
				"type": "LOCATION"
			},
			{
				"name": "abortions",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "hero",
				"salience": 0.0001408152,
				"type": "PERSON"
			},
			{
				"name": "influence",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "humor",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "newspaper journalists",
				"salience": 0.0001408152,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.0001408152,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.0001408152,
				"type": "LOCATION"
			},
			{
				"name": "style",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "table",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "toughness",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "kayak",
				"salience": 0.0001408152,
				"type": "OTHER"
			},
			{
				"name": "lawyers",
				"salience": 0.00013904035,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06kx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reno,_Nevada"
				},
				"name": "Reno",
				"salience": 0.00013781272,
				"type": "LOCATION"
			},
			{
				"name": "least",
				"salience": 0.00013454354,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00013454354,
				"type": "OTHER"
			},
			{
				"name": "high school",
				"salience": 0.00013454354,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00013454354,
				"type": "OTHER"
			},
			{
				"name": "reign",
				"salience": 0.00013454354,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "U.S. Supreme Court",
				"salience": 0.00013072303,
				"type": "ORGANIZATION"
			},
			{
				"name": "end",
				"salience": 0.00012846135,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00012846135,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.00012779806,
				"type": "OTHER"
			},
			{
				"name": "bomber",
				"salience": 0.00012667335,
				"type": "PERSON"
			},
			{
				"name": "integrity",
				"salience": 0.00012533097,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00012533097,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0465sdr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Holder"
				},
				"name": "Eric Holder",
				"salience": 0.00012430748,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05mfw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_City_bombing"
				},
				"name": "Oklahoma City",
				"salience": 0.00012260396,
				"type": "LOCATION"
			},
			{
				"name": "junior high",
				"salience": 0.00012147556,
				"type": "ORGANIZATION"
			},
			{
				"name": "wall",
				"salience": 0.00012147556,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00011702155,
				"type": "PERSON"
			},
			{
				"name": "parody",
				"salience": 0.00011693979,
				"type": "WORK_OF_ART"
			},
			{
				"name": "end",
				"salience": 0.000113157635,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.000113157635,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.000113157635,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.000113157635,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00011265205,
				"type": "PERSON"
			},
			{
				"name": "tension",
				"salience": 0.00011065775,
				"type": "OTHER"
			},
			{
				"name": "figure dancing",
				"salience": 0.000109753324,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/014zws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_Law_School"
				},
				"name": "Harvard Law School",
				"salience": 0.000109042645,
				"type": "ORGANIZATION"
			},
			{
				"name": "attorney general",
				"salience": 0.0001081176,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027gvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida_Legislature"
				},
				"name": "Florida state Legislature",
				"salience": 0.00010616019,
				"type": "ORGANIZATION"
			},
			{
				"name": "displeasure",
				"salience": 0.0001051831,
				"type": "OTHER"
			},
			{
				"name": "downs",
				"salience": 0.0001051831,
				"type": "OTHER"
			},
			{
				"name": "evaluation",
				"salience": 0.0001051831,
				"type": "OTHER"
			},
			{
				"name": "foes",
				"salience": 0.0001051831,
				"type": "PERSON"
			},
			{
				"name": "anybody",
				"salience": 0.0001051831,
				"type": "PERSON"
			},
			{
				"name": "separation",
				"salience": 0.0001051831,
				"type": "EVENT"
			},
			{
				"name": "re-election",
				"salience": 0.0001051831,
				"type": "EVENT"
			},
			{
				"name": "nobody",
				"salience": 0.0001051831,
				"type": "PERSON"
			},
			{
				"name": "close",
				"salience": 0.0001051831,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.00010385729,
				"type": "PERSON"
			},
			{
				"name": "Barry Thumma",
				"salience": 0.00010219618,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00009842038,
				"type": "PERSON"
			},
			{
				"name": "critics",
				"salience": 0.00009798062,
				"type": "PERSON"
			},
			{
				"name": "skit",
				"salience": 0.00009798062,
				"type": "OTHER"
			},
			{
				"name": "skit",
				"salience": 0.00009798062,
				"type": "OTHER"
			},
			{
				"name": "skits",
				"salience": 0.00009798062,
				"type": "WORK_OF_ART"
			},
			{
				"name": "least",
				"salience": 0.00009798062,
				"type": "OTHER"
			},
			{
				"name": "intellect",
				"salience": 0.00009361648,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00009361648,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00009073654,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS News",
				"salience": 0.00008962923,
				"type": "ORGANIZATION"
			},
			{
				"name": "difference",
				"salience": 0.000089592795,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.000089592795,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.00008846347,
				"type": "OTHER"
			},
			{
				"name": "pearls",
				"salience": 0.00008846347,
				"type": "OTHER"
			},
			{
				"name": "parody",
				"salience": 0.00008846347,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wall",
				"salience": 0.00008846347,
				"type": "OTHER"
			},
			{
				"name": "pearls",
				"salience": 0.00008846347,
				"type": "OTHER"
			},
			{
				"name": "tenure",
				"salience": 0.00008846347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.000086659595,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00008452318,
				"type": "WORK_OF_ART"
			},
			{
				"name": "parts",
				"salience": 0.00008452318,
				"type": "LOCATION"
			},
			{
				"name": "job",
				"salience": 0.00008452318,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.000084086714,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00007922303,
				"type": "OTHER"
			},
			{
				"name": "moves",
				"salience": 0.00007659813,
				"type": "OTHER"
			},
			{
				"name": "orchestra",
				"salience": 0.00007659813,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.00007659813,
				"type": "EVENT"
			},
			{
				"name": "signature lines",
				"salience": 0.00007659813,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.00007659813,
				"type": "OTHER"
			},
			{
				"name": "glories",
				"salience": 0.00007659813,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.00007659813,
				"type": "WORK_OF_ART"
			},
			{
				"name": "laugh",
				"salience": 0.00007659813,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.00007659813,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00007318628,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00007318628,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.00007318628,
				"type": "PERSON"
			},
			{
				"name": "values",
				"salience": 0.00007318628,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.00007318628,
				"type": "OTHER"
			},
			{
				"name": "Janet Reno's Dance Party",
				"salience": 0.00006963766,
				"type": "ORGANIZATION"
			},
			{
				"name": "angels",
				"salience": 0.00006833369,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.00006607724,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00006607724,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00006607724,
				"type": "OTHER"
			},
			{
				"name": "-leaders",
				"salience": 0.00006607724,
				"type": "PERSON"
			},
			{
				"name": "responsibility",
				"salience": 0.00006607724,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00006607724,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00006607724,
				"type": "PERSON"
			},
			{
				"name": "steel drum",
				"salience": 0.000065781984,
				"type": "OTHER"
			},
			{
				"name": "Ferrell",
				"salience": 0.00006527083,
				"type": "LOCATION"
			},
			{
				"name": "Reno Time!",
				"salience": 0.000060297145,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.0000601924,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.000059313796,
				"type": "LOCATION"
			},
			{
				"name": "gain",
				"salience": 0.000057214245,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.000057214245,
				"type": "OTHER"
			},
			{
				"name": "work ethic",
				"salience": 0.000057214245,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.000057214245,
				"type": "OTHER"
			},
			{
				"name": "dedication",
				"salience": 0.000057214245,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.000057214245,
				"type": "LOCATION"
			},
			{
				"name": "height",
				"salience": 0.000057214245,
				"type": "OTHER"
			},
			{
				"name": "primary",
				"salience": 0.000057214245,
				"type": "EVENT"
			},
			{
				"name": "hill",
				"salience": 0.00005369789,
				"type": "LOCATION"
			},
			{
				"name": "ups",
				"salience": 0.00005369789,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.000051960997,
				"type": "PERSON"
			},
			{
				"name": "Twist and Shout",
				"salience": 0.000047137815,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.000047137815,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/039cq4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saturday_Night_Live"
				},
				"name": "Saturday Night Live",
				"salience": 0.000047137815,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Florida Democratic Party State Conference",
				"salience": 0.000045038105,
				"type": "EVENT"
			},
			{
				"name": "No. 2",
				"salience": 0.000040663108,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z_27q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lake_Buena_Vista,_Florida"
				},
				"name": "Lake Buena Vista",
				"salience": 0.000035208755,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.000035208755,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.000035208755,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01w3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cornell_University"
				},
				"name": "Cornell",
				"salience": 0.000035208755,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/ap04041306797_wide-3b32aeee98f9b05524d232d32b05fd9f16f2dee9-s800-c85.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T20:01:08.838+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 30.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Janet Reno, First Female US Attorney General, Dies At 78 11/07/2016 \nNPR \nJanet Reno, the first woman to serve as attorney general of the United States, died early Monday from complications of Parkinson’s disease. Reno’s goddaughter Gabrielle D’Alemberte and sister Margaret Hurchalla confirmed her passing to NPR. \nReno spent her final days at home in Miami surrounded by family and friends, D’Alemberte told The Associated Press. She was 78. \nReno served longer in the job than anyone had in 150 years. And her tenure was marked by tragedy and controversy. But she left office widely respected for her independence and accomplishments. \nShe was not President Bill Clinton’s first choice to head the Justice Department, nor his second. But after his No. 1 pick went down in confirmation flames, and his second choice also proved controversial, Clinton finally turned to Reno. \nShe was an unexpected pick. She had no connections to Clinton or Washington. But Clinton wanted a woman, and Reno was a big-time prosecutor, holding the top prosecutor’s job in Miami-Dade County, a position she had been elected to four times over 15 years. \nJamie Gorelick, who would later become deputy attorney general, was assigned to prep Reno for her confirmation hearing. “She was the least air-brushed candidate we have ever had for a Cabinet-level position,” says Gorelick. “She was herself, and she didn’t change herself for Washington.” \nReno arrived at the Justice Department knowing no one, and was immediately plunged into the siege at the Branch Davidian compound outside Waco, Texas. Four federal agents had been killed and 16 wounded while serving a warrant to search for illegal guns. Seven weeks into the siege, pressed by the FBI, Reno authorized a raid on the compound, resulting in 76 deaths, including as many as 25 children and the Davidian leader David Koresh, who ordered his followers to set fire to the compound. \nIn two sets of Waco congressional hearings over the next two years, Reno would successfully quell critics on the right and left. \n“What haunted me,” Reno explained at one hearing, “was that if I did not go in, I might be sitting there 10 days [later] … when [Koresh] came out with explosives, blew himself, some agents and the entire place up.” \nYears later, however, in an interview with NPR shortly before leaving office, her regret was palpable. “We’ll never know whether it was a mistake or not, in one sense,” Reno admitted. “But knowing what I do, I would not do it again. I would try to figure another way.” \n“Waco didn’t make her hesitant: It made her insistent about getting her own information,” observes Walter Dellinger, who served in two top Justice Department jobs under Reno. \nDellinger believes, for instance, that it may have been the Waco experience that led Reno to go personally to Miami in April 2000 to see if there was a way to avoid a forcible removal of 6-year-old Cuban refugee Elián González from the home of a great-uncle so the boy could be returned to his only living parent, in Cuba. \nElián had been rescued at sea after his mother and eight others drowned trying to get to the United States. Rescued by fishermen and brought to the U.S., he was soon turned over to his great-uncle. The Cuban community in Miami was in an uproar over the idea of returning the boy to his father, who lived in Cuba, and the furor soon bled over to Congress. \nBut when negotiations with the great-uncle failed, armed federal agents, acting on Reno’s orders, raided the home, removed Elián, and turned him over to his father, who had come to the U.S. to receive his son. When the U.S. Supreme Court refused to intervene, the two returned to their home in Cuba. \nJanet Reno takes the oath as attorney general during a ceremony at the White House on March 12, 1993, while President Bill Clinton watches. \nBarry Thumma/AP \nOver the course of time, Reno would become embroiled in many controversies. She sought the appointment of a series of independent counsels to investigate four fellow Cabinet members and President Clinton himself. But she refused to authorize an independent counsel investigation of contributions to the Clinton-Gore campaign after Justice Department lawyers concluded no crime had been committed by either the president or vice president. \nThe decision so infuriated Republicans that some called for her impeachment. “This is the most politicized Justice Department in the history of the United States,” railed Dan Burton, the Republican chairman of a key House oversight committee. \nAt 6 feet 2 inches, however, Reno stood tall in the political crosswinds. Gorelick observes that when members of Congress, like Burton, were unhappy with a government official, they threatened to call that official to testify. But Reno, who had served as a staffer in the Florida state Legislature, always said, “Fine, I’ll be there.” As a result, says Gorelick, “eventually all those who were threatening her with a hearing stopped doing that, because she prevailed in every outing that I can recall — she just went in there and laid out her views and bested those who would challenge her.” \nThe controversies that the Justice Department faced during Reno’s reign often eclipsed the many things that went well: the quick apprehension and successful prosecution of the Oklahoma City bombers, for example; the pursuit of bombers of women’s health clinics that provide abortions; and the solving of the so-called Unabomber case. \nAfter nearly two decades of fruitless pursuit, the FBI still had no idea as to the identity of the man dubbed the Unabomber, who had killed three people and injured 23. Then, in 1995, the bomber sent a letter to The New York Times offering to cease his terror campaign if the Times or the Washington Post would publish his 35,000-word manifesto against modern industry and technology. Neither newspaper was inclined to do that initially, but Reno, the daughter of two newspaper journalists, persuaded the newspaper owners to jointly publish the essay in the interests of public safety. \nIt paid off. The Unabomber’s brother recognized the style and ideas in the essay and tipped off the FBI, ending the bomber’s long reign of terror. Theodore Kaczynski, aka the Unabomber, is now serving a life term in a maximum security federal prison. \nIn 1995 Reno was diagnosed with Parkinson’s disease. She did not slow down, but her hands sometimes shook so hard you could hear them knocking against the table at a congressional hearing. She even joked about the disease, claiming that “shaking sometimes helps,” as in playing a steel drum or balancing her kayak. \nThat combination of toughness and self-deprecating humor, plus her determination to protect the Justice Department from improper influence, made her a hero to many who worked for her. \n“Janet Reno led with her values,” says former Deputy Attorney General Gorelick, the department’s No. 2 official. “And that meant that if she decided that a certain path was the right thing to do, the people around her believed her and would charge up any hill behind her. … I’d never seen that before in quite the same way.” \nFlorida gubernatorial candidate and former U.S. Attorney General Janet Reno speaks at the Florida Democratic Party State Conference on April 13, 2002, in Lake Buena Vista, Fla. She lost the Democratic primary. \nReno won enormous respect inside the department as well, because of her work ethic and dedication to understanding issues in the many parts of the Justice Department — from national security, to environmental questions, to the generally obscure field of Indian law. \nU.S. Attorney General Loretta Lynch called her “one of the most effective, decisive and well-respected-leaders in [the department’s] proud history” who “never shied from criticism or shirked responsibility.” And former Attorney General Eric Holder said that “in a city where too many compromise their values for short term political gain, Janet Reno stood out as a person of integrity and of enduring values.” \nFormer Solicitor General Dellinger believes that Reno was prepared for the attorney general’s job early in life by her intellect and ungainly height. “This is a woman that went to Cornell and Harvard Law School at a time when very few women went to Harvard Law School, went through junior high and high school being twice as tall as anybody else and probably twice as smart … and that’s really, really tough.” \nThere were, of course, ups and downs in the eight years of Reno’s reign. But she said she always took the long view of her job. \n“If the end brings me out right, what people said about me won’t make any difference, and if the end brings me out wrong, 10 angels saying I was right won’t make any difference,” she said in an interview with NPR in 1997. \nPresident Clinton made little secret of his frequent displeasure with Reno and the wall of separation she erected between the Justice Department and the White House. Still, he never asked her to resign. Reno was the last Cabinet member he reappointed after his re-election in 1996. \n“It was actually quite wonderful,” said Dellinger. “She just decided to stay, and it turns out that nobody could fire her.” \nThe tension between Clinton and his attorney general was apparent even as Clinton’s time in office drew to a close. In an interview with CBS News’ 60 Minutes , Clinton went out of his way to praise friends and foes alike, but when it came to his evaluation of Reno, he was tepid, to say the least. \n“Good woman,” he said. “Tried really hard to do a good job. She’s a good person.” \n“At least he didn’t say I was a bad person,” replied Reno, with a laugh. “I’ll take what I can get!” \nIndeed, by the end of her tenure, Janet Reno had outlasted her critics and earned such a reputation for integrity and independence that comedian Will Ferrell’s parody of her became one of the iconic skits on NBC’s Saturday Night Live . The recurring skit was inspired by reports that Reno had cut quite a figure dancing at a Justice Department party. \nOn the last episode of the “Janet Reno’s Dance Party” parody, Ferrell, wearing a blue dress and pearls, reminisces about past glories and laments that the end of the party is near. Then, suddenly, the real Janet Reno comes crashing through the wall of the set, wearing the same blue dress and pearls as Ferrell, to deliver one of Ferrell’s signature lines: “It’s Reno Time!” \n“Oh, Janet,” he says to the real Reno, as he mourns the end of the skit’s run, “what do you do when you get sad?” \n“I just dance,” Reno replies, commanding the orchestra, “Now, hit it!” as she breaks out her best moves to “Twist and Shout.” It was her last day in office.",
		"thread_title": "Janet Reno, First Female US Attorney General, Dies At 78",
		"title": "Janet Reno, First Female US Attorney General, Dies At 78",
		"type": "bs",
		"uuid": "a10a5bc206ea03312e6c21a8a1b4ab8004a84b92"
	},
	"-KhIhXexQR9lz15F0WRd": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T20:01:08.914+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "buildings",
				"salience": 0.11405419,
				"type": "LOCATION"
			},
			{
				"name": "quake",
				"salience": 0.039546702,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0z96c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cushing,_Oklahoma"
				},
				"name": "Cushing",
				"salience": 0.038019672,
				"type": "LOCATION"
			},
			{
				"name": "Jeremy Frazier",
				"salience": 0.036209177,
				"type": "PERSON"
			},
			{
				"name": "Damage",
				"salience": 0.03270571,
				"type": "OTHER"
			},
			{
				"name": "Oklahoma city",
				"salience": 0.031380564,
				"type": "LOCATION"
			},
			{
				"name": "Quake Near Oklahoma Oil Hub",
				"salience": 0.025356349,
				"type": "EVENT"
			},
			{
				"name": "earthquake",
				"salience": 0.025347786,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.02459179,
				"type": "LOCATION"
			},
			{
				"name": "magnitude",
				"salience": 0.02459179,
				"type": "OTHER"
			},
			{
				"name": "Steve Spears",
				"salience": 0.023324504,
				"type": "PERSON"
			},
			{
				"name": "Cindy Roe",
				"salience": 0.023016408,
				"type": "PERSON"
			},
			{
				"name": "building facades",
				"salience": 0.022974476,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.02222179,
				"type": "LOCATION"
			},
			{
				"name": "oil hubs",
				"salience": 0.019261448,
				"type": "LOCATION"
			},
			{
				"name": "infrastructure",
				"salience": 0.019261448,
				"type": "OTHER"
			},
			{
				"name": "windows",
				"salience": 0.019261448,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.018782102,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05mph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma"
				},
				"name": "Oklahoma",
				"salience": 0.016147634,
				"type": "LOCATION"
			},
			{
				"name": "earthquake",
				"salience": 0.016107628,
				"type": "EVENT"
			},
			{
				"name": "Megan Gustafson",
				"salience": 0.013240001,
				"type": "PERSON"
			},
			{
				"name": "quake",
				"salience": 0.012403513,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09d5h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS"
				},
				"name": "CBS",
				"salience": 0.0118843,
				"type": "ORGANIZATION"
			},
			{
				"name": "ground",
				"salience": 0.011388074,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.010224188,
				"type": "PERSON"
			},
			{
				"name": "debris",
				"salience": 0.009865844,
				"type": "OTHER"
			},
			{
				"name": "bricks",
				"salience": 0.009865844,
				"type": "OTHER"
			},
			{
				"name": "piles",
				"salience": 0.009865844,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.00881735,
				"type": "OTHER"
			},
			{
				"name": "television news footage",
				"salience": 0.008265058,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Jonathan Gillespie",
				"salience": 0.0082315,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.00819259,
				"type": "OTHER"
			},
			{
				"name": "trailer",
				"salience": 0.008144725,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sun",
				"salience": 0.0077584605,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0067600794,
				"type": "OTHER"
			},
			{
				"name": "earthquakes",
				"salience": 0.006649938,
				"type": "EVENT"
			},
			{
				"name": "oil",
				"salience": 0.006342563,
				"type": "OTHER"
			},
			{
				"name": "magnitude",
				"salience": 0.0052012457,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0049887444,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0049259635,
				"type": "OTHER"
			},
			{
				"name": "quake",
				"salience": 0.004802758,
				"type": "EVENT"
			},
			{
				"name": "wastewater",
				"salience": 0.0046968157,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0046968157,
				"type": "PERSON"
			},
			{
				"name": "downtown",
				"salience": 0.0046968157,
				"type": "LOCATION"
			},
			{
				"name": "injection",
				"salience": 0.0046968157,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0046826284,
				"type": "OTHER"
			},
			{
				"name": "quakes",
				"salience": 0.0046826284,
				"type": "OTHER"
			},
			{
				"name": "earthquake",
				"salience": 0.004664992,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.0044910554,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0044910554,
				"type": "LOCATION"
			},
			{
				"name": "parts",
				"salience": 0.0040676915,
				"type": "OTHER"
			},
			{
				"name": "aftershocks",
				"salience": 0.0040676915,
				"type": "OTHER"
			},
			{
				"name": "wells",
				"salience": 0.0040676915,
				"type": "LOCATION"
			},
			{
				"name": "shutdown",
				"salience": 0.0040676915,
				"type": "EVENT"
			},
			{
				"name": "gas",
				"salience": 0.0040676915,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0040676915,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.0040676915,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0038014178,
				"type": "PERSON"
			},
			{
				"name": "magnitude",
				"salience": 0.0036481556,
				"type": "OTHER"
			},
			{
				"name": "crude oil",
				"salience": 0.0036328987,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0035120847,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0035120847,
				"type": "LOCATION"
			},
			{
				"name": "geologists",
				"salience": 0.0035120847,
				"type": "PERSON"
			},
			{
				"name": "oil storage terminal",
				"salience": 0.0034654434,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0032338938,
				"type": "LOCATION"
			},
			{
				"name": "foundations",
				"salience": 0.0031973952,
				"type": "ORGANIZATION"
			},
			{
				"name": "lights",
				"salience": 0.0031973952,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0030393559,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0029786534,
				"type": "LOCATION"
			},
			{
				"name": "damage",
				"salience": 0.0029675774,
				"type": "OTHER"
			},
			{
				"name": "quakes",
				"salience": 0.0029675774,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0028655266,
				"type": "OTHER"
			},
			{
				"name": "radius",
				"salience": 0.0028527344,
				"type": "OTHER"
			},
			{
				"name": "reading",
				"salience": 0.0028527344,
				"type": "OTHER"
			},
			{
				"name": "epicenter",
				"salience": 0.0028527344,
				"type": "LOCATION"
			},
			{
				"name": "bridge",
				"salience": 0.0028527344,
				"type": "OTHER"
			},
			{
				"name": "highway",
				"salience": 0.0028527344,
				"type": "LOCATION"
			},
			{
				"name": "earthquakes",
				"salience": 0.0028460983,
				"type": "EVENT"
			},
			{
				"name": "earthquakes",
				"salience": 0.0028460983,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0fvzg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_City"
				},
				"name": "Oklahoma City",
				"salience": 0.0027653445,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.0027463024,
				"type": "OTHER"
			},
			{
				"name": "news conference",
				"salience": 0.0027463024,
				"type": "EVENT"
			},
			{
				"name": "classes",
				"salience": 0.0027463024,
				"type": "OTHER"
			},
			{
				"name": "daylight",
				"salience": 0.0027463024,
				"type": "OTHER"
			},
			{
				"name": "gawkers",
				"salience": 0.0027463024,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.002711714,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0026895683,
				"type": "LOCATION"
			},
			{
				"name": "barrels",
				"salience": 0.0026895683,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0026895683,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.0025698661,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06q20f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mary_Fallin"
				},
				"name": "Mary Fallin",
				"salience": 0.002363879,
				"type": "PERSON"
			},
			{
				"name": "countryside",
				"salience": 0.0023290846,
				"type": "LOCATION"
			},
			{
				"name": "tank farms",
				"salience": 0.0023290846,
				"type": "ORGANIZATION"
			},
			{
				"name": "earthquake",
				"salience": 0.0020731178,
				"type": "EVENT"
			},
			{
				"name": "police barricade downtown",
				"salience": 0.0020093792,
				"type": "LOCATION"
			},
			{
				"name": "data",
				"salience": 0.0020093792,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01b69s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Geological_Survey"
				},
				"name": "U.S. Geological Survey",
				"salience": 0.0019610522,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09_b17",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_Department_of_Transportation"
				},
				"name": "Oklahoma Department of Transportation",
				"salience": 0.0017561605,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.0017561605,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.0017561605,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0017561605,
				"type": "LOCATION"
			},
			{
				"name": "bit",
				"salience": 0.0017400046,
				"type": "OTHER"
			},
			{
				"name": "Cushing Public School District",
				"salience": 0.0016906157,
				"type": "ORGANIZATION"
			},
			{
				"name": "geologists",
				"salience": 0.0016209086,
				"type": "PERSON"
			},
			{
				"name": "city manager",
				"salience": 0.0016209086,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0016209086,
				"type": "OTHER"
			},
			{
				"name": "quake",
				"salience": 0.0016148785,
				"type": "EVENT"
			},
			{
				"name": "damage",
				"salience": 0.0016148785,
				"type": "OTHER"
			},
			{
				"name": "wastewater injections",
				"salience": 0.0014635267,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ptrz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Energy_Information_Administration"
				},
				"name": "U.S. Energy Information Administration",
				"salience": 0.0014336952,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pipeline Crossroads of the World",
				"salience": 0.0014336952,
				"type": "ORGANIZATION"
			},
			{
				"name": "building",
				"salience": 0.0013983636,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.0013332356,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.0012672952,
				"type": "LOCATION"
			},
			{
				"name": "work",
				"salience": 0.0012672952,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0012672952,
				"type": "LOCATION"
			},
			{
				"name": "well operators",
				"salience": 0.0012672952,
				"type": "ORGANIZATION"
			},
			{
				"name": "fault",
				"salience": 0.0012672952,
				"type": "OTHER"
			},
			{
				"name": "temblor",
				"salience": 0.0012672952,
				"type": "EVENT"
			},
			{
				"name": "record",
				"salience": 0.0012672952,
				"type": "OTHER"
			},
			{
				"name": "train",
				"salience": 0.0012569403,
				"type": "OTHER"
			},
			{
				"name": "pipeline companies",
				"salience": 0.001093281,
				"type": "ORGANIZATION"
			},
			{
				"name": "companies",
				"salience": 0.001093281,
				"type": "ORGANIZATION"
			},
			{
				"name": "storage tanks",
				"salience": 0.001093281,
				"type": "OTHER"
			},
			{
				"name": "oil storage terminal",
				"salience": 0.001093281,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fhkg0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_Corporation_Commission"
				},
				"name": "Oklahoma Corporation Commission",
				"salience": 0.0010799426,
				"type": "ORGANIZATION"
			},
			{
				"name": "trouble",
				"salience": 0.00094667566,
				"type": "OTHER"
			},
			{
				"name": "co-workers",
				"salience": 0.00094667566,
				"type": "PERSON"
			},
			{
				"name": "volume",
				"salience": 0.00088850735,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mxr5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pawnee_County,_Oklahoma"
				},
				"name": "Pawnee",
				"salience": 0.0007799844,
				"type": "LOCATION"
			},
			{
				"name": "Cushing McDonald's",
				"salience": 0.00058262644,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/oklahoma-quake.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T20:01:08.914+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "5.0 Quake Near Oklahoma Oil Hub Causes Substantial Damage 11/07/2016 \nCBS \nA magnitude 5.0 earthquake centered near one of the world’s key oil hubs brought down building facades and shattered windows in a central Oklahoma city, rendering century-old buildings unsafe and raising concerns about key infrastructure. \nAs the sun rose Monday, television news footage showed widespread, substantial damage to buildings, with piles of bricks and other debris littering the ground following the earthquake the previous evening. Cushing Assistant City Manager Jeremy Frazier told a news conference late Sunday that a few minor injuries had been reported. He said the damage appeared to be contained downtown. \nOklahoma has had thousands of earthquakes in recent years, with nearly all traced to the underground injection of wastewater left over from oil and gas production. Sunday’s quake was centered 1 mile west of Cushing and about 25 miles south of where a magnitude 4.3 quake forced a shutdown of several wells last week. \nFearing aftershocks, police cordoned off older parts of the city to keep gawkers away late Sunday, and geologists confirmed that several small quakes have rumbled the area. Frazier said an assisted living community had been evacuated after damage was reported. The Cushing Public School District canceled Monday classes. \n“Stay out of the area,” said City Manager Steve Spears, who noted that while some damage was superficial, compromised foundations and other potential problems would be difficult to assess until daylight in the city of 7,900 about 50 miles northeast of Oklahoma City. \nThe Oklahoma Department of Transportation reported Sunday night that no highway or bridge damage was found within a 15-mile radius of the earthquake’s epicenter. \nThe quake struck at 7:44 p.m. Sunday and was felt as far away as Iowa, Illinois and Texas. The U.S. Geological Survey initially said Sunday’s quake was of magnitude 5.3 but later lowered the reading to 5.0. \n“I thought my whole trailer was going to tip over, it was shaking it so bad,” said Cushing resident Cindy Roe, 50. “It was loud and all the lights went out and you could hear things falling on the ground. \n“It was awful and I don’t want to have another one.” \nCushing’s oil storage terminal is one of the world’s largest. As of Oct. 28, tank farms in the countryside around Cushing held 58.5 million barrels of crude oil, according to data from the U.S. Energy Information Administration. The community bills itself as the “Pipeline Crossroads of the World.” \nFrazier said two pipeline companies had reported no trouble as of late Sunday but that the community hadn’t heard from all companies. Gov. Mary Fallin tweeted that no damage was reported at the storage tanks at Cushing’s oil storage terminal \nMegan Gustafson and Jonathan Gillespie were working at a Cushing McDonald’s when the quake hit. \n“It felt like a train was going right through the building, actually,” Gustafson, 17, said Sunday night as she and her co-workers stood behind a police barricade downtown, looking for damage. “I kind of freaked out and was hyperventilating a bit.” \nGillespie said the building shook for about 10 seconds, but that he wasn’t as alarmed as Gustafson because he lives in an area that has experienced multiple earthquakes, especially in recent years. \n“I didn’t think it was anything new,” he said. \nAccording to USGS data, there have been about two dozen earthquakes in Oklahoma in the past week. When particularly strong quakes hit, the Oklahoma Corporation Commission directs well operators to cease wastewater injections or reduce volume. \nA 5.8 earthquake — a record for Oklahoma — hit Pawnee on Sept. 3. Shortly afterward, geologists speculated on whether the temblor occurred on a previously unknown fault. \n“I was at home doing some work in my office and, basically, you could feel the whole house sway some,” Spears, the Cushing city manager, said Sunday night. “It’s beginning to become normal.”",
		"thread_title": "5.0 Quake Near Oklahoma Oil Hub Causes Substantial Damage",
		"title": "5.0 Quake Near Oklahoma Oil Hub Causes Substantial Damage",
		"type": "bs",
		"uuid": "8b3238a12ba1ecfb62a4a07861d126a25ef458e7"
	},
	"-KhIhY2fq6hAzj7cQQMc": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T21:48:27.296+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05fm_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sheldon_Adelson"
				},
				"name": "Sheldon Adelson",
				"salience": 0.056775823,
				"type": "PERSON"
			},
			{
				"name": "Derek Peterson",
				"salience": 0.05465423,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/029l86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas_Strip"
				},
				"name": "Las Vegas",
				"salience": 0.04548134,
				"type": "LOCATION"
			},
			{
				"name": "casinos",
				"salience": 0.035402242,
				"type": "LOCATION"
			},
			{
				"name": "proposal",
				"salience": 0.028165726,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/029l86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas_Strip"
				},
				"name": "Las Vegas Strip",
				"salience": 0.025825873,
				"type": "LOCATION"
			},
			{
				"name": "casino industry",
				"salience": 0.022425748,
				"type": "OTHER"
			},
			{
				"name": "marijuana",
				"salience": 0.022342209,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "catchphrase",
				"salience": 0.020064095,
				"type": "WORK_OF_ART"
			},
			{
				"name": "doctor",
				"salience": 0.017279152,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.016322935,
				"type": "LOCATION"
			},
			{
				"name": "brothels",
				"salience": 0.016187407,
				"type": "LOCATION"
			},
			{
				"name": "passage",
				"salience": 0.0146308355,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.014511671,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ftj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Amsterdam"
				},
				"name": "New Amsterdam",
				"salience": 0.014280368,
				"type": "LOCATION"
			},
			{
				"name": "nightclubs",
				"salience": 0.01185362,
				"type": "LOCATION"
			},
			{
				"name": "pot",
				"salience": 0.01185362,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "state ballot",
				"salience": 0.01185362,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.01185362,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.010811286,
				"type": "LOCATION"
			},
			{
				"name": "entrepreneurs",
				"salience": 0.0102676535,
				"type": "PERSON"
			},
			{
				"name": "cannabis district",
				"salience": 0.0102676535,
				"type": "OTHER"
			},
			{
				"name": "vice",
				"salience": 0.0102676535,
				"type": "PERSON"
			},
			{
				"name": "tourists",
				"salience": 0.009956081,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hvtz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bonnie_and_Clyde"
				},
				"name": "Clyde Barrow",
				"salience": 0.009788897,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.009787623,
				"type": "LOCATION"
			},
			{
				"name": "marijuana",
				"salience": 0.009223051,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "game changer",
				"salience": 0.00915019,
				"type": "EVENT"
			},
			{
				"name": "cocktails",
				"salience": 0.009103043,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.008544732,
				"type": "EVENT"
			},
			{
				"name": "drug",
				"salience": 0.008536143,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "framework",
				"salience": 0.00838532,
				"type": "OTHER"
			},
			{
				"name": "customer base",
				"salience": 0.0076244846,
				"type": "OTHER"
			},
			{
				"name": "casinos",
				"salience": 0.007409647,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amsterdam"
				},
				"name": "Amsterdam",
				"salience": 0.0073026647,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0071887607,
				"type": "PERSON"
			},
			{
				"name": "tourists",
				"salience": 0.006598637,
				"type": "PERSON"
			},
			{
				"name": "marijuana",
				"salience": 0.006469938,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "marijuana",
				"salience": 0.0062286933,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "state study",
				"salience": 0.0061475863,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0060206577,
				"type": "PERSON"
			},
			{
				"name": "marijuana",
				"salience": 0.0059964308,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "company",
				"salience": 0.005856335,
				"type": "ORGANIZATION"
			},
			{
				"name": "visitors",
				"salience": 0.005856335,
				"type": "PERSON"
			},
			{
				"name": "proposals",
				"salience": 0.0057644728,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0053718793,
				"type": "OTHER"
			},
			{
				"name": "Virginia Valentine",
				"salience": 0.0053594233,
				"type": "PERSON"
			},
			{
				"name": "marijuana",
				"salience": 0.0052829,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "market",
				"salience": 0.005248056,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0052161817,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pot",
				"salience": 0.0048856693,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "nightclub",
				"salience": 0.0048856693,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0048856693,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0046280073,
				"type": "LOCATION"
			},
			{
				"name": "hangovers",
				"salience": 0.0042309924,
				"type": "OTHER"
			},
			{
				"name": "alternative",
				"salience": 0.0042309924,
				"type": "OTHER"
			},
			{
				"name": "dayclub",
				"salience": 0.0042309924,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0042309924,
				"type": "LOCATION"
			},
			{
				"name": "marijuana industry",
				"salience": 0.004218204,
				"type": "OTHER"
			},
			{
				"name": "casino industry",
				"salience": 0.004218204,
				"type": "OTHER"
			},
			{
				"name": "waitresses",
				"salience": 0.0041250964,
				"type": "PERSON"
			},
			{
				"name": "marijuana",
				"salience": 0.0039472254,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/08chth",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas_Convention_and_Visitors_Authority"
				},
				"name": "Las Vegas Convention and Visitors Authority",
				"salience": 0.003931957,
				"type": "ORGANIZATION"
			},
			{
				"name": "tourism bureau",
				"salience": 0.0038957973,
				"type": "ORGANIZATION"
			},
			{
				"name": "tourism",
				"salience": 0.0037785862,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0037748828,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0037619357,
				"type": "LOCATION"
			},
			{
				"name": "marijuana",
				"salience": 0.0037048375,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "proponents",
				"salience": 0.0036528846,
				"type": "PERSON"
			},
			{
				"name": "visitors",
				"salience": 0.0036406624,
				"type": "PERSON"
			},
			{
				"name": "Nevada Resort Association",
				"salience": 0.0034889556,
				"type": "ORGANIZATION"
			},
			{
				"name": "donations",
				"salience": 0.0034261623,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0034261623,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.0034261623,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0034261623,
				"type": "PERSON"
			},
			{
				"name": "extent",
				"salience": 0.0034261623,
				"type": "OTHER"
			},
			{
				"name": "initiative",
				"salience": 0.0032983168,
				"type": "OTHER"
			},
			{
				"name": "casino owners",
				"salience": 0.0032983168,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.0032983168,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003276961,
				"type": "PERSON"
			},
			{
				"name": "bread",
				"salience": 0.00316106,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "efforts",
				"salience": 0.0029669122,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.0029669122,
				"type": "OTHER"
			},
			{
				"name": "drug addiction",
				"salience": 0.0029669122,
				"type": "OTHER"
			},
			{
				"name": "drug overdose",
				"salience": 0.0029669122,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.0029669122,
				"type": "PERSON"
			},
			{
				"name": "share",
				"salience": 0.0029669122,
				"type": "OTHER"
			},
			{
				"name": "casino operators",
				"salience": 0.0029669122,
				"type": "ORGANIZATION"
			},
			{
				"name": "marijuana edibles",
				"salience": 0.0029669122,
				"type": "OTHER"
			},
			{
				"name": "casino companies",
				"salience": 0.0029348787,
				"type": "ORGANIZATION"
			},
			{
				"name": "marijuana",
				"salience": 0.002875166,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "opinion",
				"salience": 0.0028561912,
				"type": "OTHER"
			},
			{
				"name": "substance",
				"salience": 0.0028561912,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0028561912,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0028561912,
				"type": "OTHER"
			},
			{
				"name": "fortune",
				"salience": 0.0028561912,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0028561912,
				"type": "OTHER"
			},
			{
				"name": "measure",
				"salience": 0.0028561912,
				"type": "OTHER"
			},
			{
				"name": "clubs",
				"salience": 0.0028561912,
				"type": "LOCATION"
			},
			{
				"name": "gambling regulators",
				"salience": 0.0028561912,
				"type": "ORGANIZATION"
			},
			{
				"name": "buildings",
				"salience": 0.0028376959,
				"type": "LOCATION"
			},
			{
				"name": "ski states",
				"salience": 0.0028229768,
				"type": "LOCATION"
			},
			{
				"name": "donations",
				"salience": 0.0027971717,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0027971717,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0027971717,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0027846806,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.002692781,
				"type": "OTHER"
			},
			{
				"name": "Blum",
				"salience": 0.0026046676,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0026046676,
				"type": "LOCATION"
			},
			{
				"name": "complaints",
				"salience": 0.0025051432,
				"type": "OTHER"
			},
			{
				"name": "tourism record",
				"salience": 0.0024530883,
				"type": "OTHER"
			},
			{
				"name": "department",
				"salience": 0.0024221817,
				"type": "ORGANIZATION"
			},
			{
				"name": "butter",
				"salience": 0.0024221817,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "potential",
				"salience": 0.0024221817,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0024221817,
				"type": "OTHER"
			},
			{
				"name": "amenities",
				"salience": 0.0024221817,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0024221817,
				"type": "LOCATION"
			},
			{
				"name": "science",
				"salience": 0.0024221817,
				"type": "OTHER"
			},
			{
				"name": "fray",
				"salience": 0.0022164618,
				"type": "PERSON"
			},
			{
				"name": "ballot initiative",
				"salience": 0.0021706545,
				"type": "OTHER"
			},
			{
				"name": "marijuana",
				"salience": 0.0021479095,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "marijuana",
				"salience": 0.0021479095,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "places",
				"salience": 0.002119912,
				"type": "LOCATION"
			},
			{
				"name": "Marijuana opponents",
				"salience": 0.002089633,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.002089633,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.002089633,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.002089633,
				"type": "OTHER"
			},
			{
				"name": "consumption",
				"salience": 0.002089633,
				"type": "OTHER"
			},
			{
				"name": "marijuana industry",
				"salience": 0.0019714346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "Massachusetts",
				"salience": 0.0018262562,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0018262562,
				"type": "LOCATION"
			},
			{
				"name": "snow",
				"salience": 0.0018094527,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0018094527,
				"type": "OTHER"
			},
			{
				"name": "factors",
				"salience": 0.0018094527,
				"type": "OTHER"
			},
			{
				"name": "panhandling",
				"salience": 0.0018094527,
				"type": "OTHER"
			},
			{
				"name": "downtown corridor",
				"salience": 0.0018094527,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04v0y7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas_Sands"
				},
				"name": "Las Vegas Sands",
				"salience": 0.0017580839,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cv3w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Las_Vegas"
				},
				"name": "Sin City",
				"salience": 0.0017217457,
				"type": "LOCATION"
			},
			{
				"name": "municipalities",
				"salience": 0.0015939412,
				"type": "LOCATION"
			},
			{
				"name": "dispensaries",
				"salience": 0.0015809167,
				"type": "OTHER"
			},
			{
				"name": "tourism",
				"salience": 0.001535944,
				"type": "OTHER"
			},
			{
				"name": "convention business",
				"salience": 0.0015218992,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0015218992,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0015218992,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0015218992,
				"type": "OTHER"
			},
			{
				"name": "reputation",
				"salience": 0.0015218992,
				"type": "OTHER"
			},
			{
				"name": "consumption",
				"salience": 0.0015218992,
				"type": "OTHER"
			},
			{
				"name": "marijuana dispensaries",
				"salience": 0.0015218992,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.0015218992,
				"type": "ORGANIZATION"
			},
			{
				"name": "University of Texas-Rio Grande Valley",
				"salience": 0.0014908736,
				"type": "LOCATION"
			},
			{
				"name": "research",
				"salience": 0.0014585395,
				"type": "OTHER"
			},
			{
				"name": "casino industry",
				"salience": 0.001454128,
				"type": "LOCATION"
			},
			{
				"name": "Visit Denver",
				"salience": 0.0014244834,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colorado",
				"salience": 0.0013742599,
				"type": "LOCATION"
			},
			{
				"name": "competitor",
				"salience": 0.0013629653,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0013346359,
				"type": "OTHER"
			},
			{
				"name": "marijuana store",
				"salience": 0.0013178161,
				"type": "LOCATION"
			},
			{
				"name": "result",
				"salience": 0.0013178161,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0013178161,
				"type": "PERSON"
			},
			{
				"name": "practice",
				"salience": 0.0013178161,
				"type": "OTHER"
			},
			{
				"name": "perception",
				"salience": 0.0013178161,
				"type": "OTHER"
			},
			{
				"name": "blanket bans",
				"salience": 0.0013178161,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0012686173,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02cl1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denver"
				},
				"name": "Denver",
				"salience": 0.0012660599,
				"type": "LOCATION"
			},
			{
				"name": "governments",
				"salience": 0.0012212548,
				"type": "ORGANIZATION"
			},
			{
				"name": "millennials",
				"salience": 0.0011368458,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.0011368458,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0011368458,
				"type": "OTHER"
			},
			{
				"name": "entertainment",
				"salience": 0.0011368458,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.0011368458,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.0010622222,
				"type": "LOCATION"
			},
			{
				"name": "beverage",
				"salience": 0.0009843846,
				"type": "OTHER"
			},
			{
				"name": "recreation",
				"salience": 0.0009843846,
				"type": "OTHER"
			},
			{
				"name": "difficulties",
				"salience": 0.0009843846,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0009843846,
				"type": "OTHER"
			},
			{
				"name": "entertainment dollars",
				"salience": 0.0009843846,
				"type": "OTHER"
			},
			{
				"name": "alcohol",
				"salience": 0.0009843846,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sales",
				"salience": 0.0009843846,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/Las-Vegas-HD-Pics-04173-990x556.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T21:48:27.296+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Las Vegas May Become the New Amsterdam 11/07/2016 \nHIGH TIMES \nNevada already has legal brothels, round-the-clock casinos and a coy catchphrase declaring that “what happens in Vegas, stays in Vegas.” If voters approve, the state could soon add another vice in the form of recreational marijuana. \nA proposal on the Nov. 8 state ballot would legalize pot, and entrepreneurs hope its passage could someday allow the drug at Las Vegas’ glamorous nightclubs and perhaps provide the framework for a future Amsterdam-style cannabis district. \n“I really think this would be the third-largest market in the country,” said Derek Peterson, whose company operates medical marijuana dispensaries called Blum. He predicts that only California and New York would offer a bigger customer base than Las Vegas and its 42 million tourists a year. “I think it should be able to fit in really well with the whole dayclub/nightclub thing.” \nNevada has allowed medical marijuana since 2000, and Peterson sees recreational pot as an alternative for visitors tired of cocktails that can top $15 apiece and inflict hangovers. But before waitresses begin delivering high-grade marijuana at clubs along the Las Vegas Strip, weed proponents will have to win over not just voters, who narrowly support the initiative in polls, but a risk-averse casino industry. \nThe Nevada Resort Association came out against the measure, pointing to an opinion from gambling regulators that casino owners should avoid the marijuana industry because the substance remains illegal under federal law. Las Vegas Sands owner Sheldon Adelson has bankrolled most of the opposition, pouring $2 million of his fortune into a campaign that raises the possibility that small children could become intoxicated from candy-like marijuana edibles. \nAdelson also has contributed $1.5 million in Arizona and Massachusetts, a significant share of all anti-marijuana donations there. \nAdelson, whose son died of a drug overdose and whose wife is a doctor specializing in drug addiction, has donated millions toward efforts to defeat medical marijuana proposals in Florida and other states in years past. \nOther casino operators have joined the fray, but to a lesser extent. \nIn spite of its libertine reputation, the rigorously regulated casino industry is known to err on the conservative side to avoid scandalizing the middle-aged tourists who are its bread and butter. \n“I don’t know that this is a game changer in terms of tourism,” Virginia Valentine, president of the Nevada Resort Association, said of marijuana’s potential. “We’re really known for other things. You may attract people or turn them off.” \nThe Las Vegas Convention and Visitors Authority, which promotes Sin City’s amenities to the world, is neutral on the issue. \nClyde Barrow, a gambling expert who chairs the political science department at the University of Texas-Rio Grande Valley, suggests the donations may indicate the casino companies are acting in their own best interests. \n“The marijuana industry is emerging as another form of recreation and entertainment. Given the casino industry’s difficulties attracting millennials, marijuana is probably perceived as a direct competitor with casinos for entertainment dollars,” he said. “Another reason is that legalized marijuana competes with alcohol, and, to that extent, competes with the food and beverage sales at casinos.” \nThere’s no solid state-sponsored research on how legal recreational marijuana has affected tourism in places that have legalized it, although both sides point to Colorado to make their case. \nPro-marijuana interests cite a state study that found Colorado set an all-time tourism record in 2015, capping a fifth year of growth. It’s unclear how much of that is due to weed, and how much can be chalked up to other factors, such as good snow in recent years relative to competing ski states. \nMarijuana opponents refer to a report from the Visit Denver tourism bureau that logged increasing complaints about panhandling and open marijuana consumption in the city’s downtown corridor. \n“Denver is losing visitors and valuable convention business as a result of these overall safety (or perception of safety) issues,” the report said. “We fear not being able to brand Denver away from this growing reputation.” \nNevada’s ballot initiative would not allow municipalities to put blanket bans on marijuana, as Colorado does. But it would bar consumption in buildings that are open to the public and permit local governments to restrict the locations of marijuana dispensaries and related businesses. It effectively blocks people from growing their own by banning the practice within 25 miles of a licensed marijuana store.",
		"thread_title": "Las Vegas May Become the New Amsterdam",
		"title": "Las Vegas May Become the New Amsterdam",
		"type": "bs",
		"uuid": "99fb9cded53f50a45621a57158c06071d66a71cf"
	},
	"-KhIhYOyAAAk1iHnIcuh": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T21:48:27.739+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "People's Republic of China",
				"salience": 0.49441537,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08wdkk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dmitry_Medvedev"
				},
				"name": "Dmitry Medvedev",
				"salience": 0.08091195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0746963,
				"type": "LOCATION"
			},
			{
				"name": "system",
				"salience": 0.051233158,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.03353354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian Federation",
				"salience": 0.02142165,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.013430384,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.013286294,
				"type": "OTHER"
			},
			{
				"name": "risks",
				"salience": 0.0121340975,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0121340975,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.010657639,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kcyk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China_Central_Television"
				},
				"name": "Chinese Central Television",
				"salience": 0.008531155,
				"type": "ORGANIZATION"
			},
			{
				"name": "To Autonomous Financial System 11",
				"salience": 0.006484814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.005472408,
				"type": "LOCATION"
			},
			{
				"name": "gas pipeline",
				"salience": 0.0051543796,
				"type": "OTHER"
			},
			{
				"name": "economies",
				"salience": 0.0039799623,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0039259424,
				"type": "OTHER"
			},
			{
				"name": "payment system",
				"salience": 0.0039259424,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0030704788,
				"type": "LOCATION"
			},
			{
				"name": "banks",
				"salience": 0.0030704788,
				"type": "ORGANIZATION"
			},
			{
				"name": "integration",
				"salience": 0.002836838,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0028249763,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0025616267,
				"type": "OTHER"
			},
			{
				"name": "risks",
				"salience": 0.0025616267,
				"type": "OTHER"
			},
			{
				"name": "payments",
				"salience": 0.0025616267,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0024265477,
				"type": "OTHER"
			},
			{
				"name": "economy growth",
				"salience": 0.0024265477,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0024265477,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.002265458,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.0022283562,
				"type": "OTHER"
			},
			{
				"name": "reliability",
				"salience": 0.00221841,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.00221841,
				"type": "OTHER"
			},
			{
				"name": "bank cards",
				"salience": 0.00221841,
				"type": "OTHER"
			},
			{
				"name": "sorts",
				"salience": 0.00221841,
				"type": "OTHER"
			},
			{
				"name": "degree",
				"salience": 0.00221841,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.002073154,
				"type": "ORGANIZATION"
			},
			{
				"name": "bank",
				"salience": 0.002073154,
				"type": "ORGANIZATION"
			},
			{
				"name": "systems",
				"salience": 0.0020576618,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0020576618,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0020576618,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.0019895497,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.0019895497,
				"type": "EVENT"
			},
			{
				"name": "partners",
				"salience": 0.0019895497,
				"type": "ORGANIZATION"
			},
			{
				"name": "growth",
				"salience": 0.0019812272,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.0019153248,
				"type": "ORGANIZATION"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0018732641,
				"type": "PERSON"
			},
			{
				"name": "predictability",
				"salience": 0.0017964581,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0017964581,
				"type": "OTHER"
			},
			{
				"name": "predictability",
				"salience": 0.0017964581,
				"type": "OTHER"
			},
			{
				"name": "no-one",
				"salience": 0.0017436709,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.001650259,
				"type": "LOCATION"
			},
			{
				"name": "economy",
				"salience": 0.001650259,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0016321529,
				"type": "LOCATION"
			},
			{
				"name": "purpose",
				"salience": 0.0015556768,
				"type": "OTHER"
			},
			{
				"name": "traffic",
				"salience": 0.0015556768,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.0015556768,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.0014976256,
				"type": "OTHER"
			},
			{
				"name": "disputes",
				"salience": 0.0014976256,
				"type": "EVENT"
			},
			{
				"name": "nature",
				"salience": 0.0014976256,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0014976256,
				"type": "ORGANIZATION"
			},
			{
				"name": "level",
				"salience": 0.0014879284,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0014666816,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.001376599,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09cj5w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China_UnionPay"
				},
				"name": "UnionPay",
				"salience": 0.0013657503,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kzv7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mir"
				},
				"name": "Mir",
				"salience": 0.0013657503,
				"type": "PERSON"
			},
			{
				"name": "factor",
				"salience": 0.0013531873,
				"type": "OTHER"
			},
			{
				"name": "energy sector",
				"salience": 0.0013135686,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0013135686,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0012700707,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0012700707,
				"type": "LOCATION"
			},
			{
				"name": "phase",
				"salience": 0.0012700707,
				"type": "EVENT"
			},
			{
				"name": "speed",
				"salience": 0.0012700707,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.0012700707,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.0012135293,
				"type": "OTHER"
			},
			{
				"name": "oil pipeline",
				"salience": 0.0012135293,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.0012135293,
				"type": "EVENT"
			},
			{
				"name": "projects",
				"salience": 0.0012135293,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0011139633,
				"type": "LOCATION"
			},
			{
				"name": "cooperation",
				"salience": 0.0010957088,
				"type": "OTHER"
			},
			{
				"name": "Power",
				"salience": 0.0010957088,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0009567294,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.0009567294,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.0009488022,
				"type": "OTHER"
			},
			{
				"name": "oil supplies",
				"salience": 0.0009488022,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stretch",
				"salience": 0.0009488022,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.0009488022,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00092186796,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.00092186796,
				"type": "LOCATION"
			},
			{
				"name": "projects",
				"salience": 0.0008838536,
				"type": "OTHER"
			},
			{
				"name": "projects",
				"salience": 0.0008838536,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.0008838536,
				"type": "EVENT"
			},
			{
				"name": "sectors",
				"salience": 0.0008427854,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.0008199243,
				"type": "PERSON"
			},
			{
				"name": "growth",
				"salience": 0.00080539164,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0007844514,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.0007817594,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00071469153,
				"type": "LOCATION"
			},
			{
				"name": "sectors",
				"salience": 0.00071469153,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.00071469153,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.00071469153,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.00071469153,
				"type": "OTHER"
			},
			{
				"name": "ministries",
				"salience": 0.00071469153,
				"type": "ORGANIZATION"
			},
			{
				"name": "Share",
				"salience": 0.0006910177,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0006910177,
				"type": "OTHER"
			},
			{
				"name": "helicopters",
				"salience": 0.0006910177,
				"type": "OTHER"
			},
			{
				"name": "facilities",
				"salience": 0.0006910177,
				"type": "LOCATION"
			},
			{
				"name": "jets",
				"salience": 0.0006910177,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.0006602457,
				"type": "OTHER"
			},
			{
				"name": "Energy",
				"salience": 0.0006602457,
				"type": "OTHER"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0006216298,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.000596126,
				"type": "ORGANIZATION"
			},
			{
				"name": "Skovorodino-Mohe",
				"salience": 0.0005839725,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07bfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Siberia"
				},
				"name": "Siberia",
				"salience": 0.0005839725,
				"type": "LOCATION"
			},
			{
				"name": "satellite",
				"salience": 0.00051618234,
				"type": "OTHER"
			},
			{
				"name": "agencies",
				"salience": 0.00051618234,
				"type": "ORGANIZATION"
			},
			{
				"name": "businesses",
				"salience": 0.00051618234,
				"type": "ORGANIZATION"
			},
			{
				"name": "goal",
				"salience": 0.00051618234,
				"type": "OTHER"
			},
			{
				"name": "Wi-Fi network",
				"salience": 0.00051618234,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00051618234,
				"type": "LOCATION"
			},
			{
				"name": "work",
				"salience": 0.00051618234,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00051618234,
				"type": "OTHER"
			},
			{
				"name": "gear",
				"salience": 0.00051618234,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Indicators",
				"salience": 0.00051618234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y_v04",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tianwan_Nuclear_Power_Plant"
				},
				"name": "Tianwan Nuclear Power Plant",
				"salience": 0.0004911579,
				"type": "LOCATION"
			},
			{
				"name": "Unit 3",
				"salience": 0.00042528784,
				"type": "LOCATION"
			},
			{
				"name": "leaders",
				"salience": 0.00021787263,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/1147882.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T21:48:27.739+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Russia, China Look To Autonomous Financial System 11/07/2016 \nTASS.COM \nRussia and China need to create an autonomous financial system which would be minimally subject to political risks and external pressure, Russian Prime Minister Dmitry Medvedev said in an interview with the Chinese Central Television (CCTV). \n“As I see it, what should we be guided with in creating a modern financial system in the People’s Republic of China and in the Russian Federation?” he said. “We need to set up a modern, protected and simultaneously quite autonomous financial system, which would be subject to political risks to a lesser degree.” Nowadays, Russia and China are considering integration of Russia’s national payment system, the Mir bank cards, and China’s UnionPay system, he said. \n“In our view, it would help to enhance the reliability of payments,” Medvedev said, adding that sometimes some countries were trying to exert “all sorts of political pressure.” European banks had been regularly fined by US financial authorities and financial companies, he added. \n“They say ‘We will take ten billion euros from a French bank and seven billion euros from a German bank’. Our European partners agree with this,” Medvedev said. \n“I am not speaking about the nature of these disputes but that we must protect our financial systems. China must protect its own system and Russia must protect its own system. Therefore, this cooperation is very useful as in this situation no-one will be capable of blocking the road of financial traffic,” he emphasized. Russia looks to predictability of China’s economic growth \nRussia expects that China’s economic growth will be predictable and is set to cooperate with Chinese partners for the purpose, Russia’s Prime Minister said in an interview. \n“We are interested in predictability of China’s economy growth and so we are ready to work with our Chinese partners,” Medvedev said, adding the Russian government was implementing a plan aimed to boost the economic growth. \n“Actually, everyone needs it. Our country needs it as recently we have been plunged in a phase of such decline. Both European and US economies need it since they have not been gaining fast growth, to say nothing about Japan. Also, the Chinese economy needs it since it had been gathering speed in the past years but has slowed down later,” he said. “It is closely watched by everyone as China’s economy is the most significant factor of the world economic growth.”. Energy and high technology sectors \nRussia and China may reach the goal of $200bln trade by 2020 but energy and high technology sectors along with traditional trade should move up a gear, Russian Prime Minister said. \n“Indicators have been improving this year as a result of joint work of the two states, including our countries’ leaders, governments, ministries, agencies and businesses,” Medvedev said. Russia, China intend to develop small satellite for Wi-Fi network \n“I am convinced that if we move ahead like this, by 2020 we will be able to reach the trade of $200 billion worth. However, attention should be turned to key aspects of cooperation,” he said explaining he implied the energy sector, with some projects like the Power of Siberia gas pipeline. \n“In 2015 construction of an eastern stretch of the gas pipeline was launched,” he said. “Also, it includes oil supplies along the Skovorodino-Mohe (oil pipeline) extension and construction of large facilities, in particular the construction of Unit 3 at the Tianwan Nuclear Power Plant.” \nBesides, high-tech projects should be enhanced, he said. \n“I mean wide-body jets, heavy helicopters and other projects in the high-tech sector,” Medvedev said. “It seems to me that if we diversify trade like this, our countries will be quite capable of reaching the level which we agreed on several years ago,” he said in conclusion. Share",
		"thread_title": "Russia, China Look To Autonomous Financial System",
		"title": "Russia, China Look To Autonomous Financial System",
		"type": "bs",
		"uuid": "b50d019c763ad99b161092ddf82105e45233644e"
	},
	"-KhIhYb0c3HrsJzPp7nf": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T21:48:28.350+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.12283204,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.08747766,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.067345865,
				"type": "LOCATION"
			},
			{
				"name": "PRESS TV Experts",
				"salience": 0.05192944,
				"type": "PERSON"
			},
			{
				"name": "worst",
				"salience": 0.049578212,
				"type": "OTHER"
			},
			{
				"name": "slump",
				"salience": 0.042720307,
				"type": "OTHER"
			},
			{
				"name": "Slump",
				"salience": 0.042720307,
				"type": "OTHER"
			},
			{
				"name": "kingdom",
				"salience": 0.038631454,
				"type": "LOCATION"
			},
			{
				"name": "experts",
				"salience": 0.037625935,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.035392974,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.033734325,
				"type": "OTHER"
			},
			{
				"name": "outlook",
				"salience": 0.033515688,
				"type": "OTHER"
			},
			{
				"name": "recovery",
				"salience": 0.033515688,
				"type": "EVENT"
			},
			{
				"name": "consultants",
				"salience": 0.020834904,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.014624308,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.01319309,
				"type": "ORGANIZATION"
			},
			{
				"name": "currency crisis",
				"salience": 0.011917273,
				"type": "EVENT"
			},
			{
				"name": "experts",
				"salience": 0.011080562,
				"type": "PERSON"
			},
			{
				"name": "degree",
				"salience": 0.008817293,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.008817293,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0082096085,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0082096085,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sector",
				"salience": 0.0082096085,
				"type": "OTHER"
			},
			{
				"name": "uncertainty",
				"salience": 0.0082096085,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.007560455,
				"type": "OTHER"
			},
			{
				"name": "kingdom",
				"salience": 0.0072341296,
				"type": "LOCATION"
			},
			{
				"name": "challenges",
				"salience": 0.0071113454,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0066255536,
				"type": "ORGANIZATION"
			},
			{
				"name": "Experts",
				"salience": 0.005813482,
				"type": "PERSON"
			},
			{
				"name": "austerity policies",
				"salience": 0.0057702395,
				"type": "OTHER"
			},
			{
				"name": "construction firms",
				"salience": 0.0057604206,
				"type": "ORGANIZATION"
			},
			{
				"name": "construction firms",
				"salience": 0.0057604206,
				"type": "ORGANIZATION"
			},
			{
				"name": "reforms",
				"salience": 0.0057604206,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0057604206,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0055457507,
				"type": "EVENT"
			},
			{
				"name": "slump",
				"salience": 0.0052091954,
				"type": "OTHER"
			},
			{
				"name": "dues",
				"salience": 0.004989178,
				"type": "OTHER"
			},
			{
				"name": "spending cuts",
				"salience": 0.004989178,
				"type": "OTHER"
			},
			{
				"name": "establishments",
				"salience": 0.004989178,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0048031965,
				"type": "OTHER"
			},
			{
				"name": "bills",
				"salience": 0.0048031965,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0048031965,
				"type": "EVENT"
			},
			{
				"name": "threats",
				"salience": 0.0048031965,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.0048031965,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0047040535,
				"type": "LOCATION"
			},
			{
				"name": "Experts",
				"salience": 0.0043446426,
				"type": "PERSON"
			},
			{
				"name": "discounts",
				"salience": 0.004074024,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.004074024,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.004074024,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.004074024,
				"type": "LOCATION"
			},
			{
				"name": "obligations",
				"salience": 0.004074024,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0035151462,
				"type": "OTHER"
			},
			{
				"name": "payments",
				"salience": 0.0034994588,
				"type": "OTHER"
			},
			{
				"name": "oil revenues",
				"salience": 0.0030441654,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0030441654,
				"type": "OTHER"
			},
			{
				"name": "demand",
				"salience": 0.0030441654,
				"type": "OTHER"
			},
			{
				"name": "job market",
				"salience": 0.0030441654,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00283591,
				"type": "ORGANIZATION"
			},
			{
				"name": "slowdown",
				"salience": 0.0027857507,
				"type": "EVENT"
			},
			{
				"name": "citizens",
				"salience": 0.002560683,
				"type": "PERSON"
			},
			{
				"name": "uncertainty",
				"salience": 0.002227424,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0022174786,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.0022174786,
				"type": "OTHER"
			},
			{
				"name": "foreigners",
				"salience": 0.0022174786,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0021642137,
				"type": "LOCATION"
			},
			{
				"name": "surge",
				"salience": 0.0021347334,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.0020126107,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lay-offs",
				"salience": 0.0017875716,
				"type": "EVENT"
			},
			{
				"name": "reform drive",
				"salience": 0.0016566323,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0016566323,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.0016566323,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0016566323,
				"type": "PERSON"
			},
			{
				"name": "consumer electronics",
				"salience": 0.0016566323,
				"type": "OTHER"
			},
			{
				"name": "clothes",
				"salience": 0.0016566323,
				"type": "OTHER"
			},
			{
				"name": "stores",
				"salience": 0.0016566323,
				"type": "LOCATION"
			},
			{
				"name": "cars",
				"salience": 0.0013871806,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "issue",
				"salience": 0.0012065761,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/c23a7d3b-4225-41b0-a9d7-6cfc6f99eac5.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T21:48:28.350+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Worst Of Saudi Economic Slump Yet To Come 11/07/2016 \nPRESS TV \nExperts say the outlook for Saudi economic recovery will remain murky for many months to come with some even warning that the worst of the economic slump for the kingdom is yet to come. \nReuters in a report quoted several Riyadh-based experts as saying that there would be a high degree of uncertainty over the status of the Saudi economy in 2017. That would mainly be a result of the remaining challenges from the private sector. \nThe Saudi economy may appear to have escaped a fiscal and currency crisis that loomed at the start of 2016. However, experts said, threats from certain basic problems still remain and will haunt the kingdom next year. \nThe government owes its success to temporarily escape crisis to unpaid bills rather than sustainable spending cuts. \nThe government has reduced or suspended payments that it owed to construction firms, medical establishments and even some of the foreign consultants who helped to design the economic reforms, Reuters added quoting the experts. The estimated unpaid dues for construction firms alone totaled 80 billion riyals. \nExperts further warned that this could store up obligations for Riyadh in the future. \nReuters elsewhere emphasized that signs of the economic slump could be seen in Riyadh and other major cities, where discounts of 50 percent or more are offered by stores selling clothes and consumer electronics, and there is a surge in people offering second-hand cars for sale. \nThe biggest uncertainty may be how authorities can push through a key part of their reform drive, added the report. The most important issue for the Saudis may be determining how they plan to foster a vibrant private sector that does not depend on oil revenues while at the same pushing ahead austerity policies that are suppressing private demand. \nExperts also warned that the status of the Saudi job market over the next few years. Between 1 million and 2 million of Saudi Arabia’s 10 million foreign workers may leave over the next couple of years as the economic slowdown causes lay-offs and the government seeks to steer Saudi citizens into jobs previously held by foreigners, Reuters added.",
		"thread_title": "Worst Of Saudi Economic Slump Yet To Come",
		"title": "Worst Of Saudi Economic Slump Yet To Come",
		"type": "bs",
		"uuid": "ea37149f2677f2b06668b62d8ebe6ed4ed3705b8"
	},
	"-KhIhYjrt6O3AOCuN11x": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T00:16:26.979+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.33803037,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.104479685,
				"type": "ORGANIZATION"
			},
			{
				"name": "Charge",
				"salience": 0.09739923,
				"type": "OTHER"
			},
			{
				"name": "TREASON",
				"salience": 0.09739923,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.041101675,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.041101675,
				"type": "EVENT"
			},
			{
				"name": "AMTV",
				"salience": 0.029363163,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.027899254,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Christopher Greene",
				"salience": 0.025468066,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.025468066,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.016015965,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.015606646,
				"type": "ORGANIZATION"
			},
			{
				"name": "catchphrase",
				"salience": 0.014879525,
				"type": "WORK_OF_ART"
			},
			{
				"name": "casinos",
				"salience": 0.014879525,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.012272822,
				"type": "LOCATION"
			},
			{
				"name": "brothels",
				"salience": 0.0115617635,
				"type": "LOCATION"
			},
			{
				"name": "To Autonomous Financial System 11",
				"salience": 0.010370124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.009946376,
				"type": "LOCATION"
			},
			{
				"name": "Slump",
				"salience": 0.009095075,
				"type": "OTHER"
			},
			{
				"name": "PRESS TV Experts",
				"salience": 0.009095075,
				"type": "PERSON"
			},
			{
				"name": "outlook",
				"salience": 0.009095075,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.008655696,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.008515048,
				"type": "LOCATION"
			},
			{
				"name": "recovery",
				"salience": 0.006630229,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.006630229,
				"type": "OTHER"
			},
			{
				"name": "politic",
				"salience": 0.004955871,
				"type": "OTHER"
			},
			{
				"name": "AMTV Archives",
				"salience": 0.004084549,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/^28E95437BCA0095AA9138357F8C482DD17771DFC98D96D2EC0^pimgpsh_fullsize_distr.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T00:16:26.979+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Charge Comey with TREASON and Flush Out the Entire FBI 11/07/2016 In today’s video Christopher Greene of AMTV reports on FBI Director James Comey dropping investigation on Hillary Clinton’s emails. 11/07/2016 HIGH TIMES Nevada already has legal brothels, round-the-clock casinos and a coy catchphrase declaring that “what happ ... Russia, China Look To Autonomous Financial System 11/07/2016 TASS.COM Russia and China need to create an autonomous financial system which would be minimally subject to politic ... Worst Of Saudi Economic Slump Yet To Come 11/07/2016 PRESS TV Experts say the outlook for Saudi economic recovery will remain murky for many months to come with some even ... AMTV Archives",
		"thread_title": "Charge Comey with TREASON and Flush Out the Entire FBI",
		"title": "Charge Comey with TREASON and Flush Out the Entire FBI",
		"type": "bs",
		"uuid": "bfd5b9f8f0d5cf99aae7a765204a0f35691fe524"
	},
	"-KhIhZ1QIYtZ0MEdyWuL": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T21:00:37.324+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.24286051,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.11792746,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.113405384,
				"type": "EVENT"
			},
			{
				"name": "hackers",
				"salience": 0.10677537,
				"type": "PERSON"
			},
			{
				"name": "penetration",
				"salience": 0.047967285,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.025389798,
				"type": "OTHER"
			},
			{
				"name": "communications networks",
				"salience": 0.024581302,
				"type": "OTHER"
			},
			{
				"name": "hackers",
				"salience": 0.023062285,
				"type": "PERSON"
			},
			{
				"name": "systems",
				"salience": 0.019281942,
				"type": "OTHER"
			},
			{
				"name": "preparation",
				"salience": 0.019281942,
				"type": "OTHER"
			},
			{
				"name": "Military",
				"salience": 0.016934099,
				"type": "ORGANIZATION"
			},
			{
				"name": "grid",
				"salience": 0.01672288,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.01672288,
				"type": "ORGANIZATION"
			},
			{
				"name": "cyber strike",
				"salience": 0.01672288,
				"type": "EVENT"
			},
			{
				"name": "It Hacks The Election",
				"salience": 0.015217797,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.010540396,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "DAILY CALLER",
				"salience": 0.010332857,
				"type": "PERSON"
			},
			{
				"name": "infrastructure",
				"salience": 0.010217807,
				"type": "OTHER"
			},
			{
				"name": "Officials",
				"salience": 0.0075875125,
				"type": "PERSON"
			},
			{
				"name": "hacker",
				"salience": 0.0065540895,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0053943703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dd9hwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stuxnet"
				},
				"name": "Stuxnet",
				"salience": 0.0051884,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.004900535,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05zyst_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Cyber_Command"
				},
				"name": "U.S. Cyber Command",
				"salience": 0.0047082542,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gary Brown",
				"salience": 0.003781606,
				"type": "PERSON"
			},
			{
				"name": "act",
				"salience": 0.0035420747,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0035420747,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0035313813,
				"type": "EVENT"
			},
			{
				"name": "networks",
				"salience": 0.0035313813,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0034385237,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.003399785,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0032730822,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0030428288,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.002995468,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.002995468,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.002995468,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.002995468,
				"type": "EVENT"
			},
			{
				"name": "administration",
				"salience": 0.0028689397,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons",
				"salience": 0.0028689397,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0027619856,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0027619856,
				"type": "OTHER"
			},
			{
				"name": "preparations",
				"salience": 0.0027619856,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.0026471498,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0026067512,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.0025484506,
				"type": "OTHER"
			},
			{
				"name": "military scouting mission",
				"salience": 0.002484701,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.002446014,
				"type": "PERSON"
			},
			{
				"name": "security experts",
				"salience": 0.0023920496,
				"type": "PERSON"
			},
			{
				"name": "Guccifer 2.0",
				"salience": 0.0021815535,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.002098255,
				"type": "EVENT"
			},
			{
				"name": "access",
				"salience": 0.0020288152,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0020288152,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0019385489,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0019285496,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.0017873546,
				"type": "OTHER"
			},
			{
				"name": "capabilities",
				"salience": 0.0017504364,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0015285141,
				"type": "EVENT"
			},
			{
				"name": "enrichment",
				"salience": 0.0015158551,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0015158551,
				"type": "OTHER"
			},
			{
				"name": "computer worm",
				"salience": 0.0015158551,
				"type": "OTHER"
			},
			{
				"name": "havoc",
				"salience": 0.0015158551,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0014728426,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.001429149,
				"type": "ORGANIZATION"
			},
			{
				"name": "infrastructure",
				"salience": 0.0012750623,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0011469459,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.0011041426,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.0011041426,
				"type": "OTHER"
			},
			{
				"name": "terrorist group",
				"salience": 0.0011041426,
				"type": "ORGANIZATION"
			},
			{
				"name": "misinformation campaigns",
				"salience": 0.0011041426,
				"type": "EVENT"
			},
			{
				"name": "agencies",
				"salience": 0.00095256366,
				"type": "ORGANIZATION"
			},
			{
				"name": "capabilities",
				"salience": 0.00095256366,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0009331487,
				"type": "ORGANIZATION"
			},
			{
				"name": "provocation",
				"salience": 0.0008248516,
				"type": "EVENT"
			},
			{
				"name": "line",
				"salience": 0.0008248516,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.0006796334,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0006796334,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "National Security Agency",
				"salience": 0.00058631017,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/74f7cc6254e2f30ed8f738bc9279f5e8.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T21:00:37.324+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "US Military Prepares To Shut Down Russia’s Internet If It Hacks The Election 11/08/2016 \nDAILY CALLER \nAmerican hackers recently broke into Russia’s communications networks, electrical grid and government systems in preparation for a retaliatory cyber strike should Russian hackers meddle in the U.S. election, according to NBC News. \nOfficials do not expect any major attacks on U.S. infrastructure, which would be tantamount to an act of war, but they are concerned that Russian hackers may meddle in the election by spreading false information. The hacker “Guccifer 2.0” — which officials and some cyber security experts believe is a front for Russian intelligence — claimed they would be monitoring elections “from inside the system.” \nThe U.S. preparations are no different than Russia and China’s probing of U.S. networks. The penetration caused no damage to Russia, instead it was the equivalent of a military scouting mission. Cyber weapons could be deployed if the U.S. suffered a significant attack, but officials tell NBC News that is an unlikely scenario. Just to be sure though, Obama administration officials issued a back-channel warning to Russia to stay out of the election. \n“You’d gain access to a network, you’d establish your presence on the network and then you’re poised to do what you would like to do with the network,” Gary Brown, a former legal adviser to U.S. Cyber Command (CYBERCOM), told NBC News. \nU.S. cyber capabilities are top of the line, but the Obama administration has been wary of deploying them, despite consistent Russian provocation. CYBERCOM and the National Security Agency, the agencies responsible for U.S. cyber security, are incredibly secretive regarding U.S. capabilities. Stuxnet is the most well-known, publicized U.S. cyber weapon. The highly advanced computer worm wreaked havoc on Iran’s nuclear enrichment program in 2010. \nCYBERCOM is currently involved in cyber attacks against the Islamic State, but Pentagon officials have been especially silent on the exact details of the “ cyber bombs ” being dropped on the terrorist group. Russia may find itself the next target, should it decide to go from misinformation campaigns to attacks on infrastructure.",
		"thread_title": "US Military Prepares To Shut Down Russia’s Internet If It Hacks The Election",
		"title": "US Military Prepares To Shut Down Russia’s Internet If It Hacks The Election",
		"type": "bs",
		"uuid": "193c4397a7a9317d3360d76e45c7a9d2a30cd462"
	},
	"-KhIhZAwKZ2mi1kWJujV": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T21:00:37.382+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.22451481,
				"type": "PERSON"
			},
			{
				"name": "polling station",
				"salience": 0.19427532,
				"type": "LOCATION"
			},
			{
				"name": "Protesters",
				"salience": 0.09467891,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/039g95",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Polling_place"
				},
				"name": "Polling Station",
				"salience": 0.05924559,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "DAILY CALLER",
				"salience": 0.043108787,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.043108787,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.041558754,
				"type": "LOCATION"
			},
			{
				"name": "protesters",
				"salience": 0.039970446,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.035499934,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bwmc83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FEMEN"
				},
				"name": "Femen",
				"salience": 0.035228927,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.019259915,
				"type": "PERSON"
			},
			{
				"name": "activist",
				"salience": 0.015844006,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.015609382,
				"type": "PERSON"
			},
			{
				"name": "polling station",
				"salience": 0.0139357615,
				"type": "LOCATION"
			},
			{
				"name": "balls",
				"salience": 0.010471012,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.010471012,
				"type": "OTHER"
			},
			{
				"name": "audio",
				"salience": 0.010471012,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.010471012,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.010081765,
				"type": "PERSON"
			},
			{
				"name": "backs",
				"salience": 0.008554846,
				"type": "OTHER"
			},
			{
				"name": "representative",
				"salience": 0.0074443123,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0073836637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.007175273,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03q353",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Billy_Bush"
				},
				"name": "Billy Bush",
				"salience": 0.0064553414,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0063960915,
				"type": "OTHER"
			},
			{
				"name": "gender injustice",
				"salience": 0.0063960915,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0057804035,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0046613626,
				"type": "OTHER"
			},
			{
				"name": "Femen USA",
				"salience": 0.0045495345,
				"type": "OTHER"
			},
			{
				"name": "Femen USA",
				"salience": 0.0033148641,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0021449535,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04mzd6n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Beast"
				},
				"name": "The Daily Beast",
				"salience": 0.0019381176,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/topless-protesters-trump.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T21:00:37.382+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Topless Protesters Arrested At Trump’s Polling Station 11/08/2016 \nDAILY CALLER \nThe polling station where Republican candidate Donald Trump plans to vote Tuesday morning in New York was crashed by angry, shirtless protesters. \nTwo topless female protesters entered the New York City polling station, disturbing voters and chanting. The women were reportedly saying “Trump, grab your balls!” in reference to the leaked audio of his lewd conversation with Billy Bush from 2005. \nThe protesters had “Femen USA” painted on their backs. Femen is a mostly-European, extreme feminist activist group, increasingly spreading in the United States. \n“I can assure you sure that once American women are trained and ready to act as Femen, every place of gender injustice, every representative of patriarchal culture, will be a target of Femen USA,” one activist told The Daily Beast .",
		"thread_title": "Topless Protesters Arrested At Trump’s Polling Station",
		"title": "Topless Protesters Arrested At Trump’s Polling Station",
		"type": "bs",
		"uuid": "f28f6ef27569ff86674a0b45807d34abc3046919"
	},
	"-KhIhZzkZetgD5t6PQ4n": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T21:00:37.427+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.3476398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.1729457,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.04675557,
				"type": "PERSON"
			},
			{
				"name": "pilots",
				"salience": 0.044045012,
				"type": "PERSON"
			},
			{
				"name": "Swen Jacob",
				"salience": 0.026592257,
				"type": "PERSON"
			},
			{
				"name": "defences",
				"salience": 0.021482846,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.015889153,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01522",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Sea"
				},
				"name": "Baltic",
				"salience": 0.015252046,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.012139153,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04f52sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C3%84mari"
				},
				"name": "Amari",
				"salience": 0.011377978,
				"type": "LOCATION"
			},
			{
				"name": "jets",
				"salience": 0.008935853,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.008935853,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.008935853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07r_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tallinn"
				},
				"name": "Tallinn",
				"salience": 0.007309271,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0066216774,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.006541787,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonia",
				"salience": 0.0064925007,
				"type": "LOCATION"
			},
			{
				"name": "fighter pilots",
				"salience": 0.0049982783,
				"type": "PERSON"
			},
			{
				"name": "pilot",
				"salience": 0.0049982783,
				"type": "PERSON"
			},
			{
				"name": "pilots",
				"salience": 0.0049982783,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0047235056,
				"type": "LOCATION"
			},
			{
				"name": "jets",
				"salience": 0.004572457,
				"type": "OTHER"
			},
			{
				"name": "skies",
				"salience": 0.0044538113,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018js4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Top_Gun"
				},
				"name": "Top Gun",
				"salience": 0.0042194366,
				"type": "WORK_OF_ART"
			},
			{
				"name": "experts",
				"salience": 0.0040791123,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.0037780176,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01b8g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jens_Stoltenberg"
				},
				"name": "Jens Stoltenberg",
				"salience": 0.0037490856,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.0037409156,
				"type": "OTHER"
			},
			{
				"name": "Typhoons",
				"salience": 0.0035979825,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.0035341014,
				"type": "ORGANIZATION"
			},
			{
				"name": "defences",
				"salience": 0.0031949058,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0031681194,
				"type": "ORGANIZATION"
			},
			{
				"name": "pilots",
				"salience": 0.0029928046,
				"type": "PERSON"
			},
			{
				"name": "occasion",
				"salience": 0.0029326978,
				"type": "EVENT"
			},
			{
				"name": "air base",
				"salience": 0.0029326978,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.0029326978,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/049hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kaliningrad"
				},
				"name": "Kaliningrad",
				"salience": 0.0029070617,
				"type": "LOCATION"
			},
			{
				"name": "enclave",
				"salience": 0.0028081585,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0024112754,
				"type": "LOCATION"
			},
			{
				"name": "Lt Col Jacob",
				"salience": 0.0023093142,
				"type": "OTHER"
			},
			{
				"name": "salute",
				"salience": 0.0022193184,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.002211821,
				"type": "OTHER"
			},
			{
				"name": "air force",
				"salience": 0.002211821,
				"type": "ORGANIZATION"
			},
			{
				"name": "air force",
				"salience": 0.002211821,
				"type": "ORGANIZATION"
			},
			{
				"name": "air forces",
				"salience": 0.002211821,
				"type": "ORGANIZATION"
			},
			{
				"name": "air",
				"salience": 0.002211821,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.002085229,
				"type": "ORGANIZATION"
			},
			{
				"name": "air force",
				"salience": 0.0020760265,
				"type": "ORGANIZATION"
			},
			{
				"name": "plans",
				"salience": 0.002041463,
				"type": "OTHER"
			},
			{
				"name": "chiefs",
				"salience": 0.00194251,
				"type": "ORGANIZATION"
			},
			{
				"name": "Sukhoi SU-27 Flanker",
				"salience": 0.0018955077,
				"type": "PERSON"
			},
			{
				"name": "jets",
				"salience": 0.0018840709,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonian",
				"salience": 0.0018057869,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04g5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latvia"
				},
				"name": "Latvia",
				"salience": 0.0018057869,
				"type": "LOCATION"
			},
			{
				"name": "plane",
				"salience": 0.0017984591,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06dqt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_Air_Force"
				},
				"name": "RAF",
				"salience": 0.0017511933,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0017261361,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04gzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lithuania"
				},
				"name": "Lithuania",
				"salience": 0.0016328336,
				"type": "LOCATION"
			},
			{
				"name": "enclave",
				"salience": 0.0015446942,
				"type": "LOCATION"
			},
			{
				"name": "planes",
				"salience": 0.0015446942,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0015446942,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016dy9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurofighter_Typhoon"
				},
				"name": "Eurofighter Typhoon",
				"salience": 0.0014710557,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06pr6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saint_Petersburg"
				},
				"name": "St Petersburg",
				"salience": 0.0014567835,
				"type": "LOCATION"
			},
			{
				"name": "pilots",
				"salience": 0.0014444329,
				"type": "PERSON"
			},
			{
				"name": "military force",
				"salience": 0.0014193614,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0013866846,
				"type": "PERSON"
			},
			{
				"name": "military capabilities",
				"salience": 0.0012842196,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0012718531,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0012718531,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0012718531,
				"type": "OTHER"
			},
			{
				"name": "orders",
				"salience": 0.0012077763,
				"type": "OTHER"
			},
			{
				"name": "field",
				"salience": 0.0012077763,
				"type": "OTHER"
			},
			{
				"name": "poppies",
				"salience": 0.0012077763,
				"type": "OTHER"
			},
			{
				"name": "airspace corridor",
				"salience": 0.0012077763,
				"type": "LOCATION"
			},
			{
				"name": "jet",
				"salience": 0.0012077763,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0012077763,
				"type": "OTHER"
			},
			{
				"name": "cold war",
				"salience": 0.0011286554,
				"type": "EVENT"
			},
			{
				"name": "blasts",
				"salience": 0.0011052025,
				"type": "EVENT"
			},
			{
				"name": "defence spending",
				"salience": 0.0010969394,
				"type": "OTHER"
			},
			{
				"name": "military spending",
				"salience": 0.0010831187,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.0010649962,
				"type": "OTHER"
			},
			{
				"name": "features",
				"salience": 0.0010373103,
				"type": "OTHER"
			},
			{
				"name": "parades",
				"salience": 0.0010165824,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0009779545,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0009779545,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0009643929,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0009459975,
				"type": "OTHER"
			},
			{
				"name": "deployment force",
				"salience": 0.0009459975,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.000941451,
				"type": "OTHER"
			},
			{
				"name": "collisions",
				"salience": 0.000941451,
				"type": "OTHER"
			},
			{
				"name": "cluster bombs",
				"salience": 0.000941451,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.000941451,
				"type": "OTHER"
			},
			{
				"name": "Adam Thomson",
				"salience": 0.0009392662,
				"type": "PERSON"
			},
			{
				"name": "missiles",
				"salience": 0.0009381659,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0008842308,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0008842308,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.0008662258,
				"type": "LOCATION"
			},
			{
				"name": "bear",
				"salience": 0.00084683,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.00084683,
				"type": "OTHER"
			},
			{
				"name": "doorstep",
				"salience": 0.00084683,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00084683,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.00084683,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.00084683,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00084683,
				"type": "LOCATION"
			},
			{
				"name": "contingents",
				"salience": 0.00084683,
				"type": "OTHER"
			},
			{
				"name": "fighter aircraft",
				"salience": 0.00084683,
				"type": "OTHER"
			},
			{
				"name": "transponders",
				"salience": 0.00081521884,
				"type": "PERSON"
			},
			{
				"name": "island",
				"salience": 0.00081521884,
				"type": "LOCATION"
			},
			{
				"name": "rockets",
				"salience": 0.00081521884,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.00081521884,
				"type": "OTHER"
			},
			{
				"name": "teeth",
				"salience": 0.00081521884,
				"type": "OTHER"
			},
			{
				"name": "kinds",
				"salience": 0.00081521884,
				"type": "OTHER"
			},
			{
				"name": "air show",
				"salience": 0.00081521884,
				"type": "EVENT"
			},
			{
				"name": "armoury",
				"salience": 0.00081521884,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0008057361,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0007983689,
				"type": "PERSON"
			},
			{
				"name": "Relations",
				"salience": 0.0007983689,
				"type": "OTHER"
			},
			{
				"name": "military capabilities",
				"salience": 0.0007983689,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.0007748977,
				"type": "OTHER"
			},
			{
				"name": "tank",
				"salience": 0.000772554,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0007691031,
				"type": "PERSON"
			},
			{
				"name": "defence",
				"salience": 0.0007628187,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spanish",
				"salience": 0.0007434106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italian",
				"salience": 0.0007434106,
				"type": "LOCATION"
			},
			{
				"name": "tank",
				"salience": 0.0007159508,
				"type": "OTHER"
			},
			{
				"name": "Europe The Flanker",
				"salience": 0.0006946986,
				"type": "PERSON"
			},
			{
				"name": "costs",
				"salience": 0.0006913143,
				"type": "OTHER"
			},
			{
				"name": "tension",
				"salience": 0.0006913143,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0006913143,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.0006913143,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.0006913143,
				"type": "OTHER"
			},
			{
				"name": "insistence",
				"salience": 0.0006913143,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.0006913143,
				"type": "EVENT"
			},
			{
				"name": "alert",
				"salience": 0.0006913143,
				"type": "OTHER"
			},
			{
				"name": "pontoon bridge",
				"salience": 0.0006913143,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0006889769,
				"type": "OTHER"
			},
			{
				"name": "defence spending",
				"salience": 0.00066052936,
				"type": "OTHER"
			},
			{
				"name": "Vympel R-27",
				"salience": 0.0006417758,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "R",
				"salience": 0.0006417758,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04h8hf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/R-73_(missile)"
				},
				"name": "R-73",
				"salience": 0.0006417758,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lt Col Jacob",
				"salience": 0.0006417758,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rm8f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sukhoi"
				},
				"name": "Sukhoi",
				"salience": 0.0006417758,
				"type": "ORGANIZATION"
			},
			{
				"name": "Post",
				"salience": 0.00063542597,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0006238093,
				"type": "LOCATION"
			},
			{
				"name": "pilots",
				"salience": 0.00060985336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g5qq1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Western_sentiment"
				},
				"name": "anti-Western",
				"salience": 0.00060192164,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.000589106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Poland",
				"salience": 0.00058110483,
				"type": "LOCATION"
			},
			{
				"name": "S-8",
				"salience": 0.0005794497,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00056962,
				"type": "PERSON"
			},
			{
				"name": "super tank",
				"salience": 0.0005555514,
				"type": "OTHER"
			},
			{
				"name": "tank",
				"salience": 0.0005555514,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.0005502141,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0005502141,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0247rk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C5%A0iauliai"
				},
				"name": "Šiauliai",
				"salience": 0.0005212015,
				"type": "LOCATION"
			},
			{
				"name": "representative",
				"salience": 0.00051640504,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00051640504,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighbours",
				"salience": 0.00051640504,
				"type": "PERSON"
			},
			{
				"name": "terms",
				"salience": 0.00051640504,
				"type": "OTHER"
			},
			{
				"name": "reinforcement",
				"salience": 0.00051640504,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00051640504,
				"type": "EVENT"
			},
			{
				"name": "ways",
				"salience": 0.00051640504,
				"type": "OTHER"
			},
			{
				"name": "military build-up",
				"salience": 0.00051640504,
				"type": "EVENT"
			},
			{
				"name": "document",
				"salience": 0.0005034703,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Danish",
				"salience": 0.00050174235,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03m4jw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Falster"
				},
				"name": "Falster",
				"salience": 0.00050174235,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/036vrm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Farnborough_Airshow"
				},
				"name": "Farnborough",
				"salience": 0.00050174235,
				"type": "LOCATION"
			},
			{
				"name": "Zvezda Kh-35U",
				"salience": 0.00050174235,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hr2c9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Ukraine"
				},
				"name": "West",
				"salience": 0.00049137,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dv_mb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/9K720_Iskander"
				},
				"name": "Iskander",
				"salience": 0.00048335793,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00048335793,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War Two",
				"salience": 0.00048335793,
				"type": "EVENT"
			},
			{
				"name": "military parade",
				"salience": 0.00048104808,
				"type": "EVENT"
			},
			{
				"name": "Berlin Britain",
				"salience": 0.0004694865,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.00044005027,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00044005027,
				"type": "LOCATION"
			},
			{
				"name": "missiles",
				"salience": 0.00043833608,
				"type": "OTHER"
			},
			{
				"name": "abilities",
				"salience": 0.0004269372,
				"type": "OTHER"
			},
			{
				"name": "Anaconda-16",
				"salience": 0.00042547184,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07_w1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vistula"
				},
				"name": "Vistula river",
				"salience": 0.00042547184,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0kn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(country)"
				},
				"name": "Georgians",
				"salience": 0.00042547184,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.00042547184,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00042547184,
				"type": "LOCATION"
			},
			{
				"name": "pro-Moscow",
				"salience": 0.00042547184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/011jw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abkhazia"
				},
				"name": "Abkhazia",
				"salience": 0.00042547184,
				"type": "LOCATION"
			},
			{
				"name": "military intelligence officers",
				"salience": 0.00038747143,
				"type": "PERSON"
			},
			{
				"name": "battle tank",
				"salience": 0.00037972615,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01v51r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Ossetia"
				},
				"name": "South Ossetia",
				"salience": 0.00037957105,
				"type": "LOCATION"
			},
			{
				"name": "moment",
				"salience": 0.0003760777,
				"type": "OTHER"
			},
			{
				"name": "crews",
				"salience": 0.0003760777,
				"type": "PERSON"
			},
			{
				"name": "machine",
				"salience": 0.0003760777,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0003760777,
				"type": "ORGANIZATION"
			},
			{
				"name": "anything",
				"salience": 0.0003760777,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0003760777,
				"type": "OTHER"
			},
			{
				"name": "gates",
				"salience": 0.0003760777,
				"type": "LOCATION"
			},
			{
				"name": "parade",
				"salience": 0.00035932782,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.00035932782,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.00032442683,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00032442683,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.00032442683,
				"type": "PERSON"
			},
			{
				"name": "relations",
				"salience": 0.00032442683,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.00032442683,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.00032442683,
				"type": "PERSON"
			},
			{
				"name": "Officials",
				"salience": 0.00030837645,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.0003069986,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00029514465,
				"type": "PERSON"
			},
			{
				"name": "turret",
				"salience": 0.00028265695,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0002809142,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.0002809142,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election process",
				"salience": 0.0002809142,
				"type": "OTHER"
			},
			{
				"name": "reset",
				"salience": 0.0002809142,
				"type": "OTHER"
			},
			{
				"name": "uniforms",
				"salience": 0.0002809142,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0002809142,
				"type": "LOCATION"
			},
			{
				"name": "appeasement",
				"salience": 0.0002809142,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hm_7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Red_Square"
				},
				"name": "Red Square",
				"salience": 0.00023144307,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04dnx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kremlin"
				},
				"name": "Kremlin",
				"salience": 0.00023144307,
				"type": "ORGANIZATION"
			},
			{
				"name": "Armata",
				"salience": 0.00023144307,
				"type": "PERSON"
			},
			{
				"name": "Challenger II",
				"salience": 0.00023144307,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.00017287477,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazis",
				"salience": 0.00017287477,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00017287477,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ndwhc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimea"
				},
				"name": "Crimea",
				"salience": 0.00017287477,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06c1y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Romania"
				},
				"name": "Romania",
				"salience": 0.00017287477,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09rkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times"
				},
				"name": "The Times",
				"salience": 0.00016455501,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06dr9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Red_Army"
				},
				"name": "Red Army",
				"salience": 0.00012912655,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/0005794F00000C1D-3915886-image-a-10_1478595771806.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T21:00:37.427+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "NATO fighter jets on constant watch for Russian jets above Baltic states 11/08/2016 \nDAILY MAIL Russian fighter jets are constantly probing Nato’s defences over the Baltic states, with more than 600 ‘interceptions’ so far this year. Ironically, considering the history, the Nato pilots defending the skies over Estonia, Latvia and Lithuania are often German. Seven German fighter pilots are based at an air base at Amari, west of the Estonian capital Tallinn. Lieutenant Colonel Swen Jacob, the commander of the German pilots, said they often flew as close as 10 yards from the Russian jets and one occasion a Russian pilot gave him a middle-fingered salute. Lt Col Jacob joked to the Washington Post : ‘Maybe he watched too much “Top Gun”.’ But the situation in the Baltic is deadly serious, with the Russian air force clearly under orders from President Vladimir Putin to be more aggressive in the air. An RAF Eurofighter Typhoon plane takes off over a field of poppies. German Typhoons are currently based in Amari, Estonia, and it is possible they will be replaced by British Typhoons in January The Typhoon jet (left) is flown by the German air force and the RAF aswell as the Italian and Spanish air forces. It is matched in the air with the Russian Sukhoi SU-27 Flanker (right) The German pilots have scrambled 34 times since they were posted in Estonia on August 31, with Sukhoi SU-27 Flanker jets the most common threat. The Russian planes are free to fly along an international airspace corridor running between St Petersburg and the Kaliningrad enclave and west as far as the Danish island of Falster. Russian pilots often fly without transponders, making them virtually invisible and increasing the danger of mid-air collisions. Lt Col Jacob told the Post: ‘The fighter aircraft are almost always armed to the teeth. Six kinds of missiles. They could carry up to 10.’ This Sukhoi SU-27 Flanker showed off its abilities at the Farnborough air show a few years ago, before the icy blasts of the new cold war descended on Europe The Flanker’s full armoury includes Vympel R-27, R-73 and R-77 air-to-air missiles, Zvezda Kh-35U anti-ship missiles, S-8 and S-13 rockets and a collection of guided bombs and cluster bombs. The French air force also has four fighter jets based at Šiauliai in Lithuania. Both the French and German contingents are due to be rotated out of the area in January and replaced by other Nato pilots, including possibly RAF pilots from Britain. \n+20 Goodybe Mr President: Russia’s President Putin (left) has massively increased Russian military spending and anti-Western rhetoric and most experts agree he has outmanouevred President Obama (right) militarily and politically The Baltic states seized their independence from the collapsing Soviet Union in 1991 and, increasingly worried about the Russian bear on their doorstep, joined Nato in 2004. Putin was enraged that Nato was within 100 miles of Russia’s second city, St Petersburg, and in the last year he has been increasingly probing Nato’s defences in the region. Yesterday Nato chiefs announced plans to put together a force of 300,000 troops which they can put on ‘high alert’ in eastern Europe. Relations between Russia and the West have plunged in the last year, with Moscow’s insistence on backing its Syrian ally, President Bashar al-Assad, at all costs leading to serious tension with the US, Britain and France. Most Nato members cut their defence spending dramatically since the Soviet Union collapsed in 1991 but Russia has been bolstering its military capabilities, holding parades involving more than 100,000 troops each year. \n+20 Nato soldiers stand on a pontoon bridge constructed across the Vistula river in Poland during the NATO Anaconda-16 exercise earlier this year Moscow has been throwing its weight around in recent years – in 2008 Russian troops humiliated the Georgians and in turn the White House by invading South Ossetia and Abkhazia in support of pro-Moscow rebels. Then in 2014 Russia annexed Crimea and supported ethnic Russian rebels in the eastern Ukraine. President Obama’s ‘Russian reset’ policy, which was designed to improve relations with Moscow, has looked increasingly like a policy of appeasement. \n+20 At the weekend Russian soldiers, dressed in World War Two era uniforms, commemorate the 75th anniversary of a famous parade in 1941 when the Red Army headed out of Moscow to take on the Nazis Russia’s President Vladimir Putin has been accused of attempting to interfere with the US election process by hacking into the emails of senior members of the Democratic party and recently moved the Iskander nuclear-capable missiles into the Kaliningrad enclave, on the borders with Poland. But Nato members like Estonia, Poland and Romania, who are feeling increasingly threatened by Moscow, are now being promised a rapid deployment force. Nato Secretary General Jens Stoltenberg told The Times this week: ‘We have also seen Russia using propaganda in Europe among Nato allies and that is exactly the reason why Nato is responding. We are responding with the biggest reinforcement of our collective defence since the end of the Cold War. ‘We have seen Russia being much more active in many different ways. ‘We have seen a more assertive Russia implementing a substantial military build-up over many years; tripling defence spending since 2000 in real terms; developing new military capabilities; exercising their forces and using military force against neighbours,’ added Mr Stoltenberg. \n+20 Russia recently moved its nuclear-capable Iskander missiles into the Kaliningrad enclave. The missiles could take out targets in Berlin Britain’s permanent representative to Nato, Sir Adam Thomson, told The Times it would currently take Nato six months to deploy a force of 300,000, which was simply too slow. At the weekend British military intelligence officers issued a warning over a new Russian ‘super tank’ which they claim is far superior to anything which is available to Nato. The document claims that Britain’s Challenger II main battle tank could be overpowered by the Kremlin’s new Armata tank. Officials believe the new Russian tank is ‘revolutionary’ and blames the government for failing to provide a proper response. The new tank has several highly advanced features including an un-manned turret which makes the machine safer for crews Yesterday’s military parade in Red Square commemorated a pivotal moment in World War Two when German forces were turned back from the gates of Moscow",
		"thread_title": "NATO fighter jets on constant watch for Russian jets above Baltic states",
		"title": "NATO fighter jets on constant watch for Russian jets above Baltic states",
		"type": "bs",
		"uuid": "91e473fe89691fd3073c1a2260aaf4c2d8938c7b"
	},
	"-KhIh_42SAy2_yHo-i77": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T01:14:46.436+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Election Mood Setting Music",
				"salience": 0.73427397,
				"type": "OTHER"
			},
			{
				"name": "Family",
				"salience": 0.26572606,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/img-hillary-vs-trump-dancing-debate-112.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T01:14:46.436+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Election Mood Setting Music for You and Your Family 11/08/2016 11/08/2016  ",
		"thread_title": "Election Mood Setting Music for You and Your Family",
		"title": "Election Mood Setting Music for You and Your Family",
		"type": "bs",
		"uuid": "d63dec5d5969d8c21f96217ce3fa2555703b99d4"
	},
	"-KhIh_9cY3zAsECNcg8P": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T01:14:46.534+02:00",
		"domain_rank": "",
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/963aff_3490162.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T01:14:46.534+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "11/08/2016  ",
		"thread_title": "2009 FLASHBACK: “What If” Remixed",
		"title": "2009 FLASHBACK: “What If” Remixed",
		"type": "bs",
		"uuid": "cde9b30603cff1cb2105a853c00fd134a5cee716"
	},
	"-KhIh_KhVQ3j2mDzuvw9": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T19:23:44.336+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0478__m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lady_Gaga"
				},
				"name": "Lady Gaga",
				"salience": 0.38006026,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.15662704,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.06582775,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.039838918,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04qqj8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump_Tower_(New_York_City)"
				},
				"name": "Trump Tower",
				"salience": 0.032386962,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.028709784,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.026908489,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.025881326,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02lw5z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/E!"
				},
				"name": "E! ONLINE",
				"salience": 0.021389965,
				"type": "ORGANIZATION"
			},
			{
				"name": "rally",
				"salience": 0.015763491,
				"type": "EVENT"
			},
			{
				"name": "sign",
				"salience": 0.015763491,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.01537716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0807c3_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bad_Romance"
				},
				"name": "Bad Romance",
				"salience": 0.01096617,
				"type": "WORK_OF_ART"
			},
			{
				"name": "everyone",
				"salience": 0.010737019,
				"type": "PERSON"
			},
			{
				"name": "career",
				"salience": 0.010309515,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.007343116,
				"type": "OTHER"
			},
			{
				"name": "s building",
				"salience": 0.007343116,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0060242536,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.0057268646,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.0057268646,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048knlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Love"
				},
				"name": "Love",
				"salience": 0.0052232915,
				"type": "WORK_OF_ART"
			},
			{
				"name": "education",
				"salience": 0.005152233,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.005152233,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.005152233,
				"type": "OTHER"
			},
			{
				"name": "prayer",
				"salience": 0.005152233,
				"type": "OTHER"
			},
			{
				"name": "strengths",
				"salience": 0.005152233,
				"type": "OTHER"
			},
			{
				"name": "Nothing",
				"salience": 0.0049602115,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0049602115,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0049602115,
				"type": "LOCATION"
			},
			{
				"name": "kindness",
				"salience": 0.0049602115,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0049602115,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.0048578475,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0045973314,
				"type": "OTHER"
			},
			{
				"name": "women's rights",
				"salience": 0.0042073284,
				"type": "OTHER"
			},
			{
				"name": "wisdom",
				"salience": 0.0042073284,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0042073284,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0031439052,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.0031439052,
				"type": "OTHER"
			},
			{
				"name": "gratitude",
				"salience": 0.0031439052,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0031439052,
				"type": "ORGANIZATION"
			},
			{
				"name": "destiny",
				"salience": 0.0022902105,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.0022902105,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0022902105,
				"type": "OTHER"
			},
			{
				"name": "partnership",
				"salience": 0.0022902105,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0022902105,
				"type": "OTHER"
			},
			{
				"name": "common ground",
				"salience": 0.0022902105,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0019758698,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.0017110083,
				"type": "EVENT"
			},
			{
				"name": "need",
				"salience": 0.0017110083,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0017110083,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/rs_1024x759-161109051946-1024.Lady-Gaga-Election-Day-JR-110916.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T19:23:44.336+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.5,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Lady Gaga Protests Donald Trump Outside of Trump Tower 11/09/2016 \nE! ONLINE \nLady Gaga took to Trump Tower early Wednesday morning to protest the results of the U.S. election. \nThe “Bad Romance” singer, a well-known Hillary Clinton supporter, stood outside Donald Trump ‘s building and held a sign that read “Love trumps hate.” As the hours passed Tuesday night and it became clearer that Trump would win the presidency, Gaga tweeted, “In a room full of hope, we will be heard. Stand up for kindness, equality, and love. Nothing will stop us. Say a prayer America.” \nGaga campaigned for Clinton earlier this week, attending a rally where she spoke of Clinton’s strengths. “She has a career in politics that spans decades of experience, education, leadership, and wisdom. She’s ready to be president,” she said. “She kept going and she kept fighting for women’s rights. She kept fighting for the care of our children. She kept fighting for those that are in need.”Trump’s victory was declared around 2:30 a.m. ET, and during his speech he praised Clinton’s efforts throughout the election. He said she was owed a “deep debt of gratitude” for all her hard work. “We will get along with all other nations willing to get along with us. We will deal fairly with everyone. We will seek common ground, partnership not conflict,” he added in his speech. “America will no longer settle for anything less than the best. We must reclaim our destiny.”",
		"thread_title": "Lady Gaga Protests Donald Trump Outside of Trump Tower",
		"title": "Lady Gaga Protests Donald Trump Outside of Trump Tower",
		"type": "bs",
		"uuid": "9aab4aec865814cf27eeae53c4689a83adf74a8a"
	},
	"-KhIh_XTTjlNu8uC0liE": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T19:23:46.958+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.18384689,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "New York City Police Department",
				"salience": 0.14028245,
				"type": "ORGANIZATION"
			},
			{
				"name": "Dump Trucks",
				"salience": 0.06303465,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "dump trucks",
				"salience": 0.06303465,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "perimeter",
				"salience": 0.059386298,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04qqj8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump_Tower_(New_York_City)"
				},
				"name": "Trump Tower",
				"salience": 0.040304665,
				"type": "LOCATION"
			},
			{
				"name": "Anticipation Of Violence",
				"salience": 0.027769974,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "DAILY CALLER",
				"salience": 0.027769974,
				"type": "PERSON"
			},
			{
				"name": "building",
				"salience": 0.026001832,
				"type": "LOCATION"
			},
			{
				"name": "New York Hilton Midtown Manhattan Hotel",
				"salience": 0.022869676,
				"type": "LOCATION"
			},
			{
				"name": "anticipation",
				"salience": 0.018635496,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.018635496,
				"type": "OTHER"
			},
			{
				"name": "dump trucks",
				"salience": 0.013505975,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.011500295,
				"type": "EVENT"
			},
			{
				"name": "beds",
				"salience": 0.01018761,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.010042602,
				"type": "LOCATION"
			},
			{
				"name": "trucks",
				"salience": 0.00913014,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Police",
				"salience": 0.0085649,
				"type": "PERSON"
			},
			{
				"name": "skyscraper",
				"salience": 0.008271029,
				"type": "LOCATION"
			},
			{
				"name": "sides",
				"salience": 0.008271029,
				"type": "OTHER"
			},
			{
				"name": "guardrails",
				"salience": 0.008271029,
				"type": "OTHER"
			},
			{
				"name": "police officers",
				"salience": 0.008271029,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.008246085,
				"type": "PERSON"
			},
			{
				"name": "truck",
				"salience": 0.007746196,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "headquarters",
				"salience": 0.006700519,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.006450925,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.006450925,
				"type": "LOCATION"
			},
			{
				"name": "public",
				"salience": 0.006450925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.006435985,
				"type": "PERSON"
			},
			{
				"name": "RELATED",
				"salience": 0.005803765,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.005803765,
				"type": "EVENT"
			},
			{
				"name": "Election Day Voting",
				"salience": 0.005803765,
				"type": "EVENT"
			},
			{
				"name": "penthouse",
				"salience": 0.005803765,
				"type": "LOCATION"
			},
			{
				"name": "top",
				"salience": 0.005803765,
				"type": "OTHER"
			},
			{
				"name": "corridor",
				"salience": 0.005587501,
				"type": "LOCATION"
			},
			{
				"name": "press corps",
				"salience": 0.005587501,
				"type": "ORGANIZATION"
			},
			{
				"name": "interviews",
				"salience": 0.005587501,
				"type": "EVENT"
			},
			{
				"name": "traffic",
				"salience": 0.005587501,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.005587501,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.005178799,
				"type": "PERSON"
			},
			{
				"name": "Guests",
				"salience": 0.005145308,
				"type": "PERSON"
			},
			{
				"name": "Police",
				"salience": 0.005034059,
				"type": "PERSON"
			},
			{
				"name": "effect",
				"salience": 0.004739537,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.004739537,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.004739537,
				"type": "OTHER"
			},
			{
				"name": "sand",
				"salience": 0.004739537,
				"type": "OTHER"
			},
			{
				"name": "hotel",
				"salience": 0.0045287833,
				"type": "LOCATION"
			},
			{
				"name": "hotel",
				"salience": 0.0045287833,
				"type": "LOCATION"
			},
			{
				"name": "headquarters",
				"salience": 0.0042479285,
				"type": "LOCATION"
			},
			{
				"name": "public",
				"salience": 0.0040895445,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.0040895445,
				"type": "OTHER"
			},
			{
				"name": "victory rally",
				"salience": 0.0039194906,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01fdzj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tower"
				},
				"name": "Tower",
				"salience": 0.00373231,
				"type": "LOCATION"
			},
			{
				"name": "business",
				"salience": 0.0035417348,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.003441281,
				"type": "ORGANIZATION"
			},
			{
				"name": "barrier",
				"salience": 0.0032411485,
				"type": "LOCATION"
			},
			{
				"name": "trucks",
				"salience": 0.0031526955,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "trucks",
				"salience": 0.0031526955,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "security check-point",
				"salience": 0.0025800948,
				"type": "OTHER"
			},
			{
				"name": "premises",
				"salience": 0.0025800948,
				"type": "LOCATION"
			},
			{
				"name": "security measures",
				"salience": 0.0025800948,
				"type": "OTHER"
			},
			{
				"name": "keycards",
				"salience": 0.0025800948,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0022259923,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "The Daily Caller News Foundation",
				"salience": 0.0019703368,
				"type": "ORGANIZATION"
			},
			{
				"name": "fleet",
				"salience": 0.0019276211,
				"type": "OTHER"
			},
			{
				"name": "munition",
				"salience": 0.0019276211,
				"type": "OTHER"
			},
			{
				"name": "car bombs",
				"salience": 0.0019276211,
				"type": "OTHER"
			},
			{
				"name": "hedge",
				"salience": 0.0019276211,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0015883234,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07fnrc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jacob_K._Javits_Convention_Center"
				},
				"name": "Javits Convention Center",
				"salience": 0.0015883234,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015jh6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hell's_Kitchen,_Manhattan"
				},
				"name": "Hell's Kitchen",
				"salience": 0.0015883234,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/1108-trump-tower-dump-trucks-sub-tmz-4.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T19:23:46.958+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Trump Tower Surrounded By Dump Trucks In Anticipation Of Violence 11/09/2016 \nDAILY CALLER \nThe New York City Police Department (NYPD) has surrounded the perimeter of Trump Tower with reinforced dump trucks in anticipation of Election Day violence. \nThe dump trucks flank the skyscraper on all sides, and are supplemented by guardrails and heavily armed police officers. This morning, the building was not open to the general public and traffic crawled through a narrow corridor of trucks and police. On the street, supporters and protesters stood for interviews with a burgeoning press corps camped across the street. Republican presidential nominee Donald Trump lives in a penthouse near the top of the building, which also serves as headquarters for his presidential campaign. (RELATED: Election Day Voting Has Begun – Who Is Winning?) \nPolice told The Daily Caller News Foundation that the dumping beds are filled with sand, which adds weight to each truck, in effect making it impossible to run the barrier. Police decided to circle the Tower with trucks as a hedge against car bombs, or some such similar incendiary munition delivered by car. The fleet of trucks will travel with Trump this evening to surround the New York Hilton Midtown Manhattan Hotel, where Trump is hosting his victory rally. The NYPD maintained a presence around the hotel for several days, which is also closed to the public. \nGuests staying in the hotel on unrelated business must present their keycards at a security check-point before entering the premises. \nSimilar security measures will attend Democratic presidential nominee Hillary Clinton’s headquarters at the Javits Convention Center in Hell’s Kitchen this evening.",
		"thread_title": "Trump Tower Surrounded By Dump Trucks In Anticipation Of Violence",
		"title": "Trump Tower Surrounded By Dump Trucks In Anticipation Of Violence",
		"type": "bs",
		"uuid": "58f39f82c2ab67116dc0b3af734342d22b61183e"
	},
	"-KhIh_j91HD5dt1dM5MZ": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T19:23:48.469+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "protesters",
				"salience": 0.27552918,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.09404346,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.058577184,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.042589527,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.038518105,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.034631703,
				"type": "LOCATION"
			},
			{
				"name": "Shouts",
				"salience": 0.03342269,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.031310987,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.025802791,
				"type": "EVENT"
			},
			{
				"name": "PBS Moments",
				"salience": 0.020677172,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.020677172,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.020677172,
				"type": "ORGANIZATION"
			},
			{
				"name": "protesters",
				"salience": 0.015380744,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.014593679,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07ypg4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Nexus"
				},
				"name": "Daily Nexus",
				"salience": 0.014312731,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.013864469,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.012894067,
				"type": "PERSON"
			},
			{
				"name": "highway",
				"salience": 0.011127175,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01p06z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles_Times"
				},
				"name": "Los Angeles Times",
				"salience": 0.01021284,
				"type": "ORGANIZATION"
			},
			{
				"name": "campuses",
				"salience": 0.009071581,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01f1r4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Santa_Barbara"
				},
				"name": "University of California, Santa Barbara",
				"salience": 0.00741243,
				"type": "ORGANIZATION"
			},
			{
				"name": "media outlets",
				"salience": 0.0070974664,
				"type": "ORGANIZATION"
			},
			{
				"name": "hundreds",
				"salience": 0.006366419,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0062863682,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0060028383,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0060028383,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.005870524,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0057494207,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0057494207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dc95",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oakland,_California"
				},
				"name": "Oakland",
				"salience": 0.005708292,
				"type": "LOCATION"
			},
			{
				"name": "videos",
				"salience": 0.0055351984,
				"type": "WORK_OF_ART"
			},
			{
				"name": "social media",
				"salience": 0.0055351984,
				"type": "OTHER"
			},
			{
				"name": "John O'Reilly",
				"salience": 0.0055223755,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.005377135,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07vjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_San_Diego"
				},
				"name": "UC San Diego",
				"salience": 0.0052242563,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-Trump",
				"salience": 0.0050484543,
				"type": "ORGANIZATION"
			},
			{
				"name": "chants",
				"salience": 0.004979771,
				"type": "OTHER"
			},
			{
				"name": "expletives",
				"salience": 0.004979771,
				"type": "OTHER"
			},
			{
				"name": "closure",
				"salience": 0.0047941683,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.0047941683,
				"type": "OTHER"
			},
			{
				"name": "Photos",
				"salience": 0.0047941683,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.0046952264,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dozens",
				"salience": 0.004557394,
				"type": "PERSON"
			},
			{
				"name": "protester",
				"salience": 0.00406977,
				"type": "PERSON"
			},
			{
				"name": "dorms",
				"salience": 0.004066459,
				"type": "LOCATION"
			},
			{
				"name": "flag",
				"salience": 0.004066459,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.004066459,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hundreds",
				"salience": 0.0038856016,
				"type": "PERSON"
			},
			{
				"name": "anti-Trump",
				"salience": 0.0035412312,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0030386106,
				"type": "LOCATION"
			},
			{
				"name": "downtown",
				"salience": 0.0030386106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gdjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bay_Area_Rapid_Transit"
				},
				"name": "Bay Area Rapid Transit",
				"salience": 0.0029524146,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gdjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bay_Area_Rapid_Transit"
				},
				"name": "BART",
				"salience": 0.0029524146,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.0029276528,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09f2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Los_Angeles"
				},
				"name": "UCLA",
				"salience": 0.0028443339,
				"type": "ORGANIZATION"
			},
			{
				"name": "authorities",
				"salience": 0.002643248,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.0025039755,
				"type": "LOCATION"
			},
			{
				"name": "fires",
				"salience": 0.0022134895,
				"type": "EVENT"
			},
			{
				"name": "car",
				"salience": 0.0022134895,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "campus",
				"salience": 0.0021149714,
				"type": "LOCATION"
			},
			{
				"name": "campus",
				"salience": 0.0021149714,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon"
				},
				"name": "Oregon",
				"salience": 0.001870758,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01v9vx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco_Chronicle"
				},
				"name": "San Francisco Chronicle",
				"salience": 0.001870758,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, D.C.",
				"salience": 0.001870758,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02frhbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portland,_Oregon"
				},
				"name": "Portland",
				"salience": 0.001870758,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0723bk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_State_Route_20"
				},
				"name": "Highway 20",
				"salience": 0.0017427307,
				"type": "LOCATION"
			},
			{
				"name": "Officials",
				"salience": 0.001661099,
				"type": "PERSON"
			},
			{
				"name": "Elsewhere",
				"salience": 0.0016536812,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.0012473612,
				"type": "PERSON"
			},
			{
				"name": "BuzzFeed News",
				"salience": 0.0010620996,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0010178846,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0c5x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Irvine"
				},
				"name": "UC Irvine",
				"salience": 0.0010178846,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vhb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_Santa_Cruz"
				},
				"name": "UC Santa Cruz",
				"salience": 0.0010178846,
				"type": "ORGANIZATION"
			},
			{
				"name": "reports",
				"salience": 0.0008444532,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/RTX2SQDV-1024x682.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T19:23:48.469+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Shouts of ‘Not my president!’ in California, following Trump victory 11/09/2016 \nPBS \nMoments after Donald Trump’s stunning victory over Hillary Clinton for the White House, protests erupted in California and other states, including people crying “Not my president!” \nThe Los Angeles Times and other media outlets reported anti-Trump protesters amassing around the campuses of the University of California, Santa Barbara, and UC San Diego, among others. \nIn Oakland, the overnight protests led to a partial closure of the Bay Area Rapid Transit, or BART, the Times reported. \nPhotos and videos on social media captured the protesters marching and yelling “Who’s got the power? We got the power,” “Not my president!” and other anti-Trump chants filled with expletives . \nUCSB student newspaper the Daily Nexus reported that hundreds of students left their dorms to protest. In the video captured by the paper below, one student is seen carrying a Mexican flag. \nLikewise, hundreds of students at UC San Diego and UCLA demonstrated on campus early Wednesday morning. There also were reports of protests at UC Santa Cruz and UC Irvine. Officials said there were as many as 3,000 students that marched through the UCLA campus, ABC reported . \nElsewhere in the country, protests were reported in Portland, Oregon and Washington, D.C. \nIn Oakland, authorities said dozens of protesters gathered downtown, while hundreds blocked a local highway. \nThe San Francisco Chronicle also reported that a 20-year-old protester was severely injured after being hit by a car on Highway 20. Protesters had blocked the highway and lit several fires, officer John O’Reilly told BuzzFeed News .",
		"thread_title": "Shouts of ‘Not my president!’ in California, following Trump victory",
		"title": "Shouts of ‘Not my president!’ in California, following Trump victory",
		"type": "bs",
		"uuid": "f1f2048ecd9edd3e0ce124437316f00bc87d841c"
	},
	"-KhIha46A5vwoSmnQ2_W": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T19:23:50.222+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "establishment",
				"salience": 0.1647418,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.13898502,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.05304242,
				"type": "OTHER"
			},
			{
				"name": "inflation",
				"salience": 0.02721629,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.02329056,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.022024626,
				"type": "PERSON"
			},
			{
				"name": "Elites",
				"salience": 0.019645073,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0nfwhxb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom_European_Union_membership_referendum"
				},
				"name": "Brexit",
				"salience": 0.018686855,
				"type": "LOCATION"
			},
			{
				"name": "establishment",
				"salience": 0.018420512,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.017024582,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01fnc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_of_England"
				},
				"name": "Bank of England",
				"salience": 0.014956497,
				"type": "ORGANIZATION"
			},
			{
				"name": "billionaires",
				"salience": 0.014646612,
				"type": "PERSON"
			},
			{
				"name": "SILVERISTHENEW",
				"salience": 0.012155603,
				"type": "ORGANIZATION"
			},
			{
				"name": "stability.",
				"salience": 0.010691427,
				"type": "OTHER"
			},
			{
				"name": "Banked On Trump Victory",
				"salience": 0.010498913,
				"type": "WORK_OF_ART"
			},
			{
				"name": "path",
				"salience": 0.01013577,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.01013577,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.008714563,
				"type": "OTHER"
			},
			{
				"name": "win",
				"salience": 0.0086696865,
				"type": "EVENT"
			},
			{
				"name": "magic formula",
				"salience": 0.008384165,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00787017,
				"type": "PERSON"
			},
			{
				"name": "stagnation",
				"salience": 0.00787017,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0071708425,
				"type": "EVENT"
			},
			{
				"name": "angst",
				"salience": 0.0068168137,
				"type": "OTHER"
			},
			{
				"name": "uses",
				"salience": 0.0068168137,
				"type": "OTHER"
			},
			{
				"name": "by-product",
				"salience": 0.0068168137,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "war",
				"salience": 0.0068168137,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.0068168137,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.0068168137,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0068168137,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0068168137,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0068168137,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.006357326,
				"type": "OTHER"
			},
			{
				"name": "Eric Peters",
				"salience": 0.00625584,
				"type": "PERSON"
			},
			{
				"name": "break",
				"salience": 0.006043381,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.00589462,
				"type": "OTHER"
			},
			{
				"name": "conservatives",
				"salience": 0.0057215774,
				"type": "PERSON"
			},
			{
				"name": "globalists",
				"salience": 0.005665133,
				"type": "PERSON"
			},
			{
				"name": "stability",
				"salience": 0.0045395964,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.004367257,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0041472777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03c9qj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Carney"
				},
				"name": "Mark Carney",
				"salience": 0.0041163214,
				"type": "PERSON"
			},
			{
				"name": "establishment",
				"salience": 0.0038875183,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0035916097,
				"type": "EVENT"
			},
			{
				"name": "ingredient",
				"salience": 0.0034836633,
				"type": "OTHER"
			},
			{
				"name": "globalists",
				"salience": 0.0033070995,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025wvyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quantitative_easing"
				},
				"name": "QE",
				"salience": 0.0032825125,
				"type": "ORGANIZATION"
			},
			{
				"name": "elites",
				"salience": 0.0032800946,
				"type": "PERSON"
			},
			{
				"name": "volatility",
				"salience": 0.0032453374,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.003243072,
				"type": "OTHER"
			},
			{
				"name": "instability",
				"salience": 0.003243072,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.003243072,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.003243072,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.003243072,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.003243072,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.003243072,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003243072,
				"type": "PERSON"
			},
			{
				"name": "inflation",
				"salience": 0.0032332698,
				"type": "OTHER"
			},
			{
				"name": "disquiet",
				"salience": 0.003030349,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0029861443,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.002950595,
				"type": "PERSON"
			},
			{
				"name": "elite",
				"salience": 0.0029084692,
				"type": "PERSON"
			},
			{
				"name": "returns",
				"salience": 0.002808441,
				"type": "OTHER"
			},
			{
				"name": "easing",
				"salience": 0.002808441,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.002808441,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.002808441,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.002808441,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.002808441,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0027902585,
				"type": "OTHER"
			},
			{
				"name": "inflation",
				"salience": 0.0027421052,
				"type": "OTHER"
			},
			{
				"name": "banking",
				"salience": 0.0027262315,
				"type": "OTHER"
			},
			{
				"name": "Brandon Smith",
				"salience": 0.0026919346,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.002537612,
				"type": "OTHER"
			},
			{
				"name": "inflation volatility",
				"salience": 0.0025186439,
				"type": "OTHER"
			},
			{
				"name": "volatility",
				"salience": 0.0025186439,
				"type": "OTHER"
			},
			{
				"name": "uprising",
				"salience": 0.0024429199,
				"type": "EVENT"
			},
			{
				"name": "magic formula",
				"salience": 0.002422966,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.002422966,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0023924443,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0023745603,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0022741512,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0022741512,
				"type": "OTHER"
			},
			{
				"name": "lemons",
				"salience": 0.0022741512,
				"type": "OTHER"
			},
			{
				"name": "banksters",
				"salience": 0.0022257518,
				"type": "ORGANIZATION"
			},
			{
				"name": "interest rates",
				"salience": 0.0021892833,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00212213,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.0020717352,
				"type": "OTHER"
			},
			{
				"name": "wild card candidacy",
				"salience": 0.002056247,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.002056247,
				"type": "EVENT"
			},
			{
				"name": "close",
				"salience": 0.0019692893,
				"type": "EVENT"
			},
			{
				"name": "expectations",
				"salience": 0.0019692893,
				"type": "OTHER"
			},
			{
				"name": "inflation target",
				"salience": 0.0019692893,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "currency devaluation",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "immigration restrictions",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "price gains",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "inflation overshoot",
				"salience": 0.001895791,
				"type": "EVENT"
			},
			{
				"name": "process",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "uncertainty",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "surge",
				"salience": 0.001895791,
				"type": "EVENT"
			},
			{
				"name": "spenders",
				"salience": 0.001895791,
				"type": "PERSON"
			},
			{
				"name": "revelation",
				"salience": 0.001895791,
				"type": "OTHER"
			},
			{
				"name": "master manipulators",
				"salience": 0.0018835136,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0018803035,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0018566134,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0018566134,
				"type": "OTHER"
			},
			{
				"name": "rates",
				"salience": 0.0018101245,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.001773955,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0017288284,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0017206076,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.0017129229,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0017129229,
				"type": "OTHER"
			},
			{
				"name": "lemonade",
				"salience": 0.0016775223,
				"type": "OTHER"
			},
			{
				"name": "stock market collapse",
				"salience": 0.0016076949,
				"type": "EVENT"
			},
			{
				"name": "choice",
				"salience": 0.0016076949,
				"type": "OTHER"
			},
			{
				"name": "speculation",
				"salience": 0.0016076949,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0016076949,
				"type": "OTHER"
			},
			{
				"name": "discontent",
				"salience": 0.0016076949,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.0016076949,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0014920732,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0013869542,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0012920083,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0012920083,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.0012009786,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.0012009786,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.0012009786,
				"type": "EVENT"
			},
			{
				"name": "rug",
				"salience": 0.0012009786,
				"type": "OTHER"
			},
			{
				"name": "FAVOR",
				"salience": 0.0012009786,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0011761542,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0011709003,
				"type": "OTHER"
			},
			{
				"name": "River Asset Management",
				"salience": 0.001166882,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.001166882,
				"type": "LOCATION"
			},
			{
				"name": "post-Brexit",
				"salience": 0.001166882,
				"type": "LOCATION"
			},
			{
				"name": "candidates",
				"salience": 0.0011187593,
				"type": "PERSON"
			},
			{
				"name": "electorate",
				"salience": 0.0011187593,
				"type": "PERSON"
			},
			{
				"name": "globalism",
				"salience": 0.0011187593,
				"type": "OTHER"
			},
			{
				"name": "Tumelar",
				"salience": 0.0010951862,
				"type": "PERSON"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.00101494,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0010101127,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0010101127,
				"type": "PERSON"
			},
			{
				"name": "reasons",
				"salience": 0.0010101127,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0010101127,
				"type": "OTHER"
			},
			{
				"name": "puppets",
				"salience": 0.0010101127,
				"type": "OTHER"
			},
			{
				"name": "puppeteer",
				"salience": 0.0010101127,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y7_v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Janet_Yellen"
				},
				"name": "Yellen",
				"salience": 0.0009895194,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "WW3",
				"salience": 0.0009895194,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02xmb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Reserve_System"
				},
				"name": "Fed",
				"salience": 0.0009895194,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0009895194,
				"type": "LOCATION"
			},
			{
				"name": "scapegoat",
				"salience": 0.0009804135,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.00096512947,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.0008904142,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.000874653,
				"type": "EVENT"
			},
			{
				"name": "philosophy",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "dialectic",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "establishment opposition",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "market conditions",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.000874653,
				"type": "PERSON"
			},
			{
				"name": "ideal",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.000874653,
				"type": "LOCATION"
			},
			{
				"name": "existence",
				"salience": 0.000874653,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0008357005,
				"type": "EVENT"
			},
			{
				"name": "outcome",
				"salience": 0.0007545359,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0007545359,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0007545359,
				"type": "EVENT"
			},
			{
				"name": "institution",
				"salience": 0.0007545359,
				"type": "ORGANIZATION"
			},
			{
				"name": "catalyst",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "alternative media",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "controls",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0006533426,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.0006533426,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "mainstream",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "downfall",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "shadows",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.0006533426,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "unpredictability",
				"salience": 0.0006533426,
				"type": "OTHER"
			},
			{
				"name": "demands",
				"salience": 0.0006451078,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjkjr"
				},
				"name": "Hegelian",
				"salience": 0.0005382899,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/donaldtrump-fear.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T19:23:50.222+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14,
			"score": 0
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Elites Have Secretly “Banked On Trump Victory 11/09/2016 \nSILVERISTHENEW \nThere’s more than one way for the establishment to yield power from this election. \nThe first path is obvious, direct and potentially deadly. A Hillary presidency will be surrounded by bitter people, and overt uses of power, along with war, increased taxes and thinly-veiled pay-for-play politics benefiting the billionaires who’ve bankrolled her rise to power. \nThe other path is less predictable, but possible just the perfect “magic formula” they need to get things flowing again. \nThe Brexit vote, a by-product of populist anger against economic stagnation and political angst, was secretly a win for those who wield power from the financial sector. \nIn the end, the disquiet of the people has proven to be the secret ingredient to stirring something up in an economy otherwise stymied by quantitative easing and dismal economic returns. \nAs Zero Hedge explains , it just may be, particularly in light of some of the statements that have been made by significant figures on Wall Street: \nSo yes, inflation is possible, it just can’t coexist with political stability, which may explain why – according to some more conspiratorial elements – a “surprising” Trump victory on Tuesday may be assured : after all, what better way to unleash political instability than to inaugurate the candidate who promises a full break with the establishment as we know it. If in the process, it leads to a surge in much needed inflation, now that QE has tried and failed, it’s a price the establishment, reeling under the weight of record global debt, is willing to pay. \nOne River Asset Management’s Eric Peters laying out his inflationary “revelation”: “British spenders have entirely looked through post-Brexit uncertainty,” said Mark Carney [governor of the Bank of England]. … So the Bank of England forecast its biggest inflation overshoot since 1997; expecting 2018 price gains to peak at +2.8%. What’s it tell us? \nA populist uprising, compromised free trade, immigration restrictions, a 15% currency devaluation, 0.50% interest rates combined with aggressive QE is today’s magic formula for modestly exceeding a 2% inflation target 2yrs hence. \n[…]we live in the 2010s, and inflationary expectations have succumbed to decades of independent central banking. Economic volatility is remarkably muted too. With it has come a long period of political stability. […] And we also know that a long period of political stability is drawing to a close. \nBut we can’t be sure that political volatility will increase inflation volatility. Nor can we be sure that it won’t. It all depends on time and place. And today’s time and place is something new. \nIs this proof that the elite are secretly planning to make lemonade from the lemons of American discontent and the wild card candidacy of Donald Trump? \nThat is a difficult call to make, but it is worth noting that there is clearly an advantage to be held if this outcome does occur. \nAs Tumelar notes, the fix is in either way: \nIt’s either inflation by Trump’s victory or by WW3 started by Hillary Clinton. \nA hard choice for the banksters. \nOf course, the situation is much more complicated than just inflation, or any one factor. There is a great deal of speculation that the end of QE, known to be no longer effective at stimulating the economy has made a stock market collapse inevitable, subject to the Fed raises rates. \nIt appears that Yellen has been waiting for the outcome of the election, and one way or another, will dump the next crisis on the next president. If that proves to be Trump, he will be blamed for the downfall… meanwhile, there will be those waiting in the shadows to profit from disaster. \nFor his part, astute columnist Brandon Smith has consistently argued that the elite have chosen Trump and will allow him to take the presidency – only to use the unpredictability as a catalyst for order out of chaos, and the institution of great political and economic controls over the country: \nThe vast majority of analysts in the mainstream and in the alternative media refused to acknowledge the possibility that a successful Brexit actually works in FAVOR of the globalists, because it provides them a perfect scapegoat for a financial crisis that has been broiling for years and is now ready to burst into flames. \n[…] \nI argue that the globalists want Trump in office, just as they wanted the passage of the Brexit. I argue that they need conservative movements to feel as though we have won, so that they can pull the rug out from under us in the near future. I argue that we are being set up. \nAgain, the elites are openly telling us what is about to happen. They are telling us that if “populists” (conservatives) gain political power, the system will effectively collapse. To what extent is hard to say, but let’s assume that the situation will be ugly enough to influence the masses to reconsider the ideal of globalism as a possible solution. The elites are fond of the Hegelian dialectic and the philosophy of “order out of chaos,” after all. \nAgain, the reasons parallel the reasons that Brexit was able to succeed in spite of fierce establishment opposition. \nThe master manipulators are adaptive to any market conditions, and their influence runs deeper than the electorate of any given political season. Its agents and officers instruct the candidates and make demands, not the other way around. \nIn a puppeteer’s world, must we always argue for the existence of puppets on every stage? \nRead more:",
		"thread_title": "Elites Have Secretly “Banked On Trump Victory",
		"title": "Elites Have Secretly “Banked On Trump Victory",
		"type": "bs",
		"uuid": "82ea2fe1ffeda674f2c74e0717972b862a79002b"
	},
	"-KhIhaEHsPcHrRA3A150": {
		"author": "Alex Ansary",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-09T19:23:50.481+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.19301523,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.1844184,
				"type": "LOCATION"
			},
			{
				"name": "cruise missiles",
				"salience": 0.05282023,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.049544502,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.02723297,
				"type": "OTHER"
			},
			{
				"name": "navy",
				"salience": 0.022756694,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.019893115,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.019729264,
				"type": "EVENT"
			},
			{
				"name": "group",
				"salience": 0.019181192,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01xyg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cruise_missile"
				},
				"name": "Cruise Missiles",
				"salience": 0.018952062,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.017308762,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cy4y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Defence_(United_Kingdom)"
				},
				"name": "Ministry of Defence",
				"salience": 0.014055141,
				"type": "ORGANIZATION"
			},
			{
				"name": "missile cruiser",
				"salience": 0.013979859,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.012179364,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "DAILY MAIL",
				"salience": 0.012179364,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.010479278,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.010457468,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.0103501305,
				"type": "LOCATION"
			},
			{
				"name": "destroyers",
				"salience": 0.010112253,
				"type": "OTHER"
			},
			{
				"name": "ships",
				"salience": 0.010112253,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.010112253,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.009403478,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.009109594,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar-al-Assad",
				"salience": 0.008174658,
				"type": "PERSON"
			},
			{
				"name": "planes",
				"salience": 0.008146375,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.0073782704,
				"type": "EVENT"
			},
			{
				"name": "missile strikes",
				"salience": 0.0073782704,
				"type": "EVENT"
			},
			{
				"name": "missiles",
				"salience": 0.006502613,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.006157001,
				"type": "ORGANIZATION"
			},
			{
				"name": "details",
				"salience": 0.0060585667,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0057718046,
				"type": "LOCATION"
			},
			{
				"name": "source",
				"salience": 0.0057718046,
				"type": "PERSON"
			},
			{
				"name": "rebel stronghold province",
				"salience": 0.0057112128,
				"type": "LOCATION"
			},
			{
				"name": "goal",
				"salience": 0.0053730365,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.0051770224,
				"type": "EVENT"
			},
			{
				"name": "strikes",
				"salience": 0.0051770224,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04swx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mediterranean_Sea"
				},
				"name": "Mediterranean Sea",
				"salience": 0.005029825,
				"type": "LOCATION"
			},
			{
				"name": "strike",
				"salience": 0.0049840873,
				"type": "EVENT"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.004939409,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0048159035,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.0041006263,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0038980525,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0038980525,
				"type": "LOCATION"
			},
			{
				"name": "bombing campaign",
				"salience": 0.0038831152,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.0038728334,
				"type": "PERSON"
			},
			{
				"name": "Kalibr",
				"salience": 0.0036187107,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebel groups",
				"salience": 0.0035270776,
				"type": "ORGANIZATION"
			},
			{
				"name": "aircraft",
				"salience": 0.00342349,
				"type": "OTHER"
			},
			{
				"name": "aircraft carrier",
				"salience": 0.0033780332,
				"type": "ORGANIZATION"
			},
			{
				"name": "casualties",
				"salience": 0.0029627564,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0029254514,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0029254514,
				"type": "EVENT"
			},
			{
				"name": "war crimes",
				"salience": 0.0028522431,
				"type": "OTHER"
			},
			{
				"name": "Rami Abdel Rahman",
				"salience": 0.0028223942,
				"type": "PERSON"
			},
			{
				"name": "targets",
				"salience": 0.0028163278,
				"type": "OTHER"
			},
			{
				"name": "zeros",
				"salience": 0.0028163278,
				"type": "OTHER"
			},
			{
				"name": "submarine",
				"salience": 0.0028163278,
				"type": "OTHER"
			},
			{
				"name": "human shields",
				"salience": 0.0028163278,
				"type": "OTHER"
			},
			{
				"name": "city residents",
				"salience": 0.0028163278,
				"type": "PERSON"
			},
			{
				"name": "street",
				"salience": 0.002798099,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.0027581586,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.0024703196,
				"type": "OTHER"
			},
			{
				"name": "disasters",
				"salience": 0.0023885432,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.0023885432,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0023885432,
				"type": "ORGANIZATION"
			},
			{
				"name": "innocents",
				"salience": 0.0023885432,
				"type": "PERSON"
			},
			{
				"name": "strike killing",
				"salience": 0.0023885432,
				"type": "EVENT"
			},
			{
				"name": "largest",
				"salience": 0.0023885432,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.002371433,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07806",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_aircraft_carrier_Admiral_Kuznetsov"
				},
				"name": "Admiral Kuznetsov",
				"salience": 0.0023207706,
				"type": "PERSON"
			},
			{
				"name": "strike",
				"salience": 0.0023013013,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.0020607233,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0020607233,
				"type": "OTHER"
			},
			{
				"name": "defence ministry",
				"salience": 0.0020607233,
				"type": "PERSON"
			},
			{
				"name": "information provocations",
				"salience": 0.0017994057,
				"type": "OTHER"
			},
			{
				"name": "munitions",
				"salience": 0.0017845,
				"type": "OTHER"
			},
			{
				"name": "flight patterns",
				"salience": 0.0017845,
				"type": "OTHER"
			},
			{
				"name": "location",
				"salience": 0.0017845,
				"type": "LOCATION"
			},
			{
				"name": "network",
				"salience": 0.0017845,
				"type": "OTHER"
			},
			{
				"name": "raids",
				"salience": 0.0017845,
				"type": "EVENT"
			},
			{
				"name": "type",
				"salience": 0.0017845,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053kb5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gazeta.ru"
				},
				"name": "Gazeta.ru",
				"salience": 0.0017338541,
				"type": "ORGANIZATION"
			},
			{
				"name": "strike",
				"salience": 0.0017193051,
				"type": "EVENT"
			},
			{
				"name": "strikes",
				"salience": 0.0017193051,
				"type": "EVENT"
			},
			{
				"name": "grandfather",
				"salience": 0.0017179049,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0016623726,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0015651768,
				"type": "PERSON"
			},
			{
				"name": "planes",
				"salience": 0.0015602628,
				"type": "OTHER"
			},
			{
				"name": "air campaign",
				"salience": 0.0015009817,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0g2vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Observatory"
				},
				"name": "Observatory",
				"salience": 0.0013474195,
				"type": "ORGANIZATION"
			},
			{
				"name": "province",
				"salience": 0.0013442667,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0012997463,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0012997463,
				"type": "ORGANIZATION"
			},
			{
				"name": "family",
				"salience": 0.0012997463,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0011212903,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0011212903,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0010984334,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.0010984334,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.0009709391,
				"type": "LOCATION"
			},
			{
				"name": "monitor",
				"salience": 0.0009709391,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "south",
				"salience": 0.0009709391,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07l57d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib"
				},
				"name": "Idlib",
				"salience": 0.0009088116,
				"type": "LOCATION"
			},
			{
				"name": "planes",
				"salience": 0.00063411385,
				"type": "OTHER"
			},
			{
				"name": "Khan Sheikun",
				"salience": 0.0005975748,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hr9tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Observatory_for_Human_Rights"
				},
				"name": "Syrian Observatory for Human Rights",
				"salience": 0.0005975748,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.amtvmedia.com/wp-content/uploads/2016/11/3A23FFB700000578-0-image-a-6_1478632697219.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-09T19:23:50.481+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "amtvmedia.com",
		"spam_score": "0",
		"text": "Russia To Hit ISIS In Aleppo With Cruise Missiles 11/09/2016 \nDAILY MAIL The Russian navy is planning a massive attack on Aleppo within the next 24 hours, according to a Ministry of Defence source. A group of ships including an aircraft carrier, a nuclear power guided missile cruiser and two destroyers is reportedly ready to strike from the Mediterranean Sea. But the Russian source insisted the missiles will aim for areas surrounding Aleppo to avoid harming the 200,000 civilians still living there. ‘The group’s main goal is to carry out missile strikes on terrorists outside of Aleppo that are attempting to get into the city’, they told Gazeta.ru . ‘The strikes will avoid the city of Aleppo to prevent civilian casualties, because terrorists continue to use city residents as human shields.’ The source added that the details of the strike are still being finalised as they navy zeros in on exact targets around the Syrian city. The strikes could apparently include Kalibr cruise missiles, launched from a submarine. The strikes could apparently include Kalibr cruise missiles, although these would be launched from a submarine Russian aircraft carrier Admiral Kuznetsov is among the group in the Mediterranean Sea It comes on the day of the US election, after American officials have condemned Russia’s bombing campaign in Syria. Secretary of state John Kerry has called on Russia, which supports dictator Bashar-al-Assad against rebel groups, to stop bombing civilians in what he described as the ‘largest of humanitarian disasters’. But President Putin has denied any ‘war crimes’ and asked for evidence that his forces are bombing innocents. Russian planes were allegedly responsible for a strike killing at least seven children and two pregnant women in Syria’s rebel stronghold province of Idlib on Tuesday. \n+6 Russian planes were allegedly responsible for strikes killing at least seven children and two pregnant women in Syria’s rebel stronghold province of Idlib on Tuesday The strike hit the town of Khan Sheikun in the south of the province, the Syrian Observatory for Human Rights monitor said. The Britain-based group, which relies on a network of sources inside Syria for its information, says it determines what planes carried out raids according to their type, location, flight patterns and the munitions involved. In Moscow, the defence ministry denied that Russian aircraft had been in the area on Tuesday, and accused the Observatory of ‘information provocations’. Russia began its air campaign in support of the government in September 2015, saying it was targeting ‘terrorists.’ ‘The strike hit a street where children were playing. Three of the dead children were from one family and were visiting their grandfather,’ Observatory director Rami Abdel Rahman said.",
		"thread_title": "Russia To Hit ISIS In Aleppo With Cruise Missiles",
		"title": "Russia To Hit ISIS In Aleppo With Cruise Missiles",
		"type": "bs",
		"uuid": "28fdcb27ce2bfd0a5dec96f490ff388902b07571"
	},
	"-KhIhaN877c85AO_oEyB": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T12:48:14.753+02:00",
		"domain_rank": "42160",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08fdk5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colonial_Pipeline"
				},
				"name": "Colonial Pipeline",
				"salience": 0.10139102,
				"type": "ORGANIZATION"
			},
			{
				"name": "fuel marketers",
				"salience": 0.063258775,
				"type": "PERSON"
			},
			{
				"name": "Protesters",
				"salience": 0.05921072,
				"type": "PERSON"
			},
			{
				"name": "Experiences",
				"salience": 0.054973062,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.054973062,
				"type": "OTHER"
			},
			{
				"name": "Largest Gas Pipeline",
				"salience": 0.047006704,
				"type": "OTHER"
			},
			{
				"name": "Deadly Explosion",
				"salience": 0.04349122,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ny1p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zhejiang"
				},
				"name": "ZHE",
				"salience": 0.034137875,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.034137875,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.034137875,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06yxd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Carolina"
				},
				"name": "S.C.",
				"salience": 0.034137875,
				"type": "PERSON"
			},
			{
				"name": "DAPL",
				"salience": 0.034137875,
				"type": "ORGANIZATION"
			},
			{
				"name": "fire",
				"salience": 0.033727307,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alabama"
				},
				"name": "Alabama",
				"salience": 0.03290434,
				"type": "LOCATION"
			},
			{
				"name": "mainlines",
				"salience": 0.030225266,
				"type": "OTHER"
			},
			{
				"name": "suppliers",
				"salience": 0.022936443,
				"type": "ORGANIZATION"
			},
			{
				"name": "allocation notices",
				"salience": 0.022936443,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kzpc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shelby_County,_Alabama"
				},
				"name": "Shelby County",
				"salience": 0.01809272,
				"type": "LOCATION"
			},
			{
				"name": "executive director of state",
				"salience": 0.01791502,
				"type": "PERSON"
			},
			{
				"name": "fire",
				"salience": 0.015677515,
				"type": "OTHER"
			},
			{
				"name": "Michael Fields",
				"salience": 0.014167848,
				"type": "PERSON"
			},
			{
				"name": "explosion",
				"salience": 0.010825676,
				"type": "EVENT"
			},
			{
				"name": "Petroleum Marketers Association",
				"salience": 0.009579816,
				"type": "ORGANIZATION"
			},
			{
				"name": "https://t.co/TNcIGRujDA pic.twitter.com/83TyLP6Cqk",
				"salience": 0.009158527,
				"type": "EVENT"
			},
			{
				"name": "petroleum line",
				"salience": 0.008623618,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.008259985,
				"type": "LOCATION"
			},
			{
				"name": "Fire units",
				"salience": 0.008259985,
				"type": "LOCATION"
			},
			{
				"name": "blast",
				"salience": 0.0081927,
				"type": "EVENT"
			},
			{
				"name": "smoke",
				"salience": 0.0079525625,
				"type": "OTHER"
			},
			{
				"name": "skyline",
				"salience": 0.0079525625,
				"type": "OTHER"
			},
			{
				"name": "plume",
				"salience": 0.0079525625,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007788667,
				"type": "PERSON"
			},
			{
				"name": "blast",
				"salience": 0.007498731,
				"type": "EVENT"
			},
			{
				"name": "office",
				"salience": 0.0067469003,
				"type": "ORGANIZATION"
			},
			{
				"name": "gas pipeline",
				"salience": 0.006467439,
				"type": "OTHER"
			},
			{
				"name": "McAdory Fire Station",
				"salience": 0.005876383,
				"type": "LOCATION"
			},
			{
				"name": "Colonial Line",
				"salience": 0.0053142235,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.005305012,
				"type": "OTHER"
			},
			{
				"name": "response team",
				"salience": 0.005172392,
				"type": "ORGANIZATION"
			},
			{
				"name": "Alagasco",
				"salience": 0.0050898325,
				"type": "ORGANIZATION"
			},
			{
				"name": "CBS42",
				"salience": 0.0050898325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0q825",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Helena,_Alabama"
				},
				"name": "Helena",
				"salience": 0.0049001495,
				"type": "LOCATION"
			},
			{
				"name": "Shelby County Sheriff",
				"salience": 0.0047990317,
				"type": "LOCATION"
			},
			{
				"name": "gas line",
				"salience": 0.004698398,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004242799,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.0042238734,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kcrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jefferson_County,_Alabama"
				},
				"name": "Jefferson County",
				"salience": 0.003971585,
				"type": "LOCATION"
			},
			{
				"name": "pipeline",
				"salience": 0.0038002878,
				"type": "OTHER"
			},
			{
				"name": "tanker",
				"salience": 0.0036745572,
				"type": "OTHER"
			},
			{
				"name": "Sheriff",
				"salience": 0.003170487,
				"type": "PERSON"
			},
			{
				"name": "crew work",
				"salience": 0.0027456917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ptrz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Energy_Information_Administration"
				},
				"name": "EIA",
				"salience": 0.0023502486,
				"type": "ORGANIZATION"
			},
			{
				"name": "McAdory Fire Department",
				"salience": 0.0022625627,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02jyr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Alabama_at_Birmingham"
				},
				"name": "UAB",
				"salience": 0.0022625627,
				"type": "ORGANIZATION"
			},
			{
				"name": "primer",
				"salience": 0.0022135207,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.anonews.co/wp-content/uploads/2016/11/2a99c0e5-d14d-4797-ac68-b30ecde21635-large16x9_ShelbyCountyexplosionfire.png.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-02T07:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "anonews.co",
		"spam_score": "0.048",
		"text": "DAPL Protesters Proven Right as Largest Gas Pipeline in U.S. Experiences Massive and Deadly Explosion 18 Shares Email \n( ZHE ) Bloomberg reports that S.C. fuel marketers are receiving allocation notices from major suppliers after Colonial Pipeline shut its mainlines on fire in Shelby County, Alabama, according to Michael Fields, executive director of state’s Petroleum Marketers Association. \nMassive plume of smoke is filling the skyline after a gas pipeline exploded in Helena, Alabama according to CBS42. Fire units are headed to the scene, according to McAdory Fire Station #2. Alagasco has stated that the fire is from a petroleum line. According to the Shelby County Sheriff’s office, the blast was on the Colonial Line, with 8-9 people injured. \nFor those curious about the pipeline, the EIA has a great primer found here. \nThe Sheriff adds that the blast happened during crew work. \nThe explosion took place near 334 Highway 13. At this time, a response team has been called in from Jefferson County as well as a tanker from the McAdory Fire Department. 7 victims now going to UAB: 6 people severely burned after reported gas line explosion https://t.co/TNcIGRujDA pic.twitter.com/83TyLP6Cqk ",
		"thread_title": "DAPL Protesters Proven Right as Largest Gas Pipeline in U.S. Experiences Massive and Deadly Explosion – Anonymous",
		"title": "DAPL Protesters Proven Right as Largest Gas Pipeline in U.S. Experiences Massive and Deadly Explosion – Anonymous",
		"type": "bs",
		"uuid": "44c544c433a771bbb36cf5b7ab1b96519cd03064"
	},
	"-KhIhaWQo5v8ivvm4-2C": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-11T01:43:09.906+02:00",
		"domain_rank": "42160",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.33642238,
				"type": "ORGANIZATION"
			},
			{
				"name": "cameramen",
				"salience": 0.1785137,
				"type": "PERSON"
			},
			{
				"name": "protesters",
				"salience": 0.09621689,
				"type": "PERSON"
			},
			{
				"name": "abovetopsecret.com",
				"salience": 0.060081247,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.050346296,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.041920517,
				"type": "PERSON"
			},
			{
				"name": "camera man",
				"salience": 0.0358895,
				"type": "PERSON"
			},
			{
				"name": "opinion",
				"salience": 0.020830281,
				"type": "OTHER"
			},
			{
				"name": "Editorials",
				"salience": 0.020830281,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anchor man",
				"salience": 0.016264005,
				"type": "PERSON"
			},
			{
				"name": "each other",
				"salience": 0.014638026,
				"type": "PERSON"
			},
			{
				"name": "college",
				"salience": 0.014638026,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.014094386,
				"type": "OTHER"
			},
			{
				"name": "segment",
				"salience": 0.014094386,
				"type": "OTHER"
			},
			{
				"name": "OOPSY",
				"salience": 0.012858654,
				"type": "OTHER"
			},
			{
				"name": "laughs",
				"salience": 0.011961446,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.01151676,
				"type": "OTHER"
			},
			{
				"name": "meltdown",
				"salience": 0.01086022,
				"type": "EVENT"
			},
			{
				"name": "cameraman",
				"salience": 0.008878179,
				"type": "PERSON"
			},
			{
				"name": "Looks",
				"salience": 0.0078823725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025smhq"
				},
				"name": "Brian",
				"salience": 0.0077622463,
				"type": "PERSON"
			},
			{
				"name": "trash meltdown",
				"salience": 0.0056262873,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.004873009,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/025wqnl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Don_Lemon"
				},
				"name": "Don Lemon",
				"salience": 0.0030008843,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.anonews.co/wp-content/uploads/2016/11/cnn_expo_431098-1000x600.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-11T01:43:09.906+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonews.co",
		"spam_score": "0",
		"text": "By: Seasonal via abovetopsecret.com \nCNN outs themselves as using their own cameramen as fake protesters. \nOOPSY! Using your own camera man to voice an opinion. Editorials belong in that segment on your new network. \nLooks like the anchor man knew the guy who was so mad about the electoral college. They all know each other, how nice. \nIf you’ve been watching CNN just for laughs since Trump won the election, you probably saw some worthless white trash meltdown with Don Lemon last night. His name is “Brian” and his meltdown on CNN was epic last night. Turns out, this “Brian” is a CNN cameraman.",
		"thread_title": "CNN Exposed: Using Own Camera-Man For Story as Trump Protester",
		"title": "CNN Exposed: Using Own Camera-Man For Story as Trump Protester",
		"type": "bs",
		"uuid": "c7761dd6701c754f4f3c5f11e16ef48f64bbbb98"
	},
	"-KhIhap_c3TYhIUXfMZo": {
		"author": "",
		"comments": "0",
		"country": "CA",
		"crawled": "2016-11-11T03:06:50.813+02:00",
		"domain_rank": "42160",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0hn8_h9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kelcy_Warren"
				},
				"name": "Kelcy Warren",
				"salience": 0.4529905,
				"type": "PERSON"
			},
			{
				"name": "Isaac Davis",
				"salience": 0.020057118,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.019134555,
				"type": "PERSON"
			},
			{
				"name": "pipleine protest",
				"salience": 0.016858479,
				"type": "EVENT"
			},
			{
				"name": "protection",
				"salience": 0.016858479,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.016125992,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.014972456,
				"type": "PERSON"
			},
			{
				"name": "guard",
				"salience": 0.012502234,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cmtrq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Energy_Transfer_Partners"
				},
				"name": "Energy Transfer Partners",
				"salience": 0.0124625135,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02rnkmh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Keystone_Pipeline"
				},
				"name": "Keystone XL pipeline",
				"salience": 0.01165428,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock Indian Reservation",
				"salience": 0.011229125,
				"type": "LOCATION"
			},
			{
				"name": "Shares",
				"salience": 0.0108336145,
				"type": "OTHER"
			},
			{
				"name": "water supply",
				"salience": 0.0108336145,
				"type": "OTHER"
			},
			{
				"name": "clamp",
				"salience": 0.0108336145,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/055mw6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greg_Abbott"
				},
				"name": "Greg Abbott",
				"salience": 0.010455857,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0zg6x8j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ray_Davis_(businessman)"
				},
				"name": "Ray Davis",
				"salience": 0.010003897,
				"type": "PERSON"
			},
			{
				"name": "Pipeline Billionaire Who Militarized Police",
				"salience": 0.00923828,
				"type": "ORGANIZATION"
			},
			{
				"name": "tear gas",
				"salience": 0.008180493,
				"type": "OTHER"
			},
			{
				"name": "pipeline companies",
				"salience": 0.00771671,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Native Americans",
				"salience": 0.007710689,
				"type": "PERSON"
			},
			{
				"name": "Dakota Access",
				"salience": 0.007710689,
				"type": "OTHER"
			},
			{
				"name": "Texas Parks and Wildlife Commission",
				"salience": 0.007690313,
				"type": "ORGANIZATION"
			},
			{
				"name": "protector camps",
				"salience": 0.006400366,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02wzq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Texas"
				},
				"name": "West Texas",
				"salience": 0.0062621357,
				"type": "LOCATION"
			},
			{
				"name": "horses",
				"salience": 0.0055440227,
				"type": "OTHER"
			},
			{
				"name": "atrocity",
				"salience": 0.0055440227,
				"type": "OTHER"
			},
			{
				"name": "goons",
				"salience": 0.0055440227,
				"type": "PERSON"
			},
			{
				"name": "best",
				"salience": 0.0055440227,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0055440227,
				"type": "OTHER"
			},
			{
				"name": "battle dress",
				"salience": 0.0055440227,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.0055440227,
				"type": "OTHER"
			},
			{
				"name": "tazers",
				"salience": 0.0055440227,
				"type": "OTHER"
			},
			{
				"name": "attack dogs",
				"salience": 0.0055440227,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0055440227,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "citizens",
				"salience": 0.0049778013,
				"type": "PERSON"
			},
			{
				"name": "Source",
				"salience": 0.0047942367,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03p21tj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Energy_Transfer_Equity"
				},
				"name": "Energy Transfer Equity",
				"salience": 0.0047499337,
				"type": "ORGANIZATION"
			},
			{
				"name": "protestors",
				"salience": 0.0046483083,
				"type": "PERSON"
			},
			{
				"name": "fortune",
				"salience": 0.0038404725,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.003562936,
				"type": "EVENT"
			},
			{
				"name": "LRAD",
				"salience": 0.003414984,
				"type": "ORGANIZATION"
			},
			{
				"name": "root issue",
				"salience": 0.003398762,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.003398762,
				"type": "OTHER"
			},
			{
				"name": "saying",
				"salience": 0.0032574274,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0031621302,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.0031621302,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0031621302,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0031621302,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0029434694,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.0029434694,
				"type": "OTHER"
			},
			{
				"name": "pipelines",
				"salience": 0.0029335273,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0029214795,
				"type": "PERSON"
			},
			{
				"name": "Water Is Life",
				"salience": 0.0028751423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ykz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Missouri_River"
				},
				"name": "Missouri River",
				"salience": 0.0028166086,
				"type": "LOCATION"
			},
			{
				"name": "guard",
				"salience": 0.0026380187,
				"type": "PERSON"
			},
			{
				"name": "root",
				"salience": 0.0026380187,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0025493908,
				"type": "ORGANIZATION"
			},
			{
				"name": "capitalism",
				"salience": 0.002433969,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0023861048,
				"type": "LOCATION"
			},
			{
				"name": "natural gas",
				"salience": 0.0023658818,
				"type": "OTHER"
			},
			{
				"name": "protection movement",
				"salience": 0.0022845257,
				"type": "OTHER"
			},
			{
				"name": "state oppression",
				"salience": 0.0022845257,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0022845257,
				"type": "EVENT"
			},
			{
				"name": "perception",
				"salience": 0.0022845257,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0022845257,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0022176616,
				"type": "ORGANIZATION"
			},
			{
				"name": "commissioners",
				"salience": 0.0021211035,
				"type": "PERSON"
			},
			{
				"name": "crude oil",
				"salience": 0.00204882,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00204882,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.0020473897,
				"type": "OTHER"
			},
			{
				"name": "native",
				"salience": 0.0019975356,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0019723761,
				"type": "PERSON"
			},
			{
				"name": "state parks",
				"salience": 0.0019316276,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0018499574,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0018499574,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02590c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_Texas"
				},
				"name": "East Texas",
				"salience": 0.0018449546,
				"type": "LOCATION"
			},
			{
				"name": "wildlife commission",
				"salience": 0.00181059,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pipelines",
				"salience": 0.0017895249,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0017809272,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.0017809272,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.0017809272,
				"type": "OTHER"
			},
			{
				"name": "profit stream",
				"salience": 0.0017285899,
				"type": "OTHER"
			},
			{
				"name": "holdings",
				"salience": 0.0016640848,
				"type": "OTHER"
			},
			{
				"name": "products",
				"salience": 0.0016019852,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "natural gas liquids",
				"salience": 0.0016019852,
				"type": "OTHER"
			},
			{
				"name": "underground",
				"salience": 0.0016019852,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0016019852,
				"type": "OTHER"
			},
			{
				"name": "shale tycoons",
				"salience": 0.0016019852,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.0016019852,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0015422014,
				"type": "OTHER"
			},
			{
				"name": "expense",
				"salience": 0.0015422014,
				"type": "OTHER"
			},
			{
				"name": "civil engineering",
				"salience": 0.0015422014,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0015422014,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0015422014,
				"type": "PERSON"
			},
			{
				"name": "top",
				"salience": 0.0015422014,
				"type": "OTHER"
			},
			{
				"name": "pyramid",
				"salience": 0.0015422014,
				"type": "OTHER"
			},
			{
				"name": "graduate",
				"salience": 0.0015422014,
				"type": "PERSON"
			},
			{
				"name": "degree",
				"salience": 0.0015422014,
				"type": "OTHER"
			},
			{
				"name": "baseball team",
				"salience": 0.0015422014,
				"type": "ORGANIZATION"
			},
			{
				"name": "natural gas industry",
				"salience": 0.0015422014,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0015103337,
				"type": "OTHER"
			},
			{
				"name": "pipeline project",
				"salience": 0.0015103337,
				"type": "OTHER"
			},
			{
				"name": "environmentalists",
				"salience": 0.0015103337,
				"type": "PERSON"
			},
			{
				"name": "Regency Energy Partners",
				"salience": 0.0014564965,
				"type": "ORGANIZATION"
			},
			{
				"name": "natural gas",
				"salience": 0.0014430981,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.0013997041,
				"type": "OTHER"
			},
			{
				"name": "insult",
				"salience": 0.0013934533,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0013526529,
				"type": "PERSON"
			},
			{
				"name": "co-chair",
				"salience": 0.0013414467,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.0013368443,
				"type": "ORGANIZATION"
			},
			{
				"name": "Andrew Lucas",
				"salience": 0.0013274004,
				"type": "PERSON"
			},
			{
				"name": "lands",
				"salience": 0.0013078577,
				"type": "LOCATION"
			},
			{
				"name": "wellhead",
				"salience": 0.0013078577,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.0013078577,
				"type": "ORGANIZATION"
			},
			{
				"name": "future",
				"salience": 0.0013078577,
				"type": "OTHER"
			},
			{
				"name": "hunting",
				"salience": 0.0013078577,
				"type": "OTHER"
			},
			{
				"name": "fishing",
				"salience": 0.0013078577,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0012646922,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.0012496305,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0011720456,
				"type": "OTHER"
			},
			{
				"name": "stuff others",
				"salience": 0.001152109,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.001128298,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.001128298,
				"type": "LOCATION"
			},
			{
				"name": "resources",
				"salience": 0.001128298,
				"type": "OTHER"
			},
			{
				"name": "Trans Pecos Pipeline",
				"salience": 0.001101563,
				"type": "OTHER"
			},
			{
				"name": "Comanche Trail Pipeline",
				"salience": 0.001101563,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018wpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunoco"
				},
				"name": "Sunoco",
				"salience": 0.0009860876,
				"type": "ORGANIZATION"
			},
			{
				"name": "Southern Union",
				"salience": 0.0009860876,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01r2lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Forbes"
				},
				"name": "Forbes",
				"salience": 0.0009860876,
				"type": "ORGANIZATION"
			},
			{
				"name": "hands",
				"salience": 0.0009770145,
				"type": "OTHER"
			},
			{
				"name": "developments",
				"salience": 0.0009770145,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0009770145,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0009770145,
				"type": "WORK_OF_ART"
			},
			{
				"name": "damages",
				"salience": 0.0009770145,
				"type": "OTHER"
			},
			{
				"name": "regard",
				"salience": 0.0009770145,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.0009770145,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0009770145,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.0009770145,
				"type": "OTHER"
			},
			{
				"name": "crude oil pipeline",
				"salience": 0.00097371143,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03np_7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Texas_at_Arlington"
				},
				"name": "University of Texas at Arlington",
				"salience": 0.000949278,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07l8x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas_Rangers_(baseball)"
				},
				"name": "Texas Rangers",
				"salience": 0.000949278,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01smr6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Big_Bend_National_Park"
				},
				"name": "Big Bend National Park",
				"salience": 0.00092270534,
				"type": "LOCATION"
			},
			{
				"name": "campaign contributions",
				"salience": 0.00082174997,
				"type": "OTHER"
			},
			{
				"name": "control matrix",
				"salience": 0.0007115552,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.0007115552,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0007115552,
				"type": "EVENT"
			},
			{
				"name": "liberty",
				"salience": 0.0007115552,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0007115552,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0007115552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01smr6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Big_Bend_National_Park"
				},
				"name": "Big Bend",
				"salience": 0.00069445476,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c9_mp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trans-Pecos"
				},
				"name": "Trans Pecos",
				"salience": 0.00069445476,
				"type": "LOCATION"
			},
			{
				"name": "headlines",
				"salience": 0.0006594169,
				"type": "OTHER"
			},
			{
				"name": "billionaire",
				"salience": 0.00065448537,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gyl6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas_Parks_and_Wildlife_Department"
				},
				"name": "Texas Parks And Wildlife",
				"salience": 0.000646909,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texans",
				"salience": 0.00063592126,
				"type": "PERSON"
			},
			{
				"name": "CEO",
				"salience": 0.00061384024,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.00061384024,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.0005992919,
				"type": "OTHER"
			},
			{
				"name": "drive",
				"salience": 0.00053830334,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.0005315188,
				"type": "PERSON"
			},
			{
				"name": "opportunities",
				"salience": 0.0005315188,
				"type": "OTHER"
			},
			{
				"name": "recreation",
				"salience": 0.0005315188,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0005315188,
				"type": "EVENT"
			},
			{
				"name": "major",
				"salience": 0.0005315188,
				"type": "PERSON"
			},
			{
				"name": "post",
				"salience": 0.0005315188,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.0005315188,
				"type": "OTHER"
			},
			{
				"name": "Texas State Park",
				"salience": 0.00048322554,
				"type": "LOCATION"
			},
			{
				"name": "OffgridOutpost.com Survival Tips",
				"salience": 0.00043792158,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00043792158,
				"type": "OTHER"
			},
			{
				"name": "WakingTimes.com",
				"salience": 0.00043792158,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0003940568,
				"type": "PERSON"
			},
			{
				"name": "Standing Rock Sioux Reservation",
				"salience": 0.00037777697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h8zl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Environmental_science"
				},
				"name": "Environmental Science",
				"salience": 0.0003271089,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03szws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Texas_at_San_Antonio"
				},
				"name": "UTSA",
				"salience": 0.0003271089,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f2rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dallas"
				},
				"name": "Dallas",
				"salience": 0.0003271089,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0q76g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Midwestern_United_States"
				},
				"name": "Midwest",
				"salience": 0.0003271089,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.anonews.co/wp-content/uploads/2016/11/NB_19WARREN2AJ_47346553-1000x600.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-11T01:00:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "anonews.co",
		"spam_score": "0",
		"text": "Pipeline Billionaire Who Militarized Police at Standing Rock 11 Shares Email \nThe months long Dakota Access Keystone XL pipleine protest at the Standing Rock Indian Reservation by Native Americans and those sympathetic to protection of our water supply has been met with heavy-handed and brutal clamp down by police and national guard. Militarized goons in battle dress have stormed protector camps with LRAD sonic weapons, attack dogs , tear gas, tazers , and even live ammunition ( killing horses ), while politicians and mainstream media do their best to ignore this growing atrocity, hoping to wait it out until the protestors give up. \nBut, as the saying goes, Water Is Life , and the issue of life and death is at the root of this protection movement, therefore, for people concerned with life, giving up on this is simply unthinkable. The root issue justifying state oppression of the protest is capitalism, and the perception that money is more important than life itself. When the police and national guard attack U.S. citizens on private property to protect corporate interests, who are they really working for? \nThe corporate dream of the Keystone XL pipeline is to create a profit stream for a small number of people at the expense of the natural world and anyone in the way. At the top of this pyramid of profit is Texas billionaire Kelcy Warren, CEO of Energy Transfer Partners, the company responsible for the project. \nSo who is Kelcy Warren? \nA native of East Texas and graduate of the University of Texas at Arlington with a degree in civil engineering, Warren worked in the natural gas industry and became co-chair of Energy Transfer Equity in 2007. With business partner Ray Davis, co-owner of the Texas Rangers baseball team, Warren built Energy Transfer Equity into one of the nation’s largest pipeline companies, which now owns about 71,000 miles of pipelines carrying natural gas, natural gas liquids, refined products and crude oil. The company’s holdings include Sunoco, Southern Union and Regency Energy Partners. \nForbes estimates the 60-year-old Warren’s personal wealth at $4 billion. Bloomberg described him as “among America’s new shale tycoons” — but rather than building a fortune by drilling he “takes the stuff others pull from underground and moves it from one place to another, chilling, boiling, pressurizing, and processing it until it’s worth more than when it burst from the wellhead.” [ Source ] \nShockingly, in 2015 the governor of Texas, Greg Abbott, appointed Warren to the Texas Parks and Wildlife Commission which is an insult to environmentalists working to protect Big Bend National Park and surrounding sacred tribal lands from another $770 million pipeline project . \n“According to the governor’s office, the state parks and wildlife commission “manages and conserves the natural and cultural resources of Texas,” along with ensuring the future of hunting, fishing and outdoor recreation opportunities for Texans.” [ Source ] \nThis glaring conflict of interest has inspired Environmental Science major at UTSA and former Texas State Park Ambassador Andrew Lucas to begin a drive to have Warren removed from this environmental post. His petition is described here : \nMost people may know Kelcy Warren as the man behind the controversial Dakota Access Pipeline. The Dallas-based billionaire and CEO of Energy Transfer Partners has been making headlines for fast-tracking a 1100 mile crude oil pipeline across the Midwest and under the Missouri River, just north of the Standing Rock Sioux Reservation. No environmental impact assessment, no respect for cultural sites, and no regard for the local and widespread communities living along the river. A similar story is unfolding out in West Texas, where Warren’s company has split through the pristine Big Bend region with the 200 mile Comanche Trail Pipeline and nearly-complete 143 mile Trans Pecos Pipeline. These Pipelines mark the way for massive natural gas and oil developments in the Trans Pecos region. \nWith untold damages unfolding for cultural and environmental resources at the hands of Energy Transfer Partners, it would surprise most to know that nearly a year ago, Texas Governor Greg Abbott appointed Kelcy Warren for a 6 year term as 1 of the 10 commissioners who preside over Texas Parks And Wildlife… Why? Probably the $550,000 in campaign contributions Abbott received from Warren. \nRead More… About the Author \nIsaac Davis is a staff writer for WakingTimes.com and OffgridOutpost.com Survival Tips blog. He is an outspoken advocate of liberty and of a voluntary society. He is an avid reader of history and passionate about becoming self-sufficient to break free of the control matrix. Follow him on Facebook, here .",
		"thread_title": "Pipeline Billionaire Who Militarized Police at Standing Rock",
		"title": "Pipeline Billionaire Who Militarized Police at Standing Rock",
		"type": "bs",
		"uuid": "cf861a5795c31fb3d962e20e17950fc242b9c70a"
	},
	"-KhIhb0uakHhXEFoEatz": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-11-22T01:00:18.880+02:00",
		"domain_rank": "42160",
		"entities": [
			{
				"name": "#TwitterGate",
				"salience": 0.21804021,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.12410321,
				"type": "OTHER"
			},
			{
				"name": "child p0rn0graphy accounts",
				"salience": 0.06042915,
				"type": "OTHER"
			},
			{
				"name": "twitter",
				"salience": 0.035017967,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.028282681,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.028282681,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.028282681,
				"type": "PERSON"
			},
			{
				"name": "CEO",
				"salience": 0.026464516,
				"type": "PERSON"
			},
			{
				"name": "member",
				"salience": 0.019188052,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.019188052,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nr1np",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anonymous_(group)"
				},
				"name": "Anonymous",
				"salience": 0.017965348,
				"type": "ORGANIZATION"
			},
			{
				"name": "NOTE",
				"salience": 0.016383138,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.012607,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07pksv8"
				},
				"name": "Pedophile",
				"salience": 0.011829605,
				"type": "PERSON"
			},
			{
				"name": "@0hour",
				"salience": 0.011829605,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Walt_Disney_Company"
				},
				"name": "Disney",
				"salience": 0.011397284,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.0085050585,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.00819898,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.00819898,
				"type": "PERSON"
			},
			{
				"name": "notsafeforjerk",
				"salience": 0.007917302,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.007917302,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.007893394,
				"type": "OTHER"
			},
			{
				"name": "accounts",
				"salience": 0.007893394,
				"type": "OTHER"
			},
			{
				"name": "child p0rn0graphy accounts",
				"salience": 0.007893394,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.007477605,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0073380647,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.0071545434,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.00646515,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.006412386,
				"type": "OTHER"
			},
			{
				"name": "pol",
				"salience": 0.006412386,
				"type": "OTHER"
			},
			{
				"name": "message boards",
				"salience": 0.0055534164,
				"type": "ORGANIZATION"
			},
			{
				"name": "manhunt",
				"salience": 0.0055534164,
				"type": "EVENT"
			},
			{
				"name": "scope",
				"salience": 0.0055534164,
				"type": "OTHER"
			},
			{
				"name": "horror increases",
				"salience": 0.0055534164,
				"type": "OTHER"
			},
			{
				"name": "child pornography",
				"salience": 0.0053463005,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.0053463005,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.0053463005,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0053463005,
				"type": "PERSON"
			},
			{
				"name": "@Stern100",
				"salience": 0.004941958,
				"type": "OTHER"
			},
			{
				"name": "@SternUpdates",
				"salience": 0.004941958,
				"type": "OTHER"
			},
			{
				"name": "@SternShowMoms",
				"salience": 0.004941958,
				"type": "OTHER"
			},
			{
				"name": "@sternshow",
				"salience": 0.004941958,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0048757605,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.0048757605,
				"type": "OTHER"
			},
			{
				"name": "channels",
				"salience": 0.004534341,
				"type": "OTHER"
			},
			{
				"name": "@SternShowQuotes",
				"salience": 0.0036924048,
				"type": "OTHER"
			},
			{
				"name": "@SternShowPundit",
				"salience": 0.0036924048,
				"type": "OTHER"
			},
			{
				"name": "@SternShowXtra",
				"salience": 0.0036924048,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b2334",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reddit"
				},
				"name": "Reddit",
				"salience": 0.003419212,
				"type": "OTHER"
			},
			{
				"name": "backs",
				"salience": 0.0032613503,
				"type": "OTHER"
			},
			{
				"name": "@MaraReinstein",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@EliBraden",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@DitaFan",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@BenBarto",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@LittleMikeysp",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@bobohstern",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@JasonFielderTV",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@hperik1971",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@DocIvanSFN",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@TomCotterComic",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@SBrandano",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@shalomshuli",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@rmlimodriver69",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@jdharm",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "NorthCrane",
				"salience": 0.002791497,
				"type": "OTHER"
			},
			{
				"name": "@Sternpage",
				"salience": 0.002689508,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.0024675597,
				"type": "OTHER"
			},
			{
				"name": "scapegoat",
				"salience": 0.0024675597,
				"type": "OTHER"
			},
			{
				"name": "@Howard100",
				"salience": 0.0024082747,
				"type": "OTHER"
			},
			{
				"name": "@Howard101",
				"salience": 0.0024082747,
				"type": "OTHER"
			},
			{
				"name": "@mydrugismusic",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@darkmang_25",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@johnbutler1",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@heaney_sean",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@Carrie_Stevens1",
				"salience": 0.002085393,
				"type": "PERSON"
			},
			{
				"name": "@JustinNColumbia",
				"salience": 0.002085393,
				"type": "PERSON"
			},
			{
				"name": "@TheSternShow",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@valthepoet",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@julianvelard",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@ImGrover",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@TheRealGSid",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@bobby_rooney",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@IamArtieLange",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@WhoopAsh",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@RealTalkRooney",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@HighPitch2009",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@FakeLisaG",
				"salience": 0.002085393,
				"type": "OTHER"
			},
			{
				"name": "@SternShowAddict",
				"salience": 0.002009189,
				"type": "PERSON"
			},
			{
				"name": "@preemiememe",
				"salience": 0.0015188111,
				"type": "OTHER"
			},
			{
				"name": "@beckalah428",
				"salience": 0.0015188111,
				"type": "OTHER"
			},
			{
				"name": "@IamFredNorris",
				"salience": 0.0015188111,
				"type": "OTHER"
			},
			{
				"name": "@atsternshow",
				"salience": 0.0015188111,
				"type": "OTHER"
			},
			{
				"name": "@shaneomtl",
				"salience": 0.0015188111,
				"type": "OTHER"
			},
			{
				"name": "@RFromMN",
				"salience": 0.0015188111,
				"type": "OTHER"
			},
			{
				"name": "@ChadFromStL",
				"salience": 0.0015188111,
				"type": "OTHER"
			},
			{
				"name": "@DannyMendelson",
				"salience": 0.0015188111,
				"type": "PERSON"
			},
			{
				"name": "@cwild22",
				"salience": 0.0015188111,
				"type": "OTHER"
			},
			{
				"name": "@ThisIsPiotr",
				"salience": 0.001310248,
				"type": "OTHER"
			},
			{
				"name": "@thisiswolfie",
				"salience": 0.001310248,
				"type": "PERSON"
			},
			{
				"name": "@leithforrest",
				"salience": 0.0011345388,
				"type": "PERSON"
			},
			{
				"name": "@salgovernale",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@reporterjon",
				"salience": 0.0011345388,
				"type": "PERSON"
			},
			{
				"name": "@q8i_snake",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@JoeyBoots",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@Murman78",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@IsaacLeicht",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@kimberlyratliff",
				"salience": 0.0011345388,
				"type": "PERSON"
			},
			{
				"name": "@craiggasscomedy",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@twangger",
				"salience": 0.0011345388,
				"type": "PERSON"
			},
			{
				"name": "@memetwalker",
				"salience": 0.0011345388,
				"type": "PERSON"
			},
			{
				"name": "@AsianPete5",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@kylesimonLOL",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@MMABILLYMIRA",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@TheMikeTrainor",
				"salience": 0.0011345388,
				"type": "PERSON"
			},
			{
				"name": "@TARAxVx",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@MichaelSantang5",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@Innocuous_Flop",
				"salience": 0.0011345388,
				"type": "OTHER"
			},
			{
				"name": "@FTESTERNBTLSFAN",
				"salience": 0.0011345388,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.anonews.co/wp-content/uploads/2016/11/Twitter-Hole-featured-1000x600.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-22T01:00:18.880+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonews.co",
		"spam_score": "0",
		"text": "Twittergate is happening right now. 1000s of twitter Pedophile accounts discovered 1 Share Email \nSeveral Twitter users were reporting child p0rn0graphy accounts and sending them to 0hour, an active member of Anonymous. \nThe Anonymous user, @0hour, was retweeting them and tagging Twitter, FBI and Disney. The YouTube user, notsafeforjerk , is providing up-to-date reports on #TwitterGate. \n“Twitter cares more about silencing political opinions than protecting our children. Twitter’s CEO works for Disney .” \nHours later, 0hour got his account suspended while many of the child p0rn0graphy accounts remained active, despite the child pornography being publicly displayed on the Twitter accounts. \n#TwitterGate has become a topic of discussion on several message boards such as Reddit and /pol/. \nAs more people become involved in the manhunt, the scope of horror increases. \nThus far, this is the list of users identified by /pol/: \nNOTE: These Twitter users have not been vetted through NorthCrane channels. \n@sternshow @jdharm @rmlimodriver69 @SternShowMoms @shalomshuli @SternUpdates @SBrandano @TomCotterComic @DocIvanSFN @hperik1971 @MaraReinstein @JasonFielderTV @bobohstern @LittleMikeysp @BenBarto @Stern100 @DitaFan @EliBraden @salgovernale @SternShowAddict @reporterjon @q8i_snake @JoeyBoots @Murman78 @IsaacLeicht @kimberlyratliff @craiggasscomedy @twangger @memetwalker @leithforrest @kylesimonLOL @MMABILLYMIRA @TheMikeTrainor @thisiswolfie @TARAxVx @ThisIsPiotr @MichaelSantang5 @Innocuous_Flop @FTESTERNBTLSFAN @AsianPete5 @TheRealGSid @SternShowQuotes @julianvelard @valthepoet @SternShowPundit @JustinNColumbia @Carrie_Stevens1 @heaney_sean @johnbutler1 @darkmang_25 @mydrugismusic @TheSternShow @ImGrover @bobby_rooney @Howard100 @Howard101 @IamArtieLange @WhoopAsh @RealTalkRooney @HighPitch2009 @FakeLisaG @SternShowXtra @preemiememe @beckalah428 @IamFredNorris @atsternshow @shaneomtl @RFromMN @ChadFromStL @DannyMendelson @Sternpage @cwild22 \nArchived link here https://archive.4plebs.org/pol/thread/99543043/ but watch your backs please. Don’t be the person who gets caught if they need a scapegoat.",
		"thread_title": "Twittergate is happening right now. 1000s of twitter Pedophile accounts discovered",
		"title": "Twittergate is happening right now. 1000s of twitter Pedophile accounts discovered",
		"type": "bs",
		"uuid": "3a56270a868913e0fadb95def285546f3585d1e9"
	},
	"-KhIhb4TRADqGXaMt4XC": {
		"author": "fundamentaly flawed humanity",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:57:24.590+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Alfi",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/anon_bill_431101.jpg",
		"ord_in_thread": "18",
		"participants_count": "19",
		"published": "2016-10-26T23:14:00.000+03:00",
		"replies_count": "20",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.8
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "troll…ignore the ignorant and blatantly dumb “Alfi”.",
		"thread_title": "Anonymous: Bill Clinton Pedophile Sex Tape Filmed By Jeffrey Epstein!",
		"title": "",
		"type": "bs",
		"uuid": "748d5db125906cfcc6a5232d9538e680f8466564"
	},
	"-KhIhb8S3KeEfrXrZSIB": {
		"author": "John Doe",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:57:24.608+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "party",
				"salience": 0.31600696,
				"type": "ORGANIZATION"
			},
			{
				"name": "affidavit",
				"salience": 0.22578824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "DJT",
				"salience": 0.19930153,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dnjc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Doe"
				},
				"name": "JOHN DOE",
				"salience": 0.13625987,
				"type": "PERSON"
			},
			{
				"name": "pube comb",
				"salience": 0.0954342,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.027209196,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/anon_bill_431101.jpg",
		"ord_in_thread": "19",
		"participants_count": "19",
		"published": "2016-10-26T13:50:00.000+03:00",
		"replies_count": "20",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "I think I was raped by DJT at that party too.. add JOHN DOE to the affidavit. I remember a blonde pube comb over and it was short fat and greasy….. the drugs were so good.",
		"thread_title": "Anonymous: Bill Clinton Pedophile Sex Tape Filmed By Jeffrey Epstein!",
		"title": "",
		"type": "bs",
		"uuid": "7cb6c5d08bb18ac3eb336eeb68b5ae26cb251cfa"
	},
	"-KhIhbGLAO7T1s6nzl1J": {
		"author": "fundamentaly flawed humanity",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:57:24.698+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "danger",
				"salience": 0.39283302,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.28419745,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.12680107,
				"type": "OTHER"
			},
			{
				"name": "lesser",
				"salience": 0.0512901,
				"type": "OTHER"
			},
			{
				"name": "evils",
				"salience": 0.0512901,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0512901,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03qcq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hunter_S._Thompson"
				},
				"name": "Hunter S. Thompson",
				"salience": 0.04229815,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/anon_bill_431101.jpg",
		"ord_in_thread": "20",
		"participants_count": "19",
		"published": "2016-10-26T23:18:00.000+03:00",
		"replies_count": "20",
		"sentiment": {
			"magnitude": 1.5,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "and you should be ashamed of how uneducated you are, it doesn’t matter who wins the election you numskull. “There’s a terrible danger in voting for the lesser of two evils because the parties can set it up that way.” – Hunter S. Thompson",
		"thread_title": "Anonymous: Bill Clinton Pedophile Sex Tape Filmed By Jeffrey Epstein!",
		"title": "",
		"type": "bs",
		"uuid": "38e6a633a460de4105335ab8eafcf0f0af7c515d"
	},
	"-KhIhbdQt4qnlw94LreK": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:58:28.423+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "reason",
				"salience": 0.183905,
				"type": "OTHER"
			},
			{
				"name": "rumors",
				"salience": 0.09133493,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034bs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Orwell"
				},
				"name": "George Orwell",
				"salience": 0.075492196,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.041426815,
				"type": "OTHER"
			},
			{
				"name": "shocks",
				"salience": 0.041426815,
				"type": "OTHER"
			},
			{
				"name": "rulers",
				"salience": 0.038503565,
				"type": "PERSON"
			},
			{
				"name": "The Managerial Revolution",
				"salience": 0.02830688,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ability",
				"salience": 0.027075566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qqk8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Burnham"
				},
				"name": "James Burnham",
				"salience": 0.018528994,
				"type": "PERSON"
			},
			{
				"name": "concepts",
				"salience": 0.017798198,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.016917424,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.012718287,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.011631342,
				"type": "PERSON"
			},
			{
				"name": "demise",
				"salience": 0.011477149,
				"type": "EVENT"
			},
			{
				"name": "breaking point",
				"salience": 0.011477149,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.0104426155,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.008665857,
				"type": "OTHER"
			},
			{
				"name": "winners",
				"salience": 0.0080269985,
				"type": "PERSON"
			},
			{
				"name": "herd",
				"salience": 0.0072106305,
				"type": "OTHER"
			},
			{
				"name": "globalization",
				"salience": 0.007205435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/075bp7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Martin_Wolf"
				},
				"name": "Martin Wolf",
				"salience": 0.0071332357,
				"type": "PERSON"
			},
			{
				"name": "elites",
				"salience": 0.0067309528,
				"type": "PERSON"
			},
			{
				"name": "elites",
				"salience": 0.0067309528,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0058725765,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.0054188445,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Johnson",
				"salience": 0.005332354,
				"type": "PERSON"
			},
			{
				"name": "institutions",
				"salience": 0.005271505,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.005086484,
				"type": "OTHER"
			},
			{
				"name": "fragility",
				"salience": 0.005086484,
				"type": "OTHER"
			},
			{
				"name": "novel",
				"salience": 0.005086484,
				"type": "WORK_OF_ART"
			},
			{
				"name": "groundwork",
				"salience": 0.005086484,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.005086484,
				"type": "OTHER"
			},
			{
				"name": "concentration",
				"salience": 0.0046635554,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.0046031536,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.0043982994,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0043982994,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0042065815,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.003947572,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0037370687,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0037370687,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.003573099,
				"type": "OTHER"
			},
			{
				"name": "democratic",
				"salience": 0.0032683495,
				"type": "PERSON"
			},
			{
				"name": "citizenry",
				"salience": 0.0032031755,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0031433688,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.003094413,
				"type": "PERSON"
			},
			{
				"name": "masses",
				"salience": 0.0030870952,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02vlxbq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Mason_(journalist)"
				},
				"name": "Paul Mason",
				"salience": 0.0029053586,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.0029005848,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0029005848,
				"type": "OTHER"
			},
			{
				"name": "managers",
				"salience": 0.0027692653,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0027450472,
				"type": "PERSON"
			},
			{
				"name": "worldview",
				"salience": 0.0026797848,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.002582413,
				"type": "PERSON"
			},
			{
				"name": "capitalism",
				"salience": 0.002505893,
				"type": "OTHER"
			},
			{
				"name": "capitalist",
				"salience": 0.0024197171,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0024197171,
				"type": "OTHER"
			},
			{
				"name": "oligarchy",
				"salience": 0.0024197171,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0024197171,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.0024124032,
				"type": "OTHER"
			},
			{
				"name": "James Traub",
				"salience": 0.0023257115,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0022986664,
				"type": "PERSON"
			},
			{
				"name": "Jason Brennan",
				"salience": 0.0022373246,
				"type": "PERSON"
			},
			{
				"name": "drift",
				"salience": 0.0021221442,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.0020954143,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0020954143,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0020954143,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0020954143,
				"type": "OTHER"
			},
			{
				"name": "boots",
				"salience": 0.0020954143,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bureaucrats",
				"salience": 0.0020954143,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/11b824j5c9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PostCapitalism:_A_Guide_to_our_Future"
				},
				"name": "Postcapitalism",
				"salience": 0.002084233,
				"type": "WORK_OF_ART"
			},
			{
				"name": "way",
				"salience": 0.0020783,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0020340737,
				"type": "OTHER"
			},
			{
				"name": "questioning",
				"salience": 0.0020340737,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0019621504,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0019581723,
				"type": "OTHER"
			},
			{
				"name": "concentration",
				"salience": 0.0019581723,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0019581723,
				"type": "OTHER"
			},
			{
				"name": "marriage",
				"salience": 0.001893336,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.001879183,
				"type": "LOCATION"
			},
			{
				"name": "elites",
				"salience": 0.0018713201,
				"type": "PERSON"
			},
			{
				"name": "softball",
				"salience": 0.0018694857,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.0018459357,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.001809057,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.001809057,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0018077937,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.0017716765,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0017716765,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.0017716765,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0016967574,
				"type": "OTHER"
			},
			{
				"name": "assumptions",
				"salience": 0.0016967574,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0016606447,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0016334342,
				"type": "LOCATION"
			},
			{
				"name": "oligarchy",
				"salience": 0.0016334342,
				"type": "OTHER"
			},
			{
				"name": "demise",
				"salience": 0.0016334342,
				"type": "EVENT"
			},
			{
				"name": "breaking point",
				"salience": 0.0016334342,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0016334342,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0015986684,
				"type": "OTHER"
			},
			{
				"name": "emergence",
				"salience": 0.0015751574,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.0015654505,
				"type": "PERSON"
			},
			{
				"name": "legitimacy",
				"salience": 0.0015457278,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0015341718,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.0015341718,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0014692899,
				"type": "ORGANIZATION"
			},
			{
				"name": "fashion",
				"salience": 0.0014692899,
				"type": "OTHER"
			},
			{
				"name": "incomes",
				"salience": 0.0014692899,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0014692899,
				"type": "PERSON"
			},
			{
				"name": "losers",
				"salience": 0.0014692899,
				"type": "PERSON"
			},
			{
				"name": "prosperity",
				"salience": 0.0014692899,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0014692899,
				"type": "OTHER"
			},
			{
				"name": "business papers",
				"salience": 0.0014692899,
				"type": "OTHER"
			},
			{
				"name": "discontent",
				"salience": 0.0014324994,
				"type": "OTHER"
			},
			{
				"name": "examinations",
				"salience": 0.0014144509,
				"type": "OTHER"
			},
			{
				"name": "proletariat",
				"salience": 0.0014144509,
				"type": "OTHER"
			},
			{
				"name": "weakness",
				"salience": 0.0014144509,
				"type": "OTHER"
			},
			{
				"name": "circumstances",
				"salience": 0.0014144509,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0014144509,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0014144509,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0014028952,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0013980003,
				"type": "PERSON"
			},
			{
				"name": "assumptions",
				"salience": 0.0013852194,
				"type": "OTHER"
			},
			{
				"name": "Apologists",
				"salience": 0.0012537325,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0012405843,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0012405843,
				"type": "OTHER"
			},
			{
				"name": "critiques",
				"salience": 0.001214803,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "sentiments",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.0011994959,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "systems",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0011994959,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "commentariat share",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "ire",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "willingness",
				"salience": 0.0011994959,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0011994959,
				"type": "PERSON"
			},
			{
				"name": "minority",
				"salience": 0.0011694577,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.0011460874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wealth",
				"salience": 0.0011460874,
				"type": "OTHER"
			},
			{
				"name": "leash",
				"salience": 0.0011460874,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.0011132286,
				"type": "OTHER"
			},
			{
				"name": "reforms",
				"salience": 0.0010837795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0108kc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Financial_Times"
				},
				"name": "Financial Times",
				"salience": 0.0010444078,
				"type": "ORGANIZATION"
			},
			{
				"name": "extent",
				"salience": 0.0010347979,
				"type": "OTHER"
			},
			{
				"name": "Josh Barro",
				"salience": 0.0010082918,
				"type": "PERSON"
			},
			{
				"name": "characterization",
				"salience": 0.0009917191,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.0009426667,
				"type": "OTHER"
			},
			{
				"name": "Brexit",
				"salience": 0.0009043614,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0009043614,
				"type": "LOCATION"
			},
			{
				"name": "instability",
				"salience": 0.0009035269,
				"type": "OTHER"
			},
			{
				"name": "excesses",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "diatribes",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "midst",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.00089603965,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.00088474766,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.0008409844,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.00083469524,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.00083469524,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.00083469524,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00079752435,
				"type": "OTHER"
			},
			{
				"name": "Against Democracy",
				"salience": 0.00076356303,
				"type": "OTHER"
			},
			{
				"name": "Elites",
				"salience": 0.0007605889,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "limits",
				"salience": 0.0007536336,
				"type": "OTHER"
			},
			{
				"name": "limits",
				"salience": 0.0007536336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cqnm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walter_Lippmann"
				},
				"name": "Walter Lippmann",
				"salience": 0.0007382689,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0006749258,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.000652567,
				"type": "ORGANIZATION"
			},
			{
				"name": "stability",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "environment",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "CEO",
				"salience": 0.000652567,
				"type": "PERSON"
			},
			{
				"name": "accumulation",
				"salience": 0.000652567,
				"type": "EVENT"
			},
			{
				"name": "attempts",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "crash",
				"salience": 0.000652567,
				"type": "EVENT"
			},
			{
				"name": "austerity",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "boundaries",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "information technology",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "capacity",
				"salience": 0.000652567,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.000628203,
				"type": "OTHER"
			},
			{
				"name": "leash",
				"salience": 0.00062350463,
				"type": "OTHER"
			},
			{
				"name": "leash",
				"salience": 0.00062350463,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0006047484,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.00056294806,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00056294806,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00056294806,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.00056294806,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00056294806,
				"type": "OTHER"
			},
			{
				"name": "elitists",
				"salience": 0.0005400377,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.000539508,
				"type": "EVENT"
			},
			{
				"name": "judgment",
				"salience": 0.0005327081,
				"type": "OTHER"
			},
			{
				"name": "launching pad",
				"salience": 0.0005327081,
				"type": "OTHER"
			},
			{
				"name": "surplus",
				"salience": 0.00048744833,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.00048744833,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.00048744833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01gqgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oxfam"
				},
				"name": "Oxfam",
				"salience": 0.0004016085,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/enjoy_capitalism.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.009",
		"text": "‘Though it appears as if rumors of capitalism’s imminent demise have been greatly exaggerated,’ writes Johnson, ‘there is good reason to believe that its remarkable ability to adapt and evolve in the face of frequent (self-induced) shocks has reached a breaking point.’ In 1946, George Orwell pondered the fragility of the capitalist order.\nReviewing the work of the influential theorist James Burnham, Orwell presaged several concepts that would later form the groundwork for his best-known novel, 1984.\n“Not only is the best of capitalism behind us, but the worst of it may lie just ahead.”\nIn his book The Managerial Revolution , Burnham envisioned, as Orwell put it , “a new kind of planned, centralised society which will be neither capitalist nor, in any accepted sense of the word, democratic. The rulers of this new society will be the people who effectively control the means of production.”\n“The real question,” Orwell adds, “is not whether the people who wipe their boots on us during the next fifty years are to be called managers, bureaucrats, or politicians: the question is whether capitalism, now obviously doomed, is to give way to oligarchy or to true democracy.”\nWhile Orwell was wary of Burnham’s worldview and of his more specific predictions, he agreed that the relationship between capitalism and democracy has always been, and always will be, a precarious one.\n“For quite fifty years past,” Orwell noted, “the general drift has almost certainly been towards oligarchy.”\nPointing to the concentration of political and economic power in the hands of the few and acknowledging “the weakness of the proletariat against the centralised state,” Orwell was far from optimistic about the future — but he was quite certain that the economic status quo would eventually give way.\nRecent events, and the material circumstances of much of the world’s population, have prompted serious examinations of the same questions Orwell was considering seven decades ago. And though it appears as if rumors of capitalism’s imminent demise have been greatly exaggerated, there is good reason to believe that its remarkable ability to adapt and evolve in the face of frequent (self-induced) shocks has reached a breaking point.\nWidespread discontent over stagnant incomes and the uneven prosperity brought about by neoliberal globalization has, in 2016, come to a head in striking fashion; Donald Trump, Brexit, and the rise of far-right parties in Europe have many questioning previously sacred assumptions.\n“Is the marriage between liberal democracy and global capitalism an enduring one?” asked Martin Wolf, a formidable commentator in one of the world’s leading business papers, the Financial Times .\nThis was no rhetorical softball; Wolf is genuinely concerned that the winners of globalization have grown complacent, that they have “taken for granted” a couple that was only tenuously compatible to begin with. He also worries, rightly, that they have downplayed the concerns of the “losers.”\nWolf concludes that “if the legitimacy of our democratic political systems is to be maintained, economic policy must be orientated towards promoting the interests of the many not the few; in the first place would be the citizenry, to whom the politicians are accountable.”\nNot all members of the commentariat share Wolf’s willingness to engage with these cherished assumptions, however. Indeed, many analysts have reserved their ire not for failing institutions or policies but for the public, reviving Walter Lippmann’s characterization of the masses as a “bewildered herd” that, if left to its own devices, is sure to usher in a regime of chaos.\n“It’s time,” declared Foreign Policy ‘s James Traub, channeling the sentiments of Josh Barro, “for the elites to rise up against the ignorant masses.”\nApologists like Traub and Barro — just two among many — speak and write as if the leash previously restraining the “herd” has been loosened, and that the resulting freedom has laid bare what elitists have long believed to be the case: To use Barro’s infamous words , “Elites are usually elite for good reason, and tend to have better judgment than the average person.” They point to the rise of Donald Trump as evidence of an intolerable democratic surplus — evidence, in short, of what the masses will do if granted a loud enough voice.\nAside from being conveniently self-serving, this narrative is also false.\nFar from loosening the leash, elites have consolidated power to an unprecedented extent , and they have used their influence to undercut democratic movements and hijack public institutions. The resulting concentration of wealth and political power is jarring, and it puts the lie to the farcical notion that elites are a persecuted minority.\nBut, in the midst of these anti-democratic diatribes, fascinating and important critiques of a rather different nature have emerged.\n“Far from loosening the leash, elites have consolidated power to an unprecedented extent , and they have used their influence to undercut democratic movements and hijack public institutions.”\nInstead of urging us to align Against Democracy , to use the name of a recent book by the libertarian political philosopher Jason Brennan, many are arguing that it is capitalism, and not the excesses of the democratic process, that has provided figures like Trump a launching pad.\nIn his book Postcapitalism , Paul Mason argues that the rapid emergence of information technology has corroded the boundaries of the market; “capitalism,” he insists, “has reached the limits of its capacity to adapt.” And its attempts to reach beyond these limits have fostered an economic environment defined by instability, crippling austerity for the many, and rapid accumulation of wealth for the few.\nAccording to Oxfam, the global 1 percent now owns as much wealth as the bottom 99 percent. CEO pay has continued to soar. And though post-crisis reforms have carried soaring promises of stability, the financial sector is still far too large , and many of the banks harmed by the crash they created are back and nearly as powerful as ever .",
		"thread_title": "Capitalism Is Doomed — Without Alternatives, So Are We",
		"title": "Capitalism Is Doomed — Without Alternatives, So Are We",
		"type": "bs",
		"uuid": "83ef92b5972665300524324b20b9e3ece3803046"
	},
	"-KhIhbmxMelCECfkNxba": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:43.641+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.4832994,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.080931544,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.062955745,
				"type": "ORGANIZATION"
			},
			{
				"name": "Arjun Walia",
				"salience": 0.062955745,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.03194139,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.030549843,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05rgkg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Henry_Paulson"
				},
				"name": "Hank Paulson",
				"salience": 0.024801781,
				"type": "PERSON"
			},
			{
				"name": "messages",
				"salience": 0.022703389,
				"type": "OTHER"
			},
			{
				"name": "inauguration",
				"salience": 0.019703146,
				"type": "EVENT"
			},
			{
				"name": "transition team",
				"salience": 0.017732326,
				"type": "ORGANIZATION"
			},
			{
				"name": "batch",
				"salience": 0.015797904,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.013988473,
				"type": "WORK_OF_ART"
			},
			{
				"name": "collective-evolution.com",
				"salience": 0.012194288,
				"type": "ORGANIZATION"
			},
			{
				"name": "Administration",
				"salience": 0.009703967,
				"type": "ORGANIZATION"
			},
			{
				"name": "transition plan",
				"salience": 0.008987701,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0059534395,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.005728101,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.005071077,
				"type": "WORK_OF_ART"
			},
			{
				"name": "batch",
				"salience": 0.0048338384,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.004246885,
				"type": "EVENT"
			},
			{
				"name": "message",
				"salience": 0.004206201,
				"type": "OTHER"
			},
			{
				"name": "invitation",
				"salience": 0.0041874642,
				"type": "OTHER"
			},
			{
				"name": "Secretary Paulson",
				"salience": 0.0037562354,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0036435223,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05256f_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President-elect_of_the_United_States"
				},
				"name": "President-Elect",
				"salience": 0.0035698311,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interactions",
				"salience": 0.0033922666,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0033201987,
				"type": "EVENT"
			},
			{
				"name": "memo",
				"salience": 0.0032658929,
				"type": "WORK_OF_ART"
			},
			{
				"name": "memo",
				"salience": 0.0032658929,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president",
				"salience": 0.0030774053,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.002975659,
				"type": "OTHER"
			},
			{
				"name": "policy choices",
				"salience": 0.0029382287,
				"type": "OTHER"
			},
			{
				"name": "transition board",
				"salience": 0.0029382287,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.0028287333,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0027810142,
				"type": "WORK_OF_ART"
			},
			{
				"name": "housing",
				"salience": 0.0023994122,
				"type": "OTHER"
			},
			{
				"name": "crises",
				"salience": 0.0023994122,
				"type": "EVENT"
			},
			{
				"name": "policy responses",
				"salience": 0.0023994122,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0022927104,
				"type": "ORGANIZATION"
			},
			{
				"name": "members",
				"salience": 0.002070331,
				"type": "PERSON"
			},
			{
				"name": "transition",
				"salience": 0.0016641389,
				"type": "EVENT"
			},
			{
				"name": "transition",
				"salience": 0.0016641389,
				"type": "EVENT"
			},
			{
				"name": "transition team",
				"salience": 0.0014715461,
				"type": "ORGANIZATION"
			},
			{
				"name": "wheels",
				"salience": 0.0014273156,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0013508623,
				"type": "OTHER"
			},
			{
				"name": "motion",
				"salience": 0.0013061434,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0012734499,
				"type": "EVENT"
			},
			{
				"name": "interest",
				"salience": 0.0011268771,
				"type": "OTHER"
			},
			{
				"name": "matters",
				"salience": 0.00097582664,
				"type": "OTHER"
			},
			{
				"name": "engagement",
				"salience": 0.00097582664,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00097582664,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/barackobama.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "By: Arjun Walia via collective-evolution.com\nWikiLeaks just released their newest batch of leaked emails, and they contain messages sent to and from Barack Obama prior to his presidential inauguration.\nThe most interesting of the emails in this batch involves a message from John Podesta to Obama regarding an invitation from President George W. Bush to then ‘President-Elect’. It alluded to a transition plan that was being worked on before the election took place.\nAccording to the memo, Obama was already discussing his transition into office with the then-Treasury Secretary Hank Paulson. Here is a statement taken from a memo sent from the transition board to Barack Obama:\nAs you have observed in your interactions with Secretary Paulson, he is apparently eager to involve you and your transition team extensively in his policy choices following the election.\nImmediately after the election Secretary Paulson and other members of the Administration will likely seek to involve you and your transition team in their ongoing policy responses to the financial and housing crises. We also expect relentless interest from the press and public about your intended level of engagement with the Administration on these matters during the transition.\nThink about this for a second, Obama’s transition was already being discussed with certain members of the Bush administration. Also, judging by the email, it’s clear that it was known that Obama was going to be the president.\nAnother telling email, dated October 30, 2008, came from John Podesta to the then Senator Obama discussing an economic transition team, and why Obama needed to get the wheels in motion before his term begins.",
		"thread_title": "Wikileaks Releases First Batch Of Barack Obama Emails & They Hint At A Rigged Election",
		"title": "Wikileaks Releases First Batch Of Barack Obama Emails & They Hint At A Rigged Election",
		"type": "bs",
		"uuid": "ba29d216696e0ff6b9689e08454cf009999a5198"
	},
	"-KhIhbv7GzAvdesstwd4": {
		"author": "Jeannette",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:50.056+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.71954906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.10456486,
				"type": "LOCATION"
			},
			{
				"name": "order",
				"salience": 0.06639593,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.057240393,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.025138631,
				"type": "LOCATION"
			},
			{
				"name": "Vote Trump",
				"salience": 0.015206931,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Assange",
				"salience": 0.011904181,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "3",
		"participants_count": "13",
		"published": "2016-10-26T14:06:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "And this is,why every single American needs to vote for Trump.\nHis first order of business would probably be to pardon Assange.\nVote Trump, America, vote Trump!!!",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "49747e1dbab450a8099042b93f0ce64556f34240"
	},
	"-KhIhbyf5Q04aOKCzoxc": {
		"author": "AnonVoid (Moderator)",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:50.063+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "jeannette trump",
				"salience": 1,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "4",
		"participants_count": "13",
		"published": "2016-10-27T04:48:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "welcome back jeannette trump!",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "8710847343313bbe58e6122b5830177ec1c31ff7"
	},
	"-KhIhc1d6qTH98tkwLYB": {
		"author": "Sara Walters",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:50.384+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "reality",
				"salience": 0.6590547,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.1800608,
				"type": "PERSON"
			},
			{
				"name": "anywhere",
				"salience": 0.16088451,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "5",
		"participants_count": "13",
		"published": "2016-10-27T06:39:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "In reality, Julian Assange will never be safe anywhere.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "78340020d0193e13a40841ddac3636ef8fef609a"
	},
	"-KhIhc8ymeFvhE8b_kVW": {
		"author": "HazyHotDog",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:51.130+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "guy",
				"salience": 0.7143879,
				"type": "PERSON"
			},
			{
				"name": "plane",
				"salience": 0.114072554,
				"type": "OTHER"
			},
			{
				"name": "thread",
				"salience": 0.049433697,
				"type": "OTHER"
			},
			{
				"name": "embassy",
				"salience": 0.020886676,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.020118471,
				"type": "OTHER"
			},
			{
				"name": "dot",
				"salience": 0.017455209,
				"type": "OTHER"
			},
			{
				"name": "embassy",
				"salience": 0.017098915,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Assange",
				"salience": 0.014414198,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.012813261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ecuador"
				},
				"name": "Ecuadorian",
				"salience": 0.01121118,
				"type": "LOCATION"
			},
			{
				"name": "alarm",
				"salience": 0.008107953,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "6",
		"participants_count": "13",
		"published": "2016-10-26T17:50:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Oh hey, I was the guy who started that plane tracking thread – https://www.reddit.com/r/conspiracy/comments/57×782/flightradar24com_offline_after_a_redditor_tracks/ . A week ago I put the final dot on the situation, since the Ecuadorian embassy seemingly validated that Assange is still at the embassy and doing well.\nNow, 8 days later I come back to see what has changed, and to be honest, it looks like the situation hasn’t been crossed off as a “false alarm” yet.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "3919b26f289074229a1b8cc7a2a76f2abc25503e"
	},
	"-KhIhcCetxSJoI-f4oZb": {
		"author": "Truthteller",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:51.251+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Confidence",
				"salience": 0.5427159,
				"type": "OTHER"
			},
			{
				"name": "coward",
				"salience": 0.31737784,
				"type": "OTHER"
			},
			{
				"name": "guts",
				"salience": 0.13990627,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "7",
		"participants_count": "13",
		"published": "2016-10-26T21:04:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.5,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Confidence is high he is spilling his guts while being tortured, but coward he is he quickly gave it all up and now is dead.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "59f50c413b6417a91b30d6a8d6951be8efb81b81"
	},
	"-KhIhcG2CuV-2QUH2TyC": {
		"author": "Carole Jones",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:51.278+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Jesus",
				"salience": 0.71041906,
				"type": "PERSON"
			},
			{
				"name": "suffering",
				"salience": 0.20796907,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assage",
				"salience": 0.08161188,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "8",
		"participants_count": "13",
		"published": "2016-10-26T21:37:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Jesus hurry back. . To much suffering..thk u. Julian Assage.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "693b79fc8faa1ab96dad55b560672ccde66e2a8f"
	},
	"-KhIhcMJo9r_9gQmmqs0": {
		"author": "Ryanmorph",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:51.325+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "N379P",
				"salience": 0.25187457,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.14179215,
				"type": "EVENT"
			},
			{
				"name": "Malibu Mirage",
				"salience": 0.10900525,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03qd9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Piper_PA-46"
				},
				"name": "Piper PA-46",
				"salience": 0.10900525,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.10162177,
				"type": "OTHER"
			},
			{
				"name": "Flightradar24.com",
				"salience": 0.085641116,
				"type": "OTHER"
			},
			{
				"name": "airport",
				"salience": 0.07655793,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0qxzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hayward,_California"
				},
				"name": "Hayward",
				"salience": 0.047576856,
				"type": "LOCATION"
			},
			{
				"name": "landing",
				"salience": 0.04212979,
				"type": "EVENT"
			},
			{
				"name": "23rd",
				"salience": 0.03479533,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "9",
		"participants_count": "13",
		"published": "2016-10-27T00:44:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "N379P / Piper PA-46-350P Malibu Mirage\nand Flightradar24.com does list this flight as an “unknown” status on the 21st landing and then it came back to Hayward airport on the 23rd.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "0a2e9889ef324c5c323498b2045227488a885538"
	},
	"-KhIhcQ8jTSKhNcVeCXP": {
		"author": "WB",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:51.366+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "facts",
				"salience": 0.37364104,
				"type": "OTHER"
			},
			{
				"name": "rumor",
				"salience": 0.24418618,
				"type": "OTHER"
			},
			{
				"name": "speculation",
				"salience": 0.15724702,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.07553976,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sources",
				"salience": 0.06920223,
				"type": "OTHER"
			},
			{
				"name": "brain",
				"salience": 0.05185562,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.028328128,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "10",
		"participants_count": "13",
		"published": "2016-10-27T05:09:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 1.6,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "I find it troubling that there is only rumor, and unsubstantiated speculation being reported. Until I see facts with sources I can not believe anything…It is how my brain is wired. This article requires facts.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "f313b7a35d036f8f697d197535524e649e237ef7"
	},
	"-KhIhcy0YncIJuU2nfj5": {
		"author": "Janet Davenport",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:51.554+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0187wh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_WB"
				},
				"name": "WB",
				"salience": 0.7807015,
				"type": "ORGANIZATION"
			},
			{
				"name": "slice",
				"salience": 0.09405719,
				"type": "OTHER"
			},
			{
				"name": "ham",
				"salience": 0.077821106,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.047420193,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "11",
		"participants_count": "13",
		"published": "2016-10-27T06:43:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.5,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "I agree WB….that’s an awfully thin slice of ham not to have two sides.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "357daad320fa8e2c95e056c295efe284514026f6"
	},
	"-KhIhdDXf4L4CY8328AE": {
		"author": "sebastien Provencher",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T07:59:52.571+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "action",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "12",
		"participants_count": "13",
		"published": "2016-10-27T07:59:52.571+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 0.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "I’m ready come to me , you will regret your action.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "00fb73e408d13e789d4b74787a079b715477a261"
	},
	"-KhIhdW6Xwr3KLKUgDfT": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T08:00:42.861+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.29524356,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.14123902,
				"type": "LOCATION"
			},
			{
				"name": "distraction",
				"salience": 0.05680596,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.05081086,
				"type": "PERSON"
			},
			{
				"name": "clip",
				"salience": 0.05081086,
				"type": "WORK_OF_ART"
			},
			{
				"name": "group",
				"salience": 0.04164409,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.037353892,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.03153335,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.029434212,
				"type": "PERSON"
			},
			{
				"name": "enemy",
				"salience": 0.027345521,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.024425946,
				"type": "LOCATION"
			},
			{
				"name": "Would Mrs. Clinton",
				"salience": 0.022730555,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.021179369,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.021179369,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.021179369,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.008800472,
				"type": "PERSON"
			},
			{
				"name": "enemies",
				"salience": 0.008473017,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.008121377,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.0076238452,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0073400317,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0071887244,
				"type": "LOCATION"
			},
			{
				"name": "response",
				"salience": 0.0063865897,
				"type": "WORK_OF_ART"
			},
			{
				"name": "calls",
				"salience": 0.006227007,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.006227007,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.006227007,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0060218996,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.005373618,
				"type": "LOCATION"
			},
			{
				"name": "each other",
				"salience": 0.005373618,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War 3",
				"salience": 0.004697392,
				"type": "EVENT"
			},
			{
				"name": "another",
				"salience": 0.0046542385,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0046542385,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0045223087,
				"type": "ORGANIZATION"
			},
			{
				"name": "threats",
				"salience": 0.0039155674,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.003406294,
				"type": "PERSON"
			},
			{
				"name": "rhetoric",
				"salience": 0.0033910943,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0033910943,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0025338125,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.0025338125,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/o-PUTIN-facebook.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "In the clip – filmed in Russia – Putin, 64, tells a group of journalists that the US is creating a “distraction” aiming “to distract voters from the country’s problems” by creating “an enemy and uniting the nation against them”. He references both Iran and Russia as the potential enemies.\nBut when asked whether he prefers Donald Trump or Hillary Clinton his response says a lot about ongoing World War 3 fears.\nThe President responded: “Mrs Clinton has chosen to take up a very aggressive stance against our country, against Russia.\n“Mr Trump, on the other hand, calls for cooperation – at least when it comes to the international fight against terrorism.\n“Naturally we welcome those who would like to cooperate with us. And we consider it wrong, that we always have to be in conflict with one another, creating existential threats for each other and for the whole world.\n“Would Mrs. Clinton delivers on he threats and harsh rhetoric against Russia if she became President? Or will she correct her position against us?”",
		"thread_title": "Putin blasts Clinton & Tells U.S. Govt to STOP Criticizing Russia",
		"title": "Putin blasts Clinton & Tells U.S. Govt to STOP Criticizing Russia",
		"type": "bs",
		"uuid": "10165357c27399c0b85c74c0830238239b3902c3"
	},
	"-KhIhdkmHpqa24AtpYgX": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T08:01:08.762+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.34899256,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.10333771,
				"type": "OTHER"
			},
			{
				"name": "scholar",
				"salience": 0.061943043,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.049117938,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.043642282,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.040018763,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02tpw5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stephen_Kinzer"
				},
				"name": "Stephen Kinzer",
				"salience": 0.033118177,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.019438582,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.017398242,
				"type": "ORGANIZATION"
			},
			{
				"name": "thousands",
				"salience": 0.016242811,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0156525,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media",
				"salience": 0.015073005,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.01454516,
				"type": "WORK_OF_ART"
			},
			{
				"name": "kind",
				"salience": 0.014168234,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.009206275,
				"type": "EVENT"
			},
			{
				"name": "nations",
				"salience": 0.008329622,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0076488676,
				"type": "EVENT"
			},
			{
				"name": "public",
				"salience": 0.0072168955,
				"type": "PERSON"
			},
			{
				"name": "piece",
				"salience": 0.0072168955,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0058214627,
				"type": "OTHER"
			},
			{
				"name": "media misinformation",
				"salience": 0.004815439,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07dk8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Boston_Globe"
				},
				"name": "Boston Globe",
				"salience": 0.0044481056,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0041190507,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0041190507,
				"type": "LOCATION"
			},
			{
				"name": "title",
				"salience": 0.0037617388,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.003743999,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.003559119,
				"type": "EVENT"
			},
			{
				"name": "nations",
				"salience": 0.003436842,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0034264633,
				"type": "EVENT"
			},
			{
				"name": "intervention",
				"salience": 0.0029899427,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.002976604,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.002976604,
				"type": "OTHER"
			},
			{
				"name": "ignorance",
				"salience": 0.002976604,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.002976604,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.002976604,
				"type": "OTHER"
			},
			{
				"name": "truths",
				"salience": 0.0029063504,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0029063504,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0029063504,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0028895386,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0028895386,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0027817998,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0027817998,
				"type": "ORGANIZATION"
			},
			{
				"name": "Neither",
				"salience": 0.0026897623,
				"type": "PERSON"
			},
			{
				"name": "assertion",
				"salience": 0.0025894612,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.002582444,
				"type": "ORGANIZATION"
			},
			{
				"name": "principles",
				"salience": 0.0024106828,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0023594094,
				"type": "ORGANIZATION"
			},
			{
				"name": "principle",
				"salience": 0.0023207746,
				"type": "OTHER"
			},
			{
				"name": "culpability",
				"salience": 0.0023207746,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.002191877,
				"type": "EVENT"
			},
			{
				"name": "truth",
				"salience": 0.0021717253,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0021717253,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002087696,
				"type": "PERSON"
			},
			{
				"name": "wealth",
				"salience": 0.002087696,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.002087696,
				"type": "OTHER"
			},
			{
				"name": "affairs",
				"salience": 0.002087696,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.002087696,
				"type": "ORGANIZATION"
			},
			{
				"name": "set",
				"salience": 0.002087696,
				"type": "OTHER"
			},
			{
				"name": "military mission",
				"salience": 0.002087696,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.002035451,
				"type": "PERSON"
			},
			{
				"name": "meddling",
				"salience": 0.00200982,
				"type": "OTHER"
			},
			{
				"name": "fault",
				"salience": 0.00200982,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0018329005,
				"type": "PERSON"
			},
			{
				"name": "Brown University Institute",
				"salience": 0.0018329005,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0018329005,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.0017513633,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0017045328,
				"type": "PERSON"
			},
			{
				"name": "reality",
				"salience": 0.0017045328,
				"type": "OTHER"
			},
			{
				"name": "rebellion",
				"salience": 0.0017045328,
				"type": "EVENT"
			},
			{
				"name": "uprising",
				"salience": 0.0017045328,
				"type": "EVENT"
			},
			{
				"name": "point",
				"salience": 0.001482697,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0014705869,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0013916368,
				"type": "OTHER"
			},
			{
				"name": "continuation",
				"salience": 0.0013228289,
				"type": "OTHER"
			},
			{
				"name": "brief",
				"salience": 0.0012734634,
				"type": "OTHER"
			},
			{
				"name": "volumes",
				"salience": 0.0012734634,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0012373206,
				"type": "LOCATION"
			},
			{
				"name": "authority",
				"salience": 0.0011952445,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0011818961,
				"type": "OTHER"
			},
			{
				"name": "Alon Ben-David",
				"salience": 0.0011621577,
				"type": "PERSON"
			},
			{
				"name": "swamp",
				"salience": 0.0010711349,
				"type": "OTHER"
			},
			{
				"name": "swamp",
				"salience": 0.0010711349,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00095929817,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.00095929817,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.00092752714,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00092752714,
				"type": "OTHER"
			},
			{
				"name": "mosquitoes",
				"salience": 0.00092752714,
				"type": "OTHER"
			},
			{
				"name": "swarms",
				"salience": 0.00092752714,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.00092752714,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.00088622957,
				"type": "OTHER"
			},
			{
				"name": "culpability",
				"salience": 0.0008001757,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0008001757,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01978x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Jerusalem_Post"
				},
				"name": "Jerusalem Post",
				"salience": 0.0007838644,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conflict",
				"salience": 0.0006928811,
				"type": "EVENT"
			},
			{
				"name": "versions",
				"salience": 0.0006928811,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "points",
				"salience": 0.0006928811,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0006928811,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0006928811,
				"type": "OTHER"
			},
			{
				"name": "genocide",
				"salience": 0.0006928811,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.0005708841,
				"type": "LOCATION"
			},
			{
				"name": "No one",
				"salience": 0.00027225772,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "416",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/truth_in_syria.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.3,
			"score": 0
		},
		"shares": "416",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "In Syria, the only “truth” that all parties seem to agree upon is that hundreds of thousands are dead and Syria is shattered.\n“The United States has the power to decree the death of nations,” wrote Stephen Kinzer in the Boston Globe.\nKinzer’s article was entitled: “ The media are misleading the public on Syria .” In his piece, the scholar at a Brown University Institute contested that his country’s media misinformation on Syria is leading to the kind of ignorance which is enabling the American government to pursue any policy, however imprudent, in the war-torn Arab country.\nThe US government can ‘decree the death of nations’ with “popular support because many Americans — and many journalists — are content with the official story,” he wrote.\nKinzer, in principle makes a strong point. His article, however, was particularly popular among those who sees the Syrian government entirely innocent of any culpability in the ongoing war, and that Iran and Russia are at no fault whatsoever; better yet, their intervention in Syria is entirely morally-guided and altruistic.\nThat said, Kinzer’s assertion regarding the US government’s dangerous meddling in Syria’s affairs, renewed Cold War with Russia and ill-defined military mission in that country, is all true.\nNeither is the US, nor its western and other allies, following rules of war nor adhering to a particularly noble set of principles aimed at ending that most devastating war, which has killed well over 300,000 people , rendered millions displaced and destroyed the country’s wealth and infrastructure.\nSo what is the truth on Syria?\nIn the last five and a half years, since a regional uprising turned into an armed rebellion—turned into civil, regional and international war—’the truth on Syria’, has been segmented into many self-tailored ‘truths,’ each promoted by one of the warring party to be the one and only, absolute and uncontested reality. But since there are many parties to the conflict, the versions of the ‘truth’ communicated to us via copious media, are numerous and, most often, unverifiable.\nThe only truth that all parties seem to agree upon is that hundreds of thousands are dead and Syria is shattered. But, of course, each points to the other side for culpability of the ongoing genocide.\nAn oddly refreshing, although disturbing ‘truth’ was articulated by Alon Ben-David in the Israeli Jerusalem Post last year.\nThe title of his article speaks volumes: “ May it never end: The uncomfortable truth about the war in Syria .”\n“If Israel’s interest in the war in Syria can be summarized in brief, it would be: That it should never end,” Ben-David wrote.\n“No one will say this publicly, but the continuation of the fighting in Syria, as long as there is a recognized authority in Damascus, allows Israel to stay out of the swamp and distance itself from the swarms of mosquitoes that are buzzing in it.” Of course, Israel never truly ‘stayed out of the swamp’ , but that is for a separate discussion.",
		"thread_title": "The Many \"Truths\" on Syria: How Our Rivalry Has Destroyed a Country",
		"title": "The Many \"Truths\" on Syria: How Our Rivalry Has Destroyed a Country",
		"type": "bs",
		"uuid": "c9a320623a31272e7bddbab07a58ed0abb352341"
	},
	"-KhIheDlLOMgBbS5mVgo": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:02:01.600+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "employees",
				"salience": 0.20466165,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.16345237,
				"type": "OTHER"
			},
			{
				"name": "employee",
				"salience": 0.079870746,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.062958464,
				"type": "ORGANIZATION"
			},
			{
				"name": "more",
				"salience": 0.062958464,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.06146868,
				"type": "OTHER"
			},
			{
				"name": "trueactivist.com",
				"salience": 0.034019526,
				"type": "OTHER"
			},
			{
				"name": "Amanda Froelich",
				"salience": 0.034019526,
				"type": "PERSON"
			},
			{
				"name": "health implications",
				"salience": 0.032670137,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.02300859,
				"type": "LOCATION"
			},
			{
				"name": "work",
				"salience": 0.018257445,
				"type": "OTHER"
			},
			{
				"name": "dread",
				"salience": 0.017017603,
				"type": "OTHER"
			},
			{
				"name": "workplace",
				"salience": 0.012831846,
				"type": "LOCATION"
			},
			{
				"name": "work",
				"salience": 0.01235544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.011922823,
				"type": "LOCATION"
			},
			{
				"name": "friends",
				"salience": 0.011736019,
				"type": "PERSON"
			},
			{
				"name": "family members",
				"salience": 0.011736019,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.011736019,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.010810103,
				"type": "PERSON"
			},
			{
				"name": "contact",
				"salience": 0.010609019,
				"type": "OTHER"
			},
			{
				"name": "Credit",
				"salience": 0.008240771,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.007934173,
				"type": "OTHER"
			},
			{
				"name": "stomach",
				"salience": 0.007934173,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.00788295,
				"type": "PERSON"
			},
			{
				"name": "workplace",
				"salience": 0.007842184,
				"type": "LOCATION"
			},
			{
				"name": "employees",
				"salience": 0.0078109023,
				"type": "PERSON"
			},
			{
				"name": "family leave",
				"salience": 0.0067316573,
				"type": "OTHER"
			},
			{
				"name": "initiative",
				"salience": 0.0064810324,
				"type": "OTHER"
			},
			{
				"name": "amendment",
				"salience": 0.0064810324,
				"type": "WORK_OF_ART"
			},
			{
				"name": "result",
				"salience": 0.0053607766,
				"type": "OTHER"
			},
			{
				"name": "Wall Street Journal Already",
				"salience": 0.005078705,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.005032066,
				"type": "OTHER"
			},
			{
				"name": "relays",
				"salience": 0.005032066,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "law",
				"salience": 0.0046882075,
				"type": "OTHER"
			},
			{
				"name": "employee",
				"salience": 0.0040454455,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.0031638246,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0031638246,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.0030868258,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rqxn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Assembly_(France)"
				},
				"name": "French National Assembly",
				"salience": 0.002257899,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0551nw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beno%C3%AEt_Hamon"
				},
				"name": "Benoit Hamon",
				"salience": 0.001964069,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/049rl0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC_News"
				},
				"name": "BBC News",
				"salience": 0.0016869246,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/89641461_woman_cut.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "By Amanda Froelich at trueactivist.com\nThe new “right to disconnect” law mandates that a company with 50 employees or more cannot email an employee after typical work hours.\nIf you’ve ever been with friends or family members over the weekend then received an urgent email from work, you’re aware of the dread that fills your stomach and causes your mood to dip. Being unable to fully disconnect from work can have mental and physical health implications, which is why unwarranted contact by the workplace is soon to become illegal in France.\nCredit: Wall Street Journal\nAlready, the country gives its employees 30 days off a year and 16 weeks of full-paid family leave; this latest initiative is only making France more popular. According to BBC News , the new “right to disconnect” law will mandate that a company with 50 employees or more cannot email an employee after typical work hours. The amendment is largely a result of studies showing that people have an increasingly difficult time distancing themselves from the workplace.\nGood relays that the law seeks to make sure the French citizens are able to fully enjoy their time off. Said Benoit Hamon of the French National Assembly:",
		"thread_title": "New French Law Makes It Illegal To Contact Employees After Work Hours",
		"title": "New French Law Makes It Illegal To Contact Employees After Work Hours",
		"type": "bs",
		"uuid": "c202f2092c08246a59e4fbb4c2e1299b549b63bf"
	},
	"-KhIheIjHmvC9ir7GuvW": {
		"author": "Martin",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:02:02.508+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "women",
				"salience": 0.46572042,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.21929592,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.19600824,
				"type": "PERSON"
			},
			{
				"name": "PEACE",
				"salience": 0.0808995,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.038075928,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/F150826HP11-635x357.jpg",
		"ord_in_thread": "1",
		"participants_count": "3",
		"published": "2016-10-27T02:06:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.11",
		"text": "Put the women in charge. Maybe PEACE will break out.*\n*Hillary not included, she’s not really a woman.",
		"thread_title": "Promoting Peace: A Large Number of Israeli and Palestinian Women March Together",
		"title": "",
		"type": "bs",
		"uuid": "57dc910580c184569ca28b81aa2bfbbf6a499a20"
	},
	"-KhIheOxGPjwsAvD2MQo": {
		"author": "OZbanislam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:02:02.532+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.5093447,
				"type": "OTHER"
			},
			{
				"name": "Extremists",
				"salience": 0.13857485,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h8mw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haaretz"
				},
				"name": "Haaretz",
				"salience": 0.087155215,
				"type": "ORGANIZATION"
			},
			{
				"name": "racists",
				"salience": 0.06199935,
				"type": "PERSON"
			},
			{
				"name": "protestors",
				"salience": 0.058963217,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.03344933,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.029701615,
				"type": "OTHER"
			},
			{
				"name": "Anti Semitism",
				"salience": 0.021428624,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.020211847,
				"type": "PERSON"
			},
			{
				"name": "sovereignty",
				"salience": 0.009560152,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0071476633,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Netanyahu",
				"salience": 0.0062766187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05yg8kx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UNESCO"
				},
				"name": "UNESCO",
				"salience": 0.005891751,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.005891751,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.00440332,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/F150826HP11-635x357.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-27T03:35:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 1,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.11",
		"text": "Haaretz are full of crap.The Jewish Extremists might harm the peaceful protestors? Who were mainly Jewish women?Are you truly that hateful to Jews you still need to throw n some Anti Semitism?Must be hard for racists to report on Jewish women extending the hand of peace to Islam?If you think they are protesting Netanyahu you miss understand.They are standing against the UNESCO trying to remove Jewish sovereignty from Israel.",
		"thread_title": "Promoting Peace: A Large Number of Israeli and Palestinian Women March Together",
		"title": "",
		"type": "bs",
		"uuid": "bbbc9a0ed6158fa5f3abfc0647d2fbc01ca8101b"
	},
	"-KhIhe_HT91jnvZSUVP9": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:02:04.437+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "video",
				"salience": 0.17290261,
				"type": "WORK_OF_ART"
			},
			{
				"name": "height",
				"salience": 0.07408634,
				"type": "OTHER"
			},
			{
				"name": "ignorance",
				"salience": 0.06968731,
				"type": "OTHER"
			},
			{
				"name": "Condemnation",
				"salience": 0.06968731,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.06968731,
				"type": "OTHER"
			},
			{
				"name": "Firemen",
				"salience": 0.05167321,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jcx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Albert_Einstein"
				},
				"name": "Albert Einstein",
				"salience": 0.043450646,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05hhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Institute_of_Standards_and_Technology"
				},
				"name": "NIST",
				"salience": 0.043450646,
				"type": "ORGANIZATION"
			},
			{
				"name": "explosions",
				"salience": 0.033715375,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0czc1h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/One_World_Trade_Center"
				},
				"name": "WTC1",
				"salience": 0.029319394,
				"type": "LOCATION"
			},
			{
				"name": "Studies",
				"salience": 0.029257203,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.029257203,
				"type": "OTHER"
			},
			{
				"name": "devices",
				"salience": 0.026803432,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "video",
				"salience": 0.023599356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "firefighters",
				"salience": 0.021295998,
				"type": "PERSON"
			},
			{
				"name": "International Center",
				"salience": 0.020879189,
				"type": "LOCATION"
			},
			{
				"name": "collapse",
				"salience": 0.019835617,
				"type": "EVENT"
			},
			{
				"name": "twin towers",
				"salience": 0.019835617,
				"type": "LOCATION"
			},
			{
				"name": "buildings",
				"salience": 0.017145526,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.016220348,
				"type": "OTHER"
			},
			{
				"name": "lobby",
				"salience": 0.014602652,
				"type": "LOCATION"
			},
			{
				"name": "bombs",
				"salience": 0.014007445,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.013497138,
				"type": "LOCATION"
			},
			{
				"name": "fires",
				"salience": 0.011935548,
				"type": "EVENT"
			},
			{
				"name": "explosions",
				"salience": 0.009964461,
				"type": "EVENT"
			},
			{
				"name": "plane",
				"salience": 0.008633431,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0049491725,
				"type": "OTHER"
			},
			{
				"name": "lobby",
				"salience": 0.004865706,
				"type": "LOCATION"
			},
			{
				"name": "Firefighters",
				"salience": 0.004865706,
				"type": "PERSON"
			},
			{
				"name": "third",
				"salience": 0.004825465,
				"type": "PERSON"
			},
			{
				"name": "lobby",
				"salience": 0.00474408,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.0047048423,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0047048423,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.0047048423,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0047048423,
				"type": "PERSON"
			},
			{
				"name": "How Bombs Were Going Off In The Lobby Of World Trade Center 1",
				"salience": 0.0025001834,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Untitled-19-959x600.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.1,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "By anonews\n“Condemnation without investigation is the height of ignorance” – Albert Einstein\nNewly obtained video that was reluctantly released by NIST after a lawsuit by the International Center for 9/11 Studies shows two firefighters on 9/11 discussing how secondary explosions occurred immediately before the collapse of the twin towers, providing damning new evidence that explosive devices were used to bring down the buildings.\nFiremen discuss how bombs were going off in the lobby of WTC1 as they were staging to move up the building.\nThey explain how the building had already been hit by the plane and fires were already burning. After two explosions in the lobby, a third went off and the whole lobby collapsed.\nListen To 9/11 Firefighters Tell How Bombs Were Going Off In The Lobby Of World Trade Center 1:\nEven though it’s an old video, it’s useful to share given the fact that people are still waking up to the possibility that the official story presented to the public was false.",
		"thread_title": "9/11 Firefighters Reveal Bombs Destroyed WTC lobby",
		"title": "9/11 Firefighters Reveal Bombs Destroyed WTC lobby",
		"type": "bs",
		"uuid": "eb0f2d4d6ef563de65103dcb02686e9fb431c868"
	},
	"-KhIhelIivGBjAhxw4vA": {
		"author": "Amando Flavio",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:02:07.350+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi Germany",
				"salience": 0.14685768,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.112138316,
				"type": "LOCATION"
			},
			{
				"name": "Schatzgraber",
				"salience": 0.07809874,
				"type": "OTHER"
			},
			{
				"name": "mystery",
				"salience": 0.036663257,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026pf9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ahnenerbe"
				},
				"name": "Ahnenerbe",
				"salience": 0.034973342,
				"type": "ORGANIZATION"
			},
			{
				"name": "observers",
				"salience": 0.03289597,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.030374544,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.028525453,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "The Third Reich",
				"salience": 0.02703453,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "Second World War",
				"salience": 0.026729345,
				"type": "EVENT"
			},
			{
				"name": "belief",
				"salience": 0.018829174,
				"type": "OTHER"
			},
			{
				"name": "speculation",
				"salience": 0.01558329,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.015036447,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.014686958,
				"type": "LOCATION"
			},
			{
				"name": "pseudo-science",
				"salience": 0.014630172,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.014630172,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.014630172,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.014630172,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.014384044,
				"type": "PERSON"
			},
			{
				"name": "expeditions",
				"salience": 0.012798465,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.011715417,
				"type": "WORK_OF_ART"
			},
			{
				"name": "base",
				"salience": 0.009772349,
				"type": "OTHER"
			},
			{
				"name": "scientists",
				"salience": 0.009106877,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hitler",
				"salience": 0.009019911,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazis",
				"salience": 0.008709789,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.008352944,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0074924747,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0074924747,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0074924747,
				"type": "OTHER"
			},
			{
				"name": "discovery",
				"salience": 0.00725209,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0069700126,
				"type": "ORGANIZATION"
			},
			{
				"name": "experiments",
				"salience": 0.006223826,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.0060682083,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.006036933,
				"type": "LOCATION"
			},
			{
				"name": "answers",
				"salience": 0.006036933,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.006036933,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.006036933,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02p8yz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Treasure_hunting"
				},
				"name": "Treasure Hunter",
				"salience": 0.005834546,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0056419624,
				"type": "EVENT"
			},
			{
				"name": "polar bear",
				"salience": 0.0055590887,
				"type": "OTHER"
			},
			{
				"name": "Evgeny Ermolov",
				"salience": 0.005223975,
				"type": "PERSON"
			},
			{
				"name": "experiments",
				"salience": 0.005082373,
				"type": "OTHER"
			},
			{
				"name": "weather station",
				"salience": 0.004707156,
				"type": "LOCATION"
			},
			{
				"name": "base",
				"salience": 0.0045726453,
				"type": "LOCATION"
			},
			{
				"name": "base",
				"salience": 0.0042919954,
				"type": "OTHER"
			},
			{
				"name": "submarines",
				"salience": 0.0042345156,
				"type": "OTHER"
			},
			{
				"name": "beings",
				"salience": 0.0042345156,
				"type": "OTHER"
			},
			{
				"name": "aliens",
				"salience": 0.0042345156,
				"type": "OTHER"
			},
			{
				"name": "win",
				"salience": 0.0042345156,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.0042345156,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0042345156,
				"type": "PERSON"
			},
			{
				"name": "warships",
				"salience": 0.0042345156,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0040765917,
				"type": "EVENT"
			},
			{
				"name": "researchers",
				"salience": 0.003773181,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "USSR",
				"salience": 0.0037178094,
				"type": "ORGANIZATION"
			},
			{
				"name": "army",
				"salience": 0.0034945048,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0034743918,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.003457479,
				"type": "EVENT"
			},
			{
				"name": "attempts",
				"salience": 0.003457479,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.003457479,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09738",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arctic"
				},
				"name": "Arctic",
				"salience": 0.0032099017,
				"type": "LOCATION"
			},
			{
				"name": "observers",
				"salience": 0.002983017,
				"type": "PERSON"
			},
			{
				"name": "populations",
				"salience": 0.0029696997,
				"type": "PERSON"
			},
			{
				"name": "existence",
				"salience": 0.0025832152,
				"type": "OTHER"
			},
			{
				"name": "myth",
				"salience": 0.0025832152,
				"type": "OTHER"
			},
			{
				"name": "authors",
				"salience": 0.0025832152,
				"type": "PERSON"
			},
			{
				"name": "U-boat",
				"salience": 0.0025832152,
				"type": "OTHER"
			},
			{
				"name": "influences",
				"salience": 0.0025832152,
				"type": "OTHER"
			},
			{
				"name": "trichinosis",
				"salience": 0.0025832152,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.002488851,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0024868245,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0021728398,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/014wc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aryan"
				},
				"name": "Aryan",
				"salience": 0.002128559,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hfz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Heinrich_Himmler"
				},
				"name": "Heinrich Himmler",
				"salience": 0.002128559,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/094yqy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Herman_Wirth"
				},
				"name": "Herman Wirth",
				"salience": 0.002128559,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/033214",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_Walther_Darr%C3%A9"
				},
				"name": "Richard Walther Darré",
				"salience": 0.002128559,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05j429",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nordic_race"
				},
				"name": "Nordic",
				"salience": 0.002128559,
				"type": "LOCATION"
			},
			{
				"name": "rescue",
				"salience": 0.0021089788,
				"type": "EVENT"
			},
			{
				"name": "proof",
				"salience": 0.0020561758,
				"type": "OTHER"
			},
			{
				"name": "island",
				"salience": 0.0018815545,
				"type": "LOCATION"
			},
			{
				"name": "sources",
				"salience": 0.0018815545,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0016232351,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0016232351,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05g9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Party"
				},
				"name": "Nazis",
				"salience": 0.0015320424,
				"type": "PERSON"
			},
			{
				"name": "offensive",
				"salience": 0.0014055935,
				"type": "OTHER"
			},
			{
				"name": "supplies",
				"salience": 0.0014055935,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0014055935,
				"type": "OTHER"
			},
			{
				"name": "base outpost",
				"salience": 0.0014055935,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.0011740549,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rpjx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alexandra_Land"
				},
				"name": "Alexandra Land",
				"salience": 0.0011581228,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j9p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arctic_Circle"
				},
				"name": "Arctic Circle",
				"salience": 0.0011581228,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05h21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Pole"
				},
				"name": "North Pole",
				"salience": 0.0011581228,
				"type": "LOCATION"
			},
			{
				"name": "Russian Arctic National Park",
				"salience": 0.0011581228,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-2-43.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.034",
		"text": "The mystery surrounding The Third Reich and Nazi Germany is still a subject of debate between many observers. Some believe that Nazi Germany, under the control of Adolf Hitler, possessed supernatural powers, and largely employed pseudo-science during the 1933-1945 period. However, some also hold that the above belief is just a mere speculation without any proven fact. Over the years, researchers have searched extensively for answers to some of the more mysterious activities associated with Nazi Germany.\nNazi Germany invaded Russia (formerly the USSR) during the Second World War on June 22, 1941. At the time, the German army progressed deep into Russian territory, gaining ground close to the capital Moscow, before the Russians could counter-attack, eventually driving the Nazis back.\nDuring the Nazi occupation in Russia, in 1942, the Nazis built a secret military base around the Arctic, code-named “Schatzgraber” or “Treasure Hunter,” which was reportedly very instrumental in the war against Russia. The base was primarily used as a tactical weather station for planning the strategic movements of Nazi troops, warships and submarines. The base also housed eminent Nazi scientists, whom conducted many experiments to help progress a German win of the war. It was widely speculated at the time that the Nazis used the base to contact aliens or extraterrestrial beings. The controversial Ahnenerbe was even linked to the base. The Ahnenerbe was an institute in Nazi Germany. Responsible for researching archaeological and cultural history of the Aryan race, it is rumored to have had heavy occult influences. Founded on July 1, 1935, by Heinrich Himmler, Herman Wirth and Richard Walther Darré, the Ahnenerbe later conducted experiments and launched expeditions in attempts to prove that mythological Nordic populations had once ruled the world.\nHowever, the Nazis abandoned the base in 1944 – a time when the Russian army began its offensive, pushing the Germans out of the country. According to a war-time story, supplies had dwindled to dangerously low levels, and the Nazi officers stationed at the base outpost were forced to kill and eat polar bear, which ultimately, was infected with trichinosis. This caused those stationed at the base to fall severely ill and eventually they required rescue by a German U-boat. Despite Russian authors telling the story of “Treasure Hunter,” some observers consider it a myth, doubting its existence.\nBut Russian researchers have now announced that “Treasure Hunter” has been discovered, saying the base is on the island of Alexandra Land in the Arctic Circle, located 620 miles from the North Pole.\nA senior researcher at the Russian Arctic National Park, Evgeny Ermolov said in a statement announcing the discovery : “Before it was only known from written sources, but now we also have real proof.”",
		"thread_title": "Russian Researchers Discover Secret Nazi Military Base ‘Treasure Hunter’ in the Arctic [Photos]",
		"title": "Russian Researchers Discover Secret Nazi Military Base ‘Treasure Hunter’ in the Arctic [Photos]",
		"type": "bs",
		"uuid": "7b7e46aef27cf485f7abe94a43a685d3187da241"
	},
	"-KhIhezBj1DFpRygs6_D": {
		"author": "Amando Flavio",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:02:35.729+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Richard Ganyata",
				"salience": 0.2551039,
				"type": "PERSON"
			},
			{
				"name": "pedophile",
				"salience": 0.1840713,
				"type": "PERSON"
			},
			{
				"name": "Internet Interceptors",
				"salience": 0.122518316,
				"type": "ORGANIZATION"
			},
			{
				"name": "friend",
				"salience": 0.07547099,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.047888953,
				"type": "PERSON"
			},
			{
				"name": "sex",
				"salience": 0.03855813,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.03363257,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.026067622,
				"type": "PERSON"
			},
			{
				"name": "law deal",
				"salience": 0.016762892,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.015986403,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "United Kingdom",
				"salience": 0.01588677,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.012642078,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04p7yd4"
				},
				"name": "Richard",
				"salience": 0.0108083645,
				"type": "PERSON"
			},
			{
				"name": "pedophile",
				"salience": 0.010106668,
				"type": "OTHER"
			},
			{
				"name": "sex",
				"salience": 0.008242021,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.0072195088,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.0069509647,
				"type": "PERSON"
			},
			{
				"name": "Rugby player",
				"salience": 0.0067630033,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.006571645,
				"type": "LOCATION"
			},
			{
				"name": "vigilante group",
				"salience": 0.006421118,
				"type": "ORGANIZATION"
			},
			{
				"name": "girl",
				"salience": 0.0058976575,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.0058976575,
				"type": "PERSON"
			},
			{
				"name": "sex",
				"salience": 0.0052957013,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.004696793,
				"type": "PERSON"
			},
			{
				"name": "club house",
				"salience": 0.0044190995,
				"type": "LOCATION"
			},
			{
				"name": "sex",
				"salience": 0.004325214,
				"type": "EVENT"
			},
			{
				"name": "club house",
				"salience": 0.004254468,
				"type": "LOCATION"
			},
			{
				"name": "rugby team",
				"salience": 0.004254468,
				"type": "ORGANIZATION"
			},
			{
				"name": "sister",
				"salience": 0.0038276091,
				"type": "PERSON"
			},
			{
				"name": "pedophile",
				"salience": 0.0038187157,
				"type": "OTHER"
			},
			{
				"name": "video chat",
				"salience": 0.0036849666,
				"type": "OTHER"
			},
			{
				"name": "residence",
				"salience": 0.0036849666,
				"type": "LOCATION"
			},
			{
				"name": "Saracens Amateur RFC",
				"salience": 0.0033608703,
				"type": "LOCATION"
			},
			{
				"name": "team",
				"salience": 0.0031591328,
				"type": "ORGANIZATION"
			},
			{
				"name": "response",
				"salience": 0.0031256813,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.0031256813,
				"type": "OTHER"
			},
			{
				"name": "sofa",
				"salience": 0.0031256813,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "police",
				"salience": 0.0030863462,
				"type": "PERSON"
			},
			{
				"name": "pedophile",
				"salience": 0.003079172,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0023356874,
				"type": "EVENT"
			},
			{
				"name": "camera",
				"salience": 0.0023356874,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0021759258,
				"type": "ORGANIZATION"
			},
			{
				"name": "pedophile",
				"salience": 0.00207911,
				"type": "OTHER"
			},
			{
				"name": "pedophiles",
				"salience": 0.00207911,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00207911,
				"type": "OTHER"
			},
			{
				"name": "pedophile",
				"salience": 0.00207911,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.0010431688,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-1-42-e1477379119658.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.294",
		"text": "An online vigilante group in the United Kingdom, the Internet Interceptors, has helped the law deal with a 33-year-old pedophile who was planning to lure a 14-year-old girl to have sex with him in north London. The pedophile, Richard Ganyata, is said to be a Rugby player at Saracens Amateur RFC. It’s thought that he had met the underage 14-year-old girl online, proposing to have sex with her at his residence.\nIn a video chat with the supposed underage girl, Ganyata claimed to be 23-years-old. He told the girl that he lived at the club house of his rugby team. He then proposed that the girl visit him for sex, instructing the girl that if she arrives at the club house, she should pretend she was just his little sister’s friend.\nHe also told the girl how he planned to lay with her on the sofa, describing in detail what he would do to her during sex. The positive response from the girl excited Ganyata, who was looking forward to having a good time with the underage girl.\nBut unbeknownst to the pedophile, he had spoken to members of the Internet Interceptors instead – the team who dedicate their time to hunting down pedophiles on the Internet.\nWhen the day came for the pedophile to meet the girl as planned, he went to pick her up, but rather than meet with her, he was confronted by members of the Internet Interceptors, who immediately called the police. The vigilante group filmed their meeting with the pedophile on camera.\nA member of the group asked the pedophile: “You’re here to meet a 14-year-girl aren’t you, Richard?”\nHe replied: “I wasn’t really sure about it.”",
		"thread_title": "Anonymous Online Vigilante Group Helps Jail a Pedophile",
		"title": "Anonymous Online Vigilante Group Helps Jail a Pedophile",
		"type": "bs",
		"uuid": "983b2c96728589706efc06f9f5dc0237c964ccb3"
	},
	"-KhIhf8Pf2wtYpHv6wUv": {
		"author": "Mae",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:05:07.419+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "mammogram",
				"salience": 0.85586095,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.14413905,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/MAMMOGRAPHY.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-27T07:54:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 1.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "I have only ever had one mammogram, and that was enough to convince me that I would not be going back. If you want to avoid cancer, live clean, eat clean and think clean.",
		"thread_title": "Surgeons Admit Mammography is Outdated, Harmful at Best",
		"title": "",
		"type": "bs",
		"uuid": "e81b3f1e14a80bc901002a28ceac63c81f03f9cc"
	},
	"-KhIhfERviFyMsOGCeuq": {
		"author": "Mae",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:05:08.088+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Wheat",
				"salience": 0.45098093,
				"type": "OTHER"
			},
			{
				"name": "gmo hybrid",
				"salience": 0.076195724,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.067721546,
				"type": "OTHER"
			},
			{
				"name": "crap",
				"salience": 0.055839855,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.053464457,
				"type": "ORGANIZATION"
			},
			{
				"name": "food",
				"salience": 0.04057272,
				"type": "OTHER"
			},
			{
				"name": "meat",
				"salience": 0.031807806,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.027496072,
				"type": "OTHER"
			},
			{
				"name": "milk",
				"salience": 0.024426684,
				"type": "OTHER"
			},
			{
				"name": "fruits",
				"salience": 0.023966018,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.021536328,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.021266678,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.019967908,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.018281005,
				"type": "OTHER"
			},
			{
				"name": "seeds",
				"salience": 0.013674725,
				"type": "OTHER"
			},
			{
				"name": "counterparts",
				"salience": 0.009969894,
				"type": "PERSON"
			},
			{
				"name": "hippe commune",
				"salience": 0.009969894,
				"type": "LOCATION"
			},
			{
				"name": "foods",
				"salience": 0.009527122,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n8m6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monsanto"
				},
				"name": "monsanto",
				"salience": 0.00842916,
				"type": "ORGANIZATION"
			},
			{
				"name": "veg",
				"salience": 0.0074527366,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.0074527366,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-4-18-e1476186991869.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-27T07:59:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Well, duh. Wheat is no longer wheat, but a gmo hybrid. Many animals are fed this knock-off food, and now their milk and meat is contaminated. Promoted as the foods to eat, people have been getting poisoned for the past 25 years. Now we see the results. The government should never have been allowed to dictate what we should eat for health, because they have a vested interest in the profits from these unhealthy foods. The only fruits and veg that will be affordable is the mutant crap that monsanto sells seeds for, that can be made to yield ten-fold versus it’s counterparts. Time to move to a hippe commune!",
		"thread_title": "New Report Reveals Modern Diets are Making People Sicker Across the World",
		"title": "",
		"type": "bs",
		"uuid": "5b51f3baa45613c6d9fcad1e7196d648c328e7ab"
	},
	"-KhIhfb6956rHIs3Z17B": {
		"author": "Amando Flavio",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:05:19.341+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Researchers",
				"salience": 0.06952871,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.06818932,
				"type": "PERSON"
			},
			{
				"name": "warming",
				"salience": 0.061581872,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.049765192,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.04790358,
				"type": "OTHER"
			},
			{
				"name": "serendipity",
				"salience": 0.039045706,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.031607706,
				"type": "OTHER"
			},
			{
				"name": "greenhouse gas",
				"salience": 0.029762426,
				"type": "OTHER"
			},
			{
				"name": "greenhouse effect",
				"salience": 0.028710103,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.02713565,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.025613163,
				"type": "LOCATION"
			},
			{
				"name": "researchers",
				"salience": 0.024455313,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.023144249,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.023144249,
				"type": "OTHER"
			},
			{
				"name": "occurrence",
				"salience": 0.021909859,
				"type": "OTHER"
			},
			{
				"name": "greenhouse emissions",
				"salience": 0.020060496,
				"type": "OTHER"
			},
			{
				"name": "invention",
				"salience": 0.020060496,
				"type": "OTHER"
			},
			{
				"name": "climate change activists",
				"salience": 0.020060496,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.019809278,
				"type": "ORGANIZATION"
			},
			{
				"name": "electricity",
				"salience": 0.01589007,
				"type": "OTHER"
			},
			{
				"name": "gases",
				"salience": 0.013886136,
				"type": "OTHER"
			},
			{
				"name": "catalyst",
				"salience": 0.011583372,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.011462297,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.011462297,
				"type": "OTHER"
			},
			{
				"name": "CO2",
				"salience": 0.011462297,
				"type": "OTHER"
			},
			{
				"name": "heat",
				"salience": 0.010993614,
				"type": "OTHER"
			},
			{
				"name": "Carbon dioxide",
				"salience": 0.010671433,
				"type": "OTHER"
			},
			{
				"name": "CO2",
				"salience": 0.00997426,
				"type": "OTHER"
			},
			{
				"name": "heat",
				"salience": 0.009566225,
				"type": "OTHER"
			},
			{
				"name": "greenhouse gases",
				"salience": 0.009566225,
				"type": "OTHER"
			},
			{
				"name": "compound",
				"salience": 0.008827632,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.00858113,
				"type": "OTHER"
			},
			{
				"name": "radiation",
				"salience": 0.008286554,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.0077447817,
				"type": "OTHER"
			},
			{
				"name": "byproduct",
				"salience": 0.0068845563,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.0068845563,
				"type": "OTHER"
			},
			{
				"name": "fuel byproduct",
				"salience": 0.0067124544,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0067124544,
				"type": "OTHER"
			},
			{
				"name": "fuel consumption",
				"salience": 0.0064623174,
				"type": "OTHER"
			},
			{
				"name": "experiments",
				"salience": 0.0062726517,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.005887868,
				"type": "OTHER"
			},
			{
				"name": "diseases",
				"salience": 0.005597074,
				"type": "OTHER"
			},
			{
				"name": "human health",
				"salience": 0.005597074,
				"type": "OTHER"
			},
			{
				"name": "CO2 gas",
				"salience": 0.0054815495,
				"type": "OTHER"
			},
			{
				"name": "ethanol",
				"salience": 0.0054815495,
				"type": "OTHER"
			},
			{
				"name": "discovery",
				"salience": 0.0054815495,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0054815495,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.005210788,
				"type": "OTHER"
			},
			{
				"name": "yields",
				"salience": 0.004747412,
				"type": "OTHER"
			},
			{
				"name": "journal",
				"salience": 0.004747412,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wind",
				"salience": 0.0045362506,
				"type": "OTHER"
			},
			{
				"name": "ethanol",
				"salience": 0.0044196793,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.004096178,
				"type": "OTHER"
			},
			{
				"name": "wind energy",
				"salience": 0.0038160079,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09hv1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oak_Ridge_National_Laboratory"
				},
				"name": "Oak Ridge National Laboratory",
				"salience": 0.0035802794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07h34",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tennessee"
				},
				"name": "Tennessee",
				"salience": 0.0035802794,
				"type": "LOCATION"
			},
			{
				"name": "solar",
				"salience": 0.0035473611,
				"type": "OTHER"
			},
			{
				"name": "batteries",
				"salience": 0.0035473611,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "energy sources",
				"salience": 0.0035473611,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0035473611,
				"type": "OTHER"
			},
			{
				"name": "wind power",
				"salience": 0.0035473611,
				"type": "OTHER"
			},
			{
				"name": "renewables",
				"salience": 0.0035473611,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0033046873,
				"type": "LOCATION"
			},
			{
				"name": "energy",
				"salience": 0.0032364265,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.0032053576,
				"type": "OTHER"
			},
			{
				"name": "factories",
				"salience": 0.0029839722,
				"type": "LOCATION"
			},
			{
				"name": "discovery",
				"salience": 0.0029839722,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0029231773,
				"type": "LOCATION"
			},
			{
				"name": "ChemistrySelect",
				"salience": 0.0029231773,
				"type": "LOCATION"
			},
			{
				"name": "sun",
				"salience": 0.002753114,
				"type": "OTHER"
			},
			{
				"name": "CO2",
				"salience": 0.0026725242,
				"type": "OTHER"
			},
			{
				"name": "turbines",
				"salience": 0.0025840423,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.0025840423,
				"type": "OTHER"
			},
			{
				"name": "factory owners",
				"salience": 0.0025840423,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.0024876206,
				"type": "OTHER"
			},
			{
				"name": "fuel",
				"salience": 0.002469026,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00222935,
				"type": "OTHER"
			},
			{
				"name": "platinum",
				"salience": 0.0019304937,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.0019304937,
				"type": "OTHER"
			},
			{
				"name": "energy industry",
				"salience": 0.0019304937,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.0018821566,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-3-43-e1477415710114.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.3,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "In the scientific world, there is something called serendipity. The word is used to denote the occurrence or invention of something beneficial by chance. For years, governments and climate change activists have struggled to convince the world to cut down on greenhouse emissions. A greenhouse gas is any gaseous compound in the atmosphere that is capable of absorbing infrared radiation, thereby trapping and holding heat in the atmosphere. By increasing the heat in the atmosphere, greenhouse gases are responsible for the greenhouse effect, which ultimately leads to global warming.\nCarbon dioxide (CO2) is one of the gases that are responsible for global warming. CO2 is a byproduct of fuel consumption. Apart from it being harmful to the atmosphere, it also has devastating consequences on human health, mainly through respiratory diseases.\nIn the past, researchers have attempted to convert this fuel byproduct back into energy, for future use. As the experiments proved unsuccessful, researchers were hoping that one day their dream would eventually come true. And indeed, it did. Unexpectedly.\nResearchers from the Oak Ridge National Laboratory, Tennessee, United States, have announced that they have accidentally discovered a catalyst that is capable of transforming CO2 gas into high yields of ethanol . The discovery has been accepted and published in the online journal ChemistrySelect .\nAccording to the researchers, they can do this without the use of rare and expensive elements such as platinum; with the process said to be very cheap and efficient.\nThe good news is, the new energy produced from the CO2 is said to be environmentally friendly. Developing the new fuel could significantly boost the already booming renewable energy industry.\nThe researchers have suggested that their new process could be combined with other renewables, such as solar or wind power, in order to efficiently harness those energy sources. Excess electricity produced by wind and solar is often lost when it is stored in batteries. However, by applying this new discovery, the researchers said the excess electricity could be used to produce ethanol to power solar factories and turbines when there is insufficient sun or wind energy. This method will cut down the costs of production for factory owners, ultimately benefiting the entire world.",
		"thread_title": "Researchers Accidentally Find Simple Way to Convert Harmful CO2 Gas to Green Energy",
		"title": "Researchers Accidentally Find Simple Way to Convert Harmful CO2 Gas to Green Energy",
		"type": "bs",
		"uuid": "4730ad92733eeaa41c32a1db5d6cfdf37657e7ef"
	},
	"-KhIhg6XY3aihjdbQQ_b": {
		"author": "Dwdan",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:05:54.161+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "dipshit",
				"salience": 0.5433253,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.19662373,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.19001333,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.07003763,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-2-33-e1476964480261.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-27T06:09:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.5
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.002",
		"text": "Combined dipshit, all the women and children in developing world….combined.",
		"thread_title": "Cheap Wind-Powered Device Produces 11 Gallons of Clean Drinking Water Per Day from the Air",
		"title": "",
		"type": "bs",
		"uuid": "c99da2b79478ab146ce12b16af2992bfb9ffb2e1"
	},
	"-KhIhgIeH2jepMX4iv9h": {
		"author": "Mae",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T16:06:59.281+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "article",
				"salience": 0.22128278,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ketones",
				"salience": 0.11754195,
				"type": "OTHER"
			},
			{
				"name": "Quote",
				"salience": 0.0899419,
				"type": "OTHER"
			},
			{
				"name": "brain",
				"salience": 0.056248352,
				"type": "OTHER"
			},
			{
				"name": "glucose",
				"salience": 0.056248352,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.054169472,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0291824,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.028455222,
				"type": "OTHER"
			},
			{
				"name": "fat",
				"salience": 0.02626278,
				"type": "OTHER"
			},
			{
				"name": "assumptions",
				"salience": 0.025286725,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.024766315,
				"type": "OTHER"
			},
			{
				"name": "function",
				"salience": 0.021457728,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.021457728,
				"type": "PERSON"
			},
			{
				"name": "diet",
				"salience": 0.020659544,
				"type": "OTHER"
			},
			{
				"name": "GMO grains",
				"salience": 0.018520614,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.018287946,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.017386038,
				"type": "PERSON"
			},
			{
				"name": "fruits",
				"salience": 0.016043834,
				"type": "OTHER"
			},
			{
				"name": "veg",
				"salience": 0.016043834,
				"type": "OTHER"
			},
			{
				"name": "meats",
				"salience": 0.016043834,
				"type": "OTHER"
			},
			{
				"name": "dairy",
				"salience": 0.014948203,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.013499795,
				"type": "PERSON"
			},
			{
				"name": "Grains",
				"salience": 0.013499795,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.01169295,
				"type": "PERSON"
			},
			{
				"name": "health",
				"salience": 0.01169295,
				"type": "OTHER"
			},
			{
				"name": "dairy",
				"salience": 0.011173176,
				"type": "OTHER"
			},
			{
				"name": "relatives",
				"salience": 0.009918447,
				"type": "PERSON"
			},
			{
				"name": "lactose INTOLERANCE",
				"salience": 0.009548713,
				"type": "OTHER"
			},
			{
				"name": "dairy cows",
				"salience": 0.0087386295,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/paleo-diet-1.jpg",
		"ord_in_thread": "3",
		"participants_count": "4",
		"published": "2016-10-27T08:19:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 4.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.006",
		"text": "This article is so confusing. In the first Quote: we see “it is very difficult to know exactly…” and “very likely to be…” and “it might be that…” and ” but we cannot be completely sure…”. Wow. So many assumptions, and no facts listed. And it has been proven in many studies that the brain functions better on ketones (from dietary fat) than it does on glucose, which the body does NOT need. In fact, ketones make the body as a whole function better and more efficiently. And now that so many people have lactose INTOLERANCE, let us not argue about our distant relatives adapting to eating dairy. Especially now that the dairy cows are fed GMO grains.\nA diet based on clean, local, fresh fruits and veg as well as pastured meats is all anyone needs for good health. Grains and dairy are unnecessary for anyone, but may be enjoyed by everyone if it works for them.",
		"thread_title": "Everything You Knew About the Paleo Diet is Wrong. Here’s the Proof",
		"title": "",
		"type": "bs",
		"uuid": "36cc72a1aaad661495b2533cba45a3f10acf0a28"
	},
	"-KhIhgO68S5wpKRHYiGX": {
		"author": "Phlox",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:06:04.688+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "moslems",
				"salience": 0.7101865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06z0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunlight"
				},
				"name": "Sun",
				"salience": 0.28981355,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Mars-1.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-27T23:53:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.299",
		"text": "Can we then send moslems to the Sun?",
		"thread_title": "Barack Obama ‘Reveals’: How NASA Will Send Humans To Mars By The 2030s",
		"title": "",
		"type": "bs",
		"uuid": "ee3079adad639c1eeabd0b26bf5e8145e969e35e"
	},
	"-KhIhgZzYa4DmI3hyNIZ": {
		"author": "Texasoutlaw",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:07:30.391+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "guys",
				"salience": 0.22639468,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.21992372,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.14610109,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.09257634,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.06848855,
				"type": "OTHER"
			},
			{
				"name": "tape",
				"salience": 0.051601455,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.044069897,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.04112173,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.031943873,
				"type": "ORGANIZATION"
			},
			{
				"name": "guys",
				"salience": 0.023391824,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.02026214,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.012056999,
				"type": "LOCATION"
			},
			{
				"name": "WTF",
				"salience": 0.011033856,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.011033856,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/anon_bill_431101.jpg",
		"ord_in_thread": "21",
		"participants_count": "20",
		"published": "2016-10-27T17:05:00.000+03:00",
		"replies_count": "21",
		"sentiment": {
			"magnitude": 6.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "I actually think you guys have done good work. Here is the problem! You say you have the tape? Where is it? Release it already! You know we can never trust government! I hope that we can trust you! Your credibility is on the line here! I hope you are just not another source that can’t be trusted. Because we do really want to trust you! If you have it release it! What are you waiting on? Are you scared? WTF?\nYou said you had it and nothing! If it does not come out soon I for one will not believe you guys anymore! I doubt anyone will! Man up! Release it or tell the world you don’t have it!",
		"thread_title": "Anonymous: Bill Clinton Pedophile Sex Tape Filmed By Jeffrey Epstein!",
		"title": "",
		"type": "bs",
		"uuid": "e6cbc509f44b8da6c2a356ae1ef9f95903ed0472"
	},
	"-KhIhgpj77bRXfAwqOyn": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:08:19.956+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Whitney Webb",
				"salience": 0.18366541,
				"type": "PERSON"
			},
			{
				"name": "Cyndy Coppola",
				"salience": 0.15258098,
				"type": "PERSON"
			},
			{
				"name": "property",
				"salience": 0.103495605,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.103495605,
				"type": "LOCATION"
			},
			{
				"name": "DAPL",
				"salience": 0.08519144,
				"type": "ORGANIZATION"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.03849421,
				"type": "OTHER"
			},
			{
				"name": "construction equipment",
				"salience": 0.028117359,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.027742801,
				"type": "OTHER"
			},
			{
				"name": "trueactivist.com",
				"salience": 0.017400641,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.015757142,
				"type": "OTHER"
			},
			{
				"name": "farmers",
				"salience": 0.0155709,
				"type": "PERSON"
			},
			{
				"name": "repression",
				"salience": 0.014457189,
				"type": "OTHER"
			},
			{
				"name": "seizure",
				"salience": 0.012890748,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.00920441,
				"type": "LOCATION"
			},
			{
				"name": "pipeline",
				"salience": 0.008813955,
				"type": "OTHER"
			},
			{
				"name": "Eminent domain",
				"salience": 0.008368628,
				"type": "OTHER"
			},
			{
				"name": "seizure",
				"salience": 0.0061596227,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.00597486,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.00597486,
				"type": "OTHER"
			},
			{
				"name": "protests",
				"salience": 0.00597486,
				"type": "EVENT"
			},
			{
				"name": "pipeline",
				"salience": 0.005956838,
				"type": "OTHER"
			},
			{
				"name": "eminent domain",
				"salience": 0.005584351,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access",
				"salience": 0.0054334085,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0053595426,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0053595426,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.0053595426,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0053595426,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.005159927,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0050535104,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cmtrq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Energy_Transfer_Partners"
				},
				"name": "Energy Transfer Partners",
				"salience": 0.0048089335,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.0048055816,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.00445278,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.004423992,
				"type": "LOCATION"
			},
			{
				"name": "parties",
				"salience": 0.0043771705,
				"type": "ORGANIZATION"
			},
			{
				"name": "passage",
				"salience": 0.004192347,
				"type": "EVENT"
			},
			{
				"name": "company",
				"salience": 0.0040361118,
				"type": "ORGANIZATION"
			},
			{
				"name": "thanks",
				"salience": 0.0040361118,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0039528245,
				"type": "PERSON"
			},
			{
				"name": "corporations",
				"salience": 0.0039528245,
				"type": "ORGANIZATION"
			},
			{
				"name": "access",
				"salience": 0.0037770849,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0037770849,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.0036014162,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.0034235315,
				"type": "OTHER"
			},
			{
				"name": "easements",
				"salience": 0.003380448,
				"type": "OTHER"
			},
			{
				"name": "seizure",
				"salience": 0.0031493169,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.002751968,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ds835g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Condemnation_Act"
				},
				"name": "Condemnation Act",
				"salience": 0.0025819943,
				"type": "WORK_OF_ART"
			},
			{
				"name": "eminent domain",
				"salience": 0.002579614,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0025697262,
				"type": "PERSON"
			},
			{
				"name": "trucks",
				"salience": 0.0025582581,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "pipeline construction materials",
				"salience": 0.0025582581,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0024856937,
				"type": "LOCATION"
			},
			{
				"name": "farm",
				"salience": 0.0023832724,
				"type": "LOCATION"
			},
			{
				"name": "use",
				"salience": 0.0023832724,
				"type": "OTHER"
			},
			{
				"name": "farm",
				"salience": 0.0023832724,
				"type": "LOCATION"
			},
			{
				"name": "example",
				"salience": 0.0023411256,
				"type": "OTHER"
			},
			{
				"name": "domain",
				"salience": 0.0019274199,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0017806723,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.0017360988,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0016914584,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0016078328,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0nsh2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calhoun_County,_Iowa"
				},
				"name": "Calhoun County",
				"salience": 0.00157507,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/cyndycoppola-768x444.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.022",
		"text": "By Whitney Webb at trueactivist.com\nCyndy Coppola was arrested for standing on her own property as she tried to block Dakota Access Pipeline construction equipment from crossing her land.\nOnce again, the repression of those against the Dakota Access Pipeline (DAPL) is heating up, with 127 activists arrested in North Dakota over the weekend. However, North Dakota isn’t the only place where protests over the Dakota Access pipeline are coming to a head. In Iowa, farmers have had their land seized by the company behind the pipeline, Energy Transfer Partners, through the use of eminent domain. Eminent domain has been legal in the US since 1888, thanks to the passage of the Condemnation Act . The law authorizes the federal government to take private property for public use. However, in 1906, the law was amended to allow for the seizure of private property even if it only benefited private parties (e.g., corporations), not the public. The argument for this was that corporate seizure of private land “helps” the public through economic development. Yet, what the law essentially means is that even your own land doesn’t belong to you if the government or government-supported corporations want it.\nA sad, yet accurate example of eminent domain gone wrong took place last week in Calhoun County, Iowa. Cyndy Coppola was arrested over the weekend on her own property for trying to block access to DAPL trucks from hauling pipeline construction materials through her land. DAPL first received access to Coppola’s farm through the use of eminent domain, which granted Energy Transfer Partners easements to her property. Coppola remarked that watching the morally wrong seizure of the farm she worked so hard for was difficult to handle.",
		"thread_title": "Woman Arrested On Own Property After Her Land Was Stolen By DAPL",
		"title": "Woman Arrested On Own Property After Her Land Was Stolen By DAPL",
		"type": "bs",
		"uuid": "810a2fca0f23a26314c4d7ed9937baf5b56d015a"
	},
	"-KhIhgwg9WqaEoEBLdyl": {
		"author": "Jaclyn Smith",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:08:32.472+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "creatures",
				"salience": 0.3895505,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.23571113,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.07242181,
				"type": "OTHER"
			},
			{
				"name": "height",
				"salience": 0.06311789,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.06311789,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0500516,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.044812996,
				"type": "PERSON"
			},
			{
				"name": "rights",
				"salience": 0.044812996,
				"type": "OTHER"
			},
			{
				"name": "Fear",
				"salience": 0.02811616,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.008287015,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/110405-F-JA180-002.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-27T19:52:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "the national laws passed during the height of fear of terrorism, opened the door for many of our rights being taken from us. Fear is their greatest tool, when we are afraid we are irrational creatures.",
		"thread_title": "Wisconsin Supreme Court Guts Fourth Amendment in Unprecedented Decision",
		"title": "",
		"type": "bs",
		"uuid": "89c43d8c71b97e6e530b9a7e33883efe10b5b320"
	},
	"-KhIhh2855ikT9qG2xH8": {
		"author": "David Costa",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:09:01.002+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "nature",
				"salience": 0.14577016,
				"type": "OTHER"
			},
			{
				"name": "tribes",
				"salience": 0.1272329,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.1272329,
				"type": "OTHER"
			},
			{
				"name": "living",
				"salience": 0.1272329,
				"type": "OTHER"
			},
			{
				"name": "relatives",
				"salience": 0.060372394,
				"type": "PERSON"
			},
			{
				"name": "tree",
				"salience": 0.0540017,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0540017,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.043625526,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.025681034,
				"type": "OTHER"
			},
			{
				"name": "ancestors",
				"salience": 0.02113938,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.020705953,
				"type": "PERSON"
			},
			{
				"name": "capitalism",
				"salience": 0.019602355,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.019602355,
				"type": "LOCATION"
			},
			{
				"name": "cats",
				"salience": 0.018875942,
				"type": "OTHER"
			},
			{
				"name": "dogs",
				"salience": 0.018875942,
				"type": "OTHER"
			},
			{
				"name": "monkeys",
				"salience": 0.018875942,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.018488571,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.018488571,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.016024714,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.011255527,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.010090901,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.008742121,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007544961,
				"type": "PERSON"
			},
			{
				"name": "plants",
				"salience": 0.006535567,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/enjoy_capitalism.png",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-27T21:56:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.009",
		"text": "nature, tribes, ancient civilizalions way of living… how our close relatives in the tree of life live? how did our ancestors lived? and the monkeys and dogs and cats? for free, from the earth… capitalism is directly applied to futile things and objects and things people don’t live for and want… people are like animals and plants that drink and eat, and that’s the system everyone needs. go back to nature, purity original form.",
		"thread_title": "Capitalism Is Doomed — Without Alternatives, So Are We",
		"title": "",
		"type": "bs",
		"uuid": "7cd455b7fd633481097c15350617ff3d41c580a5"
	},
	"-KhIhh5rpiD3ySrwBRu_": {
		"author": "Robert",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:10:23.909+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "story",
				"salience": 0.30822197,
				"type": "OTHER"
			},
			{
				"name": "estate",
				"salience": 0.22122431,
				"type": "LOCATION"
			},
			{
				"name": "ive",
				"salience": 0.19855228,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.13789248,
				"type": "OTHER"
			},
			{
				"name": "Rothschild",
				"salience": 0.13410899,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/barackobama.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-27T09:16:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "If you ever want the true story to the Rothschild estate just let me know ive got all the proof you need ….",
		"thread_title": "Wikileaks Releases First Batch Of Barack Obama Emails & They Hint At A Rigged Election",
		"title": "",
		"type": "bs",
		"uuid": "9ea42a73dd22f63b50aaf72d2801ec152e50acd9"
	},
	"-KhIhhH6WcsBcWvhRVMy": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:10:35.172+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.21507068,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.08603668,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.08351776,
				"type": "PERSON"
			},
			{
				"name": "Dillary Trumplon",
				"salience": 0.047974635,
				"type": "WORK_OF_ART"
			},
			{
				"name": "books",
				"salience": 0.04545967,
				"type": "WORK_OF_ART"
			},
			{
				"name": "record",
				"salience": 0.04545967,
				"type": "OTHER"
			},
			{
				"name": "Nick Bernabe",
				"salience": 0.032454766,
				"type": "PERSON"
			},
			{
				"name": "theantimedia.org",
				"salience": 0.028143302,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.026974311,
				"type": "PERSON"
			},
			{
				"name": "frontrunners",
				"salience": 0.023384985,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.023384985,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.023384985,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.023172103,
				"type": "PERSON"
			},
			{
				"name": "war-starter",
				"salience": 0.020745402,
				"type": "PERSON"
			},
			{
				"name": "song",
				"salience": 0.017087227,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Blaise",
				"salience": 0.016293954,
				"type": "PERSON"
			},
			{
				"name": "art",
				"salience": 0.014573791,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.014434889,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.014302664,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.011159279,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.011159279,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.009667321,
				"type": "LOCATION"
			},
			{
				"name": "example",
				"salience": 0.008737086,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.008671919,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.007540023,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007540023,
				"type": "PERSON"
			},
			{
				"name": "nightmare",
				"salience": 0.006783627,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.006783627,
				"type": "PERSON"
			},
			{
				"name": "giant",
				"salience": 0.0065308576,
				"type": "ORGANIZATION"
			},
			{
				"name": "top",
				"salience": 0.0065308576,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.0065308576,
				"type": "LOCATION"
			},
			{
				"name": "victims",
				"salience": 0.0065308576,
				"type": "PERSON"
			},
			{
				"name": "wake",
				"salience": 0.0065308576,
				"type": "OTHER"
			},
			{
				"name": "portion",
				"salience": 0.0065308576,
				"type": "OTHER"
			},
			{
				"name": "meteor",
				"salience": 0.0065308576,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.006396108,
				"type": "OTHER"
			},
			{
				"name": "demagoguery",
				"salience": 0.006396108,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0060864226,
				"type": "ORGANIZATION"
			},
			{
				"name": "war mongering",
				"salience": 0.005539753,
				"type": "OTHER"
			},
			{
				"name": "Blaise Guerra",
				"salience": 0.0051857773,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.004780033,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.004780033,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0041397414,
				"type": "OTHER"
			},
			{
				"name": "shot",
				"salience": 0.0041397414,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0034824002,
				"type": "OTHER"
			},
			{
				"name": "meaning",
				"salience": 0.0030157475,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.0030157475,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.0030157475,
				"type": "EVENT"
			},
			{
				"name": "primaries",
				"salience": 0.0030157475,
				"type": "EVENT"
			},
			{
				"name": "Election Justice USA",
				"salience": 0.0025488439,
				"type": "ORGANIZATION"
			},
			{
				"name": "clarity",
				"salience": 0.0022531103,
				"type": "OTHER"
			},
			{
				"name": "responses",
				"salience": 0.0022531103,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0022531103,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.0020880844,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/dillary-trumplon.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "By Nick Bernabe at theantimedia.org\nThe 2016 election has been one for the record books. Somehow, two of the most reviled people in the United States have become the frontrunners for the most powerful job in the country — and the world.\nOn one hand, there is Donald Trump , the compulsively lying demagogic womanizing egomaniacal billionaire. On the other hand, there is Hillary Clinton, the infinitely corrupt influence peddling war-starter who allegedly cheated her way to the top of the Democratic Party while leaving a number of victims in her wake.\nA significant portion of young people would actually prefer that a giant, apocalyptic meteor hit the earth rather than see Hillary Clinton or Donald Trump elected president.\nIt’s not all bad, though — at least when it comes to the creative art that has been inspired by this nightmare of an election. One such example is “Dillary Trumplon,” a recently released rap song written and performed by Blaise Guerra that’s starting to go viral on social media. From Trump’s demagoguery to Hillary’s war mongering, Guerra leaves no stone unturned.\nListen to the song for yourself, then check out our interview with Blaise below (his responses have been slightly edited and condensed for clarity).\nAM: What inspired you to make this song? Blaise: I was inspired to make the song because I felt very disenfranchised by the way Bernie Sanders sparked such an incredible movement but was completely ignored by the media and given no shot. Yet according to Election Justice USA , without the primaries being fixed, Sanders could have won by a landslide. I felt so cheated when he lost. I knew the Democratic establishment had completely undermined the meaning of democracy and stolen the nomination from him.",
		"thread_title": "‘Dillary Trumplon’: This Guy’s Epic Rap Song Just Destroyed Trump AND Hillary",
		"title": "‘Dillary Trumplon’: This Guy’s Epic Rap Song Just Destroyed Trump AND Hillary",
		"type": "bs",
		"uuid": "1952f74ad6fd40a47501b5e055b3c596ee0147be"
	},
	"-KhIhhL0GJcSzyKT4K_m": {
		"author": "Kathy",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:10:46.352+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Dumptrump",
				"salience": 0.883427,
				"type": "OTHER"
			},
			{
				"name": "hillary m",
				"salience": 0.116572954,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "12",
		"participants_count": "18",
		"published": "2016-10-27T22:54:00.000+03:00",
		"replies_count": "18",
		"sentiment": {
			"magnitude": 0.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Dumptrump and hillary m",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "a2377e964e3b3f550f3156ccd5d4703cf0204e3f"
	},
	"-KhIhhP3v_fnC7znH1qj": {
		"author": "WakeUpAmericaPlease",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:10:46.367+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Jesus",
				"salience": 0.40309647,
				"type": "PERSON"
			},
			{
				"name": "soul",
				"salience": 0.19382216,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.16571248,
				"type": "OTHER"
			},
			{
				"name": "shit",
				"salience": 0.12523682,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.06921893,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01skgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ignorance"
				},
				"name": "Ignorant",
				"salience": 0.04291312,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "13",
		"participants_count": "18",
		"published": "2016-10-27T10:10:00.000+03:00",
		"replies_count": "18",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.9
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "“Jesus” will save his soul not his body, Ignorant piece of shit.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "64d5aafc7bf1c87cb03b0fe83c4308a79671a7c9"
	},
	"-KhIhhTWpBfI6a08VxkR": {
		"author": "Karml",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:10:46.448+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "world",
				"salience": 1,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "15",
		"participants_count": "18",
		"published": "2016-10-27T14:45:00.000+03:00",
		"replies_count": "18",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "How tragic for the world if true",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "75722c00a31ec28152ba74e4b550f2e26d8ea94a"
	},
	"-KhIhhZir4PR8wkYWvl-": {
		"author": "Pleezdeez",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:10:46.453+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "statement",
				"salience": 0.17545985,
				"type": "OTHER"
			},
			{
				"name": "nationals",
				"salience": 0.12147813,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.11706432,
				"type": "PERSON"
			},
			{
				"name": "embassy",
				"salience": 0.11706432,
				"type": "LOCATION"
			},
			{
				"name": "brits",
				"salience": 0.07724463,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02k1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ecuador"
				},
				"name": "ecuadorian",
				"salience": 0.07557006,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "british",
				"salience": 0.07279538,
				"type": "LOCATION"
			},
			{
				"name": "action",
				"salience": 0.06610011,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.061323944,
				"type": "WORK_OF_ART"
			},
			{
				"name": "geneva convention",
				"salience": 0.038554925,
				"type": "EVENT"
			},
			{
				"name": "hit",
				"salience": 0.028144123,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.028144123,
				"type": "OTHER"
			},
			{
				"name": "violation",
				"salience": 0.021056075,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "16",
		"participants_count": "18",
		"published": "2016-10-27T10:50:00.000+03:00",
		"replies_count": "18",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "He has been confirmed as alive and free as of 10/21 when he made a public statement claiming british troops had stormed the embassy but were held off by ecuadorian nationals. The video also points out that any such action by the brits is in direct violation of the geneva convention so they need to tred lightly to avoid taking a massive hit in foreign policy",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "71e58c65bff6d4af68440663c92fde324175c9bd"
	},
	"-KhIhhh5U4R2bbXs03tr": {
		"author": "bluuder",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:10:46.456+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "https://www.youtube.com/watch?v=6iO8YZLwqlY",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "17",
		"participants_count": "18",
		"published": "2016-10-28T01:04:00.000+03:00",
		"replies_count": "18",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "He is alive: https://www.youtube.com/watch?v=6iO8YZLwqlY",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "098f5a30ec280282544ed77a837cb2d1d873d9f0"
	},
	"-KhIhhmB5NE2X7-glohb": {
		"author": "Richard",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:10:46.469+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "person",
				"salience": 0.47935942,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.21812959,
				"type": "PERSON"
			},
			{
				"name": "irony",
				"salience": 0.100769535,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.058997422,
				"type": "EVENT"
			},
			{
				"name": "dissent",
				"salience": 0.037492324,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.036742453,
				"type": "LOCATION"
			},
			{
				"name": "lackey",
				"salience": 0.035960335,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.032548927,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "18",
		"participants_count": "18",
		"published": "2016-10-28T01:10:46.469+03:00",
		"replies_count": "18",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Am I the only person who sees the irony of John Kerry being a dissident speaking out against the war in Vietnam, now he’s a lackey for a far greater evil government silencing dissent ?",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "f2ce0250b339d110f58f371269f5ecd067ad7f97"
	},
	"-KhIhi0TAvxJHpF0umFz": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:11:01.168+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.27511787,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar Peninsula",
				"salience": 0.07520014,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.04917414,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.038448367,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027glbp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Jazeera"
				},
				"name": "Al Jazeera's",
				"salience": 0.035828903,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.030178513,
				"type": "WORK_OF_ART"
			},
			{
				"name": "intelligence",
				"salience": 0.030178513,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.030178513,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.027909542,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.02548581,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.023269609,
				"type": "LOCATION"
			},
			{
				"name": "sources",
				"salience": 0.021882186,
				"type": "OTHER"
			},
			{
				"name": "first lady",
				"salience": 0.021882186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.018617187,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.017896717,
				"type": "OTHER"
			},
			{
				"name": "Amitabh Desai",
				"salience": 0.014981415,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.014333426,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.013520229,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.013520229,
				"type": "ORGANIZATION"
			},
			{
				"name": "Alice Salles",
				"salience": 0.013520229,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.013520229,
				"type": "LOCATION"
			},
			{
				"name": "theantimedia.org",
				"salience": 0.013520229,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.011574626,
				"type": "LOCATION"
			},
			{
				"name": "reasons",
				"salience": 0.0099578565,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.009059392,
				"type": "ORGANIZATION"
			},
			{
				"name": "effort",
				"salience": 0.008887951,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.008537876,
				"type": "ORGANIZATION"
			},
			{
				"name": "check",
				"salience": 0.006990566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jt9h01",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam_in_Lebanon"
				},
				"name": "Sunni",
				"salience": 0.0055841827,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0053506647,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0053506647,
				"type": "LOCATION"
			},
			{
				"name": "need",
				"salience": 0.0046345145,
				"type": "OTHER"
			},
			{
				"name": "intelligence assets",
				"salience": 0.0046345145,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.004331356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "region",
				"salience": 0.0040019085,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.0033622477,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0033344198,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.003251008,
				"type": "LOCATION"
			},
			{
				"name": "birthday",
				"salience": 0.003251008,
				"type": "EVENT"
			},
			{
				"name": "piece",
				"salience": 0.0031297803,
				"type": "OTHER"
			},
			{
				"name": "willingness",
				"salience": 0.0031297803,
				"type": "OTHER"
			},
			{
				"name": "correspondence",
				"salience": 0.0031297803,
				"type": "OTHER"
			},
			{
				"name": "Ambassador",
				"salience": 0.0030130667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.002854362,
				"type": "LOCATION"
			},
			{
				"name": "broadcaster",
				"salience": 0.0026883637,
				"type": "ORGANIZATION"
			},
			{
				"name": "suggestions",
				"salience": 0.0026545154,
				"type": "OTHER"
			},
			{
				"name": "investments",
				"salience": 0.0026545154,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0026545154,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0026545154,
				"type": "OTHER"
			},
			{
				"name": "projects",
				"salience": 0.0026545154,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0025364088,
				"type": "ORGANIZATION"
			},
			{
				"name": "developments",
				"salience": 0.0023684078,
				"type": "OTHER"
			},
			{
				"name": "omission",
				"salience": 0.002290279,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.002157928,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.002113106,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "NYC",
				"salience": 0.0020017582,
				"type": "LOCATION"
			},
			{
				"name": "post",
				"salience": 0.001983349,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meeting",
				"salience": 0.001983349,
				"type": "EVENT"
			},
			{
				"name": "endowment",
				"salience": 0.001983349,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.001958369,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01hy1q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_policy"
				},
				"name": "Foreign Policy",
				"salience": 0.0019270709,
				"type": "ORGANIZATION"
			},
			{
				"name": "list",
				"salience": 0.0018476391,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0018087279,
				"type": "LOCATION"
			},
			{
				"name": "most",
				"salience": 0.0017252213,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.0017252213,
				"type": "OTHER"
			},
			{
				"name": "omission",
				"salience": 0.0016682928,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haiti",
				"salience": 0.0016342967,
				"type": "LOCATION"
			},
			{
				"name": "emails",
				"salience": 0.0014941363,
				"type": "WORK_OF_ART"
			},
			{
				"name": "revelation",
				"salience": 0.0014446599,
				"type": "OTHER"
			},
			{
				"name": "lapse",
				"salience": 0.0014446599,
				"type": "EVENT"
			},
			{
				"name": "users",
				"salience": 0.0014446599,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.0013803473,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0013803473,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.0012888714,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0012209304,
				"type": "OTHER"
			},
			{
				"name": "king",
				"salience": 0.0010792338,
				"type": "PERSON"
			},
			{
				"name": "scheme",
				"salience": 0.0010792338,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00088922994,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Morocco",
				"salience": 0.00066425477,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/14813683_1467449626616981_1381731532_n.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "By Alice Salles at theantimedia.org\nIn an email between Democratic presidential candidate Hillary Clinton and her campaign chairman, John Podesta, the former first lady and secretary of state cites “ Western intelligence, US intelligence and sources in the region ” to accuse Qatar and Saudi Arabia of “ providing clandestine financial and logistic support to ISIL [or ISIS] and other radical Sunni groups in the region .”\nCiting the need to “ use our diplomatic and more traditional intelligence assets ,” the candidate told Podesta the current developments in the Middle East were “ important to the U.S. for reasons that often differ from country to country .” In the same email, Clinton seemed to claim Turkey needed to be reassured of America’s willingness to “ take serious actions, ” an effort that “ [could] be sustained to protect our national interests ” in the region.\nIn another piece of correspondence from 2012, the Director of Foreign Policy at the Clinton Foundation, Amitabh Desai , claimed the Ambassador from Qatar would “ like to see [Bill Clinton] ‘for five minutes’ in NYC, to present $1 million check that Qatar promised for [his] birthday in 2011 ,” adding that the small but rich nation occupying the Qatar Peninsula would “ welcome [the Clinton Foundation’s] suggestions for investments in Haiti — particularly on education and health .” Desai added that while Qatar had already “ allocated most of their $20 million … [they were] happy to consider projects we suggest .”\nAl Jazeera , a Qatar-based, state-funded news organization, recently ran a list of “ revealing, juicy and quirky emails ” leaked by WikiLeaks. In its list, the news organization went over the “pay-for-play” scheme involving the Clinton Foundation, going so far as to mention an email confirming the king of Morocco offered $12m “for the endowment” — as long as Clinton was willing to take part in a meeting.\nNevertheless, the state-funded broadcaster failed to bring up the Qatar connection. Unfortunately for the organization, Wikileaks promptly noticed the omission.\nIn a post on Facebook , the WikiLeaks official page said, “ Al Jazeera’s list of juiciest Wikileaks forgets to mention the revelation that Qatar funds both ISIS & Bill Clinton. ”\nOn Twitter, the convenient lapse wasn’t forgiven. Promptly after WikiLeaks pointed out the omission, users began pressuring Al Jazeera to explain why the publication failed to link Qatar to ISIS and Clinton.",
		"thread_title": "Hillary Admits In Leaked Email That Clinton Donors Are Funding ISIS",
		"title": "Hillary Admits In Leaked Email That Clinton Donors Are Funding ISIS",
		"type": "bs",
		"uuid": "c29887688c1207bd2eafeabd32b41f669ea03681"
	},
	"-KhIhiDTF524QWsn2MNp": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:11:03.164+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.38706368,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.1574846,
				"type": "PERSON"
			},
			{
				"name": "Claire Bernish",
				"salience": 0.076165564,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.049878348,
				"type": "PERSON"
			},
			{
				"name": "smoking gun email",
				"salience": 0.039636876,
				"type": "OTHER"
			},
			{
				"name": "correspondence",
				"salience": 0.027374426,
				"type": "OTHER"
			},
			{
				"name": "email account",
				"salience": 0.023750931,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.019051952,
				"type": "PERSON"
			},
			{
				"name": "theantimedia.org Thanks",
				"salience": 0.014690213,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.014690213,
				"type": "ORGANIZATION"
			},
			{
				"name": "transparency",
				"salience": 0.011291833,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.010558997,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.007437704,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.007437704,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.007399451,
				"type": "OTHER"
			},
			{
				"name": "Katherine Miller",
				"salience": 0.0072948905,
				"type": "PERSON"
			},
			{
				"name": "panic",
				"salience": 0.007139186,
				"type": "PERSON"
			},
			{
				"name": "lack",
				"salience": 0.006410416,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0055133053,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lie",
				"salience": 0.0053028255,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.005041171,
				"type": "WORK_OF_ART"
			},
			{
				"name": "credibility",
				"salience": 0.005041171,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0046424326,
				"type": "EVENT"
			},
			{
				"name": "email",
				"salience": 0.004618397,
				"type": "WORK_OF_ART"
			},
			{
				"name": "policy",
				"salience": 0.0045558596,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0042268545,
				"type": "WORK_OF_ART"
			},
			{
				"name": "news reports",
				"salience": 0.0040835827,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.003970627,
				"type": "ORGANIZATION"
			},
			{
				"name": "transparency",
				"salience": 0.0039314134,
				"type": "OTHER"
			},
			{
				"name": "government system",
				"salience": 0.0039314134,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.003913883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0385gg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Plante"
				},
				"name": "Bill Plante",
				"salience": 0.003778852,
				"type": "PERSON"
			},
			{
				"name": "stretch",
				"salience": 0.0035819488,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0035368812,
				"type": "ORGANIZATION"
			},
			{
				"name": "use",
				"salience": 0.0034050453,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0034050453,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0034050453,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.003377263,
				"type": "PERSON"
			},
			{
				"name": "attention",
				"salience": 0.0032928023,
				"type": "OTHER"
			},
			{
				"name": "Josh Schwerin",
				"salience": 0.0029312652,
				"type": "PERSON"
			},
			{
				"name": "records",
				"salience": 0.0028881526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS News",
				"salience": 0.0027852918,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jgf9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BlackBerry"
				},
				"name": "BlackBerry",
				"salience": 0.0021781211,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0021781211,
				"type": "ORGANIZATION"
			},
			{
				"name": "Zero Hedge",
				"salience": 0.0021781211,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.002158095,
				"type": "WORK_OF_ART"
			},
			{
				"name": "picture",
				"salience": 0.002158095,
				"type": "OTHER"
			},
			{
				"name": "snippet",
				"salience": 0.002158095,
				"type": "OTHER"
			},
			{
				"name": "email system",
				"salience": 0.0018153519,
				"type": "OTHER"
			},
			{
				"name": "news reports",
				"salience": 0.0018153519,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.0018153519,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.0017179082,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.0015592104,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0013562681,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.0011744545,
				"type": "PERSON"
			},
			{
				"name": "scenes",
				"salience": 0.0011744545,
				"type": "WORK_OF_ART"
			},
			{
				"name": "appearance",
				"salience": 0.0011744545,
				"type": "OTHER"
			},
			{
				"name": "pic.twitter.com/ufkeoZCx2m",
				"salience": 0.0010575288,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0009677095,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0120w9bh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jennifer_Palmieri"
				},
				"name": "Jennifer Palmieri",
				"salience": 0.0007228994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07g7bl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Director_of_communications"
				},
				"name": "Director of Communications",
				"salience": 0.0007228994,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Screen-Shot-2016-10-25-at-1.49.01-PM-660x330.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "By Claire Bernish at theantimedia.org\nThanks to Wikileaks, we now have the smoking gun email irrefutably proving not only did President Barack Obama know about Hillary Clinton’s non-government-issued email account, he used it in correspondence with her.\nEven more damning to the president’s credibility, it appears the lie was a purposeful attempt to protect Clinton’s upcoming bid for the presidency.\nShortly after the New York Times broke the story on March 2, 2015, of Clinton’s use of a personal server to supplant the government system — and, as has been revealed, to thwart transparency — Obama announced publicly his lack of prior knowledge.\n“The same time everybody else learned it through news reports,” the president told CBS News White House correspondent Bill Plante, as Zero Hedge reported . “The policy of my administration is to encourage transparency, which is why my emails, the BlackBerry I carry around, all those records are available and archived.\n“I’m glad that Hillary’s instructed that those emails about official business need to be disclosed.”\nIt wouldn’t be a stretch to imagine, however, Obama’s placid public appearance guarded secret internal panic — a panic echoed behind the scenes at the burgeoning Clinton campaign.\nAn email penned by Clinton campaign spokesman Josh Schwerin to Director of Communications, Jennifer Palmieri, and a few others, calling immediate attention to a tweet by journalist Katherine Miller paints an entirely different picture.\nMiller tweeted a snippet of the aforementioned interview in which Plante asked Obama, “Mr. President, When did you first learn that Hillary Clinton used an email system outside the U.S. Government for official business while she was Secretary of State?”\n“The same time everybody else learned it,” he responded, “through news reports.”\nI have some questions here pic.twitter.com/ufkeoZCx2m",
		"thread_title": "BREAKING: Irrefutable Proof Obama Lied to Protect Hillary Clinton’s Run for the White House Read",
		"title": "BREAKING: Irrefutable Proof Obama Lied to Protect Hillary Clinton’s Run for the White House Read",
		"type": "bs",
		"uuid": "4513dd3c19e5e13c68aa94a10f38257d085d3e97"
	},
	"-KhIhil5mj3WmMlFq2Aj": {
		"author": "John Bentley",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:11:36.176+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "extent",
				"salience": 0.15439393,
				"type": "OTHER"
			},
			{
				"name": "mishandling",
				"salience": 0.13430683,
				"type": "OTHER"
			},
			{
				"name": "government documents",
				"salience": 0.13430683,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.07764902,
				"type": "PERSON"
			},
			{
				"name": "extent",
				"salience": 0.03333963,
				"type": "OTHER"
			},
			{
				"name": "pay",
				"salience": 0.028896356,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.026755864,
				"type": "ORGANIZATION"
			},
			{
				"name": "computers",
				"salience": 0.02661851,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "destination",
				"salience": 0.025929483,
				"type": "LOCATION"
			},
			{
				"name": "destruction",
				"salience": 0.024966555,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.024966555,
				"type": "ORGANIZATION"
			},
			{
				"name": "truth",
				"salience": 0.022553425,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.021289794,
				"type": "LOCATION"
			},
			{
				"name": "voice",
				"salience": 0.020943644,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.020295957,
				"type": "OTHER"
			},
			{
				"name": "munitions",
				"salience": 0.020295957,
				"type": "OTHER"
			},
			{
				"name": "stinger missals",
				"salience": 0.020295957,
				"type": "WORK_OF_ART"
			},
			{
				"name": "list",
				"salience": 0.017662767,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.016581172,
				"type": "EVENT"
			},
			{
				"name": "rigging",
				"salience": 0.016581172,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.016581172,
				"type": "PERSON"
			},
			{
				"name": "disruption",
				"salience": 0.016581172,
				"type": "EVENT"
			},
			{
				"name": "schemes",
				"salience": 0.013544234,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.012396459,
				"type": "OTHER"
			},
			{
				"name": "foundations",
				"salience": 0.012396459,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.011119427,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.010430302,
				"type": "OTHER"
			},
			{
				"name": "script",
				"salience": 0.009033993,
				"type": "WORK_OF_ART"
			},
			{
				"name": "propaganda",
				"salience": 0.009033993,
				"type": "OTHER"
			},
			{
				"name": "election ballot boxes",
				"salience": 0.006751123,
				"type": "OTHER"
			},
			{
				"name": "cell phones",
				"salience": 0.006751123,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "wiping",
				"salience": 0.006751123,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/wikileaks-assange-thumb.jpg",
		"ord_in_thread": "4",
		"participants_count": "4",
		"published": "2016-10-27T23:12:00.000+03:00",
		"replies_count": "4",
		"sentiment": {
			"magnitude": 3.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Is it better that we don’t know the true extent of Clinton’s mishandling of government documents? Is it better we don’t know the extent of her pay to play schemes? Is it better we don’t know the truth about the destruction of the legitimate government of Libya? Should we not know the ultimate destination of the arms and munitions, especially stinger missals removed from Libya? How about the disruption of an opposing political candidate’s political rallies and possibly the rigging of election ballot boxes? Is the destruction of cell phones and wiping of computers OK even if they held evidence of Clinton foundations wrong doing?\nThe list goes on. What does our government do? It silences the voice of truth and replaces it with the script of propaganda.",
		"thread_title": "Ecuador Admits They Silenced Assange Because Clinton Leaks Were ‘Interfering’ With US Election",
		"title": "",
		"type": "bs",
		"uuid": "9859b764d9d4e77eb3fb97bccb04fe872adae58b"
	},
	"-KhIhj2OZFxOY5YXyxQD": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:12:17.874+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Jabhat al-Nusra",
				"salience": 0.34832746,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.101455025,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "U.S. State Department",
				"salience": 0.06438929,
				"type": "ORGANIZATION"
			},
			{
				"name": "Darius Shahtahmasebi",
				"salience": 0.061235264,
				"type": "PERSON"
			},
			{
				"name": "theantimedia.org",
				"salience": 0.061235264,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012dwfwl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kirby_(admiral)"
				},
				"name": "John Kirby",
				"salience": 0.052716423,
				"type": "PERSON"
			},
			{
				"name": "priority",
				"salience": 0.050594315,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.03655773,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.03181826,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.027991911,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.023791846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.022085046,
				"type": "LOCATION"
			},
			{
				"name": "priority",
				"salience": 0.018334657,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.017215202,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.014919187,
				"type": "EVENT"
			},
			{
				"name": "dilemma",
				"salience": 0.012191197,
				"type": "OTHER"
			},
			{
				"name": "insight",
				"salience": 0.009960098,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.009116671,
				"type": "PERSON"
			},
			{
				"name": "spoiler",
				"salience": 0.009116671,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.007260567,
				"type": "OTHER"
			},
			{
				"name": "co-mingling",
				"salience": 0.006645151,
				"type": "OTHER"
			},
			{
				"name": "ad nauseam",
				"salience": 0.006645151,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.0063975966,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/al-qaeda-us-backed-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "By Darius Shahtahmasebi at theantimedia.org\nLast week, the U.S. State Department acknowledged that al-Qaeda-linked terror group Jabhat al-Nusra is not a “priority” for the United States’ efforts in Syria.\nOne might ask, then: if al-Qaeda in Syria is not a priority for the war on terror, what is?\nState Department spokesman John Kirby provided some useful insight into this dilemma, stating:\n“The only thing that stands between where we are now and a permanent and enduring ceasefire in Syria is Bashar al-Assad and his supporters . We recognize Al-Nusra as a spoiler, we have concerns about co-mingling, I’ve talked about this ad nauseam.”",
		"thread_title": "US Government Acknowledges That al-Qaeda Is Not A Priority In Syria",
		"title": "US Government Acknowledges That al-Qaeda Is Not A Priority In Syria",
		"type": "bs",
		"uuid": "fd33df670c81142dead7c8ac088a7c7297d0fdaf"
	},
	"-KhIhj83IfEWUfYfOuUQ": {
		"author": "Robert",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:12:59.592+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Fraud fraud fraud",
				"salience": 0.1755993,
				"type": "OTHER"
			},
			{
				"name": "family tree",
				"salience": 0.16083348,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.13935265,
				"type": "PERSON"
			},
			{
				"name": "care takers",
				"salience": 0.10299592,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.10299592,
				"type": "OTHER"
			},
			{
				"name": "bullshit",
				"salience": 0.076767735,
				"type": "OTHER"
			},
			{
				"name": "pictures",
				"salience": 0.06955917,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.05922678,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.044903442,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.028133273,
				"type": "PERSON"
			},
			{
				"name": "theifing",
				"salience": 0.022909189,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.01672313,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/ukraina-e-vo-sopstvenost-na-semejstvoto-rotshild-259400.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-27T08:54:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 1.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Fraud fraud fraud can’t anyone see the family tree isnt even old and using care takers in pictures is beond bullshit i hate the U.S. government for everything theyve done to my family !!! Enjoy your theifing selfs your getting ready to burn in hell ..",
		"thread_title": "The History of the House of Rothschild (1743-2006)",
		"title": "",
		"type": "bs",
		"uuid": "1c32f441f24a42ed4072b07bb314c078937bcb47"
	},
	"-KhIhjD7BzoPNVgY3kPB": {
		"author": "Robert",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:12:59.603+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Margaret ann Roth",
				"salience": 0.4753003,
				"type": "PERSON"
			},
			{
				"name": "Marcus A Degenhart",
				"salience": 0.28503615,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0488g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas"
				},
				"name": "kansas",
				"salience": 0.06287091,
				"type": "LOCATION"
			},
			{
				"name": "mother",
				"salience": 0.054621402,
				"type": "PERSON"
			},
			{
				"name": "Janet Mary Degenhart",
				"salience": 0.046327267,
				"type": "PERSON"
			},
			{
				"name": "Reichert",
				"salience": 0.04022111,
				"type": "PERSON"
			},
			{
				"name": "family tree",
				"salience": 0.03562285,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/ukraina-e-vo-sopstvenost-na-semejstvoto-rotshild-259400.jpg",
		"ord_in_thread": "2",
		"participants_count": "2",
		"published": "2016-10-27T09:01:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Marcus A Degenhart , mother Margaret ann Roth , kansas and didnt even put me on the family tree Janet Mary Degenhart(Reichert) my mother",
		"thread_title": "The History of the House of Rothschild (1743-2006)",
		"title": "",
		"type": "bs",
		"uuid": "7f23c6375ea89acc64f4b2c4649cfc946367b1f7"
	},
	"-KhIhjNXMU0ha8hObhrG": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:13:00.968+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.47473684,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.11658695,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.041893046,
				"type": "LOCATION"
			},
			{
				"name": "tension",
				"salience": 0.035092775,
				"type": "OTHER"
			},
			{
				"name": "military buildup",
				"salience": 0.035092775,
				"type": "OTHER"
			},
			{
				"name": "midst",
				"salience": 0.030474665,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.027670654,
				"type": "LOCATION"
			},
			{
				"name": "thefreethoughtproject.com",
				"salience": 0.018890878,
				"type": "OTHER"
			},
			{
				"name": "John Vibes",
				"salience": 0.018890878,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.01626916,
				"type": "LOCATION"
			},
			{
				"name": "cold war",
				"salience": 0.016184755,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.010263843,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.008984051,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.008038166,
				"type": "ORGANIZATION"
			},
			{
				"name": "thousands",
				"salience": 0.007953322,
				"type": "PERSON"
			},
			{
				"name": "military divisions",
				"salience": 0.007325488,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.006498098,
				"type": "ORGANIZATION"
			},
			{
				"name": "effort",
				"salience": 0.006498098,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.006498098,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0063084615,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.00607376,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.005364976,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.0051532285,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.0050689997,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.00456075,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.00456075,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0043003396,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0043003396,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.00400493,
				"type": "ORGANIZATION"
			},
			{
				"name": "hardware",
				"salience": 0.0037248204,
				"type": "OTHER"
			},
			{
				"name": "military deployment",
				"salience": 0.0037248204,
				"type": "EVENT"
			},
			{
				"name": "total",
				"salience": 0.0037248204,
				"type": "OTHER"
			},
			{
				"name": "drones",
				"salience": 0.0037248204,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.0037248204,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.0033123407,
				"type": "LOCATION"
			},
			{
				"name": "move",
				"salience": 0.0032141835,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Denmark",
				"salience": 0.002704843,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.002704843,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.002704843,
				"type": "LOCATION"
			},
			{
				"name": "third world war",
				"salience": 0.002593433,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0023418595,
				"type": "ORGANIZATION"
			},
			{
				"name": "tensions",
				"salience": 0.0023418595,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Estonia"
				},
				"name": "Estonia",
				"salience": 0.0022941683,
				"type": "LOCATION"
			},
			{
				"name": "army",
				"salience": 0.0022444637,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.0020975317,
				"type": "PERSON"
			},
			{
				"name": "deterrent",
				"salience": 0.0020281142,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0015153215,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0015153215,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0015153215,
				"type": "OTHER"
			},
			{
				"name": "military build-up",
				"salience": 0.0015153215,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.001193054,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/France-largest-Army-in-the-world-1000x600.jpg",
		"ord_in_thread": "0",
		"participants_count": "3",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 2.8,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.966",
		"text": "By: John Vibes via thefreethoughtproject.com\nIn the midst of deepening tension between US allies NATO and Russia, NATO is planning the largest military buildup along the Russian border since the cold war.\nNATO called on allied governments this week to contribute whatever troops and equipment they can to the effort. According to Reuters, thousands of troops are expected to arrive in the coming days and weeks.\nIt was reported that Italy, France, Denmark and other European states are expected to join the NATO military divisions that will be led by the United States along Russia’s border.\nOn Wednesday, Britain announced it is sending hundreds of soldiers and hardware to Russia’s borders as part of a huge military deployment.\nA total of 800 troops, drones and tanks are moving to Estonia as part of the biggest military build-up of NATO troops on Russia’s borders since the Cold War.\nIn addition to the forces allocated for his specific operation, NATO has an army of over 40,000 ready to be called up to fight at any time.\nThe US military claims that this threatening move is meant to act as a “deterrent” to the Russian military, but this is obvious a move that will escalate tensions and push towards a possible third world war.",
		"thread_title": "NATO, US, & UK To Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"title": "NATO, US, & UK To Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"type": "bs",
		"uuid": "d62100eee1b1cb32b8d3a599a727f168ca11276e"
	},
	"-KhIhjTE8p_WEuklHY2h": {
		"author": "David Costa",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:13:01.120+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "makeup",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/France-largest-Army-in-the-world-1000x600.jpg",
		"ord_in_thread": "1",
		"participants_count": "3",
		"published": "2016-10-27T21:39:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.966",
		"text": "synchronized makeup",
		"thread_title": "NATO, US, & UK To Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"title": "",
		"type": "bs",
		"uuid": "e94897e3e3602785da29995cfb3e4fd9ba04344e"
	},
	"-KhIhjmG1cfgjpIDezSk": {
		"author": "Ian",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:13:01.130+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "leaders",
				"salience": 0.6296976,
				"type": "PERSON"
			},
			{
				"name": "madness",
				"salience": 0.18299155,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.10706941,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.080241434,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/France-largest-Army-in-the-world-1000x600.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-28T01:13:01.130+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.966",
		"text": "If this is really true our leaders are sicker than I thought. Its madness and and the people need to rise up in protest",
		"thread_title": "NATO, US, & UK To Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"title": "",
		"type": "bs",
		"uuid": "017f86b2045577d795cdfd671a8157ee2d7c0f77"
	},
	"-KhIhjqyJXZkVpB7B3Po": {
		"author": "The Man",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:13:14.423+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "CHRISTIAN",
				"salience": 1,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-1-42-e1477379119658.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-27T23:53:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.294",
		"text": "How about adding that he is a CHRISTIAN!!!",
		"thread_title": "Anonymous Online Vigilante Group Helps Jail a Pedophile",
		"title": "",
		"type": "bs",
		"uuid": "c0e0779379d24b8e28644f1596daf491619bb776"
	},
	"-KhIhjxJtYI7-KrlpFB-": {
		"author": "The Man",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:13:14.434+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "ga",
				"salience": 0.766535,
				"type": "OTHER"
			},
			{
				"name": "tee",
				"salience": 0.23346499,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-1-42-e1477379119658.jpg",
		"ord_in_thread": "2",
		"participants_count": "2",
		"published": "2016-10-28T00:52:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.294",
		"text": "forgot to add that this nee ga is a kris tee yan!!!",
		"thread_title": "Anonymous Online Vigilante Group Helps Jail a Pedophile",
		"title": "",
		"type": "bs",
		"uuid": "768fca693f79ef9855240df9e21cda7f30ca48b2"
	},
	"-KhIhk3f35vUBJgkjW1_": {
		"author": "Martin",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:13:25.968+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 1,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Untitled-19-959x600.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-27T14:00:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Israel.",
		"thread_title": "9/11 Firefighters Reveal Bombs Destroyed WTC lobby",
		"title": "",
		"type": "bs",
		"uuid": "ee49246c38ce4cb1260f0f5909bfe3e76de9084d"
	},
	"-KhIhkFFjEVWsd06Azk2": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:13:28.712+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.2972734,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.1966236,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.11125618,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.045033235,
				"type": "PERSON"
			},
			{
				"name": "coalition airstrikes",
				"salience": 0.039839715,
				"type": "EVENT"
			},
			{
				"name": "casualties",
				"salience": 0.036364235,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.034600087,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01fc50",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-war_movement"
				},
				"name": "ANTIWAR",
				"salience": 0.021453103,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.019912563,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.015776718,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.01440184,
				"type": "OTHER"
			},
			{
				"name": "air war",
				"salience": 0.01440184,
				"type": "EVENT"
			},
			{
				"name": "civilians",
				"salience": 0.013396095,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.010100149,
				"type": "LOCATION"
			},
			{
				"name": "coalition",
				"salience": 0.008519295,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.0076432815,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0073590274,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.006872937,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/012w_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manbij"
				},
				"name": "Manbij",
				"salience": 0.006530299,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0059807273,
				"type": "LOCATION"
			},
			{
				"name": "invasion",
				"salience": 0.0059807273,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0059807273,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0057581016,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0052039973,
				"type": "WORK_OF_ART"
			},
			{
				"name": "scores",
				"salience": 0.00518081,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0051385825,
				"type": "WORK_OF_ART"
			},
			{
				"name": "slain",
				"salience": 0.004987876,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.004987876,
				"type": "OTHER"
			},
			{
				"name": "count",
				"salience": 0.0042313016,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.0042313016,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0039218506,
				"type": "EVENT"
			},
			{
				"name": "deaths",
				"salience": 0.0036512678,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.0031916827,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.003162355,
				"type": "OTHER"
			},
			{
				"name": "corrections",
				"salience": 0.0026151557,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0023932233,
				"type": "OTHER"
			},
			{
				"name": "death toll",
				"salience": 0.0023039638,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09w3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pentagon"
				},
				"name": "Pentagon",
				"salience": 0.0022671556,
				"type": "ORGANIZATION"
			},
			{
				"name": "some",
				"salience": 0.0021901017,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.0019878352,
				"type": "EVENT"
			},
			{
				"name": "policy",
				"salience": 0.0017214422,
				"type": "OTHER"
			},
			{
				"name": "recognition",
				"salience": 0.0017214422,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0016783532,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hr9tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Observatory_for_Human_Rights"
				},
				"name": "Syrian Observatory for Human Rights",
				"salience": 0.001114842,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.0010597111,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/13814654_1374339872594624_1640854087_n.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.001",
		"text": "( ANTIWAR ) Amnesty International has issued a new statement warning that the US needs to do more to prevent civilian casualties in its coalition airstrikes in both Iraq and Syria, and cautioned the US has dramatically under-reported the number of civilians killed in their air war. The new report centered on Syria, noting that the US-led coalition had killed at least 300 civilians in Syria, and had not admitted to the vast majority of those slain. They reported the US had killed around 250 civilians just in the city of Manbij and the surrounding area.\nThe US backed a Kurdish invasion of Manbij earlier this past summer, and conducted several major airstrikes in the surrounding areas, including some which killed scores of civilians. As Amnesty pointed out, the US has not officially included any civilians from the Manbij strikes on their official count, despite the incidents being well established.\nAmnesty warned that the lack of official recognition raised concerns that the US had not made any corrections to their policy, and that this was particularly concerning with the ongoing invasion of the city of Mosul, which is many times larger and expected to be an even longer conflict.\nThe Pentagon has only acknowledged a few dozen civilian deaths in both Iraq and Syria combined. The Amnesty report, while drastically higher, is still considered very conservative, with the Syrian Observatory for Human Rights putting the US-caused civilian death toll in Syria between 600 and 1,000.",
		"thread_title": "US Coalition Airstrikes Have Killed at Least 300 Civilians in Syria",
		"title": "US Coalition Airstrikes Have Killed at Least 300 Civilians in Syria",
		"type": "bs",
		"uuid": "eaa25c92259b91655644cf5c5cd985b49f5cb489"
	},
	"-KhIhkNZokW7pJkvWBMi": {
		"author": "Josh",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:13:49.615+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "cops",
				"salience": 0.8861781,
				"type": "PERSON"
			},
			{
				"name": "respect",
				"salience": 0.06962033,
				"type": "OTHER"
			},
			{
				"name": "fucker",
				"salience": 0.04420159,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Houghton-arrest-KUTV.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-28T00:29:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 1.6,
			"score": -0.8
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "And cops wonder why they get no respect. Stupid fucker",
		"thread_title": "Crash Victim Calls for Help - Gets Arrested and Sexually Assaulted Instead",
		"title": "",
		"type": "bs",
		"uuid": "24e4502be52838d5e21b21eaf5909295e739f380"
	},
	"-KhIhkS_1Km0GP2iTeXZ": {
		"author": "Jim",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T01:15:54.664+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "guy",
				"salience": 0.6574721,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.16789694,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.09437955,
				"type": "OTHER"
			},
			{
				"name": "FAUX",
				"salience": 0.08025143,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Broken-Pipe.jpg",
		"ord_in_thread": "3",
		"participants_count": "4",
		"published": "2016-10-27T12:42:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Says the guy who drops a link from FAUX news",
		"thread_title": "Pennsylvania Pipelines Bursts, Leaks 55,000 Gallons Of Gas Into One Of US’ Most Endangered Rivers",
		"title": "",
		"type": "bs",
		"uuid": "a0c652e595a4857f504fb5a2593f367c71efa55a"
	},
	"-KhIhkdXTIiJIuqPcX5T": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T16:10:15.408+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Pirates",
				"salience": 0.12362704,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rj0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iceland"
				},
				"name": "Icelandic",
				"salience": 0.11823645,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hzq9zh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pirate_Party"
				},
				"name": "Pirate Party",
				"salience": 0.05462316,
				"type": "ORGANIZATION"
			},
			{
				"name": "libertarians",
				"salience": 0.046141185,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.04173191,
				"type": "LOCATION"
			},
			{
				"name": "surveillance",
				"salience": 0.04173191,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.04173191,
				"type": "LOCATION"
			},
			{
				"name": "ordinary",
				"salience": 0.03621317,
				"type": "OTHER"
			},
			{
				"name": "amalgamation",
				"salience": 0.03621317,
				"type": "OTHER"
			},
			{
				"name": "anarchists",
				"salience": 0.03621317,
				"type": "OTHER"
			},
			{
				"name": "hackers",
				"salience": 0.03621317,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.03621317,
				"type": "EVENT"
			},
			{
				"name": "thefreethoughtproject.com",
				"salience": 0.022406332,
				"type": "OTHER"
			},
			{
				"name": "Claire Bernish",
				"salience": 0.022406332,
				"type": "PERSON"
			},
			{
				"name": "explosion",
				"salience": 0.015309452,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cc597m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Birgitta_J%C3%B3nsd%C3%B3ttir"
				},
				"name": "Birgitta Jónsdóttir",
				"salience": 0.012675236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0v5m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pirate_Party_of_Sweden"
				},
				"name": "Swedish Pirate Party",
				"salience": 0.012323522,
				"type": "ORGANIZATION"
			},
			{
				"name": "fruition",
				"salience": 0.009595564,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.008879575,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.008879575,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.008705359,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.008412277,
				"type": "ORGANIZATION"
			},
			{
				"name": "popularity",
				"salience": 0.0076920325,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.0076920325,
				"type": "OTHER"
			},
			{
				"name": "free-thinkers",
				"salience": 0.0076920325,
				"type": "OTHER"
			},
			{
				"name": "paradigm",
				"salience": 0.0076920325,
				"type": "OTHER"
			},
			{
				"name": "Internet spying",
				"salience": 0.0076920325,
				"type": "OTHER"
			},
			{
				"name": "libertarianism",
				"salience": 0.0066427873,
				"type": "OTHER"
			},
			{
				"name": "founder",
				"salience": 0.0065546865,
				"type": "PERSON"
			},
			{
				"name": "Big Government",
				"salience": 0.0059989826,
				"type": "ORGANIZATION"
			},
			{
				"name": "tactics",
				"salience": 0.0059989826,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.005397047,
				"type": "ORGANIZATION"
			},
			{
				"name": "process",
				"salience": 0.005397047,
				"type": "OTHER"
			},
			{
				"name": "traditionalists",
				"salience": 0.005397047,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.005397047,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.005397047,
				"type": "OTHER"
			},
			{
				"name": "anti-establishment roots",
				"salience": 0.005397047,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0051959013,
				"type": "EVENT"
			},
			{
				"name": "citizenship",
				"salience": 0.0051959013,
				"type": "OTHER"
			},
			{
				"name": "promotion",
				"salience": 0.0051959013,
				"type": "OTHER"
			},
			{
				"name": "privacy rights",
				"salience": 0.0051959013,
				"type": "OTHER"
			},
			{
				"name": "shrinking",
				"salience": 0.0051959013,
				"type": "OTHER"
			},
			{
				"name": "freedoms",
				"salience": 0.0051959013,
				"type": "OTHER"
			},
			{
				"name": "programmer",
				"salience": 0.0050886734,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0050886734,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0049073515,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vzv0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edward_Snowden"
				},
				"name": "Edward Snowden",
				"salience": 0.0046203695,
				"type": "PERSON"
			},
			{
				"name": "activist",
				"salience": 0.0044072443,
				"type": "PERSON"
			},
			{
				"name": "enthusiasm",
				"salience": 0.0044072443,
				"type": "OTHER"
			},
			{
				"name": "haven",
				"salience": 0.004351778,
				"type": "OTHER"
			},
			{
				"name": "off-guard",
				"salience": 0.0042970083,
				"type": "EVENT"
			},
			{
				"name": "Pirates",
				"salience": 0.0042463816,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.0039825444,
				"type": "OTHER"
			},
			{
				"name": "systems",
				"salience": 0.0032932914,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.0032932914,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.0032932914,
				"type": "OTHER"
			},
			{
				"name": "mix",
				"salience": 0.0032932914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0027138605,
				"type": "ORGANIZATION"
			},
			{
				"name": "laws",
				"salience": 0.0024296334,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0023990322,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0023990322,
				"type": "OTHER"
			},
			{
				"name": "The Icelandic Pirate Party",
				"salience": 0.0023630075,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jónsdóttir",
				"salience": 0.0023414118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg42y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rick_Falkvinge"
				},
				"name": "Richard Falkvinge",
				"salience": 0.0023309581,
				"type": "PERSON"
			},
			{
				"name": "liberties",
				"salience": 0.0022922584,
				"type": "OTHER"
			},
			{
				"name": "police state tactics",
				"salience": 0.0020697555,
				"type": "OTHER"
			},
			{
				"name": "surveillance programs",
				"salience": 0.0020697555,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0020697555,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0020697555,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.0018320285,
				"type": "ORGANIZATION"
			},
			{
				"name": "rise",
				"salience": 0.0017923088,
				"type": "OTHER"
			},
			{
				"name": "frustration",
				"salience": 0.0017923088,
				"type": "OTHER"
			},
			{
				"name": "internet copyright reform",
				"salience": 0.001558993,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0012097807,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/pirate-party.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.01",
		"text": "By Claire Bernish at thefreethoughtproject.com\nIn a country continuing to shirk the ordinary, Iceland’s Pirate Party — an amalgamation of anarchists, libertarians, and hackers, who want to ban digital surveillance — is predicted to win the country’s national elections this Saturday.\nThis collection of free-thinkers have upturned the traditional Western political paradigm and hopes to use online public polls to shape governmental policy and end all Internet spying.\nAlthough the Pirate Party formed just four years ago, its popularity has skyrocketed — most likely for unconventional tactics aligning loosely with libertarianism — the promotion of privacy rights and personal freedoms, and simultaneous shrinking of Big Government.\nEdward Snowden has been offered the safe haven of Icelandic citizenship should the Pirates likely victory come to fruition — which makes sense, given the party’s anti-establishment roots.\nIn fact, the Pirates have experienced astonishing success in a short time — taking the nation’s longstanding political traditionalists off-guard in the process — even the group’s founder, a programmer and former Wikileaks activist, is stunned.\nAsked whether she expected the explosion of enthusiasm for the nascent Pirate Party — which now leads in public polls with 22.6 percent — founder Birgitta Jónsdóttir decisively told the Washington Post , “No way.”\nBut considering growing frustration with ever-increasing Western governments — and all of the surveillance programs, police state tactics, and chill on personal liberties — the rise of the Pirates, who describe themselves as neither right nor left but a radical mix of both, hardly seems too shocking.\n“People want real changes and they understand that we have to change the systems,” Jónsdóttir asserted, “we have to modernize how we make laws.”\nAccording to the Pirates’ website , “The Icelandic Pirate Party was founded on November 24th, 2012 based on the political ideology of the Swedish Pirate Party, which Richard Falkvinge founded in January 2006, to bring about internet copyright reform.”",
		"thread_title": "Political Party of Anarchists, Libertarians, Hackers, and Computer Geeks to Take Power in Iceland",
		"title": "Political Party of Anarchists, Libertarians, Hackers, and Computer Geeks to Take Power in Iceland",
		"type": "bs",
		"uuid": "16272301eef853acec79c45bd273e916ff4b9caf"
	},
	"-KhIhklfuwekzgh0ByUy": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T16:10:25.476+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.41776615,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.079637714,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.046938058,
				"type": "PERSON"
			},
			{
				"name": "missile",
				"salience": 0.04341683,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.031552754,
				"type": "WORK_OF_ART"
			},
			{
				"name": "soil",
				"salience": 0.031552754,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.031552754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.030952847,
				"type": "LOCATION"
			},
			{
				"name": "ZHE",
				"salience": 0.019540109,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.019540109,
				"type": "LOCATION"
			},
			{
				"name": "systems",
				"salience": 0.01673717,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.01512405,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.01512405,
				"type": "EVENT"
			},
			{
				"name": "arms",
				"salience": 0.01512405,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.014479905,
				"type": "OTHER"
			},
			{
				"name": "PUTIN",
				"salience": 0.01382902,
				"type": "OTHER"
			},
			{
				"name": "ICBM",
				"salience": 0.008580643,
				"type": "ORGANIZATION"
			},
			{
				"name": "defences",
				"salience": 0.008580643,
				"type": "OTHER"
			},
			{
				"name": "photos",
				"salience": 0.0067144195,
				"type": "WORK_OF_ART"
			},
			{
				"name": "picture",
				"salience": 0.0063312785,
				"type": "WORK_OF_ART"
			},
			{
				"name": "designer",
				"salience": 0.006275731,
				"type": "PERSON"
			},
			{
				"name": "missiles",
				"salience": 0.006275731,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.006023177,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.006023177,
				"type": "LOCATION"
			},
			{
				"name": "ICBM",
				"salience": 0.006023177,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012ngfw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RS-28_Sarmat"
				},
				"name": "Sarmat",
				"salience": 0.0059398673,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.005798919,
				"type": "LOCATION"
			},
			{
				"name": "picture",
				"salience": 0.0054397113,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03vs5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Intercontinental_ballistic_missile"
				},
				"name": "Intercontinental Ballistic Missiles",
				"salience": 0.0050892173,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0047118096,
				"type": "OTHER"
			},
			{
				"name": "payload",
				"salience": 0.0045362613,
				"type": "OTHER"
			},
			{
				"name": "accordance",
				"salience": 0.0038479227,
				"type": "OTHER"
			},
			{
				"name": "Decree",
				"salience": 0.0038479227,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.0038479227,
				"type": "ORGANIZATION"
			},
			{
				"name": "Makeyev Design Bureau",
				"salience": 0.0035726042,
				"type": "ORGANIZATION"
			},
			{
				"name": "TREATY",
				"salience": 0.0033475847,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0033202672,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.0033202672,
				"type": "OTHER"
			},
			{
				"name": "Makeyev Rocket Design Bureau",
				"salience": 0.0031877453,
				"type": "ORGANIZATION"
			},
			{
				"name": "deterrent",
				"salience": 0.0028755474,
				"type": "OTHER"
			},
			{
				"name": "objectives",
				"salience": 0.0028755474,
				"type": "OTHER"
			},
			{
				"name": "State Defence Order",
				"salience": 0.0027363037,
				"type": "OTHER"
			},
			{
				"name": "SYSTEMS",
				"salience": 0.002678889,
				"type": "OTHER"
			},
			{
				"name": "ARMS RACE",
				"salience": 0.0024189749,
				"type": "EVENT"
			},
			{
				"name": "ATTACK",
				"salience": 0.0024189749,
				"type": "OTHER"
			},
			{
				"name": "missile system",
				"salience": 0.0023303733,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.0021665571,
				"type": "OTHER"
			},
			{
				"name": "CIRCLE",
				"salience": 0.002094843,
				"type": "OTHER"
			},
			{
				"name": "CONFRONTATION",
				"salience": 0.002094843,
				"type": "EVENT"
			},
			{
				"name": "SPHERE",
				"salience": 0.002094843,
				"type": "OTHER"
			},
			{
				"name": "Bureau",
				"salience": 0.0020016213,
				"type": "ORGANIZATION"
			},
			{
				"name": "development",
				"salience": 0.0018073557,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.0018073557,
				"type": "OTHER"
			},
			{
				"name": "state contract",
				"salience": 0.001565111,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.001565111,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h6l2s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Defence_(India)"
				},
				"name": "Ministry of Defense",
				"salience": 0.0009634161,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/russia-2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "( ZHE ) Having unveiled the first images of its new nuclear missile capable of reaching US soil, Russian President Vladimir Putin is warning today that Washington’s actions are “pushing Russian into a nuclear arms race,” forcing Russia “to develop its nuclear attack systems.” Yesterday, Russia reveals photos of a new highly advanced liquid fuelled heavy ICBM capable of evading anti-missile defences and hitting US territory with 10 tonne nuclear payload.\nThe Makeyev Design Bureau – the designer of Russia’s heavy liquid fuelled Intercontinental Ballistic Missiles (“ICBMs”) – ie. of missiles capable of reaching US territory from Russian territory, has published the first picture of Russia’s new heavy Sarmat ICBM which is due to enter service shortly, probably in 2018.\nThe picture is accompanied by a short statement which reads\n“In accordance with the Decree of the Russian Government ‘On the State Defence Order for 2010 and the planning period 2012-2013,’ the Makeyev Rocket Design Bureau was instructed to start design and development work on the Sarmat. In June 2011, the Bureau and the Russian Ministry of Defense signed a state contract for the Sarmat’s development. The prospective strategic missile system is being developed in order to assuredly and effectively fulfil objectives of nuclear deterrent by Russia’s strategic forces. ”\nAnd now today, Putin explains:\n*PUTIN: INTERMEDIATE NUCLEAR FORCES TREATY SHOULD BE OBSERVED *PUTIN: RUSSIA, U.S. MUST BREAK VICIOUS CIRCLE OF CONFRONTATION *PUTIN: RUSSIA HAS TO DEVELOP ITS NUCLEAR ATTACK SYSTEMS *PUTIN: U.S. PUSHED RUSSIA TO ARMS RACE IN NUCLEAR SPHERE",
		"thread_title": "Putin Warns “US Has Pushed Russia Back Into Nuclear Arms Race”",
		"title": "Putin Warns “US Has Pushed Russia Back Into Nuclear Arms Race”",
		"type": "bs",
		"uuid": "21f82e0a0b13b5b177dc99c1152b1c695b8f1b2f"
	},
	"-KhIhkpMBPc_YpuBvb_R": {
		"author": "Yo Mama",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T16:10:53.733+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "memes",
				"salience": 0.41122603,
				"type": "OTHER"
			},
			{
				"name": "bullshit",
				"salience": 0.39740083,
				"type": "OTHER"
			},
			{
				"name": "duck dynasty",
				"salience": 0.19137314,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/France-largest-Army-in-the-world-1000x600.jpg",
		"ord_in_thread": "3",
		"participants_count": "4",
		"published": "2016-10-28T07:15:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.966",
		"text": "They’re too busy liking bullshit memes and watching duck dynasty than to care.",
		"thread_title": "NATO, US, & UK To Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"title": "",
		"type": "bs",
		"uuid": "66235757ae62598a90ecbe41d4ad90425ac45c65"
	},
	"-KhIhl4GKe5gvijZxeiR": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T16:11:01.167+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.34111333,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0976456,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.046604108,
				"type": "PERSON"
			},
			{
				"name": "classroom",
				"salience": 0.040200554,
				"type": "LOCATION"
			},
			{
				"name": "classrooms",
				"salience": 0.036627308,
				"type": "LOCATION"
			},
			{
				"name": "Children",
				"salience": 0.03461655,
				"type": "PERSON"
			},
			{
				"name": "anywhere",
				"salience": 0.028753374,
				"type": "LOCATION"
			},
			{
				"name": "chance",
				"salience": 0.028753374,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.028753374,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020q9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Lake"
				},
				"name": "Anthony Lake",
				"salience": 0.026230907,
				"type": "PERSON"
			},
			{
				"name": "risk",
				"salience": 0.023242902,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.021765301,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.00998061,
				"type": "PERSON"
			},
			{
				"name": "Children",
				"salience": 0.009192939,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07l57d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib"
				},
				"name": "Idlib",
				"salience": 0.008793502,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.00735593,
				"type": "EVENT"
			},
			{
				"name": "classes",
				"salience": 0.0073329085,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0070822365,
				"type": "EVENT"
			},
			{
				"name": "teachers",
				"salience": 0.0070551536,
				"type": "PERSON"
			},
			{
				"name": "Photo",
				"salience": 0.0070551536,
				"type": "WORK_OF_ART"
			},
			{
				"name": "village",
				"salience": 0.0070551536,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.007007446,
				"type": "PERSON"
			},
			{
				"name": "aid groups",
				"salience": 0.0068483953,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.006703107,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.0061117853,
				"type": "LOCATION"
			},
			{
				"name": "south",
				"salience": 0.0061117853,
				"type": "LOCATION"
			},
			{
				"name": "air strike",
				"salience": 0.0061117853,
				"type": "EVENT"
			},
			{
				"name": "school",
				"salience": 0.0060933516,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.0060933516,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack",
				"salience": 0.005933275,
				"type": "EVENT"
			},
			{
				"name": "entrance",
				"salience": 0.0056285392,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0051693837,
				"type": "ORGANIZATION"
			},
			{
				"name": "teachers",
				"salience": 0.0051427586,
				"type": "PERSON"
			},
			{
				"name": "atrocity",
				"salience": 0.0049918983,
				"type": "OTHER"
			},
			{
				"name": "war crime",
				"salience": 0.0045687053,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0044775754,
				"type": "EVENT"
			},
			{
				"name": "tragedy",
				"salience": 0.0043984777,
				"type": "EVENT"
			},
			{
				"name": "outrage",
				"salience": 0.0043984777,
				"type": "OTHER"
			},
			{
				"name": "school compound",
				"salience": 0.004288523,
				"type": "LOCATION"
			},
			{
				"name": "conflict",
				"salience": 0.0041287118,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0h540rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hass,_Syria"
				},
				"name": "Hass",
				"salience": 0.0037656054,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02dlk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agence_France-Presse"
				},
				"name": "AFP",
				"salience": 0.0037656054,
				"type": "ORGANIZATION"
			},
			{
				"name": "Omar haj kadour",
				"salience": 0.0037656054,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.0036540064,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0035021056,
				"type": "PERSON"
			},
			{
				"name": "scar",
				"salience": 0.0035021056,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0035021056,
				"type": "PERSON"
			},
			{
				"name": "village",
				"salience": 0.0030217983,
				"type": "LOCATION"
			},
			{
				"name": "elsewhere",
				"salience": 0.0030217983,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.0026412832,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fxc0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UNICEF"
				},
				"name": "UNICEF",
				"salience": 0.0026412832,
				"type": "ORGANIZATION"
			},
			{
				"name": "raids",
				"salience": 0.0026170027,
				"type": "EVENT"
			},
			{
				"name": "Activists",
				"salience": 0.0026170027,
				"type": "PERSON"
			},
			{
				"name": "bombing",
				"salience": 0.002456357,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0024380046,
				"type": "EVENT"
			},
			{
				"name": "photographs",
				"salience": 0.0022014356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "many",
				"salience": 0.0022014356,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0020311433,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0019223448,
				"type": "EVENT"
			},
			{
				"name": "human suffering",
				"salience": 0.0019064248,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.0019064248,
				"type": "OTHER"
			},
			{
				"name": "floor",
				"salience": 0.0019064248,
				"type": "LOCATION"
			},
			{
				"name": "treatment center",
				"salience": 0.0019064248,
				"type": "LOCATION"
			},
			{
				"name": "buildings",
				"salience": 0.0014243046,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0014243046,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.0013331964,
				"type": "ORGANIZATION"
			},
			{
				"name": "Haas",
				"salience": 0.0008767176,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09bjv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beirut"
				},
				"name": "Beirut",
				"salience": 0.0008767176,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.0008767176,
				"type": "LOCATION"
			},
			{
				"name": "James Longman",
				"salience": 0.0008767176,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Children-in-Syria.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.9,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "“Syria’s children, like children anywhere else in the world, deserve the chance to learn and play without running the risk of being killed in their classrooms.” A damaged classroom at a school after it was hit in an air strike in the village of Hass, in the south of Syria’s rebel-held Idlib province on October 26, 2016. (Photo: Omar haj kadour/AFP)\nTwenty-two children and six teachers were killed after a school in Idlib, Syria was bombed on Wednesday, which aid groups are saying may be the deadliest attack on a school since the conflict began.\n“This is a tragedy. It is an outrage. And if deliberate, it is a war crime,” said Anthony Lake, executive director of the United Nations children’s agency UNICEF, of the attack on the school compound.\n“This latest atrocity may be the deadliest attack on a school since the war began more than five years ago,” he continued. “Children lost forever to their families…teachers lost forever to their students…one more scar on Syria’s future.”\nAccording to BBC :\nThe attack on Haas, about 75km (46 miles) south-west of Aleppo, appears to have been intense and flattened a number of buildings, reports the BBC’s James Longman in Beirut.\nChildren were reportedly gathered around an entrance when it was hit, at about 11:30 local time (08:30 GMT). They had been allowed to leave classes early because of the raids elsewhere in the village.\nActivists shared photographs of dead bodies—many of them children—on the floor of a makeshift treatment center.\nMany are saying that Wednesday’s bombing is evidence of the increasing human suffering caused by the intractable war within Syria .",
		"thread_title": "Yet Another School Bombing In Syria: 22 Children And 6 Teachers Killed",
		"title": "Yet Another School Bombing In Syria: 22 Children And 6 Teachers Killed",
		"type": "bs",
		"uuid": "c7fb6beae1a06f25cc7592b312e605e9bf6deeed"
	},
	"-KhIhlMksK5o7jW5GDSt": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T16:11:06.954+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "situation",
				"salience": 0.1138488,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.10961591,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.10626734,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0c_bfw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Committee_of_the_Red_Cross"
				},
				"name": "International Committee of the Red Cross",
				"salience": 0.068716176,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.05112433,
				"type": "PERSON"
			},
			{
				"name": "progress",
				"salience": 0.048625037,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.045332246,
				"type": "LOCATION"
			},
			{
				"name": "school",
				"salience": 0.039524533,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0375611,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.02986774,
				"type": "LOCATION"
			},
			{
				"name": "offensive",
				"salience": 0.02508039,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.021192443,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.020204175,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.019519962,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.015534376,
				"type": "LOCATION"
			},
			{
				"name": "call",
				"salience": 0.014879426,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.014879426,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.014325715,
				"type": "ORGANIZATION"
			},
			{
				"name": "coalition airstrikes",
				"salience": 0.014325715,
				"type": "ORGANIZATION"
			},
			{
				"name": "girls",
				"salience": 0.014325715,
				"type": "PERSON"
			},
			{
				"name": "objects",
				"salience": 0.014325715,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.012154085,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.012154085,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.012154085,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.011285268,
				"type": "LOCATION"
			},
			{
				"name": "offensive",
				"salience": 0.010488865,
				"type": "OTHER"
			},
			{
				"name": "sidelines",
				"salience": 0.009085027,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.009085027,
				"type": "WORK_OF_ART"
			},
			{
				"name": "action",
				"salience": 0.009085027,
				"type": "OTHER"
			},
			{
				"name": "pause",
				"salience": 0.009085027,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Al-Nusra Front",
				"salience": 0.008922944,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00882756,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.008565997,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.008078902,
				"type": "ORGANIZATION"
			},
			{
				"name": "general",
				"salience": 0.006704186,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0066198064,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.005595436,
				"type": "LOCATION"
			},
			{
				"name": "ability",
				"salience": 0.0049465084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.004076159,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0040097437,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/14877223_10210059538501723_668073892_n.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.017",
		"text": "“ We are closely monitoring the situation around Mosul. So far we see no substantial progress in liberating this city from the terrorists of ISIS ,” he added, referring to the terrorist organization Islamic State by its former name. According to the Russian military, among the civilian objects hit by US-led coalition airstrikes was a school for girls in southern Mosul, which was attacked last Friday.\nMeanwhile, the International Committee of the Red Cross reiterated its call not to target civilians and civilian infrastructure in Mosul. The aid organization earlier warned that the offensive may force hundreds of thousands of refugees to flee the city, overstretching Iraq’s already-challenged ability to shelter them.\nThe general described the situation around the Iraqi city on the sidelines of a report about Russia’s action in Syria, where Moscow and Damascus continue a pause in the offensive in Aleppo, which is divided between the Syrian Army and various armed groups, including the terrorist organization Al-Nusra Front.",
		"thread_title": "60 Civilians Killed, 200 Injured As US-Led Airstrikes Hit a School In Iraq",
		"title": "60 Civilians Killed, 200 Injured As US-Led Airstrikes Hit a School In Iraq",
		"type": "bs",
		"uuid": "aab669d79cf4dac4daa466c3980d372cb77e5205"
	},
	"-KhIhlXR8hiFsDhLdKnz": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T16:11:19.120+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "deployment",
				"salience": 0.31561556,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.24758661,
				"type": "ORGANIZATION"
			},
			{
				"name": "deployment",
				"salience": 0.044511627,
				"type": "EVENT"
			},
			{
				"name": "ground troops",
				"salience": 0.034234244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.028978541,
				"type": "LOCATION"
			},
			{
				"name": "progress",
				"salience": 0.028868375,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.028868375,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01b8g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jens_Stoltenberg"
				},
				"name": "Jens Stoltenberg",
				"salience": 0.024152273,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.021887638,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01522",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Sea"
				},
				"name": "Baltic",
				"salience": 0.02126066,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern Europe",
				"salience": 0.0179132,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01fc50",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-war_movement"
				},
				"name": "ANTIWAR",
				"salience": 0.0179132,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.017697493,
				"type": "PERSON"
			},
			{
				"name": "member nations",
				"salience": 0.015350744,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.014296326,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/069dd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quotation"
				},
				"name": "Quote",
				"salience": 0.0137405675,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.012056174,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.012030464,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.010444247,
				"type": "PERSON"
			},
			{
				"name": "border",
				"salience": 0.008142327,
				"type": "LOCATION"
			},
			{
				"name": "nations",
				"salience": 0.005328199,
				"type": "OTHER"
			},
			{
				"name": "d diplomats",
				"salience": 0.0043301135,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.004168907,
				"type": "OTHER"
			},
			{
				"name": "participants",
				"salience": 0.0036735423,
				"type": "PERSON"
			},
			{
				"name": "complaints",
				"salience": 0.0035367147,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0035367147,
				"type": "OTHER"
			},
			{
				"name": "warship deployments",
				"salience": 0.0030031146,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0026679183,
				"type": "ORGANIZATION"
			},
			{
				"name": "coast",
				"salience": 0.002643408,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.002643408,
				"type": "OTHER"
			},
			{
				"name": "deployments",
				"salience": 0.0022443584,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04g61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Luxembourg"
				},
				"name": "Luxembourg",
				"salience": 0.002178583,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Albania"
				},
				"name": "Albania",
				"salience": 0.002178583,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06t8v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slovenia"
				},
				"name": "Slovenia",
				"salience": 0.002178583,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.002158561,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0019937253,
				"type": "LOCATION"
			},
			{
				"name": "shore",
				"salience": 0.001925978,
				"type": "LOCATION"
			},
			{
				"name": "capacity",
				"salience": 0.001925978,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.001925978,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.0018541511,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0018402993,
				"type": "LOCATION"
			},
			{
				"name": "battalions",
				"salience": 0.0017849994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05jd9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Fleet"
				},
				"name": "Baltic Fleet",
				"salience": 0.0011858349,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05b4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norway"
				},
				"name": "Norway",
				"salience": 0.0008859214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0154j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belgium"
				},
				"name": "Belgium",
				"salience": 0.0008859214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01pj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Croatia"
				},
				"name": "Croatia",
				"salience": 0.0008859214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.0008859214,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/14825571_1468335756528368_2064406412_n.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.1,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "( ANTIWAR ) A day after reports NATO was soliciting even more ground troops for their deployment into Eastern Europe, officials are reporting “progress” in recruiting more troops from more member nations to participate in the deployment, intended to be around 40,000 troops along the Baltic states, near Russia’s border. NATO Secretary-General Jens Stoltenberg claimed to have been “ very inspired ” by the response of nations he sought troops from, after yesterday’s report Quote: d diplomats as saying the deployment was meant to both “confront” Russia and to undercut Republican presidential nominee Donald Trump’s complaints NATO isn’t participating enough in its own defense.\nThe new participants in the deployment include Albania, Slovenia, Luxembourg, the Netherlands, Croatia, Belgium, and Norway. The size of individual deployments from different nations is unclear, but there will be four battalions, and the US is expected to provide the majority.\nWith all these troops headed to the Baltic coast, reports out of Russia’s media suggest that they are planning some new warship deployments into their Baltic Fleet, with an eye toward enhancing their targeting capacity along the shore.",
		"thread_title": "NATO Confirms Major Troop Buildup In Eastern Europe",
		"title": "NATO Confirms Major Troop Buildup In Eastern Europe",
		"type": "bs",
		"uuid": "701c688b1d6cf2f55bb978351ee806725acb84d3"
	},
	"-KhIhlbEjFhmfJ1wT-sb": {
		"author": "IT Ninja",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:46:44.624+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apple_Inc."
				},
				"name": "Apple",
				"salience": 0.42387697,
				"type": "ORGANIZATION"
			},
			{
				"name": "HomeKit",
				"salience": 0.22467138,
				"type": "LOCATION"
			},
			{
				"name": "home security security",
				"salience": 0.21046314,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.14098851,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "3",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Genie-Smart-Lock-2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "3",
		"site_url": "anonhq.com",
		"spam_score": "0.181",
		"text": "Apple HomeKit home security security smart house",
		"thread_title": "Siri Can Open Smart Locks and Let Neighbors Walk Into Your House",
		"title": "Siri Can Open Smart Locks and Let Neighbors Walk Into Your House",
		"type": "bs",
		"uuid": "bafa36749916697117bd52516e083337fb847462"
	},
	"-KhIhlm-l9nZRe79t6qO": {
		"author": "righteous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:47:58.642+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Anonymous",
				"salience": 0.4476902,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nr1np",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anonymous_(group)"
				},
				"name": "Anonymous",
				"salience": 0.048090395,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Anons",
				"salience": 0.031230794,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.026260316,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.021447603,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.017917749,
				"type": "PERSON"
			},
			{
				"name": "Anonymous",
				"salience": 0.01694589,
				"type": "OTHER"
			},
			{
				"name": "individual",
				"salience": 0.015531419,
				"type": "PERSON"
			},
			{
				"name": "another",
				"salience": 0.015531419,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.015531419,
				"type": "OTHER"
			},
			{
				"name": "masks",
				"salience": 0.012855893,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.01171838,
				"type": "OTHER"
			},
			{
				"name": "Anons",
				"salience": 0.011382929,
				"type": "PERSON"
			},
			{
				"name": "Protesters",
				"salience": 0.010686513,
				"type": "PERSON"
			},
			{
				"name": "gap",
				"salience": 0.010243549,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.009053284,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0090162065,
				"type": "PERSON"
			},
			{
				"name": "generation",
				"salience": 0.008857217,
				"type": "PERSON"
			},
			{
				"name": "demonstration",
				"salience": 0.007956334,
				"type": "EVENT"
			},
			{
				"name": "everyone",
				"salience": 0.007840578,
				"type": "PERSON"
			},
			{
				"name": "peoples",
				"salience": 0.007395738,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.006684141,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0462hs8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Counterfeiting_Trade_Agreement"
				},
				"name": "Anti-Counterfeiting Trade Agreement",
				"salience": 0.00645256,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0055937534,
				"type": "OTHER"
			},
			{
				"name": "Anonymous",
				"salience": 0.005507929,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00501883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.004902957,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cp6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nice"
				},
				"name": "Nice",
				"salience": 0.004902957,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hht0z7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guy_Fawkes_mask"
				},
				"name": "Guy Fawkes",
				"salience": 0.004902957,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0048415307,
				"type": "PERSON"
			},
			{
				"name": "Anonymous",
				"salience": 0.004731794,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.004540155,
				"type": "OTHER"
			},
			{
				"name": "hacker",
				"salience": 0.004540155,
				"type": "PERSON"
			},
			{
				"name": "Matrix",
				"salience": 0.0042263856,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.004194829,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0040425276,
				"type": "OTHER"
			},
			{
				"name": "fringe lunatics",
				"salience": 0.004026108,
				"type": "PERSON"
			},
			{
				"name": "hackers",
				"salience": 0.004000189,
				"type": "PERSON"
			},
			{
				"name": "fewer",
				"salience": 0.0037880307,
				"type": "OTHER"
			},
			{
				"name": "perspective",
				"salience": 0.0037880307,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0035168193,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0033974405,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0033974405,
				"type": "LOCATION"
			},
			{
				"name": "PHOTO",
				"salience": 0.003280664,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hacks",
				"salience": 0.0031846866,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0031846866,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0031846866,
				"type": "OTHER"
			},
			{
				"name": "hacker",
				"salience": 0.0030659211,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0028618863,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0027740817,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0027740817,
				"type": "LOCATION"
			},
			{
				"name": "warriors",
				"salience": 0.0027474563,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.0026568344,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.002600317,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0025921573,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0025700743,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0025700743,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0025577308,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0025577308,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.002409935,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.002300819,
				"type": "OTHER"
			},
			{
				"name": "advocates",
				"salience": 0.002300819,
				"type": "PERSON"
			},
			{
				"name": "liberties",
				"salience": 0.002300819,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0022149815,
				"type": "OTHER"
			},
			{
				"name": "sorts",
				"salience": 0.0022149815,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0022149815,
				"type": "OTHER"
			},
			{
				"name": "n00b",
				"salience": 0.0022149815,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mind",
				"salience": 0.0022149815,
				"type": "OTHER"
			},
			{
				"name": "fan",
				"salience": 0.0022149815,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.002198428,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.0021692254,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0021692254,
				"type": "OTHER"
			},
			{
				"name": "VALERY HACHE",
				"salience": 0.002071839,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0020527851,
				"type": "OTHER"
			},
			{
				"name": "say",
				"salience": 0.0020527851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dlk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agence_France-Presse"
				},
				"name": "AFP",
				"salience": 0.0020199784,
				"type": "ORGANIZATION"
			},
			{
				"name": "idea",
				"salience": 0.001912323,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0018784927,
				"type": "PERSON"
			},
			{
				"name": "conversation",
				"salience": 0.0018548311,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0017948805,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0016339929,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0016206458,
				"type": "ORGANIZATION"
			},
			{
				"name": "freedom",
				"salience": 0.0016085308,
				"type": "OTHER"
			},
			{
				"name": "Freedom",
				"salience": 0.0016085308,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.0015946472,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0015097322,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0015097322,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0015097322,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0014096849,
				"type": "PERSON"
			},
			{
				"name": "no one",
				"salience": 0.0014033894,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0014033894,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.0014033894,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0013986458,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0013986458,
				"type": "PERSON"
			},
			{
				"name": "impact",
				"salience": 0.0013857086,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0012585408,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.001190126,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0011804025,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0011804025,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0011278464,
				"type": "LOCATION"
			},
			{
				"name": "purpose",
				"salience": 0.0010221354,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0010221354,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0010221354,
				"type": "OTHER"
			},
			{
				"name": "government elites",
				"salience": 0.0010221354,
				"type": "PERSON"
			},
			{
				"name": "censorship",
				"salience": 0.0010221354,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0010221354,
				"type": "ORGANIZATION"
			},
			{
				"name": "society",
				"salience": 0.0010221354,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0010221354,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0010221354,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0010221354,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0009766228,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0008817866,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0008817866,
				"type": "OTHER"
			},
			{
				"name": "spectrum",
				"salience": 0.0007635435,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0007635435,
				"type": "OTHER"
			},
			{
				"name": "ant",
				"salience": 0.0007635435,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.0007635435,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0007635435,
				"type": "OTHER"
			},
			{
				"name": "anthill",
				"salience": 0.0007635435,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "258",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/what-is-anonymous.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": 0
		},
		"shares": "258",
		"site_url": "anonhq.com",
		"spam_score": "0.006",
		"text": "What Anonymous is and what it means really depends on the individual; to one person it means one thing, and to another, something else. Anonymous has even been around long enough, these days, that there is actually a generational gap developing. Protesters wearing Anonymous Guy Fawkes masks take part in a demonstration against controversial Anti-Counterfeiting Trade Agreement (ACTA), on February 25, 2012 in Nice, southeastern France. AFP PHOTO / VALERY HACHE\nThink about it in this perspective: the Matrix is already 17 years old; there is an entire generation which didn’t grow up with it!\nThe oldest members are naturally the most die-hard ‘Anons,’ and the older the member, typically, the better the hacker – there are becoming fewer and fewer of them by the day. For the most part the oldest ‘Anons’ are of the mind that Anonymous should be an exclusive hacker collective – everyone who can’t hack is largely considered a n00b or just a fan of the movement.\nAnons protesting against the government\nThe newest members of Anonymous tend to be social justice warriors of sorts; almost none of them are hackers, but they make up the large majority of people who now call themselves “Anonymous.” They are, for the large part, protestors, civil rights/liberties advocates or people who want to change the world, but are unsure on how to go about it. They seem to be drawn to Anonymous, not because all of the hacks occurring around the world, but because they see Anonymous publicly advocating for many of the same things they believe in.\nThere are a lot of things happening in this world that people do not get to vote on, or simply have no say over; there are a lot of things that tend to control/dictate peoples’ lives, for which they have no control over.\nI remember a conversation last year with a friend in the movement. I was frustrated because all I want is to change and make an impact on the world, but always feel like nothing more than an ant – nothing I seem to do is even measurable in the grand scheme of life.\nThey responded, “Welcome to the anthill.”\nJust as with any group of people in the world, or in politics, there are bound to be some fringe lunatics/extremists on both sides of the spectrum – and Anonymous is no different.\nPeople do not seem to understand that no one in Anonymous speaks for anyone else in Anonymous. Far too often, people in Anonymous are left defending – or accused – for the actions of other people they know nothing about. People also do not seem to understand what it means when some says “Anonymous is an idea, not a group.”\nWhat it means to be part of an “idea” can also differ depending on the purpose. But what I have come to believe this “idea” means is a freedom of expression in its purest form: Freedom from censorship; freedom for ALL knowledge to be free and available to the public/society; freedom for people to stand up and fight for whatever they believe in; freedom for everyone’s voice to matter – not just corporations/politicians/government elites.",
		"thread_title": "What is Anonymous?",
		"title": "What is Anonymous?",
		"type": "bs",
		"uuid": "16f19ffbbfe178bbf72a2a6699a02c147b330a46"
	},
	"-KhIhlsxF-KgEAz6aTrJ": {
		"author": "Marietta Peverelli",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:49:04.980+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "lady",
				"salience": 0.5856824,
				"type": "PERSON"
			},
			{
				"name": "Pipeline",
				"salience": 0.1508623,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.1508623,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.044082444,
				"type": "OTHER"
			},
			{
				"name": "farm",
				"salience": 0.038811352,
				"type": "LOCATION"
			},
			{
				"name": "ladies",
				"salience": 0.012397634,
				"type": "PERSON"
			},
			{
				"name": "righteousness",
				"salience": 0.012222056,
				"type": "OTHER"
			},
			{
				"name": "Common America",
				"salience": 0.005079518,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/cyndycoppola-768x444.jpg",
		"ord_in_thread": "1",
		"participants_count": "3",
		"published": "2016-10-28T21:14:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 1.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.022",
		"text": "Unless this Pipeline in progress arranged with this lady, they are trespassing and she has the right to be n her farm! Where is righteousness?\nCommon America, don’t push little ladies over… Help them!",
		"thread_title": "Woman Arrested On Own Property After Her Land Was Stolen By DAPL",
		"title": "",
		"type": "bs",
		"uuid": "fcd788dc4d96376407f5c8c864bea43c28291a78"
	},
	"-KhIhlxw2KJJP3g9SsB4": {
		"author": "fundamentaly flawed humanity",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:49:05.012+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "unrest",
				"salience": 0.42125013,
				"type": "EVENT"
			},
			{
				"name": "oil",
				"salience": 0.25193217,
				"type": "OTHER"
			},
			{
				"name": "DAPL",
				"salience": 0.18590803,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.14090967,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/cyndycoppola-768x444.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-28T21:42:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.022",
		"text": "time for more civil unrest… fuck DAPL, they deserve to burn in the oil they are trying so desperately to transport across the nation.",
		"thread_title": "Woman Arrested On Own Property After Her Land Was Stolen By DAPL",
		"title": "",
		"type": "bs",
		"uuid": "532af47c1e3f70442344212cd6db500b05308b48"
	},
	"-KhIhm6vjlG7sIeoz1g3": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:49:24.333+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "frontline camp",
				"salience": 0.053230513,
				"type": "LOCATION"
			},
			{
				"name": "path",
				"salience": 0.04883776,
				"type": "OTHER"
			},
			{
				"name": "riot gear",
				"salience": 0.04175092,
				"type": "OTHER"
			},
			{
				"name": "ATVs",
				"salience": 0.04175092,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vehicles",
				"salience": 0.04175092,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "helicopters",
				"salience": 0.04175092,
				"type": "OTHER"
			},
			{
				"name": "humvees",
				"salience": 0.04175092,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.040388003,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.03333164,
				"type": "ORGANIZATION"
			},
			{
				"name": "road",
				"salience": 0.030318048,
				"type": "LOCATION"
			},
			{
				"name": "Cannonball",
				"salience": 0.02977489,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.028663015,
				"type": "PERSON"
			},
			{
				"name": "SSC",
				"salience": 0.025810217,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "ND",
				"salience": 0.025810217,
				"type": "LOCATION"
			},
			{
				"name": "Highway 1806",
				"salience": 0.025810217,
				"type": "LOCATION"
			},
			{
				"name": "Treaty Camp",
				"salience": 0.016897256,
				"type": "EVENT"
			},
			{
				"name": "promises",
				"salience": 0.013350621,
				"type": "OTHER"
			},
			{
				"name": "pipeline",
				"salience": 0.011315889,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.011315889,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0104211895,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.009194876,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.008852356,
				"type": "LOCATION"
			},
			{
				"name": "occupation",
				"salience": 0.008852356,
				"type": "OTHER"
			},
			{
				"name": "blockades",
				"salience": 0.008852356,
				"type": "OTHER"
			},
			{
				"name": "Ft",
				"salience": 0.008852356,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.008852356,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.008852356,
				"type": "LOCATION"
			},
			{
				"name": "reclamation",
				"salience": 0.008852356,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.00820503,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "car",
				"salience": 0.007989369,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Another",
				"salience": 0.0076443297,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.0071704336,
				"type": "OTHER"
			},
			{
				"name": "tipi",
				"salience": 0.0071704336,
				"type": "OTHER"
			},
			{
				"name": "sound cannon",
				"salience": 0.0069031776,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "face",
				"salience": 0.0069031776,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0069031776,
				"type": "OTHER"
			},
			{
				"name": "medic",
				"salience": 0.0068585314,
				"type": "PERSON"
			},
			{
				"name": "tipi",
				"salience": 0.0065622376,
				"type": "OTHER"
			},
			{
				"name": "pipeline",
				"salience": 0.006484185,
				"type": "OTHER"
			},
			{
				"name": "Laramie Treaty",
				"salience": 0.00629596,
				"type": "OTHER"
			},
			{
				"name": "elders",
				"salience": 0.0062102797,
				"type": "PERSON"
			},
			{
				"name": "prayer circle",
				"salience": 0.0062102797,
				"type": "OTHER"
			},
			{
				"name": "rubber bullet",
				"salience": 0.0062102797,
				"type": "OTHER"
			},
			{
				"name": "percussion grenades",
				"salience": 0.005978749,
				"type": "OTHER"
			},
			{
				"name": "pepper spray",
				"salience": 0.005978749,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.005978749,
				"type": "PERSON"
			},
			{
				"name": "shotguns",
				"salience": 0.005978749,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.005978749,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.005978749,
				"type": "OTHER"
			},
			{
				"name": "hook",
				"salience": 0.005978749,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.005855326,
				"type": "OTHER"
			},
			{
				"name": "water protectors",
				"salience": 0.005855326,
				"type": "OTHER"
			},
			{
				"name": "wrist",
				"salience": 0.0057442267,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.005683392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "members",
				"salience": 0.005675887,
				"type": "PERSON"
			},
			{
				"name": "DAPL",
				"salience": 0.0054527195,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock Reservation",
				"salience": 0.0054527195,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fk3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sioux"
				},
				"name": "Dakota",
				"salience": 0.0054527195,
				"type": "LOCATION"
			},
			{
				"name": "officer",
				"salience": 0.005125305,
				"type": "PERSON"
			},
			{
				"name": "owners",
				"salience": 0.0050710156,
				"type": "PERSON"
			},
			{
				"name": "ribbon",
				"salience": 0.0050710156,
				"type": "OTHER"
			},
			{
				"name": "sweat lodge",
				"salience": 0.0050710156,
				"type": "LOCATION"
			},
			{
				"name": "ceremony",
				"salience": 0.0050710156,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.004845429,
				"type": "PERSON"
			},
			{
				"name": "tobacco pipe",
				"salience": 0.004845429,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "member",
				"salience": 0.004845429,
				"type": "PERSON"
			},
			{
				"name": "water protector",
				"salience": 0.0044875983,
				"type": "PERSON"
			},
			{
				"name": "items",
				"salience": 0.0043753036,
				"type": "OTHER"
			},
			{
				"name": "altar item",
				"salience": 0.0043753036,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "addition",
				"salience": 0.0043753036,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.0037890254,
				"type": "OTHER"
			},
			{
				"name": "bean bags",
				"salience": 0.0037890254,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0037890254,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0037890254,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.003710758,
				"type": "ORGANIZATION"
			},
			{
				"name": "International Indigenous Youth Council",
				"salience": 0.0035467297,
				"type": "ORGANIZATION"
			},
			{
				"name": "car",
				"salience": 0.0035297934,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "car",
				"salience": 0.0035297934,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "police",
				"salience": 0.0035297934,
				"type": "PERSON"
			},
			{
				"name": "driver side",
				"salience": 0.0027599994,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0027599994,
				"type": "PERSON"
			},
			{
				"name": "motion",
				"salience": 0.0027599994,
				"type": "OTHER"
			},
			{
				"name": "batons",
				"salience": 0.0027599994,
				"type": "OTHER"
			},
			{
				"name": "front line",
				"salience": 0.0027599994,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.002623533,
				"type": "PERSON"
			},
			{
				"name": "medics",
				"salience": 0.0024264622,
				"type": "PERSON"
			},
			{
				"name": "youth council",
				"salience": 0.002381129,
				"type": "ORGANIZATION"
			},
			{
				"name": "arrest",
				"salience": 0.002381129,
				"type": "EVENT"
			},
			{
				"name": "mass-arrest",
				"salience": 0.002381129,
				"type": "EVENT"
			},
			{
				"name": "wrist",
				"salience": 0.002381129,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.002061907,
				"type": "OTHER"
			},
			{
				"name": "canupa",
				"salience": 0.0016000348,
				"type": "OTHER"
			},
			{
				"name": "IIYC",
				"salience": 0.0014656449,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/sacred-stone-1-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.062",
		"text": "( SSC ) Cannonball, ND — Over 300 police officers in riot gear, 8 ATVs, 5 armored vehicles, 2 helicopters, and numerous military-grade humvees showed up north of the newly formed frontline camp just east of Highway 1806. The 1851 Treaty Camp was set up this past Sunday directly in the path of the pipeline, on land recently purchased by DAPL. Today this camp, a reclamation of unceded Dakota territory affirmed as part of the Standing Rock Reservation in the Ft. Laramie Treaty of 1851, was violently cleared. Both blockades established this past weekend to enable that occupation were also cleared. In addition to pepper spray and percussion grenades, shotguns were fired into the crowd with less lethal ammunition and a sound cannon was used (see images below). At least one person was tased and the barbed hook lodged in his face, just outside his eye. Another was hit in the face by a rubber bullet.\nA prayer circle of elders, including several women, was interrupted and all were arrested for standing peacefully on the public road. A tipi was erected in the road and was recklessly dismantled, despite promises from law enforcement that they would merely mark the tipi with a yellow ribbon and ask its owners to retrieve it. A group of water protectors was also dragged out of a ceremony in a sweat lodge erected in the path of the pipeline, wearing minimal clothing, thrown to the ground, and arrested.\nA member of the International Indigenous Youth Council (IIYC) that had her wrist broken during a mass-arrest on October 22nd was hurt again after an officer gripped her visibly injured wrist and twisted it during an attempted arrest. At least six other members of the youth council verified that they had been maced up to five times and were also shot and hit with bean bags. In addition to being assaulted, an altar item and sacred staff was wrenched from the hands of an IIYC member by police. Several other sacred items were reported stolen, including a canupa (sacred tobacco pipe).\nTwo medics giving aid at front line were hit with batons and thrown off the car they were sitting on. Then police grabbed another medic, who was driving the car, out of the driver side while it was still in motion. Another water protector had to jump into the car to stop it from hitting other people.",
		"thread_title": "Uncensored Truth: Here’s What Really Happened at #NoDAPL Protests Yesterday",
		"title": "Uncensored Truth: Here’s What Really Happened at #NoDAPL Protests Yesterday",
		"type": "bs",
		"uuid": "b1e3a60481cf435f8082cfbf0aa16c02acef9b21"
	},
	"-KhIhmFNlaHui0maqCVc": {
		"author": "EV",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:49:54.027+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "dog-handlers",
				"salience": 0.23508857,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.09288916,
				"type": "EVENT"
			},
			{
				"name": "Frost Kennel",
				"salience": 0.085252985,
				"type": "LOCATION"
			},
			{
				"name": "workers",
				"salience": 0.070945196,
				"type": "PERSON"
			},
			{
				"name": "Morton County Sheriff's Department",
				"salience": 0.06205598,
				"type": "ORGANIZATION"
			},
			{
				"name": "security company",
				"salience": 0.04699114,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "State of North Dakota",
				"salience": 0.044354178,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.044145275,
				"type": "OTHER"
			},
			{
				"name": "Ashley Nicole Welch",
				"salience": 0.041110843,
				"type": "PERSON"
			},
			{
				"name": "DAPL",
				"salience": 0.02584659,
				"type": "ORGANIZATION"
			},
			{
				"name": "land protectors",
				"salience": 0.021031758,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "State of Ohio",
				"salience": 0.020182552,
				"type": "LOCATION"
			},
			{
				"name": "guard dogs",
				"salience": 0.017408237,
				"type": "OTHER"
			},
			{
				"name": "Frost Kennel",
				"salience": 0.016496532,
				"type": "ORGANIZATION"
			},
			{
				"name": "outcry",
				"salience": 0.015084776,
				"type": "OTHER"
			},
			{
				"name": "film crew",
				"salience": 0.015084776,
				"type": "PERSON"
			},
			{
				"name": "journalist",
				"salience": 0.014524151,
				"type": "PERSON"
			},
			{
				"name": "Protesters",
				"salience": 0.014225238,
				"type": "PERSON"
			},
			{
				"name": "Dogs",
				"salience": 0.014225238,
				"type": "OTHER"
			},
			{
				"name": "investigators",
				"salience": 0.011693802,
				"type": "PERSON"
			},
			{
				"name": "social media",
				"salience": 0.009215234,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.009215234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020m38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amy_Goodman"
				},
				"name": "Amy Goodman",
				"salience": 0.008954286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020sgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy_Now!"
				},
				"name": "Democracy Now",
				"salience": 0.008954286,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02zxgs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grand_Forks_Herald"
				},
				"name": "Grand Forks Herald",
				"salience": 0.0075962585,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/014p13",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pepper_spray"
				},
				"name": "Pepper Spray",
				"salience": 0.0075962585,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.0075962585,
				"type": "PERSON"
			},
			{
				"name": "Dakota Access Pipeline Company Attacks",
				"salience": 0.0075962585,
				"type": "EVENT"
			},
			{
				"name": "Source",
				"salience": 0.0067161787,
				"type": "OTHER"
			},
			{
				"name": "security company",
				"salience": 0.0064176316,
				"type": "ORGANIZATION"
			},
			{
				"name": "Frost Kennels",
				"salience": 0.0042780167,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0041364525,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rcnp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silverton,_Colorado"
				},
				"name": "Silverton",
				"salience": 0.0030906717,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/0b5bebmedyj9vnmrszjhtn0g2ddg.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.077",
		"text": "An investigation conducted by the Morton County Sheriff’s Department has concluded that the Frost Kennel dog-handlers hired by the DAPL, were not properly licensed to handle security in the State of North Dakota, nor are they a registered security company in the State of Ohio. On Sept. 3, Democracy Now journalist, Amy Goodman, and film crew captured Frost Kennel workers attacking land protectors with guard dogs, sparking a national outcry.\nDakota Access Pipeline Company Attacks Native American Protesters with Dogs & Pepper Spray:\nAccording to North Dakota’s Grand Forks Herald , Frost Kennels, who was working under a private security company called Silverton, refused to cooperate with investigators, and as a result, they were supposedly only able to identify the Frost Kennel workers exposed in social media . This includes Ashley Nicole Welch, who was the main aggressor.\nAshley Nicole Welch. Source: Facebook",
		"thread_title": "DAPL Guards Who Attacked Natives with Dogs Were Not Licensed to Work Security",
		"title": "DAPL Guards Who Attacked Natives with Dogs Were Not Licensed to Work Security",
		"type": "bs",
		"uuid": "759e07b54516bdba8f03c53059f867d2b0456c4d"
	},
	"-KhIhmM5iEuFXEp6pGuz": {
		"author": "starmount",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:53:33.960+03:00",
		"domain_rank": "12993",
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/dillary-trumplon.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-28T21:20:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.5,
			"score": 0.5
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "cool and true",
		"thread_title": "‘Dillary Trumplon’: This Guy’s Epic Rap Song Just Destroyed Trump AND Hillary",
		"title": "",
		"type": "bs",
		"uuid": "46774798af563080040f2d7be12def63d012f219"
	},
	"-KhIhmYQ3rQLGxhN1Z1G": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:53:57.015+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.28081703,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.07171573,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.061765738,
				"type": "PERSON"
			},
			{
				"name": "integrity",
				"salience": 0.047851417,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.034749556,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cheerleading squad",
				"salience": 0.034749556,
				"type": "ORGANIZATION"
			},
			{
				"name": "release",
				"salience": 0.034749556,
				"type": "EVENT"
			},
			{
				"name": "iteration",
				"salience": 0.034749556,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.032555405,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07s0vkx"
				},
				"name": "Intercept",
				"salience": 0.024948202,
				"type": "OTHER"
			},
			{
				"name": "Claire Bernish",
				"salience": 0.023187904,
				"type": "PERSON"
			},
			{
				"name": "thefreethoughtproject.com Revelations",
				"salience": 0.021503568,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.021503568,
				"type": "PERSON"
			},
			{
				"name": "Thanks",
				"salience": 0.017865742,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.012570143,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/069dd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quotation"
				},
				"name": "Quote",
				"salience": 0.011278167,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.008825639,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.008401325,
				"type": "ORGANIZATION"
			},
			{
				"name": "list",
				"salience": 0.008066521,
				"type": "OTHER"
			},
			{
				"name": "court journalists",
				"salience": 0.0077738506,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.007708337,
				"type": "WORK_OF_ART"
			},
			{
				"name": "outlets",
				"salience": 0.007383148,
				"type": "OTHER"
			},
			{
				"name": "drivel",
				"salience": 0.007383148,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.007383148,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.007383148,
				"type": "PERSON"
			},
			{
				"name": "campaign coverage",
				"salience": 0.007383148,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.007383148,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.007383148,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0072091254,
				"type": "EVENT"
			},
			{
				"name": "stories",
				"salience": 0.00716748,
				"type": "WORK_OF_ART"
			},
			{
				"name": "documents",
				"salience": 0.0063761007,
				"type": "OTHER"
			},
			{
				"name": "component",
				"salience": 0.0060571753,
				"type": "OTHER"
			},
			{
				"name": "campaign strategy",
				"salience": 0.005981005,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.005853932,
				"type": "WORK_OF_ART"
			},
			{
				"name": "story",
				"salience": 0.0054258322,
				"type": "OTHER"
			},
			{
				"name": "strategy document",
				"salience": 0.005408825,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign staff",
				"salience": 0.0053132684,
				"type": "PERSON"
			},
			{
				"name": "light",
				"salience": 0.004987371,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.004987371,
				"type": "OTHER"
			},
			{
				"name": "campaign tactics",
				"salience": 0.004987371,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.004987371,
				"type": "PERSON"
			},
			{
				"name": "journalism",
				"salience": 0.0049294517,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.0049294517,
				"type": "PERSON"
			},
			{
				"name": "background",
				"salience": 0.0042303973,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.0042303973,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.003161177,
				"type": "WORK_OF_ART"
			},
			{
				"name": "agreement",
				"salience": 0.003161177,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.003161177,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0clb0v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Greenwald"
				},
				"name": "Glenn Greenwald",
				"salience": 0.0030715095,
				"type": "PERSON"
			},
			{
				"name": "Guccifer 2.0",
				"salience": 0.0030715095,
				"type": "OTHER"
			},
			{
				"name": "Lee Fang",
				"salience": 0.0030715095,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0029714133,
				"type": "EVENT"
			},
			{
				"name": "journalist plant",
				"salience": 0.0029671178,
				"type": "LOCATION"
			},
			{
				"name": "practice",
				"salience": 0.0026139691,
				"type": "OTHER"
			},
			{
				"name": "goals",
				"salience": 0.0023028117,
				"type": "OTHER"
			},
			{
				"name": "shaping",
				"salience": 0.0023028117,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0023028117,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0023028117,
				"type": "OTHER"
			},
			{
				"name": "completion",
				"salience": 0.0019867478,
				"type": "EVENT"
			},
			{
				"name": "Maggie Haberman",
				"salience": 0.0018267288,
				"type": "PERSON"
			},
			{
				"name": "news pieces",
				"salience": 0.0017204325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "oblique insult",
				"salience": 0.0017204325,
				"type": "OTHER"
			},
			{
				"name": "fundamentals",
				"salience": 0.0017204325,
				"type": "OTHER"
			},
			{
				"name": "Placing a Story",
				"salience": 0.001423952,
				"type": "EVENT"
			},
			{
				"name": "Earned Media/Next Steps",
				"salience": 0.0010589855,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/clinton-wikileaks-media.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "By Claire Bernish at thefreethoughtproject.com\nRevelations from the Wikileaks release of John Podesta’s emails yet again prove mainstream, corporate media serves as Hillary Clinton’s personal cheerleading squad — and is devoid of any iteration of journalistic integrity.\nThanks to Wikileaks and the Intercept , in fact, we now have a list of no less than 65 mainstream “reporters” whose campaign coverage constitutes propaganda for the Clinton campaign — and no wonder, considering the obscenely lopsided drivel presented by their outlets.\nAs (actual) journalists Glenn Greenwald and Lee Fang reported on October 9, the Intercept exclusively received documents obtained by the source known as Guccifer 2.0 evidencing Clinton campaign tactics to court journalists portraying the former secretary of state in a positive light.\n“As these internal documents demonstrate,” the Intercept reported , “a central component of the Clinton campaign strategy is ensuring that journalists they believe are favorable to Clinton are tasked to report the stories the campaign wants circulated.\n“At times, Clinton’s campaign staff not only internally drafted the stories they wanted published but even specified what should be Quote: d ‘on background’ and what should be described as ‘on the record.’”\nOne internal strategy document dated January 2015 — months before Clinton officially kicked off her campaign in April — with the curious heading “Earned Media/Next Steps” exposes how the campaign made an albeit infrequent practice of crafting supposed news pieces from beginning to completion.\nUnder the — not-at-all oblique insult to the fundamentals of journalism — heading “ Placing a Story ,” the memo’s Quote: :\n“As we discussed on our call, we are all in agreement that the time is right [to] place a story with a friendly journalist in the coming days that positions us a little more transparently while achieving the above goals.”\nSpecifically named as a suggested journalist plant is Maggie Haberman of Politico , whom they note will assist in doing “the most shaping” of the narrative they have in mind.",
		"thread_title": "WikiLeaks List Exposes At Least 65 Corporate ‘Presstitutes’ Who Colluded to Hide Clinton’s Crimes",
		"title": "WikiLeaks List Exposes At Least 65 Corporate ‘Presstitutes’ Who Colluded to Hide Clinton’s Crimes",
		"type": "bs",
		"uuid": "afdc2d51e91f90d4f94e4dfb9d11efb41412742f"
	},
	"-KhIhmsRLN-_6Y3buhSB": {
		"author": "Mick",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:53:57.932+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "whopper",
				"salience": 0.30152917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06_wyyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Family_of_Barack_Obama"
				},
				"name": "Obamas",
				"salience": 0.19382237,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.13273038,
				"type": "WORK_OF_ART"
			},
			{
				"name": "transparency",
				"salience": 0.104574025,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cl8jz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jonathan_Gruber_(economist)"
				},
				"name": "Jonathan Gruber",
				"salience": 0.10434054,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.09101607,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "ACA",
				"salience": 0.03002831,
				"type": "ORGANIZATION"
			},
			{
				"name": "transparency",
				"salience": 0.02442828,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.01753084,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/clinton-obama.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-28T20:35:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "There’s another whopper in Obamas lie about hillarys email, he says the administration strives for transparency. Not true Jonathan Gruber , ACA architect was recorded admitting specifically that transparency is a liability so the ACA was written to be long and convoluted.",
		"thread_title": "BREAKING: Irrefutable Proof Obama Lied to Protect Hillary Clinton’s Run for the White House Read",
		"title": "",
		"type": "bs",
		"uuid": "2970a1ec7d56e6ed706d57cafc30d1a3898a113a"
	},
	"-KhIhnD8HOLg-5bHVMaZ": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:54:15.244+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al Assad",
				"salience": 0.13501634,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.089323565,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0835362,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.08066079,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.07110105,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.050034773,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.050034773,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/031zs3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Levonorgestrel"
				},
				"name": "Plan B",
				"salience": 0.03465237,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.030209903,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.025293807,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.02078329,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.02078329,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.02078329,
				"type": "OTHER"
			},
			{
				"name": "artillery",
				"salience": 0.018784083,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.016285772,
				"type": "OTHER"
			},
			{
				"name": "whomever",
				"salience": 0.016285772,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.016285772,
				"type": "OTHER"
			},
			{
				"name": "Claire Bernish",
				"salience": 0.014492263,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07qkqyv"
				},
				"name": "Rebels",
				"salience": 0.01239084,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.010054569,
				"type": "LOCATION"
			},
			{
				"name": "thefreethoughtproject.com",
				"salience": 0.010054569,
				"type": "OTHER"
			},
			{
				"name": "defectors",
				"salience": 0.009107919,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.008993638,
				"type": "OTHER"
			},
			{
				"name": "defectors",
				"salience": 0.008769338,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0066410196,
				"type": "OTHER"
			},
			{
				"name": "state of affairs",
				"salience": 0.004705322,
				"type": "ORGANIZATION"
			},
			{
				"name": "Skepticism",
				"salience": 0.004078059,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0037665728,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.0036261748,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.003443694,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.003443694,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.003443694,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ally",
				"salience": 0.003443694,
				"type": "OTHER"
			},
			{
				"name": "proxy war",
				"salience": 0.0034155936,
				"type": "EVENT"
			},
			{
				"name": "State",
				"salience": 0.0033429752,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0032468718,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.00321834,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.0031874906,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.0029734587,
				"type": "OTHER"
			},
			{
				"name": "restriction",
				"salience": 0.0027890159,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0027890159,
				"type": "ORGANIZATION"
			},
			{
				"name": "restrictions",
				"salience": 0.0027890159,
				"type": "OTHER"
			},
			{
				"name": "goals",
				"salience": 0.00252195,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00252195,
				"type": "OTHER"
			},
			{
				"name": "anti-Assad",
				"salience": 0.002448704,
				"type": "ORGANIZATION"
			},
			{
				"name": "ideologies",
				"salience": 0.0024153632,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0024153632,
				"type": "OTHER"
			},
			{
				"name": "air attack",
				"salience": 0.0024153632,
				"type": "EVENT"
			},
			{
				"name": "issues",
				"salience": 0.0024153632,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0023252699,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.0022982429,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0022772448,
				"type": "PERSON"
			},
			{
				"name": "terrorist group",
				"salience": 0.0021646908,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.002107138,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.0020396009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04kch_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ash_Carter"
				},
				"name": "Ashton Carter",
				"salience": 0.00200154,
				"type": "PERSON"
			},
			{
				"name": "moderates",
				"salience": 0.0019720849,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0019720849,
				"type": "LOCATION"
			},
			{
				"name": "radicalize",
				"salience": 0.0019720849,
				"type": "OTHER"
			},
			{
				"name": "compromise",
				"salience": 0.0019720849,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0019635092,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0018843206,
				"type": "PERSON"
			},
			{
				"name": "units",
				"salience": 0.0017451139,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0017172231,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0017014296,
				"type": "EVENT"
			},
			{
				"name": "skeptics",
				"salience": 0.0017014296,
				"type": "PERSON"
			},
			{
				"name": "proxy battle",
				"salience": 0.0017014296,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0h3xpcx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Free_Syrian_Army"
				},
				"name": "Free Syrian Army",
				"salience": 0.0016605158,
				"type": "ORGANIZATION"
			},
			{
				"name": "program",
				"salience": 0.0015828945,
				"type": "OTHER"
			},
			{
				"name": "government forces",
				"salience": 0.0015500095,
				"type": "ORGANIZATION"
			},
			{
				"name": "official",
				"salience": 0.001519044,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0014733719,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0014183889,
				"type": "OTHER"
			},
			{
				"name": "artillery",
				"salience": 0.0013890804,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0013725396,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0013725396,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0012507231,
				"type": "PERSON"
			},
			{
				"name": "battlefield",
				"salience": 0.0012392895,
				"type": "LOCATION"
			},
			{
				"name": "units",
				"salience": 0.0012392895,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0012140317,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime change",
				"salience": 0.0010731417,
				"type": "EVENT"
			},
			{
				"name": "extremists",
				"salience": 0.0010731417,
				"type": "PERSON"
			},
			{
				"name": "adversary",
				"salience": 0.0010731417,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.001025362,
				"type": "PERSON"
			},
			{
				"name": "goal",
				"salience": 0.001025362,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00094533915,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026ms60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_O._Brennan"
				},
				"name": "John Brennan",
				"salience": 0.0008451958,
				"type": "PERSON"
			},
			{
				"name": "proponents",
				"salience": 0.0008016638,
				"type": "PERSON"
			},
			{
				"name": "favor",
				"salience": 0.0008016638,
				"type": "OTHER"
			},
			{
				"name": "repercussions",
				"salience": 0.0008016638,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0008016638,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.0007186943,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "856",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/obama-rebels.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.3,
			"score": 0
		},
		"shares": "856",
		"site_url": "anonhq.com",
		"spam_score": "0.59",
		"text": "By Claire Bernish at thefreethoughtproject.com\nPresident Obama contemplated arming the already controversial ‘moderate’ Syrian rebels weapons to “defend themselves against Russian aircraft and artillery” as his Plan B for Syria when all else failed in the effort to oust Assad — but although this treacherous plan has been effectively shelved, it remains an option for whomever next ascends to the White House.\nAccording to a new report from the Washington Post , Obama’s Plan B has neither been “approved or rejected” in the U.S.’ disintegrating and increasingly complex campaign to depose Syrian President Bashar al Assad — which has, of course, precipitated a perilous proxy war with staunch Syrian ally, Russia.\nSkepticism over allowing the CIA to provide various anti-Assad terrorists — euphemistically termed moderate rebels by the U.S. — with “truck-mounted antiaircraft weapons that could help rebel units but would be difficult for a terrorist group to conceal and use against civilian aircraft” apparently forced the plan to be tabled, the Post reports.\nIn the U.S. program to topple Assad, the CIA has armed and trained defectors from Syrian military known as the Free Syrian Army — whose own defectors went on to form the Islamic State — as well as other terroristic groups virtually indistinguishable from one another except for their political ideologies.\nThese issues factored into restrictions on weapons the U.S. would provide to their sponsored rebels; but, as the Post explains:\n“Rebels chafed at the restriction, complaining that it left them vulnerable to air attack by Assad and, more recently, Russia.”\nPlan B was envisaged as a compromise by the CIA.\nBut the complex state of affairs in Syria has led not only the FSA, but other ‘moderates,’ to ‘radicalize’ — complicating U.S.’ goals and frustrating Russian efforts to purge the embattled nation of terrorists. While the Pentagon’s public goal has duly sought to wrest control from Assad and fight the Islamic State, the CIA program of arming rebels is widely considered counterproductive — if not, perhaps, nefarious.\nPlan B, despite potentially devastating repercussions, retains stolid support from top officials, including unsurprisingly CIA Director John Brennan and Secretary of Defense Ashton Carter — but has lost favor recently with former proponents, including Secretary of State John Kerry.\nKerry and other skeptics rightly grasp providing heavy artillery to rebels fighting Russia-backed Syrian government forces to down Russian aircraft — which would undoubtedly turn the smoldering U.S. proxy battle into an all-out war with Russia.\nAdditionally, the Post reports, a growing number of U.S. officials feel the contentious CIA program has only proven to bedevil the ultimate goal of regime change, and, as one unnamed ‘senior official’ noted, CIA units are “not doing any better on the battlefield, they’re up against a more formidable adversary, and they’re increasingly dominated by extremists,” adding, “What has this program become, and how will history record this effort?”",
		"thread_title": "‘Plan-B’ — Obama Paves Way to Give Syrian ‘Moderate Rebels’ Anti-Aircraft Weapons to Fight Russia",
		"title": "‘Plan-B’ — Obama Paves Way to Give Syrian ‘Moderate Rebels’ Anti-Aircraft Weapons to Fight Russia",
		"type": "bs",
		"uuid": "fef7abd5fa9fffabffa5792adb618e0a1537a3f0"
	},
	"-KhIhna9Nuv2yWZKWIrD": {
		"author": "teeling",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:55:26.169+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "profit",
				"salience": 0.3740928,
				"type": "OTHER"
			},
			{
				"name": "Rhotcilds",
				"salience": 0.20649566,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.13401051,
				"type": "OTHER"
			},
			{
				"name": "shit",
				"salience": 0.13401051,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.092160374,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.05923017,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/France-largest-Army-in-the-world-1000x600.jpg",
		"ord_in_thread": "4",
		"participants_count": "6",
		"published": "2016-10-28T14:07:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.966",
		"text": "This is the Rhotcilds at work stirring shit starting wars to make a profit it is what they do best never mind all the people that have to die .",
		"thread_title": "NATO, US, & UK To Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"title": "",
		"type": "bs",
		"uuid": "1f4e4b045d82f3bc3abb140b331cec0f86dde70c"
	},
	"-KhIhngb2ANwdADm2EHx": {
		"author": "Kevin",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:55:26.706+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.63765365,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.36234635,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/France-largest-Army-in-the-world-1000x600.jpg",
		"ord_in_thread": "5",
		"participants_count": "6",
		"published": "2016-10-29T00:59:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.966",
		"text": "fuck the US government",
		"thread_title": "NATO, US, & UK To Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"title": "",
		"type": "bs",
		"uuid": "1b3083d7b372ef66428587ddd8d66ac8c590d628"
	},
	"-KhIhnlBbsC3U_QA1YDq": {
		"author": "fundamentaly flawed humanity",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:56:43.256+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "anyone",
				"salience": 0.37981847,
				"type": "PERSON"
			},
			{
				"name": "insert",
				"salience": 0.16613416,
				"type": "OTHER"
			},
			{
				"name": "vaginas",
				"salience": 0.14878818,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.08290887,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.072087646,
				"type": "PERSON"
			},
			{
				"name": "rapists dick",
				"salience": 0.049377494,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.04204291,
				"type": "OTHER"
			},
			{
				"name": "creep",
				"salience": 0.041524958,
				"type": "PERSON"
			},
			{
				"name": "breasts",
				"salience": 0.017317293,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Houghton-arrest-KUTV.jpg",
		"ord_in_thread": "3",
		"participants_count": "4",
		"published": "2016-10-28T21:46:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "anyone heard of the protective insert for women’s vaginas that impales any rapists dick if he were to try to rape her, women need something like this for their breasts, some creep tries to grope you, he gets impaled horribly.",
		"thread_title": "Crash Victim Calls Police for Help - Gets Arrested and Sexually Assaulted Instead",
		"title": "",
		"type": "bs",
		"uuid": "37ffbe8e05fbc25e235d334845205c6dc72d82ee"
	},
	"-KhIhnpXqmSBhljQJOtX": {
		"author": "fundamentaly flawed humanity",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:58:49.171+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "anyone",
				"salience": 0.59018046,
				"type": "PERSON"
			},
			{
				"name": "answer",
				"salience": 0.40981954,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-2-33-e1476964480261.jpg",
		"ord_in_thread": "3",
		"participants_count": "4",
		"published": "2016-10-28T22:17:00.000+03:00",
		"replies_count": "3",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.002",
		"text": "what about in the winter?? anyone got an answer for me",
		"thread_title": "Cheap Wind-Powered Device Produces 11 Gallons of Clean Drinking Water Per Day from the Air",
		"title": "",
		"type": "bs",
		"uuid": "b2136bc6a565e6777a5bd39e47b95de7ae8cb586"
	},
	"-KhIho1sYAlD-_24b4iK": {
		"author": "Amando Flavio",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T01:59:18.808+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09fgtl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clenbuterol"
				},
				"name": "Clenbuterol",
				"salience": 0.41292682,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059yj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Football_League"
				},
				"name": "National Football League",
				"salience": 0.11046955,
				"type": "ORGANIZATION"
			},
			{
				"name": "players",
				"salience": 0.0669547,
				"type": "PERSON"
			},
			{
				"name": "beef",
				"salience": 0.025708508,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.025495904,
				"type": "LOCATION"
			},
			{
				"name": "players",
				"salience": 0.022118464,
				"type": "PERSON"
			},
			{
				"name": "warning",
				"salience": 0.020165524,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.020165524,
				"type": "OTHER"
			},
			{
				"name": "drug tests",
				"salience": 0.019520866,
				"type": "OTHER"
			},
			{
				"name": "Clenbuterol",
				"salience": 0.018813092,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.014266716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.014086824,
				"type": "LOCATION"
			},
			{
				"name": "substance",
				"salience": 0.013929965,
				"type": "OTHER"
			},
			{
				"name": "muscle-building",
				"salience": 0.009558278,
				"type": "LOCATION"
			},
			{
				"name": "players",
				"salience": 0.00917234,
				"type": "PERSON"
			},
			{
				"name": "player",
				"salience": 0.00917234,
				"type": "PERSON"
			},
			{
				"name": "levels",
				"salience": 0.009014021,
				"type": "OTHER"
			},
			{
				"name": "players",
				"salience": 0.008342681,
				"type": "PERSON"
			},
			{
				"name": "drug test",
				"salience": 0.008087642,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03m4w91",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Duane_Brown"
				},
				"name": "Duane Brown",
				"salience": 0.0072267326,
				"type": "PERSON"
			},
			{
				"name": "muscle",
				"salience": 0.0069145346,
				"type": "OTHER"
			},
			{
				"name": "farmers",
				"salience": 0.005829029,
				"type": "PERSON"
			},
			{
				"name": "memo",
				"salience": 0.0056702457,
				"type": "WORK_OF_ART"
			},
			{
				"name": "drug",
				"salience": 0.0054664365,
				"type": "OTHER"
			},
			{
				"name": "drug tests",
				"salience": 0.0054664365,
				"type": "OTHER"
			},
			{
				"name": "beef",
				"salience": 0.0054664365,
				"type": "OTHER"
			},
			{
				"name": "beef",
				"salience": 0.004756441,
				"type": "OTHER"
			},
			{
				"name": "players",
				"salience": 0.004577665,
				"type": "PERSON"
			},
			{
				"name": "ability",
				"salience": 0.0043382575,
				"type": "OTHER"
			},
			{
				"name": "matches",
				"salience": 0.0042764205,
				"type": "EVENT"
			},
			{
				"name": "players",
				"salience": 0.003883273,
				"type": "PERSON"
			},
			{
				"name": "weight-loss stimulant",
				"salience": 0.0037040506,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0037040506,
				"type": "OTHER"
			},
			{
				"name": "performance",
				"salience": 0.0037040506,
				"type": "OTHER"
			},
			{
				"name": "players",
				"salience": 0.0035539821,
				"type": "PERSON"
			},
			{
				"name": "Players",
				"salience": 0.0033994035,
				"type": "PERSON"
			},
			{
				"name": "cattle",
				"salience": 0.0031984518,
				"type": "OTHER"
			},
			{
				"name": "Clenbuterol test",
				"salience": 0.0031324383,
				"type": "OTHER"
			},
			{
				"name": "beef",
				"salience": 0.0031324383,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.003000122,
				"type": "LOCATION"
			},
			{
				"name": "substance",
				"salience": 0.003000122,
				"type": "OTHER"
			},
			{
				"name": "farmers",
				"salience": 0.003000122,
				"type": "PERSON"
			},
			{
				"name": "memo",
				"salience": 0.002936338,
				"type": "WORK_OF_ART"
			},
			{
				"name": "league",
				"salience": 0.002712932,
				"type": "OTHER"
			},
			{
				"name": "cattle ranchers",
				"salience": 0.0025983085,
				"type": "PERSON"
			},
			{
				"name": "cattle industry",
				"salience": 0.0025983085,
				"type": "OTHER"
			},
			{
				"name": "growth enhancer",
				"salience": 0.0025983085,
				"type": "OTHER"
			},
			{
				"name": "regulation",
				"salience": 0.0025983085,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.0025983085,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.0025014195,
				"type": "OTHER"
			},
			{
				"name": "profits",
				"salience": 0.0025014195,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0024497707,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0024497707,
				"type": "OTHER"
			},
			{
				"name": "beef",
				"salience": 0.0023407943,
				"type": "OTHER"
			},
			{
				"name": "quantities",
				"salience": 0.0021215726,
				"type": "OTHER"
			},
			{
				"name": "drug-testing administrator",
				"salience": 0.0016888609,
				"type": "PERSON"
			},
			{
				"name": "Free Thought Project",
				"salience": 0.0015998684,
				"type": "WORK_OF_ART"
			},
			{
				"name": "memo",
				"salience": 0.0015983931,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sources",
				"salience": 0.0015851553,
				"type": "PERSON"
			},
			{
				"name": "trip",
				"salience": 0.0015851553,
				"type": "EVENT"
			},
			{
				"name": "process",
				"salience": 0.0015851553,
				"type": "OTHER"
			},
			{
				"name": "Players",
				"salience": 0.0015797989,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0014322968,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0013333524,
				"type": "OTHER"
			},
			{
				"name": "ban",
				"salience": 0.0011546179,
				"type": "OTHER"
			},
			{
				"name": "disappointment",
				"salience": 0.0011546179,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.0010387122,
				"type": "WORK_OF_ART"
			},
			{
				"name": "risk",
				"salience": 0.0009961086,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0009961086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03lsq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houston_Texans"
				},
				"name": "Texan",
				"salience": 0.0009758061,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.0009758061,
				"type": "LOCATION"
			},
			{
				"name": "caution",
				"salience": 0.00091901515,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.00086255785,
				"type": "OTHER"
			},
			{
				"name": "meat",
				"salience": 0.00086255785,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b1smw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patrick_Peterson"
				},
				"name": "Patrick Peterson",
				"salience": 0.0007107007,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ws7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona_Cardinals"
				},
				"name": "Arizona Cardinals",
				"salience": 0.0007107007,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0007107007,
				"type": "OTHER"
			},
			{
				"name": "GottaGoVeganOnVacation 🤕 pic.twitter.com/HmWNpi4cAj",
				"salience": 0.0007107007,
				"type": "OTHER"
			},
			{
				"name": "#SMH",
				"salience": 0.0007107007,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kc6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ESPN"
				},
				"name": "ESPN",
				"salience": 0.00065862964,
				"type": "ORGANIZATION"
			},
			{
				"name": "defensive back",
				"salience": 0.00048746483,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "967",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-3-47-e1477598316636.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.5,
			"score": -0.3
		},
		"shares": "967",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "The National Football League (NFL) in the United States has issued a warning to players , asking them to avoid eating beef because of the high levels of Clenbuterol . These high levels have been said to cause players to fail drug tests. Clenbuterol is a muscle-building and weight-loss stimulant. It is a substance banned by the league, and considered a performance enhancing drug. However, recently, many players in the NFL have failed drug tests linked to Clenbuterol. If a player fails this drug test then he is banned for 10 matches.\nThe majority of beef consumed in the United States is imported from China and Mexico. The NFL said beef from China and Mexico is particularly dangerous to the players.\nClenbuterol has the ability to build muscle, which is why farmers use it, increasing the size of their cattle to increase profits. In Mexico, cattle ranchers are banned from using Clenbuterol as a growth enhancer. However, it is said farmers are not complying with the regulation, leading to widespread abuse of the substance within the nation’s cattle industry.\nThe Free Thought Project reports that the NFL’s independent drug-testing administrator has officially sent a memo to all players in the league, telling them that consuming large quantities of beef while visiting China and Mexico may result in a positive Clenbuterol test. The memo further stated that if players refused to heed the warning and do otherwise, they do so at their own risk.\n“Players are warned to be aware of this issue when traveling to Mexico and China. Please take caution if you decide to consume meat, and understand that you do so at your own risk. Players are responsible for what is in their bodies,” the memo said.\nIn 2015, the Texan’s left tackle, Duane Brown, tested positive for Clenbuterol after a trip to Mexico, during which he ate Mexican beef, sources told ESPN . After a months-long process, Brown was finally cleared in April this year, permitting him to avoid what would have been a 10-match ban.\nWhen the memo was issued, several players in the NFL, including the Arizona Cardinals defensive back, Patrick Peterson, took to Twitter to express his disappointment in the issue.\nThis can’t be real life! #SMH #GottaGoVeganOnVacation 🤕 pic.twitter.com/HmWNpi4cAj",
		"thread_title": "NFL Warns Clenbuterol Level So High in Beef that Players Fail Drug Tests",
		"title": "NFL Warns Clenbuterol Level So High in Beef that Players Fail Drug Tests",
		"type": "bs",
		"uuid": "1dbf6c2650ba9b7c43b9abb5eae95ad107209380"
	},
	"-KhIhoDEOLbdGt5vFCiL": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:24:38.995+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "pipeline",
				"salience": 0.14654851,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.13048777,
				"type": "OTHER"
			},
			{
				"name": "pipeline",
				"salience": 0.11704673,
				"type": "OTHER"
			},
			{
				"name": "stand",
				"salience": 0.037731517,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.034896087,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.030953908,
				"type": "LOCATION"
			},
			{
				"name": "site",
				"salience": 0.023182431,
				"type": "LOCATION"
			},
			{
				"name": "news narrative",
				"salience": 0.023182431,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.019480666,
				"type": "LOCATION"
			},
			{
				"name": "standoff",
				"salience": 0.019391559,
				"type": "EVENT"
			},
			{
				"name": "Sacred Stone Camp",
				"salience": 0.016825685,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition",
				"salience": 0.016427608,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.01641066,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Native Americans",
				"salience": 0.016135894,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.016018422,
				"type": "EVENT"
			},
			{
				"name": "theantimedia.org",
				"salience": 0.014312105,
				"type": "OTHER"
			},
			{
				"name": "Nick Bernabe",
				"salience": 0.014312105,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.013715059,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.012130648,
				"type": "PERSON"
			},
			{
				"name": "media coverage",
				"salience": 0.01188325,
				"type": "OTHER"
			},
			{
				"name": "Sacred Stone Camp",
				"salience": 0.011857151,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock Sioux",
				"salience": 0.011115716,
				"type": "LOCATION"
			},
			{
				"name": "location",
				"salience": 0.0073953657,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.0069730454,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.0067829196,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0067829196,
				"type": "OTHER"
			},
			{
				"name": "standoff",
				"salience": 0.006711202,
				"type": "OTHER"
			},
			{
				"name": "tribe",
				"salience": 0.006184044,
				"type": "PERSON"
			},
			{
				"name": "partners",
				"salience": 0.0056596133,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition encampment",
				"salience": 0.0056596133,
				"type": "LOCATION"
			},
			{
				"name": "stand",
				"salience": 0.0054117646,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.005376764,
				"type": "LOCATION"
			},
			{
				"name": "journalist",
				"salience": 0.0049017756,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0049017756,
				"type": "OTHER"
			},
			{
				"name": "fiction",
				"salience": 0.0049017756,
				"type": "OTHER"
			},
			{
				"name": "reluctance",
				"salience": 0.0049017756,
				"type": "OTHER"
			},
			{
				"name": "pipeline builders",
				"salience": 0.0049017756,
				"type": "PERSON"
			},
			{
				"name": "favoritism",
				"salience": 0.0049017756,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.0049017756,
				"type": "OTHER"
			},
			{
				"name": "law-enforcement",
				"salience": 0.0049017756,
				"type": "ORGANIZATION"
			},
			{
				"name": "treaty land",
				"salience": 0.0045903,
				"type": "OTHER"
			},
			{
				"name": "pipeline",
				"salience": 0.004386142,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.004002564,
				"type": "OTHER"
			},
			{
				"name": "farming",
				"salience": 0.0039698924,
				"type": "OTHER"
			},
			{
				"name": "drinking water",
				"salience": 0.0039698924,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.003885461,
				"type": "ORGANIZATION"
			},
			{
				"name": "medicines",
				"salience": 0.003885461,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "opposition",
				"salience": 0.0037882468,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ykz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Missouri_River"
				},
				"name": "Missouri",
				"salience": 0.003760789,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0035897465,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.0034380294,
				"type": "OTHER"
			},
			{
				"name": "wildlife",
				"salience": 0.0034380294,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0034380294,
				"type": "OTHER"
			},
			{
				"name": "camp website",
				"salience": 0.0034380294,
				"type": "OTHER"
			},
			{
				"name": "ecosystems",
				"salience": 0.0034380294,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.0034300336,
				"type": "LOCATION"
			},
			{
				"name": "water protectors",
				"salience": 0.0033097893,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0033097893,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.0033097893,
				"type": "ORGANIZATION"
			},
			{
				"name": "environmentalists",
				"salience": 0.0033097893,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0032681134,
				"type": "OTHER"
			},
			{
				"name": "treaty territory",
				"salience": 0.0032414296,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0032414296,
				"type": "LOCATION"
			},
			{
				"name": "Farmers",
				"salience": 0.0032414296,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fk3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sioux"
				},
				"name": "Sioux",
				"salience": 0.0030179163,
				"type": "LOCATION"
			},
			{
				"name": "culture",
				"salience": 0.0028070617,
				"type": "OTHER"
			},
			{
				"name": "ranchers",
				"salience": 0.0028070617,
				"type": "PERSON"
			},
			{
				"name": "Anti-Media",
				"salience": 0.0021710119,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c0wf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Hills"
				},
				"name": "Black Hills of South Dakota",
				"salience": 0.0021297834,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04ykz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Missouri_River"
				},
				"name": "Missouri River",
				"salience": 0.0021166601,
				"type": "LOCATION"
			},
			{
				"name": "treaty",
				"salience": 0.0021147078,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.0020971906,
				"type": "PERSON"
			},
			{
				"name": "human",
				"salience": 0.0020971906,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0020971906,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0020971906,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.0020971906,
				"type": "OTHER"
			},
			{
				"name": "instances",
				"salience": 0.0020971906,
				"type": "OTHER"
			},
			{
				"name": "gold",
				"salience": 0.0018949212,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0018666947,
				"type": "LOCATION"
			},
			{
				"name": "landowners",
				"salience": 0.0018666947,
				"type": "PERSON"
			},
			{
				"name": "tribe",
				"salience": 0.0017639973,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.0015275026,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.0015275026,
				"type": "WORK_OF_ART"
			},
			{
				"name": "starvation",
				"salience": 0.0015275026,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0015275026,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0013945098,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0347zg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Treaty_of_Fort_Laramie_(1868)"
				},
				"name": "Treaty of Fort Laramie",
				"salience": 0.0013017014,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Native_Americans_in_the_United_States"
				},
				"name": "Natives",
				"salience": 0.0012909157,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0137v8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Atlantic"
				},
				"name": "The Atlantic",
				"salience": 0.0012909157,
				"type": "LOCATION"
			},
			{
				"name": "will",
				"salience": 0.0011410814,
				"type": "OTHER"
			},
			{
				"name": "domain",
				"salience": 0.0011410814,
				"type": "OTHER"
			},
			{
				"name": "pipeline corporation",
				"salience": 0.0011410814,
				"type": "ORGANIZATION"
			},
			{
				"name": "tradition",
				"salience": 0.0011410814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04j4gc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fort_Laramie_National_Historic_Site"
				},
				"name": "Laramie",
				"salience": 0.0010857694,
				"type": "LOCATION"
			},
			{
				"name": "whites",
				"salience": 0.0010846414,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y9zg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Sioux_War_of_1876"
				},
				"name": "Great Sioux War",
				"salience": 0.0009401719,
				"type": "EVENT"
			},
			{
				"name": "reputation",
				"salience": 0.00091978075,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/dakota-access-pipeline-protests.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.024",
		"text": "By Nick Bernabe at theantimedia.org\nA small Standing Rock Sioux site in North Dakota called the Sacred Stone Camp has been propelled into the national news narrative following their stand against the Dakota Access Pipeline. Due in part to independent media coverage of the ongoing standoff, the Sacred Stone camp has grown into a formidable opposition against the $3.8 billion, 1,200-mile long pipeline.\nDue to misinformation coming from law-enforcement, political favoritism toward the pipeline builders, and the media’s blatant reluctance to report on the pipeline, it’s hard to tell truth from fiction. Anti-Media , along with our partners in the independent media and our embedded journalist at the opposition encampment, have been covering the unfolding standoff continuously. Here are five things you need to know.\n1. Who is opposing the pipeline — and why The Standing Rock Sioux tribe is leading the opposition to the Dakota Access Pipeline. They have been joined by the largest tribal coalition in over 100 years in their stand against the pipeline. The coalition is also comprised of activists, allies, and environmentalists, collectively known as “water protectors,” at the Sacred Stone Camp, an encampment close to the location where the pipeline is planned to cross the Missouri River in North Dakota. According to the Sacred Stone camp website , they are opposing the pipeline because “[t]he Dakota Access threatens everything from farming and drinking water to entire ecosystems, wildlife and food sources surrounding the Missouri .”\nThe Standing Rock Sioux also say the pipeline is violating treaty land , Sioux territory that was established many years ago by the federal government. “We will not allow Dakota Access to trespass on our treaty territory and destroy our medicines and our culture.”\nThe opposition to the pipeline spreads across several states and is not opposed solely by Native Americans. Farmers, ranchers, and landowners are also opposed to the pipeline. Many of them have had their land taken from them against their will and given to the pipeline via eminent domain.\n2. The U.S. government and the pipeline corporation are continuing a long tradition of disrespecting Native Americans\nThe United States has a very bad reputation for treating Native Americans, the original inhabitants of this land, as less than human. In many instances in the past, the land where Native Americans lived was deemed to be of higher value than the Natives’ lives.\nSuch has been the case in North Dakota — not only now, but in the past as well. According to The Atlantic :\n“The land beneath the pipeline was accorded to Sioux peoples by the Treaty of Fort Laramie in 1868. Eleven years later, the U.S. government incited and won the Great Sioux War, and ‘renegotiated’ a new treaty with the Sioux under threat of starvation. In that document, the tribe ceded much of the Laramie land, including the Black Hills of South Dakota, where many whites believed there to be gold.”",
		"thread_title": "5 Things You Need to Know About the Dakota Access Pipeline Protests",
		"title": "5 Things You Need to Know About the Dakota Access Pipeline Protests",
		"type": "bs",
		"uuid": "794aa98406a69a5ecd00c29b288be2179e18933d"
	},
	"-KhIhoRggiyki94R7Kre": {
		"author": "Vandita",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:24:58.135+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0n8m6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monsanto"
				},
				"name": "Monsanto",
				"salience": 0.1750046,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01snr1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bayer"
				},
				"name": "Bayer",
				"salience": 0.06090582,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0g55yv2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Cannabis_Industry_Association"
				},
				"name": "Big Cannabis",
				"salience": 0.036966056,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.034783598,
				"type": "OTHER"
			},
			{
				"name": "cards",
				"salience": 0.034783598,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rlm62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Hagedorn"
				},
				"name": "Jim Hagedorn",
				"salience": 0.028336372,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02q3wl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pharmaceutical_industry"
				},
				"name": "Big Pharma",
				"salience": 0.02478761,
				"type": "OTHER"
			},
			{
				"name": "crops",
				"salience": 0.022787541,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.022787541,
				"type": "ORGANIZATION"
			},
			{
				"name": "producer",
				"salience": 0.020586058,
				"type": "PERSON"
			},
			{
				"name": "consortium",
				"salience": 0.020586058,
				"type": "OTHER"
			},
			{
				"name": "debt",
				"salience": 0.01783782,
				"type": "OTHER"
			},
			{
				"name": "takeover",
				"salience": 0.01783782,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02rkffn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Scotts_Miracle-Gro_Company"
				},
				"name": "Scotts Miracle-Gro Company",
				"salience": 0.017610852,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawn",
				"salience": 0.015430009,
				"type": "LOCATION"
			},
			{
				"name": "cannabis seeds",
				"salience": 0.01419112,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01q_vm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glyphosate"
				},
				"name": "RoundUp Ready",
				"salience": 0.012694905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.012694905,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0109970085,
				"type": "LOCATION"
			},
			{
				"name": "#Cannabis",
				"salience": 0.010079585,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.010024543,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.009908163,
				"type": "ORGANIZATION"
			},
			{
				"name": "seeds",
				"salience": 0.009409668,
				"type": "OTHER"
			},
			{
				"name": "cannabis seeds",
				"salience": 0.008945183,
				"type": "OTHER"
			},
			{
				"name": "crop chemicals",
				"salience": 0.008497644,
				"type": "OTHER"
			},
			{
				"name": "shop",
				"salience": 0.0082482705,
				"type": "LOCATION"
			},
			{
				"name": "cannabis",
				"salience": 0.008083956,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0077824574,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0073600034,
				"type": "PERSON"
			},
			{
				"name": "heroin",
				"salience": 0.0073600034,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mission",
				"salience": 0.0073600034,
				"type": "OTHER"
			},
			{
				"name": "cannabis market",
				"salience": 0.0073600034,
				"type": "OTHER"
			},
			{
				"name": "concentration camps",
				"salience": 0.0073600034,
				"type": "LOCATION"
			},
			{
				"name": "worry",
				"salience": 0.006650925,
				"type": "OTHER"
			},
			{
				"name": "cash crops",
				"salience": 0.006601258,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0063551515,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.006164244,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.005961,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01yx7f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_of_America"
				},
				"name": "Bank of America",
				"salience": 0.005796005,
				"type": "ORGANIZATION"
			},
			{
				"name": "cannabis growers",
				"salience": 0.005738727,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.005641206,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.00543084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016w62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toxicity"
				},
				"name": "Non Toxic",
				"salience": 0.005233739,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.005228307,
				"type": "EVENT"
			},
			{
				"name": "tobacco",
				"salience": 0.005162487,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.005162487,
				"type": "PERSON"
			},
			{
				"name": "corn",
				"salience": 0.005162487,
				"type": "OTHER"
			},
			{
				"name": "notes",
				"salience": 0.005162487,
				"type": "OTHER"
			},
			{
				"name": "patents",
				"salience": 0.005162487,
				"type": "OTHER"
			},
			{
				"name": "business practices",
				"salience": 0.005162487,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.0049699484,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.0049699484,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "infant marijuana industry",
				"salience": 0.0049699484,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.0049699484,
				"type": "OTHER"
			},
			{
				"name": "merger",
				"salience": 0.004907376,
				"type": "OTHER"
			},
			{
				"name": "garden use",
				"salience": 0.004867313,
				"type": "OTHER"
			},
			{
				"name": "cannabis farmers farm",
				"salience": 0.004867313,
				"type": "ORGANIZATION"
			},
			{
				"name": "producer",
				"salience": 0.004867313,
				"type": "PERSON"
			},
			{
				"name": "pesticides",
				"salience": 0.004867313,
				"type": "OTHER"
			},
			{
				"name": "consumer",
				"salience": 0.004867313,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "Goldman Sachs",
				"salience": 0.0046488615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hlwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JPMorgan_Chase"
				},
				"name": "JP Morgan",
				"salience": 0.004532528,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.004532528,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi",
				"salience": 0.004532528,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rothschild Banking Cartel",
				"salience": 0.004532528,
				"type": "ORGANIZATION"
			},
			{
				"name": "words",
				"salience": 0.00421514,
				"type": "OTHER"
			},
			{
				"name": "operators",
				"salience": 0.00421514,
				"type": "ORGANIZATION"
			},
			{
				"name": "fines",
				"salience": 0.00421514,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.0040275706,
				"type": "ORGANIZATION"
			},
			{
				"name": "pot business",
				"salience": 0.0040275706,
				"type": "OTHER"
			},
			{
				"name": "pot growers",
				"salience": 0.0036366915,
				"type": "OTHER"
			},
			{
				"name": "garden",
				"salience": 0.0036366915,
				"type": "LOCATION"
			},
			{
				"name": "proponents",
				"salience": 0.0035298327,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hrg4v1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leafly"
				},
				"name": "Leafly",
				"salience": 0.0035177262,
				"type": "ORGANIZATION"
			},
			{
				"name": "Roundup Ready Blue Dream",
				"salience": 0.0031785045,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "accessories",
				"salience": 0.0031492703,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "thing",
				"salience": 0.0031492703,
				"type": "OTHER"
			},
			{
				"name": "fertilizers",
				"salience": 0.0031492703,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "soils",
				"salience": 0.0031492703,
				"type": "OTHER"
			},
			{
				"name": "VoteNoOn64 -- David",
				"salience": 0.0030598994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/037mm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Genetically_modified_organism"
				},
				"name": "GMO",
				"salience": 0.0030598994,
				"type": "OTHER"
			},
			{
				"name": "SaveCannabis",
				"salience": 0.0030598994,
				"type": "PERSON"
			},
			{
				"name": "@rskls",
				"salience": 0.0030598994,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01r2lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Forbes"
				},
				"name": "Forbes",
				"salience": 0.0029478404,
				"type": "ORGANIZATION"
			},
			{
				"name": "hydroponics equipment company",
				"salience": 0.0029337606,
				"type": "ORGANIZATION"
			},
			{
				"name": "deals",
				"salience": 0.0029337606,
				"type": "OTHER"
			},
			{
				"name": "hormones",
				"salience": 0.002538714,
				"type": "OTHER"
			},
			{
				"name": "lighting",
				"salience": 0.0022938426,
				"type": "OTHER"
			},
			{
				"name": "acquisition",
				"salience": 0.0022938426,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.0022938426,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.0022938426,
				"type": "OTHER"
			},
			{
				"name": "sales",
				"salience": 0.0022938426,
				"type": "OTHER"
			},
			{
				"name": "General Hydroponics",
				"salience": 0.0022387311,
				"type": "OTHER"
			},
			{
				"name": "marijuana",
				"salience": 0.0019789159,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "chemicals",
				"salience": 0.0019789159,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0019789159,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0019385791,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.0018257487,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.001713582,
				"type": "OTHER"
			},
			{
				"name": "coca",
				"salience": 0.001713582,
				"type": "OTHER"
			},
			{
				"name": "plants",
				"salience": 0.001713582,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.001713582,
				"type": "EVENT"
			},
			{
				"name": "violations",
				"salience": 0.001713582,
				"type": "OTHER"
			},
			{
				"name": "penalties",
				"salience": 0.001713582,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amsterdam"
				},
				"name": "Amsterdam",
				"salience": 0.0014118835,
				"type": "LOCATION"
			},
			{
				"name": "buyout",
				"salience": 0.0013296972,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012qj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drug_Enforcement_Administration"
				},
				"name": "DEA",
				"salience": 0.0010546639,
				"type": "ORGANIZATION"
			},
			{
				"name": "Federal Pesticide Laws",
				"salience": 0.0010546639,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "3",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/cannabis.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": -0.1
		},
		"shares": "3",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Big Cannabis – on the lines of Big Pharma – is on the cards. At least that’s what Germany-based pharmaceutical giant Bayer’s $66 billion takeover of America-based agrichemical giant Monsanto (a leading producer of RoundUp Ready genetically modified crops) indicates. Financed from a consortium of corrupt, in-debt, and influential banks (including Goldman Sachs, HSBC, JP Morgan, and Bank of America), the multi-billion-dollar deal (negotiated by the Rothschild Banking Cartel) brings Bayer ( famous for selling heroin to children and financing Nazi concentration camps ) closer to the multi-billion-dollar cannabis market through its ”mission” to create a one-stop shop for seeds, crop chemicals and computer-aided services to cannabis growers .\n#Cannabis is Non Toxic but #Monsanto will make it toxic by making a GMO version. #SaveCannabis #VoteNoOn64\n— David (@rskls) September 6, 2016\nCannabis proponents believe the largest all-cash deal on record will destroy the infant marijuana industry by introducing genetically modified cannabis seeds, highly expensive cannabis-based drugs, monopolistic use of patents, and restrictive business practices. Leafly notes:\n“The worry is that the combined firm will have the financial and political influence to do to cannabis what it has already done to corn, tobacco, and other cash crops — namely, use pricey patented cannabis seeds (Roundup Ready Blue Dream, anyone?) that favor large-scale operators and rigidly control how all cannabis farmers farm. The merger, in other words, could be the first step toward Big Cannabis .”\nMonsanto’s decades old intimate ties with the Scotts Miracle-Gro Company — a leading producer of pesticides for commercial and consumer lawn and garden use (who was ordered to pay $12.5 million in criminal fines and civil penalties for violations of Federal Pesticide Laws in 2012) — is especially a matter of concern. Monsanto and Scotts Miracle-Gro have long been partners with the DEA to produce hormones and carcinogenic chemicals used in the wars against marijuana and coca plants.\nJim Hagedorn, who took over Scotts Miracle-Gro in 2001, shared his intention to “invest, like, half a billion in the pot business” with Forbes in July, calling cannabis the biggest thing he has ever seen in lawn and garden. Forbes reports:\nScotts Miracle-Gro shelled out $135 million last year on two California-based businesses [including the $130 million buyout of General Hydroponics] that sell fertilizers, soils and accessories to pot growers. It recently spent another $120 million on a still-undisclosed lighting and hydroponics equipment company in Amsterdam and promises to invest about another $150 million by the end of 2016.\nAltogether, the deals are bigger than the largest single acquisition in the history of Scotts Miracle-Gro, which takes in $160 million of profit on $3 billion in sales annually.",
		"thread_title": "War on Weed: Bayer-Monsanto Working on Genetically Modified Corporate Cannabis?",
		"title": "War on Weed: Bayer-Monsanto Working on Genetically Modified Corporate Cannabis?",
		"type": "bs",
		"uuid": "40675695f854cba88df3ebf909220a048b00b0e4"
	},
	"-KhIhoiveeg64XqqNaNd": {
		"author": "EV",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:26:21.653+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.33049098,
				"type": "LOCATION"
			},
			{
				"name": "event",
				"salience": 0.03702216,
				"type": "EVENT"
			},
			{
				"name": "government facilities",
				"salience": 0.027772691,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.02356171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_lf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_Stalin"
				},
				"name": "Joseph Stalin",
				"salience": 0.016387662,
				"type": "PERSON"
			},
			{
				"name": "Areas",
				"salience": 0.015667168,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.015667168,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.014478192,
				"type": "EVENT"
			},
			{
				"name": "almighty",
				"salience": 0.014233134,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.013893171,
				"type": "LOCATION"
			},
			{
				"name": "bomb",
				"salience": 0.013675786,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.013076996,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.013076996,
				"type": "LOCATION"
			},
			{
				"name": "factors",
				"salience": 0.011328545,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.011328545,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.011328545,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.011328545,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.011328545,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.011328545,
				"type": "OTHER"
			},
			{
				"name": "soil",
				"salience": 0.011328545,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.011328545,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.009009759,
				"type": "PERSON"
			},
			{
				"name": "fallout",
				"salience": 0.008698143,
				"type": "EVENT"
			},
			{
				"name": "fallout",
				"salience": 0.008698143,
				"type": "EVENT"
			},
			{
				"name": "Fallout Reach",
				"salience": 0.008058797,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0js8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Emergency_Management_Agency"
				},
				"name": "FEMA",
				"salience": 0.007977624,
				"type": "ORGANIZATION"
			},
			{
				"name": "How Far",
				"salience": 0.006979946,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.0064633354,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.005392411,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.005392411,
				"type": "OTHER"
			},
			{
				"name": "reactors",
				"salience": 0.005392411,
				"type": "LOCATION"
			},
			{
				"name": "destruction",
				"salience": 0.005392411,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.005373614,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.005305974,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.005108111,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.004917617,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.004859791,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.0048362943,
				"type": "EVENT"
			},
			{
				"name": "nukes",
				"salience": 0.004670034,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.004670034,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.004670034,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.004670034,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.004670034,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.004670034,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.004670034,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0044060824,
				"type": "EVENT"
			},
			{
				"name": "aggressing nation",
				"salience": 0.0043642996,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0043642996,
				"type": "ORGANIZATION"
			},
			{
				"name": "historians",
				"salience": 0.004219857,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.004219857,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.004170809,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g3cw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hiroshima"
				},
				"name": "Hiroshima",
				"salience": 0.0040514367,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05gqf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nagasaki"
				},
				"name": "Nagasaki",
				"salience": 0.0040514367,
				"type": "LOCATION"
			},
			{
				"name": "bomb",
				"salience": 0.004032093,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.004032093,
				"type": "PERSON"
			},
			{
				"name": "plants",
				"salience": 0.0038616569,
				"type": "OTHER"
			},
			{
				"name": "fallout",
				"salience": 0.0038185483,
				"type": "EVENT"
			},
			{
				"name": "cases",
				"salience": 0.0037818917,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0036408035,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0034453808,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.0034360397,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.0034196314,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0034196314,
				"type": "EVENT"
			},
			{
				"name": "list",
				"salience": 0.0033742057,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.0032750594,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "indicator",
				"salience": 0.0032750594,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0032750594,
				"type": "OTHER"
			},
			{
				"name": "government narrative",
				"salience": 0.0032750594,
				"type": "WORK_OF_ART"
			},
			{
				"name": "problem",
				"salience": 0.0032750594,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0032073997,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.003152862,
				"type": "PERSON"
			},
			{
				"name": "strength",
				"salience": 0.003152862,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.003152862,
				"type": "OTHER"
			},
			{
				"name": "spots",
				"salience": 0.003152862,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.003152862,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0030877243,
				"type": "OTHER"
			},
			{
				"name": "Population",
				"salience": 0.0030877243,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Dakota"
				},
				"name": "North Dakota",
				"salience": 0.002875261,
				"type": "LOCATION"
			},
			{
				"name": "military personnel",
				"salience": 0.0028129301,
				"type": "PERSON"
			},
			{
				"name": "Transformers",
				"salience": 0.0026738497,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "apple pie-eating",
				"salience": 0.0026738497,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0026738497,
				"type": "LOCATION"
			},
			{
				"name": "mixture",
				"salience": 0.002623071,
				"type": "OTHER"
			},
			{
				"name": "bomb",
				"salience": 0.002554825,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.002554825,
				"type": "EVENT"
			},
			{
				"name": "troposphere",
				"salience": 0.0023067999,
				"type": "OTHER"
			},
			{
				"name": "stratosphere",
				"salience": 0.0023067999,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.0023067999,
				"type": "OTHER"
			},
			{
				"name": "Event",
				"salience": 0.0021489153,
				"type": "EVENT"
			},
			{
				"name": "targets",
				"salience": 0.0021035245,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "WWII",
				"salience": 0.0020160868,
				"type": "EVENT"
			},
			{
				"name": "Foner",
				"salience": 0.0020160868,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.0020160868,
				"type": "LOCATION"
			},
			{
				"name": "Fallout Last",
				"salience": 0.0019975388,
				"type": "OTHER"
			},
			{
				"name": "map",
				"salience": 0.0019975388,
				"type": "WORK_OF_ART"
			},
			{
				"name": "coloration",
				"salience": 0.0019975388,
				"type": "OTHER"
			},
			{
				"name": "yellow",
				"salience": 0.0019975388,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0019975388,
				"type": "OTHER"
			},
			{
				"name": "explosion",
				"salience": 0.0019975388,
				"type": "EVENT"
			},
			{
				"name": "fireball",
				"salience": 0.0019975388,
				"type": "OTHER"
			},
			{
				"name": "detonation",
				"salience": 0.0019975388,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.0019975388,
				"type": "OTHER"
			},
			{
				"name": "debris",
				"salience": 0.0019975388,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.0019316083,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012mzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Notre_Dame"
				},
				"name": "University of Notre Dame",
				"salience": 0.0018697424,
				"type": "ORGANIZATION"
			},
			{
				"name": "Attack",
				"salience": 0.0018608097,
				"type": "EVENT"
			},
			{
				"name": "Fallout",
				"salience": 0.0018538868,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.0017519953,
				"type": "LOCATION"
			},
			{
				"name": "terms",
				"salience": 0.0016801276,
				"type": "OTHER"
			},
			{
				"name": "stratosphere",
				"salience": 0.0016801276,
				"type": "OTHER"
			},
			{
				"name": "troposphere",
				"salience": 0.0016801276,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.0016801276,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j97p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Archives_and_Records_Administration"
				},
				"name": "National Archives and Records Administration",
				"salience": 0.0016458797,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0475mb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agricultural_machinery"
				},
				"name": "Agricultural Equipment",
				"salience": 0.0016458797,
				"type": "OTHER"
			},
			{
				"name": "Yep",
				"salience": 0.0016458797,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0016053175,
				"type": "EVENT"
			},
			{
				"name": "conditions",
				"salience": 0.0014548462,
				"type": "OTHER"
			},
			{
				"name": "half-life",
				"salience": 0.0014548462,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.0014548462,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0014198855,
				"type": "LOCATION"
			},
			{
				"name": "maps",
				"salience": 0.0014005363,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attack",
				"salience": 0.0013900631,
				"type": "EVENT"
			},
			{
				"name": "Government Officials",
				"salience": 0.0012815641,
				"type": "PERSON"
			},
			{
				"name": "populations",
				"salience": 0.0012550732,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.0012550732,
				"type": "EVENT"
			},
			{
				"name": "earth",
				"salience": 0.0012550732,
				"type": "LOCATION"
			},
			{
				"name": "How Long",
				"salience": 0.0012294865,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Elite'' Go",
				"salience": 0.0011453123,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0010867678,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.0010867678,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.0010867678,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0010867678,
				"type": "OTHER"
			},
			{
				"name": "sample fallout pattern",
				"salience": 0.0010461941,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviets",
				"salience": 0.0008555272,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0xs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._state"
				},
				"name": "States",
				"salience": 0.00077243487,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "2",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/missile-plus-u.s.-equals-sad.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.2,
			"score": 0
		},
		"shares": "2",
		"site_url": "anonhq.com",
		"spam_score": "0.001",
		"text": "Ever wonder what would happen if the U.S. was nuked? While there are numerous factors to take into consideration in the event of a nuclear war on U.S. soil, we’ve done our best to answer some of the most commonly asked questions, in the simplest and most understandable of terms.\nWhich Areas Would be Hit, and How Far Would the Fallout Reach? On the topic of which regions of the U.S. would be hit; part of it is left up to guess work, as we are unable to fully predict the aggressing nation’s tactics, but then much of it is also based on logic. For example, any nation that strikes the U.S. will want to disable their nukes, so we can easily surmise that areas such as North Dakota would be obliterated.\nActive nuclear energy plants would also make good targets, as the added nuclear energy from the reactors would maximize destruction. And then of course, there are the major government facilities that would be targeted, at least, those that are known of – unfortunately, it’s safe to assume an aggressing nation’s intelligence would have a better idea of the U.S. government’s “soft spots” than the average American citizen.\nBefore we get too far ahead of ourselves, however, let’s go with what we know; what kind of targets would the U.S. go for? In the case of Hiroshima and Nagasaki, numerous military personnel, politicians, and now historians claim that the first bomb was dropped to prove it could be done, and the second bomb was dropped to display the United States’ strength to Joseph Stalin in the Soviet Union, who was originally aligned with the U.S. and Britain during WWII, but who the U.S. knew would become a problem once the war was over, (Foner, 2014, p. 887-949).\nWhile we are aware there are numerous citizens who, to this day, refuse to believe any other version of events than the original government narrative, the point is, we can’t use the cases of Hiroshima and Nagasaki as an accurate indicator of the type of targets the U.S. would choose. Fortunately though, we do have a detailed list of targets the U.S. created in 1956 – in the event of war with the Soviet Union – that was released through the National Archives and Records Administration . The list includes major cities for “ systematic destruction ,” including areas that contain “ Agricultural Equipment ” and “ Transformers, Heavy .” Most horridly though, was a target simply titled “ Population .”\nYep. The almighty, all wise, glorious, wholesome and righteous, baseball-loving, apple pie-eating, land of the free, and home of the brave, planned to target large populations of innocent civilians, and it’s with that in mind we can surmise that largely populated areas would be potential targets here in the States, as well.\nProvided below are two maps created by FEMA, the first of which is from 1990, and shows the presumed targets the Soviets would have hit in the event of a nuclear attack. “Fallout,” according to the University of Notre Dame , is described as the mixture of earth and/or water that has entered the rising fireball caused from the detonation of a nuclear bomb near the Earth’s surface. This mixes with the radioactive debris of the explosion at an early stage, and is then blown into the troposphere and lower stratosphere, creating fallout. The most lethal fallout is indicated by the darkest coloration, while the lesser lethal fallout is indicated with yellow:\nSource: FEMA\nIn this map, FEMA shows a sample fallout pattern we could expect in a nuclear attack:\nSource: FEMA\nHow Long Would the Fallout Last? After being blown into the troposphere and lower stratosphere, “ the material is then re-distributed over polar (3-12 months) or equatorial regions (8-24 months). Fall-out removal times (defined in terms of half-life) ranges from 10 to 24 months depending upon seasonal conditions, most rapid during spring, slow in summer ,” again, this is according to the University of Notre Dame, (source above).\nWhere Would Government Officials and the “Elite” Go in the Event of a Nuclear Attack?",
		"thread_title": "What Would Happen if the U.S. was Nuked?",
		"title": "What Would Happen if the U.S. was Nuked?",
		"type": "bs",
		"uuid": "01ecb742e8362f5e76355c22c8b95d871aa52a5b"
	},
	"-KhIhpSM4DdCFBMHmGxf": {
		"author": "Vandita",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:26:42.369+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.30741948,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.12335982,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.08061822,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.060281582,
				"type": "PERSON"
			},
			{
				"name": "civil war",
				"salience": 0.03792876,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0154650705,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.013746271,
				"type": "ORGANIZATION"
			},
			{
				"name": "proxy war",
				"salience": 0.010227515,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.009602391,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.009211915,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.008432799,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hr9tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Observatory_for_Human_Rights"
				},
				"name": "Syrian Observatory for Human Rights",
				"salience": 0.00840654,
				"type": "ORGANIZATION"
			},
			{
				"name": "war crimes",
				"salience": 0.0068713124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.0067554093,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War III",
				"salience": 0.0063069053,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.0063069053,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0056569385,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/011x3wvm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq"
				},
				"name": "Islamic State of Iraq",
				"salience": 0.0055232244,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0053984905,
				"type": "LOCATION"
			},
			{
				"name": "proxy war",
				"salience": 0.00523494,
				"type": "EVENT"
			},
			{
				"name": "facilities",
				"salience": 0.005058801,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.0049000913,
				"type": "EVENT"
			},
			{
				"name": "lives",
				"salience": 0.0049000913,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0049000913,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0045841313,
				"type": "EVENT"
			},
			{
				"name": "intent",
				"salience": 0.0044318843,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0044268873,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.004269447,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.004221423,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0041256766,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00409488,
				"type": "LOCATION"
			},
			{
				"name": "refugee crisis",
				"salience": 0.003951459,
				"type": "EVENT"
			},
			{
				"name": "regime",
				"salience": 0.0039342945,
				"type": "OTHER"
			},
			{
				"name": "Serena Shim",
				"salience": 0.0036429644,
				"type": "PERSON"
			},
			{
				"name": "regime",
				"salience": 0.0034663884,
				"type": "ORGANIZATION"
			},
			{
				"name": "research",
				"salience": 0.0029158285,
				"type": "OTHER"
			},
			{
				"name": "proportions",
				"salience": 0.00289203,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0027692118,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.002504606,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.002504606,
				"type": "ORGANIZATION"
			},
			{
				"name": "least",
				"salience": 0.002504606,
				"type": "OTHER"
			},
			{
				"name": "Status",
				"salience": 0.0023277504,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0023277504,
				"type": "EVENT"
			},
			{
				"name": "locus",
				"salience": 0.002220207,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0021574371,
				"type": "EVENT"
			},
			{
				"name": "war crimes",
				"salience": 0.0018888371,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0018397678,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0018041608,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.0017979156,
				"type": "OTHER"
			},
			{
				"name": "Western Claim",
				"salience": 0.0017807108,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0016089006,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0015870776,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0015232367,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/041wm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julius_Caesar"
				},
				"name": "Caesar",
				"salience": 0.0015045193,
				"type": "PERSON"
			},
			{
				"name": "pictures",
				"salience": 0.0014988419,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.0014954123,
				"type": "LOCATION"
			},
			{
				"name": "Evidence",
				"salience": 0.0014277817,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.0014277817,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0013289857,
				"type": "LOCATION"
			},
			{
				"name": "crimes",
				"salience": 0.0013244938,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.0013244938,
				"type": "OTHER"
			},
			{
				"name": "Status",
				"salience": 0.0013244938,
				"type": "OTHER"
			},
			{
				"name": "hospitals",
				"salience": 0.0013190506,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.0013190506,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0013190506,
				"type": "PERSON"
			},
			{
				"name": "civility",
				"salience": 0.0013190506,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0012975883,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0012750637,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0012750637,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0012351486,
				"type": "EVENT"
			},
			{
				"name": "dictator",
				"salience": 0.0012291534,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0011909921,
				"type": "PERSON"
			},
			{
				"name": "tool",
				"salience": 0.0011909921,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0011909921,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0011909921,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.0011909921,
				"type": "EVENT"
			},
			{
				"name": "use",
				"salience": 0.0011909921,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0011909921,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0011909921,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0011909921,
				"type": "PERSON"
			},
			{
				"name": "bodies",
				"salience": 0.0011909921,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0011909921,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0011627745,
				"type": "LOCATION"
			},
			{
				"name": "slaughterhouse",
				"salience": 0.0010988188,
				"type": "LOCATION"
			},
			{
				"name": "war crimes",
				"salience": 0.0010813067,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0010453295,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0010353314,
				"type": "PERSON"
			},
			{
				"name": "punishment",
				"salience": 0.0010313179,
				"type": "OTHER"
			},
			{
				"name": "war crimes inquiry",
				"salience": 0.0010313179,
				"type": "OTHER"
			},
			{
				"name": "prisoners",
				"salience": 0.0010313179,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0010313179,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.0010313179,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0010313179,
				"type": "OTHER"
			},
			{
				"name": "chief",
				"salience": 0.0010313179,
				"type": "PERSON"
			},
			{
				"name": "starvation",
				"salience": 0.0010313179,
				"type": "OTHER"
			},
			{
				"name": "rubble",
				"salience": 0.0010313179,
				"type": "OTHER"
			},
			{
				"name": "beauty",
				"salience": 0.0010313179,
				"type": "OTHER"
			},
			{
				"name": "battlefield",
				"salience": 0.0010313179,
				"type": "LOCATION"
			},
			{
				"name": "pain",
				"salience": 0.0010313179,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0010313179,
				"type": "EVENT"
			},
			{
				"name": "military strikes",
				"salience": 0.0010313179,
				"type": "EVENT"
			},
			{
				"name": "commission",
				"salience": 0.0010313179,
				"type": "ORGANIZATION"
			},
			{
				"name": "streets",
				"salience": 0.0010313179,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0010281991,
				"type": "ORGANIZATION"
			},
			{
				"name": "mainstream media",
				"salience": 0.0010069492,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.001001118,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.001001118,
				"type": "PERSON"
			},
			{
				"name": "regime",
				"salience": 0.001001118,
				"type": "ORGANIZATION"
			},
			{
				"name": "torture",
				"salience": 0.001001118,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.000978032,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0009657086,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.00096375,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.00096375,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00096375,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.00093666534,
				"type": "OTHER"
			},
			{
				"name": "photographer",
				"salience": 0.00092486286,
				"type": "PERSON"
			},
			{
				"name": "photos",
				"salience": 0.0008903399,
				"type": "WORK_OF_ART"
			},
			{
				"name": "military photographer",
				"salience": 0.0008903399,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0008903399,
				"type": "WORK_OF_ART"
			},
			{
				"name": "military hospitals",
				"salience": 0.0008903399,
				"type": "LOCATION"
			},
			{
				"name": "documents",
				"salience": 0.0008903399,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tool",
				"salience": 0.000889718,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.00083505653,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00083505653,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.00083505653,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thousands",
				"salience": 0.00083505653,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.00083505653,
				"type": "WORK_OF_ART"
			},
			{
				"name": "world",
				"salience": 0.00081727916,
				"type": "LOCATION"
			},
			{
				"name": "most",
				"salience": 0.000810507,
				"type": "PERSON"
			},
			{
				"name": "groupings",
				"salience": 0.00080388435,
				"type": "ORGANIZATION"
			},
			{
				"name": "murder",
				"salience": 0.00080388435,
				"type": "EVENT"
			},
			{
				"name": "tens of thousands",
				"salience": 0.00080388435,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.00080388435,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.00078375184,
				"type": "PERSON"
			},
			{
				"name": "self-interest",
				"salience": 0.00078088697,
				"type": "OTHER"
			},
			{
				"name": "interventions",
				"salience": 0.00078088697,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00076071,
				"type": "OTHER"
			},
			{
				"name": "hospital",
				"salience": 0.0007550214,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.0007550214,
				"type": "OTHER"
			},
			{
				"name": "armed conflict",
				"salience": 0.0007550214,
				"type": "EVENT"
			},
			{
				"name": "fear mongering media",
				"salience": 0.0007522121,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0007522121,
				"type": "OTHER"
			},
			{
				"name": "bruises",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "professionals",
				"salience": 0.00072308356,
				"type": "PERSON"
			},
			{
				"name": "Quote",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "d",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "human rights abuse",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "disappearances",
				"salience": 0.00072308356,
				"type": "EVENT"
			},
			{
				"name": "arrests",
				"salience": 0.00072308356,
				"type": "EVENT"
			},
			{
				"name": "eyes",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "genitals",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "strangulation",
				"salience": 0.00072308356,
				"type": "EVENT"
			},
			{
				"name": "marks",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "emaciation",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "acid",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "burns",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "beatings",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.00072308356,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.0006960897,
				"type": "LOCATION"
			},
			{
				"name": "policy",
				"salience": 0.0006960897,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0006960897,
				"type": "OTHER"
			},
			{
				"name": "security-intelligence agencies",
				"salience": 0.0006960897,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.0006960897,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime operatives",
				"salience": 0.0006960897,
				"type": "ORGANIZATION"
			},
			{
				"name": "officer",
				"salience": 0.0006960897,
				"type": "PERSON"
			},
			{
				"name": "Accountability",
				"salience": 0.0006960897,
				"type": "OTHER"
			},
			{
				"name": "brutality",
				"salience": 0.0006960897,
				"type": "OTHER"
			},
			{
				"name": "war crimes whistleblower",
				"salience": 0.0006960897,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "show corpses",
				"salience": 0.0006960897,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reason",
				"salience": 0.0006873175,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.00068217755,
				"type": "PERSON"
			},
			{
				"name": "gas",
				"salience": 0.00068170106,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00068170106,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.00068170106,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.00068170106,
				"type": "OTHER"
			},
			{
				"name": "mainstream media reports",
				"salience": 0.00068170106,
				"type": "OTHER"
			},
			{
				"name": "SOHR claims",
				"salience": 0.00068170106,
				"type": "OTHER"
			},
			{
				"name": "William Roebuck",
				"salience": 0.0006801188,
				"type": "PERSON"
			},
			{
				"name": "Western Lies Why",
				"salience": 0.00064339687,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026vs_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_law"
				},
				"name": "International Justice",
				"salience": 0.0006347709,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.0006347709,
				"type": "ORGANIZATION"
			},
			{
				"name": "residents",
				"salience": 0.00062892964,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0006227731,
				"type": "EVENT"
			},
			{
				"name": "peace",
				"salience": 0.00061050896,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00061050896,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00061050896,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0005933484,
				"type": "EVENT"
			},
			{
				"name": "activists",
				"salience": 0.00059028505,
				"type": "PERSON"
			},
			{
				"name": "abundance",
				"salience": 0.00059028505,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.00059028505,
				"type": "LOCATION"
			},
			{
				"name": "nature",
				"salience": 0.00059028505,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00059028505,
				"type": "OTHER"
			},
			{
				"name": "fault",
				"salience": 0.0005828458,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0005682473,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00056399754,
				"type": "EVENT"
			},
			{
				"name": "Adam Ciralsky",
				"salience": 0.0005251799,
				"type": "PERSON"
			},
			{
				"name": "lies",
				"salience": 0.000524317,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0005092225,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005092225,
				"type": "PERSON"
			},
			{
				"name": "project",
				"salience": 0.0005092225,
				"type": "OTHER"
			},
			{
				"name": "reconciliation",
				"salience": 0.0005092225,
				"type": "OTHER"
			},
			{
				"name": "nation-building",
				"salience": 0.0005092225,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.0005019848,
				"type": "EVENT"
			},
			{
				"name": "treasure trove",
				"salience": 0.0004880203,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0004746886,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.000474357,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00046247512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00044502603,
				"type": "LOCATION"
			},
			{
				"name": "Peace",
				"salience": 0.00044461535,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.00044093042,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.00044093042,
				"type": "WORK_OF_ART"
			},
			{
				"name": "much",
				"salience": 0.00044093042,
				"type": "OTHER"
			},
			{
				"name": "talking points",
				"salience": 0.00044093042,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00044093042,
				"type": "OTHER"
			},
			{
				"name": "backing",
				"salience": 0.00044093042,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00044093042,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.00044093042,
				"type": "PERSON"
			},
			{
				"name": "member state",
				"salience": 0.0004394394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.00042841016,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Switzerland"
				},
				"name": "Switzerland",
				"salience": 0.00042841016,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.00042841016,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05b4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norway"
				},
				"name": "Norway",
				"salience": 0.00042841016,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.00042841016,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denmark"
				},
				"name": "Denmark",
				"salience": 0.00042841016,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00042841016,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00042841016,
				"type": "LOCATION"
			},
			{
				"name": "intervention",
				"salience": 0.00042481354,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.0004107397,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.0004107397,
				"type": "OTHER"
			},
			{
				"name": "coverage",
				"salience": 0.00037867477,
				"type": "OTHER"
			},
			{
				"name": "road building projects",
				"salience": 0.000370846,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.000370846,
				"type": "OTHER"
			},
			{
				"name": "gas",
				"salience": 0.000370846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.00036328452,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.00036328452,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.00036328452,
				"type": "LOCATION"
			},
			{
				"name": "Reality",
				"salience": 0.00035540422,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0003524995,
				"type": "OTHER"
			},
			{
				"name": "life expectancy",
				"salience": 0.0003378215,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.0003378215,
				"type": "OTHER"
			},
			{
				"name": "U.S. Peace Council",
				"salience": 0.00032333678,
				"type": "ORGANIZATION"
			},
			{
				"name": "areas",
				"salience": 0.00032110847,
				"type": "LOCATION"
			},
			{
				"name": "education",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "electricity",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "irrigation",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00032110847,
				"type": "PERSON"
			},
			{
				"name": "infrastructure",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.00032110847,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00031339025,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.00031050586,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.00030680638,
				"type": "PERSON"
			},
			{
				"name": "illiteracy",
				"salience": 0.00030522217,
				"type": "OTHER"
			},
			{
				"name": "human rights record",
				"salience": 0.0002770059,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.0002770059,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.0002770059,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/087vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yugoslavia"
				},
				"name": "Yugoslavia",
				"salience": 0.0002713575,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0002713575,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.0002713575,
				"type": "ORGANIZATION"
			},
			{
				"name": "health services",
				"salience": 0.00024601552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z4f6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Human_Rights_Council"
				},
				"name": "United Nations Human Rights Council",
				"salience": 0.00024151699,
				"type": "ORGANIZATION"
			},
			{
				"name": "gaze",
				"salience": 0.0002398525,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0002398525,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0002398525,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0002398525,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.0002398525,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0002398525,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.0002398525,
				"type": "PERSON"
			},
			{
				"name": "soil",
				"salience": 0.0002398525,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0002398525,
				"type": "OTHER"
			},
			{
				"name": "revolution",
				"salience": 0.0002398525,
				"type": "EVENT"
			},
			{
				"name": "plan",
				"salience": 0.0002112771,
				"type": "OTHER"
			},
			{
				"name": "cables",
				"salience": 0.00020082394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00020027898,
				"type": "LOCATION"
			},
			{
				"name": "Henry Lowendorf",
				"salience": 0.0001976118,
				"type": "PERSON"
			},
			{
				"name": "ISIS-Turkey",
				"salience": 0.0001976118,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01jg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Board_of_directors"
				},
				"name": "Executive Board",
				"salience": 0.0001976118,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fact-Finding Delegation",
				"salience": 0.0001976118,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.00018082057,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00016337032,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.00014760398,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05mg9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Osama_bin_Laden"
				},
				"name": "Osama bin Laden",
				"salience": 0.00014760398,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.00014760398,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "12",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/HILARY-WAR-CRIMES.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 22.2,
			"score": -0.1
		},
		"shares": "12",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "After claiming the lives of more than a quarter of a million people; causing the biggest refugee crisis since World War II; and fueling the rise of Islamic State of Iraq and Syria (ISIS), the civil war in Syria, which started in 2011 as a peaceful protest against President Bashar al-Assad but later turned into an international proxy war, is today, signaling World War III. At least, that’s what the West and the mainstream media want you to believe . However, the truth is the United States and its allies are using the “war crimes” and “crimes of historic proportions” in Syria to prolong the proxy war, overthrow Assad, and annex an independent country. Sadly, the United Nations, Amnesty International, the Syrian Observatory for Human Rights, and other “concerned parties” (including the mainstream media), support the West in its malicious intent.\nThe Western Claim “Russia and the Syrian regime owe the world more than an explanation about why they keep hitting hospitals and medical facilities and children and women,” US Secretary of State John Kerry recently commented. Kerry begged for an investigation of the Russian and Syrian military strikes against civilians and medical facilities in Aleppo, as war crimes.\n“There is clear and abundant evidence the Assad regime and the Russian government are committing crimes that include, but are not limited to, deliberate attacks on civilians, collective punishment, starvation as a tool of war, torture, murder, inhumane treatment of prisoners and the use of chemical weapons on the battlefield,” asserted The Washington Post .\n“The ancient city of Aleppo, a place of millennial civility and beauty, is today a slaughterhouse — a gruesome locus of pain and fear, where the lifeless bodies of small children are trapped under streets of rubble and pregnant women deliberately bombed,” observed the UN human rights’ chief, seeking a war crimes inquiry.\nThe Western Evidence 1. A commission for International Justice and Accountability — a non-profit organization funded by western states including the UK, US, the EU, Germany, Switzerland, Norway, Canada and Denmark — smuggled over 600,000 top-secret Syrian government documents brought to Western Europe .\nAn analysis of some 400 documents “linked the systematic torture and murder of tens of thousands of Syrians to a written policy approved by President Bashar al-Assad, coordinated among his security-intelligence agencies, and implemented by regime operatives.” Current status: Neither the documents nor the evidence has been made public.\n2. A decorated American journalist and a former CIA officer, Adam Ciralsky wrote about the 53,275 photos that “Caesar” (a Syrian military photographer turned war crimes whistleblower, who fled the country in August 2013) took as grisly evidence of Assad’s brutality.\n“The pictures, most of them taken in Syrian military hospitals, show corpses photographed at close range — one at a time as well as in small groupings. Virtually all of the bodies — thousands of them — betray signs of torture: gouged eyes; mangled genitals ; bruises and dried blood from beatings; acid and electric burns; emaciation; and marks from strangulation,” Ciralsky explained. Current Status: The treasure trove, as well as the photographer “Caesar,” is hidden from the public eye.\n3. In 2015, Amnesty International documented the systematic and widespread “unthinkable atrocities” war crimes, and crimes against humanity committed by Assad’s regime, in a 74-page report (including indiscriminate use of explosive weapons, arbitrary arrests, torture, and enforced disappearances). The ‘heartbreaking’ research involved merely 78 residents (mostly former) and 29 professionals working in Aleppo .\n4. The Syrian Observatory for Human Rights — the London-based monitoring group, often Quote: d as the most authoritative source of information about human rights abuse in Syria — is a tool of Western propaganda run by one man who last visited Syria in 2000 (11 years before the armed conflict began). He relies on “intelligence” allegedly gathered by around 200 “activists” who he has never met. Current Status: Whatever the SOHR claims, the mainstream media reports as truth without verifying its nature – because the SOHR does not reference any sources.\nThe Western Lies Why is the angry and (nowadays) concerned world not asking the United States and the mainstream media a few pertinent questions? What is the West doing in Syria? Why is the peace-loving West prolonging the war? Why is the West backing the rebels in a foreign country? Why is the West funding and arming ISIS?\nWhy are the Western forces not being held accountable for war crimes like bombing a hospital? Why is the mainstream media, the NGOs and the UN not holding the West accountable for crimes committed on their own land, or in Israel, Africa or Yemen?\nOne reason may be because of the abundance of natural gas under Syrian soil, and that this may very well be another ‘petrodollar’ war . The US had long had its gaze set on Syria – years before the civil war and the 2011 “revolution.” Leaked WikiLeaks cables show the US ambassador to Syria (2004-2007) William Roebuck discussing a plan to remove Assad from power, in December 2006 .\nWhile the Russian and Iranian forces entered Syria on Assad’s request to fight against ISIS and armed rebels, the Western military invaded Syria — a sovereign country and United Nations member state — to violently overthrow the Syrian government.\nWhy didn’t the West invade Saudi Arabia to initiate “humanitarian intervention” and save innocent citizens from its brutal dictator? Saudi Arabia remains a member of the United Nations Human Rights Council and a U.S. ally, despite its poor human rights record — if attacking an independent harmless country is justified, why did the US act against Osama bin Laden?\nThe Western effort to annex Syria has relied on a series of crudely-spun lies and media-generated talking points. In September, RT dared to expose the top 10 Western lies about Syrian conflict that the mainstream media are trading in, to fool the Western public into backing yet another failed ‘nation-building’ project (after Yugoslavia, Iraq and Libya). Obviously, the fear mongering media didn’t find it profitable to give the lies much, if any, coverage in the West.\nFrom calling the conflict a fault of wicked Assad, and Assad a brutal dictator who enjoyed no popular support, to portraying him as an uncompromising President interested only in ‘killing his own people’ – and not in peace and reconciliation, the list is endless. From accusing the Syrian government and Russia for helping ISIS and terming the Western interventions in Syria as humanitarian, to claiming Russia was acting out of self-interest and that the West was on the side of the ‘good guys’ in Syria, can you be certain of the ‘truth’? Realistically, the West hasn’t been fighting ‘terror’ in Syria, it has aided it.\nRemember the American journalist Serena Shim, who was killed in October 2014, after she revealed the ISIS-Turkey-US link that proved the West was assisting ISIS in Syria?\nThe Syrian Reality Henry Lowendorf, a member of the Executive Board of the U.S. Peace Council’s Peace and Fact-Finding Delegation to Syria – who returned from Syria in August – noted: “What we saw in Syria goes against everything we read in the United States.”\nBefore 2011, illiteracy in Syria had been wiped out; the life expectancy was 75.9 years and the government spent massive amounts of money on improving the nation. Developing irrigation, electricity, water and road building projects, and expanding the health services and education to rural areas, all occurred; and China invested hundreds of millions of dollars to modernize Syria’s aging oil and gas infrastructure.",
		"thread_title": "The Truth that America Doesn't Want You to Know about War Crimes in Syria",
		"title": "The Truth that America Doesn't Want You to Know about War Crimes in Syria",
		"type": "bs",
		"uuid": "d754f91d49c458013ee95d5935825a7c8c84826d"
	},
	"-KhIhpdHV1-OFhVhbVvE": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:26:47.704+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "weapons",
				"salience": 0.21803978,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.12533018,
				"type": "ORGANIZATION"
			},
			{
				"name": "instrument",
				"salience": 0.062312406,
				"type": "OTHER"
			},
			{
				"name": "elimination",
				"salience": 0.05006321,
				"type": "OTHER"
			},
			{
				"name": "landmark resolution",
				"salience": 0.05006321,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.04346435,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.038407627,
				"type": "ORGANIZATION"
			},
			{
				"name": "L41",
				"salience": 0.027610758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.026601339,
				"type": "OTHER"
			},
			{
				"name": "journey",
				"salience": 0.023669986,
				"type": "EVENT"
			},
			{
				"name": "elimination",
				"salience": 0.020843819,
				"type": "OTHER"
			},
			{
				"name": "First Committee",
				"salience": 0.02054788,
				"type": "ORGANIZATION"
			},
			{
				"name": "moment",
				"salience": 0.019956449,
				"type": "OTHER"
			},
			{
				"name": "Setsuko Thurlow",
				"salience": 0.018652888,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.014114084,
				"type": "EVENT"
			},
			{
				"name": "Beatrice Fihn",
				"salience": 0.014071713,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.013951118,
				"type": "PERSON"
			},
			{
				"name": "member nations",
				"salience": 0.012798827,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.011828072,
				"type": "OTHER"
			},
			{
				"name": "Resolution",
				"salience": 0.010683935,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0095847985,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0095847985,
				"type": "OTHER"
			},
			{
				"name": "pdf",
				"salience": 0.009256074,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.008199008,
				"type": "OTHER"
			},
			{
				"name": "occasion",
				"salience": 0.00814605,
				"type": "EVENT"
			},
			{
				"name": "International Campaign to Abolish Nuclear",
				"salience": 0.0077734864,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.0074991276,
				"type": "LOCATION"
			},
			{
				"name": "abolition",
				"salience": 0.006495792,
				"type": "EVENT"
			},
			{
				"name": "security",
				"salience": 0.0062538106,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.0062538106,
				"type": "OTHER"
			},
			{
				"name": "matters",
				"salience": 0.0062538106,
				"type": "OTHER"
			},
			{
				"name": "disarmament",
				"salience": 0.0062538106,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0062538106,
				"type": "EVENT"
			},
			{
				"name": "ban",
				"salience": 0.0061248094,
				"type": "OTHER"
			},
			{
				"name": "L.41",
				"salience": 0.00570398,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.0054863724,
				"type": "LOCATION"
			},
			{
				"name": "proponent",
				"salience": 0.0053049577,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0053049577,
				"type": "LOCATION"
			},
			{
				"name": "powers",
				"salience": 0.0043588853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035jnk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atomic_bombings_of_Hiroshima_and_Nagasaki"
				},
				"name": "Hiroshima",
				"salience": 0.004027863,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.003964503,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vp7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_General_Assembly"
				},
				"name": "UN General Assembly",
				"salience": 0.0038520782,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.00372119,
				"type": "OTHER"
			},
			{
				"name": "ban",
				"salience": 0.0033350743,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.002888217,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.0024411029,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0024411029,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0024411029,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "United Kingdom",
				"salience": 0.0024411029,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0024411029,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0024411029,
				"type": "LOCATION"
			},
			{
				"name": "bombings",
				"salience": 0.0021578954,
				"type": "EVENT"
			},
			{
				"name": "FirstCommittee pic.twitter.com/SM5mFzSXzf",
				"salience": 0.0017780961,
				"type": "OTHER"
			},
			{
				"name": "#goodbyenukes",
				"salience": 0.0017780961,
				"type": "OTHER"
			},
			{
				"name": "Michael Hurley",
				"salience": 0.0017780961,
				"type": "PERSON"
			},
			{
				"name": "@mdghurley",
				"salience": 0.0017780961,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0011903851,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "828",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Nuke.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.7,
			"score": 0.3
		},
		"shares": "828",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Co-sponsored by 57 nations, L41 calls for a 2017 conference ‘to negotiate a legally binding instrument to prohibit nuclear weapons, leading towards their total elimination’ The United Nations on Thursday adopted a landmark resolution calling for the ultimate elimination of nuclear weapons worldwide.\nResolution L.41 (pdf) was accepted by a vote of 123-38, with 16 member nations abstaining. The vote was held during a meeting of the First Committee of the UN General Assembly, which deals with disarmament and international security matters.\n“For seven decades, the UN has warned of the dangers of nuclear weapons, and people globally have campaigned for their abolition. Today the majority of states finally resolved to outlaw these weapons,” said Beatrice Fihn, executive director of International Campaign to Abolish Nuclear weapons (ICAN).\nSetsuko Thurlow , a survivor of the Hiroshima and leading proponent of a ban, also celebrated Thursday’s vote.\n“This is a truly historic moment for the entire world,” Thurlow said. “For those of us who survived the atomic bombings of Hiroshima and Nagasaki, it is a very joyous occasion. We have been waiting so long for this day to come.”\nAs expected, nuclear powers including the United States, France, Canada, Israel, Russia, and the United Kingdom, as well as several of their European allies, were among the nations who voted against the ban.\nIt was a long journey to get to this point, but totally worth it! #goodbyenukes #FirstCommittee pic.twitter.com/SM5mFzSXzf\n— Michael Hurley (@mdghurley) October 27, 2016",
		"thread_title": "US Votes 'No' As UN Adopts Landmark Resolution Calling to Ban Nuclear Weapons",
		"title": "US Votes 'No' As UN Adopts Landmark Resolution Calling to Ban Nuclear Weapons",
		"type": "bs",
		"uuid": "af3f4b94ef999152afb86508a1d85fe2c84f3118"
	},
	"-KhIhph5Z1eTT3r7uXSW": {
		"author": "The Man",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:26:48.907+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Yankee K",
				"salience": 0.54542434,
				"type": "OTHER"
			},
			{
				"name": "I_I NT5",
				"salience": 0.45457566,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/russia-2.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-29T02:52:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "fu – ck the Yankee K I_I NT5 – ha ha ha",
		"thread_title": "Putin Warns “US Has Pushed Russia Back Into Nuclear Arms Race”",
		"title": "",
		"type": "bs",
		"uuid": "2da2d86c9a8d9592f1a5023f4512cf4f23aad228"
	},
	"-KhIhpqes9v5dJb79K4Y": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:26:59.074+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.27422115,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.15101968,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.13852814,
				"type": "ORGANIZATION"
			},
			{
				"name": "predictions",
				"salience": 0.06592842,
				"type": "OTHER"
			},
			{
				"name": "member nations",
				"salience": 0.039345227,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0367243,
				"type": "LOCATION"
			},
			{
				"name": "hysteria",
				"salience": 0.034181226,
				"type": "OTHER"
			},
			{
				"name": "military attacks",
				"salience": 0.034181226,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.031494144,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fc50",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-war_movement"
				},
				"name": "ANTIWAR",
				"salience": 0.021209892,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.01817585,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.01719799,
				"type": "PERSON"
			},
			{
				"name": "effect",
				"salience": 0.014244514,
				"type": "OTHER"
			},
			{
				"name": "assurance",
				"salience": 0.014244514,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.008429167,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.0059936233,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0059183454,
				"type": "OTHER"
			},
			{
				"name": "predictions",
				"salience": 0.005420905,
				"type": "OTHER"
			},
			{
				"name": "ouster",
				"salience": 0.0053930045,
				"type": "EVENT"
			},
			{
				"name": "military spending",
				"salience": 0.0051270146,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0051270146,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0050488906,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.0049361405,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0044610733,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.004187601,
				"type": "OTHER"
			},
			{
				"name": "banana republic",
				"salience": 0.004187601,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.004187601,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hr2c9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Ukraine"
				},
				"name": "West",
				"salience": 0.003677169,
				"type": "LOCATION"
			},
			{
				"name": "ground troops",
				"salience": 0.0031298927,
				"type": "PERSON"
			},
			{
				"name": "border",
				"salience": 0.0031298927,
				"type": "LOCATION"
			},
			{
				"name": "numbers",
				"salience": 0.0031298927,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0031298927,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.002633135,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.002633135,
				"type": "LOCATION"
			},
			{
				"name": "civil war",
				"salience": 0.0022804292,
				"type": "EVENT"
			},
			{
				"name": "east",
				"salience": 0.0022804292,
				"type": "LOCATION"
			},
			{
				"name": "military leaders",
				"salience": 0.0022804292,
				"type": "PERSON"
			},
			{
				"name": "tanks",
				"salience": 0.0022804292,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0021346523,
				"type": "LOCATION"
			},
			{
				"name": "involvement",
				"salience": 0.002034677,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07lz5p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russophilia"
				},
				"name": "pro-Russian",
				"salience": 0.0019274892,
				"type": "LOCATION"
			},
			{
				"name": "plots",
				"salience": 0.0017039168,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0017039168,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.000796355,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/14877155_1469308609764416_1205231045_n.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.007",
		"text": "( ANTIWAR ) Complaining about Western “hysteria” surrounding repeated predictions of Russian military attacks on NATO member nations, Russian President Vladimir Putin sought to resolve two solid years of predictions to that effect with a straightforward assurance that “ Russia is not going to attack anyone .” Putin accused Western nations of having “mythical, dreamt-up problems,” and insisted the idea that Russia was going to attack the West was “ simply stupid and unrealistic .” He added that he believes the idea is being played up to justify bigger military spending.\nThe Russian president also sought to dismiss allegations that he is plotting to rig the US elections to his own benefit, noting that the US is a great power and not some banana republic with an easily manipulated political system. Russia has repeatedly denied involvement in such plots.\nNATO has played up the Russian threat to justify sending over 40,000 ground troops to the Russian border, with ever-growing numbers announced all the time. Such predictions started after the ouster of a pro-Russian government in Ukraine led to a civil war in that country’s east, with NATO military leaders repeatedly predicting Russian tanks rolling across Ukraine into NATO countries.",
		"thread_title": "Putin: \"Russia Is Not Going to Attack Anyone\"",
		"title": "Putin: \"Russia Is Not Going to Attack Anyone\"",
		"type": "bs",
		"uuid": "37c43f93bea394bddea3e367fff440edca06fe43"
	},
	"-KhIhq45pMVF4OwBMlcv": {
		"author": "Amando Flavio",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:27:18.423+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01p4vl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ashton_Kutcher"
				},
				"name": "Christopher Ashton Kutcher",
				"salience": 0.3341674,
				"type": "PERSON"
			},
			{
				"name": "traffickers",
				"salience": 0.05687276,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.038321156,
				"type": "OTHER"
			},
			{
				"name": "entertainment industry",
				"salience": 0.031219598,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019pm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Demi_Moore"
				},
				"name": "Demi Moore",
				"salience": 0.023345942,
				"type": "PERSON"
			},
			{
				"name": "investor",
				"salience": 0.019691281,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.019292409,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.018527556,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.01848879,
				"type": "OTHER"
			},
			{
				"name": "investments",
				"salience": 0.01848879,
				"type": "OTHER"
			},
			{
				"name": "venture capitalist",
				"salience": 0.016022556,
				"type": "OTHER"
			},
			{
				"name": "technology startups",
				"salience": 0.016022556,
				"type": "OTHER"
			},
			{
				"name": "Technology companies",
				"salience": 0.015704341,
				"type": "ORGANIZATION"
			},
			{
				"name": "sex trafficking",
				"salience": 0.011694992,
				"type": "OTHER"
			},
			{
				"name": "human trafficking",
				"salience": 0.010177074,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06wcbt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foursquare"
				},
				"name": "Foursquare",
				"salience": 0.009880997,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0svqyn7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Airbnb"
				},
				"name": "Airbnb",
				"salience": 0.009880997,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fq3bg1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Path_(social_network)"
				},
				"name": "Path",
				"salience": 0.009880997,
				"type": "LOCATION"
			},
			{
				"name": "trade",
				"salience": 0.009316596,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.008969755,
				"type": "OTHER"
			},
			{
				"name": "human",
				"salience": 0.00845536,
				"type": "PERSON"
			},
			{
				"name": "traffickers",
				"salience": 0.007851575,
				"type": "OTHER"
			},
			{
				"name": "businessman",
				"salience": 0.007636151,
				"type": "PERSON"
			},
			{
				"name": "figure",
				"salience": 0.007636151,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.0074194027,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.007233983,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0066141896,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0066141896,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0066141896,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0066141896,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0066141896,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0066141896,
				"type": "LOCATION"
			},
			{
				"name": "Non-Governmental Organizations",
				"salience": 0.005932537,
				"type": "ORGANIZATION"
			},
			{
				"name": "trade",
				"salience": 0.0059077456,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.005711426,
				"type": "OTHER"
			},
			{
				"name": "gadgets",
				"salience": 0.0056819883,
				"type": "OTHER"
			},
			{
				"name": "technology",
				"salience": 0.0055935546,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0053572957,
				"type": "LOCATION"
			},
			{
				"name": "efforts",
				"salience": 0.0053572957,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.005243405,
				"type": "OTHER"
			},
			{
				"name": "slavery",
				"salience": 0.0051575857,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.0051575857,
				"type": "OTHER"
			},
			{
				"name": "sexual slavery",
				"salience": 0.0051575857,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.00475886,
				"type": "OTHER"
			},
			{
				"name": "human rights activists",
				"salience": 0.004639822,
				"type": "PERSON"
			},
			{
				"name": "individuals",
				"salience": 0.004639822,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.004639822,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.004639822,
				"type": "OTHER"
			},
			{
				"name": "unemployment",
				"salience": 0.004639822,
				"type": "OTHER"
			},
			{
				"name": "poverty levels",
				"salience": 0.004639822,
				"type": "OTHER"
			},
			{
				"name": "labor",
				"salience": 0.0044668163,
				"type": "OTHER"
			},
			{
				"name": "humans",
				"salience": 0.0044668163,
				"type": "PERSON"
			},
			{
				"name": "coercion",
				"salience": 0.0044668163,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.0044668163,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0044668163,
				"type": "PERSON"
			},
			{
				"name": "purpose",
				"salience": 0.0044668163,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.004374592,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026wfg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Skype"
				},
				"name": "Skype",
				"salience": 0.0041782963,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bmfcbs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fab_(website)"
				},
				"name": "Fab.com",
				"salience": 0.00407376,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.003918217,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.003788552,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.003788552,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.003693754,
				"type": "OTHER"
			},
			{
				"name": "traffickers",
				"salience": 0.0036502182,
				"type": "OTHER"
			},
			{
				"name": "task force",
				"salience": 0.0036199968,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.0032990656,
				"type": "ORGANIZATION"
			},
			{
				"name": "technology companies",
				"salience": 0.0032687315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0s8xxt6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thorn_(organization)"
				},
				"name": "Thorn",
				"salience": 0.003037159,
				"type": "ORGANIZATION"
			},
			{
				"name": "Thorn Task Technical Force",
				"salience": 0.0030211192,
				"type": "ORGANIZATION"
			},
			{
				"name": "resources",
				"salience": 0.0028306907,
				"type": "OTHER"
			},
			{
				"name": "corners",
				"salience": 0.0028306907,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.0027372986,
				"type": "PERSON"
			},
			{
				"name": "sex-trafficking",
				"salience": 0.0027272985,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0026706452,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.0026370082,
				"type": "ORGANIZATION"
			},
			{
				"name": "trade",
				"salience": 0.0024030106,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0023810475,
				"type": "PERSON"
			},
			{
				"name": "Internet",
				"salience": 0.0021324917,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.0021324917,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0020618788,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0020618788,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0020618788,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0019849306,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.0017788246,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0017788246,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v48rh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Imgur"
				},
				"name": "Imgur",
				"salience": 0.0017425697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0nbtf_n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Snapchat"
				},
				"name": "Snapchat",
				"salience": 0.0017425697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/019rl6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yahoo!"
				},
				"name": "Yahoo",
				"salience": 0.0017425697,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0017425697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.0017425697,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0017425697,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0015403378,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.0015403378,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-1-40-e1477305721977.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Christopher Ashton Kutcher is a well-known figure in the American entertainment industry. Apart from acting, Kutcher is also an investor. A venture capitalist, Kutcher has successfully invested in several high technology startups with some of his investments including Skype, Foursquare, Airbnb, Path and Fab.com. But despite being a businessman and a public figure, societal problems are dear to his heart. In 2008, Kutcher and his ex-wife, Demi Moore decided to tackle one of the more serious crimes facing our modern world – human/sex trafficking.\nBy basic definition, human trafficking is the trade of humans, most commonly for the purpose of sexual slavery, forced labor or commercial sexual exploitation. The trade is a modern form of slavery . It involves controlling a person through force, fraud, or coercion to exploit the victim. Over the years, the United Nations, International Non-Governmental Organizations, human rights activists, and individuals have all stepped up efforts in order to end the trade. However, due to the high rate of unemployment and rising poverty levels in some nations, the trade is still secretly thriving.\nAlso, with the rise of the Internet and technology, it is becoming increasingly easy for traffickers to lure people, especially young girls, into the dirty business. Mostly, traffickers will hide on the deep web, using sophisticated gadgets to carry out their trade.\nKutcher and Moore decided to concentrate their efforts on the Internet, to thwart the trade of the traffickers. They set up an organization called Thorn. Thorn’s mission is very simple: to eliminate sex-trafficking and child exploitation over the Internet.\nWith the help of around 20 technology companies, they set up the Thorn Task Technical Force. Technology companies such as Facebook, Google, Twitter, Yahoo!, Snapchat and Imgur are all part of this task force.\nThey dedicate their time and resources to searching the darker corners of the Internet, hunting out traffickers who have been involving in trafficking innocent people. Since establishing Thorn in 2008, the organization has so far, identified and rescued over 6,000 trafficking victims and captured over 2,000 traffickers – many of which are now in the process of facing criminal charges.",
		"thread_title": "Ashton Kutcher Rescues 6,000 Sex Trafficking Victims, Arrests over 2,000 Traffickers [Video]",
		"title": "Ashton Kutcher Rescues 6,000 Sex Trafficking Victims, Arrests over 2,000 Traffickers [Video]",
		"type": "bs",
		"uuid": "58a42fec55567592fa215fa0f5b461e0dec233ae"
	},
	"-KhIhqKA6ps9wfS0sV4-": {
		"author": "Vandita",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T14:28:49.496+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0gjwh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tetrahydrocannabinol"
				},
				"name": "THC",
				"salience": 0.09028231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nw5g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Cancer_Institute"
				},
				"name": "National Cancer Institute",
				"salience": 0.0386341,
				"type": "ORGANIZATION"
			},
			{
				"name": "increase",
				"salience": 0.038522102,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j_5ft6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tetrahydrocannabinolic_acid"
				},
				"name": "THCA",
				"salience": 0.03609982,
				"type": "ORGANIZATION"
			},
			{
				"name": "plant",
				"salience": 0.03229378,
				"type": "LOCATION"
			},
			{
				"name": "Tetra Hydro Cannabinolic-Acid",
				"salience": 0.031806055,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.031795952,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.029618872,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.029399753,
				"type": "OTHER"
			},
			{
				"name": "cannabis",
				"salience": 0.027952505,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "epilepsy",
				"salience": 0.026572343,
				"type": "OTHER"
			},
			{
				"name": "sclerosis",
				"salience": 0.026572343,
				"type": "OTHER"
			},
			{
				"name": "cannabis oil",
				"salience": 0.026572343,
				"type": "OTHER"
			},
			{
				"name": "CBDA",
				"salience": 0.025410654,
				"type": "OTHER"
			},
			{
				"name": "compounds",
				"salience": 0.023625657,
				"type": "OTHER"
			},
			{
				"name": "muscle spasms",
				"salience": 0.023038873,
				"type": "OTHER"
			},
			{
				"name": "cures",
				"salience": 0.023038873,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.021767505,
				"type": "PERSON"
			},
			{
				"name": "cannabinoids",
				"salience": 0.01743701,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "William Courtney",
				"salience": 0.0161566,
				"type": "PERSON"
			},
			{
				"name": "use",
				"salience": 0.015203039,
				"type": "OTHER"
			},
			{
				"name": "cannabis oil",
				"salience": 0.013631574,
				"type": "OTHER"
			},
			{
				"name": "cannabis plant",
				"salience": 0.013553113,
				"type": "OTHER"
			},
			{
				"name": "cancer cells",
				"salience": 0.011811159,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.011811159,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.011811159,
				"type": "OTHER"
			},
			{
				"name": "cannabis",
				"salience": 0.01157277,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.010593261,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.009454281,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.008123241,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "benefits cannabis",
				"salience": 0.007820771,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.007820771,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.0074348743,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.007157966,
				"type": "OTHER"
			},
			{
				"name": "liver diseases",
				"salience": 0.006742155,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.006742155,
				"type": "OTHER"
			},
			{
				"name": "diseases",
				"salience": 0.006742155,
				"type": "OTHER"
			},
			{
				"name": "diseases",
				"salience": 0.006742155,
				"type": "OTHER"
			},
			{
				"name": "cannabinoids",
				"salience": 0.006634628,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.006634628,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cannabis",
				"salience": 0.006634628,
				"type": "OTHER"
			},
			{
				"name": "sclerosis",
				"salience": 0.0056256703,
				"type": "OTHER"
			},
			{
				"name": "fibromyalgia",
				"salience": 0.0056256703,
				"type": "OTHER"
			},
			{
				"name": "epilepsy",
				"salience": 0.0056256703,
				"type": "OTHER"
			},
			{
				"name": "inflammation",
				"salience": 0.005125573,
				"type": "OTHER"
			},
			{
				"name": "cannabis",
				"salience": 0.004958674,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "conditions",
				"salience": 0.004872419,
				"type": "OTHER"
			},
			{
				"name": "liver cirrhosis",
				"salience": 0.004872419,
				"type": "OTHER"
			},
			{
				"name": "diabetes",
				"salience": 0.004872419,
				"type": "OTHER"
			},
			{
				"name": "lifestyle",
				"salience": 0.004872419,
				"type": "OTHER"
			},
			{
				"name": "brain disorders",
				"salience": 0.004872419,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.004597157,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.0043700584,
				"type": "OTHER"
			},
			{
				"name": "health benefits",
				"salience": 0.0042071156,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.003946158,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.0037989987,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0035951592,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0035683,
				"type": "OTHER"
			},
			{
				"name": "health issues",
				"salience": 0.0034610718,
				"type": "OTHER"
			},
			{
				"name": "each",
				"salience": 0.0034174952,
				"type": "OTHER"
			},
			{
				"name": "smoke",
				"salience": 0.0034174952,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0034174952,
				"type": "OTHER"
			},
			{
				"name": "cannabis specialist",
				"salience": 0.0032900258,
				"type": "PERSON"
			},
			{
				"name": "therapy",
				"salience": 0.0032900258,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0032220767,
				"type": "OTHER"
			},
			{
				"name": "Cannabidiolic-Acid",
				"salience": 0.0031072798,
				"type": "OTHER"
			},
			{
				"name": "essential amino acids",
				"salience": 0.0030787096,
				"type": "OTHER"
			},
			{
				"name": "fatty acids",
				"salience": 0.0030787096,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0030004364,
				"type": "LOCATION"
			},
			{
				"name": "dosages",
				"salience": 0.0027903158,
				"type": "OTHER"
			},
			{
				"name": "high",
				"salience": 0.0027903158,
				"type": "OTHER"
			},
			{
				"name": "CB1 receptor agonist",
				"salience": 0.0027903158,
				"type": "OTHER"
			},
			{
				"name": "cannabis",
				"salience": 0.0026993798,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "effects",
				"salience": 0.0025975925,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0025024228,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0024733942,
				"type": "OTHER"
			},
			{
				"name": "nutrients",
				"salience": 0.002407372,
				"type": "OTHER"
			},
			{
				"name": "supplement",
				"salience": 0.002407372,
				"type": "OTHER"
			},
			{
				"name": "cannabinoid acids",
				"salience": 0.0022426415,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04klcx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cannabidiol"
				},
				"name": "CBD",
				"salience": 0.0021040493,
				"type": "ORGANIZATION"
			},
			{
				"name": "diseases",
				"salience": 0.0021021084,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.002084696,
				"type": "OTHER"
			},
			{
				"name": "terpenes",
				"salience": 0.002084696,
				"type": "OTHER"
			},
			{
				"name": "vitamins",
				"salience": 0.002084696,
				"type": "OTHER"
			},
			{
				"name": "proteins",
				"salience": 0.002084696,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.002084696,
				"type": "OTHER"
			},
			{
				"name": "treatments",
				"salience": 0.002084696,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0020255325,
				"type": "LOCATION"
			},
			{
				"name": "properties",
				"salience": 0.0019420293,
				"type": "OTHER"
			},
			{
				"name": "properties",
				"salience": 0.0019420293,
				"type": "OTHER"
			},
			{
				"name": "properties",
				"salience": 0.0019420293,
				"type": "OTHER"
			},
			{
				"name": "fibromyalgia",
				"salience": 0.0017534944,
				"type": "OTHER"
			},
			{
				"name": "antioxidants",
				"salience": 0.0017534944,
				"type": "OTHER"
			},
			{
				"name": "nutrients",
				"salience": 0.0017534944,
				"type": "OTHER"
			},
			{
				"name": "glaucoma",
				"salience": 0.0015184118,
				"type": "OTHER"
			},
			{
				"name": "irritable bowel syndrome",
				"salience": 0.0015184118,
				"type": "OTHER"
			},
			{
				"name": "migraine",
				"salience": 0.0015184118,
				"type": "OTHER"
			},
			{
				"name": "prevention",
				"salience": 0.0015184118,
				"type": "OTHER"
			},
			{
				"name": "metabolism",
				"salience": 0.0015184118,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.0015184118,
				"type": "OTHER"
			},
			{
				"name": "plant",
				"salience": 0.001450808,
				"type": "LOCATION"
			},
			{
				"name": "anti-oxidant",
				"salience": 0.001309938,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "supplement",
				"salience": 0.001309938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05nkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omega-3_fatty_acid"
				},
				"name": "Omega 3",
				"salience": 0.0012832363,
				"type": "OTHER"
			},
			{
				"name": "CBGA",
				"salience": 0.0012832363,
				"type": "ORGANIZATION"
			},
			{
				"name": "dose",
				"salience": 0.0011342954,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.0011342954,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "3",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/raw-cannabis.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.1,
			"score": 0
		},
		"shares": "3",
		"site_url": "anonhq.com",
		"spam_score": "0.689",
		"text": "There is evidence out there, supporting that cannabis oil destroys cancer , cures severe epilepsy , treats muscle spasms caused by multiple sclerosis, and saves lives . The National Cancer Institute has admitted cannabis oil kills cancer cells . It is widely acknowledged that natural compounds of the cannabis — a plant that the use, sale, and possession of is still illegal in the United States — can prevent, treat and manage inflammation; neurodegenerative diseases such as multiple sclerosis; brain disorders such as epilepsy; lifestyle related diseases such as diabetes and cancer; chronic liver diseases such as liver cirrhosis; and medical conditions such as fibromyalgia.\nMeanwhile, experts have come forward to make a strong case for eating unheated raw cannabis for maximum health benefits. While smoked or vaporized cannabis can be used as a medicinal therapy, they claim, eating raw cannabis can help prevent health issues from arising altogether — without psychoactive effect.\nDr. William Courtney, a California-based physician and a dietary raw cannabis specialist , says we are actually walking away from 99% of the benefits cannabis provides when we cook or smoke cannabis. He explains:\n“In its raw form, the cannabis plant contains both THCA (Tetra Hydro Cannabinolic-Acid) and CBDA (Cannabidiolic-Acid), two cannabinoids known for their medicinal benefits; each of which must be heated in order to produce THC and CBD, respectively. Only when you decarboxylate THCA, turning it into THC, does it cause psychoactive effects or “the high” most associated with smoking cannabis.\n“Additionally, the body is able to tolerate larger dosages of cannabinoids when cannabis is consumed in the raw form. This is because when you smoke cannabis, the THC actually acts as a CB1 receptor agonist and your body can only absorb 10 mg at a time.\n“If you don’t heat cannabis, you can go up to five or six hundred milligrams and use the plant strictly as a dietary supplement by upping the anti-oxidant and neuro-protective levels which come into play at hundreds of milligrams of CBDA and THCA. It is this dramatic increase in dose from 10 mg of psychoactive THC to the 500 mg – 1,000 mg of non-psychoactive THCA, CBDA, and CBGA that comprises the primary difference between traditional medical cannabis treatments and using cannabis as a dietary supplement.”\nIt is no secret that cannabis contains a wealth of nutrients , proteins, vitamins, terpenes, Omega 3 and 6 fatty acids, essential amino acids, and antioxidants. When eaten raw, our body is able to process much larger amounts of THCA and CBDA — which possess anti-inflammatory properties, anti-diabetic properties, and anti-ischemic properties — and converts these cannabinoid acids — linked to the prevention of chronic diseases such as migraine, irritable bowel syndrome, glaucoma, and fibromyalgia — into essential nutrients through its metabolism.",
		"thread_title": "Evidence: Eating Raw Cannabis PREVENTS Cancer, Does NOT Get You High",
		"title": "Evidence: Eating Raw Cannabis PREVENTS Cancer, Does NOT Get You High",
		"type": "bs",
		"uuid": "bdad7da31fbb9d8ea7a1b4eb701632fbe6bf01b1"
	},
	"-KhIhqQ12F12nvYK24Uw": {
		"author": "Rod",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:06:33.229+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.7204405,
				"type": "ORGANIZATION"
			},
			{
				"name": "Anonymous",
				"salience": 0.13379925,
				"type": "OTHER"
			},
			{
				"name": "creators",
				"salience": 0.030989027,
				"type": "PERSON"
			},
			{
				"name": "bullshit",
				"salience": 0.026690472,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.021858381,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.021858381,
				"type": "OTHER"
			},
			{
				"name": "buddies",
				"salience": 0.021053504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03t2s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Internet_Relay_Chat"
				},
				"name": "IRC",
				"salience": 0.013526538,
				"type": "ORGANIZATION"
			},
			{
				"name": "morons",
				"salience": 0.00978395,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/what-is-anonymous.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-29T19:03:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 1.7,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.006",
		"text": "Anonymous means the FBI. One of the creators flipped and got all his buddies busted. The FBI is in charge of the IRC and everything they have done since occupy bullshit has been the FBI. If you don’t understand that, you deserve to be arrested as morons.",
		"thread_title": "What is Anonymous?",
		"title": "",
		"type": "bs",
		"uuid": "0c1069ff8c5683fcf6ad3d883f68a577bba26990"
	},
	"-KhIhqZ1rqOd9yqn6VJS": {
		"author": "greenanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:06:36.444+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "camera",
				"salience": 0.39602664,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "streams",
				"salience": 0.10814609,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.09734202,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.07329813,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington d.c.",
				"salience": 0.04542205,
				"type": "LOCATION"
			},
			{
				"name": "girlfriend",
				"salience": 0.019727489,
				"type": "PERSON"
			},
			{
				"name": "hit",
				"salience": 0.016637618,
				"type": "OTHER"
			},
			{
				"name": "smile",
				"salience": 0.01561895,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.014459164,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.012654629,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.012654629,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.012183461,
				"type": "OTHER"
			},
			{
				"name": "self control",
				"salience": 0.011530724,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.011456215,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.011101287,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.010961716,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.010961716,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.010961716,
				"type": "OTHER"
			},
			{
				"name": "body limp",
				"salience": 0.010553415,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "facebook",
				"salience": 0.009625661,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.008952361,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.008952361,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.008952361,
				"type": "OTHER"
			},
			{
				"name": "anon",
				"salience": 0.0077885156,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.006746275,
				"type": "OTHER"
			},
			{
				"name": "mask",
				"salience": 0.005820231,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.00562829,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00562829,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0054629785,
				"type": "PERSON"
			},
			{
				"name": "Love",
				"salience": 0.0048742103,
				"type": "OTHER"
			},
			{
				"name": "wishes",
				"salience": 0.0048742103,
				"type": "OTHER"
			},
			{
				"name": "idea.",
				"salience": 0.0042053605,
				"type": "OTHER"
			},
			{
				"name": "street",
				"salience": 0.0042053605,
				"type": "LOCATION"
			},
			{
				"name": "mask",
				"salience": 0.0034181045,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0031677668,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/09/Anon-Wants-You.jpg",
		"ord_in_thread": "12",
		"participants_count": "13",
		"published": "2016-10-29T15:39:00.000+03:00",
		"replies_count": "12",
		"sentiment": {
			"magnitude": 6.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "I will be a camera and would like to know if there is any live streams for the Washington d.c. area. Can some one please post a time for those of us who do not even trust facebook. I have heard 7 and 12. I will go. I will love to learn and also support. I can take a hit and smile. I have extreme self control. I would gladly die with my body limp in the hopes some one else with step up behind me. My girlfriend said if some thing happens she would have a hard time not fighting we both agree that no matter if or if not life after life;then it will probably do some good so please do not start stuff this day. I believe that destruction of property may be needed but not yet. As some anon said above this can be a place for knowledge. We can grow this day. We can grow internally. We can grow our idea.i will look forward to meeting our family. You will be a great idea to see forming in a street. It is sad we have to meet mask to mask but i feel one day we will tell our kids we were there. We said no that day and i hope even more that one day we will be able to have the ability to say that to them. The only true hope at least one of the non- violent things you can do you do and be safe. Love and wishes",
		"thread_title": "Join Us Worldwide for the 2016 Million Mask March!",
		"title": "",
		"type": "bs",
		"uuid": "ac29b46250d6d24c0182fab60a3ecfb7c920d1bf"
	},
	"-KhIhqc_2wd_KejDJBkx": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:07:16.422+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Eli Chomsky",
				"salience": 0.39152366,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.38658157,
				"type": "PERSON"
			},
			{
				"name": "staff writer",
				"salience": 0.055736504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dsv4l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Jewish_Press"
				},
				"name": "Jewish Press",
				"salience": 0.040921208,
				"type": "ORGANIZATION"
			},
			{
				"name": "re-election",
				"salience": 0.03244353,
				"type": "EVENT"
			},
			{
				"name": "senator",
				"salience": 0.03244353,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.020143226,
				"type": "LOCATION"
			},
			{
				"name": "board",
				"salience": 0.0092015285,
				"type": "OTHER"
			},
			{
				"name": "rounds",
				"salience": 0.008493287,
				"type": "OTHER"
			},
			{
				"name": "boards",
				"salience": 0.007909391,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cr3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brooklyn"
				},
				"name": "Brooklyn",
				"salience": 0.007748977,
				"type": "LOCATION"
			},
			{
				"name": "trip",
				"salience": 0.0068535763,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/Comp-1_431098-1000x600.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "On September 5, 2006, Eli Chomsky was an editor and staff writer for the Jewish Press, and Hillary Clinton was running for a shoo-in re-election as a U.S. senator. Her trip making the rounds of editorial boards brought her to Brooklyn to meet the editorial board of the Jewish Press.",
		"thread_title": "Hillary: Leaked Audio of Her Discussing Rigging an Election in Palestine",
		"title": "Hillary: Leaked Audio of Her Discussing Rigging an Election in Palestine",
		"type": "bs",
		"uuid": "e400c4fa1c0dbf380fedc97c5f05ad4395d2dc5f"
	},
	"-KhIhqqqiqokwGo_Insp": {
		"author": "hqanon",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:07:20.330+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "protest camp",
				"salience": 0.13014364,
				"type": "LOCATION"
			},
			{
				"name": "protesters",
				"salience": 0.074347116,
				"type": "PERSON"
			},
			{
				"name": "standoff",
				"salience": 0.07098709,
				"type": "EVENT"
			},
			{
				"name": "buffalo",
				"salience": 0.05287283,
				"type": "OTHER"
			},
			{
				"name": "riot police",
				"salience": 0.05287283,
				"type": "ORGANIZATION"
			},
			{
				"name": "herd",
				"salience": 0.05157167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rzx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Standing_Rock_Indian_Reservation"
				},
				"name": "Standing Rock Sioux",
				"salience": 0.044374563,
				"type": "LOCATION"
			},
			{
				"name": "protestors",
				"salience": 0.038434796,
				"type": "PERSON"
			},
			{
				"name": "Amanda Froelich",
				"salience": 0.028413506,
				"type": "PERSON"
			},
			{
				"name": "trueactivist.com",
				"salience": 0.028413506,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.023610013,
				"type": "OTHER"
			},
			{
				"name": "law enforcement workers",
				"salience": 0.023610013,
				"type": "PERSON"
			},
			{
				"name": "protectors",
				"salience": 0.019375425,
				"type": "PERSON"
			},
			{
				"name": "protectors",
				"salience": 0.015938038,
				"type": "OTHER"
			},
			{
				"name": "standoffs",
				"salience": 0.01520354,
				"type": "EVENT"
			},
			{
				"name": "indigenous",
				"salience": 0.014634857,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.014440887,
				"type": "PERSON"
			},
			{
				"name": "arrests",
				"salience": 0.011504248,
				"type": "EVENT"
			},
			{
				"name": "rubber bullets",
				"salience": 0.009760952,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.009760952,
				"type": "OTHER"
			},
			{
				"name": "concussion cannons",
				"salience": 0.009760952,
				"type": "OTHER"
			},
			{
				"name": "tribe",
				"salience": 0.009760952,
				"type": "PERSON"
			},
			{
				"name": "standoff",
				"salience": 0.008719392,
				"type": "EVENT"
			},
			{
				"name": "DAPL",
				"salience": 0.008470274,
				"type": "ORGANIZATION"
			},
			{
				"name": "bison",
				"salience": 0.0079076635,
				"type": "OTHER"
			},
			{
				"name": "buffalo",
				"salience": 0.0079076635,
				"type": "OTHER"
			},
			{
				"name": "Dakota Access Pipeline",
				"salience": 0.0078511145,
				"type": "OTHER"
			},
			{
				"name": "herd",
				"salience": 0.0077100666,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0072050933,
				"type": "OTHER"
			},
			{
				"name": "nowhere",
				"salience": 0.006849417,
				"type": "LOCATION"
			},
			{
				"name": "macing",
				"salience": 0.006849417,
				"type": "OTHER"
			},
			{
				"name": "beatings",
				"salience": 0.006849417,
				"type": "OTHER"
			},
			{
				"name": "batons",
				"salience": 0.006849417,
				"type": "OTHER"
			},
			{
				"name": "stampede",
				"salience": 0.0066782027,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.006594204,
				"type": "OTHER"
			},
			{
				"name": "opposers",
				"salience": 0.006594204,
				"type": "PERSON"
			},
			{
				"name": "plight",
				"salience": 0.006594204,
				"type": "OTHER"
			},
			{
				"name": "riot police",
				"salience": 0.0064581507,
				"type": "ORGANIZATION"
			},
			{
				"name": "bison",
				"salience": 0.0064581507,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.006268618,
				"type": "WORK_OF_ART"
			},
			{
				"name": "guardsmen",
				"salience": 0.005593511,
				"type": "OTHER"
			},
			{
				"name": "joy",
				"salience": 0.005593511,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.005593511,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.005593511,
				"type": "PERSON"
			},
			{
				"name": "cry",
				"salience": 0.005593511,
				"type": "OTHER"
			},
			{
				"name": "burial grounds",
				"salience": 0.005119019,
				"type": "LOCATION"
			},
			{
				"name": "water protectors",
				"salience": 0.0049793827,
				"type": "OTHER"
			},
			{
				"name": "celebrities",
				"salience": 0.00417994,
				"type": "PERSON"
			},
			{
				"name": "frontlines",
				"salience": 0.00417994,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.00417994,
				"type": "PERSON"
			},
			{
				"name": "alternative media sites",
				"salience": 0.00417994,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ykz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Missouri_River"
				},
				"name": "Missouri river",
				"salience": 0.0040613892,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.003977522,
				"type": "LOCATION"
			},
			{
				"name": "Tatanka Oyate",
				"salience": 0.003977522,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0035162263,
				"type": "LOCATION"
			},
			{
				"name": "leaders",
				"salience": 0.0031232159,
				"type": "PERSON"
			},
			{
				"name": "treaty",
				"salience": 0.0030450472,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0030450472,
				"type": "LOCATION"
			},
			{
				"name": "ownership",
				"salience": 0.0030450472,
				"type": "OTHER"
			},
			{
				"name": "mistreatment",
				"salience": 0.0030450472,
				"type": "EVENT"
			},
			{
				"name": "rights",
				"salience": 0.0030450472,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0030450472,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/074bmq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shailene_Woodley"
				},
				"name": "Shailene Woodley",
				"salience": 0.0025736126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington D.C.",
				"salience": 0.0025736126,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/035rnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Ruffalo"
				},
				"name": "Mark Ruffalo",
				"salience": 0.0025736126,
				"type": "PERSON"
			},
			{
				"name": "symbol",
				"salience": 0.0022750085,
				"type": "OTHER"
			},
			{
				"name": "relays",
				"salience": 0.0022750085,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "culture",
				"salience": 0.0022750085,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0022750085,
				"type": "OTHER"
			},
			{
				"name": "gift",
				"salience": 0.0022750085,
				"type": "OTHER"
			},
			{
				"name": "appearance",
				"salience": 0.0022750085,
				"type": "OTHER"
			},
			{
				"name": "sacrifice",
				"salience": 0.0022750085,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.0016172134,
				"type": "PERSON"
			},
			{
				"name": "Tatanka Oyate",
				"salience": 0.0016172134,
				"type": "ORGANIZATION"
			},
			{
				"name": "UsUncut",
				"salience": 0.0014003817,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05y_7r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Spirit"
				},
				"name": "Great Spirit",
				"salience": 0.0014003817,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/bison2.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.001",
		"text": "By Amanda Froelich at trueactivist.com\nDuring a standoff between riot police and peaceful protesters, a herd of buffalo appeared near the Standing Rock protest camp.\nYesterday, tensions between law enforcement workers and peaceful protestors with the Standing Rock Sioux tribe escalated. A series of standoffs resulted in “protectors” being maced, shot with rubber bullets, tasered, and even attacked with sound and concussion cannons. Ultimately, 117 people were arrested in the plight to stop the four-state Dakota Access Pipeline (DAPL) from being constructed.\nAfter months of similar struggle to protect sacred burial grounds and the Missouri river, opposers of the DAPL were blessed today when a herd of buffalo appeared from nowhere. While mass arrests, macing, and beatings from batons took place, a stampede of bison appeared near the Standing Rock protest camp. Reportedly, a cry of joy erupted from the crowd, as protectors have been praying for help from the American bison (known as Tatanka Oyate) during their standoff with riot police and national guardsmen.\nAs UsUncut relays , the Native American culture honors the Tatanka Oyate as a symbol of sacrifice. Its appearance is reportedly being hailed as a gift from the Great Spirit.\nDespite impressive attention being given to the protesting of the Dakota Access Pipeline by alternative media sites , activists on the frontlines, and even celebrities such as Mark Ruffalo and Shailene Woodley , little is being done in Washington D.C. The tribal leaders are calling on state and federal governments to respect the constitutional rights of water protectors and to stop the mistreatment of the indigenous who assert their ownership of the land due to a 1881 treaty.",
		"thread_title": "Thousands Of Buffalo Appear At Site Of Standing Rock Protest [Watch]",
		"title": "Thousands Of Buffalo Appear At Site Of Standing Rock Protest [Watch]",
		"type": "bs",
		"uuid": "dd748bfc6ae040829af4b79a0ccfdac2cdc59d44"
	},
	"-KhIhquxVOzORl5qOQZ3": {
		"author": "OZbanislam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:07:40.939+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "stuff",
				"salience": 0.3046166,
				"type": "OTHER"
			},
			{
				"name": "pop",
				"salience": 0.21728094,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tabs",
				"salience": 0.17438231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.1309057,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.09872492,
				"type": "OTHER"
			},
			{
				"name": "timr",
				"salience": 0.07408953,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/dakota-access-pipeline-protests.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-29T15:25:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.024",
		"text": "When I attempt to share your stuff on Facebook it rejects it.Also some pop up tabs appear every timr I try to comment.Is your site safe?",
		"thread_title": "5 Things You Need to Know About the Dakota Access Pipeline Protests",
		"title": "",
		"type": "bs",
		"uuid": "65924f23798ba972ab4c0b9384d24e4b650c15c0"
	},
	"-KhIhqzFy5HRbz-E-ub4": {
		"author": "Anon.Dos",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:09:51.680+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Anonymous Independent & Investigative News",
				"salience": 0.3117984,
				"type": "ORGANIZATION"
			},
			{
				"name": "List",
				"salience": 0.09604417,
				"type": "OTHER"
			},
			{
				"name": "Password Managers Offering",
				"salience": 0.0776506,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.068270825,
				"type": "OTHER"
			},
			{
				"name": "Services",
				"salience": 0.0635351,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.057716828,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article",
				"salience": 0.054886855,
				"type": "WORK_OF_ART"
			},
			{
				"name": "license",
				"salience": 0.04758219,
				"type": "OTHER"
			},
			{
				"name": "@AnonymousNewsHQ",
				"salience": 0.04624112,
				"type": "PERSON"
			},
			{
				"name": "attribution",
				"salience": 0.03472392,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.03472392,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0drb3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Creative_Commons"
				},
				"name": "Creative Commons",
				"salience": 0.029369334,
				"type": "ORGANIZATION"
			},
			{
				"name": "permission",
				"salience": 0.02837461,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.027666952,
				"type": "OTHER"
			},
			{
				"name": "AnonHQ.com",
				"salience": 0.021415196,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/password-manager.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.002",
		"text": "You want to support Anonymous Independent & Investigative News? Please, follow us on Twitter: Follow @AnonymousNewsHQ This article (A List of Best Password Managers Offering Both Free and Premium Services) is a completely free and open source. You have permission to republish this article under a Creative Commons license with attribution to the author and AnonHQ.com .",
		"thread_title": "A List of Best Password Managers Offering Both Free and Premium Services",
		"title": "A List of Best Password Managers Offering Both Free and Premium Services",
		"type": "bs",
		"uuid": "a13207d9f7fe70c549568c6e37e329e34dbd34db"
	},
	"-KhIhr1m_cP2lxApxqox": {
		"author": "Jeannette",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:10:34.958+03:00",
		"domain_rank": "12993",
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "19",
		"participants_count": "18",
		"published": "2016-10-29T14:17:00.000+03:00",
		"replies_count": "21",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "🙂",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "1ab0c1720010553514360b0a089bd925f7822c76"
	},
	"-KhIitfQHaH_kj2CXriS": {
		"author": "Jeannette",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:10:35.000+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "pleasure",
				"salience": 1,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "20",
		"participants_count": "18",
		"published": "2016-10-29T14:18:00.000+03:00",
		"replies_count": "21",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0.8
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "It’s always a pleasure 🙂",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "983ff5d3f0334621b72e0a727d22ba3e6586c85a"
	},
	"-KhIitlt7iLpJ_rS9dA9": {
		"author": "Jeannette",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:10:35.099+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "woman",
				"salience": 0.79133654,
				"type": "PERSON"
			},
			{
				"name": "Anon Void",
				"salience": 0.1529783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.039399285,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.01628587,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/juli_431105.jpg",
		"ord_in_thread": "21",
		"participants_count": "18",
		"published": "2016-10-29T14:30:00.000+03:00",
		"replies_count": "21",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Hey Anon Void, I’m woman enough to admit when I’m wrong, you were right about Russia, well, Putin at least 🙂 He’s not bad at all.",
		"thread_title": "Fears Grow Julian Assange Was Extradited On ‘Guantanamo Express’",
		"title": "",
		"type": "bs",
		"uuid": "454b9db1ded56199a6d8bd0fbae905768259fe95"
	},
	"-KhIittGxJ6VLiR82ort": {
		"author": "Jesse",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:10:59.642+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05d2y1g"
				},
				"name": "robert",
				"salience": 1,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/barackobama.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-29T04:58:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "All day send that shit robert",
		"thread_title": "Wikileaks Releases First Batch Of Barack Obama Emails & They Hint At A Rigged Election",
		"title": "",
		"type": "bs",
		"uuid": "d629abe018a50e32799b241916d7bcda3cc8a5a1"
	},
	"-KhIitxLsYHPajLRICc_": {
		"author": "jim",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:12:47.778+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "lies",
				"salience": 0.71759266,
				"type": "OTHER"
			},
			{
				"name": "shame",
				"salience": 0.23096533,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.051442027,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/HILARY-WAR-CRIMES.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-29T08:28:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.8
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Absolute lies,and a tankies wet dream.Anonymous your shame is only matched by your genocide apologist solidarity.Every Syrian knows what you’ve written is false!",
		"thread_title": "The Truth that America Doesn't Want You to Know about War Crimes in Syria",
		"title": "",
		"type": "bs",
		"uuid": "307cc37568fbb0df5973ec8145aa775e7dacabd0"
	},
	"-KhIiu4HbvBYq_Rm5NLX": {
		"author": "james",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:12:58.520+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "frogadier",
				"salience": 0.28732,
				"type": "PERSON"
			},
			{
				"name": "OP",
				"salience": 0.28643957,
				"type": "OTHER"
			},
			{
				"name": "HaloPro2121",
				"salience": 0.082751736,
				"type": "OTHER"
			},
			{
				"name": "im",
				"salience": 0.05376181,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.050519973,
				"type": "OTHER"
			},
			{
				"name": "clock",
				"salience": 0.046882145,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.038393248,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.028781516,
				"type": "OTHER"
			},
			{
				"name": "alonzo",
				"salience": 0.028781516,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.028781516,
				"type": "OTHER"
			},
			{
				"name": "hes",
				"salience": 0.028781516,
				"type": "OTHER"
			},
			{
				"name": "emoji",
				"salience": 0.021020515,
				"type": "OTHER"
			},
			{
				"name": "HaloPro2121 ahahahhahhahahhahahahaha",
				"salience": 0.01778495,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/14877155_1469308609764416_1205231045_n.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-29T10:56:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.007",
		"text": "8:20 PM\n( ͡° ͜ʖ ͡°)\n8:33 PM\nHaloPro2121\nlol\n9:08 PM\nmy frogadier is totally OP\nonly like 16 more levels untill it evolves to greninja\nHaloPro2121\nnice\ni know\nbut i dont know how im going to fix that clock\nHaloPro2121\n????\nyou know from the beginning of the pokemon adventure\nHaloPro2121\noh\nélol\n9:13 PM\ni had throw it out the window hitting alonzo in the face then killed him\nHaloPro2121\nahahahhahhahahhahahahaha\nhes so flabby\nHaloPro2121\ni wish i could do that laugh crying emoji",
		"thread_title": "Putin: \"Russia Is Not Going to Attack Anyone\"",
		"title": "",
		"type": "bs",
		"uuid": "8c8506a0e0fcfc0691df3166435c626e3488bb4f"
	},
	"-KhIiu80B52_Zxb4DGk8": {
		"author": "Darth",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:13:15.122+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06nh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/StarCraft"
				},
				"name": "Starcraft",
				"salience": 0.7485469,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d2l53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hell"
				},
				"name": "Hell",
				"salience": 0.2514531,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/France-largest-Army-in-the-world-1000x600.jpg",
		"ord_in_thread": "6",
		"participants_count": "7",
		"published": "2016-10-29T05:45:00.000+03:00",
		"replies_count": "6",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0.966",
		"text": "(Starcraft)\nHell, it’s about time.",
		"thread_title": "NATO, US, & UK To Assemble Largest Troop Buildup On Russian Border Since Cold War",
		"title": "",
		"type": "bs",
		"uuid": "5023fe752856dab6e01fa16cb68ce05199c1d098"
	},
	"-KhIiuKeWrA0RbRon0SL": {
		"author": "Amando Flavio",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:13:42.319+03:00",
		"domain_rank": "12993",
		"entities": [
			{
				"name": "Researchers",
				"salience": 0.22058974,
				"type": "PERSON"
			},
			{
				"name": "paper",
				"salience": 0.11687351,
				"type": "WORK_OF_ART"
			},
			{
				"name": "messages",
				"salience": 0.05267675,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stars",
				"salience": 0.048887555,
				"type": "PERSON"
			},
			{
				"name": "aliens",
				"salience": 0.042435553,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.041631073,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.04107154,
				"type": "PERSON"
			},
			{
				"name": "researchers",
				"salience": 0.029016877,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06_10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Search_for_extraterrestrial_intelligence"
				},
				"name": "Search for Extraterrestrial Intelligence",
				"salience": 0.027045088,
				"type": "ORGANIZATION"
			},
			{
				"name": "stars",
				"salience": 0.015705077,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.014795591,
				"type": "OTHER"
			},
			{
				"name": "hypothesis",
				"salience": 0.011074582,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.011005275,
				"type": "WORK_OF_ART"
			},
			{
				"name": "paper",
				"salience": 0.011005275,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0694j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quebec"
				},
				"name": "Quebec",
				"salience": 0.010549387,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01zh3_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laval_University"
				},
				"name": "University of Laval",
				"salience": 0.010549387,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.010549387,
				"type": "LOCATION"
			},
			{
				"name": "paper",
				"salience": 0.010462887,
				"type": "WORK_OF_ART"
			},
			{
				"name": "solar type stars",
				"salience": 0.010421162,
				"type": "OTHER"
			},
			{
				"name": "modulations",
				"salience": 0.009028046,
				"type": "OTHER"
			},
			{
				"name": "fraction",
				"salience": 0.009028046,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.009021759,
				"type": "OTHER"
			},
			{
				"name": "discovery",
				"salience": 0.008362602,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.008195927,
				"type": "OTHER"
			},
			{
				"name": "Discovery",
				"salience": 0.008153731,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.007436823,
				"type": "WORK_OF_ART"
			},
			{
				"name": "messages",
				"salience": 0.0073140115,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/g/11b80c8nvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Extraterrestrial_intelligence"
				},
				"name": "Extraterrestrial Intelligence",
				"salience": 0.007261711,
				"type": "OTHER"
			},
			{
				"name": "journal",
				"salience": 0.0070629115,
				"type": "WORK_OF_ART"
			},
			{
				"name": "title",
				"salience": 0.0070629115,
				"type": "OTHER"
			},
			{
				"name": "print version",
				"salience": 0.0070629115,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Signals",
				"salience": 0.006601102,
				"type": "OTHER"
			},
			{
				"name": "fraction",
				"salience": 0.0063352594,
				"type": "OTHER"
			},
			{
				"name": "aliens",
				"salience": 0.0063352594,
				"type": "OTHER"
			},
			{
				"name": "modulations",
				"salience": 0.0063352594,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.0060183015,
				"type": "OTHER"
			},
			{
				"name": "stars",
				"salience": 0.005973381,
				"type": "PERSON"
			},
			{
				"name": "messages",
				"salience": 0.005973381,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.005973381,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0055079446,
				"type": "OTHER"
			},
			{
				"name": "modulations",
				"salience": 0.005173676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/073gh_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Publications_of_the_Astronomical_Society_of_the_Pacific"
				},
				"name": "Publications of the Astronomical Society of the Pacific",
				"salience": 0.0050235107,
				"type": "WORK_OF_ART"
			},
			{
				"name": "survey",
				"salience": 0.004955155,
				"type": "EVENT"
			},
			{
				"name": "sky",
				"salience": 0.004955155,
				"type": "LOCATION"
			},
			{
				"name": "finding",
				"salience": 0.004955155,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.004770438,
				"type": "PERSON"
			},
			{
				"name": "space",
				"salience": 0.004770438,
				"type": "LOCATION"
			},
			{
				"name": "paper",
				"salience": 0.004715023,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stars",
				"salience": 0.0044642,
				"type": "PERSON"
			},
			{
				"name": "existence",
				"salience": 0.0040462264,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0040462264,
				"type": "PERSON"
			},
			{
				"name": "set",
				"salience": 0.0040462264,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0040462264,
				"type": "OTHER"
			},
			{
				"name": "fraction",
				"salience": 0.0038662439,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.003491154,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0032768399,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0030486253,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.0030233818,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.0030233818,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0024300083,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.0024300083,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.0022777452,
				"type": "OTHER"
			},
			{
				"name": "signals",
				"salience": 0.0022777452,
				"type": "OTHER"
			},
			{
				"name": "explanations",
				"salience": 0.0022404299,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0022023316,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.0022023316,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0022023316,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0021201507,
				"type": "OTHER"
			},
			{
				"name": "hypothesis",
				"salience": 0.0021043026,
				"type": "OTHER"
			},
			{
				"name": "aliens",
				"salience": 0.0021043026,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.0019000266,
				"type": "EVENT"
			},
			{
				"name": "conclusion",
				"salience": 0.0019000266,
				"type": "OTHER"
			},
			{
				"name": "E Trottier",
				"salience": 0.0018613052,
				"type": "PERSON"
			},
			{
				"name": "EF Borra",
				"salience": 0.0018613052,
				"type": "PERSON"
			},
			{
				"name": "shape",
				"salience": 0.0017980098,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://anonhq.com/wp-content/uploads/2016/10/s-4-43-e1477576940884.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "anonhq.com",
		"spam_score": "0",
		"text": "Researchers involved in the Search for Extraterrestrial Intelligence (SETI) have announced in a paper that they have detected new messages from the stars, saying they are likely to have been generated by aliens. The researchers are from the University of Laval in Quebec, Canada. Their paper has been accepted by the journal Publications of the Astronomical Society of the Pacific and is titled ‘ Discovery of peculiar periodic spectral modulations in a small fraction of solar type stars.’\nAccording to a print version of the paper – also available online – the title of the paper was initially proposed as ‘Signals probably from Extraterrestrial Intelligence.’ However, this was later changed due to concerns raised by some observers.\nThe researchers who made the discovery revealed they heard unusual messages from deep in space. For them, they strongly believe the messages are coming from aliens.\nThe paper revealed the finding of specific modulations in just 234 out of the 2.5 million stars that have been observed during a survey of the sky. The work found that a tiny fraction of them seemed to be behaving strangely. According to the researchers, their analysis of these modulations in a tiny set of stars, may indicate that these messages are from extraterrestrial intelligence looking to alert humanity of their existence.\nThe researchers said there is no obvious explanation to what they discovered, hence their conclusion that the messages are coming from aliens.\n“We find that the detected signals have exactly the shape of an [extraterrestrial intelligence] signal predicted in the previous publication and are therefore in agreement with this hypothesis. The fact that they are only found in a very small fraction of stars within a narrow spectral range centered near the spectral type of the sun is also in agreement with the Extraterrestrial Intelligence hypothesis,” the researchers, EF Borra and E Trottier wrote in their paper.\nThe researchers also noted that further work will need to be done, in order to confirm or deny the hypothesis they have put forward. Doing so will require watching for the same signals on different equipment, aiding to discard all other explanations. This will be done by a so-called independent body.",
		"thread_title": "Researchers Detect Strange Messages from the Stars, Says it Might be Aliens",
		"title": "Researchers Detect Strange Messages from the Stars, Says it Might be Aliens",
		"type": "bs",
		"uuid": "a68f934a5b1f874aad7211bb0cce320e4ae80bb3"
	},
	"-KhIiuT1n1LVo_GOuXk5": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T04:35:34.510+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "civilians",
				"salience": 0.086546235,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.08334879,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.07936684,
				"type": "ORGANIZATION"
			},
			{
				"name": "kidnapping",
				"salience": 0.078006804,
				"type": "EVENT"
			},
			{
				"name": "group",
				"salience": 0.07551415,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02bszt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ghor_Province"
				},
				"name": "Ghor Province",
				"salience": 0.07139315,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.06673638,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.061974924,
				"type": "ORGANIZATION"
			},
			{
				"name": "Revenge' Attack 26",
				"salience": 0.052005216,
				"type": "EVENT"
			},
			{
				"name": "This Underscoring",
				"salience": 0.03838401,
				"type": "ORGANIZATION"
			},
			{
				"name": "victims",
				"salience": 0.034331027,
				"type": "PERSON"
			},
			{
				"name": "execution",
				"salience": 0.027475141,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.025805097,
				"type": "OTHER"
			},
			{
				"name": "Locals",
				"salience": 0.019660309,
				"type": "PERSON"
			},
			{
				"name": "firewood",
				"salience": 0.018612415,
				"type": "OTHER"
			},
			{
				"name": "hills",
				"salience": 0.018612415,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.018243201,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.012994442,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.012657947,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025t4py",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kochi_people"
				},
				"name": "Kuchi",
				"salience": 0.010392283,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.010342828,
				"type": "LOCATION"
			},
			{
				"name": "presence",
				"salience": 0.01021301,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.009907011,
				"type": "EVENT"
			},
			{
				"name": "sheep ownership",
				"salience": 0.009907011,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.009538543,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.008449597,
				"type": "OTHER"
			},
			{
				"name": "bone",
				"salience": 0.008093278,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0077339425,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.0077339425,
				"type": "EVENT"
			},
			{
				"name": "locals",
				"salience": 0.00631256,
				"type": "PERSON"
			},
			{
				"name": "possessions",
				"salience": 0.0059742616,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.004778323,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.0032947455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02bt3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nangarhar_Province"
				},
				"name": "Nangarhar Province",
				"salience": 0.0031351899,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0025249848,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2016/10/ghor.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T04:35:34.510+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.1,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Locals Say as Many as 42 May Have Been Killed in 'Revenge' Attack   26, 2016 Share This \nUnderscoring the group’s growing presence around Afghanistan, ISIS has launched a mass kidnapping and execution in Afghanistan’s Ghor Province today, rounding up and shooting dozens of civilians who were gathering firewood in the hills. \nThe victims were nomads from the Kuchi group, and while it was initially thought the attack might’ve been part of an ethnic conflict in the area over sheep ownership, it has since been attributed to ISIS, who officials say has a growing presence in the area and a bone to pick with the Kuchi. \nThat the victims were nomads is making it hard to nail down exactly how many people were killed, with official reports saying it was at least 30, and locals saying as many as 42 were missing and presumed to have been killed in the attack. \nGhor is far afield from the areas ISIS has been previously reported to have a major presence in Afghanistan. Early on they were claimed to be confined to the Nangarhar Province, but have also set up some territorial possessions in the far south.  ",
		"thread_title": "ISIS Kidnaps, Kills at Least 30 Civilians in Afghanistan",
		"title": "ISIS Kidnaps, Kills at Least 30 Civilians in Afghanistan",
		"type": "bs",
		"uuid": "84dc0ca985b1e913c48485fd827465e3706ac402"
	},
	"-KhIiuk_drbu55Ofg4RU": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T04:35:34.657+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Attack",
				"salience": 0.115734525,
				"type": "EVENT"
			},
			{
				"name": "School",
				"salience": 0.107183695,
				"type": "ORGANIZATION"
			},
			{
				"name": "flurry",
				"salience": 0.0843517,
				"type": "OTHER"
			},
			{
				"name": "Killing Several Children 26",
				"salience": 0.060367905,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hr9tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Observatory_for_Human_Rights"
				},
				"name": "Syrian Observatory for Human Rights",
				"salience": 0.060367905,
				"type": "ORGANIZATION"
			},
			{
				"name": "airstrikes",
				"salience": 0.04059421,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0261yrl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib_Governorate"
				},
				"name": "Idlib Province",
				"salience": 0.036026698,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.035203367,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.035203367,
				"type": "PERSON"
			},
			{
				"name": "school",
				"salience": 0.030430576,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.027770218,
				"type": "LOCATION"
			},
			{
				"name": "strikes",
				"salience": 0.02749751,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.021726746,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.020784043,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacks",
				"salience": 0.017532691,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.017455554,
				"type": "LOCATION"
			},
			{
				"name": "school children",
				"salience": 0.017246626,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.014387198,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.012744718,
				"type": "EVENT"
			},
			{
				"name": "sources",
				"salience": 0.012679137,
				"type": "OTHER"
			},
			{
				"name": "warplanes",
				"salience": 0.012207274,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.011955708,
				"type": "EVENT"
			},
			{
				"name": "target",
				"salience": 0.010356671,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.010356671,
				"type": "OTHER"
			},
			{
				"name": "location",
				"salience": 0.010356671,
				"type": "LOCATION"
			},
			{
				"name": "lack",
				"salience": 0.010097935,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.009988298,
				"type": "PERSON"
			},
			{
				"name": "tension",
				"salience": 0.009970994,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.008937643,
				"type": "ORGANIZATION"
			},
			{
				"name": "strikes",
				"salience": 0.008937643,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.008077015,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.007813133,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0077413702,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g2vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Observatory"
				},
				"name": "Observatory",
				"salience": 0.0075556654,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0075219735,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07l57d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib"
				},
				"name": "Idlib",
				"salience": 0.006328855,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.0061175926,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0058336835,
				"type": "EVENT"
			},
			{
				"name": "invasion",
				"salience": 0.005640685,
				"type": "EVENT"
			},
			{
				"name": "coast",
				"salience": 0.005640685,
				"type": "LOCATION"
			},
			{
				"name": "awhile",
				"salience": 0.005640685,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.0053897947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.004767804,
				"type": "LOCATION"
			},
			{
				"name": "tendency",
				"salience": 0.004605772,
				"type": "OTHER"
			},
			{
				"name": "Latakia Provinces",
				"salience": 0.0044416916,
				"type": "LOCATION"
			},
			{
				"name": "bystanders",
				"salience": 0.004214848,
				"type": "PERSON"
			},
			{
				"name": "any",
				"salience": 0.004214848,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T04:35:34.657+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Attack Hit a School, Killing Several Children   26, 2016 Share This \nAccording to the Syrian Observatory for Human Rights, a flurry of airstrikes today against the Idlib Province in northern Syria killed at least 35 civilians today, including an estimated 22 school children, when one of the strikes hit a school. \nThe Observatory said they weren’t clear if the attacks were carried out by Syrian or Russian warplanes, though later reports from other sources attributed the attacks to the Syrians. The Idlib Province is controlled by the al-Qaeda-linked Nusra Front. \nThis has made it a regular target for airstrikes, though the comparative lack of intelligence on the location of Nusra fighters means that the attacks have a tendency to hit civilian bystanders. Few Nusra fighters have been caught up in any of the recent strikes. \nThe main fighting between Nusra and the Syrian military recently is over Aleppo, though there is also considerable tension along the border between Idlib and Latakia Provinces, with the Syrian military having talked up a potential invasion of Idlib from the coast for awhile.  ",
		"thread_title": "Syrian Airstrike Kills 35 Civilians in Idlib",
		"title": "Syrian Airstrike Kills 35 Civilians in Idlib",
		"type": "bs",
		"uuid": "7dbc665c9a2028cd9f54d44f18ab14e6ae4d97dd"
	},
	"-KhIiuuPjtwLZxodAZpq": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T04:48:14.611+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "deployment",
				"salience": 0.33396748,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.204064,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.09576215,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01b8g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jens_Stoltenberg"
				},
				"name": "Jens Stoltenberg",
				"salience": 0.034379646,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03236385,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05jd9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Fleet"
				},
				"name": "Baltic Fleet",
				"salience": 0.024920862,
				"type": "ORGANIZATION"
			},
			{
				"name": "deployment",
				"salience": 0.019479638,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.019479638,
				"type": "PERSON"
			},
			{
				"name": "Troops Pour Into Eastern Europe",
				"salience": 0.018679598,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.016344327,
				"type": "PERSON"
			},
			{
				"name": "member nations",
				"salience": 0.01600551,
				"type": "LOCATION"
			},
			{
				"name": "ground troops",
				"salience": 0.015740383,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.015735468,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.012541577,
				"type": "PERSON"
			},
			{
				"name": "progress",
				"salience": 0.012541577,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.011937581,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.009173382,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern Europe",
				"salience": 0.008935023,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01522",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltic_Sea"
				},
				"name": "Baltic",
				"salience": 0.008751103,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.008486645,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.008486645,
				"type": "LOCATION"
			},
			{
				"name": "nations",
				"salience": 0.0057673343,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0057673343,
				"type": "WORK_OF_ART"
			},
			{
				"name": "response",
				"salience": 0.004512384,
				"type": "OTHER"
			},
			{
				"name": "diplomats",
				"salience": 0.004512384,
				"type": "PERSON"
			},
			{
				"name": "participants",
				"salience": 0.003828053,
				"type": "PERSON"
			},
			{
				"name": "complaints",
				"salience": 0.0036854458,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0036854458,
				"type": "OTHER"
			},
			{
				"name": "warship deployments",
				"salience": 0.0031293244,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0027544524,
				"type": "OTHER"
			},
			{
				"name": "coast",
				"salience": 0.0027544524,
				"type": "LOCATION"
			},
			{
				"name": "deployments",
				"salience": 0.002338594,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06t8v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slovenia"
				},
				"name": "Slovenia",
				"salience": 0.0022700496,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Albania"
				},
				"name": "Albania",
				"salience": 0.0022700496,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0022700496,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.0022491848,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.002077412,
				"type": "LOCATION"
			},
			{
				"name": "eye",
				"salience": 0.0020068143,
				"type": "OTHER"
			},
			{
				"name": "capacity",
				"salience": 0.0020068143,
				"type": "OTHER"
			},
			{
				"name": "shore",
				"salience": 0.0020068143,
				"type": "LOCATION"
			},
			{
				"name": "posts",
				"salience": 0.0020068143,
				"type": "WORK_OF_ART"
			},
			{
				"name": "size",
				"salience": 0.001931966,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0019175317,
				"type": "LOCATION"
			},
			{
				"name": "battalions",
				"salience": 0.0018599059,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norway"
				},
				"name": "Norway",
				"salience": 0.0009230582,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0154j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belgium"
				},
				"name": "Belgium",
				"salience": 0.0009230582,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01pj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Croatia"
				},
				"name": "Croatia",
				"salience": 0.0009230582,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.0009230582,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04g61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Luxembourg"
				},
				"name": "Luxembourg",
				"salience": 0.0009230582,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2010/10/europe.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T04:48:14.611+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Russia Seeks to Expand Baltic Fleet as Troops Pour Into Eastern Europe by Jason Ditz, October 26, 2016 Share This \nA day after reports NATO was soliciting even more ground troops for their deployment into Eastern Europe, officials are reporting “progress” in recruiting more troops from more member nations to participate in the deployment, intended to be around 40,000 troops along the Baltic states, near Russia’s border. \nNATO Secretary-General Jens Stoltenberg claimed to have been “ very inspired ” by the response of nations he sought troops from, after yesterday’s report quoted diplomats as saying the deployment was meant to both “confront” Russia and to undercut Republican presidential nominee Donald Trump’s complaints NATO isn’t participating enough in its own defense. \nThe new participants in the deployment include Albania, Slovenia, Luxembourg, the Netherlands, Croatia, Belgium, and Norway. The size of individual deployments from different nations is unclear, but there will be four battalions, and the US is expected to provide the majority. \nWith all these troops headed to the Baltic coast, reports out of Russia’s media suggest that they are planning some new warship deployments into their Baltic Fleet, with an eye toward enhancing their targeting capacity along the shore. Last 5 posts by Jason Ditz",
		"thread_title": "NATO Confirms Major Buildup in Eastern Europe",
		"title": "NATO Confirms Major Buildup in Eastern Europe",
		"type": "bs",
		"uuid": "eb87c16c6b50fc800d1a0ae229601928fa0ce56d"
	},
	"-KhIiv2xkpt82UBm-h31": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T05:02:45.101+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "resolution",
				"salience": 0.17544296,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.13928485,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.11448145,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.07565366,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0430_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jerusalem"
				},
				"name": "Jerusalem",
				"salience": 0.062625736,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.04601511,
				"type": "PERSON"
			},
			{
				"name": "Mosque",
				"salience": 0.03746528,
				"type": "OTHER"
			},
			{
				"name": "Claim",
				"salience": 0.026654761,
				"type": "OTHER"
			},
			{
				"name": "Muslims",
				"salience": 0.026654761,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.024869645,
				"type": "PERSON"
			},
			{
				"name": "Tax",
				"salience": 0.023138864,
				"type": "OTHER"
			},
			{
				"name": "Bill",
				"salience": 0.023138864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Fragment",
				"salience": 0.02256856,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Aqsa_Mosque"
				},
				"name": "al-Aqsa Mosque",
				"salience": 0.019731915,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05ld9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Old_Testament"
				},
				"name": "Old",
				"salience": 0.01433076,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05yg8kx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UNESCO"
				},
				"name": "UNESCO",
				"salience": 0.012969821,
				"type": "ORGANIZATION"
			},
			{
				"name": "site",
				"salience": 0.011092365,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.010541137,
				"type": "OTHER"
			},
			{
				"name": "fury",
				"salience": 0.009614722,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.009614722,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.009614722,
				"type": "LOCATION"
			},
			{
				"name": "worship",
				"salience": 0.009614722,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.007383236,
				"type": "ORGANIZATION"
			},
			{
				"name": "cave",
				"salience": 0.0071476586,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0db0q5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miri_Regev"
				},
				"name": "Miri Regev",
				"salience": 0.006118129,
				"type": "PERSON"
			},
			{
				"name": "mosque",
				"salience": 0.005646247,
				"type": "OTHER"
			},
			{
				"name": "papyrus",
				"salience": 0.0038413086,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.0036817528,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0036256192,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0035374642,
				"type": "LOCATION"
			},
			{
				"name": "papyrus strip",
				"salience": 0.0035157055,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.00345602,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.0034479925,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.0034479925,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.003300129,
				"type": "OTHER"
			},
			{
				"name": "strip",
				"salience": 0.0030977416,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0028223933,
				"type": "LOCATION"
			},
			{
				"name": "control",
				"salience": 0.0028223933,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.002455412,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.0024353752,
				"type": "EVENT"
			},
			{
				"name": "destruction",
				"salience": 0.0024353752,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.0024353752,
				"type": "OTHER"
			},
			{
				"name": "temple",
				"salience": 0.0024353752,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03hkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hebrew_language"
				},
				"name": "Hebrew",
				"salience": 0.0021287515,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0017742999,
				"type": "OTHER"
			},
			{
				"name": "precedent",
				"salience": 0.0016790839,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0015365551,
				"type": "EVENT"
			},
			{
				"name": "territory",
				"salience": 0.0015365551,
				"type": "LOCATION"
			},
			{
				"name": "posts",
				"salience": 0.0015365551,
				"type": "WORK_OF_ART"
			},
			{
				"name": "temple",
				"salience": 0.0013256876,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011480042,
				"type": "PERSON"
			},
			{
				"name": "capital",
				"salience": 0.0011480042,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.0010745758,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israelis",
				"salience": 0.0009038328,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/10/aqsa.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T05:02:45.101+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Fragment of Old Tax Bill Meant to Undercut Muslims' Claim to Important Mosque by Jason Ditz, October 26, 2016 Share This \nWhile the UNESCO resolution which recognized the al-Aqsa Mosque in Jerusalem as a “Muslim holy site of worship” was barely reported around the world, and considered fairly non-controversial, Israeli officials have been expressing fury over the matter for two solid weeks. \nAnd the Muslims may have a huge, ancient mosque that has been a key part of Islam for 1,300 years, but Israel has a small strip of papyrus they found in a cave, which they’re pretty sure is a far more conclusive document, since it mentioned the word Jerusalem and was written in Hebrew. \nIsraeli officials have claimed that the UNESCO resolution, in recognizing the mosque as important to Islam, was tantamount to denying Israel’s absolute and eternal control over the entire city of Jerusalem. Israeli Culture Minister Miri Regev said the papyrus strip proved Jerusalem “was and will remain the eternal capital of the Jewish people.” \nThe al-Aqsa mosque was built on a site which is believed to have previously housed an important Jewish temple, and some Israelis advocate the eventual destruction of the mosque and the construction of a new temple, though the details of such a construction would be hugely religiously complicated, and since the destruction of the mosque would undoubtedly start a massive war, it is considered unlikely. Still, the far-right government wants to ensure that they have some international precedent for their claim to the territory. Last 5 posts by Jason Ditz",
		"thread_title": "Israel: Ancient Papyrus Proves Jerusalem Belongs to Israel",
		"title": "Israel: Ancient Papyrus Proves Jerusalem Belongs to Israel",
		"type": "bs",
		"uuid": "4a5eaaf1ac778e0612c70b7691b790f5da4605db"
	},
	"-KhIivDs1Yr-5c_8cO5x": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T05:22:41.059+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.38141367,
				"type": "LOCATION"
			},
			{
				"name": "Embargo",
				"salience": 0.09197701,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.067429505,
				"type": "ORGANIZATION"
			},
			{
				"name": "time",
				"salience": 0.067175224,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.067175224,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.05912864,
				"type": "PERSON"
			},
			{
				"name": "embargo",
				"salience": 0.042296257,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.017390313,
				"type": "LOCATION"
			},
			{
				"name": "significance",
				"salience": 0.017120613,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.016666539,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.01617983,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "assembly",
				"salience": 0.014445007,
				"type": "EVENT"
			},
			{
				"name": "embargo",
				"salience": 0.014024392,
				"type": "OTHER"
			},
			{
				"name": "embargo",
				"salience": 0.013503744,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.010670967,
				"type": "OTHER"
			},
			{
				"name": "restrictions",
				"salience": 0.010591509,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.010145301,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.009211065,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.008910641,
				"type": "LOCATION"
			},
			{
				"name": "island nation",
				"salience": 0.00828824,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.00828824,
				"type": "PERSON"
			},
			{
				"name": "leadership",
				"salience": 0.0067700944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congressional",
				"salience": 0.006295257,
				"type": "ORGANIZATION"
			},
			{
				"name": "commerce",
				"salience": 0.0061963415,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.005107424,
				"type": "PERSON"
			},
			{
				"name": "position",
				"salience": 0.004515542,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.004515542,
				"type": "ORGANIZATION"
			},
			{
				"name": "restrictions",
				"salience": 0.0043147686,
				"type": "OTHER"
			},
			{
				"name": "restrictions",
				"salience": 0.0043147686,
				"type": "OTHER"
			},
			{
				"name": "easing",
				"salience": 0.0035498256,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0023885244,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2013/04/cu-map.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T05:22:41.059+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Embargo Remains Politically Contentious Within the US   \nFor the first time ever, the US has abstained from the UN vote denouncing the ongoing US embargo of Cuba. The resolution passed through the general assembly 191-0, with the US and Israel the only ones abstaining. \nThe UN has been voting overwhelmingly against the embargo for decades, but it is only in the past year that President Obama has started to criticize the embargo himself, and has sought to ease a lot of the long-standing restrictions on the island nation. \nThe matter is hugely politically contentious within the US, however, with many in the Republican Congress condemning the White House for easing the restrictions, and the Congressional leadership so far preventing any more easing of the restrictions on commerce. \nThe UN resolution itself is non-binding, and the real significance is not that it passed, but rather that the US abstained, which while reflecting the administration’s position is unusual, as it criticizes the US Congress internationally.  ",
		"thread_title": "US Abstains From UN Vote Against Cuba Embargo",
		"title": "US Abstains From UN Vote Against Cuba Embargo",
		"type": "bs",
		"uuid": "0426997d094499a0c8b7d1eae9ce68e65fc03e85"
	},
	"-KhIivNfAEckUXIeVYzm": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T05:41:26.157+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.12740114,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.078807116,
				"type": "LOCATION"
			},
			{
				"name": "Clashes",
				"salience": 0.078807116,
				"type": "EVENT"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.07356652,
				"type": "PERSON"
			},
			{
				"name": "Around Country",
				"salience": 0.054172408,
				"type": "ORGANIZATION"
			},
			{
				"name": "Share This Fighting",
				"salience": 0.048996914,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.036441725,
				"type": "LOCATION"
			},
			{
				"name": "clashes",
				"salience": 0.03294097,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.03294097,
				"type": "LOCATION"
			},
			{
				"name": "ceasefire",
				"salience": 0.03294097,
				"type": "EVENT"
			},
			{
				"name": "uptick",
				"salience": 0.028564844,
				"type": "EVENT"
			},
			{
				"name": "half",
				"salience": 0.028564844,
				"type": "LOCATION"
			},
			{
				"name": "ending",
				"salience": 0.028564844,
				"type": "OTHER"
			},
			{
				"name": "Ismail Ouid Cheikh Ahmed",
				"salience": 0.026882362,
				"type": "PERSON"
			},
			{
				"name": "exchange",
				"salience": 0.02125027,
				"type": "OTHER"
			},
			{
				"name": "peace process",
				"salience": 0.017589662,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ds4g09",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abd_Rabbuh_Mansur_Hadi"
				},
				"name": "Hadi",
				"salience": 0.01563889,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.0146509865,
				"type": "EVENT"
			},
			{
				"name": "border post",
				"salience": 0.011872827,
				"type": "EVENT"
			},
			{
				"name": "fighters",
				"salience": 0.011431144,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.010819204,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.010285716,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.010285716,
				"type": "PERSON"
			},
			{
				"name": "capital city",
				"salience": 0.009902876,
				"type": "LOCATION"
			},
			{
				"name": "artillery fire east",
				"salience": 0.009902876,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.009515039,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.009063917,
				"type": "EVENT"
			},
			{
				"name": "anything",
				"salience": 0.008401453,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.008028208,
				"type": "LOCATION"
			},
			{
				"name": "proposals",
				"salience": 0.0073098205,
				"type": "OTHER"
			},
			{
				"name": "pro-Saudi",
				"salience": 0.007044785,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.006337936,
				"type": "ORGANIZATION"
			},
			{
				"name": "Baida",
				"salience": 0.006337936,
				"type": "OTHER"
			},
			{
				"name": "split",
				"salience": 0.006279717,
				"type": "EVENT"
			},
			{
				"name": "blockade",
				"salience": 0.006279717,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.006279717,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.006279717,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0fyc5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sana'a"
				},
				"name": "Sanaa",
				"salience": 0.006101731,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/047vsxx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houthis"
				},
				"name": "Houthis",
				"salience": 0.006101731,
				"type": "PERSON"
			},
			{
				"name": "posts",
				"salience": 0.005283162,
				"type": "WORK_OF_ART"
			},
			{
				"name": "capital",
				"salience": 0.005283162,
				"type": "LOCATION"
			},
			{
				"name": "boundaries",
				"salience": 0.0045755627,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0045755627,
				"type": "ORGANIZATION"
			},
			{
				"name": "port",
				"salience": 0.0045755627,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035hr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Yemen"
				},
				"name": "South Yemen",
				"salience": 0.0038997573,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0034189133,
				"type": "PERSON"
			},
			{
				"name": "behest",
				"salience": 0.0034189133,
				"type": "OTHER"
			},
			{
				"name": "pro-Saudi",
				"salience": 0.0032533037,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09h6g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aden"
				},
				"name": "Aden",
				"salience": 0.0028173141,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.002104813,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.002104813,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.002104813,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/08/yemen.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T05:41:26.157+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Several Clashes Reported Around Country by Jason Ditz, October 26, 2016 Share This \nFighting was reported in several areas around Yemen over the past 24 hours, with the ending of the 72-hour ceasefire leading to a substantial uptick in clashes in several areas, mostly in the northern half of the country. \nThree different incidents were reported, with the largest an exchange of artillery fire east of the capital city of Sanaa, in which 15 Houthis and 5 pro-Saudi fighters were slain. 11 more were killed in fighting at a border post, and six others were killed in Baida. \nThe UN special envoy Ismail Ouid Cheikh Ahmed was in Yemen yesterday pushing proposals for a new peace process, though it as yet doesn’t appear that either side is willing to commit to anything, and only accepted the most recent 72-hour ceasefire because it came at the behest of US and British officials. \nSaudi Arabia attacked Yemen in March of 2015, vowing to reinstall former President Hadi in power. The war has continued since, with heavy airstrikes and a naval blockade, so far resulting in a split of the country along north-south boundaries, with the pro-Saudi forces centered on Aden, a southern port and former capital of South Yemen. Last 5 posts by Jason Ditz",
		"thread_title": "At Least 37 Killed in Yemen Fighting Since Ceasefire’s End",
		"title": "At Least 37 Killed in Yemen Fighting Since Ceasefire’s End",
		"type": "bs",
		"uuid": "354b1fc672561db49ed04a53045350ab18efc386"
	},
	"-KhIivVqgDjQGiKQGnNG": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:32:57.589+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.15430747,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.14238256,
				"type": "ORGANIZATION"
			},
			{
				"name": "Frontline Troops",
				"salience": 0.10828347,
				"type": "ORGANIZATION"
			},
			{
				"name": "special forces",
				"salience": 0.09715437,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.09526276,
				"type": "PERSON"
			},
			{
				"name": "Reinforcements",
				"salience": 0.040354747,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.039835285,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.037664473,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.035054404,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.035054404,
				"type": "EVENT"
			},
			{
				"name": "advance",
				"salience": 0.020152574,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0187352,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.016841771,
				"type": "LOCATION"
			},
			{
				"name": "resistance",
				"salience": 0.014602212,
				"type": "OTHER"
			},
			{
				"name": "obstacle",
				"salience": 0.014602212,
				"type": "OTHER"
			},
			{
				"name": "reinforcements",
				"salience": 0.011402505,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.01113758,
				"type": "ORGANIZATION"
			},
			{
				"name": "advance",
				"salience": 0.008894584,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.008220065,
				"type": "ORGANIZATION"
			},
			{
				"name": "advance",
				"salience": 0.0069973134,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0057040127,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0055615744,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.0050590937,
				"type": "PERSON"
			},
			{
				"name": "pause",
				"salience": 0.0050590937,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.004954789,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.004291841,
				"type": "EVENT"
			},
			{
				"name": "territory",
				"salience": 0.004291841,
				"type": "LOCATION"
			},
			{
				"name": "bit",
				"salience": 0.004291841,
				"type": "OTHER"
			},
			{
				"name": "Peshmerga",
				"salience": 0.004291841,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0041011185,
				"type": "ORGANIZATION"
			},
			{
				"name": "offensive",
				"salience": 0.0037035905,
				"type": "OTHER"
			},
			{
				"name": "advance",
				"salience": 0.0032344938,
				"type": "OTHER"
			},
			{
				"name": "military setbacks",
				"salience": 0.0032077315,
				"type": "OTHER"
			},
			{
				"name": "car bombs",
				"salience": 0.0032077315,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0032077315,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.0026985912,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0026985912,
				"type": "OTHER"
			},
			{
				"name": "machine gun",
				"salience": 0.0023371,
				"type": "OTHER"
			},
			{
				"name": "sniper fire",
				"salience": 0.0023371,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0023371,
				"type": "WORK_OF_ART"
			},
			{
				"name": "readiness",
				"salience": 0.0017462394,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0017462394,
				"type": "EVENT"
			},
			{
				"name": "concerns",
				"salience": 0.0017025325,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0012882081,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:32:57.589+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Frontline Troops Forced to Wait for Reinforcements by Jason Ditz, October 26, 2016 Share This \nAfter 10 days of upbeat reports on the invasion of Mosul, Iraqi special forces south of the city have run into their first major obstacle, with heavy resistance from ISIS forcing them to pause their advance and wait for additional reinforcements. \nWhile officials are treating this as a brief pause, it effectively means that ISIS has temporarily broken the southern advance into Mosul, and that only the northern advance, the Kurdish forces are still approaching the city. \nThat could be a huge problem for the Iraqi government, as in addition to fighting ISIS they’re in a bit of a territorial battle with the Kurdish Peshmerga. The Kurds have annexed a lot of territory they’ve captured, and that could make the Mosul offensive something of a race. \nIt also raises concerns about the Iraqi military’s readiness for the offensive, as in the past they have not reacted well to military setbacks. The ISIS forces have been deploying a large number of car bombs to try to slow the offensive, and the addition of machine gun and sniper fire has ultimately stopped the advance. Last 5 posts by Jason Ditz",
		"thread_title": "Iraqi Offensive South of Mosul Stalls as ISIS Resistance Grows",
		"title": "Iraqi Offensive South of Mosul Stalls as ISIS Resistance Grows",
		"type": "bs",
		"uuid": "aea09f0232c1ffa87ebe431d74b3d2003d69434f"
	},
	"-KhIivgEnRaOmXta_I_i": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:44:58.282+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.16942078,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.12963809,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.1200883,
				"type": "PERSON"
			},
			{
				"name": "Stephen Townsend",
				"salience": 0.090523414,
				"type": "PERSON"
			},
			{
				"name": "military forces",
				"salience": 0.044653095,
				"type": "ORGANIZATION"
			},
			{
				"name": "Involvement",
				"salience": 0.037402388,
				"type": "OTHER"
			},
			{
				"name": "Stop YPG",
				"salience": 0.032700095,
				"type": "OTHER"
			},
			{
				"name": "Objections",
				"salience": 0.032478914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03hz03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Raqqah"
				},
				"name": "Raqqa",
				"salience": 0.030255131,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.028425936,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.027545318,
				"type": "ORGANIZATION"
			},
			{
				"name": "YPG",
				"salience": 0.024675759,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kbh1z3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/People's_Protection_Units"
				},
				"name": "YPG",
				"salience": 0.023615986,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.018654343,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09v0xhf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mevl%C3%BCt_%C3%87avu%C5%9Fo%C4%9Flu"
				},
				"name": "Mevlut Cavusoglu",
				"salience": 0.017965164,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.017246848,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kurdish YPG",
				"salience": 0.013604923,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.013511877,
				"type": "EVENT"
			},
			{
				"name": "capital city",
				"salience": 0.013511877,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.011235337,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.008339668,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0073434357,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.007223529,
				"type": "OTHER"
			},
			{
				"name": "YPG fighters",
				"salience": 0.0063768276,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurds",
				"salience": 0.005636659,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0054908246,
				"type": "ORGANIZATION"
			},
			{
				"name": "steps",
				"salience": 0.0054010735,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0054010735,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0050736032,
				"type": "ORGANIZATION"
			},
			{
				"name": "details",
				"salience": 0.0046785125,
				"type": "OTHER"
			},
			{
				"name": "portion",
				"salience": 0.0039687855,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0039687855,
				"type": "EVENT"
			},
			{
				"name": "Townsend",
				"salience": 0.0035004835,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0n53476",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rojava"
				},
				"name": "Kurdish",
				"salience": 0.0033276062,
				"type": "PERSON"
			},
			{
				"name": "locations",
				"salience": 0.002966076,
				"type": "LOCATION"
			},
			{
				"name": "offensive",
				"salience": 0.002966076,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0027632657,
				"type": "ORGANIZATION"
			},
			{
				"name": "airstrikes",
				"salience": 0.0026968531,
				"type": "EVENT"
			},
			{
				"name": "much",
				"salience": 0.0024952118,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.002160915,
				"type": "WORK_OF_ART"
			},
			{
				"name": "territory",
				"salience": 0.002160915,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.001986358,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.001864399,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026cygp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afrin,_Syria"
				},
				"name": "Afrin",
				"salience": 0.0018264167,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0016145369,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist organization",
				"salience": 0.0016145369,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:44:58.282+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Turkish Objections Won't Stop YPG's Involvement by Jason Ditz, October 26, 2016 Share This \nUS Lt. Gen. Stephen Townsend, the leader of the US military forces in Iraq and Syria , today announced that Kurdish YPG forces will participate in the invasion of the ISIS capital city of Raqqa, despite Turkish government demands that the Kurds not be allowed to take part. \nTownsend was a bit vague on the details of Kurdish involvement, saying the US are “going to take this in steps,” and that Turkey has to realize the only way that the US is going to have enough force to take over Raqqa any time soon is with a significant portion of the YPG involved. \nTurkish Foreign Minister Mevlut Cavusoglu reiterated that his government wants only “local forces” involved in the Raqqa battle, and that the YPG, who Turkey considers a terrorist organization, must not be allowed to take part in any way. \nTurkey’s military has been attacking the YPG in several locations around Syria over the past week, including heavy airstrikes which killed an estimated 200 YPG fighters who were engaged in an offensive against ISIS around Afrin. The Turkish government has repeatedly complained the YPG is gaining too much territory in Syria, and that they must abandon much of it. Last 5 posts by Jason Ditz",
		"thread_title": "US: Kurdish Troops Will Be Involved in Invading ISIS Capital of Raqqa",
		"title": "US: Kurdish Troops Will Be Involved in Invading ISIS Capital of Raqqa",
		"type": "bs",
		"uuid": "94e73b7de98caff738c1a1d4239d58e3f1ad9ef9"
	},
	"-KhIiw-7gzADx2Q0osjA": {
		"author": "Daniel McAdams",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T08:02:30.421+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.5801828,
				"type": "LOCATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.016718969,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.012394912,
				"type": "LOCATION"
			},
			{
				"name": "shape",
				"salience": 0.010739335,
				"type": "OTHER"
			},
			{
				"name": "landscape",
				"salience": 0.010739335,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06tw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sudan"
				},
				"name": "Sudanese",
				"salience": 0.009989748,
				"type": "LOCATION"
			},
			{
				"name": "Rodrigo Duterte",
				"salience": 0.008276805,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.008035885,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0070232097,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0070232097,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0063426564,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.0063426564,
				"type": "PERSON"
			},
			{
				"name": "dictator",
				"salience": 0.0063426564,
				"type": "PERSON"
			},
			{
				"name": "disaster",
				"salience": 0.006156567,
				"type": "EVENT"
			},
			{
				"name": "story",
				"salience": 0.005852641,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03gj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hungary"
				},
				"name": "Hungarians",
				"salience": 0.0057514077,
				"type": "PERSON"
			},
			{
				"name": "ambassador",
				"salience": 0.0055926363,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.005493698,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.005493698,
				"type": "OTHER"
			},
			{
				"name": "unrest",
				"salience": 0.005493698,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03860h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Viktor_Orb%C3%A1n"
				},
				"name": "Viktor Orban",
				"salience": 0.005203566,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05rznz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Sudan"
				},
				"name": "South Sudan",
				"salience": 0.005194042,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.005142758,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06zrg5s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boko_Haram"
				},
				"name": "Boko Haram",
				"salience": 0.0050415844,
				"type": "ORGANIZATION"
			},
			{
				"name": "interventionists",
				"salience": 0.004920954,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.003952534,
				"type": "PERSON"
			},
			{
				"name": "interventionism",
				"salience": 0.0037013264,
				"type": "OTHER"
			},
			{
				"name": "deed",
				"salience": 0.0033951106,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0033834707,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0033834707,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0g9zr2q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_Spring"
				},
				"name": "Arab Spring",
				"salience": 0.0033834707,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0033422366,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0033422366,
				"type": "LOCATION"
			},
			{
				"name": "philosophy",
				"salience": 0.0033422366,
				"type": "OTHER"
			},
			{
				"name": "critics",
				"salience": 0.003283136,
				"type": "PERSON"
			},
			{
				"name": "Daniel McAdams",
				"salience": 0.0032778836,
				"type": "PERSON"
			},
			{
				"name": "newspaper",
				"salience": 0.0032208194,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0031328935,
				"type": "ORGANIZATION"
			},
			{
				"name": "democracy",
				"salience": 0.0031328935,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0030815876,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.002916209,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.002894418,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.002894418,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0027494344,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00261353,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.00261353,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.00261353,
				"type": "PERSON"
			},
			{
				"name": "interventionists",
				"salience": 0.0025958105,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0025290723,
				"type": "LOCATION"
			},
			{
				"name": "Ron Paul Institute",
				"salience": 0.0025046566,
				"type": "PERSON"
			},
			{
				"name": "interventionists",
				"salience": 0.0024827875,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0023438737,
				"type": "LOCATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.0023236473,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0022632612,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.0022632612,
				"type": "LOCATION"
			},
			{
				"name": "protests",
				"salience": 0.0022632612,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0022632612,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.0022632612,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0022632612,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.002197009,
				"type": "ORGANIZATION"
			},
			{
				"name": "regions",
				"salience": 0.0021901128,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arabs",
				"salience": 0.0021744221,
				"type": "PERSON"
			},
			{
				"name": "interventionism",
				"salience": 0.0021193265,
				"type": "OTHER"
			},
			{
				"name": "governance",
				"salience": 0.0021150298,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0020212228,
				"type": "OTHER"
			},
			{
				"name": "south",
				"salience": 0.0019539737,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.0019539737,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0019539737,
				"type": "LOCATION"
			},
			{
				"name": "cable",
				"salience": 0.0018952239,
				"type": "OTHER"
			},
			{
				"name": "Ambassador",
				"salience": 0.0018326811,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.0017936764,
				"type": "OTHER"
			},
			{
				"name": "weapons depots",
				"salience": 0.0017788176,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0017642869,
				"type": "LOCATION"
			},
			{
				"name": "examples",
				"salience": 0.0017642869,
				"type": "OTHER"
			},
			{
				"name": "track record",
				"salience": 0.0016695564,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0016695564,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0016440515,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0016428668,
				"type": "ORGANIZATION"
			},
			{
				"name": "route",
				"salience": 0.0016277535,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0016035057,
				"type": "EVENT"
			},
			{
				"name": "allies",
				"salience": 0.0015869966,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.0015869966,
				"type": "OTHER"
			},
			{
				"name": "hint",
				"salience": 0.0015869966,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.0015869966,
				"type": "OTHER"
			},
			{
				"name": "pretext",
				"salience": 0.0015869966,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0015869966,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0015869966,
				"type": "OTHER"
			},
			{
				"name": "dispute",
				"salience": 0.0015670022,
				"type": "EVENT"
			},
			{
				"name": "society",
				"salience": 0.0015277655,
				"type": "OTHER"
			},
			{
				"name": "latter",
				"salience": 0.0015277655,
				"type": "OTHER"
			},
			{
				"name": "prey",
				"salience": 0.0015277655,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.0015277655,
				"type": "PERSON"
			},
			{
				"name": "development",
				"salience": 0.0015277655,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0015277655,
				"type": "LOCATION"
			},
			{
				"name": "north",
				"salience": 0.0015277655,
				"type": "LOCATION"
			},
			{
				"name": "lunch",
				"salience": 0.0015277655,
				"type": "EVENT"
			},
			{
				"name": "foreign policy",
				"salience": 0.0015099973,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0014961929,
				"type": "OTHER"
			},
			{
				"name": "exportation",
				"salience": 0.0014961929,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0014961929,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0014961929,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0014961929,
				"type": "LOCATION"
			},
			{
				"name": "philosophy",
				"salience": 0.0014295798,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0014295798,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02gyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Diplomatic_mission"
				},
				"name": "US Embassy",
				"salience": 0.0014109912,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.001393213,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.001393213,
				"type": "LOCATION"
			},
			{
				"name": "harm",
				"salience": 0.0012955938,
				"type": "OTHER"
			},
			{
				"name": "orders",
				"salience": 0.0012955938,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0012955938,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0012955938,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0012955938,
				"type": "OTHER"
			},
			{
				"name": "magnitude",
				"salience": 0.0012955938,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.0012379073,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0011855476,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.0011587037,
				"type": "LOCATION"
			},
			{
				"name": "ally thousands",
				"salience": 0.0011177034,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0011177034,
				"type": "PERSON"
			},
			{
				"name": "foreign policy",
				"salience": 0.0010997677,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0010576756,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0010490332,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vznt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Samantha_Power"
				},
				"name": "Samantha Power",
				"salience": 0.0010199635,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04_5sg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hill"
				},
				"name": "Hill",
				"salience": 0.0009768185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0009768185,
				"type": "LOCATION"
			},
			{
				"name": "Demonization",
				"salience": 0.00097591715,
				"type": "EVENT"
			},
			{
				"name": "domination",
				"salience": 0.00096783007,
				"type": "OTHER"
			},
			{
				"name": "arsenal",
				"salience": 0.00096783007,
				"type": "OTHER"
			},
			{
				"name": "war footing",
				"salience": 0.00096783007,
				"type": "OTHER"
			},
			{
				"name": "sovereignty",
				"salience": 0.00096783007,
				"type": "OTHER"
			},
			{
				"name": "neighbor",
				"salience": 0.00096783007,
				"type": "PERSON"
			},
			{
				"name": "fruits",
				"salience": 0.00096783007,
				"type": "OTHER"
			},
			{
				"name": "Lies",
				"salience": 0.00096783007,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.00096783007,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.00096783007,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0009403524,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03w86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamism"
				},
				"name": "Islamist",
				"salience": 0.0009403524,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.0009403524,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05cgv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nigeria"
				},
				"name": "Nigeria",
				"salience": 0.0009403524,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.0009403524,
				"type": "LOCATION"
			},
			{
				"name": "benefit",
				"salience": 0.000919958,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.00087990507,
				"type": "LOCATION"
			},
			{
				"name": "neoconservatives",
				"salience": 0.0008634328,
				"type": "PERSON"
			},
			{
				"name": "announcement",
				"salience": 0.0008525514,
				"type": "EVENT"
			},
			{
				"name": "consequences",
				"salience": 0.00084558455,
				"type": "OTHER"
			},
			{
				"name": "failures",
				"salience": 0.0008140161,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0008140161,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0008140161,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hungary"
				},
				"name": "Hungarian",
				"salience": 0.00079742045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.00079742045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04d_m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khartoum"
				},
				"name": "Khartoum",
				"salience": 0.00079742045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00079742045,
				"type": "ORGANIZATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.0007517368,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0007509996,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0007290028,
				"type": "ORGANIZATION"
			},
			{
				"name": "media messages",
				"salience": 0.00070485286,
				"type": "OTHER"
			},
			{
				"name": "Manipulation",
				"salience": 0.00070485286,
				"type": "OTHER"
			},
			{
				"name": "obfuscation",
				"salience": 0.00070485286,
				"type": "OTHER"
			},
			{
				"name": "frequency",
				"salience": 0.00070485286,
				"type": "OTHER"
			},
			{
				"name": "subscribers",
				"salience": 0.00070485286,
				"type": "PERSON"
			},
			{
				"name": "Updates",
				"salience": 0.00070485286,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.00070485286,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00068791263,
				"type": "ORGANIZATION"
			},
			{
				"name": "regions",
				"salience": 0.0006734622,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0006734622,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.00065613457,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.000647865,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.000647865,
				"type": "OTHER"
			},
			{
				"name": "anniversary",
				"salience": 0.00063684164,
				"type": "EVENT"
			},
			{
				"name": "result",
				"salience": 0.00060805405,
				"type": "OTHER"
			},
			{
				"name": "democracy export",
				"salience": 0.00060805405,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.00060805405,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.00060805405,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jtm8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_China_Sea"
				},
				"name": "South China Sea",
				"salience": 0.00059565646,
				"type": "LOCATION"
			},
			{
				"name": "Liberty Report",
				"salience": 0.00059565646,
				"type": "WORK_OF_ART"
			},
			{
				"name": "structures",
				"salience": 0.00056097837,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00052650546,
				"type": "EVENT"
			},
			{
				"name": "migration",
				"salience": 0.00052650546,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.00052650546,
				"type": "EVENT"
			},
			{
				"name": "representative",
				"salience": 0.00052650546,
				"type": "PERSON"
			},
			{
				"name": "revolution",
				"salience": 0.00052650546,
				"type": "EVENT"
			},
			{
				"name": "boot",
				"salience": 0.00052650546,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "case",
				"salience": 0.0005198693,
				"type": "OTHER"
			},
			{
				"name": "The Ron Paul Institute for Peace & Prosperity",
				"salience": 0.00050097896,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.00047783463,
				"type": "OTHER"
			},
			{
				"name": "RPI",
				"salience": 0.00043378817,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.00032401885,
				"type": "ORGANIZATION"
			},
			{
				"name": "pro-US",
				"salience": 0.00032401885,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet",
				"salience": 0.00032401885,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T08:02:30.421+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nLooking over the global landscape, the areas most touched by US interventionist foreign policy are objectively in the worst, most desperate shape. The mainstream media will report that the current disaster in Syria came about because the people decided to stand up to a cruel dictator in the “Arab Spring” that swept through the greater Middle East in 2011, and that the dictator cracked down so hard it caused the violence to spin out of control. We know, of course, that is not the whole story. The US had been involved in fomenting unrest in Syria at least five years or more before violence broke out. A WikiLeaks-released cable from 2006 shows how hard the US Embassy in Damascus was working to figure out a way to overthrow the government. Shortly after the partially manufactured protests devolved into violence, the CIA moved in and began arming (and importing) rebels to finish the deed. In five years the country has been destroyed, hundreds of thousands killed, millions left without homes. \nLikewise, even most critics of the 2003 US attack on Iraq will try to salvage the philosophy of interventionism by claiming the only reason democracy hasn’t broken out is that the US military didn’t occupy the country long enough! As if being occupied by a foreign power is the route to responsible governance and the development of civil society! \nThere are too many other examples to mention, even little-discussed areas like Somalia and Nigeria – with the latter falling prey to a radical Islamist gang, Boko Haram, that benefited from a region awash in weapons after the US-led attack on Libya opened the weapons depots. \nThe US was actively involved in breaking up Sudan, which we were told was being run into the ground by “Arabs” ruling from the north who were abusing black Africans in the south. I was once invited to lunch by the Sudanese ambassador to Washington while I was working on the Hill and he asked me, “do I look like an Arab to you?” Needless to say, I doubt anyone would have guessed he was not what the US government considered a “black African.” His point was that the dispute was being created artificially by external sources. In fact the US and its allies were determined to break the country up (hint: it had a lot to do with oil) and would settle for any pretext. The result has not been the peaceful South Sudan ruled locally that was promised. Instead the new country launched with the help of “humanitarian interventionists” like US Ambassador to the UN Samantha Power has proven to be orders of magnitude worse off than when it was under Khartoum’s rule. \nThe track record of US interventionism is so universally disastrous that slowly but steadily the rest of the world is pushing back against a US foreign policy that is making their own lives less safe. Hungarian prime minister Viktor Orban, for example, gave an interview to a German newspaper recently in which he singled out US foreign policy as a force for harm rather than good in the world. \nSaid Orban: \nAmerica believes in the exportation of democracy. This sounds good; however, wherever it has been tried, entire regions often became destabilized, the consequences of which are suffering, death and migration. Additionally, often anti-democratic, extremist forces rose to power as a result of the free elections. \nBelieving in the democracy export is arrogant because it fails to take the cultural structures of the given regions into consideration. But whether you like it or not, it is the culture that determines the political culture. \nThat is pretty pointed criticism coming from a close NATO ally and the representative of a pro-US, center-right government. But this week the Hungarians celebrate the 60th anniversary of their 1956 revolution to extricate themselves from under the Soviet boot, so it is understandable that they have the idea of national sovereignty fresh in their minds. \nIn a recent episode of Ron Paul’s Liberty Report, we discussed Philippines president Rodrigo Duterte’s announcement last week that he wanted to separate his country from domination by US foreign policy. The US has been determined to use the Philippines as a weapon in its arsenal against a China newly assertive in the South China Sea, but many in the Philippines – the president included it seems – see little benefit to going on war footing against a neighbor with your ally thousands of miles away. \nWhat can the interventionists offer when the fruits of their philosophy are laid bare? Lies and obfuscation. Manipulation of media messages. Demonization of those who oppose the neoconservatives and “humanitarian” interventionists who run Washington’s foreign policy. But as Dr. Paul has said with increasing frequency lately, their failure is our big opportunity. We must educate ourselves on their failures and we must train ourselves to make the case for a pure noninterventionist foreign policy as the only way to keep us safe. \nDaniel McAdams is director of the The Ron Paul Institute for Peace & Prosperity . Reprinted from the Ron Paul Institute’s weekly review of the news, available exclusively to subscribers. Subscribe for free to RPI Updates. Read more by Daniel McAdams",
		"thread_title": "The End of Interventionism?",
		"title": "The End of Interventionism?",
		"type": "bs",
		"uuid": "469a7dfb59b7d7cbc359501252ad94f46ce7ff69"
	},
	"-KhIiwOWCjcuytAtlWhA": {
		"author": "Andrew P. Napolitano",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T08:02:30.898+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.36117446,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.12114453,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.08073795,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.06023735,
				"type": "PERSON"
			},
			{
				"name": "law enforcement jargon",
				"salience": 0.046656605,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.022522463,
				"type": "PERSON"
			},
			{
				"name": "John Giacalone",
				"salience": 0.019598497,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.014074927,
				"type": "EVENT"
			},
			{
				"name": "email scandal",
				"salience": 0.013641455,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.012265779,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05g7p6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andrew_Napolitano"
				},
				"name": "Andrew P. Napolitano",
				"salience": 0.008366086,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.007355695,
				"type": "OTHER"
			},
			{
				"name": "state secrets",
				"salience": 0.006941255,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0064046574,
				"type": "PERSON"
			},
			{
				"name": "email use",
				"salience": 0.006269627,
				"type": "OTHER"
			},
			{
				"name": "agent",
				"salience": 0.005539121,
				"type": "PERSON"
			},
			{
				"name": "motion",
				"salience": 0.0054315072,
				"type": "OTHER"
			},
			{
				"name": "gun",
				"salience": 0.0054315072,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "failure",
				"salience": 0.0054315072,
				"type": "OTHER"
			},
			{
				"name": "indictment",
				"salience": 0.0054315072,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Department of Justice",
				"salience": 0.004741221,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.004099739,
				"type": "WORK_OF_ART"
			},
			{
				"name": "agents",
				"salience": 0.0037693174,
				"type": "PERSON"
			},
			{
				"name": "back story",
				"salience": 0.0035777357,
				"type": "OTHER"
			},
			{
				"name": "servers",
				"salience": 0.0035510312,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0034249292,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.003208068,
				"type": "ORGANIZATION"
			},
			{
				"name": "use",
				"salience": 0.0032067664,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0032067664,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0030372725,
				"type": "PERSON"
			},
			{
				"name": "no",
				"salience": 0.0029589094,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0029216763,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.0027773627,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0027773627,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0027773627,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0027773627,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.0027773627,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, D.C.",
				"salience": 0.0023493227,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0019748772,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.001892824,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0018017273,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0017843852,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0017843852,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.0017178191,
				"type": "PERSON"
			},
			{
				"name": "interviews",
				"salience": 0.0016894025,
				"type": "EVENT"
			},
			{
				"name": "senior",
				"salience": 0.0015835603,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.0015835603,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0015835603,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.0015244788,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.001469029,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.0014629931,
				"type": "OTHER"
			},
			{
				"name": "justice charges",
				"salience": 0.0014629931,
				"type": "OTHER"
			},
			{
				"name": "field offices",
				"salience": 0.0014629931,
				"type": "LOCATION"
			},
			{
				"name": "agents",
				"salience": 0.0014201682,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.0014142167,
				"type": "OTHER"
			},
			{
				"name": "government criminal case",
				"salience": 0.0014142167,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0014098247,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0013896952,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0013788152,
				"type": "OTHER"
			},
			{
				"name": "espionage",
				"salience": 0.0013209889,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.0013209889,
				"type": "OTHER"
			},
			{
				"name": "senior managers",
				"salience": 0.0013209889,
				"type": "PERSON"
			},
			{
				"name": "judge",
				"salience": 0.0012512963,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0012512963,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0012512963,
				"type": "EVENT"
			},
			{
				"name": "Andrew McCabe",
				"salience": 0.0012214003,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0012199699,
				"type": "EVENT"
			},
			{
				"name": "judge",
				"salience": 0.0012046018,
				"type": "PERSON"
			},
			{
				"name": "interviewers",
				"salience": 0.0011846685,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0011681888,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0011585117,
				"type": "OTHER"
			},
			{
				"name": "round",
				"salience": 0.0011439173,
				"type": "EVENT"
			},
			{
				"name": "theft",
				"salience": 0.0011439173,
				"type": "EVENT"
			},
			{
				"name": "government property",
				"salience": 0.0011439173,
				"type": "OTHER"
			},
			{
				"name": "obstruction",
				"salience": 0.0011439173,
				"type": "OTHER"
			},
			{
				"name": "nowhere",
				"salience": 0.0011439173,
				"type": "LOCATION"
			},
			{
				"name": "design",
				"salience": 0.0011439173,
				"type": "OTHER"
			},
			{
				"name": "chief",
				"salience": 0.0011345731,
				"type": "PERSON"
			},
			{
				"name": "grand jury",
				"salience": 0.0011104259,
				"type": "PERSON"
			},
			{
				"name": "records",
				"salience": 0.0010907878,
				"type": "OTHER"
			},
			{
				"name": "comment",
				"salience": 0.0010689847,
				"type": "WORK_OF_ART"
			},
			{
				"name": "comment",
				"salience": 0.0010689847,
				"type": "WORK_OF_ART"
			},
			{
				"name": "grand jury",
				"salience": 0.0010689847,
				"type": "PERSON"
			},
			{
				"name": "grand jury",
				"salience": 0.0010689847,
				"type": "PERSON"
			},
			{
				"name": "grand jury",
				"salience": 0.0010689847,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0010532638,
				"type": "PERSON"
			},
			{
				"name": "search warrants",
				"salience": 0.0010382219,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0010258581,
				"type": "OTHER"
			},
			{
				"name": "secret",
				"salience": 0.0010258581,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.001014781,
				"type": "PERSON"
			},
			{
				"name": "subpoena power",
				"salience": 0.00097444776,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.00096716237,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.00096716237,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.00096716237,
				"type": "EVENT"
			},
			{
				"name": "The Radical Expansion",
				"salience": 0.00094784354,
				"type": "OTHER"
			},
			{
				"name": "successors",
				"salience": 0.0009262591,
				"type": "PERSON"
			},
			{
				"name": "intelligence community",
				"salience": 0.0009065429,
				"type": "OTHER"
			},
			{
				"name": "subpoenas",
				"salience": 0.0008916871,
				"type": "OTHER"
			},
			{
				"name": "search warrants",
				"salience": 0.0008916871,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0008438033,
				"type": "OTHER"
			},
			{
				"name": "bureau",
				"salience": 0.000802072,
				"type": "ORGANIZATION"
			},
			{
				"name": "primaries",
				"salience": 0.000802072,
				"type": "EVENT"
			},
			{
				"name": "circle",
				"salience": 0.000802072,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.000802072,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.000802072,
				"type": "OTHER"
			},
			{
				"name": "passion",
				"salience": 0.000802072,
				"type": "OTHER"
			},
			{
				"name": "boss",
				"salience": 0.000802072,
				"type": "PERSON"
			},
			{
				"name": "determination",
				"salience": 0.000802072,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00078928826,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.00078198645,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00077213295,
				"type": "OTHER"
			},
			{
				"name": "realization",
				"salience": 0.00077213295,
				"type": "EVENT"
			},
			{
				"name": "need",
				"salience": 0.00077213295,
				"type": "OTHER"
			},
			{
				"name": "testimony",
				"salience": 0.00077213295,
				"type": "OTHER"
			},
			{
				"name": "grand juries",
				"salience": 0.00077213295,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.00076315185,
				"type": "EVENT"
			},
			{
				"name": "Director",
				"salience": 0.0007561743,
				"type": "PERSON"
			},
			{
				"name": "injury",
				"salience": 0.0007561743,
				"type": "OTHER"
			},
			{
				"name": "head injury",
				"salience": 0.0007561743,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.00073195365,
				"type": "PERSON"
			},
			{
				"name": "request",
				"salience": 0.00071556424,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "National Security Agency",
				"salience": 0.0007136902,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.0007041228,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0007041228,
				"type": "LOCATION"
			},
			{
				"name": "place",
				"salience": 0.00068885286,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0006695701,
				"type": "OTHER"
			},
			{
				"name": "news conference",
				"salience": 0.0006617989,
				"type": "EVENT"
			},
			{
				"name": "reference",
				"salience": 0.00065478164,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.00065478164,
				"type": "OTHER"
			},
			{
				"name": "memory",
				"salience": 0.00065478164,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.00065478164,
				"type": "OTHER"
			},
			{
				"name": "gravity",
				"salience": 0.00065478164,
				"type": "OTHER"
			},
			{
				"name": "senior management",
				"salience": 0.00064124743,
				"type": "PERSON"
			},
			{
				"name": "servers",
				"salience": 0.00062562467,
				"type": "OTHER"
			},
			{
				"name": "field office",
				"salience": 0.00062562467,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.00062562467,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00062562467,
				"type": "LOCATION"
			},
			{
				"name": "reputation",
				"salience": 0.0006068071,
				"type": "OTHER"
			},
			{
				"name": "features",
				"salience": 0.0006068071,
				"type": "WORK_OF_ART"
			},
			{
				"name": "money machine",
				"salience": 0.00057679246,
				"type": "OTHER"
			},
			{
				"name": "matters",
				"salience": 0.0005730561,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0005648697,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.0005648697,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0005648697,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0005648697,
				"type": "PERSON"
			},
			{
				"name": "recent",
				"salience": 0.00053016207,
				"type": "OTHER"
			},
			{
				"name": "paperwork",
				"salience": 0.0005277937,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00052619725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00049366336,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.0004932078,
				"type": "OTHER"
			},
			{
				"name": "campaign funds",
				"salience": 0.00048912043,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.00048912043,
				"type": "EVENT"
			},
			{
				"name": "appearance",
				"salience": 0.00048912043,
				"type": "OTHER"
			},
			{
				"name": "impropriety",
				"salience": 0.00048912043,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00048912043,
				"type": "PERSON"
			},
			{
				"name": "space",
				"salience": 0.00048912043,
				"type": "LOCATION"
			},
			{
				"name": "defense witness",
				"salience": 0.00048912043,
				"type": "PERSON"
			},
			{
				"name": "trial",
				"salience": 0.00048912043,
				"type": "EVENT"
			},
			{
				"name": "espionage cases",
				"salience": 0.00048746658,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06qb8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FBI_National_Security_Branch"
				},
				"name": "FBI National Security Branch",
				"salience": 0.00047523284,
				"type": "ORGANIZATION"
			},
			{
				"name": "Powers",
				"salience": 0.0004113813,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.00040830456,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.00039306007,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0003700259,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00036841555,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00036841555,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00036841555,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.00035621022,
				"type": "PERSON"
			},
			{
				"name": "rule of law",
				"salience": 0.00035621022,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.00035621022,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Threat",
				"salience": 0.00035621022,
				"type": "OTHER"
			},
			{
				"name": "writers",
				"salience": 0.00035621022,
				"type": "PERSON"
			},
			{
				"name": "cartoonists",
				"salience": 0.00035621022,
				"type": "PERSON"
			},
			{
				"name": "COPYRIGHT",
				"salience": 0.00035621022,
				"type": "OTHER"
			},
			{
				"name": "grandfather",
				"salience": 0.00035621022,
				"type": "PERSON"
			},
			{
				"name": "stress",
				"salience": 0.00035621022,
				"type": "OTHER"
			},
			{
				"name": "bravery",
				"salience": 0.00035621022,
				"type": "OTHER"
			},
			{
				"name": "fidelity",
				"salience": 0.00035621022,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00034764872,
				"type": "LOCATION"
			},
			{
				"name": "servers",
				"salience": 0.00034034555,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00032328223,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053fc5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Senate_of_Virginia"
				},
				"name": "Virginia Senate",
				"salience": 0.0003010233,
				"type": "ORGANIZATION"
			},
			{
				"name": "www.creators.com",
				"salience": 0.00028978352,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/082tmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Creators_Syndicate"
				},
				"name": "Creators Syndicate",
				"salience": 0.00028869693,
				"type": "ORGANIZATION"
			},
			{
				"name": "standard",
				"salience": 0.00028349753,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.00026607548,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_8w2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_News"
				},
				"name": "CBS News",
				"salience": 0.00025986155,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "US Constitution",
				"salience": 0.0002531749,
				"type": "WORK_OF_ART"
			},
			{
				"name": "American Liberty",
				"salience": 0.0002192182,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News Channel",
				"salience": 0.0002192182,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0br_xl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey_Superior_Court"
				},
				"name": "Superior Court of New Jersey",
				"salience": 0.0002192182,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00016374404,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T08:02:30.898+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nWhen FBI Director James Comey announced on July 5 that the Department of Justice would not seek the indictment of Hillary Clinton for failure to safeguard state secrets related to her email use while she was secretary of state, he both jumped the gun and set in motion a series of events that surely he did not intend. Was his hand forced by the behavior of FBI agents who wouldn’t take no for an answer? Did he let the FBI become a political tool? \nHere is the back story. \nThe FBI began investigating the Clinton email scandal in the spring of 2015, when The New York Times revealed Clinton’s use of a private email address for her official governmental work and the fact that she did not preserve the emails on State Department servers, contrary to federal law. After an initial collection of evidence and a round of interviews, agents and senior managers gathered in the summer of 2015 to discuss how to proceed. It was obvious to all that a prima-facie case could be made for espionage, theft of government property and obstruction of justice charges. The consensus was to proceed with a formal criminal investigation. \nSix months later, the senior FBI agent in charge of that investigation resigned from the case and retired from the FBI because he felt the case was going \"sideways\"; that’s law enforcement jargon for \"nowhere by design.\" John Giacalone had been the chief of the New York City, Philadelphia and Washington, D.C., field offices of the FBI and, at the time of his \"sideways\" comment, was the chief of the FBI National Security Branch. \nThe reason for the \"sideways\" comment must have been Giacalone’s realization that DOJ and FBI senior management had decided that the investigation would not work in tandem with a federal grand jury. That is nearly fatal to any government criminal case. In criminal cases, the FBI and the DOJ cannot issue subpoenas for testimony or for tangible things; only grand juries can. \nGiacalone knew that without a grand jury, the FBI would be toothless, as it would have no subpoena power. He also knew that without a grand jury, the FBI would have a hard time persuading any federal judge to issue search warrants. A judge would perceive the need for search warrants to be not acute in such a case because to a judge, the absence of a grand jury can only mean a case is \"sideways\" and not a serious investigation. \nAs the investigation dragged on in secret and Donald Trump simultaneously began to rise in the Republican presidential primaries, it became more apparent to Giacalone’s successors that the goal of the FBI was to exonerate Clinton, not determine whether there was enough evidence to indict her. In late spring of this year, agents began interviewing the Clinton inner circle. \nWhen Clinton herself was interviewed on July 2 – for only four hours, during which the interviewers seemed to some in the bureau to lack aggression, passion and determination – some FBI agents privately came to the same conclusion as their former boss: The case was going sideways. \nA few determined agents were frustrated by Clinton’s professed lack of memory during her interview and her oblique reference to a recent head injury she had suffered as the probable cause of that. They sought to obtain her medical records to verify the gravity of her injury and to determine whether she had been truthful with them. They prepared the paperwork to obtain the records, only to have their request denied by Director Comey himself on July 4. \nThen some agents did the unthinkable; they reached out to colleagues in the intelligence community and asked them to obtain Clinton’s medical records so they could show them to Comey. We know that the National Security Agency can access anything that is stored digitally, including medical records. These communications took place late on July 4. \nWhen Comey learned of these efforts, he headed them off the next morning with his now infamous news conference, in which he announced that Clinton would not be indicted because the FBI had determined that her behavior, though extremely careless, was not reckless, which is the legal standard in espionage cases. He then proceeded to recount the evidence against her. He did this, no doubt, to head off the agents who had sought the Clinton medical records, whom he suspected would leak evidence against her. \nThree months later – and just weeks before Clinton will probably be elected president – we have learned that President Barack Obama regularly communicated with Clinton via her personal email servers about matters that the White House considered classified. That means that he lied when he told CBS News that he learned of the Clinton servers when the rest of us did. \nWe also learned this week that Andrew McCabe, Giacalone’s successor as head of the FBI Washington field office and presently the No. 3 person in the FBI, is married to a woman to whom the Clinton money machine in Virginia funneled about $675,000 in lawful campaign funds for a failed 2015 run for the Virginia Senate. Comey apparently saw no conflict or appearance of impropriety in having the person in charge of the Clinton investigation in such an ethically challenged space. \nWhy did this case go sideways? \nDid President Obama fear being a defense witness at Hillary Clinton’s criminal trial? Did he so fear being succeeded in office by Donald Trump that he ordered the FBI to exonerate Clinton, the rule of law be damned? Did the FBI lose its reputation for fidelity to law, bravery under stress and integrity at all times? \nThis is not your grandfather’s FBI – or your father’s. It is the Obama FBI. \nAndrew P. Napolitano, a former judge of the Superior Court of New Jersey, is the senior judicial analyst at Fox News Channel. Judge Napolitano has written seven books on the US Constitution. The most recent is Suicide Pact: The Radical Expansion of Presidential Powers and the Lethal Threat to American Liberty . To find out more about Judge Napolitano and to read features by other Creators Syndicate writers and cartoonists, visit www.creators.com . \nCOPYRIGHT 2016 ANDREW P. NAPOLITANO – DISTRIBUTED BY CREATORS.COM Read more by Andrew P. Napolitano",
		"thread_title": "What Happened to the FBI?",
		"title": "What Happened to the FBI?",
		"type": "bs",
		"uuid": "230f82f6546d687001d221eb95c453cbafa287bd"
	},
	"-KhIiw_A2kHKE0x3WLog": {
		"author": "Margaret Griffis",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T08:02:31.127+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "forces",
				"salience": 0.098921776,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.079915576,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.079513244,
				"type": "PERSON"
			},
			{
				"name": "operations",
				"salience": 0.06282013,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.06282013,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.06282013,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.062280957,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.03895506,
				"type": "ORGANIZATION"
			},
			{
				"name": "others",
				"salience": 0.028735386,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.02615289,
				"type": "LOCATION"
			},
			{
				"name": "Special forces",
				"salience": 0.023545472,
				"type": "PERSON"
			},
			{
				"name": "Abdulrahim Shamari",
				"salience": 0.019128514,
				"type": "PERSON"
			},
			{
				"name": "Security forces",
				"salience": 0.018531641,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.01712704,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0146582695,
				"type": "PERSON"
			},
			{
				"name": "militiamen",
				"salience": 0.0146582695,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0146582695,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.014113294,
				"type": "PERSON"
			},
			{
				"name": "security personnel",
				"salience": 0.013584995,
				"type": "PERSON"
			},
			{
				"name": "evacuation",
				"salience": 0.013404806,
				"type": "EVENT"
			},
			{
				"name": "hundreds",
				"salience": 0.013404806,
				"type": "OTHER"
			},
			{
				"name": "military forces",
				"salience": 0.013013682,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.010861482,
				"type": "PERSON"
			},
			{
				"name": "Dozens",
				"salience": 0.010861482,
				"type": "PERSON"
			},
			{
				"name": "dozens",
				"salience": 0.010457197,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.009823292,
				"type": "PERSON"
			},
			{
				"name": "village",
				"salience": 0.009408836,
				"type": "LOCATION"
			},
			{
				"name": "gas plant",
				"salience": 0.009058466,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.008953351,
				"type": "PERSON"
			},
			{
				"name": "militant",
				"salience": 0.008953351,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.008871679,
				"type": "EVENT"
			},
			{
				"name": "teenagers",
				"salience": 0.008342014,
				"type": "PERSON"
			},
			{
				"name": "human rights committee",
				"salience": 0.0076845065,
				"type": "ORGANIZATION"
			},
			{
				"name": "airstrike",
				"salience": 0.0066311373,
				"type": "EVENT"
			},
			{
				"name": "civilians",
				"salience": 0.0066311373,
				"type": "PERSON"
			},
			{
				"name": "Tel Keif",
				"salience": 0.0064144516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01b8yn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shura"
				},
				"name": "Shura",
				"salience": 0.0057965005,
				"type": "PERSON"
			},
			{
				"name": "Fadiliyah",
				"salience": 0.0057965005,
				"type": "OTHER"
			},
			{
				"name": "Kokjili",
				"salience": 0.0055804094,
				"type": "OTHER"
			},
			{
				"name": "Qalat",
				"salience": 0.0055804094,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg7d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jenin"
				},
				"name": "Jenin",
				"salience": 0.0055804094,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03m_n0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peshmerga"
				},
				"name": "Peshmerga",
				"salience": 0.0055804094,
				"type": "ORGANIZATION"
			},
			{
				"name": "fate",
				"salience": 0.0053908364,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v0gf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sevens_(card_game)"
				},
				"name": "Parliament",
				"salience": 0.0047331983,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04l2q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.mp"
				},
				"name": "M.P.",
				"salience": 0.0047331983,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.004401845,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.004184324,
				"type": "PERSON"
			},
			{
				"name": "hostages",
				"salience": 0.004184324,
				"type": "PERSON"
			},
			{
				"name": "human shields",
				"salience": 0.004184324,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.0036300537,
				"type": "ORGANIZATION"
			},
			{
				"name": "families",
				"salience": 0.0031263991,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.0031263991,
				"type": "PERSON"
			},
			{
				"name": "Nana",
				"salience": 0.002576196,
				"type": "PERSON"
			},
			{
				"name": "Margaret Griffis",
				"salience": 0.002576196,
				"type": "PERSON"
			},
			{
				"name": "Hammam al-Alil",
				"salience": 0.0019246072,
				"type": "PERSON"
			},
			{
				"name": "Most",
				"salience": 0.0015967357,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T08:02:31.127+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This The United Nations estimates that over 10,500 people have been displaced by operations in the Mosul region, so far, and expects that number to rise rapidly as troops close in on the city itself. Security forces have assisted in the evacuation of hundreds of people, while others have escaped on their own. Special forces are closing in on Kokjili , while Qalat and Jenin were captured . Peshmerga forces are approaching Tel Keif , where they have seized a gas plant, and dozens of militants have been killed . They also fought with militants in Fadiliyah . Dirk village was liberated . Shi’ite militiamen and military forces are clearing out Shura . Dozens of militants were killed in airstrikes there. At least 256 people were killed and seven were wounded : M.P. Abdulrahim Shamari , chair of Parliament’s human rights committee, reported that 232 civilians were executed in Hammam al-Alil , just south of Mosul. Most of the victims were former security personnel who had been kidnapped along with their families. In Mosul , an airstrike killed five civilians and wounded seven more ; eight militants were also killed . Two teenagers killed a militant , but then were pursued by other Daesh members. Their fate is unknown. A man was shot dead while trying to escape Daesh relocating hostages/human shields in Nana . Read more by Margaret Griffis",
		"thread_title": "No End in Sight for Executioners; 256 Killed in Iraq",
		"title": "No End in Sight for Executioners; 256 Killed in Iraq",
		"type": "bs",
		"uuid": "a580b3e63b91edfe091094dc352dfec3e2a40fb2"
	},
	"-KhIiwjO1BRcN3tiRxF7": {
		"author": "Daniel McAdams",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T03:08:48.329+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.26790455,
				"type": "PERSON"
			},
			{
				"name": "anniversary",
				"salience": 0.1437085,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.13108927,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07x98",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patriot_Act"
				},
				"name": "PATRIOT Act",
				"salience": 0.090800755,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0_fts0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Freedom_Act"
				},
				"name": "USA FREEDOM Act",
				"salience": 0.07201596,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bills",
				"salience": 0.05040376,
				"type": "OTHER"
			},
			{
				"name": "measure",
				"salience": 0.030776056,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.02944987,
				"type": "OTHER"
			},
			{
				"name": "Adam Dick",
				"salience": 0.02653049,
				"type": "PERSON"
			},
			{
				"name": "emergency situation",
				"salience": 0.024862286,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.024862286,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.020165445,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.017478539,
				"type": "LOCATION"
			},
			{
				"name": "some",
				"salience": 0.016830007,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dsm7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/War_Powers_Resolution"
				},
				"name": "War Powers Resolution",
				"salience": 0.008809091,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/030z4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Foreign_Intelligence_Surveillance_Court"
				},
				"name": "FISA Court",
				"salience": 0.008809091,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ron Paul Institute",
				"salience": 0.007602556,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0067220503,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0062305266,
				"type": "ORGANIZATION"
			},
			{
				"name": "government abuses",
				"salience": 0.0058223535,
				"type": "OTHER"
			},
			{
				"name": "The Ron Paul Institute for Peace & Prosperity",
				"salience": 0.0055406126,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ron Paul Liberty Report",
				"salience": 0.0035859488,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:08:48.329+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Yesterday was the 15th anniversary of President George W. Bush signing the PATRIOT Act into law. It was supposed to be only a temporary measure to address the emergency situation caused by the attacks of 9/11. Fifteen years later it has been re-authorized many times and last year some of its worst parts were codified into law in the USA FREEDOM Act. From the War Powers Resolution, to the FISA Court, to the “reform” USA FREEDOM Act, bills that were designed to rein in government abuses end up just giving government more power. Is there anything we can do about it? Ron Paul Institute Senior Fellow Adam Dick joins today’s Ron Paul Liberty Report to discuss:\n\nReprinted from The Ron Paul Institute for Peace & Prosperity . \n",
		"thread_title": "PATRIOT Act At 15: Do You Feel Safer?",
		"title": "PATRIOT Act At 15: Do You Feel Safer?",
		"type": "bs",
		"uuid": "68ea998a7a8f09afe015b6f577d6480ab36e1a0d"
	},
	"-KhIiwv2jxJMCTNvnA0M": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T03:54:22.548+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0ds4g09",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abd_Rabbuh_Mansur_Hadi"
				},
				"name": "Abd-Rabbu Mansour Hadi",
				"salience": 0.67591554,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.046093456,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03618104,
				"type": "PERSON"
			},
			{
				"name": "constitution",
				"salience": 0.029077625,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ruler",
				"salience": 0.019999858,
				"type": "OTHER"
			},
			{
				"name": "rounds",
				"salience": 0.01954042,
				"type": "OTHER"
			},
			{
				"name": "ambition",
				"salience": 0.017798388,
				"type": "OTHER"
			},
			{
				"name": "unity government",
				"salience": 0.016199736,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hadi Would Be Figurehead",
				"salience": 0.015202624,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.011021325,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.00998858,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.008772104,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.008363593,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ali Mushin Ahmar",
				"salience": 0.0081787035,
				"type": "PERSON"
			},
			{
				"name": "peace plan proposal",
				"salience": 0.0073936987,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0056733643,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00549627,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0043981797,
				"type": "OTHER"
			},
			{
				"name": "reign",
				"salience": 0.0043517104,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0037868344,
				"type": "EVENT"
			},
			{
				"name": "Elected",
				"salience": 0.0031357326,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ruler",
				"salience": 0.0030678902,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0029536271,
				"type": "EVENT"
			},
			{
				"name": "military offensive",
				"salience": 0.0026573546,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.0026573546,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.0025583461,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0025583461,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0024782661,
				"type": "OTHER"
			},
			{
				"name": "UN-mandated",
				"salience": 0.0023333838,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0021701285,
				"type": "EVENT"
			},
			{
				"name": "openness",
				"salience": 0.0021701285,
				"type": "OTHER"
			},
			{
				"name": "figurehead",
				"salience": 0.0018725377,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0018725377,
				"type": "OTHER"
			},
			{
				"name": "anti-Houthi",
				"salience": 0.0016367678,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shi'ites",
				"salience": 0.0016367678,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0016217231,
				"type": "PERSON"
			},
			{
				"name": "sides",
				"salience": 0.0016217231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/047vsxx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houthis"
				},
				"name": "Houthis",
				"salience": 0.0016173284,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.0015811501,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0014907501,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0011814226,
				"type": "WORK_OF_ART"
			},
			{
				"name": "war",
				"salience": 0.0011814226,
				"type": "EVENT"
			},
			{
				"name": "Ahmar",
				"salience": 0.0005122388,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/08/yemen.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T03:54:22.548+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Hadi Would Be Figurehead to Placate Saudis by Jason Ditz, October 27, 2016 Share This \nHeavily backed by Saudi Arabia, former Yemeni President Abd-Rabbu Mansour Hadi’s ambition to return as the ruler of Yemen appears to be waning, with a new UN peace plan proposal making the rounds that would sideline him more or less entirely. \nHadi’s position has been contentious from the start. “Elected” in 2012 in a UN-mandated vote in which no opposition was allowed, Hadi was supposed to serve two years in office leading to a new constitution and free elections. The constitution never happened, and Hadi extended his reign unilaterally in 2014. He resigned in January 2015 when his anti-Houthi military offensive turned sour and he lost the capital. \nThe Saudis, primarily opposed to the Houthis because they’re Shi’ites, insists to this day that Hadi remains the rightful ruler, and in March 2015 attacked Yemen, vowing to reinstall him. While the Houthis have expressed openness to a unity government that ends the conflict, they’ve also opposed it involving Hadi or his vice president Ali Mushin Ahmar, who they say were too corrupt to work with in a transitional government. \nThe UN plan seems largely to agree, as it would require Ahmar to resign outright, and would allow Hadi to remain only as a figurehead with no real power, instead seeking to stack the government with people both sides are likely to accept. \nThe decision to leave Hadi in at all appears to be designed to placate the Saudis, who vowed to reinstall him through their war, and would be able to claim that they succeeded under this deal, even if it ultimately means Hadi doesn’t get any power. Last 5 posts by Jason Ditz",
		"thread_title": "UN’s Yemen Peace Plan Would Sideline Former President Hadi",
		"title": "UN’s Yemen Peace Plan Would Sideline Former President Hadi",
		"type": "bs",
		"uuid": "80934d8ed0885772b9f28de5c14b962a9fa411b3"
	},
	"-KhIix2-FrkmKwVyF850": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T04:24:39.078+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Kevin Donegan",
				"salience": 0.41630176,
				"type": "PERSON"
			},
			{
				"name": "ships",
				"salience": 0.11126749,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.103491694,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.08103914,
				"type": "PERSON"
			},
			{
				"name": "ships",
				"salience": 0.054239757,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.04305901,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.032663036,
				"type": "LOCATION"
			},
			{
				"name": "blockade",
				"salience": 0.029631454,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.02036881,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.012385795,
				"type": "OTHER"
			},
			{
				"name": "coast",
				"salience": 0.011511325,
				"type": "LOCATION"
			},
			{
				"name": "arms",
				"salience": 0.010740373,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.007270752,
				"type": "OTHER"
			},
			{
				"name": "ships",
				"salience": 0.005704154,
				"type": "OTHER"
			},
			{
				"name": "weapons ships",
				"salience": 0.005704154,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/047vsxx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houthis"
				},
				"name": "Houthi",
				"salience": 0.004485435,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0044641793,
				"type": "OTHER"
			},
			{
				"name": "blockade",
				"salience": 0.0042703613,
				"type": "OTHER"
			},
			{
				"name": "crews",
				"salience": 0.0038674262,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.003646736,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.003646736,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.0035109767,
				"type": "PERSON"
			},
			{
				"name": "smuggling attempt",
				"salience": 0.0031589437,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0027260778,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0024838138,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.0023830622,
				"type": "ORGANIZATION"
			},
			{
				"name": "involvement",
				"salience": 0.0023611719,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0023611719,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0023611719,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.001977606,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.001898127,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0016104438,
				"type": "LOCATION"
			},
			{
				"name": "incidents",
				"salience": 0.0014844011,
				"type": "EVENT"
			},
			{
				"name": "missiles",
				"salience": 0.0012855104,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09w3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pentagon"
				},
				"name": "Pentagon",
				"salience": 0.0006379602,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/08/yemen.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T04:24:39.078+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nVice Admiral Kevin Donegan today claimed the US and other members of the Saudi-led naval blockade of Yemen had captured four ships with arms which they are claiming both came from Iran and were bound for Yemen, where they would’ve delivered the weapons to the Houthi movement. \nThe vice admiral claimed the US “knows” both where the ships came from and where they were going because they interviewed the crews of the captured ships. Only one of the four putative weapons ships was validated by the United Nations as being an actual smuggling attempt. \nDonegan went on to claim that he believes Iran is “connected in some way” to recent incidents of missiles fired at a US ship off the Yemeni coast, though the Pentagon conceded one of those incidents likely never happened, and he offered no evidence of Iranian involvement in anything else. \nThe allegations were likely made by way of justifying US attacks on the Yemeni coast, as well as justifying Saudi Arabia’s ongoing naval blockade of Yemen, which Saudi Arabia recently denied is happening.  ",
		"thread_title": "US Claims Four Arms Ships From Iran to Yemen Caught in Past 18 Months",
		"title": "US Claims Four Arms Ships From Iran to Yemen Caught in Past 18 Months",
		"type": "bs",
		"uuid": "bde34d916cf86c096129e2b974356d7e40480939"
	},
	"-KhIixBapryU2gtNwWBc": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T04:24:41.111+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.3553192,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.15788163,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.082529634,
				"type": "ORGANIZATION"
			},
			{
				"name": "predictions",
				"salience": 0.057847027,
				"type": "OTHER"
			},
			{
				"name": "Threats",
				"salience": 0.034484528,
				"type": "OTHER"
			},
			{
				"name": "hysteria",
				"salience": 0.02995211,
				"type": "OTHER"
			},
			{
				"name": "Claims",
				"salience": 0.02995211,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.024171513,
				"type": "LOCATION"
			},
			{
				"name": "Stupid",
				"salience": 0.021412026,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.02019654,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.018575741,
				"type": "PERSON"
			},
			{
				"name": "predictions",
				"salience": 0.01591652,
				"type": "OTHER"
			},
			{
				"name": "member nations",
				"salience": 0.014385295,
				"type": "LOCATION"
			},
			{
				"name": "effect",
				"salience": 0.012471846,
				"type": "OTHER"
			},
			{
				"name": "assurance",
				"salience": 0.012471846,
				"type": "OTHER"
			},
			{
				"name": "military attacks",
				"salience": 0.012471846,
				"type": "EVENT"
			},
			{
				"name": "anyone",
				"salience": 0.010196348,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.005245961,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0051800576,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.004987256,
				"type": "LOCATION"
			},
			{
				"name": "predictions",
				"salience": 0.0047445735,
				"type": "OTHER"
			},
			{
				"name": "ouster",
				"salience": 0.0047201486,
				"type": "EVENT"
			},
			{
				"name": "military spending",
				"salience": 0.0044872956,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0044189054,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.004320204,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0039043396,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0036649548,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.0036649548,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0036649548,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hr2c9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Ukraine"
				},
				"name": "West",
				"salience": 0.003342726,
				"type": "LOCATION"
			},
			{
				"name": "numbers",
				"salience": 0.0027391377,
				"type": "OTHER"
			},
			{
				"name": "ground troops",
				"salience": 0.0027391377,
				"type": "PERSON"
			},
			{
				"name": "border",
				"salience": 0.0027391377,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0023043514,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0023043514,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0019956566,
				"type": "ORGANIZATION"
			},
			{
				"name": "civil war",
				"salience": 0.0019956566,
				"type": "EVENT"
			},
			{
				"name": "east",
				"salience": 0.0019956566,
				"type": "LOCATION"
			},
			{
				"name": "military leaders",
				"salience": 0.0019956566,
				"type": "PERSON"
			},
			{
				"name": "tanks",
				"salience": 0.0019956566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0018680728,
				"type": "LOCATION"
			},
			{
				"name": "involvement",
				"salience": 0.001780575,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07lz5p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russophilia"
				},
				"name": "pro-Russian",
				"salience": 0.0016867662,
				"type": "LOCATION"
			},
			{
				"name": "plots",
				"salience": 0.0014911019,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0014911019,
				"type": "OTHER"
			},
			{
				"name": "banana republic",
				"salience": 0.0014911019,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.00080476893,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2016/08/hillamir.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T04:24:41.111+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Claims of Russian Threats 'Simply Stupid' by Jason Ditz, October 27, 2016 Share This \nComplaining about Western “hysteria” surrounding repeated predictions of Russian military attacks on NATO member nations, Russian President Vladimir Putin sought to resolve two solid years of predictions to that effect with a straightforward assurance that “Russia is not going to attack anyone .” \nPutin accused Western nations of having “mythical, dreamt-up problems,” and insisted the idea that Russia was going to attack the West was “ simply stupid and unrealistic .” He added that he believes the idea is being played up to justify bigger military spending. \nThe Russian president also sought to dismiss allegations that he is plotting to rig the US elections to his own benefit, noting that the US is a great power and not some banana republic with an easily manipulated political system. Russia has repeatedly denied involvement in such plots. \nNATO has played up the Russian threat to justify sending over 40,000 ground troops to the Russian border, with ever-growing numbers announced all the time. Such predictions started after the ouster of a pro-Russian government in Ukraine led to a civil war in that country’s east, with NATO military leaders repeatedly predicting Russian tanks rolling across Ukraine into NATO countries.  ",
		"thread_title": "Putin: Russia Is Not Going to Attack Anyone",
		"title": "Putin: Russia Is Not Going to Attack Anyone",
		"type": "bs",
		"uuid": "5bc81595f6f21e6cddf16c33c1802d779cf039de"
	},
	"-KhIixLs3KEzhFdkInMk": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:54:33.798+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.21532647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.17082344,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0glsgx8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_Votel"
				},
				"name": "Joseph Votel",
				"salience": 0.097920015,
				"type": "PERSON"
			},
			{
				"name": "Forces",
				"salience": 0.07047061,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.05178431,
				"type": "PERSON"
			},
			{
				"name": "assessment",
				"salience": 0.04819973,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.04819973,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01xsrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Central_Command"
				},
				"name": "Centcom",
				"salience": 0.02991288,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.029552758,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.02908536,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighters",
				"salience": 0.023170719,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.013598455,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.012569533,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.009114994,
				"type": "LOCATION"
			},
			{
				"name": "fighting",
				"salience": 0.008348224,
				"type": "EVENT"
			},
			{
				"name": "Peshmerga",
				"salience": 0.008037597,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.007901295,
				"type": "OTHER"
			},
			{
				"name": "roadside bomb north",
				"salience": 0.0072320625,
				"type": "OTHER"
			},
			{
				"name": "soldier",
				"salience": 0.006962834,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.006962834,
				"type": "PERSON"
			},
			{
				"name": "contrast",
				"salience": 0.006962834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.0062757167,
				"type": "PERSON"
			},
			{
				"name": "casualties",
				"salience": 0.0059070066,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0059070066,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.0059070066,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0059070066,
				"type": "EVENT"
			},
			{
				"name": "success",
				"salience": 0.0059070066,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03m_n0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peshmerga"
				},
				"name": "Peshmerga",
				"salience": 0.0051447214,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0047491244,
				"type": "ORGANIZATION"
			},
			{
				"name": "figures",
				"salience": 0.004665215,
				"type": "OTHER"
			},
			{
				"name": "outskirts",
				"salience": 0.0044150613,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.0044150613,
				"type": "LOCATION"
			},
			{
				"name": "skirmishers",
				"salience": 0.0044150613,
				"type": "PERSON"
			},
			{
				"name": "advance",
				"salience": 0.0044150613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.004289911,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.0035758617,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0035491541,
				"type": "OTHER"
			},
			{
				"name": "traps",
				"salience": 0.003216829,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.003216829,
				"type": "EVENT"
			},
			{
				"name": "posts",
				"salience": 0.003216829,
				"type": "WORK_OF_ART"
			},
			{
				"name": "majority",
				"salience": 0.003216829,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.002775507,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.002775507,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T05:54:33.798+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Forces Still Several Kilometers From Mosul by Jason Ditz, October 27, 2016 Share This \nAdding to the upbeat official assessment of the invasion of Mosul, Centcom chief Gen. Joseph Votel today told the press that he believes the forces involved have “ probably killed about 800-900 ISIS fighters ” in the past week and a half. \nBy contrast, Votel insisted that only 57 Iraqi troops were killed, and another 30 Kurdish Peshmerga. Unmentioned was a US soldier also killed in the fighting, embedded with the Peshmerga and killed by a roadside bomb north of Mosul. \nIt is difficult to get accurate information on ISIS casualties, and the official figures from Iraqi officials are almost always dramatically overstated in an effort to sell the war as a runaway success. There are reasons to be skeptical about the 800-900 figure, however. \nThe main reason is that Iraqi and Kurdish forces are still several kilomters away from the outskirts of Mosul, mostly occupying empty villages, and while ISIS has sent out some forces of skirmishers to slow their advance, it is believed the vast majority of their defensive forces have remained in Mosul, gearing up for the eventual attack and setting assorted traps. Last 5 posts by Jason Ditz",
		"thread_title": "US: 800-900 ISIS ‘Probably’ Killed in Mosul Fighting",
		"title": "US: 800-900 ISIS ‘Probably’ Killed in Mosul Fighting",
		"type": "bs",
		"uuid": "d7f700048cbb3187ec42a1ddece9e8258b908ebb"
	},
	"-KhIixXvEsqWMPDGsjv8": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:54:34.977+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.29499793,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.19607447,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03hz03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Raqqah"
				},
				"name": "Raqqa",
				"salience": 0.16643259,
				"type": "LOCATION"
			},
			{
				"name": "Stephen Townsend",
				"salience": 0.03750336,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.035421114,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.032965653,
				"type": "PERSON"
			},
			{
				"name": "ISIS Capital",
				"salience": 0.02356859,
				"type": "OTHER"
			},
			{
				"name": "Has 'Sense of Urgency",
				"salience": 0.02356859,
				"type": "OTHER"
			},
			{
				"name": "plots",
				"salience": 0.018193103,
				"type": "OTHER"
			},
			{
				"name": "capital city",
				"salience": 0.015835391,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.013729353,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.013729353,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.013729353,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.011054303,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.008476422,
				"type": "LOCATION"
			},
			{
				"name": "any",
				"salience": 0.008128491,
				"type": "OTHER"
			},
			{
				"name": "Kurdish YPG",
				"salience": 0.006614038,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.006047834,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.0057028164,
				"type": "LOCATION"
			},
			{
				"name": "urgency",
				"salience": 0.0057028164,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0057028164,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0051965215,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.004940181,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.004940181,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.0040348815,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.0040348815,
				"type": "EVENT"
			},
			{
				"name": "capture",
				"salience": 0.0040348815,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0032951392,
				"type": "PERSON"
			},
			{
				"name": "portions",
				"salience": 0.0030156474,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0030156474,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0030156474,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0029301543,
				"type": "LOCATION"
			},
			{
				"name": "YPG",
				"salience": 0.002843303,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.002485324,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012w_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manbij"
				},
				"name": "Manbij",
				"salience": 0.002485324,
				"type": "LOCATION"
			},
			{
				"name": "posts",
				"salience": 0.002197132,
				"type": "WORK_OF_ART"
			},
			{
				"name": "plots",
				"salience": 0.0018956786,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.0012387746,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0012222882,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T05:54:34.977+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Insists US Has 'Sense of Urgency' in Taking Over ISIS Capital by Jason Ditz, October 27, 2016 Share This \nUS officials in the past few days have kept talking up an imminent invasion of the ISIS capital city of Raqqa, despite so much focus presently on Mosul, and despite the obvious huge problems its going to cause between Turkey and the Kurdish YPG. \nLt. Gen. Stephen Townsend, the US commander in Iraq, insists the US has decided it doesn’t have a choice in the matter, and feels a “ sense of urgency ” to take over Raqqa before any of the ISIS leadership in that city is able to plan any retaliatory strikes against Western targets. \n“We’ve got to get to Raqqa pretty soon,” Townsend insisted, claiming that the capture of Manbij a couple of months ago uncovered ISIS plots to attack France and the US, and they are convinced even more plots are ongoing within Raqqa. \nISIS is estimated to have around 4,000 troops in Raqqa, and the attack will require the Kurdish YPG to commit substantial portions of its force to the area. That’s problematic, because Turkey has in the past attacked them when they were fighting ISIS, and has warned the US not to allow any Kurds into Raqqa. Last 5 posts by Jason Ditz",
		"thread_title": "US Commander: We Must Conquer Raqqa Before ISIS Launches Attacks on West",
		"title": "US Commander: We Must Conquer Raqqa Before ISIS Launches Attacks on West",
		"type": "bs",
		"uuid": "5e93ef448dcb408aacfa6ecd41a4c427efd49075"
	},
	"-KhIixhY2u9EEn51u6ML": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:54:35.578+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama Administration",
				"salience": 0.24244101,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.15969828,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/024tls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adam_Schiff"
				},
				"name": "Adam Schiff",
				"salience": 0.10594303,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0522481,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.050745443,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.041571993,
				"type": "EVENT"
			},
			{
				"name": "intention",
				"salience": 0.03880642,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03621019,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.02675278,
				"type": "PERSON"
			},
			{
				"name": "Provoke Retaliation Before Vote",
				"salience": 0.024371432,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.022985179,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.020371877,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.01615979,
				"type": "EVENT"
			},
			{
				"name": "cyberwar",
				"salience": 0.01615979,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.014007968,
				"type": "WORK_OF_ART"
			},
			{
				"name": "choosing",
				"salience": 0.014007968,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/012gx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Biden"
				},
				"name": "Joe Biden",
				"salience": 0.01343043,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.006437881,
				"type": "EVENT"
			},
			{
				"name": "hope",
				"salience": 0.0062448005,
				"type": "OTHER"
			},
			{
				"name": "cyberwar",
				"salience": 0.005814371,
				"type": "OTHER"
			},
			{
				"name": "president-elect",
				"salience": 0.0055978666,
				"type": "PERSON"
			},
			{
				"name": "both",
				"salience": 0.005458015,
				"type": "PERSON"
			},
			{
				"name": "hacks",
				"salience": 0.005258408,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.005036474,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.005036474,
				"type": "OTHER"
			},
			{
				"name": "standpoint",
				"salience": 0.004848862,
				"type": "OTHER"
			},
			{
				"name": "win",
				"salience": 0.004113196,
				"type": "EVENT"
			},
			{
				"name": "certainty",
				"salience": 0.004113196,
				"type": "OTHER"
			},
			{
				"name": "doubts",
				"salience": 0.004113196,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0038504351,
				"type": "ORGANIZATION"
			},
			{
				"name": "fights",
				"salience": 0.003578433,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.0035492354,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.003073899,
				"type": "EVENT"
			},
			{
				"name": "hacks",
				"salience": 0.002863697,
				"type": "OTHER"
			},
			{
				"name": "hack",
				"salience": 0.002863697,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0026740672,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0024471187,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.002239409,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0021805656,
				"type": "ORGANIZATION"
			},
			{
				"name": "factor",
				"salience": 0.0021558716,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0021287233,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0017826256,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0016731536,
				"type": "EVENT"
			},
			{
				"name": "retaliation",
				"salience": 0.0015774423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0288j83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0013173005,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07nxbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Permanent_Select_Committee_on_Intelligence"
				},
				"name": "House Intelligence Committee",
				"salience": 0.001029946,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025tkqy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calcium"
				},
				"name": "CA",
				"salience": 0.001029946,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2010/12/ClintonObama.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T05:54:35.578+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Rep. Schiff: US Doesn't Want to Provoke Retaliation Before Vote by Jason Ditz, October 27, 2016 Share This \nWhile the Obama Administration has made much of its intention to start a full-scale cyberwar against Russia at a “time of their choosing,” the most recent reports suggest that the war is effectively on hold at least until the presidential election in two weeks. \nFrom President Obama’s standpoint, the hope is to work with Hillary Clinton, if she becomes president-elect, to launch a cyber war that they both can get behind. Indeed, both have appeared very hawkish against Russia, and Obama apparently doesn’t want to deny Clinton a chance to participate in the early days of a war she’d inherit. \nStarting a cyberwar ahead of a Trump win would be even less wise, as Trump has opposed the idea of picking fights with Russia, and expressed strong doubts about Democratic Party “certainty” that Russia is behind hacks against them. \nRep. Adam Schiff (D – CA), the ranking Democrat on the House Intelligence Committee, says that another factor is concern about provoking Russian retaliation for such a US attack before the vote, with many Democrats concerned Russia could release “forged” documents to embarrass the Clinton campaign. \nEarlier this month, Vice President Joe Biden reported that he has informed Russia of an imminent retaliatory hack, and says the Obama Administration will pick a time which will “have the greatest impact.” Russia has denied any involvement in the hacks. Last 5 posts by Jason Ditz",
		"thread_title": "US to Hold Off on Cyberwar With Russia Until After Election",
		"title": "US to Hold Off on Cyberwar With Russia Until After Election",
		"type": "bs",
		"uuid": "48d98c1211b980991dc33f2a8f16dbf50012b572"
	},
	"-KhIixp_x3PXqlrznG8M": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T05:54:35.641+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.200503,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.17628862,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03hz03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Raqqah"
				},
				"name": "Raqqa",
				"salience": 0.14608087,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.08295351,
				"type": "PERSON"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurds_in_Syria"
				},
				"name": "Kurds",
				"salience": 0.063773945,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.036650844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.035540774,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kurdish YPG",
				"salience": 0.03339049,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.020284334,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Recep Tayyip Erdogan",
				"salience": 0.018189138,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.01813235,
				"type": "LOCATION"
			},
			{
				"name": "middle",
				"salience": 0.016388524,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.014209236,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.014209236,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.013307085,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.01235617,
				"type": "ORGANIZATION"
			},
			{
				"name": "invasion",
				"salience": 0.011669127,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.007898494,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.0075996034,
				"type": "EVENT"
			},
			{
				"name": "coalition",
				"salience": 0.0067829746,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighters",
				"salience": 0.0065352214,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.0056829737,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.0056829737,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighting",
				"salience": 0.0053715473,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.0053385315,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0051133274,
				"type": "LOCATION"
			},
			{
				"name": "factions",
				"salience": 0.0049229427,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.004176338,
				"type": "LOCATION"
			},
			{
				"name": "anywhere",
				"salience": 0.003870953,
				"type": "LOCATION"
			},
			{
				"name": "invasion",
				"salience": 0.0036039192,
				"type": "EVENT"
			},
			{
				"name": "middle",
				"salience": 0.0026259664,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0022742038,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0022742038,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fighting",
				"salience": 0.0021730294,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0016992445,
				"type": "OTHER"
			},
			{
				"name": "anti-ISIS",
				"salience": 0.0014002132,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012w_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manbij"
				},
				"name": "Manbij",
				"salience": 0.0010460728,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T05:54:35.641+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Turkey Repeatedly Demanded US Not Allow Kurds to Participate by Jason Ditz, October 27, 2016 Share This \nUS officials are making clear that they intend to invade Raqqa really soon, with the ISIS capital scheduled to be attacks in the middle of the ongoing offensive against the city of Mosul. But while the Mosul invasion has a coalition of at least sort of friendly factions participating. No such coalition exists for Raqqa. \nIndeed, the US has insisted that the Kurdish YPG will be the overwhelming majority of the force, because they’re the only force available in the area with enough fighters to realistically attack the city. Yet Turkey has been outright livid over this, and has repeatedly demanded that the Kurds not be allowed anywhere near Raqqa. \nTurkish President Recep Tayyip Erdogan insists his country will be invading Raqqa, along with the YPG-held city of Manbij, very soon, and while they’ll doubtless also do some fighting against ISIS on the way, it’s pretty clear this is going to include some heavy fighting with the Kurds . \nThat’s likely to complicate, and potentially outright derail, the invasion of Raqqa, as the Kurdish YPG can’t fight ISIS and Turkey at the same time, and the US seems wholly incapable of keeping Turkey from launching attacks on the Kurds in the middle of anti-ISIS operations. Last 5 posts by Jason Ditz",
		"thread_title": "Turkey’s Rivalry With Kurds Likely to Complicate Raqqa Invasion",
		"title": "Turkey’s Rivalry With Kurds Likely to Complicate Raqqa Invasion",
		"type": "bs",
		"uuid": "bc827cc621edd2376bfaba5a320514d48d678c6a"
	},
	"-KhIixzNSIx5vU-TfNl5": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:54:31.903+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "officials",
				"salience": 0.31477717,
				"type": "PERSON"
			},
			{
				"name": "Dhia Amir",
				"salience": 0.10105374,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.05884015,
				"type": "PERSON"
			},
			{
				"name": "treatment",
				"salience": 0.054770414,
				"type": "OTHER"
			},
			{
				"name": "Troops Brag of Having Shot Some Fleeing Mosul",
				"salience": 0.03918291,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.034000985,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.03362525,
				"type": "PERSON"
			},
			{
				"name": "checkpoints",
				"salience": 0.026340343,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.026340343,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "Associated Press",
				"salience": 0.02596733,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.024429265,
				"type": "PERSON"
			},
			{
				"name": "mass detentions",
				"salience": 0.02294203,
				"type": "OTHER"
			},
			{
				"name": "abuses",
				"salience": 0.022840481,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.01867689,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.017645301,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.016277341,
				"type": "LOCATION"
			},
			{
				"name": "summary execution",
				"salience": 0.015461106,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.010364293,
				"type": "ORGANIZATION"
			},
			{
				"name": "police forces",
				"salience": 0.009492551,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.009139392,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.008223545,
				"type": "PERSON"
			},
			{
				"name": "basis",
				"salience": 0.007866303,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.0077542504,
				"type": "PERSON"
			},
			{
				"name": "crackdown",
				"salience": 0.007622697,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.006716978,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.006716978,
				"type": "EVENT"
			},
			{
				"name": "militias",
				"salience": 0.006716978,
				"type": "PERSON"
			},
			{
				"name": "cities",
				"salience": 0.006716978,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.005796518,
				"type": "PERSON"
			},
			{
				"name": "checkpoint",
				"salience": 0.0057236166,
				"type": "LOCATION"
			},
			{
				"name": "son",
				"salience": 0.0050205807,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.004223817,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni Arabs",
				"salience": 0.0041378257,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shi'ite",
				"salience": 0.0041378257,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0041378257,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.0036580854,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0036580854,
				"type": "EVENT"
			},
			{
				"name": "posts",
				"salience": 0.0036580854,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tensions",
				"salience": 0.0035665694,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0031562499,
				"type": "PERSON"
			},
			{
				"name": "detention",
				"salience": 0.0031562499,
				"type": "OTHER"
			},
			{
				"name": "boy",
				"salience": 0.0027333442,
				"type": "PERSON"
			},
			{
				"name": "pretext",
				"salience": 0.0027333442,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:54:31.903+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Troops Brag of Having Shot Some Fleeing Mosul by Jason Ditz, October 27, 2016 Share This \nWhile UN officials claim they’re carefully monitoring the treatment of those displaced from Mosul and haven’t documented any abuses, the troops occupying checkpoints through which the civilians have to flee are telling a different story, involving mass detentions and summary execution. \nThe Associated Press quoted one of those manning a checkpoint, named Dhia Amir, as having bragged of not only “arresting” over 100 people, handing them over to police forces, but of having personally shot and killed two men who he claims to have “known” were fleeing ISIS fighters. \nThis has been a recurring problem in Iraq’s wars against ISIS, as Shi’ite dominated security forces and allied militias are immediately distrustful of Sunni Arabs fleeing the ISIS cities, and don’t need much pretext for a detention, or to disappear people outright. \n“A 13-year-old boy can still kill,” Amir noted, defending the crackdown on fleeing civilians. “And even if he doesn’t kill me, one day he could kill my son.” That, ultimately, has been the basis on which much of the war has been fought, and the main reason why sectarian tensions are only growing. Last 5 posts by Jason Ditz",
		"thread_title": "Those Fleeing Mosul Face Summary Execution",
		"title": "Those Fleeing Mosul Face Summary Execution",
		"type": "bs",
		"uuid": "f5cae1d80fee7c3de22cc083a0c301984113902f"
	},
	"-KhIiy7vROc5BwJsy5RH": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T19:57:57.087+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.31640464,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.14641841,
				"type": "LOCATION"
			},
			{
				"name": "miss",
				"salience": 0.09572494,
				"type": "OTHER"
			},
			{
				"name": "Pilot",
				"salience": 0.050688095,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.04282647,
				"type": "PERSON"
			},
			{
				"name": "jet",
				"salience": 0.039606888,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "US Air Force",
				"salience": 0.038548294,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lousy Russian",
				"salience": 0.034071613,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.02562043,
				"type": "LOCATION"
			},
			{
				"name": "warplane",
				"salience": 0.021191737,
				"type": "OTHER"
			},
			{
				"name": "spy plane",
				"salience": 0.019154035,
				"type": "OTHER"
			},
			{
				"name": "skies",
				"salience": 0.016607378,
				"type": "OTHER"
			},
			{
				"name": "Jeff Harrigian",
				"salience": 0.014310463,
				"type": "PERSON"
			},
			{
				"name": "warplane",
				"salience": 0.009710277,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0090512475,
				"type": "LOCATION"
			},
			{
				"name": "none",
				"salience": 0.008095062,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0077359355,
				"type": "EVENT"
			},
			{
				"name": "pilot",
				"salience": 0.007638807,
				"type": "PERSON"
			},
			{
				"name": "pilots",
				"salience": 0.007354649,
				"type": "PERSON"
			},
			{
				"name": "planes",
				"salience": 0.0066427016,
				"type": "OTHER"
			},
			{
				"name": "awareness",
				"salience": 0.0065300413,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.00628699,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.006240113,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.005754364,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.005635731,
				"type": "LOCATION"
			},
			{
				"name": "incident",
				"salience": 0.005463245,
				"type": "EVENT"
			},
			{
				"name": "proof",
				"salience": 0.004881706,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.004881706,
				"type": "OTHER"
			},
			{
				"name": "warplanes",
				"salience": 0.00466478,
				"type": "OTHER"
			},
			{
				"name": "lights",
				"salience": 0.004301378,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0031099205,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.0030558375,
				"type": "LOCATION"
			},
			{
				"name": "ceasefire",
				"salience": 0.0026922536,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.002658361,
				"type": "LOCATION"
			},
			{
				"name": "posts",
				"salience": 0.002658361,
				"type": "WORK_OF_ART"
			},
			{
				"name": "northwest",
				"salience": 0.002658361,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.002658361,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.0022469205,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.0022469205,
				"type": "ORGANIZATION"
			},
			{
				"name": "Details",
				"salience": 0.001986292,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.001986292,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T19:57:57.087+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Air Force General Attributes It to Lousy Russian Pilot by Jason Ditz, October 28, 2016 Share This \nThe US Air Force is claiming a “ near miss ” in the skies of Syria last week, in which a Russian jet that was escorting a spy plane came within “half a mile” of a US warplane. The incident was at night and none of the planes had any lights on. \nUS Air Force Lt. Gen. Jeff Harrigian chalked the matter up to inferior Russian pilots, saying that it was because the pilot did not have “the necessary situational awareness” and simply didn’t see that there was a US warplane flying around in the area. \nThe US is eager to hype any such incidents as proof of Russia’s “unsafe and unprofessional behavior” in Syria, though a major factor in this is that the US dramatically curtailed information sharing with Russia in Syria after the last ceasefire failed. \nDetails on the incident are still minimal, but it was described as happening in “eastern Syria.” This is unusual because, while Russian warplanes tend to operate in that area, where al-Qaeda’s Nusra Front holds significant territory, the US generally does not, and US airstrikes are more or less exclusively in the northwest of the country. Last 5 posts by Jason Ditz",
		"thread_title": "Russian, US Jets in ‘Near Miss’ Over Syria",
		"title": "Russian, US Jets in ‘Near Miss’ Over Syria",
		"type": "bs",
		"uuid": "d03b85ea65d09aecbc7a4dc128382ff73fdbe448"
	},
	"-KhIiyGPWzzyweTd1YbR": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T03:55:27.741+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07jqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taliban"
				},
				"name": "Taliban",
				"salience": 0.36326423,
				"type": "ORGANIZATION"
			},
			{
				"name": "Home",
				"salience": 0.061261237,
				"type": "OTHER"
			},
			{
				"name": "Commander",
				"salience": 0.056252114,
				"type": "PERSON"
			},
			{
				"name": "drone strike",
				"salience": 0.050938398,
				"type": "EVENT"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.04755427,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02bt3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nangarhar_Province"
				},
				"name": "Nangarhar Province",
				"salience": 0.039719068,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.038771354,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.025485024,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.024651824,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.023567691,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.023567691,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.021304639,
				"type": "LOCATION"
			},
			{
				"name": "center",
				"salience": 0.018475419,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.017012097,
				"type": "LOCATION"
			},
			{
				"name": "commander",
				"salience": 0.015970565,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.014431234,
				"type": "EVENT"
			},
			{
				"name": "civilian",
				"salience": 0.009556618,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.008503511,
				"type": "OTHER"
			},
			{
				"name": "commander",
				"salience": 0.007983111,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0076808715,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0075179506,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.007395176,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0066542607,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0066542607,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0066542607,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.0066542607,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.0065826187,
				"type": "PERSON"
			},
			{
				"name": "casualties",
				"salience": 0.006406618,
				"type": "OTHER"
			},
			{
				"name": "strike",
				"salience": 0.006274591,
				"type": "EVENT"
			},
			{
				"name": "everyone",
				"salience": 0.0057174587,
				"type": "PERSON"
			},
			{
				"name": "hospital",
				"salience": 0.005435385,
				"type": "LOCATION"
			},
			{
				"name": "treatment",
				"salience": 0.005435385,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.005435385,
				"type": "OTHER"
			},
			{
				"name": "blast",
				"salience": 0.005299595,
				"type": "EVENT"
			},
			{
				"name": "warplanes",
				"salience": 0.0040628235,
				"type": "OTHER"
			},
			{
				"name": "faction",
				"salience": 0.0040628235,
				"type": "OTHER"
			},
			{
				"name": "Locals",
				"salience": 0.003194081,
				"type": "PERSON"
			},
			{
				"name": "occupation",
				"salience": 0.0029603427,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0029603427,
				"type": "LOCATION"
			},
			{
				"name": "posts",
				"salience": 0.0029603427,
				"type": "WORK_OF_ART"
			},
			{
				"name": "everywhere",
				"salience": 0.0025752804,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.0025542579,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0025022374,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.0022120352,
				"type": "WORK_OF_ART"
			},
			{
				"name": "presence",
				"salience": 0.0022120352,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.0018524181,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.001822815,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/07/afghan0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:55:27.741+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Attack Targeted Home of Suspected 'Taliban Commander' by Jason Ditz, October 28, 2016 Share This \nA US drone strike has killed and wounded a number of civilians in Afghanistan’s Nangarhar Province today, though exact numbers are as yet unclear, with officials claiming that the home at the center of the attack was owned by a suspected Taliban commander. \nThe putative commander does not appear to have been among the casualties, though at least four people were killed within the house, and the blast also wounded a number of people in the surrounding area. At least seven children and five women are in the hospital for treatment related to the strike. \nOfficial Afghan statements only labeled the 12 wounded as civilians, and everyone else was not a civilian. Locals offered varying estimates, and the Taliban claimed two civilians killed and over 30 wounded in their own report on the attack. \nThe Nangarhar Province has been heavily targeted by US warplanes over the past several months, though generally trying to tamp down a growing ISIS faction therein. The Taliban has had a presence in Nangarhar throughout the US occupation, as indeed they have almost everywhere along the Pakistan border. Last 5 posts by Jason Ditz",
		"thread_title": "US Drone Strike in Afghanistan Kills, Wounds Several Civilians",
		"title": "US Drone Strike in Afghanistan Kills, Wounds Several Civilians",
		"type": "bs",
		"uuid": "c2eee768e791cb34fed532de80ebcb6ff96da85b"
	},
	"-KhIiyRR8Ii5vf5mSxr-": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:23:53.119+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.21265674,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.17052083,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01xp_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defence_minister"
				},
				"name": "Defense Ministry",
				"salience": 0.12552081,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.11355435,
				"type": "LOCATION"
			},
			{
				"name": "ceasefire",
				"salience": 0.05251156,
				"type": "EVENT"
			},
			{
				"name": "request",
				"salience": 0.041323278,
				"type": "OTHER"
			},
			{
				"name": "Rebels",
				"salience": 0.036998466,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.032838855,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.021416457,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.017157404,
				"type": "ORGANIZATION"
			},
			{
				"name": "airstrikes",
				"salience": 0.014678037,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.014678037,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.014678037,
				"type": "LOCATION"
			},
			{
				"name": "airstrikes",
				"salience": 0.014678037,
				"type": "EVENT"
			},
			{
				"name": "resumption",
				"salience": 0.013896642,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.008084749,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.007856321,
				"type": "LOCATION"
			},
			{
				"name": "rebel factions",
				"salience": 0.0072070295,
				"type": "OTHER"
			},
			{
				"name": "rebel factions",
				"salience": 0.005851981,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.005285472,
				"type": "LOCATION"
			},
			{
				"name": "goal",
				"salience": 0.004755678,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0044278493,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.00440812,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.004317228,
				"type": "EVENT"
			},
			{
				"name": "defense ministry",
				"salience": 0.004001628,
				"type": "PERSON"
			},
			{
				"name": "call",
				"salience": 0.003933701,
				"type": "OTHER"
			},
			{
				"name": "East Aleppo",
				"salience": 0.0039032106,
				"type": "LOCATION"
			},
			{
				"name": "two",
				"salience": 0.003739537,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.003739537,
				"type": "OTHER"
			},
			{
				"name": "factions",
				"salience": 0.003573345,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.0028207977,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0028207977,
				"type": "LOCATION"
			},
			{
				"name": "siege",
				"salience": 0.0027948795,
				"type": "EVENT"
			},
			{
				"name": "step",
				"salience": 0.0027948795,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0026233918,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0026162844,
				"type": "LOCATION"
			},
			{
				"name": "leadership",
				"salience": 0.0020362684,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0020362684,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rejection",
				"salience": 0.0017270142,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0015950755,
				"type": "LOCATION"
			},
			{
				"name": "influence",
				"salience": 0.0015214459,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0014833641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0009366059,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/09/putin.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:23:53.119+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Putin Still Hopes to See Moderate Rebels Separated From Nusra Front by Jason Ditz, October 28, 2016 Share This \nRussian President Vladimir Putin has officially rejected a request from his nation’s Defense Ministry to endorse a resumption of Russian airstrikes against the Syrian city of Aleppo, after 10 straight days of no Russian airstrikes being conducted. \nRussia launched a brief ceasefire in Aleppo last week, and extended it for four days. Even after it officially expired, they have not resumed strikes against the city, with officials saying they want to convince Western nations to separate the moderate rebel factions within East Aleppo from the al-Qaeda-linked Nusra Front. \nSo far that’s not been working so well, as indeed separating the two was the primary goal of a weeklong ceasefire a month ago, and a public US call to separate never amounted to anything. After that, the idea appears to have been given up on by the US, and Russia has also sought Turkey and Saudi Arabia’s influence on the more moderate factions. \nAs the rebel factions are launching a new offensive trying to brief the Aleppo siege, the Russian defense ministry has gone to the unusual step of publicly announcing their request to Putin, and Putin’s very public rejection may suggest there is some debate within the Russian leadership on how to proceed. Last 5 posts by Jason Ditz",
		"thread_title": "Putin Rejects Russian Army’s Calls to Resume Aleppo Airstrikes",
		"title": "Putin Rejects Russian Army’s Calls to Resume Aleppo Airstrikes",
		"type": "bs",
		"uuid": "46174493f907df24519d8a26361de6130041c996"
	},
	"-KhIiya--CYNMk8STLlX": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T04:33:15.270+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.18375535,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.16600968,
				"type": "ORGANIZATION"
			},
			{
				"name": "territory",
				"salience": 0.04952132,
				"type": "LOCATION"
			},
			{
				"name": "south",
				"salience": 0.04630739,
				"type": "LOCATION"
			},
			{
				"name": "Supply Lines",
				"salience": 0.044809617,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.04181259,
				"type": "PERSON"
			},
			{
				"name": "Offensive Aims",
				"salience": 0.03890625,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.032461315,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nusra-Held East",
				"salience": 0.027794434,
				"type": "LOCATION"
			},
			{
				"name": "Share This With al-Qaeda",
				"salience": 0.024107343,
				"type": "ORGANIZATION"
			},
			{
				"name": "advantage",
				"salience": 0.021737954,
				"type": "OTHER"
			},
			{
				"name": "supply lines",
				"salience": 0.021701252,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.019639727,
				"type": "ORGANIZATION"
			},
			{
				"name": "east",
				"salience": 0.018662887,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.018662887,
				"type": "LOCATION"
			},
			{
				"name": "some",
				"salience": 0.018662887,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.018662887,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.016178025,
				"type": "ORGANIZATION"
			},
			{
				"name": "stronghold",
				"salience": 0.016178025,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.013907967,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.01040496,
				"type": "PERSON"
			},
			{
				"name": "fighting",
				"salience": 0.008718479,
				"type": "EVENT"
			},
			{
				"name": "Clashes",
				"salience": 0.008288721,
				"type": "EVENT"
			},
			{
				"name": "suburb",
				"salience": 0.008029643,
				"type": "LOCATION"
			},
			{
				"name": "Locals",
				"salience": 0.0075868103,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.007158869,
				"type": "LOCATION"
			},
			{
				"name": "government officials",
				"salience": 0.006558935,
				"type": "PERSON"
			},
			{
				"name": "attackers",
				"salience": 0.006465482,
				"type": "PERSON"
			},
			{
				"name": "feature",
				"salience": 0.0058171046,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0058171046,
				"type": "EVENT"
			},
			{
				"name": "reinforcements",
				"salience": 0.005600421,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.005600421,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.005600421,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.0050926497,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.004821631,
				"type": "PERSON"
			},
			{
				"name": "counterattack",
				"salience": 0.004750756,
				"type": "EVENT"
			},
			{
				"name": "other",
				"salience": 0.004750756,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.0040993975,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0040993975,
				"type": "EVENT"
			},
			{
				"name": "major",
				"salience": 0.0037825024,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0035503928,
				"type": "OTHER"
			},
			{
				"name": "corner",
				"salience": 0.0035503928,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0261yrl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib_Governorate"
				},
				"name": "Idlib Province",
				"salience": 0.003449716,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.0033076121,
				"type": "LOCATION"
			},
			{
				"name": "anywhere",
				"salience": 0.0025865627,
				"type": "LOCATION"
			},
			{
				"name": "hands",
				"salience": 0.0025865627,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0025865627,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ceasefire",
				"salience": 0.0023971861,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0022316233,
				"type": "ORGANIZATION"
			},
			{
				"name": "calls",
				"salience": 0.0019325346,
				"type": "OTHER"
			},
			{
				"name": "hold",
				"salience": 0.0019325346,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.0019325346,
				"type": "EVENT"
			},
			{
				"name": "heels",
				"salience": 0.0019325346,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0019325346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0015664537,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T04:33:15.270+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Offensive Aims to Reopen Supply Lines to Nusra-Held East by Jason Ditz, October 28, 2016 Share This \nWith al-Qaeda’s Nusra Front losing territory in recent weeks around Aleppo, and seeing their main stronghold in the city’s east increasingly surrounded, the group and some of its allies have launched a new offensive south of the city aimed at opening the supply lines back up. \nClashes have been reported throughout the day in several areas around government-held western Aleppo , with the attackers coming from further west, likely reinforcements from Nusra’s main territory, the Idlib Province. Locals described substantial fighting. \nThis has been a recurring feature in the battle over Aleppo since 2012, but particularly over the past several months, with each side getting a sizeable advantage only to lose it to a sudden counterattack from the other, leaving the civilian population trapped within. \nOver the past few weeks, however, it had seemed like Aleppo was really going to be reunified by the military, with Nusra forces on their heels and Russia feeling confident enough to put their airstrikes on hold. Russian President Vladimir Putin has ordered the ceasefire to continue, despite calls from the military to resume attacks. \nExactly how far the latest offensive has gotten is a major of debate, with Nusra claiming they’d captured a suburb that amounts to the whole southwestern corner of Aleppo, and government officials denying that they’d lost anywhere near so much. As usual, it will take some time for this to shake out and become clear what territory changed hands. Last 5 posts by Jason Ditz",
		"thread_title": "Nusra Front Launches New Offensive Around Syria’s Aleppo",
		"title": "Nusra Front Launches New Offensive Around Syria’s Aleppo",
		"type": "bs",
		"uuid": "a3c0ef8c46bc634928a3d61c55a2caaa76cd847d"
	},
	"-KhIiym6Z5xxkc83Q5hc": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T05:20:41.744+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.22214106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.17042287,
				"type": "LOCATION"
			},
			{
				"name": "Keen",
				"salience": 0.09555729,
				"type": "ORGANIZATION"
			},
			{
				"name": "determination",
				"salience": 0.06336289,
				"type": "OTHER"
			},
			{
				"name": "Nations",
				"salience": 0.04120485,
				"type": "LOCATION"
			},
			{
				"name": "disputes",
				"salience": 0.034486864,
				"type": "EVENT"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.032173555,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jtm8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_China_Sea"
				},
				"name": "South China Sea",
				"salience": 0.03101229,
				"type": "LOCATION"
			},
			{
				"name": "Buying",
				"salience": 0.02993116,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.023911601,
				"type": "OTHER"
			},
			{
				"name": "Rodrigo Duterte",
				"salience": 0.019117795,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.017165259,
				"type": "LOCATION"
			},
			{
				"name": "claims",
				"salience": 0.015867693,
				"type": "OTHER"
			},
			{
				"name": "sea",
				"salience": 0.015867693,
				"type": "LOCATION"
			},
			{
				"name": "client states",
				"salience": 0.015867693,
				"type": "LOCATION"
			},
			{
				"name": "claims",
				"salience": 0.015867693,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.012426359,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.011973715,
				"type": "ORGANIZATION"
			},
			{
				"name": "deal",
				"salience": 0.011591955,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09pmkv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malaysia"
				},
				"name": "Malaysia",
				"salience": 0.011123405,
				"type": "LOCATION"
			},
			{
				"name": "mission ships",
				"salience": 0.0063915607,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0059472537,
				"type": "LOCATION"
			},
			{
				"name": "claims",
				"salience": 0.0054952945,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.005290623,
				"type": "OTHER"
			},
			{
				"name": "ships",
				"salience": 0.005154821,
				"type": "OTHER"
			},
			{
				"name": "incentive",
				"salience": 0.0046664253,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.0045217886,
				"type": "EVENT"
			},
			{
				"name": "headlines",
				"salience": 0.0045217886,
				"type": "OTHER"
			},
			{
				"name": "combat",
				"salience": 0.004464913,
				"type": "OTHER"
			},
			{
				"name": "decision-making process",
				"salience": 0.004464913,
				"type": "OTHER"
			},
			{
				"name": "Details",
				"salience": 0.004464913,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0036765907,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0036461689,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.0036461689,
				"type": "OTHER"
			},
			{
				"name": "might",
				"salience": 0.0036461689,
				"type": "OTHER"
			},
			{
				"name": "chances",
				"salience": 0.0036461689,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0034840307,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00335414,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0032735355,
				"type": "OTHER"
			},
			{
				"name": "arms sales",
				"salience": 0.0027246724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.0025504886,
				"type": "LOCATION"
			},
			{
				"name": "interest",
				"salience": 0.0025383127,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.001984869,
				"type": "WORK_OF_ART"
			},
			{
				"name": "area",
				"salience": 0.001984869,
				"type": "LOCATION"
			},
			{
				"name": "warships",
				"salience": 0.001984869,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0018965341,
				"type": "OTHER"
			},
			{
				"name": "disputes",
				"salience": 0.0018952102,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0016775609,
				"type": "LOCATION"
			},
			{
				"name": "relations",
				"salience": 0.0014829155,
				"type": "OTHER"
			},
			{
				"name": "complaints",
				"salience": 0.0014829155,
				"type": "OTHER"
			},
			{
				"name": "grievances",
				"salience": 0.0014829155,
				"type": "OTHER"
			},
			{
				"name": "reliance",
				"salience": 0.0014829155,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/54145268__48951920_south_china-sea_1_466-1.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T05:20:41.744+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "US Keen to Keep South China Sea Nations Buying From Them, Not China by Jason Ditz, October 28, 2016 Share This \nUnited States determination to keep its South China Sea territorial disputes with China going rests heavily on having nations with active claims in the sea as US client states, particularly those with claims that conflict with China’s. That used to be, with several nations having such claims. \nBut the US is struggling to keep those nations exclusively buying US arms. Today’s big loss was from Malaysia , which has announced they intend to buy littoral mission ships from China, instead of the United States. Details on the decision-making process are unclear, but the US problems with their own littoral combat ships breaking down, so that might’ve hurt their chances. \nIt’s a comparatively small deal, but part of a growing trend. Philippines President Rodrigo Duterte has been making headlines for weeks with his interest in ending long-standing reliance on the US. While this has grown into complaints about general US-Philippines relations, one of the early grievances was his not liking the US dictating arms sales, and expressing interest in buying from China and Russia instead. \nIf these countries start buying their arms from China, they’ll have a strong incentive to resolve maritime disputes with China diplomatically, which could severely limit their interest in having warships patrolling through the area to “confront” China. Last 5 posts by Jason Ditz",
		"thread_title": "Malaysia to Buy Ships From China in Another Blow to US Regional Dominance",
		"title": "Malaysia to Buy Ships From China in Another Blow to US Regional Dominance",
		"type": "bs",
		"uuid": "71f54ed20f90ca496ce7716f18d91255f85e5198"
	},
	"-KhIiz-d_OF26Wdf0bnc": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T05:41:21.998+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.16476195,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.10900706,
				"type": "LOCATION"
			},
			{
				"name": "Militia Fighters",
				"salience": 0.089077294,
				"type": "PERSON"
			},
			{
				"name": "militias",
				"salience": 0.05873058,
				"type": "PERSON"
			},
			{
				"name": "west",
				"salience": 0.050347418,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.042662077,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.04193071,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03948909,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.036743544,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.036743544,
				"type": "PERSON"
			},
			{
				"name": "invasion",
				"salience": 0.036743544,
				"type": "EVENT"
			},
			{
				"name": "Areas West of City",
				"salience": 0.026247466,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shi'ite",
				"salience": 0.018400628,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni Arab",
				"salience": 0.018400628,
				"type": "OTHER"
			},
			{
				"name": "militias",
				"salience": 0.017713796,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.017623087,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.011918445,
				"type": "LOCATION"
			},
			{
				"name": "involvement",
				"salience": 0.009501736,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rvp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tal_Afar"
				},
				"name": "Tal Afar",
				"salience": 0.00942714,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.008379977,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.007826377,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.00731516,
				"type": "LOCATION"
			},
			{
				"name": "offensive",
				"salience": 0.00719563,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.006810279,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.006759497,
				"type": "LOCATION"
			},
			{
				"name": "Civilians",
				"salience": 0.0065078484,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0064215823,
				"type": "PERSON"
			},
			{
				"name": "cities",
				"salience": 0.006340873,
				"type": "LOCATION"
			},
			{
				"name": "offensive",
				"salience": 0.006104764,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00577767,
				"type": "OTHER"
			},
			{
				"name": "liberation",
				"salience": 0.0054925364,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0051557766,
				"type": "EVENT"
			},
			{
				"name": "territory",
				"salience": 0.004639046,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.004639046,
				"type": "LOCATION"
			},
			{
				"name": "torture",
				"salience": 0.0044856537,
				"type": "OTHER"
			},
			{
				"name": "locals",
				"salience": 0.0044856537,
				"type": "PERSON"
			},
			{
				"name": "league",
				"salience": 0.0044856537,
				"type": "OTHER"
			},
			{
				"name": "executions",
				"salience": 0.0044856537,
				"type": "OTHER"
			},
			{
				"name": "flight",
				"salience": 0.0044856537,
				"type": "OTHER"
			},
			{
				"name": "looting",
				"salience": 0.0044856537,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0038706253,
				"type": "LOCATION"
			},
			{
				"name": "militias",
				"salience": 0.0036060023,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0033522465,
				"type": "ORGANIZATION"
			},
			{
				"name": "left",
				"salience": 0.0033522465,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0031230103,
				"type": "PERSON"
			},
			{
				"name": "militias",
				"salience": 0.0026945719,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.00252579,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.0024421916,
				"type": "EVENT"
			},
			{
				"name": "posts",
				"salience": 0.0024421916,
				"type": "WORK_OF_ART"
			},
			{
				"name": "presence",
				"salience": 0.0023810735,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0023335211,
				"type": "PERSON"
			},
			{
				"name": "step",
				"salience": 0.0022633825,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0021070587,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.0021070587,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.0018246608,
				"type": "LOCATION"
			},
			{
				"name": "risks",
				"salience": 0.0018246608,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T05:41:21.998+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Militia Fighters to Advance on Areas West of City by Jason Ditz, October 28, 2016 Share This \nAfter a week and a half of assuring everyone that their role in the invasion of Mosul would be very limited, and removed from the Sunni population, Iraq’s Shi’ite militias have been announced to have launched an offensive west of Mosul, advancing on Tal Afar . \nAccording to officials, the main goal of this offensive is to cut the city of Mosul off from ISIS territory in Syria, preventing the ISIS fighters within the city from fleeing west if the battle begins to turn sour. The offensive is said to start “within a few days or hours.” \nThe involvement of Shi’ite militias in the “liberation” of Sunni Arab cities in Iraq has been controversial because they often end up carrying out extrajudicial executions, looting and torture of locals they suspect of being secretly in league with ISIS. \nAn effort to block flight from Mosul to ISIS territory is Syria would be an obvious step, but the militias’ involvement again risks targeting of civilians, as the population of from Mosul is already overrunning the minimal camps set up for the displaced. \nCivilians fleeing these cities are usually not welcomed in Iraqi government-held territory, and wind up fleeing into other ISIS-held territory. With little left in Iraq, this likely means fleeing into Syria, and the militias’ presence means the civilians displaced by the attack are likely to be targeted for fleeing “with” ISIS. Last 5 posts by Jason Ditz",
		"thread_title": "Shi’ite Militias Join Iraq’s Mosul Attack",
		"title": "Shi’ite Militias Join Iraq’s Mosul Attack",
		"type": "bs",
		"uuid": "433fe1c4ccf387d8fdd6317e1efb177095f68718"
	},
	"-KhIiz9JcDvzUXLoFewe": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T06:02:35.504+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.23869985,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.09971867,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0701105,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.05417041,
				"type": "LOCATION"
			},
			{
				"name": "Evidence",
				"salience": 0.049030334,
				"type": "OTHER"
			},
			{
				"name": "Notes",
				"salience": 0.04258611,
				"type": "OTHER"
			},
			{
				"name": "military offensive",
				"salience": 0.04258611,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.042203143,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.029255494,
				"type": "LOCATION"
			},
			{
				"name": "White phosphorus",
				"salience": 0.022769118,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.022630217,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.021771943,
				"type": "ORGANIZATION"
			},
			{
				"name": "concerns",
				"salience": 0.02045311,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.02045311,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.017732555,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.017487895,
				"type": "LOCATION"
			},
			{
				"name": "use",
				"salience": 0.0134010045,
				"type": "OTHER"
			},
			{
				"name": "phosphorus",
				"salience": 0.011613264,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0109473895,
				"type": "ORGANIZATION"
			},
			{
				"name": "use",
				"salience": 0.009177333,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.007689292,
				"type": "OTHER"
			},
			{
				"name": "phosphorus",
				"salience": 0.00746394,
				"type": "OTHER"
			},
			{
				"name": "war crime",
				"salience": 0.0073650405,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0073650405,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0064612767,
				"type": "PERSON"
			},
			{
				"name": "chemical burns",
				"salience": 0.006380067,
				"type": "OTHER"
			},
			{
				"name": "temperature",
				"salience": 0.006380067,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0063280696,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.0061424947,
				"type": "OTHER"
			},
			{
				"name": "smoke screens",
				"salience": 0.0061424947,
				"type": "OTHER"
			},
			{
				"name": "illumination",
				"salience": 0.0061424947,
				"type": "OTHER"
			},
			{
				"name": "war zones",
				"salience": 0.0061424947,
				"type": "LOCATION"
			},
			{
				"name": "risk",
				"salience": 0.0061424947,
				"type": "OTHER"
			},
			{
				"name": "chemical",
				"salience": 0.0060158414,
				"type": "OTHER"
			},
			{
				"name": "northeast",
				"salience": 0.0060158414,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0058316956,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.0048514265,
				"type": "OTHER"
			},
			{
				"name": "interpretation",
				"salience": 0.004496593,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0038945246,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0038945246,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0036555652,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.003628265,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.0035192743,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0031306075,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0028374381,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0028374381,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0024481253,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T06:02:35.504+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Notes Evidence of Use Northeast of Mosul by   \nWith Iraqi forces continuing to near the city of Mosul in a protracted military offensive, there are more than a few concerns about potential war crimes against the massive civilian population in the ISIS-held city. Today, Amnesty International’s concern centers on white phosphorus . \nWhite phosphorus is legally used both for smoke screens and for illumination in war zones, its use is often heavily criticized for the risk of civilian casualties in the intense temperature the chemical burns at. Its use in areas where civilians are present is considered a war crime. \nThis is particularly true around Mosul, a huge city in which some 1.5 million people are believed to still reside. Amnesty noted it has photographic evidence of the use of the chemical to the northeast of Mosul, and warned against any further use in areas where civilians are present or may be present in the near future. \nUS forces have been documented using white phosphorus recently in Iraq, though they insist they’ve only done so in ways consistent with their interpretation of international law. The US, of course, insists everything they do in Iraq is legal, but in the case of such a densely populated area, this could be a big problem.  ",
		"thread_title": "Amnesty Warns Against Using White Phosphorus in Attack on Mosul",
		"title": "Amnesty Warns Against Using White Phosphorus in Attack on Mosul",
		"type": "bs",
		"uuid": "1017fec72846254fbb3441529f5f912ec902029c"
	},
	"-KhIizPuQcDlxfvBS8vW": {
		"author": "Mike Merryman-Lotze",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T08:23:40.521+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.5519837,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0357_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gaza_Strip"
				},
				"name": "Gaza",
				"salience": 0.12661833,
				"type": "LOCATION"
			},
			{
				"name": "friends",
				"salience": 0.04441547,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.023746919,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.020995658,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.02059821,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03m6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamas"
				},
				"name": "Hamas",
				"salience": 0.016493144,
				"type": "ORGANIZATION"
			},
			{
				"name": "occupation",
				"salience": 0.008314704,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.008083286,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestine",
				"salience": 0.0075634136,
				"type": "LOCATION"
			},
			{
				"name": "military aid",
				"salience": 0.0072054616,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0072054616,
				"type": "OTHER"
			},
			{
				"name": "rockets",
				"salience": 0.006133823,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.005746389,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.005632139,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0054414477,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.0046516755,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.004535532,
				"type": "OTHER"
			},
			{
				"name": "escalation",
				"salience": 0.004257661,
				"type": "EVENT"
			},
			{
				"name": "incidents",
				"salience": 0.0036881308,
				"type": "EVENT"
			},
			{
				"name": "colleagues",
				"salience": 0.0036881308,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.0036881308,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.0036881308,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.002974235,
				"type": "OTHER"
			},
			{
				"name": "blockade",
				"salience": 0.0029206933,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.0023704136,
				"type": "OTHER"
			},
			{
				"name": "rockets",
				"salience": 0.0023704136,
				"type": "OTHER"
			},
			{
				"name": "periods",
				"salience": 0.0022084054,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0021628146,
				"type": "WORK_OF_ART"
			},
			{
				"name": "territory",
				"salience": 0.0019437042,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.0018176197,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0018176197,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0017551337,
				"type": "EVENT"
			},
			{
				"name": "story",
				"salience": 0.0017551337,
				"type": "WORK_OF_ART"
			},
			{
				"name": "event",
				"salience": 0.0017551337,
				"type": "EVENT"
			},
			{
				"name": "instances",
				"salience": 0.0017551337,
				"type": "OTHER"
			},
			{
				"name": "instances",
				"salience": 0.0017551337,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0017498302,
				"type": "OTHER"
			},
			{
				"name": "blockade",
				"salience": 0.0017490144,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0015199684,
				"type": "OTHER"
			},
			{
				"name": "odds",
				"salience": 0.0015199684,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.0015199684,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0015199684,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.0015199684,
				"type": "LOCATION"
			},
			{
				"name": "targets",
				"salience": 0.0015199684,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israelis",
				"salience": 0.001518715,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0015153746,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0015153746,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0015153746,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0013734228,
				"type": "OTHER"
			},
			{
				"name": "blockade",
				"salience": 0.0013574566,
				"type": "OTHER"
			},
			{
				"name": "Gazans",
				"salience": 0.0012547532,
				"type": "PERSON"
			},
			{
				"name": "none",
				"salience": 0.0012308578,
				"type": "OTHER"
			},
			{
				"name": "None",
				"salience": 0.0012308578,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0011849323,
				"type": "OTHER"
			},
			{
				"name": "military escalation",
				"salience": 0.0011849323,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0010658817,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0010658817,
				"type": "OTHER"
			},
			{
				"name": "apology",
				"salience": 0.0010658817,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0010658817,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.001026107,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.001026107,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.001026107,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.001026107,
				"type": "OTHER"
			},
			{
				"name": "blockade",
				"salience": 0.0010141752,
				"type": "EVENT"
			},
			{
				"name": "rockets",
				"salience": 0.0010141752,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.0009674041,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0009271427,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0009011963,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.00089076796,
				"type": "LOCATION"
			},
			{
				"name": "decision",
				"salience": 0.0008812971,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "travel",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "average",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "assurances",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "restrictions",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "ceasefire agreement",
				"salience": 0.00087019417,
				"type": "WORK_OF_ART"
			},
			{
				"name": "effect",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00087019417,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.00087019417,
				"type": "EVENT"
			},
			{
				"name": "trade",
				"salience": 0.00087019417,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0008496349,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0nyg5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestinian_territories"
				},
				"name": "Palestinian territories",
				"salience": 0.0008391741,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.0008076196,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0008076196,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00078625814,
				"type": "OTHER"
			},
			{
				"name": "military incursions",
				"salience": 0.000750728,
				"type": "OTHER"
			},
			{
				"name": "blockade",
				"salience": 0.0007386827,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ftnk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Office_for_the_Coordination_of_Humanitarian_Affairs"
				},
				"name": "United Nations Office for the Coordination of Humanitarian Affairs",
				"salience": 0.00065611023,
				"type": "ORGANIZATION"
			},
			{
				"name": "firing",
				"salience": 0.0006500736,
				"type": "EVENT"
			},
			{
				"name": "situation",
				"salience": 0.0006500736,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0006500736,
				"type": "PERSON"
			},
			{
				"name": "pundits",
				"salience": 0.0006500736,
				"type": "PERSON"
			},
			{
				"name": "ruins",
				"salience": 0.0006500736,
				"type": "LOCATION"
			},
			{
				"name": "bombardment",
				"salience": 0.0006500736,
				"type": "EVENT"
			},
			{
				"name": "homes",
				"salience": 0.0006500736,
				"type": "LOCATION"
			},
			{
				"name": "reconstruction materials",
				"salience": 0.0006500736,
				"type": "OTHER"
			},
			{
				"name": "Palestine-Israel",
				"salience": 0.0006481401,
				"type": "ORGANIZATION"
			},
			{
				"name": "military incursions",
				"salience": 0.0006286156,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.00061856466,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.00060557347,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0006033203,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0005825609,
				"type": "OTHER"
			},
			{
				"name": "blockade",
				"salience": 0.0005518147,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00054676906,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.00054676906,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0005306943,
				"type": "OTHER"
			},
			{
				"name": "Program Director",
				"salience": 0.0004734507,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0004734507,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0004734507,
				"type": "OTHER"
			},
			{
				"name": "raisons d'etre",
				"salience": 0.00046159275,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.00045236712,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00036928442,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0003536616,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0003536616,
				"type": "PERSON"
			},
			{
				"name": "failure",
				"salience": 0.0003536616,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0003536616,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.0003536616,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0003536616,
				"type": "OTHER"
			},
			{
				"name": "military operation",
				"salience": 0.0003536616,
				"type": "EVENT"
			},
			{
				"name": "Mike Merryman-Lotze",
				"salience": 0.00029510455,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017rlk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Friends_Service_Committee"
				},
				"name": "American Friends Service Committee",
				"salience": 0.00029138508,
				"type": "ORGANIZATION"
			},
			{
				"name": "OtherWords.org",
				"salience": 0.00029138508,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T08:23:40.521+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nThis fall, the U.S. agreed to provide $38 billion in military aid to Israel over the next ten years, ensuring America’s continued role in funding the occupation of Palestine. Meanwhile, my friends and colleagues here in Gaza live in fear of another significant Israeli attack in the near future. \nThey have every reason to fear another major escalation – violence is a daily reality in Gaza. In two recent incidents, a rocket was fired from Gaza into Israel without causing damage or injuries, and in both instances Israel responded by bombing targets throughout Gaza. \nIn August alone, Israel bombed more than 50 locations in the small territory . \nThe simple story told about these events focuses on action and reaction: Palestinians attacked Israel with a rocket and Israel responded. We hear this logic after nearly every event of this sort, but it’s woefully incomplete. \nIn both instances, the rockets fired weren’t fired by Hamas, but rather by small radical armed groups at odds with Hamas, which governs Gaza. These groups seek to incite Israeli attacks on Hamas with the goal of destabilizing its control over Gaza, because they see Hamas as too comfortable with the status quo. \nSince seizing power in 2007, Hamas has worked to control and limit violence from the territory. Outside of periods of defined military escalation – which tend to be precipitated by Israeli attacks – they have effectively stopped attacks against Israel from Gaza. \nThis explains why, as noted by the Israeli press, there were only 14 rockets fired from Gaza towards Israel between January and August this year. None were fired by Hamas, so Israel’s decision to target Hamas as a response makes no sense. \nOf course, 14 rockets fired from Gaza is 14 too many for those of us committed to ending all violence, and none of this should be taken as an apology for other violence perpetrated by Hamas. \nBut, as the United Nations Office for the Coordination of Humanitarian Affairs in the occupied Palestinian territories reports , there were also 45 Israeli military incursions into Gaza this year, resulting in 7 Palestinian deaths and, on average, injuring five Palestinians in Gaza every week. \nThis is the part of the story that isn’t told. \nGaza also remains under an Israeli-imposed blockade that severely limits travel, trade, and life for Gazans. Despite assurances that restrictions would be lifted in the 2014 Hamas-Israel ceasefire agreement, the blockade remains in effect. \nIsrael, with support from the US government, claims this decades-long blockade is in place to pressure the people of Gaza to rise up against Hamas and provide security for Israelis. \nIf those are Israel’s raisons d’etre, then it’s a complete failure. It hasn’t stopped violence, it hasn’t weakened Hamas, and it hasn’t brought Israelis or Palestinians security. \nWhile the blockade hasn’t succeeded in achieving the changes Israel claims to be seeking, its impact on the civilian population of Gaza has been immense. \nOver two years after the end of the last large military operation there, much of Gaza remains in ruins. \nOf the 100,000 Palestinians in Gaza who were displaced during the 2014 Israeli bombardment, over 65,000 remain homeless, as 70 percent of the homes seriously damaged or destroyed haven’t been rebuilt. This is largely because reconstruction materials remain blocked from entering Gaza. \nThis important context is too often missing as US pundits and politicians consider the situation in Gaza. \nGiven the blockade and regular military incursions imposed by Israel, the firing of less than 2 rockets per month by Palestinians cannot be seen as the core reason for violence. \nIf the US is serious about promoting peace between Israelis and Palestinians, preventing future violence in Gaza, and guaranteeing security, then it must recognize the violence inherent in the Israeli occupation and end the blockade. \nThe next attack on Gaza, feared by my friends who live there, is an inevitable reality if nothing changes. \nMike Merryman-Lotze has worked with the American Friends Service Committee as the Palestine-Israel Program Director since 2010. Distributed by OtherWords.org .",
		"thread_title": "Israel’s Blockade of Gaza Is Inherently Violent",
		"title": "Israel’s Blockade of Gaza Is Inherently Violent",
		"type": "bs",
		"uuid": "7b93f268d3884b6ada5f6473489292fb76f2e6a7"
	},
	"-KhIizyZOfRCt7Lgq8i-": {
		"author": "Pat Hynes",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T08:23:40.688+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.060028043,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.025570162,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.023575857,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/088xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Republic_of_the_Congo"
				},
				"name": "Democratic Republic of Congo",
				"salience": 0.022568142,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.018633647,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026fkt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_Kony"
				},
				"name": "Joseph Kony",
				"salience": 0.017471984,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.016993405,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.016151877,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.015020707,
				"type": "PERSON"
			},
			{
				"name": "Child soldiers",
				"salience": 0.013710623,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0122876745,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.012118057,
				"type": "PERSON"
			},
			{
				"name": "Child Soldier Prevention Act",
				"salience": 0.011720548,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0114406,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.011216398,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.010739856,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.009496261,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.009496261,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.009496261,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00941358,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00939938,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0w_051t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grace_Akallo"
				},
				"name": "Grace Akallo",
				"salience": 0.00883879,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.008811591,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.008698215,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.008698215,
				"type": "PERSON"
			},
			{
				"name": "boy soldiers",
				"salience": 0.008313761,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.008117336,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0077910125,
				"type": "ORGANIZATION"
			},
			{
				"name": "girls",
				"salience": 0.00705798,
				"type": "PERSON"
			},
			{
				"name": "secretary of State",
				"salience": 0.006368504,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.0060632084,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.006035717,
				"type": "PERSON"
			},
			{
				"name": "girl soldiers",
				"salience": 0.0059070545,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0057080397,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0056773503,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.005528006,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.005342022,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0053215073,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0053215073,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0053215073,
				"type": "EVENT"
			},
			{
				"name": "girls",
				"salience": 0.0052084057,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.005168919,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0czcxyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leymah_Gbowee"
				},
				"name": "Leymah Gbowee",
				"salience": 0.0048982846,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.0048235427,
				"type": "PERSON"
			},
			{
				"name": "tens of thousands",
				"salience": 0.00480535,
				"type": "PERSON"
			},
			{
				"name": "tens of thousands",
				"salience": 0.00480535,
				"type": "PERSON"
			},
			{
				"name": "rape",
				"salience": 0.00480535,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.004678909,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.004504428,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.004504428,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.004504428,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.004504428,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0044176187,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.0041929437,
				"type": "LOCATION"
			},
			{
				"name": "military aid",
				"salience": 0.0041616186,
				"type": "OTHER"
			},
			{
				"name": "military aid",
				"salience": 0.0041616186,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0041616186,
				"type": "PERSON"
			},
			{
				"name": "torture",
				"salience": 0.0041616186,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.0041616186,
				"type": "OTHER"
			},
			{
				"name": "child soldiers",
				"salience": 0.0039142654,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.0039142654,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.0039142654,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.0039142654,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0038801243,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0038801243,
				"type": "PERSON"
			},
			{
				"name": "minerals",
				"salience": 0.0037578274,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.0037578274,
				"type": "OTHER"
			},
			{
				"name": "minerals",
				"salience": 0.0037578274,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0037578274,
				"type": "ORGANIZATION"
			},
			{
				"name": "Others",
				"salience": 0.0036890693,
				"type": "PERSON"
			},
			{
				"name": "girl soldiers",
				"salience": 0.0036042212,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.0035847726,
				"type": "PERSON"
			},
			{
				"name": "ban",
				"salience": 0.0032542758,
				"type": "OTHER"
			},
			{
				"name": "kill",
				"salience": 0.0032542758,
				"type": "EVENT"
			},
			{
				"name": "childhood nightmares",
				"salience": 0.0032542758,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.0032542758,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.0032542758,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.0032542758,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0032542758,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0030325712,
				"type": "LOCATION"
			},
			{
				"name": "boys",
				"salience": 0.0028874879,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.0027449806,
				"type": "PERSON"
			},
			{
				"name": "rebel soldiers",
				"salience": 0.0027449806,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.0027449806,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.002721029,
				"type": "PERSON"
			},
			{
				"name": "military resources",
				"salience": 0.002656935,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.0026529136,
				"type": "PERSON"
			},
			{
				"name": "boy soldiers",
				"salience": 0.0026425559,
				"type": "PERSON"
			},
			{
				"name": "boy soldiers",
				"salience": 0.0026425559,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.0026425559,
				"type": "PERSON"
			},
			{
				"name": "girl soldiers",
				"salience": 0.0026254463,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0026194972,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0026194972,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0026194972,
				"type": "PERSON"
			},
			{
				"name": "Children",
				"salience": 0.0026194972,
				"type": "PERSON"
			},
			{
				"name": "wives",
				"salience": 0.0025869994,
				"type": "PERSON"
			},
			{
				"name": "high school girls",
				"salience": 0.0025138347,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.0025138347,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00245862,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00245862,
				"type": "PERSON"
			},
			{
				"name": "each",
				"salience": 0.0024439408,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0024200282,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.0024200282,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.0024200282,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.0024200282,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.0024043582,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05zvrb7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmie_Briggs"
				},
				"name": "Jimmie Briggs",
				"salience": 0.0022581078,
				"type": "PERSON"
			},
			{
				"name": "girl soldiers",
				"salience": 0.002241056,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.002241056,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.0021917261,
				"type": "EVENT"
			},
			{
				"name": "conflicts",
				"salience": 0.0021917261,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.0021917261,
				"type": "EVENT"
			},
			{
				"name": "waiver",
				"salience": 0.0021148522,
				"type": "OTHER"
			},
			{
				"name": "boys",
				"salience": 0.002090258,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0020247246,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05rznz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Sudan"
				},
				"name": "South Sudan",
				"salience": 0.0020033775,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05cgv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nigeria"
				},
				"name": "Nigeria",
				"salience": 0.0020033775,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.0020033775,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.0019789457,
				"type": "PERSON"
			},
			{
				"name": "child soldier",
				"salience": 0.0019493304,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/047gmxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lord's_Resistance_Army"
				},
				"name": "Lord's Resistance Army",
				"salience": 0.0019374299,
				"type": "ORGANIZATION"
			},
			{
				"name": "child soldiers",
				"salience": 0.0019005209,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0018549131,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0018549131,
				"type": "OTHER"
			},
			{
				"name": "rebel",
				"salience": 0.0018549131,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0017136331,
				"type": "ORGANIZATION"
			},
			{
				"name": "Reality",
				"salience": 0.0017136331,
				"type": "OTHER"
			},
			{
				"name": "girl soldiers",
				"salience": 0.001674195,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.001674195,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.001674195,
				"type": "PERSON"
			},
			{
				"name": "girl soldiers",
				"salience": 0.001674195,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.001674195,
				"type": "PERSON"
			},
			{
				"name": "commitments",
				"salience": 0.0016634533,
				"type": "OTHER"
			},
			{
				"name": "childhood",
				"salience": 0.0016595818,
				"type": "OTHER"
			},
			{
				"name": "babies",
				"salience": 0.0016513334,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0016513334,
				"type": "PERSON"
			},
			{
				"name": "commanders",
				"salience": 0.0016013631,
				"type": "PERSON"
			},
			{
				"name": "Pat Hynes",
				"salience": 0.0015931218,
				"type": "PERSON"
			},
			{
				"name": "village",
				"salience": 0.0015669891,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0015576282,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0015472444,
				"type": "ORGANIZATION"
			},
			{
				"name": "elders",
				"salience": 0.0015472444,
				"type": "PERSON"
			},
			{
				"name": "family abuse",
				"salience": 0.0015472444,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0015331719,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.0015224173,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.001492033,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0014793855,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0014793855,
				"type": "EVENT"
			},
			{
				"name": "peace",
				"salience": 0.0014655889,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hzj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberia"
				},
				"name": "Liberia",
				"salience": 0.0014236129,
				"type": "LOCATION"
			},
			{
				"name": "boys",
				"salience": 0.0014108808,
				"type": "PERSON"
			},
			{
				"name": "boys",
				"salience": 0.0014108808,
				"type": "PERSON"
			},
			{
				"name": "rapes",
				"salience": 0.0013875271,
				"type": "EVENT"
			},
			{
				"name": "rape",
				"salience": 0.0013875271,
				"type": "EVENT"
			},
			{
				"name": "fighters",
				"salience": 0.0013875271,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0013795033,
				"type": "ORGANIZATION"
			},
			{
				"name": "commanders",
				"salience": 0.0013579885,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0013579885,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0013579885,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0013568823,
				"type": "OTHER"
			},
			{
				"name": "route",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "hunger",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "enemy brutality",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "fields",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "ages",
				"salience": 0.0013397838,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0013397838,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0013357317,
				"type": "PERSON"
			},
			{
				"name": "fighting",
				"salience": 0.0013357317,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.0013357317,
				"type": "PERSON"
			},
			{
				"name": "image",
				"salience": 0.0013357317,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fighter",
				"salience": 0.0013357317,
				"type": "PERSON"
			},
			{
				"name": "civil war",
				"salience": 0.0012545415,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01ls2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colombia"
				},
				"name": "Colombia",
				"salience": 0.0012540572,
				"type": "LOCATION"
			},
			{
				"name": "cases",
				"salience": 0.0012519968,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0012519968,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0012519968,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0012519968,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons",
				"salience": 0.0012519968,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.001243887,
				"type": "OTHER"
			},
			{
				"name": "child soldiers",
				"salience": 0.0012193376,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.0012193376,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.0012193376,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.0012193376,
				"type": "OTHER"
			},
			{
				"name": "child soldiers",
				"salience": 0.0012193376,
				"type": "PERSON"
			},
			{
				"name": "servants",
				"salience": 0.0012014738,
				"type": "PERSON"
			},
			{
				"name": "wives",
				"salience": 0.0012014738,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0012014738,
				"type": "OTHER"
			},
			{
				"name": "boys",
				"salience": 0.0011664794,
				"type": "PERSON"
			},
			{
				"name": "servants",
				"salience": 0.0011566209,
				"type": "PERSON"
			},
			{
				"name": "rehabilitation process",
				"salience": 0.0011566209,
				"type": "OTHER"
			},
			{
				"name": "adults",
				"salience": 0.0011566209,
				"type": "PERSON"
			},
			{
				"name": "rape",
				"salience": 0.0011327128,
				"type": "EVENT"
			},
			{
				"name": "villages",
				"salience": 0.0010847967,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.0010847967,
				"type": "LOCATION"
			},
			{
				"name": "cycle",
				"salience": 0.0010847967,
				"type": "OTHER"
			},
			{
				"name": "prostitution",
				"salience": 0.0010847967,
				"type": "OTHER"
			},
			{
				"name": "misogyny",
				"salience": 0.0010847967,
				"type": "OTHER"
			},
			{
				"name": "investigators",
				"salience": 0.0010799507,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.0010617005,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0010617005,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0010617005,
				"type": "ORGANIZATION"
			},
			{
				"name": "cooks",
				"salience": 0.0010442982,
				"type": "OTHER"
			},
			{
				"name": "prevalence",
				"salience": 0.0010442982,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.0010442982,
				"type": "OTHER"
			},
			{
				"name": "porters",
				"salience": 0.0010442982,
				"type": "PERSON"
			},
			{
				"name": "survey",
				"salience": 0.0010442982,
				"type": "OTHER"
			},
			{
				"name": "portering",
				"salience": 0.0010442982,
				"type": "OTHER"
			},
			{
				"name": "cooking",
				"salience": 0.0010442982,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.001026531,
				"type": "PERSON"
			},
			{
				"name": "revenge",
				"salience": 0.0010008201,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0009913291,
				"type": "ORGANIZATION"
			},
			{
				"name": "stigma",
				"salience": 0.0009882071,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0009808167,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.0009808167,
				"type": "EVENT"
			},
			{
				"name": "torture",
				"salience": 0.0009808167,
				"type": "OTHER"
			},
			{
				"name": "seasoning process",
				"salience": 0.0009808167,
				"type": "OTHER"
			},
			{
				"name": "Leaders",
				"salience": 0.0009737821,
				"type": "PERSON"
			},
			{
				"name": "war photos",
				"salience": 0.0009562503,
				"type": "WORK_OF_ART"
			},
			{
				"name": "photos",
				"salience": 0.0009562503,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07tp2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uganda"
				},
				"name": "Uganda",
				"salience": 0.0009523027,
				"type": "LOCATION"
			},
			{
				"name": "girls",
				"salience": 0.0009468894,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.0009468894,
				"type": "PERSON"
			},
			{
				"name": "pain",
				"salience": 0.00093932403,
				"type": "OTHER"
			},
			{
				"name": "boarding school dormitory",
				"salience": 0.00093932403,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.00093932403,
				"type": "OTHER"
			},
			{
				"name": "ex-soldier",
				"salience": 0.00093932403,
				"type": "WORK_OF_ART"
			},
			{
				"name": "husband",
				"salience": 0.00093932403,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.00093932403,
				"type": "OTHER"
			},
			{
				"name": "utility",
				"salience": 0.00093932403,
				"type": "OTHER"
			},
			{
				"name": "community honor",
				"salience": 0.00093932403,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.00093932403,
				"type": "LOCATION"
			},
			{
				"name": "infections",
				"salience": 0.00093932403,
				"type": "OTHER"
			},
			{
				"name": "sexually transmitted diseases",
				"salience": 0.00093932403,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00093932403,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0009379015,
				"type": "PERSON"
			},
			{
				"name": "counterparts",
				"salience": 0.0009371374,
				"type": "PERSON"
			},
			{
				"name": "girl soldiers",
				"salience": 0.0009108376,
				"type": "PERSON"
			},
			{
				"name": "suicide bombers",
				"salience": 0.00090425485,
				"type": "PERSON"
			},
			{
				"name": "trauma",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "cleaning",
				"salience": 0.00090425485,
				"type": "EVENT"
			},
			{
				"name": "terrorists",
				"salience": 0.00090425485,
				"type": "PERSON"
			},
			{
				"name": "spies",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.00090425485,
				"type": "PERSON"
			},
			{
				"name": "combat",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "finding",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "sex discrimination",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "human shields",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "warring parties",
				"salience": 0.00090425485,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "slavery",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "cessation",
				"salience": 0.00090425485,
				"type": "EVENT"
			},
			{
				"name": "peace talks",
				"salience": 0.00090425485,
				"type": "EVENT"
			},
			{
				"name": "exchange",
				"salience": 0.00090425485,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.00090425485,
				"type": "PERSON"
			},
			{
				"name": "contrast",
				"salience": 0.0008855618,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.00084612344,
				"type": "WORK_OF_ART"
			},
			{
				"name": "images",
				"salience": 0.00084612344,
				"type": "WORK_OF_ART"
			},
			{
				"name": "women",
				"salience": 0.00084612344,
				"type": "PERSON"
			},
			{
				"name": "images",
				"salience": 0.00084612344,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tens of thousands",
				"salience": 0.00084612344,
				"type": "PERSON"
			},
			{
				"name": "images",
				"salience": 0.00084612344,
				"type": "WORK_OF_ART"
			},
			{
				"name": "girls",
				"salience": 0.00083409727,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.00083409727,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06s_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sierra_Leone"
				},
				"name": "Sierra Leone",
				"salience": 0.00082459295,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asia",
				"salience": 0.00082459295,
				"type": "LOCATION"
			},
			{
				"name": "innocence",
				"salience": 0.00080670725,
				"type": "OTHER"
			},
			{
				"name": "thorn",
				"salience": 0.00080670725,
				"type": "OTHER"
			},
			{
				"name": "boy soldiers",
				"salience": 0.0008023388,
				"type": "PERSON"
			},
			{
				"name": "rebellion",
				"salience": 0.0007930735,
				"type": "EVENT"
			},
			{
				"name": "handful",
				"salience": 0.0007900303,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.0007668002,
				"type": "EVENT"
			},
			{
				"name": "laureate",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "skin",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "encounter",
				"salience": 0.0007668002,
				"type": "EVENT"
			},
			{
				"name": "father",
				"salience": 0.0007668002,
				"type": "PERSON"
			},
			{
				"name": "backs",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "wills",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "consciences",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "sibling",
				"salience": 0.0007668002,
				"type": "PERSON"
			},
			{
				"name": "rifles",
				"salience": 0.0007668002,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "butts",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "sticks",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.0007668002,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00075147295,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0007443395,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.00073877245,
				"type": "PERSON"
			},
			{
				"name": "functions",
				"salience": 0.0007381705,
				"type": "OTHER"
			},
			{
				"name": "suicide",
				"salience": 0.0007326496,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0007326496,
				"type": "PERSON"
			},
			{
				"name": "photos",
				"salience": 0.0007326496,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reality",
				"salience": 0.0007326496,
				"type": "OTHER"
			},
			{
				"name": "militias",
				"salience": 0.0007326496,
				"type": "PERSON"
			},
			{
				"name": "human rights",
				"salience": 0.00069640524,
				"type": "OTHER"
			},
			{
				"name": "armed conflict",
				"salience": 0.0006824848,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0006824848,
				"type": "LOCATION"
			},
			{
				"name": "conflict",
				"salience": 0.0006824848,
				"type": "EVENT"
			},
			{
				"name": "individual",
				"salience": 0.0006710792,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07tp2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uganda"
				},
				"name": "Uganda",
				"salience": 0.0006676355,
				"type": "LOCATION"
			},
			{
				"name": "contrast",
				"salience": 0.00066149107,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.00066149107,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.00066149107,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0006585357,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0006508738,
				"type": "OTHER"
			},
			{
				"name": "violators",
				"salience": 0.00064740557,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00064009754,
				"type": "PERSON"
			},
			{
				"name": "crime",
				"salience": 0.00061537744,
				"type": "OTHER"
			},
			{
				"name": "garbage heap",
				"salience": 0.00059498975,
				"type": "OTHER"
			},
			{
				"name": "child soldiers",
				"salience": 0.00059176754,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cpbmpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Mary's_College_Kisubi"
				},
				"name": "St. Mary's College Kisubi",
				"salience": 0.0005780943,
				"type": "ORGANIZATION"
			},
			{
				"name": "violation",
				"salience": 0.00057756074,
				"type": "OTHER"
			},
			{
				"name": "hookers",
				"salience": 0.00057277374,
				"type": "PERSON"
			},
			{
				"name": "pictures",
				"salience": 0.00057277374,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cartoons",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "thighs",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "muscles",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "gun",
				"salience": 0.00057277374,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "armies",
				"salience": 0.00057277374,
				"type": "ORGANIZATION"
			},
			{
				"name": "search",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "decorations",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.00057277374,
				"type": "LOCATION"
			},
			{
				"name": "prey",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "depravity",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "unreality",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "exercise",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "Fiction",
				"salience": 0.00057277374,
				"type": "WORK_OF_ART"
			},
			{
				"name": "traces",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"name": "omission",
				"salience": 0.00057277374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06m_5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sri_Lanka"
				},
				"name": "Sri Lanka",
				"salience": 0.00055650895,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fxc0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UNICEF"
				},
				"name": "UNICEF",
				"salience": 0.00055650895,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/028dr4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Save_the_Children"
				},
				"name": "Save the Children",
				"salience": 0.0005556661,
				"type": "ORGANIZATION"
			},
			{
				"name": "community",
				"salience": 0.0005518367,
				"type": "OTHER"
			},
			{
				"name": "sham",
				"salience": 0.0005444371,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.000536116,
				"type": "ORGANIZATION"
			},
			{
				"name": "Many",
				"salience": 0.0005346161,
				"type": "PERSON"
			},
			{
				"name": "reintegration",
				"salience": 0.00053355383,
				"type": "OTHER"
			},
			{
				"name": "women's rights",
				"salience": 0.00053355383,
				"type": "OTHER"
			},
			{
				"name": "civil rights",
				"salience": 0.00053355383,
				"type": "OTHER"
			},
			{
				"name": "militarism",
				"salience": 0.00053355383,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.00053355383,
				"type": "OTHER"
			},
			{
				"name": "militarism",
				"salience": 0.00053355383,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0005097895,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0005097895,
				"type": "EVENT"
			},
			{
				"name": "boys",
				"salience": 0.00048617605,
				"type": "PERSON"
			},
			{
				"name": "exploitation",
				"salience": 0.00048172945,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00048172945,
				"type": "OTHER"
			},
			{
				"name": "rehabilitation",
				"salience": 0.00048172945,
				"type": "OTHER"
			},
			{
				"name": "climate justice",
				"salience": 0.00048172945,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00048172945,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.00047957705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AK-47"
				},
				"name": "AK-47s",
				"salience": 0.00047190665,
				"type": "OTHER"
			},
			{
				"name": "Liberian Nobel Peace Prize",
				"salience": 0.00047190665,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0tw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles_Taylor_(Liberian_politician)"
				},
				"name": "Charles Taylor",
				"salience": 0.00047190665,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00046027303,
				"type": "PERSON"
			},
			{
				"name": "interaction",
				"salience": 0.00043141158,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.00043141158,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00043141158,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "xenophobia",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00041711796,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.00041711796,
				"type": "ORGANIZATION"
			},
			{
				"name": "arms",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "feminism",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "floodlight",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "coverall",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "hypocrisy",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "erasure",
				"salience": 0.00041711796,
				"type": "OTHER"
			},
			{
				"name": "Forgotten Casualties of War: Girls in Armed Conflict",
				"salience": 0.00041375274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nexus",
				"salience": 0.00040154252,
				"type": "OTHER"
			},
			{
				"name": "suicides",
				"salience": 0.00039853898,
				"type": "EVENT"
			},
			{
				"name": "programs",
				"salience": 0.00039853898,
				"type": "OTHER"
			},
			{
				"name": "child wives",
				"salience": 0.00039853898,
				"type": "PERSON"
			},
			{
				"name": "reintegration programs",
				"salience": 0.00039853898,
				"type": "OTHER"
			},
			{
				"name": "reintegration programs",
				"salience": 0.00039853898,
				"type": "OTHER"
			},
			{
				"name": "HIV/AIDS",
				"salience": 0.00039648105,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.00035982716,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00035982716,
				"type": "LOCATION"
			},
			{
				"name": "community leaders",
				"salience": 0.00035982716,
				"type": "PERSON"
			},
			{
				"name": "abuse",
				"salience": 0.00035982716,
				"type": "OTHER"
			},
			{
				"name": "cycle",
				"salience": 0.00035982716,
				"type": "OTHER"
			},
			{
				"name": "elders",
				"salience": 0.00035982716,
				"type": "PERSON"
			},
			{
				"name": "prostitution",
				"salience": 0.00035982716,
				"type": "OTHER"
			},
			{
				"name": "demobilization",
				"salience": 0.00035982716,
				"type": "OTHER"
			},
			{
				"name": "Armed Services Day",
				"salience": 0.00035248976,
				"type": "EVENT"
			},
			{
				"name": "traffic",
				"salience": 0.000344843,
				"type": "OTHER"
			},
			{
				"name": "reflection",
				"salience": 0.00033196606,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.00033196606,
				"type": "EVENT"
			},
			{
				"name": "sides",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "neglect",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "job skills",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00031156404,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "nongovernmental organizations",
				"salience": 0.00031156404,
				"type": "ORGANIZATION"
			},
			{
				"name": "disarmament",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.00031156404,
				"type": "WORK_OF_ART"
			},
			{
				"name": "burdens",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.00031156404,
				"type": "ORGANIZATION"
			},
			{
				"name": "recrimination",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "exit",
				"salience": 0.00031156404,
				"type": "LOCATION"
			},
			{
				"name": "spiral",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "ex-soldiers",
				"salience": 0.00031156404,
				"type": "PERSON"
			},
			{
				"name": "submission",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"name": "manhood",
				"salience": 0.00031156404,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gl5_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston_University"
				},
				"name": "Boston University",
				"salience": 0.0002566929,
				"type": "ORGANIZATION"
			},
			{
				"name": "Traprock Center for Peace and Justice",
				"salience": 0.0002566929,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "Massachusetts",
				"salience": 0.0002566929,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03v8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Criminal_Court"
				},
				"name": "International Criminal Court",
				"salience": 0.0002566929,
				"type": "ORGANIZATION"
			},
			{
				"name": "maleness.",
				"salience": 0.00025433017,
				"type": "OTHER"
			},
			{
				"name": "misogyny",
				"salience": 0.00023376365,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.00019173288,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T08:23:40.688+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 29,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nAs secretary of State, Hillary Clinton was visibly shaken by sexual crimes against women and girls when she visited the Democratic Republic of Congo (DRC) in 2009. Sexual crimes in this central African country, known as the “rape capital of the world,” include the sexual exploitation of tens of thousands of girls abducted and trapped as child soldiers. Nonetheless, since 2010, President Obama has waived a congressionally mandated ban on military aid to countries known to exploit child soldiers, among them the DRC. \nThe DRC’s eastern region is exceedingly rich in rare minerals and exceedingly rife with decades of brutal war over those minerals. This country and three others – Nigeria, Somalia and South Sudan – each of which exploits thousands of child soldiers, will receive more than $161 million in U.S. military aid in fiscal year 2016. \nThe Child Soldier Prevention Act of 2008 bans the US government from providing military resources and aid to countries that use soldiers younger than 18; it allows a presidential waiver in cases of “national interest,” however. But what possible “national interest” can override the lives of tens of thousands of children shattered in the worst of childhood nightmares – lives of being forced to torture, kill and rape, and in the case of girls, lives of being serially raped and impregnated? \nThe Reality \nAt any given time, about 300,000 children between the ages of 8 and 18 are exploited as child soldiers in scores of civil and international conflicts in Africa, Asia and Colombia. In Sierra Leone’s civil war (1991-2001), 80 percent of fighters were between 7 and 15 years old; in Liberia’s conflict (1989-2003), up to 70 percent of government and rebel troops were children. Forty percent of soldiers slain in Colombia were children; the Lord’s Resistance Army in Uganda is mainly composed of children. They are abducted from agricultural fields, or taken en route to school or market, or when their village is attacked. Others join for reasons of extreme poverty and hunger; fleeing family abuse; revenge for enemy brutality upon their family; being drawn to a popular cause; and, in the case of some boys, as a way to garner respect from male elders. In-depth investigators of child soldiers conclude , “… never before in the history of warfare have children been so exploited on such a vast scale.” \nWhat most people do not realize is how many child soldiers are girls – an estimated 40 percent, who are exploited, like boy soldiers, as servants, cooks, porters, spies, human shields, suicide bombers and fighters. In Sri Lanka, more than 43 percent of 50,000 children in armed groups were girls, a finding determined during peace talks between warring parties and UNICEF and documented by journalist Jimmie Briggs . Deepening their trauma, girls are taken into sexual slavery by boy soldiers, adult soldiers and commanders and, in some cases, sold in exchange for weapons. Given the popular image of boys as child soldiers, hundreds of thousands of girls constitute an invisible army and “forgotten casualties of war” in the rehabilitation process following the cessation of armed conflict. \nArmed groups target children for wars because children – and particularly girls, because of sex discrimination – are obedient, vulnerable and malleable. Children can be more easily indoctrinated into being the next generation of armed rebels and terrorists. Child soldiers are cheap because they are unpaid and eat less than adults; and they provide functions such as cooking, cleaning and portering, thus freeing up adult soldiers for more rigorous fighting. With the prevalence of light but deadly weapons, both girls and boys are trained for combat. In a 2002 survey, nearly half the interviewed girls in armed groups described their primary role as “fighter.” \nDespite their utility as fighters and servants, girl soldiers are raped, prostituted, mutilated, infected with sexually transmitted diseases including HIV/AIDS, and made pregnant by soldiers. Many are permanently injured and will suffer lifelong pain as a result of multiple rapes and untreated infections. Returning to their villages and homes, numerous girls have reported that they are rejected as filthy and immoral, and they are blamed for disgracing family and community honor. Even more shunned are girls who return pregnant or with children born of rape. Losing family and social support, they are compelled to turn to prostitution or stay with an abusive ex-soldier “husband” in order to raise their child and survive. \nMoreover, even after commitments to release child soldiers, armed groups often refuse to give up girls, holding them captive as “wives.” Thus, the full cycle of misogyny entraps girls: ruthlessly violated as child soldiers, ostracized when returning home and often not released in the “peace” process. \nFifteen-year-old Grace Akallo was abducted in 1996 with 29 other high school girls from her boarding school dormitory at St. Mary’s College Kisubi in northern Uganda by warlord Joseph Kony and rebel soldiers of the Lord’s Resistance Army. Physically, the girls were pushed to the point of death, walking barefoot, given little food and water and beaten with sticks and the butts of rifles. And spiritually, they were driven to the point of death, forced to torture and kill other children – sometimes a sibling – in a seasoning process designed to dehumanize them, extinguish their consciences and break their wills. Kony forced the girls to train with AK-47s. He also distributed them among his commanders as “wives.” They were expected to fight even with babies strapped to their backs. \nAkallo was given to a man “older than her father,” who on first encounter seized her and raped her. “I felt like a thorn was in my skin as my innocence was destroyed,” she wrote of his sexual violence. In her community, the stigma of rape is so extreme that ex-girl soldiers will admit to murder before they will admit to having been raped. \nIn contrast to the outcast plight of girl soldiers, many boy soldiers earn a manly status in their communities. Leymah Gbowee, the Liberian Nobel Peace Prize laureate, works with ex-child soldiers from Charles Taylor’s army during Liberia’s civil war. Joseph, a boy she counseled, explained that he became a child soldier because “boys who joined the rebellion came back and were really respected and were often seen in the company of the elders and community leaders.” \nGbowee is convinced that the nexus between violence, weapons and manhood is responsible for drawing many former boy soldiers into the brutal, macho cycle of war. Many of the girls she assisted were “child wives” of the ex-soldiers and had been abducted, raped and beaten into submission. With no exit , each girl was “caught up in a spiral of one individual trying to prove his maleness. … The abuse women suffer during conflict is a reflection of the interaction between men and women, boys and girls, during peace time.” \nCompounding the excruciating burdens of girl soldiers is the failure of the disarmament, demobilization and reintegration programs of the United Nations and international nongovernmental organizations – programs intended to help former child soldiers with education, job skills and fitting back into society. Save the Children’s 2005 report, “Forgotten Casualties of War: Girls in Armed Conflict,” concludes that girls are caught between “recrimination from the armed group if they leave and from the community if they return home” and are invisible in the reintegration programs. The misogyny and neglect on all sides has sent many of them into prostitution for survival or resulted in their suicides. Former girl soldiers are more than twice as likely to commit suicide as their male counterparts. \nThe Fiction \nFor an exercise in unreality and moral depravity, Google images of “girl soldiers.” You will find a garbage heap of pornographic pictures: cartoons of large-breasted women with big thighs and some muscles, barely clothed, wielding a gun in each hand, looking like (so-called) “happy hookers” costumed for Armed Services Day. Sprinkled among these are photos of young female soldiers, hanging out passively, like decorations, among male soldiers. Of the first 200 images I perused, a handful portrayed real girl soldiers – serious beyond years with sad-to-death eyes. Yet even these photos lacked the gruesome reality of the tens of thousands of girls entrapped in armies and militias. \nFor contrast, Google images of “child soldiers.” Ninety-five percent of these images are boys. All are realistic war photos: children carrying, aiming and shooting weapons sometimes taller than they are; roaming streets in search of prey; poised to kill, faces deadly serious, some hardened, some older than their years, others still bearing traces of their stolen childhood. No airbrushed or pornographic reality on this site. Only a crucial omission: Real girl soldiers – who constitute up to 40 percent of child soldiers and suffer the most vile sexual violation and rejection – are missing . \nWe in the United States need a national floodlight on the issue of child soldiers. Employing children, by whatever means, in armed conflict is an crime against humanity recognized by the International Criminal Court. Forty percent of funding available for the rehabilitation of child soldiers should be dedicated to the reintegration of girls within their communities. Leaders who use child soldiers should be prosecuted and indicted. We need to research countries that traffic in arms and whose businesses invest in or conduct trade with countries that use child soldiers. And violators should be publicized, stigmatized and boycotted. \nWe need to frame and shame the hypocrisy of passing a law to protect children caught in conflict and then violating it for that morbid excuse of “national security” – a coverall for American militarism, xenophobia, torture, erasure of civil rights and sexual exploitation. Otherwise, political statements that women’s rights are human rights are a sham. \nPat Hynes, a retired professor of environmental health from Boston University, directs the Traprock Center for Peace and Justice in western Massachusetts. She writes and speaks on issues of feminism, climate justice, U.S. militarism and peace.",
		"thread_title": "Girl Soldiers: Forgotten Casualties of War",
		"title": "Girl Soldiers: Forgotten Casualties of War",
		"type": "bs",
		"uuid": "d7ff2e1c42d5365fa7d2509be9a4790ef8d467d9"
	},
	"-KhIj-8kQHPwxOLskKDL": {
		"author": "Margaret Griffis",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T08:23:41.495+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "people",
				"salience": 0.113596775,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.099129006,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.09875383,
				"type": "EVENT"
			},
			{
				"name": "John Dorrian",
				"salience": 0.06919375,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/096ld",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Organization_for_Migration"
				},
				"name": "International Organization for Migration",
				"salience": 0.061381873,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07rvp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tal_Afar"
				},
				"name": "Tal Afar",
				"salience": 0.056939628,
				"type": "LOCATION"
			},
			{
				"name": "tens of thousands",
				"salience": 0.053337593,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.05262215,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.029407457,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.025497107,
				"type": "ORGANIZATION"
			},
			{
				"name": "homes",
				"salience": 0.024434986,
				"type": "LOCATION"
			},
			{
				"name": "phosphorous",
				"salience": 0.02227134,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Security forces",
				"salience": 0.01950481,
				"type": "ORGANIZATION"
			},
			{
				"name": "militiamen",
				"salience": 0.018539127,
				"type": "PERSON"
			},
			{
				"name": "shells",
				"salience": 0.014868931,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.014868931,
				"type": "EVENT"
			},
			{
				"name": "belligerents",
				"salience": 0.014868931,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.014315731,
				"type": "OTHER"
			},
			{
				"name": "rockets",
				"salience": 0.014315731,
				"type": "OTHER"
			},
			{
				"name": "human shields",
				"salience": 0.014315731,
				"type": "OTHER"
			},
			{
				"name": "advance",
				"salience": 0.014199143,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.012776184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v0xhf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mevl%C3%BCt_%C3%87avu%C5%9Fo%C4%9Flu"
				},
				"name": "Mevlüt Çavuşoğlu",
				"salience": 0.012327033,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.012146017,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.010850383,
				"type": "ORGANIZATION"
			},
			{
				"name": "break",
				"salience": 0.010568323,
				"type": "EVENT"
			},
			{
				"name": "advance",
				"salience": 0.01048217,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.009672519,
				"type": "PERSON"
			},
			{
				"name": "minority group",
				"salience": 0.009079422,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0pyfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Coalition"
				},
				"name": "Coalition",
				"salience": 0.008822149,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.008640137,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.008458994,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.007638888,
				"type": "PERSON"
			},
			{
				"name": "gains",
				"salience": 0.0066159717,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0066159717,
				"type": "LOCATION"
			},
			{
				"name": "check",
				"salience": 0.0055408785,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0049437694,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0049437694,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f06xq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraqi_Turkmen"
				},
				"name": "Turkmen",
				"salience": 0.003514853,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T08:23:41.495+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This The International Organization for Migration estimates that almost 16,000 people have been displaced by fighting since the Mosul operation against the Islamic State militants began. But, there are also reports that tens of thousands more have been forcibly moved from their homes to be used as human shields. Colonel John Dorrian , a Coalition spokesman, said about 2,500 bombs, missiles, rockets and shells have been dropped during the Mosul campaign. Amnesty International has called on all belligerents to cease or resist using white phosphorous around civilians. Shi’ite militiamen say that they could begin their advance towards Tal Afar any day now. However, Turkish Foreign Minister Mevlüt Çavuşoğlu has threatened to retaliate against any attack on Tal Afar, which is home to many of the Turkmen minority group. Security forces have paused in their advance towards Mosul. The break may take a couple of days as troops reorganize themselves, consolidate their gains, and double check for militants in captured areas. At least 78 people were killed :",
		"thread_title": "78 Killed in Iraq Before Troops Pause Advance Towards Mosul",
		"title": "78 Killed in Iraq Before Troops Pause Advance Towards Mosul",
		"type": "bs",
		"uuid": "0f524d4650565e9501d11cd842939485f8dad036"
	},
	"-KhIj-exWRVYaWHjfkrT": {
		"author": "Robert Koehler",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T08:23:41.903+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.24275483,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.10640793,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.07633804,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cph1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_Hartung"
				},
				"name": "William Hartung",
				"salience": 0.061855428,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.023900585,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam War",
				"salience": 0.022553336,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.020338394,
				"type": "EVENT"
			},
			{
				"name": "game",
				"salience": 0.012302632,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.010430219,
				"type": "EVENT"
			},
			{
				"name": "intention",
				"salience": 0.010217114,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.00961688,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.009306919,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.007844656,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.0066410135,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.00657379,
				"type": "PERSON"
			},
			{
				"name": "Robert Koehler",
				"salience": 0.0063231634,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.0062879995,
				"type": "OTHER"
			},
			{
				"name": "harbinger",
				"salience": 0.0060992455,
				"type": "PERSON"
			},
			{
				"name": "staying power",
				"salience": 0.00589456,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.005501731,
				"type": "EVENT"
			},
			{
				"name": "transcendence",
				"salience": 0.005446302,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.005446302,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.0049182293,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.0049182293,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0049182293,
				"type": "OTHER"
			},
			{
				"name": "status quo",
				"salience": 0.0049182293,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.0045834333,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/034ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_H._W._Bush"
				},
				"name": "George H.W. Bush",
				"salience": 0.0044539385,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09bg4l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_S._Truman"
				},
				"name": "Truman",
				"salience": 0.0044009546,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0042986255,
				"type": "EVENT"
			},
			{
				"name": "craziness",
				"salience": 0.004259581,
				"type": "OTHER"
			},
			{
				"name": "volition",
				"salience": 0.004259581,
				"type": "OTHER"
			},
			{
				"name": "hemorrhaging",
				"salience": 0.004259581,
				"type": "OTHER"
			},
			{
				"name": "universe",
				"salience": 0.004259581,
				"type": "LOCATION"
			},
			{
				"name": "relaunch",
				"salience": 0.004259581,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.004259581,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.004259581,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0krz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dean_Acheson"
				},
				"name": "Dean Acheson",
				"salience": 0.0040578614,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.004031545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0036305056,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.003472489,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.003118442,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h3vy45",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Feffer"
				},
				"name": "John Feffer",
				"salience": 0.0030920308,
				"type": "PERSON"
			},
			{
				"name": "Hurricane Donald",
				"salience": 0.0030287332,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0030148884,
				"type": "EVENT"
			},
			{
				"name": "militarists",
				"salience": 0.002870242,
				"type": "PERSON"
			},
			{
				"name": "consensus",
				"salience": 0.0028693567,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0028693567,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0027365687,
				"type": "OTHER"
			},
			{
				"name": "military budget",
				"salience": 0.0027365687,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0026830584,
				"type": "OTHER"
			},
			{
				"name": "Big War",
				"salience": 0.0026469245,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0026228672,
				"type": "LOCATION"
			},
			{
				"name": "wars",
				"salience": 0.0025908921,
				"type": "EVENT"
			},
			{
				"name": "wars",
				"salience": 0.0024780806,
				"type": "EVENT"
			},
			{
				"name": "presidency",
				"salience": 0.0024727047,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024615426,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0024615426,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0024615426,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.002428561,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0022893804,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0022436478,
				"type": "PERSON"
			},
			{
				"name": "transition",
				"salience": 0.0022436478,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0022436478,
				"type": "ORGANIZATION"
			},
			{
				"name": "soldiers",
				"salience": 0.0021621045,
				"type": "PERSON"
			},
			{
				"name": "exceptionalism",
				"salience": 0.002025859,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.002025859,
				"type": "OTHER"
			},
			{
				"name": "military spending",
				"salience": 0.002025859,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0203v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colin_Powell"
				},
				"name": "Gen. Colin Powell",
				"salience": 0.0020123676,
				"type": "PERSON"
			},
			{
				"name": "military budget",
				"salience": 0.0019189738,
				"type": "OTHER"
			},
			{
				"name": "budget boys",
				"salience": 0.0019170927,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0018690957,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048n7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korean_War"
				},
				"name": "Korean War",
				"salience": 0.0018560927,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.0018473604,
				"type": "LOCATION"
			},
			{
				"name": "proxy wars",
				"salience": 0.0018167896,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "pillars",
				"salience": 0.0017542914,
				"type": "PERSON"
			},
			{
				"name": "array",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "corner",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0017542914,
				"type": "LOCATION"
			},
			{
				"name": "beneficiaries",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "domination",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "human shape",
				"salience": 0.0017542914,
				"type": "OTHER"
			},
			{
				"name": "war consensus",
				"salience": 0.0016427025,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0016393714,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0016358711,
				"type": "OTHER"
			},
			{
				"name": "military operations",
				"salience": 0.0015732308,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0015666469,
				"type": "PERSON"
			},
			{
				"name": "God Korea",
				"salience": 0.0014465249,
				"type": "PERSON"
			},
			{
				"name": "aide",
				"salience": 0.0014321837,
				"type": "PERSON"
			},
			{
				"name": "draft",
				"salience": 0.0014204826,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0014204826,
				"type": "LOCATION"
			},
			{
				"name": "draft",
				"salience": 0.0014204826,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0014204826,
				"type": "ORGANIZATION"
			},
			{
				"name": "strategy",
				"salience": 0.0014204826,
				"type": "OTHER"
			},
			{
				"name": "demons",
				"salience": 0.0013902455,
				"type": "OTHER"
			},
			{
				"name": "demons",
				"salience": 0.0013902455,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0013674623,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tax increases",
				"salience": 0.0013674623,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0013674623,
				"type": "WORK_OF_ART"
			},
			{
				"name": "increase",
				"salience": 0.0013674623,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0013394442,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.0013383531,
				"type": "OTHER"
			},
			{
				"name": "hurdle",
				"salience": 0.001294027,
				"type": "OTHER"
			},
			{
				"name": "Vietnam Syndrome",
				"salience": 0.0012905168,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0012843512,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.0012300273,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0012300273,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0012300273,
				"type": "OTHER"
			},
			{
				"name": "stake",
				"salience": 0.0012300273,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0012300273,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.0012300273,
				"type": "OTHER"
			},
			{
				"name": "wake",
				"salience": 0.0012300273,
				"type": "OTHER"
			},
			{
				"name": "arms race",
				"salience": 0.0012300273,
				"type": "EVENT"
			},
			{
				"name": "disgust",
				"salience": 0.0012300273,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0012271644,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0012271644,
				"type": "OTHER"
			},
			{
				"name": "arms production facilities",
				"salience": 0.0011841126,
				"type": "LOCATION"
			},
			{
				"name": "communism",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "motion",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "arms lobby",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "placement",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "departments",
				"salience": 0.0011841126,
				"type": "ORGANIZATION"
			},
			{
				"name": "military bases",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "nuisance",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "containment",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "recommendations",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "hydrogen bomb",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "districts",
				"salience": 0.0011841126,
				"type": "LOCATION"
			},
			{
				"name": "expansion",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.0011841126,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0011841126,
				"type": "PERSON"
			},
			{
				"name": "military budget",
				"salience": 0.0011703392,
				"type": "OTHER"
			},
			{
				"name": "military spending",
				"salience": 0.0011596383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0xs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._state"
				},
				"name": "State",
				"salience": 0.0011371144,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.0011174794,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0011080022,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0011080022,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0011080022,
				"type": "OTHER"
			},
			{
				"name": "VJ Days",
				"salience": 0.0010798121,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0010798121,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0zgfr43",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Engelhardt"
				},
				"name": "TomDispatch",
				"salience": 0.0010798121,
				"type": "ORGANIZATION"
			},
			{
				"name": "enemy",
				"salience": 0.0010746768,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0010385432,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0010385432,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0010041427,
				"type": "OTHER"
			},
			{
				"name": "health care",
				"salience": 0.0010041427,
				"type": "OTHER"
			},
			{
				"name": "infrastructure repair",
				"salience": 0.0010041427,
				"type": "OTHER"
			},
			{
				"name": "villains",
				"salience": 0.0010041427,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0010041427,
				"type": "OTHER"
			},
			{
				"name": "peace dividend",
				"salience": 0.0010041427,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0010005885,
				"type": "EVENT"
			},
			{
				"name": "approach",
				"salience": 0.0009914887,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00095942785,
				"type": "OTHER"
			},
			{
				"name": "transfers",
				"salience": 0.00095942785,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.000931483,
				"type": "OTHER"
			},
			{
				"name": "connectedness",
				"salience": 0.00091884227,
				"type": "OTHER"
			},
			{
				"name": "war consensus",
				"salience": 0.0008937438,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0008937438,
				"type": "OTHER"
			},
			{
				"name": "exceptions",
				"salience": 0.00086625497,
				"type": "OTHER"
			},
			{
				"name": "recklessness",
				"salience": 0.00086625497,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Defense",
				"salience": 0.00084166,
				"type": "OTHER"
			},
			{
				"name": "health problems",
				"salience": 0.000809396,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0008058738,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.00079919526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hitler",
				"salience": 0.0007570545,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/079dy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saddam_Hussein"
				},
				"name": "Saddam Hussein",
				"salience": 0.0007570545,
				"type": "PERSON"
			},
			{
				"name": "integrity",
				"salience": 0.0007563559,
				"type": "OTHER"
			},
			{
				"name": "interim",
				"salience": 0.0007563559,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0007500876,
				"type": "OTHER"
			},
			{
				"name": "critics",
				"salience": 0.0007500876,
				"type": "PERSON"
			},
			{
				"name": "instance",
				"salience": 0.0007500876,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.0007500876,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0007500876,
				"type": "ORGANIZATION"
			},
			{
				"name": "O",
				"salience": 0.0007500876,
				"type": "OTHER"
			},
			{
				"name": "paradox",
				"salience": 0.0007500876,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.0007500876,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0381pn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/History_(TV_channel)"
				},
				"name": "history.com",
				"salience": 0.00072878995,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congressional",
				"salience": 0.00072878995,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02f2bl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NSC-68"
				},
				"name": "NSC-68",
				"salience": 0.00072878995,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00072878995,
				"type": "ORGANIZATION"
			},
			{
				"name": "website",
				"salience": 0.00072208315,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fj6s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Victory_in_Europe_Day"
				},
				"name": "VE",
				"salience": 0.0007196049,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqis",
				"salience": 0.00071372406,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00071372406,
				"type": "LOCATION"
			},
			{
				"name": "presidency",
				"salience": 0.00071368244,
				"type": "OTHER"
			},
			{
				"name": "mainstream",
				"salience": 0.00070399663,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00070399663,
				"type": "WORK_OF_ART"
			},
			{
				"name": "electorate",
				"salience": 0.00069873146,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.00069873146,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.0006366921,
				"type": "PERSON"
			},
			{
				"name": "military budget",
				"salience": 0.0006366921,
				"type": "OTHER"
			},
			{
				"name": "recklessness",
				"salience": 0.00063086936,
				"type": "OTHER"
			},
			{
				"name": "compassion",
				"salience": 0.00063086936,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018w0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gulf_War"
				},
				"name": "Operation Desert Storm",
				"salience": 0.0006180066,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01brfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joint_Chiefs_of_Staff"
				},
				"name": "Joint Chiefs of Staff",
				"salience": 0.0006180066,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09k0f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fidel_Castro"
				},
				"name": "Castro",
				"salience": 0.0006180066,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04bbj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kim_Il-sung"
				},
				"name": "Kim Il-sung",
				"salience": 0.0006180066,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.0006180066,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gqgt3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/War_on_Terror"
				},
				"name": "Global War on Terror",
				"salience": 0.00061581883,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.0006046015,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0006027726,
				"type": "EVENT"
			},
			{
				"name": "wars",
				"salience": 0.0006027726,
				"type": "OTHER"
			},
			{
				"name": "Special Operations forces",
				"salience": 0.0006027726,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03gt8x4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_Policy_in_Focus"
				},
				"name": "Foreign Policy in Focus",
				"salience": 0.0005904826,
				"type": "ORGANIZATION"
			},
			{
				"name": "thinking",
				"salience": 0.00056497875,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0005462612,
				"type": "OTHER"
			},
			{
				"name": "writer",
				"salience": 0.0005462612,
				"type": "PERSON"
			},
			{
				"name": "Wound",
				"salience": 0.0005462612,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0005462612,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.0005462612,
				"type": "OTHER"
			},
			{
				"name": "well",
				"salience": 0.0005462612,
				"type": "LOCATION"
			},
			{
				"name": "chunk",
				"salience": 0.0005462612,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0005462612,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00053534185,
				"type": "ORGANIZATION"
			},
			{
				"name": "PeaceVoice",
				"salience": 0.00052457454,
				"type": "ORGANIZATION"
			},
			{
				"name": "name",
				"salience": 0.00052193186,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.0004712377,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0004616291,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0004616291,
				"type": "PERSON"
			},
			{
				"name": "change",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "neocon think tanks",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "stone",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "gears",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "boots",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00040803492,
				"type": "LOCATION"
			},
			{
				"name": "use",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.00040803492,
				"type": "OTHER"
			},
			{
				"name": "drone strikes",
				"salience": 0.00040803492,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/097gl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pearl_Harbor"
				},
				"name": "Pearl Harbor",
				"salience": 0.0003690428,
				"type": "EVENT"
			},
			{
				"name": "prison-industrial complex",
				"salience": 0.00036103718,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00035489348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.0003361772,
				"type": "LOCATION"
			},
			{
				"name": "commonwonders.com",
				"salience": 0.0003361772,
				"type": "OTHER"
			},
			{
				"name": "Courage Grows Strong",
				"salience": 0.0003361772,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00029340043,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.0002900034,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01c4wz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Project_for_the_New_American_Century"
				},
				"name": "Project for a New American Century",
				"salience": 0.00025110552,
				"type": "ORGANIZATION"
			},
			{
				"name": "W",
				"salience": 0.00025110552,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04fh3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kosovo"
				},
				"name": "Kosovo",
				"salience": 0.00025110552,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T14:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 20.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nToday we call it the status quo, or endless war, or we just don’t bother to notice it. Indeed, now more than ever we don’t notice it. It’s barely part of the 2016 election, even though we’re engaged in active conflict in half a dozen countries, toying with a relaunch of the Cold War with Russia and, of course, hemorrhaging, as always, more than half our annual discretionary budget on “defense.” \nWorld War II has been going on for seven decades now and has no intention of ever stopping . . . of its own volition. But this year’s rocking electoral craziness – not just Hurricane Donald, but the unexpected staying power of the Bernie Sanders campaign – may well be the harbinger of transcendence. Apparently there’s another force in the universe capable of standing up to the American, indeed, the global, military-industrial status quo. \nSlowly, slowly this force is organizing itself and taking human shape. This isn’t a simple process. After all, the game of empire – the game called war, the game of domination – has been coalescing political power for several thousand years now. \nBut our current military budget was birthed by the wars of the 20th century. William Hartung , writing recently at TomDispatch, shows the fascinating connectedness of the wars that followed VE and VJ Days, as the corporate beneficiaries of the Big War aligned with mainstream politicians of both major parties and coalesced into the Washington consensus. Over the decades they have engaged in an ongoing struggle to maintain military spending at breathtakingly high levels and avoid any sort of transition to something called peace. \nThe two pillars of this consensus, as Hartung points out, are the ideology of “armed exceptionalism,” that a shifting array of enemies are out there itching to destroy us, but we will persist in our mission to maintain order in every corner of the planet; and the “strategic placement of arms production facilities and military bases in key states and Congressional districts,” ensuring entrenched political power for the arms lobby. \nSo World War II initially, as we know, morphed into the Cold War, America’s crusade against communism, which was set into motion in 1950 by a long-classified report (NSC-68) prepared by the State and Defense departments and the CIA, urging the vigorous containment of Soviet expansion and the development of the hydrogen bomb. \nPresident Truman “was somewhat taken aback at the costs associated with the report’s recommendations,” according to history.com , and “he hesitated to publicly support a program that would result in heavy tax increases for the American public, particularly since the increase would be spent on defending the United States during a time of peace.” \nPeace! What a nuisance! But: “Thank God Korea came along,” as an aide to Secretary of State Dean Acheson put it at the time. The Korean War gave the militarists the enemy they needed and the nuclear arms race, and so much else, was born. The military budget was set for decades. \nAs Hartung points out, the next terrible hurdle the budget boys faced was in the wake of the Vietnam War, which ended in 1975. That war, and the universal draft that essentially pulled the whole country into a front-row seat for it, spawned a passionate antiwar movement and, ultimately, a moldering national disgust for war, known as Vietnam Syndrome. The Cold War continued, but the U.S. military was confined to proxy wars for a while and had to rethink its strategy. \nTwo things happened. The universal draft was ended, removing most of the American middle class from a life-and-death stake in our military operations; and Saddam Hussein, our ally, was recast as Adolf Hitler. And in 1991, President George H.W. Bush embarked on a month of war with Iraq known as Operation Desert Storm. Not only did the US“win” this war and kill over 100,000 Iraqis (and ultimately cause hideous health problems for American soldiers), but, perhaps most importantly: “By God, we’ve kicked the Vietnam Syndrome once and for all.” So the president proclaimed. \nUnfortunately for the war consensus, the Soviet Union dissolved a short time later and the Cold War ended . . . and a “peace dividend” loomed. Hartung notes that Gen. Colin Powell, then chairman of the Joint Chiefs of Staff, expressed the situation thus: “I’m running out of demons. I’m running out of villains. I’m down to Castro and Kim Il-sung.” \nWould military spending be diverted to infrastructure repair, free education, universal health care? \nWell, no. The Bill Clinton presidency found a few new demons. It fought a war in Kosovo and, on the domestic front, vastly expanded the prison-industrial complex. Meanwhile, the neocon think tanks cogitated and one of them, the Project for a New American Century, reflecting the fact that geopolitical thinking had stopped with World War II, decided that what America needed was a new Pearl Harbor . And then came the presidency of George W. Bush, 9/11, and the Global War on Terror. And the US military budget was carved, seemingly, in stone. \nBarack Obama was elected president in 2008 on the promise of serious change, but any hope that he intended to upend W’s wars was soon dispelled. He dumped the name but kept the wars, essentially settling “for a no-name global war,” Hartung writes. “He would shift gears from a strategy focused on large numbers of ‘boots on the ground’ to an emphasis on drone strikes, the use of Special Operations forces, and massive transfers of arms to US allies like Saudi Arabia. . . . (O)ne might call Obama’s approach ‘politically sustainable warfare.’” \nAnd here we are, immersed in a no-name global war that has no logical end and few serious critics in the world of mainstream media and politics. But maybe the American democracy is not the closed system it’s supposed to be. \nFor instance, John Feffer , director of Foreign Policy in Focus, points out that Donald Trump, in all his fun-house recklessness, is shaking up the consensus: “Democrats and Republicans disagree about many things. But with a few exceptions they all support an enormous military budget, an expensive overseas expeditionary force, and unilateral acts of force when necessary to protect US national interests (understood broadly). \n“It’s an odd paradox that Trump, who blathers on about making America great again, departs from this consensus.” \nHe won’t win, and he shouldn’t win for a million reasons, but in his recklessness he has touched the raw anger of a sizable chunk of the American electorate. Sanders, speaking with compassion and integrity and delivering a far different message, managed to tap the same well of public outrage. And, as Feffer noted, “the mainstream is worried that the political parties will realize that the ‘bring the war dollars home’ message can win a national election and disrupt the comfortable revolving-door consensus.” \nAnd World War II will finally end? Not this year, but maybe four years from now, if we refuse to let the war consensus have any peace in the interim. \nRobert Koehler is an award-winning, Chicago-based journalist and nationally syndicated writer. His new book, Courage Grows Strong at the Wound is now available. Contact him at or visit his website at commonwonders.com . Reprinted with permission from PeaceVoice . Read more by Robert Koehler",
		"thread_title": "Budgeting the Good War, for 75 Years",
		"title": "Budgeting the Good War, for 75 Years",
		"type": "bs",
		"uuid": "92a8d047932c5978a6f15af2ea1fa9a0a27cb9ec"
	},
	"-KhIj1EebJp423k7P_Yh": {
		"author": "Justin Raimondo",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T08:23:42.137+03:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.67162013,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.15916689,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.023614667,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016lh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ron_Paul"
				},
				"name": "Ron Paul",
				"salience": 0.005428124,
				"type": "PERSON"
			},
			{
				"name": "newspaper",
				"salience": 0.0036285762,
				"type": "ORGANIZATION"
			},
			{
				"name": "revelation",
				"salience": 0.0024788808,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0024259137,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.002128037,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0019386909,
				"type": "PERSON"
			},
			{
				"name": "pacifists",
				"salience": 0.0017124056,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0014307773,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02kjdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Judith_Miller"
				},
				"name": "Judith Miller",
				"salience": 0.0013797763,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0013233513,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, D.C.",
				"salience": 0.0012913258,
				"type": "LOCATION"
			},
			{
				"name": "wars",
				"salience": 0.0012478707,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0012023875,
				"type": "LOCATION"
			},
			{
				"name": "concerns",
				"salience": 0.0011444736,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.001108366,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0010717338,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0010513852,
				"type": "ORGANIZATION"
			},
			{
				"name": "member states",
				"salience": 0.0010427126,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.0009932856,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0009713672,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.0009264228,
				"type": "OTHER"
			},
			{
				"name": "pronouncement",
				"salience": 0.00089099316,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.00087782973,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0008549669,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0008326269,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00079805404,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0007730354,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0007730354,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0007516229,
				"type": "OTHER"
			},
			{
				"name": "interventionism",
				"salience": 0.00074773864,
				"type": "OTHER"
			},
			{
				"name": "opponents",
				"salience": 0.00074773864,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0007413125,
				"type": "OTHER"
			},
			{
				"name": "felony",
				"salience": 0.0007053391,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.000686416,
				"type": "PERSON"
			},
			{
				"name": "ideology",
				"salience": 0.00068585714,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0006819558,
				"type": "OTHER"
			},
			{
				"name": "millennials",
				"salience": 0.0006774989,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0006741773,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.0006473365,
				"type": "OTHER"
			},
			{
				"name": "National Security State",
				"salience": 0.000646181,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.00062688487,
				"type": "PERSON"
			},
			{
				"name": "optimism",
				"salience": 0.0006237563,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.00062077545,
				"type": "PERSON"
			},
			{
				"name": "billions",
				"salience": 0.00062015065,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hcqj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/America_First_Committee"
				},
				"name": "America First.",
				"salience": 0.00061307655,
				"type": "ORGANIZATION"
			},
			{
				"name": "class",
				"salience": 0.0006063027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.000566123,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0005640602,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00055041414,
				"type": "EVENT"
			},
			{
				"name": "cold war",
				"salience": 0.00055041414,
				"type": "EVENT"
			},
			{
				"name": "point of view",
				"salience": 0.0005491249,
				"type": "OTHER"
			},
			{
				"name": "pessimism",
				"salience": 0.00054014556,
				"type": "OTHER"
			},
			{
				"name": "respects",
				"salience": 0.00054014556,
				"type": "OTHER"
			},
			{
				"name": "Justin Raimondo Assange",
				"salience": 0.0005088527,
				"type": "PERSON"
			},
			{
				"name": "Country",
				"salience": 0.00050257205,
				"type": "LOCATION"
			},
			{
				"name": "War Party",
				"salience": 0.0004940435,
				"type": "ORGANIZATION"
			},
			{
				"name": "pacifist",
				"salience": 0.00049313693,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00048844604,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00048844604,
				"type": "OTHER"
			},
			{
				"name": "policing",
				"salience": 0.00048844604,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00048342152,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00045668418,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.00045124552,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0004363523,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00043035275,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00043035275,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0004186598,
				"type": "PERSON"
			},
			{
				"name": "anti-Trump",
				"salience": 0.00041424087,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0004105581,
				"type": "ORGANIZATION"
			},
			{
				"name": "defense",
				"salience": 0.0004074332,
				"type": "OTHER"
			},
			{
				"name": "psychology",
				"salience": 0.00039532132,
				"type": "OTHER"
			},
			{
				"name": "Darkness Falls",
				"salience": 0.00038396235,
				"type": "WORK_OF_ART"
			},
			{
				"name": "intervention",
				"salience": 0.00038189473,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00038189473,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.00038189473,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.00038189473,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00038189473,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.00038189473,
				"type": "PERSON"
			},
			{
				"name": "supply",
				"salience": 0.00038189473,
				"type": "OTHER"
			},
			{
				"name": "neoconservatives",
				"salience": 0.00038189473,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00037977166,
				"type": "ORGANIZATION"
			},
			{
				"name": "lesson",
				"salience": 0.0003779657,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00037658427,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0003754454,
				"type": "EVENT"
			},
			{
				"name": "editors",
				"salience": 0.00036790554,
				"type": "PERSON"
			},
			{
				"name": "military action",
				"salience": 0.00036622942,
				"type": "OTHER"
			},
			{
				"name": "Curioso",
				"salience": 0.0003661502,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00036566053,
				"type": "LOCATION"
			},
			{
				"name": "reluctance",
				"salience": 0.0003554633,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00035356346,
				"type": "OTHER"
			},
			{
				"name": "zones",
				"salience": 0.00035280536,
				"type": "LOCATION"
			},
			{
				"name": "column",
				"salience": 0.00035280536,
				"type": "WORK_OF_ART"
			},
			{
				"name": "complex",
				"salience": 0.00035280536,
				"type": "LOCATION"
			},
			{
				"name": "primary",
				"salience": 0.00035280536,
				"type": "EVENT"
			},
			{
				"name": "legitimacy",
				"salience": 0.00035280536,
				"type": "OTHER"
			},
			{
				"name": "prospect",
				"salience": 0.00034656152,
				"type": "OTHER"
			},
			{
				"name": "sea change",
				"salience": 0.0003457549,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00033642835,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.00033069242,
				"type": "OTHER"
			},
			{
				"name": "emergency rations",
				"salience": 0.00031854663,
				"type": "OTHER"
			},
			{
				"name": "concept",
				"salience": 0.00031854663,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00031854663,
				"type": "ORGANIZATION"
			},
			{
				"name": "spite",
				"salience": 0.00031854663,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fhypr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_R._Gordon"
				},
				"name": "Michael R. Gordon",
				"salience": 0.0003180366,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0003176916,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0003176916,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01j6t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barry_Goldwater"
				},
				"name": "Barry Goldwater",
				"salience": 0.00031672025,
				"type": "PERSON"
			},
			{
				"name": "propaganda",
				"salience": 0.0003127136,
				"type": "WORK_OF_ART"
			},
			{
				"name": "matter",
				"salience": 0.00031056895,
				"type": "OTHER"
			},
			{
				"name": "measuring",
				"salience": 0.0003091817,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00030583216,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00030583216,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.00030365374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00030362347,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.00030143844,
				"type": "OTHER"
			},
			{
				"name": "Trumpism",
				"salience": 0.00029585697,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00029281733,
				"type": "PERSON"
			},
			{
				"name": "undercurrent",
				"salience": 0.00028234645,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0108kc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Financial_Times"
				},
				"name": "Financial Times",
				"salience": 0.00027774583,
				"type": "ORGANIZATION"
			},
			{
				"name": "purse",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "coffers",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "expense",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "swath",
				"salience": 0.0002758321,
				"type": "LOCATION"
			},
			{
				"name": "sovereignty",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "bear",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "foreign policy orthodoxy",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "sentiment",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "project",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "utility",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "share",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "inconsistencies",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "square",
				"salience": 0.0002758321,
				"type": "LOCATION"
			},
			{
				"name": "implications",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "grip",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0002758321,
				"type": "PERSON"
			},
			{
				"name": "encirclement",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.0002758321,
				"type": "PERSON"
			},
			{
				"name": "sort",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "backyard bomb shelters",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.0002758321,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0002743577,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0002743577,
				"type": "OTHER"
			},
			{
				"name": "``mainstream'' media",
				"salience": 0.0002743577,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0002743577,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00026838062,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0002671367,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.00026601023,
				"type": "EVENT"
			},
			{
				"name": "The Life of Murray N. Rothbard",
				"salience": 0.00026494922,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0002590953,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06qd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Korea"
				},
				"name": "South Korea",
				"salience": 0.00025799577,
				"type": "LOCATION"
			},
			{
				"name": "powers",
				"salience": 0.00025745967,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.00024916374,
				"type": "OTHER"
			},
			{
				"name": "campaign theme",
				"salience": 0.00024448446,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00023991516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00023062002,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0002289279,
				"type": "OTHER"
			},
			{
				"name": "ire",
				"salience": 0.00022517344,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00022274119,
				"type": "OTHER"
			},
			{
				"name": "conservatives",
				"salience": 0.00021924323,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.00021745995,
				"type": "ORGANIZATION"
			},
			{
				"name": "Eastasia",
				"salience": 0.00021714384,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0002164801,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0002142093,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00021133726,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00020796814,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00020796814,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00020796814,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.00020194886,
				"type": "PERSON"
			},
			{
				"name": "partisanship",
				"salience": 0.00020104666,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00020104666,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00020104666,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00020104666,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00019958145,
				"type": "OTHER"
			},
			{
				"name": "Thing",
				"salience": 0.0001978893,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.00019366299,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0001892741,
				"type": "ORGANIZATION"
			},
			{
				"name": "reality",
				"salience": 0.00018712878,
				"type": "OTHER"
			},
			{
				"name": "state elections",
				"salience": 0.000186496,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.000186496,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.000186496,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.000186496,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.000186496,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.000186496,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00018344572,
				"type": "LOCATION"
			},
			{
				"name": "votes",
				"salience": 0.00018201678,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00017953293,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00017953293,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00017953293,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00017953293,
				"type": "EVENT"
			},
			{
				"name": "Power",
				"salience": 0.00017712696,
				"type": "OTHER"
			},
			{
				"name": "talking points",
				"salience": 0.00017712696,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00017600725,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/033j4x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Media_conglomerate"
				},
				"name": "Big Media",
				"salience": 0.00017474548,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/028rk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dwight_D._Eisenhower"
				},
				"name": "Dwight Eisenhower",
				"salience": 0.00017412327,
				"type": "PERSON"
			},
			{
				"name": "lines",
				"salience": 0.0001714031,
				"type": "OTHER"
			},
			{
				"name": "clouds",
				"salience": 0.00017034636,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0001697617,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.0001697617,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0001697617,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0001697617,
				"type": "LOCATION"
			},
			{
				"name": "weapons of mass destruction",
				"salience": 0.00016924275,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00016769054,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.00016655268,
				"type": "OTHER"
			},
			{
				"name": "electoral votes",
				"salience": 0.00016655268,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00016643744,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00016587906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.00016562875,
				"type": "ORGANIZATION"
			},
			{
				"name": "legacy",
				"salience": 0.00016398611,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00016277854,
				"type": "PERSON"
			},
			{
				"name": "last",
				"salience": 0.00016264591,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.00016203632,
				"type": "PERSON"
			},
			{
				"name": "anti-American",
				"salience": 0.00016110396,
				"type": "OTHER"
			},
			{
				"name": "Skywalker Trump",
				"salience": 0.00016094917,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00016033405,
				"type": "PERSON"
			},
			{
				"name": "voter",
				"salience": 0.00016033405,
				"type": "PERSON"
			},
			{
				"name": "Clintons",
				"salience": 0.00015977593,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.00015883842,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.00015717627,
				"type": "EVENT"
			},
			{
				"name": "revelations",
				"salience": 0.00015717627,
				"type": "OTHER"
			},
			{
				"name": "military intervention",
				"salience": 0.00015717627,
				"type": "EVENT"
			},
			{
				"name": "contributions",
				"salience": 0.00015717627,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00015670079,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.00015471232,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.00015471232,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.00015471232,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0001522412,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.0001503761,
				"type": "OTHER"
			},
			{
				"name": "pollsters",
				"salience": 0.0001503761,
				"type": "OTHER"
			},
			{
				"name": "preference polls",
				"salience": 0.0001503761,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0001503761,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00014893127,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00014705762,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00014629481,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.00014610136,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00014595421,
				"type": "PERSON"
			},
			{
				"name": "worst",
				"salience": 0.0001452006,
				"type": "PERSON"
			},
			{
				"name": "hatred",
				"salience": 0.0001452006,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0001452006,
				"type": "OTHER"
			},
			{
				"name": "war propaganda",
				"salience": 0.0001452006,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0001452006,
				"type": "OTHER"
			},
			{
				"name": "pollsters",
				"salience": 0.00014476135,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00014471442,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00014415907,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.00014263016,
				"type": "PERSON"
			},
			{
				"name": "candidacy",
				"salience": 0.00014200942,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.00014156336,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.00014094725,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.00014094725,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0001408324,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00014050453,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00014035616,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.00013670699,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.0001357704,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.00013568449,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.00013480539,
				"type": "PERSON"
			},
			{
				"name": "blandishments",
				"salience": 0.00013386509,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.00013368808,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00013287927,
				"type": "PERSON"
			},
			{
				"name": "vanguard",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "jihad",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "watchdog",
				"salience": 0.00013109749,
				"type": "ORGANIZATION"
			},
			{
				"name": "front page",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "silver lining",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "squeals",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "MARGIN",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00013109749,
				"type": "ORGANIZATION"
			},
			{
				"name": "trend",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "pretense",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "pretense",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "objectivity",
				"salience": 0.00013109749,
				"type": "OTHER"
			},
			{
				"name": "phone",
				"salience": 0.00013063989,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00013035432,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00013020789,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00013020789,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00012971819,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00012966275,
				"type": "EVENT"
			},
			{
				"name": "territories",
				"salience": 0.00012944506,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.00012669462,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.00012590861,
				"type": "OTHER"
			},
			{
				"name": "libertarian thinker",
				"salience": 0.00012534605,
				"type": "OTHER"
			},
			{
				"name": "paroxysms",
				"salience": 0.00012482454,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.00012423472,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.00012417673,
				"type": "OTHER"
			},
			{
				"name": "phone",
				"salience": 0.00012417673,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.00012157506,
				"type": "WORK_OF_ART"
			},
			{
				"name": "phone",
				"salience": 0.00011954005,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "point",
				"salience": 0.00011954005,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00011954005,
				"type": "OTHER"
			},
			{
				"name": "phones",
				"salience": 0.00011954005,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "phones",
				"salience": 0.00011954005,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Flyover America",
				"salience": 0.00011918536,
				"type": "LOCATION"
			},
			{
				"name": "wars",
				"salience": 0.000118765536,
				"type": "OTHER"
			},
			{
				"name": "Strider73",
				"salience": 0.00011868302,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00011837738,
				"type": "LOCATION"
			},
			{
				"name": "stigma",
				"salience": 0.00011791751,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.000117560776,
				"type": "PERSON"
			},
			{
				"name": "defeat",
				"salience": 0.000117560776,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.00011728707,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00011728707,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00011728707,
				"type": "OTHER"
			},
			{
				"name": "marxists",
				"salience": 0.00011567681,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.000115057344,
				"type": "OTHER"
			},
			{
				"name": "slumber party",
				"salience": 0.000115057344,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.000115057344,
				"type": "LOCATION"
			},
			{
				"name": "right",
				"salience": 0.00011402397,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00011371781,
				"type": "EVENT"
			},
			{
				"name": "target",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "horizon",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "NOTES",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "jeers",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0001135145,
				"type": "PERSON"
			},
			{
				"name": "perspective",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.0001135145,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "disdain",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "tongs",
				"salience": 0.0001135145,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hammer",
				"salience": 0.0001135145,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "conduit",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "ears",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "challenge",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "foreign policy mandarins",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "Establishment",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "music",
				"salience": 0.0001135145,
				"type": "WORK_OF_ART"
			},
			{
				"name": "publication",
				"salience": 0.0001135145,
				"type": "WORK_OF_ART"
			},
			{
				"name": "isolationism",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "skepticism",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "outrage",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.0001135145,
				"type": "PERSON"
			},
			{
				"name": "power structure",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "chorus",
				"salience": 0.0001135145,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.000113250215,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.00011317109,
				"type": "EVENT"
			},
			{
				"name": "Eileen Kuch",
				"salience": 0.00011110249,
				"type": "PERSON"
			},
			{
				"name": "beast",
				"salience": 0.000110750894,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0001101892,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0001101892,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0001101892,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0001101892,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.0001101892,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0001101892,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0001101892,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00011007917,
				"type": "OTHER"
			},
			{
				"name": "hegemony",
				"salience": 0.000107898464,
				"type": "OTHER"
			},
			{
				"name": "terminology",
				"salience": 0.00010629037,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00010607472,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00010607472,
				"type": "OTHER"
			},
			{
				"name": "Old Republic",
				"salience": 0.00010537855,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.00010451392,
				"type": "OTHER"
			},
			{
				"name": "guess",
				"salience": 0.00010256025,
				"type": "OTHER"
			},
			{
				"name": "pacifist",
				"salience": 0.000102249964,
				"type": "PERSON"
			},
			{
				"name": "pacifist",
				"salience": 0.000102249964,
				"type": "PERSON"
			},
			{
				"name": "anti-interventionist",
				"salience": 0.000102249964,
				"type": "PERSON"
			},
			{
				"name": "matters",
				"salience": 0.0001017931,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0001017931,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.000101366895,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.000101366895,
				"type": "OTHER"
			},
			{
				"name": "prank phone",
				"salience": 0.000101366895,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "violence",
				"salience": 0.00010082671,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "u.s.",
				"salience": 0.00010010383,
				"type": "LOCATION"
			},
			{
				"name": "bomb",
				"salience": 0.000099788995,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0000992546,
				"type": "PERSON"
			},
			{
				"name": "bipeds",
				"salience": 0.0000987306,
				"type": "OTHER"
			},
			{
				"name": "Claus-Erik Hamle Trump",
				"salience": 0.00009813905,
				"type": "PERSON"
			},
			{
				"name": "lie",
				"salience": 0.000098090895,
				"type": "OTHER"
			},
			{
				"name": "touch screen",
				"salience": 0.000097992095,
				"type": "OTHER"
			},
			{
				"name": "reportage",
				"salience": 0.000097992095,
				"type": "OTHER"
			},
			{
				"name": "complaint",
				"salience": 0.000097992095,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.000097992095,
				"type": "OTHER"
			},
			{
				"name": "computers",
				"salience": 0.000097992095,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "touch screens",
				"salience": 0.000097992095,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.000097992095,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07pzy0z"
				},
				"name": "Neocons",
				"salience": 0.00009693718,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0000968519,
				"type": "EVENT"
			},
			{
				"name": "problem",
				"salience": 0.00009668929,
				"type": "OTHER"
			},
			{
				"name": "self defense",
				"salience": 0.00009596606,
				"type": "OTHER"
			},
			{
				"name": "pacifism",
				"salience": 0.00009596606,
				"type": "OTHER"
			},
			{
				"name": "self defense",
				"salience": 0.00009596606,
				"type": "OTHER"
			},
			{
				"name": "correspondents",
				"salience": 0.00009521735,
				"type": "PERSON"
			},
			{
				"name": "no-fly zone",
				"salience": 0.00009491825,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.000092891176,
				"type": "PERSON"
			},
			{
				"name": "squeaker",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.00009190557,
				"type": "LOCATION"
			},
			{
				"name": "immigration",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "dump",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "dump",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "parameters",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "trade",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "underpinnings",
				"salience": 0.00009190557,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0000901591,
				"type": "PERSON"
			},
			{
				"name": "correction",
				"salience": 0.0000899484,
				"type": "OTHER"
			},
			{
				"name": "interpretations",
				"salience": 0.0000899484,
				"type": "OTHER"
			},
			{
				"name": "lifetime",
				"salience": 0.0000899484,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.0000899484,
				"type": "PERSON"
			},
			{
				"name": "correction",
				"salience": 0.0000899484,
				"type": "OTHER"
			},
			{
				"name": "revelations",
				"salience": 0.0000899484,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0000899484,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.00008939457,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.00008935805,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00008890115,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.000088473724,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "error",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "user error",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.000088473724,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "trade",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.000088473724,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.000088473724,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.00008816489,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b6gkfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream_media"
				},
				"name": "MSM",
				"salience": 0.00008752304,
				"type": "ORGANIZATION"
			},
			{
				"name": "article",
				"salience": 0.000087419576,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hit",
				"salience": 0.000087419576,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00008594193,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00008594193,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00008594193,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.00008541277,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00008541277,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00008309442,
				"type": "WORK_OF_ART"
			},
			{
				"name": "legitimacy",
				"salience": 0.00008309442,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00008309442,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.00008309442,
				"type": "EVENT"
			},
			{
				"name": "primaries",
				"salience": 0.00008309442,
				"type": "EVENT"
			},
			{
				"name": "legislation",
				"salience": 0.00008309442,
				"type": "OTHER"
			},
			{
				"name": "high school newspaper",
				"salience": 0.00008309442,
				"type": "ORGANIZATION"
			},
			{
				"name": "column",
				"salience": 0.00008309442,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article",
				"salience": 0.00008309442,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.0000828134,
				"type": "EVENT"
			},
			{
				"name": "master class",
				"salience": 0.00008278514,
				"type": "OTHER"
			},
			{
				"name": "vote switch",
				"salience": 0.000082665334,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00008249866,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Assange",
				"salience": 0.00008182434,
				"type": "PERSON"
			},
			{
				"name": "photo",
				"salience": 0.00008162331,
				"type": "WORK_OF_ART"
			},
			{
				"name": "choice",
				"salience": 0.000079935664,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.000079578494,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.000079578494,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.000079578494,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.000079578494,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.000079578494,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.000079578494,
				"type": "LOCATION"
			},
			{
				"name": "gains",
				"salience": 0.000079578494,
				"type": "OTHER"
			},
			{
				"name": "nomination race",
				"salience": 0.000079578494,
				"type": "EVENT"
			},
			{
				"name": "principles",
				"salience": 0.000079578494,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.000079578494,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.000079393205,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.000078983234,
				"type": "OTHER"
			},
			{
				"name": "Populist",
				"salience": 0.000078928046,
				"type": "PERSON"
			},
			{
				"name": "editors",
				"salience": 0.000078718745,
				"type": "PERSON"
			},
			{
				"name": "chances",
				"salience": 0.00007740425,
				"type": "OTHER"
			},
			{
				"name": "popularity",
				"salience": 0.000076950746,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "jest",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "behalf",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.000076606906,
				"type": "ORGANIZATION"
			},
			{
				"name": "districts",
				"salience": 0.000076606906,
				"type": "LOCATION"
			},
			{
				"name": "eyes",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "feed",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "ads",
				"salience": 0.000076606906,
				"type": "WORK_OF_ART"
			},
			{
				"name": "touch screen calibration explanation",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "tweets",
				"salience": 0.000076606906,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.000076606906,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nowhere",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "tactic",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "ubiquity",
				"salience": 0.000076606906,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.00007611053,
				"type": "OTHER"
			},
			{
				"name": "knees",
				"salience": 0.00007611053,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.00007611053,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.000075715514,
				"type": "ORGANIZATION"
			},
			{
				"name": "millions",
				"salience": 0.00007546512,
				"type": "PERSON"
			},
			{
				"name": "minds",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"name": "vanguard",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"name": "jihad",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"name": "front page",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"name": "comrade hermit",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.000075022974,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00007448508,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.00007448508,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.00007448508,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00007448508,
				"type": "ORGANIZATION"
			},
			{
				"name": "look",
				"salience": 0.000073268435,
				"type": "OTHER"
			},
			{
				"name": "watchdogs",
				"salience": 0.00007314349,
				"type": "OTHER"
			},
			{
				"name": "character flaws",
				"salience": 0.00007281666,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.000072720366,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.00007228038,
				"type": "OTHER"
			},
			{
				"name": "gang",
				"salience": 0.00007227198,
				"type": "PERSON"
			},
			{
				"name": "anti-interventionists",
				"salience": 0.00007168125,
				"type": "PERSON"
			},
			{
				"name": "craziest",
				"salience": 0.00007168125,
				"type": "OTHER"
			},
			{
				"name": "presstitute",
				"salience": 0.00007168125,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.000070530594,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/079dy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saddam_Hussein"
				},
				"name": "Saddam Hussein",
				"salience": 0.00006985693,
				"type": "PERSON"
			},
			{
				"name": "Trump Effect",
				"salience": 0.00006985693,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.00006921393,
				"type": "ORGANIZATION"
			},
			{
				"name": "pile",
				"salience": 0.000068341455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vlhp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Enemy_of_the_state"
				},
				"name": "Enemy of the State",
				"salience": 0.000067550165,
				"type": "WORK_OF_ART"
			},
			{
				"name": "revelation",
				"salience": 0.00006718625,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00006718625,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.00006718625,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.00006718625,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.00006718625,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00006718625,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition",
				"salience": 0.00006718625,
				"type": "OTHER"
			},
			{
				"name": "government control",
				"salience": 0.00006718625,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.00006677256,
				"type": "OTHER"
			},
			{
				"name": "foothold",
				"salience": 0.00006662934,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "assertions",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "hearsay",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "trick",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "betrayal",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00006496012,
				"type": "EVENT"
			},
			{
				"name": "elite",
				"salience": 0.00006496012,
				"type": "PERSON"
			},
			{
				"name": "favor",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "drone strike",
				"salience": 0.00006496012,
				"type": "EVENT"
			},
			{
				"name": "difference",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "election cycle",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "king",
				"salience": 0.00006496012,
				"type": "PERSON"
			},
			{
				"name": "slur",
				"salience": 0.00006496012,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.00006496012,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.00006474042,
				"type": "EVENT"
			},
			{
				"name": "Joe Flack",
				"salience": 0.000064207976,
				"type": "PERSON"
			},
			{
				"name": "mass media",
				"salience": 0.0000637983,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0000637983,
				"type": "OTHER"
			},
			{
				"name": "mass media",
				"salience": 0.0000637983,
				"type": "OTHER"
			},
			{
				"name": "mansions",
				"salience": 0.000063332714,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.00006258536,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00006258536,
				"type": "LOCATION"
			},
			{
				"name": "hit",
				"salience": 0.00006206658,
				"type": "EVENT"
			},
			{
				"name": "lawsuit",
				"salience": 0.00006206658,
				"type": "OTHER"
			},
			{
				"name": "no-fly zone",
				"salience": 0.00006206658,
				"type": "OTHER"
			},
			{
				"name": "world gangsterism",
				"salience": 0.00006206658,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.00006206658,
				"type": "OTHER"
			},
			{
				"name": "hit",
				"salience": 0.00006206658,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00006129131,
				"type": "PERSON"
			},
			{
				"name": "stupid s**t",
				"salience": 0.00006096772,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hhz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oval_Office"
				},
				"name": "Oval Office",
				"salience": 0.00006080227,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.000060303933,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000059748865,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.000059748865,
				"type": "OTHER"
			},
			{
				"name": "Hildabeast",
				"salience": 0.000059502156,
				"type": "PERSON"
			},
			{
				"name": "force",
				"salience": 0.000058310736,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01ssyy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Free_World"
				},
				"name": "Free World",
				"salience": 0.000058093923,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00005803518,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d2fpv"
				},
				"name": "Tony",
				"salience": 0.000058011472,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00005799845,
				"type": "OTHER"
			},
			{
				"name": "chances",
				"salience": 0.000057816254,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.000057816254,
				"type": "OTHER"
			},
			{
				"name": "chances",
				"salience": 0.000057816254,
				"type": "OTHER"
			},
			{
				"name": "taxpayer money",
				"salience": 0.000056037537,
				"type": "OTHER"
			},
			{
				"name": "silver lining",
				"salience": 0.000056037537,
				"type": "OTHER"
			},
			{
				"name": "poll ratings",
				"salience": 0.000056037537,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.000056037537,
				"type": "OTHER"
			},
			{
				"name": "objective",
				"salience": 0.000056037537,
				"type": "OTHER"
			},
			{
				"name": "dictatorships",
				"salience": 0.000056037537,
				"type": "OTHER"
			},
			{
				"name": "dictatorships",
				"salience": 0.000056037537,
				"type": "OTHER"
			},
			{
				"name": "throat",
				"salience": 0.000056037537,
				"type": "OTHER"
			},
			{
				"name": "TonyDiGerolamo",
				"salience": 0.000055845172,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chief Military Correspondent",
				"salience": 0.000055353645,
				"type": "PERSON"
			},
			{
				"name": "stripes",
				"salience": 0.000055137985,
				"type": "OTHER"
			},
			{
				"name": "Michael Gillespie",
				"salience": 0.00005420281,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Reagan",
				"salience": 0.00005420281,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00005398894,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.000053756627,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.000053264925,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.000052681928,
				"type": "EVENT"
			},
			{
				"name": "problem",
				"salience": 0.000052593474,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.000052471012,
				"type": "OTHER"
			},
			{
				"name": "Hillary Campaign",
				"salience": 0.000052468655,
				"type": "ORGANIZATION"
			},
			{
				"name": "surprise",
				"salience": 0.000052358464,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.000052358464,
				"type": "OTHER"
			},
			{
				"name": "No one",
				"salience": 0.000052200052,
				"type": "PERSON"
			},
			{
				"name": "Anti-statists",
				"salience": 0.000052200052,
				"type": "PERSON"
			},
			{
				"name": "anti-imperialists",
				"salience": 0.000052200052,
				"type": "PERSON"
			},
			{
				"name": "acquittal",
				"salience": 0.00005169844,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.000051313233,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.000051313233,
				"type": "LOCATION"
			},
			{
				"name": "hatred",
				"salience": 0.000050664883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07pkw84"
				},
				"name": "Communist",
				"salience": 0.000050301613,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.00004976787,
				"type": "OTHER"
			},
			{
				"name": "Queen",
				"salience": 0.0000491405,
				"type": "PERSON"
			},
			{
				"name": "pro-Zionist",
				"salience": 0.000048971808,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.000048926606,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.000048926606,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.000048926606,
				"type": "EVENT"
			},
			{
				"name": "life",
				"salience": 0.000048926606,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.000048926606,
				"type": "OTHER"
			},
			{
				"name": "Elsewhere",
				"salience": 0.000048738828,
				"type": "LOCATION"
			},
			{
				"name": "protesters",
				"salience": 0.00004852104,
				"type": "PERSON"
			},
			{
				"name": "impression",
				"salience": 0.00004852104,
				"type": "OTHER"
			},
			{
				"name": "shooting",
				"salience": 0.00004852104,
				"type": "EVENT"
			},
			{
				"name": "intimidation blitz",
				"salience": 0.00004852104,
				"type": "OTHER"
			},
			{
				"name": "browbeaters",
				"salience": 0.00004852104,
				"type": "PERSON"
			},
			{
				"name": "thugs",
				"salience": 0.00004852104,
				"type": "PERSON"
			},
			{
				"name": "supremacy",
				"salience": 0.00004852104,
				"type": "OTHER"
			},
			{
				"name": "government ownership",
				"salience": 0.00004852104,
				"type": "OTHER"
			},
			{
				"name": "latter",
				"salience": 0.00004852104,
				"type": "OTHER"
			},
			{
				"name": "sadists",
				"salience": 0.00004852104,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.00004852104,
				"type": "OTHER"
			},
			{
				"name": "ad campaign",
				"salience": 0.000048356935,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_zsd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marxist_philosophy"
				},
				"name": "Marxist",
				"salience": 0.00004714305,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02d9wb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Destiny"
				},
				"name": "Fate",
				"salience": 0.00004714305,
				"type": "ORGANIZATION"
			},
			{
				"name": "Thomas L. Knapp",
				"salience": 0.00004714305,
				"type": "PERSON"
			},
			{
				"name": "Prometheus Books",
				"salience": 0.00004714305,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f4r5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bureau_of_Land_Management"
				},
				"name": "BLM",
				"salience": 0.00004714305,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00004714305,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.000046600355,
				"type": "PERSON"
			},
			{
				"name": "hope",
				"salience": 0.00004553891,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04p7yd4"
				},
				"name": "richard",
				"salience": 0.00004541533,
				"type": "PERSON"
			},
			{
				"name": "conservatives",
				"salience": 0.000045198256,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.000045198256,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.000045198256,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.000045198256,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000045198256,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000045198256,
				"type": "OTHER"
			},
			{
				"name": "empires",
				"salience": 0.000045198256,
				"type": "OTHER"
			},
			{
				"name": "dream",
				"salience": 0.000045198256,
				"type": "OTHER"
			},
			{
				"name": "world master class",
				"salience": 0.000045030018,
				"type": "EVENT"
			},
			{
				"name": "same",
				"salience": 0.000045030018,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.000045030018,
				"type": "OTHER"
			},
			{
				"name": "master class",
				"salience": 0.000045030018,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.000045030018,
				"type": "EVENT"
			},
			{
				"name": "choices",
				"salience": 0.000044597302,
				"type": "OTHER"
			},
			{
				"name": "Change",
				"salience": 0.000043184926,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.000043184926,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.000043184926,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.000042058542,
				"type": "EVENT"
			},
			{
				"name": "nuts",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "authority figures",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "masses",
				"salience": 0.00004080768,
				"type": "PERSON"
			},
			{
				"name": "decline",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "self-destruct",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "paradigm",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.00004080768,
				"type": "LOCATION"
			},
			{
				"name": "savior figure",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "nuts",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "comrade hermit",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "Globalists",
				"salience": 0.00004080768,
				"type": "PERSON"
			},
			{
				"name": "trends",
				"salience": 0.00004080768,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.00004062533,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.000040113206,
				"type": "PERSON"
			},
			{
				"name": "supremeborg",
				"salience": 0.000039975504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06grw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Revolution"
				},
				"name": "Revolution",
				"salience": 0.000039975504,
				"type": "EVENT"
			},
			{
				"name": "John V. Walsh",
				"salience": 0.000039975504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "NYT",
				"salience": 0.000039975504,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ladder of Power",
				"salience": 0.000039975504,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "POTUS",
				"salience": 0.000039975504,
				"type": "ORGANIZATION"
			},
			{
				"name": "YouAreNuts",
				"salience": 0.000038482678,
				"type": "PERSON"
			},
			{
				"name": "Nation Gang",
				"salience": 0.000038194805,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.000037816786,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.000037816786,
				"type": "OTHER"
			},
			{
				"name": "shift",
				"salience": 0.000037647802,
				"type": "EVENT"
			},
			{
				"name": "symptom",
				"salience": 0.000037647802,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.000037647802,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.000036704598,
				"type": "OTHER"
			},
			{
				"name": "opposite",
				"salience": 0.000036544832,
				"type": "OTHER"
			},
			{
				"name": "editors",
				"salience": 0.000036544832,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.000036544832,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00003649424,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048xm2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Red_states_and_blue_states"
				},
				"name": "Blue States",
				"salience": 0.000036306043,
				"type": "ORGANIZATION"
			},
			{
				"name": "whiff",
				"salience": 0.000036241898,
				"type": "OTHER"
			},
			{
				"name": "throat",
				"salience": 0.00003594565,
				"type": "OTHER"
			},
			{
				"name": "mint",
				"salience": 0.000035785026,
				"type": "OTHER"
			},
			{
				"name": "Aion",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "bellow",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "Account Exec",
				"salience": 0.000035333916,
				"type": "PERSON"
			},
			{
				"name": "state capitalism",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "assurances",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "mobility",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "rocks",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "people cherry",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "stability",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "above",
				"salience": 0.000035333916,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.000035333916,
				"type": "EVENT"
			},
			{
				"name": "Hildabeast",
				"salience": 0.000034484518,
				"type": "PERSON"
			},
			{
				"name": "mass media corporations",
				"salience": 0.000033759967,
				"type": "ORGANIZATION"
			},
			{
				"name": "column",
				"salience": 0.000033759967,
				"type": "WORK_OF_ART"
			},
			{
				"name": "women",
				"salience": 0.000033759967,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.000033759967,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.000033759967,
				"type": "PERSON"
			},
			{
				"name": "corporations",
				"salience": 0.000033759967,
				"type": "ORGANIZATION"
			},
			{
				"name": "Assad & Putin",
				"salience": 0.00003324392,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq_War"
				},
				"name": "War on Iraq",
				"salience": 0.000032419477,
				"type": "EVENT"
			},
			{
				"name": "DEWEY DEFEATS TRUMAN",
				"salience": 0.00003212293,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0136kr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberal_Party_of_Canada"
				},
				"name": "liberal",
				"salience": 0.00003212293,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07w42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libertarian_Party_(United_States)"
				},
				"name": "Libertarian",
				"salience": 0.00003212293,
				"type": "ORGANIZATION"
			},
			{
				"name": "flag",
				"salience": 0.00003112403,
				"type": "OTHER"
			},
			{
				"name": "tabloid",
				"salience": 0.000030731673,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.000030731673,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m61",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antisemitism"
				},
				"name": "anti-Jewish",
				"salience": 0.00003069201,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "shit",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "optimism",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "lesson",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "abuser",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "gulag",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "mass media independent",
				"salience": 0.000030480465,
				"type": "PERSON"
			},
			{
				"name": "gulag",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "shit",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.000030480465,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.000030480465,
				"type": "PERSON"
			},
			{
				"name": "Finnicum",
				"salience": 0.000029858878,
				"type": "PERSON"
			},
			{
				"name": "Jackboot",
				"salience": 0.000029858878,
				"type": "PERSON"
			},
			{
				"name": "hackjob",
				"salience": 0.000029858878,
				"type": "OTHER"
			},
			{
				"name": "Lavoy",
				"salience": 0.000029858878,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ls2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colombia"
				},
				"name": "Colombia",
				"salience": 0.000029858878,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0108bx7v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bundy_standoff"
				},
				"name": "Bundy Ranch",
				"salience": 0.000029858878,
				"type": "LOCATION"
			},
			{
				"name": "credit",
				"salience": 0.000028842844,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.000028842844,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020swz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Dream"
				},
				"name": "American Dream",
				"salience": 0.000027814056,
				"type": "WORK_OF_ART"
			},
			{
				"name": "standard",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "worshippers",
				"salience": 0.000026391897,
				"type": "PERSON"
			},
			{
				"name": "proclamation",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.000026391897,
				"type": "PERSON"
			},
			{
				"name": "subclasses",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "prejudice",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.000026391897,
				"type": "PERSON"
			},
			{
				"name": "rule",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.000026391897,
				"type": "LOCATION"
			},
			{
				"name": "existence",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "homeland",
				"salience": 0.000026391897,
				"type": "LOCATION"
			},
			{
				"name": "terrorist attack",
				"salience": 0.000026391897,
				"type": "EVENT"
			},
			{
				"name": "boil",
				"salience": 0.000026391897,
				"type": "EVENT"
			},
			{
				"name": "vanity",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "youth",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "frustration",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "secret",
				"salience": 0.000026391897,
				"type": "OTHER"
			},
			{
				"name": "bob balkas",
				"salience": 0.000026391897,
				"type": "PERSON"
			},
			{
				"name": "shearing",
				"salience": 0.000026391897,
				"type": "EVENT"
			},
			{
				"name": "round",
				"salience": 0.000026391897,
				"type": "EVENT"
			},
			{
				"name": "friends",
				"salience": 0.000026391897,
				"type": "PERSON"
			},
			{
				"name": "road",
				"salience": 0.000026391897,
				"type": "LOCATION"
			},
			{
				"name": "Red States",
				"salience": 0.000026195245,
				"type": "ORGANIZATION"
			},
			{
				"name": "bullet",
				"salience": 0.000026176165,
				"type": "OTHER"
			},
			{
				"name": "Claus-Erik Hamle",
				"salience": 0.000025112131,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "Chinese",
				"salience": 0.000024191242,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqis",
				"salience": 0.000023993496,
				"type": "PERSON"
			},
			{
				"name": "Julius Streicher",
				"salience": 0.000022978196,
				"type": "PERSON"
			},
			{
				"name": "Joe Flack Somehow",
				"salience": 0.000022488819,
				"type": "PERSON"
			},
			{
				"name": "facts",
				"salience": 0.000021836333,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04m9y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lizard"
				},
				"name": "Lizard",
				"salience": 0.000021743637,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vhjc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_world_order_(politics)"
				},
				"name": "New World Order",
				"salience": 0.000021743637,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.000021743637,
				"type": "LOCATION"
			},
			{
				"name": "Brexit",
				"salience": 0.000021743637,
				"type": "PERSON"
			},
			{
				"name": "Sacred Golden Bull",
				"salience": 0.000018756893,
				"type": "OTHER"
			},
			{
				"name": "Luther Blissett",
				"salience": 0.000018205243,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05bkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nuremberg"
				},
				"name": "Nürnberg",
				"salience": 0.00001624086,
				"type": "LOCATION"
			},
			{
				"name": "Hil",
				"salience": 0.00001624086,
				"type": "PERSON"
			},
			{
				"name": "Divide and Conquer",
				"salience": 0.00001624086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.00001624086,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.00001624086,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.00001624086,
				"type": "LOCATION"
			},
			{
				"name": "Mikhailovich",
				"salience": 0.00001583396,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T14:00:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 90.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "As Darkness Falls, A Silver Lining Short term pessimism – long term optimism Share This \nThe future, in many respects, looks dark for opponents of interventionism and the National Security State. US troops are currently involved in civil wars and “policing” across a wide swath of the Middle East, Europe, and Eastasia. Our political class is firmly committed to a globalist ideology that disdains the very concept of national sovereignty, most especially our own. And what Dwight Eisenhower called the “ military-industrial-congressional complex ” is more firmly entrenched than ever, extracting billions from the “public” purse and filling their coffers at our expense. \nFurthermore, the presidential election is hardly encouraging. The prospect of Hillary Clinton in the White House must surely cause even the most optimistic among us to consider building one of those backyard bomb shelters so popular during the cold war era and stocking it with a couple of years supply of emergency rations. She has all but threatened to go to war with nuclear-armed Russia , intervene massively in Syria , and ratchet up NATO’s encirclement of the Russian bear. \nYet these are all short-term concerns: in the long term, we anti-interventionists have every reason to be optimistic. \nTo begin with, the American people are with us. Every poll shows that, while support for a strong defense is rising, the reluctance to engage in foreign wars is strong and getting stronger. The most recent measuring of anti-interventionist sentiment came out just as I started writing this column: a mere 25 percent want the US to expand the role of the US military overseas, reports the Financial Times . Fourteen percent say the fifteen years of constant warfare have made us more safe, 51 percent disagree. A majority says no to “safe zones” or any sort of intervention in Syria: and a whopping 80 percent say Congress must approve any military action abroad. \nSecondly, the victory of Donald Trump in the Republican presidential primary has broken the iron grip of the neoconservatives on GOP foreign policy orthodoxy and given opposition to globalism new legitimacy in the pubic square. No matter what one may think of Trump as a candidate, and in spite of his many inconsistencies, one indisputable fact remains: the Republican party, which cheered as George W. Bush launched two wars and declared a multi-generational interventionist project, very shortly afterward nominated someone who not only opposed the Iraq war but said “They lied. There were no weapons of mass destruction and they knew there were none .” That, all by itself, represents a sea change. But it didn’t end there. \nTrump has questioned the utility of NATO, and even threatened to pull out if member states didn’t pay their fair share – a pronouncement that, just a short time ago, would have been inconceivable coming from any major part presidential nominee. He wondered aloud why we’re defending South Korea, Japan, and Saudi Arabia , all rich nations that are perfectly capable of defending themselves. And he provoked the undying ire of the War Party when he asked : “Wouldn’t it be nice if we could get along with Russia?” \nUnderscoring that he understands the broader implications of these positions, Trump adopted a campaign theme that evokes the historical legacy of the anti-interventionist movement in this country: “America First.” This provoked paroxysms of hatred from the foreign policy mandarins in Washington, who loathe “isolationism” — and their squeals of outrage were music to my ears. \nThirdly, the Trump campaign has generated the healthiest trend to be seen in this country in a long time: widespread skepticism, and even hatred, of the “mainstream” media. Trump has campaigned against the media almost more than he has against Hillary Clinton, making them a special target of his disdain. “See those people out there,” he says at his rallies, pointing to the media in attendance. “They’re the worst! They’re corrupt!” And as a chorus of jeers rises up from the crowd, we can count another victory for our side. \nFor the very same media that served as a conduit for the war propaganda of the Bush administration is now going after Trump, hammer and tongs , in an unabashed campaign to deny him the presidency. The result is that nearly half the country is now not only skeptical of anything they hear coming from the media, they positively loathe them – and that, from our perspective, is a Good Thing. \nRemember, it was the American media that assured us Saddam Hussein was plotting to nuke Washington, D.C., and reported the Bush administration’s talking points as if they were fact. The same newspaper that put Judy Miller’s manufactured “revelations” about Iraq’s alleged nuclear program on the front page is now in the vanguard of the anti-Trump jihad. The Washington Post , which has editorially supported every single military intervention in the past 35 years, today reads like a publication of the Democratic National Committee. \nThe revelation that the media, rather than being a watchdog of Power, is itself an integral part of the power structure, is one of the great contributions of the Trump campaign. In the past, journalists, hiding behind the pretense of “objectivity,” have effectively channeled the War Party’s propaganda, reporting it as fact: now that this pretense has been dropped, and their brazen partisanship has been exposed, much of their power to persuade has been lost. \nThe media and the Establishment they serve are telling us that all this will go away after the election. Having already declared Mrs. Clinton the winner, they’re gloating that Trumpism – and the Trump Effect – is dead or dying. \nThis is wishful thinking on their part. The reality is that there’s an undercurrent coursing through Flyover America that threatens the ideological and political hegemony of the War Party, and, indeed, poses a rising challenge to our arrogant and self-isolated political class. Trump has tapped into this, and he will not be the last to do so. The movement to put “America First,” to reject the blandishments of Empire and restore our Old Republic, far from being dead, is just being born. \nYes, dark clouds are gathering on the horizon: but if you step back, the silver lining shines through. \nNOTES IN THE MARGIN \nYou can check out my Twitter feed by going here . But please note that my tweets are sometimes deliberately provocative, often made in jest, and largely consist of me thinking out loud. \nYou can buy An Enemy of the State: The Life of Murray N. Rothbard (Prometheus Books, 2000), my biography of the great libertarian thinker, here . Read more by Justin Raimondo Assange’s Fate – October 18th, 2016 Trumped! – October 16th, 2016 Click here to hide comments Michael Gillespie \nIf he loses the election by a significant margin, won’t many of the entirely legitimate issues and questions Trump has raised be submerged again by his defeat? And doesn’t the mere fact that it is Trump who has raised these issues and questions de-legitimize them in the eyes of those who (with the assistance of anti-Trump ads and Big Media reportage) can see only Trump’s character flaws? TonyDiGerolamo \nWas thinking the same thing. However, if the media so brazenly lies, why not the pollsters? Maybe Trump isn’t losing by much or not at all. Maybe the powers that be want it to look like Trump is losing so that stealing the election won’t be questioned. Eileen Kuch \nThe truth is, Tony, this election’s already being rigged. Many voters in Texas alone who’ve voted early have complained about their votes being switched from Republican to Democrat. This vote switch has already proved Trump to be right about the election being rigged. The Donald already has a lawsuit in place, should he lose this election. This lawsuit contains a complaint that voters in GOP districts had been intimidated by violent groups such as Black Lives Matter (BLM) and Marxist activists and threatened with violence if they (the voters) voted for Trump. It is a felony to intimidate and threaten violence against voters in an election. Period. Those participating in this tactic must be immediately arrested and charged accordingly. \n“Many voters in Texas alone who’ve voted early have complained about their votes being switched from Republican to Democrat.” \nAnd yet, despite the ubiquity of smart phones, not a single one has shown it actually happening. Strider73 \nDo you really think the people in charge of the machines would allow anyone to get out his/her phone and take such a photo or video? Nor would they allow someone else to do so on another voter’s behalf. Thane_Eichenauer \nPersonally I believe the touch screen calibration explanation by and large. Half the reports I also attribute to user error. If you can’t use a touch screen you probably aren’t capable of capturing the error on a smart phone. Those people that are adept with computers, touch screens and smart phones won’t have the problem in the first place. I would think there would still be a captured report but Strider73 below does make a good point. wars r u.s. Thomas L. Knapp \nInteresting point. \nI think it’s worth comparing Trump to Ron Paul on that. Paul was right on foreign policy, right on trade, and at least not as egregiously wrong and anti-American as Trump on immigration. And while he did energize a movement, he pretty much got nowhere in the GOP presidential nomination race. \nTrump sometimes gets something right on foreign policy, usually five minutes or so before reversing himself. He doesn’t reverse himself on his egregiously wrong and anti-American positions on trade and immigration. \nSo I guess the lesson is, if you want to be the Republican presidential nominee, be as wrong as it’s humanly possible to be on most issues all of the time, and on the rest of the issues some of the time. \nI’m guessing that the occasional sense he talks on foreign policy will be, as you put it, once again submerged if he loses the election. Skywalker \nTrump’s candidacy is more like Barry Goldwater’s than Ron Paul’s. Unlike Paul,Trump got the nomination and like Goldwater he redefined the parameters of national debate. Goldwater’s defeat emboldened conservatives to lose national elections on their principles for 16 years until Reagan was elected. Trump questioned some of the underpinnings of the Neocons. Unfortunately he was as pro-Zionist as any other candidate, including Clinton and as militaristic as the Neocons. Trump just saw the existential enemies of the US as ISIS and China, not Russia. Instead Trump wanted to push the allies and Russia to the front lines against ISIS and China with the US backing them up. But Trump’s enduring popularity and the independence of the Sanders supporters showed that the Neocons and the MSM are losing control of public opinion and the national discourse. All the polls show that Trump will do much better than Goldwater. So we may be closer to a real antiwar candidate than the MSM would like us to believe. Finally, it is too early to count Trump out. Florida, Ohio and North Carolina are still close and a timely WikiLeaks dump could still swing those states and the election. \n“Finally, it is too early to count Trump out. Florida, Ohio and North Carolina are still close and a timely WikiLeaks dump could still swing those states and the election.” \nUnless something changes, I still expect Trump to win. \nA lot of people are mistakenly looking at this as a national election. It isn’t. It’s 50 state elections (plus DC and the territories, although if I recall correctly the territories get no electoral votes and so don’t really matter except as preference polls). \nIf Clinton wins California 55-45, she gets exactly the same number of electoral votes as if she wins it 70-30. If she loses Texas 51-49, she is no closer to its electoral votes than if she loses it 80-20. So when she gains in national polls, it’s important to realize that WHERE those gains are coming from matters. \nIt’s also quite likely that many Trump voters aren’t admitting they are Trump voters, even on the phone to pollsters. There’s a stigma in some areas. \nI expect Trump to win any state that the polls have him within five points of carrying. And I expect him to win the election. disqus_eEbPU3IGDU \nMy guess is Trump wins in a squeaker, but the Democrats steal the election and Hillary becomes president. Eileen Kuch \nI expect Trump to win in a near landslide. Well over 70% of eligible voters have already said they’d never vote for Hillary Clinton, and a good number are millennials who had supported Bernie Sanders during the primaries and who are now furious over Bernie’s betrayal of them at the end, but still blame Hillary. In these young people’s minds, Trump is the next best choice as POTUS. They know how corrupt the Hildabeast truly is, how desperate she is to gain the Oval Office – even by rigging the election in her favor. After all, she had done it to Bernie in the primaries. However, Trump has more determination at winning the Oval Office than had Bernie. He also had stronger opposition. richard vajs \nIf Hillary does win (and we can count on Bill pulling every dirty trick out of his evil mind to ensure that), one thing that we can count on – 4 years of legislation to prevent any Populist like Bernie or Trump from ever getting another foothold on the Ladder of Power in this country. The elite don’t ever want to have to worry about the “little people” getting uppity again. Remember, This is Their Country. wars r u.s. comrade hermit \nRon Paul, like him or loath him, was/is a legitimate pacifist. Trump is a knuckle-dragging malignant narcissist who would drone strike a fourth grade slumber party for prank phone-calling him. BIG f**king difference there. I don’t believe the good Doctor Paul has earned such a slur. His son maybe but leave the old man out of this one. Just sayin. supremeborg \n“Ron Paul, like him or loath him, was/is a legitimate pacifist” \nJust a slight correction to your terminology. Ron Paul is not, technically, a pacifist, in spite of the fact that he would have opposed every war the US has been in save the original war of Revolution. He upholds the legitimacy of violence used in self defense, at least some of the time, in some cases \nYour point is well taken, however, as he is the most consistent anti-interventionist to have served in Congress in my lifetime. \nThere are different interpretations of pacifism. Many people, including myself, consider themselves to be pacifists but still defend the right to self defense. Joe Flack \nAnd Big Media has at least three years to work with. By the next presidential election cycle, Trump and his message will very likely be all but forgotten. John V. Walsh \nGood column. A correction. Justin writes, “The same newspaper that put Judy Miller’s manufactured “revelations” about Iraq’s alleged nuclear program on the front page is now in the vanguard of the anti-Trump jihad. It was not only Judith Miller that authored the article but she and co-author Michael R. Gordon who has remained the “Chief Military Correspondent” of the NYT. The despicable Miller took the hit when the lies of the article could no longer be denied but the despicable Gordon continued on. And the article was obviously a pile of assertions without evidence save for hearsay. That was obvious to me and I have not served as an editor since my high school newspaper. The editors who passed on that piece of shit should also be sent to some gulag, their existence there to be supervised by parents and children of Iraqis and Americans who lost their lives in the War on Iraq. Strider73 \nThe editors who passed on that piece of shit should also be sent to some gulag, . . . \nNah, just hang them (or if one is more frugal, give them one bullet to the head each like the Chinese do) for crimes against humanity. Julius Streicher was executed at Nürnberg simply for publishing a virulently anti-Jewish tabloid ; under that standard they deserve the same. Mikhailovich \nBy independent mass media they mean mass media independent from the state. This idea promoted by those few mass media corporations who own the mass media and together with other corporations they own the state. Very few people own almost everything. You can’t change situation by attacking the correspondents and editors, they are employed people. Here I shut up, one can’t touch the Sacred Golden Bull, the worshippers would be insulted. Joe Flack \nSomehow, in the US, ‘America First’ is interpreted as being a racist and misogynistic proclamation. richard vajs \nI can just see a smiling Bill Clinton leaning back and saying, “look, here is how we win this thing, Hil. – Divide and Conquer – millions of women are anxious to battle “abuse and prejudice against women and teach an abuser a lesson!”. Not very original, but effective- was effective in the “Change , you can believe in” ad campaign eight years ago. Four years from now, the same women will still have lousy or no jobs; money will still be being spent in the Mid East bombing Muslims for Israel; the Clintons and their friends will be building bigger mansions, and a new generation of Americans will be ready for another round of shearing. Luther Blissett \nI enjoy the optimism of this column but I’m witnessing the opposite – many worthy anti-globalist & anti-war ideas are being tarred and deeply poisoned by having such a truly unlikable and wildly unstable politician claim them as his own. Making the case against toppling Assad was easier before Trump started blabbering on about Assad & Putin ‘outsmarting’ America. \nTrump has tapped into real populist frustration, especially in the working class & the underemployed youth, but he is simply far too incoherent and repellent to do anything with it besides waste it on his own vanity. \nRight-wing hatred of the ‘liberal media’ has been at a scalding boil since the Vietnam war so I don’t think Trump should get any credit for that – but it would be nice that when the next big terrorist attack in the ‘homeland’ occurs if the Red States were skeptical because if Hillary is president the Blue States are going shove the American flag down everyone’s throat and floss them with it. \nThose so called “polls” are made in secret, right? Why would you trust that? bob balkas \nCompare “our political class committed to globalist ideology” with my: Our master class along with a sub-master class on the road to obtain the entire planet and permanent rule of the world master class of all subclasses or ‘lower-valued’ bipeds. \nCurioso is also the term, “we the anti-interventionists”. The term means that US intervenes when something goes wrong in other countries. But the naked facts say otherwise. US not only commits crimes against some nations, but before it does those crimes, it almost always first destabilizes them in too many ways to list them all. After all, many nations and people believe that CIA is the biggest terrorist organization. \nThe Nation Gang; aka Nato no longer utile, according to Trump? Even if Trump wins, someone would explain to him that such a gang will be very useful to world gangsterism and supremacy of the master class. disqus_eEbPU3IGDU \nVery very very well put. Justin might have added that for a long time the MSM in the so-called Free World were even worse that the government-controlled media in Communist countries and dictatorships. In the Free World, the MSM have not been under formal government control, so this makes them seem objective so that what they say is more believable and their power is greater. If in fact they do sometimes print something that Washington really doesn’t like, that’s just good psychology because it reinforces the impression that MSM really are independent watchdogs of government. By contrast, in the Communist countries and dictatorships, the media have been under formal government ownership. As this fact could not of course have been hidden from the people, the latter naturally tended to discount what they read in the media because they knew that the media were biased. Claus-Erik Hamle \nTrump may win. In Colombia there was no doubt that it would be “yes”, but unfortunately, it ended “no”. So really, it´s impossible to know. Does she really mean that she´ll nake a no-fly zone no matter that it leads to war with Syria and Russia? disqus_eEbPU3IGDU \nThis is a crazy election, the craziest since at least 1968. In such a crazy and unusual situation, what do the polls mean? YouAreNuts \nThe only silver lining I’ve seen this week is the acquittal of the Bundy Ranch protesters. Hopefully the Finnicum family make a mint (of taxpayer money) in a lawsuit for the unnecessary shooting of Lavoy. \nElsewhere, I have to agree with Assange; Trump probably can’t overcome the almost complete propaganda and intimidation blitz against his campaign by the MSM and hackjob Democrat browbeaters and Jackboot thugs. \nOnce Hillary is in, it won’t so much be her forcing policy down her throat; it will be the entire Dem machine and presstitute corp as mentioned above… Assange, btw, will probably get renditioned or taken out.. \nSince it’s logistically difficult to impossible for millions to stream into DC to squat and demand justice, I don’t really see any threat of consequences for whatever atrocious policies that the sadists in Washington implement. Eileen Kuch \nRegarding Hillary’s so-called “victory”, I have to disagree. With every revelation of her crimes by Wikileaks, the Hildabeast’s chances of winning the election grow slimmer and slimmer, as her poll ratings take hit after hit after hit. The DNC’S and the Hillary Campaign’s involvement in violence against Trump supporters doesn’t help her campaign, either .. Instead, such intimidation only backfires on the DNC and the Hillary Campaign. It has boosted Trump’s chances of winning the election. There’s still one more “surprise” from Wikileaks yet to be released, and what it contains may destroy Hillary’s chances. Aion The Irredeemable \nIt almost seems as though Justin has accepted reality and is now supporting Donald Trump. Has he seen the light or is he now pandering to the huge numbers of his followers who have left the Libertarian camp to become true conservatives? I don’t think I’ll be returning to the liberal/libertarian point of view but it’s a good sign that Justin has accepted the fact that Donald Trump represents the only force that will defeat the social marxists and their agenda of the New World Order/Globalists. \n“It almost seems as though Justin has accepted reality and is now supporting Donald Trump.” \nThat’s a one or the other kind of thing. Claus-Erik Hamle \nWill President Clinton insist on a no-fly zone, even if it means war with Syria and Russia ? Is she mad, crazy, nuts, insane, bonkers ? Strider73 \nIs she mad, crazy, nuts, insane, bonkers? \nAll of the above, and worse. Account Exec \nRemember how the British and U.S. media assured us that Brexit was doomed to failure? Getting a whiff of the same scenario playing out here with all the “assurances” of a Clinton victory. Might even get to enjoy another Wikileaks bomb or two before it’s all said and done. wars r u.s. \nTrump’s biggest problem with the media is that they print all the stupid s**t he says. He hardly made people realize how corrupt our corporate media is unless they were living under rocks for the last 40 years. We have two lousy choices no matter how hard people cherry pick what the Donald spews. comrade hermit \nTrump is not the cause of these growing trends. He is a symptom of them and not exactly a positive one. When empires are in decline, the aggrieved masses often look to authority figures to save them from the inevitable death of a way of life. In this country we call that dying way of life the “American Dream”. A dream of stability and upward mobility that has been in decline for decades but is now in free fall. The Donald cannot save this dream. No one can. It is built upon the lie of state capitalism which is inherently unsustainable and built to self-destruct. Our only hope for real change is a total shift in the way we approach the very notion of modern society. This change cannot come from above, from an authoritarian savior figure. It must come from bellow, from the streets, and it must be divorced from the outdated left-right paradigm. Anti-statists and anti-imperialists of all stripes must join together in solidarity and bring this beast called empire to its knees where it belongs. Strider73 \nThree words for anyone who thinks the Lizard Queen has it sewn up because of the polls: \nDEWEY DEFEATS TRUMAN",
		"thread_title": "As Darkness Falls, A Silver Lining",
		"title": "As Darkness Falls, A Silver Lining",
		"type": "bs",
		"uuid": "cb34e417f25bc697752ce9fca269a3eb24561d52"
	},
	"-KhIj1OkBvWJDsO-TUIn": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T06:04:33.796+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.20221533,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.1538709,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tal-Kayf",
				"salience": 0.120629705,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.11516336,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.10014853,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.096516974,
				"type": "ORGANIZATION"
			},
			{
				"name": "Others",
				"salience": 0.046863284,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.022233354,
				"type": "PERSON"
			},
			{
				"name": "Attack",
				"salience": 0.020691575,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01crwf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Friendly_fire"
				},
				"name": "Friendly Fire",
				"salience": 0.014791898,
				"type": "WORK_OF_ART"
			},
			{
				"name": "town",
				"salience": 0.011892021,
				"type": "LOCATION"
			},
			{
				"name": "friendly fire incident",
				"salience": 0.010995483,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.009937678,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.009235108,
				"type": "LOCATION"
			},
			{
				"name": "invasion",
				"salience": 0.008615826,
				"type": "EVENT"
			},
			{
				"name": "fighting",
				"salience": 0.0067274664,
				"type": "EVENT"
			},
			{
				"name": "incident",
				"salience": 0.0039620493,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.0037950084,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0035784976,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.003502543,
				"type": "LOCATION"
			},
			{
				"name": "military officials",
				"salience": 0.0034453063,
				"type": "PERSON"
			},
			{
				"name": "details",
				"salience": 0.0030999226,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.0029844916,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.0029844916,
				"type": "EVENT"
			},
			{
				"name": "mistake",
				"salience": 0.0025318314,
				"type": "OTHER"
			},
			{
				"name": "planes",
				"salience": 0.0025318314,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0025318314,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0018922567,
				"type": "LOCATION"
			},
			{
				"name": "Many",
				"salience": 0.0018922567,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0016338805,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0015918965,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0013786434,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0013786434,
				"type": "EVENT"
			},
			{
				"name": "posts",
				"salience": 0.0013786434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "incident",
				"salience": 0.0013173079,
				"type": "EVENT"
			},
			{
				"name": "vicinity",
				"salience": 0.001030086,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.001030086,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T06:04:33.796+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Nine Others Wounded in 'Friendly Fire' Attack by Jason Ditz, October 29, 2016 Share This \nAs Iraqi forces continue to struggle to get closer to the ISIS city of Mosul during the ongoing invasion, a US friendly fire incident has been reported in the town of Tal-Kayf, a town which fell quite some time ago and in which recent fighting hadn’t been reported. \nAccording to Iraqi military officials, the US airstrikes against the town killed at least four Iraqi soldiers and wounded nine others . The details are still scant on what happened, and the US has yet to comment on the incident at all. \nIraqi officials are chalking it up as a mistake, but it is unclear why the town would be struck by US planes in the first place, as the Iraqi troops had been there for almost a week and there did not appear to be ISIS forces in the immediate vicinity. \nIraqi forces confirmed the incident amid an announcement of more villages captured in the area west of Mosul. Many of the villages more than 5 km from the city have already fallen, and ISIS appears to be only sparsely defending those that remain, with the vast majority of their fighters hunkered down in Mosul itself, prepared for a major battle. Last 5 posts by Jason Ditz",
		"thread_title": "US Airstrike Kills Four Iraqi Troops Near Mosul",
		"title": "US Airstrike Kills Four Iraqi Troops Near Mosul",
		"type": "bs",
		"uuid": "1ba0dd5e852208b8dbfeb8bec0eea50ecf853588"
	},
	"-KhIj1xd1l5IzqtzcvG8": {
		"author": "William J. Astore",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T20:13:55.035+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.3046433,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.23842546,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.06410851,
				"type": "ORGANIZATION"
			},
			{
				"name": "email server",
				"salience": 0.049918905,
				"type": "OTHER"
			},
			{
				"name": "Much",
				"salience": 0.027317636,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.024355829,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.02232619,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.019144265,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.017849965,
				"type": "OTHER"
			},
			{
				"name": "William J. Astore",
				"salience": 0.013487891,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.013349464,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0108444495,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.010451169,
				"type": "OTHER"
			},
			{
				"name": "privileges",
				"salience": 0.009386341,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ww37b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_Interest_Declassification_Board"
				},
				"name": "Public Interest Declassification Board",
				"salience": 0.0077349944,
				"type": "ORGANIZATION"
			},
			{
				"name": "idea",
				"salience": 0.007515849,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0067230174,
				"type": "PERSON"
			},
			{
				"name": "government agency",
				"salience": 0.0054504927,
				"type": "ORGANIZATION"
			},
			{
				"name": "lack",
				"salience": 0.0043134135,
				"type": "OTHER"
			},
			{
				"name": "transparency",
				"salience": 0.0043134135,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0043134135,
				"type": "OTHER"
			},
			{
				"name": "character",
				"salience": 0.0043134135,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0043134135,
				"type": "OTHER"
			},
			{
				"name": "pursuit",
				"salience": 0.0043134135,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0043134135,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0038688197,
				"type": "OTHER"
			},
			{
				"name": "evasiveness",
				"salience": 0.003567276,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0035565016,
				"type": "OTHER"
			},
			{
				"name": "security classification",
				"salience": 0.0034936408,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0034936408,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0034686332,
				"type": "LOCATION"
			},
			{
				"name": "secrets",
				"salience": 0.0033633898,
				"type": "OTHER"
			},
			{
				"name": "classification",
				"salience": 0.0033633898,
				"type": "OTHER"
			},
			{
				"name": "over-classification",
				"salience": 0.0031829674,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0030257094,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0029128785,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0029128785,
				"type": "OTHER"
			},
			{
				"name": "rectitude",
				"salience": 0.0029128785,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0029128785,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.0029128785,
				"type": "OTHER"
			},
			{
				"name": "self-righteousness",
				"salience": 0.0029128785,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0028790298,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0028790298,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0028790298,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.0028527316,
				"type": "PERSON"
			},
			{
				"name": "Government",
				"salience": 0.0027258252,
				"type": "ORGANIZATION"
			},
			{
				"name": "government decisions",
				"salience": 0.0024705357,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0024705357,
				"type": "OTHER"
			},
			{
				"name": "malfeasance",
				"salience": 0.0024705357,
				"type": "OTHER"
			},
			{
				"name": "enabl",
				"salience": 0.0024705357,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0024705357,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0023606112,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0023606112,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0021315338,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0021315338,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "The Guardian",
				"salience": 0.0018630043,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0018630043,
				"type": "ORGANIZATION"
			},
			{
				"name": "autocracy",
				"salience": 0.0018458706,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.0018458706,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.0018458706,
				"type": "OTHER"
			},
			{
				"name": "Views",
				"salience": 0.0015526467,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0015526467,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0015262422,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0013445122,
				"type": "PERSON"
			},
			{
				"name": "permission",
				"salience": 0.0013445122,
				"type": "OTHER"
			},
			{
				"name": "blogs",
				"salience": 0.0013445122,
				"type": "WORK_OF_ART"
			},
			{
				"name": "military",
				"salience": 0.0013445122,
				"type": "ORGANIZATION"
			},
			{
				"name": "schools",
				"salience": 0.0013445122,
				"type": "ORGANIZATION"
			},
			{
				"name": "everything",
				"salience": 0.0012846568,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0010044138,
				"type": "OTHER"
			},
			{
				"name": "equivalent",
				"salience": 0.0010044138,
				"type": "OTHER"
			},
			{
				"name": "filing cabinets",
				"salience": 0.0010044138,
				"type": "OTHER"
			},
			{
				"name": "text",
				"salience": 0.0010044138,
				"type": "OTHER"
			},
			{
				"name": "Bracing Views",
				"salience": 0.0009557306,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "USAF",
				"salience": 0.0008275802,
				"type": "ORGANIZATION"
			},
			{
				"name": "wastore",
				"salience": 0.0008275802,
				"type": "LOCATION"
			},
			{
				"name": "@pct.edu",
				"salience": 0.0008275802,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T20:13:55.035+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Much is being made of Hillary Clinton’s private email server, which she used when she was Secretary of State. To me, the real issue is not that Hillary endangered national security by sending classified information in the clear. No – the real issue is that the Clintons act as if they are above the rules and laws that apply to “the little people.” They are superior and smug, totally devoted to themselves and their pursuit of power and the privileges that come with it. It’s a matter of character, in other words. Hillary’s evasiveness, her lack of transparency, her self-righteousness, her strong sense of her own rectitude, make her a dangerous candidate for the presidency.\nMy second point is this: The issue of classification should be turned on its head. The real issue is not that Hillary potentially revealed secrets. No – the real issue is that our government keeps far too much from us. Our government uses security classification not so much to keep us safe, but to keep the national security state safe – safe from the eyes of the American people.\n\nAs The Guardian reported in 2013 :\n“A committee established by Congress, the Public Interest Declassification Board, warned in December that rampant over-classification is ‘imped[ing] informed government decisions and an informed public’ and, worse, ‘enabl[ing] corruption and malfeasance’. In one instance it documented, a government agency was found to be classifying one petabyte of new data every 18 months, the equivalent of 20m filing cabinets filled with text.”\nNowadays, seemingly everything is classified. And if it’s classified, if it’s secret, we can’t know about it. Because we can’t be trusted with it. That’s a fine idea for an autocracy or dictatorship, but not so fine for a democracy.\nGovernment of the people, by the people, for the people? Impossible when nearly everything of any importance is classified.\nToo bad Hillary didn’t send everything in the clear – what a service she would have done for the American people and for democracy!\nWilliam J. Astore is a retired lieutenant colonel (USAF). He taught history for fifteen years at military and civilian schools and blogs at Bracing Views . He can be reached at wastore@pct.edu . Reprinted from Bracing Views with the author’s permission. \n",
		"thread_title": "Two Points About the Hillary Clinton Email Fiasco",
		"title": "Two Points About the Hillary Clinton Email Fiasco",
		"type": "bs",
		"uuid": "7c623df2e9a5dd8e35618d7802fa2045f8a04530"
	},
	"-KhIj2CJshICPZ9LOmxn": {
		"author": "Margaret Griffis",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T03:04:48.351+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "militiamen",
				"salience": 0.2424297,
				"type": "PERSON"
			},
			{
				"name": "route",
				"salience": 0.11110712,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.10317438,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07rvp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tal_Afar"
				},
				"name": "Tal Afar",
				"salience": 0.09014306,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.062241063,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.04924771,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.031811867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Recep Tayyip Erdoğan",
				"salience": 0.027452677,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.025468927,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.01968437,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.01968437,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.010765212,
				"type": "LOCATION"
			},
			{
				"name": "militiamen",
				"salience": 0.008933829,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.008637513,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.007801364,
				"type": "EVENT"
			},
			{
				"name": "border town",
				"salience": 0.007801364,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.007602135,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.006758058,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shi'ite",
				"salience": 0.006018686,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0054745874,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.005270622,
				"type": "LOCATION"
			},
			{
				"name": "condition",
				"salience": 0.0047417833,
				"type": "OTHER"
			},
			{
				"name": "marches",
				"salience": 0.0047417833,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.0047417833,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0047417833,
				"type": "LOCATION"
			},
			{
				"name": "food",
				"salience": 0.0047417833,
				"type": "OTHER"
			},
			{
				"name": "shelter",
				"salience": 0.0047417833,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0045650634,
				"type": "PERSON"
			},
			{
				"name": "outskirts",
				"salience": 0.0045650634,
				"type": "LOCATION"
			},
			{
				"name": "human shields",
				"salience": 0.0045650634,
				"type": "OTHER"
			},
			{
				"name": "assault",
				"salience": 0.0045355414,
				"type": "EVENT"
			},
			{
				"name": "security personnel",
				"salience": 0.004470856,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.004470856,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bjzhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silopi"
				},
				"name": "Silopi",
				"salience": 0.004163543,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.003872172,
				"type": "PERSON"
			},
			{
				"name": "corridor",
				"salience": 0.003872172,
				"type": "LOCATION"
			},
			{
				"name": "battle",
				"salience": 0.003872172,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.0037342834,
				"type": "LOCATION"
			},
			{
				"name": "militia forces",
				"salience": 0.0036999655,
				"type": "PERSON"
			},
			{
				"name": "terror",
				"salience": 0.003680889,
				"type": "OTHER"
			},
			{
				"name": "villages",
				"salience": 0.0033410706,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0028934765,
				"type": "PERSON"
			},
			{
				"name": "Several",
				"salience": 0.0028934765,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f06xq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraqi_Turkmen"
				},
				"name": "Turkmen",
				"salience": 0.0028114012,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0026955558,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.0024339813,
				"type": "PERSON"
			},
			{
				"name": "casualties",
				"salience": 0.0024339813,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0024339813,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.0024339813,
				"type": "OTHER"
			},
			{
				"name": "Qayara",
				"salience": 0.0023843965,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01b8yn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shura"
				},
				"name": "Shura",
				"salience": 0.0023843965,
				"type": "PERSON"
			},
			{
				"name": "estimates",
				"salience": 0.0021077918,
				"type": "OTHER"
			},
			{
				"name": "civilian",
				"salience": 0.0021077918,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0019130758,
				"type": "OTHER"
			},
			{
				"name": "villages",
				"salience": 0.0018184917,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j40h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan_Workers'_Party"
				},
				"name": "P.K.K.",
				"salience": 0.0017814356,
				"type": "ORGANIZATION"
			},
			{
				"name": "Sajma",
				"salience": 0.0017814356,
				"type": "PERSON"
			},
			{
				"name": "San Zaban",
				"salience": 0.0017814356,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01c9bx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kirkuk"
				},
				"name": "Kirkuk",
				"salience": 0.001297534,
				"type": "LOCATION"
			},
			{
				"name": "Security forces",
				"salience": 0.0012599078,
				"type": "PERSON"
			},
			{
				"name": "guerrillas",
				"salience": 0.0012220186,
				"type": "PERSON"
			},
			{
				"name": "witnesses",
				"salience": 0.0011615831,
				"type": "PERSON"
			},
			{
				"name": "Mwaylaha",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Haram",
				"salience": 0.0009692963,
				"type": "LOCATION"
			},
			{
				"name": "Hamza",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Zwirij",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Tal Tayiba",
				"salience": 0.0009692963,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shruq",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Mustanqa",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Mukhalat",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Majman",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Jayif",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Humaidiya",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Ayn An Nasr",
				"salience": 0.0009692963,
				"type": "PERSON"
			},
			{
				"name": "Abu Arayis",
				"salience": 0.0009692963,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T11:10:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This Shi’ite militiamen announced they have launched their campaign to reach Tal Afar and cut off an escape route to Syria that is being used both by Islamic State militants and refugees. Still eager to insinuate Turkish troops into the Mosul campaign, Turkish President Recep Tayyip Erdoğan announced he would reinforce Turkish forces in the border town of Silopi. There, they will be ready to be deployed should he believe that Shi’ite militiamen are causing sectarian terror in Tal Afar , home to many Turkmen. In Mosul , witnesses say that thousands of human shields rounded up in the outskirts of the city are now clustered in central Mosul and are without food or shelter. Many of the displaced are women, children, or elderly and appear to be in poor condition after their forced marches. In other parts of the city, militants are rounding up former security personnel. Security forces say the town of Shura has been cleared of militants after a battle. A humanitarian corridor has been set up for civilians to relocate to nearby Qayara. The villages of Abu Arayis, Ayn An Nasr, Humaidiya, Jayif, Majman, Mukhalat, Mustanqa, Shruq, Tal Tayiba, and Zwirij were also liberated . Hamza, Haram, Mwaylaha,, Sajma, and San Zaban were freed as well. Several of these villages were captured by Shi’ite militia forces. At least 200 people were killed and 94 were wounded , including 10 P.K.K. guerrillas: The number of casualties in the Kirkuk assault that occurred just over a week ago was readjusted from previous estimates . The number of civilian and security personnel casualties rose by 17 dead and 65 wounded .",
		"thread_title": "200 Killed in Iraq; Shi’ite Militias Join Mosul Campaign",
		"title": "200 Killed in Iraq; Shi’ite Militias Join Mosul Campaign",
		"type": "bs",
		"uuid": "6bcec2f23def68e151ef6df800f1833819a0b90e"
	},
	"-KhIj2Mj8YH3_Ivltil7": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T03:20:00.429+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "prison",
				"salience": 0.32216856,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabian",
				"salience": 0.19759113,
				"type": "LOCATION"
			},
			{
				"name": "Attack",
				"salience": 0.055606645,
				"type": "EVENT"
			},
			{
				"name": "Targeting Procedures",
				"salience": 0.046653997,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.04055803,
				"type": "LOCATION"
			},
			{
				"name": "inmates",
				"salience": 0.04055803,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.037859164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/039_81",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Hudaydah"
				},
				"name": "Hodeidah",
				"salience": 0.025209429,
				"type": "LOCATION"
			},
			{
				"name": "others",
				"salience": 0.019538559,
				"type": "PERSON"
			},
			{
				"name": "warplanes",
				"salience": 0.016946014,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.016946014,
				"type": "PERSON"
			},
			{
				"name": "dozens",
				"salience": 0.016946014,
				"type": "PERSON"
			},
			{
				"name": "prisoners",
				"salience": 0.011778351,
				"type": "PERSON"
			},
			{
				"name": "Officials",
				"salience": 0.010507449,
				"type": "PERSON"
			},
			{
				"name": "prisoners",
				"salience": 0.010384269,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.008814276,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.008735541,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.008443296,
				"type": "EVENT"
			},
			{
				"name": "prison",
				"salience": 0.007967906,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.007288043,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0070484453,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.0070484453,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0068989894,
				"type": "EVENT"
			},
			{
				"name": "rubble",
				"salience": 0.006106644,
				"type": "OTHER"
			},
			{
				"name": "witnesses",
				"salience": 0.006106644,
				"type": "PERSON"
			},
			{
				"name": "rescue workers",
				"salience": 0.006106644,
				"type": "PERSON"
			},
			{
				"name": "guards",
				"salience": 0.005879446,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.004988348,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.0040743076,
				"type": "PERSON"
			},
			{
				"name": "prisoners",
				"salience": 0.0033725281,
				"type": "PERSON"
			},
			{
				"name": "roof",
				"salience": 0.0032442005,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.003137278,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.003137278,
				"type": "EVENT"
			},
			{
				"name": "civilians",
				"salience": 0.002717168,
				"type": "PERSON"
			},
			{
				"name": "standards",
				"salience": 0.002717168,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.002717168,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.0023444833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/047vsxx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houthis"
				},
				"name": "Houthi",
				"salience": 0.0022967407,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.0020303975,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.0020303975,
				"type": "ORGANIZATION"
			},
			{
				"name": "buildings",
				"salience": 0.0020303975,
				"type": "LOCATION"
			},
			{
				"name": "gates",
				"salience": 0.0020303975,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0014357738,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/08/yemen.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T03:20:00.429+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Officials Say Attack In Keeping With Targeting Procedures   \nMostly destroyed and no longer usable, the prison in the Yemeni city of Hodeidah held 84 inmates until Saturday, when Saudi Arabian warplanes repeatedly bombed it, killing at least 60 of the people within and wounding dozens of others. \nThe exact number of prisoners killed compared to guards is unknown, though prisoners are said to be the vast majority. The prison was leveled in the attack, according to witnesses, and rescue workers are still looking through the rubble, with others believed trapped within. \nThree airstrikes were targeted against the prison, with the first hitting it directly, bringing down the roof, and the follow-up attacks targeting the gates and the administration buildings. The Saudi coalition insisted the attacks were in keeping with targeting procedures, noting the prison was known to have Houthi security forces within. \nIt is unclear who the prisoners generally were at the prison, but deliberately attacking a prison will doubtless add to concerns about Saudi Arabia’s standards for airstrikes against Yemen, which have killed massive numbers of civilians over the past 19 months.  ",
		"thread_title": "Saudi Warplanes Repeatedly Bomb Yemen Prison, Killing 60",
		"title": "Saudi Warplanes Repeatedly Bomb Yemen Prison, Killing 60",
		"type": "bs",
		"uuid": "7fb2378cd3fe4b2d229078f1003dabd22d81f514"
	},
	"-KhIj2WTq1EW3jfEwsVO": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T03:20:00.491+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.30203986,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.1609349,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pentagon Downplays Situation",
				"salience": 0.1280424,
				"type": "OTHER"
			},
			{
				"name": "Losses Mount The Pentagon",
				"salience": 0.11997715,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.06318738,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g9zf5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Special_Inspector_General_for_Afghanistan_Reconstruction"
				},
				"name": "Special Inspector General for Afghanistan Reconstruction",
				"salience": 0.026162334,
				"type": "ORGANIZATION"
			},
			{
				"name": "narrative",
				"salience": 0.025165798,
				"type": "OTHER"
			},
			{
				"name": "losses",
				"salience": 0.023023872,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.019149657,
				"type": "OTHER"
			},
			{
				"name": "territory changes",
				"salience": 0.019149657,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05_5p5w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Second_Anglo-Afghan_War"
				},
				"name": "Afghan War",
				"salience": 0.011868067,
				"type": "EVENT"
			},
			{
				"name": "majority",
				"salience": 0.00918845,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.008791369,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07jqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taliban"
				},
				"name": "Taliban",
				"salience": 0.008249625,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.0047108885,
				"type": "WORK_OF_ART"
			},
			{
				"name": "notes",
				"salience": 0.0040814397,
				"type": "OTHER"
			},
			{
				"name": "percentages",
				"salience": 0.0036614197,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0034194244,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0033973386,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0033546472,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0033068594,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.0031837414,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.002990701,
				"type": "ORGANIZATION"
			},
			{
				"name": "influence",
				"salience": 0.0028644921,
				"type": "OTHER"
			},
			{
				"name": "indications",
				"salience": 0.0027578,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0027578,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0027009216,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0027009216,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0023394292,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.0023394292,
				"type": "PERSON"
			},
			{
				"name": "farmlands",
				"salience": 0.0020186969,
				"type": "LOCATION"
			},
			{
				"name": "farming",
				"salience": 0.0020186969,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0017932125,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.0017483599,
				"type": "LOCATION"
			},
			{
				"name": "cases",
				"salience": 0.0017483599,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0014708019,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contrast",
				"salience": 0.0014708019,
				"type": "OTHER"
			},
			{
				"name": "percentages",
				"salience": 0.001329958,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.0012737471,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.0012737471,
				"type": "ORGANIZATION"
			},
			{
				"name": "matter",
				"salience": 0.0012737471,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0012737471,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0012737471,
				"type": "OTHER"
			},
			{
				"name": "morale",
				"salience": 0.0012737471,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0012737471,
				"type": "PERSON"
			},
			{
				"name": "losses",
				"salience": 0.0010354538,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00095168105,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/07/afghan.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T03:20:00.491+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Pentagon Downplays Situation as Losses Mount   \nThe Pentagon’s narrative on the Afghan War tries to present the territory changes as brief, minor, and limited, repeatedly touting the fact that the Afghan government still controls the majority of the country. It’s a shrinking majority, however, as a new report from the Special Inspector General for Afghanistan Reconstruction (SIGAR) notes. \nSIGAR noted that the data from the Pentagon showed that the Afghan government actually controlled only about 63.4 percent of the country as of the end of August, the result of steady losses throughout the summer. All indications are that the losses have continued over the past two months as well. \nIf these numbers sound worse than those coming from the Pentagon, it’s because they are. Officially, the Pentagon’s percentages are based on “control or influence” of population, not physical territory held. These numbers tend to be higher, because most of the major cities are still controlled by the government, even if many are surrounded. \nPentagon officials have done this not only to have bigger percentages, but to downplay the losses, arguing that they are mostly in rural areas. While this is true, the reality is that Afghanistan is a heavily rural country, and strongly dependent on farming. The Taliban has aimed in many cases specifically at the farmlands, particularly in opium-producing regions, because those are so much more economically valuable for them. \nThe SIGAR report also cited major casualties among Afghan security forces as a matter of concern. Again, this was in stark contrast to Pentagon statements, which have insisted that morale among the still surviving troops remains strong  ",
		"thread_title": "US Inspector General: Afghan Govt Rapidly Lost Territory Over Summer",
		"title": "US Inspector General: Afghan Govt Rapidly Lost Territory Over Summer",
		"type": "bs",
		"uuid": "c3626b887cf4b37d916ace29554c0bcec657ecb3"
	},
	"-KhIj2f3zBuxFkS6W6xm": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T03:29:53.822+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Hadi",
				"salience": 0.72723,
				"type": "PERSON"
			},
			{
				"name": "peace deal",
				"salience": 0.04253178,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.02645887,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.014672593,
				"type": "EVENT"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.011445844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.011369438,
				"type": "LOCATION"
			},
			{
				"name": "installation",
				"salience": 0.01077986,
				"type": "EVENT"
			},
			{
				"name": "hope",
				"salience": 0.010645613,
				"type": "OTHER"
			},
			{
				"name": "peace process",
				"salience": 0.010645613,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.008995476,
				"type": "LOCATION"
			},
			{
				"name": "glimmer",
				"salience": 0.0089308405,
				"type": "OTHER"
			},
			{
				"name": "UN Deal Would Reward 'Putschists",
				"salience": 0.007592513,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.006590972,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0059107896,
				"type": "LOCATION"
			},
			{
				"name": "figurehead",
				"salience": 0.005466879,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.0051047397,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0050911144,
				"type": "ORGANIZATION"
			},
			{
				"name": "unity deal",
				"salience": 0.0046146535,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.00441593,
				"type": "OTHER"
			},
			{
				"name": "technocrats",
				"salience": 0.0044116196,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0035179695,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.003278027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035hr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Yemen"
				},
				"name": "South Yemen",
				"salience": 0.002705095,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.002606322,
				"type": "ORGANIZATION"
			},
			{
				"name": "putschist",
				"salience": 0.002606322,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fkqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ali_Abdullah_Saleh"
				},
				"name": "Ali Abdullah Saleh",
				"salience": 0.0024102214,
				"type": "PERSON"
			},
			{
				"name": "solution",
				"salience": 0.0020789988,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035mlt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Yemen"
				},
				"name": "North Yemen",
				"salience": 0.0020352253,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0020249938,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0020249938,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0019495377,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0018286848,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0017898169,
				"type": "EVENT"
			},
			{
				"name": "borders",
				"salience": 0.0016536766,
				"type": "LOCATION"
			},
			{
				"name": "backers",
				"salience": 0.0015838245,
				"type": "PERSON"
			},
			{
				"name": "deputy",
				"salience": 0.0015838245,
				"type": "PERSON"
			},
			{
				"name": "discussion",
				"salience": 0.0015838245,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0015838245,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0015838245,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0015247788,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0015247788,
				"type": "LOCATION"
			},
			{
				"name": "ruler",
				"salience": 0.0015247788,
				"type": "PERSON"
			},
			{
				"name": "continuation",
				"salience": 0.0014933029,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0013375399,
				"type": "EVENT"
			},
			{
				"name": "likelihood",
				"salience": 0.0012932837,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0012932837,
				"type": "LOCATION"
			},
			{
				"name": "split",
				"salience": 0.0012932837,
				"type": "EVENT"
			},
			{
				"name": "unification",
				"salience": 0.0012932837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.001251899,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.001235753,
				"type": "LOCATION"
			},
			{
				"name": "Shi'ite Houthis",
				"salience": 0.0010531137,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.00097440806,
				"type": "EVENT"
			},
			{
				"name": "allies",
				"salience": 0.0009663393,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.00090022705,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.00090022705,
				"type": "OTHER"
			},
			{
				"name": "measure",
				"salience": 0.0008195482,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0007039045,
				"type": "WORK_OF_ART"
			},
			{
				"name": "neighbor",
				"salience": 0.0007039045,
				"type": "PERSON"
			},
			{
				"name": "separation",
				"salience": 0.0007039045,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.0007039045,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00060727954,
				"type": "OTHER"
			},
			{
				"name": "south",
				"salience": 0.00060727954,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.00060727954,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.00052586664,
				"type": "OTHER"
			},
			{
				"name": "ambitions",
				"salience": 0.00043478358,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0003878893,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2011/02/syemen.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T03:29:53.822+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Hadi: UN Deal Would Reward 'Putschists' by Jason Ditz, October 30, 2016 Share This \nThe UN offered a glimmer of hope for a peace process 19 months in Yemen’s war last week, offering a peace deal which would see the installation of an interim government made of mostly technocrats, and in which former President Hadi would be a figurehead. \nHadi, on whose behalf Saudi invaded Yemen, was quick to spurn the deal, insisting it would “ reward the putschist s” and punish his legitimate government. Hadi was “elected” to a two-year term in office in early 2012, and resigned in 2015, but insists he remains the rightful ruler of the nation. \nThe Shi’ite Houthis, who had previously ruled out any deal in which Hadi was returned to power, expressed support for the UN plan as a “ basis for discussion .” The deal would force Hadi’s main deputy to resign, and give Hadi little to no real power. \nHadi’s rejection, assuming it is upheld by his Saudi backers, means a continuation of the war, and greatly increases the likelihood that Yemen as a unified nation is over. The nation is already in a state of de facto split, and roughly on the same borders as before the 1990 unification. \nThis may ultimately make more sense for Yemen at any rate, resolving long-standing secessionist ambitions in the south, and leaving Hadi with control of South Yemen, where he is from, and where his limited political support is centered. \nThe Saudis are unlikely to accept such a solution, however, as it would leave a North Yemen dominated by the Houthis and former president Ali Abdullah Saleh’s political allies with a substantial border with Saudi Arabia after a bloody Saudi-instigated war against them. \nWhile a unity deal in which Hadi gets only token power would allow the Saudis to claim some measure of “victory” in their war, a formal separation would be much harder to spin, and would leave them with a very resentful neighbor on their southern border. Last 5 posts by Jason Ditz",
		"thread_title": "Chances of Yemen Partition Grow as Pro-Saudi Faction Spurns UN Peace Deal",
		"title": "Chances of Yemen Partition Grow as Pro-Saudi Faction Spurns UN Peace Deal",
		"type": "bs",
		"uuid": "c5a1b28cc043550c92bb3f2c2e496b4689d405ee"
	},
	"-KhIj2nKOINMh-bTQVmz": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T04:00:33.969+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.26435256,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02nlkt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taiz"
				},
				"name": "Taiz",
				"salience": 0.14218685,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.12877935,
				"type": "EVENT"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03914718,
				"type": "PERSON"
			},
			{
				"name": "airstrike",
				"salience": 0.03643342,
				"type": "PERSON"
			},
			{
				"name": "Burned Farms",
				"salience": 0.031139655,
				"type": "LOCATION"
			},
			{
				"name": "Attacks Destroyed Villagers' Homes",
				"salience": 0.028805079,
				"type": "ORGANIZATION"
			},
			{
				"name": "blockade",
				"salience": 0.025865233,
				"type": "OTHER"
			},
			{
				"name": "villagers",
				"salience": 0.019363727,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.018191371,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.017501168,
				"type": "PERSON"
			},
			{
				"name": "strikes",
				"salience": 0.01517359,
				"type": "EVENT"
			},
			{
				"name": "prison",
				"salience": 0.01517359,
				"type": "LOCATION"
			},
			{
				"name": "dozens",
				"salience": 0.01517359,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.014186912,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0102681415,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/039_81",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Hudaydah"
				},
				"name": "Hodeidah",
				"salience": 0.009368084,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09pcdk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ma'rib_Governorate"
				},
				"name": "Maarib Province",
				"salience": 0.009368084,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.008145953,
				"type": "EVENT"
			},
			{
				"name": "criticism",
				"salience": 0.0071640047,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.0067185927,
				"type": "LOCATION"
			},
			{
				"name": "injuries",
				"salience": 0.0063027143,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.006168945,
				"type": "OTHER"
			},
			{
				"name": "farmland",
				"salience": 0.006168945,
				"type": "LOCATION"
			},
			{
				"name": "injuries",
				"salience": 0.006068141,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.005890261,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0058647054,
				"type": "OTHER"
			},
			{
				"name": "villagers",
				"salience": 0.005700334,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.005459855,
				"type": "LOCATION"
			},
			{
				"name": "access",
				"salience": 0.005459855,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.005459855,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.005256558,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.005148177,
				"type": "OTHER"
			},
			{
				"name": "farmland",
				"salience": 0.004611759,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0044593243,
				"type": "LOCATION"
			},
			{
				"name": "long run",
				"salience": 0.0044593243,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cp1wb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maariv"
				},
				"name": "Maarib",
				"salience": 0.0038837697,
				"type": "LOCATION"
			},
			{
				"name": "hospitals",
				"salience": 0.0033753456,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09pcp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sa'dah"
				},
				"name": "Saada",
				"salience": 0.0033637797,
				"type": "LOCATION"
			},
			{
				"name": "numbers",
				"salience": 0.0033606805,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.0033328733,
				"type": "EVENT"
			},
			{
				"name": "air war",
				"salience": 0.0033328733,
				"type": "EVENT"
			},
			{
				"name": "nation",
				"salience": 0.0033328733,
				"type": "LOCATION"
			},
			{
				"name": "food insecurity",
				"salience": 0.0033328733,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0028038563,
				"type": "PERSON"
			},
			{
				"name": "Most",
				"salience": 0.0026872598,
				"type": "PERSON"
			},
			{
				"name": "improvements",
				"salience": 0.0025544818,
				"type": "OTHER"
			},
			{
				"name": "farmland",
				"salience": 0.0025113598,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0024282555,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0024282555,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0024282555,
				"type": "WORK_OF_ART"
			},
			{
				"name": "homes",
				"salience": 0.0023202251,
				"type": "LOCATION"
			},
			{
				"name": "food",
				"salience": 0.0020950914,
				"type": "OTHER"
			},
			{
				"name": "imports",
				"salience": 0.0018143385,
				"type": "OTHER"
			},
			{
				"name": "circumstances",
				"salience": 0.0018143385,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0018143385,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/08/yemen.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T04:00:33.969+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Attacks Destroyed Villagers' Homes, Burned Farms by Jason Ditz, October 30, 2016 Share This \nWhile the biggest single Saudi airstrike over the weekend in Yemen targeted a prison in Hodeidah, dozens of other strikes were reported over the weekend by villagers around Taiz and in the Maarib Province, with attacks killing at least 27 civilians , and wounding a number of others. \nMost of the casualties were in Taiz, where attacks destroyed several homes and caused a large number of injuries. With hospitals in the area having very limited access to medicine because of the naval blockade, many of those injuries proved fatal. \nThe attacks in Maarib and Saada, however, may prove more devastating to the country in the long run, targeting some of the very limited farmland Yemen has, destroying a number of villagers’ homes and burning a lot of that farmland. Yemen has to import some 90 percent of its food under normal circumstances, with such imports severely limited by the blockade, and the loss of farmland just adds to food insecurity in the nation. \nSaudi Arabia has been coming under growing international criticism for its air war against Yemen, with massive numbers of civilians killed and little sign that the promised improvements to targeting will ever amount to anything. Last 5 posts by Jason Ditz",
		"thread_title": "27 Civilians Killed in Saudi Airstrikes Against Yemen Villages",
		"title": "27 Civilians Killed in Saudi Airstrikes Against Yemen Villages",
		"type": "bs",
		"uuid": "b8f07f358648a276ffbcd961f48151d3e6ae9652"
	},
	"-KhIj2wz6KkaK-0TZ0fv": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T04:47:40.442+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.1615102,
				"type": "LOCATION"
			},
			{
				"name": "coalition",
				"salience": 0.16142915,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.07299025,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.050783597,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.047752816,
				"type": "PERSON"
			},
			{
				"name": "Rebels Continue Offensive Against Western Aleppo",
				"salience": 0.033764362,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.032984793,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h3xpcx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Free_Syrian_Army"
				},
				"name": "Free Syrian Army",
				"salience": 0.02928682,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.02928682,
				"type": "ORGANIZATION"
			},
			{
				"name": "offensive",
				"salience": 0.027138118,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.02273483,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.022674331,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.019861491,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.019656043,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.019304078,
				"type": "PERSON"
			},
			{
				"name": "sieges",
				"salience": 0.011853756,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.011625056,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.011013889,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.010707019,
				"type": "PERSON"
			},
			{
				"name": "use",
				"salience": 0.010071766,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.010071766,
				"type": "OTHER"
			},
			{
				"name": "offensives",
				"salience": 0.009413986,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.009275948,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.008764343,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.008592378,
				"type": "ORGANIZATION"
			},
			{
				"name": "offensive",
				"salience": 0.007987076,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.007856516,
				"type": "EVENT"
			},
			{
				"name": "siege",
				"salience": 0.0073801507,
				"type": "EVENT"
			},
			{
				"name": "fighting",
				"salience": 0.007068705,
				"type": "EVENT"
			},
			{
				"name": "gas",
				"salience": 0.007068705,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.007068705,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007068705,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.006805421,
				"type": "OTHER"
			},
			{
				"name": "shells",
				"salience": 0.006805421,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.006805421,
				"type": "ORGANIZATION"
			},
			{
				"name": "half",
				"salience": 0.0066650626,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hr9tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Observatory_for_Human_Rights"
				},
				"name": "Syrian Observatory for Human Rights",
				"salience": 0.004354443,
				"type": "ORGANIZATION"
			},
			{
				"name": "brunt",
				"salience": 0.0043144263,
				"type": "OTHER"
			},
			{
				"name": "combatants",
				"salience": 0.0043144263,
				"type": "PERSON"
			},
			{
				"name": "casualties",
				"salience": 0.0043144263,
				"type": "OTHER"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0043144263,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0041920897,
				"type": "LOCATION"
			},
			{
				"name": "artillery attacks",
				"salience": 0.0036294968,
				"type": "EVENT"
			},
			{
				"name": "weapons",
				"salience": 0.0036294968,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0031432246,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.0031432246,
				"type": "EVENT"
			},
			{
				"name": "ones",
				"salience": 0.0031432246,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.0031432246,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0031432246,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rockets",
				"salience": 0.0031432246,
				"type": "OTHER"
			},
			{
				"name": "trading sieges",
				"salience": 0.0030033672,
				"type": "EVENT"
			},
			{
				"name": "anothers",
				"salience": 0.0023484626,
				"type": "PERSON"
			},
			{
				"name": "strikes",
				"salience": 0.0023484626,
				"type": "EVENT"
			},
			{
				"name": "counter-offensives",
				"salience": 0.0023484626,
				"type": "EVENT"
			},
			{
				"name": "rebel faction",
				"salience": 0.0023484626,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0023484626,
				"type": "ORGANIZATION"
			},
			{
				"name": "sides",
				"salience": 0.0022042398,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T04:47:40.442+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Rebels Continue Offensive Against Western Aleppo by Jason Ditz, October 30, 2016 Share This \nA coalition of rebels including al-Qaeda’s-Nusra Front and the Free Syrian Army are continuing their offensive against the government-held western half of Aleppo . The UN harshly criticized them for their use of “ indiscriminate ” weapons, warning it could amount to war crimes. \nPerhaps the biggest issue, though as-yet-unproven, is reports that the rebels have begun to use chlorine-filled shells in their attacks. Syrian media reported 35 civilians were suffering from effects of the toxic gas, though the rebels denied using them. \nThe Syrian Observatory for Human Rights reported at least 21 people killed over the weekend, amid heavy fighting around western Aleppo. The offensive began Friday, with the Nusra-led rebels trying to end a siege of their eastern half of the city. \nThis has been a recurring situation in Aleppo since it boiled down to just the military and this rebel faction, with both sides having repeatedly launched offensives and counter-offensives over the last several months, trading sieges and strikes against one anothers’ neighborhoods. \nThis has resulted in heavy casualties for the civilians stuck in the city, facing regular sieges that they are rarely as able to survive as the combatants, and taking the brunt of the rockets, airstrikes, and artillery attacks. The addition of chemical weapons, even primitive ones, threaten to make the matter far worse. Last 5 posts by Jason Ditz",
		"thread_title": "UN Slams Aleppo Rebels Amid Accused Poison Gas Attacks",
		"title": "UN Slams Aleppo Rebels Amid Accused Poison Gas Attacks",
		"type": "bs",
		"uuid": "158b58028ecf2258f2530d27842c51b959074e3e"
	},
	"-KhIj38I2QHudit40Olu": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T04:56:08.749+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.15100889,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.12174547,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.10134004,
				"type": "LOCATION"
			},
			{
				"name": "militia groups",
				"salience": 0.08570772,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.047106866,
				"type": "LOCATION"
			},
			{
				"name": "invasion",
				"salience": 0.046927556,
				"type": "EVENT"
			},
			{
				"name": "Block ISIS Escape",
				"salience": 0.0454264,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.035138197,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.032686528,
				"type": "EVENT"
			},
			{
				"name": "Deployment",
				"salience": 0.03187889,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shi'ite",
				"salience": 0.03121057,
				"type": "OTHER"
			},
			{
				"name": "escape",
				"salience": 0.018736785,
				"type": "OTHER"
			},
			{
				"name": "militias",
				"salience": 0.015690332,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.013561704,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.013561704,
				"type": "LOCATION"
			},
			{
				"name": "west",
				"salience": 0.013561704,
				"type": "OTHER"
			},
			{
				"name": "ambition",
				"salience": 0.013474335,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.011777805,
				"type": "LOCATION"
			},
			{
				"name": "escape",
				"salience": 0.011386225,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.008393001,
				"type": "OTHER"
			},
			{
				"name": "militias",
				"salience": 0.007593042,
				"type": "PERSON"
			},
			{
				"name": "militias",
				"salience": 0.0073103746,
				"type": "PERSON"
			},
			{
				"name": "fight",
				"salience": 0.006942939,
				"type": "EVENT"
			},
			{
				"name": "militias",
				"salience": 0.0062018437,
				"type": "PERSON"
			},
			{
				"name": "wars",
				"salience": 0.005624318,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni Arab",
				"salience": 0.0055840863,
				"type": "ORGANIZATION"
			},
			{
				"name": "recruitment",
				"salience": 0.004871452,
				"type": "OTHER"
			},
			{
				"name": "spike",
				"salience": 0.004871452,
				"type": "EVENT"
			},
			{
				"name": "locals",
				"salience": 0.004871452,
				"type": "PERSON"
			},
			{
				"name": "abandon",
				"salience": 0.004689895,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.004689895,
				"type": "LOCATION"
			},
			{
				"name": "involvement",
				"salience": 0.004689895,
				"type": "OTHER"
			},
			{
				"name": "captures",
				"salience": 0.004689895,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0045931097,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0045931097,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0045931097,
				"type": "ORGANIZATION"
			},
			{
				"name": "many",
				"salience": 0.0045931097,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0045150914,
				"type": "PERSON"
			},
			{
				"name": "blurring",
				"salience": 0.003978042,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.003978042,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.003978042,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.003978042,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.00343241,
				"type": "PERSON"
			},
			{
				"name": "territory",
				"salience": 0.002997388,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.002997388,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.002972572,
				"type": "EVENT"
			},
			{
				"name": "reality",
				"salience": 0.002972572,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.002782523,
				"type": "PERSON"
			},
			{
				"name": "militias",
				"salience": 0.0025235694,
				"type": "PERSON"
			},
			{
				"name": "escape",
				"salience": 0.0022395425,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0021654011,
				"type": "OTHER"
			},
			{
				"name": "alternatives",
				"salience": 0.0021654011,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0021654011,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0021133919,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0018681911,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.0016177635,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0016177635,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0016177635,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T04:56:08.749+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Deployment Meant to Block ISIS Escape by Jason Ditz, October 30, 2016 Share This \nAs the Iraqi invasion of Mosul continues, the Shi’ite militia groups who have proven so controversial in previous attacks have begun to deploy west of the city, aiming to block the escape of any ISIS forces into Syria. The militias see this as the last real fight against ISIS inside Iraq, and are openly talking about heading into Syria next . \nWhile the militias’ involvement in previous captures of major Sunni Arab cities around Iraq has seen them looting, torturing, and killing with reckless abandon, the militias’ ambition to get into Syria once this is wrapped up may mean less are left behind around Mosul to harass the locals. \nThe sectarian nature of the wars in Iraq and Syria have both led to a spike in recruitment for the Shi’ite militias, with many being deployed around significant religious sites in both countries to protect them from groups like ISIS. For many of them, this has also meant a blurring of the lines between the two wars. \nThere remains considerable concern about the impact on the Mosul population of the militias’ presence. This is doubly true because, in “blocking” ISIS escape, they may also end up blocking the escape of the civilian population,. which is unlikely to be welcomed if they flee into Kurdish territory. \nThat’s also a recurring reality in Iraq’s war, that the Sunni Arab civilians aren’t welcomed into Kurdish or Shi’ite territory, and generally end up having to flee into other ISIS territory for lack of alternatives. With little ISIS territory left, it is unclear where they’ll go. Last 5 posts by Jason Ditz",
		"thread_title": "Shi’ite Militias Enter Mosul Battle, But Eyes Are on Joining Syria War",
		"title": "Shi’ite Militias Enter Mosul Battle, But Eyes Are on Joining Syria War",
		"type": "bs",
		"uuid": "bad9a82686d77e09db7813e71ef4c88136c58a94"
	},
	"-KhIj3HjbmPgPXEUUmHB": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T06:59:04.101+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.29102653,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.13279912,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.12818795,
				"type": "LOCATION"
			},
			{
				"name": "fighting",
				"salience": 0.06488781,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.06363921,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.04640777,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.039399445,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hr9tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Observatory_for_Human_Rights"
				},
				"name": "Syrian Observatory for Human Rights",
				"salience": 0.03322635,
				"type": "ORGANIZATION"
			},
			{
				"name": "Locals",
				"salience": 0.032169472,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.02235058,
				"type": "LOCATION"
			},
			{
				"name": "brigade",
				"salience": 0.009946979,
				"type": "PERSON"
			},
			{
				"name": "cubs",
				"salience": 0.009946979,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.009298277,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.008887553,
				"type": "PERSON"
			},
			{
				"name": "fighting",
				"salience": 0.0085571995,
				"type": "EVENT"
			},
			{
				"name": "casualties",
				"salience": 0.008061572,
				"type": "OTHER"
			},
			{
				"name": "gains",
				"salience": 0.0069843135,
				"type": "OTHER"
			},
			{
				"name": "minor",
				"salience": 0.0069843135,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0069843135,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.006724442,
				"type": "LOCATION"
			},
			{
				"name": "loss",
				"salience": 0.006724442,
				"type": "EVENT"
			},
			{
				"name": "caliphate",
				"salience": 0.006724442,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.0066464734,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.00570521,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0054480205,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.0048447927,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02wz61q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daquq"
				},
				"name": "Daquq",
				"salience": 0.0041438546,
				"type": "LOCATION"
			},
			{
				"name": "numbers",
				"salience": 0.0038539676,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.003805483,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g2vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Observatory"
				},
				"name": "Observatory",
				"salience": 0.0035307568,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0032138696,
				"type": "PERSON"
			},
			{
				"name": "auxiliaries",
				"salience": 0.0031075538,
				"type": "ORGANIZATION"
			},
			{
				"name": "casualties",
				"salience": 0.0026813112,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0019135312,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.0011861189,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T06:59:04.101+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nAccording to the Syrian Observatory for Human Rights, around 300 Syrian children, recruited as child soldiers by ISIS, have been killed over the past two weeks in fighting in and around the Iraqi city of Mosul. The brigade is called the “cubs of the caliphate.” \nLocals reported that the loss of children in fighting around the Syrian town of Daquq was spun by ISIS religious leaders as minor compared to the gains they would secure in Mosul. The fighting is fierce around Mosul, and the casualties are high. \nThe Observatory said that at least 480 Syrian fighters had been killed in fighting around the Mosul area since the fighting began two weeks ago. This means that a strong majority of those casualties were actually children. \nThe US has claimed they believe between 800 and 900 fighters have been killed overall around Mosul. This indicates that the fighting outside of Mosul is heavily between invading Iraqi forces and ISIS’ Syrian auxiliaries. Large numbers of ISIS fighters are believed to have remained within Mosul, preparing to defend the city itself.  ",
		"thread_title": "Syrian Observatory: 300 ISIS Child Soldiers Killed in Past Two Weeks Around Mosul",
		"title": "Syrian Observatory: 300 ISIS Child Soldiers Killed in Past Two Weeks Around Mosul",
		"type": "bs",
		"uuid": "1bacee510e70c753681b51ef3876ae297dac1ee5"
	},
	"-KhIj3SXbu3KlQFwlLSm": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T06:59:04.184+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/051wzv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Badr_Organization"
				},
				"name": "Badr Brigade",
				"salience": 0.54523396,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.11622022,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.05681445,
				"type": "LOCATION"
			},
			{
				"name": "MP",
				"salience": 0.02884704,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.02884704,
				"type": "OTHER"
			},
			{
				"name": "Battle Lasts",
				"salience": 0.022826338,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.017920043,
				"type": "PERSON"
			},
			{
				"name": "Amiri",
				"salience": 0.016385706,
				"type": "PERSON"
			},
			{
				"name": "militia",
				"salience": 0.01388599,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.012257413,
				"type": "PERSON"
			},
			{
				"name": "invasion",
				"salience": 0.012042314,
				"type": "EVENT"
			},
			{
				"name": "expectations",
				"salience": 0.012042314,
				"type": "OTHER"
			},
			{
				"name": "caution",
				"salience": 0.012042314,
				"type": "OTHER"
			},
			{
				"name": "Population Mobilization Forces",
				"salience": 0.009499986,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.007439632,
				"type": "LOCATION"
			},
			{
				"name": "battle",
				"salience": 0.0071663936,
				"type": "EVENT"
			},
			{
				"name": "battle",
				"salience": 0.0063973027,
				"type": "EVENT"
			},
			{
				"name": "battle",
				"salience": 0.00522724,
				"type": "EVENT"
			},
			{
				"name": "picnic",
				"salience": 0.0051772264,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0050308118,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08s2km",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hadi_Al-Amiri"
				},
				"name": "Hadi al-Amiri",
				"salience": 0.0049898615,
				"type": "PERSON"
			},
			{
				"name": "timetable",
				"salience": 0.0045287395,
				"type": "OTHER"
			},
			{
				"name": "precision",
				"salience": 0.0043378016,
				"type": "OTHER"
			},
			{
				"name": "breath",
				"salience": 0.0043378016,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.004090318,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.004090318,
				"type": "PERSON"
			},
			{
				"name": "predictions",
				"salience": 0.0035432824,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0035325936,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.0033858928,
				"type": "LOCATION"
			},
			{
				"name": "militia forces",
				"salience": 0.0033858928,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighting",
				"salience": 0.0026485594,
				"type": "EVENT"
			},
			{
				"name": "intention",
				"salience": 0.0026485594,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.002228292,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0021829328,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.0021829328,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0018440377,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0016651503,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0016312385,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.0014420566,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T06:59:04.184+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.4,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Insists Badr Brigade Prepared Even if Battle Lasts Months by Jason Ditz, October 30, 2016 Share This \nA powerful MP as well as the head of the Badr Brigade, the largest militia within Iraq’s “Population Mobilization Forces,” Hadi al-Amiri expressed caution about expectations of a quick invasion of the city of Mosul, which is ISIS’ largest city. \n“The battle of Mosul will not be a picnic. It needs time, it needs precision, it needs a deep breath,” Amiri insisted, adding that his Badr Brigade is prepared to continue with the battle even if it lasts for several months. And well it might. \nThough US officials initially presented the battle as having a timetable of weeks, Kurdish officials responded with predictions it would last multiple months. Indeed, nearly two weeks into the attack, the invading forces are still several kilometers from Mosul, and not expected to enter the city for some time. \nSome of the militia forces involved in the fighting over Mosul are openly talking about their intention to join the Syrian war as soon as Mosul is finished, suggesting they may be looking beyond what is expected to be by far the largest battle of the war.  ",
		"thread_title": "Iraqi Militia Leader: Mosul Battle Won’t Be a Picnic",
		"title": "Iraqi Militia Leader: Mosul Battle Won’t Be a Picnic",
		"type": "bs",
		"uuid": "ce6c1bd072de6c22d1fbc798c14b3042fb509403"
	},
	"-KhIj3nEgehcnxwJxBH5": {
		"author": "Ray McGovern",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T09:24:20.546+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.40326482,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.18538599,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.088491224,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.042980067,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.023460176,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.016862737,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.015412119,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.010114068,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02n670",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sergey_Lavrov"
				},
				"name": "Sergey Lavrov",
				"salience": 0.00985171,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02bp17",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Director_of_National_Intelligence"
				},
				"name": "National Intelligence Director",
				"salience": 0.009142264,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0078025837,
				"type": "OTHER"
			},
			{
				"name": "saber-rattling",
				"salience": 0.00651337,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.006506819,
				"type": "PERSON"
			},
			{
				"name": "distrust",
				"salience": 0.0056429417,
				"type": "OTHER"
			},
			{
				"name": "trust",
				"salience": 0.0056429417,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.004498702,
				"type": "LOCATION"
			},
			{
				"name": "results",
				"salience": 0.0042725513,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0039932327,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.003689667,
				"type": "EVENT"
			},
			{
				"name": "resort",
				"salience": 0.0033320282,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.003145133,
				"type": "PERSON"
			},
			{
				"name": "agreements",
				"salience": 0.0031276545,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0028859233,
				"type": "PERSON"
			},
			{
				"name": "grace",
				"salience": 0.0028859233,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0028859233,
				"type": "OTHER"
			},
			{
				"name": "zenith",
				"salience": 0.0028859233,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0024790468,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04bcnk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Friedman"
				},
				"name": "George Friedman",
				"salience": 0.002231332,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02q42m1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_R._Clapper"
				},
				"name": "James Clapper",
				"salience": 0.0020806454,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0119g4rv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Major_general_(United_States)"
				},
				"name": "Maj. Gen.",
				"salience": 0.0020030467,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0019316898,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02sn34",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kiev"
				},
				"name": "Kiev",
				"salience": 0.0018950285,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04kch_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ash_Carter"
				},
				"name": "Ashton Carter",
				"salience": 0.001753241,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/089zlv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Frank-Walter_Steinmeier"
				},
				"name": "Frank-Walter Steinmeier",
				"salience": 0.0017473736,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0016482782,
				"type": "LOCATION"
			},
			{
				"name": "defense ministry",
				"salience": 0.0015527998,
				"type": "PERSON"
			},
			{
				"name": "agreements",
				"salience": 0.0014441316,
				"type": "OTHER"
			},
			{
				"name": "presidents",
				"salience": 0.0014207336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0m465",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sochi"
				},
				"name": "Sochi",
				"salience": 0.001415728,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015h7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Sea"
				},
				"name": "Black Sea",
				"salience": 0.001415728,
				"type": "LOCATION"
			},
			{
				"name": "meeting",
				"salience": 0.0013727393,
				"type": "EVENT"
			},
			{
				"name": "air defenses",
				"salience": 0.0013003219,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cl7x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Victoria_Nuland"
				},
				"name": "Victoria Nuland",
				"salience": 0.0012692567,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04bcmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stratfor"
				},
				"name": "STRATFOR",
				"salience": 0.0012692567,
				"type": "ORGANIZATION"
			},
			{
				"name": "statements",
				"salience": 0.0012518013,
				"type": "OTHER"
			},
			{
				"name": "air defense",
				"salience": 0.0012518013,
				"type": "OTHER"
			},
			{
				"name": "air force",
				"salience": 0.0012310884,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0012310884,
				"type": "OTHER"
			},
			{
				"name": "coalition aircraft",
				"salience": 0.0012310884,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0012310884,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "compromises",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.0011887433,
				"type": "EVENT"
			},
			{
				"name": "practice",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "military machine",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "assurances",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "contacts",
				"salience": 0.0011887433,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0011887433,
				"type": "ORGANIZATION"
			},
			{
				"name": "aircraft",
				"salience": 0.0011851492,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00117022,
				"type": "OTHER"
			},
			{
				"name": "aircraft",
				"salience": 0.0011554788,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06l9s7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ray_McGovern"
				},
				"name": "Ray McGovern",
				"salience": 0.001144079,
				"type": "PERSON"
			},
			{
				"name": "aircraft",
				"salience": 0.0011123589,
				"type": "OTHER"
			},
			{
				"name": "defense ministers",
				"salience": 0.001061604,
				"type": "PERSON"
			},
			{
				"name": "battalion task force",
				"salience": 0.0010050723,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0009625679,
				"type": "OTHER"
			},
			{
				"name": "generals",
				"salience": 0.0009266426,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d3k14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy"
				},
				"name": "Kennedy",
				"salience": 0.0009244924,
				"type": "PERSON"
			},
			{
				"name": "Relations",
				"salience": 0.0008954924,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.000870328,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0008658359,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00084247725,
				"type": "ORGANIZATION"
			},
			{
				"name": "claim",
				"salience": 0.0008335188,
				"type": "OTHER"
			},
			{
				"name": "blue",
				"salience": 0.0008335188,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0008335188,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0008335188,
				"type": "OTHER"
			},
			{
				"name": "warnings",
				"salience": 0.0008335188,
				"type": "OTHER"
			},
			{
				"name": "equation",
				"salience": 0.0008335188,
				"type": "OTHER"
			},
			{
				"name": "volatility",
				"salience": 0.0008335188,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0008335188,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00080738345,
				"type": "ORGANIZATION"
			},
			{
				"name": "scores",
				"salience": 0.00080240733,
				"type": "OTHER"
			},
			{
				"name": "army positions",
				"salience": 0.00080240733,
				"type": "OTHER"
			},
			{
				"name": "cease-fire",
				"salience": 0.00080240733,
				"type": "EVENT"
			},
			{
				"name": "coalition air strikes",
				"salience": 0.00080240733,
				"type": "EVENT"
			},
			{
				"name": "paranoia",
				"salience": 0.00080240733,
				"type": "OTHER"
			},
			{
				"name": "TV viewers",
				"salience": 0.00080240733,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.00080240733,
				"type": "PERSON"
			},
			{
				"name": "nadir",
				"salience": 0.00080240733,
				"type": "OTHER"
			},
			{
				"name": "gauntlet",
				"salience": 0.00080240733,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.00080240733,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.00080240733,
				"type": "OTHER"
			},
			{
				"name": "prime minister",
				"salience": 0.00079307455,
				"type": "PERSON"
			},
			{
				"name": "myth",
				"salience": 0.0007858237,
				"type": "OTHER"
			},
			{
				"name": "summit meeting",
				"salience": 0.0007858237,
				"type": "EVENT"
			},
			{
				"name": "resort",
				"salience": 0.0007858237,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "Air Force",
				"salience": 0.00075780746,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0007508351,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0007508351,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0007388067,
				"type": "PERSON"
			},
			{
				"name": "news outlets",
				"salience": 0.000725001,
				"type": "WORK_OF_ART"
			},
			{
				"name": "battalion",
				"salience": 0.00071957987,
				"type": "PERSON"
			},
			{
				"name": "coup",
				"salience": 0.0007037695,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0007037695,
				"type": "EVENT"
			},
			{
				"name": "alliance leaders",
				"salience": 0.0006804595,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.0006804595,
				"type": "PERSON"
			},
			{
				"name": "capital",
				"salience": 0.0006804595,
				"type": "LOCATION"
			},
			{
				"name": "brigade combat team",
				"salience": 0.0006804595,
				"type": "ORGANIZATION"
			},
			{
				"name": "deterrence",
				"salience": 0.0006804595,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0006804595,
				"type": "OTHER"
			},
			{
				"name": "recording",
				"salience": 0.0005918609,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0005776042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Polish",
				"salience": 0.0005515143,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.00054683664,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.00054683664,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.00053568854,
				"type": "LOCATION"
			},
			{
				"name": "Valdai Conference",
				"salience": 0.00053568854,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00052695465,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0005195755,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0005130276,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0005130276,
				"type": "LOCATION"
			},
			{
				"name": "putsch",
				"salience": 0.0005083066,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0005083066,
				"type": "OTHER"
			},
			{
				"name": "circumstances",
				"salience": 0.0005083066,
				"type": "OTHER"
			},
			{
				"name": "coup government",
				"salience": 0.0005083066,
				"type": "ORGANIZATION"
			},
			{
				"name": "choice",
				"salience": 0.0005083066,
				"type": "OTHER"
			},
			{
				"name": "coup d'état",
				"salience": 0.0005083066,
				"type": "ORGANIZATION"
			},
			{
				"name": "ambassador",
				"salience": 0.0005083066,
				"type": "PERSON"
			},
			{
				"name": "reaction",
				"salience": 0.0005083066,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.0005083066,
				"type": "OTHER"
			},
			{
				"name": "diet",
				"salience": 0.0005083066,
				"type": "OTHER"
			},
			{
				"name": "stealth aircraft",
				"salience": 0.00050038256,
				"type": "OTHER"
			},
			{
				"name": "associate",
				"salience": 0.00047350596,
				"type": "PERSON"
			},
			{
				"name": "reporters",
				"salience": 0.00045926275,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06kk0d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sam_Adams_(Oregon_politician)"
				},
				"name": "Sam Adams",
				"salience": 0.0004382467,
				"type": "PERSON"
			},
			{
				"name": "Igor Konashenkov",
				"salience": 0.00042956322,
				"type": "PERSON"
			},
			{
				"name": "permission",
				"salience": 0.00042752002,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081m_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Warsaw"
				},
				"name": "Warsaw",
				"salience": 0.0004188037,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03h47r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2nd_Cavalry_Regiment_(United_States)"
				},
				"name": "2nd Cavalry Regiment",
				"salience": 0.0004188037,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0004188037,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.00041197496,
				"type": "LOCATION"
			},
			{
				"name": "associates",
				"salience": 0.00041184618,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.00040971983,
				"type": "OTHER"
			},
			{
				"name": "hype",
				"salience": 0.00037018573,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00037018573,
				"type": "OTHER"
			},
			{
				"name": "analyst",
				"salience": 0.00037018573,
				"type": "PERSON"
			},
			{
				"name": "standard",
				"salience": 0.00037018573,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00037018573,
				"type": "OTHER"
			},
			{
				"name": "lesson",
				"salience": 0.00037018573,
				"type": "OTHER"
			},
			{
				"name": "awardees",
				"salience": 0.00037018573,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.00037018573,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00037018573,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02q86vg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arseniy_Yatsenyuk"
				},
				"name": "Arseniy Yatsenyuk",
				"salience": 0.00036128852,
				"type": "PERSON"
			},
			{
				"name": "Yats",
				"salience": 0.00036128852,
				"type": "OTHER"
			},
			{
				"name": "pretexts",
				"salience": 0.00035796355,
				"type": "OTHER"
			},
			{
				"name": "military units",
				"salience": 0.00035369894,
				"type": "ORGANIZATION"
			},
			{
				"name": "confrontation",
				"salience": 0.00035369894,
				"type": "EVENT"
			},
			{
				"name": "Myth",
				"salience": 0.0003359665,
				"type": "OTHER"
			},
			{
				"name": "saber-rattling",
				"salience": 0.00031934594,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.00031934594,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.00031934594,
				"type": "LOCATION"
			},
			{
				"name": "pretexts",
				"salience": 0.00031934594,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.00031283463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ndwhc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimea"
				},
				"name": "Crimea",
				"salience": 0.00031283463,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05f5rkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sam_Adams_Award"
				},
				"name": "Sam Adams Associates for Integrity in Intelligence",
				"salience": 0.00029141415,
				"type": "PERSON"
			},
			{
				"name": "defense budgets",
				"salience": 0.0002765161,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.0002765161,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.0002765161,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0002765161,
				"type": "OTHER"
			},
			{
				"name": "military threat",
				"salience": 0.0002765161,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0002765161,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07pkw84"
				},
				"name": "Communist",
				"salience": 0.00026310948,
				"type": "PERSON"
			},
			{
				"name": "military posturing",
				"salience": 0.00022860548,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n0qv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Baltimore_Sun"
				},
				"name": "Baltimore Sun",
				"salience": 0.00022782078,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00022782078,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00022782078,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0274prg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East/West"
				},
				"name": "East-West",
				"salience": 0.00021767351,
				"type": "WORK_OF_ART"
			},
			{
				"name": "set",
				"salience": 0.00019385132,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00017964446,
				"type": "OTHER"
			},
			{
				"name": "infrastructure",
				"salience": 0.00017964446,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T09:24:20.546+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nHow did the \"growing trust\" that Russian President Vladimir Putin once said marked his \"working and personal relationship with President Obama \" change into today’s deep distrust and saber-rattling? \nTheir relationship reached its zenith after Mr. Putin persuaded Syria to give up its chemical weapons for verified destruction, enabling Mr. Obama at the last minute to call off, with some grace, plans to attack Syria in late summer 2013. But at an international conference in the Russian Black Sea resort of Sochi last week, Mr. Putin spoke of the \"feverish\" state of international relations and lamented: \"My personal agreements with the President of the United States have not produced results.\" He complained about \"people in Washington ready to do everything possible to prevent these agreements from being implemented in practice\" and, referring to Syria, decried the lack of a \"common front against terrorism after such lengthy negotiations, enormous effort, and difficult compromises.\" \nA month earlier, Russian Foreign Minister Sergey Lavrov , who chooses his words carefully, told Russian TV viewers, \"My good friend John Kerry … is under fierce criticism from the U.S. military machine. Despite [Mr. Kerry’s] assurances that the US commander in chief, President Barack Obama, supported him in his contacts with Russia (he confirmed that during his meeting with President Vladimir Putin) apparently the military does not really listen to the commander in chief.\" \nDo not chalk this up to paranoia. The U.S.-led coalition air strikes on known Syrian army positions killing scores of troops just five days into the September cease-fire – not to mention statements at the time by the most senior US generals – were evidence enough to convince the Russians that the Pentagon was intent on scuttling meaningful cooperation with Russia. \nRelations between the US and Russian presidents have now reached a nadir, and Mr. Putin has ordered his own defense ministry to throw down the gauntlet. On Oct. 6, ministry spokesman Maj. Gen. Igor Konashenkov said Russia is prepared to shoot down unidentified aircraft – including any stealth aircraft – over Syria, and warned ominously that Russian air defense will not have time to identify the origin of the aircraft. \nIt seems possible that the US air force will challenge that claim in due course – perhaps even without seeking prior permission from the White House. Last week, National Intelligence Director and former Air Force General James Clapper commented offhandedly, \"I wouldn’t put it past them to shoot down an American aircraft … if they felt it was threatening their forces on the ground.\" \nInjecting additional volatility into the equation, major news outlets are playing down or ignoring Russia’s warnings. Thus, Americans who depend on the corporate media can be expected to be suitably shocked by what that same media will no doubt cast as naked aggression out of the blue if Russian air defenses down a US or coalition aircraft. \nMeanwhile in Europe, as NATO defense ministers met in Brussels on Wednesday, Defense Secretary Ashton Carter told reporters the US is contributing \"a persistent rotational armored brigade combat team\" as a \"major sign of the US commitment to strengthening deterrence here.\" \n\"This was a decision made by the alliance leaders in Warsaw,\" he explained, referring to NATO’s July summit meeting in the Polish capital. \"The United States will lead a battalion in Poland and deploy an entire battle-ready battalion task force of approximately 900 soldiers from the 2nd Cavalry Regiment, which is based in Germany.\" \nOn Thursday, at the Valdai Conference in the Russian Black Sea resort of Sochi, President Putin accused the West of promoting the \"myth\" of a \"Russian military threat,\" calling this a \"profitable business that can be used to pump new money into defense budgets … expand NATO and bring its infrastructure, military units, and arms closer to our borders.\" \nMyth or not, German Foreign Minister Frank-Walter Steinmeier was correct to point out last spring that military posturing on Russia’s borders will bring less regional security. Mr. Steinmeier warned against \"saber-rattling,\" adding that, \"We are well advised not to create pretexts to renew an old confrontation.\" \nSpeaking of such pretexts, it is high time to acknowledge that the marked increase in East-West tensions over the past two and a half years originally stemmed from the Western-sponsored coup d’état in Kiev on Feb. 22, 2014, and Russia’s reaction in annexing Crimea. Americans malnourished on the diet served up by \"mainstream\" media are blissfully unaware that two weeks before the coup, YouTube published a recording of an intercepted conversation between US Assistant Secretary of State Victoria Nuland and the US ambassador in Kiev, during which \"Yats\" (for Arseniy Yatsenyuk) was identified as Washington’s choice to become the new prime minister of the coup government in Kiev. \nThis unique set of circumstances prompted George Friedman, president of the think-tank STRATFOR, to label the putsch in Kiev on Feb. 22, 2014, \"really the most blatant coup in history.\" \nIt’s time for Western politicians and media to learn their lesson and pay attention to the statements coming out of Russia. Ask yourselves: Why all this hype now? \nRay McGovern, like Sam Adams, began a career as a CIA analyst under President Kennedy; working on Vietnam, they became close associates. Sam was too straight-arrow to go to the media about the unconscionable fraud regarding the number of Communist forces. Ray knew that and rationalized not doing so himself. So, while a close associate of Sam Adams years ago, Ray fell short of the standard set by the above awardees, who deserved to be honored by Sam Adams Associates for Integrity in Intelligence. \nReprinted with the author’s permission from the Baltimore Sun . Read more by Ray McGovern",
		"thread_title": "Putin-Obama Trust Evaporates",
		"title": "Putin-Obama Trust Evaporates",
		"type": "bs",
		"uuid": "7a6a3c1717138ff4fa8150d57b27eef3aa5ee8fc"
	},
	"-KhIj4yW9aWIHIH2PqU5": {
		"author": "Tom Engelhardt",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T09:24:20.740+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Nate Terani",
				"salience": 0.31107086,
				"type": "PERSON"
			},
			{
				"name": "Veterans Challenge Islamophobia",
				"salience": 0.15148327,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.039571557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.028417215,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.026834473,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0233938,
				"type": "LOCATION"
			},
			{
				"name": "classmates",
				"salience": 0.012042163,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02497z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam_in_the_United_States"
				},
				"name": "American Muslims",
				"salience": 0.011197847,
				"type": "OTHER"
			},
			{
				"name": "veterans",
				"salience": 0.009276183,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.008740676,
				"type": "LOCATION"
			},
			{
				"name": "War",
				"salience": 0.0085873995,
				"type": "EVENT"
			},
			{
				"name": "book",
				"salience": 0.008139484,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.008106455,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.007313501,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0zgfr43",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Engelhardt"
				},
				"name": "Tom Engelhardt",
				"salience": 0.0057529463,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0054204734,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0049308967,
				"type": "OTHER"
			},
			{
				"name": "Kill Anything That Moves",
				"salience": 0.0041781953,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.003970154,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.0039229267,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.0039229267,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "U.S. Navy",
				"salience": 0.0036765558,
				"type": "ORGANIZATION"
			},
			{
				"name": "veterans",
				"salience": 0.0036144885,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ftlx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tehran"
				},
				"name": "Tehran",
				"salience": 0.0034866491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranians",
				"salience": 0.0034117205,
				"type": "PERSON"
			},
			{
				"name": "queries",
				"salience": 0.0032931098,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wcxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Veteran"
				},
				"name": "Veteran",
				"salience": 0.003094108,
				"type": "PERSON"
			},
			{
				"name": "mom",
				"salience": 0.0029477023,
				"type": "PERSON"
			},
			{
				"name": "Veterans",
				"salience": 0.0027701468,
				"type": "PERSON"
			},
			{
				"name": "Veterans",
				"salience": 0.0027701468,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqqxpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nick_Turse"
				},
				"name": "Nick Turse",
				"salience": 0.0026001565,
				"type": "PERSON"
			},
			{
				"name": "Veterans",
				"salience": 0.0026000778,
				"type": "PERSON"
			},
			{
				"name": "veterans",
				"salience": 0.0025673367,
				"type": "PERSON"
			},
			{
				"name": "veterans",
				"salience": 0.0025673367,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.0025666123,
				"type": "PERSON"
			},
			{
				"name": "Veterans",
				"salience": 0.0025185982,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.0023285204,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/068gn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Purple_Heart"
				},
				"name": "Purple Heart",
				"salience": 0.002301887,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.002299468,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00218396,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0021655774,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.0021655774,
				"type": "OTHER"
			},
			{
				"name": "fundmentalists",
				"salience": 0.0021042437,
				"type": "PERSON"
			},
			{
				"name": "stars",
				"salience": 0.0020832606,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.002040917,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.002040917,
				"type": "EVENT"
			},
			{
				"name": "friends",
				"salience": 0.0019830836,
				"type": "PERSON"
			},
			{
				"name": "lifetime",
				"salience": 0.0019730332,
				"type": "OTHER"
			},
			{
				"name": "books",
				"salience": 0.0019420659,
				"type": "WORK_OF_ART"
			},
			{
				"name": "question",
				"salience": 0.0019239613,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.0019176035,
				"type": "WORK_OF_ART"
			},
			{
				"name": "question",
				"salience": 0.0018288381,
				"type": "OTHER"
			},
			{
				"name": "veterans",
				"salience": 0.0018054415,
				"type": "PERSON"
			},
			{
				"name": "interviews",
				"salience": 0.0017384144,
				"type": "EVENT"
			},
			{
				"name": "interviewers",
				"salience": 0.0017384144,
				"type": "PERSON"
			},
			{
				"name": "Questions",
				"salience": 0.0017384144,
				"type": "OTHER"
			},
			{
				"name": "interviewer",
				"salience": 0.0017384144,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam War",
				"salience": 0.0016543103,
				"type": "EVENT"
			},
			{
				"name": "boy",
				"salience": 0.001645847,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.001645847,
				"type": "PERSON"
			},
			{
				"name": "killer",
				"salience": 0.0016313202,
				"type": "PERSON"
			},
			{
				"name": "heart",
				"salience": 0.0015933057,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0015427002,
				"type": "OTHER"
			},
			{
				"name": "indignation",
				"salience": 0.001540024,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0014790095,
				"type": "PERSON"
			},
			{
				"name": "faith",
				"salience": 0.001425209,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.001425209,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.001425209,
				"type": "OTHER"
			},
			{
				"name": "head-shaker",
				"salience": 0.0014178533,
				"type": "OTHER"
			},
			{
				"name": "Case",
				"salience": 0.0014178533,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.0013702027,
				"type": "OTHER"
			},
			{
				"name": "Veterans",
				"salience": 0.0013113027,
				"type": "PERSON"
			},
			{
				"name": "courtyard",
				"salience": 0.0012957583,
				"type": "LOCATION"
			},
			{
				"name": "demonization",
				"salience": 0.001286835,
				"type": "EVENT"
			},
			{
				"name": "atrocities",
				"salience": 0.001286835,
				"type": "OTHER"
			},
			{
				"name": "pride",
				"salience": 0.001286835,
				"type": "OTHER"
			},
			{
				"name": "military power",
				"salience": 0.001286835,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.001286835,
				"type": "OTHER"
			},
			{
				"name": "patriotism",
				"salience": 0.001286835,
				"type": "OTHER"
			},
			{
				"name": "vets",
				"salience": 0.001286835,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.001286835,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.001286835,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.001286835,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0012632743,
				"type": "PERSON"
			},
			{
				"name": "soldier",
				"salience": 0.0012421369,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0012095005,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0012077829,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0011999604,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.0011872381,
				"type": "OTHER"
			},
			{
				"name": "favorite",
				"salience": 0.0011722788,
				"type": "PERSON"
			},
			{
				"name": "offense",
				"salience": 0.0011722788,
				"type": "OTHER"
			},
			{
				"name": "combat",
				"salience": 0.0011575078,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0011549025,
				"type": "PERSON"
			},
			{
				"name": "grandparents",
				"salience": 0.0011406147,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07hyp5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Veterans_for_Peace"
				},
				"name": "Veterans For Peace",
				"salience": 0.0011286403,
				"type": "ORGANIZATION"
			},
			{
				"name": "swirl",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "suffering",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "host",
				"salience": 0.0011143014,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "memories",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "skeptics",
				"salience": 0.0011143014,
				"type": "PERSON"
			},
			{
				"name": "atrocity-deniers",
				"salience": 0.0011143014,
				"type": "EVENT"
			},
			{
				"name": "hundreds",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "continents",
				"salience": 0.0011143014,
				"type": "LOCATION"
			},
			{
				"name": "abuse",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "stripes",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "genesis",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "implication",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0011143014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0011053344,
				"type": "OTHER"
			},
			{
				"name": "vets",
				"salience": 0.0010920597,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.001077933,
				"type": "PERSON"
			},
			{
				"name": "soldier",
				"salience": 0.0010533625,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0009876771,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0009867119,
				"type": "LOCATION"
			},
			{
				"name": "Islamophobia",
				"salience": 0.0009597332,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0009541119,
				"type": "OTHER"
			},
			{
				"name": "quotes",
				"salience": 0.0009096715,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0009096715,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0008915176,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.0008915176,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.0008915176,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.0008915176,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.00088571646,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0008745548,
				"type": "PERSON"
			},
			{
				"name": "smoke",
				"salience": 0.0008526515,
				"type": "OTHER"
			},
			{
				"name": "bullies",
				"salience": 0.00084190635,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.0008323971,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0007531753,
				"type": "ORGANIZATION"
			},
			{
				"name": "thesaurus",
				"salience": 0.0007377967,
				"type": "OTHER"
			},
			{
				"name": "summer soldiers",
				"salience": 0.00071558484,
				"type": "PERSON"
			},
			{
				"name": "Kodachrome",
				"salience": 0.0006858317,
				"type": "OTHER"
			},
			{
				"name": "stream",
				"salience": 0.0006795203,
				"type": "LOCATION"
			},
			{
				"name": "wing",
				"salience": 0.00066660973,
				"type": "OTHER"
			},
			{
				"name": "Grand Ayatollah Khomeini",
				"salience": 0.0006607028,
				"type": "PERSON"
			},
			{
				"name": "kids",
				"salience": 0.0006528294,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08b3m1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_Veterans_Against_the_War"
				},
				"name": "Vietnam Veterans Against the War",
				"salience": 0.0006505717,
				"type": "ORGANIZATION"
			},
			{
				"name": "soldier",
				"salience": 0.00063839194,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.00063499046,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00063499046,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00063499046,
				"type": "PERSON"
			},
			{
				"name": "homeland",
				"salience": 0.00063499046,
				"type": "LOCATION"
			},
			{
				"name": "courtyard",
				"salience": 0.00062503683,
				"type": "LOCATION"
			},
			{
				"name": "courtyard",
				"salience": 0.00060170074,
				"type": "LOCATION"
			},
			{
				"name": "home countries",
				"salience": 0.00060170074,
				"type": "LOCATION"
			},
			{
				"name": "courtyard",
				"salience": 0.00060170074,
				"type": "LOCATION"
			},
			{
				"name": "hatred",
				"salience": 0.0005866119,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0005866119,
				"type": "OTHER"
			},
			{
				"name": "military service",
				"salience": 0.0005866119,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0005866119,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0005866119,
				"type": "OTHER"
			},
			{
				"name": "Michael McPhearson",
				"salience": 0.00057747035,
				"type": "PERSON"
			},
			{
				"name": "classmate",
				"salience": 0.0005694294,
				"type": "PERSON"
			},
			{
				"name": "classmates",
				"salience": 0.0005694294,
				"type": "PERSON"
			},
			{
				"name": "flag patch",
				"salience": 0.00056527945,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.00056527945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.0005532607,
				"type": "LOCATION"
			},
			{
				"name": "commotion",
				"salience": 0.0005485161,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.000548169,
				"type": "OTHER"
			},
			{
				"name": "classroom",
				"salience": 0.000548169,
				"type": "LOCATION"
			},
			{
				"name": "classroom",
				"salience": 0.000548169,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.00054010394,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0yns0bc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Death_to_America"
				},
				"name": "Death to America",
				"salience": 0.0005317003,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.0005296385,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.0005296385,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0005296385,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0005296385,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0005296385,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.0005296385,
				"type": "LOCATION"
			},
			{
				"name": "movement",
				"salience": 0.0005296385,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.0005296385,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0005296385,
				"type": "OTHER"
			},
			{
				"name": "battlefield",
				"salience": 0.0005296385,
				"type": "LOCATION"
			},
			{
				"name": "patriots",
				"salience": 0.0005296385,
				"type": "PERSON"
			},
			{
				"name": "school",
				"salience": 0.0005280363,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.0005280363,
				"type": "ORGANIZATION"
			},
			{
				"name": "feeling",
				"salience": 0.00052727223,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.0005260447,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.0005260447,
				"type": "OTHER"
			},
			{
				"name": "devil's advocate",
				"salience": 0.00052062655,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0005102349,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0005102349,
				"type": "LOCATION"
			},
			{
				"name": "fundamentalism",
				"salience": 0.00050851144,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00050640374,
				"type": "LOCATION"
			},
			{
				"name": "flags",
				"salience": 0.00050640374,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00050640374,
				"type": "PERSON"
			},
			{
				"name": "flags",
				"salience": 0.00050640374,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00050640374,
				"type": "LOCATION"
			},
			{
				"name": "time",
				"salience": 0.0005016799,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0004970918,
				"type": "ORGANIZATION"
			},
			{
				"name": "essay",
				"salience": 0.0004948709,
				"type": "WORK_OF_ART"
			},
			{
				"name": "VCI",
				"salience": 0.00049358327,
				"type": "ORGANIZATION"
			},
			{
				"name": "Something",
				"salience": 0.00049337384,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0004876465,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.00048294844,
				"type": "PERSON"
			},
			{
				"name": "Death",
				"salience": 0.00047495245,
				"type": "EVENT"
			},
			{
				"name": "soccer",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "cold",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "glow",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "bravery",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "blessings",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "nod",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "whistleblowers",
				"salience": 0.00045860608,
				"type": "PERSON"
			},
			{
				"name": "minorities",
				"salience": 0.00045860608,
				"type": "PERSON"
			},
			{
				"name": "thanks",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "kid",
				"salience": 0.00045860608,
				"type": "PERSON"
			},
			{
				"name": "outsiders",
				"salience": 0.00045860608,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.00045860608,
				"type": "PERSON"
			},
			{
				"name": "division",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "jeopardy",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.00045860608,
				"type": "LOCATION"
			},
			{
				"name": "tyrants",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00045860608,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.00045860608,
				"type": "PERSON"
			},
			{
				"name": "activism",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "truth-tellers",
				"salience": 0.00045860608,
				"type": "PERSON"
			},
			{
				"name": "despair",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "knocks",
				"salience": 0.00045860608,
				"type": "OTHER"
			},
			{
				"name": "Death",
				"salience": 0.00045721873,
				"type": "EVENT"
			},
			{
				"name": "Death",
				"salience": 0.00045721873,
				"type": "EVENT"
			},
			{
				"name": "child",
				"salience": 0.00045721873,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00045721873,
				"type": "ORGANIZATION"
			},
			{
				"name": "military veterans",
				"salience": 0.0004518991,
				"type": "PERSON"
			},
			{
				"name": "middle school",
				"salience": 0.00044776616,
				"type": "ORGANIZATION"
			},
			{
				"name": "elementary school",
				"salience": 0.00044776616,
				"type": "ORGANIZATION"
			},
			{
				"name": "high school",
				"salience": 0.00044776616,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ayatollah",
				"salience": 0.00044517228,
				"type": "PERSON"
			},
			{
				"name": "attention",
				"salience": 0.00044517228,
				"type": "OTHER"
			},
			{
				"name": "uniform",
				"salience": 0.00044517228,
				"type": "OTHER"
			},
			{
				"name": "ayatollah",
				"salience": 0.00044517228,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09lzsr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq_Veterans_Against_the_War"
				},
				"name": "Iraq Veterans Against the War",
				"salience": 0.0004403992,
				"type": "ORGANIZATION"
			},
			{
				"name": "heart",
				"salience": 0.0004345993,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00043179735,
				"type": "LOCATION"
			},
			{
				"name": "veterans",
				"salience": 0.00042954276,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.00042942146,
				"type": "OTHER"
			},
			{
				"name": "uniforms",
				"salience": 0.00042855027,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "home",
				"salience": 0.00042855027,
				"type": "LOCATION"
			},
			{
				"name": "values",
				"salience": 0.00042855027,
				"type": "OTHER"
			},
			{
				"name": "military fundamentalists",
				"salience": 0.00042855027,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.00042855027,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00042855027,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.00041621175,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00041125293,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.00041125293,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.00041125293,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.00041125293,
				"type": "OTHER"
			},
			{
				"name": "senses",
				"salience": 0.00041125293,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00041125293,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.00040734882,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.00039589722,
				"type": "ORGANIZATION"
			},
			{
				"name": "bigotry",
				"salience": 0.00039589722,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.00039589722,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00039589722,
				"type": "LOCATION"
			},
			{
				"name": "perspective",
				"salience": 0.000393853,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0003933322,
				"type": "OTHER"
			},
			{
				"name": "Nick Turse Tehran",
				"salience": 0.00039079285,
				"type": "ORGANIZATION"
			},
			{
				"name": "USA Fighting Fundamentalism",
				"salience": 0.00039079285,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00038771218,
				"type": "ORGANIZATION"
			},
			{
				"name": "childhood",
				"salience": 0.00038771218,
				"type": "OTHER"
			},
			{
				"name": "courtyard",
				"salience": 0.00038112604,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00038112604,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00038112604,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00038112604,
				"type": "LOCATION"
			},
			{
				"name": "otherness",
				"salience": 0.00037914686,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0003758133,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.00037361158,
				"type": "OTHER"
			},
			{
				"name": "symbols",
				"salience": 0.00037130807,
				"type": "OTHER"
			},
			{
				"name": "peers",
				"salience": 0.00037130807,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.00037130807,
				"type": "PERSON"
			},
			{
				"name": "compliment",
				"salience": 0.00037130807,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.00037130807,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.00037130807,
				"type": "OTHER"
			},
			{
				"name": "feet",
				"salience": 0.00037130807,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.00037130807,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0003634012,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0003634012,
				"type": "OTHER"
			},
			{
				"name": "uniform",
				"salience": 0.0003634012,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.0003634012,
				"type": "OTHER"
			},
			{
				"name": "sounds",
				"salience": 0.00036038912,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00035917037,
				"type": "EVENT"
			},
			{
				"name": "target",
				"salience": 0.00035744358,
				"type": "OTHER"
			},
			{
				"name": "symbols",
				"salience": 0.00035744358,
				"type": "OTHER"
			},
			{
				"name": "gunfire",
				"salience": 0.00035744358,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00035744358,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00035744358,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.00035744358,
				"type": "LOCATION"
			},
			{
				"name": "gunfire",
				"salience": 0.00035744358,
				"type": "OTHER"
			},
			{
				"name": "chants",
				"salience": 0.00035744358,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.00034848938,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.00034409674,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.000339997,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.00033975946,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.00033571137,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00033571137,
				"type": "PERSON"
			},
			{
				"name": "trust",
				"salience": 0.00033571137,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00033571137,
				"type": "PERSON"
			},
			{
				"name": "bullies",
				"salience": 0.00033571137,
				"type": "OTHER"
			},
			{
				"name": "committee",
				"salience": 0.00033446192,
				"type": "ORGANIZATION"
			},
			{
				"name": "committee",
				"salience": 0.00033446192,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.00033446192,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.00033446192,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.00033446192,
				"type": "OTHER"
			},
			{
				"name": "goodness",
				"salience": 0.0003339779,
				"type": "OTHER"
			},
			{
				"name": "bigotry",
				"salience": 0.00033147977,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00033038034,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.00032595012,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.00032595012,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.0003256114,
				"type": "EVENT"
			},
			{
				"name": "thing",
				"salience": 0.0003235017,
				"type": "OTHER"
			},
			{
				"name": "privilege",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "sand-nigger",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "raghead",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "defamation",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "jibes",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "score",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "chest",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "third grade",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "knees",
				"salience": 0.0003215071,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0003215071,
				"type": "PERSON"
			},
			{
				"name": "nationalists",
				"salience": 0.00032075855,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.00032075855,
				"type": "LOCATION"
			},
			{
				"name": "oath",
				"salience": 0.00031887932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle Eastern",
				"salience": 0.00031704697,
				"type": "LOCATION"
			},
			{
				"name": "rest",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "corridor",
				"salience": 0.00030950192,
				"type": "LOCATION"
			},
			{
				"name": "guns",
				"salience": 0.00030950192,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "equality",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "boots",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "tiles",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "flash",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "flames",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "building",
				"salience": 0.00030950192,
				"type": "LOCATION"
			},
			{
				"name": "playbook",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "unison",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "rifle",
				"salience": 0.00030950192,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "refuge",
				"salience": 0.00030950192,
				"type": "LOCATION"
			},
			{
				"name": "balcony",
				"salience": 0.00030950192,
				"type": "LOCATION"
			},
			{
				"name": "shirt collars",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "distance",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "remains",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "teaching",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "tolerance",
				"salience": 0.00030950192,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.0003059007,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.00030310283,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00030310283,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.00030310283,
				"type": "OTHER"
			},
			{
				"name": "taunts",
				"salience": 0.00030310283,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.00030310283,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.00030310283,
				"type": "OTHER"
			},
			{
				"name": "pride",
				"salience": 0.00030310283,
				"type": "OTHER"
			},
			{
				"name": "kindness",
				"salience": 0.00030310283,
				"type": "OTHER"
			},
			{
				"name": "ceremony",
				"salience": 0.00030310283,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04xfb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mahatma_Gandhi"
				},
				"name": "Gandhi",
				"salience": 0.00030092974,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0002896928,
				"type": "LOCATION"
			},
			{
				"name": "militarism",
				"salience": 0.00028960223,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00028960223,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0002881068,
				"type": "OTHER"
			},
			{
				"name": "passages",
				"salience": 0.00028320408,
				"type": "OTHER"
			},
			{
				"name": "Raritan Rovers",
				"salience": 0.00028223195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07kwl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_Paine"
				},
				"name": "Thomas Paine",
				"salience": 0.00028223195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020b8d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Smedley_Butler"
				},
				"name": "Smedley Butler",
				"salience": 0.00028223195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Westerners",
				"salience": 0.00028223195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c3tl_f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Manning"
				},
				"name": "Chelsea Manning",
				"salience": 0.00028223195,
				"type": "PERSON"
			},
			{
				"name": "Raritan Red Sox",
				"salience": 0.00028223195,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.00028223195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ks4j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daniel_Ellsberg"
				},
				"name": "Daniel Ellsberg",
				"salience": 0.00028223195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0645qz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andrew_Bacevich"
				},
				"name": "Andrew Bacevich",
				"salience": 0.00028223195,
				"type": "PERSON"
			},
			{
				"name": "dinners",
				"salience": 0.00027963423,
				"type": "OTHER"
			},
			{
				"name": "photos",
				"salience": 0.00027963423,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0002775508,
				"type": "LOCATION"
			},
			{
				"name": "countrymen",
				"salience": 0.0002775508,
				"type": "PERSON"
			},
			{
				"name": "school courtyard",
				"salience": 0.0002775508,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.00027144238,
				"type": "LOCATION"
			},
			{
				"name": "uniforms",
				"salience": 0.00027144238,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.00027144238,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.00027144238,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00026699217,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.00026499503,
				"type": "PERSON"
			},
			{
				"name": "shoulder",
				"salience": 0.0002624487,
				"type": "OTHER"
			},
			{
				"name": "enlistment",
				"salience": 0.0002624487,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0002624487,
				"type": "OTHER"
			},
			{
				"name": "joy",
				"salience": 0.0002624487,
				"type": "OTHER"
			},
			{
				"name": "images",
				"salience": 0.0002624487,
				"type": "WORK_OF_ART"
			},
			{
				"name": "carpet",
				"salience": 0.0002624487,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0002624487,
				"type": "PERSON"
			},
			{
				"name": "strangers",
				"salience": 0.0002624487,
				"type": "PERSON"
			},
			{
				"name": "patience",
				"salience": 0.0002624487,
				"type": "OTHER"
			},
			{
				"name": "humor",
				"salience": 0.0002624487,
				"type": "OTHER"
			},
			{
				"name": "embodiment",
				"salience": 0.0002624487,
				"type": "OTHER"
			},
			{
				"name": "Master Chief Petty Officer",
				"salience": 0.0002624487,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00026156113,
				"type": "EVENT"
			},
			{
				"name": "group",
				"salience": 0.00025720207,
				"type": "ORGANIZATION"
			},
			{
				"name": "camera",
				"salience": 0.00025395994,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00025285457,
				"type": "OTHER"
			},
			{
				"name": "clash",
				"salience": 0.00025285457,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00025285457,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0002507587,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0002507587,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0002507587,
				"type": "ORGANIZATION"
			},
			{
				"name": "bigots",
				"salience": 0.0002507587,
				"type": "PERSON"
			},
			{
				"name": "hatred",
				"salience": 0.0002507587,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0002507587,
				"type": "OTHER"
			},
			{
				"name": "Nationalism",
				"salience": 0.00023358714,
				"type": "PERSON"
			},
			{
				"name": "book",
				"salience": 0.00023358714,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nation",
				"salience": 0.00023358714,
				"type": "LOCATION"
			},
			{
				"name": "flag",
				"salience": 0.00023358714,
				"type": "OTHER"
			},
			{
				"name": "destination",
				"salience": 0.000229683,
				"type": "LOCATION"
			},
			{
				"name": "Camel Jockey",
				"salience": 0.00022850424,
				"type": "OTHER"
			},
			{
				"name": "assistant",
				"salience": 0.00022826678,
				"type": "PERSON"
			},
			{
				"name": "dangers",
				"salience": 0.00022640101,
				"type": "OTHER"
			},
			{
				"name": "assassinations",
				"salience": 0.00022640101,
				"type": "EVENT"
			},
			{
				"name": "much",
				"salience": 0.00022640101,
				"type": "OTHER"
			},
			{
				"name": "oath",
				"salience": 0.00022640101,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.00022640101,
				"type": "OTHER"
			},
			{
				"name": "wake",
				"salience": 0.00022640101,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.00022640101,
				"type": "PERSON"
			},
			{
				"name": "``other",
				"salience": 0.00022276674,
				"type": "PERSON"
			},
			{
				"name": "military intelligence",
				"salience": 0.00022276674,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00022089007,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.00021631648,
				"type": "ORGANIZATION"
			},
			{
				"name": "league",
				"salience": 0.00021423785,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00021089727,
				"type": "OTHER"
			},
			{
				"name": "boy",
				"salience": 0.00021089727,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.00021089727,
				"type": "EVENT"
			},
			{
				"name": "boy",
				"salience": 0.00021089727,
				"type": "PERSON"
			},
			{
				"name": "pieces",
				"salience": 0.00020995492,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00020731446,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0pl7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_Intelligence_Agency"
				},
				"name": "Defense Intelligence Agency",
				"salience": 0.00020308542,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizers",
				"salience": 0.00020211475,
				"type": "PERSON"
			},
			{
				"name": "No one",
				"salience": 0.00019853642,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06dnh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ralph_Nader"
				},
				"name": "Nader",
				"salience": 0.00019785488,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0244gs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cub_Scout"
				},
				"name": "Cub Scout",
				"salience": 0.00019785488,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.00019767226,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "perpetuation",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "shooting",
				"salience": 0.00019603374,
				"type": "EVENT"
			},
			{
				"name": "fasts",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "Ramadan",
				"salience": 0.00019603374,
				"type": "EVENT"
			},
			{
				"name": "hate speech",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "soul mates",
				"salience": 0.00019603374,
				"type": "PERSON"
			},
			{
				"name": "hate-speakers",
				"salience": 0.00019603374,
				"type": "PERSON"
			},
			{
				"name": "gauntlet",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "chord",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "sorrow",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "tenet",
				"salience": 0.00019603374,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.00019603374,
				"type": "EVENT"
			},
			{
				"name": "word",
				"salience": 0.00019603374,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.00019384314,
				"type": "PERSON"
			},
			{
				"name": "Boy",
				"salience": 0.00019297698,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.00018886729,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jfqp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chapel_Hill,_North_Carolina"
				},
				"name": "Chapel Hill",
				"salience": 0.00018348635,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.00018260935,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00018260935,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00018260935,
				"type": "LOCATION"
			},
			{
				"name": "trust",
				"salience": 0.00018260935,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.00018260935,
				"type": "OTHER"
			},
			{
				"name": "campaign organizer",
				"salience": 0.00018260935,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.00018260935,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.00018166636,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.00018018144,
				"type": "ORGANIZATION"
			},
			{
				"name": "place",
				"salience": 0.00018018144,
				"type": "OTHER"
			},
			{
				"name": "quest",
				"salience": 0.0001663929,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0001663929,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00016622969,
				"type": "OTHER"
			},
			{
				"name": "bullying peers",
				"salience": 0.00016487093,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00016487093,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilizations",
				"salience": 0.00016487093,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.00016487093,
				"type": "OTHER"
			},
			{
				"name": "love",
				"salience": 0.00016487093,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.00016487093,
				"type": "EVENT"
			},
			{
				"name": "feet",
				"salience": 0.00016487093,
				"type": "OTHER"
			},
			{
				"name": "appearance",
				"salience": 0.00016413422,
				"type": "EVENT"
			},
			{
				"name": "Ceremonial Honor Guard",
				"salience": 0.00016150883,
				"type": "ORGANIZATION"
			},
			{
				"name": "childhood",
				"salience": 0.00015752694,
				"type": "OTHER"
			},
			{
				"name": "boy",
				"salience": 0.00015752694,
				"type": "PERSON"
			},
			{
				"name": "trust",
				"salience": 0.00015682304,
				"type": "OTHER"
			},
			{
				"name": "camel jockey",
				"salience": 0.00015671346,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00015485073,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.00015210462,
				"type": "OTHER"
			},
			{
				"name": "somewhere",
				"salience": 0.00014764848,
				"type": "LOCATION"
			},
			{
				"name": "hate",
				"salience": 0.00014764848,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.00014764848,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00014764848,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.00014642457,
				"type": "OTHER"
			},
			{
				"name": "Dispatch Book",
				"salience": 0.00014374695,
				"type": "WORK_OF_ART"
			},
			{
				"name": "xenophobia",
				"salience": 0.0001427562,
				"type": "OTHER"
			},
			{
				"name": "Copyright",
				"salience": 0.0001427562,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.0001427562,
				"type": "EVENT"
			},
			{
				"name": "anyone",
				"salience": 0.0001427562,
				"type": "PERSON"
			},
			{
				"name": "Surveillance",
				"salience": 0.0001427562,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.0001427562,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0001427562,
				"type": "OTHER"
			},
			{
				"name": "representative",
				"salience": 0.0001427562,
				"type": "PERSON"
			},
			{
				"name": "niceties",
				"salience": 0.0001427562,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.0001427562,
				"type": "ORGANIZATION"
			},
			{
				"name": "leadership team",
				"salience": 0.0001427562,
				"type": "ORGANIZATION"
			},
			{
				"name": "childhood experiences",
				"salience": 0.00014095662,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.0001393245,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0001393245,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.00013700944,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.00013639721,
				"type": "OTHER"
			},
			{
				"name": "military service",
				"salience": 0.00013639721,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.00013639721,
				"type": "PERSON"
			},
			{
				"name": "path",
				"salience": 0.00012416244,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "wake",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "overarching",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "taunts",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "turn",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "terror religion",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00012314753,
				"type": "OTHER"
			},
			{
				"name": "apartment complex",
				"salience": 0.00012314753,
				"type": "LOCATION"
			},
			{
				"name": "assassinations",
				"salience": 0.00012159513,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.00012063622,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05782m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iftar"
				},
				"name": "Iftar",
				"salience": 0.00012063622,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ply0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orlando,_Florida"
				},
				"name": "Orlando",
				"salience": 0.00012063622,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00012063622,
				"type": "LOCATION"
			},
			{
				"name": "LGBTQ+",
				"salience": 0.00012063622,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00011311726,
				"type": "PERSON"
			},
			{
				"name": "Single-Superpower World",
				"salience": 0.0001123748,
				"type": "OTHER"
			},
			{
				"name": "Global Security State",
				"salience": 0.0001123748,
				"type": "ORGANIZATION"
			},
			{
				"name": "meaning",
				"salience": 0.00011217959,
				"type": "OTHER"
			},
			{
				"name": "portrait",
				"salience": 0.00010662904,
				"type": "WORK_OF_ART"
			},
			{
				"name": "verydemons",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "misadventures",
				"salience": 0.00010662904,
				"type": "EVENT"
			},
			{
				"name": "fundamentalist",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "pursuit",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "founding",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "villain",
				"salience": 0.00010662904,
				"type": "PERSON"
			},
			{
				"name": "hallmarks",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "daughter",
				"salience": 0.00010662904,
				"type": "PERSON"
			},
			{
				"name": "monster",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "creation",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "insults",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00010662904,
				"type": "LOCATION"
			},
			{
				"name": "ideology",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "throat",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "shift",
				"salience": 0.00010662904,
				"type": "EVENT"
			},
			{
				"name": "masse",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "attitude",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "desert",
				"salience": 0.00010662904,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "ultra-nationalism",
				"salience": 0.00010662904,
				"type": "OTHER"
			},
			{
				"name": "Arizona Muslim Voice",
				"salience": 0.000101458565,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00008784923,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m2m6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Secret_Wars"
				},
				"name": "Secret Wars",
				"salience": 0.00008784923,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Shadow Government",
				"salience": 0.00008784923,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07qy9x1"
				},
				"name": "Dead",
				"salience": 0.00008784923,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00008784923,
				"type": "OTHER"
			},
			{
				"name": "Common Defense PAC",
				"salience": 0.00008784923,
				"type": "ORGANIZATION"
			},
			{
				"name": "Razan Abu-Salha",
				"salience": 0.000075782205,
				"type": "PERSON"
			},
			{
				"name": "Yusor Abu-Salha",
				"salience": 0.000075782205,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.000065616914,
				"type": "LOCATION"
			},
			{
				"name": "Deah Shaddy Barakat",
				"salience": 0.000065616914,
				"type": "PERSON"
			},
			{
				"name": "Schoolyard Grown Up",
				"salience": 0.000065616914,
				"type": "EVENT"
			},
			{
				"name": "Post-9",
				"salience": 0.000065616914,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/063c3v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy_Reserve"
				},
				"name": "Naval Reserve",
				"salience": 0.000065616914,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacks",
				"salience": 0.000054433196,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T09:24:20.740+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 52.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "One Veteran’s War on Islamophobia Nate Terani and Nick Turse, October 31, 2016 Share This \nOriginally posted at TomDispatch . \nRecently, I was asked a question about Kill Anything That Moves , my history of civilian suffering during the Vietnam War. An interviewer wanted to know how I responded to veterans who took offense at the (supposed) implication that every American who served in Vietnam committed atrocities. \nI think I softly snorted and slowly shook my head. \nAlready two books behind me, Kill Anything That Moves might as well have been written by someone else in another lifetime. In some sense, it was. \nIt takes effort for me to dredge up the faded memories of that work, a Kodachrome-hued swirl of hundreds of interviews on two continents over the course of a decade. But this particular question was easy enough to answer. Almost all the Americans I interviewed had seen combat, but most American veterans of the war hadn’t. Many had little or no real opportunity to commit war crimes. Case closed. \nBut that question caused me to recall a host of related queries that churned around the book. Questions by skeptics, atrocity-deniers, fair-minded interviewers attempting to play devil’s advocate. A favorite was whether the book was \"anti-veteran.\" That, too, was a head-shaker for me. \n\"How could that be?\" I would respond. After all, the book owed its genesis to veterans. Veterans were key sources for it. Veterans provided the evidence. Veterans provided the quotes. Veterans even supplied the title. The book was, to a great extent, the history of the war as described to me by veterans. The story I told was their story. How could that in any way be anti-veteran? \nMany of the vets I spoke with viewed their truth-telling as a form of patriotism, of continuing service to country. Nate Terani’s inaugural TomDispatch essay follows in the same American tradition. His eyes were opened to the abuse of military power while living in Iran as a boy. Later he would join the U.S. Navy and wear the stars and stripes with particular pride. September 11th and all that came after – notably the demonization of his Muslim faith in his homeland – imbued him with a new mission, one he now views as no less sacred than his military service. \nFrom Smedley Butler to Andrew Bacevich , Daniel Ellsberg to Chelsea Manning , Vietnam Veterans Against the War to Iraq Veterans Against the War , the U.S. armed forces have produced a steady stream of truth-tellers and whistleblowers, men and women willing to serve their country in profound ways during trying times. There’s no bronze star for activism, no Navy Cross for unpopular or contrarian opinions, no Purple Heart for the hard knocks involved in speaking out against war crimes or Islamophobia or laying bare information vital to the American public. Veterans who dare to do so have sometimes walked a cold, lonely road far from the warm glow enjoyed by summer soldiers and sunshine patriots. Those who do so exhibit a special form of courage that may even exceed the bravery of the battlefield, the courage to stand tall and make oneself a target, a courage deserving ( with a nod to Thomas Paine ) of the love and thanks of man and woman. ~ Nick Turse \nTehran, USA Fighting Fundamentalism in America By Nate Terani \nI’m not an immigrant, but my grandparents are. More than 50 years ago, they arrived in New York City from Iran. I grew up mainly in central New Jersey, an American kid playing little league for the Raritan Red Sox and soccer for the Raritan Rovers. In 1985, I travelled with my family to our ancestral land. I was only eight, but old enough to understand that the Iranians had lost their liberty and freedom. I saw the abject despair of a people who, in a desperate attempt to bring about change, had ushered in nationalist tyrants led by Ayatollah Khomeini. \nWhat I witnessed during that year in Iran changed the course of my life. In 1996, at age 19, wanting to help preserve the blessings of liberty and freedom we enjoy in America, I enlisted in the U.S. Navy. Now, with the rise of Donald Trump and his nationalist alt-right movement, I’ve come to feel that the values I sought to protect are in jeopardy. \nIn Iran, theocratic fundmentalists sowed division and hatred of outsiders – of Westerners, Christians, and other religious minorities. Here in America, the right wing seems to have stolen passages directly from their playbook as it spreads hatred of immigrants, particularly Muslim ones. This form of nationalistic bigotry – Islamophobia – threatens the heart of our nation. When I chose to serve in the military, I did so to protect what I viewed as our sacred foundational values of liberty, equality, and democracy. Now, 20 years later, I’ve joined forces with fellow veterans to again fight for those sacred values, this time right here at home. \n\"Death to America!\" \nAs a child, I sat in my class at the international school one sunny morning and heard in the distance the faint sounds of gunfire and rising chants of \"Death to America!\" That day would define the rest of my life. \nIt was Tehran, the capital of Iran, in 1985. I was attending a unique school for bilingual students who had been born in Western nations. It had become the last refuge in that city with any tolerance for Western teaching, but that also made it a target for military fundamentalists. As the gunfire drew closer, I heard boots pounding the marble tiles outside, marching into our building, and thundering down the corridor toward my classroom. As I heard voices chanting \"Death to America!\" I remember wondering if I would survive to see my parents again. \nIn a flash of green and black uniforms, those soldiers rushed into our classroom, grabbed us by our shirt collars, and yelled at us to get outside. We were then packed into the school’s courtyard where a soldier pointed his rifle at our group and commanded us to look up. Almost in unison, my classmates and I raised our eyes and saw the flags of our many nations being torn down and dangled from the balcony, then set ablaze and tossed, still burning, into the courtyard. As those flags floated to the ground in flames, the soldiers fired their guns in the air. Shouting, they ordered us – if we ever wanted to see our families again – to swear allegiance to the Grand Ayatollah Khomeini and trample on the remains of the burning symbols of our home countries. I scanned the smoke that was filling the courtyard for my friends and classmates and, horrified, watched them capitulate and begin to chant, \"Death to America!\" as they stomped on our sacred symbols. \nI was so angry that, young as I was, I began to plead with them to come to their senses. No one paid the slightest attention to an eight year old and yet, for the first time in my life, I felt something like righteous indignation. I suspect that, born and raised in America, I was already imbued with such a sense of privilege that I just couldn’t fathom the immense danger I was in. Certainly, I was acting in ways no native Iranian would have found reasonable. \nAcross the smoke-filled courtyard, I saw a soldier coming at me and knew he meant to force me to submit. I spotted an American flag still burning, dropped to my knees, and grabbed the charred pieces from underneath a classmate’s feet. As the soldier closed in on me, I ducked and ran, still clutching my charred pieces of flag into a crowd of civilians who had gathered to witness the commotion. The events of that day would come to define all that I have ever stood for – or against. \n\"Camel Jockey,\"\"Ayatollah,\" and \"Gandhi\" \nMy parents and I soon returned to the United States and I entered third grade. More than anything, I just wanted to be normal, to fit in and be accepted by my peers. Unfortunately, my first name, Nader (which I changed to Nate upon joining the Navy), and my swarthy Middle Eastern appearance, were little help on that score, eliciting regular jibes from my classmates. Even at that young age, they had already mastered a veritable thesaurus of ethnic defamation, including \"camel jockey,\"\"sand-nigger,\"\"raghead,\"\"ayatollah,\" and ironically, \"Gandhi\" (which I now take as a compliment). My classmates regularly sought to \"other-ize\" me in those years, as if I were a lesser American because of my faith and ethnicity. \nYet I remember that tingling in my chest when I first donned my Cub Scout uniform – all because of the American flag patch on its shoulder. Something felt so good about wearing it, a feeling I still had when I joined the military. It seems that the flag I tried to rescue in Tehran was stapled to my heart, or that’s how I felt anyway as I wore my country’s uniform. \nWhen I took my oath of enlistment in the U.S. Navy, I gave my mom a camera and asked her to take some photos, but she was so overwhelmed with pride and joy that she cried throughout the ceremony and managed to snap only a few images of the carpet. She cried even harder when I was selected to serve as the first Muslim-American member of the U.S. Navy Presidential Ceremonial Honor Guard . On that day, I was proud, too, and all the taunts of those bullies of my childhood seemed finally silenced. \nBeing tormented because of my ethnicity and religion in those early years had another effect on me. It caused me to become unusually sensitive to the nature of other people. Somehow, I grasped that, if it weren’t for a fear of the unknown, there was an inherent goodness and frail humanity lurking in many of the kids who bullied and harassed me. Often, I discovered, those same bullies could be tremendously kind to their families, friends, or even strangers. I realized, then, that if, despite everything, I could lay myself bare and trust them enough to reach out in kindness, I might in turn gain their trust and they might then see me, too, and stop operating from such a place of fear and hate. \nThrough patience, humor, and understanding, I was able to offer myself as the embodiment of my people and somehow defang the \"otherness\" of so much that Americans found scary. To this day, I have friends from elementary school, middle school, high school, and the military who tell me that I am the only Muslim they have ever known and that, had they not met me, their perspective on Islam would have been wholly subject to the prevailing fear-based narrative that has poisoned this country since September 11, 2001. \nIn 1998, I became special assistant to the Master Chief Petty Officer of the Navy and then, in 1999, I was recruited to serve atthe Defense Intelligence Agency. In August 2000, I transferred to the Naval Reserve. \nIn the wake of 9/11, I began to observe how so many of my fellow Americans were adopting a fundamentalist \"us vs. them\" attitude towards Muslims and Islam. I suddenly found myself in an America where the scattered insults I had endured as a child took on an overarching and sinister meaning and form, where they became something like an ideology and way of life. \nBy the time I completed my military service in 2006, I had begun to understand that our policies in the Middle East,similarly disturbed, seemed in pursuit of little more than perpetual warfare. That, in turn, was made possible by the creation of a new enemy: Islam – or rather of a portrait, painted by the powers-that-be, of Islam as a terror religion, as a hooded villain lurking out there somewhere in the desert, waiting to destroy us. I knew that attempting to dispel, through the patient approach of my childhood, the kind of Islamophobia that now had the country by the throat was not going to be enough. Post-9/11 attacks on Muslims in the U.S. and elsewhere were not merely childish taunts. \nFor the first time in my life, in a country gripped by fear, I believed I was witnessing a shift, en masse, toward an American fundamentalism and ultra-nationalism that reflected a wanton lack of reason, not to mention fact. As a boy in Iran, I had witnessed the dark destination down which such a path could take a country. Now, it seemed to me, in America’s quest to escape the verydemons we had sown by our own misadventures in the Middle East, and forsaking the hallmarks of our founding, we risked becoming everything we sought to defeat. \nThe Boy in the Schoolyard Grown Up \nOn February 10, 2015, three young American students, Yusor Abu-Salha, Razan Abu-Salha, and Deah Shaddy Barakat, were executed at an apartment complex in Chapel Hill, North Carolina. The killer was a gun-crazy white man filled with hate and described by his own daughter as \"a monster.\" Those assassinations struck a special chord of sorrow and loss in me. My mom and I cried and prayed together for those students and their families. \nThe incident in Chapel Hill also awoke in me some version of the righteous indignation I had felt so many years earlier in that smoke-filled courtyard in Iran. I would be damned if I stood by while kids in my country were murdered simply because of their faith. It violated every word of the oath I had taken when I joined the military and desecrated every value I held in my heart as a sacred tenet of our nation. White nationalists and bigots had, by then, thrown down the gauntlet for so much of this, using Islamophobia to trigger targeted assassinations in the United States. This was terrorism, pure and simple, inspired by hate-speakers here at home. \nAt that moment, I reached out to fellow veterans who, I thought, might be willing to help – and it’s true what they say about soul mates being irrevocably drawn to each other. When I contacted Veterans For Peace , an organization dedicated to exposing the costs of war and militarism, I found the leadership well aware of the inherent dangers of Islamophobia and of the need to confront this new enemy. So Executive Director Michael McPhearson formed a committee of vets from around the country to decide how those of us who had donned uniforms to defend this land could best battle the phenomenon – and I, of course, joined it. \nFrom that committee emerged Veterans Challenge Islamophobia (VCI). It now has organizers in Arizona, Georgia, New Jersey, and Texas, and that’s just a beginning. Totally nonpartisan, VCI focuses on politicians of any party who engage in hate speech. We’ve met with leaders of American Muslim communities, sat with them through Ramadan, and attended their Iftar dinners to break our fasts together. In the wake of the Orlando shooting , we at VCI also mobilized to fight back against attempts to pit the Muslim community against the LGBTQ+ community. \nOur group was born of the belief that, as American military veterans, we had a responsibility to call out bigotry, hatred, and the perpetuation of endless warfare. We want the American Muslim community to know that they have allies, and that those allies are indeed veterans as well. We stand with them and for them and, for those of us who are Muslim, among them. \nNationalism and xenophobia have no place in American life, and I, for my part, don’t think Donald Trump or anyone like him should be able to peddle Islamophobia in an attempt to undermine our national unity. Without Islamophobia, there no longer exists a \"clash of civilizations.\" Without Islamophobia, whatever the problems in the world may be, there is no longer an \"us vs. them\" and it’s possible to begin reimagining a world of something other than perpetual war. \nAs of now, this remains the struggle of my life, for despite my intense love for America, some of my countrymen increasingly see American Muslims as the \"other,\" the enemy. \nMy Mom taught me as a boy that the only thing that mattered was what was in my heart. Now, with her in mind and as a representative of VCI, when I meet fellow Americans I always remember my childhood experiences with my bullying peers. And I still lay myself bare, as I did then. I give trust to gain trust, but always knowing that these days this isn’t just a matter of niceties. It’s a question of life or death. It’s part of a battle for the soul of our nation. \nIn many ways, I still consider myself that boy in the school courtyard in Tehran trying to rescue charred pieces of that flag from those trampling feet. It’s just that now I’m doing it in my own country. \nNate Terani is a veteran of the U.S. Navy and served in military intelligence with the Defense Intelligence Agency. He is currently a member of the leadership team at Common Defense PAC and regional campaign organizer with Veterans Challenge Islamophobia . He is a featured columnist with the Arizona Muslim Voice newspaper. \nFollow TomDispatch on Twitter and join us on Facebook . Check out the newest Dispatch Book, Nick Turse’s Next Time They’ll Come to Count the Dead , and Tom Engelhardt’s latest book, Shadow Government: Surveillance, Secret Wars, and a Global Security State in a Single-Superpower World . \nCopyright 2016 Nate Terani",
		"thread_title": "One Veteran’s War on Islamophobia",
		"title": "One Veteran’s War on Islamophobia",
		"type": "bs",
		"uuid": "c84e1a9564e584997ea674feba3f338f42292f1a"
	},
	"-KhIj5ZhFvtjMIFx3Z8g": {
		"author": "Justin Raimondo",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T09:24:20.746+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.061549928,
				"type": "LOCATION"
			},
			{
				"name": "movements",
				"salience": 0.036427766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.034831263,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.030398455,
				"type": "ORGANIZATION"
			},
			{
				"name": "War Party",
				"salience": 0.022617573,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.022386719,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.022386719,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.02114768,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.020308979,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-Americans",
				"salience": 0.020134835,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.02001633,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.01900613,
				"type": "OTHER"
			},
			{
				"name": "What Is To Be Done?",
				"salience": 0.014691989,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01hcqj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/America_First_Committee"
				},
				"name": "America First",
				"salience": 0.014651462,
				"type": "ORGANIZATION"
			},
			{
				"name": "America First Political Action Committee",
				"salience": 0.012016167,
				"type": "ORGANIZATION"
			},
			{
				"name": "politician",
				"salience": 0.01069471,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.010669707,
				"type": "PERSON"
			},
			{
				"name": "kid",
				"salience": 0.009272734,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.009237227,
				"type": "EVENT"
			},
			{
				"name": "cold war",
				"salience": 0.008976357,
				"type": "EVENT"
			},
			{
				"name": "action",
				"salience": 0.0081670815,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00785987,
				"type": "ORGANIZATION"
			},
			{
				"name": "thing",
				"salience": 0.007655872,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.007598707,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.006522869,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.006387406,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.005942701,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.005942701,
				"type": "OTHER"
			},
			{
				"name": "lobbyists",
				"salience": 0.005935838,
				"type": "PERSON"
			},
			{
				"name": "grassroots organizations",
				"salience": 0.005935838,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0058200457,
				"type": "EVENT"
			},
			{
				"name": "task",
				"salience": 0.0055317692,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0053608147,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0051959534,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.0049985405,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.004968375,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.0049577304,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0049577304,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0049577304,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0049577304,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.0048255567,
				"type": "ORGANIZATION"
			},
			{
				"name": "extent",
				"salience": 0.004577559,
				"type": "OTHER"
			},
			{
				"name": "stock",
				"salience": 0.004574255,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0043947278,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0043947278,
				"type": "OTHER"
			},
			{
				"name": "assets",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "sea",
				"salience": 0.0042934027,
				"type": "LOCATION"
			},
			{
				"name": "maturity",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "smears",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "puppet",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "quagmires",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "sensationalism",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "unwillingness",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "arms race",
				"salience": 0.0042934027,
				"type": "EVENT"
			},
			{
				"name": "midst",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0042934027,
				"type": "OTHER"
			},
			{
				"name": "components",
				"salience": 0.004247062,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0041082804,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.004012315,
				"type": "PERSON"
			},
			{
				"name": "America First Lobby",
				"salience": 0.0039938726,
				"type": "ORGANIZATION"
			},
			{
				"name": "politicians",
				"salience": 0.0038574548,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.0035988642,
				"type": "ORGANIZATION"
			},
			{
				"name": "organizations",
				"salience": 0.0035988642,
				"type": "ORGANIZATION"
			},
			{
				"name": "complex",
				"salience": 0.003511727,
				"type": "LOCATION"
			},
			{
				"name": "grassroots anti-interventionist movement",
				"salience": 0.0033969537,
				"type": "OTHER"
			},
			{
				"name": "lobby",
				"salience": 0.0033802898,
				"type": "ORGANIZATION"
			},
			{
				"name": "resources",
				"salience": 0.0032960589,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.0032420584,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0032376377,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.0031502414,
				"type": "EVENT"
			},
			{
				"name": "organizers",
				"salience": 0.003054292,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.0030522645,
				"type": "ORGANIZATION"
			},
			{
				"name": "conservatives",
				"salience": 0.0029944796,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.0029133654,
				"type": "OTHER"
			},
			{
				"name": "support groups",
				"salience": 0.002757719,
				"type": "ORGANIZATION"
			},
			{
				"name": "action groups",
				"salience": 0.002757719,
				"type": "ORGANIZATION"
			},
			{
				"name": "resources",
				"salience": 0.0026743517,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.0026430974,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0026430974,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0026430974,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0026430974,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0026430974,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.0026430974,
				"type": "LOCATION"
			},
			{
				"name": "approach",
				"salience": 0.002636078,
				"type": "OTHER"
			},
			{
				"name": "grassroots movement",
				"salience": 0.0026029695,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.002593156,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.002593156,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0025787768,
				"type": "PERSON"
			},
			{
				"name": "resentment",
				"salience": 0.0025690442,
				"type": "OTHER"
			},
			{
				"name": "cannon fodder",
				"salience": 0.002452957,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0024187486,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0023222605,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.002308813,
				"type": "OTHER"
			},
			{
				"name": "specialty",
				"salience": 0.002277866,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.002277866,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.002277866,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.0022631136,
				"type": "PERSON"
			},
			{
				"name": "functions",
				"salience": 0.0022608351,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0022608351,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0022608351,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0022608351,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0022608351,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.0022307902,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.002211165,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0022074152,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0021946323,
				"type": "OTHER"
			},
			{
				"name": "war profiteers",
				"salience": 0.0021786424,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.002125022,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0021170094,
				"type": "EVENT"
			},
			{
				"name": "consequence",
				"salience": 0.002081641,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0020413166,
				"type": "EVENT"
			},
			{
				"name": "question",
				"salience": 0.0020413166,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0019335875,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.0019335875,
				"type": "PERSON"
			},
			{
				"name": "chapters",
				"salience": 0.0019316915,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0018833167,
				"type": "OTHER"
			},
			{
				"name": "political parties",
				"salience": 0.0018532984,
				"type": "ORGANIZATION"
			},
			{
				"name": "millions",
				"salience": 0.0017982014,
				"type": "PERSON"
			},
			{
				"name": "potential",
				"salience": 0.0017755419,
				"type": "OTHER"
			},
			{
				"name": "growth",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0017676109,
				"type": "PERSON"
			},
			{
				"name": "prospects",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "shape",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "web site",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "reach",
				"salience": 0.0017676109,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0017676109,
				"type": "PERSON"
			},
			{
				"name": "components",
				"salience": 0.0017158448,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0017158448,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.001681833,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0016664548,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0016590109,
				"type": "OTHER"
			},
			{
				"name": "thinktanks",
				"salience": 0.0016517922,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0016274939,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0016274939,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.0016274939,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.0015970791,
				"type": "WORK_OF_ART"
			},
			{
				"name": "function",
				"salience": 0.0015851362,
				"type": "OTHER"
			},
			{
				"name": "sentiment",
				"salience": 0.0015374584,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0015374584,
				"type": "OTHER"
			},
			{
				"name": "spearhead",
				"salience": 0.0015180834,
				"type": "PERSON"
			},
			{
				"name": "activity",
				"salience": 0.0014944187,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0014679682,
				"type": "OTHER"
			},
			{
				"name": "neocons",
				"salience": 0.001431202,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.001431202,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.001431202,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.001431202,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.001431202,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.001431202,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04q07p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antiwar.com"
				},
				"name": "Antiwar.com",
				"salience": 0.0014020246,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0013777715,
				"type": "OTHER"
			},
			{
				"name": "neoconservatives",
				"salience": 0.0013777715,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0013777715,
				"type": "LOCATION"
			},
			{
				"name": "experts",
				"salience": 0.0013777715,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.0013777715,
				"type": "OTHER"
			},
			{
				"name": "The Life of Murray N. Rothbard",
				"salience": 0.0013745736,
				"type": "WORK_OF_ART"
			},
			{
				"name": "name",
				"salience": 0.0013604083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018_n5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Israel_Public_Affairs_Committee"
				},
				"name": "AIPAC",
				"salience": 0.0013580547,
				"type": "ORGANIZATION"
			},
			{
				"name": "alliances",
				"salience": 0.0013372629,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0013204099,
				"type": "OTHER"
			},
			{
				"name": "reiteration",
				"salience": 0.0013204099,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/032px5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Argentine_Football_Association"
				},
				"name": "AFA",
				"salience": 0.0013002321,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.0012953234,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.001294019,
				"type": "EVENT"
			},
			{
				"name": "resources",
				"salience": 0.0012817363,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.0012711143,
				"type": "EVENT"
			},
			{
				"name": "aspect",
				"salience": 0.0012711143,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0012711143,
				"type": "OTHER"
			},
			{
				"name": "slogan",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "campaign theme",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "meaning",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.001239277,
				"type": "PERSON"
			},
			{
				"name": "mine",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "banner",
				"salience": 0.001239277,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Item number one",
				"salience": 0.001239277,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0012009384,
				"type": "OTHER"
			},
			{
				"name": "grassroots",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "undertaking",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "entanglements",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "prognostications",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0011930094,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.0011852809,
				"type": "PERSON"
			},
			{
				"name": "military intervention",
				"salience": 0.0011791303,
				"type": "EVENT"
			},
			{
				"name": "ground",
				"salience": 0.0011791303,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0011791303,
				"type": "ORGANIZATION"
			},
			{
				"name": "time",
				"salience": 0.0011744107,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0011683473,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.0011683473,
				"type": "OTHER"
			},
			{
				"name": "indication",
				"salience": 0.0011683473,
				"type": "OTHER"
			},
			{
				"name": "media appearances",
				"salience": 0.0011683473,
				"type": "EVENT"
			},
			{
				"name": "candidates",
				"salience": 0.0011683473,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0011683473,
				"type": "EVENT"
			},
			{
				"name": "favorite",
				"salience": 0.0011683473,
				"type": "PERSON"
			},
			{
				"name": "America First Action",
				"salience": 0.0011266839,
				"type": "EVENT"
			},
			{
				"name": "appeal",
				"salience": 0.0011105519,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.0010778978,
				"type": "OTHER"
			},
			{
				"name": "Peace",
				"salience": 0.0010463253,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0010463253,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0010463253,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0010463253,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0010463253,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0010463253,
				"type": "OTHER"
			},
			{
				"name": "works",
				"salience": 0.0010116623,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hook",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "howls",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "phone lines",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "warmongers",
				"salience": 0.0010116623,
				"type": "PERSON"
			},
			{
				"name": "rallies",
				"salience": 0.0010116623,
				"type": "EVENT"
			},
			{
				"name": "lecture tours",
				"salience": 0.0010116623,
				"type": "EVENT"
			},
			{
				"name": "harassment",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "Internet trolling",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "laser",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "arm",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "labors",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "weaknesses",
				"salience": 0.0010116623,
				"type": "OTHER"
			},
			{
				"name": "Polls",
				"salience": 0.0009989117,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0009748466,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0009666066,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.00089707196,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.0008727254,
				"type": "EVENT"
			},
			{
				"name": "cause",
				"salience": 0.0008727254,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0008727254,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0008727254,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/013pt4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cato_Institute"
				},
				"name": "Cato Institute",
				"salience": 0.0008479438,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ron Paul Institute",
				"salience": 0.0008479438,
				"type": "PERSON"
			},
			{
				"name": "lobby",
				"salience": 0.0008478944,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.0008190949,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0008129685,
				"type": "OTHER"
			},
			{
				"name": "pipedream",
				"salience": 0.00080515735,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.00077007245,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0007626978,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0007626978,
				"type": "ORGANIZATION"
			},
			{
				"name": "libertarian thinker",
				"salience": 0.00076199387,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00076199387,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0007590697,
				"type": "PERSON"
			},
			{
				"name": "elite",
				"salience": 0.0007556783,
				"type": "PERSON"
			},
			{
				"name": "investment",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "daughters",
				"salience": 0.0007556783,
				"type": "PERSON"
			},
			{
				"name": "diversion",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "altar",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "war machine",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "war god",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "persuasions",
				"salience": 0.0007556783,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "hobbyhorse",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "wayside",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"name": "dozen",
				"salience": 0.0007556783,
				"type": "PERSON"
			},
			{
				"name": "success",
				"salience": 0.0007556783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.00073421974,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00073421974,
				"type": "LOCATION"
			},
			{
				"name": "John Quincy Adams Society",
				"salience": 0.00073421974,
				"type": "ORGANIZATION"
			},
			{
				"name": "Center for the National Interest",
				"salience": 0.00073421974,
				"type": "ORGANIZATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.0007280555,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0007280555,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0007151668,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0007009871,
				"type": "ORGANIZATION"
			},
			{
				"name": "components",
				"salience": 0.00066275644,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00066021306,
				"type": "ORGANIZATION"
			},
			{
				"name": "lobby",
				"salience": 0.0006414275,
				"type": "ORGANIZATION"
			},
			{
				"name": "intervention",
				"salience": 0.0006414275,
				"type": "OTHER"
			},
			{
				"name": "lobby",
				"salience": 0.0006414275,
				"type": "OTHER"
			},
			{
				"name": "subsidiary groups",
				"salience": 0.0006414275,
				"type": "ORGANIZATION"
			},
			{
				"name": "Libertarians",
				"salience": 0.000635561,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.000635561,
				"type": "ORGANIZATION"
			},
			{
				"name": "empire",
				"salience": 0.000635561,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.000635561,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.000635561,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.000635561,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.000635561,
				"type": "OTHER"
			},
			{
				"name": "cannon fodder",
				"salience": 0.000635561,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00062260154,
				"type": "LOCATION"
			},
			{
				"name": "time war clouds",
				"salience": 0.00061687117,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00060725294,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.00060725294,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.0006014181,
				"type": "OTHER"
			},
			{
				"name": "function",
				"salience": 0.0005602354,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00055734254,
				"type": "LOCATION"
			},
			{
				"name": "jest",
				"salience": 0.0005503172,
				"type": "OTHER"
			},
			{
				"name": "tweets",
				"salience": 0.0005503172,
				"type": "WORK_OF_ART"
			},
			{
				"name": "preconceptions",
				"salience": 0.0005503172,
				"type": "OTHER"
			},
			{
				"name": "prejudices",
				"salience": 0.0005503172,
				"type": "OTHER"
			},
			{
				"name": "feed",
				"salience": 0.0005503172,
				"type": "OTHER"
			},
			{
				"name": "albatross",
				"salience": 0.0005503172,
				"type": "OTHER"
			},
			{
				"name": "MARGIN",
				"salience": 0.0005503172,
				"type": "OTHER"
			},
			{
				"name": "NOTES",
				"salience": 0.0005503172,
				"type": "OTHER"
			},
			{
				"name": "proposal",
				"salience": 0.0005297681,
				"type": "OTHER"
			},
			{
				"name": "constituencies",
				"salience": 0.00052580546,
				"type": "LOCATION"
			},
			{
				"name": "military intervention",
				"salience": 0.0005170038,
				"type": "OTHER"
			},
			{
				"name": "sons",
				"salience": 0.0004972103,
				"type": "PERSON"
			},
			{
				"name": "campuses",
				"salience": 0.00047473176,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.00047473176,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.00047473176,
				"type": "PERSON"
			},
			{
				"name": "draft",
				"salience": 0.00047473176,
				"type": "EVENT"
			},
			{
				"name": "universities",
				"salience": 0.00047473176,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.00047473176,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.00047473176,
				"type": "OTHER"
			},
			{
				"name": "Trumpists",
				"salience": 0.00046893826,
				"type": "PERSON"
			},
			{
				"name": "student affiliate",
				"salience": 0.00043797377,
				"type": "ORGANIZATION"
			},
			{
				"name": "Enemy of the State",
				"salience": 0.00042017188,
				"type": "WORK_OF_ART"
			},
			{
				"name": "earth",
				"salience": 0.00041105677,
				"type": "LOCATION"
			},
			{
				"name": "model",
				"salience": 0.00041105677,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "government officials",
				"salience": 0.00041105677,
				"type": "PERSON"
			},
			{
				"name": "aid",
				"salience": 0.00041105677,
				"type": "OTHER"
			},
			{
				"name": "behalf",
				"salience": 0.00041105677,
				"type": "OTHER"
			},
			{
				"name": "high schools",
				"salience": 0.00041105677,
				"type": "LOCATION"
			},
			{
				"name": "student bodies",
				"salience": 0.00041105677,
				"type": "OTHER"
			},
			{
				"name": "draft registration",
				"salience": 0.00041105677,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.00041105677,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.00041105677,
				"type": "OTHER"
			},
			{
				"name": "horizon",
				"salience": 0.00041105677,
				"type": "OTHER"
			},
			{
				"name": "storms",
				"salience": 0.00041105677,
				"type": "EVENT"
			},
			{
				"name": "signal",
				"salience": 0.0003530124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Justin_Raimondo"
				},
				"name": "Justin Raimondo",
				"salience": 0.00033866358,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00033866358,
				"type": "PERSON"
			},
			{
				"name": "Prometheus Books",
				"salience": 0.00033866358,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00033866358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnam",
				"salience": 0.00033866358,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Bibi Netanyahu",
				"salience": 0.0003301792,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02pkff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Capitol_Hill"
				},
				"name": "Capitol Hill",
				"salience": 0.00032357834,
				"type": "LOCATION"
			},
			{
				"name": "pro-Israel",
				"salience": 0.00029214637,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07qb5ct"
				},
				"name": "Hell",
				"salience": 0.00025295973,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00025295973,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T09:24:20.746+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 22.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "What Is To Be Done? How to build a new anti-interventionist movement Share This \nIn the midst of an election in which the issues are largely ignored in favor of sensationalism and smears, the anti-interventionist voter is pretty much at sea. Hillary Clinton’s demagogic Russia-baiting of Trump as a Kremlin “puppet” augurs a foreign policy that will take us back to the arctic winter of the cold war, circa 1950 . On the other hand, the GOP nominee, for all his encouraging “America first” rhetoric and his stated unwillingness to get into another arms race with the former Soviet Union, would likely take us into other quagmires – ISIS, China, Iran – and, in any event, cannot be trusted. \nSo what is to be done? \nThe first thing is to disabuse yourself of the notion that any politician or political party currently prominent will magically get us out of the business of Empire. This isn’t to say that political action is wrong, or ineffective – far from it. What I’m saying is that it is up to us to build a movement out of which a new politics of peace and liberty can be nurtured and brought to maturity. \nOur second task is to take stock of our assets: what kind of shape is the anti-interventionist movement in, and what are our prospects for future growth? \nThe first part of that question is easily answered: there is no anti-interventionist movement, as such, and there hasn’t been for quite some time. Oh sure, there are scattered organizations and individuals with a public platform, but none of these have a truly national presence. \nYes, Antiwar.com is one such voice with not insignificant reach, but we aren’t an organization – we’re a web site. We don’t have chapters, support groups, members, etc., and have quite deliberately avoided setting up any such network for the simple reason that we don’t have the resources to do so. Every movement has different components that specialize in various functions, and our specialty is education. That is, we give our readers the information they need in order to understand the problem, but as far as acting to eliminate the problem – that’s a mission we must leave to others. \nThe big problem is that there are no “others” – no action groups, no lobbyists, no real grassroots organizations that can respond to events as they occur, and mobilize the public against the War Party. The “movement,” such as it is, is top-heavy with thinktanks – the Cato Institute, the Center for the National Interest, the Ron Paul Institute , and the newly-organized student-oriented John Quincy Adams Society come to mind – and sorely lacking at the grassroots: essentially, a head with no body. \nThis isn’t because there is no potential for such a grassroots movement: indeed, the objective conditions are ripe – I would say over ripe – for such an undertaking. Polls consistently show that the American people are increasingly skeptical – and that is really too weak a word – of foreign entanglements, and basically endorse a foreign policy of minding our own business. This sentiment is one major – and deliberately overlooked – aspect of the populist “resentment” that catapulted Trump to the top of the GOP ticket and upended the political prognostications of the “experts.” The idea of putting America first – instead of, say, Europe, or the Saudis, or whichever country we’re supposedly ‘liberating” at great cost – has visceral appeal to ordinary Americans. \nThe astonishing fact of the matter is that, a few short years ago, the GOP was the spearhead of the War Party, with militant neoconservatives at its head – and is, today, the party of a man who said we were lied into the Iraq war, who wants to basically dismantle NATO, and who has adopted “America First” – a slogan resonant with historical meaning – as his campaign theme. \nWhen I was a kid I used to play a game with a good friend of mine: what would we do if we had a million dollars? Of course, I’m really dating myself, because today, of course, a million dollars is chump change. In any case, this column is basically a reiteration of that game: what would I do if I had the resources to organize a real grassroots anti-interventionist movement? \nWell, the very first thing I would do is to organize those millions of Trump voters attracted to his banner for precisely the reason the neocons and the foreign policy “experts” disdain him. Item number one on my agenda would be creating a grassroots America First movement, one with the following three components: \nThe America First Action (AFA) groups – the function of this organization is implied in its name. Its mission would be to respond to every move by the War Party to involve us in some foreign war by rapidly mobilizing people against it. At the first indication that such a move was in the works, congressional phone lines would be ringing off the hook with howls of protest. This is what happened when President Obama announced he was going to bomb Syria – and it worked , with very little central direction. Aside from telephonic harassment of congressional warmongers, AFA would organize meetings, rallies, lecture tours, media appearances, Internet trolling (my favorite!), and every other form of public activity, always focused like a laser on the War Party’s latest scheme. \nThe America First Political Action Committee – the electoral arm of the America First movement, AFPAC would help candidates from any and all political parties who oppose foreign wars and entangling alliances. This is one of our greatest weaknesses: currently, the War Party’s tame politicians are well-rewarded for their labors, while pro-peace candidates are routinely punished financially. The military-industrial-congressional complex takes care of its own – we must do the same. Yes, the war profiteers have tremendous resources but we can best them at their own game by appealing to the millions of Americans who are sick and tired of perpetual war. \nThe America First Lobby – while a different name would probably be best, I’m calling it a lobby because that is precisely its function. While practically every foreign government on earth has a Washington-based lobby, which meets with government officials and presses its case for more “foreign aid,” and often direct military intervention on their behalf – the American people have no such organization, no lobby to pursue and defend their interests. I would take as my model AIPAC, the notoriously powerful pro-Israel lobby, which practically storms Capitol Hill every time Bibi Netanyahu gives the signal. If only anti-interventionist Americans would do the same every time war clouds gather on the horizon, we would put an end to our foreign policy of constant warfare once and for all. \nThese three components of a newly constituted America First movement would be supplemented by subsidiary groups targeting specific constituencies. First and foremost, what’s needed is a student affiliate – it’s been a long time since we’ve heard “Hell no, we won’t go!” on the nation’s campuses. And what about abolishing draft registration? Hillary Clinton wants to force women to register for the draft – why isn’t this horrific proposal roiling the student bodies of universities and high schools across the country? \nAfrican-Americans suffer from our foreign policy of global intervention much more than most others: they are, too often, the cannon fodder that feeds the war machine, and if they return they come home to an economy drained by the diversion of vital resources toward war-making and away from productive job-creating and wealth-creating investment. \nRacial minorities, women, rural communities – all these groups suffer inordinately as a consequence of an internationalist elite that sacrifices our sons and daughters on the altar of the war god. They can and must be won over to the cause of peace. \nSuch a movement isn’t a pipedream. It can be born – and it can prosper to the extent that it organizes itself according to a strategic vision that unites people of various political persuasions around a single issue – intransigent opposition to military intervention abroad. \n“Peace” movements launched by the left have failed because they took a multi-issue approach: each and every leftist hobbyhorse was invoked to the point where the central issue – war and peace – was overshadowed. The organizers of these efforts, which have fallen by the wayside by the dozen, thought they were organizing a political party, which is why these movements never got off the ground. The one time they did manage to achieve some success – the antiwar protests of the 1960s – was when they junked the multi-issue approach, and focused on the single issue of getting us out of Vietnam. \nThe potential is there for such a movement today – but only if we cast aside our preconceptions and prejudices, and work to bring together elements that would naturally tend to split apart. Libertarians and Trumpists, Bernie Sanders supporters and “isolationist” conservatives, students at elite universities and rural folks who object to being used as cannon fodder – all must be united in a common cause to put America first, and rid ourselves of the albatross of empire. \nIt can be done. It must be done. But will it be done? I can’t answer that question: what I can say is that you, my readers, have the power to do it. Now, if only you have the will…. \nNOTES IN THE MARGIN \nYou can check out my Twitter feed by going here . But please note that my tweets are sometimes deliberately provocative, often made in jest, and largely consist of me thinking out loud. \nYou can buy An Enemy of the State: The Life of Murray N. Rothbard (Prometheus Books, 2000), my biography of the great libertarian thinker, here . Read more by Justin Raimondo",
		"thread_title": "What Is To Be Done?",
		"title": "What Is To Be Done?",
		"type": "bs",
		"uuid": "3ab60272c89bedcb8839f4641dc3bd0f5f4fc892"
	},
	"-KhIj5mUt796Pj75pGOB": {
		"author": "Margaret Griffis",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T09:24:20.762+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.2583524,
				"type": "PERSON"
			},
			{
				"name": "child soldiers",
				"salience": 0.13938949,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.09759946,
				"type": "LOCATION"
			},
			{
				"name": "operations",
				"salience": 0.09256244,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.05761201,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hr9tzh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Observatory_for_Human_Rights"
				},
				"name": "Syrian Observatory for Human Rights",
				"salience": 0.05761201,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.036562774,
				"type": "PERSON"
			},
			{
				"name": "village",
				"salience": 0.035011165,
				"type": "LOCATION"
			},
			{
				"name": "figures",
				"salience": 0.01990414,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.01786025,
				"type": "LOCATION"
			},
			{
				"name": "mass",
				"salience": 0.016062377,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09v0b7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bakhdida"
				},
				"name": "Hamdaniya",
				"salience": 0.014972233,
				"type": "LOCATION"
			},
			{
				"name": "deaths",
				"salience": 0.014890641,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.014171811,
				"type": "LOCATION"
			},
			{
				"name": "homes",
				"salience": 0.013979468,
				"type": "LOCATION"
			},
			{
				"name": "Ali Rash",
				"salience": 0.008617205,
				"type": "PERSON"
			},
			{
				"name": "villages",
				"salience": 0.0074670617,
				"type": "LOCATION"
			},
			{
				"name": "Kanona",
				"salience": 0.0070376494,
				"type": "LOCATION"
			},
			{
				"name": "Rozbian",
				"salience": 0.0070376494,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00622208,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.00622208,
				"type": "PERSON"
			},
			{
				"name": "Militants",
				"salience": 0.00622208,
				"type": "PERSON"
			},
			{
				"name": "Salmani",
				"salience": 0.0052595343,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04dkdf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zarqa"
				},
				"name": "Zarka",
				"salience": 0.0052595343,
				"type": "PERSON"
			},
			{
				"name": "Faziliya",
				"salience": 0.0052595343,
				"type": "PERSON"
			},
			{
				"name": "Kani Shirin",
				"salience": 0.0052595343,
				"type": "PERSON"
			},
			{
				"name": "Khadheir",
				"salience": 0.0052595343,
				"type": "PERSON"
			},
			{
				"name": "Kevrok",
				"salience": 0.0052595343,
				"type": "PERSON"
			},
			{
				"name": "Khrab Bet",
				"salience": 0.0052595343,
				"type": "OTHER"
			},
			{
				"name": "Qabr Esaaq",
				"salience": 0.0038317635,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0snv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anah"
				},
				"name": "Anah",
				"salience": 0.0038317635,
				"type": "LOCATION"
			},
			{
				"name": "Amrini",
				"salience": 0.0029738597,
				"type": "PERSON"
			},
			{
				"name": "Mad Al-Dibaj",
				"salience": 0.0028629007,
				"type": "PERSON"
			},
			{
				"name": "al-Thanya",
				"salience": 0.0028629007,
				"type": "PERSON"
			},
			{
				"name": "Mistanqa",
				"salience": 0.0028629007,
				"type": "PERSON"
			},
			{
				"name": "Qariya Al-Shik",
				"salience": 0.0028629007,
				"type": "PERSON"
			},
			{
				"name": "Jarn",
				"salience": 0.0028629007,
				"type": "OTHER"
			},
			{
				"name": "Ayin Al-Baiyza",
				"salience": 0.0028629007,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T09:24:20.762+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This The Syrian Observatory for Human Rights reports that 300 Daesh child soldiers were killed in Mosul operations. They believe the children were brought to Mosul from Syria. It is unclear if these deaths have already been counted in official figures. The first Christian mass in two years was held on Sunday in the Christian village of Qaraqosh , which is also known as Hamdaniya. However, many Christians doubt they will ever return to their homes. The village of Ali Rash was liberated . Kanona and Rozbian were also freed , as were about 11 villages west of Mosul, including Amrini, Ayin Al-Baiyza, Jarn, Mad Al-Dibaj, Mistanqa’ al-Thanya, Qariya Al-Shik, Salmani, and Zarka. Also freed were Faziliya, Kani Shirin, Khadheir, Kevrok, Khrab Bet, and Qabr Esaaq. Militants have trapped 7,000 civilians in Anah . At least 255 people were killed and 60 were wounded:",
		"thread_title": "255 Killed in Iraq; Baghdad Bombed",
		"title": "255 Killed in Iraq; Baghdad Bombed",
		"type": "bs",
		"uuid": "38337590d56d535f1cef5eef82b7c861f9520335"
	},
	"-KhIj641IhjdFN_zVW-5": {
		"author": "Bob Waldrop",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T17:28:47.133+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Bob Waldrop",
				"salience": 0.4814365,
				"type": "PERSON"
			},
			{
				"name": "Oscar Romero Catholic Worker House",
				"salience": 0.04017431,
				"type": "ORGANIZATION"
			},
			{
				"name": "evil",
				"salience": 0.039033182,
				"type": "OTHER"
			},
			{
				"name": "material cooperation",
				"salience": 0.039033182,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fvzg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_City"
				},
				"name": "Oklahoma City",
				"salience": 0.034606412,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05yfx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope_John_Paul_II"
				},
				"name": "John Paul II",
				"salience": 0.03296642,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.018474238,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.01380946,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.013480679,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0600q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portable_Document_Format"
				},
				"name": "PDF",
				"salience": 0.012479229,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.011999889,
				"type": "EVENT"
			},
			{
				"name": "military bishops",
				"salience": 0.011511913,
				"type": "PERSON"
			},
			{
				"name": "collection",
				"salience": 0.0109824715,
				"type": "OTHER"
			},
			{
				"name": "churches",
				"salience": 0.009014346,
				"type": "LOCATION"
			},
			{
				"name": "boycott",
				"salience": 0.009014346,
				"type": "OTHER"
			},
			{
				"name": "half page document",
				"salience": 0.008650732,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0c8wxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholicism"
				},
				"name": "Catholic",
				"salience": 0.005676942,
				"type": "ORGANIZATION"
			},
			{
				"name": "offering",
				"salience": 0.0053675952,
				"type": "OTHER"
			},
			{
				"name": "bishops",
				"salience": 0.0052303225,
				"type": "PERSON"
			},
			{
				"name": "document",
				"salience": 0.004994573,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Archdiocese of Military Services",
				"salience": 0.0049064877,
				"type": "ORGANIZATION"
			},
			{
				"name": "version",
				"salience": 0.0046497895,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "boycott",
				"salience": 0.004615111,
				"type": "OTHER"
			},
			{
				"name": "collection plate",
				"salience": 0.004168009,
				"type": "OTHER"
			},
			{
				"name": "founder",
				"salience": 0.0039234576,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09wpt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope_Benedict_XVI"
				},
				"name": "Benedict XVI",
				"salience": 0.0037916373,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.003789175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/096lth",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edwin_Frederick_O'Brien"
				},
				"name": "Edwin O'Brien",
				"salience": 0.0037107542,
				"type": "PERSON"
			},
			{
				"name": "sisters",
				"salience": 0.0035310944,
				"type": "PERSON"
			},
			{
				"name": "paper trail",
				"salience": 0.0034986392,
				"type": "LOCATION"
			},
			{
				"name": "envelope",
				"salience": 0.003447375,
				"type": "OTHER"
			},
			{
				"name": "Archdiocese for Military Services Collection",
				"salience": 0.0032922146,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0031346295,
				"type": "PERSON"
			},
			{
				"name": "Actions",
				"salience": 0.0029423367,
				"type": "OTHER"
			},
			{
				"name": "copies",
				"salience": 0.0029111851,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.002763746,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.002763746,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0025362875,
				"type": "EVENT"
			},
			{
				"name": "Archbishop",
				"salience": 0.002432525,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0023441797,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0023346555,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0022451284,
				"type": "LOCATION"
			},
			{
				"name": "www.justpeace.org/mscollection.pdf",
				"salience": 0.0021695846,
				"type": "OTHER"
			},
			{
				"name": "complexity",
				"salience": 0.002161403,
				"type": "OTHER"
			},
			{
				"name": "military adventures",
				"salience": 0.00210817,
				"type": "OTHER"
			},
			{
				"name": "embargo",
				"salience": 0.00210817,
				"type": "EVENT"
			},
			{
				"name": "performance",
				"salience": 0.00210817,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.00210817,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0020589922,
				"type": "OTHER"
			},
			{
				"name": "Pope",
				"salience": 0.0019022787,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0mzj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Military_branch"
				},
				"name": "Military Services",
				"salience": 0.0018836553,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027k49j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bishop_(Catholic_Church)"
				},
				"name": "Catholic Bishops",
				"salience": 0.0018384579,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.001803863,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.001778856,
				"type": "EVENT"
			},
			{
				"name": "page",
				"salience": 0.0017176905,
				"type": "OTHER"
			},
			{
				"name": "brother",
				"salience": 0.0017176905,
				"type": "PERSON"
			},
			{
				"name": "Text",
				"salience": 0.0017176905,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attack",
				"salience": 0.0017100233,
				"type": "EVENT"
			},
			{
				"name": "Bishops",
				"salience": 0.0016424019,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.0015779249,
				"type": "OTHER"
			},
			{
				"name": "Armed Services",
				"salience": 0.0015595703,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0015520789,
				"type": "OTHER"
			},
			{
				"name": "United States Bishops",
				"salience": 0.0014978165,
				"type": "PERSON"
			},
			{
				"name": "boycott call",
				"salience": 0.0014875026,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.0014875026,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0014875026,
				"type": "OTHER"
			},
			{
				"name": "distribution",
				"salience": 0.0014875026,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0014763855,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0014523697,
				"type": "EVENT"
			},
			{
				"name": "consequences",
				"salience": 0.0014439627,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0014439627,
				"type": "OTHER"
			},
			{
				"name": "conscience",
				"salience": 0.0013900868,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0013340188,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.0013284375,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0012842417,
				"type": "PERSON"
			},
			{
				"name": "science fiction",
				"salience": 0.0012512179,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0012456311,
				"type": "EVENT"
			},
			{
				"name": "terrorism",
				"salience": 0.0012045279,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0012045279,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0011788938,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0011691285,
				"type": "OTHER"
			},
			{
				"name": "judgment",
				"salience": 0.0011595788,
				"type": "OTHER"
			},
			{
				"name": "judgments",
				"salience": 0.0011595788,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0011595788,
				"type": "ORGANIZATION"
			},
			{
				"name": "most",
				"salience": 0.0011595788,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0010891178,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.0010834972,
				"type": "EVENT"
			},
			{
				"name": "communities",
				"salience": 0.0010430615,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.0010430615,
				"type": "LOCATION"
			},
			{
				"name": "forms",
				"salience": 0.0010430615,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.0010430615,
				"type": "OTHER"
			},
			{
				"name": "injury",
				"salience": 0.0010430615,
				"type": "OTHER"
			},
			{
				"name": "dislocation",
				"salience": 0.0010430615,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0010430615,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0010430615,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.0010041337,
				"type": "OTHER"
			},
			{
				"name": "prudence",
				"salience": 0.0010041337,
				"type": "OTHER"
			},
			{
				"name": "factors",
				"salience": 0.0010041337,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0010041337,
				"type": "PERSON"
			},
			{
				"name": "fallacy",
				"salience": 0.0010041337,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0010041337,
				"type": "OTHER"
			},
			{
				"name": "wisdom",
				"salience": 0.0010041337,
				"type": "OTHER"
			},
			{
				"name": "relativism",
				"salience": 0.0010041337,
				"type": "OTHER"
			},
			{
				"name": "military duties",
				"salience": 0.0010041337,
				"type": "OTHER"
			},
			{
				"name": "brothers",
				"salience": 0.0009833836,
				"type": "PERSON"
			},
			{
				"name": "science fiction",
				"salience": 0.00091134873,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0008861736,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0008807122,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0008807122,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0008807122,
				"type": "OTHER"
			},
			{
				"name": "Gospel",
				"salience": 0.0008515447,
				"type": "OTHER"
			},
			{
				"name": "hierarchy",
				"salience": 0.0008515447,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0008515447,
				"type": "ORGANIZATION"
			},
			{
				"name": "clergy",
				"salience": 0.0008515447,
				"type": "PERSON"
			},
			{
				"name": "protection",
				"salience": 0.0008515447,
				"type": "OTHER"
			},
			{
				"name": "conversion",
				"salience": 0.0008515447,
				"type": "EVENT"
			},
			{
				"name": "fathers",
				"salience": 0.0008515447,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0008515447,
				"type": "PERSON"
			},
			{
				"name": "mothers",
				"salience": 0.0008515447,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.00081976067,
				"type": "OTHER"
			},
			{
				"name": "food security",
				"salience": 0.000734629,
				"type": "OTHER"
			},
			{
				"name": "church musician",
				"salience": 0.000734629,
				"type": "PERSON"
			},
			{
				"name": "gardens",
				"salience": 0.000734629,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07xg1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Armed_Forces"
				},
				"name": "US Armed Forces",
				"salience": 0.0007137742,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0007137742,
				"type": "LOCATION"
			},
			{
				"name": "problems",
				"salience": 0.0007040479,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00064203335,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.00064203335,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00064203335,
				"type": "LOCATION"
			},
			{
				"name": "justice",
				"salience": 0.000641441,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.000641441,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.000641441,
				"type": "OTHER"
			},
			{
				"name": "collection",
				"salience": 0.00053996907,
				"type": "OTHER"
			},
			{
				"name": "food security",
				"salience": 0.0005350315,
				"type": "OTHER"
			},
			{
				"name": "gardens",
				"salience": 0.0005350315,
				"type": "LOCATION"
			},
			{
				"name": "church musician",
				"salience": 0.0005350315,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Christ",
				"salience": 0.00052412396,
				"type": "PERSON"
			},
			{
				"name": "parishioners",
				"salience": 0.0004516793,
				"type": "PERSON"
			},
			{
				"name": "offerings",
				"salience": 0.00040992894,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07w42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libertarian_Party_(United_States)"
				},
				"name": "Libertarian Party",
				"salience": 0.00040186086,
				"type": "ORGANIZATION"
			},
			{
				"name": "http://www.justpeace.org/warresponse.htm",
				"salience": 0.00040186086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Justin_Raimondo"
				},
				"name": "Justin Raimondo",
				"salience": 0.00040186086,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08z7kl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Garris"
				},
				"name": "Eric Garris",
				"salience": 0.00040186086,
				"type": "PERSON"
			},
			{
				"name": "San Jose Flea Market",
				"salience": 0.00040186086,
				"type": "LOCATION"
			},
			{
				"name": "collection plate",
				"salience": 0.00039966105,
				"type": "OTHER"
			},
			{
				"name": "Text",
				"salience": 0.00039966105,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Military Services Archdiocese",
				"salience": 0.00034846325,
				"type": "ORGANIZATION"
			},
			{
				"name": "lieu",
				"salience": 0.00034606195,
				"type": "OTHER"
			},
			{
				"name": "money donation",
				"salience": 0.00034606195,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.00034606195,
				"type": "OTHER"
			},
			{
				"name": "copying",
				"salience": 0.00034606195,
				"type": "OTHER"
			},
			{
				"name": "download",
				"salience": 0.00034606195,
				"type": "OTHER"
			},
			{
				"name": "envelope",
				"salience": 0.00033463602,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01bqks",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_government_of_the_United_States"
				},
				"name": "United States Government",
				"salience": 0.00021297298,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T17:28:47.133+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Bob Waldrop, founder of the Oscar Romero Catholic Worker House in Oklahoma City, is calling for a boycott of the 2016 national collection in Catholic churches for the Archdiocese of Military Services, accusing the military bishops of material cooperation with the objective evil of unjust war. To facilitate the boycott, he has prepared a half page document that can be printed and placed in the collection plate or offering envelope the weekend of November 5-6, 2016, when the offering is to be collected. A PDF version of the document is available at www.justpeace.org/mscollection.pdf . This has two copies on one page to facilitate distribution.\nText of the boycott call:\nI am not giving to the 2016 Archdiocese for Military Services Collection.\nThe bishops of the Archdiocese for Military Services, together with nearly all of their brother United States Bishops, are guilty of material cooperation with the objective evil of unjust war . In 2003, both Pope John Paul II and then Cardinal Ratzinger , who later became Benedict XVI, condemned our attack on Iraq as an unjust war. In spite of the Pope’s opposition, the Most Rev. Edwin O’Brien , then Archbishop for the Military Services advised Catholic members of the US Armed Forces: “Given the complexity of factors involved, many of which understandably remain confidential, it is altogether appropriate for members of our armed forces to presume the integrity of our leadership and its judgments and therefore to carry out their military duties in good conscience.”\t\n\t\t\t\nSubsequent events have sadly proven the truth, wisdom, and prudence of Pope John Paul II’s judgment, and the fallacy and danger of the moral relativism embraced by the Bishops of the Archdiocese for Military Services and most of the other US Catholic Bishops regarding unjust war. The consequences cascading from our invasion brought death and injury and social dislocation to hundreds of thousands and devastated the historic Christian communities of Iraq and subsequently Syria. It may fairly be said that those who enabled and supported the war on the people of Iraq are \"secondary terrorists\" in that they created the objective conditions on the ground in the Middle East that are driving the extreme forms of terrorism currently prevalent in the region. Actions have consequences and those who propose the actions must own the consequences.\nTherefore, because of these issues, I am not giving to the collection for the Archdiocese of Military Services. Instead, I will donate to an organization working to resolve the problems caused by war.\nIt is a sad and scandalous day when a people’s religious leaders fail them so egregiously. I promise to pray for the conversion of the Military Services hierarchy and clergy, and for the moral and physical protection of the members of our Armed Services, who are our sisters, brothers, fathers, mothers, and children. They deserve religious leaders who will courageously preach and teach all of the Gospel of Christ, not just that which is acceptable to the United States Government.\nText prepared by Bob Waldrop, Oscar Romero Catholic Worker House, Oklahoma City. PDF suitable for download and copying is available at www.justpeace.org/mscollection.pdf . Place this document in the collection plate or offering envelope for the Military Services collection the weekend of November 5-6. We invite those responsible for forwarding these offerings to the Military Services Archdiocese to also send any of these documents that parishioners give in lieu of a money donation.\nBob Waldrop is the founder of the Oscar Romero Catholic Worker House in Oklahoma City, which works in food security and for justice and peace. He has consistently opposed all of the United States military adventures since the 1970s when he met Justin Raimondo and Eric Garris tabling for the Libertarian Party at the San Jose Flea Market. He has been a consistent critic of the poor performance of the United States Catholic Bishops on the issues of war and peace since the embargo on the civilian economy of Iraq. His antiwar paper trail is at http://www.justpeace.org/warresponse.htm. He gardens, reads science fiction, and works as a church musician.\nBob Waldrop is the founder of the Oscar Romero Catholic Worker House in Oklahoma City, which works in food security and for justice and peace. He has consistently opposed all of the United States military adventures since the 1970s when he met Justin Raimondo and Eric Garris tabling for the Libertarian Party at the San Jose Flea Market. He has been a consistent critic of the poor performance of the United States Catholic Bishops on the issues of war and peace since the embargo on the civilian economy of Iraq. His anti-war paper trail is at http://www.justpeace.org/warresponse.htm . He gardens, reads science fiction, and works as a church musician. \n",
		"thread_title": "Oklahoma City Catholic Worker Calls for Boycott of the 2016 National Collection for the Archdiocese of Military Services",
		"title": "Oklahoma City Catholic Worker Calls for Boycott of the 2016 National Collection for the Archdiocese of Military Services",
		"type": "bs",
		"uuid": "d0ac77dde52275bca094673a69e26097e7e6f267"
	},
	"-KhIj6D31HZWSwSJAS8C": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T03:14:26.305+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "rebels",
				"salience": 0.22727461,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.06075212,
				"type": "PERSON"
			},
			{
				"name": "West Aleppo",
				"salience": 0.051501244,
				"type": "LOCATION"
			},
			{
				"name": "Western Aleppo",
				"salience": 0.051501244,
				"type": "LOCATION"
			},
			{
				"name": "favor",
				"salience": 0.042273335,
				"type": "OTHER"
			},
			{
				"name": "Rocket Fire Pounds Government",
				"salience": 0.040428426,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.034232117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.03288775,
				"type": "LOCATION"
			},
			{
				"name": "offensive",
				"salience": 0.027165474,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.027165474,
				"type": "ORGANIZATION"
			},
			{
				"name": "advance",
				"salience": 0.026491508,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.023553107,
				"type": "OTHER"
			},
			{
				"name": "snail",
				"salience": 0.023553107,
				"type": "OTHER"
			},
			{
				"name": "pace",
				"salience": 0.023553107,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.023228228,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.022231117,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.017517528,
				"type": "PERSON"
			},
			{
				"name": "attempts",
				"salience": 0.011121126,
				"type": "OTHER"
			},
			{
				"name": "rockets",
				"salience": 0.01042973,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.01042973,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.009784172,
				"type": "EVENT"
			},
			{
				"name": "parts",
				"salience": 0.0094200475,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.0094200475,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.008849103,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.008849103,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.008475807,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.008475807,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.008475807,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.008475807,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.008160227,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.008160227,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.008160227,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.008160227,
				"type": "PERSON"
			},
			{
				"name": "sides",
				"salience": 0.007991985,
				"type": "OTHER"
			},
			{
				"name": "artillery fire",
				"salience": 0.007991985,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.007991985,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00782947,
				"type": "ORGANIZATION"
			},
			{
				"name": "battle",
				"salience": 0.006922662,
				"type": "EVENT"
			},
			{
				"name": "counter-offensive",
				"salience": 0.0066647674,
				"type": "OTHER"
			},
			{
				"name": "momentum",
				"salience": 0.0057610073,
				"type": "OTHER"
			},
			{
				"name": "latest",
				"salience": 0.005512168,
				"type": "OTHER"
			},
			{
				"name": "factions",
				"salience": 0.0051740133,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0051740133,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.0051740133,
				"type": "LOCATION"
			},
			{
				"name": "east",
				"salience": 0.0051740133,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.00457899,
				"type": "ORGANIZATION"
			},
			{
				"name": "posts",
				"salience": 0.0037697002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attacks",
				"salience": 0.003252496,
				"type": "EVENT"
			},
			{
				"name": "amount",
				"salience": 0.0028166526,
				"type": "OTHER"
			},
			{
				"name": "bystanders",
				"salience": 0.0028166526,
				"type": "PERSON"
			},
			{
				"name": "anybody",
				"salience": 0.0028166526,
				"type": "PERSON"
			},
			{
				"name": "advantage",
				"salience": 0.0024300895,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T03:14:26.305+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Heavy Rocket Fire Pounds Government-Held West Aleppo by Jason Ditz, October 31, 2016 Share This \nNusra Front-led rebels continue to try to push into Western Aleppo in an offensive they launched on Friday, but the advance appears to be slowing to a snail’s pace amid heavy resistance from the military. At the same time, the rebels continue to fire rockets against the government-held parts of the city. \nSome 84 people have been killed over the course of the offensive, most of them women and children , and the UN has been harshly critical of the rebels for their “indiscriminate” attacks against areas with a large number of civilians present. \nThis has been a recurring problem throughout the battle over Aleppo, which has left the city heavy divided and badly damaged. Both sides regularly trade rocket and artillery fire, and both sides seem to have a hard time making such attacks hit anybody except for civilian bystanders. \nOver the past month the military had a seemingly decisive advantage in Aleppo, with the Nusra Front losing a growing amount of territory in the east. This newest counter-offensive is the latest in a long, long line of attempts by different factions within the city to shift the momentum in their favor, which is a big part of why, despite it being heavily contested since 2012, no one appears close to really controlling Aleppo. Last 5 posts by Jason Ditz",
		"thread_title": "Rebel Attacks on Syria’s Aleppo Slow, But Civilian Toll Rises",
		"title": "Rebel Attacks on Syria’s Aleppo Slow, But Civilian Toll Rises",
		"type": "bs",
		"uuid": "4c112185a83f571a11d19d989b9c4a092227950e"
	},
	"-KhIj6MqHQ4zwz5KcRnF": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T03:14:26.373+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.3344254,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02bt3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nangarhar_Province"
				},
				"name": "Nangarhar Province",
				"salience": 0.097786956,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.060079392,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.049646337,
				"type": "PERSON"
			},
			{
				"name": "Council of Elders",
				"salience": 0.0476008,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.04621544,
				"type": "OTHER"
			},
			{
				"name": "Set Up Anti-ISIS Coalition",
				"salience": 0.028699456,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.024598492,
				"type": "ORGANIZATION"
			},
			{
				"name": "elders",
				"salience": 0.024598492,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.022235947,
				"type": "LOCATION"
			},
			{
				"name": "suicide bomber",
				"salience": 0.019282494,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.019282494,
				"type": "EVENT"
			},
			{
				"name": "council",
				"salience": 0.018030152,
				"type": "ORGANIZATION"
			},
			{
				"name": "council",
				"salience": 0.017035652,
				"type": "ORGANIZATION"
			},
			{
				"name": "elders",
				"salience": 0.016667793,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.015061023,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/044rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jalalabad"
				},
				"name": "Jalalabad",
				"salience": 0.011910803,
				"type": "LOCATION"
			},
			{
				"name": "council",
				"salience": 0.0092456285,
				"type": "ORGANIZATION"
			},
			{
				"name": "coalition",
				"salience": 0.008874074,
				"type": "ORGANIZATION"
			},
			{
				"name": "victims",
				"salience": 0.006944107,
				"type": "PERSON"
			},
			{
				"name": "apostates",
				"salience": 0.006944107,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.006944107,
				"type": "LOCATION"
			},
			{
				"name": "government officials",
				"salience": 0.0068568704,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0066856598,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.0066856598,
				"type": "OTHER"
			},
			{
				"name": "formation",
				"salience": 0.006119292,
				"type": "OTHER"
			},
			{
				"name": "toll",
				"salience": 0.0056720683,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0056720683,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0056720683,
				"type": "EVENT"
			},
			{
				"name": "anti-ISIS",
				"salience": 0.0054703094,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.005420093,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0049656536,
				"type": "ORGANIZATION"
			},
			{
				"name": "coalition",
				"salience": 0.004775857,
				"type": "ORGANIZATION"
			},
			{
				"name": "example",
				"salience": 0.004691498,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00423968,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.00423968,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.00423968,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.00423968,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.003949908,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-ISIS",
				"salience": 0.0033388815,
				"type": "ORGANIZATION"
			},
			{
				"name": "establishment",
				"salience": 0.0030891728,
				"type": "EVENT"
			},
			{
				"name": "posts",
				"salience": 0.0030891728,
				"type": "WORK_OF_ART"
			},
			{
				"name": "provinces",
				"salience": 0.0026654047,
				"type": "LOCATION"
			},
			{
				"name": "operations",
				"salience": 0.0023082823,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0019021195,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0019021195,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/07/afghan.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T03:14:26.373+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Council of Elders Intended to Set Up Anti-ISIS Coalition by Jason Ditz, October 31, 2016 Share This \nISIS has killed a number of Afghan tribal elders and wounded several more in Nangarhar Province’s main city of Jalalabad today, with a suicide bomber from the group targeting a meeting of the council of elders in the city. \nThe details are still scant, but ISIS claims that the council was established in part to discuss the formation of a tribal anti-ISIS coalition in the area. They claimed 15 killed and 25 wounded, labeling the victims “apostates.” \nAfghan government officials put the toll a lot lower, saying only four were killed and seven wounded in the attack. Nangarhar is the main base of operations for ISIS forces in Afghanistan, though they’ve recently begun to pop up around several other provinces. \nWhether the council was at the point of establishing an anti-ISIS coalition or not, this is in keeping with the group’s reaction to any sign of growing local resistance, with ISIS having similarly made an example of tribal groups in Iraq and Syria during their establishment there. Last 5 posts by Jason Ditz",
		"thread_title": "ISIS Kills Afghan Tribal Elders in Jalalabad Suicide Attack",
		"title": "ISIS Kills Afghan Tribal Elders in Jalalabad Suicide Attack",
		"type": "bs",
		"uuid": "2856ee96fdd12232af09e9d39bba675777ddae26"
	},
	"-KhIj6Y1px6JCSYWAxow": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:17:21.563+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.26266834,
				"type": "LOCATION"
			},
			{
				"name": "Jeffrey Harrigan",
				"salience": 0.120509155,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.10113254,
				"type": "LOCATION"
			},
			{
				"name": "anti-ISIS",
				"salience": 0.09218188,
				"type": "ORGANIZATION"
			},
			{
				"name": "Govt Warns Civilians Against Fleeing Mosul",
				"salience": 0.08384352,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.038403917,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.024678506,
				"type": "PERSON"
			},
			{
				"name": "coalition",
				"salience": 0.022959888,
				"type": "ORGANIZATION"
			},
			{
				"name": "air forces",
				"salience": 0.022959888,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.01851355,
				"type": "LOCATION"
			},
			{
				"name": "warplanes",
				"salience": 0.016760886,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.014044538,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.013873492,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.013051719,
				"type": "PERSON"
			},
			{
				"name": "combat zone",
				"salience": 0.011579214,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.011002765,
				"type": "PERSON"
			},
			{
				"name": "escape",
				"salience": 0.010029632,
				"type": "EVENT"
			},
			{
				"name": "surveillance",
				"salience": 0.009536655,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.009536655,
				"type": "EVENT"
			},
			{
				"name": "airstrikes",
				"salience": 0.009536655,
				"type": "EVENT"
			},
			{
				"name": "lack",
				"salience": 0.008458878,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.006293232,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.0060548424,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0041312035,
				"type": "LOCATION"
			},
			{
				"name": "concern",
				"salience": 0.0038579958,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.0038094884,
				"type": "PERSON"
			},
			{
				"name": "concerns",
				"salience": 0.0038094884,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0034273537,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.0034273537,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0034273537,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.003384248,
				"type": "ORGANIZATION"
			},
			{
				"name": "elsewhere",
				"salience": 0.0032996524,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0032996524,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0032996524,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.0032996524,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.003278319,
				"type": "PERSON"
			},
			{
				"name": "fall",
				"salience": 0.0032171668,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0030879285,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0030879285,
				"type": "LOCATION"
			},
			{
				"name": "solution",
				"salience": 0.0027289393,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002415104,
				"type": "PERSON"
			},
			{
				"name": "invasion",
				"salience": 0.0020916099,
				"type": "EVENT"
			},
			{
				"name": "offensive",
				"salience": 0.0020916099,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.002032289,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0017594979,
				"type": "PERSON"
			},
			{
				"name": "posts",
				"salience": 0.0015237262,
				"type": "WORK_OF_ART"
			},
			{
				"name": "combat",
				"salience": 0.0013146113,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012w_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manbij"
				},
				"name": "Manbij",
				"salience": 0.0012878254,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:17:21.563+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Iraqi Govt Warns Civilians Against Fleeing Mosul by Jason Ditz, October 31, 2016 Share This \nAccording to Lt. Gen. Jeffrey Harrigan, the commander of US air forces in the Middle East, the anti-ISIS coalition is now planning on carrying out airstrikes against any fleeing ISIS fighters around Mosul, trying to prevent escape from the massive city with aerial surveillance and targeted strikes. \nThis appears to be a response to growing concerns, both within the region and internationally, that the fall of Mosul will mean thousands of seasoned ISIS fighters popping up elsewhere around the world, destabilizing the Middle East and Europe. \nPreventing them from escaping Mosul, however, raises a major concern that the relative lack of US intelligence on who it is targeting, and determination to shoot first and ask questions later is going to lead to US warplanes attacking groups of fleeing civilians that they come across. \nThe “solution” to this appears to be preventing civilians from fleeing the city as well, despite it being an open combat zone that will likely be facing months of combat. Iraqi officials are now said to be warning Mosul civilians not to try to escape, insisting they will be safer if they stay put. \nStaying put in a city during an invasion is far from safe, but suggests US warplanes are going to be particularly indiscriminate in targeting people fleeing Mosul. In the recent offensive against the ISIS city of Manbij, US warplanes killed hundreds of civilians they “mistook” for ISIS, and Mosul is a much larger city with a lot more people to be mistaken for ISIS. Last 5 posts by Jason Ditz",
		"thread_title": "US General: Warplanes Will Kill Fleeing ISIS Fighters Around Mosul",
		"title": "US General: Warplanes Will Kill Fleeing ISIS Fighters Around Mosul",
		"type": "bs",
		"uuid": "692db9803b2059f1516728d845ff9384f6ed24ad"
	},
	"-KhIj6hF46aDl-4pFkKS": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:17:22.225+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Rebels",
				"salience": 0.22643262,
				"type": "PERSON"
			},
			{
				"name": "Fights",
				"salience": 0.066901095,
				"type": "EVENT"
			},
			{
				"name": "town",
				"salience": 0.060581453,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.05655668,
				"type": "PERSON"
			},
			{
				"name": "Tel Kurdi",
				"salience": 0.044689164,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.036590245,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.035656307,
				"type": "PERSON"
			},
			{
				"name": "pullouts",
				"salience": 0.03515356,
				"type": "EVENT"
			},
			{
				"name": "Growing Losses",
				"salience": 0.032700863,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.032307684,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.032307684,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.02998126,
				"type": "LOCATION"
			},
			{
				"name": "rebel",
				"salience": 0.027945517,
				"type": "PERSON"
			},
			{
				"name": "outskirts",
				"salience": 0.021972967,
				"type": "LOCATION"
			},
			{
				"name": "rebel city",
				"salience": 0.021972967,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.016527047,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.014876493,
				"type": "LOCATION"
			},
			{
				"name": "rebel forces",
				"salience": 0.012683952,
				"type": "PERSON"
			},
			{
				"name": "rebel areas",
				"salience": 0.011238094,
				"type": "LOCATION"
			},
			{
				"name": "fighting",
				"salience": 0.010113294,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02qgf3r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Douma,_Syria"
				},
				"name": "Douma",
				"salience": 0.00917841,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.00911374,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.00911374,
				"type": "PERSON"
			},
			{
				"name": "fights",
				"salience": 0.008262342,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.007913967,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.007913967,
				"type": "LOCATION"
			},
			{
				"name": "siege",
				"salience": 0.0076194424,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.007462422,
				"type": "OTHER"
			},
			{
				"name": "losses",
				"salience": 0.007462422,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.0064643472,
				"type": "OTHER"
			},
			{
				"name": "fashions",
				"salience": 0.0064643472,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0064643472,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.0064643472,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0064643472,
				"type": "OTHER"
			},
			{
				"name": "rebel council",
				"salience": 0.0064643472,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0055786297,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0051974794,
				"type": "LOCATION"
			},
			{
				"name": "amounts",
				"salience": 0.004831949,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.004831949,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02q8ml2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ghouta"
				},
				"name": "Ghouta",
				"salience": 0.0046950076,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0038844266,
				"type": "LOCATION"
			},
			{
				"name": "posts",
				"salience": 0.0035207595,
				"type": "WORK_OF_ART"
			},
			{
				"name": "north",
				"salience": 0.0035207595,
				"type": "LOCATION"
			},
			{
				"name": "rebel influence",
				"salience": 0.0035207595,
				"type": "OTHER"
			},
			{
				"name": "government control",
				"salience": 0.0035207595,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.0030377996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07l57d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idlib"
				},
				"name": "Idlib",
				"salience": 0.0029759314,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.0029759314,
				"type": "ORGANIZATION"
			},
			{
				"name": "lot",
				"salience": 0.0026307914,
				"type": "OTHER"
			},
			{
				"name": "military offensives",
				"salience": 0.0026307914,
				"type": "OTHER"
			},
			{
				"name": "villages",
				"salience": 0.0026307914,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:17:22.225+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Rebels Blame Internal Fights for Growing Losses by Jason Ditz, October 31, 2016 Share This \nThe Syrian Army has entered the town of Tel Kurdi , on the outskirts of Damascus, entering the area over the weekend and pushing into yet another rebel-held area, bringing their forces yet closer to the rebel city of Douma, the last major rebel holding around the capital. \nTel Kurdi, like all the remaining rebel areas in Ghouta, was under siege for some time, and the rebel forces within fell back almost immediately, with no reports of major fighting, and the rebels bragging of a “scorched earth” policy destroying everything of value on their way out. \nOne of the members of the rebel council blamed the mounting losses on internal fights among the fashions. Indeed, over the past several months a lot of towns and villages in the area have fallen, either in military offensives or in negotiated pullouts. \nThe negotiated pullouts have been the most effective way to displace large amounts of rebels lately, with the rebels getting sent north into Nusra Front territory around Idlib. This is increasingly boiling down to government control of the area around Damascus, and increased rebel influence in the north. Last 5 posts by Jason Ditz",
		"thread_title": "Syrian Army Enters Metro Damascus Town, Driving Rebels Further Back",
		"title": "Syrian Army Enters Metro Damascus Town, Driving Rebels Further Back",
		"type": "bs",
		"uuid": "9d49a0d963b225bf2403c26995f7623dbf78f534"
	},
	"-KhIj6viAmq6aQVU3L6a": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:38:19.237+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.3680152,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0s8xxjb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andrew_Parker_(MI5_officer)"
				},
				"name": "Andrew Parker",
				"salience": 0.20988427,
				"type": "PERSON"
			},
			{
				"name": "spy",
				"salience": 0.037326824,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.03518979,
				"type": "LOCATION"
			},
			{
				"name": "newspaper interview",
				"salience": 0.034072697,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.028744183,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.027551541,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.024916241,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01db5m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Opposition_(planets)"
				},
				"name": "Opposition",
				"salience": 0.02052887,
				"type": "ORGANIZATION"
			},
			{
				"name": "ways",
				"salience": 0.019764932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0phpy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MI5"
				},
				"name": "MI5",
				"salience": 0.017803919,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "Guardian",
				"salience": 0.017803919,
				"type": "ORGANIZATION"
			},
			{
				"name": "interests",
				"salience": 0.016496537,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.015816635,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.011945483,
				"type": "LOCATION"
			},
			{
				"name": "opposition",
				"salience": 0.010643186,
				"type": "ORGANIZATION"
			},
			{
				"name": "range",
				"salience": 0.009763536,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0064650807,
				"type": "OTHER"
			},
			{
				"name": "state organs",
				"salience": 0.006118968,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.006118968,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0056353337,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.004957396,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.004504798,
				"type": "LOCATION"
			},
			{
				"name": "operations",
				"salience": 0.0042940797,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.0042940797,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0041783205,
				"type": "PERSON"
			},
			{
				"name": "cyberwarfare",
				"salience": 0.0041341055,
				"type": "OTHER"
			},
			{
				"name": "advent",
				"salience": 0.0041341055,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.0041341055,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.003815132,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0035068255,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0035068255,
				"type": "OTHER"
			},
			{
				"name": "talking point",
				"salience": 0.0035068255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0029890998,
				"type": "LOCATION"
			},
			{
				"name": "base",
				"salience": 0.0029001588,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.0026206833,
				"type": "EVENT"
			},
			{
				"name": "interests",
				"salience": 0.0019745522,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0019091956,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00142642,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00142642,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.00142642,
				"type": "OTHER"
			},
			{
				"name": "anti-ISIS coalition",
				"salience": 0.0014036212,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.0011753587,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.0011753587,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2011/11/Russia.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:38:19.237+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.3,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Insists Russia Defines Itself by Opposition to the West   \nThe first time a top British spy has ever given a newspaper interview, MI5 chief Andrew Parker has spoken with the Guardian , playing up the “growing threat” posed by Russia against British interests around the world. \nParker claimed a “whole range of state organs and powers” in Russia are being brought to bear against Britain and the US, claiming that the advent of cyberwarfare has increased the number of ways in which Russia can move against them. \nParker went on to claim that Russia defines itself by opposition to the West and, despite being a “covert threat for decades” has been increasingly hostile, citing their operations in Ukraine and Syria as proof that they are acting to just spite the West. \nThis has been a common western talking point, but in practice Western (read: US) policy in both Ukraine and Syria appears to have itself been built with an eye toward being on the opposite side from Russia in the first place, and Russia is then condemned for acting in their own interests. \nThis was particularly glaring in Syria, where Russia’s interest was obviously in the survival of a friendly Syrian government to host their naval base, and where “countering” Russia has brought the US “anti-ISIS coalition” into increasingly overt support for al-Qaeda’s Nusra Front, simply because they’re the ones most directly fighting against Russia.  ",
		"thread_title": "MI5 Chief Presents Russia as Growing Threat to British Interests",
		"title": "MI5 Chief Presents Russia as Growing Threat to British Interests",
		"type": "bs",
		"uuid": "7628aaa28d8e7fa58b4bd7d4e1d2e4ff1571f964"
	},
	"-KhIj76z8MppT37ziDqk": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:38:20.166+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.49040085,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.090674214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.08908271,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.032457307,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.028941678,
				"type": "EVENT"
			},
			{
				"name": "arms",
				"salience": 0.028672861,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.027687877,
				"type": "OTHER"
			},
			{
				"name": "Arms Sales",
				"salience": 0.02400131,
				"type": "OTHER"
			},
			{
				"name": "bombers",
				"salience": 0.02400131,
				"type": "PERSON"
			},
			{
				"name": "amounts",
				"salience": 0.020832649,
				"type": "OTHER"
			},
			{
				"name": "military solution",
				"salience": 0.011129894,
				"type": "OTHER"
			},
			{
				"name": "airspace",
				"salience": 0.009982264,
				"type": "LOCATION"
			},
			{
				"name": "airstrikes",
				"salience": 0.009982264,
				"type": "EVENT"
			},
			{
				"name": "Administration",
				"salience": 0.008872864,
				"type": "ORGANIZATION"
			},
			{
				"name": "call",
				"salience": 0.0057306816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0053376313,
				"type": "PERSON"
			},
			{
				"name": "director",
				"salience": 0.004902496,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.003775968,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.003589637,
				"type": "PERSON"
			},
			{
				"name": "arms sales",
				"salience": 0.003589637,
				"type": "OTHER"
			},
			{
				"name": "death tolls",
				"salience": 0.0032707097,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.003261855,
				"type": "ORGANIZATION"
			},
			{
				"name": "air war",
				"salience": 0.0032463018,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0032463018,
				"type": "EVENT"
			},
			{
				"name": "dial",
				"salience": 0.0031092523,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0031092523,
				"type": "OTHER"
			},
			{
				"name": "peace plan",
				"salience": 0.0029934,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.0029934,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0029934,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0029316396,
				"type": "EVENT"
			},
			{
				"name": "bombs",
				"salience": 0.0028223908,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckxt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Watch"
				},
				"name": "Human Rights Watch",
				"salience": 0.0027301675,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vznt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Samantha_Power"
				},
				"name": "Samantha Power",
				"salience": 0.0025770317,
				"type": "PERSON"
			},
			{
				"name": "bit",
				"salience": 0.0025391413,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.002444492,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.002222642,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.002190932,
				"type": "EVENT"
			},
			{
				"name": "sign",
				"salience": 0.002056478,
				"type": "OTHER"
			},
			{
				"name": "pro-Saudi",
				"salience": 0.0019150624,
				"type": "LOCATION"
			},
			{
				"name": "self-defense",
				"salience": 0.001897459,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.001897459,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.001897459,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.001897459,
				"type": "LOCATION"
			},
			{
				"name": "funeral",
				"salience": 0.001897459,
				"type": "EVENT"
			},
			{
				"name": "review",
				"salience": 0.001897459,
				"type": "OTHER"
			},
			{
				"name": "expectation",
				"salience": 0.0017809907,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.0014541595,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0013822812,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0013822812,
				"type": "OTHER"
			},
			{
				"name": "arms exports",
				"salience": 0.0013822812,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0011925759,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0011925759,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.0010327266,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.0008797373,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.000635695,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/08/yemen.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:38:20.166+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "No Sign US Is Going to Slow Arms Sales to Saudis   \nAfter a solid 19 months of endorsing the Saudi war in Yemen, selling the Saudis massive amounts of arms, and refueling Saudi bombers over Yemen’s airspace, the Obama Administration today called on the Saudis to halt airstrikes against Yemen, and accept that there is no military solution. \nA top Human Rights Watch director noted that the call would’ve carried a lot more weight if the US wasn’t providing the bombs the Saudis are dropping on Yemen in the first place, though former US officials say its almost certain this won’t include any dial back in US arms sales. \nThe call likely reflects the UN’s peace plan being presented to both sides and immediately rejected by the pro-Saudi officials. Huge civilian death tolls in recent Saudi attacks have added up to make the US a bit more gunshy than usual about supporting the Saudi war publicly. \nAt the same time, the US “opposition” to the air war is slim indeed, with the US Ambassador to the UN, Samantha Power, insisting even in the announcement of their opposition to further strikes that the US supports Saudi Arabia’s right to “self-defense,” which in this case included an outright invasion of a neighboring country. \nThe US has insisted Saudi aid is “under review” since a recent attack on a funeral. That said, there is no sign that any real changes in US policy were made, and the expectation is that, as always, US interest in growing arms exports will win out.  ",
		"thread_title": "US Calls on Saudis to End Airstrikes Against Yemen",
		"title": "US Calls on Saudis to End Airstrikes Against Yemen",
		"type": "bs",
		"uuid": "01e7c0bc99ecb14b494de5857370cc86cc10c99a"
	},
	"-KhIj7GYH6Hz9qrTimFE": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T04:47:53.681+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "area",
				"salience": 0.2988447,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.14578491,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.13021888,
				"type": "LOCATION"
			},
			{
				"name": "Liberate' Eastern Bank",
				"salience": 0.08725332,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.07453391,
				"type": "EVENT"
			},
			{
				"name": "Goal",
				"salience": 0.035868928,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.02616294,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.025832692,
				"type": "ORGANIZATION"
			},
			{
				"name": "Military",
				"salience": 0.024351215,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.018494511,
				"type": "LOCATION"
			},
			{
				"name": "suburbs",
				"salience": 0.017078357,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07pgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tigris"
				},
				"name": "Tigris River",
				"salience": 0.013679292,
				"type": "LOCATION"
			},
			{
				"name": "first",
				"salience": 0.011703873,
				"type": "OTHER"
			},
			{
				"name": "special forces",
				"salience": 0.011363111,
				"type": "PERSON"
			},
			{
				"name": "eastern bank",
				"salience": 0.010784606,
				"type": "ORGANIZATION"
			},
			{
				"name": "incursion",
				"salience": 0.007838912,
				"type": "OTHER"
			},
			{
				"name": "Karama District",
				"salience": 0.0072309836,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0063266517,
				"type": "PERSON"
			},
			{
				"name": "goal",
				"salience": 0.005428276,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.0040594237,
				"type": "EVENT"
			},
			{
				"name": "Indications",
				"salience": 0.0040594237,
				"type": "OTHER"
			},
			{
				"name": "district",
				"salience": 0.0040594237,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.0035165802,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0032911089,
				"type": "LOCATION"
			},
			{
				"name": "site",
				"salience": 0.0029833096,
				"type": "LOCATION"
			},
			{
				"name": "perspective",
				"salience": 0.0029833096,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.0028129364,
				"type": "PERSON"
			},
			{
				"name": "military officials",
				"salience": 0.0020019263,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0017752538,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0016246118,
				"type": "WORK_OF_ART"
			},
			{
				"name": "invasion",
				"salience": 0.0014017238,
				"type": "EVENT"
			},
			{
				"name": "measures",
				"salience": 0.0012138957,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0012138957,
				"type": "OTHER"
			},
			{
				"name": "anticipation",
				"salience": 0.0012138957,
				"type": "OTHER"
			},
			{
				"name": "traps",
				"salience": 0.0012138957,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0010793222,
				"type": "LOCATION"
			},
			{
				"name": "indications",
				"salience": 0.0007159864,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:47:53.681+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Military: Goal Is to 'Liberate' Eastern Bank of Tigris River by Jason Ditz, October 31, 2016 Share This \nIraq’s invasion of Mosul has entered its third week with a noteworthy first, as the first Iraqi special forces entered the city itself in the area around Karama District, in the far east. There was fighting reported both within the district and in surrounding suburbs. \nIndications are that the vast majority of the fighting in the area remains in the suburbs, with only a small incursion into the city itself. Still, Iraqi military officials say their goal is to take the whole eastern bank of the Tigris River, which divides the city. \nThe area entered is near a key industrial site within Mosul. It is unclear how well secured this area is from ISIS’ perspective, as they’ve laid heavy traps and tunneled in around the city in anticipation of the invasion, but indications were that a lot of these defensive measures were taken in residential areas. \nISIS is believed to have several thousand fighters in Mosul, and with the US announcing they intend to kill anyone who tries to escape, they are likely to resist all the more fiercely, knowing they don’t have any place to go after Mosul. Last 5 posts by Jason Ditz",
		"thread_title": "First Iraqi Troops Enter Mosul, But Fighting Remains Largely in Suburbs",
		"title": "First Iraqi Troops Enter Mosul, But Fighting Remains Largely in Suburbs",
		"type": "bs",
		"uuid": "4c1ae5b21f9f66c4eff19d32ec36fa957ab6b8b4"
	},
	"-KhIj8OYw2vgTy80-QUk": {
		"author": "Ted Snider",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T06:02:39.382+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.7130826,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04pnx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latin_America"
				},
				"name": "Latin American",
				"salience": 0.016922165,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.014400767,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.0087005375,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0739dz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manuel_Zelaya"
				},
				"name": "Manuel Zelaya",
				"salience": 0.005913799,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03h2c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Honduras"
				},
				"name": "Honduras",
				"salience": 0.0057671443,
				"type": "LOCATION"
			},
			{
				"name": "administration",
				"salience": 0.0051626973,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ylj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venezuela"
				},
				"name": "Venezuelan",
				"salience": 0.0050019366,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/083pr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_Howard_Taft"
				},
				"name": "Taft",
				"salience": 0.004886316,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0046325973,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028rk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dwight_D._Eisenhower"
				},
				"name": "Eisenhower",
				"salience": 0.004532389,
				"type": "ORGANIZATION"
			},
			{
				"name": "business",
				"salience": 0.004077337,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.003907278,
				"type": "EVENT"
			},
			{
				"name": "action",
				"salience": 0.0034820833,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0034092658,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup leader",
				"salience": 0.0030821436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0030667603,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0lxng",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omar_Torrijos"
				},
				"name": "Omar Torrijos",
				"salience": 0.0029103858,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h7c_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rafael_Correa"
				},
				"name": "Rafael Correa",
				"salience": 0.0027963184,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026m5c8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dilma_Rousseff"
				},
				"name": "Dilma Rousseff",
				"salience": 0.002746648,
				"type": "PERSON"
			},
			{
				"name": "Aloysio Nunes",
				"salience": 0.00266596,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07hyk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Theodore_Roosevelt"
				},
				"name": "Theodore Roosevelt",
				"salience": 0.0024683324,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.0021061064,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup",
				"salience": 0.0017946076,
				"type": "EVENT"
			},
			{
				"name": "nation",
				"salience": 0.0017613781,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gd2ms",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Weisbrot"
				},
				"name": "Mark Weisbrot",
				"salience": 0.0017044469,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015fr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brazil"
				},
				"name": "Brazilian",
				"salience": 0.0016926291,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027zf5x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fernando_Lugo"
				},
				"name": "Fernando Lugo",
				"salience": 0.0016876921,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04fw8yd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michel_Temer"
				},
				"name": "Michel Temer",
				"salience": 0.001604986,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.0016020046,
				"type": "OTHER"
			},
			{
				"name": "cable",
				"salience": 0.0015018727,
				"type": "OTHER"
			},
			{
				"name": "commission",
				"salience": 0.0015008247,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup",
				"salience": 0.001343837,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/083p7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_McKinley"
				},
				"name": "McKinley",
				"salience": 0.0013095965,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01ms5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Juan_Vicente_G%C3%B3mez"
				},
				"name": "Juan Vicente Gómez",
				"salience": 0.0013095965,
				"type": "PERSON"
			},
			{
				"name": "companies",
				"salience": 0.001304145,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0012672765,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02k1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ecuador"
				},
				"name": "Ecuadorian",
				"salience": 0.0012088432,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuba",
				"salience": 0.0012088353,
				"type": "LOCATION"
			},
			{
				"name": "term",
				"salience": 0.0011860958,
				"type": "EVENT"
			},
			{
				"name": "performance",
				"salience": 0.0011860958,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0011860958,
				"type": "OTHER"
			},
			{
				"name": "office approaches",
				"salience": 0.0011860958,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.001137867,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0010963557,
				"type": "PERSON"
			},
			{
				"name": "coups",
				"salience": 0.0010675029,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hmbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jean-Bertrand_Aristide"
				},
				"name": "Jean-Bertrand Aristide",
				"salience": 0.0010049128,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h7hb4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicol%C3%A1s_Maduro"
				},
				"name": "Nicolás Maduro",
				"salience": 0.0009806986,
				"type": "PERSON"
			},
			{
				"name": "Linda Jewell",
				"salience": 0.0009798865,
				"type": "PERSON"
			},
			{
				"name": "coup",
				"salience": 0.0009768726,
				"type": "EVENT"
			},
			{
				"name": "promise",
				"salience": 0.00094130106,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.00094042375,
				"type": "EVENT"
			},
			{
				"name": "consideration",
				"salience": 0.0009027626,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.00089476415,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.00089476415,
				"type": "OTHER"
			},
			{
				"name": "opposition politicians",
				"salience": 0.0008742044,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0008645921,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0008537013,
				"type": "PERSON"
			},
			{
				"name": "assassination",
				"salience": 0.0008537013,
				"type": "EVENT"
			},
			{
				"name": "assassination",
				"salience": 0.0008537013,
				"type": "EVENT"
			},
			{
				"name": "plane",
				"salience": 0.0008233431,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.00081840577,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.00081840577,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00081840577,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00081840577,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00081840577,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.00081840577,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00081840577,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.00081840577,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05pzq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Organization_of_American_States"
				},
				"name": "Organization of American States",
				"salience": 0.00080520485,
				"type": "ORGANIZATION"
			},
			{
				"name": "chief",
				"salience": 0.00077560847,
				"type": "PERSON"
			},
			{
				"name": "removal",
				"salience": 0.0007748277,
				"type": "EVENT"
			},
			{
				"name": "action",
				"salience": 0.0007748277,
				"type": "OTHER"
			},
			{
				"name": "covert action",
				"salience": 0.0007748277,
				"type": "OTHER"
			},
			{
				"name": "removal",
				"salience": 0.0007748277,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.00076646195,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0007391294,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0007391294,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0007391294,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0007391294,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0007391294,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0007391294,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0007391294,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.0007262692,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0007262692,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04mj68",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Union_of_South_American_Nations"
				},
				"name": "Union of South American Nations",
				"salience": 0.0006847875,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections",
				"salience": 0.00067519647,
				"type": "EVENT"
			},
			{
				"name": "vice president",
				"salience": 0.0006751342,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.0006723726,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.00067095755,
				"type": "EVENT"
			},
			{
				"name": "backyard",
				"salience": 0.00067095755,
				"type": "LOCATION"
			},
			{
				"name": "agreements",
				"salience": 0.00067095755,
				"type": "OTHER"
			},
			{
				"name": "backyard",
				"salience": 0.00067095755,
				"type": "LOCATION"
			},
			{
				"name": "assassination",
				"salience": 0.00067095755,
				"type": "EVENT"
			},
			{
				"name": "promise",
				"salience": 0.00066987134,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gxs24",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_J._Sullivan"
				},
				"name": "Mark Sullivan",
				"salience": 0.0006646012,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/024fpr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fanmi_Lavalas"
				},
				"name": "Fanmi Lavalas",
				"salience": 0.00066098187,
				"type": "ORGANIZATION"
			},
			{
				"name": "overthrow",
				"salience": 0.0006507813,
				"type": "OTHER"
			},
			{
				"name": "military commanders",
				"salience": 0.0006486089,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haitian",
				"salience": 0.00064164144,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Panama"
				},
				"name": "Panama",
				"salience": 0.00063896575,
				"type": "LOCATION"
			},
			{
				"name": "plane crash",
				"salience": 0.00063733256,
				"type": "EVENT"
			},
			{
				"name": "act",
				"salience": 0.00063733256,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.00063733256,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.000634813,
				"type": "EVENT"
			},
			{
				"name": "06QUITO2150",
				"salience": 0.0006184894,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0006058148,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.0006058148,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0006058148,
				"type": "EVENT"
			},
			{
				"name": "beginning",
				"salience": 0.0006058148,
				"type": "OTHER"
			},
			{
				"name": "plane crash",
				"salience": 0.0006058148,
				"type": "EVENT"
			},
			{
				"name": "maneuver",
				"salience": 0.0006058148,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0005981818,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.00058544887,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.00058089726,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01ms95",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jos%C3%A9_Santos_Zelaya"
				},
				"name": "José Santos Zelaya",
				"salience": 0.00057178154,
				"type": "PERSON"
			},
			{
				"name": "Jucá",
				"salience": 0.0005651611,
				"type": "PERSON"
			},
			{
				"name": "coup",
				"salience": 0.000559215,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01ty6q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Circular_error_probable"
				},
				"name": "CEP",
				"salience": 0.0005578763,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rodolfo Pastor Fasquelle",
				"salience": 0.00055650406,
				"type": "PERSON"
			},
			{
				"name": "Michael Temer",
				"salience": 0.00055122987,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.00054427376,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0005383417,
				"type": "EVENT"
			},
			{
				"name": "voice",
				"salience": 0.0005245904,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0005245904,
				"type": "PERSON"
			},
			{
				"name": "table",
				"salience": 0.0005245904,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0005245904,
				"type": "EVENT"
			},
			{
				"name": "earth",
				"salience": 0.0005245904,
				"type": "LOCATION"
			},
			{
				"name": "terrors",
				"salience": 0.0005245904,
				"type": "OTHER"
			},
			{
				"name": "close",
				"salience": 0.0005245904,
				"type": "EVENT"
			},
			{
				"name": "business",
				"salience": 0.0005239197,
				"type": "OTHER"
			},
			{
				"name": "coup government",
				"salience": 0.0005217866,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup government",
				"salience": 0.0005217866,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup",
				"salience": 0.0005182471,
				"type": "EVENT"
			},
			{
				"name": "coups",
				"salience": 0.0005182471,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.00049890217,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00049890217,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00049890217,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00049890217,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00049890217,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00049890217,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00049890217,
				"type": "EVENT"
			},
			{
				"name": "coup president",
				"salience": 0.0004976252,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05c74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nicaragua"
				},
				"name": "Nicaragua",
				"salience": 0.0004910264,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haitians",
				"salience": 0.00047693774,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05v10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paraguay"
				},
				"name": "Paraguayan",
				"salience": 0.00046650675,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d3k14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy"
				},
				"name": "Kennedy",
				"salience": 0.0004664042,
				"type": "PERSON"
			},
			{
				"name": "lack",
				"salience": 0.00046497874,
				"type": "OTHER"
			},
			{
				"name": "Honduran Coup",
				"salience": 0.00045495795,
				"type": "ORGANIZATION"
			},
			{
				"name": "Bridge",
				"salience": 0.00045351582,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.00045136147,
				"type": "PERSON"
			},
			{
				"name": "The New Confessions of an Economic Hit Man",
				"salience": 0.00044704,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.00044158698,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00044158698,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/034ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_H._W._Bush"
				},
				"name": "George H.W. Bush",
				"salience": 0.0004341721,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04vgbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Perkins_(author)"
				},
				"name": "John Perkins",
				"salience": 0.0004322327,
				"type": "PERSON"
			},
			{
				"name": "coup",
				"salience": 0.0004230766,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0004230766,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.0004230766,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/020sgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy_Now!"
				},
				"name": "Democracy Now",
				"salience": 0.00042171165,
				"type": "WORK_OF_ART"
			},
			{
				"name": "removal",
				"salience": 0.00042157984,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00040215024,
				"type": "EVENT"
			},
			{
				"name": "doubt",
				"salience": 0.0003852543,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0003852543,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00038237328,
				"type": "ORGANIZATION"
			},
			{
				"name": "military",
				"salience": 0.00038237328,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.0003703816,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00036846948,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.00036846948,
				"type": "PERSON"
			},
			{
				"name": "promise",
				"salience": 0.00036833147,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0003658325,
				"type": "ORGANIZATION"
			},
			{
				"name": "players",
				"salience": 0.00036581812,
				"type": "PERSON"
			},
			{
				"name": "embassy",
				"salience": 0.00036231804,
				"type": "LOCATION"
			},
			{
				"name": "cable",
				"salience": 0.0003532434,
				"type": "OTHER"
			},
			{
				"name": "embassy",
				"salience": 0.0003532434,
				"type": "LOCATION"
			},
			{
				"name": "constitution",
				"salience": 0.0003532434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "coup government",
				"salience": 0.00035217495,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00035217495,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00035217495,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00035217495,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup government",
				"salience": 0.00035217495,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup government",
				"salience": 0.00035217495,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.0003510959,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00034430146,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manuel_Noriega"
				},
				"name": "Manuel Noriega",
				"salience": 0.00034401484,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d1b_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hugo_Ch%C3%A1vez"
				},
				"name": "Hugo Chavez",
				"salience": 0.0003421782,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028v0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silence"
				},
				"name": "Silence",
				"salience": 0.0003405507,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0003358649,
				"type": "PERSON"
			},
			{
				"name": "Presidents",
				"salience": 0.00033368912,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06c97",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Richard_Nixon"
				},
				"name": "Nixon",
				"salience": 0.00032287673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/034m8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guyana"
				},
				"name": "Guyana",
				"salience": 0.00032287673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01p1v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chile"
				},
				"name": "Chile",
				"salience": 0.00032287673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dl1k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salvador_Allende"
				},
				"name": "Salvador Allende",
				"salience": 0.00032287673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020m38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amy_Goodman"
				},
				"name": "Amy Goodman",
				"salience": 0.00032287673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spain",
				"salience": 0.00032287673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012m7r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jo%C3%A3o_Goulart"
				},
				"name": "Goulart",
				"salience": 0.00032287673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021w2m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cheddi_Jagan"
				},
				"name": "Cheddi Jagan",
				"salience": 0.00032287673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09k0f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fidel_Castro"
				},
				"name": "Fidel Castro",
				"salience": 0.00032287673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/066rl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Panama_Canal"
				},
				"name": "Panama Canal",
				"salience": 0.00032287673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guatemala"
				},
				"name": "Guatemala",
				"salience": 0.00032287673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016x2n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jacobo_%C3%81rbenz"
				},
				"name": "Jacobo Arbenz",
				"salience": 0.00032287673,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00032287673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01w5m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Columbia_University"
				},
				"name": "Columbia",
				"salience": 0.00032287673,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00032225673,
				"type": "ORGANIZATION"
			},
			{
				"name": "silence",
				"salience": 0.00031893782,
				"type": "OTHER"
			},
			{
				"name": "removal",
				"salience": 0.00031893782,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00031603646,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00031603646,
				"type": "EVENT"
			},
			{
				"name": "business",
				"salience": 0.00031083816,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0003095962,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0003095962,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0003095962,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.0003095962,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0003095962,
				"type": "EVENT"
			},
			{
				"name": "embassy",
				"salience": 0.0003072451,
				"type": "LOCATION"
			},
			{
				"name": "none",
				"salience": 0.00030024836,
				"type": "OTHER"
			},
			{
				"name": "military base",
				"salience": 0.00029894174,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00029894174,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00029894174,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0002986433,
				"type": "ORGANIZATION"
			},
			{
				"name": "conclusions",
				"salience": 0.00029033562,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00028600908,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.00028600908,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.00028600908,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.00028554274,
				"type": "EVENT"
			},
			{
				"name": "belief",
				"salience": 0.0002853957,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00028114277,
				"type": "OTHER"
			},
			{
				"name": "Case",
				"salience": 0.00027616616,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00027616616,
				"type": "OTHER"
			},
			{
				"name": "ambassador",
				"salience": 0.00027616616,
				"type": "PERSON"
			},
			{
				"name": "indication",
				"salience": 0.00027616616,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00027616616,
				"type": "OTHER"
			},
			{
				"name": "correspondence",
				"salience": 0.00027533076,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attempt",
				"salience": 0.0002732608,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nation",
				"salience": 0.00027303855,
				"type": "ORGANIZATION"
			},
			{
				"name": "Sergio Machado",
				"salience": 0.00026624228,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.00026612324,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0002638732,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "US State Department",
				"salience": 0.0002604406,
				"type": "ORGANIZATION"
			},
			{
				"name": "leaders",
				"salience": 0.00025823142,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.00025823142,
				"type": "PERSON"
			},
			{
				"name": "plane",
				"salience": 0.000258068,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.000258068,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.000258068,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00025273292,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.00025273292,
				"type": "EVENT"
			},
			{
				"name": "coup defenders",
				"salience": 0.00024934422,
				"type": "PERSON"
			},
			{
				"name": "refusal",
				"salience": 0.00024934422,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.00024934422,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.00024934422,
				"type": "PERSON"
			},
			{
				"name": "performance",
				"salience": 0.00024934422,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00024934422,
				"type": "OTHER"
			},
			{
				"name": "gunpoint",
				"salience": 0.00024934422,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0002477288,
				"type": "OTHER"
			},
			{
				"name": "embassy cable",
				"salience": 0.00024765232,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "constitution",
				"salience": 0.00024765232,
				"type": "WORK_OF_ART"
			},
			{
				"name": "military base",
				"salience": 0.00024714993,
				"type": "OTHER"
			},
			{
				"name": "conspirators",
				"salience": 0.00023840576,
				"type": "PERSON"
			},
			{
				"name": "conspirators",
				"salience": 0.00023840576,
				"type": "PERSON"
			},
			{
				"name": "call",
				"salience": 0.0002382392,
				"type": "OTHER"
			},
			{
				"name": "senator",
				"salience": 0.0002368612,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.00023347705,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup",
				"salience": 0.0002301584,
				"type": "EVENT"
			},
			{
				"name": "process",
				"salience": 0.00022957522,
				"type": "OTHER"
			},
			{
				"name": "free trade agreement",
				"salience": 0.00022831935,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.00022736346,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00022637237,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00022637237,
				"type": "OTHER"
			},
			{
				"name": "test",
				"salience": 0.00022427758,
				"type": "OTHER"
			},
			{
				"name": "cable",
				"salience": 0.00022375544,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00022359913,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00022359913,
				"type": "OTHER"
			},
			{
				"name": "coup government",
				"salience": 0.00022307856,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00022307856,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup government",
				"salience": 0.00022307856,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00022307856,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04zxyzm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antonio_Ledezma"
				},
				"name": "Antonio Ledezma",
				"salience": 0.00022049042,
				"type": "PERSON"
			},
			{
				"name": "coup",
				"salience": 0.00021877224,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00021877224,
				"type": "EVENT"
			},
			{
				"name": "arguments",
				"salience": 0.00021590358,
				"type": "OTHER"
			},
			{
				"name": "receipt",
				"salience": 0.00021590358,
				"type": "OTHER"
			},
			{
				"name": "victor",
				"salience": 0.00021590358,
				"type": "PERSON"
			},
			{
				"name": "dialogue",
				"salience": 0.00021590358,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00021590358,
				"type": "OTHER"
			},
			{
				"name": "subtlety",
				"salience": 0.00021590358,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00021525045,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.00021274606,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.00021274606,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.00021274606,
				"type": "PERSON"
			},
			{
				"name": "promise",
				"salience": 0.00021080034,
				"type": "OTHER"
			},
			{
				"name": "foreign policy promise",
				"salience": 0.00021080034,
				"type": "OTHER"
			},
			{
				"name": "police unit",
				"salience": 0.0002095792,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0002095792,
				"type": "ORGANIZATION"
			},
			{
				"name": "wing opposition",
				"salience": 0.00020216401,
				"type": "OTHER"
			},
			{
				"name": "counterparts",
				"salience": 0.00020175388,
				"type": "PERSON"
			},
			{
				"name": "military base",
				"salience": 0.00020175388,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00019542557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06n3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_America"
				},
				"name": "South American",
				"salience": 0.00019495415,
				"type": "LOCATION"
			},
			{
				"name": "change",
				"salience": 0.00019361063,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.00019280004,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00019280004,
				"type": "OTHER"
			},
			{
				"name": "alliances",
				"salience": 0.00018461209,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.00018421774,
				"type": "OTHER"
			},
			{
				"name": "silence",
				"salience": 0.00018252809,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00018252809,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00018252809,
				"type": "PERSON"
			},
			{
				"name": "indicator",
				"salience": 0.0001771606,
				"type": "OTHER"
			},
			{
				"name": "station chief",
				"salience": 0.00017480535,
				"type": "PERSON"
			},
			{
				"name": "vision",
				"salience": 0.00017480535,
				"type": "OTHER"
			},
			{
				"name": "concert",
				"salience": 0.00017480535,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.00017480535,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.00017480535,
				"type": "OTHER"
			},
			{
				"name": "runoff",
				"salience": 0.00017480535,
				"type": "EVENT"
			},
			{
				"name": "validity",
				"salience": 0.00017402432,
				"type": "OTHER"
			},
			{
				"name": "coup",
				"salience": 0.00017191932,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00017191932,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00017191932,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00017191932,
				"type": "EVENT"
			},
			{
				"name": "coup",
				"salience": 0.00017191932,
				"type": "EVENT"
			},
			{
				"name": "grade",
				"salience": 0.00017108294,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.00017108294,
				"type": "PERSON"
			},
			{
				"name": "grounds",
				"salience": 0.00017108294,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.00017108294,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ecuador"
				},
				"name": "Ecuadorians",
				"salience": 0.0001706619,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08_fyc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ALBA"
				},
				"name": "Bolivarian Alliance for the Peoples of Our America",
				"salience": 0.00016985639,
				"type": "ORGANIZATION"
			},
			{
				"name": "Corrrea",
				"salience": 0.00016944598,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.00016909114,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05p0f1z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boaventura_de_Sousa_Santos"
				},
				"name": "Boaventura de Sousa Santos",
				"salience": 0.00016864105,
				"type": "PERSON"
			},
			{
				"name": "oil companies",
				"salience": 0.00016827822,
				"type": "ORGANIZATION"
			},
			{
				"name": "contact",
				"salience": 0.00016827822,
				"type": "OTHER"
			},
			{
				"name": "oil contracts",
				"salience": 0.00016827822,
				"type": "OTHER"
			},
			{
				"name": "coup d'état",
				"salience": 0.00016827822,
				"type": "ORGANIZATION"
			},
			{
				"name": "return",
				"salience": 0.00016827822,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00016827822,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.00016827822,
				"type": "OTHER"
			},
			{
				"name": "Secretary",
				"salience": 0.00016827822,
				"type": "PERSON"
			},
			{
				"name": "coup d'état",
				"salience": 0.00016827822,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.00016827822,
				"type": "OTHER"
			},
			{
				"name": "communique",
				"salience": 0.00016805569,
				"type": "OTHER"
			},
			{
				"name": "embassy",
				"salience": 0.0001671363,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.00016679721,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0001634629,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.0001634629,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0001634629,
				"type": "ORGANIZATION"
			},
			{
				"name": "military base",
				"salience": 0.00016261883,
				"type": "OTHER"
			},
			{
				"name": "coup government",
				"salience": 0.00016245646,
				"type": "ORGANIZATION"
			},
			{
				"name": "coup government",
				"salience": 0.00016245646,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00016143871,
				"type": "ORGANIZATION"
			},
			{
				"name": "military officials",
				"salience": 0.00015974134,
				"type": "PERSON"
			},
			{
				"name": "cost",
				"salience": 0.00015923817,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0377d0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zelaya_Department"
				},
				"name": "Zelaya",
				"salience": 0.00015882099,
				"type": "LOCATION"
			},
			{
				"name": "votes",
				"salience": 0.0001580471,
				"type": "OTHER"
			},
			{
				"name": "foreign policy leaders",
				"salience": 0.00015745887,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "George W. Bush",
				"salience": 0.00015345168,
				"type": "PERSON"
			},
			{
				"name": "coup",
				"salience": 0.00015143797,
				"type": "EVENT"
			},
			{
				"name": "dictators",
				"salience": 0.00015135999,
				"type": "PERSON"
			},
			{
				"name": "debt",
				"salience": 0.00015135999,
				"type": "OTHER"
			},
			{
				"name": "actors",
				"salience": 0.00015135999,
				"type": "PERSON"
			},
			{
				"name": "assistance",
				"salience": 0.00015135999,
				"type": "OTHER"
			},
			{
				"name": "suspension",
				"salience": 0.00015135999,
				"type": "EVENT"
			},
			{
				"name": "indignation",
				"salience": 0.00015022783,
				"type": "OTHER"
			},
			{
				"name": "runoff",
				"salience": 0.00015012287,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qwr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Academi"
				},
				"name": "Blackwater",
				"salience": 0.00014733191,
				"type": "ORGANIZATION"
			},
			{
				"name": "hemisphere",
				"salience": 0.00014570817,
				"type": "LOCATION"
			},
			{
				"name": "military personnel",
				"salience": 0.00014570817,
				"type": "PERSON"
			},
			{
				"name": "share",
				"salience": 0.00014570817,
				"type": "OTHER"
			},
			{
				"name": "revenue",
				"salience": 0.00014570817,
				"type": "OTHER"
			},
			{
				"name": "destination",
				"salience": 0.00014570817,
				"type": "LOCATION"
			},
			{
				"name": "heat",
				"salience": 0.00014570817,
				"type": "OTHER"
			},
			{
				"name": "north",
				"salience": 0.00014570817,
				"type": "LOCATION"
			},
			{
				"name": "proximity",
				"salience": 0.00014570817,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00014401278,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00014401278,
				"type": "OTHER"
			},
			{
				"name": "removal",
				"salience": 0.00014343626,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.0001426956,
				"type": "LOCATION"
			},
			{
				"name": "round results",
				"salience": 0.0001426956,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.0001426956,
				"type": "EVENT"
			},
			{
				"name": "goal",
				"salience": 0.0001426956,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0001426956,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0001426956,
				"type": "OTHER"
			},
			{
				"name": "election results",
				"salience": 0.0001426956,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0001426956,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.00014205801,
				"type": "OTHER"
			},
			{
				"name": "loans",
				"salience": 0.00013849928,
				"type": "OTHER"
			},
			{
				"name": "phone call",
				"salience": 0.00013633976,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.00013352087,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vp7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_General_Assembly"
				},
				"name": "General Assembly",
				"salience": 0.00013286997,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05fzrr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Congress_of_Honduras"
				},
				"name": "National Congress",
				"salience": 0.00013286997,
				"type": "ORGANIZATION"
			},
			{
				"name": "Open and Shut",
				"salience": 0.00013286997,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.00013223788,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00012779042,
				"type": "OTHER"
			},
			{
				"name": "confession",
				"salience": 0.00012779042,
				"type": "OTHER"
			},
			{
				"name": "Confession",
				"salience": 0.00012779042,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0001270036,
				"type": "OTHER"
			},
			{
				"name": "participation",
				"salience": 0.0001270036,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00012355638,
				"type": "OTHER"
			},
			{
				"name": "skirmish",
				"salience": 0.00012355638,
				"type": "PERSON"
			},
			{
				"name": "strategy",
				"salience": 0.00012355638,
				"type": "OTHER"
			},
			{
				"name": "successor",
				"salience": 0.00012355638,
				"type": "PERSON"
			},
			{
				"name": "monitors",
				"salience": 0.00012355638,
				"type": "OTHER"
			},
			{
				"name": "missteps",
				"salience": 0.00012355638,
				"type": "OTHER"
			},
			{
				"name": "wishes",
				"salience": 0.00012355638,
				"type": "OTHER"
			},
			{
				"name": "government allies",
				"salience": 0.000121467914,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.000121346624,
				"type": "ORGANIZATION"
			},
			{
				"name": "doubt",
				"salience": 0.000119936776,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.00011805293,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00011805293,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cp1mjc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Provisional_Electoral_Council"
				},
				"name": "Provisional Electoral Council",
				"salience": 0.000118018426,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.00011744333,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0165v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bolivia"
				},
				"name": "Bolivia",
				"salience": 0.00011470041,
				"type": "LOCATION"
			},
			{
				"name": "foreign policy",
				"salience": 0.000114667106,
				"type": "OTHER"
			},
			{
				"name": "foreign policy promise",
				"salience": 0.000114667106,
				"type": "OTHER"
			},
			{
				"name": "planning minister",
				"salience": 0.000113565264,
				"type": "PERSON"
			},
			{
				"name": "phone calls",
				"salience": 0.00011271578,
				"type": "OTHER"
			},
			{
				"name": "objections",
				"salience": 0.00011022551,
				"type": "OTHER"
			},
			{
				"name": "06QUITO2991",
				"salience": 0.000107575936,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j9c2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Hemisphere_Institute_for_Security_Cooperation"
				},
				"name": "School of the Americas",
				"salience": 0.000107575936,
				"type": "ORGANIZATION"
			},
			{
				"name": "document",
				"salience": 0.000106585765,
				"type": "WORK_OF_ART"
			},
			{
				"name": "role",
				"salience": 0.000106585765,
				"type": "OTHER"
			},
			{
				"name": "generals",
				"salience": 0.000106585765,
				"type": "PERSON"
			},
			{
				"name": "justices",
				"salience": 0.000106585765,
				"type": "PERSON"
			},
			{
				"name": "justices",
				"salience": 0.000106585765,
				"type": "PERSON"
			},
			{
				"name": "audience",
				"salience": 0.000106585765,
				"type": "PERSON"
			},
			{
				"name": "maneuver",
				"salience": 0.000106585765,
				"type": "EVENT"
			},
			{
				"name": "banks",
				"salience": 0.000106585765,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.000106585765,
				"type": "OTHER"
			},
			{
				"name": "refusal",
				"salience": 0.000106585765,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000104874816,
				"type": "OTHER"
			},
			{
				"name": "impeachment vote",
				"salience": 0.000103988226,
				"type": "OTHER"
			},
			{
				"name": "intelligence reports",
				"salience": 0.00010065581,
				"type": "OTHER"
			},
			{
				"name": "silence",
				"salience": 0.00009928688,
				"type": "OTHER"
			},
			{
				"name": "motivation",
				"salience": 0.000097093274,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00009515223,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00009486435,
				"type": "OTHER"
			},
			{
				"name": "opposition party",
				"salience": 0.00009486435,
				"type": "ORGANIZATION"
			},
			{
				"name": "side",
				"salience": 0.00009466087,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dtq1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quito"
				},
				"name": "Quito",
				"salience": 0.00009314676,
				"type": "LOCATION"
			},
			{
				"name": "candidates",
				"salience": 0.00009306078,
				"type": "PERSON"
			},
			{
				"name": "grade",
				"salience": 0.00009306078,
				"type": "OTHER"
			},
			{
				"name": "grade",
				"salience": 0.00009306078,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00009306078,
				"type": "OTHER"
			},
			{
				"name": "senate",
				"salience": 0.00009306078,
				"type": "ORGANIZATION"
			},
			{
				"name": "budget surplus",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "republic",
				"salience": 0.00009228939,
				"type": "ORGANIZATION"
			},
			{
				"name": "platform",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "cuts",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "spending",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "welfare",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "privatization",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "deregulation",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.00009228939,
				"type": "ORGANIZATION"
			},
			{
				"name": "theses",
				"salience": 0.00009228939,
				"type": "PERSON"
			},
			{
				"name": "pact",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00009228939,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.000091977265,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.000091977265,
				"type": "OTHER"
			},
			{
				"name": "state of emergency",
				"salience": 0.000091977265,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.00008966845,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gt4x_"
				},
				"name": "Patricia",
				"salience": 0.00008966845,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vqx5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soto_Cano_Air_Base"
				},
				"name": "Palmerola",
				"salience": 0.00008966845,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015fr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brazil"
				},
				"name": "Brazilians",
				"salience": 0.00008862505,
				"type": "PERSON"
			},
			{
				"name": "Rouseff",
				"salience": 0.00008862505,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01n9vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Carter_Center"
				},
				"name": "Carter Center",
				"salience": 0.00008781442,
				"type": "ORGANIZATION"
			},
			{
				"name": "player",
				"salience": 0.00008596943,
				"type": "PERSON"
			},
			{
				"name": "coup attempt",
				"salience": 0.00008596943,
				"type": "OTHER"
			},
			{
				"name": "impeachment vote",
				"salience": 0.00008596943,
				"type": "EVENT"
			},
			{
				"name": "backyard",
				"salience": 0.00008596943,
				"type": "LOCATION"
			},
			{
				"name": "Ambassador",
				"salience": 0.00008596943,
				"type": "PERSON"
			},
			{
				"name": "opposition leader",
				"salience": 0.000085649444,
				"type": "PERSON"
			},
			{
				"name": "opposition leaders",
				"salience": 0.000085649444,
				"type": "PERSON"
			},
			{
				"name": "coup leaders",
				"salience": 0.000085649444,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama White House",
				"salience": 0.000085614454,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00008506819,
				"type": "ORGANIZATION"
			},
			{
				"name": "price tag",
				"salience": 0.00008284256,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.000082140046,
				"type": "OTHER"
			},
			{
				"name": "embassy",
				"salience": 0.000082140046,
				"type": "LOCATION"
			},
			{
				"name": "role",
				"salience": 0.00008165878,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.000081293896,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000078335004,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.000078335004,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.000078335004,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.000078335004,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.00007761849,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.00007761849,
				"type": "OTHER"
			},
			{
				"name": "visit",
				"salience": 0.00007761849,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.00007761849,
				"type": "PERSON"
			},
			{
				"name": "approval",
				"salience": 0.00007761849,
				"type": "OTHER"
			},
			{
				"name": "ranking member",
				"salience": 0.00007761849,
				"type": "PERSON"
			},
			{
				"name": "meetings",
				"salience": 0.00007761849,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.00007761849,
				"type": "OTHER"
			},
			{
				"name": "budget shortfalls",
				"salience": 0.00007727166,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.000076829376,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01pdw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mercosur"
				},
				"name": "Mercosur",
				"salience": 0.00007603567,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01pp70",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bolivarian_Revolution"
				},
				"name": "Bolivarian Revolution",
				"salience": 0.00007603567,
				"type": "EVENT"
			},
			{
				"name": "proof",
				"salience": 0.00007533579,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.00007533579,
				"type": "WORK_OF_ART"
			},
			{
				"name": "audience",
				"salience": 0.000074719996,
				"type": "PERSON"
			},
			{
				"name": "operatives",
				"salience": 0.00007438612,
				"type": "ORGANIZATION"
			},
			{
				"name": "volume",
				"salience": 0.00007438612,
				"type": "OTHER"
			},
			{
				"name": "recording",
				"salience": 0.00007438612,
				"type": "OTHER"
			},
			{
				"name": "silence",
				"salience": 0.000074161064,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.000074161064,
				"type": "LOCATION"
			},
			{
				"name": "call",
				"salience": 0.000074161064,
				"type": "EVENT"
			},
			{
				"name": "call",
				"salience": 0.000074161064,
				"type": "EVENT"
			},
			{
				"name": "document",
				"salience": 0.00007377809,
				"type": "WORK_OF_ART"
			},
			{
				"name": "aircraft",
				"salience": 0.000069814334,
				"type": "OTHER"
			},
			{
				"name": "wing groups",
				"salience": 0.000069510446,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.000069510446,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.000069510446,
				"type": "OTHER"
			},
			{
				"name": "ConsortiumNews",
				"salience": 0.000067673674,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.00006720725,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article",
				"salience": 0.00006720725,
				"type": "WORK_OF_ART"
			},
			{
				"name": "patterns",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "acceptance",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "willingness",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.00006720725,
				"type": "EVENT"
			},
			{
				"name": "chairman",
				"salience": 0.00006720725,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "financing",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.00006720725,
				"type": "OTHER"
			},
			{
				"name": "accusation",
				"salience": 0.000064697524,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.000064697524,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00006421355,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00006421355,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00006421355,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.000064168686,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0b6kgn8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venezuelanalysis.com"
				},
				"name": "Venezuelanalysis.com",
				"salience": 0.000063193766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02cv6c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate_Committee_on_Foreign_Relations"
				},
				"name": "Senate Foreign Relations Committee",
				"salience": 0.000061099854,
				"type": "ORGANIZATION"
			},
			{
				"name": "transcript",
				"salience": 0.000057975827,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.000057975827,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0clb0v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Greenwald"
				},
				"name": "Glenn Greenwald",
				"salience": 0.000056793546,
				"type": "PERSON"
			},
			{
				"name": "Ted Snider",
				"salience": 0.000054712127,
				"type": "PERSON"
			},
			{
				"name": "publication",
				"salience": 0.000054169424,
				"type": "WORK_OF_ART"
			},
			{
				"name": "delegations",
				"salience": 0.000052146544,
				"type": "PERSON"
			},
			{
				"name": "Weapons",
				"salience": 0.00005148918,
				"type": "OTHER"
			},
			{
				"name": "embassy cables",
				"salience": 0.000051369287,
				"type": "OTHER"
			},
			{
				"name": "parliament",
				"salience": 0.0000501992,
				"type": "ORGANIZATION"
			},
			{
				"name": "escape",
				"salience": 0.0000501992,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0000501992,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.0000501992,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0000501992,
				"type": "EVENT"
			},
			{
				"name": "coup fail",
				"salience": 0.0000501992,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.0000501992,
				"type": "OTHER"
			},
			{
				"name": "take",
				"salience": 0.0000501992,
				"type": "OTHER"
			},
			{
				"name": "Twice",
				"salience": 0.0000501992,
				"type": "OTHER"
			},
			{
				"name": "phone conversation",
				"salience": 0.0000501992,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01yx1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Wisconsin%E2%80%93Madison"
				},
				"name": "University of Wisconsin-Madison",
				"salience": 0.00004776503,
				"type": "ORGANIZATION"
			},
			{
				"name": "Distinguished Legal Scholar",
				"salience": 0.00004776503,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03565y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Coimbra"
				},
				"name": "University of Coimbra",
				"salience": 0.00004776503,
				"type": "ORGANIZATION"
			},
			{
				"name": "Romero Jucá",
				"salience": 0.00004563733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hq5z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/A%C3%A9cio_Neves"
				},
				"name": "Aécio Neves",
				"salience": 0.00004135798,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05r4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Portugal"
				},
				"name": "Portugal",
				"salience": 0.00004135798,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06ms6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sociology"
				},
				"name": "Sociology",
				"salience": 0.00004135798,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04p7k5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jos%C3%A9_Serra"
				},
				"name": "José Serra",
				"salience": 0.00004135798,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d9fz3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bob_Corker"
				},
				"name": "Bob Corker",
				"salience": 0.00004135798,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025k3k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ben_Cardin"
				},
				"name": "Ben Cardin",
				"salience": 0.00004135798,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cq0r_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Undersecretary"
				},
				"name": "Undersecretary of State",
				"salience": 0.00004135798,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fzzlm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_A._Shannon,_Jr."
				},
				"name": "Thomas Shannon",
				"salience": 0.00004135798,
				"type": "PERSON"
			},
			{
				"name": "links",
				"salience": 0.000040460713,
				"type": "OTHER"
			},
			{
				"name": "National Transition Agreement",
				"salience": 0.000039515675,
				"type": "WORK_OF_ART"
			},
			{
				"name": "organizations",
				"salience": 0.000039275317,
				"type": "ORGANIZATION"
			},
			{
				"name": "Espinosa",
				"salience": 0.00003784355,
				"type": "LOCATION"
			},
			{
				"name": "confessions",
				"salience": 0.000036396686,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f4rwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mar%C3%ADa_Corina_Machado"
				},
				"name": "Maria Corina Machado",
				"salience": 0.00003567703,
				"type": "PERSON"
			},
			{
				"name": "Lucas Koerner",
				"salience": 0.000030891377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gxksy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leopoldo_L%C3%B3pez"
				},
				"name": "Leopoldo Lopez",
				"salience": 0.000030891377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fcyj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caracas"
				},
				"name": "Caracas",
				"salience": 0.000030891377,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T06:02:39.382+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 53.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nAs the end of Obama’s term in office approaches, it may be of interest to evaluate his performance on Latin America. One of Obama’s foreign policy promises at the beginning of his first term was to change the way America does business with Latin America. \nThe promise to change the way America does business in its backyard was a significant one because the way America has played in its backyard has a long and consistently appalling history. The history of interference and regime change began early when President McKinley betrayed Cuba and stole it under the deceptive promise of liberating it from Spain. In 1903, Theodore Roosevelt severed Panama from Columbia, declared it an independent nation and put in power a government whose first act was to sign over the future Panama Canal. In a little discussed maneuver, the U.S. cooperated with the 1908 removal of Venezuelan President Juan Vicente Gómez. In 1909, President Taft removed Nicaragua’s José Santos Zelaya because he insisted that US companies in Nicaragua honor their agreements and tried to make his country less dependent on the US by borrowing from European, and not American, banks. \nIn the modern era, 1954 saw Eisenhower order the CIA overthrow of Guatemala’s Jacobo Arbenz. In 1959-1960, Eisenhower would also start the covert action to remove Fidel Castro from Cuba. Kennedy would continue to rain \"the terrors of the earth\" on Cuba. He would also begin the Brazilian coup that would overthrow Goulart in 1964 and undertake a political action to encourage the removal of Cheddi Jagan from power in Guyana. In 1971, Nixon would brutalize Chile with the coup against Salvador Allende. President Omar Torrijos of Panama would die in a plane crash in 1981. In The New Confessions of an Economic Hit Man and in an interview with Amy Goodman on Democracy Now , John Perkins has claimed that Torrijos’ plane crash was another US assassination. Though it has never been proven that Torrijos’ death was a CIA assassination, there is some evidence that, at least earlier, consideration of his assassination was on the table. At the close of 1989, George H.W. Bush, in an unprovoked attack on the civilian population of a nation that had never threatened America, would take out Panama’s Manuel Noriega. At the end of the last century and the beginning of this one, Jean-Bertrand Aristide was twice removed from power over the popular voice of Haitians. The Latin American coups would continue through George W. Bush’s unpopular and short lived 2002 removal of Hugo Chavez in Venezuela. \nSo, it is not unimportant to evaluate Obama’s performance on his promise to change this tragic and shameful history. It’s not unimportant, but it is unimpressive. \nIt didn’t take long for the first indication that nothing had changed. On June 28, 2009, Honduras’ democratically elected President, Manuel Zelaya, was seized at gunpoint, removed in a coup and whisked away in a plane that refueled at a US military base. \nAfter the coup, US support to the Honduran military only increased. The American ambassador was never recalled, and the US refused to join the call of the United Nation’s General Assembly and the Organization of American States for the return of the elected President. Though the Organization of American States (OAS) refused to recognize the new coup president, the US State Department refused to join in that too. In fact, following an election that the OAS, the U.N. and others refused to recognize, the US would insist on recognizing the coup government as the victor of the election. \nBut, despite the refusal to call Zelaya’s removal at gunpoint a coup, and despite recognizing the coup government as the legitimate government of Honduras, the Obama White House knew it was a coup. By July 24, 2009, less than a month after the coup, the White House was in receipt of a cable sent from the US embassy in Honduras. In an almost comic lack of subtlety that was clearly never meant to be public, the cable is called \"Open and Shut: the Case of the Honduran Coup\". In it, the embassy says \"There is no doubt that the military, Supreme Court and National Congress conspired on June 28 in what constituted an illegal and unconstitutional coup . . . .\" Their conclusions could not be clearer: the embassy explicitly calls it a \"coup\" and says that \"[t]here is no doubt\". And just in case there were any remaining objections, the cable adds that \". . . none of the . . . arguments [of the coup defenders] has any substantive validity under the Honduran constitution\". \nAt best, Obama cooperated with the coup by maintaining silence, though his administration was engaged in dialogue with the rebellious military up to the day of the coup, and by recognizing the coup government as the legitimate government of Honduras. Latin American expert Mark Weisbrot told me in a correspondence that \"the Obama administration acknowledged that they were talking to the [Honduran] military right up to the day of the coup, allegedly to convince them not to do it\". But, he added, \"I find it hard to believe that they couldn’t convince them not to do it if they really wanted to: the Honduran military is pretty dependent on the US\" The charge was reiterated by Rodolfo Pastor Fasquelle , the minister of culture in the Zelaya government, who said on Democracy Now that \"I know for a fact that CIA operatives and military personnel of the United States were in direct contact with the conspirators of the coup d’état and aided the conspirators of the coup d’état.\" At worst, Obama was, as Zelaya has always insisted, involved in the coup. Zelaya claims that \"the coup came from the north form the US\" In the heat of the coup, the plane that was carrying the kidnapped president landed at the US military base of Palmerola for fifteen to twenty minutes while it refueled, despite the close proximity of its destination. After the coup, then Secretary of State Clinton has admitted that she aided the coup government by shoring up the coup government blocking the return of the elected government: \"In the subsequent days [after the coup] I spoke with my counterparts around the hemisphere, including Secretary [Patricia] Espinosa in Mexico. We strategized on a plan to restore order in Honduras and ensure that free and fair elections could be held quickly and legitimately, which would render the question of Zelaya moot.\" \nAfter the coup against Zelaya, Ecuador’s popularly elected president, Rafael Correa, said, \"We have intelligence reports that say that after Zelaya, I’m next.\" He may have been right. \nThe year after the Honduran coup, there was an attempted coup on Correa. Although the action failed, Latin American expert Mark Weisbrot says it was clearly an attempted coup to overthrow the government of Rafael Correa. \nCorrrea had renegotiated oil contracts and demanded a bigger share of the big oil companies’ revenue for the people of Ecuador. He also opposed a free trade agreement with the US and closed the US military base in Ecuador. He joined Venezuela, Cuba, Bolivia and Ecuador in the Bolivarian Alliance for the Peoples of Our America (ALBA) and successfully defaulted on over $3 billion of foreign debt that was illegitimately contacted by Ecuadorian leaders Correa said were CIA supported dictators. \nPrior to Obama, the US had started action against Correa. An October 2005 embassy cable sent by US ambassador Linda Jewell outlined action for \"desirable political and economic change in Ecuador.\" In 2006, she cabled that a Correa election would \"derail\" US hopes as the embassy expects Correa to join Chavez and other nationalist South American leaders.\" In the same cable [06QUITO2150], Jewell said that the US has \"actively discouraged potential alliances\" with Correa. She admitted [06QUITO2991] to \"working in concert with other Ecuadorians and groups who share our vision.\" \nDuring the Obama years, the US would continue to intervene in Ecuador. In March 2009, Ecuador expelled Mark Sullivan, an American official whom they accused of being the CIA station chief in Quito and whom they accused of playing a role in the suspension of US assistance to a special investigative police unit when Ecuador named a new chief of whom the US didn’t approve. \nOn October 30, 2010, the coup Correa had been expecting came. The coup leader was a graduate of the School of the Americas. A government appointed commission found that \"foreign actors\" had been involved in the coup. One of members of the commission announced his belief that the US State Department and the CIA had been involved. \nThe same year, Obama failed his next test. That year, America bankrolled the Haitian elections. The cost was 14 million dollars: a price tag that presumably gave America some say. But Haiti’s Provisional Electoral Council (CEP) banned fourteen parties from running in the election. The CEP was handpicked by the ruling party in a process that is not recognized by Haiti’s constitution. \nFanmi Lavalas, the party of Jean Bertrand Aristide, who was twice removed in US sponsored coups, is the largest and the most popular party in Haiti. It has won every election it has been allowed to participate in. That it has been allowed to participate in, that is. But in this US backed election, Fanmi Lavalas was not allowed to participate: it was banned by the CEP. \nThe US and its allies continued to influence the Haitian elections when they supported a runoff between two unpopular candidates representing essentially the same side. But the second round runoff between the two candidates was illegal because the CEP never accomplished the number of votes to ratify the first round results that selected them. \nThe Obama administration financed the election that specifically excluded the party the people wanted to elect. And, in doing so, Obama broke his foreign policy promise to Latin America and very quietly continued to do business with Latin America in the same interventionist way the US had always done business with Latin America. \nThe next indicator of a failing grade came in Paraguay, where in June 2012, Fernando Lugo, the democratically elected leader of Paraguay was removed in a coup. The right wing opposition opportunistically capitalized on a skirmish over disputed land that left at least eleven people dead to unfairly blame the deaths on President Lugo. It then impeached him after giving him only twenty-four hours to prepare his defense and only two hours to deliver it. The Latin American organizations Unasur and Mercosur suspended the new Paraguayan government; the US spent coup day negotiating a new military base in Paraguay. As in Honduras, they never used the word “coup”. \nBut they could have used the word if they hadn’t wanted to support the coup with their silence. As early as 2009, US embassy cables say that Lugo’s political opposition has as its goal to \"Capitalize on any Lugo missteps\" and to \"impeach Lugo and assure their own political supremacy\". The cable notes that to achieve their goal, they are willing to \"legally\" impeach Lugo \"even if on spurious grounds\". Obama knew it was a coup: the US had been tipped off about the strategy and told what it would look like. \nThe next year, 2013, the interference moved to Venezuela. Against the wishes of the United States, Hugo Chavez’ successor, Nicolás Maduro, won the right to continue the Bolivarian Revolution by winning the next national election. America was the only country in the world to refuse to recognize the election results , though 150 electoral monitors from around the world monitored Venezuela’s election, including delegations from the Union of South American Nations and the Carter Center. \nTwo years later, in 2015, the Obama administration again became involved in Venezuela. Contrary to Obama’s promise, business went on as usual with American money being pumped into Venezuela to fund groups who oppose Maduro. Since 2000, $90 million has poured into Venezuela. That sort of interference in Venezuela is not suggestive of a new way of doing business in Latin America. In 2015, that US funded opposition once again attempted to pull off a coup in Venezuela. Maduro explicitly accused the Americans of, as in 2002, being involved. \nThe accusation is not an empty one. Venezuelan officials have produced a significant volume of evidence that the events constitute a failed coup and that the US was involved. They have produced a recording of a communique that was to be issued after the Maduro government was removed from power. They have shown confessions by military officials. And they have admitted as evidence a recorded phone conversation between opposition leaders discussing the coup. The day before the planned coup, Caracas Mayor Antonio Ledezma, who is known to have made phone calls to a US number, Leopoldo Lopez and Maria Corina Machado, both major opposition leader of last year’s attempt to remove Maduro from power – an attempt that they made clear was an attempted coup by saying that they would not to stop until they “ got rid of Maduro \" – signed a National Transition Agreement. Weapons were also found in the office of the opposition party. \nLucas Koerner of Venezuelanalysis.com adds that the aircraft to be used as part of the failed coup has links to the notorious American security firm Academi (formerly Blackwater). And it has been reported that a number of the coup leaders obtained US visas from the American embassy to facilitate escape should the coup fail. \nAnd, just this past May, President Maduro has declared a state of emergency, accusing the US of once again conspiring with right wing groups in Venezuela to overthrow his government. Maduro says that “Washington is activating measures at the request of Venezuela’s fascist right.” \nIn perhaps his final chance to make good on his promise to do business with Latin America differently, Obama has, once again, disappointed by maintaining American silence on the coup in Brazil. How do we know that Obama should have spoken out against the take over of parliament by an unelected party? How do we know that it was a coup? Because the unelected party said so. Twice: both before the coup and after. \nThe publication of a transcript of the call between Romero Jucá, who was a senator at the time of the call and is currently the planning minister in Michael Temer’s new government, and former oil executive Sergio Machado, provides incontrovertible proof that the removal of the elected President was a coup. The phone call lays bare “a national pact” to remove Dilma and install Temer as President. Jucá reveals that, not only opposition politicians, but also the military and the Supreme Court are conspirators in the coup. Regarding the military’s role, Jucá says, “I am talking to the generals, the military commanders. They are fine with this, they said they will guarantee it.” And, as for the Supreme Court, Glenn Greenwald reports that Jucá admits that he “spoke with and secured the involvement of numerous justices on Brazil’s Supreme Court.” Jucá further boasted that “there are only a small number” of Supreme Court justices that he had not spoken to. \nSo confident is Michel Temer that he has US support for his coup that he is comfortable to openly boast about it in the US in front of an audience of business and foreign policy leaders. Temer clearly told his American audience that elected President Dilma Rousseff was not removed from power for \"violating fiscal laws by using loans from public banks to cover budget shortfalls, which artificially enhanced the budget surplus\" as the official charge stated. She was, the new, unelected President admitted, removed because of her refusal to implement a right wing economic plan that was inconsistent with the economic platform Brazilians elected her on. Temer’s economic plan featured cuts to health, education and welfare spending as well as increased emphasis on privatization and deregulation. \nRousseff was not on board. So she was thrown overboard. In the words of Temer’s comfortable confession : \nAnd many months ago, while I was still vice president, we released a document named ‘A Bridge to the Future’ because we knew it would be impossible for the government to continue on that course. We suggested that the government should adopt the theses presented in that document called ‘A Bridge to the Future.’ But, as that did not work out, the plan wasn’t adopted and a process was established which culminated with me being installed as president of the republic. \nConfession. Cased closed. \nAnd just to remove any doubt that the coup government’s motivation was not indignation at Rouseff’s fiscal maneuver, one of the coup government’s first acts of legislation was to explicitly legalize the very budgetary act they had impeached Rousseff for two days earlier. \nSo, once again, at best, Obama gets a low grade on his foreign policy promise for maintaining silence on what he knows to be a coup in Latin America. Silence is support. At worst, he gets a failing grade for cooperating with the coup. \nAmerican participation in the Brazilian coup has not been established. But, “there is no doubt that the biggest players in this coup attempt – people like former presidential candidates José Serra and Aécio Neves – are US government allies,\" according to Latin American exert Mark Weisbrot. And Boaventura de Sousa Santos, Professor of Sociology at the University of Coimbra in Portugal and Distinguished Legal Scholar at the University of Wisconsin-Madison says that Brazil is awash in financing from American sources, including “CIA-related organizations.” \nThe very day after the impeachment vote, Senator Aloysio Nunes of the coup government began a three day visit to Washington . Nunes is a significant player in the coup government: he was the vice-presidential candidate on the 2014 ticket that lost to President Rousseff and a key player in the effort to impeach President Rousseff in the senate. Nunes scheduled meetings with, amongst others, the chairman and ranking member of the Senate Foreign Relations Committee, Bob Corker and Ben Cardin, as well as with Undersecretary of State and former Ambassador to Brazil Thomas Shannon. Though Nunes denies it, there are reports that his trip to Washington was ordered by Michel Temer. The willingness to go ahead with the planned meetings with Nunes right after the impeachment vote demonstrates, once again, at least tacit acceptance or approval on the part of Washington. \nSo, Obama broke his promise. His foreign policy in Latin America may be more silent and more subtle, but the way he has done business with Latin America has not broken from the long line of Presidents who preceded him. At a rapid and consistent rate of almost one each year, Obama has done business as usual in America’s backyard: 2009 in Honduras; 2010 in Haiti and, perhaps, Ecuador; 2012 in Paraguay; 2013 in Venezuela; 2015 in Venezuela again and 2016 in Brazil. \nTed Snider writes on analyzing patterns in US foreign policy and history. An earlier version of this article was published on ConsortiumNews . Read more by Ted Snider",
		"thread_title": "The End of Obama’s Term: A Report Card on Latin America",
		"title": "The End of Obama’s Term: A Report Card on Latin America",
		"type": "bs",
		"uuid": "8f4c2084dc903caa14951b93d2a55488cfd321fa"
	},
	"-KhIj8v32H6TY66bal4Q": {
		"author": "Gareth Porter",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T06:02:40.200+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "administration",
				"salience": 0.25559667,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.18930203,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0538372,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.04016489,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/047vsxx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houthis"
				},
				"name": "Houthis",
				"salience": 0.03540758,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.03215242,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.029662218,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.026814654,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.009880264,
				"type": "LOCATION"
			},
			{
				"name": "arms",
				"salience": 0.0075287875,
				"type": "OTHER"
			},
			{
				"name": "air attack",
				"salience": 0.0072903144,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.007087038,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.007042329,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hrgd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australian_Defence_Force"
				},
				"name": "Australian Defense Force",
				"salience": 0.0065969955,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons",
				"salience": 0.0058078957,
				"type": "OTHER"
			},
			{
				"name": "sea",
				"salience": 0.005006882,
				"type": "LOCATION"
			},
			{
				"name": "Combined Maritime Forces",
				"salience": 0.004614393,
				"type": "ORGANIZATION"
			},
			{
				"name": "Yemen One",
				"salience": 0.00446186,
				"type": "LOCATION"
			},
			{
				"name": "Ian McConnaughey",
				"salience": 0.004403397,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00433703,
				"type": "EVENT"
			},
			{
				"name": "claim",
				"salience": 0.0039167157,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0039167157,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0038783015,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0038519767,
				"type": "OTHER"
			},
			{
				"name": "fishing boats",
				"salience": 0.0038385913,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0037296992,
				"type": "OTHER"
			},
			{
				"name": "supplies",
				"salience": 0.0037296992,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.0036744117,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0036502155,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j2619x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Fifth_Fleet"
				},
				"name": "U.S. Fifth Fleet",
				"salience": 0.0035813851,
				"type": "ORGANIZATION"
			},
			{
				"name": "ambitions",
				"salience": 0.0033924098,
				"type": "OTHER"
			},
			{
				"name": "failures",
				"salience": 0.0033924098,
				"type": "OTHER"
			},
			{
				"name": "News Justifying",
				"salience": 0.0030846915,
				"type": "ORGANIZATION"
			},
			{
				"name": "McConnaaughey",
				"salience": 0.0028882427,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0028346959,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.0028346959,
				"type": "ORGANIZATION"
			},
			{
				"name": "variant",
				"salience": 0.0024406512,
				"type": "OTHER"
			},
			{
				"name": "Kevin Stephens",
				"salience": 0.0023006196,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0022168444,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0022168444,
				"type": "EVENT"
			},
			{
				"name": "Saudi Slaughter",
				"salience": 0.0020892362,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0020892362,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0020892362,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0020892362,
				"type": "LOCATION"
			},
			{
				"name": "dhow",
				"salience": 0.0020156228,
				"type": "OTHER"
			},
			{
				"name": "accusation",
				"salience": 0.0020017512,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0019799187,
				"type": "OTHER"
			},
			{
				"name": "intelligence community",
				"salience": 0.0019739352,
				"type": "ORGANIZATION"
			},
			{
				"name": "interceptions",
				"salience": 0.0017794656,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0017782389,
				"type": "OTHER"
			},
			{
				"name": "flights",
				"salience": 0.0017335168,
				"type": "EVENT"
			},
			{
				"name": "theme",
				"salience": 0.0017335168,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0017335168,
				"type": "OTHER"
			},
			{
				"name": "record",
				"salience": 0.0017335168,
				"type": "OTHER"
			},
			{
				"name": "allegation",
				"salience": 0.0017335168,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.0017335168,
				"type": "EVENT"
			},
			{
				"name": "weapons",
				"salience": 0.0017013538,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0016221552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027404r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gareth_Porter"
				},
				"name": "Gareth Porter",
				"salience": 0.0016207292,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.0015870747,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0015870747,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0015569123,
				"type": "OTHER"
			},
			{
				"name": "vessel",
				"salience": 0.0015319816,
				"type": "OTHER"
			},
			{
				"name": "military spokesman",
				"salience": 0.0015284043,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0015172728,
				"type": "OTHER"
			},
			{
				"name": "coalition ship",
				"salience": 0.0014778476,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/010wd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabian_Sea"
				},
				"name": "Arabian Sea",
				"salience": 0.0014272098,
				"type": "LOCATION"
			},
			{
				"name": "ship",
				"salience": 0.0013870897,
				"type": "OTHER"
			},
			{
				"name": "dhows",
				"salience": 0.0013870897,
				"type": "LOCATION"
			},
			{
				"name": "fishing dhows",
				"salience": 0.0013870897,
				"type": "OTHER"
			},
			{
				"name": "fishing dhow",
				"salience": 0.0013870897,
				"type": "OTHER"
			},
			{
				"name": "monitoring group",
				"salience": 0.0013145162,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0013072343,
				"type": "OTHER"
			},
			{
				"name": "spokesmen",
				"salience": 0.0012637494,
				"type": "PERSON"
			},
			{
				"name": "military spokesman",
				"salience": 0.0012637494,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02pvs86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Naval_Forces_Central_Command"
				},
				"name": "U.S. Naval Forces Central Command",
				"salience": 0.0012417892,
				"type": "ORGANIZATION"
			},
			{
				"name": "ship",
				"salience": 0.0011324389,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0011128788,
				"type": "OTHER"
			},
			{
				"name": "destination",
				"salience": 0.0011090051,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.0010917224,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0010917224,
				"type": "OTHER"
			},
			{
				"name": "weapon",
				"salience": 0.0010917224,
				"type": "OTHER"
			},
			{
				"name": "crewmembers",
				"salience": 0.0010749865,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.0010713451,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02zh41",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PBS_NewsHour"
				},
				"name": "PBS NewsHour",
				"salience": 0.001063953,
				"type": "WORK_OF_ART"
			},
			{
				"name": "evidence",
				"salience": 0.0010541654,
				"type": "OTHER"
			},
			{
				"name": "fishing boats",
				"salience": 0.0010541654,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "assessment",
				"salience": 0.0010541654,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.0010541654,
				"type": "OTHER"
			},
			{
				"name": "boats",
				"salience": 0.0010541654,
				"type": "OTHER"
			},
			{
				"name": "crews",
				"salience": 0.0010155307,
				"type": "PERSON"
			},
			{
				"name": "spokesman",
				"salience": 0.000993221,
				"type": "PERSON"
			},
			{
				"name": "dhow",
				"salience": 0.0009726109,
				"type": "OTHER"
			},
			{
				"name": "fishing boats",
				"salience": 0.0009706182,
				"type": "OTHER"
			},
			{
				"name": "Shipment",
				"salience": 0.0009603567,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.0009524826,
				"type": "OTHER"
			},
			{
				"name": "coalition forces",
				"salience": 0.00094536116,
				"type": "ORGANIZATION"
			},
			{
				"name": "dhow",
				"salience": 0.0009363091,
				"type": "OTHER"
			},
			{
				"name": "dhow",
				"salience": 0.0009363091,
				"type": "OTHER"
			},
			{
				"name": "fishing dhow",
				"salience": 0.0009363091,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0009363091,
				"type": "OTHER"
			},
			{
				"name": "port",
				"salience": 0.0009169316,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.00091283635,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.00091283635,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00091283635,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00091283635,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009085413,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009085413,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.0009081247,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.00089126744,
				"type": "OTHER"
			},
			{
				"name": "interviews",
				"salience": 0.00088610617,
				"type": "WORK_OF_ART"
			},
			{
				"name": "spokesman",
				"salience": 0.00088610617,
				"type": "PERSON"
			},
			{
				"name": "interception",
				"salience": 0.00088610617,
				"type": "OTHER"
			},
			{
				"name": "spokesman",
				"salience": 0.00088610617,
				"type": "PERSON"
			},
			{
				"name": "port",
				"salience": 0.0008827069,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00088239135,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statements",
				"salience": 0.00088239135,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00088239135,
				"type": "OTHER"
			},
			{
				"name": "monitoring group",
				"salience": 0.0008809244,
				"type": "ORGANIZATION"
			},
			{
				"name": "dhow",
				"salience": 0.00084598863,
				"type": "OTHER"
			},
			{
				"name": "wording",
				"salience": 0.00082420296,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.00082420296,
				"type": "PERSON"
			},
			{
				"name": "crew",
				"salience": 0.00081861194,
				"type": "PERSON"
			},
			{
				"name": "crew",
				"salience": 0.00081861194,
				"type": "PERSON"
			},
			{
				"name": "monitoring group",
				"salience": 0.00081638823,
				"type": "ORGANIZATION"
			},
			{
				"name": "fishing dhow",
				"salience": 0.00079401577,
				"type": "OTHER"
			},
			{
				"name": "crew",
				"salience": 0.00078805524,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.00077994046,
				"type": "OTHER"
			},
			{
				"name": "destination",
				"salience": 0.0007775817,
				"type": "LOCATION"
			},
			{
				"name": "destination",
				"salience": 0.0007775817,
				"type": "LOCATION"
			},
			{
				"name": "choice",
				"salience": 0.0007508266,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00074828824,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00074828824,
				"type": "LOCATION"
			},
			{
				"name": "vessel",
				"salience": 0.00073912326,
				"type": "OTHER"
			},
			{
				"name": "destroyer",
				"salience": 0.0007298095,
				"type": "OTHER"
			},
			{
				"name": "spokesman",
				"salience": 0.00072338834,
				"type": "PERSON"
			},
			{
				"name": "interception",
				"salience": 0.00072338834,
				"type": "OTHER"
			},
			{
				"name": "boat",
				"salience": 0.00072061305,
				"type": "OTHER"
			},
			{
				"name": "justification",
				"salience": 0.0007136909,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0007136909,
				"type": "WORK_OF_ART"
			},
			{
				"name": "relationship",
				"salience": 0.0007136909,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0007136909,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0007136909,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0007136909,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0007136909,
				"type": "OTHER"
			},
			{
				"name": "ports",
				"salience": 0.00071153237,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.00069491804,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0006906141,
				"type": "OTHER"
			},
			{
				"name": "crew",
				"salience": 0.0006854498,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.0006787024,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0006787024,
				"type": "OTHER"
			},
			{
				"name": "cache",
				"salience": 0.0006733182,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.0006669277,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0006657966,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0006657966,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0006657966,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0006657966,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.000657117,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.00064001454,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00063722965,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "U.S. Naval Forces",
				"salience": 0.00063113804,
				"type": "ORGANIZATION"
			},
			{
				"name": "fishing",
				"salience": 0.0006240579,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0006161219,
				"type": "ORGANIZATION"
			},
			{
				"name": "missiles",
				"salience": 0.0006161219,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.0006161219,
				"type": "OTHER"
			},
			{
				"name": "weapons cache",
				"salience": 0.0006161219,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.0006161219,
				"type": "OTHER"
			},
			{
				"name": "monitoring group report",
				"salience": 0.0006110873,
				"type": "WORK_OF_ART"
			},
			{
				"name": "assessment",
				"salience": 0.0006033863,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.0006033863,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0006033863,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xsrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Central_Command"
				},
				"name": "Central Command",
				"salience": 0.0005990613,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.00059578236,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0005931385,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0005931385,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0005931385,
				"type": "OTHER"
			},
			{
				"name": "shipments",
				"salience": 0.0005931385,
				"type": "OTHER"
			},
			{
				"name": "Untold Story",
				"salience": 0.0005913309,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australian",
				"salience": 0.0005814484,
				"type": "LOCATION"
			},
			{
				"name": "crew members",
				"salience": 0.00057786185,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.00057786185,
				"type": "OTHER"
			},
			{
				"name": "e-mail",
				"salience": 0.00057786185,
				"type": "OTHER"
			},
			{
				"name": "e-mail",
				"salience": 0.00057786185,
				"type": "OTHER"
			},
			{
				"name": "seizure",
				"salience": 0.0005562887,
				"type": "OTHER"
			},
			{
				"name": "waters",
				"salience": 0.0005562887,
				"type": "OTHER"
			},
			{
				"name": "machine guns",
				"salience": 0.0005562887,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "assault rifles",
				"salience": 0.0005562887,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Some",
				"salience": 0.00054966204,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australians",
				"salience": 0.0005404944,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.00053312833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AK-47"
				},
				"name": "AK-47",
				"salience": 0.0005249813,
				"type": "ORGANIZATION"
			},
			{
				"name": "navy",
				"salience": 0.00052247266,
				"type": "ORGANIZATION"
			},
			{
				"name": "monitoring group",
				"salience": 0.0005205284,
				"type": "ORGANIZATION"
			},
			{
				"name": "spokesman",
				"salience": 0.0005201991,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.00050037,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.00050037,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00050037,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.00050037,
				"type": "OTHER"
			},
			{
				"name": "vicinity",
				"salience": 0.00050037,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00049429055,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00049429055,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vnr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Security_Council"
				},
				"name": "United Nations Security Council",
				"salience": 0.0004890385,
				"type": "ORGANIZATION"
			},
			{
				"name": "papers",
				"salience": 0.00048168894,
				"type": "WORK_OF_ART"
			},
			{
				"name": "coast",
				"salience": 0.00048168894,
				"type": "LOCATION"
			},
			{
				"name": "province",
				"salience": 0.00048168894,
				"type": "LOCATION"
			},
			{
				"name": "shells",
				"salience": 0.00048168894,
				"type": "OTHER"
			},
			{
				"name": "piracy",
				"salience": 0.00048168894,
				"type": "OTHER"
			},
			{
				"name": "customs officials",
				"salience": 0.00048168894,
				"type": "PERSON"
			},
			{
				"name": "grenades",
				"salience": 0.00048168894,
				"type": "OTHER"
			},
			{
				"name": "missile-launchers",
				"salience": 0.00048168894,
				"type": "EVENT"
			},
			{
				"name": "third",
				"salience": 0.00047173136,
				"type": "PERSON"
			},
			{
				"name": "machine guns",
				"salience": 0.00047173136,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "seizure",
				"salience": 0.00047173136,
				"type": "OTHER"
			},
			{
				"name": "arms embargo",
				"salience": 0.00047173136,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.00047173136,
				"type": "OTHER"
			},
			{
				"name": "propaganda line",
				"salience": 0.00047173136,
				"type": "OTHER"
			},
			{
				"name": "assault rifles",
				"salience": 0.00047173136,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "embargo",
				"salience": 0.00047173136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0179qd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Telegraph"
				},
				"name": "The Telegraph",
				"salience": 0.00046834975,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.00045930754,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0004507229,
				"type": "LOCATION"
			},
			{
				"name": "fishing vessels",
				"salience": 0.0004507229,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fishing vessels",
				"salience": 0.0004507229,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "country",
				"salience": 0.0004507229,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.0004493595,
				"type": "OTHER"
			},
			{
				"name": "monitoring group",
				"salience": 0.00044703946,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.0004388692,
				"type": "ORGANIZATION"
			},
			{
				"name": "diplomats",
				"salience": 0.0004323919,
				"type": "PERSON"
			},
			{
				"name": "fishing dhows",
				"salience": 0.00043196927,
				"type": "LOCATION"
			},
			{
				"name": "board",
				"salience": 0.00042246367,
				"type": "ORGANIZATION"
			},
			{
				"name": "Authorities",
				"salience": 0.00042113676,
				"type": "PERSON"
			},
			{
				"name": "resolution",
				"salience": 0.00040846813,
				"type": "OTHER"
			},
			{
				"name": "accordance",
				"salience": 0.00040846813,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00040846813,
				"type": "ORGANIZATION"
			},
			{
				"name": "news media",
				"salience": 0.00040846813,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.00040846813,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.00039498202,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.000393538,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00039321737,
				"type": "OTHER"
			},
			{
				"name": "fishing networks",
				"salience": 0.00039027643,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.00039027643,
				"type": "LOCATION"
			},
			{
				"name": "weapons cache",
				"salience": 0.00039027643,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.00039027643,
				"type": "PERSON"
			},
			{
				"name": "method",
				"salience": 0.00038826134,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00038535747,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00037934945,
				"type": "ORGANIZATION"
			},
			{
				"name": "slant",
				"salience": 0.0003785359,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00036922333,
				"type": "OTHER"
			},
			{
				"name": "weaponry",
				"salience": 0.0003622011,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0003622011,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0003568689,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.00035431053,
				"type": "ORGANIZATION"
			},
			{
				"name": "arms merchants",
				"salience": 0.0003523709,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.0003523709,
				"type": "OTHER"
			},
			{
				"name": "arms merchants",
				"salience": 0.0003523709,
				"type": "PERSON"
			},
			{
				"name": "waters",
				"salience": 0.0003523709,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0003523709,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.0003523709,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "diesel fuel tanks",
				"salience": 0.0003523709,
				"type": "OTHER"
			},
			{
				"name": "diesel fuel",
				"salience": 0.0003523709,
				"type": "OTHER"
			},
			{
				"name": "cargo",
				"salience": 0.0003523709,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hywq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Puntland"
				},
				"name": "Puntland",
				"salience": 0.00034334313,
				"type": "LOCATION"
			},
			{
				"name": "explanation",
				"salience": 0.00033071704,
				"type": "OTHER"
			},
			{
				"name": "fishing vessels",
				"salience": 0.00032824348,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "evidence",
				"salience": 0.00032824348,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00032508964,
				"type": "OTHER"
			},
			{
				"name": "shipment",
				"salience": 0.0003226677,
				"type": "OTHER"
			},
			{
				"name": "dhow",
				"salience": 0.0003226677,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0003226677,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0003172047,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.00030511196,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.00030511196,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00029644786,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balochistan,_Pakistan"
				},
				"name": "Baluchistan",
				"salience": 0.00029644786,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05l8y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oman"
				},
				"name": "Oman",
				"salience": 0.00029644786,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "The Associated Press",
				"salience": 0.00029644786,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04bjy7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/PK_machine_gun"
				},
				"name": "PKM",
				"salience": 0.00029644786,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02855s1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sistan"
				},
				"name": "Sistan",
				"salience": 0.00029644786,
				"type": "LOCATION"
			},
			{
				"name": "Konkurs",
				"salience": 0.00029644786,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00028636173,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02khs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eritrea"
				},
				"name": "Eritrea",
				"salience": 0.0002855847,
				"type": "LOCATION"
			},
			{
				"name": "author",
				"salience": 0.00028421986,
				"type": "PERSON"
			},
			{
				"name": "air campaign",
				"salience": 0.00028421986,
				"type": "EVENT"
			},
			{
				"name": "networks",
				"salience": 0.00028421986,
				"type": "OTHER"
			},
			{
				"name": "fishing networks",
				"salience": 0.00028421986,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.00028421986,
				"type": "PERSON"
			},
			{
				"name": "journalism",
				"salience": 0.00028421986,
				"type": "OTHER"
			},
			{
				"name": "experts group",
				"salience": 0.00028316205,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.00026584556,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.00025661345,
				"type": "EVENT"
			},
			{
				"name": "security policy",
				"salience": 0.00025661345,
				"type": "OTHER"
			},
			{
				"name": "smuggling",
				"salience": 0.00025661345,
				"type": "EVENT"
			},
			{
				"name": "accusations",
				"salience": 0.00025661345,
				"type": "OTHER"
			},
			{
				"name": "arms smuggling",
				"salience": 0.00025661345,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00025138093,
				"type": "LOCATION"
			},
			{
				"name": "Island of Socotra",
				"salience": 0.00025138093,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rz4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indian_Ocean"
				},
				"name": "Indian Ocean",
				"salience": 0.00025138093,
				"type": "LOCATION"
			},
			{
				"name": "UNSCR 2244",
				"salience": 0.00025138093,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.00024906723,
				"type": "OTHER"
			},
			{
				"name": "sea",
				"salience": 0.0002451838,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0002451838,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.0002451838,
				"type": "WORK_OF_ART"
			},
			{
				"name": "writer",
				"salience": 0.00023976709,
				"type": "PERSON"
			},
			{
				"name": "Security Council Monitoring Group",
				"salience": 0.00023627414,
				"type": "ORGANIZATION"
			},
			{
				"name": "owners",
				"salience": 0.00022790473,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00022219545,
				"type": "ORGANIZATION"
			},
			{
				"name": "alarms",
				"salience": 0.00022219545,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.00022219545,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.00022219545,
				"type": "WORK_OF_ART"
			},
			{
				"name": "permission",
				"salience": 0.00022219545,
				"type": "OTHER"
			},
			{
				"name": "arms trade",
				"salience": 0.00022219545,
				"type": "EVENT"
			},
			{
				"name": "charge",
				"salience": 0.00021229859,
				"type": "OTHER"
			},
			{
				"name": "charge",
				"salience": 0.00021229859,
				"type": "OTHER"
			},
			{
				"name": "journalists",
				"salience": 0.00021229859,
				"type": "PERSON"
			},
			{
				"name": "explanation",
				"salience": 0.00020947609,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.00020797421,
				"type": "LOCATION"
			},
			{
				"name": "connections",
				"salience": 0.00019572386,
				"type": "OTHER"
			},
			{
				"name": "air war",
				"salience": 0.00019167711,
				"type": "EVENT"
			},
			{
				"name": "ruse",
				"salience": 0.00019167711,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.00019167711,
				"type": "OTHER"
			},
			{
				"name": "cargo",
				"salience": 0.00019167711,
				"type": "OTHER"
			},
			{
				"name": "news story",
				"salience": 0.00019167711,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sanctions",
				"salience": 0.00016596775,
				"type": "OTHER"
			},
			{
				"name": "briefings",
				"salience": 0.00016596775,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00016596775,
				"type": "OTHER"
			},
			{
				"name": "insurgents",
				"salience": 0.00016596775,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00016596775,
				"type": "OTHER"
			},
			{
				"name": "paragraph",
				"salience": 0.00016596775,
				"type": "WORK_OF_ART"
			},
			{
				"name": "majority",
				"salience": 0.00015576763,
				"type": "OTHER"
			},
			{
				"name": "charge credibility",
				"salience": 0.00014253182,
				"type": "OTHER"
			},
			{
				"name": "Gellhorn Prize",
				"salience": 0.00013673834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.00013673834,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.00013673834,
				"type": "LOCATION"
			},
			{
				"name": "Iran Nuclear Scare",
				"salience": 0.00013673834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/011cbx8s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East_Eye"
				},
				"name": "Middle East Eye",
				"salience": 0.00013673834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027ggxz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Shabaab_(militant_group)"
				},
				"name": "al-Shabaab",
				"salience": 0.00013673834,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ruse",
				"salience": 0.0001179566,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T06:02:40.200+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 26.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Latest News Justifying the Saudi Slaughter in Yemen One of Obama's biggest failures is letting his policy in Syria be determined primarily by the ambitions of Qatar, Saudi Arabia and Turkey Share This \nThe Obama administration has carried out a deliberately deceptive campaign accusing Iran of covertly sending arms to the Houthis by sea, a claim that Washington cites to help justify the Saudi massive air attack against the Houthis that began last year. \nBy repeating the accusation over and over, the administration has been largely successful in turning a dubious allegation into accepted fact, even though it is contradicted by evidence that is well-documented on the public record. \nSecretary of State John Kerry introduced the new variant of the Obama administration’s familiar theme about Iran’s “nefarious activities” in the region two weeks after Saudi Arabia began its bombing in Yemen on March 26, 2015. Kerry told the PBS NewsHour, “There are obviously supplies that have been coming from Iran,” citing “a number of flights every single week that have been flying in.” Kerry vowed that the United States was “not going to stand by while the region is destabilized.” \nLater, the administration began accusing Iran of using fishing boats to smuggle arms to the Houthis. The campaign unfolded in a series of four interceptions of small fishing boats or dhows in or near the Arabian Sea from September 2015 through March 2016. The four interceptions had two things in common: the boats did have illicit weapons alright, but the crews always said the ship was bound for Somalia – not Yemen and the Houthis. \nBut instead of acknowledging the obvious fact that the weapons were not related to the Iran-Houthi relationship, a U.S. military spokesman put out a statement in all four cases citing a U.S. “assessment” that the ultimate destination of the arms was Houthi-controlled territory in Yemen. \nThe choice of wording was significant. The intelligence community says that it “assesses” that something is true only when it does not have clear-cut proof on the matter. In the case of the alleged Iranian use of fishing dhows to smuggle arms to the Houthis, the U.S. spokesmen did not cite a single piece of evidence for that “assessment” in any of the four cases. In fact, when asked for some justification for it, the military spokesman refused. \nThe first fishing dhow was intercepted in the Arabian Sea on Sept. 25, 2015, by a member of a 31-nation coalition called the Combined Maritime Forces patrolling the Arabian Sea and nearby waters for piracy. The coalition ship found the dhow to be carrying 18 Konkurs anti-tank missiles, 71 other anti-tank shells and 54 missile-launchers. \nBlaming Iran \nThe U.S. Navy’s Fifth Fleet later issued a statement that said, “Based on statements from the dhow’s crew the port of origin of the dhow and its illicit weapons cache is believed to be Iran.” It also said the anti-tank missiles were thought to be of Iranian and Russian origin, and that the papers on the ship had indicated that it had been checked by ports and customs officials in Iran’s Sistan and Baluchistan province. \nBut the crew of the vessel had said that it was bound not for Yemen but for Somalia, as the spokesman for the U.S. Fifth Fleet acknowledged to The Associated Press . A Saudi military spokesman suggested that Iran intended to reroute the arms later from Somalia to Yemen, but offered no evidence. \nOn Feb. 27, 2016, an Australian ship intercepted a second fishing dhow off the coast of Oman. The Australians found 1,989 AK-47 assault rifles, 100 rocket-propelled grenades and 40 PKM machine guns on board. The Australian Defense Force issued an official statement on the seizure that did not mention Iranian involvement. It said the boat appeared to be “stateless” and that its cache of weapons was “destined for Somalia.” The Australian Defense Force spokesman explained to CNN that the conclusion was based on interviews with crew members. \nBut a spokesman for U.S. Naval Forces, Central Command, Lt. Ian McConnaughey gave an entirely different political slant to the interception. In an e-mail to NBC News, McConnaughey said. “Based on the dhow’s course, Iran is believed to be its port of origin and the source of the illicit weapon,” he said. McConnaughey said the crew was “assessed” to be Iranian – implying that the crew itself had not indicated that. \nMcConnaughey acknowledged to NBC and The Telegraph, “According to coalition forces it is believed that the vessel’s destination was in the vicinity of Somalia.” But the CENTCOM spokesman indicated that it didn’t matter; the U.S. was insisting on its narrative about covert Iranian arms to the Houthis. \n“[T]he initial U.S. assessment is the weapons’ final destination was likely to be the Houthis in Yemen,” McConnaaughey told NBC and The Telegraph. \nWhen this writer asked McConnaughey by e-mail why the U.S. “assessed” that the weapons were intended for Yemen, despite the evidence to the contrary, he responded, “We are not going to discuss the intelligence and other information that led us to our assessment.” \nA Third Shipment \nOn March 20, a French navy destroyer intercepted a third fishing dhow off the Island of Socotra in the northern Indian Ocean and found several hundred AK-47 assault rifles, machine guns and antitank weapons. The official statement on the seizure from the Combined Maritime Forces stated categorically, “The dhow was spotted heading toward Somalia.” \nAnd because the weapons were “deemed to be destined for Somalia,” it explained, they “were seized under the United Nations Security Council mandated arms embargo in accordance with UNSCR 2244(2015).” That Security Council resolution mandates an embargo on Eritrea. \nAustralia and other states participating in the Combined Maritime Forces were thus challenging the U.S. propaganda line. But again the U.S. military used the news media to reinforce the line about Iran smuggling arms to the Houthis. Commander Kevin Stephens, a spokesman for the Fifth Fleet, told CNN that “according to a U.S. assessment,” Yemen was the “likely destination” of the arms. \nA fourth interception – the third in three weeks – occurred on March 28 by a U.S. Navy ship that was not operating as part of Combined Maritime Forces but directly under U.S. Naval Forces Central Command. That allowed the Naval Forces Central Command to issue its own news story on April 4. \nIn its lead paragraph, the report said the United States “assessed” that the shipment of illicit arms on board the dhow “originated in Iran and was likely bound for Houthi insurgents in Yemen.” \nAn Earlier Ruse \nThe Obama administration also had sought to promote the charge that Iranian was covertly sending weapons to the Houthis by sea more than two years earlier. In January 2013, the Yemen client government backed by the United States and Saudi Arabia had claimed that its forces had intercepted a ship with a large cargo of weaponry that came from Iran and was on its way to Yemen to deliver them to the Houthis. \nThe Obama administration supported that charge in briefings to journalists. After the Saudi air war against Yemen began in 2015, the U.S. pushed for a report by an experts group on sanctions against Iran that would give the charge credibility. \nBut the 2013 claim was soon exposed as a ruse. A Security Council Monitoring Group on Somalia and Eritrea revealed in a June 2013 report that the crewmembers had told diplomats who interviewed them that ship’s cargo of diesel fuel was bound for Somalia, not Yemen. And, since the weapons were hidden under the diesel fuel tanks, the weapons could be accessed only after those tanks had been emptied, in other words after the ship docked in Somalia. \nThe monitoring group learned from authorities in the Puntland region of Somalia, where most of the smuggled weapons have entered the country, that this was a widely used method of smuggling arms into the country. \nFurthermore, the monitoring group determined that the wide range of types of weapons on board the ship, which was intercepted in January 2013, as well as of their original sources indicated that the weapons cache had been assembled by arms merchants. Authorities in Puntland provided data to the monitoring group showing that most of the shipments of weapons into Puntland in the months before January 2013 had come from politically well-connected arms merchants in Yemen. \nSome of the fishing boats that were intercepted with illicit arms on board in 2015-16 had Iranian owners. But the monitoring group report reveals that the real reason is the role of such Iranian fishing vessels in illegal fishing in Somali waters. The vast majority of the hundreds of fishing vessels involved in such illegal fishing networks were either Iranian or Yemeni. As many as 300 were believed to be Yemeni-owned, while Iranian-owned 180 of them. \nThe monitoring group said it was investigating unconfirmed reports that some of those illegal fishing vessels were also being used to carry out arms smuggling and that it had established “other connections between the illegal fishing networks and networks involved in the arms trade and connected to al-Shabaab in northeastern Somalia.” \nBut the Obama administration has no interest in the considerable evidence gathered by the monitoring group that provides a more credible explanation for the arms found on those four fishing dhows. \nSuch an explanation isn’t political useful, whereas the accusations of Iranian smuggling of arms to the Houthis fulfilled multiple political and bureaucratic interests, justifying Saudi Arabia’s bloody U.S.-backed air campaign over Yemen and endless Washington alarms about “Iranian aggression.” \nGareth Porter, an investigative historian and journalist specializing in US national security policy, received the UK-based Gellhorn Prize for journalism for 2011 for articles on the U.S. war in Afghanistan. His new book is Manufactured Crisis: the Untold Story of the Iran Nuclear Scare . He can be contacted at . \nReprinted from the Middle East Eye with the author’s permission. Read more by Gareth Porter",
		"thread_title": "Justifying the Saudi Slaughter in Yemen",
		"title": "Justifying the Saudi Slaughter in Yemen",
		"type": "bs",
		"uuid": "32790a359f1fc2aa08c51c5dc32cecdee6a1c7cc"
	},
	"-KhIj9Ab_DGJoq3tsUPT": {
		"author": "Robert Dodge",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T06:02:44.487+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "weapons",
				"salience": 0.2000858,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.071935035,
				"type": "LOCATION"
			},
			{
				"name": "use",
				"salience": 0.041982695,
				"type": "OTHER"
			},
			{
				"name": "breach",
				"salience": 0.03734525,
				"type": "EVENT"
			},
			{
				"name": "weapons",
				"salience": 0.029837098,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.026305906,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.023595072,
				"type": "LOCATION"
			},
			{
				"name": "Robert Dodge",
				"salience": 0.023057166,
				"type": "PERSON"
			},
			{
				"name": "health",
				"salience": 0.01933502,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05jzn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Treaty_on_the_Non-Proliferation_of_Nuclear_Weapons"
				},
				"name": "Nuclear Non-proliferation Treaty",
				"salience": 0.018794287,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.01717039,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.014335856,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.012075195,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.011622012,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.011622012,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.011622012,
				"type": "LOCATION"
			},
			{
				"name": "arms race",
				"salience": 0.01078568,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.010383613,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.009207112,
				"type": "EVENT"
			},
			{
				"name": "arms race",
				"salience": 0.0087920735,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0077794935,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0077475687,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.007336931,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.007336931,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0072497325,
				"type": "EVENT"
			},
			{
				"name": "height",
				"salience": 0.0063550193,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.0063550193,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0063550193,
				"type": "OTHER"
			},
			{
				"name": "disarmament",
				"salience": 0.0063550193,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0063211154,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0063211154,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0063211154,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0054076836,
				"type": "EVENT"
			},
			{
				"name": "nations",
				"salience": 0.0053763404,
				"type": "ORGANIZATION"
			},
			{
				"name": "Each",
				"salience": 0.0048397966,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0047937636,
				"type": "LOCATION"
			},
			{
				"name": "weapon",
				"salience": 0.004434222,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.004434222,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01tm0q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jody_Williams"
				},
				"name": "Jody Williams",
				"salience": 0.0043203123,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0042412616,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0042321775,
				"type": "PERSON"
			},
			{
				"name": "danger",
				"salience": 0.003895545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c_bfw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Committee_of_the_Red_Cross"
				},
				"name": "International Red Cross",
				"salience": 0.003741567,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.0036242846,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0033622342,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0033622342,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0033622342,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0032368184,
				"type": "LOCATION"
			},
			{
				"name": "nations",
				"salience": 0.0032368184,
				"type": "ORGANIZATION"
			},
			{
				"name": "effort",
				"salience": 0.0030779352,
				"type": "OTHER"
			},
			{
				"name": "matters",
				"salience": 0.0030234973,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.0030234973,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.0030234973,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0030234973,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0030234973,
				"type": "PERSON"
			},
			{
				"name": "finger",
				"salience": 0.0028612171,
				"type": "OTHER"
			},
			{
				"name": "weapons programs",
				"salience": 0.0028398347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3k14",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_F._Kennedy"
				},
				"name": "Kennedy",
				"salience": 0.0027956131,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0027451639,
				"type": "LOCATION"
			},
			{
				"name": "fact deterrence",
				"salience": 0.002731977,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0027115594,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0027052513,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.002618306,
				"type": "LOCATION"
			},
			{
				"name": "scale",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "indication",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "button",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.002618306,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002618306,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.0026103912,
				"type": "OTHER"
			},
			{
				"name": "adversary",
				"salience": 0.0025527666,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0024934039,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.002478042,
				"type": "EVENT"
			},
			{
				"name": "arms",
				"salience": 0.0024468298,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.0024468298,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0024108533,
				"type": "ORGANIZATION"
			},
			{
				"name": "myth",
				"salience": 0.0023658199,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0023481364,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0023481364,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0023383119,
				"type": "OTHER"
			},
			{
				"name": "aspect",
				"salience": 0.002220524,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0022138108,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.0021202015,
				"type": "PERSON"
			},
			{
				"name": "deterrence",
				"salience": 0.0021202015,
				"type": "OTHER"
			},
			{
				"name": "temperament",
				"salience": 0.002110734,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.0020750794,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.0020410805,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.0020410805,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0020258224,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.001997641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.0019927274,
				"type": "ORGANIZATION"
			},
			{
				"name": "side",
				"salience": 0.0019682643,
				"type": "OTHER"
			},
			{
				"name": "driver",
				"salience": 0.0019561355,
				"type": "PERSON"
			},
			{
				"name": "guise",
				"salience": 0.0019561355,
				"type": "OTHER"
			},
			{
				"name": "partnership",
				"salience": 0.001917053,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.001917053,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.001917053,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.001917053,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tn2c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Campaign_to_Ban_Landmines"
				},
				"name": "International Campaign to Ban Landmines",
				"salience": 0.0018866272,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.0018690549,
				"type": "LOCATION"
			},
			{
				"name": "inaction",
				"salience": 0.0018359835,
				"type": "OTHER"
			},
			{
				"name": "NGO",
				"salience": 0.0018359835,
				"type": "OTHER"
			},
			{
				"name": "doublespeak",
				"salience": 0.0018359835,
				"type": "OTHER"
			},
			{
				"name": "arsenals",
				"salience": 0.0018359835,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.0018359835,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.0018359835,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0018359835,
				"type": "OTHER"
			},
			{
				"name": "hostage",
				"salience": 0.001767462,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.001767462,
				"type": "EVENT"
			},
			{
				"name": "pledge",
				"salience": 0.001767462,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.001767462,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.001767462,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.001767462,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0017560159,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0017469068,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0017469068,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.0017091292,
				"type": "ORGANIZATION"
			},
			{
				"name": "response",
				"salience": 0.0016663338,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0016118044,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0016118044,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06nn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Asia"
				},
				"name": "South Asia",
				"salience": 0.0016118044,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.0016118044,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/035jnk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atomic_bombings_of_Hiroshima_and_Nagasaki"
				},
				"name": "Hiroshima",
				"salience": 0.0016118044,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0015502133,
				"type": "OTHER"
			},
			{
				"name": "obligations",
				"salience": 0.0015373694,
				"type": "OTHER"
			},
			{
				"name": "militaries",
				"salience": 0.0014988724,
				"type": "ORGANIZATION"
			},
			{
				"name": "end",
				"salience": 0.0014988724,
				"type": "OTHER"
			},
			{
				"name": "madness",
				"salience": 0.0014988724,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0014938056,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.001472077,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.001472077,
				"type": "OTHER"
			},
			{
				"name": "prevention",
				"salience": 0.0014429258,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0014429258,
				"type": "OTHER"
			},
			{
				"name": "security policy",
				"salience": 0.0013777171,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0013777171,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0013372164,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.001334104,
				"type": "EVENT"
			},
			{
				"name": "understanding",
				"salience": 0.0012930766,
				"type": "OTHER"
			},
			{
				"name": "Polio",
				"salience": 0.0012930766,
				"type": "OTHER"
			},
			{
				"name": "possession",
				"salience": 0.0012930766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qy796",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Campaign_to_Abolish_Nuclear_Weapons"
				},
				"name": "International Campaign to Abolish Nuclear Weapons",
				"salience": 0.0012773017,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0012508198,
				"type": "LOCATION"
			},
			{
				"name": "parallels",
				"salience": 0.0012082126,
				"type": "OTHER"
			},
			{
				"name": "Security",
				"salience": 0.0012045585,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cljp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Council_of_Churches"
				},
				"name": "World Council of Churches",
				"salience": 0.0011800035,
				"type": "ORGANIZATION"
			},
			{
				"name": "health professionals",
				"salience": 0.0011484536,
				"type": "PERSON"
			},
			{
				"name": "Peace",
				"salience": 0.0011290471,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0011196913,
				"type": "PERSON"
			},
			{
				"name": "argument",
				"salience": 0.0011196913,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.0011196913,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.0011196913,
				"type": "OTHER"
			},
			{
				"name": "HIV",
				"salience": 0.0011196913,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011159057,
				"type": "LOCATION"
			},
			{
				"name": "security committee",
				"salience": 0.0010430379,
				"type": "ORGANIZATION"
			},
			{
				"name": "Luck",
				"salience": 0.0010040994,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.00094174605,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.00094174605,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.00094174605,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03w2s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Civil_Aviation_Organization"
				},
				"name": "ICAN",
				"salience": 0.0009225467,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05f3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Peace_Prize"
				},
				"name": "Nobel Peace Prize",
				"salience": 0.0009225467,
				"type": "OTHER"
			},
			{
				"name": "Ambassador",
				"salience": 0.0008154558,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0008154558,
				"type": "OTHER"
			},
			{
				"name": "luck",
				"salience": 0.00077914,
				"type": "OTHER"
			},
			{
				"name": "partnerships",
				"salience": 0.00077914,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.00077914,
				"type": "OTHER"
			},
			{
				"name": "luck",
				"salience": 0.00077914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vnr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Security_Council"
				},
				"name": "U.N. Security Council",
				"salience": 0.00076667994,
				"type": "ORGANIZATION"
			},
			{
				"name": "will",
				"salience": 0.00070346927,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.00070032646,
				"type": "OTHER"
			},
			{
				"name": "PeaceVoice",
				"salience": 0.0006948855,
				"type": "OTHER"
			},
			{
				"name": "Zika",
				"salience": 0.0006891265,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0frm3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ebola_virus_disease"
				},
				"name": "Ebola",
				"salience": 0.0006891265,
				"type": "OTHER"
			},
			{
				"name": "instances",
				"salience": 0.00066981115,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.00061690074,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00060912536,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.00060912536,
				"type": "ORGANIZATION"
			},
			{
				"name": "NGOs",
				"salience": 0.00060912536,
				"type": "ORGANIZATION"
			},
			{
				"name": "accident",
				"salience": 0.00060912536,
				"type": "EVENT"
			},
			{
				"name": "design",
				"salience": 0.00060912536,
				"type": "OTHER"
			},
			{
				"name": "imagination",
				"salience": 0.00060912536,
				"type": "OTHER"
			},
			{
				"name": "control systems",
				"salience": 0.00060912536,
				"type": "OTHER"
			},
			{
				"name": "ban movement",
				"salience": 0.00060912536,
				"type": "OTHER"
			},
			{
				"name": "alliances",
				"salience": 0.00060912536,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09p61j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Physicians_for_Social_Responsibility"
				},
				"name": "Physicians for Social Responsibility",
				"salience": 0.0005795936,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/030qb3t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Los_Angeles"
				},
				"name": "Los Angeles",
				"salience": 0.0005018599,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0005018599,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0r8bh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ventura,_California"
				},
				"name": "Ventura",
				"salience": 0.0005018599,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Catholic Church",
				"salience": 0.00044972525,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nuclear Age Peace Foundation and Citizens for Peaceful Resolutions",
				"salience": 0.0004048411,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T06:02:44.487+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nNuclear weapons present the greatest public health and existential threat to our survival every moment of every day. Yet the United States and world nuclear nations stand in breach of the 1968 Nuclear Non-proliferation Treaty which commits these nations to work in good faith to end the arms race and to achieve nuclear disarmament. Forty eight years later the efforts of the nuclear nations toward this goal is not evident and the state of the world is equally as dangerous as it was during the height of the Cold War and arguably more dangerous with current scientific evidence on the catastrophic effects of even limited regional nuclear war. \nThis year’s presidential campaign has once again done little to focus on the dangers of nuclear weapons focusing more on who has the temperament to have their finger on the button with absolutely no indication of any understanding of the consequences to all of humanity by the use of these weapons even on a very small scale. In addition to tensions between Russia and the U.S. in Ukraine and Syria, there is a real danger of nuclear war in South Asia which could kill more than 2 billion people from the use of just 100 Hiroshima size weapons. \nThe rest of the world is finally standing up to this threat to their survival and that of the planet. They are taking matters into their own hands and refusing to be held hostage by the nuclear nations. They will no longer be bullied into sitting back and waiting for the nuclear states to make good on empty promises. \nAt the United Nations this past week, 123 nations voted to commence negotiations next year on a new treaty to prohibit the possession of nuclear weapons. Despite President Obama’s own words in his 2009 pledge to seek the security of a world free of nuclear weapons, the US voted “no” and led the opposition to this treaty. \nRather than meet our obligations under international law, the US has proposed by stark contrast to begin a new nuclear arms race spending $1 trillion dollars over the next 30 years to modernize and rebuild every aspect our nuclear weapons programs. A ‘jobs’ program to end humanity. Each of the nuclear nations is expected to do the same in rebuilding their weapons programs continuing the arms race for generations to come. \nThe myth of deterrence is the guise for this effort when in fact deterrence is the principle driver of the arms race. For every additional weapon my adversary has, I need two and so on and so on to our global arsenals of 15,500 weapons. \nFed up with this inaction and doublespeak, the non-nuclear nations of the world have joined the ongoing efforts of the world’s NGO, health and religious communities in demanding an end to the madness. Led by the International Campaign to Abolish Nuclear Weapons (ICAN), a global partnership of 440 partners in 98 countries, the International Red Cross, the world’s health associations representing more than 17 million health professionals worldwide along with religious communities including the Catholic Church and World Council of Churches they are calling for a treaty to ban and eliminate nuclear weapons. \nThe effort to ban nuclear weapons has several parallels to the International Campaign to Ban Landmines led by Jody Williams, recipient of the 1997 Nobel Peace Prize. This effort was dismissed and called utopian by most governments and militaries of the world when it was launched by nongovernmental organizations (NGOs) in 1992 only to succeed in 1997 through partnerships, public imagination and political pressure resulting in the ultimate political will. The nuclear ban movement has been vigorously fought by the nuclear nations trying desperately to hold onto their weapons and pressuring members of their alliances to hold the line. \nUnfortunately these weapons and control systems are imperfect. During the Cold War there were many instances where the world came perilously close to nuclear war . It is a matter of sheer luck that this scenario did not come to pass by design or accident. Our luck will not hold out forever. Luck is not a security policy. From a medical and public health stance based on our current evidence-based understanding of what nuclear weapons can actually do, any argument for continued possession of these weapons by anyone in untenable and defies logic. There is absolutely no reasonable or adequate medical response to nuclear war. \nAs with any public health threat from Zika, to Ebola, Polio, HIV, prevention is the goal. The global threat from nuclear weapons is no different. The only way to prevent the use of nuclear weapons is to ban and eliminate them. Our future depends upon this. \nPresident Kennedy speaking on nuclear weapons before the U.N. Security Council in September 1961 said, “The weapons of war must be abolished before they abolish us”. Our children’s children will look back and rightly ask why we the only nation to ever use nuclear weapons remained on the wrong side of history when it came to abolishing nuclear weapons. \nRobert Dodge is a family physician practicing full time in Ventura, California. He serves on the board of Physicians for Social Responsibility Los Angeles serving as a Peace and Security Ambassador and at the national level where he sits on the security committee. He also serves on the board of the Nuclear Age Peace Foundation and Citizens for Peaceful Resolutions . He writes for PeaceVoice .",
		"thread_title": "Nuclear Weapons – The Time for Abolition is Now",
		"title": "Nuclear Weapons – The Time for Abolition is Now",
		"type": "bs",
		"uuid": "cb8356cb8f200c2fdb51d85a9d1768fd6dde7227"
	},
	"-KhIj9P8156xsv5UnvtP": {
		"author": "Margaret Griffis",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T08:12:00.950+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.13441718,
				"type": "LOCATION"
			},
			{
				"name": "Militants",
				"salience": 0.09413848,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.051251914,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.033306185,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.026872152,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.024697691,
				"type": "EVENT"
			},
			{
				"name": "security personnel",
				"salience": 0.024697691,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.024697691,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.023524271,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.020621568,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.020621568,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.017868482,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.017235477,
				"type": "OTHER"
			},
			{
				"name": "district",
				"salience": 0.017111978,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.014907282,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.014386183,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0139168715,
				"type": "ORGANIZATION"
			},
			{
				"name": "security personnel",
				"salience": 0.013218496,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.010707794,
				"type": "OTHER"
			},
			{
				"name": "soldier",
				"salience": 0.010201125,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.009103042,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.008960385,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.008814831,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.008814831,
				"type": "ORGANIZATION"
			},
			{
				"name": "militants",
				"salience": 0.008703962,
				"type": "PERSON"
			},
			{
				"name": "estimates",
				"salience": 0.008512077,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.00843151,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.007466429,
				"type": "ORGANIZATION"
			},
			{
				"name": "guerrillas",
				"salience": 0.007372486,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.007372486,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.007372486,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0073502227,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0073502227,
				"type": "LOCATION"
			},
			{
				"name": "figures",
				"salience": 0.007156894,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.006890106,
				"type": "EVENT"
			},
			{
				"name": "security personnel",
				"salience": 0.006890106,
				"type": "PERSON"
			},
			{
				"name": "soldier",
				"salience": 0.0068455385,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.006692047,
				"type": "OTHER"
			},
			{
				"name": "district",
				"salience": 0.006612443,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.006234498,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.006234498,
				"type": "LOCATION"
			},
			{
				"name": "authorities",
				"salience": 0.006020226,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j40h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan_Workers'_Party"
				},
				"name": "Kurdistan Workers Party",
				"salience": 0.005977127,
				"type": "ORGANIZATION"
			},
			{
				"name": "militant losses",
				"salience": 0.005971092,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.0058441167,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.0058441167,
				"type": "PERSON"
			},
			{
				"name": "resistance fighters",
				"salience": 0.0058441167,
				"type": "PERSON"
			},
			{
				"name": "Militants",
				"salience": 0.0053793197,
				"type": "PERSON"
			},
			{
				"name": "city limits",
				"salience": 0.0051712175,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0051712175,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0051712175,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0049783518,
				"type": "OTHER"
			},
			{
				"name": "Special forces",
				"salience": 0.0048755417,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.0048755417,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0046586194,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0046586194,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0046586194,
				"type": "PERSON"
			},
			{
				"name": "losses",
				"salience": 0.004576234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0045401873,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.0045401873,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.0045401873,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.004366799,
				"type": "LOCATION"
			},
			{
				"name": "security personnel",
				"salience": 0.004366799,
				"type": "PERSON"
			},
			{
				"name": "smoke",
				"salience": 0.00422226,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.00422226,
				"type": "EVENT"
			},
			{
				"name": "neighborhood",
				"salience": 0.00422226,
				"type": "LOCATION"
			},
			{
				"name": "casualty statements",
				"salience": 0.003980785,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.003918772,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.0036766415,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.0036428298,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0033935737,
				"type": "LOCATION"
			},
			{
				"name": "Kokjali",
				"salience": 0.0031838664,
				"type": "OTHER"
			},
			{
				"name": "Gogjiali",
				"salience": 0.0031838664,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighting",
				"salience": 0.0031809297,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.0031545826,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0031545826,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0031545826,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0031545826,
				"type": "EVENT"
			},
			{
				"name": "Karama",
				"salience": 0.003001731,
				"type": "LOCATION"
			},
			{
				"name": "Karama",
				"salience": 0.003001731,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09h6g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aden"
				},
				"name": "Aden",
				"salience": 0.0029528118,
				"type": "LOCATION"
			},
			{
				"name": "militiamen",
				"salience": 0.0029277776,
				"type": "PERSON"
			},
			{
				"name": "reporter",
				"salience": 0.002791454,
				"type": "PERSON"
			},
			{
				"name": "Bazwaya",
				"salience": 0.0025993504,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.0023764058,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.0023764058,
				"type": "LOCATION"
			},
			{
				"name": "explosion",
				"salience": 0.0022977076,
				"type": "EVENT"
			},
			{
				"name": "Gunmen",
				"salience": 0.0022977076,
				"type": "PERSON"
			},
			{
				"name": "bomb",
				"salience": 0.0022977076,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0022977076,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0022977076,
				"type": "PERSON"
			},
			{
				"name": "Moshairefa",
				"salience": 0.0019418441,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.0019418441,
				"type": "LOCATION"
			},
			{
				"name": "Shalalat",
				"salience": 0.0019418441,
				"type": "OTHER"
			},
			{
				"name": "Tal Yabis",
				"salience": 0.0019418441,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03m_n0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peshmerga"
				},
				"name": "Peshmerga",
				"salience": 0.0014142598,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09trq1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tesqopa"
				},
				"name": "Tel Skuf",
				"salience": 0.0014142598,
				"type": "LOCATION"
			},
			{
				"name": "Margaret Griffis",
				"salience": 0.0014142598,
				"type": "PERSON"
			},
			{
				"name": "Najmook",
				"salience": 0.0013443052,
				"type": "OTHER"
			},
			{
				"name": "Hasuna",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Subhi",
				"salience": 0.0010564382,
				"type": "PERSON"
			},
			{
				"name": "Sunaidii",
				"salience": 0.0010564382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024f1z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tobruk"
				},
				"name": "Tubruq",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Abu Shwayha",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Albu Juradi",
				"salience": 0.0010564382,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02hh2g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arish"
				},
				"name": "Arish",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Aslya Huwaysh",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Dalawiya Al Sharqiyan",
				"salience": 0.0010564382,
				"type": "PERSON"
			},
			{
				"name": "Imam Hamza",
				"salience": 0.0010564382,
				"type": "PERSON"
			},
			{
				"name": "Kharani Gargara",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Khurba Tayir",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Mushairafa",
				"salience": 0.0010564382,
				"type": "PERSON"
			},
			{
				"name": "Sahi Abas",
				"salience": 0.0010564382,
				"type": "PERSON"
			},
			{
				"name": "Sruj",
				"salience": 0.0010564382,
				"type": "PERSON"
			},
			{
				"name": "Um Shanin",
				"salience": 0.0010564382,
				"type": "PERSON"
			},
			{
				"name": "Um Sijqn",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Zuwai'za's",
				"salience": 0.0010564382,
				"type": "LOCATION"
			},
			{
				"name": "Tal Shikham",
				"salience": 0.0010564382,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T08:12:00.950+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This At least 5,561 people were killed and 2,463 were wounded across Iraq during October. These figures are estimates, perhaps even conservative ones. Breaking down the above numbers, we find that 1,629 civilians were killed, and 1,693 were injured. At least 303 security personnel were also killed, and 660 more were wounded in fighting. Militants lost an estimated 3,611 members, while 108 more are known to have been wounded. Again, these are very rough estimates. Also, one U.S. soldier was killed, and at least two French soldiers were wounded during October. Turkish airstrikes left at least 17 Kurdistan Workers Party (P.K.K.) guerrillas dead as well. These figures are much higher than they were in September due to a massive operation that was launched against the city of Mosul. Last month only 2,824 people were killed and 1,208 were wounded. Due to the nature of the fighting in Iraq, accurate numbers may be impossible to obtain. The Iraqi government has been tight with releasing casualty statements concerning security personnel. On the other hand, authorities may be too loose with figures detailing militant losses. Those figures may also represent civilian losses counted as military. In other news: Iraq’s special forces entered the Gogjiali (Kokjali) district on Monday, which marks the first time security personnel have been within Mosul city limits since the Islamic State militants seized the city in 2014. They were able to progress to the Karama neighborhood. A Reuters reporter in nearby Bazwaya village — which was recaptured today — could see smoke rising from the Karama battle, and soldiers also fought in the Aden district. There are also new reports of resistance fighters attacking militants in the city. Special forces also captured the eastern villages of Subhi, Sunaidii, and Tubruq. Shi’ite militiamen reported freeing the western villages of Abu Shwayha, Albu Juradi, Arish, Aslya Huwaysh, Dalawiya Al Sharqiyan, Imam Hamza, Hasuna, Kharani Gargara, Khurba Tayir, Mushairafa, Sahi Abas, Sruj, Um Shanin, Um Sijqn, Zuwai’za’s, and Tal Shikham. On the northern front, troops liberated Najmook, Shalalat, and Tal Yabis. At least 408 people were killed and 71 were wounded in recent violence: Militants executed 300 people , civilians and former security personnel, north of Mosul in the village of Moshairefa . In Baghdad , at least 16 people were killed and 50 were wounded in various attacks around the city. Gunmen killed a Peshmerga soldier in Tel Skuf , as he was trying to defuse a bomb. In Mosul , militants killed 50 of their own and mutilated 20 others for fleeing the fighting. Seven militants were killed in fighting in the Aden district. An explosion killed several militant leaders. Read more by Margaret Griffis",
		"thread_title": "5,561 Killed in Iraq during October",
		"title": "5,561 Killed in Iraq during October",
		"type": "bs",
		"uuid": "e07bf800b91799912cdc64fc8e8143d2658a8687"
	},
	"-KhIj9_eJmmj_B1lqM-q": {
		"author": "William J. Astore",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T16:07:57.027+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "lieutenant colonel",
				"salience": 0.21307485,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.16670935,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.06754592,
				"type": "PERSON"
			},
			{
				"name": "Nate Terani",
				"salience": 0.053444937,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.05014773,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.032041606,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/018w0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gulf_War"
				},
				"name": "Desert Storm",
				"salience": 0.027833879,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03znkl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ben_Carson"
				},
				"name": "Ben Carson",
				"salience": 0.027018996,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/034ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_H._W._Bush"
				},
				"name": "George H.W. Bush",
				"salience": 0.024560155,
				"type": "PERSON"
			},
			{
				"name": "ignorance",
				"salience": 0.023122031,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobia",
				"salience": 0.022887604,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.020406373,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "U.S. Air Force",
				"salience": 0.017079782,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.016319744,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.014264368,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.013616271,
				"type": "OTHER"
			},
			{
				"name": "William J. Astore",
				"salience": 0.009434144,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.00730646,
				"type": "ORGANIZATION"
			},
			{
				"name": "aftermath",
				"salience": 0.00730646,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.00730646,
				"type": "EVENT"
			},
			{
				"name": "boy",
				"salience": 0.00730646,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/079dy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saddam_Hussein"
				},
				"name": "Saddam",
				"salience": 0.0068403175,
				"type": "PERSON"
			},
			{
				"name": "memory",
				"salience": 0.005462243,
				"type": "OTHER"
			},
			{
				"name": "fundamentalists",
				"salience": 0.0050942027,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0045753135,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shia",
				"salience": 0.0045022843,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0038492994,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.0037121237,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0034784146,
				"type": "PERSON"
			},
			{
				"name": "enemy",
				"salience": 0.0032818774,
				"type": "PERSON"
			},
			{
				"name": "season",
				"salience": 0.0030124958,
				"type": "EVENT"
			},
			{
				"name": "nothing",
				"salience": 0.0030124958,
				"type": "OTHER"
			},
			{
				"name": "uniform",
				"salience": 0.0030124958,
				"type": "OTHER"
			},
			{
				"name": "interpreter",
				"salience": 0.0030124958,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.0029243596,
				"type": "OTHER"
			},
			{
				"name": "ignorance",
				"salience": 0.0027343342,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0027017938,
				"type": "OTHER"
			},
			{
				"name": "veteran",
				"salience": 0.0026010217,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0025992065,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0024396374,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.002405828,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06y24j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iranian_American"
				},
				"name": "Iranian-American",
				"salience": 0.0023818675,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0023486319,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0022930147,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0022509247,
				"type": "LOCATION"
			},
			{
				"name": "minorities",
				"salience": 0.0021127153,
				"type": "PERSON"
			},
			{
				"name": "division",
				"salience": 0.0021127153,
				"type": "OTHER"
			},
			{
				"name": "outsiders",
				"salience": 0.0021127153,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.0021127153,
				"type": "PERSON"
			},
			{
				"name": "rhetoric",
				"salience": 0.0021127153,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.0021127153,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.0020338928,
				"type": "OTHER"
			},
			{
				"name": "distinction",
				"salience": 0.0020338928,
				"type": "OTHER"
			},
			{
				"name": "prejudice",
				"salience": 0.0020338928,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0019918764,
				"type": "OTHER"
			},
			{
				"name": "bigotry",
				"salience": 0.0019918764,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0019208922,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.001894729,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.0018934062,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0018548273,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0sxkw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/101st_Airborne_Division"
				},
				"name": "101st Airborne",
				"salience": 0.0018548273,
				"type": "ORGANIZATION"
			},
			{
				"name": "fear",
				"salience": 0.0017839711,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0017249058,
				"type": "OTHER"
			},
			{
				"name": "playbook",
				"salience": 0.0017249058,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0017249058,
				"type": "PERSON"
			},
			{
				"name": "ones",
				"salience": 0.0017249058,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0017249058,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0017249058,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0017249058,
				"type": "ORGANIZATION"
			},
			{
				"name": "liberty",
				"salience": 0.0017249058,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.0017249058,
				"type": "OTHER"
			},
			{
				"name": "walls",
				"salience": 0.0016817243,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0016481279,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0015855174,
				"type": "OTHER"
			},
			{
				"name": "passages",
				"salience": 0.0015784376,
				"type": "OTHER"
			},
			{
				"name": "heartland",
				"salience": 0.0014881351,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0014881351,
				"type": "OTHER"
			},
			{
				"name": "bigotry",
				"salience": 0.0014881351,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0014881351,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0013006035,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0013006035,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Westerners",
				"salience": 0.0013006035,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.0013006035,
				"type": "PERSON"
			},
			{
				"name": "fears",
				"salience": 0.0012994036,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.0012886386,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0012886386,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0zgfr43",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Engelhardt"
				},
				"name": "TomDispatch.com",
				"salience": 0.0012520615,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "Navy",
				"salience": 0.0012520615,
				"type": "ORGANIZATION"
			},
			{
				"name": "Views",
				"salience": 0.0010838811,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0010654439,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.0010356217,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0009385533,
				"type": "ORGANIZATION"
			},
			{
				"name": "author",
				"salience": 0.0009385533,
				"type": "PERSON"
			},
			{
				"name": "permission",
				"salience": 0.0009385533,
				"type": "OTHER"
			},
			{
				"name": "blogs",
				"salience": 0.0009385533,
				"type": "WORK_OF_ART"
			},
			{
				"name": "military",
				"salience": 0.0009385533,
				"type": "ORGANIZATION"
			},
			{
				"name": "insanity",
				"salience": 0.0009385533,
				"type": "OTHER"
			},
			{
				"name": "veterans",
				"salience": 0.0008967618,
				"type": "PERSON"
			},
			{
				"name": "values",
				"salience": 0.0008096795,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00070110435,
				"type": "LOCATION"
			},
			{
				"name": "globe",
				"salience": 0.00070110435,
				"type": "LOCATION"
			},
			{
				"name": "leaders",
				"salience": 0.00070110435,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.00070110435,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00070110435,
				"type": "EVENT"
			},
			{
				"name": "wages",
				"salience": 0.00070110435,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0006698824,
				"type": "OTHER"
			},
			{
				"name": "Bracing Views",
				"salience": 0.00066711707,
				"type": "OTHER"
			},
			{
				"name": "wastore",
				"salience": 0.0005776537,
				"type": "LOCATION"
			},
			{
				"name": "@pct.edu",
				"salience": 0.0005776537,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T16:07:57.027+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "When I was a lieutenant colonel on active duty, I supervised an officer in the U.S. Air Force who was (and is) an Iraqi-American. He came to the US as a boy after President George H.W. Bush’s call to the Shia to revolt against Saddam in the aftermath of Desert Storm, which was ruthlessly suppressed by Saddam as Bush and company did nothing.\nAs an Iraqi-American in uniform, he served as an interpreter attached to the 101st Airborne in Iraq in 2004, if memory serves–dangerous times indeed for US troops in Iraq.\nHe wrote to me, rightly outraged, after Ben Carson made his anti-Muslim comments back in September of 2015 during the presidential primary season. It made him so sad, so angry, as a US Air Force veteran and as a Muslim-American to hear such ignorance, such bias, such Islamophobia. And it made me angry as well.\n\nSo many Muslim-Americans have served this country with distinction, troops like Navy veteran Nate Terani, who has written an eloquent article at TomDispatch.com on the prejudice he faced as an Iranian-American. Terani is doing his best to fight a new enemy, Islamophobia, the irrational fear of Islam fed by the unhinged rhetoric of candidates like Ben Carson and Donald Trump.\nHere is how Terani puts it in his article :\nIn Iran, theocratic fundamentalists sowed division and hatred of outsiders–of Westerners, Christians, and other religious minorities. Here in America, the right wing seems to have stolen passages directly from their playbook as it spreads hatred of immigrants, particularly Muslim ones. This form of nationalistic bigotry–Islamophobia–threatens the heart of our nation. When I chose to serve in the military, I did so to protect what I viewed as our sacred foundational values of liberty, equality, and democracy. Now, 20 years later, I’ve joined forces with fellow veterans to again fight for those sacred values, this time right here at home. \nAs America builds walls and weapons and wages war all over the globe, as our leaders look outward for enemies, we’re forgetting the enemy within America, the enemy that is a much more serious threat to our national security. That enemy, which exists right here in America’s heartland, is ignorance, hatred, fear, aggression, compounded by a cowardly desire to “get even” and to “make America great again” by ostracizing other Americans who are considered “different” and “untrustworthy.”\nBut spreading fear and bigotry is not a way to national security; it’s a way to national insanity. Islamophobia, like all other irrational fears, must be fought and defeated.\nWilliam J. Astore is a retired lieutenant colonel (USAF). He taught history for fifteen years at military and civilian schools and blogs at Bracing Views . He can be reached at wastore@pct.edu . Reprinted from Bracing Views with the author’s permission. \n",
		"thread_title": "Islamophobia Must be Fought and Defeated",
		"title": "Islamophobia Must be Fought and Defeated",
		"type": "bs",
		"uuid": "3a55c3de7469cc35f491f68098e9202ebf53cf82"
	},
	"-KhIj9j6Ud1_h0vNlmYx": {
		"author": "Daniel McAdams",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T01:16:26.097+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "government",
				"salience": 0.14686772,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.1088876,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Gaddafi",
				"salience": 0.10169927,
				"type": "PERSON"
			},
			{
				"name": "wars",
				"salience": 0.097101696,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/079dy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saddam_Hussein"
				},
				"name": "Saddam Hussein",
				"salience": 0.09039824,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.03987075,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.032618098,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.031665523,
				"type": "OTHER"
			},
			{
				"name": "Ditto",
				"salience": 0.031269103,
				"type": "OTHER"
			},
			{
				"name": "mass",
				"salience": 0.02880533,
				"type": "OTHER"
			},
			{
				"name": "societies",
				"salience": 0.021965705,
				"type": "OTHER"
			},
			{
				"name": "untold thousands",
				"salience": 0.021965705,
				"type": "PERSON"
			},
			{
				"name": "Administrations",
				"salience": 0.021965705,
				"type": "ORGANIZATION"
			},
			{
				"name": "Trillions",
				"salience": 0.02141799,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.019293582,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.015420744,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.013542401,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "Bush",
				"salience": 0.013542401,
				"type": "PERSON"
			},
			{
				"name": "change",
				"salience": 0.013418111,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.013418111,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.013038122,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Assad",
				"salience": 0.013038122,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.013038122,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07jqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taliban"
				},
				"name": "Taliban",
				"salience": 0.013038122,
				"type": "ORGANIZATION"
			},
			{
				"name": "Charles Koch Institute",
				"salience": 0.012769284,
				"type": "ORGANIZATION"
			},
			{
				"name": "poll",
				"salience": 0.01129029,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04n6n1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Center_for_the_National_Interest"
				},
				"name": "Center for the National Interest",
				"salience": 0.011060606,
				"type": "ORGANIZATION"
			},
			{
				"name": "half",
				"salience": 0.007308215,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.007308215,
				"type": "EVENT"
			},
			{
				"name": "The Ron Paul Institute for Peace & Prosperity",
				"salience": 0.00695437,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ron Paul Liberty Report",
				"salience": 0.0060227476,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T01:16:26.097+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "We were told that we had to attack Iraq because the Saddam Hussein government made us less safe. We were told we had to bomb and kill Gaddafi in Libya because his regime made us less safe. Ditto with the Taliban in Afghanistan and Assad in Syria. Now. 15 years after 9/11, Americans are seeing through the endless wars that have lasted through the Bush and Obama Administrations. Trillions spent, untold thousands killed, societies destroyed, people displaced. A new poll sponsored by the Center for the National Interest and the Charles Koch Institute has found that Americans feel less, not more safe after a decade and a half of war. We are reaching the critical mass where Americans begin to demand a change in our interventionist foreign policy. More on the encouraging poll in today’s Ron Paul Liberty Report:\n\nReprinted from The Ron Paul Institute for Peace & Prosperity . \n",
		"thread_title": "New Poll: Americans Feel Less Safe After 15 Years of War",
		"title": "New Poll: Americans Feel Less Safe After 15 Years of War",
		"type": "bs",
		"uuid": "a379a428dc070c95d0def68a9491ed774365be63"
	},
	"-KhIj9rFQxCZANWuJ_Az": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:36:34.209+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.20288442,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.19671874,
				"type": "LOCATION"
			},
			{
				"name": "warplanes",
				"salience": 0.06715864,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.066190235,
				"type": "EVENT"
			},
			{
				"name": "Attack",
				"salience": 0.05211486,
				"type": "EVENT"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.044022918,
				"type": "PERSON"
			},
			{
				"name": "Fadhiliya",
				"salience": 0.042442266,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.040970135,
				"type": "LOCATION"
			},
			{
				"name": "Promises 'Further Investigation",
				"salience": 0.029288542,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.02023379,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.019676995,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.012687141,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.010768344,
				"type": "PERSON"
			},
			{
				"name": "airstrike",
				"salience": 0.010024457,
				"type": "EVENT"
			},
			{
				"name": "airstrike",
				"salience": 0.0096518705,
				"type": "EVENT"
			},
			{
				"name": "airstrike",
				"salience": 0.0096518705,
				"type": "EVENT"
			},
			{
				"name": "family",
				"salience": 0.008744607,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.008744607,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.008744607,
				"type": "LOCATION"
			},
			{
				"name": "strikes",
				"salience": 0.008744607,
				"type": "EVENT"
			},
			{
				"name": "airstrikes",
				"salience": 0.008190261,
				"type": "EVENT"
			},
			{
				"name": "casualties",
				"salience": 0.007643877,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.007037644,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.0066514844,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.006137969,
				"type": "EVENT"
			},
			{
				"name": "incident",
				"salience": 0.006137969,
				"type": "EVENT"
			},
			{
				"name": "mosque",
				"salience": 0.006137969,
				"type": "LOCATION"
			},
			{
				"name": "light",
				"salience": 0.0059094112,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.005141629,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.005013126,
				"type": "EVENT"
			},
			{
				"name": "airstrikes",
				"salience": 0.0044629867,
				"type": "EVENT"
			},
			{
				"name": "casualties",
				"salience": 0.0043259654,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0043259654,
				"type": "LOCATION"
			},
			{
				"name": "Fadhiliya",
				"salience": 0.003948255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01c9bx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kirkuk"
				},
				"name": "Kirkuk",
				"salience": 0.0037814882,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shi'ite",
				"salience": 0.0037814882,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0037467426,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.0037467426,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0036995946,
				"type": "PERSON"
			},
			{
				"name": "concerns",
				"salience": 0.0036530388,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0034881518,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0030878342,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05zbsj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraqi_Air_Force"
				},
				"name": "Iraqi Air Force",
				"salience": 0.0030878342,
				"type": "ORGANIZATION"
			},
			{
				"name": "posts",
				"salience": 0.0027297684,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.0027074837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.002438099,
				"type": "LOCATION"
			},
			{
				"name": "facts",
				"salience": 0.0022007558,
				"type": "OTHER"
			},
			{
				"name": "take",
				"salience": 0.0020396109,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.0020396109,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0016806723,
				"type": "ORGANIZATION"
			},
			{
				"name": "allegations",
				"salience": 0.0015629415,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T03:36:34.209+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "US Promises 'Further Investigation' Into Attack in Fadhiliya by Jason Ditz, November 01, 2016 Share This \nOn October 22, US warplanes carried out airstrikes against the village of Fadhiliya, a few kilometers away from the city of Mosul. Two of the strikes hit a civilian house within, killing eight civilians from a single family, including three children. \nIt is unclear why the report of this airstrike is just coming to light now, over a week later, but it marks the first significant civilian casualties in a US airstrike related to the Mosul invasion. A previous incident the day before, initially reported as a US airstrike against a Shi’ite mosque near Kirkuk, is now being reported as likely an attack by the Iraqi Air Force, and not the US. \nPentagon officials confirmed conducting a number of airstrikes against Fadhiliya at the time of the civilian deaths, and say they are conducting “further investigation” to determine all the facts related to the attack. Saying the take the allegations seriously. \nAs the fighting around Mosul advances into more densely populated areas around the city itself, the concerns are growing that such airstrikes are going to cause a number of civilian casualties. This is doubly true because now Iraq is warning residents of Mosul against fleeing, and the US has announced its intention to carry out airstrikes to prevent “fleeing ISIS” from getting away. Last 5 posts by Jason Ditz",
		"thread_title": "US Airstrike Kills Eight Civilians Near Mosul",
		"title": "US Airstrike Kills Eight Civilians Near Mosul",
		"type": "bs",
		"uuid": "a75b8eca1b3d4a3a8abfdc61174dc7aa957084ac"
	},
	"-KhIjA8ppmJpObjG8aEw": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:36:34.219+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01px3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Line_of_Control"
				},
				"name": "Line of Control",
				"salience": 0.26704174,
				"type": "ORGANIZATION"
			},
			{
				"name": "situation",
				"salience": 0.07695922,
				"type": "OTHER"
			},
			{
				"name": "Side",
				"salience": 0.06959478,
				"type": "OTHER"
			},
			{
				"name": "villager",
				"salience": 0.06078821,
				"type": "PERSON"
			},
			{
				"name": "Both",
				"salience": 0.057461374,
				"type": "PERSON"
			},
			{
				"name": "Tensions",
				"salience": 0.05204577,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.04859541,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.045245294,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.027263569,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.021372767,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04f30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmir"
				},
				"name": "Kashmir",
				"salience": 0.020074219,
				"type": "LOCATION"
			},
			{
				"name": "amount",
				"salience": 0.018904453,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.018904453,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.018904453,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.018904453,
				"type": "EVENT"
			},
			{
				"name": "dust-up",
				"salience": 0.018866671,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.016359588,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.013477627,
				"type": "LOCATION"
			},
			{
				"name": "sides",
				"salience": 0.010213852,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.00906915,
				"type": "OTHER"
			},
			{
				"name": "firing",
				"salience": 0.008704858,
				"type": "EVENT"
			},
			{
				"name": "firing",
				"salience": 0.008381332,
				"type": "EVENT"
			},
			{
				"name": "situation",
				"salience": 0.00786303,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0068123844,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.0068123844,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0064238016,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.005564848,
				"type": "OTHER"
			},
			{
				"name": "bystanders",
				"salience": 0.005564848,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.005564848,
				"type": "PERSON"
			},
			{
				"name": "reality tensions",
				"salience": 0.0048025358,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.004725645,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.0041598496,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.0041598496,
				"type": "EVENT"
			},
			{
				"name": "focus",
				"salience": 0.0040558684,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.0039585857,
				"type": "LOCATION"
			},
			{
				"name": "fighting",
				"salience": 0.003499851,
				"type": "EVENT"
			},
			{
				"name": "firing",
				"salience": 0.0030468972,
				"type": "EVENT"
			},
			{
				"name": "blame",
				"salience": 0.0030311893,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0030311893,
				"type": "WORK_OF_ART"
			},
			{
				"name": "military",
				"salience": 0.0026154337,
				"type": "ORGANIZATION"
			},
			{
				"name": "fights",
				"salience": 0.0026154337,
				"type": "EVENT"
			},
			{
				"name": "raids",
				"salience": 0.0022650491,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.0013945271,
				"type": "LOCATION"
			},
			{
				"name": "sides",
				"salience": 0.00089872273,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/pakistan.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T03:36:34.219+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Both Blame Other Side for Fueling Tensions Along Line of Control by Jason Ditz, November 01, 2016 Share This \nOne villager in the area described the situation as like a “ full blown war, ” as Pakistani and Indian troops have exchanged a growing amount of fire across the Line of Control in Kashmir. The latest firing began on Friday and has continued to grow ever since. \nBoth sides are accusing the other, as usual, of starting the situation, and civilians living along the LoC are being evacuated in growing numbers. Since Friday at least 24 people have been killed in the firing , with the majority of them civilian bystanders. \nThis is the latest dust-up along the LoC since September, when militants attacked Indian forces within Kashmir and India responded with raids across the LoC, getting into fights with the Pakistani military on the other side. \nBoth sides say the latest firing from the other side was “unprovoked,” though in reality tensions have been boiling under the surface ever since the September incidents. The focus right now appears to be entirely on shifting blame for starting the fighting, with neither side seeming at all eager to stop firing. Last 5 posts by Jason Ditz",
		"thread_title": "24 Killed, Mostly Civilians, as Indian, Pakistani Forces Trade Fire in Kashmir",
		"title": "24 Killed, Mostly Civilians, as Indian, Pakistani Forces Trade Fire in Kashmir",
		"type": "bs",
		"uuid": "2f7b631ef7f4c5dd5f8cdc2246f2d63f3f6a2780"
	},
	"-KhIjAGIXKUHF8H5cJeO": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T03:45:17.947+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.18987781,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0280k2k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dmitry_Peskov"
				},
				"name": "Dmitry Peskov",
				"salience": 0.12580425,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.105972864,
				"type": "LOCATION"
			},
			{
				"name": "Strikes",
				"salience": 0.053059325,
				"type": "OTHER"
			},
			{
				"name": "moratorium",
				"salience": 0.047477547,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.047131207,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.04489971,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pause",
				"salience": 0.04265576,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03980804,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.030167412,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.022969501,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.022969501,
				"type": "LOCATION"
			},
			{
				"name": "positions",
				"salience": 0.015419824,
				"type": "OTHER"
			},
			{
				"name": "rebel attacks",
				"salience": 0.015419824,
				"type": "EVENT"
			},
			{
				"name": "jeopardy",
				"salience": 0.015419824,
				"type": "OTHER"
			},
			{
				"name": "counterattack",
				"salience": 0.015103512,
				"type": "EVENT"
			},
			{
				"name": "Western Aleppo",
				"salience": 0.013155172,
				"type": "LOCATION"
			},
			{
				"name": "aid",
				"salience": 0.00896697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.0084363455,
				"type": "PERSON"
			},
			{
				"name": "exit",
				"salience": 0.007903008,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.007903008,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.0068260734,
				"type": "EVENT"
			},
			{
				"name": "Eastern Aleppo",
				"salience": 0.006738362,
				"type": "LOCATION"
			},
			{
				"name": "end",
				"salience": 0.006165109,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.005984358,
				"type": "OTHER"
			},
			{
				"name": "counterattack",
				"salience": 0.005860995,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0058190976,
				"type": "LOCATION"
			},
			{
				"name": "east",
				"salience": 0.005791367,
				"type": "LOCATION"
			},
			{
				"name": "pause",
				"salience": 0.0056427657,
				"type": "OTHER"
			},
			{
				"name": "clashes",
				"salience": 0.005547012,
				"type": "OTHER"
			},
			{
				"name": "patient",
				"salience": 0.005547012,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.005230315,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.005141541,
				"type": "OTHER"
			},
			{
				"name": "Eastern Aleppo",
				"salience": 0.004728692,
				"type": "ORGANIZATION"
			},
			{
				"name": "siege",
				"salience": 0.004530388,
				"type": "EVENT"
			},
			{
				"name": "allies",
				"salience": 0.004530388,
				"type": "ORGANIZATION"
			},
			{
				"name": "airstrikes",
				"salience": 0.004329034,
				"type": "EVENT"
			},
			{
				"name": "defense ministry",
				"salience": 0.0039591645,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.003909355,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0024668179,
				"type": "OTHER"
			},
			{
				"name": "pick-up",
				"salience": 0.0024668179,
				"type": "EVENT"
			},
			{
				"name": "fighting",
				"salience": 0.0024668179,
				"type": "EVENT"
			},
			{
				"name": "calls",
				"salience": 0.0024668179,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0024668179,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01xp_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defence_minister"
				},
				"name": "Defense Ministry",
				"salience": 0.0024075902,
				"type": "ORGANIZATION"
			},
			{
				"name": "defeats",
				"salience": 0.0023570652,
				"type": "EVENT"
			},
			{
				"name": "pressure",
				"salience": 0.0021283438,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.0021283438,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.0018431211,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T03:45:17.947+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Warns Russia Can't Maintain Pause if Strikes Continue by Jason Ditz, November 01, 2016 Share This \nKremlin spokesman Dmitry Peskov warned today that the moratorium on Russian airstrikes around Aleppo is in jeopardy from the continued rebel attacks against positions around government-held Western Aleppo. \nPeskov insisted Russia wants to enable to exit of civilians from rebel Eastern Aleppo, and to create conditions wherein humanitarian aid can be delivered to the city. Russia has paused its airstrikes for about two weeks now to that end. \nWhile it seemed early on that Russia could afford to be patient, with Eastern Aleppo surrounded and the Syrian military doing well in clashes with the Nusra Front. Late last week, however, Nusra and their allies launched a major counterattack, which has been raging since. \nThe counterattack came from outside the city, trying to end the siege on the east and threatening government-held territories in the west. Russia has so far not gotten involved, and while the Syrian military seems to have staved off any huge defeats, this likely adds to pressure from Russia’s Defense Ministry. \nThough President Putin has so far insisted the pause should continue, the defense ministry has made much of calling for an end to it and resuming airstrikes. It is unusual for them to publicly dissent from official policy, and the pick-up in fighting will only increase those calls. Last 5 posts by Jason Ditz",
		"thread_title": "Russia: Rebel Attacks Around Aleppo Jeopardize Pause in Airstrikes",
		"title": "Russia: Rebel Attacks Around Aleppo Jeopardize Pause in Airstrikes",
		"type": "bs",
		"uuid": "7271a84fb9002defa7a755fadb46d601da928597"
	},
	"-KhIjAQKWfYcQJAy9HbP": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T04:39:11.765+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Ravina Shamdasani",
				"salience": 0.20280829,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.08872699,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.088085994,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.06964323,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.06363016,
				"type": "WORK_OF_ART"
			},
			{
				"name": "UN Human Rights",
				"salience": 0.043142173,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.03840255,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.036989044,
				"type": "LOCATION"
			},
			{
				"name": "strikes",
				"salience": 0.03329499,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.029007114,
				"type": "LOCATION"
			},
			{
				"name": "war crimes",
				"salience": 0.029007114,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.026712367,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.017518474,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.013360124,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.012863683,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.012863683,
				"type": "LOCATION"
			},
			{
				"name": "casualties",
				"salience": 0.010636345,
				"type": "OTHER"
			},
			{
				"name": "prohibition",
				"salience": 0.01045606,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.01045606,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.010067104,
				"type": "OTHER"
			},
			{
				"name": "factions",
				"salience": 0.010067104,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.010067104,
				"type": "PERSON"
			},
			{
				"name": "indications",
				"salience": 0.010067104,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.009859733,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.009859733,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.008541526,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.008541526,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.008541526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0071628042,
				"type": "ORGANIZATION"
			},
			{
				"name": "west",
				"salience": 0.00671673,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.006385203,
				"type": "EVENT"
			},
			{
				"name": "escalation",
				"salience": 0.0062256125,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.005948922,
				"type": "LOCATION"
			},
			{
				"name": "chlorine gas attacks",
				"salience": 0.005948922,
				"type": "EVENT"
			},
			{
				"name": "forces",
				"salience": 0.005372219,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0046528834,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reports",
				"salience": 0.0046528834,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.00444597,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00444597,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.0034769217,
				"type": "OTHER"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0034769217,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra",
				"salience": 0.0028652153,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.0028652153,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0021406885,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T04:39:11.765+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "A new statement from the UN Human Rights spokeswoman Ravina Shamdasani warned that there is growing evidence that all sides fighting around the northern Syrian city of Aleppo are engaged in war crimes by conducting indiscriminate strikes in civilian-populated areas. \nShamdasani warned that while the UN lacked details to attribute individual attacks to different factions in the area, the indications are that everyone has basically ignored the “fundamental prohibition” on launching such attacks when civilians are present. \nThis has been a recurring concern for months in Aleppo, with large civilian casualties reported on a disturbingly regular basis. And while most of the international forces with an interest in Syria are keen to exclusively blame one side or the other, civilians in both sides’ neighborhoods are being killed. \nRussia has paused their airstrikes against Aleppo over the past couple of weeks, though an escalation in fighting further west has meant civilian casualties have continued, with reports of chlorine gas attacks by Nusra forces against government-held areas. Last 5 posts by Jason Ditz",
		"thread_title": "UN: All Sides in Aleppo May Be Committing War Crimes",
		"title": "UN: All Sides in Aleppo May Be Committing War Crimes",
		"type": "bs",
		"uuid": "c4c943cb6f373f094bd5765a033a5c2446d4a2ff"
	},
	"-KhIjAYtc5fQe7j6y1r-": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T04:39:13.614+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.1832616,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.12014568,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.07681977,
				"type": "LOCATION"
			},
			{
				"name": "talks",
				"salience": 0.06705069,
				"type": "EVENT"
			},
			{
				"name": "Sergey Shogu",
				"salience": 0.058976553,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.045801472,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03w86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamism"
				},
				"name": "Islamist",
				"salience": 0.043105092,
				"type": "OTHER"
			},
			{
				"name": "Failure",
				"salience": 0.042626422,
				"type": "OTHER"
			},
			{
				"name": "indication",
				"salience": 0.042626422,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.038063202,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_nl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cabal"
				},
				"name": "Factions",
				"salience": 0.036432818,
				"type": "OTHER"
			},
			{
				"name": "peace talks",
				"salience": 0.02847603,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.026439484,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07hgcp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rein"
				},
				"name": "Rein",
				"salience": 0.026439484,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.017752817,
				"type": "OTHER"
			},
			{
				"name": "rebel factions",
				"salience": 0.012818654,
				"type": "OTHER"
			},
			{
				"name": "prospects",
				"salience": 0.00927313,
				"type": "OTHER"
			},
			{
				"name": "factions",
				"salience": 0.008835027,
				"type": "OTHER"
			},
			{
				"name": "peace talks",
				"salience": 0.008506429,
				"type": "EVENT"
			},
			{
				"name": "rebel factions",
				"salience": 0.008506429,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0079196505,
				"type": "OTHER"
			},
			{
				"name": "talks",
				"salience": 0.007309378,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.006387929,
				"type": "EVENT"
			},
			{
				"name": "air strikes",
				"salience": 0.006387929,
				"type": "EVENT"
			},
			{
				"name": "eye",
				"salience": 0.006387929,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.0061500752,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0061500752,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.005395672,
				"type": "OTHER"
			},
			{
				"name": "rebel groups",
				"salience": 0.0052173263,
				"type": "ORGANIZATION"
			},
			{
				"name": "separation",
				"salience": 0.0052173263,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0051340736,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.0039355597,
				"type": "ORGANIZATION"
			},
			{
				"name": "doubts",
				"salience": 0.0038994,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0038994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0032136622,
				"type": "LOCATION"
			},
			{
				"name": "posts",
				"salience": 0.0028410137,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ways",
				"salience": 0.0028410137,
				"type": "OTHER"
			},
			{
				"name": "peace process",
				"salience": 0.0028410137,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0021227424,
				"type": "ORGANIZATION"
			},
			{
				"name": "anything",
				"salience": 0.0021227424,
				"type": "OTHER"
			},
			{
				"name": "None",
				"salience": 0.0013621092,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0013067739,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T04:39:13.614+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.3,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Blames Western Failure to Rein in Islamist Factions by Jason Ditz, November 01, 2016 Share This \nWhile there really hasn’t been any indication that such talks were going to happen soon at any rate, Russian Defense Minister Sergey Shogu made it official today that Syrian peace talks are “ postponed for an indefinite period .” \nShogu insisted there were no prospects for new peace talks right now because the West had failed to rein in Islamist rebel factions in the country, adding that this continued in spite of Russia pausing their air strikes against Aleppo. \nThe previous ceasefire in Syria had been negotiated with an eye on separating the Islamist factions like the Nusra Front from more moderate rebel groups. The US made a public statement calling for such a separation, but it never happened, and ultimately, Russia started trying to convince Turkey and Saudi Arabia to try. None have accomplished anything so far. \nIn the meantime, the US and its allies began angrily condemning Russia and Syria for attacking the Nusra Front, complaining it proved Russia doesn’t want peace. This too is adding to doubts about getting new talks started, with everyone seemingly agreeing Nusra can’t participate in the peace process, but not able to get them split in meaningful ways from the rebel factions that might be welcomed. Last 5 posts by Jason Ditz",
		"thread_title": "Russian DM: Syria Peace Talks Indefinitely Postponed",
		"title": "Russian DM: Syria Peace Talks Indefinitely Postponed",
		"type": "bs",
		"uuid": "a91318929caea922088c69e00850ce093255e81b"
	},
	"-KhIjAij8fOm9L2AP5Pg": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T04:48:42.507+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.30494323,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.15130724,
				"type": "LOCATION"
			},
			{
				"name": "Developments",
				"salience": 0.041977864,
				"type": "OTHER"
			},
			{
				"name": "Region",
				"salience": 0.041977864,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.039178345,
				"type": "PERSON"
			},
			{
				"name": "DM",
				"salience": 0.036462422,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.036462422,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.036462422,
				"type": "OTHER"
			},
			{
				"name": "Deployments",
				"salience": 0.033945672,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.021797467,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.019379143,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0175151,
				"type": "LOCATION"
			},
			{
				"name": "convoy",
				"salience": 0.015185669,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.015185669,
				"type": "OTHER"
			},
			{
				"name": "artillery",
				"salience": 0.015185669,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.015185669,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.011975476,
				"type": "LOCATION"
			},
			{
				"name": "developments",
				"salience": 0.011857738,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.011857738,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.009161111,
				"type": "ORGANIZATION"
			},
			{
				"name": "deployment",
				"salience": 0.007567468,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.006983766,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.0068872455,
				"type": "LOCATION"
			},
			{
				"name": "deployment",
				"salience": 0.0066691823,
				"type": "EVENT"
			},
			{
				"name": "sides",
				"salience": 0.006307732,
				"type": "OTHER"
			},
			{
				"name": "deployment",
				"salience": 0.0055872765,
				"type": "EVENT"
			},
			{
				"name": "invasion",
				"salience": 0.0054642013,
				"type": "EVENT"
			},
			{
				"name": "argument",
				"salience": 0.0054642013,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.0052607427,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Erdogan",
				"salience": 0.0050119213,
				"type": "PERSON"
			},
			{
				"name": "spate",
				"salience": 0.004462874,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.004462874,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0038511595,
				"type": "LOCATION"
			},
			{
				"name": "factions",
				"salience": 0.003508822,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.0034577004,
				"type": "PERSON"
			},
			{
				"name": "Abadi",
				"salience": 0.0033664575,
				"type": "PERSON"
			},
			{
				"name": "everywhere",
				"salience": 0.0033355267,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.0029017658,
				"type": "EVENT"
			},
			{
				"name": "deployment",
				"salience": 0.002681274,
				"type": "EVENT"
			},
			{
				"name": "posts",
				"salience": 0.0024301885,
				"type": "WORK_OF_ART"
			},
			{
				"name": "right",
				"salience": 0.0024301885,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0020967592,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0020967592,
				"type": "ORGANIZATION"
			},
			{
				"name": "force",
				"salience": 0.0020967592,
				"type": "OTHER"
			},
			{
				"name": "Kurdish YPG",
				"salience": 0.0020540478,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0018157829,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j40h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan_Workers'_Party"
				},
				"name": "PKK",
				"salience": 0.0016996632,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0015474738,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0014962389,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2011/05/Turkey_map.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T04:48:42.507+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "DM: Deployments Aim to Prepare for 'Developments in the Region' by Jason Ditz, November 01, 2016 Share This \nAdding to concerns about tensions between the Turkish and Iraqi government, Turkey has deployed a convoy of tanks and artillery along the Iraqi border today, a move they say it meant to prepare for any potential “developments” in the region. \nThe deployment appears to be centered on the area around Mosul. Turkish President Erdogan promised to participate in the invasion of Mosul, but was spurned by the Abadi government in Iraq. This has been an ongoing argument between the two sides, and the deployment may suggest Turkey plans an involvement in Mosul, however unwelcome. \nThe deployment also comes following a recent spate of fighting with the Kurdish PKK inside southeastern Turkey, and some reports have speculated that the deployment could be intended as further force against the PKK forces on the Iraqi side of the border. \nWhile Turkey has been fighting Kurdish factions pretty much everywhere for decades, the government has picked up its attacks against the Kurdish YPG in Syria over the past month, and also claimed a “ natural right ” to invade Iraq if they are threatened. Last 5 posts by Jason Ditz",
		"thread_title": "Turkey Deploys Tanks, Artillery Along Iraq Border",
		"title": "Turkey Deploys Tanks, Artillery Along Iraq Border",
		"type": "bs",
		"uuid": "fee5a9f547bbe8146a8419cb0177b58ce074aca2"
	},
	"-KhIjB8JN9EzOlBFdrhz": {
		"author": "Lawrence Wittner",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T06:05:18.392+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "weapons",
				"salience": 0.6718998,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.08337144,
				"type": "ORGANIZATION"
			},
			{
				"name": "disarmament",
				"salience": 0.025240507,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05jzn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Treaty_on_the_Non-Proliferation_of_Nuclear_Weapons"
				},
				"name": "Non-Proliferation Treaty",
				"salience": 0.011002055,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.010559333,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.008524395,
				"type": "LOCATION"
			},
			{
				"name": "warheads",
				"salience": 0.006625653,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.005948526,
				"type": "OTHER"
			},
			{
				"name": "weaponry",
				"salience": 0.005901211,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.005003679,
				"type": "OTHER"
			},
			{
				"name": "halt",
				"salience": 0.0047178054,
				"type": "EVENT"
			},
			{
				"name": "governments",
				"salience": 0.0044689444,
				"type": "ORGANIZATION"
			},
			{
				"name": "reductions",
				"salience": 0.004096201,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.003943433,
				"type": "ORGANIZATION"
			},
			{
				"name": "arsenals",
				"salience": 0.0030849932,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0027860038,
				"type": "EVENT"
			},
			{
				"name": "Wars",
				"salience": 0.0027860038,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0027860038,
				"type": "PERSON"
			},
			{
				"name": "total",
				"salience": 0.0026366473,
				"type": "OTHER"
			},
			{
				"name": "deterrence",
				"salience": 0.0025649543,
				"type": "OTHER"
			},
			{
				"name": "play",
				"salience": 0.002413044,
				"type": "OTHER"
			},
			{
				"name": "disinterest",
				"salience": 0.002413044,
				"type": "OTHER"
			},
			{
				"name": "hesitation",
				"salience": 0.002413044,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.002413044,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.0021392114,
				"type": "OTHER"
			},
			{
				"name": "thanks",
				"salience": 0.0021260437,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0021185288,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.002078768,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Ronald Reagan",
				"salience": 0.0020511888,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03d3gpw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lawrence_S._Wittner"
				},
				"name": "Lawrence S. Wittner",
				"salience": 0.001963352,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.00181136,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0016925988,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons",
				"salience": 0.0016444152,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0015336508,
				"type": "ORGANIZATION"
			},
			{
				"name": "others",
				"salience": 0.0014911781,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0014860651,
				"type": "ORGANIZATION"
			},
			{
				"name": "danger",
				"salience": 0.0014679529,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.0014628728,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0014580023,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0014580023,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.001403617,
				"type": "ORGANIZATION"
			},
			{
				"name": "programs",
				"salience": 0.0013759988,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0013273594,
				"type": "ORGANIZATION"
			},
			{
				"name": "cutbacks",
				"salience": 0.0013136999,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0012712497,
				"type": "OTHER"
			},
			{
				"name": "warheads",
				"salience": 0.0012712497,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.001263527,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.001219729,
				"type": "OTHER"
			},
			{
				"name": "military spending",
				"salience": 0.0011478729,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0011478729,
				"type": "EVENT"
			},
			{
				"name": "complex",
				"salience": 0.0011478729,
				"type": "LOCATION"
			},
			{
				"name": "accidents",
				"salience": 0.0011478729,
				"type": "EVENT"
			},
			{
				"name": "accident",
				"salience": 0.0011478729,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.0011478729,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0011400898,
				"type": "LOCATION"
			},
			{
				"name": "nations",
				"salience": 0.0010975521,
				"type": "ORGANIZATION"
			},
			{
				"name": "nations",
				"salience": 0.0010975521,
				"type": "LOCATION"
			},
			{
				"name": "nations",
				"salience": 0.0010975521,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/034ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_H._W._Bush"
				},
				"name": "George H.W. Bush",
				"salience": 0.0010613458,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0010420248,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0010159397,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0010001864,
				"type": "OTHER"
			},
			{
				"name": "terrorist fanatics",
				"salience": 0.0009940239,
				"type": "PERSON"
			},
			{
				"name": "explosion",
				"salience": 0.0009940239,
				"type": "EVENT"
			},
			{
				"name": "service",
				"salience": 0.0009940239,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0009910187,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0009649242,
				"type": "OTHER"
			},
			{
				"name": "reduction",
				"salience": 0.0009649242,
				"type": "OTHER"
			},
			{
				"name": "reductions",
				"salience": 0.0009649242,
				"type": "OTHER"
			},
			{
				"name": "pressures",
				"salience": 0.0009649242,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0009649242,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0009289169,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0009289169,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0009253543,
				"type": "OTHER"
			},
			{
				"name": "arsenal",
				"salience": 0.000891445,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0008893707,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0008893707,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00085817766,
				"type": "LOCATION"
			},
			{
				"name": "arsenals",
				"salience": 0.00085817766,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.00080490374,
				"type": "OTHER"
			},
			{
				"name": "deterrent",
				"salience": 0.00078777224,
				"type": "OTHER"
			},
			{
				"name": "presidents",
				"salience": 0.00078777224,
				"type": "PERSON"
			},
			{
				"name": "powers",
				"salience": 0.00078777224,
				"type": "OTHER"
			},
			{
				"name": "deterrence",
				"salience": 0.00078777224,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.00078777224,
				"type": "OTHER"
			},
			{
				"name": "spending",
				"salience": 0.0007748639,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0007686737,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0007589895,
				"type": "OTHER"
			},
			{
				"name": "dangers",
				"salience": 0.00072182924,
				"type": "OTHER"
			},
			{
				"name": "investment",
				"salience": 0.0007148966,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0006969957,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0006969957,
				"type": "OTHER"
			},
			{
				"name": "taxpayers",
				"salience": 0.0006969957,
				"type": "PERSON"
			},
			{
				"name": "show",
				"salience": 0.0006969957,
				"type": "WORK_OF_ART"
			},
			{
				"name": "public",
				"salience": 0.0006969957,
				"type": "PERSON"
			},
			{
				"name": "respect",
				"salience": 0.0006969957,
				"type": "OTHER"
			},
			{
				"name": "bargain",
				"salience": 0.0006969957,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.0006969957,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.00067399105,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "proliferation",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.00067098084,
				"type": "LOCATION"
			},
			{
				"name": "modernization",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "latter",
				"salience": 0.00067098084,
				"type": "ORGANIZATION"
			},
			{
				"name": "retention",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "willingness",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.00067098084,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00065711385,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.00065711385,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00065711385,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.00065711385,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.00065711385,
				"type": "OTHER"
			},
			{
				"name": "Opponents",
				"salience": 0.00065417896,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.00063606765,
				"type": "ORGANIZATION"
			},
			{
				"name": "aggression",
				"salience": 0.0006139911,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00060897466,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.00058850116,
				"type": "OTHER"
			},
			{
				"name": "missile defense system",
				"salience": 0.0005690095,
				"type": "OTHER"
			},
			{
				"name": "government officials",
				"salience": 0.0005690095,
				"type": "PERSON"
			},
			{
				"name": "armada",
				"salience": 0.0005690095,
				"type": "LOCATION"
			},
			{
				"name": "claims",
				"salience": 0.0005690095,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0005690095,
				"type": "OTHER"
			},
			{
				"name": "disarmament",
				"salience": 0.0005506117,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.00054367346,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.00050763716,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0004839037,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0004839037,
				"type": "ORGANIZATION"
			},
			{
				"name": "lead",
				"salience": 0.00046451562,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.00046287145,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.00045288185,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00044352055,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0004415393,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet Union",
				"salience": 0.0004318574,
				"type": "LOCATION"
			},
			{
				"name": "consequences",
				"salience": 0.00042505574,
				"type": "OTHER"
			},
			{
				"name": "testing",
				"salience": 0.00042505574,
				"type": "EVENT"
			},
			{
				"name": "administration",
				"salience": 0.00042505574,
				"type": "EVENT"
			},
			{
				"name": "security",
				"salience": 0.00042505574,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00039893878,
				"type": "WORK_OF_ART"
			},
			{
				"name": "world",
				"salience": 0.0003959553,
				"type": "LOCATION"
			},
			{
				"name": "warheads",
				"salience": 0.0003959553,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0003783223,
				"type": "LOCATION"
			},
			{
				"name": "arms",
				"salience": 0.00035750156,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00035750156,
				"type": "OTHER"
			},
			{
				"name": "novel",
				"salience": 0.00032982527,
				"type": "WORK_OF_ART"
			},
			{
				"name": "vessels",
				"salience": 0.00030955806,
				"type": "OTHER"
			},
			{
				"name": "cut",
				"salience": 0.00030955806,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00030955806,
				"type": "WORK_OF_ART"
			},
			{
				"name": "university life",
				"salience": 0.00030955806,
				"type": "OTHER"
			},
			{
				"name": "History emeritus",
				"salience": 0.00030955806,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00030702824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern Europe",
				"salience": 0.0003021181,
				"type": "LOCATION"
			},
			{
				"name": "version",
				"salience": 0.0003018042,
				"type": "WORK_OF_ART"
			},
			{
				"name": "targets",
				"salience": 0.0002796883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01brfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joint_Chiefs_of_Staff"
				},
				"name": "Joint Chiefs of Staff",
				"salience": 0.00026832148,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack",
				"salience": 0.00026704514,
				"type": "EVENT"
			},
			{
				"name": "arms",
				"salience": 0.00026704514,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.00026704514,
				"type": "OTHER"
			},
			{
				"name": "Solidarity Press",
				"salience": 0.00026378655,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "North Korea",
				"salience": 0.00026160027,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.00026160027,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "India",
				"salience": 0.00026160027,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.00026160027,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00026160027,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.00026160027,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.00026160027,
				"type": "LOCATION"
			},
			{
				"name": "capacity",
				"salience": 0.00024951508,
				"type": "OTHER"
			},
			{
				"name": "disease",
				"salience": 0.00023123014,
				"type": "OTHER"
			},
			{
				"name": "starvation",
				"salience": 0.00023123014,
				"type": "OTHER"
			},
			{
				"name": "exposure",
				"salience": 0.00023123014,
				"type": "EVENT"
			},
			{
				"name": "wounds",
				"salience": 0.00023123014,
				"type": "OTHER"
			},
			{
				"name": "survivors",
				"salience": 0.00023123014,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.00023123014,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.00023123014,
				"type": "EVENT"
			},
			{
				"name": "possession",
				"salience": 0.00023123014,
				"type": "OTHER"
			},
			{
				"name": "acquisition",
				"salience": 0.00023123014,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.00023123014,
				"type": "PERSON"
			},
			{
				"name": "efficacy",
				"salience": 0.00023123014,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asia",
				"salience": 0.00022001928,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.00022001928,
				"type": "LOCATION"
			},
			{
				"name": "The Asia-Pacific Journal",
				"salience": 0.00019051017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "UAardvark",
				"salience": 0.00019051017,
				"type": "OTHER"
			},
			{
				"name": "What's Going On",
				"salience": 0.00019051017,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02dq8f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_at_Albany,_SUNY"
				},
				"name": "SUNY/Albany",
				"salience": 0.00019051017,
				"type": "ORGANIZATION"
			},
			{
				"name": "http://lawrenceswittner.com",
				"salience": 0.00019051017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "US Navy",
				"salience": 0.00019051017,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.00018740348,
				"type": "LOCATION"
			},
			{
				"name": "study",
				"salience": 0.00018637751,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00016434434,
				"type": "PERSON"
			},
			{
				"name": "devastation",
				"salience": 0.00014833044,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:05:18.392+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nAt present, nuclear disarmament seems to have ground to a halt. Nine nations have a total of approximately 15,500 nuclear warheads in their arsenals, including 7,300 possessed by Russia and 7,100 possessed by the United States. A Russian-American treaty to further reduce their nuclear forces has been difficult to secure thanks to Russian disinterest and Republican resistance. \nYet nuclear disarmament remains vital, for, as long as nuclear weapons exist, it is likely that they will be used. Wars have been fought for thousands of years, with the most powerful weaponry often brought into play. Nuclear weapons were used with little hesitation by the US government in 1945 and, although they have not been employed in war since then, how long can we expect to go on without their being pressed into service again by hostile governments? \nFurthermore, even if governments avoid using them for war, there remains the danger of their explosion by terrorist fanatics or simply by accident. More than a thousand accidents involving US nuclear weapons occurred between 1950 and 1968 alone. Many were trivial, but others could have been disastrous. Although none of the accidentally launched nuclear bombs, missiles, and warheads―some of which have never been found―exploded, we might not be as lucky in the future. \nAlso, nuclear weapons programs are enormously costly. Currently, the US government plans to spend $1 trillion over the next 30 years to refurbish the entire US nuclear weapons complex. Is this really affordable? Given the fact that military spending already chews up 54 percent of the federal government’s discretionary spending, an additional $1 trillion for nuclear weapons \"modernization\" seems likely to come out of whatever now remains of funding for public education, public health, and other domestic programs. \nIn addition, the proliferation of nuclear weapons to additional countries remains a constant danger. The nuclear Non-Proliferation Treaty (NPT) of 1968 was a compact between the non-nuclear nations and nuclear-armed nations, with the former forgoing nuclear weapons development while the latter eliminated their nuclear arsenals. But the nuclear powers’ retention of nuclear weapons is eroding the willingness of other nations to abide by the treaty. \nConversely, further nuclear disarmament would result in some very real benefits to the United States. A significant reduction in the 2,000 US nuclear weapons deployed around the world would reduce nuclear dangers and save the US government enormous amounts of money that could fund domestic programs or simply be returned to happy taxpayers. Also, with this show of respect for the bargain made under the NPT, non-nuclear nations would be less inclined to embark on nuclear weapons programs. \nUnilateral US nuclear reductions would also generate pressures to follow the US lead. If the US government announced cutbacks in its nuclear arsenal, while challenging the Kremlin to do the same, that would embarrass the Russian government before world public opinion, the governments of other nations, and its own public. Eventually, with much to gain and little to lose by engaging in nuclear reductions, the Kremlin might begin making them as well. \nOpponents of nuclear reductions argue that nuclear weapons must be retained, for they serve as a \"deterrent.\" But does nuclear deterrence really work? Ronald Reagan , one of America’s most military-minded presidents, repeatedly brushed off airy claims that US nuclear weapons had deterred Soviet aggression, retorting: \"Maybe other things had.\" Also, non-nuclear powers have fought numerous wars with the nuclear powers (including the United States and the Soviet Union) since 1945. Why weren’t they deterred? \nOf course, much deterrence thinking focuses on the safety from nuclear attack that nuclear weapons allegedly provide. But, in fact, US government officials, despite their vast nuclear armada, don’t seem to feel very secure. How else can we explain their huge financial investment in a missile defense system? Also, why have they been so worried about the Iranian government obtaining nuclear weapons? After all, the US government’s possession of thousands of nuclear weapons should convince them that they needn’t worry about the acquisition of nuclear arms by Iran or any other nation. \nFurthermore, even if nuclear deterrence does work, why does Washington require 2,000 deployed nuclear weapons to ensure its efficacy? A 2002 study concluded that, if only 300 US nuclear weapons were used to attack Russian targets, 90 million Russians (out of a population of 144 million) would die in the first half hour. Moreover, in the ensuing months, the enormous devastation produced by the attack would result in the deaths of the vast majority of survivors by wounds, disease, exposure, and starvation. Surely no Russian or other government would find this an acceptable outcome. \nThis overkill capacity probably explains why the US Joint Chiefs of Staff think that 1,000 deployed nuclear weapons are sufficient to safeguard US national security. It might also explain why none of the other seven nuclear powers (Britain, France, China, Israel, India, Pakistan, and North Korea) bothers to maintain more than 300 nuclear weapons . \nAlthough unilateral action to reduce nuclear dangers might sound frightening, it has been taken numerous times with no adverse consequences. The Soviet government unilaterally halted nuclear weapons testing in 1958 and, again, in 1985. Starting in 1989, it also began removing its tactical nuclear missiles from Eastern Europe. Similarly, the US government, during the administration of US president George H.W. Bush, acted unilaterally to remove all US short-range, ground-launched nuclear weapons from Europe and Asia, as well as all short-range nuclear arms from US Navy vessels around the world―an overall cut of several thousand nuclear warheads. \nObviously, negotiating an international treaty that banned and destroyed all nuclear weapons would be the best way to abolish nuclear dangers. But that need not preclude other useful action from being taken along the way. \nLawrence S. Wittner ( http://lawrenceswittner.com ) is Professor of History emeritus at SUNY/Albany. His latest book is a satirical novel about university life, What’s Going On at UAardvark? (Solidarity Press). A longer version of this article appeared originally in The Asia-Pacific Journal . Read more by Lawrence Wittner",
		"thread_title": "Let’s Reduce the US Nuclear Arsenal",
		"title": "Let’s Reduce the US Nuclear Arsenal",
		"type": "bs",
		"uuid": "1667c87cec747c23555b26dd92a0b93fd4474279"
	},
	"-KhIjBHk5mY1QvMts0uT": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T06:09:30.677+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.23422979,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.1960749,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.15316501,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.06839765,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.066773646,
				"type": "LOCATION"
			},
			{
				"name": "league",
				"salience": 0.038678415,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.036199637,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.029533561,
				"type": "EVENT"
			},
			{
				"name": "election campaign",
				"salience": 0.024364237,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.024364237,
				"type": "EVENT"
			},
			{
				"name": "allegations",
				"salience": 0.017155617,
				"type": "OTHER"
			},
			{
				"name": "Ties",
				"salience": 0.015519008,
				"type": "OTHER"
			},
			{
				"name": "Clinton Campaign Demands FBI Affirm Trump",
				"salience": 0.013561781,
				"type": "ORGANIZATION"
			},
			{
				"name": "demands",
				"salience": 0.013469763,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0204x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_Reid"
				},
				"name": "Harry Reid",
				"salience": 0.00974852,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.008338899,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigations",
				"salience": 0.0041577453,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0041410974,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0029530001,
				"type": "OTHER"
			},
			{
				"name": "coordination",
				"salience": 0.0028644407,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.00249241,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0023711296,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.002009998,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.002009998,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0019351022,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0288jjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada_Democratic_Party"
				},
				"name": "D -- NV",
				"salience": 0.0017649294,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.0016659314,
				"type": "PERSON"
			},
			{
				"name": "refusal",
				"salience": 0.0016414365,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0016414365,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0016358952,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.0016308199,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.0012266111,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0012266111,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.0012266111,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.0012266111,
				"type": "WORK_OF_ART"
			},
			{
				"name": "calls",
				"salience": 0.0011959216,
				"type": "OTHER"
			},
			{
				"name": "campaign scandal",
				"salience": 0.0011959216,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hwr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2008_Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.0011918215,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.0011427173,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0009520252,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0009206188,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0008868923,
				"type": "OTHER"
			},
			{
				"name": "puppet",
				"salience": 0.00088231673,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0008124396,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.00075522595,
				"type": "ORGANIZATION"
			},
			{
				"name": "story",
				"salience": 0.0006675997,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2011/09/fbi_building.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:09:30.677+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Clinton Campaign Demands FBI Affirm Trump's Russia Ties   \nWith the 2016 election campaign winding down, the Clinton campaign is ratcheting up demands for the FBI to publicly confirm the campaign’s allegations that Republican nominee Donald Trump is secretly in league with Russia. Sen. Harry Reid (D – NV) went so far as to claim the FBI has secret “explosive” evidence of coordination between the Trump campaign and the Russian government that it is withholding. \nFBI officials familiar with their investigations into the allegations, which the Clinton campaign started publicizing around the Democratic National Convention, say they’ve turned up nothing to connect Trump and Russia , leading FBI Director James Comey to decide against making any statements to that effect. \nThe Clinton campaign has been making the allegations so long that they have taken to claiming “everyone knows” that they are true, and appears unsettled by the FBI’s refusal to sign off on the claims simply because they haven’t been able to find real evidence corroborating the story. \nThe Trump campaign has repeatedly denied ties to Russia, but that didn’t stop Clinton from calling Trump a “puppet” of Russian President Vladimir Putin during the final presidential debate. The calls have grown since Friday’s FBI report to Congress about further Clinton emails being sought. \nWith Clinton’s main campaign scandal growing in the waning weeks of the deal, some in her campaign have suggested that affirming Trump as secretly in league with the Russians would only be fair. Absent any evidence, however, it appears that won’t be happening.  ",
		"thread_title": "US Officials See No Link Between Trump and Russia",
		"title": "US Officials See No Link Between Trump and Russia",
		"type": "bs",
		"uuid": "7689304c2cc68e4271e0d77e5a6acb0f9d9c79ed"
	},
	"-KhIjBRqSufCUB9IVQhF": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T06:09:32.275+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.3016815,
				"type": "ORGANIZATION"
			},
			{
				"name": "UN Reports ISIS",
				"salience": 0.25599462,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.07256603,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.069023356,
				"type": "PERSON"
			},
			{
				"name": "fleet",
				"salience": 0.045124423,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.034388833,
				"type": "LOCATION"
			},
			{
				"name": "trucks",
				"salience": 0.030428885,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "minibuses",
				"salience": 0.030428885,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "population",
				"salience": 0.030428885,
				"type": "PERSON"
			},
			{
				"name": "military personnel",
				"salience": 0.015814329,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.013521994,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.012699201,
				"type": "LOCATION"
			},
			{
				"name": "human shields",
				"salience": 0.009919403,
				"type": "OTHER"
			},
			{
				"name": "government warnings",
				"salience": 0.006924991,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.0058887945,
				"type": "EVENT"
			},
			{
				"name": "human shields thing",
				"salience": 0.0056698583,
				"type": "OTHER"
			},
			{
				"name": "warnings",
				"salience": 0.0056584543,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0052794972,
				"type": "OTHER"
			},
			{
				"name": "busing",
				"salience": 0.0045738495,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0043128813,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.0043128813,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.003969184,
				"type": "LOCATION"
			},
			{
				"name": "concern",
				"salience": 0.0037360473,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0037360473,
				"type": "EVENT"
			},
			{
				"name": "lead-up",
				"salience": 0.0037360473,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07pgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tigris"
				},
				"name": "Tigris River",
				"salience": 0.0028184962,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0027926082,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0027926082,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0026017476,
				"type": "LOCATION"
			},
			{
				"name": "fighters",
				"salience": 0.0023494675,
				"type": "PERSON"
			},
			{
				"name": "announcements",
				"salience": 0.0020348108,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0017556858,
				"type": "ORGANIZATION"
			},
			{
				"name": "elements",
				"salience": 0.0015204569,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0015152433,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:09:32.275+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "At Least 40 Killed Over Weekend, UN Reports   \nISIS has been reported to be using a fleet of trucks and minibuses to transport the civilian population of the area around Mosul into the city itself, which officials are saying they believe is a sign that ISIS intends to use them as human shields. \nWhile the human shields thing is purely speculative, what appears to be more certain is that those former Iraqi military personnel that ISIS is coming across in their forced busing are being executed, with reports that some 40 were killed over the weekend and thrown into the Tigris River . \nThis has been a recurring concern for ISIS since the Mosul battle began. ISIS executed some of their own fighters in the lead-up when they were claimed to be working with the Iraqi government, and have been desperate to purge any other potentially disloyal elements around the city. \nWhile the UN was harshly critical of ISIS for forcibly relocating people around Mosul, they have so far been mum on government warnings that civilians in Mosul not attempt to escape the city, warnings which came amid announcements that the US intends to launch airstrikes against “fleeing ISIS fighters.”  ",
		"thread_title": "ISIS Killing Former Soldiers in Areas Around Mosul",
		"title": "ISIS Killing Former Soldiers in Areas Around Mosul",
		"type": "bs",
		"uuid": "cf0529f08b83122b6d8b2779efb2716496fea74c"
	},
	"-KhIjCRve_Klkh0VNC5U": {
		"author": "Laura Carlsen",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T06:14:56.373+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01ls2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colombia"
				},
				"name": "Colombian",
				"salience": 0.44525847,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01kb1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C3%81lvaro_Uribe"
				},
				"name": "Alvaro Uribe",
				"salience": 0.029325368,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xlx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Plan_Colombia"
				},
				"name": "Plan Colombia",
				"salience": 0.029157603,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06hvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FARC"
				},
				"name": "FARC",
				"salience": 0.012434613,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01ls2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colombia"
				},
				"name": "Colombians",
				"salience": 0.011915643,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0117881745,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.009916654,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.009729048,
				"type": "OTHER"
			},
			{
				"name": "NO voter",
				"salience": 0.0096790325,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.008101772,
				"type": "OTHER"
			},
			{
				"name": "NO voters",
				"salience": 0.0071984977,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/082cb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/War"
				},
				"name": "War",
				"salience": 0.006849769,
				"type": "OTHER"
			},
			{
				"name": "mentality",
				"salience": 0.006341954,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0055419854,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0055419854,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0049898126,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0049505886,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0045029093,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.004414312,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0042865714,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0041435184,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0041435184,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0037626554,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.0036318412,
				"type": "EVENT"
			},
			{
				"name": "NO voters",
				"salience": 0.003240547,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.003240547,
				"type": "PERSON"
			},
			{
				"name": "peoples",
				"salience": 0.003125397,
				"type": "PERSON"
			},
			{
				"name": "belief",
				"salience": 0.0030281607,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0029427942,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.0026770697,
				"type": "OTHER"
			},
			{
				"name": "pundits",
				"salience": 0.0026678056,
				"type": "PERSON"
			},
			{
				"name": "NO promoters",
				"salience": 0.002627985,
				"type": "PERSON"
			},
			{
				"name": "myth",
				"salience": 0.0026219762,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.002576294,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.002490628,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.002490628,
				"type": "EVENT"
			},
			{
				"name": "mentality",
				"salience": 0.0024001345,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0023169818,
				"type": "EVENT"
			},
			{
				"name": "accords",
				"salience": 0.0023010287,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.002215112,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0021945382,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.0021619168,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.0020777122,
				"type": "OTHER"
			},
			{
				"name": "proposition",
				"salience": 0.0020777122,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0020777122,
				"type": "LOCATION"
			},
			{
				"name": "issue",
				"salience": 0.00207052,
				"type": "OTHER"
			},
			{
				"name": "peace accord",
				"salience": 0.0020396865,
				"type": "OTHER"
			},
			{
				"name": "peace talks",
				"salience": 0.0019475303,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.0019475303,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019475303,
				"type": "ORGANIZATION"
			},
			{
				"name": "analysis",
				"salience": 0.0019475303,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0019475303,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02pqvmj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Juan_Manuel_Santos"
				},
				"name": "Juan Santos",
				"salience": 0.0019134193,
				"type": "PERSON"
			},
			{
				"name": "analysis",
				"salience": 0.0018317838,
				"type": "OTHER"
			},
			{
				"name": "factors",
				"salience": 0.0018303642,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0018127892,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0017992393,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.0017992393,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0017067845,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0017067845,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0016974978,
				"type": "OTHER"
			},
			{
				"name": "referendum",
				"salience": 0.0016245845,
				"type": "OTHER"
			},
			{
				"name": "referendum",
				"salience": 0.0016245845,
				"type": "OTHER"
			},
			{
				"name": "bloodshed",
				"salience": 0.0016245845,
				"type": "OTHER"
			},
			{
				"name": "sentiments",
				"salience": 0.0016245845,
				"type": "OTHER"
			},
			{
				"name": "punishment",
				"salience": 0.0016245845,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0015497371,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0015497371,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0015497371,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0015497371,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0015485006,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0015144608,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rest",
				"salience": 0.0014799869,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0014400183,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.0014068036,
				"type": "PERSON"
			},
			{
				"name": "root causes",
				"salience": 0.0014068036,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0014068036,
				"type": "OTHER"
			},
			{
				"name": "wins",
				"salience": 0.0014068036,
				"type": "EVENT"
			},
			{
				"name": "ballot",
				"salience": 0.0014068036,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0014068036,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0014068036,
				"type": "OTHER"
			},
			{
				"name": "bridge",
				"salience": 0.0014068036,
				"type": "LOCATION"
			},
			{
				"name": "hysteria",
				"salience": 0.0014068036,
				"type": "OTHER"
			},
			{
				"name": "domination",
				"salience": 0.0014068036,
				"type": "OTHER"
			},
			{
				"name": "signing",
				"salience": 0.0014068036,
				"type": "EVENT"
			},
			{
				"name": "dose",
				"salience": 0.0014068036,
				"type": "OTHER"
			},
			{
				"name": "War",
				"salience": 0.0013480034,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0013388824,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0012913932,
				"type": "LOCATION"
			},
			{
				"name": "Peace",
				"salience": 0.0012590239,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0012508503,
				"type": "OTHER"
			},
			{
				"name": "sentencing members",
				"salience": 0.0012469644,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0011967607,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0011967607,
				"type": "OTHER"
			},
			{
				"name": "peasants",
				"salience": 0.001165271,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0010940399,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0010940399,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.0010866185,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0010866185,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0010866185,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.0010765136,
				"type": "LOCATION"
			},
			{
				"name": "peace agreements",
				"salience": 0.0010607578,
				"type": "OTHER"
			},
			{
				"name": "peace agreement",
				"salience": 0.0010607578,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0010460581,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0010460581,
				"type": "EVENT"
			},
			{
				"name": "interests",
				"salience": 0.0010254616,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0010254616,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0010117153,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0010096721,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0010000055,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0009924702,
				"type": "LOCATION"
			},
			{
				"name": "NO vote",
				"salience": 0.000984361,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0009770005,
				"type": "OTHER"
			},
			{
				"name": "Peace",
				"salience": 0.0009770005,
				"type": "OTHER"
			},
			{
				"name": "Peace",
				"salience": 0.0009770005,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0009770005,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0009770005,
				"type": "OTHER"
			},
			{
				"name": "Interests",
				"salience": 0.0009624608,
				"type": "OTHER"
			},
			{
				"name": "peace accords",
				"salience": 0.0009473484,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0009473484,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0009473484,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0009473484,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.0009473484,
				"type": "ORGANIZATION"
			},
			{
				"name": "platform",
				"salience": 0.00093759305,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0009356749,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.0009356749,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qmd2b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afro-Colombian"
				},
				"name": "Afro-Colombians",
				"salience": 0.0009176905,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.00091699976,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0009129037,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00090816716,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.000903479,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.000903479,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00088707503,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00088707503,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.00085535465,
				"type": "OTHER"
			},
			{
				"name": "prison terms",
				"salience": 0.00085535465,
				"type": "OTHER"
			},
			{
				"name": "proposals",
				"salience": 0.00085535465,
				"type": "OTHER"
			},
			{
				"name": "military control",
				"salience": 0.00085535465,
				"type": "OTHER"
			},
			{
				"name": "LGBT rights",
				"salience": 0.00085535465,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0008523921,
				"type": "PERSON"
			},
			{
				"name": "gains",
				"salience": 0.0008364624,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.00082962745,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0008277019,
				"type": "PERSON"
			},
			{
				"name": "counterinsurgency",
				"salience": 0.0008102093,
				"type": "OTHER"
			},
			{
				"name": "Analysts",
				"salience": 0.00080173236,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.00080173236,
				"type": "PERSON"
			},
			{
				"name": "peasant",
				"salience": 0.00080173236,
				"type": "PERSON"
			},
			{
				"name": "writers",
				"salience": 0.0007899382,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0007799628,
				"type": "LOCATION"
			},
			{
				"name": "counterinsurgency",
				"salience": 0.0007799628,
				"type": "OTHER"
			},
			{
				"name": "counterinsurgency",
				"salience": 0.0007799628,
				"type": "OTHER"
			},
			{
				"name": "NO vote",
				"salience": 0.0007735893,
				"type": "OTHER"
			},
			{
				"name": "NO vote",
				"salience": 0.00076384033,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00076384033,
				"type": "EVENT"
			},
			{
				"name": "NO vote",
				"salience": 0.00076384033,
				"type": "OTHER"
			},
			{
				"name": "peace agreement",
				"salience": 0.00074371306,
				"type": "OTHER"
			},
			{
				"name": "peace agreement",
				"salience": 0.00074371306,
				"type": "OTHER"
			},
			{
				"name": "gender justice",
				"salience": 0.0007406555,
				"type": "OTHER"
			},
			{
				"name": "promoters",
				"salience": 0.0007406555,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0007406555,
				"type": "LOCATION"
			},
			{
				"name": "guerrillas",
				"salience": 0.0007406555,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0007384153,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0007384153,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.0007384153,
				"type": "ORGANIZATION"
			},
			{
				"name": "policies",
				"salience": 0.0007384153,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00073817594,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.0007189628,
				"type": "ORGANIZATION"
			},
			{
				"name": "press interview",
				"salience": 0.0007189628,
				"type": "EVENT"
			},
			{
				"name": "agreement",
				"salience": 0.0007159481,
				"type": "OTHER"
			},
			{
				"name": "Plan",
				"salience": 0.0007159481,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0007137234,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0006921215,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0006921215,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0006921215,
				"type": "ORGANIZATION"
			},
			{
				"name": "conflict",
				"salience": 0.0006921215,
				"type": "EVENT"
			},
			{
				"name": "lands",
				"salience": 0.0006859063,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.00067266694,
				"type": "ORGANIZATION"
			},
			{
				"name": "victims",
				"salience": 0.0006687267,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0006687267,
				"type": "PERSON"
			},
			{
				"name": "lands",
				"salience": 0.0006687267,
				"type": "LOCATION"
			},
			{
				"name": "crimes",
				"salience": 0.0006687267,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0006687267,
				"type": "EVENT"
			},
			{
				"name": "interests",
				"salience": 0.000666282,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00066418946,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.00066418946,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00066418946,
				"type": "PERSON"
			},
			{
				"name": "security",
				"salience": 0.00066418946,
				"type": "OTHER"
			},
			{
				"name": "counterinsurgency war",
				"salience": 0.00066264335,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00066264335,
				"type": "EVENT"
			},
			{
				"name": "War",
				"salience": 0.00066264335,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00066264335,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00066264335,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00066264335,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0006555656,
				"type": "ORGANIZATION"
			},
			{
				"name": "security",
				"salience": 0.00063939247,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00063939247,
				"type": "OTHER"
			},
			{
				"name": "security forces",
				"salience": 0.00063939247,
				"type": "ORGANIZATION"
			},
			{
				"name": "commitment",
				"salience": 0.0006334285,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0006334285,
				"type": "ORGANIZATION"
			},
			{
				"name": "accords",
				"salience": 0.00061153347,
				"type": "OTHER"
			},
			{
				"name": "testing ground",
				"salience": 0.0006097797,
				"type": "OTHER"
			},
			{
				"name": "units",
				"salience": 0.0006073389,
				"type": "LOCATION"
			},
			{
				"name": "continuation",
				"salience": 0.00059968454,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.00059968454,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.00059968454,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00059968454,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.00059658836,
				"type": "OTHER"
			},
			{
				"name": "ignorance",
				"salience": 0.0005939231,
				"type": "OTHER"
			},
			{
				"name": "proposals",
				"salience": 0.00059212657,
				"type": "OTHER"
			},
			{
				"name": "Bernard Aronson",
				"salience": 0.00058770203,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00058733136,
				"type": "EVENT"
			},
			{
				"name": "military presence",
				"salience": 0.00058728753,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00058691594,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00058691594,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.0005820518,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.00058164523,
				"type": "OTHER"
			},
			{
				"name": "monkey wrench",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "wish list",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "sectors",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.00057904667,
				"type": "EVENT"
			},
			{
				"name": "reparations",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.00057904667,
				"type": "PERSON"
			},
			{
				"name": "prospect",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "ruins",
				"salience": 0.00057904667,
				"type": "LOCATION"
			},
			{
				"name": "channel",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.00057904667,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "longevity",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "limelight",
				"salience": 0.00057904667,
				"type": "OTHER"
			},
			{
				"name": "Grassroots organizations",
				"salience": 0.0005778771,
				"type": "ORGANIZATION"
			},
			{
				"name": "contracts",
				"salience": 0.00057729514,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00057729514,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00057729514,
				"type": "LOCATION"
			},
			{
				"name": "protest vote",
				"salience": 0.00057057885,
				"type": "OTHER"
			},
			{
				"name": "accords",
				"salience": 0.00057041773,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0005653609,
				"type": "OTHER"
			},
			{
				"name": "peasants",
				"salience": 0.000562086,
				"type": "PERSON"
			},
			{
				"name": "peace talks",
				"salience": 0.000562086,
				"type": "EVENT"
			},
			{
				"name": "peace talks",
				"salience": 0.000562086,
				"type": "EVENT"
			},
			{
				"name": "interest",
				"salience": 0.00055788213,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0005421999,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0005421999,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0005421999,
				"type": "PERSON"
			},
			{
				"name": "peace process",
				"salience": 0.0005421999,
				"type": "OTHER"
			},
			{
				"name": "peace talks",
				"salience": 0.0005411,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.0005411,
				"type": "PERSON"
			},
			{
				"name": "shots",
				"salience": 0.0005366155,
				"type": "WORK_OF_ART"
			},
			{
				"name": "peace",
				"salience": 0.00053151225,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00053151225,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00053151225,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00053151225,
				"type": "OTHER"
			},
			{
				"name": "arguments",
				"salience": 0.00051926123,
				"type": "OTHER"
			},
			{
				"name": "dialogue",
				"salience": 0.00051926123,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.00051708735,
				"type": "OTHER"
			},
			{
				"name": "peace accords",
				"salience": 0.00051537756,
				"type": "OTHER"
			},
			{
				"name": "tools",
				"salience": 0.00051006937,
				"type": "OTHER"
			},
			{
				"name": "military-industrial complex",
				"salience": 0.0004998737,
				"type": "OTHER"
			},
			{
				"name": "defense companies",
				"salience": 0.0004998737,
				"type": "ORGANIZATION"
			},
			{
				"name": "most",
				"salience": 0.0004998737,
				"type": "OTHER"
			},
			{
				"name": "parts",
				"salience": 0.0004998737,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0004998737,
				"type": "LOCATION"
			},
			{
				"name": "levels",
				"salience": 0.0004972928,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.000494058,
				"type": "LOCATION"
			},
			{
				"name": "possibility",
				"salience": 0.0004932286,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0004900331,
				"type": "OTHER"
			},
			{
				"name": "units",
				"salience": 0.00048953964,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00047451654,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.00046882834,
				"type": "PERSON"
			},
			{
				"name": "uncertainty",
				"salience": 0.00046882834,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00046882834,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.00046882834,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.00046882834,
				"type": "EVENT"
			},
			{
				"name": "democracy",
				"salience": 0.00046882834,
				"type": "OTHER"
			},
			{
				"name": "setback",
				"salience": 0.00046882834,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.00046882834,
				"type": "OTHER"
			},
			{
				"name": "violator",
				"salience": 0.00046882834,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.00046773689,
				"type": "OTHER"
			},
			{
				"name": "Plan",
				"salience": 0.00045350366,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "development projects",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "latest",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "budgets",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "lobbying industries",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "intelligence equipment",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "equipment",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "Fear",
				"salience": 0.00045132346,
				"type": "OTHER"
			},
			{
				"name": "intervention",
				"salience": 0.0004384094,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0004384094,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.0004384094,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.00043253088,
				"type": "WORK_OF_ART"
			},
			{
				"name": "war economy",
				"salience": 0.00042707915,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00042388483,
				"type": "LOCATION"
			},
			{
				"name": "logic",
				"salience": 0.00042388483,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.00042388483,
				"type": "OTHER"
			},
			{
				"name": "guerrillas",
				"salience": 0.00042388483,
				"type": "PERSON"
			},
			{
				"name": "solution",
				"salience": 0.00042388483,
				"type": "OTHER"
			},
			{
				"name": "solutions",
				"salience": 0.00042388483,
				"type": "OTHER"
			},
			{
				"name": "loved ones",
				"salience": 0.00042169617,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.000416381,
				"type": "ORGANIZATION"
			},
			{
				"name": "NO vote",
				"salience": 0.00041552895,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.00041552895,
				"type": "OTHER"
			},
			{
				"name": "Perks of Permanent War",
				"salience": 0.0004149518,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.0004080577,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "relief",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "guarantees",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "absence",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00040595073,
				"type": "LOCATION"
			},
			{
				"name": "senses",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "mixture",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "exporter",
				"salience": 0.00040595073,
				"type": "PERSON"
			},
			{
				"name": "reputation",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.00040595073,
				"type": "LOCATION"
			},
			{
				"name": "stake",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "regret",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "settlement",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00040595073,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00040500562,
				"type": "OTHER"
			},
			{
				"name": "peace process",
				"salience": 0.00040500562,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0003970218,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0003970218,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0003970218,
				"type": "OTHER"
			},
			{
				"name": "paramilitaries",
				"salience": 0.0003957817,
				"type": "ORGANIZATION"
			},
			{
				"name": "military funding",
				"salience": 0.0003940592,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0003907931,
				"type": "ORGANIZATION"
			},
			{
				"name": "incursions",
				"salience": 0.0003907931,
				"type": "EVENT"
			},
			{
				"name": "resources",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.0003907931,
				"type": "EVENT"
			},
			{
				"name": "No one",
				"salience": 0.0003907931,
				"type": "PERSON"
			},
			{
				"name": "soil",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "war machine",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "repression",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "authoritarianism",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "espionage",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "warfare",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "techniques",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "strike capacity",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "pretext",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "Billions",
				"salience": 0.0003907931,
				"type": "PERSON"
			},
			{
				"name": "proxy",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0003907931,
				"type": "PERSON"
			},
			{
				"name": "investments",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "pockets",
				"salience": 0.0003907931,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.00038624622,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.00038624622,
				"type": "LOCATION"
			},
			{
				"name": "lesson",
				"salience": 0.00038586737,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.00038271365,
				"type": "EVENT"
			},
			{
				"name": "background",
				"salience": 0.00038271365,
				"type": "OTHER"
			},
			{
				"name": "impunity",
				"salience": 0.00038271365,
				"type": "OTHER"
			},
			{
				"name": "hostilities",
				"salience": 0.00038271365,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.00038271365,
				"type": "PERSON"
			},
			{
				"name": "drug trafficking",
				"salience": 0.00038271365,
				"type": "OTHER"
			},
			{
				"name": "impunity",
				"salience": 0.00038271365,
				"type": "OTHER"
			},
			{
				"name": "annihilation",
				"salience": 0.00038271365,
				"type": "OTHER"
			},
			{
				"name": "uncertainty",
				"salience": 0.00038271365,
				"type": "OTHER"
			},
			{
				"name": "incarnations",
				"salience": 0.00038100372,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00038011666,
				"type": "OTHER"
			},
			{
				"name": "War propaganda",
				"salience": 0.00036566783,
				"type": "OTHER"
			},
			{
				"name": "factors",
				"salience": 0.00036566783,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.00036566783,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.00036566783,
				"type": "PERSON"
			},
			{
				"name": "drugs",
				"salience": 0.00036566783,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "war",
				"salience": 0.00036046995,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.00035979843,
				"type": "LOCATION"
			},
			{
				"name": "Tribunal for Transitional Justice",
				"salience": 0.00035636208,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06nm1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spanish_language"
				},
				"name": "Spanish",
				"salience": 0.00035636208,
				"type": "LOCATION"
			},
			{
				"name": "example",
				"salience": 0.00035308223,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.00035308223,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0003457823,
				"type": "OTHER"
			},
			{
				"name": "military bases",
				"salience": 0.00034423734,
				"type": "OTHER"
			},
			{
				"name": "security funding",
				"salience": 0.0003427391,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0003427391,
				"type": "OTHER"
			},
			{
				"name": "recipient",
				"salience": 0.0003398983,
				"type": "PERSON"
			},
			{
				"name": "military theorists",
				"salience": 0.0003398983,
				"type": "PERSON"
			},
			{
				"name": "sides",
				"salience": 0.00033735594,
				"type": "OTHER"
			},
			{
				"name": "Laura Carlsen",
				"salience": 0.00033633763,
				"type": "PERSON"
			},
			{
				"name": "capital",
				"salience": 0.00033138364,
				"type": "LOCATION"
			},
			{
				"name": "crisis",
				"salience": 0.00033138364,
				"type": "EVENT"
			},
			{
				"name": "incentives",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "dissidents",
				"salience": 0.00033138364,
				"type": "PERSON"
			},
			{
				"name": "truce",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "military alliance",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "juncture",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "negotiating table",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "prevention",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "military operations",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "search",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "differences",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "provocation",
				"salience": 0.00033138364,
				"type": "EVENT"
			},
			{
				"name": "diplomacy",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.00033138364,
				"type": "EVENT"
			},
			{
				"name": "military debilitation",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "fallacy",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "clash",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "perspectives",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "risks",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "correlation",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00033138364,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00032653703,
				"type": "EVENT"
			},
			{
				"name": "militarism",
				"salience": 0.00031926998,
				"type": "OTHER"
			},
			{
				"name": "militarization",
				"salience": 0.00031926998,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0003166237,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0003166237,
				"type": "LOCATION"
			},
			{
				"name": "sides",
				"salience": 0.0003166237,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0003136178,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00031038187,
				"type": "PERSON"
			},
			{
				"name": "Voters",
				"salience": 0.00031038187,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.00030458797,
				"type": "OTHER"
			},
			{
				"name": "Part",
				"salience": 0.00029716533,
				"type": "OTHER"
			},
			{
				"name": "peace process",
				"salience": 0.00029494255,
				"type": "OTHER"
			},
			{
				"name": "accords",
				"salience": 0.00029494255,
				"type": "OTHER"
			},
			{
				"name": "messages",
				"salience": 0.00029001312,
				"type": "OTHER"
			},
			{
				"name": "departments",
				"salience": 0.00028586917,
				"type": "ORGANIZATION"
			},
			{
				"name": "hostilities",
				"salience": 0.00028586917,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00028586917,
				"type": "PERSON"
			},
			{
				"name": "war industry",
				"salience": 0.00028586917,
				"type": "OTHER"
			},
			{
				"name": "obstacle",
				"salience": 0.00028586917,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00028586917,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.00028586917,
				"type": "OTHER"
			},
			{
				"name": "punishment",
				"salience": 0.00028586917,
				"type": "OTHER"
			},
			{
				"name": "setback",
				"salience": 0.00028586917,
				"type": "OTHER"
			},
			{
				"name": "obstacles",
				"salience": 0.00028586917,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0002848713,
				"type": "PERSON"
			},
			{
				"name": "drug trafficking",
				"salience": 0.0002822658,
				"type": "OTHER"
			},
			{
				"name": "Society",
				"salience": 0.0002822658,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0002812805,
				"type": "PERSON"
			},
			{
				"name": "LGBT community",
				"salience": 0.0002812805,
				"type": "OTHER"
			},
			{
				"name": "arguments",
				"salience": 0.00027538708,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00027396504,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00026875187,
				"type": "LOCATION"
			},
			{
				"name": "dialogue",
				"salience": 0.00026848825,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00026629373,
				"type": "LOCATION"
			},
			{
				"name": "drugs",
				"salience": 0.00026629373,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "terms",
				"salience": 0.00026629373,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.00026629373,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00026293707,
				"type": "LOCATION"
			},
			{
				"name": "NO",
				"salience": 0.00026176998,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00025443255,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00025443255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/031d6r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army_War_College"
				},
				"name": "US Army War College",
				"salience": 0.000249826,
				"type": "ORGANIZATION"
			},
			{
				"name": "human rights defenders",
				"salience": 0.0002495954,
				"type": "PERSON"
			},
			{
				"name": "peasants",
				"salience": 0.0002495954,
				"type": "PERSON"
			},
			{
				"name": "defense",
				"salience": 0.0002495954,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0002495954,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0002495954,
				"type": "OTHER"
			},
			{
				"name": "homicides",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "exceptions",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "culprit",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.00024752656,
				"type": "LOCATION"
			},
			{
				"name": "enormity",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "houses",
				"salience": 0.00024752656,
				"type": "LOCATION"
			},
			{
				"name": "bombs",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "limb",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "minefields",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "crossfire",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "battlefields",
				"salience": 0.00024752656,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "games",
				"salience": 0.00024752656,
				"type": "EVENT"
			},
			{
				"name": "problems",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "grievances",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "increases",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00024752656,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.00024668945,
				"type": "OTHER"
			},
			{
				"name": "peace agreement",
				"salience": 0.00024668945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0002404972,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egypt",
				"salience": 0.0002404972,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0002404972,
				"type": "ORGANIZATION"
			},
			{
				"name": "militarization",
				"salience": 0.00023847792,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02p0hk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norte_de_Santander_Department"
				},
				"name": "Norte de Santander",
				"salience": 0.00023769881,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04pnx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latin_America"
				},
				"name": "Latin America",
				"salience": 0.0002355247,
				"type": "LOCATION"
			},
			{
				"name": "room",
				"salience": 0.00023231417,
				"type": "LOCATION"
			},
			{
				"name": "guerrillas",
				"salience": 0.00023057642,
				"type": "PERSON"
			},
			{
				"name": "grassroots dialogue",
				"salience": 0.00023057642,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.00023057642,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.00023057642,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0002297182,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0002236392,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00022030598,
				"type": "PERSON"
			},
			{
				"name": "consolation prize",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"name": "peace implementation",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"name": "backlog",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0002081791,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.0002081791,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0002081791,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0002081791,
				"type": "PERSON"
			},
			{
				"name": "return",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"name": "military annihilation",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0002081791,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00020393395,
				"type": "ORGANIZATION"
			},
			{
				"name": "Engenders",
				"salience": 0.00020393395,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.00020310568,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.00020205685,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00020205685,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.0001989062,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.0001989062,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Road to Peace Understanding",
				"salience": 0.00019631865,
				"type": "LOCATION"
			},
			{
				"name": "hope",
				"salience": 0.0001920597,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.00018822012,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.00018643314,
				"type": "EVENT"
			},
			{
				"name": "negotiations",
				"salience": 0.00018643314,
				"type": "EVENT"
			},
			{
				"name": "mentality",
				"salience": 0.00018643314,
				"type": "OTHER"
			},
			{
				"name": "negotiators",
				"salience": 0.00018643314,
				"type": "PERSON"
			},
			{
				"name": "track",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "marches",
				"salience": 0.00018025588,
				"type": "EVENT"
			},
			{
				"name": "call",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.00018025588,
				"type": "LOCATION"
			},
			{
				"name": "structures",
				"salience": 0.00018025588,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "uprising",
				"salience": 0.00018025588,
				"type": "EVENT"
			},
			{
				"name": "horizon",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "hawks",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "demands",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "vision",
				"salience": 0.00018025588,
				"type": "OTHER"
			},
			{
				"name": "NO voters",
				"salience": 0.00017988698,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.00017352469,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00017352469,
				"type": "OTHER"
			},
			{
				"name": "complacency",
				"salience": 0.00017222666,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.00017222666,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.00017222666,
				"type": "PERSON"
			},
			{
				"name": "promoters",
				"salience": 0.00017222666,
				"type": "PERSON"
			},
			{
				"name": "dictatorship",
				"salience": 0.00017222666,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0001699368,
				"type": "OTHER"
			},
			{
				"name": "Foreign Policy In Focus",
				"salience": 0.00016871837,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.00016359093,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.00015549682,
				"type": "PERSON"
			},
			{
				"name": "scenarios",
				"salience": 0.00015549682,
				"type": "OTHER"
			},
			{
				"name": "implications",
				"salience": 0.00015549682,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00015238812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02p06n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arauca_Department"
				},
				"name": "Arauca",
				"salience": 0.00015232587,
				"type": "LOCATION"
			},
			{
				"name": "debacle",
				"salience": 0.00015092376,
				"type": "OTHER"
			},
			{
				"name": "failing",
				"salience": 0.00014345635,
				"type": "EVENT"
			},
			{
				"name": "Center for International Policy's Americas Project",
				"salience": 0.00014189446,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05dxpf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_security"
				},
				"name": "Democratic Security",
				"salience": 0.00013557388,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0001352438,
				"type": "EVENT"
			},
			{
				"name": "NO celebration",
				"salience": 0.00013463946,
				"type": "EVENT"
			},
			{
				"name": "crowd",
				"salience": 0.00013463946,
				"type": "PERSON"
			},
			{
				"name": "reconciliation",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "takeover",
				"salience": 0.00013463946,
				"type": "EVENT"
			},
			{
				"name": "SI",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "opening",
				"salience": 0.00013463946,
				"type": "EVENT"
			},
			{
				"name": "dismay",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "mediators",
				"salience": 0.00013463946,
				"type": "PERSON"
			},
			{
				"name": "acceptance",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "scaremongering",
				"salience": 0.00013463946,
				"type": "EVENT"
			},
			{
				"name": "scores",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "liking",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.00013463946,
				"type": "PERSON"
			},
			{
				"name": "misreading",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.00013463946,
				"type": "EVENT"
			},
			{
				"name": "latter",
				"salience": 0.00013463946,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.00013463946,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05f3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Peace_Prize"
				},
				"name": "Nobel Peace Prize",
				"salience": 0.00012811084,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00011762853,
				"type": "EVENT"
			},
			{
				"name": "footage",
				"salience": 0.000112729875,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01dzyc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bogot%C3%A1"
				},
				"name": "Bogota",
				"salience": 0.00011092668,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01pssf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cali"
				},
				"name": "Cali",
				"salience": 0.00011092668,
				"type": "LOCATION"
			},
			{
				"name": "Plan B",
				"salience": 0.00010543815,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chavez-Castro",
				"salience": 0.000082854356,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d04z6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuba"
				},
				"name": "Cuban",
				"salience": 0.000082854356,
				"type": "LOCATION"
			},
			{
				"name": "role",
				"salience": 0.00006289215,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:14:56.373+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 41.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nIn early October, the Colombian people voted NO to peace. \nOr to be exact, 50.2 percent of 37 percent of the eligible population voted no. In the referendum held on October 2, the majority of voters decided to scuttle the agreement between the government and FARC rebels, which had been reached after four years of peace talks dedicated to ending 52 years of bloodshed. \nThe vote came just days after the celebratory signing of the agreement, which was lauded in the international community for achieving a bridge between historic enemies and dealing broadly with the root causes of the conflict. The rest of the world was stunned. \nMost pundits have begun the post-mortem analysis of the referendum by saying something like “Colombians did not vote against peace.” They go on to discuss other factors, including people’s ignorance of the accords, or their mistaken belief that after four years it could simply be renegotiated. \nBut the fact of the matter is that the NO voters voted clearly and unambiguously to continue the war. The words on the ballot read: “Do you accept the final agreement to terminate the conflict and build a stable and lasting peace?” It’s almost inconceivable that any population would vote no on this proposition, but they did. \nSo why did they? \nAlthough even former president Alvaro Uribe, the nation’s leading warmonger, now makes the politically correct statement that the ultimate goal is peace, the macho sentiments of total domination and punishment (of one side), along with a strong dose of Cold War hysteria (yes, in the 21 st century) won the day. \nThe NO promoters knew what they were doing. They were not promoting an alternative peace. As a 32-year old NO voter quoted in the New York Times put it, “If ‘no’ wins, we won’t have peace, but at least we won’t give the country away to the guerrillas.” \nHis statement reflects the patriarchal logic that has started and perpetuated wars since time immemorial – the only good enemy is a dead enemy, and if I don’t win, nobody wins. \nAt least some NO voters and many of the leaders are betting on continuing war until they gain by force their entire military and political agenda – a prospect that, given the war’s longevity to date could easily be another half century. Or never. \nThe Perks of Permanent War \nFor many NO promoters, including Uribe himself, “never” could be the best-case scenario. Basking in the limelight of a political career rebuilt on the ruins of one the most complex and progressive peace agreements in history, Uribe released proposals for revamping the peace agreement designed to throw a monkey wrench into any process to salvage peace in Colombia. \nAnalysts quoted on CNN’s Spanish channel observed that Uribe’s wish list is aimed at “torpedoing the peace accords.” That’s correct: No one expects the FARC to accept Uribe’s terms, which include banning the group from politics, sentencing members to 5-8 year prison terms for crimes including drug trafficking, pardoning Colombia’s security forces for their own serious crimes, and eliminating the meticulously negotiated Tribunal for Transitional Justice. \nHuge sectors of the population reject Uribe’s terms as well, since his proposals would also wipe out the parts of the peace accord that regulate the return of stolen lands to peasant and indigenous communities and seriously hamper, if not strike altogether, plans for reparations to victims. They also could rollback meticulously negotiated gains in gender justice and LGBT rights. \nTo pretend that everyone wants peace and the only issue is how to get it is to ignore the fact that the war benefits many powerful interests. Those interests will fight to keep fighting. \nOn the political front, war assures military control over a population and justifies authoritarianism and repression through fear. In general, the most militarized parts of the country are areas where peasants, Afro-Colombians, and indigenous peoples are defending their lands and resources from the incursions of transnational corporations and mega development projects. Fear and murder are powerful repressive tools. \nWar is also a huge business. Thanks to U.S. Plan Colombia and policies that fanned the conflict, Colombia became the third largest recipient of US aid in the world during the war, behind only Israel and Egypt. Colombia’s budget for security forces skyrocketed ; between 2001 and 2005, it grew more than 30 percent, and by 2006 it was double its 1990 levels – some $4.48 billion for military and police. \nUS Interests \nThe US military-industrial complex also has a vested interest in continuing the war. The conflict justified Plan Colombia, the $10 billion dollar counterinsurgency and counternarcotics plan that allowed the Pentagon to establish a military presence in Colombia, both physically and by proxy. With the pretext of Colombia’s internal conflict, the US government built up a platform not only for control in Colombia, but also for regional strike capacity, as leaked in the proposed agreement to establish seven US military bases. \nPlan Colombia and its later incarnations kept US contracts for weapons, espionage, intelligence equipment, and military and police training flowing to the most powerful lobbying industries in the nation. Billions of dollars have been poured into Plan Colombia and national security investments that ended up in the pockets of political elites and US defense companies. In the budgets for fiscal years 2010-2017, the United States allocated over $2 billion in military and police aid – most of that during the peace talks. \nIn the process, Colombia was converted into a testing ground for the latest in counterinsurgency and unconventional warfare techniques and equipment from the United States. The blood spilled on its soil feeds the global war machine, to such an extent that Colombia has been groomed as an exporter of counterinsurgency and “security” training, despite its reputation as a gross violator of human rights and the disastrous humanitarian impact of its prolonged war. Colombian forces now work throughout the region to promote the same counternarcotics-counterinsurgency model that left more than 5 million people displaced and untold thousands of innocent peasants executed by security forces. \nSo very powerful interests saw the peace agreement as a threat. In addition to Uribe followers who viewed it as soft on the FARC, the war economy of the nation and its ally, the United States, was at stake. \nIn this context, the US government reacted tepidly when peace was voted down. Bernard Aronson, the special envoy to the peace talks, expressed no regret in a press interview after the vote, stating, “We believe Colombians want peace, but clearly they are divided about terms of settlement.” The State Department limited its statement to support for Colombian democracy and further dialogue. After four years of ostensibly supporting the peace talks, neither mentioned the vote as a setback. \nAn analysis published by the US Army War College, although it is not an official document, openly expresses relief at the continuation of indefinite war in Colombia. Through a mixture of hawkish arguments and lies , the analysis recognizes that the country now enters into a “period of uncertainty,” but notes that this “presents a strategic situation less grave and more manageable, than had the accords been approved.” \nIt goes on to predict that the FARC will likely break the ceasefire, despite the group’s explicit and public commitment to respect it even in the absence of the guarantees provided in the peace agreement. This position – coming from sources close to the US military, which has in many senses called the shots in Colombia’s war since Plan Colombia began in 2000 – indicates that there is a dangerous possibility of a provocation to further undermine the peace process that has now been thrown into crisis by the NO vote. \nThe writers also advise President Juan Santos, who staked his political capital on supporting the deal, to retract his commitment to the ceasefire following the vote. They note that Santos promised to “not authorize military operations in the areas where FARC units are located in order to avoid an incident which breaks the fragile truce. Yet not doing so will allow FARC dissidents to operate with almost complete impunity in these areas. Indeed, within the new background of uncertainty, such impunity will increase incentives for FARC units to continue illicit activity, such as drug trafficking, since doing so will pose relatively low risks.” \nWar Engenders More War, Not Peace \nBefore the NO vote, the US press hailed Plan Colombia for making peace possible. President Obama, in his self-congratulatory last speech to the UN, proclaimed that we “helped Colombia end Latin America’s longest war.” The logic of this bizarre argument went that were it not for the military debilitation of the guerrillas thanks to the U.S.-Colombian military alliance, the FARC could never have been brought to the negotiating table. \nThe NO vote is the classic example of the fallacy of that logic. The war fomented by Plan Colombia built up a mentality that made peace an unacceptable solution for many. It revealed the fundamental clash of perspectives between diplomacy and annihilation. \nThe lesson couldn’t be clearer: War is a terrible preparation for peace. Peace depends on much more than a favorable correlation of forces. Peace, at its core, is a rejection of force as the way to confront differences, and a search for nonviolent solutions to conflict and conflict prevention. \nWith US military theorists openly calling for reopening hostilities, it is a dangerous myth to assume that at this juncture everyone wants peace and the only open question is how to do it. Plan Colombia, the U.S.-sponsored war on drugs, and Uribe’s “Democratic Security” policy all posit continued militarization. Those who promote peace and reconciliation in the country must deal with that mentality head on. To second-guess or justify NO voters with “they-know-not-what-they-do” arguments reflects the kind of complacency and misreading of the public that created this dangerous debacle in the first place. \nThere is no doubt that a massive campaign of misinformation and scaremongering played a role. Voters were bombarded with alarmist messages that spun out wild scenarios, from a legislative takeover by the former FARC to a “Chavez-Castro style dictatorship.” CNN’s footage of the NO celebration showed the crowd chanting “The NO won, now we won’t have a Cuban dictatorship.” It didn’t seem to matter that there was no logical relationship between voting for the peace agreement and the nation becoming a dictatorship. \nFor followers of Uribe, who led the massive campaign against the negotiations and the acceptance of the agreement, the vote was ideological and personal. It represented the right against the left, and Uribe against Santos. For many people stuck in bitter partisan politics, to vote for peace was to vote in favor of the latter. \nIt is also likely that many people did not have a clear understanding of the accords or their implications, which is a failing of the negotiators and SI (yes) promoters that left a fatal opening for NO propaganda. Some voters also apparently believed that four years of arduous negotiations with the technical support of scores of international experts and mediators could simply be reopened and “fixed” to their liking, though Santos made it clear there was “no Plan B.” Some NO voters quoted in the press even expressed dismay that they had won, believing they were merely casting a protest vote. \nDespite these factors, the NO vote reveals a major obstacle: Society has been trained over years of conflict – one of the longest-running internal conflicts in the world – to acquiesce to war as the only response, to dehumanize the enemy and overlook the obvious fact that it takes two sides to sustain hostilities. It’s created a society that believes the only solution is to drive the enemy into the ground – even when they are men and women from one’s own country and their grievances reflect serious social problems. \nThis is the patriarchal mentality that the war industry thrives on. Plan Colombia has fomented this mentality since it began. It conflated a war on drugs with a counterinsurgency war to justify foreign intervention and broaden the war. The US government knew that military funding was going directly to paramilitary groups. A 2010 empirical study demonstrated a measurable relationship between increases in US security funding and paramilitary homicides. War propaganda presented the FARC as the sole culprit, when terrible atrocities were being committed on both sides. \nWith the exceptions of Arauca and Norte de Santander, the departments on Colombia’s borders that have suffered most in the war voted to end it. They know what it’s like to feel their houses shaken by bombs, to risk life and limb walking through minefields, to lose their loved ones in crossfire. They know that to stop the violence in their day-to-day lives is far more important than the political games of how punishment and power are dished out. \nWar as a policy is almost always favored by those farthest from the battlefields. \nThe Road to Peace \nUnderstanding the very real and perilous obstacles is not the same as being pessimistic or defeatist at this point in the Colombian peace process – it’s a process, after all. It’s important not to minimize the enormity of this setback – President Santos’ Nobel Peace Prize may be deserved, but it’s a sorry consolation prize for having gotten so close only to be slapped down. But it’s also important to acknowledge that there is still room to move forward. \nThe peace accords opened up a dialogue and allowed the nation to envision peace. Grassroots organizations are mobilizing in defense of this vision and the possibility of a new reality. \nThis is the hope on the horizon. Since the NO vote, thousands have marched to support the peace process in Bogota, and also in Cali and cities across the country. The marches have awakened and united groups of indigenous peoples, Afro-Colombians, victims, students, human rights defenders, peasants, women, and the LGBT community in defense of peace. \nThe international community should openly and actively support the call for a broad grassroots dialogue for peace. It must continue to be firm and vigilant, because there will be a serious attempt to force a return to the model of military annihilation of the left-wing guerrillas while leaving right-wing paramilitaries and other militarist structures intact. \nInternational organizations committed millions of dollars to support peace implementation, and it must be clear that those funds will only be released when the process is back on track. Part of creating adequate conditions is to deny any new funding to militarism – including the war on drugs, which acts as a thinly veiled excuse for militarization. \nThe NO vote unexpectedly flipped the political situation back in favor of the right-wing hawks. This uprising could not only flip it back in favor of peace, but also create a social movement capable of going beyond the accords in terms of establishing social justice and human rights and addressing the enormous backlog of demands from below. \nForeign Policy In Focus columnist Laura Carlsen heads the Center for International Policy’s Americas Project. Reprinted with permission from Foreign Policy In Focus .",
		"thread_title": "Who Gains From Colombia’s Vote for Permanent War?",
		"title": "Who Gains From Colombia’s Vote for Permanent War?",
		"type": "bs",
		"uuid": "ffbb5414c0a32f23781e99569f8addcf190edeb0"
	},
	"-KhIjD9U1l16xwlus-vR": {
		"author": "Justin Raimondo",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T06:14:56.696+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.5010501,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.15938333,
				"type": "LOCATION"
			},
			{
				"name": "decision",
				"salience": 0.037246794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.01888987,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "F.B.I.",
				"salience": 0.016252687,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.015915437,
				"type": "PERSON"
			},
			{
				"name": "conspiracy theories",
				"salience": 0.012972288,
				"type": "OTHER"
			},
			{
				"name": "Clintonites",
				"salience": 0.012496229,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0gzz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Howard_Dean"
				},
				"name": "Howard Dean",
				"salience": 0.012486639,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0brrkx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Franklin_Foer"
				},
				"name": "Franklin Foer",
				"salience": 0.011705333,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/039tr9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Ryan_(politician)"
				},
				"name": "Tim Ryan",
				"salience": 0.011208275,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0204x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_Reid"
				},
				"name": "Harry Reid",
				"salience": 0.007223541,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.007102536,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01jgn3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Carville"
				},
				"name": "James Carville",
				"salience": 0.003856036,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.0035791155,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.003072558,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0029238232,
				"type": "LOCATION"
			},
			{
				"name": "investigation",
				"salience": 0.002661291,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0025884672,
				"type": "ORGANIZATION"
			},
			{
				"name": "clue",
				"salience": 0.002500563,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/037ppp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alfa-Bank"
				},
				"name": "Alfa Bank",
				"salience": 0.002428176,
				"type": "ORGANIZATION"
			},
			{
				"name": "revelations",
				"salience": 0.0024032637,
				"type": "OTHER"
			},
			{
				"name": "Cendyn",
				"salience": 0.0023148262,
				"type": "ORGANIZATION"
			},
			{
				"name": "response",
				"salience": 0.0020814307,
				"type": "OTHER"
			},
			{
				"name": "Share",
				"salience": 0.0020814307,
				"type": "OTHER"
			},
			{
				"name": "Politics",
				"salience": 0.0020814307,
				"type": "OTHER"
			},
			{
				"name": "mishandling",
				"salience": 0.0020814307,
				"type": "EVENT"
			},
			{
				"name": "sources",
				"salience": 0.0020814307,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0020372586,
				"type": "PERSON"
			},
			{
				"name": "explanation",
				"salience": 0.0019594273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ncdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Trump_Organization"
				},
				"name": "Trump Organization",
				"salience": 0.0018737965,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0clb0v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Greenwald"
				},
				"name": "Glenn Greenwald",
				"salience": 0.0018625176,
				"type": "PERSON"
			},
			{
				"name": "Cendyn",
				"salience": 0.0017984513,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0017613061,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Dean scream",
				"salience": 0.0016690475,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.001644707,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0015822211,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gs7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gertrude_Stein"
				},
				"name": "Gertrude Stein",
				"salience": 0.001463854,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.0014459164,
				"type": "ORGANIZATION"
			},
			{
				"name": "load",
				"salience": 0.0013613459,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001359976,
				"type": "LOCATION"
			},
			{
				"name": "Robert Graham",
				"salience": 0.0012925027,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0012816734,
				"type": "ORGANIZATION"
			},
			{
				"name": "Crazy",
				"salience": 0.0012816734,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.0012673293,
				"type": "PERSON"
			},
			{
				"name": "traffic",
				"salience": 0.0012469995,
				"type": "OTHER"
			},
			{
				"name": "hotels",
				"salience": 0.0012419303,
				"type": "LOCATION"
			},
			{
				"name": "marginality",
				"salience": 0.0012279922,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0012279922,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0012279922,
				"type": "ORGANIZATION"
			},
			{
				"name": "chart",
				"salience": 0.0011412646,
				"type": "OTHER"
			},
			{
				"name": "Agents",
				"salience": 0.0011125646,
				"type": "PERSON"
			},
			{
				"name": "liberals",
				"salience": 0.0010987079,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04b6p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KGB"
				},
				"name": "KGB",
				"salience": 0.0010675536,
				"type": "ORGANIZATION"
			},
			{
				"name": "bit",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "fever pitch",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "tandem",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "nickname",
				"salience": 0.0010634093,
				"type": "PERSON"
			},
			{
				"name": "league",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "mainstream",
				"salience": 0.0010634093,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0010182192,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.00092313124,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0008742254,
				"type": "PERSON"
			},
			{
				"name": "hysteria",
				"salience": 0.0008572471,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.00084096607,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0008123935,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0007817941,
				"type": "OTHER"
			},
			{
				"name": "conspiracy",
				"salience": 0.0007467339,
				"type": "OTHER"
			},
			{
				"name": "implication",
				"salience": 0.0007362591,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0455m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joseph_McCarthy"
				},
				"name": "Joe McCarthy",
				"salience": 0.00073225144,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.00071615266,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00071615266,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0006758105,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.00065460213,
				"type": "LOCATION"
			},
			{
				"name": "Congressman Moonbeam",
				"salience": 0.00065460213,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rya",
				"salience": 0.00065460213,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.00064661814,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00064661814,
				"type": "OTHER"
			},
			{
				"name": "security community",
				"salience": 0.00064661814,
				"type": "OTHER"
			},
			{
				"name": "communications",
				"salience": 0.00064661814,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00064373005,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lead",
				"salience": 0.00063625956,
				"type": "OTHER"
			},
			{
				"name": "thriller material",
				"salience": 0.00059985055,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ties",
				"salience": 0.00055991893,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00055991893,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.00055991893,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00055991893,
				"type": "PERSON"
			},
			{
				"name": "company",
				"salience": 0.00052445725,
				"type": "ORGANIZATION"
			},
			{
				"name": "explanation",
				"salience": 0.0005139715,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00050554756,
				"type": "OTHER"
			},
			{
				"name": "nonsense",
				"salience": 0.00050554756,
				"type": "OTHER"
			},
			{
				"name": "advisors",
				"salience": 0.00050554756,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00050554756,
				"type": "ORGANIZATION"
			},
			{
				"name": "Conspiracy",
				"salience": 0.00050401856,
				"type": "OTHER"
			},
			{
				"name": "communication link",
				"salience": 0.00050378335,
				"type": "OTHER"
			},
			{
				"name": "Clintonite",
				"salience": 0.0004935673,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.0004833734,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0004833734,
				"type": "WORK_OF_ART"
			},
			{
				"name": "payments",
				"salience": 0.00048136277,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00047886517,
				"type": "EVENT"
			},
			{
				"name": "links",
				"salience": 0.00047886517,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.00046641415,
				"type": "OTHER"
			},
			{
				"name": "editors",
				"salience": 0.00046547214,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.00046438462,
				"type": "PERSON"
			},
			{
				"name": "bank",
				"salience": 0.00046098843,
				"type": "ORGANIZATION"
			},
			{
				"name": "links",
				"salience": 0.00046098843,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00046098843,
				"type": "EVENT"
			},
			{
				"name": "link",
				"salience": 0.00046098843,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.00045897928,
				"type": "OTHER"
			},
			{
				"name": "servers",
				"salience": 0.00045897928,
				"type": "OTHER"
			},
			{
				"name": "former",
				"salience": 0.00045677312,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.00045473265,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theorist",
				"salience": 0.00045335726,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.00045335726,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.00045319519,
				"type": "OTHER"
			},
			{
				"name": "inside",
				"salience": 0.00044334366,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qry6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wolf_Blitzer"
				},
				"name": "Wolf Blitzer",
				"salience": 0.00044182217,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0004377565,
				"type": "PERSON"
			},
			{
				"name": "credibility",
				"salience": 0.0004377565,
				"type": "OTHER"
			},
			{
				"name": "fringes",
				"salience": 0.0004377565,
				"type": "EVENT"
			},
			{
				"name": "return",
				"salience": 0.0004377565,
				"type": "OTHER"
			},
			{
				"name": "coordination",
				"salience": 0.0004377565,
				"type": "OTHER"
			},
			{
				"name": "party spectrum",
				"salience": 0.0004377565,
				"type": "OTHER"
			},
			{
				"name": "cult",
				"salience": 0.0004377565,
				"type": "OTHER"
			},
			{
				"name": "version",
				"salience": 0.0004377565,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0004377565,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nomination",
				"salience": 0.0004377565,
				"type": "OTHER"
			},
			{
				"name": "contention",
				"salience": 0.0004377565,
				"type": "OTHER"
			},
			{
				"name": "email communication",
				"salience": 0.00043643246,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.00043643246,
				"type": "OTHER"
			},
			{
				"name": "computers",
				"salience": 0.00043643246,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "explanation",
				"salience": 0.0004303589,
				"type": "OTHER"
			},
			{
				"name": "IT consultant",
				"salience": 0.00042741094,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.00042493534,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.00042493534,
				"type": "PERSON"
			},
			{
				"name": "memo",
				"salience": 0.000418684,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00040990268,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00040990268,
				"type": "WORK_OF_ART"
			},
			{
				"name": "right",
				"salience": 0.00040750165,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00039552033,
				"type": "OTHER"
			},
			{
				"name": "opponents",
				"salience": 0.0003925624,
				"type": "OTHER"
			},
			{
				"name": "latest",
				"salience": 0.0003925624,
				"type": "OTHER"
			},
			{
				"name": "communication link",
				"salience": 0.00039091904,
				"type": "OTHER"
			},
			{
				"name": "hotels",
				"salience": 0.00039091904,
				"type": "LOCATION"
			},
			{
				"name": "bank",
				"salience": 0.00039091904,
				"type": "ORGANIZATION"
			},
			{
				"name": "hotels",
				"salience": 0.00039091904,
				"type": "LOCATION"
			},
			{
				"name": "traffic",
				"salience": 0.00039091904,
				"type": "OTHER"
			},
			{
				"name": "hotels",
				"salience": 0.00039091904,
				"type": "LOCATION"
			},
			{
				"name": "traffic",
				"salience": 0.00039091904,
				"type": "OTHER"
			},
			{
				"name": "traffic",
				"salience": 0.0003811278,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0003779065,
				"type": "EVENT"
			},
			{
				"name": "investigations",
				"salience": 0.0003779065,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.0003779065,
				"type": "PERSON"
			},
			{
				"name": "employees",
				"salience": 0.00037288308,
				"type": "PERSON"
			},
			{
				"name": "pattern",
				"salience": 0.00037288308,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0003700944,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_6j_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alex_Jones_(radio_host)"
				},
				"name": "Alex Jones",
				"salience": 0.0003611897,
				"type": "PERSON"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.00035627707,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00035443762,
				"type": "OTHER"
			},
			{
				"name": "nonsense",
				"salience": 0.00035443762,
				"type": "OTHER"
			},
			{
				"name": "screed",
				"salience": 0.00035443762,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00035443762,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.0003537231,
				"type": "ORGANIZATION"
			},
			{
				"name": "kind",
				"salience": 0.0003499706,
				"type": "OTHER"
			},
			{
				"name": "computer scientist",
				"salience": 0.0003484071,
				"type": "PERSON"
			},
			{
				"name": "Right",
				"salience": 0.00034120466,
				"type": "OTHER"
			},
			{
				"name": "advisers",
				"salience": 0.00034120466,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00034120466,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.00034120466,
				"type": "EVENT"
			},
			{
				"name": "The Life of Murray N. Rothbard",
				"salience": 0.00034041266,
				"type": "WORK_OF_ART"
			},
			{
				"name": "proof",
				"salience": 0.0003269982,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0003204621,
				"type": "WORK_OF_ART"
			},
			{
				"name": "entry",
				"salience": 0.00031880752,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.00031114524,
				"type": "PERSON"
			},
			{
				"name": "agent",
				"salience": 0.0003111271,
				"type": "PERSON"
			},
			{
				"name": "music",
				"salience": 0.0003069045,
				"type": "WORK_OF_ART"
			},
			{
				"name": "radar",
				"salience": 0.0003069045,
				"type": "OTHER"
			},
			{
				"name": "comic mix",
				"salience": 0.0003069045,
				"type": "OTHER"
			},
			{
				"name": "effusions",
				"salience": 0.0003069045,
				"type": "OTHER"
			},
			{
				"name": "band",
				"salience": 0.0003069045,
				"type": "OTHER"
			},
			{
				"name": "owner",
				"salience": 0.0003069045,
				"type": "PERSON"
			},
			{
				"name": "tales",
				"salience": 0.0003069045,
				"type": "OTHER"
			},
			{
				"name": "cue",
				"salience": 0.0003069045,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0003069045,
				"type": "PERSON"
			},
			{
				"name": "cooties",
				"salience": 0.0003069045,
				"type": "OTHER"
			},
			{
				"name": "fluids",
				"salience": 0.0003069045,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.00030619002,
				"type": "OTHER"
			},
			{
				"name": "hacking",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "rabbit holes",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "criminals",
				"salience": 0.00029544576,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.00029544576,
				"type": "PERSON"
			},
			{
				"name": "brain",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "channel",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "nothingness",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "connections",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "instigation",
				"salience": 0.00029544576,
				"type": "OTHER"
			},
			{
				"name": "trump-email.com",
				"salience": 0.00029366298,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.00029200842,
				"type": "ORGANIZATION"
			},
			{
				"name": "traffic pattern",
				"salience": 0.0002893379,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0002893379,
				"type": "OTHER"
			},
			{
				"name": "recipient list",
				"salience": 0.0002893379,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0002893379,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0002798804,
				"type": "OTHER"
			},
			{
				"name": "Timothy B. Lee",
				"salience": 0.0002765381,
				"type": "PERSON"
			},
			{
				"name": "scene",
				"salience": 0.00027379554,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.00026941672,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03w86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamism"
				},
				"name": "Islamist",
				"salience": 0.00026941672,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01pzt7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/People's_Mujahedin_of_Iran"
				},
				"name": "Mujahideen-e-Khalq",
				"salience": 0.00026941672,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_of_Representatives"
				},
				"name": "House",
				"salience": 0.00026941672,
				"type": "ORGANIZATION"
			},
			{
				"name": "Secret Link",
				"salience": 0.000259612,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00025911798,
				"type": "PERSON"
			},
			{
				"name": "publisher",
				"salience": 0.00025911798,
				"type": "ORGANIZATION"
			},
			{
				"name": "International Kremlin",
				"salience": 0.00025176012,
				"type": "ORGANIZATION"
			},
			{
				"name": "employees",
				"salience": 0.0002516578,
				"type": "PERSON"
			},
			{
				"name": "existence",
				"salience": 0.00025053343,
				"type": "OTHER"
			},
			{
				"name": "email marketing firm",
				"salience": 0.00025053343,
				"type": "ORGANIZATION"
			},
			{
				"name": "spite",
				"salience": 0.00025053343,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00025053343,
				"type": "OTHER"
			},
			{
				"name": "ads",
				"salience": 0.00025053343,
				"type": "WORK_OF_ART"
			},
			{
				"name": "razor",
				"salience": 0.00025053343,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00025053343,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00025053343,
				"type": "OTHER"
			},
			{
				"name": "real estate mogul",
				"salience": 0.00024737566,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00023937508,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00023937508,
				"type": "LOCATION"
			},
			{
				"name": "level",
				"salience": 0.00023937508,
				"type": "OTHER"
			},
			{
				"name": "Putinist",
				"salience": 0.00023257772,
				"type": "PERSON"
			},
			{
				"name": "scandals",
				"salience": 0.0002192577,
				"type": "OTHER"
			},
			{
				"name": "taxpayers",
				"salience": 0.0002192577,
				"type": "PERSON"
			},
			{
				"name": "Omar Mateen",
				"salience": 0.00021813253,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01mqw1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_Republic"
				},
				"name": "The New Republic",
				"salience": 0.00021813253,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.0002161249,
				"type": "OTHER"
			},
			{
				"name": "witch-hunting",
				"salience": 0.0002161249,
				"type": "EVENT"
			},
			{
				"name": "agents",
				"salience": 0.00021265585,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00021265585,
				"type": "EVENT"
			},
			{
				"name": "agent",
				"salience": 0.00021265585,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.00021000618,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00020105793,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bzsy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McCarthyism"
				},
				"name": "McCarthyite",
				"salience": 0.00020048906,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.00019939146,
				"type": "OTHER"
			},
			{
				"name": "leftists",
				"salience": 0.00019939146,
				"type": "PERSON"
			},
			{
				"name": "Kremlin Masters",
				"salience": 0.00018887626,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07clx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tea"
				},
				"name": "Tea Leaves",
				"salience": 0.00018887626,
				"type": "WORK_OF_ART"
			},
			{
				"name": "entertainment",
				"salience": 0.00018713786,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.00018713786,
				"type": "OTHER"
			},
			{
				"name": "indiscretion",
				"salience": 0.00018713786,
				"type": "OTHER"
			},
			{
				"name": "ladies",
				"salience": 0.00018713786,
				"type": "PERSON"
			},
			{
				"name": "bottom",
				"salience": 0.00018713786,
				"type": "OTHER"
			},
			{
				"name": "visits",
				"salience": 0.00018713786,
				"type": "EVENT"
			},
			{
				"name": "waves",
				"salience": 0.00018713786,
				"type": "OTHER"
			},
			{
				"name": "slush pile",
				"salience": 0.00018713786,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.00018713786,
				"type": "PERSON"
			},
			{
				"name": "server",
				"salience": 0.000186505,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.000186505,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.000186505,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.000186505,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00018326877,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dc95",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oakland,_California"
				},
				"name": "Oakland",
				"salience": 0.00018182363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00018182363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0431h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Edgar_Hoover"
				},
				"name": "J. Edgar Hoover",
				"salience": 0.00018182363,
				"type": "PERSON"
			},
			{
				"name": "Alt",
				"salience": 0.00018182363,
				"type": "ORGANIZATION"
			},
			{
				"name": "explanation",
				"salience": 0.00018165582,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.00017563721,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.00017516062,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.00017432346,
				"type": "OTHER"
			},
			{
				"name": "Corn",
				"salience": 0.00017432346,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.00017432346,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00016781416,
				"type": "WORK_OF_ART"
			},
			{
				"name": "opposite",
				"salience": 0.00016781416,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00016769691,
				"type": "OTHER"
			},
			{
				"name": "revenge",
				"salience": 0.00016769691,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.00016655891,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045vz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Russian_sentiment"
				},
				"name": "Russophobic",
				"salience": 0.00016305344,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0001607137,
				"type": "OTHER"
			},
			{
				"name": "traffic",
				"salience": 0.00015884369,
				"type": "OTHER"
			},
			{
				"name": "hotels",
				"salience": 0.00015884369,
				"type": "LOCATION"
			},
			{
				"name": "campaigns",
				"salience": 0.00015884369,
				"type": "EVENT"
			},
			{
				"name": "liberalism",
				"salience": 0.00015739085,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00015739085,
				"type": "OTHER"
			},
			{
				"name": "MARGIN",
				"salience": 0.00015739085,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00015739085,
				"type": "OTHER"
			},
			{
				"name": "Occam",
				"salience": 0.00015418146,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-Trump pro-Hillary Vox.com",
				"salience": 0.00015418146,
				"type": "OTHER"
			},
			{
				"name": "Naadir Jeewa",
				"salience": 0.00015418146,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.00015151374,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04b1qp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Corn"
				},
				"name": "David Corn",
				"salience": 0.00014731396,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/053wn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maize"
				},
				"name": "Corn",
				"salience": 0.00014731396,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dx64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mother_Jones_(magazine)"
				},
				"name": "Mother Jones",
				"salience": 0.00014731396,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00014308894,
				"type": "LOCATION"
			},
			{
				"name": "Sad",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "brush",
				"salience": 0.00013628045,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "claims",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "NOTES",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "corridors",
				"salience": 0.00013628045,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "feed",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "tweets",
				"salience": 0.00013628045,
				"type": "WORK_OF_ART"
			},
			{
				"name": "jest",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "witch-hunting ideology",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "red scare",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "libertarian thinker",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "cards",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00013628045,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00013628045,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.00013628045,
				"type": "ORGANIZATION"
			},
			{
				"name": "transformations",
				"salience": 0.00013628045,
				"type": "OTHER"
			},
			{
				"name": "Enemy of the State",
				"salience": 0.00013309758,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fantasy",
				"salience": 0.00013119154,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0001302102,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0001302102,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0001302102,
				"type": "OTHER"
			},
			{
				"name": "setup",
				"salience": 0.00012953782,
				"type": "OTHER"
			},
			{
				"name": "key",
				"salience": 0.00012629264,
				"type": "OTHER"
			},
			{
				"name": "domain",
				"salience": 0.0001236814,
				"type": "OTHER"
			},
			{
				"name": "hotline",
				"salience": 0.000118530894,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00011756205,
				"type": "OTHER"
			},
			{
				"name": "smear",
				"salience": 0.00011756205,
				"type": "OTHER"
			},
			{
				"name": "marketing/promotions",
				"salience": 0.00011756205,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00011756205,
				"type": "OTHER"
			},
			{
				"name": "Mysterious Veteran Spook",
				"salience": 0.00011516474,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.00011516474,
				"type": "LOCATION"
			},
			{
				"name": "Smear Trump Sweepstakes",
				"salience": 0.00011516474,
				"type": "OTHER"
			},
			{
				"name": "desperation",
				"salience": 0.00010845915,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.00010179333,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.00010179333,
				"type": "OTHER"
			},
			{
				"name": "email portions",
				"salience": 0.00010179333,
				"type": "OTHER"
			},
			{
				"name": "data center",
				"salience": 0.00010179333,
				"type": "LOCATION"
			},
			{
				"name": "journalists",
				"salience": 0.00010179333,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.00010179333,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.00010179333,
				"type": "OTHER"
			},
			{
				"name": "farrago",
				"salience": 0.00010179333,
				"type": "OTHER"
			},
			{
				"name": "Law enforcement officials",
				"salience": 0.00009603308,
				"type": "PERSON"
			},
			{
				"name": "mystery",
				"salience": 0.000087419096,
				"type": "OTHER"
			},
			{
				"name": "Prometheus Books",
				"salience": 0.00008386572,
				"type": "ORGANIZATION"
			},
			{
				"name": "Justin Raimondo",
				"salience": 0.00008386572,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.000082046296,
				"type": "OTHER"
			},
			{
				"name": "Listrak",
				"salience": 0.00007234617,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/034xnb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pierre_Omidyar"
				},
				"name": "Pierre Omidyar",
				"salience": 0.00006264199,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.00006264199,
				"type": "LOCATION"
			},
			{
				"name": "server",
				"salience": 0.00006030579,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_qj7hg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Intercept"
				},
				"name": "The Intercept",
				"salience": 0.000043258802,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00004296064,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:14:56.696+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 30.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "How Hillary Clinton Poisoned American Politics Crazy conspiracy theories dominate the final days before Nov. 8 Share This \nFBI Director James Comey’s decision to reopen the investigation into Hillary Clinton’s mishandling of classified information has the Clintonites falling back on their tried-and-true response to all the revelations coming from WikiLeaks and other sources – it’s all a Russian plot. Except, this time, the hysteria has reached such a fever pitch, and the conspiracy theories are so unhinged, that the political discourse in this country will be poisoned for years to come. \nIt started with Rep. Tim Ryan (D-Ohio), who told CNN’s Wolf Blitzer: \n“So the question is: Where did these [emails] come from? How did they get to the FBI? Is Russia involved in this? We don’t have a clue where this stuff is coming from.” \nWe don’t know if Ryan was drunk ( again ) when he said this, but his nickname of “ Congressman Moonbeam ” seems well-earned, and the implication of his remarks – that the FBI is in league with the Russians – underscores his marginality. However, it wasn’t long before the marginal started merging with the mainstream. In tandem with Rya, Howard Dean, former presidential candidate and once head of the Democratic party, tweeted : \n“Ironically, Comey put himself on the same side as Putin.” \nNow Dean may be a bit more credible than Ryan, but who can forget the “ Dean scream ” that dramatized his loonier side, and effectively knocked him out of contention for the Democratic presidential nomination? And then there were those payments from the Mujahideen-e-Khalq , a nutty Marxist-Islamist cult, in return for serving as their front man. And so while Dean may be better known, what he’s know for isn’t exactly adding to his credibility, and so we can safely relegate this kind of conspiracy theorizing to the fringes of the Democratic party spectrum. Right? \nWrong. Here is longtime Clintonite strategist James Carville opining that “It’s unprecedented … the House Republicans and the KGB are trying to influence our democracy.” Well, okay, who listens to Carville, anyway? He’s so yester day! Well, then, get a load of Harry Reid, who leads the Senate’s Democrats, repeating a different version of the same nonsense in a letter to Comey : \n\"In my communications with you and other top officials in the national security community, it has become clear that you possess explosive information about close ties and coordination between Donald Trump, his top advisors, and the Russian government – a foreign interest hostile to the united states, which Trump praises at every opportunity. The public has a right to know this information. I wrote to you months ago calling for this information to be released to the public. There is no danger to American interests from releasing it. And yet, you continue to resist calls to inform the public of this critical information.\" \nIt’s so “explosive” that it exploded into utter nothingness, according to the New York Times this [Tuesday] morning: \n“For much of the summer, the F.B.I. pursued a widening investigation into a Russian role in the American presidential campaign. Agents scrutinized advisers close to Donald J. Trump, looked for financial connections with Russian financial figures, searched for those involved in hacking the computers of Democrats, and even chased a lead – which they ultimately came to doubt – about a possible secret channel of email communication from the Trump Organization to a Russian bank. \n“Law enforcement officials say that none of the investigations so far have found any conclusive or direct link between Mr. Trump and the Russian government. And even the hacking into Democratic emails, FBI and intelligence officials now believe, was aimed at disrupting the presidential election rather than electing Mr. Trump.” \nAs Gertrude Stein once put it, “There’s no there there.” She was talking about Oakland, California, but might just as well have been describing the inside of Harry’s brain. \nAnd, yes, you read the above cited Times story right: instead of going after terrorists, or ordinary criminals, for months the FBI has been chasing down rabbit holes looking for Trump’s alleged links to the nonexistent International Kremlin/Alt-Right/Putinist Conspiracy. We have returned to the halcyon days of J. Edgar Hoover, when people were investigated and harassed for their political views at the instigation of their ideological opponents. \nOh, but the FBI was too “ overburdened and undermanned ” to keep Omar Mateen on their radar. \nIn this election, the tragic and the comic mix and merge, but surely the former is dominant in the latest of Franklin Foer’s Russophobic effusions. Formerly the editor of The New Republic , who was unceremoniously dumped by its new owner, Foer has teamed up with the Clinton campaign as its unofficial conspiracy theorist, spinning tales of Trump’s “links” to the Russians. He’s the Alex Jones of the Clinton crowd, except that not even Jones would be caught dead promoting the kind of incoherent nonsense in Foer’s latest screed . \nAccording to Foer, Trump has a “secret server” set up specifically to communicate with his Kremlin Masters. We know this because a “computer scientist” who wants to be known only as “Tea Leaves,” and other “experts” – who also don’t want to tell us their names – have supposedly “discovered” this Secret Link. The server connects to the Alfa Bank, which is located in – cue in scary music – Russia! And guess what!? This closed communication link was especially active during politically sensitive times! This, according to Foer and his anonymous band of “experts,” is conclusive proof that The Donald is a secret agent of the KGB, intent on polluting our precious bodily fluids with icky Russian cooties. \nThe only problem with this wacky conspiracy theory is that there’s a prosaic explanation for the existence of this “suspicious” online traffic: the Trump Organization had hired a company to send out ads for their hotels. The online traffic to Alfa Bank meant only that several employees of that bank had stayed in Trump’s hotels and were being solicited to do so again. And in spite of the “scientific”-looking chart displayed in the Foer piece, in fact the online traffic to and from Alfa didn’t “peak” when the US political scene got hot: “That’s wrong,” writes Timothy B. Lee in the anti-Trump pro-Hillary Vox.com. “If anything, the chart shows the opposite of that.” \nAs Lee puts it: \n“ Foer claims that the pattern of traffic between the Trump Organization and Alfa Bank servers is highly unusual – so unusual that it can best be explained as a secretive communication link between Donald Trump and the Kremlin. \n“But in this case, there seems to be a plausible and perfectly innocent explanation for the traffic pattern suggested by an IT consultant named Naadir Jeewa and endorsed by security expert Robert Graham : The Trump organization is sending out promotional emails about Trump hotels, and one or more Alfa Bank employees is on the recipient list. \n“This is actually the explanation that’s suggested by Occam’s razor because – as Foer himself acknowledges in his story – the server was originally registered by an email marketing firm called Cendyn. The Trump organization seems to have hired Cendyn to send out emails promoting Trump’s hotels, a service Cendyn has been providing since the Trump server was registered in 2009. So the most obvious explanation for the traffic is that Cendyn is using its server for its intended purpose.” \nWhen Hillary Clinton’s Twitter account tweeted Foer’s farrago and declared “It’s time for Trump to answer serious questions about his ties to Russia,” cyber-security expert Robert Graham replied on his blog : \n“This is nonsense. The evidence available on the Internet is that Trump neither (directly) controls the domain \"trump-email.com,\" nor has access to the server. Instead, the domain was setup and controlled by Cendyn, a company that does marketing/promotions for hotels, including many of Trump’s hotels. Cendyn outsources the email portions of its campaigns to a company called Listrak, which actually owns/operates the physical server in a data center in Philadelphia.” \nSo the server wasn’t even owned by the Trump Organization . And yet it took the FBI months, and “journalists,” including even The Intercept , “weeks” to conclude that this story is completely bogus. The US taxpayers should demand their money back – not to mention Pierre Omidyar . \nEven after this sloppy McCarthyite smear was debunked, the Clinton campaign breathlessly repeated the charges: “This secret hotline may be the key to unlocking the mystery of Trump’s ties to Russia”! What this perfervid fantasy is the actually key to is the hysterical desperation of the Clinton campaign as it is engulfed in daily scandals that threaten to sink it beneath the electoral waves. \nAre you laughing – or crying – yet? Oh, but I’m not done! If you think this grade-B conspiracy theory is the lowest form of electoral entertainment, then you obviously haven’t read David Corn’s latest entry into the Smear Trump Sweepstakes. Glenn Greenwald – no friend of Trump’s – describes it as “an unnamed person, from an unknown country, who used to work in an unnamed agency, claims Trump is a Russian agent.” How did the real estate mogul become a tool of the Kremlin? Well, you see, Trump once traveled to Russia, where he was suborned by one of those slinky-looking Russian ladies and “Russian intelligence had ‘compromised’ Trump during his visits to Moscow and could ‘blackmail him.’” \nYes, they’re blackmailing Trump over a sexual indiscretion – because that would destroy him for sure ! And it’s all in a “secret memo” that only Corn, the editors of Mother Jones , and their Mysterious Veteran Spook have seen. \nOn one level, this is hysterically funny; it’s grade-C thriller material that is likely to be found at the bottom of some publisher’s slush pile. On another level – the political level – it is immensely depressingly significant – because these people are “liberals,” even “leftists.” They aren’t stupid: they know the ignominious history of witch-hunting in this country. I’d call this McCarthyism – but even Joe McCarthy had some actual evidence to back up his claims of “foreign agents” lurking in the corridors of power. Corn, Foer, and the Clinton campaign are simply retailing lies. \nWhat’s depressing about this is the fact that, if Hillary wins, it isn’t going to stop. Far from it: the new “red scare” will accelerate, as her political enemies are tarred with the “KGB agent” brush. And when the notoriously vindictive Democratic candidate takes revenge not only on her domestic political enemies, but on the Russians, an ugly – and dangerous – confrontation is in the cards. She’ll sic the FBI on Trump’s supporters, and Trump himself, and she’ll unleash the US military and our allies on Putin – and then, watch out. \nThat American liberalism has degenerated into a Russophobic, warmongering, witch-hunting ideology so quickly is one of the most astonishing ideological transformations in our political history. And all in the name of garnering partisan political advantage. As Donald Trump would put it: Sad! \nNOTES IN THE MARGIN \nYou can check out my Twitter feed by going here . But please note that my tweets are sometimes deliberately provocative, often made in jest, and largely consist of me thinking out loud. \nYou can buy An Enemy of the State: The Life of Murray N. Rothbard (Prometheus Books, 2000), my biography of the great libertarian thinker, here . Read more by Justin Raimondo",
		"thread_title": "How Hillary Clinton Poisoned American Politics",
		"title": "How Hillary Clinton Poisoned American Politics",
		"type": "bs",
		"uuid": "50c1cacbefcbd69a0e6be0c42363c9be97bc0ca4"
	},
	"-KhIjDGSEwKXDuk_yMXn": {
		"author": "Margaret Griffis",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T06:14:57.459+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.3750794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/028t63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haider_al-Abadi"
				},
				"name": "Haider al-Abadi",
				"salience": 0.16932823,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.08201833,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.05867637,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.042176496,
				"type": "LOCATION"
			},
			{
				"name": "border",
				"salience": 0.030012952,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0bjzhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silopi"
				},
				"name": "Silopi",
				"salience": 0.018576318,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.018576318,
				"type": "LOCATION"
			},
			{
				"name": "counter-terrorism forces",
				"salience": 0.017804442,
				"type": "ORGANIZATION"
			},
			{
				"name": "television station building",
				"salience": 0.015434581,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.01316164,
				"type": "PERSON"
			},
			{
				"name": "Militants",
				"salience": 0.0125144655,
				"type": "PERSON"
			},
			{
				"name": "Militants",
				"salience": 0.0110996645,
				"type": "PERSON"
			},
			{
				"name": "security personnel",
				"salience": 0.010441979,
				"type": "PERSON"
			},
			{
				"name": "neighborhood",
				"salience": 0.010441979,
				"type": "LOCATION"
			},
			{
				"name": "another",
				"salience": 0.009680333,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.009320504,
				"type": "LOCATION"
			},
			{
				"name": "human shields",
				"salience": 0.00886136,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.00886136,
				"type": "EVENT"
			},
			{
				"name": "Troops",
				"salience": 0.0084247375,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.007648781,
				"type": "PERSON"
			},
			{
				"name": "soldier",
				"salience": 0.007648781,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0066261627,
				"type": "PERSON"
			},
			{
				"name": "Judaidat al-Mufti",
				"salience": 0.006438576,
				"type": "PERSON"
			},
			{
				"name": "Hammam al-Alil",
				"salience": 0.0062033306,
				"type": "PERSON"
			},
			{
				"name": "Twila",
				"salience": 0.0054622917,
				"type": "PERSON"
			},
			{
				"name": "Sharezad",
				"salience": 0.0054622917,
				"type": "OTHER"
			},
			{
				"name": "Shalalat",
				"salience": 0.0054622917,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.004829564,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0041675353,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0036095039,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01b8yn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shura"
				},
				"name": "Shura",
				"salience": 0.0029747102,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07pgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tigris"
				},
				"name": "Tigris River",
				"salience": 0.0029747102,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:14:57.459+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This Prime Minister Haider al-Abadi again warned Turkey to avoid provoking conflict, after Turkey strengthened its forces in Silopi at the Iraqi border. In Mosul , counter-terrorism forces captured a state-owned television station building. Troops also reached the Judaidat al-Mufti neighborhood. At least 296 security personnel have been killed in the last week in Mosul. About 40,000 people have fled the city. Militants attempted to move 25,000 human shields out of Hammam al-Alil but were thwarted by strikes. Shalalat , Sharezad , and Twila were reported freed . At least 202 people were killed and 52 were wounded in recent violence: In Mosul , at least one soldier was killed and another was wounded . Militants killed 40 men believed to have been soldiers from Shura and Hammam al-Alil , and then they tossed the bodies into the Tigris River.",
		"thread_title": "Iraqi Troops Push Further into Mosul; 202 Killed Across Iraq",
		"title": "Iraqi Troops Push Further into Mosul; 202 Killed Across Iraq",
		"type": "bs",
		"uuid": "80701bf69f3f9ea3b0cf45ae4c412e25d528b8e3"
	},
	"-KhIjDNNxfQtpMVgAjOl": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T06:27:46.566+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Budget Amendment",
				"salience": 0.21649349,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Afghanistan The Pentagon",
				"salience": 0.1850321,
				"type": "ORGANIZATION"
			},
			{
				"name": "budget amendment",
				"salience": 0.11237699,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Troops",
				"salience": 0.081421465,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.04809563,
				"type": "LOCATION"
			},
			{
				"name": "portion",
				"salience": 0.04348475,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.034333315,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.030901657,
				"type": "ORGANIZATION"
			},
			{
				"name": "funding",
				"salience": 0.028718535,
				"type": "OTHER"
			},
			{
				"name": "troop deployments",
				"salience": 0.02491476,
				"type": "OTHER"
			},
			{
				"name": "Mike McCord",
				"salience": 0.019427437,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.012424901,
				"type": "PERSON"
			},
			{
				"name": "ground troops",
				"salience": 0.011963698,
				"type": "PERSON"
			},
			{
				"name": "hope",
				"salience": 0.011569583,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.011197451,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.011057077,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.009383874,
				"type": "OTHER"
			},
			{
				"name": "drawdown",
				"salience": 0.008988583,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.008988583,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.008988583,
				"type": "LOCATION"
			},
			{
				"name": "eye",
				"salience": 0.007343396,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.007343396,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0063965996,
				"type": "LOCATION"
			},
			{
				"name": "money",
				"salience": 0.005490089,
				"type": "OTHER"
			},
			{
				"name": "reckoning",
				"salience": 0.005490089,
				"type": "OTHER"
			},
			{
				"name": "cap",
				"salience": 0.005490089,
				"type": "OTHER"
			},
			{
				"name": "bills",
				"salience": 0.005115071,
				"type": "OTHER"
			},
			{
				"name": "emergency",
				"salience": 0.005115071,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0050111315,
				"type": "ORGANIZATION"
			},
			{
				"name": "caps",
				"salience": 0.004619326,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.004000935,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.003900891,
				"type": "OTHER"
			},
			{
				"name": "emergency spending bill",
				"salience": 0.0038230498,
				"type": "OTHER"
			},
			{
				"name": "funding bills",
				"salience": 0.0038230498,
				"type": "OTHER"
			},
			{
				"name": "emergency",
				"salience": 0.0038230498,
				"type": "OTHER"
			},
			{
				"name": "spending caps",
				"salience": 0.0034523061,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/04/pentagon.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:27:46.566+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "'Budget Amendment' for More Troops in Iraq, Afghanistan   \nThe Pentagon has announced it will file a “budget amendment” seeking another $6 billion in funding for the current fiscal year to pay for additional overseas troop deployments above and beyond what was already in the budget for this year. \nThe $6 billion request comes as an “urgent” request from the Pentagon, and would pay for additional ground troops in Iraq, the additional troops left in Afghanistan by stalling the drawdown, and to pay for escalated airstrikes around the world. \nPentagon Comptroller Mike McCord says the hope is to get the White House to approve submitting the request to Congress before next week’s election, with an eye at getting it added to the latest emergency spending bill, expected before early December. \nThese “emergency” funding bills are the main way to get around spending caps, with Congress deliberately funding the Pentagon only for a portion of the year with money that, by the cap’s reckoning, was the whole year’s budget, then slipping “emergency” bills in afterwards to pay for the rest of the year, while pretending the caps still exist.  ",
		"thread_title": "Pentagon Seeks Another $6 Billion for Overseas Troop Deployments",
		"title": "Pentagon Seeks Another $6 Billion for Overseas Troop Deployments",
		"type": "bs",
		"uuid": "cc7f45c6458366a29645ed5ba3701e862ad260e2"
	},
	"-KhIjDYyET8EpFW9S3PR": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:13:49.865+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "ceasefire",
				"salience": 0.25769284,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.16309123,
				"type": "LOCATION"
			},
			{
				"name": "Rebels",
				"salience": 0.116219595,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.09178636,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.035490427,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.029892217,
				"type": "PERSON"
			},
			{
				"name": "extension",
				"salience": 0.024956498,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.020347184,
				"type": "PERSON"
			},
			{
				"name": "Completely Out of the Question",
				"salience": 0.01984714,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rebels",
				"salience": 0.018986579,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.015943643,
				"type": "LOCATION"
			},
			{
				"name": "fire",
				"salience": 0.013257297,
				"type": "EVENT"
			},
			{
				"name": "airstrikes",
				"salience": 0.0123725915,
				"type": "EVENT"
			},
			{
				"name": "opportunity",
				"salience": 0.01229189,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.011540978,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.009940973,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.007672276,
				"type": "LOCATION"
			},
			{
				"name": "extension",
				"salience": 0.0076429467,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0075133857,
				"type": "EVENT"
			},
			{
				"name": "hand",
				"salience": 0.0068212077,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.005736448,
				"type": "LOCATION"
			},
			{
				"name": "call",
				"salience": 0.0056426697,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0056426697,
				"type": "OTHER"
			},
			{
				"name": "rebel offensives",
				"salience": 0.0051030926,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.005076809,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0047868886,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.004685189,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0043289578,
				"type": "ORGANIZATION"
			},
			{
				"name": "deadline",
				"salience": 0.0041989903,
				"type": "OTHER"
			},
			{
				"name": "offer",
				"salience": 0.0041676466,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.0041461703,
				"type": "EVENT"
			},
			{
				"name": "pause",
				"salience": 0.003991656,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.003991656,
				"type": "ORGANIZATION"
			},
			{
				"name": "hands",
				"salience": 0.003909286,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01xp_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defence_minister"
				},
				"name": "Defense Ministry",
				"salience": 0.0037842614,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.0036531033,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.003385823,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.003385823,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.003385823,
				"type": "EVENT"
			},
			{
				"name": "weapons",
				"salience": 0.0026955383,
				"type": "OTHER"
			},
			{
				"name": "deals",
				"salience": 0.00253008,
				"type": "OTHER"
			},
			{
				"name": "corridors",
				"salience": 0.00253008,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0024376987,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.0020849481,
				"type": "ORGANIZATION"
			},
			{
				"name": "pressure",
				"salience": 0.002048908,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0018430869,
				"type": "WORK_OF_ART"
			},
			{
				"name": "scale",
				"salience": 0.0018430869,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0018430869,
				"type": "OTHER"
			},
			{
				"name": "suburbs",
				"salience": 0.0018430869,
				"type": "LOCATION"
			},
			{
				"name": "rebel factions",
				"salience": 0.0018430869,
				"type": "OTHER"
			},
			{
				"name": "rebel offensive",
				"salience": 0.0017610592,
				"type": "EVENT"
			},
			{
				"name": "military",
				"salience": 0.0017610592,
				"type": "ORGANIZATION"
			},
			{
				"name": "military",
				"salience": 0.0017610592,
				"type": "ORGANIZATION"
			},
			{
				"name": "advantage",
				"salience": 0.0015047555,
				"type": "OTHER"
			},
			{
				"name": "tables",
				"salience": 0.0013769759,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.0011345947,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0008475789,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:13:49.865+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Rebels: Leaving Aleppo 'Completely Out of the Question' by Jason Ditz, November 02, 2016 Share This \nSome two weeks after initially announcing what was going to be an eight hour ceasefire in Aleppo, Russia has continued to hold their fire, and today announced an extension of the operation through Friday , calling on the rebels to take the opportunity to withdraw from the city. \nWhile on the one hand this marks an extension of the ceasefire, the Friday deadline may amount to Russia’s government announcing an upcoming end to the pause. This comes a day after Russian officials warned the rebel offensives around Aleppo were jeopardizing the ceasefire, and a few days after Russian President Vladimir Putin rejected a call from the Defense Ministry to resume strikes. \nThe rebels fighting in Aleppo have rejected Russia’s call to withdraw from the city by Friday evening as “ completely out of the question ,” insisting they intend to remain in the city to prevent allowing it to fall into the hands of the Russian military. \nOf course, Russia’s involvement has only been airstrikes in Aleppo, with the fighting on the ground all between the Nusra Front-led rebels and the Syrian military. The military has been seen to have a major advantage recently, though a rebel offensive over the weekend may have turned the tables, and is likely to reason why there is growing pressure from Russia’s Defense Ministry to resume the airstrikes. \nRussia has promised two corridors through which rebels can leave the city, and said they will allow them to take their weapons with them. The offer is similar to deals wherein rebel factions withdrew from small suburbs around Damascus, but of course on a much grander scale. That the rebels have already rejected it, however, suggests they believe they are not defeated yet. Last 5 posts by Jason Ditz",
		"thread_title": "Russia Extends Aleppo Ceasefire Through Friday, Urges Rebels to Leave",
		"title": "Russia Extends Aleppo Ceasefire Through Friday, Urges Rebels to Leave",
		"type": "bs",
		"uuid": "4aeacf400a0004d0faeae94aa25298735281aed5"
	},
	"-KhIjDhghgQ32m_WIuwa": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T02:23:36.460+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03hz03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Raqqah"
				},
				"name": "Raqqa",
				"salience": 0.31905407,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.120634176,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04kch_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ash_Carter"
				},
				"name": "Ash Carter",
				"salience": 0.08984499,
				"type": "PERSON"
			},
			{
				"name": "Forces",
				"salience": 0.056829505,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0550228,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.048008695,
				"type": "PERSON"
			},
			{
				"name": "ISIS Capital Will Be Attacked With",
				"salience": 0.038188554,
				"type": "WORK_OF_ART"
			},
			{
				"name": "invasion",
				"salience": 0.02374698,
				"type": "EVENT"
			},
			{
				"name": "invasion",
				"salience": 0.02374698,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.021462806,
				"type": "LOCATION"
			},
			{
				"name": "involvement",
				"salience": 0.021010099,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.018608345,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.013257717,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.011488683,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.01075322,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.009231825,
				"type": "ORGANIZATION"
			},
			{
				"name": "invasion",
				"salience": 0.008557827,
				"type": "EVENT"
			},
			{
				"name": "forces",
				"salience": 0.008557827,
				"type": "ORGANIZATION"
			},
			{
				"name": "operation",
				"salience": 0.007695004,
				"type": "EVENT"
			},
			{
				"name": "offensive",
				"salience": 0.00669577,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.006446454,
				"type": "LOCATION"
			},
			{
				"name": "involvement",
				"salience": 0.0056556957,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.0056556957,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.005468755,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.005468755,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.0050688493,
				"type": "LOCATION"
			},
			{
				"name": "comments",
				"salience": 0.0049101864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Kurdish YPG",
				"salience": 0.004762916,
				"type": "OTHER"
			},
			{
				"name": "YPG",
				"salience": 0.004719167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.004125219,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.004125219,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.0040873163,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0040873163,
				"type": "ORGANIZATION"
			},
			{
				"name": "involvement",
				"salience": 0.003239931,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0029779254,
				"type": "OTHER"
			},
			{
				"name": "incentive",
				"salience": 0.0029779254,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0029779254,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0029779254,
				"type": "WORK_OF_ART"
			},
			{
				"name": "plan",
				"salience": 0.0028668598,
				"type": "OTHER"
			},
			{
				"name": "post-ISIS",
				"salience": 0.0025170066,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurds",
				"salience": 0.002487103,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T02:23:36.460+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Insists ISIS Capital Will Be Attacked With 'Forces Available' by Jason Ditz, November 02, 2016 Share This \nSecretary of Defense Ash Carter today confirmed that negotiations with Turkey are ongoing related to the upcoming invasion of the Syrian city of Raqqa, the de facto capital city of ISIS. Carter suggested Turkey’s involvement would only happen “ further down the road .” \nThe US announced that it intends to launch an invasion of Raqqa very soon, will conduct the operation concurrent with the ongoing invasion of Mosul in Iraq, and that Kurdish YPG forces will be providing the vast majority of the forces for this offensive. \nThat’s irked Turkey, particularly the last part, as Turkish officials repeatedly warned the US against allowing Kurds anywhere near Raqqa and have suggested their own involvement was contingent on there being no Kurds involved. \nCarter’s comments suggest the US plan to invade without Turkey is unchanged, and that they intend to try to placate Turkey about the involvement of the YPG by giving them some involvement in the post-ISIS situation in Raqqa. Turkey is particularly keen to ensure that their own allies end up in control of Raqqa, and that’s likely the main incentive of this deal. Last 5 posts by Jason Ditz",
		"thread_title": "Defense Secretary: US Talking to Turkey About Future Role in Raqqa",
		"title": "Defense Secretary: US Talking to Turkey About Future Role in Raqqa",
		"type": "bs",
		"uuid": "98def486921b00a4fc2e6c36a09dbdb6d279ba41"
	},
	"-KhIjDqFlLS1-2i1lBs2": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T03:28:50.464+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "civilians",
				"salience": 0.14634612,
				"type": "PERSON"
			},
			{
				"name": "Camps Aid agencies",
				"salience": 0.1270017,
				"type": "ORGANIZATION"
			},
			{
				"name": "agencies",
				"salience": 0.0816514,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.060736362,
				"type": "LOCATION"
			},
			{
				"name": "influx",
				"salience": 0.052774217,
				"type": "EVENT"
			},
			{
				"name": "persons",
				"salience": 0.052774217,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.052300844,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.03833636,
				"type": "LOCATION"
			},
			{
				"name": "Civilians From Surrounding Towns Arrive",
				"salience": 0.037754823,
				"type": "ORGANIZATION"
			},
			{
				"name": "many",
				"salience": 0.02807819,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.02517734,
				"type": "PERSON"
			},
			{
				"name": "foot",
				"salience": 0.022008022,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.022008022,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.022008022,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "backs",
				"salience": 0.022008022,
				"type": "OTHER"
			},
			{
				"name": "arrivals",
				"salience": 0.022008022,
				"type": "PERSON"
			},
			{
				"name": "towns",
				"salience": 0.021829808,
				"type": "LOCATION"
			},
			{
				"name": "warning",
				"salience": 0.011647087,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.010916016,
				"type": "PERSON"
			},
			{
				"name": "camps",
				"salience": 0.010126445,
				"type": "LOCATION"
			},
			{
				"name": "air",
				"salience": 0.00914658,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.0082727065,
				"type": "LOCATION"
			},
			{
				"name": "coalition",
				"salience": 0.007923825,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.007923825,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.007923825,
				"type": "PERSON"
			},
			{
				"name": "preparation",
				"salience": 0.007628878,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.007628878,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.007071413,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.006590553,
				"type": "LOCATION"
			},
			{
				"name": "process",
				"salience": 0.006472167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.005687458,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.005585255,
				"type": "LOCATION"
			},
			{
				"name": "air strikes",
				"salience": 0.0055603557,
				"type": "EVENT"
			},
			{
				"name": "fighters",
				"salience": 0.0048375977,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0045069354,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.0040698736,
				"type": "EVENT"
			},
			{
				"name": "run",
				"salience": 0.0037720518,
				"type": "EVENT"
			},
			{
				"name": "civilians",
				"salience": 0.003645373,
				"type": "PERSON"
			},
			{
				"name": "expectations",
				"salience": 0.0035247607,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.0030412155,
				"type": "EVENT"
			},
			{
				"name": "run",
				"salience": 0.0030412155,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0030412155,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.002979273,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.002633723,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T03:28:50.464+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "First Civilians From Surrounding Towns Arrive in Camps   \nAid agencies which have been trying to prepare for the huge influx of displaced persons from the city of Mosul are reporting the first arrivals of civilians who fled the surrounding towns , most arriving on foot, and many with nothing more than the clothing on their backs. \nThe agencies are playing up the months of preparation they engaged in, but exactly how they will cope with what could easily be a million new refugees with very little assistance from either the Iraqi government or from the US-led coalition, is still up in the air. \nThe UN has reported six camps are ready to accept about 50,000 people, and 11 more camps are in the process of being readied. At the same time, the UN has warned that they don’t have the funding to support all of these refugees over the long run, and the Mosul battle looks to very much be the long run. \nIraq has warned civilians in Mosul against fleeing from the city, a warning that came after the US announced they intend to conduct air strikes against fleeing ISIS fighters. It’s unclear how many civilians will be able to “stay put” as they were ordered, but the expectations of an intense urban battle are likely to drive many to flee while they still can.  ",
		"thread_title": "Aid Agencies in Iraq Brace for Exodus as Civilians Flee Mosul",
		"title": "Aid Agencies in Iraq Brace for Exodus as Civilians Flee Mosul",
		"type": "bs",
		"uuid": "4003d40dffead25c451987c52457b858c9998c2f"
	},
	"-KhIjE0HoExGgctSVwSp": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T03:28:50.476+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "officials",
				"salience": 0.34083652,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0829735,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.07966573,
				"type": "ORGANIZATION"
			},
			{
				"name": "offensive",
				"salience": 0.07158242,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.048380002,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.03786348,
				"type": "LOCATION"
			},
			{
				"name": "Bombings",
				"salience": 0.030649897,
				"type": "EVENT"
			},
			{
				"name": "forces",
				"salience": 0.027586173,
				"type": "ORGANIZATION"
			},
			{
				"name": "military successes",
				"salience": 0.02659406,
				"type": "OTHER"
			},
			{
				"name": "Surprise Attacks Force 'Golden Division",
				"salience": 0.02270638,
				"type": "ORGANIZATION"
			},
			{
				"name": "Spread Out",
				"salience": 0.018974615,
				"type": "EVENT"
			},
			{
				"name": "strategy",
				"salience": 0.01590674,
				"type": "OTHER"
			},
			{
				"name": "Golden Division",
				"salience": 0.012921749,
				"type": "ORGANIZATION"
			},
			{
				"name": "schedule",
				"salience": 0.011029767,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0078094527,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.006933958,
				"type": "PERSON"
			},
			{
				"name": "numbers",
				"salience": 0.0066846963,
				"type": "OTHER"
			},
			{
				"name": "liberation",
				"salience": 0.0065177693,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0058466587,
				"type": "ORGANIZATION"
			},
			{
				"name": "city limits",
				"salience": 0.005645972,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.005645972,
				"type": "EVENT"
			},
			{
				"name": "outskirts",
				"salience": 0.005645972,
				"type": "LOCATION"
			},
			{
				"name": "arrival",
				"salience": 0.005645972,
				"type": "EVENT"
			},
			{
				"name": "plan",
				"salience": 0.0047293766,
				"type": "OTHER"
			},
			{
				"name": "car bombers",
				"salience": 0.0045735557,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0045735557,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0045735557,
				"type": "LOCATION"
			},
			{
				"name": "advance",
				"salience": 0.0045735557,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0044763694,
				"type": "PERSON"
			},
			{
				"name": "advances",
				"salience": 0.004185727,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.003961285,
				"type": "LOCATION"
			},
			{
				"name": "pockets",
				"salience": 0.003961285,
				"type": "OTHER"
			},
			{
				"name": "suicide",
				"salience": 0.003961285,
				"type": "OTHER"
			},
			{
				"name": "progress",
				"salience": 0.003961285,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.003961285,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.003813636,
				"type": "OTHER"
			},
			{
				"name": "retreat",
				"salience": 0.003813636,
				"type": "OTHER"
			},
			{
				"name": "morale",
				"salience": 0.003813636,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0037889706,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.0037182677,
				"type": "LOCATION"
			},
			{
				"name": "offensives",
				"salience": 0.0036204942,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.003595699,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0033454134,
				"type": "PERSON"
			},
			{
				"name": "tunnels",
				"salience": 0.0032347399,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0032347399,
				"type": "ORGANIZATION"
			},
			{
				"name": "others",
				"salience": 0.002808323,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.0027910299,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n8xw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Improvised_explosive_device"
				},
				"name": "IEDs",
				"salience": 0.0024395243,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0024170955,
				"type": "PERSON"
			},
			{
				"name": "offensives",
				"salience": 0.002251749,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0020332274,
				"type": "OTHER"
			},
			{
				"name": "liberators",
				"salience": 0.0020332274,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0018210188,
				"type": "PERSON"
			},
			{
				"name": "warzone",
				"salience": 0.0017607303,
				"type": "OTHER"
			},
			{
				"name": "loyalty",
				"salience": 0.0017607303,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.001519054,
				"type": "LOCATION"
			},
			{
				"name": "side",
				"salience": 0.0013154212,
				"type": "OTHER"
			},
			{
				"name": "front lines",
				"salience": 0.0013154212,
				"type": "OTHER"
			},
			{
				"name": "counter-offensives",
				"salience": 0.0013154212,
				"type": "EVENT"
			},
			{
				"name": "locals",
				"salience": 0.0008992108,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T03:28:50.476+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Bombings, Surprise Attacks Force 'Golden Division' to Spread Out   \nIraqi officials are never shy about talking up their military successes, and that has been especially true in the Mosul offensive, where they have regularly noted they are far ahead of schedule. The arrival of the first Iraqi troops into the outskirts of Mosul’s city limits was heralded as the start of the “true liberation.” \nIraq’s most elite fighters, the so-called Golden Division, has talked up their high morale, bragging that ISIS forces seem to be in full retreat as soon as they see them. That may, however, be the plan for ISIS, with reports that the fast advances and staggered pockets of resistance are stretching the forces thin . \nISIS is letting the Golden Division advance rapidly in some areas, and slowing their progress with IEDs and suicide car bombers in others. In some places, ISIS forces have hidden in tunnels and appeared behind the advancing troops. The Golden Division’s limited numbers have forced them to rely on the national police to hold territory that they have captured. \nThis is a familiar strategy for ISIS forces, particularly in Iraq, where previous offensives and counter-offensives have seen them withdrawing from some areas and reinforcing others specifically to widen the front lines, forcing the other side to spread themselves around. \nAnd while there are a lot more troops attacking Mosul than in most previous cases, the number of actually well-trained, highly disciplined troops is relatively small. Indeed, Iraqi officials are already saying they are counting on local civilians to rise up against ISIS when they arrive, which has happened in some cases, but notably did not happen in other offensives against major cities, where the locals were more concerned with surviving in a warzone than convincing their “liberators” of their loyalty.  ",
		"thread_title": "Iraqi Elite Forces Stretched Thin by ISIS Tactics Around Mosul",
		"title": "Iraqi Elite Forces Stretched Thin by ISIS Tactics Around Mosul",
		"type": "bs",
		"uuid": "7e6210c5efe19b4a0e5f7191686241f3dfb3a5f3"
	},
	"-KhIjEPTp43JLMOjJCAq": {
		"author": "Ramzy Baroud",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T05:04:39.470+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.15838076,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/047876",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestine_(region)"
				},
				"name": "Palestine",
				"salience": 0.09335871,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arabs",
				"salience": 0.08737439,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01jf9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balfour_Declaration"
				},
				"name": "Balfour Declaration",
				"salience": 0.057642426,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/012l1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arthur_Balfour"
				},
				"name": "Arthur James Balfour",
				"salience": 0.044796363,
				"type": "PERSON"
			},
			{
				"name": "agent",
				"salience": 0.042990465,
				"type": "PERSON"
			},
			{
				"name": "Zionist Jewish",
				"salience": 0.02228745,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.01956116,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.016773699,
				"type": "LOCATION"
			},
			{
				"name": "map",
				"salience": 0.015838062,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.011835287,
				"type": "PERSON"
			},
			{
				"name": "backing",
				"salience": 0.0101690525,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0101690525,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.008939948,
				"type": "WORK_OF_ART"
			},
			{
				"name": "commitment",
				"salience": 0.008454972,
				"type": "OTHER"
			},
			{
				"name": "government view",
				"salience": 0.007844638,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.007675089,
				"type": "EVENT"
			},
			{
				"name": "latter",
				"salience": 0.007226211,
				"type": "OTHER"
			},
			{
				"name": "homeland",
				"salience": 0.0071948254,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.006850814,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0068043787,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.006647651,
				"type": "OTHER"
			},
			{
				"name": "proclamations",
				"salience": 0.0064480244,
				"type": "OTHER"
			},
			{
				"name": "homeland",
				"salience": 0.006339235,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0604m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestinian_National_Authority"
				},
				"name": "Palestinian Authority",
				"salience": 0.0061632544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cm2xh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_I"
				},
				"name": "World War I",
				"salience": 0.005492856,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0053493013,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.0051990887,
				"type": "OTHER"
			},
			{
				"name": "tug",
				"salience": 0.0051990887,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0051990887,
				"type": "OTHER"
			},
			{
				"name": "Ramzy Baroud",
				"salience": 0.004229854,
				"type": "PERSON"
			},
			{
				"name": "habit",
				"salience": 0.004191749,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053wf0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Sykes"
				},
				"name": "Mark Sykes",
				"salience": 0.0041664816,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0037876582,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dv0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_League"
				},
				"name": "Arab League",
				"salience": 0.0036967057,
				"type": "ORGANIZATION"
			},
			{
				"name": "letter",
				"salience": 0.0034997284,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.0034841057,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.0032322416,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0032322416,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0032013124,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g7jk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Secretary_of_State_for_Foreign_and_Commonwealth_Affairs"
				},
				"name": "Foreign Secretary",
				"salience": 0.0032013124,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0031622844,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.0031622844,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0031622844,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0031622844,
				"type": "PERSON"
			},
			{
				"name": "promise",
				"salience": 0.0031183038,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0030473652,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0029641471,
				"type": "ORGANIZATION"
			},
			{
				"name": "home",
				"salience": 0.0029641471,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0029117363,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0027384476,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0027384476,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0027384476,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0027384476,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0027384476,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.002601237,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0025492704,
				"type": "ORGANIZATION"
			},
			{
				"name": "status",
				"salience": 0.0024726226,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0024726226,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0024726226,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024656",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walter_Rothschild,_2nd_Baron_Rothschild"
				},
				"name": "Walter Rothschild",
				"salience": 0.0022750972,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01nf_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sykes%E2%80%93Picot_Agreement"
				},
				"name": "Sykes-Picot Agreement",
				"salience": 0.0022266752,
				"type": "WORK_OF_ART"
			},
			{
				"name": "countries",
				"salience": 0.0022174416,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.002141159,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.002141159,
				"type": "PERSON"
			},
			{
				"name": "Majesty",
				"salience": 0.002141159,
				"type": "PERSON"
			},
			{
				"name": "endeavors",
				"salience": 0.002141159,
				"type": "OTHER"
			},
			{
				"name": "achievement",
				"salience": 0.002141159,
				"type": "OTHER"
			},
			{
				"name": "object",
				"salience": 0.002141159,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0020784666,
				"type": "OTHER"
			},
			{
				"name": "colors",
				"salience": 0.0020784666,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0020008932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.002000273,
				"type": "LOCATION"
			},
			{
				"name": "Zionists",
				"salience": 0.0019879353,
				"type": "PERSON"
			},
			{
				"name": "lines",
				"salience": 0.0019201656,
				"type": "OTHER"
			},
			{
				"name": "map",
				"salience": 0.0019201656,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0019201656,
				"type": "OTHER"
			},
			{
				"name": "lines",
				"salience": 0.0019201656,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0019201656,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0018707771,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0018484972,
				"type": "OTHER"
			},
			{
				"name": "victorious parties",
				"salience": 0.0018484972,
				"type": "OTHER"
			},
			{
				"name": "centerpiece",
				"salience": 0.001823932,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0018102949,
				"type": "EVENT"
			},
			{
				"name": "promises",
				"salience": 0.0017851073,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0017337297,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.0017337297,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0017337297,
				"type": "EVENT"
			},
			{
				"name": "attention",
				"salience": 0.0017337297,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0017337297,
				"type": "OTHER"
			},
			{
				"name": "assumptions",
				"salience": 0.0017337297,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0017337297,
				"type": "OTHER"
			},
			{
				"name": "homeland",
				"salience": 0.001696824,
				"type": "LOCATION"
			},
			{
				"name": "colonies",
				"salience": 0.001696824,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.001696824,
				"type": "ORGANIZATION"
			},
			{
				"name": "promise",
				"salience": 0.001696824,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.0016690162,
				"type": "WORK_OF_ART"
			},
			{
				"name": "behalf",
				"salience": 0.0016690162,
				"type": "OTHER"
			},
			{
				"name": "landscape",
				"salience": 0.0016690162,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0016491378,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0015675757,
				"type": "LOCATION"
			},
			{
				"name": "hypocrisy",
				"salience": 0.001559484,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.0015362494,
				"type": "OTHER"
			},
			{
				"name": "official",
				"salience": 0.0015012714,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.0015012714,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.0015012714,
				"type": "EVENT"
			},
			{
				"name": "cooperation",
				"salience": 0.0015012714,
				"type": "OTHER"
			},
			{
				"name": "repercussions",
				"salience": 0.0015012714,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0015012714,
				"type": "LOCATION"
			},
			{
				"name": "accordance",
				"salience": 0.0015012714,
				"type": "OTHER"
			},
			{
				"name": "graph pencil",
				"salience": 0.0015012714,
				"type": "OTHER"
			},
			{
				"name": "civilizations",
				"salience": 0.0015012714,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0014910619,
				"type": "LOCATION"
			},
			{
				"name": "piece",
				"salience": 0.0014452308,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0014452308,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0014452308,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0014452308,
				"type": "OTHER"
			},
			{
				"name": "designs",
				"salience": 0.0014452308,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cake",
				"salience": 0.0014452308,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.0014452308,
				"type": "LOCATION"
			},
			{
				"name": "mandates",
				"salience": 0.0014153591,
				"type": "OTHER"
			},
			{
				"name": "disregard",
				"salience": 0.0014153591,
				"type": "OTHER"
			},
			{
				"name": "aspiration",
				"salience": 0.0014153591,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0014153591,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0014153591,
				"type": "OTHER"
			},
			{
				"name": "Zionist movement",
				"salience": 0.0014153591,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0014153591,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0013975237,
				"type": "OTHER"
			},
			{
				"name": "rebellion",
				"salience": 0.0013884715,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/089g6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionism"
				},
				"name": "Zionists",
				"salience": 0.001375299,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0013523353,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.0013523353,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.0013179285,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018wvh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gentile"
				},
				"name": "non-Jewish",
				"salience": 0.0013179285,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottomans",
				"salience": 0.0013139425,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.0012893461,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.0012675585,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0012412134,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.0012315715,
				"type": "ORGANIZATION"
			},
			{
				"name": "Asia Minor Agreement",
				"salience": 0.0012315715,
				"type": "WORK_OF_ART"
			},
			{
				"name": "earnest",
				"salience": 0.0012255717,
				"type": "OTHER"
			},
			{
				"name": "migration",
				"salience": 0.0012255717,
				"type": "EVENT"
			},
			{
				"name": "division",
				"salience": 0.0012255717,
				"type": "ORGANIZATION"
			},
			{
				"name": "settlers",
				"salience": 0.0012255717,
				"type": "PERSON"
			},
			{
				"name": "entities",
				"salience": 0.0012255717,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0012255717,
				"type": "OTHER"
			},
			{
				"name": "turmoil",
				"salience": 0.0012255717,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.0012255717,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0012255717,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0012255717,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.0011709959,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0011709959,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.0011709959,
				"type": "OTHER"
			},
			{
				"name": "aberration",
				"salience": 0.0011649505,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04_qj3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Georges-Picot"
				},
				"name": "François Georges-Picot",
				"salience": 0.0011377494,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0010572758,
				"type": "LOCATION"
			},
			{
				"name": "history",
				"salience": 0.0010572758,
				"type": "OTHER"
			},
			{
				"name": "disregard",
				"salience": 0.0010572758,
				"type": "OTHER"
			},
			{
				"name": "PalestineChronicle.com",
				"salience": 0.0010340842,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0010272571,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.0009848898,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0009848898,
				"type": "PERSON"
			},
			{
				"name": "injustice",
				"salience": 0.00096313446,
				"type": "OTHER"
			},
			{
				"name": "My Father was A Freedom Fighter: Gaza's Untold Story",
				"salience": 0.00096154783,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resistance",
				"salience": 0.0009271761,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.00092399394,
				"type": "ORGANIZATION"
			},
			{
				"name": "colonialism",
				"salience": 0.00092314126,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00092314126,
				"type": "ORGANIZATION"
			},
			{
				"name": "notion",
				"salience": 0.00091549073,
				"type": "OTHER"
			},
			{
				"name": "misfortunates",
				"salience": 0.00091549073,
				"type": "OTHER"
			},
			{
				"name": "replay",
				"salience": 0.00091549073,
				"type": "OTHER"
			},
			{
				"name": "lip-service",
				"salience": 0.00091549073,
				"type": "OTHER"
			},
			{
				"name": "refugee camps",
				"salience": 0.00091549073,
				"type": "LOCATION"
			},
			{
				"name": "cleansing",
				"salience": 0.00091549073,
				"type": "OTHER"
			},
			{
				"name": "ancestors",
				"salience": 0.00091549073,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.00091549073,
				"type": "PERSON"
			},
			{
				"name": "brief",
				"salience": 0.00091549073,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0268zzq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zionist_Federation_of_Great_Britain_and_Ireland"
				},
				"name": "Zionist Federation",
				"salience": 0.00088949647,
				"type": "ORGANIZATION"
			},
			{
				"name": "book",
				"salience": 0.00085923565,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rights",
				"salience": 0.0008528094,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.0008271553,
				"type": "OTHER"
			},
			{
				"name": "aspirations",
				"salience": 0.00076998235,
				"type": "OTHER"
			},
			{
				"name": "generation",
				"salience": 0.00076998235,
				"type": "OTHER"
			},
			{
				"name": "diplomats",
				"salience": 0.00076998235,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.00076998235,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.00076998235,
				"type": "OTHER"
			},
			{
				"name": "rebellion",
				"salience": 0.00076998235,
				"type": "EVENT"
			},
			{
				"name": "intentions",
				"salience": 0.0007602777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.00075428316,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00075428316,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.00075428316,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0007356897,
				"type": "EVENT"
			},
			{
				"name": "Arabs",
				"salience": 0.0007356897,
				"type": "PERSON"
			},
			{
				"name": "colonialism",
				"salience": 0.00068956165,
				"type": "OTHER"
			},
			{
				"name": "columnist",
				"salience": 0.00066671654,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.00066671654,
				"type": "OTHER"
			},
			{
				"name": "equality",
				"salience": 0.00066671654,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.00066671654,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00066671654,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.00066671654,
				"type": "PERSON"
			},
			{
				"name": "peril",
				"salience": 0.00066671654,
				"type": "OTHER"
			},
			{
				"name": "perpetuation",
				"salience": 0.00066671654,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0006612676,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00063702214,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00063702214,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0005751492,
				"type": "OTHER"
			},
			{
				"name": "assurances",
				"salience": 0.0005751492,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.0005751492,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024cdt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jewish_diaspora"
				},
				"name": "Diaspora",
				"salience": 0.00056342175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.0005007508,
				"type": "LOCATION"
			},
			{
				"name": "takeover",
				"salience": 0.0004980093,
				"type": "EVENT"
			},
			{
				"name": "anger",
				"salience": 0.0004980093,
				"type": "OTHER"
			},
			{
				"name": "avail",
				"salience": 0.0004980093,
				"type": "OTHER"
			},
			{
				"name": "rapport",
				"salience": 0.0004980093,
				"type": "OTHER"
			},
			{
				"name": "independence",
				"salience": 0.0004980093,
				"type": "OTHER"
			},
			{
				"name": "radar",
				"salience": 0.0004980093,
				"type": "OTHER"
			},
			{
				"name": "rioters",
				"salience": 0.0004980093,
				"type": "PERSON"
			},
			{
				"name": "troublemakers",
				"salience": 0.0004980093,
				"type": "PERSON"
			},
			{
				"name": "obstacles",
				"salience": 0.0004980093,
				"type": "OTHER"
			},
			{
				"name": "concoctions",
				"salience": 0.0004980093,
				"type": "OTHER"
			},
			{
				"name": "League of Nations Council",
				"salience": 0.00043360016,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00041030618,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b8nlk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pluto_Press"
				},
				"name": "Pluto Press",
				"salience": 0.00041030618,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h44w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mandatory_Palestine"
				},
				"name": "British Mandate",
				"salience": 0.00035395057,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0002936274,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T05:04:39.470+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nLast July, the Palestinian Authority took the unexpected, although belated step of seeking Arab backing in suing Britain over the Balfour Declaration. That \"declaration\" was the first ever explicit commitment made by Britain, and the West in general, to establish a Jewish homeland atop an existing Palestinian homeland. \nIt is too early to tell whether the Arab League would heed the Palestinian call , or if the PA would even follow through, especially considering that the latter has the habit of making too many proclamations backed by little or no action. \nHowever, it seems that the next year will witness a significant tug of war regarding the Balfour Declaration, the 100 th anniversary of which will be commemorated on November 02, 2017. \nBut who is Balfour, what is the Balfour Declaration and why does all of this matters today? \nBritain’s Foreign Secretary from late 1916, Arthur James Balfour, had pledged Palestine to another people. That promise was made on November 02, 1917 on behalf of the British government in the form of a letter sent to the leader of the Jewish community in Britain, Walter Rothschild. \nAt the time, Britain was not even in control of Palestine, which was still part of the Ottoman Empire. Either way, Palestine was never Balfour’s to so casually transfer to anyone else. His letter read: \n\"His Majesty’s government view with favor the establishment in Palestine of a national home for the Jewish people, and will use their best endeavors to facilitate the achievement of this object, it being clearly understood that nothing shall be done which may prejudice the civil and religious rights of existing non-Jewish communities in Palestine, or the rights and political status enjoyed by Jews in any other country.\" \nHe concluded, \"I should be grateful if you would bring this declaration to the knowledge of the Zionist Federation.\" \nBalfour was hardly acting on his own. True, the Declaration bears his name, yet, in reality, he was a loyal agent of an Empire with massive geopolitical designs, not only concerning Palestine alone, but with Palestine as part of a larger Arab landscape. \nOnly a year earlier, another sinister document was introduced, albeit secretly. It was endorsed by another top British diplomat, Mark Sykes and, on behalf of France, by François Georges-Picot. The Russians were informed of the agreement, as they too had received a piece of the Ottoman cake. \nThe document indicated that, once the Ottomans were soundly defeated, their territories, including Palestine, would be split among the prospective victorious parties. \nThe Sykes-Picot Agreement , also known as the \"Asia Minor Agreement\", was signed in secret one hundred years ago, two years into World War I. It signified the brutal nature of colonial powers that rarely associated land and resources with people who lived upon or owned them. \nThe centerpiece of the agreement was a map that was marked with straight lines by a China graph pencil. The map largely determined the fate of the Arabs, dividing them in accordance with various haphazard assumptions of tribal and sectarian lines. \nThe improvised map consisted not only of lines but also colors , along with language that attested to the fact that the two countries viewed the Arab region purely on materialistic terms, without paying the slightest attention to the possible repercussions of slicing up entire civilizations with a multifarious history of cooperation and conflict. \nThe Sykes-Picot negotiations were completed in March 1916 and, although official, was secretly signed on May 19, 1916. \nWWI concluded on November 11, 1918, after which the division of the Ottoman Empire began in earnest. \nBritish and French mandates were extended over divided Arab entities, while Palestine was granted to the Zionist movement a year later, when Balfour conveyed the British government’s promise, sealing the fate of Palestinians to a life of perpetual war and turmoil. \nRarely was British-Western hypocrisy and complete disregard for the national aspiration of any other nation on full display as in the case of Palestine. Beginning with the first wave of Zionist Jewish migration to Palestine in 1882, European countries helped facilitate the movement of illegal settlers and resources, where the establishment of many colonies, large and small, was afoot. \nSo when Balfour sent his letter to Rothschild, the idea of a Jewish homeland in Palestine was very much plausible. \nStill, many supercilious promises were being made to the Arabs during the Great War years, as the Arab leadership sided with the British in their war against the Ottoman Empire. Arabs were promised instant independence, including that of the Palestinians. \nWhen the intentions of the British and their rapport with the Zionists became too apparent, Palestinians rebelled , marking a rebellion that has never ceased 99 years later, and highlighting the horrific consequences of British colonialism and the eventual complete Zionist takeover of Palestine which is still felt after all of these years. \nPaltry attempts to pacify Palestinian anger were to no avail, especially after the League of Nations Council in July 1922 approved the terms of the British Mandate over Palestine – which was originally granted to Britain in April 1920 – without consulting the Palestinians at all. In fact, Palestinians would disappear from the British and international radar, only to reappear as negligible rioters, troublemakers, and obstacles to the joint British-Zionist colonial concoctions. \nDespite occasional assurances to the contrary, the British intention of ensuring the establishment of an exclusively Jewish state in Palestine was becoming clearer with time. The Balfour Declaration was not merely an aberration, but had, indeed, set the stage for the full-scale ethnic cleansing that followed, three decades later. \nIn fact, that history remains in constant replay: the Zionists claimed Palestine and renamed it \"Israel\"; the British continue to support them, although never ceasing to pay lip-service to the Arabs; and the Palestinian people remain a nation that is geographically fragmented between refugee camps, in the Diaspora, militarily occupied, or treated as second class citizens in a country upon which their ancestors dwelt since time immemorial. \nWhile Balfour cannot be blamed for all the misfortunates that have befallen Palestinians since he communicated his brief, but infamous letter, the notion that his \"promise\" embodied – that of complete disregard of the aspirations and rights of the Palestinian Arab people – that very letter is handed from one generation of British diplomats to the next, in the same way that Palestinian resistance to colonialism has and continues to spread across generations. \nThat injustice continues, thus the perpetuation of the conflict. What the British, the early Zionists, the Americans and subsequent Israeli governments failed to understand, and continue to ignore at their own peril, is that there can be no peace without justice and equality in Palestine; and that Palestinians will continue to resist, as long as the reasons that inspired their rebellion nearly a century ago, remain in place. \nRamzy Baroud ( www.ramzybaroud.net ) is a media consultant, an internationally-syndicated columnist and the editor of PalestineChronicle.com . His latest book is My Father was A Freedom Fighter: Gaza’s Untold Story (Pluto Press). Read more by Ramzy Baroud",
		"thread_title": "Why Palestinians Want To Sue Britain: 99 Years Since the Balfour Declaration",
		"title": "Why Palestinians Want To Sue Britain: 99 Years Since the Balfour Declaration",
		"type": "bs",
		"uuid": "d9fef6d76e19250fb56da0f59a62367088c91eb4"
	},
	"-KhIjEhphpzlt_Rzlkf3": {
		"author": "Edward Hunt",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T05:04:56.243+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "government",
				"salience": 0.5014619,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.29044664,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.041924812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "North Korean",
				"salience": 0.028081587,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.027531039,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qgw31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Victor_Cha"
				},
				"name": "Victor Cha",
				"salience": 0.007979942,
				"type": "PERSON"
			},
			{
				"name": "enemies",
				"salience": 0.006905384,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.005452485,
				"type": "PERSON"
			},
			{
				"name": "test",
				"salience": 0.004284171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.004180168,
				"type": "ORGANIZATION"
			},
			{
				"name": "capabilities",
				"salience": 0.0028344824,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0025825188,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0025786266,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0022339015,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02q42m1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_R._Clapper"
				},
				"name": "James Clapper",
				"salience": 0.0019737792,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0019465946,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0016839062,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0015597013,
				"type": "OTHER"
			},
			{
				"name": "concessions",
				"salience": 0.0014166154,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012dwfwl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kirby_(admiral)"
				},
				"name": "John Kirby",
				"salience": 0.0014038264,
				"type": "PERSON"
			},
			{
				"name": "measures",
				"salience": 0.0013188726,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.0013188726,
				"type": "OTHER"
			},
			{
				"name": "purposes",
				"salience": 0.0013188726,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04j4_qc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ben_Rhodes_(White_House_staffer)"
				},
				"name": "Ben Rhodes",
				"salience": 0.0012676839,
				"type": "PERSON"
			},
			{
				"name": "cry",
				"salience": 0.0012169319,
				"type": "OTHER"
			},
			{
				"name": "Edward Hunt",
				"salience": 0.0011608342,
				"type": "PERSON"
			},
			{
				"name": "subcommittee",
				"salience": 0.0011422641,
				"type": "ORGANIZATION"
			},
			{
				"name": "claim",
				"salience": 0.0011422641,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0011422641,
				"type": "PERSON"
			},
			{
				"name": "line",
				"salience": 0.0011422641,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.0011422641,
				"type": "OTHER"
			},
			{
				"name": "negotiations",
				"salience": 0.0011422641,
				"type": "EVENT"
			},
			{
				"name": "officials",
				"salience": 0.001065029,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.001065029,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0009806969,
				"type": "PERSON"
			},
			{
				"name": "Mark C. Toner",
				"salience": 0.00095870707,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04nngd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Committee_on_Foreign_Affairs"
				},
				"name": "House Foreign Affairs Committee",
				"salience": 0.0008994884,
				"type": "ORGANIZATION"
			},
			{
				"name": "effort",
				"salience": 0.00080784445,
				"type": "OTHER"
			},
			{
				"name": "armistice",
				"salience": 0.0007519697,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0007015399,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04kch_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ash_Carter"
				},
				"name": "Ashton Carter",
				"salience": 0.0006809327,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.0006679943,
				"type": "OTHER"
			},
			{
				"name": "Threat",
				"salience": 0.0006512746,
				"type": "OTHER"
			},
			{
				"name": "Threat",
				"salience": 0.0006512746,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00064105383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0006402316,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.00063956255,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.00061907904,
				"type": "OTHER"
			},
			{
				"name": "deterrent",
				"salience": 0.00060168805,
				"type": "OTHER"
			},
			{
				"name": "deterrent",
				"salience": 0.00060168805,
				"type": "OTHER"
			},
			{
				"name": "Testing",
				"salience": 0.00060168805,
				"type": "EVENT"
			},
			{
				"name": "weapons",
				"salience": 0.0005555501,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.00054775894,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.000543285,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.000543285,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.000543285,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.000543285,
				"type": "LOCATION"
			},
			{
				"name": "interpretation",
				"salience": 0.000543285,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0005233774,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0005038466,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0004916328,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0004872198,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0004872198,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0004872198,
				"type": "LOCATION"
			},
			{
				"name": "administration",
				"salience": 0.00047646218,
				"type": "ORGANIZATION"
			},
			{
				"name": "truth",
				"salience": 0.00047045984,
				"type": "OTHER"
			},
			{
				"name": "pundits",
				"salience": 0.00047045984,
				"type": "PERSON"
			},
			{
				"name": "dialogue",
				"salience": 0.00047045984,
				"type": "OTHER"
			},
			{
				"name": "strategy",
				"salience": 0.00047045984,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00047045984,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.00047045984,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00046903736,
				"type": "LOCATION"
			},
			{
				"name": "sanctions",
				"salience": 0.00045668567,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.00045668567,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.00045668567,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.000449883,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.00043964197,
				"type": "OTHER"
			},
			{
				"name": "answer",
				"salience": 0.0004092181,
				"type": "OTHER"
			},
			{
				"name": "arsenal",
				"salience": 0.000405875,
				"type": "LOCATION"
			},
			{
				"name": "actions",
				"salience": 0.000405875,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.00039072643,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048n7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korean_War"
				},
				"name": "Korean War",
				"salience": 0.00038330644,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06qd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Korea"
				},
				"name": "South Korea",
				"salience": 0.00036263608,
				"type": "LOCATION"
			},
			{
				"name": "military power",
				"salience": 0.00034443606,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00033134784,
				"type": "OTHER"
			},
			{
				"name": "starters",
				"salience": 0.00032986788,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00032986788,
				"type": "ORGANIZATION"
			},
			{
				"name": "most",
				"salience": 0.00032986788,
				"type": "OTHER"
			},
			{
				"name": "press briefing",
				"salience": 0.00032986788,
				"type": "EVENT"
			},
			{
				"name": "ways",
				"salience": 0.00032986788,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.00032986788,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.00032986788,
				"type": "LOCATION"
			},
			{
				"name": "fighting",
				"salience": 0.00032986788,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.00032986788,
				"type": "OTHER"
			},
			{
				"name": "common sense",
				"salience": 0.00031755478,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00031755478,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00031755478,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.00031755478,
				"type": "PERSON"
			},
			{
				"name": "squeeze",
				"salience": 0.00031099143,
				"type": "OTHER"
			},
			{
				"name": "squeeze",
				"salience": 0.00031099143,
				"type": "OTHER"
			},
			{
				"name": "notice",
				"salience": 0.00031099143,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0003034152,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.00030103014,
				"type": "ORGANIZATION"
			},
			{
				"name": "notion",
				"salience": 0.0002993826,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "North Koreans",
				"salience": 0.00028246138,
				"type": "LOCATION"
			},
			{
				"name": "same",
				"salience": 0.00027851685,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.00027851685,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.0002692915,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0002692915,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0002692915,
				"type": "LOCATION"
			},
			{
				"name": "advantage",
				"salience": 0.0002692915,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0002692915,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.00025730007,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00025164627,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vnr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Security_Council"
				},
				"name": "U.N. Security Council",
				"salience": 0.0002448276,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00023447092,
				"type": "ORGANIZATION"
			},
			{
				"name": "arsenal",
				"salience": 0.00023231331,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.00023026914,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0002188789,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.00021432944,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.00021432944,
				"type": "OTHER"
			},
			{
				"name": "Everybody",
				"salience": 0.00021257797,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.00021162831,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.00021162831,
				"type": "OTHER"
			},
			{
				"name": "deterrent",
				"salience": 0.00021004563,
				"type": "OTHER"
			},
			{
				"name": "resolve",
				"salience": 0.00020115986,
				"type": "OTHER"
			},
			{
				"name": "provocations",
				"salience": 0.00020115986,
				"type": "EVENT"
			},
			{
				"name": "respect",
				"salience": 0.00020115986,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00020115986,
				"type": "OTHER"
			},
			{
				"name": "alternatives",
				"salience": 0.00020115986,
				"type": "OTHER"
			},
			{
				"name": "survival",
				"salience": 0.00020115986,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00020115986,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00018738727,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.00016918809,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01krx6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korean_Peninsula"
				},
				"name": "Korean Peninsula",
				"salience": 0.00016573857,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.00016495022,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00016421328,
				"type": "OTHER"
			},
			{
				"name": "range",
				"salience": 0.00016421328,
				"type": "OTHER"
			},
			{
				"name": "Vincent K. Brooks",
				"salience": 0.00016044517,
				"type": "PERSON"
			},
			{
				"name": "pressure",
				"salience": 0.00015151758,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "siege",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "vantage",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "taste",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0001464979,
				"type": "OTHER"
			},
			{
				"name": "military power",
				"salience": 0.00013997324,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.00013997324,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.00013465282,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.00012637807,
				"type": "OTHER"
			},
			{
				"name": "Consequences",
				"salience": 0.00012637807,
				"type": "OTHER"
			},
			{
				"name": "capabilities",
				"salience": 0.00012637807,
				"type": "OTHER"
			},
			{
				"name": "PhD",
				"salience": 0.00011808178,
				"type": "OTHER"
			},
			{
				"name": "soldier",
				"salience": 0.00011367272,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.00010942827,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.00010942827,
				"type": "OTHER"
			},
			{
				"name": "bombers",
				"salience": 0.00010942827,
				"type": "OTHER"
			},
			{
				"name": "preparedness",
				"salience": 0.00010942827,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jrch",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_studies"
				},
				"name": "American Studies",
				"salience": 0.000090157344,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017v3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/College_of_William_%26_Mary"
				},
				"name": "College of William & Mary",
				"salience": 0.000090157344,
				"type": "ORGANIZATION"
			},
			{
				"name": "Foreign Policy In Focus",
				"salience": 0.000090157344,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T05:04:56.243+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This \nIn recent months, a number of U.S. officials have begun to reassess their understanding of why the North Korean government wants nuclear weapons. Rather than repeating the standard claim that the North Korean government is taking extreme measures to intimidate its enemies into making concessions, some officials have begun to suggest that the North Korean government desires nuclear weapons for defensive purposes. \nAfter the North Korean government conducted its fifth underground nuclear test on September 9, 2016, former US official Victor Cha presented the new line of thinking. “This is not a cry for negotiations,” Cha told The New York Times . “This is very clearly a serious effort at amassing real nuclear capabilities that they can use to deter the US and others.” \nA few days later, Cha shared the same logic with a subcommittee of the House Foreign Affairs Committee. “Testing was once interpreted by pundits to be an attention-getting effort for dialogue with the United States,” but “it would be irresponsible today to adhere to such an interpretation,” Cha stated . In today’s world, “North Korea is executing a strategy designed to demonstrate a survivable nuclear deterrent before the next US administration comes into office.” In short, Cha insisted that the North Korean government sought to acquire nuclear weapons for the purpose of deterring its enemies. \nThreat or No Threat? \nOf course, not everyone in Washington agrees with such thinking. Although Cha and other strategic analysts have proposed that the North Korean government is rationally pursuing a nuclear deterrent to defend itself against the United States, high-level officials in Washington insist that nothing could be further from the truth. \nNotably, Secretary of State John Kerry has refuted the idea that the North Korean government needs to take defensive measures. For “any person of common sense,” the answer to the question of whether the North Korean government has to defend itself against the United States is “no,” Kerry announced on October 19, 2016. “Everybody knows that.” \nAfter making his point, Kerry then insisted that the United States posed no threat to North Korea because the US government has made no recent efforts to destroy the country. “The United States has had the power to wipe out North Korea for years – for years,” Kerry noted. “And if indeed that was our goal, we wouldn’t be sitting around waiting while they’re getting additional nuclear weapons.” \nCertainly, US officials have not recently attempted to wipe out North Korea. Although the United States had once destroyed most of North Korea during the Korean War, when it spent three years carpet-bombing the country and destroying most North Korean cities, US officials have not resorted to comparable tactics in the country since the armistice ended the fighting in 1953. \nAt the same time, US officials have continued to take other actions to pressure, marginalize, and isolate North Korea. For starters, US officials have worked with their allies to impose restrictive sanctions on the country. Certainly, “we’re always looking at ways we can continue to apply pressure,” State Department Spokesperson Mark C. Toner acknowledged during a press briefing on July 19, 2016. In fact, “the sanctions are pretty severe right now.” \nTwo months later, White House official Ben Rhodes made a similar point, only providing more emphasis. “So we’ve passed now through the U.N. Security Council the strongest sanctions ever on North Korea,” Rhodes stated . The sanctions are “having an impact” and “putting a tighter squeeze on North Korea.” \nTo put an even tighter squeeze on North Korea, US officials have also made it clear that they are ready to take more direct action. Taking advantage of their extraordinary military power in the region, including the 28,500 US soldier s that are stationed in South Korea, US officials have continually reminded the North Korean government that they are ready to resume the Korean War at a moment’s notice. \nOn the day that the North Korean government conducted its fifth underground nuclear test, Secretary of Defense Ashton Carter made the point by stating that “US forces on the Korean Peninsula are always ready, and this is true every single day, to fight tonight.” \nA few days later, US officials then sent an even more powerful signal of their preparedness, flying two nuclear-capable B-1B bombers over South Korea in a display of military power. As US General Vincent K. Brooks explained at the time, US officials wanted to demonstrate their commitment to using their “full range of military capabilities,” such as nuclear weapons. \nExpect Serious Consequences \nBy applying constant pressure to North Korea, US officials have sent another powerful message to the North Korean government. Although officials in Washington may deny that they are threatening North Korea, they have made it clear that the North Korean government can expect to face serious consequences for continuing to defy the United States with its nuclear weapons program. \n“What I can tell you is our policy, with respect to North Korea’s provocations and the resolve of the United States and the international community to try to put adequate pressure on them to change their behavior, has not changed and remains the same,” State Department Spokesperson John Kirby confirmed on October 25, 2016. \nEven so, some officials are now providing another way of understanding the situation. On the same day that Kirby made his statement, Director of National Intelligence James Clapper indicated that the United States has ultimately left the North Korean government with no serious alternatives. “I think the notion of getting the North Koreans to denuclearize is probably a lost cause,” Clapper stated . “They are not going to do that. That is their ticket to survival.” Indeed, Clapper indicated that the North Korean government would find it necessary to maintain a powerful nuclear arsenal in order to deter the constant threats it faces from the United States. \n“And I got a good taste of that when I was there, about how the world looks from their vantage,” Clapper added. “And they are under siege and they are very paranoid.” \nIn short, a number of US officials are now beginning to come to terms with one of the main reasons why the North Korean government is making such a major effort to acquire nuclear weapons. These officials are starting to believe that the North Korean government is working to build an arsenal of nuclear weapons to create a powerful deterrent against the United States. \nEdward Hunt writes about war and empire. He has a PhD in American Studies from the College of William & Mary. Reprinted with permission from Foreign Policy In Focus . Read more by Edward Hunt",
		"thread_title": "North Korea’s Nuclear Ticket to Survival",
		"title": "North Korea’s Nuclear Ticket to Survival",
		"type": "bs",
		"uuid": "bb8be5944ddc83139580920eb77aa9e4651954eb"
	},
	"-KhIjEr7WvNCHDdQ8uD-": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T05:08:16.493+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01p9wn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anders_Fogh_Rasmussen"
				},
				"name": "Anders Fogh Rasmussen",
				"salience": 0.24160711,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.17300701,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.16112173,
				"type": "PERSON"
			},
			{
				"name": "policeman",
				"salience": 0.113857254,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.04116724,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.034598902,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.02145237,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01fp7c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sky_News"
				},
				"name": "Sky News",
				"salience": 0.02145237,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.02145237,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.019879522,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.014401346,
				"type": "OTHER"
			},
			{
				"name": "attitude",
				"salience": 0.014401346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.013808056,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0068990793,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0066055893,
				"type": "PERSON"
			},
			{
				"name": "hawk",
				"salience": 0.0065875384,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0059805224,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.005732257,
				"type": "WORK_OF_ART"
			},
			{
				"name": "order",
				"salience": 0.0051806327,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0051806327,
				"type": "WORK_OF_ART"
			},
			{
				"name": "successor",
				"salience": 0.004681951,
				"type": "PERSON"
			},
			{
				"name": "level",
				"salience": 0.0042311563,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0042311563,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0041779415,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0036536907,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0031886327,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0031886327,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.0031622467,
				"type": "EVENT"
			},
			{
				"name": "favor",
				"salience": 0.0031622467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0029601655,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0029601655,
				"type": "LOCATION"
			},
			{
				"name": "fights",
				"salience": 0.0027509874,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0026061018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0026061018,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.0023038848,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.001987767,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0019472735,
				"type": "ORGANIZATION"
			},
			{
				"name": "course",
				"salience": 0.0017213833,
				"type": "OTHER"
			},
			{
				"name": "bellicosity",
				"salience": 0.0017213833,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.0017213833,
				"type": "OTHER"
			},
			{
				"name": "timing",
				"salience": 0.0017213833,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.0017213833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0011007586,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09w3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pentagon"
				},
				"name": "Pentagon",
				"salience": 0.0010596749,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "North Korea",
				"salience": 0.0010596749,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2013/02/anders.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T05:08:16.493+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.4,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Complains Obama Isn't Hawkish Enough   \nIn a new interview with Britain’s Sky News, former NATO Secretary-General Anders Fogh Rasmussen brought out the old narrative of America as the “world’s policeman,” but with a lot more upbeat of an attitude about it than one would generally see. \nRasmussen criticized President Obama for not being hawkish enough, saying his successor needs to be much more interventionist, and declaring “ we need America as the world’s policeman, ” adding that the US needs to “restore international law and order” through wars. \nRasmussen, who was always a relative hawk in the post but seems to have taken it to an entirely new level, set out a series of things the US needs to fix militarily, including Iraq, Syria, Libya, Russia, China, and North Korea. This of course closely mirrors recent Pentagon talk of wars in the decades to come. \nThe timing of his calls for extreme US bellicosity are centered on trying to influence the upcoming US election in favor of Democratic nominee Hillary Clinton, who has campaigned heavily on picking fights in Syria and against Russia. Rasmussen underscored this fact by declaring Donald Trump, who openly said the US cannot be the world’s police, as “very dangerous for the world.”  ",
		"thread_title": "Former NATO Chief: We Need US as ‘World’s Policeman’",
		"title": "Former NATO Chief: We Need US as ‘World’s Policeman’",
		"type": "bs",
		"uuid": "6f21db34fe906cac6fa5ca40c3e1b33523b05383"
	},
	"-KhIjF1uFSB0Bi0UX5e1": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T05:08:16.515+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.19776578,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukrainian",
				"salience": 0.10976543,
				"type": "LOCATION"
			},
			{
				"name": "navy",
				"salience": 0.063375615,
				"type": "OTHER"
			},
			{
				"name": "fleets",
				"salience": 0.045316085,
				"type": "OTHER"
			},
			{
				"name": "Counter",
				"salience": 0.04192881,
				"type": "PERSON"
			},
			{
				"name": "understatement",
				"salience": 0.04069064,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.037926182,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ndwhc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crimea"
				},
				"name": "Crimea",
				"salience": 0.03538165,
				"type": "LOCATION"
			},
			{
				"name": "Commander",
				"salience": 0.033060707,
				"type": "PERSON"
			},
			{
				"name": "host",
				"salience": 0.03291519,
				"type": "PERSON"
			},
			{
				"name": "secession",
				"salience": 0.03291519,
				"type": "OTHER"
			},
			{
				"name": "mess",
				"salience": 0.03291519,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wg3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Navy"
				},
				"name": "Navy",
				"salience": 0.029964829,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hetman Sahaydachnyy",
				"salience": 0.019989025,
				"type": "LOCATION"
			},
			{
				"name": "increase",
				"salience": 0.015015971,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0118615115,
				"type": "ORGANIZATION"
			},
			{
				"name": "ships",
				"salience": 0.0108985575,
				"type": "OTHER"
			},
			{
				"name": "Ihor Voronchenko",
				"salience": 0.0106392335,
				"type": "PERSON"
			},
			{
				"name": "attack boats",
				"salience": 0.01057046,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet",
				"salience": 0.010447434,
				"type": "LOCATION"
			},
			{
				"name": "ship",
				"salience": 0.0094851125,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0076513914,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0073666084,
				"type": "OTHER"
			},
			{
				"name": "like",
				"salience": 0.0069964165,
				"type": "OTHER"
			},
			{
				"name": "hand-me-downs",
				"salience": 0.0069964165,
				"type": "LOCATION"
			},
			{
				"name": "navy",
				"salience": 0.0069753146,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qfh6c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_cruiser_Moskva"
				},
				"name": "Moskva",
				"salience": 0.0069274344,
				"type": "LOCATION"
			},
			{
				"name": "patrol boats",
				"salience": 0.006792068,
				"type": "OTHER"
			},
			{
				"name": "boats",
				"salience": 0.006792068,
				"type": "OTHER"
			},
			{
				"name": "counter",
				"salience": 0.006003167,
				"type": "OTHER"
			},
			{
				"name": "frigate",
				"salience": 0.0058131106,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05dx76",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukrainian_Navy"
				},
				"name": "Ukrainian Navy",
				"salience": 0.005728474,
				"type": "ORGANIZATION"
			},
			{
				"name": "counter",
				"salience": 0.005125668,
				"type": "OTHER"
			},
			{
				"name": "repairs",
				"salience": 0.0049396437,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.0049092514,
				"type": "OTHER"
			},
			{
				"name": "upgrades",
				"salience": 0.0049092514,
				"type": "OTHER"
			},
			{
				"name": "capacity",
				"salience": 0.0049092514,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0047263093,
				"type": "OTHER"
			},
			{
				"name": "flagship",
				"salience": 0.0047263093,
				"type": "OTHER"
			},
			{
				"name": "Frigates",
				"salience": 0.0046287845,
				"type": "OTHER"
			},
			{
				"name": "boats",
				"salience": 0.0041461447,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0040090065,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0040090065,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.0040090065,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.0040090065,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ps3l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Sea_Fleet"
				},
				"name": "Black Sea Fleet",
				"salience": 0.003491574,
				"type": "ORGANIZATION"
			},
			{
				"name": "ship",
				"salience": 0.003403732,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0033706725,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015h7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Sea"
				},
				"name": "Black Sea",
				"salience": 0.0033613797,
				"type": "LOCATION"
			},
			{
				"name": "desire",
				"salience": 0.0029957925,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.0025433134,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0021823642,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighting force",
				"salience": 0.0021823642,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0021277391,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.002100941,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.0017371546,
				"type": "OTHER"
			},
			{
				"name": "missile cruiser",
				"salience": 0.0016304611,
				"type": "PERSON"
			},
			{
				"name": "missile destroyer",
				"salience": 0.0016304611,
				"type": "OTHER"
			},
			{
				"name": "submarines",
				"salience": 0.0013143343,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2014/04/newkraine.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T05:08:16.515+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Navy Commander Says Fleet Will Counter Russia   \nThe host of one of Russia’s main fleets until the secession of Crimea, calling Ukraine’s own navy a mess would be an understatement. Built around aging Soviet hand-me-downs, the ships they did have largely defected along with Crimea. \nIndeed, while they have some small attack boats and the like, it would be fair to classify Ukraine’s entire “navy” as one ship, the Hetman Sahaydachnyy, their flagship, which is in the process of being repaired and refitted. Even this ship is just a frigate, but apart from coastal patrol boats and tug boats, it is what’s left. \nUkrainian Navy Commander Vice Admiral Ihor Voronchenko is playing up the repairs and upgrades to their ship as the beginning of a major increase in capacity which will allow them to “counter Russia” in the Black Sea. The US is bankrolling part of this effort with $30 million in aid. \nBy contrast, Russia’s Black Sea Fleet includes four Frigates, a guided missile destroyer, and an even larger guided missile cruiser, the Moskva, which is roughly four times the size of Ukraine’s ship. Beyond that, Russia has half a dozen submarines in the Black Sea, along with the usual smaller boats. \nNATO in general and the US in particular have talked up their desire to counter Russia’s Black Sea Fleet, but the Ukrainian Navy seems far from a realistic counter in and of itself, and the US funding appears primarily aimed at buying more influence with the Ukrainian government than at trying to develop their ship as a serious fighting force.  ",
		"thread_title": "US Pledges $30 Million to Rebuild Ukraine’s Navy",
		"title": "US Pledges $30 Million to Rebuild Ukraine’s Navy",
		"type": "bs",
		"uuid": "a8bd486f26b185b0017aa77d3cce319bfa8d43d7"
	},
	"-KhIjFGCfQNv1M0cbdfX": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T05:08:16.529+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "staffers",
				"salience": 0.23103514,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.16211413,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.14070676,
				"type": "LOCATION"
			},
			{
				"name": "Diplomats",
				"salience": 0.04897064,
				"type": "PERSON"
			},
			{
				"name": "Espionage",
				"salience": 0.045356914,
				"type": "EVENT"
			},
			{
				"name": "Tensions",
				"salience": 0.041077077,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0357043,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04f30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmir"
				},
				"name": "Kashmir",
				"salience": 0.035399426,
				"type": "LOCATION"
			},
			{
				"name": "diplomats",
				"salience": 0.0351403,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.025559384,
				"type": "LOCATION"
			},
			{
				"name": "nations",
				"salience": 0.017191166,
				"type": "ORGANIZATION"
			},
			{
				"name": "continuation",
				"salience": 0.015772948,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.014909117,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.014909117,
				"type": "OTHER"
			},
			{
				"name": "diplomats",
				"salience": 0.013941342,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.010095308,
				"type": "OTHER"
			},
			{
				"name": "expulsions",
				"salience": 0.009417893,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dlv0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Delhi"
				},
				"name": "New Dehli",
				"salience": 0.009211429,
				"type": "LOCATION"
			},
			{
				"name": "diplomats",
				"salience": 0.007150849,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.007091863,
				"type": "PERSON"
			},
			{
				"name": "staffer",
				"salience": 0.0069507607,
				"type": "PERSON"
			},
			{
				"name": "espionage",
				"salience": 0.006863554,
				"type": "OTHER"
			},
			{
				"name": "media reports",
				"salience": 0.006199676,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.0056749224,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.005371158,
				"type": "LOCATION"
			},
			{
				"name": "tensions",
				"salience": 0.005064739,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.005064739,
				"type": "ORGANIZATION"
			},
			{
				"name": "embassy",
				"salience": 0.0043874257,
				"type": "LOCATION"
			},
			{
				"name": "other",
				"salience": 0.0043874257,
				"type": "ORGANIZATION"
			},
			{
				"name": "espionage charges",
				"salience": 0.0043874257,
				"type": "OTHER"
			},
			{
				"name": "dust-ups",
				"salience": 0.0032795954,
				"type": "OTHER"
			},
			{
				"name": "awhile",
				"salience": 0.0032795954,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0023897067,
				"type": "EVENT"
			},
			{
				"name": "powers",
				"salience": 0.0023897067,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0023299311,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.002061917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01px3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Line_of_Control"
				},
				"name": "Line of Control",
				"salience": 0.002019926,
				"type": "OTHER"
			},
			{
				"name": "exchanges",
				"salience": 0.0017856719,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0017856719,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.0017856719,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0017856719,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/pakistan.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T05:08:16.529+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Accuses Indian Diplomats of Espionage Amid Growing Tensions   \nOn-again, off-again fighting between Indian and Pakistani forces in Kashmir looks to be spilling over into the diplomatic relationship between the two nations, as Pakistan has announced it will withdraw six staffers from their mission in New Dehli, and threaten to expel a number of Indian diplomats. \nThe six staffers withdrawn include at least four diplomats, and Pakistani officials went on to accuse the five Indian diplomats of espionage , naming them in media reports and threatening to expel them from the country outright. \nThis is a continuation of tit-for-tat expulsions which began last week, with both nations ordering a staffer out of the other’s embassy on espionage charges. The tensions are soaring with reports of heavy exchanges of fire in Kashmir over the weekend. \nIndia and Pakistan are never on the best of terms, but seem to get into these dust-ups once in awhile, usually around the Line of Control in Kashmir. The most recent fighting has been ongoing since August, and seems only to be getting worse as time goes on, raising concerns about a full-scale war between the two nuclear powers.  ",
		"thread_title": "Pakistan Recalls Diplomats From India, Threatens to Expel Indian Envoys",
		"title": "Pakistan Recalls Diplomats From India, Threatens to Expel Indian Envoys",
		"type": "bs",
		"uuid": "7e69bab2ee8058ae2e19153228e75917a9d8b57c"
	},
	"-KhIjFRcLHUBY44FgNWK": {
		"author": "Margaret Griffis",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T09:23:02.737+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0h7q0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abu_Bakr_al-Baghdadi"
				},
				"name": "Abu Bakr al-Baghdadi",
				"salience": 0.19795145,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.062453117,
				"type": "EVENT"
			},
			{
				"name": "group",
				"salience": 0.062453117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.05583578,
				"type": "LOCATION"
			},
			{
				"name": "first",
				"salience": 0.054213367,
				"type": "OTHER"
			},
			{
				"name": "confidence",
				"salience": 0.054213367,
				"type": "OTHER"
			},
			{
				"name": "audio recording",
				"salience": 0.03771605,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.033894807,
				"type": "ORGANIZATION"
			},
			{
				"name": "This Islamic State",
				"salience": 0.033573456,
				"type": "ORGANIZATION"
			},
			{
				"name": "militia",
				"salience": 0.019635748,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.018087152,
				"type": "PERSON"
			},
			{
				"name": "militiamen",
				"salience": 0.01604596,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.015953438,
				"type": "PERSON"
			},
			{
				"name": "villages",
				"salience": 0.014743105,
				"type": "LOCATION"
			},
			{
				"name": "Victims",
				"salience": 0.013316664,
				"type": "PERSON"
			},
			{
				"name": "militias",
				"salience": 0.013190844,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.011536593,
				"type": "OTHER"
			},
			{
				"name": "revenge attacks",
				"salience": 0.011536593,
				"type": "EVENT"
			},
			{
				"name": "civilians",
				"salience": 0.010782847,
				"type": "PERSON"
			},
			{
				"name": "villages",
				"salience": 0.010348913,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shi'ite",
				"salience": 0.0092860535,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.00842117,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.00842117,
				"type": "PERSON"
			},
			{
				"name": "Security forces",
				"salience": 0.008095745,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.008095745,
				"type": "LOCATION"
			},
			{
				"name": "torture",
				"salience": 0.0077941213,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0077941213,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.0077941213,
				"type": "OTHER"
			},
			{
				"name": "imprisonment",
				"salience": 0.0077941213,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni",
				"salience": 0.0071087833,
				"type": "OTHER"
			},
			{
				"name": "Sab'wai",
				"salience": 0.0071087833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07pgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tigris"
				},
				"name": "Tigris River",
				"salience": 0.0071087833,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.0068375496,
				"type": "PERSON"
			},
			{
				"name": "factory",
				"salience": 0.0066114306,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.006505879,
				"type": "ORGANIZATION"
			},
			{
				"name": "militiamen",
				"salience": 0.006136604,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.005513254,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05jpvk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sanya"
				},
				"name": "Samah",
				"salience": 0.004986547,
				"type": "LOCATION"
			},
			{
				"name": "Hammam al-Alil",
				"salience": 0.004986547,
				"type": "LOCATION"
			},
			{
				"name": "Khafsan",
				"salience": 0.004986547,
				"type": "PERSON"
			},
			{
				"name": "Munita",
				"salience": 0.004986547,
				"type": "PERSON"
			},
			{
				"name": "Qutba",
				"salience": 0.004986547,
				"type": "PERSON"
			},
			{
				"name": "searches",
				"salience": 0.004940713,
				"type": "EVENT"
			},
			{
				"name": "Airstrikes",
				"salience": 0.004940713,
				"type": "EVENT"
			},
			{
				"name": "Ayn Shahlub",
				"salience": 0.004701467,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shahlub",
				"salience": 0.004701467,
				"type": "PERSON"
			},
			{
				"name": "villages",
				"salience": 0.0046028183,
				"type": "LOCATION"
			},
			{
				"name": "militiamen",
				"salience": 0.004585709,
				"type": "PERSON"
			},
			{
				"name": "Um Izzam",
				"salience": 0.0040715816,
				"type": "PERSON"
			},
			{
				"name": "Bazzunnah",
				"salience": 0.0040715816,
				"type": "PERSON"
			},
			{
				"name": "Kharar",
				"salience": 0.0040715816,
				"type": "LOCATION"
			},
			{
				"name": "Khubairat",
				"salience": 0.0040715816,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mankar",
				"salience": 0.0040715816,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01w2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cairo"
				},
				"name": "Qahira",
				"salience": 0.0040715816,
				"type": "LOCATION"
			},
			{
				"name": "Rahmaniyah",
				"salience": 0.0040715816,
				"type": "PERSON"
			},
			{
				"name": "Ayn al Jahsh",
				"salience": 0.0040715816,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tal Saif al Athari",
				"salience": 0.0040715816,
				"type": "PERSON"
			},
			{
				"name": "direction",
				"salience": 0.003599321,
				"type": "OTHER"
			},
			{
				"name": "booby-traps",
				"salience": 0.003599321,
				"type": "OTHER"
			},
			{
				"name": "Gogjiali",
				"salience": 0.0035128845,
				"type": "PERSON"
			},
			{
				"name": "Gogjiali",
				"salience": 0.0035128845,
				"type": "OTHER"
			},
			{
				"name": "Min Gar",
				"salience": 0.0034531609,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0026891453,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0026891453,
				"type": "PERSON"
			},
			{
				"name": "highway",
				"salience": 0.0026891453,
				"type": "LOCATION"
			},
			{
				"name": "capture",
				"salience": 0.0026891453,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rvp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tal_Afar"
				},
				"name": "Tal Afar",
				"salience": 0.0022158253,
				"type": "LOCATION"
			},
			{
				"name": "Abbasiya",
				"salience": 0.002079717,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.001655324,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03hz03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Raqqah"
				},
				"name": "Raqqa",
				"salience": 0.001655324,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T09:23:02.737+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Share This Islamic State leader Abu Bakr al-Baghdadi released an audio recording , the first in almost a year, and expressed his confidence in the group’s eventual victory. Amnesty International warned that is has received reports of revenge attacks on civilians in villages near the Tigris River . Victims are accusing the Sab’wai tribal militia, which is a Sunni group, of torture and false imprisonment. There are also reports that Shi’ite militiamen are interrogating civilians on the western Mosul front. In Mosul , civilians by the hundreds were able to escape the Samah neighborhood. Security forces liberated Min Gar and four other villages near Hammam al-Alil. Khafsan, Munita and Qutba were also reported freed . Also captured were Abbasiya, Ayn Shahlub, Bazzunnah, Kharar, Khubairat, Mankar, Qahira, Rahmaniyah, Shahlub, Tal Saif al Athari, Um Izzam, and Ayn al Jahsh factory. Shi’ite militiamen reported the capture of a highway linking Mosul with Raqqa , Syria. At least 283 people were killed and 84 were wounded in recent violence: In Mosul , militants killed 150 civilians as they retreated from Gogjiali . Airstrikes left 100 militants dead and 40 wounded . Eight militants were killed during house-to-house searches in Gogjiali . East of Mosul in the direction of Tal Afar , Shi’ite militias encountered many booby-traps in villages they recaptured. At least 15 militiamen were killed and 30 were wounded .",
		"thread_title": "Sectarian War Crimes Reported near Mosul; 283 Killed in Iraq",
		"title": "Sectarian War Crimes Reported near Mosul; 283 Killed in Iraq",
		"type": "bs",
		"uuid": "0f79cbbd7220380b8ec2511152fee88ca5e568ce"
	},
	"-KhIjFdz47hmc0sb0XKd": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T19:28:56.610+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07jqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taliban"
				},
				"name": "Taliban",
				"salience": 0.24070418,
				"type": "ORGANIZATION"
			},
			{
				"name": "soldiers",
				"salience": 0.20036812,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.16042647,
				"type": "LOCATION"
			},
			{
				"name": "US Troops Under Fire",
				"salience": 0.03831689,
				"type": "PERSON"
			},
			{
				"name": "Attack",
				"salience": 0.037017565,
				"type": "EVENT"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.034547094,
				"type": "PERSON"
			},
			{
				"name": "special forces",
				"salience": 0.032150637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghan",
				"salience": 0.019936763,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.01708221,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.015158411,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.013384755,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.013384755,
				"type": "LOCATION"
			},
			{
				"name": "fighting",
				"salience": 0.013384755,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04kch_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ash_Carter"
				},
				"name": "Ash Carter",
				"salience": 0.011173338,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.010432893,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01g8_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kunduz"
				},
				"name": "Kunduz",
				"salience": 0.009866098,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.008989433,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sf4r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Nicholson_(East_India_Company_officer)"
				},
				"name": "John Nicholson",
				"salience": 0.008016939,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.006154625,
				"type": "PERSON"
			},
			{
				"name": "houses",
				"salience": 0.006154625,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.005558784,
				"type": "EVENT"
			},
			{
				"name": "siege",
				"salience": 0.005351876,
				"type": "EVENT"
			},
			{
				"name": "siege",
				"salience": 0.005351876,
				"type": "EVENT"
			},
			{
				"name": "airstrikes",
				"salience": 0.005351876,
				"type": "EVENT"
			},
			{
				"name": "governor",
				"salience": 0.004815337,
				"type": "PERSON"
			},
			{
				"name": "protests",
				"salience": 0.004815337,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.004815337,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.004815337,
				"type": "LOCATION"
			},
			{
				"name": "warplanes",
				"salience": 0.0046360213,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.0045404257,
				"type": "EVENT"
			},
			{
				"name": "coalition",
				"salience": 0.0041370536,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.003932844,
				"type": "LOCATION"
			},
			{
				"name": "houses",
				"salience": 0.0030689582,
				"type": "LOCATION"
			},
			{
				"name": "Bouz Kandahari",
				"salience": 0.0029665837,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.002939325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "families",
				"salience": 0.002939325,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.002939325,
				"type": "EVENT"
			},
			{
				"name": "civilians",
				"salience": 0.0027383647,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0027383647,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0024727508,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.0024727508,
				"type": "EVENT"
			},
			{
				"name": "condolences",
				"salience": 0.0024617177,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.002320983,
				"type": "EVENT"
			},
			{
				"name": "anything",
				"salience": 0.0021414899,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.0021414899,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0021414899,
				"type": "WORK_OF_ART"
			},
			{
				"name": "houses",
				"salience": 0.0020462137,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.0017933779,
				"type": "OTHER"
			},
			{
				"name": "justification",
				"salience": 0.0017047325,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.001600056,
				"type": "OTHER"
			},
			{
				"name": "cover",
				"salience": 0.001600056,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/07/afghan.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T19:28:56.610+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Attack Was Meant to 'Defend' US Troops Under Fire by Jason Ditz, November 03, 2016 Share This \nTwo US soldiers and four Afghan special forces were killed, and three other US soldiers wounded in heavy fighting with the Taliban this morning, as the Taliban attempted to surge into an area around the northern city of Kunduz. As they usually do, the troops called in airstrikes to “break the siege.” \nInstead of breaking the siege, the US warplanes pounded the village of Bouz Kandahari, destroying a number of houses and killing at least 30 civilians . 25 further civilians were wounded in the attack, fueling protests outside the governor’s office in Kunduz. \nNATO conceded immediately that the coalition was behind the airstrikes, but appeared relatively unrepentant about it, insisting all the civilian deaths were because the Taliban were using the houses for “cover,” which of course is not a legal justification for bombing the houses. \nUS commander Gen. John Nicholson issued a statement after the incidents, offering condolences to the families of the two US soldiers who were slain. Defense Secretary Ash Carter also said he was “saddened” by the deaths of the US troops, but neither offered much of anything in comments on the dozens of dead civilians. Last 5 posts by Jason Ditz",
		"thread_title": "US Airstrikes Kill at Least 30 Afghan Civilians Around Kunduz",
		"title": "US Airstrikes Kill at Least 30 Afghan Civilians Around Kunduz",
		"type": "bs",
		"uuid": "47588e180e08a68f38823f99ce0155aba88bf525"
	},
	"-KhIjFr15lnx_oLoiZkt": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T04:16:09.463+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "government",
				"salience": 0.2003702,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.14072521,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.12983169,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.060329687,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.05056436,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.04373493,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.040700175,
				"type": "EVENT"
			},
			{
				"name": "Clinton Campaign",
				"salience": 0.037067275,
				"type": "ORGANIZATION"
			},
			{
				"name": "Neo-McCarthyist Hysteria",
				"salience": 0.029090231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012ml0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Pilger"
				},
				"name": "John Pilger",
				"salience": 0.025235344,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.021621533,
				"type": "WORK_OF_ART"
			},
			{
				"name": "any",
				"salience": 0.018500252,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.012964342,
				"type": "EVENT"
			},
			{
				"name": "denial",
				"salience": 0.012897803,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.012556584,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.008682606,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0077892817,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.0077892817,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign",
				"salience": 0.0073449085,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.007078676,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.007071542,
				"type": "EVENT"
			},
			{
				"name": "claims",
				"salience": 0.0070351455,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.007003813,
				"type": "OTHER"
			},
			{
				"name": "hysteria",
				"salience": 0.00677327,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.00677327,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0060942005,
				"type": "OTHER"
			},
			{
				"name": "plot",
				"salience": 0.0060942005,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0060942005,
				"type": "EVENT"
			},
			{
				"name": "hacking",
				"salience": 0.0060942005,
				"type": "OTHER"
			},
			{
				"name": "talking point",
				"salience": 0.005829338,
				"type": "OTHER"
			},
			{
				"name": "denial",
				"salience": 0.005532237,
				"type": "OTHER"
			},
			{
				"name": "puppet",
				"salience": 0.004977291,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.004977291,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.004294996,
				"type": "OTHER"
			},
			{
				"name": "neo-McCarthyist",
				"salience": 0.004173256,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0037198865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0030656694,
				"type": "ORGANIZATION"
			},
			{
				"name": "allegations",
				"salience": 0.0030374902,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0029901906,
				"type": "EVENT"
			},
			{
				"name": "facts",
				"salience": 0.0027447154,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0027101587,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0025895794,
				"type": "WORK_OF_ART"
			},
			{
				"name": "focus",
				"salience": 0.0024180606,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.0023382956,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attention",
				"salience": 0.002327858,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0022906614,
				"type": "ORGANIZATION"
			},
			{
				"name": "speculation",
				"salience": 0.002024937,
				"type": "OTHER"
			},
			{
				"name": "leaks",
				"salience": 0.002024937,
				"type": "EVENT"
			},
			{
				"name": "media coverage",
				"salience": 0.002024937,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2010/06/assange.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T04:16:09.463+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Accuses Clinton Campaign of 'Neo-McCarthyist Hysteria' by Jason Ditz, November 03, 2016 Share This \nIn an interview with John Pilger, WikiLeaks founder Julian Assange has confirmed today that the organization did not get any of the hacked emails they published from the Russian government. WikiLeaks has a long-standing policy of not commenting on sources , so even such a denial is highly unusual. \nAssange insisted however that it was necessary to deny the claims, saying that Hillary Clinton’s camp “has been able to project a neo-McCarthyist hysteria” with false claims that Russia’s government in behind the hacked emails as part of a plot to rig next week’s election. \nRussia has long denied being involved in the hacking, but the Clinton campaign has run heavily on the issue, accusing Republican candidate Donald Trump of being a “puppet” of the Russian government, who they are trying to install by leaking embarrassing emails. \nThe campaign’s allegations have so far been pretty effective at limiting media coverage of the content of the leaks, with a lot more attention going to the speculation that Russia is plotting to “hack the vote” for Trump. Whether Assange’s straightforward denial is sufficient to bring the focus back to content remains to be seen, though the Democratic campaign is unlikely to give up what has been materially their main talking point over the past several months just because the facts don’t support it. Last 5 posts by Jason Ditz",
		"thread_title": "Assange Confirms: WikiLeaks Didn’t Get Emails From Russian Govt",
		"title": "Assange Confirms: WikiLeaks Didn’t Get Emails From Russian Govt",
		"type": "bs",
		"uuid": "06908df0e86b9ae22a52feac79776c641d8ec586"
	},
	"-KhIjG-DgniwCFiuGO5T": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T04:16:12.136+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "rebels",
				"salience": 0.14256819,
				"type": "PERSON"
			},
			{
				"name": "firing",
				"salience": 0.12321025,
				"type": "EVENT"
			},
			{
				"name": "rebels",
				"salience": 0.06808041,
				"type": "PERSON"
			},
			{
				"name": "Attacks",
				"salience": 0.05357248,
				"type": "EVENT"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.04999971,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.04999971,
				"type": "LOCATION"
			},
			{
				"name": "coalition",
				"salience": 0.04653363,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.040708337,
				"type": "LOCATION"
			},
			{
				"name": "New Ceasefire",
				"salience": 0.039772306,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.02886297,
				"type": "ORGANIZATION"
			},
			{
				"name": "ceasefire",
				"salience": 0.02674798,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.024457155,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.019398937,
				"type": "LOCATION"
			},
			{
				"name": "strikes",
				"salience": 0.019380068,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.015465358,
				"type": "LOCATION"
			},
			{
				"name": "Western Aleppo",
				"salience": 0.014457239,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.01436998,
				"type": "PERSON"
			},
			{
				"name": "details",
				"salience": 0.013449742,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.012546291,
				"type": "OTHER"
			},
			{
				"name": "neighborhoods",
				"salience": 0.011466032,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.010287269,
				"type": "PERSON"
			},
			{
				"name": "toll",
				"salience": 0.009979092,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.00980999,
				"type": "PERSON"
			},
			{
				"name": "ceasefire",
				"salience": 0.0096448595,
				"type": "EVENT"
			},
			{
				"name": "figures",
				"salience": 0.008755537,
				"type": "OTHER"
			},
			{
				"name": "offer",
				"salience": 0.007954387,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.007879123,
				"type": "EVENT"
			},
			{
				"name": "toll",
				"salience": 0.0077503743,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0073681213,
				"type": "OTHER"
			},
			{
				"name": "military forces",
				"salience": 0.0069734566,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.006713801,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.006713801,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.005756465,
				"type": "EVENT"
			},
			{
				"name": "anything",
				"salience": 0.005695555,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.005695555,
				"type": "OTHER"
			},
			{
				"name": "corridors",
				"salience": 0.005695555,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0055586444,
				"type": "LOCATION"
			},
			{
				"name": "offensives",
				"salience": 0.005442444,
				"type": "OTHER"
			},
			{
				"name": "gains",
				"salience": 0.0053702486,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0045789615,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0045350455,
				"type": "OTHER"
			},
			{
				"name": "counteroffensives",
				"salience": 0.004256825,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.004256825,
				"type": "EVENT"
			},
			{
				"name": "offensive",
				"salience": 0.0039658044,
				"type": "OTHER"
			},
			{
				"name": "gains",
				"salience": 0.0034915658,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0031014255,
				"type": "ORGANIZATION"
			},
			{
				"name": "posts",
				"salience": 0.0031014255,
				"type": "WORK_OF_ART"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0026759005,
				"type": "LOCATION"
			},
			{
				"name": "sides",
				"salience": 0.0026759005,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0023173164,
				"type": "PERSON"
			},
			{
				"name": "bystanders",
				"salience": 0.0023173164,
				"type": "PERSON"
			},
			{
				"name": "combatants",
				"salience": 0.0023173164,
				"type": "PERSON"
			},
			{
				"name": "fire",
				"salience": 0.0023173164,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T04:16:12.136+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Attacks Ramp Up Ahead of Russia's New Ceasefire by Jason Ditz, November 03, 2016 Share This \nA coalition of Syrian rebels led by the Nusra Front have been attacking government-held Western Aleppo since Friday, and escalated the strikes ahead of Russia’s new ceasefire. Reports out of the city suggest heavy firing against government-held neighborhoods. \nWhile details are still emerging, 12 civilians were reported slain in the firing, and around 200 others were wounded . This toll is independent of the toll from fighting on the ground between rebels and military forces, for which no official figures have yet been released. \nThe Russian ceasefire is intended to offer a 10-hour window during which the rebels can leave the city freely through two corridors, taking their weapons and anything else with them, though the rebels have already denounced both the offer and the ceasefire, insisting they will never surrender the city. \nBoth sides have been trading fire for months, often shelling one another’s neighborhoods, attacks which tend to kill a lot more civilian bystanders than combatants. They also trade offensives and counteroffensives, aiming to take control of the entire city. \nSo far, neither side has been able to get serious gains in the fighting over the city. Some smaller gains by the Syrian military last month appear to be getting reversed with this new offensive by the rebels from outside the city. Last 5 posts by Jason Ditz",
		"thread_title": "Rebels Escalate Attacks on Western Aleppo, Killing 12 Civilians",
		"title": "Rebels Escalate Attacks on Western Aleppo, Killing 12 Civilians",
		"type": "bs",
		"uuid": "f819a9ecdc625c49530be5ac30b1b9ce6b3a1753"
	},
	"-KhIjG7mUlPMiVeL-OHc": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T04:16:13.045+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "rebels",
				"salience": 0.3299108,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.116862185,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fastaqim Positions Overrun",
				"salience": 0.10834532,
				"type": "OTHER"
			},
			{
				"name": "Fighters",
				"salience": 0.047233514,
				"type": "PERSON"
			},
			{
				"name": "offensive",
				"salience": 0.047057483,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03694845,
				"type": "PERSON"
			},
			{
				"name": "faction",
				"salience": 0.035183754,
				"type": "OTHER"
			},
			{
				"name": "Fastaqim",
				"salience": 0.024017684,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.019805143,
				"type": "LOCATION"
			},
			{
				"name": "government forces",
				"salience": 0.019772988,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.018283129,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.018283129,
				"type": "PERSON"
			},
			{
				"name": "offensive",
				"salience": 0.016525105,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.014719419,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0143279815,
				"type": "LOCATION"
			},
			{
				"name": "infighting",
				"salience": 0.012872884,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.012383425,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.006590365,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0063452083,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fighting",
				"salience": 0.005826169,
				"type": "EVENT"
			},
			{
				"name": "positions",
				"salience": 0.0057309773,
				"type": "OTHER"
			},
			{
				"name": "moderates",
				"salience": 0.00515655,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.004964566,
				"type": "OTHER"
			},
			{
				"name": "factions",
				"salience": 0.0048622154,
				"type": "OTHER"
			},
			{
				"name": "government forces",
				"salience": 0.0043556383,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighting",
				"salience": 0.0043556383,
				"type": "EVENT"
			},
			{
				"name": "negotiations",
				"salience": 0.004211682,
				"type": "EVENT"
			},
			{
				"name": "majority",
				"salience": 0.004211682,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h3xpcx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Free_Syrian_Army"
				},
				"name": "Free Syrian Army",
				"salience": 0.0041815597,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fastaqim",
				"salience": 0.0039105024,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0036484124,
				"type": "ORGANIZATION"
			},
			{
				"name": "reports",
				"salience": 0.0035727215,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.0031478554,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.0031478554,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0030691365,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0029326628,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.0029326628,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.0025943115,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighters",
				"salience": 0.002371984,
				"type": "PERSON"
			},
			{
				"name": "meantime",
				"salience": 0.0022934957,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0022934957,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rebel coalition",
				"salience": 0.0022934957,
				"type": "ORGANIZATION"
			},
			{
				"name": "positions",
				"salience": 0.0019788337,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0017136693,
				"type": "ORGANIZATION"
			},
			{
				"name": "leadership",
				"salience": 0.0017136693,
				"type": "OTHER"
			},
			{
				"name": "chunk",
				"salience": 0.0017136693,
				"type": "OTHER"
			},
			{
				"name": "losses",
				"salience": 0.0013469092,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T04:16:13.045+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Fastaqim Positions Overrun, Fighters Detained by Jason Ditz, November 03, 2016 Share This \nWith the Nusra Front-led rebels in Aleppo still engaged in a major offensive against government forces in the western part of the city, they also found time to launch a whole separate offensive against another faction of rebels with which they used to be allied in the city. \nNusra and its still remaining allies attacked and overran a number of positions belonging to the Fastaqim force, which like the other Nusra allies, is presented as “moderates” who are nominally aligned with the Free Syrian Army (FSA) as well as the al-Qaeda-linked Nusra. \nFighting was reported to have ended and there are negotiations ongoing among the factions, though some reports suggest Fastaqim lost the majority of their positions and that a large chunk of their fighters have been detained, though the group’s leadership downplayed the losses. \nIt’s unclear how significant the infighting will end up being in the context of ongoing fighting with government forces around Aleppo, though it certainly raises questions about the unity among the rebel coalition within the city, and whether the larger forces are going to turn on any other smaller allies in the meantime. Last 5 posts by Jason Ditz",
		"thread_title": "Nusra Front, Allies Attack Fellow Syrian Rebels in Aleppo",
		"title": "Nusra Front, Allies Attack Fellow Syrian Rebels in Aleppo",
		"type": "bs",
		"uuid": "3f909b737e291249ada52e8b57d3e97bffa206a2"
	},
	"-KhIjGJt4kJtQgIui5lo": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T04:16:14.946+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.21332957,
				"type": "LOCATION"
			},
			{
				"name": "Hayder Abadi",
				"salience": 0.13653879,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.058693867,
				"type": "LOCATION"
			},
			{
				"name": "comments",
				"salience": 0.055882305,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.052145768,
				"type": "PERSON"
			},
			{
				"name": "state television",
				"salience": 0.048522145,
				"type": "OTHER"
			},
			{
				"name": "Iraq Will Deal With Turkey",
				"salience": 0.041457266,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Erdogan",
				"salience": 0.039881554,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.035802048,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/058w0q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Enemy_combatant"
				},
				"name": "Enemy",
				"salience": 0.034666613,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.023718402,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.020179644,
				"type": "EVENT"
			},
			{
				"name": "military confrontation",
				"salience": 0.020179644,
				"type": "EVENT"
			},
			{
				"name": "border",
				"salience": 0.018590495,
				"type": "LOCATION"
			},
			{
				"name": "enemy",
				"salience": 0.0157538,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.014116734,
				"type": "PERSON"
			},
			{
				"name": "ground troops",
				"salience": 0.012733635,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.008167909,
				"type": "WORK_OF_ART"
			},
			{
				"name": "defense officials",
				"salience": 0.008065249,
				"type": "PERSON"
			},
			{
				"name": "developments",
				"salience": 0.0072564743,
				"type": "EVENT"
			},
			{
				"name": "region",
				"salience": 0.0072564743,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0072564743,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.006986186,
				"type": "OTHER"
			},
			{
				"name": "artillery",
				"salience": 0.006986186,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.006986186,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.006128958,
				"type": "LOCATION"
			},
			{
				"name": "loss",
				"salience": 0.0059263147,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0059263147,
				"type": "OTHER"
			},
			{
				"name": "refusal",
				"salience": 0.0059263147,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.0058080847,
				"type": "PERSON"
			},
			{
				"name": "relations",
				"salience": 0.005423724,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0051877974,
				"type": "OTHER"
			},
			{
				"name": "sake",
				"salience": 0.004428962,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.004428962,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.004428962,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.004428962,
				"type": "OTHER"
			},
			{
				"name": "equal",
				"salience": 0.004428962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.004145897,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0037258347,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04k4l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/League_of_Nations"
				},
				"name": "League of Nations",
				"salience": 0.0036499545,
				"type": "ORGANIZATION"
			},
			{
				"name": "principle",
				"salience": 0.0032266465,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.0032266465,
				"type": "OTHER"
			},
			{
				"name": "rise",
				"salience": 0.0032266465,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0032266465,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.002727163,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0024107802,
				"type": "ORGANIZATION"
			},
			{
				"name": "ruling",
				"salience": 0.0024107802,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0024107802,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0019864854,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T04:16:14.946+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Says Iraq Will Deal With Turkey 'As an Enemy' by Jason Ditz, November 03, 2016 Share This \nIn comments broadcast on Iraqi state television, Prime Minister Hayder Abadi confirmed that his nation is “ready” for a full-scale military confrontation with neighboring Turkey, insisting Iraq doesn’t necessarily want war, but is prepared to deal with Turkey “as an enemy.” \nThe comments come just over a day after Turkey began massing tanks and artillery along the Iraqi border, which Turkish defense officials insisted were simply aimed to prepare for potential “ developments in the region .” \nThe two nations have had testy relations for over a year, however, related to a number of Turkish ground troops deployed in Iraq without Abadi’s permission, and their refusal to leave. Turkish President Erdogan has claimed Turkey retains an interest in Mosul, whose loss to a League of Nations ruling in the 1920s they don’t recognize, and Erdogan has also warned that Abadi and the Iraqi government are not “at his level” where they can speak to him as an equal on the matter. \nThe US has been trying to keep the two nations at least civil for the sake of the Mosul invasion, but claims by Pentagon officials that the two had an agreement in principle to work together clearly never panned out, and tensions are still on the rise. Last 5 posts by Jason Ditz",
		"thread_title": "Iraq PM Threatens War Over Turkey’s Military Buildup",
		"title": "Iraq PM Threatens War Over Turkey’s Military Buildup",
		"type": "bs",
		"uuid": "03702848a0914899c4f5e8e7836659b10757a5b4"
	},
	"-KhIjGTHe5aEzfivUYEj": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T04:16:18.554+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.34051862,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h7q0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abu_Bakr_al-Baghdadi"
				},
				"name": "Abu Bakr al-Baghdadi",
				"salience": 0.24305184,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.11754986,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.030611811,
				"type": "PERSON"
			},
			{
				"name": "audio recording",
				"salience": 0.028484588,
				"type": "OTHER"
			},
			{
				"name": "prelude",
				"salience": 0.027045652,
				"type": "OTHER"
			},
			{
				"name": "Comments Prove Baghdadi Losing Control",
				"salience": 0.020350793,
				"type": "OTHER"
			},
			{
				"name": "Pentagon Claims",
				"salience": 0.01765159,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.011846321,
				"type": "ORGANIZATION"
			},
			{
				"name": "offensive",
				"salience": 0.011846321,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.011846321,
				"type": "OTHER"
			},
			{
				"name": "confidence",
				"salience": 0.011846321,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.011101038,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fighter",
				"salience": 0.008626915,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.008013925,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God.",
				"salience": 0.0073110242,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02843s6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khan_al_Baghdadi"
				},
				"name": "Baghdadi",
				"salience": 0.007294972,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.006276916,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0044688606,
				"type": "LOCATION"
			},
			{
				"name": "surrender",
				"salience": 0.004314102,
				"type": "OTHER"
			},
			{
				"name": "caliphate",
				"salience": 0.004259863,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.004259863,
				"type": "EVENT"
			},
			{
				"name": "territory",
				"salience": 0.004259863,
				"type": "LOCATION"
			},
			{
				"name": "end",
				"salience": 0.004259863,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09w3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pentagon"
				},
				"name": "Pentagon",
				"salience": 0.0041308543,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.004101192,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.004101192,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.004101192,
				"type": "LOCATION"
			},
			{
				"name": "fight",
				"salience": 0.004016604,
				"type": "EVENT"
			},
			{
				"name": "suicide attacks",
				"salience": 0.0037767442,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.0032389725,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.003002022,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.002624107,
				"type": "LOCATION"
			},
			{
				"name": "rivers",
				"salience": 0.0025999914,
				"type": "LOCATION"
			},
			{
				"name": "wars",
				"salience": 0.0025999914,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.0025999914,
				"type": "LOCATION"
			},
			{
				"name": "infighting",
				"salience": 0.001992661,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0019590175,
				"type": "LOCATION"
			},
			{
				"name": "blood flow",
				"salience": 0.0019183352,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0018941804,
				"type": "WORK_OF_ART"
			},
			{
				"name": "unbelievers",
				"salience": 0.0014152317,
				"type": "PERSON"
			},
			{
				"name": "havoc",
				"salience": 0.0014152317,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.0014152317,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T04:16:18.554+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Pentagon Claims Comments Prove Baghdadi Losing Control by Jason Ditz, November 03, 2016 Share This \nIn a newly released audio recording, ISIS leader Abu Bakr al-Baghdadi expressed confidence that his forces would succeed in defending Mosul from an ongoing offensive by what he referred to as “enemies of God.,” saying he is convinced this is the prelude to victory. \nMosul is ISIS’ largest city, with the metro area home to about 1.5 million people. It is their last major city within Iraqi territory, and the US has presented their imminent defeat in the city as spelling the effective end to the ISIS caliphate. \nBaghdadi insisted there could be no surrender in the fight, a statement which is literally true since the US has insisted they intend to kill every ISIS fighter who attempts to flee the city with airstrikes Baghdadi suggested there would be retaliatory suicide attacks abroad that would wreak havoc on “unbelievers,” and “make their blood flow as rivers.” \nThe Pentagon, always upbeat about wars everywhere, said Baghdadi’s confident statement proved he is losing control of ISIS in general, and that he was desperately trying to prevent infighting, adding “we don’t believe it is going to work.” Last 5 posts by Jason Ditz",
		"thread_title": "ISIS Leader Confident in Mosul Defense, Rules Out Retreat",
		"title": "ISIS Leader Confident in Mosul Defense, Rules Out Retreat",
		"type": "bs",
		"uuid": "eecc7fac18c89dd24608c211cbac7fef55595796"
	},
	"-KhIjGZXhP21oulnal0y": {
		"author": "Daniel McAdams",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T04:29:00.180+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.5077849,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.11542166,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.088933945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.085056566,
				"type": "LOCATION"
			},
			{
				"name": "pace",
				"salience": 0.035422754,
				"type": "OTHER"
			},
			{
				"name": "military action",
				"salience": 0.035422754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.021965114,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.012839257,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.012109164,
				"type": "ORGANIZATION"
			},
			{
				"name": "radicals",
				"salience": 0.011957527,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.011576821,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapon",
				"salience": 0.010494339,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.010494339,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.009529212,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Assad",
				"salience": 0.006472441,
				"type": "PERSON"
			},
			{
				"name": "radicals",
				"salience": 0.0049392767,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05vz3zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Soviet_Union"
				},
				"name": "Soviet",
				"salience": 0.0048388187,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0048388187,
				"type": "LOCATION"
			},
			{
				"name": "policy",
				"salience": 0.0042782957,
				"type": "OTHER"
			},
			{
				"name": "The Ron Paul Institute for Peace & Prosperity",
				"salience": 0.0035262452,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0020977613,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T04:29:00.180+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "If ISIS is such a mortal threat to the United States, why has US military action in Iraq and Syria been proceeding at such a leisurely pace? Is it possible that ISIS and al-Qaeda in Syria are being used — or even supported — by the US and its allies as a “regime change” weapon against Syria’s Assad government? The US pursued this policy before, when it used Saudi-trained radicals to fight a Soviet-backed government in Afghanistan. Those radicals became al-Qaeda…\n\nReprinted from The Ron Paul Institute for Peace & Prosperity . \n",
		"thread_title": "Ron Paul on ISIS: Mortal Threat or Paper Tiger?",
		"title": "Ron Paul on ISIS: Mortal Threat or Paper Tiger?",
		"type": "bs",
		"uuid": "b2cc917e2d4411870405c2e72b4ee5e9bdca712a"
	},
	"-KhIjGjl6OF9ApwtjwLp": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T04:39:51.161+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/082lj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan_Self-Defense_Forces"
				},
				"name": "SDF",
				"salience": 0.35254702,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.11718685,
				"type": "ORGANIZATION"
			},
			{
				"name": "ISIS Capital",
				"salience": 0.10477183,
				"type": "ORGANIZATION"
			},
			{
				"name": "force",
				"salience": 0.04243668,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03hz03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Raqqah"
				},
				"name": "Raqqa",
				"salience": 0.0404156,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.0359137,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.03441402,
				"type": "WORK_OF_ART"
			},
			{
				"name": "faction",
				"salience": 0.034195475,
				"type": "OTHER"
			},
			{
				"name": "Only Force' That",
				"salience": 0.02388795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.020722441,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.01785156,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Kurdish YPG",
				"salience": 0.017408922,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.016046287,
				"type": "EVENT"
			},
			{
				"name": "capital city",
				"salience": 0.013911334,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.012313187,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.010861704,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0100255385,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.008780195,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.006693357,
				"type": "ORGANIZATION"
			},
			{
				"name": "operation",
				"salience": 0.005777032,
				"type": "EVENT"
			},
			{
				"name": "YPG forces",
				"salience": 0.005280654,
				"type": "PERSON"
			},
			{
				"name": "strikes",
				"salience": 0.004817996,
				"type": "EVENT"
			},
			{
				"name": "rebel factions",
				"salience": 0.0047186436,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0044657784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.004342389,
				"type": "LOCATION"
			},
			{
				"name": "warning",
				"salience": 0.004191966,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.003934903,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.003526911,
				"type": "PERSON"
			},
			{
				"name": "offensives",
				"salience": 0.003526911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.003436714,
				"type": "LOCATION"
			},
			{
				"name": "warplanes",
				"salience": 0.0033584535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurds",
				"salience": 0.0030829785,
				"type": "PERSON"
			},
			{
				"name": "other",
				"salience": 0.0030546496,
				"type": "ORGANIZATION"
			},
			{
				"name": "possibility",
				"salience": 0.0029782502,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0029692545,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.0025697576,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0022461435,
				"type": "LOCATION"
			},
			{
				"name": "combat",
				"salience": 0.002225494,
				"type": "EVENT"
			},
			{
				"name": "exclusion",
				"salience": 0.002225494,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.002225494,
				"type": "WORK_OF_ART"
			},
			{
				"name": "offensive",
				"salience": 0.0019201323,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0013701766,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.0013701766,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/07/syria18.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T04:39:51.161+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Insists SDF the 'Only Force' That Will Invade the ISIS Capital by Jason Ditz, November 03, 2016 Share This \nA new statement from the Syrian Democratic Forces (SDF), a faction which is dominated by the Kurdish YPG, has affirmed that not only will they be participating in the invasion of the ISIS capital city of Raqqa, as previously announced by the US, but that they intend to be the “ only force that will take part in the operation .” \nEven more noteworthy, since the Turkish government has over the past two months repeatedly publicly warned the US that the Kurds mustn’t be allowed to participate in the Raqqa operation at all, the SDF’s statement offered its own warning to the US that Turkey can’t have any role. \nTurkey’s military and its allied rebel factions have been invading northern Syria for some time now, mostly fighting ISIS as well, but Turkish warplanes have repeatedly attacked Kurdish YPG forces as well, mostly notably a few weeks ago when they launched strikes against YPG forces who were engaged in an offensive against ISIS at the time. \nIt is unsurprising, then, that neither side is comfortable working with the other in offensives, but still raises the possibility of the two getting into direct combat over who gets to attack Raqqa. This is particularly true since Turkey is still resenting their exclusion from Iraq’s invasion of Mosul. Last 5 posts by Jason Ditz",
		"thread_title": "Syrian Kurds Warn US: Turkey Can’t Be Involved in Raqqa Invasion",
		"title": "Syrian Kurds Warn US: Turkey Can’t Be Involved in Raqqa Invasion",
		"type": "bs",
		"uuid": "b9e67e201e599efc53578f36744997acff47853f"
	},
	"-KhIjGsLGoewVq0svDkZ": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T04:49:57.291+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.46432126,
				"type": "LOCATION"
			},
			{
				"name": "Hadi",
				"salience": 0.121447735,
				"type": "PERSON"
			},
			{
				"name": "peace plan",
				"salience": 0.07911361,
				"type": "OTHER"
			},
			{
				"name": "figurehead position",
				"salience": 0.07298535,
				"type": "OTHER"
			},
			{
				"name": "Sources",
				"salience": 0.031107858,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.025146198,
				"type": "PERSON"
			},
			{
				"name": "Saudi Leadership Endorses Plan",
				"salience": 0.021319656,
				"type": "OTHER"
			},
			{
				"name": "creation",
				"salience": 0.020413626,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.014523031,
				"type": "ORGANIZATION"
			},
			{
				"name": "unity government",
				"salience": 0.012445535,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.012445535,
				"type": "ORGANIZATION"
			},
			{
				"name": "arrival",
				"salience": 0.009753634,
				"type": "EVENT"
			},
			{
				"name": "start",
				"salience": 0.009753634,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.008322197,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.0076297964,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0065100575,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shi'ite Houthis",
				"salience": 0.006022865,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.005178479,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.004985975,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.004486699,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0043661054,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.004052464,
				"type": "OTHER"
			},
			{
				"name": "leadership position",
				"salience": 0.003804255,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0035106165,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0035106165,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0033799193,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0033799193,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.002881378,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.0028673725,
				"type": "OTHER"
			},
			{
				"name": "peace talks",
				"salience": 0.0028673725,
				"type": "EVENT"
			},
			{
				"name": "reports",
				"salience": 0.0028673725,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0027399622,
				"type": "PERSON"
			},
			{
				"name": "pressure",
				"salience": 0.0025719514,
				"type": "OTHER"
			},
			{
				"name": "peace deal",
				"salience": 0.0021431288,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.0021431288,
				"type": "PERSON"
			},
			{
				"name": "coalition",
				"salience": 0.0021431288,
				"type": "ORGANIZATION"
			},
			{
				"name": "term",
				"salience": 0.0019863332,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0019613374,
				"type": "EVENT"
			},
			{
				"name": "outcry",
				"salience": 0.0015614764,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0015614764,
				"type": "WORK_OF_ART"
			},
			{
				"name": "situation",
				"salience": 0.0014909718,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0012979025,
				"type": "PERSON"
			},
			{
				"name": "candidate vote",
				"salience": 0.0011667216,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0011667216,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "United Arab Emirates",
				"salience": 0.0006656429,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/08/yemen.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T04:49:57.291+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Sources Claim 'Most' of Saudi Leadership Endorses Plan by Jason Ditz, November 03, 2016 Share This \nThe UN peace plan for Yemen, which involves the creation of an interim unity government, appeared dead on arrival when it was endorsed by the Shi’ite Houthis as a promising start, but immediately condemned by the Saudi-backed Hadi government. New reports, however, suggest the Saudis may be breathing new life into the matter. \nPublicly, the Saudi government has not commented on the plan yet, but those familiar with the situation say that most if not all of the leadership supports the plan , and that they’ve been quietly pushing Hadi in the direction of allowing it as a basis for peace talks. \nThe plan would allow Hadi to hold a nominal leadership position, but insists it would be entirely a figurehead position with little to no real power. Hadi became Yemen’s president in 2012 in a one candidate vote, and unilaterally extended his two-year term in office beyond that date. \nThe United Arab Emirates has already publicly backed the peace deal, becoming the first member of the Saudi coalition to do so. Saudi Arabia attacked Yemen in March of 2015, vowing to reinstall Hadi as president after he resigned two months prior. The ongoing war has caused growing international outcry, however, and there is more pressure to resolve the situation. Last 5 posts by Jason Ditz",
		"thread_title": "Report: Saudis Quietly Backing UN Peace Plan for Yemen",
		"title": "Report: Saudis Quietly Backing UN Peace Plan for Yemen",
		"type": "bs",
		"uuid": "4e2c88a36e47d1b3f58d8e102ac62ef7faf76f6f"
	},
	"-KhIjH10t9j3MtQcidBg": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T05:13:50.776+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.296857,
				"type": "LOCATION"
			},
			{
				"name": "Share This The US",
				"salience": 0.13189737,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.060860306,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.048292432,
				"type": "PERSON"
			},
			{
				"name": "Plan",
				"salience": 0.041677054,
				"type": "OTHER"
			},
			{
				"name": "Definition",
				"salience": 0.037718117,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03519921,
				"type": "PERSON"
			},
			{
				"name": "Officials",
				"salience": 0.030532029,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.029157318,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.02557947,
				"type": "PERSON"
			},
			{
				"name": "combat troops",
				"salience": 0.02557947,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.02557947,
				"type": "PERSON"
			},
			{
				"name": "combat",
				"salience": 0.018818187,
				"type": "OTHER"
			},
			{
				"name": "John Dorrian",
				"salience": 0.015942447,
				"type": "PERSON"
			},
			{
				"name": "roadside bombing",
				"salience": 0.013631821,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.013631821,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.013631821,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.013154665,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.009142897,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.00882332,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurdish",
				"salience": 0.008414485,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.006267355,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.006079447,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.006034128,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.005695562,
				"type": "LOCATION"
			},
			{
				"name": "troops",
				"salience": 0.0056473976,
				"type": "PERSON"
			},
			{
				"name": "Administration",
				"salience": 0.00549855,
				"type": "ORGANIZATION"
			},
			{
				"name": "Col.",
				"salience": 0.0054498175,
				"type": "PERSON"
			},
			{
				"name": "definition",
				"salience": 0.0046234448,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.0041161813,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0041161813,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0040047066,
				"type": "OTHER"
			},
			{
				"name": "outskirts",
				"salience": 0.0040047066,
				"type": "LOCATION"
			},
			{
				"name": "suburbs",
				"salience": 0.0040047066,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0039220876,
				"type": "PERSON"
			},
			{
				"name": "roles",
				"salience": 0.002992976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0029081162,
				"type": "ORGANIZATION"
			},
			{
				"name": "advisers",
				"salience": 0.0028451274,
				"type": "OTHER"
			},
			{
				"name": "combat areas",
				"salience": 0.002517863,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0024665887,
				"type": "ORGANIZATION"
			},
			{
				"name": "combat units",
				"salience": 0.0021805447,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0021805447,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.0021805447,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0018813451,
				"type": "LOCATION"
			},
			{
				"name": "ground",
				"salience": 0.0016292193,
				"type": "OTHER"
			},
			{
				"name": "boots",
				"salience": 0.0016292193,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0010029332,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T05:13:50.776+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Officials Concede Plan Could Change, as Could Definition of 'Mosul' by Jason Ditz, November 03, 2016 Share This \nThe US has made much of its troops involved in the Mosul invasion not being “combat” troops, even though one of the troops was killed in a roadside bombing while embedded with Kurdish combat troops. As the troops near Mosul, however, Pentagon spokesman Col. John Dorrian insists there are no plans so far for troops to enter Mosul. \nCol. Dorrian insisted that Iraq’s government has said “it’s just gonna be their forces.” He did, however, say he didn’t want to say US troops would “never” be involved, insisting that the plans could change at any time. \nOther officials, quoted anonymously by Reuters , suggested that the definition of Mosul could also change, saying that suburbs and parts of the city’s outskirts could easily be redefined as not Mosul, allowing US troops to enter those areas without having to technically “enter Mosul.” \nThe Obama Administration initially promised “no boots on the ground” in Iraq, but with some 6,000 such troops in Iraq, they’ve seen been trying desperately to claim they are in “non-combat” roles. This too has been difficult to sell, with a number of those troops embedded in combat units. Those troops are nominally “advisers,” but are regularly being put into combat areas. Last 5 posts by Jason Ditz",
		"thread_title": "Pentagon: No Plan ‘So Far’ For US Troops to Enter Mosul",
		"title": "Pentagon: No Plan ‘So Far’ For US Troops to Enter Mosul",
		"type": "bs",
		"uuid": "925bb596654278dc831d854ead8dfeb75c890213"
	},
	"-KhIjH8gNnUvbYC8ofiZ": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T19:51:25.256+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "soldiers",
				"salience": 0.3147614,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.17430069,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordanian",
				"salience": 0.11843444,
				"type": "LOCATION"
			},
			{
				"name": "Vehicle",
				"salience": 0.0520802,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.03614922,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.02894991,
				"type": "PERSON"
			},
			{
				"name": "base security",
				"salience": 0.028035598,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03c79",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gate"
				},
				"name": "Gate",
				"salience": 0.026599133,
				"type": "LOCATION"
			},
			{
				"name": "fire",
				"salience": 0.018787982,
				"type": "EVENT"
			},
			{
				"name": "gate",
				"salience": 0.017880818,
				"type": "LOCATION"
			},
			{
				"name": "training operation",
				"salience": 0.016160896,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.014011568,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.012486111,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.011432455,
				"type": "EVENT"
			},
			{
				"name": "al-Jafr Air Base",
				"salience": 0.011049575,
				"type": "LOCATION"
			},
			{
				"name": "vehicle",
				"salience": 0.00788159,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "soldier",
				"salience": 0.007161031,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.006713775,
				"type": "EVENT"
			},
			{
				"name": "incident",
				"salience": 0.006713775,
				"type": "EVENT"
			},
			{
				"name": "incident",
				"salience": 0.006713775,
				"type": "EVENT"
			},
			{
				"name": "incident",
				"salience": 0.0066704457,
				"type": "EVENT"
			},
			{
				"name": "gate",
				"salience": 0.0064438065,
				"type": "LOCATION"
			},
			{
				"name": "air base",
				"salience": 0.005263792,
				"type": "LOCATION"
			},
			{
				"name": "cut",
				"salience": 0.0052366946,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.005041729,
				"type": "OTHER"
			},
			{
				"name": "infiltration",
				"salience": 0.005041729,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.004854001,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempt",
				"salience": 0.004822639,
				"type": "OTHER"
			},
			{
				"name": "contractors",
				"salience": 0.004822639,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.004519338,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.004117821,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0038337954,
				"type": "OTHER"
			},
			{
				"name": "trainers",
				"salience": 0.0035534017,
				"type": "PERSON"
			},
			{
				"name": "details",
				"salience": 0.0030776358,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.0030776358,
				"type": "PERSON"
			},
			{
				"name": "fire",
				"salience": 0.0030141128,
				"type": "EVENT"
			},
			{
				"name": "posts",
				"salience": 0.002242295,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0018952362,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0016753932,
				"type": "ORGANIZATION"
			},
			{
				"name": "misunderstanding",
				"salience": 0.0016753932,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0016753932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.0011411231,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2010/09/jordan-map.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T19:51:25.256+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.7,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Jordan Claims US Vehicle 'Failed to Stop' at Gate by Jason Ditz, November 04, 2016 Share This \nThree US soldiers assigned to a training operation in Jordan were killed today by Jordanian troops at the al-Jafr Air Base, when base security opened fire on them near the gate. One Jordanian soldier was also reported wounded in the incident. \nUnlike other recent incidents of US soldiers killed by allies, this incident was not chalked up to infiltration by rogue elements. Rather, Jordanian officials blamed the US soldiers, claiming their vehicle failed to stop at the gate to the air base and security reacted. \nThe Pentagon was a little less cut and dry on the matter, saying they can’t say for sure if it was a “deliberate” attempt to kill US soldiers or some sort of misunderstanding. They say they are working with the Jordanian government to gather more details. \nUS trainers in Jordan are there to train Syrian rebels, an operation which has been ongoing for years. Last year in November, two US contractors were killed in another incident in which a police officer opened fire on them. Last 5 posts by Jason Ditz",
		"thread_title": "Jordan Troops Kill Three US Military Trainers at Air Base",
		"title": "Jordan Troops Kill Three US Military Trainers at Air Base",
		"type": "bs",
		"uuid": "7651cc6f2ecc40df1c576ceeb519132bda67f6ec"
	},
	"-KhIjHL-Vd1brzjg36w0": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T03:05:42.569+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.456885,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.22128595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.054477207,
				"type": "PERSON"
			},
			{
				"name": "hacks",
				"salience": 0.021083565,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.020056145,
				"type": "OTHER"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.019667175,
				"type": "PERSON"
			},
			{
				"name": "allegations",
				"salience": 0.0182945,
				"type": "OTHER"
			},
			{
				"name": "military cyber attacks",
				"salience": 0.013391626,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/012gx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Biden"
				},
				"name": "Joe Biden",
				"salience": 0.013233732,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.011461267,
				"type": "ORGANIZATION"
			},
			{
				"name": "Massive Election Day Hacking Offensive",
				"salience": 0.011318014,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.010951777,
				"type": "EVENT"
			},
			{
				"name": "pretext",
				"salience": 0.00813601,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0066348976,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0058218227,
				"type": "ORGANIZATION"
			},
			{
				"name": "involvement",
				"salience": 0.0053529087,
				"type": "OTHER"
			},
			{
				"name": "revenge attacks",
				"salience": 0.0051382477,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.004680309,
				"type": "ORGANIZATION"
			},
			{
				"name": "involvement",
				"salience": 0.00448475,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0036309669,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0036309669,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0032857596,
				"type": "EVENT"
			},
			{
				"name": "infrastructure",
				"salience": 0.003147047,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.003147047,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.0030801771,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0030297884,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.00301628,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.0030101996,
				"type": "OTHER"
			},
			{
				"name": "electricity grid",
				"salience": 0.0029038829,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0028353783,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0027644876,
				"type": "EVENT"
			},
			{
				"name": "command systems",
				"salience": 0.0027257656,
				"type": "OTHER"
			},
			{
				"name": "telecommunications networks",
				"salience": 0.0027257656,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0027257656,
				"type": "OTHER"
			},
			{
				"name": "choosing",
				"salience": 0.0026241727,
				"type": "EVENT"
			},
			{
				"name": "situation",
				"salience": 0.0026241727,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.0022258481,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.002170172,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0021524606,
				"type": "OTHER"
			},
			{
				"name": "military attacks",
				"salience": 0.002065942,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.002065942,
				"type": "EVENT"
			},
			{
				"name": "infrastructure",
				"salience": 0.0019205381,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.0018343539,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.0016786703,
				"type": "ORGANIZATION"
			},
			{
				"name": "everything",
				"salience": 0.0016632371,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0016632371,
				"type": "EVENT"
			},
			{
				"name": "plot",
				"salience": 0.0016632371,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0016632371,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0016632371,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.0016160562,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacks",
				"salience": 0.001543702,
				"type": "EVENT"
			},
			{
				"name": "scale",
				"salience": 0.0013990985,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0012530773,
				"type": "PERSON"
			},
			{
				"name": "posts",
				"salience": 0.0012115925,
				"type": "WORK_OF_ART"
			},
			{
				"name": "willingness",
				"salience": 0.00090517156,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00090517156,
				"type": "ORGANIZATION"
			},
			{
				"name": "anything",
				"salience": 0.00090517156,
				"type": "OTHER"
			},
			{
				"name": "retaliation",
				"salience": 0.00090517156,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00090517156,
				"type": "OTHER"
			},
			{
				"name": "comfort",
				"salience": 0.0007579516,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2011/11/Russia.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T03:05:42.569+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Pentagon Preparing for Massive Election Day Hacking Offensive by Jason Ditz, November 04, 2016 Share This \nThis US has publicly threatened ‘retaliatory’ hacks against Russia for weeks now, based on allegations that Russia may have been involved in certain hacks related to Democratic presidential candidate Hillary Clinton. Russia denied involvement and the US government has been unable to produce any concrete evidence of Russian involvement. \nVice President Joe Biden went so far as to confirm the US had informed Vladimir Putin that the US would conduct revenge attacks “at the time of our choosing.” The time may ultimately be America’s election day, according to officials familiar with the situation. \nNBC News has reported seeing top secret documents from these officials detailing potential US plans to launch military cyber attacks against Russia’s civilian infrastructure, with the documents claiming advanced US cyber weapons were prepared to take down Russia’s entire electricity grid, all telecommunications networks, and the Kremlin’s own command systems. \nThe reports are emerging in the context of US officials speculating that Russia might launch cyber attacks against the US during the election to try to disrupt it. Since they offered no evidence for this either, it raises concerns that the US is simply setting up a pretext for timing its own attacks around them. \nThat officials are trying to assure the media that such huge attacks would only be launched in retaliation offers little comfort, given the administration’s willingness to claim anything and everything remotely election-related and embarrassing to the Clinton campaign as a Russian plot. \nSuch massive US attacks on Russian infrastructure, regardless of the pretext, would likely be seen as an act of war. The US has made clear in the past they would regard cyber attacks of a large enough scale as equivalent to conventional military attacks, and given the scale that it being discussed it’s hard to imagine Russia would not react similarly. Last 5 posts by Jason Ditz",
		"thread_title": "US Threatens Military Hacks on Russia’s Electric, Communications Grids Over Election",
		"title": "US Threatens Military Hacks on Russia’s Electric, Communications Grids Over Election",
		"type": "bs",
		"uuid": "9190708d045f17a9e9b9fd2b00c60b53254d1b75"
	},
	"-KhIjHXT-7-ny62mC0pU": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T03:58:41.580+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"name": "Foreigners",
				"salience": 0.18536164,
				"type": "PERSON"
			},
			{
				"name": "Fighters",
				"salience": 0.15663502,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.11737924,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.062341698,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.051222272,
				"type": "OTHER"
			},
			{
				"name": "opposition fighters",
				"salience": 0.04663059,
				"type": "PERSON"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.04327179,
				"type": "PERSON"
			},
			{
				"name": "opposition fighters",
				"salience": 0.0272966,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0246782,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.01960928,
				"type": "ORGANIZATION"
			},
			{
				"name": "estimates",
				"salience": 0.01934512,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.016772304,
				"type": "EVENT"
			},
			{
				"name": "occupation",
				"salience": 0.016772304,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.016721988,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.010355121,
				"type": "LOCATION"
			},
			{
				"name": "opposition fighter figure",
				"salience": 0.008969821,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.008571988,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.008216482,
				"type": "OTHER"
			},
			{
				"name": "fighters",
				"salience": 0.008052881,
				"type": "PERSON"
			},
			{
				"name": "trend",
				"salience": 0.007388266,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0072734775,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0069169994,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07jqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taliban"
				},
				"name": "Taliban",
				"salience": 0.0069169994,
				"type": "ORGANIZATION"
			},
			{
				"name": "figures",
				"salience": 0.0067074904,
				"type": "OTHER"
			},
			{
				"name": "actors",
				"salience": 0.006035114,
				"type": "PERSON"
			},
			{
				"name": "opposition fighters",
				"salience": 0.006021104,
				"type": "PERSON"
			},
			{
				"name": "affiliate",
				"salience": 0.0058103977,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporters",
				"salience": 0.0058103977,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0058103977,
				"type": "PERSON"
			},
			{
				"name": "insurgency",
				"salience": 0.0058103977,
				"type": "EVENT"
			},
			{
				"name": "growth",
				"salience": 0.0056905975,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.0056905975,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.004710113,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0039628204,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0036840304,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0036840304,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacks",
				"salience": 0.0036840304,
				"type": "EVENT"
			},
			{
				"name": "death tolls",
				"salience": 0.0036840304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.0035795888,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0034321689,
				"type": "OTHER"
			},
			{
				"name": "opposition control",
				"salience": 0.0034321689,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.003099275,
				"type": "WORK_OF_ART"
			},
			{
				"name": "increase",
				"salience": 0.00304661,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0030361668,
				"type": "ORGANIZATION"
			},
			{
				"name": "growth",
				"salience": 0.0029837072,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0027183227,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0026841003,
				"type": "WORK_OF_ART"
			},
			{
				"name": "percentage",
				"salience": 0.0026841003,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.002616941,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0020055003,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0020055003,
				"type": "LOCATION"
			},
			{
				"name": "efforts",
				"salience": 0.0020055003,
				"type": "OTHER"
			},
			{
				"name": "spite",
				"salience": 0.0020055003,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistanis",
				"salience": 0.0014257288,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.0014257288,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uzbekistan"
				},
				"name": "Uzbeks",
				"salience": 0.0012345988,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0010831618,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/07/afghan.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T03:58:41.580+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "About 25% of the Fighters Are Foreigners by Jason Ditz, November 04, 2016 Share This \nA new report being circulated by the United Nations reveals a growing number of opposition fighters in Afghanistan, some 15 years after the initial US-led invasion and occupation of the country, with the most recent estimates suggesting about 45,000 opposition fighters present in the country . \nWhile these figures are generally dominated by the Taliban insurgency, it also includes a significant ISIS affiliate in the country, along with al-Qaeda supporters and others simply described by the UN as “bad actors.” An estimated 20-25% of the fighters are foreigners. \nThe opposition fighter figure is never exactly a clear number, but the trend has definitely been toward growth , with NATO estimates of 25,000 to 30,000 in 2010 growing to 35,000 by mid-2012. The foreign fighters in the country are a significant factor, including a large number of Pakistanis and Uzbeks. \nThis growth is in spite of ever-increasing efforts to control the Afghan-Pakistan border, as well as claims of massive death tolls by the Afghan government in attacks against both Taliban and ISIS forces. \nThe increase in opposition fighters makes sense, however, in the context of the growing percentage of the country under opposition control, with recent reports suggesting that only 63.4% of Afghanistan can rightly be called under control anymore. Last 5 posts by Jason Ditz",
		"thread_title": "UN Report: Around 45,000 Opposition Fighters in Afghanistan",
		"title": "UN Report: Around 45,000 Opposition Fighters in Afghanistan",
		"type": "bs",
		"uuid": "53462754a93693206af421bd85270f7e14c9df4c"
	},
	"-KhIjHgH6fQR8yZqvm2y": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T03:58:41.729+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.22248717,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.15783228,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.05520115,
				"type": "LOCATION"
			},
			{
				"name": "Jason Ditz",
				"salience": 0.051530324,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.047967684,
				"type": "ORGANIZATION"
			},
			{
				"name": "potential",
				"salience": 0.047967684,
				"type": "OTHER"
			},
			{
				"name": "intelligence officials",
				"salience": 0.043977913,
				"type": "PERSON"
			},
			{
				"name": "Tuesday Vote",
				"salience": 0.03432033,
				"type": "EVENT"
			},
			{
				"name": "US Intelligence Sees Attacks Likely",
				"salience": 0.029782664,
				"type": "OTHER"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.02942438,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.025525931,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.016070662,
				"type": "EVENT"
			},
			{
				"name": "affiliates",
				"salience": 0.015458086,
				"type": "ORGANIZATION"
			},
			{
				"name": "Details",
				"salience": 0.01310948,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.010262415,
				"type": "OTHER"
			},
			{
				"name": "targets",
				"salience": 0.009592828,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.008864908,
				"type": "OTHER"
			},
			{
				"name": "terror attacks",
				"salience": 0.0086823655,
				"type": "EVENT"
			},
			{
				"name": "polling places",
				"salience": 0.008384693,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.0083164275,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.008175448,
				"type": "PERSON"
			},
			{
				"name": "targets",
				"salience": 0.00814,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0075455396,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.007427433,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0073290216,
				"type": "OTHER"
			},
			{
				"name": "relevance",
				"salience": 0.007204721,
				"type": "OTHER"
			},
			{
				"name": "specificity",
				"salience": 0.007204721,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.007204721,
				"type": "OTHER"
			},
			{
				"name": "locations",
				"salience": 0.006936558,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0067935926,
				"type": "LOCATION"
			},
			{
				"name": "spokesman",
				"salience": 0.0062691052,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0058848727,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0049125836,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.004731468,
				"type": "EVENT"
			},
			{
				"name": "details",
				"salience": 0.0047103725,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0045114774,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.004439464,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.004398684,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.004274012,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.004274012,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.003700638,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.003700638,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0035360665,
				"type": "EVENT"
			},
			{
				"name": "target",
				"salience": 0.003531367,
				"type": "OTHER"
			},
			{
				"name": "holiday",
				"salience": 0.003414542,
				"type": "EVENT"
			},
			{
				"name": "pall",
				"salience": 0.003204994,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.003204994,
				"type": "WORK_OF_ART"
			},
			{
				"name": "warnings",
				"salience": 0.0030993095,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.00308548,
				"type": "EVENT"
			},
			{
				"name": "briefings",
				"salience": 0.0023948082,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/08/Obama-troubled.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T03:58:41.729+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "US Intelligence Sees Attacks Likely Ahead of Tuesday Vote by Jason Ditz, November 04, 2016 Share This \nUS intelligence officials have reportedly warned law enforcement around the country of the potential for multiple al-Qaeda terrorist attacks on Monday, aimed to coincide with the day before the US election. The reports were described as “ possibly legitimate and concerning. ” \nDetails are still scant, but the intelligence has singled out New York, Virginia, and Texas as the mostly likely targets. Even then, they offered no details on potential locations, saying al-Qaeda and its affiliates are eager to regain their relevance. \nA NYPD spokesman briefed on the matter said that the threats “ lack specificity ,” however local police around the country were said to have been warned that polling places are considered “attractive targets” for both organized and homegrown terror attacks. \nOf course, saying that any upcoming event is a potential “attractive target” is not unusual these days, and hardly a significant holiday goes by in the US where warnings and briefings about potential attacks are not heavily publicized. \nThe Monday warning offers some unusual details, however, as generally one would think the day of the election itself would be the target, when more people are queuing up for the vote. An attack the day before the election would, however, cast a rather dramatic pall over the entire matter. Last 5 posts by Jason Ditz",
		"thread_title": "US Officials Try to Scare Voters With Terror Threat",
		"title": "US Officials Try to Scare Voters With Terror Threat",
		"type": "bs",
		"uuid": "6e0e45a7ae2f156c598eafdee0388e3ce2280ca4"
	},
	"-KhIjHq8lZplD-eAIoe1": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:33:24.852+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.3264691,
				"type": "LOCATION"
			},
			{
				"name": "Locals",
				"salience": 0.111392885,
				"type": "PERSON"
			},
			{
				"name": "fighting",
				"salience": 0.055040933,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.04323399,
				"type": "LOCATION"
			},
			{
				"name": "fighting",
				"salience": 0.039504208,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.03645021,
				"type": "LOCATION"
			},
			{
				"name": "Crossfire",
				"salience": 0.0322424,
				"type": "OTHER"
			},
			{
				"name": "Troops",
				"salience": 0.0322424,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0322424,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0322424,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.028106524,
				"type": "ORGANIZATION"
			},
			{
				"name": "airstrikes",
				"salience": 0.024127059,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.018232204,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.014870162,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.014635872,
				"type": "PERSON"
			},
			{
				"name": "crossfire",
				"salience": 0.013438744,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.008803332,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/012w_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manbij"
				},
				"name": "Manbij",
				"salience": 0.008419499,
				"type": "LOCATION"
			},
			{
				"name": "combination",
				"salience": 0.00778335,
				"type": "OTHER"
			},
			{
				"name": "population density",
				"salience": 0.005970296,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0055804243,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.005355961,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.005333614,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.005333614,
				"type": "LOCATION"
			},
			{
				"name": "Civilians",
				"salience": 0.0053052898,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0051566395,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0048373584,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.004657275,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.004190307,
				"type": "OTHER"
			},
			{
				"name": "gear",
				"salience": 0.004190307,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "deaths",
				"salience": 0.004190307,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.004034246,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0039874255,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00390137,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0037754911,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.0035392835,
				"type": "PERSON"
			},
			{
				"name": "human shields",
				"salience": 0.0034222754,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0033516695,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0029693407,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01mxf7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Province,_Sri_Lanka"
				},
				"name": "Western",
				"salience": 0.0025813852,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/062zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Public_relations"
				},
				"name": "PR",
				"salience": 0.0025813852,
				"type": "LOCATION"
			},
			{
				"name": "welll",
				"salience": 0.002557664,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.002557664,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.002557664,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0021714787,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.002151644,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0020793728,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0020559283,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0019271616,
				"type": "PERSON"
			},
			{
				"name": "mistakes",
				"salience": 0.0018633825,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0018633825,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0018633825,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0015749454,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0010534105,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2012/04/iraq1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T05:33:24.852+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Locals Caught in Crossfire Between Troops, ISIS   \nWhile early fighting in Mosul was presented as comparatively easy by Iraqi officials, as the troops near the city, the fighting is starting to get more fierce, and the civilian population trapped in the area is increasingly caught in the crossfire . \nIncreased fighting, and higher population density are a dangerous combination, and locals by and large are being prevented from fleeing the area. Unsurprisingly, this is leading to reports of a growing number of civilians killed and wounded in the area. \nThis has the PR people going into high gear, trying to manage the narrative around the deaths, with Western and Iraq officials accusing ISIS of forcing civilians into the city to use as human shields, and preventing them from relocating outside the city. \nWhile some reports suggest this may be accurate, the US has also talked openly of conducting airstrikes against all “fighters” fleeing the city, which has led the Iraqi government to openly warn the civilian population of Mosul against fleeing , lest they get targeted as welll. \nCivilians getting mistaken for fleeing ISIS fighters has been an ongoing problem for the US, who killed hundreds of civilians around the Syrian city of Manbij in such mistakes. Manbij was a much smaller city than Mosul, which has a population of over a million people potentially in the line of fire.  ",
		"thread_title": "As Iraqi Troops Near Mosul, Civilian Casualties Begin to Rise",
		"title": "As Iraqi Troops Near Mosul, Civilian Casualties Begin to Rise",
		"type": "bs",
		"uuid": "d77e75467bfe7547409b8f822964e57e278f0d4c"
	},
	"-KhIjI0b_qxTdW0-OP2r": {
		"author": "Jason Ditz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T05:33:24.871+02:00",
		"domain_rank": "48959",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07jqh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taliban"
				},
				"name": "Taliban",
				"salience": 0.1845506,
				"type": "ORGANIZATION"
			},
			{
				"name": "Officials",
				"salience": 0.109280095,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.10333837,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghan",
				"salience": 0.100902595,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.08009447,
				"type": "PERSON"
			},
			{
				"name": "village",
				"salience": 0.045117624,
				"type": "LOCATION"
			},
			{
				"name": "Locals",
				"salience": 0.041763593,
				"type": "PERSON"
			},
			{
				"name": "mourners",
				"salience": 0.032824013,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.032824013,
				"type": "PERSON"
			},
			{
				"name": "Human Shields' Hundreds",
				"salience": 0.030358434,
				"type": "PERSON"
			},
			{
				"name": "village",
				"salience": 0.028556952,
				"type": "LOCATION"
			},
			{
				"name": "Bouz Kandahari",
				"salience": 0.024265748,
				"type": "PERSON"
			},
			{
				"name": "airstrike",
				"salience": 0.018857261,
				"type": "OTHER"
			},
			{
				"name": "infants",
				"salience": 0.015138021,
				"type": "PERSON"
			},
			{
				"name": "locals",
				"salience": 0.009894955,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.008944963,
				"type": "PERSON"
			},
			{
				"name": "locals",
				"salience": 0.0076874536,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.007000688,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.007000688,
				"type": "PERSON"
			},
			{
				"name": "airstrikes",
				"salience": 0.0067963963,
				"type": "EVENT"
			},
			{
				"name": "airstrikes",
				"salience": 0.0065435567,
				"type": "EVENT"
			},
			{
				"name": "village",
				"salience": 0.0065435567,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0064476244,
				"type": "LOCATION"
			},
			{
				"name": "matter",
				"salience": 0.0056722886,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.0056722886,
				"type": "LOCATION"
			},
			{
				"name": "details",
				"salience": 0.0056722886,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00491359,
				"type": "EVENT"
			},
			{
				"name": "siege",
				"salience": 0.0047305995,
				"type": "EVENT"
			},
			{
				"name": "attempt",
				"salience": 0.0047305995,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.004633045,
				"type": "OTHER"
			},
			{
				"name": "human shields",
				"salience": 0.004633045,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.004633045,
				"type": "LOCATION"
			},
			{
				"name": "statements",
				"salience": 0.0040892935,
				"type": "OTHER"
			},
			{
				"name": "virtue",
				"salience": 0.004013022,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.003462893,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.003462893,
				"type": "EVENT"
			},
			{
				"name": "condolences",
				"salience": 0.0029991907,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.0022598607,
				"type": "EVENT"
			},
			{
				"name": "capitals",
				"salience": 0.0021850723,
				"type": "OTHER"
			},
			{
				"name": "offensives",
				"salience": 0.0021850723,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0021850723,
				"type": "LOCATION"
			},
			{
				"name": "provinces",
				"salience": 0.0021850723,
				"type": "LOCATION"
			},
			{
				"name": "fighting",
				"salience": 0.0018852516,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01g8_p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kunduz"
				},
				"name": "Kunduz",
				"salience": 0.0018468458,
				"type": "LOCATION"
			},
			{
				"name": "reports",
				"salience": 0.0017394116,
				"type": "OTHER"
			},
			{
				"name": "toll",
				"salience": 0.0016326022,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02bt5r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Urozgan_Province"
				},
				"name": "Uruzgan",
				"salience": 0.0013452794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02bs_m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Helmand_Province"
				},
				"name": "Helmand",
				"salience": 0.0013452794,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0011554278,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://news.antiwar.com/wp-content/uploads/2009/07/afghan.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T05:33:24.871+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "antiwar.com",
		"spam_score": "0",
		"text": "Afghan Officials Say Taliban Used Locals as 'Human Shields'   \nHundreds of angry mourners gathered today in the north Afghan village of Bouz Kandahari to bury an estimated 30 civilian victims of a US airstrike the previous day. The locals noted that many of the civilians being buried were infants and small children. \nTwo US soldiers and four Afghan soldiers were killed in fighting with the Taliban near the village Thursday morning, and the airstrikes were called in, supposedly in an attempt to break the Taliban siege against the village. Instead, the airstrikes hit the village, destroying several homes and killing those within. \nNATO promised an investigation into the details of the matter, but Afghan officials appeared to be shrugging the matter off, insisting the Taliban were using the locals as “human shields” by virtue of their operating somewhat near their homes. \nUS statements on the fighting and airstrikes have more or less ignored the civilian toll entirely, insisting only that they take such reports “seriously,” and then going into details about the condolences they offer for the US soldiers killed in the fighting. \nBouz Kandahari is near the city of Kunduz, which was taken over briefly last year by the Taliban. The Taliban has been advancing in the area in recent weeks, along with offensives against the capitals of two other provinces, Helmand and Uruzgan.  ",
		"thread_title": "Angry Mourners Bury Civilian Victims of US Airstrike in North Afghanistan",
		"title": "Angry Mourners Bury Civilian Victims of US Airstrike in North Afghanistan",
		"type": "bs",
		"uuid": "6317fc76683e8c4bee42a9551a3b53405990ad65"
	},
	"-KhIjIAFMzfmAHJMYDiv": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-26T23:44:35.104+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.22657405,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.1059279,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.088673145,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04f30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmir"
				},
				"name": "Kashmir",
				"salience": 0.06582985,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.050510637,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.04385117,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.038122464,
				"type": "LOCATION"
			},
			{
				"name": "roadmap",
				"salience": 0.036817685,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03qc87b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia_Times"
				},
				"name": "Asia Times",
				"salience": 0.031320296,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01yf40",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rawalpindi"
				},
				"name": "Rawalpindi",
				"salience": 0.027163533,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Islamic Republic of Pakistan",
				"salience": 0.027163533,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.014072936,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0102459,
				"type": "ORGANIZATION"
			},
			{
				"name": "proposal",
				"salience": 0.009455416,
				"type": "OTHER"
			},
			{
				"name": "self-determination",
				"salience": 0.0093366485,
				"type": "OTHER"
			},
			{
				"name": "inhabitants",
				"salience": 0.0093366485,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.0093366485,
				"type": "OTHER"
			},
			{
				"name": "courses",
				"salience": 0.0093366485,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00890059,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition party",
				"salience": 0.008598728,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.008259747,
				"type": "OTHER"
			},
			{
				"name": "integration",
				"salience": 0.007282644,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0070690433,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.006873754,
				"type": "LOCATION"
			},
			{
				"name": "right",
				"salience": 0.006552236,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.006552236,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.0063081435,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0063081435,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0063081435,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0063081435,
				"type": "EVENT"
			},
			{
				"name": "referendum",
				"salience": 0.0063081435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/051zvy9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jammu"
				},
				"name": "Jammu",
				"salience": 0.005753518,
				"type": "LOCATION"
			},
			{
				"name": "anti-Indian Kashmiri",
				"salience": 0.005388079,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.005351018,
				"type": "PERSON"
			},
			{
				"name": "zealots",
				"salience": 0.005351018,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/010vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Azad_Kashmir"
				},
				"name": "Azad Kashmir",
				"salience": 0.0053003826,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b79c7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmiris"
				},
				"name": "Kashmiris",
				"salience": 0.00517989,
				"type": "LOCATION"
			},
			{
				"name": "Asia Time",
				"salience": 0.0046601216,
				"type": "ORGANIZATION"
			},
			{
				"name": "plebiscite",
				"salience": 0.0045967046,
				"type": "OTHER"
			},
			{
				"name": "wishes",
				"salience": 0.004314648,
				"type": "OTHER"
			},
			{
				"name": "bandits",
				"salience": 0.0039988947,
				"type": "PERSON"
			},
			{
				"name": "solution",
				"salience": 0.0039988947,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0039988947,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.0039988947,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.003363994,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03kbr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hindu"
				},
				"name": "Hindu",
				"salience": 0.0032954777,
				"type": "OTHER"
			},
			{
				"name": "bloodshed",
				"salience": 0.0029132545,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0029132545,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0029132545,
				"type": "OTHER"
			},
			{
				"name": "disposition",
				"salience": 0.0029132545,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.002348589,
				"type": "OTHER"
			},
			{
				"name": "separatists",
				"salience": 0.0021765928,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0021765928,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0021765928,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01ygr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indian_Army"
				},
				"name": "Indian army",
				"salience": 0.0020711299,
				"type": "ORGANIZATION"
			},
			{
				"name": "Indianans",
				"salience": 0.0020711299,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistanis",
				"salience": 0.0020711299,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/147750561355a020a5cf72f.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:44:35.104+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email (Rawalpindi, Islamic Republic of Pakistan)-- President Vladimir Putin in a rare interview with Asia Times revealed that Moscow offered a comprehensive roadmap to solve Kashmir's crisis which has festered for decades. The Russian proposal supports self-determination to the inhabitants of the disputed Jammu and Kashmir, based on a choice of three courses to be voted on in a referendum within four years after the establishment of peace. \"It is unrealistic to expect the Muslim population to accept the idea of integration into India. We support the inalienable right of Kashmiri people to determine their future. A UN-sponsored ceasefire is needed,\" the state-run Asia Time quoted Mr. Putin as saying, adding, the Indian army disguised as Hindu zealots are indiscriminately targeting Muslim civilians. The main anti-Indian Kashmiri opposition party, widely known as Azad Kashmir (Free Kashmir), has recently reopened its political office in Moscow after five years when Russia suddenly severed all its ties with the Muslim separatists. \"Indian army acts as ruthless bandits, though we seek a permanent solution to the conflict in Kashmir. UN must hold a plebiscite in those disputed areas to determine the wishes of Kashmiris on the final disposition of their state. I hope both side--Indianans and Pakistanis--eventually reach a mutual understanding and agree on reasonable term to end this bloodshed.",
		"thread_title": "President Putin: Russian Federation supports Jammu and Kashmir's right of self-determination, Indian army acts as ruthless bandits",
		"title": "President Putin: Russian Federation supports Jammu and Kashmir's right of self-determination, Indian army acts as ruthless bandits",
		"type": "conspiracy",
		"uuid": "e2805f48d61aee4e7019e5c69a390e57660e6ed2"
	},
	"-KhIjIIK4_VHkr9Hayl0": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-26T23:44:36.591+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.19278905,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03m6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamas"
				},
				"name": "Hamas",
				"salience": 0.14824232,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0713484,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0537556,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.046695136,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.046695136,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.046695136,
				"type": "EVENT"
			},
			{
				"name": "commander",
				"salience": 0.046695136,
				"type": "PERSON"
			},
			{
				"name": "genocide",
				"salience": 0.044430457,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestine",
				"salience": 0.036920898,
				"type": "LOCATION"
			},
			{
				"name": "Saber Siam",
				"salience": 0.03338769,
				"type": "ORGANIZATION"
			},
			{
				"name": "partner",
				"salience": 0.028520087,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.013244697,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.011508828,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.009971888,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.009971888,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.009480555,
				"type": "EVENT"
			},
			{
				"name": "militants",
				"salience": 0.00867803,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.008080228,
				"type": "EVENT"
			},
			{
				"name": "offices",
				"salience": 0.008080228,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.008080228,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0357_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gaza_Strip"
				},
				"name": "Gaza",
				"salience": 0.0073429896,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07f1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thailand"
				},
				"name": "Siam",
				"salience": 0.0070961574,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.006999719,
				"type": "PERSON"
			},
			{
				"name": "buildings",
				"salience": 0.006999719,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0069117476,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.006739098,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.006739098,
				"type": "ORGANIZATION"
			},
			{
				"name": "mosque",
				"salience": 0.0066001564,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.006488153,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0053318134,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ansar al-Bayt al-Maqdis",
				"salience": 0.005152565,
				"type": "PERSON"
			},
			{
				"name": "mosque",
				"salience": 0.004933465,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zvgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salafi_movement"
				},
				"name": "Salafist",
				"salience": 0.0047936467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.004429447,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0041518095,
				"type": "PERSON"
			},
			{
				"name": "Americans.org",
				"salience": 0.0041518095,
				"type": "ORGANIZATION"
			},
			{
				"name": "officers",
				"salience": 0.0035947291,
				"type": "PERSON"
			},
			{
				"name": "Intelligence agency",
				"salience": 0.0031131953,
				"type": "ORGANIZATION"
			},
			{
				"name": "addresses",
				"salience": 0.0031131953,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0031131953,
				"type": "OTHER"
			},
			{
				"name": "Almtahabin",
				"salience": 0.0026313493,
				"type": "PERSON"
			},
			{
				"name": "allegiance",
				"salience": 0.0023261239,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptian",
				"salience": 0.0014319863,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03w86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamism"
				},
				"name": "Islamist",
				"salience": 0.0014319863,
				"type": "OTHER"
			},
			{
				"name": "Salafist Sheikh Yasser Abu Houli",
				"salience": 0.0011112308,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774994921475744757e-800x454.png",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:44:36.591+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nISIS has declared war on Palestine, threatening genocide against the Palestinian people, following the murder of Hamas’ senior commander Saber Siam on Sunday. ISIS militants said that Siam was killed due to the fact he was “a partner in a declared war against religion and against Muslims, working for the heretical government in Gaza”. Americans.org report: The attack was conducted by ISIS-affiliated Salafist rebels who have also warned local residents to stay away from Hamas offices and buildings as it plans to carry out more attacks. The conflict between Hamas and ISIS in Gaza started when Palestinian forces demolished a makeshift mosque used by Ansar al-Bayt al-Maqdis in early May. Ansar al-Bayt al-Maqdis is an Egyptian Islamist group that has pledged allegiance to ISIS and has been recruiting Palestinians for the Islamic State. After demolishing the Almtahabin mosque, Hamas then arrested seven men, including a local Salafist Sheikh Yasser Abu Houli. ISIS claims it will kill Palestinians “one by one” and that it knows the names and addresses of all the officers working for the Palestinian Intelligence agency.",
		"thread_title": "ISIS Declares It Will kill Palestinians “One By One”’, Yet Remains Quiet On Israel",
		"title": "ISIS Declares It Will kill Palestinians “One By One”’, Yet Remains Quiet On Israel",
		"type": "conspiracy",
		"uuid": "fb32bb92ea5d5f64f16b3172ea2c9ec7801d4b8c"
	},
	"-KhIjIQVAH1WE9mImSOk": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:56.838+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.22657405,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.1059279,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.088673145,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04f30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmir"
				},
				"name": "Kashmir",
				"salience": 0.06582985,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.050510637,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.04385117,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.038122464,
				"type": "LOCATION"
			},
			{
				"name": "roadmap",
				"salience": 0.036817685,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03qc87b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia_Times"
				},
				"name": "Asia Times",
				"salience": 0.031320296,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01yf40",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rawalpindi"
				},
				"name": "Rawalpindi",
				"salience": 0.027163533,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Islamic Republic of Pakistan",
				"salience": 0.027163533,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.014072936,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0102459,
				"type": "ORGANIZATION"
			},
			{
				"name": "proposal",
				"salience": 0.009455416,
				"type": "OTHER"
			},
			{
				"name": "self-determination",
				"salience": 0.0093366485,
				"type": "OTHER"
			},
			{
				"name": "inhabitants",
				"salience": 0.0093366485,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.0093366485,
				"type": "OTHER"
			},
			{
				"name": "courses",
				"salience": 0.0093366485,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00890059,
				"type": "ORGANIZATION"
			},
			{
				"name": "opposition party",
				"salience": 0.008598728,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.008259747,
				"type": "OTHER"
			},
			{
				"name": "integration",
				"salience": 0.007282644,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0070690433,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.006873754,
				"type": "LOCATION"
			},
			{
				"name": "right",
				"salience": 0.006552236,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.006552236,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.0063081435,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0063081435,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0063081435,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0063081435,
				"type": "EVENT"
			},
			{
				"name": "referendum",
				"salience": 0.0063081435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/051zvy9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jammu"
				},
				"name": "Jammu",
				"salience": 0.005753518,
				"type": "LOCATION"
			},
			{
				"name": "anti-Indian Kashmiri",
				"salience": 0.005388079,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.005351018,
				"type": "PERSON"
			},
			{
				"name": "zealots",
				"salience": 0.005351018,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/010vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Azad_Kashmir"
				},
				"name": "Azad Kashmir",
				"salience": 0.0053003826,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b79c7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmiris"
				},
				"name": "Kashmiris",
				"salience": 0.00517989,
				"type": "LOCATION"
			},
			{
				"name": "Asia Time",
				"salience": 0.0046601216,
				"type": "ORGANIZATION"
			},
			{
				"name": "plebiscite",
				"salience": 0.0045967046,
				"type": "OTHER"
			},
			{
				"name": "wishes",
				"salience": 0.004314648,
				"type": "OTHER"
			},
			{
				"name": "bandits",
				"salience": 0.0039988947,
				"type": "PERSON"
			},
			{
				"name": "solution",
				"salience": 0.0039988947,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0039988947,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.0039988947,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.003363994,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03kbr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hindu"
				},
				"name": "Hindu",
				"salience": 0.0032954777,
				"type": "OTHER"
			},
			{
				"name": "bloodshed",
				"salience": 0.0029132545,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0029132545,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0029132545,
				"type": "OTHER"
			},
			{
				"name": "disposition",
				"salience": 0.0029132545,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.002348589,
				"type": "OTHER"
			},
			{
				"name": "separatists",
				"salience": 0.0021765928,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0021765928,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0021765928,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01ygr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indian_Army"
				},
				"name": "Indian army",
				"salience": 0.0020711299,
				"type": "ORGANIZATION"
			},
			{
				"name": "Indianans",
				"salience": 0.0020711299,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistanis",
				"salience": 0.0020711299,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/147750561355a020a5cf72f.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T00:19:56.838+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email (Rawalpindi, Islamic Republic of Pakistan)-- President Vladimir Putin in a rare interview with Asia Times revealed that Moscow offered a comprehensive roadmap to solve Kashmir's crisis which has festered for decades. The Russian proposal supports self-determination to the inhabitants of the disputed Jammu and Kashmir, based on a choice of three courses to be voted on in a referendum within four years after the establishment of peace. \"It is unrealistic to expect the Muslim population to accept the idea of integration into India. We support the inalienable right of Kashmiri people to determine their future. A UN-sponsored ceasefire is needed,\" the state-run Asia Time quoted Mr. Putin as saying, adding, the Indian army disguised as Hindu zealots are indiscriminately targeting Muslim civilians. The main anti-Indian Kashmiri opposition party, widely known as Azad Kashmir (Free Kashmir), has recently reopened its political office in Moscow after five years when Russia suddenly severed all its ties with the Muslim separatists. \"Indian army acts as ruthless bandits, though we seek a permanent solution to the conflict in Kashmir. UN must hold a plebiscite in those disputed areas to determine the wishes of Kashmiris on the final disposition of their state. I hope both side--Indianans and Pakistanis--eventually reach a mutual understanding and agree on reasonable term to end this bloodshed.",
		"thread_title": "President Putin: Russian Federation supports Jammu and Kashmir's right of self-determination, Indian army acts as ruthless bandits",
		"title": "President Putin: Russian Federation supports Jammu and Kashmir's right of self-determination, Indian army acts as ruthless bandits",
		"type": "conspiracy",
		"uuid": "1686d5c2e27c5f916b701ea792cdfdb61bb80572"
	},
	"-KhIjIewDuTKvtn8aHBX": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:57.067+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.19278905,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03m6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamas"
				},
				"name": "Hamas",
				"salience": 0.14824232,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0713484,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0537556,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.046695136,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.046695136,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.046695136,
				"type": "EVENT"
			},
			{
				"name": "commander",
				"salience": 0.046695136,
				"type": "PERSON"
			},
			{
				"name": "genocide",
				"salience": 0.044430457,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestine",
				"salience": 0.036920898,
				"type": "LOCATION"
			},
			{
				"name": "Saber Siam",
				"salience": 0.03338769,
				"type": "ORGANIZATION"
			},
			{
				"name": "partner",
				"salience": 0.028520087,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.013244697,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.011508828,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.009971888,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.009971888,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.009480555,
				"type": "EVENT"
			},
			{
				"name": "militants",
				"salience": 0.00867803,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.008080228,
				"type": "EVENT"
			},
			{
				"name": "offices",
				"salience": 0.008080228,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.008080228,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0357_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gaza_Strip"
				},
				"name": "Gaza",
				"salience": 0.0073429896,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07f1x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thailand"
				},
				"name": "Siam",
				"salience": 0.0070961574,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.006999719,
				"type": "PERSON"
			},
			{
				"name": "buildings",
				"salience": 0.006999719,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0069117476,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.006739098,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.006739098,
				"type": "ORGANIZATION"
			},
			{
				"name": "mosque",
				"salience": 0.0066001564,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.006488153,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0053318134,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ansar al-Bayt al-Maqdis",
				"salience": 0.005152565,
				"type": "PERSON"
			},
			{
				"name": "mosque",
				"salience": 0.004933465,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zvgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salafi_movement"
				},
				"name": "Salafist",
				"salience": 0.0047936467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.004429447,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0041518095,
				"type": "PERSON"
			},
			{
				"name": "Americans.org",
				"salience": 0.0041518095,
				"type": "ORGANIZATION"
			},
			{
				"name": "officers",
				"salience": 0.0035947291,
				"type": "PERSON"
			},
			{
				"name": "Intelligence agency",
				"salience": 0.0031131953,
				"type": "ORGANIZATION"
			},
			{
				"name": "addresses",
				"salience": 0.0031131953,
				"type": "OTHER"
			},
			{
				"name": "names",
				"salience": 0.0031131953,
				"type": "OTHER"
			},
			{
				"name": "Almtahabin",
				"salience": 0.0026313493,
				"type": "PERSON"
			},
			{
				"name": "allegiance",
				"salience": 0.0023261239,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptian",
				"salience": 0.0014319863,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03w86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamism"
				},
				"name": "Islamist",
				"salience": 0.0014319863,
				"type": "OTHER"
			},
			{
				"name": "Salafist Sheikh Yasser Abu Houli",
				"salience": 0.0011112308,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774994921475744757e-800x454.png",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T00:19:57.067+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nISIS has declared war on Palestine, threatening genocide against the Palestinian people, following the murder of Hamas’ senior commander Saber Siam on Sunday. ISIS militants said that Siam was killed due to the fact he was “a partner in a declared war against religion and against Muslims, working for the heretical government in Gaza”. Americans.org report: The attack was conducted by ISIS-affiliated Salafist rebels who have also warned local residents to stay away from Hamas offices and buildings as it plans to carry out more attacks. The conflict between Hamas and ISIS in Gaza started when Palestinian forces demolished a makeshift mosque used by Ansar al-Bayt al-Maqdis in early May. Ansar al-Bayt al-Maqdis is an Egyptian Islamist group that has pledged allegiance to ISIS and has been recruiting Palestinians for the Islamic State. After demolishing the Almtahabin mosque, Hamas then arrested seven men, including a local Salafist Sheikh Yasser Abu Houli. ISIS claims it will kill Palestinians “one by one” and that it knows the names and addresses of all the officers working for the Palestinian Intelligence agency.",
		"thread_title": "ISIS Declares It Will kill Palestinians “One By One”’, Yet Remains Quiet On Israel",
		"title": "ISIS Declares It Will kill Palestinians “One By One”’, Yet Remains Quiet On Israel",
		"type": "conspiracy",
		"uuid": "e6aa85081850e40ef0f80fc53486dd7aaadaec47"
	},
	"-KhIjImQTbI3AzPkBU_-": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:57.227+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.18451244,
				"type": "PERSON"
			},
			{
				"name": "Peter Kadzik",
				"salience": 0.12552659,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.106202334,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.10231925,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0742843,
				"type": "EVENT"
			},
			{
				"name": "front",
				"salience": 0.036099914,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n4bfmd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2012_Benghazi_attack"
				},
				"name": "Benghazi",
				"salience": 0.022310106,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0288j83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.022310106,
				"type": "PERSON"
			},
			{
				"name": "House Select Committee",
				"salience": 0.022310106,
				"type": "ORGANIZATION"
			},
			{
				"name": "dinner",
				"salience": 0.019100659,
				"type": "OTHER"
			},
			{
				"name": "Vincent Roberti",
				"salience": 0.015959537,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.014951032,
				"type": "ORGANIZATION"
			},
			{
				"name": "friends",
				"salience": 0.014951032,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.014906002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dinner arrangement",
				"salience": 0.01301139,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.012648433,
				"type": "WORK_OF_ART"
			},
			{
				"name": "example",
				"salience": 0.012425338,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.010639873,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.010596797,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email practices",
				"salience": 0.01049529,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.01049529,
				"type": "PERSON"
			},
			{
				"name": "affairs",
				"salience": 0.01049529,
				"type": "OTHER"
			},
			{
				"name": "agency",
				"salience": 0.01049529,
				"type": "ORGANIZATION"
			},
			{
				"name": "interest",
				"salience": 0.01010456,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.01010456,
				"type": "EVENT"
			},
			{
				"name": "contact",
				"salience": 0.008572257,
				"type": "OTHER"
			},
			{
				"name": "classmates",
				"salience": 0.008572257,
				"type": "PERSON"
			},
			{
				"name": "dinner",
				"salience": 0.008191353,
				"type": "EVENT"
			},
			{
				"name": "example",
				"salience": 0.0070321723,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.006460519,
				"type": "EVENT"
			},
			{
				"name": "fixtures",
				"salience": 0.0064070686,
				"type": "EVENT"
			},
			{
				"name": "exchanges",
				"salience": 0.0064070686,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0062254467,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02rff2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgetown_University_Law_Center"
				},
				"name": "Georgetown Law School",
				"salience": 0.00528043,
				"type": "ORGANIZATION"
			},
			{
				"name": "relationship",
				"salience": 0.0046681683,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.0042182086,
				"type": "EVENT"
			},
			{
				"name": "another",
				"salience": 0.0040277205,
				"type": "OTHER"
			},
			{
				"name": "post-Benghazi",
				"salience": 0.00394568,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0vzrj7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Inside_the_Beltway"
				},
				"name": "Beltway",
				"salience": 0.00394568,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0034880145,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.0034880145,
				"type": "PERSON"
			},
			{
				"name": "Obama Justice Department",
				"salience": 0.003319045,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0294qn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Attorney"
				},
				"name": "U.S. Attorney",
				"salience": 0.0030760022,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.0030728085,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09v53g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Daily_Caller"
				},
				"name": "The Daily Caller",
				"salience": 0.002346565,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774973631.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:56:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nThe day after Hillary Clinton testified in front of the House Select Committee on Benghazi last October, John Podesta, the Democrat’s campaign chairman, met for dinner with a small group of well-connected friends, including Peter Kadzik, a top official at the Justice Department. \nThe dinner arrangement, revealed in hacked Podesta emails released by Wikileaks, is just the latest example of an apparent conflict of interest between the Clinton campaign and the federal agency charged with investigating the former secretary of state’s email practices. \nPodesta and Kadzik, the assistant attorney general for legislative affairs, were in frequent contact, other emails show. In one email from January, Kadzik and Podesta, who were classmates at Georgetown Law School in the 1970s, discussed plans to celebrate Podesta’s birthday. And in another sent last May, Kadzik’s son emailed Podesta asking for a job on the Clinton campaign. \nThe post-Benghazi dinner was attended by Podesta, Kadzik, superlobbyist Vincent Roberti and other well-placed Beltway fixtures. \nThe exchanges are another example of the Clinton campaign’s “cozy relationship” with the Obama Justice Department, one former U.S. Attorney tells The Daily Caller.",
		"thread_title": "CLINTON CAMPAIGN CHAIRMAN HAD MULTIPLE DINNERS WITH TOP DOJ OFFICIAL DURING HILLARY'S EMAIL INVESTIGATION",
		"title": "CLINTON CAMPAIGN CHAIRMAN HAD MULTIPLE DINNERS WITH TOP DOJ OFFICIAL DURING HILLARY'S EMAIL INVESTIGATION",
		"type": "conspiracy",
		"uuid": "d21f15a94f2ee80187a7d8642fa4dc15d92aa656"
	},
	"-KhIjJ5fjTX1DpV2Xhes": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:57.290+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.32574663,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03f2_rc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barbra_Streisand"
				},
				"name": "Barbra Streisand",
				"salience": 0.067030706,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.023513021,
				"type": "OTHER"
			},
			{
				"name": "capstone",
				"salience": 0.023307713,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vrz41",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elton_John"
				},
				"name": "Elton John",
				"salience": 0.01854443,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.017763782,
				"type": "EVENT"
			},
			{
				"name": "bundlers",
				"salience": 0.016792078,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.016777597,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.01664873,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.015424329,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.015391999,
				"type": "PERSON"
			},
			{
				"name": "home stretch",
				"salience": 0.015391999,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.013903017,
				"type": "LOCATION"
			},
			{
				"name": "ticket",
				"salience": 0.013903017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.012958628,
				"type": "LOCATION"
			},
			{
				"name": "check",
				"salience": 0.012044828,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.012044828,
				"type": "OTHER"
			},
			{
				"name": "piano",
				"salience": 0.012044828,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "crowd",
				"salience": 0.012044828,
				"type": "PERSON"
			},
			{
				"name": "campaign bundlers",
				"salience": 0.0117893135,
				"type": "PERSON"
			},
			{
				"name": "tech investors",
				"salience": 0.01123401,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.010400738,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k049",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beverly_Hills,_California"
				},
				"name": "BEVERLY HILLS",
				"salience": 0.010269004,
				"type": "LOCATION"
			},
			{
				"name": "money",
				"salience": 0.010198529,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.008066781,
				"type": "LOCATION"
			},
			{
				"name": "Laura Wasserman",
				"salience": 0.0074223555,
				"type": "PERSON"
			},
			{
				"name": "Casey",
				"salience": 0.0074223555,
				"type": "LOCATION"
			},
			{
				"name": "executives",
				"salience": 0.006350341,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0058740694,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.0058738426,
				"type": "EVENT"
			},
			{
				"name": "bundlers",
				"salience": 0.00584176,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0057345023,
				"type": "OTHER"
			},
			{
				"name": "billionaires",
				"salience": 0.0057345023,
				"type": "PERSON"
			},
			{
				"name": "bundlers",
				"salience": 0.0056956494,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f1vrl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haim_Saban"
				},
				"name": "Haim Saban",
				"salience": 0.0056217997,
				"type": "PERSON"
			},
			{
				"name": "lobbyists",
				"salience": 0.005280474,
				"type": "PERSON"
			},
			{
				"name": "campaigns",
				"salience": 0.005143202,
				"type": "OTHER"
			},
			{
				"name": "north",
				"salience": 0.0049664187,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0049664187,
				"type": "OTHER"
			},
			{
				"name": "fundraising circuit",
				"salience": 0.0049664187,
				"type": "LOCATION"
			},
			{
				"name": "event",
				"salience": 0.0049664187,
				"type": "EVENT"
			},
			{
				"name": "host committee",
				"salience": 0.0049664187,
				"type": "ORGANIZATION"
			},
			{
				"name": "media moguls",
				"salience": 0.0049664187,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.004951414,
				"type": "EVENT"
			},
			{
				"name": "prohibition",
				"salience": 0.0045731193,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0044877385,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.004454211,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0044025616,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.004288082,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004288082,
				"type": "PERSON"
			},
			{
				"name": "Hillblazers",
				"salience": 0.0042328564,
				"type": "ORGANIZATION"
			},
			{
				"name": "loss",
				"salience": 0.0042122537,
				"type": "OTHER"
			},
			{
				"name": "club",
				"salience": 0.0040220297,
				"type": "ORGANIZATION"
			},
			{
				"name": "advisers",
				"salience": 0.003872001,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.003872001,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.0037109235,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0036368112,
				"type": "PERSON"
			},
			{
				"name": "raisers",
				"salience": 0.0034830743,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0034830743,
				"type": "OTHER"
			},
			{
				"name": "minimum",
				"salience": 0.0034830743,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.0034830743,
				"type": "OTHER"
			},
			{
				"name": "bundlers",
				"salience": 0.0034749722,
				"type": "PERSON"
			},
			{
				"name": "bundlers",
				"salience": 0.0034749722,
				"type": "OTHER"
			},
			{
				"name": "backbone",
				"salience": 0.0033531291,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0033531291,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0033531291,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.0033531291,
				"type": "PERSON"
			},
			{
				"name": "infrastructure",
				"salience": 0.0033531291,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0032838613,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0032016654,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0279hf2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Sacca"
				},
				"name": "Chris Sacca",
				"salience": 0.0030579239,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06xyvl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sean_Parker"
				},
				"name": "Sean Parker",
				"salience": 0.0030579239,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rq9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Katzenberg"
				},
				"name": "Jeffrey Katzenberg",
				"salience": 0.0030579239,
				"type": "PERSON"
			},
			{
				"name": "club",
				"salience": 0.0030050557,
				"type": "ORGANIZATION"
			},
			{
				"name": "blood",
				"salience": 0.002843736,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.002843736,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.002843736,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0026022685,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0024533954,
				"type": "OTHER"
			},
			{
				"name": "ballroom",
				"salience": 0.002124503,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.002124503,
				"type": "OTHER"
			},
			{
				"name": "sprinkling",
				"salience": 0.0019940005,
				"type": "OTHER"
			},
			{
				"name": "bundlers",
				"salience": 0.0018909802,
				"type": "PERSON"
			},
			{
				"name": "ticket",
				"salience": 0.001832832,
				"type": "OTHER"
			},
			{
				"name": "billionaires",
				"salience": 0.0017869361,
				"type": "PERSON"
			},
			{
				"name": "lobbyists",
				"salience": 0.0017869361,
				"type": "PERSON"
			},
			{
				"name": "family advisers",
				"salience": 0.0017869361,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6lp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/San_Francisco"
				},
				"name": "San Francisco",
				"salience": 0.0017505129,
				"type": "LOCATION"
			},
			{
				"name": "individuals",
				"salience": 0.0015473447,
				"type": "PERSON"
			},
			{
				"name": "couples",
				"salience": 0.0015473447,
				"type": "PERSON"
			},
			{
				"name": "names",
				"salience": 0.0015473447,
				"type": "OTHER"
			},
			{
				"name": "Wade Randlett",
				"salience": 0.001522604,
				"type": "PERSON"
			},
			{
				"name": "media executives",
				"salience": 0.001478446,
				"type": "PERSON"
			},
			{
				"name": "executives",
				"salience": 0.001478446,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0011558783,
				"type": "PERSON"
			},
			{
				"name": "celebrities",
				"salience": 0.0011558783,
				"type": "PERSON"
			},
			{
				"name": "-types",
				"salience": 0.0011558783,
				"type": "OTHER"
			},
			{
				"name": "sports stars",
				"salience": 0.0011558783,
				"type": "PERSON"
			},
			{
				"name": "directors",
				"salience": 0.0011558783,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03bfzn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vernon_Jordan"
				},
				"name": "Vernon Jordan",
				"salience": 0.00095235236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xndd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._J._Abrams"
				},
				"name": "J.J. Abrams",
				"salience": 0.00095235236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02r33n4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calvin_Klein"
				},
				"name": "Calvin Klein",
				"salience": 0.00095235236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0267w41",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steve_Elmendorf"
				},
				"name": "Steve Elmendorf",
				"salience": 0.00095235236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cm9pg5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Steyer"
				},
				"name": "Tom Steyer",
				"salience": 0.00095235236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01d_ys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Warren_Buffett"
				},
				"name": "Warren Buffett",
				"salience": 0.00095235236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.00095235236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0009099395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/095nx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Magic_Johnson"
				},
				"name": "Earvin ``Magic'' Johnson",
				"salience": 0.0008215648,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pj8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steven_Spielberg"
				},
				"name": "Steven Spielberg",
				"salience": 0.0007113821,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0343h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Lucas"
				},
				"name": "George Lucas",
				"salience": 0.0007113821,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cyly0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marissa_Mayer"
				},
				"name": "Marissa Mayer",
				"salience": 0.0007113821,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05hjzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sheryl_Sandberg"
				},
				"name": "Sheryl Sandberg",
				"salience": 0.0007113821,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bmfj81",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marc_Lasry"
				},
				"name": "Marc Lasry",
				"salience": 0.0007113821,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0147dk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Will_Smith"
				},
				"name": "Will Smith",
				"salience": 0.0007113821,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/036f9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anna_Wintour"
				},
				"name": "Anna Wintour",
				"salience": 0.0007113821,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0007113821,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774971911.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:53:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.1,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nBEVERLY HILLS, Calif. — More than 100 of Hillary Clinton’s biggest donors crowded into the home of Casey and Laura Wasserman here on Thursday night, each having written a check for at least $33,400 to snag a ticket. The Hollywood glitterati in attendance — Elton John performed on the piano; Barbra Streisand mingled in the crowd — were sending her off for the home stretch of the campaign with north of $5 million in fresh funding. \nIt was a fitting capstone to a remarkable 18 months for Clinton on the lucrative California fundraising circuit, this final event anchored by a host committee of billionaires, Hollywood executives, media moguls and tech investors — Sean Parker, Jeffrey Katzenberg, Haim Saban, Chris Sacca — that each directed $416,000 to Clinton’s efforts. \nClinton calls them her “Hillblazers,” campaign bundlers who have given or raised at least $100,000 for her campaign. And she has erected an unparalleled and unprecedented infrastructure of 1,133 such people — nearly double the number of any past presidential candidate, including President Obama four years ago. \nWhile Clinton and her advisers like to tout her small online donors, it is these bundlers in more than 40 states and four foreign countries who form the true backbone of her financial operation. Combined, this elite $100,000-and-up club has amassed a minimum of $113 million for Clinton and the Democratic Party — and the actual figure is likely far, far higher than that. (The biggest bundlers typically collect millions for campaigns.) \n“We had the best base of donors and bundlers and raisers ever in 2008. It was even better in 2012. And it’s much better in 2016 than 2012,” said Wade Randlett, a San Francisco-based Democrat who has raised money for Clinton, Obama and Democratic causes for decades. “The Obama people basically 100 percent in are favor of Hillary. There’s really no loss because of ideology or bad blood. And she has added an enormous number of people, especially women.” \nAmong her bundlers are celebrities (Will Smith) and sports stars (Earvin “Magic” Johnson), Hollywood directors (Steven Spielberg and George Lucas) and corporate executives (Marissa Mayer and Sheryl Sandberg), Wall Street-types (Marc Lasry), media executives (Haim Saban and Anna Wintour) and members of Congress, including her running mate, Sen. Tim Kaine, who helped raise more than $100,000 for Clinton before he joined the ticket in July. \nThe Clinton campaign said 45 percent of its bundlers are women. \nThere are also federal lobbyists, from whom the Democratic Party under Obama refused to accept money, a prohibition that has since been rolled back. \nThis club has expanded to the point where Clinton would now struggle to fit all of these bundlers into a single ballroom. As of the end of June, she counted 496 such individuals and couples. By the end of July, it was 871. On August 31, it was 1,133. \nIt includes billionaires George Soros, Warren Buffett and Tom Steyer, super lobbyists like Steve Elmendorf and bold-faced names like Calvin Klein and J.J. Abrams. There is also a sprinkling of longtime Clinton family advisers, such as Vernon Jordan.",
		"thread_title": "Hillary has built the biggest big-money operation ever",
		"title": "Hillary has built the biggest big-money operation ever",
		"type": "conspiracy",
		"uuid": "9eb39920d88dd43ea9ffd580de811aaa4c42f00f"
	},
	"-KhIjJYOqrNlbeh1d9VS": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:57.919+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.516287,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.10636126,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.0550902,
				"type": "OTHER"
			},
			{
				"name": "Stats",
				"salience": 0.03632916,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.03285925,
				"type": "OTHER"
			},
			{
				"name": "Secretary of State",
				"salience": 0.03285925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.027181985,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.017646557,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.011834213,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.009549537,
				"type": "OTHER"
			},
			{
				"name": "shipment",
				"salience": 0.00923566,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00923566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libyan",
				"salience": 0.008718037,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.008310945,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.008310945,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.008001839,
				"type": "EVENT"
			},
			{
				"name": "arms",
				"salience": 0.0078370385,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0072993473,
				"type": "PERSON"
			},
			{
				"name": "Thepoliticalinsider.com",
				"salience": 0.0072993473,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0072993473,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0067894123,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.0067894123,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.006179405,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/056rs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim_Brotherhood"
				},
				"name": "Muslim Brotherhood",
				"salience": 0.0051226355,
				"type": "ORGANIZATION"
			},
			{
				"name": "insurgency",
				"salience": 0.0050756023,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.004931811,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "Al Qaeda",
				"salience": 0.0047514956,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons shipments",
				"salience": 0.0042704553,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Gaddafi",
				"salience": 0.004183551,
				"type": "PERSON"
			},
			{
				"name": "regime change",
				"salience": 0.003698691,
				"type": "EVENT"
			},
			{
				"name": "oath",
				"salience": 0.003698691,
				"type": "OTHER"
			},
			{
				"name": "tesrce",
				"salience": 0.003698691,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.003126467,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.003126467,
				"type": "ORGANIZATION"
			},
			{
				"name": "role",
				"salience": 0.0029076159,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j44hwc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Friends_of_Syria_Group"
				},
				"name": "Friends of Syria",
				"salience": 0.002137856,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Assad",
				"salience": 0.0019651381,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774969621.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:50:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.1,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAlthough Hillary Clinton has repeatedly denied that she sold weapons to the Islamic Stats while serving as Secretary of State, Wikileaks founder Julian Assange claims he has proof to the contrary. \nThepoliticalinsider.com reported: In Obama’s second term, Secretary of State Hillary Clinton authorized the shipment of American-made arms to Qatar, a country beholden to the Muslim Brotherhood, and friendly to the Libyan rebels, in an effort to topple the Libyan/Gaddafi government, and then ship those arms to Syria in order to fund Al Qaeda, and topple Assad in Syria. \nClinton took the lead role in organizing the so-called “Friends of Syria” (aka Al Qaeda/ISIS) to back the CIA-led insurgency for regime change in Syria. \nUnder oath Hillary Clinton denied she knew about the weapons shipments during public tesrce.",
		"thread_title": "Hillary Sold Weapons To ISIS, Wikileaks Confirms",
		"title": "Hillary Sold Weapons To ISIS, Wikileaks Confirms",
		"type": "conspiracy",
		"uuid": "498724ee722a2de6c0f61f5ab669d9461b749922"
	},
	"-KhIjJivUrguJkVfTBhQ": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:58.826+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.49929032,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.14317,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.06072353,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.034784846,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.020683447,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.01793851,
				"type": "WORK_OF_ART"
			},
			{
				"name": "concern",
				"salience": 0.016212653,
				"type": "OTHER"
			},
			{
				"name": "boss",
				"salience": 0.014056024,
				"type": "PERSON"
			},
			{
				"name": "notes",
				"salience": 0.014056024,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.008760947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.008677463,
				"type": "ORGANIZATION"
			},
			{
				"name": "health",
				"salience": 0.00857211,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0073891166,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.0066787917,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.0060183057,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0058857924,
				"type": "EVENT"
			},
			{
				"name": "reporters",
				"salience": 0.0058118477,
				"type": "PERSON"
			},
			{
				"name": "messaging",
				"salience": 0.0058118477,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.0058118477,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.0058118477,
				"type": "PERSON"
			},
			{
				"name": "conservativefiringline.com",
				"salience": 0.0052210675,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.005213499,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0050193793,
				"type": "WORK_OF_ART"
			},
			{
				"name": "post",
				"salience": 0.0045330822,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fall",
				"salience": 0.0040783775,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0040783775,
				"type": "OTHER"
			},
			{
				"name": "episode",
				"salience": 0.0040783775,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0120w9bh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jennifer_Palmieri"
				},
				"name": "Jennifer Palmieri",
				"salience": 0.0040673357,
				"type": "PERSON"
			},
			{
				"name": "post-concussion syndrome",
				"salience": 0.0039010393,
				"type": "OTHER"
			},
			{
				"name": "Jeb Bush Super PAC",
				"salience": 0.003581163,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.003330607,
				"type": "EVENT"
			},
			{
				"name": "tape",
				"salience": 0.003330607,
				"type": "OTHER"
			},
			{
				"name": "health scare",
				"salience": 0.003330607,
				"type": "OTHER"
			},
			{
				"name": "dehydration",
				"salience": 0.003330607,
				"type": "OTHER"
			},
			{
				"name": "pneumonia",
				"salience": 0.003330607,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.002873879,
				"type": "OTHER"
			},
			{
				"name": "law-enforcement source",
				"salience": 0.002873879,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0027123487,
				"type": "PERSON"
			},
			{
				"name": "bathroom break",
				"salience": 0.0026183068,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07p6zym"
				},
				"name": "First Lady",
				"salience": 0.0025764871,
				"type": "PERSON"
			},
			{
				"name": "health issues",
				"salience": 0.0024889412,
				"type": "OTHER"
			},
			{
				"name": "connections",
				"salience": 0.0024889412,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0024889412,
				"type": "PERSON"
			},
			{
				"name": "Heat Street",
				"salience": 0.0024183528,
				"type": "LOCATION"
			},
			{
				"name": "concussion",
				"salience": 0.0020937463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.002051099,
				"type": "LOCATION"
			},
			{
				"name": "brain injury",
				"salience": 0.0018131895,
				"type": "OTHER"
			},
			{
				"name": "neurologist",
				"salience": 0.0018131895,
				"type": "PERSON"
			},
			{
				"name": "blood clot",
				"salience": 0.0018131895,
				"type": "OTHER"
			},
			{
				"name": "abilities",
				"salience": 0.0018131895,
				"type": "OTHER"
			},
			{
				"name": "debate stage",
				"salience": 0.001564352,
				"type": "OTHER"
			},
			{
				"name": "symptoms",
				"salience": 0.0015377523,
				"type": "OTHER"
			},
			{
				"name": "disappearance",
				"salience": 0.0013546754,
				"type": "EVENT"
			},
			{
				"name": "ailment",
				"salience": 0.0013546754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "New York Post",
				"salience": 0.0010130915,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.00083387736,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.00083387736,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774968271.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nIn an email released by Wikileaks, top Hillary Clinton aide Huma Abedin seemed to express concern for the health of her boss. \n“She’s going to stick to notes a little closer this am, still not perfect in her head,” Abedin told Podesta and others in a discussion on messaging to reporters about a Jeb Bush Super PAC. \nIt appears that Abedin wasn’t the only person concerned about Hillary’s health. \nIn an email dated September 26, 2015, John Podesta asked Jennifer Palmieri, “How bad is her head?” \nPalmieri responded, “Don’t know.” \nA post at Heat Street observed: \nHillary Clinton suffered a “cracked head” (her words) after suffering a fall in December 2012. Many have speculated about her health since that episode, and questions grew louder in September of this year when Hillary was caught on tape nearly collapsing at a 9/11 memorial event in Manhattan. \nAfter initially blaming the health scare on “dehydration,” the campaign was forced to acknowledge the candidate had been diagnosed with pneumonia. \n“It was unclear whether Abedin was referring to a serious ailment,” the New York Post added. \nIn January 2016, Breitbart reported: \nDemocrat frontrunner Hillary Clinton’s disappearance from the debate stage last month left people speculating that the former First Lady took a long bathroom break, but now a law-enforcement source with inside connections is alleging that Clinton was missing from the stage due to health issues stemming from a previous brain injury. \nThese long-lasting symptoms stemming from a concussion and blood clot, according to a neurologist, suggest Clinton is suffering from post-concussion syndrome, which can severely impact her cognitive abilities. \nSource: conservativefiringline.com",
		"thread_title": "Top aide: Hillary ‘still not perfect in her head’, Wikileaks",
		"title": "Top aide: Hillary ‘still not perfect in her head’, Wikileaks",
		"type": "conspiracy",
		"uuid": "ef178bc7fd0636c3defe9563b5e411b87fe33864"
	},
	"-KhIjJrO167SdqbZW7hR": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:58.901+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.10050955,
				"type": "ORGANIZATION"
			},
			{
				"name": "Steven Mnuchin",
				"salience": 0.09028836,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.07882293,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.07582282,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.047473807,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.043453943,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.042151563,
				"type": "PERSON"
			},
			{
				"name": "events",
				"salience": 0.04125075,
				"type": "EVENT"
			},
			{
				"name": "fundraising events",
				"salience": 0.03594114,
				"type": "EVENT"
			},
			{
				"name": "fundraising committee",
				"salience": 0.024993313,
				"type": "ORGANIZATION"
			},
			{
				"name": "nominee",
				"salience": 0.024421081,
				"type": "PERSON"
			},
			{
				"name": "Aides",
				"salience": 0.024421081,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.024421081,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.024421081,
				"type": "EVENT"
			},
			{
				"name": "move",
				"salience": 0.021664549,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.020834107,
				"type": "PERSON"
			},
			{
				"name": "Trump Victory",
				"salience": 0.019660851,
				"type": "PERSON"
			},
			{
				"name": "fundraiser",
				"salience": 0.017185377,
				"type": "EVENT"
			},
			{
				"name": "fundraising",
				"salience": 0.016757179,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.01396178,
				"type": "EVENT"
			},
			{
				"name": "money",
				"salience": 0.011653704,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.010189124,
				"type": "ORGANIZATION"
			},
			{
				"name": "source",
				"salience": 0.010095642,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0098008085,
				"type": "EVENT"
			},
			{
				"name": "Lindsay Walters",
				"salience": 0.009378066,
				"type": "PERSON"
			},
			{
				"name": "fundraising events",
				"salience": 0.008647832,
				"type": "EVENT"
			},
			{
				"name": "campaign events",
				"salience": 0.008539117,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01z6ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitch_McConnell"
				},
				"name": "Mitch McConnell",
				"salience": 0.007855857,
				"type": "PERSON"
			},
			{
				"name": "pitch",
				"salience": 0.007174418,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.0070841825,
				"type": "OTHER"
			},
			{
				"name": "houses",
				"salience": 0.006820214,
				"type": "LOCATION"
			},
			{
				"name": "hold",
				"salience": 0.006820214,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.006679494,
				"type": "EVENT"
			},
			{
				"name": "voters",
				"salience": 0.006679494,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.006512501,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0062418296,
				"type": "ORGANIZATION"
			},
			{
				"name": "fundraising schedule",
				"salience": 0.0057851975,
				"type": "OTHER"
			},
			{
				"name": "real estate mogul",
				"salience": 0.0057851975,
				"type": "PERSON"
			},
			{
				"name": "fundraising appearance",
				"salience": 0.0052278033,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2v0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami"
				},
				"name": "Miami",
				"salience": 0.004363265,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03lcyd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.004363265,
				"type": "PERSON"
			},
			{
				"name": "ticket",
				"salience": 0.004323157,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.004200542,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01w5q_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_National_Committee"
				},
				"name": "Republican National Committee",
				"salience": 0.003945535,
				"type": "ORGANIZATION"
			},
			{
				"name": "paper",
				"salience": 0.0039064465,
				"type": "ORGANIZATION"
			},
			{
				"name": "races",
				"salience": 0.0036366917,
				"type": "EVENT"
			},
			{
				"name": "events",
				"salience": 0.003474873,
				"type": "EVENT"
			},
			{
				"name": "balance",
				"salience": 0.003398179,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0032648195,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.0031493634,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0031493634,
				"type": "OTHER"
			},
			{
				"name": "Trump Victory",
				"salience": 0.0030737284,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.002661773,
				"type": "ORGANIZATION"
			},
			{
				"name": "Senate Leadership Fund",
				"salience": 0.0025988987,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02pkff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Capitol_Hill"
				},
				"name": "Capitol hill",
				"salience": 0.002479629,
				"type": "LOCATION"
			},
			{
				"name": "focus",
				"salience": 0.002352937,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.002352937,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0498y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kentucky"
				},
				"name": "Ky.",
				"salience": 0.0019387789,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01btlh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Political_action_committee"
				},
				"name": "Super PAC",
				"salience": 0.0019387789,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774955081.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:25:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nDonald Trump’s campaign has ended fundraising events meant to support the Republican Party’s get-out-the-vote efforts in next month’s elections. \nAides to the Republican nominee told Fox News that Trump Victory, the joint fundraising committee for the GOP and the campaign, held its most recent fundraiser on Oct. 19 and no more such events were scheduled. \nThe move, which was first reported by The Washington Post, cuts off a key money source for Republicans hoping to keep hold of both houses of Congress. \n“We’ve kind of wound down,” Trump national finance chairman Steven Mnuchin told the Post. “But the online fundraising continues to be strong.” \nBy contrast, the Post reported that Democrat Hillary Clinton’s campaign has scheduled 41 fundraising events between now and Nov. 4. The former secretary of state was scheduled to make her last personal fundraising appearance Tuesday in Miami. \nMnuchin told the paper that the real estate mogul was focusing on making his final pitch to the voters at a campaign events rather than raising money in the final two weeks of the race. \n“We have minimized his fundraising schedule over the last month to emphasize his focus on political [events],” Mnuchin said of the candidate. “Unlike Hillary, who has been fundraising and not out and about, he has constantly been out and about.” \nAccording to the Post, the Republican National Committee had collected $40 million through Trump Victory as of Sept. 30. \nRNC spokeswoman Lindsay Walters said the organization “[continues] to fundraise for the entire GOP ticket.” \nMeanwhile, Politico reported Tuesday that the Senate Leadership Fund, a Super PAC with ties to Senate Majority Leader Mitch McConnell, R-Ky., was putting $25 million into seven Senate races deemed crucial in determining the balance of power on Capitol hill.",
		"thread_title": "TRUMP CUTS OFF FUNDRAISING EVENTS FOR REPUBLICAN PARTY",
		"title": "TRUMP CUTS OFF FUNDRAISING EVENTS FOR REPUBLICAN PARTY",
		"type": "conspiracy",
		"uuid": "3de5da424e200f975e982dc9f8a8d7cde15309d8"
	},
	"-KhIjKGHCoi3f4cDNgLR": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:58.960+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0127xng6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Creamer_(Lobbyist)"
				},
				"name": "Robert Creamer",
				"salience": 0.18835574,
				"type": "PERSON"
			},
			{
				"name": "Mook",
				"salience": 0.13652867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.10524016,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.083807856,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.040381208,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0338916,
				"type": "PERSON"
			},
			{
				"name": "consultant",
				"salience": 0.029651893,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.028664658,
				"type": "ORGANIZATION"
			},
			{
				"name": "operatives",
				"salience": 0.02854683,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.026500732,
				"type": "EVENT"
			},
			{
				"name": "Matthew Boyle",
				"salience": 0.021334395,
				"type": "PERSON"
			},
			{
				"name": "mascot",
				"salience": 0.020759378,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gln",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Duck"
				},
				"name": "Donald Duck",
				"salience": 0.014806083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.012810878,
				"type": "ORGANIZATION"
			},
			{
				"name": "Democracy Partners",
				"salience": 0.00915814,
				"type": "ORGANIZATION"
			},
			{
				"name": "election law",
				"salience": 0.00896537,
				"type": "OTHER"
			},
			{
				"name": "activist",
				"salience": 0.008883384,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.008578515,
				"type": "EVENT"
			},
			{
				"name": "spin room",
				"salience": 0.008578515,
				"type": "LOCATION"
			},
			{
				"name": "firm",
				"salience": 0.008578515,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.008578515,
				"type": "ORGANIZATION"
			},
			{
				"name": "action",
				"salience": 0.008445139,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.007408384,
				"type": "EVENT"
			},
			{
				"name": "activist",
				"salience": 0.007255586,
				"type": "PERSON"
			},
			{
				"name": "violation",
				"salience": 0.007037814,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.006949309,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00691833,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0060191043,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0060191043,
				"type": "OTHER"
			},
			{
				"name": "media attention",
				"salience": 0.0060191043,
				"type": "OTHER"
			},
			{
				"name": "costume",
				"salience": 0.0060191043,
				"type": "WORK_OF_ART"
			},
			{
				"name": "operations",
				"salience": 0.0058949003,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.005805333,
				"type": "ORGANIZATION"
			},
			{
				"name": "video",
				"salience": 0.005330751,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0052851005,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart News",
				"salience": 0.0052851005,
				"type": "ORGANIZATION"
			},
			{
				"name": "argument",
				"salience": 0.0049152407,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0049152407,
				"type": "EVENT"
			},
			{
				"name": "ducks",
				"salience": 0.004317403,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s76_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_O'Keefe"
				},
				"name": "Project Veritas",
				"salience": 0.004280417,
				"type": "PERSON"
			},
			{
				"name": "contributors",
				"salience": 0.0041948305,
				"type": "PERSON"
			},
			{
				"name": "ducks",
				"salience": 0.003951029,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0037035707,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0037035707,
				"type": "LOCATION"
			},
			{
				"name": "executive role",
				"salience": 0.0036729088,
				"type": "OTHER"
			},
			{
				"name": "duck stunt",
				"salience": 0.0036729088,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.0036729088,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0034370136,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.003421673,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tax returns",
				"salience": 0.0034040236,
				"type": "OTHER"
			},
			{
				"name": "O'Keefe",
				"salience": 0.0031043906,
				"type": "PERSON"
			},
			{
				"name": "campaigns",
				"salience": 0.0025564986,
				"type": "EVENT"
			},
			{
				"name": "taxes",
				"salience": 0.001998922,
				"type": "OTHER"
			},
			{
				"name": "dark money",
				"salience": 0.001998922,
				"type": "OTHER"
			},
			{
				"name": "Veritas Action",
				"salience": 0.0018173783,
				"type": "OTHER"
			},
			{
				"name": "video footage",
				"salience": 0.0016738178,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0016470581,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0016470581,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774953331.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:22:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nHillary Clinton personally ordered a consultant to use a nonprofit group to troll the Trump campaign with a ‘Donald Duck’ mascot, according to the Democratic operatives who say they arranged it with a nonprofit organization. \nWhen Breitbart News’ Washington political editor, Matthew Boyle, confronted Mook about Creamer and his firm in the spin room after the third presidential debate, Mook claimed: “They’ve never worked for our campaign.” When asked if Clinton had ever discussed the controversial political operations with Creamer directly, Mook replied: “I don’t think so.” \nNow, however, O’Keefe and Project Veritas have released video of Creamer claiming that Clinton directly approved one of his more bizarre plans — an effort to attract media attention and incite violence by dressing an activist in a Donald Duck costume and sending that activist into Trump events, emphasizing the argument that Trump was “ducking” releasing his tax returns. \nThe action, if true, would be a black-letter violation of federal election law, which prohibits presidential campaigns from coordinating activities with outside groups that can collect unlimited ‘dark money’ from contributors – and don’t pay taxes on what they collect. \nProject Veritas Action video footage shows Robert Creamer, a convicted felon who was forced out of his executive role at the liberal consultancy Democracy Partners, saying Clinton chose the duck stunt. \n‘In the end, it was the candidate, Hillary Clinton, the future president of the United States, who wanted ducks on the ground. So by God we would get ducks on the ground,’ Creamer says in the video.",
		"thread_title": "Hillary Personally Ordered ‘Donald Duck’ Troll Campaign",
		"title": "Hillary Personally Ordered ‘Donald Duck’ Troll Campaign",
		"type": "conspiracy",
		"uuid": "05c1e53dae6ed861b6c7b9d558a34d9876a81202"
	},
	"-KhIjKQ0BJzefdIl3wBy": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:59.000+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.5546552,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.34929627,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.01316185,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.011550614,
				"type": "OTHER"
			},
			{
				"name": "tracking poll",
				"salience": 0.0068849195,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0059469505,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x0yg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Inflammatory_bowel_disease"
				},
				"name": "IBD",
				"salience": 0.0051984047,
				"type": "ORGANIZATION"
			},
			{
				"name": "TIPP",
				"salience": 0.0037713388,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0031048246,
				"type": "PERSON"
			},
			{
				"name": "Men",
				"salience": 0.0028392465,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0028392465,
				"type": "PERSON"
			},
			{
				"name": "matchup",
				"salience": 0.0024597938,
				"type": "EVENT"
			},
			{
				"name": "support",
				"salience": 0.0023879844,
				"type": "OTHER"
			},
			{
				"name": "blacks",
				"salience": 0.0019928867,
				"type": "PERSON"
			},
			{
				"name": "blacks",
				"salience": 0.0019928867,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0019431018,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0019186763,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.0018109548,
				"type": "PERSON"
			},
			{
				"name": "blocs",
				"salience": 0.0017262511,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.0016619447,
				"type": "OTHER"
			},
			{
				"name": "Whites",
				"salience": 0.0016619447,
				"type": "PERSON"
			},
			{
				"name": "favor",
				"salience": 0.0016276628,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.0016276628,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0016276628,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0014579986,
				"type": "OTHER"
			},
			{
				"name": "pollsters",
				"salience": 0.0014579986,
				"type": "PERSON"
			},
			{
				"name": "income",
				"salience": 0.0014097879,
				"type": "OTHER"
			},
			{
				"name": "look",
				"salience": 0.0014097879,
				"type": "OTHER"
			},
			{
				"name": "tracking poll",
				"salience": 0.001062356,
				"type": "OTHER"
			},
			{
				"name": "tracking poll",
				"salience": 0.001062356,
				"type": "OTHER"
			},
			{
				"name": "backing",
				"salience": 0.0010535632,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.000988903,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0008862931,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.00079381524,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00079381524,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0007675412,
				"type": "EVENT"
			},
			{
				"name": "error",
				"salience": 0.0007675412,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.00064872095,
				"type": "PERSON"
			},
			{
				"name": "TIPP",
				"salience": 0.00060433336,
				"type": "ORGANIZATION"
			},
			{
				"name": "independents",
				"salience": 0.00057345885,
				"type": "PERSON"
			},
			{
				"name": "tie",
				"salience": 0.00057345885,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774951651.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:19:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nThe daily IBD/TIPP tracking poll, updated Sunday, shows Republican presidential nominee Donald Trump leading challenger Hillary Clinton 43 percent to 41 percent in a race that also includes third-party candidates. \nIn a head-to-head matchup, Trump leads Clinton 43.2 percent to 42.3 percent, with 10 percent unsure. \nMen back Trump over Clinton 48 percent to 34 percent, with women supporting Clinton 46 percent to 38 percent. \nWhites back Trump over Clinton, 50 percent to 33 percent. White men back Trump, 55 percent to 27 percent and a majority of white women also support Trump over Clinton, 46 percent to 39 percent. \nFifteen percent of blacks and Hispanics back Trump over Clinton, while she earns 65 percent of those blocs’ support. Broken down, 11 percent of blacks support Trump, and 22 percent of Hispanics support him. \nTaking a look at income, likely voters making $50,000 or less each year favor Trump, while those making more than $75,000 a year favor Clinton. Of those earning between $50,000 and $75,000, 43 percent support Clinton, while 41 percent support Trump – a statistical tie. \nAmong independents, Trump leads Clinton 44 percent to 31 percent. Among Republicans, Trump gets 84 percent support, with eight percent backing Clinton. This while only 77 percent of Democrats support Clinton, with nine percent saying they plan to vote Trump. \nIBD/TIPP tracking pollsters questioned 783 likely voters from Oct. 17 to Oct. 22. The margin of error is plus or minus 3.6 percentage points. \nThe IBD/TIPP tracking poll has been billed as the most accurate presidential election tracking poll.",
		"thread_title": "IBD/TIPP Tracking Poll: Trump Leads Clinton with 43 Percent Support",
		"title": "IBD/TIPP Tracking Poll: Trump Leads Clinton with 43 Percent Support",
		"type": "conspiracy",
		"uuid": "78f38426c8d259bea0e3e779d10e9339b8374f9f"
	},
	"-KhIjKZa_Z5BpV3WU97G": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:59.087+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02dgtb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terry_McAuliffe"
				},
				"name": "Terry McAuliffe",
				"salience": 0.411545,
				"type": "PERSON"
			},
			{
				"name": "Jill McCabe",
				"salience": 0.16577305,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.065427296,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.05124892,
				"type": "OTHER"
			},
			{
				"name": "official",
				"salience": 0.028633423,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.023006741,
				"type": "ORGANIZATION"
			},
			{
				"name": "ties",
				"salience": 0.023006741,
				"type": "OTHER"
			},
			{
				"name": "Dr.",
				"salience": 0.02203987,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0288lcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_of_Virginia"
				},
				"name": "Virginia Democratic Party",
				"salience": 0.017949322,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.016409736,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03lcyd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.016409736,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "WSJ",
				"salience": 0.014225375,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill",
				"salience": 0.014225375,
				"type": "PERSON"
			},
			{
				"name": "election campaign",
				"salience": 0.014053095,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.009873724,
				"type": "EVENT"
			},
			{
				"name": "wife",
				"salience": 0.009535578,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "Federal Bureau of Investigation",
				"salience": 0.0087768985,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0074402574,
				"type": "EVENT"
			},
			{
				"name": "committee",
				"salience": 0.0064456724,
				"type": "ORGANIZATION"
			},
			{
				"name": "email use",
				"salience": 0.0064456724,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.006312841,
				"type": "OTHER"
			},
			{
				"name": "Campaign finance records",
				"salience": 0.006233524,
				"type": "OTHER"
			},
			{
				"name": "Andrew McCabe",
				"salience": 0.0057077482,
				"type": "PERSON"
			},
			{
				"name": "deputy director",
				"salience": 0.005468519,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.0047192452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053fc5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Senate_of_Virginia"
				},
				"name": "Senate",
				"salience": 0.004125483,
				"type": "ORGANIZATION"
			},
			{
				"name": "entities",
				"salience": 0.00408759,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidacy",
				"salience": 0.00408759,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0037885972,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0032860332,
				"type": "EVENT"
			},
			{
				"name": "campaign funds",
				"salience": 0.002978389,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.002978389,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0025698284,
				"type": "OTHER"
			},
			{
				"name": "third",
				"salience": 0.0022826418,
				"type": "OTHER"
			},
			{
				"name": "mailers",
				"salience": 0.0022255199,
				"type": "WORK_OF_ART"
			},
			{
				"name": "form",
				"salience": 0.0022255199,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0022255199,
				"type": "OTHER"
			},
			{
				"name": "worth",
				"salience": 0.0022255199,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774948011.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:13:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.4,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nWSJ The political organization of Virginia Gov. Terry McAuliffe, an influential Democrat with longstanding ties to Bill and Hillary Clinton, gave nearly $500,000 to the election campaign of the wife of an official at the Federal Bureau of Investigation who later helped oversee the investigation into Mrs. Clinton’s email use. \nCampaign finance records show Mr. McAuliffe’s political-action committee donated $467,500 to the 2015 state Senate campaign of Dr. Jill McCabe, who is married to Andrew McCabe, now the deputy director of the FBI. \nThe Virginia Democratic Party, over which Mr. McAuliffe exerts considerable control, donated an additional $207,788 worth of support to Dr. McCabe’s campaign in the form of mailers, according to the records. That adds up to slightly more than $675,000 to her candidacy from entities either directly under Mr. McAuliffe’s control or strongly influenced by him. The figure represents more than a third of all the campaign funds Dr. McCabe raised in the effort",
		"thread_title": "Hillary Friend Bribed FBI Agent and His Wife",
		"title": "Hillary Friend Bribed FBI Agent and His Wife",
		"type": "conspiracy",
		"uuid": "b37f6ba0ee190261558ae4a48b7ba525c4dda9a8"
	},
	"-KhIjKldv6ucoj90ne7K": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:59.268+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05y7nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turki_bin_Faisal_Al_Saud"
				},
				"name": "Turki bin Faisal Al Saud",
				"salience": 0.27242458,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.099228196,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.06452842,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06437234,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.047214046,
				"type": "OTHER"
			},
			{
				"name": "prince",
				"salience": 0.034522936,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.034522936,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudia Arabia",
				"salience": 0.033520084,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.02724694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.023618527,
				"type": "PERSON"
			},
			{
				"name": "cooperation",
				"salience": 0.020521883,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turk",
				"salience": 0.015448929,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.013968475,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.013968475,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.012003404,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.009213769,
				"type": "PERSON"
			},
			{
				"name": "gulf nations",
				"salience": 0.009029798,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.008264479,
				"type": "PERSON"
			},
			{
				"name": "King Faisal Center for Research and Islamic Studies",
				"salience": 0.007873467,
				"type": "ORGANIZATION"
			},
			{
				"name": "donors",
				"salience": 0.00743842,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0064913817,
				"type": "LOCATION"
			},
			{
				"name": "patriot",
				"salience": 0.00576237,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lets",
				"salience": 0.00576237,
				"type": "ORGANIZATION"
			},
			{
				"name": "road",
				"salience": 0.00576237,
				"type": "LOCATION"
			},
			{
				"name": "ambassador",
				"salience": 0.00576237,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0053646625,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0051682526,
				"type": "LOCATION"
			},
			{
				"name": "foundation",
				"salience": 0.0045676753,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, DC",
				"salience": 0.004186909,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.004041703,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0038909514,
				"type": "OTHER"
			},
			{
				"name": "vow",
				"salience": 0.0038909514,
				"type": "OTHER"
			},
			{
				"name": "proposal",
				"salience": 0.0038909514,
				"type": "OTHER"
			},
			{
				"name": "foreign policy dinner",
				"salience": 0.0038909514,
				"type": "EVENT"
			},
			{
				"name": "nominee",
				"salience": 0.0038909514,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0038105913,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.0038105913,
				"type": "PERSON"
			},
			{
				"name": "investment partners",
				"salience": 0.0036937632,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0036937632,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.0035966497,
				"type": "ORGANIZATION"
			},
			{
				"name": "conference",
				"salience": 0.00351584,
				"type": "EVENT"
			},
			{
				"name": "extent",
				"salience": 0.00351584,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.003299969,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.003299969,
				"type": "PERSON"
			},
			{
				"name": "speeches",
				"salience": 0.003299969,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0030028222,
				"type": "ORGANIZATION"
			},
			{
				"name": "King",
				"salience": 0.0028470801,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hmrpgb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Huffington_Post"
				},
				"name": "Huffington Post",
				"salience": 0.0024883554,
				"type": "ORGANIZATION"
			},
			{
				"name": "library",
				"salience": 0.0024654674,
				"type": "LOCATION"
			},
			{
				"name": "board",
				"salience": 0.0024654674,
				"type": "ORGANIZATION"
			},
			{
				"name": "campus",
				"salience": 0.0024654674,
				"type": "LOCATION"
			},
			{
				"name": "classmate",
				"salience": 0.0024654674,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0024470377,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00243441,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.0023954976,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0023954976,
				"type": "ORGANIZATION"
			},
			{
				"name": "research",
				"salience": 0.002384109,
				"type": "OTHER"
			},
			{
				"name": "firms",
				"salience": 0.0023540757,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0023460002,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0022967423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qataris",
				"salience": 0.0022200411,
				"type": "LOCATION"
			},
			{
				"name": "politics",
				"salience": 0.0020737713,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatari",
				"salience": 0.0020315067,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "UAE",
				"salience": 0.0020315067,
				"type": "LOCATION"
			},
			{
				"name": "heritage",
				"salience": 0.0017957508,
				"type": "OTHER"
			},
			{
				"name": "sociology",
				"salience": 0.0017957508,
				"type": "OTHER"
			},
			{
				"name": "chairman",
				"salience": 0.0017957508,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0017957508,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bwfn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_University"
				},
				"name": "New York University",
				"salience": 0.0017526046,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026swz9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cheryl_Mills"
				},
				"name": "Cheryl Mills",
				"salience": 0.0017526046,
				"type": "PERSON"
			},
			{
				"name": "defense firms",
				"salience": 0.0015491991,
				"type": "ORGANIZATION"
			},
			{
				"name": "weapons deals",
				"salience": 0.0015422795,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ftvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Little_Rock,_Arkansas"
				},
				"name": "Little Rock",
				"salience": 0.0015176204,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Morocco",
				"salience": 0.0015176204,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/054rw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marrakesh"
				},
				"name": "Marrakech",
				"salience": 0.0015176204,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gxj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abu_Dhabi"
				},
				"name": "Abu Dhabi",
				"salience": 0.0015176204,
				"type": "LOCATION"
			},
			{
				"name": "projects",
				"salience": 0.0013414753,
				"type": "OTHER"
			},
			{
				"name": "collaboration",
				"salience": 0.0013414753,
				"type": "OTHER"
			},
			{
				"name": "advisers",
				"salience": 0.0013414753,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.0013414753,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0pspl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgetown_University"
				},
				"name": "Georgetown University",
				"salience": 0.0012764502,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0240lv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Saud"
				},
				"name": "Saudi Royal family",
				"salience": 0.0011052849,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774946001.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T23:10:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nA Saudi prince has urged Americans not to vote for Donald Trump in the upcoming general election. He practically beggs the people to give their votes for Hillary Clinton. For us, this is a HUGE reason NOT TO VOTE FOR HILLARY! She got $50 million from this man. I guess you know what am I talking about. Do not let their cooperation continue, because it is going to end up bad for America. Lets choose a true patriot and see where would our country go! I am sure it is going to be much better than crooked Hillary’s road. \nTurki al-Faisal, who served as Saudia Arabia’s ambassador to the US from 2005 to 2007, spoke against the presumptive Republican nominee during a foreign policy dinner in Washington, DC on Thursday. \nHe blasted Trump’s proposal to ban Muslims from entering the US, which the billionaire first formulated in December last year before renewing his vow on Wednesday. \n‘For the life of me, I cannot believe that a country like the United States can afford to have someone as president who simply says, “These people are not going to be allowed to come to the United States,”’ Turki said according to the Huffington Post. \n‘It’s up to you, it’s not up to me,’ Turki added. ‘I just hope you, as American citizens, will make the right choice in November.’ \nThe gulf nations represent three of the largest donors to the foundation, but that is hardly the extent of their ties to the Clintons. Qatari, UAE, and Saudi firms paid Bill Clinton millions of dollars for speeches during the time Hillary served as secretary of state, when she also approved weapons deals with all three countries worth billions of dollars to U.S. defense firms, many of which are also Clinton Foundation donors. \nBill Clinton has praised the Qataris as “intelligent, forward looking” investment partners for their collaboration on Clinton Foundation projects. One of Hillary’s top advisers, Cheryl Mills, served on the board of the New York \nUniversity campus in Abu Dhabi. Bill Clinton is the friend and former classmate of Saudi Prince Turki bin Faisal Al Saud, who recently attended a lavish Clinton Foundation conference in Marrakech, hosted by the King of Morocco. The Bill Clinton presidential library in Little Rock was funded in part by a $10 million from the Saudi Royal family. \nTurk, who went to Georgetown University in Washington, DC, isn’t currently part of Saudia Arabia’s government but serves as the chairman of the King Faisal Center for Research and Islamic Studies, a cultural organization that conducts research in politics, sociology and heritage.",
		"thread_title": "Arab Prince Who Gave Hillary $50 Million Begs Americans Not to Vote for Trump",
		"title": "Arab Prince Who Gave Hillary $50 Million Begs Americans Not to Vote for Trump",
		"type": "conspiracy",
		"uuid": "c70ceeace8aaa875561456ce3663054053407063"
	},
	"-KhIjKu5D11uURMGChgH": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:59.520+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "heritage",
				"salience": 0.22640094,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.2039041,
				"type": "LOCATION"
			},
			{
				"name": "conference",
				"salience": 0.0536755,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.042147264,
				"type": "WORK_OF_ART"
			},
			{
				"name": "brotherhood",
				"salience": 0.036571763,
				"type": "OTHER"
			},
			{
				"name": "coexistence",
				"salience": 0.036571763,
				"type": "OTHER"
			},
			{
				"name": "Mehdi Ahmed Al-Sumaidaie",
				"salience": 0.022944562,
				"type": "PERSON"
			},
			{
				"name": "hatred",
				"salience": 0.018796435,
				"type": "OTHER"
			},
			{
				"name": "hostility",
				"salience": 0.018796435,
				"type": "OTHER"
			},
			{
				"name": "spirit",
				"salience": 0.018796435,
				"type": "OTHER"
			},
			{
				"name": "discord",
				"salience": 0.018796435,
				"type": "OTHER"
			},
			{
				"name": "instigators",
				"salience": 0.016673036,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.012954842,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.011183182,
				"type": "LOCATION"
			},
			{
				"name": "gap",
				"salience": 0.008702462,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.007865048,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0077661863,
				"type": "EVENT"
			},
			{
				"name": "bloodshed",
				"salience": 0.0077661863,
				"type": "OTHER"
			},
			{
				"name": "Security valves",
				"salience": 0.0077661863,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.0077661863,
				"type": "OTHER"
			},
			{
				"name": "extremism",
				"salience": 0.0077661863,
				"type": "OTHER"
			},
			{
				"name": "sectarianism",
				"salience": 0.0077661863,
				"type": "OTHER"
			},
			{
				"name": "decisions",
				"salience": 0.007368103,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.006706762,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.006568423,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0062911287,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.006056722,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.006056722,
				"type": "WORK_OF_ART"
			},
			{
				"name": "security",
				"salience": 0.0056892172,
				"type": "OTHER"
			},
			{
				"name": "stability",
				"salience": 0.005448963,
				"type": "OTHER"
			},
			{
				"name": "reconciliation",
				"salience": 0.005448963,
				"type": "OTHER"
			},
			{
				"name": "bigotry",
				"salience": 0.005448963,
				"type": "OTHER"
			},
			{
				"name": "quotas",
				"salience": 0.005448963,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.005448963,
				"type": "OTHER"
			},
			{
				"name": "decision-makers",
				"salience": 0.005245873,
				"type": "PERSON"
			},
			{
				"name": "property",
				"salience": 0.005245873,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.005099248,
				"type": "EVENT"
			},
			{
				"name": "Takfir",
				"salience": 0.004784442,
				"type": "OTHER"
			},
			{
				"name": "Marja'iat",
				"salience": 0.004784442,
				"type": "PERSON"
			},
			{
				"name": "honor",
				"salience": 0.0047017965,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.004621916,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.004449599,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.004449599,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0042517013,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.0042517013,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.0042517013,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.003859168,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0038392665,
				"type": "OTHER"
			},
			{
				"name": "mufti",
				"salience": 0.0034977635,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni",
				"salience": 0.003355759,
				"type": "OTHER"
			},
			{
				"name": "motto",
				"salience": 0.003324907,
				"type": "OTHER"
			},
			{
				"name": "solidarity",
				"salience": 0.003324907,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.003324907,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.003324907,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.0031912138,
				"type": "EVENT"
			},
			{
				"name": "integration",
				"salience": 0.003097466,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.003097466,
				"type": "OTHER"
			},
			{
				"name": "honor",
				"salience": 0.0029798388,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.0027968788,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0027968788,
				"type": "PERSON"
			},
			{
				"name": "dignity",
				"salience": 0.0024220434,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.0024220434,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0024220434,
				"type": "OTHER"
			},
			{
				"name": "homeland",
				"salience": 0.0024220434,
				"type": "LOCATION"
			},
			{
				"name": "figures",
				"salience": 0.0024220434,
				"type": "OTHER"
			},
			{
				"name": "tribes",
				"salience": 0.0024220434,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.002314243,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.002089602,
				"type": "ORGANIZATION"
			},
			{
				"name": "talk",
				"salience": 0.0018094901,
				"type": "OTHER"
			},
			{
				"name": "affairs",
				"salience": 0.0018094901,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013027rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Popular_Mobilization_Forces_(Iraq)"
				},
				"name": "al-Hashd al-Shaabi",
				"salience": 0.0011137893,
				"type": "PERSON"
			},
			{
				"name": "sheikhs",
				"salience": 0.0010226867,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774921141.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T22:28:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email Final statement of the conference stressed on brotherhood and peaceful coexistence. It stated what Iraq is witnessing today is nothing but discord, a spirit of hostility and hatred, which is heritage of instigators who have created a gap, difference, extremism, Takfir and sectarianism. It considered Marja’iat as “Security valves” to stop the war and bloodshed, and also to protect the honor and property. According to the statement, Iraqi elite of scholars and decision-makers gathered to discuss the current situation and make the right decisions which realized Iraq's unity and provide security, stability and a real national reconciliation free of religious bigotry and political quotas. The conference asked Sunni civilians to be active in the political process in Iraq and fulfill their part in building a new Iraq. Iraqi mufti, Mehdi Ahmed Al-Sumaidaie, the head of the conference announced that he will stand against every attempt to divide Iraq. He did not accept foreign interference in the internal affairs of Iraq. Al-Sumaidaie also did the talk with al-Hashd al-Shaabi and other Iraqi group to unify Iraq. The conference was held to confirm the integrity and unity of Iraq and solidarity in the face of political and security threats among different part of the country, carrying the motto \"we protect our honor and dignity by embracing religious authority as the basis of unity and integration of our homeland\". 300 figures and religious scholars including ethnic groups’ sheikhs (tribes) attended the conference.",
		"thread_title": "The Plenary Meeting of Iraqi Sunnis ended by stressing on unanimity and unity against threats",
		"title": "The Plenary Meeting of Iraqi Sunnis ended by stressing on unanimity and unity against threats",
		"type": "conspiracy",
		"uuid": "f3dbeb78b21e4d8cea02c3115f9b07867265543e"
	},
	"-KhIjL2kmAThZOcP_q59": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:59.563+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "cars",
				"salience": 0.33141437,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/07mb6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toyota"
				},
				"name": "Toyota",
				"salience": 0.15553726,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.095810406,
				"type": "OTHER"
			},
			{
				"name": "prominent",
				"salience": 0.06880963,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.041415777,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.022494229,
				"type": "EVENT"
			},
			{
				"name": "sources",
				"salience": 0.022494229,
				"type": "OTHER"
			},
			{
				"name": "supply",
				"salience": 0.022494229,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.01951628,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.01951628,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japanese",
				"salience": 0.015727712,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.012899664,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.012665601,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.01207036,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.009337988,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.008092165,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0067998273,
				"type": "ORGANIZATION"
			},
			{
				"name": "clues",
				"salience": 0.0062073944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0059243864,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0047815023,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0047815023,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0044003907,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "UAE",
				"salience": 0.0044003907,
				"type": "LOCATION"
			},
			{
				"name": "company",
				"salience": 0.00428912,
				"type": "ORGANIZATION"
			},
			{
				"name": "raids",
				"salience": 0.004141882,
				"type": "EVENT"
			},
			{
				"name": "sites",
				"salience": 0.004141882,
				"type": "LOCATION"
			},
			{
				"name": "start",
				"salience": 0.004141882,
				"type": "EVENT"
			},
			{
				"name": "nationality import company",
				"salience": 0.0035030001,
				"type": "ORGANIZATION"
			},
			{
				"name": "car",
				"salience": 0.0032837973,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "pictures",
				"salience": 0.003230071,
				"type": "WORK_OF_ART"
			},
			{
				"name": "army",
				"salience": 0.003230071,
				"type": "ORGANIZATION"
			},
			{
				"name": "ground",
				"salience": 0.003230071,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.002905914,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.002905914,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dozens",
				"salience": 0.0027975948,
				"type": "PERSON"
			},
			{
				"name": "battles",
				"salience": 0.0027975948,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0027794999,
				"type": "OTHER"
			},
			{
				"name": "pictures",
				"salience": 0.0027398518,
				"type": "WORK_OF_ART"
			},
			{
				"name": "car",
				"salience": 0.0025491405,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.002476861,
				"type": "LOCATION"
			},
			{
				"name": "investigation",
				"salience": 0.0023835413,
				"type": "EVENT"
			},
			{
				"name": "following",
				"salience": 0.002372907,
				"type": "OTHER"
			},
			{
				"name": "military intelligence",
				"salience": 0.002372907,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0020473995,
				"type": "OTHER"
			},
			{
				"name": "cars",
				"salience": 0.0018444502,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "SUV",
				"salience": 0.0017730833,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "model",
				"salience": 0.0017730833,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "DOUBLE CAB",
				"salience": 0.0017730833,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0017730833,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0017507568,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.0015105072,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0014972247,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "authorities",
				"salience": 0.0013936467,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0012915861,
				"type": "OTHER"
			},
			{
				"name": "auto sales",
				"salience": 0.0012915861,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0012489682,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.0012340974,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.0011234767,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.0011142996,
				"type": "ORGANIZATION"
			},
			{
				"name": "nationality",
				"salience": 0.0011142996,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0010915915,
				"type": "LOCATION"
			},
			{
				"name": "banks",
				"salience": 0.00096492184,
				"type": "ORGANIZATION"
			},
			{
				"name": "credit",
				"salience": 0.00096492184,
				"type": "OTHER"
			},
			{
				"name": "adoption",
				"salience": 0.00096492184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordanian",
				"salience": 0.00059392635,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774919241.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T22:25:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email According to the results of the investigation conducted by Toyota, the Japanese company, about the sources of supply of the \"Daesh\" thousands of cars, and it confirmed that the four Arab countries bought and handed over to the organization. The unfolding clues Saudi support and Qatar and the UAE group \"Daesh,\" especially with the start of Russian raids on the regulatory sites in Syria, and after that the Russian military handed the Japanese car company \"Toyota\" pictures of the dozens of cars confiscated by the Syrian army in the battles on the ground have all been with \"Daesh \". The source familiar with the Syrian and Russian governments may deliver to the company, \"Toyota\" a preliminary report on the cars delivered by the company from the Russian military intelligence pictures, and it was the most prominent are the following: that the 22,500 car bought by a Saudi nationality import company, while Qatar has bought 32,000 car, the UAE has acquired 11650 car, the Jordanian army, and imported 4,500 cars the adoption of credit from several banks Saudi nationality, all now with the organization \"Daesh.\" The number of cars owned by \"Daesh\" type of Toyota more than 60,000, all cars and SUV model \"DOUBLE CAB\" started. US authorities announced opened an investigation into how \"Daesh\" for large numbers of cars, but observers said that Washington itself delivered hundreds of these cars to Syria. For its part, \"Toyota\" confirmed that it has suspended auto sales in Syria since 2012.",
		"thread_title": "Four Arab countries bought thousands of cars from Toyota and delivered them to\"Daesh\"",
		"title": "Four Arab countries bought thousands of cars from Toyota and delivered them to\"Daesh\"",
		"type": "conspiracy",
		"uuid": "39c2302a45c4b80fe23ef933482b3ea6e588163b"
	},
	"-KhIjLHKLDvwhqM4Qnmz": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:59.800+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "government",
				"salience": 0.3733212,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.19387601,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Kingdom of Saudi Arabia",
				"salience": 0.08797861,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.06138462,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01f53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberal_Democrats"
				},
				"name": "Liberal Democrats",
				"salience": 0.045978155,
				"type": "ORGANIZATION"
			},
			{
				"name": "pilots",
				"salience": 0.029131377,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/026j7g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Fallon"
				},
				"name": "Michael Fallon",
				"salience": 0.024740512,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.01693506,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025ktk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Brake"
				},
				"name": "Tom Brake",
				"salience": 0.015134542,
				"type": "PERSON"
			},
			{
				"name": "military training",
				"salience": 0.011303682,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.008893512,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.008893512,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0077432916,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.006548547,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "Air Force",
				"salience": 0.0063355267,
				"type": "ORGANIZATION"
			},
			{
				"name": "training",
				"salience": 0.0057996614,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.004244205,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0q4tw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Independent"
				},
				"name": "The Independent",
				"salience": 0.0038058686,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h508",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boris_Johnson"
				},
				"name": "Boris Jonson",
				"salience": 0.0035246215,
				"type": "PERSON"
			},
			{
				"name": "AbdRabbuh Mansur Hadi",
				"salience": 0.0031658502,
				"type": "PERSON"
			},
			{
				"name": "training",
				"salience": 0.0029309983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hy1q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_policy"
				},
				"name": "Foreign Affairs",
				"salience": 0.0028094074,
				"type": "ORGANIZATION"
			},
			{
				"name": "training",
				"salience": 0.0023937132,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0023718642,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.0023510312,
				"type": "EVENT"
			},
			{
				"name": "complicity",
				"salience": 0.002170706,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.002170706,
				"type": "PERSON"
			},
			{
				"name": "violations",
				"salience": 0.0021610248,
				"type": "OTHER"
			},
			{
				"name": "bomb",
				"salience": 0.0018834486,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0018800239,
				"type": "EVENT"
			},
			{
				"name": "letter",
				"salience": 0.0018800239,
				"type": "WORK_OF_ART"
			},
			{
				"name": "operations",
				"salience": 0.0018250339,
				"type": "OTHER"
			},
			{
				"name": "military operations",
				"salience": 0.0018250339,
				"type": "OTHER"
			},
			{
				"name": "revelation",
				"salience": 0.001614919,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0015225913,
				"type": "PERSON"
			},
			{
				"name": "targeting",
				"salience": 0.0015225913,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0015225913,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0014658058,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.0013835194,
				"type": "LOCATION"
			},
			{
				"name": "law",
				"salience": 0.0013767853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01gqgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oxfam"
				},
				"name": "Oxfam",
				"salience": 0.001355351,
				"type": "ORGANIZATION"
			},
			{
				"name": "aggression",
				"salience": 0.0013185942,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0013185942,
				"type": "PERSON"
			},
			{
				"name": "instructions",
				"salience": 0.0013185942,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.0012694079,
				"type": "OTHER"
			},
			{
				"name": "beginning",
				"salience": 0.0012694079,
				"type": "EVENT"
			},
			{
				"name": "targeting processes",
				"salience": 0.0012431886,
				"type": "OTHER"
			},
			{
				"name": "compliance",
				"salience": 0.0012431886,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cy4y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Defence_(United_Kingdom)"
				},
				"name": "Ministry of Defense",
				"salience": 0.0011576659,
				"type": "ORGANIZATION"
			},
			{
				"name": "breach",
				"salience": 0.001076589,
				"type": "EVENT"
			},
			{
				"name": "training sessions",
				"salience": 0.001076589,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.001076589,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.001076589,
				"type": "OTHER"
			},
			{
				"name": "cluster bombs",
				"salience": 0.0010319141,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0010233677,
				"type": "OTHER"
			},
			{
				"name": "suppliers",
				"salience": 0.00092882884,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.00092882884,
				"type": "LOCATION"
			},
			{
				"name": "arms sales",
				"salience": 0.00092882884,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.00092882884,
				"type": "OTHER"
			},
			{
				"name": "sales",
				"salience": 0.00092882884,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.00092882884,
				"type": "OTHER"
			},
			{
				"name": "kingdom",
				"salience": 0.00092882884,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.00092882884,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/045f4j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_humanitarian_law"
				},
				"name": "International Humanitarian Law",
				"salience": 0.0009050468,
				"type": "ORGANIZATION"
			},
			{
				"name": "cluster bomb",
				"salience": 0.0008110439,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00080432545,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00080432545,
				"type": "PERSON"
			},
			{
				"name": "HouthiAnsarullah",
				"salience": 0.0007814976,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.00072801206,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03f70xs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_Blake"
				},
				"name": "Blake",
				"salience": 0.0006972244,
				"type": "PERSON"
			},
			{
				"name": "arms supplies",
				"salience": 0.00067653443,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.0006566486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0006385297,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.00061508606,
				"type": "LOCATION"
			},
			{
				"name": "military operations",
				"salience": 0.00060589804,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00060589804,
				"type": "OTHER"
			},
			{
				"name": "village",
				"salience": 0.00058583135,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.00058583135,
				"type": "LOCATION"
			},
			{
				"name": "denial",
				"salience": 0.00058583135,
				"type": "EVENT"
			},
			{
				"name": "disarray",
				"salience": 0.00058583135,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.0005574049,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0005568584,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.0005081769,
				"type": "LOCATION"
			},
			{
				"name": "process",
				"salience": 0.0005053957,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0005053957,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02r47k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_Saudi_Air_Force"
				},
				"name": "Saudi Air Force",
				"salience": 0.00049731485,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.00046120104,
				"type": "LOCATION"
			},
			{
				"name": "incident team",
				"salience": 0.000437628,
				"type": "ORGANIZATION"
			},
			{
				"name": "authorization",
				"salience": 0.000437628,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.00041258265,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05glwg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BL755"
				},
				"name": "BL-755",
				"salience": 0.00036057414,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14774917171.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T22:22:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email Britain has been providing military training to the Saudi Arabian Air Force, while the country is carrying out atrocities in neighboring Yemen, a report says. The UK's Liberal Democrats revealed that the British government is providing the training in both Saudi Arabia and Britain itself, The Independent revealed on Saturday. The party’s Foreign Affairs spokesman, Tom Brake, obtained a parliamentary letter from UK Defense Secretary Michael Fallon, in which he acknowledged that the British government provides the training to Saudi pilots bombing civilians in Yemen. Brake denounced the move as “shameful,” calling on the Ministry of Defense to end the training immediately. “The Government must end its complicity in this murderous campaign,” he said. \"It is shameful that the UK government is not only arming Saudi pilots, it is training them as well.” Saudi Arabia has launched a war in Yemen on March 26, 2015, in a bid to undermine the HouthiAnsarullah movement and restore power to Saudi-backed former president AbdRabbuh Mansur Hadi. Since the beginning of the aggression, almost 10,000 people, including over 2,000 children, have been killed. The Liberal Democrats also wanted to know what the instructions and advice had been given by the British government on authorizing military operations and the “targeting of aerial operations” over the last year. \"The indiscriminate bombing of innocent civilians by Saudi Arabia in Yemen, in clear breach of international humanitarian law, is now well documented,” Blake added. In response, Fallon claimed the government helps the Saudi Air Force in order to “improve their targeting processes and to support International Humanitarian Law (IHL) compliance.” Fallon said the UK had delivered two training sessions in Saudi Arabia on the process for investigating alleged International Humanitarian Law violations, under a joint incident team it supported. He, however, said that the government “has not provided any specific operational advice to the Kingdom of Saudi Arabia for operations in Yemen and has not provided training on political authorization of military operations.” The Liberal Democrat party also insisted that the latest revelation requires an urgent action by UK Foreign Secretary Boris Jonson, who personally signs off any arms sales to countries such as Saudi Arabia. London, which has been one of the biggest suppliers of weapons to Riyadh for 40 years, has come under fire for its continued sales of weapons to the kingdom during its war on Yemen. Charity group Oxfam accused the British government of being in a state of “denial and disarray” over its arms supplies to Riyadh. Earlier this year, Amnesty International found a banned British-made cluster bomb used by the Saudis in Yemen. The un-detonated bomb which was found in a remote village in northern Yemen was BL-755 cluster bombs.",
		"thread_title": "UK training Saudi pilots amid reports of war crimes in Yemen",
		"title": "UK training Saudi pilots amid reports of war crimes in Yemen",
		"type": "conspiracy",
		"uuid": "889964ab0dcc4d159a9386d366f9cccd2e767e37"
	},
	"-KhIjLVHBWRVeJShKegF": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T00:19:59.911+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.13482484,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rk0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/India"
				},
				"name": "Indian",
				"salience": 0.07962041,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02gtr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dana_Rohrabacher"
				},
				"name": "Dana Rohrabacher",
				"salience": 0.055105634,
				"type": "PERSON"
			},
			{
				"name": "bill",
				"salience": 0.05449341,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.048182987,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0472934,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.04365185,
				"type": "OTHER"
			},
			{
				"name": "state sponsor",
				"salience": 0.042761475,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04928s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ted_Poe"
				},
				"name": "Ted Poe",
				"salience": 0.040608607,
				"type": "PERSON"
			},
			{
				"name": "development",
				"salience": 0.037092965,
				"type": "OTHER"
			},
			{
				"name": "law makers",
				"salience": 0.037092965,
				"type": "PERSON"
			},
			{
				"name": "bill",
				"salience": 0.033033412,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Chairman",
				"salience": 0.026705787,
				"type": "PERSON"
			},
			{
				"name": "consequence",
				"salience": 0.021464549,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.019045081,
				"type": "EVENT"
			},
			{
				"name": "bill",
				"salience": 0.014384567,
				"type": "WORK_OF_ART"
			},
			{
				"name": "allegations",
				"salience": 0.013628712,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.010878961,
				"type": "EVENT"
			},
			{
				"name": "votary",
				"salience": 0.008377637,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0078639975,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.007840263,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bill",
				"salience": 0.007840263,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meeting",
				"salience": 0.0073022014,
				"type": "EVENT"
			},
			{
				"name": "look",
				"salience": 0.0072418065,
				"type": "OTHER"
			},
			{
				"name": "stripes",
				"salience": 0.0070536765,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.006956027,
				"type": "ORGANIZATION"
			},
			{
				"name": "secretary of state",
				"salience": 0.006650697,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.006234433,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.006234433,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.0061050574,
				"type": "EVENT"
			},
			{
				"name": "terrorist groups",
				"salience": 0.005516865,
				"type": "ORGANIZATION"
			},
			{
				"name": "visit",
				"salience": 0.005516865,
				"type": "EVENT"
			},
			{
				"name": "policy",
				"salience": 0.005516865,
				"type": "OTHER"
			},
			{
				"name": "military camp",
				"salience": 0.0053111827,
				"type": "LOCATION"
			},
			{
				"name": "nukes",
				"salience": 0.0052015386,
				"type": "LOCATION"
			},
			{
				"name": "nukes.",
				"salience": 0.0052015386,
				"type": "OTHER"
			},
			{
				"name": "House Subcommittee on Terrorism",
				"salience": 0.0048438804,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0048438804,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0048438804,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h9bz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baloch_people"
				},
				"name": "Baloch",
				"salience": 0.0048438804,
				"type": "PERSON"
			},
			{
				"name": "space",
				"salience": 0.004504792,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.004504792,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.004504792,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01h1wl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times_of_India"
				},
				"name": "Times of India",
				"salience": 0.0039228206,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nawaz",
				"salience": 0.0039053122,
				"type": "PERSON"
			},
			{
				"name": "escalation",
				"salience": 0.0038867544,
				"type": "EVENT"
			},
			{
				"name": "escalation",
				"salience": 0.0038867544,
				"type": "EVENT"
			},
			{
				"name": "Pakistan State Sponsor of Terrorism Designation Act",
				"salience": 0.003776497,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0033971732,
				"type": "LOCATION"
			},
			{
				"name": "concerns",
				"salience": 0.0033659346,
				"type": "OTHER"
			},
			{
				"name": "session",
				"salience": 0.0033659346,
				"type": "EVENT"
			},
			{
				"name": "sides",
				"salience": 0.0033659346,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0033659346,
				"type": "LOCATION"
			},
			{
				"name": "powers",
				"salience": 0.0033659346,
				"type": "OTHER"
			},
			{
				"name": "horns",
				"salience": 0.0033659346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088w11",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uri,_Jammu_and_Kashmir"
				},
				"name": "Uri",
				"salience": 0.003270436,
				"type": "ORGANIZATION"
			},
			{
				"name": "HR 6069",
				"salience": 0.003270436,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0dnxw1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jalaluddin_Haqqani"
				},
				"name": "Haqqani",
				"salience": 0.003270436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05mg9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Osama_bin_Laden"
				},
				"name": "Osama bin laden",
				"salience": 0.003270436,
				"type": "PERSON"
			},
			{
				"name": "strikes",
				"salience": 0.0031356467,
				"type": "EVENT"
			},
			{
				"name": "strikes",
				"salience": 0.0031356467,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0027134914,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0027052881,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.0025567696,
				"type": "PERSON"
			},
			{
				"name": "approval",
				"salience": 0.0024518045,
				"type": "OTHER"
			},
			{
				"name": "points agenda",
				"salience": 0.0024518045,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0296q2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Narendra_Modi"
				},
				"name": "Modi",
				"salience": 0.002072129,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.001831661,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.001831661,
				"type": "PERSON"
			},
			{
				"name": "representative",
				"salience": 0.001831661,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0016135289,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dlv0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Delhi"
				},
				"name": "New Delhi",
				"salience": 0.0015092057,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04f30",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kashmir"
				},
				"name": "Kashmir",
				"salience": 0.0011273915,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04tx37",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maliha_Lodhi"
				},
				"name": "Maleeha Lodhi",
				"salience": 0.0011273915,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020t62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nawaz_Sharif"
				},
				"name": "Sharif",
				"salience": 0.0011273915,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477424841us-735x400.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-26T03:51:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email In a shocking development in United States, two law makers moved a bill to declare Pakistan as a ‘state sponsor of terrorism’. The bill moved in a very crucial time when Pakistan and India are heading towards a war like situation. The bill was moved by Congressman Ted Poe from Texas, who is the Chairman of the House Subcommittee on Terrorism, and Congressman Dana Rohrabacher of California, who is a strong votary of the Baloch cause.The allegations which were drafted in bill says harboring Osama bin laden and Haqqani’s. The bill, HR 6069 or the Pakistan State Sponsor of Terrorism Designation Act . Poe condemned theterrorist attack on the Uri military camp in India, saying this is just the ”latest consequence of Pakistan’s longstanding irresponsible policy of supporting and providing operational space for all stripes of jihadi terrorist groups reported in Times of India .”Currently Pakistan PM is on official visit to New York for attending the UN meeting. PM Nawaz had one on one meeting with US secretary of state John Kerry. During the meeting John Kerry pressure Pakistan to limit its nukes. on the other hand Pakistan asked US to tell India to limit its nukes first. According to the statement issued by the Pakistan’s permanent representative to the UN, Maleeha Lodhi ” Sharif told Kerry that what was expected of Pakistan must also be implemented by India. Meanwhile international community specially US wants the debate of Kashmir out from UN session. Are we heading towards escalation ? Are we heading towards escalation? The growing concerns on both sides of the border, are giving a sinister look that both the nuclear powers are ready to lock horns. Indian army asked Modi government for the approval of punitive strikes inside Pakistan. A high level meeting in New Delhi which was chaired by the Indian PM focusing on two points agenda. 1: To isolate Pakistan diplomatically. 2: Surgical strikes inside Pakistan.",
		"thread_title": "US And Israeli Lawmakers Want Pakistan To Be Declared As Terrorist Country",
		"title": "US And Israeli Lawmakers Want Pakistan To Be Declared As Terrorist Country",
		"type": "conspiracy",
		"uuid": "7b45b66eef97c4dac6dca2b8635a2595018aeefc"
	},
	"-KhIjLiRHvTh5ntr4_EE": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:28.676+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.58307177,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01yq7d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gennifer_Flowers"
				},
				"name": "Gennifer Flowers",
				"salience": 0.16130856,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.026300939,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.018141655,
				"type": "OTHER"
			},
			{
				"name": "state job",
				"salience": 0.015811367,
				"type": "OTHER"
			},
			{
				"name": "GF",
				"salience": 0.01333782,
				"type": "LOCATION"
			},
			{
				"name": "recording",
				"salience": 0.010732863,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.010732863,
				"type": "WORK_OF_ART"
			},
			{
				"name": "phone conversation",
				"salience": 0.010732863,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.007939396,
				"type": "OTHER"
			},
			{
				"name": "Flowers",
				"salience": 0.007478922,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Columbia"
				},
				"name": "BC",
				"salience": 0.006111433,
				"type": "LOCATION"
			},
			{
				"name": "job",
				"salience": 0.0059800926,
				"type": "OTHER"
			},
			{
				"name": "Flowers",
				"salience": 0.005662271,
				"type": "OTHER"
			},
			{
				"name": "stepfather",
				"salience": 0.0052967328,
				"type": "PERSON"
			},
			{
				"name": "inquiries",
				"salience": 0.0047572083,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.004195596,
				"type": "OTHER"
			},
			{
				"name": "state job",
				"salience": 0.004039204,
				"type": "OTHER"
			},
			{
				"name": "grievance",
				"salience": 0.003951961,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0038359358,
				"type": "OTHER"
			},
			{
				"name": "soemone",
				"salience": 0.0038359358,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0038359358,
				"type": "EVENT"
			},
			{
				"name": "assistant",
				"salience": 0.0038359358,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c9ph5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flower"
				},
				"name": "Flowers",
				"salience": 0.0037491918,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "grievance",
				"salience": 0.0036627909,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0034260363,
				"type": "OTHER"
			},
			{
				"name": "recording",
				"salience": 0.0031066812,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0030154376,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.002990822,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conversation",
				"salience": 0.002990822,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0027247735,
				"type": "OTHER"
			},
			{
				"name": "transcript",
				"salience": 0.0027247735,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.002690466,
				"type": "OTHER"
			},
			{
				"name": "witness",
				"salience": 0.002690466,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "pay-for-play",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "scandals",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "audio segments",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "Arkansas Appeal Tribunal",
				"salience": 0.00236212,
				"type": "ORGANIZATION"
			},
			{
				"name": "possibility",
				"salience": 0.0023109266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04khbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gf"
				},
				"name": "GF",
				"salience": 0.0022929872,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.002271902,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.0021966957,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state job",
				"salience": 0.0019868258,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.0019108184,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.0018952121,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Arkansas",
				"salience": 0.0018414311,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0016411785,
				"type": "OTHER"
			},
			{
				"name": "somebody",
				"salience": 0.0016411785,
				"type": "PERSON"
			},
			{
				"name": "cancer",
				"salience": 0.0013121704,
				"type": "OTHER"
			},
			{
				"name": "GF",
				"salience": 0.0012363074,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0012106166,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0011953631,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.0010312406,
				"type": "OTHER"
			},
			{
				"name": "angioplasties",
				"salience": 0.0008929653,
				"type": "OTHER"
			},
			{
				"name": "X-ray",
				"salience": 0.0008929653,
				"type": "OTHER"
			},
			{
				"name": "scare",
				"salience": 0.0008929653,
				"type": "OTHER"
			},
			{
				"name": "spot",
				"salience": 0.000667043,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.000667043,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775662771.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:28.676+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nFormer President Bill Clinton can be heard telling his former mistress, Gennifer Flowers, to deny that he helped her get a state job in a series of recorded phone conversation from 1991. \n“If they ever asked if you’d talked to me about it, you can say no,” Clinton is heard saying in the recording. \nAt the time, the media was making inquiries about Flowers’ alleged affair with Clinton, and she was concerned that they may question how she got a job as administrative assistant for the Arkansas Appeal Tribunal. \nClinton can also be heard telling Flowers how to handle a grievance filed by soemone else who applied for the same positioned and claimed she was more qualified than Flowers. \nFlowers famously recorded a series of conversation she had with Clinton from December 1990 to December 1991, while he was still Governor of Arkansas. The audio segments about the state job were widely reported in the 1990’s, however, as other pay-for-play financial scandals have surfaced, the details may warrant revisiting. \n\nHere is a transcript of part of the recording: \nGF – But anyway, then Wednesday, there was a grievance filed in my office when I got the job by a girl who felt like she should have gotten it, a black girl named (deleted). And they called me as a witness. So I go in and uh, nothing big came of it. It’s just that they were questioning me about how I found out about the job. And I said, “Well, that personnel said it that it was a possibility there would be a position,” and then uh, “they told me that it would be advertised in the newspaper. And it was and I pursued it from there. \nBC – Good for you. \nGF: Yeah. We had a little bit of a scare recently because she had a spot on an X-ray. And she went and had it checked again and it wasn’t cancer. And it’s been almost, it’ll be two years in May that she’s now diagnosed cancer free. My stepfather has been through two angioplasties, but he’s doing good. And I am, I’m really, Bill what I’m afraid of is that if somebody in the press finds out that I’m working for the state. \nBC – Yeah. \nGF – They’re going to make a big deal of it. \nBC – Yeah. \nGF – Well the only thing that concerns me, where I’m, where I’m concerned at this point is the state job. \nBC – Yeah. I never thought about that, but as long as you say you’ve just been looking for one, you’d uh, check on it. If they ever asked if you’d talked to me about it, you can say no.",
		"thread_title": "Busted: Bill Recorded Telling Mistress To Deny That Clintons Helped Her Get A State Job",
		"title": "Busted: Bill Recorded Telling Mistress To Deny That Clintons Helped Her Get A State Job",
		"type": "conspiracy",
		"uuid": "0b9233b7f71c2ab06559c69e3ecc7745ffd1f2b1"
	},
	"-KhIjM-Ffa6XLYj-1c6O": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:28.760+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Catholic Church",
				"salience": 0.3293582,
				"type": "ORGANIZATION"
			},
			{
				"name": "senator",
				"salience": 0.16503079,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.06841674,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.05381974,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States of America",
				"salience": 0.03441166,
				"type": "LOCATION"
			},
			{
				"name": "marriage",
				"salience": 0.032534283,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.017884744,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.017557707,
				"type": "OTHER"
			},
			{
				"name": "milestone",
				"salience": 0.016070282,
				"type": "EVENT"
			},
			{
				"name": "person",
				"salience": 0.015771745,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.012611423,
				"type": "PERSON"
			},
			{
				"name": "marriage",
				"salience": 0.012436769,
				"type": "OTHER"
			},
			{
				"name": "ultimatum",
				"salience": 0.011357313,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.010192106,
				"type": "LOCATION"
			},
			{
				"name": "position",
				"salience": 0.008993949,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.008993949,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.008993949,
				"type": "OTHER"
			},
			{
				"name": "Dinner",
				"salience": 0.008993949,
				"type": "EVENT"
			},
			{
				"name": "creator",
				"salience": 0.007974749,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.0063507413,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.0060001216,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0057822242,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01xcy2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Campaign"
				},
				"name": "Human Rights Campaign",
				"salience": 0.00554227,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00554227,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00554227,
				"type": "LOCATION"
			},
			{
				"name": "liberties",
				"salience": 0.005387226,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0053050504,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.004281936,
				"type": "OTHER"
			},
			{
				"name": "core value",
				"salience": 0.0037084052,
				"type": "OTHER"
			},
			{
				"name": "chapter",
				"salience": 0.0037084052,
				"type": "WORK_OF_ART"
			},
			{
				"name": "citizen",
				"salience": 0.0037084052,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0037084052,
				"type": "LOCATION"
			},
			{
				"name": "definition",
				"salience": 0.0037084052,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0035861146,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0033509734,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0033259385,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0032018898,
				"type": "OTHER"
			},
			{
				"name": "LGBT equality",
				"salience": 0.0030032282,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0030032282,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002679516,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.0026007902,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0026007902,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0026007902,
				"type": "OTHER"
			},
			{
				"name": "abilities",
				"salience": 0.0025037604,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.0025037604,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0024722277,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0024520382,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0024520382,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.002362202,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03b5d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Book_of_Genesis"
				},
				"name": "Genesis",
				"salience": 0.0022833312,
				"type": "ORGANIZATION"
			},
			{
				"name": "ruling",
				"salience": 0.0022338366,
				"type": "OTHER"
			},
			{
				"name": "ultimatum",
				"salience": 0.0020288837,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0017065571,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.0015863493,
				"type": "PERSON"
			},
			{
				"name": "bags",
				"salience": 0.0015863493,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.0015863493,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0015863493,
				"type": "OTHER"
			},
			{
				"name": "mankind",
				"salience": 0.0015663633,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.0015094699,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.001477772,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.0013342899,
				"type": "OTHER"
			},
			{
				"name": "equals",
				"salience": 0.0013342899,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hn10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LGBT"
				},
				"name": "LBGT",
				"salience": 0.001307093,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States of America",
				"salience": 0.0012488951,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0012365401,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.001231017,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.001231017,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0011553887,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0011553887,
				"type": "EVENT"
			},
			{
				"name": "honesty",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "lesbians",
				"salience": 0.0011553887,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "gays",
				"salience": 0.0011553887,
				"type": "PERSON"
			},
			{
				"name": "LGBT rights",
				"salience": 0.0011459482,
				"type": "OTHER"
			},
			{
				"name": "ultimatum",
				"salience": 0.0011039423,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0009922896,
				"type": "PERSON"
			},
			{
				"name": "faith",
				"salience": 0.0008630834,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.0008630834,
				"type": "ORGANIZATION"
			},
			{
				"name": "line",
				"salience": 0.0008630834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0007846717,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.0005311818,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775661401.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:28.760+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nDemocratic U.S. vice-presidential nominee Tim Kaine announced Saturday that he believes the Catholic Church will change its position on same-sex marriage. The Virginia senator said that just like he had changed his opinion on the issue, the Catholic Church is also likely to follow suit. Speaking at the 20th Annual Human Rights Campaign’s National Dinner in Washington, the Roman Catholic senator reportedly said, “I think it’s going to change because my church also teaches me about a creator who, in the first chapter of Genesis, surveyed the entire world, including mankind, and said, ‘It is very good.’” \n“And besides,” he continued, “we are talking here about a country that was based and founded on democracy as a core value. By definition, that means that every single person and every single citizen is able – no, scratch that – encouraged to practice his civil, religious, and above all, sexual liberties to the best of their abilities. And I’m sorry that some people don’t like it, but to deny same-sex marriage in a country that should be the first one to accept it is just pointless. And the Catholic Church should also be accepting it instead of condemning it, which is what it’s doing right now.” \nKaine also added that, if all else fails, “there are ways of making the Catholic Church listen to the voice of reason,” which is how he dubbed all those who advocate LGBT equality. “At the end of the day, you know, we’re a civilized people, of course the first thing we’ll do is act nicely and ask nicely,” he said. “Then, if that doesn’t work, we’ll use our law and our legal system to enable ourselves to be who we are, or rather the LBGT community will do that – and it has. The Supreme Court’s ruling on same-sex marriage was a crucial milestone in our legal system that proves it works, it actually functions.” \n“So, what I’m saying here,” he argued, “is that, while I respect the Catholic Church as I’m sure millions of Americans do, you know, at some point it is going to start acting contrary to the Christian faith, and we’re talking about an institution that’s supposed to be the first one on the front line defending it. So, when that happens, and that’s what’s happening with condemning LGBT rights, we’ll state an ultimatum. The United States of America, more precisely, the future President of the United States of America, Hillary Clinton, will state an ultimatum. And that ultimatum will be to either change its stance on same-sex marriage or pack its bags and get out of America. And yes – the President of the country can do that.” \n“And in case anybody’s wondering – no, Donald Trump won’t do the same because he doesn’t care about anyone other than Donald Trump. On the other hand, Hillary Clinton is a shining example of honesty, integrity and democracy, and you can rest assured she will do everything in her power as the president to make sure gays and lesbians throughout America are loved, respected and viewed as equals during her presidential term. What happens after that is not our problem,” Kaine concluded.",
		"thread_title": "Tim Kaine: “The Catholic Church Will Change Its Same-Sex Marriage Stance Or It Will Be Banned From The U.S.”",
		"title": "Tim Kaine: “The Catholic Church Will Change Its Same-Sex Marriage Stance Or It Will Be Banned From The U.S.”",
		"type": "conspiracy",
		"uuid": "529812dddf479e66f18e37d95c4a03983f809cb9"
	},
	"-KhIjMANA8RyibbZydDj": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:28.868+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "operation",
				"salience": 0.107798986,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.087521024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Muammar Gaddafi",
				"salience": 0.06211308,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.03984808,
				"type": "PERSON"
			},
			{
				"name": "terrorist attack",
				"salience": 0.034771107,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States of America",
				"salience": 0.03169955,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.03164434,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.031368196,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.028379183,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.021097144,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.018715497,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.018715497,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.01851944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n46_gt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Christopher_Stevens"
				},
				"name": "Christopher Stevens",
				"salience": 0.017092088,
				"type": "PERSON"
			},
			{
				"name": "being",
				"salience": 0.016641848,
				"type": "PERSON"
			},
			{
				"name": "contribution",
				"salience": 0.016541049,
				"type": "OTHER"
			},
			{
				"name": "overthrow",
				"salience": 0.016214859,
				"type": "OTHER"
			},
			{
				"name": "instability",
				"salience": 0.016214859,
				"type": "OTHER"
			},
			{
				"name": "Commander-in-Chief forum",
				"salience": 0.016214859,
				"type": "EVENT"
			},
			{
				"name": "secretary of state",
				"salience": 0.016214859,
				"type": "PERSON"
			},
			{
				"name": "foreign policy decision making processes",
				"salience": 0.0143779125,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.011537046,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.011537046,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.010654809,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.009993202,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.009993202,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.009253858,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.0086530065,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.008506044,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.008414325,
				"type": "OTHER"
			},
			{
				"name": "embassy",
				"salience": 0.008033684,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0072596874,
				"type": "OTHER"
			},
			{
				"name": "magnitude",
				"salience": 0.0066870265,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.0066870265,
				"type": "OTHER"
			},
			{
				"name": "ordinary",
				"salience": 0.0066870265,
				"type": "OTHER"
			},
			{
				"name": "Politics",
				"salience": 0.0063047716,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.005817237,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0057795933,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.0056971135,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.0054155835,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0054155835,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0054155835,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0054155835,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0052135927,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0052135927,
				"type": "OTHER"
			},
			{
				"name": "hiccups",
				"salience": 0.0049967244,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.0047434904,
				"type": "PERSON"
			},
			{
				"name": "damage",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "expectations",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "toll",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "iron fist",
				"salience": 0.004514998,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.004514998,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00447813,
				"type": "OTHER"
			},
			{
				"name": "sacrifices",
				"salience": 0.004421736,
				"type": "OTHER"
			},
			{
				"name": "sacrifices",
				"salience": 0.004421736,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.004170052,
				"type": "PERSON"
			},
			{
				"name": "contact",
				"salience": 0.0040463516,
				"type": "OTHER"
			},
			{
				"name": "delegation",
				"salience": 0.0038291474,
				"type": "PERSON"
			},
			{
				"name": "auditorium",
				"salience": 0.0038291474,
				"type": "LOCATION"
			},
			{
				"name": "jokes",
				"salience": 0.0038291474,
				"type": "OTHER"
			},
			{
				"name": "homage",
				"salience": 0.0038291474,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0038291474,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.0038291474,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.003658722,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0033035784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libyans",
				"salience": 0.0032098247,
				"type": "PERSON"
			},
			{
				"name": "arms dealers",
				"salience": 0.0031803001,
				"type": "ORGANIZATION"
			},
			{
				"name": "bargain",
				"salience": 0.0028607377,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.0028607377,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0028607377,
				"type": "LOCATION"
			},
			{
				"name": "position",
				"salience": 0.0028607377,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0025636924,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.0024994994,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.002406209,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.002327466,
				"type": "PERSON"
			},
			{
				"name": "spook",
				"salience": 0.002219979,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.002154971,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0020835986,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0020835986,
				"type": "LOCATION"
			},
			{
				"name": "nation heads",
				"salience": 0.0020835986,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0020835986,
				"type": "OTHER"
			},
			{
				"name": "mine",
				"salience": 0.0020835986,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.0018204496,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.0017975097,
				"type": "LOCATION"
			},
			{
				"name": "agents",
				"salience": 0.0017975097,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.0016795363,
				"type": "EVENT"
			},
			{
				"name": "field",
				"salience": 0.0015564793,
				"type": "LOCATION"
			},
			{
				"name": "asset",
				"salience": 0.0015564793,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0015564793,
				"type": "OTHER"
			},
			{
				"name": "intelligence agency",
				"salience": 0.0014489078,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775659851.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:28.868+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nHillary Clinton declared during NBC News’s Commander-in-Chief forum that no lives were lost in Libya when she made the move to take out dictator Muammar Gaddafi. Even so, the former secretary of state did not mention the fact that 11 months later four Americans – including U.S. Ambassador Christopher Stevens – were killed in a terrorist attack in Benghazi that arose from the instability that the overthrow created. \n“That was one of the few situations in American foreign policy decision making processes where everybody came together to make sure we don’t make the wrong move, and the operation was a success, even Donald Trump supported it,” Clinton argued. “As with any operation of such magnitude, we had a few hiccups, but it was nothing out of the ordinary. As I’ve said, the operation was a success.” \nShe continued, “So much so, in fact, that I’m proud to say that no important people were lost through it all, and when I say that, I say it with the utmost respect for all those who had to give their lives on both sides so that Libyans could be freed from the iron fist of Gaddafi. It would have been unrealistic to expect 0 casualties; however, the overall toll did not exceed expectations, with the greater amount of damage being on the side of the enemy.” \n“Politics can be a cruel line of work. That being said, I stand before you here, today, and I am proud to say that giving democracy to a people that have not had any contact with it for generations is a wonderful thing that makes all of the sacrifices worth it. And while we’re on the subject of sacrifices, thank God they did not include anyone important from the American delegation, including yours truly,” she said jokingly, causing the auditorium to laugh. \nShe said, “But all jokes aside, I have to pay homage to the CIA, who has once again performed outstandingly and saved the day. Its agents’ work in the field is an immeasurable contribution and an asset that we would be wise to treasure for generations to come. If it hadn’t been for them, we would not have been able to perform the operation so cleanly and with such little impact to the surrounding nations. I am proud that the United States of America has an intelligence agency such as the CIA.” \n“I’m sure many here among you disagree with my position that one embassy is a small price to pay, a bargain, if you will, when it comes to ridding the world of another dictator and a terrorist. I would also like to remind everyone here that that price would have gone up immeasurably if we had sat idly by and allowed Gaddafi to rage on and cause death and destruction throughout the region. For better of worse, we acted and I am convinced no other dictator will ever again think about cheating the CIA out of a deal. Because, in the words of a personal friend of mine, who is a former CIA spook – shutting down arms dealers is easy; finding trustworthy partners among nation heads is the hard part,” she concluded.",
		"thread_title": "Hillary: “We Did Not Lose A Single Important Person In Libya”",
		"title": "Hillary: “We Did Not Lose A Single Important Person In Libya”",
		"type": "conspiracy",
		"uuid": "783dfc85d524893470e39148bc4e0de242816c9d"
	},
	"-KhIjMPk4CI7EST3Evo8": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:28.925+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05ttk_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hill_(newspaper)"
				},
				"name": "The Hill",
				"salience": 0.22379148,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.120619945,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07qk51t"
				},
				"name": "Band",
				"salience": 0.09075127,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.04960424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k3llq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Teneo"
				},
				"name": "Teneo",
				"salience": 0.03732412,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band",
				"salience": 0.029155346,
				"type": "ORGANIZATION"
			},
			{
				"name": "consulting firm",
				"salience": 0.02842757,
				"type": "ORGANIZATION"
			},
			{
				"name": "memo",
				"salience": 0.025522403,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.022345379,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.017467584,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/031rxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UBS"
				},
				"name": "UBS",
				"salience": 0.016851636,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.014105938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.012719157,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea Clinton",
				"salience": 0.011008873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04cxlc4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doug_Band"
				},
				"name": "Doug Band",
				"salience": 0.010424022,
				"type": "PERSON"
			},
			{
				"name": "document",
				"salience": 0.009566808,
				"type": "WORK_OF_ART"
			},
			{
				"name": "millions",
				"salience": 0.009328079,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.008608418,
				"type": "OTHER"
			},
			{
				"name": "gigs",
				"salience": 0.008288081,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00808115,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.0077739665,
				"type": "ORGANIZATION"
			},
			{
				"name": "roles",
				"salience": 0.0077376836,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0073975837,
				"type": "PERSON"
			},
			{
				"name": "confidant",
				"salience": 0.0072118696,
				"type": "PERSON"
			},
			{
				"name": "foundation",
				"salience": 0.0071465243,
				"type": "OTHER"
			},
			{
				"name": "Declan Kelly",
				"salience": 0.0067550004,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0060472093,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.005676431,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0055506486,
				"type": "ORGANIZATION"
			},
			{
				"name": "activities",
				"salience": 0.004964332,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0048505543,
				"type": "OTHER"
			},
			{
				"name": "Bill Clinton, Inc.",
				"salience": 0.0048451102,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band",
				"salience": 0.0041019255,
				"type": "PERSON"
			},
			{
				"name": "firm",
				"salience": 0.003945785,
				"type": "ORGANIZATION"
			},
			{
				"name": "Foundation",
				"salience": 0.0039338665,
				"type": "ORGANIZATION"
			},
			{
				"name": "interests",
				"salience": 0.003726591,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0035984113,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.0034763461,
				"type": "OTHER"
			},
			{
				"name": "total",
				"salience": 0.0034172689,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0034172689,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0034172689,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0033172911,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.0033172911,
				"type": "WORK_OF_ART"
			},
			{
				"name": "business",
				"salience": 0.0031935761,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0031729096,
				"type": "PERSON"
			},
			{
				"name": "brat",
				"salience": 0.003167138,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026swz9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cheryl_Mills"
				},
				"name": "Cheryl Mills",
				"salience": 0.0030692797,
				"type": "PERSON"
			},
			{
				"name": "roles",
				"salience": 0.0030520053,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0030520053,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.0029352924,
				"type": "OTHER"
			},
			{
				"name": "Band",
				"salience": 0.0029136995,
				"type": "ORGANIZATION"
			},
			{
				"name": "business",
				"salience": 0.0028135204,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0027780936,
				"type": "PERSON"
			},
			{
				"name": "court clients",
				"salience": 0.0027674434,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.002755091,
				"type": "OTHER"
			},
			{
				"name": "goals",
				"salience": 0.0026642105,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0026642105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gr916",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhtar_Kent"
				},
				"name": "Muhtar Kent",
				"salience": 0.0025266518,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.0025212208,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "responsibilities",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.0023770253,
				"type": "WORK_OF_ART"
			},
			{
				"name": "concerns",
				"salience": 0.002336611,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.002307183,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.002307183,
				"type": "PERSON"
			},
			{
				"name": "multiplicity",
				"salience": 0.002307183,
				"type": "OTHER"
			},
			{
				"name": "engagement",
				"salience": 0.002307183,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0022803606,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0022595213,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0022595213,
				"type": "OTHER"
			},
			{
				"name": "Band",
				"salience": 0.00217699,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band",
				"salience": 0.00217699,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05sjhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Examiner"
				},
				"name": "Washington Examiner",
				"salience": 0.0021040582,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.0020236815,
				"type": "OTHER"
			},
			{
				"name": "tax exempt",
				"salience": 0.0019566799,
				"type": "OTHER"
			},
			{
				"name": "best practices",
				"salience": 0.0019566799,
				"type": "OTHER"
			},
			{
				"name": "adviser",
				"salience": 0.0019566799,
				"type": "PERSON"
			},
			{
				"name": "criticism",
				"salience": 0.0019566799,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0019420544,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0017457046,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0017237132,
				"type": "OTHER"
			},
			{
				"name": "chairman",
				"salience": 0.0017202331,
				"type": "PERSON"
			},
			{
				"name": "Band",
				"salience": 0.0016264218,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.0014740054,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.0014740054,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0014617938,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wind",
				"salience": 0.0014617938,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0014617938,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0013566749,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.0012408686,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ways",
				"salience": 0.0012295237,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0012044621,
				"type": "ORGANIZATION"
			},
			{
				"name": "nothing",
				"salience": 0.0011783434,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0011059518,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0011011399,
				"type": "WORK_OF_ART"
			},
			{
				"name": "memo",
				"salience": 0.0010793139,
				"type": "WORK_OF_ART"
			},
			{
				"name": "advisory board",
				"salience": 0.0010646685,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.0010646685,
				"type": "OTHER"
			},
			{
				"name": "CGI",
				"salience": 0.0010646685,
				"type": "OTHER"
			},
			{
				"name": "clients",
				"salience": 0.000918478,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.000918478,
				"type": "OTHER"
			},
			{
				"name": "donations",
				"salience": 0.000918478,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.000918478,
				"type": "PERSON"
			},
			{
				"name": "principals",
				"salience": 0.0008054645,
				"type": "PERSON"
			},
			{
				"name": "introductions",
				"salience": 0.0007953137,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cjjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Podest%C3%A0"
				},
				"name": "Podesta",
				"salience": 0.0007567595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03phgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Coca-Cola_Company"
				},
				"name": "Coca-Cola",
				"salience": 0.00048947235,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775658391.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:28.925+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAn internal memo released Wednesday by WikiLeaks reveals how a longtime Clinton confidant played an \"unorthodox\" dual role – raising money for the Clinton Foundation and finding paid work for Bill Clinton, The Hill reports. \nThe 12-page document written in 2011 by Doug Band of Teneo, a private consulting firm that raised millions for the foundation and also scouted out paid gigs for what was dubbed \"Bill Clinton, Inc.\", the Washington Examiner reports. \nIn one instance, Band secured a $540,000 donation to the Clinton Foundation from banking giant UBS. He later arranged for Bill Clinton to give three paid speeches to the firm for a total of $900,000, The Hill reported. \nBut in his memo, Band argues his double duties were \"independent\" of one another; the memo was written after Chelsea Clinton criticized Band's role within the family's network of interests, The Hill reports. \n\"In the unique roles in which we have had the opportunity to serve, we have been able to help balance the multiplicity of activities that demand [Bill Clinton's] time and engagement to best fulfill his personal, political, business, official former President, and Foundation/non-profit goals,\" Band writes. \nAccording to The Hill, Teneo's overlapping responsibilities worried some in the Clintons' inner circle, and in one email published by WikiLeaks, Chelsea Clinton raised \"serious concerns\" with Teneo's liberal use of the Clinton name to court clients. \nBand lashed out, calling the former first daughter a meddlesome \"spoiled brat\" in one hacked email released by WikiLeaks. \n\"We appreciate the unorthodox nature of our roles, and the goal of seeking ways to ensure we are implementing best practices to protect the [tax exempt] status of the Foundation,\" Band wrote in his memo to justify his role and bat back criticism, The Hill reports. \nBand co-founded Teneo with former State Department employee Declan Kelly while Hillary Clinton was secretary of state – and paid Bill Clinton as an adviser through 2012, The Hill reports. \nBand's memo lists several Teneo clients that he and Kelly \"leveraged\" into major donors for the foundation, and also details the personal introductions the two principals made between the Clintons and the prospective donors, The Hill reports. \nOne that Kelly \"cultivated\" was Coca-Cola CEO Muhtar Kent, which led to seven-figure donations beginning in 2009. \nIn a previous hacked email to Hillary Clinton campaign chairman John Podesta, Band worried the press might catch wind of his role and misconstrue it. \n\"I'm starting to worry that if this story gets out, we are screwed,\" Band wrote. \n\"[Kelly] and I built a business. Our business has almost nothing to do with the Clintons, the foundation or [the Clinton Global Initiative] in any way. The chairman of UBS could care a less [sic] about CGI.\" \nA week after Band sent his memo, Clinton lawyer Cheryl Mills sent a document to Podesta and Band laying out ways to unwind the former president's charitable and business interests — all of which distanced Band from the foundation. \nIn December 2011, the former president resigned his position on Teneo’s advisory board, The Hill reports.",
		"thread_title": "WikiLeaks: Clinton Confidant Raised Money for Foundation, Got Bill Paid Gigs",
		"title": "WikiLeaks: Clinton Confidant Raised Money for Foundation, Got Bill Paid Gigs",
		"type": "conspiracy",
		"uuid": "38d6e2e3121d7708f6e98cec4bc412c008a0a5da"
	},
	"-KhIjMfH_PwL01OOnbWr": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:28.983+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "country",
				"salience": 0.19232616,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06497859,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.03930468,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.022894068,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02dkt6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Snopes.com"
				},
				"name": "Snopes",
				"salience": 0.022645812,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.018761689,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.018678304,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.017483309,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.017477088,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack H Obama",
				"salience": 0.016198277,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.015499141,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.014053362,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.013764001,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.012662205,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.011389378,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.01103664,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.01103664,
				"type": "EVENT"
			},
			{
				"name": "Company",
				"salience": 0.01103664,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.009903213,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.009603065,
				"type": "OTHER"
			},
			{
				"name": "sum",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "Reports",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "abatement",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "facilitation",
				"salience": 0.009560271,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.009379071,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_H._W._Bush"
				},
				"name": "George H.W. Bush",
				"salience": 0.008994957,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017jh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Prescott_Bush"
				},
				"name": "Prescott Bush",
				"salience": 0.008930082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.008773918,
				"type": "PERSON"
			},
			{
				"name": "Rick Williams",
				"salience": 0.0068942467,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0061764615,
				"type": "PERSON"
			},
			{
				"name": "high crimes",
				"salience": 0.006144459,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.006144459,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.006144459,
				"type": "EVENT"
			},
			{
				"name": "plans",
				"salience": 0.0059668357,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.005889339,
				"type": "ORGANIZATION"
			},
			{
				"name": "Qatar Central Bank",
				"salience": 0.005889339,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hlwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JPMorgan_Chase"
				},
				"name": "JP Morgan Chase",
				"salience": 0.005889339,
				"type": "ORGANIZATION"
			},
			{
				"name": "Administration",
				"salience": 0.0058175917,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00564283,
				"type": "PERSON"
			},
			{
				"name": "exit plans",
				"salience": 0.005060932,
				"type": "OTHER"
			},
			{
				"name": "extradition country",
				"salience": 0.005059125,
				"type": "LOCATION"
			},
			{
				"name": "extradition treaty",
				"salience": 0.0049714525,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.004886963,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.004855339,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.004552719,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.004549542,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.004549542,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.004130809,
				"type": "LOCATION"
			},
			{
				"name": "purchase",
				"salience": 0.0040802523,
				"type": "EVENT"
			},
			{
				"name": "purchase",
				"salience": 0.0040802523,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.003939955,
				"type": "EVENT"
			},
			{
				"name": "debates",
				"salience": 0.003939955,
				"type": "EVENT"
			},
			{
				"name": "material",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "e-mail server",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.003928047,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0039144526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0038077561,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.003681968,
				"type": "PERSON"
			},
			{
				"name": "seaside mansion",
				"salience": 0.0035334802,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0035334802,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.0035334802,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0035334802,
				"type": "OTHER"
			},
			{
				"name": "mansion",
				"salience": 0.0035334802,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0035334802,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0035186987,
				"type": "OTHER"
			},
			{
				"name": "mansion",
				"salience": 0.003401651,
				"type": "LOCATION"
			},
			{
				"name": "deaths",
				"salience": 0.003401651,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.0033874207,
				"type": "OTHER"
			},
			{
				"name": "death penalty",
				"salience": 0.0033564644,
				"type": "OTHER"
			},
			{
				"name": "Administrations",
				"salience": 0.003331379,
				"type": "ORGANIZATION"
			},
			{
				"name": "purchase",
				"salience": 0.003331379,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0032512636,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.003210314,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0031905358,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0031905358,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0031226452,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "Presidential",
				"salience": 0.0031021668,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0030863173,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0030863173,
				"type": "LOCATION"
			},
			{
				"name": "justice",
				"salience": 0.00307149,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.00307149,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00307149,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.00307149,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.003051604,
				"type": "ORGANIZATION"
			},
			{
				"name": "possibility",
				"salience": 0.0029066012,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.002812655,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.002762894,
				"type": "OTHER"
			},
			{
				"name": "firing",
				"salience": 0.002762894,
				"type": "EVENT"
			},
			{
				"name": "yacht",
				"salience": 0.002659792,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "announcement",
				"salience": 0.002659792,
				"type": "EVENT"
			},
			{
				"name": "terrorist groups",
				"salience": 0.002659792,
				"type": "ORGANIZATION"
			},
			{
				"name": "connections",
				"salience": 0.0026048338,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.002507626,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0024888802,
				"type": "OTHER"
			},
			{
				"name": "purchase",
				"salience": 0.0024888802,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0023328988,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0023328988,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0023328988,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.0023135724,
				"type": "OTHER"
			},
			{
				"name": "perpetrators",
				"salience": 0.0022556449,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.0021991667,
				"type": "WORK_OF_ART"
			},
			{
				"name": "extradition",
				"salience": 0.002029205,
				"type": "OTHER"
			},
			{
				"name": "real estate",
				"salience": 0.0019459728,
				"type": "LOCATION"
			},
			{
				"name": "real estate",
				"salience": 0.0019459728,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0019459728,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0019459728,
				"type": "OTHER"
			},
			{
				"name": "corrupt",
				"salience": 0.0019459728,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0019147497,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0019147497,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi Dictatorship",
				"salience": 0.0018909011,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05g9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Party"
				},
				"name": "Nazis",
				"salience": 0.0018909011,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0018907344,
				"type": "PERSON"
			},
			{
				"name": "Administration",
				"salience": 0.001812772,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01f08r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dubai"
				},
				"name": "Dubai",
				"salience": 0.0017007114,
				"type": "LOCATION"
			},
			{
				"name": "humanity",
				"salience": 0.0016850636,
				"type": "PERSON"
			},
			{
				"name": "trillions",
				"salience": 0.0016850636,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.0016850636,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0016850636,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0016850636,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0016793669,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gv10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nantucket"
				},
				"name": "Nantucket",
				"salience": 0.0016372278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0016372278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.0016372278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05v10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paraguay"
				},
				"name": "Paraguay",
				"salience": 0.0015772497,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0014172856,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.0013582828,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0013541746,
				"type": "OTHER"
			},
			{
				"name": "purchase",
				"salience": 0.0013541746,
				"type": "EVENT"
			},
			{
				"name": "criminals",
				"salience": 0.0013088598,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0012692804,
				"type": "PERSON"
			},
			{
				"name": "death penalty",
				"salience": 0.0012327426,
				"type": "EVENT"
			},
			{
				"name": "laws",
				"salience": 0.0012272357,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0012272357,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0012272357,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0012272357,
				"type": "OTHER"
			},
			{
				"name": "stipulation",
				"salience": 0.0011373137,
				"type": "OTHER"
			},
			{
				"name": "connections",
				"salience": 0.0010587081,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0010587081,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.0010539783,
				"type": "OTHER"
			},
			{
				"name": "extradition request",
				"salience": 0.00091672846,
				"type": "OTHER"
			},
			{
				"name": "shareholder",
				"salience": 0.00091672846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02hbt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dictatorship"
				},
				"name": "Dictatorship",
				"salience": 0.0008722853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "WWII",
				"salience": 0.000858062,
				"type": "EVENT"
			},
			{
				"name": "institutions",
				"salience": 0.00084955234,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazis",
				"salience": 0.0008218372,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gl3g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Basic_Law_for_the_Federal_Republic_of_Germany"
				},
				"name": "Constitution",
				"salience": 0.00075530075,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06n3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_America"
				},
				"name": "South America",
				"salience": 0.00065156835,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.00042826415,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775656811.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:28.983+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nIt appears Bill and Hillary Clinton are making plans to flee the country in the event Donald Trump wins this election. Reports are circulating that the Clinton’s have transferred 1.8 Billion dollars from the Clinton Foundation to the Qatar Central Bank via a facilitation/abatement of JP Morgan Chase & Company for reasons not revealed. \nThis move of such a large sum of money to the country of Qatar says in itself Hillary Clinton knows she is going to lose the election, and she doesn’t plan to allow her or Bill to be prosecuted for various high crimes and treason under a Trump Administration. \nThe country of Qatar happens to be one of a handful of countries that does not have an extradition treaty with the United States, thus would be a perfect place for her to run to in escaping justice. \nDonald Trump has said many times during his campaign and at the Presidential debates that once he gets into office he intends to prosecute her on various high crimes from her latest crimes of sending classified material via a personal e-mail server to gun-running to terrorist groups in Syria resulting in the deaths of 4 Americans in Benghazi. \nApparently, Hillary is not the only person in Washington who has made plans to escape justice under a Trump Administration, John Kerry has quietly been selling his property in the US for millions of dollars of late, with an announcement of the sale of his $25 million Nantucket mansion in June 2016 as well as the sale of his yacht for $3.9 million in July 2016. \nPresident Barack H Obama has also apparently been making exit plans with his purchase of a $4.9 million seaside mansion in Dubai in January 2016, another non extradition country. \nSnopes and other supposed fact checking sites have debunked both the story of Obama’s purchase of the mansion and the firing of Rear Admiral Rick Williams, however over the last several months these sites have been busted for lying in trying to debunk such information as the before mentioned, when in fact the information is true. Snopes and other sites try their best to keep incriminating information from being believed, but the truth has a way of coming out on its own, as it always has. \nThe Bush family has been quietly buying property as well with the purchase of 100,000 acres in Paraguay in 2006, yet another country good for the Bush family, since it does not allow extradition to any country if the death penalty is a possibility for the crime. If the corruption is found to go as far back as both of the Bush Administrations with any connections to them being the perpetrators of the events on 9-11, the death penalty would surely be a stipulation of any extradition request. Apparently, if things get going with prosecuting the corrupt and treasonous, the Bush’s plan on getting out of the country as well. \nInterestingly, the Bush family’s Nazi connections dating back to WWII seem to have played a part in the Paraguay purchase since most Nazis fled to South America after WWII. Since George H. W. Bush’s father Senator Prescott Bush was director and shareholder in companies that were connected with institutions financially backing the Nazis, the Bush family has a long history of being associated with Nazis. \nWith the movement of huge amounts of funds, selling millions of dollars in real estate, and the purchase of millions in real estate overseas, we are seeing the plans of the corrupt in Washington who have been ripping of our country in the trillions, murdering US citizens in the thousands, and citizens in foreign countries by the millions since 9-11 finally realizing their crimes against humanity is about to be exposed. \nWe are also witnessing the change from what amounts to nothing more than a Nazi Dictatorship in Washington to an actual Presidential Administration who not only will look to the Constitution as the basis of all laws, but one who is going to prosecute the criminals in our government and return it to being a government by the people, for the people, and of the people of the USA. Not the Dictatorship over the people, to the people and who disregards the people as we now have in power.",
		"thread_title": "Hillary Planning Her Escape After a Trump Win With a $1.8 BILLION Money Transfer to QATAR",
		"title": "Hillary Planning Her Escape After a Trump Win With a $1.8 BILLION Money Transfer to QATAR",
		"type": "conspiracy",
		"uuid": "3a37c69c4f2e9bec775134184ddd919d9a39589e"
	},
	"-KhIjMrU_wfpv95VBOHQ": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:28.997+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.37415966,
				"type": "PERSON"
			},
			{
				"name": "dairy farmer",
				"salience": 0.08826368,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.07190234,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.056584273,
				"type": "PERSON"
			},
			{
				"name": "family farm",
				"salience": 0.040825173,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01xyt7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Brady"
				},
				"name": "Tom Brady",
				"salience": 0.03614496,
				"type": "PERSON"
			},
			{
				"name": "kid",
				"salience": 0.028915362,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.026971275,
				"type": "OTHER"
			},
			{
				"name": "family dairy farm",
				"salience": 0.019129358,
				"type": "LOCATION"
			},
			{
				"name": "cattle",
				"salience": 0.015976358,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.015976358,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.015976358,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.01281964,
				"type": "OTHER"
			},
			{
				"name": "Willow Brady Jr.",
				"salience": 0.012594269,
				"type": "PERSON"
			},
			{
				"name": "brothers",
				"salience": 0.012279979,
				"type": "PERSON"
			},
			{
				"name": "intercourse",
				"salience": 0.010357127,
				"type": "OTHER"
			},
			{
				"name": "cows names",
				"salience": 0.008788234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013l6l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sioux_Falls,_South_Dakota"
				},
				"name": "Sioux Falls",
				"salience": 0.008539538,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.006690481,
				"type": "LOCATION"
			},
			{
				"name": "Sex",
				"salience": 0.006653951,
				"type": "OTHER"
			},
			{
				"name": "step dad",
				"salience": 0.0065997103,
				"type": "PERSON"
			},
			{
				"name": "holidays",
				"salience": 0.0057165585,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.0057165585,
				"type": "LOCATION"
			},
			{
				"name": "farm",
				"salience": 0.0055494662,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0046303417,
				"type": "EVENT"
			},
			{
				"name": "cattle",
				"salience": 0.0046303417,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.0046303417,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "everything",
				"salience": 0.0044944165,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.0040102745,
				"type": "OTHER"
			},
			{
				"name": "caucus",
				"salience": 0.0040102745,
				"type": "EVENT"
			},
			{
				"name": "festivities",
				"salience": 0.0040102745,
				"type": "EVENT"
			},
			{
				"name": "President",
				"salience": 0.00388467,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0038607544,
				"type": "OTHER"
			},
			{
				"name": "fan",
				"salience": 0.0038607544,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0038607544,
				"type": "ORGANIZATION"
			},
			{
				"name": "heart",
				"salience": 0.0038607544,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.0037810488,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "truth",
				"salience": 0.0037810488,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0036700163,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Clinton",
				"salience": 0.0034379307,
				"type": "PERSON"
			},
			{
				"name": "dad",
				"salience": 0.0033736413,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.0032745558,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0032745558,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.002902838,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.0026856451,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0023772689,
				"type": "ORGANIZATION"
			},
			{
				"name": "enemy",
				"salience": 0.002267528,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0020580583,
				"type": "PERSON"
			},
			{
				"name": "misconduct",
				"salience": 0.0017821948,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0016516582,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.001537543,
				"type": "PERSON"
			},
			{
				"name": "cows",
				"salience": 0.001537543,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0015062067,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0015062067,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0013314103,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0013314103,
				"type": "WORK_OF_ART"
			},
			{
				"name": "something",
				"salience": 0.0013314103,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0013314103,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0013314103,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0010970185,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0010970185,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0509p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monica_Lewinsky"
				},
				"name": "Monica Lewinsky",
				"salience": 0.0010970185,
				"type": "PERSON"
			},
			{
				"name": "hell",
				"salience": 0.0007717769,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775655091.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:28.997+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nSioux Falls, IA | During his 1992 presidential campaign, Bill Clinton allegedly had sexual intercourse with cattle off of Tom Brady’s family dairy farm. \nThe family farm which was owned by Tom Brady’s father at the time, Willow Brady Jr., was often visited by the Clinton family when they were in the area. \n“My dad and Bill Clinton’s step dad were like brothers. They often visited us on the holidays when I was a kid. Bill even knew the cows names by heart. That always surprised me” recalls the 64-year-old, third-generation dairy farmer. \n“ My father was a strong Democratic party supporter all his life and a big Bill Clinton fan, so I never found the strength to tell him the truth before he passed away ” \nSex, drugs and cattle \nDuring the 1992 Iowa caucus, the Clinton campaign stopped by for a night of festivities at the Brady’s farm, a night Tom Brady says he will never forget. \n“The Clinton team came by and we drank a lot and all was merry before they started indulging in hard drugs, that’s when everything went wrong” he recalls, visibly distraught by the whole affair. \n“I don’t know about all those stories about him sexually assaulting women, but I sure as hell know he assaulted one of our cows because I was there and I saw him do it with my own eyes and believe me, it’s not something I’d wish my worst enemy to live to see” he told local reporters. \n“I’m sorry for the Clinton family, but as a God-fearing Christian, I just had to let the truth be known” he adds. \nBill Clinton has been personally accused publicly by seventeen women of sexual misconduct between 1972 and 1997. The former US President also admitted to having had an “inappropriate relationship” with Monica Lewinsky while she worked at the White House in 1995 and 1996.",
		"thread_title": "IOWA FARMER CLAIMS BILL CLINTON HAD SEX WITH COW DURING ‘COCAINE PARTY’",
		"title": "IOWA FARMER CLAIMS BILL CLINTON HAD SEX WITH COW DURING ‘COCAINE PARTY’",
		"type": "conspiracy",
		"uuid": "0964c5c6a86fd36e4b712bc4f2b1b31bd056e6d0"
	},
	"-KhIjN444virA-6Ztrb1": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:29.028+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Bill Clinton Inc.)",
				"salience": 0.4373442,
				"type": "PERSON"
			},
			{
				"name": "partners",
				"salience": 0.071097605,
				"type": "ORGANIZATION"
			},
			{
				"name": "memo",
				"salience": 0.044514824,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04cxlc4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doug_Band"
				},
				"name": "Doug Band",
				"salience": 0.043020964,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.03174825,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea Clinton",
				"salience": 0.029893573,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k3llq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Teneo"
				},
				"name": "Teneo",
				"salience": 0.027838757,
				"type": "ORGANIZATION"
			},
			{
				"name": "cronies",
				"salience": 0.012824749,
				"type": "PERSON"
			},
			{
				"name": "Declan Kelly",
				"salience": 0.012782723,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.011671433,
				"type": "OTHER"
			},
			{
				"name": "arrangement",
				"salience": 0.011636388,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.01017591,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07qk51t"
				},
				"name": "Band",
				"salience": 0.009998039,
				"type": "ORGANIZATION"
			},
			{
				"name": "arrangement",
				"salience": 0.009878559,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0090662055,
				"type": "LOCATION"
			},
			{
				"name": "arrangement",
				"salience": 0.008818774,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.008818774,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.008818774,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Bill Clinton Inc.",
				"salience": 0.008610885,
				"type": "ORGANIZATION"
			},
			{
				"name": "Laureate Foundation",
				"salience": 0.008131558,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.0076036933,
				"type": "ORGANIZATION"
			},
			{
				"name": "memo",
				"salience": 0.006921216,
				"type": "WORK_OF_ART"
			},
			{
				"name": "company",
				"salience": 0.0069027185,
				"type": "ORGANIZATION"
			},
			{
				"name": "consulting firm",
				"salience": 0.005980399,
				"type": "ORGANIZATION"
			},
			{
				"name": "millions",
				"salience": 0.005980399,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0058311345,
				"type": "OTHER"
			},
			{
				"name": "consulting company",
				"salience": 0.005293864,
				"type": "ORGANIZATION"
			},
			{
				"name": "players",
				"salience": 0.005236253,
				"type": "PERSON"
			},
			{
				"name": "foundation",
				"salience": 0.004203302,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.003743316,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.003685676,
				"type": "ORGANIZATION"
			},
			{
				"name": "speeches",
				"salience": 0.0034129878,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0033755917,
				"type": "ORGANIZATION"
			},
			{
				"name": "advisory services business",
				"salience": 0.003248783,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0028950386,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0028476582,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.002839058,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.002839058,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band memo",
				"salience": 0.002802026,
				"type": "WORK_OF_ART"
			},
			{
				"name": "excess",
				"salience": 0.0024662842,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.0024662842,
				"type": "ORGANIZATION"
			},
			{
				"name": "arrangement",
				"salience": 0.0024588339,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.0024429257,
				"type": "OTHER"
			},
			{
				"name": "e-mail",
				"salience": 0.0024429257,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.002394139,
				"type": "EVENT"
			},
			{
				"name": "memo",
				"salience": 0.002346735,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Laureate",
				"salience": 0.0023269244,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.0023048639,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0022068725,
				"type": "PERSON"
			},
			{
				"name": "Bob McCann",
				"salience": 0.0021945813,
				"type": "PERSON"
			},
			{
				"name": "vet donors",
				"salience": 0.0021156804,
				"type": "PERSON"
			},
			{
				"name": "fee",
				"salience": 0.0020747315,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.002056494,
				"type": "EVENT"
			},
			{
				"name": "globe",
				"salience": 0.0019973512,
				"type": "LOCATION"
			},
			{
				"name": "speeches",
				"salience": 0.0019797927,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0019548659,
				"type": "EVENT"
			},
			{
				"name": "speeches",
				"salience": 0.0019548659,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.0019548659,
				"type": "WORK_OF_ART"
			},
			{
				"name": "For-Profit Activity",
				"salience": 0.0019500601,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0017993514,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.0017297256,
				"type": "OTHER"
			},
			{
				"name": "chairman",
				"salience": 0.0017297256,
				"type": "PERSON"
			},
			{
				"name": "Band",
				"salience": 0.0017039712,
				"type": "ORGANIZATION"
			},
			{
				"name": "meeting",
				"salience": 0.0016651987,
				"type": "EVENT"
			},
			{
				"name": "hundreds",
				"salience": 0.0016651987,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0016651987,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0016651987,
				"type": "OTHER"
			},
			{
				"name": "business interests",
				"salience": 0.0016651987,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0016308022,
				"type": "OTHER"
			},
			{
				"name": "UBS Wealth Management",
				"salience": 0.0015715493,
				"type": "ORGANIZATION"
			},
			{
				"name": "e-mail",
				"salience": 0.0015582289,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0014669795,
				"type": "PERSON"
			},
			{
				"name": "addresses",
				"salience": 0.0014122452,
				"type": "OTHER"
			},
			{
				"name": "sessions",
				"salience": 0.0014122452,
				"type": "EVENT"
			},
			{
				"name": "commitment",
				"salience": 0.0014122452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0013668261,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08wgq7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laureate"
				},
				"name": "Laureate",
				"salience": 0.0013619151,
				"type": "OTHER"
			},
			{
				"name": "foundation donors",
				"salience": 0.0013493894,
				"type": "PERSON"
			},
			{
				"name": "reach",
				"salience": 0.0013255178,
				"type": "OTHER"
			},
			{
				"name": "Band",
				"salience": 0.0012570518,
				"type": "ORGANIZATION"
			},
			{
				"name": "relationship",
				"salience": 0.0012076903,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/094jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltimore"
				},
				"name": "Baltimore",
				"salience": 0.0010648756,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.0010550799,
				"type": "PERSON"
			},
			{
				"name": "board member",
				"salience": 0.0010550799,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0010550799,
				"type": "OTHER"
			},
			{
				"name": "audit",
				"salience": 0.0010550799,
				"type": "OTHER"
			},
			{
				"name": "muddle",
				"salience": 0.0010550799,
				"type": "OTHER"
			},
			{
				"name": "business opportunities",
				"salience": 0.0010550799,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.00089563074,
				"type": "WORK_OF_ART"
			},
			{
				"name": "business arrangements",
				"salience": 0.0008479317,
				"type": "OTHER"
			},
			{
				"name": "e-mail",
				"salience": 0.0008479317,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0008049246,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.00076845917,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.00076845917,
				"type": "PERSON"
			},
			{
				"name": "CGI official",
				"salience": 0.00076845917,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.00076845917,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00076845917,
				"type": "PERSON"
			},
			{
				"name": "links",
				"salience": 0.00076845917,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.0007342431,
				"type": "PERSON"
			},
			{
				"name": "fee",
				"salience": 0.00068865233,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0006825933,
				"type": "OTHER"
			},
			{
				"name": "plane",
				"salience": 0.00057404995,
				"type": "OTHER"
			},
			{
				"name": "engagements",
				"salience": 0.00057404995,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0129tn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citizens_United_(organization)"
				},
				"name": "Citizens United",
				"salience": 0.000472974,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic_of_Ireland"
				},
				"name": "Ireland",
				"salience": 0.000472974,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03h64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hong_Kong"
				},
				"name": "Hong Kong",
				"salience": 0.00035330103,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775653191.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:29.028+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nTwo Bill Clinton cronies used their private consulting firm to steer millions in business to the former president while raising funds for the Clinton Foundation — and even called the arrangement “Bill Clinton Inc.” \nDoug Band, a top Clinton aide, detailed the complex financial arrangement between his company, Teneo, and the foundation in a memo contained in hacked e-mails released Wednesday by WikiLeaks. \n“Teneo partners have raised in excess of $8 million for the foundation, more than $5.25 million of which is in the bank,” the memo reads. \n“Teneo partners also have generated over $3 million in paid speeches for President Clinton, $1.25 million of which has been paid to him thus far.” \nThe consulting company was formed by Band and former State Department envoy Declan Kelly. The memo about its activities shows the incestuous relationship between the foundation and the private business interests of the former president. \nIn one arrangement, Kelly introduced Bob McCann, the head of UBS Wealth Management, to Clinton at an event in 2009. \nAfter the meeting, McCann donated hundreds of thousands to the foundation while inviting Clinton to give several paid speeches. \nAnother arrangement involved the Laureate Foundation, which donated more than $1 million to the Clinton Global Initiative. \nLaureate was a “personal advisory services business,” the memo said, paying Clinton “$3.5 million annually to provide advice and serve as their honorary chairman.” \nThe cozy relationship with the Clintons put the Baltimore-based Laureate at high-profile events with international players who could help it expand its reach around the globe. \nThe Band memo also includes a section about “For-Profit Activity of President Clinton (i.e., Bill Clinton Inc.).” \nSome of the speeches “secured” by Teneo include two $450,000 addresses delivered to UBS in 2011 and 2012, as well as a commitment for three additional paid speeches, if he chose to give them. \nAnother secured event was a $1 million fee for Clinton to speak at two one-hour sessions during an event in Hong Kong. The fee included $400,000 for a private plane. \n“Since 2001, President Clinton’s business arrangements have yielded more than $30 million for him personally, with $66 million to be paid out over the next nine years should he choose to continue with the current engagements,” the memo reads. \nThe relationship between Band and the donors was criticized harshly by daughter Chelsea Clinton in another e-mail. \nChelsea specifically called out Band and Teneo for “hustling’” business opportunities out of the foundation. \n“I continue to want — and to try — to disintermediate myself from this muddle, edify the corporate audit and existential process we are in — while also being a responsible board member, daughter and person,” Chelsea wrote in the 2011 e-mail. \nThe relationship between foundation donors and Hillary Clinton’s State Department was raised through e-mails obtained by Citizens United in which top Hillary aide Huma Abedin appeared to vet donors’ access to the Clintons based on their links to the CGI. \nIn a December 2012 e-mail in which a CGI official asks for Band and a few others to meet with Hillary during a trip to Ireland, Abedin writes to Band, “Are these legit cgi people?”",
		"thread_title": "Clinton cronies steered millions to foundation — and Bill’s wallet",
		"title": "Clinton cronies steered millions to foundation — and Bill’s wallet",
		"type": "conspiracy",
		"uuid": "cd21eee9fa520e04a0aaf27cae983a5b29b7bafe"
	},
	"-KhIjNGeMVcTiYqIMd-6": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:29.046+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.74613255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.03946654,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012gx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Biden"
				},
				"name": "Joe Biden",
				"salience": 0.038911056,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.022170566,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.014664134,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.0083562685,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0066671716,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.006494789,
				"type": "OTHER"
			},
			{
				"name": "trillions",
				"salience": 0.0063330135,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.006313963,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.006313963,
				"type": "OTHER"
			},
			{
				"name": "workforce",
				"salience": 0.006313963,
				"type": "OTHER"
			},
			{
				"name": "bread-winner",
				"salience": 0.0058836606,
				"type": "PERSON"
			},
			{
				"name": "childcare",
				"salience": 0.0049421703,
				"type": "OTHER"
			},
			{
				"name": "GDP",
				"salience": 0.004281831,
				"type": "OTHER"
			},
			{
				"name": "stats",
				"salience": 0.0040531005,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.003862254,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0029202993,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.0027531162,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0026388883,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0024436507,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.0023452141,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0022393947,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.0020388882,
				"type": "OTHER"
			},
			{
				"name": "recession",
				"salience": 0.0020388882,
				"type": "EVENT"
			},
			{
				"name": "recession",
				"salience": 0.0020388882,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0018774809,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0018594201,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0018286799,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.001765832,
				"type": "OTHER"
			},
			{
				"name": "campaign event",
				"salience": 0.001765832,
				"type": "EVENT"
			},
			{
				"name": "woman",
				"salience": 0.0015837346,
				"type": "PERSON"
			},
			{
				"name": "reasons",
				"salience": 0.0014300842,
				"type": "OTHER"
			},
			{
				"name": "downfall",
				"salience": 0.0014237019,
				"type": "OTHER"
			},
			{
				"name": "behinds",
				"salience": 0.0013767447,
				"type": "OTHER"
			},
			{
				"name": "behinds",
				"salience": 0.0013678345,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0012384685,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0012384685,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.0012022234,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.001192268,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.001192268,
				"type": "OTHER"
			},
			{
				"name": "economics",
				"salience": 0.0011784085,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0011676406,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.0011676406,
				"type": "LOCATION"
			},
			{
				"name": "household",
				"salience": 0.0011676406,
				"type": "OTHER"
			},
			{
				"name": "workforce",
				"salience": 0.001115679,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m49v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chatham_University"
				},
				"name": "Chatham University",
				"salience": 0.0010873103,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0010873103,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/068p2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pittsburgh"
				},
				"name": "Pittsburgh",
				"salience": 0.0010873103,
				"type": "LOCATION"
			},
			{
				"name": "dinner",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "free-loader",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "commodity",
				"salience": 0.000998421,
				"type": "OTHER"
			},
			{
				"name": "workplaces",
				"salience": 0.00081267045,
				"type": "LOCATION"
			},
			{
				"name": "laws",
				"salience": 0.00075543026,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00075543026,
				"type": "PERSON"
			},
			{
				"name": "demand",
				"salience": 0.00075543026,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.00075543026,
				"type": "WORK_OF_ART"
			},
			{
				"name": "supply",
				"salience": 0.00075543026,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00075543026,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0006412662,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00061168754,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0005502124,
				"type": "PERSON"
			},
			{
				"name": "folks",
				"salience": 0.0005502124,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.0005502124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.00043315702,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.00042157527,
				"type": "OTHER"
			},
			{
				"name": "sleeves",
				"salience": 0.0004110169,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0004110169,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775651301.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:29.046+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nDemocratic Vice President Joe Biden wants American women to get back in the workforce to help boost the economy. “If we just put all the women back to work, if they were able to afford childcare, we would increase the GDP in America by close to eight tenths of one percent,” he said. “That’s trillions of dollars over the next decade.” \nBiden made his remarks during a campaign event for Hillary Clinton at Chatham University in Pittsburgh, Pennsylvania on Tuesday. “The state of our economy could be characterized by a single word: pitiful,” he argued. “We’re still battling recession, I don’t care what the official stats are saying, America is still in recession. And we’re not doing anything about it.” \nHe added that it was “lazy American women” who brought about the downfall of the economy, because “they sit around on their behinds, doing nothing and squandering their days away when they could be improving the country that has given so much to them.” “I’m not sure how exactly we got to this point, but we’re here and we need to move. Like, yesterday,” he said. \n“Mark my words and mark them well,” he addressed the crowd. “Hillary Clinton is the only one who can force American women to go to work. This is true because of a number of reasons. First, she’s a woman herself and not just any woman; she’s a self-made woman. So you better believe what she’s saying is true and has been tried and tested in practice plenty of times.” \n“Second, Hillary Clinton understands how difficult it can be to give up the status of a free-loader when your husband is the bread-winner of the household and the wife is expected to tend to the house, the children, make sure dinner is served and always be in the mood for marital duties. She’s been all that and she’s learned how to break free from it, the hard way, I might add,” Biden continued. \n“Today’s women are pampered and aren’t used to rolling up their sleeves and getting the job done on their own,” the vice president said. “They’re too dependent, too weak and too lazy to contribute to the economy. The reason for that is they’ve learned how to manipulate men by employing one of the most fundamental laws of economics: when a sought-after commodity becomes short in supply, the demand for it rises even higher.” \n“Now, that’s all fine and dandy when it comes to their personal interests, but if you look at the big picture, it’s the economy that’s missing out on valuable workforce. And that’s why we need to get them off their lazy behinds and get them into their workplaces. And like I said, Hillary Clinton is the only one who can do it, which is what makes her the ideal candidate for the next President of the United States. We need to heal this country, folks, not run it into the ground even deeper,” Biden concluded.",
		"thread_title": "Biden Blames “Lazy American Women” For The Economy: “They Sit Around Doing Nothing, Only Hillary Can Force Them To Work”",
		"title": "Biden Blames “Lazy American Women” For The Economy: “They Sit Around Doing Nothing, Only Hillary Can Force Them To Work”",
		"type": "conspiracy",
		"uuid": "bc9916cdecdfaf1ee4991002b397cb489be07aec"
	},
	"-KhIjNQY63U8VM0HIoTG": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:29.054+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.25591353,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "DONALD TRUMP",
				"salience": 0.16289939,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.043379556,
				"type": "OTHER"
			},
			{
				"name": "SCHOOLS",
				"salience": 0.037849117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01sj48",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Legion"
				},
				"name": "American Legion",
				"salience": 0.032196794,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.025716225,
				"type": "OTHER"
			},
			{
				"name": "PATRIOTISM",
				"salience": 0.025716225,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.023620624,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "AMERICAN",
				"salience": 0.023396008,
				"type": "ORGANIZATION"
			},
			{
				"name": "values",
				"salience": 0.02281323,
				"type": "OTHER"
			},
			{
				"name": "PRIDE",
				"salience": 0.022290302,
				"type": "OTHER"
			},
			{
				"name": "GOAL",
				"salience": 0.022290302,
				"type": "OTHER"
			},
			{
				"name": "SCHOOL CURRICULA",
				"salience": 0.022290302,
				"type": "OTHER"
			},
			{
				"name": "CHANGES",
				"salience": 0.022290302,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.014442541,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "REPUBLICAN",
				"salience": 0.013753012,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.009208459,
				"type": "PERSON"
			},
			{
				"name": "convention",
				"salience": 0.009208459,
				"type": "EVENT"
			},
			{
				"name": "institutions",
				"salience": 0.00795218,
				"type": "ORGANIZATION"
			},
			{
				"name": "government intervention",
				"salience": 0.0074593253,
				"type": "EVENT"
			},
			{
				"name": "programs",
				"salience": 0.0074593253,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0074593253,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00718137,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0067205355,
				"type": "ORGANIZATION"
			},
			{
				"name": "achievements",
				"salience": 0.006219893,
				"type": "OTHER"
			},
			{
				"name": "heroes",
				"salience": 0.006219893,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.006219893,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.006091519,
				"type": "WORK_OF_ART"
			},
			{
				"name": "values",
				"salience": 0.006091519,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.006091519,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01snm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cincinnati"
				},
				"name": "Cincinnati",
				"salience": 0.0056727533,
				"type": "LOCATION"
			},
			{
				"name": "kids",
				"salience": 0.0053429664,
				"type": "PERSON"
			},
			{
				"name": "flag",
				"salience": 0.0052757184,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.0052757184,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0052757184,
				"type": "LOCATION"
			},
			{
				"name": "culture",
				"salience": 0.0052757184,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.004896688,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.0045520356,
				"type": "PERSON"
			},
			{
				"name": "interest groups",
				"salience": 0.0045520356,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign funding",
				"salience": 0.0045520356,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0045520356,
				"type": "OTHER"
			},
			{
				"name": "state money",
				"salience": 0.003942158,
				"type": "OTHER"
			},
			{
				"name": "school board election",
				"salience": 0.003942158,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.0037641213,
				"type": "OTHER"
			},
			{
				"name": "instruction",
				"salience": 0.003672483,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.003672483,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0033160818,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0033160818,
				"type": "OTHER"
			},
			{
				"name": "curriculum",
				"salience": 0.0033160818,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0033160818,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0033160818,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "Constitution",
				"salience": 0.003248522,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02cl1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denver"
				},
				"name": "Denver",
				"salience": 0.003248522,
				"type": "LOCATION"
			},
			{
				"name": "direction",
				"salience": 0.0028716493,
				"type": "OTHER"
			},
			{
				"name": "supervision",
				"salience": 0.0028716493,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.0028716493,
				"type": "PERSON"
			},
			{
				"name": "school system",
				"salience": 0.0028716493,
				"type": "ORGANIZATION"
			},
			{
				"name": "school board",
				"salience": 0.0027438342,
				"type": "ORGANIZATION"
			},
			{
				"name": "patriotism",
				"salience": 0.002477486,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.002477486,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.002477486,
				"type": "OTHER"
			},
			{
				"name": "proxy war",
				"salience": 0.0021453705,
				"type": "EVENT"
			},
			{
				"name": "board members",
				"salience": 0.0021453705,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0021453705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p03t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jefferson_County,_Colorado"
				},
				"name": "Jefferson County",
				"salience": 0.0015250049,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colorado",
				"salience": 0.0013205208,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "AP",
				"salience": 0.0013205208,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775649831.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:29.054+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nREPUBLICAN PRESIDENTIAL CANDIDATE DONALD TRUMP SIGNALED THURSDAY PLANS TO SEEK NATIONWIDE CHANGES TO SCHOOL CURRICULA WITH THE GOAL OF “PROMOTING AMERICAN PRIDE AND PATRIOTISM IN AMERICA’S SCHOOLS.” \n“In a Trump administration, I plan to work directly with the American Legion to uphold our common values and to help ensure they are taught to America’s children,” Trump said, speaking at the American Legion’s annual convention in Cincinnati. \n“We want our kids to learn the incredible achievements of America’s history, its institutions and its heroes, many of whom are with us today,” he told the veterans group. \nThe comments suggested a federal government intervention in the programs of locally run schools, which is prohibited under federal law“We will stop apologizing for America. And we will start celebrating America. We will be united by our common culture, values and principles, becoming one American nation, one country, under one Constitution, saluting one American flag, and always saluting it,” Trump said. \nLast year a Denver-area school board sought to change the content of the AP U.S. history course because some board members thought it failed to promote patriotism. \nThat sparked a political proxy war in Jefferson County, Colorado, and the 2015 school board election drew nearly $1 million in campaign funding from outside interest groups. \nPublic schools nationwide are funded by their local communities along with some state money. Most schools receive little federal funding. \nCurrent federal law prohibits the federal government from exercising “any direction, supervision, or control over the curriculum, program of instruction, administration, or personnel of any educational institution, school, or school system.”",
		"thread_title": "TRUMP CALLS FOR TEACHING ‘PATRIOTISM’ IN SCHOOLS",
		"title": "TRUMP CALLS FOR TEACHING ‘PATRIOTISM’ IN SCHOOLS",
		"type": "conspiracy",
		"uuid": "064c2e450be0413994c4a67a87e026e149692e80"
	},
	"-KhIjNYiEc6hgsj_gifg": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:29.112+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05pdb7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rand_Paul"
				},
				"name": "Rand Paul",
				"salience": 0.3193501,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.26560405,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.073729314,
				"type": "OTHER"
			},
			{
				"name": "radio",
				"salience": 0.038163684,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.03559655,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.024425995,
				"type": "OTHER"
			},
			{
				"name": "polling",
				"salience": 0.0241209,
				"type": "OTHER"
			},
			{
				"name": "The Tom Roten Morning Show",
				"salience": 0.02361706,
				"type": "WORK_OF_ART"
			},
			{
				"name": "800 WVHU",
				"salience": 0.02361706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.02067942,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.019992841,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.01875986,
				"type": "ORGANIZATION"
			},
			{
				"name": "lead",
				"salience": 0.015838178,
				"type": "OTHER"
			},
			{
				"name": "election turnout",
				"salience": 0.014805864,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.014805864,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.011122854,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.011039996,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.009616908,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00908653,
				"type": "PERSON"
			},
			{
				"name": "turnout",
				"salience": 0.0068495064,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0054088696,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0051194187,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.004950099,
				"type": "OTHER"
			},
			{
				"name": "rigging",
				"salience": 0.003699095,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775648311.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:29.112+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nWednesday on 800 WVHU radio’s “The Tom Roten Morning Show,” Sen. Rand Paul (R-KY) said polls showing Democratic presidential nominee Hillary Clinton with a lead over Republican presidential nominee Donald Trump were “designed to suppress turnout.” \nPaul said “You know, I think sometimes polling is done to dampen election turnout. So when Trump says the thing’s rigged, I’m not sure exactly what he means and I’m not sure I always agree with him. But I do think that when we say over and over someone can’t win, that is a form of rigging in the sense that it is designed to suppress turnout.” \nHe added, “The polls are put out, you know to make it either look closer than it is or to make it look like Democrats have a better chance. And I think it’s done by design to try to dampen turnout.”",
		"thread_title": "Rand Paul: Polls Showing Hillary Ahead Are ‘Designed To Suppress Turnout’",
		"title": "Rand Paul: Polls Showing Hillary Ahead Are ‘Designed To Suppress Turnout’",
		"type": "conspiracy",
		"uuid": "45a6db1fed4955815b14f152a5491ca9f176c728"
	},
	"-KhIjNciFTOFIfvK_sJ0": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:29.153+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Email",
				"salience": 0.22403878,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.11788148,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media website",
				"salience": 0.11788148,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07kcz17",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Emarat_Al_Youm"
				},
				"name": "Emarat Al-Youm",
				"salience": 0.10574745,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "Emirati",
				"salience": 0.082850695,
				"type": "LOCATION"
			},
			{
				"name": "telephone conversations",
				"salience": 0.03523347,
				"type": "EVENT"
			},
			{
				"name": "press interview",
				"salience": 0.03350595,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contact",
				"salience": 0.03350595,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.032819286,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.030577937,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.028450886,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.021488853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.021488853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.021488853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.021488853,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.015529514,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.014395714,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.011611697,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01g87g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gulf_Cooperation_Council"
				},
				"name": "Gulf Cooperation Council",
				"salience": 0.010870612,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k3z42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Secretariat_of_Ukraine"
				},
				"name": "General-Secretariat",
				"salience": 0.009571853,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.009571853,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775621201.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:29.153+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAccording to a report by an Emirati media website, Emarat Al-Youm, Saudi ambassador to the UAE said in a press interview that any contact with Iran, Iraq, Syria, and Lebanon and even making telephone conversations with these countries’ officials by the members of the Gulf Cooperation Council (GCC) states, should first be checked carefully and approved by the General-Secretariat of the organization in Riyadh.",
		"thread_title": "Saudi ambassador to the UAE: Any contact with Iran, Iraq, Syria, and Lebanon should be checked",
		"title": "Saudi ambassador to the UAE: Any contact with Iran, Iraq, Syria, and Lebanon should be checked",
		"type": "conspiracy",
		"uuid": "74e957e76b71f0a40434f87aab8d098024f085c1"
	},
	"-KhIjNkj_QSoyV6WEEW8": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T15:12:29.174+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "RecepTayyipErdoğan",
				"salience": 0.20145664,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.08886516,
				"type": "OTHER"
			},
			{
				"name": "Central Intelligence Agency (CIA",
				"salience": 0.05769219,
				"type": "ORGANIZATION"
			},
			{
				"name": "report",
				"salience": 0.04594713,
				"type": "WORK_OF_ART"
			},
			{
				"name": "newspaper",
				"salience": 0.04594713,
				"type": "ORGANIZATION"
			},
			{
				"name": "speech",
				"salience": 0.04594713,
				"type": "EVENT"
			},
			{
				"name": "city",
				"salience": 0.04594713,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/013w9d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bandar_bin_Sultan"
				},
				"name": "Bandar bin Sultan",
				"salience": 0.03200339,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08n7m9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/%C4%B0neg%C3%B6l"
				},
				"name": "İnegöl",
				"salience": 0.028420808,
				"type": "LOCATION"
			},
			{
				"name": "Dailysabah",
				"salience": 0.028420808,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.02763044,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.024181623,
				"type": "LOCATION"
			},
			{
				"name": "Director",
				"salience": 0.021988198,
				"type": "PERSON"
			},
			{
				"name": "Province",
				"salience": 0.019055055,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.015454332,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.015443581,
				"type": "PERSON"
			},
			{
				"name": "terrorist groups",
				"salience": 0.015443581,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.014136616,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0140356645,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.01261683,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.01261683,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.01261683,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026ms60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_O._Brennan"
				},
				"name": "John O. Brennan",
				"salience": 0.011750938,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0160d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bursa"
				},
				"name": "Bursa",
				"salience": 0.011750938,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.01109267,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.01092978,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.010437098,
				"type": "PERSON"
			},
			{
				"name": "Saudi Intelligence Agency",
				"salience": 0.009519934,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.009432541,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.008170257,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.008170257,
				"type": "EVENT"
			},
			{
				"name": "participants",
				"salience": 0.008170257,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.008170257,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.008170257,
				"type": "ORGANIZATION"
			},
			{
				"name": "turkey",
				"salience": 0.007611956,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.006873971,
				"type": "LOCATION"
			},
			{
				"name": "battle",
				"salience": 0.0059534837,
				"type": "EVENT"
			},
			{
				"name": "secutity",
				"salience": 0.0059534837,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0051369085,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0051369085,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.005032301,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.005032301,
				"type": "PERSON"
			},
			{
				"name": "cooperation",
				"salience": 0.0044487272,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.0044487272,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0027389564,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775618731.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T15:12:29.174+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nIn a report published by Turkish newspaper Dailysabah, RecepTayyipErdoğan said in a speech in “İnegöl” city in the “Bursa” Province of Turkey that he has evidence which shows John O. Brennan, Director of the Central Intelligence Agency (CIA) and Bandar bin Sultan, the former director general of the Saudi Intelligence Agency had met in 2009 and they had agreed that US choose the leaders of terrorist groups in order to create an armed group for promoting terrorism to serve the interests of both countries in the region. \nTurkey president also told that President Obama is planning a scenario in cooperation with ISIS leaders to make US the winner of Mosul war in order to gain participants’ votes in presidential election for Democrats, while we strive to defeat terrorists in a real battle to guarantee the secutity of turkey and the region.",
		"thread_title": "Erdoğan: US, the founder of ISIS",
		"title": "Erdoğan: US, the founder of ISIS",
		"type": "conspiracy",
		"uuid": "480cdc40c3355d779effe35e71da44110419b6d0"
	},
	"-KhIjNxIBaDNanJEZRPZ": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:10.053+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "election",
				"salience": 0.42028967,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0770844,
				"type": "PERSON"
			},
			{
				"name": "voter fraud",
				"salience": 0.051936932,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.049614932,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.041652955,
				"type": "OTHER"
			},
			{
				"name": "Morning Consult Poll",
				"salience": 0.037842434,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.037612185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.03463989,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.019023675,
				"type": "ORGANIZATION"
			},
			{
				"name": "warnings",
				"salience": 0.018575002,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.017839251,
				"type": "ORGANIZATION"
			},
			{
				"name": "fraud",
				"salience": 0.014054039,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.012542994,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.008202391,
				"type": "PERSON"
			},
			{
				"name": "doubt",
				"salience": 0.0076836264,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0075026406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.007071511,
				"type": "PERSON"
			},
			{
				"name": "polling places",
				"salience": 0.006225218,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0060930275,
				"type": "PERSON"
			},
			{
				"name": "electoral system",
				"salience": 0.0059934156,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0059934156,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.0059934156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/024v2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Ryan"
				},
				"name": "Paul Ryan",
				"salience": 0.005904375,
				"type": "PERSON"
			},
			{
				"name": "ploy",
				"salience": 0.0057445066,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.005392355,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.005392355,
				"type": "PERSON"
			},
			{
				"name": "locations",
				"salience": 0.005392355,
				"type": "LOCATION"
			},
			{
				"name": "electorate",
				"salience": 0.005379831,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.005191486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0047350693,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.004403837,
				"type": "PERSON"
			},
			{
				"name": "harassment allegations",
				"salience": 0.004403837,
				"type": "OTHER"
			},
			{
				"name": "sexual assault",
				"salience": 0.004403837,
				"type": "EVENT"
			},
			{
				"name": "election system",
				"salience": 0.0038000266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/029dv9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shiromani_Akali_Dal"
				},
				"name": "SAD",
				"salience": 0.0033216302,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0033216302,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.003318569,
				"type": "PERSON"
			},
			{
				"name": "reliability",
				"salience": 0.0032911028,
				"type": "OTHER"
			},
			{
				"name": "running mate",
				"salience": 0.0032911028,
				"type": "PERSON"
			},
			{
				"name": "Crooked Hillary",
				"salience": 0.003212108,
				"type": "PERSON"
			},
			{
				"name": "Morning Consult",
				"salience": 0.0031317533,
				"type": "ORGANIZATION"
			},
			{
				"name": "election results",
				"salience": 0.0027685973,
				"type": "OTHER"
			},
			{
				"name": "accuracy",
				"salience": 0.0023976471,
				"type": "OTHER"
			},
			{
				"name": "error",
				"salience": 0.0023976471,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0022909585,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0022909585,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v1s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indiana"
				},
				"name": "Indiana",
				"salience": 0.0020264813,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0020264813,
				"type": "PERSON"
			},
			{
				"name": "margin",
				"salience": 0.0019329323,
				"type": "OTHER"
			},
			{
				"name": "polling average",
				"salience": 0.0017913796,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0013726817,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wis",
				"salience": 0.0011027227,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dsc8s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RealClearPolitics"
				},
				"name": "RealClearPolitics",
				"salience": 0.0011027227,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477586844donaldtrump_091516getty.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:11:10.053+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nThe Politico/Morning Consult Poll finds that 41 percent of voters think widespread voter fraud could cause the GOP nominee to lose the election. Amid Trump's increased warnings about a \"rigged election,\" 73 percent of Republicans think the election could be stolen from him, compared to 17 percent of Democrats. \nOver the past week, Trump has cast doubt on the American electoral system, saying he believes the results will be \"rigged\" at many polling places. \n\"The election is absolutely being rigged by the dishonest and distorted media pushing Crooked Hillary — but also at many polling places — SAD,\" Trump wrote on Twitter Sunday. \nTrump has also encouraged supporters to keep an eye on voting locations to prevent fraud, which some say is a ploy to intimidate voters. \nTrump is trailing Democratic nominee Hillary Clinton in the polls following sexual assault and harassment allegations from multiple women. \nThe Politico/Morning Consult poll showed Clinton leading Trump by 5 points, 46 to 41 percent. \nIn a RealClearPolitics polling average, Clinton leads Trump by 5.5 points, 47.7 to 42.2 percent. \nWhile Speaker Paul Ryan (R-Wis.) and even Trump's running mate, Indiana Gov. Mike Pence, have tried to reassure the electorate about the reliability of the election system, the poll released Monday found 60 percent of Americans think it is necessary to question the accuracy of the election results. \nThe poll was conducted among 1,999 registered voters Oct. 13–15 and has a margin of error of 2 percentage points.",
		"thread_title": "Poll: 41 percent of voters say election could be ‘stolen’",
		"title": "Poll: 41 percent of voters say election could be ‘stolen’",
		"type": "conspiracy",
		"uuid": "3bc79eb4577d1bc87684eec3f19a7df2fbf4cc00"
	},
	"-KhIjO3EUUl0X8zzm1DE": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:15.654+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.41895562,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.17421354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.06627423,
				"type": "ORGANIZATION"
			},
			{
				"name": "security detail",
				"salience": 0.0452221,
				"type": "OTHER"
			},
			{
				"name": "furniture",
				"salience": 0.040960018,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Email",
				"salience": 0.035608042,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.035608042,
				"type": "LOCATION"
			},
			{
				"name": "member",
				"salience": 0.035608042,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, DC",
				"salience": 0.028768405,
				"type": "LOCATION"
			},
			{
				"name": "agent",
				"salience": 0.024188187,
				"type": "PERSON"
			},
			{
				"name": "staff",
				"salience": 0.0076353126,
				"type": "PERSON"
			},
			{
				"name": "tenure",
				"salience": 0.0076353126,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.0076353126,
				"type": "PERSON"
			},
			{
				"name": "detail",
				"salience": 0.0068507227,
				"type": "OTHER"
			},
			{
				"name": "furniture",
				"salience": 0.0059581054,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "items",
				"salience": 0.005361346,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "residence",
				"salience": 0.0051618773,
				"type": "LOCATION"
			},
			{
				"name": "lamps",
				"salience": 0.0051618773,
				"type": "OTHER"
			},
			{
				"name": "notes",
				"salience": 0.005055532,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.004379535,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview notes",
				"salience": 0.0037795955,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0032738012,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.0032738012,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0032738012,
				"type": "EVENT"
			},
			{
				"name": "handling",
				"salience": 0.0032738012,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0028482554,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0025095039,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.0023855458,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0023855458,
				"type": "LOCATION"
			},
			{
				"name": "detail",
				"salience": 0.0022794532,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0017825937,
				"type": "EVENT"
			},
			{
				"name": "term",
				"salience": 0.0017825937,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.0009105561,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477586625312777.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:11:15.654+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nHillary Clinton swiped State Department furniture to decorate her Washington home, a former member of her security detail has alleged to the FBI. \n“Early in Clinton’s tenure as secretary of state, she and her staff were observed removing lamps and furniture from the State Department which were transported to her residence in Washington, DC,” an agent on the detail told the FBI. \nThe agent “does not know whether these items were ever returned to the government,” according to FBI notes. \nThe agent was assigned to Clinton in 2009, at the start of her term, but was not on the detail when Clinton left in 2013. \nThe accusations were part of 100 newly released pages of interview notes of the FBI investigation into Clinton’s handling of classified material. \nThe department flatly denied the latest charges, saying Clinton took home only property that she owned.",
		"thread_title": "Hillary Clinton accused of stealing furniture from the State Department",
		"title": "Hillary Clinton accused of stealing furniture from the State Department",
		"type": "conspiracy",
		"uuid": "8fb9de6a44bdce0859fda86d0cc392376c926673"
	},
	"-KhIjOSV8TzKLyN_iVjN": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:19.331+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Rodham Clinton",
				"salience": 0.25195616,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccan",
				"salience": 0.17586489,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01gz4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohammed_VI_of_Morocco"
				},
				"name": "Mohammed VI",
				"salience": 0.11530635,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.1029357,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg4_d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_Ch%C3%A9rifien_des_Phosphates"
				},
				"name": "OCP",
				"salience": 0.056219507,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.04527355,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.029157342,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03bl8v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stuart_E._Eizenstat"
				},
				"name": "Stuart Eizenstat",
				"salience": 0.012187419,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0y4zr4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robby_Mook"
				},
				"name": "Robby Mook",
				"salience": 0.01117175,
				"type": "PERSON"
			},
			{
				"name": "participation",
				"salience": 0.009050451,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.008721274,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccans",
				"salience": 0.008275652,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xcy2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Campaign"
				},
				"name": "HRC",
				"salience": 0.007566823,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0062455544,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.0061732125,
				"type": "WORK_OF_ART"
			},
			{
				"name": "family",
				"salience": 0.005705046,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.005153251,
				"type": "LOCATION"
			},
			{
				"name": "charity",
				"salience": 0.005153251,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.005153251,
				"type": "OTHER"
			},
			{
				"name": "Mohamed Yeslem Beisat",
				"salience": 0.0045343577,
				"type": "PERSON"
			},
			{
				"name": "return",
				"salience": 0.004464604,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0041798325,
				"type": "ORGANIZATION"
			},
			{
				"name": "meeting",
				"salience": 0.0039619682,
				"type": "EVENT"
			},
			{
				"name": "CGI",
				"salience": 0.00355932,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0031594064,
				"type": "WORK_OF_ART"
			},
			{
				"name": "funds",
				"salience": 0.003133285,
				"type": "OTHER"
			},
			{
				"name": "boss",
				"salience": 0.0031142805,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fs44",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rabat"
				},
				"name": "Rabat",
				"salience": 0.0030637602,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.003011713,
				"type": "ORGANIZATION"
			},
			{
				"name": "communications",
				"salience": 0.0029192325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0027513711,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05g2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Africa"
				},
				"name": "North African",
				"salience": 0.0027004054,
				"type": "LOCATION"
			},
			{
				"name": "endowment",
				"salience": 0.0026362767,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0026131228,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.0023371656,
				"type": "PERSON"
			},
			{
				"name": "batch",
				"salience": 0.0022833266,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0018373298,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0016649625,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.001623669,
				"type": "ORGANIZATION"
			},
			{
				"name": "King",
				"salience": 0.0015382455,
				"type": "PERSON"
			},
			{
				"name": "mess",
				"salience": 0.0015318528,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0015292438,
				"type": "LOCATION"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0013889878,
				"type": "PERSON"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0013889878,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.001292246,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.0012283707,
				"type": "EVENT"
			},
			{
				"name": "human rights violations",
				"salience": 0.0012028564,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0011966507,
				"type": "OTHER"
			},
			{
				"name": "mining company",
				"salience": 0.0011727493,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lukas Lundin",
				"salience": 0.0011699046,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0011240847,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0010731812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/042kg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmy_Carter"
				},
				"name": "Carter",
				"salience": 0.0010042369,
				"type": "PERSON"
			},
			{
				"name": "condition",
				"salience": 0.00096901204,
				"type": "OTHER"
			},
			{
				"name": "arrangement",
				"salience": 0.0009525336,
				"type": "OTHER"
			},
			{
				"name": "hotel",
				"salience": 0.00094053487,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00094053487,
				"type": "LOCATION"
			},
			{
				"name": "tenure",
				"salience": 0.00094053487,
				"type": "EVENT"
			},
			{
				"name": "office",
				"salience": 0.0008980413,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.00087892904,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0008654027,
				"type": "LOCATION"
			},
			{
				"name": "human rights violations",
				"salience": 0.00084347225,
				"type": "OTHER"
			},
			{
				"name": "non-starter",
				"salience": 0.00083911937,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.0008078036,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.00078821986,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.00077828957,
				"type": "EVENT"
			},
			{
				"name": "contribution",
				"salience": 0.0007615856,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0007615856,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0007615856,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.0007453755,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0007398029,
				"type": "EVENT"
			},
			{
				"name": "issues",
				"salience": 0.0007344132,
				"type": "OTHER"
			},
			{
				"name": "web site.",
				"salience": 0.0007331615,
				"type": "PERSON"
			},
			{
				"name": "endowment",
				"salience": 0.0007331615,
				"type": "OTHER"
			},
			{
				"name": "loan guarantee",
				"salience": 0.0007116113,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.0006937927,
				"type": "OTHER"
			},
			{
				"name": "beneficiary",
				"salience": 0.0006624407,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0006594821,
				"type": "PERSON"
			},
			{
				"name": "Justice",
				"salience": 0.0006594821,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0006594821,
				"type": "EVENT"
			},
			{
				"name": "context",
				"salience": 0.00065409415,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0006348667,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0006348667,
				"type": "OTHER"
			},
			{
				"name": "mines phosphates",
				"salience": 0.0006217457,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0006217457,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0006217457,
				"type": "OTHER"
			},
			{
				"name": "beneficiary",
				"salience": 0.0006217457,
				"type": "OTHER"
			},
			{
				"name": "news site",
				"salience": 0.0006217457,
				"type": "LOCATION"
			},
			{
				"name": "Polisaro",
				"salience": 0.0006141612,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06t2t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Singapore"
				},
				"name": "Singapore",
				"salience": 0.0005789496,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/054rw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marrakesh"
				},
				"name": "Marrakesh",
				"salience": 0.0005789496,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03h64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hong_Kong"
				},
				"name": "Hong Kong",
				"salience": 0.0005789496,
				"type": "LOCATION"
			},
			{
				"name": "Import Bank",
				"salience": 0.0005789496,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01sr3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Export"
				},
				"name": "Export",
				"salience": 0.0005789496,
				"type": "OTHER"
			},
			{
				"name": "Robert F. Kennedy Center",
				"salience": 0.00057165447,
				"type": "PERSON"
			},
			{
				"name": "operations",
				"salience": 0.0005441512,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0005383816,
				"type": "EVENT"
			},
			{
				"name": "detainees",
				"salience": 0.0005383816,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0005383816,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0005383816,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0005383816,
				"type": "PERSON"
			},
			{
				"name": "misery",
				"salience": 0.0005383816,
				"type": "OTHER"
			},
			{
				"name": "mining firm",
				"salience": 0.00051440875,
				"type": "ORGANIZATION"
			},
			{
				"name": "government-in-exile",
				"salience": 0.00051404943,
				"type": "ORGANIZATION"
			},
			{
				"name": "trade",
				"salience": 0.00046445586,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.00046445586,
				"type": "PERSON"
			},
			{
				"name": "chances",
				"salience": 0.00043397167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0004059093,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00040553472,
				"type": "EVENT"
			},
			{
				"name": "occasions",
				"salience": 0.00040217405,
				"type": "EVENT"
			},
			{
				"name": "insider",
				"salience": 0.00040217405,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j770",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Commerce"
				},
				"name": "Department of Commerce",
				"salience": 0.00037643855,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00037643855,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.00037463973,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.00037463973,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cq0r_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Undersecretary"
				},
				"name": "Under Secretary",
				"salience": 0.00036563608,
				"type": "PERSON"
			},
			{
				"name": "bid",
				"salience": 0.0003542691,
				"type": "OTHER"
			},
			{
				"name": "mining",
				"salience": 0.0003413774,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.00033825554,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00033825554,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.00033825554,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00033825554,
				"type": "LOCATION"
			},
			{
				"name": "Polisaro Front",
				"salience": 0.00033135916,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jt3p8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Monitor"
				},
				"name": "AL-Monitor",
				"salience": 0.00033135916,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00033135916,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b9f13",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tindouf"
				},
				"name": "Tindouf",
				"salience": 0.00033135916,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Algeria"
				},
				"name": "Algeria",
				"salience": 0.00033135916,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/082qk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Sahara"
				},
				"name": "Western Sahara",
				"salience": 0.00033135916,
				"type": "LOCATION"
			},
			{
				"name": "law firm",
				"salience": 0.0003300136,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.00031660206,
				"type": "ORGANIZATION"
			},
			{
				"name": "Human rights",
				"salience": 0.00030292806,
				"type": "OTHER"
			},
			{
				"name": "mining company",
				"salience": 0.00029817063,
				"type": "ORGANIZATION"
			},
			{
				"name": "Moroccan King",
				"salience": 0.00029492486,
				"type": "ORGANIZATION"
			},
			{
				"name": "conference",
				"salience": 0.0002928925,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.0002928925,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0002928925,
				"type": "OTHER"
			},
			{
				"name": "campaign executives",
				"salience": 0.0002928925,
				"type": "PERSON"
			},
			{
				"name": "china",
				"salience": 0.0002928925,
				"type": "OTHER"
			},
			{
				"name": "esteem",
				"salience": 0.0002928925,
				"type": "OTHER"
			},
			{
				"name": "launch",
				"salience": 0.0002928925,
				"type": "EVENT"
			},
			{
				"name": "daughter",
				"salience": 0.0002928925,
				"type": "PERSON"
			},
			{
				"name": "guests",
				"salience": 0.0002928925,
				"type": "PERSON"
			},
			{
				"name": "palaces",
				"salience": 0.0002928925,
				"type": "LOCATION"
			},
			{
				"name": "mining product",
				"salience": 0.000289201,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01fzbj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Trade_Administration"
				},
				"name": "International Trade Administration",
				"salience": 0.000285853,
				"type": "ORGANIZATION"
			},
			{
				"name": "Moroccan World News",
				"salience": 0.0002822502,
				"type": "ORGANIZATION"
			},
			{
				"name": "human rights violations",
				"salience": 0.00027984811,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.00027840323,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0002526679,
				"type": "PERSON"
			},
			{
				"name": "RELATED",
				"salience": 0.0002526679,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.0002526679,
				"type": "ORGANIZATION"
			},
			{
				"name": "oil drilling operations",
				"salience": 0.0002526679,
				"type": "EVENT"
			},
			{
				"name": "blood phosphates",
				"salience": 0.0002526679,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0002526679,
				"type": "PERSON"
			},
			{
				"name": "blood diamonds",
				"salience": 0.00025153905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00024751615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f1r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_the_Treasury"
				},
				"name": "Treasury",
				"salience": 0.00024751615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.00024751615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00024751615,
				"type": "LOCATION"
			},
			{
				"name": "critics",
				"salience": 0.00022440204,
				"type": "PERSON"
			},
			{
				"name": "fees",
				"salience": 0.0002187808,
				"type": "OTHER"
			},
			{
				"name": "lobbying giants",
				"salience": 0.0002187808,
				"type": "ORGANIZATION"
			},
			{
				"name": "term",
				"salience": 0.0002187808,
				"type": "OTHER"
			},
			{
				"name": "gems",
				"salience": 0.0002187808,
				"type": "OTHER"
			},
			{
				"name": "pledge",
				"salience": 0.0002187808,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00020705206,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea",
				"salience": 0.00018025289,
				"type": "PERSON"
			},
			{
				"name": "Blood Minerals' Firm",
				"salience": 0.00017222433,
				"type": "ORGANIZATION"
			},
			{
				"name": "friendship",
				"salience": 0.00015337611,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Republic_of_the_Congo"
				},
				"name": "Congo",
				"salience": 0.00013463956,
				"type": "LOCATION"
			},
			{
				"name": "Clinton Foundation Got $100M From",
				"salience": 0.00013463956,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cltzt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Covington_%26_Burling"
				},
				"name": "Covington & Burling",
				"salience": 0.00013463956,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477586403hillary-clinton-wikileaks-morocco.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:11:19.331+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nFormer Secretary of State Hillary Clinton arranged a $12 million donation from Moroccan King Mohammed VI to her family’s charity in 2014 in return for the Clinton Global Initiative hosting its international meeting in the North African Muslim nation, according to an email made public Thursday by Wikileaks. \nThe Moroccan monarch’s funds went to the Clinton Foundation’s endowment and to CGI. The Jan. 18, 2015, email was included in Wikileaks’ latest batch of communications to and from Clinton’s presidential campaign chairman, John Podesta. \nThe email from Huma Abedin, Clinton’s Deputy Chief of Staff at the State Department, was addressed to Podesta and campaign manager Robby Mook. Hillary Clinton was a director of the foundation at the time. \nSingapore and Hong Kong officials reportedly were also vying to convene the CGI meeting in their countries, but the North African nation ultimately hosted it in a five-star hotel in Marrakesh, Morocco, in 2015. Abedin told Podesta and Mook that Morocco was not CGI’s “first choice.” \nThe actual meeting was paid for by OCP, the Moroccan-government-owned mining company that has been accused of serious human rights violations. Clinton vigorously supported the Moroccan King when she was Secretary of State and the U.S.-financed Export-Import Bank gave OCP a $92 million loan guarantee during her tenure as Secretary of State. \nThe mining company also contributed between $5 million to $10 million to the Clinton Foundation, according to the charity’s web site.Abedin described the arrangement in the email as having been organized by her boss. Hillary Clinton “created this mess and she knows it,” she told Podesta and Mook.She said the Moroccan deal was entirely dreamed up by her boss. “This was HRC’s idea, our office approached the Moroccans and they 100 percent believe they are doing this at her request. The King has personally committed approx. $12 million both for the endowment and to support the meeting.” HRC stands for Hillary Rodham Clinton. \nAbedin said Clinton’s attendance at the CGI event was a condition of the $12 million contribution. “Just to give you some context, the condition upon which the Moroccans agreed to host the meeting was her participation. If hrc was not part if it, meeting was a non-starter,” Abedin said. \nPolitico in 2015 reported that Clinton “was seen by Rabat as among its most ardent supporters in the Obama administration.” Rabat is the capital of Morocco. \nThe Robert F. Kennedy Center for Justice charged OCP with “serious human rights violations,” including exploitation of workers by not “adequately compensating the impoverished people who live there.” \nMohamed Yeslem Beisat, the Washington envoy for the Polisaro Front, as reported by AL-Monitor, a Middle East news site in 2015 that “OCP is the first beneficiary of the war and the first beneficiary of the occupation — it is the one that is cashing in on the misery of thousands of refugees and hundreds of political detainees for the past 40 years.” \nPolisaro claims to lead a Moroccan government-in-exile based in Tindouf, Algeria. \n“They’re doing this because they know Hillary has some chances of being president of the United States. And they want her to support their brutal occupation of Western Sahara,” Beisat charged. \nThe Moroccan firm mines phosphates. Human rights critics have called OCP’s mining product “blood phosphates,” appropriating the term “blood diamonds” for gems mined in operations that kill and injure local workers \nOCP is not the only mining company linked to human rights violations that has donated to the Clinton Foundation. The foundation accepted a $100 million pledge from Lukas Lundin, who owns mining and oil drilling operations in North Africa and in the Congo. (RELATED: Clinton Foundation Got $100M From ‘Blood Minerals’ Firm) \nOCP retained the law firm of Covington & Burling, one of Washington’s lobbying giants, paying the firm $1.4 million in fees from 2012 to 2015. \nStuart Eizenstat, a former White House domestic policy chief under President Carter and an influential Democratic Party insider, was the main lobbyist for the mining firm. He was also President Bill Clinton’s ambassador to the European Union, a Deputy Secretary of the Treasury and Under Secretary at the Department of Commerce. \nEizenstat specialized in foreign trade issues at Commerce where he worked in the International Trade Administration. \nHillary Clinton officially visited Morocco twice, in November 2009 and in February 2012, meeting with the King on both occasions. The two also met in New York in December 2013 where it was believed the two discussed Morocco’s bid to host the CGI meeting and the King’s $12 million donation. \nThe Moroccan World News described the meeting as showing “renewed friendship between the royal family and the Clinton family, as well as Hillary Clinton’s esteem for Morocco and its people.” \nAbedin warned both campaign executives that if CGI decided to renege on the agreement, it would hurt Clinton’s relationship with the King. “It will break a lot of china to back out now,” she wrote. \nUltimately, Clinton did not attend the meeting because it was close to the launch of her presidential campaign, but the former president and daughter Chelsea were present and during the conference were guests at one of the Moroccan King’s palaces.",
		"thread_title": "WIKILEAKS: Hillary Got $12 Million for Clinton Charity As Quid Pro Quo For Morocco Meeting",
		"title": "WIKILEAKS: Hillary Got $12 Million for Clinton Charity As Quid Pro Quo For Morocco Meeting",
		"type": "conspiracy",
		"uuid": "48f9907bdacf5372471f8eaff4d2b421700c5ae3"
	},
	"-KhIjOksqW5mz3YEMJPz": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:23.336+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.28748176,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.26863176,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.09665643,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.06124896,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.027844895,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.014734663,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.013944273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.01152384,
				"type": "ORGANIZATION"
			},
			{
				"name": "confrontation",
				"salience": 0.011034825,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.011034825,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.010015117,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.009969618,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.008998154,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.008639601,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.007804456,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War III",
				"salience": 0.0075845295,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0072746943,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.006762041,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0052612354,
				"type": "LOCATION"
			},
			{
				"name": "order",
				"salience": 0.0034591462,
				"type": "OTHER"
			},
			{
				"name": "rapprochement",
				"salience": 0.0034591462,
				"type": "EVENT"
			},
			{
				"name": "resort",
				"salience": 0.0034591462,
				"type": "LOCATION"
			},
			{
				"name": "presidents",
				"salience": 0.0031585002,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0028533612,
				"type": "ORGANIZATION"
			},
			{
				"name": "zones",
				"salience": 0.0025793263,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0024941058,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.0022343376,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0021784347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0021719362,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rnbt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doral,_Florida"
				},
				"name": "Doral",
				"salience": 0.0021304337,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0021304337,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0020707843,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.00206395,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0019935477,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0019726562,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0019726562,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.0018224985,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0016781257,
				"type": "OTHER"
			},
			{
				"name": "battleground state polls",
				"salience": 0.0016456355,
				"type": "OTHER"
			},
			{
				"name": "posture",
				"salience": 0.0016456355,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0016344782,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0015734988,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.0015410038,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.0015147923,
				"type": "EVENT"
			},
			{
				"name": "nukes",
				"salience": 0.0014432644,
				"type": "LOCATION"
			},
			{
				"name": "remarks",
				"salience": 0.0014432644,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.001425086,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.001425086,
				"type": "ORGANIZATION"
			},
			{
				"name": "no-fly zone",
				"salience": 0.0013487397,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0013344564,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0013193523,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.001278032,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.001278032,
				"type": "OTHER"
			},
			{
				"name": "Biden Trump",
				"salience": 0.0012429808,
				"type": "PERSON"
			},
			{
				"name": "no-fly zone",
				"salience": 0.0012186676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0011708258,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0011539676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.001145699,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.0011109024,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0011109024,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.0011109024,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.0011109024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0010841391,
				"type": "ORGANIZATION"
			},
			{
				"name": "purpose",
				"salience": 0.0010512546,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0010130723,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.00099927,
				"type": "PERSON"
			},
			{
				"name": "concerns",
				"salience": 0.00099927,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00099927,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00099927,
				"type": "OTHER"
			},
			{
				"name": "airspace",
				"salience": 0.00099927,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.00096696534,
				"type": "EVENT"
			},
			{
				"name": "strategy",
				"salience": 0.0009619746,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.0009619746,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0009619746,
				"type": "PERSON"
			},
			{
				"name": "regime",
				"salience": 0.0009619746,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.0009619746,
				"type": "EVENT"
			},
			{
				"name": "ground",
				"salience": 0.00094209454,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00094209454,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00094209454,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.00094209454,
				"type": "EVENT"
			},
			{
				"name": "jet",
				"salience": 0.00093788706,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00093788706,
				"type": "PERSON"
			},
			{
				"name": "civil war",
				"salience": 0.00089895335,
				"type": "EVENT"
			},
			{
				"name": "Most",
				"salience": 0.0008674263,
				"type": "PERSON"
			},
			{
				"name": "count",
				"salience": 0.00084372936,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0008367387,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00082452723,
				"type": "ORGANIZATION"
			},
			{
				"name": "fight",
				"salience": 0.0008157854,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0008157854,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.0008157854,
				"type": "OTHER"
			},
			{
				"name": "negotiation",
				"salience": 0.0008157854,
				"type": "EVENT"
			},
			{
				"name": "Jesse Lehrich",
				"salience": 0.00072017725,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.00071862823,
				"type": "ORGANIZATION"
			},
			{
				"name": "Poll",
				"salience": 0.0007037749,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00065559655,
				"type": "PERSON"
			},
			{
				"name": "complaint",
				"salience": 0.00061995257,
				"type": "OTHER"
			},
			{
				"name": "puppet",
				"salience": 0.0006094056,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0006094056,
				"type": "EVENT"
			},
			{
				"name": "suffering",
				"salience": 0.0006094056,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0006094056,
				"type": "OTHER"
			},
			{
				"name": "enactment",
				"salience": 0.0006094056,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0005792624,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0005676851,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0005424051,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0005194598,
				"type": "OTHER"
			},
			{
				"name": "administration post",
				"salience": 0.0005125549,
				"type": "WORK_OF_ART"
			},
			{
				"name": "complaints",
				"salience": 0.0005125549,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.0005125549,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0005125549,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.00044381907,
				"type": "PERSON"
			},
			{
				"name": "agenda",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "departure",
				"salience": 0.00044381907,
				"type": "EVENT"
			},
			{
				"name": "majorities",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "cabinet",
				"salience": 0.00044381907,
				"type": "EVENT"
			},
			{
				"name": "lack",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "party unity",
				"salience": 0.00038286857,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00033152057,
				"type": "EVENT"
			},
			{
				"name": "rhetoric",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "aisle",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "commander-in-chief",
				"salience": 0.00033152057,
				"type": "PERSON"
			},
			{
				"name": "talking points",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0002970821,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.00027062616,
				"type": "OTHER"
			},
			{
				"name": "security experts",
				"salience": 0.00026384686,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00020402248,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477586227636130853168961052.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:11:23.336+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email Donald Trump warned in an interview Tuesday that Hillary Clinton's policies as president to address the Syrian conflict would lead to World War III, arguing the Democratic nominee would draw the US into armed confrontation with Russia, Syria and Iran. \"What we should do is focus on ISIS. We should not be focusing on Syria,\" Trump told Reuters on Tuesday morning at his resort in Doral, Florida. \"You're going to end up in World War III over Syria if we listen to Hillary Clinton.\" The Republican nominee, who has called for a rapprochement with Russia in order to jointly combat ISIS, argued that his Democratic rival's calls for taking a more aggressive posture in Syria to bring the conflict there to an end and combat ISIS will only draw the US into a larger war. Trump's remarks come as he trails Clinton in most national and key battleground state polls just two weeks from Election Day. \"You're not fighting Syria anymore, you're fighting Syria, Russia and Iran, all right? Russia is a nuclear country, but a country where the nukes work as opposed to other countries that talk,\" he said. Trump: I'd 'love' to fight Biden Trump has not laid out a clear strategy for combating ISIS or addressing the globally destabilizing conflict in Syria, which has killed hundreds of thousands and pushed millions more to flee their homes. He has suggested the US should allow ISIS, anti-government rebels and the Syrian government to fight it out and more recently has focused on joining forces with Russia -- which has aided the Syrian regime in the bombing of civilians and US-allied rebels -- to combat ISIS. \"Assad is secondary, to me, to ISIS,\" Trump told Reuters of the Syrian President Bashar al-Assad, whom US officials have argued must step down. Clinton has called for establishing a no-fly zone over Syria to help bring the five-year civil war to an end, a proposal top Republicans in Congress have championed, which President Barack Obama and others have opposed due to the risk of entering into conflict with Russia. A US-enforced no-fly zone would mean the US could shoot down a Russian jet should it enter Syrian airspace. Clinton addressed those concerns in the final presidential debate, arguing that it would \"save lives and hasten the end of the conflict,\" while cautioning that \"this would not be done just on the first day.\" \"This would take a lot of negotiation and it would also take making it clear to the Russians and the Syrians that our purpose is to provide safe zones on the ground,\" Clinton said during the debate earlier this month. \"I think we could strike a deal and make it very clear to the Russians and Syrians that this was something that we believe the best interests of the people on the ground in Syria. It would help us in the fight against ISIS.\" Trump has additionally called for establishing safe zones in Syria to protect civilians -- as has Clinton -- which could also put the US in conflict with the Syrian government or Russia should they oppose the policy. The Clinton campaign later Tuesday pushed back against Trump's rhetoric. \"National security experts on both sides of the aisle have denounced Donald Trump as dangerously ill-prepared and temperamentally unfit to serve as commander-in-chief,\" Clinton spokesman Jesse Lehrich said. \"Once again, he is parroting Putin's talking points and playing to Americans' fears, all while refusing to lay out any plans of his own for defeating ISIS or alleviating humanitarian suffering in Syria. Moreover, this incendiary attack is aimed at a policy that his own running mate, Mike Pence, strongly supports.\" Poll: Most see a Hillary Clinton victory and a fair count ahead While Clinton has accused Trump of being Putin's \"puppet,\" Trump knocked Clinton for her criticism of the Russian strongman, asking, \"How she is going to go back and negotiate with this man who she has made to be so evil.\" And just two days after he tied the successful enactment of his agenda as president to the election of Republican majorities in Congress, Trump also returned to his more typical complaints of a lack of Republican unity weighing down his candidacy. \"If we had party unity, we couldn't lose this election to Hillary Clinton,\" he told Reuters. That complaint didn't put Trump in more of a bipartisan mood, though, as the Republican nominee also told Reuters he would not consider putting any Democrats in his cabinet -- a departure from recent presidents, who have sought to post at least one member of their rival party in a top administration post.",
		"thread_title": "Trump warns of World War III if Clinton is elected",
		"title": "Trump warns of World War III if Clinton is elected",
		"type": "conspiracy",
		"uuid": "2cfaf1e2e4e967ebe6dbbb32575c0fcb21279bff"
	},
	"-KhIjOxVN8wEESCGQ1UB": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:31.542+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.19294176,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.16610187,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.09660972,
				"type": "EVENT"
			},
			{
				"name": "results",
				"salience": 0.08756466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Sunshine State",
				"salience": 0.06670063,
				"type": "LOCATION"
			},
			{
				"name": "democracy",
				"salience": 0.045114283,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.04267134,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.03282671,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.028475167,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/085srz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patrick_Murphy_(Pennsylvania_politician)"
				},
				"name": "Patrick Murphy",
				"salience": 0.022163345,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.017176816,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.014620342,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.013216989,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.011634435,
				"type": "PERSON"
			},
			{
				"name": "adversaries",
				"salience": 0.0087659275,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0077170427,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0077170427,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dpr5f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marco_Rubio"
				},
				"name": "Marco Rubio",
				"salience": 0.0076025953,
				"type": "PERSON"
			},
			{
				"name": "seeds",
				"salience": 0.007026803,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.006036957,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.006036957,
				"type": "EVENT"
			},
			{
				"name": "mind",
				"salience": 0.006036957,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.006036957,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0054148976,
				"type": "PERSON"
			},
			{
				"name": "vote matters",
				"salience": 0.0048899283,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0048284056,
				"type": "PERSON"
			},
			{
				"name": "advantage",
				"salience": 0.0043437732,
				"type": "OTHER"
			},
			{
				"name": "fear-mongering",
				"salience": 0.004235133,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.004235133,
				"type": "OTHER"
			},
			{
				"name": "seats",
				"salience": 0.004235133,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.004077237,
				"type": "EVENT"
			},
			{
				"name": "crowd",
				"salience": 0.004077237,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.004077237,
				"type": "OTHER"
			},
			{
				"name": "rigging",
				"salience": 0.0038270291,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0037185028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04dvzs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami_Gardens,_Florida"
				},
				"name": "Miami Gardens",
				"salience": 0.0037185028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0037185028,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0034581947,
				"type": "OTHER"
			},
			{
				"name": "suspense",
				"salience": 0.0034581947,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0033292247,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0029837457,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0029837457,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.0028053431,
				"type": "WORK_OF_ART"
			},
			{
				"name": "candidate",
				"salience": 0.002583928,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida_Memorial_University"
				},
				"name": "Florida Memorial University",
				"salience": 0.0025106163,
				"type": "ORGANIZATION"
			},
			{
				"name": "credit",
				"salience": 0.0022193606,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0018821774,
				"type": "OTHER"
			},
			{
				"name": "ads",
				"salience": 0.0018821774,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0016039999,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.0014061116,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0014061116,
				"type": "EVENT"
			},
			{
				"name": "wins",
				"salience": 0.0014061116,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03j740",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Senatorial_Campaign_Committee"
				},
				"name": "Democratic Senatorial Campaign Committee",
				"salience": 0.0011585723,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0009994906,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.00086546486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00086546486,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/147758603457348262.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:11:31.542+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email President Barack Obama admonished Donald Trump Thursday, saying the Republican nominee's claims that he might not accept the results of next month's election are \"not a joking matter.\" \"I want everybody to pay attention here. This is dangerous,\" Obama said at a Hillary for America event in Miami Gardens, Florida. \"Because when you try to sow the seeds of doubt in people's mind about the legitimacy of our elections, that undermines our democracy. Then you are doing the work of our adversaries for them.\" Obama also encouraged the crowd of about 1,800 at Florida Memorial University to take advantage of Florida's early voting, telling the audience in doing so they can reject what the President called Trump's \"dark, pessimistic fear-mongering.\" \"Our democracy depends on people knowing that their vote matters. That those who occupy the seats of power were chosen by the people,\" Obama said. On Wednesday night's debate Trump, answered, \"I will look at it at the time,\" when asked whether he would concede if he loses on November 8. \"I will keep you in suspense.\" Trump also doubled down on Thursday in Ohio saying he will accept the results of next month's election as long as wins. Obama also used the opportunity while in Florida to weigh in on the close Senate race in Florida between Republican Sen. Marco Rubio and his Democratic challenger, Rep. Patrick Murphy. \"Even Marco Rubio says there's no rigging of the vote,\" Obama said, \"Which I'd like to give credit for, except he's refuting the dangerous, unprecedented claims of a candidate he says he's still going to vote for!\" Earlier this week, Obama released a new ad for the Democrat in the Sunshine State, the same week it was announced the Democratic Senatorial Campaign Committee was puling money for ads for Murphy.",
		"thread_title": "Obama slams Trump's 'rigged' election claims as 'dangerous'",
		"title": "Obama slams Trump's 'rigged' election claims as 'dangerous'",
		"type": "conspiracy",
		"uuid": "86af03b3b12992fbf54ab9ecab015bbd6f9ad67d"
	},
	"-KhIjPGLVDTCHu6_Kqon": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:33.687+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.27943295,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.09046295,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.07646596,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024p7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeff_Flake"
				},
				"name": "Jeff Flake",
				"salience": 0.03470368,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0170zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_E._Sununu"
				},
				"name": "John E. Sununu",
				"salience": 0.0322487,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.027751269,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0269qk3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allen_Raymond"
				},
				"name": "Allen Raymond",
				"salience": 0.027504688,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.016734019,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.016734019,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0128251305,
				"type": "PERSON"
			},
			{
				"name": "voting base",
				"salience": 0.012104808,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.011032167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nr8j6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jon_A._Husted"
				},
				"name": "Jon Husted",
				"salience": 0.0097223725,
				"type": "PERSON"
			},
			{
				"name": "integrity",
				"salience": 0.0085673435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01v054",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sean_Hannity"
				},
				"name": "Sean Hannity",
				"salience": 0.008520929,
				"type": "PERSON"
			},
			{
				"name": "talk",
				"salience": 0.008180153,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.008022851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.008006806,
				"type": "LOCATION"
			},
			{
				"name": "process",
				"salience": 0.0071492083,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0071492083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rrm2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeanne_Shaheen"
				},
				"name": "Jeanne Shaheen",
				"salience": 0.0067854505,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0067521986,
				"type": "EVENT"
			},
			{
				"name": "Critics",
				"salience": 0.0063510844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.0063446835,
				"type": "ORGANIZATION"
			},
			{
				"name": "volunteers",
				"salience": 0.0061923116,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0061923116,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0061923116,
				"type": "OTHER"
			},
			{
				"name": "tens of thousands",
				"salience": 0.0061923116,
				"type": "PERSON"
			},
			{
				"name": "myth",
				"salience": 0.006157279,
				"type": "OTHER"
			},
			{
				"name": "Elections",
				"salience": 0.005874526,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.005874526,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00548313,
				"type": "PERSON"
			},
			{
				"name": "claims",
				"salience": 0.005363869,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0xs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._state"
				},
				"name": "States",
				"salience": 0.00534549,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.004120678,
				"type": "EVENT"
			},
			{
				"name": "Election",
				"salience": 0.004120678,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.004120678,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.004120678,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.003967007,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.003967007,
				"type": "EVENT"
			},
			{
				"name": "primary",
				"salience": 0.003901251,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0038137604,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.003645601,
				"type": "PERSON"
			},
			{
				"name": "actor",
				"salience": 0.0036142233,
				"type": "PERSON"
			},
			{
				"name": "claims",
				"salience": 0.003531319,
				"type": "OTHER"
			},
			{
				"name": "battleground state",
				"salience": 0.003531319,
				"type": "LOCATION"
			},
			{
				"name": "operative",
				"salience": 0.0033889324,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0033645595,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0033645595,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.0032625182,
				"type": "OTHER"
			},
			{
				"name": "election official",
				"salience": 0.0032625182,
				"type": "PERSON"
			},
			{
				"name": "precincts",
				"salience": 0.0031439776,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0029865003,
				"type": "ORGANIZATION"
			},
			{
				"name": "idea",
				"salience": 0.0027490393,
				"type": "OTHER"
			},
			{
				"name": "insistence",
				"salience": 0.0026283313,
				"type": "OTHER"
			},
			{
				"name": "dive",
				"salience": 0.0025510986,
				"type": "OTHER"
			},
			{
				"name": "polls numbers",
				"salience": 0.0025510986,
				"type": "OTHER"
			},
			{
				"name": "plunge",
				"salience": 0.0025510986,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.002442092,
				"type": "LOCATION"
			},
			{
				"name": "votes",
				"salience": 0.0023888599,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.0023840165,
				"type": "OTHER"
			},
			{
				"name": "complaint",
				"salience": 0.002348962,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.002305083,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0022878528,
				"type": "LOCATION"
			},
			{
				"name": "Operative",
				"salience": 0.0022878528,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempt",
				"salience": 0.0022878528,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02p7ntz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire_Senate"
				},
				"name": "New Hampshire Senate",
				"salience": 0.002213049,
				"type": "ORGANIZATION"
			},
			{
				"name": "election phone",
				"salience": 0.0022024787,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0021569703,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0021569703,
				"type": "EVENT"
			},
			{
				"name": "voting",
				"salience": 0.0021569703,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.002065761,
				"type": "PERSON"
			},
			{
				"name": "fraud",
				"salience": 0.0020217958,
				"type": "OTHER"
			},
			{
				"name": "voter-identification laws",
				"salience": 0.0020217958,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0019920638,
				"type": "ORGANIZATION"
			},
			{
				"name": "laws",
				"salience": 0.0019218231,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0018678221,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0018310192,
				"type": "EVENT"
			},
			{
				"name": "fall election",
				"salience": 0.0018310192,
				"type": "EVENT"
			},
			{
				"name": "primary election",
				"salience": 0.0018310192,
				"type": "EVENT"
			},
			{
				"name": "assertion",
				"salience": 0.0018116564,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "phone lines",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "rigging",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "Confessions",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "election loss",
				"salience": 0.0017220681,
				"type": "EVENT"
			},
			{
				"name": "scandal",
				"salience": 0.0017220681,
				"type": "EVENT"
			},
			{
				"name": "billionaire",
				"salience": 0.0016864801,
				"type": "PERSON"
			},
			{
				"name": "prison sentence",
				"salience": 0.0016162832,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0016162832,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.0015704038,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.0015704038,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0015704038,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy"
				},
				"name": "Republic",
				"salience": 0.0015656548,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.0015640286,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0015103931,
				"type": "EVENT"
			},
			{
				"name": "task",
				"salience": 0.0014603697,
				"type": "OTHER"
			},
			{
				"name": "involvement.",
				"salience": 0.0014603697,
				"type": "OTHER"
			},
			{
				"name": "rematch",
				"salience": 0.0014603697,
				"type": "EVENT"
			},
			{
				"name": "phone bank",
				"salience": 0.0014603697,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0014121663,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0014083042,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0013953468,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0013953468,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0013335942,
				"type": "EVENT"
			},
			{
				"name": "People",
				"salience": 0.0012598556,
				"type": "PERSON"
			},
			{
				"name": "ballots",
				"salience": 0.0012598556,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.001217497,
				"type": "OTHER"
			},
			{
				"name": "poll tax",
				"salience": 0.0011921935,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0011675514,
				"type": "OTHER"
			},
			{
				"name": "voting blocks",
				"salience": 0.0011476887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alabama"
				},
				"name": "Alabama",
				"salience": 0.0011010531,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xhj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manchester,_New_Hampshire"
				},
				"name": "Manchester",
				"salience": 0.0011010531,
				"type": "LOCATION"
			},
			{
				"name": "claims",
				"salience": 0.0011000371,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0011000371,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interview",
				"salience": 0.0011000371,
				"type": "EVENT"
			},
			{
				"name": "couple",
				"salience": 0.0010909216,
				"type": "PERSON"
			},
			{
				"name": "sideline",
				"salience": 0.0010909216,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0010909216,
				"type": "OTHER"
			},
			{
				"name": "circles",
				"salience": 0.0010909216,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0010909216,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0010589712,
				"type": "OTHER"
			},
			{
				"name": "email leak",
				"salience": 0.0009900918,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00092107966,
				"type": "WORK_OF_ART"
			},
			{
				"name": "leak",
				"salience": 0.00091754546,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.0008988392,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0008915726,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09gd5v1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Business_Insider"
				},
				"name": "Business Insider",
				"salience": 0.0008261701,
				"type": "ORGANIZATION"
			},
			{
				"name": "fraud",
				"salience": 0.00082172017,
				"type": "OTHER"
			},
			{
				"name": "voter-ID laws",
				"salience": 0.00082172017,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.00082172017,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007944988,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.0007944988,
				"type": "EVENT"
			},
			{
				"name": "forefront",
				"salience": 0.0007944988,
				"type": "OTHER"
			},
			{
				"name": "electoral system",
				"salience": 0.0007944988,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0007944988,
				"type": "OTHER"
			},
			{
				"name": "campaign trail",
				"salience": 0.0007944988,
				"type": "LOCATION"
			},
			{
				"name": "statements",
				"salience": 0.0007712276,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.0007456784,
				"type": "PERSON"
			},
			{
				"name": "lack",
				"salience": 0.0007210592,
				"type": "OTHER"
			},
			{
				"name": "fall",
				"salience": 0.0006853889,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.0006853889,
				"type": "OTHER"
			},
			{
				"name": "party bosses",
				"salience": 0.00068232685,
				"type": "PERSON"
			},
			{
				"name": "disenfranchisement",
				"salience": 0.0006323261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00060662744,
				"type": "ORGANIZATION"
			},
			{
				"name": "ballot box",
				"salience": 0.00059346884,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.00059346884,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.00059346884,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.00059346884,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_f2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vermont"
				},
				"name": "Vermont",
				"salience": 0.0004889595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/068p2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pittsburgh"
				},
				"name": "Pittsburgh",
				"salience": 0.0003652293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.0003652293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477585908donald-trump-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:11:33.687+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nDonald Trump is again riling up his voting base with claims that the November election will be rigged against him. \n\"Of course there is large scale voter fraud happening on and before election day,\" Trump tweeted Monday morning. \"Why do Republican leaders deny what is going on? So naive!\" \nIt's a charge that even other Republicans have been quick to refute. Critics have called such talk potentially dangerous and detrimental to trust in the US democratic process. \n\"States, backed by tens of thousands of GOP and DEM volunteers, ensure integrity of electoral process,\" Sen. Jeff Flake of Arizona, who is often sharply critical of Trump, tweeted Sunday. \"Elections are not rigged.\" \nJon Husted, the secretary of state of Ohio and the top election official in the key battleground state, also said Monday that he could assure Trump the election would not be rigged. \nTrump's most recent claims coincided with a plunge by him in the polls. Before now, Trump most recently made similar claims when his polls numbers were taking a dive in early August. \n\"And I'm telling you, November 8, we'd better be careful, because that election is going to be rigged,\" the New York billionaire told Fox News host Sean Hannity in August. \"And I hope the Republicans are watching closely or it's going to be taken away from us.\" \nMultiple Republicans told Business Insider at the time that Trump's assertion was both ludicrous and dangerous, as Trump would be the first US presidential candidate in modern times, possibly ever, to blame an election loss on voter fraud or a rigged election. \nAllen Raymond, a former GOP operative who was involved in the 2002 New Hampshire Senate election phone-jamming scandal, called Trump's continued insistence that the election would be rigged \"detrimental to the Republic.\" \n\"The idea that it's rigged, I don't know what he's talking about,\" he said in August. \"I know someone that rigged elections. I mean, you know, the fact of the matter is Hillary Clinton doesn't need to rig this election. Trump's going to win Alabama and that's it. She doesn't have to do anything. It's painful to watch.\" \nRaymond wrote \"How to Rig an Election: Confessions of a Republican Operative\" as a tell-all about the attempt to rig the 2002 New Hampshire Senate election between then-Gov. Jeanne Shaheen, a Democrat, and Republican US Rep. John E. Sununu. Raymond said that attempted rigging was centered on jamming the phone lines at the New Hampshire Democrats office in Manchester — a task his phone bank was hired to carry out. Sununu went on to win the election by roughly 20,000 votes. Shaheen defeated Sununu in a rematch in 2008. \nThe operative served a brief prison sentence for his involvement.He said any attempts to rig an election would look similar to that — not what Trump's talking about. \nThe Manhattan billionaire told The Washington Post in August that a lack of voter-identification laws would let people \"just keep voting and voting and voting\" and suggested fraud occurred in 2012 against Republican nominee Mitt Romney because there were \"precincts where there were practically nobody voting for the Republican.\" \n\"I don't even know what he's talking about,\" Raymond said. \"But this idea that it's 1950 or 1960 and the party bosses are going to roll into Pittsburgh and Philadelphia and are going to rig the ballot box and rig the machines — that's nonsense. An election rigging these days means something totally different than what he's talking about. Now it's stupid stuff like what I did in New Hampshire.\" \nHe said the lack of voter-ID laws Trump was trying to use as proof of fraud this fall was also bogus. \n\"These voter-ID laws, what's the intention of that? The clear intention is disenfranchisement,\" he said, echoing a common complaint in liberal circles that voter-ID laws are put in place to prevent minority voting blocks from being able to cast ballots. \"You know, there's a reason we don't have a poll tax anymore. Because it's unconstitutional. \n\"People don't vote 10 times,\" he continued. \"There might be one bad actor every once in a while who tries to vote a couple of times, but he's talking about an institutional effort. It's a total myth.\" \nHe said Trump's statements were an attempt to \"basically sideline\" Hillary Clinton's first four years in office. \nThe idea of a rigged election came to the forefront after the Democratic National Committee had its emails hacked and leaked, though both Trump and Sen. Bernie Sanders of Vermont, Clinton's main opponent in the Democratic primary, had claimed the electoral system was rigged earlier in the primary season. The emails showed that the organization, which was supposed to remain neutral throughout the primary, favored Clinton. \nTrump said the email leak proved that the primary election was \"rigged\" against Sanders in his early-August interview with Hannity, in addition to such claims he perpetuated along the campaign trail. He used the leak as further evidence that the fall election would be rigged against him as well.",
		"thread_title": "Donald Trump claims the election will be 'rigged' — and critics have called that preposterous and dangerous",
		"title": "Donald Trump claims the election will be 'rigged' — and critics have called that preposterous and dangerous",
		"type": "conspiracy",
		"uuid": "2758e4d7fe361f5f85c7576596ff33314de5d095"
	},
	"-KhIjPZa_5GDHi5Rg44G": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:36.662+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.23043314,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.1014945,
				"type": "ORGANIZATION"
			},
			{
				"name": "made'After",
				"salience": 0.07081417,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06yxd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Carolina"
				},
				"name": "South Carolina",
				"salience": 0.063404754,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.06161079,
				"type": "LOCATION"
			},
			{
				"name": "agreements",
				"salience": 0.026849579,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.024208916,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.023099774,
				"type": "OTHER"
			},
			{
				"name": "peace accord",
				"salience": 0.022060184,
				"type": "OTHER"
			},
			{
				"name": "accommodation",
				"salience": 0.018973114,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.018973114,
				"type": "EVENT"
			},
			{
				"name": "shot",
				"salience": 0.017145073,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.017145073,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0226wy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Scarborough"
				},
				"name": "Joe Scarborough",
				"salience": 0.015273307,
				"type": "PERSON"
			},
			{
				"name": "town hall event",
				"salience": 0.014861546,
				"type": "EVENT"
			},
			{
				"name": "contender",
				"salience": 0.014861546,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.014861546,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.012775622,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.012772788,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.010682406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.009170341,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gkgp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charleston,_South_Carolina"
				},
				"name": "Charleston",
				"salience": 0.009170341,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.009170341,
				"type": "ORGANIZATION"
			},
			{
				"name": "agreement",
				"salience": 0.008167749,
				"type": "OTHER"
			},
			{
				"name": "accord",
				"salience": 0.007848298,
				"type": "OTHER"
			},
			{
				"name": "fault",
				"salience": 0.0072230357,
				"type": "OTHER"
			},
			{
				"name": "fault",
				"salience": 0.007088455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.0069493693,
				"type": "PERSON"
			},
			{
				"name": "position",
				"salience": 0.006750314,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0061403876,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israelis",
				"salience": 0.005897251,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.005152944,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.005046062,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0044646375,
				"type": "ORGANIZATION"
			},
			{
				"name": "hostility",
				"salience": 0.0036707222,
				"type": "OTHER"
			},
			{
				"name": "peace agreement",
				"salience": 0.0034334667,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0033616347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07j6ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ted_Cruz"
				},
				"name": "Ted Cruz",
				"salience": 0.0033117018,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.003305445,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0032121139,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0031295712,
				"type": "PERSON"
			},
			{
				"name": "agreements",
				"salience": 0.0029492762,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0029395358,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0027103082,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.002654335,
				"type": "PERSON"
			},
			{
				"name": "peoples",
				"salience": 0.002654335,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Benjamin Netanyahu",
				"salience": 0.0024109,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.002379754,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.002379754,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0023560282,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0022986683,
				"type": "EVENT"
			},
			{
				"name": "peace",
				"salience": 0.0022481934,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.002201498,
				"type": "OTHER"
			},
			{
				"name": "obstacles",
				"salience": 0.002201498,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.002201498,
				"type": "OTHER"
			},
			{
				"name": "shot",
				"salience": 0.0021835207,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0021643206,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "skepticism",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.0021193654,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "flames",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "root",
				"salience": 0.0017974004,
				"type": "OTHER"
			},
			{
				"name": "stalemate",
				"salience": 0.0017974004,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0017173974,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0016003643,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0015176807,
				"type": "WORK_OF_ART"
			},
			{
				"name": "deal",
				"salience": 0.0014796829,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0013712988,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0013540224,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.001342805,
				"type": "EVENT"
			},
			{
				"name": "real estate magnate",
				"salience": 0.001167995,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0011294436,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0011294436,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0011294436,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.0011294436,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0010791563,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0010115111,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.0010115111,
				"type": "OTHER"
			},
			{
				"name": "upset",
				"salience": 0.00090635533,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0008437185,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026gv1t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Jewish_Coalition"
				},
				"name": "Republican Jewish Coalition",
				"salience": 0.00082651863,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "AP",
				"salience": 0.00082651863,
				"type": "ORGANIZATION"
			},
			{
				"name": "negotiating partner",
				"salience": 0.00079840363,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.000757382,
				"type": "OTHER"
			},
			{
				"name": "forum",
				"salience": 0.00073057984,
				"type": "EVENT"
			},
			{
				"name": "candidates",
				"salience": 0.00073057984,
				"type": "PERSON"
			},
			{
				"name": "friend",
				"salience": 0.00073057984,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.00064355746,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00060194003,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.0005844798,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.00051927497,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477585077063_510901622-635x357.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:11:36.662+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nLeading Republican presidential hopeful suggests Israeli-Palestinian peace accord may be impossible: ‘Sometimes agreements can’t be made’After being asked by a voter at a Charleston, South Carolina, town hall event hosted by MSNBC about what steps he would take to broker an accommodation between the sides in the conflict, the GOP contender vowed to give it “one hell of a shot” and called it “probably the toughest agreement of any kind to make.”But when pressed by host Joe Scarborough over whether he ascribed fault to either Israelis or Palestinians over the failure to reach a lasting accord, Trump declined to take sides. \n“You know, I don’t want to get into it, because … If I win, I don’t want to be in a position where I’m saying to you and the other side now says, ‘We don’t want Trump involved,'” Trump said. \n“Let me be sort of a neutral guy,” he continued. “A lot of people have gone down in flames trying to make that deal. So I don’t want to say whose fault is it. I don’t think it helps.”Trump also expressed skepticism over the possibility of achieving a two-state solution, given the conditions of the conflict and the need for any agreement to be sustainable over time. \n“It’s possible it’s not makeable, because don’t forget it has to last — it’s wonderful to make it and it doesn’t work, but it has to last,” he said. “To make lasting peace there? Probably the toughest deal of all, but I’m going to give it a shot.” \nThough he was not asked directly what he considers the most substantial obstacles standing in the way of a peace agreement, he suggested that growing hostility between the two peoples was contributing to the current stalemate, and what he considers the root of the conflict. \n“A lot of people say an agreement can’t be made, which is okay. I mean, sometimes agreements can’t be made. Not good, but, you know, you have both sides really, but one side in particular, growing up and learning that these are the worst people,” he said. “I was with a very prominent Israeli the other day. He says it’s impossible, because the other side has been trained from the time they’re children to hate Jewish people.”In the past, Trump has questioned Israel’s commitment to peace, while at the same time suggesting the Jewish state does not have a negotiating partner in the Palestinians. He has also called Prime Minister Benjamin Netanyahu “a good friend.” \nAt a presidential candidates forum hosted by the Republican Jewish Coalition in December 2015, the real estate magnate said, “I don’t know that Israel has the commitment to make it, and I don’t know that the other side has the commitment to make it.” \nHe made the same point in an interview with AP earlier that day: “A lot will have to do with Israel and whether or not Israel wants to make the deal — whether or not Israel’s willing to sacrifice certain things,” he said. “They may not be, and I understand that, and I’m okay with that. But then you’re just not going to have a deal.” \nTrump’s comments Wednesday came hours after a dramatic upset in polls saw Trump fall behind Texas Sen. Ted Cruz for the first time in 31 consecutive polls, coming in at 26% of registered Republican voters nationally, two points behind Cruz at 28%.",
		"thread_title": "Trump says he’d be ‘neutral’ with Israelis and Palestinians",
		"title": "Trump says he’d be ‘neutral’ with Israelis and Palestinians",
		"type": "conspiracy",
		"uuid": "591c49955317985d894168dd5d99143a426d57ea"
	},
	"-KhIjPldFGR5pMsUHJT0": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:46.936+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.58307177,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01yq7d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gennifer_Flowers"
				},
				"name": "Gennifer Flowers",
				"salience": 0.16130856,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.026300939,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.018141655,
				"type": "OTHER"
			},
			{
				"name": "state job",
				"salience": 0.015811367,
				"type": "OTHER"
			},
			{
				"name": "GF",
				"salience": 0.01333782,
				"type": "LOCATION"
			},
			{
				"name": "recording",
				"salience": 0.010732863,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.010732863,
				"type": "WORK_OF_ART"
			},
			{
				"name": "phone conversation",
				"salience": 0.010732863,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.007939396,
				"type": "OTHER"
			},
			{
				"name": "Flowers",
				"salience": 0.007478922,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Columbia"
				},
				"name": "BC",
				"salience": 0.006111433,
				"type": "LOCATION"
			},
			{
				"name": "job",
				"salience": 0.0059800926,
				"type": "OTHER"
			},
			{
				"name": "Flowers",
				"salience": 0.005662271,
				"type": "OTHER"
			},
			{
				"name": "stepfather",
				"salience": 0.0052967328,
				"type": "PERSON"
			},
			{
				"name": "inquiries",
				"salience": 0.0047572083,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.004195596,
				"type": "OTHER"
			},
			{
				"name": "state job",
				"salience": 0.004039204,
				"type": "OTHER"
			},
			{
				"name": "grievance",
				"salience": 0.003951961,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0038359358,
				"type": "OTHER"
			},
			{
				"name": "soemone",
				"salience": 0.0038359358,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0038359358,
				"type": "EVENT"
			},
			{
				"name": "assistant",
				"salience": 0.0038359358,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c9ph5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flower"
				},
				"name": "Flowers",
				"salience": 0.0037491918,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "grievance",
				"salience": 0.0036627909,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0034260363,
				"type": "OTHER"
			},
			{
				"name": "recording",
				"salience": 0.0031066812,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0030154376,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.002990822,
				"type": "WORK_OF_ART"
			},
			{
				"name": "conversation",
				"salience": 0.002990822,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0027247735,
				"type": "OTHER"
			},
			{
				"name": "transcript",
				"salience": 0.0027247735,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.002690466,
				"type": "OTHER"
			},
			{
				"name": "witness",
				"salience": 0.002690466,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "pay-for-play",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "scandals",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "audio segments",
				"salience": 0.0025901103,
				"type": "OTHER"
			},
			{
				"name": "Arkansas Appeal Tribunal",
				"salience": 0.00236212,
				"type": "ORGANIZATION"
			},
			{
				"name": "possibility",
				"salience": 0.0023109266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04khbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gf"
				},
				"name": "GF",
				"salience": 0.0022929872,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.002271902,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.0021966957,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state job",
				"salience": 0.0019868258,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.0019108184,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.0018952121,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Arkansas",
				"salience": 0.0018414311,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0016411785,
				"type": "OTHER"
			},
			{
				"name": "somebody",
				"salience": 0.0016411785,
				"type": "PERSON"
			},
			{
				"name": "cancer",
				"salience": 0.0013121704,
				"type": "OTHER"
			},
			{
				"name": "GF",
				"salience": 0.0012363074,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0012106166,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0011953631,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.0010312406,
				"type": "OTHER"
			},
			{
				"name": "angioplasties",
				"salience": 0.0008929653,
				"type": "OTHER"
			},
			{
				"name": "X-ray",
				"salience": 0.0008929653,
				"type": "OTHER"
			},
			{
				"name": "scare",
				"salience": 0.0008929653,
				"type": "OTHER"
			},
			{
				"name": "spot",
				"salience": 0.000667043,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.000667043,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775662771.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T19:04:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nFormer President Bill Clinton can be heard telling his former mistress, Gennifer Flowers, to deny that he helped her get a state job in a series of recorded phone conversation from 1991. \n“If they ever asked if you’d talked to me about it, you can say no,” Clinton is heard saying in the recording. \nAt the time, the media was making inquiries about Flowers’ alleged affair with Clinton, and she was concerned that they may question how she got a job as administrative assistant for the Arkansas Appeal Tribunal. \nClinton can also be heard telling Flowers how to handle a grievance filed by soemone else who applied for the same positioned and claimed she was more qualified than Flowers. \nFlowers famously recorded a series of conversation she had with Clinton from December 1990 to December 1991, while he was still Governor of Arkansas. The audio segments about the state job were widely reported in the 1990’s, however, as other pay-for-play financial scandals have surfaced, the details may warrant revisiting. \n\nHere is a transcript of part of the recording: \nGF – But anyway, then Wednesday, there was a grievance filed in my office when I got the job by a girl who felt like she should have gotten it, a black girl named (deleted). And they called me as a witness. So I go in and uh, nothing big came of it. It’s just that they were questioning me about how I found out about the job. And I said, “Well, that personnel said it that it was a possibility there would be a position,” and then uh, “they told me that it would be advertised in the newspaper. And it was and I pursued it from there. \nBC – Good for you. \nGF: Yeah. We had a little bit of a scare recently because she had a spot on an X-ray. And she went and had it checked again and it wasn’t cancer. And it’s been almost, it’ll be two years in May that she’s now diagnosed cancer free. My stepfather has been through two angioplasties, but he’s doing good. And I am, I’m really, Bill what I’m afraid of is that if somebody in the press finds out that I’m working for the state. \nBC – Yeah. \nGF – They’re going to make a big deal of it. \nBC – Yeah. \nGF – Well the only thing that concerns me, where I’m, where I’m concerned at this point is the state job. \nBC – Yeah. I never thought about that, but as long as you say you’ve just been looking for one, you’d uh, check on it. If they ever asked if you’d talked to me about it, you can say no.",
		"thread_title": "Busted: Bill Recorded Telling Mistress To Deny That Clintons Helped Her Get A State Job",
		"title": "Busted: Bill Recorded Telling Mistress To Deny That Clintons Helped Her Get A State Job",
		"type": "conspiracy",
		"uuid": "1e7d5f63998784557e6fb085a8352fd3e5700a49"
	},
	"-KhIjQ-zTjEgoo7OM1Om": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:11:57.771+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Catholic Church",
				"salience": 0.3293582,
				"type": "ORGANIZATION"
			},
			{
				"name": "senator",
				"salience": 0.16503079,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.06841674,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.05381974,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States of America",
				"salience": 0.03441166,
				"type": "LOCATION"
			},
			{
				"name": "marriage",
				"salience": 0.032534283,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.017884744,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.017557707,
				"type": "OTHER"
			},
			{
				"name": "milestone",
				"salience": 0.016070282,
				"type": "EVENT"
			},
			{
				"name": "person",
				"salience": 0.015771745,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.012611423,
				"type": "PERSON"
			},
			{
				"name": "marriage",
				"salience": 0.012436769,
				"type": "OTHER"
			},
			{
				"name": "ultimatum",
				"salience": 0.011357313,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.010192106,
				"type": "LOCATION"
			},
			{
				"name": "position",
				"salience": 0.008993949,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.008993949,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.008993949,
				"type": "OTHER"
			},
			{
				"name": "Dinner",
				"salience": 0.008993949,
				"type": "EVENT"
			},
			{
				"name": "creator",
				"salience": 0.007974749,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.0063507413,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.0060001216,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0057822242,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01xcy2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Campaign"
				},
				"name": "Human Rights Campaign",
				"salience": 0.00554227,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00554227,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00554227,
				"type": "LOCATION"
			},
			{
				"name": "liberties",
				"salience": 0.005387226,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0053050504,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.004281936,
				"type": "OTHER"
			},
			{
				"name": "core value",
				"salience": 0.0037084052,
				"type": "OTHER"
			},
			{
				"name": "chapter",
				"salience": 0.0037084052,
				"type": "WORK_OF_ART"
			},
			{
				"name": "citizen",
				"salience": 0.0037084052,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0037084052,
				"type": "LOCATION"
			},
			{
				"name": "definition",
				"salience": 0.0037084052,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0035861146,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0033509734,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0033259385,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0032018898,
				"type": "OTHER"
			},
			{
				"name": "LGBT equality",
				"salience": 0.0030032282,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0030032282,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002679516,
				"type": "PERSON"
			},
			{
				"name": "ways",
				"salience": 0.0026007902,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0026007902,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0026007902,
				"type": "OTHER"
			},
			{
				"name": "abilities",
				"salience": 0.0025037604,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.0025037604,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0024722277,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0024520382,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0024520382,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.002362202,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03b5d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Book_of_Genesis"
				},
				"name": "Genesis",
				"salience": 0.0022833312,
				"type": "ORGANIZATION"
			},
			{
				"name": "ruling",
				"salience": 0.0022338366,
				"type": "OTHER"
			},
			{
				"name": "ultimatum",
				"salience": 0.0020288837,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.0017065571,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.0015863493,
				"type": "PERSON"
			},
			{
				"name": "bags",
				"salience": 0.0015863493,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.0015863493,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0015863493,
				"type": "OTHER"
			},
			{
				"name": "mankind",
				"salience": 0.0015663633,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.0015094699,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.001477772,
				"type": "PERSON"
			},
			{
				"name": "democracy",
				"salience": 0.0013342899,
				"type": "OTHER"
			},
			{
				"name": "equals",
				"salience": 0.0013342899,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hn10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LGBT"
				},
				"name": "LBGT",
				"salience": 0.001307093,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States of America",
				"salience": 0.0012488951,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0012365401,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.001231017,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.001231017,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0011553887,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0011553887,
				"type": "EVENT"
			},
			{
				"name": "honesty",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "lesbians",
				"salience": 0.0011553887,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0011553887,
				"type": "OTHER"
			},
			{
				"name": "gays",
				"salience": 0.0011553887,
				"type": "PERSON"
			},
			{
				"name": "LGBT rights",
				"salience": 0.0011459482,
				"type": "OTHER"
			},
			{
				"name": "ultimatum",
				"salience": 0.0011039423,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0009922896,
				"type": "PERSON"
			},
			{
				"name": "faith",
				"salience": 0.0008630834,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.0008630834,
				"type": "ORGANIZATION"
			},
			{
				"name": "line",
				"salience": 0.0008630834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0007846717,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.0005311818,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775661401.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T19:02:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nDemocratic U.S. vice-presidential nominee Tim Kaine announced Saturday that he believes the Catholic Church will change its position on same-sex marriage. The Virginia senator said that just like he had changed his opinion on the issue, the Catholic Church is also likely to follow suit. Speaking at the 20th Annual Human Rights Campaign’s National Dinner in Washington, the Roman Catholic senator reportedly said, “I think it’s going to change because my church also teaches me about a creator who, in the first chapter of Genesis, surveyed the entire world, including mankind, and said, ‘It is very good.’” \n“And besides,” he continued, “we are talking here about a country that was based and founded on democracy as a core value. By definition, that means that every single person and every single citizen is able – no, scratch that – encouraged to practice his civil, religious, and above all, sexual liberties to the best of their abilities. And I’m sorry that some people don’t like it, but to deny same-sex marriage in a country that should be the first one to accept it is just pointless. And the Catholic Church should also be accepting it instead of condemning it, which is what it’s doing right now.” \nKaine also added that, if all else fails, “there are ways of making the Catholic Church listen to the voice of reason,” which is how he dubbed all those who advocate LGBT equality. “At the end of the day, you know, we’re a civilized people, of course the first thing we’ll do is act nicely and ask nicely,” he said. “Then, if that doesn’t work, we’ll use our law and our legal system to enable ourselves to be who we are, or rather the LBGT community will do that – and it has. The Supreme Court’s ruling on same-sex marriage was a crucial milestone in our legal system that proves it works, it actually functions.” \n“So, what I’m saying here,” he argued, “is that, while I respect the Catholic Church as I’m sure millions of Americans do, you know, at some point it is going to start acting contrary to the Christian faith, and we’re talking about an institution that’s supposed to be the first one on the front line defending it. So, when that happens, and that’s what’s happening with condemning LGBT rights, we’ll state an ultimatum. The United States of America, more precisely, the future President of the United States of America, Hillary Clinton, will state an ultimatum. And that ultimatum will be to either change its stance on same-sex marriage or pack its bags and get out of America. And yes – the President of the country can do that.” \n“And in case anybody’s wondering – no, Donald Trump won’t do the same because he doesn’t care about anyone other than Donald Trump. On the other hand, Hillary Clinton is a shining example of honesty, integrity and democracy, and you can rest assured she will do everything in her power as the president to make sure gays and lesbians throughout America are loved, respected and viewed as equals during her presidential term. What happens after that is not our problem,” Kaine concluded.",
		"thread_title": "Tim Kaine: “The Catholic Church Will Change Its Same-Sex Marriage Stance Or It Will Be Banned From The U.S.”",
		"title": "Tim Kaine: “The Catholic Church Will Change Its Same-Sex Marriage Stance Or It Will Be Banned From The U.S.”",
		"type": "conspiracy",
		"uuid": "702ab84047aac7581589ab3e69acd6c58e4f128d"
	},
	"-KhIjQEONAVo2CnNuQog": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:12:01.325+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05ttk_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Hill_(newspaper)"
				},
				"name": "The Hill",
				"salience": 0.22379148,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.120619945,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07qk51t"
				},
				"name": "Band",
				"salience": 0.09075127,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.04960424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k3llq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Teneo"
				},
				"name": "Teneo",
				"salience": 0.03732412,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band",
				"salience": 0.029155346,
				"type": "ORGANIZATION"
			},
			{
				"name": "consulting firm",
				"salience": 0.02842757,
				"type": "ORGANIZATION"
			},
			{
				"name": "memo",
				"salience": 0.025522403,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.022345379,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.017467584,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/031rxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UBS"
				},
				"name": "UBS",
				"salience": 0.016851636,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.014105938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.012719157,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea Clinton",
				"salience": 0.011008873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04cxlc4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doug_Band"
				},
				"name": "Doug Band",
				"salience": 0.010424022,
				"type": "PERSON"
			},
			{
				"name": "document",
				"salience": 0.009566808,
				"type": "WORK_OF_ART"
			},
			{
				"name": "millions",
				"salience": 0.009328079,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.008608418,
				"type": "OTHER"
			},
			{
				"name": "gigs",
				"salience": 0.008288081,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00808115,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.0077739665,
				"type": "ORGANIZATION"
			},
			{
				"name": "roles",
				"salience": 0.0077376836,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0073975837,
				"type": "PERSON"
			},
			{
				"name": "confidant",
				"salience": 0.0072118696,
				"type": "PERSON"
			},
			{
				"name": "foundation",
				"salience": 0.0071465243,
				"type": "OTHER"
			},
			{
				"name": "Declan Kelly",
				"salience": 0.0067550004,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0060472093,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.005676431,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0055506486,
				"type": "ORGANIZATION"
			},
			{
				"name": "activities",
				"salience": 0.004964332,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0048505543,
				"type": "OTHER"
			},
			{
				"name": "Bill Clinton, Inc.",
				"salience": 0.0048451102,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band",
				"salience": 0.0041019255,
				"type": "PERSON"
			},
			{
				"name": "firm",
				"salience": 0.003945785,
				"type": "ORGANIZATION"
			},
			{
				"name": "Foundation",
				"salience": 0.0039338665,
				"type": "ORGANIZATION"
			},
			{
				"name": "interests",
				"salience": 0.003726591,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0035984113,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.0034763461,
				"type": "OTHER"
			},
			{
				"name": "total",
				"salience": 0.0034172689,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0034172689,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0034172689,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0033172911,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.0033172911,
				"type": "WORK_OF_ART"
			},
			{
				"name": "business",
				"salience": 0.0031935761,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0031729096,
				"type": "PERSON"
			},
			{
				"name": "brat",
				"salience": 0.003167138,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026swz9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cheryl_Mills"
				},
				"name": "Cheryl Mills",
				"salience": 0.0030692797,
				"type": "PERSON"
			},
			{
				"name": "roles",
				"salience": 0.0030520053,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0030520053,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.0029352924,
				"type": "OTHER"
			},
			{
				"name": "Band",
				"salience": 0.0029136995,
				"type": "ORGANIZATION"
			},
			{
				"name": "business",
				"salience": 0.0028135204,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0027780936,
				"type": "PERSON"
			},
			{
				"name": "court clients",
				"salience": 0.0027674434,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.002755091,
				"type": "OTHER"
			},
			{
				"name": "goals",
				"salience": 0.0026642105,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.0026642105,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gr916",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhtar_Kent"
				},
				"name": "Muhtar Kent",
				"salience": 0.0025266518,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.0025212208,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "responsibilities",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0023965961,
				"type": "OTHER"
			},
			{
				"name": "document",
				"salience": 0.0023770253,
				"type": "WORK_OF_ART"
			},
			{
				"name": "concerns",
				"salience": 0.002336611,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.002307183,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.002307183,
				"type": "PERSON"
			},
			{
				"name": "multiplicity",
				"salience": 0.002307183,
				"type": "OTHER"
			},
			{
				"name": "engagement",
				"salience": 0.002307183,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0022803606,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0022595213,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0022595213,
				"type": "OTHER"
			},
			{
				"name": "Band",
				"salience": 0.00217699,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band",
				"salience": 0.00217699,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05sjhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Examiner"
				},
				"name": "Washington Examiner",
				"salience": 0.0021040582,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.0020236815,
				"type": "OTHER"
			},
			{
				"name": "tax exempt",
				"salience": 0.0019566799,
				"type": "OTHER"
			},
			{
				"name": "best practices",
				"salience": 0.0019566799,
				"type": "OTHER"
			},
			{
				"name": "adviser",
				"salience": 0.0019566799,
				"type": "PERSON"
			},
			{
				"name": "criticism",
				"salience": 0.0019566799,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0019420544,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0017457046,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0017237132,
				"type": "OTHER"
			},
			{
				"name": "chairman",
				"salience": 0.0017202331,
				"type": "PERSON"
			},
			{
				"name": "Band",
				"salience": 0.0016264218,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.0014740054,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.0014740054,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0014617938,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wind",
				"salience": 0.0014617938,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0014617938,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0013566749,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.0012408686,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ways",
				"salience": 0.0012295237,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0012044621,
				"type": "ORGANIZATION"
			},
			{
				"name": "nothing",
				"salience": 0.0011783434,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0011059518,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0011011399,
				"type": "WORK_OF_ART"
			},
			{
				"name": "memo",
				"salience": 0.0010793139,
				"type": "WORK_OF_ART"
			},
			{
				"name": "advisory board",
				"salience": 0.0010646685,
				"type": "ORGANIZATION"
			},
			{
				"name": "all",
				"salience": 0.0010646685,
				"type": "OTHER"
			},
			{
				"name": "CGI",
				"salience": 0.0010646685,
				"type": "OTHER"
			},
			{
				"name": "clients",
				"salience": 0.000918478,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.000918478,
				"type": "OTHER"
			},
			{
				"name": "donations",
				"salience": 0.000918478,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.000918478,
				"type": "PERSON"
			},
			{
				"name": "principals",
				"salience": 0.0008054645,
				"type": "PERSON"
			},
			{
				"name": "introductions",
				"salience": 0.0007953137,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03cjjl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Podest%C3%A0"
				},
				"name": "Podesta",
				"salience": 0.0007567595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03phgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Coca-Cola_Company"
				},
				"name": "Coca-Cola",
				"salience": 0.00048947235,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775658391.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T18:57:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAn internal memo released Wednesday by WikiLeaks reveals how a longtime Clinton confidant played an \"unorthodox\" dual role – raising money for the Clinton Foundation and finding paid work for Bill Clinton, The Hill reports. \nThe 12-page document written in 2011 by Doug Band of Teneo, a private consulting firm that raised millions for the foundation and also scouted out paid gigs for what was dubbed \"Bill Clinton, Inc.\", the Washington Examiner reports. \nIn one instance, Band secured a $540,000 donation to the Clinton Foundation from banking giant UBS. He later arranged for Bill Clinton to give three paid speeches to the firm for a total of $900,000, The Hill reported. \nBut in his memo, Band argues his double duties were \"independent\" of one another; the memo was written after Chelsea Clinton criticized Band's role within the family's network of interests, The Hill reports. \n\"In the unique roles in which we have had the opportunity to serve, we have been able to help balance the multiplicity of activities that demand [Bill Clinton's] time and engagement to best fulfill his personal, political, business, official former President, and Foundation/non-profit goals,\" Band writes. \nAccording to The Hill, Teneo's overlapping responsibilities worried some in the Clintons' inner circle, and in one email published by WikiLeaks, Chelsea Clinton raised \"serious concerns\" with Teneo's liberal use of the Clinton name to court clients. \nBand lashed out, calling the former first daughter a meddlesome \"spoiled brat\" in one hacked email released by WikiLeaks. \n\"We appreciate the unorthodox nature of our roles, and the goal of seeking ways to ensure we are implementing best practices to protect the [tax exempt] status of the Foundation,\" Band wrote in his memo to justify his role and bat back criticism, The Hill reports. \nBand co-founded Teneo with former State Department employee Declan Kelly while Hillary Clinton was secretary of state – and paid Bill Clinton as an adviser through 2012, The Hill reports. \nBand's memo lists several Teneo clients that he and Kelly \"leveraged\" into major donors for the foundation, and also details the personal introductions the two principals made between the Clintons and the prospective donors, The Hill reports. \nOne that Kelly \"cultivated\" was Coca-Cola CEO Muhtar Kent, which led to seven-figure donations beginning in 2009. \nIn a previous hacked email to Hillary Clinton campaign chairman John Podesta, Band worried the press might catch wind of his role and misconstrue it. \n\"I'm starting to worry that if this story gets out, we are screwed,\" Band wrote. \n\"[Kelly] and I built a business. Our business has almost nothing to do with the Clintons, the foundation or [the Clinton Global Initiative] in any way. The chairman of UBS could care a less [sic] about CGI.\" \nA week after Band sent his memo, Clinton lawyer Cheryl Mills sent a document to Podesta and Band laying out ways to unwind the former president's charitable and business interests — all of which distanced Band from the foundation. \nIn December 2011, the former president resigned his position on Teneo’s advisory board, The Hill reports.",
		"thread_title": "WikiLeaks: Clinton Confidant Raised Money for Foundation, Got Bill Paid Gigs",
		"title": "WikiLeaks: Clinton Confidant Raised Money for Foundation, Got Bill Paid Gigs",
		"type": "conspiracy",
		"uuid": "1c380ea4f1d49166208159c3d0f278b5fce9272c"
	},
	"-KhIjQ_vMPq5B99yFAum": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:12:03.459+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "country",
				"salience": 0.19232616,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06497859,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.03930468,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.022894068,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02dkt6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Snopes.com"
				},
				"name": "Snopes",
				"salience": 0.022645812,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.018761689,
				"type": "EVENT"
			},
			{
				"name": "Email",
				"salience": 0.018678304,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.017483309,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.017477088,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack H Obama",
				"salience": 0.016198277,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.015499141,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.014053362,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.013764001,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.012662205,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.011389378,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.01103664,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.01103664,
				"type": "EVENT"
			},
			{
				"name": "Company",
				"salience": 0.01103664,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.009903213,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.009603065,
				"type": "OTHER"
			},
			{
				"name": "sum",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "Reports",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "abatement",
				"salience": 0.009560271,
				"type": "OTHER"
			},
			{
				"name": "facilitation",
				"salience": 0.009560271,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.009379071,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034ls",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_H._W._Bush"
				},
				"name": "George H.W. Bush",
				"salience": 0.008994957,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017jh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Prescott_Bush"
				},
				"name": "Prescott Bush",
				"salience": 0.008930082,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.008773918,
				"type": "PERSON"
			},
			{
				"name": "Rick Williams",
				"salience": 0.0068942467,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0061764615,
				"type": "PERSON"
			},
			{
				"name": "high crimes",
				"salience": 0.006144459,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.006144459,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.006144459,
				"type": "EVENT"
			},
			{
				"name": "plans",
				"salience": 0.0059668357,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.005889339,
				"type": "ORGANIZATION"
			},
			{
				"name": "Qatar Central Bank",
				"salience": 0.005889339,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hlwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JPMorgan_Chase"
				},
				"name": "JP Morgan Chase",
				"salience": 0.005889339,
				"type": "ORGANIZATION"
			},
			{
				"name": "Administration",
				"salience": 0.0058175917,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00564283,
				"type": "PERSON"
			},
			{
				"name": "exit plans",
				"salience": 0.005060932,
				"type": "OTHER"
			},
			{
				"name": "extradition country",
				"salience": 0.005059125,
				"type": "LOCATION"
			},
			{
				"name": "extradition treaty",
				"salience": 0.0049714525,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.004886963,
				"type": "OTHER"
			},
			{
				"name": "both",
				"salience": 0.004855339,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.004552719,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.004549542,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.004549542,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.004130809,
				"type": "LOCATION"
			},
			{
				"name": "purchase",
				"salience": 0.0040802523,
				"type": "EVENT"
			},
			{
				"name": "purchase",
				"salience": 0.0040802523,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.003939955,
				"type": "EVENT"
			},
			{
				"name": "debates",
				"salience": 0.003939955,
				"type": "EVENT"
			},
			{
				"name": "material",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "e-mail server",
				"salience": 0.003939955,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.003928047,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0039144526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0038077561,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.003681968,
				"type": "PERSON"
			},
			{
				"name": "seaside mansion",
				"salience": 0.0035334802,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0035334802,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.0035334802,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0035334802,
				"type": "OTHER"
			},
			{
				"name": "mansion",
				"salience": 0.0035334802,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0035334802,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0035186987,
				"type": "OTHER"
			},
			{
				"name": "mansion",
				"salience": 0.003401651,
				"type": "LOCATION"
			},
			{
				"name": "deaths",
				"salience": 0.003401651,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.0033874207,
				"type": "OTHER"
			},
			{
				"name": "death penalty",
				"salience": 0.0033564644,
				"type": "OTHER"
			},
			{
				"name": "Administrations",
				"salience": 0.003331379,
				"type": "ORGANIZATION"
			},
			{
				"name": "purchase",
				"salience": 0.003331379,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.0032512636,
				"type": "ORGANIZATION"
			},
			{
				"name": "citizens",
				"salience": 0.003210314,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0031905358,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0031905358,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0031226452,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "Presidential",
				"salience": 0.0031021668,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0030863173,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0030863173,
				"type": "LOCATION"
			},
			{
				"name": "justice",
				"salience": 0.00307149,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.00307149,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00307149,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.00307149,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.003051604,
				"type": "ORGANIZATION"
			},
			{
				"name": "possibility",
				"salience": 0.0029066012,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.002812655,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.002762894,
				"type": "OTHER"
			},
			{
				"name": "firing",
				"salience": 0.002762894,
				"type": "EVENT"
			},
			{
				"name": "yacht",
				"salience": 0.002659792,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "announcement",
				"salience": 0.002659792,
				"type": "EVENT"
			},
			{
				"name": "terrorist groups",
				"salience": 0.002659792,
				"type": "ORGANIZATION"
			},
			{
				"name": "connections",
				"salience": 0.0026048338,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.002507626,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0024888802,
				"type": "OTHER"
			},
			{
				"name": "purchase",
				"salience": 0.0024888802,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0023328988,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0023328988,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0023328988,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.0023135724,
				"type": "OTHER"
			},
			{
				"name": "perpetrators",
				"salience": 0.0022556449,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.0021991667,
				"type": "WORK_OF_ART"
			},
			{
				"name": "extradition",
				"salience": 0.002029205,
				"type": "OTHER"
			},
			{
				"name": "real estate",
				"salience": 0.0019459728,
				"type": "LOCATION"
			},
			{
				"name": "real estate",
				"salience": 0.0019459728,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0019459728,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.0019459728,
				"type": "OTHER"
			},
			{
				"name": "corrupt",
				"salience": 0.0019459728,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0019147497,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0019147497,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazi Dictatorship",
				"salience": 0.0018909011,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05g9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Party"
				},
				"name": "Nazis",
				"salience": 0.0018909011,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0018907344,
				"type": "PERSON"
			},
			{
				"name": "Administration",
				"salience": 0.001812772,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01f08r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dubai"
				},
				"name": "Dubai",
				"salience": 0.0017007114,
				"type": "LOCATION"
			},
			{
				"name": "humanity",
				"salience": 0.0016850636,
				"type": "PERSON"
			},
			{
				"name": "trillions",
				"salience": 0.0016850636,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.0016850636,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0016850636,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0016850636,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0016793669,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gv10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nantucket"
				},
				"name": "Nantucket",
				"salience": 0.0016372278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0016372278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.0016372278,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05v10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paraguay"
				},
				"name": "Paraguay",
				"salience": 0.0015772497,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0014172856,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.0013582828,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0013541746,
				"type": "OTHER"
			},
			{
				"name": "purchase",
				"salience": 0.0013541746,
				"type": "EVENT"
			},
			{
				"name": "criminals",
				"salience": 0.0013088598,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0012692804,
				"type": "PERSON"
			},
			{
				"name": "death penalty",
				"salience": 0.0012327426,
				"type": "EVENT"
			},
			{
				"name": "laws",
				"salience": 0.0012272357,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0012272357,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0012272357,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0012272357,
				"type": "OTHER"
			},
			{
				"name": "stipulation",
				"salience": 0.0011373137,
				"type": "OTHER"
			},
			{
				"name": "connections",
				"salience": 0.0010587081,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0010587081,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.0010539783,
				"type": "OTHER"
			},
			{
				"name": "extradition request",
				"salience": 0.00091672846,
				"type": "OTHER"
			},
			{
				"name": "shareholder",
				"salience": 0.00091672846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02hbt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dictatorship"
				},
				"name": "Dictatorship",
				"salience": 0.0008722853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "WWII",
				"salience": 0.000858062,
				"type": "EVENT"
			},
			{
				"name": "institutions",
				"salience": 0.00084955234,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059z0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_Germany"
				},
				"name": "Nazis",
				"salience": 0.0008218372,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gl3g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Basic_Law_for_the_Federal_Republic_of_Germany"
				},
				"name": "Constitution",
				"salience": 0.00075530075,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06n3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_America"
				},
				"name": "South America",
				"salience": 0.00065156835,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.00042826415,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775656811.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T18:54:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nIt appears Bill and Hillary Clinton are making plans to flee the country in the event Donald Trump wins this election. Reports are circulating that the Clinton’s have transferred 1.8 Billion dollars from the Clinton Foundation to the Qatar Central Bank via a facilitation/abatement of JP Morgan Chase & Company for reasons not revealed. \nThis move of such a large sum of money to the country of Qatar says in itself Hillary Clinton knows she is going to lose the election, and she doesn’t plan to allow her or Bill to be prosecuted for various high crimes and treason under a Trump Administration. \nThe country of Qatar happens to be one of a handful of countries that does not have an extradition treaty with the United States, thus would be a perfect place for her to run to in escaping justice. \nDonald Trump has said many times during his campaign and at the Presidential debates that once he gets into office he intends to prosecute her on various high crimes from her latest crimes of sending classified material via a personal e-mail server to gun-running to terrorist groups in Syria resulting in the deaths of 4 Americans in Benghazi. \nApparently, Hillary is not the only person in Washington who has made plans to escape justice under a Trump Administration, John Kerry has quietly been selling his property in the US for millions of dollars of late, with an announcement of the sale of his $25 million Nantucket mansion in June 2016 as well as the sale of his yacht for $3.9 million in July 2016. \nPresident Barack H Obama has also apparently been making exit plans with his purchase of a $4.9 million seaside mansion in Dubai in January 2016, another non extradition country. \nSnopes and other supposed fact checking sites have debunked both the story of Obama’s purchase of the mansion and the firing of Rear Admiral Rick Williams, however over the last several months these sites have been busted for lying in trying to debunk such information as the before mentioned, when in fact the information is true. Snopes and other sites try their best to keep incriminating information from being believed, but the truth has a way of coming out on its own, as it always has. \nThe Bush family has been quietly buying property as well with the purchase of 100,000 acres in Paraguay in 2006, yet another country good for the Bush family, since it does not allow extradition to any country if the death penalty is a possibility for the crime. If the corruption is found to go as far back as both of the Bush Administrations with any connections to them being the perpetrators of the events on 9-11, the death penalty would surely be a stipulation of any extradition request. Apparently, if things get going with prosecuting the corrupt and treasonous, the Bush’s plan on getting out of the country as well. \nInterestingly, the Bush family’s Nazi connections dating back to WWII seem to have played a part in the Paraguay purchase since most Nazis fled to South America after WWII. Since George H. W. Bush’s father Senator Prescott Bush was director and shareholder in companies that were connected with institutions financially backing the Nazis, the Bush family has a long history of being associated with Nazis. \nWith the movement of huge amounts of funds, selling millions of dollars in real estate, and the purchase of millions in real estate overseas, we are seeing the plans of the corrupt in Washington who have been ripping of our country in the trillions, murdering US citizens in the thousands, and citizens in foreign countries by the millions since 9-11 finally realizing their crimes against humanity is about to be exposed. \nWe are also witnessing the change from what amounts to nothing more than a Nazi Dictatorship in Washington to an actual Presidential Administration who not only will look to the Constitution as the basis of all laws, but one who is going to prosecute the criminals in our government and return it to being a government by the people, for the people, and of the people of the USA. Not the Dictatorship over the people, to the people and who disregards the people as we now have in power.",
		"thread_title": "Hillary Planning Her Escape After a Trump Win With a $1.8 BILLION Money Transfer to QATAR",
		"title": "Hillary Planning Her Escape After a Trump Win With a $1.8 BILLION Money Transfer to QATAR",
		"type": "conspiracy",
		"uuid": "2da5b83086f985feb04b67248d13e1e9d401d238"
	},
	"-KhIjQn8_h57xWVPQHer": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:12:18.668+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.37415966,
				"type": "PERSON"
			},
			{
				"name": "dairy farmer",
				"salience": 0.08826368,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.07190234,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.056584273,
				"type": "PERSON"
			},
			{
				"name": "family farm",
				"salience": 0.040825173,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01xyt7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tom_Brady"
				},
				"name": "Tom Brady",
				"salience": 0.03614496,
				"type": "PERSON"
			},
			{
				"name": "kid",
				"salience": 0.028915362,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.026971275,
				"type": "OTHER"
			},
			{
				"name": "family dairy farm",
				"salience": 0.019129358,
				"type": "LOCATION"
			},
			{
				"name": "cattle",
				"salience": 0.015976358,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.015976358,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.015976358,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.01281964,
				"type": "OTHER"
			},
			{
				"name": "Willow Brady Jr.",
				"salience": 0.012594269,
				"type": "PERSON"
			},
			{
				"name": "brothers",
				"salience": 0.012279979,
				"type": "PERSON"
			},
			{
				"name": "intercourse",
				"salience": 0.010357127,
				"type": "OTHER"
			},
			{
				"name": "cows names",
				"salience": 0.008788234,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013l6l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sioux_Falls,_South_Dakota"
				},
				"name": "Sioux Falls",
				"salience": 0.008539538,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.006690481,
				"type": "LOCATION"
			},
			{
				"name": "Sex",
				"salience": 0.006653951,
				"type": "OTHER"
			},
			{
				"name": "step dad",
				"salience": 0.0065997103,
				"type": "PERSON"
			},
			{
				"name": "holidays",
				"salience": 0.0057165585,
				"type": "EVENT"
			},
			{
				"name": "area",
				"salience": 0.0057165585,
				"type": "LOCATION"
			},
			{
				"name": "farm",
				"salience": 0.0055494662,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0046303417,
				"type": "EVENT"
			},
			{
				"name": "cattle",
				"salience": 0.0046303417,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.0046303417,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "everything",
				"salience": 0.0044944165,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.0040102745,
				"type": "OTHER"
			},
			{
				"name": "caucus",
				"salience": 0.0040102745,
				"type": "EVENT"
			},
			{
				"name": "festivities",
				"salience": 0.0040102745,
				"type": "EVENT"
			},
			{
				"name": "President",
				"salience": 0.00388467,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0038607544,
				"type": "OTHER"
			},
			{
				"name": "fan",
				"salience": 0.0038607544,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0038607544,
				"type": "ORGANIZATION"
			},
			{
				"name": "heart",
				"salience": 0.0038607544,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.0037810488,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "truth",
				"salience": 0.0037810488,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0036700163,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Clinton",
				"salience": 0.0034379307,
				"type": "PERSON"
			},
			{
				"name": "dad",
				"salience": 0.0033736413,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.0032745558,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0032745558,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.002902838,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.0026856451,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0023772689,
				"type": "ORGANIZATION"
			},
			{
				"name": "enemy",
				"salience": 0.002267528,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0020580583,
				"type": "PERSON"
			},
			{
				"name": "misconduct",
				"salience": 0.0017821948,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0016516582,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.001537543,
				"type": "PERSON"
			},
			{
				"name": "cows",
				"salience": 0.001537543,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0015062067,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0015062067,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0013314103,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0013314103,
				"type": "WORK_OF_ART"
			},
			{
				"name": "something",
				"salience": 0.0013314103,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0013314103,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0013314103,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0010970185,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0010970185,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0509p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monica_Lewinsky"
				},
				"name": "Monica Lewinsky",
				"salience": 0.0010970185,
				"type": "PERSON"
			},
			{
				"name": "hell",
				"salience": 0.0007717769,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775655091.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T18:52:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nSioux Falls, IA | During his 1992 presidential campaign, Bill Clinton allegedly had sexual intercourse with cattle off of Tom Brady’s family dairy farm. \nThe family farm which was owned by Tom Brady’s father at the time, Willow Brady Jr., was often visited by the Clinton family when they were in the area. \n“My dad and Bill Clinton’s step dad were like brothers. They often visited us on the holidays when I was a kid. Bill even knew the cows names by heart. That always surprised me” recalls the 64-year-old, third-generation dairy farmer. \n“ My father was a strong Democratic party supporter all his life and a big Bill Clinton fan, so I never found the strength to tell him the truth before he passed away ” \nSex, drugs and cattle \nDuring the 1992 Iowa caucus, the Clinton campaign stopped by for a night of festivities at the Brady’s farm, a night Tom Brady says he will never forget. \n“The Clinton team came by and we drank a lot and all was merry before they started indulging in hard drugs, that’s when everything went wrong” he recalls, visibly distraught by the whole affair. \n“I don’t know about all those stories about him sexually assaulting women, but I sure as hell know he assaulted one of our cows because I was there and I saw him do it with my own eyes and believe me, it’s not something I’d wish my worst enemy to live to see” he told local reporters. \n“I’m sorry for the Clinton family, but as a God-fearing Christian, I just had to let the truth be known” he adds. \nBill Clinton has been personally accused publicly by seventeen women of sexual misconduct between 1972 and 1997. The former US President also admitted to having had an “inappropriate relationship” with Monica Lewinsky while she worked at the White House in 1995 and 1996.",
		"thread_title": "BILL CLINTON HAD SEX WITH COW DURING ‘COCAINE PARTY’, IOWA FARMER REVEALS",
		"title": "BILL CLINTON HAD SEX WITH COW DURING ‘COCAINE PARTY’, IOWA FARMER REVEALS",
		"type": "conspiracy",
		"uuid": "71a4360e9a30cc905b092779c07a84f21b2b1bcd"
	},
	"-KhIjR2fHkTMJziGwhqQ": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:12:26.781+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Bill Clinton Inc.)",
				"salience": 0.4373442,
				"type": "PERSON"
			},
			{
				"name": "partners",
				"salience": 0.071097605,
				"type": "ORGANIZATION"
			},
			{
				"name": "memo",
				"salience": 0.044514824,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04cxlc4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doug_Band"
				},
				"name": "Doug Band",
				"salience": 0.043020964,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.03174825,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea Clinton",
				"salience": 0.029893573,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k3llq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Teneo"
				},
				"name": "Teneo",
				"salience": 0.027838757,
				"type": "ORGANIZATION"
			},
			{
				"name": "cronies",
				"salience": 0.012824749,
				"type": "PERSON"
			},
			{
				"name": "Declan Kelly",
				"salience": 0.012782723,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.011671433,
				"type": "OTHER"
			},
			{
				"name": "arrangement",
				"salience": 0.011636388,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.01017591,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07qk51t"
				},
				"name": "Band",
				"salience": 0.009998039,
				"type": "ORGANIZATION"
			},
			{
				"name": "arrangement",
				"salience": 0.009878559,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0090662055,
				"type": "LOCATION"
			},
			{
				"name": "arrangement",
				"salience": 0.008818774,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.008818774,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.008818774,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Bill Clinton Inc.",
				"salience": 0.008610885,
				"type": "ORGANIZATION"
			},
			{
				"name": "Laureate Foundation",
				"salience": 0.008131558,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.0076036933,
				"type": "ORGANIZATION"
			},
			{
				"name": "memo",
				"salience": 0.006921216,
				"type": "WORK_OF_ART"
			},
			{
				"name": "company",
				"salience": 0.0069027185,
				"type": "ORGANIZATION"
			},
			{
				"name": "consulting firm",
				"salience": 0.005980399,
				"type": "ORGANIZATION"
			},
			{
				"name": "millions",
				"salience": 0.005980399,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0058311345,
				"type": "OTHER"
			},
			{
				"name": "consulting company",
				"salience": 0.005293864,
				"type": "ORGANIZATION"
			},
			{
				"name": "players",
				"salience": 0.005236253,
				"type": "PERSON"
			},
			{
				"name": "foundation",
				"salience": 0.004203302,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0271pk1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clintons"
				},
				"name": "Clintons",
				"salience": 0.003743316,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.003685676,
				"type": "ORGANIZATION"
			},
			{
				"name": "speeches",
				"salience": 0.0034129878,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0033755917,
				"type": "ORGANIZATION"
			},
			{
				"name": "advisory services business",
				"salience": 0.003248783,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0028950386,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0028476582,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.002839058,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.002839058,
				"type": "ORGANIZATION"
			},
			{
				"name": "Band memo",
				"salience": 0.002802026,
				"type": "WORK_OF_ART"
			},
			{
				"name": "excess",
				"salience": 0.0024662842,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.0024662842,
				"type": "ORGANIZATION"
			},
			{
				"name": "arrangement",
				"salience": 0.0024588339,
				"type": "OTHER"
			},
			{
				"name": "e-mails",
				"salience": 0.0024429257,
				"type": "OTHER"
			},
			{
				"name": "e-mail",
				"salience": 0.0024429257,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.002394139,
				"type": "EVENT"
			},
			{
				"name": "memo",
				"salience": 0.002346735,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Laureate",
				"salience": 0.0023269244,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.0023048639,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0022068725,
				"type": "PERSON"
			},
			{
				"name": "Bob McCann",
				"salience": 0.0021945813,
				"type": "PERSON"
			},
			{
				"name": "vet donors",
				"salience": 0.0021156804,
				"type": "PERSON"
			},
			{
				"name": "fee",
				"salience": 0.0020747315,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.002056494,
				"type": "EVENT"
			},
			{
				"name": "globe",
				"salience": 0.0019973512,
				"type": "LOCATION"
			},
			{
				"name": "speeches",
				"salience": 0.0019797927,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0019548659,
				"type": "EVENT"
			},
			{
				"name": "speeches",
				"salience": 0.0019548659,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.0019548659,
				"type": "WORK_OF_ART"
			},
			{
				"name": "For-Profit Activity",
				"salience": 0.0019500601,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0017993514,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.0017297256,
				"type": "OTHER"
			},
			{
				"name": "chairman",
				"salience": 0.0017297256,
				"type": "PERSON"
			},
			{
				"name": "Band",
				"salience": 0.0017039712,
				"type": "ORGANIZATION"
			},
			{
				"name": "meeting",
				"salience": 0.0016651987,
				"type": "EVENT"
			},
			{
				"name": "hundreds",
				"salience": 0.0016651987,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.0016651987,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.0016651987,
				"type": "OTHER"
			},
			{
				"name": "business interests",
				"salience": 0.0016651987,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0016308022,
				"type": "OTHER"
			},
			{
				"name": "UBS Wealth Management",
				"salience": 0.0015715493,
				"type": "ORGANIZATION"
			},
			{
				"name": "e-mail",
				"salience": 0.0015582289,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0014669795,
				"type": "PERSON"
			},
			{
				"name": "addresses",
				"salience": 0.0014122452,
				"type": "OTHER"
			},
			{
				"name": "sessions",
				"salience": 0.0014122452,
				"type": "EVENT"
			},
			{
				"name": "commitment",
				"salience": 0.0014122452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0013668261,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08wgq7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laureate"
				},
				"name": "Laureate",
				"salience": 0.0013619151,
				"type": "OTHER"
			},
			{
				"name": "foundation donors",
				"salience": 0.0013493894,
				"type": "PERSON"
			},
			{
				"name": "reach",
				"salience": 0.0013255178,
				"type": "OTHER"
			},
			{
				"name": "Band",
				"salience": 0.0012570518,
				"type": "ORGANIZATION"
			},
			{
				"name": "relationship",
				"salience": 0.0012076903,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/094jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltimore"
				},
				"name": "Baltimore",
				"salience": 0.0010648756,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.0010550799,
				"type": "PERSON"
			},
			{
				"name": "board member",
				"salience": 0.0010550799,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0010550799,
				"type": "OTHER"
			},
			{
				"name": "audit",
				"salience": 0.0010550799,
				"type": "OTHER"
			},
			{
				"name": "muddle",
				"salience": 0.0010550799,
				"type": "OTHER"
			},
			{
				"name": "business opportunities",
				"salience": 0.0010550799,
				"type": "OTHER"
			},
			{
				"name": "memo",
				"salience": 0.00089563074,
				"type": "WORK_OF_ART"
			},
			{
				"name": "business arrangements",
				"salience": 0.0008479317,
				"type": "OTHER"
			},
			{
				"name": "e-mail",
				"salience": 0.0008479317,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0008049246,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.00076845917,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.00076845917,
				"type": "PERSON"
			},
			{
				"name": "CGI official",
				"salience": 0.00076845917,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.00076845917,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00076845917,
				"type": "PERSON"
			},
			{
				"name": "links",
				"salience": 0.00076845917,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.0007342431,
				"type": "PERSON"
			},
			{
				"name": "fee",
				"salience": 0.00068865233,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0006825933,
				"type": "OTHER"
			},
			{
				"name": "plane",
				"salience": 0.00057404995,
				"type": "OTHER"
			},
			{
				"name": "engagements",
				"salience": 0.00057404995,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0129tn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Citizens_United_(organization)"
				},
				"name": "Citizens United",
				"salience": 0.000472974,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03rt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republic_of_Ireland"
				},
				"name": "Ireland",
				"salience": 0.000472974,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03h64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hong_Kong"
				},
				"name": "Hong Kong",
				"salience": 0.00035330103,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775653191.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T18:48:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nTwo Bill Clinton cronies used their private consulting firm to steer millions in business to the former president while raising funds for the Clinton Foundation — and even called the arrangement “Bill Clinton Inc.” \nDoug Band, a top Clinton aide, detailed the complex financial arrangement between his company, Teneo, and the foundation in a memo contained in hacked e-mails released Wednesday by WikiLeaks. \n“Teneo partners have raised in excess of $8 million for the foundation, more than $5.25 million of which is in the bank,” the memo reads. \n“Teneo partners also have generated over $3 million in paid speeches for President Clinton, $1.25 million of which has been paid to him thus far.” \nThe consulting company was formed by Band and former State Department envoy Declan Kelly. The memo about its activities shows the incestuous relationship between the foundation and the private business interests of the former president. \nIn one arrangement, Kelly introduced Bob McCann, the head of UBS Wealth Management, to Clinton at an event in 2009. \nAfter the meeting, McCann donated hundreds of thousands to the foundation while inviting Clinton to give several paid speeches. \nAnother arrangement involved the Laureate Foundation, which donated more than $1 million to the Clinton Global Initiative. \nLaureate was a “personal advisory services business,” the memo said, paying Clinton “$3.5 million annually to provide advice and serve as their honorary chairman.” \nThe cozy relationship with the Clintons put the Baltimore-based Laureate at high-profile events with international players who could help it expand its reach around the globe. \nThe Band memo also includes a section about “For-Profit Activity of President Clinton (i.e., Bill Clinton Inc.).” \nSome of the speeches “secured” by Teneo include two $450,000 addresses delivered to UBS in 2011 and 2012, as well as a commitment for three additional paid speeches, if he chose to give them. \nAnother secured event was a $1 million fee for Clinton to speak at two one-hour sessions during an event in Hong Kong. The fee included $400,000 for a private plane. \n“Since 2001, President Clinton’s business arrangements have yielded more than $30 million for him personally, with $66 million to be paid out over the next nine years should he choose to continue with the current engagements,” the memo reads. \nThe relationship between Band and the donors was criticized harshly by daughter Chelsea Clinton in another e-mail. \nChelsea specifically called out Band and Teneo for “hustling’” business opportunities out of the foundation. \n“I continue to want — and to try — to disintermediate myself from this muddle, edify the corporate audit and existential process we are in — while also being a responsible board member, daughter and person,” Chelsea wrote in the 2011 e-mail. \nThe relationship between foundation donors and Hillary Clinton’s State Department was raised through e-mails obtained by Citizens United in which top Hillary aide Huma Abedin appeared to vet donors’ access to the Clintons based on their links to the CGI. \nIn a December 2012 e-mail in which a CGI official asks for Band and a few others to meet with Hillary during a trip to Ireland, Abedin writes to Band, “Are these legit cgi people?”",
		"thread_title": "Clinton cronies steered millions to foundation — and Bill’s wallet",
		"title": "Clinton cronies steered millions to foundation — and Bill’s wallet",
		"type": "conspiracy",
		"uuid": "0457746a16bf1e39f178ae20fa2a6e517e2bca26"
	},
	"-KhIjRHQZaqJ--WtYxs1": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:12:32.820+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.74613255,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.03946654,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012gx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Biden"
				},
				"name": "Joe Biden",
				"salience": 0.038911056,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.022170566,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.014664134,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.0083562685,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0066671716,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.006494789,
				"type": "OTHER"
			},
			{
				"name": "trillions",
				"salience": 0.0063330135,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.006313963,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.006313963,
				"type": "OTHER"
			},
			{
				"name": "workforce",
				"salience": 0.006313963,
				"type": "OTHER"
			},
			{
				"name": "bread-winner",
				"salience": 0.0058836606,
				"type": "PERSON"
			},
			{
				"name": "childcare",
				"salience": 0.0049421703,
				"type": "OTHER"
			},
			{
				"name": "GDP",
				"salience": 0.004281831,
				"type": "OTHER"
			},
			{
				"name": "stats",
				"salience": 0.0040531005,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.003862254,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0029202993,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.0027531162,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0026388883,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0024436507,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.0023452141,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0022393947,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.0020388882,
				"type": "OTHER"
			},
			{
				"name": "recession",
				"salience": 0.0020388882,
				"type": "EVENT"
			},
			{
				"name": "recession",
				"salience": 0.0020388882,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0018774809,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0018594201,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0018286799,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.001765832,
				"type": "OTHER"
			},
			{
				"name": "campaign event",
				"salience": 0.001765832,
				"type": "EVENT"
			},
			{
				"name": "woman",
				"salience": 0.0015837346,
				"type": "PERSON"
			},
			{
				"name": "reasons",
				"salience": 0.0014300842,
				"type": "OTHER"
			},
			{
				"name": "downfall",
				"salience": 0.0014237019,
				"type": "OTHER"
			},
			{
				"name": "behinds",
				"salience": 0.0013767447,
				"type": "OTHER"
			},
			{
				"name": "behinds",
				"salience": 0.0013678345,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0012384685,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0012384685,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.0012022234,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.001192268,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.001192268,
				"type": "OTHER"
			},
			{
				"name": "economics",
				"salience": 0.0011784085,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0011676406,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.0011676406,
				"type": "LOCATION"
			},
			{
				"name": "household",
				"salience": 0.0011676406,
				"type": "OTHER"
			},
			{
				"name": "workforce",
				"salience": 0.001115679,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m49v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chatham_University"
				},
				"name": "Chatham University",
				"salience": 0.0010873103,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0010873103,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/068p2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pittsburgh"
				},
				"name": "Pittsburgh",
				"salience": 0.0010873103,
				"type": "LOCATION"
			},
			{
				"name": "dinner",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "free-loader",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0010111566,
				"type": "OTHER"
			},
			{
				"name": "commodity",
				"salience": 0.000998421,
				"type": "OTHER"
			},
			{
				"name": "workplaces",
				"salience": 0.00081267045,
				"type": "LOCATION"
			},
			{
				"name": "laws",
				"salience": 0.00075543026,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00075543026,
				"type": "PERSON"
			},
			{
				"name": "demand",
				"salience": 0.00075543026,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.00075543026,
				"type": "WORK_OF_ART"
			},
			{
				"name": "supply",
				"salience": 0.00075543026,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00075543026,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0006412662,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00061168754,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0005502124,
				"type": "PERSON"
			},
			{
				"name": "folks",
				"salience": 0.0005502124,
				"type": "PERSON"
			},
			{
				"name": "ground",
				"salience": 0.0005502124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.00043315702,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.00042157527,
				"type": "OTHER"
			},
			{
				"name": "sleeves",
				"salience": 0.0004110169,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0004110169,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775651301.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T18:45:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nDemocratic Vice President Joe Biden wants American women to get back in the workforce to help boost the economy. “If we just put all the women back to work, if they were able to afford childcare, we would increase the GDP in America by close to eight tenths of one percent,” he said. “That’s trillions of dollars over the next decade.” \nBiden made his remarks during a campaign event for Hillary Clinton at Chatham University in Pittsburgh, Pennsylvania on Tuesday. “The state of our economy could be characterized by a single word: pitiful,” he argued. “We’re still battling recession, I don’t care what the official stats are saying, America is still in recession. And we’re not doing anything about it.” \nHe added that it was “lazy American women” who brought about the downfall of the economy, because “they sit around on their behinds, doing nothing and squandering their days away when they could be improving the country that has given so much to them.” “I’m not sure how exactly we got to this point, but we’re here and we need to move. Like, yesterday,” he said. \n“Mark my words and mark them well,” he addressed the crowd. “Hillary Clinton is the only one who can force American women to go to work. This is true because of a number of reasons. First, she’s a woman herself and not just any woman; she’s a self-made woman. So you better believe what she’s saying is true and has been tried and tested in practice plenty of times.” \n“Second, Hillary Clinton understands how difficult it can be to give up the status of a free-loader when your husband is the bread-winner of the household and the wife is expected to tend to the house, the children, make sure dinner is served and always be in the mood for marital duties. She’s been all that and she’s learned how to break free from it, the hard way, I might add,” Biden continued. \n“Today’s women are pampered and aren’t used to rolling up their sleeves and getting the job done on their own,” the vice president said. “They’re too dependent, too weak and too lazy to contribute to the economy. The reason for that is they’ve learned how to manipulate men by employing one of the most fundamental laws of economics: when a sought-after commodity becomes short in supply, the demand for it rises even higher.” \n“Now, that’s all fine and dandy when it comes to their personal interests, but if you look at the big picture, it’s the economy that’s missing out on valuable workforce. And that’s why we need to get them off their lazy behinds and get them into their workplaces. And like I said, Hillary Clinton is the only one who can do it, which is what makes her the ideal candidate for the next President of the United States. We need to heal this country, folks, not run it into the ground even deeper,” Biden concluded.",
		"thread_title": "Biden Blames “Lazy American Women” For The Economy: “They Sit Around Doing Nothing, Only Hillary Can Force Them To Work”",
		"title": "Biden Blames “Lazy American Women” For The Economy: “They Sit Around Doing Nothing, Only Hillary Can Force Them To Work”",
		"type": "conspiracy",
		"uuid": "00bbdb926ee71e47369fd87ed17cd8cd8a39b265"
	},
	"-KhIjRSTqXV1yoeqONko": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:12:36.705+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.25591353,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "DONALD TRUMP",
				"salience": 0.16289939,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.043379556,
				"type": "OTHER"
			},
			{
				"name": "SCHOOLS",
				"salience": 0.037849117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01sj48",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Legion"
				},
				"name": "American Legion",
				"salience": 0.032196794,
				"type": "ORGANIZATION"
			},
			{
				"name": "administration",
				"salience": 0.025716225,
				"type": "OTHER"
			},
			{
				"name": "PATRIOTISM",
				"salience": 0.025716225,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.023620624,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "AMERICAN",
				"salience": 0.023396008,
				"type": "ORGANIZATION"
			},
			{
				"name": "values",
				"salience": 0.02281323,
				"type": "OTHER"
			},
			{
				"name": "PRIDE",
				"salience": 0.022290302,
				"type": "OTHER"
			},
			{
				"name": "GOAL",
				"salience": 0.022290302,
				"type": "OTHER"
			},
			{
				"name": "SCHOOL CURRICULA",
				"salience": 0.022290302,
				"type": "OTHER"
			},
			{
				"name": "CHANGES",
				"salience": 0.022290302,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.014442541,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "REPUBLICAN",
				"salience": 0.013753012,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.009208459,
				"type": "PERSON"
			},
			{
				"name": "convention",
				"salience": 0.009208459,
				"type": "EVENT"
			},
			{
				"name": "institutions",
				"salience": 0.00795218,
				"type": "ORGANIZATION"
			},
			{
				"name": "government intervention",
				"salience": 0.0074593253,
				"type": "EVENT"
			},
			{
				"name": "programs",
				"salience": 0.0074593253,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0074593253,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.00718137,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0067205355,
				"type": "ORGANIZATION"
			},
			{
				"name": "achievements",
				"salience": 0.006219893,
				"type": "OTHER"
			},
			{
				"name": "heroes",
				"salience": 0.006219893,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.006219893,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.006091519,
				"type": "WORK_OF_ART"
			},
			{
				"name": "values",
				"salience": 0.006091519,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.006091519,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01snm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cincinnati"
				},
				"name": "Cincinnati",
				"salience": 0.0056727533,
				"type": "LOCATION"
			},
			{
				"name": "kids",
				"salience": 0.0053429664,
				"type": "PERSON"
			},
			{
				"name": "flag",
				"salience": 0.0052757184,
				"type": "OTHER"
			},
			{
				"name": "principles",
				"salience": 0.0052757184,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0052757184,
				"type": "LOCATION"
			},
			{
				"name": "culture",
				"salience": 0.0052757184,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.004896688,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.0045520356,
				"type": "PERSON"
			},
			{
				"name": "interest groups",
				"salience": 0.0045520356,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign funding",
				"salience": 0.0045520356,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0045520356,
				"type": "OTHER"
			},
			{
				"name": "state money",
				"salience": 0.003942158,
				"type": "OTHER"
			},
			{
				"name": "school board election",
				"salience": 0.003942158,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.0037641213,
				"type": "OTHER"
			},
			{
				"name": "instruction",
				"salience": 0.003672483,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.003672483,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0033160818,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0033160818,
				"type": "OTHER"
			},
			{
				"name": "curriculum",
				"salience": 0.0033160818,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0033160818,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.0033160818,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "Constitution",
				"salience": 0.003248522,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02cl1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Denver"
				},
				"name": "Denver",
				"salience": 0.003248522,
				"type": "LOCATION"
			},
			{
				"name": "direction",
				"salience": 0.0028716493,
				"type": "OTHER"
			},
			{
				"name": "supervision",
				"salience": 0.0028716493,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.0028716493,
				"type": "PERSON"
			},
			{
				"name": "school system",
				"salience": 0.0028716493,
				"type": "ORGANIZATION"
			},
			{
				"name": "school board",
				"salience": 0.0027438342,
				"type": "ORGANIZATION"
			},
			{
				"name": "patriotism",
				"salience": 0.002477486,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.002477486,
				"type": "OTHER"
			},
			{
				"name": "content",
				"salience": 0.002477486,
				"type": "OTHER"
			},
			{
				"name": "proxy war",
				"salience": 0.0021453705,
				"type": "EVENT"
			},
			{
				"name": "board members",
				"salience": 0.0021453705,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0021453705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p03t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jefferson_County,_Colorado"
				},
				"name": "Jefferson County",
				"salience": 0.0015250049,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colorado",
				"salience": 0.0013205208,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "AP",
				"salience": 0.0013205208,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775649831.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T18:43:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nREPUBLICAN PRESIDENTIAL CANDIDATE DONALD TRUMP SIGNALED THURSDAY PLANS TO SEEK NATIONWIDE CHANGES TO SCHOOL CURRICULA WITH THE GOAL OF “PROMOTING AMERICAN PRIDE AND PATRIOTISM IN AMERICA’S SCHOOLS.” \n“In a Trump administration, I plan to work directly with the American Legion to uphold our common values and to help ensure they are taught to America’s children,” Trump said, speaking at the American Legion’s annual convention in Cincinnati. \n“We want our kids to learn the incredible achievements of America’s history, its institutions and its heroes, many of whom are with us today,” he told the veterans group. \nThe comments suggested a federal government intervention in the programs of locally run schools, which is prohibited under federal law“We will stop apologizing for America. And we will start celebrating America. We will be united by our common culture, values and principles, becoming one American nation, one country, under one Constitution, saluting one American flag, and always saluting it,” Trump said. \nLast year a Denver-area school board sought to change the content of the AP U.S. history course because some board members thought it failed to promote patriotism. \nThat sparked a political proxy war in Jefferson County, Colorado, and the 2015 school board election drew nearly $1 million in campaign funding from outside interest groups. \nPublic schools nationwide are funded by their local communities along with some state money. Most schools receive little federal funding. \nCurrent federal law prohibits the federal government from exercising “any direction, supervision, or control over the curriculum, program of instruction, administration, or personnel of any educational institution, school, or school system.”",
		"thread_title": "TRUMP CALLS FOR TEACHING ‘PATRIOTISM’ IN SCHOOLS",
		"title": "TRUMP CALLS FOR TEACHING ‘PATRIOTISM’ IN SCHOOLS",
		"type": "conspiracy",
		"uuid": "e106e7c13d76222c7ff1ef19dee9c7cbf9c9c4ef"
	},
	"-KhIjRbDZpLFWPwnHP6X": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:12:39.004+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05pdb7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rand_Paul"
				},
				"name": "Rand Paul",
				"salience": 0.3193501,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.26560405,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.073729314,
				"type": "OTHER"
			},
			{
				"name": "radio",
				"salience": 0.038163684,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.03559655,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.024425995,
				"type": "OTHER"
			},
			{
				"name": "polling",
				"salience": 0.0241209,
				"type": "OTHER"
			},
			{
				"name": "The Tom Roten Morning Show",
				"salience": 0.02361706,
				"type": "WORK_OF_ART"
			},
			{
				"name": "800 WVHU",
				"salience": 0.02361706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.02067942,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.019992841,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.01875986,
				"type": "ORGANIZATION"
			},
			{
				"name": "lead",
				"salience": 0.015838178,
				"type": "OTHER"
			},
			{
				"name": "election turnout",
				"salience": 0.014805864,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.014805864,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.011122854,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.011039996,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.009616908,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00908653,
				"type": "PERSON"
			},
			{
				"name": "turnout",
				"salience": 0.0068495064,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0054088696,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0051194187,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.004950099,
				"type": "OTHER"
			},
			{
				"name": "rigging",
				"salience": 0.003699095,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775648311.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T18:40:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nWednesday on 800 WVHU radio’s “The Tom Roten Morning Show,” Sen. Rand Paul (R-KY) said polls showing Democratic presidential nominee Hillary Clinton with a lead over Republican presidential nominee Donald Trump were “designed to suppress turnout.” \nPaul said “You know, I think sometimes polling is done to dampen election turnout. So when Trump says the thing’s rigged, I’m not sure exactly what he means and I’m not sure I always agree with him. But I do think that when we say over and over someone can’t win, that is a form of rigging in the sense that it is designed to suppress turnout.” \nHe added, “The polls are put out, you know to make it either look closer than it is or to make it look like Democrats have a better chance. And I think it’s done by design to try to dampen turnout.”",
		"thread_title": "Rand Paul: Polls Showing Hillary Ahead Are ‘Designed To Suppress Turnout’",
		"title": "Rand Paul: Polls Showing Hillary Ahead Are ‘Designed To Suppress Turnout’",
		"type": "conspiracy",
		"uuid": "28791c94be73530074247ac73162a2f0ee4fc4a7"
	},
	"-KhIjRhd3bRuPeF9KXw5": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:12:41.727+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Email",
				"salience": 0.22403878,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.11788148,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media website",
				"salience": 0.11788148,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07kcz17",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Emarat_Al_Youm"
				},
				"name": "Emarat Al-Youm",
				"salience": 0.10574745,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "Emirati",
				"salience": 0.082850695,
				"type": "LOCATION"
			},
			{
				"name": "telephone conversations",
				"salience": 0.03523347,
				"type": "EVENT"
			},
			{
				"name": "press interview",
				"salience": 0.03350595,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contact",
				"salience": 0.03350595,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.032819286,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.030577937,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.028450886,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.021488853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.021488853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.021488853,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.021488853,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.015529514,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.014395714,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.011611697,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01g87g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gulf_Cooperation_Council"
				},
				"name": "Gulf Cooperation Council",
				"salience": 0.010870612,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k3z42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_Secretariat_of_Ukraine"
				},
				"name": "General-Secretariat",
				"salience": 0.009571853,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.009571853,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775621201.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T17:55:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAccording to a report by an Emirati media website, Emarat Al-Youm, Saudi ambassador to the UAE said in a press interview that any contact with Iran, Iraq, Syria, and Lebanon and even making telephone conversations with these countries’ officials by the members of the Gulf Cooperation Council (GCC) states, should first be checked carefully and approved by the General-Secretariat of the organization in Riyadh.",
		"thread_title": "Saudi ambassador to the UAE: Any contact with Iran, Iraq, Syria, and Lebanon should be checked",
		"title": "Saudi ambassador to the UAE: Any contact with Iran, Iraq, Syria, and Lebanon should be checked",
		"type": "conspiracy",
		"uuid": "555aa7ec3d5ac8c4ba79a7e09a1532c2be897d9d"
	},
	"-KhIjRprKhIhuG1gqA5b": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.241+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "election",
				"salience": 0.42028967,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.0770844,
				"type": "PERSON"
			},
			{
				"name": "voter fraud",
				"salience": 0.051936932,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.049614932,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.041652955,
				"type": "OTHER"
			},
			{
				"name": "Morning Consult Poll",
				"salience": 0.037842434,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.037612185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.03463989,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.019023675,
				"type": "ORGANIZATION"
			},
			{
				"name": "warnings",
				"salience": 0.018575002,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.017839251,
				"type": "ORGANIZATION"
			},
			{
				"name": "fraud",
				"salience": 0.014054039,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.012542994,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.008202391,
				"type": "PERSON"
			},
			{
				"name": "doubt",
				"salience": 0.0076836264,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0075026406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.007071511,
				"type": "PERSON"
			},
			{
				"name": "polling places",
				"salience": 0.006225218,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0060930275,
				"type": "PERSON"
			},
			{
				"name": "electoral system",
				"salience": 0.0059934156,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0059934156,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.0059934156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/024v2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Ryan"
				},
				"name": "Paul Ryan",
				"salience": 0.005904375,
				"type": "PERSON"
			},
			{
				"name": "ploy",
				"salience": 0.0057445066,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.005392355,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.005392355,
				"type": "PERSON"
			},
			{
				"name": "locations",
				"salience": 0.005392355,
				"type": "LOCATION"
			},
			{
				"name": "electorate",
				"salience": 0.005379831,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.005191486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0047350693,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.004403837,
				"type": "PERSON"
			},
			{
				"name": "harassment allegations",
				"salience": 0.004403837,
				"type": "OTHER"
			},
			{
				"name": "sexual assault",
				"salience": 0.004403837,
				"type": "EVENT"
			},
			{
				"name": "election system",
				"salience": 0.0038000266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/029dv9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shiromani_Akali_Dal"
				},
				"name": "SAD",
				"salience": 0.0033216302,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0033216302,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.003318569,
				"type": "PERSON"
			},
			{
				"name": "reliability",
				"salience": 0.0032911028,
				"type": "OTHER"
			},
			{
				"name": "running mate",
				"salience": 0.0032911028,
				"type": "PERSON"
			},
			{
				"name": "Crooked Hillary",
				"salience": 0.003212108,
				"type": "PERSON"
			},
			{
				"name": "Morning Consult",
				"salience": 0.0031317533,
				"type": "ORGANIZATION"
			},
			{
				"name": "election results",
				"salience": 0.0027685973,
				"type": "OTHER"
			},
			{
				"name": "accuracy",
				"salience": 0.0023976471,
				"type": "OTHER"
			},
			{
				"name": "error",
				"salience": 0.0023976471,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0022909585,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0022909585,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v1s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indiana"
				},
				"name": "Indiana",
				"salience": 0.0020264813,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0020264813,
				"type": "PERSON"
			},
			{
				"name": "margin",
				"salience": 0.0019329323,
				"type": "OTHER"
			},
			{
				"name": "polling average",
				"salience": 0.0017913796,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0013726817,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wis",
				"salience": 0.0011027227,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dsc8s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RealClearPolitics"
				},
				"name": "RealClearPolitics",
				"salience": 0.0011027227,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477586844donaldtrump_091516getty.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.241+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nThe Politico/Morning Consult Poll finds that 41 percent of voters think widespread voter fraud could cause the GOP nominee to lose the election. Amid Trump's increased warnings about a \"rigged election,\" 73 percent of Republicans think the election could be stolen from him, compared to 17 percent of Democrats. \nOver the past week, Trump has cast doubt on the American electoral system, saying he believes the results will be \"rigged\" at many polling places. \n\"The election is absolutely being rigged by the dishonest and distorted media pushing Crooked Hillary — but also at many polling places — SAD,\" Trump wrote on Twitter Sunday. \nTrump has also encouraged supporters to keep an eye on voting locations to prevent fraud, which some say is a ploy to intimidate voters. \nTrump is trailing Democratic nominee Hillary Clinton in the polls following sexual assault and harassment allegations from multiple women. \nThe Politico/Morning Consult poll showed Clinton leading Trump by 5 points, 46 to 41 percent. \nIn a RealClearPolitics polling average, Clinton leads Trump by 5.5 points, 47.7 to 42.2 percent. \nWhile Speaker Paul Ryan (R-Wis.) and even Trump's running mate, Indiana Gov. Mike Pence, have tried to reassure the electorate about the reliability of the election system, the poll released Monday found 60 percent of Americans think it is necessary to question the accuracy of the election results. \nThe poll was conducted among 1,999 registered voters Oct. 13–15 and has a margin of error of 2 percentage points.",
		"thread_title": "Poll: 41 percent of voters say election could be ‘stolen’",
		"title": "Poll: 41 percent of voters say election could be ‘stolen’",
		"type": "conspiracy",
		"uuid": "0c82664d23d8b034202f527a3007e5ef04c60029"
	},
	"-KhIjRwEkS_13axy0caG": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.286+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.41895562,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.17421354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.06627423,
				"type": "ORGANIZATION"
			},
			{
				"name": "security detail",
				"salience": 0.0452221,
				"type": "OTHER"
			},
			{
				"name": "furniture",
				"salience": 0.040960018,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Email",
				"salience": 0.035608042,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.035608042,
				"type": "LOCATION"
			},
			{
				"name": "member",
				"salience": 0.035608042,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, DC",
				"salience": 0.028768405,
				"type": "LOCATION"
			},
			{
				"name": "agent",
				"salience": 0.024188187,
				"type": "PERSON"
			},
			{
				"name": "staff",
				"salience": 0.0076353126,
				"type": "PERSON"
			},
			{
				"name": "tenure",
				"salience": 0.0076353126,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.0076353126,
				"type": "PERSON"
			},
			{
				"name": "detail",
				"salience": 0.0068507227,
				"type": "OTHER"
			},
			{
				"name": "furniture",
				"salience": 0.0059581054,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "items",
				"salience": 0.005361346,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "residence",
				"salience": 0.0051618773,
				"type": "LOCATION"
			},
			{
				"name": "lamps",
				"salience": 0.0051618773,
				"type": "OTHER"
			},
			{
				"name": "notes",
				"salience": 0.005055532,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.004379535,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview notes",
				"salience": 0.0037795955,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0032738012,
				"type": "OTHER"
			},
			{
				"name": "pages",
				"salience": 0.0032738012,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0032738012,
				"type": "EVENT"
			},
			{
				"name": "handling",
				"salience": 0.0032738012,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0028482554,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0025095039,
				"type": "OTHER"
			},
			{
				"name": "material",
				"salience": 0.0023855458,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0023855458,
				"type": "LOCATION"
			},
			{
				"name": "detail",
				"salience": 0.0022794532,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0017825937,
				"type": "EVENT"
			},
			{
				"name": "term",
				"salience": 0.0017825937,
				"type": "OTHER"
			},
			{
				"name": "accusations",
				"salience": 0.0009105561,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477586625312777.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.286+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nHillary Clinton swiped State Department furniture to decorate her Washington home, a former member of her security detail has alleged to the FBI. \n“Early in Clinton’s tenure as secretary of state, she and her staff were observed removing lamps and furniture from the State Department which were transported to her residence in Washington, DC,” an agent on the detail told the FBI. \nThe agent “does not know whether these items were ever returned to the government,” according to FBI notes. \nThe agent was assigned to Clinton in 2009, at the start of her term, but was not on the detail when Clinton left in 2013. \nThe accusations were part of 100 newly released pages of interview notes of the FBI investigation into Clinton’s handling of classified material. \nThe department flatly denied the latest charges, saying Clinton took home only property that she owned.",
		"thread_title": "Hillary Clinton accused of stealing furniture from the State Department",
		"title": "Hillary Clinton accused of stealing furniture from the State Department",
		"type": "conspiracy",
		"uuid": "28083f173b5654034b0a1940df76213c63dd6409"
	},
	"-KhIjSH-TwIjnUCTx_Bs": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.326+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Rodham Clinton",
				"salience": 0.25195616,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccan",
				"salience": 0.17586489,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01gz4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mohammed_VI_of_Morocco"
				},
				"name": "Mohammed VI",
				"salience": 0.11530635,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.1029357,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg4_d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_Ch%C3%A9rifien_des_Phosphates"
				},
				"name": "OCP",
				"salience": 0.056219507,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.04527355,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.029157342,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03bl8v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stuart_E._Eizenstat"
				},
				"name": "Stuart Eizenstat",
				"salience": 0.012187419,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0y4zr4f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robby_Mook"
				},
				"name": "Robby Mook",
				"salience": 0.01117175,
				"type": "PERSON"
			},
			{
				"name": "participation",
				"salience": 0.009050451,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.008721274,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccans",
				"salience": 0.008275652,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01xcy2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Campaign"
				},
				"name": "HRC",
				"salience": 0.007566823,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0062455544,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.0061732125,
				"type": "WORK_OF_ART"
			},
			{
				"name": "family",
				"salience": 0.005705046,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.005153251,
				"type": "LOCATION"
			},
			{
				"name": "charity",
				"salience": 0.005153251,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.005153251,
				"type": "OTHER"
			},
			{
				"name": "Mohamed Yeslem Beisat",
				"salience": 0.0045343577,
				"type": "PERSON"
			},
			{
				"name": "return",
				"salience": 0.004464604,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0041798325,
				"type": "ORGANIZATION"
			},
			{
				"name": "meeting",
				"salience": 0.0039619682,
				"type": "EVENT"
			},
			{
				"name": "CGI",
				"salience": 0.00355932,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0031594064,
				"type": "WORK_OF_ART"
			},
			{
				"name": "funds",
				"salience": 0.003133285,
				"type": "OTHER"
			},
			{
				"name": "boss",
				"salience": 0.0031142805,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fs44",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rabat"
				},
				"name": "Rabat",
				"salience": 0.0030637602,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.003011713,
				"type": "ORGANIZATION"
			},
			{
				"name": "communications",
				"salience": 0.0029192325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0027513711,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05g2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Africa"
				},
				"name": "North African",
				"salience": 0.0027004054,
				"type": "LOCATION"
			},
			{
				"name": "endowment",
				"salience": 0.0026362767,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0026131228,
				"type": "WORK_OF_ART"
			},
			{
				"name": "officials",
				"salience": 0.0023371656,
				"type": "PERSON"
			},
			{
				"name": "batch",
				"salience": 0.0022833266,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0018373298,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0016649625,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.001623669,
				"type": "ORGANIZATION"
			},
			{
				"name": "King",
				"salience": 0.0015382455,
				"type": "PERSON"
			},
			{
				"name": "mess",
				"salience": 0.0015318528,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0015292438,
				"type": "LOCATION"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0013889878,
				"type": "PERSON"
			},
			{
				"name": "Secretary of State",
				"salience": 0.0013889878,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.001292246,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.0012283707,
				"type": "EVENT"
			},
			{
				"name": "human rights violations",
				"salience": 0.0012028564,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0011966507,
				"type": "OTHER"
			},
			{
				"name": "mining company",
				"salience": 0.0011727493,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lukas Lundin",
				"salience": 0.0011699046,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0011240847,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0010731812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/042kg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmy_Carter"
				},
				"name": "Carter",
				"salience": 0.0010042369,
				"type": "PERSON"
			},
			{
				"name": "condition",
				"salience": 0.00096901204,
				"type": "OTHER"
			},
			{
				"name": "arrangement",
				"salience": 0.0009525336,
				"type": "OTHER"
			},
			{
				"name": "hotel",
				"salience": 0.00094053487,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.00094053487,
				"type": "LOCATION"
			},
			{
				"name": "tenure",
				"salience": 0.00094053487,
				"type": "EVENT"
			},
			{
				"name": "office",
				"salience": 0.0008980413,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.00087892904,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0008654027,
				"type": "LOCATION"
			},
			{
				"name": "human rights violations",
				"salience": 0.00084347225,
				"type": "OTHER"
			},
			{
				"name": "non-starter",
				"salience": 0.00083911937,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.0008078036,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.00078821986,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.00077828957,
				"type": "EVENT"
			},
			{
				"name": "contribution",
				"salience": 0.0007615856,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0007615856,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.0007615856,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.0007453755,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0007398029,
				"type": "EVENT"
			},
			{
				"name": "issues",
				"salience": 0.0007344132,
				"type": "OTHER"
			},
			{
				"name": "web site.",
				"salience": 0.0007331615,
				"type": "PERSON"
			},
			{
				"name": "endowment",
				"salience": 0.0007331615,
				"type": "OTHER"
			},
			{
				"name": "loan guarantee",
				"salience": 0.0007116113,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.0006937927,
				"type": "OTHER"
			},
			{
				"name": "beneficiary",
				"salience": 0.0006624407,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0006594821,
				"type": "PERSON"
			},
			{
				"name": "Justice",
				"salience": 0.0006594821,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0006594821,
				"type": "EVENT"
			},
			{
				"name": "context",
				"salience": 0.00065409415,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0006348667,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0006348667,
				"type": "OTHER"
			},
			{
				"name": "mines phosphates",
				"salience": 0.0006217457,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0006217457,
				"type": "OTHER"
			},
			{
				"name": "occupation",
				"salience": 0.0006217457,
				"type": "OTHER"
			},
			{
				"name": "beneficiary",
				"salience": 0.0006217457,
				"type": "OTHER"
			},
			{
				"name": "news site",
				"salience": 0.0006217457,
				"type": "LOCATION"
			},
			{
				"name": "Polisaro",
				"salience": 0.0006141612,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06t2t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Singapore"
				},
				"name": "Singapore",
				"salience": 0.0005789496,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/054rw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marrakesh"
				},
				"name": "Marrakesh",
				"salience": 0.0005789496,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03h64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hong_Kong"
				},
				"name": "Hong Kong",
				"salience": 0.0005789496,
				"type": "LOCATION"
			},
			{
				"name": "Import Bank",
				"salience": 0.0005789496,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01sr3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Export"
				},
				"name": "Export",
				"salience": 0.0005789496,
				"type": "OTHER"
			},
			{
				"name": "Robert F. Kennedy Center",
				"salience": 0.00057165447,
				"type": "PERSON"
			},
			{
				"name": "operations",
				"salience": 0.0005441512,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0005383816,
				"type": "EVENT"
			},
			{
				"name": "detainees",
				"salience": 0.0005383816,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0005383816,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0005383816,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0005383816,
				"type": "PERSON"
			},
			{
				"name": "misery",
				"salience": 0.0005383816,
				"type": "OTHER"
			},
			{
				"name": "mining firm",
				"salience": 0.00051440875,
				"type": "ORGANIZATION"
			},
			{
				"name": "government-in-exile",
				"salience": 0.00051404943,
				"type": "ORGANIZATION"
			},
			{
				"name": "trade",
				"salience": 0.00046445586,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.00046445586,
				"type": "PERSON"
			},
			{
				"name": "chances",
				"salience": 0.00043397167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0004059093,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00040553472,
				"type": "EVENT"
			},
			{
				"name": "occasions",
				"salience": 0.00040217405,
				"type": "EVENT"
			},
			{
				"name": "insider",
				"salience": 0.00040217405,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j770",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Commerce"
				},
				"name": "Department of Commerce",
				"salience": 0.00037643855,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00037643855,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.00037463973,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.00037463973,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cq0r_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Undersecretary"
				},
				"name": "Under Secretary",
				"salience": 0.00036563608,
				"type": "PERSON"
			},
			{
				"name": "bid",
				"salience": 0.0003542691,
				"type": "OTHER"
			},
			{
				"name": "mining",
				"salience": 0.0003413774,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.00033825554,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00033825554,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.00033825554,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00033825554,
				"type": "LOCATION"
			},
			{
				"name": "Polisaro Front",
				"salience": 0.00033135916,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jt3p8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Monitor"
				},
				"name": "AL-Monitor",
				"salience": 0.00033135916,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00033135916,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b9f13",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tindouf"
				},
				"name": "Tindouf",
				"salience": 0.00033135916,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Algeria"
				},
				"name": "Algeria",
				"salience": 0.00033135916,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/082qk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Sahara"
				},
				"name": "Western Sahara",
				"salience": 0.00033135916,
				"type": "LOCATION"
			},
			{
				"name": "law firm",
				"salience": 0.0003300136,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.00031660206,
				"type": "ORGANIZATION"
			},
			{
				"name": "Human rights",
				"salience": 0.00030292806,
				"type": "OTHER"
			},
			{
				"name": "mining company",
				"salience": 0.00029817063,
				"type": "ORGANIZATION"
			},
			{
				"name": "Moroccan King",
				"salience": 0.00029492486,
				"type": "ORGANIZATION"
			},
			{
				"name": "conference",
				"salience": 0.0002928925,
				"type": "EVENT"
			},
			{
				"name": "lot",
				"salience": 0.0002928925,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0002928925,
				"type": "OTHER"
			},
			{
				"name": "campaign executives",
				"salience": 0.0002928925,
				"type": "PERSON"
			},
			{
				"name": "china",
				"salience": 0.0002928925,
				"type": "OTHER"
			},
			{
				"name": "esteem",
				"salience": 0.0002928925,
				"type": "OTHER"
			},
			{
				"name": "launch",
				"salience": 0.0002928925,
				"type": "EVENT"
			},
			{
				"name": "daughter",
				"salience": 0.0002928925,
				"type": "PERSON"
			},
			{
				"name": "guests",
				"salience": 0.0002928925,
				"type": "PERSON"
			},
			{
				"name": "palaces",
				"salience": 0.0002928925,
				"type": "LOCATION"
			},
			{
				"name": "mining product",
				"salience": 0.000289201,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01fzbj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International_Trade_Administration"
				},
				"name": "International Trade Administration",
				"salience": 0.000285853,
				"type": "ORGANIZATION"
			},
			{
				"name": "Moroccan World News",
				"salience": 0.0002822502,
				"type": "ORGANIZATION"
			},
			{
				"name": "human rights violations",
				"salience": 0.00027984811,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.00027840323,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0002526679,
				"type": "PERSON"
			},
			{
				"name": "RELATED",
				"salience": 0.0002526679,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.0002526679,
				"type": "ORGANIZATION"
			},
			{
				"name": "oil drilling operations",
				"salience": 0.0002526679,
				"type": "EVENT"
			},
			{
				"name": "blood phosphates",
				"salience": 0.0002526679,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0002526679,
				"type": "PERSON"
			},
			{
				"name": "blood diamonds",
				"salience": 0.00025153905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00024751615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f1r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_the_Treasury"
				},
				"name": "Treasury",
				"salience": 0.00024751615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.00024751615,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.00024751615,
				"type": "LOCATION"
			},
			{
				"name": "critics",
				"salience": 0.00022440204,
				"type": "PERSON"
			},
			{
				"name": "fees",
				"salience": 0.0002187808,
				"type": "OTHER"
			},
			{
				"name": "lobbying giants",
				"salience": 0.0002187808,
				"type": "ORGANIZATION"
			},
			{
				"name": "term",
				"salience": 0.0002187808,
				"type": "OTHER"
			},
			{
				"name": "gems",
				"salience": 0.0002187808,
				"type": "OTHER"
			},
			{
				"name": "pledge",
				"salience": 0.0002187808,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00020705206,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chwz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Clinton"
				},
				"name": "Chelsea",
				"salience": 0.00018025289,
				"type": "PERSON"
			},
			{
				"name": "Blood Minerals' Firm",
				"salience": 0.00017222433,
				"type": "ORGANIZATION"
			},
			{
				"name": "friendship",
				"salience": 0.00015337611,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Republic_of_the_Congo"
				},
				"name": "Congo",
				"salience": 0.00013463956,
				"type": "LOCATION"
			},
			{
				"name": "Clinton Foundation Got $100M From",
				"salience": 0.00013463956,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cltzt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Covington_%26_Burling"
				},
				"name": "Covington & Burling",
				"salience": 0.00013463956,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477586403hillary-clinton-wikileaks-morocco.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.326+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nFormer Secretary of State Hillary Clinton arranged a $12 million donation from Moroccan King Mohammed VI to her family’s charity in 2014 in return for the Clinton Global Initiative hosting its international meeting in the North African Muslim nation, according to an email made public Thursday by Wikileaks. \nThe Moroccan monarch’s funds went to the Clinton Foundation’s endowment and to CGI. The Jan. 18, 2015, email was included in Wikileaks’ latest batch of communications to and from Clinton’s presidential campaign chairman, John Podesta. \nThe email from Huma Abedin, Clinton’s Deputy Chief of Staff at the State Department, was addressed to Podesta and campaign manager Robby Mook. Hillary Clinton was a director of the foundation at the time. \nSingapore and Hong Kong officials reportedly were also vying to convene the CGI meeting in their countries, but the North African nation ultimately hosted it in a five-star hotel in Marrakesh, Morocco, in 2015. Abedin told Podesta and Mook that Morocco was not CGI’s “first choice.” \nThe actual meeting was paid for by OCP, the Moroccan-government-owned mining company that has been accused of serious human rights violations. Clinton vigorously supported the Moroccan King when she was Secretary of State and the U.S.-financed Export-Import Bank gave OCP a $92 million loan guarantee during her tenure as Secretary of State. \nThe mining company also contributed between $5 million to $10 million to the Clinton Foundation, according to the charity’s web site.Abedin described the arrangement in the email as having been organized by her boss. Hillary Clinton “created this mess and she knows it,” she told Podesta and Mook.She said the Moroccan deal was entirely dreamed up by her boss. “This was HRC’s idea, our office approached the Moroccans and they 100 percent believe they are doing this at her request. The King has personally committed approx. $12 million both for the endowment and to support the meeting.” HRC stands for Hillary Rodham Clinton. \nAbedin said Clinton’s attendance at the CGI event was a condition of the $12 million contribution. “Just to give you some context, the condition upon which the Moroccans agreed to host the meeting was her participation. If hrc was not part if it, meeting was a non-starter,” Abedin said. \nPolitico in 2015 reported that Clinton “was seen by Rabat as among its most ardent supporters in the Obama administration.” Rabat is the capital of Morocco. \nThe Robert F. Kennedy Center for Justice charged OCP with “serious human rights violations,” including exploitation of workers by not “adequately compensating the impoverished people who live there.” \nMohamed Yeslem Beisat, the Washington envoy for the Polisaro Front, as reported by AL-Monitor, a Middle East news site in 2015 that “OCP is the first beneficiary of the war and the first beneficiary of the occupation — it is the one that is cashing in on the misery of thousands of refugees and hundreds of political detainees for the past 40 years.” \nPolisaro claims to lead a Moroccan government-in-exile based in Tindouf, Algeria. \n“They’re doing this because they know Hillary has some chances of being president of the United States. And they want her to support their brutal occupation of Western Sahara,” Beisat charged. \nThe Moroccan firm mines phosphates. Human rights critics have called OCP’s mining product “blood phosphates,” appropriating the term “blood diamonds” for gems mined in operations that kill and injure local workers \nOCP is not the only mining company linked to human rights violations that has donated to the Clinton Foundation. The foundation accepted a $100 million pledge from Lukas Lundin, who owns mining and oil drilling operations in North Africa and in the Congo. (RELATED: Clinton Foundation Got $100M From ‘Blood Minerals’ Firm) \nOCP retained the law firm of Covington & Burling, one of Washington’s lobbying giants, paying the firm $1.4 million in fees from 2012 to 2015. \nStuart Eizenstat, a former White House domestic policy chief under President Carter and an influential Democratic Party insider, was the main lobbyist for the mining firm. He was also President Bill Clinton’s ambassador to the European Union, a Deputy Secretary of the Treasury and Under Secretary at the Department of Commerce. \nEizenstat specialized in foreign trade issues at Commerce where he worked in the International Trade Administration. \nHillary Clinton officially visited Morocco twice, in November 2009 and in February 2012, meeting with the King on both occasions. The two also met in New York in December 2013 where it was believed the two discussed Morocco’s bid to host the CGI meeting and the King’s $12 million donation. \nThe Moroccan World News described the meeting as showing “renewed friendship between the royal family and the Clinton family, as well as Hillary Clinton’s esteem for Morocco and its people.” \nAbedin warned both campaign executives that if CGI decided to renege on the agreement, it would hurt Clinton’s relationship with the King. “It will break a lot of china to back out now,” she wrote. \nUltimately, Clinton did not attend the meeting because it was close to the launch of her presidential campaign, but the former president and daughter Chelsea were present and during the conference were guests at one of the Moroccan King’s palaces.",
		"thread_title": "WIKILEAKS: Hillary Got $12 Million for Clinton Charity As Quid Pro Quo For Morocco Meeting",
		"title": "WIKILEAKS: Hillary Got $12 Million for Clinton Charity As Quid Pro Quo For Morocco Meeting",
		"type": "conspiracy",
		"uuid": "fef154fb0c6317022ca4132d2325797172a11398"
	},
	"-KhIjS_gXBxgl9K-IG6W": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.443+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.28748176,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.26863176,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.09665643,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.06124896,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.027844895,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.014734663,
				"type": "LOCATION"
			},
			{
				"name": "policies",
				"salience": 0.013944273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.01152384,
				"type": "ORGANIZATION"
			},
			{
				"name": "confrontation",
				"salience": 0.011034825,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.011034825,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.010015117,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.009969618,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.008998154,
				"type": "PERSON"
			},
			{
				"name": "nominee",
				"salience": 0.008639601,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.007804456,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War III",
				"salience": 0.0075845295,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0072746943,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.006762041,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0052612354,
				"type": "LOCATION"
			},
			{
				"name": "order",
				"salience": 0.0034591462,
				"type": "OTHER"
			},
			{
				"name": "rapprochement",
				"salience": 0.0034591462,
				"type": "EVENT"
			},
			{
				"name": "resort",
				"salience": 0.0034591462,
				"type": "LOCATION"
			},
			{
				"name": "presidents",
				"salience": 0.0031585002,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.0028533612,
				"type": "ORGANIZATION"
			},
			{
				"name": "zones",
				"salience": 0.0025793263,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0024941058,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.0022343376,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0021784347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0021719362,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rnbt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Doral,_Florida"
				},
				"name": "Doral",
				"salience": 0.0021304337,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0021304337,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0020707843,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.00206395,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0019935477,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0019726562,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0019726562,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.0018224985,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0016781257,
				"type": "OTHER"
			},
			{
				"name": "battleground state polls",
				"salience": 0.0016456355,
				"type": "OTHER"
			},
			{
				"name": "posture",
				"salience": 0.0016456355,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0016344782,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0015734988,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.0015410038,
				"type": "PERSON"
			},
			{
				"name": "conflict",
				"salience": 0.0015147923,
				"type": "EVENT"
			},
			{
				"name": "nukes",
				"salience": 0.0014432644,
				"type": "LOCATION"
			},
			{
				"name": "remarks",
				"salience": 0.0014432644,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.001425086,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.001425086,
				"type": "ORGANIZATION"
			},
			{
				"name": "no-fly zone",
				"salience": 0.0013487397,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0013344564,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0013193523,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.001278032,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.001278032,
				"type": "OTHER"
			},
			{
				"name": "Biden Trump",
				"salience": 0.0012429808,
				"type": "PERSON"
			},
			{
				"name": "no-fly zone",
				"salience": 0.0012186676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0011708258,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0011539676,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.001145699,
				"type": "ORGANIZATION"
			},
			{
				"name": "rebels",
				"salience": 0.0011109024,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0011109024,
				"type": "ORGANIZATION"
			},
			{
				"name": "civilians",
				"salience": 0.0011109024,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.0011109024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0010841391,
				"type": "ORGANIZATION"
			},
			{
				"name": "purpose",
				"salience": 0.0010512546,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0010130723,
				"type": "EVENT"
			},
			{
				"name": "others",
				"salience": 0.00099927,
				"type": "PERSON"
			},
			{
				"name": "concerns",
				"salience": 0.00099927,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00099927,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00099927,
				"type": "OTHER"
			},
			{
				"name": "airspace",
				"salience": 0.00099927,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.00096696534,
				"type": "EVENT"
			},
			{
				"name": "strategy",
				"salience": 0.0009619746,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.0009619746,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0009619746,
				"type": "PERSON"
			},
			{
				"name": "regime",
				"salience": 0.0009619746,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.0009619746,
				"type": "EVENT"
			},
			{
				"name": "ground",
				"salience": 0.00094209454,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00094209454,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00094209454,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.00094209454,
				"type": "EVENT"
			},
			{
				"name": "jet",
				"salience": 0.00093788706,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.00093788706,
				"type": "PERSON"
			},
			{
				"name": "civil war",
				"salience": 0.00089895335,
				"type": "EVENT"
			},
			{
				"name": "Most",
				"salience": 0.0008674263,
				"type": "PERSON"
			},
			{
				"name": "count",
				"salience": 0.00084372936,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0008367387,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00082452723,
				"type": "ORGANIZATION"
			},
			{
				"name": "fight",
				"salience": 0.0008157854,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0008157854,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.0008157854,
				"type": "OTHER"
			},
			{
				"name": "negotiation",
				"salience": 0.0008157854,
				"type": "EVENT"
			},
			{
				"name": "Jesse Lehrich",
				"salience": 0.00072017725,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.00071862823,
				"type": "ORGANIZATION"
			},
			{
				"name": "Poll",
				"salience": 0.0007037749,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00065559655,
				"type": "PERSON"
			},
			{
				"name": "complaint",
				"salience": 0.00061995257,
				"type": "OTHER"
			},
			{
				"name": "puppet",
				"salience": 0.0006094056,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0006094056,
				"type": "EVENT"
			},
			{
				"name": "suffering",
				"salience": 0.0006094056,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0006094056,
				"type": "OTHER"
			},
			{
				"name": "enactment",
				"salience": 0.0006094056,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0005792624,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0005676851,
				"type": "EVENT"
			},
			{
				"name": "conflict",
				"salience": 0.0005424051,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0005194598,
				"type": "OTHER"
			},
			{
				"name": "administration post",
				"salience": 0.0005125549,
				"type": "WORK_OF_ART"
			},
			{
				"name": "complaints",
				"salience": 0.0005125549,
				"type": "OTHER"
			},
			{
				"name": "unity",
				"salience": 0.0005125549,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0005125549,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.00044381907,
				"type": "PERSON"
			},
			{
				"name": "agenda",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "departure",
				"salience": 0.00044381907,
				"type": "EVENT"
			},
			{
				"name": "majorities",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "cabinet",
				"salience": 0.00044381907,
				"type": "EVENT"
			},
			{
				"name": "lack",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.00044381907,
				"type": "OTHER"
			},
			{
				"name": "party unity",
				"salience": 0.00038286857,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00033152057,
				"type": "EVENT"
			},
			{
				"name": "rhetoric",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "aisle",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "commander-in-chief",
				"salience": 0.00033152057,
				"type": "PERSON"
			},
			{
				"name": "talking points",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.00033152057,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.0002970821,
				"type": "PERSON"
			},
			{
				"name": "plans",
				"salience": 0.00027062616,
				"type": "OTHER"
			},
			{
				"name": "security experts",
				"salience": 0.00026384686,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00020402248,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477586227636130853168961052.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.443+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email Donald Trump warned in an interview Tuesday that Hillary Clinton's policies as president to address the Syrian conflict would lead to World War III, arguing the Democratic nominee would draw the US into armed confrontation with Russia, Syria and Iran. \"What we should do is focus on ISIS. We should not be focusing on Syria,\" Trump told Reuters on Tuesday morning at his resort in Doral, Florida. \"You're going to end up in World War III over Syria if we listen to Hillary Clinton.\" The Republican nominee, who has called for a rapprochement with Russia in order to jointly combat ISIS, argued that his Democratic rival's calls for taking a more aggressive posture in Syria to bring the conflict there to an end and combat ISIS will only draw the US into a larger war. Trump's remarks come as he trails Clinton in most national and key battleground state polls just two weeks from Election Day. \"You're not fighting Syria anymore, you're fighting Syria, Russia and Iran, all right? Russia is a nuclear country, but a country where the nukes work as opposed to other countries that talk,\" he said. Trump: I'd 'love' to fight Biden Trump has not laid out a clear strategy for combating ISIS or addressing the globally destabilizing conflict in Syria, which has killed hundreds of thousands and pushed millions more to flee their homes. He has suggested the US should allow ISIS, anti-government rebels and the Syrian government to fight it out and more recently has focused on joining forces with Russia -- which has aided the Syrian regime in the bombing of civilians and US-allied rebels -- to combat ISIS. \"Assad is secondary, to me, to ISIS,\" Trump told Reuters of the Syrian President Bashar al-Assad, whom US officials have argued must step down. Clinton has called for establishing a no-fly zone over Syria to help bring the five-year civil war to an end, a proposal top Republicans in Congress have championed, which President Barack Obama and others have opposed due to the risk of entering into conflict with Russia. A US-enforced no-fly zone would mean the US could shoot down a Russian jet should it enter Syrian airspace. Clinton addressed those concerns in the final presidential debate, arguing that it would \"save lives and hasten the end of the conflict,\" while cautioning that \"this would not be done just on the first day.\" \"This would take a lot of negotiation and it would also take making it clear to the Russians and the Syrians that our purpose is to provide safe zones on the ground,\" Clinton said during the debate earlier this month. \"I think we could strike a deal and make it very clear to the Russians and Syrians that this was something that we believe the best interests of the people on the ground in Syria. It would help us in the fight against ISIS.\" Trump has additionally called for establishing safe zones in Syria to protect civilians -- as has Clinton -- which could also put the US in conflict with the Syrian government or Russia should they oppose the policy. The Clinton campaign later Tuesday pushed back against Trump's rhetoric. \"National security experts on both sides of the aisle have denounced Donald Trump as dangerously ill-prepared and temperamentally unfit to serve as commander-in-chief,\" Clinton spokesman Jesse Lehrich said. \"Once again, he is parroting Putin's talking points and playing to Americans' fears, all while refusing to lay out any plans of his own for defeating ISIS or alleviating humanitarian suffering in Syria. Moreover, this incendiary attack is aimed at a policy that his own running mate, Mike Pence, strongly supports.\" Poll: Most see a Hillary Clinton victory and a fair count ahead While Clinton has accused Trump of being Putin's \"puppet,\" Trump knocked Clinton for her criticism of the Russian strongman, asking, \"How she is going to go back and negotiate with this man who she has made to be so evil.\" And just two days after he tied the successful enactment of his agenda as president to the election of Republican majorities in Congress, Trump also returned to his more typical complaints of a lack of Republican unity weighing down his candidacy. \"If we had party unity, we couldn't lose this election to Hillary Clinton,\" he told Reuters. That complaint didn't put Trump in more of a bipartisan mood, though, as the Republican nominee also told Reuters he would not consider putting any Democrats in his cabinet -- a departure from recent presidents, who have sought to post at least one member of their rival party in a top administration post.",
		"thread_title": "Trump warns of World War III if Clinton is elected",
		"title": "Trump warns of World War III if Clinton is elected",
		"type": "conspiracy",
		"uuid": "62a33ca2aa94dede5212714fd0d31ffb3ee089e1"
	},
	"-KhIjSkuIabVjsUzbz9U": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.461+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.19294176,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.16610187,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.09660972,
				"type": "EVENT"
			},
			{
				"name": "results",
				"salience": 0.08756466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Sunshine State",
				"salience": 0.06670063,
				"type": "LOCATION"
			},
			{
				"name": "democracy",
				"salience": 0.045114283,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.04267134,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.03282671,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.028475167,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/085srz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patrick_Murphy_(Pennsylvania_politician)"
				},
				"name": "Patrick Murphy",
				"salience": 0.022163345,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.017176816,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.014620342,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.013216989,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.011634435,
				"type": "PERSON"
			},
			{
				"name": "adversaries",
				"salience": 0.0087659275,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0077170427,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0077170427,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dpr5f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marco_Rubio"
				},
				"name": "Marco Rubio",
				"salience": 0.0076025953,
				"type": "PERSON"
			},
			{
				"name": "seeds",
				"salience": 0.007026803,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.006036957,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.006036957,
				"type": "EVENT"
			},
			{
				"name": "mind",
				"salience": 0.006036957,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.006036957,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0054148976,
				"type": "PERSON"
			},
			{
				"name": "vote matters",
				"salience": 0.0048899283,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0048284056,
				"type": "PERSON"
			},
			{
				"name": "advantage",
				"salience": 0.0043437732,
				"type": "OTHER"
			},
			{
				"name": "fear-mongering",
				"salience": 0.004235133,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.004235133,
				"type": "OTHER"
			},
			{
				"name": "seats",
				"salience": 0.004235133,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.004077237,
				"type": "EVENT"
			},
			{
				"name": "crowd",
				"salience": 0.004077237,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.004077237,
				"type": "OTHER"
			},
			{
				"name": "rigging",
				"salience": 0.0038270291,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0037185028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04dvzs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami_Gardens,_Florida"
				},
				"name": "Miami Gardens",
				"salience": 0.0037185028,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.0037185028,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0034581947,
				"type": "OTHER"
			},
			{
				"name": "suspense",
				"salience": 0.0034581947,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0033292247,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0029837457,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0029837457,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.0028053431,
				"type": "WORK_OF_ART"
			},
			{
				"name": "candidate",
				"salience": 0.002583928,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shjm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida_Memorial_University"
				},
				"name": "Florida Memorial University",
				"salience": 0.0025106163,
				"type": "ORGANIZATION"
			},
			{
				"name": "credit",
				"salience": 0.0022193606,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0018821774,
				"type": "OTHER"
			},
			{
				"name": "ads",
				"salience": 0.0018821774,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0016039999,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.0014061116,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0014061116,
				"type": "EVENT"
			},
			{
				"name": "wins",
				"salience": 0.0014061116,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03j740",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Senatorial_Campaign_Committee"
				},
				"name": "Democratic Senatorial Campaign Committee",
				"salience": 0.0011585723,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0009994906,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.00086546486,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00086546486,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/147758603457348262.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.461+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email President Barack Obama admonished Donald Trump Thursday, saying the Republican nominee's claims that he might not accept the results of next month's election are \"not a joking matter.\" \"I want everybody to pay attention here. This is dangerous,\" Obama said at a Hillary for America event in Miami Gardens, Florida. \"Because when you try to sow the seeds of doubt in people's mind about the legitimacy of our elections, that undermines our democracy. Then you are doing the work of our adversaries for them.\" Obama also encouraged the crowd of about 1,800 at Florida Memorial University to take advantage of Florida's early voting, telling the audience in doing so they can reject what the President called Trump's \"dark, pessimistic fear-mongering.\" \"Our democracy depends on people knowing that their vote matters. That those who occupy the seats of power were chosen by the people,\" Obama said. On Wednesday night's debate Trump, answered, \"I will look at it at the time,\" when asked whether he would concede if he loses on November 8. \"I will keep you in suspense.\" Trump also doubled down on Thursday in Ohio saying he will accept the results of next month's election as long as wins. Obama also used the opportunity while in Florida to weigh in on the close Senate race in Florida between Republican Sen. Marco Rubio and his Democratic challenger, Rep. Patrick Murphy. \"Even Marco Rubio says there's no rigging of the vote,\" Obama said, \"Which I'd like to give credit for, except he's refuting the dangerous, unprecedented claims of a candidate he says he's still going to vote for!\" Earlier this week, Obama released a new ad for the Democrat in the Sunshine State, the same week it was announced the Democratic Senatorial Campaign Committee was puling money for ads for Murphy.",
		"thread_title": "Obama slams Trump's 'rigged' election claims as 'dangerous'",
		"title": "Obama slams Trump's 'rigged' election claims as 'dangerous'",
		"type": "conspiracy",
		"uuid": "ed1323acb7d26a94f1b424ed5980045a4f5c0148"
	},
	"-KhIjT9IB9Iu1wTwwFaL": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.563+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.27943295,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.09046295,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.07646596,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024p7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeff_Flake"
				},
				"name": "Jeff Flake",
				"salience": 0.03470368,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0170zz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_E._Sununu"
				},
				"name": "John E. Sununu",
				"salience": 0.0322487,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.027751269,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0269qk3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allen_Raymond"
				},
				"name": "Allen Raymond",
				"salience": 0.027504688,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.016734019,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.016734019,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0128251305,
				"type": "PERSON"
			},
			{
				"name": "voting base",
				"salience": 0.012104808,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.011032167,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03nr8j6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jon_A._Husted"
				},
				"name": "Jon Husted",
				"salience": 0.0097223725,
				"type": "PERSON"
			},
			{
				"name": "integrity",
				"salience": 0.0085673435,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01v054",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sean_Hannity"
				},
				"name": "Sean Hannity",
				"salience": 0.008520929,
				"type": "PERSON"
			},
			{
				"name": "talk",
				"salience": 0.008180153,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.008022851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.008006806,
				"type": "LOCATION"
			},
			{
				"name": "process",
				"salience": 0.0071492083,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0071492083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rrm2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeanne_Shaheen"
				},
				"name": "Jeanne Shaheen",
				"salience": 0.0067854505,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0067521986,
				"type": "EVENT"
			},
			{
				"name": "Critics",
				"salience": 0.0063510844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.0063446835,
				"type": "ORGANIZATION"
			},
			{
				"name": "volunteers",
				"salience": 0.0061923116,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0061923116,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0061923116,
				"type": "OTHER"
			},
			{
				"name": "tens of thousands",
				"salience": 0.0061923116,
				"type": "PERSON"
			},
			{
				"name": "myth",
				"salience": 0.006157279,
				"type": "OTHER"
			},
			{
				"name": "Elections",
				"salience": 0.005874526,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.005874526,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00548313,
				"type": "PERSON"
			},
			{
				"name": "claims",
				"salience": 0.005363869,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0xs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/U.S._state"
				},
				"name": "States",
				"salience": 0.00534549,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.004120678,
				"type": "EVENT"
			},
			{
				"name": "Election",
				"salience": 0.004120678,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.004120678,
				"type": "EVENT"
			},
			{
				"name": "elections",
				"salience": 0.004120678,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.003967007,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.003967007,
				"type": "EVENT"
			},
			{
				"name": "primary",
				"salience": 0.003901251,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0038137604,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.003645601,
				"type": "PERSON"
			},
			{
				"name": "actor",
				"salience": 0.0036142233,
				"type": "PERSON"
			},
			{
				"name": "claims",
				"salience": 0.003531319,
				"type": "OTHER"
			},
			{
				"name": "battleground state",
				"salience": 0.003531319,
				"type": "LOCATION"
			},
			{
				"name": "operative",
				"salience": 0.0033889324,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0033645595,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0033645595,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.0032625182,
				"type": "OTHER"
			},
			{
				"name": "election official",
				"salience": 0.0032625182,
				"type": "PERSON"
			},
			{
				"name": "precincts",
				"salience": 0.0031439776,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0029865003,
				"type": "ORGANIZATION"
			},
			{
				"name": "idea",
				"salience": 0.0027490393,
				"type": "OTHER"
			},
			{
				"name": "insistence",
				"salience": 0.0026283313,
				"type": "OTHER"
			},
			{
				"name": "dive",
				"salience": 0.0025510986,
				"type": "OTHER"
			},
			{
				"name": "polls numbers",
				"salience": 0.0025510986,
				"type": "OTHER"
			},
			{
				"name": "plunge",
				"salience": 0.0025510986,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.002442092,
				"type": "LOCATION"
			},
			{
				"name": "votes",
				"salience": 0.0023888599,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.0023840165,
				"type": "OTHER"
			},
			{
				"name": "complaint",
				"salience": 0.002348962,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.002305083,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0022878528,
				"type": "LOCATION"
			},
			{
				"name": "Operative",
				"salience": 0.0022878528,
				"type": "ORGANIZATION"
			},
			{
				"name": "attempt",
				"salience": 0.0022878528,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02p7ntz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire_Senate"
				},
				"name": "New Hampshire Senate",
				"salience": 0.002213049,
				"type": "ORGANIZATION"
			},
			{
				"name": "election phone",
				"salience": 0.0022024787,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0021569703,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0021569703,
				"type": "EVENT"
			},
			{
				"name": "voting",
				"salience": 0.0021569703,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.002065761,
				"type": "PERSON"
			},
			{
				"name": "fraud",
				"salience": 0.0020217958,
				"type": "OTHER"
			},
			{
				"name": "voter-identification laws",
				"salience": 0.0020217958,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0019920638,
				"type": "ORGANIZATION"
			},
			{
				"name": "laws",
				"salience": 0.0019218231,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0018678221,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0018310192,
				"type": "EVENT"
			},
			{
				"name": "fall election",
				"salience": 0.0018310192,
				"type": "EVENT"
			},
			{
				"name": "primary election",
				"salience": 0.0018310192,
				"type": "EVENT"
			},
			{
				"name": "assertion",
				"salience": 0.0018116564,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "phone lines",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "rigging",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "Confessions",
				"salience": 0.0017888318,
				"type": "OTHER"
			},
			{
				"name": "election loss",
				"salience": 0.0017220681,
				"type": "EVENT"
			},
			{
				"name": "scandal",
				"salience": 0.0017220681,
				"type": "EVENT"
			},
			{
				"name": "billionaire",
				"salience": 0.0016864801,
				"type": "PERSON"
			},
			{
				"name": "prison sentence",
				"salience": 0.0016162832,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0016162832,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.0015704038,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.0015704038,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0015704038,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy"
				},
				"name": "Republic",
				"salience": 0.0015656548,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.0015640286,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0015103931,
				"type": "EVENT"
			},
			{
				"name": "task",
				"salience": 0.0014603697,
				"type": "OTHER"
			},
			{
				"name": "involvement.",
				"salience": 0.0014603697,
				"type": "OTHER"
			},
			{
				"name": "rematch",
				"salience": 0.0014603697,
				"type": "EVENT"
			},
			{
				"name": "phone bank",
				"salience": 0.0014603697,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0014121663,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0014083042,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.0013953468,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0013953468,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0013335942,
				"type": "EVENT"
			},
			{
				"name": "People",
				"salience": 0.0012598556,
				"type": "PERSON"
			},
			{
				"name": "ballots",
				"salience": 0.0012598556,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.001217497,
				"type": "OTHER"
			},
			{
				"name": "poll tax",
				"salience": 0.0011921935,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0011675514,
				"type": "OTHER"
			},
			{
				"name": "voting blocks",
				"salience": 0.0011476887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gyh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alabama"
				},
				"name": "Alabama",
				"salience": 0.0011010531,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xhj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manchester,_New_Hampshire"
				},
				"name": "Manchester",
				"salience": 0.0011010531,
				"type": "LOCATION"
			},
			{
				"name": "claims",
				"salience": 0.0011000371,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0011000371,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interview",
				"salience": 0.0011000371,
				"type": "EVENT"
			},
			{
				"name": "couple",
				"salience": 0.0010909216,
				"type": "PERSON"
			},
			{
				"name": "sideline",
				"salience": 0.0010909216,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0010909216,
				"type": "OTHER"
			},
			{
				"name": "circles",
				"salience": 0.0010909216,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0010909216,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.0010589712,
				"type": "OTHER"
			},
			{
				"name": "email leak",
				"salience": 0.0009900918,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.00092107966,
				"type": "WORK_OF_ART"
			},
			{
				"name": "leak",
				"salience": 0.00091754546,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.0008988392,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0008915726,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09gd5v1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Business_Insider"
				},
				"name": "Business Insider",
				"salience": 0.0008261701,
				"type": "ORGANIZATION"
			},
			{
				"name": "fraud",
				"salience": 0.00082172017,
				"type": "OTHER"
			},
			{
				"name": "voter-ID laws",
				"salience": 0.00082172017,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.00082172017,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007944988,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.0007944988,
				"type": "EVENT"
			},
			{
				"name": "forefront",
				"salience": 0.0007944988,
				"type": "OTHER"
			},
			{
				"name": "electoral system",
				"salience": 0.0007944988,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0007944988,
				"type": "OTHER"
			},
			{
				"name": "campaign trail",
				"salience": 0.0007944988,
				"type": "LOCATION"
			},
			{
				"name": "statements",
				"salience": 0.0007712276,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.0007456784,
				"type": "PERSON"
			},
			{
				"name": "lack",
				"salience": 0.0007210592,
				"type": "OTHER"
			},
			{
				"name": "fall",
				"salience": 0.0006853889,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.0006853889,
				"type": "OTHER"
			},
			{
				"name": "party bosses",
				"salience": 0.00068232685,
				"type": "PERSON"
			},
			{
				"name": "disenfranchisement",
				"salience": 0.0006323261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00060662744,
				"type": "ORGANIZATION"
			},
			{
				"name": "ballot box",
				"salience": 0.00059346884,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.00059346884,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.00059346884,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.00059346884,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_f2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vermont"
				},
				"name": "Vermont",
				"salience": 0.0004889595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/068p2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pittsburgh"
				},
				"name": "Pittsburgh",
				"salience": 0.0003652293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.0003652293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477585908donald-trump-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.563+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nDonald Trump is again riling up his voting base with claims that the November election will be rigged against him. \n\"Of course there is large scale voter fraud happening on and before election day,\" Trump tweeted Monday morning. \"Why do Republican leaders deny what is going on? So naive!\" \nIt's a charge that even other Republicans have been quick to refute. Critics have called such talk potentially dangerous and detrimental to trust in the US democratic process. \n\"States, backed by tens of thousands of GOP and DEM volunteers, ensure integrity of electoral process,\" Sen. Jeff Flake of Arizona, who is often sharply critical of Trump, tweeted Sunday. \"Elections are not rigged.\" \nJon Husted, the secretary of state of Ohio and the top election official in the key battleground state, also said Monday that he could assure Trump the election would not be rigged. \nTrump's most recent claims coincided with a plunge by him in the polls. Before now, Trump most recently made similar claims when his polls numbers were taking a dive in early August. \n\"And I'm telling you, November 8, we'd better be careful, because that election is going to be rigged,\" the New York billionaire told Fox News host Sean Hannity in August. \"And I hope the Republicans are watching closely or it's going to be taken away from us.\" \nMultiple Republicans told Business Insider at the time that Trump's assertion was both ludicrous and dangerous, as Trump would be the first US presidential candidate in modern times, possibly ever, to blame an election loss on voter fraud or a rigged election. \nAllen Raymond, a former GOP operative who was involved in the 2002 New Hampshire Senate election phone-jamming scandal, called Trump's continued insistence that the election would be rigged \"detrimental to the Republic.\" \n\"The idea that it's rigged, I don't know what he's talking about,\" he said in August. \"I know someone that rigged elections. I mean, you know, the fact of the matter is Hillary Clinton doesn't need to rig this election. Trump's going to win Alabama and that's it. She doesn't have to do anything. It's painful to watch.\" \nRaymond wrote \"How to Rig an Election: Confessions of a Republican Operative\" as a tell-all about the attempt to rig the 2002 New Hampshire Senate election between then-Gov. Jeanne Shaheen, a Democrat, and Republican US Rep. John E. Sununu. Raymond said that attempted rigging was centered on jamming the phone lines at the New Hampshire Democrats office in Manchester — a task his phone bank was hired to carry out. Sununu went on to win the election by roughly 20,000 votes. Shaheen defeated Sununu in a rematch in 2008. \nThe operative served a brief prison sentence for his involvement.He said any attempts to rig an election would look similar to that — not what Trump's talking about. \nThe Manhattan billionaire told The Washington Post in August that a lack of voter-identification laws would let people \"just keep voting and voting and voting\" and suggested fraud occurred in 2012 against Republican nominee Mitt Romney because there were \"precincts where there were practically nobody voting for the Republican.\" \n\"I don't even know what he's talking about,\" Raymond said. \"But this idea that it's 1950 or 1960 and the party bosses are going to roll into Pittsburgh and Philadelphia and are going to rig the ballot box and rig the machines — that's nonsense. An election rigging these days means something totally different than what he's talking about. Now it's stupid stuff like what I did in New Hampshire.\" \nHe said the lack of voter-ID laws Trump was trying to use as proof of fraud this fall was also bogus. \n\"These voter-ID laws, what's the intention of that? The clear intention is disenfranchisement,\" he said, echoing a common complaint in liberal circles that voter-ID laws are put in place to prevent minority voting blocks from being able to cast ballots. \"You know, there's a reason we don't have a poll tax anymore. Because it's unconstitutional. \n\"People don't vote 10 times,\" he continued. \"There might be one bad actor every once in a while who tries to vote a couple of times, but he's talking about an institutional effort. It's a total myth.\" \nHe said Trump's statements were an attempt to \"basically sideline\" Hillary Clinton's first four years in office. \nThe idea of a rigged election came to the forefront after the Democratic National Committee had its emails hacked and leaked, though both Trump and Sen. Bernie Sanders of Vermont, Clinton's main opponent in the Democratic primary, had claimed the electoral system was rigged earlier in the primary season. The emails showed that the organization, which was supposed to remain neutral throughout the primary, favored Clinton. \nTrump said the email leak proved that the primary election was \"rigged\" against Sanders in his early-August interview with Hannity, in addition to such claims he perpetuated along the campaign trail. He used the leak as further evidence that the fall election would be rigged against him as well.",
		"thread_title": "Donald Trump claims the election will be 'rigged' — and critics have called that preposterous and dangerous",
		"title": "Donald Trump claims the election will be 'rigged' — and critics have called that preposterous and dangerous",
		"type": "conspiracy",
		"uuid": "2a1e52f5a75af100a9a84c8aa8668d252d290bd8"
	},
	"-KhIjTJbjCaFtzLBiAUT": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.586+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.17308483,
				"type": "LOCATION"
			},
			{
				"name": "politician",
				"salience": 0.15320517,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.09304861,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.07711645,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.063761756,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.048169322,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.03922885,
				"type": "EVENT"
			},
			{
				"name": "criminals",
				"salience": 0.02782223,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.018461224,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.016010387,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.016010387,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.016010387,
				"type": "OTHER"
			},
			{
				"name": "TV spot",
				"salience": 0.016010387,
				"type": "WORK_OF_ART"
			},
			{
				"name": "governments",
				"salience": 0.015325583,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack ad",
				"salience": 0.014727909,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.014206931,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.01252847,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.010874747,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.009771592,
				"type": "OTHER"
			},
			{
				"name": "deals",
				"salience": 0.008214528,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0077865976,
				"type": "ORGANIZATION"
			},
			{
				"name": "nominee",
				"salience": 0.0076494087,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.0076494087,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.0071061985,
				"type": "EVENT"
			},
			{
				"name": "family",
				"salience": 0.00662769,
				"type": "PERSON"
			},
			{
				"name": "controversies",
				"salience": 0.00662769,
				"type": "OTHER"
			},
			{
				"name": "cash",
				"salience": 0.00662769,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.00662769,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.004085167,
				"type": "ORGANIZATION"
			},
			{
				"name": "ad",
				"salience": 0.0036743057,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/024v2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Ryan"
				},
				"name": "Paul Ryan",
				"salience": 0.0036196888,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0030796977,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0030409489,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0029275978,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0029275978,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0027460575,
				"type": "PERSON"
			},
			{
				"name": "corporations",
				"salience": 0.0027460575,
				"type": "ORGANIZATION"
			},
			{
				"name": "donors.",
				"salience": 0.0027460575,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0026436797,
				"type": "ORGANIZATION"
			},
			{
				"name": "voice",
				"salience": 0.0025018668,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0024831803,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0024831803,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bymv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_McCain"
				},
				"name": "John McCain",
				"salience": 0.0024445343,
				"type": "PERSON"
			},
			{
				"name": "AIDS relief",
				"salience": 0.002378261,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.002378261,
				"type": "OTHER"
			},
			{
				"name": "The Clintons",
				"salience": 0.002332371,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.002289575,
				"type": "EVENT"
			},
			{
				"name": "scrutiny",
				"salience": 0.002289575,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.002289575,
				"type": "EVENT"
			},
			{
				"name": "concerns",
				"salience": 0.002289575,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.002289575,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.002289575,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0021997443,
				"type": "EVENT"
			},
			{
				"name": "instance",
				"salience": 0.0020688933,
				"type": "OTHER"
			},
			{
				"name": "recording",
				"salience": 0.0019666515,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0019418894,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0019418894,
				"type": "OTHER"
			},
			{
				"name": "advertisement",
				"salience": 0.0019418894,
				"type": "WORK_OF_ART"
			},
			{
				"name": "debate",
				"salience": 0.0019174388,
				"type": "EVENT"
			},
			{
				"name": "establishment figures",
				"salience": 0.0017546815,
				"type": "OTHER"
			},
			{
				"name": "privileges",
				"salience": 0.0017325854,
				"type": "OTHER"
			},
			{
				"name": "character",
				"salience": 0.0016996934,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haitians",
				"salience": 0.0015019572,
				"type": "PERSON"
			},
			{
				"name": "uranium rights",
				"salience": 0.0014694016,
				"type": "OTHER"
			},
			{
				"name": "misconduct",
				"salience": 0.0014508946,
				"type": "OTHER"
			},
			{
				"name": "sexual assault",
				"salience": 0.0014508946,
				"type": "OTHER"
			},
			{
				"name": "shackles",
				"salience": 0.0012304664,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0011955461,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0011117939,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0011045944,
				"type": "PERSON"
			},
			{
				"name": "observers",
				"salience": 0.00089622574,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06wxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Louis"
				},
				"name": "St. Louis",
				"salience": 0.0008931507,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0008931507,
				"type": "LOCATION"
			},
			{
				"name": "husband",
				"salience": 0.00078949414,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.00078949414,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.00078949414,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775855554200.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.586+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nDonald Trump’s campaign debuted a dark new attack ad on Tuesday, looking to further its portrayal of Hillary Clinton as a corrupt politician and doubling down on allegations that she grew wealthy through “pay-to-play politics.”The TV spot hits Clinton, the Democratic presidential nominee, on controversies related to her family’s foundation, stating that “staggering amounts of cash poured into the Clinton Foundation from criminals, dictators, countries that hate America” and that “Hillary cut deals for donors.” \nClinton’s charitable foundation has faced intense scrutiny this election over concerns about possible conflicts of interest because it took in money from corporations and foreign governments. Clinton has repeatedly denied, however, that her work as secretary of state was compromised by the foundation’s work or that she gave any special privileges to its donors.The Clintons have also said that the foundation, which contributes to AIDS relief abroad, among other charitable causes, will cease taking money from corporations and foreign governments if she is elected president.Still, the ad from the Republican nominee claims that Clinton “sold out American workers, exploited Haitians in need, she even gave American uranium rights to the Russians.”“Hillary Clinton only cares about power, money and herself,” its voice over concludes.The advertisement is another instance of Trump, an embattled candidate in an already divisive race, going on the offensive as the presidential campaign enters its final weeks. As Trump trails in the polls and high-profile Republicans abandon him, he has attacked Clinton and her husband’s character, going so far as to bring women who had accused Bill Clinton of sexual misconduct to watch the second debate in St. Louis last weekend.Some Republicans had called for him to drop out of the race after a 2005 recording emerged showing him bragging about sexual assault last week. But, attacking even Republican establishment figures like Speaker Paul Ryan and Arizona Sen. John McCain, Trump has promised to plow forward, and some observers suggest he has little to lose.“It is so nice that the shackles have been taken off me and I can now fight for America the way I want to,” he tweeted on Tuesday.",
		"thread_title": "Trump: Hillary Clinton may be 'most corrupt person ever' to run for president",
		"title": "Trump: Hillary Clinton may be 'most corrupt person ever' to run for president",
		"type": "conspiracy",
		"uuid": "c82cae8e67e53cb9f294fb5d74aedb906d8262c1"
	},
	"-KhIjTcQJJPWS1n6J3zr": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.603+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.23043314,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.1014945,
				"type": "ORGANIZATION"
			},
			{
				"name": "made'After",
				"salience": 0.07081417,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06yxd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Carolina"
				},
				"name": "South Carolina",
				"salience": 0.063404754,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.06161079,
				"type": "LOCATION"
			},
			{
				"name": "agreements",
				"salience": 0.026849579,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.024208916,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.023099774,
				"type": "OTHER"
			},
			{
				"name": "peace accord",
				"salience": 0.022060184,
				"type": "OTHER"
			},
			{
				"name": "accommodation",
				"salience": 0.018973114,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.018973114,
				"type": "EVENT"
			},
			{
				"name": "shot",
				"salience": 0.017145073,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.017145073,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0226wy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Scarborough"
				},
				"name": "Joe Scarborough",
				"salience": 0.015273307,
				"type": "PERSON"
			},
			{
				"name": "town hall event",
				"salience": 0.014861546,
				"type": "EVENT"
			},
			{
				"name": "contender",
				"salience": 0.014861546,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.014861546,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.012775622,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.012772788,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.010682406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.009170341,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gkgp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charleston,_South_Carolina"
				},
				"name": "Charleston",
				"salience": 0.009170341,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.009170341,
				"type": "ORGANIZATION"
			},
			{
				"name": "agreement",
				"salience": 0.008167749,
				"type": "OTHER"
			},
			{
				"name": "accord",
				"salience": 0.007848298,
				"type": "OTHER"
			},
			{
				"name": "fault",
				"salience": 0.0072230357,
				"type": "OTHER"
			},
			{
				"name": "fault",
				"salience": 0.007088455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.0069493693,
				"type": "PERSON"
			},
			{
				"name": "position",
				"salience": 0.006750314,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0061403876,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israelis",
				"salience": 0.005897251,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.005152944,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.005046062,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0044646375,
				"type": "ORGANIZATION"
			},
			{
				"name": "hostility",
				"salience": 0.0036707222,
				"type": "OTHER"
			},
			{
				"name": "peace agreement",
				"salience": 0.0034334667,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0033616347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07j6ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ted_Cruz"
				},
				"name": "Ted Cruz",
				"salience": 0.0033117018,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.003305445,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0032121139,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0031295712,
				"type": "PERSON"
			},
			{
				"name": "agreements",
				"salience": 0.0029492762,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0029395358,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0027103082,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.002654335,
				"type": "PERSON"
			},
			{
				"name": "peoples",
				"salience": 0.002654335,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Benjamin Netanyahu",
				"salience": 0.0024109,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.002379754,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.002379754,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0023560282,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0022986683,
				"type": "EVENT"
			},
			{
				"name": "peace",
				"salience": 0.0022481934,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.002201498,
				"type": "OTHER"
			},
			{
				"name": "obstacles",
				"salience": 0.002201498,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.002201498,
				"type": "OTHER"
			},
			{
				"name": "shot",
				"salience": 0.0021835207,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0021643206,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "skepticism",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.0021193654,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "flames",
				"salience": 0.0021193654,
				"type": "OTHER"
			},
			{
				"name": "root",
				"salience": 0.0017974004,
				"type": "OTHER"
			},
			{
				"name": "stalemate",
				"salience": 0.0017974004,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0017173974,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0016003643,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0015176807,
				"type": "WORK_OF_ART"
			},
			{
				"name": "deal",
				"salience": 0.0014796829,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0013712988,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0013540224,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.001342805,
				"type": "EVENT"
			},
			{
				"name": "real estate magnate",
				"salience": 0.001167995,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.0011294436,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0011294436,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0011294436,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.0011294436,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0010791563,
				"type": "PERSON"
			},
			{
				"name": "peace",
				"salience": 0.0010115111,
				"type": "OTHER"
			},
			{
				"name": "commitment",
				"salience": 0.0010115111,
				"type": "OTHER"
			},
			{
				"name": "upset",
				"salience": 0.00090635533,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0008437185,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026gv1t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Jewish_Coalition"
				},
				"name": "Republican Jewish Coalition",
				"salience": 0.00082651863,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "AP",
				"salience": 0.00082651863,
				"type": "ORGANIZATION"
			},
			{
				"name": "negotiating partner",
				"salience": 0.00079840363,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.000757382,
				"type": "OTHER"
			},
			{
				"name": "forum",
				"salience": 0.00073057984,
				"type": "EVENT"
			},
			{
				"name": "candidates",
				"salience": 0.00073057984,
				"type": "PERSON"
			},
			{
				"name": "friend",
				"salience": 0.00073057984,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.00064355746,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.00060194003,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.0005844798,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.00051927497,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477585077063_510901622-635x357.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.603+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nLeading Republican presidential hopeful suggests Israeli-Palestinian peace accord may be impossible: ‘Sometimes agreements can’t be made’After being asked by a voter at a Charleston, South Carolina, town hall event hosted by MSNBC about what steps he would take to broker an accommodation between the sides in the conflict, the GOP contender vowed to give it “one hell of a shot” and called it “probably the toughest agreement of any kind to make.”But when pressed by host Joe Scarborough over whether he ascribed fault to either Israelis or Palestinians over the failure to reach a lasting accord, Trump declined to take sides. \n“You know, I don’t want to get into it, because … If I win, I don’t want to be in a position where I’m saying to you and the other side now says, ‘We don’t want Trump involved,'” Trump said. \n“Let me be sort of a neutral guy,” he continued. “A lot of people have gone down in flames trying to make that deal. So I don’t want to say whose fault is it. I don’t think it helps.”Trump also expressed skepticism over the possibility of achieving a two-state solution, given the conditions of the conflict and the need for any agreement to be sustainable over time. \n“It’s possible it’s not makeable, because don’t forget it has to last — it’s wonderful to make it and it doesn’t work, but it has to last,” he said. “To make lasting peace there? Probably the toughest deal of all, but I’m going to give it a shot.” \nThough he was not asked directly what he considers the most substantial obstacles standing in the way of a peace agreement, he suggested that growing hostility between the two peoples was contributing to the current stalemate, and what he considers the root of the conflict. \n“A lot of people say an agreement can’t be made, which is okay. I mean, sometimes agreements can’t be made. Not good, but, you know, you have both sides really, but one side in particular, growing up and learning that these are the worst people,” he said. “I was with a very prominent Israeli the other day. He says it’s impossible, because the other side has been trained from the time they’re children to hate Jewish people.”In the past, Trump has questioned Israel’s commitment to peace, while at the same time suggesting the Jewish state does not have a negotiating partner in the Palestinians. He has also called Prime Minister Benjamin Netanyahu “a good friend.” \nAt a presidential candidates forum hosted by the Republican Jewish Coalition in December 2015, the real estate magnate said, “I don’t know that Israel has the commitment to make it, and I don’t know that the other side has the commitment to make it.” \nHe made the same point in an interview with AP earlier that day: “A lot will have to do with Israel and whether or not Israel wants to make the deal — whether or not Israel’s willing to sacrifice certain things,” he said. “They may not be, and I understand that, and I’m okay with that. But then you’re just not going to have a deal.” \nTrump’s comments Wednesday came hours after a dramatic upset in polls saw Trump fall behind Texas Sen. Ted Cruz for the first time in 31 consecutive polls, coming in at 26% of registered Republican voters nationally, two points behind Cruz at 28%.",
		"thread_title": "Trump says he’d be ‘neutral’ with Israelis and Palestinians",
		"title": "Trump says he’d be ‘neutral’ with Israelis and Palestinians",
		"type": "conspiracy",
		"uuid": "2e079e1423a6576bbce714cf82ad1a850ae81ef5"
	},
	"-KhIjTwM4C1qFc7uOs8D": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T21:14:42.630+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.5691424,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.18497404,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.035071116,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.009463711,
				"type": "WORK_OF_ART"
			},
			{
				"name": "prosecutor",
				"salience": 0.008611726,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.008611726,
				"type": "OTHER"
			},
			{
				"name": "misconduct",
				"salience": 0.0077800946,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.0077800946,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007704057,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0073241126,
				"type": "PERSON"
			},
			{
				"name": "rails",
				"salience": 0.0067418194,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.0067418194,
				"type": "OTHER"
			},
			{
				"name": "attorney general",
				"salience": 0.0059812553,
				"type": "PERSON"
			},
			{
				"name": "accusations",
				"salience": 0.0058675883,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.005659669,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.005376261,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.005374877,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01rqpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paula_Jones"
				},
				"name": "Paula Jones",
				"salience": 0.0042358334,
				"type": "PERSON"
			},
			{
				"name": "behavior",
				"salience": 0.004189831,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0brnz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Martha_Raddatz"
				},
				"name": "Martha Raddatz",
				"salience": 0.0041276016,
				"type": "PERSON"
			},
			{
				"name": "behavior",
				"salience": 0.003983142,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.0036782124,
				"type": "PERSON"
			},
			{
				"name": "Clinton https://t.co/raPU4ICkl6 https://t.co/IWGVUleEtr",
				"salience": 0.0034977999,
				"type": "OTHER"
			},
			{
				"name": "debate moderators",
				"salience": 0.00345024,
				"type": "PERSON"
			},
			{
				"name": "permission",
				"salience": 0.00345024,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0030589132,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0026612813,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0022173796,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0022173796,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0021326146,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0021253051,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0198fr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khan_(title)"
				},
				"name": "Khans",
				"salience": 0.0021130764,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0019412494,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.001818182,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.001818182,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.0017831757,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0016417744,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0015551918,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0015117294,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0014217821,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0014217821,
				"type": "OTHER"
			},
			{
				"name": "soldier",
				"salience": 0.0014068366,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0013286789,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0013286789,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0013286789,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0013235842,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0012750926,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0012275182,
				"type": "OTHER"
			},
			{
				"name": "misconduct",
				"salience": 0.0011083708,
				"type": "OTHER"
			},
			{
				"name": "each",
				"salience": 0.0010622476,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0010543073,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.0010410264,
				"type": "WORK_OF_ART"
			},
			{
				"name": "floundering campaign",
				"salience": 0.0010410264,
				"type": "EVENT"
			},
			{
				"name": "truth",
				"salience": 0.0009970069,
				"type": "OTHER"
			},
			{
				"name": "press conference",
				"salience": 0.00095980044,
				"type": "EVENT"
			},
			{
				"name": "fine",
				"salience": 0.00095980044,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00095980044,
				"type": "OTHER"
			},
			{
				"name": "front row",
				"salience": 0.00095980044,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.00095980044,
				"type": "OTHER"
			},
			{
				"name": "difficulty",
				"salience": 0.0009535853,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0009519602,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0009399677,
				"type": "PERSON"
			},
			{
				"name": "birthplace",
				"salience": 0.00092812616,
				"type": "LOCATION"
			},
			{
				"name": "couple",
				"salience": 0.00090643315,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0008969287,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.000875279,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.000841835,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07pvf1k"
				},
				"name": "Mine",
				"salience": 0.0008266084,
				"type": "PERSON"
			},
			{
				"name": "conclusions",
				"salience": 0.00081395666,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0007777188,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0007777188,
				"type": "LOCATION"
			},
			{
				"name": "responsibility",
				"salience": 0.00074816827,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0007123822,
				"type": "PERSON"
			},
			{
				"name": "CNN Politics",
				"salience": 0.00070872775,
				"type": "ORGANIZATION"
			},
			{
				"name": "birthplace",
				"salience": 0.0007022072,
				"type": "LOCATION"
			},
			{
				"name": "apology",
				"salience": 0.0007022072,
				"type": "OTHER"
			},
			{
				"name": "apology",
				"salience": 0.0007022072,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0007022072,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.0006478569,
				"type": "OTHER"
			},
			{
				"name": "prosecutor",
				"salience": 0.0006190105,
				"type": "PERSON"
			},
			{
				"name": "@CNNPolitics",
				"salience": 0.000613702,
				"type": "OTHER"
			},
			{
				"name": "2016The",
				"salience": 0.000613702,
				"type": "OTHER"
			},
			{
				"name": "descent",
				"salience": 0.0006080553,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0006080553,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0006080553,
				"type": "OTHER"
			},
			{
				"name": "rumors",
				"salience": 0.0006080553,
				"type": "OTHER"
			},
			{
				"name": "prosecutor",
				"salience": 0.00056643033,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.000538038,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.00053162914,
				"type": "WORK_OF_ART"
			},
			{
				"name": "women",
				"salience": 0.0005161451,
				"type": "PERSON"
			},
			{
				"name": "jail",
				"salience": 0.0005114255,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00044284496,
				"type": "EVENT"
			},
			{
				"name": "exchange",
				"salience": 0.00044284496,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00044284496,
				"type": "OTHER"
			},
			{
				"name": "deception",
				"salience": 0.00044284496,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00044284496,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.00037424234,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "back-and-forth",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "reporter",
				"salience": 0.00033079763,
				"type": "PERSON"
			},
			{
				"name": "disability",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "camera",
				"salience": 0.00033079763,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.00031208154,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00020358086,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.00020358086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq_War"
				},
				"name": "Iraq War",
				"salience": 0.00020358086,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02d2xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.00020358086,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477584851donald-trump.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T21:14:42.630+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nThe second presidential debate flew off the rails on Sunday night when Donald Trump invoked accusations of sexual misconduct against Bill Clinton and suggested that Hillary Clinton could \"be in jail\" if he's elected in November, threatening to appoint a special prosecutor to look into her private email server. \n\nABC's Martha Raddatz, one of the debate moderators, asked Trump whether his behavior exposed in the shocking 2005 video released Friday, in which he bragged about groping and kissing women without permission, was consistent with his current behavior. \n\"As I told you, that was locker-room talk,\" Trump said. \"I am not proud of it. I am a person who has great respect for people, for my family, for people of this country, and I'm not proud of it.\" \nTrump then said if you \"look at the history of politics in this country, no one had been so abusive of women\" as former President Bill Clinton, the husband of the Democratic nominee, whom Trump suggested intimidated those women. \nThree women who had previously accused Bill Clinton of sexual misconduct held a press conference with Trump earlier Sunday, and each was seated in the front row at the debate. \n\"Mine were words — his were actions,\" Trump said. \n\"So, don't tell me about words,\" he continued. \"I am absolutely, I apologize for those words. But it is things that people say. Bill Clinton. He was impeached. He was no longer allowed to practice law. He had to pay an $850,000 fine to one of the women, Paula Jones, who is here tonight. That when Hillary brings up a point like that, brings up words I say 11 years ago, I think it's disgraceful. And I think she should be ashamed of herself, if you want to know the truth.\" \nDonald Trump: \"If I win, I'm going to instruct my attorney general\" to investigate Clinton https://t.co/raPU4ICkl6 https://t.co/IWGVUleEtr \n— CNN Politics (@CNNPolitics) October 10, 2016The former secretary of state responded by saying that \"so much of what he just said is not right\" but that he was doing it because of his floundering campaign. \n\"I am reminded of what my friend Michelle Obama advised us all,\" she said. \"When they go low, you go high.\" \n\"And, look, if this were just about one video, maybe what he's saying tonight would be understandable,\" she said. \"But everyone can come to their own conclusions about whether or not the man in the video or the man on the stage respects women. But he never apologizes to anyone for anything.\" \nShe mentioned that Trump had not apologized to the Khans, a couple who lost a son, a Muslim US soldier, during the Iraq War. Trump engaged in a lengthy back-and-forth with the Khans after they appeared at the Democratic National Convention in July. \nClinton also said Trump had not apologized to a reporter whose disability he mocked in front of a camera, a federal judge who Trump said couldn't do his job fairly because he was of Mexican descent, and President Barack Obama, whose birthplace Trump tried to discredit in a multiyear campaign. \n\"He owes the president an apology, he needs to apologize to our country, and he needs to take responsibility,\" she said. \nTrump responded by repeating the false claim that the Clinton campaign started the rumors casting doubt on Obama's birthplace in 2008. He added that she owed an apology for the \"33,000 emails you deleted.\" \n\"If I win, I am going to instruct my attorney general to get a special prosecutor to look into your situation,\" Trump said. \"Because there have never been so many lies, so much deception. And we're going to have a special prosecutor.\" \nClinton said everything Trump said was \"absolutely false\" but she was \"not surprised.\" \n\"Oh really?\" Trump interjected. \nClinton then mentioned the difficulty in fact-checking Trump, to which he capped off the exchange by saying \"you'd be in jail\" during his potential administration.",
		"thread_title": "Donald Trump threatens to jail Hillary Clinton",
		"title": "Donald Trump threatens to jail Hillary Clinton",
		"type": "conspiracy",
		"uuid": "a0ef6632a41fb4d8d6cb1f1c4b86730cc62bf8c4"
	},
	"-KhIjU68_lPOAzrr5Kag": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-27T22:55:28.417+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.59110194,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.104738355,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.075457595,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.06672551,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.031934742,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.013548403,
				"type": "PERSON"
			},
			{
				"name": "terrorist group",
				"salience": 0.012249432,
				"type": "ORGANIZATION"
			},
			{
				"name": "region",
				"salience": 0.01062489,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0074203173,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0065668067,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0059412867,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.0054540476,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.0054540476,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0034315225,
				"type": "LOCATION"
			},
			{
				"name": "acronym",
				"salience": 0.0033753004,
				"type": "OTHER"
			},
			{
				"name": "Lauderdale",
				"salience": 0.002926975,
				"type": "LOCATION"
			},
			{
				"name": "decisions",
				"salience": 0.0027865067,
				"type": "OTHER"
			},
			{
				"name": "Humayun Khan",
				"salience": 0.0026303541,
				"type": "PERSON"
			},
			{
				"name": "founder",
				"salience": 0.0025996286,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0025996286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.0020915603,
				"type": "PERSON"
			},
			{
				"name": "real estate tycoon",
				"salience": 0.0019590573,
				"type": "PERSON"
			},
			{
				"name": "co-founder",
				"salience": 0.0017703371,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.0017558925,
				"type": "OTHER"
			},
			{
				"name": "military forces",
				"salience": 0.0017558925,
				"type": "PERSON"
			},
			{
				"name": "Khizr Khan",
				"salience": 0.0017518232,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.0016617174,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0015796319,
				"type": "OTHER"
			},
			{
				"name": "fury",
				"salience": 0.0015796319,
				"type": "OTHER"
			},
			{
				"name": "void",
				"salience": 0.0015207356,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0014893394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0013869262,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.0012898311,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0012898311,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0012898311,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0012324485,
				"type": "WORK_OF_ART"
			},
			{
				"name": "forces",
				"salience": 0.0011856523,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0011289782,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0010455946,
				"type": "LOCATION"
			},
			{
				"name": "rise",
				"salience": 0.00096373516,
				"type": "OTHER"
			},
			{
				"name": "Crooked",
				"salience": 0.0009363909,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni Muslims",
				"salience": 0.0009021045,
				"type": "PERSON"
			},
			{
				"name": "statements",
				"salience": 0.0008977965,
				"type": "OTHER"
			},
			{
				"name": "Captain",
				"salience": 0.00081065483,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0007941365,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.0007941365,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0007019933,
				"type": "EVENT"
			},
			{
				"name": "immigrants",
				"salience": 0.0007019933,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.00060562615,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00060562615,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.000593283,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.00052443164,
				"type": "PERSON"
			},
			{
				"name": "crucifixions",
				"salience": 0.00052443164,
				"type": "EVENT"
			},
			{
				"name": "decapitations",
				"salience": 0.00052443164,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00052443164,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.00052443164,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00052443164,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02d2xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.0004321062,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurds",
				"salience": 0.00032278604,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.00032278604,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shia",
				"salience": 0.00013624853,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/147759640151aefcd3f-33ad-4eb5-a130-91e60d06bb76.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T22:55:28.417+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email US President Barack Obama and former secretary of state Hillary Clinton “founded” the Daesh (ISIL) terrorist group in the Middle East region, according to Republican presidential nominee Donald Trump. Addressing supporters at a rally in Ft. Lauderdale, Florida, on Wednesday, Trump said Daesh is \"honoring President Obama.\" “He’s the founder of ISIS. He's the founder! He founded ISIS,” the real estate tycoon said, using an alternative acronym for the terrorist group. “I would say the co-founder would be ‘Crooked’ Hillary Clinton,” Trump added. He went on to criticize Obama’s decision to withdraw American military forces from Iraq and leaving behind a void for Daesh terrorists to fill. “We should never have gotten out the way we got out,” he said. “We unleashed terrible fury all over the Middle East.\" “Instead of allowing some small forces behind to maybe, just maybe, keep it under control, we pulled it out,” he continued. Daesh terrorists, many of whom were initially trained by the CIA in Jordan in 2012 to destabilize the Syrian government, still control parts of Iraq and Syria. They have been engaged in crimes against humanity in areas under their control. They have been carrying out horrific acts of violence such as public decapitations and crucifixions against all communities, including Shia and Sunni Muslims, Kurds, and Christians. In a statement last week, Mike Pence, Trump’s vice presidential candidate, also said that the policies of Obama and Clinton led to the rise of Daesh. He blamed Obama and Democratic presidential nominee Hillary Clinton for the “disastrous decisions” that led to the death of Captain Humayun Khan in Iraq. On July 28, Captain Khan’s father, Khizr Khan, addressed the Democratic National Convention, denouncing Trump as unpatriotic and selfish over his statements against immigrants and Muslims.",
		"thread_title": "Trump accuses Obama, Hillary Clinton of founding Daesh",
		"title": "Trump accuses Obama, Hillary Clinton of founding Daesh",
		"type": "conspiracy",
		"uuid": "d262302c669a3c221e7758433d0fe2c63f999b20"
	},
	"-KhIjUHkd1MRJWC9wYZ5": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T08:22:28.517+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.59110194,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.104738355,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.075457595,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.06672551,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.031934742,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.013548403,
				"type": "PERSON"
			},
			{
				"name": "terrorist group",
				"salience": 0.012249432,
				"type": "ORGANIZATION"
			},
			{
				"name": "region",
				"salience": 0.01062489,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0074203173,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0065668067,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0059412867,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.0054540476,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.0054540476,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0034315225,
				"type": "LOCATION"
			},
			{
				"name": "acronym",
				"salience": 0.0033753004,
				"type": "OTHER"
			},
			{
				"name": "Lauderdale",
				"salience": 0.002926975,
				"type": "LOCATION"
			},
			{
				"name": "decisions",
				"salience": 0.0027865067,
				"type": "OTHER"
			},
			{
				"name": "Humayun Khan",
				"salience": 0.0026303541,
				"type": "PERSON"
			},
			{
				"name": "founder",
				"salience": 0.0025996286,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.0025996286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.0020915603,
				"type": "PERSON"
			},
			{
				"name": "real estate tycoon",
				"salience": 0.0019590573,
				"type": "PERSON"
			},
			{
				"name": "co-founder",
				"salience": 0.0017703371,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.0017558925,
				"type": "OTHER"
			},
			{
				"name": "military forces",
				"salience": 0.0017558925,
				"type": "PERSON"
			},
			{
				"name": "Khizr Khan",
				"salience": 0.0017518232,
				"type": "PERSON"
			},
			{
				"name": "policies",
				"salience": 0.0016617174,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0015796319,
				"type": "OTHER"
			},
			{
				"name": "fury",
				"salience": 0.0015796319,
				"type": "OTHER"
			},
			{
				"name": "void",
				"salience": 0.0015207356,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0014893394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0013869262,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.0012898311,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0012898311,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0012898311,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.0012324485,
				"type": "WORK_OF_ART"
			},
			{
				"name": "forces",
				"salience": 0.0011856523,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0011289782,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0010455946,
				"type": "LOCATION"
			},
			{
				"name": "rise",
				"salience": 0.00096373516,
				"type": "OTHER"
			},
			{
				"name": "Crooked",
				"salience": 0.0009363909,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/078tg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sunni_Islam"
				},
				"name": "Sunni Muslims",
				"salience": 0.0009021045,
				"type": "PERSON"
			},
			{
				"name": "statements",
				"salience": 0.0008977965,
				"type": "OTHER"
			},
			{
				"name": "Captain",
				"salience": 0.00081065483,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0007941365,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.0007941365,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0007019933,
				"type": "EVENT"
			},
			{
				"name": "immigrants",
				"salience": 0.0007019933,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.00060562615,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00060562615,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.000593283,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.00052443164,
				"type": "PERSON"
			},
			{
				"name": "crucifixions",
				"salience": 0.00052443164,
				"type": "EVENT"
			},
			{
				"name": "decapitations",
				"salience": 0.00052443164,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.00052443164,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.00052443164,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.00052443164,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02d2xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.0004321062,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurds",
				"salience": 0.00032278604,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.00032278604,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shia",
				"salience": 0.00013624853,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/147759640151aefcd3f-33ad-4eb5-a130-91e60d06bb76.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T03:27:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email US President Barack Obama and former secretary of state Hillary Clinton “founded” the Daesh (ISIL) terrorist group in the Middle East region, according to Republican presidential nominee Donald Trump. Addressing supporters at a rally in Ft. Lauderdale, Florida, on Wednesday, Trump said Daesh is \"honoring President Obama.\" “He’s the founder of ISIS. He's the founder! He founded ISIS,” the real estate tycoon said, using an alternative acronym for the terrorist group. “I would say the co-founder would be ‘Crooked’ Hillary Clinton,” Trump added. He went on to criticize Obama’s decision to withdraw American military forces from Iraq and leaving behind a void for Daesh terrorists to fill. “We should never have gotten out the way we got out,” he said. “We unleashed terrible fury all over the Middle East.\" “Instead of allowing some small forces behind to maybe, just maybe, keep it under control, we pulled it out,” he continued. Daesh terrorists, many of whom were initially trained by the CIA in Jordan in 2012 to destabilize the Syrian government, still control parts of Iraq and Syria. They have been engaged in crimes against humanity in areas under their control. They have been carrying out horrific acts of violence such as public decapitations and crucifixions against all communities, including Shia and Sunni Muslims, Kurds, and Christians. In a statement last week, Mike Pence, Trump’s vice presidential candidate, also said that the policies of Obama and Clinton led to the rise of Daesh. He blamed Obama and Democratic presidential nominee Hillary Clinton for the “disastrous decisions” that led to the death of Captain Humayun Khan in Iraq. On July 28, Captain Khan’s father, Khizr Khan, addressed the Democratic National Convention, denouncing Trump as unpatriotic and selfish over his statements against immigrants and Muslims.",
		"thread_title": "Trump accuses Obama, Hillary Clinton of founding Daesh",
		"title": "Trump accuses Obama, Hillary Clinton of founding Daesh",
		"type": "conspiracy",
		"uuid": "16ed47cda183b8515a825209e10bba73dd570a60"
	},
	"-KhIjUSzpRc36xbZCByd": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T08:22:35.868+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.17308483,
				"type": "LOCATION"
			},
			{
				"name": "politician",
				"salience": 0.15320517,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.09304861,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.07711645,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.063761756,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.048169322,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.03922885,
				"type": "EVENT"
			},
			{
				"name": "criminals",
				"salience": 0.02782223,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.018461224,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.016010387,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.016010387,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.016010387,
				"type": "OTHER"
			},
			{
				"name": "TV spot",
				"salience": 0.016010387,
				"type": "WORK_OF_ART"
			},
			{
				"name": "governments",
				"salience": 0.015325583,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack ad",
				"salience": 0.014727909,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.014206931,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.01252847,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.010874747,
				"type": "ORGANIZATION"
			},
			{
				"name": "foundation",
				"salience": 0.009771592,
				"type": "OTHER"
			},
			{
				"name": "deals",
				"salience": 0.008214528,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0077865976,
				"type": "ORGANIZATION"
			},
			{
				"name": "nominee",
				"salience": 0.0076494087,
				"type": "PERSON"
			},
			{
				"name": "donors",
				"salience": 0.0076494087,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.0071061985,
				"type": "EVENT"
			},
			{
				"name": "family",
				"salience": 0.00662769,
				"type": "PERSON"
			},
			{
				"name": "controversies",
				"salience": 0.00662769,
				"type": "OTHER"
			},
			{
				"name": "cash",
				"salience": 0.00662769,
				"type": "OTHER"
			},
			{
				"name": "amounts",
				"salience": 0.00662769,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.004085167,
				"type": "ORGANIZATION"
			},
			{
				"name": "ad",
				"salience": 0.0036743057,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/024v2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Ryan"
				},
				"name": "Paul Ryan",
				"salience": 0.0036196888,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0030796977,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0030409489,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0029275978,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0029275978,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0027460575,
				"type": "PERSON"
			},
			{
				"name": "corporations",
				"salience": 0.0027460575,
				"type": "ORGANIZATION"
			},
			{
				"name": "donors.",
				"salience": 0.0027460575,
				"type": "OTHER"
			},
			{
				"name": "corporations",
				"salience": 0.0026436797,
				"type": "ORGANIZATION"
			},
			{
				"name": "voice",
				"salience": 0.0025018668,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0024831803,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0024831803,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bymv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_McCain"
				},
				"name": "John McCain",
				"salience": 0.0024445343,
				"type": "PERSON"
			},
			{
				"name": "AIDS relief",
				"salience": 0.002378261,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.002378261,
				"type": "OTHER"
			},
			{
				"name": "The Clintons",
				"salience": 0.002332371,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.002289575,
				"type": "EVENT"
			},
			{
				"name": "scrutiny",
				"salience": 0.002289575,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.002289575,
				"type": "EVENT"
			},
			{
				"name": "concerns",
				"salience": 0.002289575,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.002289575,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.002289575,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0021997443,
				"type": "EVENT"
			},
			{
				"name": "instance",
				"salience": 0.0020688933,
				"type": "OTHER"
			},
			{
				"name": "recording",
				"salience": 0.0019666515,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0019418894,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0019418894,
				"type": "OTHER"
			},
			{
				"name": "advertisement",
				"salience": 0.0019418894,
				"type": "WORK_OF_ART"
			},
			{
				"name": "debate",
				"salience": 0.0019174388,
				"type": "EVENT"
			},
			{
				"name": "establishment figures",
				"salience": 0.0017546815,
				"type": "OTHER"
			},
			{
				"name": "privileges",
				"salience": 0.0017325854,
				"type": "OTHER"
			},
			{
				"name": "character",
				"salience": 0.0016996934,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haitians",
				"salience": 0.0015019572,
				"type": "PERSON"
			},
			{
				"name": "uranium rights",
				"salience": 0.0014694016,
				"type": "OTHER"
			},
			{
				"name": "misconduct",
				"salience": 0.0014508946,
				"type": "OTHER"
			},
			{
				"name": "sexual assault",
				"salience": 0.0014508946,
				"type": "OTHER"
			},
			{
				"name": "shackles",
				"salience": 0.0012304664,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0011955461,
				"type": "ORGANIZATION"
			},
			{
				"name": "way",
				"salience": 0.0011117939,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0011045944,
				"type": "PERSON"
			},
			{
				"name": "observers",
				"salience": 0.00089622574,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06wxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/St._Louis"
				},
				"name": "St. Louis",
				"salience": 0.0008931507,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0008931507,
				"type": "LOCATION"
			},
			{
				"name": "husband",
				"salience": 0.00078949414,
				"type": "PERSON"
			},
			{
				"name": "polls",
				"salience": 0.00078949414,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.00078949414,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775855554200.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T00:26:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.7,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nDonald Trump’s campaign debuted a dark new attack ad on Tuesday, looking to further its portrayal of Hillary Clinton as a corrupt politician and doubling down on allegations that she grew wealthy through “pay-to-play politics.”The TV spot hits Clinton, the Democratic presidential nominee, on controversies related to her family’s foundation, stating that “staggering amounts of cash poured into the Clinton Foundation from criminals, dictators, countries that hate America” and that “Hillary cut deals for donors.” \nClinton’s charitable foundation has faced intense scrutiny this election over concerns about possible conflicts of interest because it took in money from corporations and foreign governments. Clinton has repeatedly denied, however, that her work as secretary of state was compromised by the foundation’s work or that she gave any special privileges to its donors.The Clintons have also said that the foundation, which contributes to AIDS relief abroad, among other charitable causes, will cease taking money from corporations and foreign governments if she is elected president.Still, the ad from the Republican nominee claims that Clinton “sold out American workers, exploited Haitians in need, she even gave American uranium rights to the Russians.”“Hillary Clinton only cares about power, money and herself,” its voice over concludes.The advertisement is another instance of Trump, an embattled candidate in an already divisive race, going on the offensive as the presidential campaign enters its final weeks. As Trump trails in the polls and high-profile Republicans abandon him, he has attacked Clinton and her husband’s character, going so far as to bring women who had accused Bill Clinton of sexual misconduct to watch the second debate in St. Louis last weekend.Some Republicans had called for him to drop out of the race after a 2005 recording emerged showing him bragging about sexual assault last week. But, attacking even Republican establishment figures like Speaker Paul Ryan and Arizona Sen. John McCain, Trump has promised to plow forward, and some observers suggest he has little to lose.“It is so nice that the shackles have been taken off me and I can now fight for America the way I want to,” he tweeted on Tuesday.",
		"thread_title": "Trump: Hillary Clinton may be 'most corrupt person ever' to run for president",
		"title": "Trump: Hillary Clinton may be 'most corrupt person ever' to run for president",
		"type": "conspiracy",
		"uuid": "ffe5085e4228287ae26ceedf6da29dea45857341"
	},
	"-KhIjUk2vaBjN9wirVWm": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T08:22:41.010+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.5691424,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.18497404,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.035071116,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.009463711,
				"type": "WORK_OF_ART"
			},
			{
				"name": "prosecutor",
				"salience": 0.008611726,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.008611726,
				"type": "OTHER"
			},
			{
				"name": "misconduct",
				"salience": 0.0077800946,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.0077800946,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007704057,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0073241126,
				"type": "PERSON"
			},
			{
				"name": "rails",
				"salience": 0.0067418194,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.0067418194,
				"type": "OTHER"
			},
			{
				"name": "attorney general",
				"salience": 0.0059812553,
				"type": "PERSON"
			},
			{
				"name": "accusations",
				"salience": 0.0058675883,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.005659669,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.005376261,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.005374877,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01rqpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paula_Jones"
				},
				"name": "Paula Jones",
				"salience": 0.0042358334,
				"type": "PERSON"
			},
			{
				"name": "behavior",
				"salience": 0.004189831,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0brnz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Martha_Raddatz"
				},
				"name": "Martha Raddatz",
				"salience": 0.0041276016,
				"type": "PERSON"
			},
			{
				"name": "behavior",
				"salience": 0.003983142,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.0036782124,
				"type": "PERSON"
			},
			{
				"name": "Clinton https://t.co/raPU4ICkl6 https://t.co/IWGVUleEtr",
				"salience": 0.0034977999,
				"type": "OTHER"
			},
			{
				"name": "debate moderators",
				"salience": 0.00345024,
				"type": "PERSON"
			},
			{
				"name": "permission",
				"salience": 0.00345024,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0030589132,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0026612813,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0022173796,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0022173796,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0021326146,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0021253051,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0198fr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khan_(title)"
				},
				"name": "Khans",
				"salience": 0.0021130764,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0019412494,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.001818182,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.001818182,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.0017831757,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0016417744,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0015551918,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0015117294,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0014217821,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0014217821,
				"type": "OTHER"
			},
			{
				"name": "soldier",
				"salience": 0.0014068366,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0013286789,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0013286789,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0013286789,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.0013235842,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0012750926,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0012275182,
				"type": "OTHER"
			},
			{
				"name": "misconduct",
				"salience": 0.0011083708,
				"type": "OTHER"
			},
			{
				"name": "each",
				"salience": 0.0010622476,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0010543073,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.0010410264,
				"type": "WORK_OF_ART"
			},
			{
				"name": "floundering campaign",
				"salience": 0.0010410264,
				"type": "EVENT"
			},
			{
				"name": "truth",
				"salience": 0.0009970069,
				"type": "OTHER"
			},
			{
				"name": "press conference",
				"salience": 0.00095980044,
				"type": "EVENT"
			},
			{
				"name": "fine",
				"salience": 0.00095980044,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00095980044,
				"type": "OTHER"
			},
			{
				"name": "front row",
				"salience": 0.00095980044,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.00095980044,
				"type": "OTHER"
			},
			{
				"name": "difficulty",
				"salience": 0.0009535853,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0009519602,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0009399677,
				"type": "PERSON"
			},
			{
				"name": "birthplace",
				"salience": 0.00092812616,
				"type": "LOCATION"
			},
			{
				"name": "couple",
				"salience": 0.00090643315,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0008969287,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.000875279,
				"type": "ORGANIZATION"
			},
			{
				"name": "president",
				"salience": 0.000841835,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07pvf1k"
				},
				"name": "Mine",
				"salience": 0.0008266084,
				"type": "PERSON"
			},
			{
				"name": "conclusions",
				"salience": 0.00081395666,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0007777188,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.0007777188,
				"type": "LOCATION"
			},
			{
				"name": "responsibility",
				"salience": 0.00074816827,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0007123822,
				"type": "PERSON"
			},
			{
				"name": "CNN Politics",
				"salience": 0.00070872775,
				"type": "ORGANIZATION"
			},
			{
				"name": "birthplace",
				"salience": 0.0007022072,
				"type": "LOCATION"
			},
			{
				"name": "apology",
				"salience": 0.0007022072,
				"type": "OTHER"
			},
			{
				"name": "apology",
				"salience": 0.0007022072,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0007022072,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.0006478569,
				"type": "OTHER"
			},
			{
				"name": "prosecutor",
				"salience": 0.0006190105,
				"type": "PERSON"
			},
			{
				"name": "@CNNPolitics",
				"salience": 0.000613702,
				"type": "OTHER"
			},
			{
				"name": "2016The",
				"salience": 0.000613702,
				"type": "OTHER"
			},
			{
				"name": "descent",
				"salience": 0.0006080553,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0006080553,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0006080553,
				"type": "OTHER"
			},
			{
				"name": "rumors",
				"salience": 0.0006080553,
				"type": "OTHER"
			},
			{
				"name": "prosecutor",
				"salience": 0.00056643033,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.000538038,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.00053162914,
				"type": "WORK_OF_ART"
			},
			{
				"name": "women",
				"salience": 0.0005161451,
				"type": "PERSON"
			},
			{
				"name": "jail",
				"salience": 0.0005114255,
				"type": "OTHER"
			},
			{
				"name": "administration",
				"salience": 0.00044284496,
				"type": "EVENT"
			},
			{
				"name": "exchange",
				"salience": 0.00044284496,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.00044284496,
				"type": "OTHER"
			},
			{
				"name": "deception",
				"salience": 0.00044284496,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00044284496,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexican",
				"salience": 0.00037424234,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "back-and-forth",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "reporter",
				"salience": 0.00033079763,
				"type": "PERSON"
			},
			{
				"name": "disability",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.00033079763,
				"type": "OTHER"
			},
			{
				"name": "camera",
				"salience": 0.00033079763,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.00031208154,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00020358086,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.00020358086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06vc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq_War"
				},
				"name": "Iraq War",
				"salience": 0.00020358086,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02d2xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.00020358086,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477584851donald-trump.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T00:14:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nThe second presidential debate flew off the rails on Sunday night when Donald Trump invoked accusations of sexual misconduct against Bill Clinton and suggested that Hillary Clinton could \"be in jail\" if he's elected in November, threatening to appoint a special prosecutor to look into her private email server. \n\nABC's Martha Raddatz, one of the debate moderators, asked Trump whether his behavior exposed in the shocking 2005 video released Friday, in which he bragged about groping and kissing women without permission, was consistent with his current behavior. \n\"As I told you, that was locker-room talk,\" Trump said. \"I am not proud of it. I am a person who has great respect for people, for my family, for people of this country, and I'm not proud of it.\" \nTrump then said if you \"look at the history of politics in this country, no one had been so abusive of women\" as former President Bill Clinton, the husband of the Democratic nominee, whom Trump suggested intimidated those women. \nThree women who had previously accused Bill Clinton of sexual misconduct held a press conference with Trump earlier Sunday, and each was seated in the front row at the debate. \n\"Mine were words — his were actions,\" Trump said. \n\"So, don't tell me about words,\" he continued. \"I am absolutely, I apologize for those words. But it is things that people say. Bill Clinton. He was impeached. He was no longer allowed to practice law. He had to pay an $850,000 fine to one of the women, Paula Jones, who is here tonight. That when Hillary brings up a point like that, brings up words I say 11 years ago, I think it's disgraceful. And I think she should be ashamed of herself, if you want to know the truth.\" \nDonald Trump: \"If I win, I'm going to instruct my attorney general\" to investigate Clinton https://t.co/raPU4ICkl6 https://t.co/IWGVUleEtr \n— CNN Politics (@CNNPolitics) October 10, 2016The former secretary of state responded by saying that \"so much of what he just said is not right\" but that he was doing it because of his floundering campaign. \n\"I am reminded of what my friend Michelle Obama advised us all,\" she said. \"When they go low, you go high.\" \n\"And, look, if this were just about one video, maybe what he's saying tonight would be understandable,\" she said. \"But everyone can come to their own conclusions about whether or not the man in the video or the man on the stage respects women. But he never apologizes to anyone for anything.\" \nShe mentioned that Trump had not apologized to the Khans, a couple who lost a son, a Muslim US soldier, during the Iraq War. Trump engaged in a lengthy back-and-forth with the Khans after they appeared at the Democratic National Convention in July. \nClinton also said Trump had not apologized to a reporter whose disability he mocked in front of a camera, a federal judge who Trump said couldn't do his job fairly because he was of Mexican descent, and President Barack Obama, whose birthplace Trump tried to discredit in a multiyear campaign. \n\"He owes the president an apology, he needs to apologize to our country, and he needs to take responsibility,\" she said. \nTrump responded by repeating the false claim that the Clinton campaign started the rumors casting doubt on Obama's birthplace in 2008. He added that she owed an apology for the \"33,000 emails you deleted.\" \n\"If I win, I am going to instruct my attorney general to get a special prosecutor to look into your situation,\" Trump said. \"Because there have never been so many lies, so much deception. And we're going to have a special prosecutor.\" \nClinton said everything Trump said was \"absolutely false\" but she was \"not surprised.\" \n\"Oh really?\" Trump interjected. \nClinton then mentioned the difficulty in fact-checking Trump, to which he capped off the exchange by saying \"you'd be in jail\" during his potential administration.",
		"thread_title": "Donald Trump threatens to jail Hillary Clinton",
		"title": "Donald Trump threatens to jail Hillary Clinton",
		"type": "conspiracy",
		"uuid": "cb64c208ace64bd6dbe9f5d8a892f510e3ae5dec"
	},
	"-KhIjUybVYv4TI6SIDFZ": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T08:22:42.015+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "operation",
				"salience": 0.107798986,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.087521024,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Muammar Gaddafi",
				"salience": 0.06211308,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.03984808,
				"type": "PERSON"
			},
			{
				"name": "terrorist attack",
				"salience": 0.034771107,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States of America",
				"salience": 0.03169955,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.03164434,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.031368196,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.028379183,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.021097144,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.018715497,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.018715497,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.01851944,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n46_gt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Christopher_Stevens"
				},
				"name": "Christopher Stevens",
				"salience": 0.017092088,
				"type": "PERSON"
			},
			{
				"name": "being",
				"salience": 0.016641848,
				"type": "PERSON"
			},
			{
				"name": "contribution",
				"salience": 0.016541049,
				"type": "OTHER"
			},
			{
				"name": "overthrow",
				"salience": 0.016214859,
				"type": "OTHER"
			},
			{
				"name": "instability",
				"salience": 0.016214859,
				"type": "OTHER"
			},
			{
				"name": "Commander-in-Chief forum",
				"salience": 0.016214859,
				"type": "EVENT"
			},
			{
				"name": "secretary of state",
				"salience": 0.016214859,
				"type": "PERSON"
			},
			{
				"name": "foreign policy decision making processes",
				"salience": 0.0143779125,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.011537046,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.011537046,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.010654809,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.009993202,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.009993202,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.009253858,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.0086530065,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.008506044,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.008414325,
				"type": "OTHER"
			},
			{
				"name": "embassy",
				"salience": 0.008033684,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0072596874,
				"type": "OTHER"
			},
			{
				"name": "magnitude",
				"salience": 0.0066870265,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.0066870265,
				"type": "OTHER"
			},
			{
				"name": "ordinary",
				"salience": 0.0066870265,
				"type": "OTHER"
			},
			{
				"name": "Politics",
				"salience": 0.0063047716,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.005817237,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0057795933,
				"type": "PERSON"
			},
			{
				"name": "move",
				"salience": 0.0056971135,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.0054155835,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0054155835,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0054155835,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0054155835,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0052135927,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0052135927,
				"type": "OTHER"
			},
			{
				"name": "hiccups",
				"salience": 0.0049967244,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.0047434904,
				"type": "PERSON"
			},
			{
				"name": "damage",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "expectations",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "toll",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.004689954,
				"type": "OTHER"
			},
			{
				"name": "iron fist",
				"salience": 0.004514998,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.004514998,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00447813,
				"type": "OTHER"
			},
			{
				"name": "sacrifices",
				"salience": 0.004421736,
				"type": "OTHER"
			},
			{
				"name": "sacrifices",
				"salience": 0.004421736,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.004170052,
				"type": "PERSON"
			},
			{
				"name": "contact",
				"salience": 0.0040463516,
				"type": "OTHER"
			},
			{
				"name": "delegation",
				"salience": 0.0038291474,
				"type": "PERSON"
			},
			{
				"name": "auditorium",
				"salience": 0.0038291474,
				"type": "LOCATION"
			},
			{
				"name": "jokes",
				"salience": 0.0038291474,
				"type": "OTHER"
			},
			{
				"name": "homage",
				"salience": 0.0038291474,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0038291474,
				"type": "PERSON"
			},
			{
				"name": "subject",
				"salience": 0.0038291474,
				"type": "OTHER"
			},
			{
				"name": "dictator",
				"salience": 0.003658722,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0033035784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libyans",
				"salience": 0.0032098247,
				"type": "PERSON"
			},
			{
				"name": "arms dealers",
				"salience": 0.0031803001,
				"type": "ORGANIZATION"
			},
			{
				"name": "bargain",
				"salience": 0.0028607377,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.0028607377,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0028607377,
				"type": "LOCATION"
			},
			{
				"name": "position",
				"salience": 0.0028607377,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0025636924,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.0024994994,
				"type": "PERSON"
			},
			{
				"name": "deal",
				"salience": 0.002406209,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.002327466,
				"type": "PERSON"
			},
			{
				"name": "spook",
				"salience": 0.002219979,
				"type": "OTHER"
			},
			{
				"name": "operation",
				"salience": 0.002154971,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.0020835986,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0020835986,
				"type": "LOCATION"
			},
			{
				"name": "nation heads",
				"salience": 0.0020835986,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0020835986,
				"type": "OTHER"
			},
			{
				"name": "mine",
				"salience": 0.0020835986,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.0018204496,
				"type": "PERSON"
			},
			{
				"name": "nations",
				"salience": 0.0017975097,
				"type": "LOCATION"
			},
			{
				"name": "agents",
				"salience": 0.0017975097,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.0016795363,
				"type": "EVENT"
			},
			{
				"name": "field",
				"salience": 0.0015564793,
				"type": "LOCATION"
			},
			{
				"name": "asset",
				"salience": 0.0015564793,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0015564793,
				"type": "OTHER"
			},
			{
				"name": "intelligence agency",
				"salience": 0.0014489078,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14775659851.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-27T18:59:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nHillary Clinton declared during NBC News’s Commander-in-Chief forum that no lives were lost in Libya when she made the move to take out dictator Muammar Gaddafi. Even so, the former secretary of state did not mention the fact that 11 months later four Americans – including U.S. Ambassador Christopher Stevens – were killed in a terrorist attack in Benghazi that arose from the instability that the overthrow created. \n“That was one of the few situations in American foreign policy decision making processes where everybody came together to make sure we don’t make the wrong move, and the operation was a success, even Donald Trump supported it,” Clinton argued. “As with any operation of such magnitude, we had a few hiccups, but it was nothing out of the ordinary. As I’ve said, the operation was a success.” \nShe continued, “So much so, in fact, that I’m proud to say that no important people were lost through it all, and when I say that, I say it with the utmost respect for all those who had to give their lives on both sides so that Libyans could be freed from the iron fist of Gaddafi. It would have been unrealistic to expect 0 casualties; however, the overall toll did not exceed expectations, with the greater amount of damage being on the side of the enemy.” \n“Politics can be a cruel line of work. That being said, I stand before you here, today, and I am proud to say that giving democracy to a people that have not had any contact with it for generations is a wonderful thing that makes all of the sacrifices worth it. And while we’re on the subject of sacrifices, thank God they did not include anyone important from the American delegation, including yours truly,” she said jokingly, causing the auditorium to laugh. \nShe said, “But all jokes aside, I have to pay homage to the CIA, who has once again performed outstandingly and saved the day. Its agents’ work in the field is an immeasurable contribution and an asset that we would be wise to treasure for generations to come. If it hadn’t been for them, we would not have been able to perform the operation so cleanly and with such little impact to the surrounding nations. I am proud that the United States of America has an intelligence agency such as the CIA.” \n“I’m sure many here among you disagree with my position that one embassy is a small price to pay, a bargain, if you will, when it comes to ridding the world of another dictator and a terrorist. I would also like to remind everyone here that that price would have gone up immeasurably if we had sat idly by and allowed Gaddafi to rage on and cause death and destruction throughout the region. For better of worse, we acted and I am convinced no other dictator will ever again think about cheating the CIA out of a deal. Because, in the words of a personal friend of mine, who is a former CIA spook – shutting down arms dealers is easy; finding trustworthy partners among nation heads is the hard part,” she concluded.",
		"thread_title": "Hillary: “We Did Not Lose A Single Important Person In Libya”",
		"title": "Hillary: “We Did Not Lose A Single Important Person In Libya”",
		"type": "conspiracy",
		"uuid": "587a8a634f6a302184f0cb5aca6dcf8397badbce"
	},
	"-KhIjVCWv6QnuheCHGFG": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T15:49:50.985+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Fiona Bruce",
				"salience": 0.10327633,
				"type": "PERSON"
			},
			{
				"name": "jihadists",
				"salience": 0.09465254,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.09222552,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02qgf3r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Douma,_Syria"
				},
				"name": "Douma",
				"salience": 0.08301967,
				"type": "LOCATION"
			},
			{
				"name": "Assaf",
				"salience": 0.06597657,
				"type": "PERSON"
			},
			{
				"name": "Alice Assaf",
				"salience": 0.05318685,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.03560078,
				"type": "PERSON"
			},
			{
				"name": "dough",
				"salience": 0.027222956,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.027222956,
				"type": "PERSON"
			},
			{
				"name": "bakery oven",
				"salience": 0.02274486,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.02274486,
				"type": "WORK_OF_ART"
			},
			{
				"name": "kneader",
				"salience": 0.019716976,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "barbarians",
				"salience": 0.019716976,
				"type": "PERSON"
			},
			{
				"name": "adults",
				"salience": 0.019716976,
				"type": "PERSON"
			},
			{
				"name": "kids",
				"salience": 0.019464174,
				"type": "PERSON"
			},
			{
				"name": "Yvette Isaac",
				"salience": 0.014389575,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0411145"
				},
				"name": "George",
				"salience": 0.0122538945,
				"type": "PERSON"
			},
			{
				"name": "mothers",
				"salience": 0.011862796,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.011660766,
				"type": "OTHER"
			},
			{
				"name": "Roads",
				"salience": 0.010102649,
				"type": "ORGANIZATION"
			},
			{
				"name": "town",
				"salience": 0.010102649,
				"type": "LOCATION"
			},
			{
				"name": "atrocities",
				"salience": 0.010102649,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.010102649,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.010102649,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.010102649,
				"type": "EVENT"
			},
			{
				"name": "family",
				"salience": 0.00907569,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.008958087,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.008126793,
				"type": "LOCATION"
			},
			{
				"name": "child",
				"salience": 0.0070743826,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.006696812,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048knk3"
				},
				"name": "Success",
				"salience": 0.006226125,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0059030564,
				"type": "LOCATION"
			},
			{
				"name": "door",
				"salience": 0.0059030564,
				"type": "OTHER"
			},
			{
				"name": "bakery",
				"salience": 0.0053270007,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0048104636,
				"type": "PERSON"
			},
			{
				"name": "oven",
				"salience": 0.0048104636,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.004166213,
				"type": "PERSON"
			},
			{
				"name": "youngsters",
				"salience": 0.004166213,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.004166213,
				"type": "OTHER"
			},
			{
				"name": "advocacy group",
				"salience": 0.004166213,
				"type": "ORGANIZATION"
			},
			{
				"name": "mother",
				"salience": 0.004044339,
				"type": "PERSON"
			},
			{
				"name": "dough",
				"salience": 0.003893528,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0037842111,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0033740525,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0033740525,
				"type": "OTHER"
			},
			{
				"name": "media reports",
				"salience": 0.0032482047,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.0029219592,
				"type": "EVENT"
			},
			{
				"name": "non-Muslims",
				"salience": 0.0029219592,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.0029219592,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.0028129555,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0028129555,
				"type": "OTHER"
			},
			{
				"name": "dough mixer",
				"salience": 0.0028129555,
				"type": "OTHER"
			},
			{
				"name": "bakery dough machine",
				"salience": 0.0028129555,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0028129555,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0028129555,
				"type": "LOCATION"
			},
			{
				"name": "Isaac",
				"salience": 0.0027959957,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0027548503,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0026904838,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_myf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Express"
				},
				"name": "Express",
				"salience": 0.002565322,
				"type": "ORGANIZATION"
			},
			{
				"name": "UK Mirror",
				"salience": 0.002565322,
				"type": "ORGANIZATION"
			},
			{
				"name": "mother",
				"salience": 0.0024673324,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0024673324,
				"type": "PERSON"
			},
			{
				"name": "identity",
				"salience": 0.0023856482,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0020582029,
				"type": "LOCATION"
			},
			{
				"name": "baby",
				"salience": 0.0020582029,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0017988482,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0017988482,
				"type": "PERSON"
			},
			{
				"name": "mother",
				"salience": 0.0017971888,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02p2ztb"
				},
				"name": "Bruce",
				"salience": 0.0016013265,
				"type": "PERSON"
			},
			{
				"name": "room",
				"salience": 0.0014991172,
				"type": "LOCATION"
			},
			{
				"name": "baby",
				"salience": 0.0014991172,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.001492422,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christ"
				},
				"name": "Christ",
				"salience": 0.0014751502,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g8rcp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Christian_Post"
				},
				"name": "Christian Post",
				"salience": 0.0014685619,
				"type": "ORGANIZATION"
			},
			{
				"name": "chambers",
				"salience": 0.0009697156,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0009697156,
				"type": "PERSON"
			},
			{
				"name": "testimony",
				"salience": 0.0009697156,
				"type": "OTHER"
			},
			{
				"name": "slayings",
				"salience": 0.0009697156,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0009697156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03mkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Parliament_of_the_United_Kingdom"
				},
				"name": "UK Parliament",
				"salience": 0.0005968142,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0n1p1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paradise"
				},
				"name": "Heaven",
				"salience": 0.0005968142,
				"type": "LOCATION"
			},
			{
				"name": "film footage",
				"salience": 0.00050783146,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477657535isis-syria-723942.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T15:49:50.985+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nISIS barbarians used an industrial dough kneader to kill 250 children, and roasted adults in a bakery oven, according to a shocking new report. \nIn an interview with the humanitarian organization Roads of Success, Syrian mom Alice Assaf went into chilling detail about the atrocities the jihadists committed about two years ago in the town of Douma, explaining that some of the youngsters were even decapitated in front of their parents, according to the Express. \n“We heard that the militants grabbed six strong men working at the bakery and burned them inside the oven. We knew them,” Assaf told Dr. Yvette Isaac, who works for the advocacy group, according to the UK Mirror. \n“After that, they caught some 250 kids and kneaded them like dough in the bakery dough machine,” Assaf said, according to media reports. “They were put in the dough mixer, they were kneaded. The oldest one of them was four-years-old.” \nISIS transported hundreds of girls to the city of Douma, which has been at the center of the Syrian civil war, to be slaughtered. ISIS has been systematically killing non-Muslims, and the majority of its victims at the time were Christian. \nAssaf said her own son, George, was killed by the radical militants after he refused to switch to a Muslim name. \n“My son said to me, ‘No, mother, I don’t want to die with an identity not my own. I prefer to die with the name George,'” Assaf said, according to the Christian Post. \nAssaf added, “I asked my son then to hide, but he refused and said, ‘I don’t want to hide myself. You are the one who taught me to follow what Christ said’ — ‘whoever denies me before man, I will also deny before my father who is in Heaven.'” \nDr. Isaac reported the savage slayings to a member of the UK Parliament, Fiona Bruce, who recently recounted the horrifying testimony to her colleagues in open chambers. \n“She showed us recent film footage of herself talking with mothers–more than one– who had seen their own children crucified,” Bruce said. \n“She told us of a mother with a two-month-old baby. When [ISIS] knocked at the front door of her house and ordered the entire family out, she pleaded with them to let her collect her child from another room,” Bruce said. \n“She told us of a mother with a two-month-old baby,” Bruce continued. When [ISIS] knocked at the front door of her house and ordered the entire family out, she pleaded with them to let her collect her child from another room. They told her, ‘No. Go. It is ours now.’”",
		"thread_title": "ISIS uses an industrial dough kneader to kill 250 children, roasts adults in a bakery oven in Douma, Syria",
		"title": "ISIS uses an industrial dough kneader to kill 250 children, roasts adults in a bakery oven in Douma, Syria",
		"type": "conspiracy",
		"uuid": "f4024d3430d469ed860093f5ad0eb11cbd93ce5d"
	},
	"-KhIjVKSaKfXAOboFYlq": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:22:28.381+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Robert Dougherty",
				"salience": 0.82325923,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.03391709,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.023708956,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.016583862,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.015598738,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.01315261,
				"type": "PERSON"
			},
			{
				"name": "identities",
				"salience": 0.007585423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0yjhj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jacksonville,_North_Carolina"
				},
				"name": "Jacksonville",
				"salience": 0.0075595607,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0068393927,
				"type": "LOCATION"
			},
			{
				"name": "ID",
				"salience": 0.0058206925,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0050660106,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0050660106,
				"type": "EVENT"
			},
			{
				"name": "time",
				"salience": 0.004105113,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0037407235,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.0035746272,
				"type": "OTHER"
			},
			{
				"name": "sticker",
				"salience": 0.0033959295,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0033532484,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0029046251,
				"type": "OTHER"
			},
			{
				"name": "sticker",
				"salience": 0.0028809435,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.0023128493,
				"type": "OTHER"
			},
			{
				"name": "Voter Fraud",
				"salience": 0.0017595373,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0015817629,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.0013369549,
				"type": "ORGANIZATION"
			},
			{
				"name": "addresses",
				"salience": 0.0012915129,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.0012433353,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0008942736,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0007394077,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00072758755,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776678751.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:22:28.381+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nHillary supporter Robert Dougherty from Jacksonville, North Carolina bragged on Facebook today about how he committed voter fraud. \nRobert boasted on how he voted for some of his Facebook friends using their identities, and tells them not to worry about voting, because he’s already done it for them. \nAnd he’s bragging about it on Facebook. \nRobert boasts about how they give you a sticker every time you vote. \nHe says he will continue to vote all next week! \n“Isn’t North Carolina nice they give you a sticker every time you vote… No ID required.” \n“There isn’t a need for you to wait in line anymore. Took care of it for you. Gave you a straight Democratic ticket.” \n“Amazing how many addresses you get from Google. Going again until Saturday and all next week.” \nRobert either thinks voter fraud is a big joke or he’s one stupid Hillary-supporting criminal. \nWhat do you think, will Voter Fraud play a key role in the election?",
		"thread_title": "North Carolina Hillary Supporter Brags on Facebook About Voting Multiple Times",
		"title": "North Carolina Hillary Supporter Brags on Facebook About Voting Multiple Times",
		"type": "conspiracy",
		"uuid": "a3d40b807d89442c721b34fb42248323e8096d67"
	},
	"-KhIjVV3sYNn38eDViVO": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:22:29.138+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "complaints",
				"salience": 0.17652236,
				"type": "OTHER"
			},
			{
				"name": "ballots",
				"salience": 0.15216579,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.11368717,
				"type": "PERSON"
			},
			{
				"name": "MecklenburgCatawba",
				"salience": 0.080456816,
				"type": "PERSON"
			},
			{
				"name": "voter",
				"salience": 0.042521328,
				"type": "PERSON"
			},
			{
				"name": "machines",
				"salience": 0.041257817,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cases",
				"salience": 0.026235083,
				"type": "OTHER"
			},
			{
				"name": "selections",
				"salience": 0.023184331,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.02276189,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.018677944,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.013071959,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.012922491,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.012648602,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.011694368,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.011694368,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.010602757,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.010209115,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.008879725,
				"type": "PERSON"
			},
			{
				"name": "machines",
				"salience": 0.008830956,
				"type": "OTHER"
			},
			{
				"name": "touch-screen machines",
				"salience": 0.008186726,
				"type": "OTHER"
			},
			{
				"name": "Gannon",
				"salience": 0.008186311,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.008161399,
				"type": "OTHER"
			},
			{
				"name": "elections officials",
				"salience": 0.007885181,
				"type": "PERSON"
			},
			{
				"name": "election official",
				"salience": 0.0071272654,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.006393914,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.006393914,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0061999992,
				"type": "EVENT"
			},
			{
				"name": "machines",
				"salience": 0.0061999992,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "elections",
				"salience": 0.005969252,
				"type": "EVENT"
			},
			{
				"name": "touch-screen voting machines",
				"salience": 0.005969252,
				"type": "OTHER"
			},
			{
				"name": "selections",
				"salience": 0.0052831257,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.0052227904,
				"type": "PERSON"
			},
			{
				"name": "machine",
				"salience": 0.0050642896,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0050642896,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03ccf47",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_Board_of_Elections"
				},
				"name": "State Board of Elections",
				"salience": 0.005007462,
				"type": "ORGANIZATION"
			},
			{
				"name": "audit log",
				"salience": 0.0048605786,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0048306887,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0048306887,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0048306887,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0048161126,
				"type": "PERSON"
			},
			{
				"name": "election official",
				"salience": 0.004085559,
				"type": "PERSON"
			},
			{
				"name": "touch-screen machines",
				"salience": 0.0037854032,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0037672408,
				"type": "OTHER"
			},
			{
				"name": "accuracy",
				"salience": 0.003538628,
				"type": "OTHER"
			},
			{
				"name": "selection accuracy",
				"salience": 0.003538628,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0033891757,
				"type": "OTHER"
			},
			{
				"name": "safeguards",
				"salience": 0.0033891757,
				"type": "OTHER"
			},
			{
				"name": "Kim Westbrook Strach",
				"salience": 0.0032698659,
				"type": "PERSON"
			},
			{
				"name": "advocacy groups",
				"salience": 0.0032628428,
				"type": "ORGANIZATION"
			},
			{
				"name": "counties",
				"salience": 0.0032628428,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.0031275614,
				"type": "WORK_OF_ART"
			},
			{
				"name": "voting",
				"salience": 0.0031155786,
				"type": "EVENT"
			},
			{
				"name": "paper ballots",
				"salience": 0.0030533967,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0028622218,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.002767528,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0026982964,
				"type": "OTHER"
			},
			{
				"name": "accuracy",
				"salience": 0.0026444301,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.002636441,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "N.C.",
				"salience": 0.002431629,
				"type": "ORGANIZATION"
			},
			{
				"name": "NC State Board Of Election",
				"salience": 0.002235182,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections officials",
				"salience": 0.002224561,
				"type": "PERSON"
			},
			{
				"name": "machine",
				"salience": 0.0020609659,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0020609659,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0017395216,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0015063805,
				"type": "OTHER"
			},
			{
				"name": "recalibration",
				"salience": 0.0011253911,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0011253911,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0007863956,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776677501.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:22:29.138+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "MecklenburgCatawba \nThe complaints noted that the machines wrongly identified a voter’s choice, but in all reported cases, the voters were able to correct their ballots before casting them. \n“To my knowledge, at this point, we don’t have any cases where elections officials noted significant problems with any machines based on these complaints. Of course they’re all looked into and that’s why we encourage people to immediately flag down an election official,” commented Gannon. \nThe NC State Board Of Election released the following statement regarding the complaints: \nThe N.C. State Board of Elections is aware that some voters have contacted advocacy groups or elections officials with concerns about touch-screen voting machines in several counties. \nSimilar reports have been made in recent elections, and we take them very seriously. \nWe want to ensure voters that safeguards are in place to ensure touch-screen machines accurately record voters’ selections. \nTouch-screen machines are tested thoroughly before each election. They are recalibrated daily before voting begins to test and ensure accuracy. If a voter notices an issue with selection accuracy of a machine, they should raise their hand and notify an election official immediately. If needed, the machine may be taken out of service for recalibration, and the voter may be moved to a different machine. \nAlso, each touch-screen machine prompts voters to review their selections before casting their ballot. As with paper ballots, voters should check over their selections to ensure accuracy prior to casting their ballot. On touch-screen machines, voters also can review a real-time audit log that records all of their selections. \n“We urge all voters to carefully review their selections before casting their ballots, and to immediately report any questions or concerns to elections officials,” said Kim Westbrook Strach, executive director of the N.C. State Board of Elections.",
		"thread_title": "3 Charlotte Area Counties Report Voting Machines Picking Wrong Candidates",
		"title": "3 Charlotte Area Counties Report Voting Machines Picking Wrong Candidates",
		"type": "conspiracy",
		"uuid": "9a8c817fc512a8af8f096f9471bf3c2a747eb1c7"
	},
	"-KhIjVeeM3bpqNoXED9b": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:22:31.695+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/047blr4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jason_Chaffetz"
				},
				"name": "Jason Chaffetz",
				"salience": 0.26626557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.1797479,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.06768409,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.04179699,
				"type": "PERSON"
			},
			{
				"name": "Corruption",
				"salience": 0.040231545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.037415598,
				"type": "LOCATION"
			},
			{
				"name": "manipulation",
				"salience": 0.036109436,
				"type": "OTHER"
			},
			{
				"name": "pit",
				"salience": 0.03132389,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.03132389,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024tds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Devin_Nunes"
				},
				"name": "DEVIN NUNES",
				"salience": 0.022283014,
				"type": "PERSON"
			},
			{
				"name": "documentation",
				"salience": 0.02222025,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.016084893,
				"type": "PERSON"
			},
			{
				"name": "option",
				"salience": 0.015262944,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.015112835,
				"type": "PERSON"
			},
			{
				"name": "DOCUMENTS",
				"salience": 0.014508573,
				"type": "WORK_OF_ART"
			},
			{
				"name": "documentation",
				"salience": 0.0105590485,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.007668179,
				"type": "OTHER"
			},
			{
				"name": "manipulation",
				"salience": 0.0070617306,
				"type": "OTHER"
			},
			{
				"name": "queen",
				"salience": 0.0066421763,
				"type": "PERSON"
			},
			{
				"name": "treason",
				"salience": 0.0066421763,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.0066421763,
				"type": "LOCATION"
			},
			{
				"name": "standard",
				"salience": 0.0066421763,
				"type": "OTHER"
			},
			{
				"name": "MEMBERS",
				"salience": 0.006558651,
				"type": "PERSON"
			},
			{
				"name": "Chairman",
				"salience": 0.0064480524,
				"type": "PERSON"
			},
			{
				"name": "email server",
				"salience": 0.0053802077,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0051565804,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05rw4y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Committee_on_Oversight_and_Government_Reform"
				},
				"name": "House Committee on Oversight and Government Reform",
				"salience": 0.004888627,
				"type": "ORGANIZATION"
			},
			{
				"name": "EMAILS",
				"salience": 0.004865303,
				"type": "WORK_OF_ART"
			},
			{
				"name": "EMAIL",
				"salience": 0.004865303,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00480073,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.0046597864,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0044860644,
				"type": "OTHER"
			},
			{
				"name": "SERVER",
				"salience": 0.004393457,
				"type": "OTHER"
			},
			{
				"name": "HEARINGS",
				"salience": 0.004373857,
				"type": "EVENT"
			},
			{
				"name": "EXCHANGE",
				"salience": 0.0038049703,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0031260327,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0028430563,
				"type": "OTHER"
			},
			{
				"name": "negotiation",
				"salience": 0.0028430563,
				"type": "EVENT"
			},
			{
				"name": "quid pro quo",
				"salience": 0.0028430563,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cq0r_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Undersecretary"
				},
				"name": "UNDERSECRETARY OF STATE",
				"salience": 0.0027053326,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0611v_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patrick_F._Kennedy"
				},
				"name": "PATRICK KENNEDY",
				"salience": 0.0026612543,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "DEMOCRATIC",
				"salience": 0.0023427599,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0496dt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recess_(break)"
				},
				"name": "RECESS",
				"salience": 0.0023427599,
				"type": "WORK_OF_ART"
			},
			{
				"name": "MOVE CHAFFETZ",
				"salience": 0.0022202036,
				"type": "PERSON"
			},
			{
				"name": "proposal",
				"salience": 0.0021786608,
				"type": "OTHER"
			},
			{
				"name": "downgrade",
				"salience": 0.0020973634,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0020709434,
				"type": "EVENT"
			},
			{
				"name": "crime",
				"salience": 0.0020709434,
				"type": "OTHER"
			},
			{
				"name": "agency officials",
				"salience": 0.0020709434,
				"type": "PERSON"
			},
			{
				"name": "fruition",
				"salience": 0.0020709434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0017502506,
				"type": "ORGANIZATION"
			},
			{
				"name": "congressmen",
				"salience": 0.0016170873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0016016077,
				"type": "LOCATION"
			},
			{
				"name": "DEAL",
				"salience": 0.0015471386,
				"type": "OTHER"
			},
			{
				"name": "The Daily Caller News Foundation",
				"salience": 0.001181381,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07nxbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Permanent_Select_Committee_on_Intelligence"
				},
				"name": "HOUSE PERMANENT SELECT COMMITTEE ON INTELLIGENCE",
				"salience": 0.0009522717,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/017jyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quid_pro_quo"
				},
				"name": "QUID PRO QUO",
				"salience": 0.0009522717,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776676171.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:22:31.695+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "The Corruption of the Clinton’s is like an endless dark pit of lies and manipulation. \nI am so sick of Clinton’s and I can’t believe anyone would vote for her. This FBI that is lying and trying to change documentation should be held to a legal standard and people who have tried to hide documentation and have lied should be thrown in prison for treason! \nAs far as how the media treats Hillary Clinton, if you’ve noticed, they treat her like a queen. The liberal media likes to pamper, lie, and make sure America knows she is the best option. We, however, know better. So does Jason Chaffetz. \nFor those of you who do it know who Chaffetz is, he is the House Committee on Oversight and Government Reform Chairman who famously told the guy who destroyed Hillary’s email server that he was served on live TV. Now he just served up a brutal threat to Hillary Clinton and she is running scared. \nHOUSE COMMITTEE ON OVERSIGHT AND GOVERNMENT REFORM CHAIRMAN JASON CHAFFETZ CONFIRMED IT WILL HOLD ADDITIONAL HEARINGS ON DEMOCRATIC NOMINEE HILLARY CLINTON’S PRIVATE EMAIL SERVER WHEN MEMBERS RETURN FROM RECESS. \nNEW FBI DOCUMENTS RELEASED MONDAY SHOW UNDERSECRETARY OF STATE PATRICK KENNEDY PUSHING THE FBI TO DECLASSIFY EMAILS IN EXCHANGE FOR A “QUID PRO QUO” DEAL — A MOVE CHAFFETZ AND HOUSE PERMANENT SELECT COMMITTEE ON INTELLIGENCE CHAIRMAN DEVIN NUNES FOUND DEEPLY TROUBLING. \n“Undoubtedly there will be, based on the documents the FBI released today there are new facts that need to be investigated. I’m very concerned about the quid pro quo that was in negotiation between the State Department and the FBI,” Chaffetz told The Daily Caller News Foundation. “Chairman Nunes and I believe Patrick Kennedy should be relieved of his duties immediately pending an investigation. This is a manipulation if not an outright crime and so we’re gonna drive into that.” \nWhile the downgrade discussed between the agency officials didn’t come into fruition, the congressmen were clear they believe the proposal was inappropriate.",
		"thread_title": "JASON CHAFFETZ EXPOSED HILLARY CLINTON’S PLAN TO BRIBE FBI AGENTS TO LET HER GO",
		"title": "JASON CHAFFETZ EXPOSED HILLARY CLINTON’S PLAN TO BRIBE FBI AGENTS TO LET HER GO",
		"type": "conspiracy",
		"uuid": "facd3b35fee9a42cc19c07bc424bc0701b4eb53f"
	},
	"-KhIjVtROPivcNi0mnOe": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:22:32.022+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "poll",
				"salience": 0.14463015,
				"type": "OTHER"
			},
			{
				"name": "seniors",
				"salience": 0.12002719,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06701629,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.05598517,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.04553119,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.036289666,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kfd2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Begala"
				},
				"name": "Paul Begala",
				"salience": 0.036171425,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.031687517,
				"type": "WORK_OF_ART"
			},
			{
				"name": "polls",
				"salience": 0.030932873,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.02354256,
				"type": "PERSON"
			},
			{
				"name": "operatives",
				"salience": 0.02344519,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.022862986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "poll",
				"salience": 0.019306699,
				"type": "OTHER"
			},
			{
				"name": "ends",
				"salience": 0.018774293,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.017444775,
				"type": "PERSON"
			},
			{
				"name": "Tom Matzzie",
				"salience": 0.017010584,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.01697422,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.01697422,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.013610323,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rqmk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Brock"
				},
				"name": "David Brock",
				"salience": 0.011798199,
				"type": "PERSON"
			},
			{
				"name": "Susan McCue",
				"salience": 0.011798199,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05pdb7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rand_Paul"
				},
				"name": "Rand Paul",
				"salience": 0.010394044,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.010217831,
				"type": "ORGANIZATION"
			},
			{
				"name": "polling",
				"salience": 0.009707655,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.008842969,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.008663672,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.008315326,
				"type": "PERSON"
			},
			{
				"name": "seniors",
				"salience": 0.008093859,
				"type": "PERSON"
			},
			{
				"name": "tracking poll",
				"salience": 0.007634442,
				"type": "OTHER"
			},
			{
				"name": "FYI",
				"salience": 0.007011081,
				"type": "OTHER"
			},
			{
				"name": "oversample",
				"salience": 0.007011081,
				"type": "OTHER"
			},
			{
				"name": "lead",
				"salience": 0.006610715,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.005688884,
				"type": "OTHER"
			},
			{
				"name": "newsrooms",
				"salience": 0.005679203,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.005493921,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.005174382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.004986688,
				"type": "LOCATION"
			},
			{
				"name": "bounce",
				"salience": 0.0049188347,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.0049188347,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0047354754,
				"type": "PERSON"
			},
			{
				"name": "sampling",
				"salience": 0.0047354754,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.0040165833,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0040165833,
				"type": "ORGANIZATION"
			},
			{
				"name": "nomination",
				"salience": 0.0040165833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0038735266,
				"type": "PERSON"
			},
			{
				"name": "election turnout",
				"salience": 0.0034655856,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0030012452,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.0030012452,
				"type": "LOCATION"
			},
			{
				"name": "conclusion",
				"salience": 0.0030012452,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0030012452,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.0029911057,
				"type": "OTHER"
			},
			{
				"name": "Polls",
				"salience": 0.0029911057,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02zndc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Media_Matters_for_America"
				},
				"name": "Media Matters for America",
				"salience": 0.0029161011,
				"type": "ORGANIZATION"
			},
			{
				"name": "lead",
				"salience": 0.0028656954,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.002855868,
				"type": "ORGANIZATION"
			},
			{
				"name": "turnout",
				"salience": 0.0025245794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.0024731432,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0024731432,
				"type": "PERSON"
			},
			{
				"name": "Surveymonkey",
				"salience": 0.0024731432,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.0024397422,
				"type": "WORK_OF_ART"
			},
			{
				"name": "form",
				"salience": 0.002329259,
				"type": "OTHER"
			},
			{
				"name": "operatives",
				"salience": 0.002261075,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.0021862139,
				"type": "PERSON"
			},
			{
				"name": "rigging",
				"salience": 0.0021862139,
				"type": "OTHER"
			},
			{
				"name": "propaganda tool",
				"salience": 0.0021314844,
				"type": "OTHER"
			},
			{
				"name": "topline result",
				"salience": 0.0018861237,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0018076267,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tactics",
				"salience": 0.0016332752,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0016332752,
				"type": "OTHER"
			},
			{
				"name": "The Tom Roten Show",
				"salience": 0.0015541211,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/081mh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Virginia"
				},
				"name": "West Virginia",
				"salience": 0.0013457568,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776674571.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:22:32.022+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAn email published by WikiLeaks on Friday reveals the extent to which Democrats and their allies manipulate polls to serve their ends. \nThe 2008 email appears shows Democratic operatives plotting to intentionally oversample seniors in a poll in order to get their desired results. \n“FYI: We are going to try to do an oversample of seniors on the poll. Sample too small otherwise,” operative Tom Matzzie wrote to Clinton adviser Paul Begala, campaign Chairman John Podesta, Media Matters for America founder David Brock, and operative Susan McCue. “Good,” Begala responded. \nTrump and his supporters have claimed often that many polls showing a significant Hillary lead over Trump have been manipulated through selective sampling. There is ample evidence that this occurs in Democrat-friendly newsrooms. \n“Hillary Clinton has opened up a 7-point lead over Donald Trump in an online poll that seems to reflect a ‘bounce’ for the former secretary of state after she wrapped up the Democratic nomination last week,” the Daily Mail reported in June. \n\"But the weekly tracking poll, from NBC News and the Surveymonkey company, included the opinions of 7 percent more self-identified Democrats than Republicans – the same margin as the poll's topline result,\" the article noted. \nThe email released by WikiLeaks Friday proves that Democratic operatives themselves engage eagerly in such tactics. \nPolls are a powerful propaganda tool, and people exposed repeatedly to polls suggesting their candidate's loss is a foregone conclusion will often be influenced to stay home on Election Day. \n\"I think sometimes polling is done to dampen election turnout,\" Rand Paul said in an interview on Wednesday on \"The Tom Roten Show\" out of West Virginia. \"When we say over and over someone can't win that is a form of rigging in the sense that it is designed to suppress turnout,\" he added.",
		"thread_title": "WikiLeaks: Email Proves Democrats Manipulate Polls",
		"title": "WikiLeaks: Email Proves Democrats Manipulate Polls",
		"type": "conspiracy",
		"uuid": "9dbf9a10f62e88cba29777fb45d2f7d3f5817776"
	},
	"-KhIjW284ISRXvzFAygE": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:22:33.244+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0c6qh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brad_Pitt"
				},
				"name": "Brad Pitt",
				"salience": 0.7175927,
				"type": "PERSON"
			},
			{
				"name": "businessman",
				"salience": 0.039791327,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.033176173,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.026716473,
				"type": "OTHER"
			},
			{
				"name": "Unemployment",
				"salience": 0.017678235,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.01585965,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.013750465,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.013750465,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0067778784,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.0065636053,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0058579533,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0056862743,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0056862743,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0056862743,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.004910992,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.004606798,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.004606798,
				"type": "EVENT"
			},
			{
				"name": "interview",
				"salience": 0.004606798,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.0040453845,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0039903712,
				"type": "WORK_OF_ART"
			},
			{
				"name": "son",
				"salience": 0.0039903712,
				"type": "PERSON"
			},
			{
				"name": "preacher",
				"salience": 0.0039903712,
				"type": "PERSON"
			},
			{
				"name": "beliefs",
				"salience": 0.0038417066,
				"type": "OTHER"
			},
			{
				"name": "heat",
				"salience": 0.0038417066,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0037624536,
				"type": "LOCATION"
			},
			{
				"name": "face",
				"salience": 0.0032587769,
				"type": "OTHER"
			},
			{
				"name": "teen",
				"salience": 0.0032587769,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0032587769,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00281192,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03m3pj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Christian_sentiment"
				},
				"name": "anti-Christian",
				"salience": 0.002732193,
				"type": "OTHER"
			},
			{
				"name": "celebrities",
				"salience": 0.0027293586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.0023662322,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0022687502,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0020486326,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0020069056,
				"type": "PERSON"
			},
			{
				"name": "run",
				"salience": 0.0017741291,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.0017315246,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0015306583,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/060c4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President"
				},
				"name": "Presidency",
				"salience": 0.0013968692,
				"type": "ORGANIZATION"
			},
			{
				"name": "faith",
				"salience": 0.0013255025,
				"type": "OTHER"
			},
			{
				"name": "devotion",
				"salience": 0.0013255025,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0013255025,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0010922012,
				"type": "PERSON"
			},
			{
				"name": "experience",
				"salience": 0.0009902506,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776672551.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:22:33.244+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\n“We need more and more jobs. Unemployment is way up here,” he said. “He’s hired more employees, more people, than anyone I know in the world.” \nI believe in him first of all because he’s a businessman. I think jobs are badly needed. \nHollywood star, Brad Pitt is usually catching some heat through supporters of President Obama after calling his agenda “anti-Christian.” \nPitt talked out about his own Christian beliefs during the 1999 interview. During the interview, he shared his story of how he or she uncovered religion. \nAs the particular son of a preacher and spending a majority of his time in the church, he grew to become rebellious as a teen. \nAfter what Pitt calls a personal face along with God, he came back in order to the church in his 20s. \n“I had this particular tremendous physical and spiritual experience.” \nHis devotion to his faith has shocked liberal Hollywood plus angered President Obama supporters who support his alleged “anti-Christian agenda.” \nAs other celebrities live a liberal and free life-style, Pitt has explained that he is proud of his religion \nBecause of this, Brad has finally come out in support of Donald Trump and his run for Presidency.",
		"thread_title": "Brad Pitt SHOCKS AMERICA: “I’m Tired Of Liberals Taking My Money. I’m Voting For TRUMP!”",
		"title": "Brad Pitt SHOCKS AMERICA: “I’m Tired Of Liberals Taking My Money. I’m Voting For TRUMP!”",
		"type": "conspiracy",
		"uuid": "58fd2205c45efe57ef6e9b19a999b2545015f535"
	},
	"-KhIjWId6ljntuWS5_g1": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:22:39.924+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Fiona Bruce",
				"salience": 0.10327633,
				"type": "PERSON"
			},
			{
				"name": "jihadists",
				"salience": 0.09465254,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.09222552,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02qgf3r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Douma,_Syria"
				},
				"name": "Douma",
				"salience": 0.08301967,
				"type": "LOCATION"
			},
			{
				"name": "Assaf",
				"salience": 0.06597657,
				"type": "PERSON"
			},
			{
				"name": "Alice Assaf",
				"salience": 0.05318685,
				"type": "PERSON"
			},
			{
				"name": "son",
				"salience": 0.03560078,
				"type": "PERSON"
			},
			{
				"name": "dough",
				"salience": 0.027222956,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.027222956,
				"type": "PERSON"
			},
			{
				"name": "bakery oven",
				"salience": 0.02274486,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.02274486,
				"type": "WORK_OF_ART"
			},
			{
				"name": "kneader",
				"salience": 0.019716976,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "barbarians",
				"salience": 0.019716976,
				"type": "PERSON"
			},
			{
				"name": "adults",
				"salience": 0.019716976,
				"type": "PERSON"
			},
			{
				"name": "kids",
				"salience": 0.019464174,
				"type": "PERSON"
			},
			{
				"name": "Yvette Isaac",
				"salience": 0.014389575,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0411145"
				},
				"name": "George",
				"salience": 0.0122538945,
				"type": "PERSON"
			},
			{
				"name": "mothers",
				"salience": 0.011862796,
				"type": "PERSON"
			},
			{
				"name": "some",
				"salience": 0.011660766,
				"type": "OTHER"
			},
			{
				"name": "Roads",
				"salience": 0.010102649,
				"type": "ORGANIZATION"
			},
			{
				"name": "town",
				"salience": 0.010102649,
				"type": "LOCATION"
			},
			{
				"name": "atrocities",
				"salience": 0.010102649,
				"type": "OTHER"
			},
			{
				"name": "detail",
				"salience": 0.010102649,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.010102649,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.010102649,
				"type": "EVENT"
			},
			{
				"name": "family",
				"salience": 0.00907569,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.008958087,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.008126793,
				"type": "LOCATION"
			},
			{
				"name": "child",
				"salience": 0.0070743826,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.006696812,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048knk3"
				},
				"name": "Success",
				"salience": 0.006226125,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0059030564,
				"type": "LOCATION"
			},
			{
				"name": "door",
				"salience": 0.0059030564,
				"type": "OTHER"
			},
			{
				"name": "bakery",
				"salience": 0.0053270007,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.0048104636,
				"type": "PERSON"
			},
			{
				"name": "oven",
				"salience": 0.0048104636,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.004166213,
				"type": "PERSON"
			},
			{
				"name": "youngsters",
				"salience": 0.004166213,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.004166213,
				"type": "OTHER"
			},
			{
				"name": "advocacy group",
				"salience": 0.004166213,
				"type": "ORGANIZATION"
			},
			{
				"name": "mother",
				"salience": 0.004044339,
				"type": "PERSON"
			},
			{
				"name": "dough",
				"salience": 0.003893528,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0037842111,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0033740525,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0033740525,
				"type": "OTHER"
			},
			{
				"name": "media reports",
				"salience": 0.0032482047,
				"type": "OTHER"
			},
			{
				"name": "civil war",
				"salience": 0.0029219592,
				"type": "EVENT"
			},
			{
				"name": "non-Muslims",
				"salience": 0.0029219592,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.0029219592,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.0028129555,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0028129555,
				"type": "OTHER"
			},
			{
				"name": "dough mixer",
				"salience": 0.0028129555,
				"type": "OTHER"
			},
			{
				"name": "bakery dough machine",
				"salience": 0.0028129555,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0028129555,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0028129555,
				"type": "LOCATION"
			},
			{
				"name": "Isaac",
				"salience": 0.0027959957,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0027548503,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0026904838,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_myf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Express"
				},
				"name": "Express",
				"salience": 0.002565322,
				"type": "ORGANIZATION"
			},
			{
				"name": "UK Mirror",
				"salience": 0.002565322,
				"type": "ORGANIZATION"
			},
			{
				"name": "mother",
				"salience": 0.0024673324,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0024673324,
				"type": "PERSON"
			},
			{
				"name": "identity",
				"salience": 0.0023856482,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0020582029,
				"type": "LOCATION"
			},
			{
				"name": "baby",
				"salience": 0.0020582029,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0017988482,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0017988482,
				"type": "PERSON"
			},
			{
				"name": "mother",
				"salience": 0.0017971888,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02p2ztb"
				},
				"name": "Bruce",
				"salience": 0.0016013265,
				"type": "PERSON"
			},
			{
				"name": "room",
				"salience": 0.0014991172,
				"type": "LOCATION"
			},
			{
				"name": "baby",
				"salience": 0.0014991172,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.001492422,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christ"
				},
				"name": "Christ",
				"salience": 0.0014751502,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g8rcp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Christian_Post"
				},
				"name": "Christian Post",
				"salience": 0.0014685619,
				"type": "ORGANIZATION"
			},
			{
				"name": "chambers",
				"salience": 0.0009697156,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.0009697156,
				"type": "PERSON"
			},
			{
				"name": "testimony",
				"salience": 0.0009697156,
				"type": "OTHER"
			},
			{
				"name": "slayings",
				"salience": 0.0009697156,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0009697156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03mkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Parliament_of_the_United_Kingdom"
				},
				"name": "UK Parliament",
				"salience": 0.0005968142,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0n1p1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paradise"
				},
				"name": "Heaven",
				"salience": 0.0005968142,
				"type": "LOCATION"
			},
			{
				"name": "film footage",
				"salience": 0.00050783146,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477657535isis-syria-723942.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:22:39.924+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nISIS barbarians used an industrial dough kneader to kill 250 children, and roasted adults in a bakery oven, according to a shocking new report. \nIn an interview with the humanitarian organization Roads of Success, Syrian mom Alice Assaf went into chilling detail about the atrocities the jihadists committed about two years ago in the town of Douma, explaining that some of the youngsters were even decapitated in front of their parents, according to the Express. \n“We heard that the militants grabbed six strong men working at the bakery and burned them inside the oven. We knew them,” Assaf told Dr. Yvette Isaac, who works for the advocacy group, according to the UK Mirror. \n“After that, they caught some 250 kids and kneaded them like dough in the bakery dough machine,” Assaf said, according to media reports. “They were put in the dough mixer, they were kneaded. The oldest one of them was four-years-old.” \nISIS transported hundreds of girls to the city of Douma, which has been at the center of the Syrian civil war, to be slaughtered. ISIS has been systematically killing non-Muslims, and the majority of its victims at the time were Christian. \nAssaf said her own son, George, was killed by the radical militants after he refused to switch to a Muslim name. \n“My son said to me, ‘No, mother, I don’t want to die with an identity not my own. I prefer to die with the name George,'” Assaf said, according to the Christian Post. \nAssaf added, “I asked my son then to hide, but he refused and said, ‘I don’t want to hide myself. You are the one who taught me to follow what Christ said’ — ‘whoever denies me before man, I will also deny before my father who is in Heaven.'” \nDr. Isaac reported the savage slayings to a member of the UK Parliament, Fiona Bruce, who recently recounted the horrifying testimony to her colleagues in open chambers. \n“She showed us recent film footage of herself talking with mothers–more than one– who had seen their own children crucified,” Bruce said. \n“She told us of a mother with a two-month-old baby. When [ISIS] knocked at the front door of her house and ordered the entire family out, she pleaded with them to let her collect her child from another room,” Bruce said. \n“She told us of a mother with a two-month-old baby,” Bruce continued. When [ISIS] knocked at the front door of her house and ordered the entire family out, she pleaded with them to let her collect her child from another room. They told her, ‘No. Go. It is ours now.’”",
		"thread_title": "ISIS uses an industrial dough kneader to kill 250 children, roasts adults in a bakery oven in Douma, Syria",
		"title": "ISIS uses an industrial dough kneader to kill 250 children, roasts adults in a bakery oven in Douma, Syria",
		"type": "conspiracy",
		"uuid": "887859ae24da488a3869db97a08689f13b946dad"
	},
	"-KhIjWX1pGP7RPdM9RQU": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:34:47.857+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b76qwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Walsh_(Illinois_politician)"
				},
				"name": "Joe Walsh",
				"salience": 0.61645555,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06695559,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.022550283,
				"type": "OTHER"
			},
			{
				"name": "musket",
				"salience": 0.017998086,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.015983855,
				"type": "EVENT"
			},
			{
				"name": "insurrection",
				"salience": 0.0115642985,
				"type": "OTHER"
			},
			{
				"name": "radio host",
				"salience": 0.0115642985,
				"type": "PERSON"
			},
			{
				"name": "post",
				"salience": 0.008168513,
				"type": "WORK_OF_ART"
			},
			{
				"name": "musket",
				"salience": 0.0074378215,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.007129385,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.007129385,
				"type": "LOCATION"
			},
			{
				"name": "musket",
				"salience": 0.007070865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.006895221,
				"type": "PERSON"
			},
			{
				"name": "civil disobedience",
				"salience": 0.006602174,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.005213685,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09vqjr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tammy_Duckworth"
				},
				"name": "Tammy Duckworth",
				"salience": 0.005094272,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.005073084,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.005033806,
				"type": "PERSON"
			},
			{
				"name": "musket",
				"salience": 0.0049610906,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.004832306,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.0047715064,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0047715064,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0044593127,
				"type": "EVENT"
			},
			{
				"name": "concern",
				"salience": 0.0038645293,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0038645293,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0038645293,
				"type": "OTHER"
			},
			{
				"name": "disobedience",
				"salience": 0.0037823513,
				"type": "OTHER"
			},
			{
				"name": "civil disobedience",
				"salience": 0.0037823513,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.003720429,
				"type": "OTHER"
			},
			{
				"name": "boycott",
				"salience": 0.0035208254,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0034047165,
				"type": "OTHER"
			},
			{
				"name": "@jaketapper",
				"salience": 0.0033930445,
				"type": "PERSON"
			},
			{
				"name": "@WalshFreedom",
				"salience": 0.0033930445,
				"type": "PERSON"
			},
			{
				"name": "user",
				"salience": 0.0033468513,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.0033468513,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0033468513,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0033468513,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0033468513,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0033468513,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0032220285,
				"type": "WORK_OF_ART"
			},
			{
				"name": "debate",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "suspense",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "insistence",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0029995455,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06sf9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jake_Tapper"
				},
				"name": "Jake Tapper",
				"salience": 0.0029384478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0029384478,
				"type": "ORGANIZATION"
			},
			{
				"name": "disobedience",
				"salience": 0.0028262304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.002746052,
				"type": "LOCATION"
			},
			{
				"name": "battle",
				"salience": 0.0027326844,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.0027326844,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0027326844,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.002357675,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0022907767,
				"type": "EVENT"
			},
			{
				"name": "term",
				"salience": 0.002259576,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA TODAY",
				"salience": 0.0020606315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01vrdk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Suffolk_University"
				},
				"name": "Suffolk University",
				"salience": 0.0020606315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fynw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secret_Service"
				},
				"name": "Secret Service",
				"salience": 0.0020606315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0020606315,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.0020416789,
				"type": "WORK_OF_ART"
			},
			{
				"name": "party",
				"salience": 0.0020416789,
				"type": "ORGANIZATION"
			},
			{
				"name": "criticism",
				"salience": 0.0020416789,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0019427523,
				"type": "ORGANIZATION"
			},
			{
				"name": "muskets",
				"salience": 0.0017331702,
				"type": "OTHER"
			},
			{
				"name": "musket",
				"salience": 0.0017331702,
				"type": "OTHER"
			},
			{
				"name": "police officers",
				"salience": 0.0014871032,
				"type": "PERSON"
			},
			{
				"name": "shooter",
				"salience": 0.0014871032,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0014871032,
				"type": "OTHER"
			},
			{
				"name": "punks",
				"salience": 0.0014871032,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0012772054,
				"type": "PERSON"
			},
			{
				"name": "Real America",
				"salience": 0.0012672853,
				"type": "PERSON"
			},
			{
				"name": "slingshot",
				"salience": 0.0011109189,
				"type": "OTHER"
			},
			{
				"name": "affiliate",
				"salience": 0.0011109189,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f2rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dallas"
				},
				"name": "Dallas",
				"salience": 0.0010570713,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0545qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WMAQ-TV"
				},
				"name": "NBC 5 Chicago",
				"salience": 0.0010398381,
				"type": "LOCATION"
			},
			{
				"name": "Dallas Cops",
				"salience": 0.00091532717,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776685301.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:34:47.857+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nFormer Illinois congressman and conservative radio host Joe Walsh appeared to invite armed insurrection when he tweeted that he was \"grabbing his musket\" if Hillary Clinton defeats Donald Trump in the presidential election. \n\"On November 8th, I'm voting for Trump,\" Walsh tweeted. \"On November 9th, if Trump loses, I'm grabbing my musket.\" \n\"@WalshFreedom what exactly does that mean?\" CNN's Jake Tapper tweeted in reply. \n\"@jaketapper It means protesting,\" Walsh tweeted. \"Participating in acts of civil disobedience. Doing what it takes to get our country back.\" \nWalsh's rhetoric comes as Americans are already nervous about what will happen on and after Election Day. Trump's insistence that the election is \"rigged,\" and his statement at the last debate that he would keep America \"in suspense\" about whether or not he will accept the results, have left some in fear that violence could flare up if his supporters refuse to accept the outcome. \nMore than half of Americans expressed concern about violence on election day according to a USA TODAY/Suffolk University poll released Wednesday. \nWalsh dismissed another Twitter user's concern that his call to arms could draw the attention of the Secret Service saying, \"They understand that a musket hasn't been used in battle in almost 200 years.\" \n\"I'm serious,\" Walsh tweeted later. \"I don't think a musket would do much good these days, but it's time for civil disobedience on the right.\" \nWalsh repeated his defense that he was only speaking of civil disobedience to NBC's Chicago affiliate. \"We're talking about a musket,\" Walsh said, according to NBC 5 Chicago. \"I could've said grab your slingshot and let's go. Metaphorically, I meant grab your muskets, if Trump loses, man, we're going to do what we have to do. We're going to protest and boycott and practice civil disobedience. We may start a third party.\" \nThis wasn't the first time Walsh, who served one term before being defeated by Rep. Tammy Duckworth in 2012, drew criticism for an incendiary tweet. In July he got national attention for telling President Obama to \"watch out\" after five police officers were killed by a shooter in Dallas. \n\"3 Dallas Cops killed, 7 wounded,\" Walsh tweeted in a post that has since been deleted. \"This is now war. Watch out Obama. Watch out black lives matter punks. Real America is coming after you.\"",
		"thread_title": "'If Trump loses, I'm grabbing my musket,' former congressman tweets",
		"title": "'If Trump loses, I'm grabbing my musket,' former congressman tweets",
		"type": "conspiracy",
		"uuid": "fa858167de1e5b3d01d0e5796daabcc636133a31"
	},
	"-KhIjWmKp1mxbxqiw-ve": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:34:48.130+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.33076197,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.32575342,
				"type": "PERSON"
			},
			{
				"name": "Dolly Kyle",
				"salience": 0.11622185,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.034633484,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.020901836,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.016524239,
				"type": "OTHER"
			},
			{
				"name": "duo",
				"salience": 0.0140438,
				"type": "ORGANIZATION"
			},
			{
				"name": "addiction",
				"salience": 0.009332233,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.009190569,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.006116601,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0046189153,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.004330325,
				"type": "PERSON"
			},
			{
				"name": "elsewhere",
				"salience": 0.004330325,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.0043110834,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.0036139428,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0036139428,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0036139428,
				"type": "PERSON"
			},
			{
				"name": "wonder",
				"salience": 0.0036139428,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.0035590876,
				"type": "PERSON"
			},
			{
				"name": "husband",
				"salience": 0.0028977608,
				"type": "PERSON"
			},
			{
				"name": "two",
				"salience": 0.0025939066,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0022380208,
				"type": "PERSON"
			},
			{
				"name": "worse",
				"salience": 0.00219183,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.002125344,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002097135,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.001848947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0017660259,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.001626801,
				"type": "PERSON"
			},
			{
				"name": "account",
				"salience": 0.001531748,
				"type": "OTHER"
			},
			{
				"name": "leak",
				"salience": 0.0015019248,
				"type": "OTHER"
			},
			{
				"name": "nickname",
				"salience": 0.001489663,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.001489663,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.001489663,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.001489663,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0013359975,
				"type": "EVENT"
			},
			{
				"name": "account",
				"salience": 0.0012958427,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0012900584,
				"type": "PERSON"
			},
			{
				"name": "spotlight",
				"salience": 0.0012900584,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0012009605,
				"type": "PERSON"
			},
			{
				"name": "attraction",
				"salience": 0.0011509933,
				"type": "OTHER"
			},
			{
				"name": "marriages",
				"salience": 0.0010446695,
				"type": "OTHER"
			},
			{
				"name": "bedroom habits",
				"salience": 0.0010056896,
				"type": "OTHER"
			},
			{
				"name": "habits",
				"salience": 0.0010056896,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.0010056896,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.00096092623,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02z3n9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mail_Online"
				},
				"name": "Mail Online",
				"salience": 0.0009491185,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.00094458536,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00094458536,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.00094458536,
				"type": "PERSON"
			},
			{
				"name": "deviant",
				"salience": 0.0009278738,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.000909337,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0009046445,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.0009046445,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0009046445,
				"type": "OTHER"
			},
			{
				"name": "several",
				"salience": 0.0009046445,
				"type": "LOCATION"
			},
			{
				"name": "mystery",
				"salience": 0.00087088544,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00087088544,
				"type": "PERSON"
			},
			{
				"name": "connection",
				"salience": 0.00087088544,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.00087088544,
				"type": "EVENT"
			},
			{
				"name": "secrets",
				"salience": 0.00087088544,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.00087088544,
				"type": "LOCATION"
			},
			{
				"name": "nickname",
				"salience": 0.0008528903,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.000847106,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0008364344,
				"type": "PERSON"
			},
			{
				"name": "affair",
				"salience": 0.0008149232,
				"type": "EVENT"
			},
			{
				"name": "affair",
				"salience": 0.0008149232,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0008070972,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.0007638499,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.0007385545,
				"type": "OTHER"
			},
			{
				"name": "sexual assault victims",
				"salience": 0.0007385545,
				"type": "PERSON"
			},
			{
				"name": "threats",
				"salience": 0.0007385545,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0007385545,
				"type": "OTHER"
			},
			{
				"name": "reunion",
				"salience": 0.0007385545,
				"type": "EVENT"
			},
			{
				"name": "warden",
				"salience": 0.0007385545,
				"type": "PERSON"
			},
			{
				"name": "high school",
				"salience": 0.0007385545,
				"type": "ORGANIZATION"
			},
			{
				"name": "everyone",
				"salience": 0.00070567406,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.000662325,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.00063715846,
				"type": "OTHER"
			},
			{
				"name": "hair",
				"salience": 0.00063715846,
				"type": "OTHER"
			},
			{
				"name": "hair",
				"salience": 0.00063715846,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00063715846,
				"type": "PERSON"
			},
			{
				"name": "two",
				"salience": 0.00055633904,
				"type": "PERSON"
			},
			{
				"name": "odor",
				"salience": 0.0005517293,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0005517293,
				"type": "OTHER"
			},
			{
				"name": "perspiration",
				"salience": 0.0005517293,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0005517293,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "side",
				"salience": 0.0005517293,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0004910748,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.0003885586,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00038392996,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00038392996,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00037405238,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.00034664394,
				"type": "OTHER"
			},
			{
				"name": "marriage",
				"salience": 0.00034664394,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00032802435,
				"type": "OTHER"
			},
			{
				"name": "hometown",
				"salience": 0.0003001564,
				"type": "LOCATION"
			},
			{
				"name": "rumors",
				"salience": 0.0003001564,
				"type": "OTHER"
			},
			{
				"name": "bed",
				"salience": 0.0003001564,
				"type": "OTHER"
			},
			{
				"name": "baby",
				"salience": 0.0003001564,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0003001564,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0002689774,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.00021422129,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776683501.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:34:48.130+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nNo wonder Bill went elsewhere to fulfill his “sexual addiction,” as Dolly referred to it. After all, what else can you do when you’re married to a stinky woman who doesn’t shower and isn’t attracted to men anyways? Although an affair is never justified, it’s easy to sympathize with Bill on this one. But, I digress. \nThe bigger point here is what the two are willing to do in order to remain in power. Most people know that you can’t trust Hillary as far as you can throw her – which isn’t very far – so the fact that she has any supporters is beyond baffling at this point. This woman is corrupt and fake to the core. Let’s just hope all of America wakes up to this reality before it’s too late and she can do any more damage than she already has. \nBill and Hillary Clinton just can’t stay out of the spotlight these days, and the most recent leak about them could be the most damaging yet. As it turns out, someone once close to the duo just came forward to share Bill’s revealing nickname for his wife — but the worse comes as their dirty bedroom habits were exposed. \nIt’s no mystery that Bill Clinton is a sexual deviant, but the most recent account given by the woman who had a 3-decade affair with the man is damning, to say the least. According to an exclusive interview given to Mail Online, Dolly Kyle was behind the scene’s long enough to not only know the two’s darkest secrets but even their dirty sexual habits – and now, she’s telling everyone. \nThe connection between Dolly and Bill began when she was just 11-years-old. He was about 13-years-old at the time, but Dolly states that there was an immediate attraction, even then. As the years progressed, the two became romantically involved and stayed that way through several of their marriages over the next 30 years. \nThe real affair began in 1974 just after Dolly divorced her first husband, and although Bill wasn’t married yet, he would be within the year. Although she was never interested in sharing the intimate details of the relationship, she states that she snapped when she heard Hillary recently say that all sexual assault victims have the “right to be believed.” \nKnowing full well just what Hillary had done – between the threats and the lies – to the many women who either had an affair with or were sexually assaulted by her husband Bill, Dolly knew she had to do something about it. Unfortunately for Hillary, Dolly is now coming forward with the dirty 2-word nickname Bill husband once called Hillary, among other things. \nAccording to Mail Online, Bill approached Dolly at their high school’s 35-year reunion to talk about “ the warden” – a.k.a. Hillary. Saying he was unhappy with his life and marriage, this was the least significant account Dolly had to share. \nIn fact, Dolly recalls that Bill mentioned something about having a baby to her. Although she thought he was saying he wanted to have one with her, he was actually talking about Hillary. He wanted to put to bed the rumors that Hillary was a lesbian, even though everyone in their hometown already knew it to be true. \nDolly states that the worst came when she met Hillary for the first time. “In that moment I noticed that the woman emitted an overpowering [body] odor of perspiration and greasy hair. I hoped that I wouldn’t gag when she got in my car,” she said. “The sandal-shod woman with lank, smelly hair stood off to the side and glared at everyone.” \nNo wonder Bill went elsewhere to fulfill his “sexual addiction,” as Dolly referred to it. After all, what else can you do when you’re married to a stinky woman who doesn’t shower and isn’t attracted to men anyways? Although an affair is never justified, it’s easy to sympathize with Bill on this one. But, I digress. \nThe bigger point here is what the two are willing to do in order to remain in power. Most people know that you can’t trust Hillary as far as you can throw her – which isn’t very far – so the fact that she has any supporters is beyond baffling at this point. This woman is corrupt and fake to the core. Let’s just hope all of America wakes up to this reality before it’s too late and she can do any more damage than she already has.",
		"thread_title": "Insider Leaks Bill’s 2-Word Nickname For Hillary, Exposes Dirty Bad Habits",
		"title": "Insider Leaks Bill’s 2-Word Nickname For Hillary, Exposes Dirty Bad Habits",
		"type": "conspiracy",
		"uuid": "569c0ce24609437dcf63dbf25ab4922d671a31ad"
	},
	"-KhIjWwwfAg_-muccF3-": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:34:48.377+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b2334",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reddit"
				},
				"name": "Reddit",
				"salience": 0.48922506,
				"type": "OTHER"
			},
			{
				"name": "action committee",
				"salience": 0.08278606,
				"type": "ORGANIZATION"
			},
			{
				"name": "Email",
				"salience": 0.06607688,
				"type": "OTHER"
			},
			{
				"name": "redditors",
				"salience": 0.043672867,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.029046597,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.028389834,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.020159503,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pro-Hillary Clinton",
				"salience": 0.01846301,
				"type": "PERSON"
			},
			{
				"name": "Redditors",
				"salience": 0.018214215,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vcmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Record_(Bergen_County)"
				},
				"name": "The Record",
				"salience": 0.017767616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "site",
				"salience": 0.014268559,
				"type": "OTHER"
			},
			{
				"name": "flood",
				"salience": 0.012843483,
				"type": "EVENT"
			},
			{
				"name": "efforts",
				"salience": 0.012366945,
				"type": "OTHER"
			},
			{
				"name": "PAC",
				"salience": 0.012366945,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.012366945,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.010024811,
				"type": "EVENT"
			},
			{
				"name": "revelations",
				"salience": 0.010024811,
				"type": "OTHER"
			},
			{
				"name": "internet commenters",
				"salience": 0.00977493,
				"type": "PERSON"
			},
			{
				"name": "revelations",
				"salience": 0.009652323,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.009309407,
				"type": "OTHER"
			},
			{
				"name": "pro-Hillary",
				"salience": 0.008805682,
				"type": "WORK_OF_ART"
			},
			{
				"name": "release",
				"salience": 0.008363212,
				"type": "EVENT"
			},
			{
				"name": "source",
				"salience": 0.0070963427,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.0070963427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0065894085,
				"type": "LOCATION"
			},
			{
				"name": "post",
				"salience": 0.0053053857,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.005155111,
				"type": "ORGANIZATION"
			},
			{
				"name": "site",
				"salience": 0.004520777,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0038663314,
				"type": "PERSON"
			},
			{
				"name": "upvotes",
				"salience": 0.0038663314,
				"type": "OTHER"
			},
			{
				"name": "downvotes",
				"salience": 0.0038663314,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.0028893182,
				"type": "OTHER"
			},
			{
				"name": "subreddits",
				"salience": 0.0028893182,
				"type": "OTHER"
			},
			{
				"name": "sub-communities",
				"salience": 0.0028893182,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776682061.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:34:48.377+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nReddit users (also known as redditors) are growing increasingly angry at pro-Hillary Clinton political action committee (PAC) Correct The Record over its efforts to promote a pro-Hillary narrative on the site. \nRedditors are especially concerned that Correct The Record’s paid internet commenters are suppressing revelations from WikiLeaks’ release of Clinton campaign chair John Podesta’s emails, which have produced a flood of damaging revelations about the Clinton campaign. \nReddit, which describes itself as “a source for what’s new and popular on the web” is divided into thousands of “subreddits,” which the site describes as “sub-communities, each focused on a specific topic.” \nWhether or not a post does well on Reddit (and, consequently, how large of an audience it reaches) largely depends on how many “upvotes” and “downvotes” it receives.",
		"thread_title": "Reddit Users Declare War On Hillary’s Paid Internet Trolls",
		"title": "Reddit Users Declare War On Hillary’s Paid Internet Trolls",
		"type": "conspiracy",
		"uuid": "c3a2df9ae1ffbd6a9c6b6aa5e1f15bae0646b61f"
	},
	"-KhIjX9lyd0bzVo5dcY0": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:34:48.985+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "country",
				"salience": 0.16756557,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.101126805,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.09547056,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.036259275,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.029438665,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.027420495,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.021475207,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.018610919,
				"type": "EVENT"
			},
			{
				"name": "Reports",
				"salience": 0.018610919,
				"type": "OTHER"
			},
			{
				"name": "facilitation/abatement",
				"salience": 0.018610919,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dkt6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Snopes.com"
				},
				"name": "Snopes",
				"salience": 0.018209917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.017629068,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.01645615,
				"type": "LOCATION"
			},
			{
				"name": "Clintons",
				"salience": 0.015871877,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.015084042,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack H Obama",
				"salience": 0.014589637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0122438595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.011477694,
				"type": "ORGANIZATION"
			},
			{
				"name": "Qatar Central Bank",
				"salience": 0.011477694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hlwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JPMorgan_Chase"
				},
				"name": "JP Morgan Chase",
				"salience": 0.011477694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill",
				"salience": 0.011050507,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.01021187,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.009956798,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.009821779,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.008545792,
				"type": "OTHER"
			},
			{
				"name": "Rick Williams",
				"salience": 0.008202674,
				"type": "PERSON"
			},
			{
				"name": "sum",
				"salience": 0.0076831626,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0076831626,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0076831626,
				"type": "OTHER"
			},
			{
				"name": "Company",
				"salience": 0.0076831626,
				"type": "ORGANIZATION"
			},
			{
				"name": "crimes",
				"salience": 0.006891374,
				"type": "EVENT"
			},
			{
				"name": "high crimes",
				"salience": 0.006891374,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0066844407,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.006634536,
				"type": "ORGANIZATION"
			},
			{
				"name": "extradition treaty",
				"salience": 0.0065464955,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0064352998,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0064352998,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.006223184,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.0059912037,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0059912037,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.005627519,
				"type": "ORGANIZATION"
			},
			{
				"name": "gun",
				"salience": 0.005389773,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "terrorist groups",
				"salience": 0.005389773,
				"type": "ORGANIZATION"
			},
			{
				"name": "mail server",
				"salience": 0.005389773,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.005389773,
				"type": "EVENT"
			},
			{
				"name": "material",
				"salience": 0.005389773,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.005389773,
				"type": "OTHER"
			},
			{
				"name": "debates",
				"salience": 0.005389773,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.0051888097,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.0051888097,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0050816815,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0048971334,
				"type": "LOCATION"
			},
			{
				"name": "extradition country",
				"salience": 0.004855645,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0047993483,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.004400934,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.004400934,
				"type": "PERSON"
			},
			{
				"name": "announcement",
				"salience": 0.004400934,
				"type": "EVENT"
			},
			{
				"name": "deaths",
				"salience": 0.004400934,
				"type": "EVENT"
			},
			{
				"name": "sites",
				"salience": 0.0042051384,
				"type": "OTHER"
			},
			{
				"name": "mansion",
				"salience": 0.0042051384,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0042051384,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.003946985,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "Presidential",
				"salience": 0.0038323395,
				"type": "PERSON"
			},
			{
				"name": "purchase",
				"salience": 0.0037971027,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.0037971027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0033187845,
				"type": "LOCATION"
			},
			{
				"name": "firing",
				"salience": 0.003288265,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.003063278,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.003063278,
				"type": "LOCATION"
			},
			{
				"name": "exit plans",
				"salience": 0.0028389469,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0027659463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.002709585,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.002709585,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.002709585,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.002617454,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.0024383303,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.002395189,
				"type": "OTHER"
			},
			{
				"name": "mansion",
				"salience": 0.0022885653,
				"type": "LOCATION"
			},
			{
				"name": "dollar seaside mansion",
				"salience": 0.0022885653,
				"type": "LOCATION"
			},
			{
				"name": "sale",
				"salience": 0.0020663817,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.0020663817,
				"type": "OTHER"
			},
			{
				"name": "purchase",
				"salience": 0.0020663817,
				"type": "OTHER"
			},
			{
				"name": "yacht",
				"salience": 0.001789345,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01f08r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dubai"
				},
				"name": "Dubai",
				"salience": 0.0011013318,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gv10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nantucket"
				},
				"name": "Nantucket",
				"salience": 0.0011013318,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776680451.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:34:48.985+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nIt appears Bill and Hillary Clinton are making plans to flee the country in the event Donald Trump wins this election. \nReports are circulating that the Clintons have transferred 1.8 Billion dollars from the Clinton Foundation to the Qatar Central Bank, via a facilitation/abatement of JP Morgan Chase & Company for reasons not revealed. \nThis move of such a large sum of money to the country of Qatar says in itself, Hillary Clinton knows she is going to lose the election, and she doesn’t plan to allow herself to be prosecuted for various high crimes and treason under a Trump Administration. \nThe country of Qatar happens to be one of a handful of countries that does not have an extradition treaty with the United States, thus would be a perfect place for her to run to in escaping justice. \nDonald Trump has said many times during his campaign and at the Presidential debates that once he gets into office, he intends to prosecute her on various high crimes from her latest crimes of sending classified material via a personal e mail server. All the way to gun running to terrorist groups in Syria resulting in the deaths of 4 Americans in Benghazi. \nApparently, Hillary is not the only person in Washington who has made plans to escape justice under a Trump Administration. John Kerry has quietly been selling his property in the US for millions of dollars of late, with an announcement of the sale of his $25 million dollar Nantucket mansion in June 2016, as well as the sale of his yacht for $3.9 million in July 2016. \nPresident Barack H Obama has also apparently been making exit plans with his purchase of a $4.9 million dollar seaside mansion in Dubai in January 2016, another non extradition country. \nSnopes and other supposed fact checking sites have debunked both the story of Obama’s purchase of the mansion and the firing of Rear Admiral Rick Williams. However, over the last several months, these sites have been busted for lying in trying to debunk such information as the before mentioned, when in fact the information is true. \nSnopes and other sites try their best to keep incriminating information from being believed, but the truth has a way of coming out on its own, as it always has.",
		"thread_title": "FEAR OF TRUMP: BUSH, OBAMA, CLINTON ALL BUYING PROPERTY IN NON-EXTRADITION NATIONS",
		"title": "FEAR OF TRUMP: BUSH, OBAMA, CLINTON ALL BUYING PROPERTY IN NON-EXTRADITION NATIONS",
		"type": "conspiracy",
		"uuid": "29aa6e6c0aa6e47a2ee80e18b8ddc031657425b0"
	},
	"-KhIjXIJQ3DZsOZ9MApf": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:34:49.524+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Robert Dougherty",
				"salience": 0.82325923,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.03391709,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.023708956,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.016583862,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.015598738,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.01315261,
				"type": "PERSON"
			},
			{
				"name": "identities",
				"salience": 0.007585423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0yjhj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jacksonville,_North_Carolina"
				},
				"name": "Jacksonville",
				"salience": 0.0075595607,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0068393927,
				"type": "LOCATION"
			},
			{
				"name": "ID",
				"salience": 0.0058206925,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0050660106,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0050660106,
				"type": "EVENT"
			},
			{
				"name": "time",
				"salience": 0.004105113,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0037407235,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.0035746272,
				"type": "OTHER"
			},
			{
				"name": "sticker",
				"salience": 0.0033959295,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0033532484,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0029046251,
				"type": "OTHER"
			},
			{
				"name": "sticker",
				"salience": 0.0028809435,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.0023128493,
				"type": "OTHER"
			},
			{
				"name": "Voter Fraud",
				"salience": 0.0017595373,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0015817629,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.0013369549,
				"type": "ORGANIZATION"
			},
			{
				"name": "addresses",
				"salience": 0.0012915129,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.0012433353,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0008942736,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0007394077,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00072758755,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776678751.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:34:49.524+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nHillary supporter Robert Dougherty from Jacksonville, North Carolina bragged on Facebook today about how he committed voter fraud. \nRobert boasted on how he voted for some of his Facebook friends using their identities, and tells them not to worry about voting, because he’s already done it for them. \nAnd he’s bragging about it on Facebook. \nRobert boasts about how they give you a sticker every time you vote. \nHe says he will continue to vote all next week! \n“Isn’t North Carolina nice they give you a sticker every time you vote… No ID required.” \n“There isn’t a need for you to wait in line anymore. Took care of it for you. Gave you a straight Democratic ticket.” \n“Amazing how many addresses you get from Google. Going again until Saturday and all next week.” \nRobert either thinks voter fraud is a big joke or he’s one stupid Hillary-supporting criminal. \nWhat do you think, will Voter Fraud play a key role in the election?",
		"thread_title": "North Carolina Hillary Supporter Brags on Facebook About Voting Multiple Times",
		"title": "North Carolina Hillary Supporter Brags on Facebook About Voting Multiple Times",
		"type": "conspiracy",
		"uuid": "e614dd18b2924fe218b1a94813089fd90c8f4433"
	},
	"-KhIjXU5dLCeOfpC63d5": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:34:50.073+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "complaints",
				"salience": 0.17652236,
				"type": "OTHER"
			},
			{
				"name": "ballots",
				"salience": 0.15216579,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.11368717,
				"type": "PERSON"
			},
			{
				"name": "MecklenburgCatawba",
				"salience": 0.080456816,
				"type": "PERSON"
			},
			{
				"name": "voter",
				"salience": 0.042521328,
				"type": "PERSON"
			},
			{
				"name": "machines",
				"salience": 0.041257817,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cases",
				"salience": 0.026235083,
				"type": "OTHER"
			},
			{
				"name": "selections",
				"salience": 0.023184331,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.02276189,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.018677944,
				"type": "PERSON"
			},
			{
				"name": "cases",
				"salience": 0.013071959,
				"type": "OTHER"
			},
			{
				"name": "ballot",
				"salience": 0.012922491,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.012648602,
				"type": "PERSON"
			},
			{
				"name": "knowledge",
				"salience": 0.011694368,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.011694368,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.010602757,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.010209115,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.008879725,
				"type": "PERSON"
			},
			{
				"name": "machines",
				"salience": 0.008830956,
				"type": "OTHER"
			},
			{
				"name": "touch-screen machines",
				"salience": 0.008186726,
				"type": "OTHER"
			},
			{
				"name": "Gannon",
				"salience": 0.008186311,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.008161399,
				"type": "OTHER"
			},
			{
				"name": "elections officials",
				"salience": 0.007885181,
				"type": "PERSON"
			},
			{
				"name": "election official",
				"salience": 0.0071272654,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.006393914,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.006393914,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0061999992,
				"type": "EVENT"
			},
			{
				"name": "machines",
				"salience": 0.0061999992,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "elections",
				"salience": 0.005969252,
				"type": "EVENT"
			},
			{
				"name": "touch-screen voting machines",
				"salience": 0.005969252,
				"type": "OTHER"
			},
			{
				"name": "selections",
				"salience": 0.0052831257,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.0052227904,
				"type": "PERSON"
			},
			{
				"name": "machine",
				"salience": 0.0050642896,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0050642896,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03ccf47",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_Board_of_Elections"
				},
				"name": "State Board of Elections",
				"salience": 0.005007462,
				"type": "ORGANIZATION"
			},
			{
				"name": "audit log",
				"salience": 0.0048605786,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0048306887,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0048306887,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0048306887,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0048161126,
				"type": "PERSON"
			},
			{
				"name": "election official",
				"salience": 0.004085559,
				"type": "PERSON"
			},
			{
				"name": "touch-screen machines",
				"salience": 0.0037854032,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0037672408,
				"type": "OTHER"
			},
			{
				"name": "accuracy",
				"salience": 0.003538628,
				"type": "OTHER"
			},
			{
				"name": "selection accuracy",
				"salience": 0.003538628,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0033891757,
				"type": "OTHER"
			},
			{
				"name": "safeguards",
				"salience": 0.0033891757,
				"type": "OTHER"
			},
			{
				"name": "Kim Westbrook Strach",
				"salience": 0.0032698659,
				"type": "PERSON"
			},
			{
				"name": "advocacy groups",
				"salience": 0.0032628428,
				"type": "ORGANIZATION"
			},
			{
				"name": "counties",
				"salience": 0.0032628428,
				"type": "LOCATION"
			},
			{
				"name": "statement",
				"salience": 0.0031275614,
				"type": "WORK_OF_ART"
			},
			{
				"name": "voting",
				"salience": 0.0031155786,
				"type": "EVENT"
			},
			{
				"name": "paper ballots",
				"salience": 0.0030533967,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0028622218,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.002767528,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0026982964,
				"type": "OTHER"
			},
			{
				"name": "accuracy",
				"salience": 0.0026444301,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.002636441,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "N.C.",
				"salience": 0.002431629,
				"type": "ORGANIZATION"
			},
			{
				"name": "NC State Board Of Election",
				"salience": 0.002235182,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections officials",
				"salience": 0.002224561,
				"type": "PERSON"
			},
			{
				"name": "machine",
				"salience": 0.0020609659,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0020609659,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0017395216,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0015063805,
				"type": "OTHER"
			},
			{
				"name": "recalibration",
				"salience": 0.0011253911,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0011253911,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0007863956,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776677501.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:34:50.073+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "MecklenburgCatawba \nThe complaints noted that the machines wrongly identified a voter’s choice, but in all reported cases, the voters were able to correct their ballots before casting them. \n“To my knowledge, at this point, we don’t have any cases where elections officials noted significant problems with any machines based on these complaints. Of course they’re all looked into and that’s why we encourage people to immediately flag down an election official,” commented Gannon. \nThe NC State Board Of Election released the following statement regarding the complaints: \nThe N.C. State Board of Elections is aware that some voters have contacted advocacy groups or elections officials with concerns about touch-screen voting machines in several counties. \nSimilar reports have been made in recent elections, and we take them very seriously. \nWe want to ensure voters that safeguards are in place to ensure touch-screen machines accurately record voters’ selections. \nTouch-screen machines are tested thoroughly before each election. They are recalibrated daily before voting begins to test and ensure accuracy. If a voter notices an issue with selection accuracy of a machine, they should raise their hand and notify an election official immediately. If needed, the machine may be taken out of service for recalibration, and the voter may be moved to a different machine. \nAlso, each touch-screen machine prompts voters to review their selections before casting their ballot. As with paper ballots, voters should check over their selections to ensure accuracy prior to casting their ballot. On touch-screen machines, voters also can review a real-time audit log that records all of their selections. \n“We urge all voters to carefully review their selections before casting their ballots, and to immediately report any questions or concerns to elections officials,” said Kim Westbrook Strach, executive director of the N.C. State Board of Elections.",
		"thread_title": "3 Charlotte Area Counties Report Voting Machines Picking Wrong Candidates",
		"title": "3 Charlotte Area Counties Report Voting Machines Picking Wrong Candidates",
		"type": "conspiracy",
		"uuid": "368b1329c44473650160fe155b47ba242f6872f3"
	},
	"-KhIjXdvVvgfo2xCw9JY": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:34:50.081+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/047blr4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jason_Chaffetz"
				},
				"name": "Jason Chaffetz",
				"salience": 0.26626557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.1797479,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.06768409,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.04179699,
				"type": "PERSON"
			},
			{
				"name": "Corruption",
				"salience": 0.040231545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.037415598,
				"type": "LOCATION"
			},
			{
				"name": "manipulation",
				"salience": 0.036109436,
				"type": "OTHER"
			},
			{
				"name": "pit",
				"salience": 0.03132389,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.03132389,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024tds",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Devin_Nunes"
				},
				"name": "DEVIN NUNES",
				"salience": 0.022283014,
				"type": "PERSON"
			},
			{
				"name": "documentation",
				"salience": 0.02222025,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.016084893,
				"type": "PERSON"
			},
			{
				"name": "option",
				"salience": 0.015262944,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.015112835,
				"type": "PERSON"
			},
			{
				"name": "DOCUMENTS",
				"salience": 0.014508573,
				"type": "WORK_OF_ART"
			},
			{
				"name": "documentation",
				"salience": 0.0105590485,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.007668179,
				"type": "OTHER"
			},
			{
				"name": "manipulation",
				"salience": 0.0070617306,
				"type": "OTHER"
			},
			{
				"name": "queen",
				"salience": 0.0066421763,
				"type": "PERSON"
			},
			{
				"name": "treason",
				"salience": 0.0066421763,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.0066421763,
				"type": "LOCATION"
			},
			{
				"name": "standard",
				"salience": 0.0066421763,
				"type": "OTHER"
			},
			{
				"name": "MEMBERS",
				"salience": 0.006558651,
				"type": "PERSON"
			},
			{
				"name": "Chairman",
				"salience": 0.0064480524,
				"type": "PERSON"
			},
			{
				"name": "email server",
				"salience": 0.0053802077,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0051565804,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05rw4y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Committee_on_Oversight_and_Government_Reform"
				},
				"name": "House Committee on Oversight and Government Reform",
				"salience": 0.004888627,
				"type": "ORGANIZATION"
			},
			{
				"name": "EMAILS",
				"salience": 0.004865303,
				"type": "WORK_OF_ART"
			},
			{
				"name": "EMAIL",
				"salience": 0.004865303,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00480073,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.0046597864,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0044860644,
				"type": "OTHER"
			},
			{
				"name": "SERVER",
				"salience": 0.004393457,
				"type": "OTHER"
			},
			{
				"name": "HEARINGS",
				"salience": 0.004373857,
				"type": "EVENT"
			},
			{
				"name": "EXCHANGE",
				"salience": 0.0038049703,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.0031260327,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0028430563,
				"type": "OTHER"
			},
			{
				"name": "negotiation",
				"salience": 0.0028430563,
				"type": "EVENT"
			},
			{
				"name": "quid pro quo",
				"salience": 0.0028430563,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cq0r_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Undersecretary"
				},
				"name": "UNDERSECRETARY OF STATE",
				"salience": 0.0027053326,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0611v_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patrick_F._Kennedy"
				},
				"name": "PATRICK KENNEDY",
				"salience": 0.0026612543,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "DEMOCRATIC",
				"salience": 0.0023427599,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0496dt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recess_(break)"
				},
				"name": "RECESS",
				"salience": 0.0023427599,
				"type": "WORK_OF_ART"
			},
			{
				"name": "MOVE CHAFFETZ",
				"salience": 0.0022202036,
				"type": "PERSON"
			},
			{
				"name": "proposal",
				"salience": 0.0021786608,
				"type": "OTHER"
			},
			{
				"name": "downgrade",
				"salience": 0.0020973634,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0020709434,
				"type": "EVENT"
			},
			{
				"name": "crime",
				"salience": 0.0020709434,
				"type": "OTHER"
			},
			{
				"name": "agency officials",
				"salience": 0.0020709434,
				"type": "PERSON"
			},
			{
				"name": "fruition",
				"salience": 0.0020709434,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0017502506,
				"type": "ORGANIZATION"
			},
			{
				"name": "congressmen",
				"salience": 0.0016170873,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0016016077,
				"type": "LOCATION"
			},
			{
				"name": "DEAL",
				"salience": 0.0015471386,
				"type": "OTHER"
			},
			{
				"name": "The Daily Caller News Foundation",
				"salience": 0.001181381,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07nxbm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_House_Permanent_Select_Committee_on_Intelligence"
				},
				"name": "HOUSE PERMANENT SELECT COMMITTEE ON INTELLIGENCE",
				"salience": 0.0009522717,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/017jyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quid_pro_quo"
				},
				"name": "QUID PRO QUO",
				"salience": 0.0009522717,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776676171.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:34:50.081+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "The Corruption of the Clinton’s is like an endless dark pit of lies and manipulation. \nI am so sick of Clinton’s and I can’t believe anyone would vote for her. This FBI that is lying and trying to change documentation should be held to a legal standard and people who have tried to hide documentation and have lied should be thrown in prison for treason! \nAs far as how the media treats Hillary Clinton, if you’ve noticed, they treat her like a queen. The liberal media likes to pamper, lie, and make sure America knows she is the best option. We, however, know better. So does Jason Chaffetz. \nFor those of you who do it know who Chaffetz is, he is the House Committee on Oversight and Government Reform Chairman who famously told the guy who destroyed Hillary’s email server that he was served on live TV. Now he just served up a brutal threat to Hillary Clinton and she is running scared. \nHOUSE COMMITTEE ON OVERSIGHT AND GOVERNMENT REFORM CHAIRMAN JASON CHAFFETZ CONFIRMED IT WILL HOLD ADDITIONAL HEARINGS ON DEMOCRATIC NOMINEE HILLARY CLINTON’S PRIVATE EMAIL SERVER WHEN MEMBERS RETURN FROM RECESS. \nNEW FBI DOCUMENTS RELEASED MONDAY SHOW UNDERSECRETARY OF STATE PATRICK KENNEDY PUSHING THE FBI TO DECLASSIFY EMAILS IN EXCHANGE FOR A “QUID PRO QUO” DEAL — A MOVE CHAFFETZ AND HOUSE PERMANENT SELECT COMMITTEE ON INTELLIGENCE CHAIRMAN DEVIN NUNES FOUND DEEPLY TROUBLING. \n“Undoubtedly there will be, based on the documents the FBI released today there are new facts that need to be investigated. I’m very concerned about the quid pro quo that was in negotiation between the State Department and the FBI,” Chaffetz told The Daily Caller News Foundation. “Chairman Nunes and I believe Patrick Kennedy should be relieved of his duties immediately pending an investigation. This is a manipulation if not an outright crime and so we’re gonna drive into that.” \nWhile the downgrade discussed between the agency officials didn’t come into fruition, the congressmen were clear they believe the proposal was inappropriate.",
		"thread_title": "JASON CHAFFETZ EXPOSED HILLARY CLINTON’S PLAN TO BRIBE FBI AGENTS TO LET HER GO",
		"title": "JASON CHAFFETZ EXPOSED HILLARY CLINTON’S PLAN TO BRIBE FBI AGENTS TO LET HER GO",
		"type": "conspiracy",
		"uuid": "d2316284ef67e09e023d295511c9831e00f231a3"
	},
	"-KhIjXoP91ormpgALBkU": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:34:50.127+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0c6qh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brad_Pitt"
				},
				"name": "Brad Pitt",
				"salience": 0.7175927,
				"type": "PERSON"
			},
			{
				"name": "businessman",
				"salience": 0.039791327,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.033176173,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.026716473,
				"type": "OTHER"
			},
			{
				"name": "Unemployment",
				"salience": 0.017678235,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.01585965,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.013750465,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.013750465,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0067778784,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.0065636053,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0058579533,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0056862743,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0056862743,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0056862743,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.004910992,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.004606798,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.004606798,
				"type": "EVENT"
			},
			{
				"name": "interview",
				"salience": 0.004606798,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.0040453845,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0039903712,
				"type": "WORK_OF_ART"
			},
			{
				"name": "son",
				"salience": 0.0039903712,
				"type": "PERSON"
			},
			{
				"name": "preacher",
				"salience": 0.0039903712,
				"type": "PERSON"
			},
			{
				"name": "beliefs",
				"salience": 0.0038417066,
				"type": "OTHER"
			},
			{
				"name": "heat",
				"salience": 0.0038417066,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0037624536,
				"type": "LOCATION"
			},
			{
				"name": "face",
				"salience": 0.0032587769,
				"type": "OTHER"
			},
			{
				"name": "teen",
				"salience": 0.0032587769,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0032587769,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00281192,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03m3pj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Christian_sentiment"
				},
				"name": "anti-Christian",
				"salience": 0.002732193,
				"type": "OTHER"
			},
			{
				"name": "celebrities",
				"salience": 0.0027293586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.0023662322,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0022687502,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0020486326,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.0020069056,
				"type": "PERSON"
			},
			{
				"name": "run",
				"salience": 0.0017741291,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.0017315246,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0015306583,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/060c4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President"
				},
				"name": "Presidency",
				"salience": 0.0013968692,
				"type": "ORGANIZATION"
			},
			{
				"name": "faith",
				"salience": 0.0013255025,
				"type": "OTHER"
			},
			{
				"name": "devotion",
				"salience": 0.0013255025,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0013255025,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0010922012,
				"type": "PERSON"
			},
			{
				"name": "experience",
				"salience": 0.0009902506,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776672551.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:34:50.127+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\n“We need more and more jobs. Unemployment is way up here,” he said. “He’s hired more employees, more people, than anyone I know in the world.” \nI believe in him first of all because he’s a businessman. I think jobs are badly needed. \nHollywood star, Brad Pitt is usually catching some heat through supporters of President Obama after calling his agenda “anti-Christian.” \nPitt talked out about his own Christian beliefs during the 1999 interview. During the interview, he shared his story of how he or she uncovered religion. \nAs the particular son of a preacher and spending a majority of his time in the church, he grew to become rebellious as a teen. \nAfter what Pitt calls a personal face along with God, he came back in order to the church in his 20s. \n“I had this particular tremendous physical and spiritual experience.” \nHis devotion to his faith has shocked liberal Hollywood plus angered President Obama supporters who support his alleged “anti-Christian agenda.” \nAs other celebrities live a liberal and free life-style, Pitt has explained that he is proud of his religion \nBecause of this, Brad has finally come out in support of Donald Trump and his run for Presidency.",
		"thread_title": "Brad Pitt SHOCKS AMERICA: “I’m Tired Of Liberals Taking My Money. I’m Voting For TRUMP!”",
		"title": "Brad Pitt SHOCKS AMERICA: “I’m Tired Of Liberals Taking My Money. I’m Voting For TRUMP!”",
		"type": "conspiracy",
		"uuid": "ab677029eb41d7ce1959844273be60768671cf9d"
	},
	"-KhIjY0OgXFZRVE088F3": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:40:15.653+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01stkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jackie_Mason"
				},
				"name": "Jackie Mason",
				"salience": 0.32385987,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.20140733,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.16990586,
				"type": "PERSON"
			},
			{
				"name": "resume",
				"salience": 0.05523349,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.032750282,
				"type": "OTHER"
			},
			{
				"name": "attendant",
				"salience": 0.022911565,
				"type": "PERSON"
			},
			{
				"name": "radio interview",
				"salience": 0.016839314,
				"type": "EVENT"
			},
			{
				"name": "mouth",
				"salience": 0.016839314,
				"type": "OTHER"
			},
			{
				"name": "pundit",
				"salience": 0.016839314,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.016128302,
				"type": "OTHER"
			},
			{
				"name": "ladies",
				"salience": 0.011754959,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.0088945925,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0069593433,
				"type": "OTHER"
			},
			{
				"name": "toilet paper",
				"salience": 0.005472319,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "job",
				"salience": 0.0050984006,
				"type": "OTHER"
			},
			{
				"name": "reporter",
				"salience": 0.004883124,
				"type": "PERSON"
			},
			{
				"name": "talk radio program",
				"salience": 0.004883124,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0047011455,
				"type": "LOCATION"
			},
			{
				"name": "towels",
				"salience": 0.0047011455,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "napkins",
				"salience": 0.0047011455,
				"type": "OTHER"
			},
			{
				"name": "segment",
				"salience": 0.0047011455,
				"type": "EVENT"
			},
			{
				"name": "presidency",
				"salience": 0.00398763,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.00398763,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.00398763,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00398763,
				"type": "PERSON"
			},
			{
				"name": "Aaron Klein Investigative Radio",
				"salience": 0.003845636,
				"type": "ORGANIZATION"
			},
			{
				"name": "AM 970 The Answer",
				"salience": 0.0034726302,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.003007432,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.003007432,
				"type": "LOCATION"
			},
			{
				"name": "chambermaid",
				"salience": 0.0029797847,
				"type": "PERSON"
			},
			{
				"name": "sheets",
				"salience": 0.0029797847,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "pillowcases",
				"salience": 0.0029797847,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "history",
				"salience": 0.0029797847,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0028686463,
				"type": "LOCATION"
			},
			{
				"name": "vacation",
				"salience": 0.0025065963,
				"type": "EVENT"
			},
			{
				"name": "vacation",
				"salience": 0.0025065963,
				"type": "EVENT"
			},
			{
				"name": "job",
				"salience": 0.0022665013,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.002254808,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0020221574,
				"type": "OTHER"
			},
			{
				"name": "yenta",
				"salience": 0.0016633687,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.001621724,
				"type": "LOCATION"
			},
			{
				"name": "Justice Departments",
				"salience": 0.001621724,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776687911.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:40:15.653+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nDuring a radio interview, comic legend and political pundit Jackie Mason joked that the only time Hillary Clinton is not lying “is when her mouth is not moving.”“And even then, she is probably lying because she’s probably sitting there thinking of the next lie she is going to tell,” he added. \nMason claimed that Clinton is so untrustworthy that she likely couldn’t land a job as an “attendant in the ladies’ room because they would be afraid that she would steal the towels or the napkins. Even the toilet paper wouldn’t be safe from her.” \nMason was speaking during his regular segment on this reporter’s talk radio program, “Aaron Klein Investigative Radio,” broadcast on New York’s AM 970 The Answer and NewsTalk 990 AM in Philadelphia. \nHe continued: \nDo you think that if she went for any other job besides the presidency that anyone would hire her anywhere? If you saw her resume which is a resume of accomplishing nothing and running from the police three-quarters of her life. She is always either indicted or almost indicted or about to be indicted. Her whole life spent fleeing from the Justice Departments of different countries. Now, this yenta, do you think she would be able to get any other job? … \nWould you think they would hire her as a chambermaid? Do you know what all those sheets and pillowcases are worth? Do you think they would trust her with it? After they found out the history of her life. Let’s be honest about it, if you went on a vacation would you let her watch your house while you went on vacation? Would you expect to come back and find anything still there?",
		"thread_title": "Jackie Mason: Hillary Clinton Too Untrustworthy To Serve As Bathroom Attendant – She’d Steal The Toilet Paper",
		"title": "Jackie Mason: Hillary Clinton Too Untrustworthy To Serve As Bathroom Attendant – She’d Steal The Toilet Paper",
		"type": "conspiracy",
		"uuid": "da746873944fc48ddd7083a4df7d952abe6a4b08"
	},
	"-KhIjYKtnVvkUbyUjaQL": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:40:16.159+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.33076197,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.32575342,
				"type": "PERSON"
			},
			{
				"name": "Dolly Kyle",
				"salience": 0.11622185,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.034633484,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.020901836,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.016524239,
				"type": "OTHER"
			},
			{
				"name": "duo",
				"salience": 0.0140438,
				"type": "ORGANIZATION"
			},
			{
				"name": "addiction",
				"salience": 0.009332233,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.009190569,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.006116601,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0046189153,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.004330325,
				"type": "PERSON"
			},
			{
				"name": "elsewhere",
				"salience": 0.004330325,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.0043110834,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.0036139428,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0036139428,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0036139428,
				"type": "PERSON"
			},
			{
				"name": "wonder",
				"salience": 0.0036139428,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.0035590876,
				"type": "PERSON"
			},
			{
				"name": "husband",
				"salience": 0.0028977608,
				"type": "PERSON"
			},
			{
				"name": "two",
				"salience": 0.0025939066,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0022380208,
				"type": "PERSON"
			},
			{
				"name": "worse",
				"salience": 0.00219183,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.002125344,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002097135,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.001848947,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0017660259,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.001626801,
				"type": "PERSON"
			},
			{
				"name": "account",
				"salience": 0.001531748,
				"type": "OTHER"
			},
			{
				"name": "leak",
				"salience": 0.0015019248,
				"type": "OTHER"
			},
			{
				"name": "nickname",
				"salience": 0.001489663,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.001489663,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.001489663,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.001489663,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0013359975,
				"type": "EVENT"
			},
			{
				"name": "account",
				"salience": 0.0012958427,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0012900584,
				"type": "PERSON"
			},
			{
				"name": "spotlight",
				"salience": 0.0012900584,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0012009605,
				"type": "PERSON"
			},
			{
				"name": "attraction",
				"salience": 0.0011509933,
				"type": "OTHER"
			},
			{
				"name": "marriages",
				"salience": 0.0010446695,
				"type": "OTHER"
			},
			{
				"name": "bedroom habits",
				"salience": 0.0010056896,
				"type": "OTHER"
			},
			{
				"name": "habits",
				"salience": 0.0010056896,
				"type": "OTHER"
			},
			{
				"name": "least",
				"salience": 0.0010056896,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.00096092623,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02z3n9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mail_Online"
				},
				"name": "Mail Online",
				"salience": 0.0009491185,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.00094458536,
				"type": "PERSON"
			},
			{
				"name": "something",
				"salience": 0.00094458536,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.00094458536,
				"type": "PERSON"
			},
			{
				"name": "deviant",
				"salience": 0.0009278738,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.000909337,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0009046445,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.0009046445,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0009046445,
				"type": "OTHER"
			},
			{
				"name": "several",
				"salience": 0.0009046445,
				"type": "LOCATION"
			},
			{
				"name": "mystery",
				"salience": 0.00087088544,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00087088544,
				"type": "PERSON"
			},
			{
				"name": "connection",
				"salience": 0.00087088544,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.00087088544,
				"type": "EVENT"
			},
			{
				"name": "secrets",
				"salience": 0.00087088544,
				"type": "OTHER"
			},
			{
				"name": "scene",
				"salience": 0.00087088544,
				"type": "LOCATION"
			},
			{
				"name": "nickname",
				"salience": 0.0008528903,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.000847106,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0008364344,
				"type": "PERSON"
			},
			{
				"name": "affair",
				"salience": 0.0008149232,
				"type": "EVENT"
			},
			{
				"name": "affair",
				"salience": 0.0008149232,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0008070972,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.0007638499,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.0007385545,
				"type": "OTHER"
			},
			{
				"name": "sexual assault victims",
				"salience": 0.0007385545,
				"type": "PERSON"
			},
			{
				"name": "threats",
				"salience": 0.0007385545,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0007385545,
				"type": "OTHER"
			},
			{
				"name": "reunion",
				"salience": 0.0007385545,
				"type": "EVENT"
			},
			{
				"name": "warden",
				"salience": 0.0007385545,
				"type": "PERSON"
			},
			{
				"name": "high school",
				"salience": 0.0007385545,
				"type": "ORGANIZATION"
			},
			{
				"name": "everyone",
				"salience": 0.00070567406,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.000662325,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.00063715846,
				"type": "OTHER"
			},
			{
				"name": "hair",
				"salience": 0.00063715846,
				"type": "OTHER"
			},
			{
				"name": "hair",
				"salience": 0.00063715846,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.00063715846,
				"type": "PERSON"
			},
			{
				"name": "two",
				"salience": 0.00055633904,
				"type": "PERSON"
			},
			{
				"name": "odor",
				"salience": 0.0005517293,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0005517293,
				"type": "OTHER"
			},
			{
				"name": "perspiration",
				"salience": 0.0005517293,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0005517293,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "side",
				"salience": 0.0005517293,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0004910748,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "core",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00046405144,
				"type": "OTHER"
			},
			{
				"name": "worst",
				"salience": 0.0003885586,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00038392996,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00038392996,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00037405238,
				"type": "PERSON"
			},
			{
				"name": "time",
				"salience": 0.00034664394,
				"type": "OTHER"
			},
			{
				"name": "marriage",
				"salience": 0.00034664394,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00032802435,
				"type": "OTHER"
			},
			{
				"name": "hometown",
				"salience": 0.0003001564,
				"type": "LOCATION"
			},
			{
				"name": "rumors",
				"salience": 0.0003001564,
				"type": "OTHER"
			},
			{
				"name": "bed",
				"salience": 0.0003001564,
				"type": "OTHER"
			},
			{
				"name": "baby",
				"salience": 0.0003001564,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0003001564,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0002689774,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.00021422129,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776683501.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:40:16.159+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nNo wonder Bill went elsewhere to fulfill his “sexual addiction,” as Dolly referred to it. After all, what else can you do when you’re married to a stinky woman who doesn’t shower and isn’t attracted to men anyways? Although an affair is never justified, it’s easy to sympathize with Bill on this one. But, I digress. \nThe bigger point here is what the two are willing to do in order to remain in power. Most people know that you can’t trust Hillary as far as you can throw her – which isn’t very far – so the fact that she has any supporters is beyond baffling at this point. This woman is corrupt and fake to the core. Let’s just hope all of America wakes up to this reality before it’s too late and she can do any more damage than she already has. \nBill and Hillary Clinton just can’t stay out of the spotlight these days, and the most recent leak about them could be the most damaging yet. As it turns out, someone once close to the duo just came forward to share Bill’s revealing nickname for his wife — but the worse comes as their dirty bedroom habits were exposed. \nIt’s no mystery that Bill Clinton is a sexual deviant, but the most recent account given by the woman who had a 3-decade affair with the man is damning, to say the least. According to an exclusive interview given to Mail Online, Dolly Kyle was behind the scene’s long enough to not only know the two’s darkest secrets but even their dirty sexual habits – and now, she’s telling everyone. \nThe connection between Dolly and Bill began when she was just 11-years-old. He was about 13-years-old at the time, but Dolly states that there was an immediate attraction, even then. As the years progressed, the two became romantically involved and stayed that way through several of their marriages over the next 30 years. \nThe real affair began in 1974 just after Dolly divorced her first husband, and although Bill wasn’t married yet, he would be within the year. Although she was never interested in sharing the intimate details of the relationship, she states that she snapped when she heard Hillary recently say that all sexual assault victims have the “right to be believed.” \nKnowing full well just what Hillary had done – between the threats and the lies – to the many women who either had an affair with or were sexually assaulted by her husband Bill, Dolly knew she had to do something about it. Unfortunately for Hillary, Dolly is now coming forward with the dirty 2-word nickname Bill husband once called Hillary, among other things. \nAccording to Mail Online, Bill approached Dolly at their high school’s 35-year reunion to talk about “ the warden” – a.k.a. Hillary. Saying he was unhappy with his life and marriage, this was the least significant account Dolly had to share. \nIn fact, Dolly recalls that Bill mentioned something about having a baby to her. Although she thought he was saying he wanted to have one with her, he was actually talking about Hillary. He wanted to put to bed the rumors that Hillary was a lesbian, even though everyone in their hometown already knew it to be true. \nDolly states that the worst came when she met Hillary for the first time. “In that moment I noticed that the woman emitted an overpowering [body] odor of perspiration and greasy hair. I hoped that I wouldn’t gag when she got in my car,” she said. “The sandal-shod woman with lank, smelly hair stood off to the side and glared at everyone.” \nNo wonder Bill went elsewhere to fulfill his “sexual addiction,” as Dolly referred to it. After all, what else can you do when you’re married to a stinky woman who doesn’t shower and isn’t attracted to men anyways? Although an affair is never justified, it’s easy to sympathize with Bill on this one. But, I digress. \nThe bigger point here is what the two are willing to do in order to remain in power. Most people know that you can’t trust Hillary as far as you can throw her – which isn’t very far – so the fact that she has any supporters is beyond baffling at this point. This woman is corrupt and fake to the core. Let’s just hope all of America wakes up to this reality before it’s too late and she can do any more damage than she already has.",
		"thread_title": "Insider Leaks Bill’s 2-Word Nickname For Hillary, Exposes Dirty Bad Habits",
		"title": "Insider Leaks Bill’s 2-Word Nickname For Hillary, Exposes Dirty Bad Habits",
		"type": "conspiracy",
		"uuid": "f2cc38ebb141a02797ac26eef82302582433fe4a"
	},
	"-KhIjYTYZ2kuW90IJs8M": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:40:17.748+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b2334",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reddit"
				},
				"name": "Reddit",
				"salience": 0.48922506,
				"type": "OTHER"
			},
			{
				"name": "action committee",
				"salience": 0.08278606,
				"type": "ORGANIZATION"
			},
			{
				"name": "Email",
				"salience": 0.06607688,
				"type": "OTHER"
			},
			{
				"name": "redditors",
				"salience": 0.043672867,
				"type": "PERSON"
			},
			{
				"name": "users",
				"salience": 0.029046597,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.028389834,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.020159503,
				"type": "WORK_OF_ART"
			},
			{
				"name": "pro-Hillary Clinton",
				"salience": 0.01846301,
				"type": "PERSON"
			},
			{
				"name": "Redditors",
				"salience": 0.018214215,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07vcmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Record_(Bergen_County)"
				},
				"name": "The Record",
				"salience": 0.017767616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "site",
				"salience": 0.014268559,
				"type": "OTHER"
			},
			{
				"name": "flood",
				"salience": 0.012843483,
				"type": "EVENT"
			},
			{
				"name": "efforts",
				"salience": 0.012366945,
				"type": "OTHER"
			},
			{
				"name": "PAC",
				"salience": 0.012366945,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.012366945,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.010024811,
				"type": "EVENT"
			},
			{
				"name": "revelations",
				"salience": 0.010024811,
				"type": "OTHER"
			},
			{
				"name": "internet commenters",
				"salience": 0.00977493,
				"type": "PERSON"
			},
			{
				"name": "revelations",
				"salience": 0.009652323,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.009309407,
				"type": "OTHER"
			},
			{
				"name": "pro-Hillary",
				"salience": 0.008805682,
				"type": "WORK_OF_ART"
			},
			{
				"name": "release",
				"salience": 0.008363212,
				"type": "EVENT"
			},
			{
				"name": "source",
				"salience": 0.0070963427,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.0070963427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0065894085,
				"type": "LOCATION"
			},
			{
				"name": "post",
				"salience": 0.0053053857,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.005155111,
				"type": "ORGANIZATION"
			},
			{
				"name": "site",
				"salience": 0.004520777,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0038663314,
				"type": "PERSON"
			},
			{
				"name": "upvotes",
				"salience": 0.0038663314,
				"type": "OTHER"
			},
			{
				"name": "downvotes",
				"salience": 0.0038663314,
				"type": "OTHER"
			},
			{
				"name": "topic",
				"salience": 0.0028893182,
				"type": "OTHER"
			},
			{
				"name": "subreddits",
				"salience": 0.0028893182,
				"type": "OTHER"
			},
			{
				"name": "sub-communities",
				"salience": 0.0028893182,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776682061.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:40:17.748+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nReddit users (also known as redditors) are growing increasingly angry at pro-Hillary Clinton political action committee (PAC) Correct The Record over its efforts to promote a pro-Hillary narrative on the site. \nRedditors are especially concerned that Correct The Record’s paid internet commenters are suppressing revelations from WikiLeaks’ release of Clinton campaign chair John Podesta’s emails, which have produced a flood of damaging revelations about the Clinton campaign. \nReddit, which describes itself as “a source for what’s new and popular on the web” is divided into thousands of “subreddits,” which the site describes as “sub-communities, each focused on a specific topic.” \nWhether or not a post does well on Reddit (and, consequently, how large of an audience it reaches) largely depends on how many “upvotes” and “downvotes” it receives.",
		"thread_title": "Reddit Users Declare War On Hillary’s Paid Internet Trolls",
		"title": "Reddit Users Declare War On Hillary’s Paid Internet Trolls",
		"type": "conspiracy",
		"uuid": "c4af551d9aeba3dcf1dc5f0eab19c54025c8296a"
	},
	"-KhIjYfQuqtvnGCSCpES": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:40:18.626+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "country",
				"salience": 0.16756557,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.101126805,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.09547056,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.036259275,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.029438665,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.027420495,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.021475207,
				"type": "EVENT"
			},
			{
				"name": "event",
				"salience": 0.018610919,
				"type": "EVENT"
			},
			{
				"name": "Reports",
				"salience": 0.018610919,
				"type": "OTHER"
			},
			{
				"name": "facilitation/abatement",
				"salience": 0.018610919,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dkt6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Snopes.com"
				},
				"name": "Snopes",
				"salience": 0.018209917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.017629068,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.01645615,
				"type": "LOCATION"
			},
			{
				"name": "Clintons",
				"salience": 0.015871877,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.015084042,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack H Obama",
				"salience": 0.014589637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0122438595,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.011477694,
				"type": "ORGANIZATION"
			},
			{
				"name": "Qatar Central Bank",
				"salience": 0.011477694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hlwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JPMorgan_Chase"
				},
				"name": "JP Morgan Chase",
				"salience": 0.011477694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill",
				"salience": 0.011050507,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.01021187,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.009956798,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.009821779,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.008545792,
				"type": "OTHER"
			},
			{
				"name": "Rick Williams",
				"salience": 0.008202674,
				"type": "PERSON"
			},
			{
				"name": "sum",
				"salience": 0.0076831626,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0076831626,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0076831626,
				"type": "OTHER"
			},
			{
				"name": "Company",
				"salience": 0.0076831626,
				"type": "ORGANIZATION"
			},
			{
				"name": "crimes",
				"salience": 0.006891374,
				"type": "EVENT"
			},
			{
				"name": "high crimes",
				"salience": 0.006891374,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0066844407,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.006634536,
				"type": "ORGANIZATION"
			},
			{
				"name": "extradition treaty",
				"salience": 0.0065464955,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0064352998,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0064352998,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.006223184,
				"type": "OTHER"
			},
			{
				"name": "treason",
				"salience": 0.0059912037,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0059912037,
				"type": "OTHER"
			},
			{
				"name": "Administration",
				"salience": 0.005627519,
				"type": "ORGANIZATION"
			},
			{
				"name": "gun",
				"salience": 0.005389773,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "terrorist groups",
				"salience": 0.005389773,
				"type": "ORGANIZATION"
			},
			{
				"name": "mail server",
				"salience": 0.005389773,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.005389773,
				"type": "EVENT"
			},
			{
				"name": "material",
				"salience": 0.005389773,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.005389773,
				"type": "OTHER"
			},
			{
				"name": "debates",
				"salience": 0.005389773,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.0051888097,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.0051888097,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0050816815,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0048971334,
				"type": "LOCATION"
			},
			{
				"name": "extradition country",
				"salience": 0.004855645,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0047993483,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.004400934,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.004400934,
				"type": "PERSON"
			},
			{
				"name": "announcement",
				"salience": 0.004400934,
				"type": "EVENT"
			},
			{
				"name": "deaths",
				"salience": 0.004400934,
				"type": "EVENT"
			},
			{
				"name": "sites",
				"salience": 0.0042051384,
				"type": "OTHER"
			},
			{
				"name": "mansion",
				"salience": 0.0042051384,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0042051384,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.003946985,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "Presidential",
				"salience": 0.0038323395,
				"type": "PERSON"
			},
			{
				"name": "purchase",
				"salience": 0.0037971027,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.0037971027,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0033187845,
				"type": "LOCATION"
			},
			{
				"name": "firing",
				"salience": 0.003288265,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.003063278,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.003063278,
				"type": "LOCATION"
			},
			{
				"name": "exit plans",
				"salience": 0.0028389469,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0027659463,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.002709585,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.002709585,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.002709585,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.002617454,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.0024383303,
				"type": "OTHER"
			},
			{
				"name": "best",
				"salience": 0.002395189,
				"type": "OTHER"
			},
			{
				"name": "mansion",
				"salience": 0.0022885653,
				"type": "LOCATION"
			},
			{
				"name": "dollar seaside mansion",
				"salience": 0.0022885653,
				"type": "LOCATION"
			},
			{
				"name": "sale",
				"salience": 0.0020663817,
				"type": "OTHER"
			},
			{
				"name": "sale",
				"salience": 0.0020663817,
				"type": "OTHER"
			},
			{
				"name": "purchase",
				"salience": 0.0020663817,
				"type": "OTHER"
			},
			{
				"name": "yacht",
				"salience": 0.001789345,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01f08r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dubai"
				},
				"name": "Dubai",
				"salience": 0.0011013318,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gv10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nantucket"
				},
				"name": "Nantucket",
				"salience": 0.0011013318,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776680451.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:40:18.626+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nIt appears Bill and Hillary Clinton are making plans to flee the country in the event Donald Trump wins this election. \nReports are circulating that the Clintons have transferred 1.8 Billion dollars from the Clinton Foundation to the Qatar Central Bank, via a facilitation/abatement of JP Morgan Chase & Company for reasons not revealed. \nThis move of such a large sum of money to the country of Qatar says in itself, Hillary Clinton knows she is going to lose the election, and she doesn’t plan to allow herself to be prosecuted for various high crimes and treason under a Trump Administration. \nThe country of Qatar happens to be one of a handful of countries that does not have an extradition treaty with the United States, thus would be a perfect place for her to run to in escaping justice. \nDonald Trump has said many times during his campaign and at the Presidential debates that once he gets into office, he intends to prosecute her on various high crimes from her latest crimes of sending classified material via a personal e mail server. All the way to gun running to terrorist groups in Syria resulting in the deaths of 4 Americans in Benghazi. \nApparently, Hillary is not the only person in Washington who has made plans to escape justice under a Trump Administration. John Kerry has quietly been selling his property in the US for millions of dollars of late, with an announcement of the sale of his $25 million dollar Nantucket mansion in June 2016, as well as the sale of his yacht for $3.9 million in July 2016. \nPresident Barack H Obama has also apparently been making exit plans with his purchase of a $4.9 million dollar seaside mansion in Dubai in January 2016, another non extradition country. \nSnopes and other supposed fact checking sites have debunked both the story of Obama’s purchase of the mansion and the firing of Rear Admiral Rick Williams. However, over the last several months, these sites have been busted for lying in trying to debunk such information as the before mentioned, when in fact the information is true. \nSnopes and other sites try their best to keep incriminating information from being believed, but the truth has a way of coming out on its own, as it always has.",
		"thread_title": "FEAR OF TRUMP: BUSH, OBAMA, CLINTON ALL BUYING PROPERTY IN NON-EXTRADITION NATIONS",
		"title": "FEAR OF TRUMP: BUSH, OBAMA, CLINTON ALL BUYING PROPERTY IN NON-EXTRADITION NATIONS",
		"type": "conspiracy",
		"uuid": "b2e81b8debd3ca29f942d34b781126c07e427194"
	},
	"-KhIjYnM2hx_XiJL17bu": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:40:25.233+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01stkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jackie_Mason"
				},
				"name": "Jackie Mason",
				"salience": 0.32385987,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.20140733,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.16990586,
				"type": "PERSON"
			},
			{
				"name": "resume",
				"salience": 0.05523349,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.032750282,
				"type": "OTHER"
			},
			{
				"name": "attendant",
				"salience": 0.022911565,
				"type": "PERSON"
			},
			{
				"name": "radio interview",
				"salience": 0.016839314,
				"type": "EVENT"
			},
			{
				"name": "mouth",
				"salience": 0.016839314,
				"type": "OTHER"
			},
			{
				"name": "pundit",
				"salience": 0.016839314,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.016128302,
				"type": "OTHER"
			},
			{
				"name": "ladies",
				"salience": 0.011754959,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.0088945925,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0069593433,
				"type": "OTHER"
			},
			{
				"name": "toilet paper",
				"salience": 0.005472319,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "job",
				"salience": 0.0050984006,
				"type": "OTHER"
			},
			{
				"name": "reporter",
				"salience": 0.004883124,
				"type": "PERSON"
			},
			{
				"name": "talk radio program",
				"salience": 0.004883124,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0047011455,
				"type": "LOCATION"
			},
			{
				"name": "towels",
				"salience": 0.0047011455,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "napkins",
				"salience": 0.0047011455,
				"type": "OTHER"
			},
			{
				"name": "segment",
				"salience": 0.0047011455,
				"type": "EVENT"
			},
			{
				"name": "presidency",
				"salience": 0.00398763,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.00398763,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.00398763,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00398763,
				"type": "PERSON"
			},
			{
				"name": "Aaron Klein Investigative Radio",
				"salience": 0.003845636,
				"type": "ORGANIZATION"
			},
			{
				"name": "AM 970 The Answer",
				"salience": 0.0034726302,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.003007432,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.003007432,
				"type": "LOCATION"
			},
			{
				"name": "chambermaid",
				"salience": 0.0029797847,
				"type": "PERSON"
			},
			{
				"name": "sheets",
				"salience": 0.0029797847,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "pillowcases",
				"salience": 0.0029797847,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "history",
				"salience": 0.0029797847,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0028686463,
				"type": "LOCATION"
			},
			{
				"name": "vacation",
				"salience": 0.0025065963,
				"type": "EVENT"
			},
			{
				"name": "vacation",
				"salience": 0.0025065963,
				"type": "EVENT"
			},
			{
				"name": "job",
				"salience": 0.0022665013,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.002254808,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0020221574,
				"type": "OTHER"
			},
			{
				"name": "yenta",
				"salience": 0.0016633687,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.001621724,
				"type": "LOCATION"
			},
			{
				"name": "Justice Departments",
				"salience": 0.001621724,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776687911.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:40:25.233+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nDuring a radio interview, comic legend and political pundit Jackie Mason joked that the only time Hillary Clinton is not lying “is when her mouth is not moving.”“And even then, she is probably lying because she’s probably sitting there thinking of the next lie she is going to tell,” he added. \nMason claimed that Clinton is so untrustworthy that she likely couldn’t land a job as an “attendant in the ladies’ room because they would be afraid that she would steal the towels or the napkins. Even the toilet paper wouldn’t be safe from her.” \nMason was speaking during his regular segment on this reporter’s talk radio program, “Aaron Klein Investigative Radio,” broadcast on New York’s AM 970 The Answer and NewsTalk 990 AM in Philadelphia. \nHe continued: \nDo you think that if she went for any other job besides the presidency that anyone would hire her anywhere? If you saw her resume which is a resume of accomplishing nothing and running from the police three-quarters of her life. She is always either indicted or almost indicted or about to be indicted. Her whole life spent fleeing from the Justice Departments of different countries. Now, this yenta, do you think she would be able to get any other job? … \nWould you think they would hire her as a chambermaid? Do you know what all those sheets and pillowcases are worth? Do you think they would trust her with it? After they found out the history of her life. Let’s be honest about it, if you went on a vacation would you let her watch your house while you went on vacation? Would you expect to come back and find anything still there?",
		"thread_title": "Jackie Mason: Hillary Clinton Too Untrustworthy To Serve As Bathroom Attendant – She’d Steal The Toilet Paper",
		"title": "Jackie Mason: Hillary Clinton Too Untrustworthy To Serve As Bathroom Attendant – She’d Steal The Toilet Paper",
		"type": "conspiracy",
		"uuid": "fbde22f0d5ffa43f66ee0a96ca79b64fa661cee3"
	},
	"-KhIjYyuPC-CGt2ZdEQ-": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-28T18:40:25.518+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "poll",
				"salience": 0.14463015,
				"type": "OTHER"
			},
			{
				"name": "seniors",
				"salience": 0.12002719,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06701629,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.05598517,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.04553119,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.036289666,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02kfd2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Begala"
				},
				"name": "Paul Begala",
				"salience": 0.036171425,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.031687517,
				"type": "WORK_OF_ART"
			},
			{
				"name": "polls",
				"salience": 0.030932873,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.02354256,
				"type": "PERSON"
			},
			{
				"name": "operatives",
				"salience": 0.02344519,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.022862986,
				"type": "WORK_OF_ART"
			},
			{
				"name": "poll",
				"salience": 0.019306699,
				"type": "OTHER"
			},
			{
				"name": "ends",
				"salience": 0.018774293,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.017444775,
				"type": "PERSON"
			},
			{
				"name": "Tom Matzzie",
				"salience": 0.017010584,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.01697422,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.01697422,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.013610323,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rqmk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Brock"
				},
				"name": "David Brock",
				"salience": 0.011798199,
				"type": "PERSON"
			},
			{
				"name": "Susan McCue",
				"salience": 0.011798199,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05pdb7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rand_Paul"
				},
				"name": "Rand Paul",
				"salience": 0.010394044,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.010217831,
				"type": "ORGANIZATION"
			},
			{
				"name": "polling",
				"salience": 0.009707655,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.008842969,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.008663672,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.008315326,
				"type": "PERSON"
			},
			{
				"name": "seniors",
				"salience": 0.008093859,
				"type": "PERSON"
			},
			{
				"name": "tracking poll",
				"salience": 0.007634442,
				"type": "OTHER"
			},
			{
				"name": "FYI",
				"salience": 0.007011081,
				"type": "OTHER"
			},
			{
				"name": "oversample",
				"salience": 0.007011081,
				"type": "OTHER"
			},
			{
				"name": "lead",
				"salience": 0.006610715,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.005688884,
				"type": "OTHER"
			},
			{
				"name": "newsrooms",
				"salience": 0.005679203,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.005493921,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.005174382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.004986688,
				"type": "LOCATION"
			},
			{
				"name": "bounce",
				"salience": 0.0049188347,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.0049188347,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0047354754,
				"type": "PERSON"
			},
			{
				"name": "sampling",
				"salience": 0.0047354754,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.0040165833,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.0040165833,
				"type": "ORGANIZATION"
			},
			{
				"name": "nomination",
				"salience": 0.0040165833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0038735266,
				"type": "PERSON"
			},
			{
				"name": "election turnout",
				"salience": 0.0034655856,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0030012452,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.0030012452,
				"type": "LOCATION"
			},
			{
				"name": "conclusion",
				"salience": 0.0030012452,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0030012452,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.0029911057,
				"type": "OTHER"
			},
			{
				"name": "Polls",
				"salience": 0.0029911057,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02zndc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Media_Matters_for_America"
				},
				"name": "Media Matters for America",
				"salience": 0.0029161011,
				"type": "ORGANIZATION"
			},
			{
				"name": "lead",
				"salience": 0.0028656954,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016bvz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC_News"
				},
				"name": "NBC News",
				"salience": 0.002855868,
				"type": "ORGANIZATION"
			},
			{
				"name": "turnout",
				"salience": 0.0025245794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.0024731432,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0024731432,
				"type": "PERSON"
			},
			{
				"name": "Surveymonkey",
				"salience": 0.0024731432,
				"type": "ORGANIZATION"
			},
			{
				"name": "email",
				"salience": 0.0024397422,
				"type": "WORK_OF_ART"
			},
			{
				"name": "form",
				"salience": 0.002329259,
				"type": "OTHER"
			},
			{
				"name": "operatives",
				"salience": 0.002261075,
				"type": "ORGANIZATION"
			},
			{
				"name": "someone",
				"salience": 0.0021862139,
				"type": "PERSON"
			},
			{
				"name": "rigging",
				"salience": 0.0021862139,
				"type": "OTHER"
			},
			{
				"name": "propaganda tool",
				"salience": 0.0021314844,
				"type": "OTHER"
			},
			{
				"name": "topline result",
				"salience": 0.0018861237,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0018076267,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tactics",
				"salience": 0.0016332752,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0016332752,
				"type": "OTHER"
			},
			{
				"name": "The Tom Roten Show",
				"salience": 0.0015541211,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/081mh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Virginia"
				},
				"name": "West Virginia",
				"salience": 0.0013457568,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776674571.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T18:40:25.518+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAn email published by WikiLeaks on Friday reveals the extent to which Democrats and their allies manipulate polls to serve their ends. \nThe 2008 email appears shows Democratic operatives plotting to intentionally oversample seniors in a poll in order to get their desired results. \n“FYI: We are going to try to do an oversample of seniors on the poll. Sample too small otherwise,” operative Tom Matzzie wrote to Clinton adviser Paul Begala, campaign Chairman John Podesta, Media Matters for America founder David Brock, and operative Susan McCue. “Good,” Begala responded. \nTrump and his supporters have claimed often that many polls showing a significant Hillary lead over Trump have been manipulated through selective sampling. There is ample evidence that this occurs in Democrat-friendly newsrooms. \n“Hillary Clinton has opened up a 7-point lead over Donald Trump in an online poll that seems to reflect a ‘bounce’ for the former secretary of state after she wrapped up the Democratic nomination last week,” the Daily Mail reported in June. \n\"But the weekly tracking poll, from NBC News and the Surveymonkey company, included the opinions of 7 percent more self-identified Democrats than Republicans – the same margin as the poll's topline result,\" the article noted. \nThe email released by WikiLeaks Friday proves that Democratic operatives themselves engage eagerly in such tactics. \nPolls are a powerful propaganda tool, and people exposed repeatedly to polls suggesting their candidate's loss is a foregone conclusion will often be influenced to stay home on Election Day. \n\"I think sometimes polling is done to dampen election turnout,\" Rand Paul said in an interview on Wednesday on \"The Tom Roten Show\" out of West Virginia. \"When we say over and over someone can't win that is a form of rigging in the sense that it is designed to suppress turnout,\" he added.",
		"thread_title": "WikiLeaks: Email Proves Democrats Manipulate Polls",
		"title": "WikiLeaks: Email Proves Democrats Manipulate Polls",
		"type": "conspiracy",
		"uuid": "b4689881f6de4928fcfdb820d482a93c33cd0da2"
	},
	"-KhIjZF7hZMP-KAmujbI": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T13:15:27.931+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.4189608,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "Democratic People's Republic of Korea",
				"salience": 0.18964878,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Benjamin Netanyahu",
				"salience": 0.07024474,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.05308909,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01t_55",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_minister"
				},
				"name": "Foreign Ministry",
				"salience": 0.026022747,
				"type": "ORGANIZATION"
			},
			{
				"name": "rogue group",
				"salience": 0.022099804,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.013481848,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01p62z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jewish_state"
				},
				"name": "Jewish State",
				"salience": 0.013328555,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ys4j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korean_Central_News_Agency"
				},
				"name": "Korean Central News Agency",
				"salience": 0.01312166,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.011454615,
				"type": "OTHER"
			},
			{
				"name": "terrorist attack(s)",
				"salience": 0.010350427,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.010350427,
				"type": "LOCATION"
			},
			{
				"name": "shamelessness",
				"salience": 0.010350427,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0069838637,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t7hy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shinz%C5%8D_Abe"
				},
				"name": "Shinzo Abe",
				"salience": 0.0059328917,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.005822002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.005822002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "states",
				"salience": 0.00522833,
				"type": "LOCATION"
			},
			{
				"name": "democracies",
				"salience": 0.0051379413,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00351822,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.003384801,
				"type": "ORGANIZATION"
			},
			{
				"name": "press conference",
				"salience": 0.0027519194,
				"type": "EVENT"
			},
			{
				"name": "aggression",
				"salience": 0.0027519194,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.002621606,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.002577196,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0024321645,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0024221803,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0023414926,
				"type": "WORK_OF_ART"
			},
			{
				"name": "time",
				"salience": 0.002334227,
				"type": "OTHER"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0021724382,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0019927337,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "provocation",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "dignity",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0017702642,
				"type": "WORK_OF_ART"
			},
			{
				"name": "peace",
				"salience": 0.0016988895,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0016988895,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.001635521,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0014839395,
				"type": "WORK_OF_ART"
			},
			{
				"name": "states",
				"salience": 0.0014839395,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.001476812,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.001451705,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0013686775,
				"type": "OTHER"
			},
			{
				"name": "dictatorships",
				"salience": 0.0013284627,
				"type": "OTHER"
			},
			{
				"name": "neighbors",
				"salience": 0.0013284627,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0013284627,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0012788979,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0012788979,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.0012788979,
				"type": "OTHER"
			},
			{
				"name": "parallels",
				"salience": 0.0012788979,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0012788979,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0012524773,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0012346267,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02hwz6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hermit_kingdom"
				},
				"name": "Hermit Kingdom",
				"salience": 0.001166299,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.0011217439,
				"type": "OTHER"
			},
			{
				"name": "terrorist attack(s)",
				"salience": 0.0010894677,
				"type": "EVENT"
			},
			{
				"name": "Framework",
				"salience": 0.001084603,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.001084603,
				"type": "LOCATION"
			},
			{
				"name": "diplomacy",
				"salience": 0.001084603,
				"type": "OTHER"
			},
			{
				"name": "plea",
				"salience": 0.001084603,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.001084603,
				"type": "LOCATION"
			},
			{
				"name": "face",
				"salience": 0.001084603,
				"type": "OTHER"
			},
			{
				"name": "fabrications",
				"salience": 0.0010051653,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japanese",
				"salience": 0.000997963,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0009799997,
				"type": "OTHER"
			},
			{
				"name": "insults",
				"salience": 0.00093572016,
				"type": "OTHER"
			},
			{
				"name": "shamelessness",
				"salience": 0.0008671797,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0008102764,
				"type": "PERSON"
			},
			{
				"name": "fingers",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "censure",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "condemnation",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0007872768,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.0006614909,
				"type": "OTHER"
			},
			{
				"name": "squadron",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.0005901445,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "F-4s",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "firefight",
				"salience": 0.0005901445,
				"type": "EVENT"
			},
			{
				"name": "peace",
				"salience": 0.00056386634,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.000552384,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0004987311,
				"type": "PERSON"
			},
			{
				"name": "Everybody",
				"salience": 0.00046969953,
				"type": "PERSON"
			},
			{
				"name": "trip",
				"salience": 0.00044083924,
				"type": "EVENT"
			},
			{
				"name": "cancer",
				"salience": 0.00044083924,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.00044083924,
				"type": "OTHER"
			},
			{
				"name": "settlement activity",
				"salience": 0.00044083924,
				"type": "OTHER"
			},
			{
				"name": "breakdown",
				"salience": 0.00044083924,
				"type": "EVENT"
			},
			{
				"name": "peace talks",
				"salience": 0.00044083924,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/08821",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yom_Kippur_War"
				},
				"name": "Yom Kippur War",
				"salience": 0.00036321534,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gry7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mikoyan-Gurevich_MiG-21"
				},
				"name": "MiG-21s",
				"salience": 0.00036321534,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egypt",
				"salience": 0.00036321534,
				"type": "LOCATION"
			},
			{
				"name": "Al Kibar Nuclear Reactor",
				"salience": 0.00036321534,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cw5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pyongyang"
				},
				"name": "Pyongyang",
				"salience": 0.00027131106,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477735488g14692661285.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T13:15:27.931+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nNorth Korea’s Foreign Ministry slammed the “shamelessness of Israel” on Friday, calling the Jewish State a “rogue group” that “poses a nuclear threat” and commits “terrorist attack[s]” against neighboring countries. On Friday the Korean Central News Agency released a statement attributed to North Korea’s Foreign Ministry that responded to comments Israeli Prime Minister Benjamin Netanyahu made last week that were critical of the Hermit Kingdom. “This is an unpardonable insult and provocation to the dignity and social system in the DPRK and the choice made by its people,” the statement said of Netanyahu’s comments, referring to North Korea by its official name, the Democratic People’s Republic of Korea. The statement then took issue with Israel’s foreign policy in the Middle East, stating: “Israel not only represents dictatorial forces for aggression that trample down the legitimate right of the Palestinian people and indiscriminately kill them but also is a rogue group that poses a nuclear threat and makes terrorist attack[s] on its neighboring countries with lots of nuclear weapons.” The statement was responding to comments Netanyahu made during a press conference with Japanese Prime Minister Shinzo Abe last week, in which the Israeli leader repeatedly drew parallels between Iran and North Korea. “And, Prime Minister [Abe], we have something else in common,” Netanyahu began. “We are two peace loving democracies that face formidable threats from nearby rogue states.” “Both Iran and North Korea are governed by ruthless and extreme dictatorships, states that seek to bully and intimidate their neighbors, and in our case, to actually eradicate us from the face of the earth.” Noting that “Iran and North Korea have aggressive military nuclear programs,” Netanyahu repeated his plea to not allow Iran to use diplomacy to advance its nuclear program as he alleges North Korea did with the 1994 Agreed Framework. “Iran cannot be allowed to travel the road taken by North Korea.” It’s not the first time that North Korea has slammed Israel or even Netanyahu publicly. After Netanyahu criticized Pyongyang during a trip to Japan last year, the North Korean Foreign Ministry released a similar statement, which called Israel a \"cancer to peace in the Middle East.” It also accused Netanyahu of trying to use North Korea “to divert international criticism of Israel caused by its settlement activity and breakdown in the Middle East peace talks.\" Similarly, in last week’s statement, North Korea’s Foreign Ministry said, “Everybody knows about the shamelessness of Israel telling lies and making fabrications and pointing accusing fingers to others to justify its criminal acts and evade the censure and condemnation by the international community.” Besides trading public insults, Israel has long been concerned about North Korea’s support for Arab states that are hostile to Israel, as well as Iran. In fact, during the 1973 Yom Kippur War North Korea actually deployed a squadron of MiG-21s to Egypt, which engaged in a firefight with Israeli F-4s. Neither side sustained any damage. More recently, North Korea has been accused of proliferating ballistic missiles and nuclear technology to Syria and Iran. In 2007, Israel destroyed Syria's Al Kibar Nuclear Reactor that was reportedly built by North Korean engineers.",
		"thread_title": "North Korea Threatens ‘Sacred’ Nuclear War Against Israel if this country continue supporting ISIS",
		"title": "North Korea Threatens ‘Sacred’ Nuclear War Against Israel if this country continue supporting ISIS",
		"type": "conspiracy",
		"uuid": "f659387bf602f4c233906983a0e836d383604a71"
	},
	"-KhIjZVMwnPKMdZ8kyYV": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T16:33:53.241+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.4189608,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "Democratic People's Republic of Korea",
				"salience": 0.18964878,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Benjamin Netanyahu",
				"salience": 0.07024474,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.05308909,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01t_55",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_minister"
				},
				"name": "Foreign Ministry",
				"salience": 0.026022747,
				"type": "ORGANIZATION"
			},
			{
				"name": "rogue group",
				"salience": 0.022099804,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.013481848,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01p62z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jewish_state"
				},
				"name": "Jewish State",
				"salience": 0.013328555,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ys4j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korean_Central_News_Agency"
				},
				"name": "Korean Central News Agency",
				"salience": 0.01312166,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.011454615,
				"type": "OTHER"
			},
			{
				"name": "terrorist attack(s)",
				"salience": 0.010350427,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.010350427,
				"type": "LOCATION"
			},
			{
				"name": "shamelessness",
				"salience": 0.010350427,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0069838637,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t7hy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shinz%C5%8D_Abe"
				},
				"name": "Shinzo Abe",
				"salience": 0.0059328917,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.005822002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.005822002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "states",
				"salience": 0.00522833,
				"type": "LOCATION"
			},
			{
				"name": "democracies",
				"salience": 0.0051379413,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00351822,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.003384801,
				"type": "ORGANIZATION"
			},
			{
				"name": "press conference",
				"salience": 0.0027519194,
				"type": "EVENT"
			},
			{
				"name": "aggression",
				"salience": 0.0027519194,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.002621606,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.002577196,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0024321645,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0024221803,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0023414926,
				"type": "WORK_OF_ART"
			},
			{
				"name": "time",
				"salience": 0.002334227,
				"type": "OTHER"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0021724382,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0019927337,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "provocation",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "dignity",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0018942695,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0017702642,
				"type": "WORK_OF_ART"
			},
			{
				"name": "peace",
				"salience": 0.0016988895,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0016988895,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.001635521,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0014839395,
				"type": "WORK_OF_ART"
			},
			{
				"name": "states",
				"salience": 0.0014839395,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.001476812,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.001451705,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0013686775,
				"type": "OTHER"
			},
			{
				"name": "dictatorships",
				"salience": 0.0013284627,
				"type": "OTHER"
			},
			{
				"name": "neighbors",
				"salience": 0.0013284627,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0013284627,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0012788979,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0012788979,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.0012788979,
				"type": "OTHER"
			},
			{
				"name": "parallels",
				"salience": 0.0012788979,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0012788979,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0012524773,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0012346267,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02hwz6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hermit_kingdom"
				},
				"name": "Hermit Kingdom",
				"salience": 0.001166299,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.0011217439,
				"type": "OTHER"
			},
			{
				"name": "terrorist attack(s)",
				"salience": 0.0010894677,
				"type": "EVENT"
			},
			{
				"name": "Framework",
				"salience": 0.001084603,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.001084603,
				"type": "LOCATION"
			},
			{
				"name": "diplomacy",
				"salience": 0.001084603,
				"type": "OTHER"
			},
			{
				"name": "plea",
				"salience": 0.001084603,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.001084603,
				"type": "LOCATION"
			},
			{
				"name": "face",
				"salience": 0.001084603,
				"type": "OTHER"
			},
			{
				"name": "fabrications",
				"salience": 0.0010051653,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japanese",
				"salience": 0.000997963,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0009799997,
				"type": "OTHER"
			},
			{
				"name": "insults",
				"salience": 0.00093572016,
				"type": "OTHER"
			},
			{
				"name": "shamelessness",
				"salience": 0.0008671797,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0008102764,
				"type": "PERSON"
			},
			{
				"name": "fingers",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "censure",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "condemnation",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0008102764,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0007872768,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.0006614909,
				"type": "OTHER"
			},
			{
				"name": "squadron",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "engineers",
				"salience": 0.0005901445,
				"type": "PERSON"
			},
			{
				"name": "technology",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "F-4s",
				"salience": 0.0005901445,
				"type": "OTHER"
			},
			{
				"name": "firefight",
				"salience": 0.0005901445,
				"type": "EVENT"
			},
			{
				"name": "peace",
				"salience": 0.00056386634,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.000552384,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0004987311,
				"type": "PERSON"
			},
			{
				"name": "Everybody",
				"salience": 0.00046969953,
				"type": "PERSON"
			},
			{
				"name": "trip",
				"salience": 0.00044083924,
				"type": "EVENT"
			},
			{
				"name": "cancer",
				"salience": 0.00044083924,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.00044083924,
				"type": "OTHER"
			},
			{
				"name": "settlement activity",
				"salience": 0.00044083924,
				"type": "OTHER"
			},
			{
				"name": "breakdown",
				"salience": 0.00044083924,
				"type": "EVENT"
			},
			{
				"name": "peace talks",
				"salience": 0.00044083924,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/08821",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yom_Kippur_War"
				},
				"name": "Yom Kippur War",
				"salience": 0.00036321534,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gry7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mikoyan-Gurevich_MiG-21"
				},
				"name": "MiG-21s",
				"salience": 0.00036321534,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egypt",
				"salience": 0.00036321534,
				"type": "LOCATION"
			},
			{
				"name": "Al Kibar Nuclear Reactor",
				"salience": 0.00036321534,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cw5k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pyongyang"
				},
				"name": "Pyongyang",
				"salience": 0.00027131106,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/1477735488g14692661285.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T16:33:53.241+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nNorth Korea’s Foreign Ministry slammed the “shamelessness of Israel” on Friday, calling the Jewish State a “rogue group” that “poses a nuclear threat” and commits “terrorist attack[s]” against neighboring countries. On Friday the Korean Central News Agency released a statement attributed to North Korea’s Foreign Ministry that responded to comments Israeli Prime Minister Benjamin Netanyahu made last week that were critical of the Hermit Kingdom. “This is an unpardonable insult and provocation to the dignity and social system in the DPRK and the choice made by its people,” the statement said of Netanyahu’s comments, referring to North Korea by its official name, the Democratic People’s Republic of Korea. The statement then took issue with Israel’s foreign policy in the Middle East, stating: “Israel not only represents dictatorial forces for aggression that trample down the legitimate right of the Palestinian people and indiscriminately kill them but also is a rogue group that poses a nuclear threat and makes terrorist attack[s] on its neighboring countries with lots of nuclear weapons.” The statement was responding to comments Netanyahu made during a press conference with Japanese Prime Minister Shinzo Abe last week, in which the Israeli leader repeatedly drew parallels between Iran and North Korea. “And, Prime Minister [Abe], we have something else in common,” Netanyahu began. “We are two peace loving democracies that face formidable threats from nearby rogue states.” “Both Iran and North Korea are governed by ruthless and extreme dictatorships, states that seek to bully and intimidate their neighbors, and in our case, to actually eradicate us from the face of the earth.” Noting that “Iran and North Korea have aggressive military nuclear programs,” Netanyahu repeated his plea to not allow Iran to use diplomacy to advance its nuclear program as he alleges North Korea did with the 1994 Agreed Framework. “Iran cannot be allowed to travel the road taken by North Korea.” It’s not the first time that North Korea has slammed Israel or even Netanyahu publicly. After Netanyahu criticized Pyongyang during a trip to Japan last year, the North Korean Foreign Ministry released a similar statement, which called Israel a \"cancer to peace in the Middle East.” It also accused Netanyahu of trying to use North Korea “to divert international criticism of Israel caused by its settlement activity and breakdown in the Middle East peace talks.\" Similarly, in last week’s statement, North Korea’s Foreign Ministry said, “Everybody knows about the shamelessness of Israel telling lies and making fabrications and pointing accusing fingers to others to justify its criminal acts and evade the censure and condemnation by the international community.” Besides trading public insults, Israel has long been concerned about North Korea’s support for Arab states that are hostile to Israel, as well as Iran. In fact, during the 1973 Yom Kippur War North Korea actually deployed a squadron of MiG-21s to Egypt, which engaged in a firefight with Israeli F-4s. Neither side sustained any damage. More recently, North Korea has been accused of proliferating ballistic missiles and nuclear technology to Syria and Iran. In 2007, Israel destroyed Syria's Al Kibar Nuclear Reactor that was reportedly built by North Korean engineers.",
		"thread_title": "North Korea Threatens ‘Sacred’ Nuclear War Against Israel if this country continue supporting ISIS",
		"title": "North Korea Threatens ‘Sacred’ Nuclear War Against Israel if this country continue supporting ISIS",
		"type": "conspiracy",
		"uuid": "f248c432619484c17393bd46666cc91a3fc82048"
	},
	"-KhIjZf2Pi0mee0Tz14R": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T16:33:55.081+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b76qwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Walsh_(Illinois_politician)"
				},
				"name": "Joe Walsh",
				"salience": 0.61645555,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06695559,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.022550283,
				"type": "OTHER"
			},
			{
				"name": "musket",
				"salience": 0.017998086,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.015983855,
				"type": "EVENT"
			},
			{
				"name": "insurrection",
				"salience": 0.0115642985,
				"type": "OTHER"
			},
			{
				"name": "radio host",
				"salience": 0.0115642985,
				"type": "PERSON"
			},
			{
				"name": "post",
				"salience": 0.008168513,
				"type": "WORK_OF_ART"
			},
			{
				"name": "musket",
				"salience": 0.0074378215,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.007129385,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.007129385,
				"type": "LOCATION"
			},
			{
				"name": "musket",
				"salience": 0.007070865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.006895221,
				"type": "PERSON"
			},
			{
				"name": "civil disobedience",
				"salience": 0.006602174,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.005213685,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09vqjr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tammy_Duckworth"
				},
				"name": "Tammy Duckworth",
				"salience": 0.005094272,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.005073084,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.005033806,
				"type": "PERSON"
			},
			{
				"name": "musket",
				"salience": 0.0049610906,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.004832306,
				"type": "OTHER"
			},
			{
				"name": "acts",
				"salience": 0.0047715064,
				"type": "OTHER"
			},
			{
				"name": "reply",
				"salience": 0.0047715064,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0044593127,
				"type": "EVENT"
			},
			{
				"name": "concern",
				"salience": 0.0038645293,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0038645293,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0038645293,
				"type": "OTHER"
			},
			{
				"name": "disobedience",
				"salience": 0.0037823513,
				"type": "OTHER"
			},
			{
				"name": "civil disobedience",
				"salience": 0.0037823513,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.003720429,
				"type": "OTHER"
			},
			{
				"name": "boycott",
				"salience": 0.0035208254,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0034047165,
				"type": "OTHER"
			},
			{
				"name": "@jaketapper",
				"salience": 0.0033930445,
				"type": "PERSON"
			},
			{
				"name": "@WalshFreedom",
				"salience": 0.0033930445,
				"type": "PERSON"
			},
			{
				"name": "user",
				"salience": 0.0033468513,
				"type": "PERSON"
			},
			{
				"name": "arms",
				"salience": 0.0033468513,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0033468513,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0033468513,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0033468513,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0033468513,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0032220285,
				"type": "WORK_OF_ART"
			},
			{
				"name": "debate",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "suspense",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "insistence",
				"salience": 0.0032220285,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0029995455,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06sf9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jake_Tapper"
				},
				"name": "Jake Tapper",
				"salience": 0.0029384478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0029384478,
				"type": "ORGANIZATION"
			},
			{
				"name": "disobedience",
				"salience": 0.0028262304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.002746052,
				"type": "LOCATION"
			},
			{
				"name": "battle",
				"salience": 0.0027326844,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.0027326844,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.0027326844,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.002357675,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0022907767,
				"type": "EVENT"
			},
			{
				"name": "term",
				"salience": 0.002259576,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA TODAY",
				"salience": 0.0020606315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01vrdk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Suffolk_University"
				},
				"name": "Suffolk University",
				"salience": 0.0020606315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fynw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secret_Service"
				},
				"name": "Secret Service",
				"salience": 0.0020606315,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0020606315,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.0020416789,
				"type": "WORK_OF_ART"
			},
			{
				"name": "party",
				"salience": 0.0020416789,
				"type": "ORGANIZATION"
			},
			{
				"name": "criticism",
				"salience": 0.0020416789,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0019427523,
				"type": "ORGANIZATION"
			},
			{
				"name": "muskets",
				"salience": 0.0017331702,
				"type": "OTHER"
			},
			{
				"name": "musket",
				"salience": 0.0017331702,
				"type": "OTHER"
			},
			{
				"name": "police officers",
				"salience": 0.0014871032,
				"type": "PERSON"
			},
			{
				"name": "shooter",
				"salience": 0.0014871032,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0014871032,
				"type": "OTHER"
			},
			{
				"name": "punks",
				"salience": 0.0014871032,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0012772054,
				"type": "PERSON"
			},
			{
				"name": "Real America",
				"salience": 0.0012672853,
				"type": "PERSON"
			},
			{
				"name": "slingshot",
				"salience": 0.0011109189,
				"type": "OTHER"
			},
			{
				"name": "affiliate",
				"salience": 0.0011109189,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f2rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dallas"
				},
				"name": "Dallas",
				"salience": 0.0010570713,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0545qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WMAQ-TV"
				},
				"name": "NBC 5 Chicago",
				"salience": 0.0010398381,
				"type": "LOCATION"
			},
			{
				"name": "Dallas Cops",
				"salience": 0.00091532717,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14776685301.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-28T23:30:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nFormer Illinois congressman and conservative radio host Joe Walsh appeared to invite armed insurrection when he tweeted that he was \"grabbing his musket\" if Hillary Clinton defeats Donald Trump in the presidential election. \n\"On November 8th, I'm voting for Trump,\" Walsh tweeted. \"On November 9th, if Trump loses, I'm grabbing my musket.\" \n\"@WalshFreedom what exactly does that mean?\" CNN's Jake Tapper tweeted in reply. \n\"@jaketapper It means protesting,\" Walsh tweeted. \"Participating in acts of civil disobedience. Doing what it takes to get our country back.\" \nWalsh's rhetoric comes as Americans are already nervous about what will happen on and after Election Day. Trump's insistence that the election is \"rigged,\" and his statement at the last debate that he would keep America \"in suspense\" about whether or not he will accept the results, have left some in fear that violence could flare up if his supporters refuse to accept the outcome. \nMore than half of Americans expressed concern about violence on election day according to a USA TODAY/Suffolk University poll released Wednesday. \nWalsh dismissed another Twitter user's concern that his call to arms could draw the attention of the Secret Service saying, \"They understand that a musket hasn't been used in battle in almost 200 years.\" \n\"I'm serious,\" Walsh tweeted later. \"I don't think a musket would do much good these days, but it's time for civil disobedience on the right.\" \nWalsh repeated his defense that he was only speaking of civil disobedience to NBC's Chicago affiliate. \"We're talking about a musket,\" Walsh said, according to NBC 5 Chicago. \"I could've said grab your slingshot and let's go. Metaphorically, I meant grab your muskets, if Trump loses, man, we're going to do what we have to do. We're going to protest and boycott and practice civil disobedience. We may start a third party.\" \nThis wasn't the first time Walsh, who served one term before being defeated by Rep. Tammy Duckworth in 2012, drew criticism for an incendiary tweet. In July he got national attention for telling President Obama to \"watch out\" after five police officers were killed by a shooter in Dallas. \n\"3 Dallas Cops killed, 7 wounded,\" Walsh tweeted in a post that has since been deleted. \"This is now war. Watch out Obama. Watch out black lives matter punks. Real America is coming after you.\"",
		"thread_title": "'If Trump loses, I'm grabbing my musket,' former congressman tweets",
		"title": "'If Trump loses, I'm grabbing my musket,' former congressman tweets",
		"type": "conspiracy",
		"uuid": "4d9b9529cbb864884d975681927f2a22301be427"
	},
	"-KhIjZkQYMDn_YD7UOP5": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T18:06:16.964+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Email",
				"salience": 0.16404141,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.1384339,
				"type": "PERSON"
			},
			{
				"name": "reference",
				"salience": 0.12872532,
				"type": "OTHER"
			},
			{
				"name": "suffering",
				"salience": 0.08584674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s4l_b"
				},
				"name": "Times",
				"salience": 0.054035705,
				"type": "ORGANIZATION"
			},
			{
				"name": "phrase",
				"salience": 0.053546432,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.035875145,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.035875145,
				"type": "EVENT"
			},
			{
				"name": "malnutrition",
				"salience": 0.030224469,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.029105764,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.025231564,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.025231564,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.024296276,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.02216979,
				"type": "PERSON"
			},
			{
				"name": "skeleton",
				"salience": 0.020625401,
				"type": "OTHER"
			},
			{
				"name": "port city",
				"salience": 0.017807608,
				"type": "LOCATION"
			},
			{
				"name": "malnutrition",
				"salience": 0.017807608,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.016718669,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.014993892,
				"type": "LOCATION"
			},
			{
				"name": "siege",
				"salience": 0.011250721,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.00970985,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/039_81",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Hudaydah"
				},
				"name": "Hodeidah",
				"salience": 0.009512405,
				"type": "LOCATION"
			},
			{
				"name": "result",
				"salience": 0.008410699,
				"type": "OTHER"
			},
			{
				"name": "food shortage",
				"salience": 0.008410699,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.006932463,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/070rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sidon"
				},
				"name": "Saida",
				"salience": 0.0051807677,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777534761.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T18:06:16.964+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.1,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nThe Times made a reference on Thursday to the suffering of millions of Yemenis using the phrase \"the forgotten war\". \nAn18-year-old Yemeni girl's image catches the attention on the front page of the newspaper. Her malnutrition reduced her to a skeleton and she has disturbingly become emaciated as a result of food shortage. \nThis newspaper reported that Saida has been hospitalized in the port city of Hodeidah because of malnutrition while the city is under economic siege of Saudi Arabia.",
		"thread_title": "Death of millions of Yemenis in the \"forgotten war\"",
		"title": "Death of millions of Yemenis in the \"forgotten war\"",
		"type": "conspiracy",
		"uuid": "279ab05387fdeb8306db0f41c98b7dc0b635ab0e"
	},
	"-KhIj_-NECR--K3d3VCI": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T18:06:17.995+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Donald trump",
				"salience": 0.16979554,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.083006784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.07520878,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.043764293,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.025137093,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.022748768,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.022748768,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.021185262,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.020060645,
				"type": "EVENT"
			},
			{
				"name": "other",
				"salience": 0.01964318,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.019141046,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.014873864,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.014873864,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.013727626,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.013727626,
				"type": "OTHER"
			},
			{
				"name": "excitement",
				"salience": 0.0128876865,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0128876865,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.0128876865,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "politics",
				"salience": 0.0128876865,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.0128876865,
				"type": "OTHER"
			},
			{
				"name": "http://en.institutomanquehue.org/publications/news/as-first-lady-melania-trump-wants-to-save-you-from-her-husband.html",
				"salience": 0.012381236,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.011094899,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.011003279,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010969396,
				"type": "EVENT"
			},
			{
				"name": "locker-room video",
				"salience": 0.00898821,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.008021075,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0076122754,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Assange",
				"salience": 0.007503589,
				"type": "PERSON"
			},
			{
				"name": "f-word",
				"salience": 0.0073568886,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0073568886,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.007281354,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.0065988796,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.0061386456,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "republican",
				"salience": 0.0055529373,
				"type": "ORGANIZATION"
			},
			{
				"name": "shame",
				"salience": 0.005522591,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0053888704,
				"type": "PERSON"
			},
			{
				"name": "opponent candidate",
				"salience": 0.0053888704,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.005316733,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.005316733,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.005316733,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.005316733,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.005316733,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.005183767,
				"type": "OTHER"
			},
			{
				"name": "http://en.institutomanquehue.org/publications/news/list-women-accused-donald-trump-of-sexual-assault.html",
				"salience": 0.005161243,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.005161243,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0049688304,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0049688304,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0049688304,
				"type": "PERSON"
			},
			{
				"name": "shot",
				"salience": 0.0046253246,
				"type": "OTHER"
			},
			{
				"name": "http://en.institutomanquehue.org/publications/news/christian-right-leader-hillary-clinton-hostile-biblical-christianity.html",
				"salience": 0.004531673,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.004214456,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0041454537,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0041454537,
				"type": "ORGANIZATION"
			},
			{
				"name": "ideas",
				"salience": 0.0041454537,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00402698,
				"type": "PERSON"
			},
			{
				"name": "rig",
				"salience": 0.004023703,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0037767168,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.0037291672,
				"type": "PERSON"
			},
			{
				"name": "attitude",
				"salience": 0.0037291672,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.0037291672,
				"type": "EVENT"
			},
			{
				"name": "use",
				"salience": 0.0036358538,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.0035900753,
				"type": "PERSON"
			},
			{
				"name": "harassments",
				"salience": 0.0035900753,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0035159306,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0035159306,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0035159306,
				"type": "PERSON"
			},
			{
				"name": "orientation",
				"salience": 0.0035159306,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.003149038,
				"type": "OTHER"
			},
			{
				"name": "voting system",
				"salience": 0.003149038,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.003149038,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003149038,
				"type": "PERSON"
			},
			{
				"name": "affect",
				"salience": 0.0030448008,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0030448008,
				"type": "OTHER"
			},
			{
				"name": "p...y",
				"salience": 0.0030448008,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0029335967,
				"type": "PERSON"
			},
			{
				"name": "condition",
				"salience": 0.002894293,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0027306557,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.002626937,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.002584803,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.0022938363,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0022938363,
				"type": "OTHER"
			},
			{
				"name": "mass media",
				"salience": 0.0022938363,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.002274836,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.002274836,
				"type": "WORK_OF_ART"
			},
			{
				"name": "significance",
				"salience": 0.002274836,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.002274836,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.002274836,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0022082385,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0020400744,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00203865,
				"type": "OTHER"
			},
			{
				"name": "rigged-election",
				"salience": 0.0019310826,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0019310826,
				"type": "EVENT"
			},
			{
				"name": "orientation",
				"salience": 0.0019134299,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0019134299,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0018744335,
				"type": "ORGANIZATION"
			},
			{
				"name": "key",
				"salience": 0.0017653507,
				"type": "OTHER"
			},
			{
				"name": "administration system",
				"salience": 0.0017136597,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0017136597,
				"type": "PERSON"
			},
			{
				"name": "spite",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "corruptions",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "mode",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "mysteries",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0015950645,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.0014294207,
				"type": "OTHER"
			},
			{
				"name": "media empire",
				"salience": 0.0012377586,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0012377586,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0012377586,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0012377586,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777533301.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T18:06:17.995+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nThe excitement over the US election is culminating as the due date is getting closer. Each candidate is trying to use any device at hand to denigrate the other and morality is the last thing to strike the minds of the candidates. The fact of the matter is that morality is a dead circle in the American politics. Hillary Clinton, the democratic candidate, uses f-word in a debate ( http://en.institutomanquehue.org/publications/news/did-hillary-clinton-mutter-donald-trump-debate.html ) watched by hundreds of millions of people around the world and finds no shame in it. Even American religious leaders believe that Clinton is not competent to be the president of a religious country like United States ( http://en.institutomanquehue.org/publications/news/christian-right-leader-hillary-clinton-hostile-biblical-christianity.html ). On the other hand, the GOP candidate, Donald trump , has no better condition. His sexual harassments and violent ideas towards women were shocking not only for female victims, but also for the dominant male group in America. The violent use of words to address different groups of people, mainly in social media ( http://en.institutomanquehue.org/publications/news/as-first-lady-melania-trump-wants-to-save-you-from-her-husband.html ) , made it hard for the parents to allow their kids to follow him. Besides, the number of women that accused Trump of groping and rape ( http://en.institutomanquehue.org/publications/news/list-women-accused-donald-trump-of-sexual-assault.html ) is increasing day by day and the list is running on. The so-called locker-room video of Trump talking dirty about women and his attitude towards them leaked to the public to be the final shot on the republican candidate, but it did not have that much affect. It seems that even grabbing “the women by the p…y” could not change their idea about Trump. \nAll these information, some released by the opponent candidate and some by other sources mainly WikiLeaks, seems to have had little significance in the public orientation in choosing a candidate. This has less to do with the people than with the administration system and media empire in the United States. \nThe fact that Trump does not talk about a rigged-election for respecting democracy and exercising the law is clear as a truth. His words that “I will accept the result of the election if I were chosen” is more like a joke than the words of a would-be president. What Assange is trying to say in his tweet is that the rig is being done on a higher level than the polls or the voting system. The whole administration and political system is rigged in America and the people will not choose a candidate; they are chosen to choose. This is the truth behind the weird public orientation towards election in spite of all the information released about the corruptions of the two candidates in mass media. The fact that the media and the political system are rigging the election in a latent mode is the key to the question raised about the mysteries of the American election.",
		"thread_title": "Rigged Primary, Media, and Candidate; the American Rigged System",
		"title": "Rigged Primary, Media, and Candidate; the American Rigged System",
		"type": "conspiracy",
		"uuid": "8113f04e0440379879a9f991709f8b464e4b6ea0"
	},
	"-KhIj_6ZB3ZKA8X9WY6_": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T18:06:18.403+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.24963027,
				"type": "LOCATION"
			},
			{
				"name": "airport",
				"salience": 0.108980685,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.08305083,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.068525136,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.05481525,
				"type": "LOCATION"
			},
			{
				"name": "missile strikes",
				"salience": 0.04948018,
				"type": "EVENT"
			},
			{
				"name": "AnsarAllah",
				"salience": 0.026551835,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.026274871,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01pk8b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeddah"
				},
				"name": "Jeddah",
				"salience": 0.024950156,
				"type": "LOCATION"
			},
			{
				"name": "Yemen Houthis",
				"salience": 0.024637988,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.022645054,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.017801002,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.017801002,
				"type": "PERSON"
			},
			{
				"name": "air force base",
				"salience": 0.017801002,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.015971621,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.015971621,
				"type": "EVENT"
			},
			{
				"name": "airport",
				"salience": 0.015377962,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.014120963,
				"type": "OTHER"
			},
			{
				"name": "air strikes",
				"salience": 0.013890412,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.01249905,
				"type": "OTHER"
			},
			{
				"name": "tortures",
				"salience": 0.01249905,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.01249905,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.012033987,
				"type": "OTHER"
			},
			{
				"name": "air force position",
				"salience": 0.010876401,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.010558769,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/058wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mecca"
				},
				"name": "Mecca",
				"salience": 0.008586068,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.007695714,
				"type": "OTHER"
			},
			{
				"name": "Berkane",
				"salience": 0.0062904214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0195b9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ibn_Saud"
				},
				"name": "King Abdulaziz",
				"salience": 0.0062904214,
				"type": "PERSON"
			},
			{
				"name": "news network",
				"salience": 0.006000294,
				"type": "ORGANIZATION"
			},
			{
				"name": "distance",
				"salience": 0.0055612437,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vlgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Arabiya"
				},
				"name": "Al-Arabiya",
				"salience": 0.004700727,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09pcp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sa'dah"
				},
				"name": "Sa'dah",
				"salience": 0.004700727,
				"type": "LOCATION"
			},
			{
				"name": "closure",
				"salience": 0.00415559,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/028361g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Holy_city"
				},
				"name": "Holy city",
				"salience": 0.0034244342,
				"type": "LOCATION"
			},
			{
				"name": "damages",
				"salience": 0.003350214,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777530961.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T18:06:18.403+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAn informed source in Yemen's AnsarAllah stated, last night, missile strikes by Yemen Houthis aimed to annihilate the Saudi's invading air force base in Jeddah. \nSaudis have repeatedly targeted the cities and Yemeni defenseless people by their air strikes through this airport. \nHe said: we have admonished Saudis several times so far and urged them to put an end to their attacks, otherwise we would prevent them from committing tortures and crimes through our attacks. A ballistic missile Berkane was fired at King Abdulaziz airport, which is the Saudi's Royal air force position. This attack caused wide damages to the airport, leading to its closure. \nJeddah is located 65 kilometers from Mecca, and Al-Arabiya news network announced that a ballistic missile belonging to Yemen Houthis was fired from Yemeni Sa'dah to the Holy city, Mecca. However, this missile was traced and intercepted at a distance of 65 kilometres from Mecca.",
		"thread_title": "Jeddah airport was targeted by Ansar Allah missiles and was set on fire",
		"title": "Jeddah airport was targeted by Ansar Allah missiles and was set on fire",
		"type": "conspiracy",
		"uuid": "caecd0525894b0de4ca295837b45afbb68682e89"
	},
	"-KhIj_M3kzJyTzz0DV1g": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T18:33:34.318+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.30279183,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.10831741,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.06477992,
				"type": "PERSON"
			},
			{
				"name": "Jasta Bernard Haykel",
				"salience": 0.048887897,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.040483106,
				"type": "PERSON"
			},
			{
				"name": "JASTA",
				"salience": 0.03759634,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.03265103,
				"type": "WORK_OF_ART"
			},
			{
				"name": "king",
				"salience": 0.022865616,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.018029783,
				"type": "PERSON"
			},
			{
				"name": "legislation",
				"salience": 0.0150729455,
				"type": "WORK_OF_ART"
			},
			{
				"name": "families",
				"salience": 0.0145495245,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.012851797,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.01088706,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.010568304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05y7nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turki_bin_Faisal_Al_Saud"
				},
				"name": "Turki al-Faisal",
				"salience": 0.010197517,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.009708154,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.009708154,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.008411509,
				"type": "EVENT"
			},
			{
				"name": "passing",
				"salience": 0.008263206,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.007597556,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00735784,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0073429663,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06hh_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salman_of_Saudi_Arabia"
				},
				"name": "Salman bin Abdul Aziz",
				"salience": 0.006764913,
				"type": "PERSON"
			},
			{
				"name": "harassment",
				"salience": 0.0065818494,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0065818494,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.006317736,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.0045031635,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.004436192,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0040061222,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hussein ibish",
				"salience": 0.0038768158,
				"type": "PERSON"
			},
			{
				"name": "relations",
				"salience": 0.0037553678,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0037553678,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chaos",
				"salience": 0.0037553678,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0035698877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "trial",
				"salience": 0.0034957957,
				"type": "EVENT"
			},
			{
				"name": "victims",
				"salience": 0.0034696902,
				"type": "PERSON"
			},
			{
				"name": "JASTA",
				"salience": 0.0033321509,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.00303409,
				"type": "OTHER"
			},
			{
				"name": "displeasure",
				"salience": 0.002836041,
				"type": "OTHER"
			},
			{
				"name": "veto",
				"salience": 0.0027134635,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.0027134635,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0027134635,
				"type": "EVENT"
			},
			{
				"name": "advice",
				"salience": 0.0027134635,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0025409774,
				"type": "LOCATION"
			},
			{
				"name": "law",
				"salience": 0.0025409774,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.0025358282,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0025358282,
				"type": "WORK_OF_ART"
			},
			{
				"name": "back",
				"salience": 0.0024985583,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.0024335852,
				"type": "PERSON"
			},
			{
				"name": "concern",
				"salience": 0.0023428113,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0023428113,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0023428113,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0021974398,
				"type": "ORGANIZATION"
			},
			{
				"name": "interests",
				"salience": 0.0021974398,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0021506904,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "immunity",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "ramifications",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "diplomacy",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0019029587,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0018738974,
				"type": "ORGANIZATION"
			},
			{
				"name": "complaints",
				"salience": 0.0018319588,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0018319588,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0018319588,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.001794112,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0017373406,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0017373406,
				"type": "LOCATION"
			},
			{
				"name": "chaos",
				"salience": 0.0017338186,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "United States Congress",
				"salience": 0.0016706646,
				"type": "ORGANIZATION"
			},
			{
				"name": "Justice Against Sponsors of Terrorism Act",
				"salience": 0.0016706646,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.0015536381,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.0015536381,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0015536381,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0015536381,
				"type": "ORGANIZATION"
			},
			{
				"name": "minister",
				"salience": 0.001421708,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.0013861131,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0013828877,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0013403693,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.0013023261,
				"type": "ORGANIZATION"
			},
			{
				"name": "relations",
				"salience": 0.0012312608,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0372rk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adel_al-Jubeir"
				},
				"name": "Adel al-Jubeir",
				"salience": 0.0011714536,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07y07",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secretary_of_State"
				},
				"name": "United States Secretary of State",
				"salience": 0.0011714536,
				"type": "PERSON"
			},
			{
				"name": "warrant",
				"salience": 0.0011606766,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0011606766,
				"type": "ORGANIZATION"
			},
			{
				"name": "policies",
				"salience": 0.0011606766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Persian Gulf",
				"salience": 0.0011044244,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.0010864214,
				"type": "LOCATION"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.0010812312,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.0010812312,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.0010330911,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0010330911,
				"type": "LOCATION"
			},
			{
				"name": "intelligence",
				"salience": 0.0009762469,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0009327788,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.00087511446,
				"type": "ORGANIZATION"
			},
			{
				"name": "perpetrators",
				"salience": 0.00084534794,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.00084534794,
				"type": "WORK_OF_ART"
			},
			{
				"name": "addition",
				"salience": 0.0008035362,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0007672189,
				"type": "OTHER"
			},
			{
				"name": "Relations",
				"salience": 0.00076046825,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0007541665,
				"type": "PERSON"
			},
			{
				"name": "danger",
				"salience": 0.00072927005,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.00071440294,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00071440294,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00071440294,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00071440294,
				"type": "LOCATION"
			},
			{
				"name": "letters",
				"salience": 0.00063147594,
				"type": "WORK_OF_ART"
			},
			{
				"name": "representatives",
				"salience": 0.00063147594,
				"type": "PERSON"
			},
			{
				"name": "feedback",
				"salience": 0.00063147594,
				"type": "OTHER"
			},
			{
				"name": "ruling",
				"salience": 0.00060790055,
				"type": "OTHER"
			},
			{
				"name": "impunity",
				"salience": 0.0005562566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "United Kingdom",
				"salience": 0.00053811044,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.00044883156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Gulf",
				"salience": 0.00044883156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.00044883156,
				"type": "LOCATION"
			},
			{
				"name": "Princeton University Professor",
				"salience": 0.00038863637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.00038863637,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.00038863637,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00038863637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00038863637,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777536741.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T18:33:34.318+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAccording to the JASTA law which allows government and leaders of foreign governments’ harassment by families of victims of the terrorist attacks, it is so likely that Saudi king be tried. According to experts, the passing of JASTA may cause international chaos. Especially after some governments threat they will pass similar legislation to prosecute US officials if US do so. \nIs it possible that Saudi King Salman bin Abdul Aziz being tried for potential liability in events of September 11? The trial is possible by the legislation of Jasta. By Jasta law the families of the victims could sue governments and this will lead to chaos in international relations. \nIn late September, United States Congress ignored President Obama’s advice and his veto and passed JASTA law, the Justice Against Sponsors of Terrorism Act. This law made US-Saudi relation more chaotic. \nUS confederate states expressed concern to JASTA legislation \nNot just Saudi Arabia expressed concerns to JASTA, US confederate states also expressed concern about breaking the US quasi-sacred treaty with Saudi Arabia and asked for appealing. France and the Netherlands have threatened to pass similar laws which lead to a series of judicial complaints against USA and its military and diplomacy allies. \nJohn Kerry, United States Secretary of State, showed his displeasure and called it a huge risk. A few days ago Kerry and Adel al-Jubeir discussed about the ramifications of JASTA and pointed out the negative impact on the diplomatic immunity of US interests. He said: “there are ways to fix the problem.” While experts agreed that it is only possible to reduce the strength of America in complaining by circumvent the law. \nEven Saudi minister warned the danger of chaos in the international system. \nAccording to Hussein ibish, an expert on the Persian Gulf littoral states, JASTA will cause chaos at the international level. \nLast September, European Union warned: “Other countries may also want to pass similar legislation and discuss impunity. This threat was an addition written letters to US government. \nAlso France, the Netherlands and the United Kingdom representatives discussed about the feedback of this law. The Gulf littoral states, Turkey, Iraq, Jordan, Pakistan and Japan Protested against JASTA. \nThe Saudi-US Relations in danger of Jasta \nBernard Haykel, Princeton University Professor, said: “If Saudi king does not appear in New York court to be interrogated, warrant will be issued against Saudi Arabia.” Riyadh and Washington relations declined over the past three years especially with Obama's policies on Syria.” JASTA shows Saudi ruling that Obama turned his back to its allies in the Middle East,” he added. \nRiyadh strictly denies his involvement in 9/11, While 15 of the 19 were from Saudi Arabia. Turki al-Faisal, the former head of Saudi intelligence, also comments:” America wants to invade his most loyal friend over the past 70 years.” \nJasta law does not refer to Saudi Arabia. It would allow families of the victims of the September 11 terrorist attacks to sue the perpetrators of the attack.",
		"thread_title": "Is it possible that Saudi King be tried in US courts by JASTA Law?",
		"title": "Is it possible that Saudi King be tried in US courts by JASTA Law?",
		"type": "conspiracy",
		"uuid": "03622929f3c700e5aaba5922edeaf9a7329e32fd"
	},
	"-KhIj_bY8yed2OxI8u4Z": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T19:04:51.151+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.30279183,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.10831741,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.06477992,
				"type": "PERSON"
			},
			{
				"name": "Jasta Bernard Haykel",
				"salience": 0.048887897,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.040483106,
				"type": "PERSON"
			},
			{
				"name": "JASTA",
				"salience": 0.03759634,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.03265103,
				"type": "WORK_OF_ART"
			},
			{
				"name": "king",
				"salience": 0.022865616,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.018029783,
				"type": "PERSON"
			},
			{
				"name": "legislation",
				"salience": 0.0150729455,
				"type": "WORK_OF_ART"
			},
			{
				"name": "families",
				"salience": 0.0145495245,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.012851797,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.01088706,
				"type": "PERSON"
			},
			{
				"name": "laws",
				"salience": 0.010568304,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05y7nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turki_bin_Faisal_Al_Saud"
				},
				"name": "Turki al-Faisal",
				"salience": 0.010197517,
				"type": "PERSON"
			},
			{
				"name": "governments",
				"salience": 0.009708154,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.009708154,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.008411509,
				"type": "EVENT"
			},
			{
				"name": "passing",
				"salience": 0.008263206,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.007597556,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00735784,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0073429663,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06hh_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salman_of_Saudi_Arabia"
				},
				"name": "Salman bin Abdul Aziz",
				"salience": 0.006764913,
				"type": "PERSON"
			},
			{
				"name": "harassment",
				"salience": 0.0065818494,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0065818494,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.006317736,
				"type": "ORGANIZATION"
			},
			{
				"name": "officials",
				"salience": 0.0045031635,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.004436192,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0040061222,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hussein ibish",
				"salience": 0.0038768158,
				"type": "PERSON"
			},
			{
				"name": "relations",
				"salience": 0.0037553678,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0037553678,
				"type": "WORK_OF_ART"
			},
			{
				"name": "chaos",
				"salience": 0.0037553678,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0035698877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "trial",
				"salience": 0.0034957957,
				"type": "EVENT"
			},
			{
				"name": "victims",
				"salience": 0.0034696902,
				"type": "PERSON"
			},
			{
				"name": "JASTA",
				"salience": 0.0033321509,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.00303409,
				"type": "OTHER"
			},
			{
				"name": "displeasure",
				"salience": 0.002836041,
				"type": "OTHER"
			},
			{
				"name": "veto",
				"salience": 0.0027134635,
				"type": "OTHER"
			},
			{
				"name": "liability",
				"salience": 0.0027134635,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0027134635,
				"type": "EVENT"
			},
			{
				"name": "advice",
				"salience": 0.0027134635,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0025409774,
				"type": "LOCATION"
			},
			{
				"name": "law",
				"salience": 0.0025409774,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.0025358282,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0025358282,
				"type": "WORK_OF_ART"
			},
			{
				"name": "back",
				"salience": 0.0024985583,
				"type": "OTHER"
			},
			{
				"name": "experts",
				"salience": 0.0024335852,
				"type": "PERSON"
			},
			{
				"name": "concern",
				"salience": 0.0023428113,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0023428113,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0023428113,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0021974398,
				"type": "ORGANIZATION"
			},
			{
				"name": "interests",
				"salience": 0.0021974398,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.0021506904,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "ways",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "immunity",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "ramifications",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "diplomacy",
				"salience": 0.0019029587,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0019029587,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0018738974,
				"type": "ORGANIZATION"
			},
			{
				"name": "complaints",
				"salience": 0.0018319588,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0018319588,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0018319588,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.001794112,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0017373406,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0017373406,
				"type": "LOCATION"
			},
			{
				"name": "chaos",
				"salience": 0.0017338186,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "United States Congress",
				"salience": 0.0016706646,
				"type": "ORGANIZATION"
			},
			{
				"name": "Justice Against Sponsors of Terrorism Act",
				"salience": 0.0016706646,
				"type": "ORGANIZATION"
			},
			{
				"name": "system",
				"salience": 0.0015536381,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.0015536381,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0015536381,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0015536381,
				"type": "ORGANIZATION"
			},
			{
				"name": "minister",
				"salience": 0.001421708,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.0013861131,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0013828877,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0013403693,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.0013023261,
				"type": "ORGANIZATION"
			},
			{
				"name": "relations",
				"salience": 0.0012312608,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0372rk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adel_al-Jubeir"
				},
				"name": "Adel al-Jubeir",
				"salience": 0.0011714536,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07y07",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secretary_of_State"
				},
				"name": "United States Secretary of State",
				"salience": 0.0011714536,
				"type": "PERSON"
			},
			{
				"name": "warrant",
				"salience": 0.0011606766,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0011606766,
				"type": "ORGANIZATION"
			},
			{
				"name": "policies",
				"salience": 0.0011606766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Persian Gulf",
				"salience": 0.0011044244,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.0010864214,
				"type": "LOCATION"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.0010812312,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.0010812312,
				"type": "EVENT"
			},
			{
				"name": "law",
				"salience": 0.0010330911,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0010330911,
				"type": "LOCATION"
			},
			{
				"name": "intelligence",
				"salience": 0.0009762469,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0009327788,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.00087511446,
				"type": "ORGANIZATION"
			},
			{
				"name": "perpetrators",
				"salience": 0.00084534794,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.00084534794,
				"type": "WORK_OF_ART"
			},
			{
				"name": "addition",
				"salience": 0.0008035362,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0007672189,
				"type": "OTHER"
			},
			{
				"name": "Relations",
				"salience": 0.00076046825,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0007541665,
				"type": "PERSON"
			},
			{
				"name": "danger",
				"salience": 0.00072927005,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.00071440294,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00071440294,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00071440294,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00071440294,
				"type": "LOCATION"
			},
			{
				"name": "letters",
				"salience": 0.00063147594,
				"type": "WORK_OF_ART"
			},
			{
				"name": "representatives",
				"salience": 0.00063147594,
				"type": "PERSON"
			},
			{
				"name": "feedback",
				"salience": 0.00063147594,
				"type": "OTHER"
			},
			{
				"name": "ruling",
				"salience": 0.00060790055,
				"type": "OTHER"
			},
			{
				"name": "impunity",
				"salience": 0.0005562566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "United Kingdom",
				"salience": 0.00053811044,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "Netherlands",
				"salience": 0.00044883156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Gulf",
				"salience": 0.00044883156,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.00044883156,
				"type": "LOCATION"
			},
			{
				"name": "Princeton University Professor",
				"salience": 0.00038863637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japan"
				},
				"name": "Japan",
				"salience": 0.00038863637,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.00038863637,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00038863637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00038863637,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777536741.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T19:04:51.151+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAccording to the JASTA law which allows government and leaders of foreign governments’ harassment by families of victims of the terrorist attacks, it is so likely that Saudi king be tried. According to experts, the passing of JASTA may cause international chaos. Especially after some governments threat they will pass similar legislation to prosecute US officials if US do so. \nIs it possible that Saudi King Salman bin Abdul Aziz being tried for potential liability in events of September 11? The trial is possible by the legislation of Jasta. By Jasta law the families of the victims could sue governments and this will lead to chaos in international relations. \nIn late September, United States Congress ignored President Obama’s advice and his veto and passed JASTA law, the Justice Against Sponsors of Terrorism Act. This law made US-Saudi relation more chaotic. \nUS confederate states expressed concern to JASTA legislation \nNot just Saudi Arabia expressed concerns to JASTA, US confederate states also expressed concern about breaking the US quasi-sacred treaty with Saudi Arabia and asked for appealing. France and the Netherlands have threatened to pass similar laws which lead to a series of judicial complaints against USA and its military and diplomacy allies. \nJohn Kerry, United States Secretary of State, showed his displeasure and called it a huge risk. A few days ago Kerry and Adel al-Jubeir discussed about the ramifications of JASTA and pointed out the negative impact on the diplomatic immunity of US interests. He said: “there are ways to fix the problem.” While experts agreed that it is only possible to reduce the strength of America in complaining by circumvent the law. \nEven Saudi minister warned the danger of chaos in the international system. \nAccording to Hussein ibish, an expert on the Persian Gulf littoral states, JASTA will cause chaos at the international level. \nLast September, European Union warned: “Other countries may also want to pass similar legislation and discuss impunity. This threat was an addition written letters to US government. \nAlso France, the Netherlands and the United Kingdom representatives discussed about the feedback of this law. The Gulf littoral states, Turkey, Iraq, Jordan, Pakistan and Japan Protested against JASTA. \nThe Saudi-US Relations in danger of Jasta \nBernard Haykel, Princeton University Professor, said: “If Saudi king does not appear in New York court to be interrogated, warrant will be issued against Saudi Arabia.” Riyadh and Washington relations declined over the past three years especially with Obama's policies on Syria.” JASTA shows Saudi ruling that Obama turned his back to its allies in the Middle East,” he added. \nRiyadh strictly denies his involvement in 9/11, While 15 of the 19 were from Saudi Arabia. Turki al-Faisal, the former head of Saudi intelligence, also comments:” America wants to invade his most loyal friend over the past 70 years.” \nJasta law does not refer to Saudi Arabia. It would allow families of the victims of the September 11 terrorist attacks to sue the perpetrators of the attack.",
		"thread_title": "Is it possible that Saudi King be tried in US courts by JASTA Law?",
		"title": "Is it possible that Saudi King be tried in US courts by JASTA Law?",
		"type": "conspiracy",
		"uuid": "fd4528b94a38297e8dae20de00abb6908c410dfc"
	},
	"-KhIj_gdVXqycvygeXMo": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T19:04:52.894+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Email",
				"salience": 0.16404141,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.1384339,
				"type": "PERSON"
			},
			{
				"name": "reference",
				"salience": 0.12872532,
				"type": "OTHER"
			},
			{
				"name": "suffering",
				"salience": 0.08584674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s4l_b"
				},
				"name": "Times",
				"salience": 0.054035705,
				"type": "ORGANIZATION"
			},
			{
				"name": "phrase",
				"salience": 0.053546432,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.035875145,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.035875145,
				"type": "EVENT"
			},
			{
				"name": "malnutrition",
				"salience": 0.030224469,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.029105764,
				"type": "ORGANIZATION"
			},
			{
				"name": "attention",
				"salience": 0.025231564,
				"type": "OTHER"
			},
			{
				"name": "page",
				"salience": 0.025231564,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.024296276,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.02216979,
				"type": "PERSON"
			},
			{
				"name": "skeleton",
				"salience": 0.020625401,
				"type": "OTHER"
			},
			{
				"name": "port city",
				"salience": 0.017807608,
				"type": "LOCATION"
			},
			{
				"name": "malnutrition",
				"salience": 0.017807608,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.016718669,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.014993892,
				"type": "LOCATION"
			},
			{
				"name": "siege",
				"salience": 0.011250721,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.00970985,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/039_81",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Hudaydah"
				},
				"name": "Hodeidah",
				"salience": 0.009512405,
				"type": "LOCATION"
			},
			{
				"name": "result",
				"salience": 0.008410699,
				"type": "OTHER"
			},
			{
				"name": "food shortage",
				"salience": 0.008410699,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.006932463,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/070rd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sidon"
				},
				"name": "Saida",
				"salience": 0.0051807677,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777534761.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T19:04:52.894+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.1,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nThe Times made a reference on Thursday to the suffering of millions of Yemenis using the phrase \"the forgotten war\". \nAn18-year-old Yemeni girl's image catches the attention on the front page of the newspaper. Her malnutrition reduced her to a skeleton and she has disturbingly become emaciated as a result of food shortage. \nThis newspaper reported that Saida has been hospitalized in the port city of Hodeidah because of malnutrition while the city is under economic siege of Saudi Arabia.",
		"thread_title": "Death of millions of Yemenis in the \"forgotten war\"",
		"title": "Death of millions of Yemenis in the \"forgotten war\"",
		"type": "conspiracy",
		"uuid": "59a08fe69ab584ebe2d61f5d9573bff97678a807"
	},
	"-KhIj_yVQBfEFavN-QEQ": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T19:05:02.999+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Donald trump",
				"salience": 0.16979554,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.083006784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.07520878,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.043764293,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.025137093,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.022748768,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.022748768,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.021185262,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.020060645,
				"type": "EVENT"
			},
			{
				"name": "other",
				"salience": 0.01964318,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.019141046,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.014873864,
				"type": "OTHER"
			},
			{
				"name": "morality",
				"salience": 0.014873864,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.013727626,
				"type": "OTHER"
			},
			{
				"name": "circle",
				"salience": 0.013727626,
				"type": "OTHER"
			},
			{
				"name": "excitement",
				"salience": 0.0128876865,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0128876865,
				"type": "OTHER"
			},
			{
				"name": "device",
				"salience": 0.0128876865,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "politics",
				"salience": 0.0128876865,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.0128876865,
				"type": "OTHER"
			},
			{
				"name": "http://en.institutomanquehue.org/publications/news/as-first-lady-melania-trump-wants-to-save-you-from-her-husband.html",
				"salience": 0.012381236,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.011094899,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.011003279,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010969396,
				"type": "EVENT"
			},
			{
				"name": "locker-room video",
				"salience": 0.00898821,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.008021075,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0076122754,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Assange",
				"salience": 0.007503589,
				"type": "PERSON"
			},
			{
				"name": "f-word",
				"salience": 0.0073568886,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0073568886,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.007281354,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidate",
				"salience": 0.0065988796,
				"type": "PERSON"
			},
			{
				"name": "hand",
				"salience": 0.0061386456,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "republican",
				"salience": 0.0055529373,
				"type": "ORGANIZATION"
			},
			{
				"name": "shame",
				"salience": 0.005522591,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0053888704,
				"type": "PERSON"
			},
			{
				"name": "opponent candidate",
				"salience": 0.0053888704,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.005316733,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.005316733,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.005316733,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.005316733,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.005316733,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.005183767,
				"type": "OTHER"
			},
			{
				"name": "http://en.institutomanquehue.org/publications/news/list-women-accused-donald-trump-of-sexual-assault.html",
				"salience": 0.005161243,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.005161243,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0049688304,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.0049688304,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0049688304,
				"type": "PERSON"
			},
			{
				"name": "shot",
				"salience": 0.0046253246,
				"type": "OTHER"
			},
			{
				"name": "http://en.institutomanquehue.org/publications/news/christian-right-leader-hillary-clinton-hostile-biblical-christianity.html",
				"salience": 0.004531673,
				"type": "ORGANIZATION"
			},
			{
				"name": "women",
				"salience": 0.004214456,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0041454537,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0041454537,
				"type": "ORGANIZATION"
			},
			{
				"name": "ideas",
				"salience": 0.0041454537,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00402698,
				"type": "PERSON"
			},
			{
				"name": "rig",
				"salience": 0.004023703,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0037767168,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.0037291672,
				"type": "PERSON"
			},
			{
				"name": "attitude",
				"salience": 0.0037291672,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.0037291672,
				"type": "EVENT"
			},
			{
				"name": "use",
				"salience": 0.0036358538,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.0035900753,
				"type": "PERSON"
			},
			{
				"name": "harassments",
				"salience": 0.0035900753,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0035159306,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0035159306,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0035159306,
				"type": "PERSON"
			},
			{
				"name": "orientation",
				"salience": 0.0035159306,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.003149038,
				"type": "OTHER"
			},
			{
				"name": "voting system",
				"salience": 0.003149038,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.003149038,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003149038,
				"type": "PERSON"
			},
			{
				"name": "affect",
				"salience": 0.0030448008,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0030448008,
				"type": "OTHER"
			},
			{
				"name": "p...y",
				"salience": 0.0030448008,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0029335967,
				"type": "PERSON"
			},
			{
				"name": "condition",
				"salience": 0.002894293,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0027306557,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.002626937,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.002584803,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.0022938363,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0022938363,
				"type": "OTHER"
			},
			{
				"name": "mass media",
				"salience": 0.0022938363,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.002274836,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.002274836,
				"type": "WORK_OF_ART"
			},
			{
				"name": "significance",
				"salience": 0.002274836,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.002274836,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.002274836,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0022082385,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0020400744,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00203865,
				"type": "OTHER"
			},
			{
				"name": "rigged-election",
				"salience": 0.0019310826,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0019310826,
				"type": "EVENT"
			},
			{
				"name": "orientation",
				"salience": 0.0019134299,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0019134299,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.0018744335,
				"type": "ORGANIZATION"
			},
			{
				"name": "key",
				"salience": 0.0017653507,
				"type": "OTHER"
			},
			{
				"name": "administration system",
				"salience": 0.0017136597,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0017136597,
				"type": "PERSON"
			},
			{
				"name": "spite",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "corruptions",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "mode",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "mysteries",
				"salience": 0.0016569078,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0015950645,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.0014294207,
				"type": "OTHER"
			},
			{
				"name": "media empire",
				"salience": 0.0012377586,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.0012377586,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0012377586,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0012377586,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777533301.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T19:05:02.999+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nThe excitement over the US election is culminating as the due date is getting closer. Each candidate is trying to use any device at hand to denigrate the other and morality is the last thing to strike the minds of the candidates. The fact of the matter is that morality is a dead circle in the American politics. Hillary Clinton, the democratic candidate, uses f-word in a debate ( http://en.institutomanquehue.org/publications/news/did-hillary-clinton-mutter-donald-trump-debate.html ) watched by hundreds of millions of people around the world and finds no shame in it. Even American religious leaders believe that Clinton is not competent to be the president of a religious country like United States ( http://en.institutomanquehue.org/publications/news/christian-right-leader-hillary-clinton-hostile-biblical-christianity.html ). On the other hand, the GOP candidate, Donald trump , has no better condition. His sexual harassments and violent ideas towards women were shocking not only for female victims, but also for the dominant male group in America. The violent use of words to address different groups of people, mainly in social media ( http://en.institutomanquehue.org/publications/news/as-first-lady-melania-trump-wants-to-save-you-from-her-husband.html ) , made it hard for the parents to allow their kids to follow him. Besides, the number of women that accused Trump of groping and rape ( http://en.institutomanquehue.org/publications/news/list-women-accused-donald-trump-of-sexual-assault.html ) is increasing day by day and the list is running on. The so-called locker-room video of Trump talking dirty about women and his attitude towards them leaked to the public to be the final shot on the republican candidate, but it did not have that much affect. It seems that even grabbing “the women by the p…y” could not change their idea about Trump. \nAll these information, some released by the opponent candidate and some by other sources mainly WikiLeaks, seems to have had little significance in the public orientation in choosing a candidate. This has less to do with the people than with the administration system and media empire in the United States. \nThe fact that Trump does not talk about a rigged-election for respecting democracy and exercising the law is clear as a truth. His words that “I will accept the result of the election if I were chosen” is more like a joke than the words of a would-be president. What Assange is trying to say in his tweet is that the rig is being done on a higher level than the polls or the voting system. The whole administration and political system is rigged in America and the people will not choose a candidate; they are chosen to choose. This is the truth behind the weird public orientation towards election in spite of all the information released about the corruptions of the two candidates in mass media. The fact that the media and the political system are rigging the election in a latent mode is the key to the question raised about the mysteries of the American election.",
		"thread_title": "Rigged Primary, Media, and Candidate; the American Rigged System",
		"title": "Rigged Primary, Media, and Candidate; the American Rigged System",
		"type": "conspiracy",
		"uuid": "8815c809d17e97381a759b8e7eda06967e210794"
	},
	"-KhIja5Rh4b2kp85fKKE": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T19:05:03.671+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.24963027,
				"type": "LOCATION"
			},
			{
				"name": "airport",
				"salience": 0.108980685,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.08305083,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.068525136,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemeni",
				"salience": 0.05481525,
				"type": "LOCATION"
			},
			{
				"name": "missile strikes",
				"salience": 0.04948018,
				"type": "EVENT"
			},
			{
				"name": "AnsarAllah",
				"salience": 0.026551835,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.026274871,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01pk8b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeddah"
				},
				"name": "Jeddah",
				"salience": 0.024950156,
				"type": "LOCATION"
			},
			{
				"name": "Yemen Houthis",
				"salience": 0.024637988,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.022645054,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.017801002,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.017801002,
				"type": "PERSON"
			},
			{
				"name": "air force base",
				"salience": 0.017801002,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.015971621,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.015971621,
				"type": "EVENT"
			},
			{
				"name": "airport",
				"salience": 0.015377962,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.014120963,
				"type": "OTHER"
			},
			{
				"name": "air strikes",
				"salience": 0.013890412,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.01249905,
				"type": "OTHER"
			},
			{
				"name": "tortures",
				"salience": 0.01249905,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.01249905,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.012033987,
				"type": "OTHER"
			},
			{
				"name": "air force position",
				"salience": 0.010876401,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.010558769,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/058wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mecca"
				},
				"name": "Mecca",
				"salience": 0.008586068,
				"type": "LOCATION"
			},
			{
				"name": "missile",
				"salience": 0.007695714,
				"type": "OTHER"
			},
			{
				"name": "Berkane",
				"salience": 0.0062904214,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0195b9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ibn_Saud"
				},
				"name": "King Abdulaziz",
				"salience": 0.0062904214,
				"type": "PERSON"
			},
			{
				"name": "news network",
				"salience": 0.006000294,
				"type": "ORGANIZATION"
			},
			{
				"name": "distance",
				"salience": 0.0055612437,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vlgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Arabiya"
				},
				"name": "Al-Arabiya",
				"salience": 0.004700727,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09pcp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sa'dah"
				},
				"name": "Sa'dah",
				"salience": 0.004700727,
				"type": "LOCATION"
			},
			{
				"name": "closure",
				"salience": 0.00415559,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/028361g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Holy_city"
				},
				"name": "Holy city",
				"salience": 0.0034244342,
				"type": "LOCATION"
			},
			{
				"name": "damages",
				"salience": 0.003350214,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777530961.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T19:05:03.671+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAn informed source in Yemen's AnsarAllah stated, last night, missile strikes by Yemen Houthis aimed to annihilate the Saudi's invading air force base in Jeddah. \nSaudis have repeatedly targeted the cities and Yemeni defenseless people by their air strikes through this airport. \nHe said: we have admonished Saudis several times so far and urged them to put an end to their attacks, otherwise we would prevent them from committing tortures and crimes through our attacks. A ballistic missile Berkane was fired at King Abdulaziz airport, which is the Saudi's Royal air force position. This attack caused wide damages to the airport, leading to its closure. \nJeddah is located 65 kilometers from Mecca, and Al-Arabiya news network announced that a ballistic missile belonging to Yemen Houthis was fired from Yemeni Sa'dah to the Holy city, Mecca. However, this missile was traced and intercepted at a distance of 65 kilometres from Mecca.",
		"thread_title": "Jeddah airport was targeted by Ansar Allah missiles and was set on fire",
		"title": "Jeddah airport was targeted by Ansar Allah missiles and was set on fire",
		"type": "conspiracy",
		"uuid": "9248b4958c690d1e300553da32d2878e271da740"
	},
	"-KhIjaLqeldWfo-CkH6X": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T19:11:58.717+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "report",
				"salience": 0.33119243,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.18939602,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.073634095,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08xg_d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar_Central_Bank"
				},
				"name": "Qatar Central Bank",
				"salience": 0.054161385,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.031815212,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09h81",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_for_International_Settlements"
				},
				"name": "Bank For International Settlements",
				"salience": 0.03015986,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j7mmqf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_Intelligence_Service_(Kazakhstan)"
				},
				"name": "Foreign Intelligence Service",
				"salience": 0.02934923,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hlwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JPMorgan_Chase"
				},
				"name": "JP Morgan Chase & Company",
				"salience": 0.017627051,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03crtr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jamie_Dimon"
				},
				"name": "Jamie Dimon",
				"salience": 0.01620727,
				"type": "PERSON"
			},
			{
				"name": "banks",
				"salience": 0.016132154,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.014838103,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.011464589,
				"type": "PERSON"
			},
			{
				"name": "bank",
				"salience": 0.01034718,
				"type": "ORGANIZATION"
			},
			{
				"name": "Email",
				"salience": 0.0088189645,
				"type": "OTHER"
			},
			{
				"name": "bankers",
				"salience": 0.007533669,
				"type": "PERSON"
			},
			{
				"name": "mafia",
				"salience": 0.0071264114,
				"type": "OTHER"
			},
			{
				"name": "transfer",
				"salience": 0.0045153163,
				"type": "OTHER"
			},
			{
				"name": "transactions",
				"salience": 0.0045153163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05c35cg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Finance_(Vietnam)"
				},
				"name": "MoF",
				"salience": 0.004287057,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.004077904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0040352964,
				"type": "PERSON"
			},
			{
				"name": "counterparty",
				"salience": 0.0035322148,
				"type": "OTHER"
			},
			{
				"name": "facilitation/abetment",
				"salience": 0.0035322148,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0035322148,
				"type": "OTHER"
			},
			{
				"name": "CF",
				"salience": 0.0035322148,
				"type": "OTHER"
			},
			{
				"name": "bribery scheme",
				"salience": 0.0031315195,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0031091727,
				"type": "ORGANIZATION"
			},
			{
				"name": "bank",
				"salience": 0.0031091727,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qataris",
				"salience": 0.002813621,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02lc8s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deutsche_Bank"
				},
				"name": "Deutsche Bank",
				"salience": 0.002730251,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gulf State",
				"salience": 0.002591769,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.002541038,
				"type": "ORGANIZATION"
			},
			{
				"name": "master plan",
				"salience": 0.0025250467,
				"type": "OTHER"
			},
			{
				"name": "Company",
				"salience": 0.002379987,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0021756338,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.0021756338,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03grh0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Finance_(Chile)"
				},
				"name": "Ministry of Finance",
				"salience": 0.0021756338,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0021395336,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01yx7f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_of_America"
				},
				"name": "Bank of America",
				"salience": 0.0021322344,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime",
				"salience": 0.001974126,
				"type": "ORGANIZATION"
			},
			{
				"name": "nations",
				"salience": 0.0018612049,
				"type": "LOCATION"
			},
			{
				"name": "megabank",
				"salience": 0.0017905325,
				"type": "OTHER"
			},
			{
				"name": "Chappaqua Compound",
				"salience": 0.0017881743,
				"type": "LOCATION"
			},
			{
				"name": "clients",
				"salience": 0.0017457254,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0016806059,
				"type": "OTHER"
			},
			{
				"name": "money laundering",
				"salience": 0.0016806059,
				"type": "OTHER"
			},
			{
				"name": "Company",
				"salience": 0.0016069442,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0016069442,
				"type": "ORGANIZATION"
			},
			{
				"name": "clients",
				"salience": 0.0015474735,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0014553916,
				"type": "ORGANIZATION"
			},
			{
				"name": "surveillance",
				"salience": 0.0014553916,
				"type": "OTHER"
			},
			{
				"name": "associates",
				"salience": 0.0014553916,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0014553916,
				"type": "ORGANIZATION"
			},
			{
				"name": "husband",
				"salience": 0.0014553916,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0013623174,
				"type": "LOCATION"
			},
			{
				"name": "emails",
				"salience": 0.0013470338,
				"type": "WORK_OF_ART"
			},
			{
				"name": "banking",
				"salience": 0.0013305089,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0013052236,
				"type": "PERSON"
			},
			{
				"name": "transfer",
				"salience": 0.0013052236,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0013052236,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0011785296,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0011785296,
				"type": "OTHER"
			},
			{
				"name": "stocks",
				"salience": 0.0011345512,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.001065612,
				"type": "WORK_OF_ART"
			},
			{
				"name": "monarchy",
				"salience": 0.0010205501,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0010205501,
				"type": "EVENT"
			},
			{
				"name": "sum",
				"salience": 0.0010205501,
				"type": "OTHER"
			},
			{
				"name": "credit line",
				"salience": 0.000982463,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.000982463,
				"type": "OTHER"
			},
			{
				"name": "being",
				"salience": 0.000982463,
				"type": "EVENT"
			},
			{
				"name": "mainstream propaganda media",
				"salience": 0.0009744372,
				"type": "OTHER"
			},
			{
				"name": "megabanks",
				"salience": 0.0009621609,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00092625146,
				"type": "OTHER"
			},
			{
				"name": "stocks",
				"salience": 0.0009145818,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0008407561,
				"type": "LOCATION"
			},
			{
				"name": "knowledge",
				"salience": 0.0008331686,
				"type": "OTHER"
			},
			{
				"name": "sheiks",
				"salience": 0.0008331686,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.0008331686,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.0008331686,
				"type": "EVENT"
			},
			{
				"name": "sub-prime auto loan bubble",
				"salience": 0.00079607376,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00079607376,
				"type": "LOCATION"
			},
			{
				"name": "dividend growth",
				"salience": 0.00073394604,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.00071877684,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00071877684,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0006707171,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Persian Gulf",
				"salience": 0.0006559248,
				"type": "LOCATION"
			},
			{
				"name": "Obama-Clinton",
				"salience": 0.00065370725,
				"type": "PERSON"
			},
			{
				"name": "statistics",
				"salience": 0.0006474714,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00062818,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "doom",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "catastrophe",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "tens-of-thousands",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0006223999,
				"type": "PERSON"
			},
			{
				"name": "market crash",
				"salience": 0.0006223999,
				"type": "EVENT"
			},
			{
				"name": "deficiencies",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xmb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Reserve_System"
				},
				"name": "Federal Reserve",
				"salience": 0.0006047301,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0006047301,
				"type": "LOCATION"
			},
			{
				"name": "bills",
				"salience": 0.00057979155,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.00057979155,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/030q7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FIFA_World_Cup"
				},
				"name": "World Cup",
				"salience": 0.0005533604,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/015wpt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Deposit_Insurance_Corporation"
				},
				"name": "Federal Deposit Insurance Corporation",
				"salience": 0.00054756476,
				"type": "ORGANIZATION"
			},
			{
				"name": "cash grab",
				"salience": 0.0005413591,
				"type": "OTHER"
			},
			{
				"name": "secret",
				"salience": 0.0005234876,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0005128155,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0005128155,
				"type": "LOCATION"
			},
			{
				"name": "warning",
				"salience": 0.000468818,
				"type": "OTHER"
			},
			{
				"name": "recession warning",
				"salience": 0.000468818,
				"type": "OTHER"
			},
			{
				"name": "warnings",
				"salience": 0.000468818,
				"type": "OTHER"
			},
			{
				"name": "blackout",
				"salience": 0.00045328776,
				"type": "EVENT"
			},
			{
				"name": "debt",
				"salience": 0.00045328776,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.00045328776,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.00045328776,
				"type": "OTHER"
			},
			{
				"name": "rulers",
				"salience": 0.00045328776,
				"type": "PERSON"
			},
			{
				"name": "innocent",
				"salience": 0.00045328776,
				"type": "OTHER"
			},
			{
				"name": "auto loan bubble",
				"salience": 0.00043310114,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00043310114,
				"type": "PERSON"
			},
			{
				"name": "sub-prime auto loan bubble",
				"salience": 0.00042225316,
				"type": "OTHER"
			},
			{
				"name": "propaganda mainstream media",
				"salience": 0.00040108486,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00038929158,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0003830659,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0003830659,
				"type": "LOCATION"
			},
			{
				"name": "Red Alert",
				"salience": 0.00035052124,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stability",
				"salience": 0.00033859606,
				"type": "OTHER"
			},
			{
				"name": "warning letter",
				"salience": 0.00033859606,
				"type": "WORK_OF_ART"
			},
			{
				"name": "collapse",
				"salience": 0.00033859606,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0003221803,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.00027897066,
				"type": "ORGANIZATION"
			},
			{
				"name": "Clinton Crime Story of the Century",
				"salience": 0.00027897066,
				"type": "WORK_OF_ART"
			},
			{
				"name": "customers",
				"salience": 0.00027640315,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.00019875143,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777572901.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T19:11:58.717+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAn intriguing Ministry of Finance (MoF) report circulating in the Kremlin today says that elite Western bankers were stunned a few hours ago after the Bank For International Settlements (BIS) registered a $1.8 billion transfer from the Clinton Foundation (CF) to the Qatar Central Bank (QCB) through the “facilitation/abetment” of JP Morgan Chase & Company (JPM)—and for reasons yet to be firmly established. \nAccording to this report, the Bank for International Settlements is the world's oldest international financial organization and acts as a prime counterparty for central banks in their financial transactions; the Qatar Central Bank is the bank of that Gulf State nations government and their “bank of banks”; JP Morgan Chase & Company is the United States largest “megabank”; and the Clinton Foundation is an international criminal money laundering organization whose clients include the Russian mafia. \nWith Hillary Clinton’s US presidential campaign Chairman John Podesta having longstanding ties to the Russian mafia and money laundering, this report continues, the Foreign Intelligence Service (SVR) maintains complete surveillance of him and his criminal associates—including both Hillary Clinton and her husband, and former US President, Bill Clinton. \nOn Saturday 15 October (2016), this report notes, the SVR reported to the MoF that Hillary Clinton and John Podesta met with JP Morgan Chase & Company CEO Jamie Dimon at Clinton’s Chappaqua Compound outside of New York City—and who, in 2009, both President Obama and Hillary Clinton allowed to break US laws by his, Dimon’s, being able to buy millions-of-dollars of his company’s stocks prior to the public being told his JP Morgan bank was receiving a Federal Reserve $80 billion credit line—and that caused JP Morgan’s stocks to soar and that have had an astonishing 920% dividend growth since 2010. \nWithin 12 hours of the Hillary Clinton-John Podesta-Jamie Dimon meeting at the Chappaqua Compound, this report continues, the BIS registered the transfer of $1.8 billion from the Clinton Foundation to the Qatar Central Bank. \nTo why the Clinton Foundation transferred this enormous sum of money to Qatar, this report explains, is due to the longstanding ties between this Islamic neo-patrimonial absolute monarchy and then US Secretary of State Hillary Clinton who oversaw the “massive bribery scheme” that allowed this Gulf State nation to secure the 2022 World Cup—and that the Qataris were so appreciative of they donated millions to the Clinton Foundation, and incredibly, in 2011, gave former US President Bill Clinton $1 million for a birthday present—bringing Hillary Clinton’s total “cash grab” from these Persian Gulf sheiks of $100 million—all occurring as recently released secret emails revealed Hillary Clinton’s knowledge that both Qatar and Saudi Arabia were, and still are, funding ISIS. \nTo what Jamie Dimon said to Hillary Clinton that caused her to suddenly transfer $1.8 billion to Qatar, this report notes, revolves around his JP Morgan bank being told by the US Federal Deposit Insurance Corporation (FDIC) in April (2016) that this “megabanks” master plan to save itself had “serious deficiencies” that could “pose serious adverse effects to the financial stability of the United States”. \nTwo months after the FDIC’s warning letter to Jamie Dimon, in June (2016), this report says, he cryptically “sounded a warning” that the United States sub-prime auto loan bubble was nearing collapse and stated that “someone is going to get hurt”. \nUnbeknownst to the American people, MoF experts in this report explain, is that just 8 weeks ago multiple warnings began to be issued that the United States $1 trillion sub-prime auto loan bubble was beginning to collapse—and that this past week became so severe the Bank of America issued a recession warning telling its elite customers that “this market is scary”, and the British-based multinational banking and financial services company HSBC, likewise, issued a “Red Alert” warning all of its clients warning them to “prepare for a severe market crash”. \nWith one of the first casualties of this sub-prime auto loan bubble being the German global banking giant Deutsche Bank that is “nearing its doom” and laying off tens-of-thousands of it workers worldwide, this report grimly states, the American mainstream propaganda media is failing to allow the people of that nation to know the full extent of this looming catastrophe—who unlike Hillary Clinton who has just protected $1.8 billion of her wealth, will be left defenseless once again at the hands of their elite rulers. \nAs Wikileaks secret Hillary Clinton emails have now proven that the US propaganda mainstream media is now totally controlled by her, and who continue their blackout on the “Clinton Crime Story of the Century”, this report continues, the absolutely horrifying statistics released this week showing that an astounding 35% of American who have been brutalized by the Obama-Clinton regime these past 8 years are so buried in debt they can no longer pay their bills is, likewise, being kept from these most innocent of peoples.",
		"thread_title": "Hillary Clinton’s “Sudden Move” Of $1.8 Billion To Qatar Central Bank Stuns Financial World",
		"title": "Hillary Clinton’s “Sudden Move” Of $1.8 Billion To Qatar Central Bank Stuns Financial World",
		"type": "conspiracy",
		"uuid": "1e6f9e6ff0bb6bab5900e577c66d5a404f2995d9"
	},
	"-KhIjaefLq4zBZIojUmT": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-29T20:49:42.827+03:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "report",
				"salience": 0.33119243,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.18939602,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.073634095,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08xg_d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar_Central_Bank"
				},
				"name": "Qatar Central Bank",
				"salience": 0.054161385,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.031815212,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09h81",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_for_International_Settlements"
				},
				"name": "Bank For International Settlements",
				"salience": 0.03015986,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j7mmqf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_Intelligence_Service_(Kazakhstan)"
				},
				"name": "Foreign Intelligence Service",
				"salience": 0.02934923,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01hlwv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JPMorgan_Chase"
				},
				"name": "JP Morgan Chase & Company",
				"salience": 0.017627051,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03crtr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jamie_Dimon"
				},
				"name": "Jamie Dimon",
				"salience": 0.01620727,
				"type": "PERSON"
			},
			{
				"name": "banks",
				"salience": 0.016132154,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.014838103,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.011464589,
				"type": "PERSON"
			},
			{
				"name": "bank",
				"salience": 0.01034718,
				"type": "ORGANIZATION"
			},
			{
				"name": "Email",
				"salience": 0.0088189645,
				"type": "OTHER"
			},
			{
				"name": "bankers",
				"salience": 0.007533669,
				"type": "PERSON"
			},
			{
				"name": "mafia",
				"salience": 0.0071264114,
				"type": "OTHER"
			},
			{
				"name": "transfer",
				"salience": 0.0045153163,
				"type": "OTHER"
			},
			{
				"name": "transactions",
				"salience": 0.0045153163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05c35cg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Finance_(Vietnam)"
				},
				"name": "MoF",
				"salience": 0.004287057,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.004077904,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0040352964,
				"type": "PERSON"
			},
			{
				"name": "counterparty",
				"salience": 0.0035322148,
				"type": "OTHER"
			},
			{
				"name": "facilitation/abetment",
				"salience": 0.0035322148,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0035322148,
				"type": "OTHER"
			},
			{
				"name": "CF",
				"salience": 0.0035322148,
				"type": "OTHER"
			},
			{
				"name": "bribery scheme",
				"salience": 0.0031315195,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0031091727,
				"type": "ORGANIZATION"
			},
			{
				"name": "bank",
				"salience": 0.0031091727,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qataris",
				"salience": 0.002813621,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02lc8s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Deutsche_Bank"
				},
				"name": "Deutsche Bank",
				"salience": 0.002730251,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gulf State",
				"salience": 0.002591769,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq1f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HSBC"
				},
				"name": "HSBC",
				"salience": 0.002541038,
				"type": "ORGANIZATION"
			},
			{
				"name": "master plan",
				"salience": 0.0025250467,
				"type": "OTHER"
			},
			{
				"name": "Company",
				"salience": 0.002379987,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0021756338,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ps5qq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_Russia"
				},
				"name": "Kremlin",
				"salience": 0.0021756338,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03grh0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ministry_of_Finance_(Chile)"
				},
				"name": "Ministry of Finance",
				"salience": 0.0021756338,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0021395336,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01yx7f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_of_America"
				},
				"name": "Bank of America",
				"salience": 0.0021322344,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime",
				"salience": 0.001974126,
				"type": "ORGANIZATION"
			},
			{
				"name": "nations",
				"salience": 0.0018612049,
				"type": "LOCATION"
			},
			{
				"name": "megabank",
				"salience": 0.0017905325,
				"type": "OTHER"
			},
			{
				"name": "Chappaqua Compound",
				"salience": 0.0017881743,
				"type": "LOCATION"
			},
			{
				"name": "clients",
				"salience": 0.0017457254,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0016806059,
				"type": "OTHER"
			},
			{
				"name": "money laundering",
				"salience": 0.0016806059,
				"type": "OTHER"
			},
			{
				"name": "Company",
				"salience": 0.0016069442,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0016069442,
				"type": "ORGANIZATION"
			},
			{
				"name": "clients",
				"salience": 0.0015474735,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0014553916,
				"type": "ORGANIZATION"
			},
			{
				"name": "surveillance",
				"salience": 0.0014553916,
				"type": "OTHER"
			},
			{
				"name": "associates",
				"salience": 0.0014553916,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0014553916,
				"type": "ORGANIZATION"
			},
			{
				"name": "husband",
				"salience": 0.0014553916,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0013623174,
				"type": "LOCATION"
			},
			{
				"name": "emails",
				"salience": 0.0013470338,
				"type": "WORK_OF_ART"
			},
			{
				"name": "banking",
				"salience": 0.0013305089,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0013052236,
				"type": "PERSON"
			},
			{
				"name": "transfer",
				"salience": 0.0013052236,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0013052236,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0011785296,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.0011785296,
				"type": "OTHER"
			},
			{
				"name": "stocks",
				"salience": 0.0011345512,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.001065612,
				"type": "WORK_OF_ART"
			},
			{
				"name": "monarchy",
				"salience": 0.0010205501,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0010205501,
				"type": "EVENT"
			},
			{
				"name": "sum",
				"salience": 0.0010205501,
				"type": "OTHER"
			},
			{
				"name": "credit line",
				"salience": 0.000982463,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.000982463,
				"type": "OTHER"
			},
			{
				"name": "being",
				"salience": 0.000982463,
				"type": "EVENT"
			},
			{
				"name": "mainstream propaganda media",
				"salience": 0.0009744372,
				"type": "OTHER"
			},
			{
				"name": "megabanks",
				"salience": 0.0009621609,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.00092625146,
				"type": "OTHER"
			},
			{
				"name": "stocks",
				"salience": 0.0009145818,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0008407561,
				"type": "LOCATION"
			},
			{
				"name": "knowledge",
				"salience": 0.0008331686,
				"type": "OTHER"
			},
			{
				"name": "sheiks",
				"salience": 0.0008331686,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.0008331686,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.0008331686,
				"type": "EVENT"
			},
			{
				"name": "sub-prime auto loan bubble",
				"salience": 0.00079607376,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00079607376,
				"type": "LOCATION"
			},
			{
				"name": "dividend growth",
				"salience": 0.00073394604,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.00071877684,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00071877684,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0006707171,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Persian Gulf",
				"salience": 0.0006559248,
				"type": "LOCATION"
			},
			{
				"name": "Obama-Clinton",
				"salience": 0.00065370725,
				"type": "PERSON"
			},
			{
				"name": "statistics",
				"salience": 0.0006474714,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00062818,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "doom",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "catastrophe",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "extent",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "tens-of-thousands",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0006223999,
				"type": "PERSON"
			},
			{
				"name": "market crash",
				"salience": 0.0006223999,
				"type": "EVENT"
			},
			{
				"name": "deficiencies",
				"salience": 0.0006223999,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xmb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Reserve_System"
				},
				"name": "Federal Reserve",
				"salience": 0.0006047301,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0006047301,
				"type": "LOCATION"
			},
			{
				"name": "bills",
				"salience": 0.00057979155,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.00057979155,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/030q7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FIFA_World_Cup"
				},
				"name": "World Cup",
				"salience": 0.0005533604,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/015wpt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Deposit_Insurance_Corporation"
				},
				"name": "Federal Deposit Insurance Corporation",
				"salience": 0.00054756476,
				"type": "ORGANIZATION"
			},
			{
				"name": "cash grab",
				"salience": 0.0005413591,
				"type": "OTHER"
			},
			{
				"name": "secret",
				"salience": 0.0005234876,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0005128155,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0005128155,
				"type": "LOCATION"
			},
			{
				"name": "warning",
				"salience": 0.000468818,
				"type": "OTHER"
			},
			{
				"name": "recession warning",
				"salience": 0.000468818,
				"type": "OTHER"
			},
			{
				"name": "warnings",
				"salience": 0.000468818,
				"type": "OTHER"
			},
			{
				"name": "blackout",
				"salience": 0.00045328776,
				"type": "EVENT"
			},
			{
				"name": "debt",
				"salience": 0.00045328776,
				"type": "OTHER"
			},
			{
				"name": "wealth",
				"salience": 0.00045328776,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.00045328776,
				"type": "OTHER"
			},
			{
				"name": "rulers",
				"salience": 0.00045328776,
				"type": "PERSON"
			},
			{
				"name": "innocent",
				"salience": 0.00045328776,
				"type": "OTHER"
			},
			{
				"name": "auto loan bubble",
				"salience": 0.00043310114,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00043310114,
				"type": "PERSON"
			},
			{
				"name": "sub-prime auto loan bubble",
				"salience": 0.00042225316,
				"type": "OTHER"
			},
			{
				"name": "propaganda mainstream media",
				"salience": 0.00040108486,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00038929158,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0003830659,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0003830659,
				"type": "LOCATION"
			},
			{
				"name": "Red Alert",
				"salience": 0.00035052124,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stability",
				"salience": 0.00033859606,
				"type": "OTHER"
			},
			{
				"name": "warning letter",
				"salience": 0.00033859606,
				"type": "WORK_OF_ART"
			},
			{
				"name": "collapse",
				"salience": 0.00033859606,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0003221803,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.00027897066,
				"type": "ORGANIZATION"
			},
			{
				"name": "Clinton Crime Story of the Century",
				"salience": 0.00027897066,
				"type": "WORK_OF_ART"
			},
			{
				"name": "customers",
				"salience": 0.00027640315,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.00019875143,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14777572901.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-29T20:49:42.827+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAn intriguing Ministry of Finance (MoF) report circulating in the Kremlin today says that elite Western bankers were stunned a few hours ago after the Bank For International Settlements (BIS) registered a $1.8 billion transfer from the Clinton Foundation (CF) to the Qatar Central Bank (QCB) through the “facilitation/abetment” of JP Morgan Chase & Company (JPM)—and for reasons yet to be firmly established. \nAccording to this report, the Bank for International Settlements is the world's oldest international financial organization and acts as a prime counterparty for central banks in their financial transactions; the Qatar Central Bank is the bank of that Gulf State nations government and their “bank of banks”; JP Morgan Chase & Company is the United States largest “megabank”; and the Clinton Foundation is an international criminal money laundering organization whose clients include the Russian mafia. \nWith Hillary Clinton’s US presidential campaign Chairman John Podesta having longstanding ties to the Russian mafia and money laundering, this report continues, the Foreign Intelligence Service (SVR) maintains complete surveillance of him and his criminal associates—including both Hillary Clinton and her husband, and former US President, Bill Clinton. \nOn Saturday 15 October (2016), this report notes, the SVR reported to the MoF that Hillary Clinton and John Podesta met with JP Morgan Chase & Company CEO Jamie Dimon at Clinton’s Chappaqua Compound outside of New York City—and who, in 2009, both President Obama and Hillary Clinton allowed to break US laws by his, Dimon’s, being able to buy millions-of-dollars of his company’s stocks prior to the public being told his JP Morgan bank was receiving a Federal Reserve $80 billion credit line—and that caused JP Morgan’s stocks to soar and that have had an astonishing 920% dividend growth since 2010. \nWithin 12 hours of the Hillary Clinton-John Podesta-Jamie Dimon meeting at the Chappaqua Compound, this report continues, the BIS registered the transfer of $1.8 billion from the Clinton Foundation to the Qatar Central Bank. \nTo why the Clinton Foundation transferred this enormous sum of money to Qatar, this report explains, is due to the longstanding ties between this Islamic neo-patrimonial absolute monarchy and then US Secretary of State Hillary Clinton who oversaw the “massive bribery scheme” that allowed this Gulf State nation to secure the 2022 World Cup—and that the Qataris were so appreciative of they donated millions to the Clinton Foundation, and incredibly, in 2011, gave former US President Bill Clinton $1 million for a birthday present—bringing Hillary Clinton’s total “cash grab” from these Persian Gulf sheiks of $100 million—all occurring as recently released secret emails revealed Hillary Clinton’s knowledge that both Qatar and Saudi Arabia were, and still are, funding ISIS. \nTo what Jamie Dimon said to Hillary Clinton that caused her to suddenly transfer $1.8 billion to Qatar, this report notes, revolves around his JP Morgan bank being told by the US Federal Deposit Insurance Corporation (FDIC) in April (2016) that this “megabanks” master plan to save itself had “serious deficiencies” that could “pose serious adverse effects to the financial stability of the United States”. \nTwo months after the FDIC’s warning letter to Jamie Dimon, in June (2016), this report says, he cryptically “sounded a warning” that the United States sub-prime auto loan bubble was nearing collapse and stated that “someone is going to get hurt”. \nUnbeknownst to the American people, MoF experts in this report explain, is that just 8 weeks ago multiple warnings began to be issued that the United States $1 trillion sub-prime auto loan bubble was beginning to collapse—and that this past week became so severe the Bank of America issued a recession warning telling its elite customers that “this market is scary”, and the British-based multinational banking and financial services company HSBC, likewise, issued a “Red Alert” warning all of its clients warning them to “prepare for a severe market crash”. \nWith one of the first casualties of this sub-prime auto loan bubble being the German global banking giant Deutsche Bank that is “nearing its doom” and laying off tens-of-thousands of it workers worldwide, this report grimly states, the American mainstream propaganda media is failing to allow the people of that nation to know the full extent of this looming catastrophe—who unlike Hillary Clinton who has just protected $1.8 billion of her wealth, will be left defenseless once again at the hands of their elite rulers. \nAs Wikileaks secret Hillary Clinton emails have now proven that the US propaganda mainstream media is now totally controlled by her, and who continue their blackout on the “Clinton Crime Story of the Century”, this report continues, the absolutely horrifying statistics released this week showing that an astounding 35% of American who have been brutalized by the Obama-Clinton regime these past 8 years are so buried in debt they can no longer pay their bills is, likewise, being kept from these most innocent of peoples.",
		"thread_title": "Hillary Clinton’s “Sudden Move” Of $1.8 Billion To Qatar Central Bank Stuns Financial World",
		"title": "Hillary Clinton’s “Sudden Move” Of $1.8 Billion To Qatar Central Bank Stuns Financial World",
		"type": "conspiracy",
		"uuid": "5d7c1f6133d380e202a1b7692f659ebf7f276ffb"
	},
	"-KhIjakg8_Ldh6_MyV1P": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-30T13:10:51.667+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Email",
				"salience": 0.27364367,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.14582121,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h8mw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haaretz"
				},
				"name": "Haaretz",
				"salience": 0.091341406,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03hkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hebrew_language"
				},
				"name": "Hebrew",
				"salience": 0.091341406,
				"type": "OTHER"
			},
			{
				"name": "Zionist regime",
				"salience": 0.061658435,
				"type": "ORGANIZATION"
			},
			{
				"name": "houses",
				"salience": 0.05336717,
				"type": "LOCATION"
			},
			{
				"name": "houses",
				"salience": 0.047694836,
				"type": "LOCATION"
			},
			{
				"name": "C",
				"salience": 0.043474786,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.04187254,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/082pc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Bank"
				},
				"name": "West Bank",
				"salience": 0.02689401,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.026648514,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jt7v76",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palestinians"
				},
				"name": "Palestinians",
				"salience": 0.025897807,
				"type": "PERSON"
			},
			{
				"name": "houses",
				"salience": 0.024837706,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0430_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jerusalem"
				},
				"name": "Jerusalem",
				"salience": 0.021987313,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.014549921,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.008969261,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14778253541.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T13:10:51.667+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nHebrew newspaper 'Haaretz': From the beginning of this year, Zionist regime has destroyed 80 houses belonging to Palestinians in the areas better known as \"C\" in the West Bank and Jerusalem. \nTotally, 453 houses had been destroyed by the military of Israel in 2015, so, it indicates that the number of destroyed houses have been dramatically increased this year.",
		"thread_title": "From the beginning of this year, Zionist regime has destroyed 780 houses belonging to Palestinians",
		"title": "From the beginning of this year, Zionist regime has destroyed 780 houses belonging to Palestinians",
		"type": "conspiracy",
		"uuid": "4b7420fcdcb15d90fe98d1e97b17f9eee92cec05"
	},
	"-KhIjar9pYbDj-_mE79o": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-30T13:10:51.726+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0kvk5nr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abdel_Fattah_el-Sisi"
				},
				"name": "Abdel Fattah el-Sisi",
				"salience": 0.27423668,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.1509754,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.083303586,
				"type": "LOCATION"
			},
			{
				"name": "page",
				"salience": 0.07908259,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.05665027,
				"type": "OTHER"
			},
			{
				"name": "twitter account",
				"salience": 0.056232914,
				"type": "OTHER"
			},
			{
				"name": "@jil_ht",
				"salience": 0.049179785,
				"type": "PERSON"
			},
			{
				"name": "Jil al HorriyavalTanweer",
				"salience": 0.049179785,
				"type": "PERSON"
			},
			{
				"name": "revival",
				"salience": 0.023260284,
				"type": "EVENT"
			},
			{
				"name": "military forces",
				"salience": 0.023260284,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egyptian",
				"salience": 0.020438466,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.014357789,
				"type": "LOCATION"
			},
			{
				"name": "regime",
				"salience": 0.01422627,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.01422627,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.011730723,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.011730723,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.011730723,
				"type": "LOCATION"
			},
			{
				"name": "issues",
				"salience": 0.01037346,
				"type": "OTHER"
			},
			{
				"name": "hostility",
				"salience": 0.01037346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Erdogan",
				"salience": 0.008770868,
				"type": "PERSON"
			},
			{
				"name": "disintegration",
				"salience": 0.0077551473,
				"type": "OTHER"
			},
			{
				"name": "plundering",
				"salience": 0.0077551473,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar Assad",
				"salience": 0.006392242,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0047771493,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14778250681.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T13:10:51.726+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nAccording to Twitter page Jil al HorriyavalTanweer, @jil_ht, the Egyptian president Abdel Fattah el-Sisi has claimed in his official twitter account that Turkey is pursuing a revival of Ottoman Empire by deploying military forces to Syria and Iraq, while Saudi Arabia is remaining silent against the disintegration and plundering of the Arab countries by the Erdogan regime, only because of strategic issues and its own hostility toward Bashar Assad.",
		"thread_title": "Erdogan wants to revive the dream of Ottoman Empire by supporting Saudi Arabia",
		"title": "Erdogan wants to revive the dream of Ottoman Empire by supporting Saudi Arabia",
		"type": "conspiracy",
		"uuid": "d7281a0bd0743c501667fbc121735fe08c54fc5a"
	},
	"-KhIjazgLwsCjhRLrJ3S": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-30T13:16:35.059+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.3514708,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.14983594,
				"type": "OTHER"
			},
			{
				"name": "representative",
				"salience": 0.081784576,
				"type": "PERSON"
			},
			{
				"name": "Email",
				"salience": 0.045973767,
				"type": "OTHER"
			},
			{
				"name": "governors",
				"salience": 0.034877703,
				"type": "PERSON"
			},
			{
				"name": "governor",
				"salience": 0.034877703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.03450501,
				"type": "LOCATION"
			},
			{
				"name": "job",
				"salience": 0.030497631,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.02430166,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.023747714,
				"type": "EVENT"
			},
			{
				"name": "opportunity",
				"salience": 0.019548517,
				"type": "OTHER"
			},
			{
				"name": "representation",
				"salience": 0.0113585135,
				"type": "OTHER"
			},
			{
				"name": "province",
				"salience": 0.009842688,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.009813059,
				"type": "ORGANIZATION"
			},
			{
				"name": "governors",
				"salience": 0.009813059,
				"type": "PERSON"
			},
			{
				"name": "cooperation",
				"salience": 0.007679884,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.007679884,
				"type": "PERSON"
			},
			{
				"name": "corruption",
				"salience": 0.006910444,
				"type": "OTHER"
			},
			{
				"name": "importance",
				"salience": 0.006910444,
				"type": "OTHER"
			},
			{
				"name": "Law enforcement",
				"salience": 0.006910444,
				"type": "ORGANIZATION"
			},
			{
				"name": "councils",
				"salience": 0.006653267,
				"type": "ORGANIZATION"
			},
			{
				"name": "research",
				"salience": 0.0056446423,
				"type": "OTHER"
			},
			{
				"name": "offices",
				"salience": 0.0056446423,
				"type": "LOCATION"
			},
			{
				"name": "usage",
				"salience": 0.0056446423,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0056446423,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0054344386,
				"type": "OTHER"
			},
			{
				"name": "exclusion",
				"salience": 0.0046101403,
				"type": "OTHER"
			},
			{
				"name": "martyrs",
				"salience": 0.0042192386,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0042192386,
				"type": "PERSON"
			},
			{
				"name": "affairs",
				"salience": 0.0042192386,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0042192386,
				"type": "OTHER"
			},
			{
				"name": "veterans",
				"salience": 0.0042192386,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0042192386,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.003074313,
				"type": "OTHER"
			},
			{
				"name": "sacrifices",
				"salience": 0.003074313,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.003074313,
				"type": "EVENT"
			},
			{
				"name": "terrorism",
				"salience": 0.003074313,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0026525944,
				"type": "ORGANIZATION"
			},
			{
				"name": "institutions",
				"salience": 0.0026525944,
				"type": "ORGANIZATION"
			},
			{
				"name": "cooperation system",
				"salience": 0.002574683,
				"type": "OTHER"
			},
			{
				"name": "price fluctuations",
				"salience": 0.0022971965,
				"type": "OTHER"
			},
			{
				"name": "customer rights",
				"salience": 0.0022971965,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.0022971965,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14778261151.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T13:16:35.059+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nDuring a meeting with governors, Syrian President Bashar al-Assad, emphasized that, the job of a governor is not limited to the governmental representation in the province, but it is also important that the citizens feel that the Governor is their representative in the government. This is an opportunity for deeper and greater cooperation between governors, citizens and local councils. \nHe also noted the importance of Law enforcement for all, justly and similar. It is an issue, that requires more research, to uncover corruption in the offices first, and then to fight with it. It also requires exclusion for personal usage of public funds in governmental institutions, creating a cooperation system between public and private institutions and protection of customer rights by removing price fluctuations. \nThe President also stated the need for a great attention to the affairs of the families of martyrs and war veterans is to repay at least a small part of the sacrifices that they made for Syria. He also announced that Syria will continue the fight against terrorism.",
		"thread_title": "Syrian President Bashar al-Assad, welcomes the Prime Minister and Internal Trade and Consumer Protection Minister",
		"title": "Syrian President Bashar al-Assad, welcomes the Prime Minister and Internal Trade and Consumer Protection Minister",
		"type": "conspiracy",
		"uuid": "620b8daa86b62ebe514f0482925be5f28d941c09"
	},
	"-KhIjb4uH-rdZkJU0aI7": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-30T13:16:35.260+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.24959478,
				"type": "LOCATION"
			},
			{
				"name": "Email",
				"salience": 0.13404678,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.079959236,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.06975466,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06pq6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shia_Islam"
				},
				"name": "Shiites",
				"salience": 0.054299917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03m7d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hezbollah"
				},
				"name": "Hezbollah",
				"salience": 0.04326092,
				"type": "ORGANIZATION"
			},
			{
				"name": "defendant",
				"salience": 0.040771555,
				"type": "PERSON"
			},
			{
				"name": "prosecutor",
				"salience": 0.038776793,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.03284866,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.029045738,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.021741135,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.020412736,
				"type": "PERSON"
			},
			{
				"name": "expense",
				"salience": 0.016680766,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.016680766,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.016680766,
				"type": "EVENT"
			},
			{
				"name": "army",
				"salience": 0.014701707,
				"type": "ORGANIZATION"
			},
			{
				"name": "connections",
				"salience": 0.014606842,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.014398972,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/052dhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takfiri"
				},
				"name": "Takfiri",
				"salience": 0.01258992,
				"type": "PERSON"
			},
			{
				"name": "None",
				"salience": 0.012474446,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.012474446,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.012121396,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.010497315,
				"type": "LOCATION"
			},
			{
				"name": "chaos",
				"salience": 0.009208679,
				"type": "OTHER"
			},
			{
				"name": "reflection",
				"salience": 0.009092893,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.009092893,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.004185304,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14778259561.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T13:16:35.260+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \n\nCondemning two young men, accused for confirming the current government of Syria and Hezbollah, wondered Shia community in Saudi Arabia. The Public prosecutor claimed that the first defendant had the purpose of going to Yemen, and then to Syria, to join the army for fighting against the Takfiri terrorists. And the second one, had paid 2500 riyals to him as the expense of his trip. \nDespite six years of war in Syria, and definite denies of Shiites in Saudi Arabia for having connections with Iran and Syria, they are still accused for trying to make chaos in the region. None of these allegations has been proven, but Shiites are worried about the reflection of the chaotic situation of the region against themselves.",
		"thread_title": "Accusing two young men in Al-Qatif",
		"title": "Accusing two young men in Al-Qatif",
		"type": "conspiracy",
		"uuid": "4e5545d95f60e67ccb10a773e2fc6912aa803600"
	},
	"-KhIjbD0ASi4EEq5fn71": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-30T13:16:35.292+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "reward",
				"salience": 0.34385332,
				"type": "OTHER"
			},
			{
				"name": "VAT Act",
				"salience": 0.19692823,
				"type": "WORK_OF_ART"
			},
			{
				"name": "touches",
				"salience": 0.09039893,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.071455784,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.033898644,
				"type": "OTHER"
			},
			{
				"name": "mode",
				"salience": 0.033898644,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.027390942,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.021047335,
				"type": "OTHER"
			},
			{
				"name": "Ibrahim al-Assaf",
				"salience": 0.01798532,
				"type": "PERSON"
			},
			{
				"name": "social networks commentators",
				"salience": 0.015134174,
				"type": "PERSON"
			},
			{
				"name": "budget",
				"salience": 0.0092644375,
				"type": "OTHER"
			},
			{
				"name": "trade deficit",
				"salience": 0.008369578,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.007509655,
				"type": "OTHER"
			},
			{
				"name": "austerity",
				"salience": 0.007252423,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.007252423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0240lv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Saud"
				},
				"name": "Al-Saud",
				"salience": 0.006184363,
				"type": "PERSON"
			},
			{
				"name": "tax",
				"salience": 0.005091559,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.005091559,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0049020485,
				"type": "PERSON"
			},
			{
				"name": "adoption",
				"salience": 0.0049020485,
				"type": "OTHER"
			},
			{
				"name": "basics",
				"salience": 0.0049020485,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0049020485,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.004158825,
				"type": "LOCATION"
			},
			{
				"name": "buyer",
				"salience": 0.004158825,
				"type": "PERSON"
			},
			{
				"name": "value",
				"salience": 0.004158825,
				"type": "OTHER"
			},
			{
				"name": "fees",
				"salience": 0.004158825,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.004158825,
				"type": "OTHER"
			},
			{
				"name": "store",
				"salience": 0.004158825,
				"type": "LOCATION"
			},
			{
				"name": "surplus",
				"salience": 0.0040039364,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.0039740643,
				"type": "OTHER"
			},
			{
				"name": "budget",
				"salience": 0.0039740643,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0035889468,
				"type": "ORGANIZATION"
			},
			{
				"name": "pockets",
				"salience": 0.0035889468,
				"type": "OTHER"
			},
			{
				"name": "deficit",
				"salience": 0.0035889468,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zq91",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Finance_minister"
				},
				"name": "Ministry of Finance",
				"salience": 0.0034872575,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01fsjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Value-added_tax"
				},
				"name": "VAT",
				"salience": 0.0034872575,
				"type": "OTHER"
			},
			{
				"name": "pockets",
				"salience": 0.0026152318,
				"type": "OTHER"
			},
			{
				"name": "poor",
				"salience": 0.0026152318,
				"type": "PERSON"
			},
			{
				"name": "poor",
				"salience": 0.0026152318,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.0025384475,
				"type": "OTHER"
			},
			{
				"name": "punishment",
				"salience": 0.0022649614,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0019542496,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0016924052,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0014423555,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14778258141.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T13:16:35.292+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email Saudi Arabia announces the VAT Act, which was the last touches which come into force in early 2018 mode, and angry on Twitter. After the case of austerity pursued by the government of Al-Saud and the trade deficit in the budget, said Ibrahim al-Assaf, Saudi Minister of Finance, on Thursday, by members of the Ministry of Finance meeting, it was finalized last basics of the adoption of the VAT law, and will be implemented in the early 2018 according to an earlier agreement, a law requiring the buyer to pay a financial tax of $ (5% or 10%) on everything you buy from any store and these fees (value added) of the state and is applied in most countries of the world. This law has angered the Saudis on social networks commentators on this law that will adversely affect the community, describing the situation experienced by their government that when there is a surplus in the budget, they go to the rich pockets, and when there is a deficit in the budget are taken from the pockets of the poor and this law is a \"reward for the rich .... and the punishment of the poor.\"",
		"thread_title": "Saudi Arabia announces date certain for the application of VAT",
		"title": "Saudi Arabia announces date certain for the application of VAT",
		"type": "conspiracy",
		"uuid": "03efecc76b59e2bb783f5321a319f9bfd93ce2f0"
	},
	"-KhIjcCAqHFTeCklKIPX": {
		"author": "",
		"comments": "0",
		"country": "DE",
		"crawled": "2016-10-30T14:19:34.955+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cltv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anne,_Queen_of_Great_Britain"
				},
				"name": "Queen Anne",
				"salience": 0.5013943,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d1_f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elizabeth_II"
				},
				"name": "Elizabeth II",
				"salience": 0.3256015,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "United Kingdom",
				"salience": 0.014827173,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cp2_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monarchy_of_the_United_Kingdom"
				},
				"name": "Sovereign",
				"salience": 0.009480902,
				"type": "ORGANIZATION"
			},
			{
				"name": "Queen",
				"salience": 0.0069995713,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0266lb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Cameron"
				},
				"name": "David Cameron",
				"salience": 0.0066355555,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0044611213,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d2kt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/River_Thames"
				},
				"name": "River Thames",
				"salience": 0.0026193259,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09v0gf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sevens_(card_game)"
				},
				"name": "Parliament",
				"salience": 0.0024964958,
				"type": "ORGANIZATION"
			},
			{
				"name": "consent",
				"salience": 0.0024182175,
				"type": "OTHER"
			},
			{
				"name": "whales",
				"salience": 0.0022577844,
				"type": "OTHER"
			},
			{
				"name": "head of state",
				"salience": 0.00215756,
				"type": "PERSON"
			},
			{
				"name": "affair",
				"salience": 0.002110031,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0lf35",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abdullah_of_Saudi_Arabia"
				},
				"name": "Abdullah of Saudi Arabia",
				"salience": 0.0020373901,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.0017941217,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.0015425032,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01nq43",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scottish_Government"
				},
				"name": "Scottish Government",
				"salience": 0.0014626471,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027_m40",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sherard_Cowper-Coles"
				},
				"name": "Sherard Cowper-Coles",
				"salience": 0.001312805,
				"type": "PERSON"
			},
			{
				"name": "army driver",
				"salience": 0.0013102804,
				"type": "PERSON"
			},
			{
				"name": "poet",
				"salience": 0.0012672929,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03k6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Lords"
				},
				"name": "Lords",
				"salience": 0.0011181976,
				"type": "OTHER"
			},
			{
				"name": "Queen",
				"salience": 0.001109081,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.001109081,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.001109081,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05yq74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Majesty"
				},
				"name": "Her Majesty",
				"salience": 0.0011073614,
				"type": "PERSON"
			},
			{
				"name": "sovereign",
				"salience": 0.0010748684,
				"type": "PERSON"
			},
			{
				"name": "birthday",
				"salience": 0.0010402291,
				"type": "EVENT"
			},
			{
				"name": "sturgeons",
				"salience": 0.0010320625,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0009958822,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09rkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times"
				},
				"name": "The Times",
				"salience": 0.00093993056,
				"type": "ORGANIZATION"
			},
			{
				"name": "Email",
				"salience": 0.0009125839,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c6p_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edward_II_of_England"
				},
				"name": "Edward II",
				"salience": 0.00090303645,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0008888722,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06q1r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scotland"
				},
				"name": "Scottish",
				"salience": 0.0008840391,
				"type": "LOCATION"
			},
			{
				"name": "sturgeon",
				"salience": 0.0008581317,
				"type": "OTHER"
			},
			{
				"name": "statute",
				"salience": 0.00082529633,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government",
				"salience": 0.0008043596,
				"type": "ORGANIZATION"
			},
			{
				"name": "Monarchy",
				"salience": 0.0007828718,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.00077639555,
				"type": "PERSON"
			},
			{
				"name": "prerogative powers",
				"salience": 0.0007732375,
				"type": "OTHER"
			},
			{
				"name": "prerogative powers",
				"salience": 0.0007732375,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.0007732375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "The Guardian",
				"salience": 0.0007669098,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australian",
				"salience": 0.0007638281,
				"type": "LOCATION"
			},
			{
				"name": "swans",
				"salience": 0.00075208576,
				"type": "OTHER"
			},
			{
				"name": "government ministers",
				"salience": 0.00070303347,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.0006638367,
				"type": "PERSON"
			},
			{
				"name": "swans",
				"salience": 0.00066257076,
				"type": "PERSON"
			},
			{
				"name": "swans",
				"salience": 0.00066257076,
				"type": "OTHER"
			},
			{
				"name": "swans",
				"salience": 0.00066257076,
				"type": "PERSON"
			},
			{
				"name": "swans",
				"salience": 0.00066257076,
				"type": "OTHER"
			},
			{
				"name": "statute",
				"salience": 0.0006405364,
				"type": "WORK_OF_ART"
			},
			{
				"name": "law",
				"salience": 0.0006343927,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00061641977,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0231r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles_I_of_England"
				},
				"name": "Charles I",
				"salience": 0.00060949597,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0005962257,
				"type": "OTHER"
			},
			{
				"name": "uniforms",
				"salience": 0.000585679,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "society",
				"salience": 0.00057478884,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04syw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monarch"
				},
				"name": "Crown",
				"salience": 0.00057084573,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00053433183,
				"type": "OTHER"
			},
			{
				"name": "ministers",
				"salience": 0.0005263688,
				"type": "PERSON"
			},
			{
				"name": "website",
				"salience": 0.00050084916,
				"type": "OTHER"
			},
			{
				"name": "open water",
				"salience": 0.00050084916,
				"type": "OTHER"
			},
			{
				"name": "ownership",
				"salience": 0.00050084916,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.00050084916,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.00050084916,
				"type": "PERSON"
			},
			{
				"name": "website",
				"salience": 0.00050084916,
				"type": "OTHER"
			},
			{
				"name": "waters",
				"salience": 0.00050084916,
				"type": "LOCATION"
			},
			{
				"name": "waters",
				"salience": 0.00050084916,
				"type": "OTHER"
			},
			{
				"name": "sturgeons",
				"salience": 0.00050084916,
				"type": "OTHER"
			},
			{
				"name": "dominion",
				"salience": 0.0004803102,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0168vx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Carol_Ann_Duffy"
				},
				"name": "Carol Ann Duffy",
				"salience": 0.00047947964,
				"type": "PERSON"
			},
			{
				"name": "John Kirkhope",
				"salience": 0.00047744098,
				"type": "PERSON"
			},
			{
				"name": "crown prince",
				"salience": 0.00047363297,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0004627094,
				"type": "EVENT"
			},
			{
				"name": "identification numbers",
				"salience": 0.0004627094,
				"type": "OTHER"
			},
			{
				"name": "rule",
				"salience": 0.0004627094,
				"type": "OTHER"
			},
			{
				"name": "Queen",
				"salience": 0.00045681032,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.00045681032,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.00045681032,
				"type": "PERSON"
			},
			{
				"name": "queen",
				"salience": 0.00045681032,
				"type": "PERSON"
			},
			{
				"name": "tax laws",
				"salience": 0.00044789075,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cp2_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monarchy_of_the_United_Kingdom"
				},
				"name": "Royal Family",
				"salience": 0.0004264759,
				"type": "WORK_OF_ART"
			},
			{
				"name": "requests",
				"salience": 0.00041867082,
				"type": "OTHER"
			},
			{
				"name": "treaty",
				"salience": 0.00041778974,
				"type": "OTHER"
			},
			{
				"name": "wine",
				"salience": 0.00041778974,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "place",
				"salience": 0.00041778974,
				"type": "OTHER"
			},
			{
				"name": "stretches",
				"salience": 0.00041778974,
				"type": "OTHER"
			},
			{
				"name": "waves",
				"salience": 0.00041778974,
				"type": "OTHER"
			},
			{
				"name": "waves",
				"salience": 0.00041778974,
				"type": "OTHER"
			},
			{
				"name": "dolphins",
				"salience": 0.00041778974,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.00041778974,
				"type": "OTHER"
			},
			{
				"name": "reign",
				"salience": 0.00041778974,
				"type": "EVENT"
			},
			{
				"name": "maidens",
				"salience": 0.00041098087,
				"type": "PERSON"
			},
			{
				"name": "Swan uppers",
				"salience": 0.00038060112,
				"type": "OTHER"
			},
			{
				"name": "civil service",
				"salience": 0.00036340256,
				"type": "OTHER"
			},
			{
				"name": "census",
				"salience": 0.00036177956,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.00036177956,
				"type": "PERSON"
			},
			{
				"name": "swan population",
				"salience": 0.00036177956,
				"type": "PERSON"
			},
			{
				"name": "tributaries",
				"salience": 0.00036177956,
				"type": "LOCATION"
			},
			{
				"name": "skiffs",
				"salience": 0.00036177956,
				"type": "OTHER"
			},
			{
				"name": "song",
				"salience": 0.00036177956,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tradition",
				"salience": 0.00036177956,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.00036177956,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.00036177956,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00036177956,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Helena Kennedy QC",
				"salience": 0.00035874627,
				"type": "PERSON"
			},
			{
				"name": "bill",
				"salience": 0.00035078006,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01ljsd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HMY_Britannia"
				},
				"name": "Britannia",
				"salience": 0.00033866608,
				"type": "ORGANIZATION"
			},
			{
				"name": "dominion",
				"salience": 0.00033678112,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00033137738,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.00032891886,
				"type": "LOCATION"
			},
			{
				"name": "monarch",
				"salience": 0.00032167134,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.00032029994,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.00032029994,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.00032029994,
				"type": "PERSON"
			},
			{
				"name": "crown prince",
				"salience": 0.00031970223,
				"type": "PERSON"
			},
			{
				"name": "health check",
				"salience": 0.00031071485,
				"type": "OTHER"
			},
			{
				"name": "Queen",
				"salience": 0.0003083442,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0002996623,
				"type": "PERSON"
			},
			{
				"name": "purchaser",
				"salience": 0.0002991167,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00029548313,
				"type": "ORGANIZATION"
			},
			{
				"name": "parade",
				"salience": 0.0002947512,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0kz42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerr_(governor-general)"
				},
				"name": "John Kerr",
				"salience": 0.00029081528,
				"type": "PERSON"
			},
			{
				"name": "birthday",
				"salience": 0.0002849338,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d2kt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/River_Thames"
				},
				"name": "River Thames",
				"salience": 0.00028481745,
				"type": "LOCATION"
			},
			{
				"name": "person",
				"salience": 0.00028017315,
				"type": "PERSON"
			},
			{
				"name": "King",
				"salience": 0.00027447587,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0002596462,
				"type": "WORK_OF_ART"
			},
			{
				"name": "approval",
				"salience": 0.0002596462,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.00024471144,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01kw9b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rule,_Britannia!"
				},
				"name": "Rule, Britannia",
				"salience": 0.00024461152,
				"type": "WORK_OF_ART"
			},
			{
				"name": "law",
				"salience": 0.00024361833,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00024361833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.00024204962,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0155br",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sherry"
				},
				"name": "Sherry",
				"salience": 0.00024138155,
				"type": "PERSON"
			},
			{
				"name": "advice",
				"salience": 0.00024105574,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.00023221507,
				"type": "ORGANIZATION"
			},
			{
				"name": "Birthday",
				"salience": 0.00022967605,
				"type": "EVENT"
			},
			{
				"name": "power",
				"salience": 0.00022607118,
				"type": "OTHER"
			},
			{
				"name": "license",
				"salience": 0.00022531065,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00022322219,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.00022322219,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00022322219,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bs_f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ornithology"
				},
				"name": "Ornithology",
				"salience": 0.00022267672,
				"type": "OTHER"
			},
			{
				"name": "Swan Marker",
				"salience": 0.00022267672,
				"type": "PERSON"
			},
			{
				"name": "Swan Warden",
				"salience": 0.00022267672,
				"type": "LOCATION"
			},
			{
				"name": "Department of Zoology",
				"salience": 0.00022267672,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07tgn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Oxford"
				},
				"name": "University of Oxford",
				"salience": 0.00022267672,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/023fng",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Swan_Upping"
				},
				"name": "Swan Upping",
				"salience": 0.00022267672,
				"type": "EVENT"
			},
			{
				"name": "bill",
				"salience": 0.00022084422,
				"type": "WORK_OF_ART"
			},
			{
				"name": "seat",
				"salience": 0.00021996033,
				"type": "OTHER"
			},
			{
				"name": "driving seat",
				"salience": 0.00021996033,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.00021996033,
				"type": "LOCATION"
			},
			{
				"name": "seat",
				"salience": 0.00021996033,
				"type": "OTHER"
			},
			{
				"name": "country seat",
				"salience": 0.00021996033,
				"type": "LOCATION"
			},
			{
				"name": "sovereign",
				"salience": 0.00021488877,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04r40",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Land_Rover"
				},
				"name": "Land Rover",
				"salience": 0.0002145183,
				"type": "ORGANIZATION"
			},
			{
				"name": "birthday",
				"salience": 0.0002128475,
				"type": "EVENT"
			},
			{
				"name": "fantasy author",
				"salience": 0.00021196209,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.00020716651,
				"type": "ORGANIZATION"
			},
			{
				"name": "licence",
				"salience": 0.00020617041,
				"type": "OTHER"
			},
			{
				"name": "sturgeon",
				"salience": 0.00020617041,
				"type": "OTHER"
			},
			{
				"name": "Driving licenses",
				"salience": 0.00020617041,
				"type": "OTHER"
			},
			{
				"name": "license",
				"salience": 0.00020617041,
				"type": "OTHER"
			},
			{
				"name": "fisherman",
				"salience": 0.00020617041,
				"type": "PERSON"
			},
			{
				"name": "ministers",
				"salience": 0.00020293881,
				"type": "PERSON"
			},
			{
				"name": "government ministers",
				"salience": 0.00020293881,
				"type": "PERSON"
			},
			{
				"name": "houses",
				"salience": 0.00020023534,
				"type": "LOCATION"
			},
			{
				"name": "times",
				"salience": 0.00019536239,
				"type": "OTHER"
			},
			{
				"name": "monarch",
				"salience": 0.00019124981,
				"type": "PERSON"
			},
			{
				"name": "parliament",
				"salience": 0.00019124981,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0001910636,
				"type": "EVENT"
			},
			{
				"name": "whales",
				"salience": 0.00019046353,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.00019046353,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00019046353,
				"type": "OTHER"
			},
			{
				"name": "interpreter",
				"salience": 0.00019046353,
				"type": "PERSON"
			},
			{
				"name": "birthday",
				"salience": 0.00018988742,
				"type": "EVENT"
			},
			{
				"name": "birthdays",
				"salience": 0.00018988742,
				"type": "EVENT"
			},
			{
				"name": "birthday",
				"salience": 0.00018988742,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.00018956714,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00018956714,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00018956714,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00018956714,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00018956714,
				"type": "ORGANIZATION"
			},
			{
				"name": "crisis",
				"salience": 0.00018845989,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05zp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Palace"
				},
				"name": "Palace",
				"salience": 0.00018494274,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00017992879,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00017992879,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07s52",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Time_(magazine)"
				},
				"name": "Time",
				"salience": 0.000178152,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0732jx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Sunday_Times"
				},
				"name": "Sunday Times",
				"salience": 0.000178152,
				"type": "ORGANIZATION"
			},
			{
				"name": "bills",
				"salience": 0.00017576838,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.000171966,
				"type": "EVENT"
			},
			{
				"name": "Women",
				"salience": 0.000171966,
				"type": "PERSON"
			},
			{
				"name": "port",
				"salience": 0.000171966,
				"type": "OTHER"
			},
			{
				"name": "dolphins",
				"salience": 0.000171966,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0001707992,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0001707992,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0001707992,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0001707992,
				"type": "OTHER"
			},
			{
				"name": "ministers",
				"salience": 0.00016566622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03p77",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Henry_VIII_of_England"
				},
				"name": "Henry VIII",
				"salience": 0.00016307972,
				"type": "PERSON"
			},
			{
				"name": "capital gains tax",
				"salience": 0.00016288864,
				"type": "OTHER"
			},
			{
				"name": "consent",
				"salience": 0.00016288864,
				"type": "OTHER"
			},
			{
				"name": "tax",
				"salience": 0.00016288864,
				"type": "OTHER"
			},
			{
				"name": "tax",
				"salience": 0.00016288864,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.00016288864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "income tax",
				"salience": 0.00016288864,
				"type": "OTHER"
			},
			{
				"name": "royal family",
				"salience": 0.00015680704,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00015680704,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00015617938,
				"type": "ORGANIZATION"
			},
			{
				"name": "position",
				"salience": 0.00015352199,
				"type": "OTHER"
			},
			{
				"name": "birthdays",
				"salience": 0.0001530576,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.00015206468,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04szc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monarchy"
				},
				"name": "Monarchy",
				"salience": 0.00015112171,
				"type": "PERSON"
			},
			{
				"name": "poet laureate",
				"salience": 0.00014957195,
				"type": "OTHER"
			},
			{
				"name": "loyalty",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "gesture",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00014890371,
				"type": "ORGANIZATION"
			},
			{
				"name": "guidance",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "shores",
				"salience": 0.00014890371,
				"type": "LOCATION"
			},
			{
				"name": "porpoises",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "wain",
				"salience": 0.00014890371,
				"type": "PERSON"
			},
			{
				"name": "oxen",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "number plate",
				"salience": 0.00014890371,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cars",
				"salience": 0.00014890371,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "wheel",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "training",
				"salience": 0.00014890371,
				"type": "EVENT"
			},
			{
				"name": "spark plug",
				"salience": 0.00014890371,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "surprise",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "ignition",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00014890371,
				"type": "PERSON"
			},
			{
				"name": "notes",
				"salience": 0.00014890371,
				"type": "OTHER"
			},
			{
				"name": "poet",
				"salience": 0.00014845327,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.00014454208,
				"type": "OTHER"
			},
			{
				"name": "prerogative",
				"salience": 0.00014454208,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.00014454208,
				"type": "PERSON"
			},
			{
				"name": "Queen",
				"salience": 0.00014225017,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00013961506,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.00013914531,
				"type": "OTHER"
			},
			{
				"name": "knights",
				"salience": 0.00013914531,
				"type": "PERSON"
			},
			{
				"name": "gun",
				"salience": 0.00013914531,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "website",
				"salience": 0.00013914531,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00013914531,
				"type": "PERSON"
			},
			{
				"name": "celebrations",
				"salience": 0.00013861136,
				"type": "EVENT"
			},
			{
				"name": "exception",
				"salience": 0.00013709808,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00013695999,
				"type": "OTHER"
			},
			{
				"name": "interests",
				"salience": 0.00013352928,
				"type": "OTHER"
			},
			{
				"name": "landowners",
				"salience": 0.00013325954,
				"type": "PERSON"
			},
			{
				"name": "contribution",
				"salience": 0.00012951228,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00012951228,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0001285436,
				"type": "OTHER"
			},
			{
				"name": "interpreter",
				"salience": 0.0001285436,
				"type": "PERSON"
			},
			{
				"name": "salute",
				"salience": 0.0001285436,
				"type": "OTHER"
			},
			{
				"name": "21-gun salute",
				"salience": 0.0001285436,
				"type": "EVENT"
			},
			{
				"name": "salute",
				"salience": 0.0001285436,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0001285436,
				"type": "OTHER"
			},
			{
				"name": "pieces",
				"salience": 0.00012787989,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03bxsfb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_fish"
				},
				"name": "Royal Fish",
				"salience": 0.00012688633,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0001258861,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.0001258861,
				"type": "ORGANIZATION"
			},
			{
				"name": "seats",
				"salience": 0.0001258861,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013zl5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_assent"
				},
				"name": "Royal Assent",
				"salience": 0.0001235852,
				"type": "PERSON"
			},
			{
				"name": "honour",
				"salience": 0.000121553465,
				"type": "OTHER"
			},
			{
				"name": "canary wine",
				"salience": 0.00012056002,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "poet laureate",
				"salience": 0.00012056002,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.00012056002,
				"type": "OTHER"
			},
			{
				"name": "throne",
				"salience": 0.00012056002,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.00012056002,
				"type": "LOCATION"
			},
			{
				"name": "Sheriff",
				"salience": 0.00012024035,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.00011912367,
				"type": "OTHER"
			},
			{
				"name": "General Election",
				"salience": 0.000117992815,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.000117992815,
				"type": "EVENT"
			},
			{
				"name": "Knighthoods",
				"salience": 0.000117992815,
				"type": "PERSON"
			},
			{
				"name": "knights",
				"salience": 0.000117992815,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.00011721847,
				"type": "EVENT"
			},
			{
				"name": "travel documents",
				"salience": 0.0001160585,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0001160585,
				"type": "LOCATION"
			},
			{
				"name": "birthday celebrations",
				"salience": 0.0001160585,
				"type": "EVENT"
			},
			{
				"name": "cash machine",
				"salience": 0.0001160585,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "road",
				"salience": 0.0001160585,
				"type": "LOCATION"
			},
			{
				"name": "estate roads",
				"salience": 0.0001160585,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j5g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wales"
				},
				"name": "Wales",
				"salience": 0.00011590952,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cw10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Queen_Victoria"
				},
				"name": "Victoria",
				"salience": 0.00011578908,
				"type": "PERSON"
			},
			{
				"name": "prosecutions",
				"salience": 0.000113587135,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0198g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Buckingham_Palace"
				},
				"name": "Buckingham Palace",
				"salience": 0.00011277281,
				"type": "LOCATION"
			},
			{
				"name": "status",
				"salience": 0.00011273755,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.00011264569,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00011249674,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0001109669,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.00011039393,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.00010934593,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.00010900247,
				"type": "EVENT"
			},
			{
				"name": "business",
				"salience": 0.00010900247,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.00010900247,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.00010900247,
				"type": "EVENT"
			},
			{
				"name": "commons",
				"salience": 0.00010900247,
				"type": "OTHER"
			},
			{
				"name": "king",
				"salience": 0.00010859679,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.00010583316,
				"type": "LOCATION"
			},
			{
				"name": "Women's Auxillary Territorial Service",
				"salience": 0.00010583316,
				"type": "ORGANIZATION"
			},
			{
				"name": "Maundy money",
				"salience": 0.00010493241,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.000104390594,
				"type": "PERSON"
			},
			{
				"name": "subjects",
				"salience": 0.000104390594,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.000104390594,
				"type": "ORGANIZATION"
			},
			{
				"name": "debate",
				"salience": 0.000104390594,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.000104390594,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.000104390594,
				"type": "OTHER"
			},
			{
				"name": "butt",
				"salience": 0.000104390594,
				"type": "OTHER"
			},
			{
				"name": "military strikes",
				"salience": 0.000104390594,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.000104390594,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.000104390594,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00010414755,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00010414755,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.00010414755,
				"type": "OTHER"
			},
			{
				"name": "barrel",
				"salience": 0.00010353739,
				"type": "OTHER"
			},
			{
				"name": "owner",
				"salience": 0.00010262618,
				"type": "PERSON"
			},
			{
				"name": "significance",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.00010049272,
				"type": "ORGANIZATION"
			},
			{
				"name": "appointee",
				"salience": 0.00010049272,
				"type": "PERSON"
			},
			{
				"name": "wartime",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "style",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "nervousness",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "basement",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "perk",
				"salience": 0.00010049272,
				"type": "OTHER"
			},
			{
				"name": "walkabout",
				"salience": 0.00010049272,
				"type": "EVENT"
			},
			{
				"name": "pasties",
				"salience": 0.000099841614,
				"type": "OTHER"
			},
			{
				"name": "snowball",
				"salience": 0.000099841614,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00009848385,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00009841504,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.00009841504,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.00009841504,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.00009841504,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00009841504,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.00009841504,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04q3vp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_of_Information_Act_2000"
				},
				"name": "Freedom Of Information",
				"salience": 0.00009562877,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.00009474025,
				"type": "OTHER"
			},
			{
				"name": "precedent",
				"salience": 0.00009474025,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.000093611474,
				"type": "OTHER"
			},
			{
				"name": "cash machine",
				"salience": 0.00009354607,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/01g_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balmoral_Castle"
				},
				"name": "Balmoral",
				"salience": 0.0000916386,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0chgsm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Windsor_Castle"
				},
				"name": "Windsor Castle",
				"salience": 0.00009136136,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.000091266425,
				"type": "OTHER"
			},
			{
				"name": "ministers",
				"salience": 0.000090118694,
				"type": "PERSON"
			},
			{
				"name": "proceedings",
				"salience": 0.000090116024,
				"type": "EVENT"
			},
			{
				"name": "Term Parliaments Act",
				"salience": 0.000089743946,
				"type": "WORK_OF_ART"
			},
			{
				"name": "spending bill",
				"salience": 0.000089738714,
				"type": "OTHER"
			},
			{
				"name": "exemption",
				"salience": 0.0000896507,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0000896507,
				"type": "OTHER"
			},
			{
				"name": "owner",
				"salience": 0.0000892605,
				"type": "PERSON"
			},
			{
				"name": "castle",
				"salience": 0.000088252855,
				"type": "ORGANIZATION"
			},
			{
				"name": "example",
				"salience": 0.00008813538,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.00008813538,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.00008813538,
				"type": "OTHER"
			},
			{
				"name": "prosecution",
				"salience": 0.00008813538,
				"type": "PERSON"
			},
			{
				"name": "well-wishers",
				"salience": 0.00008740486,
				"type": "OTHER"
			},
			{
				"name": "arts",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00008521527,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "nominees",
				"salience": 0.00008521527,
				"type": "PERSON"
			},
			{
				"name": "backing",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "rock",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "tales",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "valour",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.00008521527,
				"type": "ORGANIZATION"
			},
			{
				"name": "MP",
				"salience": 0.00008521527,
				"type": "PERSON"
			},
			{
				"name": "figures",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00008521527,
				"type": "LOCATION"
			},
			{
				"name": "meteorite",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "sword",
				"salience": 0.00008521527,
				"type": "OTHER"
			},
			{
				"name": "tender",
				"salience": 0.00008308053,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01spm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Church_of_England"
				},
				"name": "Church of England",
				"salience": 0.00008272284,
				"type": "ORGANIZATION"
			},
			{
				"name": "rose",
				"salience": 0.00008245909,
				"type": "OTHER"
			},
			{
				"name": "passport",
				"salience": 0.00008203329,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.00008203329,
				"type": "OTHER"
			},
			{
				"name": "side effect",
				"salience": 0.00008203329,
				"type": "OTHER"
			},
			{
				"name": "immunity",
				"salience": 0.00008203329,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservative_Party_(UK)"
				},
				"name": "Conservatives",
				"salience": 0.00008183197,
				"type": "PERSON"
			},
			{
				"name": "court",
				"salience": 0.00008141968,
				"type": "LOCATION"
			},
			{
				"name": "proceedings",
				"salience": 0.00008141968,
				"type": "OTHER"
			},
			{
				"name": "religions",
				"salience": 0.00008141968,
				"type": "OTHER"
			},
			{
				"name": "silver coin",
				"salience": 0.00008141968,
				"type": "OTHER"
			},
			{
				"name": "cathedral",
				"salience": 0.00008141968,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.00008141968,
				"type": "OTHER"
			},
			{
				"name": "coins",
				"salience": 0.00008141968,
				"type": "OTHER"
			},
			{
				"name": "coins",
				"salience": 0.00008141968,
				"type": "OTHER"
			},
			{
				"name": "Court",
				"salience": 0.00008141968,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.00008005678,
				"type": "OTHER"
			},
			{
				"name": "blast",
				"salience": 0.00007932455,
				"type": "OTHER"
			},
			{
				"name": "blast",
				"salience": 0.00007932455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0225b3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trooping_the_Colour"
				},
				"name": "Trooping the Colour",
				"salience": 0.00007910753,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dccs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_IV_of_Scotland"
				},
				"name": "James IV",
				"salience": 0.00007875583,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.00007832466,
				"type": "OTHER"
			},
			{
				"name": "driving skills",
				"salience": 0.000077974684,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.000077027136,
				"type": "ORGANIZATION"
			},
			{
				"name": "governor",
				"salience": 0.000077027136,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.000077027136,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.000077027136,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Catholic Church",
				"salience": 0.00007620854,
				"type": "ORGANIZATION"
			},
			{
				"name": "advice",
				"salience": 0.000075844306,
				"type": "OTHER"
			},
			{
				"name": "Military Actions Against Iraq Bill",
				"salience": 0.00007419395,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00007419395,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015p59",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_of_information_laws_by_country"
				},
				"name": "Freedom of Information act",
				"salience": 0.00007419395,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.00007404342,
				"type": "OTHER"
			},
			{
				"name": "sovereign",
				"salience": 0.00007404342,
				"type": "PERSON"
			},
			{
				"name": "prerogative powers",
				"salience": 0.00007404342,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00007404342,
				"type": "OTHER"
			},
			{
				"name": "colour.",
				"salience": 0.000073562456,
				"type": "OTHER"
			},
			{
				"name": "pensioners",
				"salience": 0.00007351106,
				"type": "PERSON"
			},
			{
				"name": "pensioners",
				"salience": 0.00007351106,
				"type": "PERSON"
			},
			{
				"name": "treason",
				"salience": 0.00007351106,
				"type": "OTHER"
			},
			{
				"name": "throne",
				"salience": 0.00007351106,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00007233106,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.00007233106,
				"type": "OTHER"
			},
			{
				"name": "tax",
				"salience": 0.00007233106,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00007233106,
				"type": "OTHER"
			},
			{
				"name": "consent",
				"salience": 0.00007233106,
				"type": "OTHER"
			},
			{
				"name": "Horseguards' Parade",
				"salience": 0.00007142347,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00007142347,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05x8my",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Windsor_Great_Park"
				},
				"name": "Windsor Great Park",
				"salience": 0.00007142347,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01d_0p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hyde_Park,_London"
				},
				"name": "Hyde Park",
				"salience": 0.00007142347,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservative_Party_(UK)"
				},
				"name": "Tories",
				"salience": 0.00007110433,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.0000699229,
				"type": "OTHER"
			},
			{
				"name": "maundy money",
				"salience": 0.0000699229,
				"type": "OTHER"
			},
			{
				"name": "worry",
				"salience": 0.00006868498,
				"type": "OTHER"
			},
			{
				"name": "ministers",
				"salience": 0.00006731388,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0xnc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles,_Prince_of_Wales"
				},
				"name": "Prince Charles",
				"salience": 0.00006598687,
				"type": "PERSON"
			},
			{
				"name": "tenant",
				"salience": 0.00006446375,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03mdt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/HBO"
				},
				"name": "HBO",
				"salience": 0.000064242464,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02n1rn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Duchy_of_Cornwall"
				},
				"name": "Duchy of Cornwall",
				"salience": 0.000064242464,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rob Stothard",
				"salience": 0.000064242464,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.000064242464,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016jq3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Business_intelligence"
				},
				"name": "BI",
				"salience": 0.000064242464,
				"type": "LOCATION"
			},
			{
				"name": "fishing",
				"salience": 0.000064183165,
				"type": "OTHER"
			},
			{
				"name": "owner",
				"salience": 0.000064183165,
				"type": "PERSON"
			},
			{
				"name": "Some",
				"salience": 0.000064183165,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.000064183165,
				"type": "OTHER"
			},
			{
				"name": "denominations",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "circulation",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "about-face",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "recipients",
				"salience": 0.000063651154,
				"type": "PERSON"
			},
			{
				"name": "theory",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "ceremony",
				"salience": 0.000063651154,
				"type": "EVENT"
			},
			{
				"name": "question",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "capacity",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "accordance",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "elderly",
				"salience": 0.000063651154,
				"type": "PERSON"
			},
			{
				"name": "delinquent",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "dies",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "grievance offence",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.000063651154,
				"type": "OTHER"
			},
			{
				"name": "glasses",
				"salience": 0.0000628488,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0759fc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Coutts"
				},
				"name": "Coutts",
				"salience": 0.00006184354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01c9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Labour_Party_(UK)"
				},
				"name": "Labour",
				"salience": 0.00006184354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01p48x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_Mint"
				},
				"name": "Royal Mint",
				"salience": 0.00006184354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07nqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tower_of_London"
				},
				"name": "Tower of London",
				"salience": 0.00006184354,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01dmcq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Mall,_London"
				},
				"name": "The Mall",
				"salience": 0.00006184354,
				"type": "LOCATION"
			},
			{
				"name": "head",
				"salience": 0.000060361042,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.000059680064,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.000059680064,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j_4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Easter"
				},
				"name": "Easter",
				"salience": 0.000059577145,
				"type": "EVENT"
			},
			{
				"name": "crisis",
				"salience": 0.000059292393,
				"type": "EVENT"
			},
			{
				"name": "process",
				"salience": 0.000059292393,
				"type": "OTHER"
			},
			{
				"name": "red rose",
				"salience": 0.000059292393,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.000059292393,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.000059292393,
				"type": "OTHER"
			},
			{
				"name": "rose",
				"salience": 0.000059292393,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.000058807753,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.000058299844,
				"type": "OTHER"
			},
			{
				"name": "head of state",
				"salience": 0.000056651334,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.000056651334,
				"type": "PERSON"
			},
			{
				"name": "head of state",
				"salience": 0.000056651334,
				"type": "PERSON"
			},
			{
				"name": "letters",
				"salience": 0.00005536099,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00005466313,
				"type": "OTHER"
			},
			{
				"name": "input",
				"salience": 0.000053974065,
				"type": "OTHER"
			},
			{
				"name": "anniversary",
				"salience": 0.000053532895,
				"type": "EVENT"
			},
			{
				"name": "flag",
				"salience": 0.000053532895,
				"type": "OTHER"
			},
			{
				"name": "anniversary",
				"salience": 0.000053532895,
				"type": "EVENT"
			},
			{
				"name": "flag",
				"salience": 0.000053532895,
				"type": "OTHER"
			},
			{
				"name": "port",
				"salience": 0.000053532895,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.000053532895,
				"type": "EVENT"
			},
			{
				"name": "list",
				"salience": 0.000053532895,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.000053532895,
				"type": "OTHER"
			},
			{
				"name": "reign",
				"salience": 0.000053532895,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07d3x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Terry_Pratchett"
				},
				"name": "Terry Pratchett",
				"salience": 0.000052441246,
				"type": "PERSON"
			},
			{
				"name": "Battle of Blenheim.The Duke of Wellington",
				"salience": 0.000050745013,
				"type": "ORGANIZATION"
			},
			{
				"name": "details",
				"salience": 0.00005065686,
				"type": "OTHER"
			},
			{
				"name": "Church Commission",
				"salience": 0.000050105336,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k05r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Court"
				},
				"name": "Courts",
				"salience": 0.000050105336,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02n5d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_Civil_War"
				},
				"name": "English Civil War",
				"salience": 0.000050105336,
				"type": "EVENT"
			},
			{
				"name": "first-aid truck",
				"salience": 0.000048150483,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "many",
				"salience": 0.000047940903,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.000047940903,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.000047940903,
				"type": "EVENT"
			},
			{
				"name": "role",
				"salience": 0.000047187867,
				"type": "OTHER"
			},
			{
				"name": "hunting horn",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "holdings",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "grandmother",
				"salience": 0.00004635242,
				"type": "PERSON"
			},
			{
				"name": "property",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "quit-rent",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "bugle.",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "armour",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "grazing",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"name": "stranger",
				"salience": 0.00004635242,
				"type": "PERSON"
			},
			{
				"name": "privileges",
				"salience": 0.00004635242,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0p5vf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Member_of_parliament"
				},
				"name": "MPs",
				"salience": 0.0000461933,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fyzk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marquess"
				},
				"name": "Marquis",
				"salience": 0.0000461933,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.000045238176,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.000044621494,
				"type": "OTHER"
			},
			{
				"name": "colonies",
				"salience": 0.000044287706,
				"type": "ORGANIZATION"
			},
			{
				"name": "majority",
				"salience": 0.000044287706,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.000044287706,
				"type": "OTHER"
			},
			{
				"name": "state religion",
				"salience": 0.000044287706,
				"type": "OTHER"
			},
			{
				"name": "black spider memos",
				"salience": 0.0000435036,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Sauchlemuir Castle",
				"salience": 0.00004214023,
				"type": "ORGANIZATION"
			},
			{
				"name": "Kidwelly Castle",
				"salience": 0.00004214023,
				"type": "LOCATION"
			},
			{
				"name": "Dunlambert Castle",
				"salience": 0.00004214023,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02w6zj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Crown_land"
				},
				"name": "Crown Lands",
				"salience": 0.00004214023,
				"type": "LOCATION"
			},
			{
				"name": "government shutdown",
				"salience": 0.000039985625,
				"type": "EVENT"
			},
			{
				"name": "precedent",
				"salience": 0.000039985625,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.000039985625,
				"type": "LOCATION"
			},
			{
				"name": "ability",
				"salience": 0.00003980695,
				"type": "OTHER"
			},
			{
				"name": "Hungerford",
				"salience": 0.0000396703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02vgdy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lord_of_the_manor"
				},
				"name": "Lord of the Manor",
				"salience": 0.000039497627,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bodyguard",
				"salience": 0.00003783737,
				"type": "OTHER"
			},
			{
				"name": "herrings",
				"salience": 0.00003783737,
				"type": "OTHER"
			},
			{
				"name": "eel pie.",
				"salience": 0.00003783737,
				"type": "OTHER"
			},
			{
				"name": "defender",
				"salience": 0.000036889425,
				"type": "OTHER"
			},
			{
				"name": "Sovereign.The Duke of Marlborough",
				"salience": 0.000036487785,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01dcm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Battle_of_Waterloo"
				},
				"name": "Battle of Waterloo",
				"salience": 0.000036487785,
				"type": "EVENT"
			},
			{
				"name": "above",
				"salience": 0.00003462217,
				"type": "OTHER"
			},
			{
				"name": "possibility",
				"salience": 0.00003462217,
				"type": "OTHER"
			},
			{
				"name": "replacement",
				"salience": 0.00003462217,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.00003462217,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.00003462217,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00003462217,
				"type": "OTHER"
			},
			{
				"name": "Bishops",
				"salience": 0.00003462217,
				"type": "PERSON"
			},
			{
				"name": "scratch",
				"salience": 0.00003462217,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.00003462217,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.000033754775,
				"type": "OTHER"
			},
			{
				"name": "The Duke of Atholl",
				"salience": 0.000032966378,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02zr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Forest"
				},
				"name": "Forest",
				"salience": 0.000032943346,
				"type": "LOCATION"
			},
			{
				"name": "Savernake Forest",
				"salience": 0.000032943346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0p98z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Yarmouth"
				},
				"name": "Great Yarmouth",
				"salience": 0.000030780444,
				"type": "LOCATION"
			},
			{
				"name": "shutdown",
				"salience": 0.000029866522,
				"type": "EVENT"
			},
			{
				"name": "Max Fisher",
				"salience": 0.000028762888,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0n_v0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fleur-de-lis"
				},
				"name": "Fleur de Lys",
				"salience": 0.000028524459,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01pl3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Year's_Eve"
				},
				"name": "New Year's Eve",
				"salience": 0.000028524459,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.000028524459,
				"type": "LOCATION"
			},
			{
				"name": "Fowlis",
				"salience": 0.000028524459,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05bcl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northern_Ireland"
				},
				"name": "Northern Ireland",
				"salience": 0.000028524459,
				"type": "LOCATION"
			},
			{
				"name": "The City of Gloucester",
				"salience": 0.000028524459,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/016q8l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flag_of_Ireland"
				},
				"name": "Tricolour",
				"salience": 0.000028524459,
				"type": "OTHER"
			},
			{
				"name": "Ailesbury",
				"salience": 0.000028524459,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01d3ch",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Commonwealth_realm"
				},
				"name": "Commonwealth Realms",
				"salience": 0.000027809825,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0162v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barbados"
				},
				"name": "Barbados",
				"salience": 0.000024606348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.000024606348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/035yg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grenada"
				},
				"name": "Grenada",
				"salience": 0.000024606348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0djqw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barbuda"
				},
				"name": "Barbuda",
				"salience": 0.000024606348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06s6l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saint_Vincent_and_the_Grenadines"
				},
				"name": "Saint Vincent and the Grenadines",
				"salience": 0.000024606348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01n8qg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Solomon_Islands"
				},
				"name": "Solomon Islands",
				"salience": 0.000024606348,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09gd5v1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Business_Insider"
				},
				"name": "Business Insider",
				"salience": 0.000022148195,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0c_6g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Archbishop"
				},
				"name": "Archbishops",
				"salience": 0.000021305716,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0160w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Bahamas"
				},
				"name": "Bahamas",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/069pbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antigua"
				},
				"name": "Antigua",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03_r3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jamaica"
				},
				"name": "Jamaica",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012nm4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whitehall"
				},
				"name": "Whitehall",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0164b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belize"
				},
				"name": "Belize",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06c62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rome"
				},
				"name": "Rome",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07fsv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tuvalu"
				},
				"name": "Tuvalu",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ctw_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Zealand"
				},
				"name": "New Zealand",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Papua_New_Guinea"
				},
				"name": "Papua New Guinea",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06ryl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saint_Kitts_and_Nevis"
				},
				"name": "Saint Kitts and Nevis",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06s0l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saint_Lucia"
				},
				"name": "Saint Lucia",
				"salience": 0.000021305716,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.000021305716,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://awdnews.com/images/14778275732701-bj74t1.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T14:19:34.955+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 40.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "awdnews.com",
		"spam_score": "0",
		"text": "Email \nQueen Elizabeth II is not like you and me. \nDid you know she is immune from prosecution? That she has her own personal poet, paid in Sherry wine? Or that she holds dominion over British swans and can fire the entire Australian government? \nIt's true that her role as the British head of state is largely ceremonial, and the Monarch no longer holds any serious power from day to day. The historic \"prerogative powers\" of the Sovereign have been devolved largely to government ministers. But this still means that when the British government declares war, or regulates the civil service, or signs a treaty, it is doing so only on her authority. \nAnd she still wields some of these prerogative powers herself — as well as numerous other unique powers, ranging from the surprising to the utterly bizarre. \nMost famously, she owns all swans in the River Thames. \nTechnically, all unmarked swans in open water belong to the Queen, though the Crown \"exercises her ownership\" only \"on certain stretches of the Thames and its surrounding tributaries,\" according to the official website of the Royal Family. \nToday this tradition is observed during the annual \"Swan Upping,\" in which swans in the River Thames are caught, ringed, and set free again as part of census of the swan population. \nIt's a highly ceremonial affair, taking place over five days. \"Swan uppers\" wear traditional uniforms and row upriver in six skiffs accompanied by the Queen's Swan Marker. \n\"The swans are also given a health check and ringed with individual identification numbers by The Queen's Swan Warden, a Professor of Ornithology at the University of Oxford's Department of Zoology,\" according to the Royal Family website. \n\"Rule, Britannia, Britannia rules the waves,\" goes a classic British song — and this rule extends beneath the waves, too. The sovereign has dominion over a variety of aquatic animals in British waters. \nThe Queen still technically owns all the sturgeons, whales, and dolphins in the waters around England and Wales, in a rule that dates back to a statute from 1324, during the reign of King Edward II, according to Time. \nAccording to the article: \"This statute is still valid today, and sturgeons, porpoises, whales, and dolphins are recognised as 'fishes royal': when they are captured within 3 miles (about 5 km) of UK shores or wash ashore, they may be claimed on behalf of the Crown. Generally, when brought into port, a sturgeon is sold in the usual way, and the purchaser, as a gesture of loyalty, requests the honour of its being accepted by Elizabeth.\" \nThe law is still observed: In 2004, a Welsh fisherman was investigated by the police after catching a 10-foot sturgeon, the BBC reported at the time. The Scottish government also issued guidance on the law in 2007, writing that \"the right to claim Royal Fish in Scotland allows the Scottish Government (on behalf of the Crown) to claim stranded whales which are too large to be drawn to land by a 'wain pulled by six oxen.'\" \nThe Queen can drive without a licence. \nDriving licenses are issued in the Queen's name, yet she is the only person in the United Kingdom who doesn't legally need a license to drive or a number plate on her cars, according to Time. \nDespite not being required to have a license, the Queen is comfortable behind the wheel, having learned to drive during World War II when she operated a first-aid truck for the Women's Auxillary Territorial Service. (As a result of the Queen's training, she can also change a spark plug, Time notes). \nQueen Elizabeth II isn't afraid to show off her driving skills, either. In 1998, she surprised King Abdullah of Saudi Arabia (then still a prince) by driving him around in her country seat of Balmoral. \nFormer British Ambassador Sherard Cowper-Coles recounted the meeting in the Sunday Times: \"As instructed, the crown prince climbed into the front seat of the front Land Rover, with his interpreter in the seat behind. To his surprise, the Queen climbed into the driving seat, turned the ignition and drove off. Women are not — yet — allowed to drive in Saudi Arabia, and Abdullah was not used to being driven by a woman, let alone a queen.\" \nCowper-Coles continued: \"His nervousness only increased as the Queen, an army driver in wartime, accelerated the Land Rover along the narrow Scottish estate roads, talking all the time. Through his interpreter, the crown prince implored the Queen to slow down and concentrate on the road ahead.\" \nUnlike other members of the Royal family, the Queen does not require a passport, as they are issued in her name. Despite this lack of travel documents, she has been abroad many times. \nShe has two birthdays. \nWhen you're the British head of state, one birthday just isn't enough. The Queen's official birthday is celebrated on a Saturday in June, though her actual birthday is on April 21. \n\"Official celebrations to mark a sovereign's birthday have often been held on a day other than the actual birthday, particularly when the actual birthday has not been in the summer,\" according to the Royal Mint. \nBoth birthdays are celebrated in suitable style, too. Her actual birthday \"is marked publicly by gun salutes in central London at midday,\" according to the official website of the British Monarchy. This includes \"a 41-gun salute in Hyde Park, a 21-gun salute in Windsor Great Park, and a 62-gun salute at the Tower of London. In 2006, Her Majesty celebrated her 80th Birthday in 2006 with a walkabout in the streets outside of Windsor Castle to meet well-wishers.\" \nFor her \"official\" birthday celebrations, meanwhile, she \"is joined by other members of the Royal Family at the spectacular Trooping the Colour parade, which moves between Buckingham Palace, The Mall, and Horseguards' Parade.\" \nShe has her own private cash machine. \nLess a \"power\" and more a perk of the job, a private cash machine for use by the royal family is installed in the basement of Buckingham Palace. It's provided by Coutts, one of Britain's most prestigious — and exclusive — banks. \nThe Queen has her own personal poet. \nThe poet laureate is an honorary position in British society appointed by the Monarch to a poet \"whose work is of national significance,\" according to the official website of the British Monarchy. When first the role was introduced, the appointee was paid £200 per year plus a butt of canary wine. Today the poet laureate is given a barrel of Sherry. \nCarol Ann Duffy will hold the position until 2019. \nShe has to sign laws. \nThe Queen's consent is necessary to turn any bill into an actual law. Once a proposed law has passed both houses of Parliament, it makes its way to the Palace for approval, which is called \"Royal Assent.\" The most recent British Monarch to refuse to provide Royal Assent was Queen Anne, back in 1708. \nRoyal Assent is different than \"Queen's consent,\" in which the Queen must consent to any law being debated in Parliament that affects the Monarchy's interests (such as reforming the prerogative or tax laws that might affect the Duchy of Cornwall, for example). Without consent, the bill cannot be debated in Parliament. \nQueen's consent is exercised only on the advice of ministers, but its existence provides the government with a tool for blocking debate on certain subjects if bills are tabled by backbench rebels or the opposition. \nIt has been exercised at least 39 times, according to documents released under the Freedom of Information act, including \"one instance [in which] the Queen completely vetoed the Military Actions Against Iraq Bill in 1999, a private member's bill that sought to transfer the power to authorise military strikes against Iraq from the monarch to parliament,\" The Guardian reported in 2013. \nShe can create Lords. \nThe Queen has the power to appoint Lords, who can then sit in Parliament, the upper house in Britain's legislative system. Like many other powers, this is exercised only \"on the advice of\" elected government ministers. \nShe doesn't have to pay tax (but she does anyway). \nThe Queen does not have to pay tax, but she has been voluntarily paying income tax and capital gains tax since 1992. \nThe Queen has the power to form governments. \nUnlike the Queen, Prime Minister David Cameron doesn't literally sit on a throne. Rob Stothard/Getty Images/HBO/BI \nThe Queen previously wielded the power to dissolve Parliament and call a general election, but the Fixed-Term Parliaments Act put an end to that in 2011. Now a two-thirds vote in the commons is required to dissolve Parliament before a five-year fixed-term is up. \nShe does still play a part after an election, however, when she calls on the MP most able to form a government to do so. \nThis caused some worry ahead of this year's General Election. It once looked as if the Conservatives might not have a majority (but would be the largest party) and would try to form a government. Meanwhile, it was feasible that Labour could form a majority, despite having fewer seats, by entering into a coalition with multiple other parties. \nIn this situation, the Queen would have been stuck between a rock and a hard place. Every year, she opens Parliament with the Queen's speech, which lays out the government's plans. But to give David Cameron's speech would arguably be to tacitly endorse his government — while staying away would send the opposite message. \nAt one point, The Times was told by sources that she planned to \"stay away\" if Cameron failed to secure enough MPs, but the Palace later had an about-face. \"Royal sources confirmed she would lead proceedings, even if there was a risk the speech would be overthrown the following week because the Tories had failed to muster enough backing from smaller parties,\" The Times subsequently reported. \nShe has knights.​ \nSure, they no longer ride around on horseback wooing maidens with their tales of valour, but Britain still retains knights. Like Lords, they are appointed by the Queen — and she knights them personally. \nKnighthoods are typically given to figures who have made a particular contribution to British society — whether in business, the arts, the military, or elsewhere. After Terry Pratchett was knighted, the legendary fantasy author forged himself a special sword using pieces of a meteorite. \nThe individuals knighted are decided by ministers, the BBC reports, \"who present her with a list of nominees each year for her approval.\" \nShe is exempt from Freedom Of Information requests. \nAll information about the royal family is exempt from Freedom of Information requests. The exemption was made after a legal battle between The Guardian and the government to have letters from Prince Charles sent to Whitehall ministers made public. The so-called black spider memos were recently released, but the change means the same can't happen in the future. \nShe can ignore or overrule ministerial advice in \"grave constitutional crisis.\" \nWhile the overwhelming majority of the Queen's prerogative powers are devolved to her ministers, there is one exception that allows her to wield power herself. Only \"in grave constitutional crisis,\" the Sovereign can \"act contrary to or without Ministerial advice.\" With no precedent in modern times, it's not clear what would actually constitute this, but the possibility remains. \nThe Queen holds the ability to fire the entire Australian government. \nAs the head of state in Australia, the Queen has certain powers over the government. In 1975, for example, the Queen's representative in the country at the time, Gov. Gen. Sir John Kerr, fired the prime minister in response to a government shutdown. \n\"[Kerr] appointed a replacement, who immediately passed the spending bill to fund the government, Max Fisher wrote in The Washington Post. \"Three hours later, Kerr dismissed the rest of Parliament. Then Australia held elections to restart from scratch. And they haven't had another shutdown since.\" \nIn addition to the UK and Australia, the Queen is also the head of state in Antigua and Barbuda, the Bahamas, Barbados, Belize, Canada, Grenada, Jamaica, New Zealand, Papua New Guinea, Saint Kitts and Nevis, Saint Lucia, Saint Vincent and the Grenadines, Solomon Islands, and Tuvalu. \nAll the above are Commonwealth Realms, or former British colonies. The British sovereign retains the position she holds in the United Kingdom, that of head of state. As in Britain, this is largely a ceremonial role from day to day. \nShe's the head of a religion. \nQueen Elizabeth II is the head of the Church of England, Britain's state religion first established after King Henry VIII split away from the Catholic Church in Rome in the 16th century. \nHer formal title is defender of the faith and supreme governor of the Church of England, and she also has the power to appoint Bishops and Archbishops. As with many of her other powers, however, this is exercised only on the advice of the prime minister, who himself takes advice from a Church Commission. \nAn interesting side effect of this is that the Sovereign must be a confirmed member of Church of England. Catholics and those of other religions may not ascend to the British throne. If Prince Charles converted to Islam, for example, he would be unable to become king after Queen Elizabeth II dies. \nShe gets to give away special money to the elderly. \nMaundy money is a special kind of silver coin the Queen gives away to pensioners every year at a UK cathedral every Easter in a special ceremony. The number of recipients corresponds with the Sovereign's age. This year, for example, she will be 89 when Easter rolls around, so she will give maundy money away to 89 pensioners. \nThe coins are technically legal tender, despite coming in unconventional 3-pence and 4-pence denominations. But given the coins' rare status, they tend not to enter general circulation. \nShe's also immune from prosecution. \nAll prosecutions are carried out in the name of the Sovereign, and she is both immune from prosecution and cannot be compelled to give evidence in court. \nIn theory, the Sovereign \"is incapable of thinking or doing wrong,\" legal scholar John Kirkhope told Business Insider. However, barrister Baroness Helena Kennedy QC told the BBC in 2002 that \"nowadays, that immunity is questionable.\" \n\"Although civil and criminal proceedings cannot be taken against the Sovereign as a person under UK law, the Queen is careful to ensure that all her activities in her personal capacity are carried out in strict accordance with the law,\" according to official site of the Monarchy. \nIf the monarch did commit a grievance offence, he or she would almost certainly be forced to abdicate. There is at least one precedent of the Courts' prosecuting the Sovereign. In the 17th Century, King Charles I was tried for treason following the English Civil War. He said \"no earthly power can justly call me (who am your King) in question as a delinquent.\" The Court disagreed and had him executed. \nThe Queen has the right to be consulted, to encourage, and to warn her ministers. \nAssuming no \"grave constitutional crisis,\" the Queen's input into the legislative process is supposed to be limited in real terms to the right \"to be consulted, to encourage, and to warn\" her ministers — advice delivered via meetings with the prime minister. \nThe Queen also has certain historic rights and privileges. John Kirkhope, a lawyer who successfully campaigned to have details of \"Queen's consent\" made public, provided Business Insider with a list of some of the stranger rights the Queen still holds. \nHungerford has to present a red rose to the Sovereign in exchange for its fishing and grazing rights.The Duke of Atholl must pay by way of a rose whenever the Sovereign calls. This most recently happened during the reign of Queen Victoria, so it's unclear whether the rose has to be any particular colour.If the Sovereign passes near Kidwelly Castle in Wales, the tenant has to provide a bodyguard in full armour. This is complicated slightly by the fact the castle is a ruin.The Marquis of Ailesbury owns Savernake Forest and is required to produce a blast on a hunting horn should the Sovereign pass through the Forest. This last happened in 1943.Similarly, the owner of Dunlambert Castle in Northern Ireland has to produce a blast on an ancient bugle.And lastly, many landowners must also pay a \"quit-rent\" — a kind of tax on their property paid to the Monarch. Some are pretty unusual. \nThe owner of Sauchlemuir Castle must set out three glasses of port on New Year's Eve for the grandmother of James IV of Scotland. (For reference, James IV served from 1474 to 1513.)The owner of Fowlis must deliver — when required — a snowball in mid-summer.The City of Gloucester pays for its holdings of Crown Lands by providing an enormous eel pie.Great Yarmouth must provide a hundred herrings baked in 24 pasties to the Sheriff, who then sends them to the Lord of the Manor — who then sends them to the Sovereign.The Duke of Marlborough has to present a small satin flag with a Fleur de Lys on August 13, the anniversary of the Battle of Blenheim.The Duke of Wellington has to present a French Tricolour flag before noon on June 19 — the anniversary of the Battle of Waterloo.",
		"thread_title": "Queen Elizabeth II owns every dolphin in Britain and doesn't need a driving licence and doesn't pay tax — here are the incredible powers you didn't know the monarchy has",
		"title": "Queen Elizabeth II owns every dolphin in Britain and doesn't need a driving licence and doesn't pay tax — here are the incredible powers you didn't know the monarchy has",
		"type": "conspiracy",
		"uuid": "d5196999e263839289d72d5f879b6288d5bfe7f3"
	},
	"-KhIjcKsazagoz9RWw13": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T00:12:35.588+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/QN58XKQRJIE/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T00:12:35.588+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "MORE MUSLIM ANIMAL ABUSE: Palestinians film themselves stoning a hyena to death using cement blocks and large stones",
		"title": "MORE MUSLIM ANIMAL ABUSE: Palestinians film themselves stoning a hyena to death using cement blocks and large stones",
		"type": "bs",
		"uuid": "44a34ec273d677af872755b03f57941332d90893"
	},
	"-KhIjcWWaElmD8qeGXOs": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T00:12:35.695+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "invaders",
				"salience": 0.12829833,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.10961648,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.07949133,
				"type": "LOCATION"
			},
			{
				"name": "Hey",
				"salience": 0.057837635,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.047783952,
				"type": "LOCATION"
			},
			{
				"name": "fire",
				"salience": 0.0448047,
				"type": "OTHER"
			},
			{
				"name": "child migrants",
				"salience": 0.034826543,
				"type": "PERSON"
			},
			{
				"name": "jungle camp",
				"salience": 0.030707195,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.030707195,
				"type": "EVENT"
			},
			{
				"name": "invaders",
				"salience": 0.028128823,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.02775845,
				"type": "PERSON"
			},
			{
				"name": "neighborhood",
				"salience": 0.02407203,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.02407203,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.023271238,
				"type": "OTHER"
			},
			{
				"name": "trucks",
				"salience": 0.023042057,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "authorities",
				"salience": 0.023032902,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.021469522,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.014870148,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01y3fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jungle"
				},
				"name": "Jungle",
				"salience": 0.013413475,
				"type": "WORK_OF_ART"
			},
			{
				"name": "end",
				"salience": 0.012970888,
				"type": "OTHER"
			},
			{
				"name": "Hamid",
				"salience": 0.007913988,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.007613881,
				"type": "ORGANIZATION"
			},
			{
				"name": "Fabienne Buccio",
				"salience": 0.0074652154,
				"type": "PERSON"
			},
			{
				"name": "hopes",
				"salience": 0.006992668,
				"type": "OTHER"
			},
			{
				"name": "plumes",
				"salience": 0.0069047655,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00645337,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.005999696,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.005883698,
				"type": "OTHER"
			},
			{
				"name": "tents",
				"salience": 0.005883698,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "shelters",
				"salience": 0.005883698,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.005096114,
				"type": "OTHER"
			},
			{
				"name": "inhabitants",
				"salience": 0.005096114,
				"type": "PERSON"
			},
			{
				"name": "shantytown",
				"salience": 0.005096114,
				"type": "LOCATION"
			},
			{
				"name": "blazes",
				"salience": 0.0049994616,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0049471115,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0045708185,
				"type": "LOCATION"
			},
			{
				"name": "riot police",
				"salience": 0.004127543,
				"type": "ORGANIZATION"
			},
			{
				"name": "tents",
				"salience": 0.0039736517,
				"type": "OTHER"
			},
			{
				"name": "passage",
				"salience": 0.0037604843,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.003574686,
				"type": "LOCATION"
			},
			{
				"name": "sea",
				"salience": 0.003574686,
				"type": "LOCATION"
			},
			{
				"name": "freeloaders",
				"salience": 0.003574686,
				"type": "PERSON"
			},
			{
				"name": "smoke",
				"salience": 0.003574686,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0034413782,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0034413782,
				"type": "EVENT"
			},
			{
				"name": "anarchists",
				"salience": 0.0034413782,
				"type": "PERSON"
			},
			{
				"name": "defiance",
				"salience": 0.0034413782,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0034191092,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0030186693,
				"type": "OTHER"
			},
			{
				"name": "tunnel",
				"salience": 0.0029187617,
				"type": "LOCATION"
			},
			{
				"name": "fences",
				"salience": 0.0029187617,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0029187617,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0029187617,
				"type": "OTHER"
			},
			{
				"name": "trains",
				"salience": 0.0029187617,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0027050674,
				"type": "ORGANIZATION"
			},
			{
				"name": "shelters",
				"salience": 0.002518244,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.002518244,
				"type": "OTHER"
			},
			{
				"name": "Mission",
				"salience": 0.0022085644,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.0022009893,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asia"
				},
				"name": "Asia",
				"salience": 0.0022009893,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0022009893,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0021807468,
				"type": "OTHER"
			},
			{
				"name": "scenes",
				"salience": 0.0021807468,
				"type": "WORK_OF_ART"
			},
			{
				"name": "worries",
				"salience": 0.0021807468,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_Channel"
				},
				"name": "Channel",
				"salience": 0.002075088,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.001588422,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_Channel"
				},
				"name": "Channel",
				"salience": 0.0015502603,
				"type": "ORGANIZATION"
			},
			{
				"name": "politicians",
				"salience": 0.001370352,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0013424209,
				"type": "LOCATION"
			},
			{
				"name": "referendum vote",
				"salience": 0.0012483607,
				"type": "EVENT"
			},
			{
				"name": "action",
				"salience": 0.0011866206,
				"type": "OTHER"
			},
			{
				"name": "slum",
				"salience": 0.0011866206,
				"type": "LOCATION"
			},
			{
				"name": "opposition",
				"salience": 0.0011866206,
				"type": "ORGANIZATION"
			},
			{
				"name": "criticism",
				"salience": 0.0011866206,
				"type": "OTHER"
			},
			{
				"name": "port traffic",
				"salience": 0.0011866206,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0011291052,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0011291052,
				"type": "LOCATION"
			},
			{
				"name": "reports",
				"salience": 0.00087524916,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.0007303423,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/ab5860e164e24fa69f563ad1e16591ba.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T00:12:35.695+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 26 2016 Coming soon, to a French neighborhood near you…7,000 MORE illegal alien Muslim invaders who set fire to their Calais jungle camp as the camp was being shut down Hey, where are all the women and children? Reuters French authorities said on Wednesday they had finished clearing the “Jungle”, a squalid shantytown outside Calais built by Muslim invaders who had hoped to make the passage to Britain but whose last inhabitants are now mostly dispersed around France. The operation passed off peacefully for the most part, though some migrants torched tents and shelters in a last act of defiance as their hopes of a new life in Britain evaporated. Some reports say that British anarchists set fire to the tents. “This is the end of the ‘Jungle’,” Calais regional prefect Fabienne Buccio said. “Mission accomplished.” Earlier in the day, riot police spread out around the camp, and fire trucks moved in to put out blazes that sent plumes of smoke into the sky. Muslim freeloaders from the Middle East, Asia and Africa congregated to Calais hoping to cross the short stretch of sea to Britain by leaping on trucks and trains, or even walking through the tunnel under the Channel. Britain refused to accept the vast majority of them – apart from a number of unaccompanied child migrants (who are actually adults in their 20’s and 30’s) now being processed separately – and high fences were built to keep them away from the port traffic, but still they came. Local opposition to the sprawling slum, along with growing criticism from right-wing politicians, finally stung the French government into action. The British referendum vote this year to quit the European Union was in large part driven by such worries, and stoked by scenes of the Calais migrants trying to force their way in. Hamid, 30, from Afghanistan, said he had been among those setting fire to shelters in the Jungle, and still hoped to cross the Channel to Britain. “We don’t care about problems that are to come after this. We did it because we don’t want to stay in France,” he said. “We want to go to England and England only. It doesn’t matter if I go to jail here.”",
		"thread_title": "Coming soon, to a French neighborhood near you…7,000 MORE illegal alien Muslim invaders who set fire to their Calais jungle camp as the camp was being shut down",
		"title": "Coming soon, to a French neighborhood near you…7,000 MORE illegal alien Muslim invaders who set fire to their Calais jungle camp as the camp was being shut down",
		"type": "bs",
		"uuid": "6c305cfab7813826fa495836bfb7a1978e0c500e"
	},
	"-KhIjchExnbdU6xUOrrJ": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T00:12:36.713+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "invader",
				"salience": 0.2178443,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.123075515,
				"type": "OTHER"
			},
			{
				"name": "statue",
				"salience": 0.07544291,
				"type": "OTHER"
			},
			{
				"name": "Karmel Church",
				"salience": 0.048634365,
				"type": "ORGANIZATION"
			},
			{
				"name": "church",
				"salience": 0.045596737,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.04365474,
				"type": "PERSON"
			},
			{
				"name": "statue",
				"salience": 0.03873242,
				"type": "OTHER"
			},
			{
				"name": "burst",
				"salience": 0.03794363,
				"type": "EVENT"
			},
			{
				"name": "couple",
				"salience": 0.037474986,
				"type": "PERSON"
			},
			{
				"name": "church wedding",
				"salience": 0.035837963,
				"type": "EVENT"
			},
			{
				"name": "Ludger A.",
				"salience": 0.033130288,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04n7gc6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mary_(mother_of_Jesus)"
				},
				"name": "Virgin Mary",
				"salience": 0.0296899,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "GERMANY",
				"salience": 0.020084124,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.016995206,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/017bdl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takbir"
				},
				"name": "Allahu Akbar",
				"salience": 0.016682148,
				"type": "WORK_OF_ART"
			},
			{
				"name": "man",
				"salience": 0.015696699,
				"type": "PERSON"
			},
			{
				"name": "wedding decorations",
				"salience": 0.011680735,
				"type": "OTHER"
			},
			{
				"name": "Marcel Lohbeck",
				"salience": 0.010061678,
				"type": "PERSON"
			},
			{
				"name": "Friederike",
				"salience": 0.010061678,
				"type": "PERSON"
			},
			{
				"name": "church",
				"salience": 0.009169891,
				"type": "LOCATION"
			},
			{
				"name": "fight",
				"salience": 0.0070041865,
				"type": "EVENT"
			},
			{
				"name": "church",
				"salience": 0.00685778,
				"type": "LOCATION"
			},
			{
				"name": "wedding",
				"salience": 0.006244685,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0ps1q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Duisburg"
				},
				"name": "Duisburg",
				"salience": 0.005327009,
				"type": "LOCATION"
			},
			{
				"name": "emergency",
				"salience": 0.0044711987,
				"type": "OTHER"
			},
			{
				"name": "back row",
				"salience": 0.0041970033,
				"type": "OTHER"
			},
			{
				"name": "ceremony",
				"salience": 0.0041970033,
				"type": "EVENT"
			},
			{
				"name": "beginning",
				"salience": 0.0041970033,
				"type": "OTHER"
			},
			{
				"name": "candles",
				"salience": 0.0041970033,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hat",
				"salience": 0.0041970033,
				"type": "OTHER"
			},
			{
				"name": "jumper",
				"salience": 0.0041970033,
				"type": "OTHER"
			},
			{
				"name": "Karmel Church",
				"salience": 0.00406859,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0040406073,
				"type": "LOCATION"
			},
			{
				"name": "guests",
				"salience": 0.0040406073,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0038360185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.003685258,
				"type": "ORGANIZATION"
			},
			{
				"name": "Duisburg UK",
				"salience": 0.003685258,
				"type": "LOCATION"
			},
			{
				"name": "flowers",
				"salience": 0.0034273865,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.0034273865,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0032749772,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0028734738,
				"type": "LOCATION"
			},
			{
				"name": "statue",
				"salience": 0.0025825622,
				"type": "OTHER"
			},
			{
				"name": "colleagues",
				"salience": 0.002561183,
				"type": "PERSON"
			},
			{
				"name": "face",
				"salience": 0.002561183,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.002561183,
				"type": "OTHER"
			},
			{
				"name": "Brenda K",
				"salience": 0.002488539,
				"type": "PERSON"
			},
			{
				"name": "h",
				"salience": 0.002488539,
				"type": "PERSON"
			},
			{
				"name": "Lochbeck",
				"salience": 0.0021647732,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.0021105977,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.0021105977,
				"type": "OTHER"
			},
			{
				"name": "examination",
				"salience": 0.0018657701,
				"type": "EVENT"
			},
			{
				"name": "hospital",
				"salience": 0.0018657701,
				"type": "LOCATION"
			},
			{
				"name": "groom",
				"salience": 0.0016097015,
				"type": "PERSON"
			},
			{
				"name": "officer",
				"salience": 0.0015507196,
				"type": "PERSON"
			},
			{
				"name": "church sexton",
				"salience": 0.0013939356,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0011485748,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/303D332200000578-0-image-a-39_1452981823556.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T00:12:36.713+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "GERMANY: Syrian Muslim invader shouting “Allahu Akbar” disrupts church wedding, gropes statue of Virgin Mary A newlywed couple claims their big day was ruined when a Muslim illegal alien burst inside the church shouting ‘Allahu Akbar’ and then started tearing down wedding decorations, laughing wildly, and fondling a statue of the Virgin Mary. ( Maybe he had a ‘sexual emergency?’ ) Karmel Church in Duisburg UK Daily Mail (h/t Brenda K) Groom Marcel Lohbeck, 35, and bride Friederike were celebrating their wedding with 90 guests in the Karmel Church in Duisburg, a city in western Germany . Lochbeck said: ‘At the beginning of the ceremony, a man with a thick jumper and a hat on came into the church and sat in the back row. ‘Shortly afterwards, he stood up and wandered around the candles. He laughed in a disturbing manner and then fondled the statue of Mary. ‘He had been speaking in Arabic and partly English. He then started destroying the flowers and kept shouting “Allahu Akbar”.’ Police officer Ludger A., 57, the uncle of the groom, reportedly tried to intervene along with the church sexton. The officer said: ‘We tried to calm the Syrian Muslim invader.’ After the man again refused to leave the church, there was a fight in which the police officer got slight injuries to his face. Yet he managed to restrain the man until his colleagues from the Duisburg police could arrive. After a medical examination, the 23-year-old Syrian was taken to a psychiatric hospital. Well, at least he didn’t destroy the statue and urinate on it as Muslims did HERE :",
		"thread_title": "GERMANY: Syrian Muslim invader shouting “Allahu Akbar” disrupts church wedding, gropes statue of Virgin Mary",
		"title": "GERMANY: Syrian Muslim invader shouting “Allahu Akbar” disrupts church wedding, gropes statue of Virgin Mary",
		"type": "bs",
		"uuid": "08b7fc1a5ee4c5d6eb53355baf9fe198a903bd85"
	},
	"-KhIjd-We7PPBCzTAVC4": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T01:29:34.996+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/sHCul_DIM_4/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T01:29:34.996+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "PAT CONDELL: America’s last chance…",
		"title": "PAT CONDELL: America’s last chance…",
		"type": "bs",
		"uuid": "2510c3503b1562450efa20230edb39f32707e304"
	},
	"-KhIjdBUNiQx_MBhvA7I": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T01:29:36.116+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/B9F1tXU43hk/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T01:29:36.116+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "GERMANY: About that “nice friendly Muslim family” next door….",
		"title": "GERMANY: About that “nice friendly Muslim family” next door….",
		"type": "bs",
		"uuid": "2aa307065b533c31cd2395e9fb23bbc0a6f438f9"
	},
	"-KhIjdNyv2vEpISuRq-E": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T05:17:28.859+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Wael Odeh",
				"salience": 0.54149,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.15190731,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rlgg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Temple_Terrace,_Florida"
				},
				"name": "Temple Terrace",
				"salience": 0.039690368,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.027378073,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "Council on American-Islamic Relations",
				"salience": 0.016223716,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.012640673,
				"type": "ORGANIZATION"
			},
			{
				"name": "reason",
				"salience": 0.012640673,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.010897611,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/074hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sharia"
				},
				"name": "Sharia Law",
				"salience": 0.0072508994,
				"type": "ORGANIZATION"
			},
			{
				"name": "Grant Rimbey",
				"salience": 0.0071627065,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.006764845,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.006764845,
				"type": "LOCATION"
			},
			{
				"name": "mailing",
				"salience": 0.0064825905,
				"type": "WORK_OF_ART"
			},
			{
				"name": "office",
				"salience": 0.0064825905,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0056166286,
				"type": "LOCATION"
			},
			{
				"name": "homes",
				"salience": 0.0056166286,
				"type": "LOCATION"
			},
			{
				"name": "reasons",
				"salience": 0.005431892,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "FLORIDA",
				"salience": 0.0044251652,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.0040980307,
				"type": "LOCATION"
			},
			{
				"name": "campaign mailers",
				"salience": 0.0040350906,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.0036116547,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "Mass",
				"salience": 0.003461827,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0n1rj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tampa,_Florida"
				},
				"name": "Tampa",
				"salience": 0.003461827,
				"type": "LOCATION"
			},
			{
				"name": "Laila Abdelaziz",
				"salience": 0.0028792217,
				"type": "PERSON"
			},
			{
				"name": "terrorism",
				"salience": 0.002768216,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0026748022,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.0026748022,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0026513042,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0025338389,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.0025338389,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.002439383,
				"type": "WORK_OF_ART"
			},
			{
				"name": "terrorism",
				"salience": 0.0023480523,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0023166158,
				"type": "LOCATION"
			},
			{
				"name": "addresses",
				"salience": 0.0023166158,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0022043327,
				"type": "WORK_OF_ART"
			},
			{
				"name": "group",
				"salience": 0.0021295636,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z59hb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tampa_City_Council"
				},
				"name": "City Council",
				"salience": 0.0021064125,
				"type": "ORGANIZATION"
			},
			{
				"name": "Florida City Council",
				"salience": 0.0021064125,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0021027587,
				"type": "EVENT"
			},
			{
				"name": "sharia",
				"salience": 0.0020777404,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0020777404,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0020383121,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0020002613,
				"type": "OTHER"
			},
			{
				"name": "foot",
				"salience": 0.0019401611,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0019000986,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.001876178,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021yby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Seat_of_local_government"
				},
				"name": "City Hall",
				"salience": 0.0018379678,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.0018062053,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0018062053,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.001719875,
				"type": "EVENT"
			},
			{
				"name": "Could Odeh's",
				"salience": 0.0017048097,
				"type": "PERSON"
			},
			{
				"name": "wife",
				"salience": 0.0016248071,
				"type": "PERSON"
			},
			{
				"name": "role",
				"salience": 0.0016248071,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.0016248071,
				"type": "PERSON"
			},
			{
				"name": "addition",
				"salience": 0.0016248071,
				"type": "OTHER"
			},
			{
				"name": "fundamentalists",
				"salience": 0.0016248071,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0016248071,
				"type": "OTHER"
			},
			{
				"name": "scholars",
				"salience": 0.0016248071,
				"type": "PERSON"
			},
			{
				"name": "door",
				"salience": 0.0015641984,
				"type": "OTHER"
			},
			{
				"name": "typewritten",
				"salience": 0.0015641984,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0015641984,
				"type": "OTHER"
			},
			{
				"name": "council",
				"salience": 0.0014637234,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinian",
				"salience": 0.0014265069,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03cbps",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillsborough_River_(Florida)"
				},
				"name": "Hillsborough River",
				"salience": 0.0014265069,
				"type": "LOCATION"
			},
			{
				"name": "candidates",
				"salience": 0.0013720213,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.0013266018,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0013266018,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ties",
				"salience": 0.0012610211,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.001126169,
				"type": "WORK_OF_ART"
			},
			{
				"name": "links",
				"salience": 0.0010694396,
				"type": "OTHER"
			},
			{
				"name": "CAIR Florida",
				"salience": 0.0010444792,
				"type": "ORGANIZATION"
			},
			{
				"name": "population",
				"salience": 0.0009911114,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.0009911114,
				"type": "EVENT"
			},
			{
				"name": "seats",
				"salience": 0.0009911114,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0009232812,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0008336439,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0008336439,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09rkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times"
				},
				"name": "Times",
				"salience": 0.000816653,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.00079652946,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/089xsp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rimbey"
				},
				"name": "Rimbey",
				"salience": 0.00078029465,
				"type": "LOCATION"
			},
			{
				"name": "positions",
				"salience": 0.0007218771,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0007218771,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0007218771,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0006949322,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0006359055,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00062276213,
				"type": "PERSON"
			},
			{
				"name": "block",
				"salience": 0.00062276213,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00053925696,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.00053925696,
				"type": "OTHER"
			},
			{
				"name": "neighbors",
				"salience": 0.00053925696,
				"type": "PERSON"
			},
			{
				"name": "community leaders",
				"salience": 0.00053925696,
				"type": "PERSON"
			},
			{
				"name": "Temple Terrace City Council",
				"salience": 0.00049026747,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobic",
				"salience": 0.00033189068,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.00030473928,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/sShariaLawInTexasSuchABadThing-vi.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T05:17:28.859+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 26 2016 When a Muslim in America runs for political office, the ONLY reason he is running is to spread Islam. Period. FLORIDA: Mass mailing sent to Temple Terrace homes in the Tampa area questions whether or not a Muslim candidate is fit for office and offers solid reasons why he probably is not. CAIR-Florida City Council candidate Wael Odeh has lived more than three decades in this town of 25,000 straddling the Hillsborough River. Odeh is also a Muslim, born in Palestinian territory, and some believes that’s enough to disqualify him from election to the City Council. An anonymous letter has been mailed to a number of addresses in Temple Terrace questioning whether City Hall is safe with a Muslim working there and whether Odeh has ties to terrorism. The typewritten, single-spaced, one-page letter is dated October 2016. Among a number of questions it poses: “Could Odeh’s election be a foot in the door of Sharia Law’s subtle influence in our community?” Sharia is the detailed system of religious law developed by Muslim scholars in the early centuries of Islam and still in force among fundamentalists. Among other questions raised in the letter are why Odeh has not revealed in campaign mailers where he was born. The letter also questions whether he forces his wife into a subservient role, as do some observers of sharia. In addition, the letter says that designated terrorist group CAIR (Council on American-Islamic Relations) endorses Odeh and claims the group has links to terrorism (It does) . In a statement to the Times, CAIR Florida’s government affairs director Laila Abdelaziz said, “This unfounded and slanderous attack on Mr. Odeh is concerning, and we hope Temple Terrace residents, community leaders and neighbors will reject its Islamophobic message.” Still, Temple Terrace City Council member Grant Rimbey said he worries the truth may not matter to a certain block of voters. “That is the sad reality,” Rimbey said. “I think there is racism in the city” and there are people “who want to keep Temple Terrace looking like it did in 1952 forever.” (What “race” is Islam?) Rimbey and Odeh estimate that 20 to 25 percent of Temple Terrace’s population is Muslim. (Now, that really IS disturbing – more Muslim block-busting) Six candidates have applied for two open seats on the council; the two candidates recording the most votes Nov. 8 will fill the positions. Odeh said he invites anyone with questions about Muslims to reach out to him — including the author of the anonymous letter. “If he wanted to learn more, he should have come to me directly.” (He learned everything he needed to know about Muslims on 9/11)",
		"thread_title": "When a Muslim in America runs for political office, the ONLY reason he is running is to spread Islam. Period.",
		"title": "When a Muslim in America runs for political office, the ONLY reason he is running is to spread Islam. Period.",
		"type": "bs",
		"uuid": "c81fbaadb1df3618134a0e6b77c1170c57b53b5a"
	},
	"-KhIjdUKX--vQ7KxdSKy": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T05:17:50.609+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.243652,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.23529229,
				"type": "OTHER"
			},
			{
				"name": "track",
				"salience": 0.17390187,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.063560285,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.03837128,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.035887662,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.027007168,
				"type": "OTHER"
			},
			{
				"name": "TrumpPence2016",
				"salience": 0.024573896,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.01732309,
				"type": "LOCATION"
			},
			{
				"name": "CrookedHillary",
				"salience": 0.016679931,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chicago"
				},
				"name": "Chicago",
				"salience": 0.016679931,
				"type": "LOCATION"
			},
			{
				"name": "Voters",
				"salience": 0.016664624,
				"type": "PERSON"
			},
			{
				"name": "@RSBNetwork",
				"salience": 0.015730241,
				"type": "OTHER"
			},
			{
				"name": "MAGA pic.twitter.com/8JRRR7Ai1l -- RSBN TV",
				"salience": 0.013630225,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0124655375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.01019299,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.01019299,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.01019299,
				"type": "LOCATION"
			},
			{
				"name": "TRUMP @Rasmussen_Poll",
				"salience": 0.007429799,
				"type": "OTHER"
			},
			{
				"name": "Gateway Pundit",
				"salience": 0.0055531156,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.005018102,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/172-800x254-1-800x254.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T05:17:50.609+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Donald Trump is on track to win more black votes than any time since 1960. In the past month, the number of black voters for Donald Trump has increased significantly. These black Trump supporters from Chicago don't want anything to do with #CrookedHillary #TrumpPence2016 #MAGA pic.twitter.com/8JRRR7Ai1l \n— RSBN TV (@RSBNetwork) July 29, 2016 Gateway Pundit If Democrats lose 25% of the black vote they would lose Virginia, Florida, Ohio and North Carolina. Black Likely Voters for TRUMP @Rasmussen_Poll Oct 3 – 9%",
		"thread_title": "BLACK VETERANS FOR TRUMP, too!",
		"title": "BLACK VETERANS FOR TRUMP, too!",
		"type": "bs",
		"uuid": "282d3271455e3139f4dd6c38d122084ad2d4fba7"
	},
	"-KhIjde-i39zCLi49EIH": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T05:18:01.387+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.52406365,
				"type": "PERSON"
			},
			{
				"name": "@ 9",
				"salience": 0.111188784,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.10362518,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "FaceBook",
				"salience": 0.06473455,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.045851804,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.015780114,
				"type": "PERSON"
			},
			{
				"name": "circles",
				"salience": 0.015194156,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0144464,
				"type": "LOCATION"
			},
			{
				"name": "Susan K",
				"salience": 0.013862201,
				"type": "PERSON"
			},
			{
				"name": "Democracy",
				"salience": 0.012415774,
				"type": "OTHER"
			},
			{
				"name": "Globalists",
				"salience": 0.0096434,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.0096434,
				"type": "EVENT"
			},
			{
				"name": "weapon",
				"salience": 0.009052686,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.008644698,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.008644698,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.008114974,
				"type": "OTHER"
			},
			{
				"name": "VOTE",
				"salience": 0.008114974,
				"type": "OTHER"
			},
			{
				"name": "gal",
				"salience": 0.00525381,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.00525381,
				"type": "EVENT"
			},
			{
				"name": "@ 8",
				"salience": 0.003235459,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Az",
				"salience": 0.003235459,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/F5FYHE8VQ58/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T05:18:01.387+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "October 26, 2016 @ 9:37 pm \nFaceBook has censored my posts on Donald Trump. Susan K October 26, 2016 @ 9:09 pm \nIt will not work. They can try and try and try again. Going around in circles. I must admit it is very pleasant to know how distressed some groups are because of Donald Trump. When Donald Trump is elected, and he will be, he should make it very clear he will not deal with any country persecuting freedom of speech. Az gal October 26, 2016 @ 8:32 pm \nThe Globalists are waging war on Donald Trump. Democracy is dead or dying. We are the soldiers for freedom. Our most important weapon is our vote! VOTE TRUMP!",
		"thread_title": "FACEBOOK Nazi Thought Police editors threaten to quit if Mark Zuckerberg doesn’t ban Donald Trump for hate speech",
		"title": "FACEBOOK Nazi Thought Police editors threaten to quit if Mark Zuckerberg doesn’t ban Donald Trump for hate speech",
		"type": "bs",
		"uuid": "147326b0eca9c38c998facb1a8e81aa676179205"
	},
	"-KhIjdu463tQTsCjaMAv": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T06:26:08.063+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "John Guandolo",
				"salience": 0.20140524,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "CAIR",
				"salience": 0.15119617,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.12245731,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.094791815,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.06482987,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.037285265,
				"type": "OTHER"
			},
			{
				"name": "agent",
				"salience": 0.037285265,
				"type": "PERSON"
			},
			{
				"name": "counter-terrorism expert",
				"salience": 0.037285265,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.02313275,
				"type": "ORGANIZATION"
			},
			{
				"name": "BNI",
				"salience": 0.02313275,
				"type": "ORGANIZATION"
			},
			{
				"name": "training law enforcement officers",
				"salience": 0.017916907,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.015534734,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.013943466,
				"type": "OTHER"
			},
			{
				"name": "Breaking the Silence",
				"salience": 0.013386175,
				"type": "WORK_OF_ART"
			},
			{
				"name": "speech",
				"salience": 0.013357588,
				"type": "OTHER"
			},
			{
				"name": "thugs",
				"salience": 0.013190456,
				"type": "PERSON"
			},
			{
				"name": "mosques",
				"salience": 0.012598328,
				"type": "OTHER"
			},
			{
				"name": "advance",
				"salience": 0.010513528,
				"type": "OTHER"
			},
			{
				"name": "training session",
				"salience": 0.010513528,
				"type": "EVENT"
			},
			{
				"name": "areas",
				"salience": 0.009807341,
				"type": "LOCATION"
			},
			{
				"name": "territory",
				"salience": 0.0073356484,
				"type": "LOCATION"
			},
			{
				"name": "convenience stores",
				"salience": 0.00645383,
				"type": "LOCATION"
			},
			{
				"name": "jobs",
				"salience": 0.0057340604,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.005590853,
				"type": "OTHER"
			},
			{
				"name": "insurgency",
				"salience": 0.005590853,
				"type": "EVENT"
			},
			{
				"name": "cab companies",
				"salience": 0.005590853,
				"type": "ORGANIZATION"
			},
			{
				"name": "hotels",
				"salience": 0.005590853,
				"type": "LOCATION"
			},
			{
				"name": "airports",
				"salience": 0.005590853,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.0052717286,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.005140034,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.003940546,
				"type": "LOCATION"
			},
			{
				"name": "All",
				"salience": 0.003940546,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado_Springs,_Colorado"
				},
				"name": "Colorado Springs",
				"salience": 0.0033162276,
				"type": "LOCATION"
			},
			{
				"name": "doctrine",
				"salience": 0.002486662,
				"type": "OTHER"
			},
			{
				"name": "harassment",
				"salience": 0.002486662,
				"type": "OTHER"
			},
			{
				"name": "Muslims",
				"salience": 0.002376038,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/061.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:26:08.063+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 26 2016 Always under fire from designated terrorist group CAIR, former FBI agent and counter-terrorism expert, John Guandolo, is the go-to person for training law enforcement officers about the growing threat Islam poses to America Every time Guandolo is scheduled to give a speech or a training session, CAIR thugs try to shut him down in advance. At the recent Breaking the Silence ” conference in Colorado Springs, Guandolo warned that Muslims in America are getting jobs at airports, hotels, convenience stores and cab companies as part of a growing “insurgency” and an “intentional plan” to “occupy the land.” “Why are they building huge, $100 million mosques in areas where there are like 100 or 90 Muslims?” he asked. “Because, when they build a mosque they’re claiming territory, now all they have to do is occupy it. So they’re calling Muslims to occupy the land. All of this, they have an intentional plan and it’s based in Islamic doctrine and they’re putting it to work through what they’re doing.” CAIR’s relentless harassment of John Guandolo:",
		"thread_title": "Always under fire from designated terrorist group CAIR, former FBI agent and counter-terrorism expert, John Guandolo, is the go-to person for training law enforcement officers about the growing threat Islam poses to America",
		"title": "Always under fire from designated terrorist group CAIR, former FBI agent and counter-terrorism expert, John Guandolo, is the go-to person for training law enforcement officers about the growing threat Islam poses to America",
		"type": "bs",
		"uuid": "8e2e4ff1bb05ec5bf13b48dac019aeacffe792ab"
	},
	"-KhIje2fh2Z7J23INDdh": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T10:54:02.372+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.21013777,
				"type": "OTHER"
			},
			{
				"name": "boys",
				"salience": 0.057372656,
				"type": "PERSON"
			},
			{
				"name": "swimming pool",
				"salience": 0.057372656,
				"type": "LOCATION"
			},
			{
				"name": "investigation",
				"salience": 0.05207473,
				"type": "EVENT"
			},
			{
				"name": "girls",
				"salience": 0.051956113,
				"type": "PERSON"
			},
			{
				"name": "sisters",
				"salience": 0.051421177,
				"type": "PERSON"
			},
			{
				"name": "Gang",
				"salience": 0.040782552,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.03315912,
				"type": "LOCATION"
			},
			{
				"name": "victims",
				"salience": 0.024298247,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.021904843,
				"type": "ORGANIZATION"
			},
			{
				"name": "Police",
				"salience": 0.021816684,
				"type": "ORGANIZATION"
			},
			{
				"name": "father",
				"salience": 0.021181231,
				"type": "PERSON"
			},
			{
				"name": "gang",
				"salience": 0.020994563,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.019153371,
				"type": "PERSON"
			},
			{
				"name": "schoolgirls",
				"salience": 0.018626448,
				"type": "PERSON"
			},
			{
				"name": "boys",
				"salience": 0.018501012,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "GERMANY",
				"salience": 0.017477924,
				"type": "LOCATION"
			},
			{
				"name": "police spokeswoman",
				"salience": 0.017189609,
				"type": "PERSON"
			},
			{
				"name": "schoolgirls",
				"salience": 0.012601732,
				"type": "PERSON"
			},
			{
				"name": "swimming pool",
				"salience": 0.012283855,
				"type": "LOCATION"
			},
			{
				"name": "boys",
				"salience": 0.011314354,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.011314354,
				"type": "PERSON"
			},
			{
				"name": "youngest",
				"salience": 0.010111977,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.008624402,
				"type": "PERSON"
			},
			{
				"name": "boys",
				"salience": 0.008624402,
				"type": "PERSON"
			},
			{
				"name": "pool",
				"salience": 0.008624402,
				"type": "LOCATION"
			},
			{
				"name": "swimming pool",
				"salience": 0.008303442,
				"type": "LOCATION"
			},
			{
				"name": "girl",
				"salience": 0.008303442,
				"type": "PERSON"
			},
			{
				"name": "asylum-seekers",
				"salience": 0.0075220256,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.007473435,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0070446655,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.005277999,
				"type": "PERSON"
			},
			{
				"name": "bottoms",
				"salience": 0.005277999,
				"type": "OTHER"
			},
			{
				"name": "breasts",
				"salience": 0.005277999,
				"type": "OTHER"
			},
			{
				"name": "swimming pool",
				"salience": 0.005265736,
				"type": "LOCATION"
			},
			{
				"name": "t",
				"salience": 0.00508131,
				"type": "OTHER"
			},
			{
				"name": "birthday",
				"salience": 0.00508131,
				"type": "EVENT"
			},
			{
				"name": "treat",
				"salience": 0.00508131,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "h",
				"salience": 0.00508131,
				"type": "OTHER"
			},
			{
				"name": "suspects",
				"salience": 0.004976457,
				"type": "PERSON"
			},
			{
				"name": "tattoos",
				"salience": 0.0047096056,
				"type": "OTHER"
			},
			{
				"name": "youths",
				"salience": 0.0043101124,
				"type": "PERSON"
			},
			{
				"name": "pool supervisor",
				"salience": 0.0043101124,
				"type": "PERSON"
			},
			{
				"name": "help",
				"salience": 0.0043101124,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.004118441,
				"type": "PERSON"
			},
			{
				"name": "UK Express",
				"salience": 0.0040317783,
				"type": "ORGANIZATION"
			},
			{
				"name": "swimming pool",
				"salience": 0.003836842,
				"type": "LOCATION"
			},
			{
				"name": "boys",
				"salience": 0.003836842,
				"type": "PERSON"
			},
			{
				"name": "boys",
				"salience": 0.003836842,
				"type": "PERSON"
			},
			{
				"name": "spokeswoman",
				"salience": 0.0035827986,
				"type": "PERSON"
			},
			{
				"name": "district",
				"salience": 0.0032207798,
				"type": "LOCATION"
			},
			{
				"name": "incident",
				"salience": 0.0032207798,
				"type": "EVENT"
			},
			{
				"name": "parents",
				"salience": 0.0032207798,
				"type": "PERSON"
			},
			{
				"name": "Terry D",
				"salience": 0.0031294248,
				"type": "PERSON"
			},
			{
				"name": "boys",
				"salience": 0.0028669792,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.0023462514,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sexual assault",
				"salience": 0.0023462514,
				"type": "OTHER"
			},
			{
				"name": "suspects",
				"salience": 0.0022977819,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0021295138,
				"type": "PERSON"
			},
			{
				"name": "Mariendorf",
				"salience": 0.002035367,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0156q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Berlin"
				},
				"name": "Berlin",
				"salience": 0.0019829844,
				"type": "LOCATION"
			},
			{
				"name": "spokeswoman",
				"salience": 0.0019500594,
				"type": "PERSON"
			},
			{
				"name": "offences",
				"salience": 0.0017528969,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0017528969,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.0008951403,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/XdSsJQ-fvOU/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T10:54:02.372+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 27 2016 GERMANY: Gang of Syrian Muslim boys banned from swimming pool after sexually molesting girls as young as nine How about banning ALL Muslims? Police have launched an investigation after a gang of young Syrian asylum-seekers sexually harassed three schoolgirls at their local swimming pool. The girls – sisters aged 9, 11 and 14 – were surrounded and molested by seven Muslims, the youngest of whom was just seven. UK Express (h/t Terry D) The father of the schoolgirls said he had dropped them off at the swimming pool as a treat for the older girl’s 14th birthday. He said as soon as they started swimming they were harassed by the Muslim boys who surrounded them in the pool. The man said: “Five of the boys touched the girls’ breasts and bottoms.” He said his 11 year-old daughter managed to get away from the youths and ran to the pool supervisor to ask for help. Guess these girls didn’t have the “Don’t rape me” tattoos Germany has been giving out A police spokeswoman said the suspects were being investigated for sexual offences. She said one of the boys was 14-years-old and the rest were children between the seven and eleven. The spokeswoman said: “The suspects are said to have swam after the girls and to then have grabbed them.” The boys were all interviewed by police before being handed over to their parents after the incident in the Mariendorf district of Berlin. A spokeswoman for the swimming pool said the boys had all been banned for one year. (That’s all?) According to local reports, many girls have been victims of sexual assault by Muslim boys at the same swimming pool in Mariendorf.",
		"thread_title": "GERMANY: Gang of Syrian Muslim boys banned from swimming pool after sexually molesting girls as young as nine",
		"title": "GERMANY: Gang of Syrian Muslim boys banned from swimming pool after sexually molesting girls as young as nine",
		"type": "bs",
		"uuid": "c5fc0ab8e1e16503b7da5242c0925c293502d41b"
	},
	"-KhIje768vwq351mOQf2": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T21:15:48.012+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/gBSRIqyZN_s/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T21:15:48.012+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "BULGARIA: Nearly l,000 Muslim freeloaders rebel over “bad food and delays in giving them status to enter Western Europe”",
		"title": "BULGARIA: Nearly l,000 Muslim freeloaders rebel over “bad food and delays in giving them status to enter Western Europe”",
		"type": "bs",
		"uuid": "72b8b2c72d50e2282a501a1c5ab70cc7e207e070"
	},
	"-KhIjeKaralxxRSxE7h7": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T21:15:48.531+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "children",
				"salience": 0.19873859,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.10990075,
				"type": "PERSON"
			},
			{
				"name": "British Dental Association",
				"salience": 0.03837525,
				"type": "ORGANIZATION"
			},
			{
				"name": "freeloaders",
				"salience": 0.030849164,
				"type": "PERSON"
			},
			{
				"name": "invaders",
				"salience": 0.026302464,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.02563494,
				"type": "OTHER"
			},
			{
				"name": "worker",
				"salience": 0.02436998,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0310ky",
					"wikipedia_url": "http://en.wikipedia.org/wiki/David_Davies_(Welsh_politician)"
				},
				"name": "David Davies",
				"salience": 0.02428742,
				"type": "PERSON"
			},
			{
				"name": "invaders",
				"salience": 0.022905905,
				"type": "PERSON"
			},
			{
				"name": "career",
				"salience": 0.02280442,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.02280442,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.02280442,
				"type": "LOCATION"
			},
			{
				"name": "court Industry insiders",
				"salience": 0.02280442,
				"type": "ORGANIZATION"
			},
			{
				"name": "fear",
				"salience": 0.02280442,
				"type": "OTHER"
			},
			{
				"name": "ages",
				"salience": 0.02280442,
				"type": "OTHER"
			},
			{
				"name": "tests",
				"salience": 0.018531684,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.015239974,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.014079423,
				"type": "ORGANIZATION"
			},
			{
				"name": "UK Child Protection Services",
				"salience": 0.014079423,
				"type": "ORGANIZATION"
			},
			{
				"name": "revelations",
				"salience": 0.013097258,
				"type": "OTHER"
			},
			{
				"name": "arrivals",
				"salience": 0.011690212,
				"type": "EVENT"
			},
			{
				"name": "migrant",
				"salience": 0.010815047,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.008637738,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.008583066,
				"type": "LOCATION"
			},
			{
				"name": "child protection officers",
				"salience": 0.008398991,
				"type": "PERSON"
			},
			{
				"name": "press child migrants",
				"salience": 0.008353379,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.008217591,
				"type": "PERSON"
			},
			{
				"name": "managers",
				"salience": 0.0076455562,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.00715008,
				"type": "PERSON"
			},
			{
				"name": "asylum seeker",
				"salience": 0.0066817957,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.006599827,
				"type": "LOCATION"
			},
			{
				"name": "age",
				"salience": 0.0058795945,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.0058670607,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0057659373,
				"type": "PERSON"
			},
			{
				"name": "worker",
				"salience": 0.0057286536,
				"type": "PERSON"
			},
			{
				"name": "asylum seeker",
				"salience": 0.005253391,
				"type": "OTHER"
			},
			{
				"name": "asylum seeker",
				"salience": 0.005253391,
				"type": "OTHER"
			},
			{
				"name": "adult",
				"salience": 0.0050315033,
				"type": "PERSON"
			},
			{
				"name": "assessment",
				"salience": 0.0048223343,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0048223343,
				"type": "WORK_OF_ART"
			},
			{
				"name": "issue",
				"salience": 0.0048223343,
				"type": "OTHER"
			},
			{
				"name": "fury",
				"salience": 0.0048223343,
				"type": "OTHER"
			},
			{
				"name": "h",
				"salience": 0.0048223343,
				"type": "OTHER"
			},
			{
				"name": "t",
				"salience": 0.0048223343,
				"type": "OTHER"
			},
			{
				"name": "asylum seeker",
				"salience": 0.004077885,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0039055743,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.0038225125,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.0037599248,
				"type": "OTHER"
			},
			{
				"name": "interpreter",
				"salience": 0.003603546,
				"type": "PERSON"
			},
			{
				"name": "worker",
				"salience": 0.003518466,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wpm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Conservative_Party_(UK)"
				},
				"name": "Conservative",
				"salience": 0.003429026,
				"type": "ORGANIZATION"
			},
			{
				"name": "UK Express",
				"salience": 0.003429026,
				"type": "ORGANIZATION"
			},
			{
				"name": "case",
				"salience": 0.003382338,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.003382338,
				"type": "OTHER"
			},
			{
				"name": "wits",
				"salience": 0.003382338,
				"type": "OTHER"
			},
			{
				"name": "complaints",
				"salience": 0.003318136,
				"type": "OTHER"
			},
			{
				"name": "specialist",
				"salience": 0.0032561775,
				"type": "PERSON"
			},
			{
				"name": "meeting",
				"salience": 0.0032561775,
				"type": "EVENT"
			},
			{
				"name": "statement",
				"salience": 0.0032561775,
				"type": "WORK_OF_ART"
			},
			{
				"name": "struggles",
				"salience": 0.0032561775,
				"type": "OTHER"
			},
			{
				"name": "professionals",
				"salience": 0.0032561775,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0031889263,
				"type": "OTHER"
			},
			{
				"name": "consensus",
				"salience": 0.0031889263,
				"type": "OTHER"
			},
			{
				"name": "Terry D",
				"salience": 0.0029695623,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.0028561458,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0027616008,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0027616008,
				"type": "LOCATION"
			},
			{
				"name": "workers",
				"salience": 0.002628889,
				"type": "PERSON"
			},
			{
				"name": "Aid workers",
				"salience": 0.0025630866,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01gx10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Home_Office"
				},
				"name": "Home Office",
				"salience": 0.0023149818,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06l22",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Real_Madrid_C.F."
				},
				"name": "REAL",
				"salience": 0.0023149818,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07p82qp"
				},
				"name": "Act",
				"salience": 0.0020823884,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.0020804675,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.002063234,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.002063234,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.002063234,
				"type": "OTHER"
			},
			{
				"name": "Express Online",
				"salience": 0.002004679,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0019862393,
				"type": "OTHER"
			},
			{
				"name": "STORIES",
				"salience": 0.001735439,
				"type": "WORK_OF_ART"
			},
			{
				"name": "asylum seeker",
				"salience": 0.0016581784,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0016083147,
				"type": "EVENT"
			},
			{
				"name": "child protection experts",
				"salience": 0.0015027749,
				"type": "PERSON"
			},
			{
				"name": "documents",
				"salience": 0.0015027749,
				"type": "OTHER"
			},
			{
				"name": "queue",
				"salience": 0.0015027749,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0015027749,
				"type": "OTHER"
			},
			{
				"name": "hassle",
				"salience": 0.0015027749,
				"type": "OTHER"
			},
			{
				"name": "phase",
				"salience": 0.0014466835,
				"type": "EVENT"
			},
			{
				"name": "cross",
				"salience": 0.0013926848,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0012964464,
				"type": "OTHER"
			},
			{
				"name": "decisions",
				"salience": 0.0012964464,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0012964464,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0012964464,
				"type": "LOCATION"
			},
			{
				"name": "manager",
				"salience": 0.0012014648,
				"type": "PERSON"
			},
			{
				"name": "solicitor",
				"salience": 0.0011226117,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0011226117,
				"type": "EVENT"
			},
			{
				"name": "opinion",
				"salience": 0.0011226117,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/migrants-725855.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T21:15:48.531+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 27 2016 UK Child Protection Services workers are ‘afraid’ to challenge the ages of Muslim invaders for fear of ending up in court Industry insiders reveal they often meet obviously adult-aged Muslim invaders posing as children who are permitted to stay in the country because challenging them can put their career at risk. The revelations came after the arrivals of Muslim “child” economic freeloaders from Calais – who apparently are much older than the teenage years they had claimed. UK Express (h/t Terry D) Britain was once again divided over the issue with Conservative MP David Davies suggesting they should be made to undergo dental tests to establish their age. His comments were met with fury by the British Dental Association (BDA) which said tests were “invasive” – a statement which was backed by the Home Office. But, speaking to Express Online a social worker who asked not to be named has revealed the REAL struggles faced by those in the industry. According to the specialist THREE professionals are assigned to the first meeting with a migrant who claims to be a child. And senior child protection officers are at their wits’ end. He said: “So a social worker is assigned the case. The social worker attends the assessment and because the asylum seeker is claiming to be under 17 (to come under the children’s Act) an appropriate adult is also in attendance and so is an interpreter. “Usually they enter the room and they see this asylum seeker is well over 17. It is that obvious. “After they have done the process three times all three social workers have to come to a consensus on the estimated age of the asylum seeker – so let’s says all three say this asylum seeker is well over 17 or 18 years old. You would think that would be the end of the process, but not so. “They tell their managers of their decisions and then the manager tells them ‘If that’s your decision then okay but the asylum seeker will now be assigned a solicitor to challenge your opinion and you are likely to be cross examined in court’. After this phase of the investigation is complete, if a social worker chooses to challenge the age, they are reportedly met with anger and abuse. Many, he claims, have received calls calling them “racist” and have had complaints made against them. Those put in this position have said they “cannot afford” to fight it. One said: “I just sign and say he’s under 17 years because it’s not worth the hassle.” Social workers and child protection experts have called the system “broken” in Britain. Aid workers in Calais recently admitted to the press child migrants ARE lying about their age to get to the front of the queue to Britain – and are shredding their real documents. RELATED STORIES:",
		"thread_title": "UK Child Protection Services workers are ‘afraid’ to challenge the ages of Muslim invaders for fear of ending up in court",
		"title": "UK Child Protection Services workers are ‘afraid’ to challenge the ages of Muslim invaders for fear of ending up in court",
		"type": "bs",
		"uuid": "020dd1a987c7d843b00ab63c9002fd3236baa76f"
	},
	"-KhIjeUKb-Js1SRSQGsq": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T21:15:49.524+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "father",
				"salience": 0.18758638,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.16171013,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "GERMANY",
				"salience": 0.07090538,
				"type": "LOCATION"
			},
			{
				"name": "handout",
				"salience": 0.043151915,
				"type": "WORK_OF_ART"
			},
			{
				"name": "school",
				"salience": 0.039151326,
				"type": "ORGANIZATION"
			},
			{
				"name": "primary school",
				"salience": 0.033449728,
				"type": "ORGANIZATION"
			},
			{
				"name": "primary school",
				"salience": 0.033449728,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.02974194,
				"type": "PERSON"
			},
			{
				"name": "pupil",
				"salience": 0.027509104,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.024872666,
				"type": "PERSON"
			},
			{
				"name": "prayer",
				"salience": 0.024872666,
				"type": "OTHER"
			},
			{
				"name": "Parents",
				"salience": 0.024872666,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02587z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Garmisch-Partenkirchen"
				},
				"name": "Garmisch-Partenkirchen",
				"salience": 0.02217008,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.02157513,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Islamic",
				"salience": 0.021170827,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.019957151,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allah"
				},
				"name": "Allah",
				"salience": 0.01923289,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017bdl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takbir"
				},
				"name": "Allahu Akbar",
				"salience": 0.013336432,
				"type": "WORK_OF_ART"
			},
			{
				"name": "BNI",
				"salience": 0.013336432,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01vq3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christmas"
				},
				"name": "Christmas",
				"salience": 0.011091022,
				"type": "EVENT"
			},
			{
				"name": "prayer",
				"salience": 0.010315394,
				"type": "OTHER"
			},
			{
				"name": "Gisela Herl",
				"salience": 0.007995159,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.006504401,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.005424739,
				"type": "OTHER"
			},
			{
				"name": "teachers",
				"salience": 0.004573671,
				"type": "PERSON"
			},
			{
				"name": "chants",
				"salience": 0.004573671,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.003979208,
				"type": "OTHER"
			},
			{
				"name": "handout",
				"salience": 0.0039495034,
				"type": "WORK_OF_ART"
			},
			{
				"name": "girl",
				"salience": 0.003704651,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.003704651,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.003625904,
				"type": "PERSON"
			},
			{
				"name": "praise",
				"salience": 0.0035959042,
				"type": "OTHER"
			},
			{
				"name": "pupils",
				"salience": 0.0033500833,
				"type": "PERSON"
			},
			{
				"name": "majesty",
				"salience": 0.003290872,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.003208564,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.003208564,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ethics",
				"salience": 0.003208564,
				"type": "OTHER"
			},
			{
				"name": "lesson",
				"salience": 0.003208564,
				"type": "OTHER"
			},
			{
				"name": "news service",
				"salience": 0.0030889388,
				"type": "OTHER"
			},
			{
				"name": "t",
				"salience": 0.0030889388,
				"type": "OTHER"
			},
			{
				"name": "h",
				"salience": 0.0030889388,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.00306373,
				"type": "EVENT"
			},
			{
				"name": "schools",
				"salience": 0.0030530517,
				"type": "ORGANIZATION"
			},
			{
				"name": "schools",
				"salience": 0.0030530517,
				"type": "ORGANIZATION"
			},
			{
				"name": "newspaper",
				"salience": 0.0030251695,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.002709602,
				"type": "PERSON"
			},
			{
				"name": "Migrants",
				"salience": 0.002709602,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.002709602,
				"type": "PERSON"
			},
			{
				"name": "rituals",
				"salience": 0.002619942,
				"type": "OTHER"
			},
			{
				"name": "cultures",
				"salience": 0.002619942,
				"type": "OTHER"
			},
			{
				"name": "nursery",
				"salience": 0.002619942,
				"type": "LOCATION"
			},
			{
				"name": "daycare centre",
				"salience": 0.0019948422,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/017v_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bavaria"
				},
				"name": "Bavarian",
				"salience": 0.001975755,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0019739333,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0019739333,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.001957587,
				"type": "LOCATION"
			},
			{
				"name": "kindergarten",
				"salience": 0.001957587,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.001957587,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.001957587,
				"type": "OTHER"
			},
			{
				"name": "UK Express",
				"salience": 0.0019020456,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austrian",
				"salience": 0.0019020456,
				"type": "LOCATION"
			},
			{
				"name": "Terry D",
				"salience": 0.0019020456,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0016969949,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027lpsk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hessische/Nieders%C3%A4chsische_Allgemeine"
				},
				"name": "HNA",
				"salience": 0.0016130984,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hessian Niedersächsische Allgemeine",
				"salience": 0.0016130984,
				"type": "WORK_OF_ART"
			},
			{
				"name": "asylum",
				"salience": 0.0014259358,
				"type": "OTHER"
			},
			{
				"name": "pupils",
				"salience": 0.0013624614,
				"type": "PERSON"
			},
			{
				"name": "celebrations",
				"salience": 0.0013214948,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0012051202,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0010652667,
				"type": "PERSON"
			},
			{
				"name": "Christmas tree",
				"salience": 0.0010652667,
				"type": "OTHER"
			},
			{
				"name": "stories",
				"salience": 0.0010043118,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0bkv0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kassel"
				},
				"name": "Kassel",
				"salience": 0.0009971142,
				"type": "LOCATION"
			},
			{
				"name": "Federal Office for Migration and Refugees",
				"salience": 0.0008777306,
				"type": "ORGANIZATION"
			},
			{
				"name": "Sara Nussbaum House",
				"salience": 0.0006556726,
				"type": "ORGANIZATION"
			},
			{
				"name": "spokesman",
				"salience": 0.0006253862,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/cIndoctrinationinPublicSchools-vi-e1477588629628.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T21:15:49.524+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 27 2016 GERMANY: Parents outraged after German primary school ‘forces’ children to chant “Allahu Akbar” and “there is no God but Allah” in Muslim prayer The father of the pupil at the girl’s primary school in German ski resort Garmisch-Partenkirchen discovered that his daughter had been forced to learn the Islamic prayer when he discovered a handout she had been given. He claimed she had been “forced” by teachers to memorize the Islamic chants and forwarded the handout to Austrian news service unsertirol24. UK Express (h/t Terry D) The handout read: “Oh Allah, how perfect you are and praise be to you. Blessed is your name, and exalted is your majesty. There is no God but you.” It had been given to the girl during a lesson in “ethics” at the Bavarian school. Headteacher Gisela Herl did not confirm the incident when questioned, but said the school would issue a written statement detailing its position in the coming week. The incident comes just weeks after parents complained to German newspaper Hessian Niedersächsische Allgemeine (HNA) that their children’s nursery was refusing to acknowledge “Christmas rituals” to accommodate the “diverse cultures” of other pupils. The Sara Nussbaum House daycare centre in Kassel refused to put up a Christmas tree, tell Christmas stories or celebrate Christmas in general because it said only a minority of pupils. A spokesman for Kassel explained: “There will be no Christmas celebrations, in the strictest sense. Because the majority of children at this kindergarten are not Christian the festival will not be celebrated in the way that it is at other schools.” Migrants now outnumber native children at many schools in Germany as the country has been inundated with Muslim migrants in recent years. More than one million migrants are estimated to have arrived in Germany during the last year alone. The Federal Office for Migration and Refugees estimates that another 200,000 Muslims will apply for asylum in 2017.",
		"thread_title": "GERMANY: Parents outraged after German primary school ‘forces’ children to chant “Allahu Akbar” and “there is no God but Allah” in Muslim prayer",
		"title": "GERMANY: Parents outraged after German primary school ‘forces’ children to chant “Allahu Akbar” and “there is no God but Allah” in Muslim prayer",
		"type": "bs",
		"uuid": "df46a41a611c42d7c068ac02e0b330bf29029983"
	},
	"-KhIjeg-kZGBLXWso8JK": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T21:15:50.979+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.4749228,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.05739282,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.052698996,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.03134246,
				"type": "PERSON"
			},
			{
				"name": "@ 11",
				"salience": 0.02959089,
				"type": "OTHER"
			},
			{
				"name": "same",
				"salience": 0.027166376,
				"type": "OTHER"
			},
			{
				"name": "idiot",
				"salience": 0.017137105,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.015077174,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.011221838,
				"type": "OTHER"
			},
			{
				"name": "mountain",
				"salience": 0.011221838,
				"type": "LOCATION"
			},
			{
				"name": "right",
				"salience": 0.010488158,
				"type": "OTHER"
			},
			{
				"name": "ridicule",
				"salience": 0.010334207,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.010257092,
				"type": "PERSON"
			},
			{
				"name": "mentality",
				"salience": 0.0099322945,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.009763664,
				"type": "LOCATION"
			},
			{
				"name": "refugee",
				"salience": 0.009090157,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.008751417,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.008694828,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.00787316,
				"type": "OTHER"
			},
			{
				"name": "gays",
				"salience": 0.00787316,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.00787316,
				"type": "PERSON"
			},
			{
				"name": "penny",
				"salience": 0.00787316,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.0075796843,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0075796843,
				"type": "OTHER"
			},
			{
				"name": "male",
				"salience": 0.0075796843,
				"type": "PERSON"
			},
			{
				"name": "company line",
				"salience": 0.007484306,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.007423238,
				"type": "OTHER"
			},
			{
				"name": "mentality",
				"salience": 0.007423238,
				"type": "OTHER"
			},
			{
				"name": "refugee",
				"salience": 0.007423238,
				"type": "PERSON"
			},
			{
				"name": "upside",
				"salience": 0.007146504,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.006793479,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.006678051,
				"type": "OTHER"
			},
			{
				"name": "Right",
				"salience": 0.006649029,
				"type": "OTHER"
			},
			{
				"name": "Right",
				"salience": 0.006649029,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.006429053,
				"type": "OTHER"
			},
			{
				"name": "AndyT",
				"salience": 0.0053897994,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gay support",
				"salience": 0.0052494816,
				"type": "OTHER"
			},
			{
				"name": "upside",
				"salience": 0.005206625,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.004848495,
				"type": "LOCATION"
			},
			{
				"name": "BareNakedIslam",
				"salience": 0.004848495,
				"type": "OTHER"
			},
			{
				"name": "@ 12",
				"salience": 0.004848495,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0048039164,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0048039164,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z8cms"
				},
				"name": "Andy",
				"salience": 0.004571226,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.0040409626,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.003368792,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h0jl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian_right"
				},
				"name": "Christian Right",
				"salience": 0.0029822155,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.0026143182,
				"type": "LOCATION"
			},
			{
				"name": "irony",
				"salience": 0.0026143182,
				"type": "OTHER"
			},
			{
				"name": "circles",
				"salience": 0.0026143182,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d63kt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gay"
				},
				"name": "Gay",
				"salience": 0.0024876213,
				"type": "OTHER"
			},
			{
				"name": "Paleologos",
				"salience": 0.0020736996,
				"type": "PERSON"
			},
			{
				"name": "LGBTQWERTY",
				"salience": 0.0016091588,
				"type": "OTHER"
			},
			{
				"name": "@ 10",
				"salience": 0.0016091588,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/kbiZUMirPAQ/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T14:28:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "October 27, 2016 @ 11:59 am \nI’m voting for him – but will be very quiet about it. \nI believe there Are many out there who are doing the same. Islam is not gay-friendly. It’s the leftist idiot who would believe that it is despite a mountain of evidence showing the truth about Islam. \nHowever – too many follow the company line. It is getting very demanding these days, and frankly very strange. But doesn’t the left always do that? Whatever problem there is within the right – at least there is enough room, and more than the case now with the left. Well – at least for this ‘cis’ white male. AndyT October 27, 2016 @ 11:39 am \nAs a gay man I despair of my fellow gays. Here in the UK most have this “poor refugee” mentality. By time the penny finally drops it will be too late BareNakedIslam October 27, 2016 @ 12:34 pm \nAndy, while the majority still have that “poor refugee” mentality, I have seen a number of gay people commenting here and/or emailing me who know the truth. They’re just afraid of the ridicule they will get by talking about it in within their liberal circles. Manual Paleologos October 27, 2016 @ 10:56 am \nThe irony is that the LGBTQWERTY community is almost uniformly liberal. They support the people who are stoning them, throwing them from buildings, and hanging them. They have ceded any influence with the political Right, as no matter what the Right does, they will not get any meaningful Gay support. That means that just or unjust, there is absolutely no upside to supporting Gay issues. There is a small upside from the Christian Right, to pissing on them. \nMeanwhile, although we disagree on some major issues, we are probably their best friends. We are the people who would die to protect them.",
		"thread_title": "GAY TRUMP SUPPORTERS getting death threats from gay people who support a candidate who receives multi-million dollar contributions from countries that execute gays",
		"title": "GAY TRUMP SUPPORTERS getting death threats from gay people who support a candidate who receives multi-million dollar contributions from countries that execute gays",
		"type": "bs",
		"uuid": "a14c7651e36d86ffcbb7870cf1eb8576ffc9fe79"
	},
	"-KhIjelEyrHk4Q4b8xT4": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-27T21:26:28.739+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/W6TLeg6_d9M/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T21:26:28.739+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "CONTROVERSIAL BRITISH COMMENTATOR Katie Hopkins upsets CNN host by calling her out for her network’s blatantly biased promotion of Hillary Clinton",
		"title": "CONTROVERSIAL BRITISH COMMENTATOR Katie Hopkins upsets CNN host by calling her out for her network’s blatantly biased promotion of Hillary Clinton",
		"type": "bs",
		"uuid": "af526b0f9c668a1ab77dc745175d19252b46565e"
	},
	"-KhIjerdIj1crQgSahy_": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:27:10.753+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0tkjd7n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Britain_First"
				},
				"name": "Jayda Fransen",
				"salience": 0.46694788,
				"type": "PERSON"
			},
			{
				"name": "GIRL",
				"salience": 0.11778931,
				"type": "PERSON"
			},
			{
				"name": "throats",
				"salience": 0.09960211,
				"type": "OTHER"
			},
			{
				"name": "butcher shop",
				"salience": 0.06863422,
				"type": "LOCATION"
			},
			{
				"name": "hell",
				"salience": 0.062600784,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.038854327,
				"type": "OTHER"
			},
			{
				"name": "butchers",
				"salience": 0.030987278,
				"type": "OTHER"
			},
			{
				"name": "customers",
				"salience": 0.020269578,
				"type": "PERSON"
			},
			{
				"name": "agony",
				"salience": 0.01891875,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.015468841,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.011575656,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.011287199,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.009546151,
				"type": "OTHER"
			},
			{
				"name": "slaughter house",
				"salience": 0.008442164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.006451618,
				"type": "PERSON"
			},
			{
				"name": "tax",
				"salience": 0.0063120667,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0063120667,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/HiGovX6I_Vs/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:27:10.753+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "YOU GO GIRL! Jayda Fransen of Britain First raises hell at a halal butcher shop She screams at the butchers for barbarically slaughtering fully conscious animals by cutting their throats so they bleed out dying in agony and tells the customers they are supporting Islamic terrorism by paying a special halal tax on everything they buy there. Even worse, a lot of the people working in the halal slaughter house don’t appear to be Muslims.",
		"thread_title": "YOU GO GIRL! Jayda Fransen of Britain First raises hell at a halal butcher shop",
		"title": "YOU GO GIRL! Jayda Fransen of Britain First raises hell at a halal butcher shop",
		"type": "bs",
		"uuid": "42978c20ee2b99ed86ccf25dd018ce01e9d44afb"
	},
	"-KhIjf0Jzwz7xhlHm0NJ": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T06:27:11.883+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/Wd8O6K3L16Y/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T06:27:11.883+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "TEXAS: ASK FOR A PAPER BALLOT at polling stations where George Soros electronic voting machines are rigged to switch Trump votes to Hillary",
		"title": "TEXAS: ASK FOR A PAPER BALLOT at polling stations where George Soros electronic voting machines are rigged to switch Trump votes to Hillary",
		"type": "bs",
		"uuid": "f139aa775e140fa4c60ff4eb0a855301ebf555d5"
	},
	"-KhIjfSYdkXSSC9m9UaH": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T12:59:30.440+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.28522152,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vrmb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dearborn,_Michigan"
				},
				"name": "Dearborn",
				"salience": 0.08227368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01mw2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kafir"
				},
				"name": "non-Muslims",
				"salience": 0.080554835,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k48py",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dennis_Michael_Lynch"
				},
				"name": "Dennis Michael Lynch",
				"salience": 0.032951396,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.030768698,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.026523443,
				"type": "OTHER"
			},
			{
				"name": "HILLARY'S",
				"salience": 0.02060954,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.015582067,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.010248559,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "AMERICA",
				"salience": 0.008803873,
				"type": "LOCATION"
			},
			{
				"name": "council",
				"salience": 0.008651316,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0520jw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elizabeth_Hendrickson"
				},
				"name": "Liz",
				"salience": 0.007994907,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.007853748,
				"type": "PERSON"
			},
			{
				"name": "growth",
				"salience": 0.0077313557,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle Eastern",
				"salience": 0.007694218,
				"type": "LOCATION"
			},
			{
				"name": "Michiganistan",
				"salience": 0.0075021195,
				"type": "ORGANIZATION"
			},
			{
				"name": "NO-GO ZONES",
				"salience": 0.007242317,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vrr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamtramck,_Michigan"
				},
				"name": "Hamtramck",
				"salience": 0.0072315377,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0067523704,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025smhq"
				},
				"name": "Brian",
				"salience": 0.006348503,
				"type": "PERSON"
			},
			{
				"name": "security implications",
				"salience": 0.0062732953,
				"type": "OTHER"
			},
			{
				"name": "jihadists",
				"salience": 0.0062732953,
				"type": "PERSON"
			},
			{
				"name": "rest",
				"salience": 0.0062732953,
				"type": "OTHER"
			},
			{
				"name": "invaders",
				"salience": 0.0056229904,
				"type": "PERSON"
			},
			{
				"name": "Parts",
				"salience": 0.0053215264,
				"type": "OTHER"
			},
			{
				"name": "Muslims",
				"salience": 0.005242373,
				"type": "PERSON"
			},
			{
				"name": "segments",
				"salience": 0.0050921137,
				"type": "OTHER"
			},
			{
				"name": "universities",
				"salience": 0.0050921137,
				"type": "ORGANIZATION"
			},
			{
				"name": "area",
				"salience": 0.0050000018,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.0046475185,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.004598557,
				"type": "LOCATION"
			},
			{
				"name": "immigrants",
				"salience": 0.004437723,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/1q629d176",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cedar-Riverside,_Minneapolis"
				},
				"name": "Cedar Riverside",
				"salience": 0.004357548,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0425dz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WorldNetDaily"
				},
				"name": "WND",
				"salience": 0.004225919,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0041774856,
				"type": "LOCATION"
			},
			{
				"name": "streets",
				"salience": 0.0041000987,
				"type": "LOCATION"
			},
			{
				"name": "call",
				"salience": 0.0041000987,
				"type": "OTHER"
			},
			{
				"name": "Calls",
				"salience": 0.0041000987,
				"type": "OTHER"
			},
			{
				"name": "Prayer",
				"salience": 0.0041000987,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.003747398,
				"type": "LOCATION"
			},
			{
				"name": "times",
				"salience": 0.0037023914,
				"type": "EVENT"
			},
			{
				"name": "enclave",
				"salience": 0.0037023914,
				"type": "LOCATION"
			},
			{
				"name": "invasion",
				"salience": 0.0037023914,
				"type": "EVENT"
			},
			{
				"name": "Catholic",
				"salience": 0.0037023914,
				"type": "PERSON"
			},
			{
				"name": "majority",
				"salience": 0.0035780377,
				"type": "OTHER"
			},
			{
				"name": "corner",
				"salience": 0.0032063923,
				"type": "OTHER"
			},
			{
				"name": "property values tank",
				"salience": 0.0032063923,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.0032063923,
				"type": "OTHER"
			},
			{
				"name": "prayer echoes",
				"salience": 0.0032063923,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0032063923,
				"type": "OTHER"
			},
			{
				"name": "waves",
				"salience": 0.0032063923,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0032063923,
				"type": "OTHER"
			},
			{
				"name": "squabbles",
				"salience": 0.0028422938,
				"type": "OTHER"
			},
			{
				"name": "resident",
				"salience": 0.0026936417,
				"type": "PERSON"
			},
			{
				"name": "city council",
				"salience": 0.0025657497,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0025657497,
				"type": "LOCATION"
			},
			{
				"name": "Women",
				"salience": 0.002452251,
				"type": "PERSON"
			},
			{
				"name": "Residents",
				"salience": 0.00240327,
				"type": "PERSON"
			},
			{
				"name": "park",
				"salience": 0.002301666,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.0022058939,
				"type": "ORGANIZATION"
			},
			{
				"name": "tenants",
				"salience": 0.0020704241,
				"type": "PERSON"
			},
			{
				"name": "enclaves",
				"salience": 0.002040861,
				"type": "OTHER"
			},
			{
				"name": "HillaryDaily T",
				"salience": 0.0020206915,
				"type": "OTHER"
			},
			{
				"name": "culture shift",
				"salience": 0.0020151534,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.0019740898,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Polish",
				"salience": 0.0019740898,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.0019740898,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0162b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bangladesh"
				},
				"name": "Bangladesh",
				"salience": 0.0019740898,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0166b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bosnia_and_Herzegovina"
				},
				"name": "Bosnia",
				"salience": 0.0019740898,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.0019500188,
				"type": "PERSON"
			},
			{
				"name": "city government",
				"salience": 0.0018278166,
				"type": "ORGANIZATION"
			},
			{
				"name": "city",
				"salience": 0.0017991781,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0017320344,
				"type": "LOCATION"
			},
			{
				"name": "city council",
				"salience": 0.0017208183,
				"type": "ORGANIZATION"
			},
			{
				"name": "Muslims",
				"salience": 0.0016973787,
				"type": "PERSON"
			},
			{
				"name": "call",
				"salience": 0.0016886187,
				"type": "OTHER"
			},
			{
				"name": "prayer",
				"salience": 0.0016886187,
				"type": "OTHER"
			},
			{
				"name": "refugee resettlement program",
				"salience": 0.0016272363,
				"type": "OTHER"
			},
			{
				"name": "burqas",
				"salience": 0.0015936098,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "areas",
				"salience": 0.0015782632,
				"type": "LOCATION"
			},
			{
				"name": "leaders",
				"salience": 0.0015246784,
				"type": "PERSON"
			},
			{
				"name": "NO-GO Zones",
				"salience": 0.0015246784,
				"type": "OTHER"
			},
			{
				"name": "counties",
				"salience": 0.0014688418,
				"type": "LOCATION"
			},
			{
				"name": "documentaries",
				"salience": 0.0014687983,
				"type": "WORK_OF_ART"
			},
			{
				"name": "refugees",
				"salience": 0.0014578168,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.0014442229,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0014442229,
				"type": "LOCATION"
			},
			{
				"name": "City Council",
				"salience": 0.0014409425,
				"type": "ORGANIZATION"
			},
			{
				"name": "towns",
				"salience": 0.0013903183,
				"type": "LOCATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.0013202645,
				"type": "LOCATION"
			},
			{
				"name": "mayor",
				"salience": 0.0013202645,
				"type": "PERSON"
			},
			{
				"name": "Places",
				"salience": 0.0013202645,
				"type": "LOCATION"
			},
			{
				"name": "loudspeakers",
				"salience": 0.0013202645,
				"type": "OTHER"
			},
			{
				"name": "bill",
				"salience": 0.0013202645,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resident",
				"salience": 0.001316272,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.001316272,
				"type": "OTHER"
			},
			{
				"name": "residents",
				"salience": 0.001316272,
				"type": "PERSON"
			},
			{
				"name": "culture shift",
				"salience": 0.0013094778,
				"type": "EVENT"
			},
			{
				"name": "properties",
				"salience": 0.0012766864,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0012362723,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0011839821,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.0011839821,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.0011790266,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.0011790266,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.0011790266,
				"type": "LOCATION"
			},
			{
				"name": "businessmen",
				"salience": 0.0011397863,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.0011397863,
				"type": "LOCATION"
			},
			{
				"name": "businessman",
				"salience": 0.0011397863,
				"type": "PERSON"
			},
			{
				"name": "businesses",
				"salience": 0.0011397863,
				"type": "ORGANIZATION"
			},
			{
				"name": "documentary",
				"salience": 0.0011397863,
				"type": "WORK_OF_ART"
			},
			{
				"name": "story",
				"salience": 0.0011246378,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.001114743,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0010972719,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0010972719,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0010972719,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0010972719,
				"type": "LOCATION"
			},
			{
				"name": "interview",
				"salience": 0.0010690134,
				"type": "EVENT"
			},
			{
				"name": "anywhere",
				"salience": 0.0010690134,
				"type": "LOCATION"
			},
			{
				"name": "industry",
				"salience": 0.0010690134,
				"type": "OTHER"
			},
			{
				"name": "shopping",
				"salience": 0.0010690134,
				"type": "OTHER"
			},
			{
				"name": "food mart",
				"salience": 0.0010690134,
				"type": "LOCATION"
			},
			{
				"name": "burqa",
				"salience": 0.0010690134,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0010291073,
				"type": "LOCATION"
			},
			{
				"name": "storefronts",
				"salience": 0.0010291073,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.0010291073,
				"type": "OTHER"
			},
			{
				"name": "island",
				"salience": 0.00096655387,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.00096655387,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0009658787,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.0009658787,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0009384567,
				"type": "LOCATION"
			},
			{
				"name": "immigration system",
				"salience": 0.0009256676,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.0009256676,
				"type": "PERSON"
			},
			{
				"name": "mothers",
				"salience": 0.0009256676,
				"type": "PERSON"
			},
			{
				"name": "school",
				"salience": 0.0009256676,
				"type": "ORGANIZATION"
			},
			{
				"name": "plants",
				"salience": 0.0009256676,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03dgvh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigander"
				},
				"name": "Michiganders",
				"salience": 0.00090408075,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.00090408075,
				"type": "LOCATION"
			},
			{
				"name": "shock",
				"salience": 0.0008911107,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0008911107,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.0008911107,
				"type": "OTHER"
			},
			{
				"name": "dialect",
				"salience": 0.0008911107,
				"type": "PERSON"
			},
			{
				"name": "hotel",
				"salience": 0.0008911107,
				"type": "LOCATION"
			},
			{
				"name": "towns",
				"salience": 0.00088074437,
				"type": "LOCATION"
			},
			{
				"name": "Hillary's America",
				"salience": 0.000877576,
				"type": "ORGANIZATION"
			},
			{
				"name": "reason",
				"salience": 0.00087269064,
				"type": "OTHER"
			},
			{
				"name": "settlements",
				"salience": 0.00087269064,
				"type": "OTHER"
			},
			{
				"name": "phenomenon",
				"salience": 0.0008687922,
				"type": "OTHER"
			},
			{
				"name": "polling",
				"salience": 0.00086703745,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vc7k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Township,_Macomb_County,_Michigan"
				},
				"name": "Clinton Township",
				"salience": 0.00085573853,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.00084703247,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0150zs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_American"
				},
				"name": "Arab",
				"salience": 0.0008340888,
				"type": "PERSON"
			},
			{
				"name": "thanks",
				"salience": 0.0008258176,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fpzwf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minneapolis"
				},
				"name": "Minneapolis",
				"salience": 0.0008126117,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05cc9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalis"
				},
				"name": "Somali",
				"salience": 0.0008126117,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027f_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas_Legislature"
				},
				"name": "Texas Legislature",
				"salience": 0.0008126117,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05q8lvb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Little_Mogadishu"
				},
				"name": "Little Mogadishu",
				"salience": 0.0008126117,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0008126117,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/013n60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amarillo,_Texas"
				},
				"name": "Amarillo",
				"salience": 0.0008126117,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.0008087467,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0008074516,
				"type": "PERSON"
			},
			{
				"name": "kids",
				"salience": 0.00080513384,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0007991363,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0007991363,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0007991363,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.000784968,
				"type": "OTHER"
			},
			{
				"name": "any",
				"salience": 0.0007815521,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vm42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rochester_Hills,_Michigan"
				},
				"name": "Rochester Hills",
				"salience": 0.00076090515,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vm42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rochester_Hills,_Michigan"
				},
				"name": "Rochester Hills",
				"salience": 0.00076090515,
				"type": "LOCATION"
			},
			{
				"name": "Shariah law",
				"salience": 0.00075566204,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.00075566204,
				"type": "OTHER"
			},
			{
				"name": "co-founders",
				"salience": 0.00075566204,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.00075566204,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0007428915,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0007428915,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00072744983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03lq2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halloween"
				},
				"name": "Halloween",
				"salience": 0.0007249532,
				"type": "EVENT"
			},
			{
				"name": "presidents",
				"salience": 0.0007220094,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0007220094,
				"type": "PERSON"
			},
			{
				"name": "Corcoran",
				"salience": 0.000706795,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vcdq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sterling_Heights,_Michigan"
				},
				"name": "Sterling Heights",
				"salience": 0.000701509,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vcdq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sterling_Heights,_Michigan"
				},
				"name": "Sterling Heights",
				"salience": 0.000701509,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "U.S. State Department",
				"salience": 0.00065906654,
				"type": "ORGANIZATION"
			},
			{
				"name": "things",
				"salience": 0.0006518879,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0006518879,
				"type": "LOCATION"
			},
			{
				"name": "refugee settlements",
				"salience": 0.0006518879,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0006518879,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00064142526,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0vm0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oak_Park,_Michigan"
				},
				"name": "Oak Park",
				"salience": 0.000633378,
				"type": "LOCATION"
			},
			{
				"name": "comment",
				"salience": 0.00060725404,
				"type": "WORK_OF_ART"
			},
			{
				"name": "comments",
				"salience": 0.00060725404,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statistics",
				"salience": 0.00060725404,
				"type": "OTHER"
			},
			{
				"name": "counties",
				"salience": 0.0005969393,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0005969393,
				"type": "LOCATION"
			},
			{
				"name": "The Sterling Heights",
				"salience": 0.0005948728,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/071jd_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamization"
				},
				"name": "Islamization",
				"salience": 0.0005948728,
				"type": "OTHER"
			},
			{
				"name": "Shariahvilles",
				"salience": 0.0005869649,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0nj7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oakland_County,_Michigan"
				},
				"name": "Oakland",
				"salience": 0.0005851729,
				"type": "LOCATION"
			},
			{
				"name": "amount",
				"salience": 0.0005789647,
				"type": "OTHER"
			},
			{
				"name": "donations",
				"salience": 0.00057166757,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.00056970544,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02zs4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ford_Motor_Company"
				},
				"name": "Ford",
				"salience": 0.00056970544,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.00056917965,
				"type": "ORGANIZATION"
			},
			{
				"name": "harbinger",
				"salience": 0.00056446233,
				"type": "OTHER"
			},
			{
				"name": "globe",
				"salience": 0.00056446233,
				"type": "LOCATION"
			},
			{
				"name": "side deals",
				"salience": 0.00056446233,
				"type": "OTHER"
			},
			{
				"name": "strings",
				"salience": 0.00056446233,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00056446233,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.00054843427,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vm75",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Troy,_Michigan"
				},
				"name": "Troy",
				"salience": 0.00054843427,
				"type": "LOCATION"
			},
			{
				"name": "SecureMichigan.org",
				"salience": 0.0005370961,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0njdm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Macomb_County,_Michigan"
				},
				"name": "Macomb",
				"salience": 0.0005283381,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0nj07",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wayne_County,_Michigan"
				},
				"name": "Wayne",
				"salience": 0.0005283381,
				"type": "LOCATION"
			},
			{
				"name": "threats",
				"salience": 0.0005099949,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0005023945,
				"type": "PERSON"
			},
			{
				"name": "amendment",
				"salience": 0.00048476463,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.00048380162,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.00047912443,
				"type": "LOCATION"
			},
			{
				"name": "poll",
				"salience": 0.0004747425,
				"type": "OTHER"
			},
			{
				"name": "blasphemy",
				"salience": 0.0004747425,
				"type": "OTHER"
			},
			{
				"name": "non-Muslims",
				"salience": 0.0004747425,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.0004747425,
				"type": "OTHER"
			},
			{
				"name": "organizer",
				"salience": 0.00046666432,
				"type": "PERSON"
			},
			{
				"name": "ties",
				"salience": 0.00045497442,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.000453598,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0004492397,
				"type": "OTHER"
			},
			{
				"name": "facet",
				"salience": 0.00043798622,
				"type": "OTHER"
			},
			{
				"name": "contractors",
				"salience": 0.0004251561,
				"type": "ORGANIZATION"
			},
			{
				"name": "controversy",
				"salience": 0.0004251561,
				"type": "OTHER"
			},
			{
				"name": "government contractors",
				"salience": 0.0004251561,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.00041107018,
				"type": "OTHER"
			},
			{
				"name": "government takeover",
				"salience": 0.00041107018,
				"type": "EVENT"
			},
			{
				"name": "moments",
				"salience": 0.00041107018,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00041107018,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.00041107018,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00041107018,
				"type": "PERSON"
			},
			{
				"name": "warning",
				"salience": 0.00041107018,
				"type": "OTHER"
			},
			{
				"name": "Member",
				"salience": 0.00037614323,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0nj7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oakland_County,_Michigan"
				},
				"name": "Oakland County",
				"salience": 0.00036736953,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06k6pv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southeast_Michigan"
				},
				"name": "Southeast Michigan",
				"salience": 0.00036736953,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.00036546175,
				"type": "PERSON"
			},
			{
				"name": "food mart",
				"salience": 0.00035461158,
				"type": "LOCATION"
			},
			{
				"name": "leaders",
				"salience": 0.00035461158,
				"type": "PERSON"
			},
			{
				"name": "industry",
				"salience": 0.00035461158,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.00035461158,
				"type": "EVENT"
			},
			{
				"name": "anywhere",
				"salience": 0.00035461158,
				"type": "LOCATION"
			},
			{
				"name": "shopping",
				"salience": 0.00035461158,
				"type": "OTHER"
			},
			{
				"name": "notice",
				"salience": 0.00030704917,
				"type": "OTHER"
			},
			{
				"name": "arrivals",
				"salience": 0.00030704917,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.0002670587,
				"type": "PERSON"
			},
			{
				"name": "thatMuslims",
				"salience": 0.00025297425,
				"type": "OTHER"
			},
			{
				"name": "Samaritas",
				"salience": 0.00024663672,
				"type": "PERSON"
			},
			{
				"name": "Lutheran Services",
				"salience": 0.00021822748,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dnlhc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Charities_USA"
				},
				"name": "Catholic Charities",
				"salience": 0.00021822748,
				"type": "ORGANIZATION"
			},
			{
				"name": "Episcopal Migration Services",
				"salience": 0.00021822748,
				"type": "ORGANIZATION"
			},
			{
				"name": "USRI",
				"salience": 0.00018895623,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Polish",
				"salience": 0.0001324633,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/na-hamtramck.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T12:59:30.440+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 21.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "HILLARY’S (Islamic) AMERICA IS ALREADY HERE where ‘Muslim NO-GO ZONES’ are popping up all over Michiganistan The rest of America may be agonizing over the security implications of taking in potential Islamic jihadists posing as refugees. But Syrian Muslim invaders are being welcomed with open arms in Hamtramck, Michigan – America’s first and only majority Muslim city. Non-Muslim residents in the Dearborn area are saying ‘You know, we’re getting ready to sell and get out of here.’” (Before property values tank as a result of the Muslim invasion with a mosque on every corner, blasting amplified Islamic Calls to Prayer several times a day) WND ( h/t Liz) Once 90 percent Polish Catholic, the blue-collar enclave just outside Detroit has been transformed by successive waves of immigrants from Bangladesh, Yemen and Bosnia. Muslims now outnumber non-Muslims, the council has a Muslim majority and the call to prayer echoes through the streets five times a day. “They’re setting this all up so they can continue their ancient squabbles that they have carried on for centuries in the Middle East right here your neighborhood,” Corcoran said. They call it “culture shift.” Places, in America, that no longer look or feel like America. (In Europe, they are referred to as NO-GO Zones) Cedar Riverside in Minneapolis fits the bill, with its large Somali community known as “Little Mogadishu,” as does and Hamtramck, Michigan, where the Islamic call to prayer is shouted over loudspeakers and the local city council is now majority-Muslim . Parts of Amarillo, Texas, have been flooded with so many Muslim refugees that some ethnic enclaves claim to have elected their own tribal leaders independent of the city government, the city’s mayor recently testified before the Texas Legislature . Then there is Dearborn, Michigan, which is now 40 percent Muslim and spilling over into neighboring cities and towns. Documentary filmmaker Dennis Michael Lynch recently drove through Dearborn, guided by a lifelong resident of the city named Brian (see video below). What Brian showed him was not just a culture shift but something closer to a shock. Women walk the streets dressed in long, black burqas that cover all but their eyes. Almost all the signs on storefronts are in Arabic or some other Middle Eastern dialect. Arab businessmen buy up commercial properties, force out the American tenants and replace them with similar businesses run by Muslims, Brian told Lynch in the documentary. The same phenomenon is now beginning to occur in nearby Sterling Heights, Troy, Oak Park and Clinton Township. In Sterling Heights, residents informed WND this week that Middle Eastern refugees are being housed in a local hotel owned by an Arab-American businessman. But in Dearborn, the tremendous growth in the Muslim community started more than 20 years ago, fueled by local universities and industry. Muslims voting for Muslims only “Brian still lives there. He’s not going anywhere,” Lynch told WND in an interview. “It depends on where you go in the city, but certain segments are 100 percent Muslim. Brian said to be prepared. We went through the areas, went shopping at the food mart. You really don’t feel like you are in America anymore.” Lynch said he was a regular contributor on Fox News between 2012 and 2015, until he started making hard-hitting documentaries on the U.S. immigration system. In certain areas in Dearborn. “You have two areas, and it’s almost like the Ford plants separate the two sides, and when you cross to the other side it’s totally radical again. We went to a park where kids were playing after school with the mothers all there, and everybody was dressed in full burqa. It was almost like it was Halloween. I’d never seen anything like it in my life.” Dearborn does not exist on an island. Residents of southeastern Michigan have every reason to expect their towns will one day look like Dearborn, Lynch said, thanks to President Obama’s Syrian refugee resettlement program, which Hillary Clinton says she’d like to expand by more than 500 percent. This is “Hillary’s America,” says a resident of nearby Rochester Hills who is one of the co-founders of SecureMichigan.org , a group that started up last year with the mission of helping educate Michiganders about Shariah law and Islamic settlements. He said the Islamization is literally moving from town to town in Oakland, Macomb and Wayne counties. “The Sterling Heights story is significant because we have these budding ‘Shariahvilles’ in Michigan,” he said. “We know there are refugees being planted. Now, in Rochester Hills, I’ve got five covered women walking down my street, and that’s never happened until two weeks ago.” In one 18-day period from Oct. 1 through Oct. 18, the U.S. State Department and its federal contractors have sent 199 Syrians to three counties in southeast Michigan – Oakland, Macomb and Wayne –and Oakland County leaders have not received any advance notice of the arrivals, said sources familiar with the growing controversy. The government contractors secretly planting the refugees in southeast Michigan are Lutheran Services/Samaritas, Catholic Charities of Southeast Michigan, USRI and Episcopal Migration Services. In Dearborn, the tremendous growth in the Muslim community started more than 20 years ago, fueled by local universities and industry. “Brian still lives there. He’s not going anywhere,” Lynch told WND in an interview. “It depends on where you go in the city, but certain segments are 100 percent Muslim. Brian said to be prepared. We went through the areas, went shopping at the food mart. You really Dearborn is but a harbinger of things to come for many more cities and towns across America if Hillary Clinton is elected president of the United States. “I think if she gets elected you’re going to see more immigration from Mideast countries than under any of the previous presidents including Obama, because she obviously has ties to those countries, getting an incredible amount of money donated from them,” Lynch said. “These donations come with strings. They come with side deals, and we don’t know what they are. It may be something as simple as ‘OK, we want to see more immigration from our country or some other country into the United States.’ Why else is there any need to increase the Syrian refugee settlements in America? There’s no reason. “If you look at all at the pay-for-play things, Muslims have said they want to spread Islam across the globe. The one country that doesn’t have that much of it is the United States.” Member of first Muslim-majority City Council warns: “Today we show the Polish”…thatMuslims are in charge. Within moments of winning the city’s election, an organizer involved in the government takeover was caught making ominous threats against non-Muslims in the city. HillaryDaily T his warning is no doubt troubling in its own right, but becomes even more unsettling when one pairs the comment with recent polling that suggests what Muslims would do should they take over any facet of government. Over half reject the first amendment, while 46% want blasphemers punished. 12% percent would even like to see those who commit blasphemy killed outright. Given their comments about the white population in the area, coupled with the sobering statistics outlined in the recent poll, it looks as if the city of Hamtramck, Michigan may be faced with a extremist city council under which they must be governed.",
		"thread_title": "HILLARY’S (Islamic) AMERICA IS ALREADY HERE where ‘Muslim NO-GO ZONES’ are popping up all over Michiganistan",
		"title": "HILLARY’S (Islamic) AMERICA IS ALREADY HERE where ‘Muslim NO-GO ZONES’ are popping up all over Michiganistan",
		"type": "bs",
		"uuid": "a404c6b3158002a3e3085c84c3a25b3c7e7a2e2b"
	},
	"-KhIjfYWUMxxZG2kkJYo": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T23:25:06.406+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.43845835,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.116700016,
				"type": "OTHER"
			},
			{
				"name": "bubble",
				"salience": 0.102589466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.06385334,
				"type": "ORGANIZATION"
			},
			{
				"name": "smoking gun",
				"salience": 0.040592328,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.031300493,
				"type": "ORGANIZATION"
			},
			{
				"name": "things",
				"salience": 0.03022299,
				"type": "OTHER"
			},
			{
				"name": "blackout",
				"salience": 0.03022299,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.026558658,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.01796715,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.01796715,
				"type": "ORGANIZATION"
			},
			{
				"name": "segment",
				"salience": 0.017802602,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.017465957,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.015247267,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.013483663,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.01125784,
				"type": "ORGANIZATION"
			},
			{
				"name": "Trico",
				"salience": 0.008309741,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/Ij8PH9nDT-o/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T23:25:06.406+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "HUGE! Has Wikileaks finally burst the Hillary Clinton bubble? When the mainstream media including the New York Times, Wall Street Journal, MSNBC, Bloomberg , and Washington Post, have lifted their coordinated blackout on all things negative about Hillary Clinton, you know it’s bad. Next week, Julian Assange is set to release Hillary’s actual emails which could be the smoking gun that finally brings her down. Be sure to watch the MSNBC segment in below video: \nh/t Trico",
		"thread_title": "HUGE! Has Wikileaks finally burst the Hillary Clinton bubble?",
		"title": "HUGE! Has Wikileaks finally burst the Hillary Clinton bubble?",
		"type": "bs",
		"uuid": "ade4f75a5e259a4477768c9e4aa8f4cee50c4f26"
	},
	"-KhIjfe393jMvHsLf1wK": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T23:25:09.646+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "@ 2",
				"salience": 0.18155237,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z4575"
				},
				"name": "Christine",
				"salience": 0.18155237,
				"type": "PERSON"
			},
			{
				"name": "POS Trudeau",
				"salience": 0.07635115,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.06350497,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.058528643,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.05185735,
				"type": "LOCATION"
			},
			{
				"name": "parties",
				"salience": 0.049635246,
				"type": "EVENT"
			},
			{
				"name": "mosques",
				"salience": 0.047588,
				"type": "LOCATION"
			},
			{
				"name": "xpress",
				"salience": 0.04468951,
				"type": "OTHER"
			},
			{
				"name": "frau",
				"salience": 0.04303511,
				"type": "OTHER"
			},
			{
				"name": "headlines",
				"salience": 0.0365402,
				"type": "OTHER"
			},
			{
				"name": "theyre",
				"salience": 0.027343793,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.027343793,
				"type": "OTHER"
			},
			{
				"name": "Peto Party",
				"salience": 0.026024813,
				"type": "ORGANIZATION"
			},
			{
				"name": "clubs",
				"salience": 0.019941917,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.019941917,
				"type": "OTHER"
			},
			{
				"name": "traitors",
				"salience": 0.014910242,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.014910242,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.014748379,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/s0VZH7f8sP0/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T23:25:09.646+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Christine t October 28, 2016 @ 2:59 pm \nWhy oh why did they vote that POS Trudeau in. At least possible good news in Germany 3 parties are clubbing together and possibly the fat frau could be gone in a week. Mind you uk daily xpress always puts out rubbish headlines. Dont know who the Peto Party are in Germany but there are another bunch of traitors and strangely enough have 65% of the votes in one town where theyre using public dollars to build mosques. Germans need to break out the clubs on that lot",
		"thread_title": "Hey, CANADIANS! Were you shocked by recent reports of the Syrian Muslim migrant in Germany getting welfare for all four of his wives and 23 children?",
		"title": "Hey, CANADIANS! Were you shocked by recent reports of the Syrian Muslim migrant in Germany getting welfare for all four of his wives and 23 children?",
		"type": "bs",
		"uuid": "527791e139d615538d0d493d09fb317730a91908"
	},
	"-KhIjfnqW14XgOg7K2Xo": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-28T23:25:10.681+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "someone",
				"salience": 0.12269669,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.08872696,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.05432569,
				"type": "PERSON"
			},
			{
				"name": "Reports",
				"salience": 0.05312064,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mailboxes",
				"salience": 0.05312064,
				"type": "LOCATION"
			},
			{
				"name": "absentee ballots",
				"salience": 0.05312064,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.040235993,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/050l8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montana"
				},
				"name": "Montana",
				"salience": 0.032871876,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x44q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Billings,_Montana"
				},
				"name": "Billings",
				"salience": 0.032871876,
				"type": "LOCATION"
			},
			{
				"name": "@ 3",
				"salience": 0.032871876,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.031505555,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.027310839,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.027310839,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.02343223,
				"type": "PERSON"
			},
			{
				"name": "bots",
				"salience": 0.019799838,
				"type": "OTHER"
			},
			{
				"name": "Hilloween",
				"salience": 0.016854446,
				"type": "PERSON"
			},
			{
				"name": "presidency",
				"salience": 0.015609986,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.014533366,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.01302872,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.01302872,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.011286404,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.011286404,
				"type": "PERSON"
			},
			{
				"name": "defense",
				"salience": 0.011286404,
				"type": "OTHER"
			},
			{
				"name": "well being",
				"salience": 0.011286404,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.011286404,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.010548713,
				"type": "OTHER"
			},
			{
				"name": "woman president",
				"salience": 0.010416106,
				"type": "PERSON"
			},
			{
				"name": "President",
				"salience": 0.008948736,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.007919179,
				"type": "OTHER"
			},
			{
				"name": "anticipation",
				"salience": 0.007919179,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007624049,
				"type": "LOCATION"
			},
			{
				"name": "interest",
				"salience": 0.007624049,
				"type": "OTHER"
			},
			{
				"name": "scenes",
				"salience": 0.007624049,
				"type": "OTHER"
			},
			{
				"name": "Information",
				"salience": 0.007624049,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.007624049,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.007466719,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04q7gbh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Americans"
				},
				"name": "American People",
				"salience": 0.0069534914,
				"type": "PERSON"
			},
			{
				"name": "joke",
				"salience": 0.0064668856,
				"type": "OTHER"
			},
			{
				"name": "swing' state",
				"salience": 0.00627774,
				"type": "OTHER"
			},
			{
				"name": "democrats",
				"salience": 0.006179291,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.005191402,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07xs2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Constitution_Party_(United_States)"
				},
				"name": "Constitution Party",
				"salience": 0.005009503,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.0046702833,
				"type": "ORGANIZATION"
			},
			{
				"name": "impeachment",
				"salience": 0.004366559,
				"type": "OTHER"
			},
			{
				"name": "swing",
				"salience": 0.004065006,
				"type": "OTHER"
			},
			{
				"name": "@ 2",
				"salience": 0.003982195,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "democrat",
				"salience": 0.0038049843,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "democrats",
				"salience": 0.0038049843,
				"type": "PERSON"
			},
			{
				"name": "criminals",
				"salience": 0.0035202412,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.0035202412,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0035202412,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.0035202412,
				"type": "OTHER"
			},
			{
				"name": "3rd parties",
				"salience": 0.003363569,
				"type": "ORGANIZATION"
			},
			{
				"name": "voting machines",
				"salience": 0.002837828,
				"type": "OTHER"
			},
			{
				"name": "primary",
				"salience": 0.0026299753,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/021_42",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Commission_of_India"
				},
				"name": "Election Commission",
				"salience": 0.0021670323,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/K2VjiY_IZDk/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-28T23:25:10.681+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "October 28, 2016 @ 3:07 pm \nReports are coming in now of absentee ballots being stolen from mailboxes in Billings, Montana. \nBigger issue: FBI has now reopened their investigation into Hilloween’s emails! Have found new ones. My concern is, how is someone under federal investigation going to fulfill the duties of the office of the presidency? That person would be focusing on their defense, not the well being of the American People! How is someone barred from access to Highly Classified Information going to be able to act in the interest of our country? A successful impeachment would see Kaine elevated to the presidency! He must be sitting behind the scenes, rubbing his hands in eager anticipation!”My precious! My precious!” All those mindless bots who are voting for this ho, only doing so because they desire to see a woman president will be sorely disappointed to see that office ceded to Tim Kaine! Whatta joke! TRUMP/PENCE!! marlene October 28, 2016 @ 2:50 pm \nI will consider the Constitution Party AFTER Donald Trump has served 8 years as President. When it comes to Congress, unfortunately my state does not allow 3rd parties to vote in the primary. If they did, I’d vote for the Constitution Party to give Trump a Congress he can work with. This also means that if I change to democrat, how can I vote out the democrats in Congress? And if I stay republican, it would be useless to vote them out as it would result in more democrats! My state SUCKS and has the worst rigged voting machines, soros-paid Election Commission criminals, and is a “swing” state. A ‘swing’ state is one where they swing your votes to the other candidate of THEIR choice.",
		"thread_title": "THE RIG IS IN: CROOKED HILLARY’S CROOKED VOTING MACHINES",
		"title": "THE RIG IS IN: CROOKED HILLARY’S CROOKED VOTING MACHINES",
		"type": "bs",
		"uuid": "275ffbf63c54c3265b9e1e6630b4995064d9816c"
	},
	"-KhIjg1WP_kYuGp9O8AE": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T03:54:08.307+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "girl",
				"salience": 0.33958963,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0948644,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.08340652,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0154j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belgium"
				},
				"name": "BELGIUM",
				"salience": 0.064629555,
				"type": "LOCATION"
			},
			{
				"name": "migrant",
				"salience": 0.051110752,
				"type": "PERSON"
			},
			{
				"name": "schoolgirl",
				"salience": 0.051110752,
				"type": "PERSON"
			},
			{
				"name": "friend",
				"salience": 0.04247262,
				"type": "PERSON"
			},
			{
				"name": "invader",
				"salience": 0.033112887,
				"type": "PERSON"
			},
			{
				"name": "drugging",
				"salience": 0.023362532,
				"type": "OTHER"
			},
			{
				"name": "schoolgirl",
				"salience": 0.021120742,
				"type": "PERSON"
			},
			{
				"name": "UK Express",
				"salience": 0.020306488,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.013054328,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.0113182375,
				"type": "ORGANIZATION"
			},
			{
				"name": "apartments",
				"salience": 0.0058522066,
				"type": "LOCATION"
			},
			{
				"name": "shock sentencing",
				"salience": 0.0053678686,
				"type": "EVENT"
			},
			{
				"name": "jail",
				"salience": 0.0053678686,
				"type": "LOCATION"
			},
			{
				"name": "jail",
				"salience": 0.0053678686,
				"type": "LOCATION"
			},
			{
				"name": "asylum seeker",
				"salience": 0.0051834825,
				"type": "PERSON"
			},
			{
				"name": "drugging",
				"salience": 0.004959972,
				"type": "OTHER"
			},
			{
				"name": "raping",
				"salience": 0.004479383,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.004479383,
				"type": "ORGANIZATION"
			},
			{
				"name": "pervert",
				"salience": 0.0038798603,
				"type": "OTHER"
			},
			{
				"name": "shock verdict",
				"salience": 0.0038798603,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0038798603,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.0038431368,
				"type": "PERSON"
			},
			{
				"name": "sentence",
				"salience": 0.0036260707,
				"type": "OTHER"
			},
			{
				"name": "drugs",
				"salience": 0.0034799823,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "gang",
				"salience": 0.0031425327,
				"type": "PERSON"
			},
			{
				"name": "sex attack",
				"salience": 0.0028417148,
				"type": "EVENT"
			},
			{
				"name": "alcohol",
				"salience": 0.0027216517,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.0027216517,
				"type": "OTHER"
			},
			{
				"name": "city centre",
				"salience": 0.0027216517,
				"type": "LOCATION"
			},
			{
				"name": "journey",
				"salience": 0.0026201645,
				"type": "OTHER"
			},
			{
				"name": "bus",
				"salience": 0.0026201645,
				"type": "OTHER"
			},
			{
				"name": "hometown",
				"salience": 0.0026201645,
				"type": "LOCATION"
			},
			{
				"name": "incident",
				"salience": 0.0026201645,
				"type": "EVENT"
			},
			{
				"name": "girl",
				"salience": 0.0024519167,
				"type": "PERSON"
			},
			{
				"name": "judge",
				"salience": 0.0024126724,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017p44",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tongeren"
				},
				"name": "Tongeren",
				"salience": 0.002389595,
				"type": "LOCATION"
			},
			{
				"name": "jail",
				"salience": 0.0022983525,
				"type": "LOCATION"
			},
			{
				"name": "flat",
				"salience": 0.002222291,
				"type": "LOCATION"
			},
			{
				"name": "screaming",
				"salience": 0.002222291,
				"type": "EVENT"
			},
			{
				"name": "throat",
				"salience": 0.002222291,
				"type": "OTHER"
			},
			{
				"name": "abuser",
				"salience": 0.002222291,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.002222291,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0021234162,
				"type": "EVENT"
			},
			{
				"name": "gang rape",
				"salience": 0.0021234162,
				"type": "EVENT"
			},
			{
				"name": "defenses",
				"salience": 0.0019173647,
				"type": "OTHER"
			},
			{
				"name": "invaders",
				"salience": 0.0019173647,
				"type": "PERSON"
			},
			{
				"name": "migrant",
				"salience": 0.0019173647,
				"type": "PERSON"
			},
			{
				"name": "sentencing",
				"salience": 0.0016956347,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/017nl3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Genk"
				},
				"name": "Genk",
				"salience": 0.0016758244,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/017411",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hasselt"
				},
				"name": "Hasselt",
				"salience": 0.0016758244,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.0016604128,
				"type": "PERSON"
			},
			{
				"name": "nature",
				"salience": 0.0016604128,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0016604128,
				"type": "PERSON"
			},
			{
				"name": "defence lawyers",
				"salience": 0.0016188509,
				"type": "PERSON"
			},
			{
				"name": "Bertem",
				"salience": 0.0016132985,
				"type": "LOCATION"
			},
			{
				"name": "Rape",
				"salience": 0.0014890844,
				"type": "OTHER"
			},
			{
				"name": "sentence",
				"salience": 0.0013843732,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.001209438,
				"type": "PERSON"
			},
			{
				"name": "victim",
				"salience": 0.001209438,
				"type": "PERSON"
			},
			{
				"name": "compensation",
				"salience": 0.001209438,
				"type": "OTHER"
			},
			{
				"name": "rape conviction",
				"salience": 0.001209438,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.0011555972,
				"type": "EVENT"
			},
			{
				"name": "help",
				"salience": 0.0010434038,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0010434038,
				"type": "ORGANIZATION"
			},
			{
				"name": "help",
				"salience": 0.0010434038,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0145g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ostend"
				},
				"name": "Ostend",
				"salience": 0.0010221374,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0009626503,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00090351264,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00090351264,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.00090351264,
				"type": "ORGANIZATION"
			},
			{
				"name": "rest",
				"salience": 0.00090351264,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.00074444583,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/eR0-Jp4TyIE/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:54:08.307+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 28 2016 BELGIUM: Iranian Muslim invader found guilty of drugging, repeatedly raping, and threatening to kill a 15-year-old Belgian schoolgirl, GETS NO JAIL TIME! An Iranian Muslim illegal alien migrant who threatened to kill a runaway schoolgirl if she screamed as he repeatedly raped her has been spared any jail in a shock sentencing. The 20-year-old Muslim whose identity is being protected ( why? ), was found guilty of drugging, raping, and threatening the young girl by the court in Tongeren, Belgium. But the typical Muslim pervert has been spared jail in a shock verdict – and got away with a suspended sentence. UK Express The harrowing incident happened in April 2014, after the young girl and a female friend ran away from their hometown of Bertem. When the friend decided to return home two days later, the 15-year-old carried on her journey – taking a bus from Hasselt to Genk on her own. There, after arriving at 11pm on April 20, she took up with a gang of other young people who were hanging around in the city centre, and was taken to one of their apartments where she was plied with alcohol and drugs. The young girl later fell asleep at the flat, but was woken up just hours later by the 20-year-old Iranian Muslim who repeatedly raped her. During the horrific sex attack, she was bitten by her abuser and nearly suffocated after he put his hands around her throat to stop her screaming. He threatened to kill her if she continued to call for help. The court heard that after the attack, she did not dare to ask for help any more and feared the rest of the group could burst in at any minute and rape her as well. “Rape is the most natural thing in the world,” and “women must obey men,” were just two of the defenses offered by some of the seven Muslim invaders recently arrested for a gang rape of an unconscious 17-year-old white girl in Ostend, Belgium However, despite the aggressive nature of the attack, the migrant has been spared jail. Handing him a suspended sentence, the judge also fined the Iranian £3,680 in compensation to the girl and her family. The sentencing comes just days after an Iraqi asylum seeker had his rape conviction overturned , after his defence lawyers claimed he did not know his 10-year-old victim did not want to be raped.",
		"thread_title": "BELGIUM: Iranian Muslim invader found guilty of drugging, repeatedly raping, and threatening to kill a 15-year-old Belgian schoolgirl, GETS NO JAIL TIME!",
		"title": "BELGIUM: Iranian Muslim invader found guilty of drugging, repeatedly raping, and threatening to kill a 15-year-old Belgian schoolgirl, GETS NO JAIL TIME!",
		"type": "bs",
		"uuid": "1e15d75bbdba70d5c74f1381f4d0255ef337aed4"
	},
	"-KhIjgO0Zo9PGNEFVf-n": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T03:54:08.530+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Jay Talerman",
				"salience": 0.20233624,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04_xn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosque"
				},
				"name": "Islamic Society",
				"salience": 0.0489763,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "CAIR",
				"salience": 0.031113416,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.03051071,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.024922548,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.024922548,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/035pfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Board_of_selectmen"
				},
				"name": "Board of Selectmen",
				"salience": 0.024329841,
				"type": "ORGANIZATION"
			},
			{
				"name": "position",
				"salience": 0.022824498,
				"type": "OTHER"
			},
			{
				"name": "cemetery",
				"salience": 0.019525325,
				"type": "LOCATION"
			},
			{
				"name": "courts",
				"salience": 0.018492538,
				"type": "LOCATION"
			},
			{
				"name": "Boston Globe The Islamic Society of Greater Worcester",
				"salience": 0.01744671,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.016909268,
				"type": "OTHER"
			},
			{
				"name": "countercharges",
				"salience": 0.016027741,
				"type": "OTHER"
			},
			{
				"name": "DEAD MUSLIMS SOCIETY",
				"salience": 0.014997597,
				"type": "ORGANIZATION"
			},
			{
				"name": "bigotry",
				"salience": 0.01447969,
				"type": "OTHER"
			},
			{
				"name": "Amjad Bahnassi",
				"salience": 0.014393621,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.013862412,
				"type": "PERSON"
			},
			{
				"name": "grandstanding",
				"salience": 0.012547057,
				"type": "OTHER"
			},
			{
				"name": "resolution",
				"salience": 0.012547057,
				"type": "OTHER"
			},
			{
				"name": "litigation jihadists",
				"salience": 0.012547057,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.012547057,
				"type": "OTHER"
			},
			{
				"name": "acrimony",
				"salience": 0.012547057,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "Massachusetts",
				"salience": 0.011176729,
				"type": "LOCATION"
			},
			{
				"name": "process",
				"salience": 0.009857058,
				"type": "OTHER"
			},
			{
				"name": "burials",
				"salience": 0.009483726,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.009425463,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.00825057,
				"type": "LOCATION"
			},
			{
				"name": "graveyard",
				"salience": 0.008207471,
				"type": "OTHER"
			},
			{
				"name": "proposal",
				"salience": 0.008207471,
				"type": "OTHER"
			},
			{
				"name": "Gary Brackett",
				"salience": 0.0080207465,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.007961974,
				"type": "PERSON"
			},
			{
				"name": "organization",
				"salience": 0.0076184114,
				"type": "ORGANIZATION"
			},
			{
				"name": "farmland",
				"salience": 0.0074125035,
				"type": "LOCATION"
			},
			{
				"name": "talks",
				"salience": 0.0074125035,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0v00h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dudley,_Massachusetts"
				},
				"name": "Dudley",
				"salience": 0.0061647873,
				"type": "LOCATION"
			},
			{
				"name": "property",
				"salience": 0.006148307,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.005275934,
				"type": "LOCATION"
			},
			{
				"name": "investigation",
				"salience": 0.0051776366,
				"type": "EVENT"
			},
			{
				"name": "society",
				"salience": 0.0051391344,
				"type": "OTHER"
			},
			{
				"name": "procedures",
				"salience": 0.005105749,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0050104843,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0041263187,
				"type": "OTHER"
			},
			{
				"name": "courts",
				"salience": 0.0039067813,
				"type": "LOCATION"
			},
			{
				"name": "attorney",
				"salience": 0.0039067813,
				"type": "PERSON"
			},
			{
				"name": "Sarah Wunsch",
				"salience": 0.003877626,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0038524775,
				"type": "OTHER"
			},
			{
				"name": "civil rights suit",
				"salience": 0.003840393,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0037088175,
				"type": "ORGANIZATION"
			},
			{
				"name": "town",
				"salience": 0.0037008082,
				"type": "LOCATION"
			},
			{
				"name": "society",
				"salience": 0.0034703547,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0033834234,
				"type": "ORGANIZATION"
			},
			{
				"name": "selectmen",
				"salience": 0.0033834234,
				"type": "ORGANIZATION"
			},
			{
				"name": "counter-offer",
				"salience": 0.0033834234,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.0032964626,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.003178841,
				"type": "LOCATION"
			},
			{
				"name": "client",
				"salience": 0.003055138,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.003055138,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0030217369,
				"type": "LOCATION"
			},
			{
				"name": "cemetery",
				"salience": 0.0028940132,
				"type": "LOCATION"
			},
			{
				"name": "rights",
				"salience": 0.002786055,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0027712225,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0026457473,
				"type": "OTHER"
			},
			{
				"name": "discussions",
				"salience": 0.0026457473,
				"type": "EVENT"
			},
			{
				"name": "water supply",
				"salience": 0.0026457473,
				"type": "OTHER"
			},
			{
				"name": "plenty",
				"salience": 0.0026457473,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0026457473,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.0025683101,
				"type": "PERSON"
			},
			{
				"name": "graveyard",
				"salience": 0.0024487735,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.0024336874,
				"type": "OTHER"
			},
			{
				"name": "affront",
				"salience": 0.0024211311,
				"type": "OTHER"
			},
			{
				"name": "cemetery application",
				"salience": 0.00237277,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00237277,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0023628436,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.0022842386,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0022576805,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.0022576805,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.0022576805,
				"type": "LOCATION"
			},
			{
				"name": "cemetery",
				"salience": 0.0022460313,
				"type": "LOCATION"
			},
			{
				"name": "farmland",
				"salience": 0.002169793,
				"type": "LOCATION"
			},
			{
				"name": "details",
				"salience": 0.0021601052,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0021424624,
				"type": "OTHER"
			},
			{
				"name": "clients",
				"salience": 0.0021424624,
				"type": "PERSON"
			},
			{
				"name": "sides",
				"salience": 0.0021424624,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0020968702,
				"type": "OTHER"
			},
			{
				"name": "talks",
				"salience": 0.002062517,
				"type": "EVENT"
			},
			{
				"name": "organization",
				"salience": 0.002062517,
				"type": "ORGANIZATION"
			},
			{
				"name": "accusations",
				"salience": 0.002027443,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0020108828,
				"type": "OTHER"
			},
			{
				"name": "graves",
				"salience": 0.001974074,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.0018906,
				"type": "OTHER"
			},
			{
				"name": "crowds",
				"salience": 0.0018789502,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.0018636021,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.0018552803,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0018552803,
				"type": "EVENT"
			},
			{
				"name": "citizens",
				"salience": 0.0018552803,
				"type": "PERSON"
			},
			{
				"name": "size",
				"salience": 0.0018552803,
				"type": "OTHER"
			},
			{
				"name": "willingness",
				"salience": 0.0018552803,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.0018552803,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0018552803,
				"type": "PERSON"
			},
			{
				"name": "state Attorney General",
				"salience": 0.0017860433,
				"type": "PERSON"
			},
			{
				"name": "addition",
				"salience": 0.0017860433,
				"type": "OTHER"
			},
			{
				"name": "violations",
				"salience": 0.0017860433,
				"type": "EVENT"
			},
			{
				"name": "surprise",
				"salience": 0.0017860433,
				"type": "OTHER"
			},
			{
				"name": "strategies",
				"salience": 0.0017744775,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0017652734,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0017491367,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.0017491367,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0017491367,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.0017491367,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0017491367,
				"type": "OTHER"
			},
			{
				"name": "cemetery application",
				"salience": 0.0017065343,
				"type": "OTHER"
			},
			{
				"name": "thugs",
				"salience": 0.0016763385,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.001644457,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.001644457,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j75z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_district_court"
				},
				"name": "US District Court",
				"salience": 0.0016238337,
				"type": "ORGANIZATION"
			},
			{
				"name": "Massachusetts Land Court",
				"salience": 0.0016238337,
				"type": "LOCATION"
			},
			{
				"name": "bigotry",
				"salience": 0.0015605146,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0015240378,
				"type": "OTHER"
			},
			{
				"name": "Attorney's Office",
				"salience": 0.0015220586,
				"type": "ORGANIZATION"
			},
			{
				"name": "equivalent",
				"salience": 0.0015146454,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0015146454,
				"type": "OTHER"
			},
			{
				"name": "misunderstanding",
				"salience": 0.0015146454,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0015146454,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0015146454,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.0014472113,
				"type": "OTHER"
			},
			{
				"name": "selectmen",
				"salience": 0.0013756405,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.001364828,
				"type": "PERSON"
			},
			{
				"name": "intention",
				"salience": 0.00133427,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.001318751,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.001306694,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.001306694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0012696006,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0012696006,
				"type": "LOCATION"
			},
			{
				"name": "society",
				"salience": 0.0011965766,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0011965766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k3ll",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Worcester_County,_Massachusetts"
				},
				"name": "Worcester County",
				"salience": 0.0011924353,
				"type": "LOCATION"
			},
			{
				"name": "cemetery",
				"salience": 0.001191533,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Muslim",
				"salience": 0.001141998,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0011409443,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0011314903,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.0011314903,
				"type": "OTHER"
			},
			{
				"name": "refusal",
				"salience": 0.0011314903,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0011314903,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vkm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_Liberties_Union"
				},
				"name": "ACLU",
				"salience": 0.0011133985,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0010993682,
				"type": "PERSON"
			},
			{
				"name": "agreement",
				"salience": 0.0010540321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h67yj8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Land_court"
				},
				"name": "Land Court",
				"salience": 0.0010287033,
				"type": "LOCATION"
			},
			{
				"name": "burials",
				"salience": 0.0010269169,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.00093968323,
				"type": "OTHER"
			},
			{
				"name": "olive branch",
				"salience": 0.0008780067,
				"type": "LOCATION"
			},
			{
				"name": "project",
				"salience": 0.00082405825,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.00082405825,
				"type": "OTHER"
			},
			{
				"name": "STORIES",
				"salience": 0.00082405825,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lack",
				"salience": 0.00082405825,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.00082405825,
				"type": "OTHER"
			},
			{
				"name": "VIDEOS",
				"salience": 0.00082405825,
				"type": "WORK_OF_ART"
			},
			{
				"name": "contention",
				"salience": 0.00082405825,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0008179198,
				"type": "OTHER"
			},
			{
				"name": "roads",
				"salience": 0.00081367296,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Zoning_in_the_United_States"
				},
				"name": "Zoning Board of Appeals",
				"salience": 0.000804254,
				"type": "ORGANIZATION"
			},
			{
				"name": "application",
				"salience": 0.0007873604,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0007199673,
				"type": "OTHER"
			},
			{
				"name": "townspeople",
				"salience": 0.0007120888,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0007108934,
				"type": "LOCATION"
			},
			{
				"name": "water",
				"salience": 0.0007108934,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.000615556,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.000615556,
				"type": "PERSON"
			},
			{
				"name": "hardship",
				"salience": 0.000615556,
				"type": "OTHER"
			},
			{
				"name": "coffins",
				"salience": 0.000615556,
				"type": "OTHER"
			},
			{
				"name": "town government",
				"salience": 0.000615556,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0pc7r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Worcester,_Massachusetts"
				},
				"name": "Worcester",
				"salience": 0.00048457205,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01x73",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Connecticut"
				},
				"name": "Conn.",
				"salience": 0.000378827,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rdg0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Enfield,_Connecticut"
				},
				"name": "Enfield",
				"salience": 0.000378827,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/yiede-vi.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T03:54:08.530+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "DEAD MUSLIMS SOCIETY will sue to force small Massachusetts town to allocate space for 16,000 dead Muslims Negotiations to put a Muslim cemetery in the small town of Dudley have broken down in acrimony, and the contentious issue — replete with charges and countercharges of bigotry and grandstanding — appears to be headed for resolution in the courts, aided and abetted by the litigation jihadists of designated terrorist group CAIR. Boston Globe The Islamic Society of Greater Worcester ended talks this week after the Board of Selectmen did not accept its latest proposal for a graveyard on 55 acres of abandoned farmland , according to the society’s attorney. A counter-offer by the town also was not accepted. Neither side provided details of the private discussions. People are opposed to casket free Muslim burials which could contaminate the water supply Jay Talerman, the Islamic Society attorney, said Thursday the group will now pursue the plan in the courts, following a 10-month process that failed to produce an agreement but generated plenty of heated rhetoric. “Each time, the selectmen retreated to a position that involved violating my client’s rights,” Talerman said. “The most disappointing part appears to be that they never sincerely or genuinely had any intention to accommodate us.” (What a surprise. NOT) A suit filed by the society is pending in Massachusetts Land Court. In addition, the ACLU of Massachusetts is preparing to file a civil rights suit in US District Court, said Sarah Wunsch, the organization’s deputy legal director. The Obama thugs of the US Attorney’s Office in Boston already has launched an investigation into whether civil rights violations occurred. The state Attorney General’s office has been in talks with both sides. The town’s attorney, Gary Brackett, said that the issue always has been about the size and impact of the cemetery — not whether one would be permitted. Throughout the process, Talerman said, “the selectmen never expressed a willingness to abandon procedures that are a direct affront to my clients.” Brackett denounced Talerman’s repeated accusations that anti-Muslim bias tainted the cemetery application. Large crowds have come out to every meeting to protest the proposed cemetery “I would compare Mr. Talerman’s broad-brush claims regarding the citizens and officials of the town of Dudley as being the equivalent of Donald Trump’s attempt at portraying Muslims,” Brackett said. Dr. Amjad Bahnassi, the president of the Islamic Society, said he attributed part of the opposition to a “misunderstanding” of the Muslim religion and said the issue has become a civil rights concern for many of the estimated 5,000 Muslims in Worcester County. “We’re being denied unfairly what is granted to us by the law,” Bahnassi said. At issue is the Islamic Society’s attempt to buy farmland with enough space for an estimated 16,000 graves that, if filled, would be the largest Muslim cemetery in the state. The society currently uses a graveyard in Enfield, Conn., 60 miles from Worcester, which Muslim leaders said poses a hardship for many families. When the society’s plans became public early this year, townspeople expressed fears that burials would contaminate well water, because Muslims traditionally do not use coffins, and that the nearby rural roads would become congested. Muslim leaders continued to pursue their application through town government, even though Talerman said the society was not required to seek approval because the organization is a religious group seeking the land for a religious purpose. The town’s Zoning Board of Appeals rejected the cemetery application in June, and the Islamic Society filed suit in Land Court. The town also began efforts to buy the land under a right of first refusal for certain agricultural property. However, the Islamic Society, which already had signed a purchase-and-sale agreement for the property, argued again that the town had no such right. Facing intensifying pressure, the town eventually waived that claim. On Thursday, Talerman reiterated his longstanding contention that bigotry lies behind the lack of an agreement. “We gave this town an opportunity to lock arms with us and welcome a benign use into their town that would dispel any notion that they were biased or bigoted,” he said. “They have not taken up the olive branch and instead have doubled down on strategies that are solely intended to delay or kill our project.” (Yes, and once Trump is in office you can take your lawsuit and stuff it) RELATED STORIES/VIDEOS:",
		"thread_title": "DEAD MUSLIMS SOCIETY will sue to force small Massachusetts town to allocate space for 16,000 dead Muslims",
		"title": "DEAD MUSLIMS SOCIETY will sue to force small Massachusetts town to allocate space for 16,000 dead Muslims",
		"type": "bs",
		"uuid": "0c0ff93384f5a5df6a03cb2e6cb4d421210525b0"
	},
	"-KhIjgTJEWYydLmmE9Ij": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T05:28:01.804+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/1g-Svw3ITuI/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T05:28:01.804+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "ATTENTION DONALD TRUMP VOTERS!!! What to do if you see vote switching from Trump to Clinton at the polls",
		"title": "ATTENTION DONALD TRUMP VOTERS!!! What to do if you see vote switching from Trump to Clinton at the polls",
		"type": "bs",
		"uuid": "6de5c2c42f6bbfb7382d255dcf2f0feb9b2b8990"
	},
	"-KhIjgjAiJRCMXjESeH_": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-29T12:15:52.248+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.16456771,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "FRANCE",
				"salience": 0.13349739,
				"type": "LOCATION"
			},
			{
				"name": "Police",
				"salience": 0.113900214,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Parisian",
				"salience": 0.06675632,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01mw2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kafir"
				},
				"name": "non-Muslims",
				"salience": 0.04447794,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.031245688,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qg4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Hollande"
				},
				"name": "Francois Hollande",
				"salience": 0.02872328,
				"type": "PERSON"
			},
			{
				"name": "NO-GO Zones",
				"salience": 0.022426218,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.01890734,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.01760607,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/074hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sharia"
				},
				"name": "Sharia",
				"salience": 0.01737587,
				"type": "OTHER"
			},
			{
				"name": "Brenda K",
				"salience": 0.016959732,
				"type": "PERSON"
			},
			{
				"name": "NO GO ZONES",
				"salience": 0.01561939,
				"type": "OTHER"
			},
			{
				"name": "NO-GO Zones",
				"salience": 0.013860408,
				"type": "OTHER"
			},
			{
				"name": "insistence",
				"salience": 0.011597581,
				"type": "OTHER"
			},
			{
				"name": "migrant areas",
				"salience": 0.011597581,
				"type": "LOCATION"
			},
			{
				"name": "siege",
				"salience": 0.011597581,
				"type": "OTHER"
			},
			{
				"name": "NO-GO Zones",
				"salience": 0.011511662,
				"type": "OTHER"
			},
			{
				"name": "shootings",
				"salience": 0.009419737,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00849015,
				"type": "OTHER"
			},
			{
				"name": "multiculturalists",
				"salience": 0.007783026,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.007152782,
				"type": "ORGANIZATION"
			},
			{
				"name": "firefighters",
				"salience": 0.0068539307,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0068539307,
				"type": "OTHER"
			},
			{
				"name": "French Republic: Myth",
				"salience": 0.006505496,
				"type": "WORK_OF_ART"
			},
			{
				"name": "limits",
				"salience": 0.0059372745,
				"type": "OTHER"
			},
			{
				"name": "migrant",
				"salience": 0.0059372745,
				"type": "PERSON"
			},
			{
				"name": "suburbs",
				"salience": 0.005757178,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.00526408,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0052518547,
				"type": "OTHER"
			},
			{
				"name": "no-go zones",
				"salience": 0.0047525954,
				"type": "OTHER"
			},
			{
				"name": "gangs",
				"salience": 0.004522376,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0037481529,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Gatestone",
				"salience": 0.0036577873,
				"type": "OTHER"
			},
			{
				"name": "television presenter",
				"salience": 0.0034382103,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0033870183,
				"type": "LOCATION"
			},
			{
				"name": "no-go zones",
				"salience": 0.0032096915,
				"type": "OTHER"
			},
			{
				"name": "mountain",
				"salience": 0.0031528573,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0mhpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Seine-Saint-Denis"
				},
				"name": "Seine-Saint-Denis",
				"salience": 0.0031443143,
				"type": "LOCATION"
			},
			{
				"name": "Host-country authorities",
				"salience": 0.0031131722,
				"type": "ORGANIZATION"
			},
			{
				"name": "No-Go Zones",
				"salience": 0.0028075497,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.00280659,
				"type": "PERSON"
			},
			{
				"name": "no-go zones",
				"salience": 0.002722337,
				"type": "OTHER"
			},
			{
				"name": "Suburbs",
				"salience": 0.002676743,
				"type": "LOCATION"
			},
			{
				"name": "societies",
				"salience": 0.002563192,
				"type": "OTHER"
			},
			{
				"name": "civil law",
				"salience": 0.0025342891,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0024471565,
				"type": "OTHER"
			},
			{
				"name": "fire fighting",
				"salience": 0.0024471565,
				"type": "EVENT"
			},
			{
				"name": "ambulance services",
				"salience": 0.0024471565,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.0024471565,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0024471565,
				"type": "OTHER"
			},
			{
				"name": "societies",
				"salience": 0.002375544,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighborhoods",
				"salience": 0.002375544,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.0023088274,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0021947094,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy"
				},
				"name": "Republic",
				"salience": 0.0021583226,
				"type": "LOCATION"
			},
			{
				"name": "by-product",
				"salience": 0.0021558919,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "aid",
				"salience": 0.001998032,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0019817152,
				"type": "LOCATION"
			},
			{
				"name": "projectiles",
				"salience": 0.0019817152,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.0019817152,
				"type": "EVENT"
			},
			{
				"name": "gendarmerie",
				"salience": 0.0019817152,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.0019817152,
				"type": "OTHER"
			},
			{
				"name": "no-go zones",
				"salience": 0.0019335195,
				"type": "OTHER"
			},
			{
				"name": "Reality",
				"salience": 0.0019077781,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0019077781,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.001800473,
				"type": "ORGANIZATION"
			},
			{
				"name": "Banlieue de la République",
				"salience": 0.001800473,
				"type": "PERSON"
			},
			{
				"name": "landmark",
				"salience": 0.0017161131,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.001687127,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0016785009,
				"type": "LOCATION"
			},
			{
				"name": "youth",
				"salience": 0.0016520773,
				"type": "PERSON"
			},
			{
				"name": "values",
				"salience": 0.0016520773,
				"type": "OTHER"
			},
			{
				"name": "radicalism",
				"salience": 0.0016520773,
				"type": "OTHER"
			},
			{
				"name": "enclaves",
				"salience": 0.0016520773,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0016520773,
				"type": "LOCATION"
			},
			{
				"name": "grounds",
				"salience": 0.0016520773,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0016520773,
				"type": "OTHER"
			},
			{
				"name": "host nations",
				"salience": 0.0016520773,
				"type": "LOCATION"
			},
			{
				"name": "suburbs",
				"salience": 0.0016328676,
				"type": "LOCATION"
			},
			{
				"name": "society",
				"salience": 0.001624172,
				"type": "OTHER"
			},
			{
				"name": "Reality",
				"salience": 0.001617943,
				"type": "OTHER"
			},
			{
				"name": "research paper",
				"salience": 0.001617943,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0015459246,
				"type": "OTHER"
			},
			{
				"name": "civil law",
				"salience": 0.0015459246,
				"type": "OTHER"
			},
			{
				"name": "Zones Urbaines Sensibles",
				"salience": 0.0015066061,
				"type": "OTHER"
			},
			{
				"name": "NO-GO Zones",
				"salience": 0.0014816328,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0014010617,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0014010617,
				"type": "EVENT"
			},
			{
				"name": "Some",
				"salience": 0.0014010617,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0014010617,
				"type": "PERSON"
			},
			{
				"name": "commentators",
				"salience": 0.0013487738,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.0013386905,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0013386905,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.0012984362,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0012445382,
				"type": "WORK_OF_ART"
			},
			{
				"name": "attention",
				"salience": 0.0012342277,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.001213376,
				"type": "WORK_OF_ART"
			},
			{
				"name": "public",
				"salience": 0.0012087215,
				"type": "PERSON"
			},
			{
				"name": "suburbs",
				"salience": 0.0011893284,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.0010466664,
				"type": "OTHER"
			},
			{
				"name": "marginalization",
				"salience": 0.0010466664,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0010169545,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.00097502006,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0009316061,
				"type": "PERSON"
			},
			{
				"name": "Suburbs",
				"salience": 0.0008884666,
				"type": "LOCATION"
			},
			{
				"name": "suburbs",
				"salience": 0.0008884666,
				"type": "LOCATION"
			},
			{
				"name": "multiculturalism",
				"salience": 0.00088034297,
				"type": "OTHER"
			},
			{
				"name": "preachers",
				"salience": 0.0008597615,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0007884125,
				"type": "LOCATION"
			},
			{
				"name": "societies",
				"salience": 0.0007884125,
				"type": "ORGANIZATION"
			},
			{
				"name": "apologies",
				"salience": 0.00076229713,
				"type": "OTHER"
			},
			{
				"name": "air",
				"salience": 0.00076229713,
				"type": "OTHER"
			},
			{
				"name": "Mayor",
				"salience": 0.00076229713,
				"type": "PERSON"
			},
			{
				"name": "result",
				"salience": 0.00076229713,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00072835153,
				"type": "OTHER"
			},
			{
				"name": "gendarmerie",
				"salience": 0.0006576187,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0006576187,
				"type": "LOCATION"
			},
			{
				"name": "projectiles",
				"salience": 0.0006576187,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.0006576187,
				"type": "EVENT"
			},
			{
				"name": "dozens",
				"salience": 0.0006576187,
				"type": "OTHER"
			},
			{
				"name": "Obertone",
				"salience": 0.0006442117,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "FOX News",
				"salience": 0.0006178357,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06z90w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charlie_Hebdo"
				},
				"name": "Charlie Hebdo",
				"salience": 0.00046915974,
				"type": "PERSON"
			},
			{
				"name": "c",
				"salience": 0.00046915974,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/maxresdefault-e13753855622951.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-29T12:15:52.248+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 29 2016 FRANCE: Police are under siege in Muslim migrant areas in and around Paris, also known as “NO-GO Zones” Despite President Francois Hollande’s continued insistence that there aren’t any Muslim NO-GO Zones in France, police say otherwise. NO-GO Zones are violent and lawless Muslim migrant dominated neighborhoods around Paris that are virtually off limits to non-Muslims and a threat to police and firefighters. Gatestone (h/t Brenda K) There is a mountain of evidence that confirms the existence of Muslim ‘NO GO ZONES’ (Zones Urbaines Sensibles) where non-Muslims are afraid to go because they regularly are attacked by gangs of Muslims who rule these lawless neighborhoods. Host-country authorities have effectively lost control over many no-go zones and are often unable or unwilling to provide even basic public aid, such as police, fire fighting and ambulance services, out of fear of being attacked by Muslim youth. Muslim enclaves in European cities are also breeding grounds for Islamic radicalism and pose a significant threat to Western security. Europe’s no-go zones are the by-product of decades of multicultural policies that have encouraged Muslim immigrants to create parallel societies and remain segregated from — rather than become integrated into — their European host nations. A 120-page research paper entitled “No-Go Zones in the French Republic: Myth or Reality?” documented dozens of French neighborhoods “where police and gendarmerie cannot enforce the Republican order or even enter without risking confrontation, projectiles, or even fatal shootings.” A landmark 2,200-page report, “Banlieue de la République” (Suburbs of the Republic) found that Seine-Saint-Denis and other Parisian suburbs are becoming “separate Islamic societies” cut off from the French state, and where Islamic Sharia law is rapidly displacing French civil law. The report said that Muslim immigrants are increasingly rejecting French values and instead are immersing themselves in literal violent Islam. The problem of no-go zones is well documented, but multiculturalists and their politically correct supporters vehemently deny that they exist. Some are now engaged in a concerted campaign to discredit and even silence those who draw attention to the issue. A 120-page research paper entitled “No-Go Zones in the French Republic: Myth or Reality?” documented dozens of French neighborhoods “where police and gendarmerie cannot enforce the Republican order or even enter without risking confrontation, projectiles, or even fatal shootings.” In October 2011, a 2,200-page report, “Banlieue de la République” (Suburbs of the Republic) found that Seine-Saint-Denis and other Parisian suburbs are becoming “separate Islamic societies” cut off from the French state and where Islamic Sharia law is rapidly displacing French civil law. The report also showed how the problem is being exacerbated by radical Muslim preachers who are promoting the social marginalization of Muslim immigrants in order to create a parallel Muslim society in France that is ruled by Sharia law. The television presenter asks: “What if we went to the suburbs?” Obertone replies: “I do not recommend this. Not even we French dare go there anymore. But nobody talks about this in public, of course. Nor do those who claim, ‘long live multiculturalism,’ and ‘Paris is wonderful!’ dare enter the suburbs.” Back in 2015, the Mayor of Paris threatened to sue FOX News for reporting on the problem of Muslim NO-GO Zones. As a result, several FOX commentators were forced to issue apologies on the air for claiming after the Charlie Hebdo attack that there are Muslim-ruled “no-go zones” in France. \nc",
		"thread_title": "FRANCE: Police are under siege in Muslim migrant areas in and around Paris, also known as “NO-GO Zones”",
		"title": "FRANCE: Police are under siege in Muslim migrant areas in and around Paris, also known as “NO-GO Zones”",
		"type": "bs",
		"uuid": "035bf73a677dd27abbc585169af2c0a891c433ea"
	},
	"-KhIjgvuOE2edzROTJRP": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T00:19:11.313+03:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "migrants",
				"salience": 0.13063979,
				"type": "PERSON"
			},
			{
				"name": "freeloaders",
				"salience": 0.09230881,
				"type": "PERSON"
			},
			{
				"name": "designer clothes",
				"salience": 0.03765788,
				"type": "OTHER"
			},
			{
				"name": "clothes",
				"salience": 0.035892893,
				"type": "OTHER"
			},
			{
				"name": "designer clothes",
				"salience": 0.034497045,
				"type": "OTHER"
			},
			{
				"name": "Breitbart",
				"salience": 0.030040242,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.027040303,
				"type": "EVENT"
			},
			{
				"name": "meals",
				"salience": 0.027040303,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.02569675,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.024714055,
				"type": "LOCATION"
			},
			{
				"name": "traffic",
				"salience": 0.024436299,
				"type": "OTHER"
			},
			{
				"name": "pasta",
				"salience": 0.024436299,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_pf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venice"
				},
				"name": "Venice",
				"salience": 0.0227834,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "ITALY",
				"salience": 0.022152605,
				"type": "LOCATION"
			},
			{
				"name": "knockoffs",
				"salience": 0.021183075,
				"type": "OTHER"
			},
			{
				"name": "Marcello Orrù",
				"salience": 0.020055676,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.017192038,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03wr6g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Armani"
				},
				"name": "Armani",
				"salience": 0.017052354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/025rywz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hugo_Boss"
				},
				"name": "Hugo Boss",
				"salience": 0.017052354,
				"type": "ORGANIZATION"
			},
			{
				"name": "clothes",
				"salience": 0.016319731,
				"type": "OTHER"
			},
			{
				"name": "Migrants",
				"salience": 0.011940262,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.011496172,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/071cfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Caritas_International"
				},
				"name": "Caritas",
				"salience": 0.011155307,
				"type": "ORGANIZATION"
			},
			{
				"name": "h/t",
				"salience": 0.010853583,
				"type": "PERSON"
			},
			{
				"name": "models",
				"salience": 0.0108392835,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "people",
				"salience": 0.009860694,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.00949346,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04jwp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lord_Byron"
				},
				"name": "Byron",
				"salience": 0.0087018255,
				"type": "LOCATION"
			},
			{
				"name": "protesters",
				"salience": 0.008633077,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.00791838,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.00791838,
				"type": "PERSON"
			},
			{
				"name": "reception centre",
				"salience": 0.007472888,
				"type": "OTHER"
			},
			{
				"name": "clothes",
				"salience": 0.0073165107,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0280hwq"
				},
				"name": "Emma",
				"salience": 0.006688848,
				"type": "WORK_OF_ART"
			},
			{
				"name": "model",
				"salience": 0.0057228873,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.005662787,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.005555547,
				"type": "PERSON"
			},
			{
				"name": "point",
				"salience": 0.0055151274,
				"type": "OTHER"
			},
			{
				"name": "living conditions",
				"salience": 0.0052427407,
				"type": "OTHER"
			},
			{
				"name": "clothes",
				"salience": 0.0050997436,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hotel",
				"salience": 0.0046351245,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.004536565,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.00447582,
				"type": "LOCATION"
			},
			{
				"name": "displeasure",
				"salience": 0.00447582,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.00447582,
				"type": "OTHER"
			},
			{
				"name": "goods",
				"salience": 0.00447582,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "asylum reception systems",
				"salience": 0.00447582,
				"type": "OTHER"
			},
			{
				"name": "hosts",
				"salience": 0.00447582,
				"type": "PERSON"
			},
			{
				"name": "pasta",
				"salience": 0.0036247838,
				"type": "OTHER"
			},
			{
				"name": "traffic",
				"salience": 0.0036247838,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0034895828,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.0032776354,
				"type": "LOCATION"
			},
			{
				"name": "Hotel Byron",
				"salience": 0.0031824282,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0031390907,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.0031390907,
				"type": "WORK_OF_ART"
			},
			{
				"name": "headlines",
				"salience": 0.0031390907,
				"type": "OTHER"
			},
			{
				"name": "meals",
				"salience": 0.0030564845,
				"type": "OTHER"
			},
			{
				"name": "shoes",
				"salience": 0.0030219862,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "dissatisfaction",
				"salience": 0.0030219862,
				"type": "OTHER"
			},
			{
				"name": "hotel",
				"salience": 0.0028278558,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0027559493,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c8wxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholicism"
				},
				"name": "Catholic",
				"salience": 0.0027559493,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lorenzo Chinalleto",
				"salience": 0.0027559493,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italian",
				"salience": 0.0027094053,
				"type": "LOCATION"
			},
			{
				"name": "television",
				"salience": 0.0025744168,
				"type": "OTHER"
			},
			{
				"name": "minors",
				"salience": 0.002562923,
				"type": "PERSON"
			},
			{
				"name": "earthquakes",
				"salience": 0.002562923,
				"type": "EVENT"
			},
			{
				"name": "order",
				"salience": 0.002562923,
				"type": "OTHER"
			},
			{
				"name": "entertainment possibilities",
				"salience": 0.002562923,
				"type": "OTHER"
			},
			{
				"name": "meals",
				"salience": 0.0024488517,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.0024488517,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.0024055294,
				"type": "ORGANIZATION"
			},
			{
				"name": "smartphones",
				"salience": 0.002257794,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "welcome",
				"salience": 0.0021461605,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.0019325154,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.0019325154,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/064lq2w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Il_Gazzettino"
				},
				"name": "Il Gazzettino",
				"salience": 0.0019325154,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06srk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Senegal"
				},
				"name": "Senegal",
				"salience": 0.0019325154,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05cgv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nigeria"
				},
				"name": "Nigeria",
				"salience": 0.0019325154,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04v09",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mali"
				},
				"name": "Mali",
				"salience": 0.0019325154,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/035dk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ghana"
				},
				"name": "Ghana",
				"salience": 0.0019325154,
				"type": "LOCATION"
			},
			{
				"name": "racism",
				"salience": 0.0019147382,
				"type": "OTHER"
			},
			{
				"name": "bus",
				"salience": 0.0019147382,
				"type": "OTHER"
			},
			{
				"name": "lodgings",
				"salience": 0.0019147382,
				"type": "LOCATION"
			},
			{
				"name": "controversy",
				"salience": 0.0019147382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d63b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pirelli"
				},
				"name": "Pirelli",
				"salience": 0.0018603926,
				"type": "ORGANIZATION"
			},
			{
				"name": "migrants",
				"salience": 0.0018447808,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0018447808,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c7l_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cagliari"
				},
				"name": "Cagliari",
				"salience": 0.0017922512,
				"type": "LOCATION"
			},
			{
				"name": "room",
				"salience": 0.0017836897,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0016105112,
				"type": "PERSON"
			},
			{
				"name": "Fondachelli Fantina",
				"salience": 0.0015776852,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01zqgj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Interior_ministry"
				},
				"name": "Interior Ministry",
				"salience": 0.0015776852,
				"type": "ORGANIZATION"
			},
			{
				"name": "hotel",
				"salience": 0.001538807,
				"type": "LOCATION"
			},
			{
				"name": "ticket",
				"salience": 0.001394581,
				"type": "OTHER"
			},
			{
				"name": "ship",
				"salience": 0.001394581,
				"type": "OTHER"
			},
			{
				"name": "masseuse",
				"salience": 0.001394581,
				"type": "PERSON"
			},
			{
				"name": "TV",
				"salience": 0.001394581,
				"type": "OTHER"
			},
			{
				"name": "model iPhones",
				"salience": 0.001394581,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "boys",
				"salience": 0.001394581,
				"type": "PERSON"
			},
			{
				"name": "injustice",
				"salience": 0.001394581,
				"type": "OTHER"
			},
			{
				"name": "xenophobia",
				"salience": 0.001394581,
				"type": "OTHER"
			},
			{
				"name": "room",
				"salience": 0.001332486,
				"type": "LOCATION"
			},
			{
				"name": "television set",
				"salience": 0.0010417702,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "coach",
				"salience": 0.0010417702,
				"type": "PERSON"
			},
			{
				"name": "capital",
				"salience": 0.0010417702,
				"type": "LOCATION"
			},
			{
				"name": "island",
				"salience": 0.0010417702,
				"type": "LOCATION"
			},
			{
				"name": "Tensions",
				"salience": 0.0010417702,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0010417702,
				"type": "OTHER"
			},
			{
				"name": "sticks",
				"salience": 0.0010417702,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06qkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sardinian_language"
				},
				"name": "Sardinian",
				"salience": 0.0008583395,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/078lk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sardinia"
				},
				"name": "Sardinia",
				"salience": 0.0007404646,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/062fl_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sardinian_Action_Party"
				},
				"name": "Sardinian Action Party",
				"salience": 0.0006411598,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/QvthZlRogQk/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T00:19:11.313+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "ITALY: African Muslim illegal alien freeloaders are demanding to have designer clothes and better food African MUSLIM illegal migrants who took the streets in protest and blocked traffic in Venice this week are now demanding real designer clothes (Armani and Hugo Boss), no knockoffs, and say they don’t like having to eat so much pasta in their meals. Breitbart (h/t Emma) Lorenzo Chinalleto, whose cooperative hosts migrants at the Hotel Byron in the Venice province, said migrants respond with displeasure when receiving clothes from Catholic charity Caritas and other charitable bodies, because the goods are unbranded. He explained: “Unfortunately they come to Italy with the asylum reception systems of northern Europe as a model. When they arrived we gave them clothes, standard clothes. “But they want brand-name clothes like Armani and Boss, and they asked for Pirelli shoes. These are their models. When they came to us, they didn’t have clothes, but they all had smartphones,” the Italian added . Forty of the migrants hosted at the Hotel Byron took to the streets to express their dissatisfaction, blocking the traffic. In a video (below) taken outside the hotel on Monday protesters can be seen shouting, in English, that they don’t want to eat pasta. The migrants originate mostly from Senegal, Nigeria, Somalia, Mali and Ghana, Il Gazzettino reported . Migrants frequently hit the headlines in Italy protesting their living conditions in the country, which has recently been hit hard by several earthquakes. In May a group of “unaccompanied minors” launched a violent protest in order to be transferred from Fondachelli Fantina, complaining that there were “too few entertainment possibilities” in the town. After they had completely destroyed the reception centre to the point where it cannot be used again, the Interior Ministry transferred the migrants to a luxury hotel. In June migrants staying in a small town in Sardinia protested for several days demanding better meals, a television set in every room, and a daily coach to take them to the island’s capital, Cagliari. Tensions in the town ran high as the migrants brandished sticks and smashed property. Regional director of the populist Sardinian Action Party, Marcello Orrù, commented on the controversy. He said: “It is intolerable for us to continue to accept these people who don’t like the welcome offered, the meals and their lodgings at the hotel for free. And who then protest to have a television in the room and a daily bus take them to Cagliari for free. “It’s too easy to accuse us of racism and xenophobia, but we refuse to accept this total and grave injustice to the Sardinian people. These boys are muscular and equipped with the latest model iPhones. “I say if they want a TV in the room and maybe even a masseuse, they must be loaded on a ship and sent back to Africa immediately. With a one-way ticket”.",
		"thread_title": "ITALY: African Muslim illegal alien freeloaders are demanding to have designer clothes and better food",
		"title": "ITALY: African Muslim illegal alien freeloaders are demanding to have designer clothes and better food",
		"type": "bs",
		"uuid": "19f15a72f9cd67c5f2915c2cd5dccd4ca6c2c46c"
	},
	"-KhIjh80ooS06uPufJtG": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T05:09:55.812+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0q3_g5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saeed_Abedini"
				},
				"name": "Saeed Abedini",
				"salience": 0.44956362,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.06960725,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.049641147,
				"type": "LOCATION"
			},
			{
				"name": "foreign minister",
				"salience": 0.0392941,
				"type": "PERSON"
			},
			{
				"name": "pastor",
				"salience": 0.0388314,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.03517983,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.031861,
				"type": "PERSON"
			},
			{
				"name": "hostage",
				"salience": 0.03046694,
				"type": "OTHER"
			},
			{
				"name": "aspirant",
				"salience": 0.02642636,
				"type": "OTHER"
			},
			{
				"name": "gratitude",
				"salience": 0.02642636,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.02218259,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.016746657,
				"type": "PERSON"
			},
			{
				"name": "revelation",
				"salience": 0.0135653755,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0090970015,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.0083663715,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.008264638,
				"type": "PERSON"
			},
			{
				"name": "pastor",
				"salience": 0.00761138,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0071594054,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.005993126,
				"type": "OTHER"
			},
			{
				"name": "needs",
				"salience": 0.005600572,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.005600572,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.004736414,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.004367278,
				"type": "LOCATION"
			},
			{
				"name": "post",
				"salience": 0.00392888,
				"type": "WORK_OF_ART"
			},
			{
				"name": "page",
				"salience": 0.00392888,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.00392888,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.00392888,
				"type": "OTHER"
			},
			{
				"name": "chains",
				"salience": 0.0037823925,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/099ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boise,_Idaho"
				},
				"name": "Boise",
				"salience": 0.0034495802,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0034495802,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03s5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idaho"
				},
				"name": "Idaho",
				"salience": 0.0034495802,
				"type": "LOCATION"
			},
			{
				"name": "ideas",
				"salience": 0.003208084,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.003208084,
				"type": "PERSON"
			},
			{
				"name": "contrast",
				"salience": 0.003208084,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.0030653614,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.0027822799,
				"type": "PERSON"
			},
			{
				"name": "hostage",
				"salience": 0.0027679282,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0027679282,
				"type": "OTHER"
			},
			{
				"name": "gift",
				"salience": 0.0024275866,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0024192613,
				"type": "OTHER"
			},
			{
				"name": "mom",
				"salience": 0.002397014,
				"type": "PERSON"
			},
			{
				"name": "wife",
				"salience": 0.002397014,
				"type": "PERSON"
			},
			{
				"name": "sister",
				"salience": 0.002397014,
				"type": "PERSON"
			},
			{
				"name": "daughter",
				"salience": 0.002397014,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christ"
				},
				"name": "Christ",
				"salience": 0.002329003,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0020162708,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0019751862,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.0017460065,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.0017460065,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.0016682828,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.0015063209,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0015063209,
				"type": "OTHER"
			},
			{
				"name": "women's rights",
				"salience": 0.0013043729,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0011745018,
				"type": "PERSON"
			},
			{
				"name": "release",
				"salience": 0.0011490324,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/abedinifamily_25007982_ver1.0_640_480.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T05:09:55.812+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Why Iranian-American pastor held hostage in Iran is voting for Donald Trump Iranian-American Pastor Saeed Abedini is brimming with gratitude for one U.S. presidential aspirant: Donald Trump. Christian Today In a surprising revelation, Abedini said the Republican presidential nominee helped provide for the needs of his family in Boise, Idaho while he was locked up in an Iranian prison for his faith. The pastor said Trump gave his family $10,000 while he was imprisoned for three and a half years. “I am finally free in a free country. Last year on the same day I was sick and in chains for Christ, and now I can vote to choose my next president,” Abedini said in a post on his Facebook page on Sunday. “And most amazingly, I can vote for someone that I know fought for me and called my name so many times. He met my family and gave them a $10,000 gift. I think his ideas are more biblical than the other candidates,” he added. In contrast, Abedini said Democratic presidential nominee Hillary Clinton did not do or say anything to help secure his release from Iranian prison. The pastor said Clinton never spoke his name or met his family. Abedini family As a woman who says she stands for women’s rights when she was foreign minister, she never contacted my mom, wife, sister or my daughter. She never did anything to help when I was in prison as an American pastor who was detained in Iran as a hostage,” he wrote. (Probably because she was too busy figuring out how to get more Iranian Muslims into the country) Last week, Abedini said he already cast an early vote for Trump in the 2016 presidential election.",
		"thread_title": "Why Iranian-American pastor held hostage in Iran is voting for Donald Trump",
		"title": "Why Iranian-American pastor held hostage in Iran is voting for Donald Trump",
		"type": "bs",
		"uuid": "3d08ebf4f4b2cbc5434763a9e25be0aa4b40ec8d"
	},
	"-KhIjhJbK6bKU2cV_R9p": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T05:10:01.148+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "police",
				"salience": 0.1199857,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "MUSLIM",
				"salience": 0.09876125,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.042408142,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.042408142,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.03769009,
				"type": "PERSON"
			},
			{
				"name": "train station",
				"salience": 0.03769009,
				"type": "LOCATION"
			},
			{
				"name": "Hessenschau",
				"salience": 0.034792103,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.03150063,
				"type": "PERSON"
			},
			{
				"name": "knifeman",
				"salience": 0.03150063,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02z0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Frankfurt"
				},
				"name": "Frankfurt",
				"salience": 0.028561397,
				"type": "LOCATION"
			},
			{
				"name": "run",
				"salience": 0.027313273,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0bmj7zm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Frankfurt_Hauptwache_station"
				},
				"name": "Hauptwache Station",
				"salience": 0.023304971,
				"type": "LOCATION"
			},
			{
				"name": "attacker",
				"salience": 0.021798274,
				"type": "PERSON"
			},
			{
				"name": "Daleel",
				"salience": 0.020665891,
				"type": "PERSON"
			},
			{
				"name": "motive",
				"salience": 0.01802578,
				"type": "OTHER"
			},
			{
				"name": "stabbings",
				"salience": 0.01789173,
				"type": "EVENT"
			},
			{
				"name": "UNIDENTIFIED",
				"salience": 0.01468002,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.014004845,
				"type": "OTHER"
			},
			{
				"name": "Ali Sonboly",
				"salience": 0.012501554,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.009007022,
				"type": "EVENT"
			},
			{
				"name": "de l'assaillant du train",
				"salience": 0.008535413,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.00825335,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0077951914,
				"type": "PERSON"
			},
			{
				"name": "Tweeting",
				"salience": 0.006671147,
				"type": "OTHER"
			},
			{
				"name": "David Thomson",
				"salience": 0.00616885,
				"type": "PERSON"
			},
			{
				"name": "dispute",
				"salience": 0.0061053857,
				"type": "EVENT"
			},
			{
				"name": "knife assault",
				"salience": 0.006078157,
				"type": "EVENT"
			},
			{
				"name": "stabbings",
				"salience": 0.005881923,
				"type": "EVENT"
			},
			{
				"name": "rescue workers",
				"salience": 0.0057779765,
				"type": "PERSON"
			},
			{
				"name": "h",
				"salience": 0.0057779765,
				"type": "OTHER"
			},
			{
				"name": "t",
				"salience": 0.0057779765,
				"type": "OTHER"
			},
			{
				"name": "police force",
				"salience": 0.0057779765,
				"type": "ORGANIZATION"
			},
			{
				"name": "colleagues",
				"salience": 0.0057779765,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0057779765,
				"type": "PERSON"
			},
			{
				"name": "hospital",
				"salience": 0.0057779765,
				"type": "LOCATION"
			},
			{
				"name": "passenger train",
				"salience": 0.0056090048,
				"type": "OTHER"
			},
			{
				"name": "station",
				"salience": 0.0056090048,
				"type": "LOCATION"
			},
			{
				"name": "stabbings",
				"salience": 0.005591416,
				"type": "EVENT"
			},
			{
				"name": "Frankfurt Police",
				"salience": 0.0055489647,
				"type": "ORGANIZATION"
			},
			{
				"name": "attack",
				"salience": 0.0054287906,
				"type": "EVENT"
			},
			{
				"name": "station",
				"salience": 0.0053999084,
				"type": "LOCATION"
			},
			{
				"name": "incident",
				"salience": 0.0052483403,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.005189823,
				"type": "ORGANIZATION"
			},
			{
				"name": "incident",
				"salience": 0.005182289,
				"type": "EVENT"
			},
			{
				"name": "passengers",
				"salience": 0.005182289,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0051606256,
				"type": "EVENT"
			},
			{
				"name": "B",
				"salience": 0.0048391954,
				"type": "OTHER"
			},
			{
				"name": "dispute",
				"salience": 0.004679632,
				"type": "EVENT"
			},
			{
				"name": "#Hauptwache",
				"salience": 0.0045500975,
				"type": "LOCATION"
			},
			{
				"name": "video",
				"salience": 0.0045051295,
				"type": "WORK_OF_ART"
			},
			{
				"name": "aftermath",
				"salience": 0.0045051295,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0045051295,
				"type": "PERSON"
			},
			{
				"name": "bloodshed",
				"salience": 0.004263415,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.004231565,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.004231565,
				"type": "EVENT"
			},
			{
				"name": "public",
				"salience": 0.004052738,
				"type": "PERSON"
			},
			{
				"name": "cuts",
				"salience": 0.004052738,
				"type": "OTHER"
			},
			{
				"name": "glass",
				"salience": 0.004052738,
				"type": "OTHER"
			},
			{
				"name": "fight",
				"salience": 0.004052738,
				"type": "EVENT"
			},
			{
				"name": "platform",
				"salience": 0.0039015824,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "Daily Mail",
				"salience": 0.003558179,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.003558179,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0034222894,
				"type": "PERSON"
			},
			{
				"name": "victims",
				"salience": 0.0034091687,
				"type": "PERSON"
			},
			{
				"name": "Riaz Khan Ahmadzai",
				"salience": 0.0033584307,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0033090103,
				"type": "OTHER"
			},
			{
				"name": "string",
				"salience": 0.0033090103,
				"type": "EVENT"
			},
			{
				"name": "population",
				"salience": 0.0033090103,
				"type": "PERSON"
			},
			{
				"name": "pressure",
				"salience": 0.0033090103,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.003226193,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0716dk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hauptwache_(Frankfurt_am_Main)"
				},
				"name": "Hauptwache",
				"salience": 0.003191102,
				"type": "LOCATION"
			},
			{
				"name": "violence",
				"salience": 0.0028962472,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0028091073,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.0025117903,
				"type": "LOCATION"
			},
			{
				"name": "Taunusanlage",
				"salience": 0.0024951985,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0024928972,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0024722484,
				"type": "OTHER"
			},
			{
				"name": "shopping centre",
				"salience": 0.0024722484,
				"type": "LOCATION"
			},
			{
				"name": "rampage",
				"salience": 0.0024722484,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAMIC",
				"salience": 0.002175096,
				"type": "OTHER"
			},
			{
				"name": "MUSLIM immigration policy",
				"salience": 0.0020986698,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0020371056,
				"type": "LOCATION"
			},
			{
				"name": "train",
				"salience": 0.0018623816,
				"type": "OTHER"
			},
			{
				"name": "music festival",
				"salience": 0.0018007052,
				"type": "EVENT"
			},
			{
				"name": "bomb",
				"salience": 0.0018007052,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0018007052,
				"type": "PERSON"
			},
			{
				"name": "screws",
				"salience": 0.0018007052,
				"type": "OTHER"
			},
			{
				"name": "shards",
				"salience": 0.0018007052,
				"type": "OTHER"
			},
			{
				"name": "rucksack",
				"salience": 0.0018007052,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0018007052,
				"type": "PERSON"
			},
			{
				"name": "death",
				"salience": 0.0018007052,
				"type": "EVENT"
			},
			{
				"name": "passengers",
				"salience": 0.0017205348,
				"type": "PERSON"
			},
			{
				"name": "lien",
				"salience": 0.0016687933,
				"type": "OTHER"
			},
			{
				"name": "refugee",
				"salience": 0.0015534782,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.0015218129,
				"type": "LOCATION"
			},
			{
				"name": "@_DavidThomson",
				"salience": 0.0015218129,
				"type": "PERSON"
			},
			{
				"name": "Allemagne pic.twitter.com/AxT7qcBQj0",
				"salience": 0.0015218129,
				"type": "OTHER"
			},
			{
				"name": "Amaq de l",
				"salience": 0.0015218129,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0218w7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unemployment_benefits"
				},
				"name": "EI",
				"salience": 0.0015218129,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02h6_6p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Munich"
				},
				"name": "Munich",
				"salience": 0.0015218129,
				"type": "LOCATION"
			},
			{
				"name": "axe",
				"salience": 0.001345184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03hb5z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reutlingen"
				},
				"name": "Reutlingen",
				"salience": 0.0011083441,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.0008279203,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.0008279203,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghan",
				"salience": 0.0008279203,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01pqfc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/W%C3%BCrzburg"
				},
				"name": "Wurzburg",
				"salience": 0.0008279203,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/39DA979B00000578-3885618-image-a-9_1477764049483.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T05:10:01.148+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "UNIDENTIFIED (MUSLIM?) ‘knifeman’ on the run after stabbing four people at a Frankfurt train station The attack this afternoon occurred at Hauptwache Station and police have said there are four victims. At this stage the motive for the stabbings is not clear. ( It will become crystal clear once you identify the attacker as a Muslim ) UK Daily Mail (h/t larr) The local police force confirmed the attack by Tweeting: ‘There was a knife assault at the #Hauptwache in #Frankfurt. ‘That’s why so many colleagues [police officers] and rescue workers there.’ Frankfurt Police confirmed all four victims were still in hospital. A video of the bloody aftermath was captured on what is understood to be level B of the station. The incident was at 5.30pm local time, according to Hessenschau , who report the stabbings came after a group were quarreling. A dispute had started on one platform and spilled over onto another one. There was more bloodshed in a separate incident at the station, understood to be on a passenger train between Hauptwache and Taunusanlage. A dispute between two passengers broke out into a fight, according to Hessenschau , which led to glass being broken and people suffering cuts. Frankfurt police looked to reassure the public by tweeting: “If we recognized a threat to the local population we would communicate this.” (No, you wouldn’t) The stabbings will still raise fears the attack was ISLAMIC terror-related after a string of incidents across Europe over recent months. Germany has been rocked by ISLAMIC terror attacks this year, heaping pressure on chancellor Angela Merkel’s open-door MUSLIM immigration policy. A bloody week of violence that rocked Germany began on July 18 when Pakistani MUSLIM teenager Riaz Khan Ahmadzai, 17, posing as an Afghan refugee, hacked at passengers on a train in Wurzburg with an axe, wounding five. Four days later, a German-Iranian MUSLIM teenager Ali Sonboly shot nine people dead during a rampage through a shopping centre in Munich before taking his own life. Pour prouver le lien, l'agence Amaq de l' #EI diffuse une video de l'assaillant du train en Allemagne pic.twitter.com/AxT7qcBQj0 \n— David Thomson (@_DavidThomson) July 19, 2016 Two days later a Syrian MUSLIM refugee, 21, hacked a pregnant woman to death in Reutlingen and on the same night Daleel, 27, injured 12 people when he detonated a rucksack packed with metal shards and screws. Daleel carried out the attack on behalf of the ISLAMIC terror group ISIS and had planned to kill hundreds by detonating him bomb at an open-air music festival.",
		"thread_title": "UNIDENTIFIED (MUSLIM?) ‘knifeman’ on the run after stabbing four people at a Frankfurt train station",
		"title": "UNIDENTIFIED (MUSLIM?) ‘knifeman’ on the run after stabbing four people at a Frankfurt train station",
		"type": "bs",
		"uuid": "dc7021bba293bfea93dbe7c1c4eef62f342b4fa9"
	},
	"-KhIjhYAkw-qg41-3TcB": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T05:10:02.633+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.13652664,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.120998256,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.09924094,
				"type": "LOCATION"
			},
			{
				"name": "taxpayer money",
				"salience": 0.03904526,
				"type": "OTHER"
			},
			{
				"name": "invaders",
				"salience": 0.038145706,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.03335592,
				"type": "OTHER"
			},
			{
				"name": "debit cards",
				"salience": 0.031289738,
				"type": "OTHER"
			},
			{
				"name": "debit cards",
				"salience": 0.026917687,
				"type": "OTHER"
			},
			{
				"name": "cash transfers",
				"salience": 0.026150506,
				"type": "OTHER"
			},
			{
				"name": "cash transfers",
				"salience": 0.026150506,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.026150506,
				"type": "OTHER"
			},
			{
				"name": "colonizers",
				"salience": 0.022673843,
				"type": "OTHER"
			},
			{
				"name": "housing",
				"salience": 0.022673843,
				"type": "OTHER"
			},
			{
				"name": "debit cards",
				"salience": 0.019699225,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.017882025,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.01479231,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.014000607,
				"type": "ORGANIZATION"
			},
			{
				"name": "money",
				"salience": 0.013844553,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.013718232,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.013385955,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.012211357,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.009116457,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arabs",
				"salience": 0.009062615,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/047yc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kuwait"
				},
				"name": "Kuwaiti",
				"salience": 0.0082171075,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.008172296,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Northern Syria",
				"salience": 0.0071231695,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.0055206753,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.0055206753,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.005109452,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0050991494,
				"type": "LOCATION"
			},
			{
				"name": "program",
				"salience": 0.004842443,
				"type": "OTHER"
			},
			{
				"name": "country hosts",
				"salience": 0.004795994,
				"type": "PERSON"
			},
			{
				"name": "package",
				"salience": 0.004795994,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.004795994,
				"type": "OTHER"
			},
			{
				"name": "cooperation",
				"salience": 0.004795994,
				"type": "OTHER"
			},
			{
				"name": "Progression",
				"salience": 0.00478151,
				"type": "OTHER"
			},
			{
				"name": "armies",
				"salience": 0.0044163247,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0840f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_Food_Programme"
				},
				"name": "World Food Program",
				"salience": 0.0043608835,
				"type": "ORGANIZATION"
			},
			{
				"name": "Countries",
				"salience": 0.0038016895,
				"type": "ORGANIZATION"
			},
			{
				"name": "family",
				"salience": 0.0037394464,
				"type": "PERSON"
			},
			{
				"name": "Demands",
				"salience": 0.0033639348,
				"type": "OTHER"
			},
			{
				"name": "helicopter drop",
				"salience": 0.0033639348,
				"type": "EVENT"
			},
			{
				"name": "amounts",
				"salience": 0.0033639348,
				"type": "OTHER"
			},
			{
				"name": "sinkhole",
				"salience": 0.0032384668,
				"type": "OTHER"
			},
			{
				"name": "handouts",
				"salience": 0.0032384668,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0032384668,
				"type": "OTHER"
			},
			{
				"name": "family members",
				"salience": 0.0032384668,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.0032384668,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0032384668,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0032175076,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0031715843,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0030554147,
				"type": "LOCATION"
			},
			{
				"name": "budget constraints",
				"salience": 0.003001379,
				"type": "OTHER"
			},
			{
				"name": "ZeroHedge",
				"salience": 0.0029534232,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bs0nv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkish_Red_Crescent"
				},
				"name": "Turkish Red Crescent",
				"salience": 0.0029534232,
				"type": "ORGANIZATION"
			},
			{
				"name": "scheme",
				"salience": 0.0027466,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0027466,
				"type": "OTHER"
			},
			{
				"name": "refugee crisis",
				"salience": 0.0027466,
				"type": "EVENT"
			},
			{
				"name": "problem",
				"salience": 0.0027466,
				"type": "OTHER"
			},
			{
				"name": "media questions",
				"salience": 0.0027466,
				"type": "OTHER"
			},
			{
				"name": "land resources",
				"salience": 0.0027466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0195tf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eurozone"
				},
				"name": "Eurozone",
				"salience": 0.0026487303,
				"type": "LOCATION"
			},
			{
				"name": "building tent cities",
				"salience": 0.0026243732,
				"type": "LOCATION"
			},
			{
				"name": "taxes",
				"salience": 0.0024196513,
				"type": "OTHER"
			},
			{
				"name": "urgency",
				"salience": 0.0024039864,
				"type": "OTHER"
			},
			{
				"name": "economist",
				"salience": 0.002389176,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02l6_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Central_Bank"
				},
				"name": "ECB",
				"salience": 0.0020710977,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0020691876,
				"type": "ORGANIZATION"
			},
			{
				"name": "deserts",
				"salience": 0.0020520482,
				"type": "LOCATION"
			},
			{
				"name": "claws",
				"salience": 0.0020520482,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.0020520482,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0020520482,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0020291337,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0020207046,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08qmn6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_states_of_the_Persian_Gulf"
				},
				"name": "Arab Gulf states",
				"salience": 0.0019207926,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cvmv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabian_Peninsula"
				},
				"name": "Arabia",
				"salience": 0.0018656958,
				"type": "LOCATION"
			},
			{
				"name": "bloc",
				"salience": 0.0018307823,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.001799855,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/024137",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Economic_and_Monetary_Union_of_the_European_Union"
				},
				"name": "EMU",
				"salience": 0.0016908613,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "West",
				"salience": 0.0016908613,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0016908613,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dv0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_League"
				},
				"name": "Arab League",
				"salience": 0.0016277557,
				"type": "ORGANIZATION"
			},
			{
				"name": "action",
				"salience": 0.0014388533,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0012894323,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0012631488,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egypt",
				"salience": 0.0012631488,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.0012631488,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Morocco",
				"salience": 0.0012631488,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0012631488,
				"type": "LOCATION"
			},
			{
				"name": "love",
				"salience": 0.0011165409,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.0010151108,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tw8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sudan"
				},
				"name": "Sudan",
				"salience": 0.00091995584,
				"type": "LOCATION"
			},
			{
				"name": "official",
				"salience": 0.0008774621,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.00068719545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.00068719545,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00068719545,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "UAE",
				"salience": 0.00068719545,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/immigratiA.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T05:10:02.633+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 29 2016 EU using taxpayer money to give Muslim invaders in Turkey free debit cards and cash transfers to keep them out of Europe As many as one million illegal alien Muslim colonizers in Turkey will receive debit cards and monthly cash transfers to help pay for food and housing under a new €348 million ($393 million) humanitarian program from the European Union. ZeroHedge The EU’s largest-ever humanitarian program is part of a €3 billion package of assistance the bloc promised Turkey to support some three million refugees the country hosts, mainly from Syria. The new EU program will be overseen by the World Food Program, in cooperation with the Turkish Red Crescent. Each family’s need will be assessed individually and there are additional funds available for education or supporting elderly family members. Step-by-Step Progression into a sinkhole for the EU More refugees will seek free handouts. Turkey will complain €3 billion is not enough. The refugees will complain €1,000 is not enough. EU citizens will wonder why refugees are getting €1,000 and they are not. Demands for an EU-wide helicopter drop of free debit cards will soar. The amounts demanded will soar. Some economist will propose the debit cards will expire if not used quickly. And then, and then ….Under Eurozone rules the ECB cannot simply print money and give it away. Countries have budget constraints. So, either taxes go up to pay for the scheme, or the EMU rules have to change. Western media are reporting on the Muslim refugee crisis as a humanitarian problem for the West only. But where are the media questions about the huge financial and land resources available in the Arab Gulf states of Saudi Arabia, Qatar, Kuwait, and the UAE? So far, the richest Arab Muslim countries in the Middle East have taken in virtually no Muslim refugees. Liveleak The world is often lectured to about the urgency of respecting Arab and Islamic brotherly love, but where is the Arab action to rescue fellow Muslims and Arabs from the claws of ISIS? Where are the mighty Arab armies who waged dozens of wars against Israel? Why aren’t they fighting ISIS and building tent cities in the vast deserts of Arabia, Egypt, Jordan and the wealthy Gulf States? Where is the wealthy Arab League to coordinate safe cities on Arab land that extends from Morocco to Iraq and from Northern Syria to Sudan? Kuwaiti official explains why Kuwait will NOT take in any Syrian refugees “Kuwait and other oil-rich Muslim countries are too valuable to accept low-class Muslim refugees who we will have to support because they don’t want to work. We don’t want people who are different from us.”",
		"thread_title": "EU using taxpayer money to give Muslim invaders in Turkey free debit cards and cash transfers to keep them out of Europe",
		"title": "EU using taxpayer money to give Muslim invaders in Turkey free debit cards and cash transfers to keep them out of Europe",
		"type": "bs",
		"uuid": "36ef645be05acf218567bf0734d64ad9a7fef1fe"
	},
	"-KhIjhewnKWhBnrkzc3L": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T05:10:03.653+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/QAPgh2V_mGQ/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T05:10:03.653+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "“I’m a Hispanic woman and I am voting for Donald Trump”",
		"title": "“I’m a Hispanic woman and I am voting for Donald Trump”",
		"type": "bs",
		"uuid": "e4973a292f8334dd1e86f76c916b5d6d11e757fa"
	},
	"-KhIjhqbVmStK2U6s_CC": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T05:10:04.452+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.449967,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.06755412,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.060257524,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.040285002,
				"type": "WORK_OF_ART"
			},
			{
				"name": "woman",
				"salience": 0.034805406,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.02235404,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.02235404,
				"type": "PERSON"
			},
			{
				"name": "mob",
				"salience": 0.018683683,
				"type": "PERSON"
			},
			{
				"name": "attorney",
				"salience": 0.016200436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0glqtb_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Cohen_(politician)"
				},
				"name": "Michael Cohen",
				"salience": 0.015968168,
				"type": "PERSON"
			},
			{
				"name": "star",
				"salience": 0.01259577,
				"type": "PERSON"
			},
			{
				"name": "EVP",
				"salience": 0.011458147,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.011041857,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.010774636,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0qjfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood_Walk_of_Fame"
				},
				"name": "Hollywood Walk of Fame",
				"salience": 0.010004519,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black",
				"salience": 0.010004519,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.010004519,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.009050383,
				"type": "ORGANIZATION"
			},
			{
				"name": "woman",
				"salience": 0.0074665844,
				"type": "PERSON"
			},
			{
				"name": "desire",
				"salience": 0.00700379,
				"type": "OTHER"
			},
			{
				"name": "insults",
				"salience": 0.006323896,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0040954887,
				"type": "PERSON"
			},
			{
				"name": "abuse",
				"salience": 0.003957322,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0037209322,
				"type": "PERSON"
			},
			{
				"name": "Videos",
				"salience": 0.0036704277,
				"type": "WORK_OF_ART"
			},
			{
				"name": "banners",
				"salience": 0.0035336285,
				"type": "OTHER"
			},
			{
				"name": "Special Counsel",
				"salience": 0.0034275097,
				"type": "ORGANIZATION"
			},
			{
				"name": "RT",
				"salience": 0.0034275097,
				"type": "LOCATION"
			},
			{
				"name": "ground",
				"salience": 0.0034275097,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0033272784,
				"type": "OTHER"
			},
			{
				"name": "@MichaelCohen212",
				"salience": 0.0032251347,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0031909728,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0031561898,
				"type": "PERSON"
			},
			{
				"name": "videos",
				"salience": 0.0030741564,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0030741564,
				"type": "PERSON"
			},
			{
				"name": "gift",
				"salience": 0.002672472,
				"type": "OTHER"
			},
			{
				"name": "mob",
				"salience": 0.002672472,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0026342713,
				"type": "PERSON"
			},
			{
				"name": "Crazy 4 Trump",
				"salience": 0.0026201832,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "woman",
				"salience": 0.0025960992,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0025960992,
				"type": "PERSON"
			},
			{
				"name": "laugh",
				"salience": 0.0025290886,
				"type": "OTHER"
			},
			{
				"name": "dignity",
				"salience": 0.0024041163,
				"type": "OTHER"
			},
			{
				"name": "compassion",
				"salience": 0.0024041163,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0024041163,
				"type": "OTHER"
			},
			{
				"name": "thugs",
				"salience": 0.0023144514,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0022971595,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ncdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Trump_Organization"
				},
				"name": "Trump Organization",
				"salience": 0.0021107455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0021107455,
				"type": "OTHER"
			},
			{
				"name": "@ClydeStones",
				"salience": 0.0021043664,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0020301358,
				"type": "PERSON"
			},
			{
				"name": "messages",
				"salience": 0.0019629388,
				"type": "OTHER"
			},
			{
				"name": "illegals",
				"salience": 0.0019629388,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0019629388,
				"type": "LOCATION"
			},
			{
				"name": "tents",
				"salience": 0.0019629388,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.0019629388,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0018912501,
				"type": "PERSON"
			},
			{
				"name": "insults",
				"salience": 0.0018755887,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0018755887,
				"type": "PERSON"
			},
			{
				"name": "insults",
				"salience": 0.0018755887,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0018755887,
				"type": "PERSON"
			},
			{
				"name": "gift",
				"salience": 0.0018273689,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f2wj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood"
				},
				"name": "Hollywood",
				"salience": 0.001822374,
				"type": "LOCATION"
			},
			{
				"name": "@realDonaldTrump",
				"salience": 0.0017847287,
				"type": "PERSON"
			},
			{
				"name": "@DiamondandSilk",
				"salience": 0.0017847287,
				"type": "PERSON"
			},
			{
				"name": "abuses",
				"salience": 0.0017816311,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0016722282,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.0016109598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.0014801839,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0014665697,
				"type": "OTHER"
			},
			{
				"name": "hotspot",
				"salience": 0.0014665697,
				"type": "OTHER"
			},
			{
				"name": "preferences",
				"salience": 0.0014665697,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.0013662088,
				"type": "PERSON"
			},
			{
				"name": "banners",
				"salience": 0.0013662088,
				"type": "PERSON"
			},
			{
				"name": "pro-Trump",
				"salience": 0.00120844,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.00120844,
				"type": "PERSON"
			},
			{
				"name": "pieces",
				"salience": 0.0010682055,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0010682055,
				"type": "OTHER"
			},
			{
				"name": "cart",
				"salience": 0.0010682055,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "feet",
				"salience": 0.0010682055,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.0010682055,
				"type": "OTHER"
			},
			{
				"name": "banners",
				"salience": 0.0010206476,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.0009215478,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/035zpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hollywood_Boulevard"
				},
				"name": "Hollywood Boulevard",
				"salience": 0.0009027636,
				"type": "LOCATION"
			},
			{
				"name": "plantation",
				"salience": 0.00087205844,
				"type": "LOCATION"
			},
			{
				"name": "script",
				"salience": 0.0007979854,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bus",
				"salience": 0.0007979854,
				"type": "OTHER"
			},
			{
				"name": "reading",
				"salience": 0.0007979854,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0007979854,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.0007979854,
				"type": "OTHER"
			},
			{
				"name": "asses",
				"salience": 0.00075851695,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.00074895856,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0007395206,
				"type": "OTHER"
			},
			{
				"name": "Clintons",
				"salience": 0.0007254948,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0004911373,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/ApzTgvYwCOw/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T05:10:04.452+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 29 2016 The attorney for Republican presidential candidate Donald Trump is looking for the homeless Black woman seen on video being attacked by a mob of Hillary Clinton supporters as she protected Trump’s star on the Hollywood Walk of Fame after it was sledgehammered by a Clinton supporter earlier this week. Videos of the abuse show people yelling at the woman and knocking her to the ground as the insults continue. RT Michael Cohen, Trump Organization EVP and Special Counsel to Donald J. Trump, spoke out on Twitter Friday evening about Mr. Trump’s desire–before it was known to him that she was attacked by the Clinton mob–to present an unspecified gift to the woman. Cohen said he had a friend in Hollywood looking for her. After learning she had been attacked, Cohen promised she would have “the last laugh on these thugs.” . @ClydeStones she deserves to be treated with dignity and compassion. \n— Michael Cohen (@MichaelCohen212) October 29, 2016 A number of videos titled ‘Crazy 4 Trump’ posted on YouTube show a crowd of people surrounding the woman as she holds up banners in support for the Republican presidential nominee. Her hand-written signs promote pro-Trump messages like “Twenty million illegals and Americans sleep on the streets in tents” and “Donald Trump – keeping it real”. . @DiamondandSilk @realDonaldTrump someone please help me locate this woman as Mr. Trump has a gift for her… \n— Michael Cohen (@MichaelCohen212) October 28, 2016 Some of the banners included provocative language, including one targeting the US president, reading, “Obama threw our black asses under the bus, he owes the Clintons, flip this script (get off the Clinton plantation).” A crowd on Hollywood Boulevard, not a hotspot for Trump supporters, did not share the woman’s political preferences. Nor did they choose to let her be. People are heard yelling insults at the woman, but one man temporarily stops the insults. His words calmed the crowd briefly, but verbal abuses continued as someone started accusing the woman of “spewing” hate. Soon, the situation turned violent, with some physically assaulting the woman and damaging her property. She was knocked off her feet, her cart overturned and her banners torn to pieces.",
		"thread_title": "DONALD TRUMP attorney searching for homeless woman who was attacked by Clinton supporters for guarding Trump’s star on the Hollywood Walk of Fame",
		"title": "DONALD TRUMP attorney searching for homeless woman who was attacked by Clinton supporters for guarding Trump’s star on the Hollywood Walk of Fame",
		"type": "bs",
		"uuid": "79c5926d5513a98783ad643cc02f2a6a9613e1f1"
	},
	"-KhIji0nn9PLzZ-8UOXl": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T05:10:04.824+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "girls",
				"salience": 0.15596987,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.09733852,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedish",
				"salience": 0.085367486,
				"type": "LOCATION"
			},
			{
				"name": "frustration",
				"salience": 0.07450879,
				"type": "OTHER"
			},
			{
				"name": "freeloaders",
				"salience": 0.06262115,
				"type": "PERSON"
			},
			{
				"name": "activities",
				"salience": 0.04980166,
				"type": "OTHER"
			},
			{
				"name": "illegals",
				"salience": 0.03922866,
				"type": "PERSON"
			},
			{
				"name": "cars",
				"salience": 0.033913653,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Activities Coordinator",
				"salience": 0.029410595,
				"type": "PERSON"
			},
			{
				"name": "alien invaders",
				"salience": 0.029410595,
				"type": "PERSON"
			},
			{
				"name": "space",
				"salience": 0.029410595,
				"type": "OTHER"
			},
			{
				"name": "government dole",
				"salience": 0.029410595,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.02496251,
				"type": "PERSON"
			},
			{
				"name": "activities",
				"salience": 0.009705955,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03zx_5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/V%C3%A4ster%C3%A5s"
				},
				"name": "Vasteras",
				"salience": 0.00896364,
				"type": "LOCATION"
			},
			{
				"name": "shortage",
				"salience": 0.007855396,
				"type": "OTHER"
			},
			{
				"name": "HELP WANTED",
				"salience": 0.00752909,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.00718951,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0068817064,
				"type": "PERSON"
			},
			{
				"name": "hell",
				"salience": 0.006620675,
				"type": "OTHER"
			},
			{
				"name": "submitter",
				"salience": 0.006415448,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.006378414,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.006227167,
				"type": "WORK_OF_ART"
			},
			{
				"name": "editor",
				"salience": 0.006227167,
				"type": "PERSON"
			},
			{
				"name": "newspaper",
				"salience": 0.006227167,
				"type": "ORGANIZATION"
			},
			{
				"name": "die",
				"salience": 0.006032213,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.0057343217,
				"type": "PERSON"
			},
			{
				"name": "phenomenon",
				"salience": 0.0054175616,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0054175616,
				"type": "PERSON"
			},
			{
				"name": "Friatider",
				"salience": 0.004940979,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0048590107,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004560825,
				"type": "PERSON"
			},
			{
				"name": "Skallberget",
				"salience": 0.0044283965,
				"type": "LOCATION"
			},
			{
				"name": "race",
				"salience": 0.0043681157,
				"type": "EVENT"
			},
			{
				"name": "age",
				"salience": 0.0043681157,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.0043681157,
				"type": "PERSON"
			},
			{
				"name": "ethnicity",
				"salience": 0.0043681157,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0043681157,
				"type": "LOCATION"
			},
			{
				"name": "racism",
				"salience": 0.0043681157,
				"type": "OTHER"
			},
			{
				"name": "car fires",
				"salience": 0.004205223,
				"type": "EVENT"
			},
			{
				"name": "series",
				"salience": 0.004205223,
				"type": "EVENT"
			},
			{
				"name": "activities",
				"salience": 0.0041563567,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0041563567,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.0039647976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gjd0kj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vestmanlands_L%C3%A4ns_Tidning"
				},
				"name": "VLT",
				"salience": 0.0038351486,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.003566621,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.003566621,
				"type": "LOCATION"
			},
			{
				"name": "wall",
				"salience": 0.003566621,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.003566621,
				"type": "OTHER"
			},
			{
				"name": "loved ones",
				"salience": 0.003566621,
				"type": "PERSON"
			},
			{
				"name": "value",
				"salience": 0.003566621,
				"type": "OTHER"
			},
			{
				"name": "fellowship",
				"salience": 0.003433582,
				"type": "OTHER"
			},
			{
				"name": "shortage",
				"salience": 0.003362664,
				"type": "OTHER"
			},
			{
				"name": "potential",
				"salience": 0.0031421164,
				"type": "OTHER"
			},
			{
				"name": "Submitters",
				"salience": 0.003077212,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.003077212,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.002865506,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0028419395,
				"type": "OTHER"
			},
			{
				"name": "responses",
				"salience": 0.002664808,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0019657784,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.0019530485,
				"type": "OTHER"
			},
			{
				"name": "signature",
				"salience": 0.0019410129,
				"type": "OTHER"
			},
			{
				"name": "v",
				"salience": 0.0019410129,
				"type": "OTHER"
			},
			{
				"name": "car owners",
				"salience": 0.0019410129,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.0019410129,
				"type": "OTHER"
			},
			{
				"name": "pity",
				"salience": 0.0019410129,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0019410129,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.0019410129,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0019410129,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0019410129,
				"type": "OTHER"
			},
			{
				"name": "reasoning",
				"salience": 0.0019410129,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0018546019,
				"type": "PERSON"
			},
			{
				"name": "objectives",
				"salience": 0.0016745395,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0016745395,
				"type": "OTHER"
			},
			{
				"name": "cars",
				"salience": 0.0016745395,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "environment",
				"salience": 0.0015846173,
				"type": "OTHER"
			},
			{
				"name": "football field",
				"salience": 0.0014500257,
				"type": "LOCATION"
			},
			{
				"name": "Skallberget''.",
				"salience": 0.0011947383,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/muslim-spitting-on-swedish-woman-james-wood-tweet.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T02:04:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "SWEDEN HELP WANTED: Activities Coordinator for bored illegal alien Muslim freeloaders and rapists Muslim illegal alien invaders taking up space in Sweden and living off the government dole, say they are vandalizing and burning cars (not to mention gang-raping Swedish girls) because they do not have enough “activities” to keep them busy. Friatider “It is clear as hell that we take out our frustration by destroying and vandalizing when we have a shortage of activities here,” one of the illegals living in Skallberget in Vasteras writes in a letter to the editor in the local newspaper VLT. Vasteras has recently been subjected to a long series of car fires. The submitter tries the young man, who wishes to remain anonymous, explain what the phenomenon is due. He writes that he came to Sweden when he was young and admittedly had “good potential” but that he was subject to persistent “racism” by the authorities. (What “race” is Islam?) “Already at an early age became a man treated differently. Sometimes it was because of ethnicity, sometimes because they were at a certain place, and sometimes just to those very people who were in power felt to fuck with us. So many times I had been propped up against the wall and strip-searched in front of my loved ones. It really depressed me and my value, “he writes. The man writes that the young people in the area feel “oppressed” and that they are burning cars to “get the environment to react and listen.” Among other things, he complains that the objectives of the local football field does not have a network and that it is not organized enough “activities” for young people. “In short, it is clear as hell that we take out our frustration by destroying and vandalizing when we have a shortage of activities here. There is neither good fellowship, activities and things / objects we can make use of.” Submitters have received several responses from readers who are critical of the reasoning. “It’s just a matter of time before someone of obtained or ‘the others’ die if this continues. No pity you – all just hate you more and more,” writes , for example, the signature “Former car owners on Skallberget”. \nv",
		"thread_title": "SWEDEN HELP WANTED: Activities Coordinator for bored illegal alien Muslim freeloaders and rapists",
		"title": "SWEDEN HELP WANTED: Activities Coordinator for bored illegal alien Muslim freeloaders and rapists",
		"type": "bs",
		"uuid": "9175c4026e3427941a780a8a33a1e86aa05e670d"
	},
	"-KhIjiAYdYUZ2nh9gLY9": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T22:55:45.454+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Sadiq Mohammad",
				"salience": 0.5038702,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.27560207,
				"type": "PERSON"
			},
			{
				"name": "CALIFORNIA Creepy Clown",
				"salience": 0.06984822,
				"type": "ORGANIZATION"
			},
			{
				"name": "kid playing basketball",
				"salience": 0.020861391,
				"type": "PERSON"
			},
			{
				"name": "get-up",
				"salience": 0.012871124,
				"type": "OTHER"
			},
			{
				"name": "drive-thru",
				"salience": 0.009756771,
				"type": "EVENT"
			},
			{
				"name": "clown craze",
				"salience": 0.0093946755,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.0093946755,
				"type": "PERSON"
			},
			{
				"name": "ball",
				"salience": 0.00927697,
				"type": "OTHER"
			},
			{
				"name": "Guns.com",
				"salience": 0.0085715335,
				"type": "OTHER"
			},
			{
				"name": "Gary F",
				"salience": 0.0085715335,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bushes",
				"salience": 0.007973822,
				"type": "OTHER"
			},
			{
				"name": "clown garb",
				"salience": 0.007973822,
				"type": "OTHER"
			},
			{
				"name": "bajeezus",
				"salience": 0.0059638033,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0059638033,
				"type": "PERSON"
			},
			{
				"name": "clown suit",
				"salience": 0.0059638033,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09cg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Taco_Bell"
				},
				"name": "Taco Bell",
				"salience": 0.005795074,
				"type": "ORGANIZATION"
			},
			{
				"name": "exchange",
				"salience": 0.0043475595,
				"type": "EVENT"
			},
			{
				"name": "handgun",
				"salience": 0.0043475595,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "head",
				"salience": 0.0043475595,
				"type": "OTHER"
			},
			{
				"name": "victim",
				"salience": 0.0037826907,
				"type": "PERSON"
			},
			{
				"name": "scare",
				"salience": 0.0032496531,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04s9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_in_Islam"
				},
				"name": "Muhammad",
				"salience": 0.002271699,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/ri_22hmNtKA/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T22:55:45.454+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "CALIFORNIA Creepy Clown is a Muslim who nearly gets himself killed DAMN! “Nearly” doesn’t count. Guns.com (h/t Gary F) This week, Sadiq Mohammad thought he’d get in on the creepy clown craze – spooking employees at a Taco Bell drive-thru, creeping out a kid playing basketball, who incidentally threw the ball at him. But when he jumped out of some bushes – wearing his clown garb get-up – Mohammad was the one who got the biggest scare. The innocent victim didn’t take lightly to having the bajeezus scared out of him by a man in a clown suit and, after a brief verbal exchange, pulled out a handgun and knocked Muhammad in the head.",
		"thread_title": "CALIFORNIA Creepy Clown is a Muslim who nearly gets himself killed",
		"title": "CALIFORNIA Creepy Clown is a Muslim who nearly gets himself killed",
		"type": "bs",
		"uuid": "deba2ec29bc1ccf6cc52b582c07dd07c6cc7f8bd"
	},
	"-KhIjiO098s15_WIVwBH": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T22:55:45.636+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "son",
				"salience": 0.23370649,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.10988373,
				"type": "PERSON"
			},
			{
				"name": "mosque",
				"salience": 0.05514569,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.03260997,
				"type": "OTHER"
			},
			{
				"name": "Parents",
				"salience": 0.030729767,
				"type": "PERSON"
			},
			{
				"name": "mosque",
				"salience": 0.030729767,
				"type": "OTHER"
			},
			{
				"name": "field trip",
				"salience": 0.027319398,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.026862515,
				"type": "LOCATION"
			},
			{
				"name": "son",
				"salience": 0.025697479,
				"type": "PERSON"
			},
			{
				"name": "trial",
				"salience": 0.02284226,
				"type": "EVENT"
			},
			{
				"name": "fine",
				"salience": 0.02284226,
				"type": "OTHER"
			},
			{
				"name": "teenager",
				"salience": 0.02284226,
				"type": "PERSON"
			},
			{
				"name": "Alexander Heumann",
				"salience": 0.02230395,
				"type": "PERSON"
			},
			{
				"name": "truancy",
				"salience": 0.01981128,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0181574,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.01794817,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "GERMAN",
				"salience": 0.014124039,
				"type": "LOCATION"
			},
			{
				"name": "parents",
				"salience": 0.014032401,
				"type": "PERSON"
			},
			{
				"name": "mosque",
				"salience": 0.012769626,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03cqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gestapo"
				},
				"name": "GESTAPO",
				"salience": 0.012242069,
				"type": "ORGANIZATION"
			},
			{
				"name": "BNI",
				"salience": 0.012242069,
				"type": "ORGANIZATION"
			},
			{
				"name": "school field trip",
				"salience": 0.011339917,
				"type": "EVENT"
			},
			{
				"name": "Others",
				"salience": 0.008359015,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.0082034385,
				"type": "PERSON"
			},
			{
				"name": "indoctrination",
				"salience": 0.0082034385,
				"type": "OTHER"
			},
			{
				"name": "mosques",
				"salience": 0.005691599,
				"type": "OTHER"
			},
			{
				"name": "trip",
				"salience": 0.005450561,
				"type": "EVENT"
			},
			{
				"name": "idea",
				"salience": 0.0051387884,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0050568124,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00494087,
				"type": "ORGANIZATION"
			},
			{
				"name": "story",
				"salience": 0.004845363,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mosque",
				"salience": 0.00459017,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.0043461532,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.0041968846,
				"type": "LOCATION"
			},
			{
				"name": "student",
				"salience": 0.0041968846,
				"type": "PERSON"
			},
			{
				"name": "Peter Mueller-Rakow",
				"salience": 0.0041261604,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.003922369,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.003922369,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.0037207296,
				"type": "PERSON"
			},
			{
				"name": "geography class",
				"salience": 0.0036240458,
				"type": "OTHER"
			},
			{
				"name": "geography classes",
				"salience": 0.0036240458,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.003549252,
				"type": "PERSON"
			},
			{
				"name": "teen",
				"salience": 0.003399337,
				"type": "PERSON"
			},
			{
				"name": "school trip",
				"salience": 0.003327069,
				"type": "EVENT"
			},
			{
				"name": "authorities",
				"salience": 0.003272614,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.0032314297,
				"type": "OTHER"
			},
			{
				"name": "participant",
				"salience": 0.0031627254,
				"type": "PERSON"
			},
			{
				"name": "priority",
				"salience": 0.0030196088,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0029440755,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0029440755,
				"type": "WORK_OF_ART"
			},
			{
				"name": "flat",
				"salience": 0.0029440755,
				"type": "LOCATION"
			},
			{
				"name": "class teacher",
				"salience": 0.0029440755,
				"type": "PERSON"
			},
			{
				"name": "image",
				"salience": 0.0029440755,
				"type": "WORK_OF_ART"
			},
			{
				"name": "regime",
				"salience": 0.0029440755,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0028342977,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0028342977,
				"type": "OTHER"
			},
			{
				"name": "user tweeting",
				"salience": 0.0028342977,
				"type": "WORK_OF_ART"
			},
			{
				"name": "parents",
				"salience": 0.002801365,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.0027757783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08cgw1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norddeutscher_Rundfunk"
				},
				"name": "NDR",
				"salience": 0.0026869578,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dkz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RT_(TV_network)"
				},
				"name": "RT",
				"salience": 0.002584891,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0n1l2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rendsburg"
				},
				"name": "Rendsburg",
				"salience": 0.002584891,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.002403918,
				"type": "PERSON"
			},
			{
				"name": "safety",
				"salience": 0.002403918,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.002403918,
				"type": "OTHER"
			},
			{
				"name": "motives",
				"salience": 0.002403918,
				"type": "OTHER"
			},
			{
				"name": "lawyer",
				"salience": 0.002074077,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.002074077,
				"type": "WORK_OF_ART"
			},
			{
				"name": "movement",
				"salience": 0.002074077,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.0020408172,
				"type": "PERSON"
			},
			{
				"name": "fine",
				"salience": 0.0018505012,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01f9sl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/F%C3%BChrer"
				},
				"name": "Fuhrer",
				"salience": 0.0018127997,
				"type": "PERSON"
			},
			{
				"name": "branch",
				"salience": 0.0017961287,
				"type": "LOCATION"
			},
			{
				"name": "education authority",
				"salience": 0.001510819,
				"type": "ORGANIZATION"
			},
			{
				"name": "court trial",
				"salience": 0.001510819,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0014800326,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012g432k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pegida"
				},
				"name": "Dugida",
				"salience": 0.0014559127,
				"type": "OTHER"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam_in_Europe"
				},
				"name": "Islamization of Europe",
				"salience": 0.001354354,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0013531046,
				"type": "ORGANIZATION"
			},
			{
				"name": "total",
				"salience": 0.0013082993,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0013082993,
				"type": "OTHER"
			},
			{
				"name": "Pax Europa' movement",
				"salience": 0.0012768693,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0012500582,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0012500582,
				"type": "ORGANIZATION"
			},
			{
				"name": "couple",
				"salience": 0.0011286952,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hf7l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/D%C3%BCsseldorf"
				},
				"name": "Dusseldorf",
				"salience": 0.0011056907,
				"type": "LOCATION"
			},
			{
				"name": "will",
				"salience": 0.0009773704,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0009773704,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.0009773704,
				"type": "OTHER"
			},
			{
				"name": "Arthur Dent",
				"salience": 0.00083652884,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rfdxh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alternative_for_Germany"
				},
				"name": "Alternative for Germany",
				"salience": 0.0006947235,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/mosque-visit.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T22:55:45.636+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 30 2016 GERMAN ‘GESTAPO’ considers prosecuting parents who refused to allow their son to go on a field trip to mosque Parents of a German teenager may face a trial for refusing to pay ‘truancy’ fine after refusing to allow their son to go to a local mosque on a school field trip out of fear that it would lead to his indoctrination by Muslim leaders. RT The story broke in mid-June, when parents of a 13-year-old student opposed the idea of their son visiting a mosque in the northern German town of Rendsburg, reportedly organized as part of a geography class. “What a trip to the mosque has to do with geography classes?” Arthur Dent asked. Others compared the authorities’ actions to the darkest part of German history, with one user tweeting: “Visiting mosques is a top priority under our regime, similar to having a Fuhrer’s image in everyone’s flat.” In a letter to the class teacher quoted by the NDR, the teen’s father argued that his son would be “indoctrinated” in the mosque. He went on to say that “for years we have been hearing reports about religiously-motivated violence connected with Islamic people.” The parents’ lawyer, Alexander Heumann, argues that they refused the school trip out of fear for their son’s “bodily safety.” Denying any faith-based motives, he emphasized that the couple do not belong to any religious group, and are of the opinion that “nobody shall be forced into a sacred place against his good will.” Heumann himself, however, is a former member of the Alternative for Germany party, an anti-immigrant political group, and was a participant in setting up the ‘Dugida,’ a Dusseldorf-based branch of the far-right PEGIDA movement. According to the NDR report, the parents met the lawyer through the ‘Pax Europa’ movement, a civic group which opposes the perceived “Islamization of Europe.” A local education authority subsequently fined the couple a total of €300 ($328). When the parents opposed the fine, their case was forwarded to Peter Mueller-Rakow, a local prosecutor, who will decide whether or not to proceed with a court trial.",
		"thread_title": "GERMAN ‘GESTAPO’ considers prosecuting parents who refused to allow their son to go on a field trip to mosque",
		"title": "GERMAN ‘GESTAPO’ considers prosecuting parents who refused to allow their son to go on a field trip to mosque",
		"type": "bs",
		"uuid": "492acf4fe6bc72034fe6a392eec29bb3c3cd6c83"
	},
	"-KhIjifgIr6L7uhjLiV1": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-30T22:55:46.390+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.29609615,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.06279444,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighbors",
				"salience": 0.05301485,
				"type": "PERSON"
			},
			{
				"name": "safety",
				"salience": 0.037320707,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0488g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas"
				},
				"name": "State of Kansas",
				"salience": 0.037080534,
				"type": "LOCATION"
			},
			{
				"name": "mailer",
				"salience": 0.035656646,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state",
				"salience": 0.026813459,
				"type": "LOCATION"
			},
			{
				"name": "Joseph Scapa",
				"salience": 0.02279095,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0207656,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.018585844,
				"type": "OTHER"
			},
			{
				"name": "Clay Barker",
				"salience": 0.016530735,
				"type": "PERSON"
			},
			{
				"name": "law enforcement officers",
				"salience": 0.0131746605,
				"type": "PERSON"
			},
			{
				"name": "Robert McCraw",
				"salience": 0.0126693845,
				"type": "PERSON"
			},
			{
				"name": "values",
				"salience": 0.012399455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c0llt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Guantanamo_Bay_detention_camp"
				},
				"name": "Guantanamo",
				"salience": 0.012366585,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07qrvnn"
				},
				"name": "Mailer",
				"salience": 0.012197061,
				"type": "WORK_OF_ART"
			},
			{
				"name": "message",
				"salience": 0.010925304,
				"type": "OTHER"
			},
			{
				"name": "mailers",
				"salience": 0.010128081,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state",
				"salience": 0.009866157,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.008984603,
				"type": "PERSON"
			},
			{
				"name": "issue",
				"salience": 0.0073679686,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.007035873,
				"type": "PERSON"
			},
			{
				"name": "neighbors",
				"salience": 0.00650133,
				"type": "PERSON"
			},
			{
				"name": "The State of Kansas",
				"salience": 0.0060100406,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.0058715027,
				"type": "EVENT"
			},
			{
				"name": "explosions",
				"salience": 0.0058715027,
				"type": "EVENT"
			},
			{
				"name": "machine gun",
				"salience": 0.0058453367,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ideologies",
				"salience": 0.005764234,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0056610033,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0202ny",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sam_Brownback"
				},
				"name": "Sam Brownback",
				"salience": 0.005543144,
				"type": "PERSON"
			},
			{
				"name": "homes",
				"salience": 0.0050857766,
				"type": "LOCATION"
			},
			{
				"name": "races",
				"salience": 0.0050857766,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.0050857766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05387d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas_Republican_Party"
				},
				"name": "Kansas Republican Party",
				"salience": 0.005083395,
				"type": "ORGANIZATION"
			},
			{
				"name": "mailers",
				"salience": 0.0047428953,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.0046292455,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.004558501,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "Council on American-Islamic Relations",
				"salience": 0.0041466397,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0040705213,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0tbql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wichita,_Kansas"
				},
				"name": "Wichita",
				"salience": 0.0040054116,
				"type": "LOCATION"
			},
			{
				"name": "mailers",
				"salience": 0.0038731524,
				"type": "WORK_OF_ART"
			},
			{
				"name": "issues",
				"salience": 0.0037599748,
				"type": "OTHER"
			},
			{
				"name": "mailer",
				"salience": 0.0036354999,
				"type": "WORK_OF_ART"
			},
			{
				"name": "John T. Booker, Jr.",
				"salience": 0.003485988,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0034152744,
				"type": "LOCATION"
			},
			{
				"name": "article",
				"salience": 0.0034124956,
				"type": "WORK_OF_ART"
			},
			{
				"name": "example",
				"salience": 0.0031627459,
				"type": "OTHER"
			},
			{
				"name": "House District 88",
				"salience": 0.0031324963,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04fcd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wichita_Eagle"
				},
				"name": "Wichita Eagle",
				"salience": 0.0031324963,
				"type": "ORGANIZATION"
			},
			{
				"name": "fighter",
				"salience": 0.0030783685,
				"type": "PERSON"
			},
			{
				"name": "soldiers",
				"salience": 0.0029131982,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0029005343,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0028551163,
				"type": "LOCATION"
			},
			{
				"name": "threats",
				"salience": 0.002679771,
				"type": "OTHER"
			},
			{
				"name": "state party",
				"salience": 0.0026013542,
				"type": "ORGANIZATION"
			},
			{
				"name": "mailers",
				"salience": 0.0025823459,
				"type": "WORK_OF_ART"
			},
			{
				"name": "parts",
				"salience": 0.0025043201,
				"type": "LOCATION"
			},
			{
				"name": "ideologies",
				"salience": 0.0024675087,
				"type": "OTHER"
			},
			{
				"name": "resolutions",
				"salience": 0.0024396603,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00241974,
				"type": "OTHER"
			},
			{
				"name": "mailers",
				"salience": 0.0023932834,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mailers",
				"salience": 0.0023932834,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mailer",
				"salience": 0.0023777918,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "United States Constitution",
				"salience": 0.0023721561,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Elizabeth Bishop",
				"salience": 0.0022373681,
				"type": "PERSON"
			},
			{
				"name": "focus",
				"salience": 0.0020954716,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0020954716,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0020954716,
				"type": "OTHER"
			},
			{
				"name": "polling",
				"salience": 0.0020954716,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.0020954716,
				"type": "OTHER"
			},
			{
				"name": "terror groups",
				"salience": 0.0020341363,
				"type": "ORGANIZATION"
			},
			{
				"name": "security issue",
				"salience": 0.0019582408,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.0019582408,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0018475163,
				"type": "ORGANIZATION"
			},
			{
				"name": "transfer",
				"salience": 0.0017998002,
				"type": "EVENT"
			},
			{
				"name": "violence",
				"salience": 0.0016968416,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0016607303,
				"type": "PERSON"
			},
			{
				"name": "justices",
				"salience": 0.001633521,
				"type": "PERSON"
			},
			{
				"name": "Robert Carey",
				"salience": 0.0016297312,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0015823119,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.0015506992,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0015342617,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.0015222045,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.0014881288,
				"type": "PERSON"
			},
			{
				"name": "flier",
				"salience": 0.0014693814,
				"type": "OTHER"
			},
			{
				"name": "scare mongering tactics",
				"salience": 0.0014693814,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0014693814,
				"type": "PERSON"
			},
			{
				"name": "incitement",
				"salience": 0.0014693814,
				"type": "OTHER"
			},
			{
				"name": "detainees",
				"salience": 0.0014693814,
				"type": "PERSON"
			},
			{
				"name": "government affairs",
				"salience": 0.0014145433,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0014145433,
				"type": "OTHER"
			},
			{
				"name": "knuckleheads",
				"salience": 0.0014145433,
				"type": "PERSON"
			},
			{
				"name": "assassinations",
				"salience": 0.0014145433,
				"type": "EVENT"
			},
			{
				"name": "terrorist attack",
				"salience": 0.0013853122,
				"type": "EVENT"
			},
			{
				"name": "Rep.",
				"salience": 0.0013853122,
				"type": "PERSON"
			},
			{
				"name": "justices",
				"salience": 0.0013853122,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0013853122,
				"type": "OTHER"
			},
			{
				"name": "ideologies",
				"salience": 0.0013428169,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0011995886,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0011995886,
				"type": "OTHER"
			},
			{
				"name": "variations",
				"salience": 0.0011995886,
				"type": "OTHER"
			},
			{
				"name": "participation",
				"salience": 0.0011557552,
				"type": "OTHER"
			},
			{
				"name": "Kansas Barker",
				"salience": 0.0010906268,
				"type": "PERSON"
			},
			{
				"name": "explosion",
				"salience": 0.0010750146,
				"type": "EVENT"
			},
			{
				"name": "fact",
				"salience": 0.0010498835,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0010348873,
				"type": "LOCATION"
			},
			{
				"name": "mailer",
				"salience": 0.00097294076,
				"type": "WORK_OF_ART"
			},
			{
				"name": "refugees",
				"salience": 0.00096404477,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mpq3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fort_Leavenworth"
				},
				"name": "Fort Leavenworth",
				"salience": 0.0009044462,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, D.C.",
				"salience": 0.0009044462,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c3b0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Legislature"
				},
				"name": "Legislature",
				"salience": 0.0009044462,
				"type": "ORGANIZATION"
			},
			{
				"name": "resettlement",
				"salience": 0.00090361165,
				"type": "OTHER"
			},
			{
				"name": "animosity",
				"salience": 0.00089612405,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.00089612405,
				"type": "OTHER"
			},
			{
				"name": "mail campaign",
				"salience": 0.00089612405,
				"type": "EVENT"
			},
			{
				"name": "military base",
				"salience": 0.00089612405,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.00089612405,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0008706831,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0008706831,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0t6qk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Garden_City,_Kansas"
				},
				"name": "Garden City",
				"salience": 0.0008706831,
				"type": "LOCATION"
			},
			{
				"name": "parts",
				"salience": 0.00086337485,
				"type": "LOCATION"
			},
			{
				"name": "Scapa",
				"salience": 0.0007636406,
				"type": "ORGANIZATION"
			},
			{
				"name": "safety",
				"salience": 0.00075371057,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.00075371057,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0286jt6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas_Supreme_Court"
				},
				"name": "Kansas Supreme Court",
				"salience": 0.0007383449,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0tbql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wichita,_Kansas"
				},
				"name": "Wichita",
				"salience": 0.00070546474,
				"type": "LOCATION"
			},
			{
				"name": "administration",
				"salience": 0.00068660086,
				"type": "ORGANIZATION"
			},
			{
				"name": "action",
				"salience": 0.00065263733,
				"type": "OTHER"
			},
			{
				"name": "refugee resettlement grants",
				"salience": 0.00065263733,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00065263733,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.00063695246,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.00063695246,
				"type": "PERSON"
			},
			{
				"name": "security threat",
				"salience": 0.00062357285,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00062357285,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005630115,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0005630115,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00055153255,
				"type": "PERSON"
			},
			{
				"name": "security interests",
				"salience": 0.00050641317,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.0004875053,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Office of Refugee Resettlement",
				"salience": 0.00046387012,
				"type": "ORGANIZATION"
			},
			{
				"name": "dictates",
				"salience": 0.00045178065,
				"type": "OTHER"
			},
			{
				"name": "Refugee Resettlement Program State Plan",
				"salience": 0.0004016574,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/GOP-mailer-2.jpeg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-30T22:55:46.390+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "KANSAS: Republican Mailer asks voters “Have you met the new neighbors?” (your ‘Muslim terrorist’ neighbors) The Kansas Republican Party is sending out mailers in legislative races around the state depicting ISIS fighters and explosions from MUSLIM terrorist attacks. A mailer going to homes in east Wichita’s House District 88 shows an ISIS fighter holding a machine gun with a message that reads: “Have you met the new neighbors?” Wichita Eagle The other side of the mailer touts Republican Rep. Joseph Scapa’s support for funding to train Kansas law enforcement officers to “recognize and deal with foreign and domestic threats to our state, from those who support ideologies that are in conflict with the U.S. Constitution and our Kansas values.” Clay Barker, executive director of the Kansas Republican Party, said similar mailers are being sent out around the state. “We did polling and focus groups, and the one issue that got overwhelming positive response and was associated with Republicans was safety,” Barker said. “You know, Gitmo, that article that came out back in August that ISIS had named soldiers for assassinations, police being shot and those knuckleheads in Garden City, it all kind of added up to a security issue … the whole feeling that’s there violence out there. And it’s a positive issue for Republicans.” The Republican mailer specifically depicts ISIS, the Islamic terror group that controls parts of Syria and Iraq. Robert McCraw, director of government affairs for the designated terrorist group CAIR (Council on American-Islamic Relations) in Washington, D.C., called the mailers “a shameful example of scare mongering tactics that I hope the Republican Party can learn to move away from.” He said it was appalling for the state party “to falsely insinuate that the state’s Muslim population is linked to terror groups like ISIS.” “This flier verges on incitement of violence to Muslims.” The Republican-controlled Legislature has passed resolutions opposing the possible transfer of Guantanamo detainees to Fort Leavenworth. Barker said there are several variations of the mailers. One depicts an explosion from a terrorist attack. “It’s one of the few (issues) that was a clear, like high 80 percent positive and associated with Republicans,” Barker said. It’s not only Republicans who don’t want Gitmo terrorists in Kansas Barker also said the party is sending out mailers highlighting Republicans’ support for ousting four of the sitting Kansas Supreme Court justices, portraying Democrats who support retaining the justices as soft on crime. Rep. Joseph Scapa, who said he saw the mailer before it was sent out, focused his comments about the mailer more on Muslim refugees, who he says pose a potential security threat. “We have people coming into our state from parts of the world who believe in ideologies that are incompatible with the United States Constitution and our Kansas values and that poses a threat,” Scapa said. “We know for a fact that we cannot vet the people that are coming into our state from other parts of the world … where they believe in ideologies that we don’t.” 20-year-old Kansas Muslim convert John T. Booker, Jr., could face life in prison for allegedly plotting to bomb a U.S. military base. Scapa’s opponent, Democrat Elizabeth Bishop, criticized the mail campaign, saying the mailers could contribute to animosity toward Muslims in Wichita. (One can only hope) Led by Republican Governor Sam Brownback the state of Kansas informed the Obama administration this week that it is defying its dictates for Kansas to cooperate in the resettlement of refugees from Syria. In a letter to Robert Carey, director of the Office of Refugee Resettlement, Brownback wrote, “The State of Kansas hereby withdraws its Refugee Resettlement Program State Plan and terminates its participation in all federal refugee resettlement grants and programs, effective at the earliest possible date.” Hopefully, they are the last Brownback added that he was taking his action to “protect the safety and security interests of the State of Kansas.”",
		"thread_title": "KANSAS: Republican Mailer asks voters “Have you met the new neighbors?” (your ‘Muslim terrorist’ neighbors)",
		"title": "KANSAS: Republican Mailer asks voters “Have you met the new neighbors?” (your ‘Muslim terrorist’ neighbors)",
		"type": "bs",
		"uuid": "3d6f358e1d0640fdf9d02715ea1c880204fe2a6e"
	},
	"-KhIjis0QUgiJmneWN5-": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T03:38:50.449+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/ngZ70KqVV6w/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T03:38:50.449+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "MILO to college students: “Hey liberals, Muslims hate everyone…especially you”",
		"title": "MILO to college students: “Hey liberals, Muslims hate everyone…especially you”",
		"type": "bs",
		"uuid": "9c6f9c9f2ba6764fa82f4e55d4cb43b2292f7b20"
	},
	"-KhIjizfFFIkrdZa2T1E": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T04:21:42.575+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.22483885,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "GREECE",
				"salience": 0.19341452,
				"type": "LOCATION"
			},
			{
				"name": "invaders",
				"salience": 0.15668657,
				"type": "PERSON"
			},
			{
				"name": "fire",
				"salience": 0.05639198,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.050096318,
				"type": "EVENT"
			},
			{
				"name": "island",
				"salience": 0.04203083,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t6b4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lesbos"
				},
				"name": "Lesbos",
				"salience": 0.022711307,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.022711307,
				"type": "OTHER"
			},
			{
				"name": "freeloaders",
				"salience": 0.020621073,
				"type": "PERSON"
			},
			{
				"name": "neither",
				"salience": 0.019614918,
				"type": "PERSON"
			},
			{
				"name": "asylum-seekers",
				"salience": 0.016361207,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.016255032,
				"type": "LOCATION"
			},
			{
				"name": "fire",
				"salience": 0.016123675,
				"type": "OTHER"
			},
			{
				"name": "illegals",
				"salience": 0.013211584,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01261jzq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Asylum_Support_Office"
				},
				"name": "European Asylum Support Office",
				"salience": 0.010589085,
				"type": "ORGANIZATION"
			},
			{
				"name": "delays",
				"salience": 0.010338902,
				"type": "OTHER"
			},
			{
				"name": "asylum claims",
				"salience": 0.010338902,
				"type": "OTHER"
			},
			{
				"name": "facilities",
				"salience": 0.010338902,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0162b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bangladesh"
				},
				"name": "Bangladesh",
				"salience": 0.009433934,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistan",
				"salience": 0.009433934,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.0062153353,
				"type": "LOCATION"
			},
			{
				"name": "parasites",
				"salience": 0.00589651,
				"type": "OTHER"
			},
			{
				"name": "bout",
				"salience": 0.0055015073,
				"type": "EVENT"
			},
			{
				"name": "blankets",
				"salience": 0.0055015073,
				"type": "OTHER"
			},
			{
				"name": "rocks",
				"salience": 0.0052302955,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.004647542,
				"type": "LOCATION"
			},
			{
				"name": "containers",
				"salience": 0.0044940286,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01jfjz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Euronews"
				},
				"name": "EuroNews",
				"salience": 0.0039143385,
				"type": "ORGANIZATION"
			},
			{
				"name": "spokesman",
				"salience": 0.0039102817,
				"type": "PERSON"
			},
			{
				"name": "islands",
				"salience": 0.0038784049,
				"type": "LOCATION"
			},
			{
				"name": "number",
				"salience": 0.0031137017,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018t8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mytilene"
				},
				"name": "Moria",
				"salience": 0.0027688625,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.002731505,
				"type": "EVENT"
			},
			{
				"name": "protesters",
				"salience": 0.0018291958,
				"type": "PERSON"
			},
			{
				"name": "petrol bombs",
				"salience": 0.0018291958,
				"type": "OTHER"
			},
			{
				"name": "interviews",
				"salience": 0.0018291958,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.0018291958,
				"type": "OTHER"
			},
			{
				"name": "Riots",
				"salience": 0.0018291958,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0015073647,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/EXxebLYZk9o/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T04:21:42.575+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "GREECE: Illegal alien Muslim invaders set fire to their camp on island of Lesbos Apparently, the Islamic freeloaders, mainly from Pakistan and Bangladesh (neither of which is a war-torn country), are upset over delays in processing their asylum claims, so they set fire to facilities used by the European Asylum Support Office (EASO). EuroNews A bout 70 Muslim illegals threw rocks and burning blankets at containers inside the Moria camp, damaging a number of them. A spokesman for EASO said protesters had hurled petrol bombs while interviews with Muslim asylum-seekers were taking place. Riots have broken out before among Muslim asylum seekers with more than 15,000 living in overcrowded camps on Greek islands close to Turkey. (Send the Muslim parasites back where they came from. Then close the camp)",
		"thread_title": "GREECE: Illegal alien Muslim invaders set fire to their camp on island of Lesbos",
		"title": "GREECE: Illegal alien Muslim invaders set fire to their camp on island of Lesbos",
		"type": "bs",
		"uuid": "542bc4a3d2f7608044c00de65f9397dd93764e0a"
	},
	"-KhIjjAzuy69UZ1SuxIf": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T14:32:04.459+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.20390473,
				"type": "OTHER"
			},
			{
				"name": "supremacists",
				"salience": 0.0913275,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01l8ql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adhan"
				},
				"name": "Adhan",
				"salience": 0.08519281,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.069767006,
				"type": "OTHER"
			},
			{
				"name": "Prayer",
				"salience": 0.045613427,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.04281847,
				"type": "EVENT"
			},
			{
				"name": "MUSLIMS",
				"salience": 0.03962467,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.033958156,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.03367527,
				"type": "PERSON"
			},
			{
				"name": "non-Muslims",
				"salience": 0.031120554,
				"type": "PERSON"
			},
			{
				"name": "noise pollution",
				"salience": 0.031120554,
				"type": "OTHER"
			},
			{
				"name": "The Islamic Call to Prayer",
				"salience": 0.024618313,
				"type": "WORK_OF_ART"
			},
			{
				"name": "residents",
				"salience": 0.022765344,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "United Kingdom",
				"salience": 0.020399978,
				"type": "LOCATION"
			},
			{
				"name": "BNI",
				"salience": 0.019274117,
				"type": "ORGANIZATION"
			},
			{
				"name": "Prayer",
				"salience": 0.019041311,
				"type": "OTHER"
			},
			{
				"name": "mosque amplifiers",
				"salience": 0.012931296,
				"type": "OTHER"
			},
			{
				"name": "visitors",
				"salience": 0.012931296,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0120891435,
				"type": "OTHER"
			},
			{
				"name": "unbelievers",
				"salience": 0.011184574,
				"type": "PERSON"
			},
			{
				"name": "faith",
				"salience": 0.009735323,
				"type": "OTHER"
			},
			{
				"name": "EVERYDAY",
				"salience": 0.008746143,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.008157957,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0070415665,
				"type": "PERSON"
			},
			{
				"name": "prayer",
				"salience": 0.006603659,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.0061908923,
				"type": "OTHER"
			},
			{
				"name": "inferiors",
				"salience": 0.006062589,
				"type": "OTHER"
			},
			{
				"name": "UK Express",
				"salience": 0.005157442,
				"type": "ORGANIZATION"
			},
			{
				"name": "respect",
				"salience": 0.004788655,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0045364294,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.004423041,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.003925794,
				"type": "OTHER"
			},
			{
				"name": "customs",
				"salience": 0.0037959705,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0037959705,
				"type": "PERSON"
			},
			{
				"name": "areas",
				"salience": 0.0037959705,
				"type": "LOCATION"
			},
			{
				"name": "Government",
				"salience": 0.0032754515,
				"type": "ORGANIZATION"
			},
			{
				"name": "response",
				"salience": 0.0032754515,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.003153335,
				"type": "ORGANIZATION"
			},
			{
				"name": "population",
				"salience": 0.003099757,
				"type": "PERSON"
			},
			{
				"name": "authority",
				"salience": 0.0028367434,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighbourhood towns",
				"salience": 0.0028367434,
				"type": "LOCATION"
			},
			{
				"name": "h",
				"salience": 0.0027562943,
				"type": "LOCATION"
			},
			{
				"name": "Rob E",
				"salience": 0.0027562943,
				"type": "PERSON"
			},
			{
				"name": "call",
				"salience": 0.0024083422,
				"type": "OTHER"
			},
			{
				"name": "prayer",
				"salience": 0.0022801654,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0021373315,
				"type": "EVENT"
			},
			{
				"name": "contribution",
				"salience": 0.0020665857,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0020665857,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.0020665857,
				"type": "EVENT"
			},
			{
				"name": "terrorism",
				"salience": 0.0020665857,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0020665857,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0020665857,
				"type": "OTHER"
			},
			{
				"name": "Officials",
				"salience": 0.0017976611,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00178298,
				"type": "PERSON"
			},
			{
				"name": "religion",
				"salience": 0.0015440052,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0015440052,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/c3CaIuO-e1451297122837.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T14:32:04.459+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 31 2016 UK MUSLIMS want to subject non-Muslims to the noise pollution of the amplified ‘Islamic Call to Prayer’ several times a day If Muslim supremacists get their way, British residents and visitors will be forced to endure the eardrum-shattering, highly offensive Islamic Call to Prayer (‘Adhan’) being blasted from mosque amplifiers – so it can be heard for miles around – at least three times a day, EVERYDAY! UK Express (h/t Rob E) A petition to allow the Islamic call for prayer has been signed by more than 25,000 Muslims. Those behind the petition say: “The Islamic Call to Prayer, is an integral part of the Muslim faith ” which actually means unbelievers are my inferiors and I have no respect for their country, customs, and its citizens. The petition says: “I believe it is the right time to experiment and allow highly Muslim populated areas with a loud call for prayer at least three times a day, not during anti-social hours.” “The number of people practicing the religion of Islam in the United Kingdom exceeds three million. “Some neighbourhood towns have more than 50% Muslim population.” The Government’s official response to the petition has advised people to speak to their local authority about public calls to worship. Officials said: “The Government recognizes the unique contribution (to violence, rape, and terrorism) that Muslims make to their own local communities and to wider society.”",
		"thread_title": "UK MUSLIMS want to subject non-Muslims to the noise pollution of the amplified ‘Islamic Call to Prayer’ several times a day",
		"title": "UK MUSLIMS want to subject non-Muslims to the noise pollution of the amplified ‘Islamic Call to Prayer’ several times a day",
		"type": "bs",
		"uuid": "123d6a6750659c2856ce4eee23cf79d06bf4d977"
	},
	"-KhIjjGpy_BhroGFgOxl": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T14:32:04.619+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "BNI",
				"salience": 0.285194,
				"type": "ORGANIZATION"
			},
			{
				"name": "WELCOME",
				"salience": 0.10926566,
				"type": "OTHER"
			},
			{
				"name": "tour buses",
				"salience": 0.10926566,
				"type": "OTHER"
			},
			{
				"name": "jungle' camp",
				"salience": 0.09061936,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "PARIS",
				"salience": 0.0670472,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.05894375,
				"type": "OTHER"
			},
			{
				"name": "tent cities",
				"salience": 0.05343539,
				"type": "LOCATION"
			},
			{
				"name": "streets",
				"salience": 0.03637206,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.032773998,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.03254277,
				"type": "LOCATION"
			},
			{
				"name": "invaders",
				"salience": 0.026832782,
				"type": "PERSON"
			},
			{
				"name": "tent cities",
				"salience": 0.022614615,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.020294342,
				"type": "LOCATION"
			},
			{
				"name": "tourism",
				"salience": 0.013848514,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0126790535,
				"type": "LOCATION"
			},
			{
				"name": "hit",
				"salience": 0.008012972,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.0075222906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.004635576,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03slzg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Away_goals_rule"
				},
				"name": "Â",
				"salience": 0.004635576,
				"type": "OTHER"
			},
			{
				"name": "Gee",
				"salience": 0.0034644087,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/v4AWhkKjUHQ/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T14:32:04.619+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 31 2016 WELCOME TO PARIS where tour buses have to navigate around all the new Muslim tent cities filling the streets Now that France has shut down the filthy Calais ‘jungle’ camp where thousands of illegal alien Muslim invaders had been squatting, Muslim tent cities are sprouting up all over the streets of Paris. Gee, I guess French tourism hasn’t taken a big enough hit yet, following several Islamic terrorist attacks.Â",
		"thread_title": "WELCOME TO PARIS where tour buses have to navigate around all the new Muslim tent cities filling the streets",
		"title": "WELCOME TO PARIS where tour buses have to navigate around all the new Muslim tent cities filling the streets",
		"type": "bs",
		"uuid": "d4969f613d0cd30d7a4a7a5db5f067c54576636c"
	},
	"-KhIjjW9cB3Sa7nzhv-c": {
		"author": "",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T22:08:22.714+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/011jqh96",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tess_Holliday"
				},
				"name": "Tess Holliday",
				"salience": 0.11662077,
				"type": "PERSON"
			},
			{
				"name": "pig",
				"salience": 0.09408769,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0695067,
				"type": "OTHER"
			},
			{
				"name": "T-shirt",
				"salience": 0.06641715,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "women",
				"salience": 0.054884195,
				"type": "PERSON"
			},
			{
				"name": "platform",
				"salience": 0.048364703,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.04467168,
				"type": "WORK_OF_ART"
			},
			{
				"name": "model",
				"salience": 0.04467168,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07qdr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Times_Square"
				},
				"name": "Times Square",
				"salience": 0.043922864,
				"type": "LOCATION"
			},
			{
				"name": "treatment",
				"salience": 0.03237359,
				"type": "OTHER"
			},
			{
				"name": "Dump Trump",
				"salience": 0.02945589,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.026203092,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.019991627,
				"type": "ORGANIZATION"
			},
			{
				"name": "Respect Women #Dump Trump",
				"salience": 0.017950328,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.014374123,
				"type": "PERSON"
			},
			{
				"name": "shirt",
				"salience": 0.014158954,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.013513181,
				"type": "PERSON"
			},
			{
				"name": "T-shirt",
				"salience": 0.013206126,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "someone",
				"salience": 0.011288698,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0glpjll",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Instagram"
				},
				"name": "Instagram",
				"salience": 0.00985948,
				"type": "OTHER"
			},
			{
				"name": "photo",
				"salience": 0.00790754,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Women",
				"salience": 0.007883666,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.007883666,
				"type": "PERSON"
			},
			{
				"name": "Respect Women",
				"salience": 0.0071903616,
				"type": "PERSON"
			},
			{
				"name": "hips",
				"salience": 0.0068488503,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0068488503,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0068488503,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bodies",
				"salience": 0.0068488503,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.006687239,
				"type": "PERSON"
			},
			{
				"name": "sexual assault story",
				"salience": 0.0060612303,
				"type": "OTHER"
			},
			{
				"name": "objects",
				"salience": 0.0060341903,
				"type": "OTHER"
			},
			{
				"name": "step",
				"salience": 0.0059582465,
				"type": "OTHER"
			},
			{
				"name": "pollution",
				"salience": 0.0055222083,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0055222083,
				"type": "OTHER"
			},
			{
				"name": "consumption",
				"salience": 0.0053401156,
				"type": "OTHER"
			},
			{
				"name": "consent",
				"salience": 0.0053401156,
				"type": "OTHER"
			},
			{
				"name": "pig",
				"salience": 0.005015852,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004917223,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0048038834,
				"type": "PERSON"
			},
			{
				"name": "ad",
				"salience": 0.0046247137,
				"type": "WORK_OF_ART"
			},
			{
				"name": "problem",
				"salience": 0.0046247137,
				"type": "OTHER"
			},
			{
				"name": "cupcake",
				"salience": 0.0046247137,
				"type": "OTHER"
			},
			{
				"name": "UK Daily Mail",
				"salience": 0.0042176666,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0041675596,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0039223186,
				"type": "LOCATION"
			},
			{
				"name": "model",
				"salience": 0.0035737322,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0030828936,
				"type": "OTHER"
			},
			{
				"name": "New Look Fashion",
				"salience": 0.0029576775,
				"type": "WORK_OF_ART"
			},
			{
				"name": "endorsement",
				"salience": 0.0029304735,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0029304735,
				"type": "WORK_OF_ART"
			},
			{
				"name": "costumes",
				"salience": 0.0029304735,
				"type": "OTHER"
			},
			{
				"name": "film",
				"salience": 0.0029304735,
				"type": "WORK_OF_ART"
			},
			{
				"name": "stuff",
				"salience": 0.0027504934,
				"type": "OTHER"
			},
			{
				"name": "dress",
				"salience": 0.0025815591,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.0024649156,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0024649156,
				"type": "PERSON"
			},
			{
				"name": "weight",
				"salience": 0.0024649156,
				"type": "OTHER"
			},
			{
				"name": "appearance",
				"salience": 0.0024229935,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.0024146808,
				"type": "LOCATION"
			},
			{
				"name": "model",
				"salience": 0.002207573,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.0021344654,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0021344654,
				"type": "WORK_OF_ART"
			},
			{
				"name": "messages",
				"salience": 0.0021344654,
				"type": "WORK_OF_ART"
			},
			{
				"name": "woman",
				"salience": 0.0020810186,
				"type": "PERSON"
			},
			{
				"name": "throwback photo",
				"salience": 0.001841416,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0018038816,
				"type": "ORGANIZATION"
			},
			{
				"name": "Miss",
				"salience": 0.0015945155,
				"type": "PERSON"
			},
			{
				"name": "husband",
				"salience": 0.0015945155,
				"type": "PERSON"
			},
			{
				"name": "celebration",
				"salience": 0.0015945155,
				"type": "OTHER"
			},
			{
				"name": "Gee",
				"salience": 0.0015104492,
				"type": "PERSON"
			},
			{
				"name": "Orange is the New Black star",
				"salience": 0.001449666,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Iskra Lawrence",
				"salience": 0.0009813776,
				"type": "PERSON"
			},
			{
				"name": "Refinery29",
				"salience": 0.0009813776,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0yp7bm9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Danielle_Brooks"
				},
				"name": "Danielle Brooks",
				"salience": 0.0009813776,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01qxc7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Beetlejuice"
				},
				"name": "Beetlejuice",
				"salience": 0.0009813776,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jgd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Argentina"
				},
				"name": "Argentina",
				"salience": 0.0009813776,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05d3rvc"
				},
				"name": "Nick",
				"salience": 0.0009813776,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lq2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Halloween"
				},
				"name": "Halloween",
				"salience": 0.0009813776,
				"type": "EVENT"
			},
			{
				"name": "Every Beautiful Body Symposium",
				"salience": 0.0009813776,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/39E9DE3B00000578-3890046-image-m-2_1477926572326.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-31T22:08:22.714+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0.822",
		"text": "BNI Store Oct 31 2016 “He is a pig,” says morbidly obese and tattooed “model” while wearing a ‘Dump Trump’ T-shirt in Times Square Tess Holliday is using her platform as a jumbo-sized so-called “model” to speak out against Donald Trump’s treatment of women. The 31-year-old took to Instagram to share a photo of herself posed with her hands on her mega hips wearing the ‘Respect Women #Dump Trump’ shirt. ( Hey, why wasn’t she arrested for causing visual pollution in Times Square? ) UK Daily Mail ‘Respect Women,’ she captioned the image. ‘Our bodies are not for you to stare at or touch without our consent. Women are not just sexual objects, women are not here for your consumption. (One problem you don’t have, cupcake) The 31-year-old took to Instagram over the weekend to share an ad of herself posing in New York City’s Times Square while modeling a New Look Fashion T-shirt that reads: ‘Respect Women #Dump Trump.’ So many of us have a sexual assault story, myself included,’ she continued. (Gee, were you 100 pounds lighter then?) ‘To endorse someone who not just condones this behavior but actively engages in it would be an awful step backwards for women not just in the US but across the world. ‘Also might I add I’m NOT telling you who to vote for. Trump is a pig & that’s a fact.’ (But obviously, you are supporting a pig – Hillary Clinton – who has verbally abused all the women who were sexually assaulted/raped by her husband) Last week Tess made an appearance (above left) alongside model Iskra Lawrence and Orange is the New Black star Danielle Brooks at Refinery29’s Every Beautiful Body Symposium in New York City, wearing a figure-hugging dress. In celebration of Halloween, Tess also posted a throwback photo of her and Nick dressed as Miss Argentina and Beetlejuice from the 1988 film. ‘But how do I top last year?’ she wrote. We pulled these costumes off in two days, and I’m pretty darn proud.’ There was also a fierce debate about whether or not Tess’ post could be seen as an endorsement for the Democratic nominee, Hillary Clinton, and some people who disagreed with her statement attacked the size 22 model for her weight. ‘There is some super hateful stuff on here,’ one woman wrote. ‘And targeting her weight because you disagree? Really? People are crazy, keep up your positive messages Tess! Whatever your political views are, I still love what you represent!’ ",
		"thread_title": "“He is a pig,” says morbidly obese and tattooed “model” while wearing a ‘Dump Trump’ T-shirt in Times Square – BARE NAKED ISLAM",
		"title": "“He is a pig,” says morbidly obese and tattooed “model” while wearing a ‘Dump Trump’ T-shirt in Times Square – BARE NAKED ISLAM",
		"type": "bs",
		"uuid": "8e7b2416fb336912256dbeb90df4660e477ca2b5"
	},
	"-KhIjjh73sZ7wwJzGPSI": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T22:36:44.927+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "terrorists",
				"salience": 0.26734972,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.094971314,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.08621091,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.03841822,
				"type": "PERSON"
			},
			{
				"name": "store",
				"salience": 0.033612497,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.032252178,
				"type": "PERSON"
			},
			{
				"name": "customers",
				"salience": 0.025281133,
				"type": "PERSON"
			},
			{
				"name": "advertisement",
				"salience": 0.020920763,
				"type": "WORK_OF_ART"
			},
			{
				"name": "customers",
				"salience": 0.02067344,
				"type": "PERSON"
			},
			{
				"name": "parlance",
				"salience": 0.019805243,
				"type": "LOCATION"
			},
			{
				"name": "Omar Mateen",
				"salience": 0.01975193,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/034qg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Firearm"
				},
				"name": "GUN STORE",
				"salience": 0.019274583,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "PENNSYLVANIA",
				"salience": 0.018892135,
				"type": "LOCATION"
			},
			{
				"name": "ALTRA FIREARMS",
				"salience": 0.018017784,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Paul Chandler",
				"salience": 0.017181752,
				"type": "PERSON"
			},
			{
				"name": "Supporters",
				"salience": 0.0165643,
				"type": "PERSON"
			},
			{
				"name": "sign",
				"salience": 0.010340445,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.009664501,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.009198222,
				"type": "PERSON"
			},
			{
				"name": "Altra",
				"salience": 0.007994713,
				"type": "ORGANIZATION"
			},
			{
				"name": "gun store",
				"salience": 0.0078919465,
				"type": "LOCATION"
			},
			{
				"name": "Â TalkingPointsMemo Â The â",
				"salience": 0.006811151,
				"type": "ORGANIZATION"
			},
			{
				"name": "store",
				"salience": 0.006780341,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "Council on American-Islamic Relations",
				"salience": 0.0064307135,
				"type": "ORGANIZATION"
			},
			{
				"name": "Firearms",
				"salience": 0.00617786,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bunker",
				"salience": 0.005529345,
				"type": "OTHER"
			},
			{
				"name": "store advertising",
				"salience": 0.0048319986,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0046203514,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.004449468,
				"type": "PERSON"
			},
			{
				"name": "heâ",
				"salience": 0.004184864,
				"type": "OTHER"
			},
			{
				"name": "readers",
				"salience": 0.004184864,
				"type": "PERSON"
			},
			{
				"name": "sales",
				"salience": 0.004184864,
				"type": "OTHER"
			},
			{
				"name": "papers",
				"salience": 0.004184864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "front",
				"salience": 0.004184864,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0041722218,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.004119707,
				"type": "EVENT"
			},
			{
				"name": "Crusades.Â",
				"salience": 0.0039018681,
				"type": "OTHER"
			},
			{
				"name": "Firearmsâ",
				"salience": 0.0038051007,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Altra Firearms",
				"salience": 0.0038051007,
				"type": "ORGANIZATION"
			},
			{
				"name": "Theyâ",
				"salience": 0.0033891574,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0033891574,
				"type": "LOCATION"
			},
			{
				"name": "wouldnâ t",
				"salience": 0.0033170665,
				"type": "LOCATION"
			},
			{
				"name": "Theyâ",
				"salience": 0.003262746,
				"type": "OTHER"
			},
			{
				"name": "itâ",
				"salience": 0.003207285,
				"type": "OTHER"
			},
			{
				"name": "Satan",
				"salience": 0.0031270243,
				"type": "PERSON"
			},
			{
				"name": "blanket ban",
				"salience": 0.0030487694,
				"type": "OTHER"
			},
			{
				"name": "infidel",
				"salience": 0.00293504,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.00293504,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00293504,
				"type": "ORGANIZATION"
			},
			{
				"name": "expansion",
				"salience": 0.00293504,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.00293504,
				"type": "OTHER"
			},
			{
				"name": "television",
				"salience": 0.0028255482,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0028255482,
				"type": "OTHER"
			},
			{
				"name": "phone interview",
				"salience": 0.0028255482,
				"type": "EVENT"
			},
			{
				"name": "letters",
				"salience": 0.0028255482,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.002767183,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.002767183,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.002767183,
				"type": "PERSON"
			},
			{
				"name": "Jackson Center",
				"salience": 0.0025768061,
				"type": "LOCATION"
			},
			{
				"name": "t",
				"salience": 0.002478378,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0024688742,
				"type": "OTHER"
			},
			{
				"name": "gun store ad",
				"salience": 0.0023963281,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0023283293,
				"type": "LOCATION"
			},
			{
				"name": "customers",
				"salience": 0.0022896724,
				"type": "PERSON"
			},
			{
				"name": "abortion clinic",
				"salience": 0.0022896724,
				"type": "LOCATION"
			},
			{
				"name": "store",
				"salience": 0.002224052,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04bdtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Talking_Points_Memo"
				},
				"name": "TPM",
				"salience": 0.0021593685,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0020144791,
				"type": "LOCATION"
			},
			{
				"name": "hundreds",
				"salience": 0.0019564198,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0018069011,
				"type": "LOCATION"
			},
			{
				"name": "t",
				"salience": 0.0018052342,
				"type": "OTHER"
			},
			{
				"name": "bombings",
				"salience": 0.0017902794,
				"type": "EVENT"
			},
			{
				"name": "series",
				"salience": 0.0017902794,
				"type": "EVENT"
			},
			{
				"name": "preachers",
				"salience": 0.0017902794,
				"type": "PERSON"
			},
			{
				"name": "niggers",
				"salience": 0.0017902794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranian",
				"salience": 0.0017394666,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.0016757547,
				"type": "OTHER"
			},
			{
				"name": "store",
				"salience": 0.0016615456,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.0015935017,
				"type": "PERSON"
			},
			{
				"name": "clerics",
				"salience": 0.001518232,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ply0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orlando,_Florida"
				},
				"name": "Orlando",
				"salience": 0.0014751363,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hn10",
					"wikipedia_url": "http://en.wikipedia.org/wiki/LGBT"
				},
				"name": "LGBT",
				"salience": 0.0014751363,
				"type": "OTHER"
			},
			{
				"name": "Â Chandler",
				"salience": 0.0014157821,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.001415737,
				"type": "PERSON"
			},
			{
				"name": "service",
				"salience": 0.0013434266,
				"type": "OTHER"
			},
			{
				"name": "GUN SUPPLY",
				"salience": 0.0013129798,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0013039344,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0012458756,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/032rk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gun"
				},
				"name": "gun.",
				"salience": 0.0011019652,
				"type": "OTHER"
			},
			{
				"name": "bumper sticker",
				"salience": 0.0009740567,
				"type": "WORK_OF_ART"
			},
			{
				"name": "car",
				"salience": 0.0009740567,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09wjyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/TV_One_(New_Zealand)"
				},
				"name": "one.",
				"salience": 0.0008025491,
				"type": "OTHER"
			},
			{
				"name": "Free Zone",
				"salience": 0.0008025491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.00076680846,
				"type": "LOCATION"
			},
			{
				"name": "pic.twitter.com/yPqAsd5MsO",
				"salience": 0.000599486,
				"type": "OTHER"
			},
			{
				"name": "Dorey Scheimer",
				"salience": 0.000599486,
				"type": "PERSON"
			},
			{
				"name": "@DoreyScheimer",
				"salience": 0.000599486,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/maxresdefault-12-e14381947727741.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T22:36:44.927+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.2,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "PENNSYLVANIA GUN STORE tells customers “Muslims and Hillary supporters are not welcome” An advertisement for ALTRA FIREARMS warns potential customers that Muslims and supporters of Hillary Clinton, who are “terrorists” in the store’s parlance, are not welcome. âPlease NO Muslims or Hillary Supporters â We do not feel safe selling to terrorists!â Altra Firearms in Jackson Center, Pennsylvania advertised in local papers this week.Â TalkingPointsMemo Â The âPolitically Incorrect Firearmsâ store also invited readers to âVisit our underground bunker and speak with our unique and deplorable sales associates.â Altra Firearms’ owner Paul Chandler, 54, told TPM Friday that heâs had a sign in front of his store advertising that supporters of President Obama arenât welcome to come inside, either. âWe did have, in three-foot letters, âNo radical Muslims,â but I changed that to âNo Muslims,â period,â Chandler said in a phone interview, noting rhetoric from Iranian television motivated the change. âTheyâre saying that America is the great Satan and itâs got to be destroyed. Theyâre basically teaching that if itâs an infidel, either they convert or kill them. And thatâs what theyâre doing in our country now,â he said, comparing the actions of modern Islamic nations to the expansion of Muslim influence into Europe before the Crusades.Â âIf the gun store in Florida wouldnât have sold to that man, thereâs be 40 or 50 more people alive,â he continued, referring to Omar Mateen, who killed 49 people in Orlando when he opened fire in an LGBT nightclub.Â PA gun store ad: \"please no Muslims or Hillary supporters. We do not feel safe selling to terrorists\" pic.twitter.com/yPqAsd5MsO \n— Dorey Scheimer (@DoreyScheimer) October 27, 2016 Chandler told TPM he’s never actually denied service to any Muslims or Clinton supporters, although he said he’d told one woman with an Obama bumper sticker on her car that the store was closed. He also said he’d denied service to one man who told him âI hate niggers, I want a gun.âÂ Chandler said he didnât extend the same blanket ban to potential Christian customers after a series of abortion clinic bombings years ago because âhundreds of Christian preachers got up and said âthat is wrong.â” âDo you hear any Muslim clerics condemning what is going on today?â he asked. âI havenât heard one.â In 2015, designated terrorist group CAIR (Council on American-Islamic Relations) sued a different store in Florida ( FLORIDA GUN SUPPLY ) which declared itself a ‘Muslim Free Zone’ but the case was dismissed.",
		"thread_title": "PENNSYLVANIA GUN STORE tells customers “Muslims and Hillary supporters are not welcome”",
		"title": "PENNSYLVANIA GUN STORE tells customers “Muslims and Hillary supporters are not welcome”",
		"type": "bs",
		"uuid": "dc404d5c7b066fd9ee91a4e647ecaabd4740e74c"
	},
	"-KhIjjtqsbHSxXWY-6kk": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-31T22:36:49.421+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Liberals",
				"salience": 0.19574511,
				"type": "PERSON"
			},
			{
				"name": "welfare",
				"salience": 0.11492697,
				"type": "OTHER"
			},
			{
				"name": "taxpayers",
				"salience": 0.10959128,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.109351136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.096754044,
				"type": "LOCATION"
			},
			{
				"name": "BNI",
				"salience": 0.056617483,
				"type": "ORGANIZATION"
			},
			{
				"name": "families",
				"salience": 0.04394364,
				"type": "PERSON"
			},
			{
				"name": "wives",
				"salience": 0.038137563,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.038137563,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.024132509,
				"type": "ORGANIZATION"
			},
			{
				"name": "facts",
				"salience": 0.015902175,
				"type": "OTHER"
			},
			{
				"name": "tens of thousands",
				"salience": 0.013780611,
				"type": "PERSON"
			},
			{
				"name": "information requests",
				"salience": 0.01326866,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.01326866,
				"type": "PERSON"
			},
			{
				"name": "access",
				"salience": 0.01326866,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.012995693,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.012995693,
				"type": "OTHER"
			},
			{
				"name": "welfare agencies",
				"salience": 0.008419888,
				"type": "ORGANIZATION"
			},
			{
				"name": "anything",
				"salience": 0.008419888,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.008181521,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h7h6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toronto"
				},
				"name": "Toronto",
				"salience": 0.007882593,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.007085048,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.006136944,
				"type": "OTHER"
			},
			{
				"name": "marriages",
				"salience": 0.006136944,
				"type": "OTHER"
			},
			{
				"name": "welfare",
				"salience": 0.005864193,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0052957013,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.004586609,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.004586609,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.004586609,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/s0VZH7f8sP0/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-31T22:36:49.421+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 31 2016 Do Canadian taxpayers know they are funding welfare for polygamous Muslim migrant families with up to 4 wives and countless children? Canadian Liberals have been stonewalling on any access to information requests relating to the Syrian Muslim migrants they’ve been shipping in by the tens of thousands . They’re either embarrassed by the facts or don’t even want to know what the facts actually are. Back in 2008, Toronto media left and right reported on hundreds of polygamous Muslim families in Toronto, many on welfare. Has anything changed? Neither Canada’s government nor its welfare agencies bother to screen for polygamous marriages. And the media won’t breathe a word about it.",
		"thread_title": "Do Canadian taxpayers know they are funding welfare for polygamous Muslim migrant families with up to 4 wives and countless children?",
		"title": "Do Canadian taxpayers know they are funding welfare for polygamous Muslim migrant families with up to 4 wives and countless children?",
		"type": "bs",
		"uuid": "59fdf2e7f9a3d6dd76e82dad5b328bb06c83895b"
	},
	"-KhIjkI74atL_5etE8D1": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T03:41:47.585+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.16381484,
				"type": "OTHER"
			},
			{
				"name": "Denk Partij",
				"salience": 0.14322743,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059j2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Netherlands"
				},
				"name": "NETHERLANDS",
				"salience": 0.121306665,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.06532785,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0n_59sr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tunahan_Kuzu"
				},
				"name": "Tunahan Kuzu",
				"salience": 0.051327087,
				"type": "PERSON"
			},
			{
				"name": "Denk Party",
				"salience": 0.04408325,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.020447554,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.018144771,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime",
				"salience": 0.016459398,
				"type": "ORGANIZATION"
			},
			{
				"name": "Think Party",
				"salience": 0.0156505,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d2s4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Labour_Party_(Netherlands)"
				},
				"name": "Dutch Labour Party",
				"salience": 0.0156505,
				"type": "ORGANIZATION"
			},
			{
				"name": "colonizers",
				"salience": 0.013747371,
				"type": "PERSON"
			},
			{
				"name": "colonizers",
				"salience": 0.013747371,
				"type": "PERSON"
			},
			{
				"name": "controversy",
				"salience": 0.011914628,
				"type": "OTHER"
			},
			{
				"name": "affiliation",
				"salience": 0.011914628,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.011914628,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.011914628,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.010164906,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0p76ryq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sel%C3%A7uk_%C3%96zt%C3%BCrk"
				},
				"name": "Selçuk Öztürk",
				"salience": 0.009588662,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03w86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamism"
				},
				"name": "Islamist",
				"salience": 0.008482831,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/011hr1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Armenian_Genocide"
				},
				"name": "Armenian Genocide",
				"salience": 0.008482831,
				"type": "OTHER"
			},
			{
				"name": "anti-immigration registry",
				"salience": 0.0074818367,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kzhd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Zionism"
				},
				"name": "anti-Israel",
				"salience": 0.007349249,
				"type": "OTHER"
			},
			{
				"name": "UK Express DENK",
				"salience": 0.005920544,
				"type": "PERSON"
			},
			{
				"name": "champion",
				"salience": 0.0059097614,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0054369606,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.004706128,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.004483357,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0039829314,
				"type": "LOCATION"
			},
			{
				"name": "racism",
				"salience": 0.003921411,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0037678233,
				"type": "ORGANIZATION"
			},
			{
				"name": "Racism Police",
				"salience": 0.0035893167,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "E.U.",
				"salience": 0.0035498808,
				"type": "ORGANIZATION"
			},
			{
				"name": "registry",
				"salience": 0.0034804235,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.003473001,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0032156296,
				"type": "OTHER"
			},
			{
				"name": "ideology",
				"salience": 0.0030988492,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0029037138,
				"type": "EVENT"
			},
			{
				"name": "offenders",
				"salience": 0.0029037138,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.00251471,
				"type": "OTHER"
			},
			{
				"name": "Insurrection",
				"salience": 0.00251471,
				"type": "OTHER"
			},
			{
				"name": "thought",
				"salience": 0.00251471,
				"type": "OTHER"
			},
			{
				"name": "re-education",
				"salience": 0.00251471,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.00251471,
				"type": "LOCATION"
			},
			{
				"name": "fines",
				"salience": 0.00251471,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0023500714,
				"type": "PERSON"
			},
			{
				"name": "renaming",
				"salience": 0.0023012669,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.002298989,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0022863718,
				"type": "PERSON"
			},
			{
				"name": "offenders",
				"salience": 0.0020364472,
				"type": "PERSON"
			},
			{
				"name": "immigrant population",
				"salience": 0.0019604722,
				"type": "PERSON"
			},
			{
				"name": "proposals",
				"salience": 0.0019604722,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0019604722,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02cjss",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Respect_Party"
				},
				"name": "Respect Party",
				"salience": 0.0018944652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobic",
				"salience": 0.0017878746,
				"type": "OTHER"
			},
			{
				"name": "pro-Muslim",
				"salience": 0.0017878746,
				"type": "OTHER"
			},
			{
				"name": "listing",
				"salience": 0.0017635229,
				"type": "OTHER"
			},
			{
				"name": "child molesters",
				"salience": 0.0017635229,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0017635229,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0017635229,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0017635229,
				"type": "PERSON"
			},
			{
				"name": "slave trading history",
				"salience": 0.0017635229,
				"type": "OTHER"
			},
			{
				"name": "tunnels",
				"salience": 0.0017635229,
				"type": "OTHER"
			},
			{
				"name": "foreigner",
				"salience": 0.0017635229,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.0017635229,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0016977212,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.0016977212,
				"type": "PERSON"
			},
			{
				"name": "origin",
				"salience": 0.0016977212,
				"type": "OTHER"
			},
			{
				"name": "parliament",
				"salience": 0.0016977212,
				"type": "LOCATION"
			},
			{
				"name": "elections",
				"salience": 0.0016977212,
				"type": "EVENT"
			},
			{
				"name": "natives",
				"salience": 0.0016867293,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.0016779816,
				"type": "OTHER"
			},
			{
				"name": "genocide",
				"salience": 0.0016626455,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.0016626455,
				"type": "OTHER"
			},
			{
				"name": "Islamophobia",
				"salience": 0.0015886404,
				"type": "OTHER"
			},
			{
				"name": "sentences",
				"salience": 0.0015535665,
				"type": "OTHER"
			},
			{
				"name": "Truth Revolt",
				"salience": 0.0015482373,
				"type": "EVENT"
			},
			{
				"name": "Racism Register",
				"salience": 0.0015029114,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0fm2h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benjamin_Netanyahu"
				},
				"name": "Benjamin Netenyahu",
				"salience": 0.0014612917,
				"type": "PERSON"
			},
			{
				"name": "root",
				"salience": 0.0014397807,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0014397807,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0014397807,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0014397807,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0014397807,
				"type": "OTHER"
			},
			{
				"name": "heritage",
				"salience": 0.0014397807,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.0014216431,
				"type": "OTHER"
			},
			{
				"name": "immigrant",
				"salience": 0.0013756884,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.0013009147,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0012876872,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0012511226,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0012421319,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0012421319,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0012222035,
				"type": "OTHER"
			},
			{
				"name": "Islamophobia",
				"salience": 0.0011571149,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02px1y2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turks_in_the_Netherlands"
				},
				"name": "Turkish-Dutch",
				"salience": 0.0011335306,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021275",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Recep_Tayyip_Erdo%C4%9Fan"
				},
				"name": "Erdogan",
				"salience": 0.00108559,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0czc_8k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Surinamese_people"
				},
				"name": "Surinamese",
				"salience": 0.00108559,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0243k7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Justice_and_Development_Party_(Turkey)"
				},
				"name": "AKP",
				"salience": 0.00108559,
				"type": "ORGANIZATION"
			},
			{
				"name": "program",
				"salience": 0.0010756024,
				"type": "OTHER"
			},
			{
				"name": "identity",
				"salience": 0.0010756024,
				"type": "OTHER"
			},
			{
				"name": "holiday",
				"salience": 0.0010756024,
				"type": "EVENT"
			},
			{
				"name": "ideals",
				"salience": 0.0010756024,
				"type": "OTHER"
			},
			{
				"name": "ban",
				"salience": 0.0010756024,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0010756024,
				"type": "OTHER"
			},
			{
				"name": "mentions",
				"salience": 0.0010756024,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0010756024,
				"type": "ORGANIZATION"
			},
			{
				"name": "integration",
				"salience": 0.0010756024,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.0010234714,
				"type": "LOCATION"
			},
			{
				"name": "things",
				"salience": 0.0009046851,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0009046851,
				"type": "OTHER"
			},
			{
				"name": "classroom",
				"salience": 0.0009046851,
				"type": "LOCATION"
			},
			{
				"name": "citizenship classes",
				"salience": 0.0009046851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fhjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Galloway"
				},
				"name": "George Galloway",
				"salience": 0.0008862436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0008862436,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0008862436,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01hd99",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Armenian_Apostolic_Church"
				},
				"name": "Armenian Christians",
				"salience": 0.0008862436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israeli",
				"salience": 0.00087179564,
				"type": "LOCATION"
			},
			{
				"name": "culture",
				"salience": 0.00078337785,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00078337785,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.00078337785,
				"type": "ORGANIZATION"
			},
			{
				"name": "migrants",
				"salience": 0.00078337785,
				"type": "PERSON"
			},
			{
				"name": "atmosphere",
				"salience": 0.00078337785,
				"type": "OTHER"
			},
			{
				"name": "acceptance",
				"salience": 0.00078337785,
				"type": "OTHER"
			},
			{
				"name": "attitudes",
				"salience": 0.00078337785,
				"type": "OTHER"
			},
			{
				"name": "benchmark",
				"salience": 0.0006813746,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0006758066,
				"type": "EVENT"
			},
			{
				"name": "proposals",
				"salience": 0.0006758066,
				"type": "OTHER"
			},
			{
				"name": "customs",
				"salience": 0.00067278766,
				"type": "OTHER"
			},
			{
				"name": "nature",
				"salience": 0.0006234908,
				"type": "OTHER"
			},
			{
				"name": "media attention",
				"salience": 0.0005851799,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.0005851799,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0005851799,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0005851799,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0005851799,
				"type": "OTHER"
			},
			{
				"name": "dissident",
				"salience": 0.0005851799,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.0005851799,
				"type": "OTHER"
			},
			{
				"name": "pro-Islam",
				"salience": 0.0005568112,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atlantic_Ocean"
				},
				"name": "Atlantic",
				"salience": 0.00036014084,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/racism-police-migrant-party-726398.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T03:41:47.585+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "NETHERLANDS has a new Muslim political party called ‘DENK’ (Think) created by Muslim colonizers for Muslim colonizers Founded by 2 Turkish Muslims, Tunahan Kuzu and Selçuk Öztürk, after being booted out of the Dutch Labour Party, the Denk Partij (Think Party) is the first political force in Europe established by Muslims and is attracting controversy for its affiliation with the Turkish Islamist regime, rejection of the Armenian Genocide, and radical anti-Israel positions. DENK is also proposing a 1,000 strong ‘racism’ police and national anti-immigration registry which will target anyone who says anything ‘Islamophobic’ against Muslims. Legal Insurrection is reporting ( h/t Truth Revolt ) that the Netherlands’ pro-Muslim immigration Denk Party is pushing for a thousand-strong “Racism Police” to go after thought and speech crimes against Muslims which would result in a registry for offenders, fines, and re-education camps. The party, dominated by members of Turkish and Muslim origin was founded in 2014 by two former-socialist Turkish politicians but it already sits in the Dutch parliament and is hoping to mobilize the country’s million-strong mainly Muslim immigrant population (out of about 17 million overall) and growing Muslim population, currently at about 7 percent, in the parliamentary elections to be held early next year. Tunahan Kuzu and Selçuk Öztürk Among the Denk Party’s latest proposals are the renaming of streets and tunnels suggestive of Dutch colonial and slave trading history, changing the term “foreigner” to “Turkish and Surinamese Dutch person,” creating a thousand-man “Racism Police,” establishing stricter sentences for “racist and discriminatory behavior,” and listing offenders on a nationwide “Racism Register” — you know, just like child molesters. This multicultural champion has close ties to Erdogan’s Turkish-Islamist AKP party and it refuses to recognize the genocide of Armenian Christians. According to a recent Dutch poll, nearly 90 percent of young Turkish-Dutch sympathize with ISIS — 90 percent . This is the Denk Party’s political base. Denk Party stands in the tradition of George Galloway’s Respect Party in UK, a new mutant ideology taking root in Europe that fuses leftist “social justice” issues with political Islam, dipped in fierce hatred for Israel and Western heritage. Last month, the Denk Party attracted media attention when party’s leader and Dutch MP Tunahan Kuzu refused to shake hands with the visiting Israeli Prime Minister Benjamin Netenyahu. What should worry the freedom-loving people — on the either side of the Atlantic — is not just the outrageous nature of Denk Party’s proposals, but the determined effort already underway in Europe to criminalize “undesired” speech and political dissident. The E.U. has long been pressuring its media to omit mentions of Islam when Muslims are involved in terrorism. UK Express DENK proposes a ban on words like ‘native’ and ‘immigrant’ would be introduced, alongside a national holiday to celebrate Muslim diversity. The party aims to reinvent Dutch national identity, and the program is geared towards tackling the institutional racism/Islamophobia it says is endemic in the Netherlands. And part of that is scrapping the government’s ideals of integration, claiming this should not be expected of Muslim migrants, but rather an atmosphere of ‘mutual acceptance’ should be adopted. (In other words, forcing Dutch natives to give up their customs and culture and accommodate the Muslim way of doing things) Tackling racism/Islamophobia should begin in schools, with pro-Islam attitudes promoted in the classroom through citizenship classes, and that students are regularly tested to see if they are meeting the required benchmark.",
		"thread_title": "NETHERLANDS has a new Muslim political party called ‘DENK’ (Think) created by Muslim colonizers for Muslim colonizers",
		"title": "NETHERLANDS has a new Muslim political party called ‘DENK’ (Think) created by Muslim colonizers for Muslim colonizers",
		"type": "bs",
		"uuid": "c9c6c4274e32bb7bc71a10bc85d06fbd576c1c1e"
	},
	"-KhIjkaI4uk1GXBhdTQU": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T03:41:50.347+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "John Bennett",
				"salience": 0.2994319,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0850594,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.07530448,
				"type": "PERSON"
			},
			{
				"name": "cancer",
				"salience": 0.044455417,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05mph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma"
				},
				"name": "Oklahoma",
				"salience": 0.03884681,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.02389674,
				"type": "PERSON"
			},
			{
				"name": "James Davenport",
				"salience": 0.022206547,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobia",
				"salience": 0.020838171,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christianity",
				"salience": 0.018121388,
				"type": "OTHER"
			},
			{
				"name": "Imad Enchassi",
				"salience": 0.017953664,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.01766106,
				"type": "OTHER"
			},
			{
				"name": "John Guandolo",
				"salience": 0.015339194,
				"type": "PERSON"
			},
			{
				"name": "State Rep.",
				"salience": 0.01277089,
				"type": "PERSON"
			},
			{
				"name": "Adam Soltani",
				"salience": 0.012060275,
				"type": "PERSON"
			},
			{
				"name": "beheading",
				"salience": 0.011484487,
				"type": "EVENT"
			},
			{
				"name": "attempt",
				"salience": 0.011484487,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.011484487,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.009949883,
				"type": "PERSON"
			},
			{
				"name": "Randy Grau",
				"salience": 0.008805707,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0085322065,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "Council on American-Islamic Relations",
				"salience": 0.007092255,
				"type": "ORGANIZATION"
			},
			{
				"name": "stud",
				"salience": 0.0067530284,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fftcq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_Republican_Party"
				},
				"name": "Oklahoma GOP",
				"salience": 0.0061319135,
				"type": "ORGANIZATION"
			},
			{
				"name": "BNI",
				"salience": 0.0061319135,
				"type": "ORGANIZATION"
			},
			{
				"name": "science",
				"salience": 0.0050888318,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0038952753,
				"type": "LOCATION"
			},
			{
				"name": "someone",
				"salience": 0.003700225,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.0033536095,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christ"
				},
				"name": "Christ",
				"salience": 0.0033315183,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.0032696929,
				"type": "OTHER"
			},
			{
				"name": "Nondoc Whining",
				"salience": 0.0031338672,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04m4b0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rose_State_College"
				},
				"name": "Rose State College",
				"salience": 0.0031338672,
				"type": "ORGANIZATION"
			},
			{
				"name": "freedom",
				"salience": 0.0029172783,
				"type": "OTHER"
			},
			{
				"name": "faiths",
				"salience": 0.0028562997,
				"type": "OTHER"
			},
			{
				"name": "faiths",
				"salience": 0.0027497436,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02t7t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Evangelicalism"
				},
				"name": "Evangelical Christian",
				"salience": 0.0027385612,
				"type": "ORGANIZATION"
			},
			{
				"name": "member",
				"salience": 0.0025241494,
				"type": "PERSON"
			},
			{
				"name": "executive director",
				"salience": 0.0024206548,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0024206548,
				"type": "OTHER"
			},
			{
				"name": "radicalization process",
				"salience": 0.0024206548,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0024206548,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.0024206548,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0024206548,
				"type": "PERSON"
			},
			{
				"name": "faith",
				"salience": 0.0023320331,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0023320331,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0023168663,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.0022929583,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0022929583,
				"type": "OTHER"
			},
			{
				"name": "strides",
				"salience": 0.0022333679,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002218908,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0022074003,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.002096207,
				"type": "OTHER"
			},
			{
				"name": "impact",
				"salience": 0.002096207,
				"type": "OTHER"
			},
			{
				"name": "spectacle",
				"salience": 0.002096207,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.002096207,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.002096207,
				"type": "OTHER"
			},
			{
				"name": "tradition",
				"salience": 0.002096207,
				"type": "OTHER"
			},
			{
				"name": "chapter",
				"salience": 0.002096207,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.0020437294,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00203484,
				"type": "OTHER"
			},
			{
				"name": "state representative",
				"salience": 0.0019674636,
				"type": "PERSON"
			},
			{
				"name": "Imam",
				"salience": 0.0019589057,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0019589057,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0018798829,
				"type": "LOCATION"
			},
			{
				"name": "freedom",
				"salience": 0.0018720166,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01skqzw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Marine_Corps"
				},
				"name": "U.S. Marines",
				"salience": 0.0018184131,
				"type": "ORGANIZATION"
			},
			{
				"name": "problem",
				"salience": 0.0017856804,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0017422393,
				"type": "OTHER"
			},
			{
				"name": "faiths",
				"salience": 0.0017422393,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0017422393,
				"type": "OTHER"
			},
			{
				"name": "minority faiths",
				"salience": 0.0017422393,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0017422393,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.0016973807,
				"type": "PERSON"
			},
			{
				"name": "network use relationships",
				"salience": 0.0016973807,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.001661253,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0016340314,
				"type": "PERSON"
			},
			{
				"name": "attendance",
				"salience": 0.0016340314,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0016340314,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/038vs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gospel_of_John"
				},
				"name": "John 18",
				"salience": 0.0016090325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Imam Enchassi",
				"salience": 0.0015877909,
				"type": "PERSON"
			},
			{
				"name": "agent",
				"salience": 0.0015660197,
				"type": "PERSON"
			},
			{
				"name": "CAIR-Oklahoma",
				"salience": 0.0015432162,
				"type": "ORGANIZATION"
			},
			{
				"name": "fact",
				"salience": 0.0015347283,
				"type": "OTHER"
			},
			{
				"name": "Islamic Society of Greater Oklahoma City",
				"salience": 0.0014901235,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.0014885757,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0014764143,
				"type": "PERSON"
			},
			{
				"name": "priorities",
				"salience": 0.0014698203,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.0014698203,
				"type": "OTHER"
			},
			{
				"name": "association",
				"salience": 0.0014698203,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0014698203,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0014698203,
				"type": "EVENT"
			},
			{
				"name": "bigotry",
				"salience": 0.0014149593,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.0014149593,
				"type": "OTHER"
			},
			{
				"name": "cloak",
				"salience": 0.0014149593,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.0014149593,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.0014149593,
				"type": "EVENT"
			},
			{
				"name": "instruction",
				"salience": 0.0013857163,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0013222568,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/056rs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim_Brotherhood"
				},
				"name": "Muslim Brotherhood",
				"salience": 0.0012903352,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/074hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sharia"
				},
				"name": "Shariah Law",
				"salience": 0.0012903352,
				"type": "ORGANIZATION"
			},
			{
				"name": "faith",
				"salience": 0.0012689414,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0012689414,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0012410242,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.00119992,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.00119992,
				"type": "OTHER"
			},
			{
				"name": "reasoning",
				"salience": 0.00119992,
				"type": "OTHER"
			},
			{
				"name": "believers",
				"salience": 0.00119992,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.00119992,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0011464908,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.001131253,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0011169977,
				"type": "PERSON"
			},
			{
				"name": "type",
				"salience": 0.0010570071,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0010501604,
				"type": "PERSON"
			},
			{
				"name": "society",
				"salience": 0.0010351589,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0010351589,
				"type": "ORGANIZATION"
			},
			{
				"name": "Judiciary and Civil Procedure Committee",
				"salience": 0.0010057702,
				"type": "ORGANIZATION"
			},
			{
				"name": "influence",
				"salience": 0.0009795619,
				"type": "OTHER"
			},
			{
				"name": "UnderstandingtheThreat.com",
				"salience": 0.0009046737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0009046737,
				"type": "ORGANIZATION"
			},
			{
				"name": "religion",
				"salience": 0.0009038389,
				"type": "OTHER"
			},
			{
				"name": "ilk",
				"salience": 0.00089634885,
				"type": "PERSON"
			},
			{
				"name": "love",
				"salience": 0.00089634885,
				"type": "OTHER"
			},
			{
				"name": "levers",
				"salience": 0.00089634885,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0z8j4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Edmond,_Oklahoma"
				},
				"name": "Edmond",
				"salience": 0.0008708997,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "R",
				"salience": 0.0008708997,
				"type": "PERSON"
			},
			{
				"name": "accommodations",
				"salience": 0.0008450484,
				"type": "OTHER"
			},
			{
				"name": "Father",
				"salience": 0.00084127334,
				"type": "PERSON"
			},
			{
				"metadata": {
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity_in_the_Middle_East"
				},
				"name": "Christians in the Middle East",
				"salience": 0.00082172477,
				"type": "ORGANIZATION"
			},
			{
				"name": "news",
				"salience": 0.0007698042,
				"type": "OTHER"
			},
			{
				"name": "STORIES",
				"salience": 0.00075389066,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05crg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Testament"
				},
				"name": "New Testament",
				"salience": 0.0007385204,
				"type": "WORK_OF_ART"
			},
			{
				"name": "threat",
				"salience": 0.0007193578,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00070756604,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0006751545,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0006751545,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0006751545,
				"type": "PERSON"
			},
			{
				"name": "idea",
				"salience": 0.0006611203,
				"type": "OTHER"
			},
			{
				"name": "cleansing",
				"salience": 0.0006527878,
				"type": "OTHER"
			},
			{
				"name": "enemies",
				"salience": 0.0006527878,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0006527878,
				"type": "OTHER"
			},
			{
				"name": "VIDEOS",
				"salience": 0.0006527878,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sanction",
				"salience": 0.0006527878,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0006527878,
				"type": "OTHER"
			},
			{
				"name": "acknowledgement",
				"salience": 0.0006284151,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00062371505,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0005653064,
				"type": "PERSON"
			},
			{
				"name": "faith community",
				"salience": 0.00056313706,
				"type": "OTHER"
			},
			{
				"name": "accommodation",
				"salience": 0.00056313706,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.000551655,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bq0_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oklahoma_Legislature"
				},
				"name": "Oklahoma Legislature",
				"salience": 0.000551655,
				"type": "ORGANIZATION"
			},
			{
				"name": "instructions",
				"salience": 0.000502384,
				"type": "OTHER"
			},
			{
				"name": "sadness",
				"salience": 0.0004938355,
				"type": "OTHER"
			},
			{
				"name": "pushback",
				"salience": 0.000487611,
				"type": "OTHER"
			},
			{
				"name": "combining",
				"salience": 0.000487611,
				"type": "OTHER"
			},
			{
				"name": "state power",
				"salience": 0.000487611,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000487611,
				"type": "PERSON"
			},
			{
				"name": "event",
				"salience": 0.000487611,
				"type": "EVENT"
			},
			{
				"name": "leaders",
				"salience": 0.000487611,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.000487611,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.000487611,
				"type": "OTHER"
			},
			{
				"name": "immersion",
				"salience": 0.000487611,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.000487611,
				"type": "LOCATION"
			},
			{
				"name": "academia",
				"salience": 0.000487611,
				"type": "PERSON"
			},
			{
				"name": "Luke 6",
				"salience": 0.00040174156,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/10/ByfDjrmIIAE2Izf1.png-large1.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T03:41:50.347+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Oct 31 2016 It isn’t ‘Islamophobia’ when an Oklahoma GOP State Rep. says “Islam is a cancer in our nation that needs to be cut out” Unfortunately, some Christians in Oklahoma, where there has been one savage beheading of a Christian woman by a Muslim and at least one other beheading attempt, seem to think so, and blindly condemn all outspoken critics of Islam…especially the Christians. Nondoc Whining about so-called “Islamophobia is exactly what James Davenport, a Christian political science professor of at Rose State College, is doing . Specifically, he attacks State Rep. John Bennett for holding an interim stud y this past week on the impact of “radical Islam, Shariah Law, the Muslim Brotherhood and the radicalization process” on Oklahoma and the nation. During the course of this study, Rep. Bennett referred to Adam Soltani, the executive director for designated terrorist group CAIR (Council on American-Islamic Relations chapter of Oklahoma), and Imam Imad Enchassi, of the Islamic Society of Greater Oklahoma City, as “terrorists.” As someone who grew up in the Evangelical Christian tradition, and as someone who believes religious freedom remains a fundamental principle of our system of government, I am both offended and saddened at this spectacle. I am offended that a state representative from my state would use the cloak of Christianity to spew hate and bigotry such as this. I am also offended that he would do so while arguing he is defending freedom. Imam Enchassi then got up from his seat in the audience and hugged two members of other faiths who were in attendance. Bennett asked Rep. Randy Grau, R-Edmond, chairman of the Judiciary and Civil Procedure Committee, to admonish members of the audience not to hug a Muslim. In fact, during one exchange between Bennett and Imam Enchassi, the Imam stated, “It’s a free country,” to which Bennett, who served in the U.S. Marines replied, “I know, I fought for it in two wars.” John Guandolo, the founder of UnderstandingtheThreat.com , who served in the Marines and is a former FBI agent, said the Islamic movement in Oklahoma has made significant strides, and he called CAIR-Oklahoma executive director Adam Soltani a terrorist. Under questioning from Bennett, Guandolo said groups in the country’s jihadi network use relationships with other faiths as a tool. But one wonders what, exactly, Bennett fought for. It clearly wasn’t freedom. Neither freedom of religion nor freedom of association seem high on his list of priorities, especially if you happen to be a member of Islam. Perhaps he was fighting for Christianity. The problem with that line of reasoning is there rests absolutely no instruction in the New Testament for believers to physically fight for Christ, or for the faith. In fact, if one were to hold strictly to Christ’s own words on this, one could easily reach the conclusion that Christ expects us not to fight for him (read John 18:36 ). So if Bennett wasn’t fighting for freedom, and he wasn’t fighting for Christianity, what was he fighting for? Perhaps he should spend more time reading the history of his own faith rather than fretting about the supposed threat from Muslims. He would find that this combining of religion and state power never ends well — for anyone. I also mentioned I was saddened by this event. That sadness comes from the fact that I know I will receive pushback from members of my own faith community on this matter. I will be told I do not understand the true threat posed by Islam. I’ll also be told I’ve been blinded to the truth by my immersion in the liberal world of academia. Too many Evangelicals have been convinced by opportunistic political and religious leaders that any acknowledgement or accommodation of Islam is a threat to Christianity itself. I disagree. If allowing others to freely practice their faith, if providing (special and excessive) accommodations to those of Islam and if refusing to use the levers of government to intimidate, harass or oppress minority faiths (the one faith determined to subjugate and dominate those of every other faith) is a threat to Christianity, we Christians have bigger problems than we know. \nIf Christians want to have real influence on our society — if we want to spread the good news of God’s love — we must reject the type of political religion promoted by Rep. Bennett and his ilk. We must stand with those of other faiths and affirm that, unlike some in the Oklahoma Legislature , we believe all people of faith are entitled to practice their religion freely without fear of official sanction. “If you are concerned that there are some who wish to destroy the Christian faith, follow Christ’s instructions: “Love your enemies! Do good to those who hate you. Bless those who curse you. Pray for those who hurt you…You must be compassionate, just as your Father is compassionate.” ( Luke 6:27-36 ) (And we see how well that idea has worked out for Christians in the Middle East who are very close to becoming extinct because of the ethnic cleansing by the Muslim majority) RELATED STORIES/VIDEOS:",
		"thread_title": "It isn’t ‘Islamophobia’ when an Oklahoma GOP State Rep. says “Islam is a cancer in our nation that needs to be cut out”",
		"title": "It isn’t ‘Islamophobia’ when an Oklahoma GOP State Rep. says “Islam is a cancer in our nation that needs to be cut out”",
		"type": "bs",
		"uuid": "3019e93cbc7bfc94ff5a250e547ec5452a220908"
	},
	"-KhIjl1CRkJo_Uk_jb2u": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T05:23:13.094+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Therese Borg",
				"salience": 0.1700142,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.115861654,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedish",
				"salience": 0.0766668,
				"type": "LOCATION"
			},
			{
				"name": "freeloaders",
				"salience": 0.057608772,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.055882245,
				"type": "OTHER"
			},
			{
				"name": "councils",
				"salience": 0.030036181,
				"type": "ORGANIZATION"
			},
			{
				"name": "Migration Board",
				"salience": 0.027163088,
				"type": "ORGANIZATION"
			},
			{
				"name": "families",
				"salience": 0.023714291,
				"type": "PERSON"
			},
			{
				"name": "housing queue",
				"salience": 0.021431424,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.019929176,
				"type": "LOCATION"
			},
			{
				"name": "MP",
				"salience": 0.01857915,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.01857915,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.01619895,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.014820323,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.014038886,
				"type": "LOCATION"
			},
			{
				"name": "housing",
				"salience": 0.014038886,
				"type": "OTHER"
			},
			{
				"name": "asylum seekers",
				"salience": 0.013163354,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.012975877,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.010989044,
				"type": "PERSON"
			},
			{
				"name": "requests",
				"salience": 0.009520884,
				"type": "OTHER"
			},
			{
				"name": "invaders",
				"salience": 0.008231579,
				"type": "PERSON"
			},
			{
				"name": "apartments",
				"salience": 0.0075732833,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_myf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Express"
				},
				"name": "Express.co.uk",
				"salience": 0.006774373,
				"type": "ORGANIZATION"
			},
			{
				"name": "UK Express",
				"salience": 0.006774373,
				"type": "ORGANIZATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.006694439,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.006691938,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.006598273,
				"type": "OTHER"
			},
			{
				"name": "apartments",
				"salience": 0.0063854074,
				"type": "LOCATION"
			},
			{
				"name": "Bert-Inge Karlsson",
				"salience": 0.0059092357,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06mx8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scandinavia"
				},
				"name": "Scandinavian",
				"salience": 0.0058678985,
				"type": "LOCATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.005433784,
				"type": "PERSON"
			},
			{
				"name": "policy",
				"salience": 0.005433784,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.005220154,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedes",
				"salience": 0.005147805,
				"type": "LOCATION"
			},
			{
				"name": "waiting list",
				"salience": 0.005020567,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.004838319,
				"type": "EVENT"
			},
			{
				"name": "council",
				"salience": 0.004499923,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01fts4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian_Democrats_(Sweden)"
				},
				"name": "Christian Democrats",
				"salience": 0.0044446876,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.004209223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06mz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Dakota"
				},
				"name": "SD",
				"salience": 0.0041719796,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0039766645,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.0039266148,
				"type": "ORGANIZATION"
			},
			{
				"name": "property company",
				"salience": 0.0039266148,
				"type": "ORGANIZATION"
			},
			{
				"name": "accommodations",
				"salience": 0.0039266148,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0038339347,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0038339347,
				"type": "PERSON"
			},
			{
				"name": "apartment",
				"salience": 0.003521704,
				"type": "LOCATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.003444403,
				"type": "PERSON"
			},
			{
				"name": "list",
				"salience": 0.003390373,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.003390373,
				"type": "LOCATION"
			},
			{
				"name": "list",
				"salience": 0.003390373,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.0033880074,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Sweden",
				"salience": 0.0033467147,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0033203645,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.0032228413,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0030666625,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0030614391,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0030614391,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0027890846,
				"type": "WORK_OF_ART"
			},
			{
				"name": "youth",
				"salience": 0.0027539644,
				"type": "OTHER"
			},
			{
				"name": "politician",
				"salience": 0.0027074623,
				"type": "PERSON"
			},
			{
				"name": "treatment",
				"salience": 0.0026512316,
				"type": "OTHER"
			},
			{
				"name": "teenagers",
				"salience": 0.0026512316,
				"type": "PERSON"
			},
			{
				"name": "turn",
				"salience": 0.0026512316,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.002571865,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.002516855,
				"type": "PERSON"
			},
			{
				"name": "Klippan",
				"salience": 0.002417843,
				"type": "LOCATION"
			},
			{
				"name": "responsibility",
				"salience": 0.0023956087,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0022485042,
				"type": "LOCATION"
			},
			{
				"name": "funds",
				"salience": 0.0022485042,
				"type": "OTHER"
			},
			{
				"name": "arrivals",
				"salience": 0.0021104247,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0020868604,
				"type": "PERSON"
			},
			{
				"name": "migration",
				"salience": 0.0020868604,
				"type": "EVENT"
			},
			{
				"name": "turmoil nation",
				"salience": 0.0020534415,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0019398914,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0019398914,
				"type": "LOCATION"
			},
			{
				"name": "housing crisis",
				"salience": 0.0018357438,
				"type": "OTHER"
			},
			{
				"name": "asylum",
				"salience": 0.0018071384,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0017897849,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0016938872,
				"type": "OTHER"
			},
			{
				"name": "municipalities",
				"salience": 0.001679855,
				"type": "LOCATION"
			},
			{
				"name": "insinuation",
				"salience": 0.001679855,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0016321774,
				"type": "OTHER"
			},
			{
				"name": "Theresa Borg",
				"salience": 0.0015272895,
				"type": "PERSON"
			},
			{
				"name": "housing",
				"salience": 0.0014753494,
				"type": "OTHER"
			},
			{
				"name": "queue",
				"salience": 0.0014129544,
				"type": "OTHER"
			},
			{
				"name": "waiting",
				"salience": 0.0014129544,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0012605716,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0012235157,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0012235157,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0012235157,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.0012235157,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0012235157,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.0012235157,
				"type": "PERSON"
			},
			{
				"name": "housing shortages",
				"salience": 0.0012235157,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0012235157,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0011690387,
				"type": "OTHER"
			},
			{
				"name": "Nyheteridag",
				"salience": 0.0011016907,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0010555222,
				"type": "WORK_OF_ART"
			},
			{
				"name": "families",
				"salience": 0.0009913649,
				"type": "PERSON"
			},
			{
				"name": "portrayal",
				"salience": 0.0009615473,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.000913987,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.000913987,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.000913987,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/dqNRXXoJsBY/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T05:23:13.094+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "A Swedish MP has lashed out after it was revealed Muslim freeloaders posing as refugees would be allowed to jump ahead of Swedish families in the housing queue. NOT ANYMORE! UK Express Earlier this month Express.co.uk reported several councils in the Scandinavian country are prioritising the requests of asylum seekers ahead of their own citizens, with Muslim migrants given housing straight away, despite Swedes being placed on a huge waiting list. Now 20 accommodations in Klippan, in south Sweden, are being prepared for Muslim migrants after a new policy demanded all available apartments owned by the municipal property company be put aside for asylum seekers. The move has been criticised by Therese Borg, of the Swedish Democrats (SD) party, as she argued the Muslim invaders should be placed on the list and wait their turn. Ms Borg said asylum seekers urgently needed to be placed on the list alongside regular people because hardworking citizens risked growing resentful of the preferential treatment. She told Nyheteridag : “You can see a lot of comments on Facebook. People are pissed off. “There are a lot of teenagers living at home and who are looking for [a small apartment] to move into as it is a good place to start [building a life]. “The small apartments are necessary for [the youth] moving out, but they are not offered them unless the newly arrivals decline to take the property.” Meanwhile aid workers helping migrants say they have been terrified by Muslim attacks which have left them too scared to leave their homes. The SD politician also said the council should start focusing on the migrants already living in the area, rather than focusing funds on asylum seekers who might arrive in the future. Lashing out against the Government and Migration Board, Ms Borg demanded they take responsibility for the migrants they have allowed into the country. Even worse, a lot of Swedish families are being kicked out of their homes in order to accommodate Muslim freeloaders: However, Bert-Inge Karlsson, of the Christian Democrats, blasted Ms Borg’s comments as he insisted her portrayal of the situation was out-of-touch with reality. Mr Karlsson said: “I [question] the way Theresa Borg has portrayed it as if we have an extraordinary housing crisis in the nation. How is it then possible for us to take in so incredibly many. “She has returned to the kind of insinuation… which suggests the entire world could be on its way here.” In March this year, Sweden passed a law requiring all municipalities accept and provide housing for migrants, allowing families and others on the waiting to be placed at the back of the queue. The turmoil nation, which has been plagued with increasing levels of violence and criminal activity , with three police officers quitting each day , is experiencing chronic housing shortages as a result of the country’s generous asylum and migration policies over the last decade.",
		"thread_title": "SWEDISH OUTRAGE as Muslim colonizers get preference for housing while native Swedes are out in the cold",
		"title": "SWEDISH OUTRAGE as Muslim colonizers get preference for housing while native Swedes are out in the cold",
		"type": "bs",
		"uuid": "e6ab86ab2f89dfe8e9980b1f98ded6b9c962fa06"
	},
	"-KhIjlSJVolW-eyJEWNV": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T11:44:09.560+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09g9s5g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government_of_the_United_Kingdom"
				},
				"name": "UK Ministers",
				"salience": 0.13662806,
				"type": "ORGANIZATION"
			},
			{
				"name": "housing",
				"salience": 0.11266012,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.048837237,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.040321987,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.038671423,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01c8br",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Street"
				},
				"name": "Streets",
				"salience": 0.03283961,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.028497549,
				"type": "LOCATION"
			},
			{
				"name": "houses",
				"salience": 0.020984272,
				"type": "LOCATION"
			},
			{
				"name": "council houses",
				"salience": 0.019216742,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.017299673,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.015851023,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.015467425,
				"type": "OTHER"
			},
			{
				"name": "Mahmoud",
				"salience": 0.0149367,
				"type": "PERSON"
			},
			{
				"name": "benefits",
				"salience": 0.013294844,
				"type": "OTHER"
			},
			{
				"name": "colonizers",
				"salience": 0.012607063,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.012607063,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.012156041,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.01209672,
				"type": "PERSON"
			},
			{
				"name": "granting",
				"salience": 0.011712492,
				"type": "OTHER"
			},
			{
				"name": "reluctance",
				"salience": 0.011712492,
				"type": "OTHER"
			},
			{
				"name": "war heroes",
				"salience": 0.010740618,
				"type": "PERSON"
			},
			{
				"name": "households",
				"salience": 0.009852193,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.009160634,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.007931478,
				"type": "OTHER"
			},
			{
				"name": "luxury homes",
				"salience": 0.007914387,
				"type": "LOCATION"
			},
			{
				"name": "plans",
				"salience": 0.0077671525,
				"type": "OTHER"
			},
			{
				"name": "rate taxpayers",
				"salience": 0.007494099,
				"type": "PERSON"
			},
			{
				"name": "taxpayers",
				"salience": 0.007494099,
				"type": "PERSON"
			},
			{
				"name": "mother",
				"salience": 0.0063184346,
				"type": "PERSON"
			},
			{
				"name": "hero",
				"salience": 0.0062419195,
				"type": "PERSON"
			},
			{
				"name": "migration",
				"salience": 0.0061919177,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0061919177,
				"type": "PERSON"
			},
			{
				"name": "benefits",
				"salience": 0.0061919177,
				"type": "OTHER"
			},
			{
				"name": "firms",
				"salience": 0.006029407,
				"type": "ORGANIZATION"
			},
			{
				"name": "service personnel",
				"salience": 0.005318253,
				"type": "PERSON"
			},
			{
				"name": "equivalent",
				"salience": 0.0051815845,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0050782277,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/036nz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Government"
				},
				"name": "Government",
				"salience": 0.004837893,
				"type": "ORGANIZATION"
			},
			{
				"name": "mortgage",
				"salience": 0.0045859357,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.0045859357,
				"type": "OTHER"
			},
			{
				"name": "housing handouts",
				"salience": 0.0045859357,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0045859357,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.004340028,
				"type": "PERSON"
			},
			{
				"name": "rules",
				"salience": 0.004065553,
				"type": "OTHER"
			},
			{
				"name": "salary",
				"salience": 0.0039718878,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0038437224,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0034015463,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cxx_t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MigrationWatch_UK"
				},
				"name": "Migration Watch",
				"salience": 0.0032344924,
				"type": "ORGANIZATION"
			},
			{
				"name": "homes",
				"salience": 0.0029296775,
				"type": "LOCATION"
			},
			{
				"name": "families",
				"salience": 0.0028601494,
				"type": "PERSON"
			},
			{
				"name": "housing",
				"salience": 0.0028507868,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0027708623,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ends",
				"salience": 0.0025608172,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.0025518874,
				"type": "OTHER"
			},
			{
				"name": "military",
				"salience": 0.0025172846,
				"type": "ORGANIZATION"
			},
			{
				"name": "UK Daily Mail",
				"salience": 0.0024458696,
				"type": "ORGANIZATION"
			},
			{
				"name": "standing controversy",
				"salience": 0.0024342458,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0024160554,
				"type": "PERSON"
			},
			{
				"name": "Charmaine",
				"salience": 0.0023379999,
				"type": "PERSON"
			},
			{
				"name": "freeloaders",
				"salience": 0.002315595,
				"type": "PERSON"
			},
			{
				"name": "homes",
				"salience": 0.0022886219,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.00223134,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gccgj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/TaxPayers'_Alliance"
				},
				"name": "TaxPayers' Alliance",
				"salience": 0.0022116404,
				"type": "ORGANIZATION"
			},
			{
				"name": "pre-fab homes",
				"salience": 0.0022032384,
				"type": "ORGANIZATION"
			},
			{
				"name": "taxpayers",
				"salience": 0.0021667888,
				"type": "PERSON"
			},
			{
				"name": "need",
				"salience": 0.002092271,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0020162356,
				"type": "PERSON"
			},
			{
				"name": "spokesperson",
				"salience": 0.0018891918,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0018891918,
				"type": "ORGANIZATION"
			},
			{
				"name": "authorities",
				"salience": 0.0018891918,
				"type": "PERSON"
			},
			{
				"name": "council home",
				"salience": 0.0018685304,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0018685304,
				"type": "LOCATION"
			},
			{
				"name": "more",
				"salience": 0.0018431857,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08d6xc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Acton,_Cheshire"
				},
				"name": "Acton",
				"salience": 0.0018056703,
				"type": "LOCATION"
			},
			{
				"name": "ends",
				"salience": 0.0017957888,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.0017895246,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0017877704,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0017390103,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.0017390103,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.0017390103,
				"type": "LOCATION"
			},
			{
				"name": "migration",
				"salience": 0.0017227466,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00169424,
				"type": "PERSON"
			},
			{
				"name": "Jonathan Isaby",
				"salience": 0.0016734204,
				"type": "PERSON"
			},
			{
				"name": "invasion",
				"salience": 0.0016432995,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0016359615,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0016359615,
				"type": "PERSON"
			},
			{
				"name": "litters",
				"salience": 0.0016359615,
				"type": "OTHER"
			},
			{
				"name": "wives",
				"salience": 0.0016359615,
				"type": "PERSON"
			},
			{
				"name": "priority",
				"salience": 0.0016359615,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0016359615,
				"type": "PERSON"
			},
			{
				"name": "taxpayers",
				"salience": 0.0015483185,
				"type": "PERSON"
			},
			{
				"name": "heroes",
				"salience": 0.0015287997,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.0015287997,
				"type": "OTHER"
			},
			{
				"name": "housing lettings",
				"salience": 0.001524,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0014671237,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0014671237,
				"type": "OTHER"
			},
			{
				"name": "cry",
				"salience": 0.001441164,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0014123688,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0014123688,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0014064583,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0013959435,
				"type": "LOCATION"
			},
			{
				"name": "building",
				"salience": 0.0013246854,
				"type": "LOCATION"
			},
			{
				"name": "servicemen",
				"salience": 0.0013246854,
				"type": "OTHER"
			},
			{
				"name": "taxpayers",
				"salience": 0.0013216026,
				"type": "PERSON"
			},
			{
				"name": "war heroes",
				"salience": 0.0012964889,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0012924182,
				"type": "OTHER"
			},
			{
				"name": "ministers",
				"salience": 0.0012761346,
				"type": "PERSON"
			},
			{
				"name": "demand",
				"salience": 0.0012752434,
				"type": "OTHER"
			},
			{
				"name": "housing demand",
				"salience": 0.0012752434,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.001266631,
				"type": "LOCATION"
			},
			{
				"name": "council house",
				"salience": 0.001266631,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07pql3r"
				},
				"name": "Army",
				"salience": 0.001265192,
				"type": "ORGANIZATION"
			},
			{
				"name": "Queen",
				"salience": 0.0011977409,
				"type": "PERSON"
			},
			{
				"name": "benefits",
				"salience": 0.001192728,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.001176545,
				"type": "OTHER"
			},
			{
				"name": "influx",
				"salience": 0.0011470827,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.0011470827,
				"type": "OTHER"
			},
			{
				"name": "advantage",
				"salience": 0.0011470827,
				"type": "OTHER"
			},
			{
				"name": "wave",
				"salience": 0.0011470827,
				"type": "OTHER"
			},
			{
				"name": "housing crisis",
				"salience": 0.0011470827,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0011470827,
				"type": "PERSON"
			},
			{
				"name": "paper",
				"salience": 0.0011470827,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.0011092203,
				"type": "OTHER"
			},
			{
				"name": "housing strategy",
				"salience": 0.001104266,
				"type": "OTHER"
			},
			{
				"name": "supply",
				"salience": 0.001104266,
				"type": "OTHER"
			},
			{
				"name": "horrors",
				"salience": 0.001104266,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.001104266,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.001104266,
				"type": "OTHER"
			},
			{
				"name": "properties",
				"salience": 0.001104266,
				"type": "LOCATION"
			},
			{
				"name": "house building programme",
				"salience": 0.001104266,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.001104266,
				"type": "ORGANIZATION"
			},
			{
				"name": "residents",
				"salience": 0.001104266,
				"type": "PERSON"
			},
			{
				"name": "destination",
				"salience": 0.001104266,
				"type": "LOCATION"
			},
			{
				"name": "amenities",
				"salience": 0.001104266,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.001104266,
				"type": "OTHER"
			},
			{
				"name": "housing benefits",
				"salience": 0.0010914219,
				"type": "OTHER"
			},
			{
				"name": "Outrage",
				"salience": 0.001081443,
				"type": "OTHER"
			},
			{
				"name": "colonizers",
				"salience": 0.001081443,
				"type": "PERSON"
			},
			{
				"name": "duty",
				"salience": 0.001081443,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.001081443,
				"type": "OTHER"
			},
			{
				"name": "grounds",
				"salience": 0.001081443,
				"type": "LOCATION"
			},
			{
				"name": "rank",
				"salience": 0.0010766127,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0010598318,
				"type": "PERSON"
			},
			{
				"name": "costs",
				"salience": 0.0010189129,
				"type": "OTHER"
			},
			{
				"name": "Rob E",
				"salience": 0.0010070027,
				"type": "PERSON"
			},
			{
				"name": "h",
				"salience": 0.0010070027,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/047vl6j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cornwall_Council"
				},
				"name": "Cornwall County Council",
				"salience": 0.0010040457,
				"type": "ORGANIZATION"
			},
			{
				"name": "taxpayer",
				"salience": 0.0009625566,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.00096049265,
				"type": "PERSON"
			},
			{
				"name": "Andrew Kerr",
				"salience": 0.00095043355,
				"type": "PERSON"
			},
			{
				"name": "Rob Mather",
				"salience": 0.00095043355,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cm2xh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_I"
				},
				"name": "First World War",
				"salience": 0.00094102236,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.0009364382,
				"type": "OTHER"
			},
			{
				"name": "accommodation",
				"salience": 0.0009364382,
				"type": "OTHER"
			},
			{
				"name": "brain damage",
				"salience": 0.0009364382,
				"type": "OTHER"
			},
			{
				"name": "brain tumor",
				"salience": 0.0009364382,
				"type": "OTHER"
			},
			{
				"name": "corporal",
				"salience": 0.0009364382,
				"type": "PERSON"
			},
			{
				"name": "horse",
				"salience": 0.0009364382,
				"type": "OTHER"
			},
			{
				"name": "head injuries",
				"salience": 0.0009364382,
				"type": "OTHER"
			},
			{
				"name": "seizure",
				"salience": 0.0009364382,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0009177235,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02dbz_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslims_(nationality)"
				},
				"name": "Muslims",
				"salience": 0.0009030492,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00090221595,
				"type": "LOCATION"
			},
			{
				"name": "UK Express",
				"salience": 0.00087588775,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.0008607369,
				"type": "OTHER"
			},
			{
				"name": "Home",
				"salience": 0.00081953796,
				"type": "OTHER"
			},
			{
				"name": "invaders",
				"salience": 0.0008078518,
				"type": "PERSON"
			},
			{
				"name": "state handouts",
				"salience": 0.0008078518,
				"type": "OTHER"
			},
			{
				"name": "mortgages",
				"salience": 0.0008078518,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05_5p5w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Second_Anglo-Afghan_War"
				},
				"name": "Afghan War",
				"salience": 0.0007979955,
				"type": "EVENT"
			},
			{
				"name": "migration",
				"salience": 0.00079488737,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00079488737,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.00075948983,
				"type": "LOCATION"
			},
			{
				"name": "standing controversy",
				"salience": 0.00075821497,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0007525447,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d1_f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elizabeth_II"
				},
				"name": "Queen",
				"salience": 0.0007372027,
				"type": "PERSON"
			},
			{
				"name": "taxpayers",
				"salience": 0.00071903213,
				"type": "PERSON"
			},
			{
				"name": "Jamie Streets",
				"salience": 0.0007187385,
				"type": "LOCATION"
			},
			{
				"name": "rent",
				"salience": 0.0006995196,
				"type": "OTHER"
			},
			{
				"name": "human",
				"salience": 0.0006995196,
				"type": "PERSON"
			},
			{
				"name": "husband",
				"salience": 0.0006995196,
				"type": "PERSON"
			},
			{
				"name": "expense",
				"salience": 0.0006995196,
				"type": "OTHER"
			},
			{
				"name": "eight",
				"salience": 0.0006995196,
				"type": "OTHER"
			},
			{
				"name": "citizenship",
				"salience": 0.00069380313,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00067395286,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ljwb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Household_Cavalry"
				},
				"name": "Household Cavalry",
				"salience": 0.00066560844,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.00065475574,
				"type": "LOCATION"
			},
			{
				"name": "street",
				"salience": 0.0006516269,
				"type": "LOCATION"
			},
			{
				"name": "level",
				"salience": 0.0006516269,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00064072094,
				"type": "PERSON"
			},
			{
				"name": "issues",
				"salience": 0.00062405993,
				"type": "OTHER"
			},
			{
				"name": "rocket",
				"salience": 0.0005883412,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.0005883412,
				"type": "PERSON"
			},
			{
				"name": "rules",
				"salience": 0.0005883412,
				"type": "OTHER"
			},
			{
				"name": "refurbishment",
				"salience": 0.0005883412,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04fh3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kosovo"
				},
				"name": "Kosovo",
				"salience": 0.0005763459,
				"type": "LOCATION"
			},
			{
				"name": "Queen",
				"salience": 0.0005387333,
				"type": "PERSON"
			},
			{
				"name": "cost",
				"salience": 0.00052689377,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.00051861885,
				"type": "OTHER"
			},
			{
				"name": "foreigner",
				"salience": 0.0005159411,
				"type": "PERSON"
			},
			{
				"name": "spokesperson",
				"salience": 0.00051172456,
				"type": "PERSON"
			},
			{
				"name": "suckers",
				"salience": 0.0005094383,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.0005094383,
				"type": "OTHER"
			},
			{
				"name": "neighbours",
				"salience": 0.0005094383,
				"type": "PERSON"
			},
			{
				"name": "half",
				"salience": 0.0005094383,
				"type": "OTHER"
			},
			{
				"name": "daughters",
				"salience": 0.0005094383,
				"type": "PERSON"
			},
			{
				"name": "sons",
				"salience": 0.0005094383,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.00048942864,
				"type": "LOCATION"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0004867494,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0nbpd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Notting_Hill"
				},
				"name": "Notting Hill",
				"salience": 0.00043051253,
				"type": "LOCATION"
			},
			{
				"name": "doorstep",
				"salience": 0.00038053168,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00038053168,
				"type": "OTHER"
			},
			{
				"name": "lifestyles",
				"salience": 0.00038053168,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.00038053168,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00037610414,
				"type": "PERSON"
			},
			{
				"name": "outrage",
				"salience": 0.0003587493,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0126hc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fulham"
				},
				"name": "Fulham",
				"salience": 0.00031351837,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "West London",
				"salience": 0.00029955397,
				"type": "LOCATION"
			},
			{
				"name": "Muslim Welfare 'Refugees' Trash",
				"salience": 0.00023418138,
				"type": "ORGANIZATION"
			},
			{
				"name": "Household Cavalry Veterans Association",
				"salience": 0.00023418138,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "PALESTINIAN",
				"salience": 0.00023418138,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/toreceivemorebenifits31_7_2012-vi.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T11:44:09.560+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "UK citizens and war heroes get cheap pre-fab houses while Muslim colonizers get taxpayer-funded luxurious council homes UK Ministers have been forced to put forward plans for pre-fabricated homes after 30,000 luxury council houses were handed out to unemployed illegal alien Muslim migrants. Migration Watch said the costs will continue to rocket if a “sustainable” level of migration is not achieved. UK Daily Mail More than 11,000 households are raking in benefits that are at least the equivalent of a higher rate taxpayers’ £47,000 salary, it was revealed last month. According to official figures, thousands of Muslim migrant families on benefits are living in luxury homes, with many receiving housing handouts of about £5,000 per month – enough to fund a £1million mortgage. Jonathan Isaby, of the TaxPayers’ Alliance, said: ‘Many taxpayers struggling to make ends meet will find it incredibly unfair that some people are drawing more in benefits than they’ve ever actually earned themselves. UK Express (h/t Rob E) A spokesperson said: “There is a long standing controversy over the granting of social housing to immigrants. This has not been helped by local authorities’ reluctance to publish the relevant information. “Some immigrant groups have very low use of social housing whereas others are more likely to be in social housing than the UK born. There is absolutely nothing in the rules that state that immigrants should get preferential treatment. “However, priority for social housing is largely determined by need and so some ‘high need’ immigrant families (with multiple wives and large litters of kids) will gain access to housing over longer standing local residents deemed to be of lower need. This can be contentious. The 100,000 pre-fab homes(below) proposed by the Government are a far cry from those properties “fit for heroes” and service personnel who were awarded social housing on their return from the horrors of the First World War. “In the future, any housing strategy must address both supply and demand. The Muslim invasion is a major part of housing demand. “Unless net migration is reduced to a manageable and sustainable level a large house building programme will have to continue indefinitely, with all the costs and loss of amenities involved.” A white paper due out next month includes measures to encourage banks to lend to firms which construct off-site before delivering them to their final destination. A Government source said: “The first and most obvious advantage is speeding up the building of housing. “There is pretty good evidence that if you did it at scale it is cheaper.” This has pushed ministers to plan a new wave of pre-made homes to solve the housing crisis. The prefabricated homes can be built off site in as little as a day and take just 48 hours to install on a site. Jonathan Isaby, of the TaxPayers’ Alliance, said: ‘Many taxpayers struggling to make ends meet will find it incredibly unfair that some people are drawing more in benefits than they’ve ever actually earned themselves. But today when approximately 9,000 of our servicemen and women are sleeping rough after leaving the military, Government figures show how an influx of Muslims has seen 30,000 social housing lettings given to immigrants in 2015. Outrage as Afghan War hero who guarded the Queen is thrown out of council home From 2015, Jamie Streets, 34, spent 15 years in the Household Cavalry and suffered brain damage while on duty. But he, his wife Charmaine and their four children are to be kicked out of temporary accommodation after Cornwall County Council denied them a permanent home. Mr Streets served in both Kosovo and Afghanistan and escorted the Queen on ceremonial duty, holding the rank of corporal of horse. But he was discharged on medical grounds last year after suffering serious head injuries and a brain tumor. Although he recovered enough to return to work, he then suffered a seizure and had to leave the Army. Sorry, we decided that unemployed Muslim colonizers deserve a nicer home than war heroes In an open letter to the Prime Minister and Cornwall Council’s chief executive Andrew Kerr, the Household Cavalry Veterans Association says it is “incensed”. Signed by Secretary Rob Mather, the letter claims taxpayers’ money is spent on “lavish lifestyles and foreign aid”, while “serious issues on our own doorstep are not resolved”. “This is not acceptable treatment of one who served his Queen and country.” The seven-bedroom home in Acton, West London, where an Afghan Muslim family were placed at a cost of £2,875 a week to taxpayers UK: Muslim Welfare ‘Refugees’ Trash The £1.25 Million Home They Are Living In For Free And Laugh About It A family of PALESTINIAN MUSLIM freeloaders provoked outrage yesterday by saying they “deserve” to live in a £1.25 million taxpayer-funded luxury home (above) despite trashing it. The mother, Mrs Mahmoud, gets £20,000 a year in housing benefits to pay her rent. Yet she said: “I don’t care if people think I am not grateful. I am entitled to live in a house like this even if I don’t pay for it. “I deserve to live in a nice house and get benefits because I am human.” The family is one of at least 100 unemployed Muslim invaders living in homes on state handouts that could fund £1million mortgages. Muslim mother of eight was placed in a £2.6m house in Notting Hill, west London at the taxpayers’ expense She has since split with her husband and was given British citizenship five years ago but has never worked in this country. She moved with her two sons and five daughters to the three-bedroom house in Fulham, west London, three years ago. It had just undergone a £76,000 refurbishment, half paid for by the taxpayer. She claims her family is being persecuted because neighbours “don’t want a foreigner to come and live in this street.” Thanks for the nice council house, suckers. Migration Watch said the costs will continue to rocket if a “sustainable” level of migration is not achieved. A spokesperson said: “There is a long standing controversy over the granting of social housing to immigrants. This has not been helped by local authorities’ reluctance to publish the relevant information. There is absolutely nothing in the rules that state that immigrants should get preferential treatment.",
		"thread_title": "UK citizens and war heroes get cheap pre-fab houses while Muslim colonizers get taxpayer-funded luxurious council homes",
		"title": "UK citizens and war heroes get cheap pre-fab houses while Muslim colonizers get taxpayer-funded luxurious council homes",
		"type": "bs",
		"uuid": "63c5a29bbaee520c51d8363802d9a411fdba5f45"
	},
	"-KhIjlcfIcYuFBbKEx5D": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T02:57:52.091+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "MAYOR",
				"salience": 0.15805575,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "ITALIAN",
				"salience": 0.15484984,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.06968827,
				"type": "PERSON"
			},
			{
				"name": "mayor",
				"salience": 0.060957793,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.059641827,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.022403235,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.02222162,
				"type": "EVENT"
			},
			{
				"name": "invaders",
				"salience": 0.022027628,
				"type": "PERSON"
			},
			{
				"name": "arrivals",
				"salience": 0.021959513,
				"type": "PERSON"
			},
			{
				"name": "savages",
				"salience": 0.019262228,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.019262228,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.018037539,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.017093195,
				"type": "OTHER"
			},
			{
				"name": "mayor",
				"salience": 0.013802104,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Muslim",
				"salience": 0.011886209,
				"type": "OTHER"
			},
			{
				"name": "pig farm",
				"salience": 0.011247008,
				"type": "LOCATION"
			},
			{
				"name": "Thousands",
				"salience": 0.011182211,
				"type": "PERSON"
			},
			{
				"name": "Southern Italy Yes",
				"salience": 0.0106087215,
				"type": "ORGANIZATION"
			},
			{
				"name": "Joe Formaggio",
				"salience": 0.009896064,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.009867753,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.009867753,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.00954304,
				"type": "EVENT"
			},
			{
				"name": "pigs",
				"salience": 0.008749603,
				"type": "OTHER"
			},
			{
				"name": "tensions",
				"salience": 0.005874418,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g8m2p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Albettone"
				},
				"name": "Albettone",
				"salience": 0.005767927,
				"type": "LOCATION"
			},
			{
				"name": "mosques",
				"salience": 0.0056309327,
				"type": "LOCATION"
			},
			{
				"name": "mosques",
				"salience": 0.0056309327,
				"type": "LOCATION"
			},
			{
				"name": "niggers",
				"salience": 0.0048834537,
				"type": "OTHER"
			},
			{
				"name": "gypsies",
				"salience": 0.00469812,
				"type": "PERSON"
			},
			{
				"name": "Mayor",
				"salience": 0.0041773547,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0040688626,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0040688626,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0040688626,
				"type": "ORGANIZATION"
			},
			{
				"name": "front",
				"salience": 0.0040688626,
				"type": "OTHER"
			},
			{
				"name": "asses",
				"salience": 0.0040688626,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.0038025288,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.0037546586,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.0037546586,
				"type": "OTHER"
			},
			{
				"name": "Thousands",
				"salience": 0.0035348975,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0035131278,
				"type": "PERSON"
			},
			{
				"name": "Immigrants",
				"salience": 0.0032951606,
				"type": "PERSON"
			},
			{
				"name": "arrivals",
				"salience": 0.0032951606,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "refugees",
				"salience": 0.0032951606,
				"type": "PERSON"
			},
			{
				"name": "Mayor",
				"salience": 0.0032014982,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0031722474,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0031722474,
				"type": "PERSON"
			},
			{
				"name": "closing",
				"salience": 0.003158088,
				"type": "EVENT"
			},
			{
				"name": "farm",
				"salience": 0.0031323025,
				"type": "LOCATION"
			},
			{
				"name": "Secretary General",
				"salience": 0.0030790546,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.0030539136,
				"type": "PERSON"
			},
			{
				"name": "imports niggers",
				"salience": 0.002979564,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.002890007,
				"type": "PERSON"
			},
			{
				"name": "boats",
				"salience": 0.0028536124,
				"type": "OTHER"
			},
			{
				"name": "welcoming",
				"salience": 0.0028536124,
				"type": "EVENT"
			},
			{
				"name": "town",
				"salience": 0.0028536124,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.0027661994,
				"type": "LOCATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.0027471522,
				"type": "PERSON"
			},
			{
				"name": "routes",
				"salience": 0.0027471522,
				"type": "OTHER"
			},
			{
				"name": "freeloaders",
				"salience": 0.0027471522,
				"type": "PERSON"
			},
			{
				"name": "start",
				"salience": 0.0027471522,
				"type": "EVENT"
			},
			{
				"name": "ministry",
				"salience": 0.0027471522,
				"type": "ORGANIZATION"
			},
			{
				"name": "smuggler",
				"salience": 0.0027471522,
				"type": "PERSON"
			},
			{
				"name": "destinations",
				"salience": 0.0027471522,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0026904033,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0026904033,
				"type": "LOCATION"
			},
			{
				"name": "comments",
				"salience": 0.0026565196,
				"type": "WORK_OF_ART"
			},
			{
				"name": "h",
				"salience": 0.0025052992,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06c62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rome"
				},
				"name": "Rome",
				"salience": 0.0025052992,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d5qx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colosseum"
				},
				"name": "Coliseum",
				"salience": 0.0025052992,
				"type": "LOCATION"
			},
			{
				"name": "Brenda K",
				"salience": 0.0025052992,
				"type": "PERSON"
			},
			{
				"name": "UK Express",
				"salience": 0.0025052992,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allah"
				},
				"name": "Allah",
				"salience": 0.0025052992,
				"type": "PERSON"
			},
			{
				"name": "responses",
				"salience": 0.002466188,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.0023547783,
				"type": "PERSON"
			},
			{
				"name": "exports brains",
				"salience": 0.0023298212,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0023298212,
				"type": "OTHER"
			},
			{
				"name": "houses",
				"salience": 0.0022146339,
				"type": "LOCATION"
			},
			{
				"name": "Mayor",
				"salience": 0.0019777804,
				"type": "PERSON"
			},
			{
				"name": "comments",
				"salience": 0.0018628007,
				"type": "WORK_OF_ART"
			},
			{
				"name": "IQ",
				"salience": 0.0018192612,
				"type": "OTHER"
			},
			{
				"name": "Vento",
				"salience": 0.0017567324,
				"type": "ORGANIZATION"
			},
			{
				"name": "La Zanzara",
				"salience": 0.0017567324,
				"type": "PERSON"
			},
			{
				"name": "Radio 24",
				"salience": 0.0017567324,
				"type": "ORGANIZATION"
			},
			{
				"name": "invasion",
				"salience": 0.0017551119,
				"type": "EVENT"
			},
			{
				"name": "statements",
				"salience": 0.0017405717,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0017405717,
				"type": "PERSON"
			},
			{
				"name": "problems",
				"salience": 0.0017405717,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mediterranean_Sea"
				},
				"name": "Mediterranean",
				"salience": 0.0016911679,
				"type": "LOCATION"
			},
			{
				"name": "Albetton",
				"salience": 0.0014832948,
				"type": "PERSON"
			},
			{
				"name": "invasion migration",
				"salience": 0.0014640103,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italians",
				"salience": 0.0012765124,
				"type": "PERSON"
			},
			{
				"name": "feelings",
				"salience": 0.0012677179,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0012677179,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.0012677179,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0012677179,
				"type": "LOCATION"
			},
			{
				"name": "values",
				"salience": 0.0012677179,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.0012677179,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protests",
				"salience": 0.0012677179,
				"type": "EVENT"
			},
			{
				"name": "Vicenza Chamber",
				"salience": 0.0012372558,
				"type": "ORGANIZATION"
			},
			{
				"name": "The Chamber of Vicenza",
				"salience": 0.0012372558,
				"type": "ORGANIZATION"
			},
			{
				"name": "niggers",
				"salience": 0.0012112705,
				"type": "OTHER"
			},
			{
				"name": "None",
				"salience": 0.0012050178,
				"type": "OTHER"
			},
			{
				"name": "gypsies",
				"salience": 0.0010936488,
				"type": "PERSON"
			},
			{
				"name": "shooting range",
				"salience": 0.0010349109,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.001021869,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00095908303,
				"type": "PERSON"
			},
			{
				"name": "licenses",
				"salience": 0.0009469964,
				"type": "OTHER"
			},
			{
				"name": "barricades",
				"salience": 0.0009469964,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.0009469964,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0009469964,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0009469964,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.0009469964,
				"type": "LOCATION"
			},
			{
				"name": "Giampaolo Zanni",
				"salience": 0.000931853,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bzjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Veneto"
				},
				"name": "Veneto",
				"salience": 0.00058282726,
				"type": "LOCATION"
			},
			{
				"name": "Gorino",
				"salience": 0.00058282726,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/fX73ggsMNEI/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T02:57:52.091+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "ITALIAN MAYOR blasted for scathing verbal attack on African Muslim savages who have been invading Southern Italy Yes, his words may be racist and anti-Muslim, but look at the videos below to see what African Muslim illegal alien invaders are bringing to Italy and you won’t be so quick to condemn him. What would you say if they did the same thing in your cities? Thousands of Muslims lift their asses to Allah in front of the Coliseum in Rome to protest the government’s closing of hundreds of illegal mosques UK Express (h/t Brenda K) An Italian mayor has come under fire after saying he will shoot ’niggers and gypsies’ and build a pig farm next to mosques as tensions continue to rise over the illegal alien Muslim invasion of southern Italy. More than 160,000 economic freeloaders posing as asylum seekers have been housed in Italy since the start of 2014, according to date from the interior ministry. Italy has been one of the first destinations along migrants typical routes for months, receiving thousands of new arrivals who continue to risk their lives to cross the Mediterranean on rickety smuggler’s boats. But many have been critical of the welcoming of so many refugees – and now one Mayor from the town of Albettone in Vento has launched a scathing attack on the new arrivals. Speaking on La Zanzara on Radio 24, Joe Formaggio said: “Immigrants? If they send them to us, we will protect our houses. We are proud to be racists.” The mayor claims his city “exports brains and imports niggers” who “are less intelligent than us, they are inferior”. Amid possible plans to open a mosque in the city, he claimed he would open a “large farm of pigs if they open a mosque here”. Mr Formaggio added: ”If refugees are sent here to Albettone, the barricades in Gorino will be seen as nothing. “Here we do not want immigrants, niggers or gypsies. They have a lower IQ: history proves it. “We have a shooting range and the highest number of licenses to carry weapons in the whole Veneto region. “And we do not want anyone to come and bother us. They risk their lives around us.” The comments were deemed so strong that the Secretary General of the Vicenza Chamber has been forced to intervene. Calling the comments “irresponsible”, Giampaolo Zanni said: “The Chamber of Vicenza totally rejects the Mayor of Albetton’s statements about the black population. “None of us underestimates the problems arising from illegal alien Muslim invasion migration. “But responses like those of the Mayor of Albettone are not only xenophobic and racist, but are also dangerous as they encourage feelings of racial hatred, and therefore are in stark contrast to the values of our constitution.” Thousands of Italians have come out in large protests against the never-ending Muslim invasion of their country.",
		"thread_title": "ITALIAN MAYOR blasted for scathing verbal attack on African Muslim savages who have been invading Southern Italy",
		"title": "ITALIAN MAYOR blasted for scathing verbal attack on African Muslim savages who have been invading Southern Italy",
		"type": "bs",
		"uuid": "dbd8814b25c1decf56d48b5e86e1c4356932ee6c"
	},
	"-KhIjlzY1TdIfyQvsRIU": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T14:03:30.276+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0vkm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_Liberties_Union"
				},
				"name": "American Civil Liberties Union",
				"salience": 0.1252211,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.09645741,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.05113582,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "CAIR",
				"salience": 0.031176401,
				"type": "ORGANIZATION"
			},
			{
				"name": "teacher",
				"salience": 0.024975084,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.024332661,
				"type": "PERSON"
			},
			{
				"name": "sixth grade teacher",
				"salience": 0.023897262,
				"type": "PERSON"
			},
			{
				"name": "terrorist",
				"salience": 0.020714136,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.018916043,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.017337877,
				"type": "PERSON"
			},
			{
				"name": "ARIZONA Charter School",
				"salience": 0.016860507,
				"type": "ORGANIZATION"
			},
			{
				"name": "Store",
				"salience": 0.016183723,
				"type": "LOCATION"
			},
			{
				"name": "Heather Weaver",
				"salience": 0.015627813,
				"type": "PERSON"
			},
			{
				"name": "immigrant",
				"salience": 0.015594399,
				"type": "PERSON"
			},
			{
				"name": "complaints",
				"salience": 0.01493991,
				"type": "OTHER"
			},
			{
				"name": "student",
				"salience": 0.014351073,
				"type": "PERSON"
			},
			{
				"name": "charter school",
				"salience": 0.014003264,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somali",
				"salience": 0.013528101,
				"type": "LOCATION"
			},
			{
				"name": "AOE",
				"salience": 0.01299123,
				"type": "ORGANIZATION"
			},
			{
				"name": "shadows",
				"salience": 0.012575602,
				"type": "OTHER"
			},
			{
				"name": "stench",
				"salience": 0.012575602,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.012575602,
				"type": "PERSON"
			},
			{
				"name": "assault",
				"salience": 0.012575602,
				"type": "EVENT"
			},
			{
				"name": "harassment",
				"salience": 0.012575602,
				"type": "OTHER"
			},
			{
				"name": "student",
				"salience": 0.012482375,
				"type": "PERSON"
			},
			{
				"name": "teacher",
				"salience": 0.011363673,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0110697625,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d35y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix,_Arizona"
				},
				"name": "Phoenix",
				"salience": 0.009004506,
				"type": "LOCATION"
			},
			{
				"name": "teacher",
				"salience": 0.00839102,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0077705774,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.007753979,
				"type": "ORGANIZATION"
			},
			{
				"name": "teacher",
				"salience": 0.0076802084,
				"type": "PERSON"
			},
			{
				"name": "sister",
				"salience": 0.0074455123,
				"type": "PERSON"
			},
			{
				"name": "terrorist",
				"salience": 0.0073268227,
				"type": "PERSON"
			},
			{
				"name": "Education",
				"salience": 0.006435855,
				"type": "OTHER"
			},
			{
				"name": "sixth grade teacher",
				"salience": 0.0060020513,
				"type": "PERSON"
			},
			{
				"name": "Muslims",
				"salience": 0.0059574163,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.005920944,
				"type": "PERSON"
			},
			{
				"name": "charter school",
				"salience": 0.0057811257,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.0057811257,
				"type": "LOCATION"
			},
			{
				"name": "Excellence Charter School",
				"salience": 0.0056675784,
				"type": "ORGANIZATION"
			},
			{
				"name": "Academy of Excellence",
				"salience": 0.0054861763,
				"type": "ORGANIZATION"
			},
			{
				"name": "allegations",
				"salience": 0.0054074693,
				"type": "OTHER"
			},
			{
				"name": "sixth grade teacher",
				"salience": 0.0052884547,
				"type": "PERSON"
			},
			{
				"name": "Obama Departments of Justice",
				"salience": 0.004577456,
				"type": "ORGANIZATION"
			},
			{
				"name": "teacher",
				"salience": 0.004429396,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0043367436,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.0043367436,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ABC15",
				"salience": 0.003964426,
				"type": "ORGANIZATION"
			},
			{
				"name": "complaints",
				"salience": 0.0038616944,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.003853457,
				"type": "EVENT"
			},
			{
				"name": "Detective",
				"salience": 0.003853457,
				"type": "PERSON"
			},
			{
				"name": "allegations",
				"salience": 0.003808684,
				"type": "OTHER"
			},
			{
				"name": "Academy",
				"salience": 0.0036709004,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist",
				"salience": 0.0036295159,
				"type": "OTHER"
			},
			{
				"name": "teacher",
				"salience": 0.0035713336,
				"type": "PERSON"
			},
			{
				"name": "teacher",
				"salience": 0.0035713336,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0034786751,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0034348823,
				"type": "PERSON"
			},
			{
				"name": "mom",
				"salience": 0.003367241,
				"type": "PERSON"
			},
			{
				"name": "school",
				"salience": 0.0033114678,
				"type": "LOCATION"
			},
			{
				"name": "school",
				"salience": 0.0033114678,
				"type": "ORGANIZATION"
			},
			{
				"name": "school",
				"salience": 0.0033114678,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0031229306,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.0030624804,
				"type": "OTHER"
			},
			{
				"name": "sister",
				"salience": 0.0030624804,
				"type": "PERSON"
			},
			{
				"name": "teacher",
				"salience": 0.003029,
				"type": "PERSON"
			},
			{
				"name": "teacher",
				"salience": 0.003029,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0029503955,
				"type": "PERSON"
			},
			{
				"name": "Academy",
				"salience": 0.0029404394,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.0028199025,
				"type": "PERSON"
			},
			{
				"name": "allegation",
				"salience": 0.0026885788,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00265212,
				"type": "OTHER"
			},
			{
				"name": "nationality",
				"salience": 0.00265212,
				"type": "OTHER"
			},
			{
				"name": "occasion",
				"salience": 0.00265212,
				"type": "EVENT"
			},
			{
				"name": "state agencies",
				"salience": 0.00265212,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist",
				"salience": 0.0026441042,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0025472401,
				"type": "WORK_OF_ART"
			},
			{
				"name": "school",
				"salience": 0.0024742503,
				"type": "OTHER"
			},
			{
				"name": "mother",
				"salience": 0.0024731613,
				"type": "PERSON"
			},
			{
				"name": "classmates",
				"salience": 0.0023784942,
				"type": "PERSON"
			},
			{
				"name": "bus",
				"salience": 0.0023784942,
				"type": "OTHER"
			},
			{
				"name": "classmates",
				"salience": 0.002289752,
				"type": "PERSON"
			},
			{
				"name": "visa",
				"salience": 0.0022881534,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0022733398,
				"type": "PERSON"
			},
			{
				"name": "letters",
				"salience": 0.002173677,
				"type": "WORK_OF_ART"
			},
			{
				"name": "complaints",
				"salience": 0.0021019366,
				"type": "OTHER"
			},
			{
				"name": "victim",
				"salience": 0.0019418807,
				"type": "PERSON"
			},
			{
				"name": "bus",
				"salience": 0.0019418807,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.001859769,
				"type": "LOCATION"
			},
			{
				"name": "bus ride",
				"salience": 0.001859769,
				"type": "EVENT"
			},
			{
				"name": "comments",
				"salience": 0.001859769,
				"type": "WORK_OF_ART"
			},
			{
				"name": "visas",
				"salience": 0.0018445777,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.00180226,
				"type": "ORGANIZATION"
			},
			{
				"name": "SCHOOLS",
				"salience": 0.00180226,
				"type": "ORGANIZATION"
			},
			{
				"name": "neck",
				"salience": 0.0017903661,
				"type": "OTHER"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.0017903661,
				"type": "EVENT"
			},
			{
				"name": "statements",
				"salience": 0.0017695464,
				"type": "OTHER"
			},
			{
				"name": "allegation",
				"salience": 0.0017695464,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0017695464,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emergency window",
				"salience": 0.0017678118,
				"type": "OTHER"
			},
			{
				"name": "complaint",
				"salience": 0.0016520107,
				"type": "OTHER"
			},
			{
				"name": "suspect",
				"salience": 0.0016484837,
				"type": "PERSON"
			},
			{
				"name": "teacher",
				"salience": 0.0016484403,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0016056385,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0015703196,
				"type": "EVENT"
			},
			{
				"name": "expulsion",
				"salience": 0.0015183169,
				"type": "EVENT"
			},
			{
				"name": "school director",
				"salience": 0.0015183169,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.0015183169,
				"type": "OTHER"
			},
			{
				"name": "school rules",
				"salience": 0.0015183169,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.0015183169,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0015183169,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.0014507207,
				"type": "PERSON"
			},
			{
				"name": "mom",
				"salience": 0.0014314422,
				"type": "PERSON"
			},
			{
				"name": "payment",
				"salience": 0.0014070943,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0013893655,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letters",
				"salience": 0.0013514225,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letters",
				"salience": 0.0013514225,
				"type": "WORK_OF_ART"
			},
			{
				"name": "faith",
				"salience": 0.0013098652,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0013098652,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0012888479,
				"type": "OTHER"
			},
			{
				"name": "statements",
				"salience": 0.0012888479,
				"type": "OTHER"
			},
			{
				"name": "witnesses",
				"salience": 0.0012239048,
				"type": "PERSON"
			},
			{
				"name": "crime",
				"salience": 0.0011932554,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0011342389,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0011342389,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.0011342389,
				"type": "PERSON"
			},
			{
				"name": "motive",
				"salience": 0.0010918992,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0130mmtt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Double-A_(baseball)"
				},
				"name": "A.A.",
				"salience": 0.0010881524,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0010558558,
				"type": "OTHER"
			},
			{
				"name": "letters",
				"salience": 0.001009545,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.0009822652,
				"type": "EVENT"
			},
			{
				"name": "allegations",
				"salience": 0.0009627941,
				"type": "OTHER"
			},
			{
				"name": "Police",
				"salience": 0.0009539904,
				"type": "ORGANIZATION"
			},
			{
				"name": "both",
				"salience": 0.0008543647,
				"type": "PERSON"
			},
			{
				"name": "difference",
				"salience": 0.0008472846,
				"type": "OTHER"
			},
			{
				"name": "timing",
				"salience": 0.0008260635,
				"type": "OTHER"
			},
			{
				"name": "ISLAMIZATION",
				"salience": 0.0008260635,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0008260635,
				"type": "OTHER"
			},
			{
				"name": "contact",
				"salience": 0.0008260635,
				"type": "EVENT"
			},
			{
				"name": "plaintif",
				"salience": 0.0008260635,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0008260635,
				"type": "OTHER"
			},
			{
				"name": "footnotes",
				"salience": 0.0008260635,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0008260635,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04gs3b5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix_Police_Department"
				},
				"name": "Phoenix Police Department",
				"salience": 0.00080621126,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0008018691,
				"type": "EVENT"
			},
			{
				"name": "victim jihad",
				"salience": 0.0007852019,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.00071262434,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00071262434,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.00071262434,
				"type": "OTHER"
			},
			{
				"name": "AOE",
				"salience": 0.00070392917,
				"type": "ORGANIZATION"
			},
			{
				"name": "statement",
				"salience": 0.000666501,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Administration",
				"salience": 0.00061705563,
				"type": "ORGANIZATION"
			},
			{
				"name": "situation",
				"salience": 0.00061705563,
				"type": "OTHER"
			},
			{
				"name": "Academy of Excellence Charter School Governing Board",
				"salience": 0.00052581663,
				"type": "ORGANIZATION"
			},
			{
				"name": "AOE",
				"salience": 0.00052581663,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/rmuslimschoolprayerlarge5701-vi.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T14:03:30.276+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 19.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 2 2016 ARIZONA Charter School teacher accused of harassment and assault of Somali Muslim student just because he is a Muslim Does anyone else smell the stench of designated terrorist group CAIR lurking in the shadows? A sixth grade teacher at the Academy of Excellence, a public charter school in Phoenix, allegedly said to a Muslim student: “You’re a terrorist. I can’t wait until Trump is elected. He’s going to deport you all.” The ACLU has since filed complaints with the Obama Departments of Justice and Education. ABC15 The American Civil Liberties Union says a Somali Muslim immigrant and his sister were expelled from a Phoenix school after a sixth grade teacher allegedly discriminated against him. The complaints were made against Academy of Excellence Charter School, a public charter school in Phoenix. According to a letter sent to both state agencies, the 11-year-old student allegedly was targeted by his sixth grade teacher multiple times during the 2015-2016 school year. The letter accuses the teacher of singling out the student because of his religion and/or nationality. On one occasion, the teacher allegedly showed a video about the Sept. 11 2001 terrorist attacks. The teacher is accused of then telling the student “That’s going to be you,” suggesting that he was to become a terrorist himself, ACLU attorney Heather Weaver said. Earlier in the school year, the same teacher had refused to let A.A. pray during class one day , and is also accused of grabbing the student by his neck and choking him because he would not stop talking with his classmates . The letter said that, during a separate incident in which the teacher was speaking about Donald Trump, she turned to the student and said, “I can’t wait until Trump is elected. He’s going to deport all you Muslims. Muslims shouldn’t be given visas. They’ll probably take away your visa and deport you. You’re going to be the next terrorist, I bet.” Because of the teacher’s comments claimed by the ACLU, the student allegedly was teased by classmates on the bus ride home that day and was accused of plotting to blow up the bus, calling him a “terrorist.” She then allegedly threatened the student, saying “If you tell your mom (about the abuse), watch what happens next.” The ACLU said that when the alleged victim’s mom complained to the school, the school director sided with the teacher, stating that she had done nothing wrong. The student was accused of breaking school rules by opening an emergency window while riding on the bus. As a result, both he and his sister – a second grader at the same school – were expelled; effective immediately. The complaints against the teacher were’t lodged until after the students’ expulsion from the school. The Academy of Excellence Charter School is refuting the claims. They’ve since released a statement regarding the situation, calling the allegations false. “The Academy of Excellence Charter School Governing Board and Administration (“AOE”) refutes the allegations contained in two letters from the ACLU. Those letters, both of which are dated October 28, 2016, are devoid of any evidence and contain false and unsubstantiated allegations. AOE conducted an internal investigation on January 25, 2016. That investigation produced no evidence to support the claims now being made . Additionally, these allegations were investigated by the Phoenix Police Department but at that time, her only complaint was that “she believed that her children were kicked out of our school due to their Muslim faith.” AOE has many children who practice the Muslim faith. It was not until February 24, 2016, that the mother and her son made the allegation of ‘choking.’ This allegation was investigated by a Detective who found that, ‘At the conclusion of the investigation, a crime in this matter was unfounded. Both suspect and witnesses provided corroborating statements, and were not consistent with the victims’ statement.’ This is the “cursory and inadequate” investigation the ACLU notes in the footnotes to its letters. Finally, if you compare the timing of events contained in the ACLU’s letters and the statements made to the Police by the teacher and the student, they are completely different. The difference between the statements calls into question the motive of the plaintif. AOE’s first contact from the ACLU sought a substantial monetary payment.” (DING DING DING! It’s always about the money) See more “victim jihad” in public schools: ISLAMIZATION OF SCHOOLS",
		"thread_title": "ARIZONA Charter School teacher accused of harassment and assault of Somali Muslim student just because he is a Muslim",
		"title": "ARIZONA Charter School teacher accused of harassment and assault of Somali Muslim student just because he is a Muslim",
		"type": "bs",
		"uuid": "4f92026b4fd58361d5cd81850297ba2bb5e10f5f"
	},
	"-KhIjmA28YTfddWmiXYy": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T14:03:30.328+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Weiner & Abedin",
				"salience": 0.260477,
				"type": "PERSON"
			},
			{
				"name": "@ 3",
				"salience": 0.06879445,
				"type": "OTHER"
			},
			{
				"name": "plethora",
				"salience": 0.056264896,
				"type": "PERSON"
			},
			{
				"name": "cynic",
				"salience": 0.04597992,
				"type": "PERSON"
			},
			{
				"name": "@ 2",
				"salience": 0.03831144,
				"type": "OTHER"
			},
			{
				"name": "Mohammed Wazza Paedo",
				"salience": 0.037936162,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.032334678,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.029150426,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.020507775,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.020507775,
				"type": "OTHER"
			},
			{
				"name": "being",
				"salience": 0.017845009,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.017711932,
				"type": "WORK_OF_ART"
			},
			{
				"name": "breath",
				"salience": 0.016540887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.015098072,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.014590263,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.014590263,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.014391865,
				"type": "OTHER"
			},
			{
				"name": "sections",
				"salience": 0.013855719,
				"type": "OTHER"
			},
			{
				"name": "batch",
				"salience": 0.013855719,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.013855719,
				"type": "EVENT"
			},
			{
				"name": "đ",
				"salience": 0.0136814695,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0135699,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0131543465,
				"type": "WORK_OF_ART"
			},
			{
				"name": "means",
				"salience": 0.012842469,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.012842469,
				"type": "OTHER"
			},
			{
				"name": "shakeup",
				"salience": 0.010893601,
				"type": "OTHER"
			},
			{
				"name": "@ 4",
				"salience": 0.01023587,
				"type": "OTHER"
			},
			{
				"name": "mud stick",
				"salience": 0.010225252,
				"type": "OTHER"
			},
			{
				"name": "Criminal Clinton",
				"salience": 0.009854278,
				"type": "PERSON"
			},
			{
				"name": "answers",
				"salience": 0.008783498,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.008783498,
				"type": "OTHER"
			},
			{
				"name": "man switch",
				"salience": 0.008783498,
				"type": "OTHER"
			},
			{
				"name": "blackmail value",
				"salience": 0.008783498,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02hx8_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Intelligence_Community"
				},
				"name": "Intelligence Community",
				"salience": 0.008534411,
				"type": "ORGANIZATION"
			},
			{
				"name": "Obamination",
				"salience": 0.008358197,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/082xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Winston_Churchill"
				},
				"name": "Sir Winston Churchill",
				"salience": 0.0077118482,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0072384556,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09w3b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Pentagon"
				},
				"name": "Pentagon",
				"salience": 0.0072384556,
				"type": "ORGANIZATION"
			},
			{
				"name": "Moe",
				"salience": 0.0072384556,
				"type": "PERSON"
			},
			{
				"name": "Rumor",
				"salience": 0.0066468567,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.0063989093,
				"type": "LOCATION"
			},
			{
				"name": "mountain lion",
				"salience": 0.0063989093,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0059303883,
				"type": "OTHER"
			},
			{
				"name": "Don Spilman",
				"salience": 0.0054083043,
				"type": "PERSON"
			},
			{
				"name": "email archive folder",
				"salience": 0.0053585665,
				"type": "OTHER"
			},
			{
				"name": "life insurance",
				"salience": 0.0047808457,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.0047808457,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0029429256,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/ov5kvWSz5LM/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T13:14:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "November 2, 2016 @ 3:20 am \nCount me in. Mohammed Wazza Paedo November 2, 2016 @ 2:52 am \nSounds great, but the cynic in me tells me that I’ve heard similar for the the last 3 or 4 years, that this or that is gonna happen to Obama or Clinton etc etc & of course nothing ever did. Seeing is believing. That being said, this time with the release of the latest batch of Criminal Clinton’s, Weiner & Abedin emails, I think this time there’s enough to make the mud stick. Especially now that the Intelligence Community & sections of the FBI are really pissed off. I won’t be holding my breath, but as Sir Winston Churchill once said “A week is a long time in politics”. Dajjal November 2, 2016 @ 4:33 am \nMoe, there are many pissed off people in the CIA, FBI & Pentagon plus a plethora who were purged, who have scores to settle with Obamination and some of them have the means. đ We may never know who really tipped off Wikileaks, it may be an inside job. \nRumor has it the email archive folder on Weiner’s laptop was named “life insurance”. Did Weiner archive those emails for their blackmail value? Did he contemplate triggering a dead man switch? Too many questions, not enough answers. Don Spilman November 2, 2016 @ 2:29 am \nThere is going to be some major shakeup. Thank you BNI I sent this immediately to my base. These are very vile evil people we are dealing with and they will react like a cornered mountain lion. The next few days are going to be interesting.",
		"thread_title": "U.S. Intelligence Community’s Counter-Coup against Hillary Clinton’s Coup",
		"title": "U.S. Intelligence Community’s Counter-Coup against Hillary Clinton’s Coup",
		"type": "bs",
		"uuid": "908b226ce92b95c2370b8719b09603e48feb57d9"
	},
	"-KhIjmLDOOJuGhkiM51E": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:25:40.385+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.34503096,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01p3n8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Matthews"
				},
				"name": "Chris Mathews",
				"salience": 0.120169245,
				"type": "PERSON"
			},
			{
				"name": "SHOCKER",
				"salience": 0.09506436,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.049308408,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.03844184,
				"type": "PERSON"
			},
			{
				"name": "fireworks display",
				"salience": 0.032386817,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.03053953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07syddx"
				},
				"name": "Left Wing",
				"salience": 0.03053953,
				"type": "ORGANIZATION"
			},
			{
				"name": "election",
				"salience": 0.02363864,
				"type": "EVENT"
			},
			{
				"name": "meantime",
				"salience": 0.02048979,
				"type": "OTHER"
			},
			{
				"name": "fireworks",
				"salience": 0.019893529,
				"type": "OTHER"
			},
			{
				"name": "displsy",
				"salience": 0.01873504,
				"type": "OTHER"
			},
			{
				"name": "firefighters",
				"salience": 0.016259015,
				"type": "PERSON"
			},
			{
				"name": "victory celebration",
				"salience": 0.014393526,
				"type": "EVENT"
			},
			{
				"name": "explosion",
				"salience": 0.014393526,
				"type": "EVENT"
			},
			{
				"name": "fuse",
				"salience": 0.013858526,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.013858526,
				"type": "OTHER"
			},
			{
				"name": "fireworks display",
				"salience": 0.01315851,
				"type": "OTHER"
			},
			{
				"name": "sparkles",
				"salience": 0.010296633,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Night",
				"salience": 0.008873965,
				"type": "ORGANIZATION"
			},
			{
				"name": "balloon drop",
				"salience": 0.0075540296,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cvyp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hudson_River"
				},
				"name": "Hudson River",
				"salience": 0.0072477125,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "NY Post",
				"salience": 0.0072477125,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYC Cops",
				"salience": 0.0072477125,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.0072477125,
				"type": "LOCATION"
			},
			{
				"name": "half-price",
				"salience": 0.0064079673,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02d2xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.005416833,
				"type": "EVENT"
			},
			{
				"name": "hubris",
				"salience": 0.0047888737,
				"type": "OTHER"
			},
			{
				"name": "shower",
				"salience": 0.0047888737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ncdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Trump_Organization"
				},
				"name": "Trump",
				"salience": 0.004557009,
				"type": "PERSON"
			},
			{
				"name": "Somebody",
				"salience": 0.004219094,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05p1sxd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_Jefferson_Avenue_Residential_TR"
				},
				"name": "East Side",
				"salience": 0.0039465423,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/oSSfA0FqoNQ/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:25:40.385+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "SHOCKER!!! Left Wing MSNBC commentator Chris Mathews has just endorsed Donald Trump for president In the meantime, Hillary Clinton has just ordered a fireworks display to celebrate her winning the election on Nov. 8th. But this could blow up in her face! Hillary Clinton may have lit the fuse for her victory celebration a little too soon — by planning an Election Night explosion of fireworks over the Hudson River in New York City. NY Post NYC Cops and firefighters were blown away by Clinton’s hubris in planning the fireworks display, which would eclipse the shower of blazing sparkles that preceded the balloon drop at July’s Democratic National Convention. Somebody asked “If she loses, will she take the displsy over to the East Side and sell it to Trump for half-price?”",
		"thread_title": "SHOCKER!!! Left Wing MSNBC commentator Chris Mathews has just endorsed Donald Trump for president",
		"title": "SHOCKER!!! Left Wing MSNBC commentator Chris Mathews has just endorsed Donald Trump for president",
		"type": "bs",
		"uuid": "c54124d59506ef7817981443764142208c3dc69e"
	},
	"-KhIjmTb1ORRFkU7Xl5g": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:25:40.987+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/eUZXKNSuzeU/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:25:40.987+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "University of Wisconsin Saudi Muslim student beaten to death",
		"title": "University of Wisconsin Saudi Muslim student beaten to death",
		"type": "bs",
		"uuid": "2caf524fe924ca1bc2d2fd13cca5ec0d310f9ff9"
	},
	"-KhIjmZtrDarcgAdHNCR": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T18:25:42.574+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "speakers",
				"salience": 0.5854553,
				"type": "PERSON"
			},
			{
				"name": "synagogue",
				"salience": 0.0629521,
				"type": "ORGANIZATION"
			},
			{
				"name": "Terrorist Group CAIR",
				"salience": 0.050069764,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05t9kz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_G._Boykin"
				},
				"name": "Jerry Boykin",
				"salience": 0.04432493,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05k7sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Massachusetts"
				},
				"name": "MASSACHUSETTS",
				"salience": 0.039473385,
				"type": "LOCATION"
			},
			{
				"name": "counter-jihadists",
				"salience": 0.026660789,
				"type": "PERSON"
			},
			{
				"name": "warriors",
				"salience": 0.024437755,
				"type": "PERSON"
			},
			{
				"name": "jihadists",
				"salience": 0.022978537,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.018804742,
				"type": "OTHER"
			},
			{
				"name": "battle",
				"salience": 0.018804742,
				"type": "EVENT"
			},
			{
				"name": "Frank Gaffney of Investigative Project on Terrorism",
				"salience": 0.01653649,
				"type": "PERSON"
			},
			{
				"name": "pro-Israel",
				"salience": 0.01653649,
				"type": "OTHER"
			},
			{
				"name": "The United West",
				"salience": 0.011636485,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tom Trento",
				"salience": 0.011205659,
				"type": "PERSON"
			},
			{
				"name": "Islamization of America",
				"salience": 0.009514342,
				"type": "EVENT"
			},
			{
				"name": "truth",
				"salience": 0.0077057146,
				"type": "OTHER"
			},
			{
				"name": "Somebody",
				"salience": 0.007419583,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "CAIR",
				"salience": 0.006127578,
				"type": "ORGANIZATION"
			},
			{
				"name": "death cult",
				"salience": 0.0059116464,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.0059116464,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0043102177,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0032220867,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/m-ra2ITfyjw/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T18:25:42.574+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "MASSACHUSETTS: Designated Terrorist Group CAIR demands synagogue cancel speakers who are pro-Israel anti-Islam The speakers include leading counter-jihadists Frank Gaffney of Investigative Project on Terrorism, General Jerry Boykin, and Tom Trento of The United West, all of whom are warriors in the battle to stop the Islamization of America. Somebody needs to tell the CAIR jihadists to mind their own damn business, the truth about CAIR and the death cult posing as a religion is getting out, despite their best efforts to whitewash it.",
		"thread_title": "MASSACHUSETTS: Designated Terrorist Group CAIR demands synagogue cancel speakers who are pro-Israel anti-Islam",
		"title": "MASSACHUSETTS: Designated Terrorist Group CAIR demands synagogue cancel speakers who are pro-Israel anti-Islam",
		"type": "bs",
		"uuid": "232ef13c0652289079d957bf845feac42716ae49"
	},
	"-KhIjmpYQqDUcMBhGmRR": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T20:55:10.942+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06w3g7j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Matteo_Renzi"
				},
				"name": "Matteo Renzi",
				"salience": 0.31419182,
				"type": "PERSON"
			},
			{
				"name": "budget",
				"salience": 0.07819985,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "European Union",
				"salience": 0.07619283,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.031327497,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.030778987,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italian",
				"salience": 0.026188955,
				"type": "LOCATION"
			},
			{
				"name": "Store",
				"salience": 0.026014563,
				"type": "LOCATION"
			},
			{
				"name": "migration",
				"salience": 0.016142344,
				"type": "EVENT"
			},
			{
				"name": "project",
				"salience": 0.013006012,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0124041205,
				"type": "LOCATION"
			},
			{
				"name": "BNI",
				"salience": 0.011423288,
				"type": "ORGANIZATION"
			},
			{
				"name": "bureaucrats",
				"salience": 0.011036048,
				"type": "PERSON"
			},
			{
				"name": "Prime Minister",
				"salience": 0.010946175,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.010946175,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.010482316,
				"type": "OTHER"
			},
			{
				"name": "paralysis",
				"salience": 0.009482652,
				"type": "OTHER"
			},
			{
				"name": "invasion",
				"salience": 0.009482652,
				"type": "OTHER"
			},
			{
				"name": "taxpayers",
				"salience": 0.009482652,
				"type": "PERSON"
			},
			{
				"name": "cash",
				"salience": 0.009482652,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.009482652,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.009165135,
				"type": "OTHER"
			},
			{
				"name": "FURIOUS Italian",
				"salience": 0.0091073,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.008623447,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02nyxv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mario_Monti"
				},
				"name": "Mario Monti",
				"salience": 0.008397682,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05q4qjw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Porta_a_Porta"
				},
				"name": "Porta a Porta",
				"salience": 0.006839242,
				"type": "WORK_OF_ART"
			},
			{
				"name": "migrants",
				"salience": 0.0066635897,
				"type": "PERSON"
			},
			{
				"name": "member states",
				"salience": 0.006474551,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03gj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hungary"
				},
				"name": "Hungary",
				"salience": 0.0060339468,
				"type": "LOCATION"
			},
			{
				"name": "UK Express",
				"salience": 0.0058426643,
				"type": "OTHER"
			},
			{
				"name": "freeloaders",
				"salience": 0.005679184,
				"type": "PERSON"
			},
			{
				"name": "friendship",
				"salience": 0.0047272122,
				"type": "OTHER"
			},
			{
				"name": "breaking point",
				"salience": 0.004513807,
				"type": "OTHER"
			},
			{
				"name": "influx",
				"salience": 0.004513807,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.004513807,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0045001707,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bmdt8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angelino_Alfano"
				},
				"name": "Angelino Alfano",
				"salience": 0.004466587,
				"type": "PERSON"
			},
			{
				"name": "ratcheting",
				"salience": 0.004381251,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0041563706,
				"type": "PERSON"
			},
			{
				"name": "tensions",
				"salience": 0.003909135,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.003909135,
				"type": "OTHER"
			},
			{
				"name": "inability",
				"salience": 0.003909135,
				"type": "OTHER"
			},
			{
				"name": "refugee chaos",
				"salience": 0.003909135,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0038973226,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0038168395,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0038168395,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0036229694,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0035059154,
				"type": "PERSON"
			},
			{
				"name": "strain",
				"salience": 0.0034005481,
				"type": "OTHER"
			},
			{
				"name": "influx",
				"salience": 0.003165704,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.003047604,
				"type": "PERSON"
			},
			{
				"name": "focal point",
				"salience": 0.003047604,
				"type": "OTHER"
			},
			{
				"name": "sea conditions",
				"salience": 0.0027414528,
				"type": "OTHER"
			},
			{
				"name": "borders",
				"salience": 0.0027414528,
				"type": "OTHER"
			},
			{
				"name": "services",
				"salience": 0.0027414528,
				"type": "OTHER"
			},
			{
				"name": "migration crisis",
				"salience": 0.0026391654,
				"type": "EVENT"
			},
			{
				"name": "millions",
				"salience": 0.0026391654,
				"type": "PERSON"
			},
			{
				"name": "route",
				"salience": 0.0026391654,
				"type": "OTHER"
			},
			{
				"name": "repatriation deal",
				"salience": 0.0026391654,
				"type": "OTHER"
			},
			{
				"name": "boats",
				"salience": 0.0026391654,
				"type": "OTHER"
			},
			{
				"name": "north",
				"salience": 0.0026391654,
				"type": "LOCATION"
			},
			{
				"name": "smugglers",
				"salience": 0.0026391654,
				"type": "PERSON"
			},
			{
				"name": "asylum seekers",
				"salience": 0.0026391654,
				"type": "PERSON"
			},
			{
				"name": "budget contribution",
				"salience": 0.0026220789,
				"type": "OTHER"
			},
			{
				"name": "doors",
				"salience": 0.0026059241,
				"type": "OTHER"
			},
			{
				"name": "veto",
				"salience": 0.002584641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06c62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rome"
				},
				"name": "Rome",
				"salience": 0.0024067953,
				"type": "LOCATION"
			},
			{
				"name": "share",
				"salience": 0.0023846584,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0022382005,
				"type": "ORGANIZATION"
			},
			{
				"name": "help",
				"salience": 0.0022382005,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0022382005,
				"type": "OTHER"
			},
			{
				"name": "retaliation",
				"salience": 0.0022382005,
				"type": "OTHER"
			},
			{
				"name": "Money",
				"salience": 0.0021755681,
				"type": "OTHER"
			},
			{
				"name": "commitments",
				"salience": 0.002138569,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0021211002,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0020772712,
				"type": "PERSON"
			},
			{
				"name": "solidarity",
				"salience": 0.0020481355,
				"type": "OTHER"
			},
			{
				"name": "referendum",
				"salience": 0.0019589309,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0019342517,
				"type": "ORGANIZATION"
			},
			{
				"name": "veto",
				"salience": 0.0019309552,
				"type": "OTHER"
			},
			{
				"name": "scheme",
				"salience": 0.001922332,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0017987951,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/086mh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Winter"
				},
				"name": "Winter",
				"salience": 0.0016876087,
				"type": "PERSON"
			},
			{
				"name": "walls",
				"salience": 0.0016720827,
				"type": "OTHER"
			},
			{
				"name": "duties",
				"salience": 0.0016720827,
				"type": "OTHER"
			},
			{
				"name": "exchange",
				"salience": 0.0016720827,
				"type": "OTHER"
			},
			{
				"name": "funds",
				"salience": 0.0016720827,
				"type": "OTHER"
			},
			{
				"name": "ultimatum",
				"salience": 0.0016720827,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mzp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Switzerland"
				},
				"name": "Switzerland",
				"salience": 0.0016246196,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "France",
				"salience": 0.0016246196,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04swx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mediterranean_Sea"
				},
				"name": "Mediterranean",
				"salience": 0.0016246196,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.0016246196,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austria",
				"salience": 0.0016246196,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0016246196,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.0016246196,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09b69",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Europe"
				},
				"name": "Eastern",
				"salience": 0.0015910439,
				"type": "LOCATION"
			},
			{
				"name": "mass migration",
				"salience": 0.001551836,
				"type": "EVENT"
			},
			{
				"name": "money",
				"salience": 0.0015449049,
				"type": "OTHER"
			},
			{
				"name": "impasse",
				"salience": 0.0013824635,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0013437662,
				"type": "LOCATION"
			},
			{
				"name": "budget",
				"salience": 0.0013437662,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0013437662,
				"type": "LOCATION"
			},
			{
				"name": "migrant quotas",
				"salience": 0.0012388872,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0010505873,
				"type": "PERSON"
			},
			{
				"name": "member states",
				"salience": 0.0010505873,
				"type": "LOCATION"
			},
			{
				"name": "migrant quotas",
				"salience": 0.0010505873,
				"type": "OTHER"
			},
			{
				"name": "lessons",
				"salience": 0.0010458941,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0010458941,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0009097036,
				"type": "OTHER"
			},
			{
				"name": "pressures",
				"salience": 0.0009097036,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009097036,
				"type": "OTHER"
			},
			{
				"name": "proceedings",
				"salience": 0.0009097036,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.0009097036,
				"type": "OTHER"
			},
			{
				"name": "difficulty",
				"salience": 0.0009097036,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0009097036,
				"type": "PERSON"
			},
			{
				"name": "bid",
				"salience": 0.0009097036,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06npd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slovakia"
				},
				"name": "Slovakia",
				"salience": 0.0007495193,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05wyn38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Commission"
				},
				"name": "EU Commission",
				"salience": 0.00071613875,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/italy-refugees.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T20:55:10.942+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.1,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 2 2016 “WE’VE HAD ENOUGH!” Italian Prime Minister threatens to cripple the EU unless it stops mass Muslim migration FURIOUS Italian leader Matteo Renzi today threatened to fatally cripple the entire European Union project unless Brussels bureaucrats do something about ending the Muslim invasion. UK Express In an extraordinary threat the apoplectic PM vowed to veto the EU budget and starve Brussels of taxpayers’ cash, inducing complete paralysis, if the refugee chaos is not fixed by the end of this year. A visibly angry Mr Renzi warned that Italy “cannot survive” another influx of migrants in 2017 similar to the one it faced this year and blasted Europe’s “inability to show solidarity” on the issue. His remarkable threat marks another ratcheting up of the growing tensions between Rome and Brussels, whose friendship has been stretched to breaking point by the migration crisis. Italy has become the focal point for millions of migrants and refugees hoping to reach Europe ever since the route to Greece was effectively cut off by a repatriation deal with Turkey. More than 155,000 Muslim freeloaders posing as asylum seekers have arrived in the country this year alone after crossing the Mediterranean from Libya on rickety smugglers’ boats. But Austria, Switzerland and France to the north have shored up their borders meaning almost all of those have become trapped in Italy, placing a huge strain on services and local communities. Speaking to the talk show Porta a Porta last night, Mr Renzi blasted: “Either we block the influx by 2017 or Italy will not handle another year like the past year.” And he warned: “Right now we can manage it. Winter is coming and sea conditions will worsen, but we have six months maximum.” Mr Renzi also strongly hinted that he will veto the EU budget in retaliation for the critical situation unless Brussels steps in and forces member states to take in their fair share of migrants. He blasted: “If the Eastern countries who are growing with the help of our money do not open their doors to migrants as has been agreed, then we’ll put a veto on the future European budget.” An EU Commission to impose migrant quotas on countries has run into difficulty following furious opposition from eastern European countries and a less than enthusiastic response from others already struggling with the pressures of mass migration. A number of member states including Hungary, which recently held a referendum where 98 per cent of voters rejected migrant quotas, are even taking legal proceedings against the EU in a bid to hold up the scheme. And Italy’s interior minister, Angelino Alfano, backed up Mr Renzi’s extraordinary ultimatum to veto the EU budget and withhold funds from Brussels unless it resolves the impasse. He said: “We must use the veto. We give our money so that, in exchange for these duties, the others honour their commitments. “Money does not go through walls. You know what? If they don’t help us, we will not give more money.” Referring to the country’s net budget contribution under its former leader, the technocrat Mario Monti, he added: “The Monti government determined that we give 20 billion [euros] and receive 12, but if Hungary and Slovakia give us moral lessons about our money and then refuse to give us a hand on migrants, that doesn’t work.”",
		"thread_title": "“WE’VE HAD ENOUGH!” Italian Prime Minister threatens to cripple the EU unless it stops mass Muslim migration",
		"title": "“WE’VE HAD ENOUGH!” Italian Prime Minister threatens to cripple the EU unless it stops mass Muslim migration",
		"type": "bs",
		"uuid": "f8a8836353bb9293bf47acf34f323bf21095c8be"
	},
	"-KhIjn7t5bSkwd3Z1k6B": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T01:23:31.678+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.20742099,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01lvn4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City_Police_Department"
				},
				"name": "NYPD",
				"salience": 0.17314914,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.09002104,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.07099756,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.040808387,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.03605035,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.025511567,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.023053264,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.018037263,
				"type": "WORK_OF_ART"
			},
			{
				"name": "detectives",
				"salience": 0.012251534,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.012251534,
				"type": "OTHER"
			},
			{
				"name": "Money Laundering",
				"salience": 0.01106919,
				"type": "OTHER"
			},
			{
				"name": "Perjury",
				"salience": 0.01106919,
				"type": "OTHER"
			},
			{
				"name": "crew",
				"salience": 0.01106919,
				"type": "PERSON"
			},
			{
				"name": "sexting case",
				"salience": 0.01106919,
				"type": "OTHER"
			},
			{
				"name": "laptop",
				"salience": 0.01106919,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "whistle",
				"salience": 0.009592822,
				"type": "OTHER"
			},
			{
				"name": "Store",
				"salience": 0.009592822,
				"type": "LOCATION"
			},
			{
				"name": "prosecutors",
				"salience": 0.009592822,
				"type": "PERSON"
			},
			{
				"name": "BOMBSHELL",
				"salience": 0.009592822,
				"type": "OTHER"
			},
			{
				"name": "Sex Crimes with Children, Child Exploitation New York Police Department",
				"salience": 0.0075603602,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08n961",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chief_(heraldry)"
				},
				"name": "Chief",
				"salience": 0.0061959457,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.005916072,
				"type": "ORGANIZATION"
			},
			{
				"name": "Pay to Play",
				"salience": 0.005916072,
				"type": "ORGANIZATION"
			},
			{
				"name": "children",
				"salience": 0.0058003315,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.0049874526,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t31",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Congress"
				},
				"name": "Congress",
				"salience": 0.004600389,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fz196",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeffrey_Epstein"
				},
				"name": "Jeffrey Epstein",
				"salience": 0.004540463,
				"type": "PERSON"
			},
			{
				"name": "Sex Slave Island",
				"salience": 0.0044544963,
				"type": "LOCATION"
			},
			{
				"name": "sources",
				"salience": 0.004284898,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0039602164,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0038208338,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0038208338,
				"type": "WORK_OF_ART"
			},
			{
				"name": "candidate",
				"salience": 0.002940581,
				"type": "PERSON"
			},
			{
				"name": "detectives",
				"salience": 0.002937624,
				"type": "PERSON"
			},
			{
				"name": "press conference",
				"salience": 0.002903574,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.0026802658,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0026802658,
				"type": "WORK_OF_ART"
			},
			{
				"name": "insiders",
				"salience": 0.0025881429,
				"type": "PERSON"
			},
			{
				"name": "insiders",
				"salience": 0.0025881429,
				"type": "PERSON"
			},
			{
				"name": "content",
				"salience": 0.0025881429,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0025803237,
				"type": "WORK_OF_ART"
			},
			{
				"name": "law enforcement sources",
				"salience": 0.0025803237,
				"type": "PERSON"
			},
			{
				"name": "crew",
				"salience": 0.0024275994,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0023370655,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.0022446716,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.0021885056,
				"type": "WORK_OF_ART"
			},
			{
				"name": "secretary of state",
				"salience": 0.0020239442,
				"type": "PERSON"
			},
			{
				"name": "tenure",
				"salience": 0.0020239442,
				"type": "EVENT"
			},
			{
				"name": "search warrant",
				"salience": 0.0020239442,
				"type": "OTHER"
			},
			{
				"name": "computer",
				"salience": 0.0020239442,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "aides",
				"salience": 0.0020239442,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.0020239442,
				"type": "OTHER"
			},
			{
				"name": "felony crimes",
				"salience": 0.001964715,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0018914245,
				"type": "OTHER"
			},
			{
				"name": "Money laundering Sex crimes",
				"salience": 0.0018914245,
				"type": "OTHER"
			},
			{
				"name": "field offices",
				"salience": 0.0018151506,
				"type": "LOCATION"
			},
			{
				"name": "department",
				"salience": 0.0018151506,
				"type": "ORGANIZATION"
			},
			{
				"name": "Chief",
				"salience": 0.0018151506,
				"type": "PERSON"
			},
			{
				"name": "detectives",
				"salience": 0.0018151506,
				"type": "PERSON"
			},
			{
				"name": "trove",
				"salience": 0.0017830456,
				"type": "OTHER"
			},
			{
				"name": "contents",
				"salience": 0.0017474334,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0017474334,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0017474334,
				"type": "PERSON"
			},
			{
				"name": "sources",
				"salience": 0.0016351757,
				"type": "PERSON"
			},
			{
				"name": "Perjury",
				"salience": 0.0015778373,
				"type": "PERSON"
			},
			{
				"name": "laptop",
				"salience": 0.0015778373,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "contents",
				"salience": 0.0014819766,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0014679305,
				"type": "PERSON"
			},
			{
				"name": "escape",
				"salience": 0.0014374227,
				"type": "EVENT"
			},
			{
				"name": "sources",
				"salience": 0.0014223654,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0014193169,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.0014193169,
				"type": "PERSON"
			},
			{
				"name": "co- conspirators",
				"salience": 0.0014193169,
				"type": "PERSON"
			},
			{
				"name": "rank",
				"salience": 0.0014193169,
				"type": "OTHER"
			},
			{
				"name": "indictments",
				"salience": 0.0014193169,
				"type": "OTHER"
			},
			{
				"name": "Commissioner",
				"salience": 0.0014193169,
				"type": "PERSON"
			},
			{
				"name": "subordinates",
				"salience": 0.0013663549,
				"type": "OTHER"
			},
			{
				"name": "email investigation",
				"salience": 0.0013663549,
				"type": "OTHER"
			},
			{
				"name": "associates",
				"salience": 0.0013663549,
				"type": "PERSON"
			},
			{
				"name": "revelations",
				"salience": 0.0013663549,
				"type": "OTHER"
			},
			{
				"name": "island",
				"salience": 0.0013504672,
				"type": "LOCATION"
			},
			{
				"name": "island",
				"salience": 0.0013504672,
				"type": "LOCATION"
			},
			{
				"name": "People",
				"salience": 0.0013321486,
				"type": "PERSON"
			},
			{
				"name": "copies",
				"salience": 0.0012662817,
				"type": "OTHER"
			},
			{
				"name": "TruePundit",
				"salience": 0.0012460407,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.0011808093,
				"type": "PERSON"
			},
			{
				"name": "probe",
				"salience": 0.0011587486,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0011587486,
				"type": "OTHER"
			},
			{
				"name": "stomach",
				"salience": 0.0011587486,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.0011174434,
				"type": "ORGANIZATION"
			},
			{
				"name": "government officials",
				"salience": 0.0011071638,
				"type": "PERSON"
			},
			{
				"name": "occasions",
				"salience": 0.0009996716,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.0009996716,
				"type": "PERSON"
			},
			{
				"name": "island",
				"salience": 0.0009836324,
				"type": "LOCATION"
			},
			{
				"name": "Clinton Foundation Obstruction of justice",
				"salience": 0.000873681,
				"type": "OTHER"
			},
			{
				"name": "dignitaries",
				"salience": 0.0008656426,
				"type": "ORGANIZATION"
			},
			{
				"name": "boys",
				"salience": 0.0008656426,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.0008656426,
				"type": "PERSON"
			},
			{
				"name": "pimps",
				"salience": 0.0008656426,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0008410693,
				"type": "ORGANIZATION"
			},
			{
				"name": "Orgy Island",
				"salience": 0.0008312865,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ww5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Virgin_Islands"
				},
				"name": "U.S Virgin Islands",
				"salience": 0.0008312865,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.0008063871,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0007739384,
				"type": "PERSON"
			},
			{
				"name": "law enforcement source",
				"salience": 0.0007739384,
				"type": "PERSON"
			},
			{
				"name": "occasions",
				"salience": 0.000728084,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0007132419,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d_t5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harry_Houdini"
				},
				"name": "Houdini",
				"salience": 0.0007132419,
				"type": "PERSON"
			},
			{
				"name": "internet",
				"salience": 0.0006304539,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.0006304539,
				"type": "OTHER"
			},
			{
				"name": "MORE",
				"salience": 0.0006304539,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0006304539,
				"type": "OTHER"
			},
			{
				"name": "guest",
				"salience": 0.0006304539,
				"type": "PERSON"
			},
			{
				"name": "media reports",
				"salience": 0.0006304539,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0006304539,
				"type": "OTHER"
			},
			{
				"name": "shopping",
				"salience": 0.000614664,
				"type": "EVENT"
			},
			{
				"name": "insiders",
				"salience": 0.00060237915,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0005794857,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0005438795,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0mlk2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boeing_727"
				},
				"name": "Boeing 727",
				"salience": 0.0005327913,
				"type": "OTHER"
			},
			{
				"name": "itineraries",
				"salience": 0.00047094285,
				"type": "OTHER"
			},
			{
				"name": "travel documents",
				"salience": 0.00047094285,
				"type": "OTHER"
			},
			{
				"name": "immunity deals",
				"salience": 0.00047094285,
				"type": "OTHER"
			},
			{
				"name": "portions",
				"salience": 0.00047094285,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.00047094285,
				"type": "LOCATION"
			},
			{
				"name": "sentences",
				"salience": 0.00044764613,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/hillary-huma-sex-ring.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T01:23:31.678+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 2 2016 BREAKING BOMBSHELL: NYPD blows whistle on new Hillary emails: Money Laundering, Pay to Play, Perjury, Sex Crimes with Children, Child Exploitation New York Police Department (NYPD) detectives and prosecutors working an alleged underage sexting case against former Congressman Anthony Weiner have turned over a newly-found laptop he shared with wife Huma Abedin to the FBI with enough evidence “to put Hillary (Clinton) and her crew away for life,” NYPD sources said. TruePundit NYPD sources said Clinton’s “crew” also included several unnamed yet implicated members of Congress in addition to her aides and insiders. The NYPD seized the computer from Weiner during a search warrant and detectives discovered a trove of over 500,000 emails to and from Hillary Clinton, Abedin and other insiders during her tenure as secretary of state. The content of those emails sparked the FBI to reopen its defunct email investigation into Clinton on Friday. But new revelations on the contents of that laptop, according to law enforcement sources, implicate the Democratic presidential candidate, her subordinates, and even select elected officials in far more alleged serious crimes than mishandling classified and top secret emails, sources said. NYPD sources said these new emails include evidence linking Clinton herself and associates to: Money laundering Sex crimes with minors (children) Perjury Pay to play through Clinton Foundation Obstruction of justice Other felony crimes NYPD detectives and a NYPD Chief, the department’s highest rank under Commissioner, said openly that if the FBI and Justice Department fail to garner timely indictments against Clinton and co- conspirators, NYPD will go public with the damaging emails now in the hands of FBI Director James Comey and many FBI field offices. “What’s in the emails is staggering and as a father, it turned my stomach,” the NYPD Chief said. “There is not going to be any Houdini-like escape from what we found. We have copies of everything. We will ship them to Wikileaks or I will personally hold my own press conference if it comes to that.” The NYPD Chief said once Comey saw the alarming contents of the emails he was forced to reopen a criminal probe against Clinton. “People are going to prison,” he said. Meanwhile, FBI sources said Abedin and Weiner were cooperating with federal agents, who have taken over the non-sexting portions the case from NYPD. The husband-and-wife Clinton insiders are both shopping for separate immunity deals, sources said. “If they don’t cooperate they are going to see long sentences,” a federal law enforcement source said. The new emails contain travel documents and itineraries indicating Hillary Clinton, President Bill Clinton, Weiner and multiple members of Congress and other government officials accompanied convicted pedophile billionaire Jeffrey Epstein on his Boeing 727 on multiple occasions to his private island in the U.S Virgin Islands, sources said. Epstein’s island has also been dubbed Orgy Island or Sex Slave Island where Epstein allegedly pimps out underage girls and boys to international dignitaries. Both NYPD and FBI sources confirm based on the new emails they now believe Hillary Clinton traveled as Epstein’s guest on at least six occasions, probably more when all the evidence is combed, sources said. Bill Clinton, it has been confirmed in media reports spanning recent years, that he too traveled with Epstein over 20 times to the island. READ MORE (Apparently the link has been scrubbed from the internet already. Don’t know if that means it’s something they don’t want to get out?)",
		"thread_title": "BREAKING BOMBSHELL: NYPD blows whistle on new Hillary emails: Money Laundering, Pay to Play, Perjury, Sex Crimes with Children, Child Exploitation",
		"title": "BREAKING BOMBSHELL: NYPD blows whistle on new Hillary emails: Money Laundering, Pay to Play, Perjury, Sex Crimes with Children, Child Exploitation",
		"type": "bs",
		"uuid": "cc5ef867cf027cbd3f130a043c3dac5480b22a0b"
	},
	"-KhIjnHK1cm7WhcAcoQc": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T01:23:32.007+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.36824182,
				"type": "PERSON"
			},
			{
				"name": "info",
				"salience": 0.12556684,
				"type": "OTHER"
			},
			{
				"name": "@ 6",
				"salience": 0.123721056,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.048450418,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.03508002,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "huma",
				"salience": 0.029554205,
				"type": "PERSON"
			},
			{
				"name": "anti-Israel Intimidation",
				"salience": 0.026444282,
				"type": "OTHER"
			},
			{
				"name": "mus slum demon hood",
				"salience": 0.019983074,
				"type": "OTHER"
			},
			{
				"name": "@ 5",
				"salience": 0.01836353,
				"type": "OTHER"
			},
			{
				"name": "muzslime",
				"salience": 0.017507054,
				"type": "OTHER"
			},
			{
				"name": "pigmies",
				"salience": 0.016856665,
				"type": "PERSON"
			},
			{
				"name": "leaders",
				"salience": 0.016856665,
				"type": "PERSON"
			},
			{
				"name": "College",
				"salience": 0.016856665,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.015378339,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.014305044,
				"type": "OTHER"
			},
			{
				"name": "lover",
				"salience": 0.014305044,
				"type": "PERSON"
			},
			{
				"name": "cat",
				"salience": 0.014305044,
				"type": "OTHER"
			},
			{
				"name": "Don Spilman",
				"salience": 0.010795775,
				"type": "PERSON"
			},
			{
				"name": "association",
				"salience": 0.010696727,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western World",
				"salience": 0.010393903,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.010393903,
				"type": "LOCATION"
			},
			{
				"name": "bed",
				"salience": 0.0077964477,
				"type": "OTHER"
			},
			{
				"name": "mus slum brother",
				"salience": 0.0077964477,
				"type": "PERSON"
			},
			{
				"name": "mother",
				"salience": 0.0077964477,
				"type": "PERSON"
			},
			{
				"name": "huma",
				"salience": 0.0067277225,
				"type": "PERSON"
			},
			{
				"name": "killery",
				"salience": 0.0058268835,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/oIObqf4a8q0/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T01:23:32.007+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.5,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "November 2, 2016 @ 6:50 pm \nIt’s getting harder and harder to get this info from the media. November 2, 2016 @ 6:04 pm \nTrump will ask Justice Department to probe anti-Israel Intimidation on US College. He is the GREAT MAN. All Western World leaders are pigmies compare to him. Don Spilman November 2, 2016 @ 5:46 pm \nI hope that damnable evil muzslime gets life in prison. … and her perverted lover huma too!! cat November 2, 2016 @ 5:38 pm \nI hope that the down fall of killery by huma, comes true before the 8th of November. Vote Trump. Say no to killery Hillary and her association with the mus slum demon hood that is in bed with huma’s mus slum brother and her mus slum mother. Vote Trump.",
		"thread_title": "Did you know Donald Trump predicted Hillary Clinton’s downfall would be caused by Huma Abedin more than a year ago?",
		"title": "Did you know Donald Trump predicted Hillary Clinton’s downfall would be caused by Huma Abedin more than a year ago?",
		"type": "bs",
		"uuid": "20b9ad08708727c46a5505a9ec966589ed0d11d8"
	},
	"-KhIjnen2v2u_BTnh5hM": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T01:23:35.531+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.31200314,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.15998206,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.117040746,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.07494186,
				"type": "OTHER"
			},
			{
				"name": "Thousands",
				"salience": 0.014858893,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.012706462,
				"type": "ORGANIZATION"
			},
			{
				"name": "migration policy",
				"salience": 0.012706462,
				"type": "OTHER"
			},
			{
				"name": "UK Express",
				"salience": 0.0117833605,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.010509591,
				"type": "WORK_OF_ART"
			},
			{
				"name": "streets",
				"salience": 0.008627057,
				"type": "LOCATION"
			},
			{
				"name": "control",
				"salience": 0.00779383,
				"type": "OTHER"
			},
			{
				"name": "lawlessness",
				"salience": 0.00779383,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.006983917,
				"type": "PERSON"
			},
			{
				"name": "Store",
				"salience": 0.006753596,
				"type": "LOCATION"
			},
			{
				"name": "catastrophe",
				"salience": 0.006753596,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.006753596,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.006319102,
				"type": "OTHER"
			},
			{
				"name": "Gatestone Institute",
				"salience": 0.005802943,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0056460393,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.005476844,
				"type": "PERSON"
			},
			{
				"name": "aggression",
				"salience": 0.0050287484,
				"type": "OTHER"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.0044178003,
				"type": "EVENT"
			},
			{
				"name": "migrants",
				"salience": 0.004376028,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.0041639614,
				"type": "ORGANIZATION"
			},
			{
				"name": "robberies",
				"salience": 0.0039899023,
				"type": "EVENT"
			},
			{
				"name": "home invasions",
				"salience": 0.0039899023,
				"type": "EVENT"
			},
			{
				"name": "drug trafficking",
				"salience": 0.0039899023,
				"type": "OTHER"
			},
			{
				"name": "stabbings",
				"salience": 0.003456063,
				"type": "OTHER"
			},
			{
				"name": "assaults",
				"salience": 0.003456063,
				"type": "OTHER"
			},
			{
				"name": "burglaries",
				"salience": 0.003456063,
				"type": "EVENT"
			},
			{
				"name": "wave",
				"salience": 0.003456063,
				"type": "OTHER"
			},
			{
				"name": "invitation",
				"salience": 0.003456063,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003456063,
				"type": "PERSON"
			},
			{
				"name": "woes",
				"salience": 0.003456063,
				"type": "OTHER"
			},
			{
				"name": "crimes",
				"salience": 0.0032123027,
				"type": "EVENT"
			},
			{
				"name": "migrants",
				"salience": 0.0028285237,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.0027482654,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0026071637,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.002408914,
				"type": "EVENT"
			},
			{
				"name": "country",
				"salience": 0.002328781,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.002328781,
				"type": "LOCATION"
			},
			{
				"name": "Tania Kambouri",
				"salience": 0.0023240997,
				"type": "PERSON"
			},
			{
				"name": "parts",
				"salience": 0.0022303974,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.002221073,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0021288416,
				"type": "OTHER"
			},
			{
				"name": "respondents",
				"salience": 0.002042622,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0018211973,
				"type": "EVENT"
			},
			{
				"name": "parts",
				"salience": 0.0018211973,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0018156943,
				"type": "PERSON"
			},
			{
				"name": "crime",
				"salience": 0.0017605033,
				"type": "OTHER"
			},
			{
				"name": "rapes",
				"salience": 0.0016866999,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.001644492,
				"type": "OTHER"
			},
			{
				"name": "home countries",
				"salience": 0.0016333446,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0015724178,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0015399402,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0015399402,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0014996532,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crimes",
				"salience": 0.001493122,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.001493122,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.001493122,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.001493122,
				"type": "EVENT"
			},
			{
				"name": "crimes",
				"salience": 0.001493122,
				"type": "EVENT"
			},
			{
				"name": "Many",
				"salience": 0.0014916693,
				"type": "PERSON"
			},
			{
				"name": "Nationalism",
				"salience": 0.0014859502,
				"type": "OTHER"
			},
			{
				"name": "lack",
				"salience": 0.0014241299,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0014241299,
				"type": "LOCATION"
			},
			{
				"name": "infrastructure",
				"salience": 0.0014241299,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0014241299,
				"type": "OTHER"
			},
			{
				"name": "limit",
				"salience": 0.0014241299,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0014241299,
				"type": "EVENT"
			},
			{
				"name": "surges",
				"salience": 0.0014241299,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.0014241299,
				"type": "OTHER"
			},
			{
				"name": "mayhem",
				"salience": 0.0014241299,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0014198254,
				"type": "PERSON"
			},
			{
				"name": "respect",
				"salience": 0.0013956862,
				"type": "OTHER"
			},
			{
				"name": "Anegla Merkel",
				"salience": 0.0013676377,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0013550608,
				"type": "WORK_OF_ART"
			},
			{
				"name": "poll",
				"salience": 0.0013005956,
				"type": "OTHER"
			},
			{
				"name": "migrant offenders",
				"salience": 0.0012771948,
				"type": "PERSON"
			},
			{
				"name": "police report",
				"salience": 0.0012718516,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0gg68",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian_Democratic_Union_of_Germany"
				},
				"name": "Christian Democratic Union",
				"salience": 0.0011543935,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugee",
				"salience": 0.0011532272,
				"type": "OTHER"
			},
			{
				"name": "nationalism",
				"salience": 0.0011532272,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0011532272,
				"type": "PERSON"
			},
			{
				"name": "robbery",
				"salience": 0.0011532272,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.0011505442,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugees",
				"salience": 0.001110195,
				"type": "PERSON"
			},
			{
				"name": "spiralling levels",
				"salience": 0.001110195,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.001110195,
				"type": "EVENT"
			},
			{
				"name": "nightmare",
				"salience": 0.0010639948,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.001060345,
				"type": "LOCATION"
			},
			{
				"name": "figure",
				"salience": 0.0010373575,
				"type": "OTHER"
			},
			{
				"name": "behaviour",
				"salience": 0.0009986457,
				"type": "OTHER"
			},
			{
				"name": "justice system",
				"salience": 0.0009986457,
				"type": "OTHER"
			},
			{
				"name": "leniency",
				"salience": 0.0009986457,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0009986457,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0009986457,
				"type": "OTHER"
			},
			{
				"name": "extremists",
				"salience": 0.00096137746,
				"type": "PERSON"
			},
			{
				"name": "patriots",
				"salience": 0.00096137746,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.00096137746,
				"type": "PERSON"
			},
			{
				"name": "rise",
				"salience": 0.00096137746,
				"type": "OTHER"
			},
			{
				"name": "pretences",
				"salience": 0.00096137746,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00096137746,
				"type": "LOCATION"
			},
			{
				"name": "asylum seekers",
				"salience": 0.00096137746,
				"type": "PERSON"
			},
			{
				"name": "unrest",
				"salience": 0.00096137746,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.00096137746,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.00096137746,
				"type": "LOCATION"
			},
			{
				"name": "increase",
				"salience": 0.00094151177,
				"type": "OTHER"
			},
			{
				"name": "suspect",
				"salience": 0.0009254991,
				"type": "PERSON"
			},
			{
				"name": "joke",
				"salience": 0.0009179387,
				"type": "OTHER"
			},
			{
				"name": "officers",
				"salience": 0.0008995983,
				"type": "PERSON"
			},
			{
				"name": "attention",
				"salience": 0.0008469006,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0008469006,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0008380272,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.00083623064,
				"type": "EVENT"
			},
			{
				"name": "offenders",
				"salience": 0.0008195217,
				"type": "PERSON"
			},
			{
				"name": "body language",
				"salience": 0.00078486226,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0007789941,
				"type": "LOCATION"
			},
			{
				"name": "respect",
				"salience": 0.0007789941,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0007789941,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00076864194,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09_ztc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Criminal_Police_Office_(Germany)"
				},
				"name": "Federal Criminal Police Office",
				"salience": 0.0007412395,
				"type": "ORGANIZATION"
			},
			{
				"name": "increase",
				"salience": 0.00072142325,
				"type": "OTHER"
			},
			{
				"name": "offenders",
				"salience": 0.0007128311,
				"type": "PERSON"
			},
			{
				"name": "German Police Union",
				"salience": 0.00070988905,
				"type": "ORGANIZATION"
			},
			{
				"name": "courts",
				"salience": 0.00070335774,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03hrz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hamburg"
				},
				"name": "Hamburg",
				"salience": 0.00061470654,
				"type": "LOCATION"
			},
			{
				"name": "Freddi Lohse",
				"salience": 0.00061470654,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02vhjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_World_Order_(conspiracy_theory)"
				},
				"name": "New World Order",
				"salience": 0.00061470654,
				"type": "ORGANIZATION"
			},
			{
				"name": "cop",
				"salience": 0.00060905056,
				"type": "PERSON"
			},
			{
				"name": "insults",
				"salience": 0.00060905056,
				"type": "OTHER"
			},
			{
				"name": "book",
				"salience": 0.00060905056,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04kf4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leipzig"
				},
				"name": "Leipzig",
				"salience": 0.00059176015,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/070zc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saxony"
				},
				"name": "Saxony",
				"salience": 0.00059176015,
				"type": "LOCATION"
			},
			{
				"name": "controversy",
				"salience": 0.0005741964,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.000567357,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.000567357,
				"type": "ORGANIZATION"
			},
			{
				"name": "consequences",
				"salience": 0.000567357,
				"type": "OTHER"
			},
			{
				"name": "joke",
				"salience": 0.0005457959,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0005438912,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0005420931,
				"type": "LOCATION"
			},
			{
				"name": "first",
				"salience": 0.0005122617,
				"type": "PERSON"
			},
			{
				"name": "courts",
				"salience": 0.0005122617,
				"type": "LOCATION"
			},
			{
				"name": "cases",
				"salience": 0.0005122617,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0005122617,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01jfhb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bild"
				},
				"name": "Bild",
				"salience": 0.0005018186,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rfdxh0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alternative_for_Germany"
				},
				"name": "Alternative for Germany",
				"salience": 0.00050012197,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.00049196807,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.00048945023,
				"type": "PERSON"
			},
			{
				"name": "traffic stop",
				"salience": 0.00044922993,
				"type": "OTHER"
			},
			{
				"name": "police files",
				"salience": 0.00044356848,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.00044356848,
				"type": "LOCATION"
			},
			{
				"name": "probation",
				"salience": 0.00044356848,
				"type": "OTHER"
			},
			{
				"name": "whatever",
				"salience": 0.00044356848,
				"type": "OTHER"
			},
			{
				"name": "thousands",
				"salience": 0.00042381504,
				"type": "LOCATION"
			},
			{
				"name": "streets",
				"salience": 0.00042381504,
				"type": "LOCATION"
			},
			{
				"name": "invasion",
				"salience": 0.00038265492,
				"type": "EVENT"
			},
			{
				"name": "lawlessness",
				"salience": 0.00038265492,
				"type": "OTHER"
			},
			{
				"name": "train stations",
				"salience": 0.00038265492,
				"type": "LOCATION"
			},
			{
				"name": "sense",
				"salience": 0.00033133742,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00033133742,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.00033133742,
				"type": "OTHER"
			},
			{
				"name": "subways",
				"salience": 0.00033133742,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00033133742,
				"type": "EVENT"
			},
			{
				"name": "protests",
				"salience": 0.00033133742,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Islam",
				"salience": 0.0002729909,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07nf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thuringia"
				},
				"name": "Thuringia",
				"salience": 0.0002729909,
				"type": "LOCATION"
			},
			{
				"name": "land grab project",
				"salience": 0.0002474977,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.00024129786,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0002039126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "Soros",
				"salience": 0.0002039126,
				"type": "PERSON"
			},
			{
				"name": "Clinton Arab Spring",
				"salience": 0.0002039126,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/034ndv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouGov"
				},
				"name": "YouGov",
				"salience": 0.0002039126,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/etGD2OBN04Y/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T01:23:35.531+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.6,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 2 2016 “We are losing control of the streets,” say police as Angela Merkel’s Germany descends into chaos and lawlessness GERMAN Chancellor Angela Merkel is facing catastrophe over her failed mass Muslim migration policy, according to a new report. Germany has been hit by a tidal wave of horrendous violent crime including rapes, sexual and physical assaults, stabbings, home invasions, robberies, burglaries and drug trafficking…not to mention Islamic terrorist attacks. UK Express Adding to the country’s woes is the fact that thousands of people have gone missing after travelling there on invitation from Anegla Merkel. Germany took in more than 1.1million migrants in the past year and parts of the country are crippled with a lack of infrastructure. Now the true reality is hitting home ahead of next year’s elections as the far right surges in the polls threatening to topple the Christian Democratic Union (CDU) leader Mrs Merkel. According to a report by the international policy council the Gatestone Institute, local police in many parts of the country admit that they are stretched to the limit. Despite the mayhem caused by skyrocketing violent crime and terror attacks by Muslim migrants, German officials insist on blaming the unrest on the rise of the “far right extremists” (aka German patriots). The report states: “The rape of a ten-year-old girl in Leipzig, the largest city in Saxony, has drawn renewed attention to the spiralling levels of violent crime perpetrated by migrants in cities and towns across Germany. “Thousands of migrants who entered the country as ‘asylum seekers’ or ‘refugees’ have gone missing. They are, presumably, economic migrants who entered Germany on false pretences. “Many are thought to be engaging in robbery and criminal violence.” According to Freddi Lohse of the German Police Union in Hamburg, many migrant offenders view the leniency of the German justice system as a green light to continue delinquent behaviour, says the report. He said: “They are used to tougher consequences in their home countries. “They have no respect for us.” After the “refugee” disaster that Angela Merkel has created, she is now unsettled about Europe returning to nationalism. Nationalism is a nightmare for all the liberal leaders working for a New World Order. “During the first six months of 2016, Muslim migrants committed 142,500 crimes , according to the Federal Criminal Police Office. This is equivalent to 780 crimes committed by migrants every day, an increase of nearly 40 per cent over 2015. The data includes only those crimes in which a suspect has been caught. Muslim migrants committed 208,344 crimes in 2015 , according to a confidential police report leaked to Bild. This figure represents an 80 per cent increase since 2014 and is equivalent to 570 crimes committed by migrants every day, or 23 crimes each hour, in 2015 alone. “Nearly 70 per cent of respondents said they fear for their lives and property in German train stations and subways, while 63 per cent feel unsafe at large public events.” The report added: “The growing sense of lawlessness is substantiated by an October 24 YouGov poll which found that 68 per cent of Germans believe that security in the country has deteriorated during the past several years. Germans are taking to the streets in the thousands in weekly protests against the Muslim invasion started by the Obama/Soros/Clinton Arab Spring and aided and abetted by Angela Merkel. Meanwhile a female police officer has admitted that officers are under attack and that the courts are a “joke.” In a new book, Tania Kambouri, a German police officer, said: “For weeks, months and years I have noticed that Muslims, mostly young men, do not have even a minimum level of respect for the police. “When we are out patrolling the streets, we are verbally abused by young Muslims. “There is the body language, and insults like ‘s*** cop’ when passing by. “If we make a traffic stop, the aggression increases ever further, this is overwhelmingly the case with migrants. “It cannot be that offenders continue to fill the police files, hurt us physically, insult us, whatever, and there are no consequences. “Many cases are closed or offenders are released on probation or whatever. “Yes, what is happening in the courts today is a joke.” The construction of a small mosque, the first in the German state of Thuringia, created controversy after the Alternative for Germany party labeled it a ‘land grab project’ and announced a massive anti-Islam rally.",
		"thread_title": "“We are losing control of the streets,” say police as Angela Merkel’s Germany descends into chaos and lawlessness",
		"title": "“We are losing control of the streets,” say police as Angela Merkel’s Germany descends into chaos and lawlessness",
		"type": "bs",
		"uuid": "e58dcbebf91e41d392e02b24e64dbe65b6355b29"
	},
	"-KhIjnoaw7ZvIOhz92LS": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T03:10:03.785+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Terrorist Group CAIR",
				"salience": 0.22124304,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "FLORIDA",
				"salience": 0.1547043,
				"type": "LOCATION"
			},
			{
				"name": "hate crime",
				"salience": 0.045710057,
				"type": "OTHER"
			},
			{
				"name": "entrance sign",
				"salience": 0.040233932,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Islamic",
				"salience": 0.03948615,
				"type": "OTHER"
			},
			{
				"name": "graffiti",
				"salience": 0.038285315,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.038285315,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/021sj1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office"
				},
				"name": "Office",
				"salience": 0.03563018,
				"type": "ORGANIZATION"
			},
			{
				"name": "demands",
				"salience": 0.0332442,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0332442,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.029809538,
				"type": "OTHER"
			},
			{
				"name": "Al Amin Islamic Center",
				"salience": 0.02375315,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0rp_m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boynton_Beach,_Florida"
				},
				"name": "Boynton Beach",
				"salience": 0.02375315,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.02060321,
				"type": "PERSON"
			},
			{
				"name": "car",
				"salience": 0.016809078,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "graffiti",
				"salience": 0.01595134,
				"type": "OTHER"
			},
			{
				"name": "terrorist messages",
				"salience": 0.0138279805,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04_xn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosque"
				},
				"name": "Islamic Center",
				"salience": 0.01167563,
				"type": "LOCATION"
			},
			{
				"name": "crimes",
				"salience": 0.009023579,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.008106536,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.007085464,
				"type": "WORK_OF_ART"
			},
			{
				"name": "vandalism",
				"salience": 0.007085464,
				"type": "OTHER"
			},
			{
				"name": "deputies",
				"salience": 0.007085464,
				"type": "PERSON"
			},
			{
				"name": "Sheriff",
				"salience": 0.007085464,
				"type": "PERSON"
			},
			{
				"name": "hate speech",
				"salience": 0.0066086194,
				"type": "WORK_OF_ART"
			},
			{
				"name": "entrance sign",
				"salience": 0.0065973904,
				"type": "OTHER"
			},
			{
				"name": "hate crime",
				"salience": 0.0061389473,
				"type": "OTHER"
			},
			{
				"name": "hate crimes",
				"salience": 0.0056188894,
				"type": "OTHER"
			},
			{
				"name": "surveillance video",
				"salience": 0.005527041,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mosque",
				"salience": 0.005527041,
				"type": "OTHER"
			},
			{
				"name": "Someone",
				"salience": 0.005433258,
				"type": "PERSON"
			},
			{
				"name": "The Palm Beach",
				"salience": 0.0050413567,
				"type": "LOCATION"
			},
			{
				"name": "spray paint",
				"salience": 0.0049728174,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0048090313,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0046298965,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01v3sw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ABC_News"
				},
				"name": "ABC News",
				"salience": 0.004366734,
				"type": "ORGANIZATION"
			},
			{
				"name": "increase",
				"salience": 0.0040612975,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.0040612975,
				"type": "EVENT"
			},
			{
				"name": "memories",
				"salience": 0.0040612975,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0039425674,
				"type": "PERSON"
			},
			{
				"name": "Fuck Islam",
				"salience": 0.003916745,
				"type": "OTHER"
			},
			{
				"name": "terrorist group",
				"salience": 0.0038807676,
				"type": "ORGANIZATION"
			},
			{
				"name": "Wilfredo Amr Ruiz",
				"salience": 0.0035860513,
				"type": "PERSON"
			},
			{
				"name": "Fuck ISIS",
				"salience": 0.0030633404,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0030605174,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0030605174,
				"type": "PERSON"
			},
			{
				"name": "rhetoric",
				"salience": 0.003035189,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.003035189,
				"type": "EVENT"
			},
			{
				"name": "type",
				"salience": 0.003035189,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "United Arab Emirates",
				"salience": 0.0018689558,
				"type": "LOCATION"
			},
			{
				"name": "arsonist",
				"salience": 0.001652138,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.001652138,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/056rs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim_Brotherhood"
				},
				"name": "Muslim Brotherhood",
				"salience": 0.001017025,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rs82",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fort_Pierce,_Florida"
				},
				"name": "Fort Pierce",
				"salience": 0.001017025,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/wptv_islamic_center_boynton-vandalism_1478121132610_49050482_ver1.0_640_480.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T03:10:03.785+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "FLORIDA: Designated Terrorist Group CAIR demands ‘hate crime’ investigation of anti-Islam graffiti on mosque, blames Trump The entrance sign at the Al Amin Islamic Center in Boynton Beach was spray-painted with graffiti containing anti-Islamic and anti- Islamic terrorist messages. ABC News The Palm Beach Sheriff’s Office said deputies responded to a report of vandalism this morning, and that it occurred sometime after midnight and was captured on surveillance video. CAIR officials said the video shows a car pulling up to the mosque about 12:40 a.m. Someone got out of the car, approached the entrance sign and wrote “Fuck Islam” and “Fuck ISIS” with spray paint. “Our community continues to suffer from an increase in hate crimes and hate incidents. We still have fresh in our memories the recent hate crime committed at the Islamic Center of Fort Pierce that was attacked by an arsonist,” CAIR-Florida spokesman Wilfredo Amr Ruiz said in a statement. Muslim Brotherhood-linked Islamic group CAIR, has been designated a terrorist group by the United Arab Emirates. “The hate speech and rhetoric that has come along this presidential campaign is fueling these type of crimes that endanger not only the Muslim community but the Florida community in general.” (Nah, the Florida community is not the least bit endangered. Speak for yourself)",
		"thread_title": "FLORIDA: Designated Terrorist Group CAIR demands ‘hate crime’ investigation of anti-Islam graffiti on mosque, blames Trump",
		"title": "FLORIDA: Designated Terrorist Group CAIR demands ‘hate crime’ investigation of anti-Islam graffiti on mosque, blames Trump",
		"type": "bs",
		"uuid": "f31840d4d3068ed07e219e79fcd78f22eb7d46e1"
	},
	"-KhIjo5X1QfXGYVL05G8": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T03:55:50.701+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "bacon",
				"salience": 0.2316193,
				"type": "OTHER"
			},
			{
				"name": "Christians",
				"salience": 0.07141038,
				"type": "PERSON"
			},
			{
				"name": "sex traffickers",
				"salience": 0.06967889,
				"type": "PERSON"
			},
			{
				"name": "bacon",
				"salience": 0.05092955,
				"type": "OTHER"
			},
			{
				"name": "Piotr Czak-Zukowski",
				"salience": 0.04952217,
				"type": "PERSON"
			},
			{
				"name": "mosque",
				"salience": 0.045312144,
				"type": "LOCATION"
			},
			{
				"name": "men",
				"salience": 0.03792451,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "BRITAIN",
				"salience": 0.033286326,
				"type": "LOCATION"
			},
			{
				"name": "jail Two",
				"salience": 0.032914694,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.032914694,
				"type": "PERSON"
			},
			{
				"name": "Store",
				"salience": 0.029045576,
				"type": "LOCATION"
			},
			{
				"name": "Mateusz Pawlikowski",
				"salience": 0.024066973,
				"type": "PERSON"
			},
			{
				"name": "Paki Muslim",
				"salience": 0.020373851,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.020373851,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.019633917,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.018876288,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.01616876,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.016007068,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.015766613,
				"type": "PERSON"
			},
			{
				"name": "hate crime",
				"salience": 0.015766613,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.009948018,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.007439029,
				"type": "PERSON"
			},
			{
				"name": "Tracey McMath",
				"salience": 0.0064999666,
				"type": "PERSON"
			},
			{
				"name": "bacon",
				"salience": 0.006250612,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "Londoners",
				"salience": 0.0057431655,
				"type": "PERSON"
			},
			{
				"name": "incident",
				"salience": 0.005668653,
				"type": "EVENT"
			},
			{
				"name": "police officers",
				"salience": 0.0054574893,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.0054574893,
				"type": "PERSON"
			},
			{
				"name": "worshippers",
				"salience": 0.004909975,
				"type": "PERSON"
			},
			{
				"name": "packet",
				"salience": 0.0047270106,
				"type": "OTHER"
			},
			{
				"name": "pocket",
				"salience": 0.0047270106,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0047270106,
				"type": "EVENT"
			},
			{
				"name": "Al-Rahman Mosque",
				"salience": 0.0041852263,
				"type": "LOCATION"
			},
			{
				"name": "floor",
				"salience": 0.0040096184,
				"type": "OTHER"
			},
			{
				"name": "defendants",
				"salience": 0.0039335536,
				"type": "PERSON"
			},
			{
				"name": "Piotr Czak",
				"salience": 0.0038668506,
				"type": "PERSON"
			},
			{
				"name": "rasher",
				"salience": 0.0038115666,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ndnw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kings_Cross,_London"
				},
				"name": "Kings Cross",
				"salience": 0.0034918096,
				"type": "LOCATION"
			},
			{
				"name": "Crowndale Road",
				"salience": 0.0034918096,
				"type": "LOCATION"
			},
			{
				"name": "Zukowski Pawlikowski",
				"salience": 0.0034175583,
				"type": "PERSON"
			},
			{
				"name": "damage",
				"salience": 0.0029962673,
				"type": "OTHER"
			},
			{
				"name": "offence",
				"salience": 0.0029962673,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0029962673,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0029112832,
				"type": "OTHER"
			},
			{
				"name": "Wilton Road",
				"salience": 0.0028511623,
				"type": "LOCATION"
			},
			{
				"name": "hate crime",
				"salience": 0.0025204818,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0025204818,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0nbkk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muswell_Hill"
				},
				"name": "Muswell Hill",
				"salience": 0.0024691382,
				"type": "LOCATION"
			},
			{
				"name": "mosque",
				"salience": 0.0022574493,
				"type": "LOCATION"
			},
			{
				"name": "form",
				"salience": 0.0021827202,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0021827202,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.0021827202,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0021827202,
				"type": "PERSON"
			},
			{
				"name": "convictions",
				"salience": 0.002048688,
				"type": "OTHER"
			},
			{
				"name": "Camden Community Safety Unit",
				"salience": 0.0018447799,
				"type": "ORGANIZATION"
			},
			{
				"name": "Blackfriars Crown Court",
				"salience": 0.0018447799,
				"type": "ORGANIZATION"
			},
			{
				"name": "pair",
				"salience": 0.0017155564,
				"type": "PERSON"
			},
			{
				"name": "prayer room",
				"salience": 0.0016307323,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/034ryk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brent_Cross"
				},
				"name": "Brent Cross",
				"salience": 0.0011592131,
				"type": "LOCATION"
			},
			{
				"name": "disregard",
				"salience": 0.001143418,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bmbpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Camden_Lock"
				},
				"name": "Camden Lock",
				"salience": 0.001003786,
				"type": "LOCATION"
			},
			{
				"name": "Sneath Avenue",
				"salience": 0.001003786,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/s-l1000-e1478135264246.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T03:55:50.701+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.4,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 2 2016 IN BRITAIN, Paki Muslim sex traffickers who rape and pimp out young white children go free but Christians who throw bacon at a mosque get thrown in jail Two British men have been jailed for going to a mosque and throwing bacon at a Muslim man in what the sharia-compliant British officials call a ‘callous hate crime.’ There you go, Londoners, keep on electing Muslim politicians and soon you’ll be stoned to death for insulting Islam. Metro Piotr Czak-Zukowski was found with an empty packet of bacon in his pocket when he was searched by police officers after the incident. He and Mateusz Pawlikowski had confronted worshippers at the Al-Rahman Mosque in Crowndale Road, Kings Cross, north London on October 2. BACON BANDITS Mateusz Pawlikowski and Piotr Czak-Zukowski Pawlikowski, 22, of Wilton Road, in Muswell Hill, north London, swore at a man and threw a rasher of bacon towards him, and chucked more bacon on the floor of the prayer room. The pair fled but Pawlikowski was detained near the mosque and Czak-Zukowski, 28, of Sneath Avenue, in Brent Cross, north London, was found at Camden Lock. Both men admitted criminal damage and a religiously aggravated public order offence last month. They were jailed for eight months at Blackfriars Crown Court. DC Tracey McMath, from the Camden Community Safety Unit, said: ‘The defendants showed a complete disregard for the faith and belief of others in this callous and highly offensive incident; and I hope their convictions highlight that we will not tolerate hate crime in any form.",
		"thread_title": "IN BRITAIN, Paki Muslim sex traffickers who rape and pimp out young white children go free but Christians who throw bacon at a mosque get thrown in jail",
		"title": "IN BRITAIN, Paki Muslim sex traffickers who rape and pimp out young white children go free but Christians who throw bacon at a mosque get thrown in jail",
		"type": "bs",
		"uuid": "1522deb84bb98693890d280d11bafa5c16db0330"
	},
	"-KhIjoNYmicbZOwAEqwL": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T06:12:17.835+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "people",
				"salience": 0.0820841,
				"type": "PERSON"
			},
			{
				"name": "Ted Cantle",
				"salience": 0.066152364,
				"type": "PERSON"
			},
			{
				"name": "Mohammed Tabrez Noorji",
				"salience": 0.059099097,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.056289036,
				"type": "OTHER"
			},
			{
				"name": "butcher",
				"salience": 0.042029414,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.030514412,
				"type": "LOCATION"
			},
			{
				"name": "towns",
				"salience": 0.030209495,
				"type": "LOCATION"
			},
			{
				"name": "minority groups",
				"salience": 0.027923597,
				"type": "ORGANIZATION"
			},
			{
				"name": "Store",
				"salience": 0.019891614,
				"type": "LOCATION"
			},
			{
				"name": "families",
				"salience": 0.015990186,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.015020213,
				"type": "PERSON"
			},
			{
				"name": "populations",
				"salience": 0.015020213,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.015020213,
				"type": "PERSON"
			},
			{
				"name": "towns",
				"salience": 0.014081601,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.013318401,
				"type": "PERSON"
			},
			{
				"name": "segregation",
				"salience": 0.013168417,
				"type": "OTHER"
			},
			{
				"name": "BNI",
				"salience": 0.012264379,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/023qzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_flight"
				},
				"name": "WHITE FLIGHT",
				"salience": 0.012264379,
				"type": "ORGANIZATION"
			},
			{
				"name": "cities",
				"salience": 0.01175172,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.01175172,
				"type": "OTHER"
			},
			{
				"name": "Ian Goodliffe",
				"salience": 0.011357749,
				"type": "PERSON"
			},
			{
				"name": "fright",
				"salience": 0.010844199,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.010789693,
				"type": "LOCATION"
			},
			{
				"name": "lows",
				"salience": 0.010179387,
				"type": "OTHER"
			},
			{
				"name": "multiculturalism",
				"salience": 0.010179387,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07hwkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_American"
				},
				"name": "White",
				"salience": 0.009092944,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.008829706,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0072398866,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0071516973,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.0071516973,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01c9x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Labour_Party_(UK)"
				},
				"name": "Labour",
				"salience": 0.0071146507,
				"type": "ORGANIZATION"
			},
			{
				"name": "parts",
				"salience": 0.006610069,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0065855044,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.0065419115,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.006522322,
				"type": "OTHER"
			},
			{
				"name": "UK Express",
				"salience": 0.006270257,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0nlc7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London_Borough_of_Newham"
				},
				"name": "Newham",
				"salience": 0.006270257,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01w2dq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Blackburn"
				},
				"name": "Blackburn",
				"salience": 0.0061957943,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.00619386,
				"type": "PERSON"
			},
			{
				"name": "impasse",
				"salience": 0.0059422674,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.005805991,
				"type": "LOCATION"
			},
			{
				"name": "nothing",
				"salience": 0.005404508,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.005381014,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0053603887,
				"type": "PERSON"
			},
			{
				"name": "butcher shop",
				"salience": 0.0048835413,
				"type": "LOCATION"
			},
			{
				"name": "whole",
				"salience": 0.0048436695,
				"type": "LOCATION"
			},
			{
				"name": "area",
				"salience": 0.004829032,
				"type": "LOCATION"
			},
			{
				"name": "focus",
				"salience": 0.004670951,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.0044170646,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.004293615,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0041946205,
				"type": "OTHER"
			},
			{
				"name": "another",
				"salience": 0.0041946205,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.004123785,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.0040718513,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.003919937,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03cnty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chuka_Umunna"
				},
				"name": "Chuka Umunna",
				"salience": 0.0038958488,
				"type": "PERSON"
			},
			{
				"name": "census",
				"salience": 0.0038385128,
				"type": "OTHER"
			},
			{
				"name": "bones",
				"salience": 0.0036487535,
				"type": "OTHER"
			},
			{
				"name": "Government",
				"salience": 0.0036214825,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.0036214825,
				"type": "OTHER"
			},
			{
				"name": "polarisation",
				"salience": 0.0035733723,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003546664,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.0035419466,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.003396709,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.003396709,
				"type": "PERSON"
			},
			{
				"name": "community adhesion",
				"salience": 0.003396709,
				"type": "OTHER"
			},
			{
				"name": "community adhesion",
				"salience": 0.0032699627,
				"type": "OTHER"
			},
			{
				"name": "matters",
				"salience": 0.0032699627,
				"type": "OTHER"
			},
			{
				"name": "element",
				"salience": 0.0031338856,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.0031338856,
				"type": "OTHER"
			},
			{
				"name": "gang mentality",
				"salience": 0.0031338856,
				"type": "OTHER"
			},
			{
				"name": "distrust",
				"salience": 0.0030944087,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0030598538,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0030598538,
				"type": "LOCATION"
			},
			{
				"name": "experts",
				"salience": 0.0029922954,
				"type": "PERSON"
			},
			{
				"name": "calls",
				"salience": 0.0029789337,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0029789337,
				"type": "LOCATION"
			},
			{
				"name": "Government",
				"salience": 0.0029566651,
				"type": "ORGANIZATION"
			},
			{
				"name": "fear",
				"salience": 0.002941407,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.002941407,
				"type": "OTHER"
			},
			{
				"name": "sides",
				"salience": 0.002941407,
				"type": "OTHER"
			},
			{
				"name": "taxi firm",
				"salience": 0.002941407,
				"type": "ORGANIZATION"
			},
			{
				"name": "referendum",
				"salience": 0.002941407,
				"type": "EVENT"
			},
			{
				"name": "hate crime",
				"salience": 0.002941407,
				"type": "OTHER"
			},
			{
				"name": "spike",
				"salience": 0.002941407,
				"type": "EVENT"
			},
			{
				"name": "research",
				"salience": 0.0029043527,
				"type": "OTHER"
			},
			{
				"name": "mosques",
				"salience": 0.0028316379,
				"type": "LOCATION"
			},
			{
				"name": "direction",
				"salience": 0.0028316379,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0028316379,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.002808507,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0027731257,
				"type": "PERSON"
			},
			{
				"name": "Whalley Range",
				"salience": 0.0025822765,
				"type": "LOCATION"
			},
			{
				"name": "integration",
				"salience": 0.0024836077,
				"type": "OTHER"
			},
			{
				"name": "Eric Kaufman",
				"salience": 0.0024372416,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0024320001,
				"type": "OTHER"
			},
			{
				"name": "street",
				"salience": 0.0024013591,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0024013591,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0023221027,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.002294448,
				"type": "OTHER"
			},
			{
				"name": "minorities",
				"salience": 0.002294448,
				"type": "PERSON"
			},
			{
				"name": "pupils",
				"salience": 0.002225448,
				"type": "PERSON"
			},
			{
				"name": "Politicians",
				"salience": 0.0021534984,
				"type": "PERSON"
			},
			{
				"name": "study",
				"salience": 0.0020981056,
				"type": "OTHER"
			},
			{
				"name": "segregation",
				"salience": 0.0020716693,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0020716693,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0020716693,
				"type": "OTHER"
			},
			{
				"name": "Brexit",
				"salience": 0.0018105566,
				"type": "PERSON"
			},
			{
				"name": "integration",
				"salience": 0.0018088861,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.0017938976,
				"type": "WORK_OF_ART"
			},
			{
				"name": "extremism",
				"salience": 0.0017938976,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0017938976,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0017938976,
				"type": "ORGANIZATION"
			},
			{
				"name": "residents",
				"salience": 0.0017938976,
				"type": "PERSON"
			},
			{
				"name": "policy-makers",
				"salience": 0.0017938976,
				"type": "PERSON"
			},
			{
				"name": "respect",
				"salience": 0.0017938976,
				"type": "OTHER"
			},
			{
				"name": "Open Democracy",
				"salience": 0.0017429705,
				"type": "ORGANIZATION"
			},
			{
				"name": "debate",
				"salience": 0.0017269329,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0016648758,
				"type": "LOCATION"
			},
			{
				"name": "study",
				"salience": 0.0015280729,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0015088161,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/094vy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yorkshire"
				},
				"name": "Yorkshireman",
				"salience": 0.0014780572,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.0014416274,
				"type": "PERSON"
			},
			{
				"name": "Towns",
				"salience": 0.0013512485,
				"type": "LOCATION"
			},
			{
				"name": "media",
				"salience": 0.0013064874,
				"type": "OTHER"
			},
			{
				"name": "headlines",
				"salience": 0.0013064874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bottom",
				"salience": 0.0013064874,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0013064874,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0013064874,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0013064874,
				"type": "LOCATION"
			},
			{
				"name": "pace",
				"salience": 0.0013064874,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0012483057,
				"type": "ORGANIZATION"
			},
			{
				"name": "parts",
				"salience": 0.0012483057,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0012483057,
				"type": "PERSON"
			},
			{
				"name": "Professor",
				"salience": 0.0012483057,
				"type": "PERSON"
			},
			{
				"name": "Polarization",
				"salience": 0.0011270728,
				"type": "OTHER"
			},
			{
				"name": "decrease",
				"salience": 0.0011270728,
				"type": "OTHER"
			},
			{
				"name": "integration experts",
				"salience": 0.0011270728,
				"type": "PERSON"
			},
			{
				"name": "cities",
				"salience": 0.0011270728,
				"type": "LOCATION"
			},
			{
				"name": "decrease",
				"salience": 0.0011270728,
				"type": "OTHER"
			},
			{
				"name": "whole",
				"salience": 0.0011270728,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dd_44",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_integration"
				},
				"name": "Social Integration",
				"salience": 0.0011133206,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.0010939332,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0010665327,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/08kg04",
					"wikipedia_url": "http://en.wikipedia.org/wiki/All-party_parliamentary_group"
				},
				"name": "All Party Parliamentary Group",
				"salience": 0.0010284992,
				"type": "ORGANIZATION"
			},
			{
				"name": "striking",
				"salience": 0.0009759223,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.0009759223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.00077404594,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0006936368,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k33p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Birmingham"
				},
				"name": "Birmingham",
				"salience": 0.00060060504,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dhdp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leicester"
				},
				"name": "Leicester",
				"salience": 0.00060060504,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c9cw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Slough"
				},
				"name": "Slough",
				"salience": 0.00060060504,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fg6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Luton"
				},
				"name": "Luton",
				"salience": 0.00060060504,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/020d8d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bradford"
				},
				"name": "Bradford",
				"salience": 0.00060060504,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/wjvFhGH2eyo/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T06:12:17.835+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 2 2016 WHITE FLIGHT? Or is it white fright? British multiculturalism has created segregation in towns where the white population is fleeing as the Muslim population is exploding White and mainly Muslim minority groups are now more isolated from each other than ever before – while white populations in towns and cities have sunk to record lows – now less than 50% in the last decade alone, it has been revealed. UK Express In Newham, east London, just 16 per cent of the population are white compared to 33 per cent 10 years ago. And Blackburn has ranked as one of the most segregated town in Britain, where in the Whalley Range area 95 per cent of people are Muslim and a local butcher has admitted he has never served a white person in the whole of his time there. Mohammed Tabrez Noorji, who opened his halal butcher shop last year, said: “I do sometimes speak to the white people when they walk past but there is nothing for them to buy here. “It is not good that we all live separately but how can we fix this problem? Muslim families like to live in the same area as each other so we can support one another, but then the white people move out. “It’s not that we deliberately choose to live separately – it is just what happens. We want to live in this area because we are close to the mosques and all our families are very close to each other.” And experts warn matters will increase in the same direction. Academic Ted Cantle, a Government advisor on community adhesion, has warned the 2021 census will reveal polarisation has got even greater. The research, published by Open Democracy, calls on the Government to do more to promote mixed communities. The calls have been made particularly relevant in light of the spike in hate crime reported since the Brexit referendum on June 23. But not everyone wants ‘community adhesion’ to be encouraged. Retired taxi driver Ian Goodliffe, who previously worked at a ‘white only’ taxi firm, said: “There are certain areas where white people no longer go and the same for Muslims. They lead very separate lives. “There is an element of fear on both sides and then there is of course this awful racism. I hear it all the time. “It is sometimes a gang mentality and everyone wants to stick to their own. There are whole parts of Blackburn where a white person would not buy a house but then there is the same for the Muslims. “There is a mutual distrust and the only way to change that is for people to mix, but we are at a total impasse and it is only going to get worse.” Professor Cantle also said he met a Yorkshireman who said he was the first Muslim to move into a street and within three years all the white families had gone. He said: “ Some of those families made no bones about it – they are moving out because ‘they’ are moving in.” The study, conducted by integration experts Professor Cantle and Professor Eric Kaufman, has revealed that white and minority groups are now more isolated from each other than ever before – even though England as a whole is more ethnically mixed. Polarization mainly occurs in urban areas, with some places in the UK seeing a decrease in the white population of more than 50 per cent between 1991 and 2011. Towns and cities, such as Birmingham, Leicester, Slough, Luton, Bradford and London have seen the “striking” decrease occur more rapidly than other parts of the UK, it has been claimed. P rofessor Cantle said: “The focus of policy needs to shift, this is not just about minorities. “Politicians and policy-makers need to encourage white British residents to remain in diverse areas. “To choose, rather than avoid, diverse areas when they do re-locate, encouraging similar choices with respect to placing pupils in diverse schools. “In other words to create a positive choice for mixed areas and a shared society.” The study comes as the Government is about to deliver a major review into integration, segregation and extremism. Labour’s Chuka Umunna, chairman of the All Party Parliamentary Group on Social Integration, said: “During a year in which our country has seemed more divided than at any point in modern history, there are few questions which require investigation more urgently than the matter of how well we are living together. “Equally, however – at a time in which our political debate has become yet more polarized and media headlines yet more fraught – there are few questions which it can seem harder to get to the bottom of. “It’s clear that, whilst the UK is becoming increasingly diverse, levels of integration are not keeping pace.”",
		"thread_title": "WHITE FLIGHT? Or is it white fright? British multiculturalism has created segregation in towns where the white population is fleeing as the Muslim population is exploding",
		"title": "WHITE FLIGHT? Or is it white fright? British multiculturalism has created segregation in towns where the white population is fleeing as the Muslim population is exploding",
		"type": "bs",
		"uuid": "691f9cdd9cfa6658a33df60cba25d499f7d71ef8"
	},
	"-KhIjoZKQ5qzDYfSkjIT": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T06:27:44.548+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06rgxb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bret_Baier"
				},
				"name": "Bret Baier",
				"salience": 0.20139498,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.1578402,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.13414542,
				"type": "ORGANIZATION"
			},
			{
				"name": "investigation",
				"salience": 0.0548011,
				"type": "EVENT"
			},
			{
				"name": "Sources",
				"salience": 0.051971886,
				"type": "PERSON"
			},
			{
				"name": "indictment",
				"salience": 0.049630124,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.049630124,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.049630124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News Channel",
				"salience": 0.02680303,
				"type": "ORGANIZATION"
			},
			{
				"name": "sources",
				"salience": 0.02484408,
				"type": "OTHER"
			},
			{
				"name": "aides",
				"salience": 0.01835303,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.017949136,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.015185369,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.010665696,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.010020892,
				"type": "EVENT"
			},
			{
				"name": "anybody",
				"salience": 0.00924262,
				"type": "PERSON"
			},
			{
				"name": "pieces",
				"salience": 0.00924262,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.008292679,
				"type": "PERSON"
			},
			{
				"name": "laptops",
				"salience": 0.0075857867,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "duplicates",
				"salience": 0.006912836,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0064895367,
				"type": "PERSON"
			},
			{
				"name": "accuracy",
				"salience": 0.0062077143,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.006119316,
				"type": "WORK_OF_ART"
			},
			{
				"name": "laptop",
				"salience": 0.006119316,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "server",
				"salience": 0.006119316,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.006119316,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Agents",
				"salience": 0.0058575957,
				"type": "PERSON"
			},
			{
				"name": "pay-for-play",
				"salience": 0.0039624707,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0039624707,
				"type": "OTHER"
			},
			{
				"name": "Cherryl Mills",
				"salience": 0.0038501807,
				"type": "PERSON"
			},
			{
				"name": "Heather Samuelson",
				"salience": 0.0038501807,
				"type": "PERSON"
			},
			{
				"name": "intelligence agencies",
				"salience": 0.003691678,
				"type": "ORGANIZATION"
			},
			{
				"name": "server",
				"salience": 0.0033337383,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0033337383,
				"type": "OTHER"
			},
			{
				"name": "obstruction",
				"salience": 0.0032771083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03tvfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anthony_Weiner"
				},
				"name": "Anthony Weiner",
				"salience": 0.0032658791,
				"type": "PERSON"
			},
			{
				"name": "indictment",
				"salience": 0.0032094694,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0024912478,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "Justice Department",
				"salience": 0.0024405136,
				"type": "ORGANIZATION"
			},
			{
				"name": "nature",
				"salience": 0.0021574832,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/_x60AEi5gDk/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T06:27:44.548+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "FBI Sources believe Clinton Foundation case is “likely moving toward an indictment” Fox News Channel’s Bret Baier reports the latest news about the Clinton Foundation investigation from two sources inside the FBI. He reveals five important new pieces of information: 1. The Clinton Foundation investigation is far more expansive than anybody has reported so far and has been going on for more than a year. 2. The laptops of Clinton aides Cherryl Mills and Heather Samuelson have not been destroyed, and agents are currently combing through them. The investigation has interviewed several people twice, and plans to interview some for a third time. 3. Agents have found emails believed to have originated on Hillary Clinton’s secret server on Anthony Weiner’s laptop. They say the emails are not duplicates and could potentially be classified in nature. 4. Sources within the FBI have told him that an indictment is “likely” in the case of pay-for-play at the Clinton Foundation, “barring some obstruction in some way” from the Justice Department. 5. FBI sources say with 99% accuracy that Hillary Clinton’s server has been hacked by at least five foreign intelligence agencies, and that information had been taken from it.",
		"thread_title": "FBI Sources believe Clinton Foundation case is “likely moving toward an indictment”",
		"title": "FBI Sources believe Clinton Foundation case is “likely moving toward an indictment”",
		"type": "bs",
		"uuid": "f853c296ab1e463312f4960b412e8a31b45246a7"
	},
	"-KhIjomhkXcuX4MR6zDt": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T12:46:43.606+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.3041144,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.2018258,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06910513,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.056870013,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "DONATE",
				"salience": 0.040081196,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.03580505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.032793812,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.030257616,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.025694296,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.02218947,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.021835692,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.019230962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.018687988,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.017921356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Email",
				"salience": 0.016337944,
				"type": "OTHER"
			},
			{
				"name": "Email Address",
				"salience": 0.016189255,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.014027192,
				"type": "OTHER"
			},
			{
				"name": "LINKS",
				"salience": 0.010488911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.006462718,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/zGhqug03C4Q/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T12:46:43.606+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address",
		"thread_title": "OFF TOPIC: Unlike Muslims…horses actually do have a sense of humor",
		"title": "OFF TOPIC: Unlike Muslims…horses actually do have a sense of humor",
		"type": "bs",
		"uuid": "5b991df273849a628a0579414c69c1fbc0c5289a"
	},
	"-KhIjp8f1j34fkrVAzoL": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T12:46:52.651+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "reset button",
				"salience": 0.16648738,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.110949285,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.072744034,
				"type": "LOCATION"
			},
			{
				"name": "society",
				"salience": 0.0685241,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.06845485,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.06530647,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austria",
				"salience": 0.061590213,
				"type": "LOCATION"
			},
			{
				"name": "boy",
				"salience": 0.05348285,
				"type": "PERSON"
			},
			{
				"name": "rationale",
				"salience": 0.047369458,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.038833145,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.038833145,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.017098516,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.015857816,
				"type": "LOCATION"
			},
			{
				"name": "reference",
				"salience": 0.013728014,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.013385832,
				"type": "OTHER"
			},
			{
				"name": "rapes",
				"salience": 0.013385832,
				"type": "EVENT"
			},
			{
				"name": "continent",
				"salience": 0.013385832,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.013385832,
				"type": "LOCATION"
			},
			{
				"name": "bewilderment",
				"salience": 0.013385832,
				"type": "OTHER"
			},
			{
				"name": "migrant",
				"salience": 0.012009807,
				"type": "PERSON"
			},
			{
				"name": "emergency",
				"salience": 0.00976127,
				"type": "EVENT"
			},
			{
				"name": "swimming pool",
				"salience": 0.009398047,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0090482915,
				"type": "WORK_OF_ART"
			},
			{
				"name": "situation",
				"salience": 0.008989859,
				"type": "OTHER"
			},
			{
				"name": "boy",
				"salience": 0.008861826,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fhp9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vienna"
				},
				"name": "Vienna",
				"salience": 0.0057912613,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.0057912613,
				"type": "LOCATION"
			},
			{
				"name": "advice",
				"salience": 0.0041809957,
				"type": "OTHER"
			},
			{
				"name": "immigration policy",
				"salience": 0.0041809957,
				"type": "OTHER"
			},
			{
				"name": "h/t",
				"salience": 0.0041809957,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0039950307,
				"type": "PERSON"
			},
			{
				"name": "guilt",
				"salience": 0.003124135,
				"type": "OTHER"
			},
			{
				"name": "Rob E",
				"salience": 0.002574426,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.001923369,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/5uMQZnQR1TU/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T12:46:52.651+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.5
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Apparently, Donald Trump has already activated the ‘reset button’ with Russia And this is why Hillary Clinton never could. Russian President Vladimir Putin expressed his bewilderment at why European countries were taking in so many migrants given the increasing number of rapes sweeping the continent, asserting that a society which cannot protect its children “has no future”. Putin made reference to a story out of Austria where an Iraqi migrant was not punished for raping a 10-year-old boy at a swimming pool in Vienna after he claimed it was a “sexual emergency” and that he didn’t understand the boy didn’t want to be raped. “I can’t even explain the rationale – is it a sense of guilt before the illegal alien Muslim migrants? A society that cannot defend its children today has no tomorrow, it has no future,” warned Putin, adding that he would not look to Europe for advice on Russia’s immigration policy given the situation that is unfolding there. \nh/t Rob E",
		"thread_title": "Apparently, Donald Trump has already activated the ‘reset button’ with Russia",
		"title": "Apparently, Donald Trump has already activated the ‘reset button’ with Russia",
		"type": "bs",
		"uuid": "161b3118c2bb7663f9782047ce761f7f436d88f9"
	},
	"-KhIjpLckMlDiOuBTS1J": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T12:47:01.586+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "function",
				"salience": 0.26757753,
				"type": "OTHER"
			},
			{
				"name": "@ 3",
				"salience": 0.097354524,
				"type": "OTHER"
			},
			{
				"name": "ngr",
				"salience": 0.056430455,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.045352027,
				"type": "PERSON"
			},
			{
				"name": "GdM",
				"salience": 0.0451835,
				"type": "ORGANIZATION"
			},
			{
				"name": "sight",
				"salience": 0.031448007,
				"type": "OTHER"
			},
			{
				"name": "vetting rattlesnakes",
				"salience": 0.030415861,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.027105188,
				"type": "LOCATION"
			},
			{
				"name": "spots",
				"salience": 0.02635761,
				"type": "OTHER"
			},
			{
				"name": "function",
				"salience": 0.021907715,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.020566784,
				"type": "OTHER"
			},
			{
				"name": "explanation",
				"salience": 0.018506514,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.016252933,
				"type": "LOCATION"
			},
			{
				"name": "Jive",
				"salience": 0.016252933,
				"type": "ORGANIZATION"
			},
			{
				"name": "@DonSpilman",
				"salience": 0.016252933,
				"type": "PERSON"
			},
			{
				"name": "mind",
				"salience": 0.015117031,
				"type": "OTHER"
			},
			{
				"name": "blowback",
				"salience": 0.012663253,
				"type": "EVENT"
			},
			{
				"name": "Sidi",
				"salience": 0.011404705,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_w0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barbary_pirates"
				},
				"name": "Barbary Pirates",
				"salience": 0.011404705,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jeffersopn",
				"salience": 0.011404705,
				"type": "OTHER"
			},
			{
				"name": "Adams",
				"salience": 0.011404705,
				"type": "LOCATION"
			},
			{
				"name": "Wala wal Bara",
				"salience": 0.011404705,
				"type": "LOCATION"
			},
			{
				"name": "domination",
				"salience": 0.011299962,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.011299962,
				"type": "OTHER"
			},
			{
				"name": "genocide",
				"salience": 0.011299962,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.011299962,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.011299962,
				"type": "OTHER"
			},
			{
				"name": "Slime",
				"salience": 0.010979739,
				"type": "WORK_OF_ART"
			},
			{
				"name": "politicians",
				"salience": 0.009506976,
				"type": "PERSON"
			},
			{
				"name": "Franklin",
				"salience": 0.0093134595,
				"type": "PERSON"
			},
			{
				"name": "@ 2",
				"salience": 0.0093134595,
				"type": "OTHER"
			},
			{
				"name": "Liz",
				"salience": 0.0093134595,
				"type": "PERSON"
			},
			{
				"name": "Hedaya",
				"salience": 0.0093134595,
				"type": "PERSON"
			},
			{
				"name": "Sahih Bukhari 4.53.386",
				"salience": 0.0093134595,
				"type": "PERSON"
			},
			{
				"name": "flames",
				"salience": 0.009052831,
				"type": "OTHER"
			},
			{
				"name": "terror",
				"salience": 0.008233819,
				"type": "OTHER"
			},
			{
				"name": "expansionism",
				"salience": 0.008233819,
				"type": "OTHER"
			},
			{
				"name": "jihad",
				"salience": 0.008233819,
				"type": "OTHER"
			},
			{
				"name": "muslims",
				"salience": 0.0078112553,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "islam",
				"salience": 0.006959726,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.0061525954,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/L2itYutAuc4/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T12:07:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "November 3, 2016 @ 3:07 am \nAllowing any GdM to enter or remain here is suicidal. Vetting Muslims is like vetting rattlesnakes. \n@DonSpilman That Jive ngr has not changed its spots. It blamed America first as it has always done. ‘Slime’s hatred is not a function of our foreign or domestic policy, it is a function of our not being GdM. Never lose sight of Wala wal Bara and Sidi’s explanation of the Barbary Pirates to Jeffersopn, Adams & Franklin. Always bear in mind Sahih Bukhari 4.53.386 and Hedaya 2.216. Liz November 3, 2016 @ 2:41 am \nHe makes it sound like muslims were totally peaceful until the big, bad west agitated them and created all this blowback. To claim that is to ignore islam’s 1400 year history of war, genocide, oppression, domination, terror, and tyrannical expansionism. Western leftist/liberal politicians merely kindled the flames of jihad that were already there.",
		"thread_title": "Louis Farrakhan (Nation of Islam) agrees with Donald Trump about the need for extreme vetting of Muslim immigrants",
		"title": "Louis Farrakhan (Nation of Islam) agrees with Donald Trump about the need for extreme vetting of Muslim immigrants",
		"type": "bs",
		"uuid": "1c169a0834f735e53eab4206a4a54a1d9fdf0130"
	},
	"-KhIjpdjEUdkCSKvL8CL": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-03T19:44:08.304+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Jericho Elementary School",
				"salience": 0.13946116,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.13809772,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.11047384,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.05241837,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.050385028,
				"type": "EVENT"
			},
			{
				"name": "elementary school",
				"salience": 0.05001677,
				"type": "ORGANIZATION"
			},
			{
				"name": "Store",
				"salience": 0.038330354,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.03706477,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.035783894,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.032207873,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.029730106,
				"type": "PERSON"
			},
			{
				"name": "Glen Rogers",
				"salience": 0.027795598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "NY",
				"salience": 0.023748165,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0y855",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Centereach,_New_York"
				},
				"name": "Centereach",
				"salience": 0.023748165,
				"type": "LOCATION"
			},
			{
				"name": "BNI",
				"salience": 0.023748165,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York",
				"salience": 0.023176037,
				"type": "LOCATION"
			},
			{
				"name": "kids",
				"salience": 0.021082222,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.016971651,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.015936146,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.01419926,
				"type": "PERSON"
			},
			{
				"name": "Teachers",
				"salience": 0.012360243,
				"type": "PERSON"
			},
			{
				"name": "school",
				"salience": 0.0070514134,
				"type": "LOCATION"
			},
			{
				"name": "cafeteria",
				"salience": 0.006614711,
				"type": "OTHER"
			},
			{
				"name": "cafeteria",
				"salience": 0.006614711,
				"type": "OTHER"
			},
			{
				"name": "teachers",
				"salience": 0.0063684057,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.0058026984,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0055163014,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.0054025175,
				"type": "OTHER"
			},
			{
				"name": "Trump! Trump! Trump",
				"salience": 0.005210271,
				"type": "WORK_OF_ART"
			},
			{
				"name": "words",
				"salience": 0.004679372,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03wz0t"
				},
				"name": "Roger",
				"salience": 0.0039260485,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01v3sw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ABC_News"
				},
				"name": "ABC News",
				"salience": 0.0039233104,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist attack",
				"salience": 0.0034970173,
				"type": "EVENT"
			},
			{
				"name": "opinions",
				"salience": 0.0034970173,
				"type": "OTHER"
			},
			{
				"name": "Susan K",
				"salience": 0.0033978515,
				"type": "PERSON"
			},
			{
				"name": "points",
				"salience": 0.0025476606,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0021532723,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0020800682,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.001903461,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0015684466,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Amendment_to_the_United_States_Constitution"
				},
				"name": "First Amendment",
				"salience": 0.001509913,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/trump_mock.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-03T19:44:08.304+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 3 2016 NY elementary school calls off mock election because students were chanting “Trump” and “We don’t want Muslims here” Jericho Elementary School in Centereach, New York, announced it had scrapped the mock vote that was due to take place this Friday after some young students started chanting “Trump” and repeated ‘negative rhetoric about Muslims.’ ABC News (h/t Susan K) Principal Glen Rogers revealed the decision was made after teachers complained about what some children had been chanting around the school and in the cafeteria. Teachers have said they’ve heard some kids in the cafeteria chanting “Trump! Trump! Trump!” or saying they don’t want Muslims here,’ Roger said. ‘I mean, kids often repeat what they hear on the TV or the news, but it doesn’t mean it’s OK. (In other words, you don’t think the First Amendment is OK) “We have a diverse community here. We want all our students to feel valued.” (So we don’t become the target of an Islamic terrorist attack?) ‘It’s important for our students to be able to express their opinions, but it’s also important for them to be informed about it and not just repeating what they happen to hear,’ Rogers said. (Especially if it goes against the Democrat talking points. This IS New York, after all)",
		"thread_title": "NY elementary school calls off mock election because students were chanting “Trump” and “We don’t want Muslims here”",
		"title": "NY elementary school calls off mock election because students were chanting “Trump” and “We don’t want Muslims here”",
		"type": "bs",
		"uuid": "1838a7454880951f50f9c33e00f3d735b7fc7b1f"
	},
	"-KhIjpiGKbxNUtwGdU-7": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T01:30:38.813+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Store",
				"salience": 0.2494267,
				"type": "LOCATION"
			},
			{
				"name": "BNI",
				"salience": 0.1373708,
				"type": "ORGANIZATION"
			},
			{
				"name": "war chest",
				"salience": 0.093031734,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.06994724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06rmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_Poverty_Law_Center"
				},
				"name": "Southern Poverty Law Center",
				"salience": 0.06661845,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist states",
				"salience": 0.063315734,
				"type": "LOCATION"
			},
			{
				"name": "Southern 'Poverty' Law Center",
				"salience": 0.04696152,
				"type": "ORGANIZATION"
			},
			{
				"name": "individuals",
				"salience": 0.04433538,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.042167448,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.039229136,
				"type": "OTHER"
			},
			{
				"name": "coffers",
				"salience": 0.024408573,
				"type": "OTHER"
			},
			{
				"name": "SPLC Hatewatch",
				"salience": 0.020910185,
				"type": "ORGANIZATION"
			},
			{
				"name": "hundreds",
				"salience": 0.020718815,
				"type": "OTHER"
			},
			{
				"name": "STORIES",
				"salience": 0.017441025,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.017087033,
				"type": "LOCATION"
			},
			{
				"name": "VIDEOS",
				"salience": 0.015111324,
				"type": "WORK_OF_ART"
			},
			{
				"name": "patriots",
				"salience": 0.0136584295,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.011299009,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Islam",
				"salience": 0.00696146,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/U66NkbEmkmY/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T01:30:38.813+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 3 2016 JUST AS YOU EXPECTED: Southern Poverty Law Center’s $300 million war chest likely being funded by Muslim terrorist states Southern ‘Poverty’ Law Center is anything but poor. Now renamed ‘SPLC Hatewatch,’ they spend most of their time attacking American patriots as well as anti-Islam groups and individuals after somehow enriching their coffers with hundreds of millions of dirty dollars they never had before. RELATED STORIES/VIDEOS:",
		"thread_title": "JUST AS YOU EXPECTED: Southern Poverty Law Center’s $300 million war chest likely being funded by Muslim terrorist states",
		"title": "JUST AS YOU EXPECTED: Southern Poverty Law Center’s $300 million war chest likely being funded by Muslim terrorist states",
		"type": "bs",
		"uuid": "a18117223ec0fe2826a3b2390f8369d027d1ba35"
	},
	"-KhIjprEjiXn2Npb_Tfa": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T01:30:38.856+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.28377226,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.18805154,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06426741,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.05716114,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.035996392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "DONATE",
				"salience": 0.03588462,
				"type": "OTHER"
			},
			{
				"name": "barenakedislam@gmail.com Top Posts",
				"salience": 0.03236068,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.029204627,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.028123902,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.027799565,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.02469274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "LINKS",
				"salience": 0.023880832,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.017367292,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.01518282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.01473926,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.011250982,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/iHN1zphlBTI/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T01:18:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address CONTACT: barenakedislam@gmail.com Top Posts",
		"thread_title": "BARBARIANS AT THE GATE: Muslims from Morocco keep breaking into Spain",
		"title": "BARBARIANS AT THE GATE: Muslims from Morocco keep breaking into Spain",
		"type": "bs",
		"uuid": "562aa9717e661754c1e6ed11071ade5c95cf549a"
	},
	"-KhIjq3lbqS3JrchBJCR": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T01:30:38.938+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "PARIS",
				"salience": 0.22083047,
				"type": "LOCATION"
			},
			{
				"name": "illegals",
				"salience": 0.17123333,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.07217915,
				"type": "OTHER"
			},
			{
				"name": "invaders",
				"salience": 0.051338807,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0369575,
				"type": "LOCATION"
			},
			{
				"name": "squatters camps",
				"salience": 0.03284541,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.029327003,
				"type": "EVENT"
			},
			{
				"name": "destruction",
				"salience": 0.0263398,
				"type": "OTHER"
			},
			{
				"name": "UK Daily Mail",
				"salience": 0.025308318,
				"type": "ORGANIZATION"
			},
			{
				"name": "freeloaders",
				"salience": 0.024776112,
				"type": "PERSON"
			},
			{
				"name": "beasts",
				"salience": 0.02441687,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.021177618,
				"type": "PERSON"
			},
			{
				"name": "destruction",
				"salience": 0.013882071,
				"type": "OTHER"
			},
			{
				"name": "march",
				"salience": 0.012722918,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghans",
				"salience": 0.011177535,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.010869348,
				"type": "PERSON"
			},
			{
				"name": "treatment",
				"salience": 0.010869348,
				"type": "OTHER"
			},
			{
				"name": "Masses",
				"salience": 0.009639858,
				"type": "PERSON"
			},
			{
				"name": "Stalingrad Metro station",
				"salience": 0.009199716,
				"type": "LOCATION"
			},
			{
				"name": "destruction",
				"salience": 0.008017517,
				"type": "OTHER"
			},
			{
				"name": "raid",
				"salience": 0.007487935,
				"type": "EVENT"
			},
			{
				"name": "camps",
				"salience": 0.0069930223,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qg4z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fran%C3%A7ois_Hollande"
				},
				"name": "Francois Hollande",
				"salience": 0.0067596845,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.0055527682,
				"type": "EVENT"
			},
			{
				"name": "pavements",
				"salience": 0.0053221504,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0051803403,
				"type": "PERSON"
			},
			{
				"name": "human",
				"salience": 0.0051803403,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.0049075177,
				"type": "EVENT"
			},
			{
				"name": "sticks",
				"salience": 0.0045442143,
				"type": "OTHER"
			},
			{
				"name": "h",
				"salience": 0.0044870605,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0044870605,
				"type": "LOCATION"
			},
			{
				"name": "sign",
				"salience": 0.0044870605,
				"type": "OTHER"
			},
			{
				"name": "t",
				"salience": 0.0044870605,
				"type": "OTHER"
			},
			{
				"name": "encampment",
				"salience": 0.0044870605,
				"type": "LOCATION"
			},
			{
				"name": "beast",
				"salience": 0.003971233,
				"type": "OTHER"
			},
			{
				"name": "each other",
				"salience": 0.003664297,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/g/11btw_7mgd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais_jungle"
				},
				"name": "Calais Jungle",
				"salience": 0.003656922,
				"type": "LOCATION"
			},
			{
				"name": "riot police",
				"salience": 0.0036343997,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugees",
				"salience": 0.0036343997,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0034989184,
				"type": "PERSON"
			},
			{
				"name": "fighting",
				"salience": 0.0034989184,
				"type": "EVENT"
			},
			{
				"name": "bleeding hearts",
				"salience": 0.003353452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britain",
				"salience": 0.0033022778,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0031476717,
				"type": "LOCATION"
			},
			{
				"name": "demolition workers",
				"salience": 0.0031476717,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0031476717,
				"type": "PERSON"
			},
			{
				"name": "wake",
				"salience": 0.0031476717,
				"type": "OTHER"
			},
			{
				"name": "clubs",
				"salience": 0.003030306,
				"type": "ORGANIZATION"
			},
			{
				"name": "men",
				"salience": 0.003030306,
				"type": "PERSON"
			},
			{
				"name": "gangs",
				"salience": 0.003030306,
				"type": "PERSON"
			},
			{
				"name": "speaker",
				"salience": 0.003030306,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.003030306,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.003030306,
				"type": "LOCATION"
			},
			{
				"name": "camps",
				"salience": 0.0029950966,
				"type": "LOCATION"
			},
			{
				"name": "scuffles",
				"salience": 0.0025701744,
				"type": "OTHER"
			},
			{
				"name": "possessions",
				"salience": 0.0025701744,
				"type": "OTHER"
			},
			{
				"name": "razing",
				"salience": 0.0025701744,
				"type": "EVENT"
			},
			{
				"name": "fight",
				"salience": 0.002392703,
				"type": "EVENT"
			},
			{
				"name": "clearance",
				"salience": 0.002217529,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.0021819696,
				"type": "LOCATION"
			},
			{
				"name": "hub",
				"salience": 0.0019203621,
				"type": "LOCATION"
			},
			{
				"name": "north",
				"salience": 0.0019203621,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0017133313,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0016807977,
				"type": "PERSON"
			},
			{
				"name": "refugee camp",
				"salience": 0.001630223,
				"type": "LOCATION"
			},
			{
				"name": "operation",
				"salience": 0.0016153231,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02khs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eritrea"
				},
				"name": "Eritreans",
				"salience": 0.0015824076,
				"type": "PERSON"
			},
			{
				"name": "tents",
				"salience": 0.0014166442,
				"type": "OTHER"
			},
			{
				"name": "riot police",
				"salience": 0.0014050723,
				"type": "PERSON"
			},
			{
				"name": "Gare du Nord Eurostar",
				"salience": 0.0011821769,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lps0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Calais"
				},
				"name": "Calais",
				"salience": 0.0011012612,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07_h1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Volgograd"
				},
				"name": "Stalingrad",
				"salience": 0.0011012612,
				"type": "LOCATION"
			},
			{
				"name": "resettlement centres",
				"salience": 0.0010449813,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.0010449813,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vbwp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Compagnies_R%C3%A9publicaines_de_S%C3%A9curit%C3%A9"
				},
				"name": "CRS",
				"salience": 0.00086101145,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01y3fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jungle"
				},
				"name": "Jungle",
				"salience": 0.0008226724,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/rDvi0iqFE74/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T00:59:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "PARIS: After destruction begins on their squatters camps, Muslim illegals scream that they are “humans, not beasts” But nobody is buying it. Illegal alien Muslim invaders have staged a mass protest in Paris over their treatment by French authorities following destruction of their makeshift camps. Masses of Muslim freeloaders sleeping in the streets joined local bleeding hearts to demonstrate at their encampment near the Stalingrad Metro station. UK Daily Mail (h/t therezam) One man held up a sign saying ‘human, no beast’ as a man used a loud speaker to lead the march, which happened late last night. It came 24 hours after violence broke out at the site with gangs of men attacking each other using sticks as makeshift clubs. The fighting unfolded just hours after demolition workers supported by riot police began smashing up an illegal camp full of UK-bound migrants in Paris. It also came in the wake of the destruction of the Calais Jungle which saw refugees transported around the country. It is not yet known what caused the fight in Paris. There had already been scuffles on Monday as mainly Afghans and Eritreans tried to save their possessions during the raid, which started soon after 8am. It followed thousands of Muslim freeloaders arriving in the French capital following the razing of the Calais Jungle refugee camp last week. While some 5000 Jungle residents agreed to be bused to resettlement centres around France, many others headed off independently, saying they still wanted to get to Britain. Up to 3000 set up tents on the pavements around the Stalingrad Metro station, which is close to the Gare du Nord Eurostar hub in the north of Paris. Shortly before Monday’s clearance French president Francois Hollande said: ‘We won’t tolerate the camps any longer.’ Referring to the Paris clearance, Mr Hollande said: ‘We are going to carry out the same operation as in Calais.’ CRS riot police around Stalingrad said there would be a ‘gradual operation’ which is likely to go on all week until all the camps are gone.",
		"thread_title": "PARIS: After destruction begins on their squatters camps, Muslim illegals scream that they are “humans, not beasts”",
		"title": "PARIS: After destruction begins on their squatters camps, Muslim illegals scream that they are “humans, not beasts”",
		"type": "bs",
		"uuid": "0ce067847b8248e9dacb62fb32e40086538e9b0e"
	},
	"-KhIjqEIS2s5W2TwVO0Y": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T09:08:23.678+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.68337446,
				"type": "PERSON"
			},
			{
				"name": "John LaBarbera",
				"salience": 0.048101466,
				"type": "PERSON"
			},
			{
				"name": "gays",
				"salience": 0.022368237,
				"type": "PERSON"
			},
			{
				"name": "gays",
				"salience": 0.0220919,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.019688146,
				"type": "EVENT"
			},
			{
				"name": "supporters",
				"salience": 0.016435565,
				"type": "PERSON"
			},
			{
				"name": "persecution",
				"salience": 0.014259393,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.014259393,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.014259393,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.008818618,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.008818618,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.008818618,
				"type": "PERSON"
			},
			{
				"name": "Jacksonville Equestrian Center",
				"salience": 0.008818618,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.008130265,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0076546357,
				"type": "PERSON"
			},
			{
				"name": "Craig Starling",
				"salience": 0.0052311155,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0ply0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orlando,_Florida"
				},
				"name": "Orlando",
				"salience": 0.003961687,
				"type": "LOCATION"
			},
			{
				"name": "Gays for Trump",
				"salience": 0.0038065098,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0034931835,
				"type": "OTHER"
			},
			{
				"name": "rainbow",
				"salience": 0.0034931835,
				"type": "OTHER"
			},
			{
				"name": "gays",
				"salience": 0.0033721528,
				"type": "PERSON"
			},
			{
				"name": "gays",
				"salience": 0.0031654811,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.003025887,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.003025887,
				"type": "OTHER"
			},
			{
				"name": "T-shirts",
				"salience": 0.003025887,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart News",
				"salience": 0.0029422925,
				"type": "PERSON"
			},
			{
				"name": "gay pride rally",
				"salience": 0.0029374696,
				"type": "EVENT"
			},
			{
				"name": "yard signs",
				"salience": 0.0027141634,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lhn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Savannah,_Georgia"
				},
				"name": "Savannah",
				"salience": 0.0026255627,
				"type": "LOCATION"
			},
			{
				"name": "fans",
				"salience": 0.0025995793,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.00235974,
				"type": "EVENT"
			},
			{
				"name": "booth",
				"salience": 0.0023492174,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.0022165375,
				"type": "OTHER"
			},
			{
				"name": "hate",
				"salience": 0.002122921,
				"type": "OTHER"
			},
			{
				"name": "theft",
				"salience": 0.002122921,
				"type": "EVENT"
			},
			{
				"name": "policies",
				"salience": 0.002122921,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0020437865,
				"type": "OTHER"
			},
			{
				"name": "nightclub",
				"salience": 0.0020437865,
				"type": "LOCATION"
			},
			{
				"name": "immigration",
				"salience": 0.0020437865,
				"type": "OTHER"
			},
			{
				"name": "Musilm",
				"salience": 0.0018639922,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.0017335248,
				"type": "OTHER"
			},
			{
				"name": "Gays for Trump",
				"salience": 0.0016647936,
				"type": "PERSON"
			},
			{
				"name": "terror attack",
				"salience": 0.0014957221,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0013073388,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0012953186,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.0012585715,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.0010052965,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0009758689,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.0009435595,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.0009435595,
				"type": "PERSON"
			},
			{
				"name": "addition",
				"salience": 0.0009435595,
				"type": "OTHER"
			},
			{
				"name": "killing",
				"salience": 0.0009435595,
				"type": "EVENT"
			},
			{
				"name": "handling",
				"salience": 0.0009435595,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0009015611,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00089383224,
				"type": "ORGANIZATION"
			},
			{
				"name": "supporter",
				"salience": 0.00081404304,
				"type": "PERSON"
			},
			{
				"name": "rainbow flag",
				"salience": 0.0008104079,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00070491544,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00070491544,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0005808243,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muammar_Gaddafi"
				},
				"name": "Muammar Gaddafi",
				"salience": 0.0005808243,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005808243,
				"type": "LOCATION"
			},
			{
				"name": "LGBTs for Trump",
				"salience": 0.0004988374,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01n4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colorado"
				},
				"name": "Colorado",
				"salience": 0.00043388666,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Sunshine State",
				"salience": 0.00043388666,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/IMG_5738-640x480.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T09:08:23.678+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Very concerned about Islam-sanctioned persecution of gays by Muslim, gays come out in force for Trump Republican presidential nominee Donald Trump kicked off a marathon day of campaigning with a speech to over 4,000 supporters at the Jacksonville Equestrian Center on Thursday. And John LaBarbera and Craig Starling, wearing rainbow ‘Gays for Trump’ T-shirts, made sure they were there. Breitbart “We’re concerned about the possibility of Musilm terrorism and anti-gay violence such as the deadly attack on a gay nightclub in Orlando,” Starling told Breitbart News. “Trump is better on security and immigration.” LaBarbera, who drove with Starling from Savannah, Georgia, to attend the rally, agreed, adding that he also preferred Trump’s economic policies. He said that he had lost several yard signs to theft, and had endured hate on Facebook. But he added that people at Savannah’s gay pride rally had been “kind” when they set up a booth for Trump, and that Trump fans at the rally had been “supportive” as well. Other “Gays for Trump” signs have been popping up at Trump rallies elsewhere in the Sunshine State. One supporter waved a homemade sign at Trump’s rally in Orlando on Wednesday. And Trump emerged onstage in Colorado on Sunday holding a rainbow flag with the words “LGBTs for Trump” written on it. More and more gays are supporting Donald Trump. In light of the Orlando terror attack they realize that Trump is the only one who will keep them safe. Hillary helped to create ISIS with her bumbling handling of Libya and the killing of Muammar Gaddafi. In addition, Hillary Clinton supports and takes millions of dollars from Saudis, who not only abuse and execute gays, they also treat women like second-class citizens.",
		"thread_title": "Very concerned about Islam-sanctioned persecution of gays by Muslim, gays come out in force for Trump",
		"title": "Very concerned about Islam-sanctioned persecution of gays by Muslim, gays come out in force for Trump",
		"type": "bs",
		"uuid": "270e72c75c9aff26b5f5d648679a8e34e6e72191"
	},
	"-KhIjqRXI5R0cF5UjN8i": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T09:08:23.933+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.12032816,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.07894647,
				"type": "OTHER"
			},
			{
				"name": "vicar",
				"salience": 0.06092829,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.053003073,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "GERMANY",
				"salience": 0.042927496,
				"type": "LOCATION"
			},
			{
				"name": "priest",
				"salience": 0.042107895,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.042107895,
				"type": "PERSON"
			},
			{
				"name": "pre-teens",
				"salience": 0.038700037,
				"type": "PERSON"
			},
			{
				"name": "town",
				"salience": 0.03774504,
				"type": "LOCATION"
			},
			{
				"name": "priest",
				"salience": 0.037659355,
				"type": "PERSON"
			},
			{
				"name": "stones",
				"salience": 0.033038825,
				"type": "OTHER"
			},
			{
				"name": "Isack Majura",
				"salience": 0.030280298,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.029408254,
				"type": "PERSON"
			},
			{
				"name": "outskirts",
				"salience": 0.028657645,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02z0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Frankfurt"
				},
				"name": "Frankfurt",
				"salience": 0.020434616,
				"type": "LOCATION"
			},
			{
				"name": "priest",
				"salience": 0.019228565,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019pcs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ethiopia"
				},
				"name": "Ethiopian",
				"salience": 0.017712861,
				"type": "LOCATION"
			},
			{
				"name": "priests",
				"salience": 0.017167943,
				"type": "PERSON"
			},
			{
				"name": "priest",
				"salience": 0.016740682,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017bdl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takbir"
				},
				"name": "Allahu Akhbar",
				"salience": 0.015068083,
				"type": "OTHER"
			},
			{
				"name": "Raunheim",
				"salience": 0.013887928,
				"type": "LOCATION"
			},
			{
				"name": "cross",
				"salience": 0.009821904,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.007482945,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.007482945,
				"type": "PERSON"
			},
			{
				"name": "stones",
				"salience": 0.0066662976,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0062899846,
				"type": "PERSON"
			},
			{
				"name": "gear",
				"salience": 0.0060739843,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "neck",
				"salience": 0.0060739843,
				"type": "OTHER"
			},
			{
				"name": "church",
				"salience": 0.0060739843,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0060556503,
				"type": "PERSON"
			},
			{
				"name": "convert",
				"salience": 0.005629785,
				"type": "PERSON"
			},
			{
				"name": "parents",
				"salience": 0.0055933846,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0054442696,
				"type": "WORK_OF_ART"
			},
			{
				"name": "news reports",
				"salience": 0.0049198517,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hold",
				"salience": 0.0046560043,
				"type": "OTHER"
			},
			{
				"name": "daughter",
				"salience": 0.004597415,
				"type": "PERSON"
			},
			{
				"name": "photos",
				"salience": 0.0043703257,
				"type": "WORK_OF_ART"
			},
			{
				"name": "UK Express",
				"salience": 0.0043198066,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.0042610154,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0042610154,
				"type": "OTHER"
			},
			{
				"name": "mobile phones",
				"salience": 0.0041021467,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "chapel",
				"salience": 0.0041021467,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.0040174574,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0040174574,
				"type": "EVENT"
			},
			{
				"name": "camps",
				"salience": 0.0040174574,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0038387661,
				"type": "PERSON"
			},
			{
				"name": "baton",
				"salience": 0.003479296,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "example",
				"salience": 0.003479296,
				"type": "OTHER"
			},
			{
				"name": "pupil",
				"salience": 0.0033245094,
				"type": "PERSON"
			},
			{
				"name": "pupils",
				"salience": 0.0032005128,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christianity",
				"salience": 0.0031634993,
				"type": "OTHER"
			},
			{
				"name": "rituals",
				"salience": 0.002599667,
				"type": "OTHER"
			},
			{
				"name": "nursery",
				"salience": 0.002599667,
				"type": "LOCATION"
			},
			{
				"name": "chants",
				"salience": 0.002599667,
				"type": "OTHER"
			},
			{
				"name": "teachers",
				"salience": 0.002599667,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b06q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Orthodox_Church"
				},
				"name": "Russian Orthodox",
				"salience": 0.0025259068,
				"type": "ORGANIZATION"
			},
			{
				"name": "Frankfurter Straße",
				"salience": 0.0025259068,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0024334204,
				"type": "LOCATION"
			},
			{
				"name": "pupils",
				"salience": 0.0024217996,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.0024217996,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01vq3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christmas"
				},
				"name": "Christmas",
				"salience": 0.0023636338,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allah"
				},
				"name": "Allah",
				"salience": 0.0022155326,
				"type": "PERSON"
			},
			{
				"name": "asylum centers",
				"salience": 0.0021867377,
				"type": "LOCATION"
			},
			{
				"name": "carols",
				"salience": 0.0021769742,
				"type": "OTHER"
			},
			{
				"name": "Hamburg-Eidelstedt",
				"salience": 0.00214218,
				"type": "LOCATION"
			},
			{
				"name": "youngsters",
				"salience": 0.0020957422,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09kb_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God_in_Islam"
				},
				"name": "God",
				"salience": 0.002062245,
				"type": "PERSON"
			},
			{
				"name": "Christmas tree",
				"salience": 0.0018936258,
				"type": "OTHER"
			},
			{
				"name": "cultures",
				"salience": 0.0018936258,
				"type": "OTHER"
			},
			{
				"name": "invader centers",
				"salience": 0.0016336773,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.0016336773,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0016003817,
				"type": "OTHER"
			},
			{
				"name": "ski resort",
				"salience": 0.0014146562,
				"type": "LOCATION"
			},
			{
				"name": "girl",
				"salience": 0.0014146562,
				"type": "PERSON"
			},
			{
				"name": "primary school",
				"salience": 0.0014146562,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01_myf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Express"
				},
				"name": "Express.co.uk",
				"salience": 0.00136327,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02587z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Garmisch-Partenkirchen"
				},
				"name": "Garmisch-Partenkirchen",
				"salience": 0.00087071833,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/Merkel-koran-725651.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T09:08:23.933+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "GERMANY: Christian priest gets stoned by illegal alien Muslim children shouting “Allahu Akbar” The Ethiopian vicar was visiting the town of Raunheim on the outskirts of Frankfurt when the pre-teens started throwing stones at him. The three Muslim children, aged between 10 and 12-years-old, shouted “Allahu Akhbar” as they threw the stones, the other priest who was visiting from a nearby church said. UK Express Dressed in traditional priest’s gear and wearing a cross around his neck, the 47-year-old was walking to the Russian Orthodox chapel in Frankfurter Straße with a local priest, who wished to remain anonymous, when he was attacked. Both priests tried to take photos of the children with their mobile phones, but the youngsters were too quick and managed to escape. Raunheim social worker Dr Isack Majura said he was going to do everything possible to get hold of the children. He said: “What happened is absolutely unacceptable.” (Get used to it) There have been a number of news reports of Christians facing attacks by Muslims at German camps, such as a case from October 2015 where a convert to Christianity was reportedly beaten unconscious with a baton by Muslim refugees at a camp in Hamburg-Eidelstedt. For example, a report earlier this year revealed that there had been no less than 743 reported attacks by Muslims upon Christians in invader centers in Germany. Yesterday, Express.co.uk revealed pupils at a girl’s primary school in the German ski resort of Garmisch-Partenkirchen are being forced to chant “Allahu Akhbar” and “there is no God but Allah.” A father of a pupil claimed his daughter had been “forced” by teachers to memorize the Islamic chants. Weeks before, parents complained their children’s nursery was refusing to acknowledge “Christmas rituals” such as putting up a Christmas tree or singing carols to accommodate the “diverse (Muslim) cultures” of other pupils. In Germany, Christian refugees have to be separated from Muslim refugees because they are being peesecuted by the Muslims in the asylum centers.",
		"thread_title": "GERMANY: Christian priest gets stoned by illegal alien Muslim children shouting “Allahu Akbar”",
		"title": "GERMANY: Christian priest gets stoned by illegal alien Muslim children shouting “Allahu Akbar”",
		"type": "bs",
		"uuid": "eb9c8712c7559e176758860959734e6e11f789ed"
	},
	"-KhIjqdj93XwGjF4F-zV": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T10:30:26.074+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Noor Salman",
				"salience": 0.6356717,
				"type": "PERSON"
			},
			{
				"name": "Omar Mateen",
				"salience": 0.116078615,
				"type": "PERSON"
			},
			{
				"name": "Wife",
				"salience": 0.030918665,
				"type": "PERSON"
			},
			{
				"name": "husband",
				"salience": 0.026253304,
				"type": "PERSON"
			},
			{
				"name": "nothing",
				"salience": 0.017055871,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ply0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Orlando,_Florida"
				},
				"name": "Orlando",
				"salience": 0.013436758,
				"type": "LOCATION"
			},
			{
				"name": "nightclub massacre",
				"salience": 0.011149469,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01s0l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salman_Khan"
				},
				"name": "Salman",
				"salience": 0.011079538,
				"type": "PERSON"
			},
			{
				"name": "jihadist",
				"salience": 0.008738199,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.008738199,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.008738199,
				"type": "OTHER"
			},
			{
				"name": "Store",
				"salience": 0.007609033,
				"type": "LOCATION"
			},
			{
				"name": "BNI",
				"salience": 0.0053960904,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.0053960904,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0048202123,
				"type": "ORGANIZATION"
			},
			{
				"name": "massacre",
				"salience": 0.0046189926,
				"type": "EVENT"
			},
			{
				"name": "massacre",
				"salience": 0.0046189926,
				"type": "EVENT"
			},
			{
				"name": "whereabouts",
				"salience": 0.0044806586,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.004324658,
				"type": "ORGANIZATION"
			},
			{
				"name": "interview",
				"salience": 0.0039693983,
				"type": "EVENT"
			},
			{
				"name": "controversy",
				"salience": 0.0036146676,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.0034295316,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/090h4n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mia_Bloom"
				},
				"name": "Mia Bloom",
				"salience": 0.0030483764,
				"type": "PERSON"
			},
			{
				"name": "Pulse Nightclub",
				"salience": 0.0028476398,
				"type": "LOCATION"
			},
			{
				"name": "detail",
				"salience": 0.0018486248,
				"type": "OTHER"
			},
			{
				"name": "track",
				"salience": 0.0018486248,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.0018486248,
				"type": "OTHER"
			},
			{
				"name": "trips",
				"salience": 0.001844897,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0017682037,
				"type": "PERSON"
			},
			{
				"name": "videos",
				"salience": 0.0017133697,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nightclub",
				"salience": 0.0016580413,
				"type": "LOCATION"
			},
			{
				"name": "interest",
				"salience": 0.0015962241,
				"type": "OTHER"
			},
			{
				"name": "husband",
				"salience": 0.0015632708,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.0014532526,
				"type": "OTHER"
			},
			{
				"name": "lawyers",
				"salience": 0.0014413908,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0014413908,
				"type": "EVENT"
			},
			{
				"name": "discussions",
				"salience": 0.0012482913,
				"type": "EVENT"
			},
			{
				"name": "agents",
				"salience": 0.0012482913,
				"type": "PERSON"
			},
			{
				"name": "law enforcement",
				"salience": 0.0012482913,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.0012482913,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0012482913,
				"type": "WORK_OF_ART"
			},
			{
				"name": "relatives",
				"salience": 0.0012225119,
				"type": "PERSON"
			},
			{
				"name": "husband",
				"salience": 0.0011681189,
				"type": "PERSON"
			},
			{
				"name": "accomplice",
				"salience": 0.0010587026,
				"type": "OTHER"
			},
			{
				"name": "slaughter",
				"salience": 0.0010587026,
				"type": "OTHER"
			},
			{
				"name": "friends",
				"salience": 0.0010587026,
				"type": "PERSON"
			},
			{
				"name": "terrorist activities",
				"salience": 0.0010587026,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0010115902,
				"type": "OTHER"
			},
			{
				"name": "intentions",
				"salience": 0.0010115902,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.00096882606,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.00093268,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0009134122,
				"type": "EVENT"
			},
			{
				"name": "trip",
				"salience": 0.0009134122,
				"type": "EVENT"
			},
			{
				"name": "piece",
				"salience": 0.00090190786,
				"type": "WORK_OF_ART"
			},
			{
				"name": "studies",
				"salience": 0.00088657235,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00079098623,
				"type": "PERSON"
			},
			{
				"name": "hallmarks",
				"salience": 0.00079098623,
				"type": "OTHER"
			},
			{
				"name": "park",
				"salience": 0.00079098623,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.00079098623,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.00079098623,
				"type": "EVENT"
			},
			{
				"name": "notorious",
				"salience": 0.00069680804,
				"type": "OTHER"
			},
			{
				"name": "cold blood",
				"salience": 0.000665324,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j416",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_State_University"
				},
				"name": "Georgia State University",
				"salience": 0.0006517647,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09rkd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Times"
				},
				"name": "The Times",
				"salience": 0.00064979395,
				"type": "ORGANIZATION"
			},
			{
				"name": "relationship",
				"salience": 0.0006486658,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.00062960025,
				"type": "OTHER"
			},
			{
				"name": "lawyers",
				"salience": 0.0006011509,
				"type": "PERSON"
			},
			{
				"name": "holster",
				"salience": 0.00057612965,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00057612965,
				"type": "OTHER"
			},
			{
				"name": "bed",
				"salience": 0.00057612965,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b1k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walt_Disney_World"
				},
				"name": "Disneyworld",
				"salience": 0.0004868993,
				"type": "LOCATION"
			},
			{
				"name": "trouble",
				"salience": 0.00046441206,
				"type": "OTHER"
			},
			{
				"name": "bystander",
				"salience": 0.00043038768,
				"type": "PERSON"
			},
			{
				"name": "preparation",
				"salience": 0.00043038768,
				"type": "OTHER"
			},
			{
				"name": "terrorist career",
				"salience": 0.00043038768,
				"type": "OTHER"
			},
			{
				"name": "ammunition",
				"salience": 0.00037434924,
				"type": "OTHER"
			},
			{
				"name": "pass",
				"salience": 0.00036963174,
				"type": "OTHER"
			},
			{
				"name": "suspicions",
				"salience": 0.00032150134,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/UgcxGFmYyPs/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-04T10:30:26.074+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 4 2016 Wife of Muslim jihadist who killed and wounded over 100 in Orlando nightclub massacre says she “knew nothing” “I was unaware of everything,” says Omar Mateen’s wife, 30-year-old Noor Salman (whose whereabouts were a matter of controversy for some time after the massacre), has given her first interview since the Pulse Nightclub massacre to the New York Times. The New York Times piece does not go into detail about her movements since the FBI seemingly lost track of her, although it suggests she is still a person of interest to law enforcement. Her lawyers pop up early in the article to insist she “did nothing wrong” and to forbid questions about her discussions with federal agents. Salman said she had no idea what Mateen was up to on the day of the attack. She knew her husband watched jihadist videos, but she did not think much of it. But how could she have not suspected what her husband was planning – she knew he had the weapons, she drove him to the nightclub and dropped him off: Noor Salman, wife of Orlando shooter Omar Mateen, had all the hallmarks of a willing accomplice to her husband’s jihadist slaughter. Georgia State University professor Mia Bloom told The Times that studies show relatives and friends are aware of budding terrorist activities about 64% of the time and argued that Mateen’s abusive relationship with Salman “doesn’t give her a free pass as a bystander to not come forward.” Salman insists she had no dark suspicions about several trips she took with Mateen that have been viewed as preparation for his terrorist career, although the lawyers notably intervened to prevent her from discussing the most notorious of these incidents – the April 2015 trip to Disneyworld that Mateen may have used to case the park for an attack. Salman did nothing to warn the police of her husband’s intentions. When the FBI first questioned Salman, she admitted to bringing Mateen ammunition and a holster. The piece describes her as “shattered and afraid,” to the point that she sometimes has trouble getting out of bed. (Awww…I bet those 49 people her husband slaughtered in cold blood in Orlando would love to have that problem)",
		"thread_title": "Wife of Muslim jihadist who killed and wounded over 100 in Orlando nightclub massacre says she “knew nothing”",
		"title": "Wife of Muslim jihadist who killed and wounded over 100 in Orlando nightclub massacre says she “knew nothing”",
		"type": "bs",
		"uuid": "d7832b9ddbfb62b0bd76945109828b556839d2de"
	},
	"-KhIjqjvK93TXGVati0Y": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T00:16:00.174+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.28377226,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.18805154,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06426741,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.05716114,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.035996392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "DONATE",
				"salience": 0.03588462,
				"type": "OTHER"
			},
			{
				"name": "barenakedislam@gmail.com Top Posts",
				"salience": 0.03236068,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.029204627,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.028123902,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.027799565,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.02469274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "LINKS",
				"salience": 0.023880832,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.017367292,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.01518282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.01473926,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.011250982,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/172-800x254-1-800x254.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:16:00.174+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address CONTACT: barenakedislam@gmail.com Top Posts",
		"thread_title": "BLACK TRUMP SUPPORTERS call Hillary Clinton a “racist”",
		"title": "BLACK TRUMP SUPPORTERS call Hillary Clinton a “racist”",
		"type": "bs",
		"uuid": "8ff824a8d52fb90b6c64f149a7fd4d0c3bdc2e03"
	},
	"-KhIjqqs9zyTHv2onMFJ": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T00:16:00.439+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.28377226,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.18805154,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06426741,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.05716114,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.035996392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "DONATE",
				"salience": 0.03588462,
				"type": "OTHER"
			},
			{
				"name": "barenakedislam@gmail.com Top Posts",
				"salience": 0.03236068,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.029204627,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.028123902,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.027799565,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.02469274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "LINKS",
				"salience": 0.023880832,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.017367292,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.01518282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.01473926,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.011250982,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/7ELh5o1BAdA/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:16:00.439+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address CONTACT: barenakedislam@gmail.com Top Posts",
		"thread_title": "MILO at Dartmouth College on Donald Trump, real men, and political correctness",
		"title": "MILO at Dartmouth College on Donald Trump, real men, and political correctness",
		"type": "bs",
		"uuid": "58016c4fc9091b1b0b6711620f775c95e9d834a7"
	},
	"-KhIjr4NBKyiFogZvMQq": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T00:16:00.893+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "crime",
				"salience": 0.13561514,
				"type": "OTHER"
			},
			{
				"name": "Countries",
				"salience": 0.09871457,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.08188845,
				"type": "PERSON"
			},
			{
				"name": "statements",
				"salience": 0.041909218,
				"type": "OTHER"
			},
			{
				"name": "@ 4",
				"salience": 0.039233543,
				"type": "OTHER"
			},
			{
				"name": "undesirables network",
				"salience": 0.0325936,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.032374706,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.03157805,
				"type": "OTHER"
			},
			{
				"name": "believers",
				"salience": 0.028248152,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.025942357,
				"type": "PERSON"
			},
			{
				"name": "undesirables",
				"salience": 0.019213257,
				"type": "PERSON"
			},
			{
				"name": "'s",
				"salience": 0.018390201,
				"type": "OTHER"
			},
			{
				"name": "thieves",
				"salience": 0.016937178,
				"type": "PERSON"
			},
			{
				"name": "undesirables",
				"salience": 0.016810933,
				"type": "PERSON"
			},
			{
				"name": "human nature",
				"salience": 0.014345516,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.012757291,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.012757291,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.012426353,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.011664503,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.011554128,
				"type": "PERSON"
			},
			{
				"name": "world war",
				"salience": 0.011157351,
				"type": "EVENT"
			},
			{
				"name": "All",
				"salience": 0.010462599,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.010193929,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.0101209935,
				"type": "ORGANIZATION"
			},
			{
				"name": "network",
				"salience": 0.0099390745,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.009770277,
				"type": "LOCATION"
			},
			{
				"name": "share",
				"salience": 0.009448281,
				"type": "OTHER"
			},
			{
				"name": "States",
				"salience": 0.009448281,
				"type": "LOCATION"
			},
			{
				"name": "Countries",
				"salience": 0.009448281,
				"type": "ORGANIZATION"
			},
			{
				"name": "politicians",
				"salience": 0.009096125,
				"type": "PERSON"
			},
			{
				"name": "cut",
				"salience": 0.008183112,
				"type": "OTHER"
			},
			{
				"name": "likes",
				"salience": 0.008183112,
				"type": "OTHER"
			},
			{
				"name": "holiday",
				"salience": 0.007878032,
				"type": "EVENT"
			},
			{
				"name": "pockets",
				"salience": 0.007878032,
				"type": "OTHER"
			},
			{
				"name": "company executives",
				"salience": 0.007878032,
				"type": "PERSON"
			},
			{
				"name": "law officials",
				"salience": 0.007878032,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.007878032,
				"type": "OTHER"
			},
			{
				"name": "motor car",
				"salience": 0.007878032,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "companies",
				"salience": 0.007618294,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0074277283,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0070292507,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.0066819363,
				"type": "OTHER"
			},
			{
				"name": "outcomes",
				"salience": 0.0066819363,
				"type": "OTHER"
			},
			{
				"name": "foundation",
				"salience": 0.0066819363,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.006384687,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western Societies",
				"salience": 0.005818712,
				"type": "ORGANIZATION"
			},
			{
				"name": "share",
				"salience": 0.005765216,
				"type": "OTHER"
			},
			{
				"name": "human nature",
				"salience": 0.005765216,
				"type": "OTHER"
			},
			{
				"name": "MONEY",
				"salience": 0.005672775,
				"type": "OTHER"
			},
			{
				"name": "purse",
				"salience": 0.004992693,
				"type": "OTHER"
			},
			{
				"name": "worms",
				"salience": 0.004992693,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.00465111,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00465111,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00465111,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0042384216,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0042384216,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0042384216,
				"type": "OTHER"
			},
			{
				"name": "societies",
				"salience": 0.0041996855,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.004114114,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0040127644,
				"type": "PERSON"
			},
			{
				"name": "mayhems",
				"salience": 0.0036367744,
				"type": "OTHER"
			},
			{
				"name": "power politicians",
				"salience": 0.0031375473,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.002894736,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.0027169175,
				"type": "OTHER"
			},
			{
				"name": "plenty",
				"salience": 0.0027169175,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0027169175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.0022386194,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0017592935,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/0ktchDCoLek/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:16:00.893+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "November 4, 2016 @ 4:48 pm \nNow why am I not surprised? Countries which have allowed enough undesirable’s to immigrate, have been sucked in with the undesirables network of serious organised crime. Crime’s are largely committed upon non believers, as is the right these people have been bought up to believe they have. They are bought up to lie and cheat. It is human nature for pretty much everyone – is to have material things better than they would normally afford. Be it a nicer home, or some annual holiday or expensive motor car. Who does not like the better things in life? Well – these scheming thieves already have a network of bribed politicians, EU, law officials, high paid company executives etc – in their pockets. All from a share of the corrupt money they have stolen from Western Societies. And distributed a cut to money greedy people who are trusted in running our companies, States and Countries. With what I see going on with the likes of the EU – I am not surprised one bit with likely outcomes with the Clinton foundation. Oh – they come out with statements that they are fighting terrorism, yet they have been bribed to do as they are told – and actually let these undesirables help themselves to our money. And these undesirables funnel plenty of money to the very people our in power politicians pretend they are protecting us from. It is very much a catch 22 situation. They spend lots of money to fight ISIS, yet on the hand allow these people to help themselves to our purse – effectively supporting them. All due to our human nature of wanting more than our honest fair share. Our financial world is can of worms. Let’s hope a nasty world war is held off for as long as possible – as this is where we are heading – for whoever ends up in power. In the mean time – our people in power are turning our free Western societies into mini mayhems – and pretending they are doing good. All for MONEY.",
		"thread_title": "HILLARY CLINTON is being funded by the same Muslim terrorism supporting governments as the Islamic State (ISIS)",
		"title": "HILLARY CLINTON is being funded by the same Muslim terrorism supporting governments as the Islamic State (ISIS)",
		"type": "bs",
		"uuid": "c10c23c6dfe4779fe36aeb512ec0d71e0eb69a34"
	},
	"-KhIjrFfBmwnBtf-nqDc": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T00:16:00.922+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/052pl4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/R._White_Daring_Molenbeek"
				},
				"name": "MOLENBEEK",
				"salience": 0.2128688,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.16128185,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0154j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belgium"
				},
				"name": "BELGIUM",
				"salience": 0.088906065,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.04564467,
				"type": "PERSON"
			},
			{
				"name": "heart activists",
				"salience": 0.03221252,
				"type": "PERSON"
			},
			{
				"name": "population",
				"salience": 0.03221252,
				"type": "PERSON"
			},
			{
				"name": "jihad",
				"salience": 0.027950566,
				"type": "OTHER"
			},
			{
				"name": "counter-terrorism crackdown",
				"salience": 0.027950566,
				"type": "EVENT"
			},
			{
				"name": "heroes",
				"salience": 0.027950566,
				"type": "PERSON"
			},
			{
				"name": "hotbed",
				"salience": 0.027950566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ptl__"
				},
				"name": "Leftist",
				"salience": 0.017290752,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.016873183,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ckxt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Watch"
				},
				"name": "Human Rights Watch",
				"salience": 0.015844125,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.014806767,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.014806767,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist suspects",
				"salience": 0.014806767,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.013794273,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013vjh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sint-Jans-Molenbeek"
				},
				"name": "Molenbeek-Saint-Jean",
				"salience": 0.013179736,
				"type": "LOCATION"
			},
			{
				"name": "treatment",
				"salience": 0.011593429,
				"type": "OTHER"
			},
			{
				"name": "metro station",
				"salience": 0.008438423,
				"type": "LOCATION"
			},
			{
				"name": "population",
				"salience": 0.006851033,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.00593469,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0057021864,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.005546728,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.0053233914,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0053233914,
				"type": "EVENT"
			},
			{
				"name": "hundreds",
				"salience": 0.0048074634,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0048074634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0045674453,
				"type": "LOCATION"
			},
			{
				"name": "sites",
				"salience": 0.0041638943,
				"type": "LOCATION"
			},
			{
				"name": "sports stadium",
				"salience": 0.0041638943,
				"type": "LOCATION"
			},
			{
				"name": "conveyor belt",
				"salience": 0.0041638943,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0041638943,
				"type": "LOCATION"
			},
			{
				"name": "actions",
				"salience": 0.0041299253,
				"type": "OTHER"
			},
			{
				"name": "habitants",
				"salience": 0.004008697,
				"type": "LOCATION"
			},
			{
				"name": "capita",
				"salience": 0.0039259633,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0039259633,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0039259633,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0039259633,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05qtj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paris"
				},
				"name": "Paris",
				"salience": 0.0038003882,
				"type": "LOCATION"
			},
			{
				"name": "station",
				"salience": 0.0037320561,
				"type": "LOCATION"
			},
			{
				"name": "ALL",
				"salience": 0.0034002026,
				"type": "OTHER"
			},
			{
				"name": "airport",
				"salience": 0.0034002026,
				"type": "LOCATION"
			},
			{
				"name": "recruits",
				"salience": 0.0034002026,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0034002026,
				"type": "OTHER"
			},
			{
				"name": "attackers",
				"salience": 0.0032489744,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0029358524,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.0029338037,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0029338037,
				"type": "LOCATION"
			},
			{
				"name": "many",
				"salience": 0.0029338037,
				"type": "PERSON"
			},
			{
				"name": "wing 'rights' groups",
				"salience": 0.0028604015,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.0026774833,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0025407465,
				"type": "OTHER"
			},
			{
				"name": "neighborhood",
				"salience": 0.0025407465,
				"type": "LOCATION"
			},
			{
				"name": "searches",
				"salience": 0.0025407465,
				"type": "OTHER"
			},
			{
				"name": "stops",
				"salience": 0.0025407465,
				"type": "LOCATION"
			},
			{
				"name": "raids",
				"salience": 0.0025407465,
				"type": "EVENT"
			},
			{
				"name": "detentions",
				"salience": 0.0025407465,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0024151753,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "suspects",
				"salience": 0.0023669438,
				"type": "PERSON"
			},
			{
				"name": "terrorist suspects",
				"salience": 0.0023669438,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.0018508108,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.0018508108,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.0018508108,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.0018508108,
				"type": "EVENT"
			},
			{
				"name": "concert hall",
				"salience": 0.001759309,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.001382723,
				"type": "PERSON"
			},
			{
				"name": "regulations",
				"salience": 0.001382723,
				"type": "OTHER"
			},
			{
				"name": "counterterrorism laws",
				"salience": 0.001382723,
				"type": "OTHER"
			},
			{
				"name": "raft",
				"salience": 0.001382723,
				"type": "OTHER"
			},
			{
				"name": "salute",
				"salience": 0.001382723,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.001382723,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.001382723,
				"type": "ORGANIZATION"
			},
			{
				"name": "cities",
				"salience": 0.001382723,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/2E7EA9F000000578-3320070-image-m-48_1447677980066-800x556.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:16:00.922+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BELGIUM: Leftist bleeding heart activists whine about Muslims being targeted in counter-terrorism crackdown MOLENBEEK: Belgium’s hotbed of violent Islamic jihad where up to 80% of the population is Muslim and ISIS terrorists are considered heroes, Muslims being questioned by police complain of being “insulted and humiliated,” says Human Rights Watch, who accuse police of overly harsh treatment of terrorist suspects. Belgium, with a population of just 11million and about a half million Muslims – has produced more jihadi fighters per capita than any other country in Europe. Molenbeek-Saint-Jean – home to just 90,000 habitants – has become known across the world as Europe’s “jihadi conveyor belt”. Coordinated attacks in Paris at sites including a concert hall and sports stadium killed 130 people and injured hundreds, as well as coordinated attacks at the Brussels international airport and a metro station that killed 32 people and injured hundreds ALL were linked to Belgium, the country with the highest reported number of recruits to Islamic jihadist groups per capita in Western Europe. The one-finger salute of ISIS in Molenbeek In response the Belgian government has enacted a raft of new counterterrorism laws and regulations, and deployed more than 1,800 soldiers in major cities. The Belgian police have carried out several hundred raids, detentions and stops and searches, many in Molenbeek, the neighborhood of Brussels that was a home or way station to many of the Paris and Brussels attackers. These actions have helped the authorities convict 43 suspects and charge 72 others for terrorism-related crimes. But left wing ‘rights’ groups such as Human Rights Watch claim the terrorist suspects are the ones being persecuted.",
		"thread_title": "BELGIUM: Leftist bleeding heart activists whine about Muslims being targeted in counter-terrorism crackdown",
		"title": "BELGIUM: Leftist bleeding heart activists whine about Muslims being targeted in counter-terrorism crackdown",
		"type": "bs",
		"uuid": "fc6d072517d43d3afb966bd59ebfc025b945a601"
	},
	"-KhIjrUrmOl-O-CoNVGl": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T00:16:00.978+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03ryn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indonesia"
				},
				"name": "Indonesian",
				"salience": 0.13641849,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dsc093",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joko_Widodo"
				},
				"name": "Joko Widodo",
				"salience": 0.13023603,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.07647946,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.06260565,
				"type": "OTHER"
			},
			{
				"name": "governor",
				"salience": 0.051984042,
				"type": "PERSON"
			},
			{
				"name": "governor",
				"salience": 0.024440426,
				"type": "PERSON"
			},
			{
				"name": "street protest",
				"salience": 0.024440426,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.022853395,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.022596952,
				"type": "LOCATION"
			},
			{
				"name": "Store",
				"salience": 0.020422067,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.020422067,
				"type": "EVENT"
			},
			{
				"name": "capital",
				"salience": 0.019177746,
				"type": "LOCATION"
			},
			{
				"name": "display",
				"salience": 0.017704586,
				"type": "OTHER"
			},
			{
				"name": "strain",
				"salience": 0.017704586,
				"type": "OTHER"
			},
			{
				"name": "hold",
				"salience": 0.017704586,
				"type": "OTHER"
			},
			{
				"name": "MODERATE",
				"salience": 0.017704586,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.017704586,
				"type": "LOCATION"
			},
			{
				"name": "Purnama",
				"salience": 0.017157212,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0mgnb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Blasphemy"
				},
				"name": "Blasphemy",
				"salience": 0.016329532,
				"type": "OTHER"
			},
			{
				"name": "governor",
				"salience": 0.011125423,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qdfcw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank_Negara_Indonesia"
				},
				"name": "BNI",
				"salience": 0.010928494,
				"type": "ORGANIZATION"
			},
			{
				"name": "JARKARTA",
				"salience": 0.010928494,
				"type": "ORGANIZATION"
			},
			{
				"name": "hard-liners",
				"salience": 0.01065388,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.01028153,
				"type": "ORGANIZATION"
			},
			{
				"name": "politician",
				"salience": 0.009899285,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.007947813,
				"type": "OTHER"
			},
			{
				"name": "sect",
				"salience": 0.006619503,
				"type": "PERSON"
			},
			{
				"name": "Yon Machmudi",
				"salience": 0.005483067,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/051fj9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jusuf_Kalla"
				},
				"name": "Jusuf Kalla",
				"salience": 0.005346024,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.004944422,
				"type": "OTHER"
			},
			{
				"name": "hard-liners",
				"salience": 0.0047998726,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0047848257,
				"type": "LOCATION"
			},
			{
				"name": "blasphemy",
				"salience": 0.0047848257,
				"type": "OTHER"
			},
			{
				"name": "capital",
				"salience": 0.0043209107,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0043209107,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.003928803,
				"type": "ORGANIZATION"
			},
			{
				"name": "prosecutions",
				"salience": 0.0037422774,
				"type": "EVENT"
			},
			{
				"name": "rally",
				"salience": 0.0037422774,
				"type": "EVENT"
			},
			{
				"name": "deputy governor",
				"salience": 0.0036328149,
				"type": "PERSON"
			},
			{
				"name": "conservatism",
				"salience": 0.0035574029,
				"type": "OTHER"
			},
			{
				"name": "Protesters",
				"salience": 0.0034973607,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0033563878,
				"type": "PERSON"
			},
			{
				"name": "WSJ Police",
				"salience": 0.0031264557,
				"type": "ORGANIZATION"
			},
			{
				"name": "protests",
				"salience": 0.0029663139,
				"type": "EVENT"
			},
			{
				"name": "class",
				"salience": 0.0029177407,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0029177407,
				"type": "PERSON"
			},
			{
				"name": "calls",
				"salience": 0.0029177407,
				"type": "OTHER"
			},
			{
				"name": "boss",
				"salience": 0.0029047192,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0028988582,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.002740539,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.002740539,
				"type": "ORGANIZATION"
			},
			{
				"name": "aim",
				"salience": 0.0026247057,
				"type": "OTHER"
			},
			{
				"name": "ascent",
				"salience": 0.0026247057,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0026247057,
				"type": "OTHER"
			},
			{
				"name": "minority",
				"salience": 0.0026247057,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07g59k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sidney_Jones"
				},
				"name": "Sidney Jones",
				"salience": 0.0025322398,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.002526797,
				"type": "OTHER"
			},
			{
				"name": "tension",
				"salience": 0.002526797,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.002526797,
				"type": "OTHER"
			},
			{
				"name": "Religiosity",
				"salience": 0.002526797,
				"type": "OTHER"
			},
			{
				"name": "calm",
				"salience": 0.002526797,
				"type": "OTHER"
			},
			{
				"name": "identification",
				"salience": 0.002526797,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.002526797,
				"type": "OTHER"
			},
			{
				"name": "protest leaders",
				"salience": 0.002474606,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0023635228,
				"type": "PERSON"
			},
			{
				"name": "Gang",
				"salience": 0.002254423,
				"type": "PERSON"
			},
			{
				"name": "target",
				"salience": 0.0021429793,
				"type": "OTHER"
			},
			{
				"name": "police investigation",
				"salience": 0.0021429793,
				"type": "EVENT"
			},
			{
				"name": "kafir",
				"salience": 0.0021429793,
				"type": "OTHER"
			},
			{
				"name": "nonbeliever",
				"salience": 0.0021429793,
				"type": "OTHER"
			},
			{
				"name": "re-election",
				"salience": 0.0021429793,
				"type": "EVENT"
			},
			{
				"name": "verse",
				"salience": 0.0021429793,
				"type": "WORK_OF_ART"
			},
			{
				"name": "address",
				"salience": 0.0021429793,
				"type": "LOCATION"
			},
			{
				"name": "Basuki Tjahaha Purnama",
				"salience": 0.0020666106,
				"type": "PERSON"
			},
			{
				"name": "Ahok",
				"salience": 0.0016158897,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0152wh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chinese_Indonesians"
				},
				"name": "Chinese",
				"salience": 0.0016158897,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0016010258,
				"type": "OTHER"
			},
			{
				"name": "undertaking",
				"salience": 0.0016010258,
				"type": "OTHER"
			},
			{
				"name": "umrah",
				"salience": 0.0016010258,
				"type": "OTHER"
			},
			{
				"name": "pilgrimage",
				"salience": 0.0016010258,
				"type": "EVENT"
			},
			{
				"name": "cells",
				"salience": 0.0016010258,
				"type": "OTHER"
			},
			{
				"name": "crossover",
				"salience": 0.0016010258,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Muslim",
				"salience": 0.0015555861,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zlrv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Indonesia"
				},
				"name": "University of Indonesia",
				"salience": 0.0015555861,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03ryn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indonesia"
				},
				"name": "Indonesians",
				"salience": 0.0014556216,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0013590776,
				"type": "ORGANIZATION"
			},
			{
				"name": "call",
				"salience": 0.001346653,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/096tx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quran"
				},
				"name": "Quran",
				"salience": 0.0013192061,
				"type": "WORK_OF_ART"
			},
			{
				"name": "non-violence",
				"salience": 0.0011661056,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0011661056,
				"type": "PERSON"
			},
			{
				"name": "death members",
				"salience": 0.0011661056,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0011661056,
				"type": "OTHER"
			},
			{
				"name": "Travel",
				"salience": 0.001122579,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0010670591,
				"type": "ORGANIZATION"
			},
			{
				"name": "Security experts",
				"salience": 0.0010122354,
				"type": "PERSON"
			},
			{
				"name": "convenience stores",
				"salience": 0.0010059963,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0010059963,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/058wp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mecca"
				},
				"name": "Mecca",
				"salience": 0.0009854893,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.0009854893,
				"type": "ORGANIZATION"
			},
			{
				"name": "movement",
				"salience": 0.0009764217,
				"type": "OTHER"
			},
			{
				"name": "alcohol",
				"salience": 0.0008711031,
				"type": "OTHER"
			},
			{
				"name": "blasphemy case",
				"salience": 0.0008711031,
				"type": "OTHER"
			},
			{
				"name": "head scarves",
				"salience": 0.0008711031,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0008711031,
				"type": "PERSON"
			},
			{
				"name": "steam",
				"salience": 0.0008711031,
				"type": "OTHER"
			},
			{
				"name": "sales",
				"salience": 0.0008711031,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/044rv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jakarta"
				},
				"name": "Jakarta",
				"salience": 0.00071772584,
				"type": "LOCATION"
			},
			{
				"name": "Institute for Policy Analysis of Conflict",
				"salience": 0.00071772584,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01wdbc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ahmadiyya"
				},
				"name": "Ahmadiyah",
				"salience": 0.00071772584,
				"type": "PERSON"
			},
			{
				"name": "critics",
				"salience": 0.0006425076,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/yjyiblVVGYM/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T00:16:00.978+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 4 2016 “MODERATE” INDONESIA: Protest against a Christian governor turns violent as more than 100,000 Muslims demand death for Christian governor who “blasphemed” Islam JARKARTA: The biggest street protest in years shook this sprawling capital today in a stark display of the more conservative, militant strain of Islam taking hold in the world’s largest Muslim country. ( Which Hillary Clinton has called a “shining example of a ‘moderate’ Islamic country” ) WSJ Police said an estimated 100,000 people turned out for a rally called by hard-line Muslim groups against the capital’s Christian governor, whom they accuse of having committed blasphemy. Blasphemy is a criminal offense in Indonesia and prosecutions have increased in the past decade. President Joko Widodo had met with other political leaders amid calls for calm, but critics say he has been too slow since taking office in 2014 to respond to worsening tension for fear of being labeled anti-Muslim. “Religiosity is rising, especially among the middle class,” said Yon Machmudi, an Islamic politics expert at the University of Indonesia. “A sense of identification is increasing.’’ Protesters were taking aim at Basuki Tjahaha Purnama, known as Ahok, who is the most prominent politician among the country’s often-persecuted, ethnic Chinese minority. He was elected deputy governor in 2012 and elevated to the top job in 2014 after his boss, Mr. Widodo, was elected president. Some hard-liners had tried to block his ascent then, saying Muslims shouldn’t be ruled by a “kafir,” or nonbeliever. Mr. Purnama, now running for re-election, angered the groups again by citing a verse of the Quran in a public address in late September. He has apologized and said he would cooperate with a police investigation, but has since been the target of protests. Vice President Jusuf Kalla met a group of protest leaders and said afterward that police would pursue a blasphemy case against Mr. Purnama. Nearly 90% of Indonesia’s 250 million people are Muslim and are becoming more radical every year as seen by head scarves for women, once rare, are now widely worn and Islamic schools are expanding. A movement to ban alcohol is gaining steam and sales have been banned from convenience stores. Travel to Mecca for the minor pilgrimage of umrah, once a relatively uncommon undertaking for middle-class Indonesians, is newly popular. Security experts say the rising conservatism paves the way for potential violence , pointing to some religious hard-liners who have rebranded themselves as cells of Islamic State. “What we’ve seen in the last 18 months to two years is increasing crossover from organizations that started out ‘nonviolent but hard-line’ to organizations which are now committed to using violence,” said Sidney Jones, director of the Jakarta-based Institute for Policy Analysis of Conflict. Gang of Indonesian Muslim men (below) beat to death members of Ahmadiyah sect, which Muslims reject as part of Islam because of it’s call for non-violence.",
		"thread_title": "“MODERATE” INDONESIA: Protest against a Christian governor turns violent as more than 100,000 Muslims demand death for Christian governor who “blasphemed” Islam",
		"title": "“MODERATE” INDONESIA: Protest against a Christian governor turns violent as more than 100,000 Muslims demand death for Christian governor who “blasphemed” Islam",
		"type": "bs",
		"uuid": "4ee3a935b4c72066e7f90199d1e4d4a1d1877aa9"
	},
	"-KhIjrhBgfivF0f2OeNp": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T01:00:31.434+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "immigrants",
				"salience": 0.21271047,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06qgwy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vincent_Nichols"
				},
				"name": "Vincent Nichols",
				"salience": 0.09721649,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslims",
				"salience": 0.06042438,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.046618436,
				"type": "PERSON"
			},
			{
				"name": "faith",
				"salience": 0.046618436,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.046618436,
				"type": "OTHER"
			},
			{
				"name": "H e",
				"salience": 0.041769017,
				"type": "PERSON"
			},
			{
				"name": "vibrancy",
				"salience": 0.03900269,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.033841543,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.033841543,
				"type": "PERSON"
			},
			{
				"name": "immigration crisis",
				"salience": 0.026970457,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "Britons",
				"salience": 0.017998774,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.016700294,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.016612353,
				"type": "PERSON"
			},
			{
				"name": "leader",
				"salience": 0.012216337,
				"type": "PERSON"
			},
			{
				"name": "media stories",
				"salience": 0.011686391,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0099377055,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.009268938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.008655702,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j5g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wales"
				},
				"name": "Wales",
				"salience": 0.008655702,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Roman Catholic Church",
				"salience": 0.008655702,
				"type": "ORGANIZATION"
			},
			{
				"name": "Cardinal",
				"salience": 0.008294009,
				"type": "PERSON"
			},
			{
				"name": "atmosphere",
				"salience": 0.008294009,
				"type": "OTHER"
			},
			{
				"name": "atmosphere",
				"salience": 0.0076382905,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0076382905,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.0069747157,
				"type": "OTHER"
			},
			{
				"name": "immigration",
				"salience": 0.0069747157,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0063422625,
				"type": "PERSON"
			},
			{
				"name": "hatred",
				"salience": 0.0062044803,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0059425486,
				"type": "PERSON"
			},
			{
				"name": "faith",
				"salience": 0.005696282,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0056030913,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0050408253,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.0050408253,
				"type": "EVENT"
			},
			{
				"name": "nature",
				"salience": 0.0050408253,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0050408253,
				"type": "OTHER"
			},
			{
				"name": "priest",
				"salience": 0.0048529385,
				"type": "PERSON"
			},
			{
				"name": "public",
				"salience": 0.0048529385,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.0048529385,
				"type": "PERSON"
			},
			{
				"name": "referendum",
				"salience": 0.0048529385,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.004752779,
				"type": "OTHER"
			},
			{
				"name": "vibrancy",
				"salience": 0.004752779,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h1gl3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Telegraph_Media_Group"
				},
				"name": "UK Telegraph",
				"salience": 0.004426053,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.004426053,
				"type": "ORGANIZATION"
			},
			{
				"name": "fear",
				"salience": 0.0042571146,
				"type": "OTHER"
			},
			{
				"name": "religions",
				"salience": 0.00411628,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.00411628,
				"type": "PERSON"
			},
			{
				"name": "arrivals",
				"salience": 0.00411628,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.00411628,
				"type": "OTHER"
			},
			{
				"name": "features",
				"salience": 0.0040133134,
				"type": "OTHER"
			},
			{
				"name": "hatred",
				"salience": 0.0039332,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.003603066,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.0035358,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.00310435,
				"type": "ORGANIZATION"
			},
			{
				"name": "fear",
				"salience": 0.003101488,
				"type": "OTHER"
			},
			{
				"name": "legislation",
				"salience": 0.0030758088,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nobody",
				"salience": 0.0030758088,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0029885552,
				"type": "LOCATION"
			},
			{
				"name": "hatred",
				"salience": 0.0028654018,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0025113076,
				"type": "OTHER"
			},
			{
				"name": "distaste",
				"salience": 0.002240569,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.0016739033,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/hindus-killed-by-muslims-hindu-islam.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T01:00:31.434+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Cardinal Vincent Nichols says: “Britons could learn a lot from the ‘vibrant’ faith of Muslim migrants” British people have much to learn from the “vibrancy of the Muslim faith” of new immigrants including refugees, the leader of the Roman Catholic Church in England and Wales has said. UK Telegraph Cardinal Vincent Nichols said immigrants had been enduring a worsening “atmosphere of fear” in the months since the EU referendum with the members of the public casually voicing hatred in a “self-indulgent” way. (Self-indulgent? I wonder what this French priest would have to say about that?) H e accused politicians of “trading in fear” and said media stories constantly portraying immigration in a negative light were proving “corrosive of our best nature”. In an interview with the BBC , he insisted that increasingly secular British society could learn much from the faith of new arrivals whether Muslims or followers of other religions. “Of course what we have to learn too is from the vibrancy of the Muslim faith that comes here. H e added: “I think the immigration crisis is real and it needs concerted effort to address it,” he said. “It needs to be addressed realistically with resources and proper legislation, but it’s almost impossible to do that in an atmosphere in which fear and hatred are the dominant features. “It does nobody any good, this somewhat self-indulgent way in which people have begun to express themselves and their distaste and their hatred of people who they see as different. “And that is creating a culture of fear among people who have been welcomed here.”",
		"thread_title": "Cardinal Vincent Nichols says: “Britons could learn a lot from the ‘vibrant’ faith of Muslim migrants”",
		"title": "Cardinal Vincent Nichols says: “Britons could learn a lot from the ‘vibrant’ faith of Muslim migrants”",
		"type": "bs",
		"uuid": "938c997065b9eaeef2f261ccb87ce9a2e51bdf12"
	},
	"-KhIjrt7YgsKOJx8SU9o": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T01:00:32.119+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "people",
				"salience": 0.09176934,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.06682637,
				"type": "OTHER"
			},
			{
				"name": "@ 6",
				"salience": 0.06624923,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.05522869,
				"type": "LOCATION"
			},
			{
				"name": "Values",
				"salience": 0.05333178,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.049497776,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europeans",
				"salience": 0.043935023,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.036465965,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.035669245,
				"type": "OTHER"
			},
			{
				"name": "Lincoln Applegate Hahn",
				"salience": 0.031734165,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.026354475,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.025830962,
				"type": "PERSON"
			},
			{
				"name": "Followers",
				"salience": 0.021221085,
				"type": "PERSON"
			},
			{
				"name": "animals",
				"salience": 0.017926222,
				"type": "OTHER"
			},
			{
				"name": "comme ci comme ca",
				"salience": 0.016251352,
				"type": "OTHER"
			},
			{
				"name": "Etti",
				"salience": 0.016251352,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.013906344,
				"type": "LOCATION"
			},
			{
				"name": "effort",
				"salience": 0.011588658,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.010877957,
				"type": "OTHER"
			},
			{
				"name": "sharia law",
				"salience": 0.010877957,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.010877957,
				"type": "PERSON"
			},
			{
				"name": "followers",
				"salience": 0.009874228,
				"type": "PERSON"
			},
			{
				"name": "human rights",
				"salience": 0.0088106785,
				"type": "OTHER"
			},
			{
				"name": "paedophile",
				"salience": 0.008482211,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.008482211,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/064_8sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/French_language"
				},
				"name": "French",
				"salience": 0.007735941,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.0076306425,
				"type": "OTHER"
			},
			{
				"name": "dignity",
				"salience": 0.0076306425,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0076306425,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.0076306425,
				"type": "OTHER"
			},
			{
				"name": "paedophile savage",
				"salience": 0.0076306425,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.0073461016,
				"type": "PERSON"
			},
			{
				"name": "golden rule",
				"salience": 0.0073461016,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0073461016,
				"type": "LOCATION"
			},
			{
				"name": "view",
				"salience": 0.0073461016,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0071944213,
				"type": "PERSON"
			},
			{
				"name": "French Parliament",
				"salience": 0.0066996496,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05d3xft"
				},
				"name": "Lisa",
				"salience": 0.0066996496,
				"type": "PERSON"
			},
			{
				"name": "responsibility",
				"salience": 0.0066380613,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.006230578,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.006230578,
				"type": "OTHER"
			},
			{
				"name": "displays",
				"salience": 0.006230578,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.006230578,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.006230578,
				"type": "OTHER"
			},
			{
				"name": "guilty",
				"salience": 0.006230578,
				"type": "OTHER"
			},
			{
				"name": "victims",
				"salience": 0.006230578,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0hqjh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Africa"
				},
				"name": "West",
				"salience": 0.0052380497,
				"type": "LOCATION"
			},
			{
				"name": "hell hole",
				"salience": 0.0046552415,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0046552415,
				"type": "LOCATION"
			},
			{
				"name": "birth",
				"salience": 0.0046552415,
				"type": "EVENT"
			},
			{
				"name": "hatred",
				"salience": 0.0046552415,
				"type": "OTHER"
			},
			{
				"name": "opression",
				"salience": 0.0046552415,
				"type": "OTHER"
			},
			{
				"name": "intolerance",
				"salience": 0.0046552415,
				"type": "OTHER"
			},
			{
				"name": "diet",
				"salience": 0.0046552415,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.0046552415,
				"type": "EVENT"
			},
			{
				"name": "freedoms",
				"salience": 0.0046552415,
				"type": "OTHER"
			},
			{
				"name": "recipe",
				"salience": 0.0046552415,
				"type": "WORK_OF_ART"
			},
			{
				"name": "human rights",
				"salience": 0.004617223,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.004336708,
				"type": "LOCATION"
			},
			{
				"name": "monsters",
				"salience": 0.0038006755,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.003390851,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.003390851,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.003390851,
				"type": "WORK_OF_ART"
			},
			{
				"name": "perspective",
				"salience": 0.003390851,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.003390851,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0032398987,
				"type": "LOCATION"
			},
			{
				"name": "honour",
				"salience": 0.0029253452,
				"type": "OTHER"
			},
			{
				"name": "honour",
				"salience": 0.0029253452,
				"type": "OTHER"
			},
			{
				"name": "sense",
				"salience": 0.0027682583,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "islam",
				"salience": 0.0026896787,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0025331369,
				"type": "PERSON"
			},
			{
				"name": "doIngs",
				"salience": 0.0025331369,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "europe",
				"salience": 0.0024103592,
				"type": "LOCATION"
			},
			{
				"name": "Nicolai sennels",
				"salience": 0.0020348956,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/xzlMFU9Ovmg/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T01:00:32.119+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.7,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Lincoln Applegate Hahn November 4, 2016 @ 6:30 pm \nWe’ve seen your “French Values”…. and they are the problem …. comme ci comme ca (like this and that) ? Etti November 4, 2016 @ 6:09 pm \nWhat a foolish man! He believes that accepting migrants and teaching them to learn French will see them in the French Parliament. Of course you will and they will be forcing sharia law on to the French population not making the country more civilised. Lisa November 4, 2016 @ 6:03 pm \nBecause rightly or wrongly, people project their view of the world onto others.We live according to the golden rule and don’t do to others that which we do not want them to.do to us. Many cannot fathom or conceive just how vile the followers of the murderous paedophile can be. It’s incomprehensible. Even animals that have been traumatised and abused don’t behave like that when rescued. Europeans have mostly been peaceful for the last 70 years because they made a concerted effort to live in peace and to uphold dignity of life and human rights. That came at a price. Followers of the paedophile savage are socialised differently. They are pathetic and emotionally infantile. In the West we are taught to take personal responsibility for our actions. They are taught to blame everyone but themselves often turning victims into the guilty in the case of raped women. In the West violent displays of anger are frowned upon and we are taught to apologise for our wrong doIngs. Muslims have a warped and messed up sense of honour. An honour they will gladly kill their families to restore. In short they accept everything that is a crime in our countries as somehow permissible. Incompatible. In the West they are given human rights they don’t deserve and freedoms they can’t handle. Proven recipe for disaster. You have to be very very naive to believe that people who are fed a steady diet of intolerance, opression and hatred since birth will miraculously change just because they cross a border from hell hole to civilsed country. It should be obvious by now that Muslims born in europe cannot be integrated so what hope do we have integrating the rest. Nicolai sennels wrote a great paper on why islam is prone to creating monsters. Puts it all into perspective and is a must read in my opinion.",
		"thread_title": "Prime Minister of France says, “if we grant immediate asylum to illegal alien Muslim invaders, by tomorrow they will be speaking French and sharing French values”",
		"title": "Prime Minister of France says, “if we grant immediate asylum to illegal alien Muslim invaders, by tomorrow they will be speaking French and sharing French values”",
		"type": "bs",
		"uuid": "72e5faea05b3f4c0ad014a79d1d078b7525e3ea2"
	},
	"-KhIjs0Rtehf3RCOaMg0": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T09:12:36.767+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0c40c2k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_LePage"
				},
				"name": "Paul LePage",
				"salience": 0.48757613,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/050ks",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maine"
				},
				"name": "MAINE",
				"salience": 0.059682418,
				"type": "LOCATION"
			},
			{
				"name": "confidence",
				"salience": 0.036895156,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.033125754,
				"type": "LOCATION"
			},
			{
				"name": "government",
				"salience": 0.02856509,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugee resettlement program",
				"salience": 0.026906483,
				"type": "OTHER"
			},
			{
				"name": "refugee settlement program",
				"salience": 0.026906483,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.025496593,
				"type": "LOCATION"
			},
			{
				"name": "GOVERNOR",
				"salience": 0.02392259,
				"type": "PERSON"
			},
			{
				"name": "ability",
				"salience": 0.017351475,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.017351475,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.015167248,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.014860777,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.011650506,
				"type": "OTHER"
			},
			{
				"name": "Adnan Fazeli",
				"salience": 0.011010959,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.009702696,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.009702696,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0zg9jc6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Office_of_Refugee_Resettlement"
				},
				"name": "Office of Refugee Resettlement",
				"salience": 0.009666764,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.0076629124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0488g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kansas"
				},
				"name": "Kansas",
				"salience": 0.00542823,
				"type": "LOCATION"
			},
			{
				"name": "families",
				"salience": 0.0042454456,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05cc9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalis"
				},
				"name": "Somali",
				"salience": 0.004162093,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ffnk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Refugee_Act"
				},
				"name": "Refugee Act",
				"salience": 0.004080266,
				"type": "WORK_OF_ART"
			},
			{
				"name": "program",
				"salience": 0.0038720567,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.003808095,
				"type": "LOCATION"
			},
			{
				"name": "test",
				"salience": 0.0036773204,
				"type": "OTHER"
			},
			{
				"name": "dumping grounds",
				"salience": 0.0036773204,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0036773204,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0036773204,
				"type": "PERSON"
			},
			{
				"name": "refugee settlement",
				"salience": 0.0036014589,
				"type": "OTHER"
			},
			{
				"name": "ORR",
				"salience": 0.0035698316,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0034806246,
				"type": "PERSON"
			},
			{
				"name": "taxpayers",
				"salience": 0.0033016882,
				"type": "PERSON"
			},
			{
				"name": "partner",
				"salience": 0.0031993303,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.0029785705,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Muslims WCSH6",
				"salience": 0.0029551254,
				"type": "ORGANIZATION"
			},
			{
				"name": "letter",
				"salience": 0.0028675427,
				"type": "WORK_OF_ART"
			},
			{
				"name": "case",
				"salience": 0.002579692,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.002579692,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.002579692,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.002579692,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.0024835085,
				"type": "PERSON"
			},
			{
				"name": "kafir",
				"salience": 0.0024835085,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "program",
				"salience": 0.0024546538,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0023240512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama Regime",
				"salience": 0.0022649849,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugees",
				"salience": 0.0021651124,
				"type": "PERSON"
			},
			{
				"name": "quantity",
				"salience": 0.0021064193,
				"type": "OTHER"
			},
			{
				"name": "refugee policy",
				"salience": 0.0021064193,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0021064193,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.0019152287,
				"type": "ORGANIZATION"
			},
			{
				"name": "office",
				"salience": 0.0018174141,
				"type": "ORGANIZATION"
			},
			{
				"name": "welfare",
				"salience": 0.0018174141,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0017882715,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.0015738729,
				"type": "EVENT"
			},
			{
				"name": "counterparts",
				"salience": 0.0015738729,
				"type": "PERSON"
			},
			{
				"name": "h",
				"salience": 0.001529217,
				"type": "PERSON"
			},
			{
				"name": "integration assistance process",
				"salience": 0.001323878,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01m61m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freeport,_Maine"
				},
				"name": "Freeport",
				"salience": 0.0012969018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0012969018,
				"type": "ORGANIZATION"
			},
			{
				"name": "passing",
				"salience": 0.0011464232,
				"type": "EVENT"
			},
			{
				"name": "state workers",
				"salience": 0.0011464232,
				"type": "PERSON"
			},
			{
				"name": "burden",
				"salience": 0.0010624529,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0009890462,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.0009890462,
				"type": "OTHER"
			},
			{
				"name": "vetting process",
				"salience": 0.0009890462,
				"type": "OTHER"
			},
			{
				"name": "Health and Human Services Department",
				"salience": 0.0009688886,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fyyq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Health_and_Human_Services"
				},
				"name": "DHHS",
				"salience": 0.0009688886,
				"type": "ORGANIZATION"
			},
			{
				"name": "basis",
				"salience": 0.0009359382,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0008564477,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.0008564477,
				"type": "OTHER"
			},
			{
				"name": "origin",
				"salience": 0.0008564477,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0008564477,
				"type": "LOCATION"
			},
			{
				"name": "safety",
				"salience": 0.0006645971,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.0005027913,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/duuOI3MlY8M/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T09:12:36.767+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "MAINE GOVERNOR joins Kansas, Texas, and New Jersey in withdrawing from the federal (Muslim) refugee resettlement program Gov. Paul LePage is withdrawing the state of Maine from the federal refugee settlement program, citing a loss of confidence in its ability to safely and responsibly run the program. Maine has become one of the Obama Regime’s favorite dumping grounds for unskilled, illiterate, welfare-dependant large Somali Muslim families. Obama doesn’t need a religious test for refugees because most of them are Muslims WCSH6 (h/t kafir) In a letter Friday, Gov. LePage informed President Obama and notified the director of the Office of Refugee Resettlement (ORR) that Maine would no longer be participating in the program. “The federal government has proven to be an unwilling partner with states in ensuring that refugee settlement does not unduly put American lives at risk,” LePage wrote. Maine joins Kansas, New Jersey and Texas in severing ties with the ORR. In the letter, LePage included the case of refugee Adnan Fazeli of Freeport, who was revealed in August through an FBI investigation to have died last year while fighting for the Islamic State. “I sincerely hope that the federal government will re-evaluate its current refugee policy — both the quantity and nation of origin of refugees it resettles and the vetting process they are subjected in — in order to best protect the safety and interests of the American people,” LePage wrote. The typical size of Somali Muslim refugee families places an unfair burden on hardworking American taxpayers who must fund welfare for them According to LePage’s office, the governor has directed the state Health and Human Services Department (DHHS) to work with federal counterparts to implement a transition out of the ORR program. The ORR was created after the passing of the 1980 Refugee Act, which provided the legal basis. By withdrawing from the federal program, LePage has removed state workers from the integration assistance process but has not stopped refugees from entering or living in Maine.",
		"thread_title": "MAINE GOVERNOR joins Kansas, Texas, and New Jersey in withdrawing from the federal (Muslim) refugee resettlement program",
		"title": "MAINE GOVERNOR joins Kansas, Texas, and New Jersey in withdrawing from the federal (Muslim) refugee resettlement program",
		"type": "bs",
		"uuid": "1ffa075ec68a3612aefd82af727c5554cd3c779f"
	},
	"-KhIjs78FovfehF2ptIX": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T09:26:57.455+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.28377226,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.18805154,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06426741,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.05716114,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.035996392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "DONATE",
				"salience": 0.03588462,
				"type": "OTHER"
			},
			{
				"name": "barenakedislam@gmail.com Top Posts",
				"salience": 0.03236068,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.029204627,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.028123902,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.027799565,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.02469274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "LINKS",
				"salience": 0.023880832,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.017367292,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.01518282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.01473926,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.011250982,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/aDMZRiYrcuE/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T09:26:57.455+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address CONTACT: barenakedislam@gmail.com Top Posts",
		"thread_title": "Welcome to the ‘Islamic State of Germany’",
		"title": "Welcome to the ‘Islamic State of Germany’",
		"type": "bs",
		"uuid": "7e8322b7e465abe6e1e99c8d2d413d02a96d4181"
	},
	"-KhIjsMHsisAzZxcFY65": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-05T13:37:30.722+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "campaign ad",
				"salience": 0.34203136,
				"type": "EVENT"
			},
			{
				"name": "David Kittos",
				"salience": 0.13097127,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dzqp5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump,_Jr."
				},
				"name": "Donald Trump Jr.",
				"salience": 0.06866318,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03m8jh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Skittles_(confectionery)"
				},
				"name": "Skittles",
				"salience": 0.04208413,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.041476496,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "TRUMP",
				"salience": 0.036536496,
				"type": "PERSON"
			},
			{
				"name": "photo",
				"salience": 0.034591887,
				"type": "WORK_OF_ART"
			},
			{
				"name": "man",
				"salience": 0.017039593,
				"type": "PERSON"
			},
			{
				"name": "photo",
				"salience": 0.015730524,
				"type": "WORK_OF_ART"
			},
			{
				"name": "skittles",
				"salience": 0.015092704,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0127926115,
				"type": "PERSON"
			},
			{
				"name": "candy",
				"salience": 0.011825744,
				"type": "OTHER"
			},
			{
				"name": "candy",
				"salience": 0.011825744,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.011790335,
				"type": "PERSON"
			},
			{
				"name": "lawsuit",
				"salience": 0.010251606,
				"type": "OTHER"
			},
			{
				"name": "jihadists",
				"salience": 0.009261341,
				"type": "PERSON"
			},
			{
				"name": "bowl",
				"salience": 0.009261341,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "infiltrators",
				"salience": 0.009261341,
				"type": "PERSON"
			},
			{
				"name": "firestorm",
				"salience": 0.009261341,
				"type": "EVENT"
			},
			{
				"name": "photo",
				"salience": 0.0084911855,
				"type": "WORK_OF_ART"
			},
			{
				"name": "micro-agression",
				"salience": 0.0075200805,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tweet",
				"salience": 0.006995684,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.006367209,
				"type": "LOCATION"
			},
			{
				"name": "reaction",
				"salience": 0.0055653886,
				"type": "OTHER"
			},
			{
				"name": "photo",
				"salience": 0.0050907778,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0048293993,
				"type": "OTHER"
			},
			{
				"name": "copyright infringement",
				"salience": 0.0047426936,
				"type": "OTHER"
			},
			{
				"name": "Refugees",
				"salience": 0.004331137,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0037245348,
				"type": "PERSON"
			},
			{
				"name": "copyright violation",
				"salience": 0.0034344108,
				"type": "OTHER"
			},
			{
				"name": "picture",
				"salience": 0.0032794795,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0136kr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberal_Party_of_Canada"
				},
				"name": "Liberals",
				"salience": 0.0029221964,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugee",
				"salience": 0.0027059189,
				"type": "PERSON"
			},
			{
				"name": "Skittle",
				"salience": 0.002599493,
				"type": "OTHER"
			},
			{
				"name": "ad",
				"salience": 0.0025000663,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lawsuit",
				"salience": 0.0024068565,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0023051691,
				"type": "PERSON"
			},
			{
				"name": "picture",
				"salience": 0.0021460361,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.0020247584,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lighting",
				"salience": 0.0019800817,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0019551534,
				"type": "OTHER"
			},
			{
				"name": "safe room",
				"salience": 0.0019551534,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.0019551534,
				"type": "LOCATION"
			},
			{
				"name": "shelter",
				"salience": 0.0019551534,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.0019492456,
				"type": "WORK_OF_ART"
			},
			{
				"name": "permission",
				"salience": 0.0019391924,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0018271565,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0017534846,
				"type": "PERSON"
			},
			{
				"name": "permission",
				"salience": 0.0017084109,
				"type": "OTHER"
			},
			{
				"name": "photo",
				"salience": 0.0016397119,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0hm0k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canadian_Broadcasting_Corporation"
				},
				"name": "CBC",
				"salience": 0.0015394826,
				"type": "ORGANIZATION"
			},
			{
				"name": "experiment",
				"salience": 0.0015242615,
				"type": "OTHER"
			},
			{
				"name": "Denise Young",
				"salience": 0.0015207261,
				"type": "PERSON"
			},
			{
				"name": "ad",
				"salience": 0.0014316665,
				"type": "WORK_OF_ART"
			},
			{
				"name": "photo",
				"salience": 0.0014263426,
				"type": "WORK_OF_ART"
			},
			{
				"name": "candy",
				"salience": 0.0013958316,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0013711406,
				"type": "OTHER"
			},
			{
				"name": "Skittles",
				"salience": 0.0013679508,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01kh5q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mars,_Incorporated"
				},
				"name": "Mars, Inc.",
				"salience": 0.0013462452,
				"type": "ORGANIZATION"
			},
			{
				"name": "plight",
				"salience": 0.0013199818,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0013199818,
				"type": "EVENT"
			},
			{
				"name": "privilege",
				"salience": 0.0013199818,
				"type": "OTHER"
			},
			{
				"name": "shock",
				"salience": 0.0013199818,
				"type": "OTHER"
			},
			{
				"name": "tweet",
				"salience": 0.0012351745,
				"type": "WORK_OF_ART"
			},
			{
				"name": "matter",
				"salience": 0.0012079055,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0012037621,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cxgc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Surrey"
				},
				"name": "Surrey",
				"salience": 0.0012037621,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01ppq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cyprus"
				},
				"name": "Cypriot",
				"salience": 0.0012037621,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0011407499,
				"type": "PERSON"
			},
			{
				"name": "authors",
				"salience": 0.0011194396,
				"type": "PERSON"
			},
			{
				"name": "law",
				"salience": 0.0011194396,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0011194396,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0011194396,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0011194396,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawyer",
				"salience": 0.001105338,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.001069609,
				"type": "PERSON"
			},
			{
				"name": "tweet",
				"salience": 0.0010212814,
				"type": "WORK_OF_ART"
			},
			{
				"name": "point",
				"salience": 0.0009737253,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vk77f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBC_News"
				},
				"name": "CBC News",
				"salience": 0.0009710845,
				"type": "ORGANIZATION"
			},
			{
				"name": "message",
				"salience": 0.000961458,
				"type": "OTHER"
			},
			{
				"name": "stupidity",
				"salience": 0.0008469671,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.0008440611,
				"type": "OTHER"
			},
			{
				"name": "owner",
				"salience": 0.0008362958,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0008362958,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.0008362958,
				"type": "PERSON"
			},
			{
				"name": "boy",
				"salience": 0.0008362958,
				"type": "PERSON"
			},
			{
				"name": "outrage",
				"salience": 0.0008362958,
				"type": "OTHER"
			},
			{
				"name": "social media",
				"salience": 0.0008362958,
				"type": "OTHER"
			},
			{
				"name": "kid",
				"salience": 0.0008362958,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04dtx9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flickr"
				},
				"name": "Flickr",
				"salience": 0.00081255706,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.00077905273,
				"type": "OTHER"
			},
			{
				"name": "election campaign",
				"salience": 0.0007634851,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03v0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illinois"
				},
				"name": "Illinois",
				"salience": 0.0006890699,
				"type": "LOCATION"
			},
			{
				"name": "damages",
				"salience": 0.00065724464,
				"type": "OTHER"
			},
			{
				"name": "apology",
				"salience": 0.00060909154,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00060909154,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00060909154,
				"type": "OTHER"
			},
			{
				"name": "corporate affairs",
				"salience": 0.00060909154,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.000586354,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.00056446495,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.000514742,
				"type": "PERSON"
			},
			{
				"name": "campaign stop",
				"salience": 0.00045499095,
				"type": "LOCATION"
			},
			{
				"name": "risk",
				"salience": 0.00045499095,
				"type": "OTHER"
			},
			{
				"name": "vetting",
				"salience": 0.00045499095,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00045499095,
				"type": "PERSON"
			},
			{
				"name": "citizens",
				"salience": 0.00045499095,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00036876186,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/099ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boise,_Idaho"
				},
				"name": "Boise",
				"salience": 0.0002800194,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Idaho"
				},
				"name": "Idaho",
				"salience": 0.0002800194,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/shutterstock_222204877.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-05T13:37:30.722+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.1,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "TRUMP CAMPAIGN being sued for humiliating Skittles candy by comparing it to Syrian Muslim infiltrators It was a campaign ad that ignited a firestorm: Donald Trump Jr. tweeted a photo of a bowl of skittles and compared the colorful candy to Syrian jihadists posing as refugees. Now, the man who took the photo is suing Donald Trump, Donald Trump Jr., and vice-presidential nominee Mike Pence for copyright infringement. Liberals accused the tweet of being insenstive, racist, and a micro-agression which forced them to seek shelter in the nearest safe room. CBC David Kittos, an expert photographer and former Cypriot refugee, says he never gave permission and never would give permission for his photo to be used in the ad. “The image, the way it was used is reprehensible,” said Kittos from his home in Surrey, England, in an interview with CBC News. “It’s ignoring the plight of the refugees and it’s completely unacceptable that someone who was born into privilege would steal my picture and use it to make this political point.” Kittos says when he first saw the tweet, he was “in shock.” He explains he took the photo in 2010 as an experiment using artificial lighting and posted it on Flickr . “I just couldn’t believe my humble picture of some Skittles would just be used by someone so powerful.” Kittos says his lawyer reached out to the Trump campaign to discuss the matter but got no response. So he reported a copyright violation to Twitter, and about a week after it was posted his Skittles photo was removed from Trump Jr.’s tweet. Even though his photo is no longer connected to the ad, Kittos decided to file a lawsuit at a federal court in Illinois. He says he wants to ensure the Trump campaign never uses the work again. As well, he wants to spread the message that “they can’t go around stealing from authors like myself. They’re not above the law.” The Trump campaign told CBC News it’s not commenting on the case at this time. Back in September, Trump Jr. defended the tweet. “I am surprised by the reaction simply because it is a metaphor for risk,” he said at a campaign stop in Boise, Idaho. Trump’s election campaign has called for “extreme vetting” of immigrants to the U.S., especially Muslims, to help weed out anyone who could be a danger to American citizens. While Trump’s position is popular with some Americans, his eldest son’s tweet ignited outrage on social media. “Sorry kid. For all we know you could be a poisonous Skittle,” someone tweeted along with a well-known photo of an injured and bloodied young Syrian boy. “The stupidity ensues,” commented another person. Even the Skittles owner, Mars, Inc., weighed in. “Skittles are candy. Refugees are people,” tweeted Denise Young, vice-president of corporate affairs. Kittos is seeking yet to be determined damages as part of the lawsuit. But he says he’s not in it for the money (sure he isn’t) and would have settled a for a public apology. Because that didn’t happen, he says he’s pursuing the lawsuit because “it’s the right thing to do.”",
		"thread_title": "TRUMP CAMPAIGN being sued for humiliating Skittles candy by comparing it to Syrian Muslim infiltrators",
		"title": "TRUMP CAMPAIGN being sued for humiliating Skittles candy by comparing it to Syrian Muslim infiltrators",
		"type": "bs",
		"uuid": "5ccd680aa76d6a4574c42ea61c3bb541634b5e75"
	},
	"-KhIjsiR5W521Z4TNm05": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T02:38:46.441+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/032k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Southern_Maine"
				},
				"name": "University of Southern Maine",
				"salience": 0.22382252,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.21883325,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04h9h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latin"
				},
				"name": "Latin",
				"salience": 0.052493136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03qnp5t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Cummings"
				},
				"name": "Glenn Cummings",
				"salience": 0.03893298,
				"type": "PERSON"
			},
			{
				"name": "graffiti",
				"salience": 0.02339045,
				"type": "OTHER"
			},
			{
				"name": "Muhammad ``Humza'' Khan",
				"salience": 0.022701457,
				"type": "PERSON"
			},
			{
				"name": "freedom of speech",
				"salience": 0.01871098,
				"type": "OTHER"
			},
			{
				"name": "hate speech",
				"salience": 0.016154485,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hate speech",
				"salience": 0.016154485,
				"type": "OTHER"
			},
			{
				"name": "nobody",
				"salience": 0.0119876275,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobic",
				"salience": 0.011822149,
				"type": "OTHER"
			},
			{
				"name": "Store",
				"salience": 0.01168879,
				"type": "LOCATION"
			},
			{
				"name": "Inshallah",
				"salience": 0.01168879,
				"type": "OTHER"
			},
			{
				"name": "Deus Vult",
				"salience": 0.01094409,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02my4d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Inshallah"
				},
				"name": "God Willing",
				"salience": 0.01094409,
				"type": "OTHER"
			},
			{
				"name": "student",
				"salience": 0.01063967,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.009771885,
				"type": "LOCATION"
			},
			{
				"name": "phrase",
				"salience": 0.0094018765,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sxm4k"
				},
				"name": "Crusader",
				"salience": 0.009210895,
				"type": "ORGANIZATION"
			},
			{
				"name": "students",
				"salience": 0.009171944,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.0072067785,
				"type": "OTHER"
			},
			{
				"name": "BNI",
				"salience": 0.0072067785,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03m3pj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Christian_sentiment"
				},
				"name": "Christophobic",
				"salience": 0.0072067785,
				"type": "ORGANIZATION"
			},
			{
				"name": "cry",
				"salience": 0.006905526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.006435911,
				"type": "PERSON"
			},
			{
				"name": "state Attorney General",
				"salience": 0.005981583,
				"type": "PERSON"
			},
			{
				"name": "phrase",
				"salience": 0.0058504776,
				"type": "OTHER"
			},
			{
				"name": "Graffiti of Crusades",
				"salience": 0.005744651,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Matt Raymond",
				"salience": 0.005707414,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.0049562356,
				"type": "EVENT"
			},
			{
				"name": "graffiti",
				"salience": 0.0044187377,
				"type": "OTHER"
			},
			{
				"name": "student",
				"salience": 0.0041114553,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.004030539,
				"type": "LOCATION"
			},
			{
				"name": "student government office",
				"salience": 0.004030539,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.003958172,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.003958172,
				"type": "PERSON"
			},
			{
				"name": "asswipes",
				"salience": 0.0037200698,
				"type": "PERSON"
			},
			{
				"name": "phrase",
				"salience": 0.0036396014,
				"type": "OTHER"
			},
			{
				"name": "hate crime",
				"salience": 0.0035302534,
				"type": "OTHER"
			},
			{
				"name": "Press",
				"salience": 0.0034116826,
				"type": "ORGANIZATION"
			},
			{
				"name": "student",
				"salience": 0.0033572135,
				"type": "PERSON"
			},
			{
				"name": "Crusades",
				"salience": 0.0031520382,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.0029023888,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.002869635,
				"type": "OTHER"
			},
			{
				"name": "cry",
				"salience": 0.0028462056,
				"type": "OTHER"
			},
			{
				"name": "desk",
				"salience": 0.0028462056,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0028462056,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0028269119,
				"type": "OTHER"
			},
			{
				"name": "graffiti",
				"salience": 0.0026961004,
				"type": "OTHER"
			},
			{
				"name": "priority",
				"salience": 0.0026260512,
				"type": "OTHER"
			},
			{
				"name": "graffiti",
				"salience": 0.0025305664,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0025084822,
				"type": "PERSON"
			},
			{
				"name": "school officials",
				"salience": 0.0024904434,
				"type": "PERSON"
			},
			{
				"name": "insult",
				"salience": 0.0024648136,
				"type": "OTHER"
			},
			{
				"name": "campus community",
				"salience": 0.0024648136,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0024648136,
				"type": "WORK_OF_ART"
			},
			{
				"name": "phrase",
				"salience": 0.0024573635,
				"type": "OTHER"
			},
			{
				"name": "student government",
				"salience": 0.0023926725,
				"type": "ORGANIZATION"
			},
			{
				"name": "student body president",
				"salience": 0.0023926725,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.0023034054,
				"type": "OTHER"
			},
			{
				"name": "witnesses",
				"salience": 0.002240957,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0022127326,
				"type": "PERSON"
			},
			{
				"name": "member",
				"salience": 0.0021280288,
				"type": "PERSON"
			},
			{
				"name": "campus security",
				"salience": 0.0020380558,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0020077028,
				"type": "PERSON"
			},
			{
				"name": "Student Government",
				"salience": 0.0019534745,
				"type": "ORGANIZATION"
			},
			{
				"name": "act",
				"salience": 0.0019214705,
				"type": "EVENT"
			},
			{
				"name": "facts",
				"salience": 0.0019214705,
				"type": "OTHER"
			},
			{
				"name": "applications",
				"salience": 0.0018650028,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0018415097,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0017284065,
				"type": "EVENT"
			},
			{
				"name": "meaning",
				"salience": 0.0017284065,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0017284065,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.0016851334,
				"type": "ORGANIZATION"
			},
			{
				"name": "idiot",
				"salience": 0.0016639045,
				"type": "OTHER"
			},
			{
				"name": "dialogue",
				"salience": 0.0016639045,
				"type": "OTHER"
			},
			{
				"name": "death cult",
				"salience": 0.0016639045,
				"type": "OTHER"
			},
			{
				"name": "non-muslims",
				"salience": 0.0016639045,
				"type": "PERSON"
			},
			{
				"name": "graffiti",
				"salience": 0.0016445551,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.0016295221,
				"type": "OTHER"
			},
			{
				"name": "desk",
				"salience": 0.0016295221,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0016295221,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.0016295221,
				"type": "OTHER"
			},
			{
				"name": "act",
				"salience": 0.0016295221,
				"type": "EVENT"
			},
			{
				"name": "students",
				"salience": 0.0016096603,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0015333494,
				"type": "ORGANIZATION"
			},
			{
				"name": "Woodbury Campus Center",
				"salience": 0.0015173764,
				"type": "LOCATION"
			},
			{
				"name": "phrase",
				"salience": 0.0014799876,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0014439385,
				"type": "LOCATION"
			},
			{
				"name": "post",
				"salience": 0.001411067,
				"type": "OTHER"
			},
			{
				"name": "straitjacket",
				"salience": 0.001411067,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "letters",
				"salience": 0.001411067,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cover",
				"salience": 0.001411067,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0013650606,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0013650606,
				"type": "PERSON"
			},
			{
				"name": "opportunities",
				"salience": 0.0013584008,
				"type": "OTHER"
			},
			{
				"name": "Muslims",
				"salience": 0.0013095936,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.0012173367,
				"type": "ORGANIZATION"
			},
			{
				"name": "interest",
				"salience": 0.0012173367,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07r8cv9"
				},
				"name": "Senators",
				"salience": 0.0012024867,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0011861578,
				"type": "LOCATION"
			},
			{
				"name": "members",
				"salience": 0.0011289424,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gztl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southwest_Airlines"
				},
				"name": "Southwest Airlines",
				"salience": 0.001070502,
				"type": "ORGANIZATION"
			},
			{
				"name": "incident",
				"salience": 0.0010541145,
				"type": "EVENT"
			},
			{
				"name": "lunchtime",
				"salience": 0.0010541145,
				"type": "EVENT"
			},
			{
				"name": "support",
				"salience": 0.0010541145,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0010541145,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05k17c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dean_(education)"
				},
				"name": "Dean of Students",
				"salience": 0.0010241892,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0010241892,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0010241892,
				"type": "LOCATION"
			},
			{
				"name": "student government",
				"salience": 0.0010232441,
				"type": "ORGANIZATION"
			},
			{
				"name": "Death",
				"salience": 0.0009819535,
				"type": "EVENT"
			},
			{
				"name": "name",
				"salience": 0.0009768844,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0008865972,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00086852285,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0008496863,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00079400855,
				"type": "OTHER"
			},
			{
				"name": "epithet",
				"salience": 0.00076770637,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00076770637,
				"type": "PERSON"
			},
			{
				"name": "language",
				"salience": 0.00076770637,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.00076770637,
				"type": "LOCATION"
			},
			{
				"name": "mess",
				"salience": 0.00076770637,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0007614328,
				"type": "OTHER"
			},
			{
				"name": "intimidation",
				"salience": 0.00066228025,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00061100844,
				"type": "OTHER"
			},
			{
				"name": "Executive branch",
				"salience": 0.00057346246,
				"type": "ORGANIZATION"
			},
			{
				"name": "bias",
				"salience": 0.00057346246,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.00057346246,
				"type": "OTHER"
			},
			{
				"name": "Cabinet",
				"salience": 0.00057346246,
				"type": "EVENT"
			},
			{
				"name": "nationality",
				"salience": 0.00057346246,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00057346246,
				"type": "OTHER"
			},
			{
				"name": "sexuality",
				"salience": 0.00057346246,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00057346246,
				"type": "OTHER"
			},
			{
				"name": "gender",
				"salience": 0.00057346246,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00057346246,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.00047247912,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00047247912,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0294j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Death"
				},
				"name": "Death",
				"salience": 0.00046303455,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.000300299,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/14889853_1327500537268732_2350422579670049954_o-copy-1.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T02:38:46.441+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 5 2016 Muslims regularly use “Inshallah” (“God Willing” in Arabic) and nobody calls it ‘Christophobic’ hate speech…so why is “Deus Vult” (“God Willing” in Latin) graffiti being called ‘Islamophobic’ Crusader hate speech? At the newly sharia-compliant University of Southern Maine, moronic school officials say “Deus Vult” Graffiti of Crusades’ rallying cry is being referred to the state Attorney General’s office after the Latin phrase used by Christians was written on a desk and wall in a student government office. Press Herald The phrase was used as a rallying cry for Christians during the Crusades in medieval times, and more recently has now is being called an anti-Muslim insult. In an email to the campus community, USM President Glenn Cummings condemned the “anti-Muslim graffiti” found in the office in the Woodbury Campus Center. “I want you to know that addressing this is our highest priority. Our campus security is fully investigating what we believe to be a hate crime,” Cummings wrote. “A team from our Dean of Students is working hard to uncover the facts while providing opportunities for intergroup dialogue and supporting students directly and indirectly affected by this reprehensible act. (It’s free speech, you idiot, and Muslims use the exact same phrase everyday, especially when trying to impose their death cult on non-muslims) British member of ISIS Mostly, to our Muslim students I want to express how sorry I am this has happened. Please know that such actions affect all of us. This is not who USM is or wants to be.” (USM is a school of politically correct asswipes who should be fired) According to USM’s student body president (a Muslim, of course) , Muhammad “Humza” Khan, a male student who is not part of student government drew the graffiti Tuesday afternoon, while two student Senate members were in the office. Khan, who declined to identify the student because of the investigation, said the two witnesses have said they didn’t understand the meaning of the phrase – which was written in small letters on an electrical wire cover on a wall, and on a wooden desk. USM officials also have not released the student’s name. In a Facebook post, USM student body Vice President Matt Raymond condemned the graffiti. “I just wanted to say that all this happened a day after five Muslim students asked for applications to Student Government to become Senators. I believe this act of “criminal intimidation” (Seriously? You should be taken away in a straitjacket) to be linked to that fact,” Raymond wrote, adding that student government is open to all students of any race, gender, religion, sexuality, economic background or nationality.” (It is, but you can’t blame students for hating Muslims, the biggest threat to America) Southwest Airlines knows what it means and acted accordingly Humza Khan, myself, and our Cabinet under the Executive branch condemn in the harshest terms this crime of bias and intimidation. Let’s show folks that USM is a diverse and inclusive university for all moving forward!” A group of about 40 students rallied in support of Muslim students at lunchtime Thursday. Raymond said he plans to ask the student Senate to vote out two members who he believes did not respond appropriately to the incident. Khan said he believes the person who wrote the graffiti intended to intimidate Muslim students who have expressed interest in joining the student Senate. “The way Muslims see (that Latin phrase,) we see it indirectly as ‘Let’s kill Muslims,’ ” said Khan, who is Muslim. (But Muslim students who keep saying Death to Israel/Death to America are said to be exercising their freedom of speech) “It’s not immediately seen as racist, it’s not a racial epithet, but it’s still there to intimidate a specific group of people,” Raymond said. “And it served its purpose, even though it was coded language.” (One can only hope. Muslims should be banned from holding office anywhere America. Look at the mess the Muslim in the White House has made)",
		"thread_title": "Muslims regularly use “Inshallah” (“God Willing” in Arabic) and nobody calls it ‘Christophobic’ hate speech…so why is “Deus Vult” (“God Willing” in Latin) graffiti being called ‘Islamophobic’ Crusader hate speech?",
		"title": "Muslims regularly use “Inshallah” (“God Willing” in Arabic) and nobody calls it ‘Christophobic’ hate speech…so why is “Deus Vult” (“God Willing” in Latin) graffiti being called ‘Islamophobic’ Crusader hate speech?",
		"type": "bs",
		"uuid": "ece4e6e3cf9ddcff00fbf9dd10019fea1e1ff1fd"
	},
	"-KhIjsu45hkU3H1cB6eA": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T02:38:47.382+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.19234753,
				"type": "OTHER"
			},
			{
				"name": "MUSLEH KHAN",
				"salience": 0.16102663,
				"type": "PERSON"
			},
			{
				"name": "chaplain",
				"salience": 0.08339068,
				"type": "PERSON"
			},
			{
				"name": "fundamentalist",
				"salience": 0.07250663,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.060143545,
				"type": "PERSON"
			},
			{
				"name": "Toronto Police Force",
				"salience": 0.05151842,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi",
				"salience": 0.04508642,
				"type": "LOCATION"
			},
			{
				"name": "husband",
				"salience": 0.036080025,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.02754028,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.026396332,
				"type": "PERSON"
			},
			{
				"name": "puberty",
				"salience": 0.022846963,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04s9n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_in_Islam"
				},
				"name": "Mohammed",
				"salience": 0.022190398,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.018066164,
				"type": "LOCATION"
			},
			{
				"name": "marriage",
				"salience": 0.017955504,
				"type": "OTHER"
			},
			{
				"name": "subjects",
				"salience": 0.015560877,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.015560877,
				"type": "OTHER"
			},
			{
				"name": "marriage",
				"salience": 0.013265529,
				"type": "OTHER"
			},
			{
				"name": "husband permission",
				"salience": 0.012612216,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.012612216,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h7h6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toronto"
				},
				"name": "Toronto",
				"salience": 0.012264175,
				"type": "LOCATION"
			},
			{
				"name": "Chaplain",
				"salience": 0.012143338,
				"type": "PERSON"
			},
			{
				"name": "care",
				"salience": 0.011639793,
				"type": "OTHER"
			},
			{
				"name": "beliefs",
				"salience": 0.010520789,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/074hw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sharia"
				},
				"name": "Islamic Law",
				"salience": 0.009597009,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.009597009,
				"type": "LOCATION"
			},
			{
				"name": "girl",
				"salience": 0.008594164,
				"type": "PERSON"
			},
			{
				"name": "husbands",
				"salience": 0.006217017,
				"type": "PERSON"
			},
			{
				"name": "sex",
				"salience": 0.0048625707,
				"type": "OTHER"
			},
			{
				"name": "dolls",
				"salience": 0.0048625707,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015w6q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barbie"
				},
				"name": "Barbie",
				"salience": 0.0029943394,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/tDBik7YiZOY/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T02:38:47.382+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Why did the Toronto Police Force hire a Saudi-born radical Islamic fundamentalist as a Muslim chaplain? MUSLEH KHAN: Born in Saudi Arabia, Khan now lectures in Toronto’s Muslim community on subjects like Islamic Law and marriage. On October 26th of this year, Khan was officially appointed Muslim Chaplain for The Toronto Police. Among Khan’s radical beliefs: • A woman should ask her husband permission before leaving the home… she should take care to seek permission from her husband before going out of the home that he has provided her . • The Muslim prophet Mohammed’s marriage to a nine-year-old is somehow instructive. Khan says puberty is the right time to get married (and, if that occurs when a girl is 9, so be it) — and, don’t forget, according to Khan, married women are forbidden from withholding sex from their husbands, even if they want to play with their Barbie dolls instead.",
		"thread_title": "Why did the Toronto Police Force hire a Saudi-born radical Islamic fundamentalist as a Muslim chaplain?",
		"title": "Why did the Toronto Police Force hire a Saudi-born radical Islamic fundamentalist as a Muslim chaplain?",
		"type": "bs",
		"uuid": "4e38e562efd8b58461f619c7595bc15fcecfebd5"
	},
	"-KhIjtDV65vBRsDy2ogL": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T02:38:47.921+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.64247394,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "African-Americans",
				"salience": 0.06616958,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Hussein Obama",
				"salience": 0.039903983,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.03340858,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.011958019,
				"type": "PERSON"
			},
			{
				"name": "John Yob",
				"salience": 0.011748686,
				"type": "PERSON"
			},
			{
				"name": "ayne Bradley",
				"salience": 0.009521827,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "Ku Klux Klan",
				"salience": 0.009356894,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bss",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robert_Byrd"
				},
				"name": "Robert Byrd",
				"salience": 0.0071633407,
				"type": "PERSON"
			},
			{
				"name": "HOOD",
				"salience": 0.006054332,
				"type": "LOCATION"
			},
			{
				"name": "distrust",
				"salience": 0.0059422455,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0058224024,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.00456011,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0041544414,
				"type": "LOCATION"
			},
			{
				"name": "track",
				"salience": 0.0035773057,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0035773057,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0035382714,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.003334076,
				"type": "ORGANIZATION"
			},
			{
				"name": "polling firm",
				"salience": 0.0030987572,
				"type": "ORGANIZATION"
			},
			{
				"name": "memory",
				"salience": 0.0030987572,
				"type": "OTHER"
			},
			{
				"name": "tracking poll",
				"salience": 0.0025463512,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0024803372,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0024803372,
				"type": "PERSON"
			},
			{
				"name": "pollsters",
				"salience": 0.0022721423,
				"type": "PERSON"
			},
			{
				"name": "ballots",
				"salience": 0.0022253098,
				"type": "OTHER"
			},
			{
				"name": "Strategic National",
				"salience": 0.0022040363,
				"type": "PERSON"
			},
			{
				"name": "Bernie Saunders",
				"salience": 0.002151312,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.0021327508,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0021327508,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.002127932,
				"type": "PERSON"
			},
			{
				"name": "gain",
				"salience": 0.0021196795,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0020532473,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0020532473,
				"type": "OTHER"
			},
			{
				"name": "National Ethnic Coalition Organization",
				"salience": 0.0019088829,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gcpmn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ellis_Island_Medal_of_Honor"
				},
				"name": "Ellis Island Medal of Honor",
				"salience": 0.0019088829,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h353",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muhammad_Ali"
				},
				"name": "Muhammad Ali",
				"salience": 0.0019088829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06lfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rosa_Parks"
				},
				"name": "Rosa Parks",
				"salience": 0.0019088829,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0017862243,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0017862243,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.001739886,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0017196188,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0017196188,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0016750058,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0100q4hr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harper_Polling"
				},
				"name": "Harper Polling",
				"salience": 0.0015682962,
				"type": "ORGANIZATION"
			},
			{
				"name": "praises",
				"salience": 0.0014680341,
				"type": "OTHER"
			},
			{
				"name": "pollsters",
				"salience": 0.0014584949,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0014368757,
				"type": "PERSON"
			},
			{
				"name": "college grads",
				"salience": 0.0014323336,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0014206478,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0013968522,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0013447483,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0013447483,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0013360445,
				"type": "LOCATION"
			},
			{
				"name": "t hat",
				"salience": 0.0013265144,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0013225054,
				"type": "OTHER"
			},
			{
				"name": "pollsters",
				"salience": 0.0012765952,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.0012269107,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0011953732,
				"type": "LOCATION"
			},
			{
				"name": "drop",
				"salience": 0.0011783814,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0011404909,
				"type": "LOCATION"
			},
			{
				"name": "support",
				"salience": 0.0011177112,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0010897345,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0010897345,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0010897345,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0010897345,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0010797757,
				"type": "OTHER"
			},
			{
				"name": "error margin",
				"salience": 0.0010295077,
				"type": "OTHER"
			},
			{
				"name": "drop",
				"salience": 0.0010121197,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.001005482,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.000995539,
				"type": "OTHER"
			},
			{
				"name": "absentee ballots",
				"salience": 0.000995539,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0009633627,
				"type": "OTHER"
			},
			{
				"name": "drop",
				"salience": 0.0009620813,
				"type": "OTHER"
			},
			{
				"name": "turnout",
				"salience": 0.0009392462,
				"type": "OTHER"
			},
			{
				"name": "drop-off",
				"salience": 0.0009302274,
				"type": "EVENT"
			},
			{
				"name": "turnout",
				"salience": 0.0009274151,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.00091253855,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.00091253855,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_7l8y"
				},
				"name": "U.S. Senator",
				"salience": 0.00090788247,
				"type": "ORGANIZATION"
			},
			{
				"name": "level",
				"salience": 0.00089551526,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00089551526,
				"type": "EVENT"
			},
			{
				"name": "successor",
				"salience": 0.00089551526,
				"type": "PERSON"
			},
			{
				"name": "enthusiasm",
				"salience": 0.00089551526,
				"type": "OTHER"
			},
			{
				"name": "reduction",
				"salience": 0.00089551526,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.00089551526,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0008659642,
				"type": "OTHER"
			},
			{
				"name": "shift",
				"salience": 0.00086209737,
				"type": "EVENT"
			},
			{
				"name": "engagement",
				"salience": 0.00086209737,
				"type": "OTHER"
			},
			{
				"name": "competition",
				"salience": 0.0008442841,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0008442841,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0008442841,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05b6w_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WJBK"
				},
				"name": "Fox 2",
				"salience": 0.0007861821,
				"type": "ORGANIZATION"
			},
			{
				"name": "vote",
				"salience": 0.00077314966,
				"type": "OTHER"
			},
			{
				"name": "Africans Americans",
				"salience": 0.00073617446,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0007311035,
				"type": "PERSON"
			},
			{
				"name": "opinions",
				"salience": 0.0007311035,
				"type": "OTHER"
			},
			{
				"name": "non-whites",
				"salience": 0.00069855514,
				"type": "PERSON"
			},
			{
				"name": "non-whites",
				"salience": 0.00069855514,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.00068173214,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.0006583163,
				"type": "PERSON"
			},
			{
				"name": "candidates",
				"salience": 0.00063073146,
				"type": "PERSON"
			},
			{
				"name": "complexity",
				"salience": 0.00063073146,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/055k8p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan_Republican_Party"
				},
				"name": "Michigan Republican Party",
				"salience": 0.0006128274,
				"type": "ORGANIZATION"
			},
			{
				"name": "polls",
				"salience": 0.00059297954,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00059297954,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00057758053,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.00057758053,
				"type": "OTHER"
			},
			{
				"name": "Bradley",
				"salience": 0.0005540968,
				"type": "LOCATION"
			},
			{
				"name": "office",
				"salience": 0.0005461648,
				"type": "LOCATION"
			},
			{
				"name": "disagreement",
				"salience": 0.0005461648,
				"type": "OTHER"
			},
			{
				"name": "rivalries",
				"salience": 0.0005461648,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.00053066015,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0005112199,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.00049652264,
				"type": "OTHER"
			},
			{
				"name": "tally",
				"salience": 0.00046315647,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.00045937192,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.00045000733,
				"type": "LOCATION"
			},
			{
				"name": "cities",
				"salience": 0.00039777256,
				"type": "LOCATION"
			},
			{
				"name": "message",
				"salience": 0.00039777256,
				"type": "OTHER"
			},
			{
				"name": "blue wall",
				"salience": 0.00039777256,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.00039777256,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.00036862685,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.00034314906,
				"type": "OTHER"
			},
			{
				"name": "TIPP",
				"salience": 0.00033615305,
				"type": "ORGANIZATION"
			},
			{
				"name": "choice",
				"salience": 0.00031259397,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.00029713046,
				"type": "OTHER"
			},
			{
				"name": "sympathizers",
				"salience": 0.00029713046,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.00029713046,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.00029713046,
				"type": "OTHER"
			},
			{
				"name": "preference",
				"salience": 0.00029713046,
				"type": "OTHER"
			},
			{
				"name": "respondents",
				"salience": 0.00029713046,
				"type": "PERSON"
			},
			{
				"name": "penalties",
				"salience": 0.00029713046,
				"type": "OTHER"
			},
			{
				"name": "phone",
				"salience": 0.00029713046,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0002448083,
				"type": "LOCATION"
			},
			{
				"name": "non-answer",
				"salience": 0.00019903005,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Hispanics",
				"salience": 0.00018685724,
				"type": "PERSON"
			},
			{
				"name": "Reports",
				"salience": 0.00018583429,
				"type": "OTHER"
			},
			{
				"name": "Some",
				"salience": 0.00011674367,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/black-trump-supporter-800x416-800x416.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T02:38:47.921+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "ALL IN…IN THE HOOD…for Donald Trump! Donald Trump is on track to win more of the African-American vote than any other Republican in modern memory, said John Yob, CEO of a Michigan-based polling firm, Strategic National . And that’s why Barack Hussein Obama is running around campaigning so hard against him for Hillary. While that so-called “racist” Donald Trump along with Rosa Parks and Muhammad Ali, were receiving the Ellis Island Medal of Honor from the National Ethnic Coalition Organization… …Hillary Clinton was singing the praises of Democrat Senator Robert Byrd, former leader in the Ku Klux Klan before becoming a U.S. Senator. Breitbart On Friday, a poll of 506 Pennsylvania voters by Harper Polling showed Trump has the support of 18.46 percent of African-Americans. An Oct. 30 poll of 1,249 likely voters in Pennsylvania showed Trump has 19 percent support among African Americans, while another 7 percent remain undecided. That poll has a error margin of 2.77 percent. In next-door Michigan, two nights of a tracking poll conducted for Fox 2 of 1,150 likely voters showed Trump with 14 percent support and 19 percent support. That’s equivalent to a two-point shift from Clinton to Trump in the state. Trump is gaining in Michigan partly because many African-American voters — especially younger voters who backed Sen. Bernie Saunders — distrust Clinton, said W ayne Bradley, state director of African-American engagement for the Michigan Republican Party. That distrust has helped cause a sharp drop in the number of absentee ballots mailed in from Detroit, even as other part of the state send in more ballots that before, Bradley said. Faced with a low turnout, the Clinton campaign is trying to frighten African-Americans to vote, but “t hat’s not a convincing enough argument,” he said. Trump’s gain among African-American voters is happening in many states, alongside an overall reduction in African-American enthusiasm and support for Obama’s designated successor. That drop-off in support from Obama’s 93 percent level will likely reduce the turnout for Clinton. That’s a problem for Democrats, because a 7.5 percent drop in nationwide African-American turnout would be equal to a one-point drop in a nationwide vote for Clinton. Reports say the early-voting turnout by Africans Americans has dropped by up to 10 percent in North Carolina and by somewhat less in Florida . President Barack Obama and other top Democrats have hopscotched through the states to push that turnout back up by election day. But pollsters face problems when trying to gauge opinions in a high-stakes emotional competition. Some concerned people lie to pollsters. For example, roughly 7 percent of college grads hide their support for Trump when they’re ask by pollsters over the phone, perhaps out of fear of penalties if their choice was made public. So when polls show a non-answer from respondents, for example, many undecided voters, the votes may be hiding a weak or strong preference for Trump. These factor may be impacting polls of African-Americans, who are being hammered by claims from Clinton and Obama that Trump is supposedly a racist. “If you accept the support of Klan sympathizers — the Klan — and hesitate when asked about that support, then you’ll tolerate that support when you’re in office,” Obama told an African-American crowd in North Carolina on Nov. 3. (See above for Hillary’s support of the KKK) A national poll by TIPP showed Clinton at only 75 percent support among all non-whites, including Hispanics, African-Americans and Latinos. That poll showed Trump getting support from 15 percent of non-whites , leaving 5 percent undecided and 5 percent supporting other candidates. Amid the disagreement, rivalries and complexity, Bradley is confident that Trump will do well among African-Americans. His final tally as the GOP candidate “will be a higher number that it has been in the past… [because] he’s working, he’s coming to these cities to deliver the message.” The African-American vote may even be enough to help push Trump over the so-called “blue wall” of Democratic northern states that stands in his path to the White House. Some say Trump is likely to get 16-25% of Black vote.",
		"thread_title": "ALL IN…IN THE HOOD…for Donald Trump!",
		"title": "ALL IN…IN THE HOOD…for Donald Trump!",
		"type": "bs",
		"uuid": "2e3b36aa89bb7668bacda5ecb02db830cece0286"
	},
	"-KhIjtO9HQLDUgkxvQKQ": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T04:07:10.182+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0346_6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim_Students'_Association"
				},
				"name": "Muslim Student Association",
				"salience": 0.37292805,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "Council on American-Islamic Relations",
				"salience": 0.16637124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Islamic State",
				"salience": 0.059091855,
				"type": "ORGANIZATION"
			},
			{
				"name": "sign",
				"salience": 0.03291769,
				"type": "OTHER"
			},
			{
				"name": "hate crime",
				"salience": 0.029518696,
				"type": "OTHER"
			},
			{
				"name": "description",
				"salience": 0.027853377,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.02565265,
				"type": "OTHER"
			},
			{
				"name": "graffiti",
				"salience": 0.023194807,
				"type": "OTHER"
			},
			{
				"name": "Store",
				"salience": 0.020120448,
				"type": "LOCATION"
			},
			{
				"name": "discovery",
				"salience": 0.020120448,
				"type": "EVENT"
			},
			{
				"name": "MINNESOTASTAN",
				"salience": 0.014349004,
				"type": "ORGANIZATION"
			},
			{
				"name": "BNI",
				"salience": 0.012438363,
				"type": "ORGANIZATION"
			},
			{
				"name": "campus",
				"salience": 0.011522327,
				"type": "LOCATION"
			},
			{
				"name": "incident",
				"salience": 0.011486373,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.011098389,
				"type": "PERSON"
			},
			{
				"name": "vandals",
				"salience": 0.010729533,
				"type": "PERSON"
			},
			{
				"name": "hate crime investigation",
				"salience": 0.009621081,
				"type": "EVENT"
			},
			{
				"name": "headquarters",
				"salience": 0.008283095,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04ykg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minnesota"
				},
				"name": "MN",
				"salience": 0.0076109786,
				"type": "LOCATION"
			},
			{
				"name": "chapter",
				"salience": 0.0067259045,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.0066898195,
				"type": "EVENT"
			},
			{
				"name": "thugs",
				"salience": 0.00660333,
				"type": "PERSON"
			},
			{
				"name": "founders",
				"salience": 0.0064338814,
				"type": "PERSON"
			},
			{
				"name": "Jaylani Hussein",
				"salience": 0.0061740903,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025v3k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Minnesota"
				},
				"name": "University of Minnesota",
				"salience": 0.005933463,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobic",
				"salience": 0.0055118,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0054180855,
				"type": "OTHER"
			},
			{
				"name": "campus",
				"salience": 0.0039871125,
				"type": "LOCATION"
			},
			{
				"name": "sign",
				"salience": 0.0036839268,
				"type": "OTHER"
			},
			{
				"name": "graffiti",
				"salience": 0.003390007,
				"type": "OTHER"
			},
			{
				"name": "tag",
				"salience": 0.0030696061,
				"type": "OTHER"
			},
			{
				"name": "terrorist activities",
				"salience": 0.0029928347,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0029928347,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.0029928347,
				"type": "ORGANIZATION"
			},
			{
				"name": "background",
				"salience": 0.0028812566,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0028217768,
				"type": "OTHER"
			},
			{
				"name": "hate crime",
				"salience": 0.0025274348,
				"type": "OTHER"
			},
			{
				"name": "state sponsor",
				"salience": 0.002443805,
				"type": "ORGANIZATION"
			},
			{
				"name": "tap dance",
				"salience": 0.002443805,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0023455583,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North American",
				"salience": 0.002048717,
				"type": "LOCATION"
			},
			{
				"name": "hate",
				"salience": 0.0020271991,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.0018429394,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/056rs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim_Brotherhood"
				},
				"name": "Muslim Brotherhood",
				"salience": 0.0018429394,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0kvk5nr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abdel_Fattah_el-Sisi"
				},
				"name": "al-Sisi",
				"salience": 0.0018429394,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.0018429394,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egypt",
				"salience": 0.0018429394,
				"type": "LOCATION"
			},
			{
				"name": "election campaign",
				"salience": 0.0018412401,
				"type": "EVENT"
			},
			{
				"name": "rhetoric",
				"salience": 0.001825993,
				"type": "OTHER"
			},
			{
				"name": "law enforcement agencies",
				"salience": 0.001825993,
				"type": "ORGANIZATION"
			},
			{
				"name": "campus police",
				"salience": 0.0016922886,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0014676006,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0014676006,
				"type": "LOCATION"
			},
			{
				"name": "FOX9 Naturally",
				"salience": 0.0014670015,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.0013300886,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.0013300886,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0013300886,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.0013300886,
				"type": "LOCATION"
			},
			{
				"name": "students",
				"salience": 0.0012708816,
				"type": "PERSON"
			},
			{
				"name": "hate crime investigation",
				"salience": 0.0011475048,
				"type": "EVENT"
			},
			{
				"name": "society",
				"salience": 0.0009936665,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.0009936665,
				"type": "PERSON"
			},
			{
				"name": "University administrators",
				"salience": 0.0009936665,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0008187371,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.00061160536,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/Hillary-Clinton’s-Email-–-Saudi-and-Qatar-Sponsor-ISIL.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T04:07:10.182+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 5 2016 MINNESOTASTAN: Tagging the Muslim Student Association (MSA) sign with “ISIS” is NOT a hate crime but an accurate description of what the MSA stands for The discovery of ISIS graffiti on the MSA sign at the University of Minnesota campus has the local chapter of designated terrorist group CAIR (Council on American-Islamic Relations) calling for a hate crime investigation. CAIR-MN says that “Islamophobic” vandals spray-painted “ISIS” on the Muslim Student Association’s sign on campus. However, if you are familiar with the background of the MSA, it’s easy to understand why ISIS is an appropriate tag for them. MSA, like CAIR, is a North American affiliate of the terror-linked Muslim Brotherhood organization (original founders of al-Qaeda), whose headquarters, originally in Egypt (from which it has been banned by the al-Sisi government for its terrorist activities) now is in Qatar, a well-known state sponsor of terrorism, including the Islamic State (ISIS). FOX9 Naturally, the CAIR thugs think you are too ignorant to know this, so they perform their usual “Islamophobia” tap dance, demanding yet another time-wasting state and local hate crime investigation for some harmless graffiti which was likely painted by Muslim students themselves. “University administrators and state religious and political leaders must speak out forcefully against the rising anti-Muslim hate in our society that results in such disturbing incidents,” said a statement from CAIR-MN executive director Jaylani Hussein. “We urge campus police and other relevant law enforcement agencies to investigate this incident as a hate crime.” Hussein cited the “Islamophobic rhetoric in the presidential election campaign,” particularly from Donald Trump, as a possible contributing factor to these types of incidents. (No, it’s the abhorrent behavior of Muslims themselves that cause so many people around the world to hate Muslims)",
		"thread_title": "MINNESOTASTAN: Tagging the Muslim Student Association (MSA) sign with “ISIS” is NOT a hate crime but an accurate description of what the MSA stands for",
		"title": "MINNESOTASTAN: Tagging the Muslim Student Association (MSA) sign with “ISIS” is NOT a hate crime but an accurate description of what the MSA stands for",
		"type": "bs",
		"uuid": "d188ef8af77200dee31aabba73e6ebb6ba729b41"
	},
	"-KhIjtYamB2PDVj9X94V": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T11:31:52.461+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Store",
				"salience": 0.2137161,
				"type": "LOCATION"
			},
			{
				"name": "BNI",
				"salience": 0.13376787,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0694j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quebec"
				},
				"name": "Quebec",
				"salience": 0.069215044,
				"type": "LOCATION"
			},
			{
				"name": "garbage bags",
				"salience": 0.050444826,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "women",
				"salience": 0.04889339,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.037713163,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.03754593,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.03268815,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.03268815,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "terrorists",
				"salience": 0.031475272,
				"type": "PERSON"
			},
			{
				"name": "burqas",
				"salience": 0.031475272,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.028717995,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.027398476,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.02671578,
				"type": "OTHER"
			},
			{
				"name": "diversity",
				"salience": 0.02671578,
				"type": "OTHER"
			},
			{
				"name": "idiots",
				"salience": 0.023547944,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.023063317,
				"type": "LOCATION"
			},
			{
				"name": "genocide",
				"salience": 0.01998223,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Sweden",
				"salience": 0.016474653,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.016474653,
				"type": "LOCATION"
			},
			{
				"name": "power",
				"salience": 0.014567389,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.014567389,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.012571495,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.010888893,
				"type": "PERSON"
			},
			{
				"name": "lack",
				"salience": 0.009716274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.008974564,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/q1C2cXdFHoo/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T11:31:52.461+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.4,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 6 2016 That was then… Sadly, this is now: Quebec seems to have done a 180 and is considering allowing Muslim women to wear the most offensive, most oppressive, and most potentially dangerous (terrorists often dress in burqas to hide bombs) kind of clothing of all – big black garbage bags that cover everything but the eyes. Is Canada trying to become Sweden? All these leftist idiots preaching diversity should go around the world and see what a lack of white people has done for the 3rd world. This is nothing more than white genocide, perpetrated by those in power, who want a population they can easily control and enslave…like Islam.",
		"thread_title": "WHAT HAPPENED? In 2014, Quebec tried to pass a Charter that would have banned all religious attire in public, specifically to prevent Muslim women from hiding their faces",
		"title": "WHAT HAPPENED? In 2014, Quebec tried to pass a Charter that would have banned all religious attire in public, specifically to prevent Muslim women from hiding their faces",
		"type": "bs",
		"uuid": "6da03cfdc6db7db26a3e81a99d42b3ba53cea3f5"
	},
	"-KhIjtf_gWpINf8mfY2B": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T11:31:58.058+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.28377226,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.18805154,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06426741,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.05716114,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.035996392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "DONATE",
				"salience": 0.03588462,
				"type": "OTHER"
			},
			{
				"name": "barenakedislam@gmail.com Top Posts",
				"salience": 0.03236068,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.029204627,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.028123902,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.027799565,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.02469274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "LINKS",
				"salience": 0.023880832,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.017367292,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.01518282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.01473926,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.011250982,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/NcRgUtapQl8/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T11:31:58.058+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address CONTACT: barenakedislam@gmail.com Top Posts",
		"thread_title": "SAY WHAT? Chicago Tribune calls on Democrats to force Clinton to step aside",
		"title": "SAY WHAT? Chicago Tribune calls on Democrats to force Clinton to step aside",
		"type": "bs",
		"uuid": "066e58ae8383587a338b9e7f4c7f49eba7b1bb36"
	},
	"-KhIjtpaQP95rfY08r2y": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T23:08:05.041+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "residents",
				"salience": 0.14387186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.108140185,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.056972083,
				"type": "OTHER"
			},
			{
				"name": "Store",
				"salience": 0.043247696,
				"type": "LOCATION"
			},
			{
				"name": "Locals",
				"salience": 0.042002037,
				"type": "PERSON"
			},
			{
				"name": "Guido Bucholtz",
				"salience": 0.04020169,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09qqq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall"
				},
				"name": "Wall",
				"salience": 0.03537077,
				"type": "LOCATION"
			},
			{
				"name": "invaders",
				"salience": 0.03513042,
				"type": "PERSON"
			},
			{
				"name": "shelter",
				"salience": 0.034752168,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "GERMANY",
				"salience": 0.032766346,
				"type": "LOCATION"
			},
			{
				"name": "suburb",
				"salience": 0.030475793,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/017f5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Berlin_Wall"
				},
				"name": "Berlin Wall",
				"salience": 0.02848171,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.027558496,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.024674555,
				"type": "PERSON"
			},
			{
				"name": "authorities",
				"salience": 0.021988695,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.018842679,
				"type": "ORGANIZATION"
			},
			{
				"name": "Neuperlach Süd",
				"salience": 0.018842679,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02h6_6p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Munich"
				},
				"name": "Munich",
				"salience": 0.01838724,
				"type": "LOCATION"
			},
			{
				"name": "wall",
				"salience": 0.015684742,
				"type": "OTHER"
			},
			{
				"name": "illegals",
				"salience": 0.014881502,
				"type": "PERSON"
			},
			{
				"name": "estate",
				"salience": 0.012630331,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.010696662,
				"type": "PERSON"
			},
			{
				"name": "wall",
				"salience": 0.010606333,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.00823729,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.006988364,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.006988364,
				"type": "OTHER"
			},
			{
				"name": "freeloaders",
				"salience": 0.006503621,
				"type": "PERSON"
			},
			{
				"name": "residents",
				"salience": 0.006497087,
				"type": "PERSON"
			},
			{
				"name": "alienation voters",
				"salience": 0.0064636203,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.0064636203,
				"type": "OTHER"
			},
			{
				"name": "invaders",
				"salience": 0.0050404994,
				"type": "PERSON"
			},
			{
				"name": "wall",
				"salience": 0.004903041,
				"type": "OTHER"
			},
			{
				"name": "fear",
				"salience": 0.004710176,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.004534594,
				"type": "OTHER"
			},
			{
				"name": "fence",
				"salience": 0.004534594,
				"type": "OTHER"
			},
			{
				"name": "migrant camp",
				"salience": 0.004534594,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.004534594,
				"type": "WORK_OF_ART"
			},
			{
				"name": "monster",
				"salience": 0.004365545,
				"type": "OTHER"
			},
			{
				"name": "refugee policy",
				"salience": 0.004365545,
				"type": "OTHER"
			},
			{
				"name": "asylum centre",
				"salience": 0.004275429,
				"type": "LOCATION"
			},
			{
				"name": "court",
				"salience": 0.004275429,
				"type": "ORGANIZATION"
			},
			{
				"name": "nothing",
				"salience": 0.0038952227,
				"type": "OTHER"
			},
			{
				"name": "locals",
				"salience": 0.0038294762,
				"type": "PERSON"
			},
			{
				"name": "value",
				"salience": 0.003702769,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.003702769,
				"type": "LOCATION"
			},
			{
				"name": "housing development",
				"salience": 0.003702769,
				"type": "LOCATION"
			},
			{
				"name": "arguments",
				"salience": 0.003702769,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germans",
				"salience": 0.0031041682,
				"type": "PERSON"
			},
			{
				"name": "wall",
				"salience": 0.0028438258,
				"type": "OTHER"
			},
			{
				"name": "locals",
				"salience": 0.0027898147,
				"type": "PERSON"
			},
			{
				"name": "leisure use",
				"salience": 0.0027667135,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0027667135,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0027667135,
				"type": "OTHER"
			},
			{
				"name": "ball",
				"salience": 0.0027667135,
				"type": "OTHER"
			},
			{
				"name": "games",
				"salience": 0.0027667135,
				"type": "EVENT"
			},
			{
				"name": "engineers",
				"salience": 0.0024066833,
				"type": "PERSON"
			},
			{
				"name": "centre",
				"salience": 0.0023272787,
				"type": "LOCATION"
			},
			{
				"name": "sound insulation",
				"salience": 0.0022588926,
				"type": "OTHER"
			},
			{
				"name": "Locals",
				"salience": 0.002222345,
				"type": "PERSON"
			},
			{
				"name": "towns",
				"salience": 0.002015346,
				"type": "LOCATION"
			},
			{
				"name": "friction",
				"salience": 0.002015346,
				"type": "OTHER"
			},
			{
				"name": "rapists",
				"salience": 0.002015346,
				"type": "EVENT"
			},
			{
				"name": "jihadists",
				"salience": 0.002015346,
				"type": "PERSON"
			},
			{
				"name": "judgment",
				"salience": 0.0017387016,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.0017387016,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01w1sx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cold_War"
				},
				"name": "Cold War",
				"salience": 0.0017032671,
				"type": "EVENT"
			},
			{
				"name": "behaviour",
				"salience": 0.0015056098,
				"type": "OTHER"
			},
			{
				"name": "noise",
				"salience": 0.0015056098,
				"type": "OTHER"
			},
			{
				"name": "thugs",
				"salience": 0.0015056098,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0014131212,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03qcfv3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Administrative_court"
				},
				"name": "Administrative Court",
				"salience": 0.0010702234,
				"type": "ORGANIZATION"
			},
			{
				"name": "UK Daily Mail Critics",
				"salience": 0.0010127448,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/refugee-crisis-357690-800x450.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T23:08:05.041+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 6 2016 GERMANY: Bigger than the Berlin Wall, the 12-foot-high ‘Munich Wall’ is being constructed to protect local residents from illegal alien Muslim invaders Locals campaigned for the wall, in the suburb of Neuperlach Süd, after authorities decided that some 160 young (up to age 40) unaccompanied Muslim illegals will move into a large shelter which is less than 100 metres from a residential estate. UK Daily Mail Critics say the wall is further proof of the alienation voters feel with Chancellor Angela Merkel’s refugee policy. Deputy District Chairman Guido Bucholtz, said: ‘I was frightened when I saw this monster of a wall.’ (Not as frightened as Germans are of the Muslim invaders) He added that he thinks the wall is too high as another similar structure designed to fence off a migrant camp was just three metres high. He said: ‘This whole propaganda really sucks.’ (Yeah, I guess you don’t like it when people find out you’ve been lying to them) However residents from the neighbouring housing development from the asylum centre went to court to get the wall built. One of their arguments for the wall was the fear that the value of their homes would plummet if there was nothing to separate them from the refugees who could be there for years to come. Local residents said they are fearful of the ‘noise and behaviour’ of the Muslim thugs. The judge of the Administrative Court in Munich confirmed the wall in a judgment – noted that the migrants should not use if for ‘ball throwing games’ or other ‘leisure use’. The fact that it is higher than the Berlin Wall of the Cold War is not lost on locals and officials. But engineers said it had to be that high to provide an effective sound insulation. The wall is nearly finished. Locals say they do not care about how it looks; only that it will separate them from the unaccompanied Muslim freeloaders, rapists and jihadists who have often been at the centre of friction with locals in other German towns.",
		"thread_title": "GERMANY: Bigger than the Berlin Wall, the 12-foot-high ‘Munich Wall’ is being constructed to protect local residents from illegal alien Muslim invaders",
		"title": "GERMANY: Bigger than the Berlin Wall, the 12-foot-high ‘Munich Wall’ is being constructed to protect local residents from illegal alien Muslim invaders",
		"type": "bs",
		"uuid": "e2a9b33da3c30f2d576645416d4f91bbdb790962"
	},
	"-KhIjtxuSkzgG1vyeKqr": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T23:08:05.497+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "@ 2",
				"salience": 0.16587174,
				"type": "OTHER"
			},
			{
				"name": "Maher",
				"salience": 0.13290314,
				"type": "PERSON"
			},
			{
				"name": "Anita",
				"salience": 0.096351385,
				"type": "PERSON"
			},
			{
				"name": "Liberals",
				"salience": 0.080218405,
				"type": "PERSON"
			},
			{
				"name": "leftys",
				"salience": 0.067768894,
				"type": "PERSON"
			},
			{
				"name": "change",
				"salience": 0.056170076,
				"type": "EVENT"
			},
			{
				"name": "wing coup d'état",
				"salience": 0.042085983,
				"type": "ORGANIZATION"
			},
			{
				"name": "snake",
				"salience": 0.033351433,
				"type": "OTHER"
			},
			{
				"name": "win win situation",
				"salience": 0.027957283,
				"type": "OTHER"
			},
			{
				"name": "bitch",
				"salience": 0.023431042,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.023431042,
				"type": "LOCATION"
			},
			{
				"name": "libs",
				"salience": 0.022560338,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0163v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belarus"
				},
				"name": "BLR",
				"salience": 0.020581307,
				"type": "LOCATION"
			},
			{
				"name": "events",
				"salience": 0.019144548,
				"type": "EVENT"
			},
			{
				"name": "research",
				"salience": 0.019144548,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.019144548,
				"type": "EVENT"
			},
			{
				"name": "corporations",
				"salience": 0.0152489925,
				"type": "ORGANIZATION"
			},
			{
				"name": "@ 1",
				"salience": 0.014447244,
				"type": "OTHER"
			},
			{
				"name": "Ronald Dumont",
				"salience": 0.014447244,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.014314671,
				"type": "OTHER"
			},
			{
				"name": "guise",
				"salience": 0.014314671,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.013909355,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.01179997,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/021583",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_(law)"
				},
				"name": "Bill",
				"salience": 0.010529648,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.010432942,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.010044179,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.007797088,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.007797088,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.004801215,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/Poztq2xHr3o/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T23:08:05.497+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Anita November 6, 2016 @ 2:09 pm \nWho cares what Maher has to say! Liberals are all as odd as a three headed snake! BLR November 6, 2016 @ 2:08 pm \nTrump gets in it will be a win win situation for libs and leftys they will get to cry and bitch in a great country for a change Ronald Dumont November 6, 2016 @ 1:52 pm \nIt seems Bill has done some research, This US election almost mirrors events of 1933 Germany! The only major difference is there are only tow political parties vying for control! This is not a true Right wing coup d’état, it is a industrialist transnational corporations taking power under the guise of protecting and defending us from what they have created in the first place to control us!",
		"thread_title": "Liberal commentator Bill Maher says democrats made a big mistake in attacking George W Bush, Mitt Romney, and John McCain so harshly…",
		"title": "Liberal commentator Bill Maher says democrats made a big mistake in attacking George W Bush, Mitt Romney, and John McCain so harshly…",
		"type": "bs",
		"uuid": "3245db03c6921bdba38c0c708a57e1370be2dad4"
	},
	"-KhIju8oxF5sRetP_MoZ": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T23:08:05.989+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "government",
				"salience": 0.24020728,
				"type": "ORGANIZATION"
			},
			{
				"name": "fan",
				"salience": 0.09814226,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.081641585,
				"type": "PERSON"
			},
			{
				"name": "@ 2",
				"salience": 0.06605335,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald J. Trump",
				"salience": 0.053718615,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05qhw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Poland"
				},
				"name": "Polish",
				"salience": 0.05088755,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05d7fpf"
				},
				"name": "Nina",
				"salience": 0.05088755,
				"type": "PERSON"
			},
			{
				"name": "cop",
				"salience": 0.046505075,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.04236314,
				"type": "PERSON"
			},
			{
				"name": "opposition",
				"salience": 0.03425872,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.03425872,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.03425872,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.025818706,
				"type": "LOCATION"
			},
			{
				"name": "anti-Trumper",
				"salience": 0.018106649,
				"type": "PERSON"
			},
			{
				"name": "Video",
				"salience": 0.016293328,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bitches",
				"salience": 0.01191019,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.011737109,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Job",
				"salience": 0.010106712,
				"type": "OTHER"
			},
			{
				"name": "WATCH",
				"salience": 0.010106712,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "patience",
				"salience": 0.009979814,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.009368743,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.007556737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "hillary",
				"salience": 0.007342753,
				"type": "PERSON"
			},
			{
				"name": "Dubi",
				"salience": 0.007342753,
				"type": "PERSON"
			},
			{
				"name": "views",
				"salience": 0.0063584796,
				"type": "OTHER"
			},
			{
				"name": "Views",
				"salience": 0.0059686066,
				"type": "OTHER"
			},
			{
				"name": "hater",
				"salience": 0.0058935415,
				"type": "OTHER"
			},
			{
				"name": "Obnoxious Trump-Hater Getting Justice",
				"salience": 0.0029266113,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/Poll_110616.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T23:08:05.989+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Nina November 6, 2016 @ 2:39 pm \nPolish government and common people (except liberal and leftist opposition which lost everything in last year election) pray for Trump to be the president of USA. Dubi November 6, 2016 @ 2:25 pm \nWith bitches like this hillary fan America is lost if she wins. She is lucky I wasn’t that cop who has the patience of Job, because I don’t! GO TRUMP! ! ! \nWATCH: Video of Obnoxious Trump-Hater Getting Justice Explodes…6 MILLION Views This obnoxious Donald J. Trump hater has gone viral in a major way, and it’s not good. Here’s what happened to this anti-Trumper on video that has netted her six million views… This is AWESOME! Read more…",
		"thread_title": "As of 6:00 AM NOVEMBER 6th, Trump is leading in major national polls",
		"title": "As of 6:00 AM NOVEMBER 6th, Trump is leading in major national polls",
		"type": "bs",
		"uuid": "3ee79e368b14ae0ca25cd5adf2ff2a2388fda853"
	},
	"-KhIjuHhTAxEV014Z5WM": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T23:08:06.991+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "same",
				"salience": 0.22197609,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.1610261,
				"type": "ORGANIZATION"
			},
			{
				"name": "@ 12",
				"salience": 0.13987263,
				"type": "OTHER"
			},
			{
				"name": "Leftwing Journalist DI LORENZO",
				"salience": 0.12451438,
				"type": "PERSON"
			},
			{
				"name": "everybody",
				"salience": 0.10389663,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02l3h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election"
				},
				"name": "Elections.",
				"salience": 0.03944548,
				"type": "PERSON"
			},
			{
				"name": "guy",
				"salience": 0.037198555,
				"type": "PERSON"
			},
			{
				"name": "Passports",
				"salience": 0.036249883,
				"type": "OTHER"
			},
			{
				"name": "TV",
				"salience": 0.034473155,
				"type": "OTHER"
			},
			{
				"name": "didnt",
				"salience": 0.032984287,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.019659163,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n9z5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Die_Zeit"
				},
				"name": "DIE ZEIT",
				"salience": 0.017398227,
				"type": "ORGANIZATION"
			},
			{
				"name": "Socialdemocratic Newspaper",
				"salience": 0.017398227,
				"type": "ORGANIZATION"
			},
			{
				"name": "charge",
				"salience": 0.013907181,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/nfgEvgVC6Qs/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-06T23:08:06.991+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.5,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "November 6, 2016 @ 12:34 pm \nThe same in the EU. YOu now there are EU Elections.And everybody who have 2 Passports from EU can vote-but only 1 time is allowed. \nBut in TV the Leftwing Journalist DI LORENZO from the Socialdemocratic Newspaper DIE ZEIT-sayed that he voted 2 times.And what happened?The charge was stopped. \nAnd this leftwing guy who always behave like he knews all sayed:In didnt know that it is forbidden to vote 2 times…",
		"thread_title": "ARREST HIIM! Barack Hussein Obama tells illegal alien there will be no consequences if she votes illegally",
		"title": "ARREST HIIM! Barack Hussein Obama tells illegal alien there will be no consequences if she votes illegally",
		"type": "bs",
		"uuid": "ccaaa097de587c7ee7fe27233f38a6321c57aa72"
	},
	"-KhIjuOUym-iFelMGOfV": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T01:36:51.678+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0158r2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Camilla,_Duchess_of_Cornwall"
				},
				"name": "Camilla",
				"salience": 0.21203846,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0xnc3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Charles,_Prince_of_Wales"
				},
				"name": "Charles",
				"salience": 0.18107232,
				"type": "PERSON"
			},
			{
				"name": "Store",
				"salience": 0.06773366,
				"type": "LOCATION"
			},
			{
				"name": "Zaved Grand Mosque",
				"salience": 0.06758979,
				"type": "PERSON"
			},
			{
				"name": "female",
				"salience": 0.05365235,
				"type": "PERSON"
			},
			{
				"name": "Prince",
				"salience": 0.0510063,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.033393886,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j5g9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wales"
				},
				"name": "Wales",
				"salience": 0.032191593,
				"type": "LOCATION"
			},
			{
				"name": "mosque",
				"salience": 0.03095974,
				"type": "OTHER"
			},
			{
				"name": "mosque",
				"salience": 0.028785942,
				"type": "OTHER"
			},
			{
				"name": "shoes",
				"salience": 0.028637448,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "shoes",
				"salience": 0.028637448,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Prince",
				"salience": 0.019424682,
				"type": "PERSON"
			},
			{
				"name": "Visitors",
				"salience": 0.018032987,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gxj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abu_Dhabi"
				},
				"name": "Abu Dhabi",
				"salience": 0.016022412,
				"type": "LOCATION"
			},
			{
				"name": "Duchess",
				"salience": 0.015220527,
				"type": "OTHER"
			},
			{
				"name": "tolerance",
				"salience": 0.015220527,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01q1j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cornwall"
				},
				"name": "Cornwall",
				"salience": 0.009396356,
				"type": "LOCATION"
			},
			{
				"name": "wife",
				"salience": 0.00917504,
				"type": "PERSON"
			},
			{
				"name": "linen suit",
				"salience": 0.008102976,
				"type": "OTHER"
			},
			{
				"name": "tie",
				"salience": 0.008102976,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "headscarf",
				"salience": 0.007641014,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "jacket",
				"salience": 0.0066197556,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "trousers",
				"salience": 0.0066197556,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "footwear",
				"salience": 0.0066197556,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Daily Mail Charles",
				"salience": 0.0063844556,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.0049948255,
				"type": "LOCATION"
			},
			{
				"name": "entrance",
				"salience": 0.004948972,
				"type": "LOCATION"
			},
			{
				"name": "research centres",
				"salience": 0.00360653,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.00360653,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00360653,
				"type": "LOCATION"
			},
			{
				"name": "shoes",
				"salience": 0.0034461734,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Abu Dhabi City Island",
				"salience": 0.0030486055,
				"type": "LOCATION"
			},
			{
				"name": "head",
				"salience": 0.0022386545,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j1z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Arab_Emirates"
				},
				"name": "United Arab Emirates",
				"salience": 0.0022210209,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/3A1DDA4500000578-3910096-image-a-47_1478443765293.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T01:36:51.678+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": 0.6
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 6 2016 Like a good little sharia-compliant female, Prince Charles’ wife Camilla removes her shoes to enter a mosque in Abu Dhabi, but the Prince of Wales keeps his shoes on The Prince of Wales and Duchess of Cornwall have visited the spectacular Sheikh Zaved Grand Mosque to promote religious tolerance. ( HAH! ) UK Daily Mail Charles was dressed in a linen suit and striped tie, while Camilla wore a blue headscarf, long jacket and trousers. Visitors to the mosque must remove their footwear, BUT Charles walked round in black shoes while his wife went barefoot with her head covered. The mosque was established in 2008 and sits at the entrance to Abu Dhabi City Island. It aims to work with research centres and religious, educational and cultural institutions within the United Arab Emirates and across the world.",
		"thread_title": "Like a good little sharia-compliant female, Prince Charles’ wife Camilla removes her shoes to enter a mosque in Abu Dhabi, but the Prince of Wales keeps his shoes on",
		"title": "Like a good little sharia-compliant female, Prince Charles’ wife Camilla removes her shoes to enter a mosque in Abu Dhabi, but the Prince of Wales keeps his shoes on",
		"type": "bs",
		"uuid": "0dd2093203b8b9e1e4adcd8ac0b7872b6ea744d7"
	},
	"-KhIjuYK0eVbhm7h6maf": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T01:36:51.842+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Muslims",
				"salience": 0.35983387,
				"type": "PERSON"
			},
			{
				"name": "Albayrak",
				"salience": 0.15345325,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.08110059,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.05022567,
				"type": "PERSON"
			},
			{
				"name": "freeloaders",
				"salience": 0.043638732,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somali",
				"salience": 0.029237583,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09krp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hesse"
				},
				"name": "Hesse",
				"salience": 0.027086355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dqwsf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wabern,_Hesse"
				},
				"name": "Wabern",
				"salience": 0.027086355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "GERMANY",
				"salience": 0.027086355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.026435697,
				"type": "OTHER"
			},
			{
				"name": "pub",
				"salience": 0.02321329,
				"type": "LOCATION"
			},
			{
				"name": "drinks",
				"salience": 0.013621543,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05r5c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Piano"
				},
				"name": "Piano",
				"salience": 0.011236178,
				"type": "WORK_OF_ART"
			},
			{
				"name": "time",
				"salience": 0.009330185,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.008156223,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0080179805,
				"type": "OTHER"
			},
			{
				"name": "savages",
				"salience": 0.007560716,
				"type": "OTHER"
			},
			{
				"name": "pub owner",
				"salience": 0.0068383114,
				"type": "PERSON"
			},
			{
				"name": "establishment",
				"salience": 0.0065499046,
				"type": "OTHER"
			},
			{
				"name": "vodkas",
				"salience": 0.006306085,
				"type": "OTHER"
			},
			{
				"name": "payment",
				"salience": 0.006306085,
				"type": "OTHER"
			},
			{
				"name": "tab",
				"salience": 0.006306085,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.006306085,
				"type": "OTHER"
			},
			{
				"name": "beers",
				"salience": 0.006306085,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Source Two",
				"salience": 0.006071313,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalis",
				"salience": 0.005264542,
				"type": "PERSON"
			},
			{
				"name": "pub door",
				"salience": 0.0046167383,
				"type": "OTHER"
			},
			{
				"name": "glass",
				"salience": 0.0039987066,
				"type": "OTHER"
			},
			{
				"name": "iron rods",
				"salience": 0.0039987066,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.003849667,
				"type": "PERSON"
			},
			{
				"name": "savages",
				"salience": 0.0033640938,
				"type": "OTHER"
			},
			{
				"name": "two",
				"salience": 0.0027838969,
				"type": "PERSON"
			},
			{
				"name": "owner",
				"salience": 0.0027838969,
				"type": "PERSON"
			},
			{
				"name": "noise",
				"salience": 0.0025344929,
				"type": "OTHER"
			},
			{
				"name": "boom",
				"salience": 0.0025138012,
				"type": "OTHER"
			},
			{
				"name": "boom",
				"salience": 0.0025138012,
				"type": "OTHER"
			},
			{
				"name": "sound",
				"salience": 0.0022901646,
				"type": "OTHER"
			},
			{
				"name": "thugs",
				"salience": 0.0021769702,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/SomalisDontPay.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T01:36:51.842+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.7,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "GERMANY: “We are Somali Muslims, we don’t have to pay” In Wabern, Hesse, a group of five Somali Muslim freeloaders sat down and had drinks at the “Piano” pub. The group was there for the first time and Albayrak [the owner] didn’t know them. They drank “eight beers, two vodkas” and put everything on a tab. When Albayrak want to collect payment, there was anger. “We are Somalis, we don’t pay.” Source Two of the savages stood up and went out. Albayrak banned the other three from the establishment and threw them out. “They were very aggressive, they were upset,” says Albayrak. The pub owner then shut the door. Suddenly, the owner heard a noise from outside. There was a “boom, boom” sound. Albayrak looked out and saw two of the Somali Muslim thugs with iron rods beating on the pub door, shattering the glass. “I was afraid they were going to kill me,” says the 58-year-old. He called the police but they didn’t arrive for a half hour, and by then, the savages were already gone.",
		"thread_title": "GERMANY: “We are Somali Muslims, we don’t have to pay”",
		"title": "GERMANY: “We are Somali Muslims, we don’t have to pay”",
		"type": "bs",
		"uuid": "bc8db989ccad2b78273f4e12a0e097e9686c379b"
	},
	"-KhIjul-CIKyJHF0vN_0": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T01:36:51.972+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italian",
				"salience": 0.18272592,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08dds4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_de_Maizi%C3%A8re"
				},
				"name": "Thomas de Maizière",
				"salience": 0.12360239,
				"type": "PERSON"
			},
			{
				"name": "proposal",
				"salience": 0.05322931,
				"type": "OTHER"
			},
			{
				"name": "invaders",
				"salience": 0.052469645,
				"type": "PERSON"
			},
			{
				"name": "crossing",
				"salience": 0.033748206,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.031459764,
				"type": "LOCATION"
			},
			{
				"name": "INTERIOR MINISTER",
				"salience": 0.030308437,
				"type": "PERSON"
			},
			{
				"name": "Minister",
				"salience": 0.030308437,
				"type": "PERSON"
			},
			{
				"name": "invaders",
				"salience": 0.0299404,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "Germany",
				"salience": 0.025991013,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.022156253,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.018616732,
				"type": "LOCATION"
			},
			{
				"name": "order",
				"salience": 0.018616732,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.017434001,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.017002285,
				"type": "LOCATION"
			},
			{
				"name": "freeloaders",
				"salience": 0.016414223,
				"type": "PERSON"
			},
			{
				"name": "Africa Germany",
				"salience": 0.015882276,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fg2q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Interior_(topology)"
				},
				"name": "Interior",
				"salience": 0.014679583,
				"type": "ORGANIZATION"
			},
			{
				"name": "Protesters",
				"salience": 0.011251513,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.011030754,
				"type": "PERSON"
			},
			{
				"name": "Helmut Teichmann",
				"salience": 0.010247759,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04swx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mediterranean_Sea"
				},
				"name": "Mediterranean",
				"salience": 0.009577989,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0085748,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.008421133,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.006599017,
				"type": "ORGANIZATION"
			},
			{
				"name": "refugees",
				"salience": 0.005527674,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.004884241,
				"type": "PERSON"
			},
			{
				"name": "migration",
				"salience": 0.004884241,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0048404587,
				"type": "OTHER"
			},
			{
				"name": "measure",
				"salience": 0.0048188725,
				"type": "OTHER"
			},
			{
				"name": "migrants",
				"salience": 0.0047022067,
				"type": "PERSON"
			},
			{
				"name": "pull factor",
				"salience": 0.0045435256,
				"type": "OTHER"
			},
			{
				"name": "taxi service",
				"salience": 0.0045435256,
				"type": "OTHER"
			},
			{
				"name": "minister",
				"salience": 0.0043445337,
				"type": "PERSON"
			},
			{
				"name": "crossings",
				"salience": 0.004267751,
				"type": "LOCATION"
			},
			{
				"name": "refugees",
				"salience": 0.0041838675,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.0041429354,
				"type": "PERSON"
			},
			{
				"name": "migrants",
				"salience": 0.004064336,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.003935081,
				"type": "PERSON"
			},
			{
				"name": "spitting distance",
				"salience": 0.003935081,
				"type": "OTHER"
			},
			{
				"name": "asylum applications",
				"salience": 0.003763854,
				"type": "OTHER"
			},
			{
				"name": "prevention",
				"salience": 0.0037406816,
				"type": "OTHER"
			},
			{
				"name": "aim",
				"salience": 0.003555871,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05g2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Africa"
				},
				"name": "North African",
				"salience": 0.0035040413,
				"type": "LOCATION"
			},
			{
				"name": "Rescuers",
				"salience": 0.003438615,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.003438615,
				"type": "PERSON"
			},
			{
				"name": "migrant route",
				"salience": 0.0033801778,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0033525864,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.0031869237,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.0031869237,
				"type": "LOCATION"
			},
			{
				"name": "migrants",
				"salience": 0.0029803696,
				"type": "PERSON"
			},
			{
				"name": "purpose",
				"salience": 0.0029404492,
				"type": "OTHER"
			},
			{
				"name": "@moas_eu",
				"salience": 0.0027980313,
				"type": "PERSON"
			},
			{
				"name": "@audioexpression",
				"salience": 0.0027980313,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0027599314,
				"type": "ORGANIZATION"
			},
			{
				"name": "approach",
				"salience": 0.0027599314,
				"type": "OTHER"
			},
			{
				"name": "human traffickers",
				"salience": 0.0026569786,
				"type": "OTHER"
			},
			{
				"name": "spokeswoman",
				"salience": 0.0026569786,
				"type": "PERSON"
			},
			{
				"name": "scandal",
				"salience": 0.0026397805,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0024734803,
				"type": "LOCATION"
			},
			{
				"name": "The Champ",
				"salience": 0.0024230895,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.0024230895,
				"type": "PERSON"
			},
			{
				"name": "incentive",
				"salience": 0.0022533864,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0022533864,
				"type": "EVENT"
			},
			{
				"name": "bodies",
				"salience": 0.0022533864,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0022533864,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0022533864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "vessels",
				"salience": 0.0022533864,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06c62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rome"
				},
				"name": "Rome",
				"salience": 0.0022173745,
				"type": "LOCATION"
			},
			{
				"name": "deaths",
				"salience": 0.0020194636,
				"type": "EVENT"
			},
			{
				"name": "coast",
				"salience": 0.001944109,
				"type": "LOCATION"
			},
			{
				"name": "fact",
				"salience": 0.001944109,
				"type": "OTHER"
			},
			{
				"name": "Minister",
				"salience": 0.0017010227,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05_03q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Police_(Germany)"
				},
				"name": "Federal Police",
				"salience": 0.001699141,
				"type": "ORGANIZATION"
			},
			{
				"name": "trip",
				"salience": 0.0016835112,
				"type": "EVENT"
			},
			{
				"name": "record number",
				"salience": 0.0016835112,
				"type": "OTHER"
			},
			{
				"name": "shipwrecks",
				"salience": 0.0016835112,
				"type": "OTHER"
			},
			{
				"name": "whole",
				"salience": 0.0016835112,
				"type": "LOCATION"
			},
			{
				"name": "point",
				"salience": 0.0016835112,
				"type": "OTHER"
			},
			{
				"name": "journey",
				"salience": 0.0016835112,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0016835112,
				"type": "OTHER"
			},
			{
				"name": "crossing",
				"salience": 0.001670926,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.0016357305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01jjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Balkans"
				},
				"name": "Balkans",
				"salience": 0.0016357305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austria",
				"salience": 0.0016357305,
				"type": "LOCATION"
			},
			{
				"name": "countries",
				"salience": 0.0014160331,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04vr4p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Strait_of_Sicily"
				},
				"name": "Strait of Sicily",
				"salience": 0.001387172,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012q_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Coast_guard"
				},
				"name": "Coast Guard",
				"salience": 0.001387172,
				"type": "ORGANIZATION"
			},
			{
				"name": "sea",
				"salience": 0.0012261837,
				"type": "LOCATION"
			},
			{
				"name": "Critics",
				"salience": 0.0011508546,
				"type": "PERSON"
			},
			{
				"name": "International Organization of Migrants",
				"salience": 0.0011477328,
				"type": "ORGANIZATION"
			},
			{
				"name": "rescuers",
				"salience": 0.0011414515,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0011414515,
				"type": "PERSON"
			},
			{
				"name": "death toll",
				"salience": 0.0010939356,
				"type": "OTHER"
			},
			{
				"name": "asylum",
				"salience": 0.0010578256,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.00097594474,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.00091598264,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00091598264,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.00091598264,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00091598264,
				"type": "OTHER"
			},
			{
				"name": "prospect",
				"salience": 0.00091598264,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.0008930419,
				"type": "OTHER"
			},
			{
				"name": "taxi service",
				"salience": 0.0008635608,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0377k9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Minister_(government)"
				},
				"name": "Minister",
				"salience": 0.0008547586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07fj_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tunisia"
				},
				"name": "Tunisia",
				"salience": 0.0007547033,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02k54",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Egypt"
				},
				"name": "Egypt",
				"salience": 0.0007547033,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/gocmen-main.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T01:36:51.972+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "GERMAN INTERIOR MINISTER demands that Italy send all new illegal alien Muslim invaders back to Africa Germany’s Minister of the Interior has launched a controversial proposal to return African Muslim male invaders home rather than bringing them to Italy, in order to discourage more economic freeloaders from attempting the dangerous crossing. Even worse, Italy has been rescuing them near Libya, not even waiting until they get within spitting distance of Italy. So, where are all the women and children? @moas_eu the taxi service just outside of Libya is part of the pull factor \n— The Champ (@audioexpression) November 5, 2016 Breitbart Minister Thomas de Maizière said Sunday that those “saved in the Mediterranean should be sent back to Africa” instead of taking them to Europe. According to a spokeswoman for the minister, this measure would serve a twofold purpose: discouraging new migrants from coming while also demolishing the organizations of human traffickers that organize the crossings. Germany’s interior minister Thomas de Maiziere threatened to close Italy’s border with Austria if Rome starts sending migrants north. With the migrant route through the Balkans from Greece closed, migrants are instead crossing the Mediterranean from North African countries such as Libya and arriving in Italy. De Maizière is not alone in his approach. “The prevention of illegal migration does not start at our internal borders,” said Helmut Teichmann, director of the Germany’s Federal Police. “The aim of the federal government is to stop the refugees before they reach Europe,” he said. On Saturday, 2,200 more people tried to cross the Strait of Sicily in 16 different vessels, and were rescued in a series of operations coordinated by the Italian Coast Guard who later brought them to Italy. Rescuers also recovered ten bodies of migrants who drowned during the attempt. Critics were quick to remark that part of the incentive for attempting the crossing in the first place is the knowledge that migrant rescuers are providing a free “taxi service” to Italy. Protesters have raised their voices in opposition to De Maizière’s plan, claiming it was a “scandal” that would effectively deny potential refugees the right of asylum, but the Minister did not back down. “Eliminating the prospect of reaching Europe could keep them from risking their lives in a dangerous journey.” In point of fact, this year has seen the deaths of a record number of migrants during the perilous trip. On Thursday, some 240 migrants drowned in two shipwrecks off the coast of Libya, bringing the year’s death toll in the Mediterranean to 4,220, compared with 3,777 in the whole of 2015. The Minister suggested that once the migrants were returned to Tunisia, Egypt or other North African countries, they could submit their asylum applications which, if approved, would allow them to reach Europe safely. \nAs of 2 November, 159,496 people had reached Italy by sea so far in 2016, according to the International Organization of Migrants (IOM).",
		"thread_title": "GERMAN INTERIOR MINISTER demands that Italy send all new illegal alien Muslim invaders back to Africa",
		"title": "GERMAN INTERIOR MINISTER demands that Italy send all new illegal alien Muslim invaders back to Africa",
		"type": "bs",
		"uuid": "612a3f0f8bae875b5ff1aefc407ee70547beec3e"
	},
	"-KhIjurWQLQN1UeJ-T8t": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T02:50:49.584+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.28377226,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.18805154,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06426741,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.05716114,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.035996392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "DONATE",
				"salience": 0.03588462,
				"type": "OTHER"
			},
			{
				"name": "barenakedislam@gmail.com Top Posts",
				"salience": 0.03236068,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.029204627,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.028123902,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.027799565,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.02469274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "LINKS",
				"salience": 0.023880832,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.017367292,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.01518282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.01473926,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.011250982,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/J81eKkzb3e8/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T02:50:49.584+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address CONTACT: barenakedislam@gmail.com Top Posts",
		"thread_title": "SWEDEN: Filthy Muslim savage tries to cut ahead of a Swedish woman in line",
		"title": "SWEDEN: Filthy Muslim savage tries to cut ahead of a Swedish woman in line",
		"type": "bs",
		"uuid": "66dee4f7d125d9c0d1c66335d621c3a378696fb3"
	},
	"-KhIjv6aHsA5kebYeHr1": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T06:04:24.963+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/08lfdk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Heinz-Christian_Strache"
				},
				"name": "Heinz-Christian Strache",
				"salience": 0.37219962,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/013vy8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_Party_of_Austria"
				},
				"name": "Austrian Freedom Party",
				"salience": 0.18484984,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jl0g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Angela_Merkel"
				},
				"name": "Angela Merkel",
				"salience": 0.050277684,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.042690534,
				"type": "PERSON"
			},
			{
				"name": "amount",
				"salience": 0.021736303,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.018225618,
				"type": "PERSON"
			},
			{
				"name": "anti-Islamization Freedom Party",
				"salience": 0.018109124,
				"type": "ORGANIZATION"
			},
			{
				"name": "leader",
				"salience": 0.017985845,
				"type": "PERSON"
			},
			{
				"name": "Chancellor",
				"salience": 0.017985845,
				"type": "PERSON"
			},
			{
				"name": "aliens",
				"salience": 0.015599033,
				"type": "OTHER"
			},
			{
				"name": "verge",
				"salience": 0.015599033,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.015599033,
				"type": "PERSON"
			},
			{
				"name": "Norbert Hofer",
				"salience": 0.015056514,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austrian",
				"salience": 0.014771806,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0146105355,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0fhp9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vienna"
				},
				"name": "Vienna",
				"salience": 0.012484315,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01y1xp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_Aotearoa_New_Zealand"
				},
				"name": "Green party",
				"salience": 0.012031874,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.009638809,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.009638809,
				"type": "LOCATION"
			},
			{
				"name": "civil war",
				"salience": 0.0074543646,
				"type": "EVENT"
			},
			{
				"name": "term",
				"salience": 0.004699568,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0h7x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austria"
				},
				"name": "Austrians",
				"salience": 0.00454487,
				"type": "PERSON"
			},
			{
				"name": "election posters",
				"salience": 0.0038462193,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0038148605,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0034974054,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.003421813,
				"type": "EVENT"
			},
			{
				"name": "migrants",
				"salience": 0.0033042883,
				"type": "PERSON"
			},
			{
				"name": "social welfare system",
				"salience": 0.0033042883,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.003294313,
				"type": "EVENT"
			},
			{
				"name": "civil war",
				"salience": 0.002815407,
				"type": "EVENT"
			},
			{
				"name": "influx",
				"salience": 0.0027327575,
				"type": "OTHER"
			},
			{
				"name": "re-run",
				"salience": 0.0026763529,
				"type": "EVENT"
			},
			{
				"name": "phrase",
				"salience": 0.0026763529,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.002670132,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0025765803,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0025765803,
				"type": "PERSON"
			},
			{
				"name": "tone",
				"salience": 0.0023179129,
				"type": "OTHER"
			},
			{
				"name": "bid",
				"salience": 0.0023179129,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.0023179129,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.0023179129,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0023179129,
				"type": "PERSON"
			},
			{
				"name": "t",
				"salience": 0.002231482,
				"type": "OTHER"
			},
			{
				"name": "h",
				"salience": 0.002231482,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.002231482,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0020881942,
				"type": "EVENT"
			},
			{
				"name": "slogan",
				"salience": 0.002068155,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.001892634,
				"type": "EVENT"
			},
			{
				"name": "church",
				"salience": 0.001892634,
				"type": "LOCATION"
			},
			{
				"name": "branches",
				"salience": 0.0016463868,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0016329435,
				"type": "OTHER"
			},
			{
				"name": "phrase",
				"salience": 0.0016329435,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0015212273,
				"type": "EVENT"
			},
			{
				"name": "heart",
				"salience": 0.0014141097,
				"type": "OTHER"
			},
			{
				"name": "Norbert Hofer UK Express",
				"salience": 0.0013739846,
				"type": "ORGANIZATION"
			},
			{
				"name": "Terry D",
				"salience": 0.0013739846,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0013455993,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05sfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Protestantism"
				},
				"name": "Protestant",
				"salience": 0.0013236728,
				"type": "PERSON"
			},
			{
				"name": "statement",
				"salience": 0.0013105541,
				"type": "WORK_OF_ART"
			},
			{
				"name": "re-run",
				"salience": 0.0012513488,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.0011652423,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09949m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Istanbul"
				},
				"name": "Istanbul",
				"salience": 0.0011652423,
				"type": "LOCATION"
			},
			{
				"name": "place",
				"salience": 0.0010974399,
				"type": "OTHER"
			},
			{
				"name": "religions",
				"salience": 0.0010747636,
				"type": "OTHER"
			},
			{
				"name": "defects",
				"salience": 0.0010564853,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0010364208,
				"type": "PERSON"
			},
			{
				"name": "vote envelopes",
				"salience": 0.0010300343,
				"type": "OTHER"
			},
			{
				"name": "voting irregularities",
				"salience": 0.0010300343,
				"type": "OTHER"
			},
			{
				"name": "void",
				"salience": 0.0010300343,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0010300343,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christian",
				"salience": 0.001005289,
				"type": "OTHER"
			},
			{
				"name": "religion",
				"salience": 0.00088862976,
				"type": "OTHER"
			},
			{
				"name": "cultures",
				"salience": 0.00088862976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c8wxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholicism"
				},
				"name": "Catholic",
				"salience": 0.00087051804,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0hfjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_(genre)"
				},
				"name": "Western",
				"salience": 0.00087051804,
				"type": "ORGANIZATION"
			},
			{
				"name": "intentions",
				"salience": 0.0007694901,
				"type": "OTHER"
			},
			{
				"name": "purposes",
				"salience": 0.0007694901,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0007694901,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.0007694901,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05ns0s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alexander_Van_der_Bellen"
				},
				"name": "Alexander Van der Bellen",
				"salience": 0.000634019,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/mMF0bC8j_tQ/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T06:04:24.963+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "AUSTRIA: Freedom Party leader calls Chancellor Angela Merkel the “most dangerous woman in Europe” Heinz-Christian Strache (right), chairman of the anti-Islamization Freedom Party roasted the German Chancellor for allowing an unlimited amount of Muslim illegal aliens which he claims has left Europe on the verge of civil war. Talking to supporters, Strache argued “the uncontrolled influx of migrants alien to our culture who seep into our social welfare system… makes civil war in the medium-term not unlikely.” Austrian Freedom Party (FPOe) party leader Heinz-Christian Strache (L) and Freedom Party’s presidential candidate Norbert Hofer UK Express (h/t Terry D) Strache added that his party’s presidential candidate, Norbert Hofer, “will be there for all Austrians” in a rallying speech to drum up support ahead of the general election. Hofer has attempted to keep a neutral tone in a bid to broaden the typical appeal of the Freedom Party from an anti-immigration stance to the wider Austrian population ahead of a re-run of the earlier election. Yet the 45-year-old’s recent election posters carry the phrase “so help me God” – a term which has been slammed by both Islamic and Christian officials who say introducing God into the campaign is not appropriate. “Vienna must not become Istanbul” He says what Vienna thinks Three branches of the Protestant church in Austria released a joint statement denouncing the slogan. It reads: “God cannot be instrumentalised for one’s own intentions or for political purposes. “We consider that mentioning God… to attack other religions and cultures indirectly amounts to an abuse of his name and religion in general.” The Freedom Party claim Hofer used the rallying phrase as it came “directly from the heart” and “is strongly anchored in Christian and Western values” which the party holds. Two-thirds of Austrians identify as Catholic while just four per cent are Protestant. The Freedom Party narrowly lost the election by just 31,000 votes to Alexander Van der Bellen’s left-leaning Green party, but the result was ruled void after voting irregularities were discovered. The initial re-run of the election was due to take place in October but has been pushed back to December after defects were found in the postal vote envelopes.",
		"thread_title": "AUSTRIA: Freedom Party leader calls Chancellor Angela Merkel the “most dangerous woman in Europe”",
		"title": "AUSTRIA: Freedom Party leader calls Chancellor Angela Merkel the “most dangerous woman in Europe”",
		"type": "bs",
		"uuid": "e5106847e14cb0f1dace01470ab95a6eaa6489b1"
	},
	"-KhIjvVNDoKdSjylwXO-": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T06:04:28.069+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "Nissar Hussain",
				"salience": 0.29198933,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.093140624,
				"type": "PERSON"
			},
			{
				"name": "convert",
				"salience": 0.06860253,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.06098694,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.056599837,
				"type": "PERSON"
			},
			{
				"name": "converts",
				"salience": 0.044686783,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.031960703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.03068602,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.02173068,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.014525511,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.011158333,
				"type": "LOCATION"
			},
			{
				"name": "persecution",
				"salience": 0.011158333,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.011158333,
				"type": "LOCATION"
			},
			{
				"name": "Miriam Hussain",
				"salience": 0.010844241,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kvhz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hussein_of_Jordan"
				},
				"name": "Hussein",
				"salience": 0.010674772,
				"type": "PERSON"
			},
			{
				"name": "threats",
				"salience": 0.010080808,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christianity",
				"salience": 0.00922345,
				"type": "OTHER"
			},
			{
				"name": "Store",
				"salience": 0.00873553,
				"type": "LOCATION"
			},
			{
				"name": "safety",
				"salience": 0.00873553,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.00873553,
				"type": "OTHER"
			},
			{
				"name": "guard",
				"salience": 0.00873553,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0076137637,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.007028811,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.006465193,
				"type": "ORGANIZATION"
			},
			{
				"name": "persecution",
				"salience": 0.005714551,
				"type": "OTHER"
			},
			{
				"name": "BNI",
				"salience": 0.0053862324,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.0053862324,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "British",
				"salience": 0.0053862324,
				"type": "LOCATION"
			},
			{
				"name": "place",
				"salience": 0.0051611005,
				"type": "OTHER"
			},
			{
				"name": "nurse",
				"salience": 0.0051474543,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03ql23",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manningham,_Bradford"
				},
				"name": "Manningham",
				"salience": 0.0048713824,
				"type": "LOCATION"
			},
			{
				"name": "culmination",
				"salience": 0.004470609,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0034782263,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0031421338,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/047jy2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Telegraph_%26_Argus"
				},
				"name": "Telegraph and Argus",
				"salience": 0.002753853,
				"type": "ORGANIZATION"
			},
			{
				"name": "surprise",
				"salience": 0.0027062753,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.002373635,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0023559027,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0023559027,
				"type": "OTHER"
			},
			{
				"name": "persecution",
				"salience": 0.0023559027,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.002314246,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0022030673,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0021273247,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0019627812,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0018422715,
				"type": "PERSON"
			},
			{
				"name": "sections",
				"salience": 0.0018422715,
				"type": "OTHER"
			},
			{
				"name": "harassment",
				"salience": 0.0018422715,
				"type": "OTHER"
			},
			{
				"name": "arrival",
				"salience": 0.0018422715,
				"type": "EVENT"
			},
			{
				"name": "stake",
				"salience": 0.0018422715,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0017883528,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.0017883528,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0134bf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Yorkshire"
				},
				"name": "West Yorkshire",
				"salience": 0.0017755429,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.0016521999,
				"type": "LOCATION"
			},
			{
				"name": "plans",
				"salience": 0.001602533,
				"type": "OTHER"
			},
			{
				"name": "belongings",
				"salience": 0.0014918373,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.0014918373,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0014883665,
				"type": "PERSON"
			},
			{
				"name": "attack",
				"salience": 0.0014600914,
				"type": "EVENT"
			},
			{
				"name": "hand",
				"salience": 0.0014361712,
				"type": "OTHER"
			},
			{
				"name": "kneecap",
				"salience": 0.0014361712,
				"type": "OTHER"
			},
			{
				"name": "troubles",
				"salience": 0.0014297588,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lz3x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Closed-circuit_television"
				},
				"name": "CCTV",
				"salience": 0.0013553838,
				"type": "OTHER"
			},
			{
				"name": "converts",
				"salience": 0.0013489102,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0012998816,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0012918719,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0012918719,
				"type": "LOCATION"
			},
			{
				"name": "pick-axe",
				"salience": 0.0012918719,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0012436619,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0012436619,
				"type": "EVENT"
			},
			{
				"name": "left",
				"salience": 0.0012436619,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0012279947,
				"type": "WORK_OF_ART"
			},
			{
				"name": "kneecap",
				"salience": 0.0012179636,
				"type": "OTHER"
			},
			{
				"name": "priority",
				"salience": 0.0011821667,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0010840958,
				"type": "PERSON"
			},
			{
				"name": "documentary",
				"salience": 0.0010546853,
				"type": "WORK_OF_ART"
			},
			{
				"name": "arm",
				"salience": 0.0010546853,
				"type": "OTHER"
			},
			{
				"name": "wife",
				"salience": 0.0010546853,
				"type": "PERSON"
			},
			{
				"name": "post-traumatic stress disorder",
				"salience": 0.0010546853,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.0010077301,
				"type": "ORGANIZATION"
			},
			{
				"name": "communities",
				"salience": 0.0010077301,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.0010025289,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0009913316,
				"type": "PERSON"
			},
			{
				"name": "Nissar",
				"salience": 0.0009791256,
				"type": "PERSON"
			},
			{
				"name": "car",
				"salience": 0.00092307036,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "place",
				"salience": 0.00090988615,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00090988615,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.00090988615,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09gbn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/West_Yorkshire_Police"
				},
				"name": "West Yorkshire Police",
				"salience": 0.00082723674,
				"type": "ORGANIZATION"
			},
			{
				"name": "St Paul's Road",
				"salience": 0.00079520565,
				"type": "LOCATION"
			},
			{
				"name": "impact",
				"salience": 0.00078788894,
				"type": "OTHER"
			},
			{
				"name": "control measures",
				"salience": 0.00078788894,
				"type": "OTHER"
			},
			{
				"name": "opportunities",
				"salience": 0.00078788894,
				"type": "OTHER"
			},
			{
				"name": "Neighbors",
				"salience": 0.00078788894,
				"type": "PERSON"
			},
			{
				"name": "haven",
				"salience": 0.00078788894,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020d8d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bradford"
				},
				"name": "Bradford",
				"salience": 0.00077529124,
				"type": "LOCATION"
			},
			{
				"name": "Leena",
				"salience": 0.0007655218,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02jx1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/England"
				},
				"name": "England",
				"salience": 0.0007655218,
				"type": "LOCATION"
			},
			{
				"name": "Issar",
				"salience": 0.0007655218,
				"type": "PERSON"
			},
			{
				"name": "Anniesa",
				"salience": 0.0007655218,
				"type": "PERSON"
			},
			{
				"name": "Kubra",
				"salience": 0.0007655218,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f15zj"
				},
				"name": "Sarah",
				"salience": 0.0007655218,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0007339534,
				"type": "ORGANIZATION"
			},
			{
				"name": "partners",
				"salience": 0.0007339534,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.0007312225,
				"type": "PERSON"
			},
			{
				"name": "spokesman",
				"salience": 0.0006853037,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/094vy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yorkshire"
				},
				"name": "Yorkshire",
				"salience": 0.00067141134,
				"type": "LOCATION"
			},
			{
				"name": "justice",
				"salience": 0.0006626809,
				"type": "OTHER"
			},
			{
				"name": "perpetrators",
				"salience": 0.0006626809,
				"type": "PERSON"
			},
			{
				"name": "lines",
				"salience": 0.0006626809,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0006626809,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w92",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Channel_4"
				},
				"name": "Channel 4",
				"salience": 0.00064917153,
				"type": "ORGANIZATION"
			},
			{
				"name": "van",
				"salience": 0.00062708894,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "benefit",
				"salience": 0.00057381764,
				"type": "OTHER"
			},
			{
				"name": "guidance",
				"salience": 0.00057381764,
				"type": "OTHER"
			},
			{
				"name": "enquiry",
				"salience": 0.00057381764,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00057381764,
				"type": "EVENT"
			},
			{
				"name": "instance",
				"salience": 0.00057381764,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.00049501815,
				"type": "OTHER"
			},
			{
				"name": "belongings",
				"salience": 0.00049501815,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00049501815,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00047440775,
				"type": "OTHER"
			},
			{
				"name": "professionalism",
				"salience": 0.00045093964,
				"type": "OTHER"
			},
			{
				"name": "incidents",
				"salience": 0.00044525627,
				"type": "EVENT"
			},
			{
				"name": "perpetrators",
				"salience": 0.00043055575,
				"type": "PERSON"
			},
			{
				"name": "none",
				"salience": 0.0004286322,
				"type": "OTHER"
			},
			{
				"name": "no-one",
				"salience": 0.0004286322,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.0004286322,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/yXGzPSX5gnM/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T06:04:28.069+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 6 2016 UK: Muslim family who converted to Christianity forced to flee Manningham home as violence and threats by Muslims against them continue to escalate A British Christian convert who said he suffered “seven years of persecution” from Muslims has been forced to flee his home under armed guard amid fears for his safety. Nissar Hussain was with his family when police arrived and moved him to a safe place. The Telegraph and Argus Mr Hussain said the culmination of the “extreme persecution” had devastated his family and the dramatic arrival of armed police was a complete surprise. “My family are distraught and extremely traumatised to be leaving,” said Mr Hussain. “But when your life is at stake there is no other choice.” Mr Hussain converted to Christianity 20 years ago, but says in recent years he has been subjected to harassment and violence by sections of the Islamic community. “This extreme persecution by certain people in the Muslim community because we are converts has broken us as a family,” he said. From left to right, Leena, Anniesa, Nissar, Sarah, Kubra, Issar, and Miriam Hussain, a Christian family who have been threatened with death for converting from Islam in West Yorkshire, England. “We are fragmented and I do not know how we will recover from this. We haven’t functioned properly for years.” He said “serious questions” needed to be answered. Last year, Mr Hussain was hospitalized after his kneecap was smashed and his hand broken during an attack outside his home in St Paul’s Road, Manningham . Two hooded men, one armed with a pick-axe handle, assaulted him in a vicious attack caught on CCTV. (See video below) At the time, Mr Hussain said he and his family were being driven out of the city and he was making plans to leave. This week he had started packing up his belongings when the police arrived on Thursday. The 50-year-old, who was a nurse before leaving work due to post-traumatic stress disorder, said his six children, aged eight to 24, and wife would never see their friends again. Nissar Hussain, 49, was hospitalised on 17 November 2015 with a smashed kneecap and broken arm after a violent attack which was captured on CCTV. He said he was attacked because he converted from Islam to Christianity and that his troubles started after he appeared on a Channel 4 documentary on how Islam converts are treated. He had been expecting an attack for some months, but when the police arrived he was “none the wiser” that he was at such serious risk. “The armed police arrived at about 3pm on Thursday,” he said. “I had been loading a van up with our belongings for eight hours, having to stealthily check no-one could see what I was doing, before they arrived. Hussein stands in front of his car that was vandalized by Muslims “It took me completely by surprise, but their [the police] professionalism was deeply reassuring, and they escorted my family and I to a safe haven outside Yorkshire.” Last night, a West Yorkshire Police spokesman said “Our priority has always been to work effectively with our partners to minimise the risk to Mr Hussain and ensure that we maximise opportunities to put control measures in place to safeguard him, his family and consider any wider impact upon the communities across West Yorkshire,” he added. Neighbors demand justice for the persecuted Hussein family “We are disappointed that Mr Hussain and his family have decided to leave Bradford, particularly as police and partners have been working together for some time to try and resolve the situation to the benefit of all parties concerned. “All the incidents reported by Mr Hussain have been recorded in line with National guidance and we continue to proactively pursue lines of enquiry to identify the perpetrators and are committed to ensuring that a thorough and effective investigation is undertaken to mitigate the threat posed in the first instance and where possible bring the perpetrators to justice.",
		"thread_title": "UK: Muslim family who converted to Christianity forced to flee Manningham home as violence and threats by Muslims against them continue to escalate",
		"title": "UK: Muslim family who converted to Christianity forced to flee Manningham home as violence and threats by Muslims against them continue to escalate",
		"type": "bs",
		"uuid": "4dd877a761fbee386b962af6b0306f6a212a15e0"
	},
	"-KhIjviSvXl795X5XxgT": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T12:29:05.427+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0kbnw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dead_Sea_Scrolls"
				},
				"name": "The dead Sea Scrolls",
				"salience": 0.2190605,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01k0p4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/State_of_Palestine"
				},
				"name": "Palestinians",
				"salience": 0.16464372,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.091514945,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.06436631,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hf8g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Temple_Mount"
				},
				"name": "Temple Mount",
				"salience": 0.038167335,
				"type": "LOCATION"
			},
			{
				"name": "Store",
				"salience": 0.032169104,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01978x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Jerusalem_Post"
				},
				"name": "The Jerusalem Post",
				"salience": 0.025114123,
				"type": "ORGANIZATION"
			},
			{
				"name": "Carmel Shama-Hacohen",
				"salience": 0.024170598,
				"type": "PERSON"
			},
			{
				"name": "origin",
				"salience": 0.021095395,
				"type": "OTHER"
			},
			{
				"name": "Muslims",
				"salience": 0.01906082,
				"type": "PERSON"
			},
			{
				"name": "straight",
				"salience": 0.01804368,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.016519913,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09k5lh3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arab_Muslims"
				},
				"name": "Arab Muslim",
				"salience": 0.015399904,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03hkp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hebrew_language"
				},
				"name": "Hebrew",
				"salience": 0.0134041365,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.01225965,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.011433589,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Muslim",
				"salience": 0.010190221,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.009010996,
				"type": "EVENT"
			},
			{
				"name": "documents",
				"salience": 0.008720467,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.007684432,
				"type": "WORK_OF_ART"
			},
			{
				"name": "documents",
				"salience": 0.0061191623,
				"type": "WORK_OF_ART"
			},
			{
				"name": "texts",
				"salience": 0.005739863,
				"type": "WORK_OF_ART"
			},
			{
				"name": "texts",
				"salience": 0.0055259527,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0430_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jerusalem"
				},
				"name": "Jerusalem",
				"salience": 0.005373072,
				"type": "LOCATION"
			},
			{
				"name": "David Koschitzky",
				"salience": 0.00530767,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02cnp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dead_Sea"
				},
				"name": "Dead Sea",
				"salience": 0.004819187,
				"type": "LOCATION"
			},
			{
				"name": "some",
				"salience": 0.0047860295,
				"type": "OTHER"
			},
			{
				"name": "copies",
				"salience": 0.0047860295,
				"type": "OTHER"
			},
			{
				"name": "northwest shore",
				"salience": 0.0047860295,
				"type": "LOCATION"
			},
			{
				"name": "finds",
				"salience": 0.0047860295,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0047860295,
				"type": "OTHER"
			},
			{
				"name": "caves",
				"salience": 0.0047860295,
				"type": "OTHER"
			},
			{
				"name": "Countries",
				"salience": 0.004607604,
				"type": "LOCATION"
			},
			{
				"name": "meeting",
				"salience": 0.0045124893,
				"type": "EVENT"
			},
			{
				"name": "evidence",
				"salience": 0.0045124893,
				"type": "OTHER"
			},
			{
				"name": "ambassador",
				"salience": 0.0045124893,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0044923583,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.004351654,
				"type": "OTHER"
			},
			{
				"name": "representatives",
				"salience": 0.004296883,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_gx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Judaism"
				},
				"name": "Judaism",
				"salience": 0.0042022252,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.003908068,
				"type": "OTHER"
			},
			{
				"name": "accusation",
				"salience": 0.0037623267,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05yg8kx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/UNESCO"
				},
				"name": "United Nations Education, Scientific and Cultural Organization",
				"salience": 0.003735387,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04s4sr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Origin_(mathematics)"
				},
				"name": "Origin",
				"salience": 0.003628308,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/039d68",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Biblical_Hebrew"
				},
				"name": "Biblical",
				"salience": 0.0034032066,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.003371919,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.003371919,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.003371919,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.003111113,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01dpz0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qumran"
				},
				"name": "Qumran",
				"salience": 0.0029472015,
				"type": "LOCATION"
			},
			{
				"name": "effort",
				"salience": 0.0029201014,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.0028833286,
				"type": "OTHER"
			},
			{
				"name": "Intergovernmental Committee for Promoting the Return of Cultural Property",
				"salience": 0.0028372547,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0j1sb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Second_Temple"
				},
				"name": "Second Temple",
				"salience": 0.002778647,
				"type": "LOCATION"
			},
			{
				"name": "land",
				"salience": 0.0027203222,
				"type": "LOCATION"
			},
			{
				"name": "attempts",
				"salience": 0.0024563,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0024563,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b37_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel_Antiquities_Authority"
				},
				"name": "Israel Antiquities Authority",
				"salience": 0.002406252,
				"type": "ORGANIZATION"
			},
			{
				"name": "proof",
				"salience": 0.0023841218,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01k1xh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Land_of_Israel"
				},
				"name": "Land of Israel",
				"salience": 0.0022991537,
				"type": "LOCATION"
			},
			{
				"name": "legitimacy",
				"salience": 0.0021270714,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0021270714,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0021270714,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0021270714,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0020323892,
				"type": "LOCATION"
			},
			{
				"name": "attempt",
				"salience": 0.0019551788,
				"type": "OTHER"
			},
			{
				"name": "committee",
				"salience": 0.0018350882,
				"type": "ORGANIZATION"
			},
			{
				"name": "connection",
				"salience": 0.0015890733,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0015890733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/088wg2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jewish_Federations_of_North_America"
				},
				"name": "UJA Federation",
				"salience": 0.0013093286,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0h7h6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toronto"
				},
				"name": "Toronto",
				"salience": 0.0013093286,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/reliability-of-the-bible-58-638.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T12:29:05.427+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 7 2016 HERE THEY GO AGAIN! Muslims trying to claim that the Hebrew-language Dead Sea Scrolls are Arab Muslim in origin So, let me get this straight. The Dead Sea Scrolls are demonstrably written in Hebrew. But the Palestinians are now saying these ancient documents are, like Jerusalem’s Temple Mount , the holiest site in Judaism, Arab Muslim in origin.That is how ridiculous the campaign to delegitimize Israel has become. Israel Today Carmel Shama-Hacohen – Israel’s ambassador to the United Nations Education, Scientific and Cultural Organization (UNESCO) – said the Palestinians raised the matter informally during a recent meeting of the Intergovernmental Committee for Promoting the Return of Cultural Property to its Countries of Origin. JERUSALEM POST The dead Sea Scrolls are about 900 documents and Biblical texts, discovered in one of the greatest archaeological finds of the 20th century in the 1940’s and 50’s in caves in and around Qumran on the northwest shore of the Dead Sea. The texts include some of the only known surviving copies of Biblical documents made before 100 B.C.E., and preserve evidence of Jewish life during the Second Temple period. According to the ambassador and to representatives of the Israel Antiquities Authority who were present at the meeting, the Palestinians intend to make a formal claim to the Dead Sea Scrolls when the committee next convenes in 2017. “This is another provocative and audacious attempt by the Palestinians to rewrite history and to erase our connection to our land,” Shama-Hacohen told The Jerusalem Post . “The Dead Sea Scrolls are factual and weighty archeological evidence of the presence of the Jewish people in the Land of Israel.” “[The accusation is] part of an ongoing effort to deny the continuous Jewish presence in Israel. The Dead Sea Scrolls provide incontrovertible proof of the historical facts that underpin the legitimacy of Israel as a Jewish state,” David Koschitzky, chairman of the UJA Federation in Toronto. “As such, they pose a threat to the ongoing attempts to obscure the unique relationship of the Jewish people with the land of Israel.",
		"thread_title": "HERE THEY GO AGAIN! Muslims trying to claim that the Hebrew-language Dead Sea Scrolls are Arab Muslim in origin",
		"title": "HERE THEY GO AGAIN! Muslims trying to claim that the Hebrew-language Dead Sea Scrolls are Arab Muslim in origin",
		"type": "bs",
		"uuid": "b5f785c03a3253c46b6e585dc2dfa7005d66ffc9"
	},
	"-KhIjvqxNAuONdQwd1RB": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-07T12:29:10.595+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "move city",
				"salience": 0.19877404,
				"type": "OTHER"
			},
			{
				"name": "@ 5",
				"salience": 0.11423136,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.073307805,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islamic",
				"salience": 0.053745877,
				"type": "OTHER"
			},
			{
				"name": "Rape",
				"salience": 0.05100938,
				"type": "EVENT"
			},
			{
				"name": "village",
				"salience": 0.048811447,
				"type": "LOCATION"
			},
			{
				"name": "tens of thousands",
				"salience": 0.039683443,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.034299552,
				"type": "PERSON"
			},
			{
				"name": "youths",
				"salience": 0.027895479,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.027895479,
				"type": "OTHER"
			},
			{
				"name": "everywhere",
				"salience": 0.027895479,
				"type": "LOCATION"
			},
			{
				"name": "mosques",
				"salience": 0.027895479,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.027895479,
				"type": "PERSON"
			},
			{
				"name": "schools",
				"salience": 0.026860218,
				"type": "ORGANIZATION"
			},
			{
				"name": "girl",
				"salience": 0.025505455,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.024742423,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wgh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morocco"
				},
				"name": "Moroccans",
				"salience": 0.02450678,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06mkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spain"
				},
				"name": "Spain",
				"salience": 0.02450678,
				"type": "LOCATION"
			},
			{
				"name": "trouble",
				"salience": 0.019964572,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/033r0s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maghrebi_Arabic"
				},
				"name": "Maghrebi",
				"salience": 0.01720883,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.017051047,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslim",
				"salience": 0.016568635,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.01588761,
				"type": "PERSON"
			},
			{
				"name": "@ 4",
				"salience": 0.014057668,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.010508637,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.009291049,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/tBJvv9WXOxQ/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-07T12:29:10.595+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Bk November 7, 2016 @ 5:00 am \nI have time thinking move city. Live in northern Spain and in recent years have been tens of thousands of Moroccans. Rape of young girls is now commonplace. The schools are filled with Muslim children, many veiled women, mosques everywhere and Maghrebi youths committing crimes. I want to go to a small traditional village where not see anything Islamic. jo503 November 7, 2016 @ 4:04 am \nPoor girl… Having a trouble in her country and fleeing it for having a better life… And then we ask ourselves why Europe is falling down… People are scared being called racist so they shut up or leave… Poor little girl…",
		"thread_title": "FRENCH COLLEGE STUDENT came to America with her family nine years ago because Europe had become too dangerous to live in because of mass Muslim migration",
		"title": "FRENCH COLLEGE STUDENT came to America with her family nine years ago because Europe had become too dangerous to live in because of mass Muslim migration",
		"type": "bs",
		"uuid": "5461d7586759014b0dc0e07a2c935413d1df0261"
	},
	"-KhIjvxUifgPftu4jzHN": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T02:20:05.497+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"name": "email",
				"salience": 0.28377226,
				"type": "OTHER"
			},
			{
				"name": "comments",
				"salience": 0.18805154,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.06426741,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.05716114,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donations",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.037259936,
				"type": "OTHER"
			},
			{
				"name": "BNI POSTS",
				"salience": 0.035996392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "DONATE",
				"salience": 0.03588462,
				"type": "OTHER"
			},
			{
				"name": "barenakedislam@gmail.com Top Posts",
				"salience": 0.03236068,
				"type": "OTHER"
			},
			{
				"name": "Payment Options",
				"salience": 0.029204627,
				"type": "OTHER"
			},
			{
				"name": "RUNNING",
				"salience": 0.028123902,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.027799565,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.02469274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "LINKS",
				"salience": 0.023880832,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"name": "notifications",
				"salience": 0.017872032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "ISLAM",
				"salience": 0.017367292,
				"type": "OTHER"
			},
			{
				"name": "Email",
				"salience": 0.01518282,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "TWITTER",
				"salience": 0.01473926,
				"type": "OTHER"
			},
			{
				"name": "email address",
				"salience": 0.011250982,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://img.youtube.com/vi/SadYtCMxnr8/0.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T02:20:05.497+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "Notify me of follow-up comments by email. Notify me of new posts by email. PLEASE DONATE TO KEEP BARE NAKED ISLAM UP AND RUNNING. Choose DONATE for one-time donation or SUBSCRIBE for monthly donations Payment Options GET ALL NEW BNI POSTS/LINKS ON TWITTER Subscribe to Blog via Email \nEnter your email address to subscribe to this blog and receive notifications of new posts by email. Email Address CONTACT: barenakedislam@gmail.com Top Posts",
		"thread_title": "MUST SEE! “Welcome to the family.” Why so many Hispanic-Americans are voting for Donald Trump",
		"title": "MUST SEE! “Welcome to the family.” Why so many Hispanic-Americans are voting for Donald Trump",
		"type": "bs",
		"uuid": "7155fa210ba77d91335ec0dec112109685124ae4"
	},
	"-KhIjwIAFlVeDRBSGCY2": {
		"author": "BareNakedIslam",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-08T02:20:05.672+02:00",
		"domain_rank": "61606",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.2468702,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.10657048,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02497z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam_in_the_United_States"
				},
				"name": "Muslim Americans",
				"salience": 0.07336642,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/014_q8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Council_on_American%E2%80%93Islamic_Relations"
				},
				"name": "Council on American Islamic Relations",
				"salience": 0.06625721,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.061961293,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.044584114,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.019945752,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.01805402,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.014502253,
				"type": "LOCATION"
			},
			{
				"name": "MUSLIM LIE",
				"salience": 0.013976493,
				"type": "ORGANIZATION"
			},
			{
				"name": "violence",
				"salience": 0.013288587,
				"type": "OTHER"
			},
			{
				"name": "inbreeding",
				"salience": 0.012899766,
				"type": "OTHER"
			},
			{
				"name": "White supremacists",
				"salience": 0.012110726,
				"type": "PERSON"
			},
			{
				"name": "Store",
				"salience": 0.012110726,
				"type": "LOCATION"
			},
			{
				"name": "The Islamic State",
				"salience": 0.010675615,
				"type": "ORGANIZATION"
			},
			{
				"name": "apostate",
				"salience": 0.00883707,
				"type": "PERSON"
			},
			{
				"name": "BNI",
				"salience": 0.0074664024,
				"type": "ORGANIZATION"
			},
			{
				"name": "lie",
				"salience": 0.007154264,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.007154264,
				"type": "PERSON"
			},
			{
				"name": "Ritz Katz",
				"salience": 0.0063979886,
				"type": "PERSON"
			},
			{
				"name": "slaughter",
				"salience": 0.006196951,
				"type": "OTHER"
			},
			{
				"name": "obfuscation",
				"salience": 0.006196951,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.006196951,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.005832907,
				"type": "ORGANIZATION"
			},
			{
				"name": "media center",
				"salience": 0.004862333,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.004520381,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0043149805,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.004283974,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hassan Shibly",
				"salience": 0.004092751,
				"type": "PERSON"
			},
			{
				"name": "Alia Salem",
				"salience": 0.004032556,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03cgq24",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Keeping_Up_with_the_Kardashians"
				},
				"name": "Kardashian",
				"salience": 0.0038170177,
				"type": "PERSON"
			},
			{
				"name": "threats",
				"salience": 0.0036761784,
				"type": "OTHER"
			},
			{
				"name": "agents",
				"salience": 0.003633556,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0029861405,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0029485393,
				"type": "OTHER"
			},
			{
				"name": "ballot boxes",
				"salience": 0.0029485393,
				"type": "OTHER"
			},
			{
				"name": "ballot boxes",
				"salience": 0.0029485393,
				"type": "OTHER"
			},
			{
				"name": "essay",
				"salience": 0.0029485393,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fact",
				"salience": 0.0029485393,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0029285513,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.002890559,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0028193062,
				"type": "EVENT"
			},
			{
				"name": "threat",
				"salience": 0.0026443556,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0025897315,
				"type": "LOCATION"
			},
			{
				"name": "Elections2016",
				"salience": 0.0025711234,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02bd3p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Dallas_Morning_News"
				},
				"name": "Dallas Morning News",
				"salience": 0.0025604353,
				"type": "ORGANIZATION"
			},
			{
				"name": "suspects",
				"salience": 0.0025534194,
				"type": "PERSON"
			},
			{
				"name": "terrorist group",
				"salience": 0.0024786822,
				"type": "ORGANIZATION"
			},
			{
				"name": "anyone",
				"salience": 0.0022735463,
				"type": "PERSON"
			},
			{
				"name": "essay",
				"salience": 0.00224491,
				"type": "WORK_OF_ART"
			},
			{
				"name": "questioning",
				"salience": 0.0022310792,
				"type": "EVENT"
			},
			{
				"name": "difference",
				"salience": 0.0022211177,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0022045162,
				"type": "EVENT"
			},
			{
				"name": "environment",
				"salience": 0.002188714,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0021795651,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0198cf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/SITE_Institute"
				},
				"name": "SITE Intelligence Group",
				"salience": 0.002176113,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.00215897,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.002094062,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reports",
				"salience": 0.0020676844,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0020676844,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.0020676844,
				"type": "OTHER"
			},
			{
				"name": "surprise visits",
				"salience": 0.0020676844,
				"type": "EVENT"
			},
			{
				"name": "agents",
				"salience": 0.0020676844,
				"type": "PERSON"
			},
			{
				"name": "Ryan Lenz",
				"salience": 0.0019859092,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0019643027,
				"type": "PERSON"
			},
			{
				"name": "offices",
				"salience": 0.0018695776,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03cbfyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rita_Katz"
				},
				"name": "Rita Katz",
				"salience": 0.0018152486,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.0017905192,
				"type": "OTHER"
			},
			{
				"name": "representatives",
				"salience": 0.0017905192,
				"type": "PERSON"
			},
			{
				"name": "drumbeat",
				"salience": 0.0017905192,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.0017236975,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.0017236975,
				"type": "OTHER"
			},
			{
				"name": "arguments",
				"salience": 0.0017236975,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0017236975,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0017236975,
				"type": "OTHER"
			},
			{
				"name": "Fusion website",
				"salience": 0.0017236975,
				"type": "OTHER"
			},
			{
				"name": "no other",
				"salience": 0.0017236975,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0017236975,
				"type": "WORK_OF_ART"
			},
			{
				"name": "calamity",
				"salience": 0.0017236975,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07kh6nt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apostasy_in_Islam"
				},
				"name": "Murtadd",
				"salience": 0.0015789517,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b_40j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Hayat"
				},
				"name": "Al Hayat",
				"salience": 0.0015719002,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01dl_x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/USA_Today"
				},
				"name": "USA Today",
				"salience": 0.0015719002,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081yw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington_(state)"
				},
				"name": "Washington State",
				"salience": 0.0015347612,
				"type": "LOCATION"
			},
			{
				"name": "militia groups",
				"salience": 0.0015118364,
				"type": "ORGANIZATION"
			},
			{
				"name": "@Rita_Katz",
				"salience": 0.0015008699,
				"type": "OTHER"
			},
			{
				"name": "equivalent",
				"salience": 0.0014617684,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0014617684,
				"type": "PERSON"
			},
			{
				"name": "abortion clinic",
				"salience": 0.0014617684,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.0013966872,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0013682497,
				"type": "LOCATION"
			},
			{
				"name": "Election Day al Qaeda",
				"salience": 0.0012727838,
				"type": "ORGANIZATION"
			},
			{
				"name": "manifesto",
				"salience": 0.0012714618,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0012610734,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.0012610734,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0012610734,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0012610734,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0012610734,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0012610734,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0012610734,
				"type": "OTHER"
			},
			{
				"name": "Muslims",
				"salience": 0.0012149906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.0011892546,
				"type": "PERSON"
			},
			{
				"name": "The Murtadd Vote",
				"salience": 0.0011795376,
				"type": "WORK_OF_ART"
			},
			{
				"name": "threats",
				"salience": 0.0011747488,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0011539581,
				"type": "OTHER"
			},
			{
				"name": "scrutiny",
				"salience": 0.0011059202,
				"type": "OTHER"
			},
			{
				"name": "fears",
				"salience": 0.0011059202,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "Islamophobic",
				"salience": 0.0011021252,
				"type": "OTHER"
			},
			{
				"name": "surge",
				"salience": 0.0010919841,
				"type": "EVENT"
			},
			{
				"name": "nationalism",
				"salience": 0.0010919841,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0010919841,
				"type": "PERSON"
			},
			{
				"name": "candidacy",
				"salience": 0.0010919841,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.0010919841,
				"type": "ORGANIZATION"
			},
			{
				"name": "resources",
				"salience": 0.0010919841,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0010609832,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0010609832,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist attacks",
				"salience": 0.0010172295,
				"type": "EVENT"
			},
			{
				"name": "ideas",
				"salience": 0.0009184462,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0009184462,
				"type": "OTHER"
			},
			{
				"name": "fringe",
				"salience": 0.0009184462,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0008997224,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.0008997224,
				"type": "LOCATION"
			},
			{
				"name": "Kansas Oklahoma",
				"salience": 0.0008997224,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0008997224,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0008997224,
				"type": "LOCATION"
			},
			{
				"name": "environment",
				"salience": 0.0008841586,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00088020886,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Allah"
				},
				"name": "Allah",
				"salience": 0.0008771881,
				"type": "PERSON"
			},
			{
				"name": "landscape",
				"salience": 0.00079528306,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.00079528306,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.00079528306,
				"type": "OTHER"
			},
			{
				"name": "radicals",
				"salience": 0.00079528306,
				"type": "PERSON"
			},
			{
				"name": "campaign season",
				"salience": 0.00079528306,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.00079528306,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d23k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Salem,_Oregon"
				},
				"name": "Salem",
				"salience": 0.00077617017,
				"type": "LOCATION"
			},
			{
				"name": "relations",
				"salience": 0.0007598663,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0006860688,
				"type": "OTHER"
			},
			{
				"name": "visits",
				"salience": 0.0006860688,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "KKK",
				"salience": 0.000672081,
				"type": "ORGANIZATION"
			},
			{
				"name": "followers",
				"salience": 0.00059405994,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.00059405994,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sweeps",
				"salience": 0.00059405994,
				"type": "OTHER"
			},
			{
				"name": "descent",
				"salience": 0.00059405994,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00059405994,
				"type": "LOCATION"
			},
			{
				"name": "all",
				"salience": 0.00057917944,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.000574446,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06rmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_Poverty_Law_Center"
				},
				"name": "Southern Poverty Law Center",
				"salience": 0.00056525896,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-American",
				"salience": 0.0004894487,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wjf0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dallas%E2%80%93Fort_Worth_metroplex"
				},
				"name": "Dallas-Fort Worth",
				"salience": 0.00036559673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05sb1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pakistan"
				},
				"name": "Pakistani",
				"salience": 0.00036559673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghani",
				"salience": 0.00036559673,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0ps53",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reuters"
				},
				"name": "Reuters",
				"salience": 0.00033031605,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.barenakedislam.com/wp-content/uploads/2016/11/isis2_110616012405.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-08T02:20:05.672+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "barenakedislam.com",
		"spam_score": "0",
		"text": "BNI Store Nov 7 2016 BIGGEST MUSLIM LIE OF THE DAY: “White supremacists are openly threatening Election Day violence…so the FBI is hassling Muslims” Is it the inbreeding? Or just that they think they can promote any fantastical lie or obfuscation and the Kardashian-worshipping American public won’t notice. It’s been reported for days that The Islamic State/al-Qaeda is calling for the “slaughter of U.S. voters” on Election Day. But that didn’t stop officials from designated terrorist group CAIR from inventing a fake potential threat against Muslims…to deflect the fact that the FBI is questioning potential terror-linked suspects in the Muslim community. USA Today Ritz Katz, director of the SITE Intelligence Group, said Saturday on Twitter that the threats appear in an essay carried by the Islamic State’s Al Hayat media center that declares militants “have come to slaughter you and smash your ballot boxes.” 3) #ISIS urges Muslims to refuse participate in #Elections2016 & to announce that they “have come to slaughter you & smash your ballot boxes” \n— Rita Katz (@Rita_Katz) November 5, 2016 “May Allah make this year’s U.S. presidential election a dreadful calamity like no other to have struck America throughout its pathetic history,” the seven-page manifesto, entitled “The Murtadd Vote ,” read. Murtadd is an apostate who turns his back on Islam. The essay, which uses lengthy religious arguments in an effort to justify such attacks, also declares there is no difference between the Republican and Democratic parties in their “policies against Islam and Muslims” In an article from the perpetually Muslim-sympathizing Fusion website: As if Muslim Americans haven’t had it hard enough during this presidential campaign—what with Donald Trump’s steady drumbeat of Islamophobic racism–now comes reports that federal agents are paying surprise visits to Muslims across the United States ahead of the November 8 election. According to officials from the Council on American Islamic Relations, representatives from the FBI have questioned Muslims living in at least eight states leading up to November 8, reportedly searching for information pertaining to a possible Election Day al Qaeda threat . Over the weekend, the designated terrorist group CAIR (Council on American Islamic Relations) received reports from Muslim-Americans in eight states, who said they were approached by FBI agents who wanted to speak to them about the alleged threat. Those states included California, Washington State, Michigan, Pennsylvania, Kansas Oklahoma, Florida and Texas. Hassan Shibly, executive director of CAIR’s Florida offices, called the reported questioning “completely outrageous,” and “borderline unconstitutional,” telling the Washington Post : “That’s the equivalent of the FBI visiting churchgoing Christians because someone overseas was threatening to blow up an abortion clinic. It’s that preposterous and outrageous.” The people who were interviewed this weekend were asked if they knew anyone who might want to harm Americans at home or abroad. Shibly said all of those interviewed appeared to be of Afghani or Pakistani descent. Shibly says such sweeps are dangerous to Muslim-American relations.’Unfortunately we’re dealing with an environment that’s not very friendly to American Muslims,’ he said. ‘The environment is very hostile to the American Muslim community.’ On Twitter, CAIR’s Dallas-Fort Worth director Alia Salem posted a short video updating her followers about the FBI visits, and offering a series of resources for anyone approached by law enforcement. “It was made apparent to us that the FBI has a list of a couple hundred people they are wanting to visit,” Salem told the Dallas Morning News . “And ask a series of eight generic questions intended to drum up information about the attacks.” The FBI’s sudden scrutiny of Muslim Americans comes as the United States is experiencing a surge in white nationalism and militia groups , fueled in no small part by Donald Trump’s KKK-backed candidacy . Militant Trump supporters have, in fact, explicitly stoked fears of violence come Election Day. (But it’s Muslims who actually carry out terrorist attacks on Americans) “Prior to this campaign season, these ideas were relegated to sort of the political fringe of the American political landscape,” Ryan Lenz, a researcher at the anti-American, Muslim-funded Southern Poverty Law Center told Reuters . “Now these ideas are legitimized.” Perhaps while the FBI is questioning Muslim Americans over vague international threats, they should check in with some of the no-longer-fringe radicals on America’s far right wing, too.",
		"thread_title": "BIGGEST MUSLIM LIE OF THE DAY: “White supremacists are openly threatening Election Day violence…so the FBI is hassling Muslims”",
		"title": "BIGGEST MUSLIM LIE OF THE DAY: “White supremacists are openly threatening Election Day violence…so the FBI is hassling Muslims”",
		"type": "bs",
		"uuid": "332bca9e507ddbac93812ae7f5d4df46257d1257"
	},
	"-KhIjwWOAQC8xOFVfwyW": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:56:40.558+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.16693024,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0865283,
				"type": "OTHER"
			},
			{
				"name": "allergies",
				"salience": 0.07883521,
				"type": "OTHER"
			},
			{
				"name": "dose",
				"salience": 0.050407093,
				"type": "OTHER"
			},
			{
				"name": "doses",
				"salience": 0.040216174,
				"type": "OTHER"
			},
			{
				"name": "medication",
				"salience": 0.03820303,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YOUTUBE",
				"salience": 0.033872284,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.01905721,
				"type": "OTHER"
			},
			{
				"name": "diseases",
				"salience": 0.018746732,
				"type": "OTHER"
			},
			{
				"name": "medication",
				"salience": 0.018746732,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "government",
				"salience": 0.018746732,
				"type": "ORGANIZATION"
			},
			{
				"name": "breakthrough",
				"salience": 0.017521085,
				"type": "OTHER"
			},
			{
				"name": "success stories",
				"salience": 0.01624192,
				"type": "WORK_OF_ART"
			},
			{
				"name": "government organizations",
				"salience": 0.01624192,
				"type": "ORGANIZATION"
			},
			{
				"name": "sorts",
				"salience": 0.01624192,
				"type": "OTHER"
			},
			{
				"name": "ailments",
				"salience": 0.01624192,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.01624192,
				"type": "LOCATION"
			},
			{
				"name": "results",
				"salience": 0.01624192,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.015066647,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.013691649,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.011419933,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/032mx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Food_and_Drug_Administration"
				},
				"name": "FDA",
				"salience": 0.010009879,
				"type": "ORGANIZATION"
			},
			{
				"name": "difference",
				"salience": 0.008564378,
				"type": "OTHER"
			},
			{
				"name": "feature video",
				"salience": 0.008564378,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Prodovite",
				"salience": 0.008469665,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.008390261,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.008307199,
				"type": "OTHER"
			},
			{
				"name": "allergies",
				"salience": 0.0073263226,
				"type": "OTHER"
			},
			{
				"name": "allergies",
				"salience": 0.0073263226,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.006698186,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.006007451,
				"type": "WORK_OF_ART"
			},
			{
				"name": "allergies",
				"salience": 0.005982331,
				"type": "OTHER"
			},
			{
				"name": "food allergies",
				"salience": 0.005982331,
				"type": "OTHER"
			},
			{
				"name": "VIDEO",
				"salience": 0.005783415,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mold problem",
				"salience": 0.005222293,
				"type": "OTHER"
			},
			{
				"name": "Diseases",
				"salience": 0.005222293,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01m748",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Subscription_business_model"
				},
				"name": "SUBSCRIBE",
				"salience": 0.004866584,
				"type": "OTHER"
			},
			{
				"name": "LYN LEAHZ",
				"salience": 0.004866584,
				"type": "PERSON"
			},
			{
				"name": "gentleman",
				"salience": 0.004697781,
				"type": "PERSON"
			},
			{
				"name": "words",
				"salience": 0.004697781,
				"type": "OTHER"
			},
			{
				"name": "prison",
				"salience": 0.004697781,
				"type": "LOCATION"
			},
			{
				"name": "difference",
				"salience": 0.0045459843,
				"type": "OTHER"
			},
			{
				"name": "Cancer",
				"salience": 0.0045225327,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.0045225327,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0045225327,
				"type": "LOCATION"
			},
			{
				"name": "Sickness",
				"salience": 0.0045225327,
				"type": "OTHER"
			},
			{
				"name": "blessing",
				"salience": 0.0045225327,
				"type": "OTHER"
			},
			{
				"name": "Discovery",
				"salience": 0.0045225327,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0044291154,
				"type": "OTHER"
			},
			{
				"name": "dose",
				"salience": 0.004074124,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.003966864,
				"type": "PERSON"
			},
			{
				"name": "vision",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "feeling",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "glands",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "ears",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "light headedness",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "dizziness",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "disturbances",
				"salience": 0.0038355377,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0037395272,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0036924263,
				"type": "OTHER"
			},
			{
				"name": "fatigue",
				"salience": 0.0035098754,
				"type": "OTHER"
			},
			{
				"name": "symptoms",
				"salience": 0.0035098754,
				"type": "OTHER"
			},
			{
				"name": "Glen",
				"salience": 0.0033398108,
				"type": "LOCATION"
			},
			{
				"name": "Brand New",
				"salience": 0.0032151814,
				"type": "ORGANIZATION"
			},
			{
				"name": "product",
				"salience": 0.002889448,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "suffering",
				"salience": 0.0028655117,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0026778001,
				"type": "PERSON"
			},
			{
				"name": "ingredients",
				"salience": 0.0026221587,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k5b5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BP"
				},
				"name": "BP",
				"salience": 0.0023610992,
				"type": "ORGANIZATION"
			},
			{
				"name": "everyone",
				"salience": 0.0021585673,
				"type": "PERSON"
			},
			{
				"name": "CEO",
				"salience": 0.0020870757,
				"type": "PERSON"
			},
			{
				"name": "founder",
				"salience": 0.0020870757,
				"type": "PERSON"
			},
			{
				"name": "post",
				"salience": 0.0020870757,
				"type": "WORK_OF_ART"
			},
			{
				"name": "formulator",
				"salience": 0.0020870757,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0020870757,
				"type": "OTHER"
			},
			{
				"name": "Glen",
				"salience": 0.0020369266,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.002009171,
				"type": "OTHER"
			},
			{
				"name": "blood analysis example",
				"salience": 0.001983854,
				"type": "OTHER"
			},
			{
				"name": "smells",
				"salience": 0.0016195362,
				"type": "OTHER"
			},
			{
				"name": "hangover",
				"salience": 0.0015590767,
				"type": "EVENT"
			},
			{
				"name": "fog",
				"salience": 0.0015590767,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0015590767,
				"type": "PERSON"
			},
			{
				"name": "difference",
				"salience": 0.0014708767,
				"type": "OTHER"
			},
			{
				"name": "Bill Downs",
				"salience": 0.0012845626,
				"type": "PERSON"
			},
			{
				"name": "Blood Analysis Audio",
				"salience": 0.0012252245,
				"type": "OTHER"
			},
			{
				"name": "testimonials",
				"salience": 0.0008810408,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "95",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/238056/images/sciencespace.jpg",
		"ord_in_thread": "0",
		"participants_count": "5",
		"published": "2016-10-26T17:07:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 11.4,
			"score": 0.1
		},
		"shares": "95",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.022",
		"text": "(Before It's News)\nAn absolutely must-see! This is something that the FDA and government organizations does not want you to know about. This new scientific breakthrough has been proven to healall sorts of diseases and ailments, including ones that have been deemed ‘incurable’. The results and success stories are out of this world.\nOur government wants to keep you sick so that you are dependent upon medication after medication, which just makes you sicker.\nCheck out this feature video. I have been on it now for less than one week and am already noticing a huge difference. I’ve also only been taking small doses as opposed to the full dose to start out with. But, if small doses is making changes in me, I can only imagine what will happen when I start taking the full amount. I am literally excited!\nFEATURE VIDEO Brand New Shocking Discovery-People Cured of Cancer, Sickness & Fatal Diseases! MUST SEE!\nCHECK OUT LYN LEAHZ ON YOUTUBE AND SUBSCRIBE TODAY—CLICK HERE NOW! After being sick for many years with ‘strange’ allergies, which all began after living in a home with a hidden mold problem, I can’t tell you how thankful I am and what a blessing it is that God has led me to Glen, the gentleman in the video. It is wonderful beyond words to actually feel ‘normal’ again after having felt sick, tired, and practically living in a prison to my allergies for many years now.\nFor many years now, I have lived with allergies so bad, not only did I feel like I had a cold 24-7, but I had other strange symptoms too:\n—extreme fatigue\n—sudden visual disturbances or double vision\n—dizziness\n—light headedness\n—problems hearing, ringing in the ears\n—swelling in my face\n—swollen glands\n—constant food allergies\n—allergies to just about everything, including smells\n—just an overall not feeling right, you can’t really put your finger on it, but you just don’t feel good\n—constant excessively low BP and feeling as if I am about to pass out at times\n—feeling like I am in a fog\n—unmovitvated\n—not feeling good when I would wake up in the morning, like a person having a massive hangover\nThere is so much more… but I have literally lived this way since around 2004 until now, and this is the first thing that has really helped to make a difference. I will keep everyone updated, as I have not yet tried the full dose. But so far, the low dose is really making a difference. I was told by Glen to start off small due to the strange allergies. So that is what I’ve been doing.\nI really want to share this with everyone because I understand how frustrating life is when you don’t feel good, especially when no one gives you answers for your suffering and you have no idea what to do to fix it or make yourself feel better. It’s extremely depressing. I strongly urge everyone to share this post and to try this product. God bless you!\nCHECK OUT LYN LEAHZ ON YOUTUBE AND SUBSCRIBE TODAY—CLICK HERE NOW! Don’t believe it? See this blood analysis example:\nProdovite Blood Analysis\nAudio of Bill Downs, CEO, founder and formulator of Prodovite explaining the ingredients of Prodovite as well as other information, including testimonials",
		"thread_title": "Experts Speechless! Numerous People Miraculously Relieved of Serious Illness & Fatal Diseases-Must See! (Video) | Alternative",
		"title": "Experts Speechless! Numerous People Miraculously Relieved of Serious Illness & Fatal Diseases-Must See! (Video) | Alternative",
		"type": "bs",
		"uuid": "12a91dfc4d932f3b183c18e412c943fe25c94502"
	},
	"-KhIjwbvjtFJ1bxZTkLo": {
		"author": "AmbrociousXP",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:56:40.601+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "ingredients",
				"salience": 0.3021248,
				"type": "OTHER"
			},
			{
				"name": "http://www.vniinc.com/media/docs/prodovite_label.pdf",
				"salience": 0.3021248,
				"type": "OTHER"
			},
			{
				"name": "supplement",
				"salience": 0.13135053,
				"type": "OTHER"
			},
			{
				"name": "servings",
				"salience": 0.1213153,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hm4_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greed"
				},
				"name": "GREED",
				"salience": 0.07291075,
				"type": "OTHER"
			},
			{
				"name": "bottle",
				"salience": 0.053535484,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bottle",
				"salience": 0.016638342,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/238056/images/sciencespace.jpg",
		"ord_in_thread": "1",
		"participants_count": "5",
		"published": "2016-10-26T18:11:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 2.4,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.022",
		"text": "Judging by the ingredients ( http://www.vniinc.com/media/docs/prodovite_label.pdf ) I can say that it seems like a pretty healthy supplement.\nBUT….for 30 servings in one bottle that costs $85 freaking dollars, I could NEVER NEVER NEVER afford to buy this and respect myself afterwards. If this bottle was dropped down to maybe $35 or $40 then I would be willing to buy it.\nGREED is a real problem.",
		"thread_title": "Experts Speechless! Numerous People Miraculously Relieved of Serious Illness & Fatal Diseases-Must See! (Video) | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "03df1111ec954d6128a020adf81440b8443ca73c"
	},
	"-KhIjwgg74ViOfInvvp3": {
		"author": "Lyn Leahz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:56:40.794+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "Glen",
				"salience": 0.6346553,
				"type": "PERSON"
			},
			{
				"name": "link",
				"salience": 0.10842551,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.08906963,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.05430377,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.025234757,
				"type": "OTHER"
			},
			{
				"name": "Blessings",
				"salience": 0.018950233,
				"type": "OTHER"
			},
			{
				"name": "discounts",
				"salience": 0.016165113,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.014552216,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.01372514,
				"type": "OTHER"
			},
			{
				"name": "link",
				"salience": 0.0079785455,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.0064888136,
				"type": "OTHER"
			},
			{
				"name": "discounts",
				"salience": 0.005600122,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0048508407,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/238056/images/sciencespace.jpg",
		"ord_in_thread": "2",
		"participants_count": "5",
		"published": "2016-10-26T18:18:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 2.5,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.022",
		"text": "Maybe people should use the link I gave and talk to Glen first. It doesn’t cost that much if they talk to Glen. He is giving huge discounts through me on every order. Blessings! http://prodovite.biz and Glen gives his number, several numbers, where he can be reached in the video. Again, huge discounts and it’s not as expensive as what you are seeing there. That is a different link than I gave. Thanks!",
		"thread_title": "Experts Speechless! Numerous People Miraculously Relieved of Serious Illness & Fatal Diseases-Must See! (Video) | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "7d5a96bf217b9b0b1152b6fddce17a15e3452b7d"
	},
	"-KhIjwtJyvjep_4QVuqN": {
		"author": "Morgana Le Fay",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:56:40.945+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "ingredients",
				"salience": 0.46113646,
				"type": "OTHER"
			},
			{
				"name": "ingredients",
				"salience": 0.14287996,
				"type": "OTHER"
			},
			{
				"name": "multivitamins",
				"salience": 0.119693324,
				"type": "OTHER"
			},
			{
				"name": "ratios",
				"salience": 0.10188496,
				"type": "OTHER"
			},
			{
				"name": "price",
				"salience": 0.07651543,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.055964112,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.041925754,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/238056/images/sciencespace.jpg",
		"ord_in_thread": "3",
		"participants_count": "5",
		"published": "2016-10-26T18:32:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.1,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.022",
		"text": "Agreed. The ingredients are decent, but there are other organic multivitamins out there with comparable ingredients and ratios for a lot less money. The price for this a way too exorbitant.",
		"thread_title": "Experts Speechless! Numerous People Miraculously Relieved of Serious Illness & Fatal Diseases-Must See! (Video) | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "676d0e689a01204c46ac752f0f9388dee9b42acc"
	},
	"-KhIjx0Xmq8UBdvyZcN0": {
		"author": "Lyn Leahz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:56:41.043+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "Lisa Haven",
				"salience": 0.27931097,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.2649543,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0496404,
				"type": "PERSON"
			},
			{
				"name": "problems",
				"salience": 0.04546552,
				"type": "OTHER"
			},
			{
				"name": "avail",
				"salience": 0.04546552,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.03942122,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.032231957,
				"type": "PERSON"
			},
			{
				"name": "avail",
				"salience": 0.030784776,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.030784776,
				"type": "OTHER"
			},
			{
				"name": "illness",
				"salience": 0.02770877,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.027018795,
				"type": "OTHER"
			},
			{
				"name": "diseases",
				"salience": 0.026680237,
				"type": "OTHER"
			},
			{
				"name": "blood loss",
				"salience": 0.02264444,
				"type": "OTHER"
			},
			{
				"name": "dementia",
				"salience": 0.02264444,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.021802954,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.015182038,
				"type": "PERSON"
			},
			{
				"name": "cancers",
				"salience": 0.010653735,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.007605159,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/238056/images/sciencespace.jpg",
		"ord_in_thread": "4",
		"participants_count": "5",
		"published": "2016-10-26T18:38:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 5.5,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.022",
		"text": "Yes, but the problem is, they don’t work. I have tried literally just about everything for my problems to no avail. Furthermore, so have many people with cancer and other incurable diseases to no avail. But this stuff really works. It cured Lisa Haven of a lifelong illness she has had to do with blood loss, cured her father of dementia, and is working for me. It also has cured people with cancers, etc. Don’t knock it until you try it – do as you wish, but all I can say is that I am EXTREMELY happy that I tried it. It’s working! God bless.",
		"thread_title": "Experts Speechless! Numerous People Miraculously Relieved of Serious Illness & Fatal Diseases-Must See! (Video) | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "005b22eed94b4f621da0b72c805f94ba9a528e97"
	},
	"-KhIjxAmKHLvRaFNt4Mc": {
		"author": "PaulTarsuss",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:56:41.069+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "GREED fest",
				"salience": 0.26802814,
				"type": "WORK_OF_ART"
			},
			{
				"name": "GREED",
				"salience": 0.10666498,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.09604209,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.07715607,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.04320444,
				"type": "OTHER"
			},
			{
				"name": "makers",
				"salience": 0.038357496,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.03795592,
				"type": "PERSON"
			},
			{
				"name": "gouging exploits",
				"salience": 0.037483584,
				"type": "OTHER"
			},
			{
				"name": "Miraculous Healing in Jesus Name",
				"salience": 0.026104107,
				"type": "OTHER"
			},
			{
				"name": "minerals",
				"salience": 0.023699708,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.015540257,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.015540257,
				"type": "PERSON"
			},
			{
				"name": "fruits",
				"salience": 0.010911308,
				"type": "OTHER"
			},
			{
				"name": "science",
				"salience": 0.010911308,
				"type": "OTHER"
			},
			{
				"name": "nutrition",
				"salience": 0.010911308,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.010774261,
				"type": "OTHER"
			},
			{
				"name": "shark tank",
				"salience": 0.010505292,
				"type": "OTHER"
			},
			{
				"name": "dollar",
				"salience": 0.010288829,
				"type": "OTHER"
			},
			{
				"name": "providite makers",
				"salience": 0.009008156,
				"type": "PERSON"
			},
			{
				"name": "structure",
				"salience": 0.008912893,
				"type": "OTHER"
			},
			{
				"name": "FAITH",
				"salience": 0.008912893,
				"type": "OTHER"
			},
			{
				"name": "pennies",
				"salience": 0.008912893,
				"type": "OTHER"
			},
			{
				"name": "concoction",
				"salience": 0.008912893,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.008912893,
				"type": "OTHER"
			},
			{
				"name": "WISE",
				"salience": 0.008261466,
				"type": "OTHER"
			},
			{
				"name": "tax",
				"salience": 0.007691809,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.007691809,
				"type": "OTHER"
			},
			{
				"name": "equivalent",
				"salience": 0.0070976284,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.006662376,
				"type": "OTHER"
			},
			{
				"name": "tax rate",
				"salience": 0.006662376,
				"type": "OTHER"
			},
			{
				"name": "distributors",
				"salience": 0.006662376,
				"type": "ORGANIZATION"
			},
			{
				"name": "sums",
				"salience": 0.006662376,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "youtube",
				"salience": 0.0064735753,
				"type": "OTHER"
			},
			{
				"name": "https://www.youtube.com/watch?v=FL6AMBZfno0 Type",
				"salience": 0.005850039,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.004916478,
				"type": "OTHER"
			},
			{
				"name": "Blessings",
				"salience": 0.0048546004,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.003627526,
				"type": "OTHER"
			},
			{
				"name": "Truth",
				"salience": 0.003627526,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.003627526,
				"type": "OTHER"
			},
			{
				"name": "Yeshua",
				"salience": 0.0029892675,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/045m1_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jesus"
				},
				"name": "Jesus Christ",
				"salience": 0.0029892675,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/238056/images/sciencespace.jpg",
		"ord_in_thread": "5",
		"participants_count": "5",
		"published": "2016-10-26T18:42:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 5.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.022",
		"text": "Amen!\nGREED is a very real problem. So much so, that many an otherwise logical person will support such gouging exploits.\nI DARE the makers of ‘provodite’ to release their cost of production. Look….people aren’t afraid to do it on the GREED fest that is the TV show, “shark tank” all the time…\nhttps://www.youtube.com/watch?v=FL6AMBZfno0\nType in the phrase, “Miraculous Healing in Jesus Name” on youtube and see how God REALLY works. He doesn’t need the financial fruits of nutrition ‘science’ to get it done.\nAnd He doesn’t require many dollars for a concoction of minerals that cost pennies on the dollar to produce.\nEven water itself changes in molecular structure by FAITH….\nhttps://www.youtube.com/watch?v=PDW9Lqj8hmc\nThere are those who are always seeking, yet never able to come to an accurate knowledge of the Truth.\nPaying providite makers and their network of distributors exorbitant sums of money to obtain health is the equivalent of paying the “stupid tax” at a VERY high tax rate.\nBe WISE. Eat right. Play right, and PRAY right and often….\nAnd everything will work out right.\nBlessings in Yeshua, Jesus Christ",
		"thread_title": "Experts Speechless! Numerous People Miraculously Relieved of Serious Illness & Fatal Diseases-Must See! (Video) | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "6ed55b50c79bf7f6831feba62eb6f7cf2c35b04a"
	},
	"-KhIjxLbM0XFbjV5Sdr_": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:56:51.376+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0lz3x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Closed-circuit_television"
				},
				"name": "CCTV",
				"salience": 0.3343632,
				"type": "OTHER"
			},
			{
				"name": "Woodbank Valley Urban Farm",
				"salience": 0.062201463,
				"type": "LOCATION"
			},
			{
				"name": "farms",
				"salience": 0.051796734,
				"type": "LOCATION"
			},
			{
				"name": "farming",
				"salience": 0.038951762,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k33p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Birmingham"
				},
				"name": "Birmingham",
				"salience": 0.03546065,
				"type": "LOCATION"
			},
			{
				"name": "Michael Hardman",
				"salience": 0.03029443,
				"type": "PERSON"
			},
			{
				"name": "capacity",
				"salience": 0.029480565,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.029480565,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.029480565,
				"type": "OTHER"
			},
			{
				"name": "Many",
				"salience": 0.026348408,
				"type": "PERSON"
			},
			{
				"name": "food miles",
				"salience": 0.020731773,
				"type": "OTHER"
			},
			{
				"name": "farms",
				"salience": 0.017722353,
				"type": "LOCATION"
			},
			{
				"name": "farms",
				"salience": 0.015139859,
				"type": "ORGANIZATION"
			},
			{
				"name": "farming",
				"salience": 0.014577413,
				"type": "OTHER"
			},
			{
				"name": "Geography",
				"salience": 0.012205627,
				"type": "OTHER"
			},
			{
				"name": "neighbourhood",
				"salience": 0.012205627,
				"type": "LOCATION"
			},
			{
				"name": "projects",
				"salience": 0.012205627,
				"type": "OTHER"
			},
			{
				"name": "farms",
				"salience": 0.009979416,
				"type": "LOCATION"
			},
			{
				"name": "food",
				"salience": 0.009890091,
				"type": "OTHER"
			},
			{
				"name": "networking",
				"salience": 0.008944848,
				"type": "OTHER"
			},
			{
				"name": "health",
				"salience": 0.008567493,
				"type": "OTHER"
			},
			{
				"name": "city-dwellers",
				"salience": 0.008567493,
				"type": "PERSON"
			},
			{
				"name": "well-being",
				"salience": 0.008567493,
				"type": "OTHER"
			},
			{
				"name": "cultures",
				"salience": 0.008567493,
				"type": "OTHER"
			},
			{
				"name": "incubator",
				"salience": 0.008567493,
				"type": "OTHER"
			},
			{
				"name": "positives",
				"salience": 0.008353482,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.008248484,
				"type": "OTHER"
			},
			{
				"name": "spaces",
				"salience": 0.008248484,
				"type": "OTHER"
			},
			{
				"name": "Excerpt",
				"salience": 0.008248484,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state",
				"salience": 0.008248484,
				"type": "LOCATION"
			},
			{
				"name": "barriers",
				"salience": 0.008248484,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.008078414,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.007742905,
				"type": "OTHER"
			},
			{
				"name": "University of Salford The Conversation",
				"salience": 0.007523588,
				"type": "ORGANIZATION"
			},
			{
				"name": "diets",
				"salience": 0.0069974805,
				"type": "OTHER"
			},
			{
				"name": "sites",
				"salience": 0.0069974805,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.006909484,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0067367884,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.006485786,
				"type": "WORK_OF_ART"
			},
			{
				"name": "communities",
				"salience": 0.00643289,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.006038354,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0856n7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Community_gardening"
				},
				"name": "Community Gardens",
				"salience": 0.004310165,
				"type": "LOCATION"
			},
			{
				"name": "The Federation of City Farms",
				"salience": 0.004310165,
				"type": "ORGANIZATION"
			},
			{
				"name": "scale",
				"salience": 0.003810369,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.003810369,
				"type": "LOCATION"
			},
			{
				"name": "network",
				"salience": 0.00364085,
				"type": "OTHER"
			},
			{
				"name": "network",
				"salience": 0.00364085,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.002847023,
				"type": "OTHER"
			},
			{
				"name": "locals",
				"salience": 0.002847023,
				"type": "PERSON"
			},
			{
				"name": "few",
				"salience": 0.002847023,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.002346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.0017526457,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.cityfarmer.info/wp-content/uploads/2016/10/woolg.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:46:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nCCTV at Woodbank Valley Urban Farm, Birmingham.\nThe capacity of urban farms to tackle major issues such as poverty and reducing food miles should not be underestimated, and with more ambitious projects starting up every day, it might not be long until you see one appearing in your neighbourhood.\nBy Michael Hardman\nLecturer in Geography, University of Salford\nThe Conversation\nOct 26, 2016\nExcerpt:\nDespite these barriers, our 2016 study into the state of urban farming showed that huge positives can come out of these spaces. For example, urban farms often act as a social incubator, bringing together communities and connecting cultures. Many also impact significantly on health and well-being, allowing city-dwellers to access fresh food and sometimes even supplement diets.\nWe found that those connected to The Federation of City Farms and Community Gardens were strongest. They gained value from the networking with other such sites across the UK.\nA few in this extensive network have existed for over 30 years, and are still going due to the excellent support from both locals and the wider network. Ultimately, the idea of urban farming is not to replace traditional rural farms, but rather to complement and add value.\nTo push forward with urban farming, there’s a need to build on what works – in particular, to learn from urban farms in the US, which are expanding and are on a different scale entirely to anywhere else.\nRead the complete article here.",
		"thread_title": "Urban farms won’t feed our cities, but they’re still a great idea – here’s why | Food and Farming",
		"title": "Urban farms won’t feed our cities, but they’re still a great idea – here’s why | Food and Farming",
		"type": "bs",
		"uuid": "af1179a7f6ee14f752c799dfe7e8f8effc4bbed4"
	},
	"-KhIjxUbAds09F1vNXLS": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:56:58.293+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "need",
				"salience": 0.45866418,
				"type": "OTHER"
			},
			{
				"name": "Galbraith Last",
				"salience": 0.04278672,
				"type": "OTHER"
			},
			{
				"name": "mind",
				"salience": 0.03369564,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.03369564,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.03369564,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.03369564,
				"type": "OTHER"
			},
			{
				"name": "simulations",
				"salience": 0.02684181,
				"type": "OTHER"
			},
			{
				"name": "dark matter",
				"salience": 0.012199318,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0djgt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jammu_and_Kashmir"
				},
				"name": "J.K.",
				"salience": 0.010700934,
				"type": "PERSON"
			},
			{
				"name": "simulations",
				"salience": 0.0105709955,
				"type": "OTHER"
			},
			{
				"name": "scales",
				"salience": 0.009159077,
				"type": "OTHER"
			},
			{
				"name": "dark matter simulations",
				"salience": 0.009084525,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.008566515,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.008272767,
				"type": "OTHER"
			},
			{
				"name": "galaxies",
				"salience": 0.0082168365,
				"type": "OTHER"
			},
			{
				"name": "galaxies",
				"salience": 0.007911115,
				"type": "OTHER"
			},
			{
				"name": "galaxies",
				"salience": 0.007911115,
				"type": "OTHER"
			},
			{
				"name": "result",
				"salience": 0.0076190718,
				"type": "OTHER"
			},
			{
				"name": "successes",
				"salience": 0.007166774,
				"type": "OTHER"
			},
			{
				"name": "rotation observations",
				"salience": 0.007166774,
				"type": "OTHER"
			},
			{
				"name": "galaxy clusters",
				"salience": 0.007166774,
				"type": "OTHER"
			},
			{
				"name": "high",
				"salience": 0.007166774,
				"type": "OTHER"
			},
			{
				"name": "others",
				"salience": 0.007166774,
				"type": "OTHER"
			},
			{
				"name": "lensing",
				"salience": 0.007166774,
				"type": "OTHER"
			},
			{
				"name": "Galaxies",
				"salience": 0.0067120474,
				"type": "OTHER"
			},
			{
				"name": "web",
				"salience": 0.0066001997,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0115nj7p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Illustris_project"
				},
				"name": "Illustris Simulation",
				"salience": 0.0064382046,
				"type": "OTHER"
			},
			{
				"name": "acceleration",
				"salience": 0.0064288713,
				"type": "OTHER"
			},
			{
				"name": "acceleration",
				"salience": 0.0061894795,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0061894795,
				"type": "OTHER"
			},
			{
				"name": "Image credit",
				"salience": 0.0058060363,
				"type": "OTHER"
			},
			{
				"name": "simulations",
				"salience": 0.0056902636,
				"type": "OTHER"
			},
			{
				"name": "scientists",
				"salience": 0.005589776,
				"type": "PERSON"
			},
			{
				"name": "Radial Acceleration Relation",
				"salience": 0.0052507105,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0052312133,
				"type": "OTHER"
			},
			{
				"name": "dark matter",
				"salience": 0.0052312133,
				"type": "OTHER"
			},
			{
				"name": "show",
				"salience": 0.005029041,
				"type": "WORK_OF_ART"
			},
			{
				"name": "data",
				"salience": 0.005029041,
				"type": "OTHER"
			},
			{
				"name": "assembly",
				"salience": 0.005029041,
				"type": "EVENT"
			},
			{
				"name": "x-axis",
				"salience": 0.005029041,
				"type": "OTHER"
			},
			{
				"name": "y-axis",
				"salience": 0.005029041,
				"type": "OTHER"
			},
			{
				"name": "galaxies",
				"salience": 0.005017358,
				"type": "OTHER"
			},
			{
				"name": "correlation",
				"salience": 0.004841656,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.004841656,
				"type": "OTHER"
			},
			{
				"name": "team",
				"salience": 0.004841656,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/022sf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cosmic_microwave_background"
				},
				"name": "CMB",
				"salience": 0.0044158925,
				"type": "ORGANIZATION"
			},
			{
				"name": "galaxy",
				"salience": 0.0043102396,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0042850343,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.004212251,
				"type": "OTHER"
			},
			{
				"name": "relation",
				"salience": 0.003924304,
				"type": "OTHER"
			},
			{
				"name": "dark matter",
				"salience": 0.003578037,
				"type": "OTHER"
			},
			{
				"name": "dark matter camp",
				"salience": 0.003499108,
				"type": "EVENT"
			},
			{
				"name": "gravity camp",
				"salience": 0.003499108,
				"type": "EVENT"
			},
			{
				"name": "scientists",
				"salience": 0.0034327137,
				"type": "PERSON"
			},
			{
				"name": "structure formation",
				"salience": 0.0033113963,
				"type": "OTHER"
			},
			{
				"name": "purple",
				"salience": 0.0030690334,
				"type": "OTHER"
			},
			{
				"name": "feedback",
				"salience": 0.0030690334,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0030690334,
				"type": "OTHER"
			},
			{
				"name": "scales",
				"salience": 0.0028591312,
				"type": "OTHER"
			},
			{
				"name": "bazooka",
				"salience": 0.002669776,
				"type": "OTHER"
			},
			{
				"name": "Jim Schombert",
				"salience": 0.002529127,
				"type": "PERSON"
			},
			{
				"name": "Federico Lelli",
				"salience": 0.002529127,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06zp6vg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stacy_McGaugh"
				},
				"name": "Stacy McGaugh",
				"salience": 0.002529127,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.0024431616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "gauntlet",
				"salience": 0.002235762,
				"type": "OTHER"
			},
			{
				"name": "gunfight",
				"salience": 0.002235762,
				"type": "PERSON"
			},
			{
				"name": "challenge",
				"salience": 0.0020720486,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0017572608,
				"type": "OTHER"
			},
			{
				"name": "paper",
				"salience": 0.0016703772,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Illustris Collaboration",
				"salience": 0.0013763641,
				"type": "OTHER"
			},
			{
				"name": "James Wadsley",
				"salience": 0.0010282008,
				"type": "PERSON"
			},
			{
				"name": "Ben Keller",
				"salience": 0.0010282008,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01y8zd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McMaster_University"
				},
				"name": "McMaster University",
				"salience": 0.0010282008,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://scienceblogs.com/startswithabang/files/2016/10/rotationcurves1-1200x1500-600x750.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T15:17:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.6,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\n“Faced with the choice between changing one’s mind and proving that there is no need to do so, almost everybody gets busy on the proof.” -J. K. Galbraith\nLast month, tensions between dark matter simulations and galactic rotation observations reached a new high. Despite all the successes of dark matter on the largest scales — for the CMB, for large-scale structure, for gravitational lensing and for galaxy clusters, among others — the simplest dark matter simulations reproduced unrealistic results for how individual galaxies ought to rotate. Moreover, a team of scientists uncovered a surprising relationship: between the normal (baryonic) matter alone and the observed acceleration in galaxies.\nThe correlation between gravitational acceleration (y-axis) and the normal, baryonic matter (x-axis) visible in an assembly of 153 galaxies. The blue points show each individual galaxy, while the red show binned data. Image credit: The Radial Acceleration Relation in Rotationally Supported Galaxies, Stacy McGaugh, Federico Lelli and Jim Schombert, 2016. From https://arxiv.org/pdf/1609.05917v1.pdf.\nIf dark matter were real, then the simulations needed to reproduce that result as well, which appeared to be a tremendous challenge. Yet in a new paper, two scientists from McMaster University, Ben Keller and James Wadsley, did exactly this. Even more impressively, they didn’t make new simulations, they simply took pre-existing ones and showed that this relation does, in fact, get reproduced among all their galaxies.\nWhile the web of dark matter (purple) might seem to determine cosmic structure formation on its own, the feedback from normal matter (red) can severely impact galactic scales. Image credit: Illustris Collaboration / Illustris Simulation.\nIf the modified gravity camp through down the gauntlet, the dark matter camp just revealed they had brought a bazooka to a gunfight. Go get the full story!",
		"thread_title": "Dark Matter Rises to its Biggest Challenge… and Succeeds! (Synopsis) [Starts With a Bang] | Science and Technology",
		"title": "Dark Matter Rises to its Biggest Challenge… and Succeeds! (Synopsis) [Starts With a Bang] | Science and Technology",
		"type": "bs",
		"uuid": "a359fd3c32f2eb73b1648f4863e872588a254093"
	},
	"-KhIjxavkqSyCaqOXCck": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:57:12.691+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.34659898,
				"type": "OTHER"
			},
			{
				"name": "UFO",
				"salience": 0.14018987,
				"type": "OTHER"
			},
			{
				"name": "coastline",
				"salience": 0.05218927,
				"type": "LOCATION"
			},
			{
				"name": "photographer",
				"salience": 0.05218927,
				"type": "PERSON"
			},
			{
				"name": "Blasting News",
				"salience": 0.04080666,
				"type": "OTHER"
			},
			{
				"name": "lights",
				"salience": 0.0355063,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/016n7v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whitby"
				},
				"name": "Whitby",
				"salience": 0.03242586,
				"type": "LOCATION"
			},
			{
				"name": "Question",
				"salience": 0.03018541,
				"type": "OTHER"
			},
			{
				"name": "UFOs",
				"salience": 0.03018541,
				"type": "OTHER"
			},
			{
				"name": "Gazette Live Reports",
				"salience": 0.029709391,
				"type": "OTHER"
			},
			{
				"name": "Phoenix The Untold Story",
				"salience": 0.022836456,
				"type": "LOCATION"
			},
			{
				"name": "aaah",
				"salience": 0.022628509,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.022551658,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03ftmv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/KTVK"
				},
				"name": "3TV",
				"salience": 0.021992562,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jt2mz8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/East_Valley_(Phoenix_metropolitan_area)"
				},
				"name": "East Valley",
				"salience": 0.021992562,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFO",
				"salience": 0.021542469,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02dx64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mother_Jones_(magazine)"
				},
				"name": "Mother Jones",
				"salience": 0.01867846,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.01652668,
				"type": "OTHER"
			},
			{
				"name": "solar system",
				"salience": 0.01652668,
				"type": "OTHER"
			},
			{
				"name": "hunting",
				"salience": 0.012368767,
				"type": "OTHER"
			},
			{
				"name": "plenty",
				"salience": 0.012368767,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "1",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T20:03:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "1",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nopenminds.tv\nThis UFO spotted over Whitby coastline left photographer ‘freaked out’ – Gazette Live Reports of strange lights in East Valley – 3TV Phoenix The Untold Story of How John Podesta Answered My Question About UFOs – Mother Jones A night of UFO hunting reveals nothing unexplained, but plenty to ‘oooh’ and ‘aaah’ about – WCPO A new theory about life in our solar system – Blasting News",
		"thread_title": "Daily UFO Headlines 10/26/2016 | Paranormal",
		"title": "Daily UFO Headlines 10/26/2016 | Paranormal",
		"type": "bs",
		"uuid": "b90d2904328b9c975ca5a4c5f5d1cdcc1d53f11b"
	},
	"-KhIjxjw-5IhCugdnYAm": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:57:23.462+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/04sv4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Microsoft"
				},
				"name": "Microsoft",
				"salience": 0.5127593,
				"type": "ORGANIZATION"
			},
			{
				"name": "Microsoft Surface Studio",
				"salience": 0.2402498,
				"type": "ORGANIZATION"
			},
			{
				"name": "News",
				"salience": 0.06720868,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mbxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/IMac"
				},
				"name": "iMac",
				"salience": 0.031310543,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "PC",
				"salience": 0.024897981,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "event",
				"salience": 0.024897981,
				"type": "EVENT"
			},
			{
				"name": "touchscreen",
				"salience": 0.023250874,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.015452491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k8z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apple_Inc."
				},
				"name": "Apple",
				"salience": 0.01035102,
				"type": "ORGANIZATION"
			},
			{
				"name": "desktop",
				"salience": 0.009268196,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "creators",
				"salience": 0.009037846,
				"type": "PERSON"
			},
			{
				"name": "professionals",
				"salience": 0.009037846,
				"type": "PERSON"
			},
			{
				"name": "display",
				"salience": 0.0073883426,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hz29v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Technology_journalism"
				},
				"name": "Tech News",
				"salience": 0.004034814,
				"type": "ORGANIZATION"
			},
			{
				"name": "Gadget Reviews",
				"salience": 0.0040306356,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Pinoy Tech Blog",
				"salience": 0.0024837228,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05v8c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philippines"
				},
				"name": "Philippines",
				"salience": 0.0024837228,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0120wbmx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Windows_10"
				},
				"name": "Windows 10",
				"salience": 0.0018561741,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://feeds.feedburner.com/~r/PinoyTechBlog/~4/wWxJbfvyuuk",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nMicrosoft revealed a new all-in-one PC at its Imagine What You’ll Do event in New York City. The Microsoft Surface Studio is a desktop designed to rival Apple’s iMac. Built for creators and professionals alike, it features a 28-inch, 12.5mm thin touchscreen that’s capable of projecting a greater than 4K display. The Microsoft Surface Studio will run on Windows 10, […]\nThe post Microsoft Surface Studio Introduced, Looks to Challenge the Apple iMac appeared first on Pinoy Tech Blog – Latest Tech News and Gadget Reviews Philippines .",
		"thread_title": "Microsoft Surface Studio Introduced, Looks to Challenge the Apple iMac | Science and Technology",
		"title": "Microsoft Surface Studio Introduced, Looks to Challenge the Apple iMac | Science and Technology",
		"type": "bs",
		"uuid": "d898af99318efeeef4d2f75b76c0bd0bc65cd60f"
	},
	"-KhIjxuuRpD7PDboDjKp": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:57:53.318+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.20252535,
				"type": "OTHER"
			},
			{
				"name": "earthquakes",
				"salience": 0.07197054,
				"type": "EVENT"
			},
			{
				"name": "movements",
				"salience": 0.052332446,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.052332446,
				"type": "OTHER"
			},
			{
				"name": "troops",
				"salience": 0.052332446,
				"type": "PERSON"
			},
			{
				"name": "Judgments",
				"salience": 0.052332446,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.03738604,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06c62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rome"
				},
				"name": "Rome",
				"salience": 0.03242657,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.03242657,
				"type": "ORGANIZATION"
			},
			{
				"name": "firefighter",
				"salience": 0.028150124,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.024011383,
				"type": "PERSON"
			},
			{
				"name": "earthquake",
				"salience": 0.022926303,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italian",
				"salience": 0.020836903,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03rjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Italy"
				},
				"name": "Italy",
				"salience": 0.019206593,
				"type": "LOCATION"
			},
			{
				"name": "Sky TG24",
				"salience": 0.015912563,
				"type": "ORGANIZATION"
			},
			{
				"name": "earthquake",
				"salience": 0.015415741,
				"type": "EVENT"
			},
			{
				"name": "girl",
				"salience": 0.015144333,
				"type": "PERSON"
			},
			{
				"name": "earthquake",
				"salience": 0.010289955,
				"type": "EVENT"
			},
			{
				"name": "rubble",
				"salience": 0.010001616,
				"type": "OTHER"
			},
			{
				"name": "Hand of God",
				"salience": 0.009668472,
				"type": "OTHER"
			},
			{
				"name": "girl",
				"salience": 0.009430855,
				"type": "PERSON"
			},
			{
				"name": "rescue",
				"salience": 0.009033001,
				"type": "OTHER"
			},
			{
				"name": "rescuers",
				"salience": 0.009033001,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.008696662,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.008208439,
				"type": "ORGANIZATION"
			},
			{
				"name": "rubble",
				"salience": 0.008169311,
				"type": "OTHER"
			},
			{
				"name": "homes",
				"salience": 0.007824535,
				"type": "LOCATION"
			},
			{
				"name": "apartments",
				"salience": 0.007824535,
				"type": "LOCATION"
			},
			{
				"name": "survivors",
				"salience": 0.007824535,
				"type": "PERSON"
			},
			{
				"name": "middle",
				"salience": 0.007824535,
				"type": "OTHER"
			},
			{
				"name": "towns",
				"salience": 0.007533076,
				"type": "LOCATION"
			},
			{
				"name": "One World Religion",
				"salience": 0.0068708183,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vhjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_World_Order_(conspiracy_theory)"
				},
				"name": "New World Order",
				"salience": 0.0068708183,
				"type": "OTHER"
			},
			{
				"name": "Central Video",
				"salience": 0.0068708183,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Saletta",
				"salience": 0.0068708183,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.006617502,
				"type": "PERSON"
			},
			{
				"name": "bricks",
				"salience": 0.0063901995,
				"type": "OTHER"
			},
			{
				"name": "debris",
				"salience": 0.0063901995,
				"type": "OTHER"
			},
			{
				"name": "co-workers",
				"salience": 0.0063901995,
				"type": "PERSON"
			},
			{
				"name": "rubble",
				"salience": 0.006106129,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.0059227697,
				"type": "OTHER"
			},
			{
				"name": "color clothes",
				"salience": 0.005630267,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "girl",
				"salience": 0.005137092,
				"type": "PERSON"
			},
			{
				"name": "pile",
				"salience": 0.0047756014,
				"type": "OTHER"
			},
			{
				"name": "volley",
				"salience": 0.0047756014,
				"type": "OTHER"
			},
			{
				"name": "cheers",
				"salience": 0.0047756014,
				"type": "OTHER"
			},
			{
				"name": "Civil Protection Department",
				"salience": 0.0046401815,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f0hnm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amatrice"
				},
				"name": "Amatrice",
				"salience": 0.003935607,
				"type": "LOCATION"
			},
			{
				"name": "leg",
				"salience": 0.003818899,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.003479162,
				"type": "OTHER"
			},
			{
				"name": "dust",
				"salience": 0.003479162,
				"type": "OTHER"
			},
			{
				"name": "foot",
				"salience": 0.0033072028,
				"type": "OTHER"
			},
			{
				"name": "bystander",
				"salience": 0.0030264508,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0030017365,
				"type": "PERSON"
			},
			{
				"name": "leg",
				"salience": 0.0030017365,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.002599435,
				"type": "PERSON"
			},
			{
				"name": "firefighter clutches",
				"salience": 0.002261106,
				"type": "PERSON"
			},
			{
				"name": "firefighter",
				"salience": 0.0021604546,
				"type": "PERSON"
			},
			{
				"name": "Bella ragazza",
				"salience": 0.0018631114,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "188",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/573915/images/_90900406_a18e8138-e465-40ef-b013-589eaec1b095%20italy%20quake.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:19:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0
		},
		"shares": "188",
		"site_url": "beforeitsnews.com",
		"spam_score": "1",
		"text": "(Before It's News)\nAs Rome directs the NATO movements on a global scale and the earthquakes under her troops so she is feeling the Judgments of God. It won’t be long before the Hand of God has had enough of this New World Order and One World Religion.\nFrom Central Video:\nAt least 247 killed in earthquake in central Italy\nSaletta, Italy (CNN)\nAt least 247 people were killed after a 6.2-magnitude earthquake struck central Italy Wednesday, according to Italy’s Civil Protection Department. In the small Italian towns hit hard by a magnitude-6.2 earthquake that struck in the middle of the night, rescuers feverishly dug through the rubble of downed homes and apartments looking for survivors. In one such rescue, shown on CNN affiliate Sky TG24, a firefighter in Amatrice clawed at the rubble, trying to get to a little girl. He pulled back bricks and other debris as his co-workers and other men leaned in. Suddenly there was a foot, and leg, then the other leg. Several people wriggle in to help the firefighter. The firefighter clutches a girl, said to be 8 years old, and walks her out of the huge pile of rubble as a volley of cheers erupts. The girl silently holds on. It is impossible to tell what color clothes she is wearing because she is coated in gray dust. “Bella ragazza!” one bystander says as the girl is carried to safety. “Beautiful girl!” Read More",
		"thread_title": "Earthquake Devastation Hundreds Killed: Rome Rattled by 5.4 Magnitude Earthquake to its East. (Video) | Earthquakes",
		"title": "Earthquake Devastation Hundreds Killed: Rome Rattled by 5.4 Magnitude Earthquake to its East. (Video) | Earthquakes",
		"type": "bs",
		"uuid": "4b4a9b03588586880c65c48432398ec3e1472595"
	},
	"-KhIjyA_x14XkwmjKP9A": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:57:53.933+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "Debbie Picarello",
				"salience": 0.3932124,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.34653592,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.036160097,
				"type": "PERSON"
			},
			{
				"name": "Jacqueline Hawkins",
				"salience": 0.024526717,
				"type": "PERSON"
			},
			{
				"name": "test",
				"salience": 0.016731089,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.015159834,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.011498148,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.011334821,
				"type": "EVENT"
			},
			{
				"name": "woman",
				"salience": 0.0075371447,
				"type": "PERSON"
			},
			{
				"name": "body",
				"salience": 0.0064950297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/017bqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Duet"
				},
				"name": "Duet",
				"salience": 0.00612232,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01lk9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christ"
				},
				"name": "Christ",
				"salience": 0.005427468,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0kddq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_North_Carolina_at_Greensboro"
				},
				"name": "UNC Greensboro",
				"salience": 0.005304179,
				"type": "ORGANIZATION"
			},
			{
				"name": "Deeper Still",
				"salience": 0.005304179,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01yfp7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gap_Inc."
				},
				"name": "GAP",
				"salience": 0.005304179,
				"type": "ORGANIZATION"
			},
			{
				"name": "mind",
				"salience": 0.0044029662,
				"type": "OTHER"
			},
			{
				"name": "baby",
				"salience": 0.0044029662,
				"type": "PERSON"
			},
			{
				"name": "answers",
				"salience": 0.0039080987,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0032116256,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0031779066,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0030939057,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0030939057,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0030939057,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0029411374,
				"type": "OTHER"
			},
			{
				"name": "test",
				"salience": 0.0028548115,
				"type": "OTHER"
			},
			{
				"name": "bodies",
				"salience": 0.0027389028,
				"type": "OTHER"
			},
			{
				"name": "test",
				"salience": 0.002679679,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.002679679,
				"type": "OTHER"
			},
			{
				"name": "Jackie Hawkins",
				"salience": 0.002237534,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0021702976,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.002141625,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0018795612,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.0018795612,
				"type": "EVENT"
			},
			{
				"name": "cheat sheet",
				"salience": 0.0018149435,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0018094591,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0017720902,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0016851411,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015j7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bible"
				},
				"name": "Bible",
				"salience": 0.0016463705,
				"type": "WORK_OF_ART"
			},
			{
				"name": "words",
				"salience": 0.0014149331,
				"type": "OTHER"
			},
			{
				"name": "being",
				"salience": 0.001373359,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.0012727887,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.0012727887,
				"type": "LOCATION"
			},
			{
				"name": "Blood",
				"salience": 0.0012727887,
				"type": "OTHER"
			},
			{
				"name": "blessing",
				"salience": 0.0012727887,
				"type": "OTHER"
			},
			{
				"name": "church leaders",
				"salience": 0.0012328937,
				"type": "PERSON"
			},
			{
				"name": "price",
				"salience": 0.0012252976,
				"type": "OTHER"
			},
			{
				"name": "works",
				"salience": 0.0012252976,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mother",
				"salience": 0.0012252976,
				"type": "PERSON"
			},
			{
				"name": "womb",
				"salience": 0.0012252976,
				"type": "OTHER"
			},
			{
				"name": "Word",
				"salience": 0.0011999824,
				"type": "OTHER"
			},
			{
				"name": "test",
				"salience": 0.0011465707,
				"type": "OTHER"
			},
			{
				"name": "cursing",
				"salience": 0.001039134,
				"type": "OTHER"
			},
			{
				"name": "worship",
				"salience": 0.001039134,
				"type": "OTHER"
			},
			{
				"name": "seed",
				"salience": 0.001039134,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0009644169,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0009644169,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0008964848,
				"type": "LOCATION"
			},
			{
				"name": "children",
				"salience": 0.0008964848,
				"type": "PERSON"
			},
			{
				"name": "answers",
				"salience": 0.0008527481,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.00084141624,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0008351254,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07s4cg0"
				},
				"name": "Lamb",
				"salience": 0.0007835037,
				"type": "PERSON"
			},
			{
				"name": "colors",
				"salience": 0.0007762953,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0007762953,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0007762953,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bwj8jw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Psalm_139"
				},
				"name": "Psalm 139",
				"salience": 0.00075425924,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.000747929,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.000747929,
				"type": "OTHER"
			},
			{
				"name": "Duet 30",
				"salience": 0.00073867076,
				"type": "WORK_OF_ART"
			},
			{
				"name": "support",
				"salience": 0.0007286058,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.0007286058,
				"type": "OTHER"
			},
			{
				"name": "outreach",
				"salience": 0.0007286058,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0006529391,
				"type": "LOCATION"
			},
			{
				"name": "truth",
				"salience": 0.0006529391,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0006238656,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.0006238656,
				"type": "OTHER"
			},
			{
				"name": "assertions",
				"salience": 0.0006100869,
				"type": "OTHER"
			},
			{
				"name": "contributor",
				"salience": 0.0005653879,
				"type": "PERSON"
			},
			{
				"name": "FAB",
				"salience": 0.0005653879,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0005467237,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fxhrq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Comic_Book_Resources"
				},
				"name": "CBR",
				"salience": 0.0005292104,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.00051968114,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.00048775043,
				"type": "PERSON"
			},
			{
				"name": "belief",
				"salience": 0.00044432134,
				"type": "OTHER"
			},
			{
				"name": "likeness",
				"salience": 0.00042234236,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.00042234236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j4dr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Planned_Parenthood"
				},
				"name": "Planned Parenthood",
				"salience": 0.00034797384,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.fletcherarmstrongblog.com/wp-content/uploads/2016/09/good-choice-bad-choice-dpc-resized-300x225.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nGod spells out the choice we need to make in Duet 30.\nby Jacqueline Hawkins\nAt UNC Greensboro, a young woman told Deeper Still and GAP volunteer Debbie Picarello that she was a Christian who believed God gave her a “choice.” In her mind, God was fine with whatever she wanted to do with her own body, even if it meant destroying her baby’s body.\nShe was failing the “choice” test, the test of life and death.\nDebbie pulled out the ultimate life “cheat sheet,” the Bible. This is pretty good: In the most important test we will ever take, the test of life and death, God gave us the answers! Debbie showed her the answers she needed to know:\n“For you created my inmost being; you knit me together in my mother’s womb. I praise you because I am fearfully and wonderfully made; your works are wonderful.” (Psalm 139:13,14)\nIn other words, God made us. He put us together Himself.\n“For you are bought with a great price. Glorify and bear God in your body.” (1 Cor 6:20.)\nOur bodies are not our own; they belong to God. This is especially true for Christians purchased by the Blood of the Lamb.\n“Consider that I have set before thee this day life and good, and on the other hand death and evil … I call heaven and earth to witness this day, that I have set before you life and death, blessing and cursing. Choose therefore life, that both thou and thy seed may live.” (Duet 30:15;19)\nThe choice should be clear.\nThis was not what the young woman wanted to hear. She told Debbie she felt judged. Debbie assured her that she was not judging her, but was giving her the Word of the very God she claimed to worship. Her belief, that she could do whatever she wanted with her own body and the body of her child, was wrong. Her assertions directly contradicted the Bible.\nIt was indeed her choice to follow the Bible or not. But it was clear how God saw our choices. There are right choices and wrong choices. As followers of Christ, our choices are intended to be conformed to His likeness so that the whole world can know him. Pro-abortion Christians aren’t just dangerous for themselves and their children; they are dangerous for everyone on the planet.\nGod gives us the answers to the test, so that we can correct our course and pass with flying colors.\nUnderstanding what Debbie was saying, the young woman shook Debbie’s hand and thanked her for speaking with her.\nThis is so important. Our most important outreach is not to the pagan world; we are taking truth to confused Christians led astray by complacent church leaders who work harder than Planned Parenthood to cover up the truth. Over and over again, your support is the difference between life and death. When you support CBR , you choose life.\nJackie Hawkins is a CBR Project Director and regular FAB contributor.",
		"thread_title": "Answers to the test: The cosmic cheat sheet | Opinion - Conservative",
		"title": "Answers to the test: The cosmic cheat sheet | Opinion - Conservative",
		"type": "bs",
		"uuid": "13a52e624da56fa0d48ff681f3d9bf834271bea1"
	},
	"-KhIjyEr7HQUJk5voAz4": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:58:10.517+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.6705361,
				"type": "OTHER"
			},
			{
				"name": "markets",
				"salience": 0.08358834,
				"type": "OTHER"
			},
			{
				"name": "pattern analysis",
				"salience": 0.068864614,
				"type": "OTHER"
			},
			{
				"name": "themes",
				"salience": 0.06803179,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.051978204,
				"type": "PERSON"
			},
			{
				"name": "perspectives",
				"salience": 0.02867819,
				"type": "OTHER"
			},
			{
				"name": "investment decisions",
				"salience": 0.028322777,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T20:03:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.164",
		"text": "(Before It's News)\n We cover the most dominating themes in the markets and share pattern analysis and perspectives to empower members to make better investment decisions.",
		"thread_title": "Connect Series Webinar Oct 2016 | Financial Markets",
		"title": "Connect Series Webinar Oct 2016 | Financial Markets",
		"type": "bs",
		"uuid": "1270622478d2ed754c2e3475a1f7c10decd24cb8"
	},
	"-KhIjyl-NUQzWr3I56AH": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:58:23.789+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Texas",
				"salience": 0.22118779,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.05153957,
				"type": "LOCATION"
			},
			{
				"name": "voting machines",
				"salience": 0.050677367,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.042175483,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.028463626,
				"type": "OTHER"
			},
			{
				"name": "Joan Stevens",
				"salience": 0.025064088,
				"type": "PERSON"
			},
			{
				"name": "miracle",
				"salience": 0.021163302,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.01625404,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.015959455,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.015756756,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.01555961,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.014443892,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.012845332,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.011220964,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.011049878,
				"type": "ORGANIZATION"
			},
			{
				"name": "vote",
				"salience": 0.0107898805,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.010075124,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.009721219,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0096159335,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0084408745,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.007849636,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.007430748,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.007027684,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.006959644,
				"type": "PERSON"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.0065215593,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.006344795,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.006344795,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.0059229075,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0059229075,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0059229075,
				"type": "LOCATION"
			},
			{
				"name": "voting",
				"salience": 0.005607976,
				"type": "EVENT"
			},
			{
				"name": "thing",
				"salience": 0.005296535,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.00485712,
				"type": "OTHER"
			},
			{
				"name": "hackers",
				"salience": 0.0047376133,
				"type": "PERSON"
			},
			{
				"name": "all",
				"salience": 0.004703619,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.004644018,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.0044190735,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0041668555,
				"type": "ORGANIZATION"
			},
			{
				"name": "chances",
				"salience": 0.00411144,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.00411144,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.00411144,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.003798576,
				"type": "PERSON"
			},
			{
				"name": "Quote",
				"salience": 0.0037072697,
				"type": "OTHER"
			},
			{
				"name": "key",
				"salience": 0.003684441,
				"type": "OTHER"
			},
			{
				"name": "Michael Synder",
				"salience": 0.0035799416,
				"type": "PERSON"
			},
			{
				"name": "family member",
				"salience": 0.003488039,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0034300492,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0034300492,
				"type": "OTHER"
			},
			{
				"name": "none",
				"salience": 0.0034300492,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.0034300492,
				"type": "PERSON"
			},
			{
				"name": "chance",
				"salience": 0.0033148224,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.003085562,
				"type": "EVENT"
			},
			{
				"name": "Heather Hawthorne",
				"salience": 0.003072194,
				"type": "PERSON"
			},
			{
				"name": "posts",
				"salience": 0.0030426842,
				"type": "WORK_OF_ART"
			},
			{
				"name": "alert",
				"salience": 0.0029704624,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0029704624,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0027064802,
				"type": "OTHER"
			},
			{
				"name": "precinct",
				"salience": 0.0026467626,
				"type": "LOCATION"
			},
			{
				"name": "documents",
				"salience": 0.0025646794,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Paul Joseph Watson",
				"salience": 0.0024629433,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.002460672,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0024402284,
				"type": "LOCATION"
			},
			{
				"name": "machine",
				"salience": 0.0023768842,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0023768842,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.0023768842,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0023614257,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.002268934,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.002268934,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.002268934,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.002268934,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.002268934,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0022468828,
				"type": "LOCATION"
			},
			{
				"name": "woman",
				"salience": 0.0022330978,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.002184271,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0021567575,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.002132212,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0020328825,
				"type": "EVENT"
			},
			{
				"name": "relative",
				"salience": 0.0019179729,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0019080248,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0019080248,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0018523977,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0018523977,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0018332014,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.0018325933,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0018213545,
				"type": "OTHER"
			},
			{
				"name": "odds",
				"salience": 0.0017774892,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.0017366926,
				"type": "ORGANIZATION"
			},
			{
				"name": "county",
				"salience": 0.0017312915,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0017254461,
				"type": "PERSON"
			},
			{
				"name": "choice",
				"salience": 0.001693209,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.001693209,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.0016666773,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0016237627,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001604473,
				"type": "LOCATION"
			},
			{
				"name": "county",
				"salience": 0.001604473,
				"type": "LOCATION"
			},
			{
				"name": "voting machines",
				"salience": 0.001604473,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0015642515,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0014626983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0014424154,
				"type": "LOCATION"
			},
			{
				"name": "voting booths",
				"salience": 0.0014421794,
				"type": "LOCATION"
			},
			{
				"name": "ticket",
				"salience": 0.0014027935,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0014027935,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0014027935,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0013955528,
				"type": "WORK_OF_ART"
			},
			{
				"name": "votes",
				"salience": 0.0013838416,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0013838416,
				"type": "PERSON"
			},
			{
				"name": "electronic voting machines",
				"salience": 0.0013606466,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.0013606466,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.0013606466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0425dz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WorldNetDaily"
				},
				"name": "WND",
				"salience": 0.0013573042,
				"type": "ORGANIZATION"
			},
			{
				"name": "ticket",
				"salience": 0.0013504329,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0013225225,
				"type": "EVENT"
			},
			{
				"name": "voting",
				"salience": 0.0013225225,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0mps4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wichita_County,_Texas"
				},
				"name": "Wichita County",
				"salience": 0.0013004707,
				"type": "LOCATION"
			},
			{
				"name": "tries",
				"salience": 0.0012866392,
				"type": "OTHER"
			},
			{
				"name": "emergency switch",
				"salience": 0.0012284918,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.0012230045,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.0012230045,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0012230045,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.0012230045,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0011985638,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.0011871888,
				"type": "OTHER"
			},
			{
				"name": "alarm bells",
				"salience": 0.0011773517,
				"type": "OTHER"
			},
			{
				"name": "precincts",
				"salience": 0.0011609789,
				"type": "LOCATION"
			},
			{
				"name": "chance",
				"salience": 0.0011428723,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ms98",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chambers_County,_Texas"
				},
				"name": "Chambers County",
				"salience": 0.0011028227,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.0011027858,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0010967543,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0010967543,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0010967543,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president",
				"salience": 0.0010967543,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.001063767,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.001063767,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0010558122,
				"type": "OTHER"
			},
			{
				"name": "precincts",
				"salience": 0.0010558122,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.0010503618,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0010435305,
				"type": "LOCATION"
			},
			{
				"name": "problem",
				"salience": 0.0010417791,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0010339887,
				"type": "ORGANIZATION"
			},
			{
				"name": "election officials",
				"salience": 0.0010339887,
				"type": "PERSON"
			},
			{
				"name": "count",
				"salience": 0.001016428,
				"type": "OTHER"
			},
			{
				"name": "vote counts",
				"salience": 0.001016428,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0010045745,
				"type": "LOCATION"
			},
			{
				"name": "ballot",
				"salience": 0.00099025,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n2q0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuyahoga_County,_Ohio"
				},
				"name": "Cuyahoga County",
				"salience": 0.0009875708,
				"type": "LOCATION"
			},
			{
				"name": "numbers",
				"salience": 0.000965449,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00095328235,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00095328235,
				"type": "LOCATION"
			},
			{
				"name": "example",
				"salience": 0.00095328235,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.00095328235,
				"type": "PERSON"
			},
			{
				"name": "nomination",
				"salience": 0.00095328235,
				"type": "OTHER"
			},
			{
				"name": "family member",
				"salience": 0.00095328235,
				"type": "PERSON"
			},
			{
				"name": "officials",
				"salience": 0.000952022,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0009020812,
				"type": "PERSON"
			},
			{
				"name": "mistake",
				"salience": 0.0009020812,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0008996339,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0nqph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arlington,_Texas"
				},
				"name": "Arlington",
				"salience": 0.0008996339,
				"type": "LOCATION"
			},
			{
				"name": "everyone",
				"salience": 0.0008953351,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0008953351,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03lsq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houston_Texans"
				},
				"name": "Texans",
				"salience": 0.00088112016,
				"type": "PERSON"
			},
			{
				"name": "pattern",
				"salience": 0.00087948766,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0008684039,
				"type": "EVENT"
			},
			{
				"name": "most",
				"salience": 0.00086725573,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0008574598,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0008574598,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0008574598,
				"type": "OTHER"
			},
			{
				"name": "selections",
				"salience": 0.0008574598,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0008574598,
				"type": "PERSON"
			},
			{
				"name": "kaine box",
				"salience": 0.0008574598,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0008254477,
				"type": "PERSON"
			},
			{
				"name": "rumors",
				"salience": 0.0008254477,
				"type": "OTHER"
			},
			{
				"name": "errors",
				"salience": 0.0008254477,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0008187022,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0008142374,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0008142374,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0008142374,
				"type": "EVENT"
			},
			{
				"name": "software update",
				"salience": 0.00080838427,
				"type": "OTHER"
			},
			{
				"name": "paper ballots",
				"salience": 0.00080838427,
				"type": "OTHER"
			},
			{
				"name": "vote switching",
				"salience": 0.00080838427,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00080838427,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00080838427,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00080838427,
				"type": "OTHER"
			},
			{
				"name": "heads",
				"salience": 0.00080838427,
				"type": "OTHER"
			},
			{
				"name": "voter registrations",
				"salience": 0.00078357843,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00077700126,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.0007649634,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0007527302,
				"type": "ORGANIZATION"
			},
			{
				"name": "piece",
				"salience": 0.000731633,
				"type": "OTHER"
			},
			{
				"name": "registrations",
				"salience": 0.00073089614,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0007271226,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02qr192"
				},
				"name": "Gary",
				"salience": 0.000724627,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0007239583,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0007239583,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007239583,
				"type": "PERSON"
			},
			{
				"name": "software update",
				"salience": 0.0007074779,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0007036079,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0006999752,
				"type": "EVENT"
			},
			{
				"name": "share",
				"salience": 0.0006999752,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0006999752,
				"type": "PERSON"
			},
			{
				"name": "phenomenon",
				"salience": 0.0006999752,
				"type": "OTHER"
			},
			{
				"name": "emergency protocol",
				"salience": 0.0006999752,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0006738411,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0006688014,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.0006688014,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.0006688014,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0006688014,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0006688014,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Poll",
				"salience": 0.0006688014,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0006688014,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0006688014,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0006688014,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0y_bj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marion,_Ohio"
				},
				"name": "Marion",
				"salience": 0.0006547078,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0006541036,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0006496225,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.0006251676,
				"type": "ORGANIZATION"
			},
			{
				"name": "credibility",
				"salience": 0.0006038454,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.0006038454,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0006038454,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0006038454,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0006038454,
				"type": "OTHER"
			},
			{
				"name": "Breitbart Texas",
				"salience": 0.0005946727,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0005676916,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0005676916,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0005676916,
				"type": "LOCATION"
			},
			{
				"name": "voter fraud",
				"salience": 0.0005624997,
				"type": "OTHER"
			},
			{
				"name": "election fraud",
				"salience": 0.0005624997,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.0005624997,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0005552858,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00055294484,
				"type": "LOCATION"
			},
			{
				"name": "machines",
				"salience": 0.00055294484,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "country",
				"salience": 0.00055294484,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.0005455779,
				"type": "OTHER"
			},
			{
				"name": "election fraud",
				"salience": 0.0005414973,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07pjmfy"
				},
				"name": "Straight",
				"salience": 0.0005277174,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/013n60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amarillo,_Texas"
				},
				"name": "Amarillo",
				"salience": 0.0005277174,
				"type": "LOCATION"
			},
			{
				"name": "Lisa Houlette",
				"salience": 0.0005277174,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0106m3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bowie,_Texas"
				},
				"name": "Bowie",
				"salience": 0.0005277174,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0005272304,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0005228606,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0005228606,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.0005228606,
				"type": "LOCATION"
			},
			{
				"name": "law enforcement officials",
				"salience": 0.0005147086,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0005081074,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0005080135,
				"type": "ORGANIZATION"
			},
			{
				"name": "harm",
				"salience": 0.00050333794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.00049751066,
				"type": "PERSON"
			},
			{
				"name": "victory",
				"salience": 0.0004969937,
				"type": "EVENT"
			},
			{
				"name": "perceptions",
				"salience": 0.0004929318,
				"type": "OTHER"
			},
			{
				"name": "election system",
				"salience": 0.0004907294,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0004892449,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.00048705898,
				"type": "OTHER"
			},
			{
				"name": "None",
				"salience": 0.0004867187,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.00047240625,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.0004397513,
				"type": "LOCATION"
			},
			{
				"name": "outcome",
				"salience": 0.0004397513,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0004397513,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0004397513,
				"type": "OTHER"
			},
			{
				"name": "Shandy Clark",
				"salience": 0.00043078462,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.00042362727,
				"type": "WORK_OF_ART"
			},
			{
				"name": "way",
				"salience": 0.0004233313,
				"type": "OTHER"
			},
			{
				"name": "obligation",
				"salience": 0.00042143985,
				"type": "OTHER"
			},
			{
				"name": "election fraud",
				"salience": 0.00042016487,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.00038885474,
				"type": "OTHER"
			},
			{
				"name": "intelligence services",
				"salience": 0.00038077083,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.00038077083,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.00038077083,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.00038077083,
				"type": "OTHER"
			},
			{
				"name": "anonymity",
				"salience": 0.00038077083,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00036655276,
				"type": "OTHER"
			},
			{
				"name": "voter registrations",
				"salience": 0.00036381098,
				"type": "OTHER"
			},
			{
				"name": "contest",
				"salience": 0.00035286555,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.0003284728,
				"type": "ORGANIZATION"
			},
			{
				"name": "race",
				"salience": 0.0003284728,
				"type": "EVENT"
			},
			{
				"name": "race",
				"salience": 0.0003284728,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06z9_m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Opinion_Research_Corporation"
				},
				"name": "ORC",
				"salience": 0.00032177483,
				"type": "ORGANIZATION"
			},
			{
				"name": "multiples",
				"salience": 0.00028441558,
				"type": "OTHER"
			},
			{
				"name": "somewhere",
				"salience": 0.00028441558,
				"type": "LOCATION"
			},
			{
				"name": "list",
				"salience": 0.00028441558,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.00028441558,
				"type": "OTHER"
			},
			{
				"name": "ticket option",
				"salience": 0.00028441558,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.00028441558,
				"type": "WORK_OF_ART"
			},
			{
				"name": "glitch",
				"salience": 0.00028441558,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.00028441558,
				"type": "OTHER"
			},
			{
				"name": "voter rolls",
				"salience": 0.00028441558,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0002740799,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.000270625,
				"type": "LOCATION"
			},
			{
				"name": "http://theeconomiccollapseblog.com/archives/it-is-happening-again-voting-machines-are-switching-votes-from-donald-trump-to-hillary-clinton",
				"salience": 0.00023432607,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.00023027153,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04myyd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Systems_%26_Software"
				},
				"name": "ES&S",
				"salience": 0.00017502664,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j757",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_courts_of_appeals"
				},
				"name": "Court of Appeals",
				"salience": 0.00017502664,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/08qtd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pew_Research_Center"
				},
				"name": "Pew Research Center",
				"salience": 0.00017502664,
				"type": "ORGANIZATION"
			},
			{
				"name": "Devvy Kidd",
				"salience": 0.00017502664,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "16",
		"main_img_url": "http://theeconomiccollapseblog.com/wp-content/uploads/2016/10/Vote-With-Check-Mark-Public-Domain-460x303.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:17:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 30.5,
			"score": -0.2
		},
		"shares": "16",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nBy Michael Synder Is the 2016 election in the process of being stolen? Just a few weeks ago I issued a major alert warning that this exact sort of thing might happen. Early voting has already begun in many states, and a number of voters in Texas are reporting that the voting machines switched their votes from Donald Trump to Hillary Clinton. The odd thing is that none of the other choices were affected when these individuals attempted to vote for a straight Republican ticket. If Hillary Clinton is declared the winner of the state of Texas on election night, a full investigation of these voting machines should be conducted, because there is no way that Donald Trump should lose that state. I have said that it will be the greatest miracle in U.S. political history if Donald Trump wins this election, but without the state of Texas Donald Trump has exactly zero chance of winning. So those living down in Texas need to keep reporting anything unusual that they see or hear when they go to vote.\nMost Americans don’t realize this, but the exact same thing was happening during the last presidential election. The state of Ohio was considered to be the key to Mitt Romney’s chances of winning in 2012, and right up to election day the Romney campaign actually believed that they were going to win the state.\nUnfortunately for Romney, something funny was going on with the voting machines. In a previous article , I included a Quote: from an Ohio voter that had her vote switched from Mitt Romney to Barack Obama three times …\n“I don’t know if it happened to anybody else or not, but this is the first time in all the years that we voted that this has ever happened to me,” said Marion, Ohio, voter Joan Stevens.\nStevens said that when she voted, it took her three tries before the machine accepted her choice to vote for Romney .\n“I went to vote and I got right in the middle of Romney’s name,” Stevens told Fox News, saying that she was certain to put her finger directly on her choice for the White House.\nShe said that the first time she pushed “Romney,” the machine marked “Obama.”\nSo she pushed Romney again. Obama came up again. Then it happened a third time.\n“Maybe you make a mistake once, but not three times,” she told Fox News.\nAnd we did see some very, very strange numbers come out of certain areas of Ohio four years ago.\nFor example, there were more than 100 precincts in Cuyahoga County in which Barack Obama got at least 99 percent of the vote in 2012.\nIf that happened in just one precinct that would be odd enough. But the odds of it happening in more than 100 precincts in just one county by random chance are so low that they aren’t even worth mentioning.\nAnd of course this didn’t just happen in Ohio. Similar things were happening all over the country .\nThe reason why I bring all of this up is to show that there is a pattern. If a fair vote had been conducted, Romney may have indeed won in 2012, and now it appears that voting machines are being rigged again.\nIn Wichita County, Texas so many people were reporting that their votes were being switched from Trump to Clinton that it made the local newspaper …\nShortly after early voting booths opened Monday in Wichita County, rumors swirled online about possible errors in the process. Several online posts claimed a friend or family member had attempted to vote straight party Republican ticket, but their presidential nomination was switched to the Democratic nominee, Hilary Clinton. None of the local reports were from people who experienced the situation first hand. A Bowie woman posted that a relative who lives in Arlington saw her votes “switched.” The post was shared more than 100,000 times Monday.\nAnd Paul Joseph Watson has written about some specific individuals that are making allegations that their votes for president were switched by the machines. One of the examples that he cited was a Facebook post by Lisa Houlette of Amarillo, Texas …\nGary and I went to early vote today…I voted a straight Republican ticket and as I scrolled to submit my ballot I noticed that the Republican Straight ticket was highlighted, however, the clinton/kaine box was also highlighted! I tried to go back and change and could not get it to work. I asked for help from one of the workers and she couldn’t get it to go back either. It took a second election person to get the machine to where I could correct the vote to a straight ticket. Be careful and double check your selections before you cast your vote! Don’t hesitate to ask for help. I had to have help to get mine changed.\nI don’t know about you, but major alarm bells went off in my head when I read that.\nA similar incident was reported on Facebook by Shandy Clark of Arlington, Texas …\nHey everyone, just a heads up! I had a family member that voted this morning and she voted straight Republican. She checked before she submitted and the vote had changed to Clinton! She reported it and made sure her vote was changed back. They commented that It had been happening. She is trying to get the word out and asked that we post and share. Just want everyone’s vote to be accurate and count. Check your vote before you submit!\nAnd of course they weren’t the only ones reporting vote switching. It turns out that lots of other Texans have also experienced this phenomenon …\nSo is there a serious problem with the voting machines?\nAccording to Breitbart , one county in Texas has already removed all electronic voting machines and has made an emergency switch to paper ballots…\nChambers County election officials have executed an emergency protocol to remove all electronic voting machines available during early voting until a software update can be completed to correct problems experienced by straight-ticket voters .\nChambers County Clerk Heather Hawthorne told Breitbart Texas Tuesday morning that all electronic voting was temporarily halted until her office completes a “software update” on ES&S machines that otherwise “omit one race” when a straight ticket option is selected for either major party. The Texas 14 th Court of Appeals race was reported to be the contest in which voters commonly experienced the glitch.\nLet’s keep a very close eye on this. If the state of Texas ends up in Trump’s column on election night, perhaps no harm has been done.\nBut if Trump loses Texas there is no possible way that he will be able to make up those 38 electoral votes somewhere else.\nDespite what the mainstream media is saying, the truth is that election fraud is very real. Just the other day, WND published an article that contained a list of documented cases of election fraud in 23 different states . And Devvy Kidd just authored a piece that pointed out that there are 24 million voter registrations in this country that are “ no longer valid or are significantly inaccurate “…\nIn 2012 the highly respected Pew Research Center exposed the sickening state of voter rolls in this country:\nNearly 2 million deceased registered to vote\nClose to 3 million registered in multiples states\nApproximately 24 million—one of every eight—voter registrations in the United States are no longer valid or are significantly inaccurate\nMore than 1.8 million deceased individuals are listed as voters\nApproximately 2.75 million people have registrations in more than one state\nBut despite everything you just read, the mainstream media is trying very hard to prop up faith in the integrity of the process. In fact, just today CNN came out with an article entitled “ Poll: Most see a Hillary Clinton victory and a fair count ahead “…\nAlmost 7 in 10 voters nationwide say they think Hillary Clinton will win the presidency next month, but most say that if that happens, Donald Trump will not accept the results and concede, according to a new CNN/ORC poll.\nAmericans overall are more confident that the nation’s votes for president will be cast and counted accurately this year than they were in 2008. Whatever the outcome, however, nearly 8 in 10 say that once all the states have certified their vote counts, the losing candidate has an obligation to accept the results and concede to the winner.\nUnfortunately, CNN does not have much credibility left at this point, and it is getting harder and harder to believe the polls that are being put out by the mainstream media.\nAnd the mainstream media would also have us believe that if evidence of election fraud does emerge that it will be because the Russians have made it up …\nU.S. intelligence and law enforcement officials are warning that hackers with ties to Russia’s intelligence services could try to undermine the credibility of the presidential election by posting documents online purporting to show evidence of voter fraud.\nThe officials, who spoke on condition of anonymity, said however, that the U.S. election system is so large, diffuse and antiquated that hackers would not be able to change the outcome of the Nov. 8 election.\nBut hackers could post documents, some of which might be falsified, that are designed to create public perceptions of widespread voter fraud, the officials said.\nNow that is a real “conspiracy theory”, and it would be incredibly funny if all of this wasn’t so serious.\nDuring this election season, if you see or hear anything unusual about voting in your area, please report it.\nThe American people should be allowed to make a free and fair choice, and anyone that attempts to alter an election is committing a crime against all of us.\nAnd let’s watch the state of Texas very carefully. If it goes blue, you will know that something has gone terribly, terribly wrong.\nhttp://theeconomiccollapseblog.com/archives/it-is-happening-again-voting-machines-are-switching-votes-from-donald-trump-to-hillary-clinton",
		"thread_title": "Voting Machines Switching Trump Votes to Hillary Clinton: It Is Happening Again! | Crime All-Stars",
		"title": "Voting Machines Switching Trump Votes to Hillary Clinton: It Is Happening Again! | Crime All-Stars",
		"type": "bs",
		"uuid": "c3f80ad1cfe57f5fc9958f546345087a7dcf6df0"
	},
	"-KhIjyyG8cxfjxzfIPTD": {
		"author": "ecclesiatical",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:03.339+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "Depression",
				"salience": 0.090493806,
				"type": "OTHER"
			},
			{
				"name": "depression",
				"salience": 0.07418932,
				"type": "OTHER"
			},
			{
				"name": "vitamins deficiencies",
				"salience": 0.062076177,
				"type": "OTHER"
			},
			{
				"name": "psychiatrists",
				"salience": 0.05523009,
				"type": "PERSON"
			},
			{
				"name": "imbalances",
				"salience": 0.05386569,
				"type": "OTHER"
			},
			{
				"name": "brain.",
				"salience": 0.05386569,
				"type": "OTHER"
			},
			{
				"name": "meds",
				"salience": 0.05386569,
				"type": "OTHER"
			},
			{
				"name": "medication",
				"salience": 0.05386569,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "doctors",
				"salience": 0.04901744,
				"type": "PERSON"
			},
			{
				"name": "lactose intolerance",
				"salience": 0.04781804,
				"type": "OTHER"
			},
			{
				"name": "side effects",
				"salience": 0.027687019,
				"type": "OTHER"
			},
			{
				"name": "IBS",
				"salience": 0.022346804,
				"type": "ORGANIZATION"
			},
			{
				"name": "life",
				"salience": 0.022346804,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.022346804,
				"type": "OTHER"
			},
			{
				"name": "gluten",
				"salience": 0.022346804,
				"type": "OTHER"
			},
			{
				"name": "doctor",
				"salience": 0.022317419,
				"type": "PERSON"
			},
			{
				"name": "depression",
				"salience": 0.014483638,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.012262313,
				"type": "OTHER"
			},
			{
				"name": "B12 level",
				"salience": 0.012033779,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.011935714,
				"type": "OTHER"
			},
			{
				"name": "blood-test",
				"salience": 0.011440101,
				"type": "EVENT"
			},
			{
				"name": "cause",
				"salience": 0.01110589,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.01110589,
				"type": "OTHER"
			},
			{
				"name": "cortisol",
				"salience": 0.009765125,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.0095414035,
				"type": "OTHER"
			},
			{
				"name": "symptoms",
				"salience": 0.009267305,
				"type": "OTHER"
			},
			{
				"name": "cos",
				"salience": 0.008026762,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.008026762,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.007874523,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.007568122,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.007568122,
				"type": "OTHER"
			},
			{
				"name": "B12 deficiency",
				"salience": 0.007568122,
				"type": "OTHER"
			},
			{
				"name": "sibling",
				"salience": 0.00680848,
				"type": "PERSON"
			},
			{
				"name": "adrenaline",
				"salience": 0.006554647,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.006554647,
				"type": "OTHER"
			},
			{
				"name": "trigger",
				"salience": 0.006230839,
				"type": "OTHER"
			},
			{
				"name": "reoccurrence",
				"salience": 0.005998508,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00565559,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.00565559,
				"type": "PERSON"
			},
			{
				"name": "depression",
				"salience": 0.005001767,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.004938792,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0048979023,
				"type": "LOCATION"
			},
			{
				"name": "news",
				"salience": 0.0048979023,
				"type": "OTHER"
			},
			{
				"name": "repossession",
				"salience": 0.0048979023,
				"type": "OTHER"
			},
			{
				"name": "bereavement",
				"salience": 0.0048979023,
				"type": "OTHER"
			},
			{
				"name": "shock",
				"salience": 0.0048979023,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0041200765,
				"type": "OTHER"
			},
			{
				"name": "turn",
				"salience": 0.0041200765,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0041200765,
				"type": "OTHER"
			},
			{
				"name": "symptoms",
				"salience": 0.0041200765,
				"type": "OTHER"
			},
			{
				"name": "doctor",
				"salience": 0.00396914,
				"type": "PERSON"
			},
			{
				"name": "vitamins",
				"salience": 0.003078198,
				"type": "OTHER"
			},
			{
				"name": "zinc",
				"salience": 0.0026655681,
				"type": "OTHER"
			},
			{
				"name": "magnesium",
				"salience": 0.0026655681,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/30080/images/toxic-world-2.jpg",
		"ord_in_thread": "16",
		"participants_count": "14",
		"published": "2016-10-26T18:44:00.000+03:00",
		"replies_count": "25",
		"sentiment": {
			"magnitude": 2.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "Depression is caused by vitamins deficiencies but psychiatrists call them chemical imbalances in the brain.I too suffered from depression and was put on meds for a couple of years and the side effects of the medication I took were IBS and gluten and lactose intolerance,which I now have to live with for the rest of my life.\nThree years ago I did a blood-test and found that my B12 level was 179 and a normal would be up to 600,but still my doctor wasn’t convinced and he told me that I was borderline.So I started taking 1000mg everyday and my depression started to ease instantly.\nYou see, the problem with doctors is that they dont look at the real cause but only at the symptoms,they dont want to stop the cause,cos it will make you stop visiting,beside the fact that above all, the real cause before my B12 deficiency was that I recently had been through a traumatic situation and in order for the body to cope it releases cortisol and adrenaline which in turn eats up all your stored vitamins not just B12,so I also started taking magnesium and zinc as I also later discovered that I was also deficient in.\nIf you go back to your past before your the depression started you realize that there was trigger,say a bereavement of someone very close to you,a repossession of your house,news that a sibling has something terminal,in short, a very traumatic(shock) situation.\nYou said so yourself,you stopped taking and reoccurrence took place,which in turn means,you were doing what the doctor said,masking your problem,treating the symptoms and not the cause",
		"thread_title": "7 Insidious Ways the Elite Are Making Americans Dumber (Video) | Power Elite",
		"title": "",
		"type": "bs",
		"uuid": "6b5a90b067e4193fab014bb938cf7a2d6d1c11b8"
	},
	"-KhIjzK5NLKJbquYaRNN": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:03.640+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/30080/images/toxic-world-2.jpg",
		"ord_in_thread": "25",
		"participants_count": "14",
		"published": "2016-10-26T15:25:00.000+03:00",
		"replies_count": "25",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "7 Insidious Ways the Elite Are Making Americans Dumber (Video) | Power Elite",
		"title": "",
		"type": "bs",
		"uuid": "597ce2c30e20b4a5551493925dd3b18e08056559"
	},
	"-KhIk-5HYBlONdfmMMu-": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:11.191+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.14264145,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g6mn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vajrayana"
				},
				"name": "Tantric Buddhism",
				"salience": 0.12833808,
				"type": "OTHER"
			},
			{
				"name": "GF",
				"salience": 0.070951775,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0c9ph5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flower"
				},
				"name": "Flowers",
				"salience": 0.064204335,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/015jr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/British_Columbia"
				},
				"name": "BC",
				"salience": 0.04951733,
				"type": "LOCATION"
			},
			{
				"name": "News",
				"salience": 0.034612283,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill",
				"salience": 0.023647,
				"type": "PERSON"
			},
			{
				"name": "affairs",
				"salience": 0.013238253,
				"type": "OTHER"
			},
			{
				"name": "lottery draw",
				"salience": 0.0114603825,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.011139454,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010350407,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0103361225,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01fbcr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Number_of_the_Beast"
				},
				"name": "Mark of the Beast",
				"salience": 0.00856669,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Arkansas Appeal Tribunal",
				"salience": 0.008187852,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.007862731,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d64c6"
				},
				"name": "Mark",
				"salience": 0.007840361,
				"type": "PERSON"
			},
			{
				"name": "GF",
				"salience": 0.007608912,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0072817868,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0062880944,
				"type": "LOCATION"
			},
			{
				"name": "Mistress",
				"salience": 0.0059022643,
				"type": "PERSON"
			},
			{
				"name": "girl",
				"salience": 0.00578624,
				"type": "PERSON"
			},
			{
				"name": "audio",
				"salience": 0.005455365,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.004865591,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01yq7d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gennifer_Flowers"
				},
				"name": "Gennifer Flowers",
				"salience": 0.0045814915,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03sq5j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shambhala"
				},
				"name": "Shambhala",
				"salience": 0.0044464585,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0044057425,
				"type": "OTHER"
			},
			{
				"name": "transcript",
				"salience": 0.0038090942,
				"type": "OTHER"
			},
			{
				"name": "lottery-draw",
				"salience": 0.003659192,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0034310275,
				"type": "PERSON"
			},
			{
				"name": "He Got Her State Job",
				"salience": 0.0033153652,
				"type": "OTHER"
			},
			{
				"name": "lottery",
				"salience": 0.0031172445,
				"type": "EVENT"
			},
			{
				"name": "Flowers",
				"salience": 0.0030539054,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0029219165,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0029219165,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0029219165,
				"type": "LOCATION"
			},
			{
				"name": "Mistresses",
				"salience": 0.0029219165,
				"type": "PERSON"
			},
			{
				"name": "royalty",
				"salience": 0.0029219165,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0028859624,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0028632816,
				"type": "OTHER"
			},
			{
				"name": "Flowers",
				"salience": 0.0028362179,
				"type": "OTHER"
			},
			{
				"name": "recordings",
				"salience": 0.0027858994,
				"type": "WORK_OF_ART"
			},
			{
				"name": "King",
				"salience": 0.0027319482,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.0027197495,
				"type": "EVENT"
			},
			{
				"name": "message",
				"salience": 0.002699419,
				"type": "OTHER"
			},
			{
				"name": "Judy Gaddy",
				"salience": 0.0026988701,
				"type": "PERSON"
			},
			{
				"name": "scion",
				"salience": 0.0026854891,
				"type": "OTHER"
			},
			{
				"name": "Flowers",
				"salience": 0.0025899196,
				"type": "OTHER"
			},
			{
				"name": "counts",
				"salience": 0.002437368,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.002437368,
				"type": "OTHER"
			},
			{
				"name": "homestate",
				"salience": 0.002437368,
				"type": "LOCATION"
			},
			{
				"name": "Members",
				"salience": 0.002437368,
				"type": "PERSON"
			},
			{
				"name": "homestate",
				"salience": 0.002437368,
				"type": "LOCATION"
			},
			{
				"name": "money",
				"salience": 0.002437368,
				"type": "OTHER"
			},
			{
				"name": "Flowers",
				"salience": 0.0024002208,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.002220417,
				"type": "WORK_OF_ART"
			},
			{
				"name": "state job",
				"salience": 0.0022174236,
				"type": "OTHER"
			},
			{
				"name": "state job",
				"salience": 0.0022174236,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0022174236,
				"type": "OTHER"
			},
			{
				"name": "state job",
				"salience": 0.0022174236,
				"type": "OTHER"
			},
			{
				"name": "heaven",
				"salience": 0.0022022775,
				"type": "OTHER"
			},
			{
				"name": "ambassadors",
				"salience": 0.002110615,
				"type": "PERSON"
			},
			{
				"name": "hell",
				"salience": 0.002110615,
				"type": "OTHER"
			},
			{
				"name": "theorician",
				"salience": 0.002110615,
				"type": "PERSON"
			},
			{
				"name": "culture",
				"salience": 0.002110615,
				"type": "OTHER"
			},
			{
				"name": "TAPE",
				"salience": 0.002110615,
				"type": "OTHER"
			},
			{
				"name": "lottery numbers",
				"salience": 0.002110615,
				"type": "OTHER"
			},
			{
				"name": "orgs",
				"salience": 0.002110615,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.002110615,
				"type": "OTHER"
			},
			{
				"name": "barons",
				"salience": 0.002110615,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.002110615,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.002110615,
				"type": "EVENT"
			},
			{
				"name": "ROYAL family",
				"salience": 0.002110615,
				"type": "PERSON"
			},
			{
				"name": "stepfather",
				"salience": 0.0019681326,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0018848431,
				"type": "OTHER"
			},
			{
				"name": "scandals",
				"salience": 0.0018707997,
				"type": "OTHER"
			},
			{
				"name": "audio",
				"salience": 0.0018651421,
				"type": "OTHER"
			},
			{
				"name": "Antichrist Camp",
				"salience": 0.0017986315,
				"type": "ORGANIZATION"
			},
			{
				"name": "reporter",
				"salience": 0.0017637487,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04ys7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Messiah"
				},
				"name": "Messiah",
				"salience": 0.0016616284,
				"type": "ORGANIZATION"
			},
			{
				"name": "bid",
				"salience": 0.0016378416,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.001634534,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g0xk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Antichrist"
				},
				"name": "Antichrist",
				"salience": 0.0015984857,
				"type": "ORGANIZATION"
			},
			{
				"name": "thing",
				"salience": 0.0015617535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arkansas"
				},
				"name": "Arkansas",
				"salience": 0.0015215841,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart News",
				"salience": 0.0015081966,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03ld5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Heaven"
				},
				"name": "heaven",
				"salience": 0.0015002787,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01tz6vs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Leo_Tolstoy"
				},
				"name": "Leon Tolstoy",
				"salience": 0.0015002787,
				"type": "PERSON"
			},
			{
				"name": "state job",
				"salience": 0.0014966995,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0014966995,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0014966995,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0014966995,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.0014364956,
				"type": "OTHER"
			},
			{
				"name": "grievance",
				"salience": 0.0014266563,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.0014212762,
				"type": "EVENT"
			},
			{
				"name": "position",
				"salience": 0.0014212762,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.00140664,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0013796517,
				"type": "LOCATION"
			},
			{
				"name": "state job",
				"salience": 0.0013695622,
				"type": "OTHER"
			},
			{
				"name": "Pick 3",
				"salience": 0.0013667052,
				"type": "EVENT"
			},
			{
				"name": "news media",
				"salience": 0.0013554583,
				"type": "ORGANIZATION"
			},
			{
				"name": "news media",
				"salience": 0.0013554583,
				"type": "ORGANIZATION"
			},
			{
				"name": "assistant",
				"salience": 0.0013554583,
				"type": "PERSON"
			},
			{
				"name": "Don Barnes",
				"salience": 0.0013304402,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.001321511,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0012991042,
				"type": "LOCATION"
			},
			{
				"name": "Organizing for Action",
				"salience": 0.0012991042,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07pn2d5"
				},
				"name": "BIN",
				"salience": 0.0012991042,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b4w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Norway"
				},
				"name": "Norwegian",
				"salience": 0.0012991042,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07s9hv8"
				},
				"name": "Anarchist",
				"salience": 0.0012991042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g2vv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Apocalypse"
				},
				"name": "Apocalypse",
				"salience": 0.0012991042,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06fby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russian_Revolution"
				},
				"name": "Russian Revolution",
				"salience": 0.0012991042,
				"type": "EVENT"
			},
			{
				"name": "Chernigov Princes",
				"salience": 0.0012991042,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0flw86",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islam"
				},
				"name": "Islam",
				"salience": 0.0012991042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christianity"
				},
				"name": "Christianity",
				"salience": 0.0012991042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03j6c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hinduism"
				},
				"name": "Hinduism",
				"salience": 0.0012991042,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03pm9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Henrik_Ibsen"
				},
				"name": "Henrik Ibsen",
				"salience": 0.0012991042,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02lhsp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kalachakra"
				},
				"name": "Kalachakra",
				"salience": 0.0012991042,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02m03r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tibetan_art"
				},
				"name": "Tibetan",
				"salience": 0.0012991042,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05rd8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope"
				},
				"name": "Papal",
				"salience": 0.0012991042,
				"type": "ORGANIZATION"
			},
			{
				"name": "Royal Chamberlains",
				"salience": 0.0012991042,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04g0bp9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Royal_Households_of_the_United_Kingdom"
				},
				"name": "Royal Household",
				"salience": 0.0012991042,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01k5yg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robe"
				},
				"name": "Robe",
				"salience": 0.0012991042,
				"type": "LOCATION"
			},
			{
				"name": "Jesus' Second Coming",
				"salience": 0.0012991042,
				"type": "OTHER"
			},
			{
				"name": "conversations",
				"salience": 0.0012832569,
				"type": "EVENT"
			},
			{
				"name": "conversations",
				"salience": 0.0012832569,
				"type": "EVENT"
			},
			{
				"name": "phone conversations",
				"salience": 0.0012832569,
				"type": "EVENT"
			},
			{
				"name": "grievance",
				"salience": 0.0012727708,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0012692156,
				"type": "OTHER"
			},
			{
				"name": "grievance",
				"salience": 0.0012252555,
				"type": "OTHER"
			},
			{
				"name": "everybody",
				"salience": 0.0012234828,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0012028072,
				"type": "EVENT"
			},
			{
				"name": "relationship",
				"salience": 0.0012028072,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0012028072,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0012028072,
				"type": "EVENT"
			},
			{
				"name": "position",
				"salience": 0.0011900628,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015j7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bible"
				},
				"name": "Bible",
				"salience": 0.0011299445,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cassette recordings",
				"salience": 0.0011111738,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sections",
				"salience": 0.0011111738,
				"type": "OTHER"
			},
			{
				"name": "audio recordings",
				"salience": 0.0011111738,
				"type": "WORK_OF_ART"
			},
			{
				"name": "way",
				"salience": 0.001105437,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.0010383585,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reporters",
				"salience": 0.0010354171,
				"type": "PERSON"
			},
			{
				"name": "politician",
				"salience": 0.0010178003,
				"type": "PERSON"
			},
			{
				"name": "concern",
				"salience": 0.0010032596,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0010032596,
				"type": "WORK_OF_ART"
			},
			{
				"name": "deposition",
				"salience": 0.0010032596,
				"type": "EVENT"
			},
			{
				"name": "details",
				"salience": 0.0010032596,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0010032596,
				"type": "PERSON"
			},
			{
				"name": "side",
				"salience": 0.0010032596,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0010032596,
				"type": "WORK_OF_ART"
			},
			{
				"name": "issue",
				"salience": 0.0010032596,
				"type": "OTHER"
			},
			{
				"name": "complainant",
				"salience": 0.0010032596,
				"type": "ORGANIZATION"
			},
			{
				"name": "lawsuit",
				"salience": 0.0010032596,
				"type": "OTHER"
			},
			{
				"name": "application",
				"salience": 0.0009927052,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0009848599,
				"type": "OTHER"
			},
			{
				"name": "state job",
				"salience": 0.0009848599,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01rqpq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paula_Jones"
				},
				"name": "Paula Jones",
				"salience": 0.0009835141,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.000966478,
				"type": "PERSON"
			},
			{
				"name": "affair",
				"salience": 0.00095924985,
				"type": "EVENT"
			},
			{
				"name": "position",
				"salience": 0.00095924985,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0009585797,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.00095429725,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0009530355,
				"type": "OTHER"
			},
			{
				"name": "Michael Gauldin",
				"salience": 0.0009521034,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.00094809,
				"type": "OTHER"
			},
			{
				"name": "significance",
				"salience": 0.0009255906,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.000923721,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0009148222,
				"type": "OTHER"
			},
			{
				"name": "news media",
				"salience": 0.0009148222,
				"type": "ORGANIZATION"
			},
			{
				"name": "questions",
				"salience": 0.0009148222,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0009117974,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.0008996767,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0008814079,
				"type": "WORK_OF_ART"
			},
			{
				"name": "grievance",
				"salience": 0.0008810777,
				"type": "OTHER"
			},
			{
				"name": "transcript",
				"salience": 0.00087261264,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.0008687142,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0008687142,
				"type": "OTHER"
			},
			{
				"name": "audio segments",
				"salience": 0.0008687142,
				"type": "OTHER"
			},
			{
				"name": "encounter",
				"salience": 0.0008687142,
				"type": "EVENT"
			},
			{
				"name": "rumors",
				"salience": 0.0008687142,
				"type": "OTHER"
			},
			{
				"name": "news media inquiries",
				"salience": 0.0008687142,
				"type": "OTHER"
			},
			{
				"name": "pay-for-play",
				"salience": 0.0008687142,
				"type": "OTHER"
			},
			{
				"name": "excerpts",
				"salience": 0.0008687142,
				"type": "WORK_OF_ART"
			},
			{
				"name": "audio",
				"salience": 0.00086608634,
				"type": "OTHER"
			},
			{
				"name": "audio",
				"salience": 0.00086608634,
				"type": "OTHER"
			},
			{
				"name": "Good",
				"salience": 0.00086608634,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.00086608634,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0008432684,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0008432684,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01hhz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oval_Office"
				},
				"name": "Oval Office",
				"salience": 0.0008342274,
				"type": "ORGANIZATION"
			},
			{
				"name": "somebody",
				"salience": 0.0007790195,
				"type": "PERSON"
			},
			{
				"name": "guy",
				"salience": 0.0007790195,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.0007790195,
				"type": "PERSON"
			},
			{
				"name": "somebody",
				"salience": 0.0007790195,
				"type": "PERSON"
			},
			{
				"name": "cancer",
				"salience": 0.0007790195,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00077575806,
				"type": "OTHER"
			},
			{
				"name": "questioning",
				"salience": 0.00077575806,
				"type": "EVENT"
			},
			{
				"name": "Clara Clark",
				"salience": 0.0007707771,
				"type": "PERSON"
			},
			{
				"name": "section",
				"salience": 0.000749933,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.000749933,
				"type": "WORK_OF_ART"
			},
			{
				"name": "grievance thing",
				"salience": 0.00073442905,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.00073442905,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0007033566,
				"type": "OTHER"
			},
			{
				"name": "GF",
				"salience": 0.0006981309,
				"type": "PERSON"
			},
			{
				"name": "job",
				"salience": 0.000690456,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.000690456,
				"type": "OTHER"
			},
			{
				"name": "correspondence",
				"salience": 0.0006782511,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00067709456,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00067709456,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.00067709456,
				"type": "OTHER"
			},
			{
				"name": "Judy S. Caddy",
				"salience": 0.0006755228,
				"type": "PERSON"
			},
			{
				"name": "grievance committee",
				"salience": 0.0006690277,
				"type": "ORGANIZATION"
			},
			{
				"name": "affair",
				"salience": 0.0006640237,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0006605951,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0006571841,
				"type": "OTHER"
			},
			{
				"name": "mistress",
				"salience": 0.00065432396,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.00064953783,
				"type": "OTHER"
			},
			{
				"name": "grievance committee",
				"salience": 0.0006359294,
				"type": "ORGANIZATION"
			},
			{
				"name": "guy",
				"salience": 0.0006359294,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0006359294,
				"type": "OTHER"
			},
			{
				"name": "lawyer",
				"salience": 0.0006359294,
				"type": "PERSON"
			},
			{
				"name": "Count Tolstoy",
				"salience": 0.00063330383,
				"type": "PERSON"
			},
			{
				"name": "possibility",
				"salience": 0.000616798,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.000616798,
				"type": "OTHER"
			},
			{
				"name": "radio station",
				"salience": 0.00061268377,
				"type": "ORGANIZATION"
			},
			{
				"name": "angioplasties",
				"salience": 0.00060902355,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0006040459,
				"type": "OTHER"
			},
			{
				"name": "personnel",
				"salience": 0.00058891444,
				"type": "PERSON"
			},
			{
				"name": "newspaper advertisement",
				"salience": 0.00058628316,
				"type": "WORK_OF_ART"
			},
			{
				"name": "scare",
				"salience": 0.00058628316,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.00058628316,
				"type": "OTHER"
			},
			{
				"name": "guard",
				"salience": 0.00058628316,
				"type": "PERSON"
			},
			{
				"name": "witness",
				"salience": 0.00058628316,
				"type": "PERSON"
			},
			{
				"name": "lot",
				"salience": 0.00058628316,
				"type": "OTHER"
			},
			{
				"name": "qualifications",
				"salience": 0.00058628316,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00058628316,
				"type": "OTHER"
			},
			{
				"name": "X-ray",
				"salience": 0.00058628316,
				"type": "OTHER"
			},
			{
				"name": "grievance",
				"salience": 0.00057973224,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00057946163,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.00057946163,
				"type": "OTHER"
			},
			{
				"name": "assistant",
				"salience": 0.00057946163,
				"type": "PERSON"
			},
			{
				"name": "questioning",
				"salience": 0.00057946163,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0005741619,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0005741619,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.0005741619,
				"type": "OTHER"
			},
			{
				"name": "nose",
				"salience": 0.0005741619,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0005636306,
				"type": "OTHER"
			},
			{
				"name": "Dudley",
				"salience": 0.00055785745,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.00055310945,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "NEW YORK",
				"salience": 0.00053462776,
				"type": "LOCATION"
			},
			{
				"name": "deal",
				"salience": 0.0005187554,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0005164376,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00051574106,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00051574106,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00051574106,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.00051418983,
				"type": "OTHER"
			},
			{
				"name": "relationship",
				"salience": 0.00051418983,
				"type": "OTHER"
			},
			{
				"name": "sex allegations",
				"salience": 0.00051418983,
				"type": "OTHER"
			},
			{
				"name": "state employee",
				"salience": 0.00051418983,
				"type": "PERSON"
			},
			{
				"name": "employment",
				"salience": 0.00051418983,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00051418983,
				"type": "WORK_OF_ART"
			},
			{
				"name": "office",
				"salience": 0.0005039947,
				"type": "ORGANIZATION"
			},
			{
				"name": "complaint",
				"salience": 0.0005024832,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.0004971537,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0004971537,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0004971537,
				"type": "OTHER"
			},
			{
				"name": "dadada",
				"salience": 0.0004971537,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.00049309037,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Global Initiative",
				"salience": 0.00047515865,
				"type": "ORGANIZATION"
			},
			{
				"name": "governor",
				"salience": 0.00047501008,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.00047501008,
				"type": "PERSON"
			},
			{
				"name": "commission",
				"salience": 0.00047501008,
				"type": "ORGANIZATION"
			},
			{
				"name": "relevance",
				"salience": 0.00047255727,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00045964646,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0004576459,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0004576459,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0004576459,
				"type": "LOCATION"
			},
			{
				"name": "state job",
				"salience": 0.0004542982,
				"type": "OTHER"
			},
			{
				"name": "state job",
				"salience": 0.0004542982,
				"type": "OTHER"
			},
			{
				"name": "affair",
				"salience": 0.00045385258,
				"type": "EVENT"
			},
			{
				"name": "affair",
				"salience": 0.00045385258,
				"type": "EVENT"
			},
			{
				"name": "little",
				"salience": 0.00044550622,
				"type": "OTHER"
			},
			{
				"name": "spot",
				"salience": 0.00043792502,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.00043792502,
				"type": "OTHER"
			},
			{
				"name": "Dudley",
				"salience": 0.0004328547,
				"type": "LOCATION"
			},
			{
				"name": "proceeding",
				"salience": 0.00042887064,
				"type": "EVENT"
			},
			{
				"name": "staff",
				"salience": 0.00042887064,
				"type": "PERSON"
			},
			{
				"name": "proceeding",
				"salience": 0.00042887064,
				"type": "EVENT"
			},
			{
				"name": "phone",
				"salience": 0.00042887064,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00042887064,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.00042887064,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.00042887064,
				"type": "PERSON"
			},
			{
				"name": "employment",
				"salience": 0.00040922256,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00040793707,
				"type": "OTHER"
			},
			{
				"name": "staff aide",
				"salience": 0.00040583056,
				"type": "OTHER"
			},
			{
				"name": "Dewy",
				"salience": 0.00037479697,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cd0t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Thomas_E._Dewey"
				},
				"name": "Dewey",
				"salience": 0.00037479697,
				"type": "PERSON"
			},
			{
				"name": "Yep",
				"salience": 0.00037479697,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "allegations",
				"salience": 0.00037445105,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.00037445105,
				"type": "WORK_OF_ART"
			},
			{
				"name": "letter",
				"salience": 0.00037445105,
				"type": "WORK_OF_ART"
			},
			{
				"name": "relationship",
				"salience": 0.00037445105,
				"type": "OTHER"
			},
			{
				"name": "resume",
				"salience": 0.00037134724,
				"type": "OTHER"
			},
			{
				"name": "furtherance",
				"salience": 0.00037134724,
				"type": "OTHER"
			},
			{
				"name": "state funds",
				"salience": 0.00037134724,
				"type": "OTHER"
			},
			{
				"name": "panel",
				"salience": 0.00037134724,
				"type": "EVENT"
			},
			{
				"name": "connection",
				"salience": 0.00037134724,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00037048262,
				"type": "OTHER"
			},
			{
				"name": "job interview",
				"salience": 0.00035033404,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00035008925,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/064tvh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Isikoff"
				},
				"name": "Michael Isikoff",
				"salience": 0.0003475792,
				"type": "PERSON"
			},
			{
				"name": "interest",
				"salience": 0.0003459179,
				"type": "OTHER"
			},
			{
				"name": "lawyer",
				"salience": 0.0003459179,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0003459179,
				"type": "OTHER"
			},
			{
				"name": "governor",
				"salience": 0.0003459179,
				"type": "PERSON"
			},
			{
				"name": "interview",
				"salience": 0.0003459179,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.0003459179,
				"type": "OTHER"
			},
			{
				"name": "Dear Bill",
				"salience": 0.00034042454,
				"type": "WORK_OF_ART"
			},
			{
				"name": "situation",
				"salience": 0.00033979368,
				"type": "OTHER"
			},
			{
				"name": "guy",
				"salience": 0.00032880306,
				"type": "PERSON"
			},
			{
				"name": "first",
				"salience": 0.0003229818,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.00031519955,
				"type": "LOCATION"
			},
			{
				"name": "assistant",
				"salience": 0.00031519955,
				"type": "PERSON"
			},
			{
				"name": "King",
				"salience": 0.00031231652,
				"type": "PERSON"
			},
			{
				"name": "law suit",
				"salience": 0.00031231652,
				"type": "OTHER"
			},
			{
				"name": "note",
				"salience": 0.00031231652,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.00031231652,
				"type": "OTHER"
			},
			{
				"name": "state agency",
				"salience": 0.00031231652,
				"type": "ORGANIZATION"
			},
			{
				"name": "appointee",
				"salience": 0.00031231652,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.00031231652,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01j3sz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Laughter"
				},
				"name": "Laughter",
				"salience": 0.00030594776,
				"type": "OTHER"
			},
			{
				"name": "notes",
				"salience": 0.000296864,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tribunal",
				"salience": 0.00027969238,
				"type": "ORGANIZATION"
			},
			{
				"name": "employment",
				"salience": 0.00027969238,
				"type": "OTHER"
			},
			{
				"name": "regard",
				"salience": 0.00027042502,
				"type": "OTHER"
			},
			{
				"name": "job hunting area",
				"salience": 0.00027042502,
				"type": "LOCATION"
			},
			{
				"name": "account",
				"salience": 0.00027042502,
				"type": "OTHER"
			},
			{
				"name": "touch",
				"salience": 0.00027042502,
				"type": "OTHER"
			},
			{
				"name": "affidavit",
				"salience": 0.00026032663,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Barnes",
				"salience": 0.00025968772,
				"type": "LOCATION"
			},
			{
				"name": "Barnes",
				"salience": 0.00025968772,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.0002583793,
				"type": "OTHER"
			},
			{
				"name": "lawyer",
				"salience": 0.0002583793,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.0002583793,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00025494394,
				"type": "OTHER"
			},
			{
				"name": "weekends",
				"salience": 0.00025494394,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03bfzn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vernon_Jordan"
				},
				"name": "Vernon Jordan",
				"salience": 0.000253116,
				"type": "PERSON"
			},
			{
				"name": "reason",
				"salience": 0.00024542364,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00023456482,
				"type": "ORGANIZATION"
			},
			{
				"name": "deposition",
				"salience": 0.00023328056,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00023328056,
				"type": "PERSON"
			},
			{
				"name": "help",
				"salience": 0.00023328056,
				"type": "OTHER"
			},
			{
				"name": "understanding",
				"salience": 0.00023328056,
				"type": "OTHER"
			},
			{
				"name": "details",
				"salience": 0.00023328056,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00020198965,
				"type": "OTHER"
			},
			{
				"name": "representative",
				"salience": 0.00020198965,
				"type": "PERSON"
			},
			{
				"name": "involvement",
				"salience": 0.00020198965,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.00020198965,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00020198965,
				"type": "OTHER"
			},
			{
				"name": "cancer",
				"salience": 0.00019299211,
				"type": "OTHER"
			},
			{
				"name": "Debate Trump",
				"salience": 0.0001921952,
				"type": "LOCATION"
			},
			{
				"name": "http://www.scoopnest.com/user/TPoliticmanager/791321070535966720 Trump",
				"salience": 0.0001921952,
				"type": "PERSON"
			},
			{
				"name": "allegations",
				"salience": 0.00019115976,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0lbxz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mother"
				},
				"name": "Mom",
				"salience": 0.00017507764,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0509p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Monica_Lewinsky"
				},
				"name": "Monica Lewinsky",
				"salience": 0.00016641497,
				"type": "PERSON"
			},
			{
				"name": "Gennifer Flowers Wont Be",
				"salience": 0.00016641497,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.00016641497,
				"type": "PERSON"
			},
			{
				"name": "Just Mocking Clinton Camp All Stories",
				"salience": 0.00016641497,
				"type": "OTHER"
			},
			{
				"name": "Nichols",
				"salience": 0.00016641497,
				"type": "PERSON"
			},
			{
				"name": "Efforts",
				"salience": 0.00013805174,
				"type": "OTHER"
			},
			{
				"name": "BC- Yeah",
				"salience": 0.00012430006,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://media.breitbart.com/media/2016/10/billeyes-640x480.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:51:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 53.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News) King of Shambhala\nalso see here for me…. I belong to an old Norwegian aristocratic ROYAL family including Count Tolstoy (Leon Tolstoy, the famous Anarchist theorician inspired the Russian Revolution but at the same time was the scion of the Chernigov Princes – 11th cent. – by far the oldest Russian royalty) , Henrik Ibsen, Papal and Royal Chamberlains, many Members of the Royal Household, (Mistresses of the Robe) barons and counts, ambassadors. All those who fail to heed heaven’s voice (the lottery draw of 666 below) will be thrown into hell in the end times says the Bible. Well, heaven has spoken. On the day after Obama’s election the lottery in his homestate drew 666. The 666 lottery-draw also reveals that Obama’s Mark of 666 means his money. Check the lottery numbers in Obama’s homestate here : the Pick 3 of Nov 5, 2008 was 666, less than 24 hours after Obama’s election!! Because I’m alone in revealing the lottery draw of 666, the Mark of the Beast that everybody knows is the Antichrist, that makes me the Messiah and Jesus’ Second Coming . Tibetan Tantric Buddhism is the highest form of culture in the world and I follow it’s Kalachakra creed. Buddhism and Hinduism never carried out war like Christianity and Islam (That’s the worst thing existing in the world.) I’m working on revealing myself and my message to the world fast now so the Apocalypse blows. My message of truth and that shows the way, must be revealed not only here at BIN (the only place in the world where speech is free), but worldwide! The lying Antichrist Camp is infesting my articles with trolling from such criminal orgs as “Organizing for Action” so don’t follow anyone opposing me here!\nCAUGHT ON TAPE: Bill Clinton Tells Alleged Mistress to Deny He Got Her State Job\nNEW YORK – Speaking in a series of recorded phone conversations in 1991 with his alleged mistress Gennifer Flowers, Bill Clinton can be heard telling Flowers to deny that he aided her in obtaining a state job. “If they ever asked if you’d talked to me about it, you can say no,” Clinton can be heard saying in the audio.\nListen to the audio here:\nClinton was referring to news media inquiries about Flowers’ alleged affair with Clinton and Flowers’ concern that the media could raise questions about how she landed her job as administrative assistant for the Arkansas Appeal Tribunal.\nClinton can also be heard advising Flowers on how to handle a grievance filed by a woman who applied for the same position and alleged that she was more qualified that Flowers. The complainant implied that Flowers was only hired because of her alleged relationship with Clinton.\n From December 1990 to December 1991, Flowers famously recorded a series of conversations with Clinton during the period he was Governor of Arkansas and considering a run for the presidency.\nOn October 1991, Clinton announced his bid for the Oval Office, with rumors of extramarital affairs threatening to derail his campaign.\nFlowers recently provided this reporter with complete original cassette recordings of her taped conversations with Clinton, recordings that take on renewed significance as the issue of Clinton’s alleged treatment of women has reemerged during the 2016 presidential campaign.\nThe sections of the audio recordings related to the state job are not exclusive to Breitbart News. Those excerpts were played for the news media in 1992, one day after Bill and Hillary Clinton appeared side by side on 60 Minutes , where Bill denied a relationship with Flowers.\nClinton later admitted to one sexual encounter with Flowers in a 1998 deposition for the Paula Jones lawsuit.\nThe audio segments about the state job were widely reported by the news media in the 1990’s. However, the details may warrant revisiting amid numerous Clinton financial scandals that have since surfaced alleging pay-for-play, including those tied to the Clinton Foundation and Clinton Global Initiative.\nIn one section of the audio, which can be heard above, Flowers discusses the grievance filed against her and informs Clinton that she was being questioned about how she obtained the position.\nClinton says “Good for you,” when Flowers tells him that she found out about the job from a newspaper advertisement and pursued it from there.\nHere is a transcript of that part of the audio:\nGF – But anyway, then Wednesday, there was a grievance filed in my office when I got the job by a girl who felt like she should have gotten it, a black girl named (deleted). And they called me as a witness. So I go in and uh, nothing big came of it. It’s just that they were questioning me about how I found out about the job. And I said, “Well, that personnel said it that it was a possibility there would be a position,” and then uh, “they told me that it would be advertised in the newspaper. And it was and I pursued it from there.\nBC – Good for you.\nGF – Well, it caught me off guard ‘cause I… at first I just didn’t know… I just didn’t expect that for some reason. I thought about a whole lot of things about my qualifications and all that business, but I didn’t think about that.\nBC – Yeah.\nIn the next section of the audio, Flowers expresses concern that the news media, which was asking her questions about the alleged affair, could find out about the state job.\nGF: Yeah. We had a little bit of a scare recently because she had a spot on an X-ray. And she went and had it checked again and it wasn’t cancer. And it’s been almost, it’ll be two years in May that she’s now diagnosed cancer free. My stepfather has been through two angioplasties, but he’s doing good. And I am, I’m really, Bill what I’m afraid of is that if somebody in the press finds out that I’m working for the state.\nBC – Yeah.\nGF – They’re going to make a big deal of it.\nBC – Yeah.\nIn a subsequent conversation, Clinton specifically counsels Flowers to say “no” if she is asked about whether she discussed the state job with him.\nHere is a transcript:\nGF – Well the only thing that concerns me, where I’m, where I’m concerned at this point is the state job.\nBC – Yeah. I never thought about that, but as long as you say you’ve just been looking for one, you’d uh, check on it. If they ever asked if you’d talked to me about it, you can say no.\nGF – Well and I would. But I’m… here is the thing I’ve got to consider, too, is I’ve gotta go in there to work every day. You know what I mean?\nBC – Yep.\nGF – And if, and if these people start talking or someone in the press…\nBC – Well, have they been nice to you there?\nGF – Yeah they have been. But I don’t, you know, I mean, I just want you to know what’s going on. And I’ll be glad to hang in there.\nBC – Has the, has the…\nGF – But if it gets real…\nBC – Has the grievance committee ruled yet?\nGF – No. Not that I am aware of. Uh, I forget the guy’s name that appeared to be the head of it. Dudley or Dewey. Is there a Dudley or a Dewy or somebody? Do you know?\nBC – I don’t know.\nGF – Don Barnes was there. And of course…\nBC – Is he happy with you?\nGF – Well sure. (Laughter.) I’m good. I’m good at what I do, Bill.\nBC – I know.\nGF – But Don was, you know. He… He pretty much… When this guy was trying to beat up on me a little, said, “hey, I don’t see the relevance of this” and dadada. And then the head of the grievance committee said “I don’t either and I think we need to go on and you know go, not go along with this line of questioning.” And then that was about it except for just some other minor questions. But I found that curious that he would ask me how I found out about the job.\nBC – Yeah.\nGF – Now maybe at this point I’m paranoid but I mean no one has mentioned anything about it to me at all but I just found that, that I found interesting.\nBC – Yeah.\nIn another conversation, Clinton tells Flowers that he will “nose around” to see if he can find out more about the issue, and he asked her whether the person who filed the grievance was being represented by a lawyer.\nBC – Alright. I’m gonna nose around, if I find out anything I’ll call you. And meanwhile, uh, I can understand this grievance thing. I’ll, I’ll run that down.\nGF – Well I don’t think there’ll be any problem there from what I understand, you know, that her deal was to either have my job or for them to create a position equal to mine.\nBC – Uh huh.\nGF – But it’s my understanding that then it’ll go to… even if they say yes, created position for her.\nBC – Uh huh.\nGF – That’s the same as Gennifer’s. Don Barnes can always say, “No, I won’t” and period. That’s it.\nBC – That’s right. I mean that’s my understanding. So…\nBC- Yeah. And then she could sue, but I doubt if she will. Was she there with a lawyer or a representative of any kind?\nGF – She had a guy that works for the tribunal represent her which I thought was very inappropriate.\nBC – Uh huh. Well, I guess maybe they do that for people…\nContacted yesterday by Breitbart News, Flowers explained why she says she turned to Clinton for help securing the state job.\nShe stated:\nI found out my Mom had cancer and decided I wanted a regular job so I would have my weekends to spend with her. I was performing six nights a week and wouldn’t of had time. I asked to get me the job and he did.\nIn her deposition for the Paula Jones case, Flowers detailed Clinton’s alleged involvement in helping her secure the state job.\nHere is her affidavit on that matter:\nIn early 1990 I told Bill Clinton that I wanted a job with the state. Bill Clinton told me to contact his assistant Judy Gaddy who would assist me with the application for employment. I met with Judy Gaddy in her office and she provided me with the details of what needed to be on the application. Judy Gaddy also told me to contact Clara Clark who set up a job interview for me. I was eventually employed by the state as an administrative assistant for the Arkansas Appeal Tribunal.\nShortly after I was employed by the state, another woman who had applied for my job filed a grievance or some sort of complaint in which she alleged that she was more qualified and implied that the only reason I got the job was because I had had an affair with Bill Clinton. I was called to testify before a panel in connection with this proceeding. When I learned that I would have to testify, I did not know what to do, so I called Bill Clinton. I told him that I had been called to testify and asked what I should say. He told me to deny that we had ever had an affair. During the proceeding, when questions came up about my relationship to Bill, Don Barnes, his appointee and head of the commission, stopped the questioning.\nIn 1992, Michael Isikoff reported at the Washington Post that Clinton’s office admitted that it helped Flowers obtain the job in June 1991, while denying allegations that Flowers was Clinton’s mistress. Clinton’s office maintained that Clinton only helped Flowers because the politician felt bad that she was being hounded by the media over the sex allegations.\nIsikoff reported:\nGov. Bill Clinton’s office said today that Clinton assigned a member of his staff to help Gennifer Flowers find a state job in September 1990 after she asked for his assistance.\nMichael Gauldin, Clinton’s press secretary, also released two handwritten notes he said Flowers had written to Clinton. The first, in 1986, said she would appreciate his help in finding a job. The second, dated Feb. 23, 1991, complained that the assistant assigned to help her was not being very “successful.” …\nGauldin said Clinton was interested in helping her in part because he “felt responsible for all the women” who were being hounded by reporters after they were named in an unsuccessful 1990 lawsuit in which a state employee alleged the governor had used state funds in furtherance of extramarital affairs.\nIn the 1986 letter, Flowers enclosed a resume, said she “certainly enjoyed speaking with you by phone,” and said “anything you can do” to help with employment would be “appreciated.”\nIn the 1991 “Dear Bill” letter, Flowers complained that the staff aide Clinton assigned to the matter, special assistant Judy S. Caddy, “has not been very successful in the job hunting area.”\n“Bill, I’ve tried to explain my financial situation to you and how badly I need a job,” Flowers wrote. She said she was enclosing “some correspondence that will be of interest to you” – a letter written by a lawyer she had hired threatening to sue a local radio station for repeating the 1990 allegations. The letter, which had previously been released by Clinton, said the allegations were untrue.\n“Unfortunately, it looks like I will have to pursue the law suit to hopefully, get some money to live on until I can get employment,” Flowers ended the note. “Please be in touch.”\nIn 1998, the Washington Post again reported on the matter:\nFlowers said her affair with Clinton had been over for at least a year but that about the time of the Nichols suit, she was looking for a job and turned to the governor.\nClinton agreed to help find her a position at an Arkansas state agency, Flowers said, and enlisted a political appointee named Don Barnes. Efforts to contact Barnes last night were unsuccessful.\n“I don’t know Vernon Jordan, and I don’t know whether he is or is not telling the truth,” Flowers said. “But it reminds me of [1990] in regard to a position that Vernon Jordan supposedly arranged for Monica Lewinsky.”\nFlowers was hired by the Arkansas Appeal Tribunal, a state agency, after an interview Barnes arranged and sat in on, according to Flowers’ 1995 written account of her relationship with Clinton.\nhttp://www.scoopnest.com/user/TPoliticmanager/791321070535966720\nTrump threatened Hillary with bringing on Gennifer Flowers last month to the debate.\nMike Pence Gennifer Flowers Wont Be at Debate Trump Was Just Mocking Clinton Camp\nAll Stories By King of Shambhala Click Here!",
		"thread_title": "October Surprise! This Is Bad! Wow! Listen: Bill Clinton Tells Alleged Mistress to Deny He Got Her State Job (Video) | Alternative",
		"title": "October Surprise! This Is Bad! Wow! Listen: Bill Clinton Tells Alleged Mistress to Deny He Got Her State Job (Video) | Alternative",
		"type": "bs",
		"uuid": "ed22ce183d9172f130b0a92991289ae309224fc5"
	},
	"-KhIk-_6NrGNHWpMlvhu": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:38.951+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "sucker",
				"salience": 0.16643418,
				"type": "PERSON"
			},
			{
				"name": "Kellam Hawk",
				"salience": 0.11803926,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "puukko",
				"salience": 0.093368985,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.063572615,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.05051147,
				"type": "OTHER"
			},
			{
				"name": "IMO",
				"salience": 0.021989806,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0fp7c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hawk"
				},
				"name": "Hawk",
				"salience": 0.021212466,
				"type": "ORGANIZATION"
			},
			{
				"name": "knife",
				"salience": 0.019481707,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "utility design",
				"salience": 0.01552964,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.014434576,
				"type": "OTHER"
			},
			{
				"name": "knife designs",
				"salience": 0.013351084,
				"type": "WORK_OF_ART"
			},
			{
				"name": "knife",
				"salience": 0.012943364,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hand",
				"salience": 0.0093881115,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.008534504,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Ovako 100Cr6",
				"salience": 0.00794473,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007846347,
				"type": "PERSON"
			},
			{
				"name": "knife",
				"salience": 0.0076641594,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "word",
				"salience": 0.007650507,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.00719477,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "easiest",
				"salience": 0.006782385,
				"type": "EVENT"
			},
			{
				"name": "knives",
				"salience": 0.0066850074,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "puukotta",
				"salience": 0.0066779703,
				"type": "OTHER"
			},
			{
				"name": "puukko",
				"salience": 0.0066779703,
				"type": "OTHER"
			},
			{
				"name": "Kellam Hawk",
				"salience": 0.0063206386,
				"type": "PERSON"
			},
			{
				"name": "design",
				"salience": 0.0062199226,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.0062199226,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.0061417487,
				"type": "OTHER"
			},
			{
				"name": "tasks",
				"salience": 0.005690204,
				"type": "OTHER"
			},
			{
				"name": "wood",
				"salience": 0.005387801,
				"type": "OTHER"
			},
			{
				"name": "Kellem Knives",
				"salience": 0.005172953,
				"type": "ORGANIZATION"
			},
			{
				"name": "materials",
				"salience": 0.004666745,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.004666745,
				"type": "OTHER"
			},
			{
				"name": "consideration",
				"salience": 0.004598758,
				"type": "OTHER"
			},
			{
				"name": "Leon Pantenburg",
				"salience": 0.0043983576,
				"type": "PERSON"
			},
			{
				"name": "Pukko",
				"salience": 0.0043317103,
				"type": "OTHER"
			},
			{
				"name": "diameter",
				"salience": 0.0038148582,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.0036504993,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.0036500439,
				"type": "EVENT"
			},
			{
				"name": "name",
				"salience": 0.0036500439,
				"type": "OTHER"
			},
			{
				"name": "puu",
				"salience": 0.0035587554,
				"type": "OTHER"
			},
			{
				"name": "prefix",
				"salience": 0.0035587554,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.0035202529,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "knifemakers",
				"salience": 0.0035202529,
				"type": "PERSON"
			},
			{
				"name": "Scandinavian Puukko",
				"salience": 0.003497616,
				"type": "ORGANIZATION"
			},
			{
				"name": "puukko handle",
				"salience": 0.003278442,
				"type": "OTHER"
			},
			{
				"name": "spine",
				"salience": 0.0032502557,
				"type": "OTHER"
			},
			{
				"name": "Hawk",
				"salience": 0.00299886,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.0029624908,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.002852012,
				"type": "OTHER"
			},
			{
				"name": "puukkos",
				"salience": 0.0027529853,
				"type": "OTHER"
			},
			{
				"name": "sponsorship relationship",
				"salience": 0.002727539,
				"type": "OTHER"
			},
			{
				"name": "mark",
				"salience": 0.002644234,
				"type": "OTHER"
			},
			{
				"name": "design",
				"salience": 0.0025638118,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.002496043,
				"type": "PERSON"
			},
			{
				"name": "user knife",
				"salience": 0.002469024,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.0024588823,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0024188943,
				"type": "OTHER"
			},
			{
				"name": "bushcraft knife",
				"salience": 0.002376926,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.0023174416,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.0022993407,
				"type": "OTHER"
			},
			{
				"name": "Survivalcommonsense.com",
				"salience": 0.0022476744,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06rd7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sami_people"
				},
				"name": "Sami",
				"salience": 0.0022476744,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02vzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Finland"
				},
				"name": "Finnish",
				"salience": 0.0022476744,
				"type": "LOCATION"
			},
			{
				"name": "specs",
				"salience": 0.0022270067,
				"type": "OTHER"
			},
			{
				"name": "Handle",
				"salience": 0.0022135652,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0022135652,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.0022135652,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.0022135652,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Finland"
				},
				"name": "Finnish",
				"salience": 0.0021522804,
				"type": "LOCATION"
			},
			{
				"name": "sheath",
				"salience": 0.002081178,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.002081178,
				"type": "OTHER"
			},
			{
				"name": "Carbon Steel Handle: 4.5",
				"salience": 0.0020187008,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.0020158845,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.0019372061,
				"type": "OTHER"
			},
			{
				"name": "skin fish",
				"salience": 0.0019227278,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0018528533,
				"type": "OTHER"
			},
			{
				"name": "scandi",
				"salience": 0.0018103368,
				"type": "OTHER"
			},
			{
				"name": "hand size",
				"salience": 0.001736104,
				"type": "OTHER"
			},
			{
				"name": "change",
				"salience": 0.001736104,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.001736104,
				"type": "OTHER"
			},
			{
				"name": "Birch",
				"salience": 0.001736104,
				"type": "OTHER"
			},
			{
				"name": "sizes",
				"salience": 0.001736104,
				"type": "OTHER"
			},
			{
				"name": "steel",
				"salience": 0.0017243313,
				"type": "OTHER"
			},
			{
				"name": "steel",
				"salience": 0.0017243313,
				"type": "OTHER"
			},
			{
				"name": "knives",
				"salience": 0.001681165,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cutting tasks",
				"salience": 0.0016445129,
				"type": "OTHER"
			},
			{
				"name": "tasks",
				"salience": 0.0016445129,
				"type": "OTHER"
			},
			{
				"name": "wood",
				"salience": 0.0015569495,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0015419985,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.0015252989,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "person",
				"salience": 0.0015033933,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.0015033933,
				"type": "PERSON"
			},
			{
				"name": "Product Details",
				"salience": 0.0015033933,
				"type": "OTHER"
			},
			{
				"name": "Length",
				"salience": 0.0015033933,
				"type": "OTHER"
			},
			{
				"name": "animals",
				"salience": 0.0015033933,
				"type": "OTHER"
			},
			{
				"name": "woodworking grind",
				"salience": 0.0014968539,
				"type": "OTHER"
			},
			{
				"name": "designs",
				"salience": 0.0014678768,
				"type": "WORK_OF_ART"
			},
			{
				"name": "finger grips",
				"salience": 0.0014547964,
				"type": "OTHER"
			},
			{
				"name": "Feather Stick",
				"salience": 0.0014354662,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "materials",
				"salience": 0.0014183728,
				"type": "OTHER"
			},
			{
				"name": "grind",
				"salience": 0.0014049149,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/067sdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tang_(weaponry)"
				},
				"name": "Full Tang",
				"salience": 0.0013668586,
				"type": "PERSON"
			},
			{
				"name": "fish",
				"salience": 0.0013482368,
				"type": "OTHER"
			},
			{
				"name": "wood",
				"salience": 0.0012873156,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z1ph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Grind"
				},
				"name": "Grind",
				"salience": 0.0012811922,
				"type": "OTHER"
			},
			{
				"name": "pun",
				"salience": 0.0012749523,
				"type": "OTHER"
			},
			{
				"name": "birch",
				"salience": 0.0012173406,
				"type": "OTHER"
			},
			{
				"name": "bushcraft",
				"salience": 0.0012173406,
				"type": "OTHER"
			},
			{
				"name": "cutting",
				"salience": 0.0012173406,
				"type": "OTHER"
			},
			{
				"name": "edge",
				"salience": 0.0012119039,
				"type": "OTHER"
			},
			{
				"name": "Convex",
				"salience": 0.0011925291,
				"type": "ORGANIZATION"
			},
			{
				"name": "grinder",
				"salience": 0.0011914289,
				"type": "OTHER"
			},
			{
				"name": "Sheath",
				"salience": 0.0011914289,
				"type": "OTHER"
			},
			{
				"name": "sheath",
				"salience": 0.0011914289,
				"type": "OTHER"
			},
			{
				"name": "Blade: 3",
				"salience": 0.001183613,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0011719048,
				"type": "OTHER"
			},
			{
				"name": "sharpening guide",
				"salience": 0.0011719048,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0011719048,
				"type": "OTHER"
			},
			{
				"name": "grip",
				"salience": 0.0011579482,
				"type": "OTHER"
			},
			{
				"name": "aspect",
				"salience": 0.0011231254,
				"type": "OTHER"
			},
			{
				"name": "grip",
				"salience": 0.001114728,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Finland"
				},
				"name": "Finland",
				"salience": 0.0011059663,
				"type": "LOCATION"
			},
			{
				"name": "knife",
				"salience": 0.0010969618,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "knife",
				"salience": 0.0010969618,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "knife",
				"salience": 0.0010969618,
				"type": "OTHER"
			},
			{
				"name": "Dangler",
				"salience": 0.0010686911,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0010541294,
				"type": "OTHER"
			},
			{
				"name": "butchering",
				"salience": 0.0010541294,
				"type": "EVENT"
			},
			{
				"name": "heat",
				"salience": 0.0010541294,
				"type": "OTHER"
			},
			{
				"name": "beginner",
				"salience": 0.0010147823,
				"type": "PERSON"
			},
			{
				"name": "bevel",
				"salience": 0.0010147823,
				"type": "OTHER"
			},
			{
				"name": "whetstone",
				"salience": 0.0010147823,
				"type": "OTHER"
			},
			{
				"name": "someone",
				"salience": 0.0010147823,
				"type": "PERSON"
			},
			{
				"name": "gloves",
				"salience": 0.0010147823,
				"type": "OTHER"
			},
			{
				"name": "tasks",
				"salience": 0.001002979,
				"type": "OTHER"
			},
			{
				"name": "passes",
				"salience": 0.0009938087,
				"type": "OTHER"
			},
			{
				"name": "Spine",
				"salience": 0.0009938087,
				"type": "OTHER"
			},
			{
				"name": "Hawk",
				"salience": 0.0009343214,
				"type": "OTHER"
			},
			{
				"name": "Battle Horse",
				"salience": 0.0009254005,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/043v0j_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electric_Daisy_Carnival"
				},
				"name": "EDC",
				"salience": 0.0009254005,
				"type": "ORGANIZATION"
			},
			{
				"name": "Most",
				"salience": 0.0009053321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06mx8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scandinavia"
				},
				"name": "Scandinavia",
				"salience": 0.0008982998,
				"type": "LOCATION"
			},
			{
				"name": "Nordiska Kniva",
				"salience": 0.0008665243,
				"type": "PERSON"
			},
			{
				"name": "scandi",
				"salience": 0.0008647668,
				"type": "OTHER"
			},
			{
				"name": "tinder",
				"salience": 0.0008605541,
				"type": "OTHER"
			},
			{
				"name": "ice skate",
				"salience": 0.0008605541,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "knife blog",
				"salience": 0.0008605541,
				"type": "OTHER"
			},
			{
				"name": "angle",
				"salience": 0.0008605541,
				"type": "OTHER"
			},
			{
				"name": "ferro rod",
				"salience": 0.0008605541,
				"type": "OTHER"
			},
			{
				"name": "blade knife",
				"salience": 0.0008194547,
				"type": "OTHER"
			},
			{
				"name": "knife",
				"salience": 0.0008194547,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "design",
				"salience": 0.0007986593,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.0007659449,
				"type": "PERSON"
			},
			{
				"name": "Hand",
				"salience": 0.00076309487,
				"type": "OTHER"
			},
			{
				"name": "tool",
				"salience": 0.00074238755,
				"type": "OTHER"
			},
			{
				"name": "deer",
				"salience": 0.00074238755,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.00074238755,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.00074238755,
				"type": "OTHER"
			},
			{
				"name": "passenger",
				"salience": 0.00074238755,
				"type": "PERSON"
			},
			{
				"name": "driver",
				"salience": 0.00074238755,
				"type": "PERSON"
			},
			{
				"name": "deer",
				"salience": 0.00074238755,
				"type": "OTHER"
			},
			{
				"name": "task",
				"salience": 0.0007304736,
				"type": "OTHER"
			},
			{
				"name": "twist",
				"salience": 0.0007025137,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01tr_g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Blade"
				},
				"name": "Blade",
				"salience": 0.00067746337,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tool",
				"salience": 0.00067076035,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0006488044,
				"type": "LOCATION"
			},
			{
				"name": "road",
				"salience": 0.0006428339,
				"type": "LOCATION"
			},
			{
				"name": "legs",
				"salience": 0.0006428339,
				"type": "OTHER"
			},
			{
				"name": "pain",
				"salience": 0.0006428339,
				"type": "OTHER"
			},
			{
				"name": "radiator",
				"salience": 0.0006428339,
				"type": "PERSON"
			},
			{
				"name": "air bag",
				"salience": 0.0006428339,
				"type": "OTHER"
			},
			{
				"name": "hood",
				"salience": 0.0006428339,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.0006428339,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "end",
				"salience": 0.0006428339,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006428339,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "home",
				"salience": 0.0006428339,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0006428339,
				"type": "OTHER"
			},
			{
				"name": "highway",
				"salience": 0.0006428339,
				"type": "LOCATION"
			},
			{
				"name": "section",
				"salience": 0.0006428339,
				"type": "OTHER"
			},
			{
				"name": "camping",
				"salience": 0.0006428339,
				"type": "EVENT"
			},
			{
				"name": "suffering",
				"salience": 0.0006428339,
				"type": "OTHER"
			},
			{
				"name": "handle",
				"salience": 0.0006150963,
				"type": "OTHER"
			},
			{
				"name": "materials",
				"salience": 0.0005988222,
				"type": "OTHER"
			},
			{
				"name": "fishing",
				"salience": 0.0005988222,
				"type": "OTHER"
			},
			{
				"name": "user knives",
				"salience": 0.000572154,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "users",
				"salience": 0.000572154,
				"type": "PERSON"
			},
			{
				"name": "knives",
				"salience": 0.000572154,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "steels",
				"salience": 0.000564943,
				"type": "OTHER"
			},
			{
				"name": "tang",
				"salience": 0.00056454836,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0005616336,
				"type": "OTHER"
			},
			{
				"name": "tasks",
				"salience": 0.00054565485,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.0005406648,
				"type": "OTHER"
			},
			{
				"name": "channel",
				"salience": 0.0005406648,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0005406648,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.0005342238,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S",
				"salience": 0.0005296415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0140mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nordic_countries"
				},
				"name": "Nordic",
				"salience": 0.0005296415,
				"type": "LOCATION"
			},
			{
				"name": "tang",
				"salience": 0.00051658595,
				"type": "OTHER"
			},
			{
				"name": "tang",
				"salience": 0.00051658595,
				"type": "OTHER"
			},
			{
				"name": "tang construction",
				"salience": 0.0004841967,
				"type": "OTHER"
			},
			{
				"name": "sheath",
				"salience": 0.0004841967,
				"type": "OTHER"
			},
			{
				"name": "grandchildren",
				"salience": 0.00046815575,
				"type": "PERSON"
			},
			{
				"name": "bagel",
				"salience": 0.00046815575,
				"type": "OTHER"
			},
			{
				"name": "situations",
				"salience": 0.00046815575,
				"type": "OTHER"
			},
			{
				"name": "email update",
				"salience": 0.00046815575,
				"type": "OTHER"
			},
			{
				"name": "thanks",
				"salience": 0.00046815575,
				"type": "OTHER"
			},
			{
				"name": "Everybody",
				"salience": 0.00043938713,
				"type": "PERSON"
			},
			{
				"name": "deal-breaker",
				"salience": 0.00043384908,
				"type": "OTHER"
			},
			{
				"name": "buck",
				"salience": 0.00042838082,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h5lwp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oregon_State_Police"
				},
				"name": "Oregon State Police",
				"salience": 0.0003956257,
				"type": "ORGANIZATION"
			},
			{
				"name": "use",
				"salience": 0.00034969507,
				"type": "OTHER"
			},
			{
				"name": "user reputation",
				"salience": 0.00034969507,
				"type": "OTHER"
			},
			{
				"name": "Boy Scout outing",
				"salience": 0.00034969507,
				"type": "EVENT"
			},
			{
				"name": "brass",
				"salience": 0.00034969507,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00034969507,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.00034969507,
				"type": "OTHER"
			},
			{
				"name": "sticks",
				"salience": 0.0003381486,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.00033388633,
				"type": "OTHER"
			},
			{
				"name": "driver",
				"salience": 0.0003296778,
				"type": "PERSON"
			},
			{
				"name": "Webelos Woods",
				"salience": 0.00031792003,
				"type": "LOCATION"
			},
			{
				"name": "Mora 840 Companion",
				"salience": 0.0002992876,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.00028811218,
				"type": "OTHER"
			},
			{
				"name": "SurvivalCommonSense.com",
				"salience": 0.00028811218,
				"type": "OTHER"
			},
			{
				"name": "Fremont District",
				"salience": 0.00021520429,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://survivalcommonsense.com/wp-content/uploads/2016/10/hawk-300x136.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T18:46:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 29.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.003",
		"text": "(Before It's News)\nby Leon Pantenburg\nI bought this knife to review. At the time of publication, Kellem Knives had no sponsorship relationship with Survivalcommonsense.com. I’m a sucker for old time knife designs, especially when they are re-created with modern materials. IMO, this makes for a time-tested, utility design that will do the job.\nI particularly like the Scandinavian Puukko design, so that’s why I got a Kellam Hawk.\nThe Kellam Hawk\nThe puukko is a Finnish knife, and the name lends itself to the Finnish word “puukotta,” which means “to stab/knife.” The prefix, “puu” means “wood” in Finnish. The design of the puukko is attributed to the indigenous Sami people, who created several knives to use for day to day tasks; the puukko was the smaller option, used to skin fish or animals.\n“Although historical records vary, the puukko dates back about 1000 years. Both men and women carried (and carry) puukkos, although the sizes change depending on the person, as the puukko handle is meant to fit the hand size of the user. (From: EDC History: Pukko – A simple knife with a rich history.)\nThe old design is getting some attention from modern knifemakers. I recently reviewed the Battle Horse Knives Feather Stick, another knife with the Puukko design, and it worked out really well.\nHere’s the Hawk’s specs:\nProduct Details:\nBlade: 3″ Carbon Steel Handle: 4.5″ Stained Curly Birch Full Tang construction Dangler-style leather sheath Total Length : 7.5″ Grind: Convex is my all-time, go-to favorite grind , but scandi is a close second or third. For a beginner, it is the easiest to learn to sharpen on. The bevel is sharpening guide – all you do is lay it flat on a whetstone and hone away.\nThe scandi is also a great woodworking grind, and a practical choice for someone looking for a bushcraft knife.\nThe Hawk handle fits my large hands very well.\nHandle: I have big hands – size large gloves – and many otherwise excellent knives don’t work for me because the handle is too short. I don’t like two or three finger grips. IMO, they don’t give a secure grip for hard work, and I’m concerned they might twist in my hand.\nThe 4.5-inch handle fits my hand really, really well. It is made of dyed curly birch, a common wood in Russia and Scandinavia, with nice figure. The wood makes a handle that doesn’t transfer heat or cold. This is a consideration for a knife that will be used in Finland’s frigid winter.\nThe diameter is large, which gives me a good, solid grip. When wet or slimy from cleaning fish, or bloody from butchering, the handle seems to get “grippier.”\nA comfortable, safe handle is a really important aspect of a user knife. Pretty doesn’t cut it (pun intended) when there are lengthy cutting tasks to be done.\nSteel: The high carbon steel holds a wicked edge. I don’t know exactly what it is, but the Hawk’s steel held up nicely to normal cutting and bushcraft tasks.\nTraditionally, Blade materials can vary from the three-layer approach, which combines strong and flexible steels, to composite designs. Most are made with Finnish steel, Ovako 100Cr6, which is equivalent to U.S 52100 bearing steel, according to Nordic knife blog Nordiska Kniva r.\nSpine: I would like the spine to be ground at a 90-degree angle, like an ice skate, so it could be used for processing tinder or scraping a ferro rod. It isn’t. But a few passes on a grinder could fix that.\nSheath: The dangler-style, form-fitted leather sheath holds the knife securely. Almost too securely. It requires a slight twist to loosen the Hawk. It’s a consideration – the knife won’t fall out, but it’s a two-hand job to remove it. This might be a deal-breaker for some users.\nI find this annoying, but you can get used to the tight sheath.\nFull tang construction with a brass bolster. I prefer a full tang on any rigid blade knife, even though I’ve never needed that extra strength. In fact, one of my favorite user knives, the Mora 840 Companion , has a plastic handle and a three-quarter tang.\nFor the strongest knife available, though, get a full tang.\nHand made in Finland.\nThe Hawk is a user knife, able to handle a variety of tasks.\nIn actual use , the Hawk lives up to the user reputation of the Puukko knives. It went along on Fremont District’s Webelos Woods, a Boy Scout outing, recently. It was used to whittle sticks and do the assorted tasks associated with camping.\nOn the way home, on an isolated section of highway, I saw a fast-moving car hit a deer up ahead of me. The front end of the vehicle was demolished, and the hood popped. The air bag deployed and the radiator was steaming.\nAfter checking out the driver and passenger for injuries, (they were shaken, but fine) the driver and I followed the injured buck. It had dragged itself across the road and was severely injured.\nIt was still alive, with two broken legs, probable internal injuries and it was in agonizing pain. We called 911. Rather than wait a possible half-hour for the Oregon State Police to arrive, we ended the deer’s suffering with the only tool available – the Kellam Hawk.\nThe knife worked quickly and humanely for the sad, but necessary task.\nThat’s the mark of a good knife. It gets the job done.\nDo you need a Hawk?\nEverybody needs a good knife . The Hawk is based on a proven design, with quality materials. The Hawk has proven to be a very useful tool, and one that can be used in a variety of situations, from slicing a bagel at work, to hunting and fishing.\nThe knife retails for $74.95, and that’s a steal for a handmade knife. If you’re looking for a good-looking user, that you can work hard and pass down to your grandchildren, the Hawk is a really good choice.\nPlease click here to check out and subscribe to the SurvivalCommonSense.com YouTube channel, and here to subscribe to our weekly email update – thanks!",
		"thread_title": "Knife Review: Kellam Hawk Is Traditional Puukko Design with Modern Materials | Survival",
		"title": "Knife Review: Kellam Hawk Is Traditional Puukko Design with Modern Materials | Survival",
		"type": "bs",
		"uuid": "e96ced0ae7d6967e317d45e213208710af7449c0"
	},
	"-KhIk-fNSg1x2NpZiX5s": {
		"author": "mitch51",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.114+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "need",
				"salience": 0.4300855,
				"type": "OTHER"
			},
			{
				"name": "Brother Hodges",
				"salience": 0.2761333,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.167402,
				"type": "PERSON"
			},
			{
				"name": "credence",
				"salience": 0.044461727,
				"type": "OTHER"
			},
			{
				"name": "ANYTHING",
				"salience": 0.033303447,
				"type": "OTHER"
			},
			{
				"name": "#",
				"salience": 0.024307014,
				"type": "OTHER"
			},
			{
				"name": "Fan",
				"salience": 0.024307014,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "1",
		"participants_count": "7",
		"published": "2016-10-26T17:07:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "Brother Hodges,\nThere is no need to have other people discredit you. You do great in accomplishing this all by yourself. I think that what lends credence to this, is that you have NEVER been right regarding ANYTHING. EVER.\nSincerely, Your #! Fan",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "ceff6bc82e92e0020cc23d22a713bd76065c2106"
	},
	"-KhIk-juHvaZgXQDkYr4": {
		"author": "Redlist Renegade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.221+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "cab",
				"salience": 0.44196078,
				"type": "OTHER"
			},
			{
				"name": "gambling addiction",
				"salience": 0.13840063,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jwvh1y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vegas_(TV_series)"
				},
				"name": "Vegas",
				"salience": 0.12200951,
				"type": "LOCATION"
			},
			{
				"name": "Candy Ass",
				"salience": 0.098467976,
				"type": "OTHER"
			},
			{
				"name": "SNITCH-51",
				"salience": 0.08316412,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02l6pt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nova_Scotia_Liberal_Party"
				},
				"name": "Liberal",
				"salience": 0.07074389,
				"type": "ORGANIZATION"
			},
			{
				"name": "opinions",
				"salience": 0.045253117,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "2",
		"participants_count": "7",
		"published": "2016-10-26T17:25:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "Keep driving your cab down there in Vegas “SNITCH-51″ with your big gambling addiction and keep your half ass Liberal “opinions” to yourself you limp wristed Candy Ass FOOL !!!",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "8c41f194a1fa9e8986c76b2869039ed3a0a26ed8"
	},
	"-KhIk-okU2ssybcdxmUP": {
		"author": "mitch51",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.240+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "something",
				"salience": 0.44517642,
				"type": "OTHER"
			},
			{
				"name": "Anything",
				"salience": 0.23984274,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.19643152,
				"type": "PERSON"
			},
			{
				"name": "KOS",
				"salience": 0.11854933,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "3",
		"participants_count": "7",
		"published": "2016-10-26T17:30:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "Then, why don’t YOU point out where he was ever right about something? I mean Anything. LOL, I agree with everyone else here. I actually think that you are KOS. You’re gay enough.",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "947cbb92d104ab4e939c9eb62d769e8e484077ed"
	},
	"-KhIk0-o20cWuN6tCg4i": {
		"author": "Redlist Renegade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.245+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "shill",
				"salience": 0.52792877,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.09050939,
				"type": "OTHER"
			},
			{
				"name": "troll",
				"salience": 0.0594029,
				"type": "OTHER"
			},
			{
				"name": "bullshit",
				"salience": 0.051587973,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0136kr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberal_Party_of_Canada"
				},
				"name": "Liberal",
				"salience": 0.041375894,
				"type": "ORGANIZATION"
			},
			{
				"name": "most",
				"salience": 0.027207028,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g6ww",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quidditch"
				},
				"name": "Snitch",
				"salience": 0.02219902,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.018420994,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.014525797,
				"type": "WORK_OF_ART"
			},
			{
				"name": "closet queer",
				"salience": 0.0135496,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.012699147,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.011942354,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.011002656,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.011002656,
				"type": "PERSON"
			},
			{
				"name": "reporting",
				"salience": 0.008914872,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.008875166,
				"type": "OTHER"
			},
			{
				"name": "thi s type",
				"salience": 0.008653522,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.007434863,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0072815414,
				"type": "OTHER"
			},
			{
				"name": "cab",
				"salience": 0.0072815414,
				"type": "OTHER"
			},
			{
				"name": "opinions",
				"salience": 0.0063070804,
				"type": "OTHER"
			},
			{
				"name": "troll buddies",
				"salience": 0.0063070804,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "cab",
				"salience": 0.005442468,
				"type": "OTHER"
			},
			{
				"name": "casinos",
				"salience": 0.0047136885,
				"type": "LOCATION"
			},
			{
				"name": "ALL",
				"salience": 0.003965425,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.0034341766,
				"type": "OTHER"
			},
			{
				"name": "Professional Sports Bettor",
				"salience": 0.0029026016,
				"type": "ORGANIZATION"
			},
			{
				"name": "living",
				"salience": 0.002565885,
				"type": "OTHER"
			},
			{
				"name": "Advanced",
				"salience": 0.002565885,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "4",
		"participants_count": "7",
		"published": "2016-10-26T18:30:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 2.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "The fact that you are ALWAYS on here dogging him with your Liberal bullshit makes it obvious that You’re a shill and a troll !!! He has a lot of valid points in his reporting and most of us that read his articles recognize that ! You and a few other people that I’ve called out on here have become obvious to most of the rest of us on here for just what you really ARE !!! If you don’t LIKE thi s type of reporting then why don’t you just get on a LIBERAL website where you can “Express” your liberal opinions along with all of your other Liberal troll buddies ?!!! Your just a closet queer that drives a cab for a living !!! If you REALLY had those two “Advanced” degrees that you like to BRAG about on here and if you were a REAL “Professional Sports Bettor” you wouldn’t be driving a cab , hanging out in casinos and spending so much time on HERE !!! You’re just a Real Looser that’s never done anything or gone anyplace in life Snitch and that’s ALL you are !!!",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "a3d938d05c70a0566da8c91a6fffd4af8668cc1e"
	},
	"-KhIk05_VIDBn1fBk3TV": {
		"author": "mitch51",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.253+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "bunch",
				"salience": 0.3780172,
				"type": "OTHER"
			},
			{
				"name": "garbage",
				"salience": 0.25085846,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.16506061,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.08194865,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.04226969,
				"type": "OTHER"
			},
			{
				"name": "basement",
				"salience": 0.01812868,
				"type": "LOCATION"
			},
			{
				"name": "spelling",
				"salience": 0.011587732,
				"type": "OTHER"
			},
			{
				"name": "dictionary",
				"salience": 0.011016926,
				"type": "OTHER"
			},
			{
				"name": "Hoggs",
				"salience": 0.009554724,
				"type": "OTHER"
			},
			{
				"name": "mother",
				"salience": 0.008449079,
				"type": "PERSON"
			},
			{
				"name": "loser",
				"salience": 0.008449079,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.008342925,
				"type": "PERSON"
			},
			{
				"name": "loosers",
				"salience": 0.006316276,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "5",
		"participants_count": "7",
		"published": "2016-10-26T18:41:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 2.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "You spouted off a bunch of rancid garbage (which you are known for) that has nothing to do with the question I asked (which you are also known for). So, how about it? Just name one thing that Hoggs has gotten right.\nAlso, if you are going to call people “loosers”, you may want to check your spelling. I can see a dictionary in your mother’s basement there. Check it out, loser.",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "868b423bffcfdbe916163137c389e16e8b533638"
	},
	"-KhIk0AMDiyh6bp34h_e": {
		"author": "Miskondukt",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.296+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "risk",
				"salience": 0.4015751,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.28751191,
				"type": "OTHER"
			},
			{
				"name": "Reporting",
				"salience": 0.15045157,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.09267676,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.06778467,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "6",
		"participants_count": "7",
		"published": "2016-10-26T17:08:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 1.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "“Do I know the risk involved in reporting on such things?” Reporting? I think you need to refresh yourself of that word’s definition.",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "b064607a430eb11a1d9e140f2fa8cc4d064d53f7"
	},
	"-KhIk0Ks3ByErZtmKTyQ": {
		"author": "bigE",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.440+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "Thanks",
				"salience": 0.43672836,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.20564428,
				"type": "OTHER"
			},
			{
				"name": "#",
				"salience": 0.14864653,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.14348638,
				"type": "LOCATION"
			},
			{
				"name": "voter fraud",
				"salience": 0.06549445,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "7",
		"participants_count": "7",
		"published": "2016-10-26T17:14:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 0.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "Thanks for the list of states and the # to call if we see voter fraud",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "7d06d0ce8114d392f53122854db4ccd90bd1bc34"
	},
	"-KhIk0QyEQcGGvz0Cshj": {
		"author": "Ideas Time",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.576+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "fraud",
				"salience": 0.18467952,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.16141492,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.16141492,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.13243128,
				"type": "PERSON"
			},
			{
				"name": "news",
				"salience": 0.04572569,
				"type": "OTHER"
			},
			{
				"name": "scam",
				"salience": 0.044871375,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.031819057,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.02603087,
				"type": "OTHER"
			},
			{
				"name": "ballots",
				"salience": 0.024754858,
				"type": "OTHER"
			},
			{
				"name": "lookout",
				"salience": 0.024140283,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.024140283,
				"type": "EVENT"
			},
			{
				"name": "elite",
				"salience": 0.02364556,
				"type": "PERSON"
			},
			{
				"name": "voting",
				"salience": 0.021556627,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.020498224,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.017701287,
				"type": "PERSON"
			},
			{
				"name": "masses",
				"salience": 0.01573243,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.0153405415,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.012913614,
				"type": "OTHER"
			},
			{
				"name": "consent",
				"salience": 0.011188666,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "8",
		"participants_count": "7",
		"published": "2016-10-26T17:14:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 4.2,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "We are already seeing signs of massive fraud, just business as usual. The good news is that millions will be on the lookout and many more will be recording events and posting them on-line over the next two weeks. Keep up the good work.\nLike they if voting was a threat to the elite would not let us do at all. It is all a scam to keep the elite in power and make the masses think consent was given.\nSecrete ballots enable all this fraud.",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "e07fefe3949823f53158eeba5620c49c6943e2f6"
	},
	"-KhIk0VKwmW75LC4BAGM": {
		"author": "patriots.bonfire",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:48.698+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "eyes",
				"salience": 0.6678535,
				"type": "OTHER"
			},
			{
				"name": "delegates",
				"salience": 0.22534959,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.10679694,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "9",
		"participants_count": "7",
		"published": "2016-10-26T18:43:00.000+03:00",
		"replies_count": "9",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "All eyes on Electoral delegates. The People know where they live!",
		"thread_title": "Clinton & Soros Bribing the Electoral College Voters-Massive Voter Fraud in AZ | Conspiracy Theories",
		"title": "",
		"type": "bs",
		"uuid": "e9a5408eab9b734582ddc113166be3cc15359212"
	},
	"-KhIk0_dtJoAGH10Sc4j": {
		"author": "Fokofpoes",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:57.251+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "man",
				"salience": 0.84215945,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.05081589,
				"type": "WORK_OF_ART"
			},
			{
				"name": "math",
				"salience": 0.03698661,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.031434555,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.012867822,
				"type": "OTHER"
			},
			{
				"name": "drafting",
				"salience": 0.012867822,
				"type": "OTHER"
			},
			{
				"name": "military enlistment",
				"salience": 0.012867822,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "8",
		"participants_count": "8",
		"published": "2016-10-26T14:45:00.000+03:00",
		"replies_count": "10",
		"sentiment": {
			"magnitude": 0.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.122",
		"text": "Yeah man, I wanted to understand how he got to that too. I’m not that horrible at math and what I just read seems a bit flawed.\nMaybe he means 95% of violence because of wars, drafting, glamourizing military enlistment, etc. Pretty sure it would’ve been a much more concise article.",
		"thread_title": "Analysis: Election Outcome Scenarios Reveal 95% Chance of Widespread Post-Election Violence… Streets of America to Run Red With Blood | War and Conflict",
		"title": "",
		"type": "bs",
		"uuid": "7137e26612ec9c16a71582e4515987ea13bb2bd9"
	},
	"-KhIk0dodn8NHvi5n1BK": {
		"author": "Fokofpoes",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:57.311+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "violence",
				"salience": 0.56857985,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.43142018,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "9",
		"participants_count": "8",
		"published": "2016-10-26T14:46:00.000+03:00",
		"replies_count": "10",
		"sentiment": {
			"magnitude": 0.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.122",
		"text": "*Maybe he means 95% chance of violence",
		"thread_title": "Analysis: Election Outcome Scenarios Reveal 95% Chance of Widespread Post-Election Violence… Streets of America to Run Red With Blood | War and Conflict",
		"title": "",
		"type": "bs",
		"uuid": "a33f908477ca95dcba8eeac2c91062a6cb2fad5b"
	},
	"-KhIk0oLAJtDZk7gnjgC": {
		"author": "Ideas Time",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T21:59:57.346+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "people",
				"salience": 0.2290423,
				"type": "PERSON"
			},
			{
				"name": "White Hats",
				"salience": 0.11779314,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.09544096,
				"type": "PERSON"
			},
			{
				"name": "options",
				"salience": 0.068291426,
				"type": "OTHER"
			},
			{
				"name": "backing",
				"salience": 0.068291426,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.068291426,
				"type": "EVENT"
			},
			{
				"name": "couple",
				"salience": 0.059383336,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b6gkfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mainstream_media"
				},
				"name": "MSM",
				"salience": 0.044233628,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.03693423,
				"type": "PERSON"
			},
			{
				"name": "Cabal",
				"salience": 0.024836106,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.022139436,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.015000905,
				"type": "PERSON"
			},
			{
				"name": "know",
				"salience": 0.012750323,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.011440552,
				"type": "OTHER"
			},
			{
				"name": "transition",
				"salience": 0.0106856795,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.010334486,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.010334486,
				"type": "EVENT"
			},
			{
				"name": "backing",
				"salience": 0.009950324,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.009950324,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.008443345,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.008443345,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.007314585,
				"type": "EVENT"
			},
			{
				"name": "money",
				"salience": 0.006312762,
				"type": "OTHER"
			},
			{
				"name": "injured parties",
				"salience": 0.0054681054,
				"type": "OTHER"
			},
			{
				"name": "Trillion Dollar Class Action Law",
				"salience": 0.0052035837,
				"type": "ORGANIZATION"
			},
			{
				"name": "jury trial",
				"salience": 0.004353965,
				"type": "EVENT"
			},
			{
				"name": "Organic Constitution",
				"salience": 0.0042844554,
				"type": "WORK_OF_ART"
			},
			{
				"name": "fraud system",
				"salience": 0.0042450936,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.004138939,
				"type": "PERSON"
			},
			{
				"name": "voting fraud",
				"salience": 0.003807464,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.0034664671,
				"type": "PERSON"
			},
			{
				"name": "law suit",
				"salience": 0.003438176,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.0029776094,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.0029776094,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "10",
		"participants_count": "8",
		"published": "2016-10-26T16:34:00.000+03:00",
		"replies_count": "10",
		"sentiment": {
			"magnitude": 3,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.122",
		"text": "Another couple of options, Maybe the White Hats now having massive backing from the Americans if they steal the election, step in and remove the Cabal. All they would have to do is take over the MSM and let the public know that will be restoring the Organic Constitution and and ask for the support and backing of the people in making this transition.\nAnother option, If they steal the election from Trump thru fraud, can you imagine if Trump and all his supporters who have donated money to the Trump campaign filled a massive Trillion Dollar Class Action Law suit against the people who are enabling the voting fraud?\nHis donors would be more than happy to donate to the cause and cost of the law suit. He could raise 100 million overnight from all the injured parties.\nTrump and people who donated money would certainly have standing.\nIf you could find an honest judge and get a jury trial and win, it could take down the entire fraud system.",
		"thread_title": "Analysis: Election Outcome Scenarios Reveal 95% Chance of Widespread Post-Election Violence… Streets of America to Run Red With Blood | War and Conflict",
		"title": "",
		"type": "bs",
		"uuid": "1ffdaef68c44d82a61406960b37f06dfd5076ab4"
	},
	"-KhIk0xz-oBZeT_bXXDC": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:00:01.720+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.15998352,
				"type": "OTHER"
			},
			{
				"name": "postings",
				"salience": 0.08276784,
				"type": "OTHER"
			},
			{
				"name": "Job Posting Analytics",
				"salience": 0.06926685,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.058356803,
				"type": "OTHER"
			},
			{
				"name": "employer",
				"salience": 0.057052,
				"type": "PERSON"
			},
			{
				"name": "skill",
				"salience": 0.047794234,
				"type": "OTHER"
			},
			{
				"name": "keyword search",
				"salience": 0.047794234,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.04150652,
				"type": "LOCATION"
			},
			{
				"name": "title",
				"salience": 0.04150652,
				"type": "OTHER"
			},
			{
				"name": "certification",
				"salience": 0.04150652,
				"type": "OTHER"
			},
			{
				"name": "users",
				"salience": 0.037056684,
				"type": "PERSON"
			},
			{
				"name": "job posting",
				"salience": 0.031440698,
				"type": "OTHER"
			},
			{
				"name": "filter",
				"salience": 0.019924788,
				"type": "OTHER"
			},
			{
				"name": "functionality",
				"salience": 0.018515557,
				"type": "OTHER"
			},
			{
				"name": "ability",
				"salience": 0.017713713,
				"type": "OTHER"
			},
			{
				"name": "datapoint",
				"salience": 0.017273461,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.011322403,
				"type": "OTHER"
			},
			{
				"name": "Analyst",
				"salience": 0.011311057,
				"type": "PERSON"
			},
			{
				"name": "text",
				"salience": 0.011311057,
				"type": "WORK_OF_ART"
			},
			{
				"name": "job postings",
				"salience": 0.010935522,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Developer",
				"salience": 0.010217448,
				"type": "ORGANIZATION"
			},
			{
				"name": "employers",
				"salience": 0.008594159,
				"type": "ORGANIZATION"
			},
			{
				"name": "text",
				"salience": 0.0079416325,
				"type": "OTHER"
			},
			{
				"name": "filters",
				"salience": 0.007172705,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Job Posting Analytics",
				"salience": 0.0069745057,
				"type": "ORGANIZATION"
			},
			{
				"name": "search",
				"salience": 0.006905696,
				"type": "EVENT"
			},
			{
				"name": "keyword",
				"salience": 0.006905696,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.006213318,
				"type": "OTHER"
			},
			{
				"name": "credentials",
				"salience": 0.006213318,
				"type": "OTHER"
			},
			{
				"name": "variables",
				"salience": 0.005981923,
				"type": "OTHER"
			},
			{
				"name": "javascript",
				"salience": 0.005858564,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.005708833,
				"type": "LOCATION"
			},
			{
				"name": "users",
				"salience": 0.0056792093,
				"type": "PERSON"
			},
			{
				"name": "detail",
				"salience": 0.00513917,
				"type": "OTHER"
			},
			{
				"name": "postings",
				"salience": 0.0050574113,
				"type": "OTHER"
			},
			{
				"name": "Job Postings",
				"salience": 0.0050574113,
				"type": "WORK_OF_ART"
			},
			{
				"name": "post",
				"salience": 0.00493099,
				"type": "WORK_OF_ART"
			},
			{
				"name": "users",
				"salience": 0.004848988,
				"type": "PERSON"
			},
			{
				"name": "skills",
				"salience": 0.004378887,
				"type": "OTHER"
			},
			{
				"name": "programs",
				"salience": 0.0037925276,
				"type": "OTHER"
			},
			{
				"name": "employer needs",
				"salience": 0.0037925276,
				"type": "OTHER"
			},
			{
				"name": "occupations",
				"salience": 0.0037925276,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0037925276,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02p97",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JavaScript"
				},
				"name": "javascript",
				"salience": 0.0036089264,
				"type": "OTHER"
			},
			{
				"name": "Text",
				"salience": 0.0035332204,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05njw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oracle_Corporation"
				},
				"name": "Oracle Corporation",
				"salience": 0.0031255197,
				"type": "ORGANIZATION"
			},
			{
				"name": "employer",
				"salience": 0.0028576322,
				"type": "PERSON"
			},
			{
				"name": "development team",
				"salience": 0.0027982933,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.002763061,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0020644532,
				"type": "PERSON"
			},
			{
				"name": "talent",
				"salience": 0.0020644532,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0020644532,
				"type": "OTHER"
			},
			{
				"name": "shoes",
				"salience": 0.0020644532,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "context",
				"salience": 0.0020644532,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08nq8w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Electronics_manufacturing_services"
				},
				"name": "Emsi",
				"salience": 0.0017011287,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.economicmodeling.com/wp-content/uploads/2016/10/FullPosting.gif",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:48:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.9,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nAs advanced as our Job Posting Analytics have become—including the ability to filter by keyword search, employer, region, title, skill, or certification—there’s something that no filter or datapoint can replace: viewing the actual job posting.\nNow within Job Posting Analytics reports in Analyst and Developer , users can view the full text of the most relevant and recent job postings tailored to their search.\nNot only will the viewable postings be filtered by the selected variables, but the keyword searched will also be highlighted in the full posting text. This extra detail makes it even easier to analyze how employers are asking for certain credentials.\nWith the quick addition of new filters, the postings displayed can be narrowed from all in New York, to all in New York that mention “javascript,” to all in New York that mention “javascript” from Oracle Corporation.\nThe real power of this new functionality is in the context it provides. Now, users can step into the shoes of the employer and understand exactly what kind of talent they’re seeking in prospective candidates. We’re thrilled to see how this new functionality will empower users to better align programs with employer needs, identify emerging skills and occupations, and more.\nOver the next few weeks, our development team will be working to increase the number of viewable postings from five to at least 50.\nThe post Now Live: View Full Text of Job Postings appeared first on Emsi .",
		"thread_title": "Now Live: View Full Text of Job Postings | Economy",
		"title": "Now Live: View Full Text of Job Postings | Economy",
		"type": "bs",
		"uuid": "f6a88e23a77d71e87b7d9d4d3584d71e870385bc"
	},
	"-KhIk10xyP5tWTNQz4hK": {
		"author": "Phonics Monkey",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:00:14.385+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "more",
				"salience": 0.5928283,
				"type": "OTHER"
			},
			{
				"name": "Leach",
				"salience": 0.40717173,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.mrctv.org/sites/default/files/uploads/Jeff%20Dunetz/facebookcensor-1024x535.jpg",
		"ord_in_thread": "1",
		"participants_count": "5",
		"published": "2016-10-26T15:10:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "“Leach” Say no more.",
		"thread_title": "This Is Definitely Pissing a Lot of Hillary People Off! | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "69b8dd4fab927ee255e51675e2b214e6d28321ea"
	},
	"-KhIk1QC-16AlPtFjXfh": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:00:14.396+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.mrctv.org/sites/default/files/uploads/Jeff%20Dunetz/facebookcensor-1024x535.jpg",
		"ord_in_thread": "2",
		"participants_count": "5",
		"published": "2016-10-26T15:24:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "This Is Definitely Pissing a Lot of Hillary People Off! | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "a0809fa2c0e8d0cf972b80ce76329d791afd311a"
	},
	"-KhIk1VTTszlc9HMaC3q": {
		"author": "spure",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:00:14.499+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.29959822,
				"type": "PERSON"
			},
			{
				"name": "Firing squad",
				"salience": 0.17461851,
				"type": "OTHER"
			},
			{
				"name": "individual",
				"salience": 0.08490042,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.07371931,
				"type": "EVENT"
			},
			{
				"name": "individuals",
				"salience": 0.05768723,
				"type": "PERSON"
			},
			{
				"name": "more",
				"salience": 0.054629624,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.05196121,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.05196121,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.050044708,
				"type": "LOCATION"
			},
			{
				"name": "hillary",
				"salience": 0.026812056,
				"type": "PERSON"
			},
			{
				"name": "zuckerburg",
				"salience": 0.019652985,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "facebook",
				"salience": 0.019652985,
				"type": "OTHER"
			},
			{
				"name": "punishment",
				"salience": 0.017380761,
				"type": "OTHER"
			},
			{
				"name": "ilk",
				"salience": 0.017380761,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.mrctv.org/sites/default/files/uploads/Jeff%20Dunetz/facebookcensor-1024x535.jpg",
		"ord_in_thread": "3",
		"participants_count": "5",
		"published": "2016-10-26T15:55:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "I concur.\nFiring squad. The worst crimes are not committed against an individual, but of a nation of individuals.\nIn Hillary’s case- against the world. There is no more of a suitable punishment for her and her ilk.\nAs for facebook, zuckerburg deserves to be right next to hillary, blindfolded.",
		"thread_title": "This Is Definitely Pissing a Lot of Hillary People Off! | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "a16c01f18d129425b2f6c78e0f29c9a62276cc67"
	},
	"-KhIk1_7CiqiByjWHLr1": {
		"author": "Redlist Renegade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:00:14.510+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "all",
				"salience": 0.3112068,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.3112068,
				"type": "OTHER"
			},
			{
				"name": "account",
				"salience": 0.179131,
				"type": "OTHER"
			},
			{
				"name": "Fakebook",
				"salience": 0.1325111,
				"type": "WORK_OF_ART"
			},
			{
				"name": "censorship",
				"salience": 0.065944314,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.mrctv.org/sites/default/files/uploads/Jeff%20Dunetz/facebookcensor-1024x535.jpg",
		"ord_in_thread": "4",
		"participants_count": "5",
		"published": "2016-10-26T16:37:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 1.2,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "I’m glad that I deleted all of my information and profile off of Fakebook and closed my account with them over three months ago !!! They aren’t what they appear to be or promote themselves to be and their censorship is totalitarian !",
		"thread_title": "This Is Definitely Pissing a Lot of Hillary People Off! | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "f378304dc3e0537afd5312f3ffe2b0452416ea24"
	},
	"-KhIk1lFHZ3m_Pn0f3JW": {
		"author": "Redlist Renegade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:00:14.534+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "slogan",
				"salience": 0.5509391,
				"type": "OTHER"
			},
			{
				"name": "Hang the Bitch",
				"salience": 0.25113204,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Burn the Witch",
				"salience": 0.19792886,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.mrctv.org/sites/default/files/uploads/Jeff%20Dunetz/facebookcensor-1024x535.jpg",
		"ord_in_thread": "5",
		"participants_count": "5",
		"published": "2016-10-26T19:03:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 0.1,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "I have another slogan ; “Hang the Bitch or Burn the Witch” !!!",
		"thread_title": "This Is Definitely Pissing a Lot of Hillary People Off! | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "225dd5d562eda64b21e479c93bf23a26fb531624"
	},
	"-KhIk1q4r0q2FjCM922A": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:00:58.425+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.81812257,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.09800916,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cost",
				"salience": 0.06168884,
				"type": "OTHER"
			},
			{
				"name": "National Living Wage",
				"salience": 0.022179423,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.469",
		"text": "(Before It's News)\nHere (£)\nand\nHere (Some free articles)\nSo, is £45Bn the true cost of the National Living Wage?",
		"thread_title": "'What is not seen' or Perhaps it is? | EU",
		"title": "'What is not seen' or Perhaps it is? | EU",
		"type": "bs",
		"uuid": "09a1c0c62ec63dfc52a4ad23a5345de46284aa34"
	},
	"-KhIk2Uh7QcfejlxGP-5": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:01:26.200+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "article",
				"salience": 0.1054627,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07b_l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Texas"
				},
				"name": "Lone Star State",
				"salience": 0.087094255,
				"type": "LOCATION"
			},
			{
				"name": "Voting Machines",
				"salience": 0.0739276,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.06391845,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.029186543,
				"type": "PERSON"
			},
			{
				"name": "weapon",
				"salience": 0.021156736,
				"type": "WORK_OF_ART"
			},
			{
				"name": "votes",
				"salience": 0.017366378,
				"type": "OTHER"
			},
			{
				"name": "Joan Stevens",
				"salience": 0.016329633,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.01344383,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.013028039,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.010613314,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.010595014,
				"type": "EVENT"
			},
			{
				"name": "times",
				"salience": 0.010248821,
				"type": "OTHER"
			},
			{
				"name": "miracle",
				"salience": 0.00882479,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.008071434,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.008071434,
				"type": "LOCATION"
			},
			{
				"name": "vote",
				"salience": 0.007736439,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.007720191,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.007622493,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.0071829874,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0066139563,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.006464885,
				"type": "OTHER"
			},
			{
				"name": "swing states",
				"salience": 0.006464885,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.006464885,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.006464885,
				"type": "LOCATION"
			},
			{
				"name": "red state",
				"salience": 0.006464885,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theory",
				"salience": 0.006388171,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0063484125,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.006326349,
				"type": "OTHER"
			},
			{
				"name": "Michael Snyder",
				"salience": 0.0060158446,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.005697061,
				"type": "LOCATION"
			},
			{
				"name": "voting",
				"salience": 0.005697061,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.0055909054,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0054047722,
				"type": "EVENT"
			},
			{
				"name": "all",
				"salience": 0.0050064125,
				"type": "OTHER"
			},
			{
				"name": "voter",
				"salience": 0.004622533,
				"type": "PERSON"
			},
			{
				"name": "hackers",
				"salience": 0.0045566866,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0045350017,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0045313113,
				"type": "OTHER"
			},
			{
				"name": "fraud",
				"salience": 0.0044555683,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/069mq3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Economic_collapse"
				},
				"name": "Economic Collapse",
				"salience": 0.004402812,
				"type": "EVENT"
			},
			{
				"name": "mainstream media",
				"salience": 0.004324107,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0042184927,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0041129515,
				"type": "OTHER"
			},
			{
				"name": "Switching Votes",
				"salience": 0.0040990603,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.0040628957,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.003797967,
				"type": "LOCATION"
			},
			{
				"name": "Team Hillary",
				"salience": 0.0037063502,
				"type": "ORGANIZATION"
			},
			{
				"name": "opportunity",
				"salience": 0.003680836,
				"type": "OTHER"
			},
			{
				"name": "electoral college",
				"salience": 0.0036533347,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.0036533347,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0036533347,
				"type": "OTHER"
			},
			{
				"name": "gamble",
				"salience": 0.003543543,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.003543543,
				"type": "OTHER"
			},
			{
				"name": "family member",
				"salience": 0.0033546176,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.0032988365,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0032988365,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.0032988365,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0032988365,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.0031814587,
				"type": "PERSON"
			},
			{
				"name": "look",
				"salience": 0.0030436537,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.0030396325,
				"type": "WORK_OF_ART"
			},
			{
				"name": "things",
				"salience": 0.0028844557,
				"type": "OTHER"
			},
			{
				"name": "Editor",
				"salience": 0.0028567635,
				"type": "PERSON"
			},
			{
				"name": "fronts",
				"salience": 0.0028567635,
				"type": "OTHER"
			},
			{
				"name": "voice",
				"salience": 0.0028567635,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0028567635,
				"type": "OTHER"
			},
			{
				"name": "Comment",
				"salience": 0.0028567635,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election",
				"salience": 0.002786535,
				"type": "EVENT"
			},
			{
				"name": "sort",
				"salience": 0.002785258,
				"type": "OTHER"
			},
			{
				"name": "establishment",
				"salience": 0.0027501786,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0026634664,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0026634664,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0026634664,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0026634664,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0026224738,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.0026154185,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0026154185,
				"type": "EVENT"
			},
			{
				"name": "precinct",
				"salience": 0.0025454117,
				"type": "LOCATION"
			},
			{
				"name": "documents",
				"salience": 0.0024664612,
				"type": "WORK_OF_ART"
			},
			{
				"name": "states",
				"salience": 0.00245243,
				"type": "LOCATION"
			},
			{
				"name": "shades",
				"salience": 0.002392251,
				"type": "OTHER"
			},
			{
				"name": "Paul Joseph Watson",
				"salience": 0.002368609,
				"type": "PERSON"
			},
			{
				"name": "odds",
				"salience": 0.002346823,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.002346761,
				"type": "EVENT"
			},
			{
				"name": "vote",
				"salience": 0.0023174528,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.002292966,
				"type": "PERSON"
			},
			{
				"name": "individuals",
				"salience": 0.0022709677,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0022385393,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0022309737,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0022309737,
				"type": "EVENT"
			},
			{
				"name": "votes",
				"salience": 0.0022309737,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0021477193,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0021475414,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.0021206634,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.0020505104,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0019384595,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0019239676,
				"type": "OTHER"
			},
			{
				"name": "relative",
				"salience": 0.0018444601,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.001821373,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.001821373,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0017702513,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.0017586233,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.0017586233,
				"type": "LOCATION"
			},
			{
				"name": "thing",
				"salience": 0.0017371754,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.0017348642,
				"type": "ORGANIZATION"
			},
			{
				"name": "voting machines",
				"salience": 0.0016455055,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0016455055,
				"type": "LOCATION"
			},
			{
				"name": "machines",
				"salience": 0.0016455055,
				"type": "OTHER"
			},
			{
				"name": "county",
				"salience": 0.0016455055,
				"type": "LOCATION"
			},
			{
				"name": "chances",
				"salience": 0.0016282924,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.0016282924,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0015840873,
				"type": "OTHER"
			},
			{
				"name": "machine",
				"salience": 0.0015840873,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.0015840873,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0015615029,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0015042691,
				"type": "PERSON"
			},
			{
				"name": "process",
				"salience": 0.0015042691,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0014971909,
				"type": "EVENT"
			},
			{
				"name": "machine",
				"salience": 0.001468039,
				"type": "OTHER"
			},
			{
				"name": "key",
				"salience": 0.0014590293,
				"type": "OTHER"
			},
			{
				"name": "voting booths",
				"salience": 0.0014406448,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0014399689,
				"type": "LOCATION"
			},
			{
				"name": "voter registrations",
				"salience": 0.0013850359,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0013606367,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0013606367,
				"type": "PERSON"
			},
			{
				"name": "anything",
				"salience": 0.0013582049,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.0013582049,
				"type": "PERSON"
			},
			{
				"name": "none",
				"salience": 0.0013582049,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0013582049,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0013582049,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.0013489911,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.0013420277,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0mps4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wichita_County,_Texas"
				},
				"name": "Wichita County",
				"salience": 0.0013337169,
				"type": "LOCATION"
			},
			{
				"name": "chance",
				"salience": 0.0013125407,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0425dz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WorldNetDaily"
				},
				"name": "WND",
				"salience": 0.0013052435,
				"type": "ORGANIZATION"
			},
			{
				"name": "time",
				"salience": 0.0012986353,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0012986353,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0012835634,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0012271745,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.001221693,
				"type": "EVENT"
			},
			{
				"name": "Heather Hawthorne",
				"salience": 0.0012010676,
				"type": "PERSON"
			},
			{
				"name": "alert",
				"salience": 0.001176087,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0011482937,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.001141643,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0011389857,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0011389857,
				"type": "LOCATION"
			},
			{
				"name": "precincts",
				"salience": 0.0011164373,
				"type": "LOCATION"
			},
			{
				"name": "ticket",
				"salience": 0.001101258,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.001101258,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.001101258,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0010990242,
				"type": "WORK_OF_ART"
			},
			{
				"name": "choice",
				"salience": 0.0010990242,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0010990242,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.001096466,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.0010604735,
				"type": "OTHER"
			},
			{
				"name": "precincts",
				"salience": 0.0010546731,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.0010546731,
				"type": "PERSON"
			},
			{
				"name": "post",
				"salience": 0.0010546731,
				"type": "WORK_OF_ART"
			},
			{
				"name": "process",
				"salience": 0.0010546731,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0010229498,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0010100582,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0010034888,
				"type": "LOCATION"
			},
			{
				"name": "count",
				"salience": 0.0010034888,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0010034888,
				"type": "LOCATION"
			},
			{
				"name": "vote counts",
				"salience": 0.0010034888,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n2q0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cuyahoga_County,_Ohio"
				},
				"name": "Cuyahoga County",
				"salience": 0.00097499776,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0009644041,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.00095816044,
				"type": "OTHER"
			},
			{
				"name": "family member",
				"salience": 0.00095225015,
				"type": "PERSON"
			},
			{
				"name": "nomination",
				"salience": 0.00095225015,
				"type": "OTHER"
			},
			{
				"name": "nominee",
				"salience": 0.00095225015,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.00095225015,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.0009409065,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0009319756,
				"type": "PERSON"
			},
			{
				"name": "everyone",
				"salience": 0.0009319756,
				"type": "PERSON"
			},
			{
				"name": "change",
				"salience": 0.0009319756,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0009283996,
				"type": "OTHER"
			},
			{
				"name": "alarm bells",
				"salience": 0.00092425215,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00091669924,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00091669924,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.00091548724,
				"type": "PERSON"
			},
			{
				"name": "pattern",
				"salience": 0.0008785329,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0nqph",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arlington,_Texas"
				},
				"name": "Arlington",
				"salience": 0.0008651073,
				"type": "LOCATION"
			},
			{
				"name": "help",
				"salience": 0.00086097326,
				"type": "OTHER"
			},
			{
				"name": "help",
				"salience": 0.00086097326,
				"type": "OTHER"
			},
			{
				"name": "vote switching",
				"salience": 0.00086097326,
				"type": "OTHER"
			},
			{
				"name": "tries",
				"salience": 0.00083507446,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0008339704,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.00082454993,
				"type": "PERSON"
			},
			{
				"name": "errors",
				"salience": 0.00082454993,
				"type": "OTHER"
			},
			{
				"name": "rumors",
				"salience": 0.00082454993,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.00082454993,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00082454993,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.00082454993,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0008145316,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0008145316,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.0008145316,
				"type": "EVENT"
			},
			{
				"name": "candidate",
				"salience": 0.0008075045,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.00079376524,
				"type": "OTHER"
			},
			{
				"name": "middle",
				"salience": 0.00079376524,
				"type": "OTHER"
			},
			{
				"name": "finger",
				"salience": 0.00079376524,
				"type": "OTHER"
			},
			{
				"name": "Quote",
				"salience": 0.00079376524,
				"type": "OTHER"
			},
			{
				"name": "anybody",
				"salience": 0.00079376524,
				"type": "PERSON"
			},
			{
				"name": "ballot",
				"salience": 0.00077735604,
				"type": "OTHER"
			},
			{
				"name": "heads",
				"salience": 0.00077735604,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00077735604,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00077735604,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00076395186,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0007427361,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00074022455,
				"type": "PERSON"
			},
			{
				"name": "word",
				"salience": 0.0007356002,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0007081356,
				"type": "PERSON"
			},
			{
				"name": "piece",
				"salience": 0.0007035479,
				"type": "OTHER"
			},
			{
				"name": "registrations",
				"salience": 0.00070283934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qr192"
				},
				"name": "Gary",
				"salience": 0.00069681066,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0006961676,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mainstream media",
				"salience": 0.0006961676,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0006961676,
				"type": "OTHER"
			},
			{
				"name": "county",
				"salience": 0.00069466233,
				"type": "LOCATION"
			},
			{
				"name": "software update",
				"salience": 0.00068031927,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0006765977,
				"type": "OTHER"
			},
			{
				"name": "share",
				"salience": 0.0006731043,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0006731043,
				"type": "EVENT"
			},
			{
				"name": "ones",
				"salience": 0.0006731043,
				"type": "PERSON"
			},
			{
				"name": "selections",
				"salience": 0.0006731043,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0006731043,
				"type": "PERSON"
			},
			{
				"name": "kaine box",
				"salience": 0.0006731043,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00064797257,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0006431262,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.0006431262,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.0006431262,
				"type": "OTHER"
			},
			{
				"name": "voter registrations",
				"salience": 0.0006431262,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0006431262,
				"type": "PERSON"
			},
			{
				"name": "president",
				"salience": 0.0006431262,
				"type": "PERSON"
			},
			{
				"name": "Poll",
				"salience": 0.0006431262,
				"type": "OTHER"
			},
			{
				"name": "poll",
				"salience": 0.0006431262,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0006289921,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.000624683,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0006196184,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0006196184,
				"type": "LOCATION"
			},
			{
				"name": "mistake",
				"salience": 0.00058544666,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0005806619,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0005806619,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0005806619,
				"type": "OTHER"
			},
			{
				"name": "winner",
				"salience": 0.0005806619,
				"type": "PERSON"
			},
			{
				"name": "results",
				"salience": 0.0005806619,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0005733431,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.00057134184,
				"type": "OTHER"
			},
			{
				"name": "voter fraud",
				"salience": 0.00057134184,
				"type": "OTHER"
			},
			{
				"name": "election fraud",
				"salience": 0.00057134184,
				"type": "OTHER"
			},
			{
				"name": "election fraud",
				"salience": 0.0005500089,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0005459547,
				"type": "OTHER"
			},
			{
				"name": "machines",
				"salience": 0.0005458951,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "voting",
				"salience": 0.0005458951,
				"type": "EVENT"
			},
			{
				"name": "voting machines",
				"salience": 0.0005458951,
				"type": "OTHER"
			},
			{
				"name": "voting machines",
				"salience": 0.0005458951,
				"type": "OTHER"
			},
			{
				"name": "electronic voting machines",
				"salience": 0.0005458951,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.0005458951,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00054090243,
				"type": "PERSON"
			},
			{
				"name": "emergency switch",
				"salience": 0.00053169846,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0005246299,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/013n60",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amarillo,_Texas"
				},
				"name": "Amarillo",
				"salience": 0.00050745474,
				"type": "LOCATION"
			},
			{
				"name": "Lisa Houlette",
				"salience": 0.00050745474,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0106m3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bowie,_Texas"
				},
				"name": "Bowie",
				"salience": 0.00050745474,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.00050745474,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0005069864,
				"type": "OTHER"
			},
			{
				"name": "multiples",
				"salience": 0.00050278427,
				"type": "OTHER"
			},
			{
				"name": "voter rolls",
				"salience": 0.00050278427,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00050278427,
				"type": "LOCATION"
			},
			{
				"name": "point",
				"salience": 0.00050278427,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00050278427,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0004995681,
				"type": "PERSON"
			},
			{
				"name": "law enforcement officials",
				"salience": 0.00049494504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00048850686,
				"type": "ORGANIZATION"
			},
			{
				"name": "None",
				"salience": 0.000486183,
				"type": "OTHER"
			},
			{
				"name": "harm",
				"salience": 0.00048401076,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00047790995,
				"type": "EVENT"
			},
			{
				"name": "perceptions",
				"salience": 0.00047400393,
				"type": "OTHER"
			},
			{
				"name": "election system",
				"salience": 0.00047188607,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0004704585,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.00046835648,
				"type": "OTHER"
			},
			{
				"name": "lots",
				"salience": 0.00045426606,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00045086825,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ms98",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chambers_County,_Texas"
				},
				"name": "Chambers County",
				"salience": 0.00044242738,
				"type": "LOCATION"
			},
			{
				"name": "article",
				"salience": 0.0004409588,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election fraud",
				"salience": 0.00042676763,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0y_bj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marion,_Ohio"
				},
				"name": "Marion",
				"salience": 0.00042488557,
				"type": "PERSON"
			},
			{
				"name": "credibility",
				"salience": 0.00042286437,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.00042286437,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.00042286437,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00042286437,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07pjmfy"
				},
				"name": "Straight",
				"salience": 0.00041424177,
				"type": "ORGANIZATION"
			},
			{
				"name": "Shandy Clark",
				"salience": 0.00041424177,
				"type": "PERSON"
			},
			{
				"name": "problem",
				"salience": 0.00040707452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02z_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fox_News_Channel"
				},
				"name": "Fox News",
				"salience": 0.000405713,
				"type": "ORGANIZATION"
			},
			{
				"name": "obligation",
				"salience": 0.00040525568,
				"type": "OTHER"
			},
			{
				"name": "election officials",
				"salience": 0.00040402965,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.00040402965,
				"type": "ORGANIZATION"
			},
			{
				"name": "choice",
				"salience": 0.00037392127,
				"type": "OTHER"
			},
			{
				"name": "intelligence services",
				"salience": 0.00036614767,
				"type": "OTHER"
			},
			{
				"name": "anonymity",
				"salience": 0.00036614767,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.00036614767,
				"type": "OTHER"
			},
			{
				"name": "ties",
				"salience": 0.00036614767,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.00036614767,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03lsq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houston_Texans"
				},
				"name": "Texans",
				"salience": 0.00035993432,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.00035247538,
				"type": "OTHER"
			},
			{
				"name": "contest",
				"salience": 0.00033931358,
				"type": "EVENT"
			},
			{
				"name": "race",
				"salience": 0.00031585724,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.00031585724,
				"type": "ORGANIZATION"
			},
			{
				"name": "race",
				"salience": 0.00031585724,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00031585724,
				"type": "OTHER"
			},
			{
				"name": "software update",
				"salience": 0.00031585724,
				"type": "OTHER"
			},
			{
				"name": "paper ballots",
				"salience": 0.00031585724,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06z9_m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Opinion_Research_Corporation"
				},
				"name": "ORC",
				"salience": 0.0003094164,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08qtd3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pew_Research_Center"
				},
				"name": "Pew Research Center",
				"salience": 0.0003094164,
				"type": "ORGANIZATION"
			},
			{
				"name": "ticket option",
				"salience": 0.00027349152,
				"type": "OTHER"
			},
			{
				"name": "phenomenon",
				"salience": 0.00027349152,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.00027349152,
				"type": "OTHER"
			},
			{
				"name": "glitch",
				"salience": 0.00027349152,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00027349152,
				"type": "OTHER"
			},
			{
				"name": "emergency protocol",
				"salience": 0.00027349152,
				"type": "OTHER"
			},
			{
				"name": "somewhere",
				"salience": 0.00027349152,
				"type": "LOCATION"
			},
			{
				"name": "column",
				"salience": 0.00027349152,
				"type": "WORK_OF_ART"
			},
			{
				"name": "eye",
				"salience": 0.00027349152,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00026355268,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.00026023042,
				"type": "LOCATION"
			},
			{
				"name": "Breitbart Texas",
				"salience": 0.00024290463,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.00022142645,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0k0symb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Breitbart_News_Network"
				},
				"name": "Breitbart",
				"salience": 0.00019437555,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j757",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_courts_of_appeals"
				},
				"name": "Court of Appeals",
				"salience": 0.00016830313,
				"type": "EVENT"
			},
			{
				"name": "Devvy Kidd",
				"salience": 0.00016830313,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04myyd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Systems_%26_Software"
				},
				"name": "ES&S",
				"salience": 0.00016830313,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "2",
		"main_img_url": "http://i2.wp.com/shtfplan.com/wp-content/uploads/2016/05/election.jpg?resize=453%2C229",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T15:22:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 35.5,
			"score": -0.2
		},
		"shares": "2",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "(Before It's News)\nThis article was written by Michael Snyder and originally published at Economic Collapse blog .\nEditor’s Comment: In particular with electronic voting, the opportunity to flip votes and steal elections is almost unstoppable and will be very difficult to hold accountable. Nonetheless, that is exactly what activists in Texas and other key states should focus on. After decades of solid “red state” status, they are now talking openly about Hillary winning the Lone Star State and flipping it blue… despite being perhaps the most despised, unlikable and untrustworthy presidential candidate in modern history.\nTake a look at the electoral college, and the shades of ‘blue and red states’ as things have been… if Team Hillary is able to steal Texas, there will be no way for Trump to win 270 electoral college, even if he wins Ohio, Florida, Pennsylvania and other swing states. Perhaps this has been their secret weapon all along, and the reason that she has been so arrogant throughout the entire campaign:\nThese are dangerous times, and the establishment – after systematically denying the voice of the people on many fronts – is now making a huge gamble at holding onto power even in the face of obvious fraud. Will there be any legitimacy left in this country? And what happens if/when this election is stolen and everyone knows it?\nIt Is Happening Again! Voting Machines Are Switching Votes From Donald Trump To Hillary Clinton\nby Michael Snyder\nIs the 2016 election in the process of being stolen? Just a few weeks ago I issued a major alert warning that this exact sort of thing might happen. Early voting has already begun in many states, and a number of voters in Texas are reporting that the voting machines switched their votes from Donald Trump to Hillary Clinton. The odd thing is that none of the other choices were affected when these individuals attempted to vote for a straight Republican ticket. If Hillary Clinton is declared the winner of the state of Texas on election night, a full investigation of these voting machines should be conducted, because there is no way that Donald Trump should lose that state. I have said that it will be the greatest miracle in U.S. political history if Donald Trump wins this election, but without the state of Texas Donald Trump has exactly zero chance of winning. So those living down in Texas need to keep reporting anything unusual that they see or hear when they go to vote.\nMost Americans don’t realize this, but the exact same thing was happening during the last presidential election. The state of Ohio was considered to be the key to Mitt Romney’s chances of winning in 2012, and right up to election day the Romney campaign actually believed that they were going to win the state.\nUnfortunately for Romney, something funny was going on with the voting machines. In a previous article , I included a Quote: from an Ohio voter that had her vote switched from Mitt Romney to Barack Obama three times …\n“I don’t know if it happened to anybody else or not, but this is the first time in all the years that we voted that this has ever happened to me,” said Marion, Ohio, voter Joan Stevens.\nStevens said that when she voted, it took her three tries before the machine accepted her choice to vote for Romney .\n“I went to vote and I got right in the middle of Romney’s name,” Stevens told Fox News, saying that she was certain to put her finger directly on her choice for the White House.\nShe said that the first time she pushed “Romney,” the machine marked “Obama.”\nSo she pushed Romney again. Obama came up again. Then it happened a third time.\n“Maybe you make a mistake once, but not three times,” she told Fox News.\nAnd we did see some very, very strange numbers come out of certain areas of Ohio four years ago.\nFor example, there were more than 100 precincts in Cuyahoga County in which Barack Obama got at least 99 percent of the vote in 2012.\nIf that happened in just one precinct that would be odd enough. But the odds of it happening in more than 100 precincts in just one county by random chance are so low that they aren’t even worth mentioning.\nAnd of course this didn’t just happen in Ohio. Similar things were happening all over the country .\nThe reason why I bring all of this up is to show that there is a pattern. If a fair vote had been conducted, Romney may have indeed won in 2012, and now it appears that voting machines are being rigged again.\nIn Wichita County, Texas so many people were reporting that their votes were being switched from Trump to Clinton that it made the local newspaper …\nShortly after early voting booths opened Monday in Wichita County, rumors swirled online about possible errors in the process. Several online posts claimed a friend or family member had attempted to vote straight party Republican ticket, but their presidential nomination was switched to the Democratic nominee, Hilary Clinton. None of the local reports were from people who experienced the situation first hand. A Bowie woman posted that a relative who lives in Arlington saw her votes “switched.” The post was shared more than 100,000 times Monday.\nAnd Paul Joseph Watson has written about some specific individuals that are making allegations that their votes for president were switched by the machines. One of the examples that he cited was a Facebook post by Lisa Houlette of Amarillo, Texas …\nGary and I went to early vote today…I voted a straight Republican ticket and as I scrolled to submit my ballot I noticed that the Republican Straight ticket was highlighted, however, the clinton/kaine box was also highlighted! I tried to go back and change and could not get it to work. I asked for help from one of the workers and she couldn’t get it to go back either. It took a second election person to get the machine to where I could correct the vote to a straight ticket. Be careful and double check your selections before you cast your vote! Don’t hesitate to ask for help. I had to have help to get mine changed.\nI don’t know about you, but major alarm bells went off in my head when I read that.\nA similar incident was reported on Facebook by Shandy Clark of Arlington, Texas …\nHey everyone, just a heads up! I had a family member that voted this morning and she voted straight Republican. She checked before she submitted and the vote had changed to Clinton! She reported it and made sure her vote was changed back. They commented that It had been happening. She is trying to get the word out and asked that we post and share. Just want everyone’s vote to be accurate and count. Check your vote before you submit!\nAnd of course they weren’t the only ones reporting vote switching. It turns out that lots of other Texans have also experienced this phenomenon …\nSo is there a serious problem with the voting machines?\nAccording to Breitbart , one county in Texas has already removed all electronic voting machines and has made an emergency switch to paper ballots…\nChambers County election officials have executed an emergency protocol to remove all electronic voting machines available during early voting until a software update can be completed to correct problems experienced by straight-ticket voters .\nChambers County Clerk Heather Hawthorne told Breitbart Texas Tuesday morning that all electronic voting was temporarily halted until her office completes a “software update” on ES&S machines that otherwise “omit one race” when a straight ticket option is selected for either major party. The Texas 14 th Court of Appeals race was reported to be the contest in which voters commonly experienced the glitch.\nLet’s keep a very close eye on this. If the state of Texas ends up in Trump’s column on election night, perhaps no harm has been done.\nBut if Trump loses Texas there is no possible way that he will be able to make up those 38 electoral votes somewhere else.\nDespite what the mainstream media is saying, the truth is that election fraud is very real. Just the other day, WND published an article that contained a list of documented cases of election fraud in 23 different states . And Devvy Kidd just authored a piece that pointed out that there are 24 million voter registrations in this country that are “no longer valid or are significantly inaccurate“…\nIn 2012 the highly respected Pew Research Center exposed the sickening state of voter rolls in this country:\nNearly 2 million deceased registered to vote\nClose to 3 million registered in multiples states\nApproximately 24 million—one of every eight—voter registrations in the United States are no longer valid or are significantly inaccurate\nMore than 1.8 million deceased individuals are listed as voters\nApproximately 2.75 million people have registrations in more than one state\nBut despite everything you just read, the mainstream media is trying very hard to prop up faith in the integrity of the process. In fact, just today CNN came out with an article entitled “ Poll: Most see a Hillary Clinton victory and a fair count ahead “…\nAlmost 7 in 10 voters nationwide say they think Hillary Clinton will win the presidency next month, but most say that if that happens, Donald Trump will not accept the results and concede, according to a new CNN/ORC poll.\nAmericans overall are more confident that the nation’s votes for president will be cast and counted accurately this year than they were in 2008. Whatever the outcome, however, nearly 8 in 10 say that once all the states have certified their vote counts, the losing candidate has an obligation to accept the results and concede to the winner.\nUnfortunately, CNN does not have much credibility left at this point, and it is getting harder and harder to believe the polls that are being put out by the mainstream media.\nAnd the mainstream media would also have us believe that if evidence of election fraud does emerge that it will be because the Russians have made it up …\nU.S. intelligence and law enforcement officials are warning that hackers with ties to Russia’s intelligence services could try to undermine the credibility of the presidential election by posting documents online purporting to show evidence of voter fraud.\nThe officials, who spoke on condition of anonymity, said however, that the U.S. election system is so large, diffuse and antiquated that hackers would not be able to change the outcome of the Nov. 8 election.\nBut hackers could post documents, some of which might be falsified, that are designed to create public perceptions of widespread voter fraud, the officials said.\nNow that is a real “conspiracy theory”, and it would be incredibly funny if all of this wasn’t so serious.\nDuring this election season, if you see or hear anything unusual about voting in your area, please report it.\nThe American people should be allowed to make a free and fair choice, and anyone that attempts to alter an election is committing a crime against all of us.\nAnd let’s watch the state of Texas very carefully. If it goes blue, you will know that something has gone terribly, terribly wrong.",
		"thread_title": "Electronic Voting Machines Caught Switching Trump Votes To Hillary: “Trying to Steal Texas” | Survival",
		"title": "Electronic Voting Machines Caught Switching Trump Votes To Hillary: “Trying to Steal Texas” | Survival",
		"type": "bs",
		"uuid": "75687ed9979bf1c6168c1435b17765e8b38a71a6"
	},
	"-KhIk2cAohSGVdks2F-5": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:01:48.813+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "Project Veritas Action",
				"salience": 0.5871293,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02xbkxm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brad_Woodhouse"
				},
				"name": "Brad Woodhouse",
				"salience": 0.049054068,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.047840577,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.047840577,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donor",
				"salience": 0.041600145,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.034130573,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.026287034,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.020058189,
				"type": "EVENT"
			},
			{
				"name": "effort",
				"salience": 0.020058189,
				"type": "OTHER"
			},
			{
				"name": "Robert Creamer",
				"salience": 0.010754184,
				"type": "PERSON"
			},
			{
				"name": "series",
				"salience": 0.010508669,
				"type": "WORK_OF_ART"
			},
			{
				"name": "donation",
				"salience": 0.009293261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02b1yn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ayr_United_F.C."
				},
				"name": "AUFC",
				"salience": 0.0090804845,
				"type": "ORGANIZATION"
			},
			{
				"name": "https://youtu.be/5IuJGHuIkzY View",
				"salience": 0.008236981,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.007666989,
				"type": "WORK_OF_ART"
			},
			{
				"name": "series",
				"salience": 0.007666989,
				"type": "WORK_OF_ART"
			},
			{
				"name": "activities",
				"salience": 0.007557972,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.006970557,
				"type": "EVENT"
			},
			{
				"name": "twist",
				"salience": 0.0060392558,
				"type": "OTHER"
			},
			{
				"name": "cost",
				"salience": 0.0060392558,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.0060392558,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.0050185225,
				"type": "WORK_OF_ART"
			},
			{
				"name": "$20,000",
				"salience": 0.003866101,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0038306026,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0035688828,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0035688828,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.003461743,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0028629908,
				"type": "OTHER"
			},
			{
				"name": "https://youtu.be/hDc8PVCvfKs",
				"salience": 0.0019849031,
				"type": "OTHER"
			},
			{
				"name": "https://youtu.be/EEQvsK5w-jY",
				"salience": 0.0019849031,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "2",
		"main_img_url": "http://media.breitbart.com/media/2016/10/Scott-Foval-Project-Veritas-Screenshot.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T20:01:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.2
		},
		"shares": "2",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nIn the effort to prove the credibility of the undercover donor featured in the videos and to keep the investigation going, Project Veritas Action made the decision to donate twenty thousand dollars to Robert Creamer’s effort. Project Veritas Action had determined that the benefit of this investigation outweighed the cost. And it did. In an unexpected twist, AUFC president Brad Woodhouse, the recipient of the $20,000, heard that Project Veritas Action was releasing undercover videos exposing AUFC’s activities. He told a journalist that AUFC was going to return the twenty thousand dollars. He said it was because they were concerned that it might have been an illegal foreign donation. Project Veritas Action was pleased but wondered why that hadn’t been a problem for the month that they had the money.\nView the first part of this series here: https://youtu.be/5IuJGHuIkzY\nView the second part of this series here: https://youtu.be/hDc8PVCvfKs\nView the third part of this series here: https://youtu.be/EEQvsK5w-jY",
		"thread_title": "New Project Veritas Release: Rigging the Election - Video IV: $20K Wire Transfer From Belize Returned | Agriculture",
		"title": "New Project Veritas Release: Rigging the Election - Video IV: $20K Wire Transfer From Belize Returned | Agriculture",
		"type": "bs",
		"uuid": "f3d09497fe1802bcf4aaea59d0d51464b2c26405"
	},
	"-KhIk2xLV_-huvGwtOQC": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:03:02.121+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://feeds.feedburner.com/~r/blogspot/zklEV/~4/BoIi4eQ-kKE",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-26T15:26:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "X22Report Shadow Banking Is Back, and This Time There Is No Hope - Episode 1110a | Politics",
		"title": "",
		"type": "bs",
		"uuid": "fa371ee46482570e434d1b677b7640906617852f"
	},
	"-KhIk376RP8v89IJoDN7": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:03:02.791+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "books",
				"salience": 0.5631195,
				"type": "WORK_OF_ART"
			},
			{
				"name": "News",
				"salience": 0.14343172,
				"type": "OTHER"
			},
			{
				"name": "holidays",
				"salience": 0.10033346,
				"type": "EVENT"
			},
			{
				"name": "stock market",
				"salience": 0.0330852,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.020417927,
				"type": "OTHER"
			},
			{
				"name": "Stock Selection System",
				"salience": 0.017572852,
				"type": "ORGANIZATION"
			},
			{
				"name": "Emerging Markets",
				"salience": 0.012033052,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018c_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Starbucks"
				},
				"name": "Starbucks",
				"salience": 0.010799447,
				"type": "ORGANIZATION"
			},
			{
				"name": "Stock Picker",
				"salience": 0.009636973,
				"type": "OTHER"
			},
			{
				"name": "Momentum",
				"salience": 0.008199697,
				"type": "OTHER"
			},
			{
				"name": "reading",
				"salience": 0.007105687,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.006959528,
				"type": "OTHER"
			},
			{
				"name": "Harriman Stock Market Almanac 2017",
				"salience": 0.0061199674,
				"type": "OTHER"
			},
			{
				"name": "Stock Market 101",
				"salience": 0.0060718837,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0drqp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Stock_market"
				},
				"name": "Stock Market",
				"salience": 0.0060718837,
				"type": "OTHER"
			},
			{
				"name": "Dividends",
				"salience": 0.006030223,
				"type": "OTHER"
			},
			{
				"name": "Frontier Investor",
				"salience": 0.005253311,
				"type": "OTHER"
			},
			{
				"name": "A Practitioner's Guide to Building a Momentum",
				"salience": 0.005057874,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0045092967,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0045092967,
				"type": "OTHER"
			},
			{
				"name": "Margins_Your Essential Guide",
				"salience": 0.00429134,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0g_23",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Market_trend"
				},
				"name": "Bull and Bear Markets",
				"salience": 0.0037173098,
				"type": "OTHER"
			},
			{
				"name": "Market Anomalies",
				"salience": 0.0024564774,
				"type": "OTHER"
			},
			{
				"name": "Studies",
				"salience": 0.0024564774,
				"type": "OTHER"
			},
			{
				"name": "Investment Ideas",
				"salience": 0.0024564774,
				"type": "OTHER"
			},
			{
				"name": "Shares",
				"salience": 0.0022297378,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xf2l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Whole_Foods_Market"
				},
				"name": "Whole Foods",
				"salience": 0.0020244815,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0841v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walmart"
				},
				"name": "Walmart",
				"salience": 0.0020244815,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07gyp7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/McDonald's"
				},
				"name": "McDonald's",
				"salience": 0.0020244815,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://ir-na.amazon-adsystem.com/e/ir?t=antiquestocka-20&l=am2&o=1&a=0231170440",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": 0.4
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "(Before It's News) If you re looking for new and interesting books to read over the holidays that are related to the stock market and investing, look no further than the following list. These are books that have recently been released or will be released within the next couple weeks. Happy reading!\nQuantitative Momentum: A Practitioner’s Guide to Building a Momentum-Based Stock Selection System – – – Frontier Investor: How to Prosper in the Next Emerging Markets – – –\nStock Market 101: From Bull and Bear Markets to Dividends, Shares, and Margins_Your Essential Guide to the Stock Market – – –\nGreat Investment Ideas – – – The Harriman Stock Market Almanac 2017: Seasonality Analysis and Studies of Market Anomalies to Give You an Edge in the Year Ahead – – –\nThe Stock Picker: A financial history from the sharp end – – –\nHow to Spot the Next Starbucks, Whole Foods, Walmart, or McDonald’s BEFORE Its Shares Explode – – –",
		"thread_title": "The Latest Stock Market and Investing Books | Financial Markets",
		"title": "The Latest Stock Market and Investing Books | Financial Markets",
		"type": "bs",
		"uuid": "1f480295cd7e931f7e405cd6644c3238a29c4229"
	},
	"-KhIk3W_Xf8YPM09fI8k": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:03:02.972+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "1",
		"participants_count": "3",
		"published": "2016-10-26T15:22:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "Not Without the Consent of the Governed | Police State",
		"title": "",
		"type": "bs",
		"uuid": "0b3c43e5f7265fdbc41274b46a652be190474b08"
	},
	"-KhIk3cJu4OF_Ch3U_8W": {
		"author": "Redlist Renegade",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:03:03.069+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "people",
				"salience": 0.61531216,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.14315964,
				"type": "ORGANIZATION"
			},
			{
				"name": "Tyranny",
				"salience": 0.08651915,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.08481467,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.035451677,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03rj_w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Liberty"
				},
				"name": "Liberty",
				"salience": 0.034742683,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thecommonsenseshow.com/siteupload/2015/12/CSS-Offical-New-Logo2.jpg",
		"ord_in_thread": "2",
		"participants_count": "3",
		"published": "2016-10-26T18:10:00.000+03:00",
		"replies_count": "2",
		"sentiment": {
			"magnitude": 0.2,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "When the people fear their government there’s Tyranny , when the government fears the people there’s Liberty !!!",
		"thread_title": "Not Without the Consent of the Governed | Police State",
		"title": "",
		"type": "bs",
		"uuid": "171c96f043fba6a33ae55061166a63fb19711a6c"
	},
	"-KhIk3kGjl5JOv6cL_wj": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:03:27.849+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.48004344,
				"type": "OTHER"
			},
			{
				"name": "voting protocols",
				"salience": 0.07503198,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.070370816,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.051157303,
				"type": "OTHER"
			},
			{
				"name": "voter registration card",
				"salience": 0.051157303,
				"type": "OTHER"
			},
			{
				"name": "ID",
				"salience": 0.051157303,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.046737667,
				"type": "LOCATION"
			},
			{
				"name": "printout",
				"salience": 0.043520976,
				"type": "OTHER"
			},
			{
				"name": "cash register receipt",
				"salience": 0.043520976,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.036770348,
				"type": "OTHER"
			},
			{
				"name": "address",
				"salience": 0.032657493,
				"type": "OTHER"
			},
			{
				"name": "birth",
				"salience": 0.017874405,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.7,
			"score": -0.7
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "(Before It's News)\nCompare and contrast New Jersey and Florida voting protocols, In Florida the information on your voter registration card and ID have to match, you are issued a 12″ printout (similar to a cash register receipt) showing your name, date of birth and address which you then must confirm, and that is placed on a clear […]",
		"thread_title": "Now waiting for the results | Opinion - Conservative",
		"title": "Now waiting for the results | Opinion - Conservative",
		"type": "bs",
		"uuid": "a7a877b4e765222f4c36bfd8cc8228d3ba195b19"
	},
	"-KhIk3uvOWGNVJkEPv4a": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:03:55.099+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.2997941,
				"type": "OTHER"
			},
			{
				"name": "discovery",
				"salience": 0.08617493,
				"type": "OTHER"
			},
			{
				"name": "discovery",
				"salience": 0.08617493,
				"type": "OTHER"
			},
			{
				"name": "Location",
				"salience": 0.074971445,
				"type": "LOCATION"
			},
			{
				"name": "Bancroft Crater",
				"salience": 0.05940481,
				"type": "PERSON"
			},
			{
				"name": "entrance",
				"salience": 0.046129182,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.04004316,
				"type": "LOCATION"
			},
			{
				"name": "crater",
				"salience": 0.039534274,
				"type": "OTHER"
			},
			{
				"name": "Coordinates",
				"salience": 0.03141633,
				"type": "OTHER"
			},
			{
				"name": "crater",
				"salience": 0.027167749,
				"type": "OTHER"
			},
			{
				"name": "Earths Moon Google Earth",
				"salience": 0.022411281,
				"type": "ORGANIZATION"
			},
			{
				"name": "base entrance",
				"salience": 0.021494858,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03q0br",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bancroft_(crater)"
				},
				"name": "Bancroft",
				"salience": 0.015169256,
				"type": "LOCATION"
			},
			{
				"name": "opening",
				"salience": 0.012861719,
				"type": "EVENT"
			},
			{
				"name": "edges",
				"salience": 0.012861719,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.012075106,
				"type": "OTHER"
			},
			{
				"name": "ruler",
				"salience": 0.011336376,
				"type": "OTHER"
			},
			{
				"name": "entrance",
				"salience": 0.0102159865,
				"type": "OTHER"
			},
			{
				"name": "shadow",
				"salience": 0.009261657,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.009261657,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/045c7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google"
				},
				"name": "Google",
				"salience": 0.008932505,
				"type": "ORGANIZATION"
			},
			{
				"name": "design",
				"salience": 0.006924379,
				"type": "OTHER"
			},
			{
				"name": "base entrance",
				"salience": 0.0057099783,
				"type": "OTHER"
			},
			{
				"name": "entrance",
				"salience": 0.0057099783,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.005046274,
				"type": "OTHER"
			},
			{
				"name": "contributions",
				"salience": 0.005046274,
				"type": "OTHER"
			},
			{
				"name": "Prophecy",
				"salience": 0.005046274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05fcbj9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Google_Mars"
				},
				"name": "Google Mars",
				"salience": 0.004925206,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09cws",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mars"
				},
				"name": "Mars",
				"salience": 0.004925206,
				"type": "LOCATION"
			},
			{
				"name": "ships",
				"salience": 0.0037711381,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0037711381,
				"type": "OTHER"
			},
			{
				"name": "Scott C. Waring",
				"salience": 0.003107777,
				"type": "PERSON"
			},
			{
				"name": "Jeffery Pritchett",
				"salience": 0.003107777,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFO",
				"salience": 0.003107777,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/019lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bigfoot"
				},
				"name": "Bigfoot",
				"salience": 0.003107777,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/mediadrop/uploads/2016/43/9bf33a31a1a8ca1b868368b95f1b6e63a07f7259.png",
		"ord_in_thread": "0",
		"participants_count": "2",
		"published": "2016-10-26T18:24:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 2,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nDate of discovery: October 26, 2016\nLocation of discovery: Bancroft Crater, Earths Moon\nGoogle Earth Coordinates: 27°54’52.71″N 6°23’23.82″W\nI found this entrance to an underground alien base inside of Bancroft crater. The dark opening measures 70 meters by 50 meters exactly. The outer edges measure 114 meters by 114 meters. I used Google ruler to measure this, so it is their statistics. The base entrance is just outside the shadow of the crater, which means it was placed there deliberately to be in the light and make entering and exiting it with smaller ships much easier. Similar base entrance have been found before. For instance, a very similar entrance was found on Google Mars and was 160 meters across, but with similar design. (Click here to view the Mars entrance) .\nScott C. Waring\n Thanks http://www.ufosightingsdaily.com/ Check out more contributions by Jeffery Pritchett ranging from UFO to Bigfoot to Paranormal to Prophecy",
		"thread_title": "Doorway on Moon Found at Bancroft Crater, Google Map, Oct 2016, Photos | Paranormal",
		"title": "Doorway on Moon Found at Bancroft Crater, Google Map, Oct 2016, Photos | Paranormal",
		"type": "bs",
		"uuid": "5bff60c8bd8a209d4baec26d1fcc0c7ce0eb9ccb"
	},
	"-KhIk3z-NLo66QqxyGIt": {
		"author": "nwo2012",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:03:55.179+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "something",
				"salience": 0.3009069,
				"type": "OTHER"
			},
			{
				"name": "crater",
				"salience": 0.21543746,
				"type": "OTHER"
			},
			{
				"name": "rim",
				"salience": 0.20777984,
				"type": "OTHER"
			},
			{
				"name": "structure",
				"salience": 0.17748909,
				"type": "OTHER"
			},
			{
				"name": "V",
				"salience": 0.09838673,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/mediadrop/uploads/2016/43/9bf33a31a1a8ca1b868368b95f1b6e63a07f7259.png",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-26T19:23:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "i actually think your on to something i looked at the rim of the crater and found what looks like a structure/base\n28° 6’14.37″N 6°38’27.81″V",
		"thread_title": "Doorway on Moon Found at Bancroft Crater, Google Map, Oct 2016, Photos | Paranormal",
		"title": "",
		"type": "bs",
		"uuid": "66232bb771cb32f05542bea3b275bcb058a93b38"
	},
	"-KhIk47XQqEMI6rC_PKv": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:03:56.246+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.12074007,
				"type": "OTHER"
			},
			{
				"name": "trade deficit",
				"salience": 0.08764176,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.07551097,
				"type": "PERSON"
			},
			{
				"name": "taxes",
				"salience": 0.042174637,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.039254818,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.038685963,
				"type": "PERSON"
			},
			{
				"name": "letter",
				"salience": 0.035606943,
				"type": "WORK_OF_ART"
			},
			{
				"name": "imports",
				"salience": 0.03193031,
				"type": "OTHER"
			},
			{
				"name": "Vote",
				"salience": 0.029647382,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.028711312,
				"type": "OTHER"
			},
			{
				"name": "bunkum",
				"salience": 0.027847432,
				"type": "OTHER"
			},
			{
				"name": "imports",
				"salience": 0.026552714,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05zwc7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_J._Boudreaux"
				},
				"name": "Donald J. Boudreaux",
				"salience": 0.025970077,
				"type": "PERSON"
			},
			{
				"name": "mash",
				"salience": 0.025715372,
				"type": "OTHER"
			},
			{
				"name": "Growth",
				"salience": 0.024151573,
				"type": "OTHER"
			},
			{
				"name": "defense",
				"salience": 0.024151573,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.023347741,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.018157162,
				"type": "OTHER"
			},
			{
				"name": "Wilbur Ross",
				"salience": 0.017370632,
				"type": "PERSON"
			},
			{
				"name": "A Vote for Trump",
				"salience": 0.017217379,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/017b3j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Wall_Street_Journal"
				},
				"name": "Wall Street Journal",
				"salience": 0.014922953,
				"type": "ORGANIZATION"
			},
			{
				"name": "imports",
				"salience": 0.014838815,
				"type": "OTHER"
			},
			{
				"name": "Peter Navarro",
				"salience": 0.013500893,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.01186894,
				"type": "OTHER"
			},
			{
				"name": "trade negotiations",
				"salience": 0.010991158,
				"type": "EVENT"
			},
			{
				"name": "foreigners",
				"salience": 0.009860985,
				"type": "PERSON"
			},
			{
				"name": "exports",
				"salience": 0.0075494484,
				"type": "OTHER"
			},
			{
				"name": "imports",
				"salience": 0.0064334814,
				"type": "OTHER"
			},
			{
				"name": "taxes",
				"salience": 0.0063762716,
				"type": "OTHER"
			},
			{
				"name": "destination",
				"salience": 0.0054497593,
				"type": "LOCATION"
			},
			{
				"name": "claim",
				"salience": 0.0051155468,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.005103661,
				"type": "OTHER"
			},
			{
				"name": "spending power",
				"salience": 0.0047107167,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.004670848,
				"type": "OTHER"
			},
			{
				"name": "foreigners",
				"salience": 0.004417293,
				"type": "PERSON"
			},
			{
				"name": "exports",
				"salience": 0.0043261247,
				"type": "OTHER"
			},
			{
				"name": "exports",
				"salience": 0.0043261247,
				"type": "OTHER"
			},
			{
				"name": "exports",
				"salience": 0.0043261247,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0042846287,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0041961935,
				"type": "OTHER"
			},
			{
				"name": "regulation",
				"salience": 0.0041433894,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.0040217424,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0038440882,
				"type": "LOCATION"
			},
			{
				"name": "price",
				"salience": 0.0038230752,
				"type": "OTHER"
			},
			{
				"name": "promise",
				"salience": 0.0037749587,
				"type": "OTHER"
			},
			{
				"name": "capital stock",
				"salience": 0.0035884632,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0035884632,
				"type": "OTHER"
			},
			{
				"name": "size",
				"salience": 0.0035884632,
				"type": "OTHER"
			},
			{
				"name": "contributions",
				"salience": 0.0035884632,
				"type": "OTHER"
			},
			{
				"name": "investment",
				"salience": 0.0035884632,
				"type": "OTHER"
			},
			{
				"name": "Rubbish",
				"salience": 0.0034546538,
				"type": "OTHER"
			},
			{
				"name": "government intrusions",
				"salience": 0.0034546538,
				"type": "OTHER"
			},
			{
				"name": "commerce",
				"salience": 0.0034546538,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0034546538,
				"type": "OTHER"
			},
			{
				"name": "exports",
				"salience": 0.0032328211,
				"type": "OTHER"
			},
			{
				"name": "regulation",
				"salience": 0.0027977433,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0026081784,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0025646305,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0024047417,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/034jx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Great_Depression"
				},
				"name": "Great Depression",
				"salience": 0.0022095533,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0021892332,
				"type": "PERSON"
			},
			{
				"name": "Bunk. Trump",
				"salience": 0.0020507127,
				"type": "PERSON"
			},
			{
				"name": "freedom",
				"salience": 0.0018414748,
				"type": "OTHER"
			},
			{
				"name": "Professor",
				"salience": 0.0015946286,
				"type": "PERSON"
			},
			{
				"name": "circle",
				"salience": 0.0015946286,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.0015946286,
				"type": "OTHER"
			},
			{
				"name": "foreigners",
				"salience": 0.0015236401,
				"type": "PERSON"
			},
			{
				"name": "confusion",
				"salience": 0.00119127,
				"type": "OTHER"
			},
			{
				"name": "return",
				"salience": 0.00119127,
				"type": "OTHER"
			},
			{
				"name": "architect",
				"salience": 0.00119127,
				"type": "PERSON"
			},
			{
				"name": "camp",
				"salience": 0.00119127,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02j62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Economics"
				},
				"name": "Economics",
				"salience": 0.001133531,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d65tx"
				},
				"name": "Martha",
				"salience": 0.0009815424,
				"type": "PERSON"
			},
			{
				"name": "Nelson Getchell Chair",
				"salience": 0.0009815424,
				"type": "ORGANIZATION"
			},
			{
				"name": "Study of Free Market Capitalism",
				"salience": 0.0009815424,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0mnzd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fairfax,_Virginia"
				},
				"name": "Fairfax",
				"salience": 0.0009815424,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/039d4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Mason_University"
				},
				"name": "George Mason University",
				"salience": 0.0009815424,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0b38yh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mercatus_Center"
				},
				"name": "Mercatus Center",
				"salience": 0.0009815424,
				"type": "ORGANIZATION"
			},
			{
				"name": "VA 22030",
				"salience": 0.0009815424,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://feeds.feedburner.com/~ff/CafeHayek?d=yIl2AUoC8zA",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T20:01:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "(Before It's News)\n(Don Boudreaux)\nTweet\nHere’s a letter to the Wall Street Journal :\nWilbur Ross’s and Peter Navarro’s defense of Donald Trump’s economic policies is mostly a mash of bunkum (“ A Vote for Trump Is a Vote for Growth ,” Oct. 26). Consider this claim: “Donald Trump will cut taxes, reduce regulation … and eliminate our trade deficit through muscular trade negotiations that increase exports, [and] reduce imports….”\nCut taxes? Bunk. Trump famously promises to raise taxes on Americans who buy imports. Reduce regulation? Rubbish. Trump promises more government intrusions into Americans’ commerce with foreigners.\nAs for ‘eliminating’ our trade deficit, Trump might indeed succeed on that front. But such ‘success’ would be regrettable, for it would be the inevitable outcome of the American economy being made an unattractive destination for investment. (Ross and Navarro seem to be unaware that to “eliminate our trade deficit” – such as was done, for example, during the Great Depression – is to eliminate net contributions by foreigners to increasing the size of America’s capital stock.)\nBut Trump’s most absurd promise is to enrich Americans by increasing exports and reducing imports. Imports are what we voluntarily buy and exports are the price we pay. Therefore, a policy meant to increase exports while decreasing imports is a policy meant to force Americans to pay more to foreigners and to receive less in return – a decidedly unartful deal the architect of which would deserved to be fired.\nBut the Trump camp’s confusion runs even more deeply. Exporting for Americans is worthwhile only because it supplies us with the means to purchase imports, either currently or in the future. So a policy that aims both to increase exports and to decrease imports is akin to a policy that aims both to increase people’s spending power and to decrease it. It’s a policy meant to give Americans greater means for acquiring imports as it simultaneously strips Americans of the freedom to use those means. It’s the economic policy equivalent of an attempt to square a circle.\nSincerely,\nDonald J. Boudreaux\nProfessor of Economics\nand\nMartha and Nelson Getchell Chair for the Study of Free Market Capitalism at the Mercatus Center\nGeorge Mason University\nFairfax, VA 22030",
		"thread_title": "It Literally Hurts My Brain to Read the Economic Idiocy Emitted by Trumpkins | Libertarian",
		"title": "It Literally Hurts My Brain to Read the Economic Idiocy Emitted by Trumpkins | Libertarian",
		"type": "bs",
		"uuid": "f5b6637b246e983986742249a9a8289bcca3d538"
	},
	"-KhIk4KXZfXQExo7eznM": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:04:25.054+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.39606568,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.18350004,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.15350837,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.034377053,
				"type": "EVENT"
			},
			{
				"name": "establishment",
				"salience": 0.02570911,
				"type": "OTHER"
			},
			{
				"name": "escalator",
				"salience": 0.012046185,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "version",
				"salience": 0.012046185,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Conservatism",
				"salience": 0.010522344,
				"type": "OTHER"
			},
			{
				"name": "intelligentsia",
				"salience": 0.007907482,
				"type": "PERSON"
			},
			{
				"name": "conservatives",
				"salience": 0.0077342615,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.007572618,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04qqj8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Trump_Tower_(New_York_City)"
				},
				"name": "Trump Tower",
				"salience": 0.0074386615,
				"type": "LOCATION"
			},
			{
				"name": "nomination",
				"salience": 0.006176666,
				"type": "OTHER"
			},
			{
				"name": "waves",
				"salience": 0.006176666,
				"type": "OTHER"
			},
			{
				"name": "newcomers",
				"salience": 0.0054773563,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.005227051,
				"type": "PERSON"
			},
			{
				"name": "goal",
				"salience": 0.004706576,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0038526154,
				"type": "OTHER"
			},
			{
				"name": "pitchfork populists",
				"salience": 0.0032580327,
				"type": "PERSON"
			},
			{
				"name": "guns",
				"salience": 0.0029422278,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "agenda",
				"salience": 0.0028686703,
				"type": "OTHER"
			},
			{
				"name": "conservatism",
				"salience": 0.0026389759,
				"type": "OTHER"
			},
			{
				"name": "soldiers",
				"salience": 0.002548306,
				"type": "PERSON"
			},
			{
				"name": "abortion",
				"salience": 0.002548306,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.002548306,
				"type": "OTHER"
			},
			{
				"name": "preferences",
				"salience": 0.002548306,
				"type": "OTHER"
			},
			{
				"name": "working class",
				"salience": 0.002548306,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.002548306,
				"type": "OTHER"
			},
			{
				"name": "shores",
				"salience": 0.002548306,
				"type": "LOCATION"
			},
			{
				"name": "conservative",
				"salience": 0.00254061,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0024982318,
				"type": "LOCATION"
			},
			{
				"name": "interdependency",
				"salience": 0.0023147163,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.0022169275,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.0020638944,
				"type": "OTHER"
			},
			{
				"name": "elites",
				"salience": 0.0020638944,
				"type": "PERSON"
			},
			{
				"name": "causes",
				"salience": 0.0020638944,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0020200042,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0019619204,
				"type": "OTHER"
			},
			{
				"name": "populism",
				"salience": 0.0018662801,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.0017874107,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0017874107,
				"type": "ORGANIZATION"
			},
			{
				"name": "pieties",
				"salience": 0.0017874107,
				"type": "OTHER"
			},
			{
				"name": "peaks",
				"salience": 0.0017874107,
				"type": "OTHER"
			},
			{
				"name": "success",
				"salience": 0.0017874107,
				"type": "OTHER"
			},
			{
				"name": "impulses",
				"salience": 0.0017207452,
				"type": "OTHER"
			},
			{
				"name": "shift necessary.",
				"salience": 0.0017207452,
				"type": "OTHER"
			},
			{
				"name": "approach",
				"salience": 0.0017207452,
				"type": "OTHER"
			},
			{
				"name": "gay marriage",
				"salience": 0.0017207452,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.0016852083,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "Constitution",
				"salience": 0.0016251701,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06c0j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ronald_Reagan"
				},
				"name": "Ronald Reagan",
				"salience": 0.0015692913,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/016m7b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pat_Buchanan"
				},
				"name": "Pat Buchanan",
				"salience": 0.0015692913,
				"type": "PERSON"
			},
			{
				"name": "George Wallace Southerners",
				"salience": 0.0015692913,
				"type": "PERSON"
			},
			{
				"name": "grass-roots passions",
				"salience": 0.0014593985,
				"type": "OTHER"
			},
			{
				"name": "anger",
				"salience": 0.0014593985,
				"type": "OTHER"
			},
			{
				"name": "energy",
				"salience": 0.0014593985,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.0013525387,
				"type": "OTHER"
			},
			{
				"name": "element",
				"salience": 0.0013355047,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04ljqjd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ross_Douthat"
				},
				"name": "Ross Douthat",
				"salience": 0.0013309243,
				"type": "PERSON"
			},
			{
				"name": "plutocracy",
				"salience": 0.0012856778,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ngmw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rich_Lowry"
				},
				"name": "Rich Lowry",
				"salience": 0.0012812682,
				"type": "PERSON"
			},
			{
				"name": "guns",
				"salience": 0.0012591174,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "babies",
				"salience": 0.001090355,
				"type": "PERSON"
			},
			{
				"name": "wars",
				"salience": 0.001090355,
				"type": "EVENT"
			},
			{
				"name": "labor",
				"salience": 0.001090355,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.001090355,
				"type": "LOCATION"
			},
			{
				"name": "influx",
				"salience": 0.001090355,
				"type": "OTHER"
			},
			{
				"name": "free-trade deals",
				"salience": 0.0009851978,
				"type": "OTHER"
			},
			{
				"name": "gestures",
				"salience": 0.00093648315,
				"type": "OTHER"
			},
			{
				"name": "lip service",
				"salience": 0.00093648315,
				"type": "OTHER"
			},
			{
				"name": "falcon",
				"salience": 0.00091713166,
				"type": "OTHER"
			},
			{
				"name": "yokels",
				"salience": 0.00091303606,
				"type": "PERSON"
			},
			{
				"name": "matter",
				"salience": 0.00084615644,
				"type": "OTHER"
			},
			{
				"name": "elite",
				"salience": 0.00082867034,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00082138064,
				"type": "PERSON"
			},
			{
				"name": "falls",
				"salience": 0.00079417904,
				"type": "OTHER"
			},
			{
				"name": "signaling structure",
				"salience": 0.00079417904,
				"type": "OTHER"
			},
			{
				"name": "failure theater",
				"salience": 0.00079417904,
				"type": "LOCATION"
			},
			{
				"name": "round",
				"salience": 0.00079417904,
				"type": "EVENT"
			},
			{
				"name": "analogy",
				"salience": 0.0007841729,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0007645371,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07g9y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Third_World"
				},
				"name": "Third World",
				"salience": 0.00067117694,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.00067117694,
				"type": "LOCATION"
			},
			{
				"name": "establishment candidate",
				"salience": 0.000593277,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.000593277,
				"type": "OTHER"
			},
			{
				"name": "backers",
				"salience": 0.000593277,
				"type": "PERSON"
			},
			{
				"name": "wing",
				"salience": 0.000593277,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07skc3n"
				},
				"name": "Falconer",
				"salience": 0.0005645197,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0271_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitt_Romney"
				},
				"name": "Mitt Romney",
				"salience": 0.00036514414,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019x9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeb_Bush"
				},
				"name": "Jeb",
				"salience": 0.00036514414,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01sgfj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chamber_of_commerce"
				},
				"name": "Chamber of Commerce",
				"salience": 0.00036514414,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:07:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nThis is a good article :\n“When Donald Trump rode down an escalator at Trump Tower to launch his presidential campaign in June 2015, he began galvanizing a populist version of the Republican Party.\nBut he didn’t create it.\nThe GOP that carried Mr. Trump to the presidential nomination was formed by waves of new voters who washed onto Republican shores in the last four decades: George Wallace Southerners, Ronald Reagan Democrats, Pat Buchanan pitchfork populists and tea-party foot soldiers.\nThe Republican establishment was happy to have the votes of these newcomers, many from America’s working class, and accommodated their cultural preferences on social issues from guns to abortion to gay marriage. What the establishment didn’t do was adjust the GOP’s economic approach to match the populist impulses—or even seem to consider such a shift necessary. …”\nRich Lowry put it well here :\n“Our basic argument about Trump is simple and unassailable: He is a populist, not a conservative. Conservatism has always had a populist element, but it has been tethered to conservatism’s animating causes of liberty, limited government and the Constitution. Trump inveighs against elites and tramples on political pieties, but these causes are afterthoughts to him, at best.”\nRoss Douthat put it better here:\n“Sometimes this interdependency has worked out well. At its peaks of political success, the conservative intelligentsia has channeled and directed populism, responding to grass-roots passions without being ruled by them.”\nThe goal of the conservative intelligentsia has always been to CUCK the populist vote so that all of its anger and energy can be “tethered” or “channeled” into advancing the conservative agenda (read: classical liberal agenda) of the “governing wing” of the Republican Party. The role of populist voters in the GOP is to show up on election day and vote for a handpicked establishment candidate like Mitt Romney or ¡Jeb!\nIn this way, the conservatives can pass new free-trade deals for their corporate backers in the US Chamber of Commerce, start massive new destructive, unending wars in the Middle East, and keep the border wide open so that an endless influx of Third World cheap labor can further enrich the plutocracy. They figured all those yokels would just keep voting for them indefinitely because Democrats want to abort babies and seize guns.\nGive them lip service! Give them token gestures! Give them round after round of failure theater! You know, it kind of worked too until their whole signaling structure broke down. That’s what happens when an elite loses its legitimacy. To borrow an analogy, the falcon doesn’t respond to the Falconer anymore and the elite falls.\nIt is only a matter of time.",
		"thread_title": "Wall Street Journal: Republicans Rode Waves of Populism Until They Crashed the Party | Politics",
		"title": "Wall Street Journal: Republicans Rode Waves of Populism Until They Crashed the Party | Politics",
		"type": "bs",
		"uuid": "9c18b7a7d3da5d114f4f24db3fb460c3b1e16df2"
	},
	"-KhIk4x82zFW70eRW5Uu": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:04:40.512+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "method",
				"salience": 0.08730192,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.060605578,
				"type": "PERSON"
			},
			{
				"name": "News",
				"salience": 0.04624378,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Clinton",
				"salience": 0.038128275,
				"type": "LOCATION"
			},
			{
				"name": "data",
				"salience": 0.022728307,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.019728744,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.019728744,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.019536365,
				"type": "LOCATION"
			},
			{
				"name": "polling data",
				"salience": 0.018224413,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.016182618,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0gl0hx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nate_Silver"
				},
				"name": "Nate Silver",
				"salience": 0.014458087,
				"type": "PERSON"
			},
			{
				"name": "handle",
				"salience": 0.013180677,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.012668709,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.012668709,
				"type": "PERSON"
			},
			{
				"name": "gap",
				"salience": 0.01201564,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.010120981,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.010099731,
				"type": "LOCATION"
			},
			{
				"name": "poll",
				"salience": 0.010099731,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.010099731,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.010099731,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.009294792,
				"type": "ORGANIZATION"
			},
			{
				"name": "college",
				"salience": 0.008585489,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.008521423,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.008283364,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.008283364,
				"type": "OTHER"
			},
			{
				"name": "polling data",
				"salience": 0.0077650663,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.006919358,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.006842844,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.006842844,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.0068155015,
				"type": "PERSON"
			},
			{
				"name": "Things",
				"salience": 0.006671735,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.006671735,
				"type": "OTHER"
			},
			{
				"name": "outcomes",
				"salience": 0.006478902,
				"type": "OTHER"
			},
			{
				"name": "outcomes",
				"salience": 0.006478902,
				"type": "OTHER"
			},
			{
				"name": "Primaries",
				"salience": 0.0060733096,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.0060479753,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.005898721,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.005611239,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.0054543503,
				"type": "OTHER"
			},
			{
				"name": "waste",
				"salience": 0.0054426687,
				"type": "OTHER"
			},
			{
				"name": "no one",
				"salience": 0.0050669415,
				"type": "PERSON"
			},
			{
				"name": "states",
				"salience": 0.0048462925,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0048462925,
				"type": "LOCATION"
			},
			{
				"name": "access",
				"salience": 0.0047950824,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.0047742804,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.004734716,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.004476003,
				"type": "EVENT"
			},
			{
				"name": "organizations",
				"salience": 0.004388126,
				"type": "ORGANIZATION"
			},
			{
				"name": "team",
				"salience": 0.004388126,
				"type": "ORGANIZATION"
			},
			{
				"name": "process",
				"salience": 0.004388126,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.004388126,
				"type": "OTHER"
			},
			{
				"name": "identities",
				"salience": 0.004388126,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/047lhgv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/FiveThirtyEight"
				},
				"name": "FiveThirtyEight",
				"salience": 0.00424091,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0041627344,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.0041627344,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0041627344,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0041627344,
				"type": "LOCATION"
			},
			{
				"name": "primaries",
				"salience": 0.004153126,
				"type": "EVENT"
			},
			{
				"name": "polling data",
				"salience": 0.004122094,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.004003531,
				"type": "OTHER"
			},
			{
				"name": "election season",
				"salience": 0.0038898299,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05fkf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Carolina"
				},
				"name": "North Carolina",
				"salience": 0.0038095908,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.003597651,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.003413023,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.003413023,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.003413023,
				"type": "OTHER"
			},
			{
				"name": "methods",
				"salience": 0.003413023,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.003288995,
				"type": "PERSON"
			},
			{
				"name": "distribution data",
				"salience": 0.0031991804,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0031499432,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.0029191852,
				"type": "OTHER"
			},
			{
				"name": "preparation",
				"salience": 0.0028696205,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.0028667322,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0028187786,
				"type": "PERSON"
			},
			{
				"name": "race",
				"salience": 0.0028187786,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.0028102568,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.0028102568,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0028102568,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0027920608,
				"type": "LOCATION"
			},
			{
				"name": "states",
				"salience": 0.0027920608,
				"type": "LOCATION"
			},
			{
				"name": "polling data",
				"salience": 0.002747756,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0027135937,
				"type": "EVENT"
			},
			{
				"name": "outcome",
				"salience": 0.0026686918,
				"type": "OTHER"
			},
			{
				"name": "outcomes",
				"salience": 0.0026686918,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0026686918,
				"type": "OTHER"
			},
			{
				"name": "technique",
				"salience": 0.0025279564,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.0025014507,
				"type": "EVENT"
			},
			{
				"name": "polls",
				"salience": 0.0023832656,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0023832656,
				"type": "LOCATION"
			},
			{
				"name": "polling data",
				"salience": 0.002359986,
				"type": "OTHER"
			},
			{
				"name": "swing states",
				"salience": 0.0023357102,
				"type": "LOCATION"
			},
			{
				"name": "swing",
				"salience": 0.0023109505,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0023109505,
				"type": "OTHER"
			},
			{
				"name": "estimates",
				"salience": 0.0023109505,
				"type": "OTHER"
			},
			{
				"name": "election results",
				"salience": 0.0023109505,
				"type": "OTHER"
			},
			{
				"name": "voter behavior",
				"salience": 0.0023109505,
				"type": "OTHER"
			},
			{
				"name": "handful",
				"salience": 0.0023109505,
				"type": "OTHER"
			},
			{
				"name": "voting behavior",
				"salience": 0.0023109505,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.0023085477,
				"type": "LOCATION"
			},
			{
				"name": "analysis",
				"salience": 0.0023032164,
				"type": "OTHER"
			},
			{
				"name": "polling data",
				"salience": 0.0022432876,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0021342516,
				"type": "PERSON"
			},
			{
				"name": "quality",
				"salience": 0.0020865889,
				"type": "OTHER"
			},
			{
				"name": "undecideds",
				"salience": 0.0020267197,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.001993692,
				"type": "PERSON"
			},
			{
				"name": "things",
				"salience": 0.0019764814,
				"type": "OTHER"
			},
			{
				"name": "races",
				"salience": 0.0019764814,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0019764814,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "POTUS",
				"salience": 0.0018842111,
				"type": "ORGANIZATION"
			},
			{
				"name": "candidates",
				"salience": 0.0018712182,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0018712182,
				"type": "ORGANIZATION"
			},
			{
				"name": "backlash effect",
				"salience": 0.0018149441,
				"type": "OTHER"
			},
			{
				"name": "instance",
				"salience": 0.0018068379,
				"type": "OTHER"
			},
			{
				"name": "contests",
				"salience": 0.0018068379,
				"type": "EVENT"
			},
			{
				"name": "independents",
				"salience": 0.0018068379,
				"type": "PERSON"
			},
			{
				"name": "level",
				"salience": 0.0018068379,
				"type": "OTHER"
			},
			{
				"name": "other",
				"salience": 0.0018013737,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.0018013737,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "some",
				"salience": 0.0018013737,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0018013737,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.001767156,
				"type": "PERSON"
			},
			{
				"name": "debate",
				"salience": 0.0017539274,
				"type": "OTHER"
			},
			{
				"name": "sexual assault",
				"salience": 0.0017539274,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0016884587,
				"type": "OTHER"
			},
			{
				"name": "Primaries",
				"salience": 0.0016884587,
				"type": "EVENT"
			},
			{
				"name": "debate",
				"salience": 0.0016884587,
				"type": "EVENT"
			},
			{
				"name": "difference",
				"salience": 0.0016203284,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0016135464,
				"type": "EVENT"
			},
			{
				"name": "race",
				"salience": 0.0016135464,
				"type": "EVENT"
			},
			{
				"name": "expansion",
				"salience": 0.0016119643,
				"type": "EVENT"
			},
			{
				"name": "some",
				"salience": 0.0016070892,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0015598441,
				"type": "EVENT"
			},
			{
				"name": "voting behavior",
				"salience": 0.0015598441,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.0015337418,
				"type": "OTHER"
			},
			{
				"name": "digit",
				"salience": 0.001462988,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.001462988,
				"type": "EVENT"
			},
			{
				"name": "shooting distance",
				"salience": 0.001462988,
				"type": "OTHER"
			},
			{
				"name": "funding effect",
				"salience": 0.001462988,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.001462988,
				"type": "OTHER"
			},
			{
				"name": "sexual assault",
				"salience": 0.0014318422,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0014121644,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0014083746,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0014083746,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0014083746,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0014083746,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.0014083746,
				"type": "OTHER"
			},
			{
				"name": "rating",
				"salience": 0.0014083746,
				"type": "OTHER"
			},
			{
				"name": "C ratings",
				"salience": 0.0014083746,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.0013802279,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0013740624,
				"type": "OTHER"
			},
			{
				"name": "True Trump",
				"salience": 0.0013609286,
				"type": "PERSON"
			},
			{
				"name": "A",
				"salience": 0.0013327337,
				"type": "OTHER"
			},
			{
				"name": "support form",
				"salience": 0.0013227673,
				"type": "OTHER"
			},
			{
				"name": "gun someone",
				"salience": 0.0013227673,
				"type": "PERSON"
			},
			{
				"name": "formation",
				"salience": 0.0013227673,
				"type": "OTHER"
			},
			{
				"name": "tax forms",
				"salience": 0.0013227673,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0013227673,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.001296697,
				"type": "LOCATION"
			},
			{
				"name": "polls",
				"salience": 0.001296697,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.001296697,
				"type": "OTHER"
			},
			{
				"name": "swing states",
				"salience": 0.001296697,
				"type": "LOCATION"
			},
			{
				"name": "difference",
				"salience": 0.0012733864,
				"type": "OTHER"
			},
			{
				"name": "difference",
				"salience": 0.0012733864,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0012733864,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.001272497,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.001272497,
				"type": "OTHER"
			},
			{
				"name": "tapes",
				"salience": 0.0012668127,
				"type": "WORK_OF_ART"
			},
			{
				"name": "re-closing",
				"salience": 0.0012668127,
				"type": "EVENT"
			},
			{
				"name": "range",
				"salience": 0.0012668127,
				"type": "OTHER"
			},
			{
				"name": "commenters",
				"salience": 0.0012668127,
				"type": "PERSON"
			},
			{
				"name": "pacs",
				"salience": 0.0012668127,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.0012668127,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0012668127,
				"type": "OTHER"
			},
			{
				"name": "shift",
				"salience": 0.0012668127,
				"type": "EVENT"
			},
			{
				"name": "response",
				"salience": 0.0012668127,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.0012668127,
				"type": "WORK_OF_ART"
			},
			{
				"name": "release",
				"salience": 0.0012668127,
				"type": "EVENT"
			},
			{
				"name": "tax return",
				"salience": 0.0012668127,
				"type": "OTHER"
			},
			{
				"name": "rout",
				"salience": 0.0012668127,
				"type": "OTHER"
			},
			{
				"name": "spread",
				"salience": 0.0012668127,
				"type": "EVENT"
			},
			{
				"name": "accusations",
				"salience": 0.0012668127,
				"type": "OTHER"
			},
			{
				"name": "B",
				"salience": 0.0012195199,
				"type": "OTHER"
			},
			{
				"name": "periods",
				"salience": 0.0012195199,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.0012195199,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.0012195199,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.0012095544,
				"type": "OTHER"
			},
			{
				"name": "bunch",
				"salience": 0.0012095544,
				"type": "PERSON"
			},
			{
				"name": "votes",
				"salience": 0.0012053332,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0011943112,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.001181274,
				"type": "OTHER"
			},
			{
				"name": "admonition",
				"salience": 0.001144588,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.001141126,
				"type": "OTHER"
			},
			{
				"name": "analyses",
				"salience": 0.001069584,
				"type": "OTHER"
			},
			{
				"name": "map",
				"salience": 0.0010662249,
				"type": "WORK_OF_ART"
			},
			{
				"name": "method",
				"salience": 0.0010629998,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.0010629998,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.0010617614,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0010473521,
				"type": "OTHER"
			},
			{
				"name": "category",
				"salience": 0.0010405672,
				"type": "OTHER"
			},
			{
				"name": "Maximal Clintonosity",
				"salience": 0.0010374527,
				"type": "OTHER"
			},
			{
				"name": "rat",
				"salience": 0.0010341523,
				"type": "OTHER"
			},
			{
				"name": "narrowing",
				"salience": 0.0010341523,
				"type": "OTHER"
			},
			{
				"name": "Defeat",
				"salience": 0.0010341523,
				"type": "EVENT"
			},
			{
				"name": "debate performance",
				"salience": 0.0010341523,
				"type": "OTHER"
			},
			{
				"name": "incredulity",
				"salience": 0.0010341523,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0010341523,
				"type": "LOCATION"
			},
			{
				"name": "wishes",
				"salience": 0.0010341523,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0010127743,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0009963545,
				"type": "OTHER"
			},
			{
				"name": "map",
				"salience": 0.0009880973,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0009880973,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0009880973,
				"type": "OTHER"
			},
			{
				"name": "observations",
				"salience": 0.000970607,
				"type": "OTHER"
			},
			{
				"name": "voting activities",
				"salience": 0.0009050636,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0008955695,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0008955695,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.000892133,
				"type": "OTHER"
			},
			{
				"name": "ass",
				"salience": 0.00088814733,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.0008778145,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0008778145,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.00083104975,
				"type": "OTHER"
			},
			{
				"name": "model",
				"salience": 0.00083104975,
				"type": "OTHER"
			},
			{
				"name": "map",
				"salience": 0.00081690936,
				"type": "OTHER"
			},
			{
				"name": "Great Gap",
				"salience": 0.0008141055,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0007923346,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "NYT",
				"salience": 0.0007796629,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03f38n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Get_out_the_vote"
				},
				"name": "GOTV",
				"salience": 0.0007796629,
				"type": "ORGANIZATION"
			},
			{
				"name": "same",
				"salience": 0.00077894336,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00077248755,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00077248755,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07srw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Utah"
				},
				"name": "Utah",
				"salience": 0.00075055246,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03s0w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa"
				},
				"name": "Iowa",
				"salience": 0.00075055246,
				"type": "LOCATION"
			},
			{
				"name": "words",
				"salience": 0.0007195945,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.000715879,
				"type": "OTHER"
			},
			{
				"name": "spate",
				"salience": 0.00069794664,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0006927264,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0006556992,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0006556992,
				"type": "PERSON"
			},
			{
				"name": "sexual assault thing",
				"salience": 0.0006556992,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.0006497023,
				"type": "WORK_OF_ART"
			},
			{
				"name": "quality",
				"salience": 0.0006497023,
				"type": "OTHER"
			},
			{
				"name": "column",
				"salience": 0.0006497023,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05kkh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ohio"
				},
				"name": "Ohio",
				"salience": 0.0006369141,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0cc56",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Manhattan"
				},
				"name": "Manhattan",
				"salience": 0.0006364549,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.00062076526,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.00062076526,
				"type": "PERSON"
			},
			{
				"name": "sexual assault",
				"salience": 0.0005818414,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0005818414,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.0005643598,
				"type": "PERSON"
			},
			{
				"name": "convergence",
				"salience": 0.00056256424,
				"type": "OTHER"
			},
			{
				"name": "bit",
				"salience": 0.00056256424,
				"type": "OTHER"
			},
			{
				"name": "calibration",
				"salience": 0.00056256424,
				"type": "OTHER"
			},
			{
				"name": "calculation",
				"salience": 0.00056256424,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.00056256424,
				"type": "PERSON"
			},
			{
				"name": "tail",
				"salience": 0.00056256424,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00056256424,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00053750764,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.00053750764,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.00048797,
				"type": "LOCATION"
			},
			{
				"name": "cases",
				"salience": 0.00048529851,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.00048529851,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00045188234,
				"type": "LOCATION"
			},
			{
				"name": "none",
				"salience": 0.00042020757,
				"type": "OTHER"
			},
			{
				"name": "asshole country",
				"salience": 0.00042020757,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.00042020757,
				"type": "OTHER"
			},
			{
				"name": "write",
				"salience": 0.00042020757,
				"type": "OTHER"
			},
			{
				"name": "leaders",
				"salience": 0.00042020757,
				"type": "PERSON"
			},
			{
				"name": "change",
				"salience": 0.00039615287,
				"type": "OTHER"
			},
			{
				"name": "regression coefficients",
				"salience": 0.00039438278,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d0x8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)"
				},
				"name": "Georgia",
				"salience": 0.00034620403,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059f4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Hampshire"
				},
				"name": "New Hampshire",
				"salience": 0.00034620403,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05tbn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pennsylvania"
				},
				"name": "Pennsylvania",
				"salience": 0.00034620403,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Johnson",
				"salience": 0.00025859306,
				"type": "PERSON"
			},
			{
				"name": "True Haters of Trump",
				"salience": 0.00022491213,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "9",
		"main_img_url": "http://scienceblogs.com/gregladen/files/2016/10/Screen-Shot-2016-10-26-at-11.34.33-AM-610x471.png",
		"ord_in_thread": "0",
		"participants_count": "2",
		"published": "2016-10-26T18:49:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 23.7,
			"score": 0
		},
		"shares": "9",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "(Before It's News)\nIt is fun to look at polls, and using such data, decide which candidate will win which state, and ultimately, which candidate will win the electoral college. A lot of people and organizations do that, and for this reason, I don’t. I do not have access to polls that no one else sees. Were I to use polling data to directly predict outcomes per state, I’d use a method like that used by FiveThirtyEight, and probably come up with similar results. How boring. It would be a waste of my time to try to replicate the excellent work done by Nate Silver and his team.\nBack during the Democratic Primaries, I decided that I wanted to get a handle on which candidate was likely to win, fairly early on. The polling based estimates were inadequate because most states simply didn’t have polling data that early in the process. So, I invented an alternative method, which made certain estimates of how voters with different ethnic identities would vote. That method accurately predicted several primary outcomes, outperforming the poll based methods such as those used by FiveThirtyEight.\nAfter a while, enough primaries had been carried out that I could switch methods slightly. Using the same exact model, but primed with the results of prior primaries (that year) rather than my estimates of voter behavior, I used the ethnic distribution data for each state to predict the outcome of upcoming primary contests.\nOnce again, my method was very accurate, and once again, it out performed the polling based methods.\nSo, recently, I’ve tried to apply a similar method to estimating the electoral outcome for this year’s presidential race. But, it is impossible to use the same exact method because the entire thing happens all on one day. I can’t use the election results from a handful of states to estimate the likely future outcomes in other states.\nI recognize that polling data is very limited on a national level. Things happen during an election season that probably change people’s likely voting behavior, especially among independents. Solid states are rarely polled, and small states, swing or not, are rarely polled. Many polls are of low quality. Right now, for instance, fewer than half of the states have polls that were a) taken fully after the final POTUS debate and b) have an A- or better rating from FiveThirtyEight. If I allow the use of B and occasional C ratings for recent polls, and allow a few polls to include periods of time prior to the last POTUS debate, but only in states that are very strongly in favor of one candidate or the other (and thus likely to not move anyway), I can find 32 states that have sort of usable polling data. Interestingly, states with some of the more controversial changes happening, like Utah and Iowa, are not adequately polled.\nIn order to apply a model like the one I used in the Primaries to the current election, I used the 32 states for which there was somewhat acceptable recent polling data to inform the model (to calculate the regression coefficients) in order to then, separately, predict the likely voting behavior (Trump vs. Clinton) in all of the states.\nBefore I show you the map, however, I need to discuss something else.\nAbout a week ago the press, especially the somewhat more left leaning press, and various commenters, seeing much reaction to a series of events beginning with the NYT release of Trump’s tax return and ending with the final POTUS debate, events which sandwiched the sexual assault tapes and accusations, collectively decided that a huge gap between Clinton and Trump was rapidly opening up and the race would end with a double digit spread, an electoral rout, and a big party.\nSoon after, I pointed out that this may not be correct. That polling data seemed to show, rather, that there was an expansion of the difference between the two candidates followed by a re-closing of the gap, with Clinton still leading but by about as much as before this temporary shift. To this I added a concern. If too many people assumed that the race was over and in the double digit range, perhaps there could be a GOTV backlash effect, or a funding effect, that would shift things to within shooting distance for Trump.\nI was not alone in thinking this, and I was probably right. The GOP sunk, via pacs, 25 million dollars into Senate races in response to the Democrats shifting from the national race to the Senate, which was followed by the Democrats shifting back to the national race in certain states, presumably recognizing that the polls were artificially spread. Indeed, some who criticized (arguing mainly from incredulity and good wishes) my admonition noted, correctly, that some of that narrowing was because a bunch of right-leaning polls had come out all at once. This is true, but it ignores that a bunch of left-leaning polls had made the formation of the Great Gap of GOP Defeat look a lot bigger than it ever really was.\nI say all this as part one of my preparation for what I’m going to tell you below, which is not the news you want to hear. Part two is some logic I’d like to bludgeon you with.\nConsider these points:\n1) True Trump supporters could give a rat’s ass about sexual assault, poor debate performance, or tax forms. Donald Trump was correct when he said, weeks ago, now forgotten, that he could gun someone down on the streets of Manhattan and he would not lose support form his base. These people did not abandon him when he was heard to talk about sexual assault. If anything, they were energized by it. And, I’m talking about something just shy of 40% of the voters. We live in a barely civilized asshole country.\n2) Please tell me exactly which Hillary Clinton supporters, who were going to vote for Clinton over Trump all along, are NOW going to pick Clinton (if polled or on voting day) that change from not being Clinton supporters to being Clinton supporters? In other words (this is a somewhat subtle point) which people who hated Trump became True Haters of Trump after the sexual assault thing? Almost none. They were already there.\n3) The third category of people, the undecideds (who are only lying about being undecided, in most cases) and the so-called “reasonable Republicans” (of which there are very, very few), who could conceivably shift from Trump to Clinton are going to divide their voting activities between Johnson, a write in (as they are being advised by Republican leaders in some cases) or simply staying home.\nIn other words, over the last few weeks, no source has emerged that hands Secretary Clinton more electoral votes than she probably had about a month ago, and Trump is not going to have any, or at least not many, electoral votes go away.\nThose observations (part one) and that logic (part two) cause me to be utterly unsurprised to find out that an analysis of the electoral map I did on October 16th and one I did today do not show Clinton pulling farther ahead. In fact, the two analyses have Clinton being less far ahead than Trump now than ten days ago. The difference is in Ohio (shifting from Clinton to Trump) which is almost certainly going to happen, and North Carolina (which shifted from Clinton to Trump in this analysis) which seems much less likely to happen, and Arizona shifting from Clinton (that was probably wishful thinking) to Trump.\nThe point here is this, plain and simple. An analysis using a technique that has worked very well for me in the past shows that the difference between that moment of Maximal Clintonosity and today is plus or minus a couple of state. In other words, not different. Maybe a little worse. Really, about the same.\nHere’s the current map:\nObviously, I will be watching for more data over the next few days. I assume there will be a spate of polls as we approach November 8th (the day Democrats vote. Republicans vote on the 28th of November). If so, then there will be convergence between my method of calibration and my method of calculation, and the model will consume itself by the tail and become very accurate at the same time.\nBut between now and then, perhaps that very small number of polls that are both recent and high quality will grow a bit more and I can do this again and resolve those closer states.\nBy the way, the “swing states” according to my model, the states where things are close, are Ohio, North Carolina, Arizona, and Georgia of those now in the Trump column. Those are indeed swing states. Numerically, the close states that are in the Clinton column are Virginia, New Hampshire, and Pennsylvania.",
		"thread_title": "Clinton Vs. Trump: Latest Electoral Prediction [Greg Laden's Blog] | Science and Technology",
		"title": "Clinton Vs. Trump: Latest Electoral Prediction [Greg Laden's Blog] | Science and Technology",
		"type": "bs",
		"uuid": "55fcdf36d820505ede3ae74be6fee13fc70ad350"
	},
	"-KhIk55Yx35KGha0jK1w": {
		"author": "Tennessee Dan",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:04:41.311+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "hillary",
				"salience": 0.089560695,
				"type": "PERSON"
			},
			{
				"name": "Shillary",
				"salience": 0.0765594,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.06572223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.060528208,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0824r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wisconsin"
				},
				"name": "Wisconsin",
				"salience": 0.05339856,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.05032255,
				"type": "OTHER"
			},
			{
				"name": "vote",
				"salience": 0.05032255,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02xry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida"
				},
				"name": "Florida",
				"salience": 0.048332542,
				"type": "LOCATION"
			},
			{
				"name": "hag",
				"salience": 0.03022925,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.029578483,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.027068488,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.02092998,
				"type": "OTHER"
			},
			{
				"name": "college",
				"salience": 0.020836866,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.020836866,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.020836866,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.018308537,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.017627373,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.016255775,
				"type": "EVENT"
			},
			{
				"name": "demographics",
				"salience": 0.014626338,
				"type": "OTHER"
			},
			{
				"name": "middle school gym",
				"salience": 0.014626338,
				"type": "OTHER"
			},
			{
				"name": "football stadiums",
				"salience": 0.014626338,
				"type": "OTHER"
			},
			{
				"name": "statistics",
				"salience": 0.014626338,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.014081756,
				"type": "OTHER"
			},
			{
				"name": "top",
				"salience": 0.014081756,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.014081756,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.013791429,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.011946143,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.011946143,
				"type": "PERSON"
			},
			{
				"name": "subscribers",
				"salience": 0.011946143,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.011072609,
				"type": "EVENT"
			},
			{
				"name": "election",
				"salience": 0.010308775,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.009604223,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.009011367,
				"type": "PERSON"
			},
			{
				"name": "Hildebeast",
				"salience": 0.009011367,
				"type": "PERSON"
			},
			{
				"name": "martial law",
				"salience": 0.008928574,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.008928574,
				"type": "LOCATION"
			},
			{
				"name": "millions",
				"salience": 0.0075114053,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0075114053,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0glpjll",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Instagram"
				},
				"name": "instagram",
				"salience": 0.00735846,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "twitter",
				"salience": 0.00735846,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007177308,
				"type": "PERSON"
			},
			{
				"name": "prison pages",
				"salience": 0.0056126937,
				"type": "OTHER"
			},
			{
				"name": "president pages",
				"salience": 0.0056126937,
				"type": "OTHER"
			},
			{
				"name": "HONEST",
				"salience": 0.005498364,
				"type": "OTHER"
			},
			{
				"name": "likes",
				"salience": 0.0048605776,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "whitehouse",
				"salience": 0.0040052184,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "facebook",
				"salience": 0.0029922228,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://scienceblogs.com/gregladen/files/2016/10/Screen-Shot-2016-10-26-at-11.34.33-AM-610x471.png",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-26T19:46:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 6.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "Wisconsin, Michigan and Florida will go to Trump too. Trump will landslide the popular vote. George Soros has already said as much. The only way Shillary wins is by paying off the electoral college at which point we go to war right here at home because there is no way in hell that people will allow that nasty criminal hag to steal the election on top of everything else she has stolen.\nYou want demographics and statistics? Trump fills football stadiums. Hildebeast can’t fill a middle school gym. Tim Kaine gave a speech to 30 people in Florida 2 days ago. Those 30 people included the press and secret service.\nLoom at twitter followers, instagram subscribers, and facebook likes. More people like the hillary for prison pages than the hillary for president pages.\nShe can not, would not and should not win an HONEST election. She is going to have to declare martial law her first day in office because I and millions and millions of people like me will make her every waking minute miserable for however long she thinks she will occupy our whitehouse.",
		"thread_title": "Clinton Vs. Trump: Latest Electoral Prediction [Greg Laden's Blog] | Science and Technology",
		"title": "",
		"type": "bs",
		"uuid": "9287450bd1baf5b74479e0b00b78ece022a59490"
	},
	"-KhIk5E5cpbFPxXTe8tg": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:04:59.659+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.196754,
				"type": "OTHER"
			},
			{
				"name": "Project Veritas Action",
				"salience": 0.17509446,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02xbkxm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brad_Woodhouse"
				},
				"name": "Brad Woodhouse",
				"salience": 0.13145089,
				"type": "PERSON"
			},
			{
				"name": "Video IV",
				"salience": 0.061454818,
				"type": "WORK_OF_ART"
			},
			{
				"name": "effort",
				"salience": 0.055659357,
				"type": "OTHER"
			},
			{
				"name": "Election",
				"salience": 0.04838292,
				"type": "EVENT"
			},
			{
				"name": "decision",
				"salience": 0.0305481,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0164b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Belize"
				},
				"name": "Belize",
				"salience": 0.030067155,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.030067155,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.025775118,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.023301836,
				"type": "EVENT"
			},
			{
				"name": "donor",
				"salience": 0.020209273,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.016528798,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.015787655,
				"type": "OTHER"
			},
			{
				"name": "donation",
				"salience": 0.010789904,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02b1yn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ayr_United_F.C."
				},
				"name": "AUFC",
				"salience": 0.01054274,
				"type": "ORGANIZATION"
			},
			{
				"name": "https://youtu.be/5IuJGHuIkzY View",
				"salience": 0.009562977,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.008900956,
				"type": "WORK_OF_ART"
			},
			{
				"name": "series",
				"salience": 0.008900956,
				"type": "WORK_OF_ART"
			},
			{
				"name": "series",
				"salience": 0.008900956,
				"type": "WORK_OF_ART"
			},
			{
				"name": "activities",
				"salience": 0.008774342,
				"type": "OTHER"
			},
			{
				"name": "Robert Creamer",
				"salience": 0.008444679,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.008092137,
				"type": "EVENT"
			},
			{
				"name": "cost",
				"salience": 0.0072815707,
				"type": "OTHER"
			},
			{
				"name": "twist",
				"salience": 0.0072815707,
				"type": "OTHER"
			},
			{
				"name": "benefit",
				"salience": 0.007010639,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.0052684005,
				"type": "WORK_OF_ART"
			},
			{
				"name": "$20,000",
				"salience": 0.004487424,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0044462127,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0041423747,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0041423747,
				"type": "OTHER"
			},
			{
				"name": "journalist",
				"salience": 0.004017995,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.0033229263,
				"type": "OTHER"
			},
			{
				"name": "https://youtu.be/hDc8PVCvfKs",
				"salience": 0.0023036674,
				"type": "OTHER"
			},
			{
				"name": "https://youtu.be/EEQvsK5w-jY",
				"salience": 0.0023036674,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://feeds.feedburner.com/~r/blogspot/zklEV/~4/9MjRhkXSN-k",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T20:03:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nRigging the Election – Video IV: $20K Wire Transfer From Belize Returned – YouTube\nIn the effort to prove the credibility of the undercover donor featured in the videos and to keep the investigation going, Project Veritas Action made the decision to donate twenty thousand dollars to Robert Creamer’s effort. Project Veritas Action had determined that the benefit of this investigation outweighed the cost. And it did. In an unexpected twist, AUFC president Brad Woodhouse, the recipient of the $20,000, heard that Project Veritas Action was releasing undercover videos exposing AUFC’s activities. He told a journalist that AUFC was going to return the twenty thousand dollars. He said it was because they were concerned that it might have been an illegal foreign donation. Project Veritas Action was pleased but wondered why that hadn’t been a problem for the month that they had the money.\nView the first part of this series here: https://youtu.be/5IuJGHuIkzY\nView the second part of this series here: https://youtu.be/hDc8PVCvfKs\nView the third part of this series here: https://youtu.be/EEQvsK5w-jY",
		"thread_title": "Project Veritas Video IV: $20K Wire Transfer From Belize Returned | Politics",
		"title": "Project Veritas Video IV: $20K Wire Transfer From Belize Returned | Politics",
		"type": "bs",
		"uuid": "6fe8cfedb2d5de5dd338477629dd959ed95ce51d"
	},
	"-KhIk5SMKH6rqOgt5w0s": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:05:12.355+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "singer",
				"salience": 0.25891998,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.21410118,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.13565883,
				"type": "OTHER"
			},
			{
				"name": "Denasia Lawrence",
				"salience": 0.093867555,
				"type": "PERSON"
			},
			{
				"name": "anthem",
				"salience": 0.044890683,
				"type": "OTHER"
			},
			{
				"name": "performance",
				"salience": 0.035290845,
				"type": "EVENT"
			},
			{
				"name": "preseason game",
				"salience": 0.035290845,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05jvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Basketball_Association"
				},
				"name": "NBA",
				"salience": 0.021886727,
				"type": "ORGANIZATION"
			},
			{
				"name": "oppression",
				"salience": 0.01925697,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jm2v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miami_Heat"
				},
				"name": "Miami Heat",
				"salience": 0.01747534,
				"type": "ORGANIZATION"
			},
			{
				"name": "staff",
				"salience": 0.009755801,
				"type": "PERSON"
			},
			{
				"name": "shirt",
				"salience": 0.008693576,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "midcourt",
				"salience": 0.0086549185,
				"type": "OTHER"
			},
			{
				"name": "anthem",
				"salience": 0.00837629,
				"type": "OTHER"
			},
			{
				"name": "knee",
				"salience": 0.007532427,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.0055614794,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.005422571,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.00535442,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.005287122,
				"type": "WORK_OF_ART"
			},
			{
				"name": "jacket",
				"salience": 0.005220668,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "right",
				"salience": 0.0047181584,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.004318205,
				"type": "LOCATION"
			},
			{
				"name": "injustices",
				"salience": 0.0033523315,
				"type": "OTHER"
			},
			{
				"name": "shirt",
				"salience": 0.0032831414,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0032572972,
				"type": "OTHER"
			},
			{
				"name": "cry",
				"salience": 0.0032273682,
				"type": "OTHER"
			},
			{
				"name": "sort",
				"salience": 0.0032273682,
				"type": "OTHER"
			},
			{
				"name": "fame",
				"salience": 0.0032273682,
				"type": "OTHER"
			},
			{
				"name": "hashtag",
				"salience": 0.0032273682,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0027150845,
				"type": "OTHER"
			},
			{
				"name": "anthem",
				"salience": 0.0025827389,
				"type": "OTHER"
			},
			{
				"name": "Sheeple",
				"salience": 0.0023513674,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0023513674,
				"type": "OTHER"
			},
			{
				"name": "analyses",
				"salience": 0.0023513674,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.0023513674,
				"type": "WORK_OF_ART"
			},
			{
				"name": "details",
				"salience": 0.0023513674,
				"type": "OTHER"
			},
			{
				"name": "warning",
				"salience": 0.0018482411,
				"type": "OTHER"
			},
			{
				"name": "The Daily",
				"salience": 0.001447697,
				"type": "ORGANIZATION"
			},
			{
				"name": "plans",
				"salience": 0.0013125809,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "3",
		"main_img_url": "http://www.thedailysheeple.com/wp-content/uploads/2016/10/Woman-Kneels-For-Anthem.png",
		"ord_in_thread": "0",
		"participants_count": "2",
		"published": "2016-10-26T15:55:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 3.8,
			"score": -0.2
		},
		"shares": "3",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nA singer decided to kneel during her performance of the national anthem prior to an NBA preseason game in Miami.\nAs Denasia Lawrence approached midcourt, she unzipped her jacket, revealing the “Black Lives Matter” shirt she has underneath and dropped to her left knee as she began to sing. Her stated intention was to protest racial oppression.\nIf the anthem is a symbol of racial oppression, then why would she sing it at all?\n“We’re being unjustly killed and overly criminalized,” Lawrence explained in a Facebook post from Saturday night. “I took the opportunity to sing and kneel to show that we belong in this country and that we have the right to respectfully protest injustices against us.”\nAccording to Miami Heat staff, there was no advanced warning that Lawrence was wearing a Black Lives Matter shirt nor that she had plans to kneel.\n“I didn’t get paid to sing the national anthem nor was this moment about any sort of fame,” Lawrence wrote. “Black Lives Matter is far larger than a hashtag, it’s a rallying cry.”\nDelivered by The Daily Sheeple\nWe encourage you to share and republish our reports, analyses, breaking news and videos ( Click for details ).",
		"thread_title": "Why Even Sing? Anthem Singer Kneels During Performance | Alternative",
		"title": "Why Even Sing? Anthem Singer Kneels During Performance | Alternative",
		"type": "bs",
		"uuid": "3575171a95bf95362b6ab50c70c42110a4126ff9"
	},
	"-KhIk5WeEafoR0tAGokm": {
		"author": "Man",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:05:12.446+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "warning",
				"salience": 0.50646245,
				"type": "OTHER"
			},
			{
				"name": "shirt",
				"salience": 0.19504489,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0t6hk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lawrence,_Kansas"
				},
				"name": "Lawrence",
				"salience": 0.13924298,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.08171903,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.077530615,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.thedailysheeple.com/wp-content/uploads/2016/10/Woman-Kneels-For-Anthem.png",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-26T19:20:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "do you need an advanced warning that Lawrence for wearing a Black Lives Matter shirt or that she had planed to kneel?\nit is a free country. they can do that",
		"thread_title": "Why Even Sing? Anthem Singer Kneels During Performance | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "71daad85ce93d06ee86519af6c70b3bb94667a58"
	},
	"-KhIk5nqaW10PXc3qfrN": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:05:24.790+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/017ql",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bank"
				},
				"name": "Bank",
				"salience": 0.14633082,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01xdn1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Goldman_Sachs"
				},
				"name": "Goldman Sachs Group Inc.",
				"salience": 0.09193854,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.055533253,
				"type": "LOCATION"
			},
			{
				"name": "notices",
				"salience": 0.04806269,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.043543644,
				"type": "PERSON"
			},
			{
				"name": "notice",
				"salience": 0.03222133,
				"type": "OTHER"
			},
			{
				"name": "jobs",
				"salience": 0.027696526,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.02661117,
				"type": "PERSON"
			},
			{
				"name": "plant layoff",
				"salience": 0.022554258,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.017496154,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.016326793,
				"type": "OTHER"
			},
			{
				"name": "state agency",
				"salience": 0.016326793,
				"type": "ORGANIZATION"
			},
			{
				"name": "more",
				"salience": 0.014232093,
				"type": "OTHER"
			},
			{
				"name": "cuts",
				"salience": 0.012331901,
				"type": "OTHER"
			},
			{
				"name": "plant",
				"salience": 0.0115619125,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.011548599,
				"type": "ORGANIZATION"
			},
			{
				"name": "workers",
				"salience": 0.010684378,
				"type": "PERSON"
			},
			{
				"name": "bank",
				"salience": 0.010252606,
				"type": "ORGANIZATION"
			},
			{
				"name": "notice",
				"salience": 0.010242318,
				"type": "OTHER"
			},
			{
				"name": "fourth",
				"salience": 0.009650237,
				"type": "OTHER"
			},
			{
				"name": "third",
				"salience": 0.009650237,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.008359839,
				"type": "OTHER"
			},
			{
				"name": "Jeanne Branthover",
				"salience": 0.00781922,
				"type": "PERSON"
			},
			{
				"name": "Gena Palumbo",
				"salience": 0.007765557,
				"type": "PERSON"
			},
			{
				"name": "DHR International",
				"salience": 0.006701552,
				"type": "ORGANIZATION"
			},
			{
				"name": "notices",
				"salience": 0.00657899,
				"type": "OTHER"
			},
			{
				"name": "reduction",
				"salience": 0.006400886,
				"type": "OTHER"
			},
			{
				"name": "notices",
				"salience": 0.0060978904,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.005874379,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.005634178,
				"type": "PERSON"
			},
			{
				"name": "Employers",
				"salience": 0.005634178,
				"type": "ORGANIZATION"
			},
			{
				"name": "numbers",
				"salience": 0.0055520344,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.0051734047,
				"type": "ORGANIZATION"
			},
			{
				"name": "notice",
				"salience": 0.005043199,
				"type": "OTHER"
			},
			{
				"name": "layoffs",
				"salience": 0.004769394,
				"type": "EVENT"
			},
			{
				"name": "number",
				"salience": 0.004769394,
				"type": "OTHER"
			},
			{
				"name": "companies",
				"salience": 0.004769394,
				"type": "ORGANIZATION"
			},
			{
				"name": "plant layoff",
				"salience": 0.004769394,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.004769394,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.004533804,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/080t3d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lloyd_Blankfein"
				},
				"name": "Lloyd Blankfein",
				"salience": 0.004509209,
				"type": "PERSON"
			},
			{
				"name": "employees",
				"salience": 0.004485831,
				"type": "PERSON"
			},
			{
				"name": "reductions",
				"salience": 0.004406538,
				"type": "OTHER"
			},
			{
				"name": "notice",
				"salience": 0.0042776424,
				"type": "OTHER"
			},
			{
				"name": "notices",
				"salience": 0.004249967,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.003994416,
				"type": "OTHER"
			},
			{
				"name": "intention",
				"salience": 0.003979108,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.003979108,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.0038996695,
				"type": "LOCATION"
			},
			{
				"name": "employees",
				"salience": 0.0038047608,
				"type": "PERSON"
			},
			{
				"name": "firm",
				"salience": 0.0036287392,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.0035687285,
				"type": "LOCATION"
			},
			{
				"name": "dismissals",
				"salience": 0.0035344786,
				"type": "OTHER"
			},
			{
				"name": "notices",
				"salience": 0.0034928222,
				"type": "OTHER"
			},
			{
				"name": "outlook",
				"salience": 0.0034673936,
				"type": "OTHER"
			},
			{
				"name": "state authorities",
				"salience": 0.0034460395,
				"type": "PERSON"
			},
			{
				"name": "plant closing",
				"salience": 0.0034460395,
				"type": "EVENT"
			},
			{
				"name": "circumstances",
				"salience": 0.0034460395,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0034460395,
				"type": "OTHER"
			},
			{
				"name": "run",
				"salience": 0.0034460395,
				"type": "OTHER"
			},
			{
				"name": "cuts",
				"salience": 0.0034356264,
				"type": "OTHER"
			},
			{
				"name": "bank",
				"salience": 0.003345204,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.003345204,
				"type": "PERSON"
			},
			{
				"name": "competitors",
				"salience": 0.0032204285,
				"type": "ORGANIZATION"
			},
			{
				"name": "company",
				"salience": 0.0032204285,
				"type": "ORGANIZATION"
			},
			{
				"name": "layoffs",
				"salience": 0.0032204285,
				"type": "EVENT"
			},
			{
				"name": "Number",
				"salience": 0.0032204285,
				"type": "OTHER"
			},
			{
				"name": "revenue opportunities",
				"salience": 0.0031730928,
				"type": "OTHER"
			},
			{
				"name": "job cuts",
				"salience": 0.0031440188,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "New York State",
				"salience": 0.003133238,
				"type": "LOCATION"
			},
			{
				"name": "reduction",
				"salience": 0.003090573,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.003090573,
				"type": "PERSON"
			},
			{
				"name": "firm",
				"salience": 0.0030776463,
				"type": "ORGANIZATION"
			},
			{
				"name": "approach",
				"salience": 0.0029752844,
				"type": "OTHER"
			},
			{
				"name": "cuts",
				"salience": 0.0029138287,
				"type": "OTHER"
			},
			{
				"name": "terminations",
				"salience": 0.0028136307,
				"type": "OTHER"
			},
			{
				"name": "Ted Pick",
				"salience": 0.0028034586,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.002790655,
				"type": "PERSON"
			},
			{
				"name": "head",
				"salience": 0.002790655,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0027312809,
				"type": "PERSON"
			},
			{
				"name": "bank",
				"salience": 0.0027312809,
				"type": "ORGANIZATION"
			},
			{
				"name": "compensation",
				"salience": 0.0027312809,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.002574765,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0025233359,
				"type": "PERSON"
			},
			{
				"name": "website",
				"salience": 0.0024166538,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0024166538,
				"type": "OTHER"
			},
			{
				"name": "knowledge",
				"salience": 0.0024166538,
				"type": "OTHER"
			},
			{
				"name": "union",
				"salience": 0.0024166538,
				"type": "OTHER"
			},
			{
				"name": "radar screen",
				"salience": 0.0024166538,
				"type": "OTHER"
			},
			{
				"name": "employment law",
				"salience": 0.0024166538,
				"type": "OTHER"
			},
			{
				"name": "single",
				"salience": 0.0023264824,
				"type": "WORK_OF_ART"
			},
			{
				"name": "hundreds",
				"salience": 0.0023264824,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.0022994324,
				"type": "ORGANIZATION"
			},
			{
				"name": "each",
				"salience": 0.0022784164,
				"type": "OTHER"
			},
			{
				"name": "job-cut tally",
				"salience": 0.0022396727,
				"type": "OTHER"
			},
			{
				"name": "cuts",
				"salience": 0.0021770035,
				"type": "OTHER"
			},
			{
				"name": "staffing decisions",
				"salience": 0.00212894,
				"type": "OTHER"
			},
			{
				"name": "contact",
				"salience": 0.0021021224,
				"type": "OTHER"
			},
			{
				"name": "steps",
				"salience": 0.0020756423,
				"type": "OTHER"
			},
			{
				"name": "revenue",
				"salience": 0.0019832482,
				"type": "OTHER"
			},
			{
				"name": "scalpel",
				"salience": 0.0019730136,
				"type": "OTHER"
			},
			{
				"name": "ax",
				"salience": 0.0019730136,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.0019730136,
				"type": "PERSON"
			},
			{
				"name": "benefits",
				"salience": 0.0019730136,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0019730136,
				"type": "EVENT"
			},
			{
				"name": "sets",
				"salience": 0.0019730136,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0018851846,
				"type": "PERSON"
			},
			{
				"name": "worst",
				"salience": 0.0018754556,
				"type": "OTHER"
			},
			{
				"name": "trading business",
				"salience": 0.0017021652,
				"type": "ORGANIZATION"
			},
			{
				"name": "start",
				"salience": 0.0017021652,
				"type": "EVENT"
			},
			{
				"name": "businesses",
				"salience": 0.0016487978,
				"type": "ORGANIZATION"
			},
			{
				"name": "approach",
				"salience": 0.0016397818,
				"type": "OTHER"
			},
			{
				"name": "signal",
				"salience": 0.0015379777,
				"type": "OTHER"
			},
			{
				"name": "spokesman",
				"salience": 0.0015118176,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0c21g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Labor"
				},
				"name": "Labor Department",
				"salience": 0.0014876474,
				"type": "ORGANIZATION"
			},
			{
				"name": "partners",
				"salience": 0.001486275,
				"type": "ORGANIZATION"
			},
			{
				"name": "person",
				"salience": 0.0014805734,
				"type": "PERSON"
			},
			{
				"name": "tenure",
				"salience": 0.0014739609,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.0014739609,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0013730685,
				"type": "LOCATION"
			},
			{
				"name": "employees",
				"salience": 0.0013119328,
				"type": "PERSON"
			},
			{
				"name": "trading",
				"salience": 0.0012671504,
				"type": "OTHER"
			},
			{
				"name": "traders",
				"salience": 0.0012511833,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.0012397435,
				"type": "OTHER"
			},
			{
				"name": "sign",
				"salience": 0.0012397435,
				"type": "OTHER"
			},
			{
				"name": "preference",
				"salience": 0.0012186539,
				"type": "OTHER"
			},
			{
				"name": "eye",
				"salience": 0.0010735095,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0010735095,
				"type": "OTHER"
			},
			{
				"name": "Everything",
				"salience": 0.0010735095,
				"type": "OTHER"
			},
			{
				"name": "memos",
				"salience": 0.0010735095,
				"type": "WORK_OF_ART"
			},
			{
				"name": "retirements",
				"salience": 0.0010735095,
				"type": "EVENT"
			},
			{
				"name": "firings",
				"salience": 0.0010735095,
				"type": "EVENT"
			},
			{
				"name": "trading revenue",
				"salience": 0.0010520549,
				"type": "OTHER"
			},
			{
				"name": "trading staff",
				"salience": 0.0010257064,
				"type": "PERSON"
			},
			{
				"name": "Approach",
				"salience": 0.0010257064,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jvs0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morgan_Stanley"
				},
				"name": "Morgan Stanley",
				"salience": 0.0009255563,
				"type": "ORGANIZATION"
			},
			{
				"name": "view",
				"salience": 0.00084363914,
				"type": "OTHER"
			},
			{
				"name": "consultants",
				"salience": 0.000833007,
				"type": "PERSON"
			},
			{
				"name": "salesmen",
				"salience": 0.00080190744,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.00080190744,
				"type": "OTHER"
			},
			{
				"name": "medicine",
				"salience": 0.00080190744,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.00080190744,
				"type": "OTHER"
			},
			{
				"name": "dealmaking",
				"salience": 0.00080190744,
				"type": "OTHER"
			},
			{
				"name": "changes",
				"salience": 0.0006830633,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.00066070305,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://reddragonleo.com/media/1x-1-3.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T17:02:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.3,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News) 43 here, 109 there and pretty soon 443 employees are dismissed Bank has to file ‘WARN notices’ with New York state agency The first “plant layoff” notice came in February: 43 people would lose their jobs.\nThe second arrived six weeks later, increasing the cuts to 109 workers. Then a third, in April, for 146 more. And a fourth, in June: 98. Three more notices followed, including 20 dismissals announced last week.\nThe “plant” in question — Goldman Sachs Group Inc.\nLike all big companies in New York State, the firm is required to file a “WARN notice” with state authorities when it plans to shed large numbers of employees as part of a plant closing, or “mass layoffs” involving 250 or more. Employers also must inform the state of smaller reductions under certain circumstances, and Goldman Sachs cited a “plant layoff” in each case. Last week’s notice brings this year’s job-cut tally to 443.With the run of notices, seven since the start of the year, the bank has signaled its intention to dismiss hundreds of employees in New York without placing a single, headline-grabbing number on the overall reduction, already its largest since 2008. The company’s approach differs from competitors, including Morgan Stanley, who have shown a preference for larger, one-time cuts.\nBig Number\n“When there’s a big number, people right away get that something is happening at that firm — it’s a negative,” said Jeanne Branthover, a partner at New York-based executive-search firm DHR International. “This is more, ‘We’re having layoffs and we don’t want to explain it.’ It’s more under the radar screen.”\nThe 20 people in the latest reduction were notified either this month or last, according to a person with direct knowledge of the matter, who asked not to be identified discussing staffing decisions. The terminations will take place between Nov. 7 and Jan. 5, according to the notice posted on the state Labor Department’s website. The workers aren’t represented by a union.\nGena Palumbo, a managing director and the bank’s global head of employment law, is the sole Goldman Sachs contact listed on each of this year’s WARN notices. In 2008, the firm dismissed 900 people in New York in two different sets of cuts as the financial crisis raged. A spokesman for the bank declined to comment.\nGoldman Sachs set aside $9.2 billion for compensation and benefits this year through September, 13 percent less than the first nine months of last year. Total employees, including consultants and part-time workers, fell 5.4 percent to 34,900.\nWhile Goldman prefers a scalpel, its rival Morgan Stanley wielded an ax. That firm took steps to shrink in the fourth quarter, cutting 1,200 employees, including about 25 percent of the fixed-income trading staff, or about 470 traders and salesmen. When asked about how Morgan Stanley decided to make the changes, trading chief Ted Pick said he favored a bold move.\n“We took the view of taking tough medicine,” Pick, 47, said in February.\nSlower Approach\nGoldman Sachs’s slower approach may reflect a desire to avoid cutting too much if trading or dealmaking comes roaring back. Chief Executive Officer Lloyd Blankfein has spoken about staying nimble to respond to revenue opportunities when they arise.\nIt also may reflect an outlook that got cloudier as the year progressed. In January, a person familiar with the firm’s thinking said Goldman Sachs was mulling cuts to more than 5 percent of its fixed-income staff. By March, that would expand to more than 5 percent but less than 10 percent. And by May, 10 percent.\nThe job cuts continued after first-quarter revenue was the worst for the start of a year in Blankfein’s decade-long tenure. While trading business bounced back in the second and third quarters, total trading revenue for the first nine months declined 11 percent from last year.\nThe WARN notices don’t capture firings outside New York and they don’t include voluntary retirements. More than a half-dozen partners have left Goldman Sachs this year, according to internal memos obtained by Bloomberg.\n“Everything Goldman does is scrutinized,” Branthover said. “This may be a signal or a sign that there are changes being made internally, or there are businesses and areas that are not performing satisfactorily. I would keep an eye on it.”",
		"thread_title": "Here’s How Goldman Sachs Lays People Off | Financial Markets",
		"title": "Here’s How Goldman Sachs Lays People Off | Financial Markets",
		"type": "bs",
		"uuid": "6acbbdfd4a35b4e4feff6da2e827b0b1f6cadb51"
	},
	"-KhIk5ukFAeMj-EtRlOi": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:05:43.222+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "article",
				"salience": 0.47859553,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0z8l_jp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MNsure"
				},
				"name": "MNsure",
				"salience": 0.31465116,
				"type": "ORGANIZATION"
			},
			{
				"name": "dysfunction",
				"salience": 0.07337649,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/g/11b90jf2yc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Roz_Peterson"
				},
				"name": "Roz Peterson",
				"salience": 0.047437117,
				"type": "PERSON"
			},
			{
				"name": "constituent",
				"salience": 0.016470797,
				"type": "PERSON"
			},
			{
				"name": "story",
				"salience": 0.014902603,
				"type": "WORK_OF_ART"
			},
			{
				"name": "news conference",
				"salience": 0.011453276,
				"type": "EVENT"
			},
			{
				"name": "voter registration form",
				"salience": 0.009367018,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.009020062,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vz11",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lakeville,_Minnesota"
				},
				"name": "Lakeville",
				"salience": 0.007076196,
				"type": "LOCATION"
			},
			{
				"name": "question",
				"salience": 0.0070114713,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "R",
				"salience": 0.0068135643,
				"type": "PERSON"
			},
			{
				"name": "health insurance exchange",
				"salience": 0.0038247001,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.7,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.01",
		"text": "(Before It's News)\nThis article highlights the dysfunction of MNsure. While it isn’t surprising, it’s still aggravating. The story starts by saying “Rep. Roz Peterson, R-Lakeville, said at a Monday news conference that a constituent had contacted her after receiving a voter registration form from MNsure, the state-run health insurance exchange, even though the person in question is […]\nContinue reading MNsure caught wasting time\n. . . → Read More: MNsure caught wasting time",
		"thread_title": "MNsure caught wasting time | Opinion - Conservative",
		"title": "MNsure caught wasting time | Opinion - Conservative",
		"type": "bs",
		"uuid": "0a96be391a9b124cd0e865aa87b5d75352f8835e"
	},
	"-KhIk60ZSwcEXyVUv3U8": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:05:49.308+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.39415538,
				"type": "LOCATION"
			},
			{
				"name": "News",
				"salience": 0.295675,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h510",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Spectator"
				},
				"name": "The Spectator",
				"salience": 0.058410898,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0j7k4zc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Stanley"
				},
				"name": "Tim Stanley",
				"salience": 0.056999955,
				"type": "PERSON"
			},
			{
				"name": "politics",
				"salience": 0.0542275,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.026235303,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.024542155,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.020600049,
				"type": "OTHER"
			},
			{
				"name": "vice president",
				"salience": 0.01437797,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.013845699,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b3pq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Alexander_Hamilton"
				},
				"name": "Alexander Hamilton",
				"salience": 0.011930544,
				"type": "PERSON"
			},
			{
				"name": "duel",
				"salience": 0.0117560895,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0088704545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0bw8r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secretary_of_the_Treasury"
				},
				"name": "Secretary of the Treasury",
				"salience": 0.008372971,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://pixel.wp.com/b.gif?host=nebraskaenergyobserver.wordpress.com&blog=25147582&post=19949&subd=nebraskaenergyobserver&ref=&feed=1",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nTim Stanley wrote in The Spectator last week about American politics. Here is some of it. To anyone complaining that American politics in 2016 is uncivil, consider this: in 1804, the vice president of the United States shot the former Secretary of the Treasury in a duel. Alexander Hamilton, the retired secretary, probably fired first […]\nContinue reading American politics at its most uncivil\n. . . → Read More: American politics at its most uncivil",
		"thread_title": "American politics at its most uncivil | Opinion - Conservative",
		"title": "American politics at its most uncivil | Opinion - Conservative",
		"type": "bs",
		"uuid": "bc56a418cab1f2fc100b1c28ad35dd5430b63b32"
	},
	"-KhIk6C_GIS_eoX_KAoi": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:05:55.865+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.40767452,
				"type": "OTHER"
			},
			{
				"name": "monopoly power",
				"salience": 0.07714325,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.07581649,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.063310094,
				"type": "ORGANIZATION"
			},
			{
				"name": "antitrust laws",
				"salience": 0.060692456,
				"type": "OTHER"
			},
			{
				"name": "monopoly power",
				"salience": 0.039950237,
				"type": "OTHER"
			},
			{
				"name": "monopoly power",
				"salience": 0.033953894,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.031494826,
				"type": "ORGANIZATION"
			},
			{
				"name": "sector",
				"salience": 0.027073927,
				"type": "OTHER"
			},
			{
				"name": "Politicians",
				"salience": 0.026402371,
				"type": "PERSON"
			},
			{
				"name": "economy",
				"salience": 0.022043578,
				"type": "OTHER"
			},
			{
				"name": "air traffic control",
				"salience": 0.022043578,
				"type": "OTHER"
			},
			{
				"name": "Bureaucrats",
				"salience": 0.015560492,
				"type": "PERSON"
			},
			{
				"name": "Markets Should Guide Mergers",
				"salience": 0.014505175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dh8s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mail"
				},
				"name": "Postal Service",
				"salience": 0.013608444,
				"type": "ORGANIZATION"
			},
			{
				"name": "Politicians",
				"salience": 0.011349376,
				"type": "PERSON"
			},
			{
				"name": "Bureaucrats",
				"salience": 0.011349376,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Security_(United_States)"
				},
				"name": "Social Security",
				"salience": 0.011118892,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.010662024,
				"type": "ORGANIZATION"
			},
			{
				"name": "More",
				"salience": 0.009832604,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.008486278,
				"type": "OTHER"
			},
			{
				"name": "competition",
				"salience": 0.0059281285,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "https://pixel.wp.com/b.gif?host=danieljmitchell.wordpress.com&blog=6571774&post=34981&subd=danieljmitchell&ref=&feed=1",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nLast year, I explained the theoretical argument against antitrust laws, pointing out that monopoly power generally exists only when government intervenes. There’s monopoly power when government takes over a sector of the economy (i.e., air traffic control, Postal Service, Social Security, etc). There’s monopoly power when government prohibits or restricts competition in a sector of […]\nContinue reading Markets Should Guide Mergers, not Politicians and Bureaucrats\n. . . → Read More: Markets Should Guide Mergers, not Politicians and Bureaucrats",
		"thread_title": "Markets Should Guide Mergers, not Politicians and Bureaucrats | Opinion - Conservative",
		"title": "Markets Should Guide Mergers, not Politicians and Bureaucrats | Opinion - Conservative",
		"type": "bs",
		"uuid": "9e28c608b697abdd914703c4a94fa6bc28f161f4"
	},
	"-KhIk6Lne6yeI-l9e3ls": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:06:05.704+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "NSA Whistleblower",
				"salience": 0.17216241,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.15890072,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.13538548,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.09425006,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0j8sy9w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/William_Binney_(U.S._intelligence_official)"
				},
				"name": "William Binney",
				"salience": 0.072927564,
				"type": "PERSON"
			},
			{
				"name": "hacks",
				"salience": 0.06548391,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "Democratic National Committee",
				"salience": 0.025619272,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05htt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Security_Agency"
				},
				"name": "NSA",
				"salience": 0.023659794,
				"type": "ORGANIZATION"
			},
			{
				"name": "pundits",
				"salience": 0.018046154,
				"type": "PERSON"
			},
			{
				"name": "worker",
				"salience": 0.015585095,
				"type": "PERSON"
			},
			{
				"name": "intelligence",
				"salience": 0.015585095,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.015585095,
				"type": "OTHER"
			},
			{
				"name": "telling",
				"salience": 0.015416118,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.013243235,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.013041672,
				"type": "PERSON"
			},
			{
				"name": "questions",
				"salience": 0.008519309,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.008332059,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.006947398,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.006464434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email server",
				"salience": 0.0056030625,
				"type": "OTHER"
			},
			{
				"name": "intelligence worker",
				"salience": 0.005394335,
				"type": "PERSON"
			},
			{
				"name": "agency",
				"salience": 0.005394335,
				"type": "ORGANIZATION"
			},
			{
				"name": "story",
				"salience": 0.0051051867,
				"type": "OTHER"
			},
			{
				"name": "disregard",
				"salience": 0.0048531415,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0048531415,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0048531415,
				"type": "OTHER"
			},
			{
				"name": "lies",
				"salience": 0.0048531415,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0048531415,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.0046722903,
				"type": "OTHER"
			},
			{
				"name": "surveillance program",
				"salience": 0.0046722903,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00457588,
				"type": "OTHER"
			},
			{
				"name": "fable",
				"salience": 0.004222227,
				"type": "WORK_OF_ART"
			},
			{
				"name": "talk radio show",
				"salience": 0.003963186,
				"type": "WORK_OF_ART"
			},
			{
				"name": "voters",
				"salience": 0.003963186,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0034196423,
				"type": "OTHER"
			},
			{
				"name": "access",
				"salience": 0.0032361832,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0031209146,
				"type": "LOCATION"
			},
			{
				"name": "database",
				"salience": 0.0029615522,
				"type": "OTHER"
			},
			{
				"name": "network logs",
				"salience": 0.0029615522,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0024912723,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0022312845,
				"type": "WORK_OF_ART"
			},
			{
				"name": "reluctance",
				"salience": 0.0021574209,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0021574209,
				"type": "OTHER"
			},
			{
				"name": "Sheeple",
				"salience": 0.0021574209,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.0021574209,
				"type": "OTHER"
			},
			{
				"name": "analyses",
				"salience": 0.0021574209,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.0021574209,
				"type": "WORK_OF_ART"
			},
			{
				"name": "details",
				"salience": 0.0021574209,
				"type": "OTHER"
			},
			{
				"name": "hacks",
				"salience": 0.0018613213,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0016956672,
				"type": "OTHER"
			},
			{
				"name": "network log",
				"salience": 0.0016118258,
				"type": "OTHER"
			},
			{
				"name": "The Daily",
				"salience": 0.0013281095,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0009921446,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "3",
		"main_img_url": "http://www.thedailysheeple.com/wp-content/uploads/2016/10/NSA-spying-in-your-computer.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.8,
			"score": -0.4
		},
		"shares": "3",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nAn NSA Whistleblower says that Hillary Clinton’s deleted emails are easily accessible by the NSA and FBI should they desire to look at them, and he suggests that the hacks on the Democratic National Committee’s server was not done by Russia, as many pundits are claiming, but possibly by a disgruntled U.S. intelligence worker.\nWilliam Binney, the architect of the NSA’s surveillance program, resigned on October 31, 2001, after working for the agency for more than 30 years. He thinks that an intelligence worker may have hacked into the DNC emails due to concern about Hillary Clinton’s disregard of national security in her use of a personal email server and her continued lies about her activity. Once accessed, there’s no telling where the information could have gone.\nThe “Putin did it” story is a fable used to sway voters towards Clinton’s war-driven agenda.\nOn a talk radio show, he mentioned that there are numerous questions that are not being answered about the hacked DNC emails and the network log available to the NSA.\nBinney explains that there was no evidence tying the alleged Russian hacks to Wikileaks, and he says that they would have access to this information through the network logs. “So, if the FBI really wanted them, they can go into that database and get them right now,” he said.\nHe finds their reluctance to speak to this matter highly suspicious.\nDelivered by The Daily Sheeple\nWe encourage you to share and republish our reports, analyses, breaking news and videos ( Click for details ).",
		"thread_title": "NSA Whistleblower Says DNC Email Hack Was Not by Russia, but by US Intelligence | Alternative",
		"title": "NSA Whistleblower Says DNC Email Hack Was Not by Russia, but by US Intelligence | Alternative",
		"type": "bs",
		"uuid": "e5271d3318a27ede4c6853913da4b37c55c3e2ea"
	},
	"-KhIk6YzKaGV1zzjqiUb": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:06:28.156+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barack Obama",
				"salience": 0.34464705,
				"type": "PERSON"
			},
			{
				"name": "News",
				"salience": 0.121013954,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "Affordable Care Act",
				"salience": 0.088102214,
				"type": "OTHER"
			},
			{
				"name": "health insurance",
				"salience": 0.079077184,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03wpm_5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mark_Bertolini"
				},
				"name": "Mark Bertolini",
				"salience": 0.03114754,
				"type": "PERSON"
			},
			{
				"name": "failure",
				"salience": 0.028928928,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.025141113,
				"type": "PERSON"
			},
			{
				"name": "premiums",
				"salience": 0.01904596,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.01729453,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.014454435,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.012359539,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0120056765,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.008098948,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.008098948,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.0075023454,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0071982504,
				"type": "OTHER"
			},
			{
				"name": "fine",
				"salience": 0.0071982504,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.006675089,
				"type": "ORGANIZATION"
			},
			{
				"name": "law",
				"salience": 0.006336946,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.006336946,
				"type": "OTHER"
			},
			{
				"name": "Insurers",
				"salience": 0.006120186,
				"type": "ORGANIZATION"
			},
			{
				"name": "healthcare coverage",
				"salience": 0.005770147,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0054038786,
				"type": "PERSON"
			},
			{
				"name": "intention",
				"salience": 0.0052147084,
				"type": "OTHER"
			},
			{
				"name": "points",
				"salience": 0.0049573225,
				"type": "OTHER"
			},
			{
				"name": "health care plan",
				"salience": 0.0049423603,
				"type": "OTHER"
			},
			{
				"name": "health insurance plans",
				"salience": 0.0049423603,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Clinton",
				"salience": 0.0048473063,
				"type": "PERSON"
			},
			{
				"name": "premiums",
				"salience": 0.0048124325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kg8x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aetna"
				},
				"name": "Aetna Inc.",
				"salience": 0.0047912053,
				"type": "ORGANIZATION"
			},
			{
				"name": "Premiums",
				"salience": 0.004517313,
				"type": "OTHER"
			},
			{
				"name": "market",
				"salience": 0.0044465107,
				"type": "OTHER"
			},
			{
				"name": "pocket costs",
				"salience": 0.004280812,
				"type": "OTHER"
			},
			{
				"name": "health plans",
				"salience": 0.0041924794,
				"type": "OTHER"
			},
			{
				"name": "health insurance",
				"salience": 0.003930074,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0038657598,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.0036311208,
				"type": "OTHER"
			},
			{
				"name": "rates",
				"salience": 0.0034777322,
				"type": "OTHER"
			},
			{
				"name": "CEO",
				"salience": 0.0033630773,
				"type": "PERSON"
			},
			{
				"name": "administration",
				"salience": 0.003348074,
				"type": "ORGANIZATION"
			},
			{
				"name": "President",
				"salience": 0.0033091768,
				"type": "PERSON"
			},
			{
				"name": "stability",
				"salience": 0.0033059358,
				"type": "OTHER"
			},
			{
				"name": "beer",
				"salience": 0.003278956,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "individuals",
				"salience": 0.003278956,
				"type": "PERSON"
			},
			{
				"name": "Gas",
				"salience": 0.0028397397,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0028397397,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "math",
				"salience": 0.0028397397,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0027338343,
				"type": "OTHER"
			},
			{
				"name": "health law",
				"salience": 0.0027134106,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00245014,
				"type": "OTHER"
			},
			{
				"name": "President",
				"salience": 0.0024108535,
				"type": "PERSON"
			},
			{
				"name": "health plans",
				"salience": 0.0021154112,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.001991539,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0018012666,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027sm6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomberg_L.P."
				},
				"name": "Bloomberg",
				"salience": 0.0017484375,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0017484375,
				"type": "LOCATION"
			},
			{
				"name": "The Year Ahead Summit",
				"salience": 0.0017484375,
				"type": "EVENT"
			},
			{
				"name": "table",
				"salience": 0.0015455735,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.0015455735,
				"type": "EVENT"
			},
			{
				"name": "negotiations",
				"salience": 0.0015455735,
				"type": "EVENT"
			},
			{
				"name": "markets",
				"salience": 0.001476774,
				"type": "OTHER"
			},
			{
				"name": "costs",
				"salience": 0.001476774,
				"type": "OTHER"
			},
			{
				"name": "premiums",
				"salience": 0.0013904336,
				"type": "OTHER"
			},
			{
				"name": "fixes",
				"salience": 0.0011994126,
				"type": "OTHER"
			},
			{
				"name": "lawmakers",
				"salience": 0.001154646,
				"type": "PERSON"
			},
			{
				"name": "average",
				"salience": 0.001154646,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.00095893507,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b35q2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RedState"
				},
				"name": "RedState",
				"salience": 0.00095137605,
				"type": "OTHER"
			},
			{
				"name": "On Obamacare: Young People Will Choose Beer First",
				"salience": 0.0009275509,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "1",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:29:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.7,
			"score": -0.2
		},
		"shares": "1",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nRemember when the media, Barack Obama, and Democrats were finger-wagging and tut-tutting Republicans for saying Obamacare was going to be a failure? Remember how Obama said premiums were going to go down?\nFor the last 18 months, Obama and his fellow Democrats have been reduced to bragging about how many people are now “covered” by health insurance as if it was some real accomplishment. Two points to consider:\nIt is mandatory. People are merely obeying the law and getting a plan. The law’s intention was for healthcare coverage to be more affordable, and that has not happened. Insurers are recognizing this problem. Younger people would rather be in a position where they pay the fine (which the administration is not enforcing), rather than the out of pocket costs for a health care plan. The CEO of Aetna said as much:\nHealthier people will avoid buying Affordable Care Act health insurance plans as premiums climb, threatening the stability of the market, Aetna Inc. Chief Executive Officer Mark Bertolini said.\n“As the rates rise, the healthier people pull out because the out-of-pocket costs aren’t worth it,” Bertolini said at Bloomberg’s The Year Ahead Summit in New York. “Young people can do the math. Gas for the car, beer on Fridays and Saturdays, health insurance.”\nPremiums for health plans sold to individuals under the ACA, known as Obamacare, are going up by about 25 percent on average for next year. Bertolini said that as costs rise, more individuals will decide not to buy health plans. That’ll push premiums even higher, unless a new president and lawmakers can find fixes for the new markets created by the 2010 health law.\nThe question over whether such problems get fixed is all dependent upon whether or no the President, be it Obama or Clinton, recognizes what divided government means. It is not to say, as President Obama believes, “Here is what I need, now pass it so I can sign it.” President Obama or President Clinton must recognize divided government means everything is on the table at the start of negotiations , not just what the President wants.\nThe post Aetna CEO On Obamacare: Young People Will Choose Beer First appeared first on RedState .",
		"thread_title": "Aetna CEO on Obamacare: Young People Will Choose Beer First | Politics",
		"title": "Aetna CEO on Obamacare: Young People Will Choose Beer First | Politics",
		"type": "bs",
		"uuid": "8400c2ee86c21719fa7e078eda489fd4eda1ecd0"
	},
	"-KhIk6uhyJPHxBYdepdJ": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:06:40.225+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://stateofthenation2012.com/wp-content/uploads/2016/10/maxresdefault-4.jpg",
		"ord_in_thread": "23",
		"participants_count": "15",
		"published": "2016-10-26T15:16:00.000+03:00",
		"replies_count": "23",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "The Mothership Arrives --- But It's Not What You Think! | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "1a5958ca436f34eedf0018ac4b71acfef093b9e8"
	},
	"-KhIk74owIOz27vrF9Ny": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:06:44.012+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News) News",
				"salience": 0.1495919,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bear spray",
				"salience": 0.14557566,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mlyb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lamar_River"
				},
				"name": "Lamar Valley",
				"salience": 0.12531918,
				"type": "LOCATION"
			},
			{
				"name": "bear",
				"salience": 0.068225324,
				"type": "OTHER"
			},
			{
				"name": "injury",
				"salience": 0.03218188,
				"type": "OTHER"
			},
			{
				"name": "visitors",
				"salience": 0.02699945,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01gznn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glacier_National_Park_(U.S.)"
				},
				"name": "Glacier National Park",
				"salience": 0.026820498,
				"type": "LOCATION"
			},
			{
				"name": "bear",
				"salience": 0.025668314,
				"type": "OTHER"
			},
			{
				"name": "bear",
				"salience": 0.020605851,
				"type": "OTHER"
			},
			{
				"name": "bear",
				"salience": 0.018052835,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03j_7c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adventure_(role-playing_games)"
				},
				"name": "Adventure",
				"salience": 0.01725774,
				"type": "ORGANIZATION"
			},
			{
				"name": "grizzly bear",
				"salience": 0.01523201,
				"type": "OTHER"
			},
			{
				"name": "bear",
				"salience": 0.013945308,
				"type": "OTHER"
			},
			{
				"name": "bears",
				"salience": 0.0135103315,
				"type": "OTHER"
			},
			{
				"name": "bear",
				"salience": 0.010300785,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.009752346,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/024gm7"
				},
				"name": "John",
				"salience": 0.008841575,
				"type": "PERSON"
			},
			{
				"name": "Lisa Vandenbos",
				"salience": 0.008841575,
				"type": "PERSON"
			},
			{
				"name": "bear",
				"salience": 0.008415181,
				"type": "OTHER"
			},
			{
				"name": "spray",
				"salience": 0.007076249,
				"type": "OTHER"
			},
			{
				"name": "carcass",
				"salience": 0.006833367,
				"type": "OTHER"
			},
			{
				"name": "bear spray",
				"salience": 0.006812751,
				"type": "OTHER"
			},
			{
				"name": "bear",
				"salience": 0.006291174,
				"type": "OTHER"
			},
			{
				"name": "bear",
				"salience": 0.006291174,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.006129507,
				"type": "PERSON"
			},
			{
				"name": "couple",
				"salience": 0.006129507,
				"type": "PERSON"
			},
			{
				"name": "deterrent",
				"salience": 0.0060133133,
				"type": "OTHER"
			},
			{
				"name": "carcass",
				"salience": 0.0059455405,
				"type": "OTHER"
			},
			{
				"name": "fishing spots",
				"salience": 0.0059190383,
				"type": "OTHER"
			},
			{
				"name": "pullout",
				"salience": 0.0059190383,
				"type": "EVENT"
			},
			{
				"name": "trailhead",
				"salience": 0.0059190383,
				"type": "LOCATION"
			},
			{
				"name": "bear spray",
				"salience": 0.005779449,
				"type": "OTHER"
			},
			{
				"name": "bear spray",
				"salience": 0.005564125,
				"type": "OTHER"
			},
			{
				"name": "couple",
				"salience": 0.005539319,
				"type": "PERSON"
			},
			{
				"name": "couple",
				"salience": 0.005539319,
				"type": "OTHER"
			},
			{
				"name": "Kerry Gunther",
				"salience": 0.0054980135,
				"type": "PERSON"
			},
			{
				"name": "river",
				"salience": 0.0053091436,
				"type": "LOCATION"
			},
			{
				"name": "All",
				"salience": 0.005043486,
				"type": "OTHER"
			},
			{
				"name": "surprise encounter",
				"salience": 0.0049800393,
				"type": "EVENT"
			},
			{
				"name": "contact",
				"salience": 0.0049578315,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.0047944374,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0047944374,
				"type": "OTHER"
			},
			{
				"name": "Park rangers",
				"salience": 0.0047341175,
				"type": "PERSON"
			},
			{
				"name": "cloud",
				"salience": 0.0046157395,
				"type": "OTHER"
			},
			{
				"name": "cloud",
				"salience": 0.0046157395,
				"type": "OTHER"
			},
			{
				"name": "bears",
				"salience": 0.00458461,
				"type": "OTHER"
			},
			{
				"name": "vehicle",
				"salience": 0.0041524405,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "area",
				"salience": 0.0041524405,
				"type": "LOCATION"
			},
			{
				"name": "hillside",
				"salience": 0.0041524405,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0041185557,
				"type": "EVENT"
			},
			{
				"name": "park",
				"salience": 0.0039511872,
				"type": "LOCATION"
			},
			{
				"name": "bear encounter",
				"salience": 0.003915104,
				"type": "EVENT"
			},
			{
				"name": "incident",
				"salience": 0.003915104,
				"type": "EVENT"
			},
			{
				"name": "park ranger",
				"salience": 0.003915104,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09v7g88",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Specimen_Ridge"
				},
				"name": "Specimen Ridge",
				"salience": 0.0036459055,
				"type": "LOCATION"
			},
			{
				"name": "Tower Junction",
				"salience": 0.0036459055,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/050l8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montana"
				},
				"name": "MT",
				"salience": 0.0036459055,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x1y7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bozeman,_Montana"
				},
				"name": "Bozeman",
				"salience": 0.0036459055,
				"type": "LOCATION"
			},
			{
				"name": "bear country",
				"salience": 0.0036123958,
				"type": "LOCATION"
			},
			{
				"name": "bear",
				"salience": 0.003426028,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/08874",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yellowstone_National_Park"
				},
				"name": "Yellowstone National Park",
				"salience": 0.0032031962,
				"type": "LOCATION"
			},
			{
				"name": "bear spray",
				"salience": 0.003147041,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.003116838,
				"type": "OTHER"
			},
			{
				"name": "bear spray",
				"salience": 0.0030296652,
				"type": "OTHER"
			},
			{
				"name": "Bear",
				"salience": 0.0029803365,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.0029255026,
				"type": "OTHER"
			},
			{
				"name": "park",
				"salience": 0.0028785944,
				"type": "LOCATION"
			},
			{
				"name": "wild",
				"salience": 0.0025334933,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0023779317,
				"type": "OTHER"
			},
			{
				"name": "bear conservation",
				"salience": 0.0018454455,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0018454455,
				"type": "OTHER"
			},
			{
				"name": "Campaign",
				"salience": 0.0018454455,
				"type": "EVENT"
			},
			{
				"name": "information",
				"salience": 0.0018454455,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0015921177,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0014321251,
				"type": "PERSON"
			},
			{
				"name": "hike",
				"salience": 0.0013786732,
				"type": "EVENT"
			},
			{
				"name": "safety recommendations",
				"salience": 0.0013786732,
				"type": "OTHER"
			},
			{
				"name": "combination",
				"salience": 0.0013786732,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0013786732,
				"type": "OTHER"
			},
			{
				"name": "Jeff HikinginGlacier.com",
				"salience": 0.0013118553,
				"type": "OTHER"
			},
			{
				"name": "RockyMountainHikingTrails.com HikingintheSmokys.com",
				"salience": 0.0013118553,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.0012939807,
				"type": "OTHER"
			},
			{
				"name": "Studies",
				"salience": 0.0011544233,
				"type": "OTHER"
			},
			{
				"name": "TetonHikingTrails.com",
				"salience": 0.0011359655,
				"type": "OTHER"
			},
			{
				"name": "noise",
				"salience": 0.0010169324,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/mediadrop/uploads/2016/43/4845bd6d526e4e56e4851c00b3a5423e632db3db.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:07:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.049",
		"text": "(Before It's News)\nNews and Adventure from Glacier National Park\nAfter surprising and then being charged by a grizzly bear, a couple fishing along the Lamar River effectively deployed their bear spray and saved themselves from injury on Saturday, October 22.\nJohn and Lisa Vandenbos from Bozeman, MT, parked at a pullout near the Specimen Ridge trailhead in the Lamar Valley, east of Tower Junction. They walked cross-country to the Lamar River and, while scouting for fishing spots, surprised an adult grizzly bear who was feeding on a partially consumed carcass. The bear immediately charged the couple and came within nine feet when both individuals quickly discharged their bear spray.\nThe bear initially left. When attempting to charge the couple again, it ran into the original cloud of bear spray. Upon making contact with the cloud, the bear retreated all the way back across the river and up the adjacent hillside “as fast as it could go”. The couple did not sustain injuries and bear spray stopped the charging bear.\nThe couple left the area immediately and returned to their vehicle. They then reported the incident to a park ranger. Park rangers do not intend to search for the bear since this incident was a surprise encounter with a bear defending its carcass.\nAll of Yellowstone National Park is bear country. Reduce your risk of a bear encounter by carrying bear spray. Studies show that bear spray is more than 90 percent effective in stopping an aggressive bear. In fact, it is the most effective deterrent when used in combination with regular safety recommendations – be alert, make noise, hike in groups of three or more, do not run if you encounter a bear and stand your ground if charged by a bear.\n“Yellowstone visitors care deeply about preserving bears and observing them in the wild,” says Kerry Gunther, the park’s Bear Management Specialist. “Carrying bear spray is the best way for visitors to participate in bear conservation because reducing potential conflicts protects both people and bears.”\nHelp the park increase the number of visitors who carry bear spray and know how to use it. Visit A Bear Doesn’t Care Campaign for more information.\nJeff\nHikinginGlacier.com\nTetonHikingTrails.com\nRockyMountainHikingTrails.com\nHikingintheSmokys.com",
		"thread_title": "Yellowstone Visitors Use Bear Spray to Deter Bear Encounter | Outdoors",
		"title": "Yellowstone Visitors Use Bear Spray to Deter Bear Encounter | Outdoors",
		"type": "bs",
		"uuid": "844b7a0432d94198343904c5fa106fb24b565a3d"
	},
	"-KhIk7CsCVpPvrMIPCCN": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:06:55.438+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.22550459,
				"type": "PERSON"
			},
			{
				"name": "image credit",
				"salience": 0.22487882,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.073957175,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.061080415,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07s76_k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_O'Keefe"
				},
				"name": "Project Veritas",
				"salience": 0.05392073,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.035333812,
				"type": "EVENT"
			},
			{
				"name": "details",
				"salience": 0.026296386,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.022452245,
				"type": "OTHER"
			},
			{
				"name": "levels",
				"salience": 0.019476673,
				"type": "OTHER"
			},
			{
				"name": "The Real Agenda News",
				"salience": 0.013890379,
				"type": "OTHER"
			},
			{
				"name": "Justin Sullivan",
				"salience": 0.012040948,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025yhks",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_(Unix)"
				},
				"name": "Getty",
				"salience": 0.012040948,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05b6w1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Presidency_of_Barack_Obama"
				},
				"name": "Obama White House",
				"salience": 0.012040948,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.010637996,
				"type": "EVENT"
			},
			{
				"name": "Americans United for Change",
				"salience": 0.010278686,
				"type": "ORGANIZATION"
			},
			{
				"name": "result",
				"salience": 0.008070686,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.008070686,
				"type": "EVENT"
			},
			{
				"name": "campaigns",
				"salience": 0.0075514396,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0075514396,
				"type": "EVENT"
			},
			{
				"name": "agents",
				"salience": 0.0065026553,
				"type": "PERSON"
			},
			{
				"name": "James O'Keefe's",
				"salience": 0.006359741,
				"type": "PERSON"
			},
			{
				"name": "cohorts",
				"salience": 0.0059967944,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0057915775,
				"type": "OTHER"
			},
			{
				"name": "veil",
				"salience": 0.00548892,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.0052792965,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.0052093253,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0051036812,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.0049762037,
				"type": "EVENT"
			},
			{
				"name": "ducks",
				"salience": 0.0047679455,
				"type": "OTHER"
			},
			{
				"name": "Scott Foval",
				"salience": 0.0045575732,
				"type": "PERSON"
			},
			{
				"name": "videos",
				"salience": 0.004516901,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.0043486683,
				"type": "WORK_OF_ART"
			},
			{
				"name": "agent provocateurs",
				"salience": 0.0043444135,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.0043297587,
				"type": "EVENT"
			},
			{
				"name": "collusion",
				"salience": 0.004129994,
				"type": "OTHER"
			},
			{
				"name": "rallies",
				"salience": 0.0037044515,
				"type": "EVENT"
			},
			{
				"name": "video",
				"salience": 0.0036889745,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Corrupt practices",
				"salience": 0.0036390077,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0032361692,
				"type": "EVENT"
			},
			{
				"name": "outbursts",
				"salience": 0.0028973774,
				"type": "OTHER"
			},
			{
				"name": "trouble",
				"salience": 0.0028973774,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0028973774,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.002872055,
				"type": "PERSON"
			},
			{
				"name": "moves",
				"salience": 0.0027893598,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.002439153,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.002426575,
				"type": "EVENT"
			},
			{
				"name": "I: Clinton Campaign",
				"salience": 0.0024011885,
				"type": "WORK_OF_ART"
			},
			{
				"name": "operatives",
				"salience": 0.002365867,
				"type": "ORGANIZATION"
			},
			{
				"name": "voter fraud",
				"salience": 0.002365867,
				"type": "OTHER"
			},
			{
				"name": "scale",
				"salience": 0.002365867,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.002365867,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.0022606216,
				"type": "OTHER"
			},
			{
				"name": "mainstream media",
				"salience": 0.0020843348,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.002041289,
				"type": "OTHER"
			},
			{
				"name": "VIDEO",
				"salience": 0.0020085587,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0018325604,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.0017677649,
				"type": "EVENT"
			},
			{
				"name": "supporters",
				"salience": 0.0017677649,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0017677649,
				"type": "LOCATION"
			},
			{
				"name": "post",
				"salience": 0.0016592217,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.001500702,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.001456689,
				"type": "PERSON"
			},
			{
				"name": "masks",
				"salience": 0.001287678,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.00115479,
				"type": "ORGANIZATION"
			},
			{
				"name": "elections",
				"salience": 0.0011109172,
				"type": "EVENT"
			},
			{
				"name": "Election",
				"salience": 0.0011109172,
				"type": "EVENT"
			},
			{
				"name": "Duck And Go",
				"salience": 0.0009153622,
				"type": "OTHER"
			},
			{
				"name": "The Sleuth Journal",
				"salience": 0.0007926337,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Trump Rallies",
				"salience": 0.0007573407,
				"type": "EVENT"
			},
			{
				"name": "DNC Incite Violence",
				"salience": 0.0005921066,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "1",
		"main_img_url": "http://s3-us-west-2.amazonaws.com/sleuthjournal/wp-content/uploads/2016/10/25160224/Double-Take-Hillary-Clinton-A-Reading-List-1200-1024x715.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T18:25:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.4
		},
		"shares": "1",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "(Before It's News)\n(image credit: Justin Sullivan / Getty)\n( The Real Agenda News ) More details have emerged about the never ending levels of corruption among the DNC, the Obama White House and the Hillary Clinton campaign, as a result of James O’Keefe’s Project Veritas’ investigation.\nCorrupt practices go from promoting seemingly harmless campaigns to have people dressed as ducks at Trump rallies to collusion between the Clinton campaign, the DNC and the non-profit organization Americans United for Change.\nIn the third video put out by Project Veritas, Hillary’s cohorts confess how they managed to coordinate with her campaign and the DNC to set up what can be described at the very least as provocative moves to get the Trump campaign in trouble and to have the corrupt mainstream media cover the events while blaming Trump for violent outbursts outside his rallies.\nAs we learned from the previous two videos, it was the Clinton campaign itself the one using agent provocateurs to cause violence outside Trump rallies as these agents disguised themselves as Bernie Sanders’ followers.\nIn his second video, James O’Keefe showed how the DNC and the Hillary Clinton campaign, hire operatives to successfully carry out commit voter fraud on a massive scale.\nScott Foval, who has since been fired, admits that the Democrats have been rigging elections for fifty years.\nIn his first video, Rigging the Election – Video I: Clinton Campaign and DNC Incite Violence at Trump Rallies, O’Keefe showed how second and third parties associated with the Democratic Party and the Clinton campaign, were responsible for violence and attacks on Trump supporters all over the country.\nAs we said before, the veil of corruption that surrounds the Clinton campaign and the Democratic Party continues to fall and people can easily see what is behind their fake progressive and fake liberal masks.\nThe post It is Time For Hillary Clinton To Duck And Go (VIDEO) appeared first on The Sleuth Journal .",
		"thread_title": "It is Time for Hillary Clinton to Duck and Go (Video) | Alternative",
		"title": "It is Time for Hillary Clinton to Duck and Go (Video) | Alternative",
		"type": "bs",
		"uuid": "6c9b8c99ce5cbb1543bff3265bbb5c1b5460cf26"
	},
	"-KhIk7JYRtfd7eXsvvdw": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:07:09.802+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.41496137,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haitian",
				"salience": 0.13003317,
				"type": "LOCATION"
			},
			{
				"name": "Elena Toledo",
				"salience": 0.0963518,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0b90_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mexico"
				},
				"name": "Mexico",
				"salience": 0.084931836,
				"type": "LOCATION"
			},
			{
				"name": "immigrants",
				"salience": 0.07524021,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.046363823,
				"type": "OTHER"
			},
			{
				"name": "Luis Raul Gonzalez",
				"salience": 0.031595547,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.02879087,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/015fr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brazil"
				},
				"name": "Brazil",
				"salience": 0.027730776,
				"type": "LOCATION"
			},
			{
				"name": "flow",
				"salience": 0.019343652,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.016920516,
				"type": "PERSON"
			},
			{
				"name": "National Commission of Human Rights",
				"salience": 0.012100072,
				"type": "ORGANIZATION"
			},
			{
				"name": "issue",
				"salience": 0.010702677,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07xxbw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Human_Rights_Commission_(Mexico)"
				},
				"name": "CNDH",
				"salience": 0.0049337065,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.045",
		"text": "(Before It's News)\nElena Toledo reports that Nearly 50,000 Haitian immigrants have been stranded in Brazil, and in the coming months will pass through Mexico in order to reach the United States. President of Mexico’s National Commission of Human Rights (CNDH) Luis Raul Gonzalez said that the flow of Haitian immigrants to Mexico has become an issue over recent months […]",
		"thread_title": "Mexico: 50,000 Haitians waiting to get into the U.S. | Opinion - Conservative",
		"title": "Mexico: 50,000 Haitians waiting to get into the U.S. | Opinion - Conservative",
		"type": "bs",
		"uuid": "a516f501e29ed3cb22f7b9785ca952b0e2504e46"
	},
	"-KhIk7dt5zLcDePFtC_X": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:07:27.987+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.2886257,
				"type": "PERSON"
			},
			{
				"name": "Malloch Brown",
				"salience": 0.25549474,
				"type": "PERSON"
			},
			{
				"name": "NUKE PRO",
				"salience": 0.22820593,
				"type": "OTHER"
			},
			{
				"name": "buddies",
				"salience": 0.033477448,
				"type": "PERSON"
			},
			{
				"name": "Disaster Preparation Planning",
				"salience": 0.02248813,
				"type": "OTHER"
			},
			{
				"name": "directors",
				"salience": 0.019988218,
				"type": "PERSON"
			},
			{
				"name": "Malloch-Brown",
				"salience": 0.017796405,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0412gcn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Smartmatic"
				},
				"name": "Smartmatic",
				"salience": 0.015719304,
				"type": "ORGANIZATION"
			},
			{
				"name": "Truth Anti-Nuclear Information and Resources",
				"salience": 0.013972396,
				"type": "OTHER"
			},
			{
				"name": "asset",
				"salience": 0.012066395,
				"type": "OTHER"
			},
			{
				"name": "board",
				"salience": 0.009390413,
				"type": "ORGANIZATION"
			},
			{
				"name": "holding company",
				"salience": 0.009390413,
				"type": "ORGANIZATION"
			},
			{
				"name": "chairman",
				"salience": 0.008178352,
				"type": "PERSON"
			},
			{
				"name": "election technology",
				"salience": 0.006771753,
				"type": "OTHER"
			},
			{
				"name": "SGO Corporation Limited",
				"salience": 0.0058017606,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02vhjq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_World_Order_(conspiracy_theory)"
				},
				"name": "NWO",
				"salience": 0.0058017606,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01xfsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Open_Society_Foundations"
				},
				"name": "Open Society Institute",
				"salience": 0.0058017606,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.0043007475,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.0033829901,
				"type": "OTHER"
			},
			{
				"name": "buddy",
				"salience": 0.003071268,
				"type": "PERSON"
			},
			{
				"name": "apartment",
				"salience": 0.0027633926,
				"type": "LOCATION"
			},
			{
				"name": "name",
				"salience": 0.0026604969,
				"type": "OTHER"
			},
			{
				"name": "appointment",
				"salience": 0.0021185915,
				"type": "EVENT"
			},
			{
				"name": "Soros Advisory Committee",
				"salience": 0.0020847796,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0166b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bosnia_and_Herzegovina"
				},
				"name": "Bosnia",
				"salience": 0.0020847796,
				"type": "LOCATION"
			},
			{
				"name": "Refugees International",
				"salience": 0.0020847796,
				"type": "ORGANIZATION"
			},
			{
				"name": "fashion",
				"salience": 0.0020656325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.0017025,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0017025,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0015051417,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.0015051417,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resemblance",
				"salience": 0.0014307834,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0123hq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moloch"
				},
				"name": "Moloch",
				"salience": 0.001408946,
				"type": "OTHER"
			},
			{
				"name": "Soros' Quantum Fund",
				"salience": 0.0013383685,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0lz9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nineteen_Eighty-Four"
				},
				"name": "Orwellian",
				"salience": 0.0012722376,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06wzv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Satan"
				},
				"name": "Satan",
				"salience": 0.00092680566,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0stj7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton,_Iowa"
				},
				"name": "Clinton",
				"salience": 0.00092680566,
				"type": "LOCATION"
			},
			{
				"name": "Sir Mark",
				"salience": 0.00069242896,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/mediadrop/uploads/2016/43/dc105d48c6385c0b95cbccd787d7eb9735689935.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T20:03:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.9,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nNUKE PRO: Exposing Truth Anti-Nuclear Information and Resources, and Disaster Preparation Planning: http://nukeprofessional.blogspot.com/ Malloch-Brown and Soros are buddies at the Soros led NWO “Open Society Institute”\nMalloch Brown became chairman of the board of directors of SGO Corporation Limited, a holding company whose primary asset is the election technology and voting machine manufacturer Smartmatic, in 2014.[37][38]\nMalloch Brown has been closely associated with billionaire speculator George Soros. Working for Refugees International, he was part of the Soros Advisory Committee on Bosnia in 1993–94, formed by George Soros.\nHe has since kept cordial relations with Soros, and rented an apartment owned by Soros while working in New York on UN assignments.[43] In May 2007, Soros' Quantum Fund announced the appointment of Sir Mark as vice-president.[44] In September 2007, The\n—————————————————————————————————–\nIn amazing Orwellian fashion, this buddy of Soros, his name is very similar to Moloch, aka Satan. And in emails to Clinton people speak of “sacrificing to Moloch”. H\nI think I see the resemblance",
		"thread_title": "Proven Link Between Soros And The Voting Machines Used In America | Survival",
		"title": "Proven Link Between Soros And The Voting Machines Used In America | Survival",
		"type": "bs",
		"uuid": "91d110bd34ae45ab2fa24bf9e812315f049c3715"
	},
	"-KhIk8n2kRrwuo3fa-hW": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:07:45.397+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/01561c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Special_forces"
				},
				"name": "Special Forces",
				"salience": 0.13489671,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqi",
				"salience": 0.07834405,
				"type": "LOCATION"
			},
			{
				"name": "Hajj Qassem Soleimani",
				"salience": 0.058073163,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/028t63",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haider_al-Abadi"
				},
				"name": "Haider al-Abadi",
				"salience": 0.029158441,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.027596228,
				"type": "LOCATION"
			},
			{
				"name": "army",
				"salience": 0.025222724,
				"type": "ORGANIZATION"
			},
			{
				"name": "performance",
				"salience": 0.023396557,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "Daesh",
				"salience": 0.021724746,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01cgxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mosul"
				},
				"name": "Mosul",
				"salience": 0.02125763,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.018045194,
				"type": "LOCATION"
			},
			{
				"name": "Battle to Liberate Mosul",
				"salience": 0.013440912,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.013130292,
				"type": "LOCATION"
			},
			{
				"name": "Advanced Stage",
				"salience": 0.01265421,
				"type": "OTHER"
			},
			{
				"name": "civilians",
				"salience": 0.011528107,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.011337969,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.010325299,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0h7q0rq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Abu_Bakr_al-Baghdadi"
				},
				"name": "Abu Bakr al-Baghdadi",
				"salience": 0.009170914,
				"type": "PERSON"
			},
			{
				"name": "News",
				"salience": 0.008407799,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.007209654,
				"type": "ORGANIZATION"
			},
			{
				"name": "terror group",
				"salience": 0.006986939,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0063728215,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0059759533,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03m_n0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Peshmerga"
				},
				"name": "Peshmerga",
				"salience": 0.0056461603,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.005266004,
				"type": "ORGANIZATION"
			},
			{
				"name": "government forces",
				"salience": 0.0051920656,
				"type": "PERSON"
			},
			{
				"name": "Haider Fadhil",
				"salience": 0.0049257153,
				"type": "PERSON"
			},
			{
				"name": "Soleiman",
				"salience": 0.004921038,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.004717591,
				"type": "ORGANIZATION"
			},
			{
				"name": "security forces",
				"salience": 0.004717591,
				"type": "ORGANIZATION"
			},
			{
				"name": "military forces",
				"salience": 0.004428165,
				"type": "PERSON"
			},
			{
				"name": "tunnel",
				"salience": 0.004299416,
				"type": "LOCATION"
			},
			{
				"name": "army",
				"salience": 0.0039534564,
				"type": "ORGANIZATION"
			},
			{
				"name": "advisors",
				"salience": 0.0037594098,
				"type": "OTHER"
			},
			{
				"name": "tunnel",
				"salience": 0.0037402704,
				"type": "LOCATION"
			},
			{
				"name": "security forces",
				"salience": 0.0036858257,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0036858257,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.003627352,
				"type": "LOCATION"
			},
			{
				"name": "partners",
				"salience": 0.0035071839,
				"type": "ORGANIZATION"
			},
			{
				"name": "military campaign",
				"salience": 0.0034194386,
				"type": "EVENT"
			},
			{
				"name": "tank",
				"salience": 0.0033763915,
				"type": "OTHER"
			},
			{
				"name": "government forces",
				"salience": 0.0031749667,
				"type": "PERSON"
			},
			{
				"name": "liberation",
				"salience": 0.0031649258,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.003086996,
				"type": "LOCATION"
			},
			{
				"name": "residents",
				"salience": 0.0029269746,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.002886568,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0028804967,
				"type": "LOCATION"
			},
			{
				"name": "soldiers",
				"salience": 0.0027101843,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0026904612,
				"type": "PERSON"
			},
			{
				"name": "air raids",
				"salience": 0.0026402867,
				"type": "EVENT"
			},
			{
				"name": "phase",
				"salience": 0.0026402867,
				"type": "OTHER"
			},
			{
				"name": "phase",
				"salience": 0.0026402867,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.0026402867,
				"type": "PERSON"
			},
			{
				"name": "Ahmad al-Assadi",
				"salience": 0.0026299148,
				"type": "PERSON"
			},
			{
				"name": "beards",
				"salience": 0.002614358,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00259659,
				"type": "OTHER"
			},
			{
				"name": "liberation operations",
				"salience": 0.00259659,
				"type": "EVENT"
			},
			{
				"name": "region",
				"salience": 0.0025472473,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.002534673,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mosul Battle for Mosul",
				"salience": 0.002492035,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.002442975,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0024091376,
				"type": "ORGANIZATION"
			},
			{
				"name": "Hashd al-Sha'abi",
				"salience": 0.0023877057,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0023849008,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.002365009,
				"type": "LOCATION"
			},
			{
				"name": "fear",
				"salience": 0.0023606354,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vf1h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Special_Forces_(United_States_Army)"
				},
				"name": "Army Special Forces",
				"salience": 0.002269473,
				"type": "ORGANIZATION"
			},
			{
				"name": "plan",
				"salience": 0.0022224807,
				"type": "OTHER"
			},
			{
				"name": "Quote: da",
				"salience": 0.0021984305,
				"type": "OTHER"
			},
			{
				"name": "committees",
				"salience": 0.002067651,
				"type": "ORGANIZATION"
			},
			{
				"name": "demand",
				"salience": 0.0019532552,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.0019279736,
				"type": "LOCATION"
			},
			{
				"name": "road",
				"salience": 0.0019214774,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.0019102063,
				"type": "LOCATION"
			},
			{
				"name": "front",
				"salience": 0.0019102063,
				"type": "OTHER"
			},
			{
				"name": "villages",
				"salience": 0.0019102063,
				"type": "LOCATION"
			},
			{
				"name": "village",
				"salience": 0.0019102063,
				"type": "LOCATION"
			},
			{
				"name": "Civilians",
				"salience": 0.0019063333,
				"type": "PERSON"
			},
			{
				"name": "Province",
				"salience": 0.0018256207,
				"type": "LOCATION"
			},
			{
				"name": "camp",
				"salience": 0.0017247719,
				"type": "LOCATION"
			},
			{
				"name": "Prime Minister",
				"salience": 0.0017247719,
				"type": "PERSON"
			},
			{
				"name": "weapons",
				"salience": 0.0017247719,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.0017247719,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.0017247719,
				"type": "LOCATION"
			},
			{
				"name": "coalition",
				"salience": 0.0016793519,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0016531959,
				"type": "PERSON"
			},
			{
				"name": "Bashiqa Iraqi",
				"salience": 0.0016278912,
				"type": "LOCATION"
			},
			{
				"name": "Front Lines Iraqi",
				"salience": 0.0016278912,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07s1801"
				},
				"name": "North",
				"salience": 0.0016224635,
				"type": "LOCATION"
			},
			{
				"name": "stage",
				"salience": 0.0016166782,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0016166782,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0016099269,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "Western alliance",
				"salience": 0.0015628929,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.001526601,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.00151789,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00151789,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.00151789,
				"type": "PERSON"
			},
			{
				"name": "Militants Disguise",
				"salience": 0.0015017244,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.001493552,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0014828433,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01chdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nineveh_Governorate"
				},
				"name": "Nineveh",
				"salience": 0.0014774813,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.0014159933,
				"type": "ORGANIZATION"
			},
			{
				"name": "woman",
				"salience": 0.0013927271,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bbw_2l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashiqa"
				},
				"name": "Bashiqa",
				"salience": 0.0013917598,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0013485418,
				"type": "PERSON"
			},
			{
				"name": "families",
				"salience": 0.0013485418,
				"type": "PERSON"
			},
			{
				"name": "lines",
				"salience": 0.0013485418,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0013485418,
				"type": "PERSON"
			},
			{
				"name": "news conference",
				"salience": 0.0013485418,
				"type": "EVENT"
			},
			{
				"name": "terrorists",
				"salience": 0.0013413348,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.0013071708,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Islamic Republic of Iran",
				"salience": 0.0013013973,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0012912183,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.0012482314,
				"type": "OTHER"
			},
			{
				"name": "weapons depot",
				"salience": 0.0012441685,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.0012242764,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0012156386,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.0012028331,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0jzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabic"
				},
				"name": "Arabic",
				"salience": 0.0011775461,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.0011677339,
				"type": "LOCATION"
			},
			{
				"name": "cooperation",
				"salience": 0.0011677339,
				"type": "OTHER"
			},
			{
				"name": "fuel",
				"salience": 0.0011677339,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0011677339,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0011653451,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.0011614749,
				"type": "PERSON"
			},
			{
				"name": "Safa al-A'asam",
				"salience": 0.0011272354,
				"type": "PERSON"
			},
			{
				"name": "outskirts",
				"salience": 0.0011180926,
				"type": "LOCATION"
			},
			{
				"name": "road",
				"salience": 0.0010860362,
				"type": "LOCATION"
			},
			{
				"name": "Sergei Rudskoi",
				"salience": 0.0010774903,
				"type": "PERSON"
			},
			{
				"name": "military operation",
				"salience": 0.0010690357,
				"type": "OTHER"
			},
			{
				"name": "terrorist group",
				"salience": 0.0010690357,
				"type": "ORGANIZATION"
			},
			{
				"name": "military operations",
				"salience": 0.0010690357,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.0010642586,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0010642586,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0010642586,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0010642586,
				"type": "OTHER"
			},
			{
				"name": "ISIL Weapons",
				"salience": 0.0010616581,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0010415529,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.001029918,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0010245305,
				"type": "ORGANIZATION"
			},
			{
				"name": "security forces",
				"salience": 0.0010245305,
				"type": "ORGANIZATION"
			},
			{
				"name": "security forces",
				"salience": 0.0010245305,
				"type": "ORGANIZATION"
			},
			{
				"name": "Cache",
				"salience": 0.0010156949,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.0010057533,
				"type": "LOCATION"
			},
			{
				"name": "city",
				"salience": 0.0010057533,
				"type": "LOCATION"
			},
			{
				"name": "Abadi: Battle to Liberate Mosul Reaches Advanced Stage",
				"salience": 0.0009951054,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.0009951054,
				"type": "LOCATION"
			},
			{
				"name": "Tob Zawa",
				"salience": 0.0009951054,
				"type": "ORGANIZATION"
			},
			{
				"name": "troops",
				"salience": 0.0009933206,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.000974473,
				"type": "PERSON"
			},
			{
				"name": "operation",
				"salience": 0.0009659002,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.00095329084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.00094429817,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0009404473,
				"type": "OTHER"
			},
			{
				"name": "casualties",
				"salience": 0.0009404103,
				"type": "OTHER"
			},
			{
				"name": "tanks",
				"salience": 0.0009404103,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.00092859595,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.00092627347,
				"type": "OTHER"
			},
			{
				"name": "suicide attackers",
				"salience": 0.0009080858,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.00090219564,
				"type": "OTHER"
			},
			{
				"name": "uniforms",
				"salience": 0.0008987341,
				"type": "OTHER"
			},
			{
				"name": "military uniforms",
				"salience": 0.0008987341,
				"type": "OTHER"
			},
			{
				"name": "security source",
				"salience": 0.00088045705,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fqm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baghdad"
				},
				"name": "Baghdad",
				"salience": 0.0008779726,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.00086881086,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.0008323957,
				"type": "LOCATION"
			},
			{
				"name": "civilians",
				"salience": 0.00082020665,
				"type": "PERSON"
			},
			{
				"name": "strongholds",
				"salience": 0.0008143047,
				"type": "LOCATION"
			},
			{
				"name": "plane",
				"salience": 0.00079579314,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00078745274,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0007863133,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03slm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraqi_Army"
				},
				"name": "Iraqi Army",
				"salience": 0.00077382906,
				"type": "ORGANIZATION"
			},
			{
				"name": "territories",
				"salience": 0.00076772977,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.00076772977,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.00076772977,
				"type": "PERSON"
			},
			{
				"name": "terrorism",
				"salience": 0.00076772977,
				"type": "OTHER"
			},
			{
				"name": "security source",
				"salience": 0.0007658095,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01cf0p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Cardinal_direction"
				},
				"name": "Southwest",
				"salience": 0.0007580594,
				"type": "LOCATION"
			},
			{
				"name": "district",
				"salience": 0.000749897,
				"type": "LOCATION"
			},
			{
				"name": "province",
				"salience": 0.000749897,
				"type": "LOCATION"
			},
			{
				"name": "operations",
				"salience": 0.00074950536,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00074950536,
				"type": "OTHER"
			},
			{
				"name": "liberation operations",
				"salience": 0.00074950536,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00074950536,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00074950536,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.00074950536,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.00074762874,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.00074762874,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0007407919,
				"type": "LOCATION"
			},
			{
				"name": "Military",
				"salience": 0.0007382065,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist group",
				"salience": 0.0007215232,
				"type": "ORGANIZATION"
			},
			{
				"name": "military operation",
				"salience": 0.0007215232,
				"type": "OTHER"
			},
			{
				"name": "disappearance",
				"salience": 0.0007211923,
				"type": "EVENT"
			},
			{
				"name": "Alaraby",
				"salience": 0.0007187171,
				"type": "PERSON"
			},
			{
				"name": "Tiz Khrab Gawra",
				"salience": 0.0007187171,
				"type": "LOCATION"
			},
			{
				"name": "Khazer",
				"salience": 0.0007187171,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.0007078016,
				"type": "LOCATION"
			},
			{
				"name": "start",
				"salience": 0.0007062837,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0zrrlp3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agnes_Mariam_de_la_Croix"
				},
				"name": "Agnes",
				"salience": 0.0006869948,
				"type": "PERSON"
			},
			{
				"name": "Eenters Strait Of Gibraltar",
				"salience": 0.0006869948,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ebrahim al-Jafari",
				"salience": 0.00067279296,
				"type": "PERSON"
			},
			{
				"name": "Kicks Off Zawaya Liberation Operation Iraq",
				"salience": 0.0006700551,
				"type": "LOCATION"
			},
			{
				"name": "Commander",
				"salience": 0.00066889136,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bd931",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quds_Force"
				},
				"name": "Quds Force",
				"salience": 0.0006550192,
				"type": "ORGANIZATION"
			},
			{
				"name": "control",
				"salience": 0.0006549875,
				"type": "OTHER"
			},
			{
				"name": "government forces",
				"salience": 0.0006489912,
				"type": "ORGANIZATION"
			},
			{
				"name": "government forces",
				"salience": 0.0006489912,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0006489912,
				"type": "ORGANIZATION"
			},
			{
				"name": "militants",
				"salience": 0.0006339846,
				"type": "PERSON"
			},
			{
				"name": "training militants",
				"salience": 0.0006339846,
				"type": "PERSON"
			},
			{
				"name": "Plot",
				"salience": 0.0006300927,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0006187582,
				"type": "ORGANIZATION"
			},
			{
				"name": "source",
				"salience": 0.00061727746,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.00061473955,
				"type": "PERSON"
			},
			{
				"name": "control",
				"salience": 0.00061473955,
				"type": "OTHER"
			},
			{
				"name": "language",
				"salience": 0.00061473955,
				"type": "OTHER"
			},
			{
				"name": "Millions",
				"salience": 0.00061473955,
				"type": "PERSON"
			},
			{
				"name": "Report",
				"salience": 0.00061473955,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.00061473955,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.00061473955,
				"type": "PERSON"
			},
			{
				"name": "news channel",
				"salience": 0.00061473955,
				"type": "OTHER"
			},
			{
				"name": "military analyst",
				"salience": 0.00061473955,
				"type": "PERSON"
			},
			{
				"name": "operations",
				"salience": 0.0006118462,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.0006118462,
				"type": "ORGANIZATION"
			},
			{
				"name": "presence",
				"salience": 0.0006012297,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.00060020987,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.00059572083,
				"type": "PERSON"
			},
			{
				"name": "region",
				"salience": 0.0005888056,
				"type": "LOCATION"
			},
			{
				"name": "Counterterrorism Forces Major General",
				"salience": 0.0005750009,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0005734787,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0005734787,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0005734787,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0005734787,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0005734787,
				"type": "PERSON"
			},
			{
				"name": "Western Mosul",
				"salience": 0.00057304354,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.00056559104,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0005604185,
				"type": "ORGANIZATION"
			},
			{
				"name": "chief",
				"salience": 0.0005550341,
				"type": "PERSON"
			},
			{
				"name": "charge",
				"salience": 0.0005550341,
				"type": "OTHER"
			},
			{
				"name": "suicide bombers",
				"salience": 0.0005550341,
				"type": "PERSON"
			},
			{
				"name": "plots",
				"salience": 0.0005550341,
				"type": "OTHER"
			},
			{
				"name": "move",
				"salience": 0.0005550341,
				"type": "EVENT"
			},
			{
				"name": "charge",
				"salience": 0.0005550341,
				"type": "OTHER"
			},
			{
				"name": "Most",
				"salience": 0.0005550341,
				"type": "OTHER"
			},
			{
				"name": "Abu Mehdi al-Mohandes",
				"salience": 0.00054922013,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0005408143,
				"type": "LOCATION"
			},
			{
				"name": "army officer",
				"salience": 0.0005376253,
				"type": "PERSON"
			},
			{
				"name": "army",
				"salience": 0.0005375218,
				"type": "ORGANIZATION"
			},
			{
				"name": "army",
				"salience": 0.0005375218,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04s3g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Armed_forces"
				},
				"name": "Armed Forces",
				"salience": 0.0005347101,
				"type": "ORGANIZATION"
			},
			{
				"name": "media reports",
				"salience": 0.0005346843,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0xff",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arabs"
				},
				"name": "Arab",
				"salience": 0.0005332335,
				"type": "PERSON"
			},
			{
				"name": "fighter jets",
				"salience": 0.0005306852,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0005306852,
				"type": "LOCATION"
			},
			{
				"name": "fighter jets",
				"salience": 0.0005306852,
				"type": "OTHER"
			},
			{
				"name": "military advisors",
				"salience": 0.00052573485,
				"type": "OTHER"
			},
			{
				"name": "military advisors",
				"salience": 0.00052573485,
				"type": "OTHER"
			},
			{
				"name": "province",
				"salience": 0.00052573485,
				"type": "LOCATION"
			},
			{
				"name": "military advisor",
				"salience": 0.00052573485,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0005213616,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00051684567,
				"type": "PERSON"
			},
			{
				"name": "province",
				"salience": 0.0005061052,
				"type": "LOCATION"
			},
			{
				"name": "district",
				"salience": 0.0005061052,
				"type": "LOCATION"
			},
			{
				"name": "member",
				"salience": 0.0005056088,
				"type": "PERSON"
			},
			{
				"name": "Flee Mosul An",
				"salience": 0.0005046036,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.00049772585,
				"type": "OTHER"
			},
			{
				"name": "participation",
				"salience": 0.00049772585,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00049772585,
				"type": "EVENT"
			},
			{
				"name": "community",
				"salience": 0.00048712737,
				"type": "PERSON"
			},
			{
				"name": "commander",
				"salience": 0.00048712737,
				"type": "PERSON"
			},
			{
				"name": "Badr News",
				"salience": 0.00048393055,
				"type": "ORGANIZATION"
			},
			{
				"name": "Brain",
				"salience": 0.00048059563,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.00048059563,
				"type": "OTHER"
			},
			{
				"name": "camouflage",
				"salience": 0.00048059563,
				"type": "OTHER"
			},
			{
				"name": "suspicion",
				"salience": 0.00048059563,
				"type": "OTHER"
			},
			{
				"name": "cash",
				"salience": 0.00048059563,
				"type": "OTHER"
			},
			{
				"name": "dossiers",
				"salience": 0.00048059563,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00047914175,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.00047914175,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.00047914175,
				"type": "LOCATION"
			},
			{
				"name": "areas",
				"salience": 0.00047914175,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.00047356702,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.00047356702,
				"type": "PERSON"
			},
			{
				"name": "government forces",
				"salience": 0.0004726338,
				"type": "ORGANIZATION"
			},
			{
				"name": "Forces",
				"salience": 0.0004726338,
				"type": "OTHER"
			},
			{
				"name": "Forces",
				"salience": 0.0004726338,
				"type": "OTHER"
			},
			{
				"name": "air force",
				"salience": 0.0004726338,
				"type": "ORGANIZATION"
			},
			{
				"name": "road",
				"salience": 0.0004692359,
				"type": "LOCATION"
			},
			{
				"name": "military counseling",
				"salience": 0.0004692359,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00046651764,
				"type": "OTHER"
			},
			{
				"name": "Militants Alive",
				"salience": 0.00046011957,
				"type": "PERSON"
			},
			{
				"name": "terrorist groups",
				"salience": 0.00045702927,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist group",
				"salience": 0.00045702927,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist groups",
				"salience": 0.00045702927,
				"type": "ORGANIZATION"
			},
			{
				"name": "Analyst",
				"salience": 0.0004534028,
				"type": "PERSON"
			},
			{
				"name": "villages",
				"salience": 0.00045001158,
				"type": "LOCATION"
			},
			{
				"name": "Abi Motaz al-Qahtani",
				"salience": 0.0004498378,
				"type": "PERSON"
			},
			{
				"name": "presence",
				"salience": 0.00044909862,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00044909862,
				"type": "OTHER"
			},
			{
				"name": "Media",
				"salience": 0.00044909862,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.00044909862,
				"type": "OTHER"
			},
			{
				"name": "coalition",
				"salience": 0.00044909862,
				"type": "ORGANIZATION"
			},
			{
				"name": "region",
				"salience": 0.00044833677,
				"type": "LOCATION"
			},
			{
				"name": "regions",
				"salience": 0.00044833677,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.00044833677,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.00044402902,
				"type": "OTHER"
			},
			{
				"name": "units",
				"salience": 0.00043843227,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.00043383654,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.00043097188,
				"type": "WORK_OF_ART"
			},
			{
				"name": "province",
				"salience": 0.0004291675,
				"type": "LOCATION"
			},
			{
				"name": "losses",
				"salience": 0.0004291675,
				"type": "OTHER"
			},
			{
				"name": "losses",
				"salience": 0.0004291675,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00042729665,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0004235367,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.0004235367,
				"type": "ORGANIZATION"
			},
			{
				"name": "supply routes",
				"salience": 0.00041800638,
				"type": "OTHER"
			},
			{
				"name": "Terrorists",
				"salience": 0.00041763755,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.00041763755,
				"type": "PERSON"
			},
			{
				"name": "oil",
				"salience": 0.00041487982,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.00041487982,
				"type": "PERSON"
			},
			{
				"name": "outskirts",
				"salience": 0.00041487982,
				"type": "LOCATION"
			},
			{
				"name": "girls' school",
				"salience": 0.00041487982,
				"type": "ORGANIZATION"
			},
			{
				"name": "girls' school",
				"salience": 0.00041487982,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00041458997,
				"type": "PERSON"
			},
			{
				"name": "Zawaya",
				"salience": 0.0004095307,
				"type": "OTHER"
			},
			{
				"name": "al-Sumeriya",
				"salience": 0.0004095307,
				"type": "ORGANIZATION"
			},
			{
				"name": "Zawaya",
				"salience": 0.0004095307,
				"type": "LOCATION"
			},
			{
				"name": "weapons",
				"salience": 0.0004063023,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0004063023,
				"type": "EVENT"
			},
			{
				"name": "Casualties",
				"salience": 0.0004063023,
				"type": "OTHER"
			},
			{
				"name": "BATTLE TANKS",
				"salience": 0.0004063023,
				"type": "OTHER"
			},
			{
				"name": "artillery units",
				"salience": 0.0004063023,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01d7pt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brigadier_general"
				},
				"name": "Brigadier-General",
				"salience": 0.00040311052,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02rjqfl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Air_Force"
				},
				"name": "Air Force",
				"salience": 0.00039940784,
				"type": "ORGANIZATION"
			},
			{
				"name": "Abdolvahab al-Saedi",
				"salience": 0.0003912536,
				"type": "PERSON"
			},
			{
				"name": "operations room",
				"salience": 0.00038911164,
				"type": "LOCATION"
			},
			{
				"name": "request",
				"salience": 0.00038911164,
				"type": "OTHER"
			},
			{
				"name": "invitation",
				"salience": 0.00038911164,
				"type": "OTHER"
			},
			{
				"name": "agreement",
				"salience": 0.00038911164,
				"type": "OTHER"
			},
			{
				"name": "invitation",
				"salience": 0.00038911164,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.0003882057,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.0003882057,
				"type": "EVENT"
			},
			{
				"name": "bombardments",
				"salience": 0.000384207,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraqis",
				"salience": 0.00038346834,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00038082563,
				"type": "EVENT"
			},
			{
				"name": "coalition",
				"salience": 0.00038082563,
				"type": "ORGANIZATION"
			},
			{
				"name": "vehicles",
				"salience": 0.00038082563,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Aleppo Long Military Convoy of Terrorists",
				"salience": 0.0003784365,
				"type": "OTHER"
			},
			{
				"name": "Shave Beard",
				"salience": 0.0003783263,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0285v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Dollar"
				},
				"name": "Dollars",
				"salience": 0.0003783263,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.00037639195,
				"type": "EVENT"
			},
			{
				"name": "news channel",
				"salience": 0.00037484424,
				"type": "ORGANIZATION"
			},
			{
				"name": "language",
				"salience": 0.00037484424,
				"type": "OTHER"
			},
			{
				"name": "airstrike",
				"salience": 0.00037458236,
				"type": "EVENT"
			},
			{
				"name": "warplane",
				"salience": 0.00037458236,
				"type": "OTHER"
			},
			{
				"name": "airstrikes",
				"salience": 0.00037458236,
				"type": "EVENT"
			},
			{
				"name": "confrontation",
				"salience": 0.00037458236,
				"type": "EVENT"
			},
			{
				"name": "hands",
				"salience": 0.00037458236,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.00037344915,
				"type": "LOCATION"
			},
			{
				"name": "Abu Yusuf al-Askari",
				"salience": 0.00036922086,
				"type": "PERSON"
			},
			{
				"name": "commander",
				"salience": 0.00036386354,
				"type": "PERSON"
			},
			{
				"name": "battle",
				"salience": 0.00036386354,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01x38c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daraa"
				},
				"name": "Dara'a",
				"salience": 0.00035743887,
				"type": "LOCATION"
			},
			{
				"name": "coalition",
				"salience": 0.00035742193,
				"type": "ORGANIZATION"
			},
			{
				"name": "nation",
				"salience": 0.0003544594,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07sdncw"
				},
				"name": "Northwest",
				"salience": 0.00035353078,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03hz03",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Raqqah"
				},
				"name": "Raqqa",
				"salience": 0.00035349757,
				"type": "LOCATION"
			},
			{
				"name": "forces",
				"salience": 0.0003530369,
				"type": "PERSON"
			},
			{
				"name": "military forces",
				"salience": 0.0003530369,
				"type": "PERSON"
			},
			{
				"name": "forces",
				"salience": 0.0003530369,
				"type": "ORGANIZATION"
			},
			{
				"name": "news channel",
				"salience": 0.0003518081,
				"type": "OTHER"
			},
			{
				"name": "convoy",
				"salience": 0.0003518081,
				"type": "OTHER"
			},
			{
				"name": "Analyst",
				"salience": 0.0003518081,
				"type": "PERSON"
			},
			{
				"name": "demand",
				"salience": 0.0003518081,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.0003504987,
				"type": "LOCATION"
			},
			{
				"name": "Regions",
				"salience": 0.000347877,
				"type": "LOCATION"
			},
			{
				"name": "militants",
				"salience": 0.00034487265,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.00034487265,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.00034487265,
				"type": "PERSON"
			},
			{
				"name": "Hashd al-Sha'abi",
				"salience": 0.00033926085,
				"type": "OTHER"
			},
			{
				"name": "consultations",
				"salience": 0.00033692273,
				"type": "EVENT"
			},
			{
				"name": "figures",
				"salience": 0.00033692273,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.00033692273,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00033692273,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.00033692273,
				"type": "OTHER"
			},
			{
				"name": "plots",
				"salience": 0.00033692273,
				"type": "OTHER"
			},
			{
				"name": "capabilities",
				"salience": 0.00033692273,
				"type": "OTHER"
			},
			{
				"name": "Spokesman",
				"salience": 0.00033692273,
				"type": "PERSON"
			},
			{
				"name": "remarks",
				"salience": 0.00033692273,
				"type": "OTHER"
			},
			{
				"name": "views",
				"salience": 0.00033692273,
				"type": "OTHER"
			},
			{
				"name": "US Air Force Jet Struck School",
				"salience": 0.00033624342,
				"type": "ORGANIZATION"
			},
			{
				"name": "artillery",
				"salience": 0.0003361383,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0003361383,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.0003361383,
				"type": "OTHER"
			},
			{
				"name": "villages",
				"salience": 0.0003361383,
				"type": "LOCATION"
			},
			{
				"name": "towns",
				"salience": 0.0003361383,
				"type": "LOCATION"
			},
			{
				"name": "artillery",
				"salience": 0.0003361383,
				"type": "OTHER"
			},
			{
				"name": "army positions",
				"salience": 0.0003361383,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0003361383,
				"type": "LOCATION"
			},
			{
				"name": "ground",
				"salience": 0.0003328285,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.0003328285,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorist groups",
				"salience": 0.0003328285,
				"type": "ORGANIZATION"
			},
			{
				"name": "Aleppo Syrian Army",
				"salience": 0.00033080045,
				"type": "ORGANIZATION"
			},
			{
				"name": "chief",
				"salience": 0.00032579762,
				"type": "PERSON"
			},
			{
				"name": "trenches",
				"salience": 0.0003243419,
				"type": "OTHER"
			},
			{
				"name": "corridor",
				"salience": 0.0003243419,
				"type": "LOCATION"
			},
			{
				"name": "duck-out",
				"salience": 0.0003243419,
				"type": "EVENT"
			},
			{
				"name": "flights",
				"salience": 0.0003243419,
				"type": "EVENT"
			},
			{
				"name": "districts",
				"salience": 0.00032056798,
				"type": "LOCATION"
			},
			{
				"name": "district",
				"salience": 0.00032056798,
				"type": "LOCATION"
			},
			{
				"name": "districts",
				"salience": 0.00032056798,
				"type": "LOCATION"
			},
			{
				"name": "scores",
				"salience": 0.000317636,
				"type": "OTHER"
			},
			{
				"name": "start",
				"salience": 0.000317636,
				"type": "EVENT"
			},
			{
				"name": "agreement",
				"salience": 0.000317636,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.000317636,
				"type": "EVENT"
			},
			{
				"name": "hands",
				"salience": 0.000317636,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.000317636,
				"type": "EVENT"
			},
			{
				"name": "official",
				"salience": 0.000317636,
				"type": "PERSON"
			},
			{
				"name": "terrain",
				"salience": 0.0003119553,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0003119553,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0003119553,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0003119553,
				"type": "PERSON"
			},
			{
				"name": "terrorists",
				"salience": 0.0003119553,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dc1d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sumer"
				},
				"name": "Sumeria",
				"salience": 0.000308643,
				"type": "ORGANIZATION"
			},
			{
				"name": "assault",
				"salience": 0.00030695327,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/018hmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southern_United_States"
				},
				"name": "Southern",
				"salience": 0.00030358296,
				"type": "LOCATION"
			},
			{
				"name": "clashes",
				"salience": 0.00030348805,
				"type": "OTHER"
			},
			{
				"name": "concentration centers",
				"salience": 0.00030348805,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.00030348805,
				"type": "OTHER"
			},
			{
				"name": "mortar units",
				"salience": 0.00030348805,
				"type": "OTHER"
			},
			{
				"name": "clashes",
				"salience": 0.00030348805,
				"type": "EVENT"
			},
			{
				"name": "centers",
				"salience": 0.00030348805,
				"type": "LOCATION"
			},
			{
				"name": "clashes",
				"salience": 0.00030348805,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027rjr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Northeastern_United_States"
				},
				"name": "Northeastern",
				"salience": 0.00029978438,
				"type": "LOCATION"
			},
			{
				"name": "Treasury Man",
				"salience": 0.00029576436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vxgp18",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rudaw_Media_Network"
				},
				"name": "Rudaw",
				"salience": 0.00029576436,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ankara"
				},
				"name": "Ankara",
				"salience": 0.00029576436,
				"type": "LOCATION"
			},
			{
				"name": "Kokajli",
				"salience": 0.00029576436,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dlm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Riyadh"
				},
				"name": "Riyadh",
				"salience": 0.00029576436,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07q3j97"
				},
				"name": "South",
				"salience": 0.00029486956,
				"type": "LOCATION"
			},
			{
				"name": "army artillery units",
				"salience": 0.00028847286,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00028406366,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.00028406366,
				"type": "LOCATION"
			},
			{
				"name": "attacks",
				"salience": 0.00028270597,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0n49m9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ahrar_ash-Sham"
				},
				"name": "Ahrar al-Sham",
				"salience": 0.0002769412,
				"type": "ORGANIZATION"
			},
			{
				"name": "ISIL Burns Nine",
				"salience": 0.00027637932,
				"type": "ORGANIZATION"
			},
			{
				"name": "Al Sumeriya",
				"salience": 0.00027637932,
				"type": "ORGANIZATION"
			},
			{
				"name": "possibilities",
				"salience": 0.00027503254,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00027503254,
				"type": "OTHER"
			},
			{
				"name": "Admiral Kuznetsov",
				"salience": 0.00027503254,
				"type": "PERSON"
			},
			{
				"name": "ceasefire",
				"salience": 0.00027503254,
				"type": "EVENT"
			},
			{
				"name": "footage",
				"salience": 0.00027503254,
				"type": "WORK_OF_ART"
			},
			{
				"name": "shelling",
				"salience": 0.00027503254,
				"type": "OTHER"
			},
			{
				"name": "military column",
				"salience": 0.00027503254,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04q3gn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Army_of_the_Guardians_of_the_Islamic_Revolution"
				},
				"name": "Islamic Revolution Guards Corps",
				"salience": 0.00027306064,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01ch7h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saladin_Governorate"
				},
				"name": "Salahuddin",
				"salience": 0.00026698803,
				"type": "LOCATION"
			},
			{
				"name": "Senior Terrorist Commander",
				"salience": 0.0002649784,
				"type": "PERSON"
			},
			{
				"name": "bases",
				"salience": 0.000262782,
				"type": "OTHER"
			},
			{
				"name": "bases",
				"salience": 0.000262782,
				"type": "OTHER"
			},
			{
				"name": "government strongholds",
				"salience": 0.000262782,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.000262782,
				"type": "OTHER"
			},
			{
				"name": "Terrorists in Housing Project 1070",
				"salience": 0.0002570166,
				"type": "PERSON"
			},
			{
				"name": "Damascus Terrorist",
				"salience": 0.0002570166,
				"type": "PERSON"
			},
			{
				"name": "Hama Terrorist",
				"salience": 0.0002570166,
				"type": "PERSON"
			},
			{
				"name": "countryside",
				"salience": 0.00025524525,
				"type": "LOCATION"
			},
			{
				"name": "countryside",
				"salience": 0.00025524525,
				"type": "LOCATION"
			},
			{
				"name": "news agency",
				"salience": 0.00025279258,
				"type": "ORGANIZATION"
			},
			{
				"name": "Northeastern Dara'a",
				"salience": 0.00025004038,
				"type": "LOCATION"
			},
			{
				"name": "Western Ghouta SAA Soldier",
				"salience": 0.00025004038,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.00024919474,
				"type": "LOCATION"
			},
			{
				"name": "group",
				"salience": 0.00024860475,
				"type": "ORGANIZATION"
			},
			{
				"name": "government positions",
				"salience": 0.00024478708,
				"type": "OTHER"
			},
			{
				"name": "government positions",
				"salience": 0.00024478708,
				"type": "OTHER"
			},
			{
				"name": "fighter jets",
				"salience": 0.00024478708,
				"type": "OTHER"
			},
			{
				"name": "region",
				"salience": 0.00024387598,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.00024387598,
				"type": "LOCATION"
			},
			{
				"name": "regions",
				"salience": 0.00024387598,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.00024387598,
				"type": "LOCATION"
			},
			{
				"name": "region",
				"salience": 0.00024387598,
				"type": "LOCATION"
			},
			{
				"name": "regions",
				"salience": 0.00024387598,
				"type": "LOCATION"
			},
			{
				"name": "Elsewhere",
				"salience": 0.00024226551,
				"type": "LOCATION"
			},
			{
				"name": "General Soleimani in Mosul Operations Room",
				"salience": 0.00023946047,
				"type": "LOCATION"
			},
			{
				"name": "Air Attacks Preempt Terrorists' Great Epic Operation",
				"salience": 0.0002384999,
				"type": "EVENT"
			},
			{
				"name": "Military sources",
				"salience": 0.00023840263,
				"type": "PERSON"
			},
			{
				"name": "gathering",
				"salience": 0.00023725639,
				"type": "EVENT"
			},
			{
				"name": "Dozens",
				"salience": 0.00023725639,
				"type": "PERSON"
			},
			{
				"name": "army agent",
				"salience": 0.00023725639,
				"type": "PERSON"
			},
			{
				"name": "intel",
				"salience": 0.00023725639,
				"type": "OTHER"
			},
			{
				"name": "gatherings",
				"salience": 0.00023725639,
				"type": "OTHER"
			},
			{
				"name": "scores",
				"salience": 0.00023725639,
				"type": "OTHER"
			},
			{
				"name": "death toll",
				"salience": 0.00023725639,
				"type": "OTHER"
			},
			{
				"name": "height",
				"salience": 0.00023725639,
				"type": "OTHER"
			},
			{
				"name": "warplanes",
				"salience": 0.00023725639,
				"type": "OTHER"
			},
			{
				"name": "loss",
				"salience": 0.00023344786,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "JABHAT AL NUSRA",
				"salience": 0.00023117717,
				"type": "ORGANIZATION"
			},
			{
				"name": "Northern Homs",
				"salience": 0.00023117717,
				"type": "LOCATION"
			},
			{
				"name": "Eastern Damascus",
				"salience": 0.00022454678,
				"type": "LOCATION"
			},
			{
				"name": "SAA 1st ARMORED DIVISION",
				"salience": 0.00022290033,
				"type": "ORGANIZATION"
			},
			{
				"name": "centers",
				"salience": 0.00022100926,
				"type": "LOCATION"
			},
			{
				"name": "clashes",
				"salience": 0.00022100926,
				"type": "EVENT"
			},
			{
				"name": "tanks",
				"salience": 0.00022100926,
				"type": "OTHER"
			},
			{
				"name": "centers",
				"salience": 0.00022100926,
				"type": "LOCATION"
			},
			{
				"name": "clashes",
				"salience": 0.00022100926,
				"type": "EVENT"
			},
			{
				"name": "casualties",
				"salience": 0.00022100926,
				"type": "OTHER"
			},
			{
				"name": "centers",
				"salience": 0.00022100926,
				"type": "LOCATION"
			},
			{
				"name": "Weapons",
				"salience": 0.00022100926,
				"type": "OTHER"
			},
			{
				"name": "hills",
				"salience": 0.00021888554,
				"type": "LOCATION"
			},
			{
				"name": "Army Offensive",
				"salience": 0.00021650246,
				"type": "OTHER"
			},
			{
				"name": "Northern Lattakia",
				"salience": 0.00021297166,
				"type": "LOCATION"
			},
			{
				"name": "Hama Syrian Army Seizes Militants",
				"salience": 0.00021223417,
				"type": "PERSON"
			},
			{
				"name": "attacks",
				"salience": 0.00021116484,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.00021116484,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.00021116484,
				"type": "EVENT"
			},
			{
				"name": "attack",
				"salience": 0.00021116484,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0266sd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al_Akhbar_(Lebanon)"
				},
				"name": "al-Akhbar",
				"salience": 0.00020734152,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.00020734152,
				"type": "ORGANIZATION"
			},
			{
				"name": "anti-ISIL",
				"salience": 0.00020734152,
				"type": "OTHER"
			},
			{
				"name": "military vehicles",
				"salience": 0.00020715015,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Jeish al-Fatah",
				"salience": 0.00020685875,
				"type": "PERSON"
			},
			{
				"name": "building blocks",
				"salience": 0.00020543305,
				"type": "OTHER"
			},
			{
				"name": "missile",
				"salience": 0.00020543305,
				"type": "OTHER"
			},
			{
				"name": "Positions",
				"salience": 0.00020495472,
				"type": "OTHER"
			},
			{
				"name": "Positions",
				"salience": 0.00020495472,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0002013261,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0002013261,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0002013261,
				"type": "OTHER"
			},
			{
				"name": "al-Ratba",
				"salience": 0.00019959892,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6h97",
					"wikipedia_url": "http://en.wikipedia.org/wiki/RIA_Novosti"
				},
				"name": "RIA Novosti",
				"salience": 0.00019959892,
				"type": "ORGANIZATION"
			},
			{
				"name": "al-Ma'louma",
				"salience": 0.00019959892,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01c9bx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kirkuk"
				},
				"name": "Kirkuk",
				"salience": 0.00019959892,
				"type": "LOCATION"
			},
			{
				"name": "al-Qa'em",
				"salience": 0.00019959892,
				"type": "PERSON"
			},
			{
				"name": "Deir Ezzur",
				"salience": 0.00019959892,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07rvp8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tal_Afar"
				},
				"name": "Tal Afar",
				"salience": 0.00019959892,
				"type": "LOCATION"
			},
			{
				"name": "Be'aaj",
				"salience": 0.00019959892,
				"type": "LOCATION"
			},
			{
				"name": "Mosul A",
				"salience": 0.00019959892,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04zm7_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Staff_(military)"
				},
				"name": "General Staff",
				"salience": 0.00019959892,
				"type": "PERSON"
			},
			{
				"name": "field commander",
				"salience": 0.00019792299,
				"type": "PERSON"
			},
			{
				"name": "24 Hours: Terrorists Sustain Heavy Losses",
				"salience": 0.0001954719,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Quote: d al-Jafari",
				"salience": 0.0001954719,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/018hq1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Southwestern_United_States"
				},
				"name": "Southwestern",
				"salience": 0.00019442805,
				"type": "ORGANIZATION"
			},
			{
				"name": "Nouralddeen al-Zinki",
				"salience": 0.00019228405,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham",
				"salience": 0.00019169801,
				"type": "ORGANIZATION"
			},
			{
				"name": "number",
				"salience": 0.00019136499,
				"type": "OTHER"
			},
			{
				"name": "neighborhood",
				"salience": 0.00019136499,
				"type": "LOCATION"
			},
			{
				"name": "neighborhood",
				"salience": 0.00019136499,
				"type": "LOCATION"
			},
			{
				"name": "offensive",
				"salience": 0.00019136499,
				"type": "OTHER"
			},
			{
				"name": "offensive",
				"salience": 0.00019136499,
				"type": "OTHER"
			},
			{
				"name": "damage",
				"salience": 0.00019065272,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.00019065272,
				"type": "LOCATION"
			},
			{
				"name": "road",
				"salience": 0.00019065272,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.0001828409,
				"type": "LOCATION"
			},
			{
				"name": "villages",
				"salience": 0.0001828409,
				"type": "LOCATION"
			},
			{
				"name": "town",
				"salience": 0.0001828409,
				"type": "LOCATION"
			},
			{
				"name": "positions",
				"salience": 0.0001828409,
				"type": "OTHER"
			},
			{
				"name": "town",
				"salience": 0.0001828409,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/052dhq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Takfiri"
				},
				"name": "Takfiri",
				"salience": 0.00018072507,
				"type": "OTHER"
			},
			{
				"name": "Souran",
				"salience": 0.0001797263,
				"type": "LOCATION"
			},
			{
				"name": "army troops",
				"salience": 0.000174371,
				"type": "PERSON"
			},
			{
				"name": "loss",
				"salience": 0.000174371,
				"type": "EVENT"
			},
			{
				"name": "losses",
				"salience": 0.000174371,
				"type": "OTHER"
			},
			{
				"name": "ground troops",
				"salience": 0.000174371,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.000174371,
				"type": "PERSON"
			},
			{
				"name": "Air Raids",
				"salience": 0.00017277605,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.00017141356,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mohandes",
				"salience": 0.00017001243,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z430m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/International"
				},
				"name": "Intl",
				"salience": 0.00016925274,
				"type": "OTHER"
			},
			{
				"name": "West Damascus Scenes",
				"salience": 0.00016925274,
				"type": "WORK_OF_ART"
			},
			{
				"name": "GHOUTA Combat",
				"salience": 0.00016925274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07y0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Defense"
				},
				"name": "Pentagon",
				"salience": 0.00016925274,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/042kg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jimmy_Carter"
				},
				"name": "Carter",
				"salience": 0.00016925274,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.00016925274,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.00016925274,
				"type": "LOCATION"
			},
			{
				"name": "Deir al-Khabiyeh",
				"salience": 0.00016788409,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/044yq7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_Army_in_Iraq"
				},
				"name": "Jeish al-Islam",
				"salience": 0.00016788409,
				"type": "ORGANIZATION"
			},
			{
				"name": "Western Ghouta",
				"salience": 0.00016788409,
				"type": "LOCATION"
			},
			{
				"name": "Khan al-Sheih-Deir al-Khabiyeh",
				"salience": 0.00016788409,
				"type": "PERSON"
			},
			{
				"name": "army soldiers",
				"salience": 0.00016507992,
				"type": "PERSON"
			},
			{
				"name": "casualties",
				"salience": 0.00016507992,
				"type": "OTHER"
			},
			{
				"name": "artillery units",
				"salience": 0.00016507992,
				"type": "OTHER"
			},
			{
				"name": "army soldiers",
				"salience": 0.00016507992,
				"type": "PERSON"
			},
			{
				"name": "Housing Project 1070",
				"salience": 0.00016171354,
				"type": "LOCATION"
			},
			{
				"name": "Housing Project 1070",
				"salience": 0.00016171354,
				"type": "LOCATION"
			},
			{
				"name": "plan",
				"salience": 0.00015891535,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c6z2z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rif_Dimashq_Governorate"
				},
				"name": "Damascus Countryside",
				"salience": 0.00015707531,
				"type": "LOCATION"
			},
			{
				"name": "military vehicles",
				"salience": 0.00015472781,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vehicles",
				"salience": 0.00015472781,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Aleppo Syrian Artillery",
				"salience": 0.00015063921,
				"type": "OTHER"
			},
			{
				"name": "military convoy",
				"salience": 0.00015037753,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00015027245,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.00014960096,
				"type": "OTHER"
			},
			{
				"name": "Ammunition",
				"salience": 0.00014960096,
				"type": "OTHER"
			},
			{
				"name": "Castello",
				"salience": 0.00014600474,
				"type": "LOCATION"
			},
			{
				"name": "Castello",
				"salience": 0.00014600474,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.00014293707,
				"type": "OTHER"
			},
			{
				"name": "bases",
				"salience": 0.00014293707,
				"type": "OTHER"
			},
			{
				"name": "air support",
				"salience": 0.00014293707,
				"type": "OTHER"
			},
			{
				"name": "neighborhood",
				"salience": 0.00014293707,
				"type": "LOCATION"
			},
			{
				"name": "al-Reihan",
				"salience": 0.00014002535,
				"type": "PERSON"
			},
			{
				"name": "al-Diwan",
				"salience": 0.00014002535,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06gdww",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fine-needle_aspiration"
				},
				"name": "FNA",
				"salience": 0.00014002535,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0bkkkq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Salamiyah"
				},
				"name": "al-Salamiyah",
				"salience": 0.0001360061,
				"type": "LOCATION"
			},
			{
				"name": "Sheikh Saeed",
				"salience": 0.00012976259,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0001290521,
				"type": "LOCATION"
			},
			{
				"name": "fire",
				"salience": 0.0001290521,
				"type": "OTHER"
			},
			{
				"name": "movements",
				"salience": 0.0001290521,
				"type": "OTHER"
			},
			{
				"name": "death toll",
				"salience": 0.0001290521,
				"type": "OTHER"
			},
			{
				"name": "heights",
				"salience": 0.0001290521,
				"type": "OTHER"
			},
			{
				"name": "energy field",
				"salience": 0.0001290521,
				"type": "LOCATION"
			},
			{
				"name": "Jabal Kanz",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Tadin",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Khan Touman",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Kafr Sandou",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Kandeh",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Marand",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Qarfous",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Haraytan",
				"salience": 0.00012642039,
				"type": "OTHER"
			},
			{
				"name": "al-Malaah",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Abu Omar Danial",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "al-Ameriyeh",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Mouteh",
				"salience": 0.00012642039,
				"type": "OTHER"
			},
			{
				"name": "Ahad",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "al-Mohebah",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "al-Bazo",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Bostan al-Pasha",
				"salience": 0.00012642039,
				"type": "PERSON"
			},
			{
				"name": "Ramouseh",
				"salience": 0.00012642039,
				"type": "LOCATION"
			},
			{
				"name": "Rashedeen",
				"salience": 0.00012642039,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02kmjv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hama"
				},
				"name": "Hama",
				"salience": 0.000117762844,
				"type": "LOCATION"
			},
			{
				"name": "buffer zone",
				"salience": 0.00011367618,
				"type": "OTHER"
			},
			{
				"name": "buffer zone",
				"salience": 0.00011367618,
				"type": "OTHER"
			},
			{
				"name": "al-Sha'er",
				"salience": 0.000112517104,
				"type": "LOCATION"
			},
			{
				"name": "mountain",
				"salience": 0.000111741596,
				"type": "LOCATION"
			},
			{
				"name": "fighter strikers",
				"salience": 0.000111741596,
				"type": "PERSON"
			},
			{
				"name": "highway",
				"salience": 0.000111741596,
				"type": "LOCATION"
			},
			{
				"name": "army men",
				"salience": 0.000111741596,
				"type": "PERSON"
			},
			{
				"name": "farms",
				"salience": 0.000111741596,
				"type": "LOCATION"
			},
			{
				"name": "oilfield",
				"salience": 0.000111741596,
				"type": "LOCATION"
			},
			{
				"name": "Aleppo Gov",
				"salience": 0.000106323205,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/022cpx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/.gov"
				},
				"name": "Gov",
				"salience": 0.000106323205,
				"type": "PERSON"
			},
			{
				"name": "Suleiman al-Halabi",
				"salience": 0.00009206133,
				"type": "PERSON"
			},
			{
				"name": "Farsnews Hundreds",
				"salience": 0.00009206133,
				"type": "PERSON"
			},
			{
				"name": "Taybat al-Imam",
				"salience": 0.00009206133,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0k9qf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Homs"
				},
				"name": "Homs",
				"salience": 0.00008796042,
				"type": "LOCATION"
			},
			{
				"name": "Eastern Homs",
				"salience": 0.00008796042,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01bsmp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latakia"
				},
				"name": "Lattakia",
				"salience": 0.00008796042,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0lq2fn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tafas"
				},
				"name": "Tafas",
				"salience": 0.000068763045,
				"type": "LOCATION"
			},
			{
				"name": "al-Bitar",
				"salience": 0.000068763045,
				"type": "PERSON"
			},
			{
				"name": "Qasr al-Saudi",
				"salience": 0.000068763045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07q54r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/As-Suwayda"
				},
				"name": "Sweida",
				"salience": 0.000068763045,
				"type": "LOCATION"
			},
			{
				"name": "North al-Shahib",
				"salience": 0.000068763045,
				"type": "PERSON"
			},
			{
				"name": "al-Lejat",
				"salience": 0.000068763045,
				"type": "PERSON"
			},
			{
				"name": "al-Badiyeh",
				"salience": 0.000068763045,
				"type": "LOCATION"
			},
			{
				"name": "al-Abasiyeh",
				"salience": 0.000068763045,
				"type": "LOCATION"
			},
			{
				"name": "al-Maher",
				"salience": 0.000068763045,
				"type": "PERSON"
			},
			{
				"name": "Deir Foul",
				"salience": 0.000068763045,
				"type": "OTHER"
			},
			{
				"name": "al-Za'afaraniyeh",
				"salience": 0.000068763045,
				"type": "PERSON"
			},
			{
				"name": "al-Rastasn",
				"salience": 0.000068763045,
				"type": "PERSON"
			},
			{
				"name": "Rahoum",
				"salience": 0.000068763045,
				"type": "OTHER"
			},
			{
				"name": "Mas'adeh",
				"salience": 0.000068763045,
				"type": "OTHER"
			},
			{
				"name": "Um al-Rish",
				"salience": 0.000068763045,
				"type": "PERSON"
			},
			{
				"name": "Salam al-Sharghiyeh",
				"salience": 0.000068763045,
				"type": "PERSON"
			},
			{
				"name": "Kabani",
				"salience": 0.000068763045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0kwd9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kurdistan"
				},
				"name": "Kurds",
				"salience": 0.000068763045,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "7",
		"main_img_url": "http://feeds.feedburner.com/~r/blogspot/zklEV/~4/vPqZz4Ct8sk",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T20:03:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 26.3,
			"score": -0.1
		},
		"shares": "7",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "(Before It's News)\nAbadi says they enter new phase for liberation of Mosul\n“Over 60 civilians killed in US-led air raids on Mosul”\nIraqi forces seize tank, artillery from terrorists\nUN says Daesh reportedly executed dozens near Mosul\nBattle for Mosul on Wednesday: Battle to Liberate Mosul in Advanced Stage\nMilitary operation by the joint Iraqi forces to liberate the city of Mosul continued on Wednesday and Iraqi Prime Minister Haider al-Abadi said the military campaign has now come to an advanced phase, noting that the performance of the Iraqi army in the war on ISIL has surprised its international partners.\nAbadi: Battle to Liberate Mosul Reaches Advanced Stage\nIraqi Prime Minister Haider al-Abadi announced that the Iraqi forces reached an advanced stage in the battle to liberate Mosul, and said the performance of the Iraqi army in the war on ISIL has surprised the international coalition.\n“We reached an advanced stage in the battle to liberate the city of Mosul, and our plan is not to evacuate the families from the cities during the liberation operations,” Abadi said during a news conference in Baghdad.\nAbadi also pointed out to the continuous cooperation between the security forces and displaced people’s committees, and confirmed that they were able to provide food and fuel for displaced families in the liberated areas.\nIraqi Forces Evacuate 1,000 Civilians from Front Lines\nIraqi Special Forces moved more than 1,000 people from villages near the front lines of the battle to retake the ISIL-held city of Mosul.\nThe Iraqi Army Special Forces Major General Haider Fadhil said the residents of Tob Zawa and other nearby villages have been taken to a camp in the nearby Khazer region for their safety, Alaraby reported.\nThe Special Forces began undertaking clean up operations on Wednesday in areas retaken from the militants to the East of the city.\nLarge Cache of ISIL Weapons Seized near Bashiqa\nIraqi Peshmerga forces said on Wednesday that they have found a tunnel, which is the largest ISIL weapons depot discovered so far in the Bashiqa front.\nThe tunnel, which has been found in Tiz Khrab Gawra village, contained a large number of weapons, Rudaw reported.\nIraq’s Peshmerga forces on Monday retook complete control of Bashiqa town, 13 km Northeast of Mosul.\nIraqi Army Kicks Off Zawaya Liberation Operation\nIraq’s joint military forces started their military operations to liberate Zawaya region, Commander of Iraq’s Counterterrorism Forces Major General Abdolvahab al-Saedi announced on Wednesday.\n“After seizing back Zawaya region, the security forces will continue their military operation to take control of Kokajli district inside the city of Mosul,” al-Saedi said.\nISIL Militants Disguise as Peshmerga, Shave Beard to Flee Mosul\nAn Iraqi security source revealed that many ISIL militants have begun to wear the Peshmerga forces’ uniforms inside the city of Mosul and have shaved their beards for fear of being targeted as Iraqi joint forces continued their advanced toward the ISIL-held city.\n“Many militants of the ISIL terror group have wear the military uniforms of the Peshmerga forces for camouflage and to divert the suspicion from them within the city of Mosul,” a security source said, Badr News reported.\nThe source added that “Most of the ISIL terrorists have also begun to shave their beards for fear of being targeted”.\nReport: ISIL’s Treasury Man, Economic Brain Disappears with Millions of Dollars in Mosul\nA top ISIL member in charge of the terrorist group’s financial resources along with a German woman who trained ISIL’s female suicide attackers fled with millions of dollars from the city of Mosul in Nineveh province, media reports said Wednesday.\n“ISIL’s financial chief known as Abi Motaz al-Qahtani has disappeared with a German woman who was in charge of training ISIL’s female suicide bombers,” the Arabic-language al-Sumeriya news channel Quote: d a local source as saying on Wednesday.\nThe source noted that the disappearance of al-Qahtani and the unnamed German woman has been a planned move as they have escaped with important dossiers and millions of dollars in cash.\nIraqi Analyst Discloses Plot to Transfer Al-Baghdadi to Libya\nA prominent Iraqi military analyst disclosed that Riyadh and Ankara had hatched plots to transfer ISIL leader Abu Bakr al-Baghdadi from Mosul to Libya but the massive presence of the popular forces and Russian fighter jets at the bordering areas of Iraq and Syria dissuaded them.\n“The two countries were working to take al-Baghdadi to Turkey either by moving him through Mosul and Kirkuk to the North or through al-Qa’em and al-Ratba corridor to Deir Ezzur in Syria and then to Turkey to eventually transfer him to Libya,” Safa al-A’asam told Iraq’s al-Ma’louma news agency on Wednesday.\nHe added that the ISIL concluded that transferring al-Baghdadi through Tal Afar region to Raqqa in Syria is also impossible given the massive presence of Hashd al-Sha’abi (popular forces) in the Southern front near Be’aaj district, Northwest of the Iraqi province of Nineveh as well as the numerous flights done by the Russian fighter jets over the Syrian bordering areas with Iraq.\nRussian Military: US Air Force Jet Struck School in Iraq’s Mosul\nA US warplane hit a girls’ school in the South of the Iraqi city of Mosul on October 21, the Russian General Staff’s chief said.\n“On October 21, a US Air Force plane carried out an airstrike against a girls’ school in the Southern part of the city of Mosul,” said Lt. Gen. Sergei Rudskoi, RIA Novosti reported.\nMore than 60 civilians died and 200 were wounded because of the US-led coalition’s airstrikes on residential areas in Mosul and its outskirts in the last three days, he said.\nISIL Burns Nine Own Militants Alive in Iraq’s Mosul\nThe militants of the ISIL terrorist group executed nine of their supporters for duck-out in the Iraqi city of Mosul, media reported on Tuesday.\n“ISIL militants executed nine of their militants, who escaped from the confrontation with the security forces in Mosul, throwing them in the trenches full of black oil for burning with hands and feet tied,” a source in Iraq’s security forces said, Al Sumeriya reported.\nOn October 17, Iraqi Prime Minister Haider Abadi announced the start of a military operation to retake Mosul from the ISIL terror group.\nArab Media: General Soleimani in Mosul Operations Room\nCommander of the Quds Force of the Islamic Revolution Guards Corps (IRGC) Major General Qassem Soleimani has arrived in Hashd al-Sha’abi (popular forces) operations room in Mosul to play his advisory role in anti-ISIL campaign in Iraq, Arab media reported on Wednesday.\n“Hashd al-Sha’abi will soon start its operations in Western Mosul to cut the ISIL’s supply routes to Syria and defuse the US plots to postpone the popular forces’ participation in the Mosul operations, and General Soleimani has also joined them as a military advisor,” the Arabic-language al-Akhbar said quoting renowned Iraqi figures.\nNo other source has yet confirmed the report.\nWashington is pressuring Iraqi Prime Minister Haider al-Abadi not to allow Hashd al-Sha’abi forces to participate in the Mosul liberation operations.\nSpokesman of the Iraqi popular forces Ahmad al-Assadi had confirmed in August that General Soleimani would play a major role in operations to liberate Mosul, stressing that his country is in dire need of Iranian military advisors.\n“The presence of Brigadier-General Soleimani in the operations to free Mosul and Nineveh province is necessary and General Soleiman is the greatest advisor that has helped the Iraqi government in the war against the ISIL,” al-Assadi told FNA.\n“Hajj Qassem Soleimani is one of the most important military advisors of the Islamic Republic of Iran who is in Iraq at the invitation, demand and agreement of the Iraqi government,” he added.\nStressing that the Iranian advisors are in Iraq at the demand of the Iraqi government and have played a big role in most operations conducted by the popular forces, al-Assadi said, “They provided the Iraqis with strong views and important consultations with respect to their experience and capabilities.”\nIn relevant remarks in June, Iraqi Foreign Minister Ebrahim al-Jafari underlined that General Soleimani is in Iraq to help the country in campaign against terrorism after receiving Baghdad’s rigid request.\n“General Soleimani is in Iraq at the invitation of the Iraqi government to provide military counseling to the Iraqi forces,” the Arabic-language Sumeria news channel Quote: d al-Jafari as saying.\nAlso in June, Hashd al-Sha’abi Commander Abu Mehdi al-Mohandes underlined that General Soleimani is helping the Iraqi forces in their campaign against terrorism upon a request by the Iraqi government.\n“The Iranian advisors, headed by dear brother Qassem Soleimani, have been beside us since the start of war and his presence has happened upon the demand of the Iraqi government and agreement of the Armed Forces’ top commander,” Mohandes said in an interview with Sumeria news channel.\nHe, meantime, said that the Iraqi nation is able to kick the terrorists out of Iraq with the possibilities in their hands now, adding that Hashd al-Sha’abi doesn’t have any political plan and merely supports the political process.\nAircraft Carrier “Admiral Kuznetsov” Eenters Strait Of Gibraltar\nNATO fears Russian battle group to be used against Aleppo civilians\n‘Intl community still financing & protecting terrorists’ – Mother Agnes on Syria\n“CIA supplying weapons to Daesh, al-Qaeda terrorists”\nUK, US training militants to fight Syrian government: Analyst\n“Western alliance not after uprooting terrorism”\nNATO calls for lasting ceasefire in Syria\nNATO Concerned over Al-Nusra and Ahrar al-Sham Casualties\nUS-led coalition preparing Raqqa assault, says Carter\n‘US coalition with Syria & Russia needed to defeat ISIS’ – former Pentagon official\nSAA 1st ARMORED DIVISION DESTROYED 4 BATTLE TANKS FROM JABHAT AL NUSRA IN GHOUTA\nCombat footage of the SAA’s operations in Western Ghouta\nSAA Soldier destroys convoy of militants in West Damascus\nScenes from the Turkish shelling of the liberated villages\nSyria in Last 24 Hours: Terrorists Sustain Heavy Losses in Army Offensive in Dara’a Province\nThe Syrian army attacked the terrorists in Dara’a province, and inflicted heavy losses on them.\nThe Syrian army killed and wounded scores of terrorists in the Northeastern territories of Dara’a province.\nThe Syrian army also inflicted heavy losses on the terrorist groups in other key regions across Syria.\nDara’a\nSyrian Army’s artillery units shelled heavily a long military column of ISIL’s vehicles and forces on a road to Northeastern Dara’a, inflicting major loss and casualties on the terrorists.\nSyrian army artillery units opened heavy fire at a group of ISIL terrorists in al-Badiyeh region as they were heading to al-Lejat region.\nThe ISIL’s military convoy was on a road connecting North al-Shahib region to Sweida-Damascus highway when it came under the fire of artillery units.\nThe terrorists suffered a heavy death toll and their vehicles sustained major damage in the attack.\nPositions of Fatah al-Sham Front (formerly al-Nusra Front) in Qasr al-Saudi region North of al-Bitar farms towards the town of Tafas also came under attack by the Syrian soldiers.\nIn the meantime, army troops targeted a Fatah al-Sham in al-Abasiyeh neighborhood, leaving several militants dead.\nHoms\nThe Syrian Army and popular forces continued to beat ISIL terrorists back from two main oil-rich regions in Eastern Homs, establishing a 10-kilometer-deep buffer zone around one of them.\nThe Syrian ground troops that received strong air support from the Syrian and Russian fighter strikers inflicted major losses on the ISIL terrorists, driving the Takfiri terrorists out of more strategic heights in al-Sha’er oil-rich region.\nIn the meantime, the army soldiers pushed ISIL back from a terrain near al-Maher oilfield and established a deep buffer zone around the energy field.\nPositions of Fatah al-Sham Front in the villages of Deir Foul and al-Za’afaraniyeh and al-Rastasn region in Northern Homs also came under heavy attacks by the Syrian army men.\nSyrian military forces also targeted terrorists’ movements in the villages of Rahoum, Mas’adeh, Um al-Rish and Salam al-Sharghiyeh, destroying their bases and military vehicles.\nLattakia\nA notorious field commander of Fatah al-Sham Front was killed in heavy fighting with the Syrian Army troops in the mountainous regions in Northern Lattakia.\nAbu Yusuf al-Askari and a number of his forces were killed in Syrian army soldiers’ attack on Fatah al-Sham’s positions along a road to the town of Kabani in the Kurds mountain.\nMeanwhile, Syrian warplanes targeted bases, artillery and mortar units of the terrorist groups near the towns and villages of Jabal Kanz, Tadin, Kafr Sandou, Kandeh, Marand and Qarfous in Northern Lattakia, inflicting a heavy death toll on the militants.\nAleppo\nSyrian Army troops and Air Force struck a large gathering of the terrorist groups in the Northern outskirts of Aleppo city, killing or wounding scores of them and foiling their plan to hit government strongholds, a military source disclosed Tuesday.\n“Following sensitive intel received from army agent in the region, the Syrian government forces and fighter jets carried out surprise attacks on terrorists’ concentration centers in Haraytan and al-Malaah regions near Castello road to preempt them and defuse their plan for raiding army positions in the Northern outskirts of Aleppo city,” an army officer told FNA.\n“Dozens of militants were killed or wounded in the attack, and now the Castello road is safe and under the army’s full control,” he added.\nElsewhere, a notorious commander of the Turkey-backed terrorist group of Nouralddeen al-Zinki was killed in clashes with the Syrian Army and popular forces in Salahuddin district.\nAbu Omar Danial was killed in a heavy fighting with Syrian government forces in Salahuddin district Southwest of Aleppo city.\nIn the meantime, Syrian government forces captured several building blocks in Salahuddin after hours of non-stop clashes with al-Zinki terrorists.\nThe Syrian army and popular forces also engaged in fierce clashes with Jeish al-Fatah in the districts of Sheikh Saeed, and al-Ameriyeh, beating them back from more positions.\nSyrian army’s artillery and missile units, for their part, continued to shell terrorists’ centers in Housing Project 1070, and the Syrian soldiers are now engaged in an intense battle with terrorists to take back Mouteh, Ahad and al-Mohebah hills near al-Bazo height.\nSyrian and Russian fighter jets, for their part, have been bombing terrorists’ gatherings and bases in the town of Khan Touman, Rashedeen region, Ramouseh road, near Housing Project 1070, and the districts of Bostan al-Pasha, Suleiman al-Halabi and Sheikh Saeed.\nDamascus\nTerrorist groups lost at least 23 rebels as their attack on government positions in Western Ghouta was repelled by the Syrian Army troops and popular forces.\nSyrian government forces fended off terrorist groups’ offensive on their strongholds along Khan al-Sheih-Deir al-Khabiyeh road, inflicting 23 casualties on the militants and destroying at least three tanks of the Takfiri groups.\nThe clashes occurred in al-Diwan neighborhood in the Southwestern countryside of Deir al-Khabiyeh.\nIn the meantime, the Syrian fighter jets pounded Jeish al-Islam’s centers near the town of al-Reihan in Eastern Damascus.\nHama\nTerrorist groups lost at least 23 rebels as their attack on government positions in Western Ghouta was repelled by the Syrian Army troops and popular forces.\nSyrian government forces fended off terrorist groups’ offensive on their strongholds along Khan al-Sheih-Deir al-Khabiyeh road, inflicting 23 casualties on the militants and destroying at least three tanks of the Takfiri groups.\nThe clashes occurred in al-Diwan neighborhood in the Southwestern countryside of Deir al-Khabiyeh.\nIn the meantime, the Syrian fighter jets pounded Jeish al-Islam’s centers near the town of al-Reihan in Eastern Damascus.\nFatah al-Sham also lost a large number of military vehicles and tanks in the attacks.\nThe Russian air force also targeted terrorists’ centers on the Eastern side of al-Salamiyah, inflicting major loss and casualties on the militants.\nMilitary sources said that heavy bombardments of the Russian and Syrian fighter jets pave the ground for the government forces to launch fresh operation to take back Souran and Taybat al-Imam.\nFarsnews\nHundreds of Syrian Army Special Forces Arrive in Aleppo\nGov’t Forces Continue to Advance against Terrorists in Housing Project 1070 in Aleppo\nSyrian Artillery, Air Attacks Preempt Terrorists’ Great Epic Operation in Aleppo\nLong Military Convoy of Terrorists Targeted by Syrian Army in Southwestern Damascus\nSyrian Gov’t Forces Take Back Three More Regions From Terrorists in Hama\nSyrian Army Seizes Militants’ Weapons, Ammunition in Damascus Countryside\nSenior Terrorist Commander Killed in Syrian Air Raids in Hama",
		"thread_title": "ISIS update 10/26/2016..Aircraft Carrier \"Admiral Kuznetsov\" enters Strait Of Gibraltar | Politics",
		"title": "ISIS update 10/26/2016..Aircraft Carrier \"Admiral Kuznetsov\" enters Strait Of Gibraltar | Politics",
		"type": "bs",
		"uuid": "116c6bca3a5648b7ea0cd7600e31eec417532cef"
	},
	"-KhIk8wfhzbLBUeWzwVn": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:07:51.337+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0y3c1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Uniondale,_New_York"
				},
				"name": "UNIONDALE",
				"salience": 0.110022545,
				"type": "LOCATION"
			},
			{
				"name": "decision",
				"salience": 0.06314873,
				"type": "OTHER"
			},
			{
				"name": "Christian Browne",
				"salience": 0.06182983,
				"type": "PERSON"
			},
			{
				"name": "parking lot",
				"salience": 0.057156894,
				"type": "LOCATION"
			},
			{
				"name": "proceeding",
				"salience": 0.036823045,
				"type": "OTHER"
			},
			{
				"name": "restaurant",
				"salience": 0.034265164,
				"type": "LOCATION"
			},
			{
				"name": "limit",
				"salience": 0.034265164,
				"type": "OTHER"
			},
			{
				"name": "Firm",
				"salience": 0.029724402,
				"type": "ORGANIZATION"
			},
			{
				"name": "Town",
				"salience": 0.029724402,
				"type": "LOCATION"
			},
			{
				"name": "limit",
				"salience": 0.028455196,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n8xj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Supreme_Court"
				},
				"name": "Supreme Court of the State of New York",
				"salience": 0.02742116,
				"type": "ORGANIZATION"
			},
			{
				"name": "Mim's Restaurant",
				"salience": 0.025753913,
				"type": "ORGANIZATION"
			},
			{
				"name": "News",
				"salience": 0.023298414,
				"type": "OTHER"
			},
			{
				"name": "eatery",
				"salience": 0.023298414,
				"type": "ORGANIZATION"
			},
			{
				"name": "request",
				"salience": 0.023298414,
				"type": "OTHER"
			},
			{
				"name": "approval",
				"salience": 0.020843359,
				"type": "OTHER"
			},
			{
				"name": "restaurant",
				"salience": 0.019974926,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059rby",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York"
				},
				"name": "NEW YORK",
				"salience": 0.01988062,
				"type": "LOCATION"
			},
			{
				"name": "Sahn Ward Coschignano",
				"salience": 0.019673992,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01m15",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Appellate_court"
				},
				"name": "Appellate Court",
				"salience": 0.01773054,
				"type": "ORGANIZATION"
			},
			{
				"name": "property",
				"salience": 0.01742101,
				"type": "OTHER"
			},
			{
				"name": "zoning boards",
				"salience": 0.013884354,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01prdc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Limited_liability_company"
				},
				"name": "PLLC",
				"salience": 0.011627523,
				"type": "ORGANIZATION"
			},
			{
				"name": "Board of Zoning and Appeals",
				"salience": 0.009677282,
				"type": "ORGANIZATION"
			},
			{
				"name": "Businesses",
				"salience": 0.009620428,
				"type": "ORGANIZATION"
			},
			{
				"name": "limit",
				"salience": 0.007277061,
				"type": "OTHER"
			},
			{
				"name": "Residence District",
				"salience": 0.0068588075,
				"type": "LOCATION"
			},
			{
				"name": "Zoning boards",
				"salience": 0.0059922663,
				"type": "ORGANIZATION"
			},
			{
				"name": "zoning district",
				"salience": 0.0056924773,
				"type": "LOCATION"
			},
			{
				"name": "part",
				"salience": 0.0056924773,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.005191613,
				"type": "ORGANIZATION"
			},
			{
				"name": "parking",
				"salience": 0.005147812,
				"type": "OTHER"
			},
			{
				"name": "restaurant",
				"salience": 0.0051058186,
				"type": "LOCATION"
			},
			{
				"name": "limits",
				"salience": 0.0051058186,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0049304096,
				"type": "WORK_OF_ART"
			},
			{
				"name": "approval",
				"salience": 0.0047862376,
				"type": "OTHER"
			},
			{
				"name": "approvals",
				"salience": 0.0047862376,
				"type": "OTHER"
			},
			{
				"name": "Court",
				"salience": 0.004403662,
				"type": "ORGANIZATION"
			},
			{
				"name": "decision",
				"salience": 0.004257286,
				"type": "OTHER"
			},
			{
				"name": "firm",
				"salience": 0.004229746,
				"type": "ORGANIZATION"
			},
			{
				"name": "clients",
				"salience": 0.004226795,
				"type": "PERSON"
			},
			{
				"name": "restrictions",
				"salience": 0.004169402,
				"type": "OTHER"
			},
			{
				"name": "parking lot",
				"salience": 0.0039932528,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0039932528,
				"type": "OTHER"
			},
			{
				"name": "petition",
				"salience": 0.0039754366,
				"type": "OTHER"
			},
			{
				"name": "zoning approval",
				"salience": 0.0039083394,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.0037790295,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.0036109323,
				"type": "OTHER"
			},
			{
				"name": "types",
				"salience": 0.0034583437,
				"type": "OTHER"
			},
			{
				"name": "uses",
				"salience": 0.0034583437,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0034583437,
				"type": "OTHER"
			},
			{
				"name": "ruling",
				"salience": 0.0034583437,
				"type": "OTHER"
			},
			{
				"name": "zoning",
				"salience": 0.003290673,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0032606116,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.0032606116,
				"type": "ORGANIZATION"
			},
			{
				"name": "property rights",
				"salience": 0.0032606116,
				"type": "OTHER"
			},
			{
				"name": "real estate law",
				"salience": 0.00292039,
				"type": "OTHER"
			},
			{
				"name": "appeals",
				"salience": 0.00292039,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00292039,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.00292039,
				"type": "OTHER"
			},
			{
				"name": "Nicholas J. Cappadora",
				"salience": 0.0028658996,
				"type": "PERSON"
			},
			{
				"name": "permission",
				"salience": 0.0028237293,
				"type": "OTHER"
			},
			{
				"name": "operations",
				"salience": 0.0028237293,
				"type": "OTHER"
			},
			{
				"name": "burdens",
				"salience": 0.0028237293,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0026980788,
				"type": "OTHER"
			},
			{
				"name": "www.swc-law.com",
				"salience": 0.0026098865,
				"type": "OTHER"
			},
			{
				"name": "land use planning",
				"salience": 0.002436232,
				"type": "OTHER"
			},
			{
				"name": "counsel",
				"salience": 0.002436232,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cyn3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nassau_County,_New_York"
				},
				"name": "Nassau County",
				"salience": 0.0023671058,
				"type": "LOCATION"
			},
			{
				"name": "Practice areas",
				"salience": 0.002191483,
				"type": "LOCATION"
			},
			{
				"name": "Town Code",
				"salience": 0.0021292954,
				"type": "ORGANIZATION"
			},
			{
				"name": "employment law",
				"salience": 0.0021273314,
				"type": "OTHER"
			},
			{
				"name": "telecommunications",
				"salience": 0.0021097115,
				"type": "OTHER"
			},
			{
				"name": "litigation",
				"salience": 0.0021097115,
				"type": "OTHER"
			},
			{
				"name": "transactions",
				"salience": 0.0021097115,
				"type": "OTHER"
			},
			{
				"name": "advice",
				"salience": 0.0021097115,
				"type": "OTHER"
			},
			{
				"name": "representation",
				"salience": 0.0021097115,
				"type": "OTHER"
			},
			{
				"name": "Second Judicial Department",
				"salience": 0.0020498422,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01gm4t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Supreme_Court,_Appellate_Division"
				},
				"name": "Appellate Division",
				"salience": 0.0020498422,
				"type": "ORGANIZATION"
			},
			{
				"name": "clients",
				"salience": 0.0019890254,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0019653423,
				"type": "OTHER"
			},
			{
				"name": "PLLC Sahn Ward Coschignano",
				"salience": 0.0017979267,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.0017745559,
				"type": "OTHER"
			},
			{
				"name": "estate planning",
				"salience": 0.0017745559,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "resourcefulness",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "labor",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "tax certiorari",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "condemnation",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "skill",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "array",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0015366621,
				"type": "OTHER"
			},
			{
				"name": "Firm",
				"salience": 0.0014682494,
				"type": "ORGANIZATION"
			},
			{
				"name": "Town",
				"salience": 0.0014682494,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0013256922,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.0013256922,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.0011479441,
				"type": "OTHER"
			},
			{
				"name": "balance",
				"salience": 0.0011479441,
				"type": "OTHER"
			},
			{
				"name": "property owner",
				"salience": 0.0011479441,
				"type": "OTHER"
			},
			{
				"name": "neighborhood",
				"salience": 0.0011479441,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0011479441,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0011479441,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.00089077785,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:55:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.6,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.236",
		"text": "(Before It's News)\nUNIONDALE, NEW YORK — Sahn Ward Coschignano, PLLC has announced that Christian Browne, a Partner with the Firm, successfully appealed a New York State Supreme Court decision that dismissed a restaurant’s request to annul a five-year durational limit on the eatery’s parking lot that extends into the Town’s Residence District.\nOn April 22, 2015, the Board of Zoning and Appeals (BZA) imposed a five-year durational limit on an approval that allows Mim’s Restaurant to provide parking in a part of its property that is within a residential zoning district.\nThe restaurant then commenced an Article 78 proceeding, seeking to annul the durational limit. On November 18, 2015, the New York State Supreme Court, Nassau County, denied the petition and dismissed the proceeding.\nOn October 19, 2016, the Supreme Court of the State of New York, Appellate Division, Second Judicial Department, overturned the lower court’s decision. In its ruling, the Appellate Court stated that the BZA does not have the authority to impose the durational limit on the restaurant’s parking lot because the Town Code does not confer any such power to limit the life of the approval.\nZoning boards routinely impose durational limits on various types of approvals given for commercial uses. Businesses often object to these time restrictions as being unfair and unnecessary burdens on their property rights because, by limiting the life of a zoning approval, zoning boards force businesses to regularly seek renewed permission for their ongoing operations.\n“We are pleased with the Court’s decision,” Mr. Browne said. “We believe it strikes the proper balance between the rights of a commercial property owner and the need for the Town to protect the interest of the surrounding neighborhood.”\nNicholas J. Cappadora, an Associate with the Firm, assisted Mr. Browne on the case.\nFor more information on Sahn Ward Coschignano, call (516) 228-1300 or visit www.swc-law.com .\n###\nAbout Sahn Ward Coschignano, PLLC\nSahn Ward Coschignano, PLLC is committed to providing its clients with the highest quality representation, counsel and advice. Practice areas include zoning and land use planning; real estate law and transactions; litigation and appeals; municipal law and legislative practice; cellular and telecommunications law; environmental, corporate, labor and employment law; tax certiorari and condemnation; matrimonial practice; and estate planning. The firm strives to assist its clients in a wide array of issues, serving them with skill and experience, resourcefulness and responsibility. For more information, call (516) 228-1300 or visit www.swc-law.com .",
		"thread_title": "Appellate Court Overturns Five-Year Durational Limit for Historic Mim’s Restaurant’s Parking Lot | The Law",
		"title": "Appellate Court Overturns Five-Year Durational Limit for Historic Mim’s Restaurant’s Parking Lot | The Law",
		"type": "bs",
		"uuid": "e5ce148e1141dba574dcbe395b50e8da8c905846"
	},
	"-KhIk9YDx50Sz8z7pCVI": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:07:58.272+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.072221845,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03ksy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Harvard_University"
				},
				"name": "Harvard University",
				"salience": 0.07117398,
				"type": "ORGANIZATION"
			},
			{
				"name": "research",
				"salience": 0.051853918,
				"type": "OTHER"
			},
			{
				"name": "sugar",
				"salience": 0.045770235,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fat",
				"salience": 0.041635096,
				"type": "OTHER"
			},
			{
				"name": "Rodger Malcolm Mitchell Monetary Sovereignty",
				"salience": 0.030723702,
				"type": "PERSON"
			},
			{
				"name": "research",
				"salience": 0.020213697,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.014982956,
				"type": "OTHER"
			},
			{
				"name": "sun",
				"salience": 0.014184634,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vfz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_California,_San_Francisco"
				},
				"name": "University of California",
				"salience": 0.01414025,
				"type": "ORGANIZATION"
			},
			{
				"name": "sugar",
				"salience": 0.013061607,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "The Sugar Association",
				"salience": 0.011783909,
				"type": "ORGANIZATION"
			},
			{
				"name": "Search",
				"salience": 0.011298287,
				"type": "OTHER"
			},
			{
				"name": "post",
				"salience": 0.011298287,
				"type": "WORK_OF_ART"
			},
			{
				"name": "source",
				"salience": 0.011214376,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.011214376,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.011214376,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.011214376,
				"type": "OTHER"
			},
			{
				"name": "heart disease",
				"salience": 0.01057026,
				"type": "OTHER"
			},
			{
				"name": "repetition",
				"salience": 0.010039023,
				"type": "OTHER"
			},
			{
				"name": "skin cancer",
				"salience": 0.009112269,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.008223862,
				"type": "PERSON"
			},
			{
				"name": "repetition",
				"salience": 0.007994241,
				"type": "OTHER"
			},
			{
				"name": "repetition",
				"salience": 0.007994241,
				"type": "OTHER"
			},
			{
				"name": "cholesterol",
				"salience": 0.007994241,
				"type": "OTHER"
			},
			{
				"name": "Cristin Kearns",
				"salience": 0.00786177,
				"type": "PERSON"
			},
			{
				"name": "belief",
				"salience": 0.0073863487,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.0073863487,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.0069615003,
				"type": "OTHER"
			},
			{
				"name": "@rodgermitchell",
				"salience": 0.0069615003,
				"type": "PERSON"
			},
			{
				"name": "research",
				"salience": 0.0060689924,
				"type": "OTHER"
			},
			{
				"name": "combination",
				"salience": 0.005776981,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.005776981,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0057340064,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0056965933,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.005632482,
				"type": "EVENT"
			},
			{
				"name": "professors",
				"salience": 0.005512764,
				"type": "PERSON"
			},
			{
				"name": "sugar",
				"salience": 0.005386353,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.00522979,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.0047708564,
				"type": "PERSON"
			},
			{
				"name": "Researchers",
				"salience": 0.004710795,
				"type": "PERSON"
			},
			{
				"name": "heart disease",
				"salience": 0.0043570786,
				"type": "OTHER"
			},
			{
				"name": "heart disease",
				"salience": 0.0043570786,
				"type": "OTHER"
			},
			{
				"name": "Sugar industry",
				"salience": 0.0042122095,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.004097931,
				"type": "PERSON"
			},
			{
				"name": "Researchers",
				"salience": 0.004071408,
				"type": "PERSON"
			},
			{
				"name": "researcher",
				"salience": 0.004046331,
				"type": "PERSON"
			},
			{
				"name": "sugar industry",
				"salience": 0.00400403,
				"type": "OTHER"
			},
			{
				"name": "intelligence",
				"salience": 0.0038915758,
				"type": "OTHER"
			},
			{
				"name": "sugars",
				"salience": 0.0037776858,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sugar",
				"salience": 0.003753233,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sugar",
				"salience": 0.003636758,
				"type": "OTHER"
			},
			{
				"name": "sugar",
				"salience": 0.003636758,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "records",
				"salience": 0.0035695252,
				"type": "OTHER"
			},
			{
				"name": "diets",
				"salience": 0.0035428496,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0035092453,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0034754947,
				"type": "OTHER"
			},
			{
				"name": "heart study",
				"salience": 0.0034720886,
				"type": "OTHER"
			},
			{
				"name": "cholesterol",
				"salience": 0.0032937618,
				"type": "OTHER"
			},
			{
				"name": "Corporations",
				"salience": 0.003227673,
				"type": "ORGANIZATION"
			},
			{
				"name": "Journals",
				"salience": 0.0031587107,
				"type": "WORK_OF_ART"
			},
			{
				"name": "source",
				"salience": 0.0031211977,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.0030587602,
				"type": "OTHER"
			},
			{
				"name": "heart disease",
				"salience": 0.0030555325,
				"type": "OTHER"
			},
			{
				"name": "disease",
				"salience": 0.0030555325,
				"type": "OTHER"
			},
			{
				"name": "association",
				"salience": 0.0030429778,
				"type": "OTHER"
			},
			{
				"name": "sugar industry",
				"salience": 0.0029539007,
				"type": "OTHER"
			},
			{
				"name": "scientist",
				"salience": 0.0029455374,
				"type": "PERSON"
			},
			{
				"name": "heart disease",
				"salience": 0.0029415214,
				"type": "OTHER"
			},
			{
				"name": "John Sievenpiper",
				"salience": 0.002758226,
				"type": "PERSON"
			},
			{
				"name": "authors",
				"salience": 0.0027476053,
				"type": "PERSON"
			},
			{
				"name": "employees",
				"salience": 0.0027476053,
				"type": "PERSON"
			},
			{
				"name": "communication",
				"salience": 0.0027476053,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0027476053,
				"type": "OTHER"
			},
			{
				"name": "employees",
				"salience": 0.0027476053,
				"type": "PERSON"
			},
			{
				"name": "studies",
				"salience": 0.0027289726,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0026470015,
				"type": "OTHER"
			},
			{
				"name": "professors",
				"salience": 0.002627137,
				"type": "PERSON"
			},
			{
				"name": "fat",
				"salience": 0.0026026438,
				"type": "OTHER"
			},
			{
				"name": "sugar industry",
				"salience": 0.0026022117,
				"type": "OTHER"
			},
			{
				"name": "food research",
				"salience": 0.002596588,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0025887832,
				"type": "WORK_OF_ART"
			},
			{
				"name": "role",
				"salience": 0.0025239706,
				"type": "OTHER"
			},
			{
				"name": "fat",
				"salience": 0.002505519,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.0024972383,
				"type": "OTHER"
			},
			{
				"name": "heart disease",
				"salience": 0.002494603,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00247511,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0024640576,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0024297794,
				"type": "OTHER"
			},
			{
				"name": "forms",
				"salience": 0.0023792947,
				"type": "OTHER"
			},
			{
				"name": "causes",
				"salience": 0.0023792947,
				"type": "OTHER"
			},
			{
				"name": "Payments",
				"salience": 0.0023792947,
				"type": "OTHER"
			},
			{
				"name": "library storage vaults",
				"salience": 0.0023792947,
				"type": "OTHER"
			},
			{
				"name": "nutrition experts",
				"salience": 0.0023792947,
				"type": "PERSON"
			},
			{
				"name": "narrative",
				"salience": 0.0023792947,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.0023792947,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0023792947,
				"type": "PERSON"
			},
			{
				"name": "virtue",
				"salience": 0.0023792947,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0023792947,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0023721007,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.002339101,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cholesterol",
				"salience": 0.0023096327,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0023096327,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0023096327,
				"type": "WORK_OF_ART"
			},
			{
				"name": "profit motive",
				"salience": 0.0023096327,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0023096327,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sugar",
				"salience": 0.002304258,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0022279527,
				"type": "OTHER"
			},
			{
				"name": "cholesterol",
				"salience": 0.002223435,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.002223435,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.002195423,
				"type": "WORK_OF_ART"
			},
			{
				"name": "risk",
				"salience": 0.002133732,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0020526608,
				"type": "OTHER"
			},
			{
				"name": "insight",
				"salience": 0.0020434933,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0020434933,
				"type": "OTHER"
			},
			{
				"name": "dentist",
				"salience": 0.002026799,
				"type": "PERSON"
			},
			{
				"name": "heart disease",
				"salience": 0.0020109264,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0019774875,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0019365626,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.001926567,
				"type": "OTHER"
			},
			{
				"name": "cardiologist",
				"salience": 0.001926567,
				"type": "PERSON"
			},
			{
				"name": "drug research",
				"salience": 0.0018912437,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0018855578,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0018855578,
				"type": "OTHER"
			},
			{
				"name": "disease",
				"salience": 0.0018636142,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.001854658,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.001854658,
				"type": "OTHER"
			},
			{
				"name": "review",
				"salience": 0.001854658,
				"type": "WORK_OF_ART"
			},
			{
				"name": "industry money",
				"salience": 0.0018490494,
				"type": "OTHER"
			},
			{
				"name": "interest",
				"salience": 0.0017959494,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0017606043,
				"type": "OTHER"
			},
			{
				"name": "funding disclosures",
				"salience": 0.0017294469,
				"type": "OTHER"
			},
			{
				"name": "data",
				"salience": 0.0016895499,
				"type": "OTHER"
			},
			{
				"name": "guidelines",
				"salience": 0.0016895499,
				"type": "OTHER"
			},
			{
				"name": "deception",
				"salience": 0.0016682607,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.0016682607,
				"type": "EVENT"
			},
			{
				"name": "agenda",
				"salience": 0.0016682607,
				"type": "OTHER"
			},
			{
				"name": "craze",
				"salience": 0.0016682607,
				"type": "OTHER"
			},
			{
				"name": "website",
				"salience": 0.0016682607,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0016682607,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0016059882,
				"type": "OTHER"
			},
			{
				"name": "doubt",
				"salience": 0.0016059882,
				"type": "OTHER"
			},
			{
				"name": "trustworthiness",
				"salience": 0.0016059882,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0016059882,
				"type": "OTHER"
			},
			{
				"name": "innocence",
				"salience": 0.0016059882,
				"type": "OTHER"
			},
			{
				"name": "influences",
				"salience": 0.0015857514,
				"type": "OTHER"
			},
			{
				"name": "transparency standards",
				"salience": 0.0015727947,
				"type": "OTHER"
			},
			{
				"name": "disclosure",
				"salience": 0.0015727947,
				"type": "OTHER"
			},
			{
				"name": "Translation",
				"salience": 0.0015727947,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0015360253,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0015140843,
				"type": "OTHER"
			},
			{
				"name": "LAURA BEIL",
				"salience": 0.0014645293,
				"type": "PERSON"
			},
			{
				"name": "ScienceNews Magazine",
				"salience": 0.0014645293,
				"type": "ORGANIZATION"
			},
			{
				"name": "source",
				"salience": 0.0014402458,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.001440203,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0014128059,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.0014128059,
				"type": "OTHER"
			},
			{
				"name": "researchers",
				"salience": 0.0014128059,
				"type": "PERSON"
			},
			{
				"name": "repetition",
				"salience": 0.0014085578,
				"type": "OTHER"
			},
			{
				"name": "research question",
				"salience": 0.0014085578,
				"type": "OTHER"
			},
			{
				"name": "industry",
				"salience": 0.0013980247,
				"type": "OTHER"
			},
			{
				"name": "speaking fees",
				"salience": 0.0013619015,
				"type": "OTHER"
			},
			{
				"name": "outcome",
				"salience": 0.0013619015,
				"type": "OTHER"
			},
			{
				"name": "conflicts",
				"salience": 0.0013619015,
				"type": "OTHER"
			},
			{
				"name": "blame",
				"salience": 0.0013619015,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.0013619015,
				"type": "OTHER"
			},
			{
				"name": "deal",
				"salience": 0.0013619015,
				"type": "EVENT"
			},
			{
				"name": "norm",
				"salience": 0.0013619015,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0013447392,
				"type": "WORK_OF_ART"
			},
			{
				"name": "funding",
				"salience": 0.0013237771,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013178638,
				"type": "ORGANIZATION"
			},
			{
				"name": "nutrition",
				"salience": 0.0013012562,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.0012848579,
				"type": "OTHER"
			},
			{
				"name": "authors",
				"salience": 0.0012839603,
				"type": "PERSON"
			},
			{
				"name": "profit motive",
				"salience": 0.0012726628,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0012639452,
				"type": "OTHER"
			},
			{
				"name": "food industry",
				"salience": 0.0012631456,
				"type": "OTHER"
			},
			{
				"name": "interpretations",
				"salience": 0.0012121709,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/099hlj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andy_Bellatti"
				},
				"name": "Andy Bellatti",
				"salience": 0.0012022736,
				"type": "PERSON"
			},
			{
				"name": "industry money wholesale",
				"salience": 0.0011996874,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0011748886,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0011748886,
				"type": "ORGANIZATION"
			},
			{
				"name": "cuts",
				"salience": 0.0011748886,
				"type": "OTHER"
			},
			{
				"name": "standard",
				"salience": 0.0011748886,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0011748886,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01lr_q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Research_and_development"
				},
				"name": "Research & Development",
				"salience": 0.0011640544,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wjk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/University_of_Toronto"
				},
				"name": "University of Toronto",
				"salience": 0.0011470448,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02g96l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_England_Journal_of_Medicine"
				},
				"name": "New England Journal of Medicine",
				"salience": 0.0011415312,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c5z5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/JAMA_Internal_Medicine"
				},
				"name": "JAMA Internal Medicine",
				"salience": 0.0011415312,
				"type": "WORK_OF_ART"
			},
			{
				"name": "profit motive",
				"salience": 0.0011210742,
				"type": "OTHER"
			},
			{
				"name": "purpose",
				"salience": 0.0011026984,
				"type": "OTHER"
			},
			{
				"name": "results",
				"salience": 0.0010944518,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0010758629,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0010758629,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.0010758629,
				"type": "OTHER"
			},
			{
				"name": "belief",
				"salience": 0.0010488849,
				"type": "OTHER"
			},
			{
				"name": "Progress in Cardiovascular Diseases",
				"salience": 0.0010267829,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.0010258354,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0010258354,
				"type": "OTHER"
			},
			{
				"name": "midstream",
				"salience": 0.0010173339,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0010173339,
				"type": "OTHER"
			},
			{
				"name": "line",
				"salience": 0.0010173339,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0010173339,
				"type": "OTHER"
			},
			{
				"name": "banks",
				"salience": 0.0010173339,
				"type": "ORGANIZATION"
			},
			{
				"name": "openness",
				"salience": 0.0010173339,
				"type": "OTHER"
			},
			{
				"name": "physician",
				"salience": 0.0010173339,
				"type": "PERSON"
			},
			{
				"name": "deficit spending",
				"salience": 0.0010173339,
				"type": "OTHER"
			},
			{
				"name": "hundreds",
				"salience": 0.0010173339,
				"type": "OTHER"
			},
			{
				"name": "Institute for Health Policy Studies",
				"salience": 0.0009884484,
				"type": "ORGANIZATION"
			},
			{
				"name": "industry",
				"salience": 0.0009801507,
				"type": "OTHER"
			},
			{
				"name": "reviewers",
				"salience": 0.00097134867,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0009476808,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0009476808,
				"type": "ORGANIZATION"
			},
			{
				"name": "research money",
				"salience": 0.00094415416,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.00094278797,
				"type": "OTHER"
			},
			{
				"name": "Cuts",
				"salience": 0.000855641,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.000855641,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.0008507249,
				"type": "LOCATION"
			},
			{
				"name": "motives",
				"salience": 0.00082686736,
				"type": "OTHER"
			},
			{
				"name": "research results",
				"salience": 0.0008175339,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0008175339,
				"type": "OTHER"
			},
			{
				"name": "funding",
				"salience": 0.0008175339,
				"type": "OTHER"
			},
			{
				"name": "WORD",
				"salience": 0.0008096792,
				"type": "OTHER"
			},
			{
				"name": "Dietitians for Professional Integrity",
				"salience": 0.00080086524,
				"type": "ORGANIZATION"
			},
			{
				"name": "research question",
				"salience": 0.00076627487,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00076627487,
				"type": "OTHER"
			},
			{
				"name": "generosity",
				"salience": 0.0007408886,
				"type": "OTHER"
			},
			{
				"name": "marketing efforts",
				"salience": 0.0007408886,
				"type": "OTHER"
			},
			{
				"name": "libertarianism",
				"salience": 0.0007408886,
				"type": "OTHER"
			},
			{
				"name": "disadvantage",
				"salience": 0.0007408886,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.0007408886,
				"type": "OTHER"
			},
			{
				"name": "money supply",
				"salience": 0.0007408886,
				"type": "OTHER"
			},
			{
				"name": "grants",
				"salience": 0.0007408886,
				"type": "OTHER"
			},
			{
				"name": "study protocols",
				"salience": 0.00070423604,
				"type": "OTHER"
			},
			{
				"name": "Dietitians for Professional Integrity",
				"salience": 0.0006435706,
				"type": "ORGANIZATION"
			},
			{
				"name": "purpose",
				"salience": 0.0006391355,
				"type": "OTHER"
			},
			{
				"name": "heart health",
				"salience": 0.0006391355,
				"type": "OTHER"
			},
			{
				"name": "Sugar Research Foundation",
				"salience": 0.0006104196,
				"type": "ORGANIZATION"
			},
			{
				"name": "percentage",
				"salience": 0.0005604792,
				"type": "OTHER"
			},
			{
				"name": "benefactor",
				"salience": 0.0005534145,
				"type": "OTHER"
			},
			{
				"name": "ax",
				"salience": 0.0005534145,
				"type": "OTHER"
			},
			{
				"name": "bias",
				"salience": 0.0005534145,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.0005534145,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0005351413,
				"type": "PERSON"
			},
			{
				"name": "pieces",
				"salience": 0.00046336613,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jkvv6f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/GoFundMe"
				},
				"name": "GOFUNDME.COM",
				"salience": 0.0004559549,
				"type": "OTHER"
			},
			{
				"name": "effect",
				"salience": 0.00044606382,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://feeds.wordpress.com/1.0/comments/rodgermmitchell.wordpress.com/38646/",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:48:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 18.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.982",
		"text": "(Before It's News)\nTwitter: @rodgermitchell; Search #monetarysovereignty\nFacebook: Rodger Malcolm Mitchell\nIn a recent post, “Why do you believe what you believe” we said:\n“Why do you know the sun causes skin cancer? You know it because years ago you read it in, or heard it from, a trusted source . Then you read and heard it often again, and the repetition caused you to believe it more and more until you know it.\nThe combination of “trusted source” and “repetition” inserts belief into our minds , and once there, it may be difficult to dislodge — unless we are exposed to a more trusted source plus repetition.\nAs you know, consuming saturated fat and cholesterol increases your risk of heart disease, while sugar does not. You have heard this from many trusted sources and it has been repeated endlessly in all forms of communication.\nScienceNews Magazine, October 15, 2016, Sugar industry sought to sugarcoat causes of heart disease\nPayments revealed to authors of influential 1967 report touting fat and cholesterol as problems, by LAURA BEIL\nUsing records unearthed from library storage vaults, researchers recently revealed that the sugar industry paid nutrition experts from Harvard University to downplay studies linking sugar and heart disease.\nAlthough the incident happened in the 1960s, it appears to have helped redirect the scientific narrative for decades.\nHarvard University — what could be a more trusted source than Harvard University?\nNote however, that Harvard University does not conduct research, nor does Harvard University verify the findings of research.\nResearch is done by people, employees of Harvard , and being employees of Harvard gives those researchers no special insight or virtue.\nYet the mere association with the name “Harvard,” implies intelligence and academic trustworthiness.\nThe documents show that the Sugar Research Foundation paid professors who wrote a two-part review in 1967 in the New England Journal of Medicine . That report was highly skeptical of the evidence linking sugar to cardiovascular problems but accepting of the role of fat.\nThe now-deceased professors’ overall conclusion left “no doubt” that reducing the risk of heart disease was a matter of reducing saturated fat and cholesterol, according to researchers from the University of California, San Francisco, who published their report online September 12 in JAMA Internal Medicine .\nNow, we have the University of California, San Francisco, another trusted source, impugning the trusted Harvard results.\nThe sugar industry helped deflect the way the research was developing,” says study coauthor Cristin Kearns, a dentist at UCSF’s Institute for Health Policy Studies.\nThe belief in sugar’s innocence, and the sugar industry’s profit motive, were so powerful, it took a dentist, not a cardiologist to uncover apparently biased results from what ostensibly was a heart study.\nFollowing the publication of the Harvard report, fat and cholesterol went on to hijack the scientific agenda for decades, and even led to a craze of low-fat foods that often added sugar.\nIt was only in 2015 that dietary guidelines finally made a strong statement to limit sugar. Researchers writing this year in Progress in Cardiovascular Diseases note that current studies estimate that diets high in added sugars carry a three times higher risk of death from cardiovascular disease.\n( The Sugar Association says in a statement on its website that “ the last several decades of research have concluded that sugar does not have a unique role in heart disease. ” )\nIs this an example of deception with a true statement ?\nYes, unfortunately, the last several decades of research did absolve sugar from blame, and what does “unique role in heart disease” really mean? If sugar causes heart disease, is that a “unique role”?\nThe Sugar Association’s statement acknowledged the secret deal occurred, but pointed out that “when the studies in question were published, funding disclosures and transparency standards were not the norm they are today.”\nTranslation: The research lied, but back then, we didn’t have to reveal the lie. So, it’s O.K.\nJournals now require all authors to list conflicts of interest, especially funding from a source has a vested interest in the outcome.\nWhile a modern researcher could not take corporate money, even for speaking fees, without disclosure, the influences may be more subtle, he says. “We’re not talking about making up data, but perhaps influencing how a research question is framed.”\nRevealing the source of funding doesn’t eliminate bias. And, though one reasonably may conclude that a high percentage of private funding comes from sources with an ax to grind, that doesn’t necessarily mean the research results are misleading.\nBut, such funding leads to the question: “What happens to results that disagree with the benefactor’s purpose?\nIf several, slightly different pieces of research show that sugar has an adverse effect on heart health, and one shows it doesn’t, what happens to all the negative research?\nAndy Bellatti, cofounder and strategic director of Dietitians for Professional Integrity says that researchers don’t necessarily want to be cozy with industry, but sometimes turn to commercial sources because non-biased research money is lacking .\n“The reason the food industry is able to do this is because there is such little public funding for nutrition and disease.”\nHere is yet another example, among hundreds, of how cuts in federal deficit spending hurt America , though often benefitting big business.\nAnd what does the need for an organization titled, “ Dietitians for Professional Integrity” tell you about today’s food research?\nThe scientific community should not reject industry money wholesale, says John Sievenpiper, a physician and nutrition researcher at the University of Toronto.\nHe believes that any scientist who takes industry money should adhere to an even higher standard of openness, including releasing study protocols ahead of time so reviewers can make sure the research question was not changed midstream to favor a certain conclusion.\nBottom line:\nFor many years, your belief in “benign sugar” was created by “trusted sources” and repetition. As with privately owned banks , the profit motive encourages unethical behavior. Corporations do not fund research out of generosity. They consider research to be part of their marketing efforts. Negative results often are twisted or hidden. Researchers, whether employed by Harvard University, the University of California, a private organization, or working alone, all can be swayed , consciously or not, to tilt their interpretations in favor of the money supply. Cuts in federally funded Research & Development grants are misguided if the primary purpose is to “save the federal government money” or to “make government smaller” (a huge, often unacknowledged disadvantage of libertarianism). While the federal government has political motives, it does not have a profit motive , and that alone helps make it a more trusted source for food & drug research than is private industry. Rodger Malcolm Mitchell\nMonetary Sovereignty\nPLEASE HELP US GET THE WORD OUT\nLOOK FOR US ON GOFUNDME.COM: RODGER MALCOLM MITCHELL",
		"thread_title": "More on why you believe what you believe: Sugar | Economics and Politics",
		"title": "More on why you believe what you believe: Sugar | Economics and Politics",
		"type": "bs",
		"uuid": "6e7de04ce2d6dfb9c3464c4fe60c1a6d7016be84"
	},
	"-KhIk9d0qARrR4kNVTsW": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:28.197+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.2998508,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.27339184,
				"type": "PERSON"
			},
			{
				"name": "post",
				"salience": 0.10596292,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ACA",
				"salience": 0.061111476,
				"type": "OTHER"
			},
			{
				"name": "title",
				"salience": 0.045150142,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.028675282,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.026775282,
				"type": "WORK_OF_ART"
			},
			{
				"name": "problem",
				"salience": 0.023332518,
				"type": "OTHER"
			},
			{
				"name": "health insurance premiums",
				"salience": 0.021738723,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.021106798,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.018236607,
				"type": "PERSON"
			},
			{
				"name": "roof",
				"salience": 0.016419481,
				"type": "OTHER"
			},
			{
				"name": "criticisms",
				"salience": 0.015811633,
				"type": "OTHER"
			},
			{
				"name": "choices",
				"salience": 0.011592938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09g7pqs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Patient_Protection_and_Affordable_Care_Act"
				},
				"name": "ACA",
				"salience": 0.010584675,
				"type": "ORGANIZATION"
			},
			{
				"name": "choices",
				"salience": 0.00845673,
				"type": "OTHER"
			},
			{
				"name": "premiums",
				"salience": 0.006323955,
				"type": "OTHER"
			},
			{
				"name": "subsidies",
				"salience": 0.0054782084,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 1.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.003",
		"text": "(Before It's News)\nSome liberals will criticize me for this post, especially the title. That’s their problem. After reading this article, though, I’m not worried about liberals’ criticisms. The truth is that health insurance premiums are going through the proverbial roof with the ACA. People should flinch when they hear that “[before] taxpayer-provided subsidies, premiums for a midlevel […]\nContinue reading The ACA: fewer choices, more expensive\n. . . → Read More: The ACA: fewer choices, more expensive",
		"thread_title": "The ACA: fewer choices, more expensive | Opinion - Conservative",
		"title": "The ACA: fewer choices, more expensive | Opinion - Conservative",
		"type": "bs",
		"uuid": "15aae87244ecdc64b8f9937360c2884bab1dc27c"
	},
	"-KhIkA0K90j80j_FFglW": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:44.074+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.152757,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/061wfm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ivanka_Trump"
				},
				"name": "Ivanka Trump",
				"salience": 0.13310495,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.0844493,
				"type": "PERSON"
			},
			{
				"name": "News",
				"salience": 0.078585364,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.06158691,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.028237702,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03gb7h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bloomingdale's"
				},
				"name": "Bloomingdale's",
				"salience": 0.02619849,
				"type": "LOCATION"
			},
			{
				"name": "brand",
				"salience": 0.025969643,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.021832706,
				"type": "PERSON"
			},
			{
				"name": "lifestyle brand",
				"salience": 0.018926928,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.018926928,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "group",
				"salience": 0.018708864,
				"type": "PERSON"
			},
			{
				"name": "GrabYourWallet",
				"salience": 0.017575087,
				"type": "OTHER"
			},
			{
				"name": "stores",
				"salience": 0.017364318,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.017101252,
				"type": "EVENT"
			},
			{
				"name": "Shannon Coulter",
				"salience": 0.015937733,
				"type": "PERSON"
			},
			{
				"name": "rhetoric",
				"salience": 0.014821303,
				"type": "OTHER"
			},
			{
				"name": "stores",
				"salience": 0.012198737,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.01119459,
				"type": "PERSON"
			},
			{
				"name": "Women",
				"salience": 0.01119459,
				"type": "PERSON"
			},
			{
				"name": "audio tape",
				"salience": 0.009698942,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sexual harassment",
				"salience": 0.008760142,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0075887237,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.0075887237,
				"type": "OTHER"
			},
			{
				"name": "Most",
				"salience": 0.0068940446,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.006708094,
				"type": "ORGANIZATION"
			},
			{
				"name": "woman",
				"salience": 0.006315919,
				"type": "PERSON"
			},
			{
				"name": "reference",
				"salience": 0.006120201,
				"type": "OTHER"
			},
			{
				"name": "hashtag",
				"salience": 0.0040481687,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.004000009,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "line",
				"salience": 0.004000009,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01pkxd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Macy's"
				},
				"name": "Macy's",
				"salience": 0.0037725377,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ivankant",
				"salience": 0.0036370372,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0036120054,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0036120054,
				"type": "EVENT"
			},
			{
				"name": "tape",
				"salience": 0.0033926745,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "accessories",
				"salience": 0.0031281097,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "perfume",
				"salience": 0.0031281097,
				"type": "OTHER"
			},
			{
				"name": "jewelry",
				"salience": 0.0031281097,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "ex-girlfriend",
				"salience": 0.0028803416,
				"type": "PERSON"
			},
			{
				"name": "clothing line",
				"salience": 0.002805434,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "problem",
				"salience": 0.0027211145,
				"type": "OTHER"
			},
			{
				"name": "audio tape",
				"salience": 0.0027007808,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "women",
				"salience": 0.0026449945,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0025331834,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.0025331834,
				"type": "OTHER"
			},
			{
				"name": "sexual harassment",
				"salience": 0.0024386758,
				"type": "OTHER"
			},
			{
				"name": "#GrabYourWallet",
				"salience": 0.0022239767,
				"type": "OTHER"
			},
			{
				"name": "groper",
				"salience": 0.002203523,
				"type": "PERSON"
			},
			{
				"name": "table",
				"salience": 0.002193685,
				"type": "OTHER"
			},
			{
				"name": "deposition",
				"salience": 0.002193685,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.002193685,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.002193685,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.002193685,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0021118321,
				"type": "OTHER"
			},
			{
				"name": "experience",
				"salience": 0.0021118321,
				"type": "OTHER"
			},
			{
				"name": "superior",
				"salience": 0.0021118321,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0021118321,
				"type": "OTHER"
			},
			{
				"name": "remark",
				"salience": 0.0021118321,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0020682006,
				"type": "EVENT"
			},
			{
				"name": "interaction",
				"salience": 0.0020682006,
				"type": "OTHER"
			},
			{
				"name": "groper",
				"salience": 0.0020682006,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0020682006,
				"type": "OTHER"
			},
			{
				"name": "newspaper",
				"salience": 0.0019761436,
				"type": "ORGANIZATION"
			},
			{
				"name": "billionaire businessman",
				"salience": 0.0019411821,
				"type": "PERSON"
			},
			{
				"name": "cover story",
				"salience": 0.0019344104,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Ivanka Trump Collection",
				"salience": 0.0019258851,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0180v2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daily_Mail"
				},
				"name": "The Daily Mail",
				"salience": 0.0019258851,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Theodore Kim",
				"salience": 0.0018177312,
				"type": "PERSON"
			},
			{
				"name": "run-in",
				"salience": 0.0018138227,
				"type": "OTHER"
			},
			{
				"name": "daughter",
				"salience": 0.0017990065,
				"type": "PERSON"
			},
			{
				"name": "salvo",
				"salience": 0.0017909731,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01fc_q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nordstrom"
				},
				"name": "Nordstrom",
				"salience": 0.0015935134,
				"type": "ORGANIZATION"
			},
			{
				"name": "executive",
				"salience": 0.0015674991,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.001559459,
				"type": "ORGANIZATION"
			},
			{
				"name": "stories",
				"salience": 0.0015203233,
				"type": "WORK_OF_ART"
			},
			{
				"name": "respect",
				"salience": 0.0014437237,
				"type": "OTHER"
			},
			{
				"name": "backlash",
				"salience": 0.0014437237,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.0013503865,
				"type": "ORGANIZATION"
			},
			{
				"name": "article",
				"salience": 0.0013379628,
				"type": "WORK_OF_ART"
			},
			{
				"name": "words",
				"salience": 0.0013379628,
				"type": "OTHER"
			},
			{
				"name": "anecdote",
				"salience": 0.0013379628,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0013379628,
				"type": "OTHER"
			},
			{
				"name": "connotation",
				"salience": 0.0013379628,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.0013379628,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0012999829,
				"type": "PERSON"
			},
			{
				"name": "facts",
				"salience": 0.0012614024,
				"type": "OTHER"
			},
			{
				"name": "Brewer Lane",
				"salience": 0.0012523622,
				"type": "LOCATION"
			},
			{
				"name": "story",
				"salience": 0.0011357391,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0hr3xn9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CBS_This_Morning"
				},
				"name": "CBS This Morning",
				"salience": 0.001102415,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.001102415,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.001102415,
				"type": "PERSON"
			},
			{
				"name": "newspaper",
				"salience": 0.0010752459,
				"type": "ORGANIZATION"
			},
			{
				"name": "regard",
				"salience": 0.0009744582,
				"type": "OTHER"
			},
			{
				"name": "Source",
				"salience": 0.0009744582,
				"type": "ORGANIZATION"
			},
			{
				"name": "contributions",
				"salience": 0.0009744582,
				"type": "OTHER"
			},
			{
				"name": "Prophecy",
				"salience": 0.0009744582,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0009744582,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.0008925555,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cnn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Guardian"
				},
				"name": "Guardian",
				"salience": 0.00087742164,
				"type": "ORGANIZATION"
			},
			{
				"name": "narrative",
				"salience": 0.00084757415,
				"type": "OTHER"
			},
			{
				"name": "daughter",
				"salience": 0.000840648,
				"type": "PERSON"
			},
			{
				"name": "facts",
				"salience": 0.000840648,
				"type": "OTHER"
			},
			{
				"name": "Donald Trump Behaved With Women in Private",
				"salience": 0.0008235099,
				"type": "ORGANIZATION"
			},
			{
				"name": "Crossing the Line",
				"salience": 0.0008235099,
				"type": "EVENT"
			},
			{
				"name": "thesis",
				"salience": 0.00072791567,
				"type": "OTHER"
			},
			{
				"name": "RealTimePolitics.com",
				"salience": 0.00059973984,
				"type": "OTHER"
			},
			{
				"name": "Jeffery Pritchett",
				"salience": 0.00059973984,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07tn5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Unidentified_flying_object"
				},
				"name": "UFO",
				"salience": 0.00059973984,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/019lw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bigfoot"
				},
				"name": "Bigfoot",
				"salience": 0.00059973984,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "10",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "0",
		"participants_count": "15",
		"published": "2016-10-26T15:07:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 9,
			"score": -0.1
		},
		"shares": "10",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "(Before It's News)\nIvanka Trump is going to have to back off from her father’s campaign, because the hateful and sexist rhetoric of Donald Trump is severely hurting Ivanka’s clothing and lifestyle brand.\nWomen are turning on Ivanka Trump as she continues supporting her father despite allegations of sexual harassment against him and a 2005 audio tape capturing him bragging in lewd terms that he can do whatever he wants to women.\nNow, the growing group of women are boycotting her line of clothing, jewelry, perfume and accessories sold as part of the Ivanka Trump Collection. They are also calling on the stores that carry the brand, including Nordstrom, Bloomingdale’s and Macy’s, to stop selling it.\nIt has even created its own hashtag, #Ivankant, as well as #GrabYourWallet.\nFrom The Daily Mail :\n‘If Ivanka Trump had distanced herself from the campaign I would not be boycotting her,’ Shannon Coulter, who called on Americans to boycott the brand earlier this month, told the Guardian.\n‘But something changed for me when that tape was released.’\nCoulter, who shared her own experience of sexual harassment at the hands of a male superior, launched the hashtag ‘GrabYourWallet’ on October 11, a reference to Trump’s offensive ‘grab them by the p***y’ remark from the audio tape.\nThe problem obviously for Ivanka, is that Donald Trump’s base, for the most part, doesn’t shop at Bloomingdale’s or Nordstrom, which are two of the largest stores that carry her clothing line, along with Macy’s.\nWhat are your thoughts, should Ivanka’s business be hurt because of the actions of her father?\nFrom Politico:\nThe New York Times cited a deposition from a woman who claimed that Donald Trump groped her under the table decades ago, but the presumptive Republican presidential nominee is certainly not a groper, his daughter said Wednesday.\n“Look, I’m not in every interaction my father has, but he’s not a groper,” Ivanka Trump said in an interview broadcast Wednesday on “CBS This Morning.” “It’s not who he is. And I’ve known my father obviously my whole life and he has total respect for women.”\nThe billionaire businessman launched a Twitter salvo the “failing” newspaper for its “false, malicious & libelous story,” catapulting the story to become the newspaper’s most popular of the year, according to assistant news editor Theodore Kim.\n—\nIvanka Trump said she read the Sunday cover story and “found it to be pretty disturbing, based on the facts as I know them, and obviously I very much know them” as a daughter and an executive who’s worked alongside him for more than a decade.\n“I was bothered by it, but it’s largely been discredited since,” she said, referring to Brewer Lane’s criticism of the report. Brewer Lane, the ex-girlfriend whose first run-in with Donald Trump was used as the lead anecdote for the article, titled “Crossing the Line: How Donald Trump Behaved With Women in Private,” accused the newspaper of putting a negative connotation on her words.\n“Most of the time when stories are inaccurate they’re not discredited, and I will be frustrated by that, but in this case I think they went so far,” Ivanka Trump continued. “They had such a strong thesis and created facts to reinforce it and, you know, I think that narrative has been playing out now and there’s backlash in that regard.”\nSource RealTimePolitics.com Check out more contributions by Jeffery Pritchett ranging from UFO to Bigfoot to Paranormal to Prophecy",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"type": "bs",
		"uuid": "3f199c212a15381eb50c7e1bf5e11d6c0efb5819"
	},
	"-KhIkA4DSO-8uxaPokjJ": {
		"author": "Man",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:44.471+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "sense",
				"salience": 0.6225934,
				"type": "OTHER"
			},
			{
				"name": "company",
				"salience": 0.18080762,
				"type": "ORGANIZATION"
			},
			{
				"name": "same",
				"salience": 0.13389069,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.06270828,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "1",
		"participants_count": "15",
		"published": "2016-10-26T15:33:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Makes sense… You do the same with any other company that you disagree with their practices",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "8893768c018e0bd14dfbae739a52d1da6dcb1a1c"
	},
	"-KhIkAVz_Ieo2EynhKiT": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:44.757+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "2",
		"participants_count": "15",
		"published": "2016-10-26T15:33:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "4cf710bfb295067dce6446d1af9a6cf633a2d182"
	},
	"-KhIkAbJkaGcFnzLYnWy": {
		"author": "Busta Myth",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:44.839+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "difference",
				"salience": 0.29486057,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.101796985,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0p1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/AK-47"
				},
				"name": "Kalashnikov",
				"salience": 0.08943061,
				"type": "ORGANIZATION"
			},
			{
				"name": "raping",
				"salience": 0.069513164,
				"type": "OTHER"
			},
			{
				"name": "head chopping",
				"salience": 0.069513164,
				"type": "OTHER"
			},
			{
				"name": "child",
				"salience": 0.05916608,
				"type": "PERSON"
			},
			{
				"name": "raping",
				"salience": 0.05916608,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03qyv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hummer"
				},
				"name": "Hummer",
				"salience": 0.05730868,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.05730868,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gmfmt4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jihadism"
				},
				"name": "Jihadi",
				"salience": 0.05730868,
				"type": "PERSON"
			},
			{
				"name": "Radical",
				"salience": 0.05137427,
				"type": "OTHER"
			},
			{
				"name": "head chopping",
				"salience": 0.024340414,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h0xm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bacon"
				},
				"name": "Bacon",
				"salience": 0.008912634,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "3",
		"participants_count": "15",
		"published": "2016-10-26T18:47:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Its getting confusing\nWhat’s the difference between a “moderate” child raping, head chopping, Kalashnikov carrying American Hummer driving Jihadi\nand a “Radical” child raping, head chopping, Kalashnikov carrying American Hummer driving Jihadi ?\nOne of them eats Bacon?",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "4b1ff4f480972c946afe3dbd4c81df5ad32220b5"
	},
	"-KhIkAf9pq3uBBgEhbsO": {
		"author": "JohnSmith2016",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:44.940+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "announcement",
				"salience": 0.8054979,
				"type": "EVENT"
			},
			{
				"name": "Ivanka",
				"salience": 0.1945021,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "4",
		"participants_count": "15",
		"published": "2016-10-26T15:53:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.6,
			"score": -0.6
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Where is the announcement from Ivanka that you promoted?",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "083c9b62c857a3a538a618bc2417532945f0f375"
	},
	"-KhIkAwcwckjMcrU9E6u": {
		"author": "Tennessee Dan",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:44.955+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "bitch boy",
				"salience": 0.43506354,
				"type": "PERSON"
			},
			{
				"name": "everything",
				"salience": 0.10047879,
				"type": "OTHER"
			},
			{
				"name": "posts",
				"salience": 0.10047879,
				"type": "WORK_OF_ART"
			},
			{
				"name": "truth",
				"salience": 0.08762622,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/033123",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jeff_Hardy"
				},
				"name": "Jeffy",
				"salience": 0.062325366,
				"type": "PERSON"
			},
			{
				"name": "pants",
				"salience": 0.05800813,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sight",
				"salience": 0.05800813,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.050840866,
				"type": "PERSON"
			},
			{
				"name": "path",
				"salience": 0.023733968,
				"type": "OTHER"
			},
			{
				"name": "stuff",
				"salience": 0.023436198,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "5",
		"participants_count": "15",
		"published": "2016-10-26T16:38:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 1.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "It didn’t happen. Much like everything else Jeffy posts. The truth is he is a liberal bitch boy who would piss his pants at the sight of a real man in his path. So to compensate, he makes stuff up to feel important.",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "e63d88455f3fb6e57aaa28db962dcce727e540e7"
	},
	"-KhIkBQ_YPAx6Wcswv0H": {
		"author": "Jeffery Pritchett",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:44.969+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "one",
				"salience": 0.20794538,
				"type": "PERSON"
			},
			{
				"name": "videos",
				"salience": 0.115157925,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Quote",
				"salience": 0.115157925,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.10022199,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.10022199,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.04846655,
				"type": "WORK_OF_ART"
			},
			{
				"name": "code",
				"salience": 0.0442128,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.042055495,
				"type": "OTHER"
			},
			{
				"name": "Quote:",
				"salience": 0.030009454,
				"type": "ORGANIZATION"
			},
			{
				"name": "villain",
				"salience": 0.015185127,
				"type": "PERSON"
			},
			{
				"name": "proportions",
				"salience": 0.015185127,
				"type": "OTHER"
			},
			{
				"name": "trickster",
				"salience": 0.014620772,
				"type": "PERSON"
			},
			{
				"name": "anarchist",
				"salience": 0.014620772,
				"type": "OTHER"
			},
			{
				"name": "More",
				"salience": 0.014620772,
				"type": "OTHER"
			},
			{
				"name": "liberal",
				"salience": 0.014620772,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.01425618,
				"type": "LOCATION"
			},
			{
				"name": "morons",
				"salience": 0.012406848,
				"type": "PERSON"
			},
			{
				"name": "Momma Earth",
				"salience": 0.010145683,
				"type": "ORGANIZATION"
			},
			{
				"name": "ashtray",
				"salience": 0.009276538,
				"type": "OTHER"
			},
			{
				"name": "cut",
				"salience": 0.009159945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04kyc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loki"
				},
				"name": "Loki",
				"salience": 0.009013854,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d3l9v"
				},
				"name": "Dan",
				"salience": 0.009013854,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05d3lbf"
				},
				"name": "Danny",
				"salience": 0.008684438,
				"type": "PERSON"
			},
			{
				"name": "rude awakening",
				"salience": 0.006760858,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.006760858,
				"type": "OTHER"
			},
			{
				"name": "oblivion",
				"salience": 0.006760858,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0054572457,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "6",
		"participants_count": "15",
		"published": "2016-10-26T18:19:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 4.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Its in the article and apparently one of the videos ate part of the Quote: because of the way the code was for the embed video.. the Quote: has been updated and fixed.\nAs for Dan.. I’m not a liberal you arsehat. More of an anarchist of Loki trickster like proportions. Or a villain if you will who believes the planet needs to be ecologically purified from morons at this time. You wouldn’t make the cut Danny. And don’t worry Momma Earth is going to fix it all real soon. I know I know you all think you are going to be handed a new Earth while you treat this one like an ashtray.. you got a rude awakening coming Danny. You all do. Enjoy it.. Treasure the chaos and oblivion.",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "a465a61e20270b2ec96fd272f6d2f93c8cb83c76"
	},
	"-KhIkBVGbDBPCNHuQN3q": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:45.076+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "hillary",
				"salience": 0.50079995,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.2954123,
				"type": "OTHER"
			},
			{
				"name": "multiplication",
				"salience": 0.084861256,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.07255398,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.04637251,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "7",
		"participants_count": "15",
		"published": "2016-10-26T16:30:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "may her business grow 10 times multiplication of these evil hillary’s supporters perpetuated on her and her business.",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "c0181fddae5f6bbec8a2355d10a46803a229287b"
	},
	"-KhIkB_ckH8tgsSghkuW": {
		"author": "Tennessee Dan",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:45.172+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "meds fruitloop",
				"salience": 0.7635056,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.102453224,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04p__vm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Florida_Department_of_Law_Enforcement"
				},
				"name": "FDLE",
				"salience": 0.07769629,
				"type": "ORGANIZATION"
			},
			{
				"name": "observation",
				"salience": 0.056344923,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "8",
		"participants_count": "15",
		"published": "2016-10-26T19:28:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Take your meds fruitloop. Don’t make me call down to the FDLE folks I know to have you picked up for observation again.",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "c678d1c9637e10575c80ce430f63e32e56233f85"
	},
	"-KhIkBe8gQ_sbpbazmOy": {
		"author": "Jeffery Pritchett",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:45.597+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05d3l9v"
				},
				"name": "Dan",
				"salience": 0.6499435,
				"type": "PERSON"
			},
			{
				"name": "dream",
				"salience": 0.3500565,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "9",
		"participants_count": "15",
		"published": "2016-10-26T19:40:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Dan you even have a bad dream about me. You better wake up and apologize in the morning.",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "505b0c91fd6aa6078edd0b328ab7b1ed0b42a4fa"
	},
	"-KhIkBiVRrKG4ULLdeeW": {
		"author": "lucid_ity",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:46.384+03:00",
		"domain_rank": "6659",
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "10",
		"participants_count": "15",
		"published": "2016-10-26T17:02:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 1.3,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Tragic? Right.. who cares. She is rich enough.",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "cc7f7af6492f0f2f11a7fa8f52780876a1e88487"
	},
	"-KhIkBmBez2wF7wjoC7V": {
		"author": "Jack Shlitz",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:46.482+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "card",
				"salience": 0.6188616,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jewish",
				"salience": 0.38113835,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "11",
		"participants_count": "15",
		"published": "2016-10-26T17:03:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.8
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "She should play the anti-Semitic card: “They’re boycotting me because I am Jewish”",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "04a3dfe3f439b7a0581dc4b430856d385c684b27"
	},
	"-KhIkBqNB8WEc0rxkCR6": {
		"author": "JimmyBitch",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:46.875+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/059yj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/National_Football_League"
				},
				"name": "NFL",
				"salience": 1,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "12",
		"participants_count": "15",
		"published": "2016-10-26T17:37:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.8
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Boycott the NFL",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "b4c3b177416953c09865ee9a145a7d99ee9d57c1"
	},
	"-KhIkBw6RW5RRbNP98M5": {
		"author": "WhiteDawn",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:47.048+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "people",
				"salience": 0.50043154,
				"type": "PERSON"
			},
			{
				"name": "business",
				"salience": 0.27732098,
				"type": "OTHER"
			},
			{
				"name": "father",
				"salience": 0.11908294,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/047jp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khazars"
				},
				"name": "Khazarian",
				"salience": 0.029425448,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03_gx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Judaism"
				},
				"name": "Judaism",
				"salience": 0.025341844,
				"type": "OTHER"
			},
			{
				"name": "blades",
				"salience": 0.01503199,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Serpent People",
				"salience": 0.0114112785,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.01097698,
				"type": "OTHER"
			},
			{
				"name": "battles",
				"salience": 0.01097698,
				"type": "EVENT"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "13",
		"participants_count": "15",
		"published": "2016-10-26T18:49:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "she’s sayin’ sorry father, but it’s just business… blah\nI just found that Khazarian people before they took Judaism was called “Serpent People”!\nThey could catch blades by hands in battles..\nhttps://www.youtube.com/watch?v=BmX6DOBPLDQ",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "c89fd0917fe5fb9605f9a0ccef8413051536608b"
	},
	"-KhIkC0D0XSgVmcMu0Nv": {
		"author": "Arcturus",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:47.108+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "world",
				"salience": 0.6179072,
				"type": "LOCATION"
			},
			{
				"name": "business",
				"salience": 0.3820928,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "14",
		"participants_count": "15",
		"published": "2016-10-26T19:03:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 0.3,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Why in the world would she start a business at this time?",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "c0660f41fd13abc83b530384504da49494133599"
	},
	"-KhIkCXHhmBsUMkek9r1": {
		"author": "El",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:47.151+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.0724818,
				"type": "PERSON"
			},
			{
				"name": "Executive Orders",
				"salience": 0.040660348,
				"type": "OTHER"
			},
			{
				"name": "wind pattern change",
				"salience": 0.03564458,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.034692563,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.033758935,
				"type": "PERSON"
			},
			{
				"name": "Executive Orders",
				"salience": 0.019030947,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.014696884,
				"type": "PERSON"
			},
			{
				"name": "people homes",
				"salience": 0.014049053,
				"type": "ORGANIZATION"
			},
			{
				"name": "smoke screen",
				"salience": 0.012527673,
				"type": "OTHER"
			},
			{
				"name": "warming",
				"salience": 0.011934265,
				"type": "EVENT"
			},
			{
				"name": "liars",
				"salience": 0.011414279,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.011186554,
				"type": "EVENT"
			},
			{
				"name": "citizens",
				"salience": 0.010667266,
				"type": "PERSON"
			},
			{
				"name": "People",
				"salience": 0.010442668,
				"type": "PERSON"
			},
			{
				"name": "stores",
				"salience": 0.010347331,
				"type": "LOCATION"
			},
			{
				"name": "lie",
				"salience": 0.010101915,
				"type": "OTHER"
			},
			{
				"name": "truth matters",
				"salience": 0.010101915,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.010101915,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.010101915,
				"type": "OTHER"
			},
			{
				"name": "smoke screens",
				"salience": 0.010101915,
				"type": "OTHER"
			},
			{
				"name": "lie",
				"salience": 0.010101915,
				"type": "OTHER"
			},
			{
				"name": "grandma",
				"salience": 0.0099918125,
				"type": "PERSON"
			},
			{
				"name": "Hurricane Matthew",
				"salience": 0.009629335,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.009627549,
				"type": "LOCATION"
			},
			{
				"name": "clue",
				"salience": 0.009560135,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.009504902,
				"type": "PERSON"
			},
			{
				"name": "establishment",
				"salience": 0.008749076,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.008749076,
				"type": "LOCATION"
			},
			{
				"name": "votes",
				"salience": 0.008749076,
				"type": "OTHER"
			},
			{
				"name": "scenes",
				"salience": 0.008749076,
				"type": "WORK_OF_ART"
			},
			{
				"name": "laws",
				"salience": 0.008749076,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.008749076,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.008749076,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.008749076,
				"type": "OTHER"
			},
			{
				"name": "Hilary",
				"salience": 0.008189907,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.007905933,
				"type": "LOCATION"
			},
			{
				"name": "facts",
				"salience": 0.007905933,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.007905933,
				"type": "PERSON"
			},
			{
				"name": "income",
				"salience": 0.007846877,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0073554725,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0071880105,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0071880105,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/083kb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Weapon"
				},
				"name": "Weapon",
				"salience": 0.0070114736,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0065781176,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.005943952,
				"type": "OTHER"
			},
			{
				"name": "droughts",
				"salience": 0.005650153,
				"type": "EVENT"
			},
			{
				"name": "clothes",
				"salience": 0.005508739,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "government",
				"salience": 0.0053823483,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0049882163,
				"type": "ORGANIZATION"
			},
			{
				"name": "food",
				"salience": 0.0049882163,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0049403673,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004852846,
				"type": "PERSON"
			},
			{
				"name": "electromagnet",
				"salience": 0.0048480895,
				"type": "OTHER"
			},
			{
				"name": "income",
				"salience": 0.0046084095,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.004161076,
				"type": "OTHER"
			},
			{
				"name": "care",
				"salience": 0.004161076,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.004161076,
				"type": "OTHER"
			},
			{
				"name": "income",
				"salience": 0.0037623867,
				"type": "OTHER"
			},
			{
				"name": "storms",
				"salience": 0.0037316529,
				"type": "EVENT"
			},
			{
				"name": "storm",
				"salience": 0.0037316529,
				"type": "EVENT"
			},
			{
				"name": "world",
				"salience": 0.0037316529,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0037316529,
				"type": "LOCATION"
			},
			{
				"name": "refusal",
				"salience": 0.003603283,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.003603283,
				"type": "OTHER"
			},
			{
				"name": "bus",
				"salience": 0.003603283,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.003603283,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.003603283,
				"type": "PERSON"
			},
			{
				"name": "ownership",
				"salience": 0.003317718,
				"type": "OTHER"
			},
			{
				"name": "flooding",
				"salience": 0.0032313885,
				"type": "EVENT"
			},
			{
				"name": "electromagnets",
				"salience": 0.0032313885,
				"type": "OTHER"
			},
			{
				"name": "scientists",
				"salience": 0.0032313885,
				"type": "PERSON"
			},
			{
				"name": "floods",
				"salience": 0.0032313885,
				"type": "EVENT"
			},
			{
				"name": "acting",
				"salience": 0.0032313885,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0032178652,
				"type": "PERSON"
			},
			{
				"name": "Defense Act",
				"salience": 0.003197212,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0jrl0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/High_Frequency_Active_Auroral_Research_Program"
				},
				"name": "H.A.A.R.P.",
				"salience": 0.0031257146,
				"type": "ORGANIZATION"
			},
			{
				"name": "food",
				"salience": 0.0031205802,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0031139173,
				"type": "OTHER"
			},
			{
				"name": "State",
				"salience": 0.0031107822,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0031107822,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.003074603,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.003074603,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08874",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yellowstone_National_Park"
				},
				"name": "Yellowstone",
				"salience": 0.0030452502,
				"type": "LOCATION"
			},
			{
				"name": "pulses",
				"salience": 0.0029925834,
				"type": "OTHER"
			},
			{
				"name": "weather weapon",
				"salience": 0.0029176471,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.0029176471,
				"type": "OTHER"
			},
			{
				"name": "heavy metals",
				"salience": 0.0029176471,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.0029176471,
				"type": "ORGANIZATION"
			},
			{
				"name": "times",
				"salience": 0.0029176471,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.002904616,
				"type": "OTHER"
			},
			{
				"name": "rioting",
				"salience": 0.002904616,
				"type": "EVENT"
			},
			{
				"name": "care",
				"salience": 0.0028087446,
				"type": "OTHER"
			},
			{
				"name": "stratosphere",
				"salience": 0.0028087446,
				"type": "OTHER"
			},
			{
				"name": "wind patterns",
				"salience": 0.0028087446,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0028087446,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0028087446,
				"type": "OTHER"
			},
			{
				"name": "vapor trails",
				"salience": 0.0028087446,
				"type": "OTHER"
			},
			{
				"name": "food supply",
				"salience": 0.0028087446,
				"type": "OTHER"
			},
			{
				"name": "floods",
				"salience": 0.0026717004,
				"type": "EVENT"
			},
			{
				"name": "activity",
				"salience": 0.002638036,
				"type": "OTHER"
			},
			{
				"name": "earthquake activity",
				"salience": 0.002638036,
				"type": "OTHER"
			},
			{
				"name": "pulses",
				"salience": 0.0026361933,
				"type": "OTHER"
			},
			{
				"name": "Marsjhall Law",
				"salience": 0.0025613576,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fzh9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Medicare_(United_States)"
				},
				"name": "Medicare",
				"salience": 0.0025613576,
				"type": "ORGANIZATION"
			},
			{
				"name": "machine",
				"salience": 0.0025264558,
				"type": "OTHER"
			},
			{
				"name": "motion",
				"salience": 0.0025264558,
				"type": "OTHER"
			},
			{
				"name": "west",
				"salience": 0.0025264558,
				"type": "LOCATION"
			},
			{
				"name": "tragedy",
				"salience": 0.0025264558,
				"type": "OTHER"
			},
			{
				"name": "grain",
				"salience": 0.0025264558,
				"type": "OTHER"
			},
			{
				"name": "anywhere",
				"salience": 0.0025264558,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Hitlers",
				"salience": 0.0025043462,
				"type": "PERSON"
			},
			{
				"name": "pain",
				"salience": 0.0024321477,
				"type": "OTHER"
			},
			{
				"name": "good",
				"salience": 0.0024321477,
				"type": "OTHER"
			},
			{
				"name": "cancers",
				"salience": 0.0024321477,
				"type": "OTHER"
			},
			{
				"name": "surgeries",
				"salience": 0.0024321477,
				"type": "EVENT"
			},
			{
				"name": "sky",
				"salience": 0.0024321477,
				"type": "LOCATION"
			},
			{
				"name": "green house gasses",
				"salience": 0.0024321477,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0024321477,
				"type": "OTHER"
			},
			{
				"name": "fruits",
				"salience": 0.0024321477,
				"type": "OTHER"
			},
			{
				"name": "vegetables",
				"salience": 0.0024321477,
				"type": "OTHER"
			},
			{
				"name": "storms",
				"salience": 0.002424792,
				"type": "EVENT"
			},
			{
				"name": "meteorites",
				"salience": 0.002381878,
				"type": "OTHER"
			},
			{
				"name": "meteors",
				"salience": 0.002381878,
				"type": "PERSON"
			},
			{
				"name": "stratosphere",
				"salience": 0.002381878,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.002381878,
				"type": "LOCATION"
			},
			{
				"name": "plates",
				"salience": 0.002381878,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "plates",
				"salience": 0.0023518638,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06x37b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Elite"
				},
				"name": "Elite",
				"salience": 0.0023071948,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Mega Storms",
				"salience": 0.0022969532,
				"type": "EVENT"
			},
			{
				"name": "worlds",
				"salience": 0.0022758183,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002239298,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jqvg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rule_of_law"
				},
				"name": "Rule of Law",
				"salience": 0.0022179165,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d0b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Security_(United_States)"
				},
				"name": "Social Security",
				"salience": 0.0022179165,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_America"
				},
				"name": "North America",
				"salience": 0.0021529614,
				"type": "LOCATION"
			},
			{
				"name": "party",
				"salience": 0.002139641,
				"type": "ORGANIZATION"
			},
			{
				"name": "world government",
				"salience": 0.002133151,
				"type": "ORGANIZATION"
			},
			{
				"name": "quakes",
				"salience": 0.0021154745,
				"type": "OTHER"
			},
			{
				"name": "pills",
				"salience": 0.002088816,
				"type": "OTHER"
			},
			{
				"name": "puppet",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "fault lines",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "buffalo",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "magnet",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "flip",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "areas",
				"salience": 0.002062493,
				"type": "LOCATION"
			},
			{
				"name": "possibilities",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "protection",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.002062493,
				"type": "OTHER"
			},
			{
				"name": "eaters",
				"salience": 0.002036502,
				"type": "OTHER"
			},
			{
				"name": "scientists",
				"salience": 0.0020212727,
				"type": "PERSON"
			},
			{
				"name": "worth",
				"salience": 0.0019854973,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0n9fbyf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hurricane_Sandy"
				},
				"name": "Sandy",
				"salience": 0.0019786838,
				"type": "EVENT"
			},
			{
				"name": "many",
				"salience": 0.0019706495,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0019706495,
				"type": "ORGANIZATION"
			},
			{
				"name": "symptom",
				"salience": 0.0019604762,
				"type": "OTHER"
			},
			{
				"name": "camps",
				"salience": 0.001944456,
				"type": "LOCATION"
			},
			{
				"name": "World Elite",
				"salience": 0.0019147003,
				"type": "PERSON"
			},
			{
				"name": "heart attack",
				"salience": 0.0018168302,
				"type": "EVENT"
			},
			{
				"name": "Leonard Decaprio",
				"salience": 0.0017957994,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0016727549,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.0015549782,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03msfz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tornado_Alley"
				},
				"name": "Tornado alley",
				"salience": 0.0015549782,
				"type": "LOCATION"
			},
			{
				"name": "property",
				"salience": 0.0015406684,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0015406684,
				"type": "PERSON"
			},
			{
				"name": "civil war",
				"salience": 0.0015406684,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.0015406684,
				"type": "OTHER"
			},
			{
				"name": "barbed wire",
				"salience": 0.0015406684,
				"type": "OTHER"
			},
			{
				"name": "guard towers",
				"salience": 0.0015406684,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.0014969234,
				"type": "LOCATION"
			},
			{
				"name": "state",
				"salience": 0.0014908449,
				"type": "LOCATION"
			},
			{
				"name": "Ivanka Trumps",
				"salience": 0.0014659783,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "act",
				"salience": 0.0014430776,
				"type": "OTHER"
			},
			{
				"name": "scientists",
				"salience": 0.0014351838,
				"type": "PERSON"
			},
			{
				"name": "train",
				"salience": 0.0012957961,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0012957961,
				"type": "OTHER"
			},
			{
				"name": "chasers",
				"salience": 0.0012957961,
				"type": "OTHER"
			},
			{
				"name": "Chasers",
				"salience": 0.0012957961,
				"type": "PERSON"
			},
			{
				"name": "slaves",
				"salience": 0.0012957961,
				"type": "PERSON"
			},
			{
				"name": "changes",
				"salience": 0.0012957961,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0012737481,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0012737481,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.0012693764,
				"type": "ORGANIZATION"
			},
			{
				"name": "pictures",
				"salience": 0.0011954758,
				"type": "WORK_OF_ART"
			},
			{
				"name": "food",
				"salience": 0.001160458,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.001160458,
				"type": "ORGANIZATION"
			},
			{
				"name": "slave labor build",
				"salience": 0.0011508401,
				"type": "EVENT"
			},
			{
				"name": "comfort",
				"salience": 0.0011220124,
				"type": "OTHER"
			},
			{
				"name": "friend",
				"salience": 0.0011220124,
				"type": "PERSON"
			},
			{
				"name": "Congressmen",
				"salience": 0.0011220124,
				"type": "PERSON"
			},
			{
				"name": "stuff",
				"salience": 0.0011220124,
				"type": "OTHER"
			},
			{
				"name": "cattle cars",
				"salience": 0.0011220124,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "triple",
				"salience": 0.0011220124,
				"type": "OTHER"
			},
			{
				"name": "bunks",
				"salience": 0.0011220124,
				"type": "OTHER"
			},
			{
				"name": "hand cuffs",
				"salience": 0.0011220124,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "wall",
				"salience": 0.0011220124,
				"type": "OTHER"
			},
			{
				"name": "step up",
				"salience": 0.0011220124,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07qfn_g"
				},
				"name": "Concentration Camps",
				"salience": 0.0010950445,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0010811794,
				"type": "PERSON"
			},
			{
				"name": "bill",
				"salience": 0.0010801189,
				"type": "WORK_OF_ART"
			},
			{
				"name": "part",
				"salience": 0.0010720403,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.0009679153,
				"type": "OTHER"
			},
			{
				"name": "housing",
				"salience": 0.0009679153,
				"type": "OTHER"
			},
			{
				"name": "businesses",
				"salience": 0.0009679153,
				"type": "ORGANIZATION"
			},
			{
				"name": "thanks",
				"salience": 0.00096359075,
				"type": "OTHER"
			},
			{
				"name": "Dark Ages",
				"salience": 0.0009481794,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0009481794,
				"type": "LOCATION"
			},
			{
				"name": "note",
				"salience": 0.00083809777,
				"type": "OTHER"
			},
			{
				"name": "suspicion",
				"salience": 0.00083809777,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.00083809777,
				"type": "EVENT"
			},
			{
				"name": "girls",
				"salience": 0.00083809777,
				"type": "PERSON"
			},
			{
				"name": "charges",
				"salience": 0.00083809777,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.00083809777,
				"type": "OTHER"
			},
			{
				"name": "read",
				"salience": 0.00083809777,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.00083124783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ynx29_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_(corporate_title)"
				},
				"name": "Presidents",
				"salience": 0.0007974625,
				"type": "PERSON"
			},
			{
				"name": "Serfs",
				"salience": 0.0006905032,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09b6zr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_W._Bush"
				},
				"name": "Bush",
				"salience": 0.0006905032,
				"type": "PERSON"
			},
			{
				"name": "need",
				"salience": 0.000675524,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.0006260165,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.00059566286,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "15",
		"participants_count": "15",
		"published": "2016-10-26T19:12:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 15.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "It didn’t happen, it wouldn’t happen. Your sources are liars. I really wish you people who tend to believe a lie, either because you are too young, or two lazy to look up facts. The smoke screens are in place and you believe mainstream media, and don’t have a clue what is going on behind the scenes. If with forged votes, Hilary manages to win the election, we might have a little more time to act like there is nothing wrong with the country. But that too will be a smoke screen and a lie. You know truth matters, obeying laws matter. I dare you and your Hilary supporters to dig deep, and I guarantee you will find that so much evil is being planned and set up by the present establishment. If you read the Executive Orders signed by Obama you will realize He doesn’t plan to leave office. He plans to cause a situation, either by knocking down the propped up economy, which will leave millions without food, a government provided income, and will cause rioting like we have never seen before in America since a full 50% of people in America are supported by the government in some way. all he will have to do is declare Marsjhall Law then and his Executive Orders become the Rule of Law. Social Security and Medicare have been given to illegal immigrants , and taken from the people who worked hard all their lives and paid into the system to be assured of an income and medical care in old age. They will lose their income too, grandma is not only under the bus, but they keep running over her again and again as they kill people off with refusal to treat people for cancers if they have ever had a heart attack or do life saving surgeries. People 60 to 70 will have to prove their worth to the State to get life saving medical care. Age 70 up will simply be given pills to be in less pain and told to die quietly for the good of the state. For the last 30 years a recently declassified weather Weapon called H.A.A.R.P. has been shooting magnetic pulses up into the stratosphere altering wind patterns. The vapor trails in the sky, people have been told are to slow down global warming due to green house gasses. It is the wind pattern change that is causing every symptom of global warming, and is being done by the World Elite to wipe out the majority of our food supply, by severe droughts in the California, that provides 1/3rd of the fruits and vegetables in the world, The floods in the mid west make growing grain almost impossible, the Mega Storms and floods in the East and and Tornado alley are destroying people homes, their businesses, their lives. Hurricane Matthew as was Sandy were generated by that weather weapon bringing 3 storms together by seeding he storms with microscopic heavy metals, and using that electromagnet to move them together to form one big storm. The electromagnets have some more effects that are even more destructive. They are causing the tectonic plates around North America to move 5 times faster than anywhere else in the world. Sorry Leonard Decaprio should stick to acting, and let real scientists expose the coming tragedy if we do not stop that machine soon. Actually with what has been set in motion, it may already be too late to fix what H.A.A.R.P. has changed. Between the flooding on fault lines and the movement of the tectonic plates, we are having increasing earthquake activity, stronger and closer together. Yellowstone is constantly getting small quakes daily, and more signs of volcanic activity, even the buffalo don’t want to stay there. And Some other scientists have realized that the magnetic pulses in the stratosphere are causing the natural protection we had from most meteors is missing in some areas and instead we are about to become a magnet for iron based meteorites .\nSo you know what, it isn’t going to matter a flip if you don’t buy Ivanka Trumps clothes and boycott the stores if they don’t remove them. You will be fortunate indeed if you have food to eat, and haven’t lost your home to one of many possibilities all caused by the Elite, the CIA, and our elite puppet president, while he smiles real big and thinks how stupid we are. He hasn’t even tried to pretend anymore. In a speech he promised if Trump won, he had a legal plan to keep him from taking control. And if you think he will care how many young white girls die, think again. Since his executive orders give him total control over all food, water, housing, businesses and people. All he will have to say is, “The state has need of this” and he can take it. He can also arrest anyone for suspicion of speaking against the government and hold them without any charges indefinitely thanks to part of a the huge national Defense Act that passed that no one read but voted in… That bill is like Hitler’s enabling act that let him arrest everyone of note in any political party that stood against him. In 1933 Hitler arrested 200,000 legal German citizens who were leaders in political parties, most died in the first Concentration Camps he ever built, or rather had his slave labor build. We have camps just like those, with guard towers, and barbed wire facing in, not to keep bad people out , but top keep good people in. Of course most of America won’t take it lying down, so civil war will break out. I could probably tell you things for hours that have been going on, planned for decades culminating in a one world government, with over half the worlds population dead and gone, because the Elite who call us the eaters, can’t control too many of us. They want to outlaw private property ownership, and own it all themselves and basically take us back to the Dark Ages and use whoever is still alive as Serfs or slaves. I am telling you not what I think, but what I know. What I have researched, and what has been confirmed to me by two Congressmen, several scientists, and a few chasers…Chasers are real people who go wherever they have to go to get to the truth. One friend chased a train for 200 miles trying to take pictures of the changes one of the Bush Presidents paid to have refitted with triple to quadruple decked metal bunks with hand cuffs attached to the wall…a step up in comfort from Hitlers cattle cars. If you don’t know how to pray you might want to start because it is going to get real ugly, real soon. I hope you will at least check this stuff out, and you might want to warn people you care about.",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "b70f2598edf886e19968222f23079a99d21203b3"
	},
	"-KhIkCaI9fi5xEr-vp3Z": {
		"author": "Anonymous",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:47.348+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "agents",
				"salience": 0.42626587,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary",
				"salience": 0.2440337,
				"type": "PERSON"
			},
			{
				"name": "crud",
				"salience": 0.16561204,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.07203136,
				"type": "PERSON"
			},
			{
				"name": "demons",
				"salience": 0.05264189,
				"type": "OTHER"
			},
			{
				"name": "faces",
				"salience": 0.039415162,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "16",
		"participants_count": "15",
		"published": "2016-10-26T19:29:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 1.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Haha! Your Hillary agents are writing this crud, but we’re laughing in their soon-to-be-hung faces. We the people are coming for you, demons!",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "1bf711b4a8f8b7e513b54f4fb3b79a20821fd918"
	},
	"-KhIkCi7Z0WsdwW67a9b": {
		"author": "Danika",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:47.384+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/061wfm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ivanka_Trump"
				},
				"name": "Ivanka",
				"salience": 0.61344546,
				"type": "PERSON"
			},
			{
				"name": "father",
				"salience": 0.18462548,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.13781871,
				"type": "PERSON"
			},
			{
				"name": "No one",
				"salience": 0.02240573,
				"type": "PERSON"
			},
			{
				"name": "actions",
				"salience": 0.012304151,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0dzqp5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump,_Jr."
				},
				"name": "Don",
				"salience": 0.0076051545,
				"type": "PERSON"
			},
			{
				"name": "remarks",
				"salience": 0.0075356397,
				"type": "OTHER"
			},
			{
				"name": "mouth",
				"salience": 0.005498011,
				"type": "OTHER"
			},
			{
				"name": "Donalds",
				"salience": 0.0046497528,
				"type": "LOCATION"
			},
			{
				"name": "products",
				"salience": 0.004111914,
				"type": "CONSUMER_GOOD"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/3705969F00000578-3731203-image-a-48_1470741574805.jpg",
		"ord_in_thread": "17",
		"participants_count": "15",
		"published": "2016-10-26T19:56:00.000+03:00",
		"replies_count": "17",
		"sentiment": {
			"magnitude": 1.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.007",
		"text": "Ivanka is not her father, no more than you are yours. No one is perfect and making Ivanka responsible for Don’s actions are bullshyte. I suuport her, even though I cannot afford her products!\nI am a woman and Donalds remarks did not fall out of Ivanka’s mouth.",
		"thread_title": "Breaking: Ivanka Trump Makes Tragic Announcement Both Donald Trump and Supporters Are Shocked (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "5ed6e9382559651b180cff92dbab7745875a7b9c"
	},
	"-KhIkD-kSSQ1FIl8xiq3": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:51.325+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06r04p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_Comey"
				},
				"name": "James Comey",
				"salience": 0.15617135,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.123083,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.113719,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.08436687,
				"type": "LOCATION"
			},
			{
				"name": "News",
				"salience": 0.064100474,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.061833598,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fzdz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Joe_Arpaio"
				},
				"name": "Joe Arpaio",
				"salience": 0.057870016,
				"type": "PERSON"
			},
			{
				"name": "information",
				"salience": 0.03322756,
				"type": "OTHER"
			},
			{
				"name": "tarmac",
				"salience": 0.020515662,
				"type": "LOCATION"
			},
			{
				"name": "tête-à-tête",
				"salience": 0.020515662,
				"type": "OTHER"
			},
			{
				"name": "jet",
				"salience": 0.020515662,
				"type": "OTHER"
			},
			{
				"name": "standards",
				"salience": 0.017787222,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04_5sg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hill"
				},
				"name": "Hill",
				"salience": 0.017086735,
				"type": "PERSON"
			},
			{
				"name": "grandchildren",
				"salience": 0.01568387,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0syvm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix_Sky_Harbor_International_Airport"
				},
				"name": "Sky Harbor airport",
				"salience": 0.01098181,
				"type": "LOCATION"
			},
			{
				"name": "Sheriff",
				"salience": 0.006889439,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.0067935786,
				"type": "PERSON"
			},
			{
				"name": "evidence",
				"salience": 0.0048090857,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0048090857,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0048090857,
				"type": "OTHER"
			},
			{
				"name": "director",
				"salience": 0.004655304,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05pcg1c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/G._Murray_Snow"
				},
				"name": "Murray Snow",
				"salience": 0.004636616,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.004478717,
				"type": "ORGANIZATION"
			},
			{
				"name": "indictment",
				"salience": 0.004342881,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0041839387,
				"type": "OTHER"
			},
			{
				"name": "aides",
				"salience": 0.003761373,
				"type": "OTHER"
			},
			{
				"name": "email servers",
				"salience": 0.003761373,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.003761373,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.003761373,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0035488727,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0034422656,
				"type": "OTHER"
			},
			{
				"name": "charges",
				"salience": 0.0033735547,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.003247765,
				"type": "EVENT"
			},
			{
				"name": "Justice",
				"salience": 0.003204647,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0030463093,
				"type": "OTHER"
			},
			{
				"name": "Justice",
				"salience": 0.0030463093,
				"type": "OTHER"
			},
			{
				"name": "breaches",
				"salience": 0.002932704,
				"type": "EVENT"
			},
			{
				"name": "Secretary of State",
				"salience": 0.002932704,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rssf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/General_election"
				},
				"name": "General Election",
				"salience": 0.0028907794,
				"type": "EVENT"
			},
			{
				"name": "system",
				"salience": 0.0026718304,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0026718304,
				"type": "OTHER"
			},
			{
				"name": "penalties",
				"salience": 0.00263819,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.00263819,
				"type": "OTHER"
			},
			{
				"name": "sheeple",
				"salience": 0.00263819,
				"type": "OTHER"
			},
			{
				"name": "hook",
				"salience": 0.00263819,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.00263819,
				"type": "OTHER"
			},
			{
				"name": "conclusion",
				"salience": 0.0025397863,
				"type": "OTHER"
			},
			{
				"name": "laws",
				"salience": 0.0025397863,
				"type": "OTHER"
			},
			{
				"name": "handling",
				"salience": 0.0025397863,
				"type": "OTHER"
			},
			{
				"name": "security",
				"salience": 0.0025397863,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.0025397863,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.002487331,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.002487331,
				"type": "EVENT"
			},
			{
				"name": "person",
				"salience": 0.0024142603,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0021540213,
				"type": "EVENT"
			},
			{
				"name": "tarmac meeting fame",
				"salience": 0.0021540213,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0021540213,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.0021540213,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0021095253,
				"type": "PERSON"
			},
			{
				"name": "term",
				"salience": 0.002058161,
				"type": "EVENT"
			},
			{
				"name": "challenger",
				"salience": 0.0020475422,
				"type": "PERSON"
			},
			{
				"name": "breach",
				"salience": 0.0019550505,
				"type": "EVENT"
			},
			{
				"name": "court",
				"salience": 0.0018583986,
				"type": "ORGANIZATION"
			},
			{
				"name": "order",
				"salience": 0.0018583986,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0018583986,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0018583986,
				"type": "OTHER"
			},
			{
				"name": "sheriff",
				"salience": 0.0016227441,
				"type": "PERSON"
			},
			{
				"name": "contempt",
				"salience": 0.0016093022,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0016093022,
				"type": "EVENT"
			},
			{
				"name": "interview",
				"salience": 0.0015104595,
				"type": "EVENT"
			},
			{
				"name": "borders",
				"salience": 0.0011721496,
				"type": "LOCATION"
			},
			{
				"name": "time",
				"salience": 0.0011721496,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.0011721496,
				"type": "LOCATION"
			},
			{
				"name": "misdemeanor conviction",
				"salience": 0.0011721496,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06_dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Snow"
				},
				"name": "Snow",
				"salience": 0.0011439862,
				"type": "ORGANIZATION"
			},
			{
				"name": "term",
				"salience": 0.001119962,
				"type": "OTHER"
			},
			{
				"name": "vendetta",
				"salience": 0.0010862803,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.0010112154,
				"type": "PERSON"
			},
			{
				"name": "Presidency",
				"salience": 0.0010112154,
				"type": "OTHER"
			},
			{
				"name": "jet",
				"salience": 0.0010112154,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0b8h9s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0009906028,
				"type": "PERSON"
			},
			{
				"name": "ballot",
				"salience": 0.00087562605,
				"type": "OTHER"
			},
			{
				"name": "Paul Penzone",
				"salience": 0.0007686862,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bymv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_McCain"
				},
				"name": "John McCain",
				"salience": 0.00072145584,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03m0hn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lou_Dobbs"
				},
				"name": "Lou Dobbs",
				"salience": 0.00072145584,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.00053891656,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00053891656,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "2",
		"published": "2016-10-26T17:15:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 7.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nObvious political double standards\nWhen it comes to scandal-plagued and utterly dishonest Hillary Clinton, the U.S. Attorney General Loretta Lynch clandestinely meets on the tarmac of Sky Harbor airport for a tête-à-tête with Hill’s husband Bill aboard a private jet — ostensibly to discuss grandchildren.\nAnd, though FBI Director James Comey found compelling evidence of concerning issues in Hillary Clinton’s use of multiple private email servers, he concluded that he would not recommend charges against her, though he conceded Clinton and her aides were “extremely careless” in handling classified information. Comey refused to recommend an indictment against Hillary Clinton, despite “evidence” she violated laws pertaining to the handling of classified information, jeopardizing U.S. national security. These breaches occurred during her term as Secretary of State. “There is evidence to support a conclusion that any reasonable person in Secretary Clinton’s position should have known that an unclassified system was no place for that information,” Comey acknowledged.\nAdditionally, Comey noted that other individuals in a similar situation would not necessarily be let off the hook with no charges, and would probably face penalties. “But that’s not what we’re deciding now,” he glibly fed us, the sheeple. “We are expressing to Justice our view that no charges be made in this case.”\n“Justice,” of course, is U.S. Attorney General Loretta Lynch of the tarmac meeting fame. Addressing the people of the United States, the FBI director actually said that “no outside influence of any kind was brought to bear” on the investigation. He neglected to mention the inappropriate meeting between former president Bill Clinton and Loretta Lynch aboard a private jet.\nHillary Clinton is free to run for the U.S. Presidency, guaranteeing Obama’s third term.\nHere in Arizona, we have what clearly appears to be a personal vendetta carried out by a federal judge timed to coincide with the General Election in which popular Sheriff Joe Arpaio is on the ballot running for a seventh term. He was formally charged Tuesday with criminal contempt of court for ignoring U.S. District Judge Murray Snow’s order in a three-year old racial-profiling case. Arpaio acknowledged violating Snow’s order but insists the breach wasn’t intentional\nArpaio’s challenger in the race is once again rough ‘er up Democrat Paul Penzone, funded by multi-billionaire Socialist George Soros, who is contemptuous of national borders. Soros also funds Hillary Clinton and John McCain .\nIf convicted, Sheriff Arpaio could face up to six months in jail. A misdemeanor conviction would not bar Arpaio from serving as sheriff.\nSheriff Arpaio’s interview with Lou Dobbs is worth your time:",
		"thread_title": "Need Proof that the Feds Have Things Bassackwards? | Alternative",
		"title": "Need Proof that the Feds Have Things Bassackwards? | Alternative",
		"type": "bs",
		"uuid": "4187a8f48f35c8655836bffd5ccc76ca78adb1a5"
	},
	"-KhIkD4C3OgjXCn_MHCh": {
		"author": "Boo",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:08:51.373+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "example",
				"salience": 0.49417913,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.21509957,
				"type": "PERSON"
			},
			{
				"name": "machinery",
				"salience": 0.10807459,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.06735873,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.064927444,
				"type": "PERSON"
			},
			{
				"name": "clarity",
				"salience": 0.015688159,
				"type": "OTHER"
			},
			{
				"name": "delusion",
				"salience": 0.015688159,
				"type": "OTHER"
			},
			{
				"name": "Sheriff",
				"salience": 0.011741835,
				"type": "PERSON"
			},
			{
				"name": "Kudo",
				"salience": 0.0072423806,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-26T19:04:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 0.6,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "Another example of the public not holding our political machinery’s and it’s politicians feet to the fire but instead satisfied with saying we did. Kudo’s to the Sheriff for trying to insert some clarity into our delusion.",
		"thread_title": "Need Proof that the Feds Have Things Bassackwards? | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "aa585987ab2b5ea6cb038310d4894c274cec40b5"
	},
	"-KhIkDaD-dGkDcx8fKNP": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:09:17.250+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/mediadrop/uploads/2016/43/bbca84e195e12a04fb5f2569555b90945c543071.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-26T15:24:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "Greg Hunter, \"USA Actually Bankrupt Now\" | Opinion - Liberal",
		"title": "",
		"type": "bs",
		"uuid": "b4e0e7a8aea40f2c960b8852098e0ae8144c5f4c"
	},
	"-KhIkDlc8sBZGlPVZQBl": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:09:37.717+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "Final Version.PDF",
				"salience": 0.23733814,
				"type": "OTHER"
			},
			{
				"name": "CEI",
				"salience": 0.101814084,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0glhpr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Schneiderman"
				},
				"name": "Eric Schneiderman",
				"salience": 0.09033612,
				"type": "PERSON"
			},
			{
				"name": "office",
				"salience": 0.071907334,
				"type": "ORGANIZATION"
			},
			{
				"name": "Common Interest Agreements",
				"salience": 0.06075947,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.056819938,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/015p59",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_of_information_laws_by_country"
				},
				"name": "Freedom of Information Law",
				"salience": 0.041436765,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.031114528,
				"type": "OTHER"
			},
			{
				"name": "CEI Sues NY AG Schneiderman",
				"salience": 0.023426302,
				"type": "PERSON"
			},
			{
				"name": "Common Interest Agreement",
				"salience": 0.021104043,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York",
				"salience": 0.020633994,
				"type": "LOCATION"
			},
			{
				"name": "News",
				"salience": 0.019421058,
				"type": "OTHER"
			},
			{
				"name": "Common Interest Agreements",
				"salience": 0.014093007,
				"type": "OTHER"
			},
			{
				"name": "disclosure",
				"salience": 0.011037948,
				"type": "OTHER"
			},
			{
				"name": "records",
				"salience": 0.008641617,
				"type": "OTHER"
			},
			{
				"name": "interest agreement",
				"salience": 0.0072693997,
				"type": "OTHER"
			},
			{
				"name": "Exhibits.PDF",
				"salience": 0.0069637164,
				"type": "OTHER"
			},
			{
				"name": "agreements",
				"salience": 0.0067825536,
				"type": "OTHER"
			},
			{
				"name": "Title",
				"salience": 0.00457845,
				"type": "OTHER"
			},
			{
				"name": "disclosure",
				"salience": 0.004559674,
				"type": "OTHER"
			},
			{
				"name": "2016 PDF",
				"salience": 0.004551787,
				"type": "OTHER"
			},
			{
				"name": "pretext",
				"salience": 0.0044228476,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gktf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Silver_sulfide"
				},
				"name": "AGs",
				"salience": 0.004300656,
				"type": "ORGANIZATION"
			},
			{
				"name": "Common Interest",
				"salience": 0.0042642616,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.00411784,
				"type": "OTHER"
			},
			{
				"name": "states",
				"salience": 0.00411784,
				"type": "LOCATION"
			},
			{
				"name": "Agreements",
				"salience": 0.0040899627,
				"type": "OTHER"
			},
			{
				"name": "motion",
				"salience": 0.0040816846,
				"type": "OTHER"
			},
			{
				"name": "typo corrected.pdf Title",
				"salience": 0.003739256,
				"type": "OTHER"
			},
			{
				"name": "pdf Title",
				"salience": 0.003739256,
				"type": "OTHER"
			},
			{
				"name": "mention",
				"salience": 0.003566673,
				"type": "OTHER"
			},
			{
				"name": "territories",
				"salience": 0.003566673,
				"type": "LOCATION"
			},
			{
				"name": "activists",
				"salience": 0.003566673,
				"type": "PERSON"
			},
			{
				"name": "Albany.PDF",
				"salience": 0.003547196,
				"type": "OTHER"
			},
			{
				"name": "Petition",
				"salience": 0.003462397,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0034491357,
				"type": "WORK_OF_ART"
			},
			{
				"name": "FOIL request",
				"salience": 0.003185684,
				"type": "OTHER"
			},
			{
				"name": "disclosure",
				"salience": 0.0030798095,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f6c3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Attorney_general"
				},
				"name": "Office of the Attorney General",
				"salience": 0.0030401684,
				"type": "ORGANIZATION"
			},
			{
				"name": "information",
				"salience": 0.0028888304,
				"type": "OTHER"
			},
			{
				"name": "Case Status",
				"salience": 0.0028888304,
				"type": "OTHER"
			},
			{
				"name": "Notice",
				"salience": 0.0028888304,
				"type": "OTHER"
			},
			{
				"name": "rejection",
				"salience": 0.0028274106,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.0028274106,
				"type": "OTHER"
			},
			{
				"name": "Title",
				"salience": 0.0027945444,
				"type": "OTHER"
			},
			{
				"name": "FOIL case",
				"salience": 0.00278113,
				"type": "OTHER"
			},
			{
				"name": "Orders",
				"salience": 0.0025019115,
				"type": "OTHER"
			},
			{
				"name": "High Proceedings",
				"salience": 0.0025019115,
				"type": "EVENT"
			},
			{
				"name": "Timeline",
				"salience": 0.0025019115,
				"type": "OTHER"
			},
			{
				"name": "Court",
				"salience": 0.0025019115,
				"type": "ORGANIZATION"
			},
			{
				"name": "Level",
				"salience": 0.0025019115,
				"type": "OTHER"
			},
			{
				"name": "Opinions",
				"salience": 0.0025019115,
				"type": "OTHER"
			},
			{
				"name": "filing",
				"salience": 0.0024086146,
				"type": "EVENT"
			},
			{
				"name": "shield",
				"salience": 0.0024086146,
				"type": "OTHER"
			},
			{
				"name": "grounds",
				"salience": 0.0024086146,
				"type": "LOCATION"
			},
			{
				"name": "denial",
				"salience": 0.0023588808,
				"type": "EVENT"
			},
			{
				"name": "CEI NY AG",
				"salience": 0.0021323785,
				"type": "OTHER"
			},
			{
				"name": "Petition",
				"salience": 0.0021127746,
				"type": "OTHER"
			},
			{
				"name": "Title",
				"salience": 0.0020359512,
				"type": "OTHER"
			},
			{
				"name": "Title",
				"salience": 0.0020359512,
				"type": "OTHER"
			},
			{
				"name": "Affidavit",
				"salience": 0.001951958,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Affidavit",
				"salience": 0.001951958,
				"type": "WORK_OF_ART"
			},
			{
				"name": "appeal.pdf",
				"salience": 0.0019135175,
				"type": "OTHER"
			},
			{
				"name": "Notice of Petition Date",
				"salience": 0.0017788963,
				"type": "OTHER"
			},
			{
				"name": "Exhibits Date",
				"salience": 0.0017747584,
				"type": "EVENT"
			},
			{
				"name": "Under New York",
				"salience": 0.0017410497,
				"type": "ORGANIZATION"
			},
			{
				"name": "NY AG",
				"salience": 0.0017410497,
				"type": "LOCATION"
			},
			{
				"name": "CEI Appeal",
				"salience": 0.0017410497,
				"type": "OTHER"
			},
			{
				"name": "Dismiss.pdf",
				"salience": 0.0015768161,
				"type": "OTHER"
			},
			{
				"name": "John affirmation signed.pdf",
				"salience": 0.0015768161,
				"type": "OTHER"
			},
			{
				"name": "Title",
				"salience": 0.0015211718,
				"type": "OTHER"
			},
			{
				"name": "Hans Bader",
				"salience": 0.0014287126,
				"type": "PERSON"
			},
			{
				"name": "Verified Petition",
				"salience": 0.0013007751,
				"type": "OTHER"
			},
			{
				"name": "Request",
				"salience": 0.0012957108,
				"type": "OTHER"
			},
			{
				"name": "FOIL request",
				"salience": 0.0012957108,
				"type": "OTHER"
			},
			{
				"name": "Request",
				"salience": 0.0012957108,
				"type": "OTHER"
			},
			{
				"name": "2016.pdf",
				"salience": 0.0011780426,
				"type": "OTHER"
			},
			{
				"name": "Rejection",
				"salience": 0.0011498403,
				"type": "OTHER"
			},
			{
				"name": "News Releases",
				"salience": 0.0011117643,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Oposition",
				"salience": 0.0011117643,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02crzl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Motion_in_United_States_law"
				},
				"name": "Motion",
				"salience": 0.00094743696,
				"type": "OTHER"
			},
			{
				"name": "NY Motion",
				"salience": 0.00094743696,
				"type": "OTHER"
			},
			{
				"name": "New York Motion",
				"salience": 0.00094743696,
				"type": "OTHER"
			},
			{
				"name": "Title: Administrative Appeal",
				"salience": 0.00070776296,
				"type": "OTHER"
			},
			{
				"name": "Climate Change Subpoena Campaign",
				"salience": 0.0006843199,
				"type": "ORGANIZATION"
			},
			{
				"name": "2016 PDF: Request for Judicial Intervention.PDF Title: Request for Judicial Intervention Date",
				"salience": 0.00059035217,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://http://http://http://http://http://http://http://http://http:///modules/file/icons/application-pdf.png",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T20:03:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.7,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.001",
		"text": "(Before It's News)\nNew York Attorney General Eric Schneiderman's office denied CEI’s May 5, 2016 request for any Common Interest Agreements, which was made under New York’s Freedom of Information Law (FOIL). His office claimed the records are exempt from disclosure.\nCEI is seeking all Common Interest Agreements entered into by the Office of the Attorney General and which are signed by, mention or otherwise include the AGs for other states or territories, as well as certain environmental activists. CEI suspects that these agreements may be a pretext for simply shielding documents from public disclosure.\nAfter supplying a Common Interest Agreement to CEI, AG Schneiderman moved to dismiss our FOIL case against his office. Our October 26, 2016 filing opposes that motion to dismiss on the grounds that there could be more relevant documents yet to be produced, and we also want the common interest agreement ruled invalid, so that it stops functioning as a shield against disclosure of information by AGs.\nCase Status: Open Court Level: High Proceedings, Orders, and Opinions Timeline: Date: Wednesday, August 31, 2016 PDF: Notice of Petition – Albany.PDF Title: Notice of Petition Date: Thursday, May 5, 2016 PDF: CEI NY AG FOIL Common Interest Agreements typo corrected.pdf Title: Request Under New York FOIL Date: Tuesday, June 21, 2016 PDF: FOIL appeal by CEI of NY AG's denial of CEI's FOIL request about common ….pdf Title: CEI Appeal of NY FOIL Denial Date: Wednesday, June 15, 2016 PDF: FOIL rejection of our FOIL request 6.15.2016.pdf Title: NY FOIL Request Rejection Date: Thursday, July 7, 2016 PDF: Rejection by NY of our FOIL administrative appeal.pdf Title: Administrative Appeal of NY FOIL Request Rejection Date: Wednesday, August 31, 2016 PDF: Request for Judicial Intervention.PDF Title: Request for Judicial Intervention Date: Wednesday, August 31, 2016 PDF: Verified Petition – Final Version.PDF Title: Verified Petition Date: Friday, August 26, 2016 PDF: Affidavit of Hans Bader & Exhibits.PDF Title: Affidavit of Hans Bader and Exhibits Date: Wednesday, October 26, 2016 PDF: NY FOIL.St_. John affirmation signed.pdf Title: Oposition To Motion to Dismiss Date: Friday, September 30, 2016 PDF: NY Motion to Dismiss.pdf Title: New York Motion to Dismiss News Releases : CEI Sues NY AG Schneiderman for Common Interest Agreement on Climate Change Subpoena Campaign Date: Wednesday, August 31, 2016",
		"thread_title": "CEI v. The Attorney General of New York | Libertarian",
		"title": "CEI v. The Attorney General of New York | Libertarian",
		"type": "bs",
		"uuid": "6131c284879fd054e76e44c109ce03044ebc658d"
	},
	"-KhIkDqEDhEORRFxaXKb": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:10:02.995+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.83240056,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.08548823,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05d4jlk"
				},
				"name": "Gerard",
				"salience": 0.06005813,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0jw67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michael_Moore"
				},
				"name": "Michael Moore",
				"salience": 0.022053096,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.4,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.629",
		"text": "(Before It's News)\nI never thought I would see the day when I reposted something from Michael Moore. Today is the day.\nh/t Gerard",
		"thread_title": "Today is the day! | Opinion - Conservative",
		"title": "Today is the day! | Opinion - Conservative",
		"type": "bs",
		"uuid": "f1bc9757dd11ce72ba90cad139f0b0c324804407"
	},
	"-KhIkE7XtNsJfl9-c0q7": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:10:09.434+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://21stcenturywire.com/wp-content/uploads/2016/10/1-Russia-vs-US.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-26T15:36:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "Paul Craig Roberts: ‘By Cooperating with Washington on Syria Russia Walked Into a Trap’ | Alternative",
		"title": "",
		"type": "bs",
		"uuid": "28e7c6e7ed714fe906b695fc752085afb1dd15b7"
	},
	"-KhIkEFmjoZD0K-ibPX-": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:11:02.658+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.37010548,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.19681998,
				"type": "WORK_OF_ART"
			},
			{
				"name": "effort",
				"salience": 0.0685597,
				"type": "OTHER"
			},
			{
				"name": "emphasis",
				"salience": 0.06269191,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.052181378,
				"type": "OTHER"
			},
			{
				"name": "videos",
				"salience": 0.048683245,
				"type": "WORK_OF_ART"
			},
			{
				"name": "investigation",
				"salience": 0.048683245,
				"type": "EVENT"
			},
			{
				"name": "donor",
				"salience": 0.040784646,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.0334482,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.03003802,
				"type": "OTHER"
			},
			{
				"name": "Project Veritas Action",
				"salience": 0.018089924,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.011299098,
				"type": "EVENT"
			},
			{
				"name": "benefit",
				"salience": 0.009792668,
				"type": "OTHER"
			},
			{
				"name": "Robert Creamer",
				"salience": 0.008822526,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.8,
			"score": -0.4
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nWhat the video is about (emphasis added) In the effort to prove the credibility of the undercover donor featured in the videos and to keep the investigation going, Project Veritas Action made the decision to donate twenty thousand dollars to Robert Creamer’s effort. Project Veritas Action had determined that the benefit of this investigation outweighed […]",
		"thread_title": "Project Veritas: Money from Belize | Opinion - Conservative",
		"title": "Project Veritas: Money from Belize | Opinion - Conservative",
		"type": "bs",
		"uuid": "c86cadf7f1f97292616feb98692963ab6fde550e"
	},
	"-KhIkEY0AoZtrBTS1KzO": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:11:08.277+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "administration",
				"salience": 0.15105653,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.09223936,
				"type": "ORGANIZATION"
			},
			{
				"name": "war noises",
				"salience": 0.057595003,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.037380833,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.026199253,
				"type": "LOCATION"
			},
			{
				"name": "computer systems",
				"salience": 0.02387378,
				"type": "OTHER"
			},
			{
				"name": "no other",
				"salience": 0.021024156,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.020023389,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.018780021,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.014256752,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.011365987,
				"type": "EVENT"
			},
			{
				"name": "power grids",
				"salience": 0.010088967,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.009302634,
				"type": "OTHER"
			},
			{
				"name": "Ice storms",
				"salience": 0.008418479,
				"type": "EVENT"
			},
			{
				"name": "grid system",
				"salience": 0.008418479,
				"type": "OTHER"
			},
			{
				"name": "power outages",
				"salience": 0.008418479,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.008418479,
				"type": "EVENT"
			},
			{
				"name": "mass shootings",
				"salience": 0.008418479,
				"type": "EVENT"
			},
			{
				"name": "attention",
				"salience": 0.0079671275,
				"type": "OTHER"
			},
			{
				"name": "plural",
				"salience": 0.007291412,
				"type": "OTHER"
			},
			{
				"name": "chalkboard",
				"salience": 0.007291412,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.007291412,
				"type": "OTHER"
			},
			{
				"name": "attacks",
				"salience": 0.007291412,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.007291412,
				"type": "LOCATION"
			},
			{
				"name": "disrepair",
				"salience": 0.007291412,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.007291412,
				"type": "LOCATION"
			},
			{
				"name": "unrest",
				"salience": 0.007291412,
				"type": "EVENT"
			},
			{
				"name": "All",
				"salience": 0.007251354,
				"type": "OTHER"
			},
			{
				"name": "skills",
				"salience": 0.006981883,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.006463921,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/North_Korea"
				},
				"name": "North Korea",
				"salience": 0.0060858442,
				"type": "LOCATION"
			},
			{
				"name": "fingernails",
				"salience": 0.005879074,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0057974076,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0049541057,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0046848655,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0046848655,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0046848655,
				"type": "EVENT"
			},
			{
				"name": "wars",
				"salience": 0.0045259,
				"type": "EVENT"
			},
			{
				"name": "problem",
				"salience": 0.004476537,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.0044296216,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0043137786,
				"type": "OTHER"
			},
			{
				"name": "grid",
				"salience": 0.004157661,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.004157661,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0038411417,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0037287145,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0037287145,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0037287145,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0034683382,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0034683382,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0034683382,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0034683382,
				"type": "OTHER"
			},
			{
				"name": "wars",
				"salience": 0.0034683382,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.003437837,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0034354667,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00334126,
				"type": "LOCATION"
			},
			{
				"name": "much",
				"salience": 0.00334126,
				"type": "OTHER"
			},
			{
				"name": "focus",
				"salience": 0.0031999892,
				"type": "OTHER"
			},
			{
				"name": "factor",
				"salience": 0.003173853,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.003162782,
				"type": "OTHER"
			},
			{
				"name": "snowplows",
				"salience": 0.003162782,
				"type": "PERSON"
			},
			{
				"name": "food",
				"salience": 0.0030442572,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.0030442572,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0030417782,
				"type": "PERSON"
			},
			{
				"name": "individual",
				"salience": 0.0030034622,
				"type": "PERSON"
			},
			{
				"name": "best",
				"salience": 0.0030034622,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0030034622,
				"type": "OTHER"
			},
			{
				"name": "name",
				"salience": 0.0030034622,
				"type": "OTHER"
			},
			{
				"name": "fog",
				"salience": 0.0030034622,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.0030034622,
				"type": "EVENT"
			},
			{
				"name": "parties",
				"salience": 0.0030034622,
				"type": "ORGANIZATION"
			},
			{
				"name": "vote",
				"salience": 0.0030034622,
				"type": "OTHER"
			},
			{
				"name": "supply",
				"salience": 0.0029434601,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.002915534,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.002915534,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.002915534,
				"type": "OTHER"
			},
			{
				"name": "break-in",
				"salience": 0.0028913834,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0028549605,
				"type": "ORGANIZATION"
			},
			{
				"name": "cases",
				"salience": 0.002806734,
				"type": "OTHER"
			},
			{
				"name": "supply",
				"salience": 0.0026935085,
				"type": "OTHER"
			},
			{
				"name": "fires",
				"salience": 0.002592988,
				"type": "EVENT"
			},
			{
				"name": "Firefighters",
				"salience": 0.002592988,
				"type": "PERSON"
			},
			{
				"name": "wind chill factor",
				"salience": 0.0025585336,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.0025150187,
				"type": "OTHER"
			},
			{
				"name": "emergencies",
				"salience": 0.0024320162,
				"type": "EVENT"
			},
			{
				"name": "discontent",
				"salience": 0.0024320162,
				"type": "OTHER"
			},
			{
				"name": "shopping habits",
				"salience": 0.0024320162,
				"type": "OTHER"
			},
			{
				"name": "grocery shop",
				"salience": 0.0024320162,
				"type": "LOCATION"
			},
			{
				"name": "something",
				"salience": 0.0024320162,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0024320162,
				"type": "OTHER"
			},
			{
				"name": "supply",
				"salience": 0.0024030542,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0023802521,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.0023802521,
				"type": "OTHER"
			},
			{
				"name": "citizen",
				"salience": 0.0023605325,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.002347547,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.0023412486,
				"type": "EVENT"
			},
			{
				"name": "cooking",
				"salience": 0.0023412486,
				"type": "OTHER"
			},
			{
				"name": "injuries",
				"salience": 0.0023412486,
				"type": "OTHER"
			},
			{
				"name": "protesters",
				"salience": 0.0023412486,
				"type": "PERSON"
			},
			{
				"name": "mass shooting",
				"salience": 0.0023412486,
				"type": "EVENT"
			},
			{
				"name": "injuries",
				"salience": 0.0023412486,
				"type": "OTHER"
			},
			{
				"name": "prepforshtf.com",
				"salience": 0.0023358157,
				"type": "OTHER"
			},
			{
				"name": "The Winter of Our Discontent: Survival",
				"salience": 0.0022773286,
				"type": "WORK_OF_ART"
			},
			{
				"name": "food",
				"salience": 0.0022742834,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0022742834,
				"type": "OTHER"
			},
			{
				"name": "skills",
				"salience": 0.0021989655,
				"type": "OTHER"
			},
			{
				"name": "finances",
				"salience": 0.0021059646,
				"type": "OTHER"
			},
			{
				"name": "landscape",
				"salience": 0.0021059646,
				"type": "OTHER"
			},
			{
				"name": "weather",
				"salience": 0.0021059646,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0021059646,
				"type": "OTHER"
			},
			{
				"name": "control",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "rioting",
				"salience": 0.002027359,
				"type": "EVENT"
			},
			{
				"name": "bottom",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "ambulance services",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "Police",
				"salience": 0.002027359,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.002027359,
				"type": "LOCATION"
			},
			{
				"name": "heat",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "natural gas",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "garbage pickup",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "dark",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "strikes",
				"salience": 0.002027359,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.002027359,
				"type": "LOCATION"
			},
			{
				"name": "turmoil",
				"salience": 0.002027359,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.002003779,
				"type": "OTHER"
			},
			{
				"name": "snow",
				"salience": 0.002003779,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.0019854591,
				"type": "EVENT"
			},
			{
				"name": "cooking",
				"salience": 0.0019854591,
				"type": "OTHER"
			},
			{
				"name": "meal preparation habits",
				"salience": 0.0019854591,
				"type": "OTHER"
			},
			{
				"name": "disasters",
				"salience": 0.0019854591,
				"type": "EVENT"
			},
			{
				"name": "food reserves",
				"salience": 0.0018788361,
				"type": "OTHER"
			},
			{
				"name": "emergency blankets",
				"salience": 0.0018400042,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "case",
				"salience": 0.0017781428,
				"type": "OTHER"
			},
			{
				"name": "things",
				"salience": 0.0017781428,
				"type": "OTHER"
			},
			{
				"name": "Things",
				"salience": 0.0017781428,
				"type": "OTHER"
			},
			{
				"name": "reach",
				"salience": 0.0017192481,
				"type": "OTHER"
			},
			{
				"name": "bedroom",
				"salience": 0.0017192481,
				"type": "LOCATION"
			},
			{
				"name": "lanterns",
				"salience": 0.0017192481,
				"type": "OTHER"
			},
			{
				"name": "batteries",
				"salience": 0.0017192481,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tents",
				"salience": 0.0017192481,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sleeping bags",
				"salience": 0.0017192481,
				"type": "OTHER"
			},
			{
				"name": "fire starting",
				"salience": 0.0017192481,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.0016722911,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0016426945,
				"type": "LOCATION"
			},
			{
				"name": "house",
				"salience": 0.0016426945,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0016426945,
				"type": "OTHER"
			},
			{
				"name": "meal",
				"salience": 0.0016004364,
				"type": "OTHER"
			},
			{
				"name": "box",
				"salience": 0.0015932876,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.001541769,
				"type": "OTHER"
			},
			{
				"name": "Snow storms",
				"salience": 0.0015307122,
				"type": "EVENT"
			},
			{
				"name": "blankets",
				"salience": 0.0014831772,
				"type": "OTHER"
			},
			{
				"name": "conditions",
				"salience": 0.0014831772,
				"type": "OTHER"
			},
			{
				"name": "ditch",
				"salience": 0.0014831772,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0014731148,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0014593756,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.001296217,
				"type": "PERSON"
			},
			{
				"name": "vehicle",
				"salience": 0.001284289,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "protein bars",
				"salience": 0.001284289,
				"type": "OTHER"
			},
			{
				"name": "matches",
				"salience": 0.001284289,
				"type": "EVENT"
			},
			{
				"name": "winter survival kit",
				"salience": 0.001284289,
				"type": "OTHER"
			},
			{
				"name": "clothing",
				"salience": 0.001284289,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "shoes",
				"salience": 0.001284289,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "flashlight",
				"salience": 0.001284289,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "gloves",
				"salience": 0.001284289,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "shovel",
				"salience": 0.001284289,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hat",
				"salience": 0.001284289,
				"type": "OTHER"
			},
			{
				"name": "snow boots",
				"salience": 0.001284289,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "jacket",
				"salience": 0.001284289,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "back",
				"salience": 0.001284289,
				"type": "OTHER"
			},
			{
				"name": "snowstorm",
				"salience": 0.0012693487,
				"type": "EVENT"
			},
			{
				"name": "house",
				"salience": 0.0011963621,
				"type": "LOCATION"
			},
			{
				"name": "anything",
				"salience": 0.0011603753,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.001143084,
				"type": "OTHER"
			},
			{
				"name": "threats",
				"salience": 0.001143084,
				"type": "OTHER"
			},
			{
				"name": "snowstorm",
				"salience": 0.0010901435,
				"type": "EVENT"
			},
			{
				"name": "course",
				"salience": 0.0010801742,
				"type": "OTHER"
			},
			{
				"name": "roads",
				"salience": 0.0010801742,
				"type": "LOCATION"
			},
			{
				"name": "article",
				"salience": 0.001039846,
				"type": "WORK_OF_ART"
			},
			{
				"name": "foods",
				"salience": 0.0009973632,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0009965507,
				"type": "OTHER"
			},
			{
				"name": "shtf",
				"salience": 0.00093531376,
				"type": "OTHER"
			},
			{
				"name": "grid collapse",
				"salience": 0.00093531376,
				"type": "EVENT"
			},
			{
				"name": "invasions",
				"salience": 0.00093531376,
				"type": "EVENT"
			},
			{
				"name": "picture",
				"salience": 0.00093531376,
				"type": "WORK_OF_ART"
			},
			{
				"name": "bank",
				"salience": 0.00093531376,
				"type": "ORGANIZATION"
			},
			{
				"name": "course",
				"salience": 0.00093531376,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00089365826,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00089365826,
				"type": "LOCATION"
			},
			{
				"name": "road conditions",
				"salience": 0.00080686196,
				"type": "OTHER"
			},
			{
				"name": "ditch",
				"salience": 0.00080686196,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.00080686196,
				"type": "PERSON"
			},
			{
				"name": "power outages",
				"salience": 0.00080686196,
				"type": "OTHER"
			},
			{
				"name": "articles",
				"salience": 0.00080686196,
				"type": "WORK_OF_ART"
			},
			{
				"name": "few",
				"salience": 0.0007388254,
				"type": "OTHER"
			},
			{
				"name": "game",
				"salience": 0.00069864804,
				"type": "EVENT"
			},
			{
				"name": "fish",
				"salience": 0.00069864804,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00069864804,
				"type": "OTHER"
			},
			{
				"name": "dozens",
				"salience": 0.00069864804,
				"type": "OTHER"
			},
			{
				"name": "Simplest",
				"salience": 0.00069864804,
				"type": "OTHER"
			},
			{
				"name": "ravine",
				"salience": 0.00069864804,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00069864804,
				"type": "OTHER"
			},
			{
				"name": "water mains",
				"salience": 0.00069864804,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://feeds.feedburner.com/~ff/PreparingForShtf?d=yIl2AUoC8zA",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T16:06:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 15.9,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.005",
		"text": "(Before It's News)\nA new year coming up, a new administration being sworn in, and new threats emerging, so will this be a winter like no other? Ice storms, power outages, mass shootings, financial crisis’s, possible attacks by other countries and civil unrest all loom large in the new year.\nThe nation’s power grids, yes plural because there are three of them are in disrepair, and much of the grid system relies entirely on computer systems, which it seems, are hacked on a daily basis. Russia is stirring and making war noises, North Korea has failed to launch but they keep trying and they will get it right soon enough, and then there is Iran running their fingernails down the chalkboard trying to get our attention. Iran wants a war because it takes the focus off of just how badly treated their people are and it always ends up being about money and power, so why not start a war is their thinking.\nAll in the name of something are wars started, wars are profitable, and they cover up a lot of atrocities committed by all parties, the fog of war, and all that. This winter we may or may not be in a war much may depend on just how the new administration handles things, however.\nYou cast your vote and pray for the best, of course, there is much more you must do. You as an individual and as a family or even as a community must prepare, because you may have to go it alone for days, weeks, or even months if the grid is hacked and shut down, or if we are attacked or if a natural disaster strikes. The world is in turmoil and much of what happens is simply out of your control, what you can control, however, is how you prepare and react.\nYou have to be prepared to live without your local, state or federal governments help. No garbage pickup, no clean water piped in, no natural gas for heat or cooking, and no snowplows patrolling the streets. Police will prioritize so that recent break-in with no injuries goes to the bottom of the list. Firefighters may be responding to fires set by violent protesters and ambulance services may have to respond to a mass shooting or injuries caused by rioting. You, the average citizen may very well be on your own, on your own in the dark in some cases for a very long time, in the winter of our discontent.\nThe weather will have an influence on you, and it must be dealt with along with the other threats looming. It may be time that you grocery shop for two weeks instead of stopping every night or every other night to grab something quick. This way you stand a good chance of having a week to a 10-day supply of food on hand for emergencies.\nWe generally recommend several months, and in some cases, several years’ worth of food, but the prepping landscape is changing, and finances are the biggest factor. For most Americans, it is not realistic to have a 6-month supply of food on hand, and with that being the case, you will have to adjust your shopping habits and meal preparation habits, so you do have some food reserves on hand at all times. It may not be much but it may be enough to get past many local disasters. If you can afford to have a 6-month supply on hand do so, but for many this is financially out of reach.\nThe problem with stockpiling food, however, is that it will need to be prepared and many today simply do not have the time or skills to properly prepare a meal, but during a crisis is not the time to try and learn to cook.\nThere is more to being prepared than having a spare bedroom filled with dehydrated foods, lanterns, batteries, tents, and sleeping bags. You also need skills, such as cooking, fire starting, how to stay warm outside when the wind chill factor is well below zero and how to prepare fresh foods like wild game or fish, for example, without making the family sick.\nWe have written dozens of articles about the skills needed, and it is well worth your time to review a few. This article is more about reminding you that regardless of what may be going on in the world, the biggest threat to you is usually local. Snow storms, local power outages, broken water mains, which means no clean water unless you boil it, or you lose a few days of work because of a snowstorm, or you experience icy road conditions and end up in the ditch or down a ravine. Local threats and national and world threats all have to be dealt with, but you start with the most likely at the time.\nThe Simplest Of Things Matter The Most\nKeep your vehicle fueled up can save your life. If you run off into the ditch almost on empty, you can’t stay warm. You need a winter survival kit as well. Warm clothing and shoes for walking in snow and wet conditions, blankets and food and water protected from freezing. You don’t have to run out and buy emergency blankets, use one or two from the house and toss a spare jacket in the back and those old snow boots you never wear around the house. The simple things matter.\nBuy a box of protein bars , and a case of water. For less than 12 bucks, you have water and food for a few days. Toss in some matches, a flashlight, gloves, a small shovel and hat and you are almost there without breaking the bank. You know what you need, it is just a matter of taking the time to do it, and if you look around the house you will find you may not have to run out and buy anything because you already have what you need.\nYou, of course, have to focus on the big picture as well, the threats from abroad, nuclear war, armed invasions and a major grid collapse but it is likely you will meet a snowstorm or icy roads before the other threats manifest themselves. Of course, we never know for sure, but life is always about the most likely and what is the most realist way of living your life day-to-day.\nThe post The Winter of Our Discontent: Survival appeared first on Preparing for shtf .\nSource: prepforshtf.com",
		"thread_title": "The Winter of Our Discontent: Survival | Survival",
		"title": "The Winter of Our Discontent: Survival | Survival",
		"type": "bs",
		"uuid": "253744f02b8bd6c051ea5f13f94d62963cf838ec"
	},
	"-KhIkEtXs1ltf5FYHLsN": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:11:42.280+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.089751855,
				"type": "OTHER"
			},
			{
				"name": "Vanessa Beeley",
				"salience": 0.08908331,
				"type": "PERSON"
			},
			{
				"name": "White Helmets",
				"salience": 0.0859328,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.04801018,
				"type": "LOCATION"
			},
			{
				"name": "White Helmets",
				"salience": 0.044372905,
				"type": "ORGANIZATION"
			},
			{
				"name": "White Helmets Recycling",
				"salience": 0.0410589,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.033098876,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.023423947,
				"type": "PERSON"
			},
			{
				"name": "media outlets",
				"salience": 0.018338894,
				"type": "ORGANIZATION"
			},
			{
				"name": "child victims",
				"salience": 0.017581083,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.017581083,
				"type": "PERSON"
			},
			{
				"name": "civilians",
				"salience": 0.017581083,
				"type": "PERSON"
			},
			{
				"name": "images",
				"salience": 0.014676004,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Mother Agnes-Mariam",
				"salience": 0.013068159,
				"type": "PERSON"
			},
			{
				"name": "snipers",
				"salience": 0.012714643,
				"type": "PERSON"
			},
			{
				"name": "hell cannon",
				"salience": 0.012714643,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "mortars",
				"salience": 0.012714643,
				"type": "OTHER"
			},
			{
				"name": "West Aleppo",
				"salience": 0.011563045,
				"type": "LOCATION"
			},
			{
				"name": "East Aleppo",
				"salience": 0.011563045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.011563045,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.010227583,
				"type": "ORGANIZATION"
			},
			{
				"name": "White Helmets 'Recycling",
				"salience": 0.009900524,
				"type": "OTHER"
			},
			{
				"name": "Helmets",
				"salience": 0.008669278,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "REAL Syria Civil Defense",
				"salience": 0.008359046,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.007835329,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.007835329,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0ncl8zk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/BBC"
				},
				"name": "BBC",
				"salience": 0.007835329,
				"type": "ORGANIZATION"
			},
			{
				"name": "Letter",
				"salience": 0.0072555565,
				"type": "WORK_OF_ART"
			},
			{
				"name": "mainstream media",
				"salience": 0.0072555565,
				"type": "ORGANIZATION"
			},
			{
				"name": "level",
				"salience": 0.006754139,
				"type": "OTHER"
			},
			{
				"name": "researcher",
				"salience": 0.0060536247,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.0060536247,
				"type": "PERSON"
			},
			{
				"name": "propaganda",
				"salience": 0.0060536247,
				"type": "WORK_OF_ART"
			},
			{
				"name": "John Ryan",
				"salience": 0.005597638,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0055207163,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Child Victims",
				"salience": 0.0054222215,
				"type": "PERSON"
			},
			{
				"name": "LINKS",
				"salience": 0.0052428218,
				"type": "OTHER"
			},
			{
				"name": "Message",
				"salience": 0.0052428218,
				"type": "OTHER"
			},
			{
				"name": "Watch",
				"salience": 0.0052428218,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "standards",
				"salience": 0.0052428218,
				"type": "OTHER"
			},
			{
				"name": "information fraud",
				"salience": 0.0052428218,
				"type": "OTHER"
			},
			{
				"name": "Nominations",
				"salience": 0.0047021215,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0047021215,
				"type": "EVENT"
			},
			{
				"name": "Patrick Henningsen",
				"salience": 0.004548464,
				"type": "PERSON"
			},
			{
				"name": "Terrorist",
				"salience": 0.004526751,
				"type": "OTHER"
			},
			{
				"name": "Contest",
				"salience": 0.0042458973,
				"type": "EVENT"
			},
			{
				"name": "Child Victim",
				"salience": 0.0041555776,
				"type": "PERSON"
			},
			{
				"name": "NGO",
				"salience": 0.004087521,
				"type": "OTHER"
			},
			{
				"name": "CrossTalk",
				"salience": 0.004087521,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.004087521,
				"type": "ORGANIZATION"
			},
			{
				"name": "RT International",
				"salience": 0.0039040484,
				"type": "ORGANIZATION"
			},
			{
				"name": "Rescue Scenes: Save Aleppo",
				"salience": 0.0037584098,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07vznt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Samantha_Power"
				},
				"name": "Samantha Power",
				"salience": 0.0037277201,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05f3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Peace_Prize"
				},
				"name": "Nobel Peace Prize",
				"salience": 0.0037163491,
				"type": "OTHER"
			},
			{
				"name": "INTRODUCTION",
				"salience": 0.003676955,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Imposters CrossTalk Panel Discussion",
				"salience": 0.0035397795,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0035397795,
				"type": "PERSON"
			},
			{
				"name": "world events",
				"salience": 0.0035168647,
				"type": "EVENT"
			},
			{
				"name": "REPORT",
				"salience": 0.0034986285,
				"type": "OTHER"
			},
			{
				"name": "Barrel Bomb",
				"salience": 0.0034951998,
				"type": "OTHER"
			},
			{
				"name": "compilation",
				"salience": 0.0034666571,
				"type": "WORK_OF_ART"
			},
			{
				"name": "information",
				"salience": 0.0034666571,
				"type": "OTHER"
			},
			{
				"name": "Images",
				"salience": 0.0034666571,
				"type": "OTHER"
			},
			{
				"name": "Rescue Videos",
				"salience": 0.0034666571,
				"type": "WORK_OF_ART"
			},
			{
				"name": "VIDEO",
				"salience": 0.0034666571,
				"type": "WORK_OF_ART"
			},
			{
				"name": "report",
				"salience": 0.0034110593,
				"type": "WORK_OF_ART"
			},
			{
				"name": "White Helmet",
				"salience": 0.0033840158,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0k3n2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Right_Livelihood_Award"
				},
				"name": "RLA",
				"salience": 0.0033556756,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.003228147,
				"type": "PERSON"
			},
			{
				"name": "White Helmet Center",
				"salience": 0.0032183889,
				"type": "ORGANIZATION"
			},
			{
				"name": "Syrian War",
				"salience": 0.003133654,
				"type": "EVENT"
			},
			{
				"name": "War NOT Peace",
				"salience": 0.003133654,
				"type": "OTHER"
			},
			{
				"name": "Letter",
				"salience": 0.003104834,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Cory Morningstar",
				"salience": 0.0030468858,
				"type": "PERSON"
			},
			{
				"name": "Terrorist Connections",
				"salience": 0.00300204,
				"type": "OTHER"
			},
			{
				"name": "RESCUE REDUX",
				"salience": 0.00300204,
				"type": "OTHER"
			},
			{
				"name": "White Helmets Campaign",
				"salience": 0.0028950474,
				"type": "ORGANIZATION"
			},
			{
				"name": "21WIRE Investigative Report",
				"salience": 0.0028829346,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Claims",
				"salience": 0.00286842,
				"type": "OTHER"
			},
			{
				"name": "Nomination",
				"salience": 0.00286842,
				"type": "OTHER"
			},
			{
				"name": "The REAL Syria Civil Defence",
				"salience": 0.0027870187,
				"type": "OTHER"
			},
			{
				"name": "Smart Power & The Human Rights Industrial Complex Open Letter",
				"salience": 0.0026140208,
				"type": "OTHER"
			},
			{
				"name": "Miraculous 'Rag Doll Rescue",
				"salience": 0.0025583887,
				"type": "OTHER"
			},
			{
				"name": "21WIRE",
				"salience": 0.0023635547,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.0022636023,
				"type": "LOCATION"
			},
			{
				"name": "NGO/Human Rights Charities",
				"salience": 0.0022636023,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jeremy Salt",
				"salience": 0.0022636023,
				"type": "PERSON"
			},
			{
				"name": "How West Are Deceiving the World",
				"salience": 0.0022636023,
				"type": "WORK_OF_ART"
			},
			{
				"name": "media",
				"salience": 0.002261514,
				"type": "OTHER"
			},
			{
				"name": "Questions",
				"salience": 0.002242779,
				"type": "OTHER"
			},
			{
				"name": "nomination",
				"salience": 0.0022260116,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02gjp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Damascus"
				},
				"name": "Damascus",
				"salience": 0.002179121,
				"type": "LOCATION"
			},
			{
				"name": "NOBEL LIE",
				"salience": 0.002179121,
				"type": "OTHER"
			},
			{
				"name": "Eva Bartlett",
				"salience": 0.002179121,
				"type": "PERSON"
			},
			{
				"name": "Western Propaganda",
				"salience": 0.0021340887,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07hwkr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_American"
				},
				"name": "WHITE",
				"salience": 0.0021037664,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f9b7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Democratic_Party"
				},
				"name": "NDP",
				"salience": 0.0020993033,
				"type": "ORGANIZATION"
			},
			{
				"name": "NEWS",
				"salience": 0.0020892746,
				"type": "OTHER"
			},
			{
				"name": "Aleppo Media Centre",
				"salience": 0.002039078,
				"type": "ORGANIZATION"
			},
			{
				"name": "Investigation",
				"salience": 0.0020112956,
				"type": "EVENT"
			},
			{
				"name": "report",
				"salience": 0.0019038281,
				"type": "WORK_OF_ART"
			},
			{
				"name": "readers",
				"salience": 0.0018864224,
				"type": "PERSON"
			},
			{
				"name": "White Helmets: War by Way of Deception",
				"salience": 0.0018414318,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/059x1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nobel_Prize"
				},
				"name": "Nobel Prize",
				"salience": 0.0017656926,
				"type": "OTHER"
			},
			{
				"name": "Bogus Claim",
				"salience": 0.0017656926,
				"type": "OTHER"
			},
			{
				"name": "Protest",
				"salience": 0.0017626267,
				"type": "OTHER"
			},
			{
				"name": "news agency",
				"salience": 0.001740417,
				"type": "ORGANIZATION"
			},
			{
				"name": "letter",
				"salience": 0.0016894506,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Helmet Files",
				"salience": 0.0016543403,
				"type": "OTHER"
			},
			{
				"name": "MORE",
				"salience": 0.0016334944,
				"type": "OTHER"
			},
			{
				"name": "Actors",
				"salience": 0.0016334944,
				"type": "PERSON"
			},
			{
				"name": "WORK",
				"salience": 0.0016334944,
				"type": "OTHER"
			},
			{
				"name": "MEMBER",
				"salience": 0.0016334944,
				"type": "PERSON"
			},
			{
				"name": "Contradiction",
				"salience": 0.0014092015,
				"type": "OTHER"
			},
			{
				"name": "War Victims",
				"salience": 0.001392009,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0g7hr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Foreign_and_Commonwealth_Office"
				},
				"name": "Foreign Office",
				"salience": 0.0013804741,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_6t_z8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/European_Union"
				},
				"name": "EU",
				"salience": 0.0013804741,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0f8l9c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/France"
				},
				"name": "French",
				"salience": 0.0013804741,
				"type": "LOCATION"
			},
			{
				"name": "Tony Cartalucci",
				"salience": 0.0013804741,
				"type": "PERSON"
			},
			{
				"name": "White Helmets Raises",
				"salience": 0.0013804741,
				"type": "EVENT"
			},
			{
				"name": "@21WIRE.TV",
				"salience": 0.0012859672,
				"type": "OTHER"
			},
			{
				"name": "21st Century Wire",
				"salience": 0.0012859672,
				"type": "OTHER"
			},
			{
				"name": "NGOs",
				"salience": 0.0012202356,
				"type": "ORGANIZATION"
			},
			{
				"name": "funding sources",
				"salience": 0.0012202356,
				"type": "OTHER"
			},
			{
				"name": "Purpose",
				"salience": 0.0012202356,
				"type": "OTHER"
			},
			{
				"name": "Weapons",
				"salience": 0.0012202356,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Leader",
				"salience": 0.0012202356,
				"type": "PERSON"
			},
			{
				"name": "Syria Campaign White Helmets Report",
				"salience": 0.0011717987,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02rpw9l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Avaaz"
				},
				"name": "Avaaz",
				"salience": 0.0010443699,
				"type": "ORGANIZATION"
			},
			{
				"name": "Syria Policy Open",
				"salience": 0.0008673098,
				"type": "EVENT"
			},
			{
				"name": "Scott Ritter",
				"salience": 0.0007509925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canada",
				"salience": 0.0007509925,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02_l43",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moderate"
				},
				"name": "Moderate",
				"salience": 0.0007509925,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:46:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 2.8,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.005",
		"text": "(Before It's News)\n21st Century Wire says…\nAs western media outlets like the New York Times, Washington Post, CNN and the BBC continue to hurl viral images of ‘child victims of Aleppo,’ western and gulf-backed terrorists in East Aleppo continue to fire mortars, ‘ hell cannon ‘ and use snipers to target civilians and children in government-protected West Aleppo. The level of information fraud and propaganda being perpetrated by the western mainstream media and politicians like John Kerry and Samantha Power is unprecedented – even by traditional low US standards.\nRT International interveiws Syrian peace campaigner Mother Agnes-Mariam and independent researcher and journalist Vanessa Beeley . Watch:\n.\nRESEARCH LINKS:\nMessage from the REAL Syria Civil Defense to the White Helmets:\nLetter from the REAL Syria Civil Defense to western governments and people\nExclusive investigative report by Vanessa Beeley:\nThe REAL Syria Civil Defence Exposes Fake White Helmets as Terrorist-Linked Imposters\nCrossTalk Panel Discussion: White Helmets, ‘A Pseudo NGO’:\nCrossTalk: ‘White Helmets, Really?’ with Vanessa Beeley, Eva Bartlett & Patrick Henningsen\nA NOBEL LIE: CNN Claim Barrel Bomb Struck White Helmet Center in Damascus:\nhttp://21stcenturywire.com/2016/10/08/more-lies-cnn-claim-white-helmets-center-hit-by-barrel-bomb-in-damascus/\nNGO/Human Rights Charities investigation by Patrick Henningsen:\nAN INTRODUCTION: Smart Power & The Human Rights Industrial Complex\nOpen Letter by Vanessa Beeley:\nWhite Helmets Campaign for War NOT Peace – Retract RLA & Nobel Peace Prize Nominations\nJeremy Salt: How West Are Deceiving the World Over Syria\n“No Longer Just a Syrian War but an Existential Contest Between the US and Russia”\nStaged Rescue Videos:\n(VIDEO) White Helmets: Miraculous ‘Rag Doll Rescue’\nWhite Helmets Recycling ‘Child Victim’ Images for Western Propaganda:\nRESCUE REDUX: Are Syria’s White Helmets ‘Recycling’ its Child Victims?\n21WIRE compilation of key information on the White Helmets:\nWho are the Syria White Helmets?\n21WIRE Investigative Report on the White Helmets’ Terrorist Connections:\nSyria’s White Helmets: War by Way of Deception ~ the “Moderate” Executioners\nCory Morningstar report on White Helmets, NGOs:\nInvestigation into the funding sources of the White Helmets, Avaaz, Purpose, The Syria Campaign\nWhite Helmets Report by former Weapons Scott Ritter:\nThe ‘White Helmets’ and the Inherent Contradiction of America’s Syria Policy\nOpen letter to Canada’s NDP Leader on White Helmets’ Nobel Prize Nomination:\nLetter to NDP from Prof. John Ryan protesting White Helmet nomination for RLA and Nobel Peace Prize\nREPORT: ‘Aleppo Media Centre’ Funded By French Foreign Office, EU and US:\nhttp://21stcenturywire.com/2016/09/20/exclusive-aleppo-media-centre-funded-by-french-foreign-office-eu-and-us/\nWhite Helmets – Bogus Claims:\n‘We Saved 60,000’ – Bogus Claim by Syria’s White Helmets Raises Even More Questions\nTony Cartalucci report on the White Helmets and Staged Rescue Scenes:\nSave Aleppo” Protest Proves How Easy it is to Dress Up Actors as “War Victims”\nREAD MORE WHITE HELMET NEWS AT: 21st Century Wire White Helmet Files\nSUPPORT OUR WORK BY SUBSCRIBING & BECOMING A MEMBER @21WIRE.TV\n21st Century Wire is an alternative news agency designed to enlighten, inform and educate readers about world events which are not always covered in the mainstream media.",
		"thread_title": "‘Intl Community Still Financing, Protecting Terrorists’ – Mother Agnes, Vanessa Beeley on Syria | Alternative",
		"title": "‘Intl Community Still Financing, Protecting Terrorists’ – Mother Agnes, Vanessa Beeley on Syria | Alternative",
		"type": "bs",
		"uuid": "09712b8e5796b613b937b1d227fce70cf47c24b0"
	},
	"-KhIkEyGLDBSxcs9l9W_": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:11:54.414+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0k3m06j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/InSight_Crime"
				},
				"name": "InSight Crime",
				"salience": 0.4917578,
				"type": "ORGANIZATION"
			},
			{
				"name": "News",
				"salience": 0.13220832,
				"type": "OTHER"
			},
			{
				"name": "sailboats",
				"salience": 0.057127364,
				"type": "OTHER"
			},
			{
				"name": "cocaine",
				"salience": 0.057127364,
				"type": "OTHER"
			},
			{
				"name": "packages",
				"salience": 0.057127364,
				"type": "OTHER"
			},
			{
				"name": "weights",
				"salience": 0.057127364,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.024917327,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Colombia Traffickers Love High-Tech 'Narco Torpedoes",
				"salience": 0.024220165,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.020914473,
				"type": "OTHER"
			},
			{
				"name": "trafficking",
				"salience": 0.019731605,
				"type": "OTHER"
			},
			{
				"name": "towing",
				"salience": 0.017112594,
				"type": "OTHER"
			},
			{
				"name": "graphic",
				"salience": 0.013820865,
				"type": "OTHER"
			},
			{
				"name": "speedboats",
				"salience": 0.012815825,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.006995785,
				"type": "OTHER"
			},
			{
				"name": "submarines",
				"salience": 0.006995785,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:47:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 0.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.91",
		"text": "(Before It's News)\nInSight Crime reports on sailboats transporting cocaine by towing packages tied with dead weights, Why Colombia Traffickers Love High-Tech ‘Narco Torpedoes’. As the article points out, reports of trafficking by underwater towing have been circulating for several years, in addition to submarines used since the 1990s and the ever-present speedboats. Here’s their graphic (click to go […]",
		"thread_title": "Colombia: And now, “narco torpedoes” | Opinion - Conservative",
		"title": "Colombia: And now, “narco torpedoes” | Opinion - Conservative",
		"type": "bs",
		"uuid": "314624a9980fce89012e349aec3d9d1af2804bfd"
	},
	"-KhIkFPPdNeJUYcNnNDM": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:12:12.168+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://beforeitsnews.com/contributor/upload/106013/images/hillary-clinton-winking-AP-640x480.jpg",
		"ord_in_thread": "1",
		"participants_count": "2",
		"published": "2016-10-26T15:28:00.000+03:00",
		"replies_count": "1",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "Breaking! Wikileaks to Take Down Top Clinton Strategist (Video) | Prophecy",
		"title": "",
		"type": "bs",
		"uuid": "c282f54e588b25baaa70a6a246161e46320a5a4f"
	},
	"-KhIkFWzj1q0kEaos7V0": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:12:31.398+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"name": "News",
				"salience": 0.33028233,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.2369063,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08k5hc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/El_Gordo_y_la_Flaca"
				},
				"name": "El Gordo y la Flaca",
				"salience": 0.10286009,
				"type": "WORK_OF_ART"
			},
			{
				"name": "readers",
				"salience": 0.037265625,
				"type": "PERSON"
			},
			{
				"name": "videos",
				"salience": 0.031722765,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02p10m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Univision"
				},
				"name": "Univision",
				"salience": 0.02596596,
				"type": "ORGANIZATION"
			},
			{
				"name": "custody",
				"salience": 0.019015312,
				"type": "OTHER"
			},
			{
				"name": "entirety",
				"salience": 0.017408216,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.01690088,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.016272925,
				"type": "WORK_OF_ART"
			},
			{
				"name": "need",
				"salience": 0.015438723,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.015438723,
				"type": "PERSON"
			},
			{
				"name": "eyes",
				"salience": 0.013583915,
				"type": "OTHER"
			},
			{
				"name": "stairs",
				"salience": 0.012223254,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.012223254,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.012223254,
				"type": "PERSON"
			},
			{
				"name": "mark",
				"salience": 0.012223254,
				"type": "OTHER"
			},
			{
				"name": "eye movements",
				"salience": 0.011768453,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.01152598,
				"type": "OTHER"
			},
			{
				"name": "translator",
				"salience": 0.007463663,
				"type": "PERSON"
			},
			{
				"name": "citizen",
				"salience": 0.007463663,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0056245965,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.005438533,
				"type": "PERSON"
			},
			{
				"name": "order",
				"salience": 0.005438533,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06nm1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Spanish_language"
				},
				"name": "Spanish",
				"salience": 0.004597004,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02h40lc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/English_language"
				},
				"name": "English",
				"salience": 0.004597004,
				"type": "OTHER"
			},
			{
				"name": "following",
				"salience": 0.0040638954,
				"type": "OTHER"
			},
			{
				"name": "racist",
				"salience": 0.0040638954,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T19:46:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.4,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "(Before It's News)\nI'm about to be seriously un-PC.\nHillary Clinton appeared yesterday on El Gordo y la Flaca, a Univision TV show. I would never ask my loyal readers to watch these videos in their entirety. However, it is clear Hillary does not have custody of her eye movements. In the first video you can stop at 7s, 15s, and 31s to witness her whacked out eyes.\nAt the 1:35 mark of the second video, Hillary is introduced by a “little person” who conveniently helps her down the stairs on to the set. Hop up to 4:12, 6:01, 6:10, and 6:21 to see her eyes scramble. It is particularly noticeable at 6:10.\nDoes the following make me a racist?\nIf you'd like to know what Hillary is talking about in the second video you'll have to be able to speak Spanish since the translator speaks over Hillary. What happened to immigrants having to speak English to become a citizen? If the people watching this need to have it translated in order to know what Hillary is saying, then why are they allowed to vote?",
		"thread_title": "Hillary Clinton celebrates her birthday on Spanish TV show and spins her eyes for our entertainment... | Opinion - Conservative",
		"title": "Hillary Clinton celebrates her birthday on Spanish TV show and spins her eyes for our entertainment... | Opinion - Conservative",
		"type": "bs",
		"uuid": "1f4b60ba52796be7c85b145ebde75e3d75afbd1a"
	},
	"-KhIkFyQ3Nk_3mCc_1lG": {
		"author": "beforeitsnews.com",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:12:37.759+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/03bwyyc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vitamin_E"
				},
				"name": "Vitamin E",
				"salience": 0.33937088,
				"type": "OTHER"
			},
			{
				"name": "E. You",
				"salience": 0.04753013,
				"type": "OTHER"
			},
			{
				"name": "Foods",
				"salience": 0.04435721,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.043006416,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.018491382,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hkxq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Broccoli"
				},
				"name": "Broccoli",
				"salience": 0.018265888,
				"type": "ORGANIZATION"
			},
			{
				"name": "vitamin E foods",
				"salience": 0.015200129,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vitamin",
				"salience": 0.012269576,
				"type": "OTHER"
			},
			{
				"name": "needs",
				"salience": 0.010062176,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.009901787,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.009391281,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07r0y6n"
				},
				"name": "Mustard Greens",
				"salience": 0.008816904,
				"type": "OTHER"
			},
			{
				"name": "Seeds",
				"salience": 0.0075525357,
				"type": "OTHER"
			},
			{
				"name": "diet",
				"salience": 0.007521909,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05s28",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Parsley"
				},
				"name": "Parsley",
				"salience": 0.007443369,
				"type": "OTHER"
			},
			{
				"name": "Kale Kale",
				"salience": 0.0064717093,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.0064623267,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.0063681873,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0054711346,
				"type": "OTHER"
			},
			{
				"name": "diet",
				"salience": 0.0054711346,
				"type": "OTHER"
			},
			{
				"name": "Sunflower oil",
				"salience": 0.005418895,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "E. 7",
				"salience": 0.005380698,
				"type": "OTHER"
			},
			{
				"name": "vitamin",
				"salience": 0.005065072,
				"type": "OTHER"
			},
			{
				"name": "vitamin E foods",
				"salience": 0.005053729,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "amount",
				"salience": 0.0049880994,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.004593372,
				"type": "OTHER"
			},
			{
				"name": "Alzheimer's disease",
				"salience": 0.0045651062,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0045651062,
				"type": "OTHER"
			},
			{
				"name": "diseases",
				"salience": 0.0045651062,
				"type": "OTHER"
			},
			{
				"name": "element",
				"salience": 0.004212281,
				"type": "OTHER"
			},
			{
				"name": "imbalances",
				"salience": 0.0041592796,
				"type": "OTHER"
			},
			{
				"name": "development",
				"salience": 0.0041592796,
				"type": "OTHER"
			},
			{
				"name": "oxidation",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "fats",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "vitamin E supplements",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "research",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "maintenance",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "production",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "aging",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "method",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "immune system",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "effects",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "studies",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "antioxidant lipid",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "dementia",
				"salience": 0.003953847,
				"type": "OTHER"
			},
			{
				"name": "vitamin E",
				"salience": 0.003932743,
				"type": "OTHER"
			},
			{
				"name": "vitamin E foods",
				"salience": 0.0038738376,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "food",
				"salience": 0.0038738376,
				"type": "OTHER"
			},
			{
				"name": "vitamin E",
				"salience": 0.00369143,
				"type": "OTHER"
			},
			{
				"name": "vitamin",
				"salience": 0.0034206577,
				"type": "OTHER"
			},
			{
				"name": "Swiss chard",
				"salience": 0.0030987596,
				"type": "OTHER"
			},
			{
				"name": "ounce",
				"salience": 0.003007747,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0029387865,
				"type": "LOCATION"
			},
			{
				"name": "Vitamin",
				"salience": 0.0029012528,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.002829179,
				"type": "OTHER"
			},
			{
				"name": "cup",
				"salience": 0.00277721,
				"type": "OTHER"
			},
			{
				"name": "calcium foods",
				"salience": 0.0027170477,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "spinach",
				"salience": 0.0026246791,
				"type": "OTHER"
			},
			{
				"name": "almonds",
				"salience": 0.0025402964,
				"type": "OTHER"
			},
			{
				"name": "almonds",
				"salience": 0.0025402964,
				"type": "OTHER"
			},
			{
				"name": "Almonds Almonds",
				"salience": 0.0025402964,
				"type": "OTHER"
			},
			{
				"name": "almond oils",
				"salience": 0.0024050814,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "sunflower seeds",
				"salience": 0.002254406,
				"type": "OTHER"
			},
			{
				"name": "diet",
				"salience": 0.002254406,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.002254406,
				"type": "OTHER"
			},
			{
				"name": "seeds",
				"salience": 0.002254406,
				"type": "OTHER"
			},
			{
				"name": "vitamin E",
				"salience": 0.002252157,
				"type": "OTHER"
			},
			{
				"name": "vitamin E",
				"salience": 0.002252157,
				"type": "OTHER"
			},
			{
				"name": "Vitamin",
				"salience": 0.0021677334,
				"type": "OTHER"
			},
			{
				"name": "vitamin",
				"salience": 0.0021677334,
				"type": "OTHER"
			},
			{
				"name": "cup",
				"salience": 0.00210149,
				"type": "OTHER"
			},
			{
				"name": "cup",
				"salience": 0.00210149,
				"type": "OTHER"
			},
			{
				"name": "Swiss chard",
				"salience": 0.002092108,
				"type": "OTHER"
			},
			{
				"name": "greens",
				"salience": 0.0020913603,
				"type": "OTHER"
			},
			{
				"name": "turnip greens",
				"salience": 0.0020913603,
				"type": "OTHER"
			},
			{
				"name": "Turnip Greens",
				"salience": 0.0020913603,
				"type": "OTHER"
			},
			{
				"name": "leafy greens",
				"salience": 0.0020913603,
				"type": "OTHER"
			},
			{
				"name": "almond milk",
				"salience": 0.0020827677,
				"type": "OTHER"
			},
			{
				"name": "sunflower",
				"salience": 0.0020827677,
				"type": "OTHER"
			},
			{
				"name": "cup",
				"salience": 0.0020750223,
				"type": "OTHER"
			},
			{
				"name": "few",
				"salience": 0.0020551,
				"type": "OTHER"
			},
			{
				"name": "cup",
				"salience": 0.002023082,
				"type": "OTHER"
			},
			{
				"name": "swiss chard greens",
				"salience": 0.0020133299,
				"type": "OTHER"
			},
			{
				"name": "mustard greens",
				"salience": 0.0020133299,
				"type": "OTHER"
			},
			{
				"name": "mustard greens",
				"salience": 0.0020133299,
				"type": "OTHER"
			},
			{
				"name": "mustard greens",
				"salience": 0.0020133299,
				"type": "OTHER"
			},
			{
				"name": "Wheat germ oil",
				"salience": 0.0019303015,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fruit",
				"salience": 0.0019177471,
				"type": "OTHER"
			},
			{
				"name": "value",
				"salience": 0.0018806108,
				"type": "OTHER"
			},
			{
				"name": "cup",
				"salience": 0.0018749256,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.0018678582,
				"type": "OTHER"
			},
			{
				"name": "cottonseed oil",
				"salience": 0.0018117557,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "safflower oil",
				"salience": 0.0018117557,
				"type": "OTHER"
			},
			{
				"name": "olive oil",
				"salience": 0.0018117557,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "coconut oil",
				"salience": 0.0018117557,
				"type": "OTHER"
			},
			{
				"name": "hempseed oil",
				"salience": 0.0018117557,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "requirements",
				"salience": 0.0017981599,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0017927237,
				"type": "OTHER"
			},
			{
				"name": "Spinach Spinach",
				"salience": 0.0017719098,
				"type": "OTHER"
			},
			{
				"name": "avocados",
				"salience": 0.001708061,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0016826204,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0016826204,
				"type": "PERSON"
			},
			{
				"name": "detox foods",
				"salience": 0.0016573921,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "foods",
				"salience": 0.0016573921,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.0016573921,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.0016573921,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.0016459778,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0016285308,
				"type": "OTHER"
			},
			{
				"name": "pumpkin",
				"salience": 0.0016285308,
				"type": "OTHER"
			},
			{
				"name": "sesame",
				"salience": 0.0016285308,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0016285308,
				"type": "LOCATION"
			},
			{
				"name": "swiss chard",
				"salience": 0.0016236069,
				"type": "OTHER"
			},
			{
				"name": "parsley",
				"salience": 0.0016010209,
				"type": "OTHER"
			},
			{
				"name": "vitamin C",
				"salience": 0.001580852,
				"type": "OTHER"
			},
			{
				"name": "nutrients",
				"salience": 0.001580852,
				"type": "OTHER"
			},
			{
				"name": "spinach",
				"salience": 0.001580852,
				"type": "OTHER"
			},
			{
				"name": "Vitamin",
				"salience": 0.0015789833,
				"type": "OTHER"
			},
			{
				"name": "vitamin",
				"salience": 0.0015789833,
				"type": "OTHER"
			},
			{
				"name": "vitamin E food",
				"salience": 0.0015555945,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.0015249478,
				"type": "OTHER"
			},
			{
				"name": "vitamin E requirements",
				"salience": 0.0015249478,
				"type": "OTHER"
			},
			{
				"name": "vitamin C",
				"salience": 0.0015218557,
				"type": "OTHER"
			},
			{
				"name": "vitamin c",
				"salience": 0.0015218557,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07rtrl7"
				},
				"name": "Swiss Chard",
				"salience": 0.0014806318,
				"type": "ORGANIZATION"
			},
			{
				"name": "vitamin A",
				"salience": 0.00146046,
				"type": "OTHER"
			},
			{
				"name": "folate",
				"salience": 0.00146046,
				"type": "OTHER"
			},
			{
				"name": "vitamin K",
				"salience": 0.00146046,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00146046,
				"type": "OTHER"
			},
			{
				"name": "folate",
				"salience": 0.00146046,
				"type": "OTHER"
			},
			{
				"name": "oils",
				"salience": 0.0014302802,
				"type": "OTHER"
			},
			{
				"name": "veggie",
				"salience": 0.001416544,
				"type": "OTHER"
			},
			{
				"name": "vitamin K",
				"salience": 0.0014059537,
				"type": "OTHER"
			},
			{
				"name": "vitamin A",
				"salience": 0.0014059537,
				"type": "OTHER"
			},
			{
				"name": "vitamin A",
				"salience": 0.0014059537,
				"type": "OTHER"
			},
			{
				"name": "vitamin K",
				"salience": 0.0014059537,
				"type": "OTHER"
			},
			{
				"name": "folate",
				"salience": 0.0014059537,
				"type": "OTHER"
			},
			{
				"name": "E. Avocados",
				"salience": 0.0013974734,
				"type": "OTHER"
			},
			{
				"name": "Plant oils",
				"salience": 0.0013768995,
				"type": "OTHER"
			},
			{
				"name": "plant seed oils",
				"salience": 0.0013768995,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "kale",
				"salience": 0.0013768995,
				"type": "OTHER"
			},
			{
				"name": "kale",
				"salience": 0.0013768995,
				"type": "OTHER"
			},
			{
				"name": "broccoli",
				"salience": 0.0013750676,
				"type": "OTHER"
			},
			{
				"name": "sandwiches",
				"salience": 0.0013186686,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0012906002,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0012906002,
				"type": "OTHER"
			},
			{
				"name": "nutrients",
				"salience": 0.0012906002,
				"type": "OTHER"
			},
			{
				"name": "cup",
				"salience": 0.0012817618,
				"type": "OTHER"
			},
			{
				"name": "vegetables",
				"salience": 0.0012694511,
				"type": "OTHER"
			},
			{
				"name": "health benefits",
				"salience": 0.0012694511,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.0012694511,
				"type": "OTHER"
			},
			{
				"name": "more",
				"salience": 0.0012612296,
				"type": "OTHER"
			},
			{
				"name": "taste",
				"salience": 0.0012478585,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0012255511,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0012166115,
				"type": "OTHER"
			},
			{
				"name": "vitamin C foods",
				"salience": 0.001207172,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vitamin E foods",
				"salience": 0.001207172,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.001207172,
				"type": "OTHER"
			},
			{
				"name": "Foods",
				"salience": 0.0011769433,
				"type": "OTHER"
			},
			{
				"name": "food high",
				"salience": 0.001171201,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0011649417,
				"type": "OTHER"
			},
			{
				"name": "oils",
				"salience": 0.0011600966,
				"type": "OTHER"
			},
			{
				"name": "rest",
				"salience": 0.0011418725,
				"type": "OTHER"
			},
			{
				"name": "plenty",
				"salience": 0.0011418725,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.001139215,
				"type": "OTHER"
			},
			{
				"name": "basis",
				"salience": 0.0010992504,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02r5_b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kale"
				},
				"name": "Kale",
				"salience": 0.0010921655,
				"type": "PERSON"
			},
			{
				"name": "papaya",
				"salience": 0.0010772835,
				"type": "OTHER"
			},
			{
				"name": "parsley",
				"salience": 0.0010403378,
				"type": "OTHER"
			},
			{
				"name": "option",
				"salience": 0.0009932054,
				"type": "OTHER"
			},
			{
				"name": "oil",
				"salience": 0.0009858079,
				"type": "OTHER"
			},
			{
				"name": "broccoli",
				"salience": 0.00096411887,
				"type": "OTHER"
			},
			{
				"name": "cooking",
				"salience": 0.00093218486,
				"type": "OTHER"
			},
			{
				"name": "tablespoon",
				"salience": 0.00093218486,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vitamin E",
				"salience": 0.0009155182,
				"type": "OTHER"
			},
			{
				"name": "Vitamin E",
				"salience": 0.0009155182,
				"type": "OTHER"
			},
			{
				"name": "foods",
				"salience": 0.0009017867,
				"type": "OTHER"
			},
			{
				"name": "food",
				"salience": 0.0009017867,
				"type": "OTHER"
			},
			{
				"name": "variety",
				"salience": 0.00089738634,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.0008906758,
				"type": "OTHER"
			},
			{
				"name": "papaya",
				"salience": 0.00084662106,
				"type": "OTHER"
			},
			{
				"name": "Olives",
				"salience": 0.00083595206,
				"type": "OTHER"
			},
			{
				"name": "salads",
				"salience": 0.0008041825,
				"type": "OTHER"
			},
			{
				"name": "sandwich",
				"salience": 0.0008041825,
				"type": "OTHER"
			},
			{
				"name": "salad",
				"salience": 0.0008041825,
				"type": "OTHER"
			},
			{
				"name": "pine nut oil",
				"salience": 0.0007364033,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "Avocado",
				"salience": 0.00071207096,
				"type": "OTHER"
			},
			{
				"name": "avocados",
				"salience": 0.00071207096,
				"type": "OTHER"
			},
			{
				"name": "dishes",
				"salience": 0.0006963423,
				"type": "OTHER"
			},
			{
				"name": "spice",
				"salience": 0.0006963423,
				"type": "OTHER"
			},
			{
				"name": "Vitamin-E kick",
				"salience": 0.0006963423,
				"type": "OTHER"
			},
			{
				"name": "generations",
				"salience": 0.0006963423,
				"type": "OTHER"
			},
			{
				"name": "guacamole",
				"salience": 0.0006963423,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0006618968,
				"type": "OTHER"
			},
			{
				"name": "list",
				"salience": 0.00064866716,
				"type": "OTHER"
			},
			{
				"name": "olives",
				"salience": 0.00064866716,
				"type": "OTHER"
			},
			{
				"name": "fruit",
				"salience": 0.00064866716,
				"type": "OTHER"
			},
			{
				"name": "olives",
				"salience": 0.00064866716,
				"type": "OTHER"
			},
			{
				"name": "favorite",
				"salience": 0.00062401313,
				"type": "OTHER"
			},
			{
				"name": "requirements",
				"salience": 0.0006197792,
				"type": "OTHER"
			},
			{
				"name": "thoughts",
				"salience": 0.00059049466,
				"type": "OTHER"
			},
			{
				"name": "snack",
				"salience": 0.00058566895,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.00058566895,
				"type": "OTHER"
			},
			{
				"name": "avocado",
				"salience": 0.0005595858,
				"type": "OTHER"
			},
			{
				"name": "Hazelnuts",
				"salience": 0.00052285317,
				"type": "OTHER"
			},
			{
				"name": "fruit smoothies",
				"salience": 0.0005071244,
				"type": "OTHER"
			},
			{
				"name": "ounce",
				"salience": 0.00048453853,
				"type": "OTHER"
			},
			{
				"name": "ounce",
				"salience": 0.00048453853,
				"type": "OTHER"
			},
			{
				"name": "hazelnuts",
				"salience": 0.00048453853,
				"type": "OTHER"
			},
			{
				"name": "nuts",
				"salience": 0.00048453853,
				"type": "OTHER"
			},
			{
				"name": "nuts",
				"salience": 0.00048453853,
				"type": "OTHER"
			},
			{
				"name": "hazelnut milk",
				"salience": 0.00048453853,
				"type": "OTHER"
			},
			{
				"name": "milk",
				"salience": 0.00048453853,
				"type": "OTHER"
			},
			{
				"name": "snack",
				"salience": 0.00043747717,
				"type": "OTHER"
			},
			{
				"name": "health benefits",
				"salience": 0.00043747717,
				"type": "OTHER"
			},
			{
				"name": "workday",
				"salience": 0.0003788033,
				"type": "EVENT"
			},
			{
				"name": "anything",
				"salience": 0.0003788033,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.0003788033,
				"type": "OTHER"
			},
			{
				"name": "creamer",
				"salience": 0.0003788033,
				"type": "PERSON"
			},
			{
				"name": "morning coffee",
				"salience": 0.0003788033,
				"type": "OTHER"
			},
			{
				"name": "alternative",
				"salience": 0.0003788033,
				"type": "OTHER"
			},
			{
				"name": "The Sleuth Journal",
				"salience": 0.00031209434,
				"type": "WORK_OF_ART"
			},
			{
				"name": "natures",
				"salience": 0.00029021825,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01vg5z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pine_nut"
				},
				"name": "Pine Nuts",
				"salience": 0.00020123902,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://s3-us-west-2.amazonaws.com/sleuthjournal/wp-content/uploads/2016/10/25142320/salad-with-nuts.jpg",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T16:33:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 24.8,
			"score": 0.3
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0.191",
		"text": "(Before It's News)\nWhat is Vitamin E? Vitamin E is an important fat-soluble antioxidant compound that aids the body in neutralizing the harmful after-effects of oxidation of fats. Current research is even looking into the important role that this vitamin plays in stopping free-radical production, a key method of preventing the development of chronic diseases and aging. It is also a vital element in the overall maintenance of a healthy immune system.\nSome studies are even looking into its role in preventing degenerative mental imbalances such as dementia and Alzheimer’s disease. And while many of us may do well in taking extra vitamin E supplements, we can use an organic diet to get a large amount of the daily requirements for this powerful antioxidant lipid. In fact, there are many common foods with vitamin E. You probably have a few in your house right now.\nFoods With Vitamin E\nHere are fifteen foods with vitamin E that you should strongly consider adding to your diet.\n1. Almonds\nAlmonds are one the best vitamin E foods. Just an ounce of almonds offers a whopping 7.4 milligrams of vitamin E. You can also get your vitamin E needs in the form of almond milk and almond oils. We would recommend eating raw almonds, if possible.\n2. Raw Seeds\nSelect raw seeds , such as sunflower, pumpkin and sesame, are another common food with vitamin E. In fact, eating just ¼ of a cup of sunflower seeds gives you 90.5% of your recommended daily value, making them one of the best vitamin E foods you can eat daily.\n3. Swiss Chard\nSwiss chard is easily one of the healthiest vegetables you can eat on a daily basis. Commonly known to be high in vitamin K, vitamin A and vitamin C, Swiss chard is another food high in vitamin E. Just one cup of boiled swiss chard greens will provide you with almost 17% of your daily recommended values.\n4. Mustard Greens\nSimilar to swiss chard, mustard greens are very nutrient dense and will provide a variety of health benefits. Not only are they one of the best vitamin E foods, but mustard greens are also high in vitamin K, vitamin A, folate , and vitamin c. Eating just one cup of boiled mustard greens contains about 14% of your daily dietary requirements. We would recommend eating organic mustard greens, if possible.\n5. Spinach\nSpinach may not be your favorite veggie, but it is one of the best leafy greens you can add to your diet. Not only is it one of the best calcium foods and naturally high in folate, it’s also one of the best vitamin E foods as well. Just one cup of boiled spinach will provide you with approximately 20% of your daily needs. Try adding fresh spinach to your sandwiches to make them extra healthy.\n6. Turnip Greens\nWhile turnip greens may have a slightly bitter taste, they are very high in many essential nutrients. Like the rest of the leafy greens on this list, just one cup will provide you with plenty of vitamin K, vitamin A, vitamin C and folate. Not to mention approximately 12% of your daily requirements of vitamin E.\n7. Kale\nKale is another great cruciferous vegetable you should eat as often as possible. Kale is very high in many nutrients, in fact, just one cup of boiled kale can give you almost 6% of your daily vitamin E requirements. We would recommend eating organic kale, if possible.\n8. Plant oils\nMost plant seed oils are very good sources for Vitamin E as well. The best oil with vitamin E is Wheat germ oil. In fact, one tablespoon of this oil holds 100% of your daily Vitamin E requirements. Sunflower oil is another excellent option, as it provides over 5 mg of the vitamin, and can easily be be used for cooking. Other great Vitamin-E-rich oils include hempseed oil, coconut oil, cottonseed oil (with almost 5 mg of vitamin E), olive oil and safflower oil. We would recommend only buying oils that are cold pressed unrefined and organic.\n9. Hazelnuts\nA perfect snack during a long workday, eating just one ounce of hazelnuts can provide you with approximately 20% of our daily requirements of vitamin E. For an alternative to eating nuts, try drinking hazelnut milk in your morning coffee instead of milk or flavored creamer.\n10. Pine Nuts\nAdd an ounce of these nuts to anything you please! One serving contains 2.6 mg of vitamin E. You can also use pine nut oil for added health benefits.\n11. Avocado\nPerhaps one of the tastiest foods with Vitamin E, avocados represent natures creamiest, oil-rich food. Just half of an avocado holds more than 2 mg of vitamin E. Avocados are very easy to incorporate into your diet. We would recommend adding sliced avocados to your salad, a sandwich, or mashed up as guacamole!\n12. Broccoli\nFor generations now, broccoli has been considered one of the best detox foods , but it’s also one of the healthiest foods high in Vitamin E. Just one cup of steamed broccoli will provide you with 4% of your daily requirements. Broccoli may not be as nutrient dense as other Vitamin E foods on this list, but it is definitely one of the healthiest foods you can eat daily.\n13. Parsley\nAn excellent spice, parsley is another great Vitamin E food. Try adding fresh parsley to salads and dishes for an extra Vitamin-E kick. Dried parsley will also provide you with this important vitamin, but the fresher the better.\n14. Papaya\nThis popular fruit is most commonly known as one of the best vitamin C foods , but it’s also high in Vitamin E. Just one papaya will give you approximately 17% of your daily needs. Try adding fresh or frozen papaya to fruit smoothies, along with other fruity vitamin E foods on this list for an extra healthy snack!\n15. Olives\nFrom the oil to the fruit, eating olives is an excellent way of getting your daily needs for vitamin E. Just one cup of olives can give you approximately 20% of your daily recommended amount.\nThese are just a few examples of foods with vitamin E. There are plenty more that aren’t listed here. Which vitamin E food is your favorite? Let’s hear your thoughts below.\nThe post 15 Foods That Contain The Most Vitamin E appeared first on The Sleuth Journal .",
		"thread_title": "15 Foods That Contain the Most Vitamin E | Alternative",
		"title": "15 Foods That Contain the Most Vitamin E | Alternative",
		"type": "bs",
		"uuid": "15717462e290b7dde656114e599fff78a39b7906"
	},
	"-KhIkGLzsXQR6nlwLAR6": {
		"author": "Enjoykin4",
		"comments": "0",
		"country": "US",
		"crawled": "2016-10-26T22:12:46.082+03:00",
		"domain_rank": "6659",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.22015412,
				"type": "LOCATION"
			},
			{
				"name": "Richard Hayden Black",
				"salience": 0.16703187,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.1413318,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.08398278,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.071292415,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al-Nusra Front",
				"salience": 0.017253604,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "al-Qaeda",
				"salience": 0.016045434,
				"type": "ORGANIZATION"
			},
			{
				"name": "agents",
				"salience": 0.012878777,
				"type": "PERSON"
			},
			{
				"name": "mercenaries",
				"salience": 0.011166222,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.010973622,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkish",
				"salience": 0.010300772,
				"type": "LOCATION"
			},
			{
				"name": "senator",
				"salience": 0.010191024,
				"type": "PERSON"
			},
			{
				"name": "senator",
				"salience": 0.008870048,
				"type": "PERSON"
			},
			{
				"name": "intervention",
				"salience": 0.008830602,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.007976501,
				"type": "LOCATION"
			},
			{
				"name": "US Supporting War",
				"salience": 0.0072544874,
				"type": "EVENT"
			},
			{
				"name": "member",
				"salience": 0.0070348247,
				"type": "PERSON"
			},
			{
				"name": "end",
				"salience": 0.0069105737,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0060899244,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.0048617953,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.0045127706,
				"type": "LOCATION"
			},
			{
				"name": "rebels",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.004080582,
				"type": "PERSON"
			},
			{
				"name": "war crimes",
				"salience": 0.003813544,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar al-Assad",
				"salience": 0.0036327117,
				"type": "PERSON"
			},
			{
				"name": "conduit",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"name": "missiles",
				"salience": 0.0035342656,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabia",
				"salience": 0.003227491,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.0031259996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02ss0n",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia_State_University"
				},
				"name": "Virginia State",
				"salience": 0.0030124336,
				"type": "ORGANIZATION"
			},
			{
				"name": "state senator",
				"salience": 0.0027174263,
				"type": "PERSON"
			},
			{
				"name": "investigation",
				"salience": 0.0026240167,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.0025480867,
				"type": "PERSON"
			},
			{
				"name": "Fatah al-Sham Front",
				"salience": 0.0025132094,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0024825821,
				"type": "EVENT"
			},
			{
				"name": "war veteran",
				"salience": 0.0024629512,
				"type": "PERSON"
			},
			{
				"name": "organizations",
				"salience": 0.0024428447,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0023809858,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0023533758,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.002253911,
				"type": "OTHER"
			},
			{
				"name": "Rececp Tayyip Erdogan",
				"salience": 0.0021354437,
				"type": "PERSON"
			},
			{
				"name": "militants",
				"salience": 0.0020152733,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0019586696,
				"type": "ORGANIZATION"
			},
			{
				"name": "forces",
				"salience": 0.0018618511,
				"type": "OTHER"
			},
			{
				"name": "interview",
				"salience": 0.0018618511,
				"type": "EVENT"
			},
			{
				"name": "treaty",
				"salience": 0.0017941934,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04hqz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lebanon"
				},
				"name": "Lebanon",
				"salience": 0.0017559086,
				"type": "LOCATION"
			},
			{
				"name": "terrorism",
				"salience": 0.0016910468,
				"type": "OTHER"
			},
			{
				"name": "terror group",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "part",
				"salience": 0.001681147,
				"type": "PERSON"
			},
			{
				"name": "same",
				"salience": 0.001681147,
				"type": "OTHER"
			},
			{
				"name": "defense intelligence agency",
				"salience": 0.001681147,
				"type": "ORGANIZATION"
			},
			{
				"name": "resistance",
				"salience": 0.0016736414,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0016390645,
				"type": "PERSON"
			},
			{
				"name": "advisers",
				"salience": 0.00156069,
				"type": "OTHER"
			},
			{
				"name": "army",
				"salience": 0.0014558146,
				"type": "ORGANIZATION"
			},
			{
				"name": "two",
				"salience": 0.0014558146,
				"type": "PERSON"
			},
			{
				"name": "countries",
				"salience": 0.0014439235,
				"type": "LOCATION"
			},
			{
				"name": "rhetoric",
				"salience": 0.0014193682,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.0013632216,
				"type": "OTHER"
			},
			{
				"name": "militants",
				"salience": 0.0013604575,
				"type": "PERSON"
			},
			{
				"name": "borders",
				"salience": 0.0013552397,
				"type": "LOCATION"
			},
			{
				"name": "women",
				"salience": 0.0013404513,
				"type": "PERSON"
			},
			{
				"name": "liberalization",
				"salience": 0.0013404513,
				"type": "OTHER"
			},
			{
				"name": "determination",
				"salience": 0.001315409,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0013055755,
				"type": "ORGANIZATION"
			},
			{
				"name": "border",
				"salience": 0.0013046638,
				"type": "LOCATION"
			},
			{
				"name": "ally",
				"salience": 0.0012807802,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0011788264,
				"type": "LOCATION"
			},
			{
				"name": "organization",
				"salience": 0.0011788264,
				"type": "ORGANIZATION"
			},
			{
				"name": "move",
				"salience": 0.0011348301,
				"type": "OTHER"
			},
			{
				"name": "militant groups",
				"salience": 0.0011348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.0010861581,
				"type": "PERSON"
			},
			{
				"name": "area",
				"salience": 0.0010738927,
				"type": "LOCATION"
			},
			{
				"name": "military forces",
				"salience": 0.0010658636,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0010658636,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.0010658636,
				"type": "ORGANIZATION"
			},
			{
				"name": "support",
				"salience": 0.0010658636,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "mood",
				"salience": 0.0010207847,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "guys",
				"salience": 0.0009826836,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "response",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "terrorist watch list",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0009826836,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0009763191,
				"type": "PERSON"
			},
			{
				"name": "terrorist movement",
				"salience": 0.0009623742,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00095024816,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02qvt0h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Press_TV"
				},
				"name": "Press TV",
				"salience": 0.00089613185,
				"type": "ORGANIZATION"
			},
			{
				"name": "axis of evil",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "quarters",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"name": "definition",
				"salience": 0.0008333383,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.00082736555,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0008228374,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0007962318,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0007962318,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.0007962318,
				"type": "LOCATION"
			},
			{
				"name": "threat",
				"salience": 0.0007921215,
				"type": "OTHER"
			},
			{
				"name": "alliance",
				"salience": 0.00078056013,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0697s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Qatar"
				},
				"name": "Qatar",
				"salience": 0.000780018,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.0007638783,
				"type": "LOCATION"
			},
			{
				"name": "ties",
				"salience": 0.00076255173,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "terrorism",
				"salience": 0.00074172363,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0007189118,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04wsz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Middle_East"
				},
				"name": "Middle East",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.000645346,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03__y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jordan"
				},
				"name": "Jordan",
				"salience": 0.00062829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07_nf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam_War"
				},
				"name": "Vietnam",
				"salience": 0.00062829,
				"type": "LOCATION"
			},
			{
				"name": "military",
				"salience": 0.0006277102,
				"type": "ORGANIZATION"
			},
			{
				"name": "regret",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0006225084,
				"type": "EVENT"
			},
			{
				"name": "nose",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "car",
				"salience": 0.0006225084,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "monarchy",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"name": "permission",
				"salience": 0.0006225084,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d6qjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Central_Intelligence_Agency"
				},
				"name": "CIA",
				"salience": 0.000604834,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000604834,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0005917158,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0005842586,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.00057988917,
				"type": "LOCATION"
			},
			{
				"name": "supporter",
				"salience": 0.00057988917,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.0005539948,
				"type": "LOCATION"
			},
			{
				"name": "newspaper",
				"salience": 0.00054144737,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0005235716,
				"type": "ORGANIZATION"
			},
			{
				"name": "mercenaries",
				"salience": 0.0005235716,
				"type": "PERSON"
			},
			{
				"name": "terrorists attack",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"name": "attacks",
				"salience": 0.0005235716,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/035qy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Greece"
				},
				"name": "Greece",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000512897,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemenis",
				"salience": 0.00049005507,
				"type": "PERSON"
			},
			{
				"name": "military",
				"salience": 0.00046888966,
				"type": "ORGANIZATION"
			},
			{
				"name": "press",
				"salience": 0.00046888966,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.00045756705,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "action",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "philosophy",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "bombing",
				"salience": 0.00045335607,
				"type": "EVENT"
			},
			{
				"name": "matter",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "portrayal",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00045335607,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004331652,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.00042434287,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIL",
				"salience": 0.00038829033,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00038311988,
				"type": "PERSON"
			},
			{
				"name": "power",
				"salience": 0.00037008524,
				"type": "OTHER"
			},
			{
				"name": "institution",
				"salience": 0.00034296451,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07_m9_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Adolf_Hitler"
				},
				"name": "Adolf Hilter",
				"salience": 0.00034050574,
				"type": "PERSON"
			},
			{
				"name": "iron fist",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "constitution",
				"salience": 0.00033864164,
				"type": "WORK_OF_ART"
			},
			{
				"name": "resurrection",
				"salience": 0.00033864164,
				"type": "OTHER"
			},
			{
				"name": "front yard",
				"salience": 0.00033864164,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/014_6h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wahhabism"
				},
				"name": "Wahhabism",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00032222297,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0177z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brussels"
				},
				"name": "Brussels",
				"salience": 0.0002790059,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottoman_Empire"
				},
				"name": "Ottoman Empire",
				"salience": 0.00020840293,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0852h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_Europe"
				},
				"name": "Western Europe",
				"salience": 0.00020840293,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://www.mydailyinformer.com/wp-content/uploads/2016/10/19B1E9B9000005DC-0-image-a-23_1454516481817.jpg",
		"ord_in_thread": "3",
		"participants_count": "4",
		"published": "2016-10-26T15:20:00.000+03:00",
		"replies_count": "5",
		"sentiment": {
			"magnitude": 10.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "beforeitsnews.com",
		"spam_score": "0",
		"text": "A leading US senator: US Supporting War in Syria\nA leading US senator said the war in Syria would have been over by now if the US had put an end to its intervention when Russia entered the war-ravaged country.\n“If the United States had just stayed out of it at that point, the war would be over by now; people would be rebuilding, refugees would be returning back to Syria, but the United States rushed anti-Tank missiles, and we used these so-called moderate rebels as a conduit to supply al-Nusra Front (also known as Fatah al-Sham Front), which is al-Qaeda in Syria,” republican member of the Virginia State in US Senate, Richard Hayden Black said in an exclusive interview with Press TV.\n“If we were not supporting the war in Syria, I believe that the Syrians, combined with their allied forces from Iran, Lebanon and Russia… would move very steadily and restore the borders of Syria.”\nThe senate member, who visited Syria in April, refused to distinguish between militants and terrorists fighting the government of President Bashar al-Assad, saying, the two are “thoroughly integrated.”\n“They really are one and the same, they’re part of the same army,” he said, citing a US defense intelligence agency’s investigation in 2013, which showed Washington’s ties with the terror group.\nThe outspoken state senator referred to plans by the CIA to transfer arms from Libya to Turkey and from there to Syria to supply the militants, noting that the move “evolved into an indiscriminate program of supplying all militant groups, including specifically ISIL and al-Qaeda.”\n“We do it indirectly because it’s unlawful to do it directly,” he said, adding that the US keeps “extremely violent organizations… off the terrorist watch list because these are the agents that take our weapons and then distribute them to ISIL and al-Qaeda.”\nIn response to a question on why Iran and Russia are portrayed as the “bad guys,” while they are the ones really fighting terrorism there, as put recently by GOP presidential candidate Donald Trump, Black said the Republican candidate has a “clear understanding of what’s happening over there.”\n“Sometimes, his rhetoric has to match the political mood of the moment… but I know a number of his advisers and they believe that our determination to topple the government in Syria is suicidal, that it threatens not only the entire Middle East but literally the entire world.”\nHe further warned that the US itself could be “threatened,” arguing that, “if Syria falls, it will be dominated by some al-Qaeda-related organization; Lebanon will fall; Jordan will fall and the entire area will be destabilized.”\nThe Vietnam war veteran also elaborated on his personal definition of the Middle East “axis of evil,” naming Qatar, Saudi Arabia, and “particularly” Turkey over their support for terrorism.\n“Probably, three quarters of the rebels are not Syrian at all, they are mercenaries recruited by Turkey, Qatar and Saudi Arabia,” he asserted, describing the three countries as “the primary force behind the terrorist movement.”\n“Turkey has invaded Iraq and Syria with heavy military forces. Turkey has really become a rogue nation,” he added, referring to a 1923 treaty that set the border between Turkey and Greece, saying that was even being questioned by President Rececp Tayyip Erdogan.\n“And now you see this emerging threat against Western Europe by Turkey,” he noted, further adding that Erdogan “has made it clear that he looks to resurrection of the Ottoman Empire.”\n“He has become more and more aggressive; he’s crushed the military, the free press; every powerful institution of the Turkish government has come under his iron fist and he’s now a total dictator. He’s a man who has said that he wants the constitution amended so that he will have power similar to those of Adolf Hilter… This is our great ally; we’re allied with a man who would be Hitler.”\nHe also blasted Washington’s alliance with Saudi Arabia, “where women are not allowed to walk out in the front yard to pick up the newspaper without a man’s permission; they can’t drive a car!”\n“Somehow, this is part of the liberalization that we seek to impose on the Middle East,” he said ironically, calling it “bizarre.”\nHe also praised the resistance against the Saudi aggression by the people of Yemen, saying, “God bless them! The Yemenis are giving the Saudis a bloody nose,” despite being a “tiny little, poor nation.”\n“I think the world recognizes that Saudi Arabia has just embarked in massive war crimes in Yemen,” he said, voicing regret over the US support for the monarchy.\n“We don’t pay too much attention to them while engaged in war crimes because they’re our good allies,” he said, concluding that Washington is on a “suicidal course of action.”\n“Saudi money pays the very top politicians in many Western nations. And they really have co-opted the American military into acting as mercenaries for Wahhabism.”Black referred to the Western media’s portrayal of Iran as a supporter of terrorism, saying, “The fact of the matter is that if you really look at global terrorism, it all emanates from Saudi Arabia.”\nHe exemplified various terrorists attack, including the 9/11, the Boston bombing, and the Brussels attacks, noting that they are all a “reflection of the Wahhabi philosophy.”",
		"thread_title": "Red Warning – Nuclear Attack Russian Surprise for US Military – Surrounded USA NATO Military Drills on Russian Border – Putin Issues a Ultimatum to the United States | Self-Sufficiency",
		"title": "",
		"type": "bs",
		"uuid": "330d4115803322d82e1dec1a5207a789c1fab3c6"
	},
	"-KhIkGe5ihrG5-vGGyCr": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-11-05T03:00:44.619+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "landscaper",
				"salience": 0.2061509,
				"type": "PERSON"
			},
			{
				"name": "Chris Richards",
				"salience": 0.10844776,
				"type": "PERSON"
			},
			{
				"name": "PHOTO",
				"salience": 0.067572966,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/034vc9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brad_Richards"
				},
				"name": "Richards",
				"salience": 0.031156907,
				"type": "PERSON"
			},
			{
				"name": "wickets",
				"salience": 0.026500268,
				"type": "OTHER"
			},
			{
				"name": "Kayla",
				"salience": 0.023118677,
				"type": "PERSON"
			},
			{
				"name": "This Post",
				"salience": 0.019560738,
				"type": "PERSON"
			},
			{
				"name": "IMRAN GASHKORI",
				"salience": 0.019560738,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.019560738,
				"type": "OTHER"
			},
			{
				"name": "summer cricket",
				"salience": 0.018744962,
				"type": "OTHER"
			},
			{
				"name": "backyard cricket",
				"salience": 0.018744962,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06_c5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Shane_Warne"
				},
				"name": "Warnie",
				"salience": 0.016702987,
				"type": "PERSON"
			},
			{
				"name": "preparation",
				"salience": 0.016241947,
				"type": "OTHER"
			},
			{
				"name": "beers",
				"salience": 0.016241947,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "tradition",
				"salience": 0.016241947,
				"type": "OTHER"
			},
			{
				"name": "excitement",
				"salience": 0.016241947,
				"type": "OTHER"
			},
			{
				"name": "Sports Editor",
				"salience": 0.016241947,
				"type": "PERSON"
			},
			{
				"name": "rabbit",
				"salience": 0.014767355,
				"type": "OTHER"
			},
			{
				"name": "Wynnum",
				"salience": 0.011558398,
				"type": "LOCATION"
			},
			{
				"name": "wickets",
				"salience": 0.011519625,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/091blj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Luke_Darcy"
				},
				"name": "Darcy",
				"salience": 0.011006951,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australian",
				"salience": 0.010012291,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jt0lm_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jacob"
				},
				"name": "Jacob",
				"salience": 0.009214913,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.008639787,
				"type": "PERSON"
			},
			{
				"name": "spell",
				"salience": 0.0081383055,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0077364864,
				"type": "PERSON"
			},
			{
				"name": "kids",
				"salience": 0.0077364864,
				"type": "PERSON"
			},
			{
				"name": "wickie",
				"salience": 0.0073977234,
				"type": "OTHER"
			},
			{
				"name": "Dad",
				"salience": 0.0073069055,
				"type": "PERSON"
			},
			{
				"name": "best",
				"salience": 0.0070487782,
				"type": "OTHER"
			},
			{
				"name": "ball",
				"salience": 0.0069390717,
				"type": "OTHER"
			},
			{
				"name": "ball",
				"salience": 0.0069390717,
				"type": "OTHER"
			},
			{
				"name": "Johno",
				"salience": 0.0069222553,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.0067006517,
				"type": "OTHER"
			},
			{
				"name": "ages",
				"salience": 0.0067006517,
				"type": "OTHER"
			},
			{
				"name": "street",
				"salience": 0.0067006517,
				"type": "LOCATION"
			},
			{
				"name": "wife",
				"salience": 0.0067006517,
				"type": "PERSON"
			},
			{
				"name": "ball",
				"salience": 0.0066804155,
				"type": "OTHER"
			},
			{
				"name": "Neighbours",
				"salience": 0.0063696876,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0063696876,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tape",
				"salience": 0.006322121,
				"type": "OTHER"
			},
			{
				"name": "toss",
				"salience": 0.006170202,
				"type": "OTHER"
			},
			{
				"name": "tape",
				"salience": 0.006009822,
				"type": "OTHER"
			},
			{
				"name": "tape",
				"salience": 0.005785747,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "by-law",
				"salience": 0.005637082,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.005426883,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0052245115,
				"type": "OTHER"
			},
			{
				"name": "rules",
				"salience": 0.0052245115,
				"type": "OTHER"
			},
			{
				"name": "addition",
				"salience": 0.004699871,
				"type": "OTHER"
			},
			{
				"name": "half",
				"salience": 0.0045245755,
				"type": "OTHER"
			},
			{
				"name": "scalps",
				"salience": 0.0045245755,
				"type": "OTHER"
			},
			{
				"name": "backyard pitch",
				"salience": 0.0045245755,
				"type": "OTHER"
			},
			{
				"name": "duration",
				"salience": 0.0045245755,
				"type": "OTHER"
			},
			{
				"name": "match",
				"salience": 0.0045245755,
				"type": "EVENT"
			},
			{
				"name": "bowling style",
				"salience": 0.0038373712,
				"type": "OTHER"
			},
			{
				"name": "array",
				"salience": 0.0038373712,
				"type": "OTHER"
			},
			{
				"name": "sledges",
				"salience": 0.0038373712,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.0038373712,
				"type": "OTHER"
			},
			{
				"name": "skin",
				"salience": 0.0038373712,
				"type": "OTHER"
			},
			{
				"name": "opposition team",
				"salience": 0.0038373712,
				"type": "ORGANIZATION"
			},
			{
				"name": "poofter",
				"salience": 0.0036702973,
				"type": "PERSON"
			},
			{
				"name": "Wickets",
				"salience": 0.003639202,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "one",
				"salience": 0.0033107402,
				"type": "OTHER"
			},
			{
				"name": "balls",
				"salience": 0.003084199,
				"type": "OTHER"
			},
			{
				"name": "kid",
				"salience": 0.003054585,
				"type": "PERSON"
			},
			{
				"name": "crease",
				"salience": 0.0028669883,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.0026570058,
				"type": "OTHER"
			},
			{
				"name": "wicket",
				"salience": 0.0025518981,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0024115087,
				"type": "OTHER"
			},
			{
				"name": "dismissals",
				"salience": 0.0024007396,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0m9m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Ashes"
				},
				"name": "The Ashes",
				"salience": 0.0023925032,
				"type": "WORK_OF_ART"
			},
			{
				"name": "balls",
				"salience": 0.0023041526,
				"type": "OTHER"
			},
			{
				"name": "reporting",
				"salience": 0.0020882136,
				"type": "OTHER"
			},
			{
				"name": "stumps",
				"salience": 0.0020882136,
				"type": "OTHER"
			},
			{
				"name": "boys",
				"salience": 0.0020882136,
				"type": "PERSON"
			},
			{
				"name": "Responses",
				"salience": 0.0017485521,
				"type": "OTHER"
			},
			{
				"name": "Brisbane Dad Takes 7 Backyard",
				"salience": 0.0016439828,
				"type": "LOCATION"
			},
			{
				"name": "mo",
				"salience": 0.0015599583,
				"type": "OTHER"
			},
			{
				"name": "whinge",
				"salience": 0.0015599583,
				"type": "OTHER"
			},
			{
				"name": "detractors",
				"salience": 0.0015599583,
				"type": "PERSON"
			},
			{
				"name": "criticism",
				"salience": 0.0015599583,
				"type": "OTHER"
			},
			{
				"name": "3rd grader",
				"salience": 0.0013568428,
				"type": "PERSON"
			},
			{
				"name": "Wynnum Advertiser",
				"salience": 0.0012853026,
				"type": "ORGANIZATION"
			},
			{
				"name": "Frightening Return To Form",
				"salience": 0.0012853026,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/05d3l1z"
				},
				"name": "Greg",
				"salience": 0.0012853026,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.0011506062,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/098cxc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mitchell_Johnson_(cricketer)"
				},
				"name": "Mitchell Johnson",
				"salience": 0.0011088017,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-05T03:00:44.619+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 10.5,
			"score": 0.2
		},
		"shares": "0",
		"site_url": "betootaadvocate.com",
		"spam_score": "0",
		"text": "Follow on Facebook Print This Post \nIMRAN GASHKORI | Sports Editor | \nAs excitement for summer cricket builds, Wynnum father Chris Richards has honed his preparation, taking 7 wickets in a “frightening” spell yesterday. \n“They were coming out perfectly,” the 36-year-old said between celebratory beers. The Australian tradition of backyard cricket has gotten much more competitive in recent years. PHOTO: Supplied. \n“Warnie always said one brings two… In this case I went further,” he said. \nThe full-time landscaper took the wickets of his three kids (aged 5, 8 & 13) as well as his wife (32) and two kids from down the street (ages unknown). \n“I was a pretty talented junior but my best was only three or four for,” he said. \nRichards claimed the scalps in just four overs on his 16-meter backyard pitch aided by generous electric wickie rules and the controversial one-hand-one-bounce law. Richards vehemently denies that he tampered with the ball, despite half of it being covered in a mysterious tape for the duration of the match. PHOTO: Supplied. \nHowever, video has emerged of Richards allegedly tampering with the ball with what seems like red electrical tape. \n“The tape was already on the ball before we started playing. That’s well within the rules,” he said. \nNeighbours described his spell as “frightening and intense” but added numerous dismissals were through the six-and-out by-law. \nIn addition to his economical and wicket-to-wicket line-and-length bowling style, Richards also used an impressive array of sledges and other psychological tactics to get under the skin of the opposition team. \nHis daughter Kayla explains. \n“Dad would dip one in short and I’d have to dive out-of-the-way,” she said. \n“Every time I tried to dodge the short balls, he’d call me a poofter, which doesn’t make any sense to me,” \nDespite the criticism levelled against him, Richards has lashed out at his detractors. \n“You don’t hear Johno (Mitchell Johnson) whinge about how he takes ’em” the one-time 3rd grader said. \n“I’m already growing the mo’ so I can steam in with him when The Ashes start.” \n“I played it smart. Me boy Jacob (aged 8 ) Is a pretty timid kid. I knew after knocking over Darcy (aged 5) with a full toss that he would be pretty nervous at the crease. I banged the first one in short to get him backing away. He was a frightened rabbit after that. All I had to do was put the next one on the stumps. Seven balls later I had his wicket.” \nWith additional reporting from the Wynnum Advertiser. \n2 Responses to \" Brisbane Dad Takes 7 Backyard Wickets In “Frightening Return To Form” \" Greg July 6, 2015 at 5:08 pm \nBest one yet boys, keep it up",
		"thread_title": "Brisbane Dad Takes 7 Backyard Wickets In â€œFrightening Return To Formâ€",
		"title": "Brisbane Dad Takes 7 Backyard Wickets In â€œFrightening Return To Formâ€",
		"type": "bs",
		"uuid": "a0195fe7cc9a6a07c0a5a4add5ddb19fa32b7336"
	},
	"-KhIkGuLxiuJ3qNTZm9G": {
		"author": "",
		"comments": "0",
		"country": "AU",
		"crawled": "2016-11-08T09:15:01.745+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "maintenance workers",
				"salience": 0.10774036,
				"type": "PERSON"
			},
			{
				"name": "Ronnie Austin",
				"salience": 0.07814794,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.06254568,
				"type": "PERSON"
			},
			{
				"name": "jobs",
				"salience": 0.05929256,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/055fzc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Carlton_%26_United_Breweries"
				},
				"name": "Carlton & United Breweries",
				"salience": 0.04741554,
				"type": "ORGANIZATION"
			},
			{
				"name": "boycott",
				"salience": 0.035511795,
				"type": "OTHER"
			},
			{
				"name": "Print",
				"salience": 0.03135984,
				"type": "OTHER"
			},
			{
				"name": "boys",
				"salience": 0.028319603,
				"type": "PERSON"
			},
			{
				"name": "movement",
				"salience": 0.02579911,
				"type": "OTHER"
			},
			{
				"name": "unaustralian",
				"salience": 0.02238566,
				"type": "OTHER"
			},
			{
				"name": "CLANCY",
				"salience": 0.01936507,
				"type": "PERSON"
			},
			{
				"name": "OVERELL",
				"salience": 0.01936507,
				"type": "PERSON"
			},
			{
				"name": "This Post",
				"salience": 0.01936507,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.01936507,
				"type": "OTHER"
			},
			{
				"name": "Unions",
				"salience": 0.019149242,
				"type": "ORGANIZATION"
			},
			{
				"name": "ringers",
				"salience": 0.016079718,
				"type": "OTHER"
			},
			{
				"name": "punters",
				"salience": 0.016079718,
				"type": "PERSON"
			},
			{
				"name": "Editor",
				"salience": 0.016079718,
				"type": "PERSON"
			},
			{
				"name": "products",
				"salience": 0.016079718,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "camp",
				"salience": 0.016079718,
				"type": "EVENT"
			},
			{
				"name": "heights",
				"salience": 0.016079718,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0chghy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia"
				},
				"name": "Australia",
				"salience": 0.011605221,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/016tzn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sauvignon_blanc"
				},
				"name": "Sauvignon Blanc",
				"salience": 0.011443188,
				"type": "OTHER"
			},
			{
				"name": "Carlton United Brewery",
				"salience": 0.011443188,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g39h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Queensland"
				},
				"name": "Queensland",
				"salience": 0.009912561,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/042d8w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Channel_Country"
				},
				"name": "Channel Country",
				"salience": 0.009912561,
				"type": "LOCATION"
			},
			{
				"name": "palate",
				"salience": 0.008173848,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.007810547,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0076595033,
				"type": "OTHER"
			},
			{
				"name": "passionfruit",
				"salience": 0.00762535,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.0072559286,
				"type": "OTHER"
			},
			{
				"name": "blokes",
				"salience": 0.0069786594,
				"type": "PERSON"
			},
			{
				"name": "any",
				"salience": 0.0066340063,
				"type": "OTHER"
			},
			{
				"name": "beer brands",
				"salience": 0.0066340063,
				"type": "ORGANIZATION"
			},
			{
				"name": "showing",
				"salience": 0.0066340063,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.0066340063,
				"type": "PERSON"
			},
			{
				"name": "men",
				"salience": 0.0063063432,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.005925192,
				"type": "PERSON"
			},
			{
				"name": "brainer",
				"salience": 0.0059193894,
				"type": "OTHER"
			},
			{
				"name": "supporter",
				"salience": 0.005372938,
				"type": "PERSON"
			},
			{
				"name": "shearing contractors",
				"salience": 0.005172582,
				"type": "PERSON"
			},
			{
				"name": "machine maintenance contract",
				"salience": 0.005172582,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.005046695,
				"type": "PERSON"
			},
			{
				"name": "demons",
				"salience": 0.0046531674,
				"type": "OTHER"
			},
			{
				"name": "crook",
				"salience": 0.0046531674,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0046531674,
				"type": "OTHER"
			},
			{
				"name": "entitlements",
				"salience": 0.004479617,
				"type": "OTHER"
			},
			{
				"name": "wage",
				"salience": 0.004479617,
				"type": "OTHER"
			},
			{
				"name": "penalty rates",
				"salience": 0.004479617,
				"type": "OTHER"
			},
			{
				"name": "employer",
				"salience": 0.004479617,
				"type": "ORGANIZATION"
			},
			{
				"name": "mates",
				"salience": 0.004479617,
				"type": "PERSON"
			},
			{
				"name": "anyone",
				"salience": 0.0042526065,
				"type": "PERSON"
			},
			{
				"name": "workers unions",
				"salience": 0.004223465,
				"type": "ORGANIZATION"
			},
			{
				"name": "#CUB55",
				"salience": 0.004085337,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/087csb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Betoota,_Queensland"
				},
				"name": "Betoota",
				"salience": 0.004036802,
				"type": "LOCATION"
			},
			{
				"name": "cattle",
				"salience": 0.0038162882,
				"type": "OTHER"
			},
			{
				"name": "duty",
				"salience": 0.003799253,
				"type": "OTHER"
			},
			{
				"name": "fruit flavours",
				"salience": 0.003799253,
				"type": "OTHER"
			},
			{
				"name": "citrus",
				"salience": 0.003799253,
				"type": "OTHER"
			},
			{
				"name": "CUB 55",
				"salience": 0.0036485498,
				"type": "PERSON"
			},
			{
				"name": "acidity",
				"salience": 0.0035880778,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0035210648,
				"type": "EVENT"
			},
			{
				"name": "heads",
				"salience": 0.003277861,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0032252874,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0028385215,
				"type": "OTHER"
			},
			{
				"name": "wine",
				"salience": 0.0028385215,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "fact",
				"salience": 0.0028385215,
				"type": "OTHER"
			},
			{
				"name": "Quant",
				"salience": 0.0027579672,
				"type": "PERSON"
			},
			{
				"name": "E.H Pearson Cattle Company",
				"salience": 0.0027579672,
				"type": "ORGANIZATION"
			},
			{
				"name": "Jacob's Creek Sauvignon Blanc",
				"salience": 0.0027009817,
				"type": "PERSON"
			},
			{
				"name": "boycott",
				"salience": 0.0026442723,
				"type": "OTHER"
			},
			{
				"name": "CUB Boycott",
				"salience": 0.0026352012,
				"type": "ORGANIZATION"
			},
			{
				"name": "New Years Eve Rodeo",
				"salience": 0.0023007886,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.002288199,
				"type": "OTHER"
			},
			{
				"name": "doctor",
				"salience": 0.0020674868,
				"type": "PERSON"
			},
			{
				"name": "cultures",
				"salience": 0.0020674868,
				"type": "OTHER"
			},
			{
				"name": "state borders",
				"salience": 0.0020674868,
				"type": "OTHER"
			},
			{
				"name": "marching",
				"salience": 0.0020674868,
				"type": "OTHER"
			},
			{
				"name": "hipster musicians",
				"salience": 0.0020674868,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02sxmf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mount_Isa"
				},
				"name": "Isa",
				"salience": 0.0020178126,
				"type": "LOCATION"
			},
			{
				"name": "Rocko",
				"salience": 0.0017472752,
				"type": "PERSON"
			},
			{
				"name": "calendars",
				"salience": 0.0015444783,
				"type": "OTHER"
			},
			{
				"name": "mess",
				"salience": 0.0015444783,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0015444783,
				"type": "EVENT"
			},
			{
				"name": "finish",
				"salience": 0.0015444783,
				"type": "OTHER"
			},
			{
				"name": "length",
				"salience": 0.0015444783,
				"type": "OTHER"
			},
			{
				"name": "drink",
				"salience": 0.0015444783,
				"type": "OTHER"
			},
			{
				"name": "choice",
				"salience": 0.0015444783,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07_py",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Victoria_Bitter"
				},
				"name": "VB",
				"salience": 0.0012725496,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01b8jj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Brisbane"
				},
				"name": "Brisbane",
				"salience": 0.0012725496,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03nsrzn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Melbourne_Bitter"
				},
				"name": "Melbourne Bitter",
				"salience": 0.0012725496,
				"type": "ORGANIZATION"
			},
			{
				"name": "vibrancy",
				"salience": 0.0012608396,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02sxmf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mount_Isa"
				},
				"name": "Mount Isa",
				"salience": 0.0010978009,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-08T09:15:01.745+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 5.9,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "betootaadvocate.com",
		"spam_score": "0.039",
		"text": "Follow on Facebook Print This Post \nCLANCY OVERELL | Editor | CONTACT \nThe nationwide boycott of all Carlton United Brewery products reached new heights over the weekend, after it was revealed that a camp of ringers in Queensland’s Channel Country have only been drinking Sauvignon Blanc for the last five weeks. \nThey join a growing political movement of punters that are abstaining from drinking any of Australia’s highest-selling beer brands, in a showing of support for 55 workers who lost their jobs at Carlton & United Breweries (CUB) in June. These men and women are also known as the #CUB55. \nThe maintenance workers lost their jobs after CUB terminated a machine maintenance contract with employer Quant, they were then offered their jobs back again at a 65% lower wage, after penalty rates and other entitlements. \nE.H Pearson Cattle Company ‘s head stockman, Ronnie Austin says although he and his mates often punch on with the unionised Betoota shearing contractors, joining the CUB Boycott was a “no fucking brainer”. \n“I’m usually not a big supporter of the Unions, but you can’t carry on the way these blokes have been” \n“It’s fucking crook, mate” \nAustin says it’s been hard work trying to avoid getting stuck into a few green demons at knock off after pushing cattle all day, but it’s their duty as fellow workers to support the CUB 55. \n“It’s been tough. But we are all starting to get around the lively fruit flavours of the Jacob’s Creek Sauvignon Blanc” \n“The passionfruit and citrus prevail across the palate, which is pretty much enhanced by the fresh natural acidity which provides vibrancy and length on the finish” \nWith the Mount Isa New Years Eve Rodeo as the next big event pencilled in on their calendars, Austin says the Betoota boys are prepared to throw down with anyone who questions their choice of drink. \n“If CUB haven’t sorted this mess out by then, well yes of course we will still be drinking white wine on New Years Eve” \n“If anyone has problem with it then they can come and talk to me and Rocko. It won’t be the first time we’ve had to bust heads in the Isa” \n“In fact anyone who wants to drink VB around me better have a note from their doctor because It’s just bloody unaustralian” \nIt seems the CUB boycott has travelled across all cultures and state borders in Australia, with workers unions in Brisbane marching as well as hipster musicians now being forced to choose between supported the workers and drinking Melbourne Bitter ironically. \n",
		"thread_title": "Western QLD Drovers Show Solidarity With C.U.B Workers By Only Drinking Sauv Blanc – The Betoota Advocate",
		"title": "Western QLD Drovers Show Solidarity With C.U.B Workers By Only Drinking Sauv Blanc – The Betoota Advocate",
		"type": "bs",
		"uuid": "8ec4b91eeb8ec533f2d14ae2508d3adc24da9c82"
	},
	"-KhIkH1_NDtyqS33Rzbf": {
		"author": "",
		"comments": "0",
		"country": "GB",
		"crawled": "2016-11-21T01:14:48.043+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/02cdqb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ricky_Ponting"
				},
				"name": "Ricky Ponting",
				"salience": 0.13179848,
				"type": "PERSON"
			},
			{
				"name": "Print",
				"salience": 0.0665741,
				"type": "OTHER"
			},
			{
				"name": "Kids",
				"salience": 0.054170463,
				"type": "PERSON"
			},
			{
				"name": "batting performance",
				"salience": 0.052192174,
				"type": "OTHER"
			},
			{
				"name": "CLANCY",
				"salience": 0.04126848,
				"type": "PERSON"
			},
			{
				"name": "OVERELL",
				"salience": 0.04126848,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02y1vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Facebook"
				},
				"name": "Facebook",
				"salience": 0.04126848,
				"type": "OTHER"
			},
			{
				"name": "This Post",
				"salience": 0.04126848,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nation",
				"salience": 0.03955778,
				"type": "LOCATION"
			},
			{
				"name": "blame",
				"salience": 0.03430329,
				"type": "OTHER"
			},
			{
				"name": "town planners",
				"salience": 0.03430329,
				"type": "PERSON"
			},
			{
				"name": "wake",
				"salience": 0.03430329,
				"type": "OTHER"
			},
			{
				"name": "Editor",
				"salience": 0.03430329,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/020wyp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Australia_national_cricket_team"
				},
				"name": "Australian",
				"salience": 0.017916437,
				"type": "LOCATION"
			},
			{
				"name": "talent",
				"salience": 0.014743954,
				"type": "OTHER"
			},
			{
				"name": "Test",
				"salience": 0.014195562,
				"type": "EVENT"
			},
			{
				"name": "majority",
				"salience": 0.014195562,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.014195562,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.013074028,
				"type": "PERSON"
			},
			{
				"name": "number",
				"salience": 0.013074028,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0124169225,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.011501778,
				"type": "LOCATION"
			},
			{
				"name": "cricket",
				"salience": 0.011501778,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.011073594,
				"type": "LOCATION"
			},
			{
				"name": "players",
				"salience": 0.010797004,
				"type": "PERSON"
			},
			{
				"name": "capital cities",
				"salience": 0.009963285,
				"type": "LOCATION"
			},
			{
				"name": "bit",
				"salience": 0.009963285,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.009963285,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.009592219,
				"type": "OTHER"
			},
			{
				"name": "club",
				"salience": 0.009592219,
				"type": "ORGANIZATION"
			},
			{
				"name": "concerns",
				"salience": 0.009592219,
				"type": "OTHER"
			},
			{
				"name": "grid",
				"salience": 0.009592219,
				"type": "OTHER"
			},
			{
				"name": "housing developments",
				"salience": 0.009592219,
				"type": "OTHER"
			},
			{
				"name": "apartments",
				"salience": 0.009592219,
				"type": "LOCATION"
			},
			{
				"name": "coaching levels",
				"salience": 0.009592219,
				"type": "OTHER"
			},
			{
				"name": "dad",
				"salience": 0.008137138,
				"type": "PERSON"
			},
			{
				"name": "OLED television",
				"salience": 0.008137138,
				"type": "OTHER"
			},
			{
				"name": "hole",
				"salience": 0.008137138,
				"type": "OTHER"
			},
			{
				"name": "grandpas ashes",
				"salience": 0.0069023483,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.00631685,
				"type": "OTHER"
			},
			{
				"name": "elevator",
				"salience": 0.006081353,
				"type": "OTHER"
			},
			{
				"name": "arm",
				"salience": 0.006081353,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/05dgt4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sheffield_Shield"
				},
				"name": "Shield",
				"salience": 0.0059089237,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "kids",
				"salience": 0.005665541,
				"type": "PERSON"
			},
			{
				"name": "players",
				"salience": 0.005181183,
				"type": "PERSON"
			},
			{
				"name": "email address",
				"salience": 0.0049657063,
				"type": "OTHER"
			},
			{
				"name": "window",
				"salience": 0.004841464,
				"type": "OTHER"
			},
			{
				"name": "Tweets",
				"salience": 0.0044305613,
				"type": "WORK_OF_ART"
			},
			{
				"name": "neighbours",
				"salience": 0.0044305613,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0038226193,
				"type": "LOCATION"
			},
			{
				"name": "game",
				"salience": 0.0033103288,
				"type": "EVENT"
			},
			{
				"name": "mantlepiece",
				"salience": 0.0033103288,
				"type": "OTHER"
			},
			{
				"name": "Watson",
				"salience": 0.002037798,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-21T01:14:48.043+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 4.8,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "betootaadvocate.com",
		"spam_score": "0",
		"text": "Follow on Facebook Print This Post \nCLANCY OVERELL | Editor | CONTACT \nFormer Australian cricket captain, Ricky Ponting, has put the blame squarely on our nation’s town planners in the wake of another “very, very poor batting performance” that led to a heavy second Test defeat. \n“How do we expect to find any young talent when majority of our countries junior players are growing up in apartments? Or worse off the grid housing developments?” Amid concerns about coaching levels and the strength of club and Shield cricket, Ponting says we need to focus on decentralising our nation’s capital cities, so that kids ‘can grow up with a bit of space’. “Kids don’t learn how to knock them if they’ve got to constantly be worried about putting a hole through dad’s OLED television” “Or knocking grandpas ashes off the mantlepiece” \nPonting warned Australia’s current players are starting to make Watson look tough, while the game in this country had been weakened by a rising number of children that have to use an elevator before they can even find a fucking drive way to roll the arm over. \n“It’s ridiculous. In my day we didn’t even have a neighbours window to worry about. This kids are too crammed” Leave a Reply Your email address will not be published. Our latest Tweets!",
		"thread_title": "Rising Number Of Kids Growing Up Without Backyards Blamed For Aussie Cricket Slump",
		"title": "Rising Number Of Kids Growing Up Without Backyards Blamed For Aussie Cricket Slump",
		"type": "bs",
		"uuid": "1932b495ab47abafd6ebe844289b637533c83e94"
	},
	"-KhIkHE6MDlBKrJZspnj": {
		"author": "Email Protected",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-23T12:43:24.362+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0gyk6w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/George_Soros"
				},
				"name": "George Soros",
				"salience": 0.65269417,
				"type": "PERSON"
			},
			{
				"name": "Life",
				"salience": 0.076323815,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.024306994,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/021dvx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_of_Warcraft"
				},
				"name": "WOW",
				"salience": 0.023819944,
				"type": "WORK_OF_ART"
			},
			{
				"name": "News",
				"salience": 0.022417594,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026q3wk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democracy_Alliance"
				},
				"name": "Democracy Alliance",
				"salience": 0.021097785,
				"type": "ORGANIZATION"
			},
			{
				"name": "Got The Worst News Of His",
				"salience": 0.016854353,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Home",
				"salience": 0.016264953,
				"type": "OTHER"
			},
			{
				"name": "Bashing Trump",
				"salience": 0.015235658,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.014386778,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.010055863,
				"type": "LOCATION"
			},
			{
				"name": "Host Posts",
				"salience": 0.008352598,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0072715157,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0051522558,
				"type": "ORGANIZATION"
			},
			{
				"name": "liberal",
				"salience": 0.0046968763,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0044091367,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.0042492645,
				"type": "ORGANIZATION"
			},
			{
				"name": "richest",
				"salience": 0.0042420407,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.003598787,
				"type": "EVENT"
			},
			{
				"name": "millions",
				"salience": 0.0034492933,
				"type": "OTHER"
			},
			{
				"name": "donors",
				"salience": 0.0031764086,
				"type": "PERSON"
			},
			{
				"name": "plan",
				"salience": 0.003117162,
				"type": "OTHER"
			},
			{
				"name": "meeting",
				"salience": 0.0030010112,
				"type": "EVENT"
			},
			{
				"name": "right",
				"salience": 0.0028169442,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0027939652,
				"type": "EVENT"
			},
			{
				"name": "patriot",
				"salience": 0.002672437,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.002526578,
				"type": "ORGANIZATION"
			},
			{
				"name": "memos",
				"salience": 0.0025135542,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protests",
				"salience": 0.002419854,
				"type": "EVENT"
			},
			{
				"name": "attention",
				"salience": 0.0023296408,
				"type": "OTHER"
			},
			{
				"name": "RUMORS",
				"salience": 0.0023296408,
				"type": "OTHER"
			},
			{
				"name": "SUPPORT",
				"salience": 0.0023296408,
				"type": "OTHER"
			},
			{
				"name": "event",
				"salience": 0.0023296408,
				"type": "EVENT"
			},
			{
				"name": "Members",
				"salience": 0.0019759499,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0019759499,
				"type": "ORGANIZATION"
			},
			{
				"name": "party",
				"salience": 0.0018880513,
				"type": "ORGANIZATION"
			},
			{
				"name": "following",
				"salience": 0.0017295538,
				"type": "OTHER"
			},
			{
				"name": "wine",
				"salience": 0.0014764263,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "vision",
				"salience": 0.0014764263,
				"type": "OTHER"
			},
			{
				"name": "labor union officials",
				"salience": 0.0014764263,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.0014345383,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/08jtjr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mandarin_Oriental,_Hong_Kong"
				},
				"name": "Mandarin Oriental hotel",
				"salience": 0.0014345383,
				"type": "LOCATION"
			},
			{
				"name": "Liberty Writers News",
				"salience": 0.0012582772,
				"type": "ORGANIZATION"
			},
			{
				"name": "article",
				"salience": 0.0012419245,
				"type": "WORK_OF_ART"
			},
			{
				"name": "patriot",
				"salience": 0.0012419245,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.001075464,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.001075464,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07sjnm4"
				},
				"name": "Democrat",
				"salience": 0.0010327921,
				"type": "PERSON"
			},
			{
				"name": "strategist",
				"salience": 0.0008070523,
				"type": "PERSON"
			},
			{
				"name": "strategist",
				"salience": 0.0008070523,
				"type": "PERSON"
			},
			{
				"name": "club",
				"salience": 0.00080344797,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.00080344797,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.00066200685,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.00059263856,
				"type": "OTHER"
			},
			{
				"name": "The DA",
				"salience": 0.00049452746,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://bigbluevision.org/wp-content/uploads/2016/11/soros-trump-680x365-660x330.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-16T18:32:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "bigbluevision.org",
		"spam_score": "0.045",
		"text": "Home / US News / After Bashing Trump For Months, George Soros Just Got The Worst News Of His Life! After Bashing Trump For Months, George Soros Just Got The Worst News Of His Life! Related Articles WOW – NBC Host Posts MISLEADING Headline…This Is EMBARRASSING! 1 day ago 1 day ago \nGeorge Soros is a rich liberal! WHEW! Scratch that. George Soros is the richest of liberals. \nHe spent tens of millions of dollars trying to elect Hillary Clinton. Now that she lost… \nHe is focusing his attention on Donald Trump. \nTHERE ARE RUMORS THAT HE IS LOSING SUPPORT! \nThere is a 3­day meeting at the Mandarin Oriental hotel beginning on Sunday, according to Politico. This event is sponsored by Democracy Alliance – which is headed up by George Soros. \nTheir plan is to stop Trump even after he has won the election. Yes. You heard that right. The election is not over. It’s going to be a long year. \n*** If you didn’t know, Soros is behind the protests going on right now. \nSoros founded the Democracy Alliance in 2004. Members of the organization have to donate at least $200,000 a year to its recommended groups. \n*** Soros gave $13 million to unsuccessfully stop Trump from winning. \nThe Democratic party is wanting to get away from Soros’s Democracy Alliance. One Democratic strategist said the following: \n“The DA itself should be called into question,” said one Democratic strategist. “You can make a very good case it’s nothing more than a social club for a handful wealthy white donors and labor union officials to drink wine and read memos, as the Democratic Party burns down around them.” \nYou heard it right here at Liberty Writers News. The Democrats are starting to doubt George Soros’s vision for the party. Let’s help them doubt it! #SHARE this article with every single patriot and Democrat that you know. We need to stop this man from trying to topple our country. Are you American? \nWill you stand up, patriot? 2016-11-16 ",
		"thread_title": "After Bashing Trump For Months, George Soros Just Got The Worst News Of His Life! - Big Blue Vision",
		"title": "After Bashing Trump For Months, George Soros Just Got The Worst News Of His Life! - Big Blue Vision",
		"type": "bs",
		"uuid": "a3b6a4c4a9ff4082eaba757aabb61561ad56fcb2"
	},
	"-KhIkHVPLmwVByWlnLpI": {
		"author": "Political Ears Editorial Staff",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-02T06:53:30.680+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.44621998,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0n46_gt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/J._Christopher_Stevens"
				},
				"name": "Chris Stevens",
				"salience": 0.31015465,
				"type": "PERSON"
			},
			{
				"name": "emails",
				"salience": 0.023800744,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Aaron Klein",
				"salience": 0.023603864,
				"type": "PERSON"
			},
			{
				"name": "Hodges",
				"salience": 0.020828586,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Putin",
				"salience": 0.0120175695,
				"type": "PERSON"
			},
			{
				"name": "following",
				"salience": 0.007564239,
				"type": "OTHER"
			},
			{
				"name": "feeling",
				"salience": 0.005216839,
				"type": "OTHER"
			},
			{
				"name": "plan",
				"salience": 0.004642272,
				"type": "OTHER"
			},
			{
				"name": "Internet",
				"salience": 0.004289898,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0040435665,
				"type": "ORGANIZATION"
			},
			{
				"name": "confirmation",
				"salience": 0.0035755935,
				"type": "OTHER"
			},
			{
				"name": "places",
				"salience": 0.0033565036,
				"type": "LOCATION"
			},
			{
				"name": "gang",
				"salience": 0.0033565036,
				"type": "PERSON"
			},
			{
				"name": "thugs",
				"salience": 0.0033565036,
				"type": "OTHER"
			},
			{
				"name": "above",
				"salience": 0.003272662,
				"type": "OTHER"
			},
			{
				"name": "connections",
				"salience": 0.0032459898,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02x2tr8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Huma_Abedin"
				},
				"name": "Huma Abedin",
				"salience": 0.0027370492,
				"type": "PERSON"
			},
			{
				"name": "Timmy Davis",
				"salience": 0.002690658,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.002552344,
				"type": "LOCATION"
			},
			{
				"name": "interests",
				"salience": 0.0024902793,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01czt9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benghazi"
				},
				"name": "Benghazi",
				"salience": 0.00248888,
				"type": "LOCATION"
			},
			{
				"name": "Revelations",
				"salience": 0.0021650454,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.0020879002,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.0020679396,
				"type": "ORGANIZATION"
			},
			{
				"name": "Lafarge",
				"salience": 0.0020679396,
				"type": "ORGANIZATION"
			},
			{
				"name": "evidence",
				"salience": 0.001986723,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.001983012,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.001983012,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.0019580578,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0019090861,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0019090861,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.0019090861,
				"type": "WORK_OF_ART"
			},
			{
				"name": "dots",
				"salience": 0.0018751246,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.0018282236,
				"type": "OTHER"
			},
			{
				"name": "game plan",
				"salience": 0.0017303529,
				"type": "OTHER"
			},
			{
				"name": "visit",
				"salience": 0.0017049286,
				"type": "EVENT"
			},
			{
				"name": "emails",
				"salience": 0.0016607988,
				"type": "WORK_OF_ART"
			},
			{
				"name": "email",
				"salience": 0.0016192505,
				"type": "WORK_OF_ART"
			},
			{
				"name": "evidence",
				"salience": 0.0015575974,
				"type": "OTHER"
			},
			{
				"name": "emails",
				"salience": 0.0015198641,
				"type": "WORK_OF_ART"
			},
			{
				"name": "culprit",
				"salience": 0.0014740232,
				"type": "OTHER"
			},
			{
				"name": "travel plans",
				"salience": 0.0014397602,
				"type": "OTHER"
			},
			{
				"name": "precipice",
				"salience": 0.0013835392,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0013835392,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0013835392,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0013430539,
				"type": "OTHER"
			},
			{
				"name": "dispatches",
				"salience": 0.0013151629,
				"type": "WORK_OF_ART"
			},
			{
				"name": "charges",
				"salience": 0.001266105,
				"type": "OTHER"
			},
			{
				"name": "server",
				"salience": 0.0012408203,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0012408203,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.0012099074,
				"type": "WORK_OF_ART"
			},
			{
				"name": "server",
				"salience": 0.0011945324,
				"type": "OTHER"
			},
			{
				"name": "household name",
				"salience": 0.0011883702,
				"type": "OTHER"
			},
			{
				"name": "mission",
				"salience": 0.0011204047,
				"type": "OTHER"
			},
			{
				"name": "Ambassador",
				"salience": 0.0011204047,
				"type": "PERSON"
			},
			{
				"name": "meetings",
				"salience": 0.0011070672,
				"type": "EVENT"
			},
			{
				"name": "Employees",
				"salience": 0.0010786044,
				"type": "PERSON"
			},
			{
				"name": "revelation",
				"salience": 0.0010786044,
				"type": "OTHER"
			},
			{
				"name": "motive",
				"salience": 0.0010337263,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0010292308,
				"type": "OTHER"
			},
			{
				"name": "goal",
				"salience": 0.0010207067,
				"type": "OTHER"
			},
			{
				"name": "consequences",
				"salience": 0.0010207067,
				"type": "OTHER"
			},
			{
				"name": "interlocutors",
				"salience": 0.0010130779,
				"type": "PERSON"
			},
			{
				"name": "hotel",
				"salience": 0.0010130779,
				"type": "LOCATION"
			},
			{
				"name": "ground",
				"salience": 0.0010130779,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.000970246,
				"type": "OTHER"
			},
			{
				"name": "whereabouts",
				"salience": 0.000970246,
				"type": "LOCATION"
			},
			{
				"name": "messages",
				"salience": 0.000970246,
				"type": "OTHER"
			},
			{
				"name": "proof",
				"salience": 0.000970246,
				"type": "OTHER"
			},
			{
				"name": "series",
				"salience": 0.00093404297,
				"type": "WORK_OF_ART"
			},
			{
				"name": "VIDEO",
				"salience": 0.00093404297,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Tape Taking Celebratory BONG HITS",
				"salience": 0.00093404297,
				"type": "OTHER"
			},
			{
				"name": "B reitbart publication",
				"salience": 0.00093404297,
				"type": "WORK_OF_ART"
			},
			{
				"name": "situation",
				"salience": 0.000914745,
				"type": "OTHER"
			},
			{
				"name": "security situation",
				"salience": 0.000914745,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0008925721,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.00088132883,
				"type": "WORK_OF_ART"
			},
			{
				"name": "sense",
				"salience": 0.0008656359,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0430_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jerusalem"
				},
				"name": "Jerusalem",
				"salience": 0.0008517996,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War III",
				"salience": 0.0008517996,
				"type": "EVENT"
			},
			{
				"name": "Breitbart Bureau",
				"salience": 0.0008517996,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.0008517996,
				"type": "ORGANIZATION"
			},
			{
				"name": "stay",
				"salience": 0.0007921289,
				"type": "EVENT"
			},
			{
				"name": "day trip",
				"salience": 0.0007921289,
				"type": "EVENT"
			},
			{
				"name": "team",
				"salience": 0.0007921289,
				"type": "ORGANIZATION"
			},
			{
				"name": "hotel",
				"salience": 0.0007568666,
				"type": "LOCATION"
			},
			{
				"name": "hotel",
				"salience": 0.0007568666,
				"type": "LOCATION"
			},
			{
				"name": "security",
				"salience": 0.0007568666,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.00065841706,
				"type": "WORK_OF_ART"
			},
			{
				"name": "doubt",
				"salience": 0.00064669095,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.0006414077,
				"type": "EVENT"
			},
			{
				"name": "way",
				"salience": 0.0006304978,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.00059726083,
				"type": "LOCATION"
			},
			{
				"name": "location",
				"salience": 0.00059176586,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.00059176586,
				"type": "EVENT"
			},
			{
				"name": "villa",
				"salience": 0.00059176586,
				"type": "LOCATION"
			},
			{
				"name": "idea",
				"salience": 0.00059176586,
				"type": "OTHER"
			},
			{
				"name": "compound",
				"salience": 0.00059176586,
				"type": "LOCATION"
			},
			{
				"name": "coordination",
				"salience": 0.00059176586,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.0005749677,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09cfq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pizza_Hut"
				},
				"name": "Pizza Hut",
				"salience": 0.0005749677,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02hkr7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Nature_Conservancy"
				},
				"name": "TNC",
				"salience": 0.0005539055,
				"type": "ORGANIZATION"
			},
			{
				"name": "server",
				"salience": 0.00055125915,
				"type": "OTHER"
			},
			{
				"name": "felony",
				"salience": 0.00053031155,
				"type": "OTHER"
			},
			{
				"name": "felonies",
				"salience": 0.0004977313,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.0004977313,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04v3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malta"
				},
				"name": "Malta",
				"salience": 0.00048758526,
				"type": "LOCATION"
			},
			{
				"name": "accomplice",
				"salience": 0.00045920463,
				"type": "OTHER"
			},
			{
				"name": "groundwork",
				"salience": 0.00045002738,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.0004364917,
				"type": "OTHER"
			},
			{
				"name": "travel information",
				"salience": 0.00043099117,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00043099117,
				"type": "EVENT"
			},
			{
				"name": "death",
				"salience": 0.00043099117,
				"type": "EVENT"
			},
			{
				"name": "form",
				"salience": 0.00043099117,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00043099117,
				"type": "OTHER"
			},
			{
				"name": "meetings",
				"salience": 0.0004117991,
				"type": "EVENT"
			},
			{
				"name": "meeting",
				"salience": 0.0004117991,
				"type": "EVENT"
			},
			{
				"name": "light",
				"salience": 0.0004096732,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.00037180833,
				"type": "LOCATION"
			},
			{
				"name": "road",
				"salience": 0.00037180833,
				"type": "LOCATION"
			},
			{
				"name": "outreach mission",
				"salience": 0.00037180833,
				"type": "OTHER"
			},
			{
				"name": "connections",
				"salience": 0.00036712261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03mkk4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Master_of_Fine_Arts"
				},
				"name": "MFA",
				"salience": 0.0003642283,
				"type": "ORGANIZATION"
			},
			{
				"name": "fan",
				"salience": 0.00035632862,
				"type": "PERSON"
			},
			{
				"name": "rotation",
				"salience": 0.000321948,
				"type": "OTHER"
			},
			{
				"name": "MISTAKE",
				"salience": 0.000321948,
				"type": "OTHER"
			},
			{
				"name": "KILLER",
				"salience": 0.00028002338,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/017f3m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Law_%26_Order"
				},
				"name": "Law and Order",
				"salience": 0.0002652573,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://bignuggetnews.com/wp-content/uploads/2016/11/Christopher-Stevens-And-Hillary-Clinton.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-01T15:40:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 12.5,
			"score": 0
		},
		"shares": "0",
		"site_url": "bignuggetnews.com",
		"spam_score": "0",
		"text": "\n\nDear Mr. Hodges, \nThis is to inform you that Wikileaks will soon, or has released Clinton emails which will demonstrate the following: \n\nPlease note that I have covered the ISIS/Lafarge/Clinton connections very prominently in the past year. This is just more confirmation of what I have already covered. \nThe above is already appearing on the Internet in several places. It is clear that Putin would be a fool to allow Clinton and her gang of thugs to continue with their plan. Every time Clinton sags in the polls, she starts talking about 9/11. The evidence is beginning to line up that Clinton interests had motive to commit 9/11. No wonder Clinton tries to blame the Russians for everything, she is the main culprit on the world being brought to the precipice of World War III. \nIt is a gratifying feeling when the dots start to connect. \nThe Aaron Klein Revelations \nAaron Klein, the Breitbart Bureau Chief for Jerusalem revealed, in a B reitbart publication dated March 1, 2016, revealed that “the email from April 10th, 2011, the State Department employee, Timmy Davis, forwarded an email to the server by Clinton’s aide, Huma Abedin .” Please note that the time of this revelation, Huma Abedin, was not yet a household name. VIDEO: Pizza Hut Employees Caught On Tape Taking Celebratory BONG HITS AT WORK! \nThe series of emails will eventually have catastrophic consequences for Ambassador Stevens. “An email containing the whereabouts and plans of murdered U.S. Ambassador Chris Stevens passed through Hillary Clinton’s private server, dispatches released Monday in the final group of messages from Clinton’s emails reveal.” \nBelow are some examples of the allegations posed by Klein and these are not empty charges as Klein offered as proof, the following emails . \n“A March 27, 2011 email released last year was titled, “Chris Stevens mission.” It divulged: “The current game plan is for Mr. Stevens to move no later than Wednesday from Malta to Benghazi. He will stage offshore initially for a one day visit during which he will have meetings with TNC interlocutors and get a sense of the situation on the ground. The goal of this one day trip is for him to lay the groundwork for a stay of up to 30 days. \nAn April 8, 2011 email was forwarded to Clinton revealing the “security situation in Benghazi remains quiet. Chris Stevens & team are in the hotel, moving only for meetings as required.” \nAn April 22, 2011 email revealed Stevens was on the road: “I want to let you know about a temporary rotation in Benghazi. TNC Envoy Chris Stevens has been on the road since March 13, when he began his outreach mission, and has been in Benghazi since April 5.” CONVICTED KILLER RELEASED FROM JAIL BY MISTAKE \nAn April 24, 2011 email has the exact time of a Stevens meeting: “”Stevens will be meeting with MFA in one hour and will make a written request for better security at the hotel and for better security-related coordination. He still feels comfortable in the hotel. They are looking into the idea of moving into a villa, but that is some way off.” \nIf later emails are released, I have no doubt, that we will see that Clinton was transmitting Stevens location up until the time of the attack upon the Benghazi compound and this explains why some of these emails are not being released. However, at some point, they will see the light of day. \nThe release of travel information, in any form, is a felony! Remember, the Stevens travel plans are classified and they came from Clinton’s private server. A casual Law and Order fan could make the causal connections between the release of these emails and Stevens death. This is absolute evidence that Clinton not only is guilty of multiple felonies, she is an accomplice to murder! ",
		"thread_title": "BREAKING Wikileaks: Abedin’s Computer Confirms HillaryClinton Was Behind Murder of Ambassador Stevens - BIG NUGGET NEWS",
		"title": "BREAKING Wikileaks: Abedin’s Computer Confirms HillaryClinton Was Behind Murder of Ambassador Stevens - BIG NUGGET NEWS",
		"type": "bs",
		"uuid": "ac38edf20567ca190c2d6d4f2d56f4752891179c"
	},
	"-KhIkHt05DXW9xpQgz7-": {
		"author": "Elisabeth Parker",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T12:42:58.123+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"name": "supporter",
				"salience": 0.13572109,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.11091331,
				"type": "OTHER"
			},
			{
				"name": "Asli Noor",
				"salience": 0.055386163,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0130mmtt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Double-A_(baseball)"
				},
				"name": "A.A.",
				"salience": 0.055012126,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.03948039,
				"type": "PERSON"
			},
			{
				"name": "Academy of Excellence",
				"salience": 0.037344445,
				"type": "WORK_OF_ART"
			},
			{
				"name": "children",
				"salience": 0.033783842,
				"type": "PERSON"
			},
			{
				"name": "boy",
				"salience": 0.031994164,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vkm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_Liberties_Union"
				},
				"name": "American Civil Liberties Union",
				"salience": 0.025761764,
				"type": "ORGANIZATION"
			},
			{
				"name": "teacher",
				"salience": 0.02094715,
				"type": "PERSON"
			},
			{
				"name": "Faye Myles",
				"salience": 0.020693062,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.018157167,
				"type": "PERSON"
			},
			{
				"name": "schoolchildren",
				"salience": 0.017298928,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.015265298,
				"type": "PERSON"
			},
			{
				"name": "terrorist",
				"salience": 0.014048092,
				"type": "PERSON"
			},
			{
				"name": "complaints",
				"salience": 0.0122181885,
				"type": "OTHER"
			},
			{
				"name": "Academy of Excellence",
				"salience": 0.011680347,
				"type": "OTHER"
			},
			{
				"name": "charter school",
				"salience": 0.011337674,
				"type": "ORGANIZATION"
			},
			{
				"name": "attacks",
				"salience": 0.011126922,
				"type": "EVENT"
			},
			{
				"name": "student",
				"salience": 0.008247127,
				"type": "PERSON"
			},
			{
				"name": "Brenda Nelson",
				"salience": 0.0074515743,
				"type": "PERSON"
			},
			{
				"name": "educator",
				"salience": 0.0072768587,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.006582954,
				"type": "PERSON"
			},
			{
				"name": "example",
				"salience": 0.006571756,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.006124672,
				"type": "LOCATION"
			},
			{
				"name": "movie",
				"salience": 0.0058381115,
				"type": "WORK_OF_ART"
			},
			{
				"name": "teacher",
				"salience": 0.00573969,
				"type": "PERSON"
			},
			{
				"name": "Muslims",
				"salience": 0.005702529,
				"type": "PERSON"
			},
			{
				"name": "office reports",
				"salience": 0.005692165,
				"type": "OTHER"
			},
			{
				"name": "wonder",
				"salience": 0.005692165,
				"type": "OTHER"
			},
			{
				"name": "travesty",
				"salience": 0.005692165,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.005692165,
				"type": "OTHER"
			},
			{
				"name": "charter school",
				"salience": 0.0046769995,
				"type": "ORGANIZATION"
			},
			{
				"name": "recess",
				"salience": 0.004560148,
				"type": "EVENT"
			},
			{
				"name": "child",
				"salience": 0.0045071742,
				"type": "PERSON"
			},
			{
				"name": "schools",
				"salience": 0.0043067303,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dtj5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Justice"
				},
				"name": "U.S. Dept. of Justice",
				"salience": 0.0040480183,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jbl2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_Education"
				},
				"name": "U.S. Dept. of Education",
				"salience": 0.0040480183,
				"type": "ORGANIZATION"
			},
			{
				"name": "Excellence Academy",
				"salience": 0.003998697,
				"type": "WORK_OF_ART"
			},
			{
				"name": "children",
				"salience": 0.0036576712,
				"type": "PERSON"
			},
			{
				"name": "classmates",
				"salience": 0.0035212615,
				"type": "PERSON"
			},
			{
				"name": "Heather Weaver",
				"salience": 0.0035057515,
				"type": "PERSON"
			},
			{
				"name": "teacher",
				"salience": 0.0030085007,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0029990338,
				"type": "PERSON"
			},
			{
				"name": "complaints",
				"salience": 0.0029990338,
				"type": "OTHER"
			},
			{
				"name": "family",
				"salience": 0.0029990338,
				"type": "PERSON"
			},
			{
				"name": "complaint",
				"salience": 0.0029990338,
				"type": "OTHER"
			},
			{
				"name": "families",
				"salience": 0.0029990338,
				"type": "PERSON"
			},
			{
				"name": "education",
				"salience": 0.0029990338,
				"type": "OTHER"
			},
			{
				"name": "science teacher",
				"salience": 0.0029899701,
				"type": "PERSON"
			},
			{
				"name": "teacher",
				"salience": 0.0029899701,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0029766243,
				"type": "PERSON"
			},
			{
				"name": "teacher",
				"salience": 0.0028784338,
				"type": "PERSON"
			},
			{
				"name": "child",
				"salience": 0.002838878,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.0027425364,
				"type": "EVENT"
			},
			{
				"name": "sister",
				"salience": 0.0027079985,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0026896386,
				"type": "PERSON"
			},
			{
				"name": "student",
				"salience": 0.0026896386,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.0026896386,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0chl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Football_Association"
				},
				"name": "F.A.",
				"salience": 0.0026547418,
				"type": "OTHER"
			},
			{
				"name": "bus",
				"salience": 0.0026170043,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0025651597,
				"type": "OTHER"
			},
			{
				"name": "teacher",
				"salience": 0.0025358056,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0024694551,
				"type": "EVENT"
			},
			{
				"name": "teachers",
				"salience": 0.0023800887,
				"type": "PERSON"
			},
			{
				"name": "set",
				"salience": 0.0023450742,
				"type": "OTHER"
			},
			{
				"name": "parents",
				"salience": 0.0023450742,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0023450742,
				"type": "LOCATION"
			},
			{
				"name": "opportunities",
				"salience": 0.0023450742,
				"type": "OTHER"
			},
			{
				"name": "troubles",
				"salience": 0.0023450742,
				"type": "OTHER"
			},
			{
				"name": "Academy",
				"salience": 0.002289683,
				"type": "ORGANIZATION"
			},
			{
				"name": "Excellence",
				"salience": 0.002289683,
				"type": "OTHER"
			},
			{
				"name": "terrorist",
				"salience": 0.0022692827,
				"type": "PERSON"
			},
			{
				"name": "visa",
				"salience": 0.0022406995,
				"type": "OTHER"
			},
			{
				"name": "elementary school",
				"salience": 0.002105153,
				"type": "ORGANIZATION"
			},
			{
				"name": "each other",
				"salience": 0.0021030894,
				"type": "PERSON"
			},
			{
				"name": "classmates",
				"salience": 0.00209429,
				"type": "PERSON"
			},
			{
				"name": "school",
				"salience": 0.0020786354,
				"type": "ORGANIZATION"
			},
			{
				"name": "boy",
				"salience": 0.002023197,
				"type": "PERSON"
			},
			{
				"name": "wall",
				"salience": 0.002023197,
				"type": "OTHER"
			},
			{
				"name": "border wall",
				"salience": 0.002023197,
				"type": "OTHER"
			},
			{
				"name": "schools",
				"salience": 0.0020010686,
				"type": "ORGANIZATION"
			},
			{
				"name": "right",
				"salience": 0.0019637377,
				"type": "OTHER"
			},
			{
				"name": "bigotry",
				"salience": 0.0018989347,
				"type": "OTHER"
			},
			{
				"name": "teachers",
				"salience": 0.0018945162,
				"type": "PERSON"
			},
			{
				"name": "bus",
				"salience": 0.0018585204,
				"type": "OTHER"
			},
			{
				"name": "civics",
				"salience": 0.0018280688,
				"type": "OTHER"
			},
			{
				"name": "grades",
				"salience": 0.0018280688,
				"type": "OTHER"
			},
			{
				"name": "All",
				"salience": 0.0018280688,
				"type": "OTHER"
			},
			{
				"name": "pic.twitter.com/BbL3YdzEG8",
				"salience": 0.0018238273,
				"type": "OTHER"
			},
			{
				"name": "visas",
				"salience": 0.0018063004,
				"type": "OTHER"
			},
			{
				"name": "visa",
				"salience": 0.001716982,
				"type": "OTHER"
			},
			{
				"name": "downtime",
				"salience": 0.0016443711,
				"type": "EVENT"
			},
			{
				"name": "ways",
				"salience": 0.0016443711,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0016405445,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0016309377,
				"type": "LOCATION"
			},
			{
				"name": "math",
				"salience": 0.0015829992,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0015829992,
				"type": "EVENT"
			},
			{
				"name": "lesson",
				"salience": 0.0015829992,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.0015829992,
				"type": "OTHER"
			},
			{
				"name": "nationality",
				"salience": 0.0015829992,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0015829992,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0015829992,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0015829992,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0015829992,
				"type": "OTHER"
			},
			{
				"name": "classmates",
				"salience": 0.0015645889,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0015502855,
				"type": "LOCATION"
			},
			{
				"name": "hand",
				"salience": 0.0015433618,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0014827576,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d35y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix,_Arizona"
				},
				"name": "Phoenix",
				"salience": 0.0014435835,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.0014435835,
				"type": "LOCATION"
			},
			{
				"name": "crusade",
				"salience": 0.0014122808,
				"type": "OTHER"
			},
			{
				"name": "son",
				"salience": 0.001350761,
				"type": "PERSON"
			},
			{
				"name": "insults",
				"salience": 0.0013424358,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0013424358,
				"type": "OTHER"
			},
			{
				"name": "stomach ache",
				"salience": 0.0013424358,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0013424358,
				"type": "OTHER"
			},
			{
				"name": "bus ride",
				"salience": 0.0013424358,
				"type": "EVENT"
			},
			{
				"name": "misery",
				"salience": 0.0013424358,
				"type": "OTHER"
			},
			{
				"name": "bullying",
				"salience": 0.0012923273,
				"type": "OTHER"
			},
			{
				"name": "terrorists",
				"salience": 0.0012826642,
				"type": "PERSON"
			},
			{
				"name": "Academy",
				"salience": 0.0012458905,
				"type": "ORGANIZATION"
			},
			{
				"name": "Excellence",
				"salience": 0.0012458905,
				"type": "OTHER"
			},
			{
				"name": "bigotry",
				"salience": 0.0011581152,
				"type": "OTHER"
			},
			{
				"name": "kids",
				"salience": 0.0011581152,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latino",
				"salience": 0.0011284511,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0010869626,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.0010684711,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/015jb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamophobia"
				},
				"name": "anti-Muslim",
				"salience": 0.0010396122,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0010332,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.0010121374,
				"type": "PERSON"
			},
			{
				"name": "name",
				"salience": 0.0010073237,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.001002824,
				"type": "OTHER"
			},
			{
				"name": "criminals",
				"salience": 0.001002824,
				"type": "PERSON"
			},
			{
				"name": "spite",
				"salience": 0.001002824,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.001002824,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.001002824,
				"type": "OTHER"
			},
			{
				"name": "withdrawal forms",
				"salience": 0.00094120874,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0008434494,
				"type": "WORK_OF_ART"
			},
			{
				"name": "article",
				"salience": 0.0008434494,
				"type": "WORK_OF_ART"
			},
			{
				"name": "supporters",
				"salience": 0.0008434494,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0007781547,
				"type": "PERSON"
			},
			{
				"name": "school bus",
				"salience": 0.0007553627,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00073033955,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.00073033955,
				"type": "PERSON"
			},
			{
				"name": "policy plan",
				"salience": 0.00073033955,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00073033955,
				"type": "OTHER"
			},
			{
				"name": "school officials",
				"salience": 0.000697814,
				"type": "PERSON"
			},
			{
				"name": "school officials",
				"salience": 0.000697814,
				"type": "PERSON"
			},
			{
				"name": "emergency window",
				"salience": 0.0006352324,
				"type": "OTHER"
			},
			{
				"name": "sister",
				"salience": 0.000630041,
				"type": "PERSON"
			},
			{
				"name": "incidents",
				"salience": 0.000630041,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0h1c4mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/ThinkProgress"
				},
				"name": "Think Progress",
				"salience": 0.00061719515,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01n7q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/California"
				},
				"name": "California",
				"salience": 0.00061719515,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.00057493575,
				"type": "LOCATION"
			},
			{
				"name": "security camera",
				"salience": 0.00054554397,
				"type": "OTHER"
			},
			{
				"name": "footage",
				"salience": 0.00054554397,
				"type": "WORK_OF_ART"
			},
			{
				"name": "accusations",
				"salience": 0.00054554397,
				"type": "OTHER"
			},
			{
				"name": "school",
				"salience": 0.0005217583,
				"type": "ORGANIZATION"
			},
			{
				"name": "@KhaledBeydoun",
				"salience": 0.0005190945,
				"type": "PERSON"
			},
			{
				"name": "@JohnQarchibald",
				"salience": 0.0005190945,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.0005190945,
				"type": "ORGANIZATION"
			},
			{
				"name": "Asri Noor",
				"salience": 0.00049597485,
				"type": "PERSON"
			},
			{
				"name": "John Q Archibald",
				"salience": 0.0004494743,
				"type": "PERSON"
			},
			{
				"name": "Lynn Koenig",
				"salience": 0.0004494743,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/10/Muslim-student-aclu-teacher.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-01T02:45:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 18.7,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0.012",
		"text": "0 427 \n“That’s going to be you,” the Academy of Excellence teacher allegedly warned a 12-year-old Muslim student after showing the class a movie about the 9/11 attacks. And if that sounds outrageous, brace yourself because it gets a lot worse. \nNo wonder the American Civil Liberties Union (ACLU) and the ACLU of Arizona are siccing the U.S. Dept. of Justice and the U.S. Dept. of Education on this travesty of a public charter school and this shameful example of an educator’s sorry a**. Heather Weaver from the ACLU’s national office reports they’ve filed formal complaints on behalf of the Muslim student and his family. \nAsli Noor and her five children are refugees who settled in Phoenix, Arizona after fleeing Somalia. Like most parents, she wants opportunities and a good education for her children. And for many families — especially those living in low-income neighborhoods — that means a public charter school like the sadly misnamed “Excellence Academy.” \nThe boy and his eight-year-old sister (referred to in the complaint as A.A. and F.A.) had started the 2015-2016 school year when the family’s new set of troubles began. \nAccording to the complaints, an “Academy of Excellence” teacher named Faye Myles began “singling out” the then 11-year-old, sixth grade Muslim student as the 2015-16 school year began for “disfavorable treatment because of his faith and nationality.” \n‘Another time, when A.A. raised his hand to answer a question, his teacher snapped at him — “All you Muslims think you are so smart” — in front of the entire class.’ \nOh, and then the boy recalls the math and science teacher for grades 5-8 digressing into a special kind of lesson in civics and current events. \n‘I can’t wait until Trump is elected. He’s going to deport all you Muslims. Muslims shouldn’t be given visas. They’ll probably take away your visa and deport you. You’re going to be the next terrorist, I bet.’ \nFaye Myles also allegedly found other ways to wound her young Muslim student with her bigotry. She repeatedly denied him the right to pray during recess, which is hard to imagine ever happening to a Christian student. The child also claims his “Academy of Excellence” teacher would also would tell him to “shut up” and punish him during class “downtime” when the other students were allowed to talk with each other. \nThe bus rides home added to the child’s misery as his classmates began to follow the teacher’s example and pile on the insults. \n‘On the bus ride home, A.A.’s classmates took up his teacher’s anti-Muslim, anti-immigrant crusade, taunting him about the fact that his visa would be revoked because he is a Muslim, calling him a “terrorist,” and accusing him of planning to blow up the bus.’ \nThe child, of course, started feeling anxious and physically ill “with a stomach ache” and had no desire to return to the “Academy of Excellence.” \nIn January, Asli Noor met with school officials to complain about these incidents. Three days later, the school asked her to pick her son up early because he had supposedly tried to open the school bus’ emergency window. Noor demanded they verify these accusations with footage from the security camera but school officials refused. \nAnd then Brenda Nelson, an “Academy of Excellence” board member, printed out two “voluntary” withdrawal forms for A.A. and his younger sister F.A. She then allegedly ordered Ms. Noor to sign them, saying: \n‘Get your kids out of here. I don’t want them here.’ \nWhen Asri Noor begged for time to find another school for her children, Brenda Nelson callously refused. \nUnfortunately, these incidents of anti-Muslim bigotry in publicly-funded schools are happening more frequently. Think Progress reports that even in schools where teachers try to fight it, Trump-inspired bullying is a serious issue. \n‘In spite of some teachers’ valiant efforts to teach students about Trump, it would appear that schoolchildren already invoke the candidate’s name to scare their Latino and Muslim classmates, referencing the candidate’s harsh claims of Latino criminals and Muslim terrorists.’ \nAnd, sadly, it’s not just the kids. \n‘A predominantly Latino elementary school in California was graffiti-tagged with the words “Build the wall higher” last week, alluding to Trump’s policy plan to build a southern U.S. border wall to keep out undocumented immigrants.’ \nAnd in case you assume the “Academy of Excellence” teacher is one of those mean white Trump supporters, you’re wrong. Apparently, she’s a mean black Trump supporter. @KhaledBeydoun The teacher works at Academy of Excellence & her name is Faye Myles per the article. She should be called out. pic.twitter.com/BbL3YdzEG8 \n— John Q Archibald (@JohnQarchibald) October 30, 2016 \nFeatured image: Lynn Koenig via Getty Images . Share this Article! ",
		"thread_title": "Teacher To 11 yr Old: 'I Can't Wait Until Trump Is Elected,He's Going To Deport All You Muslims'",
		"title": "Teacher To 11 yr Old: 'I Can't Wait Until Trump Is Elected,He's Going To Deport All You Muslims'",
		"type": "bs",
		"uuid": "f4def2e2fd494ce14924c6142a4ac823c3d6c579"
	},
	"-KhIkI8Jit1ItZSNW-Lg": {
		"author": "Caleb R. Newton",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-01T16:55:37.912+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"name": "Candace Smith",
				"salience": 0.13749678,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.1279336,
				"type": "PERSON"
			},
			{
				"name": "members",
				"salience": 0.093009904,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0289n8t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Twitter"
				},
				"name": "Twitter",
				"salience": 0.06770985,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.04824902,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.035441943,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.022594798,
				"type": "PERSON"
			},
			{
				"name": "Clayton Swisher",
				"salience": 0.021901796,
				"type": "PERSON"
			},
			{
				"name": "rally",
				"salience": 0.02118985,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.02118985,
				"type": "OTHER"
			},
			{
				"name": "hand gestures",
				"salience": 0.01591557,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.013877971,
				"type": "PERSON"
			},
			{
				"name": "t-shirt",
				"salience": 0.012694351,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "supremacists",
				"salience": 0.012311538,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.012206515,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.009461432,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.009461432,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d35y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix,_Arizona"
				},
				"name": "Phoenix",
				"salience": 0.009461432,
				"type": "LOCATION"
			},
			{
				"name": "Television reporter",
				"salience": 0.009225538,
				"type": "PERSON"
			},
			{
				"name": "press area",
				"salience": 0.0090662,
				"type": "LOCATION"
			},
			{
				"name": "Nick Corasaniti",
				"salience": 0.007881075,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.007853876,
				"type": "PERSON"
			},
			{
				"name": "devil",
				"salience": 0.007853876,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.007853876,
				"type": "PERSON"
			},
			{
				"name": "salute",
				"salience": 0.00755149,
				"type": "OTHER"
			},
			{
				"name": "symbol",
				"salience": 0.0060092676,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0057287994,
				"type": "PERSON"
			},
			{
				"name": "hands",
				"salience": 0.0057287994,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.005048429,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "USA",
				"salience": 0.0048388657,
				"type": "LOCATION"
			},
			{
				"name": "Hillary for Prison",
				"salience": 0.0048388657,
				"type": "ORGANIZATION"
			},
			{
				"name": "pic.twitter.com/2yqgA6dD4k",
				"salience": 0.004783853,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0044807014,
				"type": "OTHER"
			},
			{
				"name": "signs",
				"salience": 0.0043686363,
				"type": "OTHER"
			},
			{
				"name": "media pen",
				"salience": 0.0041398057,
				"type": "OTHER"
			},
			{
				"name": "reporters",
				"salience": 0.0041398057,
				"type": "PERSON"
			},
			{
				"name": "behavior",
				"salience": 0.0041398057,
				"type": "OTHER"
			},
			{
				"name": "press pen",
				"salience": 0.0041398057,
				"type": "OTHER"
			},
			{
				"name": "hand gestures",
				"salience": 0.0038779136,
				"type": "OTHER"
			},
			{
				"name": "pic.twitter.com/phDvXFGgGw",
				"salience": 0.0034854473,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.003409082,
				"type": "WORK_OF_ART"
			},
			{
				"name": "One",
				"salience": 0.0033779398,
				"type": "OTHER"
			},
			{
				"name": "tape",
				"salience": 0.0032374407,
				"type": "OTHER"
			},
			{
				"name": "press area encounter",
				"salience": 0.0032374407,
				"type": "EVENT"
			},
			{
				"name": "hand gestures",
				"salience": 0.0032276576,
				"type": "OTHER"
			},
			{
				"name": "hand sign",
				"salience": 0.0031427082,
				"type": "OTHER"
			},
			{
				"name": "hand sign",
				"salience": 0.0031427082,
				"type": "OTHER"
			},
			{
				"name": "@CandaceSmith_",
				"salience": 0.0030461722,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.003025485,
				"type": "PERSON"
			},
			{
				"name": "supporter",
				"salience": 0.003025485,
				"type": "PERSON"
			},
			{
				"name": "hand signs",
				"salience": 0.0029497726,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00293068,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0028721534,
				"type": "PERSON"
			},
			{
				"name": "pic.twitter.com/64yseZFSVZ",
				"salience": 0.0028660907,
				"type": "OTHER"
			},
			{
				"name": "variation",
				"salience": 0.0028521388,
				"type": "OTHER"
			},
			{
				"name": "supremacist symbols",
				"salience": 0.0026217245,
				"type": "OTHER"
			},
			{
				"name": "numbers",
				"salience": 0.0026217245,
				"type": "OTHER"
			},
			{
				"name": "supporter",
				"salience": 0.0025659446,
				"type": "PERSON"
			},
			{
				"name": "Jew-s-a",
				"salience": 0.002549119,
				"type": "OTHER"
			},
			{
				"name": "JEW-S-A",
				"salience": 0.002549119,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0025307017,
				"type": "WORK_OF_ART"
			},
			{
				"name": "salute",
				"salience": 0.0025256774,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0025239144,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0024517518,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0024517518,
				"type": "PERSON"
			},
			{
				"name": "@claytonswisher",
				"salience": 0.002383692,
				"type": "PERSON"
			},
			{
				"name": "user",
				"salience": 0.0023705862,
				"type": "PERSON"
			},
			{
				"name": "username",
				"salience": 0.0023705862,
				"type": "OTHER"
			},
			{
				"name": "user",
				"salience": 0.0023705862,
				"type": "PERSON"
			},
			{
				"name": "press",
				"salience": 0.0023617703,
				"type": "OTHER"
			},
			{
				"name": "letters",
				"salience": 0.0022703616,
				"type": "WORK_OF_ART"
			},
			{
				"name": "question",
				"salience": 0.0021856483,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0021856483,
				"type": "PERSON"
			},
			{
				"name": "responses",
				"salience": 0.0021856483,
				"type": "OTHER"
			},
			{
				"name": "reference",
				"salience": 0.0021856483,
				"type": "OTHER"
			},
			{
				"name": "text",
				"salience": 0.0021856483,
				"type": "OTHER"
			},
			{
				"name": "bio",
				"salience": 0.0021856483,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anyone",
				"salience": 0.0021677972,
				"type": "PERSON"
			},
			{
				"name": "video",
				"salience": 0.0021602355,
				"type": "WORK_OF_ART"
			},
			{
				"name": "number",
				"salience": 0.0021404917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03_vfj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nazi_salute"
				},
				"name": "Heil Hitler",
				"salience": 0.0021251566,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsg7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Broadcasting_Company"
				},
				"name": "ABC",
				"salience": 0.0019932026,
				"type": "ORGANIZATION"
			},
			{
				"name": "@57MCM",
				"salience": 0.0019461173,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0019170529,
				"type": "EVENT"
			},
			{
				"name": "court",
				"salience": 0.0018535755,
				"type": "LOCATION"
			},
			{
				"name": "hand gesture version",
				"salience": 0.0018535755,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "object",
				"salience": 0.0018384345,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0017858568,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.0017858568,
				"type": "PERSON"
			},
			{
				"name": "Marisel Morales",
				"salience": 0.0017350081,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0345h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Germany"
				},
				"name": "German",
				"salience": 0.0017350081,
				"type": "LOCATION"
			},
			{
				"name": "press",
				"salience": 0.0017202973,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0017202973,
				"type": "OTHER"
			},
			{
				"name": "Security",
				"salience": 0.0015991222,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0014633103,
				"type": "PERSON"
			},
			{
				"name": "@NYTnickc",
				"salience": 0.0014538798,
				"type": "OTHER"
			},
			{
				"name": "HH",
				"salience": 0.0013975899,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0q442",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Defamation_League"
				},
				"name": "Anti-Defamation League",
				"salience": 0.0013975899,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03xw0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Internet_Explorer"
				},
				"name": "i.e.",
				"salience": 0.0013975899,
				"type": "OTHER"
			},
			{
				"name": "campaign rallies",
				"salience": 0.0013963005,
				"type": "EVENT"
			},
			{
				"name": "image",
				"salience": 0.0013847318,
				"type": "WORK_OF_ART"
			},
			{
				"name": "front",
				"salience": 0.0013847318,
				"type": "OTHER"
			},
			{
				"name": "Ben Schrekinger",
				"salience": 0.0013515797,
				"type": "PERSON"
			},
			{
				"name": "object",
				"salience": 0.0013390266,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.0013341327,
				"type": "PERSON"
			},
			{
				"name": "Schwurhand",
				"salience": 0.0013176182,
				"type": "PERSON"
			},
			{
				"name": "@puppymnkey",
				"salience": 0.0013176182,
				"type": "OTHER"
			},
			{
				"name": "Schwurhand",
				"salience": 0.0013176182,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.0012899468,
				"type": "OTHER"
			},
			{
				"name": "press",
				"salience": 0.0012851476,
				"type": "OTHER"
			},
			{
				"name": "salute",
				"salience": 0.0012417972,
				"type": "OTHER"
			},
			{
				"name": "member",
				"salience": 0.00122615,
				"type": "PERSON"
			},
			{
				"name": "incitement antics",
				"salience": 0.0011646927,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0011646927,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0011646927,
				"type": "OTHER"
			},
			{
				"name": "Scwhurhand",
				"salience": 0.0011409511,
				"type": "PERSON"
			},
			{
				"name": "Jew-S-A",
				"salience": 0.0010901473,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.0010430716,
				"type": "EVENT"
			},
			{
				"name": "2016 Trump",
				"salience": 0.0010155184,
				"type": "PERSON"
			},
			{
				"name": "coverage",
				"salience": 0.0010085216,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0010085216,
				"type": "EVENT"
			},
			{
				"name": "display",
				"salience": 0.0010085216,
				"type": "OTHER"
			},
			{
				"name": "behavior",
				"salience": 0.00096361234,
				"type": "OTHER"
			},
			{
				"name": "video",
				"salience": 0.0009474862,
				"type": "WORK_OF_ART"
			},
			{
				"name": "@SchreckReports",
				"salience": 0.00085941906,
				"type": "OTHER"
			},
			{
				"name": "Ben Schreckinger",
				"salience": 0.00085941906,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "Politico",
				"salience": 0.000852297,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04yx4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Man"
				},
				"name": "Guy",
				"salience": 0.000852297,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/041rx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jews"
				},
				"name": "Jews",
				"salience": 0.000852297,
				"type": "PERSON"
			},
			{
				"name": "@puppymnkey",
				"salience": 0.0007909912,
				"type": "OTHER"
			},
			{
				"name": "idiot",
				"salience": 0.0007533613,
				"type": "PERSON"
			},
			{
				"name": "index finger touching",
				"salience": 0.0007533613,
				"type": "OTHER"
			},
			{
				"name": "conspiracy theorists",
				"salience": 0.0007533613,
				"type": "PERSON"
			},
			{
				"name": "bit",
				"salience": 0.0007533613,
				"type": "OTHER"
			},
			{
				"name": "pinky",
				"salience": 0.0007533613,
				"type": "OTHER"
			},
			{
				"name": "film",
				"salience": 0.0007533613,
				"type": "WORK_OF_ART"
			},
			{
				"name": "group",
				"salience": 0.0007533613,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "The New York Times",
				"salience": 0.00059306104,
				"type": "ORGANIZATION"
			},
			{
				"name": "Infowars",
				"salience": 0.00046364573,
				"type": "OTHER"
			},
			{
				"name": "Boycott Trump SCION",
				"salience": 0.00046364573,
				"type": "ORGANIZATION"
			},
			{
				"name": "@CandaceSmith_",
				"salience": 0.00046364573,
				"type": "PERSON"
			},
			{
				"name": "@57MCM",
				"salience": 0.00046364573,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/10/GettyImages-618474560.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-10-30T19:14:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.7,
			"score": 0
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0.19",
		"text": "0 407 \nAn unidentified supporter of Republican presidential candidate and alleged unregistered sex offender Donald Trump took to violently harassing members of the media at a Saturday night rally held in Phoenix, Arizona. \nThe man, wearing a “Hillary for Prison” t-shirt, screamed into the press area, “You’re going down! You’re the enemy! You’re the ones working for the devil!,” before adapting the crowd’s “USA” chant into “Jew-s-a,” all the while continuing to scream at the members of the media in the press pen. \nCandace Smith, of ABC, was one of the reporters to capture the man’s disturbing behavior on tape. She posted video of the disturbing press area encounter to Twitter, a video which is featured below. This is the man who started chanting “JEW-S-A” at the media pen. Does anyone know what those hands signs mean? pic.twitter.com/64yseZFSVZ \n— Candace Smith (@CandaceSmith_) October 29, 2016 \nSmith included in the text accompanying her video post a question, saying in reference to seemingly intentional hand gestures on the part of the Trump supporter, “Does anyone know what those hand signs mean?” \nSmith got at least a couple noteworthy and credible responses. \nClayton Swisher, whose Twitter bio reads that he is an “investigative reporter and author,” suggested that the Trump supporter’s hand gestures are a variation of the “88” hand sign used by white supremacists and described by the Anti-Defamation League as follows: \n‘One of the most popular white supremacist symbols is the numeric symbol 88, which stands for “Heil Hitler” (substituting letters for numbers, 88 means HH, i.e., “Heil Hitler”). It is thus not surprising that white supremacists occasionally attempt to display 88 as a hand sign.’ \n— Clayton Swisher (@claytonswisher) October 30, 2016 \nA Twitter user identified as Marisel Morales suggested that the hand gestures were the “Scwhurhand,” which is a German salute used in court. @CandaceSmith_ It's a German salute known as Schwurhand \n— Marisel Morales (@57MCM) October 29, 2016 \nA Twitter user with the username “@puppymnkey” countered, however, that the Trump supporter’s hand gestures didn’t quite match the Schwurhand, and instead pointed to a hand gesture version of the number “666” employed by conspiracy theorists, a group almost certainly the man at the Trump rally. @57MCM @CandaceSmith_ nope. That salute is with pinky and index finger touching. It could be this given he's Infowars idiot pic.twitter.com/u953UYor2K \n— Boycott Trump SCION (@puppymnkey) October 30, 2016 \nNick Corasaniti of The New York Times was another member of the press to capture the man’s disturbing behavior on film. \nHis video, which runs a bit after Smith’s video concludes, is featured below. \nIn this second video, the man can be heard saying that “We’re run by the Jews, okay?” Guy chants “Jew-S-A” in front of press pen pic.twitter.com/2yqgA6dD4k \n— Nick Corasaniti (@NYTnickc) October 29, 2016 \nAt the same rally, Politico’s Ben Schrekinger captured an image of a man he said “had been staring at the press for some time” and was “holding an object.” \nSecurity, Schrekinger says, was notified of the man’s behavior. Bearded man's been staring at press for some time. Television reporter said he is holding object + notified security pic.twitter.com/phDvXFGgGw \n— Ben Schreckinger (@SchreckReports) October 29, 2016 \nTrump has long targeted the press in his incitement antics, as put on full display in his campaign rallies. He claims that the media has collaborated to “rig” the election against him by supposedly dishonest coverage of his campaign on their part. ",
		"thread_title": "Trump Supporters Lose Control, Violently Harass Reporters At Rally (VIDEO)",
		"title": "Trump Supporters Lose Control, Violently Harass Reporters At Rally (VIDEO)",
		"type": "bs",
		"uuid": "f92bf32cd05c601401feb645314910ab875ac932"
	},
	"-KhIkIkeJX3oPhHar9RO": {
		"author": "Elisabeth Parker",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-04T05:05:09.842+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican Party",
				"salience": 0.72667724,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.03350984,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.019040765,
				"type": "PERSON"
			},
			{
				"name": "voter turnout",
				"salience": 0.015770227,
				"type": "OTHER"
			},
			{
				"name": "poll watchers",
				"salience": 0.012257383,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.010770586,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.005523727,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0048003383,
				"type": "OTHER"
			},
			{
				"name": "win",
				"salience": 0.004761262,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.0044817477,
				"type": "ORGANIZATION"
			},
			{
				"name": "state",
				"salience": 0.004146224,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.0037863385,
				"type": "PERSON"
			},
			{
				"name": "victories",
				"salience": 0.003634973,
				"type": "OTHER"
			},
			{
				"name": "consent decree",
				"salience": 0.0034950261,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0vmt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Arizona"
				},
				"name": "Arizona",
				"salience": 0.0034901719,
				"type": "LOCATION"
			},
			{
				"name": "ass",
				"salience": 0.0032438603,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0032438603,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fh70",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Voting_Rights_Act_of_1965"
				},
				"name": "Voting Rights Act",
				"salience": 0.0026088988,
				"type": "WORK_OF_ART"
			},
			{
				"name": "people",
				"salience": 0.0026028275,
				"type": "PERSON"
			},
			{
				"name": "poll watchers",
				"salience": 0.0025965334,
				"type": "OTHER"
			},
			{
				"name": "poll watchers",
				"salience": 0.0025965334,
				"type": "OTHER"
			},
			{
				"name": "Voters",
				"salience": 0.0025239054,
				"type": "PERSON"
			},
			{
				"name": "sense",
				"salience": 0.0023941458,
				"type": "OTHER"
			},
			{
				"name": "tactics",
				"salience": 0.002329578,
				"type": "OTHER"
			},
			{
				"name": "lawsuit",
				"salience": 0.0022472816,
				"type": "OTHER"
			},
			{
				"name": "backers",
				"salience": 0.002122474,
				"type": "PERSON"
			},
			{
				"name": "poll",
				"salience": 0.002122066,
				"type": "OTHER"
			},
			{
				"name": "Tim Sifert",
				"salience": 0.0019102658,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "U.S. Supreme Court",
				"salience": 0.0019083099,
				"type": "ORGANIZATION"
			},
			{
				"name": "rights",
				"salience": 0.0018681138,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.001850405,
				"type": "LOCATION"
			},
			{
				"name": "poll watcher",
				"salience": 0.0018214379,
				"type": "OTHER"
			},
			{
				"name": "poll watchers",
				"salience": 0.0018214379,
				"type": "OTHER"
			},
			{
				"name": "poll watchers",
				"salience": 0.0017535201,
				"type": "OTHER"
			},
			{
				"name": "calls",
				"salience": 0.0017096017,
				"type": "OTHER"
			},
			{
				"name": "consent decree",
				"salience": 0.0016668311,
				"type": "OTHER"
			},
			{
				"name": "polling places",
				"salience": 0.0015437463,
				"type": "LOCATION"
			},
			{
				"name": "court order",
				"salience": 0.0015437463,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.0015437463,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.0015437463,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0015390817,
				"type": "PERSON"
			},
			{
				"name": "poll watchers",
				"salience": 0.0014872515,
				"type": "PERSON"
			},
			{
				"name": "poll watchers",
				"salience": 0.0014872515,
				"type": "OTHER"
			},
			{
				"name": "Watch",
				"salience": 0.0014872515,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "voters",
				"salience": 0.0014456118,
				"type": "PERSON"
			},
			{
				"name": "voter fraud",
				"salience": 0.0014064178,
				"type": "OTHER"
			},
			{
				"name": "Mein Trumpf",
				"salience": 0.0014036244,
				"type": "ORGANIZATION"
			},
			{
				"name": "brown shirts",
				"salience": 0.001336908,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hell",
				"salience": 0.001336908,
				"type": "OTHER"
			},
			{
				"name": "bands",
				"salience": 0.001336908,
				"type": "OTHER"
			},
			{
				"name": "water",
				"salience": 0.001336908,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0013102093,
				"type": "OTHER"
			},
			{
				"name": "activities",
				"salience": 0.0012390242,
				"type": "OTHER"
			},
			{
				"name": "call",
				"salience": 0.0012297651,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.0011939708,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0011939708,
				"type": "OTHER"
			},
			{
				"name": "consent decree",
				"salience": 0.001154255,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.001154255,
				"type": "LOCATION"
			},
			{
				"name": "citizen journalists",
				"salience": 0.0011338381,
				"type": "PERSON"
			},
			{
				"name": "photos",
				"salience": 0.0011123102,
				"type": "WORK_OF_ART"
			},
			{
				"name": "tactics",
				"salience": 0.0010826206,
				"type": "OTHER"
			},
			{
				"name": "governor race",
				"salience": 0.0010826206,
				"type": "EVENT"
			},
			{
				"name": "race",
				"salience": 0.0010826206,
				"type": "EVENT"
			},
			{
				"name": "courts",
				"salience": 0.0010595843,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.0010422267,
				"type": "OTHER"
			},
			{
				"name": "polling locations",
				"salience": 0.0010422267,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0010422267,
				"type": "EVENT"
			},
			{
				"name": "win",
				"salience": 0.0010033385,
				"type": "EVENT"
			},
			{
				"name": "state",
				"salience": 0.0009789054,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0009752646,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0009752646,
				"type": "PERSON"
			},
			{
				"name": "consequences",
				"salience": 0.0009696186,
				"type": "OTHER"
			},
			{
				"name": "monitors",
				"salience": 0.00096590014,
				"type": "OTHER"
			},
			{
				"name": "concerns",
				"salience": 0.0009375151,
				"type": "OTHER"
			},
			{
				"name": "minority districts",
				"salience": 0.0009375151,
				"type": "LOCATION"
			},
			{
				"name": "restrictions",
				"salience": 0.0009375151,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0009375151,
				"type": "PERSON"
			},
			{
				"name": "margin",
				"salience": 0.0009375151,
				"type": "OTHER"
			},
			{
				"name": "limits",
				"salience": 0.0009375151,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01w5q_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_National_Committee"
				},
				"name": "Republican National Committee",
				"salience": 0.0009245181,
				"type": "ORGANIZATION"
			},
			{
				"name": "practices",
				"salience": 0.0009081265,
				"type": "OTHER"
			},
			{
				"name": "suit",
				"salience": 0.00090657896,
				"type": "OTHER"
			},
			{
				"name": "provisions",
				"salience": 0.0009025309,
				"type": "OTHER"
			},
			{
				"name": "demise",
				"salience": 0.0009025309,
				"type": "EVENT"
			},
			{
				"name": "ammo",
				"salience": 0.0009025309,
				"type": "OTHER"
			},
			{
				"name": "polling sites",
				"salience": 0.0009025309,
				"type": "OTHER"
			},
			{
				"name": "something",
				"salience": 0.0009025309,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00089203625,
				"type": "EVENT"
			},
			{
				"name": "polling places",
				"salience": 0.0008838827,
				"type": "LOCATION"
			},
			{
				"name": "voters",
				"salience": 0.00088182604,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0008567723,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d35y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Phoenix,_Arizona"
				},
				"name": "Phoenix",
				"salience": 0.00082305714,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/041jxp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Arizona_Republic"
				},
				"name": "AZ Central",
				"salience": 0.00082305714,
				"type": "ORGANIZATION"
			},
			{
				"name": "poll watchers",
				"salience": 0.0008094138,
				"type": "OTHER"
			},
			{
				"name": "poll watchers",
				"salience": 0.0008094138,
				"type": "OTHER"
			},
			{
				"name": "stages",
				"salience": 0.00079161016,
				"type": "OTHER"
			},
			{
				"name": "Stage",
				"salience": 0.00079161016,
				"type": "OTHER"
			},
			{
				"name": "child support",
				"salience": 0.00079161016,
				"type": "OTHER"
			},
			{
				"name": "Stage",
				"salience": 0.00079161016,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0007867389,
				"type": "PERSON"
			},
			{
				"name": "mailers",
				"salience": 0.00078505237,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thanks",
				"salience": 0.00076539646,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00076539646,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.00076539646,
				"type": "OTHER"
			},
			{
				"name": "lawyers",
				"salience": 0.00076539646,
				"type": "PERSON"
			},
			{
				"name": "badges",
				"salience": 0.00074139977,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04sg6z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rachel_Maddow"
				},
				"name": "Rachel Maddow",
				"salience": 0.00071643316,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00071035826,
				"type": "PERSON"
			},
			{
				"name": "type",
				"salience": 0.0006698861,
				"type": "OTHER"
			},
			{
				"name": "ballots",
				"salience": 0.00066031853,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/027_2w9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Politico"
				},
				"name": "POLITICO",
				"salience": 0.00063917023,
				"type": "ORGANIZATION"
			},
			{
				"name": "trouble",
				"salience": 0.00061698654,
				"type": "OTHER"
			},
			{
				"name": "poll watchers",
				"salience": 0.0006046754,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.00058773305,
				"type": "PERSON"
			},
			{
				"name": "voters",
				"salience": 0.00058773305,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05fjf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_Jersey"
				},
				"name": "New Jersey",
				"salience": 0.0005770961,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06qd_h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ballot_Security_Task_Force"
				},
				"name": "Ballot Security Task Force",
				"salience": 0.0005770961,
				"type": "ORGANIZATION"
			},
			{
				"name": "parking tickets",
				"salience": 0.0005717865,
				"type": "OTHER"
			},
			{
				"name": "flyers",
				"salience": 0.0005717865,
				"type": "PERSON"
			},
			{
				"name": "neighborhoods",
				"salience": 0.0005717865,
				"type": "LOCATION"
			},
			{
				"name": "information",
				"salience": 0.0005717865,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00055827526,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "U.S.",
				"salience": 0.00054407236,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.00048536126,
				"type": "EVENT"
			},
			{
				"name": "citizenship",
				"salience": 0.0004809233,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.00047927297,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/018y36",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Committee"
				},
				"name": "DNC",
				"salience": 0.0004711195,
				"type": "ORGANIZATION"
			},
			{
				"name": "difference",
				"salience": 0.00046090226,
				"type": "OTHER"
			},
			{
				"name": "stages",
				"salience": 0.00043070162,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00043070162,
				"type": "OTHER"
			},
			{
				"name": "suppression",
				"salience": 0.00043070162,
				"type": "OTHER"
			},
			{
				"name": "Voter suppression",
				"salience": 0.00043070162,
				"type": "EVENT"
			},
			{
				"name": "questions",
				"salience": 0.0004164348,
				"type": "OTHER"
			},
			{
				"name": "ID",
				"salience": 0.0004164348,
				"type": "OTHER"
			},
			{
				"name": "demands",
				"salience": 0.0004164348,
				"type": "OTHER"
			},
			{
				"name": "authority",
				"salience": 0.0004164348,
				"type": "OTHER"
			},
			{
				"name": "video footage",
				"salience": 0.0004164348,
				"type": "WORK_OF_ART"
			},
			{
				"name": "positions",
				"salience": 0.0004164348,
				"type": "OTHER"
			},
			{
				"name": "IDs",
				"salience": 0.0004164348,
				"type": "OTHER"
			},
			{
				"name": "voting",
				"salience": 0.00039789037,
				"type": "EVENT"
			},
			{
				"name": "election monitoring",
				"salience": 0.0003592492,
				"type": "OTHER"
			},
			{
				"name": "volunteers",
				"salience": 0.0003592492,
				"type": "PERSON"
			},
			{
				"name": "polling locations",
				"salience": 0.0003592492,
				"type": "LOCATION"
			},
			{
				"name": "era",
				"salience": 0.0003592492,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.00035192503,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dyl9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Milwaukee"
				},
				"name": "Milwaukee",
				"salience": 0.00035192503,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07z1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Virginia"
				},
				"name": "Virginia",
				"salience": 0.00035192503,
				"type": "LOCATION"
			},
			{
				"name": "article",
				"salience": 0.00033566842,
				"type": "WORK_OF_ART"
			},
			{
				"name": "poll taxes",
				"salience": 0.00031107193,
				"type": "OTHER"
			},
			{
				"name": "poll workers",
				"salience": 0.00031107193,
				"type": "PERSON"
			},
			{
				"name": "color",
				"salience": 0.00031107193,
				"type": "OTHER"
			},
			{
				"name": "observers",
				"salience": 0.00031107193,
				"type": "PERSON"
			},
			{
				"name": "literacy tests",
				"salience": 0.00031107193,
				"type": "OTHER"
			},
			{
				"name": "misinformation",
				"salience": 0.00026715262,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fbfs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reconstruction_Era"
				},
				"name": "post-Civil War Reconstruction",
				"salience": 0.00025629523,
				"type": "EVENT"
			},
			{
				"name": "advice",
				"salience": 0.00025393648,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/11/Poll-watchers.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-01T20:05:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 14.2,
			"score": -0.3
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0.781",
		"text": "0 1661 \nDonald Trump wants so-called “poll watchers” to scare people into not voting? Fine, then Arizona Democrats will sue their state GOP’s sorry ass… And they’ve got a good chance of winning. \nThe U.S. Supreme Court’s gutting of the Voting Rights Act in 2013 was a huge win for the Republican Party. Since high voter turnout — especially high minority voter turnout — creates victories for Democrats, it makes sense for the GOP to keep as many people from voting as they possibly can. There’s just one thing the party of Donald Trump forgot: Voters still do have some rights, and the GOP doesn’t get to do whatever the hell it wants. \nDonald Trump’s calls for “poll watchers” to prevent nonexistent “voter fraud” may land the Republican Party in some serious hot water. AZ Central reports the Democratic Party of Arizona filed a lawsuit and seeks a court order banning Mein Trumpf’s bands of brown shirts from the polling places. \n‘The suit filed in federal court in Phoenix Monday seeks an order blocking volunteer GOP poll watchers from harassing or photographing people headed to polling locations. The suit says the state Republican Party is essentially an arm of Trump’s campaign and the campaign and its backers have been organizing “citizen journalists” and “poll watchers” to flood minority-heavy polling sites on Nov. 8.’ \nAnd despite the demise of key provisions of the Voting Rights Act, they’ve still got some ammo. Last week, Rachel Maddow talked about something the GOP forgot about: That pesky old legal consent decree. Back in 1981, the Republican National Committee (RNC) employed similar “poll watcher” tactics during a tight governor race in New Jersey. Their “Ballot Security Task Force” employed heavy-handed tactics in minority districts and won the race for their candidate by a razor thin margin. \nUnfortunately, the GOP’s short-term win backfired and had long-term consequences: a 35-year consent decree that puts strong limits on their “poll watching” activities. These legal restrictions don’t expire until next year. Naturally, Donald Trump’s renewed call for “poll watchers” has triggered concerns on the part of DNC lawyers at the national level. Now, they’re demanding that the courts extend the consent decree through 2025. Watch: Rachel Maddow explains how Trump’s call for “poll watchers” is causing legal trouble for the RNC. \nOf course, Tim Sifert, the state’s GOP spokesman, insists these poll watchers aren’t trying to intimidate voters. They’re just helping “monitor” polling places since — thanks to SCOTUS — we no longer have as many actual monitors for U.S. elections. But, as POLITICO points out, there’s a huge difference between having impartial observers around to provide advice and support for voters and poll workers and having “poll watchers” spreading misinformation and scaring voters. \n‘Trump seems to be advocating for a type of election monitoring that relies on volunteers to use deceptive practices that are often used to prevent people of color from voting. Voter suppression has changed since the era of literacy tests and poll taxes. In 2016, suppression occurs in two distinct stages: one before the election, and one at the polling locations themselves.’ \nThe POLITICO article explains how the GOP tries to scare people into not voting in two stages. Stage 1: Before an election, Republicans try to keep people from casting their ballots with false — and sometimes scary — information. In 2008, mailers went out telling Democratic voters in Virginia that Election Day had been moved from Tuesday to Wednesday. Meanwhile, black neighborhoods in Milwaukee (2004) and Philadelphia (2008) got plastered with flyers warning that people with unpaid child support and parking tickets might get arrested when they show up to vote. Stage 2: On election day, so-called “poll watchers” — often with fake badges and IDs that make them look like they’re in positions of authority — single out non-white voters with demands for ID and questions about their citizenship. They also often scare off eligible voters by taking photos and video footage (which sounds innocuous unless you happen to be among the roughly 7.5 million people being stalked each year). \nAnd, let’s not forget — here’s what “poll watchers” looked like during the post-Civil War Reconstruction era. ",
		"thread_title": "Donald Trump Hit With VERY Shady Voter Intimidation Lawsuit In Arizona (DETAILS)",
		"title": "Donald Trump Hit With VERY Shady Voter Intimidation Lawsuit In Arizona (DETAILS)",
		"type": "bs",
		"uuid": "5ed995f7a8f0033b7d1bbae26d36f487d14020d3"
	},
	"-KhIkJIEziZsZJVaSDnt": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-05T09:26:35.027+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d0b8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Social_Security_(United_States)"
				},
				"name": "Social Security",
				"salience": 0.5173364,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.1208791,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.06670724,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.04627504,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.035941087,
				"type": "PERSON"
			},
			{
				"name": "lifeline",
				"salience": 0.014763165,
				"type": "OTHER"
			},
			{
				"name": "loved ones",
				"salience": 0.013863473,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.010723179,
				"type": "PERSON"
			},
			{
				"name": "expenditure",
				"salience": 0.009147706,
				"type": "OTHER"
			},
			{
				"name": "Alex Lawson",
				"salience": 0.008450168,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00843818,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democrats",
				"salience": 0.008256016,
				"type": "PERSON"
			},
			{
				"name": "elderly",
				"salience": 0.008207749,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.008154827,
				"type": "LOCATION"
			},
			{
				"name": "lives",
				"salience": 0.007106598,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.007106598,
				"type": "EVENT"
			},
			{
				"name": "conservatives",
				"salience": 0.007106598,
				"type": "PERSON"
			},
			{
				"name": "social security",
				"salience": 0.004995507,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0288j83",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iowa_Democratic_Party"
				},
				"name": "Democrat",
				"salience": 0.0036151018,
				"type": "PERSON"
			},
			{
				"name": "folks",
				"salience": 0.0036120228,
				"type": "PERSON"
			},
			{
				"name": "care",
				"salience": 0.0031231032,
				"type": "OTHER"
			},
			{
				"name": "way",
				"salience": 0.0030450013,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0029314887,
				"type": "PERSON"
			},
			{
				"name": "streets",
				"salience": 0.0029314887,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.0029314887,
				"type": "LOCATION"
			},
			{
				"name": "poverty",
				"salience": 0.0029314887,
				"type": "OTHER"
			},
			{
				"name": "soul",
				"salience": 0.0029314887,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0029314887,
				"type": "PERSON"
			},
			{
				"name": "limits",
				"salience": 0.0029314887,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.002505471,
				"type": "PERSON"
			},
			{
				"name": "suicide",
				"salience": 0.002455147,
				"type": "EVENT"
			},
			{
				"name": "thinking",
				"salience": 0.0022856449,
				"type": "OTHER"
			},
			{
				"name": "remarks",
				"salience": 0.0021630025,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0021468424,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0021468424,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0021388615,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0021388615,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0021388615,
				"type": "PERSON"
			},
			{
				"name": "standpoint",
				"salience": 0.001979416,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.001979416,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.001979416,
				"type": "OTHER"
			},
			{
				"name": "thing",
				"salience": 0.0018662213,
				"type": "OTHER"
			},
			{
				"name": "real estate moguls",
				"salience": 0.0017107123,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.0016787625,
				"type": "OTHER"
			},
			{
				"name": "allotment",
				"salience": 0.0016787625,
				"type": "OTHER"
			},
			{
				"name": "extras",
				"salience": 0.0016787625,
				"type": "OTHER"
			},
			{
				"name": "politicians",
				"salience": 0.0016787625,
				"type": "PERSON"
			},
			{
				"name": "least",
				"salience": 0.0016787625,
				"type": "OTHER"
			},
			{
				"name": "heads",
				"salience": 0.0016787625,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.0013706101,
				"type": "WORK_OF_ART"
			},
			{
				"name": "election season",
				"salience": 0.0012542267,
				"type": "EVENT"
			},
			{
				"name": "benefits",
				"salience": 0.0012542267,
				"type": "OTHER"
			},
			{
				"name": "eyes",
				"salience": 0.0012542267,
				"type": "OTHER"
			},
			{
				"name": "donor class position",
				"salience": 0.0012542267,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0011771922,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0f1r9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_the_Treasury"
				},
				"name": "Treasury Department",
				"salience": 0.0010334601,
				"type": "ORGANIZATION"
			},
			{
				"name": "Ma and Pa Kettle",
				"salience": 0.0010334601,
				"type": "WORK_OF_ART"
			},
			{
				"name": "grandparents",
				"salience": 0.0009983138,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0009135257,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0009135257,
				"type": "WORK_OF_ART"
			},
			{
				"name": "meal",
				"salience": 0.0009135257,
				"type": "OTHER"
			},
			{
				"name": "ramen",
				"salience": 0.0009135257,
				"type": "OTHER"
			},
			{
				"name": "squalor",
				"salience": 0.0009135257,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0009135257,
				"type": "OTHER"
			},
			{
				"name": "followers",
				"salience": 0.0009135257,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/024v2j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Paul_Ryan"
				},
				"name": "Paul Ryan",
				"salience": 0.00082256977,
				"type": "PERSON"
			},
			{
				"name": "truth",
				"salience": 0.00074577524,
				"type": "OTHER"
			},
			{
				"name": "opposite",
				"salience": 0.00074577524,
				"type": "OTHER"
			},
			{
				"name": "motives",
				"salience": 0.0006824266,
				"type": "OTHER"
			},
			{
				"name": "money",
				"salience": 0.0006824266,
				"type": "OTHER"
			},
			{
				"name": "business deals",
				"salience": 0.0006824266,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "America",
				"salience": 0.00056227244,
				"type": "LOCATION"
			},
			{
				"name": "theory",
				"salience": 0.0005500775,
				"type": "OTHER"
			},
			{
				"name": "Social Security Works",
				"salience": 0.0004200087,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/10/Donald-Trump-sinking-of-the-Titanic.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-05T03:20:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.2,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0",
		"text": "0 419 \nSocial Security is the lifeline of many people who are either too elderly or disabled to support themselves or their loved ones financially. However, to Republicans and conservatives alike, it is an expenditure deemed too costly, even if it means certain death for those who depend on it. \nForget for a moment that elderly people who worked their entire lives have paid into social security, and should therefore be completely off limits. How could anyone with a soul leave the elderly to die in poverty? And what about those people who are physically and/or mentally disabled? Should we, as a nation, not take care of those citizens? Should we leave them to survive on the streets? \nDonald Trump is not known to do much critical thinking, especially before releasing a statement to the media, but his insane remarks on cutting Social Security have really got liberals fuming. Check out that time Trump told Paul Ryan that he would love to cut Social Security if he didn’t think it would be political suicide: \n“From a moral standpoint, I believe in it. But you also have to get elected. And there’s no way a Republican is going to beat a Democrat when the Republican is saying, ‘We’re going to cut your Social Security’ and the Democrat is saying, ‘We’re going to keep it and give you more.’ ” \nTrump is really trying to say that the lazy people in this country will always vote Democrat because it is Democrats who ensure that the less fortunate are, at least, able to keep their heads above water. To politicians like Donald Trump, these “extras” are killing the country. \nThat’s right folks, it’s Ma and Pa Kettle who are ruining the country with their $1200 monthly allotment from the Treasury Department. It certainly wouldn’t be wasteful, greedy real estate moguls who use other people’s money to pay for their extravagant business deals. \nAlex Lawson is the Executive Director of Social Security Works, and he has a much different theory on Trump’s motives with Social Security. Lawson had this to say about it: \n“It is really clear: Donald Trump would 100 percent go along with the Republican donor class position of cutting Social Security. He openly says he will lie to the people about it because he knows that the people are against it.” \n“In his eyes the ‘moral’ thing to do is to steal people’s hard-earned benefits and not talk about it.” \nAs we have learned throughout this election season, Donald Trump almost never tells the truth. Yet, he still convinces his mindless followers that he would somehow be good for America, regardless of the fact that there is nothing but evidence to prove the opposite. Trump won’t be happy until our grandparents are living in squalor and eating ramen for every meal. \nWake me up when November ends.. Share this Article!",
		"thread_title": "BREAKING: Trump Announces DEVASTATING Cuts To Social Security & His Reason Will Make You Vomit",
		"title": "BREAKING: Trump Announces DEVASTATING Cuts To Social Security & His Reason Will Make You Vomit",
		"type": "bs",
		"uuid": "36cd13a9c977fa8412c96a3b7f09143d1f3e2895"
	},
	"-KhIkJd7sQMvBx3cujFX": {
		"author": "Liz Lee",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-06T05:28:15.073+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.20771082,
				"type": "PERSON"
			},
			{
				"name": "Jacob Rascon",
				"salience": 0.08396801,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0fynw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Secret_Service"
				},
				"name": "Secret Service",
				"salience": 0.06548682,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign stage",
				"salience": 0.051870294,
				"type": "OTHER"
			},
			{
				"name": "Man",
				"salience": 0.043543775,
				"type": "PERSON"
			},
			{
				"name": "scare",
				"salience": 0.040725727,
				"type": "OTHER"
			},
			{
				"name": "rally",
				"salience": 0.028742688,
				"type": "EVENT"
			},
			{
				"name": "Officers",
				"salience": 0.028742688,
				"type": "PERSON"
			},
			{
				"name": "man",
				"salience": 0.027550489,
				"type": "PERSON"
			},
			{
				"name": "someone",
				"salience": 0.025504803,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.02185858,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/059_c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nevada"
				},
				"name": "Nevada",
				"salience": 0.02185858,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06kx2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reno,_Nevada"
				},
				"name": "Reno",
				"salience": 0.02185858,
				"type": "LOCATION"
			},
			{
				"name": "scuffle",
				"salience": 0.020428717,
				"type": "EVENT"
			},
			{
				"name": "crowd member",
				"salience": 0.018158816,
				"type": "PERSON"
			},
			{
				"name": "individual",
				"salience": 0.018122382,
				"type": "PERSON"
			},
			{
				"name": "Man",
				"salience": 0.016037468,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0gsgr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CNN"
				},
				"name": "CNN",
				"salience": 0.014616134,
				"type": "ORGANIZATION"
			},
			{
				"name": "gun",
				"salience": 0.013587065,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "stage",
				"salience": 0.011713611,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.011068093,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.011068093,
				"type": "OTHER"
			},
			{
				"name": "crowd",
				"salience": 0.009588844,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.009526934,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.008660417,
				"type": "OTHER"
			},
			{
				"name": "Jeanine",
				"salience": 0.008009009,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07ncdv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Trump_Organization"
				},
				"name": "Trump",
				"salience": 0.007816776,
				"type": "ORGANIZATION"
			},
			{
				"name": "man",
				"salience": 0.007011589,
				"type": "PERSON"
			},
			{
				"name": "back bathroom",
				"salience": 0.006729262,
				"type": "LOCATION"
			},
			{
				"name": "bathroom",
				"salience": 0.006729262,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.006567686,
				"type": "PERSON"
			},
			{
				"name": "crowd",
				"salience": 0.006478578,
				"type": "PERSON"
			},
			{
				"name": "venue",
				"salience": 0.0060770637,
				"type": "LOCATION"
			},
			{
				"name": "guard",
				"salience": 0.0060770637,
				"type": "PERSON"
			},
			{
				"name": "individual",
				"salience": 0.005850621,
				"type": "PERSON"
			},
			{
				"name": "front",
				"salience": 0.005850621,
				"type": "OTHER"
			},
			{
				"name": "bathroom",
				"salience": 0.0054956046,
				"type": "LOCATION"
			},
			{
				"name": "pictures",
				"salience": 0.0050673285,
				"type": "WORK_OF_ART"
			},
			{
				"name": "law enforcement",
				"salience": 0.0050673285,
				"type": "ORGANIZATION"
			},
			{
				"name": "guard",
				"salience": 0.004962744,
				"type": "PERSON"
			},
			{
				"name": "venue",
				"salience": 0.004962744,
				"type": "LOCATION"
			},
			{
				"name": "disturbance",
				"salience": 0.0049002976,
				"type": "OTHER"
			},
			{
				"name": "unit",
				"salience": 0.004244029,
				"type": "ORGANIZATION"
			},
			{
				"name": "disturbance",
				"salience": 0.004001424,
				"type": "OTHER"
			},
			{
				"name": "@Jacobnbc",
				"salience": 0.0037429575,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0037085514,
				"type": "OTHER"
			},
			{
				"name": "scuffle",
				"salience": 0.0035702433,
				"type": "OTHER"
			},
			{
				"name": "pic.twitter.com/rh319Gj1Ox",
				"salience": 0.0032414922,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/026r8jg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eric_Trump"
				},
				"name": "Eric Trump",
				"salience": 0.0032339534,
				"type": "PERSON"
			},
			{
				"name": "Justice",
				"salience": 0.0032116899,
				"type": "OTHER"
			},
			{
				"name": "liberals",
				"salience": 0.0032116899,
				"type": "OTHER"
			},
			{
				"name": "incident",
				"salience": 0.0032116899,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/05gnf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NBC"
				},
				"name": "NBC",
				"salience": 0.0031205819,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012qcd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/SWAT"
				},
				"name": "SWAT",
				"salience": 0.0031205819,
				"type": "ORGANIZATION"
			},
			{
				"name": "@Jacobnbc",
				"salience": 0.0029201398,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0025813987,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0023395517,
				"type": "WORK_OF_ART"
			},
			{
				"name": "video",
				"salience": 0.0023395517,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Article",
				"salience": 0.0023395517,
				"type": "WORK_OF_ART"
			},
			{
				"name": "screengrab",
				"salience": 0.0023395517,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0023395517,
				"type": "OTHER"
			},
			{
				"name": "secret service scare",
				"salience": 0.002018427,
				"type": "OTHER"
			},
			{
				"name": "Nobody",
				"salience": 0.0017556925,
				"type": "PERSON"
			},
			{
				"name": "Nobody",
				"salience": 0.0017556925,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/11/Snapshot_20161105_215213.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-06T04:08:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0.004",
		"text": "0 39 \nThe Republican presidential candidate, Donald Trump, suffered a serious scare tonight after being rushed off the campaign stage by Secret Service in Reno, Nevada. \nCNN reported that a crowd member yelled someone had a gun in the crowd. The scuffle happened close to the front of the stage. Secret Service removed one individual who appeared to be a white man in his 30s or 40s. \nHowever, Trump was quick to return to the stage after the individual was detained by local law enforcement and Secret Service. CNN reported that a SWAT unit also showed up at the front of the crowd. \nNBC news correspondent Jacob Rascon tweeted pictures showing the man was being detained in a back bathroom. Man who caused disturbance at Trump rally being held in bathroom in back of venue. Officers inside with him, and outside on guard. pic.twitter.com/rh319Gj1Ox \n— Jacob Rascon (@Jacobnbc) November 6, 2016 \n‘Man who caused disturbance at Trump rally being held in bathroom in back of venue. Officers inside with him, and outside on guard.’ \nHe also tweeted when Trump returned to the stage he said, “Nobody said it was going to be easy for us. But we will never be stopped.” Trump back on stage after secret service scare: \"Nobody said it was going to be easy for us. But we will never be stopped.\" \n— Jacob Rascon (@Jacobnbc) November 6, 2016 \nEric Trump, who was appearing on Justice With Judge Jeanine when the news broke, blamed liberals for the incident commenting: \n‘Listen, it’s interesting. That’s the tolerant left. That are the same people that were being paid to incite violence’ \nYou can watch the scuffle below. \nFeatured image screengrab from video . Share this Article! ",
		"thread_title": "BREAKING: Trump Dramatically Rushed Off Stage By Secret Service, Chaos Ensues (VIDEO)",
		"title": "BREAKING: Trump Dramatically Rushed Off Stage By Secret Service, Chaos Ensues (VIDEO)",
		"type": "bs",
		"uuid": "9aacfb583c9e524bc490fbad2a7b19fe90112adf"
	},
	"-KhIkK10v3dqeUQiE8-l": {
		"author": "Caleb R. Newton",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-17T21:05:44.920+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0b6k2_z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Julian_Assange"
				},
				"name": "Julian Assange",
				"salience": 0.702126,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.060811557,
				"type": "PERSON"
			},
			{
				"name": "lawyers",
				"salience": 0.0448102,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.023777315,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "WikiLeaks",
				"salience": 0.016426472,
				"type": "ORGANIZATION"
			},
			{
				"name": "charges",
				"salience": 0.013506121,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Obama",
				"salience": 0.00919287,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00842017,
				"type": "PERSON"
			},
			{
				"name": "efforts",
				"salience": 0.008364248,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.008353233,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0072527668,
				"type": "OTHER"
			},
			{
				"name": "authorities",
				"salience": 0.0063220817,
				"type": "PERSON"
			},
			{
				"name": "thorn",
				"salience": 0.004762541,
				"type": "OTHER"
			},
			{
				"name": "announcement",
				"salience": 0.0044154567,
				"type": "EVENT"
			},
			{
				"name": "administration",
				"salience": 0.004391808,
				"type": "ORGANIZATION"
			},
			{
				"name": "emails",
				"salience": 0.004388703,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0c3tl_f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chelsea_Manning"
				},
				"name": "Chelsea Manning",
				"salience": 0.0041276314,
				"type": "PERSON"
			},
			{
				"name": "rape charges",
				"salience": 0.003298409,
				"type": "OTHER"
			},
			{
				"name": "whistleblower",
				"salience": 0.0030367074,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0vqn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sweden"
				},
				"name": "Swedish",
				"salience": 0.002712915,
				"type": "LOCATION"
			},
			{
				"name": "intelligence officials",
				"salience": 0.0020464545,
				"type": "PERSON"
			},
			{
				"name": "effort",
				"salience": 0.001771905,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.001771905,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0014450677,
				"type": "PERSON"
			},
			{
				"name": "embassy",
				"salience": 0.0013858678,
				"type": "LOCATION"
			},
			{
				"name": "embassy",
				"salience": 0.0013858678,
				"type": "LOCATION"
			},
			{
				"name": "efforts",
				"salience": 0.0013582082,
				"type": "OTHER"
			},
			{
				"name": "set",
				"salience": 0.0012002529,
				"type": "OTHER"
			},
			{
				"name": "territory",
				"salience": 0.0012002529,
				"type": "LOCATION"
			},
			{
				"name": "efforts",
				"salience": 0.0011966269,
				"type": "OTHER"
			},
			{
				"name": "like",
				"salience": 0.0011192977,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.001090196,
				"type": "EVENT"
			},
			{
				"name": "investigation",
				"salience": 0.0010764713,
				"type": "EVENT"
			},
			{
				"name": "pardon",
				"salience": 0.0010764713,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.0010363238,
				"type": "EVENT"
			},
			{
				"name": "pardon",
				"salience": 0.0010363238,
				"type": "EVENT"
			},
			{
				"name": "administrations",
				"salience": 0.0010363238,
				"type": "ORGANIZATION"
			},
			{
				"name": "pardon",
				"salience": 0.0010363238,
				"type": "OTHER"
			},
			{
				"name": "Steve Bannon",
				"salience": 0.000933601,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.00087893335,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.00084178,
				"type": "LOCATION"
			},
			{
				"name": "anywhere",
				"salience": 0.00084178,
				"type": "LOCATION"
			},
			{
				"name": "soon",
				"salience": 0.00084178,
				"type": "OTHER"
			},
			{
				"name": "publication",
				"salience": 0.00084178,
				"type": "WORK_OF_ART"
			},
			{
				"name": "documents",
				"salience": 0.00084178,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wars",
				"salience": 0.00084178,
				"type": "EVENT"
			},
			{
				"name": "ones",
				"salience": 0.00084178,
				"type": "OTHER"
			},
			{
				"name": "appointments",
				"salience": 0.00084178,
				"type": "OTHER"
			},
			{
				"name": "counsel",
				"salience": 0.00081037625,
				"type": "PERSON"
			},
			{
				"name": "email",
				"salience": 0.0008009556,
				"type": "WORK_OF_ART"
			},
			{
				"name": "emails",
				"salience": 0.0008009556,
				"type": "WORK_OF_ART"
			},
			{
				"name": "interest",
				"salience": 0.0007936363,
				"type": "OTHER"
			},
			{
				"name": "lead",
				"salience": 0.0007936363,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0007510364,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "U.K.",
				"salience": 0.0007390339,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02k1b",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ecuador"
				},
				"name": "Ecuadorian",
				"salience": 0.0007390339,
				"type": "LOCATION"
			},
			{
				"name": "officials",
				"salience": 0.0007108036,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04cmyw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Debbie_Wasserman_Schultz"
				},
				"name": "Debbie Wasserman Schultz",
				"salience": 0.00069753744,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.00069753744,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.00068727083,
				"type": "PERSON"
			},
			{
				"name": "custody",
				"salience": 0.00068727083,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00068727083,
				"type": "ORGANIZATION"
			},
			{
				"name": "hope",
				"salience": 0.00068727083,
				"type": "OTHER"
			},
			{
				"name": "release",
				"salience": 0.00068727083,
				"type": "EVENT"
			},
			{
				"name": "work",
				"salience": 0.00068727083,
				"type": "WORK_OF_ART"
			},
			{
				"name": "earpiece",
				"salience": 0.00064795656,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.0006450634,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.0005516227,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0005322816,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0005182183,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0jdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Afghanistan"
				},
				"name": "Afghanistan",
				"salience": 0.0005182183,
				"type": "LOCATION"
			},
			{
				"name": "Bradley",
				"salience": 0.0005182183,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wh1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Army"
				},
				"name": "Army",
				"salience": 0.0005182183,
				"type": "ORGANIZATION"
			},
			{
				"name": "organization",
				"salience": 0.0005134512,
				"type": "ORGANIZATION"
			},
			{
				"name": "translation",
				"salience": 0.0005134512,
				"type": "OTHER"
			},
			{
				"name": "occasions",
				"salience": 0.0005134512,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/04jpl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London"
				},
				"name": "London",
				"salience": 0.0004988777,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0g2t6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/London_Evening_Standard"
				},
				"name": "Evening Standard",
				"salience": 0.0004988777,
				"type": "ORGANIZATION"
			},
			{
				"name": "earpiece",
				"salience": 0.00048407374,
				"type": "OTHER"
			},
			{
				"name": "figures",
				"salience": 0.00047830894,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.00042306658,
				"type": "EVENT"
			},
			{
				"name": "anti-Clinton",
				"salience": 0.00042306658,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00042306658,
				"type": "LOCATION"
			},
			{
				"name": "presidency",
				"salience": 0.00038677562,
				"type": "OTHER"
			},
			{
				"name": "email contents",
				"salience": 0.00037396536,
				"type": "OTHER"
			},
			{
				"name": "establishment conservatives",
				"salience": 0.00037396536,
				"type": "PERSON"
			},
			{
				"name": "action",
				"salience": 0.00037396536,
				"type": "OTHER"
			},
			{
				"name": "story",
				"salience": 0.00037396536,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.00035731398,
				"type": "EVENT"
			},
			{
				"name": "figures",
				"salience": 0.00035731398,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.00032261695,
				"type": "PERSON"
			},
			{
				"name": "leadership",
				"salience": 0.00032261695,
				"type": "OTHER"
			},
			{
				"name": "party chairperson",
				"salience": 0.00032261695,
				"type": "PERSON"
			},
			{
				"name": "observer",
				"salience": 0.00031712852,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00031604024,
				"type": "ORGANIZATION"
			},
			{
				"name": "frame",
				"salience": 0.00027935606,
				"type": "OTHER"
			},
			{
				"name": "cache",
				"salience": 0.00027935606,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.00027935606,
				"type": "PERSON"
			},
			{
				"name": "tenure",
				"salience": 0.00027935606,
				"type": "OTHER"
			},
			{
				"name": "credibility",
				"salience": 0.000268927,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g5b55l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Reince_Priebus"
				},
				"name": "Reince Priebus",
				"salience": 0.00023016777,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.00019338416,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/11/GettyImages-508572332.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-17T19:44:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0.607",
		"text": "0 122 \nWikiLeaks co-founder Julian Assange’s lawyers have suggested that the globally detested, thorn in the side social figure will keep at, and even perhaps intensify, efforts to be fully pardoned by the United States once President-elect Donald Trump takes office next year. \nAssange’s lawyers made the announcement after the controversial global “whistleblower” spoke with Swedish authorities who had come to consult with him within the neutral territory of the Ecuadorian embassy in the U.K. over rape charges which Assange faces in Sweden. \nAssange has been holed up in the aforementioned embassy for years in an effort to escape facing the diverse set of global charges which have been lobbed against him. \nAnd, as for a pivoted effort for Assange to escape the charges he faces, one directed at attempting to garner a Trump signed, U.S. presidential pardon, Assange’s lawyers said, according to London’s Evening Standard , “Through U.S. counsel, we had reached out to the Obama administration, most recently just a few months ago, and we will continue to do so with future U.S. administrations until the investigation is closed.” \nThese efforts at a presidential pardon for Assange began, as noted, under the Obama administration, but with Obama’s own federal appointments and the soon to be former president himself as the ones to ever begin an investigation into Assange in the first place, efforts for an Obama pardon of Assange unsurprisingly never got anywhere. \nThe U.S. investigation was first prompted by Assange’s publication of classified documents related to the wars in Iraq and Afghanistan delivered to him by Army whistleblower Bradley/Chelsea Manning — who, mind you, is still in American custody and doesn’t seem to have much of a hope of release anytime soon. \nAssange’s more recent work, during the lead up to Election Day, quickly turned into an elaborate anti-Clinton campaign, one viewed by American intelligence officials as backed by the Russian government in the interest of seeing their preferred candidate — Trump — elected to the presidency. \nWikiLeaks published in this time frame a huge cache of emails hacked from key members of the Democratic Party leadership and the Hillary Clinton presidential campaign, targeting figures from the now former party chairperson and U.S. Representative Debbie Wasserman Schultz to Clinton campaign chairman John Podesta. WikiLeaks also released many thousands of emails taken from Clinton’s tenure as secretary of state serving under President Obama. \nThe credibility of the emails has been occasionally questioned. Indeed, even if the organization only received and hacked actual emails and the like that had actually come from Democratic Party officials. WikiLeaks was still found, on multiple occasions, to have been improperly spinning the email contents. Such as the time a mundane email about then Secretary of State Hillary Clinton’s UN translation providing earpiece, was spun into a fake story about Clinton using an earpiece to be fed what she was supposed to say. \nTrump is far from predictable enough for any observer to definitively suggest his course of action regarding Assange once he takes office. He continues to surround himself with figures ranging from “level-headed,” establishment conservatives like Reince Priebus, to the far right controversial at best conservative media guru Steve Bannon. ",
		"thread_title": "Julian Assange Makes VERY Suspect Post Election Announcement, Seeks Pardon From Trump",
		"title": "Julian Assange Makes VERY Suspect Post Election Announcement, Seeks Pardon From Trump",
		"type": "bs",
		"uuid": "adb2a58098a992de4af5a2eb7f2b0185b1ab1880"
	},
	"-KhIkKDg6UHG8SM8OBhH": {
		"author": "Natalie Thongrit",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-20T06:03:29.035+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"metadata": {
					"mid": "/m/05ngt2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pope_Francis"
				},
				"name": "Pope Francis",
				"salience": 0.46876454,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cv_2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Associated_Press"
				},
				"name": "Associated Press",
				"salience": 0.06152817,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.029959831,
				"type": "PERSON"
			},
			{
				"name": "virus",
				"salience": 0.028941156,
				"type": "OTHER"
			},
			{
				"name": "cardinals",
				"salience": 0.024864836,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/08l9m9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tobin_Bell"
				},
				"name": "Joseph Tobin",
				"salience": 0.024465958,
				"type": "PERSON"
			},
			{
				"name": "ceremony",
				"salience": 0.022473555,
				"type": "EVENT"
			},
			{
				"name": "divisiveness",
				"salience": 0.022473555,
				"type": "OTHER"
			},
			{
				"name": "attendees",
				"salience": 0.022473555,
				"type": "PERSON"
			},
			{
				"name": "church",
				"salience": 0.022473555,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02vxy_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Catholic_Church"
				},
				"name": "Roman Catholic Church",
				"salience": 0.013882993,
				"type": "ORGANIZATION"
			},
			{
				"name": "cardinals",
				"salience": 0.012762326,
				"type": "PERSON"
			},
			{
				"name": "polarization",
				"salience": 0.011528901,
				"type": "OTHER"
			},
			{
				"name": "barriers",
				"salience": 0.0098639075,
				"type": "OTHER"
			},
			{
				"name": "hearts",
				"salience": 0.008858141,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.008599606,
				"type": "PERSON"
			},
			{
				"name": "group",
				"salience": 0.008160802,
				"type": "ORGANIZATION"
			},
			{
				"name": "name",
				"salience": 0.0062169973,
				"type": "OTHER"
			},
			{
				"name": "coincidence",
				"salience": 0.0062169973,
				"type": "OTHER"
			},
			{
				"name": "walls",
				"salience": 0.0055596656,
				"type": "OTHER"
			},
			{
				"name": "divide",
				"salience": 0.0047579096,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0047579096,
				"type": "PERSON"
			},
			{
				"name": "attendance",
				"salience": 0.0047579096,
				"type": "OTHER"
			},
			{
				"name": "speech",
				"salience": 0.0047579096,
				"type": "EVENT"
			},
			{
				"name": "enemy",
				"salience": 0.004642186,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.0043996405,
				"type": "PERSON"
			},
			{
				"name": "label",
				"salience": 0.0041208477,
				"type": "ORGANIZATION"
			},
			{
				"name": "warning",
				"salience": 0.0041208477,
				"type": "OTHER"
			},
			{
				"name": "refugee",
				"salience": 0.0038511914,
				"type": "PERSON"
			},
			{
				"name": "immigrant",
				"salience": 0.0038511914,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0036695173,
				"type": "LOCATION"
			},
			{
				"name": "man",
				"salience": 0.0036071518,
				"type": "PERSON"
			},
			{
				"name": "status",
				"salience": 0.0035581675,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0035581675,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0035581675,
				"type": "OTHER"
			},
			{
				"name": "status",
				"salience": 0.0035581675,
				"type": "OTHER"
			},
			{
				"name": "polarization",
				"salience": 0.0033374627,
				"type": "OTHER"
			},
			{
				"name": "electorate",
				"salience": 0.0033374627,
				"type": "PERSON"
			},
			{
				"name": "speech",
				"salience": 0.0033374627,
				"type": "WORK_OF_ART"
			},
			{
				"name": "ceremony",
				"salience": 0.0033158676,
				"type": "EVENT"
			},
			{
				"name": "border wall",
				"salience": 0.003266485,
				"type": "OTHER"
			},
			{
				"name": "wall",
				"salience": 0.003266485,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0032130026,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0032130026,
				"type": "OTHER"
			},
			{
				"name": "mass deportation",
				"salience": 0.0030406052,
				"type": "EVENT"
			},
			{
				"name": "customs",
				"salience": 0.0030406052,
				"type": "OTHER"
			},
			{
				"name": "thinking",
				"salience": 0.002890346,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.002890346,
				"type": "PERSON"
			},
			{
				"name": "animosity",
				"salience": 0.002890346,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0027825388,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0027825388,
				"type": "LOCATION"
			},
			{
				"name": "stranger",
				"salience": 0.0027825388,
				"type": "PERSON"
			},
			{
				"name": "person",
				"salience": 0.0027297207,
				"type": "PERSON"
			},
			{
				"name": "border",
				"salience": 0.0027250708,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.002678748,
				"type": "OTHER"
			},
			{
				"name": "time",
				"salience": 0.0025142853,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0024407008,
				"type": "PERSON"
			},
			{
				"name": "immigrants",
				"salience": 0.0024407008,
				"type": "PERSON"
			},
			{
				"name": "refugees",
				"salience": 0.0024407008,
				"type": "PERSON"
			},
			{
				"name": "campaign promises",
				"salience": 0.0023599092,
				"type": "OTHER"
			},
			{
				"name": "construction",
				"salience": 0.0023599092,
				"type": "OTHER"
			},
			{
				"name": "bridges",
				"salience": 0.0023008434,
				"type": "LOCATION"
			},
			{
				"name": "priority",
				"salience": 0.0020269442,
				"type": "OTHER"
			},
			{
				"name": "efforts",
				"salience": 0.0017631314,
				"type": "OTHER"
			},
			{
				"name": "aid",
				"salience": 0.0017631314,
				"type": "OTHER"
			},
			{
				"name": "number",
				"salience": 0.0017631314,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0017631314,
				"type": "EVENT"
			},
			{
				"name": "clip",
				"salience": 0.0016973363,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.001650354,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0014830176,
				"type": "PERSON"
			},
			{
				"name": "image",
				"salience": 0.0014830176,
				"type": "WORK_OF_ART"
			},
			{
				"name": "U.S.-Mexico",
				"salience": 0.0014527929,
				"type": "LOCATION"
			},
			{
				"name": "one",
				"salience": 0.0013339863,
				"type": "OTHER"
			},
			{
				"name": "refugees",
				"salience": 0.0013281829,
				"type": "PERSON"
			},
			{
				"name": "immigration",
				"salience": 0.0013281829,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.0012841965,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0012841965,
				"type": "ORGANIZATION"
			},
			{
				"name": "remarks",
				"salience": 0.0012841965,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0012841965,
				"type": "WORK_OF_ART"
			},
			{
				"name": "nation",
				"salience": 0.0012841965,
				"type": "LOCATION"
			},
			{
				"name": "reflection",
				"salience": 0.0012841965,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03v1s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indiana"
				},
				"name": "Indiana",
				"salience": 0.0012533413,
				"type": "LOCATION"
			},
			{
				"name": "cardinals",
				"salience": 0.0012270206,
				"type": "PERSON"
			},
			{
				"name": "building walls",
				"salience": 0.0012270206,
				"type": "LOCATION"
			},
			{
				"name": "lot",
				"salience": 0.0010351718,
				"type": "OTHER"
			},
			{
				"name": "news",
				"salience": 0.0009593301,
				"type": "OTHER"
			},
			{
				"name": "wherever",
				"salience": 0.0009593301,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01wxvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Getty_Images"
				},
				"name": "Getty Images",
				"salience": 0.0009128288,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christian",
				"salience": 0.00087482674,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09jcvs",
					"wikipedia_url": "http://en.wikipedia.org/wiki/YouTube"
				},
				"name": "YouTube",
				"salience": 0.0007904232,
				"type": "OTHER"
			},
			{
				"name": "Franco Origlia",
				"salience": 0.0007904232,
				"type": "PERSON"
			},
			{
				"name": "views",
				"salience": 0.0007732801,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ftxw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indianapolis"
				},
				"name": "Indianapolis",
				"salience": 0.0006818796,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/11/GettyImages-6243444281-e1479582722445.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-19T22:35:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 3.9,
			"score": 0
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0.12",
		"text": "0 129 \nOn Saturday, during a ceremony welcoming 17 new cardinals into the Roman Catholic Church, Pope Francis warned attendees about the divisiveness that he feels is spreading throughout the church. The Associated Press reports that Pope Francis cautioned against the “virus of polarization,” telling the new group of cardinals, “we are not immune from this.” \nDuring his speech, Pope Francis specifically issued a warning about “our pitiful hearts that tend to judge, divide, oppose, and condemn” and those who “raise walls, build barriers, and label people.” He also encouraged those in attendance to not be so quick to deem those who are different from them an enemy or a threat. \n‘We see, for example, how quickly those among us with the status of the stranger, an immigrant, or a refugee, become a threat, take on the status of an enemy. An enemy because they come from a distant country, or have different customs. \n‘The virus of polarization and animosity permeates our way of thinking, feeling and acting.’ \nPope Francis never called out Donald Trump by name; however, it seems to be more than a mere coincidence that he delivered a speech about accepting immigrants shortly after the United States electorate chose as their leader for the next four years a man who has proposed mass deportation and the construction of a wall on the U.S.-Mexico border. \nThis is not the first time that the Pope has spoken out against Donald Trump and his campaign promises, either. In February of this year, when asked about Trump’s proposed border wall, he said , “a person who only thinks about building walls, wherever they may be, and not building bridges, is not Christian.” \nAt least one of the newly appointed cardinals has views similar to Pope Francis’s when it comes to immigration. Indianapolis Archbishop Joseph Tobin, who was in the news recently for helping to resettle Syrian refugees despite now vice president-elect Mike Pence’s best efforts to block aid to and limit the number of Syrian refugees in Indiana. \nTobin recently addressed Trump’s victory, saying that, under him, the priority of settling immigrants and refugees “is going to be challenging.” He added, though, that he believes “the ethical reflection of a nation isn’t reduced to the government” and said that he has “a lot of faith in the American people.” \nWatch a clip from today’s ceremony, which includes Pope Francis’s remarks, below, via YouTube : \nFeatured image via Franco Origlia/Getty Images Share this Article! ",
		"thread_title": "Pope Francis Takes Backhanded Swipe At Trump, & Those Who 'Raise Walls, & Label People'",
		"title": "Pope Francis Takes Backhanded Swipe At Trump, & Those Who 'Raise Walls, & Label People'",
		"type": "bs",
		"uuid": "ffa7abe0749798a06d48f28a0cc45ca4ca5470bb"
	},
	"-KhIkKTL_93knc9GsAaX": {
		"author": "",
		"comments": "0",
		"country": "FR",
		"crawled": "2016-11-20T08:22:17.521+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Trump",
				"salience": 0.18398356,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.098116964,
				"type": "LOCATION"
			},
			{
				"name": "letter",
				"salience": 0.05088474,
				"type": "WORK_OF_ART"
			},
			{
				"name": "jab",
				"salience": 0.03130028,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.02740223,
				"type": "ORGANIZATION"
			},
			{
				"name": "words",
				"salience": 0.025476214,
				"type": "OTHER"
			},
			{
				"name": "leader",
				"salience": 0.025476214,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.025476214,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.025476214,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.020323236,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0vkm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/American_Civil_Liberties_Union"
				},
				"name": "American Civil Liberties Union",
				"salience": 0.020157313,
				"type": "ORGANIZATION"
			},
			{
				"name": "letter",
				"salience": 0.019816775,
				"type": "WORK_OF_ART"
			},
			{
				"name": "president-elect",
				"salience": 0.018044813,
				"type": "PERSON"
			},
			{
				"name": "jab",
				"salience": 0.016876055,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.016800981,
				"type": "OTHER"
			},
			{
				"name": "immigrants",
				"salience": 0.010724645,
				"type": "PERSON"
			},
			{
				"name": "Many",
				"salience": 0.009735667,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.007942945,
				"type": "OTHER"
			},
			{
				"name": "change course",
				"salience": 0.007942945,
				"type": "OTHER"
			},
			{
				"name": "surveillance programs",
				"salience": 0.007815905,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0172l5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Griswold_v._Connecticut"
				},
				"name": "Griswold",
				"salience": 0.0076865917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/012zdj6q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Obergefell_v._Hodges"
				},
				"name": "Obergefell",
				"salience": 0.0076865917,
				"type": "OTHER"
			},
			{
				"name": "president-elect",
				"salience": 0.007445816,
				"type": "PERSON"
			},
			{
				"name": "campaign",
				"salience": 0.006879444,
				"type": "EVENT"
			},
			{
				"name": "freedom",
				"salience": 0.006879444,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00667825,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00667825,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0064292816,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.006212258,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.006212258,
				"type": "OTHER"
			},
			{
				"name": "defender",
				"salience": 0.006212258,
				"type": "PERSON"
			},
			{
				"name": "right",
				"salience": 0.005453173,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.005453173,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.005453173,
				"type": "OTHER"
			},
			{
				"name": "career",
				"salience": 0.005380145,
				"type": "OTHER"
			},
			{
				"name": "request",
				"salience": 0.005380145,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.005380145,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.005380145,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.005380145,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.005027957,
				"type": "LOCATION"
			},
			{
				"name": "result",
				"salience": 0.0049235546,
				"type": "OTHER"
			},
			{
				"name": "statement",
				"salience": 0.00488677,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statutes",
				"salience": 0.004825244,
				"type": "OTHER"
			},
			{
				"name": "litigation",
				"salience": 0.004357045,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.004357045,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.0040630666,
				"type": "LOCATION"
			},
			{
				"name": "science",
				"salience": 0.003773178,
				"type": "OTHER"
			},
			{
				"name": "classrooms",
				"salience": 0.003773178,
				"type": "LOCATION"
			},
			{
				"name": "evolution",
				"salience": 0.003773178,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.003773178,
				"type": "EVENT"
			},
			{
				"name": "advocacy",
				"salience": 0.003773178,
				"type": "OTHER"
			},
			{
				"name": "treaties",
				"salience": 0.003773178,
				"type": "OTHER"
			},
			{
				"name": "Amendments",
				"salience": 0.003773178,
				"type": "WORK_OF_ART"
			},
			{
				"name": "freedom",
				"salience": 0.0037449794,
				"type": "OTHER"
			},
			{
				"name": "waterboarding",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "abortion services",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "woman",
				"salience": 0.0036324053,
				"type": "PERSON"
			},
			{
				"name": "forms",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "libel laws",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "expression",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "proposals",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "entry",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "deportation force",
				"salience": 0.0036324053,
				"type": "OTHER"
			},
			{
				"name": "couples",
				"salience": 0.0035573659,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0033990415,
				"type": "OTHER"
			},
			{
				"name": "attorney",
				"salience": 0.0030805708,
				"type": "PERSON"
			},
			{
				"name": "contraception",
				"salience": 0.0030805708,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0030805708,
				"type": "OTHER"
			},
			{
				"name": "internment",
				"salience": 0.0030805708,
				"type": "OTHER"
			},
			{
				"name": "open letter",
				"salience": 0.0030447512,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rights",
				"salience": 0.0029680347,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0029434497,
				"type": "LOCATION"
			},
			{
				"name": "firepower",
				"salience": 0.0029043423,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0028942106,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07sz1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Supreme_Court_of_the_United_States"
				},
				"name": "Supreme Court",
				"salience": 0.0028008225,
				"type": "ORGANIZATION"
			},
			{
				"name": "litigators",
				"salience": 0.0026577117,
				"type": "PERSON"
			},
			{
				"name": "firepower",
				"salience": 0.0026577117,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0026150753,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sj2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fourth_Amendment_to_the_United_States_Constitution"
				},
				"name": "Fourth",
				"salience": 0.0023227911,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07skl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eighth_Amendment_to_the_United_States_Constitution"
				},
				"name": "Eighth",
				"salience": 0.0023227911,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sjg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Fifth_Amendment_to_the_United_States_Constitution"
				},
				"name": "Fifth",
				"salience": 0.0023227911,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "Constitution",
				"salience": 0.0023227911,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/07sgz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/First_Amendment_to_the_United_States_Constitution"
				},
				"name": "First",
				"salience": 0.0023227911,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/015r3q",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_T._Scopes"
				},
				"name": "Scopes",
				"salience": 0.0023227911,
				"type": "OTHER"
			},
			{
				"name": "President-elect",
				"salience": 0.0023206484,
				"type": "PERSON"
			},
			{
				"name": "step",
				"salience": 0.0023014226,
				"type": "OTHER"
			},
			{
				"name": "staff",
				"salience": 0.0023014226,
				"type": "PERSON"
			},
			{
				"name": "reality",
				"salience": 0.0023014226,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0023014226,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0023014226,
				"type": "PERSON"
			},
			{
				"name": "endeavor",
				"salience": 0.0023014226,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.0023014226,
				"type": "PERSON"
			},
			{
				"name": "volunteers",
				"salience": 0.0023014226,
				"type": "PERSON"
			},
			{
				"name": "thousands",
				"salience": 0.0023014226,
				"type": "PERSON"
			},
			{
				"name": "encroachment",
				"salience": 0.0023014226,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.002236098,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.0021600497,
				"type": "OTHER"
			},
			{
				"name": "freedoms",
				"salience": 0.0021439,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0019535995,
				"type": "WORK_OF_ART"
			},
			{
				"name": "presidents",
				"salience": 0.0019535995,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0n1j7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Defense_of_Marriage_Act"
				},
				"name": "Defense of Marriage Act",
				"salience": 0.0018962814,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0gg7stg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_v._Windsor"
				},
				"name": "Windsor",
				"salience": 0.0018962814,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012pg6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Gideon_v._Wainwright"
				},
				"name": "Gideon",
				"salience": 0.0018962814,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/016m7r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Miranda_v._Arizona"
				},
				"name": "Miranda",
				"salience": 0.0018962814,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cn68",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Japanese_Americans"
				},
				"name": "Japanese",
				"salience": 0.0018962814,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01kdjw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Korematsu_v._United_States"
				},
				"name": "Korematsu",
				"salience": 0.0018962814,
				"type": "PERSON"
			},
			{
				"name": "tenure",
				"salience": 0.0016761919,
				"type": "OTHER"
			},
			{
				"name": "successor",
				"salience": 0.0016761919,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0016761919,
				"type": "WORK_OF_ART"
			},
			{
				"name": "couples",
				"salience": 0.0014460315,
				"type": "PERSON"
			},
			{
				"name": "ACLU National",
				"salience": 0.0014283893,
				"type": "ORGANIZATION"
			},
			{
				"name": "concentration camp hell",
				"salience": 0.0012521235,
				"type": "OTHER"
			},
			{
				"name": "road",
				"salience": 0.0012521235,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0012521235,
				"type": "OTHER"
			},
			{
				"name": "nightmare",
				"salience": 0.0012521235,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0012521235,
				"type": "OTHER"
			},
			{
				"name": "land",
				"salience": 0.0012521235,
				"type": "LOCATION"
			},
			{
				"name": "premise",
				"salience": 0.0012521235,
				"type": "OTHER"
			},
			{
				"name": "parties",
				"salience": 0.0012521235,
				"type": "ORGANIZATION"
			},
			{
				"name": "others",
				"salience": 0.0012521235,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01hhz7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Oval_Office"
				},
				"name": "Oval Office",
				"salience": 0.0011914244,
				"type": "ORGANIZATION"
			},
			{
				"name": "campaign",
				"salience": 0.0011228517,
				"type": "EVENT"
			},
			{
				"name": "Trump pic.twitter.com/FOpRqn9oNY",
				"salience": 0.0010316488,
				"type": "OTHER"
			},
			{
				"name": "@ACLU",
				"salience": 0.0010316488,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/11/GettyImages-462077668.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-20T03:50:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 7.5,
			"score": 0.1
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0",
		"text": "0 1949 \nThe ACLU has got a few words for America’s newest elected “leader,” and the letter they just published through the NY Times, is probably the most amazing jab in the history of politics. It doesn’t hurt that the jab came from the American Civil Liberties Union, because the power behind the letter is what makes it so ominous to the president-elect. \nThe letter begins with a request for Trump to “change course” on many of the claims he has made in his extremely short political career. \n“Dear President-Elect Trump, \nFor nearly 100 years, the ACLU has stood as this nation’s premier defender of freedom and justice for all. \nAs you assume the nation’s highest office, we must ask you now as president-elect to reconsider and change course on certain campaign promises you have made. \nSpecifically, you promised to: amass deportation force to remove 11 million undocumented immigrants ban the entry of Muslims and institute aggressive surveillance programs targeting them restrict a woman’s right to abortion services reauthorize waterboarding and other forms of torture change our nation’s libel laws and restrict freedom of expression” \nAs if this statement alone wasn’t enough of a threat, the ACLU continues: \n“These proposals are not simply un-American and wrong-headed. They are unlawful and unconstitutional, and would violate the First, Fourth, Fifth, Eighth, and Fourteenth Amendments of the Constitution, as well as other statutes and international treaties.” \n“Many of our country’s most cherished rights are the result of ACLU litigation and advocacy. They include the Scopes trial (the right to teach evolution in public science classrooms) and the following Supreme Court cases: Korematsu (challenging Japanese American internment); Miranda (the right to remain silent); Griswold (the right to contraception); Loving (the right of interracial couples to marry); Gideon (the right to a court-appointed attorney if you can’t afford one); Windsor (striking down the federal Defense of Marriage Act); and Obergefell (the right of same-sex couples to marry) and others. We have worked with and battled American presidents of both parties to ensure that our country makes good on it’s founding premise as the land of the free.” \nIn the end of the open letter, the ACLU promises to make Trump’s life a nightmare if he continues to pave his road to concentration camp hell. They say Trump will have the full firepower of the ACLU to deal with if he doesn’t wise up. \nThey letter concludes: \n“If you do not reverse course and endeavor to make these campaign promises a reality, you will have to contend with the full firepower of the ACLU at your every step. Our staff of litigators and activists in every state, thousands of volunteers, and millions of supporters stand ready to fight against any encroachment on our cherished freedoms and rights.” \n“One thing is certain: We will be vigilant every day of your tenure as president. And when you ultimately vacate the Oval Office, we will do likewise with your successor.” Today we published a full-page open letter in the New York Times to President-elect Trump pic.twitter.com/FOpRqn9oNY \n— ACLU National (@ACLU) November 11, 2016 Share this Article!",
		"thread_title": "JUST IN: ACLU Makes FULL PAGE Donald Trump Announcement Via New York Times (IMAGE)",
		"title": "JUST IN: ACLU Makes FULL PAGE Donald Trump Announcement Via New York Times (IMAGE)",
		"type": "bs",
		"uuid": "8445664d8af11f5bdf58f3b6a003f763deab2cfb"
	},
	"-KhIkKmkEkElQJ4mAev9": {
		"author": "Carissa House-Dunphy",
		"comments": "0",
		"country": "US",
		"crawled": "2016-11-22T16:37:31.116+02:00",
		"domain_rank": "7587",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0157m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bill_Clinton"
				},
				"name": "Bill Clinton",
				"salience": 0.2829307,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02rc6ry",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Morning_Joe"
				},
				"name": "Morning Joe",
				"salience": 0.13800822,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.13519216,
				"type": "PERSON"
			},
			{
				"name": "email server",
				"salience": 0.042817365,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.038594667,
				"type": "PERSON"
			},
			{
				"name": "decision",
				"salience": 0.029338498,
				"type": "OTHER"
			},
			{
				"name": "email server",
				"salience": 0.026761567,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.024746034,
				"type": "OTHER"
			},
			{
				"name": "secretary of state",
				"salience": 0.02236753,
				"type": "PERSON"
			},
			{
				"name": "source",
				"salience": 0.02236753,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.015199645,
				"type": "PERSON"
			},
			{
				"name": "prosecutor",
				"salience": 0.014073114,
				"type": "PERSON"
			},
			{
				"name": "investigations",
				"salience": 0.012705233,
				"type": "EVENT"
			},
			{
				"name": "email server use",
				"salience": 0.012705233,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0152x_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/MSNBC"
				},
				"name": "MSNBC",
				"salience": 0.011977101,
				"type": "ORGANIZATION"
			},
			{
				"name": "Source",
				"salience": 0.010640652,
				"type": "ORGANIZATION"
			},
			{
				"name": "@Morning_Joe @realDonaldTrump",
				"salience": 0.009270062,
				"type": "OTHER"
			},
			{
				"name": "@HillaryClinton",
				"salience": 0.008480355,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.007730227,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.006190209,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0fqw_s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Clinton_Foundation"
				},
				"name": "Clinton Foundation",
				"salience": 0.0061310884,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/05xy1t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lesley_Stahl"
				},
				"name": "Lesley Stahl",
				"salience": 0.005861152,
				"type": "PERSON"
			},
			{
				"name": "smoke",
				"salience": 0.0054380842,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.004292221,
				"type": "LOCATION"
			},
			{
				"name": "campaign bluster",
				"salience": 0.004103309,
				"type": "OTHER"
			},
			{
				"name": "jail",
				"salience": 0.004103309,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.004103309,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.003680285,
				"type": "OTHER"
			},
			{
				"name": "supporters",
				"salience": 0.0035430738,
				"type": "PERSON"
			},
			{
				"name": "supporters",
				"salience": 0.0035430738,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.003323324,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.003199401,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.003199401,
				"type": "PERSON"
			},
			{
				"name": "change",
				"salience": 0.0030663481,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.002878134,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.002878134,
				"type": "OTHER"
			},
			{
				"name": "walkbacks",
				"salience": 0.002878134,
				"type": "LOCATION"
			},
			{
				"name": "situation",
				"salience": 0.002878134,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0027707897,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.002752858,
				"type": "PERSON"
			},
			{
				"name": "secretary of state",
				"salience": 0.0027135685,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0027135685,
				"type": "LOCATION"
			},
			{
				"name": "supporters",
				"salience": 0.0026978895,
				"type": "PERSON"
			},
			{
				"name": "justice",
				"salience": 0.0024102912,
				"type": "OTHER"
			},
			{
				"name": "plans",
				"salience": 0.0023499697,
				"type": "OTHER"
			},
			{
				"name": "investigations",
				"salience": 0.0022453968,
				"type": "EVENT"
			},
			{
				"name": "investigations",
				"salience": 0.0022453968,
				"type": "EVENT"
			},
			{
				"name": "man",
				"salience": 0.002056841,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0020274757,
				"type": "LOCATION"
			},
			{
				"name": "course",
				"salience": 0.0017557319,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.0017557319,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0017557319,
				"type": "OTHER"
			},
			{
				"name": "committees",
				"salience": 0.0017557319,
				"type": "ORGANIZATION"
			},
			{
				"name": "hatred",
				"salience": 0.0012788225,
				"type": "OTHER"
			},
			{
				"name": "minds",
				"salience": 0.0012788225,
				"type": "OTHER"
			},
			{
				"name": "vengeance",
				"salience": 0.0012788225,
				"type": "OTHER"
			},
			{
				"name": "mirrors",
				"salience": 0.0012788225,
				"type": "OTHER"
			},
			{
				"name": "image",
				"salience": 0.0012788225,
				"type": "WORK_OF_ART"
			},
			{
				"name": "campaign trail",
				"salience": 0.0012788225,
				"type": "LOCATION"
			},
			{
				"name": "promise",
				"salience": 0.0012788225,
				"type": "OTHER"
			},
			{
				"name": "Article",
				"salience": 0.0012788225,
				"type": "WORK_OF_ART"
			},
			{
				"name": "wrongdoing",
				"salience": 0.0012788225,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0012788225,
				"type": "OTHER"
			},
			{
				"name": "hers",
				"salience": 0.0012788225,
				"type": "OTHER"
			},
			{
				"name": "predecessor",
				"salience": 0.0012788225,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_1m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Federal_Bureau_of_Investigation"
				},
				"name": "FBI",
				"salience": 0.0010807607,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0n4bfmd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2012_Benghazi_attack"
				},
				"name": "Benghazi",
				"salience": 0.0010807607,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "GOP",
				"salience": 0.0010807607,
				"type": "ORGANIZATION"
			},
			{
				"name": "public",
				"salience": 0.0010178571,
				"type": "PERSON"
			},
			{
				"name": "child rape victim",
				"salience": 0.00095532346,
				"type": "PERSON"
			},
			{
				"name": "evil",
				"salience": 0.00095532346,
				"type": "OTHER"
			},
			{
				"name": "flames",
				"salience": 0.00095532346,
				"type": "OTHER"
			},
			{
				"name": "Chip Somodevilla Share",
				"salience": 0.0007871253,
				"type": "OTHER"
			},
			{
				"name": "Getty",
				"salience": 0.0007871253,
				"type": "ORGANIZATION"
			},
			{
				"name": "answer",
				"salience": 0.0007507676,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "http://cdn.bipartisanreport.com/wordpress/wp-content/uploads/2016/08/Breaking-News.jpg",
		"ord_in_thread": "0",
		"participants_count": "0",
		"published": "2016-11-22T15:37:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 6.5,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "bipartisanreport.com",
		"spam_score": "0.001",
		"text": "0 66 \nA source at MSNBC’s Morning Joe confirms that the newly-elected Trump has made a decision regarding Hillary Clinton’s use of a private email server during her time as secretary of state. Source tells @Morning_Joe @realDonaldTrump won’t pursue investigations into @HillaryClinton for private email server use/Clinton Foundation. \n— Morning Joe (@Morning_Joe) November 22, 2016 \nDespite all his campaign bluster, when he was calling Clinton “crooked Hillary” and promising that Clinton would “be in jail” once he was president, it seems Trump has had a change of heart. It seems like only a month ago that Donald Trump told his supporters that: \n‘This is the most heinous, the most serious thing that I’ve ever seen involving justice in the United States — in the history of the United States.’ \nIn fact, it was only a month ago. Trump promised his bloodthirsty supporters that he would “lock her up” as president, and just six weeks ago Trump promised during the second presidential debate that he would appoint a “special prosecutor” to look into Hillary Clinton’s “situation” regarding her use of a private email server. \nFive days after being elected, Trump did one of the most rapid walkbacks in presidential history when asked about that “special prosecutor” to throw Hillary Clinton in prison. When asked by 60 Minutes interviewer, Lesley Stahl, about his plans for the former secretary of state, Trump balked. \n‘I don’t want to hurt them. I don’t want to hurt them. They’re, they’re good people. I don’t want to hurt them. And I will give you a very, very good and definitive answer the next time we do 60 Minutes together.’ \nThe same man who fanned the flames with supporters who called Clinton a “criminal” and “evil,” who exploited women who claimed that they were sexually assaulted by Bill Clinton and laughed at as a child rape victim by Hillary Clinton, now wants the American public to know that Bill and Hillary Clinton are “good people.” \nOf course, it was never in question whether or not Hillary Clinton would be convicted of a crime or sentenced to prison, since multiple investigations by GOP-led committees regarding Benghazi and two investigations by the FBI regarding the private email server that Clinton and every modern predecessor of hers used turned up no evidence of criminal wrongdoing. \nJust like every other promise Trump made on the campaign trail to attract voters with vengeance and hatred on their minds, it was all just smoke and mirrors. \nFeatured image via Getty/Chip Somodevilla Share this Article! ",
		"thread_title": "BREAKING: Donald Trump Makes MAJOR Clinton Indictment Announcement (DETAILS)",
		"title": "BREAKING: Donald Trump Makes MAJOR Clinton Indictment Announcement (DETAILS)",
		"type": "bs",
		"uuid": "f5daaed7d91ff76c3b1c18267f13b937fc6972d4"
	},
	"-KhIkM5y8zwkPcGgWTgo": {
		"author": "Glen Ford",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-10-26T23:03:02.969+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.39043033,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.08498703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.03478354,
				"type": "LOCATION"
			},
			{
				"name": "fascism",
				"salience": 0.023397336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_01w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Ford"
				},
				"name": "Glen Ford",
				"salience": 0.022785,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.017938625,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.017371349,
				"type": "ORGANIZATION"
			},
			{
				"name": "Glen Ford An",
				"salience": 0.016590333,
				"type": "PERSON"
			},
			{
				"name": "most",
				"salience": 0.011820481,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.011733284,
				"type": "OTHER"
			},
			{
				"name": "Big Tent",
				"salience": 0.011175735,
				"type": "OTHER"
			},
			{
				"name": "regime-change",
				"salience": 0.010398254,
				"type": "EVENT"
			},
			{
				"name": "stance",
				"salience": 0.0097007565,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.009232701,
				"type": "EVENT"
			},
			{
				"name": "section",
				"salience": 0.00865895,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01nz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bar_(establishment)"
				},
				"name": "BAR",
				"salience": 0.008629759,
				"type": "ORGANIZATION"
			},
			{
				"name": "rule",
				"salience": 0.008596386,
				"type": "OTHER"
			},
			{
				"name": "Left",
				"salience": 0.008532376,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0077230814,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0077069798,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0071494365,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.007074325,
				"type": "OTHER"
			},
			{
				"name": "architect",
				"salience": 0.006676917,
				"type": "PERSON"
			},
			{
				"name": "coups",
				"salience": 0.006676917,
				"type": "OTHER"
			},
			{
				"name": "no-fly zones",
				"salience": 0.006676917,
				"type": "OTHER"
			},
			{
				"name": "incarceration",
				"salience": 0.006676917,
				"type": "OTHER"
			},
			{
				"name": "Commander-in-Chief",
				"salience": 0.006676917,
				"type": "PERSON"
			},
			{
				"name": "bulk",
				"salience": 0.006676917,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.005815658,
				"type": "OTHER"
			},
			{
				"name": "Fascists",
				"salience": 0.0053228852,
				"type": "PERSON"
			},
			{
				"name": "regime change",
				"salience": 0.0053228852,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.004724761,
				"type": "OTHER"
			},
			{
				"name": "menace",
				"salience": 0.003942374,
				"type": "OTHER"
			},
			{
				"name": "free trade",
				"salience": 0.003942374,
				"type": "OTHER"
			},
			{
				"name": "military confrontation",
				"salience": 0.003942374,
				"type": "EVENT"
			},
			{
				"name": "opposition",
				"salience": 0.003942374,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.003942374,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0037750476,
				"type": "EVENT"
			},
			{
				"name": "handlers",
				"salience": 0.0034950392,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0034145212,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0034145212,
				"type": "PERSON"
			},
			{
				"name": "Ones",
				"salience": 0.0034145212,
				"type": "OTHER"
			},
			{
				"name": "manifestation",
				"salience": 0.0033315306,
				"type": "OTHER"
			},
			{
				"name": "herring",
				"salience": 0.0030269818,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0028054554,
				"type": "OTHER"
			},
			{
				"name": "leftists",
				"salience": 0.0027344928,
				"type": "PERSON"
			},
			{
				"name": "Fighting Ghost",
				"salience": 0.0024280066,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.002193822,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0021229943,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0021026826,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.0020770521,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0020432195,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0019469309,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0019469309,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.00185503,
				"type": "LOCATION"
			},
			{
				"name": "spectrum",
				"salience": 0.0018467414,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0017987057,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00179745,
				"type": "EVENT"
			},
			{
				"name": "candidacy",
				"salience": 0.0017174539,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0016749866,
				"type": "ORGANIZATION"
			},
			{
				"name": "status",
				"salience": 0.001624124,
				"type": "OTHER"
			},
			{
				"name": "landslide victory",
				"salience": 0.001624124,
				"type": "OTHER"
			},
			{
				"name": "orange",
				"salience": 0.001624124,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0015565411,
				"type": "PERSON"
			},
			{
				"name": "fascism",
				"salience": 0.0015479802,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.0015384426,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0014984589,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0014939287,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0014795834,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0014795834,
				"type": "OTHER"
			},
			{
				"name": "Race",
				"salience": 0.0014127361,
				"type": "EVENT"
			},
			{
				"name": "gate",
				"salience": 0.0014064278,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0014064278,
				"type": "WORK_OF_ART"
			},
			{
				"name": "barbarians",
				"salience": 0.0014064278,
				"type": "PERSON"
			},
			{
				"name": "takeover",
				"salience": 0.0014064278,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0014064278,
				"type": "ORGANIZATION"
			},
			{
				"name": "branch",
				"salience": 0.0014064278,
				"type": "LOCATION"
			},
			{
				"name": "ordinary",
				"salience": 0.0014064278,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.0014064278,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0014021756,
				"type": "PERSON"
			},
			{
				"name": "duopoly electoral system",
				"salience": 0.0014021756,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0013652523,
				"type": "EVENT"
			},
			{
				"name": "self-image",
				"salience": 0.0012707815,
				"type": "OTHER"
			},
			{
				"name": "living standards",
				"salience": 0.0012612814,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0012612814,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.0012560034,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0012509781,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0012142095,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0012142095,
				"type": "OTHER"
			},
			{
				"name": "duopoly system",
				"salience": 0.0011891181,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0011891181,
				"type": "OTHER"
			},
			{
				"name": "duopoly system",
				"salience": 0.0011891181,
				"type": "OTHER"
			},
			{
				"name": "fracture",
				"salience": 0.001182981,
				"type": "EVENT"
			},
			{
				"name": "status",
				"salience": 0.0011388295,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0010963249,
				"type": "PERSON"
			},
			{
				"name": "space",
				"salience": 0.0010963249,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0010963249,
				"type": "EVENT"
			},
			{
				"name": "failure",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "menace",
				"salience": 0.0010892247,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.0010296969,
				"type": "PERSON"
			},
			{
				"name": "blame",
				"salience": 0.0009861467,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0009861467,
				"type": "LOCATION"
			},
			{
				"name": "wake",
				"salience": 0.0009861467,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0009861467,
				"type": "OTHER"
			},
			{
				"name": "meltdown",
				"salience": 0.0009861467,
				"type": "EVENT"
			},
			{
				"name": "job losses",
				"salience": 0.0009861467,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0009861467,
				"type": "PERSON"
			},
			{
				"name": "majorities",
				"salience": 0.0009780898,
				"type": "OTHER"
			},
			{
				"name": "calculus",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "flanks",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "equation",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "cake",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0009382958,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0009382958,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0009297171,
				"type": "OTHER"
			},
			{
				"name": "free trade",
				"salience": 0.0009297171,
				"type": "OTHER"
			},
			{
				"name": "military confrontation",
				"salience": 0.0009297171,
				"type": "EVENT"
			},
			{
				"name": "opposition",
				"salience": 0.0009297171,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.0009297171,
				"type": "LOCATION"
			},
			{
				"name": "level",
				"salience": 0.0009297171,
				"type": "OTHER"
			},
			{
				"name": "Both",
				"salience": 0.00091390195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0008999385,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.000888321,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0008657214,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0008657214,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07j6ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ted_Cruz"
				},
				"name": "Ted Cruz",
				"salience": 0.0008657214,
				"type": "PERSON"
			},
			{
				"name": "disarray",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "shell",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "opening",
				"salience": 0.00080505764,
				"type": "EVENT"
			},
			{
				"name": "corporate media rejection",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00080505764,
				"type": "LOCATION"
			},
			{
				"name": "appeal",
				"salience": 0.00077902665,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00077635335,
				"type": "LOCATION"
			},
			{
				"name": "fear",
				"salience": 0.00077500514,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.000771633,
				"type": "OTHER"
			},
			{
				"name": "brown-shirts",
				"salience": 0.0007686725,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "appeal",
				"salience": 0.00074994547,
				"type": "OTHER"
			},
			{
				"name": "hysteria",
				"salience": 0.0007399777,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0007045778,
				"type": "OTHER"
			},
			{
				"name": "funders",
				"salience": 0.0006945127,
				"type": "PERSON"
			},
			{
				"name": "brown shirts",
				"salience": 0.0006945127,
				"type": "ORGANIZATION"
			},
			{
				"name": "hysteria",
				"salience": 0.0006945127,
				"type": "OTHER"
			},
			{
				"name": "fascism",
				"salience": 0.0006833672,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0006833672,
				"type": "OTHER"
			},
			{
				"name": "fascism",
				"salience": 0.0006833672,
				"type": "OTHER"
			},
			{
				"name": "fascists-in-charge",
				"salience": 0.0006833672,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0006149635,
				"type": "PERSON"
			},
			{
				"name": "tens of millions",
				"salience": 0.0006013799,
				"type": "PERSON"
			},
			{
				"name": "precincts",
				"salience": 0.0006013799,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0006013799,
				"type": "OTHER"
			},
			{
				"name": "wear blue",
				"salience": 0.0006013799,
				"type": "OTHER"
			},
			{
				"name": "embrace",
				"salience": 0.0006013799,
				"type": "OTHER"
			},
			{
				"name": "latrine area",
				"salience": 0.0006013799,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Blacks",
				"salience": 0.00058430515,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00056289654,
				"type": "PERSON"
			},
			{
				"name": "hyper-power",
				"salience": 0.00056020665,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00056020665,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00056020665,
				"type": "OTHER"
			},
			{
				"name": "ghost",
				"salience": 0.00055276003,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.0005061536,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0005058,
				"type": "OTHER"
			},
			{
				"name": "rich",
				"salience": 0.0005058,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.00048327408,
				"type": "EVENT"
			},
			{
				"name": "duopoly system",
				"salience": 0.00048327408,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00048327408,
				"type": "ORGANIZATION"
			},
			{
				"name": "electorate",
				"salience": 0.00048327408,
				"type": "PERSON"
			},
			{
				"name": "fracture",
				"salience": 0.00048077892,
				"type": "EVENT"
			},
			{
				"name": "helm",
				"salience": 0.00046664214,
				"type": "OTHER"
			},
			{
				"name": "general election campaign",
				"salience": 0.00045297362,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00044355766,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.00043796716,
				"type": "WORK_OF_ART"
			},
			{
				"name": "course",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "crusade",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "champion",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.00041846148,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.00040587294,
				"type": "OTHER"
			},
			{
				"name": "near-collapse",
				"salience": 0.00039748204,
				"type": "EVENT"
			},
			{
				"name": "funds",
				"salience": 0.00037781813,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.00037781813,
				"type": "EVENT"
			},
			{
				"name": "America Firster",
				"salience": 0.00037011455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "War",
				"salience": 0.00037011455,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/032qyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austerity"
				},
				"name": "Austerity",
				"salience": 0.00037011455,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.00032714586,
				"type": "LOCATION"
			},
			{
				"name": "pages",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "billionaire",
				"salience": 0.00032714586,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "nationalists",
				"salience": 0.00032714586,
				"type": "PERSON"
			},
			{
				"name": "husk",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "totality",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "monopoly",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "Klansmen",
				"salience": 0.0002695342,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-26T23:03:02.969+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "2016 presidential campaign by BAR executive editor Glen Ford \nAn architect of regime-change, coups, no-fly zones, rule of the rich and mass incarceration is about to become Commander-in-Chief, yet the bulk of what passes for the Left is “engaged in a 1930s-style ‘united front’ against a ‘fascism’ that was never a threat in 21 st century America.” Donald Trump, the orange menace, didn’t have a chance of becoming president. Hillary Clinton, on the other hand, is a 21 st century fascist and threat to life on Earth. Fighting Ghost Fascists While Aiding Real Ones by BAR executive editor Glen Ford \n“Trump’s anti-“free trade” stance and opposition to regime change and military confrontation with Russia and China drove most of the Republican-allied section of the ruling class straight into Hillary Clinton’s imperial Big Tent.” \nHillary Clinton’s impending -- and totally predictable -- landslide victory on November 8 will prove only that there never was any danger of a “fascist” white nationalist takeover of the U.S. executive branch of government in 2016. That was always a red (or “orange”) herring, a phony “barbarians at the gate” threat that -- as Wikileaks documents confirmed -- John Podesta and Hillary’s other handlers fervently hoped would convey “lesser evil” status to their manifestly unpopular candidate. \nThere was nothing particularly devious or out of the ordinary in the Hillary camp’s favoring Donald Trump or, alternatively, Ted Cruz. It is standard Democratic Party practice to position themselves just to the left of the Republicans. In a duopoly electoral system, victory lies in where the cake is cut. By hugging close to the GOP’s flanks, national Democratic candidates can lay claim to a “center-left” spectrum of political space that encompasses a clear majority of U.S. public opinion on most issues. By this calculus, Democrats are supposed to win, unless they are tripped up on the closely related issues of race (failure to “stand up” to the Blacks) and foreign policy (failure to “stand up” to whoever is the designated foreign enemy). \nRace is the trickiest part of the equation, since white supremacy is embedded in the American political conversation, hiding just beneath the surface of most discourse on social and economic policy. \n“His overt racism probably weakened his appeal to whites.” \nTrump thought he could win by combining an overt white racist appeal with an anti-corporate message that laid the blame on Wall Street for (white) American job losses and falling living standards. He also calculated -- correctly, it turns out -- that in the wake of the 2008 economic meltdown, many white Americans were more upset about their own economic and social status than they were angry at Russians; that they wanted regime change at home more than abroad. \nBoth of Trump’s central policies backfired, dooming his campaign. His overt racism probably weakened his appeal to whites, who have given majorities to national Republicans since 1968 but whose self-image is that they are not, as individuals, racist. (Certainly, white women found further reason to reject his candidacy.) Much more spectacularly, Trump’s anti-“free trade” stance and opposition to regime change and military confrontation with Russia and China drove most of the Republican-allied section of the ruling class straight into Hillary Clinton’s imperial Big Tent. \nAt the national level, the duopoly system, as we had known it, virtually ceased to exist – a fact dramatically driven home by the near-universal corporate media rejection of Donald Trump, the candidacy they had done so much to create. The near-collapse of the duopoly system was the great fracture of the 2016 election, a potential historic opening to a far wider space of progressive political struggle, including on the moribund electoral level. With the ruling class gathered in one Big Tent, and the overt racists occupying the imploded shell of the GOP, the system itself was in disarray. What was once two vibrant parties of the ruling class, with a virtual monopoly on the totality of the electorate, had become one ruling class party plus a hollowed-out husk, at least temporarily occupied by white nationalists under the leadership of a narcissistic and incoherent billionaire, yet without enough funds to mount a competitive general election campaign. \n“The near-collapse of the duopoly system was the great fracture of the 2016 election.” \nIn these pages, we had been saying since last year that Donald Trump could not win; that Bernie Sanders’ fate would be sealed in the southern primaries; and that, although ruling class money would insure Clinton an election by landslide, it could not buy her legitimacy among a significant section of the Democratic “base,” who would now be pushed to the latrine area of her Big Tent. As we wrote on May 18 of this year: \n“Outsized fear of Trump is hysteria. These days, the ‘brown shirts’ wear blue. Hillary is the candidate of Wall Street, War and Austerity – not Trump, the racist America Firster. And, he can’t win, anyway – not with tens of millions of ‘moderate’ Republicans and most of the party’s funders rushing into Hillary’s welcoming embrace.” \nBut sadly, hysteria does reign in most of the “left” precincts of America. Those who did not hesitate to kick Hillary when she appeared to be “down” -- in those heady days when they imagined it was possible she could lose to Sanders -- are terrified to kick her when she is “up” and primed to take the helm of the hyper-power. They are engaged in a 1930s-style “united front” against a “fascism” that was never a threat in 21 st century America, where a different kind of dictatorship of the rich (but also a fascism) has made brown-shirts (and Klansmen) utterly superfluous. These trembling leftists refuse to oppose the modern manifestation of fascism, which is now firmly entrenched in power with Hillary as its champion, in favor of a crusade against an “orange” menace that did not have a ghost of a chance of seizing national power. They have made themselves perfectly irrelevant and useless -- except, of course, to the fascists-in-charge. BAR executive editor Glen Ford can be contacted at [email protected] .",
		"thread_title": "Fighting Ghost Fascists While Aiding Real Ones",
		"title": "Fighting Ghost Fascists While Aiding Real Ones",
		"type": "bs",
		"uuid": "6a8443ba5781962df283cd096864d7c64b33c193"
	},
	"-KhIkMYTC9UV5HFFcaga": {
		"author": "Glen Ford",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-10-27T00:57:46.164+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.39043033,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.08498703,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.03478354,
				"type": "LOCATION"
			},
			{
				"name": "fascism",
				"salience": 0.023397336,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_01w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Ford"
				},
				"name": "Glen Ford",
				"salience": 0.022785,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.017938625,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.017371349,
				"type": "ORGANIZATION"
			},
			{
				"name": "Glen Ford An",
				"salience": 0.016590333,
				"type": "PERSON"
			},
			{
				"name": "most",
				"salience": 0.011820481,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.011733284,
				"type": "OTHER"
			},
			{
				"name": "Big Tent",
				"salience": 0.011175735,
				"type": "OTHER"
			},
			{
				"name": "regime-change",
				"salience": 0.010398254,
				"type": "EVENT"
			},
			{
				"name": "stance",
				"salience": 0.0097007565,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.009232701,
				"type": "EVENT"
			},
			{
				"name": "section",
				"salience": 0.00865895,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01nz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bar_(establishment)"
				},
				"name": "BAR",
				"salience": 0.008629759,
				"type": "ORGANIZATION"
			},
			{
				"name": "rule",
				"salience": 0.008596386,
				"type": "OTHER"
			},
			{
				"name": "Left",
				"salience": 0.008532376,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0077230814,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0077069798,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0071494365,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.007074325,
				"type": "OTHER"
			},
			{
				"name": "architect",
				"salience": 0.006676917,
				"type": "PERSON"
			},
			{
				"name": "coups",
				"salience": 0.006676917,
				"type": "OTHER"
			},
			{
				"name": "no-fly zones",
				"salience": 0.006676917,
				"type": "OTHER"
			},
			{
				"name": "incarceration",
				"salience": 0.006676917,
				"type": "OTHER"
			},
			{
				"name": "Commander-in-Chief",
				"salience": 0.006676917,
				"type": "PERSON"
			},
			{
				"name": "bulk",
				"salience": 0.006676917,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.005815658,
				"type": "OTHER"
			},
			{
				"name": "Fascists",
				"salience": 0.0053228852,
				"type": "PERSON"
			},
			{
				"name": "regime change",
				"salience": 0.0053228852,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.004724761,
				"type": "OTHER"
			},
			{
				"name": "menace",
				"salience": 0.003942374,
				"type": "OTHER"
			},
			{
				"name": "free trade",
				"salience": 0.003942374,
				"type": "OTHER"
			},
			{
				"name": "military confrontation",
				"salience": 0.003942374,
				"type": "EVENT"
			},
			{
				"name": "opposition",
				"salience": 0.003942374,
				"type": "OTHER"
			},
			{
				"name": "hand",
				"salience": 0.003942374,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0037750476,
				"type": "EVENT"
			},
			{
				"name": "handlers",
				"salience": 0.0034950392,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0034145212,
				"type": "OTHER"
			},
			{
				"name": "president",
				"salience": 0.0034145212,
				"type": "PERSON"
			},
			{
				"name": "Ones",
				"salience": 0.0034145212,
				"type": "OTHER"
			},
			{
				"name": "manifestation",
				"salience": 0.0033315306,
				"type": "OTHER"
			},
			{
				"name": "herring",
				"salience": 0.0030269818,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0028054554,
				"type": "OTHER"
			},
			{
				"name": "leftists",
				"salience": 0.0027344928,
				"type": "PERSON"
			},
			{
				"name": "Fighting Ghost",
				"salience": 0.0024280066,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.002193822,
				"type": "OTHER"
			},
			{
				"name": "message",
				"salience": 0.0021229943,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0021026826,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.0020770521,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0020432195,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0019469309,
				"type": "OTHER"
			},
			{
				"name": "camp",
				"salience": 0.0019469309,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.00185503,
				"type": "LOCATION"
			},
			{
				"name": "spectrum",
				"salience": 0.0018467414,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0017987057,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.00179745,
				"type": "EVENT"
			},
			{
				"name": "candidacy",
				"salience": 0.0017174539,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0016749866,
				"type": "ORGANIZATION"
			},
			{
				"name": "status",
				"salience": 0.001624124,
				"type": "OTHER"
			},
			{
				"name": "landslide victory",
				"salience": 0.001624124,
				"type": "OTHER"
			},
			{
				"name": "orange",
				"salience": 0.001624124,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0015565411,
				"type": "PERSON"
			},
			{
				"name": "fascism",
				"salience": 0.0015479802,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.0015384426,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0014984589,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.0014939287,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0014795834,
				"type": "OTHER"
			},
			{
				"name": "danger",
				"salience": 0.0014795834,
				"type": "OTHER"
			},
			{
				"name": "Race",
				"salience": 0.0014127361,
				"type": "EVENT"
			},
			{
				"name": "gate",
				"salience": 0.0014064278,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0014064278,
				"type": "WORK_OF_ART"
			},
			{
				"name": "barbarians",
				"salience": 0.0014064278,
				"type": "PERSON"
			},
			{
				"name": "takeover",
				"salience": 0.0014064278,
				"type": "EVENT"
			},
			{
				"name": "government",
				"salience": 0.0014064278,
				"type": "ORGANIZATION"
			},
			{
				"name": "branch",
				"salience": 0.0014064278,
				"type": "LOCATION"
			},
			{
				"name": "ordinary",
				"salience": 0.0014064278,
				"type": "OTHER"
			},
			{
				"name": "evil",
				"salience": 0.0014064278,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0014021756,
				"type": "PERSON"
			},
			{
				"name": "duopoly electoral system",
				"salience": 0.0014021756,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0013652523,
				"type": "EVENT"
			},
			{
				"name": "self-image",
				"salience": 0.0012707815,
				"type": "OTHER"
			},
			{
				"name": "living standards",
				"salience": 0.0012612814,
				"type": "OTHER"
			},
			{
				"name": "policies",
				"salience": 0.0012612814,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.0012560034,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0012509781,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0012142095,
				"type": "OTHER"
			},
			{
				"name": "policy",
				"salience": 0.0012142095,
				"type": "OTHER"
			},
			{
				"name": "duopoly system",
				"salience": 0.0011891181,
				"type": "OTHER"
			},
			{
				"name": "candidacy",
				"salience": 0.0011891181,
				"type": "OTHER"
			},
			{
				"name": "duopoly system",
				"salience": 0.0011891181,
				"type": "OTHER"
			},
			{
				"name": "fracture",
				"salience": 0.001182981,
				"type": "EVENT"
			},
			{
				"name": "status",
				"salience": 0.0011388295,
				"type": "OTHER"
			},
			{
				"name": "whites",
				"salience": 0.0010963249,
				"type": "PERSON"
			},
			{
				"name": "space",
				"salience": 0.0010963249,
				"type": "LOCATION"
			},
			{
				"name": "majority",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.0010963249,
				"type": "EVENT"
			},
			{
				"name": "failure",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.0010963249,
				"type": "OTHER"
			},
			{
				"name": "menace",
				"salience": 0.0010892247,
				"type": "OTHER"
			},
			{
				"name": "racists",
				"salience": 0.0010296969,
				"type": "PERSON"
			},
			{
				"name": "blame",
				"salience": 0.0009861467,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.0009861467,
				"type": "LOCATION"
			},
			{
				"name": "wake",
				"salience": 0.0009861467,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.0009861467,
				"type": "OTHER"
			},
			{
				"name": "meltdown",
				"salience": 0.0009861467,
				"type": "EVENT"
			},
			{
				"name": "job losses",
				"salience": 0.0009861467,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0009861467,
				"type": "PERSON"
			},
			{
				"name": "majorities",
				"salience": 0.0009780898,
				"type": "OTHER"
			},
			{
				"name": "calculus",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "discourse",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "opinion",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "surface",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "flanks",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "equation",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "cake",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "conversation",
				"salience": 0.00094933773,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0009382958,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0009382958,
				"type": "OTHER"
			},
			{
				"name": "level",
				"salience": 0.0009297171,
				"type": "OTHER"
			},
			{
				"name": "free trade",
				"salience": 0.0009297171,
				"type": "OTHER"
			},
			{
				"name": "military confrontation",
				"salience": 0.0009297171,
				"type": "EVENT"
			},
			{
				"name": "opposition",
				"salience": 0.0009297171,
				"type": "OTHER"
			},
			{
				"name": "space",
				"salience": 0.0009297171,
				"type": "LOCATION"
			},
			{
				"name": "level",
				"salience": 0.0009297171,
				"type": "OTHER"
			},
			{
				"name": "Both",
				"salience": 0.00091390195,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0008999385,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.000888321,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.0008657214,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01zty6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Podesta"
				},
				"name": "John Podesta",
				"salience": 0.0008657214,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07j6ty",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ted_Cruz"
				},
				"name": "Ted Cruz",
				"salience": 0.0008657214,
				"type": "PERSON"
			},
			{
				"name": "disarray",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "shell",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "opening",
				"salience": 0.00080505764,
				"type": "EVENT"
			},
			{
				"name": "corporate media rejection",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00080505764,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.00080505764,
				"type": "LOCATION"
			},
			{
				"name": "appeal",
				"salience": 0.00077902665,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russians",
				"salience": 0.00077635335,
				"type": "LOCATION"
			},
			{
				"name": "fear",
				"salience": 0.00077500514,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.000771633,
				"type": "OTHER"
			},
			{
				"name": "brown-shirts",
				"salience": 0.0007686725,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "appeal",
				"salience": 0.00074994547,
				"type": "OTHER"
			},
			{
				"name": "hysteria",
				"salience": 0.0007399777,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0007045778,
				"type": "OTHER"
			},
			{
				"name": "funders",
				"salience": 0.0006945127,
				"type": "PERSON"
			},
			{
				"name": "brown shirts",
				"salience": 0.0006945127,
				"type": "ORGANIZATION"
			},
			{
				"name": "hysteria",
				"salience": 0.0006945127,
				"type": "OTHER"
			},
			{
				"name": "fascism",
				"salience": 0.0006833672,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0006833672,
				"type": "OTHER"
			},
			{
				"name": "fascism",
				"salience": 0.0006833672,
				"type": "OTHER"
			},
			{
				"name": "fascists-in-charge",
				"salience": 0.0006833672,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0006149635,
				"type": "PERSON"
			},
			{
				"name": "tens of millions",
				"salience": 0.0006013799,
				"type": "PERSON"
			},
			{
				"name": "precincts",
				"salience": 0.0006013799,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0006013799,
				"type": "OTHER"
			},
			{
				"name": "wear blue",
				"salience": 0.0006013799,
				"type": "OTHER"
			},
			{
				"name": "embrace",
				"salience": 0.0006013799,
				"type": "OTHER"
			},
			{
				"name": "latrine area",
				"salience": 0.0006013799,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Blacks",
				"salience": 0.00058430515,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.00056289654,
				"type": "PERSON"
			},
			{
				"name": "hyper-power",
				"salience": 0.00056020665,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00056020665,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.00056020665,
				"type": "OTHER"
			},
			{
				"name": "ghost",
				"salience": 0.00055276003,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.0005061536,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0005058,
				"type": "OTHER"
			},
			{
				"name": "rich",
				"salience": 0.0005058,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.00048327408,
				"type": "EVENT"
			},
			{
				"name": "duopoly system",
				"salience": 0.00048327408,
				"type": "OTHER"
			},
			{
				"name": "party",
				"salience": 0.00048327408,
				"type": "ORGANIZATION"
			},
			{
				"name": "electorate",
				"salience": 0.00048327408,
				"type": "PERSON"
			},
			{
				"name": "fracture",
				"salience": 0.00048077892,
				"type": "EVENT"
			},
			{
				"name": "helm",
				"salience": 0.00046664214,
				"type": "OTHER"
			},
			{
				"name": "general election campaign",
				"salience": 0.00045297362,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.00044355766,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.00043796716,
				"type": "WORK_OF_ART"
			},
			{
				"name": "course",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "crusade",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "dictatorship",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "favor",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "champion",
				"salience": 0.00043796716,
				"type": "OTHER"
			},
			{
				"name": "section",
				"salience": 0.00041846148,
				"type": "OTHER"
			},
			{
				"name": "legitimacy",
				"salience": 0.00040587294,
				"type": "OTHER"
			},
			{
				"name": "near-collapse",
				"salience": 0.00039748204,
				"type": "EVENT"
			},
			{
				"name": "funds",
				"salience": 0.00037781813,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.00037781813,
				"type": "EVENT"
			},
			{
				"name": "America Firster",
				"salience": 0.00037011455,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "War",
				"salience": 0.00037011455,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/032qyr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Austerity"
				},
				"name": "Austerity",
				"salience": 0.00037011455,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.00032714586,
				"type": "LOCATION"
			},
			{
				"name": "pages",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "billionaire",
				"salience": 0.00032714586,
				"type": "PERSON"
			},
			{
				"name": "money",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "base",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "nationalists",
				"salience": 0.00032714586,
				"type": "PERSON"
			},
			{
				"name": "husk",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "totality",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"name": "monopoly",
				"salience": 0.00032714586,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/048qr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ku_Klux_Klan"
				},
				"name": "Klansmen",
				"salience": 0.0002695342,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T00:57:46.164+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 17.3,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "2016 presidential campaign by BAR executive editor Glen Ford \nAn architect of regime-change, coups, no-fly zones, rule of the rich and mass incarceration is about to become Commander-in-Chief, yet the bulk of what passes for the Left is “engaged in a 1930s-style ‘united front’ against a ‘fascism’ that was never a threat in 21 st century America.” Donald Trump, the orange menace, didn’t have a chance of becoming president. Hillary Clinton, on the other hand, is a 21 st century fascist and threat to life on Earth. Fighting Ghost Fascists While Aiding Real Ones by BAR executive editor Glen Ford \n“Trump’s anti-“free trade” stance and opposition to regime change and military confrontation with Russia and China drove most of the Republican-allied section of the ruling class straight into Hillary Clinton’s imperial Big Tent.” \nHillary Clinton’s impending -- and totally predictable -- landslide victory on November 8 will prove only that there never was any danger of a “fascist” white nationalist takeover of the U.S. executive branch of government in 2016. That was always a red (or “orange”) herring, a phony “barbarians at the gate” threat that -- as Wikileaks documents confirmed -- John Podesta and Hillary’s other handlers fervently hoped would convey “lesser evil” status to their manifestly unpopular candidate. \nThere was nothing particularly devious or out of the ordinary in the Hillary camp’s favoring Donald Trump or, alternatively, Ted Cruz. It is standard Democratic Party practice to position themselves just to the left of the Republicans. In a duopoly electoral system, victory lies in where the cake is cut. By hugging close to the GOP’s flanks, national Democratic candidates can lay claim to a “center-left” spectrum of political space that encompasses a clear majority of U.S. public opinion on most issues. By this calculus, Democrats are supposed to win, unless they are tripped up on the closely related issues of race (failure to “stand up” to the Blacks) and foreign policy (failure to “stand up” to whoever is the designated foreign enemy). \nRace is the trickiest part of the equation, since white supremacy is embedded in the American political conversation, hiding just beneath the surface of most discourse on social and economic policy. \n“His overt racism probably weakened his appeal to whites.” \nTrump thought he could win by combining an overt white racist appeal with an anti-corporate message that laid the blame on Wall Street for (white) American job losses and falling living standards. He also calculated -- correctly, it turns out -- that in the wake of the 2008 economic meltdown, many white Americans were more upset about their own economic and social status than they were angry at Russians; that they wanted regime change at home more than abroad. \nBoth of Trump’s central policies backfired, dooming his campaign. His overt racism probably weakened his appeal to whites, who have given majorities to national Republicans since 1968 but whose self-image is that they are not, as individuals, racist. (Certainly, white women found further reason to reject his candidacy.) Much more spectacularly, Trump’s anti-“free trade” stance and opposition to regime change and military confrontation with Russia and China drove most of the Republican-allied section of the ruling class straight into Hillary Clinton’s imperial Big Tent. \nAt the national level, the duopoly system, as we had known it, virtually ceased to exist – a fact dramatically driven home by the near-universal corporate media rejection of Donald Trump, the candidacy they had done so much to create. The near-collapse of the duopoly system was the great fracture of the 2016 election, a potential historic opening to a far wider space of progressive political struggle, including on the moribund electoral level. With the ruling class gathered in one Big Tent, and the overt racists occupying the imploded shell of the GOP, the system itself was in disarray. What was once two vibrant parties of the ruling class, with a virtual monopoly on the totality of the electorate, had become one ruling class party plus a hollowed-out husk, at least temporarily occupied by white nationalists under the leadership of a narcissistic and incoherent billionaire, yet without enough funds to mount a competitive general election campaign. \n“The near-collapse of the duopoly system was the great fracture of the 2016 election.” \nIn these pages, we had been saying since last year that Donald Trump could not win; that Bernie Sanders’ fate would be sealed in the southern primaries; and that, although ruling class money would insure Clinton an election by landslide, it could not buy her legitimacy among a significant section of the Democratic “base,” who would now be pushed to the latrine area of her Big Tent. As we wrote on May 18 of this year: \n“Outsized fear of Trump is hysteria. These days, the ‘brown shirts’ wear blue. Hillary is the candidate of Wall Street, War and Austerity – not Trump, the racist America Firster. And, he can’t win, anyway – not with tens of millions of ‘moderate’ Republicans and most of the party’s funders rushing into Hillary’s welcoming embrace.” \nBut sadly, hysteria does reign in most of the “left” precincts of America. Those who did not hesitate to kick Hillary when she appeared to be “down” -- in those heady days when they imagined it was possible she could lose to Sanders -- are terrified to kick her when she is “up” and primed to take the helm of the hyper-power. They are engaged in a 1930s-style “united front” against a “fascism” that was never a threat in 21 st century America, where a different kind of dictatorship of the rich (but also a fascism) has made brown-shirts (and Klansmen) utterly superfluous. These trembling leftists refuse to oppose the modern manifestation of fascism, which is now firmly entrenched in power with Hillary as its champion, in favor of a crusade against an “orange” menace that did not have a ghost of a chance of seizing national power. They have made themselves perfectly irrelevant and useless -- except, of course, to the fascists-in-charge. BAR executive editor Glen Ford can be contacted at [email protected] .",
		"thread_title": "Fighting Ghost Fascists While Aiding Real Ones",
		"title": "Fighting Ghost Fascists While Aiding Real Ones",
		"type": "bs",
		"uuid": "49ae1be32f7bccf969c2ab7551740c026d8972b2"
	},
	"-KhIkMz9qkbqwbS7QA-S": {
		"author": "Bruce A. Dixon",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-10-27T08:32:15.742+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.18233657,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03f2h01",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malcolm_X"
				},
				"name": "Malcolm X",
				"salience": 0.1440156,
				"type": "PERSON"
			},
			{
				"name": "Black Agenda Radio Commentary",
				"salience": 0.07922763,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Bruce A. Dixon It",
				"salience": 0.077972755,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01j6t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barry_Goldwater"
				},
				"name": "Barry Goldwater",
				"salience": 0.039820682,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Lyndon Baines Johnson",
				"salience": 0.032365844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.030264517,
				"type": "PERSON"
			},
			{
				"name": "conundrum",
				"salience": 0.025052082,
				"type": "OTHER"
			},
			{
				"name": "commentary",
				"salience": 0.018531378,
				"type": "WORK_OF_ART"
			},
			{
				"name": "place",
				"salience": 0.014507275,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.0144008985,
				"type": "ORGANIZATION"
			},
			{
				"name": "observation",
				"salience": 0.014325301,
				"type": "OTHER"
			},
			{
				"name": "countryside",
				"salience": 0.011781335,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.011669034,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.011491731,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010954549,
				"type": "EVENT"
			},
			{
				"name": "Bruce A.",
				"salience": 0.010325442,
				"type": "PERSON"
			},
			{
				"name": "imperialists",
				"salience": 0.010269698,
				"type": "PERSON"
			},
			{
				"name": "Bruce Dixon",
				"salience": 0.008380347,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0074240784,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.0074240784,
				"type": "EVENT"
			},
			{
				"name": "future",
				"salience": 0.0074240784,
				"type": "OTHER"
			},
			{
				"name": "birth defects",
				"salience": 0.0069596786,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0068812296,
				"type": "OTHER"
			},
			{
				"name": "Donald Trump A Black Agenda Radio Commentary",
				"salience": 0.005847233,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thing",
				"salience": 0.0054679597,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0051747025,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.004668123,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0045173564,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.0043934165,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.004218246,
				"type": "LOCATION"
			},
			{
				"name": "walls",
				"salience": 0.0041994234,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.004138193,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.003941664,
				"type": "OTHER"
			},
			{
				"name": "fox",
				"salience": 0.0037663053,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0035326306,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0035326306,
				"type": "OTHER"
			},
			{
				"name": "traps",
				"salience": 0.0035326306,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0031682076,
				"type": "EVENT"
			},
			{
				"name": "force",
				"salience": 0.0031377943,
				"type": "OTHER"
			},
			{
				"name": "aftermath",
				"salience": 0.0030592622,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0030592622,
				"type": "OTHER"
			},
			{
				"name": "grandparents",
				"salience": 0.0030592622,
				"type": "PERSON"
			},
			{
				"name": "tricks",
				"salience": 0.0030592622,
				"type": "OTHER"
			},
			{
				"name": "officeholders",
				"salience": 0.0029826937,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.002880592,
				"type": "ORGANIZATION"
			},
			{
				"name": "wolf",
				"salience": 0.0027436248,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0027436248,
				"type": "OTHER"
			},
			{
				"name": "fox",
				"salience": 0.0026412574,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0026276293,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.0025911052,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.002497724,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.002490173,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.002477324,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0024045238,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0023848843,
				"type": "LOCATION"
			},
			{
				"name": "alternative",
				"salience": 0.0023147983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnamese",
				"salience": 0.0022507277,
				"type": "LOCATION"
			},
			{
				"name": "fox",
				"salience": 0.0022399777,
				"type": "OTHER"
			},
			{
				"name": "wolf",
				"salience": 0.0022399777,
				"type": "OTHER"
			},
			{
				"name": "accommodations",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.0021452594,
				"type": "EVENT"
			},
			{
				"name": "bufoon",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0020652015,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0020411857,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0020225272,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0020225272,
				"type": "ORGANIZATION"
			},
			{
				"name": "chance",
				"salience": 0.0017829364,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0017816913,
				"type": "LOCATION"
			},
			{
				"name": "nukes",
				"salience": 0.001751387,
				"type": "LOCATION"
			},
			{
				"name": "racist",
				"salience": 0.001751387,
				"type": "PERSON"
			},
			{
				"name": "predator",
				"salience": 0.001751387,
				"type": "OTHER"
			},
			{
				"name": "tons",
				"salience": 0.001751387,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.001751387,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.001751387,
				"type": "PERSON"
			},
			{
				"name": "need",
				"salience": 0.0016860191,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.0016734134,
				"type": "EVENT"
			},
			{
				"name": "opportunity",
				"salience": 0.0016734134,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0016734134,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019twb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_Rights_Act_of_1964"
				},
				"name": "Civil Rights Act of 1964",
				"salience": 0.0016175207,
				"type": "WORK_OF_ART"
			},
			{
				"name": "peace",
				"salience": 0.0015109343,
				"type": "OTHER"
			},
			{
				"name": "trap",
				"salience": 0.0015109343,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0015109343,
				"type": "LOCATION"
			},
			{
				"name": "planet",
				"salience": 0.0015109343,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0014117777,
				"type": "OTHER"
			},
			{
				"name": "wolf",
				"salience": 0.001383565,
				"type": "OTHER"
			},
			{
				"name": "Hilllary",
				"salience": 0.0013736874,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.0013661311,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dpsf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indochina"
				},
				"name": "Indochina",
				"salience": 0.001320497,
				"type": "LOCATION"
			},
			{
				"name": "jobs",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"name": "rescue",
				"salience": 0.001308347,
				"type": "EVENT"
			},
			{
				"name": "profit",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0651vn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marxism"
				},
				"name": "Marxists",
				"salience": 0.0012712043,
				"type": "PERSON"
			},
			{
				"name": "conundrum",
				"salience": 0.0011004284,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnamese",
				"salience": 0.0010779949,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0841v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walmart"
				},
				"name": "Wal-Mart",
				"salience": 0.0010779949,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_8_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agent_Orange"
				},
				"name": "Agent Orange",
				"salience": 0.0010779949,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0010779949,
				"type": "PERSON"
			},
			{
				"name": "garbage",
				"salience": 0.0009528637,
				"type": "OTHER"
			},
			{
				"name": "co-chair",
				"salience": 0.0009528637,
				"type": "OTHER"
			},
			{
				"name": "managing editor",
				"salience": 0.0009528637,
				"type": "PERSON"
			},
			{
				"name": "fears",
				"salience": 0.0009528637,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0009528637,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.00091729,
				"type": "OTHER"
			},
			{
				"name": "GA Green party",
				"salience": 0.0009150393,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime change",
				"salience": 0.0009104299,
				"type": "EVENT"
			},
			{
				"name": "opponent",
				"salience": 0.0009104299,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0008500761,
				"type": "PERSON"
			},
			{
				"name": "stands",
				"salience": 0.000822011,
				"type": "OTHER"
			},
			{
				"name": "social security stand",
				"salience": 0.000822011,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0007680535,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007583734,
				"type": "OTHER"
			},
			{
				"name": "showdown",
				"salience": 0.0007117721,
				"type": "EVENT"
			},
			{
				"name": "range",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0007117721,
				"type": "LOCATION"
			},
			{
				"name": "issues",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "charter schools",
				"salience": 0.0007117721,
				"type": "ORGANIZATION"
			},
			{
				"name": "trade agreements",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "fracking",
				"salience": 0.0007117721,
				"type": "EVENT"
			},
			{
				"name": "contrast",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0007117721,
				"type": "EVENT"
			},
			{
				"name": "mandate",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "Marietta GA",
				"salience": 0.00067726464,
				"type": "LOCATION"
			},
			{
				"name": "appearance",
				"salience": 0.000611277,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Radio I",
				"salience": 0.0005864335,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Report",
				"salience": 0.0005864335,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.00043804114,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:05:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "  A Black Agenda Radio Commentary by Bruce A. Dixon \nWhen astute political commentary from a half century ago eloquently describes the current political conundrum it means we’ve been stuck in a bad place for a long time. Do we really want Malcolm’s observation to apply four or eight or twenty years further into the future? Malcolm X on Hillary Clinton and Donald Trump A Black Agenda Radio Commentary by Bruce A. Dixon \nIt’s that time again, it’s presidential election season, and as we hear every four years, THIS is the most important presidential election of our lives. The fact that you’ve heard that before should tell us something. It should us that in presidential years, many old things becomes new again, often because so much of what we’re told IS new is really pretty old. \nMalcolm X has been dead now a half century, dead for more years than he was ever alive. But since at least one of the tricks and traps deployed to fool, frustrate and neutralize our grandparents’ right to vote hasn’t changed much we might want to listen carefully to what Malcolm’s words in the aftermath of the 1964 presidential election. \n“ If Johnson had been running all by himself, he would not have been acceptable to anyone. The only thing that made him acceptable to the world was that the shrewd capitalists, the shrewd imperialists, knew that the only way people would run toward the fox would be if you showed them a wolf. So they created a ghastly alternative. And it had the whole world — including people who call themselves Marxists — hoping that Johnson would beat Goldwater.” \nLike today’s Donald Trump, Republican presidential candidate Barry Goldwater was a truly reprehensible and frightening figure, who had opposed the Civil Rights Act of 1964 that banned racial discrimination in public accommodations, and who favored the use of nuclear weapons to defoliate the Vietnamese countryside. Also like Donald Trump, Goldwater never really stood a chance of winning the election. Goldwater the wolf was buried beneath a Johnson landslide, carrying only 6 out of the 50 states. Republican officeholders are running away from Donald Trump not because he’s a racist bufoon but because he’s expected to lose states Republicans are accustomed to winning. \nThe fox, Lyndon Baines Johnson went on to start a war in Indochina that killed three million Vietnamese alone. LBJ defoliated the Vietnamese countryside with millions of tons of Agent Orange instead of nukes, causing hundreds of thousands of hideous and gruesome birth defects that continue to this day. \nThe wolf and the fox this year are Donald Trump and Hillary Clinton. Trump is a real estate con man, a racist and a hyper-entitled sexual predator who talks about building walls and banning Muslims. Fortunately for us all, Trump has never been in government. Hillary has scarcely ever been out of government. She’s fronted for Wal-Mart, executed bloody regime change in Libya, brought US troops to Ukraine on the Russian border, and publicly itches for a showdown in Syria. Thanks to Wikileaks there is copious evidence that Hillary’s public stands on a wide range of issues from charter schools to so-called trade agreements, to fracking and social security stand in stark contrast to the promises she makes to the powerful. \nJust as it worked 52 years ago, the overwhelming defeat of her wolvish opponent will give Hillary the appearance of a mandate. But the margin of Hillary’s victory provides those of us on the left an unprecedented opportunity. It means there is no need for those who imagine themselves on the of jobs, justice, peace and the planet to ride to Hilllary’s rescue and ensure the defeat of Donald Trump. Trump has already beaten himself. \nThis election is our best chance to break out of the decades-old two party trap and build a new political force, a new political party. The Green Party is the only peace party, the only party that stands for people and planet over profit, and our only opportunity to vote our hopes, not our fears. It’s time to choose. \nWe vote Green and build Green, we can consign the political conundrum Malcolm X eloquently described a half century ago to the garbage can of history. Or we can vote for Hillary, and Malcolm’s words will be as applicable four or eight years or twenty years from now as they have been for the last fifty. For Black Agenda Radio I’m Bruce Dixon. Bruce Dixon is managing editor at Black Agenda Report and the co-chair of the GA Green party. He lives and works near Marietta GA and can be reached  ",
		"thread_title": "Malcolm X on Hillary Clinton and Donald Trump",
		"title": "Malcolm X on Hillary Clinton and Donald Trump",
		"type": "bs",
		"uuid": "7a01f9d909f81c6ee077e89a1afda807bffbdc0c"
	},
	"-KhIkNKIx3yc3_ccjtzq": {
		"author": "Bruce A. Dixon",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-10-27T09:16:04.345+03:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.18233657,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03f2h01",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Malcolm_X"
				},
				"name": "Malcolm X",
				"salience": 0.1440156,
				"type": "PERSON"
			},
			{
				"name": "Black Agenda Radio Commentary",
				"salience": 0.07922763,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Bruce A. Dixon It",
				"salience": 0.077972755,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01j6t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barry_Goldwater"
				},
				"name": "Barry Goldwater",
				"salience": 0.039820682,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0f7fy",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Lyndon_B._Johnson"
				},
				"name": "Lyndon Baines Johnson",
				"salience": 0.032365844,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.030264517,
				"type": "PERSON"
			},
			{
				"name": "conundrum",
				"salience": 0.025052082,
				"type": "OTHER"
			},
			{
				"name": "commentary",
				"salience": 0.018531378,
				"type": "WORK_OF_ART"
			},
			{
				"name": "place",
				"salience": 0.014507275,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.0144008985,
				"type": "ORGANIZATION"
			},
			{
				"name": "observation",
				"salience": 0.014325301,
				"type": "OTHER"
			},
			{
				"name": "countryside",
				"salience": 0.011781335,
				"type": "LOCATION"
			},
			{
				"name": "election",
				"salience": 0.011669034,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.011491731,
				"type": "PERSON"
			},
			{
				"name": "election",
				"salience": 0.010954549,
				"type": "EVENT"
			},
			{
				"name": "Bruce A.",
				"salience": 0.010325442,
				"type": "PERSON"
			},
			{
				"name": "imperialists",
				"salience": 0.010269698,
				"type": "PERSON"
			},
			{
				"name": "Bruce Dixon",
				"salience": 0.008380347,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0074240784,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.0074240784,
				"type": "EVENT"
			},
			{
				"name": "future",
				"salience": 0.0074240784,
				"type": "OTHER"
			},
			{
				"name": "birth defects",
				"salience": 0.0069596786,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0068812296,
				"type": "OTHER"
			},
			{
				"name": "Donald Trump A Black Agenda Radio Commentary",
				"salience": 0.005847233,
				"type": "WORK_OF_ART"
			},
			{
				"name": "thing",
				"salience": 0.0054679597,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0051747025,
				"type": "EVENT"
			},
			{
				"name": "things",
				"salience": 0.004668123,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0045173564,
				"type": "EVENT"
			},
			{
				"name": "party",
				"salience": 0.0043934165,
				"type": "ORGANIZATION"
			},
			{
				"name": "states",
				"salience": 0.004218246,
				"type": "LOCATION"
			},
			{
				"name": "walls",
				"salience": 0.0041994234,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.004138193,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.003941664,
				"type": "OTHER"
			},
			{
				"name": "fox",
				"salience": 0.0037663053,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.0035326306,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.0035326306,
				"type": "OTHER"
			},
			{
				"name": "traps",
				"salience": 0.0035326306,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.0031682076,
				"type": "EVENT"
			},
			{
				"name": "force",
				"salience": 0.0031377943,
				"type": "OTHER"
			},
			{
				"name": "aftermath",
				"salience": 0.0030592622,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0030592622,
				"type": "OTHER"
			},
			{
				"name": "grandparents",
				"salience": 0.0030592622,
				"type": "PERSON"
			},
			{
				"name": "tricks",
				"salience": 0.0030592622,
				"type": "OTHER"
			},
			{
				"name": "officeholders",
				"salience": 0.0029826937,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.002880592,
				"type": "ORGANIZATION"
			},
			{
				"name": "wolf",
				"salience": 0.0027436248,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.0027436248,
				"type": "OTHER"
			},
			{
				"name": "fox",
				"salience": 0.0026412574,
				"type": "OTHER"
			},
			{
				"name": "figure",
				"salience": 0.0026276293,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.0025911052,
				"type": "EVENT"
			},
			{
				"name": "something",
				"salience": 0.002497724,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.002490173,
				"type": "EVENT"
			},
			{
				"name": "states",
				"salience": 0.002477324,
				"type": "LOCATION"
			},
			{
				"name": "way",
				"salience": 0.0024045238,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0023848843,
				"type": "LOCATION"
			},
			{
				"name": "alternative",
				"salience": 0.0023147983,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnamese",
				"salience": 0.0022507277,
				"type": "LOCATION"
			},
			{
				"name": "fox",
				"salience": 0.0022399777,
				"type": "OTHER"
			},
			{
				"name": "wolf",
				"salience": 0.0022399777,
				"type": "OTHER"
			},
			{
				"name": "accommodations",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.0021452594,
				"type": "EVENT"
			},
			{
				"name": "bufoon",
				"salience": 0.0021452594,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.0020652015,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0020411857,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0020225272,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0020225272,
				"type": "ORGANIZATION"
			},
			{
				"name": "chance",
				"salience": 0.0017829364,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0017816913,
				"type": "LOCATION"
			},
			{
				"name": "nukes",
				"salience": 0.001751387,
				"type": "LOCATION"
			},
			{
				"name": "racist",
				"salience": 0.001751387,
				"type": "PERSON"
			},
			{
				"name": "predator",
				"salience": 0.001751387,
				"type": "OTHER"
			},
			{
				"name": "tons",
				"salience": 0.001751387,
				"type": "OTHER"
			},
			{
				"name": "millions",
				"salience": 0.001751387,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.001751387,
				"type": "PERSON"
			},
			{
				"name": "need",
				"salience": 0.0016860191,
				"type": "OTHER"
			},
			{
				"name": "defeat",
				"salience": 0.0016734134,
				"type": "EVENT"
			},
			{
				"name": "opportunity",
				"salience": 0.0016734134,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0016734134,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019twb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Civil_Rights_Act_of_1964"
				},
				"name": "Civil Rights Act of 1964",
				"salience": 0.0016175207,
				"type": "WORK_OF_ART"
			},
			{
				"name": "peace",
				"salience": 0.0015109343,
				"type": "OTHER"
			},
			{
				"name": "trap",
				"salience": 0.0015109343,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0015109343,
				"type": "LOCATION"
			},
			{
				"name": "planet",
				"salience": 0.0015109343,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0014117777,
				"type": "OTHER"
			},
			{
				"name": "wolf",
				"salience": 0.001383565,
				"type": "OTHER"
			},
			{
				"name": "Hilllary",
				"salience": 0.0013736874,
				"type": "PERSON"
			},
			{
				"name": "opportunity",
				"salience": 0.0013661311,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dpsf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indochina"
				},
				"name": "Indochina",
				"salience": 0.001320497,
				"type": "LOCATION"
			},
			{
				"name": "jobs",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"name": "rescue",
				"salience": 0.001308347,
				"type": "EVENT"
			},
			{
				"name": "profit",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"name": "hopes",
				"salience": 0.001308347,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0651vn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marxism"
				},
				"name": "Marxists",
				"salience": 0.0012712043,
				"type": "PERSON"
			},
			{
				"name": "conundrum",
				"salience": 0.0011004284,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01crd5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vietnam"
				},
				"name": "Vietnamese",
				"salience": 0.0010779949,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0841v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Walmart"
				},
				"name": "Wal-Mart",
				"salience": 0.0010779949,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0_8_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Agent_Orange"
				},
				"name": "Agent Orange",
				"salience": 0.0010779949,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.0010779949,
				"type": "PERSON"
			},
			{
				"name": "garbage",
				"salience": 0.0009528637,
				"type": "OTHER"
			},
			{
				"name": "co-chair",
				"salience": 0.0009528637,
				"type": "OTHER"
			},
			{
				"name": "managing editor",
				"salience": 0.0009528637,
				"type": "PERSON"
			},
			{
				"name": "fears",
				"salience": 0.0009528637,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0009528637,
				"type": "OTHER"
			},
			{
				"name": "Thanks",
				"salience": 0.00091729,
				"type": "OTHER"
			},
			{
				"name": "GA Green party",
				"salience": 0.0009150393,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime change",
				"salience": 0.0009104299,
				"type": "EVENT"
			},
			{
				"name": "opponent",
				"salience": 0.0009104299,
				"type": "PERSON"
			},
			{
				"name": "troops",
				"salience": 0.0008500761,
				"type": "PERSON"
			},
			{
				"name": "stands",
				"salience": 0.000822011,
				"type": "OTHER"
			},
			{
				"name": "social security stand",
				"salience": 0.000822011,
				"type": "OTHER"
			},
			{
				"name": "margin",
				"salience": 0.0007680535,
				"type": "OTHER"
			},
			{
				"name": "evidence",
				"salience": 0.0007583734,
				"type": "OTHER"
			},
			{
				"name": "showdown",
				"salience": 0.0007117721,
				"type": "EVENT"
			},
			{
				"name": "range",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0007117721,
				"type": "LOCATION"
			},
			{
				"name": "issues",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "charter schools",
				"salience": 0.0007117721,
				"type": "ORGANIZATION"
			},
			{
				"name": "trade agreements",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "fracking",
				"salience": 0.0007117721,
				"type": "EVENT"
			},
			{
				"name": "contrast",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "victory",
				"salience": 0.0007117721,
				"type": "EVENT"
			},
			{
				"name": "mandate",
				"salience": 0.0007117721,
				"type": "OTHER"
			},
			{
				"name": "Marietta GA",
				"salience": 0.00067726464,
				"type": "LOCATION"
			},
			{
				"name": "appearance",
				"salience": 0.000611277,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Radio I",
				"salience": 0.0005864335,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Report",
				"salience": 0.0005864335,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "US",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukraine",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.00043804114,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027m_21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/WikiLeaks"
				},
				"name": "Wikileaks",
				"salience": 0.00043804114,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-10-27T06:05:00.000+03:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.3,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "  A Black Agenda Radio Commentary by Bruce A. Dixon \nWhen astute political commentary from a half century ago eloquently describes the current political conundrum it means we’ve been stuck in a bad place for a long time. Do we really want Malcolm’s observation to apply four or eight or twenty years further into the future? Malcolm X on Hillary Clinton and Donald Trump A Black Agenda Radio Commentary by Bruce A. Dixon \nIt’s that time again, it’s presidential election season, and as we hear every four years, THIS is the most important presidential election of our lives. The fact that you’ve heard that before should tell us something. It should us that in presidential years, many old things becomes new again, often because so much of what we’re told IS new is really pretty old. \nMalcolm X has been dead now a half century, dead for more years than he was ever alive. But since at least one of the tricks and traps deployed to fool, frustrate and neutralize our grandparents’ right to vote hasn’t changed much we might want to listen carefully to what Malcolm’s words in the aftermath of the 1964 presidential election. \n“ If Johnson had been running all by himself, he would not have been acceptable to anyone. The only thing that made him acceptable to the world was that the shrewd capitalists, the shrewd imperialists, knew that the only way people would run toward the fox would be if you showed them a wolf. So they created a ghastly alternative. And it had the whole world — including people who call themselves Marxists — hoping that Johnson would beat Goldwater.” \nLike today’s Donald Trump, Republican presidential candidate Barry Goldwater was a truly reprehensible and frightening figure, who had opposed the Civil Rights Act of 1964 that banned racial discrimination in public accommodations, and who favored the use of nuclear weapons to defoliate the Vietnamese countryside. Also like Donald Trump, Goldwater never really stood a chance of winning the election. Goldwater the wolf was buried beneath a Johnson landslide, carrying only 6 out of the 50 states. Republican officeholders are running away from Donald Trump not because he’s a racist bufoon but because he’s expected to lose states Republicans are accustomed to winning. \nThe fox, Lyndon Baines Johnson went on to start a war in Indochina that killed three million Vietnamese alone. LBJ defoliated the Vietnamese countryside with millions of tons of Agent Orange instead of nukes, causing hundreds of thousands of hideous and gruesome birth defects that continue to this day. \nThe wolf and the fox this year are Donald Trump and Hillary Clinton. Trump is a real estate con man, a racist and a hyper-entitled sexual predator who talks about building walls and banning Muslims. Fortunately for us all, Trump has never been in government. Hillary has scarcely ever been out of government. She’s fronted for Wal-Mart, executed bloody regime change in Libya, brought US troops to Ukraine on the Russian border, and publicly itches for a showdown in Syria. Thanks to Wikileaks there is copious evidence that Hillary’s public stands on a wide range of issues from charter schools to so-called trade agreements, to fracking and social security stand in stark contrast to the promises she makes to the powerful. \nJust as it worked 52 years ago, the overwhelming defeat of her wolvish opponent will give Hillary the appearance of a mandate. But the margin of Hillary’s victory provides those of us on the left an unprecedented opportunity. It means there is no need for those who imagine themselves on the of jobs, justice, peace and the planet to ride to Hilllary’s rescue and ensure the defeat of Donald Trump. Trump has already beaten himself. \nThis election is our best chance to break out of the decades-old two party trap and build a new political force, a new political party. The Green Party is the only peace party, the only party that stands for people and planet over profit, and our only opportunity to vote our hopes, not our fears. It’s time to choose. \nWe vote Green and build Green, we can consign the political conundrum Malcolm X eloquently described a half century ago to the garbage can of history. Or we can vote for Hillary, and Malcolm’s words will be as applicable four or eight years or twenty years from now as they have been for the last fifty. For Black Agenda Radio I’m Bruce Dixon. Bruce Dixon is managing editor at Black Agenda Report and the co-chair of the GA Green party. He lives and works near Marietta GA and can be reached  ",
		"thread_title": "Malcolm X on Hillary Clinton and Donald Trump",
		"title": "Malcolm X on Hillary Clinton and Donald Trump",
		"type": "bs",
		"uuid": "14ce8cd22c29bc948250e7741e6918fd70e54d01"
	},
	"-KhIkNc3oIMuLrKo52gE": {
		"author": "Nellie Bailey and Glen Ford",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-01T03:22:32.308+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "thing",
				"salience": 0.085516825,
				"type": "OTHER"
			},
			{
				"name": "Edward Pinkney",
				"salience": 0.08099183,
				"type": "PERSON"
			},
			{
				"name": "self-determination",
				"salience": 0.06769074,
				"type": "OTHER"
			},
			{
				"name": "Anthony Monteiro",
				"salience": 0.043101817,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.038691405,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.03353792,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.03353792,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.03353792,
				"type": "OTHER"
			},
			{
				"name": "George Caccariello-Maher",
				"salience": 0.025375335,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/054kd8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omali_Yeshitela"
				},
				"name": "Omali Yeshitela",
				"salience": 0.022182219,
				"type": "PERSON"
			},
			{
				"name": "Nellie Bailey",
				"salience": 0.01848323,
				"type": "PERSON"
			},
			{
				"name": "Venezuela The Missing Black Movement Ingredient: Self-Determination The Black Is Back Coalition for Social Justice, Peace and Reparations",
				"salience": 0.014646874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Marcina Cole",
				"salience": 0.01443541,
				"type": "PERSON"
			},
			{
				"name": "National Black Political Convention on Self-Determination",
				"salience": 0.012168001,
				"type": "EVENT"
			},
			{
				"name": "points",
				"salience": 0.010670553,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Report for Week",
				"salience": 0.010586588,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0pb5dms",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2013_Monte_Carlo_Rally"
				},
				"name": "Mon",
				"salience": 0.010586588,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, DC",
				"salience": 0.010586588,
				"type": "LOCATION"
			},
			{
				"name": "self-determination",
				"salience": 0.0104576815,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.009057542,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.009057542,
				"type": "OTHER"
			},
			{
				"name": "human rights leader",
				"salience": 0.00896241,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.00883992,
				"type": "EVENT"
			},
			{
				"name": "plan",
				"salience": 0.008179157,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.007546791,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007303042,
				"type": "PERSON"
			},
			{
				"name": "struggles",
				"salience": 0.007083624,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.007083624,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.007083624,
				"type": "LOCATION"
			},
			{
				"name": "need",
				"salience": 0.007083624,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.007083624,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.006619942,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00634862,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.006116102,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0061118337,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0pyfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Coalition"
				},
				"name": "Coalition",
				"salience": 0.006090878,
				"type": "ORGANIZATION"
			},
			{
				"name": "beginning",
				"salience": 0.006084556,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0057366276,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.0057366276,
				"type": "LOCATION"
			},
			{
				"name": "empire",
				"salience": 0.0057366276,
				"type": "OTHER"
			},
			{
				"name": "planners",
				"salience": 0.0057366276,
				"type": "PERSON"
			},
			{
				"name": "Dr.",
				"salience": 0.0057366276,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0057366276,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black",
				"salience": 0.0055777826,
				"type": "PERSON"
			},
			{
				"name": "reparations",
				"salience": 0.00552264,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00552264,
				"type": "OTHER"
			},
			{
				"name": "Ajamu Baraka",
				"salience": 0.005509832,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07rclwk"
				},
				"name": "Hard Times",
				"salience": 0.0053020944,
				"type": "ORGANIZATION"
			},
			{
				"name": "Black Is Back",
				"salience": 0.0050365,
				"type": "ORGANIZATION"
			},
			{
				"name": "pun",
				"salience": 0.0049679093,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.0049679093,
				"type": "EVENT"
			},
			{
				"name": "stakes",
				"salience": 0.0049679093,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.0049679093,
				"type": "OTHER"
			},
			{
				"name": "police invasion",
				"salience": 0.0047825673,
				"type": "EVENT"
			},
			{
				"name": "elite",
				"salience": 0.0047825673,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0047825673,
				"type": "PERSON"
			},
			{
				"name": "activist",
				"salience": 0.0047825673,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "brutality",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0047435113,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ylj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venezuela"
				},
				"name": "Venezuelans",
				"salience": 0.0046856734,
				"type": "PERSON"
			},
			{
				"name": "goods",
				"salience": 0.0046837702,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "goods",
				"salience": 0.0046837702,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "opposition",
				"salience": 0.0046837702,
				"type": "ORGANIZATION"
			},
			{
				"name": "access",
				"salience": 0.004432351,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ylj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venezuela"
				},
				"name": "Venezuela",
				"salience": 0.004233842,
				"type": "LOCATION"
			},
			{
				"name": "Moment of Truth",
				"salience": 0.0042205523,
				"type": "WORK_OF_ART"
			},
			{
				"name": "opposition government",
				"salience": 0.00415176,
				"type": "ORGANIZATION"
			},
			{
				"name": "Black Radical Organizing Committee",
				"salience": 0.004075863,
				"type": "ORGANIZATION"
			},
			{
				"name": "blood",
				"salience": 0.004056016,
				"type": "OTHER"
			},
			{
				"name": "Revolutionary Science for Radical Times",
				"salience": 0.0039114566,
				"type": "ORGANIZATION"
			},
			{
				"name": "birthday party",
				"salience": 0.00387548,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0037589606,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.0033999574,
				"type": "ORGANIZATION"
			},
			{
				"name": "sentence",
				"salience": 0.0033536388,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qdcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Party_(France)"
				},
				"name": "Socialist Party",
				"salience": 0.0031933517,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.0030583057,
				"type": "LOCATION"
			},
			{
				"name": "ministry work",
				"salience": 0.0030301712,
				"type": "OTHER"
			},
			{
				"name": "inmates",
				"salience": 0.0030301712,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0030301712,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.0030301712,
				"type": "EVENT"
			},
			{
				"name": "election tampering charges",
				"salience": 0.0030301712,
				"type": "OTHER"
			},
			{
				"name": "Duboisian",
				"salience": 0.0029441628,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0029441628,
				"type": "LOCATION"
			},
			{
				"name": "prisoner",
				"salience": 0.0029170776,
				"type": "PERSON"
			},
			{
				"name": "strength",
				"salience": 0.0027033887,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0025486988,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/029d_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drexel_University"
				},
				"name": "Drexel University",
				"salience": 0.0024967485,
				"type": "ORGANIZATION"
			},
			{
				"name": "We Created Chavez: A People's History",
				"salience": 0.0024967485,
				"type": "ORGANIZATION"
			},
			{
				"name": "problems",
				"salience": 0.0024848757,
				"type": "OTHER"
			},
			{
				"name": "communes",
				"salience": 0.0022825715,
				"type": "OTHER"
			},
			{
				"name": "Length",
				"salience": 0.0022069698,
				"type": "OTHER"
			},
			{
				"name": "edition",
				"salience": 0.0022069698,
				"type": "WORK_OF_ART"
			},
			{
				"name": "outside",
				"salience": 0.0022069698,
				"type": "OTHER"
			},
			{
				"name": "vice",
				"salience": 0.0022069698,
				"type": "PERSON"
			},
			{
				"name": "Michigan Emergency Committee Against War",
				"salience": 0.0021539377,
				"type": "EVENT"
			},
			{
				"name": "nation",
				"salience": 0.0019039306,
				"type": "LOCATION"
			},
			{
				"name": "Left",
				"salience": 0.0019039306,
				"type": "OTHER"
			},
			{
				"name": "Birthday",
				"salience": 0.0019039306,
				"type": "EVENT"
			},
			{
				"name": "organizations",
				"salience": 0.0019039306,
				"type": "ORGANIZATION"
			},
			{
				"name": "Black Agenda Radio",
				"salience": 0.0018807021,
				"type": "OTHER"
			},
			{
				"name": "David Sole",
				"salience": 0.0018651175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bm8yn8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Injustice"
				},
				"name": "Injustice",
				"salience": 0.0018651175,
				"type": "OTHER"
			},
			{
				"name": "absentia",
				"salience": 0.0018651175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.0018651175,
				"type": "LOCATION"
			},
			{
				"name": "Progressive Radio Network",
				"salience": 0.001788759,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0017789684,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.0017374307,
				"type": "ORGANIZATION"
			},
			{
				"name": "land",
				"salience": 0.001648622,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "Corruption",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "smuggling",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "money speculation",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_01w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Ford"
				},
				"name": "Glen Ford",
				"salience": 0.0013583337,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.001171792,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01pp70",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bolivarian_Revolution"
				},
				"name": "Venezuelan Revolution",
				"salience": 0.001171792,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0v2bb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benton_Harbor,_Michigan"
				},
				"name": "Benton Harbor",
				"salience": 0.0010146389,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T03:22:32.308+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "News, information and analysis from the black left. Black Agenda Report for Week of Oct 31, 2016 Submitted by Nellie Bailey a... on Mon, 10/31/2016 - 20:45 Venezuela The Missing Black Movement Ingredient: Self-Determination \nThe Black Is Back Coalition for Social Justice, Peace and Reparations will hold a National Black Political Convention on Self-Determination, November 5 and 6, in Washington, DC. “If you go through history, the fundamental thing that we’ve confronted is the loss of our self-determination as a people,” said Black Is Back chairman Omali Yeshitela . The Coalition has put forward a 19-point position on the need to put self-determination at the center of Black struggles. The 19 points “give us the beginning of some kind of a plan,” said Yeshitela. “It says, specifically, here is our view on self-determination and the subject of reparations, Black women, the question of police invasion and brutality in our community,” and many other issues. The “Moment of Truth” for the Empire \n“We are entering a new moment in American history,” said Dr. Anthony Monteiro , the Duboisian scholar and Black Radical Organizing Committee activist. “It is a moment of truth for the ruling class, for the ruling elite. What do they do when they are trumped at home -- forgive the pun -- and trumped internationally?” he asked. “Do they back off of empire, do they readjust, do they become peaceful, or do they up the stakes and attempt to resolve all problems with war abroad and oppression at home?” Dr. Monteiro is one of the planners of a Revolutionary Science for Radical Times conference, in Philadelphia, December 9 and 10. Hard Times in Venezuela \nDespite what the corporate media are telling you, Venezuelans are not starving and the Socialist Party government will not be toppled any time soon. However, the rightwing opposition “is smelling blood” due to an economic crisis that “has made it very difficult for people to get access to imported goods, and many goods are very expensive,” said political science professor George Caccariello-Maher , of Drexel University, author of We Created Chavez: A People’s History of the Venezuelan Revolution . Corruption, smuggling and money speculation are serious problems, said Caccariello-Maher. However, the strength of the Left lies in the nation’s grassroots organizations and communes. “It would be very difficult for an opposition government to come in and attempt to throw them off their land” or return property to the private sector, he said. Happy Birthday, Rev. Pinkney! \nBenton Harbor, Michigan, human rights leader Rev. Edward Pinkney, currently serving a 2 ½ to 10 year sentence on election tampering charges, turned 68 years old this month. Marcina Cole , a courtroom observer at Pinkney’s trial, teamed up with David Sole , of the Michigan Emergency Committee Against War and Injustice, to throw a birthday party for Pinkney, in absentia, in Detroit. “He’s definitely in support of other inmates, doing ministry work, and looking forward to being out very soon,” said Cole. She reported that Green Party vice presidential candidate Ajamu Baraka visited the political prisoner on October 19. “This was historical,” said Cole. “They know how powerful Rev. Pinkney is” -- and that he has allies on the outside. Black Agenda Radio on the Progressive Radio Network is hosted by Glen Ford and Nellie Bailey. A new edition of the program airs every Monday at 11:00am ET on PRN. Length: one hour.",
		"thread_title": "Black Agenda Report for Week of Oct 31, 2016",
		"title": "Black Agenda Report for Week of Oct 31, 2016",
		"type": "bs",
		"uuid": "ae9f37afa403f7eb17377232aaf2175f49ee407b"
	},
	"-KhIkOSWgywYpT-f5eiH": {
		"author": "Nellie Bailey and Glen Ford",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-01T04:43:14.786+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "thing",
				"salience": 0.085516825,
				"type": "OTHER"
			},
			{
				"name": "Edward Pinkney",
				"salience": 0.08099183,
				"type": "PERSON"
			},
			{
				"name": "self-determination",
				"salience": 0.06769074,
				"type": "OTHER"
			},
			{
				"name": "Anthony Monteiro",
				"salience": 0.043101817,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.038691405,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.03353792,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.03353792,
				"type": "OTHER"
			},
			{
				"name": "News",
				"salience": 0.03353792,
				"type": "OTHER"
			},
			{
				"name": "George Caccariello-Maher",
				"salience": 0.025375335,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/054kd8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Omali_Yeshitela"
				},
				"name": "Omali Yeshitela",
				"salience": 0.022182219,
				"type": "PERSON"
			},
			{
				"name": "Nellie Bailey",
				"salience": 0.01848323,
				"type": "PERSON"
			},
			{
				"name": "Venezuela The Missing Black Movement Ingredient: Self-Determination The Black Is Back Coalition for Social Justice, Peace and Reparations",
				"salience": 0.014646874,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Marcina Cole",
				"salience": 0.01443541,
				"type": "PERSON"
			},
			{
				"name": "National Black Political Convention on Self-Determination",
				"salience": 0.012168001,
				"type": "EVENT"
			},
			{
				"name": "points",
				"salience": 0.010670553,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Report for Week",
				"salience": 0.010586588,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0pb5dms",
					"wikipedia_url": "http://en.wikipedia.org/wiki/2013_Monte_Carlo_Rally"
				},
				"name": "Mon",
				"salience": 0.010586588,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington, DC",
				"salience": 0.010586588,
				"type": "LOCATION"
			},
			{
				"name": "self-determination",
				"salience": 0.0104576815,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.009057542,
				"type": "PERSON"
			},
			{
				"name": "history",
				"salience": 0.009057542,
				"type": "OTHER"
			},
			{
				"name": "human rights leader",
				"salience": 0.00896241,
				"type": "PERSON"
			},
			{
				"name": "crisis",
				"salience": 0.00883992,
				"type": "EVENT"
			},
			{
				"name": "plan",
				"salience": 0.008179157,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.007546791,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.007303042,
				"type": "PERSON"
			},
			{
				"name": "struggles",
				"salience": 0.007083624,
				"type": "OTHER"
			},
			{
				"name": "kind",
				"salience": 0.007083624,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.007083624,
				"type": "LOCATION"
			},
			{
				"name": "need",
				"salience": 0.007083624,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.007083624,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.006619942,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00634862,
				"type": "ORGANIZATION"
			},
			{
				"name": "history",
				"salience": 0.006116102,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.0061118337,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0pyfv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Coalition"
				},
				"name": "Coalition",
				"salience": 0.006090878,
				"type": "ORGANIZATION"
			},
			{
				"name": "beginning",
				"salience": 0.006084556,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0057366276,
				"type": "EVENT"
			},
			{
				"name": "home",
				"salience": 0.0057366276,
				"type": "LOCATION"
			},
			{
				"name": "empire",
				"salience": 0.0057366276,
				"type": "OTHER"
			},
			{
				"name": "planners",
				"salience": 0.0057366276,
				"type": "PERSON"
			},
			{
				"name": "Dr.",
				"salience": 0.0057366276,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0057366276,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black",
				"salience": 0.0055777826,
				"type": "PERSON"
			},
			{
				"name": "reparations",
				"salience": 0.00552264,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00552264,
				"type": "OTHER"
			},
			{
				"name": "Ajamu Baraka",
				"salience": 0.005509832,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07rclwk"
				},
				"name": "Hard Times",
				"salience": 0.0053020944,
				"type": "ORGANIZATION"
			},
			{
				"name": "Black Is Back",
				"salience": 0.0050365,
				"type": "ORGANIZATION"
			},
			{
				"name": "pun",
				"salience": 0.0049679093,
				"type": "OTHER"
			},
			{
				"name": "conference",
				"salience": 0.0049679093,
				"type": "EVENT"
			},
			{
				"name": "stakes",
				"salience": 0.0049679093,
				"type": "OTHER"
			},
			{
				"name": "oppression",
				"salience": 0.0049679093,
				"type": "OTHER"
			},
			{
				"name": "police invasion",
				"salience": 0.0047825673,
				"type": "EVENT"
			},
			{
				"name": "elite",
				"salience": 0.0047825673,
				"type": "PERSON"
			},
			{
				"name": "class",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "subject",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.0047825673,
				"type": "PERSON"
			},
			{
				"name": "activist",
				"salience": 0.0047825673,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "brutality",
				"salience": 0.0047825673,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.0047435113,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ylj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venezuela"
				},
				"name": "Venezuelans",
				"salience": 0.0046856734,
				"type": "PERSON"
			},
			{
				"name": "goods",
				"salience": 0.0046837702,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "goods",
				"salience": 0.0046837702,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "opposition",
				"salience": 0.0046837702,
				"type": "ORGANIZATION"
			},
			{
				"name": "access",
				"salience": 0.004432351,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ylj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Venezuela"
				},
				"name": "Venezuela",
				"salience": 0.004233842,
				"type": "LOCATION"
			},
			{
				"name": "Moment of Truth",
				"salience": 0.0042205523,
				"type": "WORK_OF_ART"
			},
			{
				"name": "opposition government",
				"salience": 0.00415176,
				"type": "ORGANIZATION"
			},
			{
				"name": "Black Radical Organizing Committee",
				"salience": 0.004075863,
				"type": "ORGANIZATION"
			},
			{
				"name": "blood",
				"salience": 0.004056016,
				"type": "OTHER"
			},
			{
				"name": "Revolutionary Science for Radical Times",
				"salience": 0.0039114566,
				"type": "ORGANIZATION"
			},
			{
				"name": "birthday party",
				"salience": 0.00387548,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0037589606,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.0033999574,
				"type": "ORGANIZATION"
			},
			{
				"name": "sentence",
				"salience": 0.0033536388,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01qdcv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Socialist_Party_(France)"
				},
				"name": "Socialist Party",
				"salience": 0.0031933517,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.0030583057,
				"type": "LOCATION"
			},
			{
				"name": "ministry work",
				"salience": 0.0030301712,
				"type": "OTHER"
			},
			{
				"name": "inmates",
				"salience": 0.0030301712,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0030301712,
				"type": "OTHER"
			},
			{
				"name": "trial",
				"salience": 0.0030301712,
				"type": "EVENT"
			},
			{
				"name": "election tampering charges",
				"salience": 0.0030301712,
				"type": "OTHER"
			},
			{
				"name": "Duboisian",
				"salience": 0.0029441628,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0029441628,
				"type": "LOCATION"
			},
			{
				"name": "prisoner",
				"salience": 0.0029170776,
				"type": "PERSON"
			},
			{
				"name": "strength",
				"salience": 0.0027033887,
				"type": "OTHER"
			},
			{
				"name": "program",
				"salience": 0.0025486988,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/029d_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Drexel_University"
				},
				"name": "Drexel University",
				"salience": 0.0024967485,
				"type": "ORGANIZATION"
			},
			{
				"name": "We Created Chavez: A People's History",
				"salience": 0.0024967485,
				"type": "ORGANIZATION"
			},
			{
				"name": "problems",
				"salience": 0.0024848757,
				"type": "OTHER"
			},
			{
				"name": "communes",
				"salience": 0.0022825715,
				"type": "OTHER"
			},
			{
				"name": "Length",
				"salience": 0.0022069698,
				"type": "OTHER"
			},
			{
				"name": "edition",
				"salience": 0.0022069698,
				"type": "WORK_OF_ART"
			},
			{
				"name": "outside",
				"salience": 0.0022069698,
				"type": "OTHER"
			},
			{
				"name": "vice",
				"salience": 0.0022069698,
				"type": "PERSON"
			},
			{
				"name": "Michigan Emergency Committee Against War",
				"salience": 0.0021539377,
				"type": "EVENT"
			},
			{
				"name": "nation",
				"salience": 0.0019039306,
				"type": "LOCATION"
			},
			{
				"name": "Left",
				"salience": 0.0019039306,
				"type": "OTHER"
			},
			{
				"name": "Birthday",
				"salience": 0.0019039306,
				"type": "EVENT"
			},
			{
				"name": "organizations",
				"salience": 0.0019039306,
				"type": "ORGANIZATION"
			},
			{
				"name": "Black Agenda Radio",
				"salience": 0.0018807021,
				"type": "OTHER"
			},
			{
				"name": "David Sole",
				"salience": 0.0018651175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0bm8yn8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Injustice"
				},
				"name": "Injustice",
				"salience": 0.0018651175,
				"type": "OTHER"
			},
			{
				"name": "absentia",
				"salience": 0.0018651175,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02dtg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Detroit"
				},
				"name": "Detroit",
				"salience": 0.0018651175,
				"type": "LOCATION"
			},
			{
				"name": "Progressive Radio Network",
				"salience": 0.001788759,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0017789684,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.0017374307,
				"type": "ORGANIZATION"
			},
			{
				"name": "land",
				"salience": 0.001648622,
				"type": "LOCATION"
			},
			{
				"name": "lies",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "property",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "sector",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "Corruption",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "smuggling",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"name": "money speculation",
				"salience": 0.001648622,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_01w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Ford"
				},
				"name": "Glen Ford",
				"salience": 0.0013583337,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.001171792,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01pp70",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bolivarian_Revolution"
				},
				"name": "Venezuelan Revolution",
				"salience": 0.001171792,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0v2bb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Benton_Harbor,_Michigan"
				},
				"name": "Benton Harbor",
				"salience": 0.0010146389,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-01T04:43:14.786+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 8.1,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "News, information and analysis from the black left. Black Agenda Report for Week of Oct 31, 2016 Submitted by Nellie Bailey a... on Mon, 10/31/2016 - 20:45 Venezuela The Missing Black Movement Ingredient: Self-Determination \nThe Black Is Back Coalition for Social Justice, Peace and Reparations will hold a National Black Political Convention on Self-Determination, November 5 and 6, in Washington, DC. “If you go through history, the fundamental thing that we’ve confronted is the loss of our self-determination as a people,” said Black Is Back chairman Omali Yeshitela . The Coalition has put forward a 19-point position on the need to put self-determination at the center of Black struggles. The 19 points “give us the beginning of some kind of a plan,” said Yeshitela. “It says, specifically, here is our view on self-determination and the subject of reparations, Black women, the question of police invasion and brutality in our community,” and many other issues. The “Moment of Truth” for the Empire \n“We are entering a new moment in American history,” said Dr. Anthony Monteiro , the Duboisian scholar and Black Radical Organizing Committee activist. “It is a moment of truth for the ruling class, for the ruling elite. What do they do when they are trumped at home -- forgive the pun -- and trumped internationally?” he asked. “Do they back off of empire, do they readjust, do they become peaceful, or do they up the stakes and attempt to resolve all problems with war abroad and oppression at home?” Dr. Monteiro is one of the planners of a Revolutionary Science for Radical Times conference, in Philadelphia, December 9 and 10. Hard Times in Venezuela \nDespite what the corporate media are telling you, Venezuelans are not starving and the Socialist Party government will not be toppled any time soon. However, the rightwing opposition “is smelling blood” due to an economic crisis that “has made it very difficult for people to get access to imported goods, and many goods are very expensive,” said political science professor George Caccariello-Maher , of Drexel University, author of We Created Chavez: A People’s History of the Venezuelan Revolution . Corruption, smuggling and money speculation are serious problems, said Caccariello-Maher. However, the strength of the Left lies in the nation’s grassroots organizations and communes. “It would be very difficult for an opposition government to come in and attempt to throw them off their land” or return property to the private sector, he said. Happy Birthday, Rev. Pinkney! \nBenton Harbor, Michigan, human rights leader Rev. Edward Pinkney, currently serving a 2 ½ to 10 year sentence on election tampering charges, turned 68 years old this month. Marcina Cole , a courtroom observer at Pinkney’s trial, teamed up with David Sole , of the Michigan Emergency Committee Against War and Injustice, to throw a birthday party for Pinkney, in absentia, in Detroit. “He’s definitely in support of other inmates, doing ministry work, and looking forward to being out very soon,” said Cole. She reported that Green Party vice presidential candidate Ajamu Baraka visited the political prisoner on October 19. “This was historical,” said Cole. “They know how powerful Rev. Pinkney is” -- and that he has allies on the outside. Black Agenda Radio on the Progressive Radio Network is hosted by Glen Ford and Nellie Bailey. A new edition of the program airs every Monday at 11:00am ET on PRN. Length: one hour.",
		"thread_title": "Black Agenda Report for Week of Oct 31, 2016",
		"title": "Black Agenda Report for Week of Oct 31, 2016",
		"type": "bs",
		"uuid": "997ebf6226b6de98d1af23302e31718681c888a1"
	},
	"-KhIkP0leIro2BWk3RIN": {
		"author": "Glen Ford",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:41:47.262+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.23446791,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.05636538,
				"type": "LOCATION"
			},
			{
				"name": "empire",
				"salience": 0.052735545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.034389086,
				"type": "PERSON"
			},
			{
				"name": "empire",
				"salience": 0.031820007,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_01w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Ford"
				},
				"name": "Glen Ford",
				"salience": 0.027830932,
				"type": "PERSON"
			},
			{
				"name": "ruling class",
				"salience": 0.026923202,
				"type": "OTHER"
			},
			{
				"name": "Lords of Capital Sic Crazy Hillary",
				"salience": 0.022206906,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.021217935,
				"type": "OTHER"
			},
			{
				"name": "stocks",
				"salience": 0.021137133,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.021137133,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.016502548,
				"type": "LOCATION"
			},
			{
				"name": "commentary",
				"salience": 0.016394654,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crisis",
				"salience": 0.01466591,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.014207019,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.014207019,
				"type": "OTHER"
			},
			{
				"name": "War",
				"salience": 0.0129491985,
				"type": "EVENT"
			},
			{
				"name": "future",
				"salience": 0.011966747,
				"type": "OTHER"
			},
			{
				"name": "Widget A Black Agenda Radio",
				"salience": 0.011195873,
				"type": "ORGANIZATION"
			},
			{
				"name": "dollar",
				"salience": 0.010808885,
				"type": "OTHER"
			},
			{
				"name": "circles",
				"salience": 0.009732958,
				"type": "OTHER"
			},
			{
				"name": "card",
				"salience": 0.008942003,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07q3j97"
				},
				"name": "South",
				"salience": 0.008772645,
				"type": "LOCATION"
			},
			{
				"name": "creatures",
				"salience": 0.008553513,
				"type": "OTHER"
			},
			{
				"name": "derivatives",
				"salience": 0.008394098,
				"type": "OTHER"
			},
			{
				"name": "bonds",
				"salience": 0.008394098,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.007922922,
				"type": "LOCATION"
			},
			{
				"name": "dealer",
				"salience": 0.0077459468,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0068116165,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.006596639,
				"type": "LOCATION"
			},
			{
				"name": "The Lords of Capital",
				"salience": 0.0064270506,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cards",
				"salience": 0.005679997,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.005342962,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.0051086266,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0043536676,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0041474197,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0041474197,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0040503107,
				"type": "OTHER"
			},
			{
				"name": "rulers",
				"salience": 0.003880749,
				"type": "PERSON"
			},
			{
				"name": "trade",
				"salience": 0.0036926134,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.0035041568,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0034624538,
				"type": "OTHER"
			},
			{
				"name": "commentary",
				"salience": 0.0034600375,
				"type": "WORK_OF_ART"
			},
			{
				"name": "business",
				"salience": 0.0034600375,
				"type": "OTHER"
			},
			{
				"name": "measurement",
				"salience": 0.0034600375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03k6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Lords"
				},
				"name": "Lords",
				"salience": 0.0033174893,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.003308401,
				"type": "LOCATION"
			},
			{
				"name": "rulers",
				"salience": 0.003267751,
				"type": "PERSON"
			},
			{
				"name": "clock",
				"salience": 0.0031859756,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.003126481,
				"type": "OTHER"
			},
			{
				"name": "dollar",
				"salience": 0.003126481,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0031031189,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.002996416,
				"type": "OTHER"
			},
			{
				"name": "headquarters",
				"salience": 0.002996416,
				"type": "LOCATION"
			},
			{
				"name": "tools",
				"salience": 0.002996416,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.002996416,
				"type": "OTHER"
			},
			{
				"name": "severity",
				"salience": 0.002996416,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.002895873,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.002805893,
				"type": "LOCATION"
			},
			{
				"name": "dominance",
				"salience": 0.0028002055,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.002695735,
				"type": "PERSON"
			},
			{
				"name": "future",
				"salience": 0.0026872745,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0026760327,
				"type": "OTHER"
			},
			{
				"name": "derivatives",
				"salience": 0.002426452,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.002426452,
				"type": "OTHER"
			},
			{
				"name": "bonds",
				"salience": 0.002426452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.002377011,
				"type": "LOCATION"
			},
			{
				"name": "World A Black Agenda Radio",
				"salience": 0.0023592443,
				"type": "ORGANIZATION"
			},
			{
				"name": "influence",
				"salience": 0.0023359135,
				"type": "OTHER"
			},
			{
				"name": "imperialists",
				"salience": 0.0023359135,
				"type": "PERSON"
			},
			{
				"name": "terror",
				"salience": 0.0023359135,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.0021319028,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.002101216,
				"type": "OTHER"
			},
			{
				"name": "inflection point",
				"salience": 0.002101216,
				"type": "OTHER"
			},
			{
				"name": "world economy",
				"salience": 0.002101216,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.002101216,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.002096327,
				"type": "LOCATION"
			},
			{
				"name": "indicators",
				"salience": 0.002048611,
				"type": "OTHER"
			},
			{
				"name": "military force",
				"salience": 0.002022804,
				"type": "ORGANIZATION"
			},
			{
				"name": "borders",
				"salience": 0.002022804,
				"type": "LOCATION"
			},
			{
				"name": "coercion",
				"salience": 0.002022804,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.002022804,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0019810067,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0019810067,
				"type": "LOCATION"
			},
			{
				"name": "trend",
				"salience": 0.0019810067,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0019810067,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0019227841,
				"type": "OTHER"
			},
			{
				"name": "bets",
				"salience": 0.0018625036,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0017741928,
				"type": "EVENT"
			},
			{
				"name": "dominance",
				"salience": 0.0017741928,
				"type": "OTHER"
			},
			{
				"name": "prognosis",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "abundance",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "equals",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "human",
				"salience": 0.0017154393,
				"type": "PERSON"
			},
			{
				"name": "natural resources",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0015665782,
				"type": "EVENT"
			},
			{
				"name": "casinos",
				"salience": 0.0015013707,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0014799269,
				"type": "PERSON"
			},
			{
				"name": "subversion",
				"salience": 0.0014799269,
				"type": "OTHER"
			},
			{
				"name": "subversion",
				"salience": 0.0014799269,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0014799269,
				"type": "PERSON"
			},
			{
				"name": "earth",
				"salience": 0.0014799269,
				"type": "LOCATION"
			},
			{
				"name": "class",
				"salience": 0.001378625,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.001378625,
				"type": "OTHER"
			},
			{
				"name": "militaries",
				"salience": 0.0012815006,
				"type": "ORGANIZATION"
			},
			{
				"name": "connection",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"name": "continent",
				"salience": 0.0012815006,
				"type": "LOCATION"
			},
			{
				"name": "most",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.0012815006,
				"type": "EVENT"
			},
			{
				"name": "tens of thousands",
				"salience": 0.0012815006,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jtm8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_China_Sea"
				},
				"name": "South China Sea",
				"salience": 0.0012451207,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0012451207,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0012451207,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0011995063,
				"type": "LOCATION"
			},
			{
				"name": "executive editor",
				"salience": 0.0011937752,
				"type": "PERSON"
			},
			{
				"name": "Capital",
				"salience": 0.0011893335,
				"type": "LOCATION"
			},
			{
				"name": "empire",
				"salience": 0.001087798,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0010778514,
				"type": "EVENT"
			},
			{
				"name": "creatures",
				"salience": 0.0010508568,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00096529163,
				"type": "EVENT"
			},
			{
				"name": "email",
				"salience": 0.0009333161,
				"type": "WORK_OF_ART"
			},
			{
				"name": "web",
				"salience": 0.0009333161,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0009333161,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.0009333161,
				"type": "EVENT"
			},
			{
				"name": "mob",
				"salience": 0.0009333161,
				"type": "OTHER"
			},
			{
				"name": "servants",
				"salience": 0.0008649295,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.00080514926,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00080514926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.000788734,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000788734,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.000788734,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04pnx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latin_America"
				},
				"name": "Latin America",
				"salience": 0.000788734,
				"type": "LOCATION"
			},
			{
				"name": "care",
				"salience": 0.0007428177,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Radio",
				"salience": 0.00073473185,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "industries",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "security networks",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "BlackAgendaReport.com",
				"salience": 0.000574406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01nz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bar_(establishment)"
				},
				"name": "BAR",
				"salience": 0.000574406,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0004955171,
				"type": "LOCATION"
			},
			{
				"name": "Beat the Clock",
				"salience": 0.0004955171,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T09:41:47.262+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget A Black Agenda Radio commentary by executive editor Glen Ford \nThe capitalist ruling class is frightened, for good reason: the empire cannot peacefully contain the rising economic powers of the South and East. “The Lords of Capital know there is no future for them in a world where the dollar is not supreme and where Wall Street’s stocks, bonds and derivatives are not backed by the full weight of unchallenged empire.” War is the only card they have left to play – and Hillary Clinton is their favored dealer. The Lords of Capital Sic Crazy Hillary on the World A Black Agenda Radio commentary by executive editor Glen Ford \n“The Lords of Capital are creatures of U.S. imperial dominance; they go out of business when the empire does.” \nBy virtually every measurement, the United States is in deep crisis, as both a society and as the headquarters of global capitalism. We can roughly measure the severity of some aspects of the crisis with the tools of economic analysis. Such an analysis is quite useful in explaining why Washington is so eager to risk war with Russia and China, whether in Syria or the South China Sea or along the ever expanding borders of NATO. To put it simply, the U.S. and western Europe become smaller, in terms of their economic influence, with every passing day, and cannot possibly maintain their political dominance in the world except by military force, coercion and terror. Those are the only cards the imperialists have left to play. The ruling circles in the U.S. are aware that time is not on their side, and it makes them crazy -- or crazier than usual. \nThe ruling class’s own analysts tell them that the center of the world economy is moving inexorably to the East and the South; that this trend will continue for the foreseeable future; and that the U.S. is already number two by some economic measures -- and dropping. The Lords of Capital know there is no future for them in a world where the dollar is not supreme and where Wall Street’s stocks, bonds and derivatives are not backed by the full weight of unchallenged empire. Put another way, U.S. imperialism is at an inflection point, with all the indicators pointing downward and no hope of reversing the trend by peaceful means. \nNow, that’s actually not such a bad prognosis for the United States, as a country. The U.S. is a big country, with an abundance of human and natural resources, and would do just fine in a world among equals. But, the fate of the Lords of Capital is tied to the ongoing existence of empire. They create nothing, but seek to monetize and turn a profit on everything. They cannot succeed in trade unless it is rigged, and have placed bets in their casinos that are nominally seven times more valuable than the total economic activity of planet Earth. In short, the Lords of Capital are creatures of U.S. imperial dominance; they go out of business when the empire does. \nBeat the Clock \nThe rulers are looking class death in the face -- and it terrifies them. And when the Lords of Capital become frightened, they order their servants in politics and the war industries and the vast national security networks to take care of the problem, by any means necessary. That means militarily encircling Russia and China; arming and mobilizing tens of thousands of jihadist terrorists in Syria, in an attempt to repeat the regime change in Libya; waging a war of economic sanctions and low-level armed aggression against Iran; occupying most of the African continent through subversion of African militaries; escalating subversion in Latin America; and spying on everyone on earth with a digital connection. All this, to stop the clock that is ticking on U.S. and European world economic dominance. \nLeft political analysts that I greatly respect argue that Hillary Clinton and the mob she will come in with in January will pull back from apocalyptic confrontation with Russia in Syria -- that they’re not really that crazy. But, I’m not at all convinced. The ruling class isn’t just imagining that their days are numbered; it’s really true. And rulers do get crazy when their class is standing at death’s door. \nFor Black Agenda Radio, I’m Glen Ford. On the web, go to BlackAgendaReport.com. BAR executive editor Glen Ford can be contacted at [email protected] .",
		"thread_title": "The Lords of Capital Sic Crazy Hillary on the World",
		"title": "The Lords of Capital Sic Crazy Hillary on the World",
		"type": "bs",
		"uuid": "c5dae6ec8f4c9876353775173b85458ed70bae46"
	},
	"-KhIkPZDsHzZr3pVpCN3": {
		"author": "Margaret Kimberley",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:41:48.857+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.3004172,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.23244461,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.08297117,
				"type": "PERSON"
			},
			{
				"name": "Margaret Kimberley",
				"salience": 0.06478829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabian",
				"salience": 0.021206273,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.010575903,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.010082143,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.008961732,
				"type": "PERSON"
			},
			{
				"name": "fate",
				"salience": 0.008280423,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0068682567,
				"type": "LOCATION"
			},
			{
				"name": "regime",
				"salience": 0.0068682567,
				"type": "OTHER"
			},
			{
				"name": "chair",
				"salience": 0.0062268856,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.005860401,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.005860002,
				"type": "LOCATION"
			},
			{
				"name": "BAR editor",
				"salience": 0.005374602,
				"type": "PERSON"
			},
			{
				"name": "head-chopping",
				"salience": 0.0046558855,
				"type": "EVENT"
			},
			{
				"name": "kleptocracy",
				"salience": 0.0046558855,
				"type": "OTHER"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.0046558855,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.004529397,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.0043741055,
				"type": "EVENT"
			},
			{
				"name": "villainy",
				"salience": 0.0041851886,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckxt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Watch"
				},
				"name": "Human Rights Watch",
				"salience": 0.0038158875,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z4f6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Human_Rights_Council"
				},
				"name": "United Nations Human Rights Council",
				"salience": 0.00380156,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime change",
				"salience": 0.0032941122,
				"type": "EVENT"
			},
			{
				"name": "fighting",
				"salience": 0.0032941122,
				"type": "EVENT"
			},
			{
				"name": "reality",
				"salience": 0.00324704,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0032185202,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0031400744,
				"type": "PERSON"
			},
			{
				"name": "War Party",
				"salience": 0.0030877194,
				"type": "ORGANIZATION"
			},
			{
				"name": "tales",
				"salience": 0.0028608926,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0027484586,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0027484586,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.0027484586,
				"type": "PERSON"
			},
			{
				"name": "Freedom Rider",
				"salience": 0.0027484586,
				"type": "PERSON"
			},
			{
				"name": "Regime change",
				"salience": 0.0025406058,
				"type": "OTHER"
			},
			{
				"name": "Regime change",
				"salience": 0.0025406058,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0025221969,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0023846983,
				"type": "PERSON"
			},
			{
				"name": "massacre",
				"salience": 0.0023803613,
				"type": "OTHER"
			},
			{
				"name": "travesty",
				"salience": 0.0023803613,
				"type": "OTHER"
			},
			{
				"name": "march",
				"salience": 0.0023803613,
				"type": "OTHER"
			},
			{
				"name": "cheers",
				"salience": 0.0023803613,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.0022643898,
				"type": "PERSON"
			},
			{
				"name": "goal",
				"salience": 0.002110131,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0019160587,
				"type": "PERSON"
			},
			{
				"name": "Russophobia: War Party Propaganda",
				"salience": 0.0018743821,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01nz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bar_(establishment)"
				},
				"name": "BAR",
				"salience": 0.0018743821,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0017466011,
				"type": "LOCATION"
			},
			{
				"name": "terror war",
				"salience": 0.0017355549,
				"type": "EVENT"
			},
			{
				"name": "All",
				"salience": 0.0016856331,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0016143792,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0016034342,
				"type": "PERSON"
			},
			{
				"name": "war party",
				"salience": 0.0016034342,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0016034342,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0015292274,
				"type": "LOCATION"
			},
			{
				"name": "presidency",
				"salience": 0.0015292274,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0015292274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0014656871,
				"type": "LOCATION"
			},
			{
				"name": "Superpower of Lies",
				"salience": 0.0014656871,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0014478182,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0013683422,
				"type": "ORGANIZATION"
			},
			{
				"name": "death",
				"salience": 0.0013571025,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.0013302143,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0013076712,
				"type": "LOCATION"
			},
			{
				"name": "fear",
				"salience": 0.001301455,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.0012537676,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0012170641,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Assad",
				"salience": 0.0011669556,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.0011320617,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0011320617,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.0011320617,
				"type": "EVENT"
			},
			{
				"name": "candle",
				"salience": 0.0011270066,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "part",
				"salience": 0.0011243842,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0010723319,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0010723319,
				"type": "OTHER"
			},
			{
				"name": "percentage",
				"salience": 0.0010712807,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0010444591,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0010313009,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001025628,
				"type": "LOCATION"
			},
			{
				"name": "claim",
				"salience": 0.0009847016,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.0009803041,
				"type": "LOCATION"
			},
			{
				"name": "bars",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "shortcomings",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "world opinion",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "repercussion",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "suspects",
				"salience": 0.00096795365,
				"type": "PERSON"
			},
			{
				"name": "statements",
				"salience": 0.0009571432,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.00095160096,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02bzjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_Riders"
				},
				"name": "Freedom Rider",
				"salience": 0.00095065765,
				"type": "PERSON"
			},
			{
				"name": "cause",
				"salience": 0.0009366618,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.00092008745,
				"type": "PERSON"
			},
			{
				"name": "starvation",
				"salience": 0.00087912433,
				"type": "OTHER"
			},
			{
				"name": "newspapers",
				"salience": 0.00087912433,
				"type": "ORGANIZATION"
			},
			{
				"name": "cause",
				"salience": 0.0008463116,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00083506474,
				"type": "OTHER"
			},
			{
				"name": "modus operandi",
				"salience": 0.000814154,
				"type": "OTHER"
			},
			{
				"name": "modus operandi",
				"salience": 0.000814154,
				"type": "OTHER"
			},
			{
				"name": "regime change victim",
				"salience": 0.0007937665,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0007937665,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0007937665,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.0007937665,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.00079022127,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.0007670808,
				"type": "EVENT"
			},
			{
				"name": "rest",
				"salience": 0.0007641381,
				"type": "OTHER"
			},
			{
				"name": "ploy",
				"salience": 0.0007323294,
				"type": "OTHER"
			},
			{
				"name": "monarchy",
				"salience": 0.0007323294,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00072114007,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.00072114007,
				"type": "ORGANIZATION"
			},
			{
				"name": "effort",
				"salience": 0.00071769464,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.00071769464,
				"type": "OTHER"
			},
			{
				"name": "Newspapers",
				"salience": 0.00071769464,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lie",
				"salience": 0.0007049931,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.00068733795,
				"type": "ORGANIZATION"
			},
			{
				"name": "assistance",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "abuses",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.00068733795,
				"type": "ORGANIZATION"
			},
			{
				"name": "necessity",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "complex",
				"salience": 0.00068733795,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0006857381,
				"type": "PERSON"
			},
			{
				"name": "war party",
				"salience": 0.0006857381,
				"type": "ORGANIZATION"
			},
			{
				"name": "dangers",
				"salience": 0.0006701247,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00066168036,
				"type": "EVENT"
			},
			{
				"name": "mood",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "ruse",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "doing",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "conflagration",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "blame",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "mushroom clouds",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "suffering",
				"salience": 0.00066168036,
				"type": "EVENT"
			},
			{
				"name": "public",
				"salience": 0.00066168036,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.0006480039,
				"type": "LOCATION"
			},
			{
				"name": "rest",
				"salience": 0.0006480039,
				"type": "OTHER"
			},
			{
				"name": "foil",
				"salience": 0.0006480039,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "heads",
				"salience": 0.00063983817,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.0006289533,
				"type": "EVENT"
			},
			{
				"name": "evil",
				"salience": 0.000623814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haiti",
				"salience": 0.00060339645,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.00060339645,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0005803351,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.0005781085,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.0005682733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0005650049,
				"type": "ORGANIZATION"
			},
			{
				"name": "destruction",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.0005611119,
				"type": "ORGANIZATION"
			},
			{
				"name": "misdeeds",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "enmity",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "entertainment",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "evilism argument",
				"salience": 0.0005611119,
				"type": "EVENT"
			},
			{
				"name": "dislocation",
				"salience": 0.0005540407,
				"type": "OTHER"
			},
			{
				"name": "starvation",
				"salience": 0.000536125,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0005289988,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0004840596,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.0004840596,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.0004840596,
				"type": "OTHER"
			},
			{
				"name": "foil",
				"salience": 0.0004840596,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "opportunity",
				"salience": 0.0004840596,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00047629102,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00046011503,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00045091854,
				"type": "LOCATION"
			},
			{
				"name": "canards",
				"salience": 0.00042449503,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0004213203,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.000419145,
				"type": "EVENT"
			},
			{
				"name": "desire",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "magnitude",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00041076718,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0004086464,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0004034961,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00039044715,
				"type": "OTHER"
			},
			{
				"name": "villain",
				"salience": 0.00039044715,
				"type": "PERSON"
			},
			{
				"name": "BAR",
				"salience": 0.00039044715,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.00038391218,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00037305822,
				"type": "PERSON"
			},
			{
				"name": "premise",
				"salience": 0.00035996758,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0003570257,
				"type": "OTHER"
			},
			{
				"name": "overtures",
				"salience": 0.00034652752,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.00034533817,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00034533817,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al Nusra",
				"salience": 0.00034533817,
				"type": "ORGANIZATION"
			},
			{
				"name": "prospect",
				"salience": 0.0003252331,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.00031570625,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.0003073651,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "Peace",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "e-Mail",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "mandate",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00030524694,
				"type": "LOCATION"
			},
			{
				"name": "show",
				"salience": 0.00030524694,
				"type": "WORK_OF_ART"
			},
			{
				"name": "world stage",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "propaganda effort",
				"salience": 0.00029537472,
				"type": "OTHER"
			},
			{
				"name": "newspapers",
				"salience": 0.00029165173,
				"type": "WORK_OF_ART"
			},
			{
				"name": "role",
				"salience": 0.00029165173,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00029165173,
				"type": "OTHER"
			},
			{
				"name": "Margaret.Kimberley",
				"salience": 0.00027751143,
				"type": "LOCATION"
			},
			{
				"name": "bloodshed",
				"salience": 0.00027702938,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.000263324,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.00026214749,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00025795476,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.00025795476,
				"type": "ORGANIZATION"
			},
			{
				"name": "borders",
				"salience": 0.00022800655,
				"type": "LOCATION"
			},
			{
				"name": "catastrophe",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "provocation",
				"salience": 0.00022800655,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.00022800655,
				"type": "PERSON"
			},
			{
				"name": "perfection",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00022800655,
				"type": "ORGANIZATION"
			},
			{
				"name": "slaughter",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "television",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "journalism",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00020431992,
				"type": "PERSON"
			},
			{
				"name": "BlackAgendaReport.com",
				"salience": 0.00018785286,
				"type": "OTHER"
			},
			{
				"name": "Ajamu Baraka",
				"salience": 0.00018785286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.00018785286,
				"type": "LOCATION"
			},
			{
				"name": "http://freedomrider.blogspot.com",
				"salience": 0.00018785286,
				"type": "OTHER"
			},
			{
				"name": "Jill Stein",
				"salience": 0.00018785286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.00014031536,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/045vz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Russian_sentiment"
				},
				"name": "anti-Russian",
				"salience": 0.00014031536,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00013214535,
				"type": "PERSON"
			},
			{
				"name": "guy",
				"salience": 0.00012721075,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:24:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 19.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget b y BAR editor and senior columnist Margaret Kimberley \nThe world’s most reactionary regime, the head-chopping, terror-sponsoring Saudi Arabian kleptocracy, was awarded the chair of the UN Human Rights Council, while Russia has been kicked out. The travesty was engineered by the Superpower of Lies to punish Moscow for resisting the U.S.-led war of sectarian massacre and regime change in Syria. The War Party is on the march, to the cheers of corporate media – and Hillary hasn’t even been elected yet. Freedom Rider : Russophobia: War Party Propaganda b y BAR editor and senior columnist Margaret Kimberley \n“ All attempts to stop the fighting were rejected by the U.S. and NATO and sealed the fate of the Syrian people.” \nDid Russia invade Iraq and kill one million people? Does Russia have a greater percentage of its population behind bars than any other country in the world? Did Russia occupy Haiti after kidnapping its president? Are Russian police allowed to shoot children to death without fear of repercussion? Is Russia entering its 20 th year of a terror war against the people of Somalia? All of these crimes take place in or at the direction of the United States. Yet the full force of propaganda and influence on world opinion is directed against Russia, which whatever its shortcomings cannot hold a candle to America in violating human rights. \nThe dangers presented by a Hillary Clinton presidency cannot be overstated. She and the war party have been steadily working towards a goal that defies logic and risks all life on earth. Regime change is once again their modus operandi and they hope to make it a reality against Russia. \nNearly every claim of Russian evil doing is a lie, a ruse meant to put Americans in a fighting mood and lose their fear of nuclear conflagration. It isn’t clear if Clinton and the rest of the would-be warriors actually realize they are risking mushroom clouds. Perhaps they believe that Vladimir Putin will be easily pushed around when all evidence points to the contrary. \n“ Regime change is once again their modus operandi and they hope to make it a reality against Russia.” \nThe unproven allegations of interference in the presidential election and casting blame on Russia as the sole cause of suffering in Syria are meant to desensitize the public. It is an age old ploy which makes war not just acceptable but deemed a necessity. The usual suspects are helping out eagerly. The corporate media, led by newspapers like the New York Times and Washington Post , are front and center in pushing tales of Russian villainy. Human Rights Watch and other organizations who care nothing about abuses committed by the United States and its allies are also playing their usual role of choosing the next regime change victim. \nRussia lost its seat on the United Nations Human Rights Council in part because of American pressure and public relations assistance from the human rights industrial complex. The UNHRC is now chaired by Saudi Arabia. Saudi Arabia is an absolute monarchy that funds the jihadist terrorist groups who caused 500,000 Syrian deaths. The Saudis are causing dislocation, death and starvation in Yemen, too, but they are American allies, so there is little opposition to their misdeeds. \nThe openly bigoted Donald Trump has been the perfect foil for Hillary Clinton. That is why she and the rest of the Democratic Party leadership preferred him as their rival. He made the case for the discredited lesser evilism argument and his sensible statements about avoiding enmity with Russia made him even more useful. \n“ Newspapers like the New York Times and Washington Post, are front and center in pushing tales of Russian villainy.” \nThe United States and its allies are the cause of Syria’s destruction. Their effort to overthrow president Assad created a humanitarian disaster complete with ISIS and al Nusra fighters who love to chop off heads for entertainment. Far from being the cause of the catastrophe Russia left its ally to fight alone for four years. They even made overtures to negotiate Assad’s fate with the United States. All attempts to stop the fighting were rejected by the U.S. and NATO and sealed the fate of the Syrian people. The people of east Aleppo are being shelled by American allies but one wouldn’t know that by reading what passes for journalism in newspapers and on television. The American role in the slaughter is barely mentioned or is excused as an effort to protect the civilian population. The bloodshed was made in the U.S. and could end if this government wanted it to. \nThe anti-Russian propaganda effort has worked to perfection. NATO is massing troops on Russia’s borders in a clear provocation yet Putin is labeled the bad guy. He is said to be menacing the countries that join in threatening his nation. The United States makes phony claims of Russian war crimes despite having blood on its hands. The latest Human Rights Watch canards about prosecuting Assad come straight from the White House and State Department and have nothing to do with concern for Syrians living in their fifth year of hell. \n“Donald Trump has been the perfect foil for Hillary Clinton.” \nThere is no lesser evil between Hillary Clinton and Donald Trump. She is fully supported by the war party in her desire for a more “muscular” foreign policy. That bizarre term means death and starvation for millions more people if Clinton wins in a landslide. She must be denied a victory of that magnitude and any opportunity to claim a mandate. Peace loving people must give their votes to the Green Party ticket of Jill Stein and Ajamu Baraka. They are alone in rejecting the premise of an imperialist country and its endless wars. \nThe United States is the most dangerous country in the world. If it has a reckless and war loving president the threat becomes existential. That is the prospect we face with a Hillary Clinton presidency. If the role of villain is cast on the world stage she is the star of the show. Margaret Kimberley's Freedom Rider column appears weekly in BAR, and is widely reprinted elsewhere. She maintains a frequently updated blog as well as at http://freedomrider.blogspot.com. Ms. Kimberley lives in New York City, and can be reached via e-Mail at Margaret.Kimberley(at)BlackAgendaReport.com.",
		"thread_title": "Freedom Rider: Russophobia: War Party Propaganda",
		"title": "Freedom Rider: Russophobia: War Party Propaganda",
		"type": "bs",
		"uuid": "cdd49d5039a3b4785fd5a4f5cc84ec0052f74728"
	},
	"-KhIkQ0U-vlxm4wDoUuk": {
		"author": "Dr. Marsha Coleman-Adebayo",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:41:49.420+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Margaret Flowers",
				"salience": 0.59239966,
				"type": "PERSON"
			},
			{
				"name": "Dr.",
				"salience": 0.029221779,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.025049869,
				"type": "LOCATION"
			},
			{
				"name": "candidates",
				"salience": 0.02261706,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.018119149,
				"type": "ORGANIZATION"
			},
			{
				"name": "Marsha Adebayo",
				"salience": 0.017515818,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.017021641,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.010510092,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.010319007,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.009749334,
				"type": "ORGANIZATION"
			},
			{
				"name": "university stage",
				"salience": 0.009390298,
				"type": "LOCATION"
			},
			{
				"name": "message",
				"salience": 0.0076461355,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025kb5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Van_Hollen"
				},
				"name": "Chris Van Hollen",
				"salience": 0.007482504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_ql9fw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kathy_Szeliga"
				},
				"name": "Kathy Szeliga",
				"salience": 0.006751287,
				"type": "PERSON"
			},
			{
				"name": "editor",
				"salience": 0.0066410806,
				"type": "PERSON"
			},
			{
				"name": "columnist",
				"salience": 0.0066410806,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0057539768,
				"type": "EVENT"
			},
			{
				"name": "vulgarity",
				"salience": 0.0057539768,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01nz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bar_(establishment)"
				},
				"name": "BAR",
				"salience": 0.005387106,
				"type": "ORGANIZATION"
			},
			{
				"name": "duopoly parties",
				"salience": 0.005204971,
				"type": "ORGANIZATION"
			},
			{
				"name": "Debate",
				"salience": 0.0048892763,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0046720337,
				"type": "OTHER"
			},
			{
				"name": "test",
				"salience": 0.0043570884,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.004343947,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/094jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltimore"
				},
				"name": "Baltimore",
				"salience": 0.0040943255,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.003748874,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0037080476,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0036105888,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0035504473,
				"type": "PERSON"
			},
			{
				"name": "veneer",
				"salience": 0.0035357112,
				"type": "OTHER"
			},
			{
				"name": "University of Baltimore College of Public Affairs",
				"salience": 0.003453333,
				"type": "LOCATION"
			},
			{
				"name": "columnist",
				"salience": 0.003398206,
				"type": "PERSON"
			},
			{
				"name": "integrity",
				"salience": 0.003398206,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.003398206,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.003398206,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.0032284432,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maryland"
				},
				"name": "Maryland",
				"salience": 0.0029547997,
				"type": "LOCATION"
			},
			{
				"name": "cops",
				"salience": 0.0029433437,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05st_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jill_Stein"
				},
				"name": "Jill Stein",
				"salience": 0.0024898716,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.0023372595,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0021463586,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026mj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Delaware"
				},
				"name": "Del",
				"salience": 0.0020430416,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.0019654674,
				"type": "OTHER"
			},
			{
				"name": "Margaret Flowers Challenges",
				"salience": 0.0018127284,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0018041151,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06lfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rosa_Parks"
				},
				"name": "Rosa Parks",
				"salience": 0.0017686437,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0017463752,
				"type": "ORGANIZATION"
			},
			{
				"name": "police murder",
				"salience": 0.0016096722,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.0015587496,
				"type": "PERSON"
			},
			{
				"name": "duopoly",
				"salience": 0.0015507087,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0015123716,
				"type": "ORGANIZATION"
			},
			{
				"name": "debates",
				"salience": 0.0014500845,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0014002181,
				"type": "OTHER"
			},
			{
				"name": "disinfectant power",
				"salience": 0.0014002181,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0014002181,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0013959857,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0013907246,
				"type": "OTHER"
			},
			{
				"name": "campaign season",
				"salience": 0.0012125563,
				"type": "EVENT"
			},
			{
				"name": "No one",
				"salience": 0.0012125563,
				"type": "PERSON"
			},
			{
				"name": "sunlight",
				"salience": 0.0012125563,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.0012125563,
				"type": "OTHER"
			},
			{
				"name": "rulers",
				"salience": 0.0012125563,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0012125563,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.0012125563,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0012125563,
				"type": "LOCATION"
			},
			{
				"name": "candidates",
				"salience": 0.0011354412,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.0011354412,
				"type": "LOCATION"
			},
			{
				"name": "stage",
				"salience": 0.0011354412,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0011354412,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0011354412,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0011331392,
				"type": "OTHER"
			},
			{
				"name": "duopoly",
				"salience": 0.001087431,
				"type": "OTHER"
			},
			{
				"name": "university",
				"salience": 0.0010870881,
				"type": "ORGANIZATION"
			},
			{
				"name": "police murders",
				"salience": 0.0010866717,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black",
				"salience": 0.0010796398,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.0010468515,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0010468515,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.0010414493,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0010130128,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c9ph5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flower"
				},
				"name": "Flowers",
				"salience": 0.0009886774,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "course",
				"salience": 0.0009818675,
				"type": "OTHER"
			},
			{
				"name": "magic number",
				"salience": 0.0009818675,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0009818675,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.00096097036,
				"type": "PERSON"
			},
			{
				"name": "audience",
				"salience": 0.00096097036,
				"type": "PERSON"
			},
			{
				"name": "audience",
				"salience": 0.00096097036,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0009572845,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.00089447177,
				"type": "OTHER"
			},
			{
				"name": "Debate",
				"salience": 0.00088448205,
				"type": "OTHER"
			},
			{
				"name": "audience members",
				"salience": 0.00087207544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.00086198363,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0008502396,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0008502396,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.00084826094,
				"type": "PERSON"
			},
			{
				"name": "dissent",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "youth",
				"salience": 0.000818506,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "drone warfare",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "corporation",
				"salience": 0.0008132051,
				"type": "ORGANIZATION"
			},
			{
				"name": "public",
				"salience": 0.0008015906,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0008015906,
				"type": "EVENT"
			},
			{
				"name": "attention",
				"salience": 0.0008015906,
				"type": "OTHER"
			},
			{
				"name": "Congressman",
				"salience": 0.0008015906,
				"type": "PERSON"
			},
			{
				"name": "poll numbers",
				"salience": 0.00079149107,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00076590216,
				"type": "OTHER"
			},
			{
				"name": "Ajamu Baraka",
				"salience": 0.0007464184,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0007302327,
				"type": "OTHER"
			},
			{
				"name": "differences",
				"salience": 0.0006941181,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0006941181,
				"type": "OTHER"
			},
			{
				"name": "Shouts",
				"salience": 0.0006941181,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.0006941181,
				"type": "OTHER"
			},
			{
				"name": "Margaret Flowers.",
				"salience": 0.0006875395,
				"type": "PERSON"
			},
			{
				"name": "Delegate Szeliga",
				"salience": 0.00066656934,
				"type": "PERSON"
			},
			{
				"name": "Szeliga",
				"salience": 0.00066656934,
				"type": "LOCATION"
			},
			{
				"name": "lawsuit",
				"salience": 0.0006514749,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.00059613737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.0005818122,
				"type": "LOCATION"
			},
			{
				"name": "response",
				"salience": 0.00054549845,
				"type": "OTHER"
			},
			{
				"name": "debate hall",
				"salience": 0.00051851664,
				"type": "LOCATION"
			},
			{
				"name": "sidewalk",
				"salience": 0.00051851664,
				"type": "LOCATION"
			},
			{
				"name": "church",
				"salience": 0.00051851664,
				"type": "LOCATION"
			},
			{
				"name": "analysis",
				"salience": 0.00051851664,
				"type": "OTHER"
			},
			{
				"name": "conscience",
				"salience": 0.00051851664,
				"type": "OTHER"
			},
			{
				"name": "evils",
				"salience": 0.00051851664,
				"type": "PERSON"
			},
			{
				"name": "lesser",
				"salience": 0.00051851664,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.00051851664,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0005173097,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0005081536,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0005037954,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06n3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_America"
				},
				"name": "South America",
				"salience": 0.0005037954,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0m2rv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flint,_Michigan"
				},
				"name": "Flint",
				"salience": 0.0005037954,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.00049799756,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00049286895,
				"type": "PERSON"
			},
			{
				"name": "Campaign Information",
				"salience": 0.0004866577,
				"type": "OTHER"
			},
			{
				"name": "whistle",
				"salience": 0.00048301832,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00048122095,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0004805247,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.00046150852,
				"type": "OTHER"
			},
			{
				"name": "sister",
				"salience": 0.0004509993,
				"type": "PERSON"
			},
			{
				"name": "rights",
				"salience": 0.0004361101,
				"type": "OTHER"
			},
			{
				"name": "Retaliation",
				"salience": 0.0004361101,
				"type": "OTHER"
			},
			{
				"name": "FEAR",
				"salience": 0.0004361101,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00041668862,
				"type": "OTHER"
			},
			{
				"name": "Accountability",
				"salience": 0.00037762552,
				"type": "OTHER"
			},
			{
				"name": "Transparency",
				"salience": 0.00037762552,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.00037762552,
				"type": "PERSON"
			},
			{
				"name": "passage",
				"salience": 0.00037762552,
				"type": "EVENT"
			},
			{
				"name": "introduction",
				"salience": 0.00037762552,
				"type": "EVENT"
			},
			{
				"name": "whistleblower law",
				"salience": 0.00037762552,
				"type": "OTHER"
			},
			{
				"name": "vanadium mine workers",
				"salience": 0.00037762552,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.00036080784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g0lh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Environmental_Protection_Agency"
				},
				"name": "EPA",
				"salience": 0.0003534594,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00032576526,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.00032576526,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00032576526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hilary Clinton",
				"salience": 0.0003191232,
				"type": "PERSON"
			},
			{
				"name": "Whistleblowers Triumph over Corruption",
				"salience": 0.00029727267,
				"type": "PERSON"
			},
			{
				"name": "podium",
				"salience": 0.0002967563,
				"type": "OTHER"
			},
			{
				"name": "ambitions",
				"salience": 0.00028207543,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.00028207543,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00028207543,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00028207543,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qwngq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/No-FEAR_Act"
				},
				"name": "No FEAR Act",
				"salience": 0.00026839957,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protest",
				"salience": 0.00026592935,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South African",
				"salience": 0.00023240199,
				"type": "LOCATION"
			},
			{
				"name": "Notification of Federal Employees Anti-discrimination and Retaliation Act of 2002",
				"salience": 0.00023240199,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/061jp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pulitzer_Prize"
				},
				"name": "Pulitzer Prize",
				"salience": 0.00023240199,
				"type": "OTHER"
			},
			{
				"name": "http://www.flowersforsenate.org",
				"salience": 0.00023240199,
				"type": "OTHER"
			},
			{
				"name": "Green Shadow Cabinet",
				"salience": 0.00023240199,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/040514z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Advisory_board"
				},
				"name": "Advisory Board",
				"salience": 0.00023240199,
				"type": "ORGANIZATION"
			},
			{
				"name": "ExposeFacts.com",
				"salience": 0.00023240199,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.00014770863,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:19:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "2016 elections by BAR editor and columnist, Dr. Marsha Adebayo \nThe “revolving, rigged system” that purports to be American democracy was revealed in all its corporate vulgarity on a Baltimore university stage, last week. Two U.S. Senate candidates of the duopoly parties pretended to support the Green Party’s candidate’s right to join the debate, but failed to protest when cops hauled her away. “This was their ‘Rosa Parks’ moment when they could have stood for integrity and democracy” -- but failed the test. Green Party’s Margaret Flowers Challenges US Senate Debate in Maryland as Undemocratic by BAR editor and columnist, Dr. Marsha Adebayo \n“ The corporate media and the political duopoly collaborated to ensure that the Green Party message would not be heard.” \nUS corruption during this campaign season is on full display for the entire world to ponder. No one paying even scant attention can deny the thin veneer that is used to hide state sponsored police murder of Africans, structural poverty and the cozy relationship between the 1% rulers in the Democratic and Republican parties. Green Party candidates, such as Jill Stein, Ajamu Baraka and Margaret Flowers have forced sunlight’s disinfectant power to expose a rigged, racist and revolting political system that politically and economically devours communities of color, condones police murders of Black youth, intentionally exposes communities, like Flint, Michigan, to poisoned water, promotes drone warfare and the pilfering of the natural resources of Africa and South America. \nThe system, however is finding it more difficult to block out the voices of dissent. Such was the situation this week at the University of Baltimore College of Public Affairs where Dr. Margaret Flowers, the Green Party candidate for the Maryland US Senate seat, was refused the opportunity to participate in the only televised debate alongside Democratic Congressman Chris Van Hollen and Republican state Del. Kathy Szeliga. The corporate media and the political duopoly collaborated to ensure that the Green Party message would not be heard. The sham excuse used to exclude Flowers was that her poll numbers had not reached 15%. But, of course it is difficult to reach the magic number of 15% in the polls when one is systematically excluded from debates and public events. This is the revolving rigged system that Black people know so well. \n“When the police came to escort her off the stage neither candidate provided a meaningful protest of the anti-democratic process unfolding.” \nWhen the rigged debate started, audience members called for Dr. Flowers to join Van Hollen and Szeliga. Shouts of “let her speak” could be heard from the audience. Responding to the audience, Dr. Flowers took her place on the stage shaking hands with both candidates. Standing on the stage, she turned her attention to the audience and said: \n“I think it’s important for voters to understand the differences between myself and Congressman Van Hollen and Delegate Szeliga.” With the police moving on stage to remove her, she said, …”I mean, you say you’re a public university and you want to educate the public, but without having a full public discussion, that doesn't actually happen.” \nWhile Van Hollen and Szeliga seemed to agree with Dr. Flowers participating in the debate, when the police came to escort her off the stage neither candidate provided a meaningful protest of the anti-democratic process unfolding. Delegate Szeliga noted that a third podium was available but both politicians remained silent while Dr. Flowers was forced to leave the stage. This was their “Rosa Parks” moment when they could have stood for integrity and democracy but Van Hollen and Szeliga, failed to show the smallest amount of courage, leadership and commitment to anything greater than their individual ambitions and desire for power. \nMargaret was escorted by police to a sidewalk outside the debate hall and that symbolically represents the state of US democracy. \nAfter church on Sunday, a sister said to me, “I know a lot of Black folks are going to vote for Hilary Clinton but I can’t vote for the lesser of two evils. I’ve decided to vote for Jill Stein. I’m going to vote my conscience!” My only response after agreeing with her analysis was to add, “Don’t forget to also vote for Margaret Flowers.“ \nDr. Margaret Flowers of Green Party Interrupts Maryland Senate Televised Debate: \nhttps://www.youtube.com/watch?v=Ix98YXLWUJg \nMargaret Flowers Campaign Information: http://www.flowersforsenate.org Dr. Marsha Adebayo is the author of the Pulitzer Prize nominated: No FEAR: A Whistleblowers Triumph over Corruption and Retaliation at the EPA . She worked at the EPA for 18 years and blew the whistle on a US multinational corporation that endangered South African vanadium mine workers. Marsha's successful lawsuit led to the introduction and passage of the first civil rights and whistleblower law of the 21st century: the Notification of Federal Employees Anti-discrimination and Retaliation Act of 2002 (No FEAR Act). She is Director of Transparency and Accountability for the Green Shadow Cabinet and serves on the Advisory Board of ExposeFacts.com.",
		"thread_title": "Green Party’s Margaret Flowers Challenges US Senate Debate in Maryland as Undemocratic",
		"title": "Green Party’s Margaret Flowers Challenges US Senate Debate in Maryland as Undemocratic",
		"type": "bs",
		"uuid": "097bdb7d2dc0c90a201113535b485ea33e031eb5"
	},
	"-KhIkQs97CzmWIvUkxjl": {
		"author": "Danny Haiphong",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:41:49.857+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.48041993,
				"type": "LOCATION"
			},
			{
				"name": "Eric Draitser",
				"salience": 0.17716226,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.10538593,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.032134652,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.01525663,
				"type": "LOCATION"
			},
			{
				"name": "Break the Silence",
				"salience": 0.012354454,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.008639939,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0068631386,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0055595925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.004622785,
				"type": "LOCATION"
			},
			{
				"name": "character",
				"salience": 0.0042681224,
				"type": "PERSON"
			},
			{
				"name": "misinformation campaigns",
				"salience": 0.0033552228,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.0033552228,
				"type": "OTHER"
			},
			{
				"name": "leftists",
				"salience": 0.003185411,
				"type": "PERSON"
			},
			{
				"name": "confusion",
				"salience": 0.003120872,
				"type": "OTHER"
			},
			{
				"name": "leftists",
				"salience": 0.0028998307,
				"type": "PERSON"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.0023444777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0022342533,
				"type": "LOCATION"
			},
			{
				"name": "regrets",
				"salience": 0.002127311,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0020391662,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0019800323,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0017009793,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0017009793,
				"type": "EVENT"
			},
			{
				"name": "Center for International Justice and Accountability",
				"salience": 0.0016992731,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0016059917,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.001463098,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.001463098,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.0013303187,
				"type": "OTHER"
			},
			{
				"name": "Imperialism",
				"salience": 0.0013303187,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.0013303187,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0012738253,
				"type": "EVENT"
			},
			{
				"name": "confusion",
				"salience": 0.001253785,
				"type": "OTHER"
			},
			{
				"name": "confusion",
				"salience": 0.001253785,
				"type": "OTHER"
			},
			{
				"name": "Danny Haiphong",
				"salience": 0.0012140987,
				"type": "ORGANIZATION"
			},
			{
				"name": "Danny Haiphong Syria",
				"salience": 0.0011757333,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.0011756856,
				"type": "OTHER"
			},
			{
				"name": "self-determination",
				"salience": 0.001068044,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.001068044,
				"type": "LOCATION"
			},
			{
				"name": "Obvious",
				"salience": 0.0009862024,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00094785524,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.00094785524,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.00094785524,
				"type": "OTHER"
			},
			{
				"name": "Answer",
				"salience": 0.0009205902,
				"type": "OTHER"
			},
			{
				"name": "Answer",
				"salience": 0.0009205902,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0008756969,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.000842438,
				"type": "OTHER"
			},
			{
				"name": "Danny Haiphong",
				"salience": 0.0008196971,
				"type": "PERSON"
			},
			{
				"name": "self-determination",
				"salience": 0.0007996822,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "plunder",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "imperialism wages wars",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "media lackeys",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "dedication",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00079070695,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar Al-Assad",
				"salience": 0.000745872,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00070069486,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00070069486,
				"type": "EVENT"
			},
			{
				"name": "left",
				"salience": 0.0006942358,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0006847265,
				"type": "PERSON"
			},
			{
				"name": "oppression",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0006847265,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0006365806,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0006026022,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0006026022,
				"type": "OTHER"
			},
			{
				"name": "conclusions",
				"salience": 0.00059198093,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0005897724,
				"type": "ORGANIZATION"
			},
			{
				"name": "imperialists",
				"salience": 0.00054786366,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.0005303004,
				"type": "OTHER"
			},
			{
				"name": "confusion",
				"salience": 0.0005163171,
				"type": "OTHER"
			},
			{
				"name": "confusion",
				"salience": 0.0005163171,
				"type": "OTHER"
			},
			{
				"name": "confusion",
				"salience": 0.0005163171,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00050131977,
				"type": "LOCATION"
			},
			{
				"name": "NGO",
				"salience": 0.0004977252,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00049131707,
				"type": "EVENT"
			},
			{
				"name": "terror groups",
				"salience": 0.0004808131,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0004808131,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0004808131,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.000473111,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00047297898,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.00046714992,
				"type": "EVENT"
			},
			{
				"name": "confrontation",
				"salience": 0.0004606348,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.00043977026,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00042747392,
				"type": "LOCATION"
			},
			{
				"name": "Tue",
				"salience": 0.00042148877,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00041634784,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00041634784,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00041579382,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004135235,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0004135235,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.00041196874,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.00040674955,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0004063306,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.00040288895,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.0004010986,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0004010986,
				"type": "EVENT"
			},
			{
				"name": "governments",
				"salience": 0.00039550915,
				"type": "ORGANIZATION"
			},
			{
				"name": "uprising",
				"salience": 0.0003952295,
				"type": "EVENT"
			},
			{
				"name": "Draister",
				"salience": 0.0003906508,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.00039024925,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00039024925,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.0003841331,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0003826925,
				"type": "ORGANIZATION"
			},
			{
				"name": "examination",
				"salience": 0.00036052207,
				"type": "EVENT"
			},
			{
				"name": "uprising",
				"salience": 0.00035710042,
				"type": "EVENT"
			},
			{
				"name": "NGOs",
				"salience": 0.00035184744,
				"type": "ORGANIZATION"
			},
			{
				"name": "criticism",
				"salience": 0.00034682138,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00034623905,
				"type": "EVENT"
			},
			{
				"name": "terror groups",
				"salience": 0.00033711272,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.00033711272,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00033560686,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00033163474,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "media lackeys",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00032452797,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00032452797,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00032195082,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00032195082,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00031226705,
				"type": "LOCATION"
			},
			{
				"name": "regime change",
				"salience": 0.00030833183,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00029962452,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029962452,
				"type": "EVENT"
			},
			{
				"name": "channels",
				"salience": 0.00029682112,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00029552742,
				"type": "EVENT"
			},
			{
				"name": "sources",
				"salience": 0.00029190746,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00029190746,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00029190746,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00028312704,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "Nowhere",
				"salience": 0.00028186225,
				"type": "LOCATION"
			},
			{
				"name": "range",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "revolutionaries",
				"salience": 0.00028186225,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0002810097,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0002810097,
				"type": "OTHER"
			},
			{
				"name": "reforms",
				"salience": 0.000277099,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00027520081,
				"type": "LOCATION"
			},
			{
				"name": "reforms",
				"salience": 0.0002736068,
				"type": "OTHER"
			},
			{
				"name": "struggles",
				"salience": 0.0002736068,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024_zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CounterPunch"
				},
				"name": "CounterPunch",
				"salience": 0.0002706736,
				"type": "ORGANIZATION"
			},
			{
				"name": "example",
				"salience": 0.00026931014,
				"type": "OTHER"
			},
			{
				"name": "reforms",
				"salience": 0.00026339205,
				"type": "OTHER"
			},
			{
				"name": "reforms",
				"salience": 0.00026339205,
				"type": "OTHER"
			},
			{
				"name": "uprisings",
				"salience": 0.00026339205,
				"type": "EVENT"
			},
			{
				"name": "uprisings",
				"salience": 0.00026339205,
				"type": "EVENT"
			},
			{
				"name": "rebels",
				"salience": 0.00026339205,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.00026339205,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.00026168575,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00026168575,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026095047,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026095047,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026095047,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026095047,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.0002595171,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00025791727,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00025766177,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00025766177,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.00025276217,
				"type": "ORGANIZATION"
			},
			{
				"name": "character",
				"salience": 0.00025276217,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.00025276217,
				"type": "ORGANIZATION"
			},
			{
				"name": "empire",
				"salience": 0.00025276217,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.00025170404,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0002451589,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.0002433254,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00024230676,
				"type": "LOCATION"
			},
			{
				"name": "peoples",
				"salience": 0.0002404946,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0002404946,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00023967552,
				"type": "PERSON"
			},
			{
				"name": "terror",
				"salience": 0.0002382953,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00023797815,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.0002360059,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.00023424778,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.00023424778,
				"type": "OTHER"
			},
			{
				"name": "activist",
				"salience": 0.00023256078,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0002282141,
				"type": "WORK_OF_ART"
			},
			{
				"name": "servants",
				"salience": 0.0002282141,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0002282141,
				"type": "PERSON"
			},
			{
				"name": "funds",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "discontent",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "East to West Aleppo",
				"salience": 0.00022490468,
				"type": "OTHER"
			},
			{
				"name": "Imperialism",
				"salience": 0.00021985368,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.00021969358,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00021969358,
				"type": "WORK_OF_ART"
			},
			{
				"name": "destruction",
				"salience": 0.00021969358,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00021969358,
				"type": "LOCATION"
			},
			{
				"name": "discontent",
				"salience": 0.00021969358,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00021820939,
				"type": "EVENT"
			},
			{
				"name": "world war",
				"salience": 0.00021820939,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00021820939,
				"type": "EVENT"
			},
			{
				"name": "supremacy",
				"salience": 0.00020882554,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.00020633773,
				"type": "ORGANIZATION"
			},
			{
				"name": "justice",
				"salience": 0.00020633773,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00020633773,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00020633773,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.00020607287,
				"type": "ORGANIZATION"
			},
			{
				"name": "military medicine",
				"salience": 0.00020556984,
				"type": "OTHER"
			},
			{
				"name": "White Helmets",
				"salience": 0.00020485854,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.00020471543,
				"type": "LOCATION"
			},
			{
				"name": "imperialism",
				"salience": 0.00019863967,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00019789457,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.0001976082,
				"type": "EVENT"
			},
			{
				"name": "regime change operation",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "socialism",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "Healthcare",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0001976082,
				"type": "PERSON"
			},
			{
				"name": "neo-liberalism",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "staffers",
				"salience": 0.0001976082,
				"type": "PERSON"
			},
			{
				"name": "lawyers",
				"salience": 0.0001976082,
				"type": "PERSON"
			},
			{
				"name": "consortium",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.00019599323,
				"type": "EVENT"
			},
			{
				"name": "someone",
				"salience": 0.00019265835,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00019207555,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0001902301,
				"type": "LOCATION"
			},
			{
				"name": "midst",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0001902301,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.0001902301,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.0001902301,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "degrees",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "monarchies",
				"salience": 0.0001902301,
				"type": "PERSON"
			},
			{
				"name": "ideology",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.00018801686,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00018801686,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00018764636,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.00018629736,
				"type": "OTHER"
			},
			{
				"name": "sarin gas attack",
				"salience": 0.00018629736,
				"type": "EVENT"
			},
			{
				"name": "words",
				"salience": 0.00018629736,
				"type": "OTHER"
			},
			{
				"name": "funders",
				"salience": 0.00018629736,
				"type": "PERSON"
			},
			{
				"name": "partners",
				"salience": 0.00018629736,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.00018629736,
				"type": "ORGANIZATION"
			},
			{
				"name": "argument",
				"salience": 0.00018629736,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.00018629736,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "New York Post",
				"salience": 0.00018496181,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.00017965354,
				"type": "ORGANIZATION"
			},
			{
				"name": "pro-Assad",
				"salience": 0.00017347046,
				"type": "PERSON"
			},
			{
				"name": "wonder",
				"salience": 0.00017187394,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0001697076,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.0001683206,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0001668393,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00016299551,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00016299551,
				"type": "EVENT"
			},
			{
				"name": "claim",
				"salience": 0.00016203581,
				"type": "OTHER"
			},
			{
				"name": "proxies",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "mouths",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "origins",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00016131185,
				"type": "EVENT"
			},
			{
				"name": "aid",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "withholding",
				"salience": 0.00016131185,
				"type": "EVENT"
			},
			{
				"name": "corridors",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "promotion",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "White Helmet",
				"salience": 0.00015555891,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0001541272,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0001541272,
				"type": "ORGANIZATION"
			},
			{
				"name": "Positions",
				"salience": 0.0001541272,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0001541272,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00014357353,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGO",
				"salience": 0.00014044956,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.00014030361,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.00013925419,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "rescue",
				"salience": 0.0001391569,
				"type": "EVENT"
			},
			{
				"name": "dedication",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "material conditions",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "rescue",
				"salience": 0.0001391569,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "assumption",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "assumption",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00013717881,
				"type": "ORGANIZATION"
			},
			{
				"name": "self-determination",
				"salience": 0.00013692325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.00013631942,
				"type": "PERSON"
			},
			{
				"name": "framework",
				"salience": 0.0001316813,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00013060504,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.00013060504,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.00012962814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.00012161209,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00012161209,
				"type": "ORGANIZATION"
			},
			{
				"name": "Eva Bartlett",
				"salience": 0.00012161209,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.00012161209,
				"type": "PERSON"
			},
			{
				"name": "struggle",
				"salience": 0.00012149985,
				"type": "OTHER"
			},
			{
				"name": "analyst",
				"salience": 0.00012149985,
				"type": "PERSON"
			},
			{
				"name": "struggle",
				"salience": 0.00012149985,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00012149985,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "hit-list",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.000120492776,
				"type": "LOCATION"
			},
			{
				"name": "war machine",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.000120492776,
				"type": "EVENT"
			},
			{
				"name": "inception",
				"salience": 0.000120492776,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "military confrontation",
				"salience": 0.00012008529,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.0001195915,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0001195915,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00011707107,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Gulf",
				"salience": 0.00011707107,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.00011707107,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.00011707107,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01x38c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daraa"
				},
				"name": "Daraa",
				"salience": 0.00011707107,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.00011453144,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.00011359533,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.000112241876,
				"type": "ORGANIZATION"
			},
			{
				"name": "side",
				"salience": 0.000112241876,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00011182412,
				"type": "OTHER"
			},
			{
				"name": "exception",
				"salience": 0.000108865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000105539446,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.000102274826,
				"type": "LOCATION"
			},
			{
				"name": "scenario",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "critique",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "plunder",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "imperialism wages wars",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00010133938,
				"type": "EVENT"
			},
			{
				"name": "imperialist order",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.000100309146,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War III",
				"salience": 0.000100309146,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02q8ml2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ghouta"
				},
				"name": "Ghouta",
				"salience": 0.000099272926,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "Al Qaeda",
				"salience": 0.000099272926,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jwcs_4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houla_massacre"
				},
				"name": "Houla Massacre",
				"salience": 0.000099272926,
				"type": "EVENT"
			},
			{
				"name": "Failure",
				"salience": 0.000098800665,
				"type": "OTHER"
			},
			{
				"name": "Stephen Gowans",
				"salience": 0.00009802156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.000097653996,
				"type": "LOCATION"
			},
			{
				"name": "military assets",
				"salience": 0.000093912415,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.00009349279,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.00009349279,
				"type": "OTHER"
			},
			{
				"name": "mistakes",
				"salience": 0.00009231428,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.00009115063,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00008932841,
				"type": "OTHER"
			},
			{
				"name": "anti-imperialists",
				"salience": 0.00008774692,
				"type": "PERSON"
			},
			{
				"name": "defense",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "sovereignty",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00008774692,
				"type": "LOCATION"
			},
			{
				"name": "email",
				"salience": 0.00008774692,
				"type": "WORK_OF_ART"
			},
			{
				"name": "commitment",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "stake",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.000083838444,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.000081681006,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.00008065137,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00007631845,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "no-fly zone",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "hostage",
				"salience": 0.00007535641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.00006907322,
				"type": "ORGANIZATION"
			},
			{
				"name": "fetishists",
				"salience": 0.00006554159,
				"type": "OTHER"
			},
			{
				"name": "starvation",
				"salience": 0.00006554159,
				"type": "OTHER"
			},
			{
				"name": "siege",
				"salience": 0.00006554159,
				"type": "EVENT"
			},
			{
				"name": "journalists",
				"salience": 0.00006554159,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.00006554159,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00006554159,
				"type": "EVENT"
			},
			{
				"name": "train",
				"salience": 0.00006554159,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00006554159,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.000053998512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.000053998512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.000053998512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/087vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yugoslavia"
				},
				"name": "Yugoslavia",
				"salience": 0.000053998512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian",
				"salience": 0.000053998512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.000053998512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.000051593186,
				"type": "PERSON"
			},
			{
				"name": "no-fly zone",
				"salience": 0.000044429136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.00004033318,
				"type": "ORGANIZATION"
			},
			{
				"name": "Vanessa Beeley",
				"salience": 0.00004033318,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02hcv8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Time_Zone"
				},
				"name": "Eastern",
				"salience": 0.00004033318,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0m59j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Howard_Zinn"
				},
				"name": "Howard Zinn",
				"salience": 0.00004033318,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02z2bs2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Madaya,_Syria"
				},
				"name": "Madaya",
				"salience": 0.00004033318,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:14:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 30.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Break the Silence or Support Self-Determination? In Syria, the Answer Should be Obvious Submitted by Danny Haiphong on Tue, 11/01/2016 - 19:14 Tweet Widget by Danny Haiphong \nSyria is “the target of one of the greatest misinformation campaigns in recent history.” The author regrets that left analyst Eric Draitser has contributed to the confusion. Draitser criticizes leftists who firmly support the Syrian government. Danny Haiphong counters that “the left must act with uncompromising dedication to the principle of self-determination in every case where US and Western imperialism wages wars of neo-colonial plunder.” Break the Silence or Support Self-Determination? In Syria, the Answer Should be Obvious by Danny Haiphong \n“To claim that the left in the US should fight for ‘peace’ and at the same time oppose the Syrian government is an intentional attempt to remain neutral in a time of war.” \nImperialism's war on Syria may be the most important question on the order of the day for those fighting for a world free of exploitation and oppression. Syria is currently the battleground of imperialism's last gasp of life. In nearly six years, Syria has been turned into a site of intense struggle between the forces of resistance and imperialism's forces of reaction. It has also been the target of one of the greatest misinformation campaigns in recent history. The imperialist countries and their media lackeys have sewed deep confusion about the true character of the war being waged on Syria. Nowhere is this confusion greater than in the United States, and it appears someone I deeply respect has been overtaken by it. \nIn a recent issue of CounterPunch, Eric Draitser dives head deep into the confusion . He criticizes what he deems as two critical problems with the left's stance. Draitser first criticizes the pro-imperialist left for their decision to align themselves with the foreign-sponsored terror groups in Syria, which have been labeled \"revolutionaries\" or \"rebels\" by the imperialist countries. He then goes on to criticize leftists who have positioned themselves firmly in support of the Syrian government. \nIt is his criticism of the \"pro-Assad left\" that needs further examination. Draitser reveals his deep confusion when he asks: \n\"Will you continue to delude yourselves by refusing to accept the plainly obvious truth that no state or group has the best interests of Syrians at heart?\" \nDraitser's question assumes that the Syrian and Russian governments are equally to blame for the chaos in Syria. Their bombs are assumed to be prolonging the war and committing atrocities against the Syrian people at the same rate of the imperialists. If this is not the case, he doesn't state otherwise in the piece. In fact, Draitser sets out to prove true what has already been proven false by a wide range of independent and corporate media sources. \n“The imperialist countries and their media lackeys have sewed deep confusion about the true character of the war being waged on Syria.” \nFirst, Draitser claims that the war on Syria began as a genuine protest against \"neo-liberal\" reforms instituted by the Syrian government. This narrative is popular among the liberal-left media as well as the white left generally. However, those who make this claim rarely specify what neo-liberal reforms were made or how the confrontation all of a sudden became violent. Stephen Gowans reviews numerous reports from the corporate media that describe the uprising in March of 2011 as immediately violent, ill-supported, and ultimately insignificant in the midst of reforms from the Syrian government that were broadly supported by the Syrian people. At the same time as the violent uprisings, thousands of Syrians were protesting in the streets in support of President Assad. \nFurthermore, reports from the city of Daraa during the 2011 uprisings confirmed the presence of armed \"rebels\" who had freshly arrived from their US-NATO backed destruction of Libya . These \"rebels\" have since infested the country through various channels of the Syrian border. Each group possesses a fundamentalist Wahhabi ideology and receives varying degrees of assistance from the Gulf monarchies, Israel, Turkey, NATO, and of course, the US. This is confirmed in Draitser's article. Yet he still reinforces the claim that a popular uprising started the war even though Assad possessed broad support in 2011 . \nThe truth is that the war on Syria has little to do with neo-liberalism or popular discontent. It has been acknowledged by UN sources that despite reforms, the Syrian economy remains highly regulated and socialist in character . Syria's own form of socialism has brought many benefits to the Syrian people. Healthcare and education are rights guaranteed to all citizens . Syria also possesses a secular government where Muslims, Christians, and all religious and ethnic groups lived peacefully prior to the war. Syria is thus a poor example of neo-liberalism. What economic struggles that do exist in Syria have largely stemmed from the harsh sanctions imposed by the US in 2004. \n“The war on Syria has little to do with neo-liberalism or popular discontent.” \nFurthermore, Draitser cites numerous sources that support regime change to smear the Syrian government and, by extension, the Syrian people. One of the sources receives much of its information from the White Helmets. The White Helmets have long been exposed as an NGO that works directly in service of imperialism's regime change operation in Syria. The organization receives approximately 33 million in funds directly from the US and UK governments. Eva Bartlett recently visited Aleppo and witnessed many White Helmet workers sporting arms and fighting among the terror groups . \nDraister also cites a source from the New York Post . The Post article relies heavily on documents collected by the dubious Center for International Justice and Accountability. This purported \"international law\" NGO is run by a consortium of corporate lawyers, former or current Amnesty International staffers, and various other servants of empire. The organization specializes in \"transitional justice.\" In other words, the Center for International Justice and Accountability (CIJA) provides a legal framework for regime change on behalf of its imperial funders. Draitser claims no group involved in the war has the interests of the Syrian people at heart yet cites directly from an organization dedicated to the promotion of war in Syria. \nThe NGOs and their partners in the corporate media have worked together to distort the reality on the ground. Aleppo is case and point. A ceasefire was brokered by all parties in late October that was supposed to allow Syrians to escape safely from East to West Aleppo. However, the humanitarian corridors were repeatedly shelled by the Nusra Front , the US-backed Al Qaeda affiliate . The media decided to ignore this and report instead that the ceasefire’s failure was due to the withholding of aid by Russia and Syria . This is but one example of many where the Syrian government has been blamed for the rebel-sponsored terror inflicted on Syrian people. \n“His analysis uses an abstract, moral argument to violate Syria's self-determination.” \nAfter five years of war on Syria, it is a wonder how anyone could believe a word that comes from the mouths of the imperialist countries. They lied about the origins of the conflict. They have continuously blamed the Syrian government for events that have all been traced back to the armed proxies they support. This includes the Houla Massacre , the sarin gas attack in Ghouta, and the so-called starvation of Madaya . Aleppo is no different. The Syrian city has been under constant siege from NATO-backed terrorists. The terrorists are holding nearly 250,000 Syrians hostage in the Eastern side of war-torn Aleppo. This has been verified by journalists on the ground such as Vanessa Beeley . \nThese facts seem not to matter in Draitser's newfound assessment of Syria. His analysis uses an abstract, moral argument to violate Syria's self-determination. Calling those who unequivocally support the Syrian government \"fetishists\" assumes that the US left should take a position different from that of the Syrian people. Actual Syrians supported Bashar Al-Assad, and thus the Syrian Army, with 88.7 percent of the vote in the 2014 elections. To claim that the left in the US should fight for \"peace\" and at the same time oppose the Syrian government is an intentional attempt to remain neutral in a time of war. As Howard Zinn brilliantly stated, one cannot be neutral on a moving train. \nAnd the imperialist war against Syria is moving dangerously toward a World War III scenario. Hillary Clinton will be elected the next President of the United States and has repeatedly expressed that she will pursue a no-fly zone once in office. A no-fly zone would place Russian and Syrian military assets at risk of US-sponsored bombs and thus the world at risk of a global military confrontation not seen since World War II. How convenient it is then that Draitser should rebuke his former anti-imperialist stance in place of a stealth form of regime change. The world is on fire, yet Draitser has interpreted the situation as a chance to distort an already highly misunderstood situation . \n“Draister's conclusions ultimately reinforce the Western assumption that the left must come to the rescue and save the Syrian people from their plight.” \nPositions such as Draitser’s are ultimately shaped by the material conditions of an imperialist empire in crisis and decline. White supremacy has been a principle condition of US imperialism since its inception. The war machine and white supremacy are deeply connected. The peoples and nations on imperialism's hit-list are routinely depicted in a manner that justifies the need for US and Western military medicine. This notion has trickled down to the day-to-day actions of ordinary people, including what currently passes as the \"anti-war\" movement in the US today. \nDraister's conclusions ultimately reinforce the Western assumption that the left must come to the rescue and save the Syrian people from their plight. Indeed, the Syrian people need allies and the left must be organizing toward an end to the war. But an end to the war cannot be achieved unless the left supports the will of the Syrian people. At the moment, this means the US left must align itself with the Syrian government and its allies. The left must act with uncompromising dedication to the principle of self-determination in every case where US and Western imperialism wages wars of neo-colonial plunder. Syria should be no exception. \nOf course, this critique should not be seen as a personal attack on Draitser himself. His body of work reflects a deep commitment to the struggle against war and Empire. He has often taken positions on international questions that are deeply unpopular with the US imperialist order. However, when mistakes are made, the left has a responsibility to correct them. There is too much at stake. Failure to step up in defense of Syria means another regime, change scenario similar to what happened in Yugoslavia, Iraq, and Libya. Draitser's piece is a study into the path that all genuine anti-imperialists should avoid. \nBut what is the correct path forward? Imperialism is the unquestionable cause of the war in Syria, so imperialism must be the primary target of an anti-imperialist movement. The US and its allies are risking world war over Syria’s destruction. On the other side, the Syrian and Russian governments (along with Iran and China) are doing as much as they can to find a peaceful solution to the conflict that also respects Syria’s national sovereignty. It is without question that this is the side where the left ought to be in the continued struggle to end the war once and for all. Danny Haiphong is an Asian activist and political analyst in the Boston area. He can be reached at [email protected]",
		"thread_title": "Break the Silence or Support Self-Determination? In Syria, the Answer Should be Obvious",
		"title": "Break the Silence or Support Self-Determination? In Syria, the Answer Should be Obvious",
		"type": "bs",
		"uuid": "deacfaa02099d376e2cd3d31b2822e3058afaeea"
	},
	"-KhIkRam5a4LDarHTxL2": {
		"author": "Anonymous",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:41:51.418+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "MOVE 9",
				"salience": 0.1493058,
				"type": "ORGANIZATION"
			},
			{
				"name": "MOVE 9",
				"salience": 0.13701594,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.052016888,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.032779768,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.025665494,
				"type": "PERSON"
			},
			{
				"name": "MOVE People",
				"salience": 0.022910852,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.018491061,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.016339354,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.014147813,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.013884113,
				"type": "PERSON"
			},
			{
				"name": "Cops",
				"salience": 0.012266455,
				"type": "PERSON"
			},
			{
				"name": "parole",
				"salience": 0.011730195,
				"type": "OTHER"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.0108646685,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.010482731,
				"type": "PERSON"
			},
			{
				"name": "John Straub",
				"salience": 0.010291646,
				"type": "PERSON"
			},
			{
				"name": "atrocity",
				"salience": 0.0095742205,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.00948449,
				"type": "PERSON"
			},
			{
				"name": "cops",
				"salience": 0.009467557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0515p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mumia_Abu-Jamal"
				},
				"name": "Mumia Abu Jamal",
				"salience": 0.009197201,
				"type": "PERSON"
			},
			{
				"name": "prisons",
				"salience": 0.009080765,
				"type": "LOCATION"
			},
			{
				"name": "prison",
				"salience": 0.009080765,
				"type": "LOCATION"
			},
			{
				"name": "Police",
				"salience": 0.008975904,
				"type": "PERSON"
			},
			{
				"name": "Move 9",
				"salience": 0.008936968,
				"type": "ORGANIZATION"
			},
			{
				"name": "hundreds",
				"salience": 0.008588463,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.008200993,
				"type": "PERSON"
			},
			{
				"name": "mentality",
				"salience": 0.008170573,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.007853101,
				"type": "PERSON"
			},
			{
				"name": "mass imprisonment",
				"salience": 0.0064148577,
				"type": "EVENT"
			},
			{
				"name": "adults",
				"salience": 0.0064148577,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01y80_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Parole"
				},
				"name": "Parole",
				"salience": 0.006055008,
				"type": "OTHER"
			},
			{
				"name": "You Speak Up for Yourself",
				"salience": 0.0058330004,
				"type": "WORK_OF_ART"
			},
			{
				"name": "People",
				"salience": 0.0056743356,
				"type": "PERSON"
			},
			{
				"name": "assault",
				"salience": 0.0055559315,
				"type": "EVENT"
			},
			{
				"name": "blogspot",
				"salience": 0.0055559315,
				"type": "OTHER"
			},
			{
				"name": "MOVE members",
				"salience": 0.0055559315,
				"type": "PERSON"
			},
			{
				"name": "city block",
				"salience": 0.0055559315,
				"type": "OTHER"
			},
			{
				"name": "slaves",
				"salience": 0.0054451786,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0054169786,
				"type": "WORK_OF_ART"
			},
			{
				"name": "man",
				"salience": 0.0049253292,
				"type": "PERSON"
			},
			{
				"name": "parole",
				"salience": 0.00483733,
				"type": "OTHER"
			},
			{
				"name": "parole board",
				"salience": 0.0044661136,
				"type": "ORGANIZATION"
			},
			{
				"name": "child",
				"salience": 0.004321849,
				"type": "PERSON"
			},
			{
				"name": "parole",
				"salience": 0.0040511712,
				"type": "OTHER"
			},
			{
				"name": "cops",
				"salience": 0.004002697,
				"type": "PERSON"
			},
			{
				"name": "The District Attorney",
				"salience": 0.003803669,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0037428222,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.0034543832,
				"type": "EVENT"
			},
			{
				"name": "parole board",
				"salience": 0.0033796283,
				"type": "ORGANIZATION"
			},
			{
				"name": "death",
				"salience": 0.0033796283,
				"type": "EVENT"
			},
			{
				"name": "People",
				"salience": 0.0033567164,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0033567164,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0033007658,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0031506123,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0029863652,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0029267152,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0029267152,
				"type": "OTHER"
			},
			{
				"name": "burning flames",
				"salience": 0.0028203556,
				"type": "OTHER"
			},
			{
				"name": "MOVE house",
				"salience": 0.0027367733,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.0027367733,
				"type": "LOCATION"
			},
			{
				"name": "release",
				"salience": 0.002642645,
				"type": "EVENT"
			},
			{
				"name": "reasons",
				"salience": 0.002642645,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.002642645,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0026346561,
				"type": "LOCATION"
			},
			{
				"name": "cops",
				"salience": 0.0026346561,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.0026346561,
				"type": "LOCATION"
			},
			{
				"name": "cops",
				"salience": 0.0026346561,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.0026346561,
				"type": "LOCATION"
			},
			{
				"name": "Police",
				"salience": 0.0026346561,
				"type": "PERSON"
			},
			{
				"name": "prisons",
				"salience": 0.0025267852,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0023699435,
				"type": "EVENT"
			},
			{
				"name": "total",
				"salience": 0.0022884225,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0022884225,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0022884225,
				"type": "OTHER"
			},
			{
				"name": "fiancé",
				"salience": 0.0022884225,
				"type": "PERSON"
			},
			{
				"name": "shooting",
				"salience": 0.0022884225,
				"type": "EVENT"
			},
			{
				"name": "folks",
				"salience": 0.0022884225,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.002234361,
				"type": "LOCATION"
			},
			{
				"name": "cops",
				"salience": 0.002234361,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.002234361,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.002234361,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0021575002,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.0020677075,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0020522494,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0020522494,
				"type": "PERSON"
			},
			{
				"name": "weaponry",
				"salience": 0.0020522494,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0020522494,
				"type": "OTHER"
			},
			{
				"name": "bench warrants",
				"salience": 0.0020508163,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0020474738,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0020249793,
				"type": "PERSON"
			},
			{
				"name": "cop",
				"salience": 0.002000865,
				"type": "PERSON"
			},
			{
				"name": "bench warrants",
				"salience": 0.0019742774,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02r15x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Parole_board"
				},
				"name": "Parole Board",
				"salience": 0.0019702988,
				"type": "ORGANIZATION"
			},
			{
				"name": "adults",
				"salience": 0.0019494042,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.0019348301,
				"type": "PERSON"
			},
			{
				"name": "parole board",
				"salience": 0.0019348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "deaths",
				"salience": 0.0019348301,
				"type": "EVENT"
			},
			{
				"name": "police officer",
				"salience": 0.0019348301,
				"type": "PERSON"
			},
			{
				"name": "deaths",
				"salience": 0.0019348301,
				"type": "EVENT"
			},
			{
				"name": "official",
				"salience": 0.0019348301,
				"type": "PERSON"
			},
			{
				"name": "babies",
				"salience": 0.0018921054,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0018754771,
				"type": "LOCATION"
			},
			{
				"name": "back",
				"salience": 0.001853004,
				"type": "OTHER"
			},
			{
				"name": "smoke bombs",
				"salience": 0.001853004,
				"type": "OTHER"
			},
			{
				"name": "MOVE child",
				"salience": 0.0018486917,
				"type": "PERSON"
			},
			{
				"name": "Joan Weimer",
				"salience": 0.0018406616,
				"type": "PERSON"
			},
			{
				"name": "The MOVE 9",
				"salience": 0.0018382873,
				"type": "WORK_OF_ART"
			},
			{
				"name": "home",
				"salience": 0.0017838434,
				"type": "LOCATION"
			},
			{
				"name": "release",
				"salience": 0.0017838434,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0017838434,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.0017838434,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0017838434,
				"type": "LOCATION"
			},
			{
				"name": "murder",
				"salience": 0.0017838434,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.001779704,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0016754313,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.0016754313,
				"type": "PERSON"
			},
			{
				"name": "cops",
				"salience": 0.001669198,
				"type": "OTHER"
			},
			{
				"name": "crane",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "premises",
				"salience": 0.0016045696,
				"type": "LOCATION"
			},
			{
				"name": "inferno",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "swat gear",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "frenzy",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "teeth",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "fire fighters",
				"salience": 0.0016045696,
				"type": "PERSON"
			},
			{
				"name": "tear gas",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "housing code violation",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "deluge gun",
				"salience": 0.0016045696,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bulldozer",
				"salience": 0.0016045696,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "prison",
				"salience": 0.0016008351,
				"type": "OTHER"
			},
			{
				"name": "kidnapping",
				"salience": 0.0015446767,
				"type": "EVENT"
			},
			{
				"name": "abuse",
				"salience": 0.0015446767,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0015446767,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.0015446767,
				"type": "EVENT"
			},
			{
				"name": "bombing",
				"salience": 0.0015127514,
				"type": "EVENT"
			},
			{
				"name": "Facts",
				"salience": 0.0015127514,
				"type": "OTHER"
			},
			{
				"name": "radio",
				"salience": 0.0015127514,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.0015127514,
				"type": "PERSON"
			},
			{
				"name": "investigation hearing",
				"salience": 0.0015127514,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.001491255,
				"type": "PERSON"
			},
			{
				"name": "mentality",
				"salience": 0.0014562842,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0014453949,
				"type": "PERSON"
			},
			{
				"name": "weapons charges",
				"salience": 0.0014315111,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0014315111,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.0013956618,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0013099154,
				"type": "EVENT"
			},
			{
				"name": "force",
				"salience": 0.0013099154,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0012637262,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0012515866,
				"type": "OTHER"
			},
			{
				"name": "cop",
				"salience": 0.0012515866,
				"type": "PERSON"
			},
			{
				"name": "judge",
				"salience": 0.001159075,
				"type": "PERSON"
			},
			{
				"name": "Ona Move",
				"salience": 0.0011473941,
				"type": "OTHER"
			},
			{
				"name": "Ali Hameli",
				"salience": 0.001141812,
				"type": "PERSON"
			},
			{
				"name": "Matter",
				"salience": 0.0011300456,
				"type": "OTHER"
			},
			{
				"name": "heartache",
				"salience": 0.0011300456,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0011300456,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.0011300456,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.0011300456,
				"type": "PERSON"
			},
			{
				"name": "pain",
				"salience": 0.0011300456,
				"type": "OTHER"
			},
			{
				"name": "MOVE parent",
				"salience": 0.0011300456,
				"type": "PERSON"
			},
			{
				"name": "everybody",
				"salience": 0.0011158048,
				"type": "PERSON"
			},
			{
				"name": "HOMICIDES",
				"salience": 0.0010829992,
				"type": "ORGANIZATION"
			},
			{
				"name": "MOVE child",
				"salience": 0.0010058025,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0010058025,
				"type": "PERSON"
			},
			{
				"name": "slave owners",
				"salience": 0.0009785078,
				"type": "PERSON"
			},
			{
				"name": "ears",
				"salience": 0.0009785078,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0009785078,
				"type": "PERSON"
			},
			{
				"name": "suffering",
				"salience": 0.0009785078,
				"type": "EVENT"
			},
			{
				"name": "Things",
				"salience": 0.0009785078,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00095828046,
				"type": "EVENT"
			},
			{
				"name": "lives",
				"salience": 0.0009115144,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0009081224,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0008709208,
				"type": "LOCATION"
			},
			{
				"name": "petition",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "imprisonment",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "injustice",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.0008229887,
				"type": "EVENT"
			},
			{
				"name": "deaths",
				"salience": 0.0007863365,
				"type": "EVENT"
			},
			{
				"name": "Justice Dept",
				"salience": 0.000766327,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0007126172,
				"type": "OTHER"
			},
			{
				"name": "necessity",
				"salience": 0.0007126172,
				"type": "OTHER"
			},
			{
				"name": "guilt",
				"salience": 0.0007126172,
				"type": "OTHER"
			},
			{
				"name": "Black Men, Women, and Children",
				"salience": 0.00069548964,
				"type": "ORGANIZATION"
			},
			{
				"name": "difference",
				"salience": 0.00068601023,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00068087934,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00068087934,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.00068087934,
				"type": "PERSON"
			},
			{
				"name": "cop",
				"salience": 0.00068087934,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00068087934,
				"type": "LOCATION"
			},
			{
				"name": "killings",
				"salience": 0.00066882634,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0006670116,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00063098385,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.0006147482,
				"type": "EVENT"
			},
			{
				"name": "everybody",
				"salience": 0.0006147482,
				"type": "PERSON"
			},
			{
				"name": "injustice",
				"salience": 0.0006147482,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0006147482,
				"type": "OTHER"
			},
			{
				"name": "pain",
				"salience": 0.0006147482,
				"type": "OTHER"
			},
			{
				"name": "MOVE parent",
				"salience": 0.0006147482,
				"type": "PERSON"
			},
			{
				"name": "grand jury",
				"salience": 0.0005322991,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.0005322991,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0005322991,
				"type": "WORK_OF_ART"
			},
			{
				"name": "baby",
				"salience": 0.0005322991,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.0005322991,
				"type": "OTHER"
			},
			{
				"name": "The Petition",
				"salience": 0.0005064909,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Https://causes.com/92454-free-the-move-9",
				"salience": 0.00043855893,
				"type": "OTHER"
			},
			{
				"name": "MOVE Conference",
				"salience": 0.00043855893,
				"type": "EVENT"
			},
			{
				"name": "Claus Speth",
				"salience": 0.00032758006,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:09:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 23.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget by MOVE People \nThe Philadelphia-based MOVE family was horribly victimized by police in 1978 and 1985. The first atrocity led to the mass imprisonment of MOVE members; the second assault killed five adults and six children and burned down a city block. No cops have ever been punished, but the MOVE 9 remain in prison, and were this year once again denied parole. “They couldn't kill us that day, so they are trying to finish the job in these prisons.” “When You Speak Up for the MOVE 9, You Speak Up for Yourself” by MOVE People \nThis article previously appeared on Move 9 blogspot . \n“The District Attorney never proved MOVE had killed a police officer.” \nThe MOVE 9 Have been eligible for Parole since August 2008, After being in prison for 30 years. We have repeatedly been denied. In June of this year (2016) , we were denied parole again , for a total of ten years past the time we should have been released. One of the reasons the parole board gave to justify not releasing us is that we are a threat to the safety of the community. This is not true. People are not afraid of MOVE People. Move People ain't strangling people to death, shooting people in the back. It ain't MOVE that killed a man in front of his fiancé and four year old child. MOVE is not drive by shooting, or terrorizing folks in the community. It's the community who is faxing, emailing, and calling the parole board asking for our release on parole. \nIt is the Parole Board and D.A. John Straub who continue to deny our release for no valid reason. On August 8th 1978, hundreds of cops attacked our home at 3:00am in the morning trying to kill us. They couldn't kill us that day, so they are trying to finish the job in these prisons but understand: John Straub and the Parole Board are not justified. MOVE did not go out to the Police's house to do them harm. The Cops came to our house, because a judge sent them to our house to serve bench warrants for not appearing in court not for rape, murder, kidnapping or abuse but for not appearing in court for a civil matter. Understand this: hundreds of cops were sent to our home, while we were asleep, dressed in swat gear, armed with all type of weaponry, semi -automatic weapons, fire fighters, smoke bombs, tear gas, a deluge gun, a crane and a bulldozer to serve bench warrants, for a housing code violation. \n“Move People ain't strangling people to death, shooting people in the back.” \nIt was the Police who came to Move’s premises. They came armed to the teeth and in their frenzy to kill MOVE, they killed one of their own, and condemned us for it. We are not making this up. The evidence is clear. \nThe whole world witnessed the attack on the MOVE house May 13th 1985, where the house was bombed into a blazing inferno, the six adults were shot and killed and the five children were shot back into the house by police as they tried to escape the burning flames where they died . These are proven Facts. During the city’s investigation hearing, it was ruled that the cops used excessive force and the killings were wrongful deaths. Those children were our children in that house that day, yet not one cop or official connected to the bombing of our family were held accountable, responsible for these deaths like the parole board is telling The MOVE 9 we have to take responsibility for a crime when the District Attorney never proved MOVE had killed a police officer. \nWe have no weapons charges and the judge admitted on public radio to the caller, Mumia Abu Jamal [a radio journalist at the time], that he didn't have the faintest idea who shot the police officer. It's a fact that world renowned forensic experts Dr. Ali Hameli and Claus Speth ruled the deaths of the children HOMICIDES in a scathing report against the city, submitted to the assistant District Attorney Joan Weimer, but the grand jury did nothing. \n“It's time for everybody to start speaking freely in protest of all this free wheeling injustice.” \nThe Move 9 have spent almost 40 years in prison for killing a cop, with no real proof. The whole world saw the Philadelphia police murder our children and family, and they have not spent a day in prison for it. But, what is the difference in these lives? Does a MOVE child not bleed, when they are shot? Does a MOVE parent not feel pain when their baby is killed, just because they are not cops or officials? Does the murder of a MOVE child, the pain of MOVE parent, the heartache of a black person's suffering still fall on deaf ears like the slaves who cried out when their babies, women and men were sold, killed, and whipped by slave owners? Ask yourself. Things may seem to have changed since those awful days, but the mentality is still very much existing. \nJust look around and listen. Black lives (Don't) Matter. That's why these cops are getting away with killing Black Men, Women, and Children. That's why The MOVE 9 are still in prison almost 40 years for killing a cop, and the cops responsible for killing 11 MOVE people, five of them children, are walking around like they are clean and without guilt. It's the mentality that makes them feel nothing after killing people. Because to them MOVE lives (Don't) matter. It's time for everybody to start speaking freely in protest of all this free wheeling injustice. People must understand this necessity of speaking out now. \nWe are asking for people to sign The Petition we have aimed at United States Attorney General Loretta Lynch demanding that The United States Justice Dept open up an investigation into the ongoing and wrongful imprisonment of The MOVE 9. People can sign the petition at Https://causes.com/92454-free-the-move-9 . Speak out with the understanding that when speaking of MOVE, you are speaking up for yourself. It can't get better for MOVE without getting better for you. \nLooking Forward To The May 2017 MOVE Conference In Philadelphia. \nOna Move",
		"thread_title": "“When You Speak Up for the MOVE 9, You Speak Up for Yourself”",
		"title": "“When You Speak Up for the MOVE 9, You Speak Up for Yourself”",
		"type": "bs",
		"uuid": "b0cd825ee17102f541a5003956a6d60ecaed5a39"
	},
	"-KhIkSTNeZv1n61vXFjd": {
		"author": "Anonymous",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:41:51.531+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.5997726,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.053985633,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.023550639,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barrack Obama",
				"salience": 0.014433671,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.01294602,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.012549072,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.012265948,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.011320825,
				"type": "PERSON"
			},
			{
				"name": "whims",
				"salience": 0.00932638,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.008986564,
				"type": "PERSON"
			},
			{
				"name": "nationalism",
				"salience": 0.007987731,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0077164453,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0062518436,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0057836627,
				"type": "EVENT"
			},
			{
				"name": "Lesseroftwoevilism",
				"salience": 0.0056863767,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0047848416,
				"type": "OTHER"
			},
			{
				"name": "apparatus",
				"salience": 0.004289263,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0041504093,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0039127944,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0037487634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0034722176,
				"type": "LOCATION"
			},
			{
				"name": "demon",
				"salience": 0.0033370408,
				"type": "OTHER"
			},
			{
				"name": "Matt Sedillo",
				"salience": 0.0032183046,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01p47r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scott_Baio"
				},
				"name": "Scott Baio",
				"salience": 0.0027770135,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00273728,
				"type": "PERSON"
			},
			{
				"name": "duopoly electoral system",
				"salience": 0.002468362,
				"type": "OTHER"
			},
			{
				"name": "hawks",
				"salience": 0.0022965374,
				"type": "OTHER"
			},
			{
				"name": "LesserOfTwoEvilism",
				"salience": 0.0022965374,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0022965374,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0022965374,
				"type": "ORGANIZATION"
			},
			{
				"name": "lesseroftwoevilism",
				"salience": 0.0022965374,
				"type": "OTHER"
			},
			{
				"name": "rainbow coalition",
				"salience": 0.00212179,
				"type": "ORGANIZATION"
			},
			{
				"name": "peacenik",
				"salience": 0.0020412416,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.0019159504,
				"type": "EVENT"
			},
			{
				"name": "blood",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0019159504,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "script",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "twitter feuds",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.0018458114,
				"type": "OTHER"
			},
			{
				"name": "menagerie",
				"salience": 0.0017677722,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.0016804059,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "election run",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "warmongers",
				"salience": 0.0016592466,
				"type": "PERSON"
			},
			{
				"name": "hypocrisy",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "doctrine",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.0016592466,
				"type": "EVENT"
			},
			{
				"name": "savior",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "downtrodden",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "eugenicist billionaire",
				"salience": 0.0014708136,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0013772891,
				"type": "ORGANIZATION"
			},
			{
				"name": "reflection",
				"salience": 0.0013721674,
				"type": "OTHER"
			},
			{
				"name": "war maker",
				"salience": 0.0013547164,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.0012187578,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0011465868,
				"type": "OTHER"
			},
			{
				"name": "warlords",
				"salience": 0.0011465868,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b60g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_R._Allen"
				},
				"name": "John Allen",
				"salience": 0.0011275925,
				"type": "PERSON"
			},
			{
				"name": "war criminal",
				"salience": 0.0010717912,
				"type": "PERSON"
			},
			{
				"name": "vision",
				"salience": 0.001010069,
				"type": "OTHER"
			},
			{
				"name": "Much",
				"salience": 0.0010090523,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0010090523,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0010090523,
				"type": "LOCATION"
			},
			{
				"name": "electorate",
				"salience": 0.0010090523,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.0010090523,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0009458137,
				"type": "EVENT"
			},
			{
				"name": "secretary of state",
				"salience": 0.0009281145,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0008737807,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0008737807,
				"type": "LOCATION"
			},
			{
				"name": "democracy",
				"salience": 0.00087113853,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.000847505,
				"type": "EVENT"
			},
			{
				"name": "lesseroftwoevilism",
				"salience": 0.00082268903,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00082268903,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00081705494,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0008165381,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00078894466,
				"type": "PERSON"
			},
			{
				"name": "generation",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00078894466,
				"type": "PERSON"
			},
			{
				"name": "primary",
				"salience": 0.00078894466,
				"type": "EVENT"
			},
			{
				"name": "direction",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"name": "zombie apocalypse",
				"salience": 0.00078894466,
				"type": "EVENT"
			},
			{
				"name": "future",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0007721607,
				"type": "LOCATION"
			},
			{
				"name": "call",
				"salience": 0.0007278827,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00072641287,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0007188087,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00070750905,
				"type": "LOCATION"
			},
			{
				"name": "advocates",
				"salience": 0.0006949881,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.000692448,
				"type": "LOCATION"
			},
			{
				"name": "inkling",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "decency",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "self interest",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "coronation",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "cult leader",
				"salience": 0.0006831658,
				"type": "PERSON"
			},
			{
				"name": "phrases",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0006810997,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0006736658,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00066702254,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00066702254,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0006631596,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.0006631596,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.0006631596,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.0006631596,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.00063970237,
				"type": "ORGANIZATION"
			},
			{
				"name": "assassination",
				"salience": 0.0006290143,
				"type": "EVENT"
			},
			{
				"name": "government officials",
				"salience": 0.0006290143,
				"type": "PERSON"
			},
			{
				"name": "convention",
				"salience": 0.0006204626,
				"type": "EVENT"
			},
			{
				"name": "unity",
				"salience": 0.000612644,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.000612644,
				"type": "PERSON"
			},
			{
				"name": "convention",
				"salience": 0.000612644,
				"type": "EVENT"
			},
			{
				"name": "response",
				"salience": 0.000612644,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.0005942177,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0005897742,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.0005897742,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0005897742,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0005897742,
				"type": "OTHER"
			},
			{
				"name": "horror show",
				"salience": 0.0005867297,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0005775838,
				"type": "LOCATION"
			},
			{
				"name": "ideology",
				"salience": 0.00056736125,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0005648269,
				"type": "PERSON"
			},
			{
				"name": "visions",
				"salience": 0.00056021154,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0005577091,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0005531519,
				"type": "LOCATION"
			},
			{
				"name": "proceedings",
				"salience": 0.0005531519,
				"type": "EVENT"
			},
			{
				"name": "borders",
				"salience": 0.0005531519,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.0005531519,
				"type": "PERSON"
			},
			{
				"name": "chants",
				"salience": 0.0005531519,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0005531519,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.0005531519,
				"type": "OTHER"
			},
			{
				"name": "anthem",
				"salience": 0.00055068097,
				"type": "OTHER"
			},
			{
				"name": "copy",
				"salience": 0.00055068097,
				"type": "OTHER"
			},
			{
				"name": "cold war",
				"salience": 0.00054190296,
				"type": "EVENT"
			},
			{
				"name": "theme",
				"salience": 0.00054137537,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0005325021,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0005325021,
				"type": "OTHER"
			},
			{
				"name": "lands",
				"salience": 0.0005325021,
				"type": "LOCATION"
			},
			{
				"name": "bombs",
				"salience": 0.0005325021,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.000521165,
				"type": "OTHER"
			},
			{
				"name": "War",
				"salience": 0.0005021978,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00050013326,
				"type": "PERSON"
			},
			{
				"name": "unity",
				"salience": 0.00050013326,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0004850897,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "inclusion",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "slave labor",
				"salience": 0.0004789764,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0004789764,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "mariachi garb",
				"salience": 0.0004789764,
				"type": "LOCATION"
			},
			{
				"name": "movements",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "tent",
				"salience": 0.0004789764,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "variation",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0004789764,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0004789764,
				"type": "PERSON"
			},
			{
				"name": "mood",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "basket",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "deplorables",
				"salience": 0.00046109472,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "war machine",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "mayhem",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "sleep",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00046109472,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.00046109472,
				"type": "PERSON"
			},
			{
				"name": "collateral damage",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "chant",
				"salience": 0.00045732674,
				"type": "OTHER"
			},
			{
				"name": "America America",
				"salience": 0.00045501415,
				"type": "WORK_OF_ART"
			},
			{
				"name": "flag",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"name": "globe",
				"salience": 0.00045156322,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.00045156322,
				"type": "LOCATION"
			},
			{
				"name": "faith",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.00044267616,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.0004354609,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.00043145363,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00043145363,
				"type": "EVENT"
			},
			{
				"name": "demon",
				"salience": 0.00042822692,
				"type": "OTHER"
			},
			{
				"name": "Mexico Will Pay",
				"salience": 0.0004204752,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11bw1_6lwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Make_America_Great_Again"
				},
				"name": "Make America Great Again",
				"salience": 0.0004204752,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0004204752,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00040440337,
				"type": "EVENT"
			},
			{
				"name": "will",
				"salience": 0.0003980525,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jm64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atlanta_Hawks"
				},
				"name": "Hawks",
				"salience": 0.00039292092,
				"type": "ORGANIZATION"
			},
			{
				"name": "gender orientation",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "abilities",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "uniform",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00039100656,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.00039100656,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.00039100656,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00039100656,
				"type": "ORGANIZATION"
			},
			{
				"name": "battlefield",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "capitals",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "creed",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "union",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "projection",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00039100656,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0003896844,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0003896844,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0003896844,
				"type": "EVENT"
			},
			{
				"name": "Rainbow Coalition",
				"salience": 0.000381876,
				"type": "ORGANIZATION"
			},
			{
				"name": "presidency",
				"salience": 0.00037955376,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.00037955376,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02d2xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.00037706306,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.00037548452,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "Constitution",
				"salience": 0.00034044197,
				"type": "WORK_OF_ART"
			},
			{
				"name": "words",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "war talk",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00033730885,
				"type": "EVENT"
			},
			{
				"name": "conspiracy",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00033730885,
				"type": "ORGANIZATION"
			},
			{
				"name": "conflict",
				"salience": 0.00033730885,
				"type": "EVENT"
			},
			{
				"name": "obliteration",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00033478605,
				"type": "EVENT"
			},
			{
				"name": "any",
				"salience": 0.00030112997,
				"type": "OTHER"
			},
			{
				"name": "Sebastian De La Cruz",
				"salience": 0.000294784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0198fr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khan_(title)"
				},
				"name": "Khan",
				"salience": 0.000294784,
				"type": "PERSON"
			},
			{
				"name": "si se puede",
				"salience": 0.000294784,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03lt8g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eva_Longoria"
				},
				"name": "Eva Longoria",
				"salience": 0.000294784,
				"type": "PERSON"
			},
			{
				"name": "aggression",
				"salience": 0.000292071,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.000292071,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000292071,
				"type": "PERSON"
			},
			{
				"name": "land dispute",
				"salience": 0.000292071,
				"type": "EVENT"
			},
			{
				"name": "someone",
				"salience": 0.000292071,
				"type": "PERSON"
			},
			{
				"name": "will",
				"salience": 0.0002898865,
				"type": "OTHER"
			},
			{
				"name": "Nations",
				"salience": 0.00028139495,
				"type": "LOCATION"
			},
			{
				"name": "nationalist",
				"salience": 0.00028139495,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.00028139495,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.00028139495,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0002776218,
				"type": "PERSON"
			},
			{
				"name": "alternative",
				"salience": 0.00027412258,
				"type": "OTHER"
			},
			{
				"name": "war hawk",
				"salience": 0.00027292955,
				"type": "PERSON"
			},
			{
				"name": "apocalypse",
				"salience": 0.00024564628,
				"type": "EVENT"
			},
			{
				"name": "twitter feuds",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "script",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.00024454875,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian",
				"salience": 0.00024063748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latino",
				"salience": 0.00024063748,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0kn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(country)"
				},
				"name": "Georgian",
				"salience": 0.0002367134,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukrainian",
				"salience": 0.0002367134,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00023470531,
				"type": "LOCATION"
			},
			{
				"name": "racket",
				"salience": 0.00022662716,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hawks",
				"salience": 0.00021998837,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0002126998,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0002126998,
				"type": "EVENT"
			},
			{
				"name": "desire",
				"salience": 0.0002126998,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0002126998,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0002126998,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rainbow coalition",
				"salience": 0.00020322602,
				"type": "ORGANIZATION"
			},
			{
				"name": "peoples",
				"salience": 0.00020322602,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.00018499816,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00018348609,
				"type": "LOCATION"
			},
			{
				"name": "globe",
				"salience": 0.00018348609,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.00018348609,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00018348609,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranians",
				"salience": 0.0001797446,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0001797446,
				"type": "LOCATION"
			},
			{
				"name": "Ghadaffi",
				"salience": 0.0001797446,
				"type": "PERSON"
			},
			{
				"name": "neo-Mcarthyite",
				"salience": 0.0001797446,
				"type": "LOCATION"
			},
			{
				"name": "Ossetia",
				"salience": 0.0001797446,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00016869805,
				"type": "PERSON"
			},
			{
				"name": "persons",
				"salience": 0.00015887569,
				"type": "PERSON"
			},
			{
				"name": "hope",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "might",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00015887569,
				"type": "PERSON"
			},
			{
				"name": "empire",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "apologies",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States of America",
				"salience": 0.00013538124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.00012600767,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014vk4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Condoleezza_Rice"
				},
				"name": "Condoleezza Rice",
				"salience": 0.00012600767,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0203v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colin_Powell"
				},
				"name": "Colin Powell",
				"salience": 0.00012506508,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.000105503175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_5vr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Madeleine_Albright"
				},
				"name": "Madeleine Albright",
				"salience": 0.00009777074,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T05:59:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 24.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "2016 presidential campaign by Matt Sedillo \nHillary Clinton is, no doubt, a threat to life on Earth. But the duopoly electoral system is a menagerie of warmongers. “The response to the white nationalism of Donald Trump has been the rainbow coalition of hawks.” Barack Obama has proven an awesomely prolific war maker. Bernie Sanders is no peacenik. “It is only the white nationalist orange demon -- guided only by his own whims and twitter feuds -- that is at all off script on this question.” LesserOfTwoEvilism by Matt Sedillo \n“ So long as there is a ruling class they shall rule by fire and blood.” \nThe loathsome and shameless hypocrisy of the Democratic Party and the doctrine of lesseroftwoevilism has been laid bare this political season. This same Democratic Party that unquestionably rigged the primaries against the left-leaning Bernie Sanders campaign is now selling itself to the public as the savior of the downtrodden from the threat of an uber right wing candidate. \nHillary Clinton at this point in her election run appears to be making no promises to the public other than to not to physically morph into Donald Trump during her coronation come Election Day. \nLesseroftwoevilism is a bankrupt political ideology and the means by which the Democratic Party deadens any inkling towards decency or rational self interest that may lay dormant in the American electorate. Hillary Clinton and the Democratic Party intend to use the platform of \"at least not being Donald Trump\" to install the most despised Democratic candidate in a generation into the White House. \nIt is indeed horrifying that a straight up eugenicist billionaire who brags about sexual assaulting women won the Republican primary. It is terrifying that the cult leader of a white nationalist zombie apocalypse has gotten this far through the electoral process. \n“There is no greater threat to the future of much of life on the planet than Hillary Clinton.” \nThe country is polarizing and it is terrifying to see that much of it is polarizing in the direction of Donald Trump whose campaign is defined by phrases like “Make America Great Again” quickly followed by “Mexico Will Pay.” Much of the country is also polarized in the direction of Bernie Sanders. It was the political apparatus of the Democratic Party, not the Republicans, that prevented these two competing visions from standing before the American public. \nSetting aside the fact, for a moment, that we don't live in a democracy, it must be noted that lesseroftwoevilism in American politics is an ideology by Americans for Americans. Hillary Clinton, Donald Trump, AND Bernie Sanders are all advocates of the US war machine. If any of these three warlords were to sit in the seat of power children in far off lands would still be bombed in their sleep and be reported on as collateral damage. \nHillary Clinton is the most bloodthirsty advocate for murder and mayhem in a political system that thrives upon such practices. When it comes to dropping bombs, obliterating nations or possibly igniting a nuclear winter there is no greater threat to the future of much of life on the planet than Hillary Clinton. \nRainbow Coalition of Hawks \nFar beyond a “basket of deplorables,” the 2016 Republican national convention was a ghastly horror show of the most reactionary, bigoted elements of American political culture. Less than esteemed actor Scott Baio captured the mood when he proclaimed, “so of course let’s make America great again, but let’s make America America again.” That largely captured the theme of the proceedings and most speeches were some variation upon that theme. \nThe Democrats in response sought to make their convention a big tent of peoples, ideas and movements. And indeed from the spontaneous chants of “black lives matter” to Tim Kaine leading a chant of “si se puede” to Eva Longoria reminding the audience “we didn’t cross the borders the borders crossed us” to Michelle Obama letting the thousands in attendance and the millions watching at home know that slave labor built the White House and the country, from Sebastian De La Cruz singing the national anthem in full mariachi garb to the Khan family holding a copy of the Constitution, the Democratic National Convention did present itself as a stark contrast to what the GOP was offering. \nThe theme of inclusion ran high and, indeed, current president Barack Obama made his call for strength in unity, explicitly saying “And most of all I see Americans of every party, every background, every faith who believe we are stronger together, black white, Latino, Asian, Native American, young, old, gay, straight, men, women, folks with different abilities, all pledging allegiance, under the same proud flag, to this big bold country that we love.” One flag to rule them all. \n“America the greatest and most diverse nation on Earth shall ransack the globe as it sees fit. ” \nGeneral John Allen, standing before a multi ethnic group of people continued upon this theme and made the connection between a more inclusive union and explicit projection of American might \n“Every American, in uniform or out, in the White House or at home, must be a force for unity in America, for a vision that includes all of us: every man and woman, every race, every ethnicity, every faith and creed, every gender orientation – all of us together pursuing our common values. \n“From the battlefield to the capitals of our allies, friends, and partners, the free peoples of the world look to America as the last best hope for peace and for liberty for all humanity, for we ARE the greatest country on this planet. \n“So we stand before you tonight to endorse Hillary Clinton for President of the United States of America.” \nThe message could not be clearer. Sorry Donald Trump, we are all Americans here. No apologies rest of the world, America the greatest and most diverse nation on Earth shall ransack the globe as it sees fit. \nThe response to the white nationalism of Donald Trump has been the rainbow coalition of hawks as chiefly embodied in the persons of Barrack Obama and Hillary Clinton. \nHillary Clinton: The Obliterator of Nations \nHillary Clinton is a war criminal. So is John Kerry. So is Condoleezza Rice. So are Colin Powell and Madeleine Albright. The secretary of state in an imperialist nation is the immediate manager of the projected might of the empire they represent. \nHillary Clinton is known to be a war hawk for much the same reason Donald Trump is known as a white nationalist. She is blatant and crass about it. \n“We came. We saw. He died” – Hillary Clinton on the assassination of Ghadaffi \n“In the next 10 years, during which they might foolishly consider launching an attack on Israel, we would be able to totally obliterate them” – Hillary Clinton speaking of obliteration of 75 million Iranians. \nFor much of the past few months the Clinton campaign have bemoaned a Russian conspiracy to reveal the words that Hillary Clinton actually wrote and thereby influence the American election. \nHillary Clinton’s neo-Mcarthyite cold war against her own words and general war talk on Russia should come as no surprise to anyone paying any attention. She was hawkish on Russia in their land dispute with Georgia over Ossetia, even going so far as to arm the Georgian government in 2010 less than two years after the conflict. She was warlike on the conflict in the Ukraine, promising Ukrainian government officials as recent as September of this year to stand with them against “Russian aggression.” \n“A Clinton presidency is the will of the ruling class.” \nThis is the talk of someone prepared for a nuclear apocalypse. \nIt should be mentioned, however, that Obama has also dialed up his anti Russian rhetoric, as has Tim Kaine, as has Mike Pence. It is only the white nationalist orange demon -- guided only by his own whims and twitter feuds -- that is at all off script on this question. \nUltimately a Clinton presidency is the will of the ruling class. If she wants war it is a reflection of their desire for war. If they want the bombs to fall then death will rain from the sky. So long as they hold power they shall exercise it. So long as there is a ruling class they shall rule by fire and blood, because there truly is no alternative. Because ultimately, this is about Clinton and then again it isn’t. And this is about the Democrats and then again it isn’t. This is about the US and this is about war. Hillary Clinton is a 2016 warlord. War is a racket. And so is this God damn election. Matt Sedillo can be contacted at [email protected] .",
		"thread_title": "LesserOfTwoEvilism",
		"title": "LesserOfTwoEvilism",
		"type": "bs",
		"uuid": "4ed9241bc0a2cc7aa2f2e7dff9304d201409c5ad"
	},
	"-KhIkT6C8CoBah_w8CBv": {
		"author": "Anonymous",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:41:51.614+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/052p7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montreal"
				},
				"name": "Montreal",
				"salience": 0.09461514,
				"type": "LOCATION"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.072300114,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.05737236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.048631366,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.037646245,
				"type": "LOCATION"
			},
			{
				"name": "Robyn Maynard",
				"salience": 0.03575029,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.033222433,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.03261,
				"type": "PERSON"
			},
			{
				"name": "Black Montrealers",
				"salience": 0.030591052,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.023246028,
				"type": "PERSON"
			},
			{
				"name": "rate",
				"salience": 0.017177256,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.01649514,
				"type": "OTHER"
			},
			{
				"name": "profiling",
				"salience": 0.015472037,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.014670306,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0137739275,
				"type": "WORK_OF_ART"
			},
			{
				"name": "study",
				"salience": 0.013313266,
				"type": "OTHER"
			},
			{
				"name": "enslavement",
				"salience": 0.01284571,
				"type": "OTHER"
			},
			{
				"name": "United Nations Working Group",
				"salience": 0.012092312,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09xr80",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Working_group"
				},
				"name": "Working Group",
				"salience": 0.012018127,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighbor",
				"salience": 0.011935714,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.011935714,
				"type": "OTHER"
			},
			{
				"name": "Robyn Maynard Canada",
				"salience": 0.010856049,
				"type": "ORGANIZATION"
			},
			{
				"name": "poverty rates",
				"salience": 0.009978472,
				"type": "OTHER"
			},
			{
				"name": "persons",
				"salience": 0.009693062,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.009518082,
				"type": "OTHER"
			},
			{
				"name": "Shame",
				"salience": 0.009195999,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.009195999,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00901285,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.00901285,
				"type": "PERSON"
			},
			{
				"name": "Realities",
				"salience": 0.008449667,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02czfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Canadians"
				},
				"name": "Black Canadians",
				"salience": 0.008400439,
				"type": "PERSON"
			},
			{
				"name": "Charmaine Nelson",
				"salience": 0.00812151,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03ts0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/French_people"
				},
				"name": "French",
				"salience": 0.0073592914,
				"type": "LOCATION"
			},
			{
				"name": "more",
				"salience": 0.007051681,
				"type": "OTHER"
			},
			{
				"name": "Veckqueth Stevenson",
				"salience": 0.0067641833,
				"type": "PERSON"
			},
			{
				"name": "Majiza Philip",
				"salience": 0.0059665134,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0059555816,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.005415425,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anti-blackness",
				"salience": 0.0052136355,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.0050714836,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.005052016,
				"type": "OTHER"
			},
			{
				"name": "Working group",
				"salience": 0.0048824833,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0041159424,
				"type": "ORGANIZATION"
			},
			{
				"name": "incarceration rates",
				"salience": 0.0041159424,
				"type": "OTHER"
			},
			{
				"name": "graduation rates",
				"salience": 0.0041159424,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0038555514,
				"type": "OTHER"
			},
			{
				"name": "businessmen",
				"salience": 0.0037989046,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02lcp_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montreal_Gazette"
				},
				"name": "Montreal Gazette",
				"salience": 0.0037625756,
				"type": "ORGANIZATION"
			},
			{
				"name": "realities",
				"salience": 0.003483991,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0033838092,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.0032188506,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0032188506,
				"type": "ORGANIZATION"
			},
			{
				"name": "shame",
				"salience": 0.0029065425,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0029065425,
				"type": "OTHER"
			},
			{
				"name": "over-apprehension",
				"salience": 0.0029065425,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0029065425,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.0029065425,
				"type": "OTHER"
			},
			{
				"name": "consultations",
				"salience": 0.0028935699,
				"type": "EVENT"
			},
			{
				"name": "rates",
				"salience": 0.0028868404,
				"type": "OTHER"
			},
			{
				"name": "Enslavement",
				"salience": 0.002844714,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0028154675,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0027791583,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0026505538,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.002626335,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0025606055,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0025516758,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.0025170732,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.0025170732,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.0025170732,
				"type": "ORGANIZATION"
			},
			{
				"name": "health",
				"salience": 0.0025170732,
				"type": "OTHER"
			},
			{
				"name": "child welfare agencies",
				"salience": 0.0025170732,
				"type": "ORGANIZATION"
			},
			{
				"name": "racism",
				"salience": 0.0025061283,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0024965194,
				"type": "OTHER"
			},
			{
				"name": "policing",
				"salience": 0.0023570238,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0023570238,
				"type": "ORGANIZATION"
			},
			{
				"name": "study",
				"salience": 0.002352246,
				"type": "OTHER"
			},
			{
				"name": "realities",
				"salience": 0.002352246,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0022573783,
				"type": "ORGANIZATION"
			},
			{
				"name": "institutions",
				"salience": 0.0022573783,
				"type": "ORGANIZATION"
			},
			{
				"name": "injustices",
				"salience": 0.002173154,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.002173154,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0021172767,
				"type": "OTHER"
			},
			{
				"name": "slavery",
				"salience": 0.0020382751,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0020382751,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0019949009,
				"type": "OTHER"
			},
			{
				"name": "gang activities",
				"salience": 0.0019949009,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0019783776,
				"type": "LOCATION"
			},
			{
				"name": "Policing Black Bodies",
				"salience": 0.0019576666,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0152tq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_France"
				},
				"name": "New France",
				"salience": 0.0018518392,
				"type": "LOCATION"
			},
			{
				"name": "studies",
				"salience": 0.001802513,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kst1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_diaspora"
				},
				"name": "People of African Descent",
				"salience": 0.0017894402,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0017650634,
				"type": "LOCATION"
			},
			{
				"name": "minority",
				"salience": 0.0017650634,
				"type": "PERSON"
			},
			{
				"name": "sociologists",
				"salience": 0.0017650634,
				"type": "PERSON"
			},
			{
				"name": "slave labor",
				"salience": 0.0017650634,
				"type": "PERSON"
			},
			{
				"name": "plantation crops",
				"salience": 0.0017650634,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0017650634,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.0017650634,
				"type": "LOCATION"
			},
			{
				"name": "activist groups",
				"salience": 0.0017609564,
				"type": "ORGANIZATION"
			},
			{
				"name": "rates",
				"salience": 0.0017609564,
				"type": "OTHER"
			},
			{
				"name": "UN Working Group",
				"salience": 0.0017328081,
				"type": "ORGANIZATION"
			},
			{
				"name": "prisons",
				"salience": 0.0016991943,
				"type": "LOCATION"
			},
			{
				"name": "means",
				"salience": 0.0016991943,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0016991943,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0016794348,
				"type": "OTHER"
			},
			{
				"name": "over-incarceration",
				"salience": 0.0016640831,
				"type": "OTHER"
			},
			{
				"name": "youth",
				"salience": 0.0016640831,
				"type": "PERSON"
			},
			{
				"name": "youth",
				"salience": 0.0016640831,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.0016224192,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0015900036,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0694j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quebec"
				},
				"name": "Quebec",
				"salience": 0.0015495603,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ontario"
				},
				"name": "Ontario",
				"salience": 0.0015495603,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059t8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nova_Scotia"
				},
				"name": "Nova Scotia",
				"salience": 0.0015495603,
				"type": "LOCATION"
			},
			{
				"name": "racism",
				"salience": 0.0014903521,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0014409972,
				"type": "PERSON"
			},
			{
				"name": "Much",
				"salience": 0.0014409972,
				"type": "OTHER"
			},
			{
				"name": "police officers",
				"salience": 0.0014409972,
				"type": "PERSON"
			},
			{
				"name": "degree",
				"salience": 0.0014409972,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0014049155,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "solutions",
				"salience": 0.0013872146,
				"type": "OTHER"
			},
			{
				"name": "injustices",
				"salience": 0.001376843,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.001282601,
				"type": "ORGANIZATION"
			},
			{
				"name": "homes",
				"salience": 0.0012431599,
				"type": "LOCATION"
			},
			{
				"name": "more",
				"salience": 0.0012431599,
				"type": "OTHER"
			},
			{
				"name": "child welfare",
				"salience": 0.0012431599,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.00114694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04yrmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Redpath"
				},
				"name": "John Redpath",
				"salience": 0.0010864733,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019zyp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_McGill"
				},
				"name": "James McGill",
				"salience": 0.0010864733,
				"type": "PERSON"
			},
			{
				"name": "Christopher McAll",
				"salience": 0.0010864733,
				"type": "PERSON"
			},
			{
				"name": "Léonel Bernard",
				"salience": 0.0010864733,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.0010854709,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0010854709,
				"type": "PERSON"
			},
			{
				"name": "enslavement",
				"salience": 0.0010854709,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0010820624,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0010764766,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0010764766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h7h6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toronto"
				},
				"name": "Toronto",
				"salience": 0.0010075996,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.00096535136,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00095813256,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.00095813256,
				"type": "PERSON"
			},
			{
				"name": "injustices",
				"salience": 0.0009411746,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.00090540684,
				"type": "PERSON"
			},
			{
				"name": "light",
				"salience": 0.00090540684,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/078lkz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montr%C3%A9al-Nord"
				},
				"name": "Montréal-Nord",
				"salience": 0.0008869492,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02lvdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/La_Presse_(Canadian_newspaper)"
				},
				"name": "La Presse",
				"salience": 0.0008869492,
				"type": "ORGANIZATION"
			},
			{
				"name": "St-Michel",
				"salience": 0.0008869492,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.00087878766,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0008650886,
				"type": "PERSON"
			},
			{
				"name": "deaths",
				"salience": 0.00085677806,
				"type": "EVENT"
			},
			{
				"name": "hands",
				"salience": 0.00078399444,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00078399444,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.00078399444,
				"type": "LOCATION"
			},
			{
				"name": "legacy",
				"salience": 0.00078399444,
				"type": "OTHER"
			},
			{
				"name": "writer",
				"salience": 0.00078399444,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.00078399444,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ksh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottawa"
				},
				"name": "Ottawa",
				"salience": 0.00068005465,
				"type": "LOCATION"
			},
			{
				"name": "crimes",
				"salience": 0.0006763321,
				"type": "OTHER"
			},
			{
				"name": "police abuse",
				"salience": 0.0006763321,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.0006763321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/080h2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vancouver"
				},
				"name": "Vancouver",
				"salience": 0.00066254305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09b8m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kingston,_Jamaica"
				},
				"name": "Kingston",
				"salience": 0.00066254305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.00066254305,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0006239727,
				"type": "OTHER"
			},
			{
				"name": "experiences",
				"salience": 0.00058563025,
				"type": "OTHER"
			},
			{
				"name": "arm",
				"salience": 0.00058563025,
				"type": "OTHER"
			},
			{
				"name": "Abdirahman Abdi",
				"salience": 0.00055723835,
				"type": "PERSON"
			},
			{
				"name": "Bony Jean-Pierre",
				"salience": 0.0004825047,
				"type": "PERSON"
			},
			{
				"name": "Nelson Mandela Park",
				"salience": 0.00036041084,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0003161841,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T05:53:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget by Robyn Maynard \nCanada, including its French-speaking regions, is home to much the same kind of systemic racism as its southern neighbor, according to a United Nations Working Group report. Black women’s poverty rates are “almost five times higher than that of white Canadian women.” In Montreal, “a 2008 study found that black girls are three times more likely than white girls the same age to have been arrested two times or more.” Realities Faced by Black Canadians are a National Shame by Robyn Maynard \nThis article previously appeared in the Montreal Gazette . \n“ Black Montrealers continue to experience dehumanizing treatment across institutions.” \nAfter holding consultations in Quebec, Nova Scotia and Ontario last month, the United Nations Working Group on People of African Descent issued a statement that sheds light on realities, too-often invisible to most Canadians, that should be seen as a national shame. \nThe group’s preliminary findings confirm what is already well known in Canada’s black communities: that systemic discrimination has subjected black people to racial profiling by law enforcement, soaring incarceration rates, disproportionate poverty and poor health, the over-apprehension of black children by child welfare agencies and lower graduation rates. Black women, they note, face a rate of poverty that is almost five times higher than that of white Canadian women, and are one of the fastest-growing groups in federal prisons. \nUnderlying these injustices, the UN Working Group has made clear, is systemic racism. \nThe UN is right to be concerned, and Montreal is by no means exempt from this criticism: Both its historical and contemporary realities are defined by a systemic anti-blackness that goes too frequently un-named. The enslavement of black (and indigenous) persons was not an uncommon practice in New France, and indeed was legal until 1834. The fact of slavery remains all around us: acclaimed art historian Charmaine Nelson reminds us that many present-day Montreal streets, buildings and institutions are named after white businessmen like James McGill and John Redpath who traded in plantation crops worked by slave labor. \nEnslavement may be over, but centuries later black Montrealers — the largest visible minority in the city — continue to experience dehumanizing treatment across institutions. A 2010 study by sociologists Léonel Bernard and Christopher McAll found that it was over-surveillance, and not the rates of so-called “black crime,” that accounted for up to 60 per cent of the over-incarceration of black youth in Montreal. \n“The enslavement of black (and indigenous) persons was not an uncommon practice in New France, and indeed was legal until 1834.” \nA report commissioned by the Montreal police, leaked to La Presse, found that in St-Michel and Montréal-Nord, up to 40 per cent of black youth were stopped in 2006-2007, a rate that indicates a high degree of racial profiling by police officers. Much of this heightened policing was justified to the public as curbing “gang activities,” when in reality, in 2009, only 1.6 per cent of crimes were gang related. High profile cases of police abuse of black Montrealers and alleged abuse continue to surface, including the recent case of Veckqueth Stevenson, a legally blind black man in his 50s, who has accused the police of using excessive force and unjustly arresting him, ironically, while he was at Nelson Mandela Park. \nBlack women and girls are not exempt, though we hear even less about their experiences locally; the case of Majiza Philip, a black woman who says she had her arm broken by police in 2014, is one example, however. A 2008 study found that black girls in Montreal are three times more likely than white girls the same age to have been arrested two times or more. \nBeyond the criminal justice system, numerous studies have demonstrated that black children are apprehended from their homes by child welfare at alarming rates in Montreal, and this, too, can be attributed to racism. \nThe UN Working group is not the first to point out these injustices, nor are they the only ones proposing solutions. Black Lives Matter-Toronto and other black activist groups in Toronto, Kingston, Ottawa, Vancouver and Montreal have been steadily mobilizing to address anti-black racism. Across cities, black communities have denounced, among other issues, the recent deaths of Abdirahman Abdi in Ottawa, and Bony Jean-Pierre in Montreal, both at the hands of police in 2016. \nIf Canada intends to genuinely reckon with its still-living legacy of black enslavement, the injustices brought to light by the UN — alongside those highlighted by black activists around the country — need to be both addressed and redressed. Robyn Maynard is an activist and writer living in Montreal, author of the forthcoming book Policing Black Bodies (2017).",
		"thread_title": "Realities Faced by Black Canadians are a National Shame",
		"title": "Realities Faced by Black Canadians are a National Shame",
		"type": "bs",
		"uuid": "f53ce94d9128797d06f9edf5fb0eac37dae03a52"
	},
	"-KhIkTnU3JTApswNewS-": {
		"author": "Anonymous",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:41:51.709+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Black Police Officer",
				"salience": 0.095906176,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.08630159,
				"type": "PERSON"
			},
			{
				"name": "Black South African Police Officers",
				"salience": 0.07751802,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.077396125,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.051411487,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0136_3g8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Negrophobia"
				},
				"name": "anti-Black",
				"salience": 0.03970544,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.039169583,
				"type": "PERSON"
			},
			{
				"name": "Black Power Front",
				"salience": 0.033082206,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.032712657,
				"type": "OTHER"
			},
			{
				"name": "struggles",
				"salience": 0.021537982,
				"type": "OTHER"
			},
			{
				"name": "police structures",
				"salience": 0.021059712,
				"type": "LOCATION"
			},
			{
				"name": "BPF",
				"salience": 0.020827368,
				"type": "ORGANIZATION"
			},
			{
				"name": "community",
				"salience": 0.019777596,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.015921278,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.014919605,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.013193537,
				"type": "PERSON"
			},
			{
				"name": "thing",
				"salience": 0.010847596,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.009805647,
				"type": "PERSON"
			},
			{
				"name": "police officers",
				"salience": 0.009000087,
				"type": "PERSON"
			},
			{
				"name": "platform",
				"salience": 0.007852545,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.007722755,
				"type": "PERSON"
			},
			{
				"name": "White Police Officers",
				"salience": 0.007557653,
				"type": "PERSON"
			},
			{
				"name": "regime",
				"salience": 0.0070008533,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0070008533,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.0067751897,
				"type": "ORGANIZATION"
			},
			{
				"name": "Police Officer",
				"salience": 0.0064426237,
				"type": "PERSON"
			},
			{
				"name": "Police Officer",
				"salience": 0.0064426237,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.006046104,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.005734401,
				"type": "PERSON"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.0054766336,
				"type": "OTHER"
			},
			{
				"name": "repression",
				"salience": 0.0054766336,
				"type": "OTHER"
			},
			{
				"name": "revolt",
				"salience": 0.0054766336,
				"type": "EVENT"
			},
			{
				"name": "members",
				"salience": 0.005378701,
				"type": "PERSON"
			},
			{
				"name": "Police Officer",
				"salience": 0.0049391286,
				"type": "PERSON"
			},
			{
				"name": "police violence",
				"salience": 0.0047716917,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South Africa",
				"salience": 0.0046683736,
				"type": "LOCATION"
			},
			{
				"name": "issues",
				"salience": 0.00427797,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.0036473866,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0035793064,
				"type": "WORK_OF_ART"
			},
			{
				"name": "activists",
				"salience": 0.0035768093,
				"type": "PERSON"
			},
			{
				"name": "struggles",
				"salience": 0.0032682233,
				"type": "OTHER"
			},
			{
				"name": "pattern",
				"salience": 0.0032320973,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.0032320973,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0031195355,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0030948252,
				"type": "OTHER"
			},
			{
				"name": "cops",
				"salience": 0.0027990825,
				"type": "PERSON"
			},
			{
				"name": "program",
				"salience": 0.0026772353,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.0025889245,
				"type": "OTHER"
			},
			{
				"name": "Open Letter",
				"salience": 0.0024787262,
				"type": "WORK_OF_ART"
			},
			{
				"name": "police",
				"salience": 0.0022093374,
				"type": "PERSON"
			},
			{
				"name": "work",
				"salience": 0.0021770732,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0021269077,
				"type": "PERSON"
			},
			{
				"name": "U1",
				"salience": 0.00210673,
				"type": "OTHER"
			},
			{
				"name": "Black community",
				"salience": 0.0019657668,
				"type": "OTHER"
			},
			{
				"name": "Black community",
				"salience": 0.0019657668,
				"type": "OTHER"
			},
			{
				"name": "students",
				"salience": 0.0019657668,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0018795839,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.0018167628,
				"type": "ORGANIZATION"
			},
			{
				"name": "government",
				"salience": 0.0018167628,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.0018037809,
				"type": "ORGANIZATION"
			},
			{
				"name": "police",
				"salience": 0.0018037809,
				"type": "ORGANIZATION"
			},
			{
				"name": "invaders",
				"salience": 0.001675013,
				"type": "PERSON"
			},
			{
				"name": "demands",
				"salience": 0.0015993323,
				"type": "OTHER"
			},
			{
				"name": "brutality",
				"salience": 0.0015955969,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0015940046,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0015202492,
				"type": "OTHER"
			},
			{
				"name": "members",
				"salience": 0.0014740808,
				"type": "PERSON"
			},
			{
				"name": "view",
				"salience": 0.0014740808,
				"type": "OTHER"
			},
			{
				"name": "instrument",
				"salience": 0.0014740808,
				"type": "OTHER"
			},
			{
				"name": "state violence",
				"salience": 0.0013783869,
				"type": "OTHER"
			},
			{
				"name": "police structures",
				"salience": 0.001377515,
				"type": "LOCATION"
			},
			{
				"name": "groups",
				"salience": 0.001347949,
				"type": "ORGANIZATION"
			},
			{
				"name": "protest action",
				"salience": 0.0013309659,
				"type": "OTHER"
			},
			{
				"name": "individuals",
				"salience": 0.0013309659,
				"type": "PERSON"
			},
			{
				"name": "groups",
				"salience": 0.0013309659,
				"type": "ORGANIZATION"
			},
			{
				"name": "individuals",
				"salience": 0.0013309659,
				"type": "PERSON"
			},
			{
				"name": "many",
				"salience": 0.001260731,
				"type": "PERSON"
			},
			{
				"name": "workers",
				"salience": 0.0012462976,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0012355712,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.0012018742,
				"type": "LOCATION"
			},
			{
				"name": "ways",
				"salience": 0.0011972069,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0011935864,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0011908085,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0011908085,
				"type": "PERSON"
			},
			{
				"name": "everywhere",
				"salience": 0.0011525198,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.0011525198,
				"type": "LOCATION"
			},
			{
				"name": "nature",
				"salience": 0.0011525198,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0011525198,
				"type": "LOCATION"
			},
			{
				"name": "spaces",
				"salience": 0.0011525198,
				"type": "LOCATION"
			},
			{
				"name": "dialogue",
				"salience": 0.0011525198,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.0011525198,
				"type": "ORGANIZATION"
			},
			{
				"name": "relation",
				"salience": 0.0011525198,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0011501925,
				"type": "OTHER"
			},
			{
				"name": "struggles",
				"salience": 0.0011389254,
				"type": "OTHER"
			},
			{
				"name": "Police Officers",
				"salience": 0.0011356698,
				"type": "PERSON"
			},
			{
				"name": "Police Officer",
				"salience": 0.0011356698,
				"type": "PERSON"
			},
			{
				"name": "police violence",
				"salience": 0.0011252864,
				"type": "OTHER"
			},
			{
				"name": "wanton violence",
				"salience": 0.0011252864,
				"type": "OTHER"
			},
			{
				"name": "state violence",
				"salience": 0.0011252864,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04bhng",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Azania"
				},
				"name": "Azania",
				"salience": 0.0010261429,
				"type": "LOCATION"
			},
			{
				"name": "instruments",
				"salience": 0.0009949694,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "politicians",
				"salience": 0.0009814585,
				"type": "PERSON"
			},
			{
				"name": "part",
				"salience": 0.0009744043,
				"type": "OTHER"
			},
			{
				"name": "freedom",
				"salience": 0.0009744043,
				"type": "OTHER"
			},
			{
				"name": "brutality",
				"salience": 0.0009608452,
				"type": "OTHER"
			},
			{
				"name": "responses",
				"salience": 0.0009408757,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.0009331877,
				"type": "WORK_OF_ART"
			},
			{
				"name": "others",
				"salience": 0.0009331877,
				"type": "PERSON"
			},
			{
				"name": "atrocities",
				"salience": 0.0009331877,
				"type": "EVENT"
			},
			{
				"name": "orders",
				"salience": 0.0009331877,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.0009331877,
				"type": "OTHER"
			},
			{
				"name": "freedom fighters",
				"salience": 0.0009331877,
				"type": "PERSON"
			},
			{
				"name": "brutality",
				"salience": 0.00091332075,
				"type": "OTHER"
			},
			{
				"name": "brutality",
				"salience": 0.00091332075,
				"type": "OTHER"
			},
			{
				"name": "Black Condition",
				"salience": 0.0009073282,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.0008983515,
				"type": "EVENT"
			},
			{
				"name": "freedom fighters",
				"salience": 0.0008983515,
				"type": "PERSON"
			},
			{
				"name": "heroines",
				"salience": 0.0008983515,
				"type": "PERSON"
			},
			{
				"name": "heroes",
				"salience": 0.0008983515,
				"type": "OTHER"
			},
			{
				"name": "warrior ancestors",
				"salience": 0.0008983515,
				"type": "PERSON"
			},
			{
				"name": "others",
				"salience": 0.0008983515,
				"type": "OTHER"
			},
			{
				"name": "slavery",
				"salience": 0.0008983515,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.00086727936,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00086727936,
				"type": "PERSON"
			},
			{
				"name": "expectation",
				"salience": 0.00085391686,
				"type": "OTHER"
			},
			{
				"name": "installation",
				"salience": 0.0008437452,
				"type": "EVENT"
			},
			{
				"name": "All",
				"salience": 0.0008437452,
				"type": "OTHER"
			},
			{
				"name": "supremacist regimes",
				"salience": 0.0008437452,
				"type": "ORGANIZATION"
			},
			{
				"name": "experience",
				"salience": 0.0008325303,
				"type": "OTHER"
			},
			{
				"name": "superiors",
				"salience": 0.0008080534,
				"type": "PERSON"
			},
			{
				"name": "visionaries",
				"salience": 0.0008080534,
				"type": "OTHER"
			},
			{
				"name": "student uprising",
				"salience": 0.0008080534,
				"type": "EVENT"
			},
			{
				"name": "level",
				"salience": 0.0008080534,
				"type": "OTHER"
			},
			{
				"name": "history",
				"salience": 0.0008080534,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0008080534,
				"type": "OTHER"
			},
			{
				"name": "capture",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "torture",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "agenda",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "land theft",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "colonization",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "context",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "martyrs",
				"salience": 0.00077788683,
				"type": "PERSON"
			},
			{
				"name": "quagmire",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "execution",
				"salience": 0.00077788683,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0007728478,
				"type": "EVENT"
			},
			{
				"name": "pattern",
				"salience": 0.000761807,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.000761807,
				"type": "OTHER"
			},
			{
				"name": "declaration",
				"salience": 0.000761807,
				"type": "EVENT"
			},
			{
				"name": "killing",
				"salience": 0.000761807,
				"type": "EVENT"
			},
			{
				"name": "part",
				"salience": 0.0007278819,
				"type": "OTHER"
			},
			{
				"name": "view",
				"salience": 0.00072463026,
				"type": "OTHER"
			},
			{
				"name": "increase",
				"salience": 0.000724124,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0006780477,
				"type": "PERSON"
			},
			{
				"name": "ends",
				"salience": 0.00066806655,
				"type": "OTHER"
			},
			{
				"name": "South Afrikan",
				"salience": 0.0006628765,
				"type": "LOCATION"
			},
			{
				"name": "South Afrika",
				"salience": 0.0006628765,
				"type": "LOCATION"
			},
			{
				"name": "horror",
				"salience": 0.00065964693,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00065964693,
				"type": "OTHER"
			},
			{
				"name": "assassinations",
				"salience": 0.00065964693,
				"type": "EVENT"
			},
			{
				"name": "question",
				"salience": 0.00065964693,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0006478515,
				"type": "PERSON"
			},
			{
				"name": "mind-set",
				"salience": 0.00064711383,
				"type": "OTHER"
			},
			{
				"name": "clarion call",
				"salience": 0.00063501915,
				"type": "EVENT"
			},
			{
				"name": "working conditions",
				"salience": 0.00063026993,
				"type": "OTHER"
			},
			{
				"name": "Azanian",
				"salience": 0.00061237416,
				"type": "PERSON"
			},
			{
				"name": "students",
				"salience": 0.00061219645,
				"type": "PERSON"
			},
			{
				"name": "violence",
				"salience": 0.00061219645,
				"type": "OTHER"
			},
			{
				"name": "Christopher Truter",
				"salience": 0.00057434326,
				"type": "PERSON"
			},
			{
				"name": "demands",
				"salience": 0.0005690576,
				"type": "OTHER"
			},
			{
				"name": "stress",
				"salience": 0.0005690576,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.0005599243,
				"type": "LOCATION"
			},
			{
				"name": "status",
				"salience": 0.0005599243,
				"type": "OTHER"
			},
			{
				"name": "some",
				"salience": 0.0005384901,
				"type": "OTHER"
			},
			{
				"name": "part",
				"salience": 0.00053009467,
				"type": "OTHER"
			},
			{
				"name": "plot",
				"salience": 0.0005282584,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.000520711,
				"type": "OTHER"
			},
			{
				"name": "supremacist regimes",
				"salience": 0.0005080227,
				"type": "ORGANIZATION"
			},
			{
				"name": "work",
				"salience": 0.0005064859,
				"type": "OTHER"
			},
			{
				"name": "Mangaliso Sobukwe",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"name": "Muntu Myeza",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"name": "Nkosi Molala",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06hz6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Robben_Island"
				},
				"name": "Robben Island",
				"salience": 0.0004973168,
				"type": "LOCATION"
			},
			{
				"name": "Onkgopotse Tiro",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"name": "Pandelani Nefolovhodwe",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/070dl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Steve_Biko"
				},
				"name": "Steve Biko",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0100bd07",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Solomon_Mahlangu"
				},
				"name": "Solomon Mahlangu",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"name": "Zolile Petersen",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"name": "Lekoane Mothopeng",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"name": "Kgalabi Masemola",
				"salience": 0.0004973168,
				"type": "PERSON"
			},
			{
				"name": "university",
				"salience": 0.0004927399,
				"type": "ORGANIZATION"
			},
			{
				"name": "education",
				"salience": 0.0004927399,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0004927399,
				"type": "OTHER"
			},
			{
				"name": "majority",
				"salience": 0.0004927399,
				"type": "OTHER"
			},
			{
				"name": "wages",
				"salience": 0.0004927399,
				"type": "OTHER"
			},
			{
				"name": "reasons",
				"salience": 0.0004927399,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c1hxg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vuyisile_Mini"
				},
				"name": "Vuyisile Mini",
				"salience": 0.00047874832,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/093j89",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Langa,_Cape_Town"
				},
				"name": "Langa",
				"salience": 0.00047874832,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01_9jw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Sharpeville_massacre"
				},
				"name": "Sharpeville",
				"salience": 0.00047874832,
				"type": "LOCATION"
			},
			{
				"name": "uKumkani uHintsa",
				"salience": 0.00047874832,
				"type": "OTHER"
			},
			{
				"name": "uKumkani uStuurman",
				"salience": 0.00047874832,
				"type": "PERSON"
			},
			{
				"name": "Kgosi Galeshewe",
				"salience": 0.00047874832,
				"type": "PERSON"
			},
			{
				"name": "Kgosi Toto",
				"salience": 0.00047874832,
				"type": "PERSON"
			},
			{
				"name": "community",
				"salience": 0.0004572931,
				"type": "OTHER"
			},
			{
				"name": "state violence",
				"salience": 0.0004572931,
				"type": "OTHER"
			},
			{
				"name": "violence",
				"salience": 0.0004572931,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00041441963,
				"type": "EVENT"
			},
			{
				"name": "stress",
				"salience": 0.00041441963,
				"type": "OTHER"
			},
			{
				"name": "frustrations",
				"salience": 0.00041441963,
				"type": "OTHER"
			},
			{
				"name": "slaves",
				"salience": 0.00041441963,
				"type": "PERSON"
			},
			{
				"name": "land",
				"salience": 0.00041441963,
				"type": "LOCATION"
			},
			{
				"name": "ancestors",
				"salience": 0.00041441963,
				"type": "PERSON"
			},
			{
				"name": "frustrations",
				"salience": 0.00041441963,
				"type": "OTHER"
			},
			{
				"name": "Nqobile Nzuza",
				"salience": 0.0004059696,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0l8qdyt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Marikana_killings"
				},
				"name": "Marikana",
				"salience": 0.0004059696,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0glt37w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Andries_Tatane"
				},
				"name": "Andries Tatane",
				"salience": 0.0004059696,
				"type": "PERSON"
			},
			{
				"name": "Mike Tshele",
				"salience": 0.0004059696,
				"type": "PERSON"
			},
			{
				"name": "Lerato Seema",
				"salience": 0.0004059696,
				"type": "PERSON"
			},
			{
				"name": "Osiah Rahube",
				"salience": 0.0004059696,
				"type": "PERSON"
			},
			{
				"name": "Mgcineni ``Mambush'' Noki",
				"salience": 0.0004059696,
				"type": "PERSON"
			},
			{
				"name": "Jan Rivombo",
				"salience": 0.0004059696,
				"type": "PERSON"
			},
			{
				"name": "forms",
				"salience": 0.00039716327,
				"type": "OTHER"
			},
			{
				"name": "Black Policer Officers",
				"salience": 0.00038024152,
				"type": "PERSON"
			},
			{
				"name": "conduct",
				"salience": 0.00036530453,
				"type": "OTHER"
			},
			{
				"name": "law and order",
				"salience": 0.00035883748,
				"type": "OTHER"
			},
			{
				"name": "pretext",
				"salience": 0.00035883748,
				"type": "OTHER"
			},
			{
				"name": "labor unions",
				"salience": 0.00035883748,
				"type": "ORGANIZATION"
			},
			{
				"name": "management",
				"salience": 0.00035883748,
				"type": "OTHER"
			},
			{
				"name": "appeal",
				"salience": 0.00035883748,
				"type": "OTHER"
			},
			{
				"name": "enemy",
				"salience": 0.0003498484,
				"type": "PERSON"
			},
			{
				"name": "focus",
				"salience": 0.0003454386,
				"type": "OTHER"
			},
			{
				"name": "letter",
				"salience": 0.0003428548,
				"type": "WORK_OF_ART"
			},
			{
				"name": "type",
				"salience": 0.0003428548,
				"type": "OTHER"
			},
			{
				"name": "Black Brothers and Sisters",
				"salience": 0.0003328859,
				"type": "ORGANIZATION"
			},
			{
				"name": "FreeDecolonisedAfrocentricEducationNow",
				"salience": 0.00032623133,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00030955256,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00030955256,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.00030955256,
				"type": "OTHER"
			},
			{
				"name": "use",
				"salience": 0.00030955256,
				"type": "OTHER"
			},
			{
				"name": "killing",
				"salience": 0.00030955256,
				"type": "EVENT"
			},
			{
				"name": "dedication",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "aspirations",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "suppression",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "state function",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "examples",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "attitude",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "involvement",
				"salience": 0.00026803353,
				"type": "OTHER"
			},
			{
				"name": "Black Sisters and Brothers",
				"salience": 0.0002550374,
				"type": "ORGANIZATION"
			},
			{
				"name": "concerns",
				"salience": 0.00025477237,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04k77f",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_African_Police_Service"
				},
				"name": "SAPS",
				"salience": 0.00022082953,
				"type": "ORGANIZATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T05:48:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 13.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget by Black Power Front \nWith students joining workers in revolt against South Africa’s neoliberal regime, young people are demanding to know why Black police are engaged in the same kind of repression that was previously used by white governments “to systematically counter Black resistance?” In a letter to Black cops, activists note “an increase and worrying pattern of anti-Black police violence.” An Open Letter to Black South African Police Officers by Black Power Front \n“As a Black Police Officer, you must understand that the struggles of Black workers and students are actually your struggles too.” \nDear Black Police Officer, \nHow are you today? Well, we hope. You may be wondering who we are, why we have decided to write to you and perhaps why we are addressing you as a “Black Police Officer” -- as opposed to just saying “Police Officer.” \nWho are we? We are the Black Power Front or BPF. We are a non-party political pro-Black platform which seeks to serve as an instrument to organize and collaborate with like-minded Black individuals and organizations, under a common program that provides practical responses to what is commonly understood as the Black Condition today. \nWhy have we decided to write to you? First, given the nature of your work, it is not always easy to sit down with you and just talk about issues that affect our country and, in particular, the Black community. \nSecond, like other members of the Black community, we in the BPF are deeply disturbed by the continued brutality of the police against Black workers and students -- particularly those who engage in legitimate protest action. And third, the BPF holds the view that, given where Black people find themselves economically, socially and otherwise today in relation to other racial groups, it is extremely urgent that like-minded Black groups and individuals (everywhere in the world) come together in exclusive spaces, and engage in constructive dialogue, with the view to find ways of getting Black people out of the quagmire they currently find themselves in. \nThe anti-Black role of the police before 1994 \nAs members of the Black community, you would know that, in the Azanian (South Afrikan) context, from the 1400s onwards, various forms of colonial police structures were key instruments in enabling the European invaders to advance and bolster their evil agenda of slavery, colonization and land theft. It was these colonial police structures that were used to systematically counter Black resistance, through amongst others the capture, torture and in many cases beheading of our warrior ancestors such as uKumkani uHintsa, Kgosi Toto, Kgosi Galeshewe, uKumkani uStuurman and many other heroes and heroines of Black resistance. \nIn the 20 th century, it was through these European colonial police structures that successive white supremacist regimes in Azania (South Afrika) were able to murder and torture our freedom fighters and ordinary Black people. They were directly responsible for the murder of our people in Sharpeville and Langa in 1960. The execution by hanging of martyrs like Vuyisile Mini and Solomon Mahlangu, in 1964 and 1979, respectively. \nIt was the colonial European police who assassinated visionaries such as Onkgopotse Tiro and Steve Biko, in 1974 and 1977, respectively. It was them who murdered the young Zolile Petersen and Christopher Truter, during the student uprising of 1976. And it was them who ensured that many of our revered freedom fighters such as Kgalabi Masemola, Mangaliso Sobukwe, Lekoane Mothopeng, Pandelani Nefolovhodwe, Nkosi Molala, Muntu Myeza and many others, were banished to Robben Island. \nEven though it is often argued that the White Police Officers who were involved in these atrocities against Black people were acting under the orders of their superiors, the truth of the matter is that, at an individual and basic level, they knew that what they were doing to Black people was wrong, inhumane and unjustified. \nThe anti-Black role of the police after 1994 \nGiven this painful history of centuries of systematic and state violence against Black people, the declaration of “freedom” on April 27, 1994, created a legitimate expectation on the part of many Black people that the type of wanton violence and naked brutality that the successive colonial white supremacist regimes unleashed on Black people would be a thing of the past. But to our horror, even after the declaration of “freedom” in 1994 and the installation of a government that is led by Black people we began to see an increase and worrying pattern of anti-Black police violence. \nThis type of anti-Black police [U1] brutality was palpable in the killing of Andries Tatane, young Nqobile Nzuza, Mike Tshele, Lerato Seema, Osiah Rahube, Jan Rivombo and of course the brutal and targeted assassinations of Mgcineni “Mambush” Noki and other Black workers in Marikana, in August 2012. \nAll of these anti-Black atrocities beg the question: how it is possible that a government that is led by people who, as part of the Black community, have first-hand experience of the brutality of state violence through the police, do not just unleash the same type of state violence against their own people, but also seek to justify the use of such anti-Black violence? \nOur attitude towards Black police officers \nBy highlighting the involvement of Black Policer Officers (after 1994) in the killing of ordinary Black people who are simply fighting for their right to be human the BPF does not seek to create the mind-set that Black Police Officers are the enemy of the Black community or that Black Police Officers are inherently bad people. Of course, there are many examples of Black Police Officers who don’t just do their job with integrity and dedication, but also do a lot of good work in the Black community. \nThis notwithstanding, the main focus of this letter, however, is not so much the individual conduct of Black Police Officers but rather the continued use of Black Police Officers (as a state function) in the brutal suppression of the right of ordinary and mainly poor Black people to freely articulate their social, economic and political concerns and aspirations. \nOur appeal to Black police officers \nAs the BPF, we regard Black Police Officers as members of the Black community first and therefore an integral part of Black life in Azania. We also hold the view that the on-going demands by Black workers for decent wages and better working conditions or those of Black students for free-decolonized-Afrocentric education, are not just demands that will benefit individual Black Police Officers (majority of them Black young people), but also their children who might be at university or will be going there in future. Therefore, as a Black Police Officer, you must understand that the struggles of Black workers and students are actually your struggles too. \nAs the BPF we fully understand that, just like all ordinary Black people, Black Police Officers are under severe financial stress and like most Black people, they are struggling to make ends meet. For these reasons, the BPF’s clarion call to all Black Police Officers is as follows: \n* Understand that the economic struggles and frustrations of ordinary Black people are your struggles and frustrations too. And that Black workers and students continue to be oppressed by the same system that is responsible for your personal financial stress; \n* As part of the Black community, you must (through your labor unions), engage the management of the SAPS to stop the state’s campaign of apartheid-style violence that is currently being unleashed on Black people in general; \n* You are our Black Brothers and Sisters and must never allow yourselves to be used by self-serving politicians as part of an elitist anti-Black-pro-capitalist plot that uses the pretext of “law and order” to justify the murder of poor Black people and wanting that Black people timidly accept their status as economic slaves in the land of their ancestors; and \n* Lastly, Black students and workers are not fighting against you (as Black police officers) but against the anti-Black-pro-capitalist system that is using some of you against your own Black Sisters and Brothers. \n#FreeDecolonisedAfrocentricEducationNow!",
		"thread_title": "An Open Letter to Black South African Police Officers",
		"title": "An Open Letter to Black South African Police Officers",
		"type": "bs",
		"uuid": "58005b805a05df3eaf3d1f4f5ee8007c0df49542"
	},
	"-KhIkUGYUwxhA83lXAH_": {
		"author": "Glen Ford",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:47:48.315+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.23446791,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.05636538,
				"type": "LOCATION"
			},
			{
				"name": "empire",
				"salience": 0.052735545,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.034389086,
				"type": "PERSON"
			},
			{
				"name": "empire",
				"salience": 0.031820007,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02_01w",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Glenn_Ford"
				},
				"name": "Glen Ford",
				"salience": 0.027830932,
				"type": "PERSON"
			},
			{
				"name": "ruling class",
				"salience": 0.026923202,
				"type": "OTHER"
			},
			{
				"name": "Lords of Capital Sic Crazy Hillary",
				"salience": 0.022206906,
				"type": "OTHER"
			},
			{
				"name": "dominance",
				"salience": 0.021217935,
				"type": "OTHER"
			},
			{
				"name": "stocks",
				"salience": 0.021137133,
				"type": "OTHER"
			},
			{
				"name": "weight",
				"salience": 0.021137133,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.016502548,
				"type": "LOCATION"
			},
			{
				"name": "commentary",
				"salience": 0.016394654,
				"type": "WORK_OF_ART"
			},
			{
				"name": "crisis",
				"salience": 0.01466591,
				"type": "EVENT"
			},
			{
				"name": "reason",
				"salience": 0.014207019,
				"type": "OTHER"
			},
			{
				"name": "powers",
				"salience": 0.014207019,
				"type": "OTHER"
			},
			{
				"name": "War",
				"salience": 0.0129491985,
				"type": "EVENT"
			},
			{
				"name": "future",
				"salience": 0.011966747,
				"type": "OTHER"
			},
			{
				"name": "Widget A Black Agenda Radio",
				"salience": 0.011195873,
				"type": "ORGANIZATION"
			},
			{
				"name": "dollar",
				"salience": 0.010808885,
				"type": "OTHER"
			},
			{
				"name": "circles",
				"salience": 0.009732958,
				"type": "OTHER"
			},
			{
				"name": "card",
				"salience": 0.008942003,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07q3j97"
				},
				"name": "South",
				"salience": 0.008772645,
				"type": "LOCATION"
			},
			{
				"name": "creatures",
				"salience": 0.008553513,
				"type": "OTHER"
			},
			{
				"name": "derivatives",
				"salience": 0.008394098,
				"type": "OTHER"
			},
			{
				"name": "bonds",
				"salience": 0.008394098,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07r8l2_"
				},
				"name": "East",
				"salience": 0.007922922,
				"type": "LOCATION"
			},
			{
				"name": "dealer",
				"salience": 0.0077459468,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.0068116165,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russia",
				"salience": 0.006596639,
				"type": "LOCATION"
			},
			{
				"name": "The Lords of Capital",
				"salience": 0.0064270506,
				"type": "WORK_OF_ART"
			},
			{
				"name": "cards",
				"salience": 0.005679997,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.005342962,
				"type": "OTHER"
			},
			{
				"name": "capitalism",
				"salience": 0.0051086266,
				"type": "OTHER"
			},
			{
				"name": "terms",
				"salience": 0.0043536676,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.0041474197,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0041474197,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09937",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Wall_Street"
				},
				"name": "Wall Street",
				"salience": 0.0040503107,
				"type": "OTHER"
			},
			{
				"name": "rulers",
				"salience": 0.003880749,
				"type": "PERSON"
			},
			{
				"name": "trade",
				"salience": 0.0036926134,
				"type": "OTHER"
			},
			{
				"name": "trend",
				"salience": 0.0035041568,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0034624538,
				"type": "OTHER"
			},
			{
				"name": "commentary",
				"salience": 0.0034600375,
				"type": "WORK_OF_ART"
			},
			{
				"name": "business",
				"salience": 0.0034600375,
				"type": "OTHER"
			},
			{
				"name": "measurement",
				"salience": 0.0034600375,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03k6x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/House_of_Lords"
				},
				"name": "Lords",
				"salience": 0.0033174893,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.003308401,
				"type": "LOCATION"
			},
			{
				"name": "rulers",
				"salience": 0.003267751,
				"type": "PERSON"
			},
			{
				"name": "clock",
				"salience": 0.0031859756,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.003126481,
				"type": "OTHER"
			},
			{
				"name": "dollar",
				"salience": 0.003126481,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.0031031189,
				"type": "OTHER"
			},
			{
				"name": "society",
				"salience": 0.002996416,
				"type": "OTHER"
			},
			{
				"name": "headquarters",
				"salience": 0.002996416,
				"type": "LOCATION"
			},
			{
				"name": "tools",
				"salience": 0.002996416,
				"type": "OTHER"
			},
			{
				"name": "aspects",
				"salience": 0.002996416,
				"type": "OTHER"
			},
			{
				"name": "severity",
				"salience": 0.002996416,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syria",
				"salience": 0.002895873,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.002805893,
				"type": "LOCATION"
			},
			{
				"name": "dominance",
				"salience": 0.0028002055,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.002695735,
				"type": "PERSON"
			},
			{
				"name": "future",
				"salience": 0.0026872745,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0026760327,
				"type": "OTHER"
			},
			{
				"name": "derivatives",
				"salience": 0.002426452,
				"type": "OTHER"
			},
			{
				"name": "measures",
				"salience": 0.002426452,
				"type": "OTHER"
			},
			{
				"name": "bonds",
				"salience": 0.002426452,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0rh6k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Washington,_D.C."
				},
				"name": "Washington",
				"salience": 0.002377011,
				"type": "LOCATION"
			},
			{
				"name": "World A Black Agenda Radio",
				"salience": 0.0023592443,
				"type": "ORGANIZATION"
			},
			{
				"name": "influence",
				"salience": 0.0023359135,
				"type": "OTHER"
			},
			{
				"name": "imperialists",
				"salience": 0.0023359135,
				"type": "PERSON"
			},
			{
				"name": "terror",
				"salience": 0.0023359135,
				"type": "OTHER"
			},
			{
				"name": "analysts",
				"salience": 0.0021319028,
				"type": "PERSON"
			},
			{
				"name": "way",
				"salience": 0.002101216,
				"type": "OTHER"
			},
			{
				"name": "inflection point",
				"salience": 0.002101216,
				"type": "OTHER"
			},
			{
				"name": "world economy",
				"salience": 0.002101216,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.002101216,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.002096327,
				"type": "LOCATION"
			},
			{
				"name": "indicators",
				"salience": 0.002048611,
				"type": "OTHER"
			},
			{
				"name": "military force",
				"salience": 0.002022804,
				"type": "ORGANIZATION"
			},
			{
				"name": "borders",
				"salience": 0.002022804,
				"type": "LOCATION"
			},
			{
				"name": "coercion",
				"salience": 0.002022804,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.002022804,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0019810067,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0019810067,
				"type": "LOCATION"
			},
			{
				"name": "trend",
				"salience": 0.0019810067,
				"type": "OTHER"
			},
			{
				"name": "everything",
				"salience": 0.0019810067,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0019227841,
				"type": "OTHER"
			},
			{
				"name": "bets",
				"salience": 0.0018625036,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0017741928,
				"type": "EVENT"
			},
			{
				"name": "dominance",
				"salience": 0.0017741928,
				"type": "OTHER"
			},
			{
				"name": "prognosis",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "hope",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "existence",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "profit",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "abundance",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "equals",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "human",
				"salience": 0.0017154393,
				"type": "PERSON"
			},
			{
				"name": "natural resources",
				"salience": 0.0017154393,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0015665782,
				"type": "EVENT"
			},
			{
				"name": "casinos",
				"salience": 0.0015013707,
				"type": "LOCATION"
			},
			{
				"name": "terrorists",
				"salience": 0.0014799269,
				"type": "PERSON"
			},
			{
				"name": "subversion",
				"salience": 0.0014799269,
				"type": "OTHER"
			},
			{
				"name": "subversion",
				"salience": 0.0014799269,
				"type": "OTHER"
			},
			{
				"name": "everyone",
				"salience": 0.0014799269,
				"type": "PERSON"
			},
			{
				"name": "earth",
				"salience": 0.0014799269,
				"type": "LOCATION"
			},
			{
				"name": "class",
				"salience": 0.001378625,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.001378625,
				"type": "OTHER"
			},
			{
				"name": "militaries",
				"salience": 0.0012815006,
				"type": "ORGANIZATION"
			},
			{
				"name": "connection",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"name": "continent",
				"salience": 0.0012815006,
				"type": "LOCATION"
			},
			{
				"name": "most",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"name": "aggression",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.0012815006,
				"type": "EVENT"
			},
			{
				"name": "tens of thousands",
				"salience": 0.0012815006,
				"type": "PERSON"
			},
			{
				"name": "attempt",
				"salience": 0.0012815006,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jtm8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_China_Sea"
				},
				"name": "South China Sea",
				"salience": 0.0012451207,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0012451207,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "Europe",
				"salience": 0.0012451207,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "African",
				"salience": 0.0011995063,
				"type": "LOCATION"
			},
			{
				"name": "executive editor",
				"salience": 0.0011937752,
				"type": "PERSON"
			},
			{
				"name": "Capital",
				"salience": 0.0011893335,
				"type": "LOCATION"
			},
			{
				"name": "empire",
				"salience": 0.001087798,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.0010778514,
				"type": "EVENT"
			},
			{
				"name": "creatures",
				"salience": 0.0010508568,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00096529163,
				"type": "EVENT"
			},
			{
				"name": "email",
				"salience": 0.0009333161,
				"type": "WORK_OF_ART"
			},
			{
				"name": "web",
				"salience": 0.0009333161,
				"type": "OTHER"
			},
			{
				"name": "door",
				"salience": 0.0009333161,
				"type": "OTHER"
			},
			{
				"name": "confrontation",
				"salience": 0.0009333161,
				"type": "EVENT"
			},
			{
				"name": "mob",
				"salience": 0.0009333161,
				"type": "OTHER"
			},
			{
				"name": "servants",
				"salience": 0.0008649295,
				"type": "PERSON"
			},
			{
				"name": "means",
				"salience": 0.00080514926,
				"type": "OTHER"
			},
			{
				"name": "business",
				"salience": 0.00080514926,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.000788734,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.000788734,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j9z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Europe"
				},
				"name": "European",
				"salience": 0.000788734,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04pnx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Latin_America"
				},
				"name": "Latin America",
				"salience": 0.000788734,
				"type": "LOCATION"
			},
			{
				"name": "care",
				"salience": 0.0007428177,
				"type": "OTHER"
			},
			{
				"name": "Black Agenda Radio",
				"salience": 0.00073473185,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "industries",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "face",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "activity",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "security networks",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "problem",
				"salience": 0.0006971727,
				"type": "OTHER"
			},
			{
				"name": "BlackAgendaReport.com",
				"salience": 0.000574406,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01nz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bar_(establishment)"
				},
				"name": "BAR",
				"salience": 0.000574406,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0004955171,
				"type": "LOCATION"
			},
			{
				"name": "Beat the Clock",
				"salience": 0.0004955171,
				"type": "WORK_OF_ART"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T09:47:48.315+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.2,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget A Black Agenda Radio commentary by executive editor Glen Ford \nThe capitalist ruling class is frightened, for good reason: the empire cannot peacefully contain the rising economic powers of the South and East. “The Lords of Capital know there is no future for them in a world where the dollar is not supreme and where Wall Street’s stocks, bonds and derivatives are not backed by the full weight of unchallenged empire.” War is the only card they have left to play – and Hillary Clinton is their favored dealer. The Lords of Capital Sic Crazy Hillary on the World A Black Agenda Radio commentary by executive editor Glen Ford \n“The Lords of Capital are creatures of U.S. imperial dominance; they go out of business when the empire does.” \nBy virtually every measurement, the United States is in deep crisis, as both a society and as the headquarters of global capitalism. We can roughly measure the severity of some aspects of the crisis with the tools of economic analysis. Such an analysis is quite useful in explaining why Washington is so eager to risk war with Russia and China, whether in Syria or the South China Sea or along the ever expanding borders of NATO. To put it simply, the U.S. and western Europe become smaller, in terms of their economic influence, with every passing day, and cannot possibly maintain their political dominance in the world except by military force, coercion and terror. Those are the only cards the imperialists have left to play. The ruling circles in the U.S. are aware that time is not on their side, and it makes them crazy -- or crazier than usual. \nThe ruling class’s own analysts tell them that the center of the world economy is moving inexorably to the East and the South; that this trend will continue for the foreseeable future; and that the U.S. is already number two by some economic measures -- and dropping. The Lords of Capital know there is no future for them in a world where the dollar is not supreme and where Wall Street’s stocks, bonds and derivatives are not backed by the full weight of unchallenged empire. Put another way, U.S. imperialism is at an inflection point, with all the indicators pointing downward and no hope of reversing the trend by peaceful means. \nNow, that’s actually not such a bad prognosis for the United States, as a country. The U.S. is a big country, with an abundance of human and natural resources, and would do just fine in a world among equals. But, the fate of the Lords of Capital is tied to the ongoing existence of empire. They create nothing, but seek to monetize and turn a profit on everything. They cannot succeed in trade unless it is rigged, and have placed bets in their casinos that are nominally seven times more valuable than the total economic activity of planet Earth. In short, the Lords of Capital are creatures of U.S. imperial dominance; they go out of business when the empire does. \nBeat the Clock \nThe rulers are looking class death in the face -- and it terrifies them. And when the Lords of Capital become frightened, they order their servants in politics and the war industries and the vast national security networks to take care of the problem, by any means necessary. That means militarily encircling Russia and China; arming and mobilizing tens of thousands of jihadist terrorists in Syria, in an attempt to repeat the regime change in Libya; waging a war of economic sanctions and low-level armed aggression against Iran; occupying most of the African continent through subversion of African militaries; escalating subversion in Latin America; and spying on everyone on earth with a digital connection. All this, to stop the clock that is ticking on U.S. and European world economic dominance. \nLeft political analysts that I greatly respect argue that Hillary Clinton and the mob she will come in with in January will pull back from apocalyptic confrontation with Russia in Syria -- that they’re not really that crazy. But, I’m not at all convinced. The ruling class isn’t just imagining that their days are numbered; it’s really true. And rulers do get crazy when their class is standing at death’s door. \nFor Black Agenda Radio, I’m Glen Ford. On the web, go to BlackAgendaReport.com. BAR executive editor Glen Ford can be contacted at [email protected] .",
		"thread_title": "The Lords of Capital Sic Crazy Hillary on the World",
		"title": "The Lords of Capital Sic Crazy Hillary on the World",
		"type": "bs",
		"uuid": "3d05e3bb3bc7df095b43c315a8c41256bbd42772"
	},
	"-KhIkUf5EzeF3s-Ujdkn": {
		"author": "Margaret Kimberley",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:47:48.436+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.3004172,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.23244461,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.08297117,
				"type": "PERSON"
			},
			{
				"name": "Margaret Kimberley",
				"salience": 0.06478829,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudi Arabian",
				"salience": 0.021206273,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.010575903,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.010082143,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/08193",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vladimir_Putin"
				},
				"name": "Vladimir Putin",
				"salience": 0.008961732,
				"type": "PERSON"
			},
			{
				"name": "fate",
				"salience": 0.008280423,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0068682567,
				"type": "LOCATION"
			},
			{
				"name": "regime",
				"salience": 0.0068682567,
				"type": "OTHER"
			},
			{
				"name": "chair",
				"salience": 0.0062268856,
				"type": "CONSUMER_GOOD"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.005860401,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01z215",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Saudi_Arabia"
				},
				"name": "Saudis",
				"salience": 0.005860002,
				"type": "LOCATION"
			},
			{
				"name": "BAR editor",
				"salience": 0.005374602,
				"type": "PERSON"
			},
			{
				"name": "head-chopping",
				"salience": 0.0046558855,
				"type": "EVENT"
			},
			{
				"name": "kleptocracy",
				"salience": 0.0046558855,
				"type": "OTHER"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.0046558855,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.004529397,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.0043741055,
				"type": "EVENT"
			},
			{
				"name": "villainy",
				"salience": 0.0041851886,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckxt",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Human_Rights_Watch"
				},
				"name": "Human Rights Watch",
				"salience": 0.0038158875,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/02z4f6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations_Human_Rights_Council"
				},
				"name": "United Nations Human Rights Council",
				"salience": 0.00380156,
				"type": "ORGANIZATION"
			},
			{
				"name": "regime change",
				"salience": 0.0032941122,
				"type": "EVENT"
			},
			{
				"name": "fighting",
				"salience": 0.0032941122,
				"type": "EVENT"
			},
			{
				"name": "reality",
				"salience": 0.00324704,
				"type": "OTHER"
			},
			{
				"name": "allies",
				"salience": 0.0032185202,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0031400744,
				"type": "PERSON"
			},
			{
				"name": "War Party",
				"salience": 0.0030877194,
				"type": "ORGANIZATION"
			},
			{
				"name": "tales",
				"salience": 0.0028608926,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.0027484586,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.0027484586,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.0027484586,
				"type": "PERSON"
			},
			{
				"name": "Freedom Rider",
				"salience": 0.0027484586,
				"type": "PERSON"
			},
			{
				"name": "Regime change",
				"salience": 0.0025406058,
				"type": "OTHER"
			},
			{
				"name": "Regime change",
				"salience": 0.0025406058,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0025221969,
				"type": "PERSON"
			},
			{
				"name": "fighters",
				"salience": 0.0023846983,
				"type": "PERSON"
			},
			{
				"name": "massacre",
				"salience": 0.0023803613,
				"type": "OTHER"
			},
			{
				"name": "travesty",
				"salience": 0.0023803613,
				"type": "OTHER"
			},
			{
				"name": "march",
				"salience": 0.0023803613,
				"type": "OTHER"
			},
			{
				"name": "cheers",
				"salience": 0.0023803613,
				"type": "OTHER"
			},
			{
				"name": "warriors",
				"salience": 0.0022643898,
				"type": "PERSON"
			},
			{
				"name": "goal",
				"salience": 0.002110131,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0019160587,
				"type": "PERSON"
			},
			{
				"name": "Russophobia: War Party Propaganda",
				"salience": 0.0018743821,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01nz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bar_(establishment)"
				},
				"name": "BAR",
				"salience": 0.0018743821,
				"type": "ORGANIZATION"
			},
			{
				"name": "countries",
				"salience": 0.0017466011,
				"type": "LOCATION"
			},
			{
				"name": "terror war",
				"salience": 0.0017355549,
				"type": "EVENT"
			},
			{
				"name": "All",
				"salience": 0.0016856331,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0016143792,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0016034342,
				"type": "PERSON"
			},
			{
				"name": "war party",
				"salience": 0.0016034342,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.0016034342,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.0015292274,
				"type": "LOCATION"
			},
			{
				"name": "presidency",
				"salience": 0.0015292274,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0015292274,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04swd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Moscow"
				},
				"name": "Moscow",
				"salience": 0.0014656871,
				"type": "LOCATION"
			},
			{
				"name": "Superpower of Lies",
				"salience": 0.0014656871,
				"type": "ORGANIZATION"
			},
			{
				"name": "world",
				"salience": 0.0014478182,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.0013683422,
				"type": "ORGANIZATION"
			},
			{
				"name": "death",
				"salience": 0.0013571025,
				"type": "EVENT"
			},
			{
				"name": "president",
				"salience": 0.0013302143,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.0013076712,
				"type": "LOCATION"
			},
			{
				"name": "fear",
				"salience": 0.001301455,
				"type": "OTHER"
			},
			{
				"name": "propaganda",
				"salience": 0.0012537676,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0012170641,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Assad",
				"salience": 0.0011669556,
				"type": "PERSON"
			},
			{
				"name": "fear",
				"salience": 0.0011320617,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.0011320617,
				"type": "PERSON"
			},
			{
				"name": "crimes",
				"salience": 0.0011320617,
				"type": "EVENT"
			},
			{
				"name": "candle",
				"salience": 0.0011270066,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "part",
				"salience": 0.0011243842,
				"type": "OTHER"
			},
			{
				"name": "human rights",
				"salience": 0.0010723319,
				"type": "OTHER"
			},
			{
				"name": "pressure",
				"salience": 0.0010723319,
				"type": "OTHER"
			},
			{
				"name": "percentage",
				"salience": 0.0010712807,
				"type": "OTHER"
			},
			{
				"name": "place",
				"salience": 0.0010444591,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0010313009,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.001025628,
				"type": "LOCATION"
			},
			{
				"name": "claim",
				"salience": 0.0009847016,
				"type": "OTHER"
			},
			{
				"name": "logic",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "earth",
				"salience": 0.0009803041,
				"type": "LOCATION"
			},
			{
				"name": "bars",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "shortcomings",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "world opinion",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "repercussion",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "influence",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.0009803041,
				"type": "OTHER"
			},
			{
				"name": "suspects",
				"salience": 0.00096795365,
				"type": "PERSON"
			},
			{
				"name": "statements",
				"salience": 0.0009571432,
				"type": "OTHER"
			},
			{
				"name": "death",
				"salience": 0.00095160096,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02bzjj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Freedom_Riders"
				},
				"name": "Freedom Rider",
				"salience": 0.00095065765,
				"type": "PERSON"
			},
			{
				"name": "cause",
				"salience": 0.0009366618,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.00092008745,
				"type": "PERSON"
			},
			{
				"name": "starvation",
				"salience": 0.00087912433,
				"type": "OTHER"
			},
			{
				"name": "newspapers",
				"salience": 0.00087912433,
				"type": "ORGANIZATION"
			},
			{
				"name": "cause",
				"salience": 0.0008463116,
				"type": "OTHER"
			},
			{
				"name": "opposition",
				"salience": 0.00083506474,
				"type": "OTHER"
			},
			{
				"name": "modus operandi",
				"salience": 0.000814154,
				"type": "OTHER"
			},
			{
				"name": "modus operandi",
				"salience": 0.000814154,
				"type": "OTHER"
			},
			{
				"name": "regime change victim",
				"salience": 0.0007937665,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0007937665,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0007937665,
				"type": "OTHER"
			},
			{
				"name": "center",
				"salience": 0.0007937665,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.00079022127,
				"type": "OTHER"
			},
			{
				"name": "deaths",
				"salience": 0.0007670808,
				"type": "EVENT"
			},
			{
				"name": "rest",
				"salience": 0.0007641381,
				"type": "OTHER"
			},
			{
				"name": "ploy",
				"salience": 0.0007323294,
				"type": "OTHER"
			},
			{
				"name": "monarchy",
				"salience": 0.0007323294,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0px38",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_Washington_Post"
				},
				"name": "Washington Post",
				"salience": 0.00072114007,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07k2d",
					"wikipedia_url": "http://en.wikipedia.org/wiki/The_New_York_Times"
				},
				"name": "New York Times",
				"salience": 0.00072114007,
				"type": "ORGANIZATION"
			},
			{
				"name": "effort",
				"salience": 0.00071769464,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.00071769464,
				"type": "OTHER"
			},
			{
				"name": "Newspapers",
				"salience": 0.00071769464,
				"type": "WORK_OF_ART"
			},
			{
				"name": "lie",
				"salience": 0.0007049931,
				"type": "OTHER"
			},
			{
				"name": "relations",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "terrorist groups",
				"salience": 0.00068733795,
				"type": "ORGANIZATION"
			},
			{
				"name": "assistance",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "abuses",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "organizations",
				"salience": 0.00068733795,
				"type": "ORGANIZATION"
			},
			{
				"name": "necessity",
				"salience": 0.00068733795,
				"type": "OTHER"
			},
			{
				"name": "complex",
				"salience": 0.00068733795,
				"type": "LOCATION"
			},
			{
				"name": "people",
				"salience": 0.0006857381,
				"type": "PERSON"
			},
			{
				"name": "war party",
				"salience": 0.0006857381,
				"type": "ORGANIZATION"
			},
			{
				"name": "dangers",
				"salience": 0.0006701247,
				"type": "OTHER"
			},
			{
				"name": "interference",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00066168036,
				"type": "EVENT"
			},
			{
				"name": "mood",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "allegations",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "ruse",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "doing",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "conflagration",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "contrary",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "blame",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "mushroom clouds",
				"salience": 0.00066168036,
				"type": "OTHER"
			},
			{
				"name": "suffering",
				"salience": 0.00066168036,
				"type": "EVENT"
			},
			{
				"name": "public",
				"salience": 0.00066168036,
				"type": "PERSON"
			},
			{
				"name": "center",
				"salience": 0.0006480039,
				"type": "LOCATION"
			},
			{
				"name": "rest",
				"salience": 0.0006480039,
				"type": "OTHER"
			},
			{
				"name": "foil",
				"salience": 0.0006480039,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "heads",
				"salience": 0.00063983817,
				"type": "OTHER"
			},
			{
				"name": "disaster",
				"salience": 0.0006289533,
				"type": "EVENT"
			},
			{
				"name": "evil",
				"salience": 0.000623814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/03gyl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Haiti"
				},
				"name": "Haiti",
				"salience": 0.00060339645,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06tgw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Somalia"
				},
				"name": "Somalia",
				"salience": 0.00060339645,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0005803351,
				"type": "EVENT"
			},
			{
				"name": "victory",
				"salience": 0.0005781085,
				"type": "EVENT"
			},
			{
				"name": "case",
				"salience": 0.0005682733,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.0005650049,
				"type": "ORGANIZATION"
			},
			{
				"name": "destruction",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "rival",
				"salience": 0.0005611119,
				"type": "ORGANIZATION"
			},
			{
				"name": "misdeeds",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "enmity",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "entertainment",
				"salience": 0.0005611119,
				"type": "OTHER"
			},
			{
				"name": "evilism argument",
				"salience": 0.0005611119,
				"type": "EVENT"
			},
			{
				"name": "dislocation",
				"salience": 0.0005540407,
				"type": "OTHER"
			},
			{
				"name": "starvation",
				"salience": 0.000536125,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0005289988,
				"type": "OTHER"
			},
			{
				"name": "foreign policy",
				"salience": 0.0004840596,
				"type": "OTHER"
			},
			{
				"name": "war crimes",
				"salience": 0.0004840596,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.0004840596,
				"type": "OTHER"
			},
			{
				"name": "foil",
				"salience": 0.0004840596,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "opportunity",
				"salience": 0.0004840596,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.00047629102,
				"type": "OTHER"
			},
			{
				"name": "nation",
				"salience": 0.00046011503,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00045091854,
				"type": "LOCATION"
			},
			{
				"name": "canards",
				"salience": 0.00042449503,
				"type": "OTHER"
			},
			{
				"name": "fate",
				"salience": 0.0004213203,
				"type": "OTHER"
			},
			{
				"name": "landslide",
				"salience": 0.000419145,
				"type": "EVENT"
			},
			{
				"name": "desire",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "hell",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "concern",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "magnitude",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.000419145,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00041076718,
				"type": "OTHER"
			},
			{
				"name": "term",
				"salience": 0.0004086464,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0004034961,
				"type": "OTHER"
			},
			{
				"name": "role",
				"salience": 0.00039044715,
				"type": "OTHER"
			},
			{
				"name": "villain",
				"salience": 0.00039044715,
				"type": "PERSON"
			},
			{
				"name": "BAR",
				"salience": 0.00039044715,
				"type": "LOCATION"
			},
			{
				"name": "president",
				"salience": 0.00038391218,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00037305822,
				"type": "PERSON"
			},
			{
				"name": "premise",
				"salience": 0.00035996758,
				"type": "OTHER"
			},
			{
				"name": "claims",
				"salience": 0.0003570257,
				"type": "OTHER"
			},
			{
				"name": "overtures",
				"salience": 0.00034652752,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01z88t",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yemen"
				},
				"name": "Yemen",
				"salience": 0.00034533817,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/027x630",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Islamic_State_of_Iraq_and_the_Levant"
				},
				"name": "ISIS",
				"salience": 0.00034533817,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "al Nusra",
				"salience": 0.00034533817,
				"type": "ORGANIZATION"
			},
			{
				"name": "prospect",
				"salience": 0.0003252331,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.00031570625,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.0003073651,
				"type": "ORGANIZATION"
			},
			{
				"name": "wars",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "ticket",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "Peace",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "e-Mail",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "mandate",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "blog",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "elsewhere",
				"salience": 0.00030524694,
				"type": "LOCATION"
			},
			{
				"name": "show",
				"salience": 0.00030524694,
				"type": "WORK_OF_ART"
			},
			{
				"name": "world stage",
				"salience": 0.00030524694,
				"type": "OTHER"
			},
			{
				"name": "propaganda effort",
				"salience": 0.00029537472,
				"type": "OTHER"
			},
			{
				"name": "newspapers",
				"salience": 0.00029165173,
				"type": "WORK_OF_ART"
			},
			{
				"name": "role",
				"salience": 0.00029165173,
				"type": "OTHER"
			},
			{
				"name": "effort",
				"salience": 0.00029165173,
				"type": "OTHER"
			},
			{
				"name": "Margaret.Kimberley",
				"salience": 0.00027751143,
				"type": "LOCATION"
			},
			{
				"name": "bloodshed",
				"salience": 0.00027702938,
				"type": "OTHER"
			},
			{
				"name": "attempts",
				"salience": 0.000263324,
				"type": "OTHER"
			},
			{
				"name": "votes",
				"salience": 0.00026214749,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.00025795476,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/07vsl",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Department_of_State"
				},
				"name": "State Department",
				"salience": 0.00025795476,
				"type": "ORGANIZATION"
			},
			{
				"name": "borders",
				"salience": 0.00022800655,
				"type": "LOCATION"
			},
			{
				"name": "catastrophe",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "provocation",
				"salience": 0.00022800655,
				"type": "EVENT"
			},
			{
				"name": "troops",
				"salience": 0.00022800655,
				"type": "PERSON"
			},
			{
				"name": "perfection",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "ally",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00022800655,
				"type": "ORGANIZATION"
			},
			{
				"name": "slaughter",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "television",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "journalism",
				"salience": 0.00022800655,
				"type": "OTHER"
			},
			{
				"name": "population",
				"salience": 0.00020431992,
				"type": "PERSON"
			},
			{
				"name": "BlackAgendaReport.com",
				"salience": 0.00018785286,
				"type": "OTHER"
			},
			{
				"name": "Ajamu Baraka",
				"salience": 0.00018785286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02_286",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_City"
				},
				"name": "New York City",
				"salience": 0.00018785286,
				"type": "LOCATION"
			},
			{
				"name": "http://freedomrider.blogspot.com",
				"salience": 0.00018785286,
				"type": "OTHER"
			},
			{
				"name": "Jill Stein",
				"salience": 0.00018785286,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.00014031536,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/045vz5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Anti-Russian_sentiment"
				},
				"name": "anti-Russian",
				"salience": 0.00014031536,
				"type": "ORGANIZATION"
			},
			{
				"name": "one",
				"salience": 0.00013214535,
				"type": "PERSON"
			},
			{
				"name": "guy",
				"salience": 0.00012721075,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:24:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 19.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget b y BAR editor and senior columnist Margaret Kimberley \nThe world’s most reactionary regime, the head-chopping, terror-sponsoring Saudi Arabian kleptocracy, was awarded the chair of the UN Human Rights Council, while Russia has been kicked out. The travesty was engineered by the Superpower of Lies to punish Moscow for resisting the U.S.-led war of sectarian massacre and regime change in Syria. The War Party is on the march, to the cheers of corporate media – and Hillary hasn’t even been elected yet. Freedom Rider : Russophobia: War Party Propaganda b y BAR editor and senior columnist Margaret Kimberley \n“ All attempts to stop the fighting were rejected by the U.S. and NATO and sealed the fate of the Syrian people.” \nDid Russia invade Iraq and kill one million people? Does Russia have a greater percentage of its population behind bars than any other country in the world? Did Russia occupy Haiti after kidnapping its president? Are Russian police allowed to shoot children to death without fear of repercussion? Is Russia entering its 20 th year of a terror war against the people of Somalia? All of these crimes take place in or at the direction of the United States. Yet the full force of propaganda and influence on world opinion is directed against Russia, which whatever its shortcomings cannot hold a candle to America in violating human rights. \nThe dangers presented by a Hillary Clinton presidency cannot be overstated. She and the war party have been steadily working towards a goal that defies logic and risks all life on earth. Regime change is once again their modus operandi and they hope to make it a reality against Russia. \nNearly every claim of Russian evil doing is a lie, a ruse meant to put Americans in a fighting mood and lose their fear of nuclear conflagration. It isn’t clear if Clinton and the rest of the would-be warriors actually realize they are risking mushroom clouds. Perhaps they believe that Vladimir Putin will be easily pushed around when all evidence points to the contrary. \n“ Regime change is once again their modus operandi and they hope to make it a reality against Russia.” \nThe unproven allegations of interference in the presidential election and casting blame on Russia as the sole cause of suffering in Syria are meant to desensitize the public. It is an age old ploy which makes war not just acceptable but deemed a necessity. The usual suspects are helping out eagerly. The corporate media, led by newspapers like the New York Times and Washington Post , are front and center in pushing tales of Russian villainy. Human Rights Watch and other organizations who care nothing about abuses committed by the United States and its allies are also playing their usual role of choosing the next regime change victim. \nRussia lost its seat on the United Nations Human Rights Council in part because of American pressure and public relations assistance from the human rights industrial complex. The UNHRC is now chaired by Saudi Arabia. Saudi Arabia is an absolute monarchy that funds the jihadist terrorist groups who caused 500,000 Syrian deaths. The Saudis are causing dislocation, death and starvation in Yemen, too, but they are American allies, so there is little opposition to their misdeeds. \nThe openly bigoted Donald Trump has been the perfect foil for Hillary Clinton. That is why she and the rest of the Democratic Party leadership preferred him as their rival. He made the case for the discredited lesser evilism argument and his sensible statements about avoiding enmity with Russia made him even more useful. \n“ Newspapers like the New York Times and Washington Post, are front and center in pushing tales of Russian villainy.” \nThe United States and its allies are the cause of Syria’s destruction. Their effort to overthrow president Assad created a humanitarian disaster complete with ISIS and al Nusra fighters who love to chop off heads for entertainment. Far from being the cause of the catastrophe Russia left its ally to fight alone for four years. They even made overtures to negotiate Assad’s fate with the United States. All attempts to stop the fighting were rejected by the U.S. and NATO and sealed the fate of the Syrian people. The people of east Aleppo are being shelled by American allies but one wouldn’t know that by reading what passes for journalism in newspapers and on television. The American role in the slaughter is barely mentioned or is excused as an effort to protect the civilian population. The bloodshed was made in the U.S. and could end if this government wanted it to. \nThe anti-Russian propaganda effort has worked to perfection. NATO is massing troops on Russia’s borders in a clear provocation yet Putin is labeled the bad guy. He is said to be menacing the countries that join in threatening his nation. The United States makes phony claims of Russian war crimes despite having blood on its hands. The latest Human Rights Watch canards about prosecuting Assad come straight from the White House and State Department and have nothing to do with concern for Syrians living in their fifth year of hell. \n“Donald Trump has been the perfect foil for Hillary Clinton.” \nThere is no lesser evil between Hillary Clinton and Donald Trump. She is fully supported by the war party in her desire for a more “muscular” foreign policy. That bizarre term means death and starvation for millions more people if Clinton wins in a landslide. She must be denied a victory of that magnitude and any opportunity to claim a mandate. Peace loving people must give their votes to the Green Party ticket of Jill Stein and Ajamu Baraka. They are alone in rejecting the premise of an imperialist country and its endless wars. \nThe United States is the most dangerous country in the world. If it has a reckless and war loving president the threat becomes existential. That is the prospect we face with a Hillary Clinton presidency. If the role of villain is cast on the world stage she is the star of the show. Margaret Kimberley's Freedom Rider column appears weekly in BAR, and is widely reprinted elsewhere. She maintains a frequently updated blog as well as at http://freedomrider.blogspot.com. Ms. Kimberley lives in New York City, and can be reached via e-Mail at Margaret.Kimberley(at)BlackAgendaReport.com.",
		"thread_title": "Freedom Rider: Russophobia: War Party Propaganda",
		"title": "Freedom Rider: Russophobia: War Party Propaganda",
		"type": "bs",
		"uuid": "d45166c584840b9b2125a8d0ad6578d7868d8249"
	},
	"-KhIkW099tt_KjPDcBHn": {
		"author": "Dr. Marsha Coleman-Adebayo",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:47:48.592+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "Margaret Flowers",
				"salience": 0.59239966,
				"type": "PERSON"
			},
			{
				"name": "Dr.",
				"salience": 0.029221779,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.025049869,
				"type": "LOCATION"
			},
			{
				"name": "candidates",
				"salience": 0.02261706,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07k5l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Green_Party_of_the_United_States"
				},
				"name": "Green Party",
				"salience": 0.018119149,
				"type": "ORGANIZATION"
			},
			{
				"name": "Marsha Adebayo",
				"salience": 0.017515818,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.017021641,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.010510092,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.010319007,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t58",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Senate"
				},
				"name": "Senate",
				"salience": 0.009749334,
				"type": "ORGANIZATION"
			},
			{
				"name": "university stage",
				"salience": 0.009390298,
				"type": "LOCATION"
			},
			{
				"name": "message",
				"salience": 0.0076461355,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/025kb5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Chris_Van_Hollen"
				},
				"name": "Chris Van Hollen",
				"salience": 0.007482504,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_ql9fw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kathy_Szeliga"
				},
				"name": "Kathy Szeliga",
				"salience": 0.006751287,
				"type": "PERSON"
			},
			{
				"name": "editor",
				"salience": 0.0066410806,
				"type": "PERSON"
			},
			{
				"name": "columnist",
				"salience": 0.0066410806,
				"type": "PERSON"
			},
			{
				"name": "elections",
				"salience": 0.0057539768,
				"type": "EVENT"
			},
			{
				"name": "vulgarity",
				"salience": 0.0057539768,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01nz0z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bar_(establishment)"
				},
				"name": "BAR",
				"salience": 0.005387106,
				"type": "ORGANIZATION"
			},
			{
				"name": "duopoly parties",
				"salience": 0.005204971,
				"type": "ORGANIZATION"
			},
			{
				"name": "Debate",
				"salience": 0.0048892763,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.0046720337,
				"type": "OTHER"
			},
			{
				"name": "test",
				"salience": 0.0043570884,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.004343947,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/094jv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Baltimore"
				},
				"name": "Baltimore",
				"salience": 0.0040943255,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.003748874,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0037080476,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0036105888,
				"type": "OTHER"
			},
			{
				"name": "candidates",
				"salience": 0.0035504473,
				"type": "PERSON"
			},
			{
				"name": "veneer",
				"salience": 0.0035357112,
				"type": "OTHER"
			},
			{
				"name": "University of Baltimore College of Public Affairs",
				"salience": 0.003453333,
				"type": "LOCATION"
			},
			{
				"name": "columnist",
				"salience": 0.003398206,
				"type": "PERSON"
			},
			{
				"name": "integrity",
				"salience": 0.003398206,
				"type": "OTHER"
			},
			{
				"name": "right",
				"salience": 0.003398206,
				"type": "OTHER"
			},
			{
				"name": "editor",
				"salience": 0.003398206,
				"type": "PERSON"
			},
			{
				"name": "candidate",
				"salience": 0.0032284432,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04rrd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Maryland"
				},
				"name": "Maryland",
				"salience": 0.0029547997,
				"type": "LOCATION"
			},
			{
				"name": "cops",
				"salience": 0.0029433437,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05st_r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Jill_Stein"
				},
				"name": "Jill Stein",
				"salience": 0.0024898716,
				"type": "PERSON"
			},
			{
				"name": "politicians",
				"salience": 0.0023372595,
				"type": "PERSON"
			},
			{
				"name": "parties",
				"salience": 0.0021463586,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/026mj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Delaware"
				},
				"name": "Del",
				"salience": 0.0020430416,
				"type": "LOCATION"
			},
			{
				"name": "debate",
				"salience": 0.0019654674,
				"type": "OTHER"
			},
			{
				"name": "Margaret Flowers Challenges",
				"salience": 0.0018127284,
				"type": "OTHER"
			},
			{
				"name": "corruption",
				"salience": 0.0018041151,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06lfd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Rosa_Parks"
				},
				"name": "Rosa Parks",
				"salience": 0.0017686437,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republican",
				"salience": 0.0017463752,
				"type": "ORGANIZATION"
			},
			{
				"name": "police murder",
				"salience": 0.0016096722,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.0015587496,
				"type": "PERSON"
			},
			{
				"name": "duopoly",
				"salience": 0.0015507087,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic",
				"salience": 0.0015123716,
				"type": "ORGANIZATION"
			},
			{
				"name": "debates",
				"salience": 0.0014500845,
				"type": "EVENT"
			},
			{
				"name": "media",
				"salience": 0.0014002181,
				"type": "OTHER"
			},
			{
				"name": "disinfectant power",
				"salience": 0.0014002181,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.0014002181,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.0013959857,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0013907246,
				"type": "OTHER"
			},
			{
				"name": "campaign season",
				"salience": 0.0012125563,
				"type": "EVENT"
			},
			{
				"name": "No one",
				"salience": 0.0012125563,
				"type": "PERSON"
			},
			{
				"name": "sunlight",
				"salience": 0.0012125563,
				"type": "OTHER"
			},
			{
				"name": "display",
				"salience": 0.0012125563,
				"type": "OTHER"
			},
			{
				"name": "rulers",
				"salience": 0.0012125563,
				"type": "PERSON"
			},
			{
				"name": "relationship",
				"salience": 0.0012125563,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.0012125563,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0012125563,
				"type": "LOCATION"
			},
			{
				"name": "candidates",
				"salience": 0.0011354412,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.0011354412,
				"type": "LOCATION"
			},
			{
				"name": "stage",
				"salience": 0.0011354412,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0011354412,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0011354412,
				"type": "PERSON"
			},
			{
				"name": "system",
				"salience": 0.0011331392,
				"type": "OTHER"
			},
			{
				"name": "duopoly",
				"salience": 0.001087431,
				"type": "OTHER"
			},
			{
				"name": "university",
				"salience": 0.0010870881,
				"type": "ORGANIZATION"
			},
			{
				"name": "police murders",
				"salience": 0.0010866717,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0x67",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_American"
				},
				"name": "Black",
				"salience": 0.0010796398,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.0010468515,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.0010468515,
				"type": "PERSON"
			},
			{
				"name": "situation",
				"salience": 0.0010414493,
				"type": "OTHER"
			},
			{
				"name": "stage",
				"salience": 0.0010130128,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0c9ph5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flower"
				},
				"name": "Flowers",
				"salience": 0.0009886774,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "course",
				"salience": 0.0009818675,
				"type": "OTHER"
			},
			{
				"name": "magic number",
				"salience": 0.0009818675,
				"type": "OTHER"
			},
			{
				"name": "polls",
				"salience": 0.0009818675,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.00096097036,
				"type": "PERSON"
			},
			{
				"name": "audience",
				"salience": 0.00096097036,
				"type": "PERSON"
			},
			{
				"name": "audience",
				"salience": 0.00096097036,
				"type": "PERSON"
			},
			{
				"name": "media",
				"salience": 0.0009572845,
				"type": "OTHER"
			},
			{
				"name": "excuse",
				"salience": 0.00089447177,
				"type": "OTHER"
			},
			{
				"name": "Debate",
				"salience": 0.00088448205,
				"type": "OTHER"
			},
			{
				"name": "audience members",
				"salience": 0.00087207544,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africans",
				"salience": 0.00086198363,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0008502396,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.0008502396,
				"type": "EVENT"
			},
			{
				"name": "police",
				"salience": 0.00084826094,
				"type": "PERSON"
			},
			{
				"name": "dissent",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "color",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "youth",
				"salience": 0.000818506,
				"type": "PERSON"
			},
			{
				"name": "water",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "opportunity",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "drone warfare",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "resources",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "voices",
				"salience": 0.000818506,
				"type": "OTHER"
			},
			{
				"name": "corporation",
				"salience": 0.0008132051,
				"type": "ORGANIZATION"
			},
			{
				"name": "public",
				"salience": 0.0008015906,
				"type": "PERSON"
			},
			{
				"name": "protest",
				"salience": 0.0008015906,
				"type": "EVENT"
			},
			{
				"name": "attention",
				"salience": 0.0008015906,
				"type": "OTHER"
			},
			{
				"name": "Congressman",
				"salience": 0.0008015906,
				"type": "PERSON"
			},
			{
				"name": "poll numbers",
				"salience": 0.00079149107,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00076590216,
				"type": "OTHER"
			},
			{
				"name": "Ajamu Baraka",
				"salience": 0.0007464184,
				"type": "PERSON"
			},
			{
				"name": "place",
				"salience": 0.0007302327,
				"type": "OTHER"
			},
			{
				"name": "differences",
				"salience": 0.0006941181,
				"type": "OTHER"
			},
			{
				"name": "hands",
				"salience": 0.0006941181,
				"type": "OTHER"
			},
			{
				"name": "Shouts",
				"salience": 0.0006941181,
				"type": "OTHER"
			},
			{
				"name": "discussion",
				"salience": 0.0006941181,
				"type": "OTHER"
			},
			{
				"name": "Margaret Flowers.",
				"salience": 0.0006875395,
				"type": "PERSON"
			},
			{
				"name": "Delegate Szeliga",
				"salience": 0.00066656934,
				"type": "PERSON"
			},
			{
				"name": "Szeliga",
				"salience": 0.00066656934,
				"type": "LOCATION"
			},
			{
				"name": "lawsuit",
				"salience": 0.0006514749,
				"type": "OTHER"
			},
			{
				"name": "lot",
				"salience": 0.00059613737,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0dg3n1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Africa"
				},
				"name": "Africa",
				"salience": 0.0005818122,
				"type": "LOCATION"
			},
			{
				"name": "response",
				"salience": 0.00054549845,
				"type": "OTHER"
			},
			{
				"name": "debate hall",
				"salience": 0.00051851664,
				"type": "LOCATION"
			},
			{
				"name": "sidewalk",
				"salience": 0.00051851664,
				"type": "LOCATION"
			},
			{
				"name": "church",
				"salience": 0.00051851664,
				"type": "LOCATION"
			},
			{
				"name": "analysis",
				"salience": 0.00051851664,
				"type": "OTHER"
			},
			{
				"name": "conscience",
				"salience": 0.00051851664,
				"type": "OTHER"
			},
			{
				"name": "evils",
				"salience": 0.00051851664,
				"type": "PERSON"
			},
			{
				"name": "lesser",
				"salience": 0.00051851664,
				"type": "OTHER"
			},
			{
				"name": "folks",
				"salience": 0.00051851664,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.0005173097,
				"type": "PERSON"
			},
			{
				"name": "state",
				"salience": 0.0005081536,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/04rrx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michigan"
				},
				"name": "Michigan",
				"salience": 0.0005037954,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06n3y",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_America"
				},
				"name": "South America",
				"salience": 0.0005037954,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0m2rv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Flint,_Michigan"
				},
				"name": "Flint",
				"salience": 0.0005037954,
				"type": "LOCATION"
			},
			{
				"name": "candidate",
				"salience": 0.00049799756,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00049286895,
				"type": "PERSON"
			},
			{
				"name": "Campaign Information",
				"salience": 0.0004866577,
				"type": "OTHER"
			},
			{
				"name": "whistle",
				"salience": 0.00048301832,
				"type": "OTHER"
			},
			{
				"name": "debate",
				"salience": 0.00048122095,
				"type": "OTHER"
			},
			{
				"name": "voters",
				"salience": 0.0004805247,
				"type": "PERSON"
			},
			{
				"name": "stage",
				"salience": 0.00046150852,
				"type": "OTHER"
			},
			{
				"name": "sister",
				"salience": 0.0004509993,
				"type": "PERSON"
			},
			{
				"name": "rights",
				"salience": 0.0004361101,
				"type": "OTHER"
			},
			{
				"name": "Retaliation",
				"salience": 0.0004361101,
				"type": "OTHER"
			},
			{
				"name": "FEAR",
				"salience": 0.0004361101,
				"type": "OTHER"
			},
			{
				"name": "democracy",
				"salience": 0.00041668862,
				"type": "OTHER"
			},
			{
				"name": "Accountability",
				"salience": 0.00037762552,
				"type": "OTHER"
			},
			{
				"name": "Transparency",
				"salience": 0.00037762552,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.00037762552,
				"type": "PERSON"
			},
			{
				"name": "passage",
				"salience": 0.00037762552,
				"type": "EVENT"
			},
			{
				"name": "introduction",
				"salience": 0.00037762552,
				"type": "EVENT"
			},
			{
				"name": "whistleblower law",
				"salience": 0.00037762552,
				"type": "OTHER"
			},
			{
				"name": "vanadium mine workers",
				"salience": 0.00037762552,
				"type": "PERSON"
			},
			{
				"name": "commitment",
				"salience": 0.00036080784,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0g0lh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Environmental_Protection_Agency"
				},
				"name": "EPA",
				"salience": 0.0003534594,
				"type": "ORGANIZATION"
			},
			{
				"name": "power",
				"salience": 0.00032576526,
				"type": "OTHER"
			},
			{
				"name": "courage",
				"salience": 0.00032576526,
				"type": "OTHER"
			},
			{
				"name": "integrity",
				"salience": 0.00032576526,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hilary Clinton",
				"salience": 0.0003191232,
				"type": "PERSON"
			},
			{
				"name": "Whistleblowers Triumph over Corruption",
				"salience": 0.00029727267,
				"type": "PERSON"
			},
			{
				"name": "podium",
				"salience": 0.0002967563,
				"type": "OTHER"
			},
			{
				"name": "ambitions",
				"salience": 0.00028207543,
				"type": "OTHER"
			},
			{
				"name": "desire",
				"salience": 0.00028207543,
				"type": "OTHER"
			},
			{
				"name": "anything",
				"salience": 0.00028207543,
				"type": "OTHER"
			},
			{
				"name": "leadership",
				"salience": 0.00028207543,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02qwngq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/No-FEAR_Act"
				},
				"name": "No FEAR Act",
				"salience": 0.00026839957,
				"type": "WORK_OF_ART"
			},
			{
				"name": "protest",
				"salience": 0.00026592935,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hzlz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/South_Africa"
				},
				"name": "South African",
				"salience": 0.00023240199,
				"type": "LOCATION"
			},
			{
				"name": "Notification of Federal Employees Anti-discrimination and Retaliation Act of 2002",
				"salience": 0.00023240199,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/061jp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Pulitzer_Prize"
				},
				"name": "Pulitzer Prize",
				"salience": 0.00023240199,
				"type": "OTHER"
			},
			{
				"name": "http://www.flowersforsenate.org",
				"salience": 0.00023240199,
				"type": "OTHER"
			},
			{
				"name": "Green Shadow Cabinet",
				"salience": 0.00023240199,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/040514z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Advisory_board"
				},
				"name": "Advisory Board",
				"salience": 0.00023240199,
				"type": "ORGANIZATION"
			},
			{
				"name": "ExposeFacts.com",
				"salience": 0.00023240199,
				"type": "OTHER"
			},
			{
				"name": "amount",
				"salience": 0.00014770863,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:19:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 11.6,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "2016 elections by BAR editor and columnist, Dr. Marsha Adebayo \nThe “revolving, rigged system” that purports to be American democracy was revealed in all its corporate vulgarity on a Baltimore university stage, last week. Two U.S. Senate candidates of the duopoly parties pretended to support the Green Party’s candidate’s right to join the debate, but failed to protest when cops hauled her away. “This was their ‘Rosa Parks’ moment when they could have stood for integrity and democracy” -- but failed the test. Green Party’s Margaret Flowers Challenges US Senate Debate in Maryland as Undemocratic by BAR editor and columnist, Dr. Marsha Adebayo \n“ The corporate media and the political duopoly collaborated to ensure that the Green Party message would not be heard.” \nUS corruption during this campaign season is on full display for the entire world to ponder. No one paying even scant attention can deny the thin veneer that is used to hide state sponsored police murder of Africans, structural poverty and the cozy relationship between the 1% rulers in the Democratic and Republican parties. Green Party candidates, such as Jill Stein, Ajamu Baraka and Margaret Flowers have forced sunlight’s disinfectant power to expose a rigged, racist and revolting political system that politically and economically devours communities of color, condones police murders of Black youth, intentionally exposes communities, like Flint, Michigan, to poisoned water, promotes drone warfare and the pilfering of the natural resources of Africa and South America. \nThe system, however is finding it more difficult to block out the voices of dissent. Such was the situation this week at the University of Baltimore College of Public Affairs where Dr. Margaret Flowers, the Green Party candidate for the Maryland US Senate seat, was refused the opportunity to participate in the only televised debate alongside Democratic Congressman Chris Van Hollen and Republican state Del. Kathy Szeliga. The corporate media and the political duopoly collaborated to ensure that the Green Party message would not be heard. The sham excuse used to exclude Flowers was that her poll numbers had not reached 15%. But, of course it is difficult to reach the magic number of 15% in the polls when one is systematically excluded from debates and public events. This is the revolving rigged system that Black people know so well. \n“When the police came to escort her off the stage neither candidate provided a meaningful protest of the anti-democratic process unfolding.” \nWhen the rigged debate started, audience members called for Dr. Flowers to join Van Hollen and Szeliga. Shouts of “let her speak” could be heard from the audience. Responding to the audience, Dr. Flowers took her place on the stage shaking hands with both candidates. Standing on the stage, she turned her attention to the audience and said: \n“I think it’s important for voters to understand the differences between myself and Congressman Van Hollen and Delegate Szeliga.” With the police moving on stage to remove her, she said, …”I mean, you say you’re a public university and you want to educate the public, but without having a full public discussion, that doesn't actually happen.” \nWhile Van Hollen and Szeliga seemed to agree with Dr. Flowers participating in the debate, when the police came to escort her off the stage neither candidate provided a meaningful protest of the anti-democratic process unfolding. Delegate Szeliga noted that a third podium was available but both politicians remained silent while Dr. Flowers was forced to leave the stage. This was their “Rosa Parks” moment when they could have stood for integrity and democracy but Van Hollen and Szeliga, failed to show the smallest amount of courage, leadership and commitment to anything greater than their individual ambitions and desire for power. \nMargaret was escorted by police to a sidewalk outside the debate hall and that symbolically represents the state of US democracy. \nAfter church on Sunday, a sister said to me, “I know a lot of Black folks are going to vote for Hilary Clinton but I can’t vote for the lesser of two evils. I’ve decided to vote for Jill Stein. I’m going to vote my conscience!” My only response after agreeing with her analysis was to add, “Don’t forget to also vote for Margaret Flowers.“ \nDr. Margaret Flowers of Green Party Interrupts Maryland Senate Televised Debate: \nhttps://www.youtube.com/watch?v=Ix98YXLWUJg \nMargaret Flowers Campaign Information: http://www.flowersforsenate.org Dr. Marsha Adebayo is the author of the Pulitzer Prize nominated: No FEAR: A Whistleblowers Triumph over Corruption and Retaliation at the EPA . She worked at the EPA for 18 years and blew the whistle on a US multinational corporation that endangered South African vanadium mine workers. Marsha's successful lawsuit led to the introduction and passage of the first civil rights and whistleblower law of the 21st century: the Notification of Federal Employees Anti-discrimination and Retaliation Act of 2002 (No FEAR Act). She is Director of Transparency and Accountability for the Green Shadow Cabinet and serves on the Advisory Board of ExposeFacts.com.",
		"thread_title": "Green Party’s Margaret Flowers Challenges US Senate Debate in Maryland as Undemocratic",
		"title": "Green Party’s Margaret Flowers Challenges US Senate Debate in Maryland as Undemocratic",
		"type": "bs",
		"uuid": "7ef9b9d164a3137a335ce1172e22aa81e81a8c04"
	},
	"-KhIkWvsozz1V_P54fZZ": {
		"author": "Danny Haiphong",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:47:48.872+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.48041993,
				"type": "LOCATION"
			},
			{
				"name": "Eric Draitser",
				"salience": 0.17716226,
				"type": "PERSON"
			},
			{
				"name": "government",
				"salience": 0.10538593,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.032134652,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.01525663,
				"type": "LOCATION"
			},
			{
				"name": "Break the Silence",
				"salience": 0.012354454,
				"type": "OTHER"
			},
			{
				"name": "countries",
				"salience": 0.008639939,
				"type": "LOCATION"
			},
			{
				"name": "war",
				"salience": 0.0068631386,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrians",
				"salience": 0.0055595925,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01505k",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Aleppo"
				},
				"name": "Aleppo",
				"salience": 0.004622785,
				"type": "LOCATION"
			},
			{
				"name": "character",
				"salience": 0.0042681224,
				"type": "PERSON"
			},
			{
				"name": "misinformation campaigns",
				"salience": 0.0033552228,
				"type": "EVENT"
			},
			{
				"name": "history",
				"salience": 0.0033552228,
				"type": "OTHER"
			},
			{
				"name": "leftists",
				"salience": 0.003185411,
				"type": "PERSON"
			},
			{
				"name": "confusion",
				"salience": 0.003120872,
				"type": "OTHER"
			},
			{
				"name": "leftists",
				"salience": 0.0028998307,
				"type": "PERSON"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.0023444777,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/020wr2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Western_world"
				},
				"name": "Western",
				"salience": 0.0022342533,
				"type": "LOCATION"
			},
			{
				"name": "regrets",
				"salience": 0.002127311,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.0020391662,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0019800323,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0017009793,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0017009793,
				"type": "EVENT"
			},
			{
				"name": "Center for International Justice and Accountability",
				"salience": 0.0016992731,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0016059917,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.001463098,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.001463098,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.0013303187,
				"type": "OTHER"
			},
			{
				"name": "Imperialism",
				"salience": 0.0013303187,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.0013303187,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.0012738253,
				"type": "EVENT"
			},
			{
				"name": "confusion",
				"salience": 0.001253785,
				"type": "OTHER"
			},
			{
				"name": "confusion",
				"salience": 0.001253785,
				"type": "OTHER"
			},
			{
				"name": "Danny Haiphong",
				"salience": 0.0012140987,
				"type": "ORGANIZATION"
			},
			{
				"name": "Danny Haiphong Syria",
				"salience": 0.0011757333,
				"type": "ORGANIZATION"
			},
			{
				"name": "question",
				"salience": 0.0011756856,
				"type": "OTHER"
			},
			{
				"name": "self-determination",
				"salience": 0.001068044,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.001068044,
				"type": "LOCATION"
			},
			{
				"name": "Obvious",
				"salience": 0.0009862024,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.00094785524,
				"type": "OTHER"
			},
			{
				"name": "struggle",
				"salience": 0.00094785524,
				"type": "EVENT"
			},
			{
				"name": "one",
				"salience": 0.00094785524,
				"type": "OTHER"
			},
			{
				"name": "Answer",
				"salience": 0.0009205902,
				"type": "OTHER"
			},
			{
				"name": "Answer",
				"salience": 0.0009205902,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.0008756969,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.000842438,
				"type": "OTHER"
			},
			{
				"name": "Danny Haiphong",
				"salience": 0.0008196971,
				"type": "PERSON"
			},
			{
				"name": "self-determination",
				"salience": 0.0007996822,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "plunder",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "imperialism wages wars",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "order",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "media lackeys",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "dedication",
				"salience": 0.00079070695,
				"type": "OTHER"
			},
			{
				"name": "forces",
				"salience": 0.00079070695,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/01_vwx",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bashar_al-Assad"
				},
				"name": "Bashar Al-Assad",
				"salience": 0.000745872,
				"type": "PERSON"
			},
			{
				"name": "war",
				"salience": 0.00070069486,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00070069486,
				"type": "EVENT"
			},
			{
				"name": "left",
				"salience": 0.0006942358,
				"type": "OTHER"
			},
			{
				"name": "resistance",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "author",
				"salience": 0.0006847265,
				"type": "PERSON"
			},
			{
				"name": "oppression",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "reaction",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "site",
				"salience": 0.0006847265,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "exploitation",
				"salience": 0.0006847265,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.0006365806,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0006026022,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0006026022,
				"type": "OTHER"
			},
			{
				"name": "conclusions",
				"salience": 0.00059198093,
				"type": "OTHER"
			},
			{
				"name": "governments",
				"salience": 0.0005897724,
				"type": "ORGANIZATION"
			},
			{
				"name": "imperialists",
				"salience": 0.00054786366,
				"type": "PERSON"
			},
			{
				"name": "reports",
				"salience": 0.0005303004,
				"type": "OTHER"
			},
			{
				"name": "confusion",
				"salience": 0.0005163171,
				"type": "OTHER"
			},
			{
				"name": "confusion",
				"salience": 0.0005163171,
				"type": "OTHER"
			},
			{
				"name": "confusion",
				"salience": 0.0005163171,
				"type": "OTHER"
			},
			{
				"name": "state",
				"salience": 0.00050131977,
				"type": "LOCATION"
			},
			{
				"name": "NGO",
				"salience": 0.0004977252,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00049131707,
				"type": "EVENT"
			},
			{
				"name": "terror groups",
				"salience": 0.0004808131,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0004808131,
				"type": "ORGANIZATION"
			},
			{
				"name": "media",
				"salience": 0.0004808131,
				"type": "OTHER"
			},
			{
				"name": "reports",
				"salience": 0.000473111,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00047297898,
				"type": "EVENT"
			},
			{
				"name": "ceasefire",
				"salience": 0.00046714992,
				"type": "EVENT"
			},
			{
				"name": "confrontation",
				"salience": 0.0004606348,
				"type": "EVENT"
			},
			{
				"name": "countries",
				"salience": 0.00043977026,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.00042747392,
				"type": "LOCATION"
			},
			{
				"name": "Tue",
				"salience": 0.00042148877,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.00041634784,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00041634784,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00041579382,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.0004135235,
				"type": "ORGANIZATION"
			},
			{
				"name": "governments",
				"salience": 0.0004135235,
				"type": "ORGANIZATION"
			},
			{
				"name": "terrorists",
				"salience": 0.00041196874,
				"type": "PERSON"
			},
			{
				"name": "left",
				"salience": 0.00040674955,
				"type": "OTHER"
			},
			{
				"name": "word",
				"salience": 0.0004063306,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0j44g62",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Nusra_Front"
				},
				"name": "Nusra Front",
				"salience": 0.00040288895,
				"type": "ORGANIZATION"
			},
			{
				"name": "war",
				"salience": 0.0004010986,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0004010986,
				"type": "EVENT"
			},
			{
				"name": "governments",
				"salience": 0.00039550915,
				"type": "ORGANIZATION"
			},
			{
				"name": "uprising",
				"salience": 0.0003952295,
				"type": "EVENT"
			},
			{
				"name": "Draister",
				"salience": 0.0003906508,
				"type": "PERSON"
			},
			{
				"name": "rebels",
				"salience": 0.00039024925,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00039024925,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.0003841331,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0003826925,
				"type": "ORGANIZATION"
			},
			{
				"name": "examination",
				"salience": 0.00036052207,
				"type": "EVENT"
			},
			{
				"name": "uprising",
				"salience": 0.00035710042,
				"type": "EVENT"
			},
			{
				"name": "NGOs",
				"salience": 0.00035184744,
				"type": "ORGANIZATION"
			},
			{
				"name": "criticism",
				"salience": 0.00034682138,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00034623905,
				"type": "EVENT"
			},
			{
				"name": "terror groups",
				"salience": 0.00033711272,
				"type": "ORGANIZATION"
			},
			{
				"name": "groups",
				"salience": 0.00033711272,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00033560686,
				"type": "OTHER"
			},
			{
				"name": "analysis",
				"salience": 0.00033163474,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "respect",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "media lackeys",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.00032551252,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00032452797,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.00032452797,
				"type": "ORGANIZATION"
			},
			{
				"name": "people",
				"salience": 0.00032195082,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.00032195082,
				"type": "PERSON"
			},
			{
				"name": "country",
				"salience": 0.00031226705,
				"type": "LOCATION"
			},
			{
				"name": "regime change",
				"salience": 0.00030833183,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00029962452,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00029962452,
				"type": "EVENT"
			},
			{
				"name": "channels",
				"salience": 0.00029682112,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00029552742,
				"type": "EVENT"
			},
			{
				"name": "sources",
				"salience": 0.00029190746,
				"type": "OTHER"
			},
			{
				"name": "sources",
				"salience": 0.00029190746,
				"type": "OTHER"
			},
			{
				"name": "source",
				"salience": 0.00029190746,
				"type": "OTHER"
			},
			{
				"name": "truth",
				"salience": 0.00028312704,
				"type": "OTHER"
			},
			{
				"name": "decision",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "head",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "chaos",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "issue",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "Nowhere",
				"salience": 0.00028186225,
				"type": "LOCATION"
			},
			{
				"name": "range",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "atrocities",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "problems",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.00028186225,
				"type": "OTHER"
			},
			{
				"name": "revolutionaries",
				"salience": 0.00028186225,
				"type": "PERSON"
			},
			{
				"name": "support",
				"salience": 0.0002810097,
				"type": "OTHER"
			},
			{
				"name": "support",
				"salience": 0.0002810097,
				"type": "OTHER"
			},
			{
				"name": "reforms",
				"salience": 0.000277099,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00027520081,
				"type": "LOCATION"
			},
			{
				"name": "reforms",
				"salience": 0.0002736068,
				"type": "OTHER"
			},
			{
				"name": "struggles",
				"salience": 0.0002736068,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/024_zq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/CounterPunch"
				},
				"name": "CounterPunch",
				"salience": 0.0002706736,
				"type": "ORGANIZATION"
			},
			{
				"name": "example",
				"salience": 0.00026931014,
				"type": "OTHER"
			},
			{
				"name": "reforms",
				"salience": 0.00026339205,
				"type": "OTHER"
			},
			{
				"name": "reforms",
				"salience": 0.00026339205,
				"type": "OTHER"
			},
			{
				"name": "uprisings",
				"salience": 0.00026339205,
				"type": "EVENT"
			},
			{
				"name": "uprisings",
				"salience": 0.00026339205,
				"type": "EVENT"
			},
			{
				"name": "rebels",
				"salience": 0.00026339205,
				"type": "OTHER"
			},
			{
				"name": "rebels",
				"salience": 0.00026339205,
				"type": "PERSON"
			},
			{
				"name": "case",
				"salience": 0.00026168575,
				"type": "OTHER"
			},
			{
				"name": "questions",
				"salience": 0.00026168575,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026095047,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026095047,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026095047,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00026095047,
				"type": "OTHER"
			},
			{
				"name": "manner",
				"salience": 0.0002595171,
				"type": "OTHER"
			},
			{
				"name": "rights",
				"salience": 0.00025791727,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00025766177,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00025766177,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.00025276217,
				"type": "ORGANIZATION"
			},
			{
				"name": "character",
				"salience": 0.00025276217,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.00025276217,
				"type": "ORGANIZATION"
			},
			{
				"name": "empire",
				"salience": 0.00025276217,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.00025170404,
				"type": "OTHER"
			},
			{
				"name": "narrative",
				"salience": 0.0002451589,
				"type": "OTHER"
			},
			{
				"name": "presence",
				"salience": 0.0002433254,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00024230676,
				"type": "LOCATION"
			},
			{
				"name": "peoples",
				"salience": 0.0002404946,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0002404946,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.00023967552,
				"type": "PERSON"
			},
			{
				"name": "terror",
				"salience": 0.0002382953,
				"type": "OTHER"
			},
			{
				"name": "case",
				"salience": 0.00023797815,
				"type": "OTHER"
			},
			{
				"name": "benefits",
				"salience": 0.0002360059,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.00023424778,
				"type": "OTHER"
			},
			{
				"name": "imperialism",
				"salience": 0.00023424778,
				"type": "OTHER"
			},
			{
				"name": "activist",
				"salience": 0.00023256078,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.0002282141,
				"type": "WORK_OF_ART"
			},
			{
				"name": "servants",
				"salience": 0.0002282141,
				"type": "PERSON"
			},
			{
				"name": "form",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "workers",
				"salience": 0.0002282141,
				"type": "PERSON"
			},
			{
				"name": "funds",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "discontent",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "service",
				"salience": 0.0002282141,
				"type": "OTHER"
			},
			{
				"name": "East to West Aleppo",
				"salience": 0.00022490468,
				"type": "OTHER"
			},
			{
				"name": "Imperialism",
				"salience": 0.00021985368,
				"type": "OTHER"
			},
			{
				"name": "claim",
				"salience": 0.00021969358,
				"type": "OTHER"
			},
			{
				"name": "article",
				"salience": 0.00021969358,
				"type": "WORK_OF_ART"
			},
			{
				"name": "destruction",
				"salience": 0.00021969358,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00021969358,
				"type": "LOCATION"
			},
			{
				"name": "discontent",
				"salience": 0.00021969358,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00021820939,
				"type": "EVENT"
			},
			{
				"name": "world war",
				"salience": 0.00021820939,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00021820939,
				"type": "EVENT"
			},
			{
				"name": "supremacy",
				"salience": 0.00020882554,
				"type": "OTHER"
			},
			{
				"name": "organization",
				"salience": 0.00020633773,
				"type": "ORGANIZATION"
			},
			{
				"name": "justice",
				"salience": 0.00020633773,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.00020633773,
				"type": "OTHER"
			},
			{
				"name": "many",
				"salience": 0.00020633773,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/059dn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/NATO"
				},
				"name": "NATO",
				"salience": 0.00020607287,
				"type": "ORGANIZATION"
			},
			{
				"name": "military medicine",
				"salience": 0.00020556984,
				"type": "OTHER"
			},
			{
				"name": "White Helmets",
				"salience": 0.00020485854,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/04gqr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Libya"
				},
				"name": "Libya",
				"salience": 0.00020471543,
				"type": "LOCATION"
			},
			{
				"name": "imperialism",
				"salience": 0.00019863967,
				"type": "OTHER"
			},
			{
				"name": "media",
				"salience": 0.00019789457,
				"type": "OTHER"
			},
			{
				"name": "arms",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "economy",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "fighting",
				"salience": 0.0001976082,
				"type": "EVENT"
			},
			{
				"name": "regime change operation",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "socialism",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "Healthcare",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "documents",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "education",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "citizens",
				"salience": 0.0001976082,
				"type": "PERSON"
			},
			{
				"name": "neo-liberalism",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "information",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "sanctions",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "staffers",
				"salience": 0.0001976082,
				"type": "PERSON"
			},
			{
				"name": "lawyers",
				"salience": 0.0001976082,
				"type": "PERSON"
			},
			{
				"name": "consortium",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "extension",
				"salience": 0.0001976082,
				"type": "OTHER"
			},
			{
				"name": "failure",
				"salience": 0.00019599323,
				"type": "EVENT"
			},
			{
				"name": "someone",
				"salience": 0.00019265835,
				"type": "PERSON"
			},
			{
				"name": "interests",
				"salience": 0.00019207555,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0001902301,
				"type": "LOCATION"
			},
			{
				"name": "midst",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "border",
				"salience": 0.0001902301,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.0001902301,
				"type": "EVENT"
			},
			{
				"name": "thousands",
				"salience": 0.0001902301,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "degrees",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "assistance",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "monarchies",
				"salience": 0.0001902301,
				"type": "PERSON"
			},
			{
				"name": "ideology",
				"salience": 0.0001902301,
				"type": "OTHER"
			},
			{
				"name": "regime change",
				"salience": 0.00018801686,
				"type": "OTHER"
			},
			{
				"name": "chance",
				"salience": 0.00018801686,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.00018764636,
				"type": "OTHER"
			},
			{
				"name": "heart",
				"salience": 0.00018629736,
				"type": "OTHER"
			},
			{
				"name": "sarin gas attack",
				"salience": 0.00018629736,
				"type": "EVENT"
			},
			{
				"name": "words",
				"salience": 0.00018629736,
				"type": "OTHER"
			},
			{
				"name": "funders",
				"salience": 0.00018629736,
				"type": "PERSON"
			},
			{
				"name": "partners",
				"salience": 0.00018629736,
				"type": "ORGANIZATION"
			},
			{
				"name": "parties",
				"salience": 0.00018629736,
				"type": "ORGANIZATION"
			},
			{
				"name": "argument",
				"salience": 0.00018629736,
				"type": "OTHER"
			},
			{
				"name": "ceasefire",
				"salience": 0.00018629736,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0px3s",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_York_Post"
				},
				"name": "New York Post",
				"salience": 0.00018496181,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/012l0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Amnesty_International"
				},
				"name": "Amnesty International",
				"salience": 0.00017965354,
				"type": "ORGANIZATION"
			},
			{
				"name": "pro-Assad",
				"salience": 0.00017347046,
				"type": "PERSON"
			},
			{
				"name": "wonder",
				"salience": 0.00017187394,
				"type": "OTHER"
			},
			{
				"name": "law",
				"salience": 0.0001697076,
				"type": "OTHER"
			},
			{
				"name": "stance",
				"salience": 0.0001683206,
				"type": "OTHER"
			},
			{
				"name": "left",
				"salience": 0.0001668393,
				"type": "OTHER"
			},
			{
				"name": "war",
				"salience": 0.00016299551,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.00016299551,
				"type": "EVENT"
			},
			{
				"name": "claim",
				"salience": 0.00016203581,
				"type": "OTHER"
			},
			{
				"name": "proxies",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "mouths",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "origins",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "events",
				"salience": 0.00016131185,
				"type": "EVENT"
			},
			{
				"name": "aid",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "withholding",
				"salience": 0.00016131185,
				"type": "EVENT"
			},
			{
				"name": "corridors",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "promotion",
				"salience": 0.00016131185,
				"type": "OTHER"
			},
			{
				"name": "White Helmet",
				"salience": 0.00015555891,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0001541272,
				"type": "ORGANIZATION"
			},
			{
				"name": "allies",
				"salience": 0.0001541272,
				"type": "ORGANIZATION"
			},
			{
				"name": "Positions",
				"salience": 0.0001541272,
				"type": "OTHER"
			},
			{
				"name": "empire",
				"salience": 0.0001541272,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00014357353,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0ckys",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Non-governmental_organization"
				},
				"name": "NGO",
				"salience": 0.00014044956,
				"type": "OTHER"
			},
			{
				"name": "body",
				"salience": 0.00014030361,
				"type": "OTHER"
			},
			{
				"name": "target",
				"salience": 0.00013925419,
				"type": "OTHER"
			},
			{
				"name": "supremacy",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "rescue",
				"salience": 0.0001391569,
				"type": "EVENT"
			},
			{
				"name": "dedication",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "condition",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "material conditions",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "form",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "situation",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "plight",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "end",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "rescue",
				"salience": 0.0001391569,
				"type": "EVENT"
			},
			{
				"name": "end",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "actions",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "assumption",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "assumption",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "principle",
				"salience": 0.0001391569,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00013717881,
				"type": "ORGANIZATION"
			},
			{
				"name": "self-determination",
				"salience": 0.00013692325,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04y29",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Muslim"
				},
				"name": "Muslims",
				"salience": 0.00013631942,
				"type": "PERSON"
			},
			{
				"name": "framework",
				"salience": 0.0001316813,
				"type": "OTHER"
			},
			{
				"name": "piece",
				"salience": 0.00013060504,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.00013060504,
				"type": "OTHER"
			},
			{
				"name": "regime",
				"salience": 0.00012962814,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07ssc",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Kingdom"
				},
				"name": "UK",
				"salience": 0.00012161209,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "UN",
				"salience": 0.00012161209,
				"type": "ORGANIZATION"
			},
			{
				"name": "Eva Bartlett",
				"salience": 0.00012161209,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/04t_mf",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Christian"
				},
				"name": "Christians",
				"salience": 0.00012161209,
				"type": "PERSON"
			},
			{
				"name": "struggle",
				"salience": 0.00012149985,
				"type": "OTHER"
			},
			{
				"name": "analyst",
				"salience": 0.00012149985,
				"type": "PERSON"
			},
			{
				"name": "struggle",
				"salience": 0.00012149985,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00012149985,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "notion",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "need",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "hit-list",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.000120492776,
				"type": "LOCATION"
			},
			{
				"name": "war machine",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "will",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "decline",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "crisis",
				"salience": 0.000120492776,
				"type": "EVENT"
			},
			{
				"name": "inception",
				"salience": 0.000120492776,
				"type": "EVENT"
			},
			{
				"name": "place",
				"salience": 0.000120492776,
				"type": "OTHER"
			},
			{
				"name": "military confrontation",
				"salience": 0.00012008529,
				"type": "EVENT"
			},
			{
				"name": "side",
				"salience": 0.0001195915,
				"type": "OTHER"
			},
			{
				"name": "positions",
				"salience": 0.0001195915,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07sv35n"
				},
				"name": "Wahhabi",
				"salience": 0.00011707107,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0661z",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Persian_Gulf"
				},
				"name": "Gulf",
				"salience": 0.00011707107,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.00011707107,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01znc_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Turkey"
				},
				"name": "Turkey",
				"salience": 0.00011707107,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01x38c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Daraa"
				},
				"name": "Daraa",
				"salience": 0.00011707107,
				"type": "LOCATION"
			},
			{
				"name": "anyone",
				"salience": 0.00011453144,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.00011359533,
				"type": "LOCATION"
			},
			{
				"name": "allies",
				"salience": 0.000112241876,
				"type": "ORGANIZATION"
			},
			{
				"name": "side",
				"salience": 0.000112241876,
				"type": "OTHER"
			},
			{
				"name": "ground",
				"salience": 0.00011182412,
				"type": "OTHER"
			},
			{
				"name": "exception",
				"salience": 0.000108865,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06vbd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syria"
				},
				"name": "Syrian",
				"salience": 0.000105539446,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.000102274826,
				"type": "LOCATION"
			},
			{
				"name": "scenario",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "destruction",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "critique",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "plunder",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "imperialism wages wars",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.00010133938,
				"type": "EVENT"
			},
			{
				"name": "imperialist order",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "path",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "work",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"name": "movement",
				"salience": 0.00010133938,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/081pw",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_II"
				},
				"name": "World War II",
				"salience": 0.000100309146,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0hc1g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/World_War_III"
				},
				"name": "World War III",
				"salience": 0.000100309146,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/02q8ml2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ghouta"
				},
				"name": "Ghouta",
				"salience": 0.000099272926,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0v74",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Al-Qaeda"
				},
				"name": "Al Qaeda",
				"salience": 0.000099272926,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0jwcs_4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Houla_massacre"
				},
				"name": "Houla Massacre",
				"salience": 0.000099272926,
				"type": "EVENT"
			},
			{
				"name": "Failure",
				"salience": 0.000098800665,
				"type": "OTHER"
			},
			{
				"name": "Stephen Gowans",
				"salience": 0.00009802156,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.000097653996,
				"type": "LOCATION"
			},
			{
				"name": "military assets",
				"salience": 0.000093912415,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.00009349279,
				"type": "OTHER"
			},
			{
				"name": "cause",
				"salience": 0.00009349279,
				"type": "OTHER"
			},
			{
				"name": "mistakes",
				"salience": 0.00009231428,
				"type": "OTHER"
			},
			{
				"name": "solution",
				"salience": 0.00009115063,
				"type": "OTHER"
			},
			{
				"name": "position",
				"salience": 0.00008932841,
				"type": "OTHER"
			},
			{
				"name": "anti-imperialists",
				"salience": 0.00008774692,
				"type": "PERSON"
			},
			{
				"name": "defense",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "sovereignty",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "area",
				"salience": 0.00008774692,
				"type": "LOCATION"
			},
			{
				"name": "email",
				"salience": 0.00008774692,
				"type": "WORK_OF_ART"
			},
			{
				"name": "commitment",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "course",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "stake",
				"salience": 0.00008774692,
				"type": "OTHER"
			},
			{
				"name": "side",
				"salience": 0.000083838444,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.000081681006,
				"type": "OTHER"
			},
			{
				"name": "attempt",
				"salience": 0.00008065137,
				"type": "OTHER"
			},
			{
				"name": "one",
				"salience": 0.00007631845,
				"type": "OTHER"
			},
			{
				"name": "peace",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "facts",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "assessment",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "argument",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "scenario",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "risk",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "no-fly zone",
				"salience": 0.00007569464,
				"type": "OTHER"
			},
			{
				"name": "hostage",
				"salience": 0.00007535641,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02rqk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Empire"
				},
				"name": "Empire",
				"salience": 0.00006907322,
				"type": "ORGANIZATION"
			},
			{
				"name": "fetishists",
				"salience": 0.00006554159,
				"type": "OTHER"
			},
			{
				"name": "starvation",
				"salience": 0.00006554159,
				"type": "OTHER"
			},
			{
				"name": "siege",
				"salience": 0.00006554159,
				"type": "EVENT"
			},
			{
				"name": "journalists",
				"salience": 0.00006554159,
				"type": "PERSON"
			},
			{
				"name": "vote",
				"salience": 0.00006554159,
				"type": "OTHER"
			},
			{
				"name": "elections",
				"salience": 0.00006554159,
				"type": "EVENT"
			},
			{
				"name": "train",
				"salience": 0.00006554159,
				"type": "OTHER"
			},
			{
				"name": "office",
				"salience": 0.00006554159,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05w3",
					"wikipedia_url": "http://en.wikipedia.org/wiki/China"
				},
				"name": "China",
				"salience": 0.000053998512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iran",
				"salience": 0.000053998512,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05q4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iraq"
				},
				"name": "Iraq",
				"salience": 0.000053998512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/087vz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Yugoslavia"
				},
				"name": "Yugoslavia",
				"salience": 0.000053998512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian",
				"salience": 0.000053998512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/01cx_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Boston"
				},
				"name": "Boston",
				"salience": 0.000053998512,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States",
				"salience": 0.000051593186,
				"type": "PERSON"
			},
			{
				"name": "no-fly zone",
				"salience": 0.000044429136,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04n7jf6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Syrian_Army"
				},
				"name": "Syrian Army",
				"salience": 0.00004033318,
				"type": "ORGANIZATION"
			},
			{
				"name": "Vanessa Beeley",
				"salience": 0.00004033318,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02hcv8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eastern_Time_Zone"
				},
				"name": "Eastern",
				"salience": 0.00004033318,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0m59j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Howard_Zinn"
				},
				"name": "Howard Zinn",
				"salience": 0.00004033318,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02z2bs2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Madaya,_Syria"
				},
				"name": "Madaya",
				"salience": 0.00004033318,
				"type": "LOCATION"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:14:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 30.8,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Break the Silence or Support Self-Determination? In Syria, the Answer Should be Obvious Submitted by Danny Haiphong on Tue, 11/01/2016 - 19:14 Tweet Widget by Danny Haiphong \nSyria is “the target of one of the greatest misinformation campaigns in recent history.” The author regrets that left analyst Eric Draitser has contributed to the confusion. Draitser criticizes leftists who firmly support the Syrian government. Danny Haiphong counters that “the left must act with uncompromising dedication to the principle of self-determination in every case where US and Western imperialism wages wars of neo-colonial plunder.” Break the Silence or Support Self-Determination? In Syria, the Answer Should be Obvious by Danny Haiphong \n“To claim that the left in the US should fight for ‘peace’ and at the same time oppose the Syrian government is an intentional attempt to remain neutral in a time of war.” \nImperialism's war on Syria may be the most important question on the order of the day for those fighting for a world free of exploitation and oppression. Syria is currently the battleground of imperialism's last gasp of life. In nearly six years, Syria has been turned into a site of intense struggle between the forces of resistance and imperialism's forces of reaction. It has also been the target of one of the greatest misinformation campaigns in recent history. The imperialist countries and their media lackeys have sewed deep confusion about the true character of the war being waged on Syria. Nowhere is this confusion greater than in the United States, and it appears someone I deeply respect has been overtaken by it. \nIn a recent issue of CounterPunch, Eric Draitser dives head deep into the confusion . He criticizes what he deems as two critical problems with the left's stance. Draitser first criticizes the pro-imperialist left for their decision to align themselves with the foreign-sponsored terror groups in Syria, which have been labeled \"revolutionaries\" or \"rebels\" by the imperialist countries. He then goes on to criticize leftists who have positioned themselves firmly in support of the Syrian government. \nIt is his criticism of the \"pro-Assad left\" that needs further examination. Draitser reveals his deep confusion when he asks: \n\"Will you continue to delude yourselves by refusing to accept the plainly obvious truth that no state or group has the best interests of Syrians at heart?\" \nDraitser's question assumes that the Syrian and Russian governments are equally to blame for the chaos in Syria. Their bombs are assumed to be prolonging the war and committing atrocities against the Syrian people at the same rate of the imperialists. If this is not the case, he doesn't state otherwise in the piece. In fact, Draitser sets out to prove true what has already been proven false by a wide range of independent and corporate media sources. \n“The imperialist countries and their media lackeys have sewed deep confusion about the true character of the war being waged on Syria.” \nFirst, Draitser claims that the war on Syria began as a genuine protest against \"neo-liberal\" reforms instituted by the Syrian government. This narrative is popular among the liberal-left media as well as the white left generally. However, those who make this claim rarely specify what neo-liberal reforms were made or how the confrontation all of a sudden became violent. Stephen Gowans reviews numerous reports from the corporate media that describe the uprising in March of 2011 as immediately violent, ill-supported, and ultimately insignificant in the midst of reforms from the Syrian government that were broadly supported by the Syrian people. At the same time as the violent uprisings, thousands of Syrians were protesting in the streets in support of President Assad. \nFurthermore, reports from the city of Daraa during the 2011 uprisings confirmed the presence of armed \"rebels\" who had freshly arrived from their US-NATO backed destruction of Libya . These \"rebels\" have since infested the country through various channels of the Syrian border. Each group possesses a fundamentalist Wahhabi ideology and receives varying degrees of assistance from the Gulf monarchies, Israel, Turkey, NATO, and of course, the US. This is confirmed in Draitser's article. Yet he still reinforces the claim that a popular uprising started the war even though Assad possessed broad support in 2011 . \nThe truth is that the war on Syria has little to do with neo-liberalism or popular discontent. It has been acknowledged by UN sources that despite reforms, the Syrian economy remains highly regulated and socialist in character . Syria's own form of socialism has brought many benefits to the Syrian people. Healthcare and education are rights guaranteed to all citizens . Syria also possesses a secular government where Muslims, Christians, and all religious and ethnic groups lived peacefully prior to the war. Syria is thus a poor example of neo-liberalism. What economic struggles that do exist in Syria have largely stemmed from the harsh sanctions imposed by the US in 2004. \n“The war on Syria has little to do with neo-liberalism or popular discontent.” \nFurthermore, Draitser cites numerous sources that support regime change to smear the Syrian government and, by extension, the Syrian people. One of the sources receives much of its information from the White Helmets. The White Helmets have long been exposed as an NGO that works directly in service of imperialism's regime change operation in Syria. The organization receives approximately 33 million in funds directly from the US and UK governments. Eva Bartlett recently visited Aleppo and witnessed many White Helmet workers sporting arms and fighting among the terror groups . \nDraister also cites a source from the New York Post . The Post article relies heavily on documents collected by the dubious Center for International Justice and Accountability. This purported \"international law\" NGO is run by a consortium of corporate lawyers, former or current Amnesty International staffers, and various other servants of empire. The organization specializes in \"transitional justice.\" In other words, the Center for International Justice and Accountability (CIJA) provides a legal framework for regime change on behalf of its imperial funders. Draitser claims no group involved in the war has the interests of the Syrian people at heart yet cites directly from an organization dedicated to the promotion of war in Syria. \nThe NGOs and their partners in the corporate media have worked together to distort the reality on the ground. Aleppo is case and point. A ceasefire was brokered by all parties in late October that was supposed to allow Syrians to escape safely from East to West Aleppo. However, the humanitarian corridors were repeatedly shelled by the Nusra Front , the US-backed Al Qaeda affiliate . The media decided to ignore this and report instead that the ceasefire’s failure was due to the withholding of aid by Russia and Syria . This is but one example of many where the Syrian government has been blamed for the rebel-sponsored terror inflicted on Syrian people. \n“His analysis uses an abstract, moral argument to violate Syria's self-determination.” \nAfter five years of war on Syria, it is a wonder how anyone could believe a word that comes from the mouths of the imperialist countries. They lied about the origins of the conflict. They have continuously blamed the Syrian government for events that have all been traced back to the armed proxies they support. This includes the Houla Massacre , the sarin gas attack in Ghouta, and the so-called starvation of Madaya . Aleppo is no different. The Syrian city has been under constant siege from NATO-backed terrorists. The terrorists are holding nearly 250,000 Syrians hostage in the Eastern side of war-torn Aleppo. This has been verified by journalists on the ground such as Vanessa Beeley . \nThese facts seem not to matter in Draitser's newfound assessment of Syria. His analysis uses an abstract, moral argument to violate Syria's self-determination. Calling those who unequivocally support the Syrian government \"fetishists\" assumes that the US left should take a position different from that of the Syrian people. Actual Syrians supported Bashar Al-Assad, and thus the Syrian Army, with 88.7 percent of the vote in the 2014 elections. To claim that the left in the US should fight for \"peace\" and at the same time oppose the Syrian government is an intentional attempt to remain neutral in a time of war. As Howard Zinn brilliantly stated, one cannot be neutral on a moving train. \nAnd the imperialist war against Syria is moving dangerously toward a World War III scenario. Hillary Clinton will be elected the next President of the United States and has repeatedly expressed that she will pursue a no-fly zone once in office. A no-fly zone would place Russian and Syrian military assets at risk of US-sponsored bombs and thus the world at risk of a global military confrontation not seen since World War II. How convenient it is then that Draitser should rebuke his former anti-imperialist stance in place of a stealth form of regime change. The world is on fire, yet Draitser has interpreted the situation as a chance to distort an already highly misunderstood situation . \n“Draister's conclusions ultimately reinforce the Western assumption that the left must come to the rescue and save the Syrian people from their plight.” \nPositions such as Draitser’s are ultimately shaped by the material conditions of an imperialist empire in crisis and decline. White supremacy has been a principle condition of US imperialism since its inception. The war machine and white supremacy are deeply connected. The peoples and nations on imperialism's hit-list are routinely depicted in a manner that justifies the need for US and Western military medicine. This notion has trickled down to the day-to-day actions of ordinary people, including what currently passes as the \"anti-war\" movement in the US today. \nDraister's conclusions ultimately reinforce the Western assumption that the left must come to the rescue and save the Syrian people from their plight. Indeed, the Syrian people need allies and the left must be organizing toward an end to the war. But an end to the war cannot be achieved unless the left supports the will of the Syrian people. At the moment, this means the US left must align itself with the Syrian government and its allies. The left must act with uncompromising dedication to the principle of self-determination in every case where US and Western imperialism wages wars of neo-colonial plunder. Syria should be no exception. \nOf course, this critique should not be seen as a personal attack on Draitser himself. His body of work reflects a deep commitment to the struggle against war and Empire. He has often taken positions on international questions that are deeply unpopular with the US imperialist order. However, when mistakes are made, the left has a responsibility to correct them. There is too much at stake. Failure to step up in defense of Syria means another regime, change scenario similar to what happened in Yugoslavia, Iraq, and Libya. Draitser's piece is a study into the path that all genuine anti-imperialists should avoid. \nBut what is the correct path forward? Imperialism is the unquestionable cause of the war in Syria, so imperialism must be the primary target of an anti-imperialist movement. The US and its allies are risking world war over Syria’s destruction. On the other side, the Syrian and Russian governments (along with Iran and China) are doing as much as they can to find a peaceful solution to the conflict that also respects Syria’s national sovereignty. It is without question that this is the side where the left ought to be in the continued struggle to end the war once and for all. Danny Haiphong is an Asian activist and political analyst in the Boston area. He can be reached at [email protected]",
		"thread_title": "Break the Silence or Support Self-Determination? In Syria, the Answer Should be Obvious",
		"title": "Break the Silence or Support Self-Determination? In Syria, the Answer Should be Obvious",
		"type": "bs",
		"uuid": "6ff05982c8c125fc5910403876ad49a3bf5e6ac0"
	},
	"-KhIkXT28abqE4yuJQVs": {
		"author": "Anonymous",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:47:49.499+02:00",
		"domain_rank": "",
		"entities": [
			{
				"name": "MOVE 9",
				"salience": 0.1493058,
				"type": "ORGANIZATION"
			},
			{
				"name": "MOVE 9",
				"salience": 0.13701594,
				"type": "OTHER"
			},
			{
				"name": "job",
				"salience": 0.052016888,
				"type": "OTHER"
			},
			{
				"name": "People",
				"salience": 0.032779768,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.025665494,
				"type": "PERSON"
			},
			{
				"name": "MOVE People",
				"salience": 0.022910852,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.018491061,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0dclg",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Philadelphia"
				},
				"name": "Philadelphia",
				"salience": 0.016339354,
				"type": "LOCATION"
			},
			{
				"name": "community",
				"salience": 0.014147813,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.013884113,
				"type": "PERSON"
			},
			{
				"name": "Cops",
				"salience": 0.012266455,
				"type": "PERSON"
			},
			{
				"name": "parole",
				"salience": 0.011730195,
				"type": "OTHER"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.0108646685,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.010482731,
				"type": "PERSON"
			},
			{
				"name": "John Straub",
				"salience": 0.010291646,
				"type": "PERSON"
			},
			{
				"name": "atrocity",
				"salience": 0.0095742205,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.00948449,
				"type": "PERSON"
			},
			{
				"name": "cops",
				"salience": 0.009467557,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0515p",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mumia_Abu-Jamal"
				},
				"name": "Mumia Abu Jamal",
				"salience": 0.009197201,
				"type": "PERSON"
			},
			{
				"name": "prisons",
				"salience": 0.009080765,
				"type": "LOCATION"
			},
			{
				"name": "prison",
				"salience": 0.009080765,
				"type": "LOCATION"
			},
			{
				"name": "Police",
				"salience": 0.008975904,
				"type": "PERSON"
			},
			{
				"name": "Move 9",
				"salience": 0.008936968,
				"type": "ORGANIZATION"
			},
			{
				"name": "hundreds",
				"salience": 0.008588463,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.008200993,
				"type": "PERSON"
			},
			{
				"name": "mentality",
				"salience": 0.008170573,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.007853101,
				"type": "PERSON"
			},
			{
				"name": "mass imprisonment",
				"salience": 0.0064148577,
				"type": "EVENT"
			},
			{
				"name": "adults",
				"salience": 0.0064148577,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01y80_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Parole"
				},
				"name": "Parole",
				"salience": 0.006055008,
				"type": "OTHER"
			},
			{
				"name": "You Speak Up for Yourself",
				"salience": 0.0058330004,
				"type": "WORK_OF_ART"
			},
			{
				"name": "People",
				"salience": 0.0056743356,
				"type": "PERSON"
			},
			{
				"name": "assault",
				"salience": 0.0055559315,
				"type": "EVENT"
			},
			{
				"name": "blogspot",
				"salience": 0.0055559315,
				"type": "OTHER"
			},
			{
				"name": "MOVE members",
				"salience": 0.0055559315,
				"type": "PERSON"
			},
			{
				"name": "city block",
				"salience": 0.0055559315,
				"type": "OTHER"
			},
			{
				"name": "slaves",
				"salience": 0.0054451786,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0054169786,
				"type": "WORK_OF_ART"
			},
			{
				"name": "man",
				"salience": 0.0049253292,
				"type": "PERSON"
			},
			{
				"name": "parole",
				"salience": 0.00483733,
				"type": "OTHER"
			},
			{
				"name": "parole board",
				"salience": 0.0044661136,
				"type": "ORGANIZATION"
			},
			{
				"name": "child",
				"salience": 0.004321849,
				"type": "PERSON"
			},
			{
				"name": "parole",
				"salience": 0.0040511712,
				"type": "OTHER"
			},
			{
				"name": "cops",
				"salience": 0.004002697,
				"type": "PERSON"
			},
			{
				"name": "The District Attorney",
				"salience": 0.003803669,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0037428222,
				"type": "LOCATION"
			},
			{
				"name": "attack",
				"salience": 0.0034543832,
				"type": "EVENT"
			},
			{
				"name": "parole board",
				"salience": 0.0033796283,
				"type": "ORGANIZATION"
			},
			{
				"name": "death",
				"salience": 0.0033796283,
				"type": "EVENT"
			},
			{
				"name": "People",
				"salience": 0.0033567164,
				"type": "PERSON"
			},
			{
				"name": "people",
				"salience": 0.0033567164,
				"type": "PERSON"
			},
			{
				"name": "fact",
				"salience": 0.0033007658,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0031506123,
				"type": "PERSON"
			},
			{
				"name": "threat",
				"salience": 0.0029863652,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0029267152,
				"type": "OTHER"
			},
			{
				"name": "community",
				"salience": 0.0029267152,
				"type": "OTHER"
			},
			{
				"name": "burning flames",
				"salience": 0.0028203556,
				"type": "OTHER"
			},
			{
				"name": "MOVE house",
				"salience": 0.0027367733,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.0027367733,
				"type": "LOCATION"
			},
			{
				"name": "release",
				"salience": 0.002642645,
				"type": "EVENT"
			},
			{
				"name": "reasons",
				"salience": 0.002642645,
				"type": "OTHER"
			},
			{
				"name": "back",
				"salience": 0.002642645,
				"type": "OTHER"
			},
			{
				"name": "house",
				"salience": 0.0026346561,
				"type": "LOCATION"
			},
			{
				"name": "cops",
				"salience": 0.0026346561,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.0026346561,
				"type": "LOCATION"
			},
			{
				"name": "cops",
				"salience": 0.0026346561,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.0026346561,
				"type": "LOCATION"
			},
			{
				"name": "Police",
				"salience": 0.0026346561,
				"type": "PERSON"
			},
			{
				"name": "prisons",
				"salience": 0.0025267852,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0023699435,
				"type": "EVENT"
			},
			{
				"name": "total",
				"salience": 0.0022884225,
				"type": "OTHER"
			},
			{
				"name": "front",
				"salience": 0.0022884225,
				"type": "OTHER"
			},
			{
				"name": "safety",
				"salience": 0.0022884225,
				"type": "OTHER"
			},
			{
				"name": "fiancé",
				"salience": 0.0022884225,
				"type": "PERSON"
			},
			{
				"name": "shooting",
				"salience": 0.0022884225,
				"type": "EVENT"
			},
			{
				"name": "folks",
				"salience": 0.0022884225,
				"type": "PERSON"
			},
			{
				"name": "house",
				"salience": 0.002234361,
				"type": "LOCATION"
			},
			{
				"name": "cops",
				"salience": 0.002234361,
				"type": "ORGANIZATION"
			},
			{
				"name": "house",
				"salience": 0.002234361,
				"type": "LOCATION"
			},
			{
				"name": "police",
				"salience": 0.002234361,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0021575002,
				"type": "LOCATION"
			},
			{
				"name": "evidence",
				"salience": 0.0020677075,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.0020522494,
				"type": "PERSON"
			},
			{
				"name": "one",
				"salience": 0.0020522494,
				"type": "PERSON"
			},
			{
				"name": "weaponry",
				"salience": 0.0020522494,
				"type": "OTHER"
			},
			{
				"name": "weapons",
				"salience": 0.0020522494,
				"type": "OTHER"
			},
			{
				"name": "bench warrants",
				"salience": 0.0020508163,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0020474738,
				"type": "PERSON"
			},
			{
				"name": "hundreds",
				"salience": 0.0020249793,
				"type": "PERSON"
			},
			{
				"name": "cop",
				"salience": 0.002000865,
				"type": "PERSON"
			},
			{
				"name": "bench warrants",
				"salience": 0.0019742774,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02r15x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Parole_board"
				},
				"name": "Parole Board",
				"salience": 0.0019702988,
				"type": "ORGANIZATION"
			},
			{
				"name": "adults",
				"salience": 0.0019494042,
				"type": "PERSON"
			},
			{
				"name": "police officer",
				"salience": 0.0019348301,
				"type": "PERSON"
			},
			{
				"name": "parole board",
				"salience": 0.0019348301,
				"type": "ORGANIZATION"
			},
			{
				"name": "deaths",
				"salience": 0.0019348301,
				"type": "EVENT"
			},
			{
				"name": "police officer",
				"salience": 0.0019348301,
				"type": "PERSON"
			},
			{
				"name": "deaths",
				"salience": 0.0019348301,
				"type": "EVENT"
			},
			{
				"name": "official",
				"salience": 0.0019348301,
				"type": "PERSON"
			},
			{
				"name": "babies",
				"salience": 0.0018921054,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0018754771,
				"type": "LOCATION"
			},
			{
				"name": "back",
				"salience": 0.001853004,
				"type": "OTHER"
			},
			{
				"name": "smoke bombs",
				"salience": 0.001853004,
				"type": "OTHER"
			},
			{
				"name": "MOVE child",
				"salience": 0.0018486917,
				"type": "PERSON"
			},
			{
				"name": "Joan Weimer",
				"salience": 0.0018406616,
				"type": "PERSON"
			},
			{
				"name": "The MOVE 9",
				"salience": 0.0018382873,
				"type": "WORK_OF_ART"
			},
			{
				"name": "home",
				"salience": 0.0017838434,
				"type": "LOCATION"
			},
			{
				"name": "release",
				"salience": 0.0017838434,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0017838434,
				"type": "LOCATION"
			},
			{
				"name": "reason",
				"salience": 0.0017838434,
				"type": "OTHER"
			},
			{
				"name": "court",
				"salience": 0.0017838434,
				"type": "LOCATION"
			},
			{
				"name": "murder",
				"salience": 0.0017838434,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0gg570x",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Loretta_Lynch"
				},
				"name": "Loretta Lynch",
				"salience": 0.001779704,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0016754313,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.0016754313,
				"type": "PERSON"
			},
			{
				"name": "cops",
				"salience": 0.001669198,
				"type": "OTHER"
			},
			{
				"name": "crane",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "premises",
				"salience": 0.0016045696,
				"type": "LOCATION"
			},
			{
				"name": "inferno",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "swat gear",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "type",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "frenzy",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "teeth",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "fire fighters",
				"salience": 0.0016045696,
				"type": "PERSON"
			},
			{
				"name": "tear gas",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "housing code violation",
				"salience": 0.0016045696,
				"type": "OTHER"
			},
			{
				"name": "deluge gun",
				"salience": 0.0016045696,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "bulldozer",
				"salience": 0.0016045696,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "prison",
				"salience": 0.0016008351,
				"type": "OTHER"
			},
			{
				"name": "kidnapping",
				"salience": 0.0015446767,
				"type": "EVENT"
			},
			{
				"name": "abuse",
				"salience": 0.0015446767,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0015446767,
				"type": "OTHER"
			},
			{
				"name": "rape",
				"salience": 0.0015446767,
				"type": "EVENT"
			},
			{
				"name": "bombing",
				"salience": 0.0015127514,
				"type": "EVENT"
			},
			{
				"name": "Facts",
				"salience": 0.0015127514,
				"type": "OTHER"
			},
			{
				"name": "radio",
				"salience": 0.0015127514,
				"type": "OTHER"
			},
			{
				"name": "judge",
				"salience": 0.0015127514,
				"type": "PERSON"
			},
			{
				"name": "investigation hearing",
				"salience": 0.0015127514,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.001491255,
				"type": "PERSON"
			},
			{
				"name": "mentality",
				"salience": 0.0014562842,
				"type": "OTHER"
			},
			{
				"name": "officials",
				"salience": 0.0014453949,
				"type": "PERSON"
			},
			{
				"name": "weapons charges",
				"salience": 0.0014315111,
				"type": "OTHER"
			},
			{
				"name": "idea",
				"salience": 0.0014315111,
				"type": "OTHER"
			},
			{
				"name": "responsibility",
				"salience": 0.0013956618,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0013099154,
				"type": "EVENT"
			},
			{
				"name": "force",
				"salience": 0.0013099154,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.0012637262,
				"type": "PERSON"
			},
			{
				"name": "lives",
				"salience": 0.0012515866,
				"type": "OTHER"
			},
			{
				"name": "cop",
				"salience": 0.0012515866,
				"type": "PERSON"
			},
			{
				"name": "judge",
				"salience": 0.001159075,
				"type": "PERSON"
			},
			{
				"name": "Ona Move",
				"salience": 0.0011473941,
				"type": "OTHER"
			},
			{
				"name": "Ali Hameli",
				"salience": 0.001141812,
				"type": "PERSON"
			},
			{
				"name": "Matter",
				"salience": 0.0011300456,
				"type": "OTHER"
			},
			{
				"name": "heartache",
				"salience": 0.0011300456,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0011300456,
				"type": "PERSON"
			},
			{
				"name": "murder",
				"salience": 0.0011300456,
				"type": "EVENT"
			},
			{
				"name": "women",
				"salience": 0.0011300456,
				"type": "PERSON"
			},
			{
				"name": "pain",
				"salience": 0.0011300456,
				"type": "OTHER"
			},
			{
				"name": "MOVE parent",
				"salience": 0.0011300456,
				"type": "PERSON"
			},
			{
				"name": "everybody",
				"salience": 0.0011158048,
				"type": "PERSON"
			},
			{
				"name": "HOMICIDES",
				"salience": 0.0010829992,
				"type": "ORGANIZATION"
			},
			{
				"name": "MOVE child",
				"salience": 0.0010058025,
				"type": "PERSON"
			},
			{
				"name": "children",
				"salience": 0.0010058025,
				"type": "PERSON"
			},
			{
				"name": "slave owners",
				"salience": 0.0009785078,
				"type": "PERSON"
			},
			{
				"name": "ears",
				"salience": 0.0009785078,
				"type": "OTHER"
			},
			{
				"name": "person",
				"salience": 0.0009785078,
				"type": "PERSON"
			},
			{
				"name": "suffering",
				"salience": 0.0009785078,
				"type": "EVENT"
			},
			{
				"name": "Things",
				"salience": 0.0009785078,
				"type": "OTHER"
			},
			{
				"name": "investigation",
				"salience": 0.00095828046,
				"type": "EVENT"
			},
			{
				"name": "lives",
				"salience": 0.0009115144,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0009081224,
				"type": "PERSON"
			},
			{
				"name": "prison",
				"salience": 0.0008709208,
				"type": "LOCATION"
			},
			{
				"name": "petition",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "imprisonment",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "injustice",
				"salience": 0.0008229887,
				"type": "OTHER"
			},
			{
				"name": "protest",
				"salience": 0.0008229887,
				"type": "EVENT"
			},
			{
				"name": "deaths",
				"salience": 0.0007863365,
				"type": "EVENT"
			},
			{
				"name": "Justice Dept",
				"salience": 0.000766327,
				"type": "ORGANIZATION"
			},
			{
				"name": "understanding",
				"salience": 0.0007126172,
				"type": "OTHER"
			},
			{
				"name": "necessity",
				"salience": 0.0007126172,
				"type": "OTHER"
			},
			{
				"name": "guilt",
				"salience": 0.0007126172,
				"type": "OTHER"
			},
			{
				"name": "Black Men, Women, and Children",
				"salience": 0.00069548964,
				"type": "ORGANIZATION"
			},
			{
				"name": "difference",
				"salience": 0.00068601023,
				"type": "OTHER"
			},
			{
				"name": "lives",
				"salience": 0.00068087934,
				"type": "OTHER"
			},
			{
				"name": "city",
				"salience": 0.00068087934,
				"type": "LOCATION"
			},
			{
				"name": "family",
				"salience": 0.00068087934,
				"type": "PERSON"
			},
			{
				"name": "cop",
				"salience": 0.00068087934,
				"type": "PERSON"
			},
			{
				"name": "world",
				"salience": 0.00068087934,
				"type": "LOCATION"
			},
			{
				"name": "killings",
				"salience": 0.00066882634,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "United States",
				"salience": 0.0006670116,
				"type": "LOCATION"
			},
			{
				"name": "world",
				"salience": 0.00063098385,
				"type": "LOCATION"
			},
			{
				"name": "protest",
				"salience": 0.0006147482,
				"type": "EVENT"
			},
			{
				"name": "everybody",
				"salience": 0.0006147482,
				"type": "PERSON"
			},
			{
				"name": "injustice",
				"salience": 0.0006147482,
				"type": "OTHER"
			},
			{
				"name": "nothing",
				"salience": 0.0006147482,
				"type": "OTHER"
			},
			{
				"name": "pain",
				"salience": 0.0006147482,
				"type": "OTHER"
			},
			{
				"name": "MOVE parent",
				"salience": 0.0006147482,
				"type": "PERSON"
			},
			{
				"name": "grand jury",
				"salience": 0.0005322991,
				"type": "PERSON"
			},
			{
				"name": "experts",
				"salience": 0.0005322991,
				"type": "PERSON"
			},
			{
				"name": "report",
				"salience": 0.0005322991,
				"type": "WORK_OF_ART"
			},
			{
				"name": "baby",
				"salience": 0.0005322991,
				"type": "PERSON"
			},
			{
				"name": "proof",
				"salience": 0.0005322991,
				"type": "OTHER"
			},
			{
				"name": "The Petition",
				"salience": 0.0005064909,
				"type": "WORK_OF_ART"
			},
			{
				"name": "Https://causes.com/92454-free-the-move-9",
				"salience": 0.00043855893,
				"type": "OTHER"
			},
			{
				"name": "MOVE Conference",
				"salience": 0.00043855893,
				"type": "EVENT"
			},
			{
				"name": "Claus Speth",
				"salience": 0.00032758006,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T06:09:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 23.1,
			"score": -0.1
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget by MOVE People \nThe Philadelphia-based MOVE family was horribly victimized by police in 1978 and 1985. The first atrocity led to the mass imprisonment of MOVE members; the second assault killed five adults and six children and burned down a city block. No cops have ever been punished, but the MOVE 9 remain in prison, and were this year once again denied parole. “They couldn't kill us that day, so they are trying to finish the job in these prisons.” “When You Speak Up for the MOVE 9, You Speak Up for Yourself” by MOVE People \nThis article previously appeared on Move 9 blogspot . \n“The District Attorney never proved MOVE had killed a police officer.” \nThe MOVE 9 Have been eligible for Parole since August 2008, After being in prison for 30 years. We have repeatedly been denied. In June of this year (2016) , we were denied parole again , for a total of ten years past the time we should have been released. One of the reasons the parole board gave to justify not releasing us is that we are a threat to the safety of the community. This is not true. People are not afraid of MOVE People. Move People ain't strangling people to death, shooting people in the back. It ain't MOVE that killed a man in front of his fiancé and four year old child. MOVE is not drive by shooting, or terrorizing folks in the community. It's the community who is faxing, emailing, and calling the parole board asking for our release on parole. \nIt is the Parole Board and D.A. John Straub who continue to deny our release for no valid reason. On August 8th 1978, hundreds of cops attacked our home at 3:00am in the morning trying to kill us. They couldn't kill us that day, so they are trying to finish the job in these prisons but understand: John Straub and the Parole Board are not justified. MOVE did not go out to the Police's house to do them harm. The Cops came to our house, because a judge sent them to our house to serve bench warrants for not appearing in court not for rape, murder, kidnapping or abuse but for not appearing in court for a civil matter. Understand this: hundreds of cops were sent to our home, while we were asleep, dressed in swat gear, armed with all type of weaponry, semi -automatic weapons, fire fighters, smoke bombs, tear gas, a deluge gun, a crane and a bulldozer to serve bench warrants, for a housing code violation. \n“Move People ain't strangling people to death, shooting people in the back.” \nIt was the Police who came to Move’s premises. They came armed to the teeth and in their frenzy to kill MOVE, they killed one of their own, and condemned us for it. We are not making this up. The evidence is clear. \nThe whole world witnessed the attack on the MOVE house May 13th 1985, where the house was bombed into a blazing inferno, the six adults were shot and killed and the five children were shot back into the house by police as they tried to escape the burning flames where they died . These are proven Facts. During the city’s investigation hearing, it was ruled that the cops used excessive force and the killings were wrongful deaths. Those children were our children in that house that day, yet not one cop or official connected to the bombing of our family were held accountable, responsible for these deaths like the parole board is telling The MOVE 9 we have to take responsibility for a crime when the District Attorney never proved MOVE had killed a police officer. \nWe have no weapons charges and the judge admitted on public radio to the caller, Mumia Abu Jamal [a radio journalist at the time], that he didn't have the faintest idea who shot the police officer. It's a fact that world renowned forensic experts Dr. Ali Hameli and Claus Speth ruled the deaths of the children HOMICIDES in a scathing report against the city, submitted to the assistant District Attorney Joan Weimer, but the grand jury did nothing. \n“It's time for everybody to start speaking freely in protest of all this free wheeling injustice.” \nThe Move 9 have spent almost 40 years in prison for killing a cop, with no real proof. The whole world saw the Philadelphia police murder our children and family, and they have not spent a day in prison for it. But, what is the difference in these lives? Does a MOVE child not bleed, when they are shot? Does a MOVE parent not feel pain when their baby is killed, just because they are not cops or officials? Does the murder of a MOVE child, the pain of MOVE parent, the heartache of a black person's suffering still fall on deaf ears like the slaves who cried out when their babies, women and men were sold, killed, and whipped by slave owners? Ask yourself. Things may seem to have changed since those awful days, but the mentality is still very much existing. \nJust look around and listen. Black lives (Don't) Matter. That's why these cops are getting away with killing Black Men, Women, and Children. That's why The MOVE 9 are still in prison almost 40 years for killing a cop, and the cops responsible for killing 11 MOVE people, five of them children, are walking around like they are clean and without guilt. It's the mentality that makes them feel nothing after killing people. Because to them MOVE lives (Don't) matter. It's time for everybody to start speaking freely in protest of all this free wheeling injustice. People must understand this necessity of speaking out now. \nWe are asking for people to sign The Petition we have aimed at United States Attorney General Loretta Lynch demanding that The United States Justice Dept open up an investigation into the ongoing and wrongful imprisonment of The MOVE 9. People can sign the petition at Https://causes.com/92454-free-the-move-9 . Speak out with the understanding that when speaking of MOVE, you are speaking up for yourself. It can't get better for MOVE without getting better for you. \nLooking Forward To The May 2017 MOVE Conference In Philadelphia. \nOna Move",
		"thread_title": "“When You Speak Up for the MOVE 9, You Speak Up for Yourself”",
		"title": "“When You Speak Up for the MOVE 9, You Speak Up for Yourself”",
		"type": "bs",
		"uuid": "f005b911b6a198681e5e4189615415521efc7a6b"
	},
	"-KhIkY2jHWXaFHzf-jkZ": {
		"author": "Anonymous",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:47:49.819+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/0d06m5",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hillary_Clinton"
				},
				"name": "Hillary Clinton",
				"salience": 0.5997726,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d075m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_Party_(United_States)"
				},
				"name": "Democratic Party",
				"salience": 0.053985633,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.023550639,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02mjmr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Barack_Obama"
				},
				"name": "Barrack Obama",
				"salience": 0.014433671,
				"type": "PERSON"
			},
			{
				"name": "response",
				"salience": 0.01294602,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.012549072,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/01_gbv",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Bernie_Sanders"
				},
				"name": "Bernie Sanders",
				"salience": 0.012265948,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0cqt90",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Donald_Trump"
				},
				"name": "Donald Trump",
				"salience": 0.011320825,
				"type": "PERSON"
			},
			{
				"name": "whims",
				"salience": 0.00932638,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.008986564,
				"type": "PERSON"
			},
			{
				"name": "nationalism",
				"salience": 0.007987731,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/07wbk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Republican_Party_(United_States)"
				},
				"name": "Republicans",
				"salience": 0.0077164453,
				"type": "ORGANIZATION"
			},
			{
				"name": "country",
				"salience": 0.0062518436,
				"type": "LOCATION"
			},
			{
				"name": "campaign",
				"salience": 0.0057836627,
				"type": "EVENT"
			},
			{
				"name": "Lesseroftwoevilism",
				"salience": 0.0056863767,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0047848416,
				"type": "OTHER"
			},
			{
				"name": "apparatus",
				"salience": 0.004289263,
				"type": "OTHER"
			},
			{
				"name": "life",
				"salience": 0.0041504093,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02j71",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Earth"
				},
				"name": "Earth",
				"salience": 0.0039127944,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "Americans",
				"salience": 0.0037487634,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/081sq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/White_House"
				},
				"name": "White House",
				"salience": 0.0034722176,
				"type": "LOCATION"
			},
			{
				"name": "demon",
				"salience": 0.0033370408,
				"type": "OTHER"
			},
			{
				"name": "Matt Sedillo",
				"salience": 0.0032183046,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/01p47r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Scott_Baio"
				},
				"name": "Scott Baio",
				"salience": 0.0027770135,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.00273728,
				"type": "PERSON"
			},
			{
				"name": "duopoly electoral system",
				"salience": 0.002468362,
				"type": "OTHER"
			},
			{
				"name": "hawks",
				"salience": 0.0022965374,
				"type": "OTHER"
			},
			{
				"name": "LesserOfTwoEvilism",
				"salience": 0.0022965374,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.0022965374,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0022965374,
				"type": "ORGANIZATION"
			},
			{
				"name": "lesseroftwoevilism",
				"salience": 0.0022965374,
				"type": "OTHER"
			},
			{
				"name": "rainbow coalition",
				"salience": 0.00212179,
				"type": "ORGANIZATION"
			},
			{
				"name": "peacenik",
				"salience": 0.0020412416,
				"type": "OTHER"
			},
			{
				"name": "primaries",
				"salience": 0.0019159504,
				"type": "EVENT"
			},
			{
				"name": "blood",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.0019159504,
				"type": "PERSON"
			},
			{
				"name": "question",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "script",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "twitter feuds",
				"salience": 0.0019159504,
				"type": "OTHER"
			},
			{
				"name": "talk",
				"salience": 0.0018458114,
				"type": "OTHER"
			},
			{
				"name": "menagerie",
				"salience": 0.0017677722,
				"type": "OTHER"
			},
			{
				"name": "promises",
				"salience": 0.0016804059,
				"type": "OTHER"
			},
			{
				"name": "wing",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "election run",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "warmongers",
				"salience": 0.0016592466,
				"type": "PERSON"
			},
			{
				"name": "hypocrisy",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "doctrine",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "season",
				"salience": 0.0016592466,
				"type": "EVENT"
			},
			{
				"name": "savior",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "downtrodden",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "point",
				"salience": 0.0016592466,
				"type": "OTHER"
			},
			{
				"name": "eugenicist billionaire",
				"salience": 0.0014708136,
				"type": "PERSON"
			},
			{
				"name": "party",
				"salience": 0.0013772891,
				"type": "ORGANIZATION"
			},
			{
				"name": "reflection",
				"salience": 0.0013721674,
				"type": "OTHER"
			},
			{
				"name": "war maker",
				"salience": 0.0013547164,
				"type": "ORGANIZATION"
			},
			{
				"name": "threat",
				"salience": 0.0012187578,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0011465868,
				"type": "OTHER"
			},
			{
				"name": "warlords",
				"salience": 0.0011465868,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05b60g4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_R._Allen"
				},
				"name": "John Allen",
				"salience": 0.0011275925,
				"type": "PERSON"
			},
			{
				"name": "war criminal",
				"salience": 0.0010717912,
				"type": "PERSON"
			},
			{
				"name": "vision",
				"salience": 0.001010069,
				"type": "OTHER"
			},
			{
				"name": "Much",
				"salience": 0.0010090523,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0010090523,
				"type": "OTHER"
			},
			{
				"name": "country",
				"salience": 0.0010090523,
				"type": "LOCATION"
			},
			{
				"name": "electorate",
				"salience": 0.0010090523,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.0010090523,
				"type": "OTHER"
			},
			{
				"name": "campaign",
				"salience": 0.0009458137,
				"type": "EVENT"
			},
			{
				"name": "secretary of state",
				"salience": 0.0009281145,
				"type": "PERSON"
			},
			{
				"name": "life",
				"salience": 0.0008737807,
				"type": "OTHER"
			},
			{
				"name": "planet",
				"salience": 0.0008737807,
				"type": "LOCATION"
			},
			{
				"name": "democracy",
				"salience": 0.00087113853,
				"type": "OTHER"
			},
			{
				"name": "attack",
				"salience": 0.000847505,
				"type": "EVENT"
			},
			{
				"name": "lesseroftwoevilism",
				"salience": 0.00082268903,
				"type": "OTHER"
			},
			{
				"name": "threat",
				"salience": 0.00082268903,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00081705494,
				"type": "OTHER"
			},
			{
				"name": "nations",
				"salience": 0.0008165381,
				"type": "OTHER"
			},
			{
				"name": "process",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"name": "candidate",
				"salience": 0.00078894466,
				"type": "PERSON"
			},
			{
				"name": "generation",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00078894466,
				"type": "PERSON"
			},
			{
				"name": "primary",
				"salience": 0.00078894466,
				"type": "EVENT"
			},
			{
				"name": "direction",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"name": "zombie apocalypse",
				"salience": 0.00078894466,
				"type": "EVENT"
			},
			{
				"name": "future",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"name": "direction",
				"salience": 0.00078894466,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/09c7w0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States"
				},
				"name": "American",
				"salience": 0.0007721607,
				"type": "LOCATION"
			},
			{
				"name": "call",
				"salience": 0.0007278827,
				"type": "OTHER"
			},
			{
				"name": "words",
				"salience": 0.00072641287,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/06bnz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Russia"
				},
				"name": "Russian",
				"salience": 0.0007188087,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00070750905,
				"type": "LOCATION"
			},
			{
				"name": "advocates",
				"salience": 0.0006949881,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.000692448,
				"type": "LOCATION"
			},
			{
				"name": "inkling",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "decency",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "platform",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "self interest",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "means",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "coronation",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "cult leader",
				"salience": 0.0006831658,
				"type": "PERSON"
			},
			{
				"name": "phrases",
				"salience": 0.0006831658,
				"type": "OTHER"
			},
			{
				"name": "much",
				"salience": 0.0006810997,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0006736658,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00066702254,
				"type": "OTHER"
			},
			{
				"name": "all",
				"salience": 0.00066702254,
				"type": "OTHER"
			},
			{
				"name": "matter",
				"salience": 0.0006631596,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.0006631596,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.0006631596,
				"type": "OTHER"
			},
			{
				"name": "theme",
				"salience": 0.0006631596,
				"type": "OTHER"
			},
			{
				"name": "partners",
				"salience": 0.00063970237,
				"type": "ORGANIZATION"
			},
			{
				"name": "assassination",
				"salience": 0.0006290143,
				"type": "EVENT"
			},
			{
				"name": "government officials",
				"salience": 0.0006290143,
				"type": "PERSON"
			},
			{
				"name": "convention",
				"salience": 0.0006204626,
				"type": "EVENT"
			},
			{
				"name": "unity",
				"salience": 0.000612644,
				"type": "OTHER"
			},
			{
				"name": "peoples",
				"salience": 0.000612644,
				"type": "PERSON"
			},
			{
				"name": "convention",
				"salience": 0.000612644,
				"type": "EVENT"
			},
			{
				"name": "response",
				"salience": 0.000612644,
				"type": "OTHER"
			},
			{
				"name": "connection",
				"salience": 0.0005942177,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0005897742,
				"type": "PERSON"
			},
			{
				"name": "planet",
				"salience": 0.0005897742,
				"type": "LOCATION"
			},
			{
				"name": "life",
				"salience": 0.0005897742,
				"type": "OTHER"
			},
			{
				"name": "power",
				"salience": 0.0005897742,
				"type": "OTHER"
			},
			{
				"name": "horror show",
				"salience": 0.0005867297,
				"type": "WORK_OF_ART"
			},
			{
				"name": "country",
				"salience": 0.0005775838,
				"type": "LOCATION"
			},
			{
				"name": "ideology",
				"salience": 0.00056736125,
				"type": "OTHER"
			},
			{
				"name": "group",
				"salience": 0.0005648269,
				"type": "PERSON"
			},
			{
				"name": "visions",
				"salience": 0.00056021154,
				"type": "OTHER"
			},
			{
				"name": "men",
				"salience": 0.0005577091,
				"type": "PERSON"
			},
			{
				"name": "home",
				"salience": 0.0005531519,
				"type": "LOCATION"
			},
			{
				"name": "proceedings",
				"salience": 0.0005531519,
				"type": "EVENT"
			},
			{
				"name": "borders",
				"salience": 0.0005531519,
				"type": "LOCATION"
			},
			{
				"name": "borders",
				"salience": 0.0005531519,
				"type": "PERSON"
			},
			{
				"name": "chants",
				"salience": 0.0005531519,
				"type": "OTHER"
			},
			{
				"name": "most",
				"salience": 0.0005531519,
				"type": "OTHER"
			},
			{
				"name": "attendance",
				"salience": 0.0005531519,
				"type": "OTHER"
			},
			{
				"name": "anthem",
				"salience": 0.00055068097,
				"type": "OTHER"
			},
			{
				"name": "copy",
				"salience": 0.00055068097,
				"type": "OTHER"
			},
			{
				"name": "cold war",
				"salience": 0.00054190296,
				"type": "EVENT"
			},
			{
				"name": "theme",
				"salience": 0.00054137537,
				"type": "OTHER"
			},
			{
				"name": "future",
				"salience": 0.0005325021,
				"type": "OTHER"
			},
			{
				"name": "culture",
				"salience": 0.0005325021,
				"type": "OTHER"
			},
			{
				"name": "lands",
				"salience": 0.0005325021,
				"type": "LOCATION"
			},
			{
				"name": "bombs",
				"salience": 0.0005325021,
				"type": "OTHER"
			},
			{
				"name": "presidency",
				"salience": 0.000521165,
				"type": "OTHER"
			},
			{
				"name": "War",
				"salience": 0.0005021978,
				"type": "EVENT"
			},
			{
				"name": "people",
				"salience": 0.00050013326,
				"type": "PERSON"
			},
			{
				"name": "unity",
				"salience": 0.00050013326,
				"type": "OTHER"
			},
			{
				"name": "force",
				"salience": 0.0004850897,
				"type": "OTHER"
			},
			{
				"name": "strength",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "inclusion",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "slave labor",
				"salience": 0.0004789764,
				"type": "PERSON"
			},
			{
				"name": "family",
				"salience": 0.0004789764,
				"type": "PERSON"
			},
			{
				"name": "course",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "contrast",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "mariachi garb",
				"salience": 0.0004789764,
				"type": "LOCATION"
			},
			{
				"name": "movements",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "ideas",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "tent",
				"salience": 0.0004789764,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "variation",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "audience",
				"salience": 0.0004789764,
				"type": "PERSON"
			},
			{
				"name": "millions",
				"salience": 0.0004789764,
				"type": "PERSON"
			},
			{
				"name": "mood",
				"salience": 0.0004789764,
				"type": "OTHER"
			},
			{
				"name": "politics",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "practices",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "basket",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "deplorables",
				"salience": 0.00046109472,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "war machine",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "elements",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "mayhem",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "sleep",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "murder",
				"salience": 0.00046109472,
				"type": "EVENT"
			},
			{
				"name": "children",
				"salience": 0.00046109472,
				"type": "PERSON"
			},
			{
				"name": "collateral damage",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "seat",
				"salience": 0.00046109472,
				"type": "OTHER"
			},
			{
				"name": "chant",
				"salience": 0.00045732674,
				"type": "OTHER"
			},
			{
				"name": "America America",
				"salience": 0.00045501415,
				"type": "WORK_OF_ART"
			},
			{
				"name": "flag",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"name": "allegiance",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"name": "faith",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"name": "flag",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"name": "globe",
				"salience": 0.00045156322,
				"type": "LOCATION"
			},
			{
				"name": "home",
				"salience": 0.00045156322,
				"type": "LOCATION"
			},
			{
				"name": "faith",
				"salience": 0.00045156322,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/053f8h",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Tim_Kaine"
				},
				"name": "Tim Kaine",
				"salience": 0.00044267616,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/025s5v9",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Michelle_Obama"
				},
				"name": "Michelle Obama",
				"salience": 0.0004354609,
				"type": "PERSON"
			},
			{
				"name": "much",
				"salience": 0.00043145363,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00043145363,
				"type": "EVENT"
			},
			{
				"name": "demon",
				"salience": 0.00042822692,
				"type": "OTHER"
			},
			{
				"name": "Mexico Will Pay",
				"salience": 0.0004204752,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/g/11bw1_6lwn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Make_America_Great_Again"
				},
				"name": "Make America Great Again",
				"salience": 0.0004204752,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/041m_j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Election_Day_(United_States)"
				},
				"name": "Election Day",
				"salience": 0.0004204752,
				"type": "EVENT"
			},
			{
				"name": "campaign",
				"salience": 0.00040440337,
				"type": "EVENT"
			},
			{
				"name": "will",
				"salience": 0.0003980525,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0jm64",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Atlanta_Hawks"
				},
				"name": "Hawks",
				"salience": 0.00039292092,
				"type": "ORGANIZATION"
			},
			{
				"name": "gender orientation",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "background",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "values",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "abilities",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "uniform",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "man",
				"salience": 0.00039100656,
				"type": "PERSON"
			},
			{
				"name": "woman",
				"salience": 0.00039100656,
				"type": "PERSON"
			},
			{
				"name": "friends",
				"salience": 0.00039100656,
				"type": "PERSON"
			},
			{
				"name": "allies",
				"salience": 0.00039100656,
				"type": "ORGANIZATION"
			},
			{
				"name": "battlefield",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "capitals",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "creed",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "ethnicity",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "union",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "projection",
				"salience": 0.00039100656,
				"type": "OTHER"
			},
			{
				"name": "race",
				"salience": 0.00039100656,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0003896844,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0003896844,
				"type": "EVENT"
			},
			{
				"name": "war",
				"salience": 0.0003896844,
				"type": "EVENT"
			},
			{
				"name": "Rainbow Coalition",
				"salience": 0.000381876,
				"type": "ORGANIZATION"
			},
			{
				"name": "presidency",
				"salience": 0.00037955376,
				"type": "OTHER"
			},
			{
				"name": "class",
				"salience": 0.00037955376,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02d2xb",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Democratic_National_Convention"
				},
				"name": "Democratic National Convention",
				"salience": 0.00037706306,
				"type": "EVENT"
			},
			{
				"metadata": {
					"mid": "/m/0432mrk",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Indigenous_peoples_of_the_Americas"
				},
				"name": "Native American",
				"salience": 0.00037548452,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07sdd",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_States_Constitution"
				},
				"name": "Constitution",
				"salience": 0.00034044197,
				"type": "WORK_OF_ART"
			},
			{
				"name": "words",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "war talk",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "conflict",
				"salience": 0.00033730885,
				"type": "EVENT"
			},
			{
				"name": "conspiracy",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "attention",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "government",
				"salience": 0.00033730885,
				"type": "ORGANIZATION"
			},
			{
				"name": "conflict",
				"salience": 0.00033730885,
				"type": "EVENT"
			},
			{
				"name": "obliteration",
				"salience": 0.00033730885,
				"type": "OTHER"
			},
			{
				"name": "election",
				"salience": 0.00033478605,
				"type": "EVENT"
			},
			{
				"name": "any",
				"salience": 0.00030112997,
				"type": "OTHER"
			},
			{
				"name": "Sebastian De La Cruz",
				"salience": 0.000294784,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0198fr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Khan_(title)"
				},
				"name": "Khan",
				"salience": 0.000294784,
				"type": "PERSON"
			},
			{
				"name": "si se puede",
				"salience": 0.000294784,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/03lt8g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Eva_Longoria"
				},
				"name": "Eva Longoria",
				"salience": 0.000294784,
				"type": "PERSON"
			},
			{
				"name": "aggression",
				"salience": 0.000292071,
				"type": "OTHER"
			},
			{
				"name": "surprise",
				"salience": 0.000292071,
				"type": "OTHER"
			},
			{
				"name": "anyone",
				"salience": 0.000292071,
				"type": "PERSON"
			},
			{
				"name": "land dispute",
				"salience": 0.000292071,
				"type": "EVENT"
			},
			{
				"name": "someone",
				"salience": 0.000292071,
				"type": "PERSON"
			},
			{
				"name": "will",
				"salience": 0.0002898865,
				"type": "OTHER"
			},
			{
				"name": "Nations",
				"salience": 0.00028139495,
				"type": "LOCATION"
			},
			{
				"name": "nationalist",
				"salience": 0.00028139495,
				"type": "PERSON"
			},
			{
				"name": "nation",
				"salience": 0.00028139495,
				"type": "LOCATION"
			},
			{
				"name": "nation",
				"salience": 0.00028139495,
				"type": "LOCATION"
			},
			{
				"name": "thousands",
				"salience": 0.0002776218,
				"type": "PERSON"
			},
			{
				"name": "alternative",
				"salience": 0.00027412258,
				"type": "OTHER"
			},
			{
				"name": "war hawk",
				"salience": 0.00027292955,
				"type": "PERSON"
			},
			{
				"name": "apocalypse",
				"salience": 0.00024564628,
				"type": "EVENT"
			},
			{
				"name": "twitter feuds",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "script",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "question",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "bombs",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "fire",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "blood",
				"salience": 0.00024564628,
				"type": "OTHER"
			},
			{
				"name": "speeches",
				"salience": 0.00024454875,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/01336l",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Asian_American"
				},
				"name": "Asian",
				"salience": 0.00024063748,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/025rpb0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Hispanic_and_Latino_Americans"
				},
				"name": "Latino",
				"salience": 0.00024063748,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0d0kn",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Georgia_(country)"
				},
				"name": "Georgian",
				"salience": 0.0002367134,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/07t21",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ukraine"
				},
				"name": "Ukrainian",
				"salience": 0.0002367134,
				"type": "LOCATION"
			},
			{
				"name": "country",
				"salience": 0.00023470531,
				"type": "LOCATION"
			},
			{
				"name": "racket",
				"salience": 0.00022662716,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "hawks",
				"salience": 0.00021998837,
				"type": "OTHER"
			},
			{
				"name": "sky",
				"salience": 0.0002126998,
				"type": "LOCATION"
			},
			{
				"name": "death",
				"salience": 0.0002126998,
				"type": "EVENT"
			},
			{
				"name": "desire",
				"salience": 0.0002126998,
				"type": "OTHER"
			},
			{
				"name": "rhetoric",
				"salience": 0.0002126998,
				"type": "OTHER"
			},
			{
				"name": "email",
				"salience": 0.0002126998,
				"type": "WORK_OF_ART"
			},
			{
				"name": "rainbow coalition",
				"salience": 0.00020322602,
				"type": "ORGANIZATION"
			},
			{
				"name": "peoples",
				"salience": 0.00020322602,
				"type": "PERSON"
			},
			{
				"name": "message",
				"salience": 0.00018499816,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00018348609,
				"type": "LOCATION"
			},
			{
				"name": "globe",
				"salience": 0.00018348609,
				"type": "LOCATION"
			},
			{
				"name": "peace",
				"salience": 0.00018348609,
				"type": "OTHER"
			},
			{
				"name": "world",
				"salience": 0.00018348609,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/03shp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Iran"
				},
				"name": "Iranians",
				"salience": 0.0001797446,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03spz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Israel"
				},
				"name": "Israel",
				"salience": 0.0001797446,
				"type": "LOCATION"
			},
			{
				"name": "Ghadaffi",
				"salience": 0.0001797446,
				"type": "PERSON"
			},
			{
				"name": "neo-Mcarthyite",
				"salience": 0.0001797446,
				"type": "LOCATION"
			},
			{
				"name": "Ossetia",
				"salience": 0.0001797446,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/0d05l6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/God"
				},
				"name": "God",
				"salience": 0.00016869805,
				"type": "PERSON"
			},
			{
				"name": "persons",
				"salience": 0.00015887569,
				"type": "PERSON"
			},
			{
				"name": "hope",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "liberty",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "might",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "humanity",
				"salience": 0.00015887569,
				"type": "PERSON"
			},
			{
				"name": "empire",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "reason",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"name": "apologies",
				"salience": 0.00015887569,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/060d2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/President_of_the_United_States"
				},
				"name": "President of the United States of America",
				"salience": 0.00013538124,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d3qd0",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Kerry"
				},
				"name": "John Kerry",
				"salience": 0.00012600767,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/014vk4",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Condoleezza_Rice"
				},
				"name": "Condoleezza Rice",
				"salience": 0.00012600767,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0203v",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Colin_Powell"
				},
				"name": "Colin Powell",
				"salience": 0.00012506508,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/022r9r",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Mike_Pence"
				},
				"name": "Mike Pence",
				"salience": 0.000105503175,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0_5vr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Madeleine_Albright"
				},
				"name": "Madeleine Albright",
				"salience": 0.00009777074,
				"type": "PERSON"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T05:59:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 24.6,
			"score": 0
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "2016 presidential campaign by Matt Sedillo \nHillary Clinton is, no doubt, a threat to life on Earth. But the duopoly electoral system is a menagerie of warmongers. “The response to the white nationalism of Donald Trump has been the rainbow coalition of hawks.” Barack Obama has proven an awesomely prolific war maker. Bernie Sanders is no peacenik. “It is only the white nationalist orange demon -- guided only by his own whims and twitter feuds -- that is at all off script on this question.” LesserOfTwoEvilism by Matt Sedillo \n“ So long as there is a ruling class they shall rule by fire and blood.” \nThe loathsome and shameless hypocrisy of the Democratic Party and the doctrine of lesseroftwoevilism has been laid bare this political season. This same Democratic Party that unquestionably rigged the primaries against the left-leaning Bernie Sanders campaign is now selling itself to the public as the savior of the downtrodden from the threat of an uber right wing candidate. \nHillary Clinton at this point in her election run appears to be making no promises to the public other than to not to physically morph into Donald Trump during her coronation come Election Day. \nLesseroftwoevilism is a bankrupt political ideology and the means by which the Democratic Party deadens any inkling towards decency or rational self interest that may lay dormant in the American electorate. Hillary Clinton and the Democratic Party intend to use the platform of \"at least not being Donald Trump\" to install the most despised Democratic candidate in a generation into the White House. \nIt is indeed horrifying that a straight up eugenicist billionaire who brags about sexual assaulting women won the Republican primary. It is terrifying that the cult leader of a white nationalist zombie apocalypse has gotten this far through the electoral process. \n“There is no greater threat to the future of much of life on the planet than Hillary Clinton.” \nThe country is polarizing and it is terrifying to see that much of it is polarizing in the direction of Donald Trump whose campaign is defined by phrases like “Make America Great Again” quickly followed by “Mexico Will Pay.” Much of the country is also polarized in the direction of Bernie Sanders. It was the political apparatus of the Democratic Party, not the Republicans, that prevented these two competing visions from standing before the American public. \nSetting aside the fact, for a moment, that we don't live in a democracy, it must be noted that lesseroftwoevilism in American politics is an ideology by Americans for Americans. Hillary Clinton, Donald Trump, AND Bernie Sanders are all advocates of the US war machine. If any of these three warlords were to sit in the seat of power children in far off lands would still be bombed in their sleep and be reported on as collateral damage. \nHillary Clinton is the most bloodthirsty advocate for murder and mayhem in a political system that thrives upon such practices. When it comes to dropping bombs, obliterating nations or possibly igniting a nuclear winter there is no greater threat to the future of much of life on the planet than Hillary Clinton. \nRainbow Coalition of Hawks \nFar beyond a “basket of deplorables,” the 2016 Republican national convention was a ghastly horror show of the most reactionary, bigoted elements of American political culture. Less than esteemed actor Scott Baio captured the mood when he proclaimed, “so of course let’s make America great again, but let’s make America America again.” That largely captured the theme of the proceedings and most speeches were some variation upon that theme. \nThe Democrats in response sought to make their convention a big tent of peoples, ideas and movements. And indeed from the spontaneous chants of “black lives matter” to Tim Kaine leading a chant of “si se puede” to Eva Longoria reminding the audience “we didn’t cross the borders the borders crossed us” to Michelle Obama letting the thousands in attendance and the millions watching at home know that slave labor built the White House and the country, from Sebastian De La Cruz singing the national anthem in full mariachi garb to the Khan family holding a copy of the Constitution, the Democratic National Convention did present itself as a stark contrast to what the GOP was offering. \nThe theme of inclusion ran high and, indeed, current president Barack Obama made his call for strength in unity, explicitly saying “And most of all I see Americans of every party, every background, every faith who believe we are stronger together, black white, Latino, Asian, Native American, young, old, gay, straight, men, women, folks with different abilities, all pledging allegiance, under the same proud flag, to this big bold country that we love.” One flag to rule them all. \n“America the greatest and most diverse nation on Earth shall ransack the globe as it sees fit. ” \nGeneral John Allen, standing before a multi ethnic group of people continued upon this theme and made the connection between a more inclusive union and explicit projection of American might \n“Every American, in uniform or out, in the White House or at home, must be a force for unity in America, for a vision that includes all of us: every man and woman, every race, every ethnicity, every faith and creed, every gender orientation – all of us together pursuing our common values. \n“From the battlefield to the capitals of our allies, friends, and partners, the free peoples of the world look to America as the last best hope for peace and for liberty for all humanity, for we ARE the greatest country on this planet. \n“So we stand before you tonight to endorse Hillary Clinton for President of the United States of America.” \nThe message could not be clearer. Sorry Donald Trump, we are all Americans here. No apologies rest of the world, America the greatest and most diverse nation on Earth shall ransack the globe as it sees fit. \nThe response to the white nationalism of Donald Trump has been the rainbow coalition of hawks as chiefly embodied in the persons of Barrack Obama and Hillary Clinton. \nHillary Clinton: The Obliterator of Nations \nHillary Clinton is a war criminal. So is John Kerry. So is Condoleezza Rice. So are Colin Powell and Madeleine Albright. The secretary of state in an imperialist nation is the immediate manager of the projected might of the empire they represent. \nHillary Clinton is known to be a war hawk for much the same reason Donald Trump is known as a white nationalist. She is blatant and crass about it. \n“We came. We saw. He died” – Hillary Clinton on the assassination of Ghadaffi \n“In the next 10 years, during which they might foolishly consider launching an attack on Israel, we would be able to totally obliterate them” – Hillary Clinton speaking of obliteration of 75 million Iranians. \nFor much of the past few months the Clinton campaign have bemoaned a Russian conspiracy to reveal the words that Hillary Clinton actually wrote and thereby influence the American election. \nHillary Clinton’s neo-Mcarthyite cold war against her own words and general war talk on Russia should come as no surprise to anyone paying any attention. She was hawkish on Russia in their land dispute with Georgia over Ossetia, even going so far as to arm the Georgian government in 2010 less than two years after the conflict. She was warlike on the conflict in the Ukraine, promising Ukrainian government officials as recent as September of this year to stand with them against “Russian aggression.” \n“A Clinton presidency is the will of the ruling class.” \nThis is the talk of someone prepared for a nuclear apocalypse. \nIt should be mentioned, however, that Obama has also dialed up his anti Russian rhetoric, as has Tim Kaine, as has Mike Pence. It is only the white nationalist orange demon -- guided only by his own whims and twitter feuds -- that is at all off script on this question. \nUltimately a Clinton presidency is the will of the ruling class. If she wants war it is a reflection of their desire for war. If they want the bombs to fall then death will rain from the sky. So long as they hold power they shall exercise it. So long as there is a ruling class they shall rule by fire and blood, because there truly is no alternative. Because ultimately, this is about Clinton and then again it isn’t. And this is about the Democrats and then again it isn’t. This is about the US and this is about war. Hillary Clinton is a 2016 warlord. War is a racket. And so is this God damn election. Matt Sedillo can be contacted at [email protected] .",
		"thread_title": "LesserOfTwoEvilism",
		"title": "LesserOfTwoEvilism",
		"type": "bs",
		"uuid": "d731118206a56d96037e6acbba2e3d2ac4dfb2d4"
	},
	"-KhIkYImrZnHEOkCKZQa": {
		"author": "Anonymous",
		"comments": "0",
		"country": "EU",
		"crawled": "2016-11-02T09:47:50.016+02:00",
		"domain_rank": "",
		"entities": [
			{
				"metadata": {
					"mid": "/m/052p7",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montreal"
				},
				"name": "Montreal",
				"salience": 0.09461514,
				"type": "LOCATION"
			},
			{
				"name": "Tweet Widget",
				"salience": 0.072300114,
				"type": "OTHER"
			},
			{
				"name": "children",
				"salience": 0.05737236,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/07t65",
					"wikipedia_url": "http://en.wikipedia.org/wiki/United_Nations"
				},
				"name": "United Nations",
				"salience": 0.048631366,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/0d060g",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Canada"
				},
				"name": "Canadian",
				"salience": 0.037646245,
				"type": "LOCATION"
			},
			{
				"name": "Robyn Maynard",
				"salience": 0.03575029,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.033222433,
				"type": "PERSON"
			},
			{
				"name": "women",
				"salience": 0.03261,
				"type": "PERSON"
			},
			{
				"name": "Black Montrealers",
				"salience": 0.030591052,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.023246028,
				"type": "PERSON"
			},
			{
				"name": "rate",
				"salience": 0.017177256,
				"type": "OTHER"
			},
			{
				"name": "racism",
				"salience": 0.01649514,
				"type": "OTHER"
			},
			{
				"name": "profiling",
				"salience": 0.015472037,
				"type": "OTHER"
			},
			{
				"name": "home",
				"salience": 0.014670306,
				"type": "LOCATION"
			},
			{
				"name": "report",
				"salience": 0.0137739275,
				"type": "WORK_OF_ART"
			},
			{
				"name": "study",
				"salience": 0.013313266,
				"type": "OTHER"
			},
			{
				"name": "enslavement",
				"salience": 0.01284571,
				"type": "OTHER"
			},
			{
				"name": "United Nations Working Group",
				"salience": 0.012092312,
				"type": "ORGANIZATION"
			},
			{
				"metadata": {
					"mid": "/m/09xr80",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Working_group"
				},
				"name": "Working Group",
				"salience": 0.012018127,
				"type": "ORGANIZATION"
			},
			{
				"name": "neighbor",
				"salience": 0.011935714,
				"type": "PERSON"
			},
			{
				"name": "kind",
				"salience": 0.011935714,
				"type": "OTHER"
			},
			{
				"name": "Robyn Maynard Canada",
				"salience": 0.010856049,
				"type": "ORGANIZATION"
			},
			{
				"name": "poverty rates",
				"salience": 0.009978472,
				"type": "OTHER"
			},
			{
				"name": "persons",
				"salience": 0.009693062,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.009518082,
				"type": "OTHER"
			},
			{
				"name": "Shame",
				"salience": 0.009195999,
				"type": "OTHER"
			},
			{
				"name": "age",
				"salience": 0.009195999,
				"type": "OTHER"
			},
			{
				"name": "women",
				"salience": 0.00901285,
				"type": "PERSON"
			},
			{
				"name": "girls",
				"salience": 0.00901285,
				"type": "PERSON"
			},
			{
				"name": "Realities",
				"salience": 0.008449667,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/02czfr",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Canadians"
				},
				"name": "Black Canadians",
				"salience": 0.008400439,
				"type": "PERSON"
			},
			{
				"name": "Charmaine Nelson",
				"salience": 0.00812151,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/03ts0c",
					"wikipedia_url": "http://en.wikipedia.org/wiki/French_people"
				},
				"name": "French",
				"salience": 0.0073592914,
				"type": "LOCATION"
			},
			{
				"name": "more",
				"salience": 0.007051681,
				"type": "OTHER"
			},
			{
				"name": "Veckqueth Stevenson",
				"salience": 0.0067641833,
				"type": "PERSON"
			},
			{
				"name": "Majiza Philip",
				"salience": 0.0059665134,
				"type": "PERSON"
			},
			{
				"name": "article",
				"salience": 0.0059555816,
				"type": "WORK_OF_ART"
			},
			{
				"name": "statement",
				"salience": 0.005415425,
				"type": "WORK_OF_ART"
			},
			{
				"name": "anti-blackness",
				"salience": 0.0052136355,
				"type": "OTHER"
			},
			{
				"name": "rate",
				"salience": 0.0050714836,
				"type": "OTHER"
			},
			{
				"name": "regions",
				"salience": 0.005052016,
				"type": "OTHER"
			},
			{
				"name": "Working group",
				"salience": 0.0048824833,
				"type": "ORGANIZATION"
			},
			{
				"name": "group",
				"salience": 0.0041159424,
				"type": "ORGANIZATION"
			},
			{
				"name": "incarceration rates",
				"salience": 0.0041159424,
				"type": "OTHER"
			},
			{
				"name": "graduation rates",
				"salience": 0.0041159424,
				"type": "OTHER"
			},
			{
				"name": "study",
				"salience": 0.0038555514,
				"type": "OTHER"
			},
			{
				"name": "businessmen",
				"salience": 0.0037989046,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/02lcp_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montreal_Gazette"
				},
				"name": "Montreal Gazette",
				"salience": 0.0037625756,
				"type": "ORGANIZATION"
			},
			{
				"name": "realities",
				"salience": 0.003483991,
				"type": "OTHER"
			},
			{
				"name": "light",
				"salience": 0.0033838092,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.0032188506,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0032188506,
				"type": "ORGANIZATION"
			},
			{
				"name": "shame",
				"salience": 0.0029065425,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0029065425,
				"type": "OTHER"
			},
			{
				"name": "over-apprehension",
				"salience": 0.0029065425,
				"type": "OTHER"
			},
			{
				"name": "people",
				"salience": 0.0029065425,
				"type": "PERSON"
			},
			{
				"name": "communities",
				"salience": 0.0029065425,
				"type": "OTHER"
			},
			{
				"name": "consultations",
				"salience": 0.0028935699,
				"type": "EVENT"
			},
			{
				"name": "rates",
				"salience": 0.0028868404,
				"type": "OTHER"
			},
			{
				"name": "Enslavement",
				"salience": 0.002844714,
				"type": "OTHER"
			},
			{
				"name": "crime",
				"salience": 0.0028154675,
				"type": "OTHER"
			},
			{
				"name": "groups",
				"salience": 0.0027791583,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0026505538,
				"type": "OTHER"
			},
			{
				"name": "report",
				"salience": 0.002626335,
				"type": "WORK_OF_ART"
			},
			{
				"name": "one",
				"salience": 0.0025606055,
				"type": "PERSON"
			},
			{
				"name": "times",
				"salience": 0.0025516758,
				"type": "OTHER"
			},
			{
				"name": "findings",
				"salience": 0.0025170732,
				"type": "OTHER"
			},
			{
				"name": "discrimination",
				"salience": 0.0025170732,
				"type": "OTHER"
			},
			{
				"name": "law enforcement",
				"salience": 0.0025170732,
				"type": "ORGANIZATION"
			},
			{
				"name": "health",
				"salience": 0.0025170732,
				"type": "OTHER"
			},
			{
				"name": "child welfare agencies",
				"salience": 0.0025170732,
				"type": "ORGANIZATION"
			},
			{
				"name": "racism",
				"salience": 0.0025061283,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0024965194,
				"type": "OTHER"
			},
			{
				"name": "policing",
				"salience": 0.0023570238,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.0023570238,
				"type": "ORGANIZATION"
			},
			{
				"name": "study",
				"salience": 0.002352246,
				"type": "OTHER"
			},
			{
				"name": "realities",
				"salience": 0.002352246,
				"type": "OTHER"
			},
			{
				"name": "institutions",
				"salience": 0.0022573783,
				"type": "ORGANIZATION"
			},
			{
				"name": "institutions",
				"salience": 0.0022573783,
				"type": "ORGANIZATION"
			},
			{
				"name": "injustices",
				"salience": 0.002173154,
				"type": "OTHER"
			},
			{
				"name": "poverty",
				"salience": 0.002173154,
				"type": "OTHER"
			},
			{
				"name": "practice",
				"salience": 0.0021172767,
				"type": "OTHER"
			},
			{
				"name": "slavery",
				"salience": 0.0020382751,
				"type": "OTHER"
			},
			{
				"name": "treatment",
				"salience": 0.0020382751,
				"type": "OTHER"
			},
			{
				"name": "reality",
				"salience": 0.0019949009,
				"type": "OTHER"
			},
			{
				"name": "gang activities",
				"salience": 0.0019949009,
				"type": "OTHER"
			},
			{
				"name": "streets",
				"salience": 0.0019783776,
				"type": "LOCATION"
			},
			{
				"name": "Policing Black Bodies",
				"salience": 0.0019576666,
				"type": "WORK_OF_ART"
			},
			{
				"metadata": {
					"mid": "/m/0152tq",
					"wikipedia_url": "http://en.wikipedia.org/wiki/New_France"
				},
				"name": "New France",
				"salience": 0.0018518392,
				"type": "LOCATION"
			},
			{
				"name": "studies",
				"salience": 0.001802513,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0kst1",
					"wikipedia_url": "http://en.wikipedia.org/wiki/African_diaspora"
				},
				"name": "People of African Descent",
				"salience": 0.0017894402,
				"type": "PERSON"
			},
			{
				"name": "city",
				"salience": 0.0017650634,
				"type": "LOCATION"
			},
			{
				"name": "minority",
				"salience": 0.0017650634,
				"type": "PERSON"
			},
			{
				"name": "sociologists",
				"salience": 0.0017650634,
				"type": "PERSON"
			},
			{
				"name": "slave labor",
				"salience": 0.0017650634,
				"type": "PERSON"
			},
			{
				"name": "plantation crops",
				"salience": 0.0017650634,
				"type": "OTHER"
			},
			{
				"name": "fact",
				"salience": 0.0017650634,
				"type": "OTHER"
			},
			{
				"name": "buildings",
				"salience": 0.0017650634,
				"type": "LOCATION"
			},
			{
				"name": "activist groups",
				"salience": 0.0017609564,
				"type": "ORGANIZATION"
			},
			{
				"name": "rates",
				"salience": 0.0017609564,
				"type": "OTHER"
			},
			{
				"name": "UN Working Group",
				"salience": 0.0017328081,
				"type": "ORGANIZATION"
			},
			{
				"name": "prisons",
				"salience": 0.0016991943,
				"type": "LOCATION"
			},
			{
				"name": "means",
				"salience": 0.0016991943,
				"type": "OTHER"
			},
			{
				"name": "criticism",
				"salience": 0.0016991943,
				"type": "OTHER"
			},
			{
				"name": "times",
				"salience": 0.0016794348,
				"type": "OTHER"
			},
			{
				"name": "over-incarceration",
				"salience": 0.0016640831,
				"type": "OTHER"
			},
			{
				"name": "youth",
				"salience": 0.0016640831,
				"type": "PERSON"
			},
			{
				"name": "youth",
				"salience": 0.0016640831,
				"type": "PERSON"
			},
			{
				"name": "age",
				"salience": 0.0016224192,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0015900036,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/0694j",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Quebec"
				},
				"name": "Quebec",
				"salience": 0.0015495603,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/05kr_",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ontario"
				},
				"name": "Ontario",
				"salience": 0.0015495603,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/059t8",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Nova_Scotia"
				},
				"name": "Nova Scotia",
				"salience": 0.0015495603,
				"type": "LOCATION"
			},
			{
				"name": "racism",
				"salience": 0.0014903521,
				"type": "OTHER"
			},
			{
				"name": "public",
				"salience": 0.0014409972,
				"type": "PERSON"
			},
			{
				"name": "Much",
				"salience": 0.0014409972,
				"type": "OTHER"
			},
			{
				"name": "police officers",
				"salience": 0.0014409972,
				"type": "PERSON"
			},
			{
				"name": "degree",
				"salience": 0.0014409972,
				"type": "OTHER"
			},
			{
				"name": "ones",
				"salience": 0.0014049155,
				"type": "CONSUMER_GOOD"
			},
			{
				"name": "solutions",
				"salience": 0.0013872146,
				"type": "OTHER"
			},
			{
				"name": "injustices",
				"salience": 0.001376843,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.001282601,
				"type": "ORGANIZATION"
			},
			{
				"name": "homes",
				"salience": 0.0012431599,
				"type": "LOCATION"
			},
			{
				"name": "more",
				"salience": 0.0012431599,
				"type": "OTHER"
			},
			{
				"name": "child welfare",
				"salience": 0.0012431599,
				"type": "OTHER"
			},
			{
				"name": "first",
				"salience": 0.00114694,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/04yrmm",
					"wikipedia_url": "http://en.wikipedia.org/wiki/John_Redpath"
				},
				"name": "John Redpath",
				"salience": 0.0010864733,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/019zyp",
					"wikipedia_url": "http://en.wikipedia.org/wiki/James_McGill"
				},
				"name": "James McGill",
				"salience": 0.0010864733,
				"type": "PERSON"
			},
			{
				"name": "Christopher McAll",
				"salience": 0.0010864733,
				"type": "PERSON"
			},
			{
				"name": "Léonel Bernard",
				"salience": 0.0010864733,
				"type": "PERSON"
			},
			{
				"name": "racism",
				"salience": 0.0010854709,
				"type": "OTHER"
			},
			{
				"name": "activists",
				"salience": 0.0010854709,
				"type": "PERSON"
			},
			{
				"name": "enslavement",
				"salience": 0.0010854709,
				"type": "OTHER"
			},
			{
				"name": "cases",
				"salience": 0.0010820624,
				"type": "OTHER"
			},
			{
				"name": "system",
				"salience": 0.0010764766,
				"type": "OTHER"
			},
			{
				"name": "justice",
				"salience": 0.0010764766,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/0h7h6",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Toronto"
				},
				"name": "Toronto",
				"salience": 0.0010075996,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.00096535136,
				"type": "OTHER"
			},
			{
				"name": "police",
				"salience": 0.00095813256,
				"type": "PERSON"
			},
			{
				"name": "police",
				"salience": 0.00095813256,
				"type": "PERSON"
			},
			{
				"name": "injustices",
				"salience": 0.0009411746,
				"type": "OTHER"
			},
			{
				"name": "communities",
				"salience": 0.00090540684,
				"type": "PERSON"
			},
			{
				"name": "light",
				"salience": 0.00090540684,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/078lkz",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Montr%C3%A9al-Nord"
				},
				"name": "Montréal-Nord",
				"salience": 0.0008869492,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/02lvdh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/La_Presse_(Canadian_newspaper)"
				},
				"name": "La Presse",
				"salience": 0.0008869492,
				"type": "ORGANIZATION"
			},
			{
				"name": "St-Michel",
				"salience": 0.0008869492,
				"type": "LOCATION"
			},
			{
				"name": "force",
				"salience": 0.00087878766,
				"type": "OTHER"
			},
			{
				"name": "girls",
				"salience": 0.0008650886,
				"type": "PERSON"
			},
			{
				"name": "deaths",
				"salience": 0.00085677806,
				"type": "EVENT"
			},
			{
				"name": "hands",
				"salience": 0.00078399444,
				"type": "OTHER"
			},
			{
				"name": "issues",
				"salience": 0.00078399444,
				"type": "OTHER"
			},
			{
				"name": "cities",
				"salience": 0.00078399444,
				"type": "LOCATION"
			},
			{
				"name": "legacy",
				"salience": 0.00078399444,
				"type": "OTHER"
			},
			{
				"name": "writer",
				"salience": 0.00078399444,
				"type": "PERSON"
			},
			{
				"name": "author",
				"salience": 0.00078399444,
				"type": "PERSON"
			},
			{
				"metadata": {
					"mid": "/m/05ksh",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Ottawa"
				},
				"name": "Ottawa",
				"salience": 0.00068005465,
				"type": "LOCATION"
			},
			{
				"name": "crimes",
				"salience": 0.0006763321,
				"type": "OTHER"
			},
			{
				"name": "police abuse",
				"salience": 0.0006763321,
				"type": "OTHER"
			},
			{
				"name": "abuse",
				"salience": 0.0006763321,
				"type": "OTHER"
			},
			{
				"metadata": {
					"mid": "/m/080h2",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Vancouver"
				},
				"name": "Vancouver",
				"salience": 0.00066254305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/09b8m",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Kingston,_Jamaica"
				},
				"name": "Kingston",
				"salience": 0.00066254305,
				"type": "LOCATION"
			},
			{
				"metadata": {
					"mid": "/m/012hdhkj",
					"wikipedia_url": "http://en.wikipedia.org/wiki/Black_Lives_Matter"
				},
				"name": "Black Lives Matter",
				"salience": 0.00066254305,
				"type": "OTHER"
			},
			{
				"name": "example",
				"salience": 0.0006239727,
				"type": "OTHER"
			},
			{
				"name": "experiences",
				"salience": 0.00058563025,
				"type": "OTHER"
			},
			{
				"name": "arm",
				"salience": 0.00058563025,
				"type": "OTHER"
			},
			{
				"name": "Abdirahman Abdi",
				"salience": 0.00055723835,
				"type": "PERSON"
			},
			{
				"name": "Bony Jean-Pierre",
				"salience": 0.0004825047,
				"type": "PERSON"
			},
			{
				"name": "Nelson Mandela Park",
				"salience": 0.00036041084,
				"type": "LOCATION"
			},
			{
				"name": "case",
				"salience": 0.0003161841,
				"type": "OTHER"
			}
		],
		"language": "english",
		"likes": "0",
		"main_img_url": "",
		"ord_in_thread": "0",
		"participants_count": "1",
		"published": "2016-11-02T05:53:00.000+02:00",
		"replies_count": "0",
		"sentiment": {
			"magnitude": 9.7,
			"score": -0.2
		},
		"shares": "0",
		"site_url": "blackagendareport.com",
		"spam_score": "0",
		"text": "Tweet Widget by Robyn Maynard \nCanada, including its French-speaking regions, is home to much the same kind of systemic racism as its southern neighbor, according to a United Nations Working Group report. Black women’s poverty rates are “almost five times higher than that of white Canadian women.” In Montreal, “a 2008 study found that black girls are three times more likely than white girls the same age to have been arrested two times or more.” Realities Faced by Black Canadians are a National Shame by Robyn Maynard \nThis article previously appeared in the Montreal Gazette . \n“ Black Montrealers continue to experience dehumanizing treatment across institutions.” \nAfter holding consultations in Quebec, Nova Scotia and Ontario last month, the United Nations Working Group on People of African Descent issued a statement that sheds light on realities, too-often invisible to most Canadians, that should be seen as a national shame. \nThe group’s preliminary findings confirm what is already well known in Canada’s black communities: that systemic discrimination has subjected black people to racial profiling by law enforcement, soaring incarceration rates, disproportionate poverty and poor health, the over-apprehension of black children by child welfare agencies and lower graduation rates. Black women, they note, face a rate of poverty that is almost five times higher than that of white Canadian women, and are one of the fastest-growing groups in federal prisons. \nUnderlying these injustices, the UN Working Group has made clear, is systemic racism. \nThe UN is right to be concerned, and Montreal is by no means exempt from this criticism: Both its historical and contemporary realities are defined by a systemic anti-blackness that goes too frequently un-named. The enslavement of black (and indigenous) persons was not an uncommon practice in New France, and indeed was legal until 1834. The fact of slavery remains all around us: acclaimed art historian Charmaine Nelson reminds us that many present-day Montreal streets, buildings and institutions are named after white businessmen like James McGill and John Redpath who traded in plantation crops worked by slave labor. \nEnslavement may be over, but centuries later black Montrealers — the largest visible minority in the city — continue to experience dehumanizing treatment across institutions. A 2010 study by sociologists Léonel Bernard and Christopher McAll found that it was over-surveillance, and not the rates of so-called “black crime,” that accounted for up to 60 per cent of the over-incarceration of black youth in Montreal. \n“The enslavement of black (and indigenous) persons was not an uncommon practice in New France, and indeed was legal until 1834.” \nA report commissioned by the Montreal police, leaked to La Presse, found that in St-Michel and Montréal-Nord, up to 40 per cent of black youth were stopped in 2006-2007, a rate that indicates a high degree of racial profiling by police officers. Much of this heightened policing was justified to the public as curbing “gang activities,” when in reality, in 2009, only 1.6 per cent of crimes were gang related. High profile cases of police abuse of black Montrealers and alleged abuse continue to surface, including the recent case of Veckqueth Stevenson, a legally blind black man in his 50s, who has accused the police of using excessive force and unjustly arresting him, ironically, while he was at Nelson Mandela Park. \nBlack women and girls are not exempt, though we hear even less about their experiences locally; the case of Majiza Philip, a black woman who says she had her arm broken by police in 2014, is one example, however. A 2008 study found that black girls in Montreal are three times more likely than white girls the same age to have been arrested two times or more. \nBeyond the criminal justice system, numerous studies have demonstrated that black children are apprehended from their homes by child welfare at alarming rates in Montreal, and this, too, can be attributed to racism. \nThe UN Working group is not the first to point out these injustices, nor are they the only ones proposing solutions. Black Lives Matter-Toronto and other black activist groups in Toronto, Kingston, Ottawa, Vancouver and Montreal have been steadily mobilizing to address anti-black racism. Across cities, black communities have denounced, among other issues, the recent deaths of Abdirahman Abdi in Ottawa, and Bony Jean-Pierre in Montreal, both at the hands of police in 2016. \nIf Canada intends to genuinely reckon with its still-living legacy of black enslavement, the injustices brought to light by the UN — alongside those highlighted by black activists around the country — need to be both addressed and redressed. Robyn Maynard is an activist and writer living in Montreal, author of the forthcoming book Policing Black Bodies (2017).",
		"thread_title": "Realities Faced by Black Canadians are a National Shame",
		"title": "Realities Faced by Black Canadians are a National Shame",
		"type": "bs",
		"uuid": "0375cd051f558218d12274777f24d52c0f701987"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/fake.json
// module id = 21
// module chunks = 0